webpackJsonp([7],[
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["guid"] = guid;
/* harmony export (immutable) */ __webpack_exports__["logError"] = logError;
/* harmony export (immutable) */ __webpack_exports__["clone"] = clone;
/* harmony export (immutable) */ __webpack_exports__["merge"] = merge;
/* harmony export (immutable) */ __webpack_exports__["mergeAll"] = mergeAll;
/* harmony export (immutable) */ __webpack_exports__["extend"] = extend;
/* harmony export (immutable) */ __webpack_exports__["defaults"] = defaults;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createCanvas", function() { return createCanvas; });
/* harmony export (immutable) */ __webpack_exports__["indexOf"] = indexOf;
/* harmony export (immutable) */ __webpack_exports__["inherits"] = inherits;
/* harmony export (immutable) */ __webpack_exports__["mixin"] = mixin;
/* harmony export (immutable) */ __webpack_exports__["isArrayLike"] = isArrayLike;
/* harmony export (immutable) */ __webpack_exports__["each"] = each;
/* harmony export (immutable) */ __webpack_exports__["map"] = map;
/* harmony export (immutable) */ __webpack_exports__["reduce"] = reduce;
/* harmony export (immutable) */ __webpack_exports__["filter"] = filter;
/* harmony export (immutable) */ __webpack_exports__["find"] = find;
/* harmony export (immutable) */ __webpack_exports__["keys"] = keys;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bind", function() { return bind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "curry", function() { return curry; });
/* harmony export (immutable) */ __webpack_exports__["isArray"] = isArray;
/* harmony export (immutable) */ __webpack_exports__["isFunction"] = isFunction;
/* harmony export (immutable) */ __webpack_exports__["isString"] = isString;
/* harmony export (immutable) */ __webpack_exports__["isStringSafe"] = isStringSafe;
/* harmony export (immutable) */ __webpack_exports__["isNumber"] = isNumber;
/* harmony export (immutable) */ __webpack_exports__["isObject"] = isObject;
/* harmony export (immutable) */ __webpack_exports__["isBuiltInObject"] = isBuiltInObject;
/* harmony export (immutable) */ __webpack_exports__["isTypedArray"] = isTypedArray;
/* harmony export (immutable) */ __webpack_exports__["isDom"] = isDom;
/* harmony export (immutable) */ __webpack_exports__["isGradientObject"] = isGradientObject;
/* harmony export (immutable) */ __webpack_exports__["isImagePatternObject"] = isImagePatternObject;
/* harmony export (immutable) */ __webpack_exports__["isRegExp"] = isRegExp;
/* harmony export (immutable) */ __webpack_exports__["eqNaN"] = eqNaN;
/* harmony export (immutable) */ __webpack_exports__["retrieve"] = retrieve;
/* harmony export (immutable) */ __webpack_exports__["retrieve2"] = retrieve2;
/* harmony export (immutable) */ __webpack_exports__["retrieve3"] = retrieve3;
/* harmony export (immutable) */ __webpack_exports__["slice"] = slice;
/* harmony export (immutable) */ __webpack_exports__["normalizeCssArray"] = normalizeCssArray;
/* harmony export (immutable) */ __webpack_exports__["assert"] = assert;
/* harmony export (immutable) */ __webpack_exports__["trim"] = trim;
/* harmony export (immutable) */ __webpack_exports__["setAsPrimitive"] = setAsPrimitive;
/* harmony export (immutable) */ __webpack_exports__["isPrimitive"] = isPrimitive;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HashMap", function() { return HashMap; });
/* harmony export (immutable) */ __webpack_exports__["createHashMap"] = createHashMap;
/* harmony export (immutable) */ __webpack_exports__["concatArray"] = concatArray;
/* harmony export (immutable) */ __webpack_exports__["createObject"] = createObject;
/* harmony export (immutable) */ __webpack_exports__["disableUserSelect"] = disableUserSelect;
/* harmony export (immutable) */ __webpack_exports__["hasOwn"] = hasOwn;
/* harmony export (immutable) */ __webpack_exports__["noop"] = noop;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RADIAN_TO_DEGREE", function() { return RADIAN_TO_DEGREE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform_js__ = __webpack_require__(67);

var BUILTIN_OBJECT = reduce([
    'Function',
    'RegExp',
    'Date',
    'Error',
    'CanvasGradient',
    'CanvasPattern',
    'Image',
    'Canvas'
], function (obj, val) {
    obj['[object ' + val + ']'] = true;
    return obj;
}, {});
var TYPED_ARRAY = reduce([
    'Int8',
    'Uint8',
    'Uint8Clamped',
    'Int16',
    'Uint16',
    'Int32',
    'Uint32',
    'Float32',
    'Float64'
], function (obj, val) {
    obj['[object ' + val + 'Array]'] = true;
    return obj;
}, {});
var objToString = Object.prototype.toString;
var arrayProto = Array.prototype;
var nativeForEach = arrayProto.forEach;
var nativeFilter = arrayProto.filter;
var nativeSlice = arrayProto.slice;
var nativeMap = arrayProto.map;
var ctorFunction = function () { }.constructor;
var protoFunction = ctorFunction ? ctorFunction.prototype : null;
var protoKey = '__proto__';
var idStart = 0x0907;
function guid() {
    return idStart++;
}
function logError() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (typeof console !== 'undefined') {
        console.error.apply(console, args);
    }
}
function clone(source) {
    if (source == null || typeof source !== 'object') {
        return source;
    }
    var result = source;
    var typeStr = objToString.call(source);
    if (typeStr === '[object Array]') {
        if (!isPrimitive(source)) {
            result = [];
            for (var i = 0, len = source.length; i < len; i++) {
                result[i] = clone(source[i]);
            }
        }
    }
    else if (TYPED_ARRAY[typeStr]) {
        if (!isPrimitive(source)) {
            var Ctor = source.constructor;
            if (Ctor.from) {
                result = Ctor.from(source);
            }
            else {
                result = new Ctor(source.length);
                for (var i = 0, len = source.length; i < len; i++) {
                    result[i] = source[i];
                }
            }
        }
    }
    else if (!BUILTIN_OBJECT[typeStr] && !isPrimitive(source) && !isDom(source)) {
        result = {};
        for (var key in source) {
            if (source.hasOwnProperty(key) && key !== protoKey) {
                result[key] = clone(source[key]);
            }
        }
    }
    return result;
}
function merge(target, source, overwrite) {
    if (!isObject(source) || !isObject(target)) {
        return overwrite ? clone(source) : target;
    }
    for (var key in source) {
        if (source.hasOwnProperty(key) && key !== protoKey) {
            var targetProp = target[key];
            var sourceProp = source[key];
            if (isObject(sourceProp)
                && isObject(targetProp)
                && !isArray(sourceProp)
                && !isArray(targetProp)
                && !isDom(sourceProp)
                && !isDom(targetProp)
                && !isBuiltInObject(sourceProp)
                && !isBuiltInObject(targetProp)
                && !isPrimitive(sourceProp)
                && !isPrimitive(targetProp)) {
                merge(targetProp, sourceProp, overwrite);
            }
            else if (overwrite || !(key in target)) {
                target[key] = clone(source[key]);
            }
        }
    }
    return target;
}
function mergeAll(targetAndSources, overwrite) {
    var result = targetAndSources[0];
    for (var i = 1, len = targetAndSources.length; i < len; i++) {
        result = merge(result, targetAndSources[i], overwrite);
    }
    return result;
}
function extend(target, source) {
    if (Object.assign) {
        Object.assign(target, source);
    }
    else {
        for (var key in source) {
            if (source.hasOwnProperty(key) && key !== protoKey) {
                target[key] = source[key];
            }
        }
    }
    return target;
}
function defaults(target, source, overlay) {
    var keysArr = keys(source);
    for (var i = 0; i < keysArr.length; i++) {
        var key = keysArr[i];
        if ((overlay ? source[key] != null : target[key] == null)) {
            target[key] = source[key];
        }
    }
    return target;
}
var createCanvas = __WEBPACK_IMPORTED_MODULE_0__platform_js__["a" /* platformApi */].createCanvas;
function indexOf(array, value) {
    if (array) {
        if (array.indexOf) {
            return array.indexOf(value);
        }
        for (var i = 0, len = array.length; i < len; i++) {
            if (array[i] === value) {
                return i;
            }
        }
    }
    return -1;
}
function inherits(clazz, baseClazz) {
    var clazzPrototype = clazz.prototype;
    function F() { }
    F.prototype = baseClazz.prototype;
    clazz.prototype = new F();
    for (var prop in clazzPrototype) {
        if (clazzPrototype.hasOwnProperty(prop)) {
            clazz.prototype[prop] = clazzPrototype[prop];
        }
    }
    clazz.prototype.constructor = clazz;
    clazz.superClass = baseClazz;
}
function mixin(target, source, override) {
    target = 'prototype' in target ? target.prototype : target;
    source = 'prototype' in source ? source.prototype : source;
    if (Object.getOwnPropertyNames) {
        var keyList = Object.getOwnPropertyNames(source);
        for (var i = 0; i < keyList.length; i++) {
            var key = keyList[i];
            if (key !== 'constructor') {
                if ((override ? source[key] != null : target[key] == null)) {
                    target[key] = source[key];
                }
            }
        }
    }
    else {
        defaults(target, source, override);
    }
}
function isArrayLike(data) {
    if (!data) {
        return false;
    }
    if (typeof data === 'string') {
        return false;
    }
    return typeof data.length === 'number';
}
function each(arr, cb, context) {
    if (!(arr && cb)) {
        return;
    }
    if (arr.forEach && arr.forEach === nativeForEach) {
        arr.forEach(cb, context);
    }
    else if (arr.length === +arr.length) {
        for (var i = 0, len = arr.length; i < len; i++) {
            cb.call(context, arr[i], i, arr);
        }
    }
    else {
        for (var key in arr) {
            if (arr.hasOwnProperty(key)) {
                cb.call(context, arr[key], key, arr);
            }
        }
    }
}
function map(arr, cb, context) {
    if (!arr) {
        return [];
    }
    if (!cb) {
        return slice(arr);
    }
    if (arr.map && arr.map === nativeMap) {
        return arr.map(cb, context);
    }
    else {
        var result = [];
        for (var i = 0, len = arr.length; i < len; i++) {
            result.push(cb.call(context, arr[i], i, arr));
        }
        return result;
    }
}
function reduce(arr, cb, memo, context) {
    if (!(arr && cb)) {
        return;
    }
    for (var i = 0, len = arr.length; i < len; i++) {
        memo = cb.call(context, memo, arr[i], i, arr);
    }
    return memo;
}
function filter(arr, cb, context) {
    if (!arr) {
        return [];
    }
    if (!cb) {
        return slice(arr);
    }
    if (arr.filter && arr.filter === nativeFilter) {
        return arr.filter(cb, context);
    }
    else {
        var result = [];
        for (var i = 0, len = arr.length; i < len; i++) {
            if (cb.call(context, arr[i], i, arr)) {
                result.push(arr[i]);
            }
        }
        return result;
    }
}
function find(arr, cb, context) {
    if (!(arr && cb)) {
        return;
    }
    for (var i = 0, len = arr.length; i < len; i++) {
        if (cb.call(context, arr[i], i, arr)) {
            return arr[i];
        }
    }
}
function keys(obj) {
    if (!obj) {
        return [];
    }
    if (Object.keys) {
        return Object.keys(obj);
    }
    var keyList = [];
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            keyList.push(key);
        }
    }
    return keyList;
}
function bindPolyfill(func, context) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return function () {
        return func.apply(context, args.concat(nativeSlice.call(arguments)));
    };
}
var bind = (protoFunction && isFunction(protoFunction.bind))
    ? protoFunction.call.bind(protoFunction.bind)
    : bindPolyfill;
function curry(func) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return function () {
        return func.apply(this, args.concat(nativeSlice.call(arguments)));
    };
}

function isArray(value) {
    if (Array.isArray) {
        return Array.isArray(value);
    }
    return objToString.call(value) === '[object Array]';
}
function isFunction(value) {
    return typeof value === 'function';
}
function isString(value) {
    return typeof value === 'string';
}
function isStringSafe(value) {
    return objToString.call(value) === '[object String]';
}
function isNumber(value) {
    return typeof value === 'number';
}
function isObject(value) {
    var type = typeof value;
    return type === 'function' || (!!value && type === 'object');
}
function isBuiltInObject(value) {
    return !!BUILTIN_OBJECT[objToString.call(value)];
}
function isTypedArray(value) {
    return !!TYPED_ARRAY[objToString.call(value)];
}
function isDom(value) {
    return typeof value === 'object'
        && typeof value.nodeType === 'number'
        && typeof value.ownerDocument === 'object';
}
function isGradientObject(value) {
    return value.colorStops != null;
}
function isImagePatternObject(value) {
    return value.image != null;
}
function isRegExp(value) {
    return objToString.call(value) === '[object RegExp]';
}
function eqNaN(value) {
    return value !== value;
}
function retrieve() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    for (var i = 0, len = args.length; i < len; i++) {
        if (args[i] != null) {
            return args[i];
        }
    }
}
function retrieve2(value0, value1) {
    return value0 != null
        ? value0
        : value1;
}
function retrieve3(value0, value1, value2) {
    return value0 != null
        ? value0
        : value1 != null
            ? value1
            : value2;
}
function slice(arr) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return nativeSlice.apply(arr, args);
}
function normalizeCssArray(val) {
    if (typeof (val) === 'number') {
        return [val, val, val, val];
    }
    var len = val.length;
    if (len === 2) {
        return [val[0], val[1], val[0], val[1]];
    }
    else if (len === 3) {
        return [val[0], val[1], val[2], val[1]];
    }
    return val;
}
function assert(condition, message) {
    if (!condition) {
        throw new Error(message);
    }
}
function trim(str) {
    if (str == null) {
        return null;
    }
    else if (typeof str.trim === 'function') {
        return str.trim();
    }
    else {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
}
var primitiveKey = '__ec_primitive__';
function setAsPrimitive(obj) {
    obj[primitiveKey] = true;
}
function isPrimitive(obj) {
    return obj[primitiveKey];
}
var HashMap = (function () {
    function HashMap(obj) {
        this.data = {};
        var isArr = isArray(obj);
        this.data = {};
        var thisMap = this;
        (obj instanceof HashMap)
            ? obj.each(visit)
            : (obj && each(obj, visit));
        function visit(value, key) {
            isArr ? thisMap.set(value, key) : thisMap.set(key, value);
        }
    }
    HashMap.prototype.get = function (key) {
        return this.data.hasOwnProperty(key) ? this.data[key] : null;
    };
    HashMap.prototype.set = function (key, value) {
        return (this.data[key] = value);
    };
    HashMap.prototype.each = function (cb, context) {
        for (var key in this.data) {
            if (this.data.hasOwnProperty(key)) {
                cb.call(context, this.data[key], key);
            }
        }
    };
    HashMap.prototype.keys = function () {
        return keys(this.data);
    };
    HashMap.prototype.removeKey = function (key) {
        delete this.data[key];
    };
    return HashMap;
}());

function createHashMap(obj) {
    return new HashMap(obj);
}
function concatArray(a, b) {
    var newArray = new a.constructor(a.length + b.length);
    for (var i = 0; i < a.length; i++) {
        newArray[i] = a[i];
    }
    var offset = a.length;
    for (var i = 0; i < b.length; i++) {
        newArray[i + offset] = b[i];
    }
    return newArray;
}
function createObject(proto, properties) {
    var obj;
    if (Object.create) {
        obj = Object.create(proto);
    }
    else {
        var StyleCtor = function () { };
        StyleCtor.prototype = proto;
        obj = new StyleCtor();
    }
    if (properties) {
        extend(obj, properties);
    }
    return obj;
}
function disableUserSelect(dom) {
    var domStyle = dom.style;
    domStyle.webkitUserSelect = 'none';
    domStyle.userSelect = 'none';
    domStyle.webkitTapHighlightColor = 'rgba(0,0,0,0)';
    domStyle['-webkit-touch-callout'] = 'none';
}
function hasOwn(own, prop) {
    return own.hasOwnProperty(prop);
}
function noop() { }
var RADIAN_TO_DEGREE = 180 / Math.PI;


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = __extends;
/* unused harmony export __assign */
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* unused harmony export __spreadArray */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var core = __webpack_require__(73);
var hide = __webpack_require__(54);
var redefine = __webpack_require__(55);
var ctx = __webpack_require__(74);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = normalizeToArray;
/* harmony export (immutable) */ __webpack_exports__["e"] = defaultEmphasis;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return TEXT_STYLE_OPTIONS; });
/* harmony export (immutable) */ __webpack_exports__["g"] = getDataItemValue;
/* harmony export (immutable) */ __webpack_exports__["u"] = isDataItemOption;
/* harmony export (immutable) */ __webpack_exports__["q"] = mappingToExists;
/* harmony export (immutable) */ __webpack_exports__["n"] = convertOptionIdName;
/* harmony export (immutable) */ __webpack_exports__["f"] = isNameSpecified;
/* harmony export (immutable) */ __webpack_exports__["s"] = isComponentIdInternal;
/* harmony export (immutable) */ __webpack_exports__["w"] = makeInternalComponentId;
/* harmony export (immutable) */ __webpack_exports__["r"] = setComponentTypeToKeyInfo;
/* harmony export (immutable) */ __webpack_exports__["j"] = compressBatches;
/* harmony export (immutable) */ __webpack_exports__["c"] = queryDataIndex;
/* harmony export (immutable) */ __webpack_exports__["a"] = makeInner;
/* harmony export (immutable) */ __webpack_exports__["l"] = parseFinder;
/* harmony export (immutable) */ __webpack_exports__["o"] = preParseFinder;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SINGLE_REFERRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MULTIPLE_REFERRING; });
/* harmony export (immutable) */ __webpack_exports__["h"] = queryReferringComponents;
/* harmony export (immutable) */ __webpack_exports__["m"] = setAttribute;
/* harmony export (immutable) */ __webpack_exports__["p"] = getAttribute;
/* harmony export (immutable) */ __webpack_exports__["v"] = getTooltipRenderMode;
/* harmony export (immutable) */ __webpack_exports__["x"] = groupData;
/* harmony export (immutable) */ __webpack_exports__["b"] = interpolateRawValues;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_env_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log_js__ = __webpack_require__(14);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





function interpolateNumber(p0, p1, percent) {
  return (p1 - p0) * percent + p0;
}
/**
 * Make the name displayable. But we should
 * make sure it is not duplicated with user
 * specified name, so use '\0';
 */


var DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
var INTERNAL_COMPONENT_ID_PREFIX = '\0_ec_\0';
/**
 * If value is not array, then translate it to array.
 * @param  {*} value
 * @return {Array} [value] or value
 */

function normalizeToArray(value) {
  return value instanceof Array ? value : value == null ? [] : [value];
}
/**
 * Sync default option between normal and emphasis like `position` and `show`
 * In case some one will write code like
 *     label: {
 *          show: false,
 *          position: 'outside',
 *          fontSize: 18
 *     },
 *     emphasis: {
 *          label: { show: true }
 *     }
 */

function defaultEmphasis(opt, key, subOpts) {
  // Caution: performance sensitive.
  if (opt) {
    opt[key] = opt[key] || {};
    opt.emphasis = opt.emphasis || {};
    opt.emphasis[key] = opt.emphasis[key] || {}; // Default emphasis option from normal

    for (var i = 0, len = subOpts.length; i < len; i++) {
      var subOptName = subOpts[i];

      if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) {
        opt.emphasis[key][subOptName] = opt[key][subOptName];
      }
    }
  }
}
var TEXT_STYLE_OPTIONS = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily', 'rich', 'tag', 'color', 'textBorderColor', 'textBorderWidth', 'width', 'height', 'lineHeight', 'align', 'verticalAlign', 'baseline', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY', 'textShadowColor', 'textShadowBlur', 'textShadowOffsetX', 'textShadowOffsetY', 'backgroundColor', 'borderColor', 'borderWidth', 'borderRadius', 'padding']; // modelUtil.LABEL_OPTIONS = modelUtil.TEXT_STYLE_OPTIONS.concat([
//     'position', 'offset', 'rotate', 'origin', 'show', 'distance', 'formatter',
//     'fontStyle', 'fontWeight', 'fontSize', 'fontFamily',
//     // FIXME: deprecated, check and remove it.
//     'textStyle'
// ]);

/**
 * The method do not ensure performance.
 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
 * This helper method retieves value from data.
 */

function getDataItemValue(dataItem) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"])(dataItem) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"])(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
}
/**
 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
 * This helper method determine if dataItem has extra option besides value
 */

function isDataItemOption(dataItem) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"])(dataItem) && !(dataItem instanceof Array); // // markLine data can be array
  // && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}
;
/**
 * Mapping to existings for merge.
 *
 * Mode "normalMege":
 *     The mapping result (merge result) will keep the order of the existing
 *     component, rather than the order of new option. Because we should ensure
 *     some specified index reference (like xAxisIndex) keep work.
 *     And in most cases, "merge option" is used to update partial option but not
 *     be expected to change the order.
 *
 * Mode "replaceMege":
 *     (1) Only the id mapped components will be merged.
 *     (2) Other existing components (except internal compoonets) will be removed.
 *     (3) Other new options will be used to create new component.
 *     (4) The index of the existing compoents will not be modified.
 *     That means their might be "hole" after the removal.
 *     The new components are created first at those available index.
 *
 * Mode "replaceAll":
 *     This mode try to support that reproduce an echarts instance from another
 *     echarts instance (via `getOption`) in some simple cases.
 *     In this senario, the `result` index are exactly the consistent with the `newCmptOptions`,
 *     which ensures the compoennt index referring (like `xAxisIndex: ?`) corrent. That is,
 *     the "hole" in `newCmptOptions` will also be kept.
 *     On the contrary, other modes try best to eliminate holes.
 *     PENDING: This is an experimental mode yet.
 *
 * @return See the comment of <MappingResult>.
 */

function mappingToExists(existings, newCmptOptions, mode) {
  var isNormalMergeMode = mode === 'normalMerge';
  var isReplaceMergeMode = mode === 'replaceMerge';
  var isReplaceAllMode = mode === 'replaceAll';
  existings = existings || [];
  newCmptOptions = (newCmptOptions || []).slice();
  var existingIdIdxMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])(); // Validate id and name on user input option.

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(newCmptOptions, function (cmptOption, index) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"])(cmptOption)) {
      newCmptOptions[index] = null;
      return;
    }

    if (true) {
      // There is some legacy case that name is set as `false`.
      // But should work normally rather than throw error.
      if (cmptOption.id != null && !isValidIdOrName(cmptOption.id)) {
        warnInvalidateIdOrName(cmptOption.id);
      }

      if (cmptOption.name != null && !isValidIdOrName(cmptOption.name)) {
        warnInvalidateIdOrName(cmptOption.name);
      }
    }
  });
  var result = prepareResult(existings, existingIdIdxMap, mode);

  if (isNormalMergeMode || isReplaceMergeMode) {
    mappingById(result, existings, existingIdIdxMap, newCmptOptions);
  }

  if (isNormalMergeMode) {
    mappingByName(result, newCmptOptions);
  }

  if (isNormalMergeMode || isReplaceMergeMode) {
    mappingByIndex(result, newCmptOptions, isReplaceMergeMode);
  } else if (isReplaceAllMode) {
    mappingInReplaceAllMode(result, newCmptOptions);
  }

  makeIdAndName(result); // The array `result` MUST NOT contain elided items, otherwise the
  // forEach will ommit those items and result in incorrect result.

  return result;
}

function prepareResult(existings, existingIdIdxMap, mode) {
  var result = [];

  if (mode === 'replaceAll') {
    return result;
  } // Do not use native `map` to in case that the array `existings`
  // contains elided items, which will be ommited.


  for (var index = 0; index < existings.length; index++) {
    var existing = existings[index]; // Because of replaceMerge, `existing` may be null/undefined.

    if (existing && existing.id != null) {
      existingIdIdxMap.set(existing.id, index);
    } // For non-internal-componnets:
    //     Mode "normalMerge": all existings kept.
    //     Mode "replaceMerge": all existing removed unless mapped by id.
    // For internal-components:
    //     go with "replaceMerge" approach in both mode.


    result.push({
      existing: mode === 'replaceMerge' || isComponentIdInternal(existing) ? null : existing,
      newOption: null,
      keyInfo: null,
      brandNew: null
    });
  }

  return result;
}

function mappingById(result, existings, existingIdIdxMap, newCmptOptions) {
  // Mapping by id if specified.
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(newCmptOptions, function (cmptOption, index) {
    if (!cmptOption || cmptOption.id == null) {
      return;
    }

    var optionId = makeComparableKey(cmptOption.id);
    var existingIdx = existingIdIdxMap.get(optionId);

    if (existingIdx != null) {
      var resultItem = result[existingIdx];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(!resultItem.newOption, 'Duplicated option on id "' + optionId + '".');
      resultItem.newOption = cmptOption; // In both mode, if id matched, new option will be merged to
      // the existings rather than creating new component model.

      resultItem.existing = existings[existingIdx];
      newCmptOptions[index] = null;
    }
  });
}

function mappingByName(result, newCmptOptions) {
  // Mapping by name if specified.
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(newCmptOptions, function (cmptOption, index) {
    if (!cmptOption || cmptOption.name == null) {
      return;
    }

    for (var i = 0; i < result.length; i++) {
      var existing = result[i].existing;

      if (!result[i].newOption // Consider name: two map to one.
      // Can not match when both ids existing but different.
      && existing && (existing.id == null || cmptOption.id == null) && !isComponentIdInternal(cmptOption) && !isComponentIdInternal(existing) && keyExistAndEqual('name', existing, cmptOption)) {
        result[i].newOption = cmptOption;
        newCmptOptions[index] = null;
        return;
      }
    }
  });
}

function mappingByIndex(result, newCmptOptions, brandNew) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(newCmptOptions, function (cmptOption) {
    if (!cmptOption) {
      return;
    } // Find the first place that not mapped by id and not internal component (consider the "hole").


    var resultItem;
    var nextIdx = 0;

    while ( // Be `!resultItem` only when `nextIdx >= result.length`.
    (resultItem = result[nextIdx]) && ( // (1) Existing models that already have id should be able to mapped to. Because
    // after mapping performed, model will always be assigned with an id if user not given.
    // After that all models have id.
    // (2) If new option has id, it can only set to a hole or append to the last. It should
    // not be merged to the existings with different id. Because id should not be overwritten.
    // (3) Name can be overwritten, because axis use name as 'show label text'.
    resultItem.newOption || isComponentIdInternal(resultItem.existing) || // In mode "replaceMerge", here no not-mapped-non-internal-existing.
    resultItem.existing && cmptOption.id != null && !keyExistAndEqual('id', cmptOption, resultItem.existing))) {
      nextIdx++;
    }

    if (resultItem) {
      resultItem.newOption = cmptOption;
      resultItem.brandNew = brandNew;
    } else {
      result.push({
        newOption: cmptOption,
        brandNew: brandNew,
        existing: null,
        keyInfo: null
      });
    }

    nextIdx++;
  });
}

function mappingInReplaceAllMode(result, newCmptOptions) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(newCmptOptions, function (cmptOption) {
    // The feature "reproduce" requires "hole" will also reproduced
    // in case that compoennt index referring are broken.
    result.push({
      newOption: cmptOption,
      brandNew: true,
      existing: null,
      keyInfo: null
    });
  });
}
/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 */


function makeIdAndName(mapResult) {
  // We use this id to hash component models and view instances
  // in echarts. id can be specified by user, or auto generated.
  // The id generation rule ensures new view instance are able
  // to mapped to old instance when setOption are called in
  // no-merge mode. So we generate model id by name and plus
  // type in view id.
  // name can be duplicated among components, which is convenient
  // to specify multi components (like series) by one name.
  // Ensure that each id is distinct.
  var idMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(mapResult, function (item) {
    var existing = item.existing;
    existing && idMap.set(existing.id, item);
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(mapResult, function (item) {
    var opt = item.newOption; // Force ensure id not duplicated.

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
    opt && opt.id != null && idMap.set(opt.id, item);
    !item.keyInfo && (item.keyInfo = {});
  }); // Make name and id.

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(mapResult, function (item, index) {
    var existing = item.existing;
    var opt = item.newOption;
    var keyInfo = item.keyInfo;

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"])(opt)) {
      return;
    } // name can be overwitten. Consider case: axis.name = '20km'.
    // But id generated by name will not be changed, which affect
    // only in that case: setOption with 'not merge mode' and view
    // instance will be recreated, which can be accepted.


    keyInfo.name = opt.name != null ? makeComparableKey(opt.name) : existing ? existing.name // Avoid diffferent series has the same name,
    // because name may be used like in color pallet.
    : DUMMY_COMPONENT_NAME_PREFIX + index;

    if (existing) {
      keyInfo.id = makeComparableKey(existing.id);
    } else if (opt.id != null) {
      keyInfo.id = makeComparableKey(opt.id);
    } else {
      // Consider this situatoin:
      //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
      //  optionB [{..}, {name: 'a'}, {name: 'a'}]
      // Series with the same name between optionA and optionB
      // should be mapped.
      var idNum = 0;

      do {
        keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
      } while (idMap.get(keyInfo.id));
    }

    idMap.set(keyInfo.id, item);
  });
}

function keyExistAndEqual(attr, obj1, obj2) {
  var key1 = convertOptionIdName(obj1[attr], null);
  var key2 = convertOptionIdName(obj2[attr], null); // See `MappingExistingItem`. `id` and `name` trade string equals to number.

  return key1 != null && key2 != null && key1 === key2;
}
/**
 * @return return null if not exist.
 */


function makeComparableKey(val) {
  if (true) {
    if (val == null) {
      throw new Error();
    }
  }

  return convertOptionIdName(val, '');
}

function convertOptionIdName(idOrName, defaultValue) {
  if (idOrName == null) {
    return defaultValue;
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"])(idOrName) ? idOrName : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isNumber"])(idOrName) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isStringSafe"])(idOrName) ? idOrName + '' : defaultValue;
}

function warnInvalidateIdOrName(idOrName) {
  if (true) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__log_js__["b" /* warn */])('`' + idOrName + '` is invalid id or name. Must be a string or number.');
  }
}

function isValidIdOrName(idOrName) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isStringSafe"])(idOrName) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__number_js__["b" /* isNumeric */])(idOrName);
}

function isNameSpecified(componentModel) {
  var name = componentModel.name; // Is specified when `indexOf` get -1 or > 0.

  return !!(name && name.indexOf(DUMMY_COMPONENT_NAME_PREFIX));
}
/**
 * @public
 * @param {Object} cmptOption
 * @return {boolean}
 */

function isComponentIdInternal(cmptOption) {
  return cmptOption && cmptOption.id != null && makeComparableKey(cmptOption.id).indexOf(INTERNAL_COMPONENT_ID_PREFIX) === 0;
}
function makeInternalComponentId(idSuffix) {
  return INTERNAL_COMPONENT_ID_PREFIX + idSuffix;
}
function setComponentTypeToKeyInfo(mappingResult, mainType, componentModelCtor) {
  // Set mainType and complete subType.
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(mappingResult, function (item) {
    var newOption = item.newOption;

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"])(newOption)) {
      item.keyInfo.mainType = mainType;
      item.keyInfo.subType = determineSubType(mainType, newOption, item.existing, componentModelCtor);
    }
  });
}

function determineSubType(mainType, newCmptOption, existComponent, componentModelCtor) {
  var subType = newCmptOption.type ? newCmptOption.type : existComponent ? existComponent.subType // Use determineSubType only when there is no existComponent.
  : componentModelCtor.determineSubType(mainType, newCmptOption); // tooltip, markline, markpoint may always has no subType

  return subType;
}
/**
 * A helper for removing duplicate items between batchA and batchB,
 * and in themselves, and categorize by series.
 *
 * @param batchA Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
 * @param batchB Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
 * @return result: [resultBatchA, resultBatchB]
 */


function compressBatches(batchA, batchB) {
  var mapA = {};
  var mapB = {};
  makeMap(batchA || [], mapA);
  makeMap(batchB || [], mapB, mapA);
  return [mapToArray(mapA), mapToArray(mapB)];

  function makeMap(sourceBatch, map, otherMap) {
    for (var i = 0, len = sourceBatch.length; i < len; i++) {
      var seriesId = convertOptionIdName(sourceBatch[i].seriesId, null);

      if (seriesId == null) {
        return;
      }

      var dataIndices = normalizeToArray(sourceBatch[i].dataIndex);
      var otherDataIndices = otherMap && otherMap[seriesId];

      for (var j = 0, lenj = dataIndices.length; j < lenj; j++) {
        var dataIndex = dataIndices[j];

        if (otherDataIndices && otherDataIndices[dataIndex]) {
          otherDataIndices[dataIndex] = null;
        } else {
          (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
        }
      }
    }
  }

  function mapToArray(map, isData) {
    var result = [];

    for (var i in map) {
      if (map.hasOwnProperty(i) && map[i] != null) {
        if (isData) {
          result.push(+i);
        } else {
          var dataIndices = mapToArray(map[i], true);
          dataIndices.length && result.push({
            seriesId: i,
            dataIndex: dataIndices
          });
        }
      }
    }

    return result;
  }
}
/**
 * @param payload Contains dataIndex (means rawIndex) / dataIndexInside / name
 *                         each of which can be Array or primary type.
 * @return dataIndex If not found, return undefined/null.
 */

function queryDataIndex(data, payload) {
  if (payload.dataIndexInside != null) {
    return payload.dataIndexInside;
  } else if (payload.dataIndex != null) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"])(payload.dataIndex) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])(payload.dataIndex, function (value) {
      return data.indexOfRawIndex(value);
    }) : data.indexOfRawIndex(payload.dataIndex);
  } else if (payload.name != null) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"])(payload.name) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])(payload.name, function (value) {
      return data.indexOfName(value);
    }) : data.indexOfName(payload.name);
  }
}
/**
 * Enable property storage to any host object.
 * Notice: Serialization is not supported.
 *
 * For example:
 * let inner = zrUitl.makeInner();
 *
 * function some1(hostObj) {
 *      inner(hostObj).someProperty = 1212;
 *      ...
 * }
 * function some2() {
 *      let fields = inner(this);
 *      fields.someProperty1 = 1212;
 *      fields.someProperty2 = 'xx';
 *      ...
 * }
 *
 * @return {Function}
 */

function makeInner() {
  var key = '__ec_inner_' + innerUniqueIndex++;
  return function (hostObj) {
    return hostObj[key] || (hostObj[key] = {});
  };
}
var innerUniqueIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__number_js__["c" /* getRandomIdBase */])();
/**
 * The same behavior as `component.getReferringComponents`.
 */

function parseFinder(ecModel, finderInput, opt) {
  var _a = preParseFinder(finderInput, opt),
      mainTypeSpecified = _a.mainTypeSpecified,
      queryOptionMap = _a.queryOptionMap,
      others = _a.others;

  var result = others;
  var defaultMainType = opt ? opt.defaultMainType : null;

  if (!mainTypeSpecified && defaultMainType) {
    queryOptionMap.set(defaultMainType, {});
  }

  queryOptionMap.each(function (queryOption, mainType) {
    var queryResult = queryReferringComponents(ecModel, mainType, queryOption, {
      useDefault: defaultMainType === mainType,
      enableAll: opt && opt.enableAll != null ? opt.enableAll : true,
      enableNone: opt && opt.enableNone != null ? opt.enableNone : true
    });
    result[mainType + 'Models'] = queryResult.models;
    result[mainType + 'Model'] = queryResult.models[0];
  });
  return result;
}
function preParseFinder(finderInput, opt) {
  var finder;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"])(finderInput)) {
    var obj = {};
    obj[finderInput + 'Index'] = 0;
    finder = obj;
  } else {
    finder = finderInput;
  }

  var queryOptionMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();
  var others = {};
  var mainTypeSpecified = false;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(finder, function (value, key) {
    // Exclude 'dataIndex' and other illgal keys.
    if (key === 'dataIndex' || key === 'dataIndexInside') {
      others[key] = value;
      return;
    }

    var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
    var mainType = parsedKey[1];
    var queryType = (parsedKey[2] || '').toLowerCase();

    if (!mainType || !queryType || opt && opt.includeMainTypes && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"])(opt.includeMainTypes, mainType) < 0) {
      return;
    }

    mainTypeSpecified = mainTypeSpecified || !!mainType;
    var queryOption = queryOptionMap.get(mainType) || queryOptionMap.set(mainType, {});
    queryOption[queryType] = value;
  });
  return {
    mainTypeSpecified: mainTypeSpecified,
    queryOptionMap: queryOptionMap,
    others: others
  };
}
var SINGLE_REFERRING = {
  useDefault: true,
  enableAll: false,
  enableNone: false
};
var MULTIPLE_REFERRING = {
  useDefault: false,
  enableAll: true,
  enableNone: true
};
function queryReferringComponents(ecModel, mainType, userOption, opt) {
  opt = opt || SINGLE_REFERRING;
  var indexOption = userOption.index;
  var idOption = userOption.id;
  var nameOption = userOption.name;
  var result = {
    models: null,
    specified: indexOption != null || idOption != null || nameOption != null
  };

  if (!result.specified) {
    // Use the first as default if `useDefault`.
    var firstCmpt = void 0;
    result.models = opt.useDefault && (firstCmpt = ecModel.getComponent(mainType)) ? [firstCmpt] : [];
    return result;
  }

  if (indexOption === 'none' || indexOption === false) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(opt.enableNone, '`"none"` or `false` is not a valid value on index option.');
    result.models = [];
    return result;
  } // `queryComponents` will return all components if
  // both all of index/id/name are null/undefined.


  if (indexOption === 'all') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(opt.enableAll, '`"all"` is not a valid value on index option.');
    indexOption = idOption = nameOption = null;
  }

  result.models = ecModel.queryComponents({
    mainType: mainType,
    index: indexOption,
    id: idOption,
    name: nameOption
  });
  return result;
}
function setAttribute(dom, key, value) {
  dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
}
function getAttribute(dom, key) {
  return dom.getAttribute ? dom.getAttribute(key) : dom[key];
}
function getTooltipRenderMode(renderModeOption) {
  if (renderModeOption === 'auto') {
    // Using html when `document` exists, use richText otherwise
    return __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_env_js__["a" /* default */].domSupported ? 'html' : 'richText';
  } else {
    return renderModeOption || 'html';
  }
}
/**
 * Group a list by key.
 */

function groupData(array, getKey // return key
) {
  var buckets = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();
  var keys = [];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(array, function (item) {
    var key = getKey(item);
    (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
  });
  return {
    keys: keys,
    buckets: buckets
  };
}
/**
 * Interpolate raw values of a series with percent
 *
 * @param data         data
 * @param labelModel   label model of the text element
 * @param sourceValue  start value. May be null/undefined when init.
 * @param targetValue  end value
 * @param percent      0~1 percentage; 0 uses start value while 1 uses end value
 * @return             interpolated values
 *                     If `sourceValue` and `targetValue` are `number`, return `number`.
 *                     If `sourceValue` and `targetValue` are `string`, return `string`.
 *                     If `sourceValue` and `targetValue` are `(string | number)[]`, return `(string | number)[]`.
 *                     Other cases do not supported.
 */

function interpolateRawValues(data, precision, sourceValue, targetValue, percent) {
  var isAutoPrecision = precision == null || precision === 'auto';

  if (targetValue == null) {
    return targetValue;
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isNumber"])(targetValue)) {
    var value = interpolateNumber(sourceValue || 0, targetValue, percent);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__number_js__["d" /* round */])(value, isAutoPrecision ? Math.max(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__number_js__["e" /* getPrecision */])(sourceValue || 0), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__number_js__["e" /* getPrecision */])(targetValue)) : precision);
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"])(targetValue)) {
    return percent < 1 ? sourceValue : targetValue;
  } else {
    var interpolated = [];
    var leftArr = sourceValue;
    var rightArr = targetValue;
    var length_1 = Math.max(leftArr ? leftArr.length : 0, rightArr.length);

    for (var i = 0; i < length_1; ++i) {
      var info = data.getDimensionInfo(i); // Don't interpolate ordinal dims

      if (info && info.type === 'ordinal') {
        // In init, there is no `sourceValue`, but should better not to get undefined result.
        interpolated[i] = (percent < 1 && leftArr ? leftArr : rightArr)[i];
      } else {
        var leftVal = leftArr && leftArr[i] ? leftArr[i] : 0;
        var rightVal = rightArr[i];
        var value = interpolateNumber(leftVal, rightVal, percent);
        interpolated[i] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__number_js__["d" /* round */])(value, isAutoPrecision ? Math.max(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__number_js__["e" /* getPrecision */])(leftVal), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__number_js__["e" /* getPrecision */])(rightVal)) : precision);
      }
    }

    return interpolated;
  }
}

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["extendShape"] = extendShape;
/* harmony export (immutable) */ __webpack_exports__["extendPath"] = extendPath;
/* harmony export (immutable) */ __webpack_exports__["registerShape"] = registerShape;
/* harmony export (immutable) */ __webpack_exports__["getShapeClass"] = getShapeClass;
/* harmony export (immutable) */ __webpack_exports__["makePath"] = makePath;
/* harmony export (immutable) */ __webpack_exports__["makeImage"] = makeImage;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergePath", function() { return mergePath; });
/* harmony export (immutable) */ __webpack_exports__["resizePath"] = resizePath;
/* harmony export (immutable) */ __webpack_exports__["subPixelOptimizeLine"] = subPixelOptimizeLine;
/* harmony export (immutable) */ __webpack_exports__["subPixelOptimizeRect"] = subPixelOptimizeRect;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subPixelOptimize", function() { return subPixelOptimize; });
/* harmony export (immutable) */ __webpack_exports__["getTransform"] = getTransform;
/* harmony export (immutable) */ __webpack_exports__["applyTransform"] = applyTransform;
/* harmony export (immutable) */ __webpack_exports__["transformDirection"] = transformDirection;
/* harmony export (immutable) */ __webpack_exports__["groupTransition"] = groupTransition;
/* harmony export (immutable) */ __webpack_exports__["clipPointsByRect"] = clipPointsByRect;
/* harmony export (immutable) */ __webpack_exports__["clipRectByRect"] = clipRectByRect;
/* harmony export (immutable) */ __webpack_exports__["createIcon"] = createIcon;
/* harmony export (immutable) */ __webpack_exports__["linePolygonIntersect"] = linePolygonIntersect;
/* harmony export (immutable) */ __webpack_exports__["lineLineIntersect"] = lineLineIntersect;
/* harmony export (immutable) */ __webpack_exports__["setTooltipConfig"] = setTooltipConfig;
/* harmony export (immutable) */ __webpack_exports__["traverseElements"] = traverseElements;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_tool_path_js__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_matrix_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_vector_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_graphic_Path_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_Transformable_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zrender_lib_graphic_Image_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_zrender_lib_graphic_Group_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_zrender_lib_graphic_Text_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_zrender_lib_graphic_shape_Circle_js__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_zrender_lib_graphic_shape_Ellipse_js__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_zrender_lib_graphic_shape_Sector_js__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_zrender_lib_graphic_shape_Ring_js__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_zrender_lib_graphic_shape_Polygon_js__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_zrender_lib_graphic_shape_Polyline_js__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_zrender_lib_graphic_shape_Rect_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_zrender_lib_graphic_shape_Line_js__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_zrender_lib_graphic_shape_BezierCurve_js__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_zrender_lib_graphic_shape_Arc_js__ = __webpack_require__(1708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_zrender_lib_graphic_CompoundPath_js__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_zrender_lib_graphic_LinearGradient_js__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_zrender_lib_graphic_RadialGradient_js__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_zrender_lib_core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_zrender_lib_core_OrientedBoundingRect_js__ = __webpack_require__(1700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_zrender_lib_core_Point_js__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_zrender_lib_graphic_IncrementalDisplayable_js__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_zrender_lib_graphic_helper_subPixelOptimize_js__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__animation_basicTrasition_js__ = __webpack_require__(40);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "updateProps", function() { return __WEBPACK_IMPORTED_MODULE_28__animation_basicTrasition_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "initProps", function() { return __WEBPACK_IMPORTED_MODULE_28__animation_basicTrasition_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "removeElement", function() { return __WEBPACK_IMPORTED_MODULE_28__animation_basicTrasition_js__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "removeElementWithFadeOut", function() { return __WEBPACK_IMPORTED_MODULE_28__animation_basicTrasition_js__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isElementRemoved", function() { return __WEBPACK_IMPORTED_MODULE_28__animation_basicTrasition_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Group", function() { return __WEBPACK_IMPORTED_MODULE_6_zrender_lib_graphic_Group_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Image", function() { return __WEBPACK_IMPORTED_MODULE_5_zrender_lib_graphic_Image_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Text", function() { return __WEBPACK_IMPORTED_MODULE_7_zrender_lib_graphic_Text_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Circle", function() { return __WEBPACK_IMPORTED_MODULE_8_zrender_lib_graphic_shape_Circle_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ellipse", function() { return __WEBPACK_IMPORTED_MODULE_9_zrender_lib_graphic_shape_Ellipse_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Sector", function() { return __WEBPACK_IMPORTED_MODULE_10_zrender_lib_graphic_shape_Sector_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ring", function() { return __WEBPACK_IMPORTED_MODULE_11_zrender_lib_graphic_shape_Ring_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Polygon", function() { return __WEBPACK_IMPORTED_MODULE_12_zrender_lib_graphic_shape_Polygon_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Polyline", function() { return __WEBPACK_IMPORTED_MODULE_13_zrender_lib_graphic_shape_Polyline_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Rect", function() { return __WEBPACK_IMPORTED_MODULE_14_zrender_lib_graphic_shape_Rect_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Line", function() { return __WEBPACK_IMPORTED_MODULE_15_zrender_lib_graphic_shape_Line_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BezierCurve", function() { return __WEBPACK_IMPORTED_MODULE_16_zrender_lib_graphic_shape_BezierCurve_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Arc", function() { return __WEBPACK_IMPORTED_MODULE_17_zrender_lib_graphic_shape_Arc_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IncrementalDisplayable", function() { return __WEBPACK_IMPORTED_MODULE_24_zrender_lib_graphic_IncrementalDisplayable_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CompoundPath", function() { return __WEBPACK_IMPORTED_MODULE_18_zrender_lib_graphic_CompoundPath_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LinearGradient", function() { return __WEBPACK_IMPORTED_MODULE_19_zrender_lib_graphic_LinearGradient_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RadialGradient", function() { return __WEBPACK_IMPORTED_MODULE_20_zrender_lib_graphic_RadialGradient_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BoundingRect", function() { return __WEBPACK_IMPORTED_MODULE_21_zrender_lib_core_BoundingRect_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "OrientedBoundingRect", function() { return __WEBPACK_IMPORTED_MODULE_22_zrender_lib_core_OrientedBoundingRect_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Point", function() { return __WEBPACK_IMPORTED_MODULE_23_zrender_lib_core_Point_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Path", function() { return __WEBPACK_IMPORTED_MODULE_3_zrender_lib_graphic_Path_js__["a"]; });

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





























/**
 * @deprecated export for compatitable reason
 */


var mathMax = Math.max;
var mathMin = Math.min;
var _customShapeMap = {};
/**
 * Extend shape with parameters
 */

function extendShape(opts) {
  return __WEBPACK_IMPORTED_MODULE_3_zrender_lib_graphic_Path_js__["a" /* default */].extend(opts);
}
var extendPathFromString = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_tool_path_js__["a" /* extendFromString */];
/**
 * Extend path
 */

function extendPath(pathData, opts) {
  return extendPathFromString(pathData, opts);
}
/**
 * Register a user defined shape.
 * The shape class can be fetched by `getShapeClass`
 * This method will overwrite the registered shapes, including
 * the registered built-in shapes, if using the same `name`.
 * The shape can be used in `custom series` and
 * `graphic component` by declaring `{type: name}`.
 *
 * @param name
 * @param ShapeClass Can be generated by `extendShape`.
 */

function registerShape(name, ShapeClass) {
  _customShapeMap[name] = ShapeClass;
}
/**
 * Find shape class registered by `registerShape`. Usually used in
 * fetching user defined shape.
 *
 * [Caution]:
 * (1) This method **MUST NOT be used inside echarts !!!**, unless it is prepared
 * to use user registered shapes.
 * Because the built-in shape (see `getBuiltInShape`) will be registered by
 * `registerShape` by default. That enables users to get both built-in
 * shapes as well as the shapes belonging to themsleves. But users can overwrite
 * the built-in shapes by using names like 'circle', 'rect' via calling
 * `registerShape`. So the echarts inner featrues should not fetch shapes from here
 * in case that it is overwritten by users, except that some features, like
 * `custom series`, `graphic component`, do it deliberately.
 *
 * (2) In the features like `custom series`, `graphic component`, the user input
 * `{tpye: 'xxx'}` does not only specify shapes but also specify other graphic
 * elements like `'group'`, `'text'`, `'image'` or event `'path'`. Those names
 * are reserved names, that is, if some user register a shape named `'image'`,
 * the shape will not be used. If we intending to add some more reserved names
 * in feature, that might bring break changes (disable some existing user shape
 * names). But that case probably rearly happen. So we dont make more mechanism
 * to resolve this issue here.
 *
 * @param name
 * @return The shape class. If not found, return nothing.
 */

function getShapeClass(name) {
  if (_customShapeMap.hasOwnProperty(name)) {
    return _customShapeMap[name];
  }
}
/**
 * Create a path element from path data string
 * @param pathData
 * @param opts
 * @param rect
 * @param layout 'center' or 'cover' default to be cover
 */

function makePath(pathData, opts, rect, layout) {
  var path = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_tool_path_js__["b" /* createFromString */](pathData, opts);

  if (rect) {
    if (layout === 'center') {
      rect = centerGraphic(rect, path.getBoundingRect());
    }

    resizePath(path, rect);
  }

  return path;
}
/**
 * Create a image element from image url
 * @param imageUrl image url
 * @param opts options
 * @param rect constrain rect
 * @param layout 'center' or 'cover'. Default to be 'cover'
 */

function makeImage(imageUrl, rect, layout) {
  var zrImg = new __WEBPACK_IMPORTED_MODULE_5_zrender_lib_graphic_Image_js__["a" /* default */]({
    style: {
      image: imageUrl,
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    },
    onload: function (img) {
      if (layout === 'center') {
        var boundingRect = {
          width: img.width,
          height: img.height
        };
        zrImg.setStyle(centerGraphic(rect, boundingRect));
      }
    }
  });
  return zrImg;
}
/**
 * Get position of centered element in bounding box.
 *
 * @param  rect         element local bounding box
 * @param  boundingRect constraint bounding box
 * @return element position containing x, y, width, and height
 */

function centerGraphic(rect, boundingRect) {
  // Set rect to center, keep width / height ratio.
  var aspect = boundingRect.width / boundingRect.height;
  var width = rect.height * aspect;
  var height;

  if (width <= rect.width) {
    height = rect.height;
  } else {
    width = rect.width;
    height = width / aspect;
  }

  var cx = rect.x + rect.width / 2;
  var cy = rect.y + rect.height / 2;
  return {
    x: cx - width / 2,
    y: cy - height / 2,
    width: width,
    height: height
  };
}

var mergePath = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_tool_path_js__["c" /* mergePath */];
/**
 * Resize a path to fit the rect
 * @param path
 * @param rect
 */

function resizePath(path, rect) {
  if (!path.applyTransform) {
    return;
  }

  var pathRect = path.getBoundingRect();
  var m = pathRect.calculateTransform(rect);
  path.applyTransform(m);
}
/**
 * Sub pixel optimize line for canvas
 */

function subPixelOptimizeLine(param) {
  __WEBPACK_IMPORTED_MODULE_25_zrender_lib_graphic_helper_subPixelOptimize_js__["b" /* subPixelOptimizeLine */](param.shape, param.shape, param.style);
  return param;
}
/**
 * Sub pixel optimize rect for canvas
 */

function subPixelOptimizeRect(param) {
  __WEBPACK_IMPORTED_MODULE_25_zrender_lib_graphic_helper_subPixelOptimize_js__["a" /* subPixelOptimizeRect */](param.shape, param.shape, param.style);
  return param;
}
/**
 * Sub pixel optimize for canvas
 *
 * @param position Coordinate, such as x, y
 * @param lineWidth Should be nonnegative integer.
 * @param positiveOrNegative Default false (negative).
 * @return Optimized position.
 */

var subPixelOptimize = __WEBPACK_IMPORTED_MODULE_25_zrender_lib_graphic_helper_subPixelOptimize_js__["c" /* subPixelOptimize */];
/**
 * Get transform matrix of target (param target),
 * in coordinate of its ancestor (param ancestor)
 *
 * @param target
 * @param [ancestor]
 */

function getTransform(target, ancestor) {
  var mat = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_matrix_js__["identity"]([]);

  while (target && target !== ancestor) {
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_matrix_js__["mul"](mat, target.getLocalTransform(), mat);
    target = target.parent;
  }

  return mat;
}
/**
 * Apply transform to an vertex.
 * @param target [x, y]
 * @param transform Can be:
 *      + Transform matrix: like [1, 0, 0, 1, 0, 0]
 *      + {position, rotation, scale}, the same as `zrender/Transformable`.
 * @param invert Whether use invert matrix.
 * @return [x, y]
 */

function applyTransform(target, transform, invert) {
  if (transform && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_zrender_lib_core_util_js__["isArrayLike"])(transform)) {
    transform = __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_Transformable_js__["a" /* default */].getLocalTransform(transform);
  }

  if (invert) {
    transform = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_matrix_js__["invert"]([], transform);
  }

  return __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_vector_js__["applyTransform"]([], target, transform);
}
/**
 * @param direction 'left' 'right' 'top' 'bottom'
 * @param transform Transform matrix: like [1, 0, 0, 1, 0, 0]
 * @param invert Whether use invert matrix.
 * @return Transformed direction. 'left' 'right' 'top' 'bottom'
 */

function transformDirection(direction, transform, invert) {
  // Pick a base, ensure that transform result will not be (0, 0).
  var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
  var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
  var vertex = [direction === 'left' ? -hBase : direction === 'right' ? hBase : 0, direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0];
  vertex = applyTransform(vertex, transform, invert);
  return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
}

function isNotGroup(el) {
  return !el.isGroup;
}

function isPath(el) {
  return el.shape != null;
}
/**
 * Apply group transition animation from g1 to g2.
 * If no animatableModel, no animation.
 */


function groupTransition(g1, g2, animatableModel) {
  if (!g1 || !g2) {
    return;
  }

  function getElMap(g) {
    var elMap = {};
    g.traverse(function (el) {
      if (isNotGroup(el) && el.anid) {
        elMap[el.anid] = el;
      }
    });
    return elMap;
  }

  function getAnimatableProps(el) {
    var obj = {
      x: el.x,
      y: el.y,
      rotation: el.rotation
    };

    if (isPath(el)) {
      obj.shape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_zrender_lib_core_util_js__["extend"])({}, el.shape);
    }

    return obj;
  }

  var elMap1 = getElMap(g1);
  g2.traverse(function (el) {
    if (isNotGroup(el) && el.anid) {
      var oldEl = elMap1[el.anid];

      if (oldEl) {
        var newProp = getAnimatableProps(el);
        el.attr(getAnimatableProps(oldEl));
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__animation_basicTrasition_js__["a" /* updateProps */])(el, newProp, animatableModel, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__innerStore_js__["a" /* getECData */])(el).dataIndex);
      }
    }
  });
}
function clipPointsByRect(points, rect) {
  // FIXME: this way migth be incorrect when grpahic clipped by a corner.
  // and when element have border.
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_zrender_lib_core_util_js__["map"])(points, function (point) {
    var x = point[0];
    x = mathMax(x, rect.x);
    x = mathMin(x, rect.x + rect.width);
    var y = point[1];
    y = mathMax(y, rect.y);
    y = mathMin(y, rect.y + rect.height);
    return [x, y];
  });
}
/**
 * Return a new clipped rect. If rect size are negative, return undefined.
 */

function clipRectByRect(targetRect, rect) {
  var x = mathMax(targetRect.x, rect.x);
  var x2 = mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
  var y = mathMax(targetRect.y, rect.y);
  var y2 = mathMin(targetRect.y + targetRect.height, rect.y + rect.height); // If the total rect is cliped, nothing, including the border,
  // should be painted. So return undefined.

  if (x2 >= x && y2 >= y) {
    return {
      x: x,
      y: y,
      width: x2 - x,
      height: y2 - y
    };
  }
}
function createIcon(iconStr, // Support 'image://' or 'path://' or direct svg path.
opt, rect) {
  var innerOpts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_zrender_lib_core_util_js__["extend"])({
    rectHover: true
  }, opt);
  var style = innerOpts.style = {
    strokeNoScale: true
  };
  rect = rect || {
    x: -1,
    y: -1,
    width: 2,
    height: 2
  };

  if (iconStr) {
    return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_zrender_lib_core_util_js__["defaults"])(style, rect), new __WEBPACK_IMPORTED_MODULE_5_zrender_lib_graphic_Image_js__["a" /* default */](innerOpts)) : makePath(iconStr.replace('path://', ''), innerOpts, rect, 'center');
  }
}
/**
 * Return `true` if the given line (line `a`) and the given polygon
 * are intersect.
 * Note that we do not count colinear as intersect here because no
 * requirement for that. We could do that if required in future.
 */

function linePolygonIntersect(a1x, a1y, a2x, a2y, points) {
  for (var i = 0, p2 = points[points.length - 1]; i < points.length; i++) {
    var p = points[i];

    if (lineLineIntersect(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) {
      return true;
    }

    p2 = p;
  }
}
/**
 * Return `true` if the given two lines (line `a` and line `b`)
 * are intersect.
 * Note that we do not count colinear as intersect here because no
 * requirement for that. We could do that if required in future.
 */

function lineLineIntersect(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
  // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
  var mx = a2x - a1x;
  var my = a2y - a1y;
  var nx = b2x - b1x;
  var ny = b2y - b1y; // `vec_m` and `vec_n` are parallel iff
  //     exising `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.

  var nmCrossProduct = crossProduct2d(nx, ny, mx, my);

  if (nearZero(nmCrossProduct)) {
    return false;
  } // `vec_m` and `vec_n` are intersect iff
  //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
  //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
  //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.


  var b1a1x = a1x - b1x;
  var b1a1y = a1y - b1y;
  var q = crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;

  if (q < 0 || q > 1) {
    return false;
  }

  var p = crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;

  if (p < 0 || p > 1) {
    return false;
  }

  return true;
}
/**
 * Cross product of 2-dimension vector.
 */

function crossProduct2d(x1, y1, x2, y2) {
  return x1 * y2 - x2 * y1;
}

function nearZero(val) {
  return val <= 1e-6 && val >= -1e-6;
}

function setTooltipConfig(opt) {
  var itemTooltipOption = opt.itemTooltipOption;
  var componentModel = opt.componentModel;
  var itemName = opt.itemName;
  var itemTooltipOptionObj = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_zrender_lib_core_util_js__["isString"])(itemTooltipOption) ? {
    formatter: itemTooltipOption
  } : itemTooltipOption;
  var mainType = componentModel.mainType;
  var componentIndex = componentModel.componentIndex;
  var formatterParams = {
    componentType: mainType,
    name: itemName,
    $vars: ['name']
  };
  formatterParams[mainType + 'Index'] = componentIndex;
  var formatterParamsExtra = opt.formatterParamsExtra;

  if (formatterParamsExtra) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_zrender_lib_core_util_js__["each"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_zrender_lib_core_util_js__["keys"])(formatterParamsExtra), function (key) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_zrender_lib_core_util_js__["hasOwn"])(formatterParams, key)) {
        formatterParams[key] = formatterParamsExtra[key];
        formatterParams.$vars.push(key);
      }
    });
  }

  var ecData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__innerStore_js__["a" /* getECData */])(opt.el);
  ecData.componentMainType = mainType;
  ecData.componentIndex = componentIndex;
  ecData.tooltipConfig = {
    name: itemName,
    option: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_zrender_lib_core_util_js__["defaults"])({
      content: itemName,
      formatterParams: formatterParams
    }, itemTooltipOptionObj)
  };
}

function traverseElement(el, cb) {
  var stopped; // TODO
  // Polyfill for fixing zrender group traverse don't visit it's root issue.

  if (el.isGroup) {
    stopped = cb(el);
  }

  if (!stopped) {
    el.traverse(cb);
  }
}

function traverseElements(els, cb) {
  if (els) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_zrender_lib_core_util_js__["isArray"])(els)) {
      for (var i = 0; i < els.length; i++) {
        traverseElement(els[i], cb);
      }
    } else {
      traverseElement(els, cb);
    }
  }
} // Register built-in shapes. These shapes might be overwirtten
// by users, although we do not recommend that.

registerShape('circle', __WEBPACK_IMPORTED_MODULE_8_zrender_lib_graphic_shape_Circle_js__["a" /* default */]);
registerShape('ellipse', __WEBPACK_IMPORTED_MODULE_9_zrender_lib_graphic_shape_Ellipse_js__["a" /* default */]);
registerShape('sector', __WEBPACK_IMPORTED_MODULE_10_zrender_lib_graphic_shape_Sector_js__["a" /* default */]);
registerShape('ring', __WEBPACK_IMPORTED_MODULE_11_zrender_lib_graphic_shape_Ring_js__["a" /* default */]);
registerShape('polygon', __WEBPACK_IMPORTED_MODULE_12_zrender_lib_graphic_shape_Polygon_js__["a" /* default */]);
registerShape('polyline', __WEBPACK_IMPORTED_MODULE_13_zrender_lib_graphic_shape_Polyline_js__["a" /* default */]);
registerShape('rect', __WEBPACK_IMPORTED_MODULE_14_zrender_lib_graphic_shape_Rect_js__["a" /* default */]);
registerShape('line', __WEBPACK_IMPORTED_MODULE_15_zrender_lib_graphic_shape_Line_js__["a" /* default */]);
registerShape('bezierCurve', __WEBPACK_IMPORTED_MODULE_16_zrender_lib_graphic_shape_BezierCurve_js__["a" /* default */]);
registerShape('arc', __WEBPACK_IMPORTED_MODULE_17_zrender_lib_graphic_shape_Arc_js__["a" /* default */]);


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(1685)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = linearMap;
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePercent;
/* harmony export (immutable) */ __webpack_exports__["d"] = round;
/* harmony export (immutable) */ __webpack_exports__["j"] = asc;
/* harmony export (immutable) */ __webpack_exports__["e"] = getPrecision;
/* harmony export (immutable) */ __webpack_exports__["s"] = getPrecisionSafe;
/* harmony export (immutable) */ __webpack_exports__["k"] = getPixelPrecision;
/* harmony export (immutable) */ __webpack_exports__["v"] = getPercentWithPrecision;
/* harmony export (immutable) */ __webpack_exports__["o"] = addSafe;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return MAX_SAFE_INTEGER; });
/* harmony export (immutable) */ __webpack_exports__["q"] = remRadian;
/* harmony export (immutable) */ __webpack_exports__["r"] = isRadianAroundZero;
/* harmony export (immutable) */ __webpack_exports__["f"] = parseDate;
/* harmony export (immutable) */ __webpack_exports__["n"] = quantity;
/* harmony export (immutable) */ __webpack_exports__["l"] = quantityExponent;
/* harmony export (immutable) */ __webpack_exports__["m"] = nice;
/* harmony export (immutable) */ __webpack_exports__["t"] = quantile;
/* harmony export (immutable) */ __webpack_exports__["i"] = reformIntervals;
/* harmony export (immutable) */ __webpack_exports__["g"] = numericToNumber;
/* harmony export (immutable) */ __webpack_exports__["b"] = isNumeric;
/* harmony export (immutable) */ __webpack_exports__["c"] = getRandomIdBase;
/* unused harmony export getGreatestCommonDividor */
/* harmony export (immutable) */ __webpack_exports__["p"] = getLeastCommonMultiple;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* A third-party license is embeded for some of the code in this file:
* The method "quantile" was copied from "d3.js".
* (See more details in the comment of the method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/

var RADIAN_EPSILON = 1e-4; // Although chrome already enlarge this number to 100 for `toFixed`, but
// we sill follow the spec for compatibility.

var ROUND_SUPPORTED_PRECISION_MAX = 20;

function _trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
}
/**
 * Linear mapping a value from domain to range
 * @param  val
 * @param  domain Domain extent domain[0] can be bigger than domain[1]
 * @param  range  Range extent range[0] can be bigger than range[1]
 * @param  clamp Default to be false
 */


function linearMap(val, domain, range, clamp) {
  var d0 = domain[0];
  var d1 = domain[1];
  var r0 = range[0];
  var r1 = range[1];
  var subDomain = d1 - d0;
  var subRange = r1 - r0;

  if (subDomain === 0) {
    return subRange === 0 ? r0 : (r0 + r1) / 2;
  } // Avoid accuracy problem in edge, such as
  // 146.39 - 62.83 === 83.55999999999999.
  // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
  // It is a little verbose for efficiency considering this method
  // is a hotspot.


  if (clamp) {
    if (subDomain > 0) {
      if (val <= d0) {
        return r0;
      } else if (val >= d1) {
        return r1;
      }
    } else {
      if (val >= d0) {
        return r0;
      } else if (val <= d1) {
        return r1;
      }
    }
  } else {
    if (val === d0) {
      return r0;
    }

    if (val === d1) {
      return r1;
    }
  }

  return (val - d0) / subDomain * subRange + r0;
}
/**
 * Convert a percent string to absolute number.
 * Returns NaN if percent is not a valid string or number
 */

function parsePercent(percent, all) {
  switch (percent) {
    case 'center':
    case 'middle':
      percent = '50%';
      break;

    case 'left':
    case 'top':
      percent = '0%';
      break;

    case 'right':
    case 'bottom':
      percent = '100%';
      break;
  }

  if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"](percent)) {
    if (_trim(percent).match(/%$/)) {
      return parseFloat(percent) / 100 * all;
    }

    return parseFloat(percent);
  }

  return percent == null ? NaN : +percent;
}
function round(x, precision, returnStr) {
  if (precision == null) {
    precision = 10;
  } // Avoid range error


  precision = Math.min(Math.max(0, precision), ROUND_SUPPORTED_PRECISION_MAX); // PENDING: 1.005.toFixed(2) is '1.00' rather than '1.01'

  x = (+x).toFixed(precision);
  return returnStr ? x : +x;
}
/**
 * Inplacd asc sort arr.
 * The input arr will be modified.
 */

function asc(arr) {
  arr.sort(function (a, b) {
    return a - b;
  });
  return arr;
}
/**
 * Get precision.
 */

function getPrecision(val) {
  val = +val;

  if (isNaN(val)) {
    return 0;
  } // It is much faster than methods converting number to string as follows
  //      let tmp = val.toString();
  //      return tmp.length - 1 - tmp.indexOf('.');
  // especially when precision is low
  // Notice:
  // (1) If the loop count is over about 20, it is slower than `getPrecisionSafe`.
  //     (see https://jsbench.me/2vkpcekkvw/1)
  // (2) If the val is less than for example 1e-15, the result may be incorrect.
  //     (see test/ut/spec/util/number.test.ts `getPrecision_equal_random`)


  if (val > 1e-14) {
    var e = 1;

    for (var i = 0; i < 15; i++, e *= 10) {
      if (Math.round(val * e) / e === val) {
        return i;
      }
    }
  }

  return getPrecisionSafe(val);
}
/**
 * Get precision with slow but safe method
 */

function getPrecisionSafe(val) {
  // toLowerCase for: '3.4E-12'
  var str = val.toString().toLowerCase(); // Consider scientific notation: '3.4e-12' '3.4e+12'

  var eIndex = str.indexOf('e');
  var exp = eIndex > 0 ? +str.slice(eIndex + 1) : 0;
  var significandPartLen = eIndex > 0 ? eIndex : str.length;
  var dotIndex = str.indexOf('.');
  var decimalPartLen = dotIndex < 0 ? 0 : significandPartLen - 1 - dotIndex;
  return Math.max(0, decimalPartLen - exp);
}
/**
 * Minimal dicernible data precisioin according to a single pixel.
 */

function getPixelPrecision(dataExtent, pixelExtent) {
  var log = Math.log;
  var LN10 = Math.LN10;
  var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
  var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10); // toFixed() digits argument must be between 0 and 20.

  var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
  return !isFinite(precision) ? 20 : precision;
}
/**
 * Get a data of given precision, assuring the sum of percentages
 * in valueList is 1.
 * The largest remainer method is used.
 * https://en.wikipedia.org/wiki/Largest_remainder_method
 *
 * @param valueList a list of all data
 * @param idx index of the data to be processed in valueList
 * @param precision integer number showing digits of precision
 * @return percent ranging from 0 to 100
 */

function getPercentWithPrecision(valueList, idx, precision) {
  if (!valueList[idx]) {
    return 0;
  }

  var sum = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["reduce"](valueList, function (acc, val) {
    return acc + (isNaN(val) ? 0 : val);
  }, 0);

  if (sum === 0) {
    return 0;
  }

  var digits = Math.pow(10, precision);
  var votesPerQuota = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"](valueList, function (val) {
    return (isNaN(val) ? 0 : val) / sum * digits * 100;
  });
  var targetSeats = digits * 100;
  var seats = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"](votesPerQuota, function (votes) {
    // Assign automatic seats.
    return Math.floor(votes);
  });
  var currentSum = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["reduce"](seats, function (acc, val) {
    return acc + val;
  }, 0);
  var remainder = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"](votesPerQuota, function (votes, idx) {
    return votes - seats[idx];
  }); // Has remainding votes.

  while (currentSum < targetSeats) {
    // Find next largest remainder.
    var max = Number.NEGATIVE_INFINITY;
    var maxId = null;

    for (var i = 0, len = remainder.length; i < len; ++i) {
      if (remainder[i] > max) {
        max = remainder[i];
        maxId = i;
      }
    } // Add a vote to max remainder.


    ++seats[maxId];
    remainder[maxId] = 0;
    ++currentSum;
  }

  return seats[idx] / digits;
}
/**
 * Solve the floating point adding problem like 0.1 + 0.2 === 0.30000000000000004
 * See <http://0.30000000000000004.com/>
 */

function addSafe(val0, val1) {
  var maxPrecision = Math.max(getPrecision(val0), getPrecision(val1)); // const multiplier = Math.pow(10, maxPrecision);
  // return (Math.round(val0 * multiplier) + Math.round(val1 * multiplier)) / multiplier;

  var sum = val0 + val1; // // PENDING: support more?

  return maxPrecision > ROUND_SUPPORTED_PRECISION_MAX ? sum : round(sum, maxPrecision);
} // Number.MAX_SAFE_INTEGER, ie do not support.

var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * To 0 - 2 * PI, considering negative radian.
 */

function remRadian(radian) {
  var pi2 = Math.PI * 2;
  return (radian % pi2 + pi2) % pi2;
}
/**
 * @param {type} radian
 * @return {boolean}
 */

function isRadianAroundZero(val) {
  return val > -RADIAN_EPSILON && val < RADIAN_EPSILON;
} // eslint-disable-next-line

var TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line

/**
 * @param value valid type: number | string | Date, otherwise return `new Date(NaN)`
 *   These values can be accepted:
 *   + An instance of Date, represent a time in its own time zone.
 *   + Or string in a subset of ISO 8601, only including:
 *     + only year, month, date: '2012-03', '2012-03-01', '2012-03-01 05', '2012-03-01 05:06',
 *     + separated with T or space: '2012-03-01T12:22:33.123', '2012-03-01 12:22:33.123',
 *     + time zone: '2012-03-01T12:22:33Z', '2012-03-01T12:22:33+8000', '2012-03-01T12:22:33-05:00',
 *     all of which will be treated as local time if time zone is not specified
 *     (see <https://momentjs.com/>).
 *   + Or other string format, including (all of which will be treated as loacal time):
 *     '2012', '2012-3-1', '2012/3/1', '2012/03/01',
 *     '2009/6/12 2:00', '2009/6/12 2:05:08', '2009/6/12 2:05:08.123'
 *   + a timestamp, which represent a time in UTC.
 * @return date Never be null/undefined. If invalid, return `new Date(NaN)`.
 */

function parseDate(value) {
  if (value instanceof Date) {
    return value;
  } else if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"](value)) {
    // Different browsers parse date in different way, so we parse it manually.
    // Some other issues:
    // new Date('1970-01-01') is UTC,
    // new Date('1970/01/01') and new Date('1970-1-01') is local.
    // See issue #3623
    var match = TIME_REG.exec(value);

    if (!match) {
      // return Invalid Date.
      return new Date(NaN);
    } // Use local time when no timezone offset specifed.


    if (!match[8]) {
      // match[n] can only be string or undefined.
      // But take care of '12' + 1 => '121'.
      return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0);
    } // Timezoneoffset of Javascript Date has considered DST (Daylight Saving Time,
    // https://tc39.github.io/ecma262/#sec-daylight-saving-time-adjustment).
    // For example, system timezone is set as "Time Zone: America/Toronto",
    // then these code will get different result:
    // `new Date(1478411999999).getTimezoneOffset();  // get 240`
    // `new Date(1478412000000).getTimezoneOffset();  // get 300`
    // So we should not use `new Date`, but use `Date.UTC`.
    else {
        var hour = +match[4] || 0;

        if (match[8].toUpperCase() !== 'Z') {
          hour -= +match[8].slice(0, 3);
        }

        return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0));
      }
  } else if (value == null) {
    return new Date(NaN);
  }

  return new Date(Math.round(value));
}
/**
 * Quantity of a number. e.g. 0.1, 1, 10, 100
 *
 * @param val
 * @return
 */

function quantity(val) {
  return Math.pow(10, quantityExponent(val));
}
/**
 * Exponent of the quantity of a number
 * e.g., 1234 equals to 1.234*10^3, so quantityExponent(1234) is 3
 *
 * @param val non-negative value
 * @return
 */

function quantityExponent(val) {
  if (val === 0) {
    return 0;
  }

  var exp = Math.floor(Math.log(val) / Math.LN10);
  /**
   * exp is expected to be the rounded-down result of the base-10 log of val.
   * But due to the precision loss with Math.log(val), we need to restore it
   * using 10^exp to make sure we can get val back from exp. #11249
   */

  if (val / Math.pow(10, exp) >= 10) {
    exp++;
  }

  return exp;
}
/**
 * find a “nice” number approximately equal to x. Round the number if round = true,
 * take ceiling if round = false. The primary observation is that the “nicest”
 * numbers in decimal are 1, 2, and 5, and all power-of-ten multiples of these numbers.
 *
 * See "Nice Numbers for Graph Labels" of Graphic Gems.
 *
 * @param  val Non-negative value.
 * @param  round
 * @return Niced number
 */

function nice(val, round) {
  var exponent = quantityExponent(val);
  var exp10 = Math.pow(10, exponent);
  var f = val / exp10; // 1 <= f < 10

  var nf;

  if (round) {
    if (f < 1.5) {
      nf = 1;
    } else if (f < 2.5) {
      nf = 2;
    } else if (f < 4) {
      nf = 3;
    } else if (f < 7) {
      nf = 5;
    } else {
      nf = 10;
    }
  } else {
    if (f < 1) {
      nf = 1;
    } else if (f < 2) {
      nf = 2;
    } else if (f < 3) {
      nf = 3;
    } else if (f < 5) {
      nf = 5;
    } else {
      nf = 10;
    }
  }

  val = nf * exp10; // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
  // 20 is the uppper bound of toFixed.

  return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
}
/**
 * This code was copied from "d3.js"
 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/arrays/quantile.js>.
 * See the license statement at the head of this file.
 * @param ascArr
 */

function quantile(ascArr, p) {
  var H = (ascArr.length - 1) * p + 1;
  var h = Math.floor(H);
  var v = +ascArr[h - 1];
  var e = H - h;
  return e ? v + e * (ascArr[h] - v) : v;
}
/**
 * Order intervals asc, and split them when overlap.
 * expect(numberUtil.reformIntervals([
 *     {interval: [18, 62], close: [1, 1]},
 *     {interval: [-Infinity, -70], close: [0, 0]},
 *     {interval: [-70, -26], close: [1, 1]},
 *     {interval: [-26, 18], close: [1, 1]},
 *     {interval: [62, 150], close: [1, 1]},
 *     {interval: [106, 150], close: [1, 1]},
 *     {interval: [150, Infinity], close: [0, 0]}
 * ])).toEqual([
 *     {interval: [-Infinity, -70], close: [0, 0]},
 *     {interval: [-70, -26], close: [1, 1]},
 *     {interval: [-26, 18], close: [0, 1]},
 *     {interval: [18, 62], close: [0, 1]},
 *     {interval: [62, 150], close: [0, 1]},
 *     {interval: [150, Infinity], close: [0, 0]}
 * ]);
 * @param list, where `close` mean open or close
 *        of the interval, and Infinity can be used.
 * @return The origin list, which has been reformed.
 */

function reformIntervals(list) {
  list.sort(function (a, b) {
    return littleThan(a, b, 0) ? -1 : 1;
  });
  var curr = -Infinity;
  var currClose = 1;

  for (var i = 0; i < list.length;) {
    var interval = list[i].interval;
    var close_1 = list[i].close;

    for (var lg = 0; lg < 2; lg++) {
      if (interval[lg] <= curr) {
        interval[lg] = curr;
        close_1[lg] = !lg ? 1 - currClose : 1;
      }

      curr = interval[lg];
      currClose = close_1[lg];
    }

    if (interval[0] === interval[1] && close_1[0] * close_1[1] !== 1) {
      list.splice(i, 1);
    } else {
      i++;
    }
  }

  return list;

  function littleThan(a, b, lg) {
    return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
  }
}
/**
 * [Numberic is defined as]:
 *     `parseFloat(val) == val`
 * For example:
 * numeric:
 *     typeof number except NaN, '-123', '123', '2e3', '-2e3', '011', 'Infinity', Infinity,
 *     and they rounded by white-spaces or line-terminal like ' -123 \n ' (see es spec)
 * not-numeric:
 *     null, undefined, [], {}, true, false, 'NaN', NaN, '123ab',
 *     empty string, string with only white-spaces or line-terminal (see es spec),
 *     0x12, '0x12', '-0x12', 012, '012', '-012',
 *     non-string, ...
 *
 * @test See full test cases in `test/ut/spec/util/number.js`.
 * @return Must be a typeof number. If not numeric, return NaN.
 */

function numericToNumber(val) {
  var valFloat = parseFloat(val);
  return valFloat == val // eslint-disable-line eqeqeq
  && (valFloat !== 0 || !__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"](val) || val.indexOf('x') <= 0) // For case ' 0x0 '.
  ? valFloat : NaN;
}
/**
 * Definition of "numeric": see `numericToNumber`.
 */

function isNumeric(val) {
  return !isNaN(numericToNumber(val));
}
/**
 * Use random base to prevent users hard code depending on
 * this auto generated marker id.
 * @return An positive integer.
 */

function getRandomIdBase() {
  return Math.round(Math.random() * 9);
}
/**
 * Get the greatest common dividor
 *
 * @param {number} a one number
 * @param {number} b the other number
 */

function getGreatestCommonDividor(a, b) {
  if (b === 0) {
    return a;
  }

  return getGreatestCommonDividor(b, a % b);
}
/**
 * Get the least common multiple
 *
 * @param {number} a one number
 * @param {number} b the other number
 */

function getLeastCommonMultiple(a, b) {
  if (a == null) {
    return b;
  }

  if (b == null) {
    return a;
  }

  return a * b / getGreatestCommonDividor(a, b);
}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(387);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
/* unused harmony export install */
/* unused harmony export mapState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mapMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mapGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mapActions; });
/* unused harmony export createNamespacedHelpers */
/**
 * vuex v2.5.0
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (true) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (true) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (true) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (true) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  var state = options.state; if ( state === void 0 ) state = {};
  if (typeof state === 'function') {
    state = state() || {};
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  if (true) {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (true) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    "prod" !== 'production' &&
    options && options.silent
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (true) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });

  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  return genericSubscribe(fn, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (true) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (true) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (true) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if ("prod" !== 'production' && !store._actions[type]) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if ("prod" !== 'production' && !store._mutations[type]) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (true) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (true) {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (true) {
    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (true) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if ("prod" !== 'production' && !(val in this.$store.getters)) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if ("prod" !== 'production' && !module) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '2.5.0',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};


/* harmony default export */ __webpack_exports__["b"] = (index_esm);


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HOVER_STATE_NORMAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return HOVER_STATE_BLUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return HOVER_STATE_EMPHASIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SPECIAL_STATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DISPLAY_STATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return Z2_EMPHASIS_LIFT; });
/* unused harmony export Z2_SELECT_LIFT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return HIGHLIGHT_ACTION_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return DOWNPLAY_ACTION_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SELECT_ACTION_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return UNSELECT_ACTION_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return TOGGLE_SELECT_ACTION_TYPE; });
/* harmony export (immutable) */ __webpack_exports__["L"] = setStatesFlag;
/* unused harmony export clearStates */
/* harmony export (immutable) */ __webpack_exports__["H"] = setDefaultStateProxy;
/* unused harmony export enterEmphasisWhenMouseOver */
/* unused harmony export leaveEmphasisWhenMouseOut */
/* harmony export (immutable) */ __webpack_exports__["j"] = enterEmphasis;
/* harmony export (immutable) */ __webpack_exports__["k"] = leaveEmphasis;
/* harmony export (immutable) */ __webpack_exports__["w"] = enterBlur;
/* harmony export (immutable) */ __webpack_exports__["x"] = leaveBlur;
/* harmony export (immutable) */ __webpack_exports__["y"] = enterSelect;
/* harmony export (immutable) */ __webpack_exports__["z"] = leaveSelect;
/* harmony export (immutable) */ __webpack_exports__["o"] = allLeaveBlur;
/* unused harmony export blurSeries */
/* harmony export (immutable) */ __webpack_exports__["i"] = blurComponent;
/* harmony export (immutable) */ __webpack_exports__["g"] = blurSeriesFromHighlightPayload;
/* harmony export (immutable) */ __webpack_exports__["h"] = findComponentHighDownDispatchers;
/* harmony export (immutable) */ __webpack_exports__["r"] = handleGlobalMouseOverForHighDown;
/* harmony export (immutable) */ __webpack_exports__["s"] = handleGlobalMouseOutForHighDown;
/* harmony export (immutable) */ __webpack_exports__["m"] = toggleSelectionFromPayload;
/* harmony export (immutable) */ __webpack_exports__["n"] = updateSeriesElementSelection;
/* harmony export (immutable) */ __webpack_exports__["p"] = getAllSelectedIndices;
/* harmony export (immutable) */ __webpack_exports__["d"] = enableHoverEmphasis;
/* unused harmony export disableHoverEmphasis */
/* harmony export (immutable) */ __webpack_exports__["G"] = toggleHoverEmphasis;
/* harmony export (immutable) */ __webpack_exports__["K"] = enableHoverFocus;
/* harmony export (immutable) */ __webpack_exports__["F"] = setStatesStylesFromModel;
/* harmony export (immutable) */ __webpack_exports__["c"] = setAsHighDownDispatcher;
/* harmony export (immutable) */ __webpack_exports__["q"] = isHighDownDispatcher;
/* harmony export (immutable) */ __webpack_exports__["I"] = enableComponentHighDownFeatures;
/* harmony export (immutable) */ __webpack_exports__["E"] = getHighlightDigit;
/* harmony export (immutable) */ __webpack_exports__["l"] = isSelectChangePayload;
/* harmony export (immutable) */ __webpack_exports__["e"] = isHighDownPayload;
/* harmony export (immutable) */ __webpack_exports__["v"] = savePathStates;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_LRU_js__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_tool_color_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zrender_lib_graphic_Path_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__log_js__ = __webpack_require__(14);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






 // Reserve 0 as default.

var _highlightNextDigit = 1;
var _highlightKeyMap = {};
var getSavedStates = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__model_js__["a" /* makeInner */])();
var getComponentStates = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__model_js__["a" /* makeInner */])();
var HOVER_STATE_NORMAL = 0;
var HOVER_STATE_BLUR = 1;
var HOVER_STATE_EMPHASIS = 2;
var SPECIAL_STATES = ['emphasis', 'blur', 'select'];
var DISPLAY_STATES = ['normal', 'emphasis', 'blur', 'select'];
var Z2_EMPHASIS_LIFT = 10;
var Z2_SELECT_LIFT = 9;
var HIGHLIGHT_ACTION_TYPE = 'highlight';
var DOWNPLAY_ACTION_TYPE = 'downplay';
var SELECT_ACTION_TYPE = 'select';
var UNSELECT_ACTION_TYPE = 'unselect';
var TOGGLE_SELECT_ACTION_TYPE = 'toggleSelect';

function hasFillOrStroke(fillOrStroke) {
  return fillOrStroke != null && fillOrStroke !== 'none';
} // Most lifted color are duplicated.


var liftedColorCache = new __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_LRU_js__["a" /* default */](100);

function liftColor(color) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"])(color)) {
    var liftedColor = liftedColorCache.get(color);

    if (!liftedColor) {
      liftedColor = __WEBPACK_IMPORTED_MODULE_3_zrender_lib_tool_color_js__["lift"](color, -0.1);
      liftedColorCache.put(color, liftedColor);
    }

    return liftedColor;
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isGradientObject"])(color)) {
    var ret = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])({}, color);
    ret.colorStops = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"])(color.colorStops, function (stop) {
      return {
        offset: stop.offset,
        color: __WEBPACK_IMPORTED_MODULE_3_zrender_lib_tool_color_js__["lift"](stop.color, -0.1)
      };
    });
    return ret;
  } // Change nothing.


  return color;
}

function doChangeHoverState(el, stateName, hoverStateEnum) {
  if (el.onHoverStateChange && (el.hoverState || 0) !== hoverStateEnum) {
    el.onHoverStateChange(stateName);
  }

  el.hoverState = hoverStateEnum;
}

function singleEnterEmphasis(el) {
  // Only mark the flag.
  // States will be applied in the echarts.ts in next frame.
  doChangeHoverState(el, 'emphasis', HOVER_STATE_EMPHASIS);
}

function singleLeaveEmphasis(el) {
  // Only mark the flag.
  // States will be applied in the echarts.ts in next frame.
  if (el.hoverState === HOVER_STATE_EMPHASIS) {
    doChangeHoverState(el, 'normal', HOVER_STATE_NORMAL);
  }
}

function singleEnterBlur(el) {
  doChangeHoverState(el, 'blur', HOVER_STATE_BLUR);
}

function singleLeaveBlur(el) {
  if (el.hoverState === HOVER_STATE_BLUR) {
    doChangeHoverState(el, 'normal', HOVER_STATE_NORMAL);
  }
}

function singleEnterSelect(el) {
  el.selected = true;
}

function singleLeaveSelect(el) {
  el.selected = false;
}

function updateElementState(el, updater, commonParam) {
  updater(el, commonParam);
}

function traverseUpdateState(el, updater, commonParam) {
  updateElementState(el, updater, commonParam);
  el.isGroup && el.traverse(function (child) {
    updateElementState(child, updater, commonParam);
  });
}

function setStatesFlag(el, stateName) {
  switch (stateName) {
    case 'emphasis':
      el.hoverState = HOVER_STATE_EMPHASIS;
      break;

    case 'normal':
      el.hoverState = HOVER_STATE_NORMAL;
      break;

    case 'blur':
      el.hoverState = HOVER_STATE_BLUR;
      break;

    case 'select':
      el.selected = true;
  }
}
/**
 * If we reuse elements when rerender.
 * DONT forget to clearStates before we update the style and shape.
 * Or we may update on the wrong state instead of normal state.
 */

function clearStates(el) {
  if (el.isGroup) {
    el.traverse(function (child) {
      child.clearStates();
    });
  } else {
    el.clearStates();
  }
}

function getFromStateStyle(el, props, toStateName, defaultValue) {
  var style = el.style;
  var fromState = {};

  for (var i = 0; i < props.length; i++) {
    var propName = props[i];
    var val = style[propName];
    fromState[propName] = val == null ? defaultValue && defaultValue[propName] : val;
  }

  for (var i = 0; i < el.animators.length; i++) {
    var animator = el.animators[i];

    if (animator.__fromStateTransition // Dont consider the animation to emphasis state.
    && animator.__fromStateTransition.indexOf(toStateName) < 0 && animator.targetName === 'style') {
      animator.saveTo(fromState, props);
    }
  }

  return fromState;
}

function createEmphasisDefaultState(el, stateName, targetStates, state) {
  var hasSelect = targetStates && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["indexOf"])(targetStates, 'select') >= 0;
  var cloned = false;

  if (el instanceof __WEBPACK_IMPORTED_MODULE_5_zrender_lib_graphic_Path_js__["a" /* default */]) {
    var store = getSavedStates(el);
    var fromFill = hasSelect ? store.selectFill || store.normalFill : store.normalFill;
    var fromStroke = hasSelect ? store.selectStroke || store.normalStroke : store.normalStroke;

    if (hasFillOrStroke(fromFill) || hasFillOrStroke(fromStroke)) {
      state = state || {};
      var emphasisStyle = state.style || {}; // inherit case

      if (emphasisStyle.fill === 'inherit') {
        cloned = true;
        state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])({}, state);
        emphasisStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])({}, emphasisStyle);
        emphasisStyle.fill = fromFill;
      } // Apply default color lift
      else if (!hasFillOrStroke(emphasisStyle.fill) && hasFillOrStroke(fromFill)) {
          cloned = true; // Not modify the original value.

          state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])({}, state);
          emphasisStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])({}, emphasisStyle); // Already being applied 'emphasis'. DON'T lift color multiple times.

          emphasisStyle.fill = liftColor(fromFill);
        } // Not highlight stroke if fill has been highlighted.
        else if (!hasFillOrStroke(emphasisStyle.stroke) && hasFillOrStroke(fromStroke)) {
            if (!cloned) {
              state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])({}, state);
              emphasisStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])({}, emphasisStyle);
            }

            emphasisStyle.stroke = liftColor(fromStroke);
          }

      state.style = emphasisStyle;
    }
  }

  if (state) {
    // TODO Share with textContent?
    if (state.z2 == null) {
      if (!cloned) {
        state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])({}, state);
      }

      var z2EmphasisLift = el.z2EmphasisLift;
      state.z2 = el.z2 + (z2EmphasisLift != null ? z2EmphasisLift : Z2_EMPHASIS_LIFT);
    }
  }

  return state;
}

function createSelectDefaultState(el, stateName, state) {
  // const hasSelect = indexOf(el.currentStates, stateName) >= 0;
  if (state) {
    // TODO Share with textContent?
    if (state.z2 == null) {
      state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])({}, state);
      var z2SelectLift = el.z2SelectLift;
      state.z2 = el.z2 + (z2SelectLift != null ? z2SelectLift : Z2_SELECT_LIFT);
    }
  }

  return state;
}

function createBlurDefaultState(el, stateName, state) {
  var hasBlur = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["indexOf"])(el.currentStates, stateName) >= 0;
  var currentOpacity = el.style.opacity;
  var fromState = !hasBlur ? getFromStateStyle(el, ['opacity'], stateName, {
    opacity: 1
  }) : null;
  state = state || {};
  var blurStyle = state.style || {};

  if (blurStyle.opacity == null) {
    // clone state
    state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])({}, state);
    blurStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])({
      // Already being applied 'emphasis'. DON'T mul opacity multiple times.
      opacity: hasBlur ? currentOpacity : fromState.opacity * 0.1
    }, blurStyle);
    state.style = blurStyle;
  }

  return state;
}

function elementStateProxy(stateName, targetStates) {
  var state = this.states[stateName];

  if (this.style) {
    if (stateName === 'emphasis') {
      return createEmphasisDefaultState(this, stateName, targetStates, state);
    } else if (stateName === 'blur') {
      return createBlurDefaultState(this, stateName, state);
    } else if (stateName === 'select') {
      return createSelectDefaultState(this, stateName, state);
    }
  }

  return state;
}
/**FI
 * Set hover style (namely "emphasis style") of element.
 * @param el Should not be `zrender/graphic/Group`.
 * @param focus 'self' | 'selfInSeries' | 'series'
 */


function setDefaultStateProxy(el) {
  el.stateProxy = elementStateProxy;
  var textContent = el.getTextContent();
  var textGuide = el.getTextGuideLine();

  if (textContent) {
    textContent.stateProxy = elementStateProxy;
  }

  if (textGuide) {
    textGuide.stateProxy = elementStateProxy;
  }
}
function enterEmphasisWhenMouseOver(el, e) {
  !shouldSilent(el, e) // "emphasis" event highlight has higher priority than mouse highlight.
  && !el.__highByOuter && traverseUpdateState(el, singleEnterEmphasis);
}
function leaveEmphasisWhenMouseOut(el, e) {
  !shouldSilent(el, e) // "emphasis" event highlight has higher priority than mouse highlight.
  && !el.__highByOuter && traverseUpdateState(el, singleLeaveEmphasis);
}
function enterEmphasis(el, highlightDigit) {
  el.__highByOuter |= 1 << (highlightDigit || 0);
  traverseUpdateState(el, singleEnterEmphasis);
}
function leaveEmphasis(el, highlightDigit) {
  !(el.__highByOuter &= ~(1 << (highlightDigit || 0))) && traverseUpdateState(el, singleLeaveEmphasis);
}
function enterBlur(el) {
  traverseUpdateState(el, singleEnterBlur);
}
function leaveBlur(el) {
  traverseUpdateState(el, singleLeaveBlur);
}
function enterSelect(el) {
  traverseUpdateState(el, singleEnterSelect);
}
function leaveSelect(el) {
  traverseUpdateState(el, singleLeaveSelect);
}

function shouldSilent(el, e) {
  return el.__highDownSilentOnTouch && e.zrByTouch;
}

function allLeaveBlur(api) {
  var model = api.getModel();
  var leaveBlurredSeries = [];
  var allComponentViews = [];
  model.eachComponent(function (componentType, componentModel) {
    var componentStates = getComponentStates(componentModel);
    var isSeries = componentType === 'series';
    var view = isSeries ? api.getViewOfSeriesModel(componentModel) : api.getViewOfComponentModel(componentModel);
    !isSeries && allComponentViews.push(view);

    if (componentStates.isBlured) {
      // Leave blur anyway
      view.group.traverse(function (child) {
        singleLeaveBlur(child);
      });
      isSeries && leaveBlurredSeries.push(componentModel);
    }

    componentStates.isBlured = false;
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(allComponentViews, function (view) {
    if (view && view.toggleBlurSeries) {
      view.toggleBlurSeries(leaveBlurredSeries, false, model);
    }
  });
}
function blurSeries(targetSeriesIndex, focus, blurScope, api) {
  var ecModel = api.getModel();
  blurScope = blurScope || 'coordinateSystem';

  function leaveBlurOfIndices(data, dataIndices) {
    for (var i = 0; i < dataIndices.length; i++) {
      var itemEl = data.getItemGraphicEl(dataIndices[i]);
      itemEl && leaveBlur(itemEl);
    }
  }

  if (targetSeriesIndex == null) {
    return;
  }

  if (!focus || focus === 'none') {
    return;
  }

  var targetSeriesModel = ecModel.getSeriesByIndex(targetSeriesIndex);
  var targetCoordSys = targetSeriesModel.coordinateSystem;

  if (targetCoordSys && targetCoordSys.master) {
    targetCoordSys = targetCoordSys.master;
  }

  var blurredSeries = [];
  ecModel.eachSeries(function (seriesModel) {
    var sameSeries = targetSeriesModel === seriesModel;
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys && coordSys.master) {
      coordSys = coordSys.master;
    }

    var sameCoordSys = coordSys && targetCoordSys ? coordSys === targetCoordSys : sameSeries; // If there is no coordinate system. use sameSeries instead.

    if (!( // Not blur other series if blurScope series
    blurScope === 'series' && !sameSeries // Not blur other coordinate system if blurScope is coordinateSystem
    || blurScope === 'coordinateSystem' && !sameCoordSys // Not blur self series if focus is series.
    || focus === 'series' && sameSeries // TODO blurScope: coordinate system
    )) {
      var view = api.getViewOfSeriesModel(seriesModel);
      view.group.traverse(function (child) {
        singleEnterBlur(child);
      });

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArrayLike"])(focus)) {
        leaveBlurOfIndices(seriesModel.getData(), focus);
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isObject"])(focus)) {
        var dataTypes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["keys"])(focus);

        for (var d = 0; d < dataTypes.length; d++) {
          leaveBlurOfIndices(seriesModel.getData(dataTypes[d]), focus[dataTypes[d]]);
        }
      }

      blurredSeries.push(seriesModel);
      getComponentStates(seriesModel).isBlured = true;
    }
  });
  ecModel.eachComponent(function (componentType, componentModel) {
    if (componentType === 'series') {
      return;
    }

    var view = api.getViewOfComponentModel(componentModel);

    if (view && view.toggleBlurSeries) {
      view.toggleBlurSeries(blurredSeries, true, ecModel);
    }
  });
}
function blurComponent(componentMainType, componentIndex, api) {
  if (componentMainType == null || componentIndex == null) {
    return;
  }

  var componentModel = api.getModel().getComponent(componentMainType, componentIndex);

  if (!componentModel) {
    return;
  }

  getComponentStates(componentModel).isBlured = true;
  var view = api.getViewOfComponentModel(componentModel);

  if (!view || !view.focusBlurEnabled) {
    return;
  }

  view.group.traverse(function (child) {
    singleEnterBlur(child);
  });
}
function blurSeriesFromHighlightPayload(seriesModel, payload, api) {
  var seriesIndex = seriesModel.seriesIndex;
  var data = seriesModel.getData(payload.dataType);

  if (!data) {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__log_js__["c" /* error */])("Unknown dataType " + payload.dataType);
    }

    return;
  }

  var dataIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__model_js__["c" /* queryDataIndex */])(data, payload); // Pick the first one if there is multiple/none exists.

  dataIndex = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(dataIndex) ? dataIndex[0] : dataIndex) || 0;
  var el = data.getItemGraphicEl(dataIndex);

  if (!el) {
    var count = data.count();
    var current = 0; // If data on dataIndex is NaN.

    while (!el && current < count) {
      el = data.getItemGraphicEl(current++);
    }
  }

  if (el) {
    var ecData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__innerStore_js__["a" /* getECData */])(el);
    blurSeries(seriesIndex, ecData.focus, ecData.blurScope, api);
  } else {
    // If there is no element put on the data. Try getting it from raw option
    // TODO Should put it on seriesModel?
    var focus_1 = seriesModel.get(['emphasis', 'focus']);
    var blurScope = seriesModel.get(['emphasis', 'blurScope']);

    if (focus_1 != null) {
      blurSeries(seriesIndex, focus_1, blurScope, api);
    }
  }
}
function findComponentHighDownDispatchers(componentMainType, componentIndex, name, api) {
  var ret = {
    focusSelf: false,
    dispatchers: null
  };

  if (componentMainType == null || componentMainType === 'series' || componentIndex == null || name == null) {
    return ret;
  }

  var componentModel = api.getModel().getComponent(componentMainType, componentIndex);

  if (!componentModel) {
    return ret;
  }

  var view = api.getViewOfComponentModel(componentModel);

  if (!view || !view.findHighDownDispatchers) {
    return ret;
  }

  var dispatchers = view.findHighDownDispatchers(name); // At presnet, the component (like Geo) only blur inside itself.
  // So we do not use `blurScope` in component.

  var focusSelf;

  for (var i = 0; i < dispatchers.length; i++) {
    if ("prod" !== 'production' && !isHighDownDispatcher(dispatchers[i])) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__log_js__["c" /* error */])('param should be highDownDispatcher');
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__innerStore_js__["a" /* getECData */])(dispatchers[i]).focus === 'self') {
      focusSelf = true;
      break;
    }
  }

  return {
    focusSelf: focusSelf,
    dispatchers: dispatchers
  };
}
function handleGlobalMouseOverForHighDown(dispatcher, e, api) {
  if ("prod" !== 'production' && !isHighDownDispatcher(dispatcher)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__log_js__["c" /* error */])('param should be highDownDispatcher');
  }

  var ecData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__innerStore_js__["a" /* getECData */])(dispatcher);

  var _a = findComponentHighDownDispatchers(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api),
      dispatchers = _a.dispatchers,
      focusSelf = _a.focusSelf; // If `findHighDownDispatchers` is supported on the component,
  // highlight/downplay elements with the same name.


  if (dispatchers) {
    if (focusSelf) {
      blurComponent(ecData.componentMainType, ecData.componentIndex, api);
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(dispatchers, function (dispatcher) {
      return enterEmphasisWhenMouseOver(dispatcher, e);
    });
  } else {
    // Try blur all in the related series. Then emphasis the hoverred.
    // TODO. progressive mode.
    blurSeries(ecData.seriesIndex, ecData.focus, ecData.blurScope, api);

    if (ecData.focus === 'self') {
      blurComponent(ecData.componentMainType, ecData.componentIndex, api);
    } // Other than series, component that not support `findHighDownDispatcher` will
    // also use it. But in this case, highlight/downplay are only supported in
    // mouse hover but not in dispatchAction.


    enterEmphasisWhenMouseOver(dispatcher, e);
  }
}
function handleGlobalMouseOutForHighDown(dispatcher, e, api) {
  if ("prod" !== 'production' && !isHighDownDispatcher(dispatcher)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__log_js__["c" /* error */])('param should be highDownDispatcher');
  }

  allLeaveBlur(api);
  var ecData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__innerStore_js__["a" /* getECData */])(dispatcher);
  var dispatchers = findComponentHighDownDispatchers(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api).dispatchers;

  if (dispatchers) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(dispatchers, function (dispatcher) {
      return leaveEmphasisWhenMouseOut(dispatcher, e);
    });
  } else {
    leaveEmphasisWhenMouseOut(dispatcher, e);
  }
}
function toggleSelectionFromPayload(seriesModel, payload, api) {
  if (!isSelectChangePayload(payload)) {
    return;
  }

  var dataType = payload.dataType;
  var data = seriesModel.getData(dataType);
  var dataIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__model_js__["c" /* queryDataIndex */])(data, payload);

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(dataIndex)) {
    dataIndex = [dataIndex];
  }

  seriesModel[payload.type === TOGGLE_SELECT_ACTION_TYPE ? 'toggleSelect' : payload.type === SELECT_ACTION_TYPE ? 'select' : 'unselect'](dataIndex, dataType);
}
function updateSeriesElementSelection(seriesModel) {
  var allData = seriesModel.getAllData();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(allData, function (_a) {
    var data = _a.data,
        type = _a.type;
    data.eachItemGraphicEl(function (el, idx) {
      seriesModel.isSelected(idx, type) ? enterSelect(el) : leaveSelect(el);
    });
  });
}
function getAllSelectedIndices(ecModel) {
  var ret = [];
  ecModel.eachSeries(function (seriesModel) {
    var allData = seriesModel.getAllData();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(allData, function (_a) {
      var data = _a.data,
          type = _a.type;
      var dataIndices = seriesModel.getSelectedDataIndices();

      if (dataIndices.length > 0) {
        var item = {
          dataIndex: dataIndices,
          seriesIndex: seriesModel.seriesIndex
        };

        if (type != null) {
          item.dataType = type;
        }

        ret.push(item);
      }
    });
  });
  return ret;
}
/**
 * Enable the function that mouseover will trigger the emphasis state.
 *
 * NOTE:
 * This function should be used on the element with dataIndex, seriesIndex.
 *
 */

function enableHoverEmphasis(el, focus, blurScope) {
  setAsHighDownDispatcher(el, true);
  traverseUpdateState(el, setDefaultStateProxy);
  enableHoverFocus(el, focus, blurScope);
}
function disableHoverEmphasis(el) {
  setAsHighDownDispatcher(el, false);
}
function toggleHoverEmphasis(el, focus, blurScope, isDisabled) {
  isDisabled ? disableHoverEmphasis(el) : enableHoverEmphasis(el, focus, blurScope);
}
function enableHoverFocus(el, focus, blurScope) {
  var ecData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__innerStore_js__["a" /* getECData */])(el);

  if (focus != null) {
    // TODO dataIndex may be set after this function. This check is not useful.
    // if (ecData.dataIndex == null) {
    //     if (__DEV__) {
    //         console.warn('focus can only been set on element with dataIndex');
    //     }
    // }
    // else {
    ecData.focus = focus;
    ecData.blurScope = blurScope; // }
  } else if (ecData.focus) {
    ecData.focus = null;
  }
}
var OTHER_STATES = ['emphasis', 'blur', 'select'];
var defaultStyleGetterMap = {
  itemStyle: 'getItemStyle',
  lineStyle: 'getLineStyle',
  areaStyle: 'getAreaStyle'
};
/**
 * Set emphasis/blur/selected states of element.
 */

function setStatesStylesFromModel(el, itemModel, styleType, // default itemStyle
getter) {
  styleType = styleType || 'itemStyle';

  for (var i = 0; i < OTHER_STATES.length; i++) {
    var stateName = OTHER_STATES[i];
    var model = itemModel.getModel([stateName, styleType]);
    var state = el.ensureState(stateName); // Let it throw error if getterType is not found.

    state.style = getter ? getter(model) : model[defaultStyleGetterMap[styleType]]();
  }
}
/**
 *
 * Set element as highlight / downplay dispatcher.
 * It will be checked when element recieved mouseover event or from highlight action.
 * It's in change of all highlight/downplay behavior of it's children.
 *
 * @param el
 * @param el.highDownSilentOnTouch
 *        In touch device, mouseover event will be trigger on touchstart event
 *        (see module:zrender/dom/HandlerProxy). By this mechanism, we can
 *        conveniently use hoverStyle when tap on touch screen without additional
 *        code for compatibility.
 *        But if the chart/component has select feature, which usually also use
 *        hoverStyle, there might be conflict between 'select-highlight' and
 *        'hover-highlight' especially when roam is enabled (see geo for example).
 *        In this case, `highDownSilentOnTouch` should be used to disable
 *        hover-highlight on touch device.
 * @param asDispatcher If `false`, do not set as "highDownDispatcher".
 */

function setAsHighDownDispatcher(el, asDispatcher) {
  var disable = asDispatcher === false;
  var extendedEl = el; // Make `highDownSilentOnTouch` and `onStateChange` only work after
  // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.

  if (el.highDownSilentOnTouch) {
    extendedEl.__highDownSilentOnTouch = el.highDownSilentOnTouch;
  } // Simple optimize, since this method might be
  // called for each elements of a group in some cases.


  if (!disable || extendedEl.__highDownDispatcher) {
    // Emphasis, normal can be triggered manually by API or other components like hover link.
    // el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent);
    // Also keep previous record.
    extendedEl.__highByOuter = extendedEl.__highByOuter || 0;
    extendedEl.__highDownDispatcher = !disable;
  }
}
function isHighDownDispatcher(el) {
  return !!(el && el.__highDownDispatcher);
}
/**
 * Enable component highlight/downplay features:
 * + hover link (within the same name)
 * + focus blur in component
 */

function enableComponentHighDownFeatures(el, componentModel, componentHighDownName) {
  var ecData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__innerStore_js__["a" /* getECData */])(el);
  ecData.componentMainType = componentModel.mainType;
  ecData.componentIndex = componentModel.componentIndex;
  ecData.componentHighDownName = componentHighDownName;
}
/**
 * Support hightlight/downplay record on each elements.
 * For the case: hover highlight/downplay (legend, visualMap, ...) and
 * user triggerred hightlight/downplay should not conflict.
 * Only all of the highlightDigit cleared, return to normal.
 * @param {string} highlightKey
 * @return {number} highlightDigit
 */

function getHighlightDigit(highlightKey) {
  var highlightDigit = _highlightKeyMap[highlightKey];

  if (highlightDigit == null && _highlightNextDigit <= 32) {
    highlightDigit = _highlightKeyMap[highlightKey] = _highlightNextDigit++;
  }

  return highlightDigit;
}
function isSelectChangePayload(payload) {
  var payloadType = payload.type;
  return payloadType === SELECT_ACTION_TYPE || payloadType === UNSELECT_ACTION_TYPE || payloadType === TOGGLE_SELECT_ACTION_TYPE;
}
function isHighDownPayload(payload) {
  var payloadType = payload.type;
  return payloadType === HIGHLIGHT_ACTION_TYPE || payloadType === DOWNPLAY_ACTION_TYPE;
}
function savePathStates(el) {
  var store = getSavedStates(el);
  store.normalFill = el.style.fill;
  store.normalStroke = el.style.stroke;
  var selectState = el.states.select || {};
  store.selectFill = selectState.style && selectState.style.fill || null;
  store.selectStroke = selectState.style && selectState.style.stroke || null;
}

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = log;
/* harmony export (immutable) */ __webpack_exports__["b"] = warn;
/* harmony export (immutable) */ __webpack_exports__["c"] = error;
/* harmony export (immutable) */ __webpack_exports__["g"] = deprecateLog;
/* harmony export (immutable) */ __webpack_exports__["a"] = deprecateReplaceLog;
/* harmony export (immutable) */ __webpack_exports__["d"] = makePrintable;
/* harmony export (immutable) */ __webpack_exports__["e"] = throwError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var ECHARTS_PREFIX = '[ECharts] ';
var storedLogs = {};
var hasConsole = typeof console !== 'undefined' // eslint-disable-next-line
&& console.warn && console.log;

function outputLog(type, str, onlyOnce) {
  if (hasConsole) {
    if (onlyOnce) {
      if (storedLogs[str]) {
        return;
      }

      storedLogs[str] = true;
    } // eslint-disable-next-line


    console[type](ECHARTS_PREFIX + str);
  }
}

function log(str, onlyOnce) {
  outputLog('log', str, onlyOnce);
}
function warn(str, onlyOnce) {
  outputLog('warn', str, onlyOnce);
}
function error(str, onlyOnce) {
  outputLog('error', str, onlyOnce);
}
function deprecateLog(str) {
  if (true) {
    // Not display duplicate message.
    outputLog('warn', 'DEPRECATED: ' + str, true);
  }
}
function deprecateReplaceLog(oldOpt, newOpt, scope) {
  if (true) {
    deprecateLog((scope ? "[" + scope + "]" : '') + (oldOpt + " is deprecated, use " + newOpt + " instead."));
  }
}
/**
 * If in __DEV__ environment, get console printable message for users hint.
 * Parameters are separated by ' '.
 * @usuage
 * makePrintable('This is an error on', someVar, someObj);
 *
 * @param hintInfo anything about the current execution context to hint users.
 * @throws Error
 */

function makePrintable() {
  var hintInfo = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    hintInfo[_i] = arguments[_i];
  }

  var msg = '';

  if (true) {
    // Fuzzy stringify for print.
    // This code only exist in dev environment.
    var makePrintableStringIfPossible_1 = function (val) {
      return val === void 0 ? 'undefined' : val === Infinity ? 'Infinity' : val === -Infinity ? '-Infinity' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["eqNaN"])(val) ? 'NaN' : val instanceof Date ? 'Date(' + val.toISOString() + ')' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"])(val) ? 'function () { ... }' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isRegExp"])(val) ? val + '' : null;
    };

    msg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])(hintInfo, function (arg) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"])(arg)) {
        // Print without quotation mark for some statement.
        return arg;
      } else {
        var printableStr = makePrintableStringIfPossible_1(arg);

        if (printableStr != null) {
          return printableStr;
        } else if (typeof JSON !== 'undefined' && JSON.stringify) {
          try {
            return JSON.stringify(arg, function (n, val) {
              var printableStr = makePrintableStringIfPossible_1(val);
              return printableStr == null ? val : printableStr;
            }); // In most cases the info object is small, so do not line break.
          } catch (err) {
            return '?';
          }
        } else {
          return '?';
        }
      }
    }).join(' ');
  }

  return msg;
}
/**
 * @throws Error
 */

function throwError(msg) {
  throw new Error(msg);
}

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setLabelText */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setLabelStyle; });
/* harmony export (immutable) */ __webpack_exports__["f"] = getLabelStatesModels;
/* harmony export (immutable) */ __webpack_exports__["d"] = createTextStyle;
/* harmony export (immutable) */ __webpack_exports__["g"] = createTextConfig;
/* harmony export (immutable) */ __webpack_exports__["c"] = getFont;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return labelInner; });
/* harmony export (immutable) */ __webpack_exports__["h"] = setLabelValueAnimation;
/* harmony export (immutable) */ __webpack_exports__["b"] = animateLabelValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_graphic_Text_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_log_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__ = __webpack_require__(4);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






var EMPTY_OBJ = {};
function setLabelText(label, labelTexts) {
  for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_2__util_states_js__["a" /* SPECIAL_STATES */].length; i++) {
    var stateName = __WEBPACK_IMPORTED_MODULE_2__util_states_js__["a" /* SPECIAL_STATES */][i];
    var text = labelTexts[stateName];
    var state = label.ensureState(stateName);
    state.style = state.style || {};
    state.style.text = text;
  }

  var oldStates = label.currentStates.slice();
  label.clearStates(true);
  label.setStyle({
    text: labelTexts.normal
  });
  label.useStates(oldStates, true);
}

function getLabelText(opt, stateModels, interpolatedValue) {
  var labelFetcher = opt.labelFetcher;
  var labelDataIndex = opt.labelDataIndex;
  var labelDimIndex = opt.labelDimIndex;
  var normalModel = stateModels.normal;
  var baseText;

  if (labelFetcher) {
    baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex, normalModel && normalModel.get('formatter'), interpolatedValue != null ? {
      interpolatedValue: interpolatedValue
    } : null);
  }

  if (baseText == null) {
    baseText = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isFunction"])(opt.defaultText) ? opt.defaultText(labelDataIndex, opt, interpolatedValue) : opt.defaultText;
  }

  var statesText = {
    normal: baseText
  };

  for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_2__util_states_js__["a" /* SPECIAL_STATES */].length; i++) {
    var stateName = __WEBPACK_IMPORTED_MODULE_2__util_states_js__["a" /* SPECIAL_STATES */][i];
    var stateModel = stateModels[stateName];
    statesText[stateName] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["retrieve2"])(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, stateName, null, labelDimIndex, stateModel && stateModel.get('formatter')) : null, baseText);
  }

  return statesText;
}

function setLabelStyle(targetEl, labelStatesModels, opt, stateSpecified // TODO specified position?
) {
  opt = opt || EMPTY_OBJ;
  var isSetOnText = targetEl instanceof __WEBPACK_IMPORTED_MODULE_0_zrender_lib_graphic_Text_js__["a" /* default */];
  var needsCreateText = false;

  for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_2__util_states_js__["b" /* DISPLAY_STATES */].length; i++) {
    var stateModel = labelStatesModels[__WEBPACK_IMPORTED_MODULE_2__util_states_js__["b" /* DISPLAY_STATES */][i]];

    if (stateModel && stateModel.getShallow('show')) {
      needsCreateText = true;
      break;
    }
  }

  var textContent = isSetOnText ? targetEl : targetEl.getTextContent();

  if (needsCreateText) {
    if (!isSetOnText) {
      // Reuse the previous
      if (!textContent) {
        textContent = new __WEBPACK_IMPORTED_MODULE_0_zrender_lib_graphic_Text_js__["a" /* default */]();
        targetEl.setTextContent(textContent);
      } // Use same state proxy


      if (targetEl.stateProxy) {
        textContent.stateProxy = targetEl.stateProxy;
      }
    }

    var labelStatesTexts = getLabelText(opt, labelStatesModels);
    var normalModel = labelStatesModels.normal;
    var showNormal = !!normalModel.getShallow('show');
    var normalStyle = createTextStyle(normalModel, stateSpecified && stateSpecified.normal, opt, false, !isSetOnText);
    normalStyle.text = labelStatesTexts.normal;

    if (!isSetOnText) {
      // Always create new
      targetEl.setTextConfig(createTextConfig(normalModel, opt, false));
    }

    for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_2__util_states_js__["a" /* SPECIAL_STATES */].length; i++) {
      var stateName = __WEBPACK_IMPORTED_MODULE_2__util_states_js__["a" /* SPECIAL_STATES */][i];
      var stateModel = labelStatesModels[stateName];

      if (stateModel) {
        var stateObj = textContent.ensureState(stateName);
        var stateShow = !!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["retrieve2"])(stateModel.getShallow('show'), showNormal);

        if (stateShow !== showNormal) {
          stateObj.ignore = !stateShow;
        }

        stateObj.style = createTextStyle(stateModel, stateSpecified && stateSpecified[stateName], opt, true, !isSetOnText);
        stateObj.style.text = labelStatesTexts[stateName];

        if (!isSetOnText) {
          var targetElEmphasisState = targetEl.ensureState(stateName);
          targetElEmphasisState.textConfig = createTextConfig(stateModel, opt, true);
        }
      }
    } // PENDING: if there is many requirements that emphasis position
    // need to be different from normal position, we might consider
    // auto slient is those cases.


    textContent.silent = !!normalModel.getShallow('silent'); // Keep x and y

    if (textContent.style.x != null) {
      normalStyle.x = textContent.style.x;
    }

    if (textContent.style.y != null) {
      normalStyle.y = textContent.style.y;
    }

    textContent.ignore = !showNormal; // Always create new style.

    textContent.useStyle(normalStyle);
    textContent.dirty();

    if (opt.enableTextSetter) {
      labelInner(textContent).setLabelText = function (interpolatedValue) {
        var labelStatesTexts = getLabelText(opt, labelStatesModels, interpolatedValue);
        setLabelText(textContent, labelStatesTexts);
      };
    }
  } else if (textContent) {
    // Not display rich text.
    textContent.ignore = true;
  }

  targetEl.dirty();
}


function getLabelStatesModels(itemModel, labelName) {
  labelName = labelName || 'label';
  var statesModels = {
    normal: itemModel.getModel(labelName)
  };

  for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_2__util_states_js__["a" /* SPECIAL_STATES */].length; i++) {
    var stateName = __WEBPACK_IMPORTED_MODULE_2__util_states_js__["a" /* SPECIAL_STATES */][i];
    statesModels[stateName] = itemModel.getModel([stateName, labelName]);
  }

  return statesModels;
}
/**
 * Set basic textStyle properties.
 */

function createTextStyle(textStyleModel, specifiedTextStyle, // Fixed style in the code. Can't be set by model.
opt, isNotNormal, isAttached // If text is attached on an element. If so, auto color will handling in zrender.
) {
  var textStyle = {};
  setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached);
  specifiedTextStyle && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])(textStyle, specifiedTextStyle); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);

  return textStyle;
}
function createTextConfig(textStyleModel, opt, isNotNormal) {
  opt = opt || {};
  var textConfig = {};
  var labelPosition;
  var labelRotate = textStyleModel.getShallow('rotate');
  var labelDistance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["retrieve2"])(textStyleModel.getShallow('distance'), isNotNormal ? null : 5);
  var labelOffset = textStyleModel.getShallow('offset');
  labelPosition = textStyleModel.getShallow('position') || (isNotNormal ? null : 'inside'); // 'outside' is not a valid zr textPostion value, but used
  // in bar series, and magric type should be considered.

  labelPosition === 'outside' && (labelPosition = opt.defaultOutsidePosition || 'top');

  if (labelPosition != null) {
    textConfig.position = labelPosition;
  }

  if (labelOffset != null) {
    textConfig.offset = labelOffset;
  }

  if (labelRotate != null) {
    labelRotate *= Math.PI / 180;
    textConfig.rotation = labelRotate;
  }

  if (labelDistance != null) {
    textConfig.distance = labelDistance;
  } // fill and auto is determined by the color of path fill if it's not specified by developers.


  textConfig.outsideFill = textStyleModel.get('color') === 'inherit' ? opt.inheritColor || null : 'auto';
  return textConfig;
}
/**
 * The uniform entry of set text style, that is, retrieve style definitions
 * from `model` and set to `textStyle` object.
 *
 * Never in merge mode, but in overwrite mode, that is, all of the text style
 * properties will be set. (Consider the states of normal and emphasis and
 * default value can be adopted, merge would make the logic too complicated
 * to manage.)
 */

function setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached) {
  // Consider there will be abnormal when merge hover style to normal style if given default value.
  opt = opt || EMPTY_OBJ;
  var ecModel = textStyleModel.ecModel;
  var globalTextStyle = ecModel && ecModel.option.textStyle; // Consider case:
  // {
  //     data: [{
  //         value: 12,
  //         label: {
  //             rich: {
  //                 // no 'a' here but using parent 'a'.
  //             }
  //         }
  //     }],
  //     rich: {
  //         a: { ... }
  //     }
  // }

  var richItemNames = getRichItemNames(textStyleModel);
  var richResult;

  if (richItemNames) {
    richResult = {};

    for (var name_1 in richItemNames) {
      if (richItemNames.hasOwnProperty(name_1)) {
        // Cascade is supported in rich.
        var richTextStyle = textStyleModel.getModel(['rich', name_1]); // In rich, never `disableBox`.
        // FIXME: consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
        // the default color `'blue'` will not be adopted if no color declared in `rich`.
        // That might confuses users. So probably we should put `textStyleModel` as the
        // root ancestor of the `richTextStyle`. But that would be a break change.

        setTokenTextStyle(richResult[name_1] = {}, richTextStyle, globalTextStyle, opt, isNotNormal, isAttached, false, true);
      }
    }
  }

  if (richResult) {
    textStyle.rich = richResult;
  }

  var overflow = textStyleModel.get('overflow');

  if (overflow) {
    textStyle.overflow = overflow;
  }

  var margin = textStyleModel.get('minMargin');

  if (margin != null) {
    textStyle.margin = margin;
  }

  setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, true, false);
} // Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             rich: {
//                 // no 'a' here but using parent 'a'.
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }
// TODO TextStyleModel


function getRichItemNames(textStyleModel) {
  // Use object to remove duplicated names.
  var richItemNameMap;

  while (textStyleModel && textStyleModel !== textStyleModel.ecModel) {
    var rich = (textStyleModel.option || EMPTY_OBJ).rich;

    if (rich) {
      richItemNameMap = richItemNameMap || {};
      var richKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["keys"])(rich);

      for (var i = 0; i < richKeys.length; i++) {
        var richKey = richKeys[i];
        richItemNameMap[richKey] = 1;
      }
    }

    textStyleModel = textStyleModel.parentModel;
  }

  return richItemNameMap;
}

var TEXT_PROPS_WITH_GLOBAL = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily', 'textShadowColor', 'textShadowBlur', 'textShadowOffsetX', 'textShadowOffsetY'];
var TEXT_PROPS_SELF = ['align', 'lineHeight', 'width', 'height', 'tag', 'verticalAlign'];
var TEXT_PROPS_BOX = ['padding', 'borderWidth', 'borderRadius', 'borderDashOffset', 'backgroundColor', 'borderColor', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY'];

function setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, isBlock, inRich) {
  // In merge mode, default value should not be given.
  globalTextStyle = !isNotNormal && globalTextStyle || EMPTY_OBJ;
  var inheritColor = opt && opt.inheritColor;
  var fillColor = textStyleModel.getShallow('color');
  var strokeColor = textStyleModel.getShallow('textBorderColor');
  var opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["retrieve2"])(textStyleModel.getShallow('opacity'), globalTextStyle.opacity);

  if (fillColor === 'inherit' || fillColor === 'auto') {
    if (true) {
      if (fillColor === 'auto') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_log_js__["a" /* deprecateReplaceLog */])('color: \'auto\'', 'color: \'inherit\'');
      }
    }

    if (inheritColor) {
      fillColor = inheritColor;
    } else {
      fillColor = null;
    }
  }

  if (strokeColor === 'inherit' || strokeColor === 'auto') {
    if (true) {
      if (strokeColor === 'auto') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_log_js__["a" /* deprecateReplaceLog */])('color: \'auto\'', 'color: \'inherit\'');
      }
    }

    if (inheritColor) {
      strokeColor = inheritColor;
    } else {
      strokeColor = null;
    }
  }

  if (!isAttached) {
    // Only use default global textStyle.color if text is individual.
    // Otherwise it will use the strategy of attached text color because text may be on a path.
    fillColor = fillColor || globalTextStyle.color;
    strokeColor = strokeColor || globalTextStyle.textBorderColor;
  }

  if (fillColor != null) {
    textStyle.fill = fillColor;
  }

  if (strokeColor != null) {
    textStyle.stroke = strokeColor;
  }

  var textBorderWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["retrieve2"])(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);

  if (textBorderWidth != null) {
    textStyle.lineWidth = textBorderWidth;
  }

  var textBorderType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["retrieve2"])(textStyleModel.getShallow('textBorderType'), globalTextStyle.textBorderType);

  if (textBorderType != null) {
    textStyle.lineDash = textBorderType;
  }

  var textBorderDashOffset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["retrieve2"])(textStyleModel.getShallow('textBorderDashOffset'), globalTextStyle.textBorderDashOffset);

  if (textBorderDashOffset != null) {
    textStyle.lineDashOffset = textBorderDashOffset;
  }

  if (!isNotNormal && opacity == null && !inRich) {
    opacity = opt && opt.defaultOpacity;
  }

  if (opacity != null) {
    textStyle.opacity = opacity;
  } // TODO


  if (!isNotNormal && !isAttached) {
    // Set default finally.
    if (textStyle.fill == null && opt.inheritColor) {
      textStyle.fill = opt.inheritColor;
    }
  } // Do not use `getFont` here, because merge should be supported, where
  // part of these properties may be changed in emphasis style, and the
  // others should remain their original value got from normal style.


  for (var i = 0; i < TEXT_PROPS_WITH_GLOBAL.length; i++) {
    var key = TEXT_PROPS_WITH_GLOBAL[i];
    var val = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["retrieve2"])(textStyleModel.getShallow(key), globalTextStyle[key]);

    if (val != null) {
      textStyle[key] = val;
    }
  }

  for (var i = 0; i < TEXT_PROPS_SELF.length; i++) {
    var key = TEXT_PROPS_SELF[i];
    var val = textStyleModel.getShallow(key);

    if (val != null) {
      textStyle[key] = val;
    }
  }

  if (textStyle.verticalAlign == null) {
    var baseline = textStyleModel.getShallow('baseline');

    if (baseline != null) {
      textStyle.verticalAlign = baseline;
    }
  }

  if (!isBlock || !opt.disableBox) {
    for (var i = 0; i < TEXT_PROPS_BOX.length; i++) {
      var key = TEXT_PROPS_BOX[i];
      var val = textStyleModel.getShallow(key);

      if (val != null) {
        textStyle[key] = val;
      }
    }

    var borderType = textStyleModel.getShallow('borderType');

    if (borderType != null) {
      textStyle.borderDash = borderType;
    }

    if ((textStyle.backgroundColor === 'auto' || textStyle.backgroundColor === 'inherit') && inheritColor) {
      if (true) {
        if (textStyle.backgroundColor === 'auto') {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_log_js__["a" /* deprecateReplaceLog */])('backgroundColor: \'auto\'', 'backgroundColor: \'inherit\'');
        }
      }

      textStyle.backgroundColor = inheritColor;
    }

    if ((textStyle.borderColor === 'auto' || textStyle.borderColor === 'inherit') && inheritColor) {
      if (true) {
        if (textStyle.borderColor === 'auto') {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_log_js__["a" /* deprecateReplaceLog */])('borderColor: \'auto\'', 'borderColor: \'inherit\'');
        }
      }

      textStyle.borderColor = inheritColor;
    }
  }
}

function getFont(opt, ecModel) {
  var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["trim"])([// FIXME in node-canvas fontWeight is before fontStyle
  opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '', opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '', (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px', opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'].join(' '));
}
var labelInner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_model_js__["a" /* makeInner */])();
function setLabelValueAnimation(label, labelStatesModels, value, getDefaultText) {
  if (!label) {
    return;
  }

  var obj = labelInner(label);
  obj.prevValue = obj.value;
  obj.value = value;
  var normalLabelModel = labelStatesModels.normal;
  obj.valueAnimation = normalLabelModel.get('valueAnimation');

  if (obj.valueAnimation) {
    obj.precision = normalLabelModel.get('precision');
    obj.defaultInterpolatedText = getDefaultText;
    obj.statesModels = labelStatesModels;
  }
}
function animateLabelValue(textEl, dataIndex, data, animatableModel, labelFetcher) {
  var labelInnerStore = labelInner(textEl);

  if (!labelInnerStore.valueAnimation || labelInnerStore.prevValue === labelInnerStore.value) {
    // Value not changed, no new label animation
    return;
  }

  var defaultInterpolatedText = labelInnerStore.defaultInterpolatedText; // Consider the case that being animating, do not use the `obj.value`,
  // Otherwise it will jump to the `obj.value` when this new animation started.

  var currValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["retrieve2"])(labelInnerStore.interpolatedValue, labelInnerStore.prevValue);
  var targetValue = labelInnerStore.value;

  function during(percent) {
    var interpolated = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_model_js__["b" /* interpolateRawValues */])(data, labelInnerStore.precision, currValue, targetValue, percent);
    labelInnerStore.interpolatedValue = percent === 1 ? null : interpolated;
    var labelText = getLabelText({
      labelDataIndex: dataIndex,
      labelFetcher: labelFetcher,
      defaultText: defaultInterpolatedText ? defaultInterpolatedText(interpolated) : interpolated + ''
    }, labelInnerStore.statesModels, interpolated);
    setLabelText(textEl, labelText);
  }

  textEl.percent = 0;
  (labelInnerStore.prevValue == null ? __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["initProps"] : __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["updateProps"])(textEl, {
    // percent is used to prevent animation from being aborted #15916
    percent: 1
  }, animatableModel, dataIndex, null, during);
}

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getECData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setCommonECData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var getECData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__model_js__["a" /* makeInner */])();
var setCommonECData = function (seriesIndex, dataType, dataIdx, el) {
  if (el) {
    var ecData = getECData(el); // Add data index and series index for indexing the data by element
    // Useful in tooltip

    ecData.dataIndex = dataIdx;
    ecData.dataType = dataType;
    ecData.seriesIndex = seriesIndex; // TODO: not store dataIndex on children.

    if (el.type === 'group') {
      el.traverse(function (child) {
        var childECData = getECData(child);
        childECData.seriesIndex = seriesIndex;
        childECData.dataIndex = dataIdx;
        childECData.dataType = dataType;
      });
    }
  }
};

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOCATION_PARAMS; });
/* unused harmony export HV_NAMES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return box; });
/* unused harmony export vbox */
/* unused harmony export hbox */
/* harmony export (immutable) */ __webpack_exports__["j"] = getAvailableSize;
/* harmony export (immutable) */ __webpack_exports__["f"] = getLayoutRect;
/* harmony export (immutable) */ __webpack_exports__["e"] = positionElement;
/* harmony export (immutable) */ __webpack_exports__["i"] = sizeCalculable;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchLayoutMode;
/* harmony export (immutable) */ __webpack_exports__["c"] = mergeLayoutParam;
/* harmony export (immutable) */ __webpack_exports__["b"] = getLayoutParams;
/* harmony export (immutable) */ __webpack_exports__["h"] = copyLayoutParams;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__format_js__ = __webpack_require__(42);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Layout helpers for each component positioning




var each = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"];
/**
 * @public
 */

var LOCATION_PARAMS = ['left', 'right', 'top', 'bottom', 'width', 'height'];
/**
 * @public
 */

var HV_NAMES = [['width', 'left', 'right'], ['height', 'top', 'bottom']];

function boxLayout(orient, group, gap, maxWidth, maxHeight) {
  var x = 0;
  var y = 0;

  if (maxWidth == null) {
    maxWidth = Infinity;
  }

  if (maxHeight == null) {
    maxHeight = Infinity;
  }

  var currentLineMaxSize = 0;
  group.eachChild(function (child, idx) {
    var rect = child.getBoundingRect();
    var nextChild = group.childAt(idx + 1);
    var nextChildRect = nextChild && nextChild.getBoundingRect();
    var nextX;
    var nextY;

    if (orient === 'horizontal') {
      var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
      nextX = x + moveX; // Wrap when width exceeds maxWidth or meet a `newline` group
      // FIXME compare before adding gap?

      if (nextX > maxWidth || child.newline) {
        x = 0;
        nextX = moveX;
        y += currentLineMaxSize + gap;
        currentLineMaxSize = rect.height;
      } else {
        // FIXME: consider rect.y is not `0`?
        currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
      }
    } else {
      var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
      nextY = y + moveY; // Wrap when width exceeds maxHeight or meet a `newline` group

      if (nextY > maxHeight || child.newline) {
        x += currentLineMaxSize + gap;
        y = 0;
        nextY = moveY;
        currentLineMaxSize = rect.width;
      } else {
        currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
      }
    }

    if (child.newline) {
      return;
    }

    child.x = x;
    child.y = y;
    child.markRedraw();
    orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
  });
}
/**
 * VBox or HBox layouting
 * @param {string} orient
 * @param {module:zrender/graphic/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */


var box = boxLayout;
/**
 * VBox layouting
 * @param {module:zrender/graphic/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */

var vbox = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["curry"](boxLayout, 'vertical');
/**
 * HBox layouting
 * @param {module:zrender/graphic/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */

var hbox = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["curry"](boxLayout, 'horizontal');
/**
 * If x or x2 is not specified or 'center' 'left' 'right',
 * the width would be as long as possible.
 * If y or y2 is not specified or 'middle' 'top' 'bottom',
 * the height would be as long as possible.
 */

function getAvailableSize(positionInfo, containerRect, margin) {
  var containerWidth = containerRect.width;
  var containerHeight = containerRect.height;
  var x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__number_js__["a" /* parsePercent */])(positionInfo.left, containerWidth);
  var y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__number_js__["a" /* parsePercent */])(positionInfo.top, containerHeight);
  var x2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__number_js__["a" /* parsePercent */])(positionInfo.right, containerWidth);
  var y2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__number_js__["a" /* parsePercent */])(positionInfo.bottom, containerHeight);
  (isNaN(x) || isNaN(parseFloat(positionInfo.left))) && (x = 0);
  (isNaN(x2) || isNaN(parseFloat(positionInfo.right))) && (x2 = containerWidth);
  (isNaN(y) || isNaN(parseFloat(positionInfo.top))) && (y = 0);
  (isNaN(y2) || isNaN(parseFloat(positionInfo.bottom))) && (y2 = containerHeight);
  margin = __WEBPACK_IMPORTED_MODULE_3__format_js__["f" /* normalizeCssArray */](margin || 0);
  return {
    width: Math.max(x2 - x - margin[1] - margin[3], 0),
    height: Math.max(y2 - y - margin[0] - margin[2], 0)
  };
}
/**
 * Parse position info.
 */

function getLayoutRect(positionInfo, containerRect, margin) {
  margin = __WEBPACK_IMPORTED_MODULE_3__format_js__["f" /* normalizeCssArray */](margin || 0);
  var containerWidth = containerRect.width;
  var containerHeight = containerRect.height;
  var left = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__number_js__["a" /* parsePercent */])(positionInfo.left, containerWidth);
  var top = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__number_js__["a" /* parsePercent */])(positionInfo.top, containerHeight);
  var right = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__number_js__["a" /* parsePercent */])(positionInfo.right, containerWidth);
  var bottom = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__number_js__["a" /* parsePercent */])(positionInfo.bottom, containerHeight);
  var width = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__number_js__["a" /* parsePercent */])(positionInfo.width, containerWidth);
  var height = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__number_js__["a" /* parsePercent */])(positionInfo.height, containerHeight);
  var verticalMargin = margin[2] + margin[0];
  var horizontalMargin = margin[1] + margin[3];
  var aspect = positionInfo.aspect; // If width is not specified, calculate width from left and right

  if (isNaN(width)) {
    width = containerWidth - right - horizontalMargin - left;
  }

  if (isNaN(height)) {
    height = containerHeight - bottom - verticalMargin - top;
  }

  if (aspect != null) {
    // If width and height are not given
    // 1. Graph should not exceeds the container
    // 2. Aspect must be keeped
    // 3. Graph should take the space as more as possible
    // FIXME
    // Margin is not considered, because there is no case that both
    // using margin and aspect so far.
    if (isNaN(width) && isNaN(height)) {
      if (aspect > containerWidth / containerHeight) {
        width = containerWidth * 0.8;
      } else {
        height = containerHeight * 0.8;
      }
    } // Calculate width or height with given aspect


    if (isNaN(width)) {
      width = aspect * height;
    }

    if (isNaN(height)) {
      height = width / aspect;
    }
  } // If left is not specified, calculate left from right and width


  if (isNaN(left)) {
    left = containerWidth - right - width - horizontalMargin;
  }

  if (isNaN(top)) {
    top = containerHeight - bottom - height - verticalMargin;
  } // Align left and top


  switch (positionInfo.left || positionInfo.right) {
    case 'center':
      left = containerWidth / 2 - width / 2 - margin[3];
      break;

    case 'right':
      left = containerWidth - width - horizontalMargin;
      break;
  }

  switch (positionInfo.top || positionInfo.bottom) {
    case 'middle':
    case 'center':
      top = containerHeight / 2 - height / 2 - margin[0];
      break;

    case 'bottom':
      top = containerHeight - height - verticalMargin;
      break;
  } // If something is wrong and left, top, width, height are calculated as NaN


  left = left || 0;
  top = top || 0;

  if (isNaN(width)) {
    // Width may be NaN if only one value is given except width
    width = containerWidth - horizontalMargin - left - (right || 0);
  }

  if (isNaN(height)) {
    // Height may be NaN if only one value is given except height
    height = containerHeight - verticalMargin - top - (bottom || 0);
  }

  var rect = new __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_BoundingRect_js__["a" /* default */](left + margin[3], top + margin[0], width, height);
  rect.margin = margin;
  return rect;
}
/**
 * Position a zr element in viewport
 *  Group position is specified by either
 *  {left, top}, {right, bottom}
 *  If all properties exists, right and bottom will be igonred.
 *
 * Logic:
 *     1. Scale (against origin point in parent coord)
 *     2. Rotate (against origin point in parent coord)
 *     3. Traslate (with el.position by this method)
 * So this method only fixes the last step 'Traslate', which does not affect
 * scaling and rotating.
 *
 * If be called repeatly with the same input el, the same result will be gotten.
 *
 * Return true if the layout happend.
 *
 * @param el Should have `getBoundingRect` method.
 * @param positionInfo
 * @param positionInfo.left
 * @param positionInfo.top
 * @param positionInfo.right
 * @param positionInfo.bottom
 * @param positionInfo.width Only for opt.boundingModel: 'raw'
 * @param positionInfo.height Only for opt.boundingModel: 'raw'
 * @param containerRect
 * @param margin
 * @param opt
 * @param opt.hv Only horizontal or only vertical. Default to be [1, 1]
 * @param opt.boundingMode
 *        Specify how to calculate boundingRect when locating.
 *        'all': Position the boundingRect that is transformed and uioned
 *               both itself and its descendants.
 *               This mode simplies confine the elements in the bounding
 *               of their container (e.g., using 'right: 0').
 *        'raw': Position the boundingRect that is not transformed and only itself.
 *               This mode is useful when you want a element can overflow its
 *               container. (Consider a rotated circle needs to be located in a corner.)
 *               In this mode positionInfo.width/height can only be number.
 */

function positionElement(el, positionInfo, containerRect, margin, opt, out) {
  var h = !opt || !opt.hv || opt.hv[0];
  var v = !opt || !opt.hv || opt.hv[1];
  var boundingMode = opt && opt.boundingMode || 'all';
  out = out || el;
  out.x = el.x;
  out.y = el.y;

  if (!h && !v) {
    return false;
  }

  var rect;

  if (boundingMode === 'raw') {
    rect = el.type === 'group' ? new __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_BoundingRect_js__["a" /* default */](0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
  } else {
    rect = el.getBoundingRect();

    if (el.needLocalTransform()) {
      var transform = el.getLocalTransform(); // Notice: raw rect may be inner object of el,
      // which should not be modified.

      rect = rect.clone();
      rect.applyTransform(transform);
    }
  } // The real width and height can not be specified but calculated by the given el.


  var layoutRect = getLayoutRect(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["defaults"]({
    width: rect.width,
    height: rect.height
  }, positionInfo), containerRect, margin); // Because 'tranlate' is the last step in transform
  // (see zrender/core/Transformable#getLocalTransform),
  // we can just only modify el.position to get final result.

  var dx = h ? layoutRect.x - rect.x : 0;
  var dy = v ? layoutRect.y - rect.y : 0;

  if (boundingMode === 'raw') {
    out.x = dx;
    out.y = dy;
  } else {
    out.x += dx;
    out.y += dy;
  }

  if (out === el) {
    el.markRedraw();
  }

  return true;
}
/**
 * @param option Contains some of the properties in HV_NAMES.
 * @param hvIdx 0: horizontal; 1: vertical.
 */

function sizeCalculable(option, hvIdx) {
  return option[HV_NAMES[hvIdx][0]] != null || option[HV_NAMES[hvIdx][1]] != null && option[HV_NAMES[hvIdx][2]] != null;
}
function fetchLayoutMode(ins) {
  var layoutMode = ins.layoutMode || ins.constructor.layoutMode;
  return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"](layoutMode) ? layoutMode : layoutMode ? {
    type: layoutMode
  } : null;
}
/**
 * Consider Case:
 * When default option has {left: 0, width: 100}, and we set {right: 0}
 * through setOption or media query, using normal zrUtil.merge will cause
 * {right: 0} does not take effect.
 *
 * @example
 * ComponentModel.extend({
 *     init: function () {
 *         ...
 *         let inputPositionParams = layout.getLayoutParams(option);
 *         this.mergeOption(inputPositionParams);
 *     },
 *     mergeOption: function (newOption) {
 *         newOption && zrUtil.merge(thisOption, newOption, true);
 *         layout.mergeLayoutParam(thisOption, newOption);
 *     }
 * });
 *
 * @param targetOption
 * @param newOption
 * @param opt
 */

function mergeLayoutParam(targetOption, newOption, opt) {
  var ignoreSize = opt && opt.ignoreSize;
  !__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](ignoreSize) && (ignoreSize = [ignoreSize, ignoreSize]);
  var hResult = merge(HV_NAMES[0], 0);
  var vResult = merge(HV_NAMES[1], 1);
  copy(HV_NAMES[0], targetOption, hResult);
  copy(HV_NAMES[1], targetOption, vResult);

  function merge(names, hvIdx) {
    var newParams = {};
    var newValueCount = 0;
    var merged = {};
    var mergedValueCount = 0;
    var enoughParamNumber = 2;
    each(names, function (name) {
      merged[name] = targetOption[name];
    });
    each(names, function (name) {
      // Consider case: newOption.width is null, which is
      // set by user for removing width setting.
      hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
      hasValue(newParams, name) && newValueCount++;
      hasValue(merged, name) && mergedValueCount++;
    });

    if (ignoreSize[hvIdx]) {
      // Only one of left/right is premitted to exist.
      if (hasValue(newOption, names[1])) {
        merged[names[2]] = null;
      } else if (hasValue(newOption, names[2])) {
        merged[names[1]] = null;
      }

      return merged;
    } // Case: newOption: {width: ..., right: ...},
    // or targetOption: {right: ...} and newOption: {width: ...},
    // There is no conflict when merged only has params count
    // little than enoughParamNumber.


    if (mergedValueCount === enoughParamNumber || !newValueCount) {
      return merged;
    } // Case: newOption: {width: ..., right: ...},
    // Than we can make sure user only want those two, and ignore
    // all origin params in targetOption.
    else if (newValueCount >= enoughParamNumber) {
        return newParams;
      } else {
        // Chose another param from targetOption by priority.
        for (var i = 0; i < names.length; i++) {
          var name_1 = names[i];

          if (!hasProp(newParams, name_1) && hasProp(targetOption, name_1)) {
            newParams[name_1] = targetOption[name_1];
            break;
          }
        }

        return newParams;
      }
  }

  function hasProp(obj, name) {
    return obj.hasOwnProperty(name);
  }

  function hasValue(obj, name) {
    return obj[name] != null && obj[name] !== 'auto';
  }

  function copy(names, target, source) {
    each(names, function (name) {
      target[name] = source[name];
    });
  }
}
/**
 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
 */

function getLayoutParams(source) {
  return copyLayoutParams({}, source);
}
/**
 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
 * @param {Object} source
 * @return {Object} Result contains those props.
 */

function copyLayoutParams(target, source) {
  source && target && each(LOCATION_PARAMS, function (name) {
    source.hasOwnProperty(name) && (target[name] = source[name]);
  });
  return target;
}

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_loading__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_axios__ = __webpack_require__(60);







// const baseURLCommon = baseURL;

// console.log('baseURL', baseURLCommon);

/* harmony default export */ __webpack_exports__["a"] = ({
    axiosCall: function axiosCall(method, url) {
        var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            config.method = method;
            config.url = url;

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_axios__["a" /* default */])(config).then(function (res) {
                if (res.success) {
                    if (res.result === 0 || res.result === false) {
                        resolve(res.result);
                    } else {
                        resolve(res.result || {}); //result有可能为null
                    }
                } else if (res.status == '200' && !res.result && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(res.data) == 'object') {
                    resolve(res);
                } else {
                    if (res) {
                        __WEBPACK_IMPORTED_MODULE_2_vue___default.a.prototype.$message.error(res.message || '');
                    }
                    reject(res.message || '');
                }
            }, function (err) {
                __WEBPACK_IMPORTED_MODULE_2_vue___default.a.prototype.$message.error('系统错误，请稍后重试');
                reject(err);
            });
        });
    },
    handleUploading: function handleUploading() {
        __WEBPACK_IMPORTED_MODULE_3__util_loading__["a" /* default */].add({});
    },
    handleUploadResult: function handleUploadResult(res) {
        if (res.success) {
            __WEBPACK_IMPORTED_MODULE_2_vue___default.a.prototype.$message.success(res.message);
        } else {
            __WEBPACK_IMPORTED_MODULE_2_vue___default.a.prototype.$message.error(res);
        }

        __WEBPACK_IMPORTED_MODULE_3__util_loading__["a" /* default */].removAll();
    },
    getBaseURL: function getBaseURL() {
        return __WEBPACK_IMPORTED_MODULE_4__util_axios__["b" /* baseURL */];
    },
    get: function get(url, params) {
        var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        config.params = params;
        return this.axiosCall('get', url, config);
    },
    post: function post(url, data) {
        var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        config.data = data;
        return this.axiosCall('post', url, config);
    },
    postForm: function postForm(url, data) {
        var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        var forms = new FormData();
        if (data) {
            for (var key in data) {
                if (Object.hasOwnProperty.call(data, key)) {
                    var element = data[key];
                    forms.append(key, element);
                }
            }
        }

        config.data = forms;
        return this.axiosCall('post', url, config);
    },
    put: function put(url, data) {
        var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        config.data = data;
        return this.axiosCall('put', url, config);
    },
    putForm: function putForm(url, data) {
        var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        var forms = new FormData();
        if (data) {
            for (var key in data) {
                if (Object.hasOwnProperty.call(data, key)) {
                    var element = data[key];
                    forms.append(key, element);
                }
            }
        }

        config.data = forms;
        return this.axiosCall('put', url, config);
    },
    delete: function _delete(url, params) {
        var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        config.params = params;
        return this.axiosCall('delete', url, config);
    }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Model_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_component_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_clazz_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_layout_js__ = __webpack_require__(19);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







var inner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_model_js__["a" /* makeInner */])();

var ComponentModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ComponentModel, _super);

  function ComponentModel(option, parentModel, ecModel) {
    var _this = _super.call(this, option, parentModel, ecModel) || this;

    _this.uid = __WEBPACK_IMPORTED_MODULE_3__util_component_js__["a" /* getUID */]('ec_cpt_model');
    return _this;
  }

  ComponentModel.prototype.init = function (option, parentModel, ecModel) {
    this.mergeDefaultAndTheme(option, ecModel);
  };

  ComponentModel.prototype.mergeDefaultAndTheme = function (option, ecModel) {
    var layoutMode = __WEBPACK_IMPORTED_MODULE_6__util_layout_js__["a" /* fetchLayoutMode */](this);
    var inputPositionParams = layoutMode ? __WEBPACK_IMPORTED_MODULE_6__util_layout_js__["b" /* getLayoutParams */](option) : {};
    var themeModel = ecModel.getTheme();
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"](option, themeModel.get(this.mainType));
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"](option, this.getDefaultOption());

    if (layoutMode) {
      __WEBPACK_IMPORTED_MODULE_6__util_layout_js__["c" /* mergeLayoutParam */](option, inputPositionParams, layoutMode);
    }
  };

  ComponentModel.prototype.mergeOption = function (option, ecModel) {
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"](this.option, option, true);
    var layoutMode = __WEBPACK_IMPORTED_MODULE_6__util_layout_js__["a" /* fetchLayoutMode */](this);

    if (layoutMode) {
      __WEBPACK_IMPORTED_MODULE_6__util_layout_js__["c" /* mergeLayoutParam */](this.option, option, layoutMode);
    }
  };
  /**
   * Called immediately after `init` or `mergeOption` of this instance called.
   */


  ComponentModel.prototype.optionUpdated = function (newCptOption, isInit) {};
  /**
   * [How to declare defaultOption]:
   *
   * (A) If using class declaration in typescript (since echarts 5):
   * ```ts
   * import {ComponentOption} from '../model/option.js';
   * export interface XxxOption extends ComponentOption {
   *     aaa: number
   * }
   * export class XxxModel extends Component {
   *     static type = 'xxx';
   *     static defaultOption: XxxOption = {
   *         aaa: 123
   *     }
   * }
   * Component.registerClass(XxxModel);
   * ```
   * ```ts
   * import {inheritDefaultOption} from '../util/component.js';
   * import {XxxModel, XxxOption} from './XxxModel.js';
   * export interface XxxSubOption extends XxxOption {
   *     bbb: number
   * }
   * class XxxSubModel extends XxxModel {
   *     static defaultOption: XxxSubOption = inheritDefaultOption(XxxModel.defaultOption, {
   *         bbb: 456
   *     })
   *     fn() {
   *         let opt = this.getDefaultOption();
   *         // opt is {aaa: 123, bbb: 456}
   *     }
   * }
   * ```
   *
   * (B) If using class extend (previous approach in echarts 3 & 4):
   * ```js
   * let XxxComponent = Component.extend({
   *     defaultOption: {
   *         xx: 123
   *     }
   * })
   * ```
   * ```js
   * let XxxSubComponent = XxxComponent.extend({
   *     defaultOption: {
   *         yy: 456
   *     },
   *     fn: function () {
   *         let opt = this.getDefaultOption();
   *         // opt is {xx: 123, yy: 456}
   *     }
   * })
   * ```
   */


  ComponentModel.prototype.getDefaultOption = function () {
    var ctor = this.constructor; // If using class declaration, it is different to travel super class
    // in legacy env and auto merge defaultOption. So if using class
    // declaration, defaultOption should be merged manually.

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_clazz_js__["d" /* isExtendedClass */])(ctor)) {
      // When using ts class, defaultOption must be declared as static.
      return ctor.defaultOption;
    } // FIXME: remove this approach?


    var fields = inner(this);

    if (!fields.defaultOption) {
      var optList = [];
      var clz = ctor;

      while (clz) {
        var opt = clz.prototype.defaultOption;
        opt && optList.push(opt);
        clz = clz.superClass;
      }

      var defaultOption = {};

      for (var i = optList.length - 1; i >= 0; i--) {
        defaultOption = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"](defaultOption, optList[i], true);
      }

      fields.defaultOption = defaultOption;
    }

    return fields.defaultOption;
  };
  /**
   * Notice: always force to input param `useDefault` in case that forget to consider it.
   * The same behavior as `modelUtil.parseFinder`.
   *
   * @param useDefault In many cases like series refer axis and axis refer grid,
   *        If axis index / axis id not specified, use the first target as default.
   *        In other cases like dataZoom refer axis, if not specified, measn no refer.
   */


  ComponentModel.prototype.getReferringComponents = function (mainType, opt) {
    var indexKey = mainType + 'Index';
    var idKey = mainType + 'Id';
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_model_js__["h" /* queryReferringComponents */])(this.ecModel, mainType, {
      index: this.get(indexKey, true),
      id: this.get(idKey, true)
    }, opt);
  };

  ComponentModel.prototype.getBoxLayoutParams = function () {
    // Consider itself having box layout configs.
    var boxLayoutModel = this;
    return {
      left: boxLayoutModel.get('left'),
      top: boxLayoutModel.get('top'),
      right: boxLayoutModel.get('right'),
      bottom: boxLayoutModel.get('bottom'),
      width: boxLayoutModel.get('width'),
      height: boxLayoutModel.get('height')
    };
  };
  /**
   * Get key for zlevel.
   * If developers don't configure zlevel. We will assign zlevel to series based on the key.
   * For example, lines with trail effect and progressive series will in an individual zlevel.
   */


  ComponentModel.prototype.getZLevelKey = function () {
    return '';
  };

  ComponentModel.prototype.setZLevel = function (zlevel) {
    this.option.zlevel = zlevel;
  };

  ComponentModel.protoInitialize = function () {
    var proto = ComponentModel.prototype;
    proto.type = 'component';
    proto.id = '';
    proto.name = '';
    proto.mainType = '';
    proto.subType = '';
    proto.componentIndex = 0;
  }();

  return ComponentModel;
}(__WEBPACK_IMPORTED_MODULE_2__Model_js__["a" /* default */]);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_clazz_js__["a" /* mountExtend */])(ComponentModel, __WEBPACK_IMPORTED_MODULE_2__Model_js__["a" /* default */]);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_clazz_js__["e" /* enableClassManagement */])(ComponentModel);
__WEBPACK_IMPORTED_MODULE_3__util_component_js__["b" /* enableSubTypeDefaulter */](ComponentModel);
__WEBPACK_IMPORTED_MODULE_3__util_component_js__["c" /* enableTopologicalTravel */](ComponentModel, getDependencies);

function getDependencies(componentType) {
  var deps = [];
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](ComponentModel.getClassesByMainType(componentType), function (clz) {
    deps = deps.concat(clz.dependencies || clz.prototype.dependencies || []);
  }); // Ensure main type.

  deps = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"](deps, function (type) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_clazz_js__["f" /* parseClassType */])(type).main;
  }); // Hack dataset for convenience.

  if (componentType !== 'dataset' && __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["indexOf"](deps, 'dataset') <= 0) {
    deps.unshift('dataset');
  }

  return deps;
}

/* harmony default export */ __webpack_exports__["a"] = (ComponentModel);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__matrix_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Point_js__ = __webpack_require__(255);


var mathMin = Math.min;
var mathMax = Math.max;
var lt = new __WEBPACK_IMPORTED_MODULE_1__Point_js__["a" /* default */]();
var rb = new __WEBPACK_IMPORTED_MODULE_1__Point_js__["a" /* default */]();
var lb = new __WEBPACK_IMPORTED_MODULE_1__Point_js__["a" /* default */]();
var rt = new __WEBPACK_IMPORTED_MODULE_1__Point_js__["a" /* default */]();
var minTv = new __WEBPACK_IMPORTED_MODULE_1__Point_js__["a" /* default */]();
var maxTv = new __WEBPACK_IMPORTED_MODULE_1__Point_js__["a" /* default */]();
var BoundingRect = (function () {
    function BoundingRect(x, y, width, height) {
        if (width < 0) {
            x = x + width;
            width = -width;
        }
        if (height < 0) {
            y = y + height;
            height = -height;
        }
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    BoundingRect.prototype.union = function (other) {
        var x = mathMin(other.x, this.x);
        var y = mathMin(other.y, this.y);
        if (isFinite(this.x) && isFinite(this.width)) {
            this.width = mathMax(other.x + other.width, this.x + this.width) - x;
        }
        else {
            this.width = other.width;
        }
        if (isFinite(this.y) && isFinite(this.height)) {
            this.height = mathMax(other.y + other.height, this.y + this.height) - y;
        }
        else {
            this.height = other.height;
        }
        this.x = x;
        this.y = y;
    };
    BoundingRect.prototype.applyTransform = function (m) {
        BoundingRect.applyTransform(this, this, m);
    };
    BoundingRect.prototype.calculateTransform = function (b) {
        var a = this;
        var sx = b.width / a.width;
        var sy = b.height / a.height;
        var m = __WEBPACK_IMPORTED_MODULE_0__matrix_js__["create"]();
        __WEBPACK_IMPORTED_MODULE_0__matrix_js__["translate"](m, m, [-a.x, -a.y]);
        __WEBPACK_IMPORTED_MODULE_0__matrix_js__["scale"](m, m, [sx, sy]);
        __WEBPACK_IMPORTED_MODULE_0__matrix_js__["translate"](m, m, [b.x, b.y]);
        return m;
    };
    BoundingRect.prototype.intersect = function (b, mtv) {
        if (!b) {
            return false;
        }
        if (!(b instanceof BoundingRect)) {
            b = BoundingRect.create(b);
        }
        var a = this;
        var ax0 = a.x;
        var ax1 = a.x + a.width;
        var ay0 = a.y;
        var ay1 = a.y + a.height;
        var bx0 = b.x;
        var bx1 = b.x + b.width;
        var by0 = b.y;
        var by1 = b.y + b.height;
        var overlap = !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
        if (mtv) {
            var dMin = Infinity;
            var dMax = 0;
            var d0 = Math.abs(ax1 - bx0);
            var d1 = Math.abs(bx1 - ax0);
            var d2 = Math.abs(ay1 - by0);
            var d3 = Math.abs(by1 - ay0);
            var dx = Math.min(d0, d1);
            var dy = Math.min(d2, d3);
            if (ax1 < bx0 || bx1 < ax0) {
                if (dx > dMax) {
                    dMax = dx;
                    if (d0 < d1) {
                        __WEBPACK_IMPORTED_MODULE_1__Point_js__["a" /* default */].set(maxTv, -d0, 0);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_1__Point_js__["a" /* default */].set(maxTv, d1, 0);
                    }
                }
            }
            else {
                if (dx < dMin) {
                    dMin = dx;
                    if (d0 < d1) {
                        __WEBPACK_IMPORTED_MODULE_1__Point_js__["a" /* default */].set(minTv, d0, 0);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_1__Point_js__["a" /* default */].set(minTv, -d1, 0);
                    }
                }
            }
            if (ay1 < by0 || by1 < ay0) {
                if (dy > dMax) {
                    dMax = dy;
                    if (d2 < d3) {
                        __WEBPACK_IMPORTED_MODULE_1__Point_js__["a" /* default */].set(maxTv, 0, -d2);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_1__Point_js__["a" /* default */].set(maxTv, 0, d3);
                    }
                }
            }
            else {
                if (dx < dMin) {
                    dMin = dx;
                    if (d2 < d3) {
                        __WEBPACK_IMPORTED_MODULE_1__Point_js__["a" /* default */].set(minTv, 0, d2);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_1__Point_js__["a" /* default */].set(minTv, 0, -d3);
                    }
                }
            }
        }
        if (mtv) {
            __WEBPACK_IMPORTED_MODULE_1__Point_js__["a" /* default */].copy(mtv, overlap ? minTv : maxTv);
        }
        return overlap;
    };
    BoundingRect.prototype.contain = function (x, y) {
        var rect = this;
        return x >= rect.x
            && x <= (rect.x + rect.width)
            && y >= rect.y
            && y <= (rect.y + rect.height);
    };
    BoundingRect.prototype.clone = function () {
        return new BoundingRect(this.x, this.y, this.width, this.height);
    };
    BoundingRect.prototype.copy = function (other) {
        BoundingRect.copy(this, other);
    };
    BoundingRect.prototype.plain = function () {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
    };
    BoundingRect.prototype.isFinite = function () {
        return isFinite(this.x)
            && isFinite(this.y)
            && isFinite(this.width)
            && isFinite(this.height);
    };
    BoundingRect.prototype.isZero = function () {
        return this.width === 0 || this.height === 0;
    };
    BoundingRect.create = function (rect) {
        return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
    };
    BoundingRect.copy = function (target, source) {
        target.x = source.x;
        target.y = source.y;
        target.width = source.width;
        target.height = source.height;
    };
    BoundingRect.applyTransform = function (target, source, m) {
        if (!m) {
            if (target !== source) {
                BoundingRect.copy(target, source);
            }
            return;
        }
        if (m[1] < 1e-5 && m[1] > -1e-5 && m[2] < 1e-5 && m[2] > -1e-5) {
            var sx = m[0];
            var sy = m[3];
            var tx = m[4];
            var ty = m[5];
            target.x = source.x * sx + tx;
            target.y = source.y * sy + ty;
            target.width = source.width * sx;
            target.height = source.height * sy;
            if (target.width < 0) {
                target.x += target.width;
                target.width = -target.width;
            }
            if (target.height < 0) {
                target.y += target.height;
                target.height = -target.height;
            }
            return;
        }
        lt.x = lb.x = source.x;
        lt.y = rt.y = source.y;
        rb.x = rt.x = source.x + source.width;
        rb.y = lb.y = source.y + source.height;
        lt.transform(m);
        rt.transform(m);
        rb.transform(m);
        lb.transform(m);
        target.x = mathMin(lt.x, rb.x, lb.x, rt.x);
        target.y = mathMin(lt.y, rb.y, lb.y, rt.y);
        var maxX = mathMax(lt.x, rb.x, lb.x, rt.x);
        var maxY = mathMax(lt.y, rb.y, lb.y, rt.y);
        target.width = maxX - target.x;
        target.height = maxY - target.y;
    };
    return BoundingRect;
}());
/* harmony default export */ __webpack_exports__["a"] = (BoundingRect);


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["create"] = create;
/* harmony export (immutable) */ __webpack_exports__["copy"] = copy;
/* harmony export (immutable) */ __webpack_exports__["clone"] = clone;
/* harmony export (immutable) */ __webpack_exports__["set"] = set;
/* harmony export (immutable) */ __webpack_exports__["add"] = add;
/* harmony export (immutable) */ __webpack_exports__["scaleAndAdd"] = scaleAndAdd;
/* harmony export (immutable) */ __webpack_exports__["sub"] = sub;
/* harmony export (immutable) */ __webpack_exports__["len"] = len;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "length", function() { return length; });
/* harmony export (immutable) */ __webpack_exports__["lenSquare"] = lenSquare;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lengthSquare", function() { return lengthSquare; });
/* harmony export (immutable) */ __webpack_exports__["mul"] = mul;
/* harmony export (immutable) */ __webpack_exports__["div"] = div;
/* harmony export (immutable) */ __webpack_exports__["dot"] = dot;
/* harmony export (immutable) */ __webpack_exports__["scale"] = scale;
/* harmony export (immutable) */ __webpack_exports__["normalize"] = normalize;
/* harmony export (immutable) */ __webpack_exports__["distance"] = distance;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dist", function() { return dist; });
/* harmony export (immutable) */ __webpack_exports__["distanceSquare"] = distanceSquare;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "distSquare", function() { return distSquare; });
/* harmony export (immutable) */ __webpack_exports__["negate"] = negate;
/* harmony export (immutable) */ __webpack_exports__["lerp"] = lerp;
/* harmony export (immutable) */ __webpack_exports__["applyTransform"] = applyTransform;
/* harmony export (immutable) */ __webpack_exports__["min"] = min;
/* harmony export (immutable) */ __webpack_exports__["max"] = max;
function create(x, y) {
    if (x == null) {
        x = 0;
    }
    if (y == null) {
        y = 0;
    }
    return [x, y];
}
function copy(out, v) {
    out[0] = v[0];
    out[1] = v[1];
    return out;
}
function clone(v) {
    return [v[0], v[1]];
}
function set(out, a, b) {
    out[0] = a;
    out[1] = b;
    return out;
}
function add(out, v1, v2) {
    out[0] = v1[0] + v2[0];
    out[1] = v1[1] + v2[1];
    return out;
}
function scaleAndAdd(out, v1, v2, a) {
    out[0] = v1[0] + v2[0] * a;
    out[1] = v1[1] + v2[1] * a;
    return out;
}
function sub(out, v1, v2) {
    out[0] = v1[0] - v2[0];
    out[1] = v1[1] - v2[1];
    return out;
}
function len(v) {
    return Math.sqrt(lenSquare(v));
}
var length = len;
function lenSquare(v) {
    return v[0] * v[0] + v[1] * v[1];
}
var lengthSquare = lenSquare;
function mul(out, v1, v2) {
    out[0] = v1[0] * v2[0];
    out[1] = v1[1] * v2[1];
    return out;
}
function div(out, v1, v2) {
    out[0] = v1[0] / v2[0];
    out[1] = v1[1] / v2[1];
    return out;
}
function dot(v1, v2) {
    return v1[0] * v2[0] + v1[1] * v2[1];
}
function scale(out, v, s) {
    out[0] = v[0] * s;
    out[1] = v[1] * s;
    return out;
}
function normalize(out, v) {
    var d = len(v);
    if (d === 0) {
        out[0] = 0;
        out[1] = 0;
    }
    else {
        out[0] = v[0] / d;
        out[1] = v[1] / d;
    }
    return out;
}
function distance(v1, v2) {
    return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0])
        + (v1[1] - v2[1]) * (v1[1] - v2[1]));
}
var dist = distance;
function distanceSquare(v1, v2) {
    return (v1[0] - v2[0]) * (v1[0] - v2[0])
        + (v1[1] - v2[1]) * (v1[1] - v2[1]);
}
var distSquare = distanceSquare;
function negate(out, v) {
    out[0] = -v[0];
    out[1] = -v[1];
    return out;
}
function lerp(out, v1, v2, t) {
    out[0] = v1[0] + t * (v2[0] - v1[0]);
    out[1] = v1[1] + t * (v2[1] - v1[1]);
    return out;
}
function applyTransform(out, v, m) {
    var x = v[0];
    var y = v[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function min(out, v1, v2) {
    out[0] = Math.min(v1[0], v2[0]);
    out[1] = Math.min(v1[1], v2[1]);
    return out;
}
function max(out, v1, v2) {
    out[0] = Math.max(v1[0], v2[0]);
    out[1] = Math.max(v1[1], v2[1]);
    return out;
}


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_PATH_STYLE; });
/* unused harmony export DEFAULT_PATH_ANIMATION_PROPS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Displayable_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_PathProxy_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contain_path_js__ = __webpack_require__(1698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tool_color_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_js__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_Transformable_js__ = __webpack_require__(117);









var DEFAULT_PATH_STYLE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_util_js__["defaults"])({
    fill: '#000',
    stroke: null,
    strokePercent: 1,
    fillOpacity: 1,
    strokeOpacity: 1,
    lineDashOffset: 0,
    lineWidth: 1,
    lineCap: 'butt',
    miterLimit: 10,
    strokeNoScale: false,
    strokeFirst: false
}, __WEBPACK_IMPORTED_MODULE_1__Displayable_js__["a" /* DEFAULT_COMMON_STYLE */]);
var DEFAULT_PATH_ANIMATION_PROPS = {
    style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_util_js__["defaults"])({
        fill: true,
        stroke: true,
        strokePercent: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineDashOffset: true,
        lineWidth: true,
        miterLimit: true
    }, __WEBPACK_IMPORTED_MODULE_1__Displayable_js__["b" /* DEFAULT_COMMON_ANIMATION_PROPS */].style)
};
var pathCopyParams = __WEBPACK_IMPORTED_MODULE_8__core_Transformable_js__["b" /* TRANSFORMABLE_PROPS */].concat(['invisible',
    'culling', 'z', 'z2', 'zlevel', 'parent'
]);
var Path = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Path, _super);
    function Path(opts) {
        return _super.call(this, opts) || this;
    }
    Path.prototype.update = function () {
        var _this = this;
        _super.prototype.update.call(this);
        var style = this.style;
        if (style.decal) {
            var decalEl = this._decalEl = this._decalEl || new Path();
            if (decalEl.buildPath === Path.prototype.buildPath) {
                decalEl.buildPath = function (ctx) {
                    _this.buildPath(ctx, _this.shape);
                };
            }
            decalEl.silent = true;
            var decalElStyle = decalEl.style;
            for (var key in style) {
                if (decalElStyle[key] !== style[key]) {
                    decalElStyle[key] = style[key];
                }
            }
            decalElStyle.fill = style.fill ? style.decal : null;
            decalElStyle.decal = null;
            decalElStyle.shadowColor = null;
            style.strokeFirst && (decalElStyle.stroke = null);
            for (var i = 0; i < pathCopyParams.length; ++i) {
                decalEl[pathCopyParams[i]] = this[pathCopyParams[i]];
            }
            decalEl.__dirty |= __WEBPACK_IMPORTED_MODULE_7__constants_js__["a" /* REDRAW_BIT */];
        }
        else if (this._decalEl) {
            this._decalEl = null;
        }
    };
    Path.prototype.getDecalElement = function () {
        return this._decalEl;
    };
    Path.prototype._init = function (props) {
        var keysArr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_util_js__["keys"])(props);
        this.shape = this.getDefaultShape();
        var defaultStyle = this.getDefaultStyle();
        if (defaultStyle) {
            this.useStyle(defaultStyle);
        }
        for (var i = 0; i < keysArr.length; i++) {
            var key = keysArr[i];
            var value = props[key];
            if (key === 'style') {
                if (!this.style) {
                    this.useStyle(value);
                }
                else {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_util_js__["extend"])(this.style, value);
                }
            }
            else if (key === 'shape') {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_util_js__["extend"])(this.shape, value);
            }
            else {
                _super.prototype.attrKV.call(this, key, value);
            }
        }
        if (!this.style) {
            this.useStyle({});
        }
    };
    Path.prototype.getDefaultStyle = function () {
        return null;
    };
    Path.prototype.getDefaultShape = function () {
        return {};
    };
    Path.prototype.canBeInsideText = function () {
        return this.hasFill();
    };
    Path.prototype.getInsideTextFill = function () {
        var pathFill = this.style.fill;
        if (pathFill !== 'none') {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_util_js__["isString"])(pathFill)) {
                var fillLum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tool_color_js__["lum"])(pathFill, 0);
                if (fillLum > 0.5) {
                    return __WEBPACK_IMPORTED_MODULE_6__config_js__["a" /* DARK_LABEL_COLOR */];
                }
                else if (fillLum > 0.2) {
                    return __WEBPACK_IMPORTED_MODULE_6__config_js__["b" /* LIGHTER_LABEL_COLOR */];
                }
                return __WEBPACK_IMPORTED_MODULE_6__config_js__["c" /* LIGHT_LABEL_COLOR */];
            }
            else if (pathFill) {
                return __WEBPACK_IMPORTED_MODULE_6__config_js__["c" /* LIGHT_LABEL_COLOR */];
            }
        }
        return __WEBPACK_IMPORTED_MODULE_6__config_js__["a" /* DARK_LABEL_COLOR */];
    };
    Path.prototype.getInsideTextStroke = function (textFill) {
        var pathFill = this.style.fill;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_util_js__["isString"])(pathFill)) {
            var zr = this.__zr;
            var isDarkMode = !!(zr && zr.isDarkMode());
            var isDarkLabel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__tool_color_js__["lum"])(textFill, 0) < __WEBPACK_IMPORTED_MODULE_6__config_js__["d" /* DARK_MODE_THRESHOLD */];
            if (isDarkMode === isDarkLabel) {
                return pathFill;
            }
        }
    };
    Path.prototype.buildPath = function (ctx, shapeCfg, inBatch) { };
    Path.prototype.pathUpdated = function () {
        this.__dirty &= ~__WEBPACK_IMPORTED_MODULE_7__constants_js__["b" /* SHAPE_CHANGED_BIT */];
    };
    Path.prototype.getUpdatedPathProxy = function (inBatch) {
        !this.path && this.createPathProxy();
        this.path.beginPath();
        this.buildPath(this.path, this.shape, inBatch);
        return this.path;
    };
    Path.prototype.createPathProxy = function () {
        this.path = new __WEBPACK_IMPORTED_MODULE_2__core_PathProxy_js__["a" /* default */](false);
    };
    Path.prototype.hasStroke = function () {
        var style = this.style;
        var stroke = style.stroke;
        return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
    };
    Path.prototype.hasFill = function () {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    Path.prototype.getBoundingRect = function () {
        var rect = this._rect;
        var style = this.style;
        var needsUpdateRect = !rect;
        if (needsUpdateRect) {
            var firstInvoke = false;
            if (!this.path) {
                firstInvoke = true;
                this.createPathProxy();
            }
            var path = this.path;
            if (firstInvoke || (this.__dirty & __WEBPACK_IMPORTED_MODULE_7__constants_js__["b" /* SHAPE_CHANGED_BIT */])) {
                path.beginPath();
                this.buildPath(path, this.shape, false);
                this.pathUpdated();
            }
            rect = path.getBoundingRect();
        }
        this._rect = rect;
        if (this.hasStroke() && this.path && this.path.len() > 0) {
            var rectStroke = this._rectStroke || (this._rectStroke = rect.clone());
            if (this.__dirty || needsUpdateRect) {
                rectStroke.copy(rect);
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                var w = style.lineWidth;
                if (!this.hasFill()) {
                    var strokeContainThreshold = this.strokeContainThreshold;
                    w = Math.max(w, strokeContainThreshold == null ? 4 : strokeContainThreshold);
                }
                if (lineScale > 1e-10) {
                    rectStroke.width += w / lineScale;
                    rectStroke.height += w / lineScale;
                    rectStroke.x -= w / lineScale / 2;
                    rectStroke.y -= w / lineScale / 2;
                }
            }
            return rectStroke;
        }
        return rect;
    };
    Path.prototype.contain = function (x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        var style = this.style;
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            var pathProxy = this.path;
            if (this.hasStroke()) {
                var lineWidth = style.lineWidth;
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                if (lineScale > 1e-10) {
                    if (!this.hasFill()) {
                        lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
                    }
                    if (__WEBPACK_IMPORTED_MODULE_3__contain_path_js__["a" /* containStroke */](pathProxy, lineWidth / lineScale, x, y)) {
                        return true;
                    }
                }
            }
            if (this.hasFill()) {
                return __WEBPACK_IMPORTED_MODULE_3__contain_path_js__["b" /* contain */](pathProxy, x, y);
            }
        }
        return false;
    };
    Path.prototype.dirtyShape = function () {
        this.__dirty |= __WEBPACK_IMPORTED_MODULE_7__constants_js__["b" /* SHAPE_CHANGED_BIT */];
        if (this._rect) {
            this._rect = null;
        }
        if (this._decalEl) {
            this._decalEl.dirtyShape();
        }
        this.markRedraw();
    };
    Path.prototype.dirty = function () {
        this.dirtyStyle();
        this.dirtyShape();
    };
    Path.prototype.animateShape = function (loop) {
        return this.animate('shape', loop);
    };
    Path.prototype.updateDuringAnimation = function (targetKey) {
        if (targetKey === 'style') {
            this.dirtyStyle();
        }
        else if (targetKey === 'shape') {
            this.dirtyShape();
        }
        else {
            this.markRedraw();
        }
    };
    Path.prototype.attrKV = function (key, value) {
        if (key === 'shape') {
            this.setShape(value);
        }
        else {
            _super.prototype.attrKV.call(this, key, value);
        }
    };
    Path.prototype.setShape = function (keyOrObj, value) {
        var shape = this.shape;
        if (!shape) {
            shape = this.shape = {};
        }
        if (typeof keyOrObj === 'string') {
            shape[keyOrObj] = value;
        }
        else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_util_js__["extend"])(shape, keyOrObj);
        }
        this.dirtyShape();
        return this;
    };
    Path.prototype.shapeChanged = function () {
        return !!(this.__dirty & __WEBPACK_IMPORTED_MODULE_7__constants_js__["b" /* SHAPE_CHANGED_BIT */]);
    };
    Path.prototype.createStyle = function (obj) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_util_js__["createObject"])(DEFAULT_PATH_STYLE, obj);
    };
    Path.prototype._innerSaveToNormal = function (toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.shape && !normalState.shape) {
            normalState.shape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_util_js__["extend"])({}, this.shape);
        }
    };
    Path.prototype._applyStateObj = function (stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetShape;
        if (state && state.shape) {
            if (transition) {
                if (keepCurrentStates) {
                    targetShape = state.shape;
                }
                else {
                    targetShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_util_js__["extend"])({}, normalState.shape);
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_util_js__["extend"])(targetShape, state.shape);
                }
            }
            else {
                targetShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_util_js__["extend"])({}, keepCurrentStates ? this.shape : normalState.shape);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_util_js__["extend"])(targetShape, state.shape);
            }
        }
        else if (needsRestoreToNormal) {
            targetShape = normalState.shape;
        }
        if (targetShape) {
            if (transition) {
                this.shape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_util_js__["extend"])({}, this.shape);
                var targetShapePrimaryProps = {};
                var shapeKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_util_js__["keys"])(targetShape);
                for (var i = 0; i < shapeKeys.length; i++) {
                    var key = shapeKeys[i];
                    if (typeof targetShape[key] === 'object') {
                        this.shape[key] = targetShape[key];
                    }
                    else {
                        targetShapePrimaryProps[key] = targetShape[key];
                    }
                }
                this._transitionState(stateName, {
                    shape: targetShapePrimaryProps
                }, animationCfg);
            }
            else {
                this.shape = targetShape;
                this.dirtyShape();
            }
        }
    };
    Path.prototype._mergeStates = function (states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedShape;
        for (var i = 0; i < states.length; i++) {
            var state = states[i];
            if (state.shape) {
                mergedShape = mergedShape || {};
                this._mergeStyle(mergedShape, state.shape);
            }
        }
        if (mergedShape) {
            mergedState.shape = mergedShape;
        }
        return mergedState;
    };
    Path.prototype.getAnimationStyleProps = function () {
        return DEFAULT_PATH_ANIMATION_PROPS;
    };
    Path.prototype.isZeroArea = function () {
        return false;
    };
    Path.extend = function (defaultProps) {
        var Sub = (function (_super) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Sub, _super);
            function Sub(opts) {
                var _this = _super.call(this, opts) || this;
                defaultProps.init && defaultProps.init.call(_this, opts);
                return _this;
            }
            Sub.prototype.getDefaultStyle = function () {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_util_js__["clone"])(defaultProps.style);
            };
            Sub.prototype.getDefaultShape = function () {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_util_js__["clone"])(defaultProps.shape);
            };
            return Sub;
        }(Path));
        for (var key in defaultProps) {
            if (typeof defaultProps[key] === 'function') {
                Sub.prototype[key] = defaultProps[key];
            }
        }
        return Sub;
    };
    Path.initDefaultProps = (function () {
        var pathProto = Path.prototype;
        pathProto.type = 'path';
        pathProto.strokeContainThreshold = 5;
        pathProto.segmentIgnoreThreshold = 0;
        pathProto.subPixelOptimize = false;
        pathProto.autoBatch = false;
        pathProto.__dirty = __WEBPACK_IMPORTED_MODULE_7__constants_js__["a" /* REDRAW_BIT */] | __WEBPACK_IMPORTED_MODULE_7__constants_js__["c" /* STYLE_CHANGED_BIT */] | __WEBPACK_IMPORTED_MODULE_7__constants_js__["b" /* SHAPE_CHANGED_BIT */];
    })();
    return Path;
}(__WEBPACK_IMPORTED_MODULE_1__Displayable_js__["c" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Path);


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(186)('wks');
var uid = __webpack_require__(130);
var Symbol = __webpack_require__(13).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SERIES_UNIVERSAL_TRANSITION_PROP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_env_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Component_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixin_palette_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_mixin_dataFormat_js__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_task_js__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_clazz_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_helper_sourceManager_js__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__component_tooltip_seriesFormatTooltip_js__ = __webpack_require__(477);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/












var inner = __WEBPACK_IMPORTED_MODULE_3__util_model_js__["a" /* makeInner */]();

function getSelectionKey(data, dataIndex) {
  return data.getName(dataIndex) || data.getId(dataIndex);
}

var SERIES_UNIVERSAL_TRANSITION_PROP = '__universalTransitionEnabled';

var SeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(SeriesModel, _super);

  function SeriesModel() {
    // [Caution]: Becuase this class or desecendants can be used as `XXX.extend(subProto)`,
    // the class members must not be initialized in constructor or declaration place.
    // Otherwise there is bad case:
    //   class A {xxx = 1;}
    //   enableClassExtend(A);
    //   class B extends A {}
    //   var C = B.extend({xxx: 5});
    //   var c = new C();
    //   console.log(c.xxx); // expect 5 but always 1.
    var _this = _super !== null && _super.apply(this, arguments) || this; // ---------------------------------------
    // Props about data selection
    // ---------------------------------------


    _this._selectedDataIndicesMap = {};
    return _this;
  }

  SeriesModel.prototype.init = function (option, parentModel, ecModel) {
    this.seriesIndex = this.componentIndex;
    this.dataTask = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__core_task_js__["a" /* createTask */])({
      count: dataTaskCount,
      reset: dataTaskReset
    });
    this.dataTask.context = {
      model: this
    };
    this.mergeDefaultAndTheme(option, ecModel);
    var sourceManager = inner(this).sourceManager = new __WEBPACK_IMPORTED_MODULE_10__data_helper_sourceManager_js__["a" /* SourceManager */](this);
    sourceManager.prepareSource();
    var data = this.getInitialData(option, ecModel);
    wrapData(data, this);
    this.dataTask.context.data = data;

    if (true) {
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"](data, 'getInitialData returned invalid data.');
    }

    inner(this).dataBeforeProcessed = data; // If we reverse the order (make data firstly, and then make
    // dataBeforeProcessed by cloneShallow), cloneShallow will
    // cause data.graph.data !== data when using
    // module:echarts/data/Graph or module:echarts/data/Tree.
    // See module:echarts/data/helper/linkSeriesData
    // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
    // init or merge stage, because the data can be restored. So we do not `restoreData`
    // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
    // Call `seriesModel.getRawData()` instead.
    // this.restoreData();

    autoSeriesName(this);

    this._initSelectedMapFromData(data);
  };
  /**
   * Util for merge default and theme to option
   */


  SeriesModel.prototype.mergeDefaultAndTheme = function (option, ecModel) {
    var layoutMode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_layout_js__["a" /* fetchLayoutMode */])(this);
    var inputPositionParams = layoutMode ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_layout_js__["b" /* getLayoutParams */])(option) : {}; // Backward compat: using subType on theme.
    // But if name duplicate between series subType
    // (for example: parallel) add component mainType,
    // add suffix 'Series'.

    var themeSubType = this.subType;

    if (__WEBPACK_IMPORTED_MODULE_4__Component_js__["a" /* default */].hasClass(themeSubType)) {
      themeSubType += 'Series';
    }

    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"](option, ecModel.getTheme().get(this.subType));
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"](option, this.getDefaultOption()); // Default label emphasis `show`

    __WEBPACK_IMPORTED_MODULE_3__util_model_js__["e" /* defaultEmphasis */](option, 'label', ['show']);
    this.fillDataTextStyle(option.data);

    if (layoutMode) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_layout_js__["c" /* mergeLayoutParam */])(option, inputPositionParams, layoutMode);
    }
  };

  SeriesModel.prototype.mergeOption = function (newSeriesOption, ecModel) {
    // this.settingTask.dirty();
    newSeriesOption = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"](this.option, newSeriesOption, true);
    this.fillDataTextStyle(newSeriesOption.data);
    var layoutMode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_layout_js__["a" /* fetchLayoutMode */])(this);

    if (layoutMode) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_layout_js__["c" /* mergeLayoutParam */])(this.option, newSeriesOption, layoutMode);
    }

    var sourceManager = inner(this).sourceManager;
    sourceManager.dirty();
    sourceManager.prepareSource();
    var data = this.getInitialData(newSeriesOption, ecModel);
    wrapData(data, this);
    this.dataTask.dirty();
    this.dataTask.context.data = data;
    inner(this).dataBeforeProcessed = data;
    autoSeriesName(this);

    this._initSelectedMapFromData(data);
  };

  SeriesModel.prototype.fillDataTextStyle = function (data) {
    // Default data label emphasis `show`
    // FIXME Tree structure data ?
    // FIXME Performance ?
    if (data && !__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isTypedArray"](data)) {
      var props = ['show'];

      for (var i = 0; i < data.length; i++) {
        if (data[i] && data[i].label) {
          __WEBPACK_IMPORTED_MODULE_3__util_model_js__["e" /* defaultEmphasis */](data[i], 'label', props);
        }
      }
    }
  };
  /**
   * Init a data structure from data related option in series
   * Must be overriden.
   */


  SeriesModel.prototype.getInitialData = function (option, ecModel) {
    return;
  };
  /**
   * Append data to list
   */


  SeriesModel.prototype.appendData = function (params) {
    // FIXME ???
    // (1) If data from dataset, forbidden append.
    // (2) support append data of dataset.
    var data = this.getRawData();
    data.appendData(params.data);
  };
  /**
   * Consider some method like `filter`, `map` need make new data,
   * We should make sure that `seriesModel.getData()` get correct
   * data in the stream procedure. So we fetch data from upstream
   * each time `task.perform` called.
   */


  SeriesModel.prototype.getData = function (dataType) {
    var task = getCurrentTask(this);

    if (task) {
      var data = task.context.data;
      return dataType == null ? data : data.getLinkedData(dataType);
    } else {
      // When series is not alive (that may happen when click toolbox
      // restore or setOption with not merge mode), series data may
      // be still need to judge animation or something when graphic
      // elements want to know whether fade out.
      return inner(this).data;
    }
  };

  SeriesModel.prototype.getAllData = function () {
    var mainData = this.getData();
    return mainData && mainData.getLinkedDataAll ? mainData.getLinkedDataAll() : [{
      data: mainData
    }];
  };

  SeriesModel.prototype.setData = function (data) {
    var task = getCurrentTask(this);

    if (task) {
      var context = task.context; // Consider case: filter, data sample.
      // FIXME:TS never used, so comment it
      // if (context.data !== data && task.modifyOutputEnd) {
      //     task.setOutputEnd(data.count());
      // }

      context.outputData = data; // Caution: setData should update context.data,
      // Because getData may be called multiply in a
      // single stage and expect to get the data just
      // set. (For example, AxisProxy, x y both call
      // getData and setDate sequentially).
      // So the context.data should be fetched from
      // upstream each time when a stage starts to be
      // performed.

      if (task !== this.dataTask) {
        context.data = data;
      }
    }

    inner(this).data = data;
  };

  SeriesModel.prototype.getEncode = function () {
    var encode = this.get('encode', true);

    if (encode) {
      return __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"](encode);
    }
  };

  SeriesModel.prototype.getSourceManager = function () {
    return inner(this).sourceManager;
  };

  SeriesModel.prototype.getSource = function () {
    return this.getSourceManager().getSource();
  };
  /**
   * Get data before processed
   */


  SeriesModel.prototype.getRawData = function () {
    return inner(this).dataBeforeProcessed;
  };

  SeriesModel.prototype.getColorBy = function () {
    var colorBy = this.get('colorBy');
    return colorBy || 'series';
  };

  SeriesModel.prototype.isColorBySeries = function () {
    return this.getColorBy() === 'series';
  };
  /**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overrided for some chart.
   * @return {type} description
   */


  SeriesModel.prototype.getBaseAxis = function () {
    var coordSys = this.coordinateSystem; // @ts-ignore

    return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
  };
  /**
   * Default tooltip formatter
   *
   * @param dataIndex
   * @param multipleSeries
   * @param dataType
   * @param renderMode valid values: 'html'(by default) and 'richText'.
   *        'html' is used for rendering tooltip in extra DOM form, and the result
   *        string is used as DOM HTML content.
   *        'richText' is used for rendering tooltip in rich text form, for those where
   *        DOM operation is not supported.
   * @return formatted tooltip with `html` and `markers`
   *        Notice: The override method can also return string
   */


  SeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__component_tooltip_seriesFormatTooltip_js__["a" /* defaultSeriesFormatTooltip */])({
      series: this,
      dataIndex: dataIndex,
      multipleSeries: multipleSeries
    });
  };

  SeriesModel.prototype.isAnimationEnabled = function () {
    var ecModel = this.ecModel; // Disable animation if using echarts in node but not give ssr flag.
    // In ssr mode, renderToString will generate svg with css animation.

    if (__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_env_js__["a" /* default */].node && !(ecModel && ecModel.ssr)) {
      return false;
    }

    var animationEnabled = this.getShallow('animation');

    if (animationEnabled) {
      if (this.getData().count() > this.getShallow('animationThreshold')) {
        animationEnabled = false;
      }
    }

    return !!animationEnabled;
  };

  SeriesModel.prototype.restoreData = function () {
    this.dataTask.dirty();
  };

  SeriesModel.prototype.getColorFromPalette = function (name, scope, requestColorNum) {
    var ecModel = this.ecModel; // PENDING

    var color = __WEBPACK_IMPORTED_MODULE_5__mixin_palette_js__["a" /* PaletteMixin */].prototype.getColorFromPalette.call(this, name, scope, requestColorNum);

    if (!color) {
      color = ecModel.getColorFromPalette(name, scope, requestColorNum);
    }

    return color;
  };
  /**
   * Use `data.mapDimensionsAll(coordDim)` instead.
   * @deprecated
   */


  SeriesModel.prototype.coordDimToDataDim = function (coordDim) {
    return this.getRawData().mapDimensionsAll(coordDim);
  };
  /**
   * Get progressive rendering count each step
   */


  SeriesModel.prototype.getProgressive = function () {
    return this.get('progressive');
  };
  /**
   * Get progressive rendering count each step
   */


  SeriesModel.prototype.getProgressiveThreshold = function () {
    return this.get('progressiveThreshold');
  }; // PENGING If selectedMode is null ?


  SeriesModel.prototype.select = function (innerDataIndices, dataType) {
    this._innerSelect(this.getData(dataType), innerDataIndices);
  };

  SeriesModel.prototype.unselect = function (innerDataIndices, dataType) {
    var selectedMap = this.option.selectedMap;

    if (!selectedMap) {
      return;
    }

    var selectedMode = this.option.selectedMode;
    var data = this.getData(dataType);

    if (selectedMode === 'series' || selectedMap === 'all') {
      this.option.selectedMap = {};
      this._selectedDataIndicesMap = {};
      return;
    }

    for (var i = 0; i < innerDataIndices.length; i++) {
      var dataIndex = innerDataIndices[i];
      var nameOrId = getSelectionKey(data, dataIndex);
      selectedMap[nameOrId] = false;
      this._selectedDataIndicesMap[nameOrId] = -1;
    }
  };

  SeriesModel.prototype.toggleSelect = function (innerDataIndices, dataType) {
    var tmpArr = [];

    for (var i = 0; i < innerDataIndices.length; i++) {
      tmpArr[0] = innerDataIndices[i];
      this.isSelected(innerDataIndices[i], dataType) ? this.unselect(tmpArr, dataType) : this.select(tmpArr, dataType);
    }
  };

  SeriesModel.prototype.getSelectedDataIndices = function () {
    if (this.option.selectedMap === 'all') {
      return [].slice.call(this.getData().getIndices());
    }

    var selectedDataIndicesMap = this._selectedDataIndicesMap;
    var nameOrIds = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["keys"](selectedDataIndicesMap);
    var dataIndices = [];

    for (var i = 0; i < nameOrIds.length; i++) {
      var dataIndex = selectedDataIndicesMap[nameOrIds[i]];

      if (dataIndex >= 0) {
        dataIndices.push(dataIndex);
      }
    }

    return dataIndices;
  };

  SeriesModel.prototype.isSelected = function (dataIndex, dataType) {
    var selectedMap = this.option.selectedMap;

    if (!selectedMap) {
      return false;
    }

    var data = this.getData(dataType);
    return (selectedMap === 'all' || selectedMap[getSelectionKey(data, dataIndex)]) && !data.getItemModel(dataIndex).get(['select', 'disabled']);
  };

  SeriesModel.prototype.isUniversalTransitionEnabled = function () {
    if (this[SERIES_UNIVERSAL_TRANSITION_PROP]) {
      return true;
    }

    var universalTransitionOpt = this.option.universalTransition; // Quick reject

    if (!universalTransitionOpt) {
      return false;
    }

    if (universalTransitionOpt === true) {
      return true;
    } // Can be simply 'universalTransition: true'


    return universalTransitionOpt && universalTransitionOpt.enabled;
  };

  SeriesModel.prototype._innerSelect = function (data, innerDataIndices) {
    var _a, _b;

    var option = this.option;
    var selectedMode = option.selectedMode;
    var len = innerDataIndices.length;

    if (!selectedMode || !len) {
      return;
    }

    if (selectedMode === 'series') {
      option.selectedMap = 'all';
    } else if (selectedMode === 'multiple') {
      if (!__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isObject"](option.selectedMap)) {
        option.selectedMap = {};
      }

      var selectedMap = option.selectedMap;

      for (var i = 0; i < len; i++) {
        var dataIndex = innerDataIndices[i]; // TODO diffrent types of data share same object.

        var nameOrId = getSelectionKey(data, dataIndex);
        selectedMap[nameOrId] = true;
        this._selectedDataIndicesMap[nameOrId] = data.getRawIndex(dataIndex);
      }
    } else if (selectedMode === 'single' || selectedMode === true) {
      var lastDataIndex = innerDataIndices[len - 1];
      var nameOrId = getSelectionKey(data, lastDataIndex);
      option.selectedMap = (_a = {}, _a[nameOrId] = true, _a);
      this._selectedDataIndicesMap = (_b = {}, _b[nameOrId] = data.getRawIndex(lastDataIndex), _b);
    }
  };

  SeriesModel.prototype._initSelectedMapFromData = function (data) {
    // Ignore select info in data if selectedMap exists.
    // NOTE It's only for legacy usage. edge data is not supported.
    if (this.option.selectedMap) {
      return;
    }

    var dataIndices = [];

    if (data.hasItemOption) {
      data.each(function (idx) {
        var rawItem = data.getRawDataItem(idx);

        if (rawItem && rawItem.selected) {
          dataIndices.push(idx);
        }
      });
    }

    if (dataIndices.length > 0) {
      this._innerSelect(data, dataIndices);
    }
  }; // /**
  //  * @see {module:echarts/stream/Scheduler}
  //  */
  // abstract pipeTask: null


  SeriesModel.registerClass = function (clz) {
    return __WEBPACK_IMPORTED_MODULE_4__Component_js__["a" /* default */].registerClass(clz);
  };

  SeriesModel.protoInitialize = function () {
    var proto = SeriesModel.prototype;
    proto.type = 'series.__base__';
    proto.seriesIndex = 0;
    proto.ignoreStyleOnData = false;
    proto.hasSymbolVisual = false;
    proto.defaultSymbol = 'circle'; // Make sure the values can be accessed!

    proto.visualStyleAccessPath = 'itemStyle';
    proto.visualDrawType = 'fill';
  }();

  return SeriesModel;
}(__WEBPACK_IMPORTED_MODULE_4__Component_js__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["mixin"](SeriesModel, __WEBPACK_IMPORTED_MODULE_6__model_mixin_dataFormat_js__["a" /* DataFormatMixin */]);
__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["mixin"](SeriesModel, __WEBPACK_IMPORTED_MODULE_5__mixin_palette_js__["a" /* PaletteMixin */]);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_clazz_js__["a" /* mountExtend */])(SeriesModel, __WEBPACK_IMPORTED_MODULE_4__Component_js__["a" /* default */]);
/**
 * MUST be called after `prepareSource` called
 * Here we need to make auto series, especially for auto legend. But we
 * do not modify series.name in option to avoid side effects.
 */

function autoSeriesName(seriesModel) {
  // User specified name has higher priority, otherwise it may cause
  // series can not be queried unexpectedly.
  var name = seriesModel.name;

  if (!__WEBPACK_IMPORTED_MODULE_3__util_model_js__["f" /* isNameSpecified */](seriesModel)) {
    seriesModel.name = getSeriesAutoName(seriesModel) || name;
  }
}

function getSeriesAutoName(seriesModel) {
  var data = seriesModel.getRawData();
  var dataDims = data.mapDimensionsAll('seriesName');
  var nameArr = [];
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](dataDims, function (dataDim) {
    var dimInfo = data.getDimensionInfo(dataDim);
    dimInfo.displayName && nameArr.push(dimInfo.displayName);
  });
  return nameArr.join(' ');
}

function dataTaskCount(context) {
  return context.model.getRawData().count();
}

function dataTaskReset(context) {
  var seriesModel = context.model;
  seriesModel.setData(seriesModel.getRawData().cloneShallow());
  return dataTaskProgress;
}

function dataTaskProgress(param, context) {
  // Avoid repead cloneShallow when data just created in reset.
  if (context.outputData && param.end > context.outputData.count()) {
    context.model.getRawData().cloneShallow(context.outputData);
  }
} // TODO refactor


function wrapData(data, seriesModel) {
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["concatArray"](data.CHANGABLE_METHODS, data.DOWNSAMPLE_METHODS), function (methodName) {
    data.wrapMethod(methodName, __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["curry"](onDataChange, seriesModel));
  });
}

function onDataChange(seriesModel, newList) {
  var task = getCurrentTask(seriesModel);

  if (task) {
    // Consider case: filter, selectRange
    task.setOutputEnd((newList || this).count());
  }

  return newList;
}

function getCurrentTask(seriesModel) {
  var scheduler = (seriesModel.ecModel || {}).scheduler;
  var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);

  if (pipeline) {
    // When pipline finished, the currrentTask keep the last
    // task (renderTask).
    var task = pipeline.currentTask;

    if (task) {
      var agentStubMap = task.agentStubMap;

      if (agentStubMap) {
        task = agentStubMap.get(seriesModel.uid);
      }
    }

    return task;
  }
}

/* harmony default export */ __webpack_exports__["b"] = (SeriesModel);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_graphic_Group_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_component_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_clazz_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_task_js__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chart_helper_createRenderPlanner_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_log_js__ = __webpack_require__(14);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/










var inner = __WEBPACK_IMPORTED_MODULE_4__util_model_js__["a" /* makeInner */]();
var renderPlanner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__chart_helper_createRenderPlanner_js__["a" /* default */])();

var ChartView =
/** @class */
function () {
  function ChartView() {
    this.group = new __WEBPACK_IMPORTED_MODULE_1_zrender_lib_graphic_Group_js__["a" /* default */]();
    this.uid = __WEBPACK_IMPORTED_MODULE_2__util_component_js__["a" /* getUID */]('viewChart');
    this.renderTask = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__core_task_js__["a" /* createTask */])({
      plan: renderTaskPlan,
      reset: renderTaskReset
    });
    this.renderTask.context = {
      view: this
    };
  }

  ChartView.prototype.init = function (ecModel, api) {};

  ChartView.prototype.render = function (seriesModel, ecModel, api, payload) {
    if (true) {
      throw new Error('render method must been implemented');
    }
  };
  /**
   * Highlight series or specified data item.
   */


  ChartView.prototype.highlight = function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData(payload && payload.dataType);

    if (!data) {
      if (true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_log_js__["c" /* error */])("Unknown dataType " + payload.dataType);
      }

      return;
    }

    toggleHighlight(data, payload, 'emphasis');
  };
  /**
   * Downplay series or specified data item.
   */


  ChartView.prototype.downplay = function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData(payload && payload.dataType);

    if (!data) {
      if (true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_log_js__["c" /* error */])("Unknown dataType " + payload.dataType);
      }

      return;
    }

    toggleHighlight(data, payload, 'normal');
  };
  /**
   * Remove self.
   */


  ChartView.prototype.remove = function (ecModel, api) {
    this.group.removeAll();
  };
  /**
   * Dispose self.
   */


  ChartView.prototype.dispose = function (ecModel, api) {};

  ChartView.prototype.updateView = function (seriesModel, ecModel, api, payload) {
    this.render(seriesModel, ecModel, api, payload);
  }; // FIXME never used?


  ChartView.prototype.updateLayout = function (seriesModel, ecModel, api, payload) {
    this.render(seriesModel, ecModel, api, payload);
  }; // FIXME never used?


  ChartView.prototype.updateVisual = function (seriesModel, ecModel, api, payload) {
    this.render(seriesModel, ecModel, api, payload);
  };
  /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */


  ChartView.prototype.eachRendered = function (cb) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_graphic_js__["traverseElements"])(this.group, cb);
  };

  ChartView.markUpdateMethod = function (payload, methodName) {
    inner(payload).updateMethod = methodName;
  };

  ChartView.protoInitialize = function () {
    var proto = ChartView.prototype;
    proto.type = 'chart';
  }();

  return ChartView;
}();

;
/**
 * Set state of single element
 */

function elSetState(el, state, highlightDigit) {
  if (el && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_states_js__["q" /* isHighDownDispatcher */])(el)) {
    (state === 'emphasis' ? __WEBPACK_IMPORTED_MODULE_5__util_states_js__["j" /* enterEmphasis */] : __WEBPACK_IMPORTED_MODULE_5__util_states_js__["k" /* leaveEmphasis */])(el, highlightDigit);
  }
}

function toggleHighlight(data, payload, state) {
  var dataIndex = __WEBPACK_IMPORTED_MODULE_4__util_model_js__["c" /* queryDataIndex */](data, payload);
  var highlightDigit = payload && payload.highlightKey != null ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_states_js__["E" /* getHighlightDigit */])(payload.highlightKey) : null;

  if (dataIndex != null) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(__WEBPACK_IMPORTED_MODULE_4__util_model_js__["d" /* normalizeToArray */](dataIndex), function (dataIdx) {
      elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
    });
  } else {
    data.eachItemGraphicEl(function (el) {
      elSetState(el, state, highlightDigit);
    });
  }
}

__WEBPACK_IMPORTED_MODULE_3__util_clazz_js__["b" /* enableClassExtend */](ChartView, ['dispose']);
__WEBPACK_IMPORTED_MODULE_3__util_clazz_js__["e" /* enableClassManagement */](ChartView);

function renderTaskPlan(context) {
  return renderPlanner(context.model);
}

function renderTaskReset(context) {
  var seriesModel = context.model;
  var ecModel = context.ecModel;
  var api = context.api;
  var payload = context.payload; // FIXME: remove updateView updateVisual

  var progressiveRender = seriesModel.pipelineContext.progressiveRender;
  var view = context.view;
  var updateMethod = payload && inner(payload).updateMethod;
  var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod // `appendData` is also supported when data amount
  // is less than progressive threshold.
  : 'render';

  if (methodName !== 'render') {
    view[methodName](seriesModel, ecModel, api, payload);
  }

  return progressMethodMap[methodName];
}

var progressMethodMap = {
  incrementalPrepareRender: {
    progress: function (params, context) {
      context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
    }
  },
  render: {
    // Put view.render in `progress` to support appendData. But in this case
    // view.render should not be called in reset, otherwise it will be called
    // twise. Use `forceFirstProgress` to make sure that view.render is called
    // in any cases.
    forceFirstProgress: true,
    progress: function (params, context) {
      context.view.render(context.model, context.ecModel, context.api, context.payload);
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (ChartView);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = __extends;
/* unused harmony export __assign */
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* unused harmony export __spreadArray */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(76);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_graphic_Group_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_component_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_clazz_js__ = __webpack_require__(99);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var ComponentView =
/** @class */
function () {
  function ComponentView() {
    this.group = new __WEBPACK_IMPORTED_MODULE_0_zrender_lib_graphic_Group_js__["a" /* default */]();
    this.uid = __WEBPACK_IMPORTED_MODULE_1__util_component_js__["a" /* getUID */]('viewComponent');
  }

  ComponentView.prototype.init = function (ecModel, api) {};

  ComponentView.prototype.render = function (model, ecModel, api, payload) {};

  ComponentView.prototype.dispose = function (ecModel, api) {};

  ComponentView.prototype.updateView = function (model, ecModel, api, payload) {// Do nothing;
  };

  ComponentView.prototype.updateLayout = function (model, ecModel, api, payload) {// Do nothing;
  };

  ComponentView.prototype.updateVisual = function (model, ecModel, api, payload) {// Do nothing;
  };
  /**
   * Hook for toggle blur target series.
   * Can be used in marker for blur or leave blur the markers
   */


  ComponentView.prototype.toggleBlurSeries = function (seriesModels, isBlur, ecModel) {// Do nothing;
  };
  /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */


  ComponentView.prototype.eachRendered = function (cb) {
    var group = this.group;

    if (group) {
      group.traverse(cb);
    }
  };

  return ComponentView;
}();

;
__WEBPACK_IMPORTED_MODULE_2__util_clazz_js__["b" /* enableClassExtend */](ComponentView);
__WEBPACK_IMPORTED_MODULE_2__util_clazz_js__["e" /* enableClassManagement */](ComponentView);
/* harmony default export */ __webpack_exports__["a"] = (ComponentView);

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(16)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_env_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_clazz_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin_areaStyle_js__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixin_textStyle_js__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixin_lineStyle_js__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixin_itemStyle_js__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/








var Model =
/** @class */
function () {
  function Model(option, parentModel, ecModel) {
    this.parentModel = parentModel;
    this.ecModel = ecModel;
    this.option = option; // Simple optimization
    // if (this.init) {
    //     if (arguments.length <= 4) {
    //         this.init(option, parentModel, ecModel, extraOpt);
    //     }
    //     else {
    //         this.init.apply(this, arguments);
    //     }
    // }
  }

  Model.prototype.init = function (option, parentModel, ecModel) {
    var rest = [];

    for (var _i = 3; _i < arguments.length; _i++) {
      rest[_i - 3] = arguments[_i];
    }
  };
  /**
   * Merge the input option to me.
   */


  Model.prototype.mergeOption = function (option, ecModel) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["merge"])(this.option, option, true);
  }; // `path` can be 'xxx.yyy.zzz', so the return value type have to be `ModelOption`
  // TODO: TYPE strict key check?
  // get(path: string | string[], ignoreParent?: boolean): ModelOption;


  Model.prototype.get = function (path, ignoreParent) {
    if (path == null) {
      return this.option;
    }

    return this._doGet(this.parsePath(path), !ignoreParent && this.parentModel);
  };

  Model.prototype.getShallow = function (key, ignoreParent) {
    var option = this.option;
    var val = option == null ? option : option[key];

    if (val == null && !ignoreParent) {
      var parentModel = this.parentModel;

      if (parentModel) {
        // FIXME:TS do not know how to make it works
        val = parentModel.getShallow(key);
      }
    }

    return val;
  }; // `path` can be 'xxx.yyy.zzz', so the return value type have to be `Model<ModelOption>`
  // getModel(path: string | string[], parentModel?: Model): Model;
  // TODO 'xxx.yyy.zzz' is deprecated


  Model.prototype.getModel = function (path, parentModel) {
    var hasPath = path != null;
    var pathFinal = hasPath ? this.parsePath(path) : null;
    var obj = hasPath ? this._doGet(pathFinal) : this.option;
    parentModel = parentModel || this.parentModel && this.parentModel.getModel(this.resolveParentPath(pathFinal));
    return new Model(obj, parentModel, this.ecModel);
  };
  /**
   * If model has option
   */


  Model.prototype.isEmpty = function () {
    return this.option == null;
  };

  Model.prototype.restoreData = function () {}; // Pending


  Model.prototype.clone = function () {
    var Ctor = this.constructor;
    return new Ctor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["clone"])(this.option));
  }; // setReadOnly(properties): void {
  // clazzUtil.setReadOnly(this, properties);
  // }
  // If path is null/undefined, return null/undefined.


  Model.prototype.parsePath = function (path) {
    if (typeof path === 'string') {
      return path.split('.');
    }

    return path;
  }; // Resolve path for parent. Perhaps useful when parent use a different property.
  // Default to be a identity resolver.
  // Can be modified to a different resolver.


  Model.prototype.resolveParentPath = function (path) {
    return path;
  }; // FIXME:TS check whether put this method here


  Model.prototype.isAnimationEnabled = function () {
    if (!__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_env_js__["a" /* default */].node && this.option) {
      if (this.option.animation != null) {
        return !!this.option.animation;
      } else if (this.parentModel) {
        return this.parentModel.isAnimationEnabled();
      }
    }
  };

  Model.prototype._doGet = function (pathArr, parentModel) {
    var obj = this.option;

    if (!pathArr) {
      return obj;
    }

    for (var i = 0; i < pathArr.length; i++) {
      // Ignore empty
      if (!pathArr[i]) {
        continue;
      } // obj could be number/string/... (like 0)


      obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;

      if (obj == null) {
        break;
      }
    }

    if (obj == null && parentModel) {
      obj = parentModel._doGet(this.resolveParentPath(pathArr), parentModel.parentModel);
    }

    return obj;
  };

  return Model;
}();

; // Enable Model.extend.

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_clazz_js__["b" /* enableClassExtend */])(Model);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_clazz_js__["c" /* enableClassCheck */])(Model);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["mixin"])(Model, __WEBPACK_IMPORTED_MODULE_4__mixin_lineStyle_js__["a" /* LineStyleMixin */]);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["mixin"])(Model, __WEBPACK_IMPORTED_MODULE_5__mixin_itemStyle_js__["a" /* ItemStyleMixin */]);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["mixin"])(Model, __WEBPACK_IMPORTED_MODULE_2__mixin_areaStyle_js__["a" /* AreaStyleMixin */]);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["mixin"])(Model, __WEBPACK_IMPORTED_MODULE_3__mixin_textStyle_js__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (Model);

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(9);
var IE8_DOM_DEFINE = __webpack_require__(413);
var toPrimitive = __webpack_require__(84);
var dP = Object.defineProperty;

exports.f = __webpack_require__(31) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(82);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Browser = (function () {
    function Browser() {
        this.firefox = false;
        this.ie = false;
        this.edge = false;
        this.newEdge = false;
        this.weChat = false;
    }
    return Browser;
}());
var Env = (function () {
    function Env() {
        this.browser = new Browser();
        this.node = false;
        this.wxa = false;
        this.worker = false;
        this.svgSupported = false;
        this.touchEventsSupported = false;
        this.pointerEventsSupported = false;
        this.domSupported = false;
        this.transformSupported = false;
        this.transform3dSupported = false;
        this.hasGlobalWindow = typeof window !== 'undefined';
    }
    return Env;
}());
var env = new Env();
if (typeof wx === 'object' && typeof wx.getSystemInfoSync === 'function') {
    env.wxa = true;
    env.touchEventsSupported = true;
}
else if (typeof document === 'undefined' && typeof self !== 'undefined') {
    env.worker = true;
}
else if (typeof navigator === 'undefined') {
    env.node = true;
    env.svgSupported = true;
}
else {
    detect(navigator.userAgent, env);
}
function detect(ua, env) {
    var browser = env.browser;
    var firefox = ua.match(/Firefox\/([\d.]+)/);
    var ie = ua.match(/MSIE\s([\d.]+)/)
        || ua.match(/Trident\/.+?rv:(([\d.]+))/);
    var edge = ua.match(/Edge?\/([\d.]+)/);
    var weChat = (/micromessenger/i).test(ua);
    if (firefox) {
        browser.firefox = true;
        browser.version = firefox[1];
    }
    if (ie) {
        browser.ie = true;
        browser.version = ie[1];
    }
    if (edge) {
        browser.edge = true;
        browser.version = edge[1];
        browser.newEdge = +edge[1].split('.')[0] > 18;
    }
    if (weChat) {
        browser.weChat = true;
    }
    env.svgSupported = typeof SVGRect !== 'undefined';
    env.touchEventsSupported = 'ontouchstart' in window && !browser.ie && !browser.edge;
    env.pointerEventsSupported = 'onpointerdown' in window
        && (browser.edge || (browser.ie && +browser.version >= 11));
    env.domSupported = typeof document !== 'undefined';
    var style = document.documentElement.style;
    env.transform3dSupported = ((browser.ie && 'transition' in style)
        || browser.edge
        || (('WebKitCSSMatrix' in window) && ('m11' in new WebKitCSSMatrix()))
        || 'MozPerspective' in style)
        && !('OTransition' in style);
    env.transformSupported = env.transform3dSupported
        || (browser.ie && +browser.version >= 9);
}
/* harmony default export */ __webpack_exports__["a"] = (env);


/***/ }),
/* 36 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return symbolBuildProxies; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createSymbol;
/* harmony export (immutable) */ __webpack_exports__["c"] = normalizeSymbolSize;
/* harmony export (immutable) */ __webpack_exports__["d"] = normalizeSymbolOffset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_contain_text_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number_js__ = __webpack_require__(8);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Symbol factory





/**
 * Triangle shape
 * @inner
 */

var Triangle = __WEBPACK_IMPORTED_MODULE_1__graphic_js__["Path"].extend({
  type: 'triangle',
  shape: {
    cx: 0,
    cy: 0,
    width: 0,
    height: 0
  },
  buildPath: function (path, shape) {
    var cx = shape.cx;
    var cy = shape.cy;
    var width = shape.width / 2;
    var height = shape.height / 2;
    path.moveTo(cx, cy - height);
    path.lineTo(cx + width, cy + height);
    path.lineTo(cx - width, cy + height);
    path.closePath();
  }
});
/**
 * Diamond shape
 * @inner
 */

var Diamond = __WEBPACK_IMPORTED_MODULE_1__graphic_js__["Path"].extend({
  type: 'diamond',
  shape: {
    cx: 0,
    cy: 0,
    width: 0,
    height: 0
  },
  buildPath: function (path, shape) {
    var cx = shape.cx;
    var cy = shape.cy;
    var width = shape.width / 2;
    var height = shape.height / 2;
    path.moveTo(cx, cy - height);
    path.lineTo(cx + width, cy);
    path.lineTo(cx, cy + height);
    path.lineTo(cx - width, cy);
    path.closePath();
  }
});
/**
 * Pin shape
 * @inner
 */

var Pin = __WEBPACK_IMPORTED_MODULE_1__graphic_js__["Path"].extend({
  type: 'pin',
  shape: {
    // x, y on the cusp
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  buildPath: function (path, shape) {
    var x = shape.x;
    var y = shape.y;
    var w = shape.width / 5 * 3; // Height must be larger than width

    var h = Math.max(w, shape.height);
    var r = w / 2; // Dist on y with tangent point and circle center

    var dy = r * r / (h - r);
    var cy = y - h + r + dy;
    var angle = Math.asin(dy / r); // Dist on x with tangent point and circle center

    var dx = Math.cos(angle) * r;
    var tanX = Math.sin(angle);
    var tanY = Math.cos(angle);
    var cpLen = r * 0.6;
    var cpLen2 = r * 0.7;
    path.moveTo(x - dx, cy + dy);
    path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
    path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
    path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
    path.closePath();
  }
});
/**
 * Arrow shape
 * @inner
 */

var Arrow = __WEBPACK_IMPORTED_MODULE_1__graphic_js__["Path"].extend({
  type: 'arrow',
  shape: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  buildPath: function (ctx, shape) {
    var height = shape.height;
    var width = shape.width;
    var x = shape.x;
    var y = shape.y;
    var dx = width / 3 * 2;
    ctx.moveTo(x, y);
    ctx.lineTo(x + dx, y + height);
    ctx.lineTo(x, y + height / 4 * 3);
    ctx.lineTo(x - dx, y + height);
    ctx.lineTo(x, y);
    ctx.closePath();
  }
});
/**
 * Map of path contructors
 */
// TODO Use function to build symbol path.

var symbolCtors = {
  line: __WEBPACK_IMPORTED_MODULE_1__graphic_js__["Line"],
  rect: __WEBPACK_IMPORTED_MODULE_1__graphic_js__["Rect"],
  roundRect: __WEBPACK_IMPORTED_MODULE_1__graphic_js__["Rect"],
  square: __WEBPACK_IMPORTED_MODULE_1__graphic_js__["Rect"],
  circle: __WEBPACK_IMPORTED_MODULE_1__graphic_js__["Circle"],
  diamond: Diamond,
  pin: Pin,
  arrow: Arrow,
  triangle: Triangle
};
var symbolShapeMakers = {
  line: function (x, y, w, h, shape) {
    shape.x1 = x;
    shape.y1 = y + h / 2;
    shape.x2 = x + w;
    shape.y2 = y + h / 2;
  },
  rect: function (x, y, w, h, shape) {
    shape.x = x;
    shape.y = y;
    shape.width = w;
    shape.height = h;
  },
  roundRect: function (x, y, w, h, shape) {
    shape.x = x;
    shape.y = y;
    shape.width = w;
    shape.height = h;
    shape.r = Math.min(w, h) / 4;
  },
  square: function (x, y, w, h, shape) {
    var size = Math.min(w, h);
    shape.x = x;
    shape.y = y;
    shape.width = size;
    shape.height = size;
  },
  circle: function (x, y, w, h, shape) {
    // Put circle in the center of square
    shape.cx = x + w / 2;
    shape.cy = y + h / 2;
    shape.r = Math.min(w, h) / 2;
  },
  diamond: function (x, y, w, h, shape) {
    shape.cx = x + w / 2;
    shape.cy = y + h / 2;
    shape.width = w;
    shape.height = h;
  },
  pin: function (x, y, w, h, shape) {
    shape.x = x + w / 2;
    shape.y = y + h / 2;
    shape.width = w;
    shape.height = h;
  },
  arrow: function (x, y, w, h, shape) {
    shape.x = x + w / 2;
    shape.y = y + h / 2;
    shape.width = w;
    shape.height = h;
  },
  triangle: function (x, y, w, h, shape) {
    shape.cx = x + w / 2;
    shape.cy = y + h / 2;
    shape.width = w;
    shape.height = h;
  }
};
var symbolBuildProxies = {};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(symbolCtors, function (Ctor, name) {
  symbolBuildProxies[name] = new Ctor();
});
var SymbolClz = __WEBPACK_IMPORTED_MODULE_1__graphic_js__["Path"].extend({
  type: 'symbol',
  shape: {
    symbolType: '',
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  calculateTextPosition: function (out, config, rect) {
    var res = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_contain_text_js__["a" /* calculateTextPosition */])(out, config, rect);
    var shape = this.shape;

    if (shape && shape.symbolType === 'pin' && config.position === 'inside') {
      res.y = rect.y + rect.height * 0.4;
    }

    return res;
  },
  buildPath: function (ctx, shape, inBundle) {
    var symbolType = shape.symbolType;

    if (symbolType !== 'none') {
      var proxySymbol = symbolBuildProxies[symbolType];

      if (!proxySymbol) {
        // Default rect
        symbolType = 'rect';
        proxySymbol = symbolBuildProxies[symbolType];
      }

      symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
      proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
    }
  }
}); // Provide setColor helper method to avoid determine if set the fill or stroke outside

function symbolPathSetColor(color, innerColor) {
  if (this.type !== 'image') {
    var symbolStyle = this.style;

    if (this.__isEmptyBrush) {
      symbolStyle.stroke = color;
      symbolStyle.fill = innerColor || '#fff'; // TODO Same width with lineStyle in LineView

      symbolStyle.lineWidth = 2;
    } else if (this.shape.symbolType === 'line') {
      symbolStyle.stroke = color;
    } else {
      symbolStyle.fill = color;
    }

    this.markRedraw();
  }
}
/**
 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
 */


function createSymbol(symbolType, x, y, w, h, color, // whether to keep the ratio of w/h,
keepAspect) {
  // TODO Support image object, DynamicImage.
  var isEmpty = symbolType.indexOf('empty') === 0;

  if (isEmpty) {
    symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
  }

  var symbolPath;

  if (symbolType.indexOf('image://') === 0) {
    symbolPath = __WEBPACK_IMPORTED_MODULE_1__graphic_js__["makeImage"](symbolType.slice(8), new __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_BoundingRect_js__["a" /* default */](x, y, w, h), keepAspect ? 'center' : 'cover');
  } else if (symbolType.indexOf('path://') === 0) {
    symbolPath = __WEBPACK_IMPORTED_MODULE_1__graphic_js__["makePath"](symbolType.slice(7), {}, new __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_BoundingRect_js__["a" /* default */](x, y, w, h), keepAspect ? 'center' : 'cover');
  } else {
    symbolPath = new SymbolClz({
      shape: {
        symbolType: symbolType,
        x: x,
        y: y,
        width: w,
        height: h
      }
    });
  }

  symbolPath.__isEmptyBrush = isEmpty; // TODO Should deprecate setColor

  symbolPath.setColor = symbolPathSetColor;

  if (color) {
    symbolPath.setColor(color);
  }

  return symbolPath;
}
function normalizeSymbolSize(symbolSize) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"])(symbolSize)) {
    symbolSize = [+symbolSize, +symbolSize];
  }

  return [symbolSize[0] || 0, symbolSize[1] || 0];
}
function normalizeSymbolOffset(symbolOffset, symbolSize) {
  if (symbolOffset == null) {
    return;
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"])(symbolOffset)) {
    symbolOffset = [symbolOffset, symbolOffset];
  }

  return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__number_js__["a" /* parsePercent */])(symbolOffset[0], symbolSize[0]) || 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__number_js__["a" /* parsePercent */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve2"])(symbolOffset[1], symbolOffset[0]), symbolSize[1]) || 0];
}

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(764), __esModule: true };

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export transitionStore */
/* harmony export (immutable) */ __webpack_exports__["d"] = getAnimationConfig;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateProps; });
/* harmony export (immutable) */ __webpack_exports__["b"] = initProps;
/* harmony export (immutable) */ __webpack_exports__["c"] = isElementRemoved;
/* harmony export (immutable) */ __webpack_exports__["g"] = removeElement;
/* harmony export (immutable) */ __webpack_exports__["h"] = removeElementWithFadeOut;
/* harmony export (immutable) */ __webpack_exports__["f"] = saveOldStyle;
/* harmony export (immutable) */ __webpack_exports__["e"] = getOldStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

 // Stored properties for further transition.

var transitionStore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_model_js__["a" /* makeInner */])();
/**
 * Return null if animation is disabled.
 */

function getAnimationConfig(animationType, animatableModel, dataIndex, // Extra opts can override the option in animatable model.
extraOpts, // TODO It's only for pictorial bar now.
extraDelayParams) {
  var animationPayload; // Check if there is global animation configuration from dataZoom/resize can override the config in option.
  // If animation is enabled. Will use this animation config in payload.
  // If animation is disabled. Just ignore it.

  if (animatableModel && animatableModel.ecModel) {
    var updatePayload = animatableModel.ecModel.getUpdatePayload();
    animationPayload = updatePayload && updatePayload.animation;
  }

  var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
  var isUpdate = animationType === 'update';

  if (animationEnabled) {
    var duration = void 0;
    var easing = void 0;
    var delay = void 0;

    if (extraOpts) {
      duration = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve2"])(extraOpts.duration, 200);
      easing = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve2"])(extraOpts.easing, 'cubicOut');
      delay = 0;
    } else {
      duration = animatableModel.getShallow(isUpdate ? 'animationDurationUpdate' : 'animationDuration');
      easing = animatableModel.getShallow(isUpdate ? 'animationEasingUpdate' : 'animationEasing');
      delay = animatableModel.getShallow(isUpdate ? 'animationDelayUpdate' : 'animationDelay');
    } // animation from payload has highest priority.


    if (animationPayload) {
      animationPayload.duration != null && (duration = animationPayload.duration);
      animationPayload.easing != null && (easing = animationPayload.easing);
      animationPayload.delay != null && (delay = animationPayload.delay);
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"])(delay)) {
      delay = delay(dataIndex, extraDelayParams);
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"])(duration)) {
      duration = duration(dataIndex);
    }

    var config = {
      duration: duration || 0,
      delay: delay,
      easing: easing
    };
    return config;
  } else {
    return null;
  }
}

function animateOrSetProps(animationType, el, props, animatableModel, dataIndex, cb, during) {
  var isFrom = false;
  var removeOpt;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"])(dataIndex)) {
    during = cb;
    cb = dataIndex;
    dataIndex = null;
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"])(dataIndex)) {
    cb = dataIndex.cb;
    during = dataIndex.during;
    isFrom = dataIndex.isFrom;
    removeOpt = dataIndex.removeOpt;
    dataIndex = dataIndex.dataIndex;
  }

  var isRemove = animationType === 'leave';

  if (!isRemove) {
    // Must stop the remove animation.
    el.stopAnimation('leave');
  }

  var animationConfig = getAnimationConfig(animationType, animatableModel, dataIndex, isRemove ? removeOpt || {} : null, animatableModel && animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);

  if (animationConfig && animationConfig.duration > 0) {
    var duration = animationConfig.duration;
    var animationDelay = animationConfig.delay;
    var animationEasing = animationConfig.easing;
    var animateConfig = {
      duration: duration,
      delay: animationDelay || 0,
      easing: animationEasing,
      done: cb,
      force: !!cb || !!during,
      // Set to final state in update/init animation.
      // So the post processing based on the path shape can be done correctly.
      setToFinal: !isRemove,
      scope: animationType,
      during: during
    };
    isFrom ? el.animateFrom(props, animateConfig) : el.animateTo(props, animateConfig);
  } else {
    el.stopAnimation(); // If `isFrom`, the props is the "from" props.

    !isFrom && el.attr(props); // Call during at least once.

    during && during(1);
    cb && cb();
  }
}
/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */


function updateProps(el, props, // TODO: TYPE AnimatableModel
animatableModel, dataIndex, cb, during) {
  animateOrSetProps('update', el, props, animatableModel, dataIndex, cb, during);
}


/**
 * Init graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 */

function initProps(el, props, animatableModel, dataIndex, cb, during) {
  animateOrSetProps('enter', el, props, animatableModel, dataIndex, cb, during);
}
/**
 * If element is removed.
 * It can determine if element is having remove animation.
 */

function isElementRemoved(el) {
  if (!el.__zr) {
    return true;
  }

  for (var i = 0; i < el.animators.length; i++) {
    var animator = el.animators[i];

    if (animator.scope === 'leave') {
      return true;
    }
  }

  return false;
}
/**
 * Remove graphic element
 */

function removeElement(el, props, animatableModel, dataIndex, cb, during) {
  // Don't do remove animation twice.
  if (isElementRemoved(el)) {
    return;
  }

  animateOrSetProps('leave', el, props, animatableModel, dataIndex, cb, during);
}

function fadeOutDisplayable(el, animatableModel, dataIndex, done) {
  el.removeTextContent();
  el.removeTextGuideLine();
  removeElement(el, {
    style: {
      opacity: 0
    }
  }, animatableModel, dataIndex, done);
}

function removeElementWithFadeOut(el, animatableModel, dataIndex) {
  function doRemove() {
    el.parent && el.parent.remove(el);
  } // Hide label and labelLine first
  // TODO Also use fade out animation?


  if (!el.isGroup) {
    fadeOutDisplayable(el, animatableModel, dataIndex, doRemove);
  } else {
    el.traverse(function (disp) {
      if (!disp.isGroup) {
        // Can invoke doRemove multiple times.
        fadeOutDisplayable(disp, animatableModel, dataIndex, doRemove);
      }
    });
  }
}
/**
 * Save old style for style transition in universalTransition module.
 * It's used when element will be reused in each render.
 * For chart like map, heatmap, which will always create new element.
 * We don't need to save this because universalTransition can get old style from the old element
 */

function saveOldStyle(el) {
  transitionStore(el).oldStyle = el.style;
}
function getOldStyle(el) {
  return transitionStore(el).oldStyle;
}

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = use;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_Component_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_Component_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_Series_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_impl_js__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_zrender_lib_zrender_js__ = __webpack_require__(364);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/








var extensions = [];
var extensionRegisters = {
  registerPreprocessor: __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["b" /* registerPreprocessor */],
  registerProcessor: __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["c" /* registerProcessor */],
  registerPostInit: __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["d" /* registerPostInit */],
  registerPostUpdate: __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["e" /* registerPostUpdate */],
  registerUpdateLifecycle: __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["f" /* registerUpdateLifecycle */],
  registerAction: __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["a" /* registerAction */],
  registerCoordinateSystem: __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["g" /* registerCoordinateSystem */],
  registerLayout: __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["h" /* registerLayout */],
  registerVisual: __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["i" /* registerVisual */],
  registerTransform: __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["j" /* registerTransform */],
  registerLoading: __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["k" /* registerLoading */],
  registerMap: __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["l" /* registerMap */],
  registerImpl: __WEBPACK_IMPORTED_MODULE_6__core_impl_js__["b" /* registerImpl */],
  PRIORITY: __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["m" /* PRIORITY */],
  ComponentModel: __WEBPACK_IMPORTED_MODULE_3__model_Component_js__["a" /* default */],
  ComponentView: __WEBPACK_IMPORTED_MODULE_1__view_Component_js__["a" /* default */],
  SeriesModel: __WEBPACK_IMPORTED_MODULE_4__model_Series_js__["b" /* default */],
  ChartView: __WEBPACK_IMPORTED_MODULE_2__view_Chart_js__["a" /* default */],
  // TODO Use ComponentModel and SeriesModel instead of Constructor
  registerComponentModel: function (ComponentModelClass) {
    __WEBPACK_IMPORTED_MODULE_3__model_Component_js__["a" /* default */].registerClass(ComponentModelClass);
  },
  registerComponentView: function (ComponentViewClass) {
    __WEBPACK_IMPORTED_MODULE_1__view_Component_js__["a" /* default */].registerClass(ComponentViewClass);
  },
  registerSeriesModel: function (SeriesModelClass) {
    __WEBPACK_IMPORTED_MODULE_4__model_Series_js__["b" /* default */].registerClass(SeriesModelClass);
  },
  registerChartView: function (ChartViewClass) {
    __WEBPACK_IMPORTED_MODULE_2__view_Chart_js__["a" /* default */].registerClass(ChartViewClass);
  },
  registerSubTypeDefaulter: function (componentType, defaulter) {
    __WEBPACK_IMPORTED_MODULE_3__model_Component_js__["a" /* default */].registerSubTypeDefaulter(componentType, defaulter);
  },
  registerPainter: function (painterType, PainterCtor) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_zrender_js__["registerPainter"])(painterType, PainterCtor);
  }
};
function use(ext) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["isArray"])(ext)) {
    // use([ChartLine, ChartBar]);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["each"])(ext, function (singleExt) {
      use(singleExt);
    });
    return;
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["indexOf"])(extensions, ext) >= 0) {
    return;
  }

  extensions.push(ext);

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["isFunction"])(ext)) {
    ext = {
      install: ext
    };
  }

  ext.install(extensionRegisters);
}

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = addCommas;
/* harmony export (immutable) */ __webpack_exports__["i"] = toCamelCase;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return normalizeCssArray; });
/* harmony export (immutable) */ __webpack_exports__["b"] = encodeHTML;
/* harmony export (immutable) */ __webpack_exports__["c"] = makeValueReadable;
/* harmony export (immutable) */ __webpack_exports__["a"] = formatTpl;
/* harmony export (immutable) */ __webpack_exports__["j"] = formatTplSimple;
/* harmony export (immutable) */ __webpack_exports__["e"] = getTooltipMarker;
/* harmony export (immutable) */ __webpack_exports__["k"] = formatTime;
/* harmony export (immutable) */ __webpack_exports__["l"] = capitalFirst;
/* harmony export (immutable) */ __webpack_exports__["d"] = convertToColorString;
/* harmony export (immutable) */ __webpack_exports__["h"] = windowOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__time_js__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_graphic_helper_parseText_js__ = __webpack_require__(588);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_4_zrender_lib_graphic_helper_parseText_js__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__legacy_getTextRect_js__ = __webpack_require__(1346);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_5__legacy_getTextRect_js__["a"]; });

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




/**
 * Add a comma each three digit.
 */

function addCommas(x) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number_js__["b" /* isNumeric */])(x)) {
    return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"](x) ? x : '-';
  }

  var parts = (x + '').split('.');
  return parts[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (parts.length > 1 ? '.' + parts[1] : '');
}
function toCamelCase(str, upperCaseFirst) {
  str = (str || '').toLowerCase().replace(/-(.)/g, function (match, group1) {
    return group1.toUpperCase();
  });

  if (upperCaseFirst && str) {
    str = str.charAt(0).toUpperCase() + str.slice(1);
  }

  return str;
}
var normalizeCssArray = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["normalizeCssArray"];
var replaceReg = /([&<>"'])/g;
var replaceMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '\'': '&#39;'
};
function encodeHTML(source) {
  return source == null ? '' : (source + '').replace(replaceReg, function (str, c) {
    return replaceMap[c];
  });
}
/**
 * Make value user readable for tooltip and label.
 * "User readable":
 *     Try to not print programmer-specific text like NaN, Infinity, null, undefined.
 *     Avoid to display an empty string, which users can not recognize there is
 *     a value and it might look like a bug.
 */

function makeValueReadable(value, valueType, useUTC) {
  var USER_READABLE_DEFUALT_TIME_PATTERN = '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss}';

  function stringToUserReadable(str) {
    return str && __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["trim"](str) ? str : '-';
  }

  function isNumberUserReadable(num) {
    return !!(num != null && !isNaN(num) && isFinite(num));
  }

  var isTypeTime = valueType === 'time';
  var isValueDate = value instanceof Date;

  if (isTypeTime || isValueDate) {
    var date = isTypeTime ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number_js__["f" /* parseDate */])(value) : value;

    if (!isNaN(+date)) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__time_js__["a" /* format */])(date, USER_READABLE_DEFUALT_TIME_PATTERN, useUTC);
    } else if (isValueDate) {
      return '-';
    } // In other cases, continue to try to display the value in the following code.

  }

  if (valueType === 'ordinal') {
    return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isStringSafe"](value) ? stringToUserReadable(value) : __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isNumber"](value) ? isNumberUserReadable(value) ? value + '' : '-' : '-';
  } // By default.


  var numericResult = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number_js__["g" /* numericToNumber */])(value);
  return isNumberUserReadable(numericResult) ? addCommas(numericResult) : __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isStringSafe"](value) ? stringToUserReadable(value) : typeof value === 'boolean' ? value + '' : '-';
}
var TPL_VAR_ALIAS = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];

var wrapVar = function (varName, seriesIdx) {
  return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
};
/**
 * Template formatter
 * @param {Array.<Object>|Object} paramsList
 */


function formatTpl(tpl, paramsList, encode) {
  if (!__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](paramsList)) {
    paramsList = [paramsList];
  }

  var seriesLen = paramsList.length;

  if (!seriesLen) {
    return '';
  }

  var $vars = paramsList[0].$vars || [];

  for (var i = 0; i < $vars.length; i++) {
    var alias = TPL_VAR_ALIAS[i];
    tpl = tpl.replace(wrapVar(alias), wrapVar(alias, 0));
  }

  for (var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++) {
    for (var k = 0; k < $vars.length; k++) {
      var val = paramsList[seriesIdx][$vars[k]];
      tpl = tpl.replace(wrapVar(TPL_VAR_ALIAS[k], seriesIdx), encode ? encodeHTML(val) : val);
    }
  }

  return tpl;
}
/**
 * simple Template formatter
 */

function formatTplSimple(tpl, param, encode) {
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](param, function (value, key) {
    tpl = tpl.replace('{' + key + '}', encode ? encodeHTML(value) : value);
  });
  return tpl;
}
function getTooltipMarker(inOpt, extraCssText) {
  var opt = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"](inOpt) ? {
    color: inOpt,
    extraCssText: extraCssText
  } : inOpt || {};
  var color = opt.color;
  var type = opt.type;
  extraCssText = opt.extraCssText;
  var renderMode = opt.renderMode || 'html';

  if (!color) {
    return '';
  }

  if (renderMode === 'html') {
    return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;' + 'border-radius:4px;width:4px;height:4px;background-color:' // Only support string
    + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:4px;' + 'border-radius:10px;width:10px;height:10px;background-color:' + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>';
  } else {
    // Should better not to auto generate style name by auto-increment number here.
    // Because this util is usually called in tooltip formatter, which is probably
    // called repeatly when mouse move and the auto-increment number increases fast.
    // Users can make their own style name by theirselves, make it unique and readable.
    var markerId = opt.markerId || 'markerX';
    return {
      renderMode: renderMode,
      content: '{' + markerId + '|}  ',
      style: type === 'subItem' ? {
        width: 4,
        height: 4,
        borderRadius: 2,
        backgroundColor: color
      } : {
        width: 10,
        height: 10,
        borderRadius: 5,
        backgroundColor: color
      }
    };
  }
}
/**
 * @deprecated Use `time/format` instead.
 * ISO Date format
 * @param {string} tpl
 * @param {number} value
 * @param {boolean} [isUTC=false] Default in local time.
 *           see `module:echarts/scale/Time`
 *           and `module:echarts/util/number#parseDate`.
 * @inner
 */

function formatTime(tpl, value, isUTC) {
  if (true) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__log_js__["a" /* deprecateReplaceLog */])('echarts.format.formatTime', 'echarts.time.format');
  }

  if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') {
    tpl = 'MM-dd\nyyyy';
  }

  var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number_js__["f" /* parseDate */])(value);
  var getUTC = isUTC ? 'getUTC' : 'get';
  var y = date[getUTC + 'FullYear']();
  var M = date[getUTC + 'Month']() + 1;
  var d = date[getUTC + 'Date']();
  var h = date[getUTC + 'Hours']();
  var m = date[getUTC + 'Minutes']();
  var s = date[getUTC + 'Seconds']();
  var S = date[getUTC + 'Milliseconds']();
  tpl = tpl.replace('MM', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__time_js__["b" /* pad */])(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', y % 100 + '').replace('dd', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__time_js__["b" /* pad */])(d, 2)).replace('d', d).replace('hh', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__time_js__["b" /* pad */])(h, 2)).replace('h', h).replace('mm', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__time_js__["b" /* pad */])(m, 2)).replace('m', m).replace('ss', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__time_js__["b" /* pad */])(s, 2)).replace('s', s).replace('SSS', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__time_js__["b" /* pad */])(S, 3));
  return tpl;
}
/**
 * Capital first
 * @param {string} str
 * @return {string}
 */

function capitalFirst(str) {
  return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
}
/**
 * @return Never be null/undefined.
 */

function convertToColorString(color, defaultColor) {
  defaultColor = defaultColor || 'transparent';
  return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"](color) ? color : __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"](color) ? color.colorStops && (color.colorStops[0] || {}).color || defaultColor : defaultColor;
}

/**
 * open new tab
 * @param link url
 * @param target blank or self
 */

function windowOpen(link, target) {
  /* global window */
  if (target === '_blank' || target === 'blank') {
    var blank = window.open();
    blank.opener = null;
    blank.location.href = link;
  } else {
    window.open(link, target);
  }
}


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["create"] = create;
/* harmony export (immutable) */ __webpack_exports__["identity"] = identity;
/* harmony export (immutable) */ __webpack_exports__["copy"] = copy;
/* harmony export (immutable) */ __webpack_exports__["mul"] = mul;
/* harmony export (immutable) */ __webpack_exports__["translate"] = translate;
/* harmony export (immutable) */ __webpack_exports__["rotate"] = rotate;
/* harmony export (immutable) */ __webpack_exports__["scale"] = scale;
/* harmony export (immutable) */ __webpack_exports__["invert"] = invert;
/* harmony export (immutable) */ __webpack_exports__["clone"] = clone;
function create() {
    return [1, 0, 0, 1, 0, 0];
}
function identity(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
}
function copy(out, m) {
    out[0] = m[0];
    out[1] = m[1];
    out[2] = m[2];
    out[3] = m[3];
    out[4] = m[4];
    out[5] = m[5];
    return out;
}
function mul(out, m1, m2) {
    var out0 = m1[0] * m2[0] + m1[2] * m2[1];
    var out1 = m1[1] * m2[0] + m1[3] * m2[1];
    var out2 = m1[0] * m2[2] + m1[2] * m2[3];
    var out3 = m1[1] * m2[2] + m1[3] * m2[3];
    var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
    var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = out3;
    out[4] = out4;
    out[5] = out5;
    return out;
}
function translate(out, a, v) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4] + v[0];
    out[5] = a[5] + v[1];
    return out;
}
function rotate(out, a, rad) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var st = Math.sin(rad);
    var ct = Math.cos(rad);
    out[0] = aa * ct + ab * st;
    out[1] = -aa * st + ab * ct;
    out[2] = ac * ct + ad * st;
    out[3] = -ac * st + ct * ad;
    out[4] = ct * atx + st * aty;
    out[5] = ct * aty - st * atx;
    return out;
}
function scale(out, a, v) {
    var vx = v[0];
    var vy = v[1];
    out[0] = a[0] * vx;
    out[1] = a[1] * vy;
    out[2] = a[2] * vx;
    out[3] = a[3] * vy;
    out[4] = a[4] * vx;
    out[5] = a[5] * vy;
    return out;
}
function invert(out, a) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var det = aa * ad - ab * ac;
    if (!det) {
        return null;
    }
    det = 1.0 / det;
    out[0] = ad * det;
    out[1] = -ab * det;
    out[2] = -ac * det;
    out[3] = aa * det;
    out[4] = (ac * aty - ad * atx) * det;
    out[5] = (ab * atx - aa * aty) * det;
    return out;
}
function clone(a) {
    var b = create();
    copy(b, a);
    return b;
}


/***/ }),
/* 44 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(277)('wks');
var uid = __webpack_require__(213);
var Symbol = __webpack_require__(44).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getWidth;
/* unused harmony export innerGetBoundingRect */
/* harmony export (immutable) */ __webpack_exports__["g"] = getBoundingRect;
/* harmony export (immutable) */ __webpack_exports__["d"] = adjustTextX;
/* harmony export (immutable) */ __webpack_exports__["c"] = adjustTextY;
/* harmony export (immutable) */ __webpack_exports__["f"] = getLineHeight;
/* unused harmony export measureText */
/* harmony export (immutable) */ __webpack_exports__["b"] = parsePercent;
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateTextPosition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_LRU_js__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_platform_js__ = __webpack_require__(67);



var textWidthCache = {};
function getWidth(text, font) {
    font = font || __WEBPACK_IMPORTED_MODULE_2__core_platform_js__["b" /* DEFAULT_FONT */];
    var cacheOfFont = textWidthCache[font];
    if (!cacheOfFont) {
        cacheOfFont = textWidthCache[font] = new __WEBPACK_IMPORTED_MODULE_1__core_LRU_js__["a" /* default */](500);
    }
    var width = cacheOfFont.get(text);
    if (width == null) {
        width = __WEBPACK_IMPORTED_MODULE_2__core_platform_js__["a" /* platformApi */].measureText(text, font).width;
        cacheOfFont.put(text, width);
    }
    return width;
}
function innerGetBoundingRect(text, font, textAlign, textBaseline) {
    var width = getWidth(text, font);
    var height = getLineHeight(font);
    var x = adjustTextX(0, width, textAlign);
    var y = adjustTextY(0, height, textBaseline);
    var rect = new __WEBPACK_IMPORTED_MODULE_0__core_BoundingRect_js__["a" /* default */](x, y, width, height);
    return rect;
}
function getBoundingRect(text, font, textAlign, textBaseline) {
    var textLines = ((text || '') + '').split('\n');
    var len = textLines.length;
    if (len === 1) {
        return innerGetBoundingRect(textLines[0], font, textAlign, textBaseline);
    }
    else {
        var uniondRect = new __WEBPACK_IMPORTED_MODULE_0__core_BoundingRect_js__["a" /* default */](0, 0, 0, 0);
        for (var i = 0; i < textLines.length; i++) {
            var rect = innerGetBoundingRect(textLines[i], font, textAlign, textBaseline);
            i === 0 ? uniondRect.copy(rect) : uniondRect.union(rect);
        }
        return uniondRect;
    }
}
function adjustTextX(x, width, textAlign) {
    if (textAlign === 'right') {
        x -= width;
    }
    else if (textAlign === 'center') {
        x -= width / 2;
    }
    return x;
}
function adjustTextY(y, height, verticalAlign) {
    if (verticalAlign === 'middle') {
        y -= height / 2;
    }
    else if (verticalAlign === 'bottom') {
        y -= height;
    }
    return y;
}
function getLineHeight(font) {
    return getWidth('国', font);
}
function measureText(text, font) {
    return __WEBPACK_IMPORTED_MODULE_2__core_platform_js__["a" /* platformApi */].measureText(text, font);
}
function parsePercent(value, maxValue) {
    if (typeof value === 'string') {
        if (value.lastIndexOf('%') >= 0) {
            return parseFloat(value) / 100 * maxValue;
        }
        return parseFloat(value);
    }
    return value;
}
function calculateTextPosition(out, opts, rect) {
    var textPosition = opts.position || 'inside';
    var distance = opts.distance != null ? opts.distance : 5;
    var height = rect.height;
    var width = rect.width;
    var halfHeight = height / 2;
    var x = rect.x;
    var y = rect.y;
    var textAlign = 'left';
    var textVerticalAlign = 'top';
    if (textPosition instanceof Array) {
        x += parsePercent(textPosition[0], rect.width);
        y += parsePercent(textPosition[1], rect.height);
        textAlign = null;
        textVerticalAlign = null;
    }
    else {
        switch (textPosition) {
            case 'left':
                x -= distance;
                y += halfHeight;
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            case 'right':
                x += distance + width;
                y += halfHeight;
                textVerticalAlign = 'middle';
                break;
            case 'top':
                x += width / 2;
                y -= distance;
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'bottom':
                x += width / 2;
                y += height + distance;
                textAlign = 'center';
                break;
            case 'inside':
                x += width / 2;
                y += halfHeight;
                textAlign = 'center';
                textVerticalAlign = 'middle';
                break;
            case 'insideLeft':
                x += distance;
                y += halfHeight;
                textVerticalAlign = 'middle';
                break;
            case 'insideRight':
                x += width - distance;
                y += halfHeight;
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            case 'insideTop':
                x += width / 2;
                y += distance;
                textAlign = 'center';
                break;
            case 'insideBottom':
                x += width / 2;
                y += height - distance;
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'insideTopLeft':
                x += distance;
                y += distance;
                break;
            case 'insideTopRight':
                x += width - distance;
                y += distance;
                textAlign = 'right';
                break;
            case 'insideBottomLeft':
                x += distance;
                y += height - distance;
                textVerticalAlign = 'bottom';
                break;
            case 'insideBottomRight':
                x += width - distance;
                y += height - distance;
                textAlign = 'right';
                textVerticalAlign = 'bottom';
                break;
        }
    }
    out = out || {};
    out.x = x;
    out.y = y;
    out.align = textAlign;
    out.verticalAlign = textVerticalAlign;
    return out;
}


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createTooltipMarkup;
/* harmony export (immutable) */ __webpack_exports__["d"] = buildTooltipMarkup;
/* harmony export (immutable) */ __webpack_exports__["a"] = retrieveVisualColorForTooltipMarker;
/* harmony export (immutable) */ __webpack_exports__["e"] = getPaddingFromTooltipModel;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TooltipMarkupStyleCreator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_format_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_helper_dataValueHelper_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_number_js__ = __webpack_require__(8);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var TOOLTIP_LINE_HEIGHT_CSS = 'line-height:1'; // TODO: more textStyle option

function getTooltipTextStyle(textStyle, renderMode) {
  var nameFontColor = textStyle.color || '#6e7079';
  var nameFontSize = textStyle.fontSize || 12;
  var nameFontWeight = textStyle.fontWeight || '400';
  var valueFontColor = textStyle.color || '#464646';
  var valueFontSize = textStyle.fontSize || 14;
  var valueFontWeight = textStyle.fontWeight || '900';

  if (renderMode === 'html') {
    // `textStyle` is probably from user input, should be encoded to reduce security risk.
    return {
      // eslint-disable-next-line max-len
      nameStyle: "font-size:" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_format_js__["b" /* encodeHTML */])(nameFontSize + '') + "px;color:" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_format_js__["b" /* encodeHTML */])(nameFontColor) + ";font-weight:" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_format_js__["b" /* encodeHTML */])(nameFontWeight + ''),
      // eslint-disable-next-line max-len
      valueStyle: "font-size:" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_format_js__["b" /* encodeHTML */])(valueFontSize + '') + "px;color:" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_format_js__["b" /* encodeHTML */])(valueFontColor) + ";font-weight:" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_format_js__["b" /* encodeHTML */])(valueFontWeight + '')
    };
  } else {
    return {
      nameStyle: {
        fontSize: nameFontSize,
        fill: nameFontColor,
        fontWeight: nameFontWeight
      },
      valueStyle: {
        fontSize: valueFontSize,
        fill: valueFontColor,
        fontWeight: valueFontWeight
      }
    };
  }
} // See `TooltipMarkupLayoutIntent['innerGapLevel']`.
// (value from UI design)


var HTML_GAPS = [0, 10, 20, 30];
var RICH_TEXT_GAPS = ['', '\n', '\n\n', '\n\n\n']; // eslint-disable-next-line max-len

function createTooltipMarkup(type, option) {
  option.type = type;
  return option;
}

function isSectionFragment(frag) {
  return frag.type === 'section';
}

function getBuilder(frag) {
  return isSectionFragment(frag) ? buildSection : buildNameValue;
}

function getBlockGapLevel(frag) {
  if (isSectionFragment(frag)) {
    var gapLevel_1 = 0;
    var subBlockLen = frag.blocks.length;
    var hasInnerGap_1 = subBlockLen > 1 || subBlockLen > 0 && !frag.noHeader;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(frag.blocks, function (subBlock) {
      var subGapLevel = getBlockGapLevel(subBlock); // If the some of the sub-blocks have some gaps (like 10px) inside, this block
      // should use a larger gap (like 20px) to distinguish those sub-blocks.

      if (subGapLevel >= gapLevel_1) {
        gapLevel_1 = subGapLevel + +(hasInnerGap_1 && ( // 0 always can not be readable gap level.
        !subGapLevel // If no header, always keep the sub gap level. Otherwise
        // look weird in case `multipleSeries`.
        || isSectionFragment(subBlock) && !subBlock.noHeader));
      }
    });
    return gapLevel_1;
  }

  return 0;
}

function buildSection(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
  var noHeader = fragment.noHeader;
  var gaps = getGap(getBlockGapLevel(fragment));
  var subMarkupTextList = [];
  var subBlocks = fragment.blocks || [];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"])(!subBlocks || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(subBlocks));
  subBlocks = subBlocks || [];
  var orderMode = ctx.orderMode;

  if (fragment.sortBlocks && orderMode) {
    subBlocks = subBlocks.slice();
    var orderMap = {
      valueAsc: 'asc',
      valueDesc: 'desc'
    };

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["hasOwn"])(orderMap, orderMode)) {
      var comparator_1 = new __WEBPACK_IMPORTED_MODULE_2__data_helper_dataValueHelper_js__["a" /* SortOrderComparator */](orderMap[orderMode], null);
      subBlocks.sort(function (a, b) {
        return comparator_1.evaluate(a.sortParam, b.sortParam);
      });
    } // FIXME 'seriesDesc' necessary?
    else if (orderMode === 'seriesDesc') {
        subBlocks.reverse();
      }
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(subBlocks, function (subBlock, idx) {
    var valueFormatter = fragment.valueFormatter;
    var subMarkupText = getBuilder(subBlock)( // Inherit valueFormatter
    valueFormatter ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])({}, ctx), {
      valueFormatter: valueFormatter
    }) : ctx, subBlock, idx > 0 ? gaps.html : 0, toolTipTextStyle);
    subMarkupText != null && subMarkupTextList.push(subMarkupText);
  });
  var subMarkupText = ctx.renderMode === 'richText' ? subMarkupTextList.join(gaps.richText) : wrapBlockHTML(subMarkupTextList.join(''), noHeader ? topMarginForOuterGap : gaps.html);

  if (noHeader) {
    return subMarkupText;
  }

  var displayableHeader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_format_js__["c" /* makeValueReadable */])(fragment.header, 'ordinal', ctx.useUTC);
  var nameStyle = getTooltipTextStyle(toolTipTextStyle, ctx.renderMode).nameStyle;

  if (ctx.renderMode === 'richText') {
    return wrapInlineNameRichText(ctx, displayableHeader, nameStyle) + gaps.richText + subMarkupText;
  } else {
    return wrapBlockHTML("<div style=\"" + nameStyle + ";" + TOOLTIP_LINE_HEIGHT_CSS + ";\">" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_format_js__["b" /* encodeHTML */])(displayableHeader) + '</div>' + subMarkupText, topMarginForOuterGap);
  }
}

function buildNameValue(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
  var renderMode = ctx.renderMode;
  var noName = fragment.noName;
  var noValue = fragment.noValue;
  var noMarker = !fragment.markerType;
  var name = fragment.name;
  var useUTC = ctx.useUTC;

  var valueFormatter = fragment.valueFormatter || ctx.valueFormatter || function (value) {
    value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(value) ? value : [value];
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"])(value, function (val, idx) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_format_js__["c" /* makeValueReadable */])(val, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(valueTypeOption) ? valueTypeOption[idx] : valueTypeOption, useUTC);
    });
  };

  if (noName && noValue) {
    return;
  }

  var markerStr = noMarker ? '' : ctx.markupStyleCreator.makeTooltipMarker(fragment.markerType, fragment.markerColor || '#333', renderMode);
  var readableName = noName ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_format_js__["c" /* makeValueReadable */])(name, 'ordinal', useUTC);
  var valueTypeOption = fragment.valueType;
  var readableValueList = noValue ? [] : valueFormatter(fragment.value);
  var valueAlignRight = !noMarker || !noName; // It little weird if only value next to marker but far from marker.

  var valueCloseToMarker = !noMarker && noName;

  var _a = getTooltipTextStyle(toolTipTextStyle, renderMode),
      nameStyle = _a.nameStyle,
      valueStyle = _a.valueStyle;

  return renderMode === 'richText' ? (noMarker ? '' : markerStr) + (noName ? '' : wrapInlineNameRichText(ctx, readableName, nameStyle)) // Value has commas inside, so use ' ' as delimiter for multiple values.
  + (noValue ? '' : wrapInlineValueRichText(ctx, readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)) : wrapBlockHTML((noMarker ? '' : markerStr) + (noName ? '' : wrapInlineNameHTML(readableName, !noMarker, nameStyle)) + (noValue ? '' : wrapInlineValueHTML(readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)), topMarginForOuterGap);
}
/**
 * @return markupText. null/undefined means no content.
 */


function buildTooltipMarkup(fragment, markupStyleCreator, renderMode, orderMode, useUTC, toolTipTextStyle) {
  if (!fragment) {
    return;
  }

  var builder = getBuilder(fragment);
  var ctx = {
    useUTC: useUTC,
    renderMode: renderMode,
    orderMode: orderMode,
    markupStyleCreator: markupStyleCreator,
    valueFormatter: fragment.valueFormatter
  };
  return builder(ctx, fragment, 0, toolTipTextStyle);
}

function getGap(gapLevel) {
  return {
    html: HTML_GAPS[gapLevel],
    richText: RICH_TEXT_GAPS[gapLevel]
  };
}

function wrapBlockHTML(encodedContent, topGap) {
  var clearfix = '<div style="clear:both"></div>';
  var marginCSS = "margin: " + topGap + "px 0 0";
  return "<div style=\"" + marginCSS + ";" + TOOLTIP_LINE_HEIGHT_CSS + ";\">" + encodedContent + clearfix + '</div>';
}

function wrapInlineNameHTML(name, leftHasMarker, style) {
  var marginCss = leftHasMarker ? 'margin-left:2px' : '';
  return "<span style=\"" + style + ";" + marginCss + "\">" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_format_js__["b" /* encodeHTML */])(name) + '</span>';
}

function wrapInlineValueHTML(valueList, alignRight, valueCloseToMarker, style) {
  // Do not too close to marker, considering there are multiple values separated by spaces.
  var paddingStr = valueCloseToMarker ? '10px' : '20px';
  var alignCSS = alignRight ? "float:right;margin-left:" + paddingStr : '';
  valueList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(valueList) ? valueList : [valueList];
  return "<span style=\"" + alignCSS + ";" + style + "\">" // Value has commas inside, so use '  ' as delimiter for multiple values.
  + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"])(valueList, function (value) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_format_js__["b" /* encodeHTML */])(value);
  }).join('&nbsp;&nbsp;') + '</span>';
}

function wrapInlineNameRichText(ctx, name, style) {
  return ctx.markupStyleCreator.wrapRichTextStyle(name, style);
}

function wrapInlineValueRichText(ctx, values, alignRight, valueCloseToMarker, style) {
  var styles = [style];
  var paddingLeft = valueCloseToMarker ? 10 : 20;
  alignRight && styles.push({
    padding: [0, 0, 0, paddingLeft],
    align: 'right'
  }); // Value has commas inside, so use '  ' as delimiter for multiple values.

  return ctx.markupStyleCreator.wrapRichTextStyle(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(values) ? values.join('  ') : values, styles);
}

function retrieveVisualColorForTooltipMarker(series, dataIndex) {
  var style = series.getData().getItemVisual(dataIndex, 'style');
  var color = style[series.visualDrawType];
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_format_js__["d" /* convertToColorString */])(color);
}
function getPaddingFromTooltipModel(model, renderMode) {
  var padding = model.get('padding');
  return padding != null ? padding // We give slightly different to look pretty.
  : renderMode === 'richText' ? [8, 10] : 10;
}
/**
 * The major feature is generate styles for `renderMode: 'richText'`.
 * But it also serves `renderMode: 'html'` to provide
 * "renderMode-independent" API.
 */

var TooltipMarkupStyleCreator =
/** @class */
function () {
  function TooltipMarkupStyleCreator() {
    this.richTextStyles = {}; // Notice that "generate a style name" usuall happens repeatly when mouse moving and
    // displaying a tooltip. So we put the `_nextStyleNameId` as a member of each creator
    // rather than static shared by all creators (which will cause it increase to fast).

    this._nextStyleNameId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_number_js__["c" /* getRandomIdBase */])();
  }

  TooltipMarkupStyleCreator.prototype._generateStyleName = function () {
    return '__EC_aUTo_' + this._nextStyleNameId++;
  };

  TooltipMarkupStyleCreator.prototype.makeTooltipMarker = function (markerType, colorStr, renderMode) {
    var markerId = renderMode === 'richText' ? this._generateStyleName() : null;
    var marker = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_format_js__["e" /* getTooltipMarker */])({
      color: colorStr,
      type: markerType,
      renderMode: renderMode,
      markerId: markerId
    });

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"])(marker)) {
      return marker;
    } else {
      if (true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"])(markerId);
      }

      this.richTextStyles[markerId] = marker.style;
      return marker.content;
    }
  };
  /**
   * @usage
   * ```ts
   * const styledText = markupStyleCreator.wrapRichTextStyle([
   *     // The styles will be auto merged.
   *     {
   *         fontSize: 12,
   *         color: 'blue'
   *     },
   *     {
   *         padding: 20
   *     }
   * ]);
   * ```
   */


  TooltipMarkupStyleCreator.prototype.wrapRichTextStyle = function (text, styles) {
    var finalStl = {};

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(styles)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(styles, function (stl) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])(finalStl, stl);
      });
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])(finalStl, styles);
    }

    var styleName = this._generateStyleName();

    this.richTextStyles[styleName] = finalStl;
    return "{" + styleName + "|" + text + "}";
  };

  return TooltipMarkupStyleCreator;
}();



/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUID;
/* harmony export (immutable) */ __webpack_exports__["b"] = enableSubTypeDefaulter;
/* harmony export (immutable) */ __webpack_exports__["c"] = enableTopologicalTravel;
/* harmony export (immutable) */ __webpack_exports__["d"] = inheritDefaultOption;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clazz_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__log_js__ = __webpack_require__(14);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


 // A random offset

var base = Math.round(Math.random() * 10);
/**
 * @public
 * @param {string} type
 * @return {string}
 */

function getUID(type) {
  // Considering the case of crossing js context,
  // use Math.random to make id as unique as possible.
  return [type || '', base++].join('_');
}
/**
 * Implements `SubTypeDefaulterManager` for `target`.
 */

function enableSubTypeDefaulter(target) {
  var subTypeDefaulters = {};

  target.registerSubTypeDefaulter = function (componentType, defaulter) {
    var componentTypeInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__clazz_js__["f" /* parseClassType */])(componentType);
    subTypeDefaulters[componentTypeInfo.main] = defaulter;
  };

  target.determineSubType = function (componentType, option) {
    var type = option.type;

    if (!type) {
      var componentTypeMain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__clazz_js__["f" /* parseClassType */])(componentType).main;

      if (target.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) {
        type = subTypeDefaulters[componentTypeMain](option);
      }
    }

    return type;
  };
}
/**
 * Implements `TopologicalTravelable<any>` for `entity`.
 *
 * Topological travel on Activity Network (Activity On Vertices).
 * Dependencies is defined in Model.prototype.dependencies, like ['xAxis', 'yAxis'].
 * If 'xAxis' or 'yAxis' is absent in componentTypeList, just ignore it in topology.
 * If there is circular dependencey, Error will be thrown.
 */

function enableTopologicalTravel(entity, dependencyGetter) {
  /**
   * @param targetNameList Target Component type list.
   *                       Can be ['aa', 'bb', 'aa.xx']
   * @param fullNameList By which we can build dependency graph.
   * @param callback Params: componentType, dependencies.
   * @param context Scope of callback.
   */
  entity.topologicalTravel = function (targetNameList, fullNameList, callback, context) {
    if (!targetNameList.length) {
      return;
    }

    var result = makeDepndencyGraph(fullNameList);
    var graph = result.graph;
    var noEntryList = result.noEntryList;
    var targetNameSet = {};
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](targetNameList, function (name) {
      targetNameSet[name] = true;
    });

    while (noEntryList.length) {
      var currComponentType = noEntryList.pop();
      var currVertex = graph[currComponentType];
      var isInTargetNameSet = !!targetNameSet[currComponentType];

      if (isInTargetNameSet) {
        callback.call(context, currComponentType, currVertex.originalDeps.slice());
        delete targetNameSet[currComponentType];
      }

      __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
    }

    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](targetNameSet, function () {
      var errMsg = '';

      if (true) {
        errMsg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__log_js__["d" /* makePrintable */])('Circular dependency may exists: ', targetNameSet, targetNameList, fullNameList);
      }

      throw new Error(errMsg);
    });

    function removeEdge(succComponentType) {
      graph[succComponentType].entryCount--;

      if (graph[succComponentType].entryCount === 0) {
        noEntryList.push(succComponentType);
      }
    } // Consider this case: legend depends on series, and we call
    // chart.setOption({series: [...]}), where only series is in option.
    // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
    // not be called, but only sereis.mergeOption is called. Thus legend
    // have no chance to update its local record about series (like which
    // name of series is available in legend).


    function removeEdgeAndAdd(succComponentType) {
      targetNameSet[succComponentType] = true;
      removeEdge(succComponentType);
    }
  };

  function makeDepndencyGraph(fullNameList) {
    var graph = {};
    var noEntryList = [];
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](fullNameList, function (name) {
      var thisItem = createDependencyGraphItem(graph, name);
      var originalDeps = thisItem.originalDeps = dependencyGetter(name);
      var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
      thisItem.entryCount = availableDeps.length;

      if (thisItem.entryCount === 0) {
        noEntryList.push(name);
      }

      __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](availableDeps, function (dependentName) {
        if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"](thisItem.predecessor, dependentName) < 0) {
          thisItem.predecessor.push(dependentName);
        }

        var thatItem = createDependencyGraphItem(graph, dependentName);

        if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"](thatItem.successor, dependentName) < 0) {
          thatItem.successor.push(name);
        }
      });
    });
    return {
      graph: graph,
      noEntryList: noEntryList
    };
  }

  function createDependencyGraphItem(graph, name) {
    if (!graph[name]) {
      graph[name] = {
        predecessor: [],
        successor: []
      };
    }

    return graph[name];
  }

  function getAvailableDependencies(originalDeps, fullNameList) {
    var availableDeps = [];
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](originalDeps, function (dep) {
      __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"](fullNameList, dep) >= 0 && availableDeps.push(dep);
    });
    return availableDeps;
  }
}
function inheritDefaultOption(superOption, subOption) {
  // See also `model/Component.ts#getDefaultOption`
  return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["merge"](__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["merge"]({}, superOption, true), subOption, true);
}

/***/ }),
/* 50 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(374);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return franchiseArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return teamArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return teamArrayByArray; });
var franchiseArray = function franchiseArray(departId) {
    var independ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (!independ && !departId) {
        return [];
    }

    var org = window.vm.$store.state.basedata.baseDataRecords.Organization || [];

    org = (org[0] || {})[departId] || [];

    return org;
};

var teamArray = function teamArray(departId, medicalField) {
    var independ = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (!independ && (!departId || !medicalField)) {
        return [];
    }

    if (departId) {
        var org = window.vm.$store.state.basedata.baseDataRecords.Organization || [];

        org = (org[0] || {})[departId] || [];

        org = org.filter(function (o) {
            return !medicalField || o.id == medicalField;
        });

        var teams = [];
        org.forEach(function (o) {
            teams = teams.concat(o.teams);
        });

        return teams;
    } else if (medicalField) {
        var _org = window.vm.$store.state.basedata.baseDataRecords.Organization || [];

        _org = _org[0] || {};

        var temp = [];
        for (departId in _org) {
            if (departId) {
                temp = temp.concat(_org[departId]);
            }
        }
        _org = temp;

        _org = _org.filter(function (o) {
            return !medicalField || o.id == medicalField;
        });

        var _teams = [];
        _org.forEach(function (o) {
            _teams = _teams.concat(o.teams);
        });

        return _teams;
    } else {
        return window.vm.$store.state.basedata.baseDataRecords.Teams;
    }
};

var teamArrayByArray = function teamArrayByArray(departId, medicalFieldArr) {
    var independ = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (!independ && (!departId || !medicalFieldArr || !medicalFieldArr.some(function (m) {
        return !!m;
    }))) {
        return [];
    }

    if (departId || medicalFieldArr && medicalFieldArr.some(function (m) {
        return !!m;
    })) {
        var org = window.vm.$store.state.basedata.baseDataRecords.Organization || [];

        org = org[0] || {};

        var temp = [];
        for (departId in org) {
            if (departId) {
                temp = temp.concat(org[departId]);
            }
        }
        org = temp;

        org = org.filter(function (o) {
            return !medicalFieldArr || !medicalFieldArr.some(function (m) {
                return !!m;
            }) || medicalFieldArr.some(function (m) {
                return m == o.id;
            });
        });

        var teams = [];
        org.forEach(function (o) {
            teams = teams.concat(o.teams);
        });

        return teams;
    } else if (medicalFieldArr.some(function (m) {
        return !!m;
    })) {
        var _org2 = window.vm.$store.state.basedata.baseDataRecords.Organization || [];

        _org2 = (_org2[0] || [])[departId] || [];

        _org2 = _org2.filter(function (o) {
            return !medicalFieldArr || !medicalFieldArr.some(function (m) {
                return !!m;
            }) || medicalFieldArr.some(function (m) {
                return m == o.id;
            });
        });

        var _teams2 = [];
        _org2.forEach(function (o) {
            _teams2 = _teams2.concat(o.teams);
        });

        return _teams2;
    } else {
        return window.vm.$store.state.basedata.baseDataRecords.Teams;
    }
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(44);
var core = __webpack_require__(36);
var ctx = __webpack_require__(105);
var hide = __webpack_require__(106);
var has = __webpack_require__(120);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(33);
var createDesc = __webpack_require__(126);
module.exports = __webpack_require__(31) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var hide = __webpack_require__(54);
var has = __webpack_require__(61);
var SRC = __webpack_require__(130)('src');
var $toString = __webpack_require__(813);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(73).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var fails = __webpack_require__(16);
var defined = __webpack_require__(82);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = cubicAt;
/* harmony export (immutable) */ __webpack_exports__["m"] = cubicDerivativeAt;
/* harmony export (immutable) */ __webpack_exports__["a"] = cubicRootAt;
/* harmony export (immutable) */ __webpack_exports__["c"] = cubicExtrema;
/* harmony export (immutable) */ __webpack_exports__["k"] = cubicSubdivide;
/* harmony export (immutable) */ __webpack_exports__["h"] = cubicProjectPoint;
/* harmony export (immutable) */ __webpack_exports__["i"] = cubicLength;
/* harmony export (immutable) */ __webpack_exports__["f"] = quadraticAt;
/* harmony export (immutable) */ __webpack_exports__["n"] = quadraticDerivativeAt;
/* harmony export (immutable) */ __webpack_exports__["d"] = quadraticRootAt;
/* harmony export (immutable) */ __webpack_exports__["e"] = quadraticExtremum;
/* harmony export (immutable) */ __webpack_exports__["l"] = quadraticSubdivide;
/* harmony export (immutable) */ __webpack_exports__["g"] = quadraticProjectPoint;
/* harmony export (immutable) */ __webpack_exports__["j"] = quadraticLength;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vector_js__ = __webpack_require__(23);

var mathPow = Math.pow;
var mathSqrt = Math.sqrt;
var EPSILON = 1e-8;
var EPSILON_NUMERIC = 1e-4;
var THREE_SQRT = mathSqrt(3);
var ONE_THIRD = 1 / 3;
var _v0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vector_js__["create"])();
var _v1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vector_js__["create"])();
var _v2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vector_js__["create"])();
function isAroundZero(val) {
    return val > -EPSILON && val < EPSILON;
}
function isNotAroundZero(val) {
    return val > EPSILON || val < -EPSILON;
}
function cubicAt(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return onet * onet * (onet * p0 + 3 * t * p1)
        + t * t * (t * p3 + 3 * onet * p2);
}
function cubicDerivativeAt(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet
        + (p3 - p2) * t * t);
}
function cubicRootAt(p0, p1, p2, p3, val, roots) {
    var a = p3 + 3 * (p1 - p2) - p0;
    var b = 3 * (p2 - p1 * 2 + p0);
    var c = 3 * (p1 - p0);
    var d = p0 - val;
    var A = b * b - 3 * a * c;
    var B = b * c - 9 * a * d;
    var C = c * c - 3 * b * d;
    var n = 0;
    if (isAroundZero(A) && isAroundZero(B)) {
        if (isAroundZero(b)) {
            roots[0] = 0;
        }
        else {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) {
                roots[n++] = t1;
            }
        }
    }
    else {
        var disc = B * B - 4 * A * C;
        if (isAroundZero(disc)) {
            var K = B / A;
            var t1 = -b / a + K;
            var t2 = -K / 2;
            if (t1 >= 0 && t1 <= 1) {
                roots[n++] = t1;
            }
            if (t2 >= 0 && t2 <= 1) {
                roots[n++] = t2;
            }
        }
        else if (disc > 0) {
            var discSqrt = mathSqrt(disc);
            var Y1 = A * b + 1.5 * a * (-B + discSqrt);
            var Y2 = A * b + 1.5 * a * (-B - discSqrt);
            if (Y1 < 0) {
                Y1 = -mathPow(-Y1, ONE_THIRD);
            }
            else {
                Y1 = mathPow(Y1, ONE_THIRD);
            }
            if (Y2 < 0) {
                Y2 = -mathPow(-Y2, ONE_THIRD);
            }
            else {
                Y2 = mathPow(Y2, ONE_THIRD);
            }
            var t1 = (-b - (Y1 + Y2)) / (3 * a);
            if (t1 >= 0 && t1 <= 1) {
                roots[n++] = t1;
            }
        }
        else {
            var T = (2 * A * b - 3 * a * B) / (2 * mathSqrt(A * A * A));
            var theta = Math.acos(T) / 3;
            var ASqrt = mathSqrt(A);
            var tmp = Math.cos(theta);
            var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
            var t2 = (-b + ASqrt * (tmp + THREE_SQRT * Math.sin(theta))) / (3 * a);
            var t3 = (-b + ASqrt * (tmp - THREE_SQRT * Math.sin(theta))) / (3 * a);
            if (t1 >= 0 && t1 <= 1) {
                roots[n++] = t1;
            }
            if (t2 >= 0 && t2 <= 1) {
                roots[n++] = t2;
            }
            if (t3 >= 0 && t3 <= 1) {
                roots[n++] = t3;
            }
        }
    }
    return n;
}
function cubicExtrema(p0, p1, p2, p3, extrema) {
    var b = 6 * p2 - 12 * p1 + 6 * p0;
    var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
    var c = 3 * p1 - 3 * p0;
    var n = 0;
    if (isAroundZero(a)) {
        if (isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) {
                extrema[n++] = t1;
            }
        }
    }
    else {
        var disc = b * b - 4 * a * c;
        if (isAroundZero(disc)) {
            extrema[0] = -b / (2 * a);
        }
        else if (disc > 0) {
            var discSqrt = mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) {
                extrema[n++] = t1;
            }
            if (t2 >= 0 && t2 <= 1) {
                extrema[n++] = t2;
            }
        }
    }
    return n;
}
function cubicSubdivide(p0, p1, p2, p3, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p23 = (p3 - p2) * t + p2;
    var p012 = (p12 - p01) * t + p01;
    var p123 = (p23 - p12) * t + p12;
    var p0123 = (p123 - p012) * t + p012;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p0123;
    out[4] = p0123;
    out[5] = p123;
    out[6] = p23;
    out[7] = p3;
}
function cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    var prev;
    var next;
    var d1;
    var d2;
    _v0[0] = x;
    _v0[1] = y;
    for (var _t = 0; _t < 1; _t += 0.05) {
        _v1[0] = cubicAt(x0, x1, x2, x3, _t);
        _v1[1] = cubicAt(y0, y1, y2, y3, _t);
        d1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vector_js__["distSquare"])(_v0, _v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for (var i = 0; i < 32; i++) {
        if (interval < EPSILON_NUMERIC) {
            break;
        }
        prev = t - interval;
        next = t + interval;
        _v1[0] = cubicAt(x0, x1, x2, x3, prev);
        _v1[1] = cubicAt(y0, y1, y2, y3, prev);
        d1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vector_js__["distSquare"])(_v1, _v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        }
        else {
            _v2[0] = cubicAt(x0, x1, x2, x3, next);
            _v2[1] = cubicAt(y0, y1, y2, y3, next);
            d2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vector_js__["distSquare"])(_v2, _v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            }
            else {
                interval *= 0.5;
            }
        }
    }
    if (out) {
        out[0] = cubicAt(x0, x1, x2, x3, t);
        out[1] = cubicAt(y0, y1, y2, y3, t);
    }
    return mathSqrt(d);
}
function cubicLength(x0, y0, x1, y1, x2, y2, x3, y3, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for (var i = 1; i <= iteration; i++) {
        var t = i * step;
        var x = cubicAt(x0, x1, x2, x3, t);
        var y = cubicAt(y0, y1, y2, y3, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}
function quadraticAt(p0, p1, p2, t) {
    var onet = 1 - t;
    return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
}
function quadraticDerivativeAt(p0, p1, p2, t) {
    return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
}
function quadraticRootAt(p0, p1, p2, val, roots) {
    var a = p0 - 2 * p1 + p2;
    var b = 2 * (p1 - p0);
    var c = p0 - val;
    var n = 0;
    if (isAroundZero(a)) {
        if (isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) {
                roots[n++] = t1;
            }
        }
    }
    else {
        var disc = b * b - 4 * a * c;
        if (isAroundZero(disc)) {
            var t1 = -b / (2 * a);
            if (t1 >= 0 && t1 <= 1) {
                roots[n++] = t1;
            }
        }
        else if (disc > 0) {
            var discSqrt = mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) {
                roots[n++] = t1;
            }
            if (t2 >= 0 && t2 <= 1) {
                roots[n++] = t2;
            }
        }
    }
    return n;
}
function quadraticExtremum(p0, p1, p2) {
    var divider = p0 + p2 - 2 * p1;
    if (divider === 0) {
        return 0.5;
    }
    else {
        return (p0 - p1) / divider;
    }
}
function quadraticSubdivide(p0, p1, p2, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p012 = (p12 - p01) * t + p01;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p012;
    out[4] = p12;
    out[5] = p2;
}
function quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    _v0[0] = x;
    _v0[1] = y;
    for (var _t = 0; _t < 1; _t += 0.05) {
        _v1[0] = quadraticAt(x0, x1, x2, _t);
        _v1[1] = quadraticAt(y0, y1, y2, _t);
        var d1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vector_js__["distSquare"])(_v0, _v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for (var i = 0; i < 32; i++) {
        if (interval < EPSILON_NUMERIC) {
            break;
        }
        var prev = t - interval;
        var next = t + interval;
        _v1[0] = quadraticAt(x0, x1, x2, prev);
        _v1[1] = quadraticAt(y0, y1, y2, prev);
        var d1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vector_js__["distSquare"])(_v1, _v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        }
        else {
            _v2[0] = quadraticAt(x0, x1, x2, next);
            _v2[1] = quadraticAt(y0, y1, y2, next);
            var d2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vector_js__["distSquare"])(_v2, _v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            }
            else {
                interval *= 0.5;
            }
        }
    }
    if (out) {
        out[0] = quadraticAt(x0, x1, x2, t);
        out[1] = quadraticAt(y0, y1, y2, t);
    }
    return mathSqrt(d);
}
function quadraticLength(x0, y0, x1, y1, x2, y2, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for (var i = 1; i <= iteration; i++) {
        var t = i * step;
        var x = quadraticAt(x0, x1, x2, t);
        var y = quadraticAt(y0, y1, y2, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["parse"] = parse;
/* harmony export (immutable) */ __webpack_exports__["lift"] = lift;
/* harmony export (immutable) */ __webpack_exports__["toHex"] = toHex;
/* harmony export (immutable) */ __webpack_exports__["fastLerp"] = fastLerp;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fastMapToColor", function() { return fastMapToColor; });
/* harmony export (immutable) */ __webpack_exports__["lerp"] = lerp;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapToColor", function() { return mapToColor; });
/* harmony export (immutable) */ __webpack_exports__["modifyHSL"] = modifyHSL;
/* harmony export (immutable) */ __webpack_exports__["modifyAlpha"] = modifyAlpha;
/* harmony export (immutable) */ __webpack_exports__["stringify"] = stringify;
/* harmony export (immutable) */ __webpack_exports__["lum"] = lum;
/* harmony export (immutable) */ __webpack_exports__["random"] = random;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_LRU_js__ = __webpack_require__(203);

var kCSSColorTable = {
    'transparent': [0, 0, 0, 0], 'aliceblue': [240, 248, 255, 1],
    'antiquewhite': [250, 235, 215, 1], 'aqua': [0, 255, 255, 1],
    'aquamarine': [127, 255, 212, 1], 'azure': [240, 255, 255, 1],
    'beige': [245, 245, 220, 1], 'bisque': [255, 228, 196, 1],
    'black': [0, 0, 0, 1], 'blanchedalmond': [255, 235, 205, 1],
    'blue': [0, 0, 255, 1], 'blueviolet': [138, 43, 226, 1],
    'brown': [165, 42, 42, 1], 'burlywood': [222, 184, 135, 1],
    'cadetblue': [95, 158, 160, 1], 'chartreuse': [127, 255, 0, 1],
    'chocolate': [210, 105, 30, 1], 'coral': [255, 127, 80, 1],
    'cornflowerblue': [100, 149, 237, 1], 'cornsilk': [255, 248, 220, 1],
    'crimson': [220, 20, 60, 1], 'cyan': [0, 255, 255, 1],
    'darkblue': [0, 0, 139, 1], 'darkcyan': [0, 139, 139, 1],
    'darkgoldenrod': [184, 134, 11, 1], 'darkgray': [169, 169, 169, 1],
    'darkgreen': [0, 100, 0, 1], 'darkgrey': [169, 169, 169, 1],
    'darkkhaki': [189, 183, 107, 1], 'darkmagenta': [139, 0, 139, 1],
    'darkolivegreen': [85, 107, 47, 1], 'darkorange': [255, 140, 0, 1],
    'darkorchid': [153, 50, 204, 1], 'darkred': [139, 0, 0, 1],
    'darksalmon': [233, 150, 122, 1], 'darkseagreen': [143, 188, 143, 1],
    'darkslateblue': [72, 61, 139, 1], 'darkslategray': [47, 79, 79, 1],
    'darkslategrey': [47, 79, 79, 1], 'darkturquoise': [0, 206, 209, 1],
    'darkviolet': [148, 0, 211, 1], 'deeppink': [255, 20, 147, 1],
    'deepskyblue': [0, 191, 255, 1], 'dimgray': [105, 105, 105, 1],
    'dimgrey': [105, 105, 105, 1], 'dodgerblue': [30, 144, 255, 1],
    'firebrick': [178, 34, 34, 1], 'floralwhite': [255, 250, 240, 1],
    'forestgreen': [34, 139, 34, 1], 'fuchsia': [255, 0, 255, 1],
    'gainsboro': [220, 220, 220, 1], 'ghostwhite': [248, 248, 255, 1],
    'gold': [255, 215, 0, 1], 'goldenrod': [218, 165, 32, 1],
    'gray': [128, 128, 128, 1], 'green': [0, 128, 0, 1],
    'greenyellow': [173, 255, 47, 1], 'grey': [128, 128, 128, 1],
    'honeydew': [240, 255, 240, 1], 'hotpink': [255, 105, 180, 1],
    'indianred': [205, 92, 92, 1], 'indigo': [75, 0, 130, 1],
    'ivory': [255, 255, 240, 1], 'khaki': [240, 230, 140, 1],
    'lavender': [230, 230, 250, 1], 'lavenderblush': [255, 240, 245, 1],
    'lawngreen': [124, 252, 0, 1], 'lemonchiffon': [255, 250, 205, 1],
    'lightblue': [173, 216, 230, 1], 'lightcoral': [240, 128, 128, 1],
    'lightcyan': [224, 255, 255, 1], 'lightgoldenrodyellow': [250, 250, 210, 1],
    'lightgray': [211, 211, 211, 1], 'lightgreen': [144, 238, 144, 1],
    'lightgrey': [211, 211, 211, 1], 'lightpink': [255, 182, 193, 1],
    'lightsalmon': [255, 160, 122, 1], 'lightseagreen': [32, 178, 170, 1],
    'lightskyblue': [135, 206, 250, 1], 'lightslategray': [119, 136, 153, 1],
    'lightslategrey': [119, 136, 153, 1], 'lightsteelblue': [176, 196, 222, 1],
    'lightyellow': [255, 255, 224, 1], 'lime': [0, 255, 0, 1],
    'limegreen': [50, 205, 50, 1], 'linen': [250, 240, 230, 1],
    'magenta': [255, 0, 255, 1], 'maroon': [128, 0, 0, 1],
    'mediumaquamarine': [102, 205, 170, 1], 'mediumblue': [0, 0, 205, 1],
    'mediumorchid': [186, 85, 211, 1], 'mediumpurple': [147, 112, 219, 1],
    'mediumseagreen': [60, 179, 113, 1], 'mediumslateblue': [123, 104, 238, 1],
    'mediumspringgreen': [0, 250, 154, 1], 'mediumturquoise': [72, 209, 204, 1],
    'mediumvioletred': [199, 21, 133, 1], 'midnightblue': [25, 25, 112, 1],
    'mintcream': [245, 255, 250, 1], 'mistyrose': [255, 228, 225, 1],
    'moccasin': [255, 228, 181, 1], 'navajowhite': [255, 222, 173, 1],
    'navy': [0, 0, 128, 1], 'oldlace': [253, 245, 230, 1],
    'olive': [128, 128, 0, 1], 'olivedrab': [107, 142, 35, 1],
    'orange': [255, 165, 0, 1], 'orangered': [255, 69, 0, 1],
    'orchid': [218, 112, 214, 1], 'palegoldenrod': [238, 232, 170, 1],
    'palegreen': [152, 251, 152, 1], 'paleturquoise': [175, 238, 238, 1],
    'palevioletred': [219, 112, 147, 1], 'papayawhip': [255, 239, 213, 1],
    'peachpuff': [255, 218, 185, 1], 'peru': [205, 133, 63, 1],
    'pink': [255, 192, 203, 1], 'plum': [221, 160, 221, 1],
    'powderblue': [176, 224, 230, 1], 'purple': [128, 0, 128, 1],
    'red': [255, 0, 0, 1], 'rosybrown': [188, 143, 143, 1],
    'royalblue': [65, 105, 225, 1], 'saddlebrown': [139, 69, 19, 1],
    'salmon': [250, 128, 114, 1], 'sandybrown': [244, 164, 96, 1],
    'seagreen': [46, 139, 87, 1], 'seashell': [255, 245, 238, 1],
    'sienna': [160, 82, 45, 1], 'silver': [192, 192, 192, 1],
    'skyblue': [135, 206, 235, 1], 'slateblue': [106, 90, 205, 1],
    'slategray': [112, 128, 144, 1], 'slategrey': [112, 128, 144, 1],
    'snow': [255, 250, 250, 1], 'springgreen': [0, 255, 127, 1],
    'steelblue': [70, 130, 180, 1], 'tan': [210, 180, 140, 1],
    'teal': [0, 128, 128, 1], 'thistle': [216, 191, 216, 1],
    'tomato': [255, 99, 71, 1], 'turquoise': [64, 224, 208, 1],
    'violet': [238, 130, 238, 1], 'wheat': [245, 222, 179, 1],
    'white': [255, 255, 255, 1], 'whitesmoke': [245, 245, 245, 1],
    'yellow': [255, 255, 0, 1], 'yellowgreen': [154, 205, 50, 1]
};
function clampCssByte(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 255 ? 255 : i;
}
function clampCssAngle(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 360 ? 360 : i;
}
function clampCssFloat(f) {
    return f < 0 ? 0 : f > 1 ? 1 : f;
}
function parseCssInt(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') {
        return clampCssByte(parseFloat(str) / 100 * 255);
    }
    return clampCssByte(parseInt(str, 10));
}
function parseCssFloat(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') {
        return clampCssFloat(parseFloat(str) / 100);
    }
    return clampCssFloat(parseFloat(str));
}
function cssHueToRgb(m1, m2, h) {
    if (h < 0) {
        h += 1;
    }
    else if (h > 1) {
        h -= 1;
    }
    if (h * 6 < 1) {
        return m1 + (m2 - m1) * h * 6;
    }
    if (h * 2 < 1) {
        return m2;
    }
    if (h * 3 < 2) {
        return m1 + (m2 - m1) * (2 / 3 - h) * 6;
    }
    return m1;
}
function lerpNumber(a, b, p) {
    return a + (b - a) * p;
}
function setRgba(out, r, g, b, a) {
    out[0] = r;
    out[1] = g;
    out[2] = b;
    out[3] = a;
    return out;
}
function copyRgba(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
var colorCache = new __WEBPACK_IMPORTED_MODULE_0__core_LRU_js__["a" /* default */](20);
var lastRemovedArr = null;
function putToCache(colorStr, rgbaArr) {
    if (lastRemovedArr) {
        copyRgba(lastRemovedArr, rgbaArr);
    }
    lastRemovedArr = colorCache.put(colorStr, lastRemovedArr || (rgbaArr.slice()));
}
function parse(colorStr, rgbaArr) {
    if (!colorStr) {
        return;
    }
    rgbaArr = rgbaArr || [];
    var cached = colorCache.get(colorStr);
    if (cached) {
        return copyRgba(rgbaArr, cached);
    }
    colorStr = colorStr + '';
    var str = colorStr.replace(/ /g, '').toLowerCase();
    if (str in kCSSColorTable) {
        copyRgba(rgbaArr, kCSSColorTable[str]);
        putToCache(colorStr, rgbaArr);
        return rgbaArr;
    }
    var strLen = str.length;
    if (str.charAt(0) === '#') {
        if (strLen === 4 || strLen === 5) {
            var iv = parseInt(str.slice(1, 4), 16);
            if (!(iv >= 0 && iv <= 0xfff)) {
                setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            setRgba(rgbaArr, ((iv & 0xf00) >> 4) | ((iv & 0xf00) >> 8), (iv & 0xf0) | ((iv & 0xf0) >> 4), (iv & 0xf) | ((iv & 0xf) << 4), strLen === 5 ? parseInt(str.slice(4), 16) / 0xf : 1);
            putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        else if (strLen === 7 || strLen === 9) {
            var iv = parseInt(str.slice(1, 7), 16);
            if (!(iv >= 0 && iv <= 0xffffff)) {
                setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, strLen === 9 ? parseInt(str.slice(7), 16) / 0xff : 1);
            putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        return;
    }
    var op = str.indexOf('(');
    var ep = str.indexOf(')');
    if (op !== -1 && ep + 1 === strLen) {
        var fname = str.substr(0, op);
        var params = str.substr(op + 1, ep - (op + 1)).split(',');
        var alpha = 1;
        switch (fname) {
            case 'rgba':
                if (params.length !== 4) {
                    return params.length === 3
                        ? setRgba(rgbaArr, +params[0], +params[1], +params[2], 1)
                        : setRgba(rgbaArr, 0, 0, 0, 1);
                }
                alpha = parseCssFloat(params.pop());
            case 'rgb':
                if (params.length !== 3) {
                    setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                setRgba(rgbaArr, parseCssInt(params[0]), parseCssInt(params[1]), parseCssInt(params[2]), alpha);
                putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case 'hsla':
                if (params.length !== 4) {
                    setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                params[3] = parseCssFloat(params[3]);
                hsla2rgba(params, rgbaArr);
                putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case 'hsl':
                if (params.length !== 3) {
                    setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                hsla2rgba(params, rgbaArr);
                putToCache(colorStr, rgbaArr);
                return rgbaArr;
            default:
                return;
        }
    }
    setRgba(rgbaArr, 0, 0, 0, 1);
    return;
}
function hsla2rgba(hsla, rgba) {
    var h = (((parseFloat(hsla[0]) % 360) + 360) % 360) / 360;
    var s = parseCssFloat(hsla[1]);
    var l = parseCssFloat(hsla[2]);
    var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
    var m1 = l * 2 - m2;
    rgba = rgba || [];
    setRgba(rgba, clampCssByte(cssHueToRgb(m1, m2, h + 1 / 3) * 255), clampCssByte(cssHueToRgb(m1, m2, h) * 255), clampCssByte(cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
    if (hsla.length === 4) {
        rgba[3] = hsla[3];
    }
    return rgba;
}
function rgba2hsla(rgba) {
    if (!rgba) {
        return;
    }
    var R = rgba[0] / 255;
    var G = rgba[1] / 255;
    var B = rgba[2] / 255;
    var vMin = Math.min(R, G, B);
    var vMax = Math.max(R, G, B);
    var delta = vMax - vMin;
    var L = (vMax + vMin) / 2;
    var H;
    var S;
    if (delta === 0) {
        H = 0;
        S = 0;
    }
    else {
        if (L < 0.5) {
            S = delta / (vMax + vMin);
        }
        else {
            S = delta / (2 - vMax - vMin);
        }
        var deltaR = (((vMax - R) / 6) + (delta / 2)) / delta;
        var deltaG = (((vMax - G) / 6) + (delta / 2)) / delta;
        var deltaB = (((vMax - B) / 6) + (delta / 2)) / delta;
        if (R === vMax) {
            H = deltaB - deltaG;
        }
        else if (G === vMax) {
            H = (1 / 3) + deltaR - deltaB;
        }
        else if (B === vMax) {
            H = (2 / 3) + deltaG - deltaR;
        }
        if (H < 0) {
            H += 1;
        }
        if (H > 1) {
            H -= 1;
        }
    }
    var hsla = [H * 360, S, L];
    if (rgba[3] != null) {
        hsla.push(rgba[3]);
    }
    return hsla;
}
function lift(color, level) {
    var colorArr = parse(color);
    if (colorArr) {
        for (var i = 0; i < 3; i++) {
            if (level < 0) {
                colorArr[i] = colorArr[i] * (1 - level) | 0;
            }
            else {
                colorArr[i] = ((255 - colorArr[i]) * level + colorArr[i]) | 0;
            }
            if (colorArr[i] > 255) {
                colorArr[i] = 255;
            }
            else if (colorArr[i] < 0) {
                colorArr[i] = 0;
            }
        }
        return stringify(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
    }
}
function toHex(color) {
    var colorArr = parse(color);
    if (colorArr) {
        return ((1 << 24) + (colorArr[0] << 16) + (colorArr[1] << 8) + (+colorArr[2])).toString(16).slice(1);
    }
}
function fastLerp(normalizedValue, colors, out) {
    if (!(colors && colors.length)
        || !(normalizedValue >= 0 && normalizedValue <= 1)) {
        return;
    }
    out = out || [];
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = colors[leftIndex];
    var rightColor = colors[rightIndex];
    var dv = value - leftIndex;
    out[0] = clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv));
    out[1] = clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv));
    out[2] = clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv));
    out[3] = clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv));
    return out;
}
var fastMapToColor = fastLerp;
function lerp(normalizedValue, colors, fullOutput) {
    if (!(colors && colors.length)
        || !(normalizedValue >= 0 && normalizedValue <= 1)) {
        return;
    }
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = parse(colors[leftIndex]);
    var rightColor = parse(colors[rightIndex]);
    var dv = value - leftIndex;
    var color = stringify([
        clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv)),
        clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv)),
        clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv)),
        clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv))
    ], 'rgba');
    return fullOutput
        ? {
            color: color,
            leftIndex: leftIndex,
            rightIndex: rightIndex,
            value: value
        }
        : color;
}
var mapToColor = lerp;
function modifyHSL(color, h, s, l) {
    var colorArr = parse(color);
    if (color) {
        colorArr = rgba2hsla(colorArr);
        h != null && (colorArr[0] = clampCssAngle(h));
        s != null && (colorArr[1] = parseCssFloat(s));
        l != null && (colorArr[2] = parseCssFloat(l));
        return stringify(hsla2rgba(colorArr), 'rgba');
    }
}
function modifyAlpha(color, alpha) {
    var colorArr = parse(color);
    if (colorArr && alpha != null) {
        colorArr[3] = clampCssFloat(alpha);
        return stringify(colorArr, 'rgba');
    }
}
function stringify(arrColor, type) {
    if (!arrColor || !arrColor.length) {
        return;
    }
    var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
    if (type === 'rgba' || type === 'hsva' || type === 'hsla') {
        colorStr += ',' + arrColor[3];
    }
    return type + '(' + colorStr + ')';
}
function lum(color, backgroundLum) {
    var arr = parse(color);
    return arr
        ? (0.299 * arr[0] + 0.587 * arr[1] + 0.114 * arr[2]) * arr[3] / 255
            + (1 - arr[3]) * backgroundLum
        : 0;
}
function random() {
    return stringify([
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255)
    ], 'rgb');
}


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.20';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50), __webpack_require__(1689)(module)))

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return baseURL; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loading__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_message_js__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_language__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constant_common__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_global__ = __webpack_require__(170);










console.log('global', __WEBPACK_IMPORTED_MODULE_8__global_global__["a" /* default */]);
var baseURL = __WEBPACK_IMPORTED_MODULE_8__global_global__["a" /* default */].BASE_URL;

var request_id_prefix = 'axios_request_index_';
var request_id_starter = Date.parse(new Date()) / 1000;

var service = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  defaults: __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.assign(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults, {
    baseURL: baseURL
  }),
  withCredentials: true
});

// http request 拦截器
service.interceptors.request.use(function (config) {
  config.requestId = getRequestId();
  // 避免ie 缓存get 请求
  if (config.method == 'get') {
    // 判断get请求
    config.params = config.params || {};
    config.params.t = Date.parse(new Date()) / 1000; // 添加时间戳
  }

  var url = config.url;
  if (url.indexOf('?') != -1) {
    // post 请求需要 encode 查询参数的value
    encodeRequestURI(config);
  }

  config.headers[__WEBPACK_IMPORTED_MODULE_6__constant_common__["a" /* E2E_INTL_HEADER */]] = __WEBPACK_IMPORTED_MODULE_5__util_language__["a" /* default */]; // 请求头add国际化header
  config.withCredentials = true;
  if (!config.skipLoading) {
    __WEBPACK_IMPORTED_MODULE_3__loading__["a" /* default */].add(config);
    delete config.skipLoading;
  }
  return config;
}, function (err) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
});

function encodeRequestURI(config) {
  var url = config.url;
  var urlArr = url.split('?');
  if (urlArr.length > 1) {
    var params = urlArr[1].split('&');
    var paramArr = [];
    for (var i = 0; i < params.length; i++) {
      if (params[i].split('=')[1]) {
        // 参数的value 存在
        paramArr.push(params[i].split('=')[0] + '=' + encodeURIComponent(params[i].split('=')[1]));
      } else {
        // 参数的value 不存在
        paramArr.push(params[i].split('=')[0] + '=' + params[i].split('=')[1]);
      }
    }
    url = urlArr[0] + '?' + paramArr.join('&');
  }
  config.url = url;
}

// 给每个请求设置一个 requestId
function getRequestId() {
  return request_id_prefix + request_id_starter++;
}

// http response 拦截器
service.interceptors.response.use(function (response) {
  __WEBPACK_IMPORTED_MODULE_3__loading__["a" /* default */].remove(response);
  var result = response;
  if (response.config.responseType == 'arraybuffer' || response.config.responseType == 'blob') {
    result = response;
  } else {
    result = response.data;
  }
  return result;
}, function (error) {
  // 接口错误状态处理，也就是说无响应时的处理

  if (error.response) {
    var _error$response = error.response,
        data = _error$response.data,
        status = _error$response.status;

    var currentPath = window.vm.$route.path;
    switch (status) {
      case 401:
        if (currentPath != '/login' && currentPath != '/' && currentPath != '/login2' && currentPath != '/403') {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_message_js__["a" /* default */])({
            message: window.vm.$t('system.login_expired'),
            type: 'error'
          });
          window.vm.$router.replace({
            name: 'login'
          });
        }
        break;
      default:
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_message_js__["a" /* default */])({
          message: data.message ? data.message : window.vm.$t('system.server_error_msg'),
          type: 'error'
        });
    }
    __WEBPACK_IMPORTED_MODULE_3__loading__["a" /* default */].remove(error.response);
  } else {
    if (error.stack.indexOf('Network') > -1) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_message_js__["a" /* default */])({
        message: window.vm.$t('system.network_error'),
        type: 'error'
      });
    } else if (error.stack.indexOf('timeout')) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_message_js__["a" /* default */])({
        message: window.vm.$t('system.network_timeout'),
        type: 'error'
      });
    }
    __WEBPACK_IMPORTED_MODULE_3__loading__["a" /* default */].removAll();
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error); // 返回接口返回的错误信息
});

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$http = service;

/* harmony default export */ __webpack_exports__["a"] = (service);



/***/ }),
/* 61 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(185);
var createDesc = __webpack_require__(126);
var toIObject = __webpack_require__(64);
var toPrimitive = __webpack_require__(84);
var has = __webpack_require__(61);
var IE8_DOM_DEFINE = __webpack_require__(413);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(31) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(61);
var toObject = __webpack_require__(34);
var IE_PROTO = __webpack_require__(302)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(184);
var defined = __webpack_require__(82);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_Model_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataDiffer_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_dataProvider_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_dimensionHelper_js__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SeriesDimensionDefine_js__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_types_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Source_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DataStore_js__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helper_SeriesDataSchema_js__ = __webpack_require__(333);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/* global Int32Array */












var isObject = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"];
var map = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"];
var CtorInt32Array = typeof Int32Array === 'undefined' ? Array : Int32Array; // Use prefix to avoid index to be the same as otherIdList[idx],
// which will cause weird udpate animation.

var ID_PREFIX = 'e\0\0';
var INDEX_NOT_FOUND = -1; // type SeriesDimensionIndex = DimensionIndex;

var TRANSFERABLE_PROPERTIES = ['hasItemOption', '_nameList', '_idList', '_invertedIndicesMap', '_dimSummary', 'userOutput', '_rawData', '_dimValueGetter', '_nameDimIdx', '_idDimIdx', '_nameRepeatCount'];
var CLONE_PROPERTIES = ['_approximateExtent']; // -----------------------------
// Internal method declarations:
// -----------------------------

var prepareInvertedIndex;
var getId;
var getIdNameFromStore;
var normalizeDimensions;
var transferProperties;
var cloneListForMapAndSample;
var makeIdFromName;

var SeriesData =
/** @class */
function () {
  /**
   * @param dimensionsInput.dimensions
   *        For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
   *        Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
   */
  function SeriesData(dimensionsInput, hostModel) {
    this.type = 'list';
    this._dimOmitted = false;
    this._nameList = [];
    this._idList = []; // Models of data option is stored sparse for optimizing memory cost
    // Never used yet (not used yet).
    // private _optionModels: Model[] = [];
    // Global visual properties after visual coding

    this._visual = {}; // Globel layout properties.

    this._layout = {}; // Item visual properties after visual coding

    this._itemVisuals = []; // Item layout properties after layout

    this._itemLayouts = []; // Graphic elemnents

    this._graphicEls = []; // key: dim, value: extent

    this._approximateExtent = {};
    this._calculationInfo = {}; // Having detected that there is data item is non primitive type
    // (in type `OptionDataItemObject`).
    // Like `data: [ { value: xx, itemStyle: {...} }, ...]`
    // At present it only happen in `SOURCE_FORMAT_ORIGINAL`.

    this.hasItemOption = false; // Methods that create a new list based on this list should be listed here.
    // Notice that those method should `RETURN` the new list.

    this.TRANSFERABLE_METHODS = ['cloneShallow', 'downSample', 'lttbDownSample', 'map']; // Methods that change indices of this list should be listed here.

    this.CHANGABLE_METHODS = ['filterSelf', 'selectRange'];
    this.DOWNSAMPLE_METHODS = ['downSample', 'lttbDownSample'];
    var dimensions;
    var assignStoreDimIdx = false;

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__helper_SeriesDataSchema_js__["a" /* isSeriesDataSchema */])(dimensionsInput)) {
      dimensions = dimensionsInput.dimensions;
      this._dimOmitted = dimensionsInput.isDimensionOmitted();
      this._schema = dimensionsInput;
    } else {
      assignStoreDimIdx = true;
      dimensions = dimensionsInput;
    }

    dimensions = dimensions || ['x', 'y'];
    var dimensionInfos = {};
    var dimensionNames = [];
    var invertedIndicesMap = {};
    var needsHasOwn = false;
    var emptyObj = {};

    for (var i = 0; i < dimensions.length; i++) {
      // Use the original dimensions[i], where other flag props may exists.
      var dimInfoInput = dimensions[i];
      var dimensionInfo = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"](dimInfoInput) ? new __WEBPACK_IMPORTED_MODULE_5__SeriesDimensionDefine_js__["a" /* default */]({
        name: dimInfoInput
      }) : !(dimInfoInput instanceof __WEBPACK_IMPORTED_MODULE_5__SeriesDimensionDefine_js__["a" /* default */]) ? new __WEBPACK_IMPORTED_MODULE_5__SeriesDimensionDefine_js__["a" /* default */](dimInfoInput) : dimInfoInput;
      var dimensionName = dimensionInfo.name;
      dimensionInfo.type = dimensionInfo.type || 'float';

      if (!dimensionInfo.coordDim) {
        dimensionInfo.coordDim = dimensionName;
        dimensionInfo.coordDimIndex = 0;
      }

      var otherDims = dimensionInfo.otherDims = dimensionInfo.otherDims || {};
      dimensionNames.push(dimensionName);
      dimensionInfos[dimensionName] = dimensionInfo;

      if (emptyObj[dimensionName] != null) {
        needsHasOwn = true;
      }

      if (dimensionInfo.createInvertedIndices) {
        invertedIndicesMap[dimensionName] = [];
      }

      if (otherDims.itemName === 0) {
        this._nameDimIdx = i;
      }

      if (otherDims.itemId === 0) {
        this._idDimIdx = i;
      }

      if (true) {
        __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"](assignStoreDimIdx || dimensionInfo.storeDimIndex >= 0);
      }

      if (assignStoreDimIdx) {
        dimensionInfo.storeDimIndex = i;
      }
    }

    this.dimensions = dimensionNames;
    this._dimInfos = dimensionInfos;

    this._initGetDimensionInfo(needsHasOwn);

    this.hostModel = hostModel;
    this._invertedIndicesMap = invertedIndicesMap;

    if (this._dimOmitted) {
      var dimIdxToName_1 = this._dimIdxToName = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"]();
      __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](dimensionNames, function (dimName) {
        dimIdxToName_1.set(dimensionInfos[dimName].storeDimIndex, dimName);
      });
    }
  }
  /**
   *
   * Get concrete dimension name by dimension name or dimension index.
   * If input a dimension name, do not validate whether the dimension name exits.
   *
   * @caution
   * @param dim Must make sure the dimension is `SeriesDimensionLoose`.
   * Because only those dimensions will have auto-generated dimension names if not
   * have a user-specified name, and other dimensions will get a return of null/undefined.
   *
   * @notice Becuause of this reason, should better use `getDimensionIndex` instead, for examples:
   * ```js
   * const val = data.getStore().get(data.getDimensionIndex(dim), dataIdx);
   * ```
   *
   * @return Concrete dim name.
   */


  SeriesData.prototype.getDimension = function (dim) {
    var dimIdx = this._recognizeDimIndex(dim);

    if (dimIdx == null) {
      return dim;
    }

    dimIdx = dim;

    if (!this._dimOmitted) {
      return this.dimensions[dimIdx];
    } // Retrieve from series dimension definition becuase it probably contains
    // generated dimension name (like 'x', 'y').


    var dimName = this._dimIdxToName.get(dimIdx);

    if (dimName != null) {
      return dimName;
    }

    var sourceDimDef = this._schema.getSourceDimension(dimIdx);

    if (sourceDimDef) {
      return sourceDimDef.name;
    }
  };
  /**
   * Get dimension index in data store. Return -1 if not found.
   * Can be used to index value from getRawValue.
   */


  SeriesData.prototype.getDimensionIndex = function (dim) {
    var dimIdx = this._recognizeDimIndex(dim);

    if (dimIdx != null) {
      return dimIdx;
    }

    if (dim == null) {
      return -1;
    }

    var dimInfo = this._getDimInfo(dim);

    return dimInfo ? dimInfo.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(dim) : -1;
  };
  /**
   * The meanings of the input parameter `dim`:
   *
   * + If dim is a number (e.g., `1`), it means the index of the dimension.
   *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
   * + If dim is a number-like string (e.g., `"1"`):
   *     + If there is the same concrete dim name defined in `series.dimensions` or `dataset.dimensions`,
   *        it means that concrete name.
   *     + If not, it will be converted to a number, which means the index of the dimension.
   *        (why? because of the backward compatbility. We have been tolerating number-like string in
   *        dimension setting, although now it seems that it is not a good idea.)
   *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
   *     if no dimension name is defined as `"1"`.
   * + If dim is a not-number-like string, it means the concrete dim name.
   *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
   *   or customized in `dimensions` property of option like `"age"`.
   *
   * @return recogonized `DimensionIndex`. Otherwise return null/undefined (means that dim is `DimensionName`).
   */


  SeriesData.prototype._recognizeDimIndex = function (dim) {
    if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isNumber"](dim) // If being a number-like string but not being defined as a dimension name.
    || dim != null && !isNaN(dim) && !this._getDimInfo(dim) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(dim) < 0)) {
      return +dim;
    }
  };

  SeriesData.prototype._getStoreDimIndex = function (dim) {
    var dimIdx = this.getDimensionIndex(dim);

    if (true) {
      if (dimIdx == null) {
        throw new Error('Unkown dimension ' + dim);
      }
    }

    return dimIdx;
  };
  /**
   * Get type and calculation info of particular dimension
   * @param dim
   *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
   *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
   */


  SeriesData.prototype.getDimensionInfo = function (dim) {
    // Do not clone, because there may be categories in dimInfo.
    return this._getDimInfo(this.getDimension(dim));
  };

  SeriesData.prototype._initGetDimensionInfo = function (needsHasOwn) {
    var dimensionInfos = this._dimInfos;
    this._getDimInfo = needsHasOwn ? function (dimName) {
      return dimensionInfos.hasOwnProperty(dimName) ? dimensionInfos[dimName] : undefined;
    } : function (dimName) {
      return dimensionInfos[dimName];
    };
  };
  /**
   * concrete dimension name list on coord.
   */


  SeriesData.prototype.getDimensionsOnCoord = function () {
    return this._dimSummary.dataDimsOnCoord.slice();
  };

  SeriesData.prototype.mapDimension = function (coordDim, idx) {
    var dimensionsSummary = this._dimSummary;

    if (idx == null) {
      return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
    }

    var dims = dimensionsSummary.encode[coordDim];
    return dims ? dims[idx] : null;
  };

  SeriesData.prototype.mapDimensionsAll = function (coordDim) {
    var dimensionsSummary = this._dimSummary;
    var dims = dimensionsSummary.encode[coordDim];
    return (dims || []).slice();
  };

  SeriesData.prototype.getStore = function () {
    return this._store;
  };
  /**
   * Initialize from data
   * @param data source or data or data store.
   * @param nameList The name of a datum is used on data diff and
   *        default label/tooltip.
   *        A name can be specified in encode.itemName,
   *        or dataItem.name (only for series option data),
   *        or provided in nameList from outside.
   */


  SeriesData.prototype.initData = function (data, nameList, dimValueGetter) {
    var _this = this;

    var store;

    if (data instanceof __WEBPACK_IMPORTED_MODULE_10__DataStore_js__["a" /* default */]) {
      store = data;
    }

    if (!store) {
      var dimensions = this.dimensions;
      var provider = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__Source_js__["a" /* isSourceInstance */])(data) || __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArrayLike"](data) ? new __WEBPACK_IMPORTED_MODULE_3__helper_dataProvider_js__["b" /* DefaultDataProvider */](data, dimensions.length) : data;
      store = new __WEBPACK_IMPORTED_MODULE_10__DataStore_js__["a" /* default */]();
      var dimensionInfos = map(dimensions, function (dimName) {
        return {
          type: _this._dimInfos[dimName].type,
          property: dimName
        };
      });
      store.initData(provider, dimensionInfos, dimValueGetter);
    }

    this._store = store; // Reset

    this._nameList = (nameList || []).slice();
    this._idList = [];
    this._nameRepeatCount = {};

    this._doInit(0, store.count()); // Cache summary info for fast visit. See "dimensionHelper".
    // Needs to be initialized after store is prepared.


    this._dimSummary = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helper_dimensionHelper_js__["a" /* summarizeDimensions */])(this, this._schema);
    this.userOutput = this._dimSummary.userOutput;
  };
  /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */


  SeriesData.prototype.appendData = function (data) {
    var range = this._store.appendData(data);

    this._doInit(range[0], range[1]);
  };
  /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   * This method does not modify `rawData` (`dataProvider`), but only
   * add values to store.
   *
   * The final count will be increased by `Math.max(values.length, names.length)`.
   *
   * @param values That is the SourceType: 'arrayRows', like
   *        [
   *            [12, 33, 44],
   *            [NaN, 43, 1],
   *            ['-', 'asdf', 0]
   *        ]
   *        Each item is exaclty cooresponding to a dimension.
   */


  SeriesData.prototype.appendValues = function (values, names) {
    var _a = this._store.appendValues(values, names.length),
        start = _a.start,
        end = _a.end;

    var shouldMakeIdFromName = this._shouldMakeIdFromName();

    this._updateOrdinalMeta();

    if (names) {
      for (var idx = start; idx < end; idx++) {
        var sourceIdx = idx - start;
        this._nameList[idx] = names[sourceIdx];

        if (shouldMakeIdFromName) {
          makeIdFromName(this, idx);
        }
      }
    }
  };

  SeriesData.prototype._updateOrdinalMeta = function () {
    var store = this._store;
    var dimensions = this.dimensions;

    for (var i = 0; i < dimensions.length; i++) {
      var dimInfo = this._dimInfos[dimensions[i]];

      if (dimInfo.ordinalMeta) {
        store.collectOrdinalMeta(dimInfo.storeDimIndex, dimInfo.ordinalMeta);
      }
    }
  };

  SeriesData.prototype._shouldMakeIdFromName = function () {
    var provider = this._store.getProvider();

    return this._idDimIdx == null && provider.getSource().sourceFormat !== __WEBPACK_IMPORTED_MODULE_6__util_types_js__["a" /* SOURCE_FORMAT_TYPED_ARRAY */] && !provider.fillStorage;
  };

  SeriesData.prototype._doInit = function (start, end) {
    if (start >= end) {
      return;
    }

    var store = this._store;
    var provider = store.getProvider();

    this._updateOrdinalMeta();

    var nameList = this._nameList;
    var idList = this._idList;
    var sourceFormat = provider.getSource().sourceFormat;
    var isFormatOriginal = sourceFormat === __WEBPACK_IMPORTED_MODULE_6__util_types_js__["g" /* SOURCE_FORMAT_ORIGINAL */]; // Each data item is value
    // [1, 2]
    // 2
    // Bar chart, line chart which uses category axis
    // only gives the 'y' value. 'x' value is the indices of category
    // Use a tempValue to normalize the value to be a (x, y) value
    // If dataItem is {name: ...} or {id: ...}, it has highest priority.
    // This kind of ids and names are always stored `_nameList` and `_idList`.

    if (isFormatOriginal && !provider.pure) {
      var sharedDataItem = [];

      for (var idx = start; idx < end; idx++) {
        // NOTICE: Try not to write things into dataItem
        var dataItem = provider.getItem(idx, sharedDataItem);

        if (!this.hasItemOption && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_model_js__["u" /* isDataItemOption */])(dataItem)) {
          this.hasItemOption = true;
        }

        if (dataItem) {
          var itemName = dataItem.name;

          if (nameList[idx] == null && itemName != null) {
            nameList[idx] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_model_js__["n" /* convertOptionIdName */])(itemName, null);
          }

          var itemId = dataItem.id;

          if (idList[idx] == null && itemId != null) {
            idList[idx] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_model_js__["n" /* convertOptionIdName */])(itemId, null);
          }
        }
      }
    }

    if (this._shouldMakeIdFromName()) {
      for (var idx = start; idx < end; idx++) {
        makeIdFromName(this, idx);
      }
    }

    prepareInvertedIndex(this);
  };
  /**
   * PENDING: In fact currently this function is only used to short-circuit
   * the calling of `scale.unionExtentFromData` when data have been filtered by modules
   * like "dataZoom". `scale.unionExtentFromData` is used to calculate data extent for series on
   * an axis, but if a "axis related data filter module" is used, the extent of the axis have
   * been fixed and no need to calling `scale.unionExtentFromData` actually.
   * But if we add "custom data filter" in future, which is not "axis related", this method may
   * be still needed.
   *
   * Optimize for the scenario that data is filtered by a given extent.
   * Consider that if data amount is more than hundreds of thousand,
   * extent calculation will cost more than 10ms and the cache will
   * be erased because of the filtering.
   */


  SeriesData.prototype.getApproximateExtent = function (dim) {
    return this._approximateExtent[dim] || this._store.getDataExtent(this._getStoreDimIndex(dim));
  };
  /**
   * Calculate extent on a filtered data might be time consuming.
   * Approximate extent is only used for: calculte extent of filtered data outside.
   */


  SeriesData.prototype.setApproximateExtent = function (extent, dim) {
    dim = this.getDimension(dim);
    this._approximateExtent[dim] = extent.slice();
  };

  SeriesData.prototype.getCalculationInfo = function (key) {
    return this._calculationInfo[key];
  };

  SeriesData.prototype.setCalculationInfo = function (key, value) {
    isObject(key) ? __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"](this._calculationInfo, key) : this._calculationInfo[key] = value;
  };
  /**
   * @return Never be null/undefined. `number` will be converted to string. Becuase:
   * In most cases, name is used in display, where returning a string is more convenient.
   * In other cases, name is used in query (see `indexOfName`), where we can keep the
   * rule that name `2` equals to name `'2'`.
   */


  SeriesData.prototype.getName = function (idx) {
    var rawIndex = this.getRawIndex(idx);
    var name = this._nameList[rawIndex];

    if (name == null && this._nameDimIdx != null) {
      name = getIdNameFromStore(this, this._nameDimIdx, rawIndex);
    }

    if (name == null) {
      name = '';
    }

    return name;
  };

  SeriesData.prototype._getCategory = function (dimIdx, idx) {
    var ordinal = this._store.get(dimIdx, idx);

    var ordinalMeta = this._store.getOrdinalMeta(dimIdx);

    if (ordinalMeta) {
      return ordinalMeta.categories[ordinal];
    }

    return ordinal;
  };
  /**
   * @return Never null/undefined. `number` will be converted to string. Becuase:
   * In all cases having encountered at present, id is used in making diff comparison, which
   * are usually based on hash map. We can keep the rule that the internal id are always string
   * (treat `2` is the same as `'2'`) to make the related logic simple.
   */


  SeriesData.prototype.getId = function (idx) {
    return getId(this, this.getRawIndex(idx));
  };

  SeriesData.prototype.count = function () {
    return this._store.count();
  };
  /**
   * Get value. Return NaN if idx is out of range.
   *
   * @notice Should better to use `data.getStore().get(dimIndex, dataIdx)` instead.
   */


  SeriesData.prototype.get = function (dim, idx) {
    var store = this._store;
    var dimInfo = this._dimInfos[dim];

    if (dimInfo) {
      return store.get(dimInfo.storeDimIndex, idx);
    }
  };
  /**
   * @notice Should better to use `data.getStore().getByRawIndex(dimIndex, dataIdx)` instead.
   */


  SeriesData.prototype.getByRawIndex = function (dim, rawIdx) {
    var store = this._store;
    var dimInfo = this._dimInfos[dim];

    if (dimInfo) {
      return store.getByRawIndex(dimInfo.storeDimIndex, rawIdx);
    }
  };

  SeriesData.prototype.getIndices = function () {
    return this._store.getIndices();
  };

  SeriesData.prototype.getDataExtent = function (dim) {
    return this._store.getDataExtent(this._getStoreDimIndex(dim));
  };

  SeriesData.prototype.getSum = function (dim) {
    return this._store.getSum(this._getStoreDimIndex(dim));
  };

  SeriesData.prototype.getMedian = function (dim) {
    return this._store.getMedian(this._getStoreDimIndex(dim));
  };

  SeriesData.prototype.getValues = function (dimensions, idx) {
    var _this = this;

    var store = this._store;
    return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](dimensions) ? store.getValues(map(dimensions, function (dim) {
      return _this._getStoreDimIndex(dim);
    }), idx) : store.getValues(dimensions);
  };
  /**
   * If value is NaN. Inlcuding '-'
   * Only check the coord dimensions.
   */


  SeriesData.prototype.hasValue = function (idx) {
    var dataDimIndicesOnCoord = this._dimSummary.dataDimIndicesOnCoord;

    for (var i = 0, len = dataDimIndicesOnCoord.length; i < len; i++) {
      // Ordinal type originally can be string or number.
      // But when an ordinal type is used on coord, it can
      // not be string but only number. So we can also use isNaN.
      if (isNaN(this._store.get(dataDimIndicesOnCoord[i], idx))) {
        return false;
      }
    }

    return true;
  };
  /**
   * Retreive the index with given name
   */


  SeriesData.prototype.indexOfName = function (name) {
    for (var i = 0, len = this._store.count(); i < len; i++) {
      if (this.getName(i) === name) {
        return i;
      }
    }

    return -1;
  };

  SeriesData.prototype.getRawIndex = function (idx) {
    return this._store.getRawIndex(idx);
  };

  SeriesData.prototype.indexOfRawIndex = function (rawIndex) {
    return this._store.indexOfRawIndex(rawIndex);
  };
  /**
   * Only support the dimension which inverted index created.
   * Do not support other cases until required.
   * @param dim concrete dim
   * @param value ordinal index
   * @return rawIndex
   */


  SeriesData.prototype.rawIndexOf = function (dim, value) {
    var invertedIndices = dim && this._invertedIndicesMap[dim];

    if (true) {
      if (!invertedIndices) {
        throw new Error('Do not supported yet');
      }
    }

    var rawIndex = invertedIndices[value];

    if (rawIndex == null || isNaN(rawIndex)) {
      return INDEX_NOT_FOUND;
    }

    return rawIndex;
  };
  /**
   * Retreive the index of nearest value
   * @param dim
   * @param value
   * @param [maxDistance=Infinity]
   * @return If and only if multiple indices has
   *         the same value, they are put to the result.
   */


  SeriesData.prototype.indicesOfNearest = function (dim, value, maxDistance) {
    return this._store.indicesOfNearest(this._getStoreDimIndex(dim), value, maxDistance);
  };

  SeriesData.prototype.each = function (dims, cb, ctx) {
    'use strict';

    if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"](dims)) {
      ctx = cb;
      cb = dims;
      dims = [];
    } // ctxCompat just for compat echarts3


    var fCtx = ctx || this;
    var dimIndices = map(normalizeDimensions(dims), this._getStoreDimIndex, this);

    this._store.each(dimIndices, fCtx ? __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["bind"](cb, fCtx) : cb);
  };

  SeriesData.prototype.filterSelf = function (dims, cb, ctx) {
    'use strict';

    if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"](dims)) {
      ctx = cb;
      cb = dims;
      dims = [];
    } // ctxCompat just for compat echarts3


    var fCtx = ctx || this;
    var dimIndices = map(normalizeDimensions(dims), this._getStoreDimIndex, this);
    this._store = this._store.filter(dimIndices, fCtx ? __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["bind"](cb, fCtx) : cb);
    return this;
  };
  /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */


  SeriesData.prototype.selectRange = function (range) {
    'use strict';

    var _this = this;

    var innerRange = {};
    var dims = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["keys"](range);
    var dimIndices = [];
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](dims, function (dim) {
      var dimIdx = _this._getStoreDimIndex(dim);

      innerRange[dimIdx] = range[dim];
      dimIndices.push(dimIdx);
    });
    this._store = this._store.selectRange(innerRange);
    return this;
  };
  /* eslint-enable max-len */


  SeriesData.prototype.mapArray = function (dims, cb, ctx) {
    'use strict';

    if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"](dims)) {
      ctx = cb;
      cb = dims;
      dims = [];
    } // ctxCompat just for compat echarts3


    ctx = ctx || this;
    var result = [];
    this.each(dims, function () {
      result.push(cb && cb.apply(this, arguments));
    }, ctx);
    return result;
  };

  SeriesData.prototype.map = function (dims, cb, ctx, ctxCompat) {
    'use strict'; // ctxCompat just for compat echarts3

    var fCtx = ctx || ctxCompat || this;
    var dimIndices = map(normalizeDimensions(dims), this._getStoreDimIndex, this);
    var list = cloneListForMapAndSample(this);
    list._store = this._store.map(dimIndices, fCtx ? __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["bind"](cb, fCtx) : cb);
    return list;
  };

  SeriesData.prototype.modify = function (dims, cb, ctx, ctxCompat) {
    var _this = this; // ctxCompat just for compat echarts3


    var fCtx = ctx || ctxCompat || this;

    if (true) {
      __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](normalizeDimensions(dims), function (dim) {
        var dimInfo = _this.getDimensionInfo(dim);

        if (!dimInfo.isCalculationCoord) {
          console.error('Danger: only stack dimension can be modified');
        }
      });
    }

    var dimIndices = map(normalizeDimensions(dims), this._getStoreDimIndex, this); // If do shallow clone here, if there are too many stacked series,
    // it still cost lots of memory, becuase `_store.dimensions` are not shared.
    // We should consider there probably be shallow clone happen in each sereis
    // in consequent filter/map.

    this._store.modify(dimIndices, fCtx ? __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["bind"](cb, fCtx) : cb);
  };
  /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */


  SeriesData.prototype.downSample = function (dimension, rate, sampleValue, sampleIndex) {
    var list = cloneListForMapAndSample(this);
    list._store = this._store.downSample(this._getStoreDimIndex(dimension), rate, sampleValue, sampleIndex);
    return list;
  };
  /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */


  SeriesData.prototype.lttbDownSample = function (valueDimension, rate) {
    var list = cloneListForMapAndSample(this);
    list._store = this._store.lttbDownSample(this._getStoreDimIndex(valueDimension), rate);
    return list;
  };

  SeriesData.prototype.getRawDataItem = function (idx) {
    return this._store.getRawDataItem(idx);
  };
  /**
   * Get model of one data item.
   */
  // TODO: Type of data item


  SeriesData.prototype.getItemModel = function (idx) {
    var hostModel = this.hostModel;
    var dataItem = this.getRawDataItem(idx);
    return new __WEBPACK_IMPORTED_MODULE_1__model_Model_js__["a" /* default */](dataItem, hostModel, hostModel && hostModel.ecModel);
  };
  /**
   * Create a data differ
   */


  SeriesData.prototype.diff = function (otherList) {
    var thisList = this;
    return new __WEBPACK_IMPORTED_MODULE_2__DataDiffer_js__["a" /* default */](otherList ? otherList.getStore().getIndices() : [], this.getStore().getIndices(), function (idx) {
      return getId(otherList, idx);
    }, function (idx) {
      return getId(thisList, idx);
    });
  };
  /**
   * Get visual property.
   */


  SeriesData.prototype.getVisual = function (key) {
    var visual = this._visual;
    return visual && visual[key];
  };

  SeriesData.prototype.setVisual = function (kvObj, val) {
    this._visual = this._visual || {};

    if (isObject(kvObj)) {
      __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"](this._visual, kvObj);
    } else {
      this._visual[kvObj] = val;
    }
  };
  /**
   * Get visual property of single data item
   */
  // eslint-disable-next-line


  SeriesData.prototype.getItemVisual = function (idx, key) {
    var itemVisual = this._itemVisuals[idx];
    var val = itemVisual && itemVisual[key];

    if (val == null) {
      // Use global visual property
      return this.getVisual(key);
    }

    return val;
  };
  /**
   * If exists visual property of single data item
   */


  SeriesData.prototype.hasItemVisual = function () {
    return this._itemVisuals.length > 0;
  };
  /**
   * Make sure itemVisual property is unique
   */
  // TODO: use key to save visual to reduce memory.


  SeriesData.prototype.ensureUniqueItemVisual = function (idx, key) {
    var itemVisuals = this._itemVisuals;
    var itemVisual = itemVisuals[idx];

    if (!itemVisual) {
      itemVisual = itemVisuals[idx] = {};
    }

    var val = itemVisual[key];

    if (val == null) {
      val = this.getVisual(key); // TODO Performance?

      if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](val)) {
        val = val.slice();
      } else if (isObject(val)) {
        val = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"]({}, val);
      }

      itemVisual[key] = val;
    }

    return val;
  }; // eslint-disable-next-line


  SeriesData.prototype.setItemVisual = function (idx, key, value) {
    var itemVisual = this._itemVisuals[idx] || {};
    this._itemVisuals[idx] = itemVisual;

    if (isObject(key)) {
      __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"](itemVisual, key);
    } else {
      itemVisual[key] = value;
    }
  };
  /**
   * Clear itemVisuals and list visual.
   */


  SeriesData.prototype.clearAllVisual = function () {
    this._visual = {};
    this._itemVisuals = [];
  };

  SeriesData.prototype.setLayout = function (key, val) {
    isObject(key) ? __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"](this._layout, key) : this._layout[key] = val;
  };
  /**
   * Get layout property.
   */


  SeriesData.prototype.getLayout = function (key) {
    return this._layout[key];
  };
  /**
   * Get layout of single data item
   */


  SeriesData.prototype.getItemLayout = function (idx) {
    return this._itemLayouts[idx];
  };
  /**
   * Set layout of single data item
   */


  SeriesData.prototype.setItemLayout = function (idx, layout, merge) {
    this._itemLayouts[idx] = merge ? __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"](this._itemLayouts[idx] || {}, layout) : layout;
  };
  /**
   * Clear all layout of single data item
   */


  SeriesData.prototype.clearItemLayouts = function () {
    this._itemLayouts.length = 0;
  };
  /**
   * Set graphic element relative to data. It can be set as null
   */


  SeriesData.prototype.setItemGraphicEl = function (idx, el) {
    var seriesIndex = this.hostModel && this.hostModel.seriesIndex;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_innerStore_js__["b" /* setCommonECData */])(seriesIndex, this.dataType, idx, el);
    this._graphicEls[idx] = el;
  };

  SeriesData.prototype.getItemGraphicEl = function (idx) {
    return this._graphicEls[idx];
  };

  SeriesData.prototype.eachItemGraphicEl = function (cb, context) {
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](this._graphicEls, function (el, idx) {
      if (el) {
        cb && cb.call(context, el, idx);
      }
    });
  };
  /**
   * Shallow clone a new list except visual and layout properties, and graph elements.
   * New list only change the indices.
   */


  SeriesData.prototype.cloneShallow = function (list) {
    if (!list) {
      list = new SeriesData(this._schema ? this._schema : map(this.dimensions, this._getDimInfo, this), this.hostModel);
    }

    transferProperties(list, this);
    list._store = this._store;
    return list;
  };
  /**
   * Wrap some method to add more feature
   */


  SeriesData.prototype.wrapMethod = function (methodName, injectFunction) {
    var originalMethod = this[methodName];

    if (!__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"](originalMethod)) {
      return;
    }

    this.__wrappedMethods = this.__wrappedMethods || [];

    this.__wrappedMethods.push(methodName);

    this[methodName] = function () {
      var res = originalMethod.apply(this, arguments);
      return injectFunction.apply(this, [res].concat(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["slice"](arguments)));
    };
  }; // ----------------------------------------------------------
  // A work around for internal method visiting private member.
  // ----------------------------------------------------------


  SeriesData.internalField = function () {
    prepareInvertedIndex = function (data) {
      var invertedIndicesMap = data._invertedIndicesMap;
      __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](invertedIndicesMap, function (invertedIndices, dim) {
        var dimInfo = data._dimInfos[dim]; // Currently, only dimensions that has ordinalMeta can create inverted indices.

        var ordinalMeta = dimInfo.ordinalMeta;
        var store = data._store;

        if (ordinalMeta) {
          invertedIndices = invertedIndicesMap[dim] = new CtorInt32Array(ordinalMeta.categories.length); // The default value of TypedArray is 0. To avoid miss
          // mapping to 0, we should set it as INDEX_NOT_FOUND.

          for (var i = 0; i < invertedIndices.length; i++) {
            invertedIndices[i] = INDEX_NOT_FOUND;
          }

          for (var i = 0; i < store.count(); i++) {
            // Only support the case that all values are distinct.
            invertedIndices[store.get(dimInfo.storeDimIndex, i)] = i;
          }
        }
      });
    };

    getIdNameFromStore = function (data, dimIdx, idx) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_model_js__["n" /* convertOptionIdName */])(data._getCategory(dimIdx, idx), null);
    };
    /**
     * @see the comment of `List['getId']`.
     */


    getId = function (data, rawIndex) {
      var id = data._idList[rawIndex];

      if (id == null && data._idDimIdx != null) {
        id = getIdNameFromStore(data, data._idDimIdx, rawIndex);
      }

      if (id == null) {
        id = ID_PREFIX + rawIndex;
      }

      return id;
    };

    normalizeDimensions = function (dimensions) {
      if (!__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](dimensions)) {
        dimensions = dimensions != null ? [dimensions] : [];
      }

      return dimensions;
    };
    /**
     * Data in excludeDimensions is copied, otherwise transfered.
     */


    cloneListForMapAndSample = function (original) {
      var list = new SeriesData(original._schema ? original._schema : map(original.dimensions, original._getDimInfo, original), original.hostModel); // FIXME If needs stackedOn, value may already been stacked

      transferProperties(list, original);
      return list;
    };

    transferProperties = function (target, source) {
      __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function (propName) {
        if (source.hasOwnProperty(propName)) {
          target[propName] = source[propName];
        }
      });
      target.__wrappedMethods = source.__wrappedMethods;
      __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](CLONE_PROPERTIES, function (propName) {
        target[propName] = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["clone"](source[propName]);
      });
      target._calculationInfo = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"]({}, source._calculationInfo);
    };

    makeIdFromName = function (data, idx) {
      var nameList = data._nameList;
      var idList = data._idList;
      var nameDimIdx = data._nameDimIdx;
      var idDimIdx = data._idDimIdx;
      var name = nameList[idx];
      var id = idList[idx];

      if (name == null && nameDimIdx != null) {
        nameList[idx] = name = getIdNameFromStore(data, nameDimIdx, idx);
      }

      if (id == null && idDimIdx != null) {
        idList[idx] = id = getIdNameFromStore(data, idDimIdx, idx);
      }

      if (id == null && name != null) {
        var nameRepeatCount = data._nameRepeatCount;
        var nmCnt = nameRepeatCount[name] = (nameRepeatCount[name] || 0) + 1;
        id = name;

        if (nmCnt > 1) {
          id += '__ec__' + nmCnt;
        }

        idList[idx] = id;
      }
    };
  }();

  return SeriesData;
}();

/* harmony default export */ __webpack_exports__["a"] = (SeriesData);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return VISUAL_DIMENSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SOURCE_FORMAT_ORIGINAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SOURCE_FORMAT_ARRAY_ROWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SOURCE_FORMAT_OBJECT_ROWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SOURCE_FORMAT_KEYED_COLUMNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SOURCE_FORMAT_TYPED_ARRAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SOURCE_FORMAT_UNKNOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SERIES_LAYOUT_BY_COLUMN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SERIES_LAYOUT_BY_ROW; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

;
;
;
var VISUAL_DIMENSIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])(['tooltip', 'label', 'itemName', 'itemId', 'itemGroupId', 'seriesName']);
var SOURCE_FORMAT_ORIGINAL = 'original';
var SOURCE_FORMAT_ARRAY_ROWS = 'arrayRows';
var SOURCE_FORMAT_OBJECT_ROWS = 'objectRows';
var SOURCE_FORMAT_KEYED_COLUMNS = 'keyedColumns';
var SOURCE_FORMAT_TYPED_ARRAY = 'typedArray';
var SOURCE_FORMAT_UNKNOWN = 'unknown';
var SERIES_LAYOUT_BY_COLUMN = 'column';
var SERIES_LAYOUT_BY_ROW = 'row';
;
;
;
;

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEFAULT_FONT_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DEFAULT_FONT_FAMILY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_FONT; });
/* unused harmony export DEFAULT_TEXT_WIDTH_MAP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return platformApi; });
/* harmony export (immutable) */ __webpack_exports__["d"] = setPlatformAPI;
var DEFAULT_FONT_SIZE = 12;
var DEFAULT_FONT_FAMILY = 'sans-serif';
var DEFAULT_FONT = DEFAULT_FONT_SIZE + "px " + DEFAULT_FONT_FAMILY;
var OFFSET = 20;
var SCALE = 100;
var defaultWidthMapStr = "007LLmW'55;N0500LLLLLLLLLL00NNNLzWW\\\\WQb\\0FWLg\\bWb\\WQ\\WrWWQ000CL5LLFLL0LL**F*gLLLL5F0LF\\FFF5.5N";
function getTextWidthMap(mapStr) {
    var map = {};
    if (typeof JSON === 'undefined') {
        return map;
    }
    for (var i = 0; i < mapStr.length; i++) {
        var char = String.fromCharCode(i + 32);
        var size = (mapStr.charCodeAt(i) - OFFSET) / SCALE;
        map[char] = size;
    }
    return map;
}
var DEFAULT_TEXT_WIDTH_MAP = getTextWidthMap(defaultWidthMapStr);
var platformApi = {
    createCanvas: function () {
        return typeof document !== 'undefined'
            && document.createElement('canvas');
    },
    measureText: (function () {
        var _ctx;
        var _cachedFont;
        return function (text, font) {
            if (!_ctx) {
                var canvas = platformApi.createCanvas();
                _ctx = canvas && canvas.getContext('2d');
            }
            if (_ctx) {
                if (_cachedFont !== font) {
                    _cachedFont = _ctx.font = font || DEFAULT_FONT;
                }
                return _ctx.measureText(text);
            }
            else {
                text = text || '';
                font = font || DEFAULT_FONT;
                var res = /^([0-9]*?)px$/.exec(font);
                var fontSize = +(res && res[1]) || DEFAULT_FONT_SIZE;
                var width = 0;
                if (font.indexOf('mono') >= 0) {
                    width = fontSize * text.length;
                }
                else {
                    for (var i = 0; i < text.length; i++) {
                        var preCalcWidth = DEFAULT_TEXT_WIDTH_MAP[text[i]];
                        width += preCalcWidth == null ? fontSize : (preCalcWidth * fontSize);
                    }
                }
                return { width: width };
            }
        };
    })(),
    loadImage: function (src, onload, onerror) {
        var image = new Image();
        image.onload = onload;
        image.onerror = onerror;
        image.src = src;
        return image;
    }
};
function setPlatformAPI(newPlatformApis) {
    for (var key in platformApi) {
        if (newPlatformApis[key]) {
            platformApi[key] = newPlatformApis[key];
        }
    }
}


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_COMMON_STYLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_COMMON_ANIMATION_PROPS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Element_js__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_js__ = __webpack_require__(139);





var STYLE_MAGIC_KEY = '__zr_style_' + Math.round((Math.random() * 10));
var DEFAULT_COMMON_STYLE = {
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: '#000',
    opacity: 1,
    blend: 'source-over'
};
var DEFAULT_COMMON_ANIMATION_PROPS = {
    style: {
        shadowBlur: true,
        shadowOffsetX: true,
        shadowOffsetY: true,
        shadowColor: true,
        opacity: true
    }
};
DEFAULT_COMMON_STYLE[STYLE_MAGIC_KEY] = true;
var PRIMARY_STATES_KEYS = ['z', 'z2', 'invisible'];
var PRIMARY_STATES_KEYS_IN_HOVER_LAYER = ['invisible'];
var Displayable = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Displayable, _super);
    function Displayable(props) {
        return _super.call(this, props) || this;
    }
    Displayable.prototype._init = function (props) {
        var keysArr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["keys"])(props);
        for (var i = 0; i < keysArr.length; i++) {
            var key = keysArr[i];
            if (key === 'style') {
                this.useStyle(props[key]);
            }
            else {
                _super.prototype.attrKV.call(this, key, props[key]);
            }
        }
        if (!this.style) {
            this.useStyle({});
        }
    };
    Displayable.prototype.beforeBrush = function () { };
    Displayable.prototype.afterBrush = function () { };
    Displayable.prototype.innerBeforeBrush = function () { };
    Displayable.prototype.innerAfterBrush = function () { };
    Displayable.prototype.shouldBePainted = function (viewWidth, viewHeight, considerClipPath, considerAncestors) {
        var m = this.transform;
        if (this.ignore
            || this.invisible
            || this.style.opacity === 0
            || (this.culling
                && isDisplayableCulled(this, viewWidth, viewHeight))
            || (m && !m[0] && !m[3])) {
            return false;
        }
        if (considerClipPath && this.__clipPaths) {
            for (var i = 0; i < this.__clipPaths.length; ++i) {
                if (this.__clipPaths[i].isZeroArea()) {
                    return false;
                }
            }
        }
        if (considerAncestors && this.parent) {
            var parent_1 = this.parent;
            while (parent_1) {
                if (parent_1.ignore) {
                    return false;
                }
                parent_1 = parent_1.parent;
            }
        }
        return true;
    };
    Displayable.prototype.contain = function (x, y) {
        return this.rectContain(x, y);
    };
    Displayable.prototype.traverse = function (cb, context) {
        cb.call(context, this);
    };
    Displayable.prototype.rectContain = function (x, y) {
        var coord = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        return rect.contain(coord[0], coord[1]);
    };
    Displayable.prototype.getPaintRect = function () {
        var rect = this._paintRect;
        if (!this._paintRect || this.__dirty) {
            var transform = this.transform;
            var elRect = this.getBoundingRect();
            var style = this.style;
            var shadowSize = style.shadowBlur || 0;
            var shadowOffsetX = style.shadowOffsetX || 0;
            var shadowOffsetY = style.shadowOffsetY || 0;
            rect = this._paintRect || (this._paintRect = new __WEBPACK_IMPORTED_MODULE_2__core_BoundingRect_js__["a" /* default */](0, 0, 0, 0));
            if (transform) {
                __WEBPACK_IMPORTED_MODULE_2__core_BoundingRect_js__["a" /* default */].applyTransform(rect, elRect, transform);
            }
            else {
                rect.copy(elRect);
            }
            if (shadowSize || shadowOffsetX || shadowOffsetY) {
                rect.width += shadowSize * 2 + Math.abs(shadowOffsetX);
                rect.height += shadowSize * 2 + Math.abs(shadowOffsetY);
                rect.x = Math.min(rect.x, rect.x + shadowOffsetX - shadowSize);
                rect.y = Math.min(rect.y, rect.y + shadowOffsetY - shadowSize);
            }
            var tolerance = this.dirtyRectTolerance;
            if (!rect.isZero()) {
                rect.x = Math.floor(rect.x - tolerance);
                rect.y = Math.floor(rect.y - tolerance);
                rect.width = Math.ceil(rect.width + 1 + tolerance * 2);
                rect.height = Math.ceil(rect.height + 1 + tolerance * 2);
            }
        }
        return rect;
    };
    Displayable.prototype.setPrevPaintRect = function (paintRect) {
        if (paintRect) {
            this._prevPaintRect = this._prevPaintRect || new __WEBPACK_IMPORTED_MODULE_2__core_BoundingRect_js__["a" /* default */](0, 0, 0, 0);
            this._prevPaintRect.copy(paintRect);
        }
        else {
            this._prevPaintRect = null;
        }
    };
    Displayable.prototype.getPrevPaintRect = function () {
        return this._prevPaintRect;
    };
    Displayable.prototype.animateStyle = function (loop) {
        return this.animate('style', loop);
    };
    Displayable.prototype.updateDuringAnimation = function (targetKey) {
        if (targetKey === 'style') {
            this.dirtyStyle();
        }
        else {
            this.markRedraw();
        }
    };
    Displayable.prototype.attrKV = function (key, value) {
        if (key !== 'style') {
            _super.prototype.attrKV.call(this, key, value);
        }
        else {
            if (!this.style) {
                this.useStyle(value);
            }
            else {
                this.setStyle(value);
            }
        }
    };
    Displayable.prototype.setStyle = function (keyOrObj, value) {
        if (typeof keyOrObj === 'string') {
            this.style[keyOrObj] = value;
        }
        else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["extend"])(this.style, keyOrObj);
        }
        this.dirtyStyle();
        return this;
    };
    Displayable.prototype.dirtyStyle = function (notRedraw) {
        if (!notRedraw) {
            this.markRedraw();
        }
        this.__dirty |= __WEBPACK_IMPORTED_MODULE_4__constants_js__["c" /* STYLE_CHANGED_BIT */];
        if (this._rect) {
            this._rect = null;
        }
    };
    Displayable.prototype.dirty = function () {
        this.dirtyStyle();
    };
    Displayable.prototype.styleChanged = function () {
        return !!(this.__dirty & __WEBPACK_IMPORTED_MODULE_4__constants_js__["c" /* STYLE_CHANGED_BIT */]);
    };
    Displayable.prototype.styleUpdated = function () {
        this.__dirty &= ~__WEBPACK_IMPORTED_MODULE_4__constants_js__["c" /* STYLE_CHANGED_BIT */];
    };
    Displayable.prototype.createStyle = function (obj) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["createObject"])(DEFAULT_COMMON_STYLE, obj);
    };
    Displayable.prototype.useStyle = function (obj) {
        if (!obj[STYLE_MAGIC_KEY]) {
            obj = this.createStyle(obj);
        }
        if (this.__inHover) {
            this.__hoverStyle = obj;
        }
        else {
            this.style = obj;
        }
        this.dirtyStyle();
    };
    Displayable.prototype.isStyleObject = function (obj) {
        return obj[STYLE_MAGIC_KEY];
    };
    Displayable.prototype._innerSaveToNormal = function (toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.style && !normalState.style) {
            normalState.style = this._mergeStyle(this.createStyle(), this.style);
        }
        this._savePrimaryToNormal(toState, normalState, PRIMARY_STATES_KEYS);
    };
    Displayable.prototype._applyStateObj = function (stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetStyle;
        if (state && state.style) {
            if (transition) {
                if (keepCurrentStates) {
                    targetStyle = state.style;
                }
                else {
                    targetStyle = this._mergeStyle(this.createStyle(), normalState.style);
                    this._mergeStyle(targetStyle, state.style);
                }
            }
            else {
                targetStyle = this._mergeStyle(this.createStyle(), keepCurrentStates ? this.style : normalState.style);
                this._mergeStyle(targetStyle, state.style);
            }
        }
        else if (needsRestoreToNormal) {
            targetStyle = normalState.style;
        }
        if (targetStyle) {
            if (transition) {
                var sourceStyle = this.style;
                this.style = this.createStyle(needsRestoreToNormal ? {} : sourceStyle);
                if (needsRestoreToNormal) {
                    var changedKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["keys"])(sourceStyle);
                    for (var i = 0; i < changedKeys.length; i++) {
                        var key = changedKeys[i];
                        if (key in targetStyle) {
                            targetStyle[key] = targetStyle[key];
                            this.style[key] = sourceStyle[key];
                        }
                    }
                }
                var targetKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["keys"])(targetStyle);
                for (var i = 0; i < targetKeys.length; i++) {
                    var key = targetKeys[i];
                    this.style[key] = this.style[key];
                }
                this._transitionState(stateName, {
                    style: targetStyle
                }, animationCfg, this.getAnimationStyleProps());
            }
            else {
                this.useStyle(targetStyle);
            }
        }
        var statesKeys = this.__inHover ? PRIMARY_STATES_KEYS_IN_HOVER_LAYER : PRIMARY_STATES_KEYS;
        for (var i = 0; i < statesKeys.length; i++) {
            var key = statesKeys[i];
            if (state && state[key] != null) {
                this[key] = state[key];
            }
            else if (needsRestoreToNormal) {
                if (normalState[key] != null) {
                    this[key] = normalState[key];
                }
            }
        }
    };
    Displayable.prototype._mergeStates = function (states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedStyle;
        for (var i = 0; i < states.length; i++) {
            var state = states[i];
            if (state.style) {
                mergedStyle = mergedStyle || {};
                this._mergeStyle(mergedStyle, state.style);
            }
        }
        if (mergedStyle) {
            mergedState.style = mergedStyle;
        }
        return mergedState;
    };
    Displayable.prototype._mergeStyle = function (targetStyle, sourceStyle) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["extend"])(targetStyle, sourceStyle);
        return targetStyle;
    };
    Displayable.prototype.getAnimationStyleProps = function () {
        return DEFAULT_COMMON_ANIMATION_PROPS;
    };
    Displayable.initDefaultProps = (function () {
        var dispProto = Displayable.prototype;
        dispProto.type = 'displayable';
        dispProto.invisible = false;
        dispProto.z = 0;
        dispProto.z2 = 0;
        dispProto.zlevel = 0;
        dispProto.culling = false;
        dispProto.cursor = 'pointer';
        dispProto.rectHover = false;
        dispProto.incremental = false;
        dispProto._rect = null;
        dispProto.dirtyRectTolerance = 0;
        dispProto.__dirty = __WEBPACK_IMPORTED_MODULE_4__constants_js__["a" /* REDRAW_BIT */] | __WEBPACK_IMPORTED_MODULE_4__constants_js__["c" /* STYLE_CHANGED_BIT */];
    })();
    return Displayable;
}(__WEBPACK_IMPORTED_MODULE_1__Element_js__["a" /* default */]));
var tmpRect = new __WEBPACK_IMPORTED_MODULE_2__core_BoundingRect_js__["a" /* default */](0, 0, 0, 0);
var viewRect = new __WEBPACK_IMPORTED_MODULE_2__core_BoundingRect_js__["a" /* default */](0, 0, 0, 0);
function isDisplayableCulled(el, width, height) {
    tmpRect.copy(el.getBoundingRect());
    if (el.transform) {
        tmpRect.applyTransform(el.transform);
    }
    viewRect.width = width;
    viewRect.height = height;
    return !tmpRect.intersect(viewRect);
}
/* harmony default export */ __webpack_exports__["c"] = (Displayable);


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = ({
  list: function list(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/meeting/pubMeeting/myMeetingList', params);
  },
  add: function add(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].post('/rocheManage/meeting/pubMeeting/add', params);
  },
  edit: function edit(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].put('/rocheManage/meeting/pubMeeting/edit', params);
  },
  delete: function _delete(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].delete('/rocheManage/meeting/pubMeeting/delete', params);
  },
  exportXls: function exportXls(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/meeting/pubMeeting/myMeetingExportXls', params, { responseType: 'blob' });
  },
  batchSubmit: function batchSubmit(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].put('/rocheManage/meeting/pubMeeting/myMeetingSubmit', params);
  },
  cancle: function cancle(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].delete('/rocheManage/meeting/pubMeeting/cancelBatch', params);
  },
  queryById: function queryById(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/meeting/pubMeeting/queryById', params);
  },
  queryMainApplication: function queryMainApplication(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/meeting/pubMeeting/myMeetingSummary', params);
  },
  getCanCreateMeeting: function getCanCreateMeeting(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/meeting/pubMeeting/getCanCreateMeeting', params);
  },
  filterMeetingCode: function filterMeetingCode(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/meeting/pubMeeting/getMeetingCode', params);
  },
  filterMeetingCreator: function filterMeetingCreator(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/meeting/pubMeeting/getMeetingCreator', params);
  },
  filterMeetingOrganizer: function filterMeetingOrganizer(params) {
    params.name = params.name.toUpperCase();
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/meeting/pubMeeting/getMeetingOrganizer', params);
  },
  filterHospital: function filterHospital(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/external/externalHospital/list', params);
  },
  saveMeetingApprove: function saveMeetingApprove(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].post('/rocheManage/meeting/pubMeeting/saveMeetingApprove', params);
  },
  submitMeetingApprove: function submitMeetingApprove(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].post('/rocheManage/meeting/pubMeeting/submitMeetingApprove', params);
  },
  queryMeetingPropAndTypeSelect: function queryMeetingPropAndTypeSelect(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/meeting/pubMeeting/meetingPropAndTypeSelect', params);
  },
  queryAreaRelationList: function queryAreaRelationList(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/external/externalAreaRelation/list', params);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(119)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(94);
var IE8_DOM_DEFINE = __webpack_require__(389);
var toPrimitive = __webpack_require__(279);
var dP = Object.defineProperty;

exports.f = __webpack_require__(70) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(46);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(16);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = getScaleExtent;
/* harmony export (immutable) */ __webpack_exports__["g"] = niceScaleExtent;
/* harmony export (immutable) */ __webpack_exports__["f"] = createScaleByModel;
/* harmony export (immutable) */ __webpack_exports__["k"] = ifAxisCrossZero;
/* harmony export (immutable) */ __webpack_exports__["c"] = makeLabelFormatter;
/* harmony export (immutable) */ __webpack_exports__["e"] = getAxisRawValue;
/* harmony export (immutable) */ __webpack_exports__["j"] = estimateLabelUnionRect;
/* harmony export (immutable) */ __webpack_exports__["b"] = getOptionCategoryInterval;
/* harmony export (immutable) */ __webpack_exports__["d"] = shouldShowAllLabels;
/* harmony export (immutable) */ __webpack_exports__["i"] = getDataDimensionsOnAxis;
/* harmony export (immutable) */ __webpack_exports__["a"] = unionAxisExtentFromData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scale_Ordinal_js__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scale_Interval_js__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scale_Scale_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_barGrid_js__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scale_Time_js__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scale_Log_js__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_helper_dataStackHelper_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__scaleRawExtentInfo_js__ = __webpack_require__(487);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/










/**
 * Get axis scale extent before niced.
 * Item of returned array can only be number (including Infinity and NaN).
 *
 * Caution:
 * Precondition of calling this method:
 * The scale extent has been initialized using series data extent via
 * `scale.setExtent` or `scale.unionExtentFromData`;
 */

function getScaleExtent(scale, model) {
  var scaleType = scale.type;
  var rawExtentResult = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__scaleRawExtentInfo_js__["a" /* ensureScaleRawExtentInfo */])(scale, model, scale.getExtent()).calculate();
  scale.setBlank(rawExtentResult.isBlank);
  var min = rawExtentResult.min;
  var max = rawExtentResult.max; // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
  // is base axis
  // FIXME
  // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
  // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
  //     Should not depend on series type `bar`?
  // (3) Fix that might overlap when using dataZoom.
  // (4) Consider other chart types using `barGrid`?
  // See #6728, #4862, `test/bar-overflow-time-plot.html`

  var ecModel = model.ecModel;

  if (ecModel && scaleType === 'time'
  /*|| scaleType === 'interval' */
  ) {
    var barSeriesModels = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__layout_barGrid_js__["a" /* prepareLayoutBarSeries */])('bar', ecModel);
    var isBaseAxisAndHasBarSeries_1 = false;
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](barSeriesModels, function (seriesModel) {
      isBaseAxisAndHasBarSeries_1 = isBaseAxisAndHasBarSeries_1 || seriesModel.getBaseAxis() === model.axis;
    });

    if (isBaseAxisAndHasBarSeries_1) {
      // Calculate placement of bars on axis. TODO should be decoupled
      // with barLayout
      var barWidthAndOffset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__layout_barGrid_js__["b" /* makeColumnLayout */])(barSeriesModels); // Adjust axis min and max to account for overflow

      var adjustedScale = adjustScaleForOverflow(min, max, model, barWidthAndOffset);
      min = adjustedScale.min;
      max = adjustedScale.max;
    }
  }

  return {
    extent: [min, max],
    // "fix" means "fixed", the value should not be
    // changed in the subsequent steps.
    fixMin: rawExtentResult.minFixed,
    fixMax: rawExtentResult.maxFixed
  };
}

function adjustScaleForOverflow(min, max, model, // Only support cartesian coord yet.
barWidthAndOffset) {
  // Get Axis Length
  var axisExtent = model.axis.getExtent();
  var axisLength = axisExtent[1] - axisExtent[0]; // Get bars on current base axis and calculate min and max overflow

  var barsOnCurrentAxis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__layout_barGrid_js__["c" /* retrieveColumnLayout */])(barWidthAndOffset, model.axis);

  if (barsOnCurrentAxis === undefined) {
    return {
      min: min,
      max: max
    };
  }

  var minOverflow = Infinity;
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](barsOnCurrentAxis, function (item) {
    minOverflow = Math.min(item.offset, minOverflow);
  });
  var maxOverflow = -Infinity;
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](barsOnCurrentAxis, function (item) {
    maxOverflow = Math.max(item.offset + item.width, maxOverflow);
  });
  minOverflow = Math.abs(minOverflow);
  maxOverflow = Math.abs(maxOverflow);
  var totalOverFlow = minOverflow + maxOverflow; // Calculate required buffer based on old range and overflow

  var oldRange = max - min;
  var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
  var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
  max += overflowBuffer * (maxOverflow / totalOverFlow);
  min -= overflowBuffer * (minOverflow / totalOverFlow);
  return {
    min: min,
    max: max
  };
} // Precondition of calling this method:
// The scale extent has been initailized using series data extent via
// `scale.setExtent` or `scale.unionExtentFromData`;


function niceScaleExtent(scale, inModel) {
  var model = inModel;
  var extentInfo = getScaleExtent(scale, model);
  var extent = extentInfo.extent;
  var splitNumber = model.get('splitNumber');

  if (scale instanceof __WEBPACK_IMPORTED_MODULE_7__scale_Log_js__["a" /* default */]) {
    scale.base = model.get('logBase');
  }

  var scaleType = scale.type;
  var interval = model.get('interval');
  var isIntervalOrTime = scaleType === 'interval' || scaleType === 'time';
  scale.setExtent(extent[0], extent[1]);
  scale.calcNiceExtent({
    splitNumber: splitNumber,
    fixMin: extentInfo.fixMin,
    fixMax: extentInfo.fixMax,
    minInterval: isIntervalOrTime ? model.get('minInterval') : null,
    maxInterval: isIntervalOrTime ? model.get('maxInterval') : null
  }); // If some one specified the min, max. And the default calculated interval
  // is not good enough. He can specify the interval. It is often appeared
  // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
  // to be 60.
  // FIXME

  if (interval != null) {
    scale.setInterval && scale.setInterval(interval);
  }
}
/**
 * @param axisType Default retrieve from model.type
 */

function createScaleByModel(model, axisType) {
  axisType = axisType || model.get('type');

  if (axisType) {
    switch (axisType) {
      // Buildin scale
      case 'category':
        return new __WEBPACK_IMPORTED_MODULE_1__scale_Ordinal_js__["a" /* default */]({
          ordinalMeta: model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(),
          extent: [Infinity, -Infinity]
        });

      case 'time':
        return new __WEBPACK_IMPORTED_MODULE_6__scale_Time_js__["a" /* default */]({
          locale: model.ecModel.getLocaleModel(),
          useUTC: model.ecModel.get('useUTC')
        });

      default:
        // case 'value'/'interval', 'log', or others.
        return new (__WEBPACK_IMPORTED_MODULE_3__scale_Scale_js__["a" /* default */].getClass(axisType) || __WEBPACK_IMPORTED_MODULE_2__scale_Interval_js__["a" /* default */])();
    }
  }
}
/**
 * Check if the axis cross 0
 */

function ifAxisCrossZero(axis) {
  var dataExtent = axis.scale.getExtent();
  var min = dataExtent[0];
  var max = dataExtent[1];
  return !(min > 0 && max > 0 || min < 0 && max < 0);
}
/**
 * @param axis
 * @return Label formatter function.
 *         param: {number} tickValue,
 *         param: {number} idx, the index in all ticks.
 *                         If category axis, this param is not required.
 *         return: {string} label string.
 */

function makeLabelFormatter(axis) {
  var labelFormatter = axis.getLabelModel().get('formatter');
  var categoryTickStart = axis.type === 'category' ? axis.scale.getExtent()[0] : null;

  if (axis.scale.type === 'time') {
    return function (tpl) {
      return function (tick, idx) {
        return axis.scale.getFormattedLabel(tick, idx, tpl);
      };
    }(labelFormatter);
  } else if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"](labelFormatter)) {
    return function (tpl) {
      return function (tick) {
        // For category axis, get raw value; for numeric axis,
        // get formatted label like '1,333,444'.
        var label = axis.scale.getLabel(tick);
        var text = tpl.replace('{value}', label != null ? label : '');
        return text;
      };
    }(labelFormatter);
  } else if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"](labelFormatter)) {
    return function (cb) {
      return function (tick, idx) {
        // The original intention of `idx` is "the index of the tick in all ticks".
        // But the previous implementation of category axis do not consider the
        // `axisLabel.interval`, which cause that, for example, the `interval` is
        // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
        // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
        // the definition here for back compatibility.
        if (categoryTickStart != null) {
          idx = tick.value - categoryTickStart;
        }

        return cb(getAxisRawValue(axis, tick), idx, tick.level != null ? {
          level: tick.level
        } : null);
      };
    }(labelFormatter);
  } else {
    return function (tick) {
      return axis.scale.getLabel(tick);
    };
  }
}
function getAxisRawValue(axis, tick) {
  // In category axis with data zoom, tick is not the original
  // index of axis.data. So tick should not be exposed to user
  // in category axis.
  return axis.type === 'category' ? axis.scale.getLabel(tick) : tick.value;
}
/**
 * @param axis
 * @return Be null/undefined if no labels.
 */

function estimateLabelUnionRect(axis) {
  var axisModel = axis.model;
  var scale = axis.scale;

  if (!axisModel.get(['axisLabel', 'show']) || scale.isBlank()) {
    return;
  }

  var realNumberScaleTicks;
  var tickCount;
  var categoryScaleExtent = scale.getExtent(); // Optimize for large category data, avoid call `getTicks()`.

  if (scale instanceof __WEBPACK_IMPORTED_MODULE_1__scale_Ordinal_js__["a" /* default */]) {
    tickCount = scale.count();
  } else {
    realNumberScaleTicks = scale.getTicks();
    tickCount = realNumberScaleTicks.length;
  }

  var axisLabelModel = axis.getLabelModel();
  var labelFormatter = makeLabelFormatter(axis);
  var rect;
  var step = 1; // Simple optimization for large amount of labels

  if (tickCount > 40) {
    step = Math.ceil(tickCount / 40);
  }

  for (var i = 0; i < tickCount; i += step) {
    var tick = realNumberScaleTicks ? realNumberScaleTicks[i] : {
      value: categoryScaleExtent[0] + i
    };
    var label = labelFormatter(tick, i);
    var unrotatedSingleRect = axisLabelModel.getTextRect(label);
    var singleRect = rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
    rect ? rect.union(singleRect) : rect = singleRect;
  }

  return rect;
}

function rotateTextRect(textRect, rotate) {
  var rotateRadians = rotate * Math.PI / 180;
  var beforeWidth = textRect.width;
  var beforeHeight = textRect.height;
  var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
  var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
  var rotatedRect = new __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_BoundingRect_js__["a" /* default */](textRect.x, textRect.y, afterWidth, afterHeight);
  return rotatedRect;
}
/**
 * @param model axisLabelModel or axisTickModel
 * @return {number|String} Can be null|'auto'|number|function
 */


function getOptionCategoryInterval(model) {
  var interval = model.get('interval');
  return interval == null ? 'auto' : interval;
}
/**
 * Set `categoryInterval` as 0 implicitly indicates that
 * show all labels reguardless of overlap.
 * @param {Object} axis axisModel.axis
 */

function shouldShowAllLabels(axis) {
  return axis.type === 'category' && getOptionCategoryInterval(axis.getLabelModel()) === 0;
}
function getDataDimensionsOnAxis(data, axisDim) {
  // Remove duplicated dat dimensions caused by `getStackedDimension`.
  var dataDimMap = {}; // Currently `mapDimensionsAll` will contain stack result dimension ('__\0ecstackresult').
  // PENDING: is it reasonable? Do we need to remove the original dim from "coord dim" since
  // there has been stacked result dim?

  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](data.mapDimensionsAll(axisDim), function (dataDim) {
    // For example, the extent of the original dimension
    // is [0.1, 0.5], the extent of the `stackResultDimension`
    // is [7, 9], the final extent should NOT include [0.1, 0.5],
    // because there is no graphic corresponding to [0.1, 0.5].
    // See the case in `test/area-stack.html` `main1`, where area line
    // stack needs `yAxis` not start from 0.
    dataDimMap[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__data_helper_dataStackHelper_js__["a" /* getStackedDimension */])(data, dataDim)] = true;
  });
  return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["keys"](dataDimMap);
}
function unionAxisExtentFromData(dataExtent, data, axisDim) {
  if (data) {
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](getDataDimensionsOnAxis(data, axisDim), function (dim) {
      var seriesExtent = data.getApproximateExtent(dim);
      seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
      seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
    });
  }
}

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_IMAGE_STYLE */
/* unused harmony export DEFAULT_IMAGE_ANIMATION_PROPS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Displayable_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_util_js__ = __webpack_require__(0);




var DEFAULT_IMAGE_STYLE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["defaults"])({
    x: 0,
    y: 0
}, __WEBPACK_IMPORTED_MODULE_1__Displayable_js__["a" /* DEFAULT_COMMON_STYLE */]);
var DEFAULT_IMAGE_ANIMATION_PROPS = {
    style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["defaults"])({
        x: true,
        y: true,
        width: true,
        height: true,
        sx: true,
        sy: true,
        sWidth: true,
        sHeight: true
    }, __WEBPACK_IMPORTED_MODULE_1__Displayable_js__["b" /* DEFAULT_COMMON_ANIMATION_PROPS */].style)
};
function isImageLike(source) {
    return !!(source
        && typeof source !== 'string'
        && source.width && source.height);
}
var ZRImage = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ZRImage, _super);
    function ZRImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ZRImage.prototype.createStyle = function (obj) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["createObject"])(DEFAULT_IMAGE_STYLE, obj);
    };
    ZRImage.prototype._getSize = function (dim) {
        var style = this.style;
        var size = style[dim];
        if (size != null) {
            return size;
        }
        var imageSource = isImageLike(style.image)
            ? style.image : this.__image;
        if (!imageSource) {
            return 0;
        }
        var otherDim = dim === 'width' ? 'height' : 'width';
        var otherDimSize = style[otherDim];
        if (otherDimSize == null) {
            return imageSource[dim];
        }
        else {
            return imageSource[dim] / imageSource[otherDim] * otherDimSize;
        }
    };
    ZRImage.prototype.getWidth = function () {
        return this._getSize('width');
    };
    ZRImage.prototype.getHeight = function () {
        return this._getSize('height');
    };
    ZRImage.prototype.getAnimationStyleProps = function () {
        return DEFAULT_IMAGE_ANIMATION_PROPS;
    };
    ZRImage.prototype.getBoundingRect = function () {
        var style = this.style;
        if (!this._rect) {
            this._rect = new __WEBPACK_IMPORTED_MODULE_2__core_BoundingRect_js__["a" /* default */](style.x || 0, style.y || 0, this.getWidth(), this.getHeight());
        }
        return this._rect;
    };
    return ZRImage;
}(__WEBPACK_IMPORTED_MODULE_1__Displayable_js__["c" /* default */]));
ZRImage.prototype.type = 'image';
/* harmony default export */ __webpack_exports__["a"] = (ZRImage);


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(759), __esModule: true };

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(74);
var IObject = __webpack_require__(184);
var toObject = __webpack_require__(34);
var toLength = __webpack_require__(29);
var asc = __webpack_require__(286);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(2);
var core = __webpack_require__(73);
var fails = __webpack_require__(16);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(18);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_SeriesData_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_helper_createDimensions_js__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_helper_dimensionHelper_js__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_CoordinateSystem_js__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_referHelper_js__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_Source_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_helper_dataStackHelper_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_helper_sourceHelper_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_types_js__ = __webpack_require__(66);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/












function getCoordSysDimDefs(seriesModel, coordSysInfo) {
  var coordSysName = seriesModel.get('coordinateSystem');
  var registeredCoordSys = __WEBPACK_IMPORTED_MODULE_5__core_CoordinateSystem_js__["a" /* default */].get(coordSysName);
  var coordSysDimDefs;

  if (coordSysInfo && coordSysInfo.coordSysDims) {
    coordSysDimDefs = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"](coordSysInfo.coordSysDims, function (dim) {
      var dimInfo = {
        name: dim
      };
      var axisModel = coordSysInfo.axisMap.get(dim);

      if (axisModel) {
        var axisType = axisModel.get('type');
        dimInfo.type = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_helper_dimensionHelper_js__["b" /* getDimensionTypeByAxis */])(axisType);
      }

      return dimInfo;
    });
  }

  if (!coordSysDimDefs) {
    // Get dimensions from registered coordinate system
    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || ['x', 'y'];
  }

  return coordSysDimDefs;
}

function injectOrdinalMeta(dimInfoList, createInvertedIndices, coordSysInfo) {
  var firstCategoryDimIndex;
  var hasNameEncode;
  coordSysInfo && __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](dimInfoList, function (dimInfo, dimIndex) {
    var coordDim = dimInfo.coordDim;
    var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);

    if (categoryAxisModel) {
      if (firstCategoryDimIndex == null) {
        firstCategoryDimIndex = dimIndex;
      }

      dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();

      if (createInvertedIndices) {
        dimInfo.createInvertedIndices = true;
      }
    }

    if (dimInfo.otherDims.itemName != null) {
      hasNameEncode = true;
    }
  });

  if (!hasNameEncode && firstCategoryDimIndex != null) {
    dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
  }

  return firstCategoryDimIndex;
}
/**
 * Caution: there are side effects to `sourceManager` in this method.
 * Should better only be called in `Series['getInitialData']`.
 */


function createSeriesData(sourceRaw, seriesModel, opt) {
  opt = opt || {};
  var sourceManager = seriesModel.getSourceManager();
  var source;
  var isOriginalSource = false;

  if (sourceRaw) {
    isOriginalSource = true;
    source = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__data_Source_js__["b" /* createSourceFromSeriesDataOption */])(sourceRaw);
  } else {
    source = sourceManager.getSource(); // Is series.data. not dataset.

    isOriginalSource = source.sourceFormat === __WEBPACK_IMPORTED_MODULE_10__util_types_js__["g" /* SOURCE_FORMAT_ORIGINAL */];
  }

  var coordSysInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__model_referHelper_js__["a" /* getCoordSysInfoBySeries */])(seriesModel);
  var coordSysDimDefs = getCoordSysDimDefs(seriesModel, coordSysInfo);
  var useEncodeDefaulter = opt.useEncodeDefaulter;
  var encodeDefaulter = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"](useEncodeDefaulter) ? useEncodeDefaulter : useEncodeDefaulter ? __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["curry"](__WEBPACK_IMPORTED_MODULE_9__data_helper_sourceHelper_js__["f" /* makeSeriesEncodeForAxisCoordSys */], coordSysDimDefs, seriesModel) : null;
  var createDimensionOptions = {
    coordDimensions: coordSysDimDefs,
    generateCoord: opt.generateCoord,
    encodeDefine: seriesModel.getEncode(),
    encodeDefaulter: encodeDefaulter,
    canOmitUnusedDimensions: !isOriginalSource
  };
  var schema = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_helper_createDimensions_js__["a" /* default */])(source, createDimensionOptions);
  var firstCategoryDimIndex = injectOrdinalMeta(schema.dimensions, opt.createInvertedIndices, coordSysInfo);
  var store = !isOriginalSource ? sourceManager.getSharedDataStore(schema) : null;
  var stackCalculationInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__data_helper_dataStackHelper_js__["c" /* enableDataStack */])(seriesModel, {
    schema: schema,
    store: store
  });
  var data = new __WEBPACK_IMPORTED_MODULE_1__data_SeriesData_js__["a" /* default */](schema, seriesModel);
  data.setCalculationInfo(stackCalculationInfo);
  var dimValueGetter = firstCategoryDimIndex != null && isNeedCompleteOrdinalData(source) ? function (itemOpt, dimName, dataIndex, dimIndex) {
    // Use dataIndex as ordinal value in categoryAxis
    return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
  } : null;
  data.hasItemOption = false;
  data.initData( // Try to reuse the data store in sourceManager if using dataset.
  isOriginalSource ? source : store, null, dimValueGetter);
  return data;
}

function isNeedCompleteOrdinalData(source) {
  if (source.sourceFormat === __WEBPACK_IMPORTED_MODULE_10__util_types_js__["g" /* SOURCE_FORMAT_ORIGINAL */]) {
    var sampleItem = firstDataNotNull(source.data || []);
    return !__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_model_js__["g" /* getDataItemValue */])(sampleItem));
  }
}

function firstDataNotNull(arr) {
  var i = 0;

  while (i < arr.length && arr[i] == null) {
    i++;
  }

  return arr[i];
}

/* harmony default export */ __webpack_exports__["a"] = (createSeriesData);

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ToolboxFeature; });
/* harmony export (immutable) */ __webpack_exports__["a"] = registerFeature;
/* harmony export (immutable) */ __webpack_exports__["c"] = getFeature;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

var ToolboxFeature =
/** @class */
function () {
  function ToolboxFeature() {}

  return ToolboxFeature;
}();


var features = {};
function registerFeature(name, ctor) {
  features[name] = ctor;
}
function getFeature(name) {
  return features[name];
}

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(523);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1665)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(660),
  /* template */
  __webpack_require__(1595),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a103c38a",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/sysmanagement/LeftBar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LeftBar.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a103c38a", Component.options)
  } else {
    hotAPI.reload("data-v-a103c38a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Eventful = (function () {
    function Eventful(eventProcessors) {
        if (eventProcessors) {
            this._$eventProcessor = eventProcessors;
        }
    }
    Eventful.prototype.on = function (event, query, handler, context) {
        if (!this._$handlers) {
            this._$handlers = {};
        }
        var _h = this._$handlers;
        if (typeof query === 'function') {
            context = handler;
            handler = query;
            query = null;
        }
        if (!handler || !event) {
            return this;
        }
        var eventProcessor = this._$eventProcessor;
        if (query != null && eventProcessor && eventProcessor.normalizeQuery) {
            query = eventProcessor.normalizeQuery(query);
        }
        if (!_h[event]) {
            _h[event] = [];
        }
        for (var i = 0; i < _h[event].length; i++) {
            if (_h[event][i].h === handler) {
                return this;
            }
        }
        var wrap = {
            h: handler,
            query: query,
            ctx: (context || this),
            callAtLast: handler.zrEventfulCallAtLast
        };
        var lastIndex = _h[event].length - 1;
        var lastWrap = _h[event][lastIndex];
        (lastWrap && lastWrap.callAtLast)
            ? _h[event].splice(lastIndex, 0, wrap)
            : _h[event].push(wrap);
        return this;
    };
    Eventful.prototype.isSilent = function (eventName) {
        var _h = this._$handlers;
        return !_h || !_h[eventName] || !_h[eventName].length;
    };
    Eventful.prototype.off = function (eventType, handler) {
        var _h = this._$handlers;
        if (!_h) {
            return this;
        }
        if (!eventType) {
            this._$handlers = {};
            return this;
        }
        if (handler) {
            if (_h[eventType]) {
                var newList = [];
                for (var i = 0, l = _h[eventType].length; i < l; i++) {
                    if (_h[eventType][i].h !== handler) {
                        newList.push(_h[eventType][i]);
                    }
                }
                _h[eventType] = newList;
            }
            if (_h[eventType] && _h[eventType].length === 0) {
                delete _h[eventType];
            }
        }
        else {
            delete _h[eventType];
        }
        return this;
    };
    Eventful.prototype.trigger = function (eventType) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!this._$handlers) {
            return this;
        }
        var _h = this._$handlers[eventType];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var len = _h.length;
            for (var i = 0; i < len; i++) {
                var hItem = _h[i];
                if (eventProcessor
                    && eventProcessor.filter
                    && hItem.query != null
                    && !eventProcessor.filter(eventType, hItem.query)) {
                    continue;
                }
                switch (argLen) {
                    case 0:
                        hItem.h.call(hItem.ctx);
                        break;
                    case 1:
                        hItem.h.call(hItem.ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(hItem.ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(hItem.ctx, args);
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger
            && eventProcessor.afterTrigger(eventType);
        return this;
    };
    Eventful.prototype.triggerWithContext = function (type) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!this._$handlers) {
            return this;
        }
        var _h = this._$handlers[type];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var ctx = args[argLen - 1];
            var len = _h.length;
            for (var i = 0; i < len; i++) {
                var hItem = _h[i];
                if (eventProcessor
                    && eventProcessor.filter
                    && hItem.query != null
                    && !eventProcessor.filter(type, hItem.query)) {
                    continue;
                }
                switch (argLen) {
                    case 0:
                        hItem.h.call(ctx);
                        break;
                    case 1:
                        hItem.h.call(ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(ctx, args.slice(1, argLen - 1));
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger
            && eventProcessor.afterTrigger(type);
        return this;
    };
    return Eventful;
}());
/* harmony default export */ __webpack_exports__["a"] = (Eventful);


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = normalizeArcAngles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vector_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bbox_js__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__curve_js__ = __webpack_require__(57);





var CMD = {
    M: 1,
    L: 2,
    C: 3,
    Q: 4,
    A: 5,
    Z: 6,
    R: 7
};
var tmpOutX = [];
var tmpOutY = [];
var min = [];
var max = [];
var min2 = [];
var max2 = [];
var mathMin = Math.min;
var mathMax = Math.max;
var mathCos = Math.cos;
var mathSin = Math.sin;
var mathAbs = Math.abs;
var PI = Math.PI;
var PI2 = PI * 2;
var hasTypedArray = typeof Float32Array !== 'undefined';
var tmpAngles = [];
function modPI2(radian) {
    var n = Math.round(radian / PI * 1e8) / 1e8;
    return (n % 2) * PI;
}
function normalizeArcAngles(angles, anticlockwise) {
    var newStartAngle = modPI2(angles[0]);
    if (newStartAngle < 0) {
        newStartAngle += PI2;
    }
    var delta = newStartAngle - angles[0];
    var newEndAngle = angles[1];
    newEndAngle += delta;
    if (!anticlockwise && newEndAngle - newStartAngle >= PI2) {
        newEndAngle = newStartAngle + PI2;
    }
    else if (anticlockwise && newStartAngle - newEndAngle >= PI2) {
        newEndAngle = newStartAngle - PI2;
    }
    else if (!anticlockwise && newStartAngle > newEndAngle) {
        newEndAngle = newStartAngle + (PI2 - modPI2(newStartAngle - newEndAngle));
    }
    else if (anticlockwise && newStartAngle < newEndAngle) {
        newEndAngle = newStartAngle - (PI2 - modPI2(newEndAngle - newStartAngle));
    }
    angles[0] = newStartAngle;
    angles[1] = newEndAngle;
}
var PathProxy = (function () {
    function PathProxy(notSaveData) {
        this.dpr = 1;
        this._xi = 0;
        this._yi = 0;
        this._x0 = 0;
        this._y0 = 0;
        this._len = 0;
        if (notSaveData) {
            this._saveData = false;
        }
        if (this._saveData) {
            this.data = [];
        }
    }
    PathProxy.prototype.increaseVersion = function () {
        this._version++;
    };
    PathProxy.prototype.getVersion = function () {
        return this._version;
    };
    PathProxy.prototype.setScale = function (sx, sy, segmentIgnoreThreshold) {
        segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
        if (segmentIgnoreThreshold > 0) {
            this._ux = mathAbs(segmentIgnoreThreshold / __WEBPACK_IMPORTED_MODULE_2__config_js__["e" /* devicePixelRatio */] / sx) || 0;
            this._uy = mathAbs(segmentIgnoreThreshold / __WEBPACK_IMPORTED_MODULE_2__config_js__["e" /* devicePixelRatio */] / sy) || 0;
        }
    };
    PathProxy.prototype.setDPR = function (dpr) {
        this.dpr = dpr;
    };
    PathProxy.prototype.setContext = function (ctx) {
        this._ctx = ctx;
    };
    PathProxy.prototype.getContext = function () {
        return this._ctx;
    };
    PathProxy.prototype.beginPath = function () {
        this._ctx && this._ctx.beginPath();
        this.reset();
        return this;
    };
    PathProxy.prototype.reset = function () {
        if (this._saveData) {
            this._len = 0;
        }
        if (this._pathSegLen) {
            this._pathSegLen = null;
            this._pathLen = 0;
        }
        this._version++;
    };
    PathProxy.prototype.moveTo = function (x, y) {
        this._drawPendingPt();
        this.addData(CMD.M, x, y);
        this._ctx && this._ctx.moveTo(x, y);
        this._x0 = x;
        this._y0 = y;
        this._xi = x;
        this._yi = y;
        return this;
    };
    PathProxy.prototype.lineTo = function (x, y) {
        var dx = mathAbs(x - this._xi);
        var dy = mathAbs(y - this._yi);
        var exceedUnit = dx > this._ux || dy > this._uy;
        this.addData(CMD.L, x, y);
        if (this._ctx && exceedUnit) {
            this._ctx.lineTo(x, y);
        }
        if (exceedUnit) {
            this._xi = x;
            this._yi = y;
            this._pendingPtDist = 0;
        }
        else {
            var d2 = dx * dx + dy * dy;
            if (d2 > this._pendingPtDist) {
                this._pendingPtX = x;
                this._pendingPtY = y;
                this._pendingPtDist = d2;
            }
        }
        return this;
    };
    PathProxy.prototype.bezierCurveTo = function (x1, y1, x2, y2, x3, y3) {
        this._drawPendingPt();
        this.addData(CMD.C, x1, y1, x2, y2, x3, y3);
        if (this._ctx) {
            this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
        }
        this._xi = x3;
        this._yi = y3;
        return this;
    };
    PathProxy.prototype.quadraticCurveTo = function (x1, y1, x2, y2) {
        this._drawPendingPt();
        this.addData(CMD.Q, x1, y1, x2, y2);
        if (this._ctx) {
            this._ctx.quadraticCurveTo(x1, y1, x2, y2);
        }
        this._xi = x2;
        this._yi = y2;
        return this;
    };
    PathProxy.prototype.arc = function (cx, cy, r, startAngle, endAngle, anticlockwise) {
        this._drawPendingPt();
        tmpAngles[0] = startAngle;
        tmpAngles[1] = endAngle;
        normalizeArcAngles(tmpAngles, anticlockwise);
        startAngle = tmpAngles[0];
        endAngle = tmpAngles[1];
        var delta = endAngle - startAngle;
        this.addData(CMD.A, cx, cy, r, r, startAngle, delta, 0, anticlockwise ? 0 : 1);
        this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
        this._xi = mathCos(endAngle) * r + cx;
        this._yi = mathSin(endAngle) * r + cy;
        return this;
    };
    PathProxy.prototype.arcTo = function (x1, y1, x2, y2, radius) {
        this._drawPendingPt();
        if (this._ctx) {
            this._ctx.arcTo(x1, y1, x2, y2, radius);
        }
        return this;
    };
    PathProxy.prototype.rect = function (x, y, w, h) {
        this._drawPendingPt();
        this._ctx && this._ctx.rect(x, y, w, h);
        this.addData(CMD.R, x, y, w, h);
        return this;
    };
    PathProxy.prototype.closePath = function () {
        this._drawPendingPt();
        this.addData(CMD.Z);
        var ctx = this._ctx;
        var x0 = this._x0;
        var y0 = this._y0;
        if (ctx) {
            ctx.closePath();
        }
        this._xi = x0;
        this._yi = y0;
        return this;
    };
    PathProxy.prototype.fill = function (ctx) {
        ctx && ctx.fill();
        this.toStatic();
    };
    PathProxy.prototype.stroke = function (ctx) {
        ctx && ctx.stroke();
        this.toStatic();
    };
    PathProxy.prototype.len = function () {
        return this._len;
    };
    PathProxy.prototype.setData = function (data) {
        var len = data.length;
        if (!(this.data && this.data.length === len) && hasTypedArray) {
            this.data = new Float32Array(len);
        }
        for (var i = 0; i < len; i++) {
            this.data[i] = data[i];
        }
        this._len = len;
    };
    PathProxy.prototype.appendPath = function (path) {
        if (!(path instanceof Array)) {
            path = [path];
        }
        var len = path.length;
        var appendSize = 0;
        var offset = this._len;
        for (var i = 0; i < len; i++) {
            appendSize += path[i].len();
        }
        if (hasTypedArray && (this.data instanceof Float32Array)) {
            this.data = new Float32Array(offset + appendSize);
        }
        for (var i = 0; i < len; i++) {
            var appendPathData = path[i].data;
            for (var k = 0; k < appendPathData.length; k++) {
                this.data[offset++] = appendPathData[k];
            }
        }
        this._len = offset;
    };
    PathProxy.prototype.addData = function (cmd, a, b, c, d, e, f, g, h) {
        if (!this._saveData) {
            return;
        }
        var data = this.data;
        if (this._len + arguments.length > data.length) {
            this._expandData();
            data = this.data;
        }
        for (var i = 0; i < arguments.length; i++) {
            data[this._len++] = arguments[i];
        }
    };
    PathProxy.prototype._drawPendingPt = function () {
        if (this._pendingPtDist > 0) {
            this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY);
            this._pendingPtDist = 0;
        }
    };
    PathProxy.prototype._expandData = function () {
        if (!(this.data instanceof Array)) {
            var newData = [];
            for (var i = 0; i < this._len; i++) {
                newData[i] = this.data[i];
            }
            this.data = newData;
        }
    };
    PathProxy.prototype.toStatic = function () {
        if (!this._saveData) {
            return;
        }
        this._drawPendingPt();
        var data = this.data;
        if (data instanceof Array) {
            data.length = this._len;
            if (hasTypedArray && this._len > 11) {
                this.data = new Float32Array(data);
            }
        }
    };
    PathProxy.prototype.getBoundingRect = function () {
        min[0] = min[1] = min2[0] = min2[1] = Number.MAX_VALUE;
        max[0] = max[1] = max2[0] = max2[1] = -Number.MAX_VALUE;
        var data = this.data;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var i;
        for (i = 0; i < this._len;) {
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            switch (cmd) {
                case CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    min2[0] = x0;
                    min2[1] = y0;
                    max2[0] = x0;
                    max2[1] = y0;
                    break;
                case CMD.L:
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__bbox_js__["a" /* fromLine */])(xi, yi, data[i], data[i + 1], min2, max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case CMD.C:
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__bbox_js__["b" /* fromCubic */])(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], min2, max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case CMD.Q:
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__bbox_js__["c" /* fromQuadratic */])(xi, yi, data[i++], data[i++], data[i], data[i + 1], min2, max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var endAngle = data[i++] + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = mathCos(startAngle) * rx + cx;
                        y0 = mathSin(startAngle) * ry + cy;
                    }
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__bbox_js__["d" /* fromArc */])(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, min2, max2);
                    xi = mathCos(endAngle) * rx + cx;
                    yi = mathSin(endAngle) * ry + cy;
                    break;
                case CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__bbox_js__["a" /* fromLine */])(x0, y0, x0 + width, y0 + height, min2, max2);
                    break;
                case CMD.Z:
                    xi = x0;
                    yi = y0;
                    break;
            }
            __WEBPACK_IMPORTED_MODULE_0__vector_js__["min"](min, min, min2);
            __WEBPACK_IMPORTED_MODULE_0__vector_js__["max"](max, max, max2);
        }
        if (i === 0) {
            min[0] = min[1] = max[0] = max[1] = 0;
        }
        return new __WEBPACK_IMPORTED_MODULE_1__BoundingRect_js__["a" /* default */](min[0], min[1], max[0] - min[0], max[1] - min[1]);
    };
    PathProxy.prototype._calculateLength = function () {
        var data = this.data;
        var len = this._len;
        var ux = this._ux;
        var uy = this._uy;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        if (!this._pathSegLen) {
            this._pathSegLen = [];
        }
        var pathSegLen = this._pathSegLen;
        var pathTotalLen = 0;
        var segCount = 0;
        for (var i = 0; i < len;) {
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            var l = -1;
            switch (cmd) {
                case CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    break;
                case CMD.L: {
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var dx = x2 - xi;
                    var dy = y2 - yi;
                    if (mathAbs(dx) > ux || mathAbs(dy) > uy || i === len - 1) {
                        l = Math.sqrt(dx * dx + dy * dy);
                        xi = x2;
                        yi = y2;
                    }
                    break;
                }
                case CMD.C: {
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var x3 = data[i++];
                    var y3 = data[i++];
                    l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__curve_js__["i" /* cubicLength */])(xi, yi, x1, y1, x2, y2, x3, y3, 10);
                    xi = x3;
                    yi = y3;
                    break;
                }
                case CMD.Q: {
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__curve_js__["j" /* quadraticLength */])(xi, yi, x1, y1, x2, y2, 10);
                    xi = x2;
                    yi = y2;
                    break;
                }
                case CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var delta = data[i++];
                    var endAngle = delta + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = mathCos(startAngle) * rx + cx;
                        y0 = mathSin(startAngle) * ry + cy;
                    }
                    l = mathMax(rx, ry) * mathMin(PI2, Math.abs(delta));
                    xi = mathCos(endAngle) * rx + cx;
                    yi = mathSin(endAngle) * ry + cy;
                    break;
                case CMD.R: {
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    l = width * 2 + height * 2;
                    break;
                }
                case CMD.Z: {
                    var dx = x0 - xi;
                    var dy = y0 - yi;
                    l = Math.sqrt(dx * dx + dy * dy);
                    xi = x0;
                    yi = y0;
                    break;
                }
            }
            if (l >= 0) {
                pathSegLen[segCount++] = l;
                pathTotalLen += l;
            }
        }
        this._pathLen = pathTotalLen;
        return pathTotalLen;
    };
    PathProxy.prototype.rebuildPath = function (ctx, percent) {
        var d = this.data;
        var ux = this._ux;
        var uy = this._uy;
        var len = this._len;
        var x0;
        var y0;
        var xi;
        var yi;
        var x;
        var y;
        var drawPart = percent < 1;
        var pathSegLen;
        var pathTotalLen;
        var accumLength = 0;
        var segCount = 0;
        var displayedLength;
        var pendingPtDist = 0;
        var pendingPtX;
        var pendingPtY;
        if (drawPart) {
            if (!this._pathSegLen) {
                this._calculateLength();
            }
            pathSegLen = this._pathSegLen;
            pathTotalLen = this._pathLen;
            displayedLength = percent * pathTotalLen;
            if (!displayedLength) {
                return;
            }
        }
        lo: for (var i = 0; i < len;) {
            var cmd = d[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = d[i];
                yi = d[i + 1];
                x0 = xi;
                y0 = yi;
            }
            if (cmd !== CMD.L && pendingPtDist > 0) {
                ctx.lineTo(pendingPtX, pendingPtY);
                pendingPtDist = 0;
            }
            switch (cmd) {
                case CMD.M:
                    x0 = xi = d[i++];
                    y0 = yi = d[i++];
                    ctx.moveTo(xi, yi);
                    break;
                case CMD.L: {
                    x = d[i++];
                    y = d[i++];
                    var dx = mathAbs(x - xi);
                    var dy = mathAbs(y - yi);
                    if (dx > ux || dy > uy) {
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                ctx.lineTo(xi * (1 - t) + x * t, yi * (1 - t) + y * t);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.lineTo(x, y);
                        xi = x;
                        yi = y;
                        pendingPtDist = 0;
                    }
                    else {
                        var d2 = dx * dx + dy * dy;
                        if (d2 > pendingPtDist) {
                            pendingPtX = x;
                            pendingPtY = y;
                            pendingPtDist = d2;
                        }
                    }
                    break;
                }
                case CMD.C: {
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    var x3 = d[i++];
                    var y3 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__curve_js__["k" /* cubicSubdivide */])(xi, x1, x2, x3, t, tmpOutX);
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__curve_js__["k" /* cubicSubdivide */])(yi, y1, y2, y3, t, tmpOutY);
                            ctx.bezierCurveTo(tmpOutX[1], tmpOutY[1], tmpOutX[2], tmpOutY[2], tmpOutX[3], tmpOutY[3]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    xi = x3;
                    yi = y3;
                    break;
                }
                case CMD.Q: {
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__curve_js__["l" /* quadraticSubdivide */])(xi, x1, x2, t, tmpOutX);
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__curve_js__["l" /* quadraticSubdivide */])(yi, y1, y2, t, tmpOutY);
                            ctx.quadraticCurveTo(tmpOutX[1], tmpOutY[1], tmpOutX[2], tmpOutY[2]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.quadraticCurveTo(x1, y1, x2, y2);
                    xi = x2;
                    yi = y2;
                    break;
                }
                case CMD.A:
                    var cx = d[i++];
                    var cy = d[i++];
                    var rx = d[i++];
                    var ry = d[i++];
                    var startAngle = d[i++];
                    var delta = d[i++];
                    var psi = d[i++];
                    var anticlockwise = !d[i++];
                    var r = (rx > ry) ? rx : ry;
                    var isEllipse = mathAbs(rx - ry) > 1e-3;
                    var endAngle = startAngle + delta;
                    var breakBuild = false;
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            endAngle = startAngle + delta * (displayedLength - accumLength) / l;
                            breakBuild = true;
                        }
                        accumLength += l;
                    }
                    if (isEllipse && ctx.ellipse) {
                        ctx.ellipse(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise);
                    }
                    else {
                        ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
                    }
                    if (breakBuild) {
                        break lo;
                    }
                    if (isFirst) {
                        x0 = mathCos(startAngle) * rx + cx;
                        y0 = mathSin(startAngle) * ry + cy;
                    }
                    xi = mathCos(endAngle) * rx + cx;
                    yi = mathSin(endAngle) * ry + cy;
                    break;
                case CMD.R:
                    x0 = xi = d[i];
                    y0 = yi = d[i + 1];
                    x = d[i++];
                    y = d[i++];
                    var width = d[i++];
                    var height = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var d_1 = displayedLength - accumLength;
                            ctx.moveTo(x, y);
                            ctx.lineTo(x + mathMin(d_1, width), y);
                            d_1 -= width;
                            if (d_1 > 0) {
                                ctx.lineTo(x + width, y + mathMin(d_1, height));
                            }
                            d_1 -= height;
                            if (d_1 > 0) {
                                ctx.lineTo(x + mathMax(width - d_1, 0), y + height);
                            }
                            d_1 -= width;
                            if (d_1 > 0) {
                                ctx.lineTo(x, y + mathMax(height - d_1, 0));
                            }
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.rect(x, y, width, height);
                    break;
                case CMD.Z:
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            ctx.lineTo(xi * (1 - t) + x0 * t, yi * (1 - t) + y0 * t);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.closePath();
                    xi = x0;
                    yi = y0;
            }
        }
    };
    PathProxy.prototype.clone = function () {
        var newProxy = new PathProxy();
        var data = this.data;
        newProxy.data = data.slice ? data.slice()
            : Array.prototype.slice.call(data);
        newProxy._len = this._len;
        return newProxy;
    };
    PathProxy.CMD = CMD;
    PathProxy.initDefaultProps = (function () {
        var proto = PathProxy.prototype;
        proto._saveData = true;
        proto._ux = 0;
        proto._uy = 0;
        proto._pendingPtDist = 0;
        proto._version = 0;
    })();
    return PathProxy;
}());
/* harmony default export */ __webpack_exports__["a"] = (PathProxy);


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(39);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(751);


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(80);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(435);
var $export = __webpack_require__(2);
var shared = __webpack_require__(186)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(439))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(31)) {
  var LIBRARY = __webpack_require__(108);
  var global = __webpack_require__(13);
  var fails = __webpack_require__(16);
  var $export = __webpack_require__(2);
  var $typed = __webpack_require__(226);
  var $buffer = __webpack_require__(307);
  var ctx = __webpack_require__(74);
  var anInstance = __webpack_require__(121);
  var propertyDesc = __webpack_require__(126);
  var hide = __webpack_require__(54);
  var redefineAll = __webpack_require__(127);
  var toInteger = __webpack_require__(76);
  var toLength = __webpack_require__(29);
  var toIndex = __webpack_require__(433);
  var toAbsoluteIndex = __webpack_require__(129);
  var toPrimitive = __webpack_require__(84);
  var has = __webpack_require__(61);
  var classof = __webpack_require__(147);
  var isObject = __webpack_require__(18);
  var toObject = __webpack_require__(34);
  var isArrayIter = __webpack_require__(293);
  var create = __webpack_require__(123);
  var getPrototypeOf = __webpack_require__(63);
  var gOPN = __webpack_require__(124).f;
  var getIterFn = __webpack_require__(309);
  var uid = __webpack_require__(130);
  var wks = __webpack_require__(25);
  var createArrayMethod = __webpack_require__(81);
  var createArrayIncludes = __webpack_require__(214);
  var speciesConstructor = __webpack_require__(187);
  var ArrayIterators = __webpack_require__(310);
  var Iterators = __webpack_require__(148);
  var $iterDetect = __webpack_require__(219);
  var setSpecies = __webpack_require__(128);
  var arrayFill = __webpack_require__(285);
  var arrayCopyWithin = __webpack_require__(405);
  var $DP = __webpack_require__(33);
  var $GOPD = __webpack_require__(62);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = enableDataStack;
/* harmony export (immutable) */ __webpack_exports__["b"] = isDimensionStacked;
/* harmony export (immutable) */ __webpack_exports__["a"] = getStackedDimension;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SeriesDataSchema_js__ = __webpack_require__(333);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * Note that it is too complicated to support 3d stack by value
 * (have to create two-dimension inverted index), so in 3d case
 * we just support that stacked by index.
 *
 * @param seriesModel
 * @param dimensionsInput The same as the input of <module:echarts/data/SeriesData>.
 *        The input will be modified.
 * @param opt
 * @param opt.stackedCoordDimension Specify a coord dimension if needed.
 * @param opt.byIndex=false
 * @return calculationInfo
 * {
 *     stackedDimension: string
 *     stackedByDimension: string
 *     isStackedByIndex: boolean
 *     stackedOverDimension: string
 *     stackResultDimension: string
 * }
 */

function enableDataStack(seriesModel, dimensionsInput, opt) {
  opt = opt || {};
  var byIndex = opt.byIndex;
  var stackedCoordDimension = opt.stackedCoordDimension;
  var dimensionDefineList;
  var schema;
  var store;

  if (isLegacyDimensionsInput(dimensionsInput)) {
    dimensionDefineList = dimensionsInput;
  } else {
    schema = dimensionsInput.schema;
    dimensionDefineList = schema.dimensions;
    store = dimensionsInput.store;
  } // Compatibal: when `stack` is set as '', do not stack.


  var mayStack = !!(seriesModel && seriesModel.get('stack'));
  var stackedByDimInfo;
  var stackedDimInfo;
  var stackResultDimension;
  var stackedOverDimension;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(dimensionDefineList, function (dimensionInfo, index) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"])(dimensionInfo)) {
      dimensionDefineList[index] = dimensionInfo = {
        name: dimensionInfo
      };
    }

    if (mayStack && !dimensionInfo.isExtraCoord) {
      // Find the first ordinal dimension as the stackedByDimInfo.
      if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) {
        stackedByDimInfo = dimensionInfo;
      } // Find the first stackable dimension as the stackedDimInfo.


      if (!stackedDimInfo && dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time' && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) {
        stackedDimInfo = dimensionInfo;
      }
    }
  });

  if (stackedDimInfo && !byIndex && !stackedByDimInfo) {
    // Compatible with previous design, value axis (time axis) only stack by index.
    // It may make sense if the user provides elaborately constructed data.
    byIndex = true;
  } // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
  // That put stack logic in List is for using conveniently in echarts extensions, but it
  // might not be a good way.


  if (stackedDimInfo) {
    // Use a weird name that not duplicated with other names.
    // Also need to use seriesModel.id as postfix because different
    // series may share same data store. The stack dimension needs to be distinguished.
    stackResultDimension = '__\0ecstackresult_' + seriesModel.id;
    stackedOverDimension = '__\0ecstackedover_' + seriesModel.id; // Create inverted index to fast query index by value.

    if (stackedByDimInfo) {
      stackedByDimInfo.createInvertedIndices = true;
    }

    var stackedDimCoordDim_1 = stackedDimInfo.coordDim;
    var stackedDimType = stackedDimInfo.type;
    var stackedDimCoordIndex_1 = 0;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(dimensionDefineList, function (dimensionInfo) {
      if (dimensionInfo.coordDim === stackedDimCoordDim_1) {
        stackedDimCoordIndex_1++;
      }
    });
    var stackedOverDimensionDefine = {
      name: stackResultDimension,
      coordDim: stackedDimCoordDim_1,
      coordDimIndex: stackedDimCoordIndex_1,
      type: stackedDimType,
      isExtraCoord: true,
      isCalculationCoord: true,
      storeDimIndex: dimensionDefineList.length
    };
    var stackResultDimensionDefine = {
      name: stackedOverDimension,
      // This dimension contains stack base (generally, 0), so do not set it as
      // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
      coordDim: stackedOverDimension,
      coordDimIndex: stackedDimCoordIndex_1 + 1,
      type: stackedDimType,
      isExtraCoord: true,
      isCalculationCoord: true,
      storeDimIndex: dimensionDefineList.length + 1
    };

    if (schema) {
      if (store) {
        stackedOverDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackedOverDimension, stackedDimType);
        stackResultDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackResultDimension, stackedDimType);
      }

      schema.appendCalculationDimension(stackedOverDimensionDefine);
      schema.appendCalculationDimension(stackResultDimensionDefine);
    } else {
      dimensionDefineList.push(stackedOverDimensionDefine);
      dimensionDefineList.push(stackResultDimensionDefine);
    }
  }

  return {
    stackedDimension: stackedDimInfo && stackedDimInfo.name,
    stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
    isStackedByIndex: byIndex,
    stackedOverDimension: stackedOverDimension,
    stackResultDimension: stackResultDimension
  };
}

function isLegacyDimensionsInput(dimensionsInput) {
  return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__SeriesDataSchema_js__["a" /* isSeriesDataSchema */])(dimensionsInput.schema);
}

function isDimensionStacked(data, stackedDim) {
  // Each single series only maps to one pair of axis. So we do not need to
  // check stackByDim, whatever stacked by a dimension or stacked by index.
  return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension');
}
function getStackedDimension(data, targetDim) {
  return isDimensionStacked(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
}

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BE_ORDINAL; });
/* harmony export (immutable) */ __webpack_exports__["e"] = resetSourceDefaulter;
/* harmony export (immutable) */ __webpack_exports__["f"] = makeSeriesEncodeForAxisCoordSys;
/* harmony export (immutable) */ __webpack_exports__["g"] = makeSeriesEncodeForNameBased;
/* harmony export (immutable) */ __webpack_exports__["c"] = querySeriesUpstreamDatasetModel;
/* harmony export (immutable) */ __webpack_exports__["d"] = queryDatasetUpstreamDatasetModels;
/* harmony export (immutable) */ __webpack_exports__["a"] = guessOrdinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_types_js__ = __webpack_require__(66);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


 // The result of `guessOrdinal`.

var BE_ORDINAL = {
  Must: 1,
  Might: 2,
  Not: 3 // Other cases

};
var innerGlobalModel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_model_js__["a" /* makeInner */])();
/**
 * MUST be called before mergeOption of all series.
 */

function resetSourceDefaulter(ecModel) {
  // `datasetMap` is used to make default encode.
  innerGlobalModel(ecModel).datasetMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"])();
}
/**
 * [The strategy of the arrengment of data dimensions for dataset]:
 * "value way": all axes are non-category axes. So series one by one take
 *     several (the number is coordSysDims.length) dimensions from dataset.
 *     The result of data arrengment of data dimensions like:
 *     | ser0_x | ser0_y | ser1_x | ser1_y | ser2_x | ser2_y |
 * "category way": at least one axis is category axis. So the the first data
 *     dimension is always mapped to the first category axis and shared by
 *     all of the series. The other data dimensions are taken by series like
 *     "value way" does.
 *     The result of data arrengment of data dimensions like:
 *     | ser_shared_x | ser0_y | ser1_y | ser2_y |
 *
 * @return encode Never be `null/undefined`.
 */

function makeSeriesEncodeForAxisCoordSys(coordDimensions, seriesModel, source) {
  var encode = {};
  var datasetModel = querySeriesUpstreamDatasetModel(seriesModel); // Currently only make default when using dataset, util more reqirements occur.

  if (!datasetModel || !coordDimensions) {
    return encode;
  }

  var encodeItemName = [];
  var encodeSeriesName = [];
  var ecModel = seriesModel.ecModel;
  var datasetMap = innerGlobalModel(ecModel).datasetMap;
  var key = datasetModel.uid + '_' + source.seriesLayoutBy;
  var baseCategoryDimIndex;
  var categoryWayValueDimStart;
  coordDimensions = coordDimensions.slice();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(coordDimensions, function (coordDimInfoLoose, coordDimIdx) {
    var coordDimInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isObject"])(coordDimInfoLoose) ? coordDimInfoLoose : coordDimensions[coordDimIdx] = {
      name: coordDimInfoLoose
    };

    if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
      baseCategoryDimIndex = coordDimIdx;
      categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimInfo);
    }

    encode[coordDimInfo.name] = [];
  });
  var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
    categoryWayDim: categoryWayValueDimStart,
    valueWayDim: 0
  }); // TODO
  // Auto detect first time axis and do arrangement.

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(coordDimensions, function (coordDimInfo, coordDimIdx) {
    var coordDimName = coordDimInfo.name;
    var count = getDataDimCountOnCoordDim(coordDimInfo); // In value way.

    if (baseCategoryDimIndex == null) {
      var start = datasetRecord.valueWayDim;
      pushDim(encode[coordDimName], start, count);
      pushDim(encodeSeriesName, start, count);
      datasetRecord.valueWayDim += count; // ??? TODO give a better default series name rule?
      // especially when encode x y specified.
      // consider: when mutiple series share one dimension
      // category axis, series name should better use
      // the other dimsion name. On the other hand, use
      // both dimensions name.
    } // In category way, the first category axis.
    else if (baseCategoryDimIndex === coordDimIdx) {
        pushDim(encode[coordDimName], 0, count);
        pushDim(encodeItemName, 0, count);
      } // In category way, the other axis.
      else {
          var start = datasetRecord.categoryWayDim;
          pushDim(encode[coordDimName], start, count);
          pushDim(encodeSeriesName, start, count);
          datasetRecord.categoryWayDim += count;
        }
  });

  function pushDim(dimIdxArr, idxFrom, idxCount) {
    for (var i = 0; i < idxCount; i++) {
      dimIdxArr.push(idxFrom + i);
    }
  }

  function getDataDimCountOnCoordDim(coordDimInfo) {
    var dimsDef = coordDimInfo.dimsDef;
    return dimsDef ? dimsDef.length : 1;
  }

  encodeItemName.length && (encode.itemName = encodeItemName);
  encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
  return encode;
}
/**
 * Work for data like [{name: ..., value: ...}, ...].
 *
 * @return encode Never be `null/undefined`.
 */

function makeSeriesEncodeForNameBased(seriesModel, source, dimCount) {
  var encode = {};
  var datasetModel = querySeriesUpstreamDatasetModel(seriesModel); // Currently only make default when using dataset, util more reqirements occur.

  if (!datasetModel) {
    return encode;
  }

  var sourceFormat = source.sourceFormat;
  var dimensionsDefine = source.dimensionsDefine;
  var potentialNameDimIndex;

  if (sourceFormat === __WEBPACK_IMPORTED_MODULE_2__util_types_js__["e" /* SOURCE_FORMAT_OBJECT_ROWS */] || sourceFormat === __WEBPACK_IMPORTED_MODULE_2__util_types_js__["f" /* SOURCE_FORMAT_KEYED_COLUMNS */]) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(dimensionsDefine, function (dim, idx) {
      if ((__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isObject"])(dim) ? dim.name : dim) === 'name') {
        potentialNameDimIndex = idx;
      }
    });
  }

  var idxResult = function () {
    var idxRes0 = {};
    var idxRes1 = {};
    var guessRecords = []; // 5 is an experience value.

    for (var i = 0, len = Math.min(5, dimCount); i < len; i++) {
      var guessResult = doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
      guessRecords.push(guessResult);
      var isPureNumber = guessResult === BE_ORDINAL.Not; // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
      // and then find a name dim with the priority:
      // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".

      if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) {
        idxRes0.v = i;
      }

      if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === BE_ORDINAL.Not) {
        idxRes0.n = i;
      }

      if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== BE_ORDINAL.Not) {
        return idxRes0;
      } // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
      // find the first BE_ORDINAL.Might as the value dim,
      // and then find a name dim with the priority:
      // "other dim" > "the value dim itself".
      // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
      // treated as number.


      if (!isPureNumber) {
        if (guessResult === BE_ORDINAL.Might && idxRes1.v == null && i !== potentialNameDimIndex) {
          idxRes1.v = i;
        }

        if (idxRes1.n == null || idxRes1.n === idxRes1.v) {
          idxRes1.n = i;
        }
      }
    }

    function fulfilled(idxResult) {
      return idxResult.v != null && idxResult.n != null;
    }

    return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
  }();

  if (idxResult) {
    encode.value = [idxResult.v]; // `potentialNameDimIndex` has highest priority.

    var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n; // By default, label use itemName in charts.
    // So we dont set encodeLabel here.

    encode.itemName = [nameDimIndex];
    encode.seriesName = [nameDimIndex];
  }

  return encode;
}
/**
 * @return If return null/undefined, indicate that should not use datasetModel.
 */

function querySeriesUpstreamDatasetModel(seriesModel) {
  // Caution: consider the scenario:
  // A dataset is declared and a series is not expected to use the dataset,
  // and at the beginning `setOption({series: { noData })` (just prepare other
  // option but no data), then `setOption({series: {data: [...]}); In this case,
  // the user should set an empty array to avoid that dataset is used by default.
  var thisData = seriesModel.get('data', true);

  if (!thisData) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_model_js__["h" /* queryReferringComponents */])(seriesModel.ecModel, 'dataset', {
      index: seriesModel.get('datasetIndex', true),
      id: seriesModel.get('datasetId', true)
    }, __WEBPACK_IMPORTED_MODULE_0__util_model_js__["i" /* SINGLE_REFERRING */]).models[0];
  }
}
/**
 * @return Always return an array event empty.
 */

function queryDatasetUpstreamDatasetModels(datasetModel) {
  // Only these attributes declared, we by defualt reference to `datasetIndex: 0`.
  // Otherwise, no reference.
  if (!datasetModel.get('transform', true) && !datasetModel.get('fromTransformResult', true)) {
    return [];
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_model_js__["h" /* queryReferringComponents */])(datasetModel.ecModel, 'dataset', {
    index: datasetModel.get('fromDatasetIndex', true),
    id: datasetModel.get('fromDatasetId', true)
  }, __WEBPACK_IMPORTED_MODULE_0__util_model_js__["i" /* SINGLE_REFERRING */]).models;
}
/**
 * The rule should not be complex, otherwise user might not
 * be able to known where the data is wrong.
 * The code is ugly, but how to make it neat?
 */

function guessOrdinal(source, dimIndex) {
  return doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
} // dimIndex may be overflow source data.
// return {BE_ORDINAL}

function doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
  var result; // Experience value.

  var maxLoop = 5;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isTypedArray"])(data)) {
    return BE_ORDINAL.Not;
  } // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
  // always exists in source.


  var dimName;
  var dimType;

  if (dimensionsDefine) {
    var dimDefItem = dimensionsDefine[dimIndex];

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isObject"])(dimDefItem)) {
      dimName = dimDefItem.name;
      dimType = dimDefItem.type;
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"])(dimDefItem)) {
      dimName = dimDefItem;
    }
  }

  if (dimType != null) {
    return dimType === 'ordinal' ? BE_ORDINAL.Must : BE_ORDINAL.Not;
  }

  if (sourceFormat === __WEBPACK_IMPORTED_MODULE_2__util_types_js__["b" /* SOURCE_FORMAT_ARRAY_ROWS */]) {
    var dataArrayRows = data;

    if (seriesLayoutBy === __WEBPACK_IMPORTED_MODULE_2__util_types_js__["d" /* SERIES_LAYOUT_BY_ROW */]) {
      var sample = dataArrayRows[dimIndex];

      for (var i = 0; i < (sample || []).length && i < maxLoop; i++) {
        if ((result = detectValue(sample[startIndex + i])) != null) {
          return result;
        }
      }
    } else {
      for (var i = 0; i < dataArrayRows.length && i < maxLoop; i++) {
        var row = dataArrayRows[startIndex + i];

        if (row && (result = detectValue(row[dimIndex])) != null) {
          return result;
        }
      }
    }
  } else if (sourceFormat === __WEBPACK_IMPORTED_MODULE_2__util_types_js__["e" /* SOURCE_FORMAT_OBJECT_ROWS */]) {
    var dataObjectRows = data;

    if (!dimName) {
      return BE_ORDINAL.Not;
    }

    for (var i = 0; i < dataObjectRows.length && i < maxLoop; i++) {
      var item = dataObjectRows[i];

      if (item && (result = detectValue(item[dimName])) != null) {
        return result;
      }
    }
  } else if (sourceFormat === __WEBPACK_IMPORTED_MODULE_2__util_types_js__["f" /* SOURCE_FORMAT_KEYED_COLUMNS */]) {
    var dataKeyedColumns = data;

    if (!dimName) {
      return BE_ORDINAL.Not;
    }

    var sample = dataKeyedColumns[dimName];

    if (!sample || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isTypedArray"])(sample)) {
      return BE_ORDINAL.Not;
    }

    for (var i = 0; i < sample.length && i < maxLoop; i++) {
      if ((result = detectValue(sample[i])) != null) {
        return result;
      }
    }
  } else if (sourceFormat === __WEBPACK_IMPORTED_MODULE_2__util_types_js__["g" /* SOURCE_FORMAT_ORIGINAL */]) {
    var dataOriginal = data;

    for (var i = 0; i < dataOriginal.length && i < maxLoop; i++) {
      var item = dataOriginal[i];
      var val = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_model_js__["g" /* getDataItemValue */])(item);

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(val)) {
        return BE_ORDINAL.Not;
      }

      if ((result = detectValue(val[dimIndex])) != null) {
        return result;
      }
    }
  }

  function detectValue(val) {
    var beStr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"])(val); // Consider usage convenience, '1', '2' will be treated as "number".
    // `isFinit('')` get `true`.

    if (val != null && isFinite(val) && val !== '') {
      return beStr ? BE_ORDINAL.Might : BE_ORDINAL.Not;
    } else if (beStr && val !== '-') {
      return BE_ORDINAL.Must;
    }
  }

  return BE_ORDINAL.Not;
}

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = parseClassType;
/* harmony export (immutable) */ __webpack_exports__["d"] = isExtendedClass;
/* harmony export (immutable) */ __webpack_exports__["b"] = enableClassExtend;
/* harmony export (immutable) */ __webpack_exports__["a"] = mountExtend;
/* harmony export (immutable) */ __webpack_exports__["c"] = enableClassCheck;
/* harmony export (immutable) */ __webpack_exports__["e"] = enableClassManagement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


var TYPE_DELIMITER = '.';
var IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
var IS_EXTENDED_CLASS = '___EC__EXTENDED_CLASS___';
/**
 * Notice, parseClassType('') should returns {main: '', sub: ''}
 * @public
 */

function parseClassType(componentType) {
  var ret = {
    main: '',
    sub: ''
  };

  if (componentType) {
    var typeArr = componentType.split(TYPE_DELIMITER);
    ret.main = typeArr[0] || '';
    ret.sub = typeArr[1] || '';
  }

  return ret;
}
/**
 * @public
 */

function checkClassType(componentType) {
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"](/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
}

function isExtendedClass(clz) {
  return !!(clz && clz[IS_EXTENDED_CLASS]);
}
/**
 * Implements `ExtendableConstructor` for `rootClz`.
 *
 * @usage
 * ```ts
 * class Xxx {}
 * type XxxConstructor = typeof Xxx & ExtendableConstructor
 * enableClassExtend(Xxx as XxxConstructor);
 * ```
 */

function enableClassExtend(rootClz, mandatoryMethods) {
  rootClz.$constructor = rootClz; // FIXME: not necessary?

  rootClz.extend = function (proto) {
    if (true) {
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](mandatoryMethods, function (method) {
        if (!proto[method]) {
          console.warn('Method `' + method + '` should be implemented' + (proto.type ? ' in ' + proto.type : '') + '.');
        }
      });
    }

    var superClass = this;
    var ExtendedClass;

    if (isESClass(superClass)) {
      ExtendedClass =
      /** @class */
      function (_super) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(class_1, _super);

        function class_1() {
          return _super.apply(this, arguments) || this;
        }

        return class_1;
      }(superClass);
    } else {
      // For backward compat, we both support ts class inheritance and this
      // "extend" approach.
      // The constructor should keep the same behavior as ts class inheritance:
      // If this constructor/$constructor is not declared, auto invoke the super
      // constructor.
      // If this constructor/$constructor is declared, it is responsible for
      // calling the super constructor.
      ExtendedClass = function () {
        (proto.$constructor || superClass).apply(this, arguments);
      };

      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["inherits"](ExtendedClass, this);
    }

    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"](ExtendedClass.prototype, proto);
    ExtendedClass[IS_EXTENDED_CLASS] = true;
    ExtendedClass.extend = this.extend;
    ExtendedClass.superCall = superCall;
    ExtendedClass.superApply = superApply;
    ExtendedClass.superClass = superClass;
    return ExtendedClass;
  };
}

function isESClass(fn) {
  return __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isFunction"](fn) && /^class\s/.test(Function.prototype.toString.call(fn));
}
/**
 * A work around to both support ts extend and this extend mechanism.
 * on sub-class.
 * @usage
 * ```ts
 * class Component { ... }
 * classUtil.enableClassExtend(Component);
 * classUtil.enableClassManagement(Component, {registerWhenExtend: true});
 *
 * class Series extends Component { ... }
 * // Without calling `markExtend`, `registerWhenExtend` will not work.
 * Component.markExtend(Series);
 * ```
 */


function mountExtend(SubClz, SupperClz) {
  SubClz.extend = SupperClz.extend;
} // A random offset.

var classBase = Math.round(Math.random() * 10);
/**
 * Implements `CheckableConstructor` for `target`.
 * Can not use instanceof, consider different scope by
 * cross domain or es module import in ec extensions.
 * Mount a method "isInstance()" to Clz.
 *
 * @usage
 * ```ts
 * class Xxx {}
 * type XxxConstructor = typeof Xxx & CheckableConstructor;
 * enableClassCheck(Xxx as XxxConstructor)
 * ```
 */

function enableClassCheck(target) {
  var classAttr = ['__\0is_clz', classBase++].join('_');
  target.prototype[classAttr] = true;

  if (true) {
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"](!target.isInstance, 'The method "is" can not be defined.');
  }

  target.isInstance = function (obj) {
    return !!(obj && obj[classAttr]);
  };
} // superCall should have class info, which can not be fetch from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, do not overrides method f,
// then when method of class C is called, dead loop occured.

function superCall(context, methodName) {
  var args = [];

  for (var _i = 2; _i < arguments.length; _i++) {
    args[_i - 2] = arguments[_i];
  }

  return this.superClass.prototype[methodName].apply(context, args);
}

function superApply(context, methodName, args) {
  return this.superClass.prototype[methodName].apply(context, args);
}
/**
 * Implements `ClassManager` for `target`
 *
 * @usage
 * ```ts
 * class Xxx {}
 * type XxxConstructor = typeof Xxx & ClassManager
 * enableClassManagement(Xxx as XxxConstructor);
 * ```
 */


function enableClassManagement(target) {
  /**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'xxx'
   *     or Object.<subKey, componentClass>, when componentType is 'xxx.yy'
   */
  var storage = {};

  target.registerClass = function (clz) {
    // `type` should not be a "instance memeber".
    // If using TS class, should better declared as `static type = 'series.pie'`.
    // otherwise users have to mount `type` on prototype manually.
    // For backward compat and enable instance visit type via `this.type`,
    // we stil support fetch `type` from prototype.
    var componentFullType = clz.type || clz.prototype.type;

    if (componentFullType) {
      checkClassType(componentFullType); // If only static type declared, we assign it to prototype mandatorily.

      clz.prototype.type = componentFullType;
      var componentTypeInfo = parseClassType(componentFullType);

      if (!componentTypeInfo.sub) {
        if (true) {
          if (storage[componentTypeInfo.main]) {
            console.warn(componentTypeInfo.main + ' exists.');
          }
        }

        storage[componentTypeInfo.main] = clz;
      } else if (componentTypeInfo.sub !== IS_CONTAINER) {
        var container = makeContainer(componentTypeInfo);
        container[componentTypeInfo.sub] = clz;
      }
    }

    return clz;
  };

  target.getClass = function (mainType, subType, throwWhenNotFound) {
    var clz = storage[mainType];

    if (clz && clz[IS_CONTAINER]) {
      clz = subType ? clz[subType] : null;
    }

    if (throwWhenNotFound && !clz) {
      throw new Error(!subType ? mainType + '.' + 'type should be specified.' : 'Component ' + mainType + '.' + (subType || '') + ' is used but not imported.');
    }

    return clz;
  };

  target.getClassesByMainType = function (componentType) {
    var componentTypeInfo = parseClassType(componentType);
    var result = [];
    var obj = storage[componentTypeInfo.main];

    if (obj && obj[IS_CONTAINER]) {
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](obj, function (o, type) {
        type !== IS_CONTAINER && result.push(o);
      });
    } else {
      result.push(obj);
    }

    return result;
  };

  target.hasClass = function (componentType) {
    // Just consider componentType.main.
    var componentTypeInfo = parseClassType(componentType);
    return !!storage[componentTypeInfo.main];
  };
  /**
   * @return Like ['aa', 'bb'], but can not be ['aa.xx']
   */


  target.getAllClassMainTypes = function () {
    var types = [];
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](storage, function (obj, type) {
      types.push(type);
    });
    return types;
  };
  /**
   * If a main type is container and has sub types
   */


  target.hasSubTypes = function (componentType) {
    var componentTypeInfo = parseClassType(componentType);
    var obj = storage[componentTypeInfo.main];
    return obj && obj[IS_CONTAINER];
  };

  function makeContainer(componentTypeInfo) {
    var container = storage[componentTypeInfo.main];

    if (!container || !container[IS_CONTAINER]) {
      container = storage[componentTypeInfo.main] = {};
      container[IS_CONTAINER] = true;
    }

    return container;
  }
} // /**
//  * @param {string|Array.<string>} properties
//  */
// export function setReadOnly(obj, properties) {
// FIXME It seems broken in IE8 simulation of IE11
// if (!zrUtil.isArray(properties)) {
//     properties = properties != null ? [properties] : [];
// }
// zrUtil.each(properties, function (prop) {
//     let value = obj[prop];
//     Object.defineProperty
//         && Object.defineProperty(obj, prop, {
//             value: value, writable: false
//         });
//     zrUtil.isArray(obj[prop])
//         && Object.freeze
//         && Object.freeze(obj[prop]);
// });
// }

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = throttle;
/* harmony export (immutable) */ __webpack_exports__["a"] = createOrUpdate;
/* harmony export (immutable) */ __webpack_exports__["b"] = clear;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var ORIGIN_METHOD = '\0__throttleOriginMethod';
var RATE = '\0__throttleRate';
var THROTTLE_TYPE = '\0__throttleType';
;
/**
 * @public
 * @param {(Function)} fn
 * @param {number} [delay=0] Unit: ms.
 * @param {boolean} [debounce=false]
 *        true: If call interval less than `delay`, only the last call works.
 *        false: If call interval less than `delay, call works on fixed rate.
 * @return {(Function)} throttled fn.
 */

function throttle(fn, delay, debounce) {
  var currCall;
  var lastCall = 0;
  var lastExec = 0;
  var timer = null;
  var diff;
  var scope;
  var args;
  var debounceNextCall;
  delay = delay || 0;

  function exec() {
    lastExec = new Date().getTime();
    timer = null;
    fn.apply(scope, args || []);
  }

  var cb = function () {
    var cbArgs = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      cbArgs[_i] = arguments[_i];
    }

    currCall = new Date().getTime();
    scope = this;
    args = cbArgs;
    var thisDelay = debounceNextCall || delay;
    var thisDebounce = debounceNextCall || debounce;
    debounceNextCall = null;
    diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
    clearTimeout(timer); // Here we should make sure that: the `exec` SHOULD NOT be called later
    // than a new call of `cb`, that is, preserving the command order. Consider
    // calculating "scale rate" when roaming as an example. When a call of `cb`
    // happens, either the `exec` is called dierectly, or the call is delayed.
    // But the delayed call should never be later than next call of `cb`. Under
    // this assurance, we can simply update view state each time `dispatchAction`
    // triggered by user roaming, but not need to add extra code to avoid the
    // state being "rolled-back".

    if (thisDebounce) {
      timer = setTimeout(exec, thisDelay);
    } else {
      if (diff >= 0) {
        exec();
      } else {
        timer = setTimeout(exec, -diff);
      }
    }

    lastCall = currCall;
  };
  /**
   * Clear throttle.
   * @public
   */


  cb.clear = function () {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };
  /**
   * Enable debounce once.
   */


  cb.debounceNextCall = function (debounceDelay) {
    debounceNextCall = debounceDelay;
  };

  return cb;
}
/**
 * Create throttle method or update throttle rate.
 *
 * @example
 * ComponentView.prototype.render = function () {
 *     ...
 *     throttle.createOrUpdate(
 *         this,
 *         '_dispatchAction',
 *         this.model.get('throttle'),
 *         'fixRate'
 *     );
 * };
 * ComponentView.prototype.remove = function () {
 *     throttle.clear(this, '_dispatchAction');
 * };
 * ComponentView.prototype.dispose = function () {
 *     throttle.clear(this, '_dispatchAction');
 * };
 *
 */

function createOrUpdate(obj, fnAttr, rate, throttleType) {
  var fn = obj[fnAttr];

  if (!fn) {
    return;
  }

  var originFn = fn[ORIGIN_METHOD] || fn;
  var lastThrottleType = fn[THROTTLE_TYPE];
  var lastRate = fn[RATE];

  if (lastRate !== rate || lastThrottleType !== throttleType) {
    if (rate == null || !throttleType) {
      return obj[fnAttr] = originFn;
    }

    fn = obj[fnAttr] = throttle(originFn, rate, throttleType === 'debounce');
    fn[ORIGIN_METHOD] = originFn;
    fn[THROTTLE_TYPE] = throttleType;
    fn[RATE] = rate;
  }

  return fn;
}
/**
 * Clear throttle. Example see throttle.createOrUpdate.
 */

function clear(obj, fnAttr) {
  var fn = obj[fnAttr];

  if (fn && fn[ORIGIN_METHOD]) {
    // Clear throttle
    fn.clear && fn.clear();
    obj[fnAttr] = fn[ORIGIN_METHOD];
  }
}

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = clientToLocal;
/* harmony export (immutable) */ __webpack_exports__["e"] = getNativeEvent;
/* harmony export (immutable) */ __webpack_exports__["d"] = normalizeEvent;
/* harmony export (immutable) */ __webpack_exports__["f"] = addEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = removeEventListener;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return stop; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isMiddleOrRightButtonOnMouseUpDown;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Eventful_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_js__ = __webpack_require__(583);
/* unused harmony reexport Dispatcher */



var MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
var _calcOut = [];
var firefoxNotSupportOffsetXY = __WEBPACK_IMPORTED_MODULE_1__env_js__["a" /* default */].browser.firefox
    && +__WEBPACK_IMPORTED_MODULE_1__env_js__["a" /* default */].browser.version.split('.')[0] < 39;
function clientToLocal(el, e, out, calculate) {
    out = out || {};
    if (calculate) {
        calculateZrXY(el, e, out);
    }
    else if (firefoxNotSupportOffsetXY
        && e.layerX != null
        && e.layerX !== e.offsetX) {
        out.zrX = e.layerX;
        out.zrY = e.layerY;
    }
    else if (e.offsetX != null) {
        out.zrX = e.offsetX;
        out.zrY = e.offsetY;
    }
    else {
        calculateZrXY(el, e, out);
    }
    return out;
}
function calculateZrXY(el, e, out) {
    if (__WEBPACK_IMPORTED_MODULE_1__env_js__["a" /* default */].domSupported && el.getBoundingClientRect) {
        var ex = e.clientX;
        var ey = e.clientY;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_js__["a" /* isCanvasEl */])(el)) {
            var box = el.getBoundingClientRect();
            out.zrX = ex - box.left;
            out.zrY = ey - box.top;
            return;
        }
        else {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_js__["b" /* transformCoordWithViewport */])(_calcOut, el, ex, ey)) {
                out.zrX = _calcOut[0];
                out.zrY = _calcOut[1];
                return;
            }
        }
    }
    out.zrX = out.zrY = 0;
}
function getNativeEvent(e) {
    return e
        || window.event;
}
function normalizeEvent(el, e, calculate) {
    e = getNativeEvent(e);
    if (e.zrX != null) {
        return e;
    }
    var eventType = e.type;
    var isTouch = eventType && eventType.indexOf('touch') >= 0;
    if (!isTouch) {
        clientToLocal(el, e, e, calculate);
        var wheelDelta = getWheelDeltaMayPolyfill(e);
        e.zrDelta = wheelDelta ? wheelDelta / 120 : -(e.detail || 0) / 3;
    }
    else {
        var touch = eventType !== 'touchend'
            ? e.targetTouches[0]
            : e.changedTouches[0];
        touch && clientToLocal(el, touch, e, calculate);
    }
    var button = e.button;
    if (e.which == null && button !== undefined && MOUSE_EVENT_REG.test(e.type)) {
        e.which = (button & 1 ? 1 : (button & 2 ? 3 : (button & 4 ? 2 : 0)));
    }
    return e;
}
function getWheelDeltaMayPolyfill(e) {
    var rawWheelDelta = e.wheelDelta;
    if (rawWheelDelta) {
        return rawWheelDelta;
    }
    var deltaX = e.deltaX;
    var deltaY = e.deltaY;
    if (deltaX == null || deltaY == null) {
        return rawWheelDelta;
    }
    var delta = deltaY !== 0 ? Math.abs(deltaY) : Math.abs(deltaX);
    var sign = deltaY > 0 ? -1
        : deltaY < 0 ? 1
            : deltaX > 0 ? -1
                : 1;
    return 3 * delta * sign;
}
function addEventListener(el, name, handler, opt) {
    el.addEventListener(name, handler, opt);
}
function removeEventListener(el, name, handler, opt) {
    el.removeEventListener(name, handler, opt);
}
var stop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.cancelBubble = true;
};
function isMiddleOrRightButtonOnMouseUpDown(e) {
    return e.which === 2 || e.which === 3;
}



/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(757), __esModule: true };

/***/ }),
/* 104 */,
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(175);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(71);
var createDesc = __webpack_require__(180);
module.exports = __webpack_require__(70) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(25)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(54)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(130)('meta');
var isObject = __webpack_require__(18);
var has = __webpack_require__(61);
var setDesc = __webpack_require__(33).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(16)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = retrieveTargetInfo;
/* harmony export (immutable) */ __webpack_exports__["d"] = getPathToRoot;
/* harmony export (immutable) */ __webpack_exports__["b"] = aboveViewRoot;
/* harmony export (immutable) */ __webpack_exports__["c"] = wrapTreePathInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

function retrieveTargetInfo(payload, validPayloadTypes, seriesModel) {
  if (payload && __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"](validPayloadTypes, payload.type) >= 0) {
    var root = seriesModel.getData().tree.root;
    var targetNode = payload.targetNode;

    if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"](targetNode)) {
      targetNode = root.getNodeById(targetNode);
    }

    if (targetNode && root.contains(targetNode)) {
      return {
        node: targetNode
      };
    }

    var targetNodeId = payload.targetNodeId;

    if (targetNodeId != null && (targetNode = root.getNodeById(targetNodeId))) {
      return {
        node: targetNode
      };
    }
  }
} // Not includes the given node at the last item.

function getPathToRoot(node) {
  var path = [];

  while (node) {
    node = node.parentNode;
    node && path.push(node);
  }

  return path.reverse();
}
function aboveViewRoot(viewRoot, node) {
  var viewPath = getPathToRoot(viewRoot);
  return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"](viewPath, node) >= 0;
} // From root to the input node (the input node will be included).

function wrapTreePathInfo(node, seriesModel) {
  var treePathInfo = [];

  while (node) {
    var nodeDataIndex = node.dataIndex;
    treePathInfo.push({
      name: node.name,
      dataIndex: nodeDataIndex,
      value: seriesModel.getRawValue(nodeDataIndex)
    });
    node = node.parentNode;
  }

  treePathInfo.reverse();
  return treePathInfo;
}

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_Model_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_symbol_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_matrix_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_vector_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__coord_axisHelper_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__label_labelLayoutHelper_js__ = __webpack_require__(334);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/











var PI = Math.PI;
/**
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
 * for example: (0, 0) ------------> (0, 50)
 *
 * nameDirection or tickDirection or labelDirection is 1 means tick
 * or label is below the standard axis, whereas is -1 means above
 * the standard axis. labelOffset means offset between label and axis,
 * which is useful when 'onZero', where axisLabel is in the grid and
 * label in outside grid.
 *
 * Tips: like always,
 * positive rotation represents anticlockwise, and negative rotation
 * represents clockwise.
 * The direction of position coordinate is the same as the direction
 * of screen coordinate.
 *
 * Do not need to consider axis 'inverse', which is auto processed by
 * axis extent.
 */

var AxisBuilder =
/** @class */
function () {
  function AxisBuilder(axisModel, opt) {
    this.group = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Group"]();
    this.opt = opt;
    this.axisModel = axisModel; // Default value

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["defaults"])(opt, {
      labelOffset: 0,
      nameDirection: 1,
      tickDirection: 1,
      labelDirection: 1,
      silent: true,
      handleAutoShown: function () {
        return true;
      }
    }); // FIXME Not use a seperate text group?

    var transformGroup = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Group"]({
      x: opt.position[0],
      y: opt.position[1],
      rotation: opt.rotation
    }); // this.group.add(transformGroup);
    // this._transformGroup = transformGroup;

    transformGroup.updateTransform();
    this._transformGroup = transformGroup;
  }

  AxisBuilder.prototype.hasBuilder = function (name) {
    return !!builders[name];
  };

  AxisBuilder.prototype.add = function (name) {
    builders[name](this.opt, this.axisModel, this.group, this._transformGroup);
  };

  AxisBuilder.prototype.getGroup = function () {
    return this.group;
  };

  AxisBuilder.innerTextLayout = function (axisRotation, textRotation, direction) {
    var rotationDiff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_number_js__["q" /* remRadian */])(textRotation - axisRotation);
    var textAlign;
    var textVerticalAlign;

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_number_js__["r" /* isRadianAroundZero */])(rotationDiff)) {
      // Label is parallel with axis line.
      textVerticalAlign = direction > 0 ? 'top' : 'bottom';
      textAlign = 'center';
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_number_js__["r" /* isRadianAroundZero */])(rotationDiff - PI)) {
      // Label is inverse parallel with axis line.
      textVerticalAlign = direction > 0 ? 'bottom' : 'top';
      textAlign = 'center';
    } else {
      textVerticalAlign = 'middle';

      if (rotationDiff > 0 && rotationDiff < PI) {
        textAlign = direction > 0 ? 'right' : 'left';
      } else {
        textAlign = direction > 0 ? 'left' : 'right';
      }
    }

    return {
      rotation: rotationDiff,
      textAlign: textAlign,
      textVerticalAlign: textVerticalAlign
    };
  };

  AxisBuilder.makeAxisEventDataBase = function (axisModel) {
    var eventData = {
      componentType: axisModel.mainType,
      componentIndex: axisModel.componentIndex
    };
    eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
    return eventData;
  };

  AxisBuilder.isLabelSilent = function (axisModel) {
    var tooltipOpt = axisModel.get('tooltip');
    return axisModel.get('silent') // Consider mouse cursor, add these restrictions.
    || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
  };

  return AxisBuilder;
}();

;
var builders = {
  axisLine: function (opt, axisModel, group, transformGroup) {
    var shown = axisModel.get(['axisLine', 'show']);

    if (shown === 'auto' && opt.handleAutoShown) {
      shown = opt.handleAutoShown('axisLine');
    }

    if (!shown) {
      return;
    }

    var extent = axisModel.axis.getExtent();
    var matrix = transformGroup.transform;
    var pt1 = [extent[0], 0];
    var pt2 = [extent[1], 0];

    if (matrix) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_vector_js__["applyTransform"])(pt1, pt1, matrix);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_vector_js__["applyTransform"])(pt2, pt2, matrix);
    }

    var lineStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"])({
      lineCap: 'round'
    }, axisModel.getModel(['axisLine', 'lineStyle']).getLineStyle());
    var line = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Line"]({
      // Id for animation
      subPixelOptimize: true,
      shape: {
        x1: pt1[0],
        y1: pt1[1],
        x2: pt2[0],
        y2: pt2[1]
      },
      style: lineStyle,
      strokeContainThreshold: opt.strokeContainThreshold || 5,
      silent: true,
      z2: 1
    });
    line.anid = 'line';
    group.add(line);
    var arrows = axisModel.get(['axisLine', 'symbol']);

    if (arrows != null) {
      var arrowSize = axisModel.get(['axisLine', 'symbolSize']);

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"])(arrows)) {
        // Use the same arrow for start and end point
        arrows = [arrows, arrows];
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"])(arrowSize) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isNumber"])(arrowSize)) {
        // Use the same size for width and height
        arrowSize = [arrowSize, arrowSize];
      }

      var arrowOffset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_symbol_js__["d" /* normalizeSymbolOffset */])(axisModel.get(['axisLine', 'symbolOffset']) || 0, arrowSize);
      var symbolWidth_1 = arrowSize[0];
      var symbolHeight_1 = arrowSize[1];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])([{
        rotate: opt.rotation + Math.PI / 2,
        offset: arrowOffset[0],
        r: 0
      }, {
        rotate: opt.rotation - Math.PI / 2,
        offset: arrowOffset[1],
        r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
      }], function (point, index) {
        if (arrows[index] !== 'none' && arrows[index] != null) {
          var symbol = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_symbol_js__["a" /* createSymbol */])(arrows[index], -symbolWidth_1 / 2, -symbolHeight_1 / 2, symbolWidth_1, symbolHeight_1, lineStyle.stroke, true); // Calculate arrow position with offset

          var r = point.r + point.offset;
          symbol.attr({
            rotation: point.rotate,
            x: pt1[0] + r * Math.cos(opt.rotation),
            y: pt1[1] - r * Math.sin(opt.rotation),
            silent: true,
            z2: 11
          });
          group.add(symbol);
        }
      });
    }
  },
  axisTickLabel: function (opt, axisModel, group, transformGroup) {
    var ticksEls = buildAxisMajorTicks(group, transformGroup, axisModel, opt);
    var labelEls = buildAxisLabel(group, transformGroup, axisModel, opt);
    fixMinMaxLabelShow(axisModel, labelEls, ticksEls);
    buildAxisMinorTicks(group, transformGroup, axisModel, opt.tickDirection); // This bit fixes the label overlap issue for the time chart.
    // See https://github.com/apache/echarts/issues/14266 for more.

    if (axisModel.get(['axisLabel', 'hideOverlap'])) {
      var labelList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__label_labelLayoutHelper_js__["a" /* prepareLayoutList */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])(labelEls, function (label) {
        return {
          label: label,
          priority: label.z2,
          defaultAttr: {
            ignore: label.ignore
          }
        };
      }));
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__label_labelLayoutHelper_js__["d" /* hideOverlap */])(labelList);
    }
  },
  axisName: function (opt, axisModel, group, transformGroup) {
    var name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve"])(opt.axisName, axisModel.get('name'));

    if (!name) {
      return;
    }

    var nameLocation = axisModel.get('nameLocation');
    var nameDirection = opt.nameDirection;
    var textStyleModel = axisModel.getModel('nameTextStyle');
    var gap = axisModel.get('nameGap') || 0;
    var extent = axisModel.axis.getExtent();
    var gapSignal = extent[0] > extent[1] ? -1 : 1;
    var pos = [nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2, // Reuse labelOffset.
    isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0];
    var labelLayout;
    var nameRotation = axisModel.get('nameRotate');

    if (nameRotation != null) {
      nameRotation = nameRotation * PI / 180; // To radian.
    }

    var axisNameAvailableWidth;

    if (isNameLocationCenter(nameLocation)) {
      labelLayout = AxisBuilder.innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, // Adapt to axis.
      nameDirection);
    } else {
      labelLayout = endTextLayout(opt.rotation, nameLocation, nameRotation || 0, extent);
      axisNameAvailableWidth = opt.axisNameAvailableWidth;

      if (axisNameAvailableWidth != null) {
        axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
        !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
      }
    }

    var textFont = textStyleModel.getFont();
    var truncateOpt = axisModel.get('nameTruncate', true) || {};
    var ellipsis = truncateOpt.ellipsis;
    var maxWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve"])(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth);
    var textEl = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Text"]({
      x: pos[0],
      y: pos[1],
      rotation: labelLayout.rotation,
      silent: AxisBuilder.isLabelSilent(axisModel),
      style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__label_labelStyle_js__["d" /* createTextStyle */])(textStyleModel, {
        text: name,
        font: textFont,
        overflow: 'truncate',
        width: maxWidth,
        ellipsis: ellipsis,
        fill: textStyleModel.getTextColor() || axisModel.get(['axisLine', 'lineStyle', 'color']),
        align: textStyleModel.get('align') || labelLayout.textAlign,
        verticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
      }),
      z2: 1
    });
    __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["setTooltipConfig"]({
      el: textEl,
      componentModel: axisModel,
      itemName: name
    });
    textEl.__fullText = name; // Id for animation

    textEl.anid = 'name';

    if (axisModel.get('triggerEvent')) {
      var eventData = AxisBuilder.makeAxisEventDataBase(axisModel);
      eventData.targetType = 'axisName';
      eventData.name = name;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_innerStore_js__["a" /* getECData */])(textEl).eventData = eventData;
    } // FIXME


    transformGroup.add(textEl);
    textEl.updateTransform();
    group.add(textEl);
    textEl.decomposeTransform();
  }
};

function endTextLayout(rotation, textPosition, textRotate, extent) {
  var rotationDiff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_number_js__["q" /* remRadian */])(textRotate - rotation);
  var textAlign;
  var textVerticalAlign;
  var inverse = extent[0] > extent[1];
  var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_number_js__["r" /* isRadianAroundZero */])(rotationDiff - PI / 2)) {
    textVerticalAlign = onLeft ? 'bottom' : 'top';
    textAlign = 'center';
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_number_js__["r" /* isRadianAroundZero */])(rotationDiff - PI * 1.5)) {
    textVerticalAlign = onLeft ? 'top' : 'bottom';
    textAlign = 'center';
  } else {
    textVerticalAlign = 'middle';

    if (rotationDiff < PI * 1.5 && rotationDiff > PI / 2) {
      textAlign = onLeft ? 'left' : 'right';
    } else {
      textAlign = onLeft ? 'right' : 'left';
    }
  }

  return {
    rotation: rotationDiff,
    textAlign: textAlign,
    textVerticalAlign: textVerticalAlign
  };
}

function fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__coord_axisHelper_js__["d" /* shouldShowAllLabels */])(axisModel.axis)) {
    return;
  } // If min or max are user set, we need to check
  // If the tick on min(max) are overlap on their neighbour tick
  // If they are overlapped, we need to hide the min(max) tick label


  var showMinLabel = axisModel.get(['axisLabel', 'showMinLabel']);
  var showMaxLabel = axisModel.get(['axisLabel', 'showMaxLabel']); // FIXME
  // Have not consider onBand yet, where tick els is more than label els.

  labelEls = labelEls || [];
  tickEls = tickEls || [];
  var firstLabel = labelEls[0];
  var nextLabel = labelEls[1];
  var lastLabel = labelEls[labelEls.length - 1];
  var prevLabel = labelEls[labelEls.length - 2];
  var firstTick = tickEls[0];
  var nextTick = tickEls[1];
  var lastTick = tickEls[tickEls.length - 1];
  var prevTick = tickEls[tickEls.length - 2];

  if (showMinLabel === false) {
    ignoreEl(firstLabel);
    ignoreEl(firstTick);
  } else if (isTwoLabelOverlapped(firstLabel, nextLabel)) {
    if (showMinLabel) {
      ignoreEl(nextLabel);
      ignoreEl(nextTick);
    } else {
      ignoreEl(firstLabel);
      ignoreEl(firstTick);
    }
  }

  if (showMaxLabel === false) {
    ignoreEl(lastLabel);
    ignoreEl(lastTick);
  } else if (isTwoLabelOverlapped(prevLabel, lastLabel)) {
    if (showMaxLabel) {
      ignoreEl(prevLabel);
      ignoreEl(prevTick);
    } else {
      ignoreEl(lastLabel);
      ignoreEl(lastTick);
    }
  }
}

function ignoreEl(el) {
  el && (el.ignore = true);
}

function isTwoLabelOverlapped(current, next) {
  // current and next has the same rotation.
  var firstRect = current && current.getBoundingRect().clone();
  var nextRect = next && next.getBoundingRect().clone();

  if (!firstRect || !nextRect) {
    return;
  } // When checking intersect of two rotated labels, we use mRotationBack
  // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.


  var mRotationBack = __WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_matrix_js__["identity"]([]);
  __WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_matrix_js__["rotate"](mRotationBack, mRotationBack, -current.rotation);
  firstRect.applyTransform(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_matrix_js__["mul"]([], mRotationBack, current.getLocalTransform()));
  nextRect.applyTransform(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_matrix_js__["mul"]([], mRotationBack, next.getLocalTransform()));
  return firstRect.intersect(nextRect);
}

function isNameLocationCenter(nameLocation) {
  return nameLocation === 'middle' || nameLocation === 'center';
}

function createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, anidPrefix) {
  var tickEls = [];
  var pt1 = [];
  var pt2 = [];

  for (var i = 0; i < ticksCoords.length; i++) {
    var tickCoord = ticksCoords[i].coord;
    pt1[0] = tickCoord;
    pt1[1] = 0;
    pt2[0] = tickCoord;
    pt2[1] = tickEndCoord;

    if (tickTransform) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_vector_js__["applyTransform"])(pt1, pt1, tickTransform);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_vector_js__["applyTransform"])(pt2, pt2, tickTransform);
    } // Tick line, Not use group transform to have better line draw


    var tickEl = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Line"]({
      subPixelOptimize: true,
      shape: {
        x1: pt1[0],
        y1: pt1[1],
        x2: pt2[0],
        y2: pt2[1]
      },
      style: tickLineStyle,
      z2: 2,
      autoBatch: true,
      silent: true
    });
    tickEl.anid = anidPrefix + '_' + ticksCoords[i].tickValue;
    tickEls.push(tickEl);
  }

  return tickEls;
}

function buildAxisMajorTicks(group, transformGroup, axisModel, opt) {
  var axis = axisModel.axis;
  var tickModel = axisModel.getModel('axisTick');
  var shown = tickModel.get('show');

  if (shown === 'auto' && opt.handleAutoShown) {
    shown = opt.handleAutoShown('axisTick');
  }

  if (!shown || axis.scale.isBlank()) {
    return;
  }

  var lineStyleModel = tickModel.getModel('lineStyle');
  var tickEndCoord = opt.tickDirection * tickModel.get('length');
  var ticksCoords = axis.getTicksCoords();
  var ticksEls = createTicks(ticksCoords, transformGroup.transform, tickEndCoord, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["defaults"])(lineStyleModel.getLineStyle(), {
    stroke: axisModel.get(['axisLine', 'lineStyle', 'color'])
  }), 'ticks');

  for (var i = 0; i < ticksEls.length; i++) {
    group.add(ticksEls[i]);
  }

  return ticksEls;
}

function buildAxisMinorTicks(group, transformGroup, axisModel, tickDirection) {
  var axis = axisModel.axis;
  var minorTickModel = axisModel.getModel('minorTick');

  if (!minorTickModel.get('show') || axis.scale.isBlank()) {
    return;
  }

  var minorTicksCoords = axis.getMinorTicksCoords();

  if (!minorTicksCoords.length) {
    return;
  }

  var lineStyleModel = minorTickModel.getModel('lineStyle');
  var tickEndCoord = tickDirection * minorTickModel.get('length');
  var minorTickLineStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["defaults"])(lineStyleModel.getLineStyle(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["defaults"])(axisModel.getModel('axisTick').getLineStyle(), {
    stroke: axisModel.get(['axisLine', 'lineStyle', 'color'])
  }));

  for (var i = 0; i < minorTicksCoords.length; i++) {
    var minorTicksEls = createTicks(minorTicksCoords[i], transformGroup.transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);

    for (var k = 0; k < minorTicksEls.length; k++) {
      group.add(minorTicksEls[k]);
    }
  }
}

function buildAxisLabel(group, transformGroup, axisModel, opt) {
  var axis = axisModel.axis;
  var show = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve"])(opt.axisLabelShow, axisModel.get(['axisLabel', 'show']));

  if (!show || axis.scale.isBlank()) {
    return;
  }

  var labelModel = axisModel.getModel('axisLabel');
  var labelMargin = labelModel.get('margin');
  var labels = axis.getViewLabels(); // Special label rotate.

  var labelRotation = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve"])(opt.labelRotate, labelModel.get('rotate')) || 0) * PI / 180;
  var labelLayout = AxisBuilder.innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
  var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
  var labelEls = [];
  var silent = AxisBuilder.isLabelSilent(axisModel);
  var triggerEvent = axisModel.get('triggerEvent');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(labels, function (labelItem, index) {
    var tickValue = axis.scale.type === 'ordinal' ? axis.scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
    var formattedLabel = labelItem.formattedLabel;
    var rawLabel = labelItem.rawLabel;
    var itemLabelModel = labelModel;

    if (rawCategoryData && rawCategoryData[tickValue]) {
      var rawCategoryItem = rawCategoryData[tickValue];

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"])(rawCategoryItem) && rawCategoryItem.textStyle) {
        itemLabelModel = new __WEBPACK_IMPORTED_MODULE_4__model_Model_js__["a" /* default */](rawCategoryItem.textStyle, labelModel, axisModel.ecModel);
      }
    }

    var textColor = itemLabelModel.getTextColor() || axisModel.get(['axisLine', 'lineStyle', 'color']);
    var tickCoord = axis.dataToCoord(tickValue);
    var textEl = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Text"]({
      x: tickCoord,
      y: opt.labelOffset + opt.labelDirection * labelMargin,
      rotation: labelLayout.rotation,
      silent: silent,
      z2: 10 + (labelItem.level || 0),
      style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__label_labelStyle_js__["d" /* createTextStyle */])(itemLabelModel, {
        text: formattedLabel,
        align: itemLabelModel.getShallow('align', true) || labelLayout.textAlign,
        verticalAlign: itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign,
        fill: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"])(textColor) ? textColor( // (1) In category axis with data zoom, tick is not the original
        // index of axis.data. So tick should not be exposed to user
        // in category axis.
        // (2) Compatible with previous version, which always use formatted label as
        // input. But in interval scale the formatted label is like '223,445', which
        // maked user repalce ','. So we modify it to return original val but remain
        // it as 'string' to avoid error in replacing.
        axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
      })
    });
    textEl.anid = 'label_' + tickValue; // Pack data for mouse event

    if (triggerEvent) {
      var eventData = AxisBuilder.makeAxisEventDataBase(axisModel);
      eventData.targetType = 'axisLabel';
      eventData.value = rawLabel;
      eventData.tickIndex = index;

      if (axis.type === 'category') {
        eventData.dataIndex = tickValue;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_innerStore_js__["a" /* getECData */])(textEl).eventData = eventData;
    } // FIXME


    transformGroup.add(textEl);
    textEl.updateTransform();
    labelEls.push(textEl);
    group.add(textEl);
    textEl.decomposeTransform();
  });
  return labelEls;
}

/* harmony default export */ __webpack_exports__["a"] = (AxisBuilder);

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axisTickLabelBuilder_js__ = __webpack_require__(1286);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var NORMALIZED_EXTENT = [0, 1];
/**
 * Base class of Axis.
 */

var Axis =
/** @class */
function () {
  function Axis(dim, scale, extent) {
    this.onBand = false;
    this.inverse = false;
    this.dim = dim;
    this.scale = scale;
    this._extent = extent || [0, 0];
  }
  /**
   * If axis extent contain given coord
   */


  Axis.prototype.contain = function (coord) {
    var extent = this._extent;
    var min = Math.min(extent[0], extent[1]);
    var max = Math.max(extent[0], extent[1]);
    return coord >= min && coord <= max;
  };
  /**
   * If axis extent contain given data
   */


  Axis.prototype.containData = function (data) {
    return this.scale.contain(data);
  };
  /**
   * Get coord extent.
   */


  Axis.prototype.getExtent = function () {
    return this._extent.slice();
  };
  /**
   * Get precision used for formatting
   */


  Axis.prototype.getPixelPrecision = function (dataExtent) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["k" /* getPixelPrecision */])(dataExtent || this.scale.getExtent(), this._extent);
  };
  /**
   * Set coord extent
   */


  Axis.prototype.setExtent = function (start, end) {
    var extent = this._extent;
    extent[0] = start;
    extent[1] = end;
  };
  /**
   * Convert data to coord. Data is the rank if it has an ordinal scale
   */


  Axis.prototype.dataToCoord = function (data, clamp) {
    var extent = this._extent;
    var scale = this.scale;
    data = scale.normalize(data);

    if (this.onBand && scale.type === 'ordinal') {
      extent = extent.slice();
      fixExtentWithBands(extent, scale.count());
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["h" /* linearMap */])(data, NORMALIZED_EXTENT, extent, clamp);
  };
  /**
   * Convert coord to data. Data is the rank if it has an ordinal scale
   */


  Axis.prototype.coordToData = function (coord, clamp) {
    var extent = this._extent;
    var scale = this.scale;

    if (this.onBand && scale.type === 'ordinal') {
      extent = extent.slice();
      fixExtentWithBands(extent, scale.count());
    }

    var t = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["h" /* linearMap */])(coord, extent, NORMALIZED_EXTENT, clamp);
    return this.scale.scale(t);
  };
  /**
   * Convert pixel point to data in axis
   */


  Axis.prototype.pointToData = function (point, clamp) {
    // Should be implemented in derived class if necessary.
    return;
  };
  /**
   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
   * `axis.getTicksCoords` considers `onBand`, which is used by
   * `boundaryGap:true` of category axis and splitLine and splitArea.
   * @param opt.tickModel default: axis.model.getModel('axisTick')
   * @param opt.clamp If `true`, the first and the last
   *        tick must be at the axis end points. Otherwise, clip ticks
   *        that outside the axis extent.
   */


  Axis.prototype.getTicksCoords = function (opt) {
    opt = opt || {};
    var tickModel = opt.tickModel || this.getTickModel();
    var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__axisTickLabelBuilder_js__["a" /* createAxisTicks */])(this, tickModel);
    var ticks = result.ticks;
    var ticksCoords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])(ticks, function (tickVal) {
      return {
        coord: this.dataToCoord(this.scale.type === 'ordinal' ? this.scale.getRawOrdinalNumber(tickVal) : tickVal),
        tickValue: tickVal
      };
    }, this);
    var alignWithLabel = tickModel.get('alignWithLabel');
    fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
    return ticksCoords;
  };

  Axis.prototype.getMinorTicksCoords = function () {
    if (this.scale.type === 'ordinal') {
      // Category axis doesn't support minor ticks
      return [];
    }

    var minorTickModel = this.model.getModel('minorTick');
    var splitNumber = minorTickModel.get('splitNumber'); // Protection.

    if (!(splitNumber > 0 && splitNumber < 100)) {
      splitNumber = 5;
    }

    var minorTicks = this.scale.getMinorTicks(splitNumber);
    var minorTicksCoords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])(minorTicks, function (minorTicksGroup) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])(minorTicksGroup, function (minorTick) {
        return {
          coord: this.dataToCoord(minorTick),
          tickValue: minorTick
        };
      }, this);
    }, this);
    return minorTicksCoords;
  };

  Axis.prototype.getViewLabels = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__axisTickLabelBuilder_js__["b" /* createAxisLabels */])(this).labels;
  };

  Axis.prototype.getLabelModel = function () {
    return this.model.getModel('axisLabel');
  };
  /**
   * Notice here we only get the default tick model. For splitLine
   * or splitArea, we should pass the splitLineModel or splitAreaModel
   * manually when calling `getTicksCoords`.
   * In GL, this method may be overrided to:
   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
   */


  Axis.prototype.getTickModel = function () {
    return this.model.getModel('axisTick');
  };
  /**
   * Get width of band
   */


  Axis.prototype.getBandWidth = function () {
    var axisExtent = this._extent;
    var dataExtent = this.scale.getExtent();
    var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0); // Fix #2728, avoid NaN when only one data.

    len === 0 && (len = 1);
    var size = Math.abs(axisExtent[1] - axisExtent[0]);
    return Math.abs(size) / len;
  };
  /**
   * Only be called in category axis.
   * Can be overrided, consider other axes like in 3D.
   * @return Auto interval for cateogry axis tick and label
   */


  Axis.prototype.calculateCategoryInterval = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__axisTickLabelBuilder_js__["c" /* calculateCategoryInterval */])(this);
  };

  return Axis;
}();

function fixExtentWithBands(extent, nTick) {
  var size = extent[1] - extent[0];
  var len = nTick;
  var margin = size / len / 2;
  extent[0] += margin;
  extent[1] -= margin;
} // If axis has labels [1, 2, 3, 4]. Bands on the axis are
// |---1---|---2---|---3---|---4---|.
// So the displayed ticks and splitLine/splitArea should between
// each data item, otherwise cause misleading (e.g., split tow bars
// of a single data item when there are two bar series).
// Also consider if tickCategoryInterval > 0 and onBand, ticks and
// splitLine/spliteArea should layout appropriately corresponding
// to displayed labels. (So we should not use `getBandWidth` in this
// case).


function fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
  var ticksLen = ticksCoords.length;

  if (!axis.onBand || alignWithLabel || !ticksLen) {
    return;
  }

  var axisExtent = axis.getExtent();
  var last;
  var diffSize;

  if (ticksLen === 1) {
    ticksCoords[0].coord = axisExtent[0];
    last = ticksCoords[1] = {
      coord: axisExtent[0]
    };
  } else {
    var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
    var shift_1 = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(ticksCoords, function (ticksItem) {
      ticksItem.coord -= shift_1 / 2;
    });
    var dataExtent = axis.scale.getExtent();
    diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
    last = {
      coord: ticksCoords[ticksLen - 1].coord + shift_1 * diffSize
    };
    ticksCoords.push(last);
  }

  var inverse = axisExtent[0] > axisExtent[1]; // Handling clamp.

  if (littleThan(ticksCoords[0].coord, axisExtent[0])) {
    clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
  }

  if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) {
    ticksCoords.unshift({
      coord: axisExtent[0]
    });
  }

  if (littleThan(axisExtent[1], last.coord)) {
    clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
  }

  if (clamp && littleThan(last.coord, axisExtent[1])) {
    ticksCoords.push({
      coord: axisExtent[1]
    });
  }

  function littleThan(a, b) {
    // Avoid rounding error cause calculated tick coord different with extent.
    // It may cause an extra unecessary tick added.
    a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["d" /* round */])(a);
    b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["d" /* round */])(b);
    return inverse ? a > b : a < b;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (Axis);

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function dataIndexMapValueLength(valNumOrArrLengthMoreThan2) {
  return valNumOrArrLengthMoreThan2 == null ? 0 : valNumOrArrLengthMoreThan2.length || 1;
}

function defaultKeyGetter(item) {
  return item;
}

var DataDiffer =
/** @class */
function () {
  /**
   * @param context Can be visited by this.context in callback.
   */
  function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context, // By default: 'oneToOne'.
  diffMode) {
    this._old = oldArr;
    this._new = newArr;
    this._oldKeyGetter = oldKeyGetter || defaultKeyGetter;
    this._newKeyGetter = newKeyGetter || defaultKeyGetter; // Visible in callback via `this.context`;

    this.context = context;
    this._diffModeMultiple = diffMode === 'multiple';
  }
  /**
   * Callback function when add a data
   */


  DataDiffer.prototype.add = function (func) {
    this._add = func;
    return this;
  };
  /**
   * Callback function when update a data
   */


  DataDiffer.prototype.update = function (func) {
    this._update = func;
    return this;
  };
  /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */


  DataDiffer.prototype.updateManyToOne = function (func) {
    this._updateManyToOne = func;
    return this;
  };
  /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */


  DataDiffer.prototype.updateOneToMany = function (func) {
    this._updateOneToMany = func;
    return this;
  };
  /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */


  DataDiffer.prototype.updateManyToMany = function (func) {
    this._updateManyToMany = func;
    return this;
  };
  /**
   * Callback function when remove a data
   */


  DataDiffer.prototype.remove = function (func) {
    this._remove = func;
    return this;
  };

  DataDiffer.prototype.execute = function () {
    this[this._diffModeMultiple ? '_executeMultiple' : '_executeOneToOne']();
  };

  DataDiffer.prototype._executeOneToOne = function () {
    var oldArr = this._old;
    var newArr = this._new;
    var newDataIndexMap = {};
    var oldDataKeyArr = new Array(oldArr.length);
    var newDataKeyArr = new Array(newArr.length);

    this._initIndexMap(oldArr, null, oldDataKeyArr, '_oldKeyGetter');

    this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');

    for (var i = 0; i < oldArr.length; i++) {
      var oldKey = oldDataKeyArr[i];
      var newIdxMapVal = newDataIndexMap[oldKey];
      var newIdxMapValLen = dataIndexMapValueLength(newIdxMapVal); // idx can never be empty array here. see 'set null' logic below.

      if (newIdxMapValLen > 1) {
        // Consider there is duplicate key (for example, use dataItem.name as key).
        // We should make sure every item in newArr and oldArr can be visited.
        var newIdx = newIdxMapVal.shift();

        if (newIdxMapVal.length === 1) {
          newDataIndexMap[oldKey] = newIdxMapVal[0];
        }

        this._update && this._update(newIdx, i);
      } else if (newIdxMapValLen === 1) {
        newDataIndexMap[oldKey] = null;
        this._update && this._update(newIdxMapVal, i);
      } else {
        this._remove && this._remove(i);
      }
    }

    this._performRestAdd(newDataKeyArr, newDataIndexMap);
  };
  /**
   * For example, consider the case:
   * oldData: [o0, o1, o2, o3, o4, o5, o6, o7],
   * newData: [n0, n1, n2, n3, n4, n5, n6, n7, n8],
   * Where:
   *     o0, o1, n0 has key 'a' (many to one)
   *     o5, n4, n5, n6 has key 'b' (one to many)
   *     o2, n1 has key 'c' (one to one)
   *     n2, n3 has key 'd' (add)
   *     o3, o4 has key 'e' (remove)
   *     o6, o7, n7, n8 has key 'f' (many to many, treated as add and remove)
   * Then:
   *     (The order of the following directives are not ensured.)
   *     this._updateManyToOne(n0, [o0, o1]);
   *     this._updateOneToMany([n4, n5, n6], o5);
   *     this._update(n1, o2);
   *     this._remove(o3);
   *     this._remove(o4);
   *     this._remove(o6);
   *     this._remove(o7);
   *     this._add(n2);
   *     this._add(n3);
   *     this._add(n7);
   *     this._add(n8);
   */


  DataDiffer.prototype._executeMultiple = function () {
    var oldArr = this._old;
    var newArr = this._new;
    var oldDataIndexMap = {};
    var newDataIndexMap = {};
    var oldDataKeyArr = [];
    var newDataKeyArr = [];

    this._initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter');

    this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');

    for (var i = 0; i < oldDataKeyArr.length; i++) {
      var oldKey = oldDataKeyArr[i];
      var oldIdxMapVal = oldDataIndexMap[oldKey];
      var newIdxMapVal = newDataIndexMap[oldKey];
      var oldIdxMapValLen = dataIndexMapValueLength(oldIdxMapVal);
      var newIdxMapValLen = dataIndexMapValueLength(newIdxMapVal);

      if (oldIdxMapValLen > 1 && newIdxMapValLen === 1) {
        this._updateManyToOne && this._updateManyToOne(newIdxMapVal, oldIdxMapVal);
        newDataIndexMap[oldKey] = null;
      } else if (oldIdxMapValLen === 1 && newIdxMapValLen > 1) {
        this._updateOneToMany && this._updateOneToMany(newIdxMapVal, oldIdxMapVal);
        newDataIndexMap[oldKey] = null;
      } else if (oldIdxMapValLen === 1 && newIdxMapValLen === 1) {
        this._update && this._update(newIdxMapVal, oldIdxMapVal);
        newDataIndexMap[oldKey] = null;
      } else if (oldIdxMapValLen > 1 && newIdxMapValLen > 1) {
        this._updateManyToMany && this._updateManyToMany(newIdxMapVal, oldIdxMapVal);
        newDataIndexMap[oldKey] = null;
      } else if (oldIdxMapValLen > 1) {
        for (var i_1 = 0; i_1 < oldIdxMapValLen; i_1++) {
          this._remove && this._remove(oldIdxMapVal[i_1]);
        }
      } else {
        this._remove && this._remove(oldIdxMapVal);
      }
    }

    this._performRestAdd(newDataKeyArr, newDataIndexMap);
  };

  DataDiffer.prototype._performRestAdd = function (newDataKeyArr, newDataIndexMap) {
    for (var i = 0; i < newDataKeyArr.length; i++) {
      var newKey = newDataKeyArr[i];
      var newIdxMapVal = newDataIndexMap[newKey];
      var idxMapValLen = dataIndexMapValueLength(newIdxMapVal);

      if (idxMapValLen > 1) {
        for (var j = 0; j < idxMapValLen; j++) {
          this._add && this._add(newIdxMapVal[j]);
        }
      } else if (idxMapValLen === 1) {
        this._add && this._add(newIdxMapVal);
      } // Support both `newDataKeyArr` are duplication removed or not removed.


      newDataIndexMap[newKey] = null;
    }
  };

  DataDiffer.prototype._initIndexMap = function (arr, // Can be null.
  map, // In 'byKey', the output `keyArr` is duplication removed.
  // In 'byIndex', the output `keyArr` is not duplication removed and
  //     its indices are accurately corresponding to `arr`.
  keyArr, keyGetterName) {
    var cbModeMultiple = this._diffModeMultiple;

    for (var i = 0; i < arr.length; i++) {
      // Add prefix to avoid conflict with Object.prototype.
      var key = '_ec_' + this[keyGetterName](arr[i], i);

      if (!cbModeMultiple) {
        keyArr[i] = key;
      }

      if (!map) {
        continue;
      }

      var idxMapVal = map[key];
      var idxMapValLen = dataIndexMapValueLength(idxMapVal);

      if (idxMapValLen === 0) {
        // Simple optimize: in most cases, one index has one key,
        // do not need array.
        map[key] = i;

        if (cbModeMultiple) {
          keyArr.push(key);
        }
      } else if (idxMapValLen === 1) {
        map[key] = [idxMapVal, i];
      } else {
        idxMapVal.push(i);
      }
    }
  };

  return DataDiffer;
}();

/* harmony default export */ __webpack_exports__["a"] = (DataDiffer);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSourceInstance;
/* harmony export (immutable) */ __webpack_exports__["c"] = createSource;
/* harmony export (immutable) */ __webpack_exports__["b"] = createSourceFromSeriesDataOption;
/* harmony export (immutable) */ __webpack_exports__["d"] = cloneSourceShallow;
/* harmony export (immutable) */ __webpack_exports__["f"] = detectSourceFormat;
/* harmony export (immutable) */ __webpack_exports__["e"] = shouldRetrieveDataByName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_types_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_sourceHelper_js__ = __webpack_require__(98);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




; // @inner

var SourceImpl =
/** @class */
function () {
  function SourceImpl(fields) {
    this.data = fields.data || (fields.sourceFormat === __WEBPACK_IMPORTED_MODULE_1__util_types_js__["f" /* SOURCE_FORMAT_KEYED_COLUMNS */] ? {} : []);
    this.sourceFormat = fields.sourceFormat || __WEBPACK_IMPORTED_MODULE_1__util_types_js__["h" /* SOURCE_FORMAT_UNKNOWN */]; // Visit config

    this.seriesLayoutBy = fields.seriesLayoutBy || __WEBPACK_IMPORTED_MODULE_1__util_types_js__["c" /* SERIES_LAYOUT_BY_COLUMN */];
    this.startIndex = fields.startIndex || 0;
    this.dimensionsDetectedCount = fields.dimensionsDetectedCount;
    this.metaRawOption = fields.metaRawOption;
    var dimensionsDefine = this.dimensionsDefine = fields.dimensionsDefine;

    if (dimensionsDefine) {
      for (var i = 0; i < dimensionsDefine.length; i++) {
        var dim = dimensionsDefine[i];

        if (dim.type == null) {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_sourceHelper_js__["a" /* guessOrdinal */])(this, i) === __WEBPACK_IMPORTED_MODULE_3__helper_sourceHelper_js__["b" /* BE_ORDINAL */].Must) {
            dim.type = 'ordinal';
          }
        }
      }
    }
  }

  return SourceImpl;
}();

function isSourceInstance(val) {
  return val instanceof SourceImpl;
}
/**
 * Create a source from option.
 * NOTE: Created source is immutable. Don't change any properties in it.
 */

function createSource(sourceData, thisMetaRawOption, // can be null. If not provided, auto detect it from `sourceData`.
sourceFormat) {
  sourceFormat = sourceFormat || detectSourceFormat(sourceData);
  var seriesLayoutBy = thisMetaRawOption.seriesLayoutBy;
  var determined = determineSourceDimensions(sourceData, sourceFormat, seriesLayoutBy, thisMetaRawOption.sourceHeader, thisMetaRawOption.dimensions);
  var source = new SourceImpl({
    data: sourceData,
    sourceFormat: sourceFormat,
    seriesLayoutBy: seriesLayoutBy,
    dimensionsDefine: determined.dimensionsDefine,
    startIndex: determined.startIndex,
    dimensionsDetectedCount: determined.dimensionsDetectedCount,
    metaRawOption: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["clone"])(thisMetaRawOption)
  });
  return source;
}
/**
 * Wrap original series data for some compatibility cases.
 */

function createSourceFromSeriesDataOption(data) {
  return new SourceImpl({
    data: data,
    sourceFormat: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isTypedArray"])(data) ? __WEBPACK_IMPORTED_MODULE_1__util_types_js__["a" /* SOURCE_FORMAT_TYPED_ARRAY */] : __WEBPACK_IMPORTED_MODULE_1__util_types_js__["g" /* SOURCE_FORMAT_ORIGINAL */]
  });
}
/**
 * Clone source but excludes source data.
 */

function cloneSourceShallow(source) {
  return new SourceImpl({
    data: source.data,
    sourceFormat: source.sourceFormat,
    seriesLayoutBy: source.seriesLayoutBy,
    dimensionsDefine: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["clone"])(source.dimensionsDefine),
    startIndex: source.startIndex,
    dimensionsDetectedCount: source.dimensionsDetectedCount
  });
}
/**
 * Note: An empty array will be detected as `SOURCE_FORMAT_ARRAY_ROWS`.
 */

function detectSourceFormat(data) {
  var sourceFormat = __WEBPACK_IMPORTED_MODULE_1__util_types_js__["h" /* SOURCE_FORMAT_UNKNOWN */];

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isTypedArray"])(data)) {
    sourceFormat = __WEBPACK_IMPORTED_MODULE_1__util_types_js__["a" /* SOURCE_FORMAT_TYPED_ARRAY */];
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"])(data)) {
    // FIXME Whether tolerate null in top level array?
    if (data.length === 0) {
      sourceFormat = __WEBPACK_IMPORTED_MODULE_1__util_types_js__["b" /* SOURCE_FORMAT_ARRAY_ROWS */];
    }

    for (var i = 0, len = data.length; i < len; i++) {
      var item = data[i];

      if (item == null) {
        continue;
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"])(item)) {
        sourceFormat = __WEBPACK_IMPORTED_MODULE_1__util_types_js__["b" /* SOURCE_FORMAT_ARRAY_ROWS */];
        break;
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"])(item)) {
        sourceFormat = __WEBPACK_IMPORTED_MODULE_1__util_types_js__["e" /* SOURCE_FORMAT_OBJECT_ROWS */];
        break;
      }
    }
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"])(data)) {
    for (var key in data) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(data, key) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArrayLike"])(data[key])) {
        sourceFormat = __WEBPACK_IMPORTED_MODULE_1__util_types_js__["f" /* SOURCE_FORMAT_KEYED_COLUMNS */];
        break;
      }
    }
  }

  return sourceFormat;
}
/**
 * Determine the source definitions from data standalone dimensions definitions
 * are not specified.
 */

function determineSourceDimensions(data, sourceFormat, seriesLayoutBy, sourceHeader, // standalone raw dimensions definition, like:
// {
//     dimensions: ['aa', 'bb', { name: 'cc', type: 'time' }]
// }
// in `dataset` or `series`
dimensionsDefine) {
  var dimensionsDetectedCount;
  var startIndex; // PEDING: could data be null/undefined here?
  // currently, if `dataset.source` not specified, error thrown.
  // if `series.data` not specified, nothing rendered without error thrown.
  // Should test these cases.

  if (!data) {
    return {
      dimensionsDefine: normalizeDimensionsOption(dimensionsDefine),
      startIndex: startIndex,
      dimensionsDetectedCount: dimensionsDetectedCount
    };
  }

  if (sourceFormat === __WEBPACK_IMPORTED_MODULE_1__util_types_js__["b" /* SOURCE_FORMAT_ARRAY_ROWS */]) {
    var dataArrayRows = data; // Rule: Most of the first line are string: it is header.
    // Caution: consider a line with 5 string and 1 number,
    // it still can not be sure it is a head, because the
    // 5 string may be 5 values of category columns.

    if (sourceHeader === 'auto' || sourceHeader == null) {
      arrayRowsTravelFirst(function (val) {
        // '-' is regarded as null/undefined.
        if (val != null && val !== '-') {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"])(val)) {
            startIndex == null && (startIndex = 1);
          } else {
            startIndex = 0;
          }
        } // 10 is an experience number, avoid long loop.

      }, seriesLayoutBy, dataArrayRows, 10);
    } else {
      startIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isNumber"])(sourceHeader) ? sourceHeader : sourceHeader ? 1 : 0;
    }

    if (!dimensionsDefine && startIndex === 1) {
      dimensionsDefine = [];
      arrayRowsTravelFirst(function (val, index) {
        dimensionsDefine[index] = val != null ? val + '' : '';
      }, seriesLayoutBy, dataArrayRows, Infinity);
    }

    dimensionsDetectedCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === __WEBPACK_IMPORTED_MODULE_1__util_types_js__["d" /* SERIES_LAYOUT_BY_ROW */] ? dataArrayRows.length : dataArrayRows[0] ? dataArrayRows[0].length : null;
  } else if (sourceFormat === __WEBPACK_IMPORTED_MODULE_1__util_types_js__["e" /* SOURCE_FORMAT_OBJECT_ROWS */]) {
    if (!dimensionsDefine) {
      dimensionsDefine = objectRowsCollectDimensions(data);
    }
  } else if (sourceFormat === __WEBPACK_IMPORTED_MODULE_1__util_types_js__["f" /* SOURCE_FORMAT_KEYED_COLUMNS */]) {
    if (!dimensionsDefine) {
      dimensionsDefine = [];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(data, function (colArr, key) {
        dimensionsDefine.push(key);
      });
    }
  } else if (sourceFormat === __WEBPACK_IMPORTED_MODULE_1__util_types_js__["g" /* SOURCE_FORMAT_ORIGINAL */]) {
    var value0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_model_js__["g" /* getDataItemValue */])(data[0]);
    dimensionsDetectedCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"])(value0) && value0.length || 1;
  } else if (sourceFormat === __WEBPACK_IMPORTED_MODULE_1__util_types_js__["a" /* SOURCE_FORMAT_TYPED_ARRAY */]) {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(!!dimensionsDefine, 'dimensions must be given if data is TypedArray.');
    }
  }

  return {
    startIndex: startIndex,
    dimensionsDefine: normalizeDimensionsOption(dimensionsDefine),
    dimensionsDetectedCount: dimensionsDetectedCount
  };
}

function objectRowsCollectDimensions(data) {
  var firstIndex = 0;
  var obj;

  while (firstIndex < data.length && !(obj = data[firstIndex++])) {} // jshint ignore: line


  if (obj) {
    var dimensions_1 = [];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(obj, function (value, key) {
      dimensions_1.push(key);
    });
    return dimensions_1;
  }
} // Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
// which is reasonable. But dimension name is duplicated.
// Returns undefined or an array contains only object without null/undefiend or string.


function normalizeDimensionsOption(dimensionsDefine) {
  if (!dimensionsDefine) {
    // The meaning of null/undefined is different from empty array.
    return;
  }

  var nameMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])(dimensionsDefine, function (rawItem, index) {
    rawItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"])(rawItem) ? rawItem : {
      name: rawItem
    }; // Other fields will be discarded.

    var item = {
      name: rawItem.name,
      displayName: rawItem.displayName,
      type: rawItem.type
    }; // User can set null in dimensions.
    // We dont auto specify name, othewise a given name may
    // cause it be refered unexpectedly.

    if (item.name == null) {
      return item;
    } // Also consider number form like 2012.


    item.name += ''; // User may also specify displayName.
    // displayName will always exists except user not
    // specified or dim name is not specified or detected.
    // (A auto generated dim name will not be used as
    // displayName).

    if (item.displayName == null) {
      item.displayName = item.name;
    }

    var exist = nameMap.get(item.name);

    if (!exist) {
      nameMap.set(item.name, {
        count: 1
      });
    } else {
      item.name += '-' + exist.count++;
    }

    return item;
  });
}

function arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
  if (seriesLayoutBy === __WEBPACK_IMPORTED_MODULE_1__util_types_js__["d" /* SERIES_LAYOUT_BY_ROW */]) {
    for (var i = 0; i < data.length && i < maxLoop; i++) {
      cb(data[i] ? data[i][0] : null, i);
    }
  } else {
    var value0 = data[0] || [];

    for (var i = 0; i < value0.length && i < maxLoop; i++) {
      cb(value0[i], i);
    }
  }
}

function shouldRetrieveDataByName(source) {
  var sourceFormat = source.sourceFormat;
  return sourceFormat === __WEBPACK_IMPORTED_MODULE_1__util_types_js__["e" /* SOURCE_FORMAT_OBJECT_ROWS */] || sourceFormat === __WEBPACK_IMPORTED_MODULE_1__util_types_js__["f" /* SOURCE_FORMAT_KEYED_COLUMNS */];
}

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1664)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(671),
  /* template */
  __webpack_require__(1594),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-88141bec",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/user/LeftBar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LeftBar.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-88141bec", Component.options)
  } else {
    hotAPI.reload("data-v-88141bec", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRANSFORMABLE_PROPS; });
/* harmony export (immutable) */ __webpack_exports__["c"] = copyTransform;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__matrix_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vector_js__ = __webpack_require__(23);


var mIdentity = __WEBPACK_IMPORTED_MODULE_0__matrix_js__["identity"];
var EPSILON = 5e-5;
function isNotAroundZero(val) {
    return val > EPSILON || val < -EPSILON;
}
var scaleTmp = [];
var tmpTransform = [];
var originTransform = __WEBPACK_IMPORTED_MODULE_0__matrix_js__["create"]();
var abs = Math.abs;
var Transformable = (function () {
    function Transformable() {
    }
    Transformable.prototype.getLocalTransform = function (m) {
        return Transformable.getLocalTransform(this, m);
    };
    Transformable.prototype.setPosition = function (arr) {
        this.x = arr[0];
        this.y = arr[1];
    };
    Transformable.prototype.setScale = function (arr) {
        this.scaleX = arr[0];
        this.scaleY = arr[1];
    };
    Transformable.prototype.setSkew = function (arr) {
        this.skewX = arr[0];
        this.skewY = arr[1];
    };
    Transformable.prototype.setOrigin = function (arr) {
        this.originX = arr[0];
        this.originY = arr[1];
    };
    Transformable.prototype.needLocalTransform = function () {
        return isNotAroundZero(this.rotation)
            || isNotAroundZero(this.x)
            || isNotAroundZero(this.y)
            || isNotAroundZero(this.scaleX - 1)
            || isNotAroundZero(this.scaleY - 1)
            || isNotAroundZero(this.skewX)
            || isNotAroundZero(this.skewY);
    };
    Transformable.prototype.updateTransform = function () {
        var parentTransform = this.parent && this.parent.transform;
        var needLocalTransform = this.needLocalTransform();
        var m = this.transform;
        if (!(needLocalTransform || parentTransform)) {
            m && mIdentity(m);
            return;
        }
        m = m || __WEBPACK_IMPORTED_MODULE_0__matrix_js__["create"]();
        if (needLocalTransform) {
            this.getLocalTransform(m);
        }
        else {
            mIdentity(m);
        }
        if (parentTransform) {
            if (needLocalTransform) {
                __WEBPACK_IMPORTED_MODULE_0__matrix_js__["mul"](m, parentTransform, m);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_0__matrix_js__["copy"](m, parentTransform);
            }
        }
        this.transform = m;
        this._resolveGlobalScaleRatio(m);
    };
    Transformable.prototype._resolveGlobalScaleRatio = function (m) {
        var globalScaleRatio = this.globalScaleRatio;
        if (globalScaleRatio != null && globalScaleRatio !== 1) {
            this.getGlobalScale(scaleTmp);
            var relX = scaleTmp[0] < 0 ? -1 : 1;
            var relY = scaleTmp[1] < 0 ? -1 : 1;
            var sx = ((scaleTmp[0] - relX) * globalScaleRatio + relX) / scaleTmp[0] || 0;
            var sy = ((scaleTmp[1] - relY) * globalScaleRatio + relY) / scaleTmp[1] || 0;
            m[0] *= sx;
            m[1] *= sx;
            m[2] *= sy;
            m[3] *= sy;
        }
        this.invTransform = this.invTransform || __WEBPACK_IMPORTED_MODULE_0__matrix_js__["create"]();
        __WEBPACK_IMPORTED_MODULE_0__matrix_js__["invert"](this.invTransform, m);
    };
    Transformable.prototype.getComputedTransform = function () {
        var transformNode = this;
        var ancestors = [];
        while (transformNode) {
            ancestors.push(transformNode);
            transformNode = transformNode.parent;
        }
        while (transformNode = ancestors.pop()) {
            transformNode.updateTransform();
        }
        return this.transform;
    };
    Transformable.prototype.setLocalTransform = function (m) {
        if (!m) {
            return;
        }
        var sx = m[0] * m[0] + m[1] * m[1];
        var sy = m[2] * m[2] + m[3] * m[3];
        var rotation = Math.atan2(m[1], m[0]);
        var shearX = Math.PI / 2 + rotation - Math.atan2(m[3], m[2]);
        sy = Math.sqrt(sy) * Math.cos(shearX);
        sx = Math.sqrt(sx);
        this.skewX = shearX;
        this.skewY = 0;
        this.rotation = -rotation;
        this.x = +m[4];
        this.y = +m[5];
        this.scaleX = sx;
        this.scaleY = sy;
        this.originX = 0;
        this.originY = 0;
    };
    Transformable.prototype.decomposeTransform = function () {
        if (!this.transform) {
            return;
        }
        var parent = this.parent;
        var m = this.transform;
        if (parent && parent.transform) {
            __WEBPACK_IMPORTED_MODULE_0__matrix_js__["mul"](tmpTransform, parent.invTransform, m);
            m = tmpTransform;
        }
        var ox = this.originX;
        var oy = this.originY;
        if (ox || oy) {
            originTransform[4] = ox;
            originTransform[5] = oy;
            __WEBPACK_IMPORTED_MODULE_0__matrix_js__["mul"](tmpTransform, m, originTransform);
            tmpTransform[4] -= ox;
            tmpTransform[5] -= oy;
            m = tmpTransform;
        }
        this.setLocalTransform(m);
    };
    Transformable.prototype.getGlobalScale = function (out) {
        var m = this.transform;
        out = out || [];
        if (!m) {
            out[0] = 1;
            out[1] = 1;
            return out;
        }
        out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
        out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
        if (m[0] < 0) {
            out[0] = -out[0];
        }
        if (m[3] < 0) {
            out[1] = -out[1];
        }
        return out;
    };
    Transformable.prototype.transformCoordToLocal = function (x, y) {
        var v2 = [x, y];
        var invTransform = this.invTransform;
        if (invTransform) {
            __WEBPACK_IMPORTED_MODULE_1__vector_js__["applyTransform"](v2, v2, invTransform);
        }
        return v2;
    };
    Transformable.prototype.transformCoordToGlobal = function (x, y) {
        var v2 = [x, y];
        var transform = this.transform;
        if (transform) {
            __WEBPACK_IMPORTED_MODULE_1__vector_js__["applyTransform"](v2, v2, transform);
        }
        return v2;
    };
    Transformable.prototype.getLineScale = function () {
        var m = this.transform;
        return m && abs(m[0] - 1) > 1e-10 && abs(m[3] - 1) > 1e-10
            ? Math.sqrt(abs(m[0] * m[3] - m[2] * m[1]))
            : 1;
    };
    Transformable.prototype.copyTransform = function (source) {
        copyTransform(this, source);
    };
    Transformable.getLocalTransform = function (target, m) {
        m = m || [];
        var ox = target.originX || 0;
        var oy = target.originY || 0;
        var sx = target.scaleX;
        var sy = target.scaleY;
        var ax = target.anchorX;
        var ay = target.anchorY;
        var rotation = target.rotation || 0;
        var x = target.x;
        var y = target.y;
        var skewX = target.skewX ? Math.tan(target.skewX) : 0;
        var skewY = target.skewY ? Math.tan(-target.skewY) : 0;
        if (ox || oy || ax || ay) {
            var dx = ox + ax;
            var dy = oy + ay;
            m[4] = -dx * sx - skewX * dy * sy;
            m[5] = -dy * sy - skewY * dx * sx;
        }
        else {
            m[4] = m[5] = 0;
        }
        m[0] = sx;
        m[3] = sy;
        m[1] = skewY * sx;
        m[2] = skewX * sy;
        rotation && __WEBPACK_IMPORTED_MODULE_0__matrix_js__["rotate"](m, m, rotation);
        m[4] += ox + x;
        m[5] += oy + y;
        return m;
    };
    Transformable.initDefaultProps = (function () {
        var proto = Transformable.prototype;
        proto.scaleX =
            proto.scaleY =
                proto.globalScaleRatio = 1;
        proto.x =
            proto.y =
                proto.originX =
                    proto.originY =
                        proto.skewX =
                            proto.skewY =
                                proto.rotation =
                                    proto.anchorX =
                                        proto.anchorY = 0;
    })();
    return Transformable;
}());
;
var TRANSFORMABLE_PROPS = [
    'x', 'y', 'originX', 'originY', 'anchorX', 'anchorY', 'rotation', 'scaleX', 'scaleY', 'skewX', 'skewY'
];
function copyTransform(target, source) {
    for (var i = 0; i < TRANSFORMABLE_PROPS.length; i++) {
        var propName = TRANSFORMABLE_PROPS[i];
        target[propName] = source[propName];
    }
}
/* harmony default export */ __webpack_exports__["a"] = (Transformable);


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(20);



/* harmony default export */ __webpack_exports__["a"] = ({
  listOrganization: function listOrganization() {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (window.vm.$store.state.login.userInfo.roleCodes.some(function (r) {
        return r == '140' || r == '159';
      })) {
        __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/external/externalOrganization/list', { pageSize: 999999, pageNo: 1 }).then(function (res) {
          res = res.records.sort(function (a, b) {
            return a.type > b.type ? 1 : -1;
          });
          var temp = {};
          var tempFranchiseObjects = {};
          res.forEach(function (r) {
            if (r.type == '1') {
              temp[r.id] = {
                id: r.id,
                name: r.organizId,
                franchise: []
              };
            } else if (r.type == '2' && temp[r.parentId]) {
              var medical = {
                id: r.organizId,
                medicalFieldName: r.organizId,
                teams: []
              };
              temp[r.parentId].franchise.push(medical);
              tempFranchiseObjects[r.id] = medical;
            } else if (r.type == '3' && tempFranchiseObjects[r.parentId]) {
              var team = {
                id: r.organizId,
                teamName: r.organizId
              };

              tempFranchiseObjects[r.parentId].teams.push(team);
            }
          });

          var resultTemp = {};
          for (var key in temp) {
            resultTemp[temp[key].name] = temp[key].franchise.sort(function (a, b) {
              return a.id > b.id ? 1 : -1;
            });
          }

          resultTemp[''] = _this.listMedicalField();

          resolve([resultTemp]);
        });
      } else {
        var resultTemp = {};
        window.vm.$store.state.login.userInfo.loginDeparts.forEach(function (d) {
          resultTemp[d.id] = _this.listMedicalField();

          resultTemp[d.id].forEach(function (m) {
            m.teams = _this.listTeams();
          });
        });
        resultTemp[''] = _this.listMedicalField();
        resolve([resultTemp]);
      }
    });
  },
  listMedicalField: function listMedicalField() {
    return window.vm.$store.state.login.userInfo.loginMedicalFields;
  },
  listTeams: function listTeams() {
    return window.vm.$store.state.login.userInfo.loginTeams;
  },
  listProduct: function listProduct() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/external/externalProduct/list', { pageSize: 999999, pageNo: 1 });
  },
  listDepart: function listDepart() {
    return window.vm.$store.state.login.userInfo.loginDeparts;
  },
  listTreatmentArea: function listTreatmentArea() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/external/externalAreaRelation/list', { pageSize: 999999, pageNo: 1 }).then(function (res) {
        var treatmentArray = [];
        res.records.forEach(function (r) {
          if (r.meetingProp == '1' && !treatmentArray.some(function (t) {
            return t.id == r.areaDbId;
          })) {
            treatmentArray.push({
              id: r.areaDbId,
              treatmentAreaName: r.areaName
            });
          }
        });
        resolve(treatmentArray);
      });
    });
  },
  listDiseaseArea: function listDiseaseArea() {

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/external/externalAreaRelation/list', { pageSize: 999999, pageNo: 1 }).then(function (res) {
        var treatmentArray = [];
        res.records.forEach(function (r) {
          if (r.meetingProp !== '1' && !treatmentArray.some(function (t) {
            return t.id == r.areaDbId;
          })) {
            treatmentArray.push({
              id: r.areaDbId,
              diseaseAreaName: r.areaName
            });
          }
        });
        resolve(treatmentArray);
      });
    });
  },
  listCountry: function listCountry() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/external/externalCountry/list', { pageSize: 999999, pageNo: 1 });
  },
  listProvince: function listProvince(params) {
    if (!params) {
      params = {};
    }
    params.pageSize = 999999;
    params.pageNo = 1;
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/external/externalProvince/list', params);
  },
  listCity: function listCity(params) {
    params.pageSize = 999999;
    params.pageNo = 1;
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/external/externalCity/list', params);
  },
  listHospitalLevel: function listHospitalLevel(params) {
    if (!params) {
      params = {};
    }
    params.pageSize = 999999;
    params.pageNo = 1;
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/bus/busHospitalLevel/list', params);
  },
  listSpeakerLevel: function listSpeakerLevel(params) {
    if (!params) {
      params = {};
    }
    params.pageSize = 999999;
    params.pageNo = 1;
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/bus/busSpeakerLevel/list', params);
  },
  listYear: function listYear() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/dict/getYearList', {});
  },
  listQuarter: function listQuarter() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/dict/getDictItemsByCode/quarter', {});
  },
  listCostCenter: function listCostCenter() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/external/externalCostCenter/list', { costType: '1' });
  },
  listWbsCode: function listWbsCode() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/external/externalCostCenter/list', { costType: '2' });
  },
  listMyApplicationStatus: function listMyApplicationStatus() {
    return [{ value: '1', text: '待提交' }, { value: '2', text: '审批中' }, { value: '4', text: '审批通过' }, { value: '5', text: '审批拒绝' }, { value: '7', text: '已取消' }];
  },
  listMyLibraryStatus: function listMyLibraryStatus() {
    return [{ value: '3', text: '审批中' }, { value: '4', text: '审批通过' }, { value: '5', text: '审批拒绝' }, { value: '7', text: '已取消' }];
  },
  listMyTaskStatus: function listMyTaskStatus() {
    return [{ value: '3', text: '待审批' }, { value: '4', text: '审批通过' }, { value: '5', text: '审批拒绝' }, { value: '7', text: '已取消' }];
  },
  listMeetingStatus: function listMeetingStatus() {
    return [{ value: '1', text: '待提交' }, { value: '2', text: '审批中' }, { value: '3', text: '待审批' }, { value: '4', text: '审批通过' }, { value: '5', text: '审批拒绝' }, { value: '7', text: '已取消' }];
  },
  listMeetingTaskStatus: function listMeetingTaskStatus() {
    return [{ value: '3', text: '待审批' }, { value: '4', text: '审批通过' }, { value: '5', text: '审批拒绝' }, { value: '7', text: '已取消' }];
  },
  listQueueTaskStatus: function listQueueTaskStatus() {
    return [{ value: '0', text: '排队中' }, { value: '1', text: '已完成' }, { value: '2', text: '已失败' }];
  },
  listCompanyStrategy: function listCompanyStrategy() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/dict/getDictItemsByCode/company_strategy', {});
  },
  listCompanyCode: function listCompanyCode() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/dict/getDictItemsByCode/company_code', {});
  },
  listMeetingProp: function listMeetingProp() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/dict/getDictItemsByCode/meeting_prop', {});
  },
  listMeetingModality: function listMeetingModality() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/dict/getDictItemsByCode/meeting_modality', {});
  },
  listMeetingType: function listMeetingType() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/dict/getDictItemsByCode/meeting_type', {});
  },
  listRole: function listRole() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/role/queryall', {});
  },
  listDomainResult: function listDomainResult(params) {
    if (!params) {
      params = {};
    }
    params.pageSize = 999999;
    params.pageNo = 1;
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/bus/busTreatResult/list', params);
  },
  listMeetingSystem: function listMeetingSystem() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/dict/getDictItemsByCode/meeting_system', {});
  },
  listAoneExeStatus: function listAoneExeStatus() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/dict/getDictItemsByCode/aone_exe_status', {});
  },
  listStrategy: function listStrategy(params) {
    if (!params) {
      params = {};
    }
    params.pageSize = 999999;
    params.pageNo = 1;
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/bus/busStrategy/list', params);
  },
  listOffice: function listOffice(params) {
    if (!params) {
      params = {};
    }
    params.pageSize = 999999;
    params.pageNo = 1;
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/bus/busOffice/list', params);
  },
  listMeetingTimeInt: function listMeetingTimeInt() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/dict/getDictItemsByCode/meeting_time_int', {});
  },
  listSysErrorTip: function listSysErrorTip() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/dict/getDictItemsByCode/sys_error_tip', {});
  },
  listSysTip: function listSysTip() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/dict/getDictItemsByCode/sys_tip', {});
  },
  listMeetingGsdType: function listMeetingGsdType() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/dict/getDictItemsByCode/meeting_gsd_type', {});
  },
  listMeetingGsdTypeSub1: function listMeetingGsdTypeSub1() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/dict/getDictItemsByCode/meeting_gsd_type_sub_1', {});
  },
  listMeetingGsdTypeSub2: function listMeetingGsdTypeSub2() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/dict/getDictItemsByCode/meeting_gsd_type_sub_2', {});
  },
  listMeetingGsdTypeSub3: function listMeetingGsdTypeSub3() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/dict/getDictItemsByCode/meeting_gsd_type_sub_3', {});
  }
});

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(74);
var call = __webpack_require__(416);
var isArrayIter = __webpack_require__(293);
var anObject = __webpack_require__(9);
var toLength = __webpack_require__(29);
var getIterFn = __webpack_require__(309);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(9);
var dPs = __webpack_require__(422);
var enumBugKeys = __webpack_require__(289);
var IE_PROTO = __webpack_require__(302)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(288)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(291).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(424);
var hiddenKeys = __webpack_require__(289).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(424);
var enumBugKeys = __webpack_require__(289);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(55);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(13);
var dP = __webpack_require__(33);
var DESCRIPTORS = __webpack_require__(31);
var SPECIES = __webpack_require__(25)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(76);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 130 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axisPointer_modelHelper_js__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_Component_js__ = __webpack_require__(30);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var axisPointerClazz = {};
/**
 * Base class of AxisView.
 */

var AxisView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(AxisView, _super);

  function AxisView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = AxisView.type;
    return _this;
  }
  /**
   * @override
   */


  AxisView.prototype.render = function (axisModel, ecModel, api, payload) {
    // FIXME
    // This process should proformed after coordinate systems updated
    // (axis scale updated), and should be performed each time update.
    // So put it here temporarily, although it is not appropriate to
    // put a model-writing procedure in `view`.
    this.axisPointerClass && __WEBPACK_IMPORTED_MODULE_1__axisPointer_modelHelper_js__["d" /* fixValue */](axisModel);

    _super.prototype.render.apply(this, arguments);

    this._doUpdateAxisPointerClass(axisModel, api, true);
  };
  /**
   * Action handler.
   */


  AxisView.prototype.updateAxisPointer = function (axisModel, ecModel, api, payload) {
    this._doUpdateAxisPointerClass(axisModel, api, false);
  };
  /**
   * @override
   */


  AxisView.prototype.remove = function (ecModel, api) {
    var axisPointer = this._axisPointer;
    axisPointer && axisPointer.remove(api);
  };
  /**
   * @override
   */


  AxisView.prototype.dispose = function (ecModel, api) {
    this._disposeAxisPointer(api);

    _super.prototype.dispose.apply(this, arguments);
  };

  AxisView.prototype._doUpdateAxisPointerClass = function (axisModel, api, forceRender) {
    var Clazz = AxisView.getAxisPointerClass(this.axisPointerClass);

    if (!Clazz) {
      return;
    }

    var axisPointerModel = __WEBPACK_IMPORTED_MODULE_1__axisPointer_modelHelper_js__["e" /* getAxisPointerModel */](axisModel);
    axisPointerModel ? (this._axisPointer || (this._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : this._disposeAxisPointer(api);
  };

  AxisView.prototype._disposeAxisPointer = function (api) {
    this._axisPointer && this._axisPointer.dispose(api);
    this._axisPointer = null;
  };

  AxisView.registerAxisPointerClass = function (type, clazz) {
    if (true) {
      if (axisPointerClazz[type]) {
        throw new Error('axisPointer ' + type + ' exists');
      }
    }

    axisPointerClazz[type] = clazz;
  };

  ;

  AxisView.getAxisPointerClass = function (type) {
    return type && axisPointerClazz[type];
  };

  ;
  AxisView.type = 'axis';
  return AxisView;
}(__WEBPACK_IMPORTED_MODULE_2__view_Component_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AxisView);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_env_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_mixin_dataFormat_js__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_Component_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tooltip_tooltipMarkup_js__ = __webpack_require__(48);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/








function fillLabel(opt) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_model_js__["e" /* defaultEmphasis */])(opt, 'label', ['show']);
} // { [componentType]: MarkerModel }


var inner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_model_js__["a" /* makeInner */])();

var MarkerModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(MarkerModel, _super);

  function MarkerModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = MarkerModel.type;
    /**
     * If marker model is created by self from series
     */

    _this.createdBySelf = false;
    return _this;
  }
  /**
   * @overrite
   */


  MarkerModel.prototype.init = function (option, parentModel, ecModel) {
    if (true) {
      if (this.type === 'marker') {
        throw new Error('Marker component is abstract component. Use markLine, markPoint, markArea instead.');
      }
    }

    this.mergeDefaultAndTheme(option, ecModel);

    this._mergeOption(option, ecModel, false, true);
  };

  MarkerModel.prototype.isAnimationEnabled = function () {
    if (__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_env_js__["a" /* default */].node) {
      return false;
    }

    var hostSeries = this.__hostSeries;
    return this.getShallow('animation') && hostSeries && hostSeries.isAnimationEnabled();
  };
  /**
   * @overrite
   */


  MarkerModel.prototype.mergeOption = function (newOpt, ecModel) {
    this._mergeOption(newOpt, ecModel, false, false);
  };

  MarkerModel.prototype._mergeOption = function (newOpt, ecModel, createdBySelf, isInit) {
    var componentType = this.mainType;

    if (!createdBySelf) {
      ecModel.eachSeries(function (seriesModel) {
        // mainType can be markPoint, markLine, markArea
        var markerOpt = seriesModel.get(this.mainType, true);
        var markerModel = inner(seriesModel)[componentType];

        if (!markerOpt || !markerOpt.data) {
          inner(seriesModel)[componentType] = null;
          return;
        }

        if (!markerModel) {
          if (isInit) {
            // Default label emphasis `position` and `show`
            fillLabel(markerOpt);
          }

          __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](markerOpt.data, function (item) {
            // FIXME Overwrite fillLabel method ?
            if (item instanceof Array) {
              fillLabel(item[0]);
              fillLabel(item[1]);
            } else {
              fillLabel(item);
            }
          });
          markerModel = this.createMarkerModelFromSeries(markerOpt, this, ecModel); // markerModel = new ImplementedMarkerModel(
          //     markerOpt, this, ecModel
          // );

          __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"](markerModel, {
            mainType: this.mainType,
            // Use the same series index and name
            seriesIndex: seriesModel.seriesIndex,
            name: seriesModel.name,
            createdBySelf: true
          });
          markerModel.__hostSeries = seriesModel;
        } else {
          markerModel._mergeOption(markerOpt, ecModel, true);
        }

        inner(seriesModel)[componentType] = markerModel;
      }, this);
    }
  };

  MarkerModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    var data = this.getData();
    var value = this.getRawValue(dataIndex);
    var itemName = data.getName(dataIndex);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tooltip_tooltipMarkup_js__["b" /* createTooltipMarkup */])('section', {
      header: this.name,
      blocks: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tooltip_tooltipMarkup_js__["b" /* createTooltipMarkup */])('nameValue', {
        name: itemName,
        value: value,
        noName: !itemName,
        noValue: value == null
      })]
    });
  };

  MarkerModel.prototype.getData = function () {
    return this._data;
  };

  MarkerModel.prototype.setData = function (data) {
    this._data = data;
  };

  MarkerModel.getMarkerModelFromSeries = function (seriesModel, // Support three types of markers. Strict check.
  componentType) {
    return inner(seriesModel)[componentType];
  };

  MarkerModel.type = 'marker';
  MarkerModel.dependencies = ['series', 'grid', 'polar', 'geo'];
  return MarkerModel;
}(__WEBPACK_IMPORTED_MODULE_4__model_Component_js__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["mixin"](MarkerModel, __WEBPACK_IMPORTED_MODULE_3__model_mixin_dataFormat_js__["a" /* DataFormatMixin */].prototype);
/* harmony default export */ __webpack_exports__["a"] = (MarkerModel);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = parseDataValue;
/* harmony export (immutable) */ __webpack_exports__["c"] = getRawValueParser;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SortOrderComparator; });
/* harmony export (immutable) */ __webpack_exports__["d"] = createFilterComparator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_log_js__ = __webpack_require__(14);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



/**
 * Convert raw the value in to inner value in List.
 *
 * [Performance sensitive]
 *
 * [Caution]: this is the key logic of user value parser.
 * For backward compatibiliy, do not modify it until have to!
 */

function parseDataValue(value, // For high performance, do not omit the second param.
opt) {
  // Performance sensitive.
  var dimType = opt && opt.type;

  if (dimType === 'ordinal') {
    // If given value is a category string
    return value;
  }

  if (dimType === 'time' // spead up when using timestamp
  && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isNumber"])(value) && value != null && value !== '-') {
    value = +__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["f" /* parseDate */])(value);
  } // dimType defaults 'number'.
  // If dimType is not ordinal and value is null or undefined or NaN or '-',
  // parse to NaN.
  // number-like string (like ' 123 ') can be converted to a number.
  // where null/undefined or other string will be converted to NaN.


  return value == null || value === '' ? NaN // If string (like '-'), using '+' parse to NaN
  // If object, also parse to NaN
  : +value;
}
;
var valueParserMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"])({
  'number': function (val) {
    // Do not use `numericToNumber` here. We have by defualt `numericToNumber`.
    // Here the number parser can have loose rule:
    // enable to cut suffix: "120px" => 120, "14%" => 14.
    return parseFloat(val);
  },
  'time': function (val) {
    // return timestamp.
    return +__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["f" /* parseDate */])(val);
  },
  'trim': function (val) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"])(val) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["trim"])(val) : val;
  }
});
function getRawValueParser(type) {
  return valueParserMap.get(type);
}
var ORDER_COMPARISON_OP_MAP = {
  lt: function (lval, rval) {
    return lval < rval;
  },
  lte: function (lval, rval) {
    return lval <= rval;
  },
  gt: function (lval, rval) {
    return lval > rval;
  },
  gte: function (lval, rval) {
    return lval >= rval;
  }
};

var FilterOrderComparator =
/** @class */
function () {
  function FilterOrderComparator(op, rval) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isNumber"])(rval)) {
      var errMsg = '';

      if (true) {
        errMsg = 'rvalue of "<", ">", "<=", ">=" can only be number in filter.';
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_log_js__["e" /* throwError */])(errMsg);
    }

    this._opFn = ORDER_COMPARISON_OP_MAP[op];
    this._rvalFloat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["g" /* numericToNumber */])(rval);
  } // Performance sensitive.


  FilterOrderComparator.prototype.evaluate = function (lval) {
    // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isNumber"])(lval) ? this._opFn(lval, this._rvalFloat) : this._opFn(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["g" /* numericToNumber */])(lval), this._rvalFloat);
  };

  return FilterOrderComparator;
}();

var SortOrderComparator =
/** @class */
function () {
  /**
   * @param order by defualt: 'asc'
   * @param incomparable by defualt: Always on the tail.
   *        That is, if 'asc' => 'max', if 'desc' => 'min'
   *        See the definition of "incomparable" in [SORT_COMPARISON_RULE]
   */
  function SortOrderComparator(order, incomparable) {
    var isDesc = order === 'desc';
    this._resultLT = isDesc ? 1 : -1;

    if (incomparable == null) {
      incomparable = isDesc ? 'min' : 'max';
    }

    this._incomparable = incomparable === 'min' ? -Infinity : Infinity;
  } // See [SORT_COMPARISON_RULE].
  // Performance sensitive.


  SortOrderComparator.prototype.evaluate = function (lval, rval) {
    // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
    var lvalFloat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isNumber"])(lval) ? lval : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["g" /* numericToNumber */])(lval);
    var rvalFloat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isNumber"])(rval) ? rval : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["g" /* numericToNumber */])(rval);
    var lvalNotNumeric = isNaN(lvalFloat);
    var rvalNotNumeric = isNaN(rvalFloat);

    if (lvalNotNumeric) {
      lvalFloat = this._incomparable;
    }

    if (rvalNotNumeric) {
      rvalFloat = this._incomparable;
    }

    if (lvalNotNumeric && rvalNotNumeric) {
      var lvalIsStr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"])(lval);
      var rvalIsStr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"])(rval);

      if (lvalIsStr) {
        lvalFloat = rvalIsStr ? lval : 0;
      }

      if (rvalIsStr) {
        rvalFloat = lvalIsStr ? rval : 0;
      }
    }

    return lvalFloat < rvalFloat ? this._resultLT : lvalFloat > rvalFloat ? -this._resultLT : 0;
  };

  return SortOrderComparator;
}();



var FilterEqualityComparator =
/** @class */
function () {
  function FilterEqualityComparator(isEq, rval) {
    this._rval = rval;
    this._isEQ = isEq;
    this._rvalTypeof = typeof rval;
    this._rvalFloat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["g" /* numericToNumber */])(rval);
  } // Performance sensitive.


  FilterEqualityComparator.prototype.evaluate = function (lval) {
    var eqResult = lval === this._rval;

    if (!eqResult) {
      var lvalTypeof = typeof lval;

      if (lvalTypeof !== this._rvalTypeof && (lvalTypeof === 'number' || this._rvalTypeof === 'number')) {
        eqResult = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["g" /* numericToNumber */])(lval) === this._rvalFloat;
      }
    }

    return this._isEQ ? eqResult : !eqResult;
  };

  return FilterEqualityComparator;
}();
/**
 * [FILTER_COMPARISON_RULE]
 * `lt`|`lte`|`gt`|`gte`:
 * + rval must be a number. And lval will be converted to number (`numericToNumber`) to compare.
 * `eq`:
 * + If same type, compare with `===`.
 * + If there is one number, convert to number (`numericToNumber`) to compare.
 * + Else return `false`.
 * `ne`:
 * + Not `eq`.
 *
 *
 * [SORT_COMPARISON_RULE]
 * All the values are grouped into three categories:
 * + "numeric" (number and numeric string)
 * + "non-numeric-string" (string that excluding numeric string)
 * + "others"
 * "numeric" vs "numeric": values are ordered by number order.
 * "non-numeric-string" vs "non-numeric-string": values are ordered by ES spec (#sec-abstract-relational-comparison).
 * "others" vs "others": do not change order (always return 0).
 * "numeric" vs "non-numeric-string": "non-numeric-string" is treated as "incomparable".
 * "number" vs "others": "others" is treated as "incomparable".
 * "non-numeric-string" vs "others": "others" is treated as "incomparable".
 * "incomparable" will be seen as -Infinity or Infinity (depends on the settings).
 * MEMO:
 *   non-numeric string sort make sence when need to put the items with the same tag together.
 *   But if we support string sort, we still need to avoid the misleading like `'2' > '12'`,
 *   So we treat "numeric-string" sorted by number order rather than string comparison.
 *
 *
 * [CHECK_LIST_OF_THE_RULE_DESIGN]
 * + Do not support string comparison until required. And also need to
 *   void the misleading of "2" > "12".
 * + Should avoid the misleading case:
 *   `" 22 " gte "22"` is `true` but `" 22 " eq "22"` is `false`.
 * + JS bad case should be avoided: null <= 0, [] <= 0, ' ' <= 0, ...
 * + Only "numeric" can be converted to comparable number, otherwise converted to NaN.
 *   See `util/number.ts#numericToNumber`.
 *
 * @return If `op` is not `RelationalOperator`, return null;
 */


function createFilterComparator(op, rval) {
  return op === 'eq' || op === 'ne' ? new FilterEqualityComparator(op === 'eq', rval) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["hasOwn"])(ORDER_COMPARISON_OP_MAP, op) ? new FilterOrderComparator(op, rval) : null;
}

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = isValueNice;
/* harmony export (immutable) */ __webpack_exports__["h"] = isIntervalOrLogScale;
/* harmony export (immutable) */ __webpack_exports__["e"] = intervalScaleNiceTicks;
/* harmony export (immutable) */ __webpack_exports__["f"] = increaseInterval;
/* harmony export (immutable) */ __webpack_exports__["d"] = getIntervalPrecision;
/* unused harmony export fixExtent */
/* harmony export (immutable) */ __webpack_exports__["a"] = contain;
/* harmony export (immutable) */ __webpack_exports__["b"] = normalize;
/* harmony export (immutable) */ __webpack_exports__["c"] = scale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_number_js__ = __webpack_require__(8);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

function isValueNice(val) {
  var exp10 = Math.pow(10, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["l" /* quantityExponent */])(Math.abs(val)));
  var f = Math.abs(val / exp10);
  return f === 0 || f === 1 || f === 2 || f === 3 || f === 5;
}
function isIntervalOrLogScale(scale) {
  return scale.type === 'interval' || scale.type === 'log';
}
/**
 * @param extent Both extent[0] and extent[1] should be valid number.
 *               Should be extent[0] < extent[1].
 * @param splitNumber splitNumber should be >= 1.
 */

function intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval) {
  var result = {};
  var span = extent[1] - extent[0];
  var interval = result.interval = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["m" /* nice */])(span / splitNumber, true);

  if (minInterval != null && interval < minInterval) {
    interval = result.interval = minInterval;
  }

  if (maxInterval != null && interval > maxInterval) {
    interval = result.interval = maxInterval;
  } // Tow more digital for tick.


  var precision = result.intervalPrecision = getIntervalPrecision(interval); // Niced extent inside original extent

  var niceTickExtent = result.niceTickExtent = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["d" /* round */])(Math.ceil(extent[0] / interval) * interval, precision), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["d" /* round */])(Math.floor(extent[1] / interval) * interval, precision)];
  fixExtent(niceTickExtent, extent);
  return result;
}
function increaseInterval(interval) {
  var exp10 = Math.pow(10, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["l" /* quantityExponent */])(interval)); // Increase interval

  var f = interval / exp10;

  if (!f) {
    f = 1;
  } else if (f === 2) {
    f = 3;
  } else if (f === 3) {
    f = 5;
  } else {
    // f is 1 or 5
    f *= 2;
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["d" /* round */])(f * exp10);
}
/**
 * @return interval precision
 */

function getIntervalPrecision(interval) {
  // Tow more digital for tick.
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["e" /* getPrecision */])(interval) + 2;
}

function clamp(niceTickExtent, idx, extent) {
  niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
} // In some cases (e.g., splitNumber is 1), niceTickExtent may be out of extent.


function fixExtent(niceTickExtent, extent) {
  !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
  !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
  clamp(niceTickExtent, 0, extent);
  clamp(niceTickExtent, 1, extent);

  if (niceTickExtent[0] > niceTickExtent[1]) {
    niceTickExtent[0] = niceTickExtent[1];
  }
}
function contain(val, extent) {
  return val >= extent[0] && val <= extent[1];
}
function normalize(val, extent) {
  if (extent[1] === extent[0]) {
    return 0.5;
  }

  return (val - extent[0]) / (extent[1] - extent[0]);
}
function scale(val, extent) {
  return val * (extent[1] - extent[0]) + extent[0];
}

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_tool_color_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_log_js__ = __webpack_require__(14);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var each = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"];
var isObject = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"];
var CATEGORY_DEFAULT_VISUAL_INDEX = -1;

var VisualMapping =
/** @class */
function () {
  function VisualMapping(option) {
    var mappingMethod = option.mappingMethod;
    var visualType = option.type;
    var thisOption = this.option = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["clone"](option);
    this.type = visualType;
    this.mappingMethod = mappingMethod;
    this._normalizeData = normalizers[mappingMethod];
    var visualHandler = VisualMapping.visualHandlers[visualType];
    this.applyVisual = visualHandler.applyVisual;
    this.getColorMapper = visualHandler.getColorMapper;
    this._normalizedToVisual = visualHandler._normalizedToVisual[mappingMethod];

    if (mappingMethod === 'piecewise') {
      normalizeVisualRange(thisOption);
      preprocessForPiecewise(thisOption);
    } else if (mappingMethod === 'category') {
      thisOption.categories ? preprocessForSpecifiedCategory(thisOption) // categories is ordinal when thisOption.categories not specified,
      // which need no more preprocess except normalize visual.
      : normalizeVisualRange(thisOption, true);
    } else {
      // mappingMethod === 'linear' or 'fixed'
      __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"](mappingMethod !== 'linear' || thisOption.dataExtent);
      normalizeVisualRange(thisOption);
    }
  }

  VisualMapping.prototype.mapValueToVisual = function (value) {
    var normalized = this._normalizeData(value);

    return this._normalizedToVisual(normalized, value);
  };

  VisualMapping.prototype.getNormalizer = function () {
    return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["bind"](this._normalizeData, this);
  };
  /**
   * List available visual types.
   *
   * @public
   * @return {Array.<string>}
   */


  VisualMapping.listVisualTypes = function () {
    return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["keys"](VisualMapping.visualHandlers);
  }; // /**
  //  * @public
  //  */
  // static addVisualHandler(name, handler) {
  //     visualHandlers[name] = handler;
  // }

  /**
   * @public
   */


  VisualMapping.isValidType = function (visualType) {
    return VisualMapping.visualHandlers.hasOwnProperty(visualType);
  };
  /**
   * Convinent method.
   * Visual can be Object or Array or primary type.
   */


  VisualMapping.eachVisual = function (visual, callback, context) {
    if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"](visual)) {
      __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](visual, callback, context);
    } else {
      callback.call(context, visual);
    }
  };

  VisualMapping.mapVisual = function (visual, callback, context) {
    var isPrimary;
    var newVisual = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](visual) ? [] : __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"](visual) ? {} : (isPrimary = true, null);
    VisualMapping.eachVisual(visual, function (v, key) {
      var newVal = callback.call(context, v, key);
      isPrimary ? newVisual = newVal : newVisual[key] = newVal;
    });
    return newVisual;
  };
  /**
   * Retrieve visual properties from given object.
   */


  VisualMapping.retrieveVisuals = function (obj) {
    var ret = {};
    var hasVisual;
    obj && each(VisualMapping.visualHandlers, function (h, visualType) {
      if (obj.hasOwnProperty(visualType)) {
        ret[visualType] = obj[visualType];
        hasVisual = true;
      }
    });
    return hasVisual ? ret : null;
  };
  /**
   * Give order to visual types, considering colorSaturation, colorAlpha depends on color.
   *
   * @public
   * @param {(Object|Array)} visualTypes If Object, like: {color: ..., colorSaturation: ...}
   *                                     IF Array, like: ['color', 'symbol', 'colorSaturation']
   * @return {Array.<string>} Sorted visual types.
   */


  VisualMapping.prepareVisualTypes = function (visualTypes) {
    if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](visualTypes)) {
      visualTypes = visualTypes.slice();
    } else if (isObject(visualTypes)) {
      var types_1 = [];
      each(visualTypes, function (item, type) {
        types_1.push(type);
      });
      visualTypes = types_1;
    } else {
      return [];
    }

    visualTypes.sort(function (type1, type2) {
      // color should be front of colorSaturation, colorAlpha, ...
      // symbol and symbolSize do not matter.
      return type2 === 'color' && type1 !== 'color' && type1.indexOf('color') === 0 ? 1 : -1;
    });
    return visualTypes;
  };
  /**
   * 'color', 'colorSaturation', 'colorAlpha', ... are depends on 'color'.
   * Other visuals are only depends on themself.
   */


  VisualMapping.dependsOn = function (visualType1, visualType2) {
    return visualType2 === 'color' ? !!(visualType1 && visualType1.indexOf(visualType2) === 0) : visualType1 === visualType2;
  };
  /**
   * @param value
   * @param pieceList [{value: ..., interval: [min, max]}, ...]
   *                         Always from small to big.
   * @param findClosestWhenOutside Default to be false
   * @return index
   */


  VisualMapping.findPieceIndex = function (value, pieceList, findClosestWhenOutside) {
    var possibleI;
    var abs = Infinity; // value has the higher priority.

    for (var i = 0, len = pieceList.length; i < len; i++) {
      var pieceValue = pieceList[i].value;

      if (pieceValue != null) {
        if (pieceValue === value // FIXME
        // It is supposed to compare value according to value type of dimension,
        // but currently value type can exactly be string or number.
        // Compromise for numeric-like string (like '12'), especially
        // in the case that visualMap.categories is ['22', '33'].
        || __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"](pieceValue) && pieceValue === value + '') {
          return i;
        }

        findClosestWhenOutside && updatePossible(pieceValue, i);
      }
    }

    for (var i = 0, len = pieceList.length; i < len; i++) {
      var piece = pieceList[i];
      var interval = piece.interval;
      var close_1 = piece.close;

      if (interval) {
        if (interval[0] === -Infinity) {
          if (littleThan(close_1[1], value, interval[1])) {
            return i;
          }
        } else if (interval[1] === Infinity) {
          if (littleThan(close_1[0], interval[0], value)) {
            return i;
          }
        } else if (littleThan(close_1[0], interval[0], value) && littleThan(close_1[1], value, interval[1])) {
          return i;
        }

        findClosestWhenOutside && updatePossible(interval[0], i);
        findClosestWhenOutside && updatePossible(interval[1], i);
      }
    }

    if (findClosestWhenOutside) {
      return value === Infinity ? pieceList.length - 1 : value === -Infinity ? 0 : possibleI;
    }

    function updatePossible(val, index) {
      var newAbs = Math.abs(val - value);

      if (newAbs < abs) {
        abs = newAbs;
        possibleI = index;
      }
    }
  };

  VisualMapping.visualHandlers = {
    color: {
      applyVisual: makeApplyVisual('color'),
      getColorMapper: function () {
        var thisOption = this.option;
        return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["bind"](thisOption.mappingMethod === 'category' ? function (value, isNormalized) {
          !isNormalized && (value = this._normalizeData(value));
          return doMapCategory.call(this, value);
        } : function (value, isNormalized, out) {
          // If output rgb array
          // which will be much faster and useful in pixel manipulation
          var returnRGBArray = !!out;
          !isNormalized && (value = this._normalizeData(value));
          out = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_tool_color_js__["fastLerp"](value, thisOption.parsedVisual, out);
          return returnRGBArray ? out : __WEBPACK_IMPORTED_MODULE_1_zrender_lib_tool_color_js__["stringify"](out, 'rgba');
        }, this);
      },
      _normalizedToVisual: {
        linear: function (normalized) {
          return __WEBPACK_IMPORTED_MODULE_1_zrender_lib_tool_color_js__["stringify"](__WEBPACK_IMPORTED_MODULE_1_zrender_lib_tool_color_js__["fastLerp"](normalized, this.option.parsedVisual), 'rgba');
        },
        category: doMapCategory,
        piecewise: function (normalized, value) {
          var result = getSpecifiedVisual.call(this, value);

          if (result == null) {
            result = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_tool_color_js__["stringify"](__WEBPACK_IMPORTED_MODULE_1_zrender_lib_tool_color_js__["fastLerp"](normalized, this.option.parsedVisual), 'rgba');
          }

          return result;
        },
        fixed: doMapFixed
      }
    },
    colorHue: makePartialColorVisualHandler(function (color, value) {
      return __WEBPACK_IMPORTED_MODULE_1_zrender_lib_tool_color_js__["modifyHSL"](color, value);
    }),
    colorSaturation: makePartialColorVisualHandler(function (color, value) {
      return __WEBPACK_IMPORTED_MODULE_1_zrender_lib_tool_color_js__["modifyHSL"](color, null, value);
    }),
    colorLightness: makePartialColorVisualHandler(function (color, value) {
      return __WEBPACK_IMPORTED_MODULE_1_zrender_lib_tool_color_js__["modifyHSL"](color, null, null, value);
    }),
    colorAlpha: makePartialColorVisualHandler(function (color, value) {
      return __WEBPACK_IMPORTED_MODULE_1_zrender_lib_tool_color_js__["modifyAlpha"](color, value);
    }),
    decal: {
      applyVisual: makeApplyVisual('decal'),
      _normalizedToVisual: {
        linear: null,
        category: doMapCategory,
        piecewise: null,
        fixed: null
      }
    },
    opacity: {
      applyVisual: makeApplyVisual('opacity'),
      _normalizedToVisual: createNormalizedToNumericVisual([0, 1])
    },
    liftZ: {
      applyVisual: makeApplyVisual('liftZ'),
      _normalizedToVisual: {
        linear: doMapFixed,
        category: doMapFixed,
        piecewise: doMapFixed,
        fixed: doMapFixed
      }
    },
    symbol: {
      applyVisual: function (value, getter, setter) {
        var symbolCfg = this.mapValueToVisual(value);
        setter('symbol', symbolCfg);
      },
      _normalizedToVisual: {
        linear: doMapToArray,
        category: doMapCategory,
        piecewise: function (normalized, value) {
          var result = getSpecifiedVisual.call(this, value);

          if (result == null) {
            result = doMapToArray.call(this, normalized);
          }

          return result;
        },
        fixed: doMapFixed
      }
    },
    symbolSize: {
      applyVisual: makeApplyVisual('symbolSize'),
      _normalizedToVisual: createNormalizedToNumericVisual([0, 1])
    }
  };
  return VisualMapping;
}();

function preprocessForPiecewise(thisOption) {
  var pieceList = thisOption.pieceList;
  thisOption.hasSpecialVisual = false;
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](pieceList, function (piece, index) {
    piece.originIndex = index; // piece.visual is "result visual value" but not
    // a visual range, so it does not need to be normalized.

    if (piece.visual != null) {
      thisOption.hasSpecialVisual = true;
    }
  });
}

function preprocessForSpecifiedCategory(thisOption) {
  // Hash categories.
  var categories = thisOption.categories;
  var categoryMap = thisOption.categoryMap = {};
  var visual = thisOption.visual;
  each(categories, function (cate, index) {
    categoryMap[cate] = index;
  }); // Process visual map input.

  if (!__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](visual)) {
    var visualArr_1 = [];

    if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"](visual)) {
      each(visual, function (v, cate) {
        var index = categoryMap[cate];
        visualArr_1[index != null ? index : CATEGORY_DEFAULT_VISUAL_INDEX] = v;
      });
    } else {
      // Is primary type, represents default visual.
      visualArr_1[CATEGORY_DEFAULT_VISUAL_INDEX] = visual;
    }

    visual = setVisualToOption(thisOption, visualArr_1);
  } // Remove categories that has no visual,
  // then we can mapping them to CATEGORY_DEFAULT_VISUAL_INDEX.


  for (var i = categories.length - 1; i >= 0; i--) {
    if (visual[i] == null) {
      delete categoryMap[categories[i]];
      categories.pop();
    }
  }
}

function normalizeVisualRange(thisOption, isCategory) {
  var visual = thisOption.visual;
  var visualArr = [];

  if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"](visual)) {
    each(visual, function (v) {
      visualArr.push(v);
    });
  } else if (visual != null) {
    visualArr.push(visual);
  }

  var doNotNeedPair = {
    color: 1,
    symbol: 1
  };

  if (!isCategory && visualArr.length === 1 && !doNotNeedPair.hasOwnProperty(thisOption.type)) {
    // Do not care visualArr.length === 0, which is illegal.
    visualArr[1] = visualArr[0];
  }

  setVisualToOption(thisOption, visualArr);
}

function makePartialColorVisualHandler(applyValue) {
  return {
    applyVisual: function (value, getter, setter) {
      // Only used in HSL
      var colorChannel = this.mapValueToVisual(value); // Must not be array value

      setter('color', applyValue(getter('color'), colorChannel));
    },
    _normalizedToVisual: createNormalizedToNumericVisual([0, 1])
  };
}

function doMapToArray(normalized) {
  var visual = this.option.visual;
  return visual[Math.round(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_number_js__["h" /* linearMap */])(normalized, [0, 1], [0, visual.length - 1], true))] || {}; // TODO {}?
}

function makeApplyVisual(visualType) {
  return function (value, getter, setter) {
    setter(visualType, this.mapValueToVisual(value));
  };
}

function doMapCategory(normalized) {
  var visual = this.option.visual;
  return visual[this.option.loop && normalized !== CATEGORY_DEFAULT_VISUAL_INDEX ? normalized % visual.length : normalized];
}

function doMapFixed() {
  // visual will be convert to array.
  return this.option.visual[0];
}
/**
 * Create mapped to numeric visual
 */


function createNormalizedToNumericVisual(sourceExtent) {
  return {
    linear: function (normalized) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_number_js__["h" /* linearMap */])(normalized, sourceExtent, this.option.visual, true);
    },
    category: doMapCategory,
    piecewise: function (normalized, value) {
      var result = getSpecifiedVisual.call(this, value);

      if (result == null) {
        result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_number_js__["h" /* linearMap */])(normalized, sourceExtent, this.option.visual, true);
      }

      return result;
    },
    fixed: doMapFixed
  };
}

function getSpecifiedVisual(value) {
  var thisOption = this.option;
  var pieceList = thisOption.pieceList;

  if (thisOption.hasSpecialVisual) {
    var pieceIndex = VisualMapping.findPieceIndex(value, pieceList);
    var piece = pieceList[pieceIndex];

    if (piece && piece.visual) {
      return piece.visual[this.type];
    }
  }
}

function setVisualToOption(thisOption, visualArr) {
  thisOption.visual = visualArr;

  if (thisOption.type === 'color') {
    thisOption.parsedVisual = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"](visualArr, function (item) {
      var color = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_tool_color_js__["parse"](item);

      if (!color && "prod" !== 'production') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_log_js__["b" /* warn */])("'" + item + "' is an illegal color, fallback to '#000000'", true);
      }

      return color || [0, 0, 0, 1];
    });
  }

  return visualArr;
}
/**
 * Normalizers by mapping methods.
 */


var normalizers = {
  linear: function (value) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_number_js__["h" /* linearMap */])(value, this.option.dataExtent, [0, 1], true);
  },
  piecewise: function (value) {
    var pieceList = this.option.pieceList;
    var pieceIndex = VisualMapping.findPieceIndex(value, pieceList, true);

    if (pieceIndex != null) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_number_js__["h" /* linearMap */])(pieceIndex, [0, pieceList.length - 1], [0, 1], true);
    }
  },
  category: function (value) {
    var index = this.option.categories ? this.option.categoryMap[value] : value; // ordinal value

    return index == null ? CATEGORY_DEFAULT_VISUAL_INDEX : index;
  },
  fixed: __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["noop"]
};

function littleThan(close, a, b) {
  return close ? a <= b : a < b;
}

/* harmony default export */ __webpack_exports__["a"] = (VisualMapping);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getValue_js__ = __webpack_require__(1421);



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getValue_js__["a" /* default */])(object, key);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (getNative);


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Element_js__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_BoundingRect_js__ = __webpack_require__(22);




var Group = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Group, _super);
    function Group(opts) {
        var _this = _super.call(this) || this;
        _this.isGroup = true;
        _this._children = [];
        _this.attr(opts);
        return _this;
    }
    Group.prototype.childrenRef = function () {
        return this._children;
    };
    Group.prototype.children = function () {
        return this._children.slice();
    };
    Group.prototype.childAt = function (idx) {
        return this._children[idx];
    };
    Group.prototype.childOfName = function (name) {
        var children = this._children;
        for (var i = 0; i < children.length; i++) {
            if (children[i].name === name) {
                return children[i];
            }
        }
    };
    Group.prototype.childCount = function () {
        return this._children.length;
    };
    Group.prototype.add = function (child) {
        if (child) {
            if (child !== this && child.parent !== this) {
                this._children.push(child);
                this._doAdd(child);
            }
            if (true) {
                if (child.__hostTarget) {
                    throw 'This elemenet has been used as an attachment';
                }
            }
        }
        return this;
    };
    Group.prototype.addBefore = function (child, nextSibling) {
        if (child && child !== this && child.parent !== this
            && nextSibling && nextSibling.parent === this) {
            var children = this._children;
            var idx = children.indexOf(nextSibling);
            if (idx >= 0) {
                children.splice(idx, 0, child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.replace = function (oldChild, newChild) {
        var idx = __WEBPACK_IMPORTED_MODULE_1__core_util_js__["indexOf"](this._children, oldChild);
        if (idx >= 0) {
            this.replaceAt(newChild, idx);
        }
        return this;
    };
    Group.prototype.replaceAt = function (child, index) {
        var children = this._children;
        var old = children[index];
        if (child && child !== this && child.parent !== this && child !== old) {
            children[index] = child;
            old.parent = null;
            var zr = this.__zr;
            if (zr) {
                old.removeSelfFromZr(zr);
            }
            this._doAdd(child);
        }
        return this;
    };
    Group.prototype._doAdd = function (child) {
        if (child.parent) {
            child.parent.remove(child);
        }
        child.parent = this;
        var zr = this.__zr;
        if (zr && zr !== child.__zr) {
            child.addSelfToZr(zr);
        }
        zr && zr.refresh();
    };
    Group.prototype.remove = function (child) {
        var zr = this.__zr;
        var children = this._children;
        var idx = __WEBPACK_IMPORTED_MODULE_1__core_util_js__["indexOf"](children, child);
        if (idx < 0) {
            return this;
        }
        children.splice(idx, 1);
        child.parent = null;
        if (zr) {
            child.removeSelfFromZr(zr);
        }
        zr && zr.refresh();
        return this;
    };
    Group.prototype.removeAll = function () {
        var children = this._children;
        var zr = this.__zr;
        for (var i = 0; i < children.length; i++) {
            var child = children[i];
            if (zr) {
                child.removeSelfFromZr(zr);
            }
            child.parent = null;
        }
        children.length = 0;
        return this;
    };
    Group.prototype.eachChild = function (cb, context) {
        var children = this._children;
        for (var i = 0; i < children.length; i++) {
            var child = children[i];
            cb.call(context, child, i);
        }
        return this;
    };
    Group.prototype.traverse = function (cb, context) {
        for (var i = 0; i < this._children.length; i++) {
            var child = this._children[i];
            var stopped = cb.call(context, child);
            if (child.isGroup && !stopped) {
                child.traverse(cb, context);
            }
        }
        return this;
    };
    Group.prototype.addSelfToZr = function (zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for (var i = 0; i < this._children.length; i++) {
            var child = this._children[i];
            child.addSelfToZr(zr);
        }
    };
    Group.prototype.removeSelfFromZr = function (zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for (var i = 0; i < this._children.length; i++) {
            var child = this._children[i];
            child.removeSelfFromZr(zr);
        }
    };
    Group.prototype.getBoundingRect = function (includeChildren) {
        var tmpRect = new __WEBPACK_IMPORTED_MODULE_3__core_BoundingRect_js__["a" /* default */](0, 0, 0, 0);
        var children = includeChildren || this._children;
        var tmpMat = [];
        var rect = null;
        for (var i = 0; i < children.length; i++) {
            var child = children[i];
            if (child.ignore || child.invisible) {
                continue;
            }
            var childRect = child.getBoundingRect();
            var transform = child.getLocalTransform(tmpMat);
            if (transform) {
                __WEBPACK_IMPORTED_MODULE_3__core_BoundingRect_js__["a" /* default */].applyTransform(tmpRect, childRect, transform);
                rect = rect || tmpRect.clone();
                rect.union(tmpRect);
            }
            else {
                rect = rect || childRect.clone();
                rect.union(childRect);
            }
        }
        return rect || tmpRect;
    };
    return Group;
}(__WEBPACK_IMPORTED_MODULE_2__Element_js__["a" /* default */]));
Group.prototype.type = 'group';
/* harmony default export */ __webpack_exports__["a"] = (Group);


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REDRAW_BIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STYLE_CHANGED_BIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SHAPE_CHANGED_BIT; });
var REDRAW_BIT = 1;
var STYLE_CHANGED_BIT = 2;
var SHAPE_CHANGED_BIT = 4;


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = ({
  listMeetingCostCenter: function listMeetingCostCenter(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/external/externalCostCenter/getMeetingCostCenterList', params);
  },
  listExistCostCenter: function listExistCostCenter(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/external/externalCostCenter/getExistCostCenter', params);
  },
  listExternalCostCenter: function listExternalCostCenter(params) {
    params.pageIndex = 1;
    params.pageSize = 1000000;
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/external/externalCostCenter/getCostCenter', params, { skipLoading: 1 });
  },
  listExternalWbsCode: function listExternalWbsCode(params) {
    params.pageIndex = 1;
    params.pageSize = 1000000;
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/external/externalCostCenter/getWbs', params);
  },
  listLocalCostCenter: function listLocalCostCenter(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/external/externalCostCenter/getCostCenterList', params);
  },
  listLocalWbsCode: function listLocalWbsCode(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/external/externalCostCenter/getWbsCodeList', params);
  },
  listRealWbsCode: function listRealWbsCode(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/external/externalCostCenter/getMeetingRealWbsList', params);
  }
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = ({
  budget: function budget(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/dashboard/dashboardBudget/queryData', params);
  },
  meeting: function meeting(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/dashboard/dashboardMeeting/meetingDistribute', params);
  },
  effectiveness: function effectiveness(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/dashboard/dashboardScore/queryScoreData', params);
  },
  getTableauTicket: function getTableauTicket(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/sys/tableau/ticket', params);
  },


  // 停留时间保存 enterTime"进入时间" leaveTime "离开时间" description"模块名称"
  saveStayTime: function saveStayTime(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].post('/rocheManage/sys/log/saveStayTime', params);
  }
});

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(748);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(269);
var defined = __webpack_require__(266);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(266);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(789)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(270)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(72);
var TAG = __webpack_require__(25)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(33).f;
var has = __webpack_require__(61);
var TAG = __webpack_require__(25)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var defined = __webpack_require__(82);
var fails = __webpack_require__(16);
var spaces = __webpack_require__(305);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRenderPlanner;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @return {string} If large mode changed, return string 'reset';
 */

function createRenderPlanner() {
  var inner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_model_js__["a" /* makeInner */])();
  return function (seriesModel) {
    var fields = inner(seriesModel);
    var pipelineContext = seriesModel.pipelineContext;
    var originalLarge = !!fields.large;
    var originalProgressive = !!fields.progressiveRender; // FIXME: if the planner works on a filtered series, `pipelineContext` does not
    // exists. See #11611 . Probably we need to modify this structure, see the comment
    // on `performRawSeries` in `Schedular.js`.

    var large = fields.large = !!(pipelineContext && pipelineContext.large);
    var progressive = fields.progressiveRender = !!(pipelineContext && pipelineContext.progressiveRender);
    return !!(originalLarge !== large || originalProgressive !== progressive) && 'reset';
  };
}

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSeriesDataSimply;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_helper_createDimensions_js__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_SeriesData_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



/**
 * [Usage]:
 * (1)
 * createListSimply(seriesModel, ['value']);
 * (2)
 * createListSimply(seriesModel, {
 *     coordDimensions: ['value'],
 *     dimensionsCount: 5
 * });
 */

function createSeriesDataSimply(seriesModel, opt, nameList) {
  opt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isArray"])(opt) && {
    coordDimensions: opt
  } || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["extend"])({
    encodeDefine: seriesModel.getEncode()
  }, opt);
  var source = seriesModel.getSource();
  var dimensions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__data_helper_createDimensions_js__["a" /* default */])(source, opt).dimensions;
  var list = new __WEBPACK_IMPORTED_MODULE_1__data_SeriesData_js__["a" /* default */](dimensions, seriesModel);
  list.initData(source, nameList);
  return list;
}

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DATA_ZOOM_AXIS_DIMENSIONS; });
/* harmony export (immutable) */ __webpack_exports__["c"] = isCoordSupported;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAxisMainType;
/* unused harmony export getAxisIndexPropName */
/* unused harmony export getAxisIdPropName */
/* harmony export (immutable) */ __webpack_exports__["a"] = findEffectedDataZooms;
/* harmony export (immutable) */ __webpack_exports__["d"] = collectReferCoordSysModelInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var DATA_ZOOM_AXIS_DIMENSIONS = ['x', 'y', 'radius', 'angle', 'single']; // Supported coords.
// FIXME: polar has been broken (but rarely used).

var SERIES_COORDS = ['cartesian2d', 'polar', 'singleAxis'];
function isCoordSupported(seriesModel) {
  var coordType = seriesModel.get('coordinateSystem');
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"])(SERIES_COORDS, coordType) >= 0;
}
function getAxisMainType(axisDim) {
  if (true) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(axisDim);
  }

  return axisDim + 'Axis';
}
function getAxisIndexPropName(axisDim) {
  if (true) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(axisDim);
  }

  return axisDim + 'AxisIndex';
}
function getAxisIdPropName(axisDim) {
  if (true) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(axisDim);
  }

  return axisDim + 'AxisId';
}
/**
 * If two dataZoomModels has the same axis controlled, we say that they are 'linked'.
 * This function finds all linked dataZoomModels start from the given payload.
 */

function findEffectedDataZooms(ecModel, payload) {
  // Key: `DataZoomAxisDimension`
  var axisRecords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();
  var effectedModels = []; // Key: uid of dataZoomModel

  var effectedModelMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])(); // Find the dataZooms specified by payload.

  ecModel.eachComponent({
    mainType: 'dataZoom',
    query: payload
  }, function (dataZoomModel) {
    if (!effectedModelMap.get(dataZoomModel.uid)) {
      addToEffected(dataZoomModel);
    }
  }); // Start from the given dataZoomModels, travel the graph to find
  // all of the linked dataZoom models.

  var foundNewLink;

  do {
    foundNewLink = false;
    ecModel.eachComponent('dataZoom', processSingle);
  } while (foundNewLink);

  function processSingle(dataZoomModel) {
    if (!effectedModelMap.get(dataZoomModel.uid) && isLinked(dataZoomModel)) {
      addToEffected(dataZoomModel);
      foundNewLink = true;
    }
  }

  function addToEffected(dataZoom) {
    effectedModelMap.set(dataZoom.uid, true);
    effectedModels.push(dataZoom);
    markAxisControlled(dataZoom);
  }

  function isLinked(dataZoomModel) {
    var isLink = false;
    dataZoomModel.eachTargetAxis(function (axisDim, axisIndex) {
      var axisIdxArr = axisRecords.get(axisDim);

      if (axisIdxArr && axisIdxArr[axisIndex]) {
        isLink = true;
      }
    });
    return isLink;
  }

  function markAxisControlled(dataZoomModel) {
    dataZoomModel.eachTargetAxis(function (axisDim, axisIndex) {
      (axisRecords.get(axisDim) || axisRecords.set(axisDim, []))[axisIndex] = true;
    });
  }

  return effectedModels;
}
/**
 * Find the first target coordinate system.
 * Available after model built.
 *
 * @return Like {
 *                  grid: [
 *                      {model: coord0, axisModels: [axis1, axis3], coordIndex: 1},
 *                      {model: coord1, axisModels: [axis0, axis2], coordIndex: 0},
 *                      ...
 *                  ],  // cartesians must not be null/undefined.
 *                  polar: [
 *                      {model: coord0, axisModels: [axis4], coordIndex: 0},
 *                      ...
 *                  ],  // polars must not be null/undefined.
 *                  singleAxis: [
 *                      {model: coord0, axisModels: [], coordIndex: 0}
 *                  ]
 *              }
 */

function collectReferCoordSysModelInfo(dataZoomModel) {
  var ecModel = dataZoomModel.ecModel;
  var coordSysInfoWrap = {
    infoList: [],
    infoMap: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])()
  };
  dataZoomModel.eachTargetAxis(function (axisDim, axisIndex) {
    var axisModel = ecModel.getComponent(getAxisMainType(axisDim), axisIndex);

    if (!axisModel) {
      return;
    }

    var coordSysModel = axisModel.getCoordSysModel();

    if (!coordSysModel) {
      return;
    }

    var coordSysUid = coordSysModel.uid;
    var coordSysInfo = coordSysInfoWrap.infoMap.get(coordSysUid);

    if (!coordSysInfo) {
      coordSysInfo = {
        model: coordSysModel,
        axisModels: []
      };
      coordSysInfoWrap.infoList.push(coordSysInfo);
      coordSysInfoWrap.infoMap.set(coordSysUid, coordSysInfo);
    }

    coordSysInfo.axisModels.push(axisModel);
  });
  return coordSysInfoWrap;
}

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sliderMove;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Calculate slider move result.
 * Usage:
 * (1) If both handle0 and handle1 are needed to be moved, set minSpan the same as
 * maxSpan and the same as `Math.abs(handleEnd[1] - handleEnds[0])`.
 * (2) If handle0 is forbidden to cross handle1, set minSpan as `0`.
 *
 * @param delta Move length.
 * @param handleEnds handleEnds[0] can be bigger then handleEnds[1].
 *              handleEnds will be modified in this method.
 * @param extent handleEnds is restricted by extent.
 *              extent[0] should less or equals than extent[1].
 * @param handleIndex Can be 'all', means that both move the two handleEnds.
 * @param minSpan The range of dataZoom can not be smaller than that.
 *              If not set, handle0 and cross handle1. If set as a non-negative
 *              number (including `0`), handles will push each other when reaching
 *              the minSpan.
 * @param maxSpan The range of dataZoom can not be larger than that.
 * @return The input handleEnds.
 */
function sliderMove(delta, handleEnds, extent, handleIndex, minSpan, maxSpan) {
  delta = delta || 0;
  var extentSpan = extent[1] - extent[0]; // Notice maxSpan and minSpan can be null/undefined.

  if (minSpan != null) {
    minSpan = restrict(minSpan, [0, extentSpan]);
  }

  if (maxSpan != null) {
    maxSpan = Math.max(maxSpan, minSpan != null ? minSpan : 0);
  }

  if (handleIndex === 'all') {
    var handleSpan = Math.abs(handleEnds[1] - handleEnds[0]);
    handleSpan = restrict(handleSpan, [0, extentSpan]);
    minSpan = maxSpan = restrict(handleSpan, [minSpan, maxSpan]);
    handleIndex = 0;
  }

  handleEnds[0] = restrict(handleEnds[0], extent);
  handleEnds[1] = restrict(handleEnds[1], extent);
  var originalDistSign = getSpanSign(handleEnds, handleIndex);
  handleEnds[handleIndex] += delta; // Restrict in extent.

  var extentMinSpan = minSpan || 0;
  var realExtent = extent.slice();
  originalDistSign.sign < 0 ? realExtent[0] += extentMinSpan : realExtent[1] -= extentMinSpan;
  handleEnds[handleIndex] = restrict(handleEnds[handleIndex], realExtent); // Expand span.

  var currDistSign;
  currDistSign = getSpanSign(handleEnds, handleIndex);

  if (minSpan != null && (currDistSign.sign !== originalDistSign.sign || currDistSign.span < minSpan)) {
    // If minSpan exists, 'cross' is forbidden.
    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + originalDistSign.sign * minSpan;
  } // Shrink span.


  currDistSign = getSpanSign(handleEnds, handleIndex);

  if (maxSpan != null && currDistSign.span > maxSpan) {
    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + currDistSign.sign * maxSpan;
  }

  return handleEnds;
}

function getSpanSign(handleEnds, handleIndex) {
  var dist = handleEnds[handleIndex] - handleEnds[1 - handleIndex]; // If `handleEnds[0] === handleEnds[1]`, always believe that handleEnd[0]
  // is at left of handleEnds[1] for non-cross case.

  return {
    span: Math.abs(dist),
    sign: dist > 0 ? -1 : dist < 0 ? 1 : handleIndex ? -1 : 1
  };
}

function restrict(value, extend) {
  return Math.min(extend[1] != null ? extend[1] : Infinity, Math.max(extend[0] != null ? extend[0] : -Infinity, value));
}

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AxisModelCommonMixin; });

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var AxisModelCommonMixin =
/** @class */
function () {
  function AxisModelCommonMixin() {}

  AxisModelCommonMixin.prototype.getNeedCrossZero = function () {
    var option = this.option;
    return !option.scale;
  };
  /**
   * Should be implemented by each axis model if necessary.
   * @return coordinate system model
   */


  AxisModelCommonMixin.prototype.getCoordSysModel = function () {
    return;
  };

  return AxisModelCommonMixin;
}();



/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GeoSVGResource_js__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GeoJSONResource_js__ = __webpack_require__(1298);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var storage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * Compatible with previous `echarts.registerMap`.
   *
   * @usage
   * ```js
   *
   * echarts.registerMap('USA', geoJson, specialAreas);
   *
   * echarts.registerMap('USA', {
   *     geoJson: geoJson,
   *     specialAreas: {...}
   * });
   * echarts.registerMap('USA', {
   *     geoJSON: geoJson,
   *     specialAreas: {...}
   * });
   *
   * echarts.registerMap('airport', {
   *     svg: svg
   * }
   * ```
   *
   * Note:
   * Do not support that register multiple geoJSON or SVG
   * one map name. Because different geoJSON and SVG have
   * different unit. It's not easy to make sure how those
   * units are mapping/normalize.
   * If intending to use multiple geoJSON or SVG, we can
   * use multiple geo coordinate system.
   */
  registerMap: function (mapName, rawDef, rawSpecialAreas) {
    if (rawDef.svg) {
      var resource = new __WEBPACK_IMPORTED_MODULE_1__GeoSVGResource_js__["a" /* GeoSVGResource */](mapName, rawDef.svg);
      storage.set(mapName, resource);
    } else {
      // Recommend:
      //     echarts.registerMap('eu', { geoJSON: xxx, specialAreas: xxx });
      // Backward compatibility:
      //     echarts.registerMap('eu', geoJSON, specialAreas);
      //     echarts.registerMap('eu', { geoJson: xxx, specialAreas: xxx });
      var geoJSON = rawDef.geoJson || rawDef.geoJSON;

      if (geoJSON && !rawDef.features) {
        rawSpecialAreas = rawDef.specialAreas;
      } else {
        geoJSON = rawDef;
      }

      var resource = new __WEBPACK_IMPORTED_MODULE_2__GeoJSONResource_js__["a" /* GeoJSONResource */](mapName, geoJSON, rawSpecialAreas);
      storage.set(mapName, resource);
    }
  },
  getGeoResource: function (mapName) {
    return storage.get(mapName);
  },

  /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */
  getMapForUser: function (mapName) {
    var resource = storage.get(mapName); // Do not support return SVG until some real requirement come.

    return resource && resource.type === 'geoJSON' && resource.getMapForUser();
  },
  load: function (mapName, nameMap, nameProperty) {
    var resource = storage.get(mapName);

    if (!resource) {
      if (true) {
        console.error('Map ' + mapName + ' not exists. The GeoJSON of the map must be provided.');
      }

      return;
    }

    return resource.load(nameMap, nameProperty);
  }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return dependencies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PRIORITY; });
/* harmony export (immutable) */ __webpack_exports__["p"] = init;
/* harmony export (immutable) */ __webpack_exports__["q"] = connect;
/* harmony export (immutable) */ __webpack_exports__["r"] = disConnect;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return disconnect; });
/* harmony export (immutable) */ __webpack_exports__["t"] = dispose;
/* harmony export (immutable) */ __webpack_exports__["u"] = getInstanceByDom;
/* harmony export (immutable) */ __webpack_exports__["v"] = getInstanceById;
/* harmony export (immutable) */ __webpack_exports__["w"] = registerTheme;
/* harmony export (immutable) */ __webpack_exports__["b"] = registerPreprocessor;
/* harmony export (immutable) */ __webpack_exports__["c"] = registerProcessor;
/* harmony export (immutable) */ __webpack_exports__["d"] = registerPostInit;
/* harmony export (immutable) */ __webpack_exports__["e"] = registerPostUpdate;
/* harmony export (immutable) */ __webpack_exports__["f"] = registerUpdateLifecycle;
/* harmony export (immutable) */ __webpack_exports__["a"] = registerAction;
/* harmony export (immutable) */ __webpack_exports__["g"] = registerCoordinateSystem;
/* harmony export (immutable) */ __webpack_exports__["x"] = getCoordinateSystemDimensions;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return registerLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return registerVisual; });
/* harmony export (immutable) */ __webpack_exports__["k"] = registerLoading;
/* harmony export (immutable) */ __webpack_exports__["z"] = setCanvasCreator;
/* harmony export (immutable) */ __webpack_exports__["l"] = registerMap;
/* harmony export (immutable) */ __webpack_exports__["A"] = getMap;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return registerTransform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return dataTool; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_zrender_js__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_env_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_timsort_js__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_Eventful_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_Global_js__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ExtensionAPI_js__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CoordinateSystem_js__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_OptionManager_js__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__preprocessor_backwardCompat_js__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__processor_dataStack_js__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__model_Series_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__view_Component_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_throttle_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__visual_style_js__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__loading_default_js__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Scheduler_js__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__theme_light_js__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__theme_dark_js__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__util_clazz_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__util_ECEventProcessor_js__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__visual_symbol_js__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__visual_helper_js__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__util_log_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__legacy_dataSelectAction_js__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__data_helper_transform_js__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__locale_js__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__util_event_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__visual_decal_js__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__lifecycle_js__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_zrender_lib_core_platform_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__impl_js__ = __webpack_require__(490);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_32__locale_js__["e"]; });

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






































var hasWindow = typeof window !== 'undefined';
var version = '5.3.2';
var dependencies = {
  zrender: '5.3.1'
};
var TEST_FRAME_REMAIN_TIME = 1;
var PRIORITY_PROCESSOR_SERIES_FILTER = 800; // Some data processors depends on the stack result dimension (to calculate data extent).
// So data stack stage should be in front of data processing stage.

var PRIORITY_PROCESSOR_DATASTACK = 900; // "Data filter" will block the stream, so it should be
// put at the begining of data processing.

var PRIORITY_PROCESSOR_FILTER = 1000;
var PRIORITY_PROCESSOR_DEFAULT = 2000;
var PRIORITY_PROCESSOR_STATISTIC = 5000;
var PRIORITY_VISUAL_LAYOUT = 1000;
var PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
var PRIORITY_VISUAL_GLOBAL = 2000;
var PRIORITY_VISUAL_CHART = 3000;
var PRIORITY_VISUAL_COMPONENT = 4000; // Visual property in data. Greater than `PRIORITY_VISUAL_COMPONENT` to enable to
// overwrite the viusal result of component (like `visualMap`)
// using data item specific setting (like itemStyle.xxx on data item)

var PRIORITY_VISUAL_CHART_DATA_CUSTOM = 4500; // Greater than `PRIORITY_VISUAL_CHART_DATA_CUSTOM` to enable to layout based on
// visual result like `symbolSize`.

var PRIORITY_VISUAL_POST_CHART_LAYOUT = 4600;
var PRIORITY_VISUAL_BRUSH = 5000;
var PRIORITY_VISUAL_ARIA = 6000;
var PRIORITY_VISUAL_DECAL = 7000;
var PRIORITY = {
  PROCESSOR: {
    FILTER: PRIORITY_PROCESSOR_FILTER,
    SERIES_FILTER: PRIORITY_PROCESSOR_SERIES_FILTER,
    STATISTIC: PRIORITY_PROCESSOR_STATISTIC
  },
  VISUAL: {
    LAYOUT: PRIORITY_VISUAL_LAYOUT,
    PROGRESSIVE_LAYOUT: PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
    GLOBAL: PRIORITY_VISUAL_GLOBAL,
    CHART: PRIORITY_VISUAL_CHART,
    POST_CHART_LAYOUT: PRIORITY_VISUAL_POST_CHART_LAYOUT,
    COMPONENT: PRIORITY_VISUAL_COMPONENT,
    BRUSH: PRIORITY_VISUAL_BRUSH,
    CHART_ITEM: PRIORITY_VISUAL_CHART_DATA_CUSTOM,
    ARIA: PRIORITY_VISUAL_ARIA,
    DECAL: PRIORITY_VISUAL_DECAL
  }
}; // Main process have three entries: `setOption`, `dispatchAction` and `resize`,
// where they must not be invoked nestedly, except the only case: invoke
// dispatchAction with updateMethod "none" in main process.
// This flag is used to carry out this rule.
// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).

var IN_MAIN_PROCESS_KEY = '__flagInMainProcess';
var PENDING_UPDATE = '__pendingUpdate';
var STATUS_NEEDS_UPDATE_KEY = '__needsUpdateStatus';
var ACTION_REG = /^[a-zA-Z0-9_]+$/;
var CONNECT_STATUS_KEY = '__connectUpdateStatus';
var CONNECT_STATUS_PENDING = 0;
var CONNECT_STATUS_UPDATING = 1;
var CONNECT_STATUS_UPDATED = 2;
;
;

function createRegisterEventWithLowercaseECharts(method) {
  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    if (this.isDisposed()) {
      disposedWarning(this.id);
      return;
    }

    return toLowercaseNameAndCallEventful(this, method, args);
  };
}

function createRegisterEventWithLowercaseMessageCenter(method) {
  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return toLowercaseNameAndCallEventful(this, method, args);
  };
}

function toLowercaseNameAndCallEventful(host, method, args) {
  // `args[0]` is event name. Event name is all lowercase.
  args[0] = args[0] && args[0].toLowerCase();
  return __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_Eventful_js__["a" /* default */].prototype[method].apply(host, args);
}

var MessageCenter =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(MessageCenter, _super);

  function MessageCenter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return MessageCenter;
}(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_Eventful_js__["a" /* default */]);

var messageCenterProto = MessageCenter.prototype;
messageCenterProto.on = createRegisterEventWithLowercaseMessageCenter('on');
messageCenterProto.off = createRegisterEventWithLowercaseMessageCenter('off'); // ---------------------------------------
// Internal method names for class ECharts
// ---------------------------------------

var prepare;
var prepareView;
var updateDirectly;
var updateMethods;
var doConvertPixel;
var updateStreamModes;
var doDispatchAction;
var flushPendingActions;
var triggerUpdatedEvent;
var bindRenderedEvent;
var bindMouseEvent;
var render;
var renderComponents;
var renderSeries;
var createExtensionAPI;
var enableConnect;
var markStatusToUpdate;
var applyChangedStates;

var ECharts =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ECharts, _super);

  function ECharts(dom, // Theme name or themeOption.
  theme, opts) {
    var _this = _super.call(this, new __WEBPACK_IMPORTED_MODULE_26__util_ECEventProcessor_js__["a" /* ECEventProcessor */]()) || this;

    _this._chartsViews = [];
    _this._chartsMap = {};
    _this._componentsViews = [];
    _this._componentsMap = {}; // Can't dispatch action during rendering procedure

    _this._pendingActions = [];
    opts = opts || {}; // Get theme by name

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isString"])(theme)) {
      theme = themeStorage[theme];
    }

    _this._dom = dom;
    var defaultRenderer = 'canvas';
    var defaultUseDirtyRect = false;

    if (true) {
      var root =
      /* eslint-disable-next-line */
      hasWindow ? window : global;
      defaultRenderer = root.__ECHARTS__DEFAULT__RENDERER__ || defaultRenderer;
      var devUseDirtyRect = root.__ECHARTS__DEFAULT__USE_DIRTY_RECT__;
      defaultUseDirtyRect = devUseDirtyRect == null ? defaultUseDirtyRect : devUseDirtyRect;
    }

    var zr = _this._zr = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_zrender_js__["init"](dom, {
      renderer: opts.renderer || defaultRenderer,
      devicePixelRatio: opts.devicePixelRatio,
      width: opts.width,
      height: opts.height,
      ssr: opts.ssr,
      useDirtyRect: opts.useDirtyRect == null ? defaultUseDirtyRect : opts.useDirtyRect
    });
    _this._ssr = opts.ssr; // Expect 60 fps.

    _this._throttledZrFlush = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_throttle_js__["c" /* throttle */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["bind"])(zr.flush, zr), 17);
    theme = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["clone"])(theme);
    theme && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__preprocessor_backwardCompat_js__["a" /* default */])(theme, true);
    _this._theme = theme;
    _this._locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32__locale_js__["d" /* createLocaleObject */])(opts.locale || __WEBPACK_IMPORTED_MODULE_32__locale_js__["b" /* SYSTEM_LANG */]);
    _this._coordSysMgr = new __WEBPACK_IMPORTED_MODULE_8__CoordinateSystem_js__["a" /* default */]();
    var api = _this._api = createExtensionAPI(_this); // Sort on demand

    function prioritySortFunc(a, b) {
      return a.__prio - b.__prio;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_timsort_js__["a" /* default */])(visualFuncs, prioritySortFunc);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_timsort_js__["a" /* default */])(dataProcessorFuncs, prioritySortFunc);
    _this._scheduler = new __WEBPACK_IMPORTED_MODULE_22__Scheduler_js__["a" /* default */](_this, api, dataProcessorFuncs, visualFuncs);
    _this._messageCenter = new MessageCenter(); // Init mouse events

    _this._initEvents(); // In case some people write `window.onresize = chart.resize`


    _this.resize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["bind"])(_this.resize, _this);
    zr.animation.on('frame', _this._onframe, _this);
    bindRenderedEvent(zr, _this);
    bindMouseEvent(zr, _this); // ECharts instance can be used as value.

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["setAsPrimitive"])(_this);
    return _this;
  }

  ECharts.prototype._onframe = function () {
    if (this._disposed) {
      return;
    }

    applyChangedStates(this);
    var scheduler = this._scheduler; // Lazy update

    if (this[PENDING_UPDATE]) {
      var silent = this[PENDING_UPDATE].silent;
      this[IN_MAIN_PROCESS_KEY] = true;

      try {
        prepare(this);
        updateMethods.update.call(this, null, this[PENDING_UPDATE].updateParams);
      } catch (e) {
        this[IN_MAIN_PROCESS_KEY] = false;
        this[PENDING_UPDATE] = null;
        throw e;
      } // At present, in each frame, zrender performs:
      //   (1) animation step forward.
      //   (2) trigger('frame') (where this `_onframe` is called)
      //   (3) zrender flush (render).
      // If we do nothing here, since we use `setToFinal: true`, the step (3) above
      // will render the final state of the elements before the real animation started.


      this._zr.flush();

      this[IN_MAIN_PROCESS_KEY] = false;
      this[PENDING_UPDATE] = null;
      flushPendingActions.call(this, silent);
      triggerUpdatedEvent.call(this, silent);
    } // Avoid do both lazy update and progress in one frame.
    else if (scheduler.unfinished) {
        // Stream progress.
        var remainTime = TEST_FRAME_REMAIN_TIME;
        var ecModel = this._model;
        var api = this._api;
        scheduler.unfinished = false;

        do {
          var startTime = +new Date();
          scheduler.performSeriesTasks(ecModel); // Currently dataProcessorFuncs do not check threshold.

          scheduler.performDataProcessorTasks(ecModel);
          updateStreamModes(this, ecModel); // Do not update coordinate system here. Because that coord system update in
          // each frame is not a good user experience. So we follow the rule that
          // the extent of the coordinate system is determin in the first frame (the
          // frame is executed immedietely after task reset.
          // this._coordSysMgr.update(ecModel, api);
          // console.log('--- ec frame visual ---', remainTime);

          scheduler.performVisualTasks(ecModel);
          renderSeries(this, this._model, api, 'remain', {});
          remainTime -= +new Date() - startTime;
        } while (remainTime > 0 && scheduler.unfinished); // Call flush explicitly for trigger finished event.


        if (!scheduler.unfinished) {
          this._zr.flush();
        } // Else, zr flushing be ensue within the same frame,
        // because zr flushing is after onframe event.

      }
  };

  ECharts.prototype.getDom = function () {
    return this._dom;
  };

  ECharts.prototype.getId = function () {
    return this.id;
  };

  ECharts.prototype.getZr = function () {
    return this._zr;
  };

  ECharts.prototype.isSSR = function () {
    return this._ssr;
  };
  /* eslint-disable-next-line */


  ECharts.prototype.setOption = function (option, notMerge, lazyUpdate) {
    if (this[IN_MAIN_PROCESS_KEY]) {
      if (true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__util_log_js__["c" /* error */])('`setOption` should not be called during main process.');
      }

      return;
    }

    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    var silent;
    var replaceMerge;
    var transitionOpt;

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isObject"])(notMerge)) {
      lazyUpdate = notMerge.lazyUpdate;
      silent = notMerge.silent;
      replaceMerge = notMerge.replaceMerge;
      transitionOpt = notMerge.transition;
      notMerge = notMerge.notMerge;
    }

    this[IN_MAIN_PROCESS_KEY] = true;

    if (!this._model || notMerge) {
      var optionManager = new __WEBPACK_IMPORTED_MODULE_9__model_OptionManager_js__["a" /* default */](this._api);
      var theme = this._theme;
      var ecModel = this._model = new __WEBPACK_IMPORTED_MODULE_6__model_Global_js__["a" /* default */]();
      ecModel.scheduler = this._scheduler;
      ecModel.ssr = this._ssr;
      ecModel.init(null, null, null, theme, this._locale, optionManager);
    }

    this._model.setOption(option, {
      replaceMerge: replaceMerge
    }, optionPreprocessorFuncs);

    var updateParams = {
      seriesTransition: transitionOpt,
      optionChanged: true
    };

    if (lazyUpdate) {
      this[PENDING_UPDATE] = {
        silent: silent,
        updateParams: updateParams
      };
      this[IN_MAIN_PROCESS_KEY] = false; // `setOption(option, {lazyMode: true})` may be called when zrender has been slept.
      // It should wake it up to make sure zrender start to render at the next frame.

      this.getZr().wakeUp();
    } else {
      try {
        prepare(this);
        updateMethods.update.call(this, null, updateParams);
      } catch (e) {
        this[PENDING_UPDATE] = null;
        this[IN_MAIN_PROCESS_KEY] = false;
        throw e;
      } // Ensure zr refresh sychronously, and then pixel in canvas can be
      // fetched after `setOption`.


      if (!this._ssr) {
        // not use flush when using ssr mode.
        this._zr.flush();
      }

      this[PENDING_UPDATE] = null;
      this[IN_MAIN_PROCESS_KEY] = false;
      flushPendingActions.call(this, silent);
      triggerUpdatedEvent.call(this, silent);
    }
  };
  /**
   * @deprecated
   */


  ECharts.prototype.setTheme = function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__util_log_js__["g" /* deprecateLog */])('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
  }; // We don't want developers to use getModel directly.


  ECharts.prototype.getModel = function () {
    return this._model;
  };

  ECharts.prototype.getOption = function () {
    return this._model && this._model.getOption();
  };

  ECharts.prototype.getWidth = function () {
    return this._zr.getWidth();
  };

  ECharts.prototype.getHeight = function () {
    return this._zr.getHeight();
  };

  ECharts.prototype.getDevicePixelRatio = function () {
    return this._zr.painter.dpr
    /* eslint-disable-next-line */
    || hasWindow && window.devicePixelRatio || 1;
  };
  /**
   * Get canvas which has all thing rendered
   * @deprecated Use renderToCanvas instead.
   */


  ECharts.prototype.getRenderedCanvas = function (opts) {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__util_log_js__["a" /* deprecateReplaceLog */])('getRenderedCanvas', 'renderToCanvas');
    }

    return this.renderToCanvas(opts);
  };

  ECharts.prototype.renderToCanvas = function (opts) {
    opts = opts || {};
    var painter = this._zr.painter;

    if (true) {
      if (painter.type !== 'canvas') {
        throw new Error('renderToCanvas can only be used in the canvas renderer.');
      }
    }

    return painter.getRenderedCanvas({
      backgroundColor: opts.backgroundColor || this._model.get('backgroundColor'),
      pixelRatio: opts.pixelRatio || this.getDevicePixelRatio()
    });
  };

  ECharts.prototype.renderToSVGString = function (opts) {
    opts = opts || {};
    var painter = this._zr.painter;

    if (true) {
      if (painter.type !== 'svg') {
        throw new Error('renderToSVGString can only be used in the svg renderer.');
      }
    }

    return painter.renderToString({
      useViewBox: opts.useViewBox
    });
  };
  /**
   * Get svg data url
   */


  ECharts.prototype.getSvgDataURL = function () {
    if (!__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_env_js__["a" /* default */].svgSupported) {
      return;
    }

    var zr = this._zr;
    var list = zr.storage.getDisplayList(); // Stop animations

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(list, function (el) {
      el.stopAnimation(null, true);
    });
    return zr.painter.toDataURL();
  };

  ECharts.prototype.getDataURL = function (opts) {
    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    opts = opts || {};
    var excludeComponents = opts.excludeComponents;
    var ecModel = this._model;
    var excludesComponentViews = [];
    var self = this;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(excludeComponents, function (componentType) {
      ecModel.eachComponent({
        mainType: componentType
      }, function (component) {
        var view = self._componentsMap[component.__viewId];

        if (!view.group.ignore) {
          excludesComponentViews.push(view);
          view.group.ignore = true;
        }
      });
    });
    var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataURL() : this.renderToCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(excludesComponentViews, function (view) {
      view.group.ignore = false;
    });
    return url;
  };

  ECharts.prototype.getConnectedDataURL = function (opts) {
    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    var isSvg = opts.type === 'svg';
    var groupId = this.group;
    var mathMin = Math.min;
    var mathMax = Math.max;
    var MAX_NUMBER = Infinity;

    if (connectedGroups[groupId]) {
      var left_1 = MAX_NUMBER;
      var top_1 = MAX_NUMBER;
      var right_1 = -MAX_NUMBER;
      var bottom_1 = -MAX_NUMBER;
      var canvasList_1 = [];
      var dpr_1 = opts && opts.pixelRatio || this.getDevicePixelRatio();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(instances, function (chart, id) {
        if (chart.group === groupId) {
          var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.renderToCanvas(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["clone"])(opts));
          var boundingRect = chart.getDom().getBoundingClientRect();
          left_1 = mathMin(boundingRect.left, left_1);
          top_1 = mathMin(boundingRect.top, top_1);
          right_1 = mathMax(boundingRect.right, right_1);
          bottom_1 = mathMax(boundingRect.bottom, bottom_1);
          canvasList_1.push({
            dom: canvas,
            left: boundingRect.left,
            top: boundingRect.top
          });
        }
      });
      left_1 *= dpr_1;
      top_1 *= dpr_1;
      right_1 *= dpr_1;
      bottom_1 *= dpr_1;
      var width = right_1 - left_1;
      var height = bottom_1 - top_1;
      var targetCanvas = __WEBPACK_IMPORTED_MODULE_36_zrender_lib_core_platform_js__["a" /* platformApi */].createCanvas();
      var zr_1 = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_zrender_js__["init"](targetCanvas, {
        renderer: isSvg ? 'svg' : 'canvas'
      });
      zr_1.resize({
        width: width,
        height: height
      });

      if (isSvg) {
        var content_1 = '';
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(canvasList_1, function (item) {
          var x = item.left - left_1;
          var y = item.top - top_1;
          content_1 += '<g transform="translate(' + x + ',' + y + ')">' + item.dom + '</g>';
        });
        zr_1.painter.getSvgRoot().innerHTML = content_1;

        if (opts.connectedBackgroundColor) {
          zr_1.painter.setBackgroundColor(opts.connectedBackgroundColor);
        }

        zr_1.refreshImmediately();
        return zr_1.painter.toDataURL();
      } else {
        // Background between the charts
        if (opts.connectedBackgroundColor) {
          zr_1.add(new __WEBPACK_IMPORTED_MODULE_15__util_graphic_js__["Rect"]({
            shape: {
              x: 0,
              y: 0,
              width: width,
              height: height
            },
            style: {
              fill: opts.connectedBackgroundColor
            }
          }));
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(canvasList_1, function (item) {
          var img = new __WEBPACK_IMPORTED_MODULE_15__util_graphic_js__["Image"]({
            style: {
              x: item.left * dpr_1 - left_1,
              y: item.top * dpr_1 - top_1,
              image: item.dom
            }
          });
          zr_1.add(img);
        });
        zr_1.refreshImmediately();
        return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
      }
    } else {
      return this.getDataURL(opts);
    }
  };

  ECharts.prototype.convertToPixel = function (finder, value) {
    return doConvertPixel(this, 'convertToPixel', finder, value);
  };

  ECharts.prototype.convertFromPixel = function (finder, value) {
    return doConvertPixel(this, 'convertFromPixel', finder, value);
  };
  /**
   * Is the specified coordinate systems or components contain the given pixel point.
   * @param {Array|number} value
   * @return {boolean} result
   */


  ECharts.prototype.containPixel = function (finder, value) {
    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    var ecModel = this._model;
    var result;
    var findResult = __WEBPACK_IMPORTED_MODULE_18__util_model_js__["l" /* parseFinder */](ecModel, finder);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(findResult, function (models, key) {
      key.indexOf('Models') >= 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(models, function (model) {
        var coordSys = model.coordinateSystem;

        if (coordSys && coordSys.containPoint) {
          result = result || !!coordSys.containPoint(value);
        } else if (key === 'seriesModels') {
          var view = this._chartsMap[model.__viewId];

          if (view && view.containPoint) {
            result = result || view.containPoint(value, model);
          } else {
            if (true) {
              console.warn(key + ': ' + (view ? 'The found component do not support containPoint.' : 'No view mapping to the found component.'));
            }
          }
        } else {
          if (true) {
            console.warn(key + ': containPoint is not supported');
          }
        }
      }, this);
    }, this);
    return !!result;
  };
  /**
   * Get visual from series or data.
   * @param finder
   *        If string, e.g., 'series', means {seriesIndex: 0}.
   *        If Object, could contain some of these properties below:
   *        {
   *            seriesIndex / seriesId / seriesName,
   *            dataIndex / dataIndexInside
   *        }
   *        If dataIndex is not specified, series visual will be fetched,
   *        but not data item visual.
   *        If all of seriesIndex, seriesId, seriesName are not specified,
   *        visual will be fetched from first series.
   * @param visualType 'color', 'symbol', 'symbolSize'
   */


  ECharts.prototype.getVisual = function (finder, visualType) {
    var ecModel = this._model;
    var parsedFinder = __WEBPACK_IMPORTED_MODULE_18__util_model_js__["l" /* parseFinder */](ecModel, finder, {
      defaultMainType: 'series'
    });
    var seriesModel = parsedFinder.seriesModel;

    if (true) {
      if (!seriesModel) {
        console.warn('There is no specified seires model');
      }
    }

    var data = seriesModel.getData();
    var dataIndexInside = parsedFinder.hasOwnProperty('dataIndexInside') ? parsedFinder.dataIndexInside : parsedFinder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(parsedFinder.dataIndex) : null;
    return dataIndexInside != null ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__visual_helper_js__["b" /* getItemVisualFromData */])(data, dataIndexInside, visualType) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28__visual_helper_js__["a" /* getVisualFromData */])(data, visualType);
  };
  /**
   * Get view of corresponding component model
   */


  ECharts.prototype.getViewOfComponentModel = function (componentModel) {
    return this._componentsMap[componentModel.__viewId];
  };
  /**
   * Get view of corresponding series model
   */


  ECharts.prototype.getViewOfSeriesModel = function (seriesModel) {
    return this._chartsMap[seriesModel.__viewId];
  };

  ECharts.prototype._initEvents = function () {
    var _this = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(MOUSE_EVENT_NAMES, function (eveName) {
      var handler = function (e) {
        var ecModel = _this.getModel();

        var el = e.target;
        var params;
        var isGlobalOut = eveName === 'globalout'; // no e.target when 'globalout'.

        if (isGlobalOut) {
          params = {};
        } else {
          el && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__util_event_js__["a" /* findEventDispatcher */])(el, function (parent) {
            var ecData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_innerStore_js__["a" /* getECData */])(parent);

            if (ecData && ecData.dataIndex != null) {
              var dataModel = ecData.dataModel || ecModel.getSeriesByIndex(ecData.seriesIndex);
              params = dataModel && dataModel.getDataParams(ecData.dataIndex, ecData.dataType) || {};
              return true;
            } // If element has custom eventData of components
            else if (ecData.eventData) {
                params = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["extend"])({}, ecData.eventData);
                return true;
              }
          }, true);
        } // Contract: if params prepared in mouse event,
        // these properties must be specified:
        // {
        //    componentType: string (component main type)
        //    componentIndex: number
        // }
        // Otherwise event query can not work.


        if (params) {
          var componentType = params.componentType;
          var componentIndex = params.componentIndex; // Special handling for historic reason: when trigger by
          // markLine/markPoint/markArea, the componentType is
          // 'markLine'/'markPoint'/'markArea', but we should better
          // enable them to be queried by seriesIndex, since their
          // option is set in each series.

          if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
            componentType = 'series';
            componentIndex = params.seriesIndex;
          }

          var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
          var view = model && _this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];

          if (true) {
            // `event.componentType` and `event[componentTpype + 'Index']` must not
            // be missed, otherwise there is no way to distinguish source component.
            // See `dataFormat.getDataParams`.
            if (!isGlobalOut && !(model && view)) {
              console.warn('model or view can not be found by params');
            }
          }

          params.event = e;
          params.type = eveName;
          _this._$eventProcessor.eventInfo = {
            targetEl: el,
            packedEvent: params,
            model: model,
            view: view
          };

          _this.trigger(eveName, params);
        }
      }; // Consider that some component (like tooltip, brush, ...)
      // register zr event handler, but user event handler might
      // do anything, such as call `setOption` or `dispatchAction`,
      // which probably update any of the content and probably
      // cause problem if it is called previous other inner handlers.


      handler.zrEventfulCallAtLast = true;

      _this._zr.on(eveName, handler, _this);
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(eventActionMap, function (actionType, eventType) {
      _this._messageCenter.on(eventType, function (event) {
        this.trigger(eventType, event);
      }, _this);
    }); // Extra events
    // TODO register?

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(['selectchanged'], function (eventType) {
      _this._messageCenter.on(eventType, function (event) {
        this.trigger(eventType, event);
      }, _this);
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__legacy_dataSelectAction_js__["a" /* handleLegacySelectEvents */])(this._messageCenter, this, this._api);
  };

  ECharts.prototype.isDisposed = function () {
    return this._disposed;
  };

  ECharts.prototype.clear = function () {
    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    this.setOption({
      series: []
    }, true);
  };

  ECharts.prototype.dispose = function () {
    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    this._disposed = true;
    var dom = this.getDom();

    if (dom) {
      __WEBPACK_IMPORTED_MODULE_18__util_model_js__["m" /* setAttribute */](this.getDom(), DOM_ATTRIBUTE_KEY, '');
    }

    var chart = this;
    var api = chart._api;
    var ecModel = chart._model;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(chart._componentsViews, function (component) {
      component.dispose(ecModel, api);
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(chart._chartsViews, function (chart) {
      chart.dispose(ecModel, api);
    }); // Dispose after all views disposed

    chart._zr.dispose(); // Set properties to null.
    // To reduce the memory cost in case the top code still holds this instance unexpectedly.


    chart._dom = chart._model = chart._chartsMap = chart._componentsMap = chart._chartsViews = chart._componentsViews = chart._scheduler = chart._api = chart._zr = chart._throttledZrFlush = chart._theme = chart._coordSysMgr = chart._messageCenter = null;
    delete instances[chart.id];
  };
  /**
   * Resize the chart
   */


  ECharts.prototype.resize = function (opts) {
    if (this[IN_MAIN_PROCESS_KEY]) {
      if (true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__util_log_js__["c" /* error */])('`resize` should not be called during main process.');
      }

      return;
    }

    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    this._zr.resize(opts);

    var ecModel = this._model; // Resize loading effect

    this._loadingFX && this._loadingFX.resize();

    if (!ecModel) {
      return;
    }

    var needPrepare = ecModel.resetOption('media');
    var silent = opts && opts.silent; // There is some real cases that:
    // chart.setOption(option, { lazyUpdate: true });
    // chart.resize();

    if (this[PENDING_UPDATE]) {
      if (silent == null) {
        silent = this[PENDING_UPDATE].silent;
      }

      needPrepare = true;
      this[PENDING_UPDATE] = null;
    }

    this[IN_MAIN_PROCESS_KEY] = true;

    try {
      needPrepare && prepare(this);
      updateMethods.update.call(this, {
        type: 'resize',
        animation: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["extend"])({
          // Disable animation
          duration: 0
        }, opts && opts.animation)
      });
    } catch (e) {
      this[IN_MAIN_PROCESS_KEY] = false;
      throw e;
    }

    this[IN_MAIN_PROCESS_KEY] = false;
    flushPendingActions.call(this, silent);
    triggerUpdatedEvent.call(this, silent);
  };

  ECharts.prototype.showLoading = function (name, cfg) {
    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isObject"])(name)) {
      cfg = name;
      name = '';
    }

    name = name || 'default';
    this.hideLoading();

    if (!loadingEffects[name]) {
      if (true) {
        console.warn('Loading effects ' + name + ' not exists.');
      }

      return;
    }

    var el = loadingEffects[name](this._api, cfg);
    var zr = this._zr;
    this._loadingFX = el;
    zr.add(el);
  };
  /**
   * Hide loading effect
   */


  ECharts.prototype.hideLoading = function () {
    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    this._loadingFX && this._zr.remove(this._loadingFX);
    this._loadingFX = null;
  };

  ECharts.prototype.makeActionFromEvent = function (eventObj) {
    var payload = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["extend"])({}, eventObj);
    payload.type = eventActionMap[eventObj.type];
    return payload;
  };
  /**
   * @param opt If pass boolean, means opt.silent
   * @param opt.silent Default `false`. Whether trigger events.
   * @param opt.flush Default `undefined`.
   *        true: Flush immediately, and then pixel in canvas can be fetched
   *            immediately. Caution: it might affect performance.
   *        false: Not flush.
   *        undefined: Auto decide whether perform flush.
   */


  ECharts.prototype.dispatchAction = function (payload, opt) {
    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isObject"])(opt)) {
      opt = {
        silent: !!opt
      };
    }

    if (!actions[payload.type]) {
      return;
    } // Avoid dispatch action before setOption. Especially in `connect`.


    if (!this._model) {
      return;
    } // May dispatchAction in rendering procedure


    if (this[IN_MAIN_PROCESS_KEY]) {
      this._pendingActions.push(payload);

      return;
    }

    var silent = opt.silent;
    doDispatchAction.call(this, payload, silent);
    var flush = opt.flush;

    if (flush) {
      this._zr.flush();
    } else if (flush !== false && __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_env_js__["a" /* default */].browser.weChat) {
      // In WeChat embeded browser, `requestAnimationFrame` and `setInterval`
      // hang when sliding page (on touch event), which cause that zr does not
      // refresh util user interaction finished, which is not expected.
      // But `dispatchAction` may be called too frequently when pan on touch
      // screen, which impacts performance if do not throttle them.
      this._throttledZrFlush();
    }

    flushPendingActions.call(this, silent);
    triggerUpdatedEvent.call(this, silent);
  };

  ECharts.prototype.updateLabelLayout = function () {
    __WEBPACK_IMPORTED_MODULE_35__lifecycle_js__["a" /* default */].trigger('series:layoutlabels', this._model, this._api, {
      // Not adding series labels.
      // TODO
      updatedSeries: []
    });
  };

  ECharts.prototype.appendData = function (params) {
    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    var seriesIndex = params.seriesIndex;
    var ecModel = this.getModel();
    var seriesModel = ecModel.getSeriesByIndex(seriesIndex);

    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["assert"])(params.data && seriesModel);
    }

    seriesModel.appendData(params); // Note: `appendData` does not support that update extent of coordinate
    // system, util some scenario require that. In the expected usage of
    // `appendData`, the initial extent of coordinate system should better
    // be fixed by axis `min`/`max` setting or initial data, otherwise if
    // the extent changed while `appendData`, the location of the painted
    // graphic elements have to be changed, which make the usage of
    // `appendData` meaningless.

    this._scheduler.unfinished = true;
    this.getZr().wakeUp();
  }; // A work around for no `internal` modifier in ts yet but
  // need to strictly hide private methods to JS users.


  ECharts.internalField = function () {
    prepare = function (ecIns) {
      var scheduler = ecIns._scheduler;
      scheduler.restorePipelines(ecIns._model);
      scheduler.prepareStageTasks();
      prepareView(ecIns, true);
      prepareView(ecIns, false);
      scheduler.plan();
    };
    /**
     * Prepare view instances of charts and components
     */


    prepareView = function (ecIns, isComponent) {
      var ecModel = ecIns._model;
      var scheduler = ecIns._scheduler;
      var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
      var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
      var zr = ecIns._zr;
      var api = ecIns._api;

      for (var i = 0; i < viewList.length; i++) {
        viewList[i].__alive = false;
      }

      isComponent ? ecModel.eachComponent(function (componentType, model) {
        componentType !== 'series' && doPrepare(model);
      }) : ecModel.eachSeries(doPrepare);

      function doPrepare(model) {
        // By defaut view will be reused if possible for the case that `setOption` with "notMerge"
        // mode and need to enable transition animation. (Usually, when they have the same id, or
        // especially no id but have the same type & name & index. See the `model.id` generation
        // rule in `makeIdAndName` and `viewId` generation rule here).
        // But in `replaceMerge` mode, this feature should be able to disabled when it is clear that
        // the new model has nothing to do with the old model.
        var requireNewView = model.__requireNewView; // This command should not work twice.

        model.__requireNewView = false; // Consider: id same and type changed.

        var viewId = '_ec_' + model.id + '_' + model.type;
        var view = !requireNewView && viewMap[viewId];

        if (!view) {
          var classType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__util_clazz_js__["f" /* parseClassType */])(model.type);
          var Clazz = isComponent ? __WEBPACK_IMPORTED_MODULE_13__view_Component_js__["a" /* default */].getClass(classType.main, classType.sub) : // FIXME:TS
          // (ChartView as ChartViewConstructor).getClass('series', classType.sub)
          // For backward compat, still support a chart type declared as only subType
          // like "liquidfill", but recommend "series.liquidfill"
          // But need a base class to make a type series.
          __WEBPACK_IMPORTED_MODULE_14__view_Chart_js__["a" /* default */].getClass(classType.sub);

          if (true) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["assert"])(Clazz, classType.sub + ' does not exist.');
          }

          view = new Clazz();
          view.init(ecModel, api);
          viewMap[viewId] = view;
          viewList.push(view);
          zr.add(view.group);
        }

        model.__viewId = view.__id = viewId;
        view.__alive = true;
        view.__model = model;
        view.group.__ecComponentInfo = {
          mainType: model.mainType,
          index: model.componentIndex
        };
        !isComponent && scheduler.prepareView(view, model, ecModel, api);
      }

      for (var i = 0; i < viewList.length;) {
        var view = viewList[i];

        if (!view.__alive) {
          !isComponent && view.renderTask.dispose();
          zr.remove(view.group);
          view.dispose(ecModel, api);
          viewList.splice(i, 1);

          if (viewMap[view.__id] === view) {
            delete viewMap[view.__id];
          }

          view.__id = view.group.__ecComponentInfo = null;
        } else {
          i++;
        }
      }
    };

    updateDirectly = function (ecIns, method, payload, mainType, subType) {
      var ecModel = ecIns._model;
      ecModel.setUpdatePayload(payload); // broadcast

      if (!mainType) {
        // FIXME
        // Chart will not be update directly here, except set dirty.
        // But there is no such scenario now.
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])([].concat(ecIns._componentsViews).concat(ecIns._chartsViews), callView);
        return;
      }

      var query = {};
      query[mainType + 'Id'] = payload[mainType + 'Id'];
      query[mainType + 'Index'] = payload[mainType + 'Index'];
      query[mainType + 'Name'] = payload[mainType + 'Name'];
      var condition = {
        mainType: mainType,
        query: query
      };
      subType && (condition.subType = subType); // subType may be '' by parseClassType;

      var excludeSeriesId = payload.excludeSeriesId;
      var excludeSeriesIdMap;

      if (excludeSeriesId != null) {
        excludeSeriesIdMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["createHashMap"])();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(__WEBPACK_IMPORTED_MODULE_18__util_model_js__["d" /* normalizeToArray */](excludeSeriesId), function (id) {
          var modelId = __WEBPACK_IMPORTED_MODULE_18__util_model_js__["n" /* convertOptionIdName */](id, null);

          if (modelId != null) {
            excludeSeriesIdMap.set(modelId, true);
          }
        });
      } // If dispatchAction before setOption, do nothing.


      ecModel && ecModel.eachComponent(condition, function (model) {
        var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) !== null;

        if (isExcluded) {
          return;
        }

        ;

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["e" /* isHighDownPayload */])(payload)) {
          if (model instanceof __WEBPACK_IMPORTED_MODULE_12__model_Series_js__["b" /* default */]) {
            if (payload.type === __WEBPACK_IMPORTED_MODULE_17__util_states_js__["f" /* HIGHLIGHT_ACTION_TYPE */] && !payload.notBlur && !model.get(['emphasis', 'disabled'])) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["g" /* blurSeriesFromHighlightPayload */])(model, payload, ecIns._api);
            }
          } else {
            var _a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["h" /* findComponentHighDownDispatchers */])(model.mainType, model.componentIndex, payload.name, ecIns._api),
                focusSelf = _a.focusSelf,
                dispatchers = _a.dispatchers;

            if (payload.type === __WEBPACK_IMPORTED_MODULE_17__util_states_js__["f" /* HIGHLIGHT_ACTION_TYPE */] && focusSelf && !payload.notBlur) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["i" /* blurComponent */])(model.mainType, model.componentIndex, ecIns._api);
            } // PENDING:
            // Whether to put this "enter emphasis" code in `ComponentView`,
            // which will be the same as `ChartView` but might be not necessary
            // and will be far from this logic.


            if (dispatchers) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(dispatchers, function (dispatcher) {
                payload.type === __WEBPACK_IMPORTED_MODULE_17__util_states_js__["f" /* HIGHLIGHT_ACTION_TYPE */] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["j" /* enterEmphasis */])(dispatcher) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["k" /* leaveEmphasis */])(dispatcher);
              });
            }
          }
        } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["l" /* isSelectChangePayload */])(payload)) {
          // TODO geo
          if (model instanceof __WEBPACK_IMPORTED_MODULE_12__model_Series_js__["b" /* default */]) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["m" /* toggleSelectionFromPayload */])(model, payload, ecIns._api);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["n" /* updateSeriesElementSelection */])(model);
            markStatusToUpdate(ecIns);
          }
        }
      }, ecIns);
      ecModel && ecModel.eachComponent(condition, function (model) {
        var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) !== null;

        if (isExcluded) {
          return;
        }

        ;
        callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
      }, ecIns);

      function callView(view) {
        view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
      }
    };

    updateMethods = {
      prepareAndUpdate: function (payload) {
        prepare(this);
        updateMethods.update.call(this, payload, {
          // Needs to mark option changed if newOption is given.
          // It's from MagicType.
          // TODO If use a separate flag optionChanged in payload?
          optionChanged: payload.newOption != null
        });
      },
      update: function (payload, updateParams) {
        var ecModel = this._model;
        var api = this._api;
        var zr = this._zr;
        var coordSysMgr = this._coordSysMgr;
        var scheduler = this._scheduler; // update before setOption

        if (!ecModel) {
          return;
        }

        ecModel.setUpdatePayload(payload);
        scheduler.restoreData(ecModel, payload);
        scheduler.performSeriesTasks(ecModel); // TODO
        // Save total ecModel here for undo/redo (after restoring data and before processing data).
        // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
        // Create new coordinate system each update
        // In LineView may save the old coordinate system and use it to get the orignal point

        coordSysMgr.create(ecModel, api);
        scheduler.performDataProcessorTasks(ecModel, payload); // Current stream render is not supported in data process. So we can update
        // stream modes after data processing, where the filtered data is used to
        // deteming whether use progressive rendering.

        updateStreamModes(this, ecModel); // We update stream modes before coordinate system updated, then the modes info
        // can be fetched when coord sys updating (consider the barGrid extent fix). But
        // the drawback is the full coord info can not be fetched. Fortunately this full
        // coord is not requied in stream mode updater currently.

        coordSysMgr.update(ecModel, api);
        clearColorPalette(ecModel);
        scheduler.performVisualTasks(ecModel, payload);
        render(this, ecModel, api, payload, updateParams); // Set background

        var backgroundColor = ecModel.get('backgroundColor') || 'transparent';
        var darkMode = ecModel.get('darkMode');
        zr.setBackgroundColor(backgroundColor); // Force set dark mode.

        if (darkMode != null && darkMode !== 'auto') {
          zr.setDarkMode(darkMode);
        }

        __WEBPACK_IMPORTED_MODULE_35__lifecycle_js__["a" /* default */].trigger('afterupdate', ecModel, api);
      },
      updateTransform: function (payload) {
        var _this = this;

        var ecModel = this._model;
        var api = this._api; // update before setOption

        if (!ecModel) {
          return;
        }

        ecModel.setUpdatePayload(payload); // ChartView.markUpdateMethod(payload, 'updateTransform');

        var componentDirtyList = [];
        ecModel.eachComponent(function (componentType, componentModel) {
          if (componentType === 'series') {
            return;
          }

          var componentView = _this.getViewOfComponentModel(componentModel);

          if (componentView && componentView.__alive) {
            if (componentView.updateTransform) {
              var result = componentView.updateTransform(componentModel, ecModel, api, payload);
              result && result.update && componentDirtyList.push(componentView);
            } else {
              componentDirtyList.push(componentView);
            }
          }
        });
        var seriesDirtyMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["createHashMap"])();
        ecModel.eachSeries(function (seriesModel) {
          var chartView = _this._chartsMap[seriesModel.__viewId];

          if (chartView.updateTransform) {
            var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
            result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
          } else {
            seriesDirtyMap.set(seriesModel.uid, 1);
          }
        });
        clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
        // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);

        this._scheduler.performVisualTasks(ecModel, payload, {
          setDirty: true,
          dirtyMap: seriesDirtyMap
        }); // Currently, not call render of components. Geo render cost a lot.
        // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);


        renderSeries(this, ecModel, api, payload, {}, seriesDirtyMap);
        __WEBPACK_IMPORTED_MODULE_35__lifecycle_js__["a" /* default */].trigger('afterupdate', ecModel, api);
      },
      updateView: function (payload) {
        var ecModel = this._model; // update before setOption

        if (!ecModel) {
          return;
        }

        ecModel.setUpdatePayload(payload);
        __WEBPACK_IMPORTED_MODULE_14__view_Chart_js__["a" /* default */].markUpdateMethod(payload, 'updateView');
        clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.

        this._scheduler.performVisualTasks(ecModel, payload, {
          setDirty: true
        });

        render(this, ecModel, this._api, payload, {});
        __WEBPACK_IMPORTED_MODULE_35__lifecycle_js__["a" /* default */].trigger('afterupdate', ecModel, this._api);
      },
      updateVisual: function (payload) {
        // updateMethods.update.call(this, payload);
        var _this = this;

        var ecModel = this._model; // update before setOption

        if (!ecModel) {
          return;
        }

        ecModel.setUpdatePayload(payload); // clear all visual

        ecModel.eachSeries(function (seriesModel) {
          seriesModel.getData().clearAllVisual();
        }); // Perform visual

        __WEBPACK_IMPORTED_MODULE_14__view_Chart_js__["a" /* default */].markUpdateMethod(payload, 'updateVisual');
        clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.

        this._scheduler.performVisualTasks(ecModel, payload, {
          visualType: 'visual',
          setDirty: true
        });

        ecModel.eachComponent(function (componentType, componentModel) {
          if (componentType !== 'series') {
            var componentView = _this.getViewOfComponentModel(componentModel);

            componentView && componentView.__alive && componentView.updateVisual(componentModel, ecModel, _this._api, payload);
          }
        });
        ecModel.eachSeries(function (seriesModel) {
          var chartView = _this._chartsMap[seriesModel.__viewId];
          chartView.updateVisual(seriesModel, ecModel, _this._api, payload);
        });
        __WEBPACK_IMPORTED_MODULE_35__lifecycle_js__["a" /* default */].trigger('afterupdate', ecModel, this._api);
      },
      updateLayout: function (payload) {
        updateMethods.update.call(this, payload);
      }
    };

    doConvertPixel = function (ecIns, methodName, finder, value) {
      if (ecIns._disposed) {
        disposedWarning(ecIns.id);
        return;
      }

      var ecModel = ecIns._model;

      var coordSysList = ecIns._coordSysMgr.getCoordinateSystems();

      var result;
      var parsedFinder = __WEBPACK_IMPORTED_MODULE_18__util_model_js__["l" /* parseFinder */](ecModel, finder);

      for (var i = 0; i < coordSysList.length; i++) {
        var coordSys = coordSysList[i];

        if (coordSys[methodName] && (result = coordSys[methodName](ecModel, parsedFinder, value)) != null) {
          return result;
        }
      }

      if (true) {
        console.warn('No coordinate system that supports ' + methodName + ' found by the given finder.');
      }
    };

    updateStreamModes = function (ecIns, ecModel) {
      var chartsMap = ecIns._chartsMap;
      var scheduler = ecIns._scheduler;
      ecModel.eachSeries(function (seriesModel) {
        scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
      });
    };

    doDispatchAction = function (payload, silent) {
      var _this = this;

      var ecModel = this.getModel();
      var payloadType = payload.type;
      var escapeConnect = payload.escapeConnect;
      var actionWrap = actions[payloadType];
      var actionInfo = actionWrap.actionInfo;
      var cptTypeTmp = (actionInfo.update || 'update').split(':');
      var updateMethod = cptTypeTmp.pop();
      var cptType = cptTypeTmp[0] != null && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__util_clazz_js__["f" /* parseClassType */])(cptTypeTmp[0]);
      this[IN_MAIN_PROCESS_KEY] = true;
      var payloads = [payload];
      var batched = false; // Batch action

      if (payload.batch) {
        batched = true;
        payloads = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["map"])(payload.batch, function (item) {
          item = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["defaults"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["extend"])({}, item), payload);
          item.batch = null;
          return item;
        });
      }

      var eventObjBatch = [];
      var eventObj;
      var isSelectChange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["l" /* isSelectChangePayload */])(payload);
      var isHighDown = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["e" /* isHighDownPayload */])(payload); // Only leave blur once if there are multiple batches.

      if (isHighDown) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["o" /* allLeaveBlur */])(this._api);
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(payloads, function (batchItem) {
        // Action can specify the event by return it.
        eventObj = actionWrap.action(batchItem, _this._model, _this._api); // Emit event outside

        eventObj = eventObj || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["extend"])({}, batchItem); // Convert type to eventType

        eventObj.type = actionInfo.event || eventObj.type;
        eventObjBatch.push(eventObj); // light update does not perform data process, layout and visual.

        if (isHighDown) {
          var _a = __WEBPACK_IMPORTED_MODULE_18__util_model_js__["o" /* preParseFinder */](payload),
              queryOptionMap = _a.queryOptionMap,
              mainTypeSpecified = _a.mainTypeSpecified;

          var componentMainType = mainTypeSpecified ? queryOptionMap.keys()[0] : 'series';
          updateDirectly(_this, updateMethod, batchItem, componentMainType);
          markStatusToUpdate(_this);
        } else if (isSelectChange) {
          // At present `dispatchAction({ type: 'select', ... })` is not supported on components.
          // geo still use 'geoselect'.
          updateDirectly(_this, updateMethod, batchItem, 'series');
          markStatusToUpdate(_this);
        } else if (cptType) {
          updateDirectly(_this, updateMethod, batchItem, cptType.main, cptType.sub);
        }
      });

      if (updateMethod !== 'none' && !isHighDown && !isSelectChange && !cptType) {
        try {
          // Still dirty
          if (this[PENDING_UPDATE]) {
            prepare(this);
            updateMethods.update.call(this, payload);
            this[PENDING_UPDATE] = null;
          } else {
            updateMethods[updateMethod].call(this, payload);
          }
        } catch (e) {
          this[IN_MAIN_PROCESS_KEY] = false;
          throw e;
        }
      } // Follow the rule of action batch


      if (batched) {
        eventObj = {
          type: actionInfo.event || payloadType,
          escapeConnect: escapeConnect,
          batch: eventObjBatch
        };
      } else {
        eventObj = eventObjBatch[0];
      }

      this[IN_MAIN_PROCESS_KEY] = false;

      if (!silent) {
        var messageCenter = this._messageCenter;
        messageCenter.trigger(eventObj.type, eventObj); // Extra triggered 'selectchanged' event

        if (isSelectChange) {
          var newObj = {
            type: 'selectchanged',
            escapeConnect: escapeConnect,
            selected: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["p" /* getAllSelectedIndices */])(ecModel),
            isFromClick: payload.isFromClick || false,
            fromAction: payload.type,
            fromActionPayload: payload
          };
          messageCenter.trigger(newObj.type, newObj);
        }
      }
    };

    flushPendingActions = function (silent) {
      var pendingActions = this._pendingActions;

      while (pendingActions.length) {
        var payload = pendingActions.shift();
        doDispatchAction.call(this, payload, silent);
      }
    };

    triggerUpdatedEvent = function (silent) {
      !silent && this.trigger('updated');
    };
    /**
     * Event `rendered` is triggered when zr
     * rendered. It is useful for realtime
     * snapshot (reflect animation).
     *
     * Event `finished` is triggered when:
     * (1) zrender rendering finished.
     * (2) initial animation finished.
     * (3) progressive rendering finished.
     * (4) no pending action.
     * (5) no delayed setOption needs to be processed.
     */


    bindRenderedEvent = function (zr, ecIns) {
      zr.on('rendered', function (params) {
        ecIns.trigger('rendered', params); // The `finished` event should not be triggered repeatly,
        // so it should only be triggered when rendering indeed happend
        // in zrender. (Consider the case that dipatchAction is keep
        // triggering when mouse move).

        if ( // Although zr is dirty if initial animation is not finished
        // and this checking is called on frame, we also check
        // animation finished for robustness.
        zr.animation.isFinished() && !ecIns[PENDING_UPDATE] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) {
          ecIns.trigger('finished');
        }
      });
    };

    bindMouseEvent = function (zr, ecIns) {
      zr.on('mouseover', function (e) {
        var el = e.target;
        var dispatcher = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__util_event_js__["a" /* findEventDispatcher */])(el, __WEBPACK_IMPORTED_MODULE_17__util_states_js__["q" /* isHighDownDispatcher */]);

        if (dispatcher) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["r" /* handleGlobalMouseOverForHighDown */])(dispatcher, e, ecIns._api);
          markStatusToUpdate(ecIns);
        }
      }).on('mouseout', function (e) {
        var el = e.target;
        var dispatcher = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__util_event_js__["a" /* findEventDispatcher */])(el, __WEBPACK_IMPORTED_MODULE_17__util_states_js__["q" /* isHighDownDispatcher */]);

        if (dispatcher) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["s" /* handleGlobalMouseOutForHighDown */])(dispatcher, e, ecIns._api);
          markStatusToUpdate(ecIns);
        }
      }).on('click', function (e) {
        var el = e.target;
        var dispatcher = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_33__util_event_js__["a" /* findEventDispatcher */])(el, function (target) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_innerStore_js__["a" /* getECData */])(target).dataIndex != null;
        }, true);

        if (dispatcher) {
          var actionType = dispatcher.selected ? 'unselect' : 'select';
          var ecData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_innerStore_js__["a" /* getECData */])(dispatcher);

          ecIns._api.dispatchAction({
            type: actionType,
            dataType: ecData.dataType,
            dataIndexInside: ecData.dataIndex,
            seriesIndex: ecData.seriesIndex,
            isFromClick: true
          });
        }
      });
    };

    function clearColorPalette(ecModel) {
      ecModel.clearColorPalette();
      ecModel.eachSeries(function (seriesModel) {
        seriesModel.clearColorPalette();
      });
    }

    ; // Allocate zlevels for series and components

    function allocateZlevels(ecModel) {
      ;
      var componentZLevels = [];
      var seriesZLevels = [];
      var hasSeperateZLevel = false;
      ecModel.eachComponent(function (componentType, componentModel) {
        var zlevel = componentModel.get('zlevel') || 0;
        var z = componentModel.get('z') || 0;
        var zlevelKey = componentModel.getZLevelKey();
        hasSeperateZLevel = hasSeperateZLevel || !!zlevelKey;
        (componentType === 'series' ? seriesZLevels : componentZLevels).push({
          zlevel: zlevel,
          z: z,
          idx: componentModel.componentIndex,
          type: componentType,
          key: zlevelKey
        });
      });

      if (hasSeperateZLevel) {
        // Series after component
        var zLevels = componentZLevels.concat(seriesZLevels);
        var lastSeriesZLevel_1;
        var lastSeriesKey_1;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_timsort_js__["a" /* default */])(zLevels, function (a, b) {
          if (a.zlevel === b.zlevel) {
            return a.z - b.z;
          }

          return a.zlevel - b.zlevel;
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(zLevels, function (item) {
          var componentModel = ecModel.getComponent(item.type, item.idx);
          var zlevel = item.zlevel;
          var key = item.key;

          if (lastSeriesZLevel_1 != null) {
            zlevel = Math.max(lastSeriesZLevel_1, zlevel);
          }

          if (key) {
            if (zlevel === lastSeriesZLevel_1 && key !== lastSeriesKey_1) {
              zlevel++;
            }

            lastSeriesKey_1 = key;
          } else if (lastSeriesKey_1) {
            if (zlevel === lastSeriesZLevel_1) {
              zlevel++;
            }

            lastSeriesKey_1 = '';
          }

          lastSeriesZLevel_1 = zlevel;
          componentModel.setZLevel(zlevel);
        });
      }
    }

    render = function (ecIns, ecModel, api, payload, updateParams) {
      allocateZlevels(ecModel);
      renderComponents(ecIns, ecModel, api, payload, updateParams);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(ecIns._chartsViews, function (chart) {
        chart.__alive = false;
      });
      renderSeries(ecIns, ecModel, api, payload, updateParams); // Remove groups of unrendered charts

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(ecIns._chartsViews, function (chart) {
        if (!chart.__alive) {
          chart.remove(ecModel, api);
        }
      });
    };

    renderComponents = function (ecIns, ecModel, api, payload, updateParams, dirtyList) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(dirtyList || ecIns._componentsViews, function (componentView) {
        var componentModel = componentView.__model;
        clearStates(componentModel, componentView);
        componentView.render(componentModel, ecModel, api, payload);
        updateZ(componentModel, componentView);
        updateStates(componentModel, componentView);
      });
    };
    /**
     * Render each chart and component
     */


    renderSeries = function (ecIns, ecModel, api, payload, updateParams, dirtyMap) {
      // Render all charts
      var scheduler = ecIns._scheduler;
      updateParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["extend"])(updateParams || {}, {
        updatedSeries: ecModel.getSeries()
      }); // TODO progressive?

      __WEBPACK_IMPORTED_MODULE_35__lifecycle_js__["a" /* default */].trigger('series:beforeupdate', ecModel, api, updateParams);
      var unfinished = false;
      ecModel.eachSeries(function (seriesModel) {
        var chartView = ecIns._chartsMap[seriesModel.__viewId];
        chartView.__alive = true;
        var renderTask = chartView.renderTask;
        scheduler.updatePayload(renderTask, payload); // TODO states on marker.

        clearStates(seriesModel, chartView);

        if (dirtyMap && dirtyMap.get(seriesModel.uid)) {
          renderTask.dirty();
        }

        if (renderTask.perform(scheduler.getPerformArgs(renderTask))) {
          unfinished = true;
        }

        chartView.group.silent = !!seriesModel.get('silent'); // Should not call markRedraw on group, because it will disable zrender
        // increamental render (alway render from the __startIndex each frame)
        // chartView.group.markRedraw();

        updateBlend(seriesModel, chartView);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["n" /* updateSeriesElementSelection */])(seriesModel);
      });
      scheduler.unfinished = unfinished || scheduler.unfinished;
      __WEBPACK_IMPORTED_MODULE_35__lifecycle_js__["a" /* default */].trigger('series:layoutlabels', ecModel, api, updateParams); // transition after label is layouted.

      __WEBPACK_IMPORTED_MODULE_35__lifecycle_js__["a" /* default */].trigger('series:transition', ecModel, api, updateParams);
      ecModel.eachSeries(function (seriesModel) {
        var chartView = ecIns._chartsMap[seriesModel.__viewId]; // Update Z after labels updated. Before applying states.

        updateZ(seriesModel, chartView); // NOTE: Update states after label is updated.
        // label should be in normal status when layouting.

        updateStates(seriesModel, chartView);
      }); // If use hover layer

      updateHoverLayerStatus(ecIns, ecModel);
      __WEBPACK_IMPORTED_MODULE_35__lifecycle_js__["a" /* default */].trigger('series:afterupdate', ecModel, api, updateParams);
    };

    markStatusToUpdate = function (ecIns) {
      ecIns[STATUS_NEEDS_UPDATE_KEY] = true; // Wake up zrender if it's sleep. Let it update states in the next frame.

      ecIns.getZr().wakeUp();
    };

    applyChangedStates = function (ecIns) {
      if (!ecIns[STATUS_NEEDS_UPDATE_KEY]) {
        return;
      }

      ecIns.getZr().storage.traverse(function (el) {
        // Not applied on removed elements, it may still in fading.
        if (__WEBPACK_IMPORTED_MODULE_15__util_graphic_js__["isElementRemoved"](el)) {
          return;
        }

        applyElementStates(el);
      });
      ecIns[STATUS_NEEDS_UPDATE_KEY] = false;
    };

    function applyElementStates(el) {
      var newStates = [];
      var oldStates = el.currentStates; // Keep other states.

      for (var i = 0; i < oldStates.length; i++) {
        var stateName = oldStates[i];

        if (!(stateName === 'emphasis' || stateName === 'blur' || stateName === 'select')) {
          newStates.push(stateName);
        }
      } // Only use states when it's exists.


      if (el.selected && el.states.select) {
        newStates.push('select');
      }

      if (el.hoverState === __WEBPACK_IMPORTED_MODULE_17__util_states_js__["t" /* HOVER_STATE_EMPHASIS */] && el.states.emphasis) {
        newStates.push('emphasis');
      } else if (el.hoverState === __WEBPACK_IMPORTED_MODULE_17__util_states_js__["u" /* HOVER_STATE_BLUR */] && el.states.blur) {
        newStates.push('blur');
      }

      el.useStates(newStates);
    }

    function updateHoverLayerStatus(ecIns, ecModel) {
      var zr = ecIns._zr;
      var storage = zr.storage;
      var elCount = 0;
      storage.traverse(function (el) {
        if (!el.isGroup) {
          elCount++;
        }
      });

      if (elCount > ecModel.get('hoverLayerThreshold') && !__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_env_js__["a" /* default */].node && !__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_env_js__["a" /* default */].worker) {
        ecModel.eachSeries(function (seriesModel) {
          if (seriesModel.preventUsingHoverLayer) {
            return;
          }

          var chartView = ecIns._chartsMap[seriesModel.__viewId];

          if (chartView.__alive) {
            chartView.eachRendered(function (el) {
              if (el.states.emphasis) {
                el.states.emphasis.hoverLayer = true;
              }
            });
          }
        });
      }
    }

    ;
    /**
     * Update chart and blend.
     */

    function updateBlend(seriesModel, chartView) {
      var blendMode = seriesModel.get('blendMode') || null;
      chartView.eachRendered(function (el) {
        // FIXME marker and other components
        if (!el.isGroup) {
          // DONT mark the element dirty. In case element is incremental and don't wan't to rerender.
          el.style.blend = blendMode;
        }
      });
    }

    ;

    function updateZ(model, view) {
      if (model.preventAutoZ) {
        return;
      }

      var z = model.get('z') || 0;
      var zlevel = model.get('zlevel') || 0; // Set z and zlevel

      view.eachRendered(function (el) {
        doUpdateZ(el, z, zlevel, -Infinity); // Don't traverse the children because it has been traversed in _updateZ.

        return true;
      });
    }

    ;

    function doUpdateZ(el, z, zlevel, maxZ2) {
      // Group may also have textContent
      var label = el.getTextContent();
      var labelLine = el.getTextGuideLine();
      var isGroup = el.isGroup;

      if (isGroup) {
        // set z & zlevel of children elements of Group
        var children = el.childrenRef();

        for (var i = 0; i < children.length; i++) {
          maxZ2 = Math.max(doUpdateZ(children[i], z, zlevel, maxZ2), maxZ2);
        }
      } else {
        // not Group
        el.z = z;
        el.zlevel = zlevel;
        maxZ2 = Math.max(el.z2, maxZ2);
      } // always set z and zlevel if label/labelLine exists


      if (label) {
        label.z = z;
        label.zlevel = zlevel; // lift z2 of text content
        // TODO if el.emphasis.z2 is spcefied, what about textContent.

        isFinite(maxZ2) && (label.z2 = maxZ2 + 2);
      }

      if (labelLine) {
        var textGuideLineConfig = el.textGuideLineConfig;
        labelLine.z = z;
        labelLine.zlevel = zlevel;
        isFinite(maxZ2) && (labelLine.z2 = maxZ2 + (textGuideLineConfig && textGuideLineConfig.showAbove ? 1 : -1));
      }

      return maxZ2;
    } // Clear states without animation.
    // TODO States on component.


    function clearStates(model, view) {
      view.eachRendered(function (el) {
        // Not applied on removed elements, it may still in fading.
        if (__WEBPACK_IMPORTED_MODULE_15__util_graphic_js__["isElementRemoved"](el)) {
          return;
        }

        var textContent = el.getTextContent();
        var textGuide = el.getTextGuideLine();

        if (el.stateTransition) {
          el.stateTransition = null;
        }

        if (textContent && textContent.stateTransition) {
          textContent.stateTransition = null;
        }

        if (textGuide && textGuide.stateTransition) {
          textGuide.stateTransition = null;
        } // TODO If el is incremental.


        if (el.hasState()) {
          el.prevStates = el.currentStates;
          el.clearStates();
        } else if (el.prevStates) {
          el.prevStates = null;
        }
      });
    }

    function updateStates(model, view) {
      var stateAnimationModel = model.getModel('stateAnimation');
      var enableAnimation = model.isAnimationEnabled();
      var duration = stateAnimationModel.get('duration');
      var stateTransition = duration > 0 ? {
        duration: duration,
        delay: stateAnimationModel.get('delay'),
        easing: stateAnimationModel.get('easing') // additive: stateAnimationModel.get('additive')

      } : null;
      view.eachRendered(function (el) {
        if (el.states && el.states.emphasis) {
          // Not applied on removed elements, it may still in fading.
          if (__WEBPACK_IMPORTED_MODULE_15__util_graphic_js__["isElementRemoved"](el)) {
            return;
          }

          if (el instanceof __WEBPACK_IMPORTED_MODULE_15__util_graphic_js__["Path"]) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["v" /* savePathStates */])(el);
          } // Only updated on changed element. In case element is incremental and don't wan't to rerender.
          // TODO, a more proper way?


          if (el.__dirty) {
            var prevStates = el.prevStates; // Restore states without animation

            if (prevStates) {
              el.useStates(prevStates);
            }
          } // Update state transition and enable animation again.


          if (enableAnimation) {
            el.stateTransition = stateTransition;
            var textContent = el.getTextContent();
            var textGuide = el.getTextGuideLine(); // TODO Is it necessary to animate label?

            if (textContent) {
              textContent.stateTransition = stateTransition;
            }

            if (textGuide) {
              textGuide.stateTransition = stateTransition;
            }
          } // The use higlighted and selected flag to toggle states.


          if (el.__dirty) {
            applyElementStates(el);
          }
        }
      });
    }

    ;

    createExtensionAPI = function (ecIns) {
      return new (
      /** @class */
      function (_super) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(class_1, _super);

        function class_1() {
          return _super !== null && _super.apply(this, arguments) || this;
        }

        class_1.prototype.getCoordinateSystems = function () {
          return ecIns._coordSysMgr.getCoordinateSystems();
        };

        class_1.prototype.getComponentByElement = function (el) {
          while (el) {
            var modelInfo = el.__ecComponentInfo;

            if (modelInfo != null) {
              return ecIns._model.getComponent(modelInfo.mainType, modelInfo.index);
            }

            el = el.parent;
          }
        };

        class_1.prototype.enterEmphasis = function (el, highlightDigit) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["j" /* enterEmphasis */])(el, highlightDigit);
          markStatusToUpdate(ecIns);
        };

        class_1.prototype.leaveEmphasis = function (el, highlightDigit) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["k" /* leaveEmphasis */])(el, highlightDigit);
          markStatusToUpdate(ecIns);
        };

        class_1.prototype.enterBlur = function (el) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["w" /* enterBlur */])(el);
          markStatusToUpdate(ecIns);
        };

        class_1.prototype.leaveBlur = function (el) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["x" /* leaveBlur */])(el);
          markStatusToUpdate(ecIns);
        };

        class_1.prototype.enterSelect = function (el) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["y" /* enterSelect */])(el);
          markStatusToUpdate(ecIns);
        };

        class_1.prototype.leaveSelect = function (el) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["z" /* leaveSelect */])(el);
          markStatusToUpdate(ecIns);
        };

        class_1.prototype.getModel = function () {
          return ecIns.getModel();
        };

        class_1.prototype.getViewOfComponentModel = function (componentModel) {
          return ecIns.getViewOfComponentModel(componentModel);
        };

        class_1.prototype.getViewOfSeriesModel = function (seriesModel) {
          return ecIns.getViewOfSeriesModel(seriesModel);
        };

        return class_1;
      }(__WEBPACK_IMPORTED_MODULE_7__ExtensionAPI_js__["a" /* default */]))(ecIns);
    };

    enableConnect = function (chart) {
      function updateConnectedChartsStatus(charts, status) {
        for (var i = 0; i < charts.length; i++) {
          var otherChart = charts[i];
          otherChart[CONNECT_STATUS_KEY] = status;
        }
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(eventActionMap, function (actionType, eventType) {
        chart._messageCenter.on(eventType, function (event) {
          if (connectedGroups[chart.group] && chart[CONNECT_STATUS_KEY] !== CONNECT_STATUS_PENDING) {
            if (event && event.escapeConnect) {
              return;
            }

            var action_1 = chart.makeActionFromEvent(event);
            var otherCharts_1 = [];
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(instances, function (otherChart) {
              if (otherChart !== chart && otherChart.group === chart.group) {
                otherCharts_1.push(otherChart);
              }
            });
            updateConnectedChartsStatus(otherCharts_1, CONNECT_STATUS_PENDING);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(otherCharts_1, function (otherChart) {
              if (otherChart[CONNECT_STATUS_KEY] !== CONNECT_STATUS_UPDATING) {
                otherChart.dispatchAction(action_1);
              }
            });
            updateConnectedChartsStatus(otherCharts_1, CONNECT_STATUS_UPDATED);
          }
        });
      });
    };
  }();

  return ECharts;
}(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_Eventful_js__["a" /* default */]);

var echartsProto = ECharts.prototype;
echartsProto.on = createRegisterEventWithLowercaseECharts('on');
echartsProto.off = createRegisterEventWithLowercaseECharts('off');
/**
 * @deprecated
 */
// @ts-ignore

echartsProto.one = function (eventName, cb, ctx) {
  var self = this;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__util_log_js__["g" /* deprecateLog */])('ECharts#one is deprecated.');

  function wrapped() {
    var args2 = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args2[_i] = arguments[_i];
    }

    cb && cb.apply && cb.apply(this, args2); // @ts-ignore

    self.off(eventName, wrapped);
  }

  ; // @ts-ignore

  this.on.call(this, eventName, wrapped, ctx);
};

var MOUSE_EVENT_NAMES = ['click', 'dblclick', 'mouseover', 'mouseout', 'mousemove', 'mousedown', 'mouseup', 'globalout', 'contextmenu'];

function disposedWarning(id) {
  if (true) {
    console.warn('Instance ' + id + ' has been disposed');
  }
}

var actions = {};
/**
 * Map eventType to actionType
 */

var eventActionMap = {};
var dataProcessorFuncs = [];
var optionPreprocessorFuncs = [];
var visualFuncs = [];
var themeStorage = {};
var loadingEffects = {};
var instances = {};
var connectedGroups = {};
var idBase = +new Date() - 0;
var groupIdBase = +new Date() - 0;
var DOM_ATTRIBUTE_KEY = '_echarts_instance_';
/**
 * @param opts.devicePixelRatio Use window.devicePixelRatio by default
 * @param opts.renderer Can choose 'canvas' or 'svg' to render the chart.
 * @param opts.width Use clientWidth of the input `dom` by default.
 *        Can be 'auto' (the same as null/undefined)
 * @param opts.height Use clientHeight of the input `dom` by default.
 *        Can be 'auto' (the same as null/undefined)
 * @param opts.locale Specify the locale.
 * @param opts.useDirtyRect Enable dirty rectangle rendering or not.
 */

function init(dom, theme, opts) {
  var isClient = !(opts && opts.ssr);

  if (isClient) {
    if (true) {
      if (!dom) {
        throw new Error('Initialize failed: invalid dom.');
      }
    }

    var existInstance = getInstanceByDom(dom);

    if (existInstance) {
      if (true) {
        console.warn('There is a chart instance already initialized on the dom.');
      }

      return existInstance;
    }

    if (true) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isDom"])(dom) && dom.nodeName.toUpperCase() !== 'CANVAS' && (!dom.clientWidth && (!opts || opts.width == null) || !dom.clientHeight && (!opts || opts.height == null))) {
        console.warn('Can\'t get DOM width or height. Please check ' + 'dom.clientWidth and dom.clientHeight. They should not be 0.' + 'For example, you may need to call this in the callback ' + 'of window.onload.');
      }
    }
  }

  var chart = new ECharts(dom, theme, opts);
  chart.id = 'ec_' + idBase++;
  instances[chart.id] = chart;
  isClient && __WEBPACK_IMPORTED_MODULE_18__util_model_js__["m" /* setAttribute */](dom, DOM_ATTRIBUTE_KEY, chart.id);
  enableConnect(chart);
  __WEBPACK_IMPORTED_MODULE_35__lifecycle_js__["a" /* default */].trigger('afterinit', chart);
  return chart;
}
/**
 * @usage
 * (A)
 * ```js
 * let chart1 = echarts.init(dom1);
 * let chart2 = echarts.init(dom2);
 * chart1.group = 'xxx';
 * chart2.group = 'xxx';
 * echarts.connect('xxx');
 * ```
 * (B)
 * ```js
 * let chart1 = echarts.init(dom1);
 * let chart2 = echarts.init(dom2);
 * echarts.connect('xxx', [chart1, chart2]);
 * ```
 */

function connect(groupId) {
  // Is array of charts
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isArray"])(groupId)) {
    var charts = groupId;
    groupId = null; // If any chart has group

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(charts, function (chart) {
      if (chart.group != null) {
        groupId = chart.group;
      }
    });
    groupId = groupId || 'g_' + groupIdBase++;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(charts, function (chart) {
      chart.group = groupId;
    });
  }

  connectedGroups[groupId] = true;
  return groupId;
}
/**
 * @deprecated
 */

function disConnect(groupId) {
  connectedGroups[groupId] = false;
}
/**
 * Alias and backword compat
 */

var disconnect = disConnect;
/**
 * Dispose a chart instance
 */

function dispose(chart) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isString"])(chart)) {
    chart = instances[chart];
  } else if (!(chart instanceof ECharts)) {
    // Try to treat as dom
    chart = getInstanceByDom(chart);
  }

  if (chart instanceof ECharts && !chart.isDisposed()) {
    chart.dispose();
  }
}
function getInstanceByDom(dom) {
  return instances[__WEBPACK_IMPORTED_MODULE_18__util_model_js__["p" /* getAttribute */](dom, DOM_ATTRIBUTE_KEY)];
}
function getInstanceById(key) {
  return instances[key];
}
/**
 * Register theme
 */

function registerTheme(name, theme) {
  themeStorage[name] = theme;
}
/**
 * Register option preprocessor
 */

function registerPreprocessor(preprocessorFunc) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["indexOf"])(optionPreprocessorFuncs, preprocessorFunc) < 0) {
    optionPreprocessorFuncs.push(preprocessorFunc);
  }
}
function registerProcessor(priority, processor) {
  normalizeRegister(dataProcessorFuncs, priority, processor, PRIORITY_PROCESSOR_DEFAULT);
}
/**
 * Register postIniter
 * @param {Function} postInitFunc
 */

function registerPostInit(postInitFunc) {
  registerUpdateLifecycle('afterinit', postInitFunc);
}
/**
 * Register postUpdater
 * @param {Function} postUpdateFunc
 */

function registerPostUpdate(postUpdateFunc) {
  registerUpdateLifecycle('afterupdate', postUpdateFunc);
}
function registerUpdateLifecycle(name, cb) {
  __WEBPACK_IMPORTED_MODULE_35__lifecycle_js__["a" /* default */].on(name, cb);
}
function registerAction(actionInfo, eventName, action) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isFunction"])(eventName)) {
    action = eventName;
    eventName = '';
  }

  var actionType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isObject"])(actionInfo) ? actionInfo.type : [actionInfo, actionInfo = {
    event: eventName
  }][0]; // Event name is all lowercase

  actionInfo.event = (actionInfo.event || actionType).toLowerCase();
  eventName = actionInfo.event;

  if (eventActionMap[eventName]) {
    // Already registered.
    return;
  } // Validate action type and event name.


  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["assert"])(ACTION_REG.test(actionType) && ACTION_REG.test(eventName));

  if (!actions[actionType]) {
    actions[actionType] = {
      action: action,
      actionInfo: actionInfo
    };
  }

  eventActionMap[eventName] = actionType;
}
function registerCoordinateSystem(type, coordSysCreator) {
  __WEBPACK_IMPORTED_MODULE_8__CoordinateSystem_js__["a" /* default */].register(type, coordSysCreator);
}
/**
 * Get dimensions of specified coordinate system.
 * @param {string} type
 * @return {Array.<string|Object>}
 */

function getCoordinateSystemDimensions(type) {
  var coordSysCreator = __WEBPACK_IMPORTED_MODULE_8__CoordinateSystem_js__["a" /* default */].get(type);

  if (coordSysCreator) {
    return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
  }
}


function registerLayout(priority, layoutTask) {
  normalizeRegister(visualFuncs, priority, layoutTask, PRIORITY_VISUAL_LAYOUT, 'layout');
}

function registerVisual(priority, visualTask) {
  normalizeRegister(visualFuncs, priority, visualTask, PRIORITY_VISUAL_CHART, 'visual');
}


var registeredTasks = [];

function normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isFunction"])(priority) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isObject"])(priority)) {
    fn = priority;
    priority = defaultPriority;
  }

  if (true) {
    if (isNaN(priority) || priority == null) {
      throw new Error('Illegal priority');
    } // Check duplicate


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(targetList, function (wrap) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["assert"])(wrap.__raw !== fn);
    });
  } // Already registered


  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["indexOf"])(registeredTasks, fn) >= 0) {
    return;
  }

  registeredTasks.push(fn);
  var stageHandler = __WEBPACK_IMPORTED_MODULE_22__Scheduler_js__["a" /* default */].wrapStageHandler(fn, visualType);
  stageHandler.__prio = priority;
  stageHandler.__raw = fn;
  targetList.push(stageHandler);
}

function registerLoading(name, loadingFx) {
  loadingEffects[name] = loadingFx;
}
/**
 * ZRender need a canvas context to do measureText.
 * But in node environment canvas may be created by node-canvas.
 * So we need to specify how to create a canvas instead of using document.createElement('canvas')
 *
 *
 * @deprecated use setPlatformAPI({ createCanvas }) instead.
 *
 * @example
 *     let Canvas = require('canvas');
 *     let echarts = require('echarts');
 *     echarts.setCanvasCreator(function () {
 *         // Small size is enough.
 *         return new Canvas(32, 32);
 *     });
 */

function setCanvasCreator(creator) {
  if (true) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__util_log_js__["g" /* deprecateLog */])('setCanvasCreator is deprecated. Use setPlatformAPI({ createCanvas }) instead.');
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_36_zrender_lib_core_platform_js__["d" /* setPlatformAPI */])({
    createCanvas: creator
  });
}
/**
 * The parameters and usage: see `geoSourceManager.registerMap`.
 * Compatible with previous `echarts.registerMap`.
 */

function registerMap(mapName, geoJson, specialAreas) {
  var registerMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__impl_js__["a" /* getImpl */])('registerMap');
  registerMap && registerMap(mapName, geoJson, specialAreas);
}
function getMap(mapName) {
  var getMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_37__impl_js__["a" /* getImpl */])('getMap');
  return getMap && getMap(mapName);
}
var registerTransform = __WEBPACK_IMPORTED_MODULE_31__data_helper_transform_js__["b" /* registerExternalTransform */];
/**
 * Globa dispatchAction to a specified chart instance.
 */
// export function dispatchAction(payload: { chartId: string } & Payload, opt?: Parameters<ECharts['dispatchAction']>[1]) {
//     if (!payload || !payload.chartId) {
//         // Must have chartId to find chart
//         return;
//     }
//     const chart = instances[payload.chartId];
//     if (chart) {
//         chart.dispatchAction(payload, opt);
//     }
// }
// Buitlin global visual

registerVisual(PRIORITY_VISUAL_GLOBAL, __WEBPACK_IMPORTED_MODULE_20__visual_style_js__["a" /* seriesStyleTask */]);
registerVisual(PRIORITY_VISUAL_CHART_DATA_CUSTOM, __WEBPACK_IMPORTED_MODULE_20__visual_style_js__["b" /* dataStyleTask */]);
registerVisual(PRIORITY_VISUAL_CHART_DATA_CUSTOM, __WEBPACK_IMPORTED_MODULE_20__visual_style_js__["c" /* dataColorPaletteTask */]);
registerVisual(PRIORITY_VISUAL_GLOBAL, __WEBPACK_IMPORTED_MODULE_27__visual_symbol_js__["a" /* seriesSymbolTask */]);
registerVisual(PRIORITY_VISUAL_CHART_DATA_CUSTOM, __WEBPACK_IMPORTED_MODULE_27__visual_symbol_js__["b" /* dataSymbolTask */]);
registerVisual(PRIORITY_VISUAL_DECAL, __WEBPACK_IMPORTED_MODULE_34__visual_decal_js__["a" /* default */]);
registerPreprocessor(__WEBPACK_IMPORTED_MODULE_10__preprocessor_backwardCompat_js__["a" /* default */]);
registerProcessor(PRIORITY_PROCESSOR_DATASTACK, __WEBPACK_IMPORTED_MODULE_11__processor_dataStack_js__["a" /* default */]);
registerLoading('default', __WEBPACK_IMPORTED_MODULE_21__loading_default_js__["a" /* default */]); // Default actions

registerAction({
  type: __WEBPACK_IMPORTED_MODULE_17__util_states_js__["f" /* HIGHLIGHT_ACTION_TYPE */],
  event: __WEBPACK_IMPORTED_MODULE_17__util_states_js__["f" /* HIGHLIGHT_ACTION_TYPE */],
  update: __WEBPACK_IMPORTED_MODULE_17__util_states_js__["f" /* HIGHLIGHT_ACTION_TYPE */]
}, __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["noop"]);
registerAction({
  type: __WEBPACK_IMPORTED_MODULE_17__util_states_js__["A" /* DOWNPLAY_ACTION_TYPE */],
  event: __WEBPACK_IMPORTED_MODULE_17__util_states_js__["A" /* DOWNPLAY_ACTION_TYPE */],
  update: __WEBPACK_IMPORTED_MODULE_17__util_states_js__["A" /* DOWNPLAY_ACTION_TYPE */]
}, __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["noop"]);
registerAction({
  type: __WEBPACK_IMPORTED_MODULE_17__util_states_js__["B" /* SELECT_ACTION_TYPE */],
  event: __WEBPACK_IMPORTED_MODULE_17__util_states_js__["B" /* SELECT_ACTION_TYPE */],
  update: __WEBPACK_IMPORTED_MODULE_17__util_states_js__["B" /* SELECT_ACTION_TYPE */]
}, __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["noop"]);
registerAction({
  type: __WEBPACK_IMPORTED_MODULE_17__util_states_js__["C" /* UNSELECT_ACTION_TYPE */],
  event: __WEBPACK_IMPORTED_MODULE_17__util_states_js__["C" /* UNSELECT_ACTION_TYPE */],
  update: __WEBPACK_IMPORTED_MODULE_17__util_states_js__["C" /* UNSELECT_ACTION_TYPE */]
}, __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["noop"]);
registerAction({
  type: __WEBPACK_IMPORTED_MODULE_17__util_states_js__["D" /* TOGGLE_SELECT_ACTION_TYPE */],
  event: __WEBPACK_IMPORTED_MODULE_17__util_states_js__["D" /* TOGGLE_SELECT_ACTION_TYPE */],
  update: __WEBPACK_IMPORTED_MODULE_17__util_states_js__["D" /* TOGGLE_SELECT_ACTION_TYPE */]
}, __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["noop"]); // Default theme

registerTheme('light', __WEBPACK_IMPORTED_MODULE_23__theme_light_js__["a" /* default */]);
registerTheme('dark', __WEBPACK_IMPORTED_MODULE_24__theme_dark_js__["a" /* default */]); // For backward compatibility, where the namespace `dataTool` will
// be mounted on `echarts` is the extension `dataTool` is imported.

var dataTool = {};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(50)))

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createDimensions;
/* harmony export (immutable) */ __webpack_exports__["a"] = prepareSeriesDataSchema;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_types_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SeriesDimensionDefine_js__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Source_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DataStore_js__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sourceHelper_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SeriesDataSchema_js__ = __webpack_require__(333);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/








/**
 * For outside usage compat (like echarts-gl are using it).
 */

function createDimensions(source, opt) {
  return prepareSeriesDataSchema(source, opt).dimensions;
}
/**
 * This method builds the relationship between:
 * + "what the coord sys or series requires (see `coordDimensions`)",
 * + "what the user defines (in `encode` and `dimensions`, see `opt.dimensionsDefine` and `opt.encodeDefine`)"
 * + "what the data source provids (see `source`)".
 *
 * Some guess strategy will be adapted if user does not define something.
 * If no 'value' dimension specified, the first no-named dimension will be
 * named as 'value'.
 *
 * @return The results are always sorted by `storeDimIndex` asc.
 */

function prepareSeriesDataSchema( // TODO: TYPE completeDimensions type
source, opt) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Source_js__["a" /* isSourceInstance */])(source)) {
    source = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Source_js__["b" /* createSourceFromSeriesDataOption */])(source);
  }

  opt = opt || {};
  var sysDims = opt.coordDimensions || [];
  var dimsDef = opt.dimensionsDefine || source.dimensionsDefine || [];
  var coordDimNameMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["createHashMap"])();
  var resultList = [];
  var dimCount = getDimCount(source, sysDims, dimsDef, opt.dimensionsCount); // Try to ignore unsed dimensions if sharing a high dimension datastore
  // 30 is an experience value.

  var omitUnusedDimensions = opt.canOmitUnusedDimensions && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__SeriesDataSchema_js__["b" /* shouldOmitUnusedDimensions */])(dimCount);
  var isUsingSourceDimensionsDef = dimsDef === source.dimensionsDefine;
  var dataDimNameMap = isUsingSourceDimensionsDef ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__SeriesDataSchema_js__["c" /* ensureSourceDimNameMap */])(source) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__SeriesDataSchema_js__["d" /* createDimNameMap */])(dimsDef);
  var encodeDef = opt.encodeDefine;

  if (!encodeDef && opt.encodeDefaulter) {
    encodeDef = opt.encodeDefaulter(source, dimCount);
  }

  var encodeDefMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["createHashMap"])(encodeDef);
  var indicesMap = new __WEBPACK_IMPORTED_MODULE_4__DataStore_js__["b" /* CtorInt32Array */](dimCount);

  for (var i = 0; i < indicesMap.length; i++) {
    indicesMap[i] = -1;
  }

  function getResultItem(dimIdx) {
    var idx = indicesMap[dimIdx];

    if (idx < 0) {
      var dimDefItemRaw = dimsDef[dimIdx];
      var dimDefItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isObject"])(dimDefItemRaw) ? dimDefItemRaw : {
        name: dimDefItemRaw
      };
      var resultItem = new __WEBPACK_IMPORTED_MODULE_1__SeriesDimensionDefine_js__["a" /* default */]();
      var userDimName = dimDefItem.name;

      if (userDimName != null && dataDimNameMap.get(userDimName) != null) {
        // Only if `series.dimensions` is defined in option
        // displayName, will be set, and dimension will be diplayed vertically in
        // tooltip by default.
        resultItem.name = resultItem.displayName = userDimName;
      }

      dimDefItem.type != null && (resultItem.type = dimDefItem.type);
      dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
      var newIdx = resultList.length;
      indicesMap[dimIdx] = newIdx;
      resultItem.storeDimIndex = dimIdx;
      resultList.push(resultItem);
      return resultItem;
    }

    return resultList[idx];
  }

  if (!omitUnusedDimensions) {
    for (var i = 0; i < dimCount; i++) {
      getResultItem(i);
    }
  } // Set `coordDim` and `coordDimIndex` by `encodeDefMap` and normalize `encodeDefMap`.


  encodeDefMap.each(function (dataDimsRaw, coordDim) {
    var dataDims = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_model_js__["d" /* normalizeToArray */])(dataDimsRaw).slice(); // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
    // `{encode: {x: -1, y: 1}}`. Should not filter anything in
    // this case.

    if (dataDims.length === 1 && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isString"])(dataDims[0]) && dataDims[0] < 0) {
      encodeDefMap.set(coordDim, false);
      return;
    }

    var validDataDims = encodeDefMap.set(coordDim, []);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(dataDims, function (resultDimIdxOrName, idx) {
      // The input resultDimIdx can be dim name or index.
      var resultDimIdx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isString"])(resultDimIdxOrName) ? dataDimNameMap.get(resultDimIdxOrName) : resultDimIdxOrName;

      if (resultDimIdx != null && resultDimIdx < dimCount) {
        validDataDims[idx] = resultDimIdx;
        applyDim(getResultItem(resultDimIdx), coordDim, idx);
      }
    });
  }); // Apply templetes and default order from `sysDims`.

  var availDimIdx = 0;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(sysDims, function (sysDimItemRaw) {
    var coordDim;
    var sysDimItemDimsDef;
    var sysDimItemOtherDims;
    var sysDimItem;

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isString"])(sysDimItemRaw)) {
      coordDim = sysDimItemRaw;
      sysDimItem = {};
    } else {
      sysDimItem = sysDimItemRaw;
      coordDim = sysDimItem.name;
      var ordinalMeta = sysDimItem.ordinalMeta;
      sysDimItem.ordinalMeta = null;
      sysDimItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["extend"])({}, sysDimItem);
      sysDimItem.ordinalMeta = ordinalMeta; // `coordDimIndex` should not be set directly.

      sysDimItemDimsDef = sysDimItem.dimsDef;
      sysDimItemOtherDims = sysDimItem.otherDims;
      sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
    }

    var dataDims = encodeDefMap.get(coordDim); // negative resultDimIdx means no need to mapping.

    if (dataDims === false) {
      return;
    }

    dataDims = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_model_js__["d" /* normalizeToArray */])(dataDims); // dimensions provides default dim sequences.

    if (!dataDims.length) {
      for (var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++) {
        while (availDimIdx < dimCount && getResultItem(availDimIdx).coordDim != null) {
          availDimIdx++;
        }

        availDimIdx < dimCount && dataDims.push(availDimIdx++);
      }
    } // Apply templates.


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(dataDims, function (resultDimIdx, coordDimIndex) {
      var resultItem = getResultItem(resultDimIdx); // Coordinate system has a higher priority on dim type than source.

      if (isUsingSourceDimensionsDef && sysDimItem.type != null) {
        resultItem.type = sysDimItem.type;
      }

      applyDim(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["defaults"])(resultItem, sysDimItem), coordDim, coordDimIndex);

      if (resultItem.name == null && sysDimItemDimsDef) {
        var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
        !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isObject"])(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
          name: sysDimItemDimsDefItem
        });
        resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
        resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
      } // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}


      sysDimItemOtherDims && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["defaults"])(resultItem.otherDims, sysDimItemOtherDims);
    });
  });

  function applyDim(resultItem, coordDim, coordDimIndex) {
    if (__WEBPACK_IMPORTED_MODULE_0__util_types_js__["i" /* VISUAL_DIMENSIONS */].get(coordDim) != null) {
      resultItem.otherDims[coordDim] = coordDimIndex;
    } else {
      resultItem.coordDim = coordDim;
      resultItem.coordDimIndex = coordDimIndex;
      coordDimNameMap.set(coordDim, true);
    }
  } // Make sure the first extra dim is 'value'.


  var generateCoord = opt.generateCoord;
  var generateCoordCount = opt.generateCoordCount;
  var fromZero = generateCoordCount != null;
  generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
  var extra = generateCoord || 'value';

  function ifNoNameFillWithCoordName(resultItem) {
    if (resultItem.name == null) {
      // Duplication will be removed in the next step.
      resultItem.name = resultItem.coordDim;
    }
  } // Set dim `name` and other `coordDim` and other props.


  if (!omitUnusedDimensions) {
    for (var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++) {
      var resultItem = getResultItem(resultDimIdx);
      var coordDim = resultItem.coordDim;

      if (coordDim == null) {
        // TODO no need to generate coordDim for isExtraCoord?
        resultItem.coordDim = genCoordDimName(extra, coordDimNameMap, fromZero);
        resultItem.coordDimIndex = 0; // Series specified generateCoord is using out.

        if (!generateCoord || generateCoordCount <= 0) {
          resultItem.isExtraCoord = true;
        }

        generateCoordCount--;
      }

      ifNoNameFillWithCoordName(resultItem);

      if (resultItem.type == null && (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__sourceHelper_js__["a" /* guessOrdinal */])(source, resultDimIdx) === __WEBPACK_IMPORTED_MODULE_6__sourceHelper_js__["b" /* BE_ORDINAL */].Must // Consider the case:
      // {
      //    dataset: {source: [
      //        ['2001', 123],
      //        ['2002', 456],
      //        ...
      //        ['The others', 987],
      //    ]},
      //    series: {type: 'pie'}
      // }
      // The first colum should better be treated as a "ordinal" although it
      // might not able to be detected as an "ordinal" by `guessOrdinal`.
      || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) {
        resultItem.type = 'ordinal';
      }
    }
  } else {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(resultList, function (resultItem) {
      // PENDING: guessOrdinal or let user specify type: 'ordinal' manually?
      ifNoNameFillWithCoordName(resultItem);
    }); // Sort dimensions: there are some rule that use the last dim as label,
    // and for some latter travel process easier.

    resultList.sort(function (item0, item1) {
      return item0.storeDimIndex - item1.storeDimIndex;
    });
  }

  removeDuplication(resultList);
  return new __WEBPACK_IMPORTED_MODULE_7__SeriesDataSchema_js__["e" /* SeriesDataSchema */]({
    source: source,
    dimensions: resultList,
    fullDimensionCount: dimCount,
    dimensionOmitted: omitUnusedDimensions
  });
}

function removeDuplication(result) {
  var duplicationMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["createHashMap"])();

  for (var i = 0; i < result.length; i++) {
    var dim = result[i];
    var dimOriginalName = dim.name;
    var count = duplicationMap.get(dimOriginalName) || 0;

    if (count > 0) {
      // Starts from 0.
      dim.name = dimOriginalName + (count - 1);
    }

    count++;
    duplicationMap.set(dimOriginalName, count);
  }
} // ??? TODO
// Originally detect dimCount by data[0]. Should we
// optimize it to only by sysDims and dimensions and encode.
// So only necessary dims will be initialized.
// But
// (1) custom series should be considered. where other dims
// may be visited.
// (2) sometimes user need to calcualte bubble size or use visualMap
// on other dimensions besides coordSys needed.
// So, dims that is not used by system, should be shared in data store?


function getDimCount(source, sysDims, dimsDef, optDimCount) {
  // Note that the result dimCount should not small than columns count
  // of data, otherwise `dataDimNameMap` checking will be incorrect.
  var dimCount = Math.max(source.dimensionsDetectedCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(sysDims, function (sysDimItem) {
    var sysDimItemDimsDef;

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isObject"])(sysDimItem) && (sysDimItemDimsDef = sysDimItem.dimsDef)) {
      dimCount = Math.max(dimCount, sysDimItemDimsDef.length);
    }
  });
  return dimCount;
}

function genCoordDimName(name, map, fromZero) {
  var mapData = map.data;

  if (fromZero || mapData.hasOwnProperty(name)) {
    var i = 0;

    while (mapData.hasOwnProperty(name + i)) {
      i++;
    }

    name += i;
  }

  map.set(name, true);
  return name;
}

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DefaultDataProvider; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getRawSourceItemGetter;
/* harmony export (immutable) */ __webpack_exports__["d"] = getRawSourceDataCounter;
/* harmony export (immutable) */ __webpack_exports__["e"] = getRawSourceValueGetter;
/* harmony export (immutable) */ __webpack_exports__["a"] = retrieveRawValue;
/* unused harmony export retrieveRawAttr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Source_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_types_js__ = __webpack_require__(66);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _a, _b, _c; // TODO
// ??? refactor? check the outer usage of data provider.
// merge with defaultDimValueGetter?






var providerMethods;
var mountMethods;
/**
 * If normal array used, mutable chunk size is supported.
 * If typed array used, chunk size must be fixed.
 */

var DefaultDataProvider =
/** @class */
function () {
  function DefaultDataProvider(sourceParam, dimSize) {
    // let source: Source;
    var source = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Source_js__["a" /* isSourceInstance */])(sourceParam) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Source_js__["b" /* createSourceFromSeriesDataOption */])(sourceParam) : sourceParam; // declare source is Source;

    this._source = source;
    var data = this._data = source.data; // Typed array. TODO IE10+?

    if (source.sourceFormat === __WEBPACK_IMPORTED_MODULE_3__util_types_js__["a" /* SOURCE_FORMAT_TYPED_ARRAY */]) {
      if (true) {
        if (dimSize == null) {
          throw new Error('Typed array data must specify dimension size');
        }
      }

      this._offset = 0;
      this._dimSize = dimSize;
      this._data = data;
    }

    mountMethods(this, data, source);
  }

  DefaultDataProvider.prototype.getSource = function () {
    return this._source;
  };

  DefaultDataProvider.prototype.count = function () {
    return 0;
  };

  DefaultDataProvider.prototype.getItem = function (idx, out) {
    return;
  };

  DefaultDataProvider.prototype.appendData = function (newData) {};

  DefaultDataProvider.prototype.clean = function () {};

  DefaultDataProvider.protoInitialize = function () {
    // PENDING: To avoid potential incompat (e.g., prototype
    // is visited somewhere), still init them on prototype.
    var proto = DefaultDataProvider.prototype;
    proto.pure = false;
    proto.persistent = true;
  }();

  DefaultDataProvider.internalField = function () {
    var _a;

    mountMethods = function (provider, data, source) {
      var sourceFormat = source.sourceFormat;
      var seriesLayoutBy = source.seriesLayoutBy;
      var startIndex = source.startIndex;
      var dimsDef = source.dimensionsDefine;
      var methods = providerMethods[getMethodMapKey(sourceFormat, seriesLayoutBy)];

      if (true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(methods, 'Invalide sourceFormat: ' + sourceFormat);
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"])(provider, methods);

      if (sourceFormat === __WEBPACK_IMPORTED_MODULE_3__util_types_js__["a" /* SOURCE_FORMAT_TYPED_ARRAY */]) {
        provider.getItem = getItemForTypedArray;
        provider.count = countForTypedArray;
        provider.fillStorage = fillStorageForTypedArray;
      } else {
        var rawItemGetter = getRawSourceItemGetter(sourceFormat, seriesLayoutBy);
        provider.getItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["bind"])(rawItemGetter, null, data, startIndex, dimsDef);
        var rawCounter = getRawSourceDataCounter(sourceFormat, seriesLayoutBy);
        provider.count = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["bind"])(rawCounter, null, data, startIndex, dimsDef);
      }
    };

    var getItemForTypedArray = function (idx, out) {
      idx = idx - this._offset;
      out = out || [];
      var data = this._data;
      var dimSize = this._dimSize;
      var offset = dimSize * idx;

      for (var i = 0; i < dimSize; i++) {
        out[i] = data[offset + i];
      }

      return out;
    };

    var fillStorageForTypedArray = function (start, end, storage, extent) {
      var data = this._data;
      var dimSize = this._dimSize;

      for (var dim = 0; dim < dimSize; dim++) {
        var dimExtent = extent[dim];
        var min = dimExtent[0] == null ? Infinity : dimExtent[0];
        var max = dimExtent[1] == null ? -Infinity : dimExtent[1];
        var count = end - start;
        var arr = storage[dim];

        for (var i = 0; i < count; i++) {
          // appendData with TypedArray will always do replace in provider.
          var val = data[i * dimSize + dim];
          arr[start + i] = val;
          val < min && (min = val);
          val > max && (max = val);
        }

        dimExtent[0] = min;
        dimExtent[1] = max;
      }
    };

    var countForTypedArray = function () {
      return this._data ? this._data.length / this._dimSize : 0;
    };

    providerMethods = (_a = {}, _a[__WEBPACK_IMPORTED_MODULE_3__util_types_js__["b" /* SOURCE_FORMAT_ARRAY_ROWS */] + '_' + __WEBPACK_IMPORTED_MODULE_3__util_types_js__["c" /* SERIES_LAYOUT_BY_COLUMN */]] = {
      pure: true,
      appendData: appendDataSimply
    }, _a[__WEBPACK_IMPORTED_MODULE_3__util_types_js__["b" /* SOURCE_FORMAT_ARRAY_ROWS */] + '_' + __WEBPACK_IMPORTED_MODULE_3__util_types_js__["d" /* SERIES_LAYOUT_BY_ROW */]] = {
      pure: true,
      appendData: function () {
        throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
      }
    }, _a[__WEBPACK_IMPORTED_MODULE_3__util_types_js__["e" /* SOURCE_FORMAT_OBJECT_ROWS */]] = {
      pure: true,
      appendData: appendDataSimply
    }, _a[__WEBPACK_IMPORTED_MODULE_3__util_types_js__["f" /* SOURCE_FORMAT_KEYED_COLUMNS */]] = {
      pure: true,
      appendData: function (newData) {
        var data = this._data;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(newData, function (newCol, key) {
          var oldCol = data[key] || (data[key] = []);

          for (var i = 0; i < (newCol || []).length; i++) {
            oldCol.push(newCol[i]);
          }
        });
      }
    }, _a[__WEBPACK_IMPORTED_MODULE_3__util_types_js__["g" /* SOURCE_FORMAT_ORIGINAL */]] = {
      appendData: appendDataSimply
    }, _a[__WEBPACK_IMPORTED_MODULE_3__util_types_js__["a" /* SOURCE_FORMAT_TYPED_ARRAY */]] = {
      persistent: false,
      pure: true,
      appendData: function (newData) {
        if (true) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isTypedArray"])(newData), 'Added data must be TypedArray if data in initialization is TypedArray');
        }

        this._data = newData;
      },
      // Clean self if data is already used.
      clean: function () {
        // PENDING
        this._offset += this.count();
        this._data = null;
      }
    }, _a);

    function appendDataSimply(newData) {
      for (var i = 0; i < newData.length; i++) {
        this._data.push(newData[i]);
      }
    }
  }();

  return DefaultDataProvider;
}();



var getItemSimply = function (rawData, startIndex, dimsDef, idx) {
  return rawData[idx];
};

var rawSourceItemGetterMap = (_a = {}, _a[__WEBPACK_IMPORTED_MODULE_3__util_types_js__["b" /* SOURCE_FORMAT_ARRAY_ROWS */] + '_' + __WEBPACK_IMPORTED_MODULE_3__util_types_js__["c" /* SERIES_LAYOUT_BY_COLUMN */]] = function (rawData, startIndex, dimsDef, idx) {
  return rawData[idx + startIndex];
}, _a[__WEBPACK_IMPORTED_MODULE_3__util_types_js__["b" /* SOURCE_FORMAT_ARRAY_ROWS */] + '_' + __WEBPACK_IMPORTED_MODULE_3__util_types_js__["d" /* SERIES_LAYOUT_BY_ROW */]] = function (rawData, startIndex, dimsDef, idx, out) {
  idx += startIndex;
  var item = out || [];
  var data = rawData;

  for (var i = 0; i < data.length; i++) {
    var row = data[i];
    item[i] = row ? row[idx] : null;
  }

  return item;
}, _a[__WEBPACK_IMPORTED_MODULE_3__util_types_js__["e" /* SOURCE_FORMAT_OBJECT_ROWS */]] = getItemSimply, _a[__WEBPACK_IMPORTED_MODULE_3__util_types_js__["f" /* SOURCE_FORMAT_KEYED_COLUMNS */]] = function (rawData, startIndex, dimsDef, idx, out) {
  var item = out || [];

  for (var i = 0; i < dimsDef.length; i++) {
    var dimName = dimsDef[i].name;

    if (true) {
      if (dimName == null) {
        throw new Error();
      }
    }

    var col = rawData[dimName];
    item[i] = col ? col[idx] : null;
  }

  return item;
}, _a[__WEBPACK_IMPORTED_MODULE_3__util_types_js__["g" /* SOURCE_FORMAT_ORIGINAL */]] = getItemSimply, _a);
function getRawSourceItemGetter(sourceFormat, seriesLayoutBy) {
  var method = rawSourceItemGetterMap[getMethodMapKey(sourceFormat, seriesLayoutBy)];

  if (true) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(method, 'Do not support get item on "' + sourceFormat + '", "' + seriesLayoutBy + '".');
  }

  return method;
}

var countSimply = function (rawData, startIndex, dimsDef) {
  return rawData.length;
};

var rawSourceDataCounterMap = (_b = {}, _b[__WEBPACK_IMPORTED_MODULE_3__util_types_js__["b" /* SOURCE_FORMAT_ARRAY_ROWS */] + '_' + __WEBPACK_IMPORTED_MODULE_3__util_types_js__["c" /* SERIES_LAYOUT_BY_COLUMN */]] = function (rawData, startIndex, dimsDef) {
  return Math.max(0, rawData.length - startIndex);
}, _b[__WEBPACK_IMPORTED_MODULE_3__util_types_js__["b" /* SOURCE_FORMAT_ARRAY_ROWS */] + '_' + __WEBPACK_IMPORTED_MODULE_3__util_types_js__["d" /* SERIES_LAYOUT_BY_ROW */]] = function (rawData, startIndex, dimsDef) {
  var row = rawData[0];
  return row ? Math.max(0, row.length - startIndex) : 0;
}, _b[__WEBPACK_IMPORTED_MODULE_3__util_types_js__["e" /* SOURCE_FORMAT_OBJECT_ROWS */]] = countSimply, _b[__WEBPACK_IMPORTED_MODULE_3__util_types_js__["f" /* SOURCE_FORMAT_KEYED_COLUMNS */]] = function (rawData, startIndex, dimsDef) {
  var dimName = dimsDef[0].name;

  if (true) {
    if (dimName == null) {
      throw new Error();
    }
  }

  var col = rawData[dimName];
  return col ? col.length : 0;
}, _b[__WEBPACK_IMPORTED_MODULE_3__util_types_js__["g" /* SOURCE_FORMAT_ORIGINAL */]] = countSimply, _b);
function getRawSourceDataCounter(sourceFormat, seriesLayoutBy) {
  var method = rawSourceDataCounterMap[getMethodMapKey(sourceFormat, seriesLayoutBy)];

  if (true) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(method, 'Do not suppport count on "' + sourceFormat + '", "' + seriesLayoutBy + '".');
  }

  return method;
}

var getRawValueSimply = function (dataItem, dimIndex, property) {
  return dataItem[dimIndex];
};

var rawSourceValueGetterMap = (_c = {}, _c[__WEBPACK_IMPORTED_MODULE_3__util_types_js__["b" /* SOURCE_FORMAT_ARRAY_ROWS */]] = getRawValueSimply, _c[__WEBPACK_IMPORTED_MODULE_3__util_types_js__["e" /* SOURCE_FORMAT_OBJECT_ROWS */]] = function (dataItem, dimIndex, property) {
  return dataItem[property];
}, _c[__WEBPACK_IMPORTED_MODULE_3__util_types_js__["f" /* SOURCE_FORMAT_KEYED_COLUMNS */]] = getRawValueSimply, _c[__WEBPACK_IMPORTED_MODULE_3__util_types_js__["g" /* SOURCE_FORMAT_ORIGINAL */]] = function (dataItem, dimIndex, property) {
  // FIXME: In some case (markpoint in geo (geo-map.html)),
  // dataItem is {coord: [...]}
  var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_model_js__["g" /* getDataItemValue */])(dataItem);
  return !(value instanceof Array) ? value : value[dimIndex];
}, _c[__WEBPACK_IMPORTED_MODULE_3__util_types_js__["a" /* SOURCE_FORMAT_TYPED_ARRAY */]] = getRawValueSimply, _c);
function getRawSourceValueGetter(sourceFormat) {
  var method = rawSourceValueGetterMap[sourceFormat];

  if (true) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(method, 'Do not suppport get value on "' + sourceFormat + '".');
  }

  return method;
}

function getMethodMapKey(sourceFormat, seriesLayoutBy) {
  return sourceFormat === __WEBPACK_IMPORTED_MODULE_3__util_types_js__["b" /* SOURCE_FORMAT_ARRAY_ROWS */] ? sourceFormat + '_' + seriesLayoutBy : sourceFormat;
} // ??? FIXME can these logic be more neat: getRawValue, getRawDataItem,
// Consider persistent.
// Caution: why use raw value to display on label or tooltip?
// A reason is to avoid format. For example time value we do not know
// how to format is expected. More over, if stack is used, calculated
// value may be 0.91000000001, which have brings trouble to display.
// TODO: consider how to treat null/undefined/NaN when display?


function retrieveRawValue(data, dataIndex, // If dimIndex is null/undefined, return OptionDataItem.
// Otherwise, return OptionDataValue.
dim) {
  if (!data) {
    return;
  } // Consider data may be not persistent.


  var dataItem = data.getRawDataItem(dataIndex);

  if (dataItem == null) {
    return;
  }

  var store = data.getStore();
  var sourceFormat = store.getSource().sourceFormat;

  if (dim != null) {
    var dimIndex = data.getDimensionIndex(dim);
    var property = store.getDimensionProperty(dimIndex);
    return getRawSourceValueGetter(sourceFormat)(dataItem, dimIndex, property);
  } else {
    var result = dataItem;

    if (sourceFormat === __WEBPACK_IMPORTED_MODULE_3__util_types_js__["g" /* SOURCE_FORMAT_ORIGINAL */]) {
      result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_model_js__["g" /* getDataItemValue */])(dataItem);
    }

    return result;
  }
}
/**
 * Compatible with some cases (in pie, map) like:
 * data: [{name: 'xx', value: 5, selected: true}, ...]
 * where only sourceFormat is 'original' and 'objectRows' supported.
 *
 * // TODO
 * Supported detail options in data item when using 'arrayRows'.
 *
 * @param data
 * @param dataIndex
 * @param attr like 'selected'
 */

function retrieveRawAttr(data, dataIndex, attr) {
  if (!data) {
    return;
  }

  var sourceFormat = data.getStore().getSource().sourceFormat;

  if (sourceFormat !== __WEBPACK_IMPORTED_MODULE_3__util_types_js__["g" /* SOURCE_FORMAT_ORIGINAL */] && sourceFormat !== __WEBPACK_IMPORTED_MODULE_3__util_types_js__["e" /* SOURCE_FORMAT_OBJECT_ROWS */]) {
    return;
  }

  var dataItem = data.getRawDataItem(dataIndex);

  if (sourceFormat === __WEBPACK_IMPORTED_MODULE_3__util_types_js__["g" /* SOURCE_FORMAT_ORIGINAL */] && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"])(dataItem)) {
    dataItem = null;
  }

  if (dataItem) {
    return dataItem[attr];
  }
}

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeStyleMapper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// TODO Parse shadow style
// TODO Only shallow path support

function makeStyleMapper(properties, ignoreParent) {
  // Normalize
  for (var i = 0; i < properties.length; i++) {
    if (!properties[i][1]) {
      properties[i][1] = properties[i][0];
    }
  }

  ignoreParent = ignoreParent || false;
  return function (model, excludes, includes) {
    var style = {};

    for (var i = 0; i < properties.length; i++) {
      var propName = properties[i][1];

      if (excludes && __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"](excludes, propName) >= 0 || includes && __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"](includes, propName) < 0) {
        continue;
      }

      var val = model.getShallow(propName, ignoreParent);

      if (val != null) {
        style[properties[i][0]] = val;
      }
    } // TODO Text or image?


    return style;
  };
}

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_format_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Scale_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_js__ = __webpack_require__(135);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var roundNumber = __WEBPACK_IMPORTED_MODULE_1__util_number_js__["d" /* round */];

var IntervalScale =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(IntervalScale, _super);

  function IntervalScale() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = 'interval'; // Step is calculated in adjustExtent.

    _this._interval = 0;
    _this._intervalPrecision = 2;
    return _this;
  }

  IntervalScale.prototype.parse = function (val) {
    return val;
  };

  IntervalScale.prototype.contain = function (val) {
    return __WEBPACK_IMPORTED_MODULE_4__helper_js__["a" /* contain */](val, this._extent);
  };

  IntervalScale.prototype.normalize = function (val) {
    return __WEBPACK_IMPORTED_MODULE_4__helper_js__["b" /* normalize */](val, this._extent);
  };

  IntervalScale.prototype.scale = function (val) {
    return __WEBPACK_IMPORTED_MODULE_4__helper_js__["c" /* scale */](val, this._extent);
  };

  IntervalScale.prototype.setExtent = function (start, end) {
    var thisExtent = this._extent; // start,end may be a Number like '25',so...

    if (!isNaN(start)) {
      thisExtent[0] = parseFloat(start);
    }

    if (!isNaN(end)) {
      thisExtent[1] = parseFloat(end);
    }
  };

  IntervalScale.prototype.unionExtent = function (other) {
    var extent = this._extent;
    other[0] < extent[0] && (extent[0] = other[0]);
    other[1] > extent[1] && (extent[1] = other[1]); // unionExtent may called by it's sub classes

    this.setExtent(extent[0], extent[1]);
  };

  IntervalScale.prototype.getInterval = function () {
    return this._interval;
  };

  IntervalScale.prototype.setInterval = function (interval) {
    this._interval = interval; // Dropped auto calculated niceExtent and use user setted extent
    // We assume user wan't to set both interval, min, max to get a better result

    this._niceExtent = this._extent.slice();
    this._intervalPrecision = __WEBPACK_IMPORTED_MODULE_4__helper_js__["d" /* getIntervalPrecision */](interval);
  };
  /**
   * @param expandToNicedExtent Whether expand the ticks to niced extent.
   */


  IntervalScale.prototype.getTicks = function (expandToNicedExtent) {
    var interval = this._interval;
    var extent = this._extent;
    var niceTickExtent = this._niceExtent;
    var intervalPrecision = this._intervalPrecision;
    var ticks = []; // If interval is 0, return [];

    if (!interval) {
      return ticks;
    } // Consider this case: using dataZoom toolbox, zoom and zoom.


    var safeLimit = 10000;

    if (extent[0] < niceTickExtent[0]) {
      if (expandToNicedExtent) {
        ticks.push({
          value: roundNumber(niceTickExtent[0] - interval, intervalPrecision)
        });
      } else {
        ticks.push({
          value: extent[0]
        });
      }
    }

    var tick = niceTickExtent[0];

    while (tick <= niceTickExtent[1]) {
      ticks.push({
        value: tick
      }); // Avoid rounding error

      tick = roundNumber(tick + interval, intervalPrecision);

      if (tick === ticks[ticks.length - 1].value) {
        // Consider out of safe float point, e.g.,
        // -3711126.9907707 + 2e-10 === -3711126.9907707
        break;
      }

      if (ticks.length > safeLimit) {
        return [];
      }
    } // Consider this case: the last item of ticks is smaller
    // than niceTickExtent[1] and niceTickExtent[1] === extent[1].


    var lastNiceTick = ticks.length ? ticks[ticks.length - 1].value : niceTickExtent[1];

    if (extent[1] > lastNiceTick) {
      if (expandToNicedExtent) {
        ticks.push({
          value: roundNumber(lastNiceTick + interval, intervalPrecision)
        });
      } else {
        ticks.push({
          value: extent[1]
        });
      }
    }

    return ticks;
  };

  IntervalScale.prototype.getMinorTicks = function (splitNumber) {
    var ticks = this.getTicks(true);
    var minorTicks = [];
    var extent = this.getExtent();

    for (var i = 1; i < ticks.length; i++) {
      var nextTick = ticks[i];
      var prevTick = ticks[i - 1];
      var count = 0;
      var minorTicksGroup = [];
      var interval = nextTick.value - prevTick.value;
      var minorInterval = interval / splitNumber;

      while (count < splitNumber - 1) {
        var minorTick = roundNumber(prevTick.value + (count + 1) * minorInterval); // For the first and last interval. The count may be less than splitNumber.

        if (minorTick > extent[0] && minorTick < extent[1]) {
          minorTicksGroup.push(minorTick);
        }

        count++;
      }

      minorTicks.push(minorTicksGroup);
    }

    return minorTicks;
  };
  /**
   * @param opt.precision If 'auto', use nice presision.
   * @param opt.pad returns 1.50 but not 1.5 if precision is 2.
   */


  IntervalScale.prototype.getLabel = function (data, opt) {
    if (data == null) {
      return '';
    }

    var precision = opt && opt.precision;

    if (precision == null) {
      precision = __WEBPACK_IMPORTED_MODULE_1__util_number_js__["e" /* getPrecision */](data.value) || 0;
    } else if (precision === 'auto') {
      // Should be more precise then tick.
      precision = this._intervalPrecision;
    } // (1) If `precision` is set, 12.005 should be display as '12.00500'.
    // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.


    var dataNum = roundNumber(data.value, precision, true);
    return __WEBPACK_IMPORTED_MODULE_2__util_format_js__["g" /* addCommas */](dataNum);
  };
  /**
   * @param splitNumber By default `5`.
   */


  IntervalScale.prototype.calcNiceTicks = function (splitNumber, minInterval, maxInterval) {
    splitNumber = splitNumber || 5;
    var extent = this._extent;
    var span = extent[1] - extent[0];

    if (!isFinite(span)) {
      return;
    } // User may set axis min 0 and data are all negative
    // FIXME If it needs to reverse ?


    if (span < 0) {
      span = -span;
      extent.reverse();
    }

    var result = __WEBPACK_IMPORTED_MODULE_4__helper_js__["e" /* intervalScaleNiceTicks */](extent, splitNumber, minInterval, maxInterval);
    this._intervalPrecision = result.intervalPrecision;
    this._interval = result.interval;
    this._niceExtent = result.niceTickExtent;
  };

  IntervalScale.prototype.calcNiceExtent = function (opt) {
    var extent = this._extent; // If extent start and end are same, expand them

    if (extent[0] === extent[1]) {
      if (extent[0] !== 0) {
        // Expand extent
        var expandSize = extent[0]; // In the fowllowing case
        //      Axis has been fixed max 100
        //      Plus data are all 100 and axis extent are [100, 100].
        // Extend to the both side will cause expanded max is larger than fixed max.
        // So only expand to the smaller side.

        if (!opt.fixMax) {
          extent[1] += expandSize / 2;
          extent[0] -= expandSize / 2;
        } else {
          extent[0] -= expandSize / 2;
        }
      } else {
        extent[1] = 1;
      }
    }

    var span = extent[1] - extent[0]; // If there are no data and extent are [Infinity, -Infinity]

    if (!isFinite(span)) {
      extent[0] = 0;
      extent[1] = 1;
    }

    this.calcNiceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // let extent = this._extent;

    var interval = this._interval;

    if (!opt.fixMin) {
      extent[0] = roundNumber(Math.floor(extent[0] / interval) * interval);
    }

    if (!opt.fixMax) {
      extent[1] = roundNumber(Math.ceil(extent[1] / interval) * interval);
    }
  };

  IntervalScale.prototype.setNiceExtent = function (min, max) {
    this._niceExtent = [min, max];
  };

  IntervalScale.type = 'interval';
  return IntervalScale;
}(__WEBPACK_IMPORTED_MODULE_3__Scale_js__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_3__Scale_js__["a" /* default */].registerClass(IntervalScale);
/* harmony default export */ __webpack_exports__["a"] = (IntervalScale);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getItemVisualFromData;
/* harmony export (immutable) */ __webpack_exports__["a"] = getVisualFromData;
/* harmony export (immutable) */ __webpack_exports__["c"] = setItemVisualFromData;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function getItemVisualFromData(data, dataIndex, key) {
  switch (key) {
    case 'color':
      var style = data.getItemVisual(dataIndex, 'style');
      return style[data.getVisual('drawType')];

    case 'opacity':
      return data.getItemVisual(dataIndex, 'style').opacity;

    case 'symbol':
    case 'symbolSize':
    case 'liftZ':
      return data.getItemVisual(dataIndex, key);

    default:
      if (true) {
        console.warn("Unknown visual type " + key);
      }

  }
}
function getVisualFromData(data, key) {
  switch (key) {
    case 'color':
      var style = data.getVisual('style');
      return style[data.getVisual('drawType')];

    case 'opacity':
      return data.getVisual('style').opacity;

    case 'symbol':
    case 'symbolSize':
    case 'liftZ':
      return data.getVisual(key);

    default:
      if (true) {
        console.warn("Unknown visual type " + key);
      }

  }
}
function setItemVisualFromData(data, dataIndex, key, value) {
  switch (key) {
    case 'color':
      // Make sure not sharing style object.
      var style = data.ensureUniqueItemVisual(dataIndex, 'style');
      style[data.getVisual('drawType')] = value; // Mark the color has been changed, not from palette anymore

      data.setItemVisual(dataIndex, 'colorFromPalette', false);
      break;

    case 'opacity':
      data.ensureUniqueItemVisual(dataIndex, 'style').opacity = value;
      break;

    case 'symbol':
    case 'symbolSize':
    case 'liftZ':
      data.setItemVisual(dataIndex, key, value);
      break;

    default:
      if (true) {
        console.warn("Unknown visual type " + key);
      }

  }
}

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(1448);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isKey_js__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringToPath_js__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(1472);





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return value;
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isKey_js__["a" /* default */])(value, object) ? [value] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__stringToPath_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (castPath);


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignValue_js__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__ = __webpack_require__(340);



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__["a" /* default */])(object, key, newValue);
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assignValue_js__["a" /* default */])(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ __webpack_exports__["a"] = (copyObject);


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export debugMode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return devicePixelRatio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DARK_MODE_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DARK_LABEL_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LIGHT_LABEL_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LIGHTER_LABEL_COLOR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_env_js__ = __webpack_require__(35);

var dpr = 1;
if (__WEBPACK_IMPORTED_MODULE_0__core_env_js__["a" /* default */].hasGlobalWindow) {
    dpr = Math.max(window.devicePixelRatio
        || (window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI)
        || 1, 1);
}
var debugMode = 0;
var devicePixelRatio = dpr;
var DARK_MODE_THRESHOLD = 0.4;
var DARK_LABEL_COLOR = '#333';
var LIGHT_LABEL_COLOR = '#ccc';
var LIGHTER_LABEL_COLOR = '#eee';


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_TEXT_ANIMATION_PROPS */
/* harmony export (immutable) */ __webpack_exports__["c"] = parseFontSize;
/* harmony export (immutable) */ __webpack_exports__["b"] = hasSeparateFont;
/* unused harmony export normalizeTextStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_parseText_js__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TSpan_js__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contain_text_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Image_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shape_Rect_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Displayable_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__core_platform_js__ = __webpack_require__(67);










var DEFAULT_RICH_TEXT_COLOR = {
    fill: '#000'
};
var DEFAULT_STROKE_LINE_WIDTH = 2;
var DEFAULT_TEXT_ANIMATION_PROPS = {
    style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["defaults"])({
        fill: true,
        stroke: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineWidth: true,
        fontSize: true,
        lineHeight: true,
        width: true,
        height: true,
        textShadowColor: true,
        textShadowBlur: true,
        textShadowOffsetX: true,
        textShadowOffsetY: true,
        backgroundColor: true,
        padding: true,
        borderColor: true,
        borderWidth: true,
        borderRadius: true
    }, __WEBPACK_IMPORTED_MODULE_8__Displayable_js__["b" /* DEFAULT_COMMON_ANIMATION_PROPS */].style)
};
var ZRText = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ZRText, _super);
    function ZRText(opts) {
        var _this = _super.call(this) || this;
        _this.type = 'text';
        _this._children = [];
        _this._defaultStyle = DEFAULT_RICH_TEXT_COLOR;
        _this.attr(opts);
        return _this;
    }
    ZRText.prototype.childrenRef = function () {
        return this._children;
    };
    ZRText.prototype.update = function () {
        _super.prototype.update.call(this);
        if (this.styleChanged()) {
            this._updateSubTexts();
        }
        for (var i = 0; i < this._children.length; i++) {
            var child = this._children[i];
            child.zlevel = this.zlevel;
            child.z = this.z;
            child.z2 = this.z2;
            child.culling = this.culling;
            child.cursor = this.cursor;
            child.invisible = this.invisible;
        }
    };
    ZRText.prototype.updateTransform = function () {
        var innerTransformable = this.innerTransformable;
        if (innerTransformable) {
            innerTransformable.updateTransform();
            if (innerTransformable.transform) {
                this.transform = innerTransformable.transform;
            }
        }
        else {
            _super.prototype.updateTransform.call(this);
        }
    };
    ZRText.prototype.getLocalTransform = function (m) {
        var innerTransformable = this.innerTransformable;
        return innerTransformable
            ? innerTransformable.getLocalTransform(m)
            : _super.prototype.getLocalTransform.call(this, m);
    };
    ZRText.prototype.getComputedTransform = function () {
        if (this.__hostTarget) {
            this.__hostTarget.getComputedTransform();
            this.__hostTarget.updateInnerText(true);
        }
        return _super.prototype.getComputedTransform.call(this);
    };
    ZRText.prototype._updateSubTexts = function () {
        this._childCursor = 0;
        normalizeTextStyle(this.style);
        this.style.rich
            ? this._updateRichTexts()
            : this._updatePlainTexts();
        this._children.length = this._childCursor;
        this.styleUpdated();
    };
    ZRText.prototype.addSelfToZr = function (zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for (var i = 0; i < this._children.length; i++) {
            this._children[i].__zr = zr;
        }
    };
    ZRText.prototype.removeSelfFromZr = function (zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for (var i = 0; i < this._children.length; i++) {
            this._children[i].__zr = null;
        }
    };
    ZRText.prototype.getBoundingRect = function () {
        if (this.styleChanged()) {
            this._updateSubTexts();
        }
        if (!this._rect) {
            var tmpRect = new __WEBPACK_IMPORTED_MODULE_7__core_BoundingRect_js__["a" /* default */](0, 0, 0, 0);
            var children = this._children;
            var tmpMat = [];
            var rect = null;
            for (var i = 0; i < children.length; i++) {
                var child = children[i];
                var childRect = child.getBoundingRect();
                var transform = child.getLocalTransform(tmpMat);
                if (transform) {
                    tmpRect.copy(childRect);
                    tmpRect.applyTransform(transform);
                    rect = rect || tmpRect.clone();
                    rect.union(tmpRect);
                }
                else {
                    rect = rect || childRect.clone();
                    rect.union(childRect);
                }
            }
            this._rect = rect || tmpRect;
        }
        return this._rect;
    };
    ZRText.prototype.setDefaultTextStyle = function (defaultTextStyle) {
        this._defaultStyle = defaultTextStyle || DEFAULT_RICH_TEXT_COLOR;
    };
    ZRText.prototype.setTextContent = function (textContent) {
        if (true) {
            throw new Error('Can\'t attach text on another text');
        }
    };
    ZRText.prototype._mergeStyle = function (targetStyle, sourceStyle) {
        if (!sourceStyle) {
            return targetStyle;
        }
        var sourceRich = sourceStyle.rich;
        var targetRich = targetStyle.rich || (sourceRich && {});
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["extend"])(targetStyle, sourceStyle);
        if (sourceRich && targetRich) {
            this._mergeRich(targetRich, sourceRich);
            targetStyle.rich = targetRich;
        }
        else if (targetRich) {
            targetStyle.rich = targetRich;
        }
        return targetStyle;
    };
    ZRText.prototype._mergeRich = function (targetRich, sourceRich) {
        var richNames = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["keys"])(sourceRich);
        for (var i = 0; i < richNames.length; i++) {
            var richName = richNames[i];
            targetRich[richName] = targetRich[richName] || {};
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["extend"])(targetRich[richName], sourceRich[richName]);
        }
    };
    ZRText.prototype.getAnimationStyleProps = function () {
        return DEFAULT_TEXT_ANIMATION_PROPS;
    };
    ZRText.prototype._getOrCreateChild = function (Ctor) {
        var child = this._children[this._childCursor];
        if (!child || !(child instanceof Ctor)) {
            child = new Ctor();
        }
        this._children[this._childCursor++] = child;
        child.__zr = this.__zr;
        child.parent = this;
        return child;
    };
    ZRText.prototype._updatePlainTexts = function () {
        var style = this.style;
        var textFont = style.font || __WEBPACK_IMPORTED_MODULE_9__core_platform_js__["b" /* DEFAULT_FONT */];
        var textPadding = style.padding;
        var text = getStyleText(style);
        var contentBlock = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper_parseText_js__["a" /* parsePlainText */])(text, style);
        var needDrawBg = needDrawBackground(style);
        var bgColorDrawn = !!(style.backgroundColor);
        var outerHeight = contentBlock.outerHeight;
        var outerWidth = contentBlock.outerWidth;
        var contentWidth = contentBlock.contentWidth;
        var textLines = contentBlock.lines;
        var lineHeight = contentBlock.lineHeight;
        var defaultStyle = this._defaultStyle;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var textAlign = style.align || defaultStyle.align || 'left';
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign || 'top';
        var textX = baseX;
        var textY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__contain_text_js__["c" /* adjustTextY */])(baseY, contentBlock.contentHeight, verticalAlign);
        if (needDrawBg || textPadding) {
            var boxX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__contain_text_js__["d" /* adjustTextX */])(baseX, outerWidth, textAlign);
            var boxY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__contain_text_js__["c" /* adjustTextY */])(baseY, outerHeight, verticalAlign);
            needDrawBg && this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        }
        textY += lineHeight / 2;
        if (textPadding) {
            textX = getTextXForPadding(baseX, textAlign, textPadding);
            if (verticalAlign === 'top') {
                textY += textPadding[0];
            }
            else if (verticalAlign === 'bottom') {
                textY -= textPadding[2];
            }
        }
        var defaultLineWidth = 0;
        var useDefaultFill = false;
        var textFill = getFill('fill' in style
            ? style.fill
            : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = getStroke('stroke' in style
            ? style.stroke
            : (!bgColorDrawn
                && (!defaultStyle.autoStroke || useDefaultFill))
                ? (defaultLineWidth = DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke)
                : null);
        var hasShadow = style.textShadowBlur > 0;
        var fixedBoundingRect = style.width != null
            && (style.overflow === 'truncate' || style.overflow === 'break' || style.overflow === 'breakAll');
        var calculatedLineHeight = contentBlock.calculatedLineHeight;
        for (var i = 0; i < textLines.length; i++) {
            var el = this._getOrCreateChild(__WEBPACK_IMPORTED_MODULE_2__TSpan_js__["a" /* default */]);
            var subElStyle = el.createStyle();
            el.useStyle(subElStyle);
            subElStyle.text = textLines[i];
            subElStyle.x = textX;
            subElStyle.y = textY;
            if (textAlign) {
                subElStyle.textAlign = textAlign;
            }
            subElStyle.textBaseline = 'middle';
            subElStyle.opacity = style.opacity;
            subElStyle.strokeFirst = true;
            if (hasShadow) {
                subElStyle.shadowBlur = style.textShadowBlur || 0;
                subElStyle.shadowColor = style.textShadowColor || 'transparent';
                subElStyle.shadowOffsetX = style.textShadowOffsetX || 0;
                subElStyle.shadowOffsetY = style.textShadowOffsetY || 0;
            }
            subElStyle.stroke = textStroke;
            subElStyle.fill = textFill;
            if (textStroke) {
                subElStyle.lineWidth = style.lineWidth || defaultLineWidth;
                subElStyle.lineDash = style.lineDash;
                subElStyle.lineDashOffset = style.lineDashOffset || 0;
            }
            subElStyle.font = textFont;
            setSeparateFont(subElStyle, style);
            textY += lineHeight;
            if (fixedBoundingRect) {
                el.setBoundingRect(new __WEBPACK_IMPORTED_MODULE_7__core_BoundingRect_js__["a" /* default */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__contain_text_js__["d" /* adjustTextX */])(subElStyle.x, style.width, subElStyle.textAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__contain_text_js__["c" /* adjustTextY */])(subElStyle.y, calculatedLineHeight, subElStyle.textBaseline), contentWidth, calculatedLineHeight));
            }
        }
    };
    ZRText.prototype._updateRichTexts = function () {
        var style = this.style;
        var text = getStyleText(style);
        var contentBlock = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper_parseText_js__["b" /* parseRichText */])(text, style);
        var contentWidth = contentBlock.width;
        var outerWidth = contentBlock.outerWidth;
        var outerHeight = contentBlock.outerHeight;
        var textPadding = style.padding;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var defaultStyle = this._defaultStyle;
        var textAlign = style.align || defaultStyle.align;
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign;
        var boxX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__contain_text_js__["d" /* adjustTextX */])(baseX, outerWidth, textAlign);
        var boxY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__contain_text_js__["c" /* adjustTextY */])(baseY, outerHeight, verticalAlign);
        var xLeft = boxX;
        var lineTop = boxY;
        if (textPadding) {
            xLeft += textPadding[3];
            lineTop += textPadding[0];
        }
        var xRight = xLeft + contentWidth;
        if (needDrawBackground(style)) {
            this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        }
        var bgColorDrawn = !!(style.backgroundColor);
        for (var i = 0; i < contentBlock.lines.length; i++) {
            var line = contentBlock.lines[i];
            var tokens = line.tokens;
            var tokenCount = tokens.length;
            var lineHeight = line.lineHeight;
            var remainedWidth = line.width;
            var leftIndex = 0;
            var lineXLeft = xLeft;
            var lineXRight = xRight;
            var rightIndex = tokenCount - 1;
            var token = void 0;
            while (leftIndex < tokenCount
                && (token = tokens[leftIndex], !token.align || token.align === 'left')) {
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft, 'left', bgColorDrawn);
                remainedWidth -= token.width;
                lineXLeft += token.width;
                leftIndex++;
            }
            while (rightIndex >= 0
                && (token = tokens[rightIndex], token.align === 'right')) {
                this._placeToken(token, style, lineHeight, lineTop, lineXRight, 'right', bgColorDrawn);
                remainedWidth -= token.width;
                lineXRight -= token.width;
                rightIndex--;
            }
            lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - remainedWidth) / 2;
            while (leftIndex <= rightIndex) {
                token = tokens[leftIndex];
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center', bgColorDrawn);
                lineXLeft += token.width;
                leftIndex++;
            }
            lineTop += lineHeight;
        }
    };
    ZRText.prototype._placeToken = function (token, style, lineHeight, lineTop, x, textAlign, parentBgColorDrawn) {
        var tokenStyle = style.rich[token.styleName] || {};
        tokenStyle.text = token.text;
        var verticalAlign = token.verticalAlign;
        var y = lineTop + lineHeight / 2;
        if (verticalAlign === 'top') {
            y = lineTop + token.height / 2;
        }
        else if (verticalAlign === 'bottom') {
            y = lineTop + lineHeight - token.height / 2;
        }
        var needDrawBg = !token.isLineHolder && needDrawBackground(tokenStyle);
        needDrawBg && this._renderBackground(tokenStyle, style, textAlign === 'right'
            ? x - token.width
            : textAlign === 'center'
                ? x - token.width / 2
                : x, y - token.height / 2, token.width, token.height);
        var bgColorDrawn = !!tokenStyle.backgroundColor;
        var textPadding = token.textPadding;
        if (textPadding) {
            x = getTextXForPadding(x, textAlign, textPadding);
            y -= token.height / 2 - textPadding[0] - token.innerHeight / 2;
        }
        var el = this._getOrCreateChild(__WEBPACK_IMPORTED_MODULE_2__TSpan_js__["a" /* default */]);
        var subElStyle = el.createStyle();
        el.useStyle(subElStyle);
        var defaultStyle = this._defaultStyle;
        var useDefaultFill = false;
        var defaultLineWidth = 0;
        var textFill = getFill('fill' in tokenStyle ? tokenStyle.fill
            : 'fill' in style ? style.fill
                : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = getStroke('stroke' in tokenStyle ? tokenStyle.stroke
            : 'stroke' in style ? style.stroke
                : (!bgColorDrawn
                    && !parentBgColorDrawn
                    && (!defaultStyle.autoStroke || useDefaultFill)) ? (defaultLineWidth = DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke)
                    : null);
        var hasShadow = tokenStyle.textShadowBlur > 0
            || style.textShadowBlur > 0;
        subElStyle.text = token.text;
        subElStyle.x = x;
        subElStyle.y = y;
        if (hasShadow) {
            subElStyle.shadowBlur = tokenStyle.textShadowBlur || style.textShadowBlur || 0;
            subElStyle.shadowColor = tokenStyle.textShadowColor || style.textShadowColor || 'transparent';
            subElStyle.shadowOffsetX = tokenStyle.textShadowOffsetX || style.textShadowOffsetX || 0;
            subElStyle.shadowOffsetY = tokenStyle.textShadowOffsetY || style.textShadowOffsetY || 0;
        }
        subElStyle.textAlign = textAlign;
        subElStyle.textBaseline = 'middle';
        subElStyle.font = token.font || __WEBPACK_IMPORTED_MODULE_9__core_platform_js__["b" /* DEFAULT_FONT */];
        subElStyle.opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["retrieve3"])(tokenStyle.opacity, style.opacity, 1);
        setSeparateFont(subElStyle, tokenStyle);
        if (textStroke) {
            subElStyle.lineWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["retrieve3"])(tokenStyle.lineWidth, style.lineWidth, defaultLineWidth);
            subElStyle.lineDash = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["retrieve2"])(tokenStyle.lineDash, style.lineDash);
            subElStyle.lineDashOffset = style.lineDashOffset || 0;
            subElStyle.stroke = textStroke;
        }
        if (textFill) {
            subElStyle.fill = textFill;
        }
        var textWidth = token.contentWidth;
        var textHeight = token.contentHeight;
        el.setBoundingRect(new __WEBPACK_IMPORTED_MODULE_7__core_BoundingRect_js__["a" /* default */](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__contain_text_js__["d" /* adjustTextX */])(subElStyle.x, textWidth, subElStyle.textAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__contain_text_js__["c" /* adjustTextY */])(subElStyle.y, textHeight, subElStyle.textBaseline), textWidth, textHeight));
    };
    ZRText.prototype._renderBackground = function (style, topStyle, x, y, width, height) {
        var textBackgroundColor = style.backgroundColor;
        var textBorderWidth = style.borderWidth;
        var textBorderColor = style.borderColor;
        var isImageBg = textBackgroundColor && textBackgroundColor.image;
        var isPlainOrGradientBg = textBackgroundColor && !isImageBg;
        var textBorderRadius = style.borderRadius;
        var self = this;
        var rectEl;
        var imgEl;
        if (isPlainOrGradientBg || style.lineHeight || (textBorderWidth && textBorderColor)) {
            rectEl = this._getOrCreateChild(__WEBPACK_IMPORTED_MODULE_6__shape_Rect_js__["a" /* default */]);
            rectEl.useStyle(rectEl.createStyle());
            rectEl.style.fill = null;
            var rectShape = rectEl.shape;
            rectShape.x = x;
            rectShape.y = y;
            rectShape.width = width;
            rectShape.height = height;
            rectShape.r = textBorderRadius;
            rectEl.dirtyShape();
        }
        if (isPlainOrGradientBg) {
            var rectStyle = rectEl.style;
            rectStyle.fill = textBackgroundColor || null;
            rectStyle.fillOpacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["retrieve2"])(style.fillOpacity, 1);
        }
        else if (isImageBg) {
            imgEl = this._getOrCreateChild(__WEBPACK_IMPORTED_MODULE_5__Image_js__["a" /* default */]);
            imgEl.onload = function () {
                self.dirtyStyle();
            };
            var imgStyle = imgEl.style;
            imgStyle.image = textBackgroundColor.image;
            imgStyle.x = x;
            imgStyle.y = y;
            imgStyle.width = width;
            imgStyle.height = height;
        }
        if (textBorderWidth && textBorderColor) {
            var rectStyle = rectEl.style;
            rectStyle.lineWidth = textBorderWidth;
            rectStyle.stroke = textBorderColor;
            rectStyle.strokeOpacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["retrieve2"])(style.strokeOpacity, 1);
            rectStyle.lineDash = style.borderDash;
            rectStyle.lineDashOffset = style.borderDashOffset || 0;
            rectEl.strokeContainThreshold = 0;
            if (rectEl.hasFill() && rectEl.hasStroke()) {
                rectStyle.strokeFirst = true;
                rectStyle.lineWidth *= 2;
            }
        }
        var commonStyle = (rectEl || imgEl).style;
        commonStyle.shadowBlur = style.shadowBlur || 0;
        commonStyle.shadowColor = style.shadowColor || 'transparent';
        commonStyle.shadowOffsetX = style.shadowOffsetX || 0;
        commonStyle.shadowOffsetY = style.shadowOffsetY || 0;
        commonStyle.opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["retrieve3"])(style.opacity, topStyle.opacity, 1);
    };
    ZRText.makeFont = function (style) {
        var font = '';
        if (hasSeparateFont(style)) {
            font = [
                style.fontStyle,
                style.fontWeight,
                parseFontSize(style.fontSize),
                style.fontFamily || 'sans-serif'
            ].join(' ');
        }
        return font && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["trim"])(font) || style.textFont || style.font;
    };
    return ZRText;
}(__WEBPACK_IMPORTED_MODULE_8__Displayable_js__["c" /* default */]));
var VALID_TEXT_ALIGN = { left: true, right: 1, center: 1 };
var VALID_TEXT_VERTICAL_ALIGN = { top: 1, bottom: 1, middle: 1 };
var FONT_PARTS = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily'];
function parseFontSize(fontSize) {
    if (typeof fontSize === 'string'
        && (fontSize.indexOf('px') !== -1
            || fontSize.indexOf('rem') !== -1
            || fontSize.indexOf('em') !== -1)) {
        return fontSize;
    }
    else if (!isNaN(+fontSize)) {
        return fontSize + 'px';
    }
    else {
        return __WEBPACK_IMPORTED_MODULE_9__core_platform_js__["c" /* DEFAULT_FONT_SIZE */] + 'px';
    }
}
function setSeparateFont(targetStyle, sourceStyle) {
    for (var i = 0; i < FONT_PARTS.length; i++) {
        var fontProp = FONT_PARTS[i];
        var val = sourceStyle[fontProp];
        if (val != null) {
            targetStyle[fontProp] = val;
        }
    }
}
function hasSeparateFont(style) {
    return style.fontSize != null || style.fontFamily || style.fontWeight;
}
function normalizeTextStyle(style) {
    normalizeStyle(style);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["each"])(style.rich, normalizeStyle);
    return style;
}
function normalizeStyle(style) {
    if (style) {
        style.font = ZRText.makeFont(style);
        var textAlign = style.align;
        textAlign === 'middle' && (textAlign = 'center');
        style.align = (textAlign == null || VALID_TEXT_ALIGN[textAlign]) ? textAlign : 'left';
        var verticalAlign = style.verticalAlign;
        verticalAlign === 'center' && (verticalAlign = 'middle');
        style.verticalAlign = (verticalAlign == null || VALID_TEXT_VERTICAL_ALIGN[verticalAlign]) ? verticalAlign : 'top';
        var textPadding = style.padding;
        if (textPadding) {
            style.padding = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["normalizeCssArray"])(style.padding);
        }
    }
}
function getStroke(stroke, lineWidth) {
    return (stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none')
        ? null
        : (stroke.image || stroke.colorStops)
            ? '#000'
            : stroke;
}
function getFill(fill) {
    return (fill == null || fill === 'none')
        ? null
        : (fill.image || fill.colorStops)
            ? '#000'
            : fill;
}
function getTextXForPadding(x, textAlign, textPadding) {
    return textAlign === 'right'
        ? (x - textPadding[1])
        : textAlign === 'center'
            ? (x + textPadding[3] / 2 - textPadding[1] / 2)
            : (x + textPadding[3]);
}
function getStyleText(style) {
    var text = style.text;
    text != null && (text += '');
    return text;
}
function needDrawBackground(style) {
    return !!(style.backgroundColor
        || style.lineHeight
        || (style.borderWidth && style.borderColor));
}
/* harmony default export */ __webpack_exports__["a"] = (ZRText);


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony export (immutable) */ __webpack_exports__["c"] = normalizeColor;
/* harmony export (immutable) */ __webpack_exports__["g"] = isAroundZero;
/* unused harmony export round3 */
/* harmony export (immutable) */ __webpack_exports__["o"] = round4;
/* unused harmony export round1 */
/* harmony export (immutable) */ __webpack_exports__["h"] = getMatrixStr;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return TEXT_ALIGN_TO_ANCHOR; });
/* harmony export (immutable) */ __webpack_exports__["j"] = adjustTextY;
/* harmony export (immutable) */ __webpack_exports__["l"] = hasShadow;
/* harmony export (immutable) */ __webpack_exports__["m"] = getShadowKey;
/* unused harmony export getClipPathsKey */
/* harmony export (immutable) */ __webpack_exports__["p"] = isImagePattern;
/* unused harmony export isSVGPattern */
/* harmony export (immutable) */ __webpack_exports__["f"] = isPattern;
/* harmony export (immutable) */ __webpack_exports__["a"] = isLinearGradient;
/* harmony export (immutable) */ __webpack_exports__["b"] = isRadialGradient;
/* harmony export (immutable) */ __webpack_exports__["e"] = isGradient;
/* harmony export (immutable) */ __webpack_exports__["n"] = getIdURL;
/* harmony export (immutable) */ __webpack_exports__["i"] = getPathPrecision;
/* harmony export (immutable) */ __webpack_exports__["q"] = getSRTTransformString;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return encodeBase64; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tool_color_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_env_js__ = __webpack_require__(35);



var mathRound = Math.round;
function normalizeColor(color) {
    var opacity;
    if (!color || color === 'transparent') {
        color = 'none';
    }
    else if (typeof color === 'string' && color.indexOf('rgba') > -1) {
        var arr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tool_color_js__["parse"])(color);
        if (arr) {
            color = 'rgb(' + arr[0] + ',' + arr[1] + ',' + arr[2] + ')';
            opacity = arr[3];
        }
    }
    return {
        color: color,
        opacity: opacity == null ? 1 : opacity
    };
}
var EPSILON = 1e-4;
function isAroundZero(transform) {
    return transform < EPSILON && transform > -EPSILON;
}
function round3(transform) {
    return mathRound(transform * 1e3) / 1e3;
}
function round4(transform) {
    return mathRound(transform * 1e4) / 1e4;
}
function round1(transform) {
    return mathRound(transform * 10) / 10;
}
function getMatrixStr(m) {
    return 'matrix('
        + round3(m[0]) + ','
        + round3(m[1]) + ','
        + round3(m[2]) + ','
        + round3(m[3]) + ','
        + round4(m[4]) + ','
        + round4(m[5])
        + ')';
}
var TEXT_ALIGN_TO_ANCHOR = {
    left: 'start',
    right: 'end',
    center: 'middle',
    middle: 'middle'
};
function adjustTextY(y, lineHeight, textBaseline) {
    if (textBaseline === 'top') {
        y += lineHeight / 2;
    }
    else if (textBaseline === 'bottom') {
        y -= lineHeight / 2;
    }
    return y;
}
function hasShadow(style) {
    return style
        && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY);
}
function getShadowKey(displayable) {
    var style = displayable.style;
    var globalScale = displayable.getGlobalScale();
    return [
        style.shadowColor,
        (style.shadowBlur || 0).toFixed(2),
        (style.shadowOffsetX || 0).toFixed(2),
        (style.shadowOffsetY || 0).toFixed(2),
        globalScale[0],
        globalScale[1]
    ].join(',');
}
function getClipPathsKey(clipPaths) {
    var key = [];
    if (clipPaths) {
        for (var i = 0; i < clipPaths.length; i++) {
            var clipPath = clipPaths[i];
            key.push(clipPath.id);
        }
    }
    return key.join(',');
}
function isImagePattern(val) {
    return val && (!!val.image);
}
function isSVGPattern(val) {
    return val && (!!val.svgElement);
}
function isPattern(val) {
    return isImagePattern(val) || isSVGPattern(val);
}
function isLinearGradient(val) {
    return val.type === 'linear';
}
function isRadialGradient(val) {
    return val.type === 'radial';
}
function isGradient(val) {
    return val && (val.type === 'linear'
        || val.type === 'radial');
}
function getIdURL(id) {
    return "url(#" + id + ")";
}
function getPathPrecision(el) {
    var scale = el.getGlobalScale();
    var size = Math.max(scale[0], scale[1]);
    return Math.max(Math.ceil(Math.log(size) / Math.log(10)), 1);
}
function getSRTTransformString(transform) {
    var x = transform.x || 0;
    var y = transform.y || 0;
    var rotation = (transform.rotation || 0) * __WEBPACK_IMPORTED_MODULE_0__core_util_js__["RADIAN_TO_DEGREE"];
    var scaleX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["retrieve2"])(transform.scaleX, 1);
    var scaleY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["retrieve2"])(transform.scaleY, 1);
    var skewX = transform.skewX || 0;
    var skewY = transform.skewY || 0;
    var res = [];
    if (x || y) {
        res.push("translate(" + x + "px," + y + "px)");
    }
    if (rotation) {
        res.push("rotate(" + rotation + ")");
    }
    if (scaleX !== 1 || scaleY !== 1) {
        res.push("scale(" + scaleX + "," + scaleY + ")");
    }
    if (skewX || skewY) {
        res.push("skew(" + mathRound(skewX * __WEBPACK_IMPORTED_MODULE_0__core_util_js__["RADIAN_TO_DEGREE"]) + "deg, " + mathRound(skewY * __WEBPACK_IMPORTED_MODULE_0__core_util_js__["RADIAN_TO_DEGREE"]) + "deg)");
    }
    return res.join(' ');
}
var encodeBase64 = (function () {
    if (__WEBPACK_IMPORTED_MODULE_2__core_env_js__["a" /* default */].hasGlobalWindow && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["isFunction"])(window.btoa)) {
        return function (str) {
            return window.btoa(unescape(str));
        };
    }
    if (typeof Buffer !== 'undefined') {
        return function (str) {
            return Buffer.from(str).toString('base64');
        };
    }
    return function (str) {
        if (true) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["logError"])('Base64 isn\'t natively supported in the current environment.');
        }
        return null;
    };
})();

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(264).Buffer))

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = moment;

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 全局参数配置
// console.log('process.en', process.env);
/* harmony default export */ __webpack_exports__["a"] = ({
  NODE_ENV: "prod",
  BASE_URL: "https://china-event-planning-service.roche.com.cn",
  PORTAL_DOMAIN: "https://portal.roche.com.cn",
  ENVIRONMENT: "Production",
  A1_PORTAL: "https://a1-team.roche.com.cn",
  DASHBOARD_URL: "https://tableau.ccas.roche.com",
  DASHBOARD_BUDGET_URL: "views/Dashboard_online_version0829/sheet0",
  DASHBOARD_MEETING_URL: "views/Dashboard_online_version0829/--",
  DASHBOARD_SCORE_URL: "views/Dashboard_online_version0829/sheet7"
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return E2E_TOKEN_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return E2E_INTL_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return E2E_LANGUAGE_STORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return E2E_FILE_TYPE_ENUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return File_Type_Name_Mapping; });
/* unused harmony export Quarterly_Plan_Status_Enum */
/* unused harmony export E2E_MAP_KEY */
var E2E_TOKEN_NAME = 'X-Access-Token';
var E2E_INTL_HEADER = 'Accept-Language';

var E2E_LANGUAGE_STORAGE_KEY = 'locale'; // 国际化 在 localstorage 存储的key

var E2E_FILE_TYPE_ENUM = {
  pdf: ['pdf'],
  image: ['png', 'jpg', 'jpeg', 'svg', 'gif'],
  excel: ['xls', 'xlsx'],
  word: ['doc', 'docx'],
  ppt: ['ppt', 'pptx'],
  msg: ['msg'],
  video: ['mp4', 'mpeg', 'avi', 'asf', 'mov', '3gp', 'wmv', 'rm', 'rmvb', 'flv', 'f4v']
};

// filebox 组件中 选择的支持上传的文件类型对应显示的名称信息
var File_Type_Name_Mapping = {
  pdf: {
    en: 'PDF',
    zh: 'PDF'
  },
  image: {
    en: 'Image',
    zh: 'Image'
  },
  excel: {
    en: 'Excel',
    zh: 'Excel'
  },
  word: {
    en: 'Word',
    zh: 'Word'
  },
  ppt: {
    en: 'PPT',
    ZH: 'PPT'
  },
  msg: {
    en: 'Msg',
    zh: 'Msg'
  }
};

// quarterly plan 状态和 value 的对应值
var Quarterly_Plan_Status_Enum = {
  draft: {
    text: 'quarterlyPlan.label.draft', // 国际化 key
    value: 1
  },
  inprogress: {
    text: 'quarterlyPlan.label.inprogress',
    value: 2
  },
  todo: {
    text: 'quarterlyPlan.label.todo',
    value: 3
  },
  approved: {
    text: 'quarterlyPlan.label.approved',
    value: 4
  },
  rejected: {
    text: 'quarterlyPlan.label.rejected',
    value: 5
  }
};

var E2E_MAP_KEY = '4660673a7aff6e995fec5bcc74caf03a';

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return keys; });
var getItem = function getItem(key) {
  var value = window.localStorage.getItem(key) || null;
  return value;
};
var setItem = function setItem(key, value) {
  window.localStorage.setItem(key, value);
};

var removeItem = function removeItem(key) {
  window.localStorage.removeItem(key);
};

var keys = {
  'MyTaskActionDate': 'event-planning-my-task-action-date',
  'MyLibrarySearchMainData': 'event-planning-my-library-search-main-data',
  'MyLibrarySearchDetailData': 'event-planning-my-library-search-detail-data',
  'MyTaskSearchMainData': 'event-planning-my-task-search-main-data',
  'MyTaskSearchDetailData': 'event-planning-my-task-search-detail-data',
  'MyAuthorizedTaskSearchMainData': 'event-planning-my-authorized-task-search-main-data',
  'MyAuthorizedTaskSearchDetailData': 'event-planning-my-authorized-task-search-detail-data',
  'MyApplicationSearchMainData': 'event-planning-my-application-search-main-data',
  'MyApplicationSearchDetailData': 'event-planning-my-application-search-detail-data',
  'UserSelectedRoleInMyTask': 'event-planning-user-selected-role-in-my-task'
};

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = ({
  queryBusDataOrg: function queryBusDataOrg(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/bus/busDataOrg/queryBusDataOrg', params);
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_login__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_overall__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_basedata__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_systemnotice__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_unapprove__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex_along__ = __webpack_require__(1688);












__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* default */]);

var debug = !(global.NODE_ENV == 'production' || global.NODE_ENV == 'test');
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* default */].Store({
  strict: debug,
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__["a" /* default */],
  modules: {
    login: __WEBPACK_IMPORTED_MODULE_4__modules_login__["a" /* default */],
    overall: __WEBPACK_IMPORTED_MODULE_5__modules_overall__["a" /* default */],
    basedata: __WEBPACK_IMPORTED_MODULE_6__modules_basedata__["a" /* default */],
    systemnotice: __WEBPACK_IMPORTED_MODULE_7__modules_systemnotice__["a" /* default */],
    unapprove: __WEBPACK_IMPORTED_MODULE_8__modules_unapprove__["a" /* default */]
  },
  plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex_along__["a" /* default */])({
    name: "roche-event-planning",
    session: { list: [], isFilter: true },
    justSession: true
  })]
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(50)))

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 176 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(105);
var call = __webpack_require__(392);
var isArrayIter = __webpack_require__(390);
var anObject = __webpack_require__(94);
var toLength = __webpack_require__(212);
var getIterFn = __webpack_require__(282);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(396);
var enumBugKeys = __webpack_require__(268);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(71).f;
var has = __webpack_require__(120);
var TAG = __webpack_require__(45)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(795);
var global = __webpack_require__(44);
var hide = __webpack_require__(106);
var Iterators = __webpack_require__(143);
var TO_STRING_TAG = __webpack_require__(45)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(9);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(72);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 185 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(73);
var global = __webpack_require__(13);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(108) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(9);
var aFunction = __webpack_require__(46);
var SPECIES = __webpack_require__(25)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Symbol_js__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__label_labelStyle_js__ = __webpack_require__(15);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





function symbolNeedsDraw(data, point, idx, opt) {
  return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx)) // We do not set clipShape on group, because it will cut part of
  // the symbol element shape. We use the same clip shape here as
  // the line clip.
  && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, 'symbol') !== 'none';
}

function normalizeUpdateOpt(opt) {
  if (opt != null && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isObject"])(opt)) {
    opt = {
      isIgnore: opt
    };
  }

  return opt || {};
}

function makeSeriesScope(data) {
  var seriesModel = data.hostModel;
  var emphasisModel = seriesModel.getModel('emphasis');
  return {
    emphasisItemStyle: emphasisModel.getModel('itemStyle').getItemStyle(),
    blurItemStyle: seriesModel.getModel(['blur', 'itemStyle']).getItemStyle(),
    selectItemStyle: seriesModel.getModel(['select', 'itemStyle']).getItemStyle(),
    focus: emphasisModel.get('focus'),
    blurScope: emphasisModel.get('blurScope'),
    emphasisDisabled: emphasisModel.get('disabled'),
    hoverScale: emphasisModel.get('scale'),
    labelStatesModels: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__label_labelStyle_js__["f" /* getLabelStatesModels */])(seriesModel),
    cursorStyle: seriesModel.get('cursor')
  };
}

var SymbolDraw =
/** @class */
function () {
  function SymbolDraw(SymbolCtor) {
    this.group = new __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Group"]();
    this._SymbolCtor = SymbolCtor || __WEBPACK_IMPORTED_MODULE_1__Symbol_js__["a" /* default */];
  }
  /**
   * Update symbols draw by new data
   */


  SymbolDraw.prototype.updateData = function (data, opt) {
    // Remove progressive els.
    this._progressiveEls = null;
    opt = normalizeUpdateOpt(opt);
    var group = this.group;
    var seriesModel = data.hostModel;
    var oldData = this._data;
    var SymbolCtor = this._SymbolCtor;
    var disableAnimation = opt.disableAnimation;
    var seriesScope = makeSeriesScope(data);
    var symbolUpdateOpt = {
      disableAnimation: disableAnimation
    };

    var getSymbolPoint = opt.getSymbolPoint || function (idx) {
      return data.getItemLayout(idx);
    }; // There is no oldLineData only when first rendering or switching from
    // stream mode to normal mode, where previous elements should be removed.


    if (!oldData) {
      group.removeAll();
    }

    data.diff(oldData).add(function (newIdx) {
      var point = getSymbolPoint(newIdx);

      if (symbolNeedsDraw(data, point, newIdx, opt)) {
        var symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
        symbolEl.setPosition(point);
        data.setItemGraphicEl(newIdx, symbolEl);
        group.add(symbolEl);
      }
    }).update(function (newIdx, oldIdx) {
      var symbolEl = oldData.getItemGraphicEl(oldIdx);
      var point = getSymbolPoint(newIdx);

      if (!symbolNeedsDraw(data, point, newIdx, opt)) {
        group.remove(symbolEl);
        return;
      }

      var newSymbolType = data.getItemVisual(newIdx, 'symbol') || 'circle';
      var oldSymbolType = symbolEl && symbolEl.getSymbolType && symbolEl.getSymbolType();

      if (!symbolEl // Create a new if symbol type changed.
      || oldSymbolType && oldSymbolType !== newSymbolType) {
        group.remove(symbolEl);
        symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
        symbolEl.setPosition(point);
      } else {
        symbolEl.updateData(data, newIdx, seriesScope, symbolUpdateOpt);
        var target = {
          x: point[0],
          y: point[1]
        };
        disableAnimation ? symbolEl.attr(target) : __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["updateProps"](symbolEl, target, seriesModel);
      } // Add back


      group.add(symbolEl);
      data.setItemGraphicEl(newIdx, symbolEl);
    }).remove(function (oldIdx) {
      var el = oldData.getItemGraphicEl(oldIdx);
      el && el.fadeOut(function () {
        group.remove(el);
      }, seriesModel);
    }).execute();
    this._getSymbolPoint = getSymbolPoint;
    this._data = data;
  };

  ;

  SymbolDraw.prototype.updateLayout = function () {
    var _this = this;

    var data = this._data;

    if (data) {
      // Not use animation
      data.eachItemGraphicEl(function (el, idx) {
        var point = _this._getSymbolPoint(idx);

        el.setPosition(point);
        el.markRedraw();
      });
    }
  };

  ;

  SymbolDraw.prototype.incrementalPrepareUpdate = function (data) {
    this._seriesScope = makeSeriesScope(data);
    this._data = null;
    this.group.removeAll();
  };

  ;
  /**
   * Update symbols draw by new data
   */

  SymbolDraw.prototype.incrementalUpdate = function (taskParams, data, opt) {
    // Clear
    this._progressiveEls = [];
    opt = normalizeUpdateOpt(opt);

    function updateIncrementalAndHover(el) {
      if (!el.isGroup) {
        el.incremental = true;
        el.ensureState('emphasis').hoverLayer = true;
      }
    }

    for (var idx = taskParams.start; idx < taskParams.end; idx++) {
      var point = data.getItemLayout(idx);

      if (symbolNeedsDraw(data, point, idx, opt)) {
        var el = new this._SymbolCtor(data, idx, this._seriesScope);
        el.traverse(updateIncrementalAndHover);
        el.setPosition(point);
        this.group.add(el);
        data.setItemGraphicEl(idx, el);

        this._progressiveEls.push(el);
      }
    }
  };

  ;

  SymbolDraw.prototype.eachRendered = function (cb) {
    __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["traverseElements"](this._progressiveEls || this.group, cb);
  };

  SymbolDraw.prototype.remove = function (enableAnimation) {
    var group = this.group;
    var data = this._data; // Incremental model do not have this._data.

    if (data && enableAnimation) {
      data.eachItemGraphicEl(function (el) {
        el.fadeOut(function () {
          group.remove(el);
        }, data.hostModel);
      });
    } else {
      group.removeAll();
    }
  };

  ;
  return SymbolDraw;
}();

/* harmony default export */ __webpack_exports__["a"] = (SymbolDraw);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createGridClipPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createPolarClipPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createClipPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




function createGridClipPath(cartesian, hasAnimation, seriesModel, done, during) {
  var rect = cartesian.getArea();
  var x = rect.x;
  var y = rect.y;
  var width = rect.width;
  var height = rect.height;
  var lineWidth = seriesModel.get(['lineStyle', 'width']) || 2; // Expand the clip path a bit to avoid the border is clipped and looks thinner

  x -= lineWidth / 2;
  y -= lineWidth / 2;
  width += lineWidth;
  height += lineWidth; // fix: https://github.com/apache/incubator-echarts/issues/11369

  x = Math.floor(x);
  width = Math.round(width);
  var clipPath = new __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Rect"]({
    shape: {
      x: x,
      y: y,
      width: width,
      height: height
    }
  });

  if (hasAnimation) {
    var baseAxis = cartesian.getBaseAxis();
    var isHorizontal = baseAxis.isHorizontal();
    var isAxisInversed = baseAxis.inverse;

    if (isHorizontal) {
      if (isAxisInversed) {
        clipPath.shape.x += width;
      }

      clipPath.shape.width = 0;
    } else {
      if (!isAxisInversed) {
        clipPath.shape.y += height;
      }

      clipPath.shape.height = 0;
    }

    var duringCb = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isFunction"])(during) ? function (percent) {
      during(percent, clipPath);
    } : null;
    __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["initProps"](clipPath, {
      shape: {
        width: width,
        height: height,
        x: x,
        y: y
      }
    }, seriesModel, null, done, duringCb);
  }

  return clipPath;
}

function createPolarClipPath(polar, hasAnimation, seriesModel) {
  var sectorArea = polar.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.

  var r0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["d" /* round */])(sectorArea.r0, 1);
  var r = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["d" /* round */])(sectorArea.r, 1);
  var clipPath = new __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Sector"]({
    shape: {
      cx: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["d" /* round */])(polar.cx, 1),
      cy: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["d" /* round */])(polar.cy, 1),
      r0: r0,
      r: r,
      startAngle: sectorArea.startAngle,
      endAngle: sectorArea.endAngle,
      clockwise: sectorArea.clockwise
    }
  });

  if (hasAnimation) {
    var isRadial = polar.getBaseAxis().dim === 'angle';

    if (isRadial) {
      clipPath.shape.endAngle = sectorArea.startAngle;
    } else {
      clipPath.shape.r = r0;
    }

    __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["initProps"](clipPath, {
      shape: {
        endAngle: sectorArea.endAngle,
        r: r
      }
    }, seriesModel);
  }

  return clipPath;
}

function createClipPath(coordSys, hasAnimation, seriesModel, done, during) {
  if (!coordSys) {
    return null;
  } else if (coordSys.type === 'polar') {
    return createPolarClipPath(coordSys, hasAnimation, seriesModel);
  } else if (coordSys.type === 'cartesian2d') {
    return createGridClipPath(coordSys, hasAnimation, seriesModel, done, during);
  }

  return null;
}



/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDefaultLabel;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDefaultInterpolatedLabel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_helper_dataProvider_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * @return label string. Not null/undefined
 */

function getDefaultLabel(data, dataIndex) {
  var labelDims = data.mapDimensionsAll('defaultedLabel');
  var len = labelDims.length; // Simple optimization (in lots of cases, label dims length is 1)

  if (len === 1) {
    var rawVal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__data_helper_dataProvider_js__["a" /* retrieveRawValue */])(data, dataIndex, labelDims[0]);
    return rawVal != null ? rawVal + '' : null;
  } else if (len) {
    var vals = [];

    for (var i = 0; i < labelDims.length; i++) {
      vals.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__data_helper_dataProvider_js__["a" /* retrieveRawValue */])(data, dataIndex, labelDims[i]));
    }

    return vals.join(' ');
  }
}
function getDefaultInterpolatedLabel(data, interpolatedValue) {
  var labelDims = data.mapDimensionsAll('defaultedLabel');

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(interpolatedValue)) {
    return interpolatedValue + '';
  }

  var vals = [];

  for (var i = 0; i < labelDims.length; i++) {
    var dimIndex = data.getDimensionIndex(labelDims[i]);

    if (dimIndex >= 0) {
      vals.push(interpolatedValue[dimIndex]);
    }
  }

  return vals.join(' ');
}

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axis_AxisView_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartesianAxisPointer_js__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AxisPointerModel_js__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AxisPointerView_js__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modelHelper_js__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__axisTrigger_js__ = __webpack_require__(1207);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







function install(registers) {
  // CartesianAxisPointer is not supposed to be required here. But consider
  // echarts.simple.js and online build tooltip, which only require gridSimple,
  // CartesianAxisPointer should be able to required somewhere.
  __WEBPACK_IMPORTED_MODULE_0__axis_AxisView_js__["a" /* default */].registerAxisPointerClass('CartesianAxisPointer', __WEBPACK_IMPORTED_MODULE_1__CartesianAxisPointer_js__["a" /* default */]);
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_2__AxisPointerModel_js__["a" /* default */]);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_3__AxisPointerView_js__["a" /* default */]);
  registers.registerPreprocessor(function (option) {
    // Always has a global axisPointerModel for default setting.
    if (option) {
      (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
      var link = option.axisPointer.link; // Normalize to array to avoid object mergin. But if link
      // is not set, remain null/undefined, otherwise it will
      // override existent link setting.

      if (link && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["isArray"])(link)) {
        option.axisPointer.link = [link];
      }
    }
  }); // This process should proformed after coordinate systems created
  // and series data processed. So put it on statistic processing stage.

  registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, function (ecModel, api) {
    // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
    // allAxesInfo should be updated when setOption performed.
    ecModel.getComponent('axisPointer').coordSysAxesInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__modelHelper_js__["a" /* collect */])(ecModel, api);
  }); // Broadcast to all views.

  registers.registerAction({
    type: 'updateAxisPointer',
    event: 'updateAxisPointer',
    update: ':updateAxisPointer'
  }, __WEBPACK_IMPORTED_MODULE_6__axisTrigger_js__["a" /* default */]);
}

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_Eventful_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_event_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interactionMutex_js__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





;

var RoamController =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(RoamController, _super);

  function RoamController(zr) {
    var _this = _super.call(this) || this;

    _this._zr = zr; // Avoid two roamController bind the same handler

    var mousedownHandler = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["bind"])(_this._mousedownHandler, _this);
    var mousemoveHandler = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["bind"])(_this._mousemoveHandler, _this);
    var mouseupHandler = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["bind"])(_this._mouseupHandler, _this);
    var mousewheelHandler = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["bind"])(_this._mousewheelHandler, _this);
    var pinchHandler = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["bind"])(_this._pinchHandler, _this);
    /**
     * Notice: only enable needed types. For example, if 'zoom'
     * is not needed, 'zoom' should not be enabled, otherwise
     * default mousewheel behaviour (scroll page) will be disabled.
     */

    _this.enable = function (controlType, opt) {
      // Disable previous first
      this.disable();
      this._opt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["defaults"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["clone"])(opt) || {}, {
        zoomOnMouseWheel: true,
        moveOnMouseMove: true,
        // By default, wheel do not trigger move.
        moveOnMouseWheel: false,
        preventDefaultMouseMove: true
      });

      if (controlType == null) {
        controlType = true;
      }

      if (controlType === true || controlType === 'move' || controlType === 'pan') {
        zr.on('mousedown', mousedownHandler);
        zr.on('mousemove', mousemoveHandler);
        zr.on('mouseup', mouseupHandler);
      }

      if (controlType === true || controlType === 'scale' || controlType === 'zoom') {
        zr.on('mousewheel', mousewheelHandler);
        zr.on('pinch', pinchHandler);
      }
    };

    _this.disable = function () {
      zr.off('mousedown', mousedownHandler);
      zr.off('mousemove', mousemoveHandler);
      zr.off('mouseup', mouseupHandler);
      zr.off('mousewheel', mousewheelHandler);
      zr.off('pinch', pinchHandler);
    };

    return _this;
  }

  RoamController.prototype.isDragging = function () {
    return this._dragging;
  };

  RoamController.prototype.isPinching = function () {
    return this._pinching;
  };

  RoamController.prototype.setPointerChecker = function (pointerChecker) {
    this.pointerChecker = pointerChecker;
  };

  RoamController.prototype.dispose = function () {
    this.disable();
  };

  RoamController.prototype._mousedownHandler = function (e) {
    if (__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_event_js__["b" /* isMiddleOrRightButtonOnMouseUpDown */](e) || e.target && e.target.draggable) {
      return;
    }

    var x = e.offsetX;
    var y = e.offsetY; // Only check on mosedown, but not mousemove.
    // Mouse can be out of target when mouse moving.

    if (this.pointerChecker && this.pointerChecker(e, x, y)) {
      this._x = x;
      this._y = y;
      this._dragging = true;
    }
  };

  RoamController.prototype._mousemoveHandler = function (e) {
    if (!this._dragging || !isAvailableBehavior('moveOnMouseMove', e, this._opt) || e.gestureEvent === 'pinch' || __WEBPACK_IMPORTED_MODULE_3__interactionMutex_js__["a" /* isTaken */](this._zr, 'globalPan')) {
      return;
    }

    var x = e.offsetX;
    var y = e.offsetY;
    var oldX = this._x;
    var oldY = this._y;
    var dx = x - oldX;
    var dy = y - oldY;
    this._x = x;
    this._y = y;
    this._opt.preventDefaultMouseMove && __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_event_js__["a" /* stop */](e.event);
    trigger(this, 'pan', 'moveOnMouseMove', e, {
      dx: dx,
      dy: dy,
      oldX: oldX,
      oldY: oldY,
      newX: x,
      newY: y,
      isAvailableBehavior: null
    });
  };

  RoamController.prototype._mouseupHandler = function (e) {
    if (!__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_event_js__["b" /* isMiddleOrRightButtonOnMouseUpDown */](e)) {
      this._dragging = false;
    }
  };

  RoamController.prototype._mousewheelHandler = function (e) {
    var shouldZoom = isAvailableBehavior('zoomOnMouseWheel', e, this._opt);
    var shouldMove = isAvailableBehavior('moveOnMouseWheel', e, this._opt);
    var wheelDelta = e.wheelDelta;
    var absWheelDeltaDelta = Math.abs(wheelDelta);
    var originX = e.offsetX;
    var originY = e.offsetY; // wheelDelta maybe -0 in chrome mac.

    if (wheelDelta === 0 || !shouldZoom && !shouldMove) {
      return;
    } // If both `shouldZoom` and `shouldMove` is true, trigger
    // their event both, and the final behavior is determined
    // by event listener themselves.


    if (shouldZoom) {
      // Convenience:
      // Mac and VM Windows on Mac: scroll up: zoom out.
      // Windows: scroll up: zoom in.
      // FIXME: Should do more test in different environment.
      // wheelDelta is too complicated in difference nvironment
      // (https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel),
      // although it has been normallized by zrender.
      // wheelDelta of mouse wheel is bigger than touch pad.
      var factor = absWheelDeltaDelta > 3 ? 1.4 : absWheelDeltaDelta > 1 ? 1.2 : 1.1;
      var scale = wheelDelta > 0 ? factor : 1 / factor;
      checkPointerAndTrigger(this, 'zoom', 'zoomOnMouseWheel', e, {
        scale: scale,
        originX: originX,
        originY: originY,
        isAvailableBehavior: null
      });
    }

    if (shouldMove) {
      // FIXME: Should do more test in different environment.
      var absDelta = Math.abs(wheelDelta); // wheelDelta of mouse wheel is bigger than touch pad.

      var scrollDelta = (wheelDelta > 0 ? 1 : -1) * (absDelta > 3 ? 0.4 : absDelta > 1 ? 0.15 : 0.05);
      checkPointerAndTrigger(this, 'scrollMove', 'moveOnMouseWheel', e, {
        scrollDelta: scrollDelta,
        originX: originX,
        originY: originY,
        isAvailableBehavior: null
      });
    }
  };

  RoamController.prototype._pinchHandler = function (e) {
    if (__WEBPACK_IMPORTED_MODULE_3__interactionMutex_js__["a" /* isTaken */](this._zr, 'globalPan')) {
      return;
    }

    var scale = e.pinchScale > 1 ? 1.1 : 1 / 1.1;
    checkPointerAndTrigger(this, 'zoom', null, e, {
      scale: scale,
      originX: e.pinchX,
      originY: e.pinchY,
      isAvailableBehavior: null
    });
  };

  return RoamController;
}(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_Eventful_js__["a" /* default */]);

function checkPointerAndTrigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
  if (controller.pointerChecker && controller.pointerChecker(e, contollerEvent.originX, contollerEvent.originY)) {
    // When mouse is out of roamController rect,
    // default befavoius should not be be disabled, otherwise
    // page sliding is disabled, contrary to expectation.
    __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_event_js__["a" /* stop */](e.event);
    trigger(controller, eventName, behaviorToCheck, e, contollerEvent);
  }
}

function trigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
  // Also provide behavior checker for event listener, for some case that
  // multiple components share one listener.
  contollerEvent.isAvailableBehavior = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["bind"])(isAvailableBehavior, null, behaviorToCheck, e); // TODO should not have type issue.

  controller.trigger(eventName, contollerEvent);
} // settings: {
//     zoomOnMouseWheel
//     moveOnMouseMove
//     moveOnMouseWheel
// }
// The value can be: true / false / 'shift' / 'ctrl' / 'alt'.


function isAvailableBehavior(behaviorToCheck, e, settings) {
  var setting = settings[behaviorToCheck];
  return !behaviorToCheck || setting && (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["isString"])(setting) || e.event[setting + 'Key']);
}

/* harmony default export */ __webpack_exports__["a"] = (RoamController);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isCoordinateSystemType;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function isCoordinateSystemType(coordSys, type) {
  return coordSys.type === type;
}

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var coordinateSystemCreators = {};

var CoordinateSystemManager =
/** @class */
function () {
  function CoordinateSystemManager() {
    this._coordinateSystems = [];
  }

  CoordinateSystemManager.prototype.create = function (ecModel, api) {
    var coordinateSystems = [];
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](coordinateSystemCreators, function (creater, type) {
      var list = creater.create(ecModel, api);
      coordinateSystems = coordinateSystems.concat(list || []);
    });
    this._coordinateSystems = coordinateSystems;
  };

  CoordinateSystemManager.prototype.update = function (ecModel, api) {
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](this._coordinateSystems, function (coordSys) {
      coordSys.update && coordSys.update(ecModel, api);
    });
  };

  CoordinateSystemManager.prototype.getCoordinateSystems = function () {
    return this._coordinateSystems.slice();
  };

  CoordinateSystemManager.register = function (type, creator) {
    coordinateSystemCreators[type] = creator;
  };

  CoordinateSystemManager.get = function (type) {
    return coordinateSystemCreators[type];
  };

  return CoordinateSystemManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (CoordinateSystemManager);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pointsLayout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart_helper_createRenderPlanner_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_helper_dataStackHelper_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_vendor_js__ = __webpack_require__(198);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




function pointsLayout(seriesType, forceStoreInTypedArray) {
  return {
    seriesType: seriesType,
    plan: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chart_helper_createRenderPlanner_js__["a" /* default */])(),
    reset: function (seriesModel) {
      var data = seriesModel.getData();
      var coordSys = seriesModel.coordinateSystem;
      var pipelineContext = seriesModel.pipelineContext;
      var useTypedArray = forceStoreInTypedArray || pipelineContext.large;

      if (!coordSys) {
        return;
      }

      var dims = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])(coordSys.dimensions, function (dim) {
        return data.mapDimension(dim);
      }).slice(0, 2);
      var dimLen = dims.length;
      var stackResultDim = data.getCalculationInfo('stackResultDimension');

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_helper_dataStackHelper_js__["b" /* isDimensionStacked */])(data, dims[0])) {
        dims[0] = stackResultDim;
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_helper_dataStackHelper_js__["b" /* isDimensionStacked */])(data, dims[1])) {
        dims[1] = stackResultDim;
      }

      var store = data.getStore();
      var dimIdx0 = data.getDimensionIndex(dims[0]);
      var dimIdx1 = data.getDimensionIndex(dims[1]);
      return dimLen && {
        progress: function (params, data) {
          var segCount = params.end - params.start;
          var points = useTypedArray && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_vendor_js__["a" /* createFloat32Array */])(segCount * dimLen);
          var tmpIn = [];
          var tmpOut = [];

          for (var i = params.start, offset = 0; i < params.end; i++) {
            var point = void 0;

            if (dimLen === 1) {
              var x = store.get(dimIdx0, i); // NOTE: Make sure the second parameter is null to use default strategy.

              point = coordSys.dataToPoint(x, null, tmpOut);
            } else {
              tmpIn[0] = store.get(dimIdx0, i);
              tmpIn[1] = store.get(dimIdx1, i); // Let coordinate system to handle the NaN data.

              point = coordSys.dataToPoint(tmpIn, null, tmpOut);
            }

            if (useTypedArray) {
              points[offset++] = point[0];
              points[offset++] = point[1];
            } else {
              data.setItemLayout(i, point.slice());
            }
          }

          useTypedArray && data.setLayout('points', points);
        }
      };
    }
  };
}
;

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dataFilter;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function dataFilter(seriesType) {
  return {
    seriesType: seriesType,
    reset: function (seriesModel, ecModel) {
      var legendModels = ecModel.findComponents({
        mainType: 'legend'
      });

      if (!legendModels || !legendModels.length) {
        return;
      }

      var data = seriesModel.getData();
      data.filterSelf(function (idx) {
        var name = data.getName(idx); // If in any legend component the status is not selected.

        for (var i = 0; i < legendModels.length; i++) {
          // @ts-ignore FIXME: LegendModel
          if (!legendModels[i].isSelected(name)) {
            return false;
          }
        }

        return true;
      });
    }
  };
}

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_clazz_js__ = __webpack_require__(99);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


var Scale =
/** @class */
function () {
  function Scale(setting) {
    this._setting = setting || {};
    this._extent = [Infinity, -Infinity];
  }

  Scale.prototype.getSetting = function (name) {
    return this._setting[name];
  };
  /**
   * Set extent from data
   */


  Scale.prototype.unionExtent = function (other) {
    var extent = this._extent;
    other[0] < extent[0] && (extent[0] = other[0]);
    other[1] > extent[1] && (extent[1] = other[1]); // not setExtent because in log axis it may transformed to power
    // this.setExtent(extent[0], extent[1]);
  };
  /**
   * Set extent from data
   */


  Scale.prototype.unionExtentFromData = function (data, dim) {
    this.unionExtent(data.getApproximateExtent(dim));
  };
  /**
   * Get extent
   *
   * Extent is always in increase order.
   */


  Scale.prototype.getExtent = function () {
    return this._extent.slice();
  };
  /**
   * Set extent
   */


  Scale.prototype.setExtent = function (start, end) {
    var thisExtent = this._extent;

    if (!isNaN(start)) {
      thisExtent[0] = start;
    }

    if (!isNaN(end)) {
      thisExtent[1] = end;
    }
  };
  /**
   * If value is in extent range
   */


  Scale.prototype.isInExtentRange = function (value) {
    return this._extent[0] <= value && this._extent[1] >= value;
  };
  /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */


  Scale.prototype.isBlank = function () {
    return this._isBlank;
  };
  /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */


  Scale.prototype.setBlank = function (isBlank) {
    this._isBlank = isBlank;
  };

  return Scale;
}();

__WEBPACK_IMPORTED_MODULE_0__util_clazz_js__["e" /* enableClassManagement */](Scale);
/* harmony default export */ __webpack_exports__["a"] = (Scale);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createFloat32Array;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/* global Float32Array */

var supportFloat32Array = typeof Float32Array !== 'undefined';
var Float32ArrayCtor = !supportFloat32Array ? Array : Float32Array;
function createFloat32Array(arg) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"])(arg)) {
    // Return self directly if don't support TypedArray.
    return supportFloat32Array ? new Float32Array(arg) : arg;
  } // Else is number


  return new Float32ArrayCtor(arg);
}

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * LegendVisualProvider is an bridge that pick encoded color from data and
 * provide to the legend component.
 */
var LegendVisualProvider =
/** @class */
function () {
  function LegendVisualProvider( // Function to get data after filtered. It stores all the encoding info
  getDataWithEncodedVisual, // Function to get raw data before filtered.
  getRawData) {
    this._getDataWithEncodedVisual = getDataWithEncodedVisual;
    this._getRawData = getRawData;
  }

  LegendVisualProvider.prototype.getAllNames = function () {
    var rawData = this._getRawData(); // We find the name from the raw data. In case it's filtered by the legend component.
    // Normally, the name can be found in rawData, but can't be found in filtered data will display as gray.


    return rawData.mapArray(rawData.getName);
  };

  LegendVisualProvider.prototype.containName = function (name) {
    var rawData = this._getRawData();

    return rawData.indexOfName(name) >= 0;
  };

  LegendVisualProvider.prototype.indexOfName = function (name) {
    // Only get data when necessary.
    // Because LegendVisualProvider constructor may be new in the stage that data is not prepared yet.
    // Invoking Series#getData immediately will throw an error.
    var dataWithEncodedVisual = this._getDataWithEncodedVisual();

    return dataWithEncodedVisual.indexOfName(name);
  };

  LegendVisualProvider.prototype.getItemVisual = function (dataIndex, key) {
    // Get encoded visual properties from final filtered data.
    var dataWithEncodedVisual = this._getDataWithEncodedVisual();

    return dataWithEncodedVisual.getItemVisual(dataIndex, key);
  };

  return LegendVisualProvider;
}();

/* harmony default export */ __webpack_exports__["a"] = (LegendVisualProvider);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(87);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(252);




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object, true) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keysIn);


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1613)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(646),
  /* template */
  __webpack_require__(1545),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-00377641",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/dashboard/error/ErrorSection.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ErrorSection.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-00377641", Component.options)
  } else {
    hotAPI.reload("data-v-00377641", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Entry */
/* unused harmony export LinkedList */
var Entry = (function () {
    function Entry(val) {
        this.value = val;
    }
    return Entry;
}());

var LinkedList = (function () {
    function LinkedList() {
        this._len = 0;
    }
    LinkedList.prototype.insert = function (val) {
        var entry = new Entry(val);
        this.insertEntry(entry);
        return entry;
    };
    LinkedList.prototype.insertEntry = function (entry) {
        if (!this.head) {
            this.head = this.tail = entry;
        }
        else {
            this.tail.next = entry;
            entry.prev = this.tail;
            entry.next = null;
            this.tail = entry;
        }
        this._len++;
    };
    LinkedList.prototype.remove = function (entry) {
        var prev = entry.prev;
        var next = entry.next;
        if (prev) {
            prev.next = next;
        }
        else {
            this.head = next;
        }
        if (next) {
            next.prev = prev;
        }
        else {
            this.tail = prev;
        }
        entry.next = entry.prev = null;
        this._len--;
    };
    LinkedList.prototype.len = function () {
        return this._len;
    };
    LinkedList.prototype.clear = function () {
        this.head = this.tail = null;
        this._len = 0;
    };
    return LinkedList;
}());

var LRU = (function () {
    function LRU(maxSize) {
        this._list = new LinkedList();
        this._maxSize = 10;
        this._map = {};
        this._maxSize = maxSize;
    }
    LRU.prototype.put = function (key, value) {
        var list = this._list;
        var map = this._map;
        var removed = null;
        if (map[key] == null) {
            var len = list.len();
            var entry = this._lastRemovedEntry;
            if (len >= this._maxSize && len > 0) {
                var leastUsedEntry = list.head;
                list.remove(leastUsedEntry);
                delete map[leastUsedEntry.key];
                removed = leastUsedEntry.value;
                this._lastRemovedEntry = leastUsedEntry;
            }
            if (entry) {
                entry.value = value;
            }
            else {
                entry = new Entry(value);
            }
            entry.key = key;
            list.insertEntry(entry);
            map[key] = entry;
        }
        return removed;
    };
    LRU.prototype.get = function (key) {
        var entry = this._map[key];
        var list = this._list;
        if (entry != null) {
            if (entry !== list.tail) {
                list.remove(entry);
                list.insertEntry(entry);
            }
            return entry.value;
        }
    };
    LRU.prototype.clear = function () {
        this._list.clear();
        this._map = {};
    };
    LRU.prototype.len = function () {
        return this._list.len();
    };
    return LRU;
}());
/* harmony default export */ __webpack_exports__["a"] = (LRU);


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RectShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Path_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_roundRect_js__ = __webpack_require__(1705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_subPixelOptimize_js__ = __webpack_require__(362);




var RectShape = (function () {
    function RectShape() {
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
    }
    return RectShape;
}());

var subPixelOptimizeOutputShape = {};
var Rect = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Rect, _super);
    function Rect(opts) {
        return _super.call(this, opts) || this;
    }
    Rect.prototype.getDefaultShape = function () {
        return new RectShape();
    };
    Rect.prototype.buildPath = function (ctx, shape) {
        var x;
        var y;
        var width;
        var height;
        if (this.subPixelOptimize) {
            var optimizedShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_subPixelOptimize_js__["a" /* subPixelOptimizeRect */])(subPixelOptimizeOutputShape, shape, this.style);
            x = optimizedShape.x;
            y = optimizedShape.y;
            width = optimizedShape.width;
            height = optimizedShape.height;
            optimizedShape.r = shape.r;
            shape = optimizedShape;
        }
        else {
            x = shape.x;
            y = shape.y;
            width = shape.width;
            height = shape.height;
        }
        if (!shape.r) {
            ctx.rect(x, y, width, height);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_2__helper_roundRect_js__["a" /* buildPath */](ctx, shape);
        }
    };
    Rect.prototype.isZeroArea = function () {
        return !this.shape.width || !this.shape.height;
    };
    return Rect;
}(__WEBPACK_IMPORTED_MODULE_1__Path_js__["a" /* default */]));
Rect.prototype.type = 'rect';
/* harmony default export */ __webpack_exports__["a"] = (Rect);


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createFromString;
/* harmony export (immutable) */ __webpack_exports__["a"] = extendFromString;
/* harmony export (immutable) */ __webpack_exports__["c"] = mergePath;
/* harmony export (immutable) */ __webpack_exports__["d"] = clonePath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphic_Path_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_PathProxy_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__transformPath_js__ = __webpack_require__(1721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_util_js__ = __webpack_require__(0);





var mathSqrt = Math.sqrt;
var mathSin = Math.sin;
var mathCos = Math.cos;
var PI = Math.PI;
function vMag(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
}
;
function vRatio(u, v) {
    return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
}
;
function vAngle(u, v) {
    return (u[0] * v[1] < u[1] * v[0] ? -1 : 1)
        * Math.acos(vRatio(u, v));
}
;
function processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
    var psi = psiDeg * (PI / 180.0);
    var xp = mathCos(psi) * (x1 - x2) / 2.0
        + mathSin(psi) * (y1 - y2) / 2.0;
    var yp = -1 * mathSin(psi) * (x1 - x2) / 2.0
        + mathCos(psi) * (y1 - y2) / 2.0;
    var lambda = (xp * xp) / (rx * rx) + (yp * yp) / (ry * ry);
    if (lambda > 1) {
        rx *= mathSqrt(lambda);
        ry *= mathSqrt(lambda);
    }
    var f = (fa === fs ? -1 : 1)
        * mathSqrt((((rx * rx) * (ry * ry))
            - ((rx * rx) * (yp * yp))
            - ((ry * ry) * (xp * xp))) / ((rx * rx) * (yp * yp)
            + (ry * ry) * (xp * xp))) || 0;
    var cxp = f * rx * yp / ry;
    var cyp = f * -ry * xp / rx;
    var cx = (x1 + x2) / 2.0
        + mathCos(psi) * cxp
        - mathSin(psi) * cyp;
    var cy = (y1 + y2) / 2.0
        + mathSin(psi) * cxp
        + mathCos(psi) * cyp;
    var theta = vAngle([1, 0], [(xp - cxp) / rx, (yp - cyp) / ry]);
    var u = [(xp - cxp) / rx, (yp - cyp) / ry];
    var v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
    var dTheta = vAngle(u, v);
    if (vRatio(u, v) <= -1) {
        dTheta = PI;
    }
    if (vRatio(u, v) >= 1) {
        dTheta = 0;
    }
    if (dTheta < 0) {
        var n = Math.round(dTheta / PI * 1e6) / 1e6;
        dTheta = PI * 2 + (n % 2) * PI;
    }
    path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
}
var commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig;
var numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function createPathProxyFromString(data) {
    var path = new __WEBPACK_IMPORTED_MODULE_2__core_PathProxy_js__["a" /* default */]();
    if (!data) {
        return path;
    }
    var cpx = 0;
    var cpy = 0;
    var subpathX = cpx;
    var subpathY = cpy;
    var prevCmd;
    var CMD = __WEBPACK_IMPORTED_MODULE_2__core_PathProxy_js__["a" /* default */].CMD;
    var cmdList = data.match(commandReg);
    if (!cmdList) {
        return path;
    }
    for (var l = 0; l < cmdList.length; l++) {
        var cmdText = cmdList[l];
        var cmdStr = cmdText.charAt(0);
        var cmd = void 0;
        var p = cmdText.match(numberReg) || [];
        var pLen = p.length;
        for (var i = 0; i < pLen; i++) {
            p[i] = parseFloat(p[i]);
        }
        var off = 0;
        while (off < pLen) {
            var ctlPtx = void 0;
            var ctlPty = void 0;
            var rx = void 0;
            var ry = void 0;
            var psi = void 0;
            var fa = void 0;
            var fs = void 0;
            var x1 = cpx;
            var y1 = cpy;
            var len = void 0;
            var pathData = void 0;
            switch (cmdStr) {
                case 'l':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'L':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'm':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'l';
                    break;
                case 'M':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'L';
                    break;
                case 'h':
                    cpx += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'H':
                    cpx = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'v':
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'V':
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'C':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
                    cpx = p[off - 2];
                    cpy = p[off - 1];
                    break;
                case 'c':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
                    cpx += p[off - 2];
                    cpy += p[off - 1];
                    break;
                case 'S':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 's':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = cpx + p[off++];
                    y1 = cpy + p[off++];
                    cpx += p[off++];
                    cpy += p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 'Q':
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'q':
                    x1 = p[off++] + cpx;
                    y1 = p[off++] + cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'T':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 't':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 'A':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.A;
                    processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
                case 'a':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.A;
                    processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
            }
        }
        if (cmdStr === 'z' || cmdStr === 'Z') {
            cmd = CMD.Z;
            path.addData(cmd);
            cpx = subpathX;
            cpy = subpathY;
        }
        prevCmd = cmd;
    }
    path.toStatic();
    return path;
}
var SVGPath = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(SVGPath, _super);
    function SVGPath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGPath.prototype.applyTransform = function (m) { };
    return SVGPath;
}(__WEBPACK_IMPORTED_MODULE_1__graphic_Path_js__["a" /* default */]));
function isPathProxy(path) {
    return path.setData != null;
}
function createPathOptions(str, opts) {
    var pathProxy = createPathProxyFromString(str);
    var innerOpts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_util_js__["extend"])({}, opts);
    innerOpts.buildPath = function (path) {
        if (isPathProxy(path)) {
            path.setData(pathProxy.data);
            var ctx = path.getContext();
            if (ctx) {
                path.rebuildPath(ctx, 1);
            }
        }
        else {
            var ctx = path;
            pathProxy.rebuildPath(ctx, 1);
        }
    };
    innerOpts.applyTransform = function (m) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__transformPath_js__["a" /* default */])(pathProxy, m);
        this.dirtyShape();
    };
    return innerOpts;
}
function createFromString(str, opts) {
    return new SVGPath(createPathOptions(str, opts));
}
function extendFromString(str, defaultOpts) {
    var innerOpts = createPathOptions(str, defaultOpts);
    var Sub = (function (_super) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Sub, _super);
        function Sub(opts) {
            var _this = _super.call(this, opts) || this;
            _this.applyTransform = innerOpts.applyTransform;
            _this.buildPath = innerOpts.buildPath;
            return _this;
        }
        return Sub;
    }(SVGPath));
    return Sub;
}
function mergePath(pathEls, opts) {
    var pathList = [];
    var len = pathEls.length;
    for (var i = 0; i < len; i++) {
        var pathEl = pathEls[i];
        pathList.push(pathEl.getUpdatedPathProxy(true));
    }
    var pathBundle = new __WEBPACK_IMPORTED_MODULE_1__graphic_Path_js__["a" /* default */](opts);
    pathBundle.createPathProxy();
    pathBundle.buildPath = function (path) {
        if (isPathProxy(path)) {
            path.appendPath(pathList);
            var ctx = path.getContext();
            if (ctx) {
                path.rebuildPath(ctx, 1);
            }
        }
    };
    return pathBundle;
}
function clonePath(sourcePath, opts) {
    opts = opts || {};
    var path = new __WEBPACK_IMPORTED_MODULE_1__graphic_Path_js__["a" /* default */]();
    if (sourcePath.shape) {
        path.setShape(sourcePath.shape);
    }
    path.setStyle(sourcePath.style);
    if (opts.bakeTransform) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__transformPath_js__["a" /* default */])(path.path, sourcePath.getComputedTransform());
    }
    else {
        if (opts.toLocal) {
            path.setLocalTransform(sourcePath.getComputedTransform());
        }
        else {
            path.copyTransform(sourcePath);
        }
    }
    path.buildPath = sourcePath.buildPath;
    path.applyTransform = path.applyTransform;
    path.z = sourcePath.z;
    path.z2 = sourcePath.z2;
    path.zlevel = sourcePath.zlevel;
    return path;
}


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = ({
    list: function list(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].post('/rocheManage/authorize/queryAuthorizeUser', params);
    },
    stop: function stop(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].post('/rocheManage/authorize/stopAuthorize', params);
    },
    save: function save(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].post('/rocheManage/authorize/saveAuthorizationInfo', params);
    },
    check: function check(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].post('/rocheManage/authorize/checkAuthorizeUser', params);
    },
    selectUser: function selectUser(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].post('/rocheManage/authorize/selectUser', params);
    },
    team: function team(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].post('/rocheManage/authorize/selectAuthorizationTeam', params);
    },
    approveUser: function approveUser(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].post('/rocheManage/authorize/selectApproveUser', params);
    }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);






var utils = {
  $isEmpty: function $isEmpty(value) {
    return value === '' || !value && value !== 0;
  },
  $isNotEmpty: function $isNotEmpty(value) {
    return !this.$isEmpty(value);
  },
  $pleaseDoSomething: function $pleaseDoSomething(prefix, object) {
    var toLowerCase = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    var objectFirstLetter = void 0;
    objectFirstLetter = object.substr(0, 1);
    if (!!toLowerCase) {
      objectFirstLetter = objectFirstLetter.toLowerCase();
    }
    object = objectFirstLetter + object.substr(1, object.length);
    return prefix + object;
  },
  $pleaseFillIn: function $pleaseFillIn(object) {
    var toLowerCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    return this.$pleaseDoSomething(__WEBPACK_IMPORTED_MODULE_3__main__["default"].$t('common.please_fill_in'), object, toLowerCase);
  },
  $pleaseSelect: function $pleaseSelect(object) {
    var toLowerCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    return this.$pleaseDoSomething(__WEBPACK_IMPORTED_MODULE_3__main__["default"].$t('common.please_select'), object, toLowerCase);
  },
  $checkSpeakerColor: function $checkSpeakerColor(data) {
    var category = data.category;
    var title = data.title || '';
    var isChairman = title.toLowerCase() === 'chairman';
    var materialUpdated = Number(data.materialUpdated); // 是否上传演讲材料，0没上传1已上传
    var tov = Number(data.tov);
    // 没上传演讲材料的校验内容
    var confirmationList = [{
      name: 'logisticsConfirmed',
      afterMeetingStatus: 'logisticsAfterMeeting'
    }, {
      name: 'scientificConfirmed',
      afterMeetingStatus: 'scientificAfterMeeting'
    }, {
      name: 'medicalConfirmed',
      afterMeetingStatus: 'medicalAfterMeeting'
    }, {
      name: 'briefingConfirmed',
      afterMeetingStatus: 'briefingAfterMeeting'
    }];

    // 没有上传演讲材料的校验内容
    var confirmationListForNoPresentationMaterial = [{
      name: 'logisticsConfirmed',
      afterMeetingStatus: 'logisticsAfterMeeting'
    }, {
      name: 'scientificConfirmed',
      afterMeetingStatus: 'scientificAfterMeeting'
    }, {
      name: 'medicalConfirmed',
      afterMeetingStatus: 'medicalAfterMeeting'
    }];
    var getConfirmationColor = function getConfirmationColor(confirmationList) {
      var result = true;
      confirmationList.forEach(function (item) {
        // 是数字非异常是1才能通过
        if (__WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$checkConfirmationColor(data, item.name)) {
          result = false;
        }
      });
      return result ? 'green' : 'red';
    };
    var result = void 0;

    if (category === 'paid') {
      if (tov > 0) {
        // 付费讲者
        result = getConfirmationColor(confirmationList);
      } else if (tov === 0) {
        // 0元讲者
        if (__WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$isEmpty(materialUpdated) || materialUpdated === 0) {
          result = getConfirmationColor(confirmationListForNoPresentationMaterial);
        } else if (materialUpdated === 1) {
          result = getConfirmationColor(confirmationList);
        }
      }
    } else if (category === 'unpaid') {
      // 非付费讲者
      if (isNaN(materialUpdated) || materialUpdated === 0) {
        result = getConfirmationColor(confirmationListForNoPresentationMaterial);
      } else if (materialUpdated === 1) {
        result = getConfirmationColor(confirmationList);
      }
    }

    return result;
  },
  $checkConfirmationColor: function $checkConfirmationColor(speakerData, confirmationName) {
    var _this = this;

    //   true是标红
    var confirmationList = [{
      name: 'logisticsConfirmed',
      afterMeetingStatus: 'logisticsAfterMeeting'
    }, {
      name: 'scientificConfirmed',
      afterMeetingStatus: 'scientificAfterMeeting'
    }, {
      name: 'medicalConfirmed',
      afterMeetingStatus: 'medicalAfterMeeting'
    }, {
      name: 'briefingConfirmed',
      afterMeetingStatus: 'briefingAfterMeeting'
    }];
    var confirmationStatus = Number(speakerData[confirmationName]);
    var category = speakerData.category;
    var chairmanTag = speakerData.chairmanTag; // 是否是主席
    var materialUpdated = Number(speakerData.materialUpdated); // 是否上传演讲材料，0没上传1已上传
    var afterMeetingStatusItem = confirmationList.find(function (item) {
      return item.name === confirmationName;
    });
    var afterMeetingStatus = __WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$isNotEmpty(afterMeetingStatusItem) ? afterMeetingStatusItem.afterMeetingStatus : null;
    var isAfterMeeting = __WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$isNotEmpty(afterMeetingStatus) ? Number(speakerData[afterMeetingStatus]) === 1 : false;
    var checker = function checker(confirmationStatus) {
      return confirmationStatus === 0 || _this.$isEmpty(confirmationStatus) || isAfterMeeting;
    };
    if (confirmationName === 'briefingConfirmed') {
      //   debugger
      if (category == 'unpaid') {
        if (chairmanTag == '1') {
          if (materialUpdated === 1) {
            return checker(confirmationStatus);
          } else {
            // 会前未上传演讲材料，
            return false;
          }
        } else {
          return checker(confirmationStatus);
        }
      } else if (speakerData.tov === 0) {
        if (materialUpdated === 1) {
          return checker(confirmationStatus);
        } else {
          return false;
        }
      } else if (speakerData.tov > 0) {
        return checker(confirmationStatus);
      }
    } else {
      //   debugger
      return checker(confirmationStatus);
    }
  },
  $checkTrainingConfirmationYesOrNoWithTranslation: function $checkTrainingConfirmationYesOrNoWithTranslation(speakerData, confirmationName) {
    var result = __WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$checkTrainingConfirmationYesOrNo(speakerData, confirmationName);
    return __WEBPACK_IMPORTED_MODULE_3__main__["default"].$t('common.' + result);
  },
  $checkTrainingConfirmationYesOrNo: function $checkTrainingConfirmationYesOrNo(speakerData, confirmationName) {
    var _this2 = this;

    var confirmationStatus = Number(speakerData[confirmationName]);
    var materialUpdated = Number(speakerData.materialUpdated);

    var category = speakerData.category;
    var chairmanTag = speakerData.chairmanTag; // 是否是主席
    var checker = function checker(confirmationStatus) {
      if (confirmationStatus === 1) {
        return 'yes';
      } else if (confirmationStatus === 0 || _this2.$isEmpty(confirmationStatus)) {
        return 'no';
      }
    };

    if (confirmationName === 'briefingConfirmed') {
      console.log('speakerData', speakerData);
      //   debugger
      if (category == 'unpaid') {
        if (chairmanTag == '1') {
          if (materialUpdated === 1) {
            return checker(confirmationStatus);
          } else {
            // 会前未上传演讲材料，
            return 'not_required';
          }
        } else {
          return checker(confirmationStatus);
        }
      } else if (speakerData.tov === 0) {
        if (materialUpdated === 1) {
          return checker(confirmationStatus);
        } else {
          return 'not_required';
        }
      } else if (speakerData.tov > 0) {
        return checker(confirmationStatus);
      } else {
        return checker(confirmationStatus);
      }
    } else {
      //   debugger
      return checker(confirmationStatus);
    }
  },
  $accurateCalulateOperation: function $accurateCalulateOperation(a, b, op) {
    var isInteger = function isInteger(obj) {
      return Math.floor(obj) === obj;
    };
    var toInteger = function toInteger(floatNum) {
      var ret = { times: 1, num: 0 };
      if (isInteger(floatNum)) {
        ret.num = floatNum;
        return ret;
      }
      var strfi = floatNum + '';
      var dotPos = strfi.indexOf('.');
      var len = strfi.substr(dotPos + 1).length;
      var times = Math.pow(10, len);
      var intNum = parseInt(floatNum * times + 0.5, 10);
      ret.times = times;
      ret.num = intNum;
      return ret;
    };
    var o1 = toInteger(a);
    var o2 = toInteger(b);
    var n1 = o1.num;
    var n2 = o2.num;
    var t1 = o1.times;
    var t2 = o2.times;
    var max = t1 > t2 ? t1 : t2;
    var result = null;
    switch (op) {
      case 'add':
        if (t1 === t2) {
          // 两个小数位数相同
          result = n1 + n2;
        } else if (t1 > t2) {
          // o1 小数位 大于 o2
          result = n1 + n2 * (t1 / t2);
        } else {
          // o1 小数位 小于 o2
          result = n1 * (t2 / t1) + n2;
        }
        return result / max;
      case 'subtract':
        if (t1 === t2) {
          result = n1 - n2;
        } else if (t1 > t2) {
          result = n1 - n2 * (t1 / t2);
        } else {
          result = n1 * (t2 / t1) - n2;
        }
        return result / max;
      case 'multiply':
        result = n1 * n2 / (t1 * t2);
        return result;
      case 'divide':
        result = n1 / n2 * (t2 / t1);
        return result;
    }
  },
  $accAdd: function $accAdd(arg1, arg2) {
    return this.$accurateCalulateOperation(arg1, arg2, 'add');
  },

  $formatEEIB: function $formatEEIB(ifEeib, isNeedCoi, restrictAttendance) {
    if (restrictAttendance === '1') {
      return vm.$t('engagementRequest.label.block');
    } else if (isNeedCoi === '0') {
      return vm.$t('engagementRequest.label.not_required');
    } else {
      if (ifEeib === '1') {
        return vm.$t('engagementRequest.label.yes');
      } else if (ifEeib === '0') {
        return vm.$t('engagementRequest.label.no');
      } else {
        return '-';
      }
    }
  },

  $formatSeriesNumber: function $formatSeriesNumber(num) {
    num = Number(num);
    num = !isNaN(num) ? num : '';
    var aaa = toString(num);
    if (num !== '' && toString(num).length < 2) {
      num = '0' + num;
    }
    return num;
  },


  //
  // 自定义函数名：PrefixZero,数字位数不够，进行前补零的JS最简实现方案
  // @param num： 被操作数
  // @param n： 固定的总位数
  $prefixZero: function $prefixZero(num) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

    var maxNum = Math.pow(10, n);
    if (num >= maxNum) {
      return num;
    } else {
      return (Array(n).join(0) + num).slice(-n);
    }
  },
  $trim: function $trim(value) {
    var lastValue = void 0;
    if (typeof value === 'string') {
      lastValue = value.replace(/(^\s*)|(\s*$)/g, '');
    }
    return lastValue;
  },


  $setFormDataParams: function $setFormDataParams(query) {
    var formData = new FormData();
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(query).forEach(function (item) {
      formData.append(item, query[item]);
    });
    return formData;
  },
  $objectToQuery: function $objectToQuery(payload) {
    var queryStr = '?',
        i = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(payload).length;
    if (!payload) {
      queryStr = '';
    }
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key, index) {
      if (i === index + 1) {
        queryStr += key + '=' + payload[key];
      } else {
        queryStr += key + '=' + payload[key] + '&';
      }
    });
    return queryStr;
  },
  $objectToParams: function $objectToParams(payload) {
    payload = !!payload && payload !== '' ? payload : {};
    var result = '';
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(payload).forEach(function (item, index) {
      result += '/' + payload[item];
    });
    return result;
  },
  $formatMoney: function $formatMoney(s, n) {
    if (Number(s) === 0) {
      return '0.00';
    }
    if (!s && Number(s) !== 0) {
      return '';
    }
    n = n > 0 && n <= 20 ? n : 2;
    s = parseFloat((s + '').replace(/[^\d\.-]/g, '')).toFixed(n) + '';
    var l = s.split('.')[0].split('').reverse(),
        r = s.split('.')[1];
    var t = '';
    for (var index = 0; index < l.length; index++) {
      t += l[index] + ((index + 1) % 3 === 0 && index + 1 !== l.length ? ',' : '');
    }
    var result = t.split('').reverse().join('') + '.' + r;
    result = !result ? '' : result;
    return result.replace('.00', '');
  },
  $toThousand: function $toThousand(val, n) {
    var fd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

    if (!val) {
      return 0;
    }

    if (!n) {
      n = 1;
    }

    return Number((val / (1000 * n)).toFixed(fd));
  },
  $toTenThousand: function $toTenThousand(val, n) {
    if (!val) {
      return 0;
    }

    if (!n) {
      n = 1;
    }

    return Number((val / (10000 * n)).toFixed(2));
  },
  $all: function $all(iterators) {
    var promises = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(iterators); // 强制转换成数组
    var len = promises.length; // 记录数组的长度
    var count = 0; // 标记成功的个数
    var resultList = []; // 要返回的 数组结果
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var _loop = function _loop(index) {
        // for 循环配合 let 确保 数组结果和参数顺序一致
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(promises[index]) // Promise.resolve，如果是参数是promise 直接返回，如果不是则直接执行Promise.resolve方法 到 then 接受
        .then(function (result) {
          count++; // 记录个数，等于len时 resolve
          resultList[index] = result; // 对应赋值结果
          if (count === len) {
            resolve(resultList);
          }
        }).catch(function (e) {
          reject(e); // 当收到错误时，直接reject，返回错误信息
        });
      };

      // 返回一个promise
      for (var index in promises) {
        _loop(index);
      }
    });
  },
  $getWindowTarget: function $getWindowTarget() {
    var ua = navigator.userAgent;
    console.log('ua:', ua);
    var isAndroid = /(?:Android)/.test(ua);
    var isFireFox = /(?:Firefox)/.test(ua);
    var isTablet = /(?:iPad|PlayBook)/.test(ua) || isAndroid && !/(?:Mobile)/.test(ua) || isFireFox && /(?:Tablet)/.test(ua);
    var isAZLink = /azlink_ipad/.test(ua);
    var target = '_blank';
    if (isTablet || isAZLink) {
      target = '_self';
    }
    return target;
  }
};

utils.install = function (Vue) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(utils).forEach(function (item, index) {
    if (item !== 'install') {
      Vue.prototype[item] = utils[item];
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Storage */
/* unused harmony export handleResponse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getZoom; });
var Storage = {
  get: function get(key) {
    var value = window.localStorage.getItem(key) || null;
    return value;
  },
  set: function set(key, value) {
    window.localStorage.setItem(key, value);
  },
  remove: function remove(key) {
    window.localStorage.removeItem(key);
  }
};

var handleResponse = function handleResponse(resolve, reject, response) {
  var status = response.body.status;
  var data = response.body.data;
  var msg = response.body.msg;
  if (status === -1) {
    reject({
      msg: msg
    });
  } else {
    resolve(data);
  }
};

var getZoom = function getZoom() {
  var isWindows = navigator.userAgent.toLowerCase().indexOf('windows') >= 0;
  var zoom = 1 / window.devicePixelRatio;
  console.log(isWindows ? { zoom: zoom } : null);
  return isWindows && zoom < 1 ? zoom : 1;
};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(750);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(749);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(176);
var TAG = __webpack_require__(45)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 211 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(278);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 213 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(64);
var toLength = __webpack_require__(29);
var toAbsoluteIndex = __webpack_require__(129);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(13);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(55);
var redefineAll = __webpack_require__(127);
var meta = __webpack_require__(109);
var forOf = __webpack_require__(122);
var anInstance = __webpack_require__(121);
var isObject = __webpack_require__(18);
var fails = __webpack_require__(16);
var $iterDetect = __webpack_require__(219);
var setToStringTag = __webpack_require__(149);
var inheritIfRequired = __webpack_require__(292);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(436);
var redefine = __webpack_require__(55);
var hide = __webpack_require__(54);
var fails = __webpack_require__(16);
var defined = __webpack_require__(82);
var wks = __webpack_require__(25);
var regexpExec = __webpack_require__(300);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(72);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(18);
var cof = __webpack_require__(72);
var MATCH = __webpack_require__(25)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(25)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(108) || !__webpack_require__(16)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(13)[K];
});


/***/ }),
/* 221 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(147);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(2);
var aFunction = __webpack_require__(46);
var ctx = __webpack_require__(74);
var forOf = __webpack_require__(122);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(2);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(76);
var defined = __webpack_require__(82);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var hide = __webpack_require__(54);
var uid = __webpack_require__(130);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_symbol_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__labelHelper_js__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_zrender_lib_graphic_Image_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__animation_basicTrasition_js__ = __webpack_require__(40);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/











var Symbol =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Symbol, _super);

  function Symbol(data, idx, seriesScope, opts) {
    var _this = _super.call(this) || this;

    _this.updateData(data, idx, seriesScope, opts);

    return _this;
  }

  Symbol.prototype._createSymbol = function (symbolType, data, idx, symbolSize, keepAspect) {
    // Remove paths created before
    this.removeAll(); // let symbolPath = createSymbol(
    //     symbolType, -0.5, -0.5, 1, 1, color
    // );
    // If width/height are set too small (e.g., set to 1) on ios10
    // and macOS Sierra, a circle stroke become a rect, no matter what
    // the scale is set. So we set width/height as 2. See #4150.

    var symbolPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_symbol_js__["a" /* createSymbol */])(symbolType, -1, -1, 2, 2, null, keepAspect);
    symbolPath.attr({
      z2: 100,
      culling: true,
      scaleX: symbolSize[0] / 2,
      scaleY: symbolSize[1] / 2
    }); // Rewrite drift method

    symbolPath.drift = driftSymbol;
    this._symbolType = symbolType;
    this.add(symbolPath);
  };
  /**
   * Stop animation
   * @param {boolean} toLastFrame
   */


  Symbol.prototype.stopSymbolAnimation = function (toLastFrame) {
    this.childAt(0).stopAnimation(null, toLastFrame);
  };

  Symbol.prototype.getSymbolType = function () {
    return this._symbolType;
  };
  /**
   * FIXME:
   * Caution: This method breaks the encapsulation of this module,
   * but it indeed brings convenience. So do not use the method
   * unless you detailedly know all the implements of `Symbol`,
   * especially animation.
   *
   * Get symbol path element.
   */


  Symbol.prototype.getSymbolPath = function () {
    return this.childAt(0);
  };
  /**
   * Highlight symbol
   */


  Symbol.prototype.highlight = function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_states_js__["j" /* enterEmphasis */])(this.childAt(0));
  };
  /**
   * Downplay symbol
   */


  Symbol.prototype.downplay = function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_states_js__["k" /* leaveEmphasis */])(this.childAt(0));
  };
  /**
   * @param {number} zlevel
   * @param {number} z
   */


  Symbol.prototype.setZ = function (zlevel, z) {
    var symbolPath = this.childAt(0);
    symbolPath.zlevel = zlevel;
    symbolPath.z = z;
  };

  Symbol.prototype.setDraggable = function (draggable) {
    var symbolPath = this.childAt(0);
    symbolPath.draggable = draggable;
    symbolPath.cursor = draggable ? 'move' : symbolPath.cursor;
  };
  /**
   * Update symbol properties
   */


  Symbol.prototype.updateData = function (data, idx, seriesScope, opts) {
    this.silent = false;
    var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
    var seriesModel = data.hostModel;
    var symbolSize = Symbol.getSymbolSize(data, idx);
    var isInit = symbolType !== this._symbolType;
    var disableAnimation = opts && opts.disableAnimation;

    if (isInit) {
      var keepAspect = data.getItemVisual(idx, 'symbolKeepAspect');

      this._createSymbol(symbolType, data, idx, symbolSize, keepAspect);
    } else {
      var symbolPath = this.childAt(0);
      symbolPath.silent = false;
      var target = {
        scaleX: symbolSize[0] / 2,
        scaleY: symbolSize[1] / 2
      };
      disableAnimation ? symbolPath.attr(target) : __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["updateProps"](symbolPath, target, seriesModel, idx);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__animation_basicTrasition_js__["f" /* saveOldStyle */])(symbolPath);
    }

    this._updateCommon(data, idx, symbolSize, seriesScope, opts);

    if (isInit) {
      var symbolPath = this.childAt(0);

      if (!disableAnimation) {
        var target = {
          scaleX: this._sizeX,
          scaleY: this._sizeY,
          style: {
            // Always fadeIn. Because it has fadeOut animation when symbol is removed..
            opacity: symbolPath.style.opacity
          }
        };
        symbolPath.scaleX = symbolPath.scaleY = 0;
        symbolPath.style.opacity = 0;
        __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["initProps"](symbolPath, target, seriesModel, idx);
      }
    }

    if (disableAnimation) {
      // Must stop leave transition manually if don't call initProps or updateProps.
      this.childAt(0).stopAnimation('leave');
    }
  };

  Symbol.prototype._updateCommon = function (data, idx, symbolSize, seriesScope, opts) {
    var symbolPath = this.childAt(0);
    var seriesModel = data.hostModel;
    var emphasisItemStyle;
    var blurItemStyle;
    var selectItemStyle;
    var focus;
    var blurScope;
    var emphasisDisabled;
    var labelStatesModels;
    var hoverScale;
    var cursorStyle;

    if (seriesScope) {
      emphasisItemStyle = seriesScope.emphasisItemStyle;
      blurItemStyle = seriesScope.blurItemStyle;
      selectItemStyle = seriesScope.selectItemStyle;
      focus = seriesScope.focus;
      blurScope = seriesScope.blurScope;
      labelStatesModels = seriesScope.labelStatesModels;
      hoverScale = seriesScope.hoverScale;
      cursorStyle = seriesScope.cursorStyle;
      emphasisDisabled = seriesScope.emphasisDisabled;
    }

    if (!seriesScope || data.hasItemOption) {
      var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx);
      var emphasisModel = itemModel.getModel('emphasis');
      emphasisItemStyle = emphasisModel.getModel('itemStyle').getItemStyle();
      selectItemStyle = itemModel.getModel(['select', 'itemStyle']).getItemStyle();
      blurItemStyle = itemModel.getModel(['blur', 'itemStyle']).getItemStyle();
      focus = emphasisModel.get('focus');
      blurScope = emphasisModel.get('blurScope');
      emphasisDisabled = emphasisModel.get('disabled');
      labelStatesModels = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__["f" /* getLabelStatesModels */])(itemModel);
      hoverScale = emphasisModel.getShallow('scale');
      cursorStyle = itemModel.getShallow('cursor');
    }

    var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
    symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);
    var symbolOffset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_symbol_js__["d" /* normalizeSymbolOffset */])(data.getItemVisual(idx, 'symbolOffset'), symbolSize);

    if (symbolOffset) {
      symbolPath.x = symbolOffset[0];
      symbolPath.y = symbolOffset[1];
    }

    cursorStyle && symbolPath.attr('cursor', cursorStyle);
    var symbolStyle = data.getItemVisual(idx, 'style');
    var visualColor = symbolStyle.fill;

    if (symbolPath instanceof __WEBPACK_IMPORTED_MODULE_8_zrender_lib_graphic_Image_js__["a" /* default */]) {
      var pathStyle = symbolPath.style;
      symbolPath.useStyle(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["extend"])({
        // TODO other properties like x, y ?
        image: pathStyle.image,
        x: pathStyle.x,
        y: pathStyle.y,
        width: pathStyle.width,
        height: pathStyle.height
      }, symbolStyle));
    } else {
      if (symbolPath.__isEmptyBrush) {
        // fill and stroke will be swapped if it's empty.
        // So we cloned a new style to avoid it affecting the original style in visual storage.
        // TODO Better implementation. No empty logic!
        symbolPath.useStyle(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["extend"])({}, symbolStyle));
      } else {
        symbolPath.useStyle(symbolStyle);
      } // Disable decal because symbol scale will been applied on the decal.


      symbolPath.style.decal = null;
      symbolPath.setColor(visualColor, opts && opts.symbolInnerColor);
      symbolPath.style.strokeNoScale = true;
    }

    var liftZ = data.getItemVisual(idx, 'liftZ');
    var z2Origin = this._z2;

    if (liftZ != null) {
      if (z2Origin == null) {
        this._z2 = symbolPath.z2;
        symbolPath.z2 += liftZ;
      }
    } else if (z2Origin != null) {
      symbolPath.z2 = z2Origin;
      this._z2 = null;
    }

    var useNameLabel = opts && opts.useNameLabel;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__["e" /* setLabelStyle */])(symbolPath, labelStatesModels, {
      labelFetcher: seriesModel,
      labelDataIndex: idx,
      defaultText: getLabelDefaultText,
      inheritColor: visualColor,
      defaultOpacity: symbolStyle.opacity
    }); // Do not execute util needed.

    function getLabelDefaultText(idx) {
      return useNameLabel ? data.getName(idx) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__labelHelper_js__["a" /* getDefaultLabel */])(data, idx);
    }

    this._sizeX = symbolSize[0] / 2;
    this._sizeY = symbolSize[1] / 2;
    var emphasisState = symbolPath.ensureState('emphasis');
    emphasisState.style = emphasisItemStyle;
    symbolPath.ensureState('select').style = selectItemStyle;
    symbolPath.ensureState('blur').style = blurItemStyle;

    if (hoverScale) {
      var scaleRatio = Math.max(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["isNumber"])(hoverScale) ? hoverScale : 1.1, 3 / this._sizeY);
      emphasisState.scaleX = this._sizeX * scaleRatio;
      emphasisState.scaleY = this._sizeY * scaleRatio;
    }

    this.setSymbolScale(1);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_states_js__["G" /* toggleHoverEmphasis */])(this, focus, blurScope, emphasisDisabled);
  };

  Symbol.prototype.setSymbolScale = function (scale) {
    this.scaleX = this.scaleY = scale;
  };

  Symbol.prototype.fadeOut = function (cb, seriesModel, opt) {
    var symbolPath = this.childAt(0);
    var dataIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_innerStore_js__["a" /* getECData */])(this).dataIndex;
    var animationOpt = opt && opt.animation; // Avoid mistaken hover when fading out

    this.silent = symbolPath.silent = true; // Not show text when animating

    if (opt && opt.fadeLabel) {
      var textContent = symbolPath.getTextContent();

      if (textContent) {
        __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["removeElement"](textContent, {
          style: {
            opacity: 0
          }
        }, seriesModel, {
          dataIndex: dataIndex,
          removeOpt: animationOpt,
          cb: function () {
            symbolPath.removeTextContent();
          }
        });
      }
    } else {
      symbolPath.removeTextContent();
    }

    __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["removeElement"](symbolPath, {
      style: {
        opacity: 0
      },
      scaleX: 0,
      scaleY: 0
    }, seriesModel, {
      dataIndex: dataIndex,
      cb: cb,
      removeOpt: animationOpt
    });
  };

  Symbol.getSymbolSize = function (data, idx) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_symbol_js__["c" /* normalizeSymbolSize */])(data.getItemVisual(idx, 'symbolSize'));
  };

  return Symbol;
}(__WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Group"]);

function driftSymbol(dx, dy) {
  this.parent.drift(dx, dy);
}

/* harmony default export */ __webpack_exports__["a"] = (Symbol);

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = initCurvenessList;
/* harmony export (immutable) */ __webpack_exports__["c"] = createEdgeMapForCurveness;
/* harmony export (immutable) */ __webpack_exports__["a"] = getCurvenessForEdge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// @ts-nocheck

var KEY_DELIMITER = '-->';
/**
 * params handler
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @returns {*}
 */

var getAutoCurvenessParams = function (seriesModel) {
  return seriesModel.get('autoCurveness') || null;
};
/**
 * Generate a list of edge curvatures, 20 is the default
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @param {number} appendLength
 * @return  20 => [0, -0.2, 0.2, -0.4, 0.4, -0.6, 0.6, -0.8, 0.8, -1, 1, -1.2, 1.2, -1.4, 1.4, -1.6, 1.6, -1.8, 1.8, -2]
 */


var createCurveness = function (seriesModel, appendLength) {
  var autoCurvenessParmas = getAutoCurvenessParams(seriesModel);
  var length = 20;
  var curvenessList = []; // handler the function set

  if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isNumber"](autoCurvenessParmas)) {
    length = autoCurvenessParmas;
  } else if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](autoCurvenessParmas)) {
    seriesModel.__curvenessList = autoCurvenessParmas;
    return;
  } // append length


  if (appendLength > length) {
    length = appendLength;
  } // make sure the length is even


  var len = length % 2 ? length + 2 : length + 3;
  curvenessList = [];

  for (var i = 0; i < len; i++) {
    curvenessList.push((i % 2 ? i + 1 : i) / 10 * (i % 2 ? -1 : 1));
  }

  seriesModel.__curvenessList = curvenessList;
};
/**
 * Create different cache key data in the positive and negative directions, in order to set the curvature later
 * @param {number|string|module:echarts/data/Graph.Node} n1
 * @param {number|string|module:echarts/data/Graph.Node} n2
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @returns {string} key
 */


var getKeyOfEdges = function (n1, n2, seriesModel) {
  var source = [n1.id, n1.dataIndex].join('.');
  var target = [n2.id, n2.dataIndex].join('.');
  return [seriesModel.uid, source, target].join(KEY_DELIMITER);
};
/**
 * get opposite key
 * @param {string} key
 * @returns {string}
 */


var getOppositeKey = function (key) {
  var keys = key.split(KEY_DELIMITER);
  return [keys[0], keys[2], keys[1]].join(KEY_DELIMITER);
};
/**
 * get edgeMap with key
 * @param edge
 * @param {module:echarts/model/SeriesModel} seriesModel
 */


var getEdgeFromMap = function (edge, seriesModel) {
  var key = getKeyOfEdges(edge.node1, edge.node2, seriesModel);
  return seriesModel.__edgeMap[key];
};
/**
 * calculate all cases total length
 * @param edge
 * @param seriesModel
 * @returns {number}
 */


var getTotalLengthBetweenNodes = function (edge, seriesModel) {
  var len = getEdgeMapLengthWithKey(getKeyOfEdges(edge.node1, edge.node2, seriesModel), seriesModel);
  var lenV = getEdgeMapLengthWithKey(getKeyOfEdges(edge.node2, edge.node1, seriesModel), seriesModel);
  return len + lenV;
};
/**
 *
 * @param key
 */


var getEdgeMapLengthWithKey = function (key, seriesModel) {
  var edgeMap = seriesModel.__edgeMap;
  return edgeMap[key] ? edgeMap[key].length : 0;
};
/**
 * Count the number of edges between the same two points, used to obtain the curvature table and the parity of the edge
 * @see /graph/GraphSeries.js@getInitialData
 * @param {module:echarts/model/SeriesModel} seriesModel
 */


function initCurvenessList(seriesModel) {
  if (!getAutoCurvenessParams(seriesModel)) {
    return;
  }

  seriesModel.__curvenessList = [];
  seriesModel.__edgeMap = {}; // calc the array of curveness List

  createCurveness(seriesModel);
}
/**
 * set edgeMap with key
 * @param {number|string|module:echarts/data/Graph.Node} n1
 * @param {number|string|module:echarts/data/Graph.Node} n2
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @param {number} index
 */

function createEdgeMapForCurveness(n1, n2, seriesModel, index) {
  if (!getAutoCurvenessParams(seriesModel)) {
    return;
  }

  var key = getKeyOfEdges(n1, n2, seriesModel);
  var edgeMap = seriesModel.__edgeMap;
  var oppositeEdges = edgeMap[getOppositeKey(key)]; // set direction

  if (edgeMap[key] && !oppositeEdges) {
    edgeMap[key].isForward = true;
  } else if (oppositeEdges && edgeMap[key]) {
    oppositeEdges.isForward = true;
    edgeMap[key].isForward = false;
  }

  edgeMap[key] = edgeMap[key] || [];
  edgeMap[key].push(index);
}
/**
 * get curvature for edge
 * @param edge
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @param index
 */

function getCurvenessForEdge(edge, seriesModel, index, needReverse) {
  var autoCurvenessParams = getAutoCurvenessParams(seriesModel);
  var isArrayParam = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](autoCurvenessParams);

  if (!autoCurvenessParams) {
    return null;
  }

  var edgeArray = getEdgeFromMap(edge, seriesModel);

  if (!edgeArray) {
    return null;
  }

  var edgeIndex = -1;

  for (var i = 0; i < edgeArray.length; i++) {
    if (edgeArray[i] === index) {
      edgeIndex = i;
      break;
    }
  } // if totalLen is Longer createCurveness


  var totalLen = getTotalLengthBetweenNodes(edge, seriesModel);
  createCurveness(seriesModel, totalLen);
  edge.lineStyle = edge.lineStyle || {}; // if is opposite edge, must set curvenss to opposite number

  var curKey = getKeyOfEdges(edge.node1, edge.node2, seriesModel);
  var curvenessList = seriesModel.__curvenessList; // if pass array no need parity

  var parityCorrection = isArrayParam ? 0 : totalLen % 2 ? 0 : 1;

  if (!edgeArray.isForward) {
    // the opposite edge show outside
    var oppositeKey = getOppositeKey(curKey);
    var len = getEdgeMapLengthWithKey(oppositeKey, seriesModel);
    var resValue = curvenessList[edgeIndex + len + parityCorrection]; // isNeedReverse, simple, force type need reverse the curveness in the junction of the forword and the opposite

    if (needReverse) {
      // set as array may make the parity handle with the len of opposite
      if (isArrayParam) {
        if (autoCurvenessParams && autoCurvenessParams[0] === 0) {
          return (len + parityCorrection) % 2 ? resValue : -resValue;
        } else {
          return ((len % 2 ? 0 : 1) + parityCorrection) % 2 ? resValue : -resValue;
        }
      } else {
        return (len + parityCorrection) % 2 ? resValue : -resValue;
      }
    } else {
      return curvenessList[edgeIndex + len + parityCorrection];
    }
  } else {
    return curvenessList[parityCorrection + edgeIndex];
  }
}

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = collect;
/* harmony export (immutable) */ __webpack_exports__["d"] = fixValue;
/* harmony export (immutable) */ __webpack_exports__["c"] = getAxisInfo;
/* harmony export (immutable) */ __webpack_exports__["e"] = getAxisPointerModel;
/* harmony export (immutable) */ __webpack_exports__["b"] = makeKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_Model_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

 // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
// allAxesInfo should be updated when setOption performed.

function collect(ecModel, api) {
  var result = {
    /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */
    axesInfo: {},
    seriesInvolved: false,

    /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */
    coordSysAxesInfo: {},
    coordSysMap: {}
  };
  collectAxesInfo(result, ecModel, api); // Check seriesInvolved for performance, in case too many series in some chart.

  result.seriesInvolved && collectSeriesInfo(result, ecModel);
  return result;
}

function collectAxesInfo(result, ecModel, api) {
  var globalTooltipModel = ecModel.getComponent('tooltip');
  var globalAxisPointerModel = ecModel.getComponent('axisPointer'); // links can only be set on global.

  var linksOption = globalAxisPointerModel.get('link', true) || [];
  var linkGroups = []; // Collect axes info.

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(api.getCoordinateSystems(), function (coordSys) {
    // Some coordinate system do not support axes, like geo.
    if (!coordSys.axisPointerEnabled) {
      return;
    }

    var coordSysKey = makeKey(coordSys.model);
    var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
    result.coordSysMap[coordSysKey] = coordSys; // Set tooltip (like 'cross') is a convienent way to show axisPointer
    // for user. So we enable seting tooltip on coordSys model.

    var coordSysModel = coordSys.model;
    var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(coordSys.getAxes(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["curry"])(saveTooltipAxisInfo, false, null)); // If axis tooltip used, choose tooltip axis for each coordSys.
    // Notice this case: coordSys is `grid` but not `cartesian2D` here.

    if (coordSys.getTooltipAxes && globalTooltipModel // If tooltip.showContent is set as false, tooltip will not
    // show but axisPointer will show as normal.
    && baseTooltipModel.get('show')) {
      // Compatible with previous logic. But series.tooltip.trigger: 'axis'
      // or series.data[n].tooltip.trigger: 'axis' are not support any more.
      var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
      var cross = baseTooltipModel.get(['axisPointer', 'type']) === 'cross';
      var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get(['axisPointer', 'axis']));

      if (triggerAxis || cross) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(tooltipAxes.baseAxes, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["curry"])(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
      }

      if (cross) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(tooltipAxes.otherAxes, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["curry"])(saveTooltipAxisInfo, 'cross', false));
      }
    } // fromTooltip: true | false | 'cross'
    // triggerTooltip: true | false | null


    function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
      var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
      var axisPointerShow = axisPointerModel.get('show');

      if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !isHandleTrigger(axisPointerModel)) {
        return;
      }

      if (triggerTooltip == null) {
        triggerTooltip = axisPointerModel.get('triggerTooltip');
      }

      axisPointerModel = fromTooltip ? makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
      var snap = axisPointerModel.get('snap');
      var axisKey = makeKey(axis.model);
      var involveSeries = triggerTooltip || snap || axis.type === 'category'; // If result.axesInfo[key] exist, override it (tooltip has higher priority).

      var axisInfo = result.axesInfo[axisKey] = {
        key: axisKey,
        axis: axis,
        coordSys: coordSys,
        axisPointerModel: axisPointerModel,
        triggerTooltip: triggerTooltip,
        involveSeries: involveSeries,
        snap: snap,
        useHandle: isHandleTrigger(axisPointerModel),
        seriesModels: [],
        linkGroup: null
      };
      axesInfoInCoordSys[axisKey] = axisInfo;
      result.seriesInvolved = result.seriesInvolved || involveSeries;
      var groupIndex = getLinkGroupIndex(linksOption, axis);

      if (groupIndex != null) {
        var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
          axesInfo: {}
        });
        linkGroup.axesInfo[axisKey] = axisInfo;
        linkGroup.mapper = linksOption[groupIndex].mapper;
        axisInfo.linkGroup = linkGroup;
      }
    }
  });
}

function makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
  var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
  var fields = ['type', 'snap', 'lineStyle', 'shadowStyle', 'label', 'animation', 'animationDurationUpdate', 'animationEasingUpdate', 'z'];
  var volatileOption = {};
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(fields, function (field) {
    volatileOption[field] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"])(tooltipAxisPointerModel.get(field));
  }); // category axis do not auto snap, otherwise some tick that do not
  // has value can not be hovered. value/time/log axis default snap if
  // triggered from tooltip and trigger tooltip.

  volatileOption.snap = axis.type !== 'category' && !!triggerTooltip; // Compatibel with previous behavior, tooltip axis do not show label by default.
  // Only these properties can be overrided from tooltip to axisPointer.

  if (tooltipAxisPointerModel.get('type') === 'cross') {
    volatileOption.type = 'line';
  }

  var labelOption = volatileOption.label || (volatileOption.label = {}); // Follow the convention, do not show label when triggered by tooltip by default.

  labelOption.show == null && (labelOption.show = false);

  if (fromTooltip === 'cross') {
    // When 'cross', both axes show labels.
    var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get(['label', 'show']);
    labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true; // If triggerTooltip, this is a base axis, which should better not use cross style
    // (cross style is dashed by default)

    if (!triggerTooltip) {
      var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
      crossStyle && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"])(labelOption, crossStyle.textStyle);
    }
  }

  return axis.model.getModel('axisPointer', new __WEBPACK_IMPORTED_MODULE_0__model_Model_js__["a" /* default */](volatileOption, globalAxisPointerModel, ecModel));
}

function collectSeriesInfo(result, ecModel) {
  // Prepare data for axis trigger
  ecModel.eachSeries(function (seriesModel) {
    // Notice this case: this coordSys is `cartesian2D` but not `grid`.
    var coordSys = seriesModel.coordinateSystem;
    var seriesTooltipTrigger = seriesModel.get(['tooltip', 'trigger'], true);
    var seriesTooltipShow = seriesModel.get(['tooltip', 'show'], true);

    if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get(['axisPointer', 'show'], true) === false) {
      return;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(result.coordSysAxesInfo[makeKey(coordSys.model)], function (axisInfo) {
      var axis = axisInfo.axis;

      if (coordSys.getAxis(axis.dim) === axis) {
        axisInfo.seriesModels.push(seriesModel);
        axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
        axisInfo.seriesDataCount += seriesModel.getData().count();
      }
    });
  });
}
/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */


function getLinkGroupIndex(linksOption, axis) {
  var axisModel = axis.model;
  var dim = axis.dim;

  for (var i = 0; i < linksOption.length; i++) {
    var linkOption = linksOption[i] || {};

    if (checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) {
      return i;
    }
  }
}

function checkPropInLink(linkPropValue, axisPropValue) {
  return linkPropValue === 'all' || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(linkPropValue) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["indexOf"])(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
}

function fixValue(axisModel) {
  var axisInfo = getAxisInfo(axisModel);

  if (!axisInfo) {
    return;
  }

  var axisPointerModel = axisInfo.axisPointerModel;
  var scale = axisInfo.axis.scale;
  var option = axisPointerModel.option;
  var status = axisPointerModel.get('status');
  var value = axisPointerModel.get('value'); // Parse init value for category and time axis.

  if (value != null) {
    value = scale.parse(value);
  }

  var useHandle = isHandleTrigger(axisPointerModel); // If `handle` used, `axisPointer` will always be displayed, so value
  // and status should be initialized.

  if (status == null) {
    option.status = useHandle ? 'show' : 'hide';
  }

  var extent = scale.getExtent().slice();
  extent[0] > extent[1] && extent.reverse();

  if ( // Pick a value on axis when initializing.
  value == null // If both `handle` and `dataZoom` are used, value may be out of axis extent,
  // where we should re-pick a value to keep `handle` displaying normally.
  || value > extent[1]) {
    // Make handle displayed on the end of the axis when init, which looks better.
    value = extent[1];
  }

  if (value < extent[0]) {
    value = extent[0];
  }

  option.value = value;

  if (useHandle) {
    option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
  }
}
function getAxisInfo(axisModel) {
  var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
  return coordSysAxesInfo && coordSysAxesInfo.axesInfo[makeKey(axisModel)];
}
function getAxisPointerModel(axisModel) {
  var axisInfo = getAxisInfo(axisModel);
  return axisInfo && axisInfo.axisPointerModel;
}

function isHandleTrigger(axisPointerModel) {
  return !!axisPointerModel.get(['handle', 'show']);
}
/**
 * @param {module:echarts/model/Model} model
 * @return {string} unique key
 */


function makeKey(model) {
  return model.type + '||' + model.id;
}

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildElStyle;
/* harmony export (immutable) */ __webpack_exports__["g"] = buildLabelElOption;
/* harmony export (immutable) */ __webpack_exports__["f"] = getValueLabel;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTransformedPosition;
/* harmony export (immutable) */ __webpack_exports__["b"] = buildCartesianSingleLabelElOption;
/* harmony export (immutable) */ __webpack_exports__["d"] = makeLineShape;
/* harmony export (immutable) */ __webpack_exports__["e"] = makeRectShape;
/* harmony export (immutable) */ __webpack_exports__["h"] = makeSectorShape;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_contain_text_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_format_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_matrix_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__coord_axisHelper_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__axis_AxisBuilder_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__ = __webpack_require__(15);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/








function buildElStyle(axisPointerModel) {
  var axisPointerType = axisPointerModel.get('type');
  var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
  var style;

  if (axisPointerType === 'line') {
    style = styleModel.getLineStyle();
    style.fill = null;
  } else if (axisPointerType === 'shadow') {
    style = styleModel.getAreaStyle();
    style.stroke = null;
  }

  return style;
}
/**
 * @param {Function} labelPos {align, verticalAlign, position}
 */

function buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos) {
  var value = axisPointerModel.get('value');
  var text = getValueLabel(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
    precision: axisPointerModel.get(['label', 'precision']),
    formatter: axisPointerModel.get(['label', 'formatter'])
  });
  var labelModel = axisPointerModel.getModel('label');
  var paddings = __WEBPACK_IMPORTED_MODULE_3__util_format_js__["f" /* normalizeCssArray */](labelModel.get('padding') || 0);
  var font = labelModel.getFont();
  var textRect = __WEBPACK_IMPORTED_MODULE_2_zrender_lib_contain_text_js__["g" /* getBoundingRect */](text, font);
  var position = labelPos.position;
  var width = textRect.width + paddings[1] + paddings[3];
  var height = textRect.height + paddings[0] + paddings[2]; // Adjust by align.

  var align = labelPos.align;
  align === 'right' && (position[0] -= width);
  align === 'center' && (position[0] -= width / 2);
  var verticalAlign = labelPos.verticalAlign;
  verticalAlign === 'bottom' && (position[1] -= height);
  verticalAlign === 'middle' && (position[1] -= height / 2); // Not overflow ec container

  confineInContainer(position, width, height, api);
  var bgColor = labelModel.get('backgroundColor');

  if (!bgColor || bgColor === 'auto') {
    bgColor = axisModel.get(['axisLine', 'lineStyle', 'color']);
  }

  elOption.label = {
    // shape: {x: 0, y: 0, width: width, height: height, r: labelModel.get('borderRadius')},
    x: position[0],
    y: position[1],
    style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__["d" /* createTextStyle */])(labelModel, {
      text: text,
      font: font,
      fill: labelModel.getTextColor(),
      padding: paddings,
      backgroundColor: bgColor
    }),
    // Lable should be over axisPointer.
    z2: 10
  };
} // Do not overflow ec container

function confineInContainer(position, width, height, api) {
  var viewWidth = api.getWidth();
  var viewHeight = api.getHeight();
  position[0] = Math.min(position[0] + width, viewWidth) - width;
  position[1] = Math.min(position[1] + height, viewHeight) - height;
  position[0] = Math.max(position[0], 0);
  position[1] = Math.max(position[1], 0);
}

function getValueLabel(value, axis, ecModel, seriesDataIndices, opt) {
  value = axis.scale.parse(value);
  var text = axis.scale.getLabel({
    value: value
  }, {
    // If `precision` is set, width can be fixed (like '12.00500'), which
    // helps to debounce when when moving label.
    precision: opt.precision
  });
  var formatter = opt.formatter;

  if (formatter) {
    var params_1 = {
      value: __WEBPACK_IMPORTED_MODULE_5__coord_axisHelper_js__["e" /* getAxisRawValue */](axis, {
        value: value
      }),
      axisDimension: axis.dim,
      axisIndex: axis.index,
      seriesData: []
    };
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](seriesDataIndices, function (idxItem) {
      var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
      var dataIndex = idxItem.dataIndexInside;
      var dataParams = series && series.getDataParams(dataIndex);
      dataParams && params_1.seriesData.push(dataParams);
    });

    if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"](formatter)) {
      text = formatter.replace('{value}', text);
    } else if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"](formatter)) {
      text = formatter(params_1);
    }
  }

  return text;
}
function getTransformedPosition(axis, value, layoutInfo) {
  var transform = __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_matrix_js__["create"]();
  __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_matrix_js__["rotate"](transform, transform, layoutInfo.rotation);
  __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_matrix_js__["translate"](transform, transform, layoutInfo.position);
  return __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["applyTransform"]([axis.dataToCoord(value), (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)], transform);
}
function buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
  // @ts-ignore
  var textLayout = __WEBPACK_IMPORTED_MODULE_6__axis_AxisBuilder_js__["a" /* default */].innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
  layoutInfo.labelMargin = axisPointerModel.get(['label', 'margin']);
  buildLabelElOption(elOption, axisModel, axisPointerModel, api, {
    position: getTransformedPosition(axisModel.axis, value, layoutInfo),
    align: textLayout.textAlign,
    verticalAlign: textLayout.textVerticalAlign
  });
}
function makeLineShape(p1, p2, xDimIndex) {
  xDimIndex = xDimIndex || 0;
  return {
    x1: p1[xDimIndex],
    y1: p1[1 - xDimIndex],
    x2: p2[xDimIndex],
    y2: p2[1 - xDimIndex]
  };
}
function makeRectShape(xy, wh, xDimIndex) {
  xDimIndex = xDimIndex || 0;
  return {
    x: xy[xDimIndex],
    y: xy[1 - xDimIndex],
    width: wh[xDimIndex],
    height: wh[1 - xDimIndex]
  };
}
function makeSectorShape(cx, cy, r0, r, startAngle, endAngle) {
  return {
    cx: cx,
    cy: cy,
    r0: r0,
    r: r,
    startAngle: startAngle,
    endAngle: endAngle,
    clockwise: true
  };
}

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = onIrrelevantElement;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var IRRELEVANT_EXCLUDES = {
  'axisPointer': 1,
  'tooltip': 1,
  'brush': 1
};
/**
 * Avoid that: mouse click on a elements that is over geo or graph,
 * but roam is triggered.
 */

function onIrrelevantElement(e, api, targetCoordSysModel) {
  var model = api.getComponentByElement(e.topTarget); // If model is axisModel, it works only if it is injected with coordinateSystem.

  var coordSys = model && model.coordinateSystem;
  return model && model !== targetCoordSysModel && !IRRELEVANT_EXCLUDES.hasOwnProperty(model.mainType) && coordSys && coordSys.model !== targetCoordSysModel;
}

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_matrix_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_Transformable_js__ = __webpack_require__(117);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Simple view coordinate system
 * Mapping given x, y to transformd view x, y
 */





var v2ApplyTransform = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["applyTransform"];

var View =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(View, _super);

  function View(name) {
    var _this = _super.call(this) || this;

    _this.type = 'view';
    _this.dimensions = ['x', 'y'];
    /**
     * Represents the transform brought by roam/zoom.
     * If `View['_viewRect']` applies roam transform,
     * we can get the final displayed rect.
     */

    _this._roamTransformable = new __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_Transformable_js__["a" /* default */]();
    /**
     * Represents the transform from `View['_rect']` to `View['_viewRect']`.
     */

    _this._rawTransformable = new __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_Transformable_js__["a" /* default */]();
    _this.name = name;
    return _this;
  }

  View.prototype.setBoundingRect = function (x, y, width, height) {
    this._rect = new __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_BoundingRect_js__["a" /* default */](x, y, width, height);
    return this._rect;
  };
  /**
   * @return {module:zrender/core/BoundingRect}
   */


  View.prototype.getBoundingRect = function () {
    return this._rect;
  };

  View.prototype.setViewRect = function (x, y, width, height) {
    this._transformTo(x, y, width, height);

    this._viewRect = new __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_BoundingRect_js__["a" /* default */](x, y, width, height);
  };
  /**
   * Transformed to particular position and size
   */


  View.prototype._transformTo = function (x, y, width, height) {
    var rect = this.getBoundingRect();
    var rawTransform = this._rawTransformable;
    rawTransform.transform = rect.calculateTransform(new __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_BoundingRect_js__["a" /* default */](x, y, width, height));
    var rawParent = rawTransform.parent;
    rawTransform.parent = null;
    rawTransform.decomposeTransform();
    rawTransform.parent = rawParent;

    this._updateTransform();
  };
  /**
   * Set center of view
   */


  View.prototype.setCenter = function (centerCoord) {
    if (!centerCoord) {
      return;
    }

    this._center = centerCoord;

    this._updateCenterAndZoom();
  };

  View.prototype.setZoom = function (zoom) {
    zoom = zoom || 1;
    var zoomLimit = this.zoomLimit;

    if (zoomLimit) {
      if (zoomLimit.max != null) {
        zoom = Math.min(zoomLimit.max, zoom);
      }

      if (zoomLimit.min != null) {
        zoom = Math.max(zoomLimit.min, zoom);
      }
    }

    this._zoom = zoom;

    this._updateCenterAndZoom();
  };
  /**
   * Get default center without roam
   */


  View.prototype.getDefaultCenter = function () {
    // Rect before any transform
    var rawRect = this.getBoundingRect();
    var cx = rawRect.x + rawRect.width / 2;
    var cy = rawRect.y + rawRect.height / 2;
    return [cx, cy];
  };

  View.prototype.getCenter = function () {
    return this._center || this.getDefaultCenter();
  };

  View.prototype.getZoom = function () {
    return this._zoom || 1;
  };

  View.prototype.getRoamTransform = function () {
    return this._roamTransformable.getLocalTransform();
  };
  /**
   * Remove roam
   */


  View.prototype._updateCenterAndZoom = function () {
    // Must update after view transform updated
    var rawTransformMatrix = this._rawTransformable.getLocalTransform();

    var roamTransform = this._roamTransformable;
    var defaultCenter = this.getDefaultCenter();
    var center = this.getCenter();
    var zoom = this.getZoom();
    center = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["applyTransform"]([], center, rawTransformMatrix);
    defaultCenter = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["applyTransform"]([], defaultCenter, rawTransformMatrix);
    roamTransform.originX = center[0];
    roamTransform.originY = center[1];
    roamTransform.x = defaultCenter[0] - center[0];
    roamTransform.y = defaultCenter[1] - center[1];
    roamTransform.scaleX = roamTransform.scaleY = zoom;

    this._updateTransform();
  };
  /**
   * Update transform props on `this` based on the current
   * `this._roamTransformable` and `this._rawTransformable`.
   */


  View.prototype._updateTransform = function () {
    var roamTransformable = this._roamTransformable;
    var rawTransformable = this._rawTransformable;
    rawTransformable.parent = roamTransformable;
    roamTransformable.updateTransform();
    rawTransformable.updateTransform();
    __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_matrix_js__["copy"](this.transform || (this.transform = []), rawTransformable.transform || __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_matrix_js__["create"]());
    this._rawTransform = rawTransformable.getLocalTransform();
    this.invTransform = this.invTransform || [];
    __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_matrix_js__["invert"](this.invTransform, this.transform);
    this.decomposeTransform();
  };

  View.prototype.getTransformInfo = function () {
    var rawTransformable = this._rawTransformable;
    var roamTransformable = this._roamTransformable; // Becuase roamTransformabel has `originX/originY` modified,
    // but the caller of `getTransformInfo` can not handle `originX/originY`,
    // so need to recalcualte them.

    var dummyTransformable = new __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_Transformable_js__["a" /* default */]();
    dummyTransformable.transform = roamTransformable.transform;
    dummyTransformable.decomposeTransform();
    return {
      roam: {
        x: dummyTransformable.x,
        y: dummyTransformable.y,
        scaleX: dummyTransformable.scaleX,
        scaleY: dummyTransformable.scaleY
      },
      raw: {
        x: rawTransformable.x,
        y: rawTransformable.y,
        scaleX: rawTransformable.scaleX,
        scaleY: rawTransformable.scaleY
      }
    };
  };

  View.prototype.getViewRect = function () {
    return this._viewRect;
  };
  /**
   * Get view rect after roam transform
   */


  View.prototype.getViewRectAfterRoam = function () {
    var rect = this.getBoundingRect().clone();
    rect.applyTransform(this.transform);
    return rect;
  };
  /**
   * Convert a single (lon, lat) data item to (x, y) point.
   */


  View.prototype.dataToPoint = function (data, noRoam, out) {
    var transform = noRoam ? this._rawTransform : this.transform;
    out = out || [];
    return transform ? v2ApplyTransform(out, data, transform) : __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["copy"](out, data);
  };
  /**
   * Convert a (x, y) point to (lon, lat) data
   */


  View.prototype.pointToData = function (point) {
    var invTransform = this.invTransform;
    return invTransform ? v2ApplyTransform([], point, invTransform) : [point[0], point[1]];
  };

  View.prototype.convertToPixel = function (ecModel, finder, value) {
    var coordSys = getCoordSys(finder);
    return coordSys === this ? coordSys.dataToPoint(value) : null;
  };

  View.prototype.convertFromPixel = function (ecModel, finder, pixel) {
    var coordSys = getCoordSys(finder);
    return coordSys === this ? coordSys.pointToData(pixel) : null;
  };
  /**
   * @implements
   */


  View.prototype.containPoint = function (point) {
    return this.getViewRectAfterRoam().contain(point[0], point[1]);
  };

  View.dimensions = ['x', 'y'];
  return View;
}(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_Transformable_js__["a" /* default */]);

function getCoordSys(finder) {
  var seriesModel = finder.seriesModel;
  return seriesModel ? seriesModel.coordinateSystem : null; // e.g., graph.
}

/* harmony default export */ __webpack_exports__["a"] = (View);

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = axisModelCreator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axisDefault_js__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_OrdinalMeta_js__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__axisCommonTypes_js__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






/**
 * Generate sub axis model class
 * @param axisName 'x' 'y' 'radius' 'angle' 'parallel' ...
 */

function axisModelCreator(registers, axisName, BaseAxisModelClass, extraDefaultOption) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["each"])(__WEBPACK_IMPORTED_MODULE_4__axisCommonTypes_js__["a" /* AXIS_TYPES */], function (v, axisType) {
    var defaultOption = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["merge"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["merge"])({}, __WEBPACK_IMPORTED_MODULE_1__axisDefault_js__["a" /* default */][axisType], true), extraDefaultOption, true);

    var AxisModel =
    /** @class */
    function (_super) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(AxisModel, _super);

      function AxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;

        _this.type = axisName + 'Axis.' + axisType;
        return _this;
      }

      AxisModel.prototype.mergeDefaultAndTheme = function (option, ecModel) {
        var layoutMode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_layout_js__["a" /* fetchLayoutMode */])(this);
        var inputPositionParams = layoutMode ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_layout_js__["b" /* getLayoutParams */])(option) : {};
        var themeModel = ecModel.getTheme();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["merge"])(option, themeModel.get(axisType + 'Axis'));
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["merge"])(option, this.getDefaultOption());
        option.type = getAxisType(option);

        if (layoutMode) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_layout_js__["c" /* mergeLayoutParam */])(option, inputPositionParams, layoutMode);
        }
      };

      AxisModel.prototype.optionUpdated = function () {
        var thisOption = this.option;

        if (thisOption.type === 'category') {
          this.__ordinalMeta = __WEBPACK_IMPORTED_MODULE_3__data_OrdinalMeta_js__["a" /* default */].createByAxisModel(this);
        }
      };
      /**
       * Should not be called before all of 'getInitailData' finished.
       * Because categories are collected during initializing data.
       */


      AxisModel.prototype.getCategories = function (rawData) {
        var option = this.option; // FIXME
        // warning if called before all of 'getInitailData' finished.

        if (option.type === 'category') {
          if (rawData) {
            return option.data;
          }

          return this.__ordinalMeta.categories;
        }
      };

      AxisModel.prototype.getOrdinalMeta = function () {
        return this.__ordinalMeta;
      };

      AxisModel.type = axisName + 'Axis.' + axisType;
      AxisModel.defaultOption = defaultOption;
      return AxisModel;
    }(BaseAxisModelClass);

    registers.registerComponentModel(AxisModel);
  });
  registers.registerSubTypeDefaulter(axisName + 'Axis', getAxisType);
}

function getAxisType(option) {
  // Default axis with data is category axis
  return option.type || (option.data ? 'category' : 'value');
}

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SYSTEM_LANG; });
/* harmony export (immutable) */ __webpack_exports__["e"] = registerLocale;
/* harmony export (immutable) */ __webpack_exports__["d"] = createLocaleObject;
/* harmony export (immutable) */ __webpack_exports__["a"] = getLocaleModel;
/* harmony export (immutable) */ __webpack_exports__["c"] = getDefaultLocaleModel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_Model_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_env_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_langEN_js__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_langZH_js__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

 // default import ZH and EN lang




var LOCALE_ZH = 'ZH';
var LOCALE_EN = 'EN';
var DEFAULT_LOCALE = LOCALE_EN;
var localeStorage = {};
var localeModels = {};
var SYSTEM_LANG = !__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_env_js__["a" /* default */].domSupported ? DEFAULT_LOCALE : function () {
  var langStr = (
  /* eslint-disable-next-line */
  document.documentElement.lang || navigator.language || navigator.browserLanguage).toUpperCase();
  return langStr.indexOf(LOCALE_ZH) > -1 ? LOCALE_ZH : DEFAULT_LOCALE;
}();
function registerLocale(locale, localeObj) {
  locale = locale.toUpperCase();
  localeModels[locale] = new __WEBPACK_IMPORTED_MODULE_0__model_Model_js__["a" /* default */](localeObj);
  localeStorage[locale] = localeObj;
} // export function getLocale(locale: string) {
//     return localeStorage[locale];
// }

function createLocaleObject(locale) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["isString"])(locale)) {
    var localeObj = localeStorage[locale.toUpperCase()] || {};

    if (locale === LOCALE_ZH || locale === LOCALE_EN) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["clone"])(localeObj);
    } else {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["merge"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["clone"])(localeObj), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["clone"])(localeStorage[DEFAULT_LOCALE]), false);
    }
  } else {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["merge"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["clone"])(locale), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["clone"])(localeStorage[DEFAULT_LOCALE]), false);
  }
}
function getLocaleModel(lang) {
  return localeModels[lang];
}
function getDefaultLocaleModel() {
  return localeModels[DEFAULT_LOCALE];
} // Default locale

registerLocale(LOCALE_EN, __WEBPACK_IMPORTED_MODULE_2__i18n_langEN_js__["a" /* default */]);
registerLocale(LOCALE_ZH, __WEBPACK_IMPORTED_MODULE_3__i18n_langZH_js__["a" /* default */]);

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = summarizeDimensions;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDimensionTypeByAxis;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_types_js__ = __webpack_require__(66);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var DimensionUserOuput =
/** @class */
function () {
  function DimensionUserOuput(encode, dimRequest) {
    this._encode = encode;
    this._schema = dimRequest;
  }

  DimensionUserOuput.prototype.get = function () {
    return {
      // Do not generate full dimension name until fist used.
      fullDimensions: this._getFullDimensionNames(),
      encode: this._encode
    };
  };
  /**
   * Get all data store dimension names.
   * Theoretically a series data store is defined both by series and used dataset (if any).
   * If some dimensions are omitted for performance reason in `this.dimensions`,
   * the dimension name may not be auto-generated if user does not specify a dimension name.
   * In this case, the dimension name is `null`/`undefined`.
   */


  DimensionUserOuput.prototype._getFullDimensionNames = function () {
    if (!this._cachedDimNames) {
      this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : [];
    }

    return this._cachedDimNames;
  };

  return DimensionUserOuput;
}();

;
function summarizeDimensions(data, schema) {
  var summary = {};
  var encode = summary.encode = {};
  var notExtraCoordDimMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();
  var defaultedLabel = [];
  var defaultedTooltip = [];
  var userOutputEncode = {};
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(data.dimensions, function (dimName) {
    var dimItem = data.getDimensionInfo(dimName);
    var coordDim = dimItem.coordDim;

    if (coordDim) {
      if (true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(__WEBPACK_IMPORTED_MODULE_1__util_types_js__["i" /* VISUAL_DIMENSIONS */].get(coordDim) == null);
      }

      var coordDimIndex = dimItem.coordDimIndex;
      getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;

      if (!dimItem.isExtraCoord) {
        notExtraCoordDimMap.set(coordDim, 1); // Use the last coord dim (and label friendly) as default label,
        // because when dataset is used, it is hard to guess which dimension
        // can be value dimension. If both show x, y on label is not look good,
        // and conventionally y axis is focused more.

        if (mayLabelDimType(dimItem.type)) {
          defaultedLabel[0] = dimName;
        } // User output encode do not contain generated coords.
        // And it only has index. User can use index to retrieve value from the raw item array.


        getOrCreateEncodeArr(userOutputEncode, coordDim)[coordDimIndex] = data.getDimensionIndex(dimItem.name);
      }

      if (dimItem.defaultTooltip) {
        defaultedTooltip.push(dimName);
      }
    }

    __WEBPACK_IMPORTED_MODULE_1__util_types_js__["i" /* VISUAL_DIMENSIONS */].each(function (v, otherDim) {
      var encodeArr = getOrCreateEncodeArr(encode, otherDim);
      var dimIndex = dimItem.otherDims[otherDim];

      if (dimIndex != null && dimIndex !== false) {
        encodeArr[dimIndex] = dimItem.name;
      }
    });
  });
  var dataDimsOnCoord = [];
  var encodeFirstDimNotExtra = {};
  notExtraCoordDimMap.each(function (v, coordDim) {
    var dimArr = encode[coordDim];
    encodeFirstDimNotExtra[coordDim] = dimArr[0]; // Not necessary to remove duplicate, because a data
    // dim canot on more than one coordDim.

    dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
  });
  summary.dataDimsOnCoord = dataDimsOnCoord;
  summary.dataDimIndicesOnCoord = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])(dataDimsOnCoord, function (dimName) {
    return data.getDimensionInfo(dimName).storeDimIndex;
  });
  summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
  var encodeLabel = encode.label; // FIXME `encode.label` is not recommanded, because formatter can not be set
  // in this way. Use label.formatter instead. May be remove this approach someday.

  if (encodeLabel && encodeLabel.length) {
    defaultedLabel = encodeLabel.slice();
  }

  var encodeTooltip = encode.tooltip;

  if (encodeTooltip && encodeTooltip.length) {
    defaultedTooltip = encodeTooltip.slice();
  } else if (!defaultedTooltip.length) {
    defaultedTooltip = defaultedLabel.slice();
  }

  encode.defaultedLabel = defaultedLabel;
  encode.defaultedTooltip = defaultedTooltip;
  summary.userOutput = new DimensionUserOuput(userOutputEncode, schema);
  return summary;
}

function getOrCreateEncodeArr(encode, dim) {
  if (!encode.hasOwnProperty(dim)) {
    encode[dim] = [];
  }

  return encode[dim];
} // FIXME:TS should be type `AxisType`


function getDimensionTypeByAxis(axisType) {
  return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
}

function mayLabelDimType(dimType) {
  // In most cases, ordinal and time do not suitable for label.
  // Ordinal info can be displayed on axis. Time is too long.
  return !(dimType === 'ordinal' || dimType === 'time');
} // function findTheLastDimMayLabel(data) {
//     // Get last value dim
//     let dimensions = data.dimensions.slice();
//     let valueType;
//     let valueDim;
//     while (dimensions.length && (
//         valueDim = dimensions.pop(),
//         valueType = data.getDimensionInfo(valueDim).type,
//         valueType === 'ordinal' || valueType === 'time'
//     )) {} // jshint ignore:line
//     return valueDim;
// }

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateLabelLinePoints;
/* harmony export (immutable) */ __webpack_exports__["d"] = limitTurnAngle;
/* harmony export (immutable) */ __webpack_exports__["e"] = limitSurfaceAngle;
/* harmony export (immutable) */ __webpack_exports__["b"] = setLabelLineStyle;
/* harmony export (immutable) */ __webpack_exports__["c"] = getLabelLineStatesModels;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_PathProxy_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_contain_util_js__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_curve_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_matrix_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_vector_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_states_js__ = __webpack_require__(12);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/








var PI2 = Math.PI * 2;
var CMD = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_PathProxy_js__["a" /* default */].CMD;
var DEFAULT_SEARCH_SPACE = ['top', 'right', 'bottom', 'left'];

function getCandidateAnchor(pos, distance, rect, outPt, outDir) {
  var width = rect.width;
  var height = rect.height;

  switch (pos) {
    case 'top':
      outPt.set(rect.x + width / 2, rect.y - distance);
      outDir.set(0, -1);
      break;

    case 'bottom':
      outPt.set(rect.x + width / 2, rect.y + height + distance);
      outDir.set(0, 1);
      break;

    case 'left':
      outPt.set(rect.x - distance, rect.y + height / 2);
      outDir.set(-1, 0);
      break;

    case 'right':
      outPt.set(rect.x + width + distance, rect.y + height / 2);
      outDir.set(1, 0);
      break;
  }
}

function projectPointToArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y, out) {
  x -= cx;
  y -= cy;
  var d = Math.sqrt(x * x + y * y);
  x /= d;
  y /= d; // Intersect point.

  var ox = x * r + cx;
  var oy = y * r + cy;

  if (Math.abs(startAngle - endAngle) % PI2 < 1e-4) {
    // Is a circle
    out[0] = ox;
    out[1] = oy;
    return d - r;
  }

  if (anticlockwise) {
    var tmp = startAngle;
    startAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_contain_util_js__["a" /* normalizeRadian */])(endAngle);
    endAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_contain_util_js__["a" /* normalizeRadian */])(tmp);
  } else {
    startAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_contain_util_js__["a" /* normalizeRadian */])(startAngle);
    endAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_contain_util_js__["a" /* normalizeRadian */])(endAngle);
  }

  if (startAngle > endAngle) {
    endAngle += PI2;
  }

  var angle = Math.atan2(y, x);

  if (angle < 0) {
    angle += PI2;
  }

  if (angle >= startAngle && angle <= endAngle || angle + PI2 >= startAngle && angle + PI2 <= endAngle) {
    // Project point is on the arc.
    out[0] = ox;
    out[1] = oy;
    return d - r;
  }

  var x1 = r * Math.cos(startAngle) + cx;
  var y1 = r * Math.sin(startAngle) + cy;
  var x2 = r * Math.cos(endAngle) + cx;
  var y2 = r * Math.sin(endAngle) + cy;
  var d1 = (x1 - x) * (x1 - x) + (y1 - y) * (y1 - y);
  var d2 = (x2 - x) * (x2 - x) + (y2 - y) * (y2 - y);

  if (d1 < d2) {
    out[0] = x1;
    out[1] = y1;
    return Math.sqrt(d1);
  } else {
    out[0] = x2;
    out[1] = y2;
    return Math.sqrt(d2);
  }
}

function projectPointToLine(x1, y1, x2, y2, x, y, out, limitToEnds) {
  var dx = x - x1;
  var dy = y - y1;
  var dx1 = x2 - x1;
  var dy1 = y2 - y1;
  var lineLen = Math.sqrt(dx1 * dx1 + dy1 * dy1);
  dx1 /= lineLen;
  dy1 /= lineLen; // dot product

  var projectedLen = dx * dx1 + dy * dy1;
  var t = projectedLen / lineLen;

  if (limitToEnds) {
    t = Math.min(Math.max(t, 0), 1);
  }

  t *= lineLen;
  var ox = out[0] = x1 + t * dx1;
  var oy = out[1] = y1 + t * dy1;
  return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}

function projectPointToRect(x1, y1, width, height, x, y, out) {
  if (width < 0) {
    x1 = x1 + width;
    width = -width;
  }

  if (height < 0) {
    y1 = y1 + height;
    height = -height;
  }

  var x2 = x1 + width;
  var y2 = y1 + height;
  var ox = out[0] = Math.min(Math.max(x, x1), x2);
  var oy = out[1] = Math.min(Math.max(y, y1), y2);
  return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}

var tmpPt = [];

function nearestPointOnRect(pt, rect, out) {
  var dist = projectPointToRect(rect.x, rect.y, rect.width, rect.height, pt.x, pt.y, tmpPt);
  out.set(tmpPt[0], tmpPt[1]);
  return dist;
}
/**
 * Calculate min distance corresponding point.
 * This method won't evaluate if point is in the path.
 */


function nearestPointOnPath(pt, path, out) {
  var xi = 0;
  var yi = 0;
  var x0 = 0;
  var y0 = 0;
  var x1;
  var y1;
  var minDist = Infinity;
  var data = path.data;
  var x = pt.x;
  var y = pt.y;

  for (var i = 0; i < data.length;) {
    var cmd = data[i++];

    if (i === 1) {
      xi = data[i];
      yi = data[i + 1];
      x0 = xi;
      y0 = yi;
    }

    var d = minDist;

    switch (cmd) {
      case CMD.M:
        // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
        // 在 closePath 的时候使用
        x0 = data[i++];
        y0 = data[i++];
        xi = x0;
        yi = y0;
        break;

      case CMD.L:
        d = projectPointToLine(xi, yi, data[i], data[i + 1], x, y, tmpPt, true);
        xi = data[i++];
        yi = data[i++];
        break;

      case CMD.C:
        d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_curve_js__["h" /* cubicProjectPoint */])(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y, tmpPt);
        xi = data[i++];
        yi = data[i++];
        break;

      case CMD.Q:
        d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_curve_js__["g" /* quadraticProjectPoint */])(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y, tmpPt);
        xi = data[i++];
        yi = data[i++];
        break;

      case CMD.A:
        // TODO Arc 判断的开销比较大
        var cx = data[i++];
        var cy = data[i++];
        var rx = data[i++];
        var ry = data[i++];
        var theta = data[i++];
        var dTheta = data[i++]; // TODO Arc 旋转

        i += 1;
        var anticlockwise = !!(1 - data[i++]);
        x1 = Math.cos(theta) * rx + cx;
        y1 = Math.sin(theta) * ry + cy; // 不是直接使用 arc 命令

        if (i <= 1) {
          // 第一个命令起点还未定义
          x0 = x1;
          y0 = y1;
        } // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放


        var _x = (x - cx) * ry / rx + cx;

        d = projectPointToArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y, tmpPt);
        xi = Math.cos(theta + dTheta) * rx + cx;
        yi = Math.sin(theta + dTheta) * ry + cy;
        break;

      case CMD.R:
        x0 = xi = data[i++];
        y0 = yi = data[i++];
        var width = data[i++];
        var height = data[i++];
        d = projectPointToRect(x0, y0, width, height, x, y, tmpPt);
        break;

      case CMD.Z:
        d = projectPointToLine(xi, yi, x0, y0, x, y, tmpPt, true);
        xi = x0;
        yi = y0;
        break;
    }

    if (d < minDist) {
      minDist = d;
      out.set(tmpPt[0], tmpPt[1]);
    }
  }

  return minDist;
} // Temporal varible for intermediate usage.


var pt0 = new __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Point"]();
var pt1 = new __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Point"]();
var pt2 = new __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Point"]();
var dir = new __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Point"]();
var dir2 = new __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Point"]();
/**
 * Calculate a proper guide line based on the label position and graphic element definition
 * @param label
 * @param labelRect
 * @param target
 * @param targetRect
 */

function updateLabelLinePoints(target, labelLineModel) {
  if (!target) {
    return;
  }

  var labelLine = target.getTextGuideLine();
  var label = target.getTextContent(); // Needs to create text guide in each charts.

  if (!(label && labelLine)) {
    return;
  }

  var labelGuideConfig = target.textGuideLineConfig || {};
  var points = [[0, 0], [0, 0], [0, 0]];
  var searchSpace = labelGuideConfig.candidates || DEFAULT_SEARCH_SPACE;
  var labelRect = label.getBoundingRect().clone();
  labelRect.applyTransform(label.getComputedTransform());
  var minDist = Infinity;
  var anchorPoint = labelGuideConfig.anchor;
  var targetTransform = target.getComputedTransform();
  var targetInversedTransform = targetTransform && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_matrix_js__["invert"])([], targetTransform);
  var len = labelLineModel.get('length2') || 0;

  if (anchorPoint) {
    pt2.copy(anchorPoint);
  }

  for (var i = 0; i < searchSpace.length; i++) {
    var candidate = searchSpace[i];
    getCandidateAnchor(candidate, 0, labelRect, pt0, dir);
    __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Point"].scaleAndAdd(pt1, pt0, dir, len); // Transform to target coord space.

    pt1.transform(targetInversedTransform); // Note: getBoundingRect will ensure the `path` being created.

    var boundingRect = target.getBoundingRect();
    var dist = anchorPoint ? anchorPoint.distance(pt1) : target instanceof __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Path"] ? nearestPointOnPath(pt1, target.path, pt2) : nearestPointOnRect(pt1, boundingRect, pt2); // TODO pt2 is in the path

    if (dist < minDist) {
      minDist = dist; // Transform back to global space.

      pt1.transform(targetTransform);
      pt2.transform(targetTransform);
      pt2.toArray(points[0]);
      pt1.toArray(points[1]);
      pt0.toArray(points[2]);
    }
  }

  limitTurnAngle(points, labelLineModel.get('minTurnAngle'));
  labelLine.setShape({
    points: points
  });
} // Temporal variable for the limitTurnAngle function

var tmpArr = [];
var tmpProjPoint = new __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Point"]();
/**
 * Reduce the line segment attached to the label to limit the turn angle between two segments.
 * @param linePoints
 * @param minTurnAngle Radian of minimum turn angle. 0 - 180
 */

function limitTurnAngle(linePoints, minTurnAngle) {
  if (!(minTurnAngle <= 180 && minTurnAngle > 0)) {
    return;
  }

  minTurnAngle = minTurnAngle / 180 * Math.PI; // The line points can be
  //      /pt1----pt2 (label)
  //     /
  // pt0/

  pt0.fromArray(linePoints[0]);
  pt1.fromArray(linePoints[1]);
  pt2.fromArray(linePoints[2]);
  __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Point"].sub(dir, pt0, pt1);
  __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Point"].sub(dir2, pt2, pt1);
  var len1 = dir.len();
  var len2 = dir2.len();

  if (len1 < 1e-3 || len2 < 1e-3) {
    return;
  }

  dir.scale(1 / len1);
  dir2.scale(1 / len2);
  var angleCos = dir.dot(dir2);
  var minTurnAngleCos = Math.cos(minTurnAngle);

  if (minTurnAngleCos < angleCos) {
    // Smaller than minTurnAngle
    // Calculate project point of pt0 on pt1-pt2
    var d = projectPointToLine(pt1.x, pt1.y, pt2.x, pt2.y, pt0.x, pt0.y, tmpArr, false);
    tmpProjPoint.fromArray(tmpArr); // Calculate new projected length with limited minTurnAngle and get the new connect point

    tmpProjPoint.scaleAndAdd(dir2, d / Math.tan(Math.PI - minTurnAngle)); // Limit the new calculated connect point between pt1 and pt2.

    var t = pt2.x !== pt1.x ? (tmpProjPoint.x - pt1.x) / (pt2.x - pt1.x) : (tmpProjPoint.y - pt1.y) / (pt2.y - pt1.y);

    if (isNaN(t)) {
      return;
    }

    if (t < 0) {
      __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Point"].copy(tmpProjPoint, pt1);
    } else if (t > 1) {
      __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Point"].copy(tmpProjPoint, pt2);
    }

    tmpProjPoint.toArray(linePoints[1]);
  }
}
/**
 * Limit the angle of line and the surface
 * @param maxSurfaceAngle Radian of minimum turn angle. 0 - 180. 0 is same direction to normal. 180 is opposite
 */

function limitSurfaceAngle(linePoints, surfaceNormal, maxSurfaceAngle) {
  if (!(maxSurfaceAngle <= 180 && maxSurfaceAngle > 0)) {
    return;
  }

  maxSurfaceAngle = maxSurfaceAngle / 180 * Math.PI;
  pt0.fromArray(linePoints[0]);
  pt1.fromArray(linePoints[1]);
  pt2.fromArray(linePoints[2]);
  __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Point"].sub(dir, pt1, pt0);
  __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Point"].sub(dir2, pt2, pt1);
  var len1 = dir.len();
  var len2 = dir2.len();

  if (len1 < 1e-3 || len2 < 1e-3) {
    return;
  }

  dir.scale(1 / len1);
  dir2.scale(1 / len2);
  var angleCos = dir.dot(surfaceNormal);
  var maxSurfaceAngleCos = Math.cos(maxSurfaceAngle);

  if (angleCos < maxSurfaceAngleCos) {
    // Calculate project point of pt0 on pt1-pt2
    var d = projectPointToLine(pt1.x, pt1.y, pt2.x, pt2.y, pt0.x, pt0.y, tmpArr, false);
    tmpProjPoint.fromArray(tmpArr);
    var HALF_PI = Math.PI / 2;
    var angle2 = Math.acos(dir2.dot(surfaceNormal));
    var newAngle = HALF_PI + angle2 - maxSurfaceAngle;

    if (newAngle >= HALF_PI) {
      // parallel
      __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Point"].copy(tmpProjPoint, pt2);
    } else {
      // Calculate new projected length with limited minTurnAngle and get the new connect point
      tmpProjPoint.scaleAndAdd(dir2, d / Math.tan(Math.PI / 2 - newAngle)); // Limit the new calculated connect point between pt1 and pt2.

      var t = pt2.x !== pt1.x ? (tmpProjPoint.x - pt1.x) / (pt2.x - pt1.x) : (tmpProjPoint.y - pt1.y) / (pt2.y - pt1.y);

      if (isNaN(t)) {
        return;
      }

      if (t < 0) {
        __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Point"].copy(tmpProjPoint, pt1);
      } else if (t > 1) {
        __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Point"].copy(tmpProjPoint, pt2);
      }
    }

    tmpProjPoint.toArray(linePoints[1]);
  }
}

function setLabelLineState(labelLine, ignore, stateName, stateModel) {
  var isNormal = stateName === 'normal';
  var stateObj = isNormal ? labelLine : labelLine.ensureState(stateName); // Make sure display.

  stateObj.ignore = ignore; // Set smooth

  var smooth = stateModel.get('smooth');

  if (smooth && smooth === true) {
    smooth = 0.3;
  }

  stateObj.shape = stateObj.shape || {};

  if (smooth > 0) {
    stateObj.shape.smooth = smooth;
  }

  var styleObj = stateModel.getModel('lineStyle').getLineStyle();
  isNormal ? labelLine.useStyle(styleObj) : stateObj.style = styleObj;
}

function buildLabelLinePath(path, shape) {
  var smooth = shape.smooth;
  var points = shape.points;

  if (!points) {
    return;
  }

  path.moveTo(points[0][0], points[0][1]);

  if (smooth > 0 && points.length >= 3) {
    var len1 = __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_vector_js__["dist"](points[0], points[1]);
    var len2 = __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_vector_js__["dist"](points[1], points[2]);

    if (!len1 || !len2) {
      path.lineTo(points[1][0], points[1][1]);
      path.lineTo(points[2][0], points[2][1]);
      return;
    }

    var moveLen = Math.min(len1, len2) * smooth;
    var midPoint0 = __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_vector_js__["lerp"]([], points[1], points[0], moveLen / len1);
    var midPoint2 = __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_vector_js__["lerp"]([], points[1], points[2], moveLen / len2);
    var midPoint1 = __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_vector_js__["lerp"]([], midPoint0, midPoint2, 0.5);
    path.bezierCurveTo(midPoint0[0], midPoint0[1], midPoint0[0], midPoint0[1], midPoint1[0], midPoint1[1]);
    path.bezierCurveTo(midPoint2[0], midPoint2[1], midPoint2[0], midPoint2[1], points[2][0], points[2][1]);
  } else {
    for (var i = 1; i < points.length; i++) {
      path.lineTo(points[i][0], points[i][1]);
    }
  }
}
/**
 * Create a label line if necessary and set it's style.
 */


function setLabelLineStyle(targetEl, statesModels, defaultStyle) {
  var labelLine = targetEl.getTextGuideLine();
  var label = targetEl.getTextContent();

  if (!label) {
    // Not show label line if there is no label.
    if (labelLine) {
      targetEl.removeTextGuideLine();
    }

    return;
  }

  var normalModel = statesModels.normal;
  var showNormal = normalModel.get('show');
  var labelIgnoreNormal = label.ignore;

  for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_7__util_states_js__["b" /* DISPLAY_STATES */].length; i++) {
    var stateName = __WEBPACK_IMPORTED_MODULE_7__util_states_js__["b" /* DISPLAY_STATES */][i];
    var stateModel = statesModels[stateName];
    var isNormal = stateName === 'normal';

    if (stateModel) {
      var stateShow = stateModel.get('show');
      var isLabelIgnored = isNormal ? labelIgnoreNormal : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["retrieve2"])(label.states[stateName] && label.states[stateName].ignore, labelIgnoreNormal);

      if (isLabelIgnored // Not show when label is not shown in this state.
      || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["retrieve2"])(stateShow, showNormal) // Use normal state by default if not set.
      ) {
          var stateObj = isNormal ? labelLine : labelLine && labelLine.states[stateName];

          if (stateObj) {
            stateObj.ignore = true;
          }

          continue;
        } // Create labelLine if not exists


      if (!labelLine) {
        labelLine = new __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Polyline"]();
        targetEl.setTextGuideLine(labelLine); // Reset state of normal because it's new created.
        // NOTE: NORMAL should always been the first!

        if (!isNormal && (labelIgnoreNormal || !showNormal)) {
          setLabelLineState(labelLine, true, 'normal', statesModels.normal);
        } // Use same state proxy.


        if (targetEl.stateProxy) {
          labelLine.stateProxy = targetEl.stateProxy;
        }
      }

      setLabelLineState(labelLine, false, stateName, stateModel);
    }
  }

  if (labelLine) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["defaults"])(labelLine.style, defaultStyle); // Not fill.

    labelLine.style.fill = null;
    var showAbove = normalModel.get('showAbove');
    var labelLineConfig = targetEl.textGuideLineConfig = targetEl.textGuideLineConfig || {};
    labelLineConfig.showAbove = showAbove || false; // Custom the buildPath.

    labelLine.buildPath = buildLabelLinePath;
  }
}
function getLabelLineStatesModels(itemModel, labelLineName) {
  labelLineName = labelLineName || 'labelLine';
  var statesModels = {
    normal: itemModel.getModel(labelLineName)
  };

  for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_7__util_states_js__["a" /* SPECIAL_STATES */].length; i++) {
    var stateName = __WEBPACK_IMPORTED_MODULE_7__util_states_js__["a" /* SPECIAL_STATES */][i];
    statesModels[stateName] = itemModel.getModel([stateName, labelLineName]);
  }

  return statesModels;
}

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getLayoutOnAxis;
/* harmony export (immutable) */ __webpack_exports__["a"] = prepareLayoutBarSeries;
/* harmony export (immutable) */ __webpack_exports__["b"] = makeColumnLayout;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return retrieveColumnLayout; });
/* harmony export (immutable) */ __webpack_exports__["e"] = layout;
/* harmony export (immutable) */ __webpack_exports__["f"] = createProgressiveLayout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_helper_dataStackHelper_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chart_helper_createRenderPlanner_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_vendor_js__ = __webpack_require__(198);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var STACK_PREFIX = '__ec_stack_';

function getSeriesStackId(seriesModel) {
  return seriesModel.get('stack') || STACK_PREFIX + seriesModel.seriesIndex;
}

function getAxisKey(axis) {
  return axis.dim + axis.index;
}
/**
 * @return {Object} {width, offset, offsetCenter} If axis.type is not 'category', return undefined.
 */


function getLayoutOnAxis(opt) {
  var params = [];
  var baseAxis = opt.axis;
  var axisKey = 'axis0';

  if (baseAxis.type !== 'category') {
    return;
  }

  var bandWidth = baseAxis.getBandWidth();

  for (var i = 0; i < opt.count || 0; i++) {
    params.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["defaults"])({
      bandWidth: bandWidth,
      axisKey: axisKey,
      stackId: STACK_PREFIX + i
    }, opt));
  }

  var widthAndOffsets = doCalBarWidthAndOffset(params);
  var result = [];

  for (var i = 0; i < opt.count; i++) {
    var item = widthAndOffsets[axisKey][STACK_PREFIX + i];
    item.offsetCenter = item.offset + item.width / 2;
    result.push(item);
  }

  return result;
}
function prepareLayoutBarSeries(seriesType, ecModel) {
  var seriesModels = [];
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    // Check series coordinate, do layout for cartesian2d only
    if (isOnCartesian(seriesModel)) {
      seriesModels.push(seriesModel);
    }
  });
  return seriesModels;
}
/**
 * Map from (baseAxis.dim + '_' + baseAxis.index) to min gap of two adjacent
 * values.
 * This works for time axes, value axes, and log axes.
 * For a single time axis, return value is in the form like
 * {'x_0': [1000000]}.
 * The value of 1000000 is in milliseconds.
 */

function getValueAxesMinGaps(barSeries) {
  /**
   * Map from axis.index to values.
   * For a single time axis, axisValues is in the form like
   * {'x_0': [1495555200000, 1495641600000, 1495728000000]}.
   * Items in axisValues[x], e.g. 1495555200000, are time values of all
   * series.
   */
  var axisValues = {};
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(barSeries, function (seriesModel) {
    var cartesian = seriesModel.coordinateSystem;
    var baseAxis = cartesian.getBaseAxis();

    if (baseAxis.type !== 'time' && baseAxis.type !== 'value') {
      return;
    }

    var data = seriesModel.getData();
    var key = baseAxis.dim + '_' + baseAxis.index;
    var dimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
    var store = data.getStore();

    for (var i = 0, cnt = store.count(); i < cnt; ++i) {
      var value = store.get(dimIdx, i);

      if (!axisValues[key]) {
        // No previous data for the axis
        axisValues[key] = [value];
      } else {
        // No value in previous series
        axisValues[key].push(value);
      } // Ignore duplicated time values in the same axis

    }
  });
  var axisMinGaps = {};

  for (var key in axisValues) {
    if (axisValues.hasOwnProperty(key)) {
      var valuesInAxis = axisValues[key];

      if (valuesInAxis) {
        // Sort axis values into ascending order to calculate gaps
        valuesInAxis.sort(function (a, b) {
          return a - b;
        });
        var min = null;

        for (var j = 1; j < valuesInAxis.length; ++j) {
          var delta = valuesInAxis[j] - valuesInAxis[j - 1];

          if (delta > 0) {
            // Ignore 0 delta because they are of the same axis value
            min = min === null ? delta : Math.min(min, delta);
          }
        } // Set to null if only have one data


        axisMinGaps[key] = min;
      }
    }
  }

  return axisMinGaps;
}

function makeColumnLayout(barSeries) {
  var axisMinGaps = getValueAxesMinGaps(barSeries);
  var seriesInfoList = [];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(barSeries, function (seriesModel) {
    var cartesian = seriesModel.coordinateSystem;
    var baseAxis = cartesian.getBaseAxis();
    var axisExtent = baseAxis.getExtent();
    var bandWidth;

    if (baseAxis.type === 'category') {
      bandWidth = baseAxis.getBandWidth();
    } else if (baseAxis.type === 'value' || baseAxis.type === 'time') {
      var key = baseAxis.dim + '_' + baseAxis.index;
      var minGap = axisMinGaps[key];
      var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
      var scale = baseAxis.scale.getExtent();
      var scaleSpan = Math.abs(scale[1] - scale[0]);
      bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan; // When there is only one data value
    } else {
      var data = seriesModel.getData();
      bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
    }

    var barWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["a" /* parsePercent */])(seriesModel.get('barWidth'), bandWidth);
    var barMaxWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["a" /* parsePercent */])(seriesModel.get('barMaxWidth'), bandWidth);
    var barMinWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["a" /* parsePercent */])( // barMinWidth by default is 0.5 / 1 in cartesian. Because in value axis,
    // the auto-calculated bar width might be less than 0.5 / 1.
    seriesModel.get('barMinWidth') || (isInLargeMode(seriesModel) ? 0.5 : 1), bandWidth);
    var barGap = seriesModel.get('barGap');
    var barCategoryGap = seriesModel.get('barCategoryGap');
    seriesInfoList.push({
      bandWidth: bandWidth,
      barWidth: barWidth,
      barMaxWidth: barMaxWidth,
      barMinWidth: barMinWidth,
      barGap: barGap,
      barCategoryGap: barCategoryGap,
      axisKey: getAxisKey(baseAxis),
      stackId: getSeriesStackId(seriesModel)
    });
  });
  return doCalBarWidthAndOffset(seriesInfoList);
}

function doCalBarWidthAndOffset(seriesInfoList) {
  // Columns info on each category axis. Key is cartesian name
  var columnsMap = {};
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(seriesInfoList, function (seriesInfo, idx) {
    var axisKey = seriesInfo.axisKey;
    var bandWidth = seriesInfo.bandWidth;
    var columnsOnAxis = columnsMap[axisKey] || {
      bandWidth: bandWidth,
      remainedWidth: bandWidth,
      autoWidthCount: 0,
      categoryGap: null,
      gap: '20%',
      stacks: {}
    };
    var stacks = columnsOnAxis.stacks;
    columnsMap[axisKey] = columnsOnAxis;
    var stackId = seriesInfo.stackId;

    if (!stacks[stackId]) {
      columnsOnAxis.autoWidthCount++;
    }

    stacks[stackId] = stacks[stackId] || {
      width: 0,
      maxWidth: 0
    }; // Caution: In a single coordinate system, these barGrid attributes
    // will be shared by series. Consider that they have default values,
    // only the attributes set on the last series will work.
    // Do not change this fact unless there will be a break change.

    var barWidth = seriesInfo.barWidth;

    if (barWidth && !stacks[stackId].width) {
      // See #6312, do not restrict width.
      stacks[stackId].width = barWidth;
      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
      columnsOnAxis.remainedWidth -= barWidth;
    }

    var barMaxWidth = seriesInfo.barMaxWidth;
    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
    var barMinWidth = seriesInfo.barMinWidth;
    barMinWidth && (stacks[stackId].minWidth = barMinWidth);
    var barGap = seriesInfo.barGap;
    barGap != null && (columnsOnAxis.gap = barGap);
    var barCategoryGap = seriesInfo.barCategoryGap;
    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
  });
  var result = {};
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(columnsMap, function (columnsOnAxis, coordSysName) {
    result[coordSysName] = {};
    var stacks = columnsOnAxis.stacks;
    var bandWidth = columnsOnAxis.bandWidth;
    var categoryGapPercent = columnsOnAxis.categoryGap;

    if (categoryGapPercent == null) {
      var columnCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["keys"])(stacks).length; // More columns in one group
      // the spaces between group is smaller. Or the column will be too thin.

      categoryGapPercent = Math.max(35 - columnCount * 4, 15) + '%';
    }

    var categoryGap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["a" /* parsePercent */])(categoryGapPercent, bandWidth);
    var barGapPercent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["a" /* parsePercent */])(columnsOnAxis.gap, 1);
    var remainedWidth = columnsOnAxis.remainedWidth;
    var autoWidthCount = columnsOnAxis.autoWidthCount;
    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(stacks, function (column) {
      var maxWidth = column.maxWidth;
      var minWidth = column.minWidth;

      if (!column.width) {
        var finalWidth = autoWidth;

        if (maxWidth && maxWidth < finalWidth) {
          finalWidth = Math.min(maxWidth, remainedWidth);
        } // `minWidth` has higher priority. `minWidth` decide that wheter the
        // bar is able to be visible. So `minWidth` should not be restricted
        // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
        // the extreme cases for `value` axis, bars are allowed to overlap
        // with each other if `minWidth` specified.


        if (minWidth && minWidth > finalWidth) {
          finalWidth = minWidth;
        }

        if (finalWidth !== autoWidth) {
          column.width = finalWidth;
          remainedWidth -= finalWidth + barGapPercent * finalWidth;
          autoWidthCount--;
        }
      } else {
        // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
        // CSS does. Becuase barWidth can be a percent value, where
        // `barMaxWidth` can be used to restrict the final width.
        var finalWidth = column.width;

        if (maxWidth) {
          finalWidth = Math.min(finalWidth, maxWidth);
        } // `minWidth` has higher priority, as described above


        if (minWidth) {
          finalWidth = Math.max(finalWidth, minWidth);
        }

        column.width = finalWidth;
        remainedWidth -= finalWidth + barGapPercent * finalWidth;
        autoWidthCount--;
      }
    }); // Recalculate width again

    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = Math.max(autoWidth, 0);
    var widthSum = 0;
    var lastColumn;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(stacks, function (column, idx) {
      if (!column.width) {
        column.width = autoWidth;
      }

      lastColumn = column;
      widthSum += column.width * (1 + barGapPercent);
    });

    if (lastColumn) {
      widthSum -= lastColumn.width * barGapPercent;
    }

    var offset = -widthSum / 2;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(stacks, function (column, stackId) {
      result[coordSysName][stackId] = result[coordSysName][stackId] || {
        bandWidth: bandWidth,
        offset: offset,
        width: column.width
      };
      offset += column.width * (1 + barGapPercent);
    });
  });
  return result;
}

function retrieveColumnLayout(barWidthAndOffset, axis, seriesModel) {
  if (barWidthAndOffset && axis) {
    var result = barWidthAndOffset[getAxisKey(axis)];

    if (result != null && seriesModel != null) {
      return result[getSeriesStackId(seriesModel)];
    }

    return result;
  }
}


function layout(seriesType, ecModel) {
  var seriesModels = prepareLayoutBarSeries(seriesType, ecModel);
  var barWidthAndOffset = makeColumnLayout(seriesModels);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(seriesModels, function (seriesModel) {
    var data = seriesModel.getData();
    var cartesian = seriesModel.coordinateSystem;
    var baseAxis = cartesian.getBaseAxis();
    var stackId = getSeriesStackId(seriesModel);
    var columnLayoutInfo = barWidthAndOffset[getAxisKey(baseAxis)][stackId];
    var columnOffset = columnLayoutInfo.offset;
    var columnWidth = columnLayoutInfo.width;
    data.setLayout({
      bandWidth: columnLayoutInfo.bandWidth,
      offset: columnOffset,
      size: columnWidth
    });
  });
} // TODO: Do not support stack in large mode yet.

function createProgressiveLayout(seriesType) {
  return {
    seriesType: seriesType,
    plan: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chart_helper_createRenderPlanner_js__["a" /* default */])(),
    reset: function (seriesModel) {
      if (!isOnCartesian(seriesModel)) {
        return;
      }

      var data = seriesModel.getData();
      var cartesian = seriesModel.coordinateSystem;
      var baseAxis = cartesian.getBaseAxis();
      var valueAxis = cartesian.getOtherAxis(baseAxis);
      var valueDimIdx = data.getDimensionIndex(data.mapDimension(valueAxis.dim));
      var baseDimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
      var drawBackground = seriesModel.get('showBackground', true);
      var valueDim = data.mapDimension(valueAxis.dim);
      var stackResultDim = data.getCalculationInfo('stackResultDimension');
      var stacked = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_helper_dataStackHelper_js__["b" /* isDimensionStacked */])(data, valueDim) && !!data.getCalculationInfo('stackedOnSeries');
      var isValueAxisH = valueAxis.isHorizontal();
      var valueAxisStart = getValueAxisStart(baseAxis, valueAxis);
      var isLarge = isInLargeMode(seriesModel);
      var barMinHeight = seriesModel.get('barMinHeight') || 0;
      var stackedDimIdx = stackResultDim && data.getDimensionIndex(stackResultDim); // Layout info.

      var columnWidth = data.getLayout('size');
      var columnOffset = data.getLayout('offset');
      return {
        progress: function (params, data) {
          var count = params.count;
          var largePoints = isLarge && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_vendor_js__["a" /* createFloat32Array */])(count * 3);
          var largeBackgroundPoints = isLarge && drawBackground && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_vendor_js__["a" /* createFloat32Array */])(count * 3);
          var largeDataIndices = isLarge && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_vendor_js__["a" /* createFloat32Array */])(count);
          var coordLayout = cartesian.master.getRect();
          var bgSize = isValueAxisH ? coordLayout.width : coordLayout.height;
          var dataIndex;
          var store = data.getStore();
          var idxOffset = 0;

          while ((dataIndex = params.next()) != null) {
            var value = store.get(stacked ? stackedDimIdx : valueDimIdx, dataIndex);
            var baseValue = store.get(baseDimIdx, dataIndex);
            var baseCoord = valueAxisStart;
            var startValue = void 0; // Because of the barMinHeight, we can not use the value in
            // stackResultDimension directly.

            if (stacked) {
              startValue = +value - store.get(valueDimIdx, dataIndex);
            }

            var x = void 0;
            var y = void 0;
            var width = void 0;
            var height = void 0;

            if (isValueAxisH) {
              var coord = cartesian.dataToPoint([value, baseValue]);

              if (stacked) {
                var startCoord = cartesian.dataToPoint([startValue, baseValue]);
                baseCoord = startCoord[0];
              }

              x = baseCoord;
              y = coord[1] + columnOffset;
              width = coord[0] - baseCoord;
              height = columnWidth;

              if (Math.abs(width) < barMinHeight) {
                width = (width < 0 ? -1 : 1) * barMinHeight;
              }
            } else {
              var coord = cartesian.dataToPoint([baseValue, value]);

              if (stacked) {
                var startCoord = cartesian.dataToPoint([baseValue, startValue]);
                baseCoord = startCoord[1];
              }

              x = coord[0] + columnOffset;
              y = baseCoord;
              width = columnWidth;
              height = coord[1] - baseCoord;

              if (Math.abs(height) < barMinHeight) {
                // Include zero to has a positive bar
                height = (height <= 0 ? -1 : 1) * barMinHeight;
              }
            }

            if (!isLarge) {
              data.setItemLayout(dataIndex, {
                x: x,
                y: y,
                width: width,
                height: height
              });
            } else {
              largePoints[idxOffset] = x;
              largePoints[idxOffset + 1] = y;
              largePoints[idxOffset + 2] = isValueAxisH ? width : height;

              if (largeBackgroundPoints) {
                largeBackgroundPoints[idxOffset] = isValueAxisH ? coordLayout.x : x;
                largeBackgroundPoints[idxOffset + 1] = isValueAxisH ? y : coordLayout.y;
                largeBackgroundPoints[idxOffset + 2] = bgSize;
              }

              largeDataIndices[dataIndex] = dataIndex;
            }

            idxOffset += 3;
          }

          if (isLarge) {
            data.setLayout({
              largePoints: largePoints,
              largeDataIndices: largeDataIndices,
              largeBackgroundPoints: largeBackgroundPoints,
              valueAxisHorizontal: isValueAxisH
            });
          }
        }
      };
    }
  };
}

function isOnCartesian(seriesModel) {
  return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
}

function isInLargeMode(seriesModel) {
  return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
} // See cases in `test/bar-start.html` and `#7412`, `#8747`.


function getValueAxisStart(baseAxis, valueAxis) {
  return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === 'log' ? 1 : 0));
}

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataFormatMixin; });
/* harmony export (immutable) */ __webpack_exports__["b"] = normalizeTooltipFormatResult;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_helper_dataProvider_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_format_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_log_js__ = __webpack_require__(14);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var DIMENSION_LABEL_REG = /\{@(.+?)\}/g;

var DataFormatMixin =
/** @class */
function () {
  function DataFormatMixin() {}
  /**
   * Get params for formatter
   */


  DataFormatMixin.prototype.getDataParams = function (dataIndex, dataType) {
    var data = this.getData(dataType);
    var rawValue = this.getRawValue(dataIndex, dataType);
    var rawDataIndex = data.getRawIndex(dataIndex);
    var name = data.getName(dataIndex);
    var itemOpt = data.getRawDataItem(dataIndex);
    var style = data.getItemVisual(dataIndex, 'style');
    var color = style && style[data.getItemVisual(dataIndex, 'drawType') || 'fill'];
    var borderColor = style && style.stroke;
    var mainType = this.mainType;
    var isSeries = mainType === 'series';
    var userOutput = data.userOutput && data.userOutput.get();
    return {
      componentType: mainType,
      componentSubType: this.subType,
      componentIndex: this.componentIndex,
      seriesType: isSeries ? this.subType : null,
      seriesIndex: this.seriesIndex,
      seriesId: isSeries ? this.id : null,
      seriesName: isSeries ? this.name : null,
      name: name,
      dataIndex: rawDataIndex,
      data: itemOpt,
      dataType: dataType,
      value: rawValue,
      color: color,
      borderColor: borderColor,
      dimensionNames: userOutput ? userOutput.fullDimensions : null,
      encode: userOutput ? userOutput.encode : null,
      // Param name list for mapping `a`, `b`, `c`, `d`, `e`
      $vars: ['seriesName', 'name', 'value']
    };
  };
  /**
   * Format label
   * @param dataIndex
   * @param status 'normal' by default
   * @param dataType
   * @param labelDimIndex Only used in some chart that
   *        use formatter in different dimensions, like radar.
   * @param formatter Formatter given outside.
   * @return return null/undefined if no formatter
   */


  DataFormatMixin.prototype.getFormattedLabel = function (dataIndex, status, dataType, labelDimIndex, formatter, extendParams) {
    status = status || 'normal';
    var data = this.getData(dataType);
    var params = this.getDataParams(dataIndex, dataType);

    if (extendParams) {
      params.value = extendParams.interpolatedValue;
    }

    if (labelDimIndex != null && __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](params.value)) {
      params.value = params.value[labelDimIndex];
    }

    if (!formatter) {
      var itemModel = data.getItemModel(dataIndex); // @ts-ignore

      formatter = itemModel.get(status === 'normal' ? ['label', 'formatter'] : [status, 'label', 'formatter']);
    }

    if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"](formatter)) {
      params.status = status;
      params.dimensionIndex = labelDimIndex;
      return formatter(params);
    } else if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"](formatter)) {
      var str = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_format_js__["a" /* formatTpl */])(formatter, params); // Support 'aaa{@[3]}bbb{@product}ccc'.
      // Do not support '}' in dim name util have to.

      return str.replace(DIMENSION_LABEL_REG, function (origin, dimStr) {
        var len = dimStr.length;
        var dimLoose = dimStr;

        if (dimLoose.charAt(0) === '[' && dimLoose.charAt(len - 1) === ']') {
          dimLoose = +dimLoose.slice(1, len - 1); // Also support: '[]' => 0

          if (true) {
            if (isNaN(dimLoose)) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_log_js__["c" /* error */])("Invalide label formatter: @" + dimStr + ", only support @[0], @[1], @[2], ...");
            }
          }
        }

        var val = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__data_helper_dataProvider_js__["a" /* retrieveRawValue */])(data, dataIndex, dimLoose);

        if (extendParams && __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](extendParams.interpolatedValue)) {
          var dimIndex = data.getDimensionIndex(dimLoose);

          if (dimIndex >= 0) {
            val = extendParams.interpolatedValue[dimIndex];
          }
        }

        return val != null ? val + '' : '';
      });
    }
  };
  /**
   * Get raw value in option
   */


  DataFormatMixin.prototype.getRawValue = function (idx, dataType) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__data_helper_dataProvider_js__["a" /* retrieveRawValue */])(this.getData(dataType), idx);
  };
  /**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {string} [dataType]
   */


  DataFormatMixin.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    // Empty function
    return;
  };

  return DataFormatMixin;
}();


; // PENDING: previously we accept this type when calling `formatTooltip`,
// but guess little chance has been used outside. Do we need to backward
// compat it?
// type TooltipFormatResultLegacyObject = {
//     // `html` means the markup language text, either in 'html' or 'richText'.
//     // The name `html` is not appropriate becuase in 'richText' it is not a HTML
//     // string. But still support it for backward compat.
//     html: string;
//     markers: Dictionary<ColorString>;
// };

/**
 * For backward compat, normalize the return from `formatTooltip`.
 */

function normalizeTooltipFormatResult(result) {
  var markupText; // let markers: Dictionary<ColorString>;

  var markupFragment;

  if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"](result)) {
    if (result.type) {
      markupFragment = result;
    } else {
      if (true) {
        console.warn('The return type of `formatTooltip` is not supported: ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_log_js__["d" /* makePrintable */])(result));
      }
    } // else {
    //     markupText = (result as TooltipFormatResultLegacyObject).html;
    //     markers = (result as TooltipFormatResultLegacyObject).markers;
    //     if (markersExisting) {
    //         markers = zrUtil.merge(markersExisting, markers);
    //     }
    // }

  } else {
    markupText = result;
  }

  return {
    text: markupText,
    // markers: markers || markersExisting,
    frag: markupFragment
  };
}

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getDecalFromPalette;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaletteMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var innerColor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_model_js__["a" /* makeInner */])();
var innerDecal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_model_js__["a" /* makeInner */])();

var PaletteMixin =
/** @class */
function () {
  function PaletteMixin() {}

  PaletteMixin.prototype.getColorFromPalette = function (name, scope, requestNum) {
    var defaultPalette = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_model_js__["d" /* normalizeToArray */])(this.get('color', true));
    var layeredPalette = this.get('colorLayer', true);
    return getFromPalette(this, innerColor, defaultPalette, layeredPalette, name, scope, requestNum);
  };

  PaletteMixin.prototype.clearColorPalette = function () {
    clearPalette(this, innerColor);
  };

  return PaletteMixin;
}();

function getDecalFromPalette(ecModel, name, scope, requestNum) {
  var defaultDecals = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_model_js__["d" /* normalizeToArray */])(ecModel.get(['aria', 'decal', 'decals']));
  return getFromPalette(ecModel, innerDecal, defaultDecals, null, name, scope, requestNum);
}

function getNearestPalette(palettes, requestColorNum) {
  var paletteNum = palettes.length; // TODO palettes must be in order

  for (var i = 0; i < paletteNum; i++) {
    if (palettes[i].length > requestColorNum) {
      return palettes[i];
    }
  }

  return palettes[paletteNum - 1];
}
/**
 * @param name MUST NOT be null/undefined. Otherwise call this function
 *             twise with the same parameters will get different result.
 * @param scope default this.
 * @return Can be null/undefined
 */


function getFromPalette(that, inner, defaultPalette, layeredPalette, name, scope, requestNum) {
  scope = scope || that;
  var scopeFields = inner(scope);
  var paletteIdx = scopeFields.paletteIdx || 0;
  var paletteNameMap = scopeFields.paletteNameMap = scopeFields.paletteNameMap || {}; // Use `hasOwnProperty` to avoid conflict with Object.prototype.

  if (paletteNameMap.hasOwnProperty(name)) {
    return paletteNameMap[name];
  }

  var palette = requestNum == null || !layeredPalette ? defaultPalette : getNearestPalette(layeredPalette, requestNum); // In case can't find in layered color palette.

  palette = palette || defaultPalette;

  if (!palette || !palette.length) {
    return;
  }

  var pickedPaletteItem = palette[paletteIdx];

  if (name) {
    paletteNameMap[name] = pickedPaletteItem;
  }

  scopeFields.paletteIdx = (paletteIdx + 1) % palette.length;
  return pickedPaletteItem;
}

function clearPalette(that, inner) {
  inner(that).paletteIdx = 0;
  inner(that).paletteNameMap = {};
}



/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createOrUpdatePatternFromDecal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_WeakMap_js__ = __webpack_require__(1701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_LRU_js__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symbol_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zrender_lib_canvas_graphic_js__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_platform_js__ = __webpack_require__(67);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







var decalMap = new __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_WeakMap_js__["a" /* default */]();
var decalCache = new __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_LRU_js__["a" /* default */](100);
var decalKeys = ['symbol', 'symbolSize', 'symbolKeepAspect', 'color', 'backgroundColor', 'dashArrayX', 'dashArrayY', 'maxTileWidth', 'maxTileHeight'];
/**
 * Create or update pattern image from decal options
 *
 * @param {InnerDecalObject | 'none'} decalObject decal options, 'none' if no decal
 * @return {Pattern} pattern with generated image, null if no decal
 */

function createOrUpdatePatternFromDecal(decalObject, api) {
  if (decalObject === 'none') {
    return null;
  }

  var dpr = api.getDevicePixelRatio();
  var zr = api.getZr();
  var isSVG = zr.painter.type === 'svg';

  if (decalObject.dirty) {
    decalMap["delete"](decalObject);
  }

  var oldPattern = decalMap.get(decalObject);

  if (oldPattern) {
    return oldPattern;
  }

  var decalOpt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["defaults"])(decalObject, {
    symbol: 'rect',
    symbolSize: 1,
    symbolKeepAspect: true,
    color: 'rgba(0, 0, 0, 0.2)',
    backgroundColor: null,
    dashArrayX: 5,
    dashArrayY: 5,
    rotation: 0,
    maxTileWidth: 512,
    maxTileHeight: 512
  });

  if (decalOpt.backgroundColor === 'none') {
    decalOpt.backgroundColor = null;
  }

  var pattern = {
    repeat: 'repeat'
  };
  setPatternnSource(pattern);
  pattern.rotation = decalOpt.rotation;
  pattern.scaleX = pattern.scaleY = isSVG ? 1 : 1 / dpr;
  decalMap.set(decalObject, pattern);
  decalObject.dirty = false;
  return pattern;

  function setPatternnSource(pattern) {
    var keys = [dpr];
    var isValidKey = true;

    for (var i = 0; i < decalKeys.length; ++i) {
      var value = decalOpt[decalKeys[i]];

      if (value != null && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isArray"])(value) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isString"])(value) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isNumber"])(value) && typeof value !== 'boolean') {
        isValidKey = false;
        break;
      }

      keys.push(value);
    }

    var cacheKey;

    if (isValidKey) {
      cacheKey = keys.join(',') + (isSVG ? '-svg' : '');
      var cache = decalCache.get(cacheKey);

      if (cache) {
        isSVG ? pattern.svgElement = cache : pattern.image = cache;
      }
    }

    var dashArrayX = normalizeDashArrayX(decalOpt.dashArrayX);
    var dashArrayY = normalizeDashArrayY(decalOpt.dashArrayY);
    var symbolArray = normalizeSymbolArray(decalOpt.symbol);
    var lineBlockLengthsX = getLineBlockLengthX(dashArrayX);
    var lineBlockLengthY = getLineBlockLengthY(dashArrayY);
    var canvas = !isSVG && __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_platform_js__["a" /* platformApi */].createCanvas();
    var svgRoot = isSVG && {
      tag: 'g',
      attrs: {},
      key: 'dcl',
      children: []
    };
    var pSize = getPatternSize();
    var ctx;

    if (canvas) {
      canvas.width = pSize.width * dpr;
      canvas.height = pSize.height * dpr;
      ctx = canvas.getContext('2d');
    }

    brushDecal();

    if (isValidKey) {
      decalCache.put(cacheKey, canvas || svgRoot);
    }

    pattern.image = canvas;
    pattern.svgElement = svgRoot;
    pattern.svgWidth = pSize.width;
    pattern.svgHeight = pSize.height;
    /**
     * Get minumum length that can make a repeatable pattern.
     *
     * @return {Object} pattern width and height
     */

    function getPatternSize() {
      /**
       * For example, if dash is [[3, 2], [2, 1]] for X, it looks like
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * So the minumum length of X is 15,
       * which is the least common multiple of `3 + 2` and `2 + 1`
       * |---  ---  ---  |---  --- ...
       * |-- -- -- -- -- |-- -- -- ...
       */
      var width = 1;

      for (var i = 0, xlen = lineBlockLengthsX.length; i < xlen; ++i) {
        width = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__number_js__["p" /* getLeastCommonMultiple */])(width, lineBlockLengthsX[i]);
      }

      var symbolRepeats = 1;

      for (var i = 0, xlen = symbolArray.length; i < xlen; ++i) {
        symbolRepeats = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__number_js__["p" /* getLeastCommonMultiple */])(symbolRepeats, symbolArray[i].length);
      }

      width *= symbolRepeats;
      var height = lineBlockLengthY * lineBlockLengthsX.length * symbolArray.length;

      if (true) {
        var warn = function (attrName) {
          /* eslint-disable-next-line */
          console.warn("Calculated decal size is greater than " + attrName + " due to decal option settings so " + attrName + " is used for the decal size. Please consider changing the decal option to make a smaller decal or set " + attrName + " to be larger to avoid incontinuity.");
        };

        if (width > decalOpt.maxTileWidth) {
          warn('maxTileWidth');
        }

        if (height > decalOpt.maxTileHeight) {
          warn('maxTileHeight');
        }
      }

      return {
        width: Math.max(1, Math.min(width, decalOpt.maxTileWidth)),
        height: Math.max(1, Math.min(height, decalOpt.maxTileHeight))
      };
    }

    function brushDecal() {
      if (ctx) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        if (decalOpt.backgroundColor) {
          ctx.fillStyle = decalOpt.backgroundColor;
          ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
      }

      var ySum = 0;

      for (var i = 0; i < dashArrayY.length; ++i) {
        ySum += dashArrayY[i];
      }

      if (ySum <= 0) {
        // dashArrayY is 0, draw nothing
        return;
      }

      var y = -lineBlockLengthY;
      var yId = 0;
      var yIdTotal = 0;
      var xId0 = 0;

      while (y < pSize.height) {
        if (yId % 2 === 0) {
          var symbolYId = yIdTotal / 2 % symbolArray.length;
          var x = 0;
          var xId1 = 0;
          var xId1Total = 0;

          while (x < pSize.width * 2) {
            var xSum = 0;

            for (var i = 0; i < dashArrayX[xId0].length; ++i) {
              xSum += dashArrayX[xId0][i];
            }

            if (xSum <= 0) {
              // Skip empty line
              break;
            } // E.g., [15, 5, 20, 5] draws only for 15 and 20


            if (xId1 % 2 === 0) {
              var size = (1 - decalOpt.symbolSize) * 0.5;
              var left = x + dashArrayX[xId0][xId1] * size;
              var top_1 = y + dashArrayY[yId] * size;
              var width = dashArrayX[xId0][xId1] * decalOpt.symbolSize;
              var height = dashArrayY[yId] * decalOpt.symbolSize;
              var symbolXId = xId1Total / 2 % symbolArray[symbolYId].length;
              brushSymbol(left, top_1, width, height, symbolArray[symbolYId][symbolXId]);
            }

            x += dashArrayX[xId0][xId1];
            ++xId1Total;
            ++xId1;

            if (xId1 === dashArrayX[xId0].length) {
              xId1 = 0;
            }
          }

          ++xId0;

          if (xId0 === dashArrayX.length) {
            xId0 = 0;
          }
        }

        y += dashArrayY[yId];
        ++yIdTotal;
        ++yId;

        if (yId === dashArrayY.length) {
          yId = 0;
        }
      }

      function brushSymbol(x, y, width, height, symbolType) {
        var scale = isSVG ? 1 : dpr;
        var symbol = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__symbol_js__["a" /* createSymbol */])(symbolType, x * scale, y * scale, width * scale, height * scale, decalOpt.color, decalOpt.symbolKeepAspect);

        if (isSVG) {
          var symbolVNode = zr.painter.renderOneToVNode(symbol);

          if (symbolVNode) {
            svgRoot.children.push(symbolVNode);
          }
        } else {
          // Paint to canvas for all other renderers.
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_canvas_graphic_js__["a" /* brushSingle */])(ctx, symbol);
        }
      }
    }
  }
}
/**
 * Convert symbol array into normalized array
 *
 * @param {string | (string | string[])[]} symbol symbol input
 * @return {string[][]} normolized symbol array
 */

function normalizeSymbolArray(symbol) {
  if (!symbol || symbol.length === 0) {
    return [['rect']];
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isString"])(symbol)) {
    return [[symbol]];
  }

  var isAllString = true;

  for (var i = 0; i < symbol.length; ++i) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isString"])(symbol[i])) {
      isAllString = false;
      break;
    }
  }

  if (isAllString) {
    return normalizeSymbolArray([symbol]);
  }

  var result = [];

  for (var i = 0; i < symbol.length; ++i) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isString"])(symbol[i])) {
      result.push([symbol[i]]);
    } else {
      result.push(symbol[i]);
    }
  }

  return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayX} dash dash input
 * @return {number[][]} normolized dash array
 */


function normalizeDashArrayX(dash) {
  if (!dash || dash.length === 0) {
    return [[0, 0]];
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isNumber"])(dash)) {
    var dashValue = Math.ceil(dash);
    return [[dashValue, dashValue]];
  }
  /**
   * [20, 5] should be normalized into [[20, 5]],
   * while [20, [5, 10]] should be normalized into [[20, 20], [5, 10]]
   */


  var isAllNumber = true;

  for (var i = 0; i < dash.length; ++i) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isNumber"])(dash[i])) {
      isAllNumber = false;
      break;
    }
  }

  if (isAllNumber) {
    return normalizeDashArrayX([dash]);
  }

  var result = [];

  for (var i = 0; i < dash.length; ++i) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isNumber"])(dash[i])) {
      var dashValue = Math.ceil(dash[i]);
      result.push([dashValue, dashValue]);
    } else {
      var dashValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["map"])(dash[i], function (n) {
        return Math.ceil(n);
      });

      if (dashValue.length % 2 === 1) {
        // [4, 2, 1] means |----  -    -- |----  -    -- |
        // so normalize it to be [4, 2, 1, 4, 2, 1]
        result.push(dashValue.concat(dashValue));
      } else {
        result.push(dashValue);
      }
    }
  }

  return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayY} dash dash input
 * @return {number[]} normolized dash array
 */


function normalizeDashArrayY(dash) {
  if (!dash || typeof dash === 'object' && dash.length === 0) {
    return [0, 0];
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isNumber"])(dash)) {
    var dashValue_1 = Math.ceil(dash);
    return [dashValue_1, dashValue_1];
  }

  var dashValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["map"])(dash, function (n) {
    return Math.ceil(n);
  });
  return dash.length % 2 ? dashValue.concat(dashValue) : dashValue;
}
/**
 * Get block length of each line. A block is the length of dash line and space.
 * For example, a line with [4, 1] has a dash line of 4 and a space of 1 after
 * that, so the block length of this line is 5.
 *
 * @param {number[][]} dash dash arrary of X or Y
 * @return {number[]} block length of each line
 */


function getLineBlockLengthX(dash) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["map"])(dash, function (line) {
    return getLineBlockLengthY(line);
  });
}

function getLineBlockLengthY(dash) {
  var blockLength = 0;

  for (var i = 0; i < dash.length; ++i) {
    blockLength += dash[i];
  }

  if (dash.length % 2 === 1) {
    // [4, 2, 1] means |----  -    -- |----  -    -- |
    // So total length is (4 + 2 + 1) * 2
    return blockLength * 2;
  }

  return blockLength;
}

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ONE_SECOND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ONE_MINUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ONE_HOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ONE_DAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ONE_YEAR; });
/* unused harmony export defaultLeveledFormatter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fullLeveledFormatter; });
/* unused harmony export primaryTimeUnits */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return timeUnits; });
/* harmony export (immutable) */ __webpack_exports__["b"] = pad;
/* harmony export (immutable) */ __webpack_exports__["e"] = getPrimaryTimeUnit;
/* harmony export (immutable) */ __webpack_exports__["B"] = isPrimaryTimeUnit;
/* harmony export (immutable) */ __webpack_exports__["d"] = getDefaultFormatPrecisionOfInterval;
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony export (immutable) */ __webpack_exports__["f"] = leveledFormat;
/* unused harmony export getUnitFromValue */
/* harmony export (immutable) */ __webpack_exports__["l"] = getUnitValue;
/* harmony export (immutable) */ __webpack_exports__["t"] = fullYearGetterName;
/* harmony export (immutable) */ __webpack_exports__["v"] = monthGetterName;
/* harmony export (immutable) */ __webpack_exports__["w"] = dateGetterName;
/* harmony export (immutable) */ __webpack_exports__["x"] = hoursGetterName;
/* harmony export (immutable) */ __webpack_exports__["y"] = minutesGetterName;
/* harmony export (immutable) */ __webpack_exports__["z"] = secondsGetterName;
/* harmony export (immutable) */ __webpack_exports__["A"] = millisecondsGetterName;
/* harmony export (immutable) */ __webpack_exports__["u"] = fullYearSetterName;
/* harmony export (immutable) */ __webpack_exports__["m"] = monthSetterName;
/* harmony export (immutable) */ __webpack_exports__["n"] = dateSetterName;
/* harmony export (immutable) */ __webpack_exports__["o"] = hoursSetterName;
/* harmony export (immutable) */ __webpack_exports__["p"] = minutesSetterName;
/* harmony export (immutable) */ __webpack_exports__["q"] = secondsSetterName;
/* harmony export (immutable) */ __webpack_exports__["r"] = millisecondsSetterName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_locale_js__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_Model_js__ = __webpack_require__(32);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var ONE_SECOND = 1000;
var ONE_MINUTE = ONE_SECOND * 60;
var ONE_HOUR = ONE_MINUTE * 60;
var ONE_DAY = ONE_HOUR * 24;
var ONE_YEAR = ONE_DAY * 365;
var defaultLeveledFormatter = {
  year: '{yyyy}',
  month: '{MMM}',
  day: '{d}',
  hour: '{HH}:{mm}',
  minute: '{HH}:{mm}',
  second: '{HH}:{mm}:{ss}',
  millisecond: '{HH}:{mm}:{ss} {SSS}',
  none: '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}'
};
var fullDayFormatter = '{yyyy}-{MM}-{dd}';
var fullLeveledFormatter = {
  year: '{yyyy}',
  month: '{yyyy}-{MM}',
  day: fullDayFormatter,
  hour: fullDayFormatter + ' ' + defaultLeveledFormatter.hour,
  minute: fullDayFormatter + ' ' + defaultLeveledFormatter.minute,
  second: fullDayFormatter + ' ' + defaultLeveledFormatter.second,
  millisecond: defaultLeveledFormatter.none
};
var primaryTimeUnits = ['year', 'month', 'day', 'hour', 'minute', 'second', 'millisecond'];
var timeUnits = ['year', 'half-year', 'quarter', 'month', 'week', 'half-week', 'day', 'half-day', 'quarter-day', 'hour', 'minute', 'second', 'millisecond'];
function pad(str, len) {
  str += '';
  return '0000'.substr(0, len - str.length) + str;
}
function getPrimaryTimeUnit(timeUnit) {
  switch (timeUnit) {
    case 'half-year':
    case 'quarter':
      return 'month';

    case 'week':
    case 'half-week':
      return 'day';

    case 'half-day':
    case 'quarter-day':
      return 'hour';

    default:
      // year, minutes, second, milliseconds
      return timeUnit;
  }
}
function isPrimaryTimeUnit(timeUnit) {
  return timeUnit === getPrimaryTimeUnit(timeUnit);
}
function getDefaultFormatPrecisionOfInterval(timeUnit) {
  switch (timeUnit) {
    case 'year':
    case 'month':
      return 'day';

    case 'millisecond':
      return 'millisecond';

    default:
      // Also for day, hour, minute, second
      return 'second';
  }
}
function format( // Note: The result based on `isUTC` are totally different, which can not be just simply
// substituted by the result without `isUTC`. So we make the param `isUTC` mandatory.
time, template, isUTC, lang) {
  var date = __WEBPACK_IMPORTED_MODULE_1__number_js__["f" /* parseDate */](time);
  var y = date[fullYearGetterName(isUTC)]();
  var M = date[monthGetterName(isUTC)]() + 1;
  var q = Math.floor((M - 1) / 4) + 1;
  var d = date[dateGetterName(isUTC)]();
  var e = date['get' + (isUTC ? 'UTC' : '') + 'Day']();
  var H = date[hoursGetterName(isUTC)]();
  var h = (H - 1) % 12 + 1;
  var m = date[minutesGetterName(isUTC)]();
  var s = date[secondsGetterName(isUTC)]();
  var S = date[millisecondsGetterName(isUTC)]();
  var localeModel = lang instanceof __WEBPACK_IMPORTED_MODULE_3__model_Model_js__["a" /* default */] ? lang : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_locale_js__["a" /* getLocaleModel */])(lang || __WEBPACK_IMPORTED_MODULE_2__core_locale_js__["b" /* SYSTEM_LANG */]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_locale_js__["c" /* getDefaultLocaleModel */])();
  var timeModel = localeModel.getModel('time');
  var month = timeModel.get('month');
  var monthAbbr = timeModel.get('monthAbbr');
  var dayOfWeek = timeModel.get('dayOfWeek');
  var dayOfWeekAbbr = timeModel.get('dayOfWeekAbbr');
  return (template || '').replace(/{yyyy}/g, y + '').replace(/{yy}/g, y % 100 + '').replace(/{Q}/g, q + '').replace(/{MMMM}/g, month[M - 1]).replace(/{MMM}/g, monthAbbr[M - 1]).replace(/{MM}/g, pad(M, 2)).replace(/{M}/g, M + '').replace(/{dd}/g, pad(d, 2)).replace(/{d}/g, d + '').replace(/{eeee}/g, dayOfWeek[e]).replace(/{ee}/g, dayOfWeekAbbr[e]).replace(/{e}/g, e + '').replace(/{HH}/g, pad(H, 2)).replace(/{H}/g, H + '').replace(/{hh}/g, pad(h + '', 2)).replace(/{h}/g, h + '').replace(/{mm}/g, pad(m, 2)).replace(/{m}/g, m + '').replace(/{ss}/g, pad(s, 2)).replace(/{s}/g, s + '').replace(/{SSS}/g, pad(S, 3)).replace(/{S}/g, S + '');
}
function leveledFormat(tick, idx, formatter, lang, isUTC) {
  var template = null;

  if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"](formatter)) {
    // Single formatter for all units at all levels
    template = formatter;
  } else if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"](formatter)) {
    // Callback formatter
    template = formatter(tick.value, idx, {
      level: tick.level
    });
  } else {
    var defaults = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"]({}, defaultLeveledFormatter);

    if (tick.level > 0) {
      for (var i = 0; i < primaryTimeUnits.length; ++i) {
        defaults[primaryTimeUnits[i]] = "{primary|" + defaults[primaryTimeUnits[i]] + "}";
      }
    }

    var mergedFormatter = formatter ? formatter.inherit === false ? formatter // Use formatter with bigger units
    : __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["defaults"](formatter, defaults) : defaults;
    var unit = getUnitFromValue(tick.value, isUTC);

    if (mergedFormatter[unit]) {
      template = mergedFormatter[unit];
    } else if (mergedFormatter.inherit) {
      // Unit formatter is not defined and should inherit from bigger units
      var targetId = timeUnits.indexOf(unit);

      for (var i = targetId - 1; i >= 0; --i) {
        if (mergedFormatter[unit]) {
          template = mergedFormatter[unit];
          break;
        }
      }

      template = template || defaults.none;
    }

    if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](template)) {
      var levelId = tick.level == null ? 0 : tick.level >= 0 ? tick.level : template.length + tick.level;
      levelId = Math.min(levelId, template.length - 1);
      template = template[levelId];
    }
  }

  return format(new Date(tick.value), template, isUTC, lang);
}
function getUnitFromValue(value, isUTC) {
  var date = __WEBPACK_IMPORTED_MODULE_1__number_js__["f" /* parseDate */](value);
  var M = date[monthGetterName(isUTC)]() + 1;
  var d = date[dateGetterName(isUTC)]();
  var h = date[hoursGetterName(isUTC)]();
  var m = date[minutesGetterName(isUTC)]();
  var s = date[secondsGetterName(isUTC)]();
  var S = date[millisecondsGetterName(isUTC)]();
  var isSecond = S === 0;
  var isMinute = isSecond && s === 0;
  var isHour = isMinute && m === 0;
  var isDay = isHour && h === 0;
  var isMonth = isDay && d === 1;
  var isYear = isMonth && M === 1;

  if (isYear) {
    return 'year';
  } else if (isMonth) {
    return 'month';
  } else if (isDay) {
    return 'day';
  } else if (isHour) {
    return 'hour';
  } else if (isMinute) {
    return 'minute';
  } else if (isSecond) {
    return 'second';
  } else {
    return 'millisecond';
  }
}
function getUnitValue(value, unit, isUTC) {
  var date = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isNumber"](value) ? __WEBPACK_IMPORTED_MODULE_1__number_js__["f" /* parseDate */](value) : value;
  unit = unit || getUnitFromValue(value, isUTC);

  switch (unit) {
    case 'year':
      return date[fullYearGetterName(isUTC)]();

    case 'half-year':
      return date[monthGetterName(isUTC)]() >= 6 ? 1 : 0;

    case 'quarter':
      return Math.floor((date[monthGetterName(isUTC)]() + 1) / 4);

    case 'month':
      return date[monthGetterName(isUTC)]();

    case 'day':
      return date[dateGetterName(isUTC)]();

    case 'half-day':
      return date[hoursGetterName(isUTC)]() / 24;

    case 'hour':
      return date[hoursGetterName(isUTC)]();

    case 'minute':
      return date[minutesGetterName(isUTC)]();

    case 'second':
      return date[secondsGetterName(isUTC)]();

    case 'millisecond':
      return date[millisecondsGetterName(isUTC)]();
  }
}
function fullYearGetterName(isUTC) {
  return isUTC ? 'getUTCFullYear' : 'getFullYear';
}
function monthGetterName(isUTC) {
  return isUTC ? 'getUTCMonth' : 'getMonth';
}
function dateGetterName(isUTC) {
  return isUTC ? 'getUTCDate' : 'getDate';
}
function hoursGetterName(isUTC) {
  return isUTC ? 'getUTCHours' : 'getHours';
}
function minutesGetterName(isUTC) {
  return isUTC ? 'getUTCMinutes' : 'getMinutes';
}
function secondsGetterName(isUTC) {
  return isUTC ? 'getUTCSeconds' : 'getSeconds';
}
function millisecondsGetterName(isUTC) {
  return isUTC ? 'getUTCMilliseconds' : 'getMilliseconds';
}
function fullYearSetterName(isUTC) {
  return isUTC ? 'setUTCFullYear' : 'setFullYear';
}
function monthSetterName(isUTC) {
  return isUTC ? 'setUTCMonth' : 'setMonth';
}
function dateSetterName(isUTC) {
  return isUTC ? 'setUTCDate' : 'setDate';
}
function hoursSetterName(isUTC) {
  return isUTC ? 'setUTCHours' : 'setHours';
}
function minutesSetterName(isUTC) {
  return isUTC ? 'setUTCMinutes' : 'setMinutes';
}
function secondsSetterName(isUTC) {
  return isUTC ? 'setUTCSeconds' : 'setSeconds';
}
function millisecondsSetterName(isUTC) {
  return isUTC ? 'setUTCMilliseconds' : 'setMilliseconds';
}

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = createVisualMappings;
/* harmony export (immutable) */ __webpack_exports__["b"] = replaceVisualOption;
/* harmony export (immutable) */ __webpack_exports__["d"] = applyVisual;
/* harmony export (immutable) */ __webpack_exports__["a"] = incrementalApplyVisual;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VisualMapping_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_js__ = __webpack_require__(162);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @file Visual solution, for consistent option specification.
 */



var each = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"];

function hasKeys(obj) {
  if (obj) {
    for (var name_1 in obj) {
      if (obj.hasOwnProperty(name_1)) {
        return true;
      }
    }
  }
}

function createVisualMappings(option, stateList, supplementVisualOption) {
  var visualMappings = {};
  each(stateList, function (state) {
    var mappings = visualMappings[state] = createMappings();
    each(option[state], function (visualData, visualType) {
      if (!__WEBPACK_IMPORTED_MODULE_1__VisualMapping_js__["a" /* default */].isValidType(visualType)) {
        return;
      }

      var mappingOption = {
        type: visualType,
        visual: visualData
      };
      supplementVisualOption && supplementVisualOption(mappingOption, state);
      mappings[visualType] = new __WEBPACK_IMPORTED_MODULE_1__VisualMapping_js__["a" /* default */](mappingOption); // Prepare a alpha for opacity, for some case that opacity
      // is not supported, such as rendering using gradient color.

      if (visualType === 'opacity') {
        mappingOption = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["clone"](mappingOption);
        mappingOption.type = 'colorAlpha';
        mappings.__hidden.__alphaForOpacity = new __WEBPACK_IMPORTED_MODULE_1__VisualMapping_js__["a" /* default */](mappingOption);
      }
    });
  });
  return visualMappings;

  function createMappings() {
    var Creater = function () {}; // Make sure hidden fields will not be visited by
    // object iteration (with hasOwnProperty checking).


    Creater.prototype.__hidden = Creater.prototype;
    var obj = new Creater();
    return obj;
  }
}
function replaceVisualOption(thisOption, newOption, keys) {
  // Visual attributes merge is not supported, otherwise it
  // brings overcomplicated merge logic. See #2853. So if
  // newOption has anyone of these keys, all of these keys
  // will be reset. Otherwise, all keys remain.
  var has;
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](keys, function (key) {
    if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
      has = true;
    }
  });
  has && __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](keys, function (key) {
    if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
      thisOption[key] = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["clone"](newOption[key]);
    } else {
      delete thisOption[key];
    }
  });
}
/**
 * @param stateList
 * @param visualMappings
 * @param list
 * @param getValueState param: valueOrIndex, return: state.
 * @param scope Scope for getValueState
 * @param dimension Concrete dimension, if used.
 */
// ???! handle brush?

function applyVisual(stateList, visualMappings, data, getValueState, scope, dimension) {
  var visualTypesMap = {};
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](stateList, function (state) {
    var visualTypes = __WEBPACK_IMPORTED_MODULE_1__VisualMapping_js__["a" /* default */].prepareVisualTypes(visualMappings[state]);
    visualTypesMap[state] = visualTypes;
  });
  var dataIndex;

  function getVisual(key) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_js__["b" /* getItemVisualFromData */])(data, dataIndex, key);
  }

  function setVisual(key, value) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_js__["c" /* setItemVisualFromData */])(data, dataIndex, key, value);
  }

  if (dimension == null) {
    data.each(eachItem);
  } else {
    data.each([dimension], eachItem);
  }

  function eachItem(valueOrIndex, index) {
    dataIndex = dimension == null ? valueOrIndex // First argument is index
    : index;
    var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance
    // @ts-ignore

    if (rawDataItem && rawDataItem.visualMap === false) {
      return;
    }

    var valueState = getValueState.call(scope, valueOrIndex);
    var mappings = visualMappings[valueState];
    var visualTypes = visualTypesMap[valueState];

    for (var i = 0, len = visualTypes.length; i < len; i++) {
      var type = visualTypes[i];
      mappings[type] && mappings[type].applyVisual(valueOrIndex, getVisual, setVisual);
    }
  }
}
/**
 * @param data
 * @param stateList
 * @param visualMappings <state, Object.<visualType, module:echarts/visual/VisualMapping>>
 * @param getValueState param: valueOrIndex, return: state.
 * @param dim dimension or dimension index.
 */

function incrementalApplyVisual(stateList, visualMappings, getValueState, dim) {
  var visualTypesMap = {};
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](stateList, function (state) {
    var visualTypes = __WEBPACK_IMPORTED_MODULE_1__VisualMapping_js__["a" /* default */].prepareVisualTypes(visualMappings[state]);
    visualTypesMap[state] = visualTypes;
  });
  return {
    progress: function progress(params, data) {
      var dimIndex;

      if (dim != null) {
        dimIndex = data.getDimensionIndex(dim);
      }

      function getVisual(key) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_js__["b" /* getItemVisualFromData */])(data, dataIndex, key);
      }

      function setVisual(key, value) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_js__["c" /* setItemVisualFromData */])(data, dataIndex, key, value);
      }

      var dataIndex;
      var store = data.getStore();

      while ((dataIndex = params.next()) != null) {
        var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance
        // @ts-ignore

        if (rawDataItem && rawDataItem.visualMap === false) {
          continue;
        }

        var value = dim != null ? store.get(dimIndex, dataIndex) : dataIndex;
        var valueState = getValueState(value);
        var mappings = visualMappings[valueState];
        var visualTypes = visualTypesMap[valueState];

        for (var i = 0, len = visualTypes.length; i < len; i++) {
          var type = visualTypes[i];
          mappings[type] && mappings[type].applyVisual(value, getVisual, setVisual);
        }
      }
    }
  };
}

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__ = __webpack_require__(1439);






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__["a" /* default */];
ListCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__["a" /* default */];
ListCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__["a" /* default */];
ListCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__["a" /* default */];
ListCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (ListCache);


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(250);


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (assocIndexOf);


/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isKeyable_js__ = __webpack_require__(1433);


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isKeyable_js__["a" /* default */])(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ __webpack_exports__["a"] = (getMapData);


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(137);


/* Built-in method references that are verified to be native. */
var nativeCreate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'create');

/* harmony default export */ __webpack_exports__["a"] = (nativeCreate);


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(351);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (toKey);


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ __webpack_exports__["a"] = (eq);


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(115);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */])(function() { return arguments; }()) ? __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */] : function(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(350);



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = createCanvasPattern;
/* harmony export (immutable) */ __webpack_exports__["a"] = brushSingle;
/* harmony export (immutable) */ __webpack_exports__["b"] = brush;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphic_Displayable_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_PathProxy_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphic_helper_image_js__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_js__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphic_Path_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphic_Image_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphic_TSpan_js__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dashStyle_js__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__graphic_constants_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__core_platform_js__ = __webpack_require__(67);











var pathProxyForDraw = new __WEBPACK_IMPORTED_MODULE_1__core_PathProxy_js__["a" /* default */](true);
function styleHasStroke(style) {
    var stroke = style.stroke;
    return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
}
function isValidStrokeFillStyle(strokeOrFill) {
    return typeof strokeOrFill === 'string' && strokeOrFill !== 'none';
}
function styleHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== 'none';
}
function doFillPath(ctx, style) {
    if (style.fillOpacity != null && style.fillOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.fillOpacity * style.opacity;
        ctx.fill();
        ctx.globalAlpha = originalGlobalAlpha;
    }
    else {
        ctx.fill();
    }
}
function doStrokePath(ctx, style) {
    if (style.strokeOpacity != null && style.strokeOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.strokeOpacity * style.opacity;
        ctx.stroke();
        ctx.globalAlpha = originalGlobalAlpha;
    }
    else {
        ctx.stroke();
    }
}
function createCanvasPattern(ctx, pattern, el) {
    var image = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__graphic_helper_image_js__["c" /* createOrUpdateImage */])(pattern.image, pattern.__image, el);
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__graphic_helper_image_js__["b" /* isImageReady */])(image)) {
        var canvasPattern = ctx.createPattern(image, pattern.repeat || 'repeat');
        if (typeof DOMMatrix === 'function'
            && canvasPattern
            && canvasPattern.setTransform) {
            var matrix = new DOMMatrix();
            matrix.translateSelf((pattern.x || 0), (pattern.y || 0));
            matrix.rotateSelf(0, 0, (pattern.rotation || 0) * __WEBPACK_IMPORTED_MODULE_7__core_util_js__["RADIAN_TO_DEGREE"]);
            matrix.scaleSelf((pattern.scaleX || 1), (pattern.scaleY || 1));
            canvasPattern.setTransform(matrix);
        }
        return canvasPattern;
    }
}
function brushPath(ctx, el, style, inBatch) {
    var _a;
    var hasStroke = styleHasStroke(style);
    var hasFill = styleHasFill(style);
    var strokePercent = style.strokePercent;
    var strokePart = strokePercent < 1;
    var firstDraw = !el.path;
    if ((!el.silent || strokePart) && firstDraw) {
        el.createPathProxy();
    }
    var path = el.path || pathProxyForDraw;
    var dirtyFlag = el.__dirty;
    if (!inBatch) {
        var fill = style.fill;
        var stroke = style.stroke;
        var hasFillGradient = hasFill && !!fill.colorStops;
        var hasStrokeGradient = hasStroke && !!stroke.colorStops;
        var hasFillPattern = hasFill && !!fill.image;
        var hasStrokePattern = hasStroke && !!stroke.image;
        var fillGradient = void 0;
        var strokeGradient = void 0;
        var fillPattern = void 0;
        var strokePattern = void 0;
        var rect = void 0;
        if (hasFillGradient || hasStrokeGradient) {
            rect = el.getBoundingRect();
        }
        if (hasFillGradient) {
            fillGradient = dirtyFlag
                ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_js__["a" /* getCanvasGradient */])(ctx, fill, rect)
                : el.__canvasFillGradient;
            el.__canvasFillGradient = fillGradient;
        }
        if (hasStrokeGradient) {
            strokeGradient = dirtyFlag
                ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_js__["a" /* getCanvasGradient */])(ctx, stroke, rect)
                : el.__canvasStrokeGradient;
            el.__canvasStrokeGradient = strokeGradient;
        }
        if (hasFillPattern) {
            fillPattern = (dirtyFlag || !el.__canvasFillPattern)
                ? createCanvasPattern(ctx, fill, el)
                : el.__canvasFillPattern;
            el.__canvasFillPattern = fillPattern;
        }
        if (hasStrokePattern) {
            strokePattern = (dirtyFlag || !el.__canvasStrokePattern)
                ? createCanvasPattern(ctx, stroke, el)
                : el.__canvasStrokePattern;
            el.__canvasStrokePattern = fillPattern;
        }
        if (hasFillGradient) {
            ctx.fillStyle = fillGradient;
        }
        else if (hasFillPattern) {
            if (fillPattern) {
                ctx.fillStyle = fillPattern;
            }
            else {
                hasFill = false;
            }
        }
        if (hasStrokeGradient) {
            ctx.strokeStyle = strokeGradient;
        }
        else if (hasStrokePattern) {
            if (strokePattern) {
                ctx.strokeStyle = strokePattern;
            }
            else {
                hasStroke = false;
            }
        }
    }
    var scale = el.getGlobalScale();
    path.setScale(scale[0], scale[1], el.segmentIgnoreThreshold);
    var lineDash;
    var lineDashOffset;
    if (ctx.setLineDash && style.lineDash) {
        _a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__dashStyle_js__["a" /* getLineDash */])(el), lineDash = _a[0], lineDashOffset = _a[1];
    }
    var needsRebuild = true;
    if (firstDraw || (dirtyFlag & __WEBPACK_IMPORTED_MODULE_9__graphic_constants_js__["b" /* SHAPE_CHANGED_BIT */])) {
        path.setDPR(ctx.dpr);
        if (strokePart) {
            path.setContext(null);
        }
        else {
            path.setContext(ctx);
            needsRebuild = false;
        }
        path.reset();
        el.buildPath(path, el.shape, inBatch);
        path.toStatic();
        el.pathUpdated();
    }
    if (needsRebuild) {
        path.rebuildPath(ctx, strokePart ? strokePercent : 1);
    }
    if (lineDash) {
        ctx.setLineDash(lineDash);
        ctx.lineDashOffset = lineDashOffset;
    }
    if (!inBatch) {
        if (style.strokeFirst) {
            if (hasStroke) {
                doStrokePath(ctx, style);
            }
            if (hasFill) {
                doFillPath(ctx, style);
            }
        }
        else {
            if (hasFill) {
                doFillPath(ctx, style);
            }
            if (hasStroke) {
                doStrokePath(ctx, style);
            }
        }
    }
    if (lineDash) {
        ctx.setLineDash([]);
    }
}
function brushImage(ctx, el, style) {
    var image = el.__image = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__graphic_helper_image_js__["c" /* createOrUpdateImage */])(style.image, el.__image, el, el.onload);
    if (!image || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__graphic_helper_image_js__["b" /* isImageReady */])(image)) {
        return;
    }
    var x = style.x || 0;
    var y = style.y || 0;
    var width = el.getWidth();
    var height = el.getHeight();
    var aspect = image.width / image.height;
    if (width == null && height != null) {
        width = height * aspect;
    }
    else if (height == null && width != null) {
        height = width / aspect;
    }
    else if (width == null && height == null) {
        width = image.width;
        height = image.height;
    }
    if (style.sWidth && style.sHeight) {
        var sx = style.sx || 0;
        var sy = style.sy || 0;
        ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
    }
    else if (style.sx && style.sy) {
        var sx = style.sx;
        var sy = style.sy;
        var sWidth = width - sx;
        var sHeight = height - sy;
        ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
    }
    else {
        ctx.drawImage(image, x, y, width, height);
    }
}
function brushText(ctx, el, style) {
    var _a;
    var text = style.text;
    text != null && (text += '');
    if (text) {
        ctx.font = style.font || __WEBPACK_IMPORTED_MODULE_10__core_platform_js__["b" /* DEFAULT_FONT */];
        ctx.textAlign = style.textAlign;
        ctx.textBaseline = style.textBaseline;
        var lineDash = void 0;
        var lineDashOffset = void 0;
        if (ctx.setLineDash && style.lineDash) {
            _a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__dashStyle_js__["a" /* getLineDash */])(el), lineDash = _a[0], lineDashOffset = _a[1];
        }
        if (lineDash) {
            ctx.setLineDash(lineDash);
            ctx.lineDashOffset = lineDashOffset;
        }
        if (style.strokeFirst) {
            if (styleHasStroke(style)) {
                ctx.strokeText(text, style.x, style.y);
            }
            if (styleHasFill(style)) {
                ctx.fillText(text, style.x, style.y);
            }
        }
        else {
            if (styleHasFill(style)) {
                ctx.fillText(text, style.x, style.y);
            }
            if (styleHasStroke(style)) {
                ctx.strokeText(text, style.x, style.y);
            }
        }
        if (lineDash) {
            ctx.setLineDash([]);
        }
    }
}
var SHADOW_NUMBER_PROPS = ['shadowBlur', 'shadowOffsetX', 'shadowOffsetY'];
var STROKE_PROPS = [
    ['lineCap', 'butt'], ['lineJoin', 'miter'], ['miterLimit', 10]
];
function bindCommonProps(ctx, style, prevStyle, forceSetAll, scope) {
    var styleChanged = false;
    if (!forceSetAll) {
        prevStyle = prevStyle || {};
        if (style === prevStyle) {
            return false;
        }
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        flushPathDrawn(ctx, scope);
        styleChanged = true;
        var opacity = Math.max(Math.min(style.opacity, 1), 0);
        ctx.globalAlpha = isNaN(opacity) ? __WEBPACK_IMPORTED_MODULE_0__graphic_Displayable_js__["a" /* DEFAULT_COMMON_STYLE */].opacity : opacity;
    }
    if (forceSetAll || style.blend !== prevStyle.blend) {
        if (!styleChanged) {
            flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalCompositeOperation = style.blend || __WEBPACK_IMPORTED_MODULE_0__graphic_Displayable_js__["a" /* DEFAULT_COMMON_STYLE */].blend;
    }
    for (var i = 0; i < SHADOW_NUMBER_PROPS.length; i++) {
        var propName = SHADOW_NUMBER_PROPS[i];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = ctx.dpr * (style[propName] || 0);
        }
    }
    if (forceSetAll || style.shadowColor !== prevStyle.shadowColor) {
        if (!styleChanged) {
            flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.shadowColor = style.shadowColor || __WEBPACK_IMPORTED_MODULE_0__graphic_Displayable_js__["a" /* DEFAULT_COMMON_STYLE */].shadowColor;
    }
    return styleChanged;
}
function bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetAll, scope) {
    var style = getStyle(el, scope.inHover);
    var prevStyle = forceSetAll
        ? null
        : (prevEl && getStyle(prevEl, scope.inHover) || {});
    if (style === prevStyle) {
        return false;
    }
    var styleChanged = bindCommonProps(ctx, style, prevStyle, forceSetAll, scope);
    if (forceSetAll || style.fill !== prevStyle.fill) {
        if (!styleChanged) {
            flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        isValidStrokeFillStyle(style.fill) && (ctx.fillStyle = style.fill);
    }
    if (forceSetAll || style.stroke !== prevStyle.stroke) {
        if (!styleChanged) {
            flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        isValidStrokeFillStyle(style.stroke) && (ctx.strokeStyle = style.stroke);
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        if (!styleChanged) {
            flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
    }
    if (el.hasStroke()) {
        var lineWidth = style.lineWidth;
        var newLineWidth = lineWidth / ((style.strokeNoScale && el.getLineScale) ? el.getLineScale() : 1);
        if (ctx.lineWidth !== newLineWidth) {
            if (!styleChanged) {
                flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.lineWidth = newLineWidth;
        }
    }
    for (var i = 0; i < STROKE_PROPS.length; i++) {
        var prop = STROKE_PROPS[i];
        var propName = prop[0];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = style[propName] || prop[1];
        }
    }
    return styleChanged;
}
function bindImageStyle(ctx, el, prevEl, forceSetAll, scope) {
    return bindCommonProps(ctx, getStyle(el, scope.inHover), prevEl && getStyle(prevEl, scope.inHover), forceSetAll, scope);
}
function setContextTransform(ctx, el) {
    var m = el.transform;
    var dpr = ctx.dpr || 1;
    if (m) {
        ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
    }
    else {
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
}
function updateClipStatus(clipPaths, ctx, scope) {
    var allClipped = false;
    for (var i = 0; i < clipPaths.length; i++) {
        var clipPath = clipPaths[i];
        allClipped = allClipped || clipPath.isZeroArea();
        setContextTransform(ctx, clipPath);
        ctx.beginPath();
        clipPath.buildPath(ctx, clipPath.shape);
        ctx.clip();
    }
    scope.allClipped = allClipped;
}
function isTransformChanged(m0, m1) {
    if (m0 && m1) {
        return m0[0] !== m1[0]
            || m0[1] !== m1[1]
            || m0[2] !== m1[2]
            || m0[3] !== m1[3]
            || m0[4] !== m1[4]
            || m0[5] !== m1[5];
    }
    else if (!m0 && !m1) {
        return false;
    }
    return true;
}
var DRAW_TYPE_PATH = 1;
var DRAW_TYPE_IMAGE = 2;
var DRAW_TYPE_TEXT = 3;
var DRAW_TYPE_INCREMENTAL = 4;
function canPathBatch(style) {
    var hasFill = styleHasFill(style);
    var hasStroke = styleHasStroke(style);
    return !(style.lineDash
        || !(+hasFill ^ +hasStroke)
        || (hasFill && typeof style.fill !== 'string')
        || (hasStroke && typeof style.stroke !== 'string')
        || style.strokePercent < 1
        || style.strokeOpacity < 1
        || style.fillOpacity < 1);
}
function flushPathDrawn(ctx, scope) {
    scope.batchFill && ctx.fill();
    scope.batchStroke && ctx.stroke();
    scope.batchFill = '';
    scope.batchStroke = '';
}
function getStyle(el, inHover) {
    return inHover ? (el.__hoverStyle || el.style) : el.style;
}
function brushSingle(ctx, el) {
    brush(ctx, el, { inHover: false, viewWidth: 0, viewHeight: 0 }, true);
}
function brush(ctx, el, scope, isLast) {
    var m = el.transform;
    if (!el.shouldBePainted(scope.viewWidth, scope.viewHeight, false, false)) {
        el.__dirty &= ~__WEBPACK_IMPORTED_MODULE_9__graphic_constants_js__["a" /* REDRAW_BIT */];
        el.__isRendered = false;
        return;
    }
    var clipPaths = el.__clipPaths;
    var prevElClipPaths = scope.prevElClipPaths;
    var forceSetTransform = false;
    var forceSetStyle = false;
    if (!prevElClipPaths || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_js__["b" /* isClipPathChanged */])(clipPaths, prevElClipPaths)) {
        if (prevElClipPaths && prevElClipPaths.length) {
            flushPathDrawn(ctx, scope);
            ctx.restore();
            forceSetStyle = forceSetTransform = true;
            scope.prevElClipPaths = null;
            scope.allClipped = false;
            scope.prevEl = null;
        }
        if (clipPaths && clipPaths.length) {
            flushPathDrawn(ctx, scope);
            ctx.save();
            updateClipStatus(clipPaths, ctx, scope);
            forceSetTransform = true;
        }
        scope.prevElClipPaths = clipPaths;
    }
    if (scope.allClipped) {
        el.__isRendered = false;
        return;
    }
    el.beforeBrush && el.beforeBrush();
    el.innerBeforeBrush();
    var prevEl = scope.prevEl;
    if (!prevEl) {
        forceSetStyle = forceSetTransform = true;
    }
    var canBatchPath = el instanceof __WEBPACK_IMPORTED_MODULE_4__graphic_Path_js__["a" /* default */]
        && el.autoBatch
        && canPathBatch(el.style);
    if (forceSetTransform || isTransformChanged(m, prevEl.transform)) {
        flushPathDrawn(ctx, scope);
        setContextTransform(ctx, el);
    }
    else if (!canBatchPath) {
        flushPathDrawn(ctx, scope);
    }
    var style = getStyle(el, scope.inHover);
    if (el instanceof __WEBPACK_IMPORTED_MODULE_4__graphic_Path_js__["a" /* default */]) {
        if (scope.lastDrawType !== DRAW_TYPE_PATH) {
            forceSetStyle = true;
            scope.lastDrawType = DRAW_TYPE_PATH;
        }
        bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
        if (!canBatchPath || (!scope.batchFill && !scope.batchStroke)) {
            ctx.beginPath();
        }
        brushPath(ctx, el, style, canBatchPath);
        if (canBatchPath) {
            scope.batchFill = style.fill || '';
            scope.batchStroke = style.stroke || '';
        }
    }
    else {
        if (el instanceof __WEBPACK_IMPORTED_MODULE_6__graphic_TSpan_js__["a" /* default */]) {
            if (scope.lastDrawType !== DRAW_TYPE_TEXT) {
                forceSetStyle = true;
                scope.lastDrawType = DRAW_TYPE_TEXT;
            }
            bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
            brushText(ctx, el, style);
        }
        else if (el instanceof __WEBPACK_IMPORTED_MODULE_5__graphic_Image_js__["a" /* default */]) {
            if (scope.lastDrawType !== DRAW_TYPE_IMAGE) {
                forceSetStyle = true;
                scope.lastDrawType = DRAW_TYPE_IMAGE;
            }
            bindImageStyle(ctx, el, prevEl, forceSetStyle, scope);
            brushImage(ctx, el, style);
        }
        else if (el.getTemporalDisplayables) {
            if (scope.lastDrawType !== DRAW_TYPE_INCREMENTAL) {
                forceSetStyle = true;
                scope.lastDrawType = DRAW_TYPE_INCREMENTAL;
            }
            brushIncremental(ctx, el, scope);
        }
    }
    if (canBatchPath && isLast) {
        flushPathDrawn(ctx, scope);
    }
    el.innerAfterBrush();
    el.afterBrush && el.afterBrush();
    scope.prevEl = el;
    el.__dirty = 0;
    el.__isRendered = true;
}
function brushIncremental(ctx, el, scope) {
    var displayables = el.getDisplayables();
    var temporalDisplayables = el.getTemporalDisplayables();
    ctx.save();
    var innerScope = {
        prevElClipPaths: null,
        prevEl: null,
        allClipped: false,
        viewWidth: scope.viewWidth,
        viewHeight: scope.viewHeight,
        inHover: scope.inHover
    };
    var i;
    var len;
    for (i = el.getCursor(), len = displayables.length; i < len; i++) {
        var displayable = displayables[i];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        brush(ctx, displayable, innerScope, i === len - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    for (var i_1 = 0, len_1 = temporalDisplayables.length; i_1 < len_1; i_1++) {
        var displayable = temporalDisplayables[i_1];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        brush(ctx, displayable, innerScope, i_1 === len_1 - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    el.clearTemporalDisplayables();
    el.notClear = true;
    ctx.restore();
}


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createLinearGradient */
/* unused harmony export createRadialGradient */
/* harmony export (immutable) */ __webpack_exports__["a"] = getCanvasGradient;
/* harmony export (immutable) */ __webpack_exports__["b"] = isClipPathChanged;
/* harmony export (immutable) */ __webpack_exports__["c"] = getSize;
function createLinearGradient(ctx, obj, rect) {
    var x = obj.x == null ? 0 : obj.x;
    var x2 = obj.x2 == null ? 1 : obj.x2;
    var y = obj.y == null ? 0 : obj.y;
    var y2 = obj.y2 == null ? 0 : obj.y2;
    if (!obj.global) {
        x = x * rect.width + rect.x;
        x2 = x2 * rect.width + rect.x;
        y = y * rect.height + rect.y;
        y2 = y2 * rect.height + rect.y;
    }
    x = isNaN(x) ? 0 : x;
    x2 = isNaN(x2) ? 1 : x2;
    y = isNaN(y) ? 0 : y;
    y2 = isNaN(y2) ? 0 : y2;
    var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
    return canvasGradient;
}
function createRadialGradient(ctx, obj, rect) {
    var width = rect.width;
    var height = rect.height;
    var min = Math.min(width, height);
    var x = obj.x == null ? 0.5 : obj.x;
    var y = obj.y == null ? 0.5 : obj.y;
    var r = obj.r == null ? 0.5 : obj.r;
    if (!obj.global) {
        x = x * width + rect.x;
        y = y * height + rect.y;
        r = r * min;
    }
    var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
    return canvasGradient;
}
function getCanvasGradient(ctx, obj, rect) {
    var canvasGradient = obj.type === 'radial'
        ? createRadialGradient(ctx, obj, rect)
        : createLinearGradient(ctx, obj, rect);
    var colorStops = obj.colorStops;
    for (var i = 0; i < colorStops.length; i++) {
        canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
    }
    return canvasGradient;
}
function isClipPathChanged(clipPaths, prevClipPaths) {
    if (clipPaths === prevClipPaths || (!clipPaths && !prevClipPaths)) {
        return false;
    }
    if (!clipPaths || !prevClipPaths || (clipPaths.length !== prevClipPaths.length)) {
        return true;
    }
    for (var i = 0; i < clipPaths.length; i++) {
        if (clipPaths[i] !== prevClipPaths[i]) {
            return true;
        }
    }
    return false;
}
function parseInt10(val) {
    return parseInt(val, 10);
}
function getSize(root, whIdx, opts) {
    var wh = ['width', 'height'][whIdx];
    var cwh = ['clientWidth', 'clientHeight'][whIdx];
    var plt = ['paddingLeft', 'paddingTop'][whIdx];
    var prb = ['paddingRight', 'paddingBottom'][whIdx];
    if (opts[wh] != null && opts[wh] !== 'auto') {
        return parseFloat(opts[wh]);
    }
    var stl = document.defaultView.getComputedStyle(root);
    return ((root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh]))
        - (parseInt10(stl[plt]) || 0)
        - (parseInt10(stl[prb]) || 0)) | 0;
}


/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Point = (function () {
    function Point(x, y) {
        this.x = x || 0;
        this.y = y || 0;
    }
    Point.prototype.copy = function (other) {
        this.x = other.x;
        this.y = other.y;
        return this;
    };
    Point.prototype.clone = function () {
        return new Point(this.x, this.y);
    };
    Point.prototype.set = function (x, y) {
        this.x = x;
        this.y = y;
        return this;
    };
    Point.prototype.equal = function (other) {
        return other.x === this.x && other.y === this.y;
    };
    Point.prototype.add = function (other) {
        this.x += other.x;
        this.y += other.y;
        return this;
    };
    Point.prototype.scale = function (scalar) {
        this.x *= scalar;
        this.y *= scalar;
    };
    Point.prototype.scaleAndAdd = function (other, scalar) {
        this.x += other.x * scalar;
        this.y += other.y * scalar;
    };
    Point.prototype.sub = function (other) {
        this.x -= other.x;
        this.y -= other.y;
        return this;
    };
    Point.prototype.dot = function (other) {
        return this.x * other.x + this.y * other.y;
    };
    Point.prototype.len = function () {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    };
    Point.prototype.lenSquare = function () {
        return this.x * this.x + this.y * this.y;
    };
    Point.prototype.normalize = function () {
        var len = this.len();
        this.x /= len;
        this.y /= len;
        return this;
    };
    Point.prototype.distance = function (other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    Point.prototype.distanceSquare = function (other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return dx * dx + dy * dy;
    };
    Point.prototype.negate = function () {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    };
    Point.prototype.transform = function (m) {
        if (!m) {
            return;
        }
        var x = this.x;
        var y = this.y;
        this.x = m[0] * x + m[2] * y + m[4];
        this.y = m[1] * x + m[3] * y + m[5];
        return this;
    };
    Point.prototype.toArray = function (out) {
        out[0] = this.x;
        out[1] = this.y;
        return out;
    };
    Point.prototype.fromArray = function (input) {
        this.x = input[0];
        this.y = input[1];
    };
    Point.set = function (p, x, y) {
        p.x = x;
        p.y = y;
    };
    Point.copy = function (p, p2) {
        p.x = p2.x;
        p.y = p2.y;
    };
    Point.len = function (p) {
        return Math.sqrt(p.x * p.x + p.y * p.y);
    };
    Point.lenSquare = function (p) {
        return p.x * p.x + p.y * p.y;
    };
    Point.dot = function (p0, p1) {
        return p0.x * p1.x + p0.y * p1.y;
    };
    Point.add = function (out, p0, p1) {
        out.x = p0.x + p1.x;
        out.y = p0.y + p1.y;
    };
    Point.sub = function (out, p0, p1) {
        out.x = p0.x - p1.x;
        out.y = p0.y - p1.y;
    };
    Point.scale = function (out, p0, scalar) {
        out.x = p0.x * scalar;
        out.y = p0.y * scalar;
    };
    Point.scaleAndAdd = function (out, p0, p1, scalar) {
        out.x = p0.x + p1.x * scalar;
        out.y = p0.y + p1.y * scalar;
    };
    Point.lerp = function (out, p0, p1, t) {
        var onet = 1 - t;
        out.x = onet * p0.x + t * p1.x;
        out.y = onet * p0.y + t * p1.y;
    };
    return Point;
}());
/* harmony default export */ __webpack_exports__["a"] = (Point);


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = fromPoints;
/* harmony export (immutable) */ __webpack_exports__["a"] = fromLine;
/* harmony export (immutable) */ __webpack_exports__["b"] = fromCubic;
/* harmony export (immutable) */ __webpack_exports__["c"] = fromQuadratic;
/* harmony export (immutable) */ __webpack_exports__["d"] = fromArc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vector_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__curve_js__ = __webpack_require__(57);


var mathMin = Math.min;
var mathMax = Math.max;
var mathSin = Math.sin;
var mathCos = Math.cos;
var PI2 = Math.PI * 2;
var start = __WEBPACK_IMPORTED_MODULE_0__vector_js__["create"]();
var end = __WEBPACK_IMPORTED_MODULE_0__vector_js__["create"]();
var extremity = __WEBPACK_IMPORTED_MODULE_0__vector_js__["create"]();
function fromPoints(points, min, max) {
    if (points.length === 0) {
        return;
    }
    var p = points[0];
    var left = p[0];
    var right = p[0];
    var top = p[1];
    var bottom = p[1];
    for (var i = 1; i < points.length; i++) {
        p = points[i];
        left = mathMin(left, p[0]);
        right = mathMax(right, p[0]);
        top = mathMin(top, p[1]);
        bottom = mathMax(bottom, p[1]);
    }
    min[0] = left;
    min[1] = top;
    max[0] = right;
    max[1] = bottom;
}
function fromLine(x0, y0, x1, y1, min, max) {
    min[0] = mathMin(x0, x1);
    min[1] = mathMin(y0, y1);
    max[0] = mathMax(x0, x1);
    max[1] = mathMax(y0, y1);
}
var xDim = [];
var yDim = [];
function fromCubic(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
    var cubicExtrema = __WEBPACK_IMPORTED_MODULE_1__curve_js__["c" /* cubicExtrema */];
    var cubicAt = __WEBPACK_IMPORTED_MODULE_1__curve_js__["b" /* cubicAt */];
    var n = cubicExtrema(x0, x1, x2, x3, xDim);
    min[0] = Infinity;
    min[1] = Infinity;
    max[0] = -Infinity;
    max[1] = -Infinity;
    for (var i = 0; i < n; i++) {
        var x = cubicAt(x0, x1, x2, x3, xDim[i]);
        min[0] = mathMin(x, min[0]);
        max[0] = mathMax(x, max[0]);
    }
    n = cubicExtrema(y0, y1, y2, y3, yDim);
    for (var i = 0; i < n; i++) {
        var y = cubicAt(y0, y1, y2, y3, yDim[i]);
        min[1] = mathMin(y, min[1]);
        max[1] = mathMax(y, max[1]);
    }
    min[0] = mathMin(x0, min[0]);
    max[0] = mathMax(x0, max[0]);
    min[0] = mathMin(x3, min[0]);
    max[0] = mathMax(x3, max[0]);
    min[1] = mathMin(y0, min[1]);
    max[1] = mathMax(y0, max[1]);
    min[1] = mathMin(y3, min[1]);
    max[1] = mathMax(y3, max[1]);
}
function fromQuadratic(x0, y0, x1, y1, x2, y2, min, max) {
    var quadraticExtremum = __WEBPACK_IMPORTED_MODULE_1__curve_js__["e" /* quadraticExtremum */];
    var quadraticAt = __WEBPACK_IMPORTED_MODULE_1__curve_js__["f" /* quadraticAt */];
    var tx = mathMax(mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
    var ty = mathMax(mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
    var x = quadraticAt(x0, x1, x2, tx);
    var y = quadraticAt(y0, y1, y2, ty);
    min[0] = mathMin(x0, x2, x);
    min[1] = mathMin(y0, y2, y);
    max[0] = mathMax(x0, x2, x);
    max[1] = mathMax(y0, y2, y);
}
function fromArc(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
    var vec2Min = __WEBPACK_IMPORTED_MODULE_0__vector_js__["min"];
    var vec2Max = __WEBPACK_IMPORTED_MODULE_0__vector_js__["max"];
    var diff = Math.abs(startAngle - endAngle);
    if (diff % PI2 < 1e-4 && diff > 1e-4) {
        min[0] = x - rx;
        min[1] = y - ry;
        max[0] = x + rx;
        max[1] = y + ry;
        return;
    }
    start[0] = mathCos(startAngle) * rx + x;
    start[1] = mathSin(startAngle) * ry + y;
    end[0] = mathCos(endAngle) * rx + x;
    end[1] = mathSin(endAngle) * ry + y;
    vec2Min(min, start, end);
    vec2Max(max, start, end);
    startAngle = startAngle % (PI2);
    if (startAngle < 0) {
        startAngle = startAngle + PI2;
    }
    endAngle = endAngle % (PI2);
    if (endAngle < 0) {
        endAngle = endAngle + PI2;
    }
    if (startAngle > endAngle && !anticlockwise) {
        endAngle += PI2;
    }
    else if (startAngle < endAngle && anticlockwise) {
        startAngle += PI2;
    }
    if (anticlockwise) {
        var tmp = endAngle;
        endAngle = startAngle;
        startAngle = tmp;
    }
    for (var angle = 0; angle < endAngle; angle += Math.PI / 2) {
        if (angle > startAngle) {
            extremity[0] = mathCos(angle) * rx + x;
            extremity[1] = mathSin(angle) * ry + y;
            vec2Min(min, extremity, min);
            vec2Max(max, extremity, max);
        }
    }
}


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_TSPAN_STYLE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Displayable_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contain_text_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Path_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_platform_js__ = __webpack_require__(67);






var DEFAULT_TSPAN_STYLE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_util_js__["defaults"])({
    strokeFirst: true,
    font: __WEBPACK_IMPORTED_MODULE_5__core_platform_js__["b" /* DEFAULT_FONT */],
    x: 0,
    y: 0,
    textAlign: 'left',
    textBaseline: 'top',
    miterLimit: 2
}, __WEBPACK_IMPORTED_MODULE_3__Path_js__["b" /* DEFAULT_PATH_STYLE */]);
var TSpan = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(TSpan, _super);
    function TSpan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TSpan.prototype.hasStroke = function () {
        var style = this.style;
        var stroke = style.stroke;
        return stroke != null && stroke !== 'none' && style.lineWidth > 0;
    };
    TSpan.prototype.hasFill = function () {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    TSpan.prototype.createStyle = function (obj) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_util_js__["createObject"])(DEFAULT_TSPAN_STYLE, obj);
    };
    TSpan.prototype.setBoundingRect = function (rect) {
        this._rect = rect;
    };
    TSpan.prototype.getBoundingRect = function () {
        var style = this.style;
        if (!this._rect) {
            var text = style.text;
            text != null ? (text += '') : (text = '');
            var rect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__contain_text_js__["g" /* getBoundingRect */])(text, style.font, style.textAlign, style.textBaseline);
            rect.x += style.x || 0;
            rect.y += style.y || 0;
            if (this.hasStroke()) {
                var w = style.lineWidth;
                rect.x -= w / 2;
                rect.y -= w / 2;
                rect.width += w;
                rect.height += w;
            }
            this._rect = rect;
        }
        return this._rect;
    };
    TSpan.initDefaultProps = (function () {
        var tspanProto = TSpan.prototype;
        tspanProto.dirtyRectTolerance = 10;
    })();
    return TSpan;
}(__WEBPACK_IMPORTED_MODULE_1__Displayable_js__["c" /* default */]));
TSpan.prototype.type = 'tspan';
/* harmony default export */ __webpack_exports__["a"] = (TSpan);


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SVGNS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return XLINKNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return XMLNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return XML_NAMESPACE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createElement;
/* harmony export (immutable) */ __webpack_exports__["d"] = createVNode;
/* harmony export (immutable) */ __webpack_exports__["f"] = vNodeToString;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCssString;
/* harmony export (immutable) */ __webpack_exports__["c"] = createBrushScope;
/* harmony export (immutable) */ __webpack_exports__["a"] = createSVGVNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_util_js__ = __webpack_require__(0);

var SVGNS = 'http://www.w3.org/2000/svg';
var XLINKNS = 'http://www.w3.org/1999/xlink';
var XMLNS = 'http://www.w3.org/2000/xmlns/';
var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace';
function createElement(name) {
    return document.createElementNS(SVGNS, name);
}
;
function createVNode(tag, key, attrs, children, text) {
    return {
        tag: tag,
        attrs: attrs || {},
        children: children,
        text: text,
        key: key
    };
}
function createElementOpen(name, attrs) {
    var attrsStr = [];
    if (attrs) {
        for (var key in attrs) {
            var val = attrs[key];
            var part = key;
            if (val === false) {
                continue;
            }
            else if (val !== true && val != null) {
                part += "=\"" + val + "\"";
            }
            attrsStr.push(part);
        }
    }
    return "<" + name + " " + attrsStr.join(' ') + ">";
}
function createElementClose(name) {
    return "</" + name + ">";
}
function vNodeToString(el, opts) {
    opts = opts || {};
    var S = opts.newline ? '\n' : '';
    function convertElToString(el) {
        var children = el.children, tag = el.tag, attrs = el.attrs;
        return createElementOpen(tag, attrs)
            + (el.text || '')
            + (children ? "" + S + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["map"])(children, function (child) { return convertElToString(child); }).join(S) + S : '')
            + createElementClose(tag);
    }
    return convertElToString(el);
}
function getCssString(selectorNodes, animationNodes, opts) {
    opts = opts || {};
    var S = opts.newline ? '\n' : '';
    var bracketBegin = " {" + S;
    var bracketEnd = S + "}";
    var selectors = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["map"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["keys"])(selectorNodes), function (className) {
        return className + bracketBegin + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["map"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["keys"])(selectorNodes[className]), function (attrName) {
            return attrName + ":" + selectorNodes[className][attrName] + ";";
        }).join(S) + bracketEnd;
    }).join(S);
    var animations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["map"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["keys"])(animationNodes), function (animationName) {
        return "@keyframes " + animationName + bracketBegin + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["map"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["keys"])(animationNodes[animationName]), function (percent) {
            return percent + bracketBegin + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["map"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["keys"])(animationNodes[animationName][percent]), function (attrName) {
                var val = animationNodes[animationName][percent][attrName];
                if (attrName === 'd') {
                    val = "path(\"" + val + "\")";
                }
                return attrName + ":" + val + ";";
            }).join(S) + bracketEnd;
        }).join(S) + bracketEnd;
    }).join(S);
    if (!selectors && !animations) {
        return '';
    }
    return ['<![CDATA[', selectors, animations, ']]>'].join(S);
}
function createBrushScope(zrId) {
    return {
        zrId: zrId,
        shadowCache: {},
        patternCache: {},
        gradientCache: {},
        clipPathCache: {},
        defs: {},
        cssNodes: {},
        cssAnims: {},
        cssClassIdx: 0,
        cssAnimIdx: 0,
        shadowIdx: 0,
        gradientIdx: 0,
        patternIdx: 0,
        clipPathIdx: 0
    };
}
function createSVGVNode(width, height, children, useViewBox) {
    return createVNode('svg', 'root', {
        'width': width,
        'height': height,
        'xmlns': SVGNS,
        'xmlns:xlink': XLINKNS,
        'version': '1.1',
        'baseProfile': 'full',
        'viewBox': useViewBox ? "0 0 " + width + " " + height : false
    }, children);
}


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./application/edit/index": 550,
	"./application/edit/index.vue": 550,
	"./application/index": 551,
	"./application/index.vue": 551,
	"./application/view/index": 552,
	"./application/view/index.vue": 552,
	"./authorizedtask/index": 553,
	"./authorizedtask/index.vue": 553,
	"./authorizedtask/view/index": 554,
	"./authorizedtask/view/index.vue": 554,
	"./library/index": 555,
	"./library/index.vue": 555,
	"./library/view/index": 556,
	"./library/view/index.vue": 556,
	"./task/index": 557,
	"./task/index.vue": 557,
	"./task/view/index": 558,
	"./task/view/index.vue": 558
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 259;

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filters__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directive_index__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_axios__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_utils__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_lang_zh_CN__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__common_lang_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_lang_zh__ = __webpack_require__(1722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_lang_zh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__common_lang_zh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__theme_index_css__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__theme_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__theme_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__libs_loading_index__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__libs_message_index__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_i18n__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_globalComponents__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_normalize_css__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lib_flexible__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lib_flexible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lib_flexible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__css_common_less__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__css_common_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__css_common_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__css_reset_less__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__css_reset_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__css_reset_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__css_e2e_style_less__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__css_e2e_style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__css_e2e_style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__css_el_reset_less__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__css_el_reset_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__css_el_reset_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__libs_messageBox__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__libs_commentBox__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__libs_approvalBox__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__libs_permission__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__libs_afterMeeting__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__libs_function__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__libs_download__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__libs_PDFViewer__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__libs_previewExcel__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__libs_previewImg__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__libs_amap__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__libs_dictSelect_index__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__libs_language__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__util_message_js__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__libs_copy__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_echarts__ = __webpack_require__(1080);







// 引入 axios












// 国际化插件






//自动适配


// 重置样式





__WEBPACK_IMPORTED_MODULE_1_vue___default.a.config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$moment = __WEBPACK_IMPORTED_MODULE_10_moment___default.a;
// 全局方法库
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7__util_utils__["a" /* default */]);

// 使用国际化插件
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_16_vue_i18n__["a" /* default */]); // 通过插件的形式挂载
var _i18n = new __WEBPACK_IMPORTED_MODULE_16_vue_i18n__["a" /* default */]({
  silentFallbackWarn: true,
  locale: 'zh', // 语言标识
  // this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    zh: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_12__common_lang_zh___default.a, __WEBPACK_IMPORTED_MODULE_11__common_lang_zh_CN___default.a) // 中文语言包
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15__libs_message_index__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14__libs_loading_index__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui___default.a, { i18n: function i18n(key, value) {
    return _i18n.t(key, value);
  } });

// messageBox 插件












__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__libs_approvalBox__["a" /* RewriteLocale */])(_i18n);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_24__libs_messageBox__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_26__libs_approvalBox__["b" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_25__libs_commentBox__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_27__libs_permission__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_28__libs_afterMeeting__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_31__libs_PDFViewer__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_32__libs_previewExcel__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_33__libs_previewImg__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_29__libs_function__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_30__libs_download__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_34__libs_amap__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_35__libs_dictSelect_index__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_36__libs_language__["a" /* default */]);

// 轻提示默认偏移量

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$message = __WEBPACK_IMPORTED_MODULE_37__util_message_js__["a" /* default */];

// copye

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_38__libs_copy__["a" /* default */]);

//引入echars

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$echarts = __WEBPACK_IMPORTED_MODULE_39_echarts__;

/* eslint-disable no-new */
var VueInstance = new __WEBPACK_IMPORTED_MODULE_1_vue___default.a({
  el: '#app',
  i18n: _i18n,
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_2__App___default.a
  }
});

window.vm = VueInstance;

/* harmony default export */ __webpack_exports__["default"] = (VueInstance);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_common__ = __webpack_require__(171);


var language = void 0;

var nav_lang = (navigator.language || navigator.userLanguage || navigator.browserLanguage).toLowerCase();

// localstorage 存在 使用 localstorage 中设置的国际化
if (localStorage.getItem(__WEBPACK_IMPORTED_MODULE_0__constant_common__["b" /* E2E_LANGUAGE_STORAGE_KEY */])) {
  language = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_0__constant_common__["b" /* E2E_LANGUAGE_STORAGE_KEY */]);
} else {
  if (nav_lang.indexOf('zh') > -1) {
    language = 'zh';
  } else {
    language = 'en';
  }
}
// 924 设置语言为英文版本
// language = 'en';
localStorage.setItem(__WEBPACK_IMPORTED_MODULE_0__constant_common__["b" /* E2E_LANGUAGE_STORAGE_KEY */], language);

/* harmony default export */ __webpack_exports__["a"] = (language);

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(763), __esModule: true };

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(746);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(103);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(753)
var ieee754 = __webpack_require__(1376)
var isArray = __webpack_require__(754)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50)))

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 266 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(80);
var document = __webpack_require__(44).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 268 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(176);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(178);
var $export = __webpack_require__(53);
var redefine = __webpack_require__(399);
var hide = __webpack_require__(106);
var Iterators = __webpack_require__(143);
var $iterCreate = __webpack_require__(779);
var setToStringTag = __webpack_require__(181);
var getPrototypeOf = __webpack_require__(785);
var ITERATOR = __webpack_require__(45)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(213)('meta');
var isObject = __webpack_require__(80);
var has = __webpack_require__(120);
var setDesc = __webpack_require__(71).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(119)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(175);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(94);
var dPs = __webpack_require__(782);
var enumBugKeys = __webpack_require__(268);
var IE_PROTO = __webpack_require__(276)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(267)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(388).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 274 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(106);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(277)('keys');
var uid = __webpack_require__(213);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(36);
var global = __webpack_require__(44);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(178) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 278 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(80);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(44);
var core = __webpack_require__(36);
var LIBRARY = __webpack_require__(178);
var wksExt = __webpack_require__(281);
var defineProperty = __webpack_require__(71).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(45);


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(210);
var ITERATOR = __webpack_require__(45)('iterator');
var Iterators = __webpack_require__(143);
module.exports = __webpack_require__(36).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 283 */
/***/ (function(module, exports) {



/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(225)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(34);
var toAbsoluteIndex = __webpack_require__(129);
var toLength = __webpack_require__(29);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(809);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(33);
var createDesc = __webpack_require__(126);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
var document = __webpack_require__(13).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 289 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(25)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(13).document;
module.exports = document && document.documentElement;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
var setPrototypeOf = __webpack_require__(301).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(148);
var ITERATOR = __webpack_require__(25)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(123);
var descriptor = __webpack_require__(126);
var setToStringTag = __webpack_require__(149);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(54)(IteratorPrototype, __webpack_require__(25)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(108);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(55);
var hide = __webpack_require__(54);
var Iterators = __webpack_require__(148);
var $iterCreate = __webpack_require__(294);
var setToStringTag = __webpack_require__(149);
var getPrototypeOf = __webpack_require__(63);
var ITERATOR = __webpack_require__(25)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 296 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 297 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var macrotask = __webpack_require__(306).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(72)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(46);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(183);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(18);
var anObject = __webpack_require__(9);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(74)(Function.call, __webpack_require__(62).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(186)('keys');
var uid = __webpack_require__(130);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(218);
var defined = __webpack_require__(82);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(76);
var defined = __webpack_require__(82);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(74);
var invoke = __webpack_require__(414);
var html = __webpack_require__(291);
var cel = __webpack_require__(288);
var global = __webpack_require__(13);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(72)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(13);
var DESCRIPTORS = __webpack_require__(31);
var LIBRARY = __webpack_require__(108);
var $typed = __webpack_require__(226);
var hide = __webpack_require__(54);
var redefineAll = __webpack_require__(127);
var fails = __webpack_require__(16);
var anInstance = __webpack_require__(121);
var toInteger = __webpack_require__(76);
var toLength = __webpack_require__(29);
var toIndex = __webpack_require__(433);
var gOPN = __webpack_require__(124).f;
var dP = __webpack_require__(33).f;
var arrayFill = __webpack_require__(285);
var setToStringTag = __webpack_require__(149);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var core = __webpack_require__(73);
var LIBRARY = __webpack_require__(108);
var wksExt = __webpack_require__(434);
var defineProperty = __webpack_require__(33).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(147);
var ITERATOR = __webpack_require__(25)('iterator');
var Iterators = __webpack_require__(148);
module.exports = __webpack_require__(73).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(107);
var step = __webpack_require__(417);
var Iterators = __webpack_require__(148);
var toIObject = __webpack_require__(64);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(295)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateCenterAndZoom;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function getCenterCoord(view, point) {
  // Use projected coord as center because it's linear.
  return view.pointToProjected ? view.pointToProjected(point) : view.pointToData(point);
}

function updateCenterAndZoom(view, payload, zoomLimit) {
  var previousZoom = view.getZoom();
  var center = view.getCenter();
  var zoom = payload.zoom;
  var point = view.projectedToPoint ? view.projectedToPoint(center) : view.dataToPoint(center);

  if (payload.dx != null && payload.dy != null) {
    point[0] -= payload.dx;
    point[1] -= payload.dy;
    view.setCenter(getCenterCoord(view, point));
  }

  if (zoom != null) {
    if (zoomLimit) {
      var zoomMin = zoomLimit.min || 0;
      var zoomMax = zoomLimit.max || Infinity;
      zoom = Math.max(Math.min(previousZoom * zoom, zoomMax), zoomMin) / previousZoom;
    } // Zoom on given point(originX, originY)


    view.scaleX *= zoom;
    view.scaleY *= zoom;
    var fixX = (payload.originX - view.x) * (zoom - 1);
    var fixY = (payload.originY - view.y) * (zoom - 1);
    view.x -= fixX;
    view.y -= fixY;
    view.updateTransform(); // Get the new center

    view.setCenter(getCenterCoord(view, point));
    view.setZoom(zoom * previousZoom);
  }

  return {
    center: view.getCenter(),
    zoom: view.getZoom()
  };
}

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ELEMENT_ANIMATABLE_PROPS; });
/* harmony export (immutable) */ __webpack_exports__["a"] = applyUpdateTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateLeaveTo;
/* harmony export (immutable) */ __webpack_exports__["d"] = applyLeaveTransition;
/* harmony export (immutable) */ __webpack_exports__["c"] = isTransitionAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_animation_Animator_js__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_graphic_Displayable_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__basicTrasition_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_log_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_Transformable_js__ = __webpack_require__(117);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/








var LEGACY_TRANSFORM_PROPS_MAP = {
  position: ['x', 'y'],
  scale: ['scaleX', 'scaleY'],
  origin: ['originX', 'originY']
};
var LEGACY_TRANSFORM_PROPS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["keys"])(LEGACY_TRANSFORM_PROPS_MAP);
var TRANSFORM_PROPS_MAP = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["reduce"])(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_Transformable_js__["b" /* TRANSFORMABLE_PROPS */], function (obj, key) {
  obj[key] = 1;
  return obj;
}, {});
var transformPropNamesStr = __WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_Transformable_js__["b" /* TRANSFORMABLE_PROPS */].join(', '); // '' means root

var ELEMENT_ANIMATABLE_PROPS = ['', 'style', 'shape', 'extra'];
;
var transitionInnerStore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_model_js__["a" /* makeInner */])();
;

function getElementAnimationConfig(animationType, el, elOption, parentModel, dataIndex) {
  var animationProp = animationType + "Animation";
  var config = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__basicTrasition_js__["d" /* getAnimationConfig */])(animationType, parentModel, dataIndex) || {};
  var userDuring = transitionInnerStore(el).userDuring; // Only set when duration is > 0 and it's need to be animated.

  if (config.duration > 0) {
    // For simplicity, if during not specified, the previous during will not work any more.
    config.during = userDuring ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(duringCall, {
      el: el,
      userDuring: userDuring
    }) : null;
    config.setToFinal = true;
    config.scope = animationType;
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])(config, elOption[animationProp]);
  return config;
}

function applyUpdateTransition(el, elOption, animatableModel, opts) {
  opts = opts || {};
  var dataIndex = opts.dataIndex,
      isInit = opts.isInit,
      clearStyle = opts.clearStyle;
  var hasAnimation = animatableModel.isAnimationEnabled(); // Save the meta info for further morphing. Like apply on the sub morphing elements.

  var store = transitionInnerStore(el);
  var styleOpt = elOption.style;
  store.userDuring = elOption.during;
  var transFromProps = {};
  var propsToSet = {};
  prepareTransformAllPropsFinal(el, elOption, propsToSet);
  prepareShapeOrExtraAllPropsFinal('shape', elOption, propsToSet);
  prepareShapeOrExtraAllPropsFinal('extra', elOption, propsToSet);

  if (!isInit && hasAnimation) {
    prepareTransformTransitionFrom(el, elOption, transFromProps);
    prepareShapeOrExtraTransitionFrom('shape', el, elOption, transFromProps);
    prepareShapeOrExtraTransitionFrom('extra', el, elOption, transFromProps);
    prepareStyleTransitionFrom(el, elOption, styleOpt, transFromProps);
  }

  propsToSet.style = styleOpt;
  applyPropsDirectly(el, propsToSet, clearStyle);
  applyMiscProps(el, elOption);

  if (hasAnimation) {
    if (isInit) {
      var enterFromProps_1 = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(ELEMENT_ANIMATABLE_PROPS, function (propName) {
        var prop = propName ? elOption[propName] : elOption;

        if (prop && prop.enterFrom) {
          if (propName) {
            enterFromProps_1[propName] = enterFromProps_1[propName] || {};
          }

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])(propName ? enterFromProps_1[propName] : enterFromProps_1, prop.enterFrom);
        }
      });
      var config = getElementAnimationConfig('enter', el, elOption, animatableModel, dataIndex);

      if (config.duration > 0) {
        el.animateFrom(enterFromProps_1, config);
      }
    } else {
      applyPropsTransition(el, elOption, dataIndex || 0, animatableModel, transFromProps);
    }
  } // Store leave to be used in leave transition.


  updateLeaveTo(el, elOption);
  styleOpt ? el.dirty() : el.markRedraw();
}
function updateLeaveTo(el, elOption) {
  // Try merge to previous set leaveTo
  var leaveToProps = transitionInnerStore(el).leaveToProps;

  for (var i = 0; i < ELEMENT_ANIMATABLE_PROPS.length; i++) {
    var propName = ELEMENT_ANIMATABLE_PROPS[i];
    var prop = propName ? elOption[propName] : elOption;

    if (prop && prop.leaveTo) {
      if (!leaveToProps) {
        leaveToProps = transitionInnerStore(el).leaveToProps = {};
      }

      if (propName) {
        leaveToProps[propName] = leaveToProps[propName] || {};
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])(propName ? leaveToProps[propName] : leaveToProps, prop.leaveTo);
    }
  }
}
function applyLeaveTransition(el, elOption, animatableModel, onRemove) {
  if (el) {
    var parent_1 = el.parent;
    var leaveToProps = transitionInnerStore(el).leaveToProps;

    if (leaveToProps) {
      // TODO TODO use leave after leaveAnimation in series is introduced
      // TODO Data index?
      var config = getElementAnimationConfig('update', el, elOption, animatableModel, 0);

      config.done = function () {
        parent_1.remove(el);
        onRemove && onRemove();
      };

      el.animateTo(leaveToProps, config);
    } else {
      parent_1.remove(el);
      onRemove && onRemove();
    }
  }
}
function isTransitionAll(transition) {
  return transition === 'all';
}

function applyPropsDirectly(el, // Can be null/undefined
allPropsFinal, clearStyle) {
  var styleOpt = allPropsFinal.style;

  if (!el.isGroup && styleOpt) {
    if (clearStyle) {
      el.useStyle({}); // When style object changed, how to trade the existing animation?
      // It is probably complicated and not needed to cover all the cases.
      // But still need consider the case:
      // (1) When using init animation on `style.opacity`, and before the animation
      //     ended users triggers an update by mousewhel. At that time the init
      //     animation should better be continued rather than terminated.
      //     So after `useStyle` called, we should change the animation target manually
      //     to continue the effect of the init animation.
      // (2) PENDING: If the previous animation targeted at a `val1`, and currently we need
      //     to update the value to `val2` and no animation declared, should be terminate
      //     the previous animation or just modify the target of the animation?
      //     Therotically That will happen not only on `style` but also on `shape` and
      //     `transfrom` props. But we haven't handle this case at present yet.
      // (3) PENDING: Is it proper to visit `animators` and `targetName`?

      var animators = el.animators;

      for (var i = 0; i < animators.length; i++) {
        var animator = animators[i]; // targetName is the "topKey".

        if (animator.targetName === 'style') {
          animator.changeTarget(el.style);
        }
      }
    }

    el.setStyle(styleOpt);
  }

  if (allPropsFinal) {
    // Not set style here.
    allPropsFinal.style = null; // Set el to the final state firstly.

    allPropsFinal && el.attr(allPropsFinal);
    allPropsFinal.style = styleOpt;
  }
}

function applyPropsTransition(el, elOption, dataIndex, model, // Can be null/undefined
transFromProps) {
  if (transFromProps) {
    var config = getElementAnimationConfig('update', el, elOption, model, dataIndex);

    if (config.duration > 0) {
      el.animateFrom(transFromProps, config);
    }
  }
}

function applyMiscProps(el, elOption) {
  // Merge by default.
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["hasOwn"])(elOption, 'silent') && (el.silent = elOption.silent);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["hasOwn"])(elOption, 'ignore') && (el.ignore = elOption.ignore);

  if (el instanceof __WEBPACK_IMPORTED_MODULE_3_zrender_lib_graphic_Displayable_js__["c" /* default */]) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["hasOwn"])(elOption, 'invisible') && (el.invisible = elOption.invisible);
  }

  if (el instanceof __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["Path"]) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["hasOwn"])(elOption, 'autoBatch') && (el.autoBatch = elOption.autoBatch);
  }
} // Use it to avoid it be exposed to user.


var tmpDuringScope = {};
var transitionDuringAPI = {
  // Usually other props do not need to be changed in animation during.
  setTransform: function (key, val) {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["hasOwn"])(TRANSFORM_PROPS_MAP, key), 'Only ' + transformPropNamesStr + ' available in `setTransform`.');
    }

    tmpDuringScope.el[key] = val;
    return this;
  },
  getTransform: function (key) {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["hasOwn"])(TRANSFORM_PROPS_MAP, key), 'Only ' + transformPropNamesStr + ' available in `getTransform`.');
    }

    return tmpDuringScope.el[key];
  },
  setShape: function (key, val) {
    if (true) {
      assertNotReserved(key);
    }

    var el = tmpDuringScope.el;
    var shape = el.shape || (el.shape = {});
    shape[key] = val;
    el.dirtyShape && el.dirtyShape();
    return this;
  },
  getShape: function (key) {
    if (true) {
      assertNotReserved(key);
    }

    var shape = tmpDuringScope.el.shape;

    if (shape) {
      return shape[key];
    }
  },
  setStyle: function (key, val) {
    if (true) {
      assertNotReserved(key);
    }

    var el = tmpDuringScope.el;
    var style = el.style;

    if (style) {
      if (true) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["eqNaN"])(val)) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_log_js__["b" /* warn */])('style.' + key + ' must not be assigned with NaN.');
        }
      }

      style[key] = val;
      el.dirtyStyle && el.dirtyStyle();
    }

    return this;
  },
  getStyle: function (key) {
    if (true) {
      assertNotReserved(key);
    }

    var style = tmpDuringScope.el.style;

    if (style) {
      return style[key];
    }
  },
  setExtra: function (key, val) {
    if (true) {
      assertNotReserved(key);
    }

    var extra = tmpDuringScope.el.extra || (tmpDuringScope.el.extra = {});
    extra[key] = val;
    return this;
  },
  getExtra: function (key) {
    if (true) {
      assertNotReserved(key);
    }

    var extra = tmpDuringScope.el.extra;

    if (extra) {
      return extra[key];
    }
  }
};

function assertNotReserved(key) {
  if (true) {
    if (key === 'transition' || key === 'enterFrom' || key === 'leaveTo') {
      throw new Error('key must not be "' + key + '"');
    }
  }
}

function duringCall() {
  // Do not provide "percent" until some requirements come.
  // Because consider thies case:
  // enterFrom: {x: 100, y: 30}, transition: 'x'.
  // And enter duration is different from update duration.
  // Thus it might be confused about the meaning of "percent" in during callback.
  var scope = this;
  var el = scope.el;

  if (!el) {
    return;
  } // If el is remove from zr by reason like legend, during still need to called,
  // becuase el will be added back to zr and the prop value should not be incorrect.


  var latestUserDuring = transitionInnerStore(el).userDuring;
  var scopeUserDuring = scope.userDuring; // Ensured a during is only called once in each animation frame.
  // If a during is called multiple times in one frame, maybe some users' calulation logic
  // might be wrong (not sure whether this usage exists).
  // The case of a during might be called twice can be: by default there is a animator for
  // 'x', 'y' when init. Before the init animation finished, call `setOption` to start
  // another animators for 'style'/'shape'/'extra'.

  if (latestUserDuring !== scopeUserDuring) {
    // release
    scope.el = scope.userDuring = null;
    return;
  }

  tmpDuringScope.el = el; // Give no `this` to user in "during" calling.

  scopeUserDuring(transitionDuringAPI); // FIXME: if in future meet the case that some prop will be both modified in `during` and `state`,
  // consider the issue that the prop might be incorrect when return to "normal" state.
}

function prepareShapeOrExtraTransitionFrom(mainAttr, fromEl, elOption, transFromProps) {
  var attrOpt = elOption[mainAttr];

  if (!attrOpt) {
    return;
  }

  var elPropsInAttr = fromEl[mainAttr];
  var transFromPropsInAttr;

  if (elPropsInAttr) {
    var transition = elOption.transition;
    var attrTransition = attrOpt.transition;

    if (attrTransition) {
      !transFromPropsInAttr && (transFromPropsInAttr = transFromProps[mainAttr] = {});

      if (isTransitionAll(attrTransition)) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])(transFromPropsInAttr, elPropsInAttr);
      } else {
        var transitionKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_model_js__["d" /* normalizeToArray */])(attrTransition);

        for (var i = 0; i < transitionKeys.length; i++) {
          var key = transitionKeys[i];
          var elVal = elPropsInAttr[key];
          transFromPropsInAttr[key] = elVal;
        }
      }
    } else if (isTransitionAll(transition) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["indexOf"])(transition, mainAttr) >= 0) {
      !transFromPropsInAttr && (transFromPropsInAttr = transFromProps[mainAttr] = {});
      var elPropsInAttrKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["keys"])(elPropsInAttr);

      for (var i = 0; i < elPropsInAttrKeys.length; i++) {
        var key = elPropsInAttrKeys[i];
        var elVal = elPropsInAttr[key];

        if (isNonStyleTransitionEnabled(attrOpt[key], elVal)) {
          transFromPropsInAttr[key] = elVal;
        }
      }
    }
  }
}

function prepareShapeOrExtraAllPropsFinal(mainAttr, elOption, allProps) {
  var attrOpt = elOption[mainAttr];

  if (!attrOpt) {
    return;
  }

  var allPropsInAttr = allProps[mainAttr] = {};
  var keysInAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["keys"])(attrOpt);

  for (var i = 0; i < keysInAttr.length; i++) {
    var key = keysInAttr[i]; // To avoid share one object with different element, and
    // to avoid user modify the object inexpectedly, have to clone.

    allPropsInAttr[key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_animation_Animator_js__["b" /* cloneValue */])(attrOpt[key]);
  }
}

function prepareTransformTransitionFrom(el, elOption, transFromProps) {
  var transition = elOption.transition;
  var transitionKeys = isTransitionAll(transition) ? __WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_Transformable_js__["b" /* TRANSFORMABLE_PROPS */] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_model_js__["d" /* normalizeToArray */])(transition || []);

  for (var i = 0; i < transitionKeys.length; i++) {
    var key = transitionKeys[i];

    if (key === 'style' || key === 'shape' || key === 'extra') {
      continue;
    }

    var elVal = el[key];

    if (true) {
      checkTransformPropRefer(key, 'el.transition');
    } // Do not clone, animator will perform that clone.


    transFromProps[key] = elVal;
  }
}

function prepareTransformAllPropsFinal(el, elOption, allProps) {
  for (var i = 0; i < LEGACY_TRANSFORM_PROPS.length; i++) {
    var legacyName = LEGACY_TRANSFORM_PROPS[i];
    var xyName = LEGACY_TRANSFORM_PROPS_MAP[legacyName];
    var legacyArr = elOption[legacyName];

    if (legacyArr) {
      allProps[xyName[0]] = legacyArr[0];
      allProps[xyName[1]] = legacyArr[1];
    }
  }

  for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_Transformable_js__["b" /* TRANSFORMABLE_PROPS */].length; i++) {
    var key = __WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_Transformable_js__["b" /* TRANSFORMABLE_PROPS */][i];

    if (elOption[key] != null) {
      allProps[key] = elOption[key];
    }
  }
}

function prepareStyleTransitionFrom(fromEl, elOption, styleOpt, transFromProps) {
  if (!styleOpt) {
    return;
  }

  var fromElStyle = fromEl.style;
  var transFromStyleProps;

  if (fromElStyle) {
    var styleTransition = styleOpt.transition;
    var elTransition = elOption.transition;

    if (styleTransition && !isTransitionAll(styleTransition)) {
      var transitionKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_model_js__["d" /* normalizeToArray */])(styleTransition);
      !transFromStyleProps && (transFromStyleProps = transFromProps.style = {});

      for (var i = 0; i < transitionKeys.length; i++) {
        var key = transitionKeys[i];
        var elVal = fromElStyle[key]; // Do not clone, see `checkNonStyleTansitionRefer`.

        transFromStyleProps[key] = elVal;
      }
    } else if (fromEl.getAnimationStyleProps && (isTransitionAll(elTransition) || isTransitionAll(styleTransition) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["indexOf"])(elTransition, 'style') >= 0)) {
      var animationProps = fromEl.getAnimationStyleProps();
      var animationStyleProps = animationProps ? animationProps.style : null;

      if (animationStyleProps) {
        !transFromStyleProps && (transFromStyleProps = transFromProps.style = {});
        var styleKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["keys"])(styleOpt);

        for (var i = 0; i < styleKeys.length; i++) {
          var key = styleKeys[i];

          if (animationStyleProps[key]) {
            var elVal = fromElStyle[key];
            transFromStyleProps[key] = elVal;
          }
        }
      }
    }
  }
}

function isNonStyleTransitionEnabled(optVal, elVal) {
  // The same as `checkNonStyleTansitionRefer`.
  return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArrayLike"])(optVal) ? optVal != null && isFinite(optVal) : optVal !== elVal;
}

var checkTransformPropRefer;

if (true) {
  checkTransformPropRefer = function (key, usedIn) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["hasOwn"])(TRANSFORM_PROPS_MAP, key)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_log_js__["b" /* warn */])('Prop `' + key + '` is not a permitted in `' + usedIn + '`. ' + 'Only `' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["keys"])(TRANSFORM_PROPS_MAP).join('`, `') + '` are permitted.');
    }
  };
}

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNodeGlobalScale;
/* harmony export (immutable) */ __webpack_exports__["b"] = getSymbolSize;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function getNodeGlobalScale(seriesModel) {
  var coordSys = seriesModel.coordinateSystem;

  if (coordSys.type !== 'view') {
    return 1;
  }

  var nodeScaleRatio = seriesModel.option.nodeScaleRatio;
  var groupZoom = coordSys.scaleX; // Scale node when zoom changes

  var roamZoom = coordSys.getZoom();
  var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
  return nodeScale / groupZoom;
}
function getSymbolSize(node) {
  var symbolSize = node.getVisual('symbolSize');

  if (symbolSize instanceof Array) {
    symbolSize = (symbolSize[0] + symbolSize[1]) / 2;
  }

  return +symbolSize;
}

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_vector_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_symbol_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LinePath_js__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_number_js__ = __webpack_require__(8);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/









var SYMBOL_CATEGORIES = ['fromSymbol', 'toSymbol'];

function makeSymbolTypeKey(symbolCategory) {
  return '_' + symbolCategory + 'Type';
}
/**
 * @inner
 */


function createSymbol(name, lineData, idx) {
  var symbolType = lineData.getItemVisual(idx, name);

  if (!symbolType || symbolType === 'none') {
    return;
  }

  var symbolSize = lineData.getItemVisual(idx, name + 'Size');
  var symbolRotate = lineData.getItemVisual(idx, name + 'Rotate');
  var symbolOffset = lineData.getItemVisual(idx, name + 'Offset');
  var symbolKeepAspect = lineData.getItemVisual(idx, name + 'KeepAspect');
  var symbolSizeArr = __WEBPACK_IMPORTED_MODULE_3__util_symbol_js__["c" /* normalizeSymbolSize */](symbolSize);
  var symbolOffsetArr = __WEBPACK_IMPORTED_MODULE_3__util_symbol_js__["d" /* normalizeSymbolOffset */](symbolOffset || 0, symbolSizeArr);
  var symbolPath = __WEBPACK_IMPORTED_MODULE_3__util_symbol_js__["a" /* createSymbol */](symbolType, -symbolSizeArr[0] / 2 + symbolOffsetArr[0], -symbolSizeArr[1] / 2 + symbolOffsetArr[1], symbolSizeArr[0], symbolSizeArr[1], null, symbolKeepAspect);
  symbolPath.__specifiedRotation = symbolRotate == null || isNaN(symbolRotate) ? void 0 : +symbolRotate * Math.PI / 180 || 0;
  symbolPath.name = name;
  return symbolPath;
}

function createLine(points) {
  var line = new __WEBPACK_IMPORTED_MODULE_4__LinePath_js__["a" /* default */]({
    name: 'line',
    subPixelOptimize: true
  });
  setLinePoints(line.shape, points);
  return line;
}

function setLinePoints(targetShape, points) {
  targetShape.x1 = points[0][0];
  targetShape.y1 = points[0][1];
  targetShape.x2 = points[1][0];
  targetShape.y2 = points[1][1];
  targetShape.percent = 1;
  var cp1 = points[2];

  if (cp1) {
    targetShape.cpx1 = cp1[0];
    targetShape.cpy1 = cp1[1];
  } else {
    targetShape.cpx1 = NaN;
    targetShape.cpy1 = NaN;
  }
}

var Line =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Line, _super);

  function Line(lineData, idx, seriesScope) {
    var _this = _super.call(this) || this;

    _this._createLine(lineData, idx, seriesScope);

    return _this;
  }

  Line.prototype._createLine = function (lineData, idx, seriesScope) {
    var seriesModel = lineData.hostModel;
    var linePoints = lineData.getItemLayout(idx);
    var line = createLine(linePoints);
    line.shape.percent = 0;
    __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["initProps"](line, {
      shape: {
        percent: 1
      }
    }, seriesModel, idx);
    this.add(line);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(SYMBOL_CATEGORIES, function (symbolCategory) {
      var symbol = createSymbol(symbolCategory, lineData, idx); // symbols must added after line to make sure
      // it will be updated after line#update.
      // Or symbol position and rotation update in line#beforeUpdate will be one frame slow

      this.add(symbol);
      this[makeSymbolTypeKey(symbolCategory)] = lineData.getItemVisual(idx, symbolCategory);
    }, this);

    this._updateCommonStl(lineData, idx, seriesScope);
  }; // TODO More strict on the List type in parameters?


  Line.prototype.updateData = function (lineData, idx, seriesScope) {
    var seriesModel = lineData.hostModel;
    var line = this.childOfName('line');
    var linePoints = lineData.getItemLayout(idx);
    var target = {
      shape: {}
    };
    setLinePoints(target.shape, linePoints);
    __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["updateProps"](line, target, seriesModel, idx);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(SYMBOL_CATEGORIES, function (symbolCategory) {
      var symbolType = lineData.getItemVisual(idx, symbolCategory);
      var key = makeSymbolTypeKey(symbolCategory); // Symbol changed

      if (this[key] !== symbolType) {
        this.remove(this.childOfName(symbolCategory));
        var symbol = createSymbol(symbolCategory, lineData, idx);
        this.add(symbol);
      }

      this[key] = symbolType;
    }, this);

    this._updateCommonStl(lineData, idx, seriesScope);
  };

  ;

  Line.prototype.getLinePath = function () {
    return this.childAt(0);
  };

  Line.prototype._updateCommonStl = function (lineData, idx, seriesScope) {
    var seriesModel = lineData.hostModel;
    var line = this.childOfName('line');
    var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
    var blurLineStyle = seriesScope && seriesScope.blurLineStyle;
    var selectLineStyle = seriesScope && seriesScope.selectLineStyle;
    var labelStatesModels = seriesScope && seriesScope.labelStatesModels;
    var emphasisDisabled = seriesScope && seriesScope.emphasisDisabled;
    var focus = seriesScope && seriesScope.focus;
    var blurScope = seriesScope && seriesScope.blurScope; // Optimization for large dataset

    if (!seriesScope || lineData.hasItemOption) {
      var itemModel = lineData.getItemModel(idx);
      var emphasisModel = itemModel.getModel('emphasis');
      emphasisLineStyle = emphasisModel.getModel('lineStyle').getLineStyle();
      blurLineStyle = itemModel.getModel(['blur', 'lineStyle']).getLineStyle();
      selectLineStyle = itemModel.getModel(['select', 'lineStyle']).getLineStyle();
      emphasisDisabled = emphasisModel.get('disabled');
      focus = emphasisModel.get('focus');
      blurScope = emphasisModel.get('blurScope');
      labelStatesModels = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__["f" /* getLabelStatesModels */])(itemModel);
    }

    var lineStyle = lineData.getItemVisual(idx, 'style');
    var visualColor = lineStyle.stroke;
    line.useStyle(lineStyle);
    line.style.fill = null;
    line.style.strokeNoScale = true;
    line.ensureState('emphasis').style = emphasisLineStyle;
    line.ensureState('blur').style = blurLineStyle;
    line.ensureState('select').style = selectLineStyle; // Update symbol

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(SYMBOL_CATEGORIES, function (symbolCategory) {
      var symbol = this.childOfName(symbolCategory);

      if (symbol) {
        // Share opacity and color with line.
        symbol.setColor(visualColor);
        symbol.style.opacity = lineStyle.opacity;

        for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_6__util_states_js__["a" /* SPECIAL_STATES */].length; i++) {
          var stateName = __WEBPACK_IMPORTED_MODULE_6__util_states_js__["a" /* SPECIAL_STATES */][i];
          var lineState = line.getState(stateName);

          if (lineState) {
            var lineStateStyle = lineState.style || {};
            var state = symbol.ensureState(stateName);
            var stateStyle = state.style || (state.style = {});

            if (lineStateStyle.stroke != null) {
              stateStyle[symbol.__isEmptyBrush ? 'stroke' : 'fill'] = lineStateStyle.stroke;
            }

            if (lineStateStyle.opacity != null) {
              stateStyle.opacity = lineStateStyle.opacity;
            }
          }
        }

        symbol.markRedraw();
      }
    }, this);
    var rawVal = seriesModel.getRawValue(idx);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__["e" /* setLabelStyle */])(this, labelStatesModels, {
      labelDataIndex: idx,
      labelFetcher: {
        getFormattedLabel: function (dataIndex, stateName) {
          return seriesModel.getFormattedLabel(dataIndex, stateName, lineData.dataType);
        }
      },
      inheritColor: visualColor || '#000',
      defaultOpacity: lineStyle.opacity,
      defaultText: (rawVal == null ? lineData.getName(idx) : isFinite(rawVal) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_number_js__["d" /* round */])(rawVal) : rawVal) + ''
    });
    var label = this.getTextContent(); // Always set `textStyle` even if `normalStyle.text` is null, because default
    // values have to be set on `normalStyle`.

    if (label) {
      var labelNormalModel = labelStatesModels.normal;
      label.__align = label.style.align;
      label.__verticalAlign = label.style.verticalAlign; // 'start', 'middle', 'end'

      label.__position = labelNormalModel.get('position') || 'middle';
      var distance = labelNormalModel.get('distance');

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(distance)) {
        distance = [distance, distance];
      }

      label.__labelDistance = distance;
    }

    this.setTextConfig({
      position: null,
      local: true,
      inside: false // Can't be inside for stroke element.

    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_states_js__["G" /* toggleHoverEmphasis */])(this, focus, blurScope, emphasisDisabled);
  };

  Line.prototype.highlight = function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_states_js__["j" /* enterEmphasis */])(this);
  };

  Line.prototype.downplay = function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_states_js__["k" /* leaveEmphasis */])(this);
  };

  Line.prototype.updateLayout = function (lineData, idx) {
    this.setLinePoints(lineData.getItemLayout(idx));
  };

  Line.prototype.setLinePoints = function (points) {
    var linePath = this.childOfName('line');
    setLinePoints(linePath.shape, points);
    linePath.dirty();
  };

  Line.prototype.beforeUpdate = function () {
    var lineGroup = this;
    var symbolFrom = lineGroup.childOfName('fromSymbol');
    var symbolTo = lineGroup.childOfName('toSymbol');
    var label = lineGroup.getTextContent(); // Quick reject

    if (!symbolFrom && !symbolTo && (!label || label.ignore)) {
      return;
    }

    var invScale = 1;
    var parentNode = this.parent;

    while (parentNode) {
      if (parentNode.scaleX) {
        invScale /= parentNode.scaleX;
      }

      parentNode = parentNode.parent;
    }

    var line = lineGroup.childOfName('line'); // If line not changed
    // FIXME Parent scale changed

    if (!this.__dirty && !line.__dirty) {
      return;
    }

    var percent = line.shape.percent;
    var fromPos = line.pointAt(0);
    var toPos = line.pointAt(percent);
    var d = __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_vector_js__["sub"]([], toPos, fromPos);
    __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_vector_js__["normalize"](d, d);

    function setSymbolRotation(symbol, percent) {
      // Fix #12388
      // when symbol is set to be 'arrow' in markLine,
      // symbolRotate value will be ignored, and compulsively use tangent angle.
      // rotate by default if symbol rotation is not specified
      var specifiedRotation = symbol.__specifiedRotation;

      if (specifiedRotation == null) {
        var tangent = line.tangentAt(percent);
        symbol.attr('rotation', (percent === 1 ? -1 : 1) * Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
      } else {
        symbol.attr('rotation', specifiedRotation);
      }
    }

    if (symbolFrom) {
      symbolFrom.setPosition(fromPos);
      setSymbolRotation(symbolFrom, 0);
      symbolFrom.scaleX = symbolFrom.scaleY = invScale * percent;
      symbolFrom.markRedraw();
    }

    if (symbolTo) {
      symbolTo.setPosition(toPos);
      setSymbolRotation(symbolTo, 1);
      symbolTo.scaleX = symbolTo.scaleY = invScale * percent;
      symbolTo.markRedraw();
    }

    if (label && !label.ignore) {
      label.x = label.y = 0;
      label.originX = label.originY = 0;
      var textAlign = void 0;
      var textVerticalAlign = void 0;
      var distance = label.__labelDistance;
      var distanceX = distance[0] * invScale;
      var distanceY = distance[1] * invScale;
      var halfPercent = percent / 2;
      var tangent = line.tangentAt(halfPercent);
      var n = [tangent[1], -tangent[0]];
      var cp = line.pointAt(halfPercent);

      if (n[1] > 0) {
        n[0] = -n[0];
        n[1] = -n[1];
      }

      var dir = tangent[0] < 0 ? -1 : 1;

      if (label.__position !== 'start' && label.__position !== 'end') {
        var rotation = -Math.atan2(tangent[1], tangent[0]);

        if (toPos[0] < fromPos[0]) {
          rotation = Math.PI + rotation;
        }

        label.rotation = rotation;
      }

      var dy = void 0;

      switch (label.__position) {
        case 'insideStartTop':
        case 'insideMiddleTop':
        case 'insideEndTop':
        case 'middle':
          dy = -distanceY;
          textVerticalAlign = 'bottom';
          break;

        case 'insideStartBottom':
        case 'insideMiddleBottom':
        case 'insideEndBottom':
          dy = distanceY;
          textVerticalAlign = 'top';
          break;

        default:
          dy = 0;
          textVerticalAlign = 'middle';
      }

      switch (label.__position) {
        case 'end':
          label.x = d[0] * distanceX + toPos[0];
          label.y = d[1] * distanceY + toPos[1];
          textAlign = d[0] > 0.8 ? 'left' : d[0] < -0.8 ? 'right' : 'center';
          textVerticalAlign = d[1] > 0.8 ? 'top' : d[1] < -0.8 ? 'bottom' : 'middle';
          break;

        case 'start':
          label.x = -d[0] * distanceX + fromPos[0];
          label.y = -d[1] * distanceY + fromPos[1];
          textAlign = d[0] > 0.8 ? 'right' : d[0] < -0.8 ? 'left' : 'center';
          textVerticalAlign = d[1] > 0.8 ? 'bottom' : d[1] < -0.8 ? 'top' : 'middle';
          break;

        case 'insideStartTop':
        case 'insideStart':
        case 'insideStartBottom':
          label.x = distanceX * dir + fromPos[0];
          label.y = fromPos[1] + dy;
          textAlign = tangent[0] < 0 ? 'right' : 'left';
          label.originX = -distanceX * dir;
          label.originY = -dy;
          break;

        case 'insideMiddleTop':
        case 'insideMiddle':
        case 'insideMiddleBottom':
        case 'middle':
          label.x = cp[0];
          label.y = cp[1] + dy;
          textAlign = 'center';
          label.originY = -dy;
          break;

        case 'insideEndTop':
        case 'insideEnd':
        case 'insideEndBottom':
          label.x = -distanceX * dir + toPos[0];
          label.y = toPos[1] + dy;
          textAlign = tangent[0] >= 0 ? 'right' : 'left';
          label.originX = distanceX * dir;
          label.originY = -dy;
          break;
      }

      label.scaleX = label.scaleY = invScale;
      label.setStyle({
        // Use the user specified text align and baseline first
        verticalAlign: label.__verticalAlign || textVerticalAlign,
        align: label.__align || textAlign
      });
    }
  };

  return Line;
}(__WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["Group"]);

/* harmony default export */ __webpack_exports__["a"] = (Line);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Line_js__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__label_labelStyle_js__ = __webpack_require__(15);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var LineDraw =
/** @class */
function () {
  function LineDraw(LineCtor) {
    this.group = new __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Group"]();
    this._LineCtor = LineCtor || __WEBPACK_IMPORTED_MODULE_1__Line_js__["a" /* default */];
  }

  LineDraw.prototype.updateData = function (lineData) {
    var _this = this; // Remove progressive els.


    this._progressiveEls = null;
    var lineDraw = this;
    var group = lineDraw.group;
    var oldLineData = lineDraw._lineData;
    lineDraw._lineData = lineData; // There is no oldLineData only when first rendering or switching from
    // stream mode to normal mode, where previous elements should be removed.

    if (!oldLineData) {
      group.removeAll();
    }

    var seriesScope = makeSeriesScope(lineData);
    lineData.diff(oldLineData).add(function (idx) {
      _this._doAdd(lineData, idx, seriesScope);
    }).update(function (newIdx, oldIdx) {
      _this._doUpdate(oldLineData, lineData, oldIdx, newIdx, seriesScope);
    }).remove(function (idx) {
      group.remove(oldLineData.getItemGraphicEl(idx));
    }).execute();
  };

  ;

  LineDraw.prototype.updateLayout = function () {
    var lineData = this._lineData; // Do not support update layout in incremental mode.

    if (!lineData) {
      return;
    }

    lineData.eachItemGraphicEl(function (el, idx) {
      el.updateLayout(lineData, idx);
    }, this);
  };

  ;

  LineDraw.prototype.incrementalPrepareUpdate = function (lineData) {
    this._seriesScope = makeSeriesScope(lineData);
    this._lineData = null;
    this.group.removeAll();
  };

  ;

  LineDraw.prototype.incrementalUpdate = function (taskParams, lineData) {
    this._progressiveEls = [];

    function updateIncrementalAndHover(el) {
      if (!el.isGroup && !isEffectObject(el)) {
        el.incremental = true;
        el.ensureState('emphasis').hoverLayer = true;
      }
    }

    for (var idx = taskParams.start; idx < taskParams.end; idx++) {
      var itemLayout = lineData.getItemLayout(idx);

      if (lineNeedsDraw(itemLayout)) {
        var el = new this._LineCtor(lineData, idx, this._seriesScope);
        el.traverse(updateIncrementalAndHover);
        this.group.add(el);
        lineData.setItemGraphicEl(idx, el);

        this._progressiveEls.push(el);
      }
    }
  };

  ;

  LineDraw.prototype.remove = function () {
    this.group.removeAll();
  };

  ;

  LineDraw.prototype.eachRendered = function (cb) {
    __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["traverseElements"](this._progressiveEls || this.group, cb);
  };

  LineDraw.prototype._doAdd = function (lineData, idx, seriesScope) {
    var itemLayout = lineData.getItemLayout(idx);

    if (!lineNeedsDraw(itemLayout)) {
      return;
    }

    var el = new this._LineCtor(lineData, idx, seriesScope);
    lineData.setItemGraphicEl(idx, el);
    this.group.add(el);
  };

  LineDraw.prototype._doUpdate = function (oldLineData, newLineData, oldIdx, newIdx, seriesScope) {
    var itemEl = oldLineData.getItemGraphicEl(oldIdx);

    if (!lineNeedsDraw(newLineData.getItemLayout(newIdx))) {
      this.group.remove(itemEl);
      return;
    }

    if (!itemEl) {
      itemEl = new this._LineCtor(newLineData, newIdx, seriesScope);
    } else {
      itemEl.updateData(newLineData, newIdx, seriesScope);
    }

    newLineData.setItemGraphicEl(newIdx, itemEl);
    this.group.add(itemEl);
  };

  return LineDraw;
}();

function isEffectObject(el) {
  return el.animators && el.animators.length > 0;
}

function makeSeriesScope(lineData) {
  var hostModel = lineData.hostModel;
  var emphasisModel = hostModel.getModel('emphasis');
  return {
    lineStyle: hostModel.getModel('lineStyle').getLineStyle(),
    emphasisLineStyle: emphasisModel.getModel(['lineStyle']).getLineStyle(),
    blurLineStyle: hostModel.getModel(['blur', 'lineStyle']).getLineStyle(),
    selectLineStyle: hostModel.getModel(['select', 'lineStyle']).getLineStyle(),
    emphasisDisabled: emphasisModel.get('disabled'),
    blurScope: emphasisModel.get('blurScope'),
    focus: emphasisModel.get('focus'),
    labelStatesModels: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__label_labelStyle_js__["f" /* getLabelStatesModels */])(hostModel)
  };
}

function isPointNaN(pt) {
  return isNaN(pt[0]) || isNaN(pt[1]);
}

function lineNeedsDraw(pts) {
  return pts && !isPointNaN(pts[0]) && !isPointNaN(pts[1]);
}

/* harmony default export */ __webpack_exports__["a"] = (LineDraw);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modelHelper_js__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_event_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_throttle_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






var inner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_model_js__["a" /* makeInner */])();
var clone = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["clone"];
var bind = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["bind"];
/**
 * Base axis pointer class in 2D.
 */

var BaseAxisPointer =
/** @class */
function () {
  function BaseAxisPointer() {
    this._dragging = false;
    /**
     * In px, arbitrary value. Do not set too small,
     * no animation is ok for most cases.
     */

    this.animationThreshold = 15;
  }
  /**
   * @implement
   */


  BaseAxisPointer.prototype.render = function (axisModel, axisPointerModel, api, forceRender) {
    var value = axisPointerModel.get('value');
    var status = axisPointerModel.get('status'); // Bind them to `this`, not in closure, otherwise they will not
    // be replaced when user calling setOption in not merge mode.

    this._axisModel = axisModel;
    this._axisPointerModel = axisPointerModel;
    this._api = api; // Optimize: `render` will be called repeatly during mouse move.
    // So it is power consuming if performing `render` each time,
    // especially on mobile device.

    if (!forceRender && this._lastValue === value && this._lastStatus === status) {
      return;
    }

    this._lastValue = value;
    this._lastStatus = status;
    var group = this._group;
    var handle = this._handle;

    if (!status || status === 'hide') {
      // Do not clear here, for animation better.
      group && group.hide();
      handle && handle.hide();
      return;
    }

    group && group.show();
    handle && handle.show(); // Otherwise status is 'show'

    var elOption = {};
    this.makeElOption(elOption, value, axisModel, axisPointerModel, api); // Enable change axis pointer type.

    var graphicKey = elOption.graphicKey;

    if (graphicKey !== this._lastGraphicKey) {
      this.clear(api);
    }

    this._lastGraphicKey = graphicKey;
    var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);

    if (!group) {
      group = this._group = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Group"]();
      this.createPointerEl(group, elOption, axisModel, axisPointerModel);
      this.createLabelEl(group, elOption, axisModel, axisPointerModel);
      api.getZr().add(group);
    } else {
      var doUpdateProps = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["curry"](updateProps, axisPointerModel, moveAnimation);
      this.updatePointerEl(group, elOption, doUpdateProps);
      this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
    }

    updateMandatoryProps(group, axisPointerModel, true);

    this._renderHandle(value);
  };
  /**
   * @implement
   */


  BaseAxisPointer.prototype.remove = function (api) {
    this.clear(api);
  };
  /**
   * @implement
   */


  BaseAxisPointer.prototype.dispose = function (api) {
    this.clear(api);
  };
  /**
   * @protected
   */


  BaseAxisPointer.prototype.determineAnimation = function (axisModel, axisPointerModel) {
    var animation = axisPointerModel.get('animation');
    var axis = axisModel.axis;
    var isCategoryAxis = axis.type === 'category';
    var useSnap = axisPointerModel.get('snap'); // Value axis without snap always do not snap.

    if (!useSnap && !isCategoryAxis) {
      return false;
    }

    if (animation === 'auto' || animation == null) {
      var animationThreshold = this.animationThreshold;

      if (isCategoryAxis && axis.getBandWidth() > animationThreshold) {
        return true;
      } // It is important to auto animation when snap used. Consider if there is
      // a dataZoom, animation will be disabled when too many points exist, while
      // it will be enabled for better visual effect when little points exist.


      if (useSnap) {
        var seriesDataCount = __WEBPACK_IMPORTED_MODULE_2__modelHelper_js__["c" /* getAxisInfo */](axisModel).seriesDataCount;
        var axisExtent = axis.getExtent(); // Approximate band width

        return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
      }

      return false;
    }

    return animation === true;
  };
  /**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */


  BaseAxisPointer.prototype.makeElOption = function (elOption, value, axisModel, axisPointerModel, api) {// Shoule be implemenented by sub-class.
  };
  /**
   * @protected
   */


  BaseAxisPointer.prototype.createPointerEl = function (group, elOption, axisModel, axisPointerModel) {
    var pointerOption = elOption.pointer;

    if (pointerOption) {
      var pointerEl = inner(group).pointerEl = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__[pointerOption.type](clone(elOption.pointer));
      group.add(pointerEl);
    }
  };
  /**
   * @protected
   */


  BaseAxisPointer.prototype.createLabelEl = function (group, elOption, axisModel, axisPointerModel) {
    if (elOption.label) {
      var labelEl = inner(group).labelEl = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Text"](clone(elOption.label));
      group.add(labelEl);
      updateLabelShowHide(labelEl, axisPointerModel);
    }
  };
  /**
   * @protected
   */


  BaseAxisPointer.prototype.updatePointerEl = function (group, elOption, updateProps) {
    var pointerEl = inner(group).pointerEl;

    if (pointerEl && elOption.pointer) {
      pointerEl.setStyle(elOption.pointer.style);
      updateProps(pointerEl, {
        shape: elOption.pointer.shape
      });
    }
  };
  /**
   * @protected
   */


  BaseAxisPointer.prototype.updateLabelEl = function (group, elOption, updateProps, axisPointerModel) {
    var labelEl = inner(group).labelEl;

    if (labelEl) {
      labelEl.setStyle(elOption.label.style);
      updateProps(labelEl, {
        // Consider text length change in vertical axis, animation should
        // be used on shape, otherwise the effect will be weird.
        // TODOTODO
        // shape: elOption.label.shape,
        x: elOption.label.x,
        y: elOption.label.y
      });
      updateLabelShowHide(labelEl, axisPointerModel);
    }
  };
  /**
   * @private
   */


  BaseAxisPointer.prototype._renderHandle = function (value) {
    if (this._dragging || !this.updateHandleTransform) {
      return;
    }

    var axisPointerModel = this._axisPointerModel;

    var zr = this._api.getZr();

    var handle = this._handle;
    var handleModel = axisPointerModel.getModel('handle');
    var status = axisPointerModel.get('status');

    if (!handleModel.get('show') || !status || status === 'hide') {
      handle && zr.remove(handle);
      this._handle = null;
      return;
    }

    var isInit;

    if (!this._handle) {
      isInit = true;
      handle = this._handle = __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["createIcon"](handleModel.get('icon'), {
        cursor: 'move',
        draggable: true,
        onmousemove: function (e) {
          // Fot mobile devicem, prevent screen slider on the button.
          __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_event_js__["a" /* stop */](e.event);
        },
        onmousedown: bind(this._onHandleDragMove, this, 0, 0),
        drift: bind(this._onHandleDragMove, this),
        ondragend: bind(this._onHandleDragEnd, this)
      });
      zr.add(handle);
    }

    updateMandatoryProps(handle, axisPointerModel, false); // update style

    handle.setStyle(handleModel.getItemStyle(null, ['color', 'borderColor', 'borderWidth', 'opacity', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY'])); // update position

    var handleSize = handleModel.get('size');

    if (!__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](handleSize)) {
      handleSize = [handleSize, handleSize];
    }

    handle.scaleX = handleSize[0] / 2;
    handle.scaleY = handleSize[1] / 2;
    __WEBPACK_IMPORTED_MODULE_4__util_throttle_js__["a" /* createOrUpdate */](this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');

    this._moveHandleToValue(value, isInit);
  };

  BaseAxisPointer.prototype._moveHandleToValue = function (value, isInit) {
    updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
  };

  BaseAxisPointer.prototype._onHandleDragMove = function (dx, dy) {
    var handle = this._handle;

    if (!handle) {
      return;
    }

    this._dragging = true; // Persistent for throttle.

    var trans = this.updateHandleTransform(getHandleTransProps(handle), [dx, dy], this._axisModel, this._axisPointerModel);
    this._payloadInfo = trans;
    handle.stopAnimation();
    handle.attr(getHandleTransProps(trans));
    inner(handle).lastProp = null;

    this._doDispatchAxisPointer();
  };
  /**
   * Throttled method.
   */


  BaseAxisPointer.prototype._doDispatchAxisPointer = function () {
    var handle = this._handle;

    if (!handle) {
      return;
    }

    var payloadInfo = this._payloadInfo;
    var axisModel = this._axisModel;

    this._api.dispatchAction({
      type: 'updateAxisPointer',
      x: payloadInfo.cursorPoint[0],
      y: payloadInfo.cursorPoint[1],
      tooltipOption: payloadInfo.tooltipOption,
      axesInfo: [{
        axisDim: axisModel.axis.dim,
        axisIndex: axisModel.componentIndex
      }]
    });
  };

  BaseAxisPointer.prototype._onHandleDragEnd = function () {
    this._dragging = false;
    var handle = this._handle;

    if (!handle) {
      return;
    }

    var value = this._axisPointerModel.get('value'); // Consider snap or categroy axis, handle may be not consistent with
    // axisPointer. So move handle to align the exact value position when
    // drag ended.


    this._moveHandleToValue(value); // For the effect: tooltip will be shown when finger holding on handle
    // button, and will be hidden after finger left handle button.


    this._api.dispatchAction({
      type: 'hideTip'
    });
  };
  /**
   * @private
   */


  BaseAxisPointer.prototype.clear = function (api) {
    this._lastValue = null;
    this._lastStatus = null;
    var zr = api.getZr();
    var group = this._group;
    var handle = this._handle;

    if (zr && group) {
      this._lastGraphicKey = null;
      group && zr.remove(group);
      handle && zr.remove(handle);
      this._group = null;
      this._handle = null;
      this._payloadInfo = null;
    }

    __WEBPACK_IMPORTED_MODULE_4__util_throttle_js__["b" /* clear */](this, '_doDispatchAxisPointer');
  };
  /**
   * @protected
   */


  BaseAxisPointer.prototype.doClear = function () {// Implemented by sub-class if necessary.
  };

  BaseAxisPointer.prototype.buildLabel = function (xy, wh, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
      x: xy[xDimIndex],
      y: xy[1 - xDimIndex],
      width: wh[xDimIndex],
      height: wh[1 - xDimIndex]
    };
  };

  return BaseAxisPointer;
}();

function updateProps(animationModel, moveAnimation, el, props) {
  // Animation optimize.
  if (!propsEqual(inner(el).lastProp, props)) {
    inner(el).lastProp = props;
    moveAnimation ? __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["updateProps"](el, props, animationModel) : (el.stopAnimation(), el.attr(props));
  }
}

function propsEqual(lastProps, newProps) {
  if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"](lastProps) && __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"](newProps)) {
    var equals_1 = true;
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](newProps, function (item, key) {
      equals_1 = equals_1 && propsEqual(lastProps[key], item);
    });
    return !!equals_1;
  } else {
    return lastProps === newProps;
  }
}

function updateLabelShowHide(labelEl, axisPointerModel) {
  labelEl[axisPointerModel.get(['label', 'show']) ? 'show' : 'hide']();
}

function getHandleTransProps(trans) {
  return {
    x: trans.x || 0,
    y: trans.y || 0,
    rotation: trans.rotation || 0
  };
}

function updateMandatoryProps(group, axisPointerModel, silent) {
  var z = axisPointerModel.get('z');
  var zlevel = axisPointerModel.get('zlevel');
  group && group.traverse(function (el) {
    if (el.type !== 'group') {
      z != null && (el.z = z);
      zlevel != null && (el.zlevel = zlevel);
      el.silent = silent;
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (BaseAxisPointer);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_Component_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_js__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






var DataZoomAxisInfo =
/** @class */
function () {
  function DataZoomAxisInfo() {
    this.indexList = [];
    this.indexMap = [];
  }

  DataZoomAxisInfo.prototype.add = function (axisCmptIdx) {
    // Remove duplication.
    if (!this.indexMap[axisCmptIdx]) {
      this.indexList.push(axisCmptIdx);
      this.indexMap[axisCmptIdx] = true;
    }
  };

  return DataZoomAxisInfo;
}();

var DataZoomModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(DataZoomModel, _super);

  function DataZoomModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = DataZoomModel.type;
    _this._autoThrottle = true;
    _this._noTarget = true;
    /**
     * It is `[rangeModeForMin, rangeModeForMax]`.
     * The optional values for `rangeMode`:
     * + `'value'` mode: the axis extent will always be determined by
     *     `dataZoom.startValue` and `dataZoom.endValue`, despite
     *     how data like and how `axis.min` and `axis.max` are.
     * + `'percent'` mode: `100` represents 100% of the `[dMin, dMax]`,
     *     where `dMin` is `axis.min` if `axis.min` specified, otherwise `data.extent[0]`,
     *     and `dMax` is `axis.max` if `axis.max` specified, otherwise `data.extent[1]`.
     *     Axis extent will be determined by the result of the percent of `[dMin, dMax]`.
     *
     * For example, when users are using dynamic data (update data periodically via `setOption`),
     * if in `'value`' mode, the window will be kept in a fixed value range despite how
     * data are appended, while if in `'percent'` mode, whe window range will be changed alone with
     * the appended data (suppose `axis.min` and `axis.max` are not specified).
     */

    _this._rangePropMode = ['percent', 'percent'];
    return _this;
  }

  DataZoomModel.prototype.init = function (option, parentModel, ecModel) {
    var inputRawOption = retrieveRawOption(option);
    /**
     * Suppose a "main process" start at the point that model prepared (that is,
     * model initialized or merged or method called in `action`).
     * We should keep the `main process` idempotent, that is, given a set of values
     * on `option`, we get the same result.
     *
     * But sometimes, values on `option` will be updated for providing users
     * a "final calculated value" (`dataZoomProcessor` will do that). Those value
     * should not be the base/input of the `main process`.
     *
     * So in that case we should save and keep the input of the `main process`
     * separately, called `settledOption`.
     *
     * For example, consider the case:
     * (Step_1) brush zoom the grid by `toolbox.dataZoom`,
     *     where the original input `option.startValue`, `option.endValue` are earsed by
     *     calculated value.
     * (Step)2) click the legend to hide and show a series,
     *     where the new range is calculated by the earsed `startValue` and `endValue`,
     *     which brings incorrect result.
     */

    this.settledOption = inputRawOption;
    this.mergeDefaultAndTheme(option, ecModel);

    this._doInit(inputRawOption);
  };

  DataZoomModel.prototype.mergeOption = function (newOption) {
    var inputRawOption = retrieveRawOption(newOption); //FIX #2591

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"])(this.option, newOption, true);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"])(this.settledOption, inputRawOption, true);

    this._doInit(inputRawOption);
  };

  DataZoomModel.prototype._doInit = function (inputRawOption) {
    var thisOption = this.option;

    this._setDefaultThrottle(inputRawOption);

    this._updateRangeUse(inputRawOption);

    var settledOption = this.settledOption;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
      // start/end has higher priority over startValue/endValue if they
      // both set, but we should make chart.setOption({endValue: 1000})
      // effective, rather than chart.setOption({endValue: 1000, end: null}).
      if (this._rangePropMode[index] === 'value') {
        thisOption[names[0]] = settledOption[names[0]] = null;
      } // Otherwise do nothing and use the merge result.

    }, this);

    this._resetTarget();
  };

  DataZoomModel.prototype._resetTarget = function () {
    var optionOrient = this.get('orient', true);
    var targetAxisIndexMap = this._targetAxisInfoMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"])();

    var hasAxisSpecified = this._fillSpecifiedTargetAxis(targetAxisIndexMap);

    if (hasAxisSpecified) {
      this._orient = optionOrient || this._makeAutoOrientByTargetAxis();
    } else {
      this._orient = optionOrient || 'horizontal';

      this._fillAutoTargetAxisByOrient(targetAxisIndexMap, this._orient);
    }

    this._noTarget = true;
    targetAxisIndexMap.each(function (axisInfo) {
      if (axisInfo.indexList.length) {
        this._noTarget = false;
      }
    }, this);
  };

  DataZoomModel.prototype._fillSpecifiedTargetAxis = function (targetAxisIndexMap) {
    var hasAxisSpecified = false;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(__WEBPACK_IMPORTED_MODULE_3__helper_js__["e" /* DATA_ZOOM_AXIS_DIMENSIONS */], function (axisDim) {
      var refering = this.getReferringComponents(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_js__["b" /* getAxisMainType */])(axisDim), __WEBPACK_IMPORTED_MODULE_4__util_model_js__["k" /* MULTIPLE_REFERRING */]); // When user set axisIndex as a empty array, we think that user specify axisIndex
      // but do not want use auto mode. Because empty array may be encountered when
      // some error occured.

      if (!refering.specified) {
        return;
      }

      hasAxisSpecified = true;
      var axisInfo = new DataZoomAxisInfo();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(refering.models, function (axisModel) {
        axisInfo.add(axisModel.componentIndex);
      });
      targetAxisIndexMap.set(axisDim, axisInfo);
    }, this);
    return hasAxisSpecified;
  };

  DataZoomModel.prototype._fillAutoTargetAxisByOrient = function (targetAxisIndexMap, orient) {
    var ecModel = this.ecModel;
    var needAuto = true; // Find axis that parallel to dataZoom as default.

    if (needAuto) {
      var axisDim = orient === 'vertical' ? 'y' : 'x';
      var axisModels = ecModel.findComponents({
        mainType: axisDim + 'Axis'
      });
      setParallelAxis(axisModels, axisDim);
    } // Find axis that parallel to dataZoom as default.


    if (needAuto) {
      var axisModels = ecModel.findComponents({
        mainType: 'singleAxis',
        filter: function (axisModel) {
          return axisModel.get('orient', true) === orient;
        }
      });
      setParallelAxis(axisModels, 'single');
    }

    function setParallelAxis(axisModels, axisDim) {
      // At least use the first parallel axis as the target axis.
      var axisModel = axisModels[0];

      if (!axisModel) {
        return;
      }

      var axisInfo = new DataZoomAxisInfo();
      axisInfo.add(axisModel.componentIndex);
      targetAxisIndexMap.set(axisDim, axisInfo);
      needAuto = false; // Find parallel axes in the same grid.

      if (axisDim === 'x' || axisDim === 'y') {
        var gridModel_1 = axisModel.getReferringComponents('grid', __WEBPACK_IMPORTED_MODULE_4__util_model_js__["i" /* SINGLE_REFERRING */]).models[0];
        gridModel_1 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(axisModels, function (axModel) {
          if (axisModel.componentIndex !== axModel.componentIndex && gridModel_1 === axModel.getReferringComponents('grid', __WEBPACK_IMPORTED_MODULE_4__util_model_js__["i" /* SINGLE_REFERRING */]).models[0]) {
            axisInfo.add(axModel.componentIndex);
          }
        });
      }
    }

    if (needAuto) {
      // If no parallel axis, find the first category axis as default. (Also consider polar).
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(__WEBPACK_IMPORTED_MODULE_3__helper_js__["e" /* DATA_ZOOM_AXIS_DIMENSIONS */], function (axisDim) {
        if (!needAuto) {
          return;
        }

        var axisModels = ecModel.findComponents({
          mainType: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_js__["b" /* getAxisMainType */])(axisDim),
          filter: function (axisModel) {
            return axisModel.get('type', true) === 'category';
          }
        });

        if (axisModels[0]) {
          var axisInfo = new DataZoomAxisInfo();
          axisInfo.add(axisModels[0].componentIndex);
          targetAxisIndexMap.set(axisDim, axisInfo);
          needAuto = false;
        }
      }, this);
    }
  };

  DataZoomModel.prototype._makeAutoOrientByTargetAxis = function () {
    var dim; // Find the first axis

    this.eachTargetAxis(function (axisDim) {
      !dim && (dim = axisDim);
    }, this);
    return dim === 'y' ? 'vertical' : 'horizontal';
  };

  DataZoomModel.prototype._setDefaultThrottle = function (inputRawOption) {
    // When first time user set throttle, auto throttle ends.
    if (inputRawOption.hasOwnProperty('throttle')) {
      this._autoThrottle = false;
    }

    if (this._autoThrottle) {
      var globalOption = this.ecModel.option;
      this.option.throttle = globalOption.animation && globalOption.animationDurationUpdate > 0 ? 100 : 20;
    }
  };

  DataZoomModel.prototype._updateRangeUse = function (inputRawOption) {
    var rangePropMode = this._rangePropMode;
    var rangeModeInOption = this.get('rangeMode');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
      var percentSpecified = inputRawOption[names[0]] != null;
      var valueSpecified = inputRawOption[names[1]] != null;

      if (percentSpecified && !valueSpecified) {
        rangePropMode[index] = 'percent';
      } else if (!percentSpecified && valueSpecified) {
        rangePropMode[index] = 'value';
      } else if (rangeModeInOption) {
        rangePropMode[index] = rangeModeInOption[index];
      } else if (percentSpecified) {
        // percentSpecified && valueSpecified
        rangePropMode[index] = 'percent';
      } // else remain its original setting.

    });
  };

  DataZoomModel.prototype.noTarget = function () {
    return this._noTarget;
  };

  DataZoomModel.prototype.getFirstTargetAxisModel = function () {
    var firstAxisModel;
    this.eachTargetAxis(function (axisDim, axisIndex) {
      if (firstAxisModel == null) {
        firstAxisModel = this.ecModel.getComponent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_js__["b" /* getAxisMainType */])(axisDim), axisIndex);
      }
    }, this);
    return firstAxisModel;
  };
  /**
   * @param {Function} callback param: axisModel, dimNames, axisIndex, dataZoomModel, ecModel
   */


  DataZoomModel.prototype.eachTargetAxis = function (callback, context) {
    this._targetAxisInfoMap.each(function (axisInfo, axisDim) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(axisInfo.indexList, function (axisIndex) {
        callback.call(context, axisDim, axisIndex);
      });
    });
  };
  /**
   * @return If not found, return null/undefined.
   */


  DataZoomModel.prototype.getAxisProxy = function (axisDim, axisIndex) {
    var axisModel = this.getAxisModel(axisDim, axisIndex);

    if (axisModel) {
      return axisModel.__dzAxisProxy;
    }
  };
  /**
   * @return If not found, return null/undefined.
   */


  DataZoomModel.prototype.getAxisModel = function (axisDim, axisIndex) {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"])(axisDim && axisIndex != null);
    }

    var axisInfo = this._targetAxisInfoMap.get(axisDim);

    if (axisInfo && axisInfo.indexMap[axisIndex]) {
      return this.ecModel.getComponent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_js__["b" /* getAxisMainType */])(axisDim), axisIndex);
    }
  };
  /**
   * If not specified, set to undefined.
   */


  DataZoomModel.prototype.setRawRange = function (opt) {
    var thisOption = this.option;
    var settledOption = this.settledOption;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])([['start', 'startValue'], ['end', 'endValue']], function (names) {
      // Consider the pair <start, startValue>:
      // If one has value and the other one is `null/undefined`, we both set them
      // to `settledOption`. This strategy enables the feature to clear the original
      // value in `settledOption` to `null/undefined`.
      // But if both of them are `null/undefined`, we do not set them to `settledOption`
      // and keep `settledOption` with the original value. This strategy enables users to
      // only set <end or endValue> but not set <start or startValue> when calling
      // `dispatchAction`.
      // The pair <end, endValue> is treated in the same way.
      if (opt[names[0]] != null || opt[names[1]] != null) {
        thisOption[names[0]] = settledOption[names[0]] = opt[names[0]];
        thisOption[names[1]] = settledOption[names[1]] = opt[names[1]];
      }
    }, this);

    this._updateRangeUse(opt);
  };

  DataZoomModel.prototype.setCalculatedRange = function (opt) {
    var option = this.option;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(['start', 'startValue', 'end', 'endValue'], function (name) {
      option[name] = opt[name];
    });
  };

  DataZoomModel.prototype.getPercentRange = function () {
    var axisProxy = this.findRepresentativeAxisProxy();

    if (axisProxy) {
      return axisProxy.getDataPercentWindow();
    }
  };
  /**
   * For example, chart.getModel().getComponent('dataZoom').getValueRange('y', 0);
   *
   * @return [startValue, endValue] value can only be '-' or finite number.
   */


  DataZoomModel.prototype.getValueRange = function (axisDim, axisIndex) {
    if (axisDim == null && axisIndex == null) {
      var axisProxy = this.findRepresentativeAxisProxy();

      if (axisProxy) {
        return axisProxy.getDataValueWindow();
      }
    } else {
      return this.getAxisProxy(axisDim, axisIndex).getDataValueWindow();
    }
  };
  /**
   * @param axisModel If axisModel given, find axisProxy
   *      corresponding to the axisModel
   */


  DataZoomModel.prototype.findRepresentativeAxisProxy = function (axisModel) {
    if (axisModel) {
      return axisModel.__dzAxisProxy;
    } // Find the first hosted axisProxy


    var firstProxy;

    var axisDimList = this._targetAxisInfoMap.keys();

    for (var i = 0; i < axisDimList.length; i++) {
      var axisDim = axisDimList[i];

      var axisInfo = this._targetAxisInfoMap.get(axisDim);

      for (var j = 0; j < axisInfo.indexList.length; j++) {
        var proxy = this.getAxisProxy(axisDim, axisInfo.indexList[j]);

        if (proxy.hostedBy(this)) {
          return proxy;
        }

        if (!firstProxy) {
          firstProxy = proxy;
        }
      }
    } // If no hosted proxy found, still need to return a proxy.
    // This case always happens in toolbox dataZoom, where axes are all hosted by
    // other dataZooms.


    return firstProxy;
  };

  DataZoomModel.prototype.getRangePropMode = function () {
    return this._rangePropMode.slice();
  };

  DataZoomModel.prototype.getOrient = function () {
    if (true) {
      // Should not be called before initialized.
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"])(this._orient);
    }

    return this._orient;
  };

  DataZoomModel.type = 'dataZoom';
  DataZoomModel.dependencies = ['xAxis', 'yAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'series', 'toolbox'];
  DataZoomModel.defaultOption = {
    // zlevel: 0,
    z: 4,
    filterMode: 'filter',
    start: 0,
    end: 100
  };
  return DataZoomModel;
}(__WEBPACK_IMPORTED_MODULE_2__model_Component_js__["a" /* default */]);
/**
 * Retrieve the those raw params from option, which will be cached separately.
 * becasue they will be overwritten by normalized/calculated values in the main
 * process.
 */


function retrieveRawOption(option) {
  var ret = {};
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(['start', 'end', 'startValue', 'endValue', 'throttle'], function (name) {
    option.hasOwnProperty(name) && (ret[name] = option[name]);
  });
  return ret;
}

/* harmony default export */ __webpack_exports__["a"] = (DataZoomModel);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_Component_js__ = __webpack_require__(30);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var DataZoomView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(DataZoomView, _super);

  function DataZoomView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = DataZoomView.type;
    return _this;
  }

  DataZoomView.prototype.render = function (dataZoomModel, ecModel, api, payload) {
    this.dataZoomModel = dataZoomModel;
    this.ecModel = ecModel;
    this.api = api;
  };

  DataZoomView.type = 'dataZoom';
  return DataZoomView;
}(__WEBPACK_IMPORTED_MODULE_1__view_Component_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (DataZoomView);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = installCommon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dataZoomProcessor_js__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dataZoomAction_js__ = __webpack_require__(1222);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


var installed = false;
function installCommon(registers) {
  if (installed) {
    return;
  }

  installed = true;
  registers.registerProcessor(registers.PRIORITY.PROCESSOR.FILTER, __WEBPACK_IMPORTED_MODULE_0__dataZoomProcessor_js__["a" /* default */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dataZoomAction_js__["a" /* default */])(registers);
  registers.registerSubTypeDefaulter('dataZoom', function () {
    // Default 'slider' when no type specified.
    return 'slider';
  });
}

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_Component_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__coord_cartesian_GridModel_js__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__coord_cartesian_AxisModel_js__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__coord_axisModelCreator_js__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__coord_cartesian_Grid_js__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__axis_CartesianAxisView_js__ = __webpack_require__(1197);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/








 // Grid view

var GridView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(GridView, _super);

  function GridView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = 'grid';
    return _this;
  }

  GridView.prototype.render = function (gridModel, ecModel) {
    this.group.removeAll();

    if (gridModel.get('show')) {
      this.group.add(new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Rect"]({
        shape: gridModel.coordinateSystem.getRect(),
        style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["defaults"])({
          fill: gridModel.get('backgroundColor')
        }, gridModel.getItemStyle()),
        silent: true,
        z2: -1
      }));
    }
  };

  GridView.type = 'grid';
  return GridView;
}(__WEBPACK_IMPORTED_MODULE_1__view_Component_js__["a" /* default */]);

var extraOption = {
  // gridIndex: 0,
  // gridId: '',
  offset: 0
};
function install(registers) {
  registers.registerComponentView(GridView);
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_2__coord_cartesian_GridModel_js__["a" /* default */]);
  registers.registerCoordinateSystem('cartesian2d', __WEBPACK_IMPORTED_MODULE_7__coord_cartesian_Grid_js__["a" /* default */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__coord_axisModelCreator_js__["a" /* default */])(registers, 'x', __WEBPACK_IMPORTED_MODULE_5__coord_cartesian_AxisModel_js__["a" /* CartesianAxisModel */], extraOption);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__coord_axisModelCreator_js__["a" /* default */])(registers, 'y', __WEBPACK_IMPORTED_MODULE_5__coord_cartesian_AxisModel_js__["a" /* CartesianAxisModel */], extraOption);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_8__axis_CartesianAxisView_js__["a" /* CartesianXAxisView */]);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_8__axis_CartesianAxisView_js__["b" /* CartesianYAxisView */]);
  registers.registerPreprocessor(function (option) {
    // Only create grid when need
    if (option.xAxis && option.yAxis && !option.grid) {
      option.grid = {};
    }
  });
}

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_Eventful_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__interactionMutex_js__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_DataDiffer_js__ = __webpack_require__(113);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






var BRUSH_PANEL_GLOBAL = true;
var mathMin = Math.min;
var mathMax = Math.max;
var mathPow = Math.pow;
var COVER_Z = 10000;
var UNSELECT_THRESHOLD = 6;
var MIN_RESIZE_LINE_WIDTH = 6;
var MUTEX_RESOURCE_KEY = 'globalPan';
var DIRECTION_MAP = {
  w: [0, 0],
  e: [0, 1],
  n: [1, 0],
  s: [1, 1]
};
var CURSOR_MAP = {
  w: 'ew',
  e: 'ew',
  n: 'ns',
  s: 'ns',
  ne: 'nesw',
  sw: 'nesw',
  nw: 'nwse',
  se: 'nwse'
};
var DEFAULT_BRUSH_OPT = {
  brushStyle: {
    lineWidth: 2,
    stroke: 'rgba(210,219,238,0.3)',
    fill: '#D2DBEE'
  },
  transformable: true,
  brushMode: 'single',
  removeOnClick: false
};
var baseUID = 0;
/**
 * params:
 *     areas: Array.<Array>, coord relates to container group,
 *                             If no container specified, to global.
 *     opt {
 *         isEnd: boolean,
 *         removeOnClick: boolean
 *     }
 */

var BrushController =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(BrushController, _super);

  function BrushController(zr) {
    var _this = _super.call(this) || this;
    /**
     * @internal
     */


    _this._track = [];
    /**
     * @internal
     */

    _this._covers = [];
    _this._handlers = {};

    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"])(zr);
    }

    _this._zr = zr;
    _this.group = new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Group"]();
    _this._uid = 'brushController_' + baseUID++;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(pointerHandlers, function (handler, eventName) {
      this._handlers[eventName] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(handler, this);
    }, _this);
    return _this;
  }
  /**
   * If set to `false`, select disabled.
   */


  BrushController.prototype.enableBrush = function (brushOption) {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"])(this._mounted);
    }

    this._brushType && this._doDisableBrush();
    brushOption.brushType && this._doEnableBrush(brushOption);
    return this;
  };

  BrushController.prototype._doEnableBrush = function (brushOption) {
    var zr = this._zr; // Consider roam, which takes globalPan too.

    if (!this._enableGlobalPan) {
      __WEBPACK_IMPORTED_MODULE_4__interactionMutex_js__["b" /* take */](zr, MUTEX_RESOURCE_KEY, this._uid);
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(this._handlers, function (handler, eventName) {
      zr.on(eventName, handler);
    });
    this._brushType = brushOption.brushType;
    this._brushOption = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"])(DEFAULT_BRUSH_OPT), brushOption, true);
  };

  BrushController.prototype._doDisableBrush = function () {
    var zr = this._zr;
    __WEBPACK_IMPORTED_MODULE_4__interactionMutex_js__["c" /* release */](zr, MUTEX_RESOURCE_KEY, this._uid);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(this._handlers, function (handler, eventName) {
      zr.off(eventName, handler);
    });
    this._brushType = this._brushOption = null;
  };
  /**
   * @param panelOpts If not pass, it is global brush.
   */


  BrushController.prototype.setPanels = function (panelOpts) {
    if (panelOpts && panelOpts.length) {
      var panels_1 = this._panels = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(panelOpts, function (panelOpts) {
        panels_1[panelOpts.panelId] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"])(panelOpts);
      });
    } else {
      this._panels = null;
    }

    return this;
  };

  BrushController.prototype.mount = function (opt) {
    opt = opt || {};

    if (true) {
      this._mounted = true; // should be at first.
    }

    this._enableGlobalPan = opt.enableGlobalPan;
    var thisGroup = this.group;

    this._zr.add(thisGroup);

    thisGroup.attr({
      x: opt.x || 0,
      y: opt.y || 0,
      rotation: opt.rotation || 0,
      scaleX: opt.scaleX || 1,
      scaleY: opt.scaleY || 1
    });
    this._transform = thisGroup.getLocalTransform();
    return this;
  }; // eachCover(cb, context): void {
  //     each(this._covers, cb, context);
  // }

  /**
   * Update covers.
   * @param coverConfigList
   *        If coverConfigList is null/undefined, all covers removed.
   */


  BrushController.prototype.updateCovers = function (coverConfigList) {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"])(this._mounted);
    }

    coverConfigList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"])(coverConfigList, function (coverConfig) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"])(DEFAULT_BRUSH_OPT), coverConfig, true);
    });
    var tmpIdPrefix = '\0-brush-index-';
    var oldCovers = this._covers;
    var newCovers = this._covers = [];
    var controller = this;
    var creatingCover = this._creatingCover;
    new __WEBPACK_IMPORTED_MODULE_5__data_DataDiffer_js__["a" /* default */](oldCovers, coverConfigList, oldGetKey, getKey).add(addOrUpdate).update(addOrUpdate).remove(remove).execute();
    return this;

    function getKey(brushOption, index) {
      return (brushOption.id != null ? brushOption.id : tmpIdPrefix + index) + '-' + brushOption.brushType;
    }

    function oldGetKey(cover, index) {
      return getKey(cover.__brushOption, index);
    }

    function addOrUpdate(newIndex, oldIndex) {
      var newBrushInternal = coverConfigList[newIndex]; // Consider setOption in event listener of brushSelect,
      // where updating cover when creating should be forbiden.

      if (oldIndex != null && oldCovers[oldIndex] === creatingCover) {
        newCovers[newIndex] = oldCovers[oldIndex];
      } else {
        var cover = newCovers[newIndex] = oldIndex != null ? (oldCovers[oldIndex].__brushOption = newBrushInternal, oldCovers[oldIndex]) : endCreating(controller, createCover(controller, newBrushInternal));
        updateCoverAfterCreation(controller, cover);
      }
    }

    function remove(oldIndex) {
      if (oldCovers[oldIndex] !== creatingCover) {
        controller.group.remove(oldCovers[oldIndex]);
      }
    }
  };

  BrushController.prototype.unmount = function () {
    if (true) {
      if (!this._mounted) {
        return;
      }
    }

    this.enableBrush(false); // container may 'removeAll' outside.

    clearCovers(this);

    this._zr.remove(this.group);

    if (true) {
      this._mounted = false; // should be at last.
    }

    return this;
  };

  BrushController.prototype.dispose = function () {
    this.unmount();
    this.off();
  };

  return BrushController;
}(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_Eventful_js__["a" /* default */]);

function createCover(controller, brushOption) {
  var cover = coverRenderers[brushOption.brushType].createCover(controller, brushOption);
  cover.__brushOption = brushOption;
  updateZ(cover, brushOption);
  controller.group.add(cover);
  return cover;
}

function endCreating(controller, creatingCover) {
  var coverRenderer = getCoverRenderer(creatingCover);

  if (coverRenderer.endCreating) {
    coverRenderer.endCreating(controller, creatingCover);
    updateZ(creatingCover, creatingCover.__brushOption);
  }

  return creatingCover;
}

function updateCoverShape(controller, cover) {
  var brushOption = cover.__brushOption;
  getCoverRenderer(cover).updateCoverShape(controller, cover, brushOption.range, brushOption);
}

function updateZ(cover, brushOption) {
  var z = brushOption.z;
  z == null && (z = COVER_Z);
  cover.traverse(function (el) {
    el.z = z;
    el.z2 = z; // Consider in given container.
  });
}

function updateCoverAfterCreation(controller, cover) {
  getCoverRenderer(cover).updateCommon(controller, cover);
  updateCoverShape(controller, cover);
}

function getCoverRenderer(cover) {
  return coverRenderers[cover.__brushOption.brushType];
} // return target panel or `true` (means global panel)


function getPanelByPoint(controller, e, localCursorPoint) {
  var panels = controller._panels;

  if (!panels) {
    return BRUSH_PANEL_GLOBAL; // Global panel
  }

  var panel;
  var transform = controller._transform;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(panels, function (pn) {
    pn.isTargetByCursor(e, localCursorPoint, transform) && (panel = pn);
  });
  return panel;
} // Return a panel or true


function getPanelByCover(controller, cover) {
  var panels = controller._panels;

  if (!panels) {
    return BRUSH_PANEL_GLOBAL; // Global panel
  }

  var panelId = cover.__brushOption.panelId; // User may give cover without coord sys info,
  // which is then treated as global panel.

  return panelId != null ? panels[panelId] : BRUSH_PANEL_GLOBAL;
}

function clearCovers(controller) {
  var covers = controller._covers;
  var originalLength = covers.length;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(covers, function (cover) {
    controller.group.remove(cover);
  }, controller);
  covers.length = 0;
  return !!originalLength;
}

function trigger(controller, opt) {
  var areas = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"])(controller._covers, function (cover) {
    var brushOption = cover.__brushOption;
    var range = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"])(brushOption.range);
    return {
      brushType: brushOption.brushType,
      panelId: brushOption.panelId,
      range: range
    };
  });
  controller.trigger('brush', {
    areas: areas,
    isEnd: !!opt.isEnd,
    removeOnClick: !!opt.removeOnClick
  });
}

function shouldShowCover(controller) {
  var track = controller._track;

  if (!track.length) {
    return false;
  }

  var p2 = track[track.length - 1];
  var p1 = track[0];
  var dx = p2[0] - p1[0];
  var dy = p2[1] - p1[1];
  var dist = mathPow(dx * dx + dy * dy, 0.5);
  return dist > UNSELECT_THRESHOLD;
}

function getTrackEnds(track) {
  var tail = track.length - 1;
  tail < 0 && (tail = 0);
  return [track[0], track[tail]];
}

;

function createBaseRectCover(rectRangeConverter, controller, brushOption, edgeNameSequences) {
  var cover = new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Group"]();
  cover.add(new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Rect"]({
    name: 'main',
    style: makeStyle(brushOption),
    silent: true,
    draggable: true,
    cursor: 'move',
    drift: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["curry"])(driftRect, rectRangeConverter, controller, cover, ['n', 's', 'w', 'e']),
    ondragend: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["curry"])(trigger, controller, {
      isEnd: true
    })
  }));
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(edgeNameSequences, function (nameSequence) {
    cover.add(new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Rect"]({
      name: nameSequence.join(''),
      style: {
        opacity: 0
      },
      draggable: true,
      silent: true,
      invisible: true,
      drift: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["curry"])(driftRect, rectRangeConverter, controller, cover, nameSequence),
      ondragend: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["curry"])(trigger, controller, {
        isEnd: true
      })
    }));
  });
  return cover;
}

function updateBaseRect(controller, cover, localRange, brushOption) {
  var lineWidth = brushOption.brushStyle.lineWidth || 0;
  var handleSize = mathMax(lineWidth, MIN_RESIZE_LINE_WIDTH);
  var x = localRange[0][0];
  var y = localRange[1][0];
  var xa = x - lineWidth / 2;
  var ya = y - lineWidth / 2;
  var x2 = localRange[0][1];
  var y2 = localRange[1][1];
  var x2a = x2 - handleSize + lineWidth / 2;
  var y2a = y2 - handleSize + lineWidth / 2;
  var width = x2 - x;
  var height = y2 - y;
  var widtha = width + lineWidth;
  var heighta = height + lineWidth;
  updateRectShape(controller, cover, 'main', x, y, width, height);

  if (brushOption.transformable) {
    updateRectShape(controller, cover, 'w', xa, ya, handleSize, heighta);
    updateRectShape(controller, cover, 'e', x2a, ya, handleSize, heighta);
    updateRectShape(controller, cover, 'n', xa, ya, widtha, handleSize);
    updateRectShape(controller, cover, 's', xa, y2a, widtha, handleSize);
    updateRectShape(controller, cover, 'nw', xa, ya, handleSize, handleSize);
    updateRectShape(controller, cover, 'ne', x2a, ya, handleSize, handleSize);
    updateRectShape(controller, cover, 'sw', xa, y2a, handleSize, handleSize);
    updateRectShape(controller, cover, 'se', x2a, y2a, handleSize, handleSize);
  }
}

function updateCommon(controller, cover) {
  var brushOption = cover.__brushOption;
  var transformable = brushOption.transformable;
  var mainEl = cover.childAt(0);
  mainEl.useStyle(makeStyle(brushOption));
  mainEl.attr({
    silent: !transformable,
    cursor: transformable ? 'move' : 'default'
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])([['w'], ['e'], ['n'], ['s'], ['s', 'e'], ['s', 'w'], ['n', 'e'], ['n', 'w']], function (nameSequence) {
    var el = cover.childOfName(nameSequence.join(''));
    var globalDir = nameSequence.length === 1 ? getGlobalDirection1(controller, nameSequence[0]) : getGlobalDirection2(controller, nameSequence);
    el && el.attr({
      silent: !transformable,
      invisible: !transformable,
      cursor: transformable ? CURSOR_MAP[globalDir] + '-resize' : null
    });
  });
}

function updateRectShape(controller, cover, name, x, y, w, h) {
  var el = cover.childOfName(name);
  el && el.setShape(pointsToRect(clipByPanel(controller, cover, [[x, y], [x + w, y + h]])));
}

function makeStyle(brushOption) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"])({
    strokeNoScale: true
  }, brushOption.brushStyle);
}

function formatRectRange(x, y, x2, y2) {
  var min = [mathMin(x, x2), mathMin(y, y2)];
  var max = [mathMax(x, x2), mathMax(y, y2)];
  return [[min[0], max[0]], [min[1], max[1]] // y range
  ];
}

function getTransform(controller) {
  return __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["getTransform"](controller.group);
}

function getGlobalDirection1(controller, localDirName) {
  var map = {
    w: 'left',
    e: 'right',
    n: 'top',
    s: 'bottom'
  };
  var inverseMap = {
    left: 'w',
    right: 'e',
    top: 'n',
    bottom: 's'
  };
  var dir = __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["transformDirection"](map[localDirName], getTransform(controller));
  return inverseMap[dir];
}

function getGlobalDirection2(controller, localDirNameSeq) {
  var globalDir = [getGlobalDirection1(controller, localDirNameSeq[0]), getGlobalDirection1(controller, localDirNameSeq[1])];
  (globalDir[0] === 'e' || globalDir[0] === 'w') && globalDir.reverse();
  return globalDir.join('');
}

function driftRect(rectRangeConverter, controller, cover, dirNameSequence, dx, dy) {
  var brushOption = cover.__brushOption;
  var rectRange = rectRangeConverter.toRectRange(brushOption.range);
  var localDelta = toLocalDelta(controller, dx, dy);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(dirNameSequence, function (dirName) {
    var ind = DIRECTION_MAP[dirName];
    rectRange[ind[0]][ind[1]] += localDelta[ind[0]];
  });
  brushOption.range = rectRangeConverter.fromRectRange(formatRectRange(rectRange[0][0], rectRange[1][0], rectRange[0][1], rectRange[1][1]));
  updateCoverAfterCreation(controller, cover);
  trigger(controller, {
    isEnd: false
  });
}

function driftPolygon(controller, cover, dx, dy) {
  var range = cover.__brushOption.range;
  var localDelta = toLocalDelta(controller, dx, dy);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(range, function (point) {
    point[0] += localDelta[0];
    point[1] += localDelta[1];
  });
  updateCoverAfterCreation(controller, cover);
  trigger(controller, {
    isEnd: false
  });
}

function toLocalDelta(controller, dx, dy) {
  var thisGroup = controller.group;
  var localD = thisGroup.transformCoordToLocal(dx, dy);
  var localZero = thisGroup.transformCoordToLocal(0, 0);
  return [localD[0] - localZero[0], localD[1] - localZero[1]];
}

function clipByPanel(controller, cover, data) {
  var panel = getPanelByCover(controller, cover);
  return panel && panel !== BRUSH_PANEL_GLOBAL ? panel.clipPath(data, controller._transform) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"])(data);
}

function pointsToRect(points) {
  var xmin = mathMin(points[0][0], points[1][0]);
  var ymin = mathMin(points[0][1], points[1][1]);
  var xmax = mathMax(points[0][0], points[1][0]);
  var ymax = mathMax(points[0][1], points[1][1]);
  return {
    x: xmin,
    y: ymin,
    width: xmax - xmin,
    height: ymax - ymin
  };
}

function resetCursor(controller, e, localCursorPoint) {
  if ( // Check active
  !controller._brushType // resetCursor should be always called when mouse is in zr area,
  // but not called when mouse is out of zr area to avoid bad influence
  // if `mousemove`, `mouseup` are triggered from `document` event.
  || isOutsideZrArea(controller, e.offsetX, e.offsetY)) {
    return;
  }

  var zr = controller._zr;
  var covers = controller._covers;
  var currPanel = getPanelByPoint(controller, e, localCursorPoint); // Check whether in covers.

  if (!controller._dragging) {
    for (var i = 0; i < covers.length; i++) {
      var brushOption = covers[i].__brushOption;

      if (currPanel && (currPanel === BRUSH_PANEL_GLOBAL || brushOption.panelId === currPanel.panelId) && coverRenderers[brushOption.brushType].contain(covers[i], localCursorPoint[0], localCursorPoint[1])) {
        // Use cursor style set on cover.
        return;
      }
    }
  }

  currPanel && zr.setCursorStyle('crosshair');
}

function preventDefault(e) {
  var rawE = e.event;
  rawE.preventDefault && rawE.preventDefault();
}

function mainShapeContain(cover, x, y) {
  return cover.childOfName('main').contain(x, y);
}

function updateCoverByMouse(controller, e, localCursorPoint, isEnd) {
  var creatingCover = controller._creatingCover;
  var panel = controller._creatingPanel;
  var thisBrushOption = controller._brushOption;
  var eventParams;

  controller._track.push(localCursorPoint.slice());

  if (shouldShowCover(controller) || creatingCover) {
    if (panel && !creatingCover) {
      thisBrushOption.brushMode === 'single' && clearCovers(controller);
      var brushOption = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"])(thisBrushOption);
      brushOption.brushType = determineBrushType(brushOption.brushType, panel);
      brushOption.panelId = panel === BRUSH_PANEL_GLOBAL ? null : panel.panelId;
      creatingCover = controller._creatingCover = createCover(controller, brushOption);

      controller._covers.push(creatingCover);
    }

    if (creatingCover) {
      var coverRenderer = coverRenderers[determineBrushType(controller._brushType, panel)];
      var coverBrushOption = creatingCover.__brushOption;
      coverBrushOption.range = coverRenderer.getCreatingRange(clipByPanel(controller, creatingCover, controller._track));

      if (isEnd) {
        endCreating(controller, creatingCover);
        coverRenderer.updateCommon(controller, creatingCover);
      }

      updateCoverShape(controller, creatingCover);
      eventParams = {
        isEnd: isEnd
      };
    }
  } else if (isEnd && thisBrushOption.brushMode === 'single' && thisBrushOption.removeOnClick) {
    // Help user to remove covers easily, only by a tiny drag, in 'single' mode.
    // But a single click do not clear covers, because user may have casual
    // clicks (for example, click on other component and do not expect covers
    // disappear).
    // Only some cover removed, trigger action, but not every click trigger action.
    if (getPanelByPoint(controller, e, localCursorPoint) && clearCovers(controller)) {
      eventParams = {
        isEnd: isEnd,
        removeOnClick: true
      };
    }
  }

  return eventParams;
}

function determineBrushType(brushType, panel) {
  if (brushType === 'auto') {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"])(panel && panel.defaultBrushType, 'MUST have defaultBrushType when brushType is "atuo"');
    }

    return panel.defaultBrushType;
  }

  return brushType;
}

var pointerHandlers = {
  mousedown: function (e) {
    if (this._dragging) {
      // In case some browser do not support globalOut,
      // and release mouse out side the browser.
      handleDragEnd(this, e);
    } else if (!e.target || !e.target.draggable) {
      preventDefault(e);
      var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
      this._creatingCover = null;
      var panel = this._creatingPanel = getPanelByPoint(this, e, localCursorPoint);

      if (panel) {
        this._dragging = true;
        this._track = [localCursorPoint.slice()];
      }
    }
  },
  mousemove: function (e) {
    var x = e.offsetX;
    var y = e.offsetY;
    var localCursorPoint = this.group.transformCoordToLocal(x, y);
    resetCursor(this, e, localCursorPoint);

    if (this._dragging) {
      preventDefault(e);
      var eventParams = updateCoverByMouse(this, e, localCursorPoint, false);
      eventParams && trigger(this, eventParams);
    }
  },
  mouseup: function (e) {
    handleDragEnd(this, e);
  }
};

function handleDragEnd(controller, e) {
  if (controller._dragging) {
    preventDefault(e);
    var x = e.offsetX;
    var y = e.offsetY;
    var localCursorPoint = controller.group.transformCoordToLocal(x, y);
    var eventParams = updateCoverByMouse(controller, e, localCursorPoint, true);
    controller._dragging = false;
    controller._track = [];
    controller._creatingCover = null; // trigger event shoule be at final, after procedure will be nested.

    eventParams && trigger(controller, eventParams);
  }
}

function isOutsideZrArea(controller, x, y) {
  var zr = controller._zr;
  return x < 0 || x > zr.getWidth() || y < 0 || y > zr.getHeight();
}
/**
 * key: brushType
 */


var coverRenderers = {
  lineX: getLineRenderer(0),
  lineY: getLineRenderer(1),
  rect: {
    createCover: function (controller, brushOption) {
      function returnInput(range) {
        return range;
      }

      return createBaseRectCover({
        toRectRange: returnInput,
        fromRectRange: returnInput
      }, controller, brushOption, [['w'], ['e'], ['n'], ['s'], ['s', 'e'], ['s', 'w'], ['n', 'e'], ['n', 'w']]);
    },
    getCreatingRange: function (localTrack) {
      var ends = getTrackEnds(localTrack);
      return formatRectRange(ends[1][0], ends[1][1], ends[0][0], ends[0][1]);
    },
    updateCoverShape: function (controller, cover, localRange, brushOption) {
      updateBaseRect(controller, cover, localRange, brushOption);
    },
    updateCommon: updateCommon,
    contain: mainShapeContain
  },
  polygon: {
    createCover: function (controller, brushOption) {
      var cover = new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Group"](); // Do not use graphic.Polygon because graphic.Polyline do not close the
      // border of the shape when drawing, which is a better experience for user.

      cover.add(new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Polyline"]({
        name: 'main',
        style: makeStyle(brushOption),
        silent: true
      }));
      return cover;
    },
    getCreatingRange: function (localTrack) {
      return localTrack;
    },
    endCreating: function (controller, cover) {
      cover.remove(cover.childAt(0)); // Use graphic.Polygon close the shape.

      cover.add(new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Polygon"]({
        name: 'main',
        draggable: true,
        drift: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["curry"])(driftPolygon, controller, cover),
        ondragend: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["curry"])(trigger, controller, {
          isEnd: true
        })
      }));
    },
    updateCoverShape: function (controller, cover, localRange, brushOption) {
      cover.childAt(0).setShape({
        points: clipByPanel(controller, cover, localRange)
      });
    },
    updateCommon: updateCommon,
    contain: mainShapeContain
  }
};

function getLineRenderer(xyIndex) {
  return {
    createCover: function (controller, brushOption) {
      return createBaseRectCover({
        toRectRange: function (range) {
          var rectRange = [range, [0, 100]];
          xyIndex && rectRange.reverse();
          return rectRange;
        },
        fromRectRange: function (rectRange) {
          return rectRange[xyIndex];
        }
      }, controller, brushOption, [[['w'], ['e']], [['n'], ['s']]][xyIndex]);
    },
    getCreatingRange: function (localTrack) {
      var ends = getTrackEnds(localTrack);
      var min = mathMin(ends[0][xyIndex], ends[1][xyIndex]);
      var max = mathMax(ends[0][xyIndex], ends[1][xyIndex]);
      return [min, max];
    },
    updateCoverShape: function (controller, cover, localRange, brushOption) {
      var otherExtent; // If brushWidth not specified, fit the panel.

      var panel = getPanelByCover(controller, cover);

      if (panel !== BRUSH_PANEL_GLOBAL && panel.getLinearBrushOtherExtent) {
        otherExtent = panel.getLinearBrushOtherExtent(xyIndex);
      } else {
        var zr = controller._zr;
        otherExtent = [0, [zr.getWidth(), zr.getHeight()][1 - xyIndex]];
      }

      var rectRange = [localRange, otherExtent];
      xyIndex && rectRange.reverse();
      updateBaseRect(controller, cover, rectRange, brushOption);
    },
    updateCommon: updateCommon,
    contain: mainShapeContain
  };
}

/* harmony default export */ __webpack_exports__["a"] = (BrushController);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateViewOnPan;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateViewOnZoom;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * For geo and graph.
 */
function updateViewOnPan(controllerHost, dx, dy) {
  var target = controllerHost.target;
  target.x += dx;
  target.y += dy;
  target.dirty();
}
/**
 * For geo and graph.
 */

function updateViewOnZoom(controllerHost, zoomDelta, zoomX, zoomY) {
  var target = controllerHost.target;
  var zoomLimit = controllerHost.zoomLimit;
  var newZoom = controllerHost.zoom = controllerHost.zoom || 1;
  newZoom *= zoomDelta;

  if (zoomLimit) {
    var zoomMin = zoomLimit.min || 0;
    var zoomMax = zoomLimit.max || Infinity;
    newZoom = Math.max(Math.min(zoomMax, newZoom), zoomMin);
  }

  var zoomScale = newZoom / controllerHost.zoom;
  controllerHost.zoom = newZoom; // Keep the mouse center when scaling

  target.x -= (zoomX - target.x) * (zoomScale - 1);
  target.y -= (zoomY - target.y) * (zoomScale - 1);
  target.scaleX *= zoomScale;
  target.scaleY *= zoomScale;
  target.dirty();
}

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LegendModel_js__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LegendView_js__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__legendFilter_js__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__legendAction_js__ = __webpack_require__(1235);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




function install(registers) {
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_0__LegendModel_js__["a" /* default */]);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_1__LegendView_js__["a" /* default */]);
  registers.registerProcessor(registers.PRIORITY.PROCESSOR.SERIES_FILTER, __WEBPACK_IMPORTED_MODULE_2__legendFilter_js__["a" /* default */]);
  registers.registerSubTypeDefaulter('legend', function () {
    return 'plain';
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__legendAction_js__["a" /* installLegendAction */])(registers);
}

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_Component_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MarkerModel_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_states_js__ = __webpack_require__(12);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






var inner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_model_js__["a" /* makeInner */])();

var MarkerView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(MarkerView, _super);

  function MarkerView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = MarkerView.type;
    return _this;
  }

  MarkerView.prototype.init = function () {
    this.markerGroupMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["createHashMap"])();
  };

  MarkerView.prototype.render = function (markerModel, ecModel, api) {
    var _this = this;

    var markerGroupMap = this.markerGroupMap;
    markerGroupMap.each(function (item) {
      inner(item).keep = false;
    });
    ecModel.eachSeries(function (seriesModel) {
      var markerModel = __WEBPACK_IMPORTED_MODULE_3__MarkerModel_js__["a" /* default */].getMarkerModelFromSeries(seriesModel, _this.type);
      markerModel && _this.renderSeries(seriesModel, markerModel, ecModel, api);
    });
    markerGroupMap.each(function (item) {
      !inner(item).keep && _this.group.remove(item.group);
    });
  };

  MarkerView.prototype.markKeep = function (drawGroup) {
    inner(drawGroup).keep = true;
  };

  MarkerView.prototype.toggleBlurSeries = function (seriesModelList, isBlur) {
    var _this = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(seriesModelList, function (seriesModel) {
      var markerModel = __WEBPACK_IMPORTED_MODULE_3__MarkerModel_js__["a" /* default */].getMarkerModelFromSeries(seriesModel, _this.type);

      if (markerModel) {
        var data = markerModel.getData();
        data.eachItemGraphicEl(function (el) {
          if (el) {
            isBlur ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_states_js__["w" /* enterBlur */])(el) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_states_js__["x" /* leaveBlur */])(el);
          }
        });
      }
    });
  };

  MarkerView.type = 'marker';
  return MarkerView;
}(__WEBPACK_IMPORTED_MODULE_1__view_Component_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MarkerView);

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = checkMarkerInSeries;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

function checkMarkerInSeries(seriesOpts, markerType) {
  if (!seriesOpts) {
    return false;
  }

  var seriesOptArr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"])(seriesOpts) ? seriesOpts : [seriesOpts];

  for (var idx = 0; idx < seriesOptArr.length; idx++) {
    if (seriesOptArr[idx] && seriesOptArr[idx][markerType]) {
      return true;
    }
  }

  return false;
}

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dataTransform;
/* harmony export (immutable) */ __webpack_exports__["c"] = getAxisInfo;
/* harmony export (immutable) */ __webpack_exports__["b"] = dataFilter;
/* harmony export (immutable) */ __webpack_exports__["e"] = createMarkerDimValueGetter;
/* harmony export (immutable) */ __webpack_exports__["d"] = numCalculate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_helper_dataStackHelper_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_helper_dataValueHelper_js__ = __webpack_require__(134);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





function hasXOrY(item) {
  return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
}

function hasXAndY(item) {
  return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
}

function markerTypeCalculatorWithExtent(markerType, data, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
  var coordArr = [];
  var stacked = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__data_helper_dataStackHelper_js__["b" /* isDimensionStacked */])(data, targetDataDim
  /*, otherDataDim*/
  );
  var calcDataDim = stacked ? data.getCalculationInfo('stackResultDimension') : targetDataDim;
  var value = numCalculate(data, calcDataDim, markerType);
  var dataIndex = data.indicesOfNearest(calcDataDim, value)[0];
  coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex);
  coordArr[targetCoordIndex] = data.get(calcDataDim, dataIndex);
  var coordArrValue = data.get(targetDataDim, dataIndex); // Make it simple, do not visit all stacked value to count precision.

  var precision = __WEBPACK_IMPORTED_MODULE_0__util_number_js__["e" /* getPrecision */](data.get(targetDataDim, dataIndex));
  precision = Math.min(precision, 20);

  if (precision >= 0) {
    coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
  }

  return [coordArr, coordArrValue];
} // TODO Specified percent


var markerTypeCalculator = {
  min: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["curry"])(markerTypeCalculatorWithExtent, 'min'),
  max: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["curry"])(markerTypeCalculatorWithExtent, 'max'),
  average: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["curry"])(markerTypeCalculatorWithExtent, 'average'),
  median: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["curry"])(markerTypeCalculatorWithExtent, 'median')
};
/**
 * Transform markPoint data item to format used in List by do the following
 * 1. Calculate statistic like `max`, `min`, `average`
 * 2. Convert `item.xAxis`, `item.yAxis` to `item.coord` array
 */

function dataTransform(seriesModel, item) {
  var data = seriesModel.getData();
  var coordSys = seriesModel.coordinateSystem; // 1. If not specify the position with pixel directly
  // 2. If `coord` is not a data array. Which uses `xAxis`,
  // `yAxis` to specify the coord on each dimension
  // parseFloat first because item.x and item.y can be percent string like '20%'

  if (item && !hasXAndY(item) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isArray"])(item.coord) && coordSys) {
    var dims = coordSys.dimensions;
    var axisInfo = getAxisInfo(item, data, coordSys, seriesModel); // Clone the option
    // Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value

    item = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["clone"])(item);

    if (item.type && markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
      var otherCoordIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["indexOf"])(dims, axisInfo.baseAxis.dim);
      var targetCoordIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["indexOf"])(dims, axisInfo.valueAxis.dim);
      var coordInfo = markerTypeCalculator[item.type](data, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex);
      item.coord = coordInfo[0]; // Force to use the value of calculated value.
      // let item use the value without stack.

      item.value = coordInfo[1];
    } else {
      // FIXME Only has one of xAxis and yAxis.
      var coord = [item.xAxis != null ? item.xAxis : item.radiusAxis, item.yAxis != null ? item.yAxis : item.angleAxis]; // Each coord support max, min, average

      for (var i = 0; i < 2; i++) {
        if (markerTypeCalculator[coord[i]]) {
          coord[i] = numCalculate(data, data.mapDimension(dims[i]), coord[i]);
        }
      }

      item.coord = coord;
    }
  }

  return item;
}
function getAxisInfo(item, data, coordSys, seriesModel) {
  var ret = {};

  if (item.valueIndex != null || item.valueDim != null) {
    ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
    ret.valueAxis = coordSys.getAxis(dataDimToCoordDim(seriesModel, ret.valueDataDim));
    ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
    ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
  } else {
    ret.baseAxis = seriesModel.getBaseAxis();
    ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
    ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
    ret.valueDataDim = data.mapDimension(ret.valueAxis.dim);
  }

  return ret;
}

function dataDimToCoordDim(seriesModel, dataDim) {
  var dimItem = seriesModel.getData().getDimensionInfo(dataDim);
  return dimItem && dimItem.coordDim;
}
/**
 * Filter data which is out of coordinateSystem range
 * [dataFilter description]
 */


function dataFilter( // Currently only polar and cartesian has containData.
coordSys, item) {
  // Alwalys return true if there is no coordSys
  return coordSys && coordSys.containData && item.coord && !hasXOrY(item) ? coordSys.containData(item.coord) : true;
}
function createMarkerDimValueGetter(inCoordSys, dims) {
  return inCoordSys ? function (item, dimName, dataIndex, dimIndex) {
    var rawVal = dimIndex < 2 // x, y, radius, angle
    ? item.coord && item.coord[dimIndex] : item.value;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_helper_dataValueHelper_js__["b" /* parseDataValue */])(rawVal, dims[dimIndex]);
  } : function (item, dimName, dataIndex, dimIndex) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_helper_dataValueHelper_js__["b" /* parseDataValue */])(item.value, dims[dimIndex]);
  };
}
function numCalculate(data, valueDataDim, type) {
  if (type === 'average') {
    var sum_1 = 0;
    var count_1 = 0;
    data.each(valueDataDim, function (val, idx) {
      if (!isNaN(val)) {
        sum_1 += val;
        count_1++;
      }
    });
    return sum_1 / count_1;
  } else if (type === 'median') {
    return data.getMedian(valueDataDim);
  } else {
    // max & min
    return data.getDataExtent(valueDataDim)[type === 'max' ? 1 : 0];
  }
}

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = layout;
/* harmony export (immutable) */ __webpack_exports__["b"] = isCartesian2DSeries;
/* harmony export (immutable) */ __webpack_exports__["c"] = findAxisModels;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * Can only be called after coordinate system creation stage.
 * (Can be called before coordinate system update stage).
 */

function layout(gridModel, axisModel, opt) {
  opt = opt || {};
  var grid = gridModel.coordinateSystem;
  var axis = axisModel.axis;
  var layout = {};
  var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
  var rawAxisPosition = axis.position;
  var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
  var axisDim = axis.dim;
  var rect = grid.getRect();
  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
  var idx = {
    left: 0,
    right: 1,
    top: 0,
    bottom: 1,
    onZero: 2
  };
  var axisOffset = axisModel.get('offset') || 0;
  var posBound = axisDim === 'x' ? [rectBound[2] - axisOffset, rectBound[3] + axisOffset] : [rectBound[0] - axisOffset, rectBound[1] + axisOffset];

  if (otherAxisOnZeroOf) {
    var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
    posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
  } // Axis position


  layout.position = [axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0], axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]]; // Axis rotation

  layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1); // Tick and label direction, x y is axisDim

  var dirMap = {
    top: -1,
    bottom: 1,
    left: -1,
    right: 1
  };
  layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
  layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;

  if (axisModel.get(['axisTick', 'inside'])) {
    layout.tickDirection = -layout.tickDirection;
  }

  if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve"](opt.labelInside, axisModel.get(['axisLabel', 'inside']))) {
    layout.labelDirection = -layout.labelDirection;
  } // Special label rotation


  var labelRotate = axisModel.get(['axisLabel', 'rotate']);
  layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate; // Over splitLine and splitArea

  layout.z2 = 1;
  return layout;
}
function isCartesian2DSeries(seriesModel) {
  return seriesModel.get('coordinateSystem') === 'cartesian2d';
}
function findAxisModels(seriesModel) {
  var axisModelMap = {
    xAxisModel: null,
    yAxisModel: null
  };
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](axisModelMap, function (v, key) {
    var axisType = key.replace(/Model$/, '');
    var axisModel = seriesModel.getReferringComponents(axisType, __WEBPACK_IMPORTED_MODULE_1__util_model_js__["i" /* SINGLE_REFERRING */]).models[0];

    if (true) {
      if (!axisModel) {
        throw new Error(axisType + ' "' + __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve3"](seriesModel.get(axisType + 'Index'), seriesModel.get(axisType + 'Id'), 0) + '" not found');
      }
    }

    axisModelMap[key] = axisModel;
  });
  return axisModelMap;
}

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Region */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GeoJSONPolygonGeometry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GeoJSONLineStringGeometry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GeoJSONRegion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GeoSVGRegion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_vector_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_contain_polygon_js__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_matrix_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






var TMP_TRANSFORM = [];

function transformPoints(points, transform) {
  for (var p = 0; p < points.length; p++) {
    __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_vector_js__["applyTransform"](points[p], points[p], transform);
  }
}

function updateBBoxFromPoints(points, min, max, projection) {
  for (var i = 0; i < points.length; i++) {
    var p = points[i];

    if (projection) {
      // projection may return null point.
      p = projection.project(p);
    }

    if (p && isFinite(p[0]) && isFinite(p[1])) {
      __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_vector_js__["min"](min, min, p);
      __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_vector_js__["max"](max, max, p);
    }
  }
}

function centroid(points) {
  var signedArea = 0;
  var cx = 0;
  var cy = 0;
  var len = points.length;
  var x0 = points[len - 1][0];
  var y0 = points[len - 1][1]; // Polygon should been closed.

  for (var i = 0; i < len; i++) {
    var x1 = points[i][0];
    var y1 = points[i][1];
    var a = x0 * y1 - x1 * y0;
    signedArea += a;
    cx += (x0 + x1) * a;
    cy += (y0 + y1) * a;
    x0 = x1;
    y0 = y1;
  }

  return signedArea ? [cx / signedArea / 3, cy / signedArea / 3, signedArea] : [points[0][0] || 0, points[0][1] || 0];
}

var Region =
/** @class */
function () {
  function Region(name) {
    this.name = name;
  }

  Region.prototype.setCenter = function (center) {
    this._center = center;
  };
  /**
   * Get center point in data unit. That is,
   * for GeoJSONRegion, the unit is lat/lng,
   * for GeoSVGRegion, the unit is SVG local coord.
   */


  Region.prototype.getCenter = function () {
    var center = this._center;

    if (!center) {
      // In most cases there are no need to calculate this center.
      // So calculate only when called.
      center = this._center = this.calcCenter();
    }

    return center;
  };

  return Region;
}();



var GeoJSONPolygonGeometry =
/** @class */
function () {
  function GeoJSONPolygonGeometry(exterior, interiors) {
    this.type = 'polygon';
    this.exterior = exterior;
    this.interiors = interiors;
  }

  return GeoJSONPolygonGeometry;
}();



var GeoJSONLineStringGeometry =
/** @class */
function () {
  function GeoJSONLineStringGeometry(points) {
    this.type = 'linestring';
    this.points = points;
  }

  return GeoJSONLineStringGeometry;
}();



var GeoJSONRegion =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(GeoJSONRegion, _super);

  function GeoJSONRegion(name, geometries, cp) {
    var _this = _super.call(this, name) || this;

    _this.type = 'geoJSON';
    _this.geometries = geometries;
    _this._center = cp && [cp[0], cp[1]];
    return _this;
  }

  GeoJSONRegion.prototype.calcCenter = function () {
    var geometries = this.geometries;
    var largestGeo;
    var largestGeoSize = 0;

    for (var i = 0; i < geometries.length; i++) {
      var geo = geometries[i];
      var exterior = geo.exterior; // Simple trick to use points count instead of polygon area as region size.
      // Ignore linestring

      var size = exterior && exterior.length;

      if (size > largestGeoSize) {
        largestGeo = geo;
        largestGeoSize = size;
      }
    }

    if (largestGeo) {
      return centroid(largestGeo.exterior);
    } // from bounding rect by default.


    var rect = this.getBoundingRect();
    return [rect.x + rect.width / 2, rect.y + rect.height / 2];
  };

  GeoJSONRegion.prototype.getBoundingRect = function (projection) {
    var rect = this._rect; // Always recalculate if using projection.

    if (rect && !projection) {
      return rect;
    }

    var min = [Infinity, Infinity];
    var max = [-Infinity, -Infinity];
    var geometries = this.geometries;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["each"])(geometries, function (geo) {
      if (geo.type === 'polygon') {
        // Doesn't consider hole
        updateBBoxFromPoints(geo.exterior, min, max, projection);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["each"])(geo.points, function (points) {
          updateBBoxFromPoints(points, min, max, projection);
        });
      }
    }); // Normalie invalid bounding.

    if (!(isFinite(min[0]) && isFinite(min[1]) && isFinite(max[0]) && isFinite(max[1]))) {
      min[0] = min[1] = max[0] = max[1] = 0;
    }

    rect = new __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_BoundingRect_js__["a" /* default */](min[0], min[1], max[0] - min[0], max[1] - min[1]);

    if (!projection) {
      this._rect = rect;
    }

    return rect;
  };

  GeoJSONRegion.prototype.contain = function (coord) {
    var rect = this.getBoundingRect();
    var geometries = this.geometries;

    if (!rect.contain(coord[0], coord[1])) {
      return false;
    }

    loopGeo: for (var i = 0, len = geometries.length; i < len; i++) {
      var geo = geometries[i]; // Only support polygon.

      if (geo.type !== 'polygon') {
        continue;
      }

      var exterior = geo.exterior;
      var interiors = geo.interiors;

      if (__WEBPACK_IMPORTED_MODULE_3_zrender_lib_contain_polygon_js__["a" /* contain */](exterior, coord[0], coord[1])) {
        // Not in the region if point is in the hole.
        for (var k = 0; k < (interiors ? interiors.length : 0); k++) {
          if (__WEBPACK_IMPORTED_MODULE_3_zrender_lib_contain_polygon_js__["a" /* contain */](interiors[k], coord[0], coord[1])) {
            continue loopGeo;
          }
        }

        return true;
      }
    }

    return false;
  };
  /**
   * Transform the raw coords to target bounding.
   * @param x
   * @param y
   * @param width
   * @param height
   */


  GeoJSONRegion.prototype.transformTo = function (x, y, width, height) {
    var rect = this.getBoundingRect();
    var aspect = rect.width / rect.height;

    if (!width) {
      width = aspect * height;
    } else if (!height) {
      height = width / aspect;
    }

    var target = new __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_BoundingRect_js__["a" /* default */](x, y, width, height);
    var transform = rect.calculateTransform(target);
    var geometries = this.geometries;

    for (var i = 0; i < geometries.length; i++) {
      var geo = geometries[i];

      if (geo.type === 'polygon') {
        transformPoints(geo.exterior, transform);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["each"])(geo.interiors, function (interior) {
          transformPoints(interior, transform);
        });
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["each"])(geo.points, function (points) {
          transformPoints(points, transform);
        });
      }
    }

    rect = this._rect;
    rect.copy(target); // Update center

    this._center = [rect.x + rect.width / 2, rect.y + rect.height / 2];
  };

  GeoJSONRegion.prototype.cloneShallow = function (name) {
    name == null && (name = this.name);
    var newRegion = new GeoJSONRegion(name, this.geometries, this._center);
    newRegion._rect = this._rect;
    newRegion.transformTo = null; // Simply avoid to be called.

    return newRegion;
  };

  return GeoJSONRegion;
}(Region);



var GeoSVGRegion =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(GeoSVGRegion, _super);

  function GeoSVGRegion(name, elOnlyForCalculate) {
    var _this = _super.call(this, name) || this;

    _this.type = 'geoSVG';
    _this._elOnlyForCalculate = elOnlyForCalculate;
    return _this;
  }

  GeoSVGRegion.prototype.calcCenter = function () {
    var el = this._elOnlyForCalculate;
    var rect = el.getBoundingRect();
    var center = [rect.x + rect.width / 2, rect.y + rect.height / 2];
    var mat = __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_matrix_js__["identity"](TMP_TRANSFORM);
    var target = el;

    while (target && !target.isGeoSVGGraphicRoot) {
      __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_matrix_js__["mul"](mat, target.getLocalTransform(), mat);
      target = target.parent;
    }

    __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_matrix_js__["invert"](mat, mat);
    __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_vector_js__["applyTransform"](center, center, mat);
    return center;
  };

  return GeoSVGRegion;
}(Region);



/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseGeoJSON;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Region_js__ = __webpack_require__(328);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Parse and decode geo json
 */



function decode(json) {
  if (!json.UTF8Encoding) {
    return json;
  }

  var jsonCompressed = json;
  var encodeScale = jsonCompressed.UTF8Scale;

  if (encodeScale == null) {
    encodeScale = 1024;
  }

  var features = jsonCompressed.features;
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](features, function (feature) {
    var geometry = feature.geometry;
    var encodeOffsets = geometry.encodeOffsets;
    var coordinates = geometry.coordinates; // Geometry may be appeded manually in the script after json loaded.
    // In this case this geometry is usually not encoded.

    if (!encodeOffsets) {
      return;
    }

    switch (geometry.type) {
      case 'LineString':
        geometry.coordinates = decodeRing(coordinates, encodeOffsets, encodeScale);
        break;

      case 'Polygon':
        decodeRings(coordinates, encodeOffsets, encodeScale);
        break;

      case 'MultiLineString':
        decodeRings(coordinates, encodeOffsets, encodeScale);
        break;

      case 'MultiPolygon':
        __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](coordinates, function (rings, idx) {
          return decodeRings(rings, encodeOffsets[idx], encodeScale);
        });
    }
  }); // Has been decoded

  jsonCompressed.UTF8Encoding = false;
  return jsonCompressed;
}

function decodeRings(rings, encodeOffsets, encodeScale) {
  for (var c = 0; c < rings.length; c++) {
    rings[c] = decodeRing(rings[c], encodeOffsets[c], encodeScale);
  }
}

function decodeRing(coordinate, encodeOffsets, encodeScale) {
  var result = [];
  var prevX = encodeOffsets[0];
  var prevY = encodeOffsets[1];

  for (var i = 0; i < coordinate.length; i += 2) {
    var x = coordinate.charCodeAt(i) - 64;
    var y = coordinate.charCodeAt(i + 1) - 64; // ZigZag decoding

    x = x >> 1 ^ -(x & 1);
    y = y >> 1 ^ -(y & 1); // Delta deocding

    x += prevX;
    y += prevY;
    prevX = x;
    prevY = y; // Dequantize

    result.push([x / encodeScale, y / encodeScale]);
  }

  return result;
}

function parseGeoJSON(geoJson, nameProperty) {
  geoJson = decode(geoJson);
  return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"](__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["filter"](geoJson.features, function (featureObj) {
    // Output of mapshaper may have geometry null
    return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
  }), function (featureObj) {
    var properties = featureObj.properties;
    var geo = featureObj.geometry;
    var geometries = [];

    switch (geo.type) {
      case 'Polygon':
        var coordinates = geo.coordinates; // According to the GeoJSON specification.
        // First must be exterior, and the rest are all interior(holes).

        geometries.push(new __WEBPACK_IMPORTED_MODULE_1__Region_js__["b" /* GeoJSONPolygonGeometry */](coordinates[0], coordinates.slice(1)));
        break;

      case 'MultiPolygon':
        __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](geo.coordinates, function (item) {
          if (item[0]) {
            geometries.push(new __WEBPACK_IMPORTED_MODULE_1__Region_js__["b" /* GeoJSONPolygonGeometry */](item[0], item.slice(1)));
          }
        });
        break;

      case 'LineString':
        geometries.push(new __WEBPACK_IMPORTED_MODULE_1__Region_js__["c" /* GeoJSONLineStringGeometry */]([geo.coordinates]));
        break;

      case 'MultiLineString':
        geometries.push(new __WEBPACK_IMPORTED_MODULE_1__Region_js__["c" /* GeoJSONLineStringGeometry */](geo.coordinates));
    }

    var region = new __WEBPACK_IMPORTED_MODULE_1__Region_js__["a" /* GeoJSONRegion */](properties[nameProperty || 'name'], geometries, properties.cp);
    region.properties = properties;
    return region;
  });
}

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTask;
/* unused harmony export Task */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

;
/**
 * @param {Object} define
 * @return See the return of `createTask`.
 */

function createTask(define) {
  return new Task(define);
}

var Task =
/** @class */
function () {
  function Task(define) {
    define = define || {};
    this._reset = define.reset;
    this._plan = define.plan;
    this._count = define.count;
    this._onDirty = define.onDirty;
    this._dirty = true;
  }
  /**
   * @param step Specified step.
   * @param skip Skip customer perform call.
   * @param modBy Sampling window size.
   * @param modDataCount Sampling count.
   * @return whether unfinished.
   */


  Task.prototype.perform = function (performArgs) {
    var upTask = this._upstream;
    var skip = performArgs && performArgs.skip; // TODO some refactor.
    // Pull data. Must pull data each time, because context.data
    // may be updated by Series.setData.

    if (this._dirty && upTask) {
      var context = this.context;
      context.data = context.outputData = upTask.context.outputData;
    }

    if (this.__pipeline) {
      this.__pipeline.currentTask = this;
    }

    var planResult;

    if (this._plan && !skip) {
      planResult = this._plan(this.context);
    } // Support sharding by mod, which changes the render sequence and makes the rendered graphic
    // elements uniformed distributed when progress, especially when moving or zooming.


    var lastModBy = normalizeModBy(this._modBy);
    var lastModDataCount = this._modDataCount || 0;
    var modBy = normalizeModBy(performArgs && performArgs.modBy);
    var modDataCount = performArgs && performArgs.modDataCount || 0;

    if (lastModBy !== modBy || lastModDataCount !== modDataCount) {
      planResult = 'reset';
    }

    function normalizeModBy(val) {
      !(val >= 1) && (val = 1); // jshint ignore:line

      return val;
    }

    var forceFirstProgress;

    if (this._dirty || planResult === 'reset') {
      this._dirty = false;
      forceFirstProgress = this._doReset(skip);
    }

    this._modBy = modBy;
    this._modDataCount = modDataCount;
    var step = performArgs && performArgs.step;

    if (upTask) {
      if (true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(upTask._outputDueEnd != null);
      }

      this._dueEnd = upTask._outputDueEnd;
    } // DataTask or overallTask
    else {
        if (true) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(!this._progress || this._count);
        }

        this._dueEnd = this._count ? this._count(this.context) : Infinity;
      } // Note: Stubs, that its host overall task let it has progress, has progress.
    // If no progress, pass index from upstream to downstream each time plan called.


    if (this._progress) {
      var start = this._dueIndex;
      var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);

      if (!skip && (forceFirstProgress || start < end)) {
        var progress = this._progress;

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"])(progress)) {
          for (var i = 0; i < progress.length; i++) {
            this._doProgress(progress[i], start, end, modBy, modDataCount);
          }
        } else {
          this._doProgress(progress, start, end, modBy, modDataCount);
        }
      }

      this._dueIndex = end; // If no `outputDueEnd`, assume that output data and
      // input data is the same, so use `dueIndex` as `outputDueEnd`.

      var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;

      if (true) {
        // ??? Can not rollback.
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(outputDueEnd >= this._outputDueEnd);
      }

      this._outputDueEnd = outputDueEnd;
    } else {
      // (1) Some overall task has no progress.
      // (2) Stubs, that its host overall task do not let it has progress, has no progress.
      // This should always be performed so it can be passed to downstream.
      this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
    }

    return this.unfinished();
  };

  Task.prototype.dirty = function () {
    this._dirty = true;
    this._onDirty && this._onDirty(this.context);
  };

  Task.prototype._doProgress = function (progress, start, end, modBy, modDataCount) {
    iterator.reset(start, end, modBy, modDataCount);
    this._callingProgress = progress;

    this._callingProgress({
      start: start,
      end: end,
      count: end - start,
      next: iterator.next
    }, this.context);
  };

  Task.prototype._doReset = function (skip) {
    this._dueIndex = this._outputDueEnd = this._dueEnd = 0;
    this._settedOutputEnd = null;
    var progress;
    var forceFirstProgress;

    if (!skip && this._reset) {
      progress = this._reset(this.context);

      if (progress && progress.progress) {
        forceFirstProgress = progress.forceFirstProgress;
        progress = progress.progress;
      } // To simplify no progress checking, array must has item.


      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"])(progress) && !progress.length) {
        progress = null;
      }
    }

    this._progress = progress;
    this._modBy = this._modDataCount = null;
    var downstream = this._downstream;
    downstream && downstream.dirty();
    return forceFirstProgress;
  };

  Task.prototype.unfinished = function () {
    return this._progress && this._dueIndex < this._dueEnd;
  };
  /**
   * @param downTask The downstream task.
   * @return The downstream task.
   */


  Task.prototype.pipe = function (downTask) {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(downTask && !downTask._disposed && downTask !== this);
    } // If already downstream, do not dirty downTask.


    if (this._downstream !== downTask || this._dirty) {
      this._downstream = downTask;
      downTask._upstream = this;
      downTask.dirty();
    }
  };

  Task.prototype.dispose = function () {
    if (this._disposed) {
      return;
    }

    this._upstream && (this._upstream._downstream = null);
    this._downstream && (this._downstream._upstream = null);
    this._dirty = false;
    this._disposed = true;
  };

  Task.prototype.getUpstream = function () {
    return this._upstream;
  };

  Task.prototype.getDownstream = function () {
    return this._downstream;
  };

  Task.prototype.setOutputEnd = function (end) {
    // This only happend in dataTask, dataZoom, map, currently.
    // where dataZoom do not set end each time, but only set
    // when reset. So we should record the setted end, in case
    // that the stub of dataZoom perform again and earse the
    // setted end by upstream.
    this._outputDueEnd = this._settedOutputEnd = end;
  };

  return Task;
}();



var iterator = function () {
  var end;
  var current;
  var modBy;
  var modDataCount;
  var winCount;
  var it = {
    reset: function (s, e, sStep, sCount) {
      current = s;
      end = e;
      modBy = sStep;
      modDataCount = sCount;
      winCount = Math.ceil(modDataCount / modBy);
      it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
    }
  };
  return it;

  function sequentialNext() {
    return current < end ? current++ : null;
  }

  function modNext() {
    var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
    var result = current >= end ? null : dataIndex < modDataCount ? dataIndex // If modDataCount is smaller than data.count() (consider `appendData` case),
    // Use normal linear rendering mode.
    : current;
    current++;
    return result;
  }
}(); ///////////////////////////////////////////////////////////
// For stream debug (Should be commented out after used!)
// @usage: printTask(this, 'begin');
// @usage: printTask(this, null, {someExtraProp});
// @usage: Use `__idxInPipeline` as conditional breakpiont.
//
// window.printTask = function (task: any, prefix: string, extra: { [key: string]: unknown }): void {
//     window.ecTaskUID == null && (window.ecTaskUID = 0);
//     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
//     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
//     let props = [];
//     if (task.__pipeline) {
//         let val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
//         props.push({text: '__idxInPipeline/total', value: val});
//     } else {
//         let stubCount = 0;
//         task.agentStubMap.each(() => stubCount++);
//         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
//     }
//     props.push({text: 'uid', value: task.uidDebug});
//     if (task.__pipeline) {
//         props.push({text: 'pipelineId', value: task.__pipeline.id});
//         task.agent && props.push(
//             {text: 'stubFor', value: task.agent.uidDebug}
//         );
//     }
//     props.push(
//         {text: 'dirty', value: task._dirty},
//         {text: 'dueIndex', value: task._dueIndex},
//         {text: 'dueEnd', value: task._dueEnd},
//         {text: 'outputDueEnd', value: task._outputDueEnd}
//     );
//     if (extra) {
//         Object.keys(extra).forEach(key => {
//             props.push({text: key, value: extra[key]});
//         });
//     }
//     let args = ['color: blue'];
//     let msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
//         args.push('color: green', 'color: red'),
//         `${item.text}: %c${item.value}`
//     )).join('%c, ');
//     console.log.apply(console, [msg].concat(args));
//     // console.log(this);
// };
// window.printPipeline = function (task: any, prefix: string) {
//     const pipeline = task.__pipeline;
//     let currTask = pipeline.head;
//     while (currTask) {
//         window.printTask(currTask, prefix);
//         currTask = currTask._downstream;
//     }
// };
// window.showChain = function (chainHeadTask) {
//     var chain = [];
//     var task = chainHeadTask;
//     while (task) {
//         chain.push({
//             task: task,
//             up: task._upstream,
//             down: task._downstream,
//             idxInPipeline: task.__idxInPipeline
//         });
//         task = task._downstream;
//     }
//     return chain;
// };
// window.findTaskInChain = function (task, chainHeadTask) {
//     let chain = window.showChain(chainHeadTask);
//     let result = [];
//     for (let i = 0; i < chain.length; i++) {
//         let chainItem = chain[i];
//         if (chainItem.task === task) {
//             result.push(i);
//         }
//     }
//     return result;
// };
// window.printChainAEachInChainB = function (chainHeadTaskA, chainHeadTaskB) {
//     let chainA = window.showChain(chainHeadTaskA);
//     for (let i = 0; i < chainA.length; i++) {
//         console.log('chainAIdx:', i, 'inChainB:', window.findTaskInChain(chainA[i].task, chainHeadTaskB));
//     }
// };

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CtorUint32Array */
/* unused harmony export CtorUint16Array */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CtorInt32Array; });
/* unused harmony export CtorFloat64Array */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_dataValueHelper_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Source_js__ = __webpack_require__(114);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var UNDEFINED = 'undefined';
/* global Float64Array, Int32Array, Uint32Array, Uint16Array */
// Caution: MUST not use `new CtorUint32Array(arr, 0, len)`, because the Ctor of array is
// different from the Ctor of typed array.

var CtorUint32Array = typeof Uint32Array === UNDEFINED ? Array : Uint32Array;
var CtorUint16Array = typeof Uint16Array === UNDEFINED ? Array : Uint16Array;
var CtorInt32Array = typeof Int32Array === UNDEFINED ? Array : Int32Array;
var CtorFloat64Array = typeof Float64Array === UNDEFINED ? Array : Float64Array;
/**
 * Multi dimensional data store
 */

var dataCtors = {
  'float': CtorFloat64Array,
  'int': CtorInt32Array,
  // Ordinal data type can be string or int
  'ordinal': Array,
  'number': Array,
  'time': CtorFloat64Array
};
var defaultDimValueGetters;

function getIndicesCtor(rawCount) {
  // The possible max value in this._indicies is always this._rawCount despite of filtering.
  return rawCount > 65535 ? CtorUint32Array : CtorUint16Array;
}

;

function getInitialExtent() {
  return [Infinity, -Infinity];
}

;

function cloneChunk(originalChunk) {
  var Ctor = originalChunk.constructor; // Only shallow clone is enough when Array.

  return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
}

function prepareStore(store, dimIdx, dimType, end, append) {
  var DataCtor = dataCtors[dimType || 'float'];

  if (append) {
    var oldStore = store[dimIdx];
    var oldLen = oldStore && oldStore.length;

    if (!(oldLen === end)) {
      var newStore = new DataCtor(end); // The cost of the copy is probably inconsiderable
      // within the initial chunkSize.

      for (var j = 0; j < oldLen; j++) {
        newStore[j] = oldStore[j];
      }

      store[dimIdx] = newStore;
    }
  } else {
    store[dimIdx] = new DataCtor(end);
  }
}

;
/**
 * Basically, DataStore API keep immutable.
 */

var DataStore =
/** @class */
function () {
  function DataStore() {
    this._chunks = []; // It will not be calculated util needed.

    this._rawExtent = [];
    this._extent = [];
    this._count = 0;
    this._rawCount = 0;
    this._calcDimNameToIdx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();
  }
  /**
   * Initialize from data
   */


  DataStore.prototype.initData = function (provider, inputDimensions, dimValueGetter) {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"])(provider.getItem) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"])(provider.count), 'Inavlid data provider.');
    }

    this._provider = provider; // Clear

    this._chunks = [];
    this._indices = null;
    this.getRawIndex = this._getRawIdxIdentity;
    var source = provider.getSource();
    var defaultGetter = this.defaultDimValueGetter = defaultDimValueGetters[source.sourceFormat]; // Default dim value getter

    this._dimValueGetter = dimValueGetter || defaultGetter; // Reset raw extent.

    this._rawExtent = [];
    var willRetrieveDataByName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Source_js__["e" /* shouldRetrieveDataByName */])(source);
    this._dimensions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])(inputDimensions, function (dim) {
      if (true) {
        if (willRetrieveDataByName) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(dim.property != null);
        }
      }

      return {
        // Only pick these two props. Not leak other properties like orderMeta.
        type: dim.type,
        property: dim.property
      };
    });

    this._initDataFromProvider(0, provider.count());
  };

  DataStore.prototype.getProvider = function () {
    return this._provider;
  };
  /**
   * Caution: even when a `source` instance owned by a series, the created data store
   * may still be shared by different sereis (the source hash does not use all `source`
   * props, see `sourceManager`). In this case, the `source` props that are not used in
   * hash (like `source.dimensionDefine`) probably only belongs to a certain series and
   * thus should not be fetch here.
   */


  DataStore.prototype.getSource = function () {
    return this._provider.getSource();
  };
  /**
   * @caution Only used in dataStack.
   */


  DataStore.prototype.ensureCalculationDimension = function (dimName, type) {
    var calcDimNameToIdx = this._calcDimNameToIdx;
    var dimensions = this._dimensions;
    var calcDimIdx = calcDimNameToIdx.get(dimName);

    if (calcDimIdx != null) {
      if (dimensions[calcDimIdx].type === type) {
        return calcDimIdx;
      }
    } else {
      calcDimIdx = dimensions.length;
    }

    dimensions[calcDimIdx] = {
      type: type
    };
    calcDimNameToIdx.set(dimName, calcDimIdx);
    this._chunks[calcDimIdx] = new dataCtors[type || 'float'](this._rawCount);
    this._rawExtent[calcDimIdx] = getInitialExtent();
    return calcDimIdx;
  };

  DataStore.prototype.collectOrdinalMeta = function (dimIdx, ordinalMeta) {
    var chunk = this._chunks[dimIdx];
    var dim = this._dimensions[dimIdx];
    var rawExtents = this._rawExtent;
    var offset = dim.ordinalOffset || 0;
    var len = chunk.length;

    if (offset === 0) {
      // We need to reset the rawExtent if collect is from start.
      // Because this dimension may be guessed as number and calcuating a wrong extent.
      rawExtents[dimIdx] = getInitialExtent();
    }

    var dimRawExtent = rawExtents[dimIdx]; // Parse from previous data offset. len may be changed after appendData

    for (var i = offset; i < len; i++) {
      var val = chunk[i] = ordinalMeta.parseAndCollect(chunk[i]);

      if (!isNaN(val)) {
        dimRawExtent[0] = Math.min(val, dimRawExtent[0]);
        dimRawExtent[1] = Math.max(val, dimRawExtent[1]);
      }
    }

    dim.ordinalMeta = ordinalMeta;
    dim.ordinalOffset = len;
    dim.type = 'ordinal'; // Force to be ordinal
  };

  DataStore.prototype.getOrdinalMeta = function (dimIdx) {
    var dimInfo = this._dimensions[dimIdx];
    var ordinalMeta = dimInfo.ordinalMeta;
    return ordinalMeta;
  };

  DataStore.prototype.getDimensionProperty = function (dimIndex) {
    var item = this._dimensions[dimIndex];
    return item && item.property;
  };
  /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */


  DataStore.prototype.appendData = function (data) {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(!this._indices, 'appendData can only be called on raw data.');
    }

    var provider = this._provider;
    var start = this.count();
    provider.appendData(data);
    var end = provider.count();

    if (!provider.persistent) {
      end += start;
    }

    if (start < end) {
      this._initDataFromProvider(start, end, true);
    }

    return [start, end];
  };

  DataStore.prototype.appendValues = function (values, minFillLen) {
    var chunks = this._chunks;
    var dimensions = this._dimensions;
    var dimLen = dimensions.length;
    var rawExtent = this._rawExtent;
    var start = this.count();
    var end = start + Math.max(values.length, minFillLen || 0);

    for (var i = 0; i < dimLen; i++) {
      var dim = dimensions[i];
      prepareStore(chunks, i, dim.type, end, true);
    }

    var emptyDataItem = [];

    for (var idx = start; idx < end; idx++) {
      var sourceIdx = idx - start; // Store the data by dimensions

      for (var dimIdx = 0; dimIdx < dimLen; dimIdx++) {
        var dim = dimensions[dimIdx];
        var val = defaultDimValueGetters.arrayRows.call(this, values[sourceIdx] || emptyDataItem, dim.property, sourceIdx, dimIdx);
        chunks[dimIdx][idx] = val;
        var dimRawExtent = rawExtent[dimIdx];
        val < dimRawExtent[0] && (dimRawExtent[0] = val);
        val > dimRawExtent[1] && (dimRawExtent[1] = val);
      }
    }

    this._rawCount = this._count = end;
    return {
      start: start,
      end: end
    };
  };

  DataStore.prototype._initDataFromProvider = function (start, end, append) {
    var provider = this._provider;
    var chunks = this._chunks;
    var dimensions = this._dimensions;
    var dimLen = dimensions.length;
    var rawExtent = this._rawExtent;
    var dimNames = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])(dimensions, function (dim) {
      return dim.property;
    });

    for (var i = 0; i < dimLen; i++) {
      var dim = dimensions[i];

      if (!rawExtent[i]) {
        rawExtent[i] = getInitialExtent();
      }

      prepareStore(chunks, i, dim.type, end, append);
    }

    if (provider.fillStorage) {
      provider.fillStorage(start, end, chunks, rawExtent);
    } else {
      var dataItem = [];

      for (var idx = start; idx < end; idx++) {
        // NOTICE: Try not to write things into dataItem
        dataItem = provider.getItem(idx, dataItem); // Each data item is value
        // [1, 2]
        // 2
        // Bar chart, line chart which uses category axis
        // only gives the 'y' value. 'x' value is the indices of category
        // Use a tempValue to normalize the value to be a (x, y) value
        // Store the data by dimensions

        for (var dimIdx = 0; dimIdx < dimLen; dimIdx++) {
          var dimStorage = chunks[dimIdx]; // PENDING NULL is empty or zero

          var val = this._dimValueGetter(dataItem, dimNames[dimIdx], idx, dimIdx);

          dimStorage[idx] = val;
          var dimRawExtent = rawExtent[dimIdx];
          val < dimRawExtent[0] && (dimRawExtent[0] = val);
          val > dimRawExtent[1] && (dimRawExtent[1] = val);
        }
      }
    }

    if (!provider.persistent && provider.clean) {
      // Clean unused data if data source is typed array.
      provider.clean();
    }

    this._rawCount = this._count = end; // Reset data extent

    this._extent = [];
  };

  DataStore.prototype.count = function () {
    return this._count;
  };
  /**
   * Get value. Return NaN if idx is out of range.
   */


  DataStore.prototype.get = function (dim, idx) {
    if (!(idx >= 0 && idx < this._count)) {
      return NaN;
    }

    var dimStore = this._chunks[dim];
    return dimStore ? dimStore[this.getRawIndex(idx)] : NaN;
  };

  DataStore.prototype.getValues = function (dimensions, idx) {
    var values = [];
    var dimArr = [];

    if (idx == null) {
      idx = dimensions; // TODO get all from store?

      dimensions = []; // All dimensions

      for (var i = 0; i < this._dimensions.length; i++) {
        dimArr.push(i);
      }
    } else {
      dimArr = dimensions;
    }

    for (var i = 0, len = dimArr.length; i < len; i++) {
      values.push(this.get(dimArr[i], idx));
    }

    return values;
  };
  /**
   * @param dim concrete dim
   */


  DataStore.prototype.getByRawIndex = function (dim, rawIdx) {
    if (!(rawIdx >= 0 && rawIdx < this._rawCount)) {
      return NaN;
    }

    var dimStore = this._chunks[dim];
    return dimStore ? dimStore[rawIdx] : NaN;
  };
  /**
   * Get sum of data in one dimension
   */


  DataStore.prototype.getSum = function (dim) {
    var dimData = this._chunks[dim];
    var sum = 0;

    if (dimData) {
      for (var i = 0, len = this.count(); i < len; i++) {
        var value = this.get(dim, i);

        if (!isNaN(value)) {
          sum += value;
        }
      }
    }

    return sum;
  };
  /**
   * Get median of data in one dimension
   */


  DataStore.prototype.getMedian = function (dim) {
    var dimDataArray = []; // map all data of one dimension

    this.each([dim], function (val) {
      if (!isNaN(val)) {
        dimDataArray.push(val);
      }
    }); // TODO
    // Use quick select?

    var sortedDimDataArray = dimDataArray.sort(function (a, b) {
      return a - b;
    });
    var len = this.count(); // calculate median

    return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
  };
  /**
   * Retreive the index with given raw data index
   */


  DataStore.prototype.indexOfRawIndex = function (rawIndex) {
    if (rawIndex >= this._rawCount || rawIndex < 0) {
      return -1;
    }

    if (!this._indices) {
      return rawIndex;
    } // Indices are ascending


    var indices = this._indices; // If rawIndex === dataIndex

    var rawDataIndex = indices[rawIndex];

    if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) {
      return rawIndex;
    }

    var left = 0;
    var right = this._count - 1;

    while (left <= right) {
      var mid = (left + right) / 2 | 0;

      if (indices[mid] < rawIndex) {
        left = mid + 1;
      } else if (indices[mid] > rawIndex) {
        right = mid - 1;
      } else {
        return mid;
      }
    }

    return -1;
  };
  /**
   * Retreive the index of nearest value
   * @param dim
   * @param value
   * @param [maxDistance=Infinity]
   * @return If and only if multiple indices has
   *         the same value, they are put to the result.
   */


  DataStore.prototype.indicesOfNearest = function (dim, value, maxDistance) {
    var chunks = this._chunks;
    var dimData = chunks[dim];
    var nearestIndices = [];

    if (!dimData) {
      return nearestIndices;
    }

    if (maxDistance == null) {
      maxDistance = Infinity;
    }

    var minDist = Infinity;
    var minDiff = -1;
    var nearestIndicesLen = 0; // Check the test case of `test/ut/spec/data/SeriesData.js`.

    for (var i = 0, len = this.count(); i < len; i++) {
      var dataIndex = this.getRawIndex(i);
      var diff = value - dimData[dataIndex];
      var dist = Math.abs(diff);

      if (dist <= maxDistance) {
        // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
        // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
        // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
        // So we chose the one that `diff >= 0` in this csae.
        // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
        // should be push to `nearestIndices`.
        if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
          minDist = dist;
          minDiff = diff;
          nearestIndicesLen = 0;
        }

        if (diff === minDiff) {
          nearestIndices[nearestIndicesLen++] = i;
        }
      }
    }

    nearestIndices.length = nearestIndicesLen;
    return nearestIndices;
  };

  DataStore.prototype.getIndices = function () {
    var newIndices;
    var indices = this._indices;

    if (indices) {
      var Ctor = indices.constructor;
      var thisCount = this._count; // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.

      if (Ctor === Array) {
        newIndices = new Ctor(thisCount);

        for (var i = 0; i < thisCount; i++) {
          newIndices[i] = indices[i];
        }
      } else {
        newIndices = new Ctor(indices.buffer, 0, thisCount);
      }
    } else {
      var Ctor = getIndicesCtor(this._rawCount);
      newIndices = new Ctor(this.count());

      for (var i = 0; i < newIndices.length; i++) {
        newIndices[i] = i;
      }
    }

    return newIndices;
  };
  /**
   * Data filter.
   */


  DataStore.prototype.filter = function (dims, cb) {
    if (!this._count) {
      return this;
    }

    var newStore = this.clone();
    var count = newStore.count();
    var Ctor = getIndicesCtor(newStore._rawCount);
    var newIndices = new Ctor(count);
    var value = [];
    var dimSize = dims.length;
    var offset = 0;
    var dim0 = dims[0];
    var chunks = newStore._chunks;

    for (var i = 0; i < count; i++) {
      var keep = void 0;
      var rawIdx = newStore.getRawIndex(i); // Simple optimization

      if (dimSize === 0) {
        keep = cb(i);
      } else if (dimSize === 1) {
        var val = chunks[dim0][rawIdx];
        keep = cb(val, i);
      } else {
        var k = 0;

        for (; k < dimSize; k++) {
          value[k] = chunks[dims[k]][rawIdx];
        }

        value[k] = i;
        keep = cb.apply(null, value);
      }

      if (keep) {
        newIndices[offset++] = rawIdx;
      }
    } // Set indices after filtered.


    if (offset < count) {
      newStore._indices = newIndices;
    }

    newStore._count = offset; // Reset data extent

    newStore._extent = [];

    newStore._updateGetRawIdx();

    return newStore;
  };
  /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */


  DataStore.prototype.selectRange = function (range) {
    var newStore = this.clone();
    var len = newStore._count;

    if (!len) {
      return this;
    }

    var dims = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["keys"])(range);
    var dimSize = dims.length;

    if (!dimSize) {
      return this;
    }

    var originalCount = newStore.count();
    var Ctor = getIndicesCtor(newStore._rawCount);
    var newIndices = new Ctor(originalCount);
    var offset = 0;
    var dim0 = dims[0];
    var min = range[dim0][0];
    var max = range[dim0][1];
    var storeArr = newStore._chunks;
    var quickFinished = false;

    if (!newStore._indices) {
      // Extreme optimization for common case. About 2x faster in chrome.
      var idx = 0;

      if (dimSize === 1) {
        var dimStorage = storeArr[dims[0]];

        for (var i = 0; i < len; i++) {
          var val = dimStorage[i]; // NaN will not be filtered. Consider the case, in line chart, empty
          // value indicates the line should be broken. But for the case like
          // scatter plot, a data item with empty value will not be rendered,
          // but the axis extent may be effected if some other dim of the data
          // item has value. Fortunately it is not a significant negative effect.

          if (val >= min && val <= max || isNaN(val)) {
            newIndices[offset++] = idx;
          }

          idx++;
        }

        quickFinished = true;
      } else if (dimSize === 2) {
        var dimStorage = storeArr[dims[0]];
        var dimStorage2 = storeArr[dims[1]];
        var min2 = range[dims[1]][0];
        var max2 = range[dims[1]][1];

        for (var i = 0; i < len; i++) {
          var val = dimStorage[i];
          var val2 = dimStorage2[i]; // Do not filter NaN, see comment above.

          if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) {
            newIndices[offset++] = idx;
          }

          idx++;
        }

        quickFinished = true;
      }
    }

    if (!quickFinished) {
      if (dimSize === 1) {
        for (var i = 0; i < originalCount; i++) {
          var rawIndex = newStore.getRawIndex(i);
          var val = storeArr[dims[0]][rawIndex]; // Do not filter NaN, see comment above.

          if (val >= min && val <= max || isNaN(val)) {
            newIndices[offset++] = rawIndex;
          }
        }
      } else {
        for (var i = 0; i < originalCount; i++) {
          var keep = true;
          var rawIndex = newStore.getRawIndex(i);

          for (var k = 0; k < dimSize; k++) {
            var dimk = dims[k];
            var val = storeArr[dimk][rawIndex]; // Do not filter NaN, see comment above.

            if (val < range[dimk][0] || val > range[dimk][1]) {
              keep = false;
            }
          }

          if (keep) {
            newIndices[offset++] = newStore.getRawIndex(i);
          }
        }
      }
    } // Set indices after filtered.


    if (offset < originalCount) {
      newStore._indices = newIndices;
    }

    newStore._count = offset; // Reset data extent

    newStore._extent = [];

    newStore._updateGetRawIdx();

    return newStore;
  }; // /**
  //  * Data mapping to a plain array
  //  */
  // mapArray(dims: DimensionIndex[], cb: MapArrayCb): any[] {
  //     const result: any[] = [];
  //     this.each(dims, function () {
  //         result.push(cb && (cb as MapArrayCb).apply(null, arguments));
  //     });
  //     return result;
  // }

  /**
   * Data mapping to a new List with given dimensions
   */


  DataStore.prototype.map = function (dims, cb) {
    // TODO only clone picked chunks.
    var target = this.clone(dims);

    this._updateDims(target, dims, cb);

    return target;
  };
  /**
   * @caution Danger!! Only used in dataStack.
   */


  DataStore.prototype.modify = function (dims, cb) {
    this._updateDims(this, dims, cb);
  };

  DataStore.prototype._updateDims = function (target, dims, cb) {
    var targetChunks = target._chunks;
    var tmpRetValue = [];
    var dimSize = dims.length;
    var dataCount = target.count();
    var values = [];
    var rawExtent = target._rawExtent;

    for (var i = 0; i < dims.length; i++) {
      rawExtent[dims[i]] = getInitialExtent();
    }

    for (var dataIndex = 0; dataIndex < dataCount; dataIndex++) {
      var rawIndex = target.getRawIndex(dataIndex);

      for (var k = 0; k < dimSize; k++) {
        values[k] = targetChunks[dims[k]][rawIndex];
      }

      values[dimSize] = dataIndex;
      var retValue = cb && cb.apply(null, values);

      if (retValue != null) {
        // a number or string (in oridinal dimension)?
        if (typeof retValue !== 'object') {
          tmpRetValue[0] = retValue;
          retValue = tmpRetValue;
        }

        for (var i = 0; i < retValue.length; i++) {
          var dim = dims[i];
          var val = retValue[i];
          var rawExtentOnDim = rawExtent[dim];
          var dimStore = targetChunks[dim];

          if (dimStore) {
            dimStore[rawIndex] = val;
          }

          if (val < rawExtentOnDim[0]) {
            rawExtentOnDim[0] = val;
          }

          if (val > rawExtentOnDim[1]) {
            rawExtentOnDim[1] = val;
          }
        }
      }
    }
  };
  /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */


  DataStore.prototype.lttbDownSample = function (valueDimension, rate) {
    var target = this.clone([valueDimension], true);
    var targetStorage = target._chunks;
    var dimStore = targetStorage[valueDimension];
    var len = this.count();
    var sampledIndex = 0;
    var frameSize = Math.floor(1 / rate);
    var currentRawIndex = this.getRawIndex(0);
    var maxArea;
    var area;
    var nextRawIndex;
    var newIndices = new (getIndicesCtor(this._rawCount))(Math.min((Math.ceil(len / frameSize) + 2) * 2, len)); // First frame use the first data.

    newIndices[sampledIndex++] = currentRawIndex;

    for (var i = 1; i < len - 1; i += frameSize) {
      var nextFrameStart = Math.min(i + frameSize, len - 1);
      var nextFrameEnd = Math.min(i + frameSize * 2, len);
      var avgX = (nextFrameEnd + nextFrameStart) / 2;
      var avgY = 0;

      for (var idx = nextFrameStart; idx < nextFrameEnd; idx++) {
        var rawIndex = this.getRawIndex(idx);
        var y = dimStore[rawIndex];

        if (isNaN(y)) {
          continue;
        }

        avgY += y;
      }

      avgY /= nextFrameEnd - nextFrameStart;
      var frameStart = i;
      var frameEnd = Math.min(i + frameSize, len);
      var pointAX = i - 1;
      var pointAY = dimStore[currentRawIndex];
      maxArea = -1;
      nextRawIndex = frameStart;
      var firstNaNIndex = -1;
      var countNaN = 0; // Find a point from current frame that construct a triangel with largest area with previous selected point
      // And the average of next frame.

      for (var idx = frameStart; idx < frameEnd; idx++) {
        var rawIndex = this.getRawIndex(idx);
        var y = dimStore[rawIndex];

        if (isNaN(y)) {
          countNaN++;

          if (firstNaNIndex < 0) {
            firstNaNIndex = rawIndex;
          }

          continue;
        } // Calculate triangle area over three buckets


        area = Math.abs((pointAX - avgX) * (y - pointAY) - (pointAX - idx) * (avgY - pointAY));

        if (area > maxArea) {
          maxArea = area;
          nextRawIndex = rawIndex; // Next a is this b
        }
      }

      if (countNaN > 0 && countNaN < frameEnd - frameStart) {
        // Append first NaN point in every bucket.
        // It is necessary to ensure the correct order of indices.
        newIndices[sampledIndex++] = Math.min(firstNaNIndex, nextRawIndex);
        nextRawIndex = Math.max(firstNaNIndex, nextRawIndex);
      }

      newIndices[sampledIndex++] = nextRawIndex;
      currentRawIndex = nextRawIndex; // This a is the next a (chosen b)
    } // First frame use the last data.


    newIndices[sampledIndex++] = this.getRawIndex(len - 1);
    target._count = sampledIndex;
    target._indices = newIndices;
    target.getRawIndex = this._getRawIdx;
    return target;
  };
  /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */


  DataStore.prototype.downSample = function (dimension, rate, sampleValue, sampleIndex) {
    var target = this.clone([dimension], true);
    var targetStorage = target._chunks;
    var frameValues = [];
    var frameSize = Math.floor(1 / rate);
    var dimStore = targetStorage[dimension];
    var len = this.count();
    var rawExtentOnDim = target._rawExtent[dimension] = getInitialExtent();
    var newIndices = new (getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize));
    var offset = 0;

    for (var i = 0; i < len; i += frameSize) {
      // Last frame
      if (frameSize > len - i) {
        frameSize = len - i;
        frameValues.length = frameSize;
      }

      for (var k = 0; k < frameSize; k++) {
        var dataIdx = this.getRawIndex(i + k);
        frameValues[k] = dimStore[dataIdx];
      }

      var value = sampleValue(frameValues);
      var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1)); // Only write value on the filtered data

      dimStore[sampleFrameIdx] = value;

      if (value < rawExtentOnDim[0]) {
        rawExtentOnDim[0] = value;
      }

      if (value > rawExtentOnDim[1]) {
        rawExtentOnDim[1] = value;
      }

      newIndices[offset++] = sampleFrameIdx;
    }

    target._count = offset;
    target._indices = newIndices;

    target._updateGetRawIdx();

    return target;
  };
  /**
   * Data iteration
   * @param ctx default this
   * @example
   *  list.each('x', function (x, idx) {});
   *  list.each(['x', 'y'], function (x, y, idx) {});
   *  list.each(function (idx) {})
   */


  DataStore.prototype.each = function (dims, cb) {
    if (!this._count) {
      return;
    }

    var dimSize = dims.length;
    var chunks = this._chunks;

    for (var i = 0, len = this.count(); i < len; i++) {
      var rawIdx = this.getRawIndex(i); // Simple optimization

      switch (dimSize) {
        case 0:
          cb(i);
          break;

        case 1:
          cb(chunks[dims[0]][rawIdx], i);
          break;

        case 2:
          cb(chunks[dims[0]][rawIdx], chunks[dims[1]][rawIdx], i);
          break;

        default:
          var k = 0;
          var value = [];

          for (; k < dimSize; k++) {
            value[k] = chunks[dims[k]][rawIdx];
          } // Index


          value[k] = i;
          cb.apply(null, value);
      }
    }
  };
  /**
   * Get extent of data in one dimension
   */


  DataStore.prototype.getDataExtent = function (dim) {
    // Make sure use concrete dim as cache name.
    var dimData = this._chunks[dim];
    var initialExtent = getInitialExtent();

    if (!dimData) {
      return initialExtent;
    } // Make more strict checkings to ensure hitting cache.


    var currEnd = this.count(); // Consider the most cases when using data zoom, `getDataExtent`
    // happened before filtering. We cache raw extent, which is not
    // necessary to be cleared and recalculated when restore data.

    var useRaw = !this._indices;
    var dimExtent;

    if (useRaw) {
      return this._rawExtent[dim].slice();
    }

    dimExtent = this._extent[dim];

    if (dimExtent) {
      return dimExtent.slice();
    }

    dimExtent = initialExtent;
    var min = dimExtent[0];
    var max = dimExtent[1];

    for (var i = 0; i < currEnd; i++) {
      var rawIdx = this.getRawIndex(i);
      var value = dimData[rawIdx];
      value < min && (min = value);
      value > max && (max = value);
    }

    dimExtent = [min, max];
    this._extent[dim] = dimExtent;
    return dimExtent;
  };
  /**
   * Get raw data item
   */


  DataStore.prototype.getRawDataItem = function (idx) {
    var rawIdx = this.getRawIndex(idx);

    if (!this._provider.persistent) {
      var val = [];
      var chunks = this._chunks;

      for (var i = 0; i < chunks.length; i++) {
        val.push(chunks[i][rawIdx]);
      }

      return val;
    } else {
      return this._provider.getItem(rawIdx);
    }
  };
  /**
   * Clone shallow.
   *
   * @param clonedDims Determine which dims to clone. Will share the data if not specified.
   */


  DataStore.prototype.clone = function (clonedDims, ignoreIndices) {
    var target = new DataStore();
    var chunks = this._chunks;
    var clonedDimsMap = clonedDims && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["reduce"])(clonedDims, function (obj, dimIdx) {
      obj[dimIdx] = true;
      return obj;
    }, {});

    if (clonedDimsMap) {
      for (var i = 0; i < chunks.length; i++) {
        // Not clone if dim is not picked.
        target._chunks[i] = !clonedDimsMap[i] ? chunks[i] : cloneChunk(chunks[i]);
      }
    } else {
      target._chunks = chunks;
    }

    this._copyCommonProps(target);

    if (!ignoreIndices) {
      target._indices = this._cloneIndices();
    }

    target._updateGetRawIdx();

    return target;
  };

  DataStore.prototype._copyCommonProps = function (target) {
    target._count = this._count;
    target._rawCount = this._rawCount;
    target._provider = this._provider;
    target._dimensions = this._dimensions;
    target._extent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["clone"])(this._extent);
    target._rawExtent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["clone"])(this._rawExtent);
  };

  DataStore.prototype._cloneIndices = function () {
    if (this._indices) {
      var Ctor = this._indices.constructor;
      var indices = void 0;

      if (Ctor === Array) {
        var thisCount = this._indices.length;
        indices = new Ctor(thisCount);

        for (var i = 0; i < thisCount; i++) {
          indices[i] = this._indices[i];
        }
      } else {
        indices = new Ctor(this._indices);
      }

      return indices;
    }

    return null;
  };

  DataStore.prototype._getRawIdxIdentity = function (idx) {
    return idx;
  };

  DataStore.prototype._getRawIdx = function (idx) {
    if (idx < this._count && idx >= 0) {
      return this._indices[idx];
    }

    return -1;
  };

  DataStore.prototype._updateGetRawIdx = function () {
    this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
  };

  DataStore.internalField = function () {
    function getDimValueSimply(dataItem, property, dataIndex, dimIndex) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper_dataValueHelper_js__["b" /* parseDataValue */])(dataItem[dimIndex], this._dimensions[dimIndex]);
    }

    defaultDimValueGetters = {
      arrayRows: getDimValueSimply,
      objectRows: function (dataItem, property, dataIndex, dimIndex) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper_dataValueHelper_js__["b" /* parseDataValue */])(dataItem[property], this._dimensions[dimIndex]);
      },
      keyedColumns: getDimValueSimply,
      original: function (dataItem, property, dataIndex, dimIndex) {
        // Performance sensitive, do not use modelUtil.getDataItemValue.
        // If dataItem is an plain object with no value field, the let `value`
        // will be assigned with the object, but it will be tread correctly
        // in the `convertValue`.
        var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value);
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper_dataValueHelper_js__["b" /* parseDataValue */])(value instanceof Array ? value[dimIndex] // If value is a single number or something else not array.
        : value, this._dimensions[dimIndex]);
      },
      typedArray: function (dataItem, property, dataIndex, dimIndex) {
        return dataItem[dimIndex];
      }
    };
  }();

  return DataStore;
}();

/* harmony default export */ __webpack_exports__["a"] = (DataStore);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TreeNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_linkSeriesData_js__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SeriesData_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_createDimensions_js__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Tree data structure
 */






var TreeNode =
/** @class */
function () {
  function TreeNode(name, hostTree) {
    this.depth = 0;
    this.height = 0;
    /**
     * Reference to list item.
     * Do not persistent dataIndex outside,
     * besause it may be changed by list.
     * If dataIndex -1,
     * this node is logical deleted (filtered) in list.
     */

    this.dataIndex = -1;
    this.children = [];
    this.viewChildren = [];
    this.isExpand = false;
    this.name = name || '';
    this.hostTree = hostTree;
  }
  /**
   * The node is removed.
   */


  TreeNode.prototype.isRemoved = function () {
    return this.dataIndex < 0;
  };

  TreeNode.prototype.eachNode = function (options, cb, context) {
    if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"](options)) {
      context = cb;
      cb = options;
      options = null;
    }

    options = options || {};

    if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"](options)) {
      options = {
        order: options
      };
    }

    var order = options.order || 'preorder';
    var children = this[options.attr || 'children'];
    var suppressVisitSub;
    order === 'preorder' && (suppressVisitSub = cb.call(context, this));

    for (var i = 0; !suppressVisitSub && i < children.length; i++) {
      children[i].eachNode(options, cb, context);
    }

    order === 'postorder' && cb.call(context, this);
  };
  /**
   * Update depth and height of this subtree.
   */


  TreeNode.prototype.updateDepthAndHeight = function (depth) {
    var height = 0;
    this.depth = depth;

    for (var i = 0; i < this.children.length; i++) {
      var child = this.children[i];
      child.updateDepthAndHeight(depth + 1);

      if (child.height > height) {
        height = child.height;
      }
    }

    this.height = height + 1;
  };

  TreeNode.prototype.getNodeById = function (id) {
    if (this.getId() === id) {
      return this;
    }

    for (var i = 0, children = this.children, len = children.length; i < len; i++) {
      var res = children[i].getNodeById(id);

      if (res) {
        return res;
      }
    }
  };

  TreeNode.prototype.contains = function (node) {
    if (node === this) {
      return true;
    }

    for (var i = 0, children = this.children, len = children.length; i < len; i++) {
      var res = children[i].contains(node);

      if (res) {
        return res;
      }
    }
  };
  /**
   * @param includeSelf Default false.
   * @return order: [root, child, grandchild, ...]
   */


  TreeNode.prototype.getAncestors = function (includeSelf) {
    var ancestors = [];
    var node = includeSelf ? this : this.parentNode;

    while (node) {
      ancestors.push(node);
      node = node.parentNode;
    }

    ancestors.reverse();
    return ancestors;
  };

  TreeNode.prototype.getAncestorsIndices = function () {
    var indices = [];
    var currNode = this;

    while (currNode) {
      indices.push(currNode.dataIndex);
      currNode = currNode.parentNode;
    }

    indices.reverse();
    return indices;
  };

  TreeNode.prototype.getDescendantIndices = function () {
    var indices = [];
    this.eachNode(function (childNode) {
      indices.push(childNode.dataIndex);
    });
    return indices;
  };

  TreeNode.prototype.getValue = function (dimension) {
    var data = this.hostTree.data;
    return data.getStore().get(data.getDimensionIndex(dimension || 'value'), this.dataIndex);
  };

  TreeNode.prototype.setLayout = function (layout, merge) {
    this.dataIndex >= 0 && this.hostTree.data.setItemLayout(this.dataIndex, layout, merge);
  };
  /**
   * @return {Object} layout
   */


  TreeNode.prototype.getLayout = function () {
    return this.hostTree.data.getItemLayout(this.dataIndex);
  }; // @depcrecated
  // getModel<T = unknown, S extends keyof T = keyof T>(path: S): Model<T[S]>
  // eslint-disable-next-line @typescript-eslint/no-unused-vars


  TreeNode.prototype.getModel = function (path) {
    if (this.dataIndex < 0) {
      return;
    }

    var hostTree = this.hostTree;
    var itemModel = hostTree.data.getItemModel(this.dataIndex);
    return itemModel.getModel(path);
  }; // TODO: TYPE More specific model


  TreeNode.prototype.getLevelModel = function () {
    return (this.hostTree.levelModels || [])[this.depth];
  };

  TreeNode.prototype.setVisual = function (key, value) {
    this.dataIndex >= 0 && this.hostTree.data.setItemVisual(this.dataIndex, key, value);
  };
  /**
   * Get item visual
   * FIXME: make return type better
   */


  TreeNode.prototype.getVisual = function (key) {
    return this.hostTree.data.getItemVisual(this.dataIndex, key);
  };

  TreeNode.prototype.getRawIndex = function () {
    return this.hostTree.data.getRawIndex(this.dataIndex);
  };

  TreeNode.prototype.getId = function () {
    return this.hostTree.data.getId(this.dataIndex);
  };
  /**
   * index in parent's children
   */


  TreeNode.prototype.getChildIndex = function () {
    if (this.parentNode) {
      var children = this.parentNode.children;

      for (var i = 0; i < children.length; ++i) {
        if (children[i] === this) {
          return i;
        }
      }

      return -1;
    }

    return -1;
  };
  /**
   * if this is an ancestor of another node
   *
   * @param node another node
   * @return if is ancestor
   */


  TreeNode.prototype.isAncestorOf = function (node) {
    var parent = node.parentNode;

    while (parent) {
      if (parent === this) {
        return true;
      }

      parent = parent.parentNode;
    }

    return false;
  };
  /**
   * if this is an descendant of another node
   *
   * @param node another node
   * @return if is descendant
   */


  TreeNode.prototype.isDescendantOf = function (node) {
    return node !== this && node.isAncestorOf(this);
  };

  return TreeNode;
}();


;

var Tree =
/** @class */
function () {
  function Tree(hostModel) {
    this.type = 'tree';
    this._nodes = [];
    this.hostModel = hostModel;
  }

  Tree.prototype.eachNode = function (options, cb, context) {
    this.root.eachNode(options, cb, context);
  };

  Tree.prototype.getNodeByDataIndex = function (dataIndex) {
    var rawIndex = this.data.getRawIndex(dataIndex);
    return this._nodes[rawIndex];
  };

  Tree.prototype.getNodeById = function (name) {
    return this.root.getNodeById(name);
  };
  /**
   * Update item available by list,
   * when list has been performed options like 'filterSelf' or 'map'.
   */


  Tree.prototype.update = function () {
    var data = this.data;
    var nodes = this._nodes;

    for (var i = 0, len = nodes.length; i < len; i++) {
      nodes[i].dataIndex = -1;
    }

    for (var i = 0, len = data.count(); i < len; i++) {
      nodes[data.getRawIndex(i)].dataIndex = i;
    }
  };
  /**
   * Clear all layouts
   */


  Tree.prototype.clearLayouts = function () {
    this.data.clearItemLayouts();
  };
  /**
   * data node format:
   * {
   *     name: ...
   *     value: ...
   *     children: [
   *         {
   *             name: ...
   *             value: ...
   *             children: ...
   *         },
   *         ...
   *     ]
   * }
   */


  Tree.createTree = function (dataRoot, hostModel, beforeLink) {
    var tree = new Tree(hostModel);
    var listData = [];
    var dimMax = 1;
    buildHierarchy(dataRoot);

    function buildHierarchy(dataNode, parentNode) {
      var value = dataNode.value;
      dimMax = Math.max(dimMax, __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](value) ? value.length : 1);
      listData.push(dataNode);
      var node = new TreeNode(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_model_js__["n" /* convertOptionIdName */])(dataNode.name, ''), tree);
      parentNode ? addChild(node, parentNode) : tree.root = node;

      tree._nodes.push(node);

      var children = dataNode.children;

      if (children) {
        for (var i = 0; i < children.length; i++) {
          buildHierarchy(children[i], node);
        }
      }
    }

    tree.root.updateDepthAndHeight(0);
    var dimensions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_createDimensions_js__["a" /* default */])(listData, {
      coordDimensions: ['value'],
      dimensionsCount: dimMax
    }).dimensions;
    var list = new __WEBPACK_IMPORTED_MODULE_2__SeriesData_js__["a" /* default */](dimensions, hostModel);
    list.initData(listData);
    beforeLink && beforeLink(list);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper_linkSeriesData_js__["a" /* default */])({
      mainData: list,
      struct: tree,
      structAttr: 'tree'
    });
    tree.update();
    return tree;
  };

  return Tree;
}();
/**
 * It is needed to consider the mess of 'list', 'hostModel' when creating a TreeNote,
 * so this function is not ready and not necessary to be public.
 */


function addChild(child, node) {
  var children = node.children;

  if (child.parentNode === node) {
    return;
  }

  children.push(child);
  child.parentNode = node;
}

/* harmony default export */ __webpack_exports__["a"] = (Tree);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SeriesDataSchema; });
/* harmony export (immutable) */ __webpack_exports__["a"] = isSeriesDataSchema;
/* harmony export (immutable) */ __webpack_exports__["d"] = createDimNameMap;
/* harmony export (immutable) */ __webpack_exports__["c"] = ensureSourceDimNameMap;
/* harmony export (immutable) */ __webpack_exports__["b"] = shouldOmitUnusedDimensions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Source_js__ = __webpack_require__(114);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var inner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_model_js__["a" /* makeInner */])();
var dimTypeShort = {
  float: 'f',
  int: 'i',
  ordinal: 'o',
  number: 'n',
  time: 't'
};
/**
 * Represents the dimension requirement of a series.
 *
 * NOTICE:
 * When there are too many dimensions in dataset and many series, only the used dimensions
 * (i.e., used by coord sys and declared in `series.encode`) are add to `dimensionDefineList`.
 * But users may query data by other unused dimension names.
 * In this case, users can only query data if and only if they have defined dimension names
 * via ec option, so we provide `getDimensionIndexFromSource`, which only query them from
 * `source` dimensions.
 */

var SeriesDataSchema =
/** @class */
function () {
  function SeriesDataSchema(opt) {
    this.dimensions = opt.dimensions;
    this._dimOmitted = opt.dimensionOmitted;
    this.source = opt.source;
    this._fullDimCount = opt.fullDimensionCount;

    this._updateDimOmitted(opt.dimensionOmitted);
  }

  SeriesDataSchema.prototype.isDimensionOmitted = function () {
    return this._dimOmitted;
  };

  SeriesDataSchema.prototype._updateDimOmitted = function (dimensionOmitted) {
    this._dimOmitted = dimensionOmitted;

    if (!dimensionOmitted) {
      return;
    }

    if (!this._dimNameMap) {
      this._dimNameMap = ensureSourceDimNameMap(this.source);
    }
  };
  /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Get index by user defined dimension name (i.e., not internal generate name).
   * That is, get index from `dimensionsDefine`.
   * If no `dimensionsDefine`, or no name get, return -1.
   */


  SeriesDataSchema.prototype.getSourceDimensionIndex = function (dimName) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve2"])(this._dimNameMap.get(dimName), -1);
  };
  /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Notice: may return `null`/`undefined` if user not specify dimension names.
   */


  SeriesDataSchema.prototype.getSourceDimension = function (dimIndex) {
    var dimensionsDefine = this.source.dimensionsDefine;

    if (dimensionsDefine) {
      return dimensionsDefine[dimIndex];
    }
  };

  SeriesDataSchema.prototype.makeStoreSchema = function () {
    var dimCount = this._fullDimCount;
    var willRetrieveDataByName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Source_js__["e" /* shouldRetrieveDataByName */])(this.source);
    var makeHashStrict = !shouldOmitUnusedDimensions(dimCount); // If source don't have dimensions or series don't omit unsed dimensions.
    // Generate from seriesDimList directly

    var dimHash = '';
    var dims = [];

    for (var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < dimCount; fullDimIdx++) {
      var property = void 0;
      var type = void 0;
      var ordinalMeta = void 0;
      var seriesDimDef = this.dimensions[seriesDimIdx]; // The list has been sorted by `storeDimIndex` asc.

      if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
        property = willRetrieveDataByName ? seriesDimDef.name : null;
        type = seriesDimDef.type;
        ordinalMeta = seriesDimDef.ordinalMeta;
        seriesDimIdx++;
      } else {
        var sourceDimDef = this.getSourceDimension(fullDimIdx);

        if (sourceDimDef) {
          property = willRetrieveDataByName ? sourceDimDef.name : null;
          type = sourceDimDef.type;
        }
      }

      dims.push({
        property: property,
        type: type,
        ordinalMeta: ordinalMeta
      }); // If retrieving data by index,
      //   use <index, type, ordinalMeta> to determine whether data can be shared.
      //   (Becuase in this case there might be no dimension name defined in dataset, but indices always exists).
      //   (indices are always 0, 1, 2, ..., so we can ignore them to shorten the hash).
      // Otherwise if retrieving data by property name (like `data: [{aa: 123, bb: 765}, ...]`),
      //   use <property, type, ordinalMeta> in hash.

      if (willRetrieveDataByName && property != null // For data stack, we have make sure each series has its own dim on this store.
      // So we do not add property to hash to make sure they can share this store.
      && (!seriesDimDef || !seriesDimDef.isCalculationCoord)) {
        dimHash += makeHashStrict // Use escape character '`' in case that property name contains '$'.
        ? property.replace(/\`/g, '`1').replace(/\$/g, '`2') // For better performance, when there are large dimensions, tolerant this defects that hardly meet.
        : property;
      }

      dimHash += '$';
      dimHash += dimTypeShort[type] || 'f';

      if (ordinalMeta) {
        dimHash += ordinalMeta.uid;
      }

      dimHash += '$';
    } // Source from endpoint(usually series) will be read differently
    // when seriesLayoutBy or startIndex(which is affected by sourceHeader) are different.
    // So we use this three props as key.


    var source = this.source;
    var hash = [source.seriesLayoutBy, source.startIndex, dimHash].join('$$');
    return {
      dimensions: dims,
      hash: hash
    };
  };

  SeriesDataSchema.prototype.makeOutputDimensionNames = function () {
    var result = [];

    for (var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < this._fullDimCount; fullDimIdx++) {
      var name_1 = void 0;
      var seriesDimDef = this.dimensions[seriesDimIdx]; // The list has been sorted by `storeDimIndex` asc.

      if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
        if (!seriesDimDef.isCalculationCoord) {
          name_1 = seriesDimDef.name;
        }

        seriesDimIdx++;
      } else {
        var sourceDimDef = this.getSourceDimension(fullDimIdx);

        if (sourceDimDef) {
          name_1 = sourceDimDef.name;
        }
      }

      result.push(name_1);
    }

    return result;
  };

  SeriesDataSchema.prototype.appendCalculationDimension = function (dimDef) {
    this.dimensions.push(dimDef);
    dimDef.isCalculationCoord = true;
    this._fullDimCount++; // If append dimension on a data store, consider the store
    // might be shared by different series, series dimensions not
    // really map to store dimensions.

    this._updateDimOmitted(true);
  };

  return SeriesDataSchema;
}();


function isSeriesDataSchema(schema) {
  return schema instanceof SeriesDataSchema;
}
function createDimNameMap(dimsDef) {
  var dataDimNameMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();

  for (var i = 0; i < (dimsDef || []).length; i++) {
    var dimDefItemRaw = dimsDef[i];
    var userDimName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"])(dimDefItemRaw) ? dimDefItemRaw.name : dimDefItemRaw;

    if (userDimName != null && dataDimNameMap.get(userDimName) == null) {
      dataDimNameMap.set(userDimName, i);
    }
  }

  return dataDimNameMap;
}
function ensureSourceDimNameMap(source) {
  var innerSource = inner(source);
  return innerSource.dimNameMap || (innerSource.dimNameMap = createDimNameMap(source.dimensionsDefine));
}
function shouldOmitUnusedDimensions(dimCount) {
  return dimCount > 30;
}

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = prepareLayoutList;
/* harmony export (immutable) */ __webpack_exports__["b"] = shiftLayoutOnX;
/* harmony export (immutable) */ __webpack_exports__["c"] = shiftLayoutOnY;
/* harmony export (immutable) */ __webpack_exports__["d"] = hideOverlap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__ = __webpack_require__(4);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

function prepareLayoutList(input) {
  var list = [];

  for (var i = 0; i < input.length; i++) {
    var rawItem = input[i];

    if (rawItem.defaultAttr.ignore) {
      continue;
    }

    var label = rawItem.label;
    var transform = label.getComputedTransform(); // NOTE: Get bounding rect after getComputedTransform, or label may not been updated by the host el.

    var localRect = label.getBoundingRect();
    var isAxisAligned = !transform || transform[1] < 1e-5 && transform[2] < 1e-5;
    var minMargin = label.style.margin || 0;
    var globalRect = localRect.clone();
    globalRect.applyTransform(transform);
    globalRect.x -= minMargin / 2;
    globalRect.y -= minMargin / 2;
    globalRect.width += minMargin;
    globalRect.height += minMargin;
    var obb = isAxisAligned ? new __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["OrientedBoundingRect"](localRect, transform) : null;
    list.push({
      label: label,
      labelLine: rawItem.labelLine,
      rect: globalRect,
      localRect: localRect,
      obb: obb,
      priority: rawItem.priority,
      defaultAttr: rawItem.defaultAttr,
      layoutOption: rawItem.computedLayoutOption,
      axisAligned: isAxisAligned,
      transform: transform
    });
  }

  return list;
}

function shiftLayout(list, xyDim, sizeDim, minBound, maxBound, balanceShift) {
  var len = list.length;

  if (len < 2) {
    return;
  }

  list.sort(function (a, b) {
    return a.rect[xyDim] - b.rect[xyDim];
  });
  var lastPos = 0;
  var delta;
  var adjusted = false;
  var shifts = [];
  var totalShifts = 0;

  for (var i = 0; i < len; i++) {
    var item = list[i];
    var rect = item.rect;
    delta = rect[xyDim] - lastPos;

    if (delta < 0) {
      // shiftForward(i, len, -delta);
      rect[xyDim] -= delta;
      item.label[xyDim] -= delta;
      adjusted = true;
    }

    var shift = Math.max(-delta, 0);
    shifts.push(shift);
    totalShifts += shift;
    lastPos = rect[xyDim] + rect[sizeDim];
  }

  if (totalShifts > 0 && balanceShift) {
    // Shift back to make the distribution more equally.
    shiftList(-totalShifts / len, 0, len);
  } // TODO bleedMargin?


  var first = list[0];
  var last = list[len - 1];
  var minGap;
  var maxGap;
  updateMinMaxGap(); // If ends exceed two bounds, squeeze at most 80%, then take the gap of two bounds.

  minGap < 0 && squeezeGaps(-minGap, 0.8);
  maxGap < 0 && squeezeGaps(maxGap, 0.8);
  updateMinMaxGap();
  takeBoundsGap(minGap, maxGap, 1);
  takeBoundsGap(maxGap, minGap, -1); // Handle bailout when there is not enough space.

  updateMinMaxGap();

  if (minGap < 0) {
    squeezeWhenBailout(-minGap);
  }

  if (maxGap < 0) {
    squeezeWhenBailout(maxGap);
  }

  function updateMinMaxGap() {
    minGap = first.rect[xyDim] - minBound;
    maxGap = maxBound - last.rect[xyDim] - last.rect[sizeDim];
  }

  function takeBoundsGap(gapThisBound, gapOtherBound, moveDir) {
    if (gapThisBound < 0) {
      // Move from other gap if can.
      var moveFromMaxGap = Math.min(gapOtherBound, -gapThisBound);

      if (moveFromMaxGap > 0) {
        shiftList(moveFromMaxGap * moveDir, 0, len);
        var remained = moveFromMaxGap + gapThisBound;

        if (remained < 0) {
          squeezeGaps(-remained * moveDir, 1);
        }
      } else {
        squeezeGaps(-gapThisBound * moveDir, 1);
      }
    }
  }

  function shiftList(delta, start, end) {
    if (delta !== 0) {
      adjusted = true;
    }

    for (var i = start; i < end; i++) {
      var item = list[i];
      var rect = item.rect;
      rect[xyDim] += delta;
      item.label[xyDim] += delta;
    }
  } // Squeeze gaps if the labels exceed margin.


  function squeezeGaps(delta, maxSqeezePercent) {
    var gaps = [];
    var totalGaps = 0;

    for (var i = 1; i < len; i++) {
      var prevItemRect = list[i - 1].rect;
      var gap = Math.max(list[i].rect[xyDim] - prevItemRect[xyDim] - prevItemRect[sizeDim], 0);
      gaps.push(gap);
      totalGaps += gap;
    }

    if (!totalGaps) {
      return;
    }

    var squeezePercent = Math.min(Math.abs(delta) / totalGaps, maxSqeezePercent);

    if (delta > 0) {
      for (var i = 0; i < len - 1; i++) {
        // Distribute the shift delta to all gaps.
        var movement = gaps[i] * squeezePercent; // Forward

        shiftList(movement, 0, i + 1);
      }
    } else {
      // Backward
      for (var i = len - 1; i > 0; i--) {
        // Distribute the shift delta to all gaps.
        var movement = gaps[i - 1] * squeezePercent;
        shiftList(-movement, i, len);
      }
    }
  }
  /**
   * Squeeze to allow overlap if there is no more space available.
   * Let other overlapping strategy like hideOverlap do the job instead of keep exceeding the bounds.
   */


  function squeezeWhenBailout(delta) {
    var dir = delta < 0 ? -1 : 1;
    delta = Math.abs(delta);
    var moveForEachLabel = Math.ceil(delta / (len - 1));

    for (var i = 0; i < len - 1; i++) {
      if (dir > 0) {
        // Forward
        shiftList(moveForEachLabel, 0, i + 1);
      } else {
        // Backward
        shiftList(-moveForEachLabel, len - i - 1, len);
      }

      delta -= moveForEachLabel;

      if (delta <= 0) {
        return;
      }
    }
  }

  return adjusted;
}
/**
 * Adjust labels on x direction to avoid overlap.
 */


function shiftLayoutOnX(list, leftBound, rightBound, // If average the shifts on all labels and add them to 0
// TODO: Not sure if should enable it.
// Pros: The angle of lines will distribute more equally
// Cons: In some layout. It may not what user wanted. like in pie. the label of last sector is usually changed unexpectedly.
balanceShift) {
  return shiftLayout(list, 'x', 'width', leftBound, rightBound, balanceShift);
}
/**
 * Adjust labels on y direction to avoid overlap.
 */

function shiftLayoutOnY(list, topBound, bottomBound, // If average the shifts on all labels and add them to 0
balanceShift) {
  return shiftLayout(list, 'y', 'height', topBound, bottomBound, balanceShift);
}
function hideOverlap(labelList) {
  var displayedLabels = []; // TODO, render overflow visible first, put in the displayedLabels.

  labelList.sort(function (a, b) {
    return b.priority - a.priority;
  });
  var globalRect = new __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["BoundingRect"](0, 0, 0, 0);

  function hideEl(el) {
    if (!el.ignore) {
      // Show on emphasis.
      var emphasisState = el.ensureState('emphasis');

      if (emphasisState.ignore == null) {
        emphasisState.ignore = false;
      }
    }

    el.ignore = true;
  }

  for (var i = 0; i < labelList.length; i++) {
    var labelItem = labelList[i];
    var isAxisAligned = labelItem.axisAligned;
    var localRect = labelItem.localRect;
    var transform = labelItem.transform;
    var label = labelItem.label;
    var labelLine = labelItem.labelLine;
    globalRect.copy(labelItem.rect); // Add a threshold because layout may be aligned precisely.

    globalRect.width -= 0.1;
    globalRect.height -= 0.1;
    globalRect.x += 0.05;
    globalRect.y += 0.05;
    var obb = labelItem.obb;
    var overlapped = false;

    for (var j = 0; j < displayedLabels.length; j++) {
      var existsTextCfg = displayedLabels[j]; // Fast rejection.

      if (!globalRect.intersect(existsTextCfg.rect)) {
        continue;
      }

      if (isAxisAligned && existsTextCfg.axisAligned) {
        // Is overlapped
        overlapped = true;
        break;
      }

      if (!existsTextCfg.obb) {
        // If self is not axis aligned. But other is.
        existsTextCfg.obb = new __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["OrientedBoundingRect"](existsTextCfg.localRect, existsTextCfg.transform);
      }

      if (!obb) {
        // If self is axis aligned. But other is not.
        obb = new __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["OrientedBoundingRect"](localRect, transform);
      }

      if (obb.intersect(existsTextCfg.obb)) {
        overlapped = true;
        break;
      }
    } // TODO Callback to determine if this overlap should be handled?


    if (overlapped) {
      hideEl(label);
      labelLine && hideEl(labelLine);
    } else {
      label.attr('ignore', labelItem.defaultAttr.ignore);
      labelLine && labelLine.attr('ignore', labelItem.defaultAttr.labelGuideIgnore);
      displayedLabels.push(labelItem);
    }
  }
}

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createLegacyDataSelectAction;
/* harmony export (immutable) */ __webpack_exports__["a"] = handleLegacySelectEvents;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_log_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


 // Legacy data selection action.
// Inlucdes: pieSelect, pieUnSelect, pieToggleSelect, mapSelect, mapUnSelect, mapToggleSelect

function createLegacyDataSelectAction(seriesType, ecRegisterAction) {
  function getSeriesIndices(ecModel, payload) {
    var seriesIndices = [];
    ecModel.eachComponent({
      mainType: 'series',
      subType: seriesType,
      query: payload
    }, function (seriesModel) {
      seriesIndices.push(seriesModel.seriesIndex);
    });
    return seriesIndices;
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])([[seriesType + 'ToggleSelect', 'toggleSelect'], [seriesType + 'Select', 'select'], [seriesType + 'UnSelect', 'unselect']], function (eventsMap) {
    ecRegisterAction(eventsMap[0], function (payload, ecModel, api) {
      payload = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"])({}, payload);

      if (true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_log_js__["a" /* deprecateReplaceLog */])(payload.type, eventsMap[1]);
      }

      api.dispatchAction(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"])(payload, {
        type: eventsMap[1],
        seriesIndex: getSeriesIndices(ecModel, payload)
      }));
    });
  });
}

function handleSeriesLegacySelectEvents(type, eventPostfix, ecIns, ecModel, payload) {
  var legacyEventName = type + eventPostfix;

  if (!ecIns.isSilent(legacyEventName)) {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_log_js__["g" /* deprecateLog */])("event " + legacyEventName + " is deprecated.");
    }

    ecModel.eachComponent({
      mainType: 'series',
      subType: 'pie'
    }, function (seriesModel) {
      var seriesIndex = seriesModel.seriesIndex;
      var selectedMap = seriesModel.option.selectedMap;
      var selected = payload.selected;

      for (var i = 0; i < selected.length; i++) {
        if (selected[i].seriesIndex === seriesIndex) {
          var data = seriesModel.getData();
          var dataIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_model_js__["c" /* queryDataIndex */])(data, payload.fromActionPayload);
          ecIns.trigger(legacyEventName, {
            type: legacyEventName,
            seriesId: seriesModel.id,
            name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"])(dataIndex) ? data.getName(dataIndex[0]) : data.getName(dataIndex),
            selected: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"])(selectedMap) ? selectedMap : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"])({}, selectedMap)
          });
        }
      }
    });
  }
}

function handleLegacySelectEvents(messageCenter, ecIns, api) {
  messageCenter.on('selectchanged', function (params) {
    var ecModel = api.getModel();

    if (params.isFromClick) {
      handleSeriesLegacySelectEvents('map', 'selectchanged', ecIns, ecModel, params);
      handleSeriesLegacySelectEvents('pie', 'selectchanged', ecIns, ecModel, params);
    } else if (params.fromAction === 'select') {
      handleSeriesLegacySelectEvents('map', 'selected', ecIns, ecModel, params);
      handleSeriesLegacySelectEvents('pie', 'selected', ecIns, ecModel, params);
    } else if (params.fromAction === 'unselect') {
      handleSeriesLegacySelectEvents('map', 'unselected', ecIns, ecModel, params);
      handleSeriesLegacySelectEvents('pie', 'unselected', ecIns, ecModel, params);
    }
  });
}

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findEventDispatcher;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function findEventDispatcher(target, det, returnFirstMatch) {
  var found;

  while (target) {
    if (det(target)) {
      found = target;

      if (returnFirstMatch) {
        break;
      }
    }

    target = target.__hostTarget || target.parent;
  }

  return found;
}

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(87);



/* Built-in method references that are verified to be native. */
var Map = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayPush);


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(250);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(objValue, value)) ||
      (value === undefined && !(key in object))) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignValue);


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(521);


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */]) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssignValue);


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__ = __webpack_require__(1383);


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](result).set(new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](arrayBuffer));
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneArrayBuffer);


/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(527);


/** Built-in value references. */
var getPrototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubArray_js__ = __webpack_require__(535);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_1__stubArray_js__["a" /* default */] : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */])(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbols);


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataView_js__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_js__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Set_js__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toSource_js__ = __webpack_require__(531);








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */]),
    mapCtorString = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]),
    promiseCtorString = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */]),
    setCtorString = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]),
    weakMapCtorString = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */](new ArrayBuffer(1))) != dataViewTag) ||
    (__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]) != mapTag) ||
    (__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */] && getTag(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */].resolve()) != promiseTag) ||
    (__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]) != setTag) ||
    (__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getTag);


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(523);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(357)(module)))

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__(1470);



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(357)(module)))

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(88);



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(115);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeys_js__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(252);




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseKeys_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keys);


/***/ }),
/* 353 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1656)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(634),
  /* template */
  __webpack_require__(1586),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-707e1f82",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/common/tableau/Tableau.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Tableau.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-707e1f82", Component.options)
  } else {
    hotAPI.reload("data-v-707e1f82", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1652)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(661),
  /* template */
  __webpack_require__(1583),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-686a6933",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/sysmanagement/dictlist/dictitem.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] dictitem.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-686a6933", Component.options)
  } else {
    hotAPI.reload("data-v-686a6933", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1638)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(668),
  /* template */
  __webpack_require__(1569),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-454b3b23",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/sysmanagement/role/roleprivilege.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] roleprivilege.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-454b3b23", Component.options)
  } else {
    hotAPI.reload("data-v-454b3b23", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = cloneValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Clip_js__ = __webpack_require__(1693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tool_color_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__easing_js__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cubicEasing_js__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_helper_js__ = __webpack_require__(168);






;
var arraySlice = Array.prototype.slice;
function interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
function interpolate1DArray(out, p0, p1, percent) {
    var len = p0.length;
    for (var i = 0; i < len; i++) {
        out[i] = interpolateNumber(p0[i], p1[i], percent);
    }
    return out;
}
function interpolate2DArray(out, p0, p1, percent) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for (var i = 0; i < len; i++) {
        if (!out[i]) {
            out[i] = [];
        }
        for (var j = 0; j < len2; j++) {
            out[i][j] = interpolateNumber(p0[i][j], p1[i][j], percent);
        }
    }
    return out;
}
function add1DArray(out, p0, p1, sign) {
    var len = p0.length;
    for (var i = 0; i < len; i++) {
        out[i] = p0[i] + p1[i] * sign;
    }
    return out;
}
function add2DArray(out, p0, p1, sign) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for (var i = 0; i < len; i++) {
        if (!out[i]) {
            out[i] = [];
        }
        for (var j = 0; j < len2; j++) {
            out[i][j] = p0[i][j] + p1[i][j] * sign;
        }
    }
    return out;
}
function fillColorStops(val0, val1) {
    var len0 = val0.length;
    var len1 = val1.length;
    var shorterArr = len0 > len1 ? val1 : val0;
    var shorterLen = Math.min(len0, len1);
    var last = shorterArr[shorterLen - 1] || { color: [0, 0, 0, 0], offset: 0 };
    for (var i = shorterLen; i < Math.max(len0, len1); i++) {
        shorterArr.push({
            offset: last.offset,
            color: last.color.slice()
        });
    }
}
function fillArray(val0, val1, arrDim) {
    var arr0 = val0;
    var arr1 = val1;
    if (!arr0.push || !arr1.push) {
        return;
    }
    var arr0Len = arr0.length;
    var arr1Len = arr1.length;
    if (arr0Len !== arr1Len) {
        var isPreviousLarger = arr0Len > arr1Len;
        if (isPreviousLarger) {
            arr0.length = arr1Len;
        }
        else {
            for (var i = arr0Len; i < arr1Len; i++) {
                arr0.push(arrDim === 1 ? arr1[i] : arraySlice.call(arr1[i]));
            }
        }
    }
    var len2 = arr0[0] && arr0[0].length;
    for (var i = 0; i < arr0.length; i++) {
        if (arrDim === 1) {
            if (isNaN(arr0[i])) {
                arr0[i] = arr1[i];
            }
        }
        else {
            for (var j = 0; j < len2; j++) {
                if (isNaN(arr0[i][j])) {
                    arr0[i][j] = arr1[i][j];
                }
            }
        }
    }
}
function cloneValue(value) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["isArrayLike"])(value)) {
        var len = value.length;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["isArrayLike"])(value[0])) {
            var ret = [];
            for (var i = 0; i < len; i++) {
                ret.push(arraySlice.call(value[i]));
            }
            return ret;
        }
        return arraySlice.call(value);
    }
    return value;
}
function rgba2String(rgba) {
    rgba[0] = Math.floor(rgba[0]) || 0;
    rgba[1] = Math.floor(rgba[1]) || 0;
    rgba[2] = Math.floor(rgba[2]) || 0;
    rgba[3] = rgba[3] == null ? 1 : rgba[3];
    return 'rgba(' + rgba.join(',') + ')';
}
function guessArrayDim(value) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["isArrayLike"])(value && value[0]) ? 2 : 1;
}
var VALUE_TYPE_NUMBER = 0;
var VALUE_TYPE_1D_ARRAY = 1;
var VALUE_TYPE_2D_ARRAY = 2;
var VALUE_TYPE_COLOR = 3;
var VALUE_TYPE_LINEAR_GRADIENT = 4;
var VALUE_TYPE_RADIAL_GRADIENT = 5;
var VALUE_TYPE_UNKOWN = 6;
function isGradientValueType(valType) {
    return valType === VALUE_TYPE_LINEAR_GRADIENT || valType === VALUE_TYPE_RADIAL_GRADIENT;
}
function isArrayValueType(valType) {
    return valType === VALUE_TYPE_1D_ARRAY || valType === VALUE_TYPE_2D_ARRAY;
}
var tmpRgba = [0, 0, 0, 0];
var Track = (function () {
    function Track(propName) {
        this.keyframes = [];
        this.discrete = false;
        this._invalid = false;
        this._needsSort = false;
        this._lastFr = 0;
        this._lastFrP = 0;
        this.propName = propName;
    }
    Track.prototype.isFinished = function () {
        return this._finished;
    };
    Track.prototype.setFinished = function () {
        this._finished = true;
        if (this._additiveTrack) {
            this._additiveTrack.setFinished();
        }
    };
    Track.prototype.needsAnimate = function () {
        return this.keyframes.length >= 1;
    };
    Track.prototype.getAdditiveTrack = function () {
        return this._additiveTrack;
    };
    Track.prototype.addKeyframe = function (time, rawValue, easing) {
        this._needsSort = true;
        var keyframes = this.keyframes;
        var len = keyframes.length;
        var discrete = false;
        var valType = VALUE_TYPE_UNKOWN;
        var value = rawValue;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["isArrayLike"])(rawValue)) {
            var arrayDim = guessArrayDim(rawValue);
            valType = arrayDim;
            if (arrayDim === 1 && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["isNumber"])(rawValue[0])
                || arrayDim === 2 && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["isNumber"])(rawValue[0][0])) {
                discrete = true;
            }
        }
        else {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["isNumber"])(rawValue) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["eqNaN"])(rawValue)) {
                valType = VALUE_TYPE_NUMBER;
            }
            else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["isString"])(rawValue)) {
                if (!isNaN(+rawValue)) {
                    valType = VALUE_TYPE_NUMBER;
                }
                else {
                    var colorArray = __WEBPACK_IMPORTED_MODULE_1__tool_color_js__["parse"](rawValue);
                    if (colorArray) {
                        value = colorArray;
                        valType = VALUE_TYPE_COLOR;
                    }
                }
            }
            else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["isGradientObject"])(rawValue)) {
                var parsedGradient = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["extend"])({}, value);
                parsedGradient.colorStops = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["map"])(rawValue.colorStops, function (colorStop) { return ({
                    offset: colorStop.offset,
                    color: __WEBPACK_IMPORTED_MODULE_1__tool_color_js__["parse"](colorStop.color)
                }); });
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__svg_helper_js__["a" /* isLinearGradient */])(rawValue)) {
                    valType = VALUE_TYPE_LINEAR_GRADIENT;
                }
                else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__svg_helper_js__["b" /* isRadialGradient */])(rawValue)) {
                    valType = VALUE_TYPE_RADIAL_GRADIENT;
                }
                value = parsedGradient;
            }
        }
        if (len === 0) {
            this.valType = valType;
        }
        else if (valType !== this.valType || valType === VALUE_TYPE_UNKOWN) {
            discrete = true;
        }
        this.discrete = this.discrete || discrete;
        var kf = {
            time: time,
            value: value,
            rawValue: rawValue,
            percent: 0
        };
        if (easing) {
            kf.easing = easing;
            kf.easingFunc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["isFunction"])(easing)
                ? easing
                : __WEBPACK_IMPORTED_MODULE_3__easing_js__["a" /* default */][easing] || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__cubicEasing_js__["a" /* createCubicEasingFunc */])(easing);
        }
        keyframes.push(kf);
        return kf;
    };
    Track.prototype.prepare = function (maxTime, additiveTrack) {
        var kfs = this.keyframes;
        if (this._needsSort) {
            kfs.sort(function (a, b) {
                return a.time - b.time;
            });
        }
        var valType = this.valType;
        var kfsLen = kfs.length;
        var lastKf = kfs[kfsLen - 1];
        var isDiscrete = this.discrete;
        var isArr = isArrayValueType(valType);
        var isGradient = isGradientValueType(valType);
        for (var i = 0; i < kfsLen; i++) {
            var kf = kfs[i];
            var value = kf.value;
            var lastValue = lastKf.value;
            kf.percent = kf.time / maxTime;
            if (!isDiscrete) {
                if (isArr && i !== kfsLen - 1) {
                    fillArray(value, lastValue, valType);
                }
                else if (isGradient) {
                    fillColorStops(value.colorStops, lastValue.colorStops);
                }
            }
        }
        if (!isDiscrete
            && valType !== VALUE_TYPE_RADIAL_GRADIENT
            && additiveTrack
            && this.needsAnimate()
            && additiveTrack.needsAnimate()
            && valType === additiveTrack.valType
            && !additiveTrack._finished) {
            this._additiveTrack = additiveTrack;
            var startValue = kfs[0].value;
            for (var i = 0; i < kfsLen; i++) {
                if (valType === VALUE_TYPE_NUMBER) {
                    kfs[i].additiveValue = kfs[i].value - startValue;
                }
                else if (valType === VALUE_TYPE_COLOR) {
                    kfs[i].additiveValue =
                        add1DArray([], kfs[i].value, startValue, -1);
                }
                else if (isArrayValueType(valType)) {
                    kfs[i].additiveValue = valType === VALUE_TYPE_1D_ARRAY
                        ? add1DArray([], kfs[i].value, startValue, -1)
                        : add2DArray([], kfs[i].value, startValue, -1);
                }
            }
        }
    };
    Track.prototype.step = function (target, percent) {
        if (this._finished) {
            return;
        }
        if (this._additiveTrack && this._additiveTrack._finished) {
            this._additiveTrack = null;
        }
        var isAdditive = this._additiveTrack != null;
        var valueKey = isAdditive ? 'additiveValue' : 'value';
        var valType = this.valType;
        var keyframes = this.keyframes;
        var kfsNum = keyframes.length;
        var propName = this.propName;
        var isValueColor = valType === VALUE_TYPE_COLOR;
        var frameIdx;
        var lastFrame = this._lastFr;
        var mathMin = Math.min;
        var frame;
        var nextFrame;
        if (kfsNum === 1) {
            frame = nextFrame = keyframes[0];
        }
        else {
            if (percent < 0) {
                frameIdx = 0;
            }
            else if (percent < this._lastFrP) {
                var start = mathMin(lastFrame + 1, kfsNum - 1);
                for (frameIdx = start; frameIdx >= 0; frameIdx--) {
                    if (keyframes[frameIdx].percent <= percent) {
                        break;
                    }
                }
                frameIdx = mathMin(frameIdx, kfsNum - 2);
            }
            else {
                for (frameIdx = lastFrame; frameIdx < kfsNum; frameIdx++) {
                    if (keyframes[frameIdx].percent > percent) {
                        break;
                    }
                }
                frameIdx = mathMin(frameIdx - 1, kfsNum - 2);
            }
            nextFrame = keyframes[frameIdx + 1];
            frame = keyframes[frameIdx];
        }
        if (!(frame && nextFrame)) {
            return;
        }
        this._lastFr = frameIdx;
        this._lastFrP = percent;
        var interval = (nextFrame.percent - frame.percent);
        var w = interval === 0 ? 1 : mathMin((percent - frame.percent) / interval, 1);
        if (nextFrame.easingFunc) {
            w = nextFrame.easingFunc(w);
        }
        var targetArr = isAdditive ? this._additiveValue
            : (isValueColor ? tmpRgba : target[propName]);
        if ((isArrayValueType(valType) || isValueColor) && !targetArr) {
            targetArr = this._additiveValue = [];
        }
        if (this.discrete) {
            target[propName] = w < 1 ? frame.rawValue : nextFrame.rawValue;
        }
        else if (isArrayValueType(valType)) {
            valType === VALUE_TYPE_1D_ARRAY
                ? interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w)
                : interpolate2DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
        }
        else if (isGradientValueType(valType)) {
            var val = frame[valueKey];
            var nextVal_1 = nextFrame[valueKey];
            var isLinearGradient_1 = valType === VALUE_TYPE_LINEAR_GRADIENT;
            target[propName] = {
                type: isLinearGradient_1 ? 'linear' : 'radial',
                x: interpolateNumber(val.x, nextVal_1.x, w),
                y: interpolateNumber(val.y, nextVal_1.y, w),
                colorStops: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["map"])(val.colorStops, function (colorStop, idx) {
                    var nextColorStop = nextVal_1.colorStops[idx];
                    return {
                        offset: interpolateNumber(colorStop.offset, nextColorStop.offset, w),
                        color: rgba2String(interpolate1DArray([], colorStop.color, nextColorStop.color, w))
                    };
                }),
                global: nextVal_1.global
            };
            if (isLinearGradient_1) {
                target[propName].x2 = interpolateNumber(val.x2, nextVal_1.x2, w);
                target[propName].y2 = interpolateNumber(val.y2, nextVal_1.y2, w);
            }
            else {
                target[propName].r = interpolateNumber(val.r, nextVal_1.r, w);
            }
        }
        else if (isValueColor) {
            interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
            if (!isAdditive) {
                target[propName] = rgba2String(targetArr);
            }
        }
        else {
            var value = interpolateNumber(frame[valueKey], nextFrame[valueKey], w);
            if (isAdditive) {
                this._additiveValue = value;
            }
            else {
                target[propName] = value;
            }
        }
        if (isAdditive) {
            this._addToTarget(target);
        }
    };
    Track.prototype._addToTarget = function (target) {
        var valType = this.valType;
        var propName = this.propName;
        var additiveValue = this._additiveValue;
        if (valType === VALUE_TYPE_NUMBER) {
            target[propName] = target[propName] + additiveValue;
        }
        else if (valType === VALUE_TYPE_COLOR) {
            __WEBPACK_IMPORTED_MODULE_1__tool_color_js__["parse"](target[propName], tmpRgba);
            add1DArray(tmpRgba, tmpRgba, additiveValue, 1);
            target[propName] = rgba2String(tmpRgba);
        }
        else if (valType === VALUE_TYPE_1D_ARRAY) {
            add1DArray(target[propName], target[propName], additiveValue, 1);
        }
        else if (valType === VALUE_TYPE_2D_ARRAY) {
            add2DArray(target[propName], target[propName], additiveValue, 1);
        }
    };
    return Track;
}());
var Animator = (function () {
    function Animator(target, loop, allowDiscreteAnimation, additiveTo) {
        this._tracks = {};
        this._trackKeys = [];
        this._maxTime = 0;
        this._started = 0;
        this._clip = null;
        this._target = target;
        this._loop = loop;
        if (loop && additiveTo) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["logError"])('Can\' use additive animation on looped animation.');
            return;
        }
        this._additiveAnimators = additiveTo;
        this._allowDiscrete = allowDiscreteAnimation;
    }
    Animator.prototype.getMaxTime = function () {
        return this._maxTime;
    };
    Animator.prototype.getDelay = function () {
        return this._delay;
    };
    Animator.prototype.getLoop = function () {
        return this._loop;
    };
    Animator.prototype.getTarget = function () {
        return this._target;
    };
    Animator.prototype.changeTarget = function (target) {
        this._target = target;
    };
    Animator.prototype.when = function (time, props, easing) {
        return this.whenWithKeys(time, props, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["keys"])(props), easing);
    };
    Animator.prototype.whenWithKeys = function (time, props, propNames, easing) {
        var tracks = this._tracks;
        for (var i = 0; i < propNames.length; i++) {
            var propName = propNames[i];
            var track = tracks[propName];
            if (!track) {
                track = tracks[propName] = new Track(propName);
                var initialValue = void 0;
                var additiveTrack = this._getAdditiveTrack(propName);
                if (additiveTrack) {
                    var addtiveTrackKfs = additiveTrack.keyframes;
                    var lastFinalKf = addtiveTrackKfs[addtiveTrackKfs.length - 1];
                    initialValue = lastFinalKf && lastFinalKf.value;
                    if (additiveTrack.valType === VALUE_TYPE_COLOR && initialValue) {
                        initialValue = rgba2String(initialValue);
                    }
                }
                else {
                    initialValue = this._target[propName];
                }
                if (initialValue == null) {
                    continue;
                }
                if (time > 0) {
                    track.addKeyframe(0, cloneValue(initialValue), easing);
                }
                this._trackKeys.push(propName);
            }
            track.addKeyframe(time, cloneValue(props[propName]), easing);
        }
        this._maxTime = Math.max(this._maxTime, time);
        return this;
    };
    Animator.prototype.pause = function () {
        this._clip.pause();
        this._paused = true;
    };
    Animator.prototype.resume = function () {
        this._clip.resume();
        this._paused = false;
    };
    Animator.prototype.isPaused = function () {
        return !!this._paused;
    };
    Animator.prototype.duration = function (duration) {
        this._maxTime = duration;
        this._force = true;
        return this;
    };
    Animator.prototype._doneCallback = function () {
        this._setTracksFinished();
        this._clip = null;
        var doneList = this._doneCbs;
        if (doneList) {
            var len = doneList.length;
            for (var i = 0; i < len; i++) {
                doneList[i].call(this);
            }
        }
    };
    Animator.prototype._abortedCallback = function () {
        this._setTracksFinished();
        var animation = this.animation;
        var abortedList = this._abortedCbs;
        if (animation) {
            animation.removeClip(this._clip);
        }
        this._clip = null;
        if (abortedList) {
            for (var i = 0; i < abortedList.length; i++) {
                abortedList[i].call(this);
            }
        }
    };
    Animator.prototype._setTracksFinished = function () {
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for (var i = 0; i < tracksKeys.length; i++) {
            tracks[tracksKeys[i]].setFinished();
        }
    };
    Animator.prototype._getAdditiveTrack = function (trackName) {
        var additiveTrack;
        var additiveAnimators = this._additiveAnimators;
        if (additiveAnimators) {
            for (var i = 0; i < additiveAnimators.length; i++) {
                var track = additiveAnimators[i].getTrack(trackName);
                if (track) {
                    additiveTrack = track;
                }
            }
        }
        return additiveTrack;
    };
    Animator.prototype.start = function (easing) {
        if (this._started > 0) {
            return;
        }
        this._started = 1;
        var self = this;
        var tracks = [];
        var maxTime = this._maxTime || 0;
        for (var i = 0; i < this._trackKeys.length; i++) {
            var propName = this._trackKeys[i];
            var track = this._tracks[propName];
            var additiveTrack = this._getAdditiveTrack(propName);
            var kfs = track.keyframes;
            var kfsNum = kfs.length;
            track.prepare(maxTime, additiveTrack);
            if (track.needsAnimate()) {
                if (!this._allowDiscrete && track.discrete) {
                    var lastKf = kfs[kfsNum - 1];
                    if (lastKf) {
                        self._target[track.propName] = lastKf.rawValue;
                    }
                    track.setFinished();
                }
                else {
                    tracks.push(track);
                }
            }
        }
        if (tracks.length || this._force) {
            var clip = new __WEBPACK_IMPORTED_MODULE_0__Clip_js__["a" /* default */]({
                life: maxTime,
                loop: this._loop,
                delay: this._delay || 0,
                onframe: function (percent) {
                    self._started = 2;
                    var additiveAnimators = self._additiveAnimators;
                    if (additiveAnimators) {
                        var stillHasAdditiveAnimator = false;
                        for (var i = 0; i < additiveAnimators.length; i++) {
                            if (additiveAnimators[i]._clip) {
                                stillHasAdditiveAnimator = true;
                                break;
                            }
                        }
                        if (!stillHasAdditiveAnimator) {
                            self._additiveAnimators = null;
                        }
                    }
                    for (var i = 0; i < tracks.length; i++) {
                        tracks[i].step(self._target, percent);
                    }
                    var onframeList = self._onframeCbs;
                    if (onframeList) {
                        for (var i = 0; i < onframeList.length; i++) {
                            onframeList[i](self._target, percent);
                        }
                    }
                },
                ondestroy: function () {
                    self._doneCallback();
                }
            });
            this._clip = clip;
            if (this.animation) {
                this.animation.addClip(clip);
            }
            if (easing) {
                clip.setEasing(easing);
            }
        }
        else {
            this._doneCallback();
        }
        return this;
    };
    Animator.prototype.stop = function (forwardToLast) {
        if (!this._clip) {
            return;
        }
        var clip = this._clip;
        if (forwardToLast) {
            clip.onframe(1);
        }
        this._abortedCallback();
    };
    Animator.prototype.delay = function (time) {
        this._delay = time;
        return this;
    };
    Animator.prototype.during = function (cb) {
        if (cb) {
            if (!this._onframeCbs) {
                this._onframeCbs = [];
            }
            this._onframeCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.done = function (cb) {
        if (cb) {
            if (!this._doneCbs) {
                this._doneCbs = [];
            }
            this._doneCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.aborted = function (cb) {
        if (cb) {
            if (!this._abortedCbs) {
                this._abortedCbs = [];
            }
            this._abortedCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.getClip = function () {
        return this._clip;
    };
    Animator.prototype.getTrack = function (propName) {
        return this._tracks[propName];
    };
    Animator.prototype.getTracks = function () {
        var _this = this;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["map"])(this._trackKeys, function (key) { return _this._tracks[key]; });
    };
    Animator.prototype.stopTracks = function (propNames, forwardToLast) {
        if (!propNames.length || !this._clip) {
            return true;
        }
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for (var i = 0; i < propNames.length; i++) {
            var track = tracks[propNames[i]];
            if (track && !track.isFinished()) {
                if (forwardToLast) {
                    track.step(this._target, 1);
                }
                else if (this._started === 1) {
                    track.step(this._target, 0);
                }
                track.setFinished();
            }
        }
        var allAborted = true;
        for (var i = 0; i < tracksKeys.length; i++) {
            if (!tracks[tracksKeys[i]].isFinished()) {
                allAborted = false;
                break;
            }
        }
        if (allAborted) {
            this._abortedCallback();
        }
        return allAborted;
    };
    Animator.prototype.saveTo = function (target, trackKeys, firstOrLast) {
        if (!target) {
            return;
        }
        trackKeys = trackKeys || this._trackKeys;
        for (var i = 0; i < trackKeys.length; i++) {
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track || track.isFinished()) {
                continue;
            }
            var kfs = track.keyframes;
            var kf = kfs[firstOrLast ? 0 : kfs.length - 1];
            if (kf) {
                target[propName] = cloneValue(kf.rawValue);
            }
        }
    };
    Animator.prototype.__changeFinalValue = function (finalProps, trackKeys) {
        trackKeys = trackKeys || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["keys"])(finalProps);
        for (var i = 0; i < trackKeys.length; i++) {
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track) {
                continue;
            }
            var kfs = track.keyframes;
            if (kfs.length > 1) {
                var lastKf = kfs.pop();
                track.addKeyframe(lastKf.time, finalProps[propName]);
                track.prepare(this._maxTime, track.getAdditiveTrack());
            }
        }
    };
    return Animator;
}());
/* harmony default export */ __webpack_exports__["a"] = (Animator);


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createCubicEasingFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_curve_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_util_js__ = __webpack_require__(0);


var regexp = /cubic-bezier\(([0-9,\.e ]+)\)/;
function createCubicEasingFunc(cubicEasingStr) {
    var cubic = cubicEasingStr && regexp.exec(cubicEasingStr);
    if (cubic) {
        var points = cubic[1].split(',');
        var a_1 = +__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_util_js__["trim"])(points[0]);
        var b_1 = +__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_util_js__["trim"])(points[1]);
        var c_1 = +__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_util_js__["trim"])(points[2]);
        var d_1 = +__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_util_js__["trim"])(points[3]);
        if (isNaN(a_1 + b_1 + c_1 + d_1)) {
            return;
        }
        var roots_1 = [];
        return function (p) {
            return p <= 0
                ? 0 : p >= 1
                ? 1
                : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_curve_js__["a" /* cubicRootAt */])(0, a_1, c_1, 1, p, roots_1) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_curve_js__["b" /* cubicAt */])(0, b_1, d_1, 1, roots_1[0]);
        };
    }
}


/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Gradient_js__ = __webpack_require__(586);


var LinearGradient = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(LinearGradient, _super);
    function LinearGradient(x, y, x2, y2, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0 : x;
        _this.y = y == null ? 0 : y;
        _this.x2 = x2 == null ? 1 : x2;
        _this.y2 = y2 == null ? 0 : y2;
        _this.type = 'linear';
        _this.global = globalCoord || false;
        return _this;
    }
    return LinearGradient;
}(__WEBPACK_IMPORTED_MODULE_1__Gradient_js__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (LinearGradient);
;


/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findExistImage;
/* harmony export (immutable) */ __webpack_exports__["c"] = createOrUpdateImage;
/* harmony export (immutable) */ __webpack_exports__["b"] = isImageReady;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_LRU_js__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_platform_js__ = __webpack_require__(67);


var globalImageCache = new __WEBPACK_IMPORTED_MODULE_0__core_LRU_js__["a" /* default */](50);
function findExistImage(newImageOrSrc) {
    if (typeof newImageOrSrc === 'string') {
        var cachedImgObj = globalImageCache.get(newImageOrSrc);
        return cachedImgObj && cachedImgObj.image;
    }
    else {
        return newImageOrSrc;
    }
}
function createOrUpdateImage(newImageOrSrc, image, hostEl, onload, cbPayload) {
    if (!newImageOrSrc) {
        return image;
    }
    else if (typeof newImageOrSrc === 'string') {
        if ((image && image.__zrImageSrc === newImageOrSrc) || !hostEl) {
            return image;
        }
        var cachedImgObj = globalImageCache.get(newImageOrSrc);
        var pendingWrap = { hostEl: hostEl, cb: onload, cbPayload: cbPayload };
        if (cachedImgObj) {
            image = cachedImgObj.image;
            !isImageReady(image) && cachedImgObj.pending.push(pendingWrap);
        }
        else {
            var image_1 = __WEBPACK_IMPORTED_MODULE_1__core_platform_js__["a" /* platformApi */].loadImage(newImageOrSrc, imageOnLoad, imageOnLoad);
            image_1.__zrImageSrc = newImageOrSrc;
            globalImageCache.put(newImageOrSrc, image_1.__cachedImgObj = {
                image: image_1,
                pending: [pendingWrap]
            });
        }
        return image;
    }
    else {
        return newImageOrSrc;
    }
}
function imageOnLoad() {
    var cachedImgObj = this.__cachedImgObj;
    this.onload = this.onerror = this.__cachedImgObj = null;
    for (var i = 0; i < cachedImgObj.pending.length; i++) {
        var pendingWrap = cachedImgObj.pending[i];
        var cb = pendingWrap.cb;
        cb && cb(this, pendingWrap.cbPayload);
        pendingWrap.hostEl.dirty();
    }
    cachedImgObj.pending.length = 0;
}
function isImageReady(image) {
    return image && image.width && image.height;
}


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = subPixelOptimizeLine;
/* harmony export (immutable) */ __webpack_exports__["a"] = subPixelOptimizeRect;
/* harmony export (immutable) */ __webpack_exports__["c"] = subPixelOptimize;
var round = Math.round;
function subPixelOptimizeLine(outputShape, inputShape, style) {
    if (!inputShape) {
        return;
    }
    var x1 = inputShape.x1;
    var x2 = inputShape.x2;
    var y1 = inputShape.y1;
    var y2 = inputShape.y2;
    outputShape.x1 = x1;
    outputShape.x2 = x2;
    outputShape.y1 = y1;
    outputShape.y2 = y2;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) {
        return outputShape;
    }
    if (round(x1 * 2) === round(x2 * 2)) {
        outputShape.x1 = outputShape.x2 = subPixelOptimize(x1, lineWidth, true);
    }
    if (round(y1 * 2) === round(y2 * 2)) {
        outputShape.y1 = outputShape.y2 = subPixelOptimize(y1, lineWidth, true);
    }
    return outputShape;
}
function subPixelOptimizeRect(outputShape, inputShape, style) {
    if (!inputShape) {
        return;
    }
    var originX = inputShape.x;
    var originY = inputShape.y;
    var originWidth = inputShape.width;
    var originHeight = inputShape.height;
    outputShape.x = originX;
    outputShape.y = originY;
    outputShape.width = originWidth;
    outputShape.height = originHeight;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) {
        return outputShape;
    }
    outputShape.x = subPixelOptimize(originX, lineWidth, true);
    outputShape.y = subPixelOptimize(originY, lineWidth, true);
    outputShape.width = Math.max(subPixelOptimize(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
    outputShape.height = Math.max(subPixelOptimize(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
    return outputShape;
}
function subPixelOptimize(position, lineWidth, positiveOrNegative) {
    if (!lineWidth) {
        return position;
    }
    var doubledPosition = round(position * 2);
    return (doubledPosition + round(lineWidth)) % 2 === 0
        ? doubledPosition / 2
        : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
}


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PolygonShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Path_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_poly_js__ = __webpack_require__(589);



var PolygonShape = (function () {
    function PolygonShape() {
        this.points = null;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolygonShape;
}());

var Polygon = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Polygon, _super);
    function Polygon(opts) {
        return _super.call(this, opts) || this;
    }
    Polygon.prototype.getDefaultShape = function () {
        return new PolygonShape();
    };
    Polygon.prototype.buildPath = function (ctx, shape) {
        __WEBPACK_IMPORTED_MODULE_2__helper_poly_js__["a" /* buildPath */](ctx, shape, true);
    };
    return Polygon;
}(__WEBPACK_IMPORTED_MODULE_1__Path_js__["a" /* default */]));
;
Polygon.prototype.type = 'polygon';
/* harmony default export */ __webpack_exports__["a"] = (Polygon);


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony export (immutable) */ __webpack_exports__["dispose"] = dispose;
/* harmony export (immutable) */ __webpack_exports__["disposeAll"] = disposeAll;
/* harmony export (immutable) */ __webpack_exports__["getInstance"] = getInstance;
/* harmony export (immutable) */ __webpack_exports__["registerPainter"] = registerPainter;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_env_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Handler_js__ = __webpack_require__(1690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Storage_js__ = __webpack_require__(1691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__animation_Animation_js__ = __webpack_require__(1692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dom_HandlerProxy_js__ = __webpack_require__(1703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tool_color_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_js__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphic_Group_js__ = __webpack_require__(138);
/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
*/









var painterCtors = {};
var instances = {};
function delInstance(id) {
    delete instances[id];
}
function isDarkMode(backgroundColor) {
    if (!backgroundColor) {
        return false;
    }
    if (typeof backgroundColor === 'string') {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tool_color_js__["lum"])(backgroundColor, 1) < __WEBPACK_IMPORTED_MODULE_7__config_js__["d" /* DARK_MODE_THRESHOLD */];
    }
    else if (backgroundColor.colorStops) {
        var colorStops = backgroundColor.colorStops;
        var totalLum = 0;
        var len = colorStops.length;
        for (var i = 0; i < len; i++) {
            totalLum += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tool_color_js__["lum"])(colorStops[i].color, 1);
        }
        totalLum /= len;
        return totalLum < __WEBPACK_IMPORTED_MODULE_7__config_js__["d" /* DARK_MODE_THRESHOLD */];
    }
    return false;
}
var ZRender = (function () {
    function ZRender(id, dom, opts) {
        var _this = this;
        this._sleepAfterStill = 10;
        this._stillFrameAccum = 0;
        this._needsRefresh = true;
        this._needsRefreshHover = true;
        this._darkMode = false;
        opts = opts || {};
        this.dom = dom;
        this.id = id;
        var storage = new __WEBPACK_IMPORTED_MODULE_3__Storage_js__["a" /* default */]();
        var rendererType = opts.renderer || 'canvas';
        if (!painterCtors[rendererType]) {
            rendererType = __WEBPACK_IMPORTED_MODULE_1__core_util_js__["keys"](painterCtors)[0];
        }
        if (true) {
            if (!painterCtors[rendererType]) {
                throw new Error("Renderer '" + rendererType + "' is not imported. Please import it first.");
            }
        }
        opts.useDirtyRect = opts.useDirtyRect == null
            ? false
            : opts.useDirtyRect;
        var painter = new painterCtors[rendererType](dom, storage, opts, id);
        var ssrMode = opts.ssr || painter.ssrOnly;
        this.storage = storage;
        this.painter = painter;
        var handerProxy = (!__WEBPACK_IMPORTED_MODULE_0__core_env_js__["a" /* default */].node && !__WEBPACK_IMPORTED_MODULE_0__core_env_js__["a" /* default */].worker && !ssrMode)
            ? new __WEBPACK_IMPORTED_MODULE_5__dom_HandlerProxy_js__["a" /* default */](painter.getViewportRoot(), painter.root)
            : null;
        this.handler = new __WEBPACK_IMPORTED_MODULE_2__Handler_js__["a" /* default */](storage, painter, handerProxy, painter.root);
        this.animation = new __WEBPACK_IMPORTED_MODULE_4__animation_Animation_js__["a" /* default */]({
            stage: {
                update: ssrMode ? null : function () { return _this._flush(true); }
            }
        });
        if (!ssrMode) {
            this.animation.start();
        }
    }
    ZRender.prototype.add = function (el) {
        if (!el) {
            return;
        }
        this.storage.addRoot(el);
        el.addSelfToZr(this);
        this.refresh();
    };
    ZRender.prototype.remove = function (el) {
        if (!el) {
            return;
        }
        this.storage.delRoot(el);
        el.removeSelfFromZr(this);
        this.refresh();
    };
    ZRender.prototype.configLayer = function (zLevel, config) {
        if (this.painter.configLayer) {
            this.painter.configLayer(zLevel, config);
        }
        this.refresh();
    };
    ZRender.prototype.setBackgroundColor = function (backgroundColor) {
        if (this.painter.setBackgroundColor) {
            this.painter.setBackgroundColor(backgroundColor);
        }
        this.refresh();
        this._backgroundColor = backgroundColor;
        this._darkMode = isDarkMode(backgroundColor);
    };
    ZRender.prototype.getBackgroundColor = function () {
        return this._backgroundColor;
    };
    ZRender.prototype.setDarkMode = function (darkMode) {
        this._darkMode = darkMode;
    };
    ZRender.prototype.isDarkMode = function () {
        return this._darkMode;
    };
    ZRender.prototype.refreshImmediately = function (fromInside) {
        if (!fromInside) {
            this.animation.update(true);
        }
        this._needsRefresh = false;
        this.painter.refresh();
        this._needsRefresh = false;
    };
    ZRender.prototype.refresh = function () {
        this._needsRefresh = true;
        this.animation.start();
    };
    ZRender.prototype.flush = function () {
        this._flush(false);
    };
    ZRender.prototype._flush = function (fromInside) {
        var triggerRendered;
        var start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__animation_Animation_js__["b" /* getTime */])();
        if (this._needsRefresh) {
            triggerRendered = true;
            this.refreshImmediately(fromInside);
        }
        if (this._needsRefreshHover) {
            triggerRendered = true;
            this.refreshHoverImmediately();
        }
        var end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__animation_Animation_js__["b" /* getTime */])();
        if (triggerRendered) {
            this._stillFrameAccum = 0;
            this.trigger('rendered', {
                elapsedTime: end - start
            });
        }
        else if (this._sleepAfterStill > 0) {
            this._stillFrameAccum++;
            if (this._stillFrameAccum > this._sleepAfterStill) {
                this.animation.stop();
            }
        }
    };
    ZRender.prototype.setSleepAfterStill = function (stillFramesCount) {
        this._sleepAfterStill = stillFramesCount;
    };
    ZRender.prototype.wakeUp = function () {
        this.animation.start();
        this._stillFrameAccum = 0;
    };
    ZRender.prototype.refreshHover = function () {
        this._needsRefreshHover = true;
    };
    ZRender.prototype.refreshHoverImmediately = function () {
        this._needsRefreshHover = false;
        if (this.painter.refreshHover && this.painter.getType() === 'canvas') {
            this.painter.refreshHover();
        }
    };
    ZRender.prototype.resize = function (opts) {
        opts = opts || {};
        this.painter.resize(opts.width, opts.height);
        this.handler.resize();
    };
    ZRender.prototype.clearAnimation = function () {
        this.animation.clear();
    };
    ZRender.prototype.getWidth = function () {
        return this.painter.getWidth();
    };
    ZRender.prototype.getHeight = function () {
        return this.painter.getHeight();
    };
    ZRender.prototype.setCursorStyle = function (cursorStyle) {
        this.handler.setCursorStyle(cursorStyle);
    };
    ZRender.prototype.findHover = function (x, y) {
        return this.handler.findHover(x, y);
    };
    ZRender.prototype.on = function (eventName, eventHandler, context) {
        this.handler.on(eventName, eventHandler, context);
        return this;
    };
    ZRender.prototype.off = function (eventName, eventHandler) {
        this.handler.off(eventName, eventHandler);
    };
    ZRender.prototype.trigger = function (eventName, event) {
        this.handler.trigger(eventName, event);
    };
    ZRender.prototype.clear = function () {
        var roots = this.storage.getRoots();
        for (var i = 0; i < roots.length; i++) {
            if (roots[i] instanceof __WEBPACK_IMPORTED_MODULE_8__graphic_Group_js__["a" /* default */]) {
                roots[i].removeSelfFromZr(this);
            }
        }
        this.storage.delAllRoots();
        this.painter.clear();
    };
    ZRender.prototype.dispose = function () {
        this.animation.stop();
        this.clear();
        this.storage.dispose();
        this.painter.dispose();
        this.handler.dispose();
        this.animation =
            this.storage =
                this.painter =
                    this.handler = null;
        delInstance(this.id);
    };
    return ZRender;
}());
function init(dom, opts) {
    var zr = new ZRender(__WEBPACK_IMPORTED_MODULE_1__core_util_js__["guid"](), dom, opts);
    instances[zr.id] = zr;
    return zr;
}
function dispose(zr) {
    zr.dispose();
}
function disposeAll() {
    for (var key in instances) {
        if (instances.hasOwnProperty(key)) {
            instances[key].dispose();
        }
    }
    instances = {};
}
function getInstance(id) {
    return instances[id];
}
function registerPainter(name, Ctor) {
    painterCtors[name] = Ctor;
}
var version = '5.3.0';
;


/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports = ELEMENT;

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = ({
    list: function list(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/sys/sysAnnouncementSend/getMyAnnouncementSendAll', params);
    },
    readCount: function readCount(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/sys/sysAnnouncementSend/queryUnReadCount', params);
    },
    myMessages: function myMessages(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/sys/sysAnnouncementSend/getMyAnnouncementSend', params);
    },
    readAll: function readAll(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].put('/rocheManage/sys/sysAnnouncementSend/readAll', params);
    },
    getUnApproveCount: function getUnApproveCount(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/meeting/pubMeeting/getUnApproveCount', params);
    },
    readMessageByAnntId: function readMessageByAnntId(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].put('/rocheManage/sys/sysAnnouncementSend/editByAnntIdAndUserId', params);
    }
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bindHandlers */
/* unused harmony export bindModelHandlers */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initEditor; });
/* unused harmony export isValidKey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return uuid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isTextarea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mergePlugins; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isNullOrUndefined; });
/**
 * Copyright (c) 2018-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var validEvents = [
    'onActivate',
    'onAddUndo',
    'onBeforeAddUndo',
    'onBeforeExecCommand',
    'onBeforeGetContent',
    'onBeforeRenderUI',
    'onBeforeSetContent',
    'onBeforePaste',
    'onBlur',
    'onChange',
    'onClearUndos',
    'onClick',
    'onContextMenu',
    'onCopy',
    'onCut',
    'onDblclick',
    'onDeactivate',
    'onDirty',
    'onDrag',
    'onDragDrop',
    'onDragEnd',
    'onDragGesture',
    'onDragOver',
    'onDrop',
    'onExecCommand',
    'onFocus',
    'onFocusIn',
    'onFocusOut',
    'onGetContent',
    'onHide',
    'onInit',
    'onKeyDown',
    'onKeyPress',
    'onKeyUp',
    'onLoadContent',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp',
    'onNodeChange',
    'onObjectResizeStart',
    'onObjectResized',
    'onObjectSelected',
    'onPaste',
    'onPostProcess',
    'onPostRender',
    'onPreProcess',
    'onProgressState',
    'onRedo',
    'onRemove',
    'onReset',
    'onSaveContent',
    'onSelectionChange',
    'onSetAttrib',
    'onSetContent',
    'onShow',
    'onSubmit',
    'onUndo',
    'onVisualAid'
];
var isValidKey = function (key) { return validEvents.map(function (event) { return event.toLowerCase(); }).indexOf(key.toLowerCase()) !== -1; };
var bindHandlers = function (initEvent, listeners, editor) {
    Object.keys(listeners)
        .filter(isValidKey)
        .forEach(function (key) {
        var handler = listeners[key];
        if (typeof handler === 'function') {
            if (key === 'onInit') {
                handler(initEvent, editor);
            }
            else {
                editor.on(key.substring(2), function (e) { return handler(e, editor); });
            }
        }
    });
};
var bindModelHandlers = function (ctx, editor) {
    var modelEvents = ctx.$props.modelEvents ? ctx.$props.modelEvents : null;
    var normalizedEvents = Array.isArray(modelEvents) ? modelEvents.join(' ') : modelEvents;
    editor.on(normalizedEvents ? normalizedEvents : 'change input undo redo', function () {
        ctx.$emit('input', editor.getContent({ format: ctx.$props.outputFormat }));
    });
};
var initEditor = function (initEvent, ctx, editor) {
    var value = ctx.$props.value ? ctx.$props.value : '';
    var initialValue = ctx.$props.initialValue ? ctx.$props.initialValue : '';
    editor.setContent(value || (ctx.initialized ? ctx.cache : initialValue));
    // Always bind the value listener in case users use :value instead of v-model
    ctx.$watch('value', function (val, prevVal) {
        if (editor && typeof val === 'string' && val !== prevVal && val !== editor.getContent({ format: ctx.$props.outputFormat })) {
            editor.setContent(val);
        }
    });
    // checks if the v-model shorthand is used (which sets an v-on:input listener) and then binds either
    // specified the events or defaults to "change keyup" event and emits the editor content on that event
    if (ctx.$listeners.input) {
        bindModelHandlers(ctx, editor);
    }
    bindHandlers(initEvent, ctx.$listeners, editor);
    ctx.initialized = true;
};
var unique = 0;
var uuid = function (prefix) {
    var time = Date.now();
    var random = Math.floor(Math.random() * 1000000000);
    unique++;
    return prefix + '_' + random + unique + String(time);
};
var isTextarea = function (element) {
    return element !== null && element.tagName.toLowerCase() === 'textarea';
};
var normalizePluginArray = function (plugins) {
    if (typeof plugins === 'undefined' || plugins === '') {
        return [];
    }
    return Array.isArray(plugins) ? plugins : plugins.split(' ');
};
var mergePlugins = function (initPlugins, inputPlugins) {
    return normalizePluginArray(initPlugins).concat(normalizePluginArray(inputPlugins));
};
var isNullOrUndefined = function (value) { return value === null || value === undefined; };



/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(51);
var settle = __webpack_require__(613);
var buildURL = __webpack_require__(375);
var buildFullPath = __webpack_require__(610);
var parseHeaders = __webpack_require__(620);
var isURLSameOrigin = __webpack_require__(618);
var createError = __webpack_require__(371);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(616);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(612);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(51);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(51);
var normalizeHeaderName = __webpack_require__(619);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(368);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(368);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(353)))

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(51);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = ({
  list: function list(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/meeting/pubMeeting/myAuthorizedTaskList', params);
  },
  apprvoal: function apprvoal(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].put('/rocheManage/meeting/pubMeeting/myTaskMeetingSubmit', params);
  },
  queryMainTask: function queryMainTask(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/meeting/pubMeeting/myTaskMeetingSummary', params);
  },
  exportXls: function exportXls(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/meeting/pubMeeting/myAuthorizedTaskExportXls', params, { responseType: 'blob' });
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = ({
  list: function list(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/meeting/pubMeeting/myMeetingTaskList', params);
  },
  apprvoal: function apprvoal(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].put('/rocheManage/meeting/pubMeeting/myTaskMeetingSubmit', params);
  },
  queryMainTask: function queryMainTask(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/meeting/pubMeeting/myTaskMeetingSummary', params);
  },
  exportXls: function exportXls(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/meeting/pubMeeting/myMeetingTaskExportXls', params, { responseType: 'blob' });
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_axios__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(20);



/* harmony default export */ __webpack_exports__["a"] = ({
  list: function list(params) {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/dict/list', params);
  },
  add: function add(params) {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].post('/rocheManage/sys/dict/add', params);
  },
  edit: function edit(params) {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].put('/rocheManage/sys/dict/edit', params);
  },
  delete: function _delete(params) {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].delete('/rocheManage/sys/dict/delete', params);
  },
  getDictItemsByCode: function getDictItemsByCode(code) {
    return __WEBPACK_IMPORTED_MODULE_0__util_axios__["a" /* default */].get('/e2estservice/sys/dict/getDictItemsByCode/' + code);
  },
  getProvinceList: function getProvinceList() {
    return __WEBPACK_IMPORTED_MODULE_0__util_axios__["a" /* default */].post('/e2estservice/master/city/province-list');
  },
  getCityList: function getCityList(province) {
    var requestURL = '/e2estservice/master/city/city-list';
    requestURL = province ? requestURL + '?province=' + province : requestURL;
    return __WEBPACK_IMPORTED_MODULE_0__util_axios__["a" /* default */].post(requestURL);
  },
  getAribaCategoryList: function getAribaCategoryList() {
    var requestURL = '/e2estservice/pub/ariba/aribaCategoryMap/list-all';
    return __WEBPACK_IMPORTED_MODULE_0__util_axios__["a" /* default */].get(requestURL);
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = ({
    list: function list(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/external/externalAdDepart/list', params);
    },
    add: function add(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].post('/rocheManage/external/externalAdDepart/add', params);
    },
    edit: function edit(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].put('/rocheManage/external/externalAdDepart/edit', params);
    },
    delete: function _delete(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].delete('/rocheManage/external/externalAdDepart/delete', params);
    },
    deleteBatch: function deleteBatch(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].delete('/rocheManage/external/externalAdDepart/deleteBatch', params);
    },
    exportXls: function exportXls(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/sys/user/exportXls', params, { responseType: 'blob' });
    },
    getEdcByAd: function getEdcByAd(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/bus/busBudgetDetail/getEdcByAd', params);
    },
    getAllowDeparts: function getAllowDeparts() {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/external/externalDepart/list', { pageSize: 999999, pageNo: 1 });
    }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_axios__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(20);



/* harmony default export */ __webpack_exports__["a"] = ({
    list: function list(params) {
        return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/permission/list', params);
    },
    add: function add(params) {
        return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].post('/rocheManage/sys/permission/add', params);
    },
    edit: function edit(params) {
        return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].put('/rocheManage/sys/permission/edit', params);
    },
    delete: function _delete(params) {
        return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].delete('/rocheManage/sys/permission/delete', params);
    },
    deleteBatch: function deleteBatch(params) {
        return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].delete('/rocheManage/sys/permission/deleteBatch', params);
    }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_axios__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(20);



/* harmony default export */ __webpack_exports__["a"] = ({
    list: function list(params) {
        return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/role/list', params);
    },
    add: function add(params) {
        return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].post('/rocheManage/sys/role/add', params);
    },
    edit: function edit(params) {
        return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].put('/rocheManage/sys/role/edit', params);
    },
    delete: function _delete(params) {
        return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].delete('/rocheManage/sys/role/delete', params);
    },
    deleteBatch: function deleteBatch(params) {
        return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].delete('/rocheManage/sys/role/deleteBatch', params);
    },
    queryRolePrivilege: function queryRolePrivilege(params) {
        return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/permission/queryRolePermission', params);
    },
    saveRolePrivilege: function saveRolePrivilege(params) {
        return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].post('/rocheManage/sys/permission/saveRolePermission', params);
    }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = ({
    list: function list(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/system/sysDateConfig/list', params);
    },
    add: function add(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].post('/rocheManage/system/sysDateConfig/add', params);
    },
    edit: function edit(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].put('/rocheManage/system/sysDateConfig/edit', params);
    },
    delete: function _delete(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].delete('/rocheManage/system/sysDateConfig/delete', params);
    }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(20);



/* harmony default export */ __webpack_exports__["a"] = ({
  list: function list(params) {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/notice/list', params);
  },
  add: function add(params) {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].post('/rocheManage/sys/notice/add', params);
  },
  edit: function edit(params) {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].put('/rocheManage/sys/notice/edit', params);
  },
  delete: function _delete(params) {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].delete('/rocheManage/sys/notice/delete', params);
  },
  deleteBatch: function deleteBatch(params) {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].delete('/rocheManage/sys/notice/deleteBatch', params);
  },
  getNoticeHomeList: function getNoticeHomeList() {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/notice/home/list');
  },
  exportXls: function exportXls(params) {
    return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/notice/exportXls', params, { responseType: 'blob' });
  },
  getUserList: function getUserList() {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      _this.list({
        pageNo: 1,
        pageSize: 999999
      }).then(function (res) {
        var temp = res.records.map(function (r) {
          return { username: r.updateBy, realname: r.updateBy };
        });
        temp = _.uniqBy(temp, 'username');
        resolve(temp);
      });
    });
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_USERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_USER_PERMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_DICT_ITEM; });
var SET_USERINFO = 'SET_USERINFO';
var SET_USER_PERMS = 'SET_USER_PERMS';

var SET_DICT_ITEM = 'SET_DICT_ITEM';

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export showLoading */
/* unused harmony export hideLoading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);



var loadingRequestCount = 0; // 当前正在请求的request 次数
var loadingInstance = void 0;
var showLoading = function showLoading(config, text) {
  if (loadingRequestCount === 0) {
    loadingInstance = __WEBPACK_IMPORTED_MODULE_0_element_ui__["Loading"].service({ text: 'Loading' });
  }
  loadingRequestCount++;
};

var hideLoading = function hideLoading(res) {
  if (loadingRequestCount <= 0) return;
  loadingRequestCount--;
  if (loadingRequestCount === 0) {
    __WEBPACK_IMPORTED_MODULE_1_vue___default.a.nextTick(function () {
      // 以服务的方式调用的 Loading 需要异步关闭
      loadingInstance.close();
    });
  }
};

var LoadingManager = {
  delay_loading_timemer: 0, // loading 延迟时间
  loading_request_pool: [],
  request_pool: [], // 请求id 池，请求结束后从池子中删除
  loadingInstance: undefined,
  loading_text: '',
  add: function add(config) {
    this.setLoadingText(config);
    var requestId = config.requestId;
    this.request_pool.push(requestId);
    this.monitor(requestId);
  },
  setLoadingText: function setLoadingText(config) {
    // 从请求中找 loading text 是否设置
    var text = window.vm.$t('system.loading');
    if (config.loading_text) {
      text = config.loading_text;
    } else if (config.params && config.params.loading_text) {
      text = config.params.loading_text;
      delete config.params.loading_text;
    } else if (config.data && config.data.loading_text) {
      text = config.data.loading_text;
      delete config.data.loading_text;
    }
    this.loading_text = text;
  },
  remove: function remove(res) {
    var requestId = res.config.requestId;
    if (this.request_pool.indexOf(requestId) > -1) {
      // 移除 对应的请求id, 以及对应的id 对应的 loading 状态
      this.request_pool.splice(this.request_pool.indexOf(requestId), 1);
      if (this.loading_request_pool.indexOf(requestId) > -1) {
        // 此时说明该请求触发了loading， 从 loading 池冲移除
        this.removeLoadingRequest(requestId);
      }
    }
  },
  // 请求所有的 loading 状态
  removAll: function removAll() {
    this.request_pool = [];
    this.loading_request_pool = [];
    this.hideLoading();
  },

  addLoadingRequest: function addLoadingRequest(requestId) {
    this.loading_request_pool.push(requestId);
    if (this.loading_request_pool.length == 1) {
      // 启动 loading
      this.showLoading();
    }
  },
  removeLoadingRequest: function removeLoadingRequest(requestId) {
    this.loading_request_pool.splice(this.loading_request_pool.indexOf(requestId), 1);
    // 如果删除后 loading 池没有了
    if (this.loading_request_pool.length == 0) {
      this.hideLoading();
    }
  },
  contain: function contain(requestId) {
    return this.request_pool.indexOf(requestId) > -1;
  },

  // 监听这个请求,如果这周
  monitor: function monitor(requestId) {
    var _this = this;

    // 定时时间后如果还包含对应的 request id，则需要进行 loading
    setTimeout(function () {
      if (_this.contain(requestId)) {
        _this.addLoadingRequest(requestId);
      }
    }, this.delay_loading_timemer);
  },
  showLoading: function showLoading(text) {
    this.loadingInstance = __WEBPACK_IMPORTED_MODULE_0_element_ui__["Loading"].service({
      text: this.loading_text,
      fullscreen: true,
      lock: true,
      spinner: 'el-icon-loading',
      customClass: 'e2e-loading'
    });
  },
  hideLoading: function hideLoading() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1_vue___default.a.nextTick(function () {
      // 以服务的方式调用的 Loading 需要异步关闭
      _this2.loadingInstance.close();
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (LoadingManager);

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);


// 定义一个新的Message方法，多传入一个offset参数
var messageInstance = null;

var DonMessage = function DonMessage(options) {
  console.log(options);

  if (messageInstance) {
    messageInstance.close();
  }
  messageInstance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Message"])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, options, {
    offset: 96
  }));
  return messageInstance;
};
// 重写一遍success的方法,将offset写入options
['success', 'warning', 'info', 'error'].forEach(function (type) {
  DonMessage[type] = function (options) {
    if (typeof options === 'string') {
      options = {
        message: options,
        offset: 96
      };
    }
    options.type = type;
    return DonMessage(options);
  };
});
// 将$message挂载到this上

/* harmony default export */ __webpack_exports__["a"] = (DonMessage);

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(761), __esModule: true };

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(44).document;
module.exports = document && document.documentElement;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(70) && !__webpack_require__(119)(function () {
  return Object.defineProperty(__webpack_require__(267)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(143);
var ITERATOR = __webpack_require__(45)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(176);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(94);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(45)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 394 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(396);
var hiddenKeys = __webpack_require__(268).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(120);
var toIObject = __webpack_require__(144);
var arrayIndexOf = __webpack_require__(769)(false);
var IE_PROTO = __webpack_require__(276)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 397 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(94);
var isObject = __webpack_require__(80);
var newPromiseCapability = __webpack_require__(272);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(106);


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(44);
var core = __webpack_require__(36);
var dP = __webpack_require__(71);
var DESCRIPTORS = __webpack_require__(70);
var SPECIES = __webpack_require__(45)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(94);
var aFunction = __webpack_require__(175);
var SPECIES = __webpack_require__(45)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(105);
var invoke = __webpack_require__(778);
var html = __webpack_require__(388);
var cel = __webpack_require__(267);
var global = __webpack_require__(44);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(176)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(80);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(72);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(34);
var toAbsoluteIndex = __webpack_require__(129);
var toLength = __webpack_require__(29);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(122);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(46);
var toObject = __webpack_require__(34);
var IObject = __webpack_require__(184);
var toLength = __webpack_require__(29);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(46);
var isObject = __webpack_require__(18);
var invoke = __webpack_require__(414);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(33).f;
var create = __webpack_require__(123);
var redefineAll = __webpack_require__(127);
var ctx = __webpack_require__(74);
var anInstance = __webpack_require__(121);
var forOf = __webpack_require__(122);
var $iterDefine = __webpack_require__(295);
var step = __webpack_require__(417);
var setSpecies = __webpack_require__(128);
var DESCRIPTORS = __webpack_require__(31);
var fastKey = __webpack_require__(109).fastKey;
var validate = __webpack_require__(131);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(147);
var from = __webpack_require__(406);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(127);
var getWeak = __webpack_require__(109).getWeak;
var anObject = __webpack_require__(9);
var isObject = __webpack_require__(18);
var anInstance = __webpack_require__(121);
var forOf = __webpack_require__(122);
var createArrayMethod = __webpack_require__(81);
var $has = __webpack_require__(61);
var validate = __webpack_require__(131);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(217);
var isObject = __webpack_require__(18);
var toLength = __webpack_require__(29);
var ctx = __webpack_require__(74);
var IS_CONCAT_SPREADABLE = __webpack_require__(25)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(31) && !__webpack_require__(16)(function () {
  return Object.defineProperty(__webpack_require__(288)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 414 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(18);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(9);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(297);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 419 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 420 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(31);
var getKeys = __webpack_require__(125);
var gOPS = __webpack_require__(221);
var pIE = __webpack_require__(185);
var toObject = __webpack_require__(34);
var IObject = __webpack_require__(184);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(16)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(33);
var anObject = __webpack_require__(9);
var getKeys = __webpack_require__(125);

module.exports = __webpack_require__(31) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(64);
var gOPN = __webpack_require__(124).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(61);
var toIObject = __webpack_require__(64);
var arrayIndexOf = __webpack_require__(214)(false);
var IE_PROTO = __webpack_require__(302)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(31);
var getKeys = __webpack_require__(125);
var toIObject = __webpack_require__(64);
var isEnum = __webpack_require__(185).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(124);
var gOPS = __webpack_require__(221);
var anObject = __webpack_require__(9);
var Reflect = __webpack_require__(13).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(13).parseFloat;
var $trim = __webpack_require__(150).trim;

module.exports = 1 / $parseFloat(__webpack_require__(305) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(13).parseInt;
var $trim = __webpack_require__(150).trim;
var ws = __webpack_require__(305);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(9);
var isObject = __webpack_require__(18);
var newPromiseCapability = __webpack_require__(299);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 431 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(29);
var repeat = __webpack_require__(304);
var defined = __webpack_require__(82);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(76);
var toLength = __webpack_require__(29);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(25);


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(409);
var validate = __webpack_require__(131);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(215)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(300);
__webpack_require__(2)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(31) && /./g.flags != 'g') __webpack_require__(33).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(183)
});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(409);
var validate = __webpack_require__(131);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(215)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(13);
var each = __webpack_require__(81)(0);
var redefine = __webpack_require__(55);
var meta = __webpack_require__(109);
var assign = __webpack_require__(421);
var weak = __webpack_require__(411);
var isObject = __webpack_require__(18);
var validate = __webpack_require__(131);
var NATIVE_WEAK_MAP = __webpack_require__(131);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(215)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = stopPreviousKeyframeAnimationAndRestore;
/* harmony export (immutable) */ __webpack_exports__["b"] = applyKeyframeAnimation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__customGraphicTransition_js__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basicTrasition_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_log_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var getStateToRestore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_model_js__["a" /* makeInner */])();
var KEYFRAME_EXCLUDE_KEYS = ['percent', 'easing', 'shape', 'style', 'extra'];
/**
 * Stop previous keyframe animation and restore the attributes.
 * Avoid new keyframe animation starts with wrong internal state when the percent: 0 is not set.
 */

function stopPreviousKeyframeAnimationAndRestore(el) {
  // Stop previous keyframe animation.
  el.stopAnimation('keyframe'); // Restore

  el.attr(getStateToRestore(el));
}
function applyKeyframeAnimation(el, animationOpts, animatableModel) {
  if (!animatableModel.isAnimationEnabled() || !animationOpts) {
    return;
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"])(animationOpts)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(animationOpts, function (singleAnimationOpts) {
      applyKeyframeAnimation(el, singleAnimationOpts, animatableModel);
    });
    return;
  }

  var keyframes = animationOpts.keyframes;
  var duration = animationOpts.duration;

  if (animatableModel && duration == null) {
    // Default to use duration of config.
    // NOTE: animation config from payload will be ignored because they are mainly for transitions.
    var config = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__basicTrasition_js__["d" /* getAnimationConfig */])('enter', animatableModel, 0);
    duration = config && config.duration;
  }

  if (!keyframes || !duration) {
    return;
  }

  var stateToRestore = getStateToRestore(el);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(__WEBPACK_IMPORTED_MODULE_1__customGraphicTransition_js__["e" /* ELEMENT_ANIMATABLE_PROPS */], function (targetPropName) {
    if (targetPropName && !el[targetPropName]) {
      return;
    }

    var animator;
    var endFrameIsSet = false; // Sort keyframes by percent.

    keyframes.sort(function (a, b) {
      return a.percent - b.percent;
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(keyframes, function (kf) {
      // Stop current animation.
      var animators = el.animators;
      var kfValues = targetPropName ? kf[targetPropName] : kf;

      if (true) {
        if (kf.percent >= 1) {
          endFrameIsSet = true;
        }
      }

      if (!kfValues) {
        return;
      }

      var propKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["keys"])(kfValues);

      if (!targetPropName) {
        // PENDING performance?
        propKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["filter"])(propKeys, function (key) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"])(KEYFRAME_EXCLUDE_KEYS, key) < 0;
        });
      }

      if (!propKeys.length) {
        return;
      }

      if (!animator) {
        animator = el.animate(targetPropName, animationOpts.loop, true);
        animator.scope = 'keyframe';
      }

      for (var i = 0; i < animators.length; i++) {
        // Stop all other animation that is not keyframe.
        if (animators[i] !== animator && animators[i].targetName === animator.targetName) {
          animators[i].stopTracks(propKeys);
        }
      }

      targetPropName && (stateToRestore[targetPropName] = stateToRestore[targetPropName] || {});
      var savedTarget = targetPropName ? stateToRestore[targetPropName] : stateToRestore;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(propKeys, function (key) {
        // Save original value.
        savedTarget[key] = ((targetPropName ? el[targetPropName] : el) || {})[key];
      });
      animator.whenWithKeys(duration * kf.percent, kfValues, propKeys, kf.easing);
    });

    if (!animator) {
      return;
    }

    if (true) {
      if (!endFrameIsSet) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_log_js__["b" /* warn */])('End frame with percent: 1 is missing in the keyframeAnimation.', true);
      }
    }

    animator.delay(animationOpts.delay || 0).duration(duration).start(animationOpts.easing);
  });
}

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_Series_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_createSeriesData_js__ = __webpack_require__(85);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var BaseBarSeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(BaseBarSeriesModel, _super);

  function BaseBarSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = BaseBarSeriesModel.type;
    return _this;
  }

  BaseBarSeriesModel.prototype.getInitialData = function (option, ecModel) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_createSeriesData_js__["a" /* default */])(null, this, {
      useEncodeDefaulter: true
    });
  };

  BaseBarSeriesModel.prototype.getMarkerPosition = function (value) {
    var coordSys = this.coordinateSystem;

    if (coordSys && coordSys.clampData) {
      // PENDING if clamp ?
      var pt = coordSys.dataToPoint(coordSys.clampData(value));
      var data = this.getData();
      var offset = data.getLayout('offset');
      var size = data.getLayout('size');
      var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
      pt[offsetIndex] += offset + size / 2;
      return pt;
    }

    return [NaN, NaN];
  };

  BaseBarSeriesModel.type = 'series.__base_bar__';
  BaseBarSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    coordinateSystem: 'cartesian2d',
    legendHoverLink: true,
    // stack: null
    // Cartesian coordinate system
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    barMinHeight: 0,
    barMinAngle: 0,
    // cursor: null,
    large: false,
    largeThreshold: 400,
    progressive: 3e3,
    progressiveChunkMode: 'mod'
  };
  return BaseBarSeriesModel;
}(__WEBPACK_IMPORTED_MODULE_1__model_Series_js__["b" /* default */]);

__WEBPACK_IMPORTED_MODULE_1__model_Series_js__["b" /* default */].registerClass(BaseBarSeriesModel);
/* harmony default export */ __webpack_exports__["a"] = (BaseBarSeriesModel);

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STYLE_VISUAL_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NON_STYLE_VISUAL_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return customInnerStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_createSeriesData_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_Series_js__ = __webpack_require__(26);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



 // Also compat with ec4, where
// `visual('color') visual('borderColor')` is supported.

var STYLE_VISUAL_TYPE = {
  color: 'fill',
  borderColor: 'stroke'
};
var NON_STYLE_VISUAL_PROPS = {
  symbol: 1,
  symbolSize: 1,
  symbolKeepAspect: 1,
  legendIcon: 1,
  visualMeta: 1,
  liftZ: 1,
  decal: 1
};
;
var customInnerStore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_model_js__["a" /* makeInner */])();

var CustomSeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(CustomSeriesModel, _super);

  function CustomSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = CustomSeriesModel.type;
    return _this;
  }

  CustomSeriesModel.prototype.optionUpdated = function () {
    this.currentZLevel = this.get('zlevel', true);
    this.currentZ = this.get('z', true);
  };

  CustomSeriesModel.prototype.getInitialData = function (option, ecModel) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper_createSeriesData_js__["a" /* default */])(null, this);
  };

  CustomSeriesModel.prototype.getDataParams = function (dataIndex, dataType, el) {
    var params = _super.prototype.getDataParams.call(this, dataIndex, dataType);

    el && (params.info = customInnerStore(el).info);
    return params;
  };

  CustomSeriesModel.type = 'series.custom';
  CustomSeriesModel.dependencies = ['grid', 'polar', 'geo', 'singleAxis', 'calendar'];
  CustomSeriesModel.defaultOption = {
    coordinateSystem: 'cartesian2d',
    // zlevel: 0,
    z: 2,
    legendHoverLink: true,
    // Custom series will not clip by default.
    // Some case will use custom series to draw label
    // For example https://echarts.apache.org/examples/en/editor.html?c=custom-gantt-flight
    clip: false // Cartesian coordinate system
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // Polar coordinate system
    // polarIndex: 0,
    // Geo coordinate system
    // geoIndex: 0,

  };
  return CustomSeriesModel;
}(__WEBPACK_IMPORTED_MODULE_3__model_Series_js__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CustomSeriesModel);

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = circularLayout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_vector_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphHelper_js__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_multipleGraphEdgeHelper_js__ = __webpack_require__(229);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var PI = Math.PI;
var _symbolRadiansHalf = [];
/**
 * `basedOn` can be:
 * 'value':
 *     This layout is not accurate and have same bad case. For example,
 *     if the min value is very smaller than the max value, the nodes
 *     with the min value probably overlap even though there is enough
 *     space to layout them. So we only use this approach in the as the
 *     init layout of the force layout.
 *     FIXME
 *     Probably we do not need this method any more but use
 *     `basedOn: 'symbolSize'` in force layout if
 *     delay its init operations to GraphView.
 * 'symbolSize':
 *     This approach work only if all of the symbol size calculated.
 *     That is, the progressive rendering is not applied to graph.
 *     FIXME
 *     If progressive rendering is applied to graph some day,
 *     probably we have to use `basedOn: 'value'`.
 */

function circularLayout(seriesModel, basedOn) {
  var coordSys = seriesModel.coordinateSystem;

  if (coordSys && coordSys.type !== 'view') {
    return;
  }

  var rect = coordSys.getBoundingRect();
  var nodeData = seriesModel.getData();
  var graph = nodeData.graph;
  var cx = rect.width / 2 + rect.x;
  var cy = rect.height / 2 + rect.y;
  var r = Math.min(rect.width, rect.height) / 2;
  var count = nodeData.count();
  nodeData.setLayout({
    cx: cx,
    cy: cy
  });

  if (!count) {
    return;
  }

  _layoutNodesBasedOn[basedOn](seriesModel, graph, nodeData, r, cx, cy, count);

  graph.eachEdge(function (edge, index) {
    var curveness = __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["retrieve3"](edge.getModel().get(['lineStyle', 'curveness']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_multipleGraphEdgeHelper_js__["a" /* getCurvenessForEdge */])(edge, seriesModel, index), 0);
    var p1 = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_vector_js__["clone"](edge.node1.getLayout());
    var p2 = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_vector_js__["clone"](edge.node2.getLayout());
    var cp1;
    var x12 = (p1[0] + p2[0]) / 2;
    var y12 = (p1[1] + p2[1]) / 2;

    if (+curveness) {
      curveness *= 3;
      cp1 = [cx * curveness + x12 * (1 - curveness), cy * curveness + y12 * (1 - curveness)];
    }

    edge.setLayout([p1, p2, cp1]);
  });
}
var _layoutNodesBasedOn = {
  value: function (seriesModel, graph, nodeData, r, cx, cy, count) {
    var angle = 0;
    var sum = nodeData.getSum('value');
    var unitAngle = Math.PI * 2 / (sum || count);
    graph.eachNode(function (node) {
      var value = node.getValue('value');
      var radianHalf = unitAngle * (sum ? value : 1) / 2;
      angle += radianHalf;
      node.setLayout([r * Math.cos(angle) + cx, r * Math.sin(angle) + cy]);
      angle += radianHalf;
    });
  },
  symbolSize: function (seriesModel, graph, nodeData, r, cx, cy, count) {
    var sumRadian = 0;
    _symbolRadiansHalf.length = count;
    var nodeScale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__graphHelper_js__["a" /* getNodeGlobalScale */])(seriesModel);
    graph.eachNode(function (node) {
      var symbolSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__graphHelper_js__["b" /* getSymbolSize */])(node); // Normally this case will not happen, but we still add
      // some the defensive code (2px is an arbitrary value).

      isNaN(symbolSize) && (symbolSize = 2);
      symbolSize < 0 && (symbolSize = 0);
      symbolSize *= nodeScale;
      var symbolRadianHalf = Math.asin(symbolSize / 2 / r); // when `symbolSize / 2` is bigger than `r`.

      isNaN(symbolRadianHalf) && (symbolRadianHalf = PI / 2);
      _symbolRadiansHalf[node.dataIndex] = symbolRadianHalf;
      sumRadian += symbolRadianHalf * 2;
    });
    var halfRemainRadian = (2 * PI - sumRadian) / count / 2;
    var angle = 0;
    graph.eachNode(function (node) {
      var radianHalf = halfRemainRadian + _symbolRadiansHalf[node.dataIndex];
      angle += radianHalf;
      node.setLayout([r * Math.cos(angle) + cx, r * Math.sin(angle) + cy]);
      angle += radianHalf;
    });
  }
};

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = simpleLayout;
/* harmony export (immutable) */ __webpack_exports__["b"] = simpleLayoutEdge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_vector_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_multipleGraphEdgeHelper_js__ = __webpack_require__(229);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



function simpleLayout(seriesModel) {
  var coordSys = seriesModel.coordinateSystem;

  if (coordSys && coordSys.type !== 'view') {
    return;
  }

  var graph = seriesModel.getGraph();
  graph.eachNode(function (node) {
    var model = node.getModel();
    node.setLayout([+model.get('x'), +model.get('y')]);
  });
  simpleLayoutEdge(graph, seriesModel);
}
function simpleLayoutEdge(graph, seriesModel) {
  graph.eachEdge(function (edge, index) {
    var curveness = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["retrieve3"](edge.getModel().get(['lineStyle', 'curveness']), -__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_multipleGraphEdgeHelper_js__["a" /* getCurvenessForEdge */])(edge, seriesModel, index, true), 0);
    var p1 = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_vector_js__["clone"](edge.node1.getLayout());
    var p2 = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_vector_js__["clone"](edge.node2.getLayout());
    var points = [p1, p2];

    if (+curveness) {
      points.push([(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * curveness]);
    }

    edge.setLayout(points);
  });
}

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Line_js__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_symbol_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_vector_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_curve_js__ = __webpack_require__(57);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Provide effect for line
 */








var EffectLine =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(EffectLine, _super);

  function EffectLine(lineData, idx, seriesScope) {
    var _this = _super.call(this) || this;

    _this.add(_this.createLine(lineData, idx, seriesScope));

    _this._updateEffectSymbol(lineData, idx);

    return _this;
  }

  EffectLine.prototype.createLine = function (lineData, idx, seriesScope) {
    return new __WEBPACK_IMPORTED_MODULE_2__Line_js__["a" /* default */](lineData, idx, seriesScope);
  };

  EffectLine.prototype._updateEffectSymbol = function (lineData, idx) {
    var itemModel = lineData.getItemModel(idx);
    var effectModel = itemModel.getModel('effect');
    var size = effectModel.get('symbolSize');
    var symbolType = effectModel.get('symbol');

    if (!__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["isArray"](size)) {
      size = [size, size];
    }

    var lineStyle = lineData.getItemVisual(idx, 'style');
    var color = effectModel.get('color') || lineStyle && lineStyle.stroke;
    var symbol = this.childAt(1);

    if (this._symbolType !== symbolType) {
      // Remove previous
      this.remove(symbol);
      symbol = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_symbol_js__["a" /* createSymbol */])(symbolType, -0.5, -0.5, 1, 1, color);
      symbol.z2 = 100;
      symbol.culling = true;
      this.add(symbol);
    } // Symbol may be removed if loop is false


    if (!symbol) {
      return;
    } // Shadow color is same with color in default


    symbol.setStyle('shadowColor', color);
    symbol.setStyle(effectModel.getItemStyle(['color']));
    symbol.scaleX = size[0];
    symbol.scaleY = size[1];
    symbol.setColor(color);
    this._symbolType = symbolType;
    this._symbolScale = size;

    this._updateEffectAnimation(lineData, effectModel, idx);
  };

  EffectLine.prototype._updateEffectAnimation = function (lineData, effectModel, idx) {
    var symbol = this.childAt(1);

    if (!symbol) {
      return;
    }

    var points = lineData.getItemLayout(idx);
    var period = effectModel.get('period') * 1000;
    var loop = effectModel.get('loop');
    var constantSpeed = effectModel.get('constantSpeed');
    var delayExpr = __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["retrieve"](effectModel.get('delay'), function (idx) {
      return idx / lineData.count() * period / 3;
    }); // Ignore when updating

    symbol.ignore = true;

    this._updateAnimationPoints(symbol, points);

    if (constantSpeed > 0) {
      period = this._getLineLength(symbol) / constantSpeed * 1000;
    }

    if (period !== this._period || loop !== this._loop) {
      symbol.stopAnimation();
      var delayNum = void 0;

      if (__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["isFunction"](delayExpr)) {
        delayNum = delayExpr(idx);
      } else {
        delayNum = delayExpr;
      }

      if (symbol.__t > 0) {
        delayNum = -period * symbol.__t;
      }

      this._animateSymbol(symbol, period, delayNum, loop);
    }

    this._period = period;
    this._loop = loop;
  };

  EffectLine.prototype._animateSymbol = function (symbol, period, delayNum, loop) {
    if (period > 0) {
      symbol.__t = 0;
      var self_1 = this;
      var animator = symbol.animate('', loop).when(period, {
        __t: 1
      }).delay(delayNum).during(function () {
        self_1._updateSymbolPosition(symbol);
      });

      if (!loop) {
        animator.done(function () {
          self_1.remove(symbol);
        });
      }

      animator.start();
    }
  };

  EffectLine.prototype._getLineLength = function (symbol) {
    // Not so accurate
    return __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_vector_js__["dist"](symbol.__p1, symbol.__cp1) + __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_vector_js__["dist"](symbol.__cp1, symbol.__p2);
  };

  EffectLine.prototype._updateAnimationPoints = function (symbol, points) {
    symbol.__p1 = points[0];
    symbol.__p2 = points[1];
    symbol.__cp1 = points[2] || [(points[0][0] + points[1][0]) / 2, (points[0][1] + points[1][1]) / 2];
  };

  EffectLine.prototype.updateData = function (lineData, idx, seriesScope) {
    this.childAt(0).updateData(lineData, idx, seriesScope);

    this._updateEffectSymbol(lineData, idx);
  };

  EffectLine.prototype._updateSymbolPosition = function (symbol) {
    var p1 = symbol.__p1;
    var p2 = symbol.__p2;
    var cp1 = symbol.__cp1;
    var t = symbol.__t;
    var pos = [symbol.x, symbol.y];
    var lastPos = pos.slice();
    var quadraticAt = __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_curve_js__["f" /* quadraticAt */];
    var quadraticDerivativeAt = __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_curve_js__["n" /* quadraticDerivativeAt */];
    pos[0] = quadraticAt(p1[0], cp1[0], p2[0], t);
    pos[1] = quadraticAt(p1[1], cp1[1], p2[1], t); // Tangent

    var tx = quadraticDerivativeAt(p1[0], cp1[0], p2[0], t);
    var ty = quadraticDerivativeAt(p1[1], cp1[1], p2[1], t);
    symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2; // enable continuity trail for 'line', 'rect', 'roundRect' symbolType

    if (this._symbolType === 'line' || this._symbolType === 'rect' || this._symbolType === 'roundRect') {
      if (symbol.__lastT !== undefined && symbol.__lastT < symbol.__t) {
        symbol.scaleY = __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_vector_js__["dist"](lastPos, pos) * 1.05; // make sure the last segment render within endPoint

        if (t === 1) {
          pos[0] = lastPos[0] + (pos[0] - lastPos[0]) / 2;
          pos[1] = lastPos[1] + (pos[1] - lastPos[1]) / 2;
        }
      } else if (symbol.__lastT === 1) {
        // After first loop, symbol.__t does NOT start with 0, so connect p1 to pos directly.
        symbol.scaleY = 2 * __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_vector_js__["dist"](p1, pos);
      } else {
        symbol.scaleY = this._symbolScale[1];
      }
    }

    symbol.__lastT = symbol.__t;
    symbol.ignore = false;
    symbol.x = pos[0];
    symbol.y = pos[1];
  };

  EffectLine.prototype.updateLayout = function (lineData, idx) {
    this.childAt(0).updateLayout(lineData, idx);
    var effectModel = lineData.getItemModel(idx).getModel('effect');

    this._updateEffectAnimation(lineData, effectModel, idx);
  };

  return EffectLine;
}(__WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Group"]);

/* harmony default export */ __webpack_exports__["a"] = (EffectLine);

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_states_js__ = __webpack_require__(12);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var Polyline =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Polyline, _super);

  function Polyline(lineData, idx, seriesScope) {
    var _this = _super.call(this) || this;

    _this._createPolyline(lineData, idx, seriesScope);

    return _this;
  }

  Polyline.prototype._createPolyline = function (lineData, idx, seriesScope) {
    // let seriesModel = lineData.hostModel;
    var points = lineData.getItemLayout(idx);
    var line = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Polyline"]({
      shape: {
        points: points
      }
    });
    this.add(line);

    this._updateCommonStl(lineData, idx, seriesScope);
  };

  ;

  Polyline.prototype.updateData = function (lineData, idx, seriesScope) {
    var seriesModel = lineData.hostModel;
    var line = this.childAt(0);
    var target = {
      shape: {
        points: lineData.getItemLayout(idx)
      }
    };
    __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["updateProps"](line, target, seriesModel, idx);

    this._updateCommonStl(lineData, idx, seriesScope);
  };

  ;

  Polyline.prototype._updateCommonStl = function (lineData, idx, seriesScope) {
    var line = this.childAt(0);
    var itemModel = lineData.getItemModel(idx);
    var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
    var focus = seriesScope && seriesScope.focus;
    var blurScope = seriesScope && seriesScope.blurScope;
    var emphasisDisabled = seriesScope && seriesScope.emphasisDisabled;

    if (!seriesScope || lineData.hasItemOption) {
      var emphasisModel = itemModel.getModel('emphasis');
      emphasisLineStyle = emphasisModel.getModel('lineStyle').getLineStyle();
      emphasisDisabled = emphasisModel.get('disabled');
      focus = emphasisModel.get('focus');
      blurScope = emphasisModel.get('blurScope');
    }

    line.useStyle(lineData.getItemVisual(idx, 'style'));
    line.style.fill = null;
    line.style.strokeNoScale = true;
    var lineEmphasisState = line.ensureState('emphasis');
    lineEmphasisState.style = emphasisLineStyle;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_states_js__["G" /* toggleHoverEmphasis */])(this, focus, blurScope, emphasisDisabled);
  };

  ;

  Polyline.prototype.updateLayout = function (lineData, idx) {
    var polyline = this.childAt(0);
    polyline.setShape('points', lineData.getItemLayout(idx));
  };

  ;
  return Polyline;
}(__WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Group"]);

/* harmony default export */ __webpack_exports__["a"] = (Polyline);

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createGraphFromNodeEdge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_SeriesData_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_Graph_js__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_helper_linkSeriesData_js__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_helper_createDimensions_js__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_CoordinateSystem_js__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createSeriesData_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/








function createGraphFromNodeEdge(nodes, edges, seriesModel, directed, beforeLink) {
  // ??? TODO
  // support dataset?
  var graph = new __WEBPACK_IMPORTED_MODULE_2__data_Graph_js__["a" /* default */](directed);

  for (var i = 0; i < nodes.length; i++) {
    graph.addNode(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve"]( // Id, name, dataIndex
    nodes[i].id, nodes[i].name, i), i);
  }

  var linkNameList = [];
  var validEdges = [];
  var linkCount = 0;

  for (var i = 0; i < edges.length; i++) {
    var link = edges[i];
    var source = link.source;
    var target = link.target; // addEdge may fail when source or target not exists

    if (graph.addEdge(source, target, linkCount)) {
      validEdges.push(link);
      linkNameList.push(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve"](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_model_js__["n" /* convertOptionIdName */])(link.id, null), source + ' > ' + target));
      linkCount++;
    }
  }

  var coordSys = seriesModel.get('coordinateSystem');
  var nodeData;

  if (coordSys === 'cartesian2d' || coordSys === 'polar') {
    nodeData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__createSeriesData_js__["a" /* default */])(nodes, seriesModel);
  } else {
    var coordSysCtor = __WEBPACK_IMPORTED_MODULE_5__core_CoordinateSystem_js__["a" /* default */].get(coordSys);
    var coordDimensions = coordSysCtor ? coordSysCtor.dimensions || [] : []; // FIXME: Some geo do not need `value` dimenson, whereas `calendar` needs
    // `value` dimension, but graph need `value` dimension. It's better to
    // uniform this behavior.

    if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"](coordDimensions, 'value') < 0) {
      coordDimensions.concat(['value']);
    }

    var dimensions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__data_helper_createDimensions_js__["a" /* default */])(nodes, {
      coordDimensions: coordDimensions,
      encodeDefine: seriesModel.getEncode()
    }).dimensions;
    nodeData = new __WEBPACK_IMPORTED_MODULE_1__data_SeriesData_js__["a" /* default */](dimensions, seriesModel);
    nodeData.initData(nodes);
  }

  var edgeData = new __WEBPACK_IMPORTED_MODULE_1__data_SeriesData_js__["a" /* default */](['value'], seriesModel);
  edgeData.initData(validEdges, linkNameList);
  beforeLink && beforeLink(nodeData, edgeData);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_helper_linkSeriesData_js__["a" /* default */])({
    mainData: nodeData,
    struct: graph,
    structAttr: 'graph',
    datas: {
      node: nodeData,
      edge: edgeData
    },
    datasAttr: {
      node: 'data',
      edge: 'edgeData'
    }
  }); // Update dataIndex of nodes and edges because invalid edge may be removed

  graph.update();
  return graph;
}

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = enableAriaDecalForTree;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_mixin_palette_js__ = __webpack_require__(240);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

function enableAriaDecalForTree(seriesModel) {
  var data = seriesModel.getData();
  var tree = data.tree;
  var decalPaletteScope = {};
  tree.eachNode(function (node) {
    // Use decal of level 1 node
    var current = node;

    while (current && current.depth > 1) {
      current = current.parentNode;
    }

    var decal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__model_mixin_palette_js__["b" /* getDecalFromPalette */])(seriesModel.ecModel, current.name || current.dataIndex + '', decalPaletteScope);
    node.setVisual('decal', decal);
  });
}

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSectorCornerRadius;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_contain_text_js__ = __webpack_require__(47);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


function getSectorCornerRadius(model, shape, zeroIfNull) {
  var cornerRadius = model.get('borderRadius');

  if (cornerRadius == null) {
    return zeroIfNull ? {
      cornerRadius: 0
    } : null;
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"])(cornerRadius)) {
    cornerRadius = [cornerRadius, cornerRadius, cornerRadius, cornerRadius];
  }

  var dr = Math.abs(shape.r || 0 - shape.r0 || 0);
  return {
    cornerRadius: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])(cornerRadius, function (cr) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_contain_text_js__["b" /* parsePercent */])(cr, dr);
    })
  };
}

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WhiskerBoxCommonMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createSeriesDataSimply_js__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_helper_dimensionHelper_js__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_helper_sourceHelper_js__ = __webpack_require__(98);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var WhiskerBoxCommonMixin =
/** @class */
function () {
  function WhiskerBoxCommonMixin() {}
  /**
   * @override
   */


  WhiskerBoxCommonMixin.prototype.getInitialData = function (option, ecModel) {
    // When both types of xAxis and yAxis are 'value', layout is
    // needed to be specified by user. Otherwise, layout can be
    // judged by which axis is category.
    var ordinalMeta;
    var xAxisModel = ecModel.getComponent('xAxis', this.get('xAxisIndex'));
    var yAxisModel = ecModel.getComponent('yAxis', this.get('yAxisIndex'));
    var xAxisType = xAxisModel.get('type');
    var yAxisType = yAxisModel.get('type');
    var addOrdinal; // FIXME
    // Consider time axis.

    if (xAxisType === 'category') {
      option.layout = 'horizontal';
      ordinalMeta = xAxisModel.getOrdinalMeta();
      addOrdinal = true;
    } else if (yAxisType === 'category') {
      option.layout = 'vertical';
      ordinalMeta = yAxisModel.getOrdinalMeta();
      addOrdinal = true;
    } else {
      option.layout = option.layout || 'horizontal';
    }

    var coordDims = ['x', 'y'];
    var baseAxisDimIndex = option.layout === 'horizontal' ? 0 : 1;
    var baseAxisDim = this._baseAxisDim = coordDims[baseAxisDimIndex];
    var otherAxisDim = coordDims[1 - baseAxisDimIndex];
    var axisModels = [xAxisModel, yAxisModel];
    var baseAxisType = axisModels[baseAxisDimIndex].get('type');
    var otherAxisType = axisModels[1 - baseAxisDimIndex].get('type');
    var data = option.data; // Clone a new data for next setOption({}) usage.
    // Avoid modifying current data will affect further update.

    if (data && addOrdinal) {
      var newOptionData_1 = [];
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](data, function (item, index) {
        var newItem;

        if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](item)) {
          newItem = item.slice(); // Modify current using data.

          item.unshift(index);
        } else if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](item.value)) {
          newItem = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"]({}, item);
          newItem.value = newItem.value.slice(); // Modify current using data.

          item.value.unshift(index);
        } else {
          newItem = item;
        }

        newOptionData_1.push(newItem);
      });
      option.data = newOptionData_1;
    }

    var defaultValueDimensions = this.defaultValueDimensions;
    var coordDimensions = [{
      name: baseAxisDim,
      type: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_helper_dimensionHelper_js__["b" /* getDimensionTypeByAxis */])(baseAxisType),
      ordinalMeta: ordinalMeta,
      otherDims: {
        tooltip: false,
        itemName: 0
      },
      dimsDef: ['base']
    }, {
      name: otherAxisDim,
      type: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_helper_dimensionHelper_js__["b" /* getDimensionTypeByAxis */])(otherAxisType),
      dimsDef: defaultValueDimensions.slice()
    }];
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createSeriesDataSimply_js__["a" /* default */])(this, {
      coordDimensions: coordDimensions,
      dimensionsCount: defaultValueDimensions.length + 1,
      encodeDefaulter: __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["curry"](__WEBPACK_IMPORTED_MODULE_3__data_helper_sourceHelper_js__["f" /* makeSeriesEncodeForAxisCoordSys */], coordDimensions, this)
    });
  };
  /**
   * If horizontal, base axis is x, otherwise y.
   * @override
   */


  WhiskerBoxCommonMixin.prototype.getBaseAxis = function () {
    var dim = this._baseAxisDim;
    return this.ecModel.getComponent(dim + 'Axis', this.get(dim + 'AxisIndex')).axis;
  };

  return WhiskerBoxCommonMixin;
}();

;


/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = prepareDataCoordInfo;
/* harmony export (immutable) */ __webpack_exports__["a"] = getStackedOnPoint;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_helper_dataStackHelper_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


function prepareDataCoordInfo(coordSys, data, valueOrigin) {
  var baseAxis = coordSys.getBaseAxis();
  var valueAxis = coordSys.getOtherAxis(baseAxis);
  var valueStart = getValueStart(valueAxis, valueOrigin);
  var baseAxisDim = baseAxis.dim;
  var valueAxisDim = valueAxis.dim;
  var valueDim = data.mapDimension(valueAxisDim);
  var baseDim = data.mapDimension(baseAxisDim);
  var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
  var dims = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"])(coordSys.dimensions, function (coordDim) {
    return data.mapDimension(coordDim);
  });
  var stacked = false;
  var stackResultDim = data.getCalculationInfo('stackResultDimension');

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__data_helper_dataStackHelper_js__["b" /* isDimensionStacked */])(data, dims[0]
  /*, dims[1]*/
  )) {
    // jshint ignore:line
    stacked = true;
    dims[0] = stackResultDim;
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__data_helper_dataStackHelper_js__["b" /* isDimensionStacked */])(data, dims[1]
  /*, dims[0]*/
  )) {
    // jshint ignore:line
    stacked = true;
    dims[1] = stackResultDim;
  }

  return {
    dataDimsForPoint: dims,
    valueStart: valueStart,
    valueAxisDim: valueAxisDim,
    baseAxisDim: baseAxisDim,
    stacked: !!stacked,
    valueDim: valueDim,
    baseDim: baseDim,
    baseDataOffset: baseDataOffset,
    stackedOverDimension: data.getCalculationInfo('stackedOverDimension')
  };
}

function getValueStart(valueAxis, valueOrigin) {
  var valueStart = 0;
  var extent = valueAxis.scale.getExtent();

  if (valueOrigin === 'start') {
    valueStart = extent[0];
  } else if (valueOrigin === 'end') {
    valueStart = extent[1];
  } // If origin is specified as a number, use it as
  // valueStart directly
  else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isNumber"])(valueOrigin) && !isNaN(valueOrigin)) {
      valueStart = valueOrigin;
    } // auto
    else {
        // Both positive
        if (extent[0] > 0) {
          valueStart = extent[0];
        } // Both negative
        else if (extent[1] < 0) {
            valueStart = extent[1];
          } // If is one positive, and one negative, onZero shall be true

      }

  return valueStart;
}

function getStackedOnPoint(dataCoordInfo, coordSys, data, idx) {
  var value = NaN;

  if (dataCoordInfo.stacked) {
    value = data.get(data.getCalculationInfo('stackedOverDimension'), idx);
  }

  if (isNaN(value)) {
    value = dataCoordInfo.valueStart;
  }

  var baseDataOffset = dataCoordInfo.baseDataOffset;
  var stackedData = [];
  stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
  stackedData[1 - baseDataOffset] = value;
  return coordSys.dataToPoint(stackedData);
}

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ECPolyline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ECPolygon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_graphic_Path_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_PathProxy_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_curve_js__ = __webpack_require__(57);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
 // Poly path support NaN point




var mathMin = Math.min;
var mathMax = Math.max;

function isPointNull(x, y) {
  return isNaN(x) || isNaN(y);
}
/**
 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
 * situations. This should be used when points are non-monotone neither in x or
 * y dimension.
 */


function drawSegment(ctx, points, start, segLen, allLen, dir, smooth, smoothMonotone, connectNulls) {
  var prevX;
  var prevY;
  var cpx0;
  var cpy0;
  var cpx1;
  var cpy1;
  var idx = start;
  var k = 0;

  for (; k < segLen; k++) {
    var x = points[idx * 2];
    var y = points[idx * 2 + 1];

    if (idx >= allLen || idx < 0) {
      break;
    }

    if (isPointNull(x, y)) {
      if (connectNulls) {
        idx += dir;
        continue;
      }

      break;
    }

    if (idx === start) {
      ctx[dir > 0 ? 'moveTo' : 'lineTo'](x, y);
      cpx0 = x;
      cpy0 = y;
    } else {
      var dx = x - prevX;
      var dy = y - prevY; // Ignore tiny segment.

      if (dx * dx + dy * dy < 0.5) {
        idx += dir;
        continue;
      }

      if (smooth > 0) {
        var nextIdx = idx + dir;
        var nextX = points[nextIdx * 2];
        var nextY = points[nextIdx * 2 + 1]; // Ignore duplicate point

        while (nextX === x && nextY === y && k < segLen) {
          k++;
          nextIdx += dir;
          idx += dir;
          nextX = points[nextIdx * 2];
          nextY = points[nextIdx * 2 + 1];
          x = points[idx * 2];
          y = points[idx * 2 + 1];
          dx = x - prevX;
          dy = y - prevY;
        }

        var tmpK = k + 1;

        if (connectNulls) {
          // Find next point not null
          while (isPointNull(nextX, nextY) && tmpK < segLen) {
            tmpK++;
            nextIdx += dir;
            nextX = points[nextIdx * 2];
            nextY = points[nextIdx * 2 + 1];
          }
        }

        var ratioNextSeg = 0.5;
        var vx = 0;
        var vy = 0;
        var nextCpx0 = void 0;
        var nextCpy0 = void 0; // Is last point

        if (tmpK >= segLen || isPointNull(nextX, nextY)) {
          cpx1 = x;
          cpy1 = y;
        } else {
          vx = nextX - prevX;
          vy = nextY - prevY;
          var dx0 = x - prevX;
          var dx1 = nextX - x;
          var dy0 = y - prevY;
          var dy1 = nextY - y;
          var lenPrevSeg = void 0;
          var lenNextSeg = void 0;

          if (smoothMonotone === 'x') {
            lenPrevSeg = Math.abs(dx0);
            lenNextSeg = Math.abs(dx1);
            var dir_1 = vx > 0 ? 1 : -1;
            cpx1 = x - dir_1 * lenPrevSeg * smooth;
            cpy1 = y;
            nextCpx0 = x + dir_1 * lenNextSeg * smooth;
            nextCpy0 = y;
          } else if (smoothMonotone === 'y') {
            lenPrevSeg = Math.abs(dy0);
            lenNextSeg = Math.abs(dy1);
            var dir_2 = vy > 0 ? 1 : -1;
            cpx1 = x;
            cpy1 = y - dir_2 * lenPrevSeg * smooth;
            nextCpx0 = x;
            nextCpy0 = y + dir_2 * lenNextSeg * smooth;
          } else {
            lenPrevSeg = Math.sqrt(dx0 * dx0 + dy0 * dy0);
            lenNextSeg = Math.sqrt(dx1 * dx1 + dy1 * dy1); // Use ratio of seg length

            ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
            cpx1 = x - vx * smooth * (1 - ratioNextSeg);
            cpy1 = y - vy * smooth * (1 - ratioNextSeg); // cp0 of next segment

            nextCpx0 = x + vx * smooth * ratioNextSeg;
            nextCpy0 = y + vy * smooth * ratioNextSeg; // Smooth constraint between point and next point.
            // Avoid exceeding extreme after smoothing.

            nextCpx0 = mathMin(nextCpx0, mathMax(nextX, x));
            nextCpy0 = mathMin(nextCpy0, mathMax(nextY, y));
            nextCpx0 = mathMax(nextCpx0, mathMin(nextX, x));
            nextCpy0 = mathMax(nextCpy0, mathMin(nextY, y)); // Reclaculate cp1 based on the adjusted cp0 of next seg.

            vx = nextCpx0 - x;
            vy = nextCpy0 - y;
            cpx1 = x - vx * lenPrevSeg / lenNextSeg;
            cpy1 = y - vy * lenPrevSeg / lenNextSeg; // Smooth constraint between point and prev point.
            // Avoid exceeding extreme after smoothing.

            cpx1 = mathMin(cpx1, mathMax(prevX, x));
            cpy1 = mathMin(cpy1, mathMax(prevY, y));
            cpx1 = mathMax(cpx1, mathMin(prevX, x));
            cpy1 = mathMax(cpy1, mathMin(prevY, y)); // Adjust next cp0 again.

            vx = x - cpx1;
            vy = y - cpy1;
            nextCpx0 = x + vx * lenNextSeg / lenPrevSeg;
            nextCpy0 = y + vy * lenNextSeg / lenPrevSeg;
          }
        }

        ctx.bezierCurveTo(cpx0, cpy0, cpx1, cpy1, x, y);
        cpx0 = nextCpx0;
        cpy0 = nextCpy0;
      } else {
        ctx.lineTo(x, y);
      }
    }

    prevX = x;
    prevY = y;
    idx += dir;
  }

  return k;
}

var ECPolylineShape =
/** @class */
function () {
  function ECPolylineShape() {
    this.smooth = 0;
    this.smoothConstraint = true;
  }

  return ECPolylineShape;
}();

var ECPolyline =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ECPolyline, _super);

  function ECPolyline(opts) {
    var _this = _super.call(this, opts) || this;

    _this.type = 'ec-polyline';
    return _this;
  }

  ECPolyline.prototype.getDefaultStyle = function () {
    return {
      stroke: '#000',
      fill: null
    };
  };

  ECPolyline.prototype.getDefaultShape = function () {
    return new ECPolylineShape();
  };

  ECPolyline.prototype.buildPath = function (ctx, shape) {
    var points = shape.points;
    var i = 0;
    var len = points.length / 2; // const result = getBoundingBox(points, shape.smoothConstraint);

    if (shape.connectNulls) {
      // Must remove first and last null values avoid draw error in polygon
      for (; len > 0; len--) {
        if (!isPointNull(points[len * 2 - 2], points[len * 2 - 1])) {
          break;
        }
      }

      for (; i < len; i++) {
        if (!isPointNull(points[i * 2], points[i * 2 + 1])) {
          break;
        }
      }
    }

    while (i < len) {
      i += drawSegment(ctx, points, i, len, len, 1, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
    }
  };

  ECPolyline.prototype.getPointOn = function (xOrY, dim) {
    if (!this.path) {
      this.createPathProxy();
      this.buildPath(this.path, this.shape);
    }

    var path = this.path;
    var data = path.data;
    var CMD = __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_PathProxy_js__["a" /* default */].CMD;
    var x0;
    var y0;
    var isDimX = dim === 'x';
    var roots = [];

    for (var i = 0; i < data.length;) {
      var cmd = data[i++];
      var x = void 0;
      var y = void 0;
      var x2 = void 0;
      var y2 = void 0;
      var x3 = void 0;
      var y3 = void 0;
      var t = void 0;

      switch (cmd) {
        case CMD.M:
          x0 = data[i++];
          y0 = data[i++];
          break;

        case CMD.L:
          x = data[i++];
          y = data[i++];
          t = isDimX ? (xOrY - x0) / (x - x0) : (xOrY - y0) / (y - y0);

          if (t <= 1 && t >= 0) {
            var val = isDimX ? (y - y0) * t + y0 : (x - x0) * t + x0;
            return isDimX ? [xOrY, val] : [val, xOrY];
          }

          x0 = x;
          y0 = y;
          break;

        case CMD.C:
          x = data[i++];
          y = data[i++];
          x2 = data[i++];
          y2 = data[i++];
          x3 = data[i++];
          y3 = data[i++];
          var nRoot = isDimX ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_curve_js__["a" /* cubicRootAt */])(x0, x, x2, x3, xOrY, roots) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_curve_js__["a" /* cubicRootAt */])(y0, y, y2, y3, xOrY, roots);

          if (nRoot > 0) {
            for (var i_1 = 0; i_1 < nRoot; i_1++) {
              var t_1 = roots[i_1];

              if (t_1 <= 1 && t_1 >= 0) {
                var val = isDimX ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_curve_js__["b" /* cubicAt */])(y0, y, y2, y3, t_1) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_curve_js__["b" /* cubicAt */])(x0, x, x2, x3, t_1);
                return isDimX ? [xOrY, val] : [val, xOrY];
              }
            }
          }

          x0 = x3;
          y0 = y3;
          break;
      }
    }
  };

  return ECPolyline;
}(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_graphic_Path_js__["a" /* default */]);



var ECPolygonShape =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ECPolygonShape, _super);

  function ECPolygonShape() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return ECPolygonShape;
}(ECPolylineShape);

var ECPolygon =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ECPolygon, _super);

  function ECPolygon(opts) {
    var _this = _super.call(this, opts) || this;

    _this.type = 'ec-polygon';
    return _this;
  }

  ECPolygon.prototype.getDefaultShape = function () {
    return new ECPolygonShape();
  };

  ECPolygon.prototype.buildPath = function (ctx, shape) {
    var points = shape.points;
    var stackedOnPoints = shape.stackedOnPoints;
    var i = 0;
    var len = points.length / 2;
    var smoothMonotone = shape.smoothMonotone;

    if (shape.connectNulls) {
      // Must remove first and last null values avoid draw error in polygon
      for (; len > 0; len--) {
        if (!isPointNull(points[len * 2 - 2], points[len * 2 - 1])) {
          break;
        }
      }

      for (; i < len; i++) {
        if (!isPointNull(points[i * 2], points[i * 2 + 1])) {
          break;
        }
      }
    }

    while (i < len) {
      var k = drawSegment(ctx, points, i, len, len, 1, shape.smooth, smoothMonotone, shape.connectNulls);
      drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
      i += k + 1;
      ctx.closePath();
    }
  };

  return ECPolygon;
}(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_graphic_Path_js__["a" /* default */]);



/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_createRenderPlanner_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_log_js__ = __webpack_require__(14);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/* global Float32Array */


var linesLayout = {
  seriesType: 'lines',
  plan: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_createRenderPlanner_js__["a" /* default */])(),
  reset: function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;

    if (!coordSys) {
      if (true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_log_js__["c" /* error */])('The lines series must have a coordinate system.');
      }

      return;
    }

    var isPolyline = seriesModel.get('polyline');
    var isLarge = seriesModel.pipelineContext.large;
    return {
      progress: function (params, lineData) {
        var lineCoords = [];

        if (isLarge) {
          var points = void 0;
          var segCount = params.end - params.start;

          if (isPolyline) {
            var totalCoordsCount = 0;

            for (var i = params.start; i < params.end; i++) {
              totalCoordsCount += seriesModel.getLineCoordsCount(i);
            }

            points = new Float32Array(segCount + totalCoordsCount * 2);
          } else {
            points = new Float32Array(segCount * 4);
          }

          var offset = 0;
          var pt = [];

          for (var i = params.start; i < params.end; i++) {
            var len = seriesModel.getLineCoords(i, lineCoords);

            if (isPolyline) {
              points[offset++] = len;
            }

            for (var k = 0; k < len; k++) {
              pt = coordSys.dataToPoint(lineCoords[k], false, pt);
              points[offset++] = pt[0];
              points[offset++] = pt[1];
            }
          }

          lineData.setLayout('linesPoints', points);
        } else {
          for (var i = params.start; i < params.end; i++) {
            var itemModel = lineData.getItemModel(i);
            var len = seriesModel.getLineCoords(i, lineCoords);
            var pts = [];

            if (isPolyline) {
              for (var j = 0; j < len; j++) {
                pts.push(coordSys.dataToPoint(lineCoords[j]));
              }
            } else {
              pts[0] = coordSys.dataToPoint(lineCoords[0]);
              pts[1] = coordSys.dataToPoint(lineCoords[1]);
              var curveness = itemModel.get(['lineStyle', 'curveness']);

              if (+curveness) {
                pts[2] = [(pts[0][0] + pts[1][0]) / 2 - (pts[0][1] - pts[1][1]) * curveness, (pts[0][1] + pts[1][1]) / 2 - (pts[1][0] - pts[0][0]) * curveness];
              }
            }

            lineData.setItemLayout(i, pts);
          }
        }
      }
    };
  }
};
/* harmony default export */ __webpack_exports__["a"] = (linesLayout);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getBasicPieLayout;
/* harmony export (immutable) */ __webpack_exports__["a"] = pieLayout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var PI2 = Math.PI * 2;
var RADIAN = Math.PI / 180;

function getViewRect(seriesModel, api) {
  return __WEBPACK_IMPORTED_MODULE_1__util_layout_js__["f" /* getLayoutRect */](seriesModel.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  });
}

function getBasicPieLayout(seriesModel, api) {
  var viewRect = getViewRect(seriesModel, api);
  var center = seriesModel.get('center');
  var radius = seriesModel.get('radius');

  if (!__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isArray"](radius)) {
    radius = [0, radius];
  }

  if (!__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isArray"](center)) {
    center = [center, center];
  }

  var width = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["a" /* parsePercent */])(viewRect.width, api.getWidth());
  var height = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["a" /* parsePercent */])(viewRect.height, api.getHeight());
  var size = Math.min(width, height);
  var cx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["a" /* parsePercent */])(center[0], width) + viewRect.x;
  var cy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["a" /* parsePercent */])(center[1], height) + viewRect.y;
  var r0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["a" /* parsePercent */])(radius[0], size / 2);
  var r = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["a" /* parsePercent */])(radius[1], size / 2);
  return {
    cx: cx,
    cy: cy,
    r0: r0,
    r: r
  };
}
function pieLayout(seriesType, ecModel, api) {
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    var data = seriesModel.getData();
    var valueDim = data.mapDimension('value');
    var viewRect = getViewRect(seriesModel, api);

    var _a = getBasicPieLayout(seriesModel, api),
        cx = _a.cx,
        cy = _a.cy,
        r = _a.r,
        r0 = _a.r0;

    var startAngle = -seriesModel.get('startAngle') * RADIAN;
    var minAngle = seriesModel.get('minAngle') * RADIAN;
    var validDataCount = 0;
    data.each(valueDim, function (value) {
      !isNaN(value) && validDataCount++;
    });
    var sum = data.getSum(valueDim); // Sum may be 0

    var unitRadian = Math.PI / (sum || validDataCount) * 2;
    var clockwise = seriesModel.get('clockwise');
    var roseType = seriesModel.get('roseType');
    var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // [0...max]

    var extent = data.getDataExtent(valueDim);
    extent[0] = 0; // In the case some sector angle is smaller than minAngle

    var restAngle = PI2;
    var valueSumLargerThanMinAngle = 0;
    var currentAngle = startAngle;
    var dir = clockwise ? 1 : -1;
    data.setLayout({
      viewRect: viewRect,
      r: r
    });
    data.each(valueDim, function (value, idx) {
      var angle;

      if (isNaN(value)) {
        data.setItemLayout(idx, {
          angle: NaN,
          startAngle: NaN,
          endAngle: NaN,
          clockwise: clockwise,
          cx: cx,
          cy: cy,
          r0: r0,
          r: roseType ? NaN : r
        });
        return;
      } // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？


      if (roseType !== 'area') {
        angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
      } else {
        angle = PI2 / validDataCount;
      }

      if (angle < minAngle) {
        angle = minAngle;
        restAngle -= minAngle;
      } else {
        valueSumLargerThanMinAngle += value;
      }

      var endAngle = currentAngle + dir * angle;
      data.setItemLayout(idx, {
        angle: angle,
        startAngle: currentAngle,
        endAngle: endAngle,
        clockwise: clockwise,
        cx: cx,
        cy: cy,
        r0: r0,
        r: roseType ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["h" /* linearMap */])(value, extent, [r0, r]) : r
      });
      currentAngle = endAngle;
    }); // Some sector is constrained by minAngle
    // Rest sectors needs recalculate angle

    if (restAngle < PI2 && validDataCount) {
      // Average the angle if rest angle is not enough after all angles is
      // Constrained by minAngle
      if (restAngle <= 1e-3) {
        var angle_1 = PI2 / validDataCount;
        data.each(valueDim, function (value, idx) {
          if (!isNaN(value)) {
            var layout_1 = data.getItemLayout(idx);
            layout_1.angle = angle_1;
            layout_1.startAngle = startAngle + dir * idx * angle_1;
            layout_1.endAngle = startAngle + dir * (idx + 1) * angle_1;
          }
        });
      } else {
        unitRadian = restAngle / valueSumLargerThanMinAngle;
        currentAngle = startAngle;
        data.each(valueDim, function (value, idx) {
          if (!isNaN(value)) {
            var layout_2 = data.getItemLayout(idx);
            var angle = layout_2.angle === minAngle ? minAngle : value * unitRadian;
            layout_2.startAngle = currentAngle;
            layout_2.endAngle = currentAngle + dir * angle;
            currentAngle += dir * angle;
          }
        });
      }
    }
  });
}

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ROOT_TO_NODE_ACTION; });
/* harmony export (immutable) */ __webpack_exports__["a"] = installSunburstAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_log_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_treeHelper_js__ = __webpack_require__(110);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var ROOT_TO_NODE_ACTION = 'sunburstRootToNode';
var HIGHLIGHT_ACTION = 'sunburstHighlight';
var UNHIGHLIGHT_ACTION = 'sunburstUnhighlight';
function installSunburstAction(registers) {
  registers.registerAction({
    type: ROOT_TO_NODE_ACTION,
    update: 'updateView'
  }, function (payload, ecModel) {
    ecModel.eachComponent({
      mainType: 'series',
      subType: 'sunburst',
      query: payload
    }, handleRootToNode);

    function handleRootToNode(model, index) {
      var targetInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_treeHelper_js__["a" /* retrieveTargetInfo */])(payload, [ROOT_TO_NODE_ACTION], model);

      if (targetInfo) {
        var originViewRoot = model.getViewRoot();

        if (originViewRoot) {
          payload.direction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_treeHelper_js__["b" /* aboveViewRoot */])(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
        }

        model.resetViewRoot(targetInfo.node);
      }
    }
  });
  registers.registerAction({
    type: HIGHLIGHT_ACTION,
    update: 'none'
  }, function (payload, ecModel, api) {
    // Clone
    payload = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"])({}, payload);
    ecModel.eachComponent({
      mainType: 'series',
      subType: 'sunburst',
      query: payload
    }, handleHighlight);

    function handleHighlight(model) {
      var targetInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_treeHelper_js__["a" /* retrieveTargetInfo */])(payload, [HIGHLIGHT_ACTION], model);

      if (targetInfo) {
        payload.dataIndex = targetInfo.node.dataIndex;
      }
    }

    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_log_js__["a" /* deprecateReplaceLog */])('highlight', 'sunburstHighlight');
    } // Fast forward action


    api.dispatchAction(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"])(payload, {
      type: 'highlight'
    }));
  });
  registers.registerAction({
    type: UNHIGHLIGHT_ACTION,
    update: 'updateView'
  }, function (payload, ecModel, api) {
    payload = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"])({}, payload);

    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_log_js__["a" /* deprecateReplaceLog */])('downplay', 'sunburstUnhighlight');
    }

    api.dispatchAction(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"])(payload, {
      type: 'downplay'
    }));
  });
}

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = init;
/* harmony export (immutable) */ __webpack_exports__["d"] = firstWalk;
/* harmony export (immutable) */ __webpack_exports__["e"] = secondWalk;
/* harmony export (immutable) */ __webpack_exports__["b"] = separation;
/* harmony export (immutable) */ __webpack_exports__["f"] = radialCoordinate;
/* harmony export (immutable) */ __webpack_exports__["a"] = getViewRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_layout_js__ = __webpack_require__(19);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* A third-party license is embeded for some of the code in this file:
* The tree layoutHelper implementation was originally copied from
* "d3.js"(https://github.com/d3/d3-hierarchy) with
* some modifications made for this project.
* (see more details in the comment of the specific method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the licence of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/

/**
 * @file The layout algorithm of node-link tree diagrams. Here we using Reingold-Tilford algorithm to drawing
 *       the tree.
 */

/**
 * Initialize all computational message for following algorithm.
 */

function init(inRoot) {
  var root = inRoot;
  root.hierNode = {
    defaultAncestor: null,
    ancestor: root,
    prelim: 0,
    modifier: 0,
    change: 0,
    shift: 0,
    i: 0,
    thread: null
  };
  var nodes = [root];
  var node;
  var children;

  while (node = nodes.pop()) {
    // jshint ignore:line
    children = node.children;

    if (node.isExpand && children.length) {
      var n = children.length;

      for (var i = n - 1; i >= 0; i--) {
        var child = children[i];
        child.hierNode = {
          defaultAncestor: null,
          ancestor: child,
          prelim: 0,
          modifier: 0,
          change: 0,
          shift: 0,
          i: i,
          thread: null
        };
        nodes.push(child);
      }
    }
  }
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * Computes a preliminary x coordinate for node. Before that, this function is
 * applied recursively to the children of node, as well as the function
 * apportion(). After spacing out the children by calling executeShifts(), the
 * node is placed to the midpoint of its outermost children.
 */

function firstWalk(node, separation) {
  var children = node.isExpand ? node.children : [];
  var siblings = node.parentNode.children;
  var subtreeW = node.hierNode.i ? siblings[node.hierNode.i - 1] : null;

  if (children.length) {
    executeShifts(node);
    var midPoint = (children[0].hierNode.prelim + children[children.length - 1].hierNode.prelim) / 2;

    if (subtreeW) {
      node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
      node.hierNode.modifier = node.hierNode.prelim - midPoint;
    } else {
      node.hierNode.prelim = midPoint;
    }
  } else if (subtreeW) {
    node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
  }

  node.parentNode.hierNode.defaultAncestor = apportion(node, subtreeW, node.parentNode.hierNode.defaultAncestor || siblings[0], separation);
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * Computes all real x-coordinates by summing up the modifiers recursively.
 */

function secondWalk(node) {
  var nodeX = node.hierNode.prelim + node.parentNode.hierNode.modifier;
  node.setLayout({
    x: nodeX
  }, true);
  node.hierNode.modifier += node.parentNode.hierNode.modifier;
}
function separation(cb) {
  return arguments.length ? cb : defaultSeparation;
}
/**
 * Transform the common coordinate to radial coordinate.
 */

function radialCoordinate(rad, r) {
  rad -= Math.PI / 2;
  return {
    x: r * Math.cos(rad),
    y: r * Math.sin(rad)
  };
}
/**
 * Get the layout position of the whole view.
 */

function getViewRect(seriesModel, api) {
  return __WEBPACK_IMPORTED_MODULE_0__util_layout_js__["f" /* getLayoutRect */](seriesModel.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  });
}
/**
 * All other shifts, applied to the smaller subtrees between w- and w+, are
 * performed by this function.
 *
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */

function executeShifts(node) {
  var children = node.children;
  var n = children.length;
  var shift = 0;
  var change = 0;

  while (--n >= 0) {
    var child = children[n];
    child.hierNode.prelim += shift;
    child.hierNode.modifier += shift;
    change += child.hierNode.change;
    shift += child.hierNode.shift + change;
  }
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * The core of the algorithm. Here, a new subtree is combined with the
 * previous subtrees. Threads are used to traverse the inside and outside
 * contours of the left and right subtree up to the highest common level.
 * Whenever two nodes of the inside contours conflict, we compute the left
 * one of the greatest uncommon ancestors using the function nextAncestor()
 * and call moveSubtree() to shift the subtree and prepare the shifts of
 * smaller subtrees. Finally, we add a new thread (if necessary).
 */


function apportion(subtreeV, subtreeW, ancestor, separation) {
  if (subtreeW) {
    var nodeOutRight = subtreeV;
    var nodeInRight = subtreeV;
    var nodeOutLeft = nodeInRight.parentNode.children[0];
    var nodeInLeft = subtreeW;
    var sumOutRight = nodeOutRight.hierNode.modifier;
    var sumInRight = nodeInRight.hierNode.modifier;
    var sumOutLeft = nodeOutLeft.hierNode.modifier;
    var sumInLeft = nodeInLeft.hierNode.modifier;

    while (nodeInLeft = nextRight(nodeInLeft), nodeInRight = nextLeft(nodeInRight), nodeInLeft && nodeInRight) {
      nodeOutRight = nextRight(nodeOutRight);
      nodeOutLeft = nextLeft(nodeOutLeft);
      nodeOutRight.hierNode.ancestor = subtreeV;
      var shift = nodeInLeft.hierNode.prelim + sumInLeft - nodeInRight.hierNode.prelim - sumInRight + separation(nodeInLeft, nodeInRight);

      if (shift > 0) {
        moveSubtree(nextAncestor(nodeInLeft, subtreeV, ancestor), subtreeV, shift);
        sumInRight += shift;
        sumOutRight += shift;
      }

      sumInLeft += nodeInLeft.hierNode.modifier;
      sumInRight += nodeInRight.hierNode.modifier;
      sumOutRight += nodeOutRight.hierNode.modifier;
      sumOutLeft += nodeOutLeft.hierNode.modifier;
    }

    if (nodeInLeft && !nextRight(nodeOutRight)) {
      nodeOutRight.hierNode.thread = nodeInLeft;
      nodeOutRight.hierNode.modifier += sumInLeft - sumOutRight;
    }

    if (nodeInRight && !nextLeft(nodeOutLeft)) {
      nodeOutLeft.hierNode.thread = nodeInRight;
      nodeOutLeft.hierNode.modifier += sumInRight - sumOutLeft;
      ancestor = subtreeV;
    }
  }

  return ancestor;
}
/**
 * This function is used to traverse the right contour of a subtree.
 * It returns the rightmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 */


function nextRight(node) {
  var children = node.children;
  return children.length && node.isExpand ? children[children.length - 1] : node.hierNode.thread;
}
/**
 * This function is used to traverse the left contour of a subtree (or a subforest).
 * It returns the leftmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 */


function nextLeft(node) {
  var children = node.children;
  return children.length && node.isExpand ? children[0] : node.hierNode.thread;
}
/**
 * If nodeInLeft’s ancestor is a sibling of node, returns nodeInLeft’s ancestor.
 * Otherwise, returns the specified ancestor.
 */


function nextAncestor(nodeInLeft, node, ancestor) {
  return nodeInLeft.hierNode.ancestor.parentNode === node.parentNode ? nodeInLeft.hierNode.ancestor : ancestor;
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * Shifts the current subtree rooted at wr.
 * This is done by increasing prelim(w+) and modifier(w+) by shift.
 */


function moveSubtree(wl, wr, shift) {
  var change = shift / (wr.hierNode.i - wl.hierNode.i);
  wr.hierNode.change -= change;
  wr.hierNode.shift += shift;
  wr.hierNode.modifier += shift;
  wr.hierNode.prelim += shift;
  wl.hierNode.change += change;
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */


function defaultSeparation(node1, node2) {
  return node1.parentNode === node2.parentNode ? 1 : 2;
}

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = rectCoordAxisBuildSplitArea;
/* harmony export (immutable) */ __webpack_exports__["a"] = rectCoordAxisHandleRemove;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var inner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_model_js__["a" /* makeInner */])();
function rectCoordAxisBuildSplitArea(axisView, axisGroup, axisModel, gridModel) {
  var axis = axisModel.axis;

  if (axis.scale.isBlank()) {
    return;
  } // TODO: TYPE


  var splitAreaModel = axisModel.getModel('splitArea');
  var areaStyleModel = splitAreaModel.getModel('areaStyle');
  var areaColors = areaStyleModel.get('color');
  var gridRect = gridModel.coordinateSystem.getRect();
  var ticksCoords = axis.getTicksCoords({
    tickModel: splitAreaModel,
    clamp: true
  });

  if (!ticksCoords.length) {
    return;
  } // For Making appropriate splitArea animation, the color and anid
  // should be corresponding to previous one if possible.


  var areaColorsLen = areaColors.length;
  var lastSplitAreaColors = inner(axisView).splitAreaColors;
  var newSplitAreaColors = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"]();
  var colorIndex = 0;

  if (lastSplitAreaColors) {
    for (var i = 0; i < ticksCoords.length; i++) {
      var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);

      if (cIndex != null) {
        colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
        break;
      }
    }
  }

  var prev = axis.toGlobalCoord(ticksCoords[0].coord);
  var areaStyle = areaStyleModel.getAreaStyle();
  areaColors = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](areaColors) ? areaColors : [areaColors];

  for (var i = 1; i < ticksCoords.length; i++) {
    var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
    var x = void 0;
    var y = void 0;
    var width = void 0;
    var height = void 0;

    if (axis.isHorizontal()) {
      x = prev;
      y = gridRect.y;
      width = tickCoord - x;
      height = gridRect.height;
      prev = x + width;
    } else {
      x = gridRect.x;
      y = prev;
      width = gridRect.width;
      height = tickCoord - y;
      prev = y + height;
    }

    var tickValue = ticksCoords[i - 1].tickValue;
    tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
    axisGroup.add(new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Rect"]({
      anid: tickValue != null ? 'area_' + tickValue : null,
      shape: {
        x: x,
        y: y,
        width: width,
        height: height
      },
      style: __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["defaults"]({
        fill: areaColors[colorIndex]
      }, areaStyle),
      autoBatch: true,
      silent: true
    }));
    colorIndex = (colorIndex + 1) % areaColorsLen;
  }

  inner(axisView).splitAreaColors = newSplitAreaColors;
}
function rectCoordAxisHandleRemove(axisView) {
  inner(axisView).splitAreaColors = null;
}

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findPointFromSeries;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * @param finder contains {seriesIndex, dataIndex, dataIndexInside}
 * @param ecModel
 * @return  {point: [x, y], el: ...} point Will not be null.
 */

function findPointFromSeries(finder, ecModel) {
  var point = [];
  var seriesIndex = finder.seriesIndex;
  var seriesModel;

  if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) {
    return {
      point: []
    };
  }

  var data = seriesModel.getData();
  var dataIndex = __WEBPACK_IMPORTED_MODULE_1__util_model_js__["c" /* queryDataIndex */](data, finder);

  if (dataIndex == null || dataIndex < 0 || __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](dataIndex)) {
    return {
      point: []
    };
  }

  var el = data.getItemGraphicEl(dataIndex);
  var coordSys = seriesModel.coordinateSystem;

  if (seriesModel.getTooltipPosition) {
    point = seriesModel.getTooltipPosition(dataIndex) || [];
  } else if (coordSys && coordSys.dataToPoint) {
    if (finder.isStacked) {
      var baseAxis = coordSys.getBaseAxis();
      var valueAxis = coordSys.getOtherAxis(baseAxis);
      var valueAxisDim = valueAxis.dim;
      var baseAxisDim = baseAxis.dim;
      var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
      var baseDim = data.mapDimension(baseAxisDim);
      var stackedData = [];
      stackedData[baseDataOffset] = data.get(baseDim, dataIndex);
      stackedData[1 - baseDataOffset] = data.get(data.getCalculationInfo('stackResultDimension'), dataIndex);
      point = coordSys.dataToPoint(stackedData) || [];
    } else {
      point = coordSys.dataToPoint(data.getValues(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"](coordSys.dimensions, function (dim) {
        return data.mapDimension(dim);
      }), dataIndex)) || [];
    }
  } else if (el) {
    // Use graphic bounding rect
    var rect = el.getBoundingRect().clone();
    rect.applyTransform(el.transform);
    point = [rect.x + rect.width / 2, rect.y + rect.height / 2];
  }

  return {
    point: point,
    el: el
  };
}

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony export (immutable) */ __webpack_exports__["b"] = unregister;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_env_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var inner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_model_js__["a" /* makeInner */])();
var each = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"];
/**
 * @param {string} key
 * @param {module:echarts/ExtensionAPI} api
 * @param {Function} handler
 *      param: {string} currTrigger
 *      param: {Array.<number>} point
 */

function register(key, api, handler) {
  if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_env_js__["a" /* default */].node) {
    return;
  }

  var zr = api.getZr();
  inner(zr).records || (inner(zr).records = {});
  initGlobalListeners(zr, api);
  var record = inner(zr).records[key] || (inner(zr).records[key] = {});
  record.handler = handler;
}

function initGlobalListeners(zr, api) {
  if (inner(zr).initialized) {
    return;
  }

  inner(zr).initialized = true;
  useHandler('click', __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["curry"](doEnter, 'click'));
  useHandler('mousemove', __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["curry"](doEnter, 'mousemove')); // useHandler('mouseout', onLeave);

  useHandler('globalout', onLeave);

  function useHandler(eventType, cb) {
    zr.on(eventType, function (e) {
      var dis = makeDispatchAction(api);
      each(inner(zr).records, function (record) {
        record && cb(record, e, dis.dispatchAction);
      });
      dispatchTooltipFinally(dis.pendings, api);
    });
  }
}

function dispatchTooltipFinally(pendings, api) {
  var showLen = pendings.showTip.length;
  var hideLen = pendings.hideTip.length;
  var actuallyPayload;

  if (showLen) {
    actuallyPayload = pendings.showTip[showLen - 1];
  } else if (hideLen) {
    actuallyPayload = pendings.hideTip[hideLen - 1];
  }

  if (actuallyPayload) {
    actuallyPayload.dispatchAction = null;
    api.dispatchAction(actuallyPayload);
  }
}

function onLeave(record, e, dispatchAction) {
  record.handler('leave', null, dispatchAction);
}

function doEnter(currTrigger, record, e, dispatchAction) {
  record.handler(currTrigger, e, dispatchAction);
}

function makeDispatchAction(api) {
  var pendings = {
    showTip: [],
    hideTip: []
  }; // FIXME
  // better approach?
  // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
  // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
  // So we have to add "final stage" to merge those dispatched actions.

  var dispatchAction = function (payload) {
    var pendingList = pendings[payload.type];

    if (pendingList) {
      pendingList.push(payload);
    } else {
      payload.dispatchAction = dispatchAction;
      api.dispatchAction(payload);
    }
  };

  return {
    dispatchAction: dispatchAction,
    pendings: pendings
  };
}

function unregister(key, api) {
  if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_env_js__["a" /* default */].node) {
    return;
  }

  var zr = api.getZr();
  var record = (inner(zr).records || {})[key];

  if (record) {
    inner(zr).records[key] = null;
  }
}

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = layoutCovers;
/* harmony export (immutable) */ __webpack_exports__["a"] = brushVisual;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__visual_visualSolution_js__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selector_js__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_throttle_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_BrushTargetManager_js__ = __webpack_require__(466);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






var STATE_LIST = ['inBrush', 'outOfBrush'];
var DISPATCH_METHOD = '__ecBrushSelect';
var DISPATCH_FLAG = '__ecInBrushSelectEvent';
;
function layoutCovers(ecModel) {
  ecModel.eachComponent({
    mainType: 'brush'
  }, function (brushModel) {
    var brushTargetManager = brushModel.brushTargetManager = new __WEBPACK_IMPORTED_MODULE_5__helper_BrushTargetManager_js__["a" /* default */](brushModel.option, ecModel);
    brushTargetManager.setInputRanges(brushModel.areas, ecModel);
  });
}
/**
 * Register the visual encoding if this modules required.
 */

function brushVisual(ecModel, api, payload) {
  var brushSelected = [];
  var throttleType;
  var throttleDelay;
  ecModel.eachComponent({
    mainType: 'brush'
  }, function (brushModel) {
    payload && payload.type === 'takeGlobalCursor' && brushModel.setBrushOption(payload.key === 'brush' ? payload.brushOption : {
      brushType: false
    });
  });
  layoutCovers(ecModel);
  ecModel.eachComponent({
    mainType: 'brush'
  }, function (brushModel, brushIndex) {
    var thisBrushSelected = {
      brushId: brushModel.id,
      brushIndex: brushIndex,
      brushName: brushModel.name,
      areas: __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["clone"](brushModel.areas),
      selected: []
    }; // Every brush component exists in event params, convenient
    // for user to find by index.

    brushSelected.push(thisBrushSelected);
    var brushOption = brushModel.option;
    var brushLink = brushOption.brushLink;
    var linkedSeriesMap = [];
    var selectedDataIndexForLink = [];
    var rangeInfoBySeries = [];
    var hasBrushExists = false;

    if (!brushIndex) {
      // Only the first throttle setting works.
      throttleType = brushOption.throttleType;
      throttleDelay = brushOption.throttleDelay;
    } // Add boundingRect and selectors to range.


    var areas = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"](brushModel.areas, function (area) {
      var builder = boundingRectBuilders[area.brushType];
      var selectableArea = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["defaults"]({
        boundingRect: builder ? builder(area) : void 0
      }, area);
      selectableArea.selectors = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__selector_js__["a" /* makeBrushCommonSelectorForSeries */])(selectableArea);
      return selectableArea;
    });
    var visualMappings = __WEBPACK_IMPORTED_MODULE_2__visual_visualSolution_js__["c" /* createVisualMappings */](brushModel.option, STATE_LIST, function (mappingOption) {
      mappingOption.mappingMethod = 'fixed';
    });
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](brushLink) && __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](brushLink, function (seriesIndex) {
      linkedSeriesMap[seriesIndex] = 1;
    });

    function linkOthers(seriesIndex) {
      return brushLink === 'all' || !!linkedSeriesMap[seriesIndex];
    } // If no supported brush or no brush on the series,
    // all visuals should be in original state.


    function brushed(rangeInfoList) {
      return !!rangeInfoList.length;
    }
    /**
     * Logic for each series: (If the logic has to be modified one day, do it carefully!)
     *
     * ( brushed ┬ && ┬hasBrushExist ┬ && linkOthers  ) => StepA: ┬record, ┬ StepB: ┬visualByRecord.
     *   !brushed┘    ├hasBrushExist ┤                            └nothing,┘        ├visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( !brushed  && ┬hasBrushExist ┬ && linkOthers  ) => StepA:  nothing,  StepB: ┬visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( brushed ┬ &&                     !linkOthers ) => StepA:  nothing,  StepB: ┬visualByCheck.
     *   !brushed┘                                                                  └nothing.
     * ( !brushed  &&                     !linkOthers ) => StepA:  nothing,  StepB:  nothing.
     */
    // Step A


    ecModel.eachSeries(function (seriesModel, seriesIndex) {
      var rangeInfoList = rangeInfoBySeries[seriesIndex] = [];
      seriesModel.subType === 'parallel' ? stepAParallel(seriesModel, seriesIndex) : stepAOthers(seriesModel, seriesIndex, rangeInfoList);
    });

    function stepAParallel(seriesModel, seriesIndex) {
      var coordSys = seriesModel.coordinateSystem;
      hasBrushExists = hasBrushExists || coordSys.hasAxisBrushed();
      linkOthers(seriesIndex) && coordSys.eachActiveState(seriesModel.getData(), function (activeState, dataIndex) {
        activeState === 'active' && (selectedDataIndexForLink[dataIndex] = 1);
      });
    }

    function stepAOthers(seriesModel, seriesIndex, rangeInfoList) {
      if (!seriesModel.brushSelector || brushModelNotControll(brushModel, seriesIndex)) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](areas, function (area) {
        if (brushModel.brushTargetManager.controlSeries(area, seriesModel, ecModel)) {
          rangeInfoList.push(area);
        }

        hasBrushExists = hasBrushExists || brushed(rangeInfoList);
      });

      if (linkOthers(seriesIndex) && brushed(rangeInfoList)) {
        var data_1 = seriesModel.getData();
        data_1.each(function (dataIndex) {
          if (checkInRange(seriesModel, rangeInfoList, data_1, dataIndex)) {
            selectedDataIndexForLink[dataIndex] = 1;
          }
        });
      }
    } // Step B


    ecModel.eachSeries(function (seriesModel, seriesIndex) {
      var seriesBrushSelected = {
        seriesId: seriesModel.id,
        seriesIndex: seriesIndex,
        seriesName: seriesModel.name,
        dataIndex: []
      }; // Every series exists in event params, convenient
      // for user to find series by seriesIndex.

      thisBrushSelected.selected.push(seriesBrushSelected);
      var rangeInfoList = rangeInfoBySeries[seriesIndex];
      var data = seriesModel.getData();
      var getValueState = linkOthers(seriesIndex) ? function (dataIndex) {
        return selectedDataIndexForLink[dataIndex] ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
      } : function (dataIndex) {
        return checkInRange(seriesModel, rangeInfoList, data, dataIndex) ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
      }; // If no supported brush or no brush, all visuals are in original state.

      (linkOthers(seriesIndex) ? hasBrushExists : brushed(rangeInfoList)) && __WEBPACK_IMPORTED_MODULE_2__visual_visualSolution_js__["d" /* applyVisual */](STATE_LIST, visualMappings, data, getValueState);
    });
  });
  dispatchAction(api, throttleType, throttleDelay, brushSelected, payload);
}
;

function dispatchAction(api, throttleType, throttleDelay, brushSelected, payload) {
  // This event will not be triggered when `setOpion`, otherwise dead lock may
  // triggered when do `setOption` in event listener, which we do not find
  // satisfactory way to solve yet. Some considered resolutions:
  // (a) Diff with prevoius selected data ant only trigger event when changed.
  // But store previous data and diff precisely (i.e., not only by dataIndex, but
  // also detect value changes in selected data) might bring complexity or fragility.
  // (b) Use spectial param like `silent` to suppress event triggering.
  // But such kind of volatile param may be weird in `setOption`.
  if (!payload) {
    return;
  }

  var zr = api.getZr();

  if (zr[DISPATCH_FLAG]) {
    return;
  }

  if (!zr[DISPATCH_METHOD]) {
    zr[DISPATCH_METHOD] = doDispatch;
  }

  var fn = __WEBPACK_IMPORTED_MODULE_4__util_throttle_js__["a" /* createOrUpdate */](zr, DISPATCH_METHOD, throttleDelay, throttleType);
  fn(api, brushSelected);
}

function doDispatch(api, brushSelected) {
  if (!api.isDisposed()) {
    var zr = api.getZr();
    zr[DISPATCH_FLAG] = true;
    api.dispatchAction({
      type: 'brushSelect',
      batch: brushSelected
    });
    zr[DISPATCH_FLAG] = false;
  }
}

function checkInRange(seriesModel, rangeInfoList, data, dataIndex) {
  for (var i = 0, len = rangeInfoList.length; i < len; i++) {
    var area = rangeInfoList[i];

    if (seriesModel.brushSelector(dataIndex, data, area.selectors, area)) {
      return true;
    }
  }
}

function brushModelNotControll(brushModel, seriesIndex) {
  var seriesIndices = brushModel.option.seriesIndex;
  return seriesIndices != null && seriesIndices !== 'all' && (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](seriesIndices) ? __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"](seriesIndices, seriesIndex) < 0 : seriesIndex !== seriesIndices);
}

var boundingRectBuilders = {
  rect: function (area) {
    return getBoundingRectFromMinMax(area.range);
  },
  polygon: function (area) {
    var minMax;
    var range = area.range;

    for (var i = 0, len = range.length; i < len; i++) {
      minMax = minMax || [[Infinity, -Infinity], [Infinity, -Infinity]];
      var rg = range[i];
      rg[0] < minMax[0][0] && (minMax[0][0] = rg[0]);
      rg[0] > minMax[0][1] && (minMax[0][1] = rg[0]);
      rg[1] < minMax[1][0] && (minMax[1][0] = rg[1]);
      rg[1] > minMax[1][1] && (minMax[1][1] = rg[1]);
    }

    return minMax && getBoundingRectFromMinMax(minMax);
  }
};

function getBoundingRectFromMinMax(minMax) {
  return new __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_BoundingRect_js__["a" /* default */](minMax[0][0], minMax[1][0], minMax[0][1] - minMax[0][0], minMax[1][1] - minMax[1][0]);
}

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = push;
/* harmony export (immutable) */ __webpack_exports__["c"] = pop;
/* harmony export (immutable) */ __webpack_exports__["a"] = clear;
/* harmony export (immutable) */ __webpack_exports__["d"] = count;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


var each = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"];
var inner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_model_js__["a" /* makeInner */])();
/**
 * @param ecModel
 * @param newSnapshot key is dataZoomId
 */

function push(ecModel, newSnapshot) {
  var storedSnapshots = getStoreSnapshots(ecModel); // If previous dataZoom can not be found,
  // complete an range with current range.

  each(newSnapshot, function (batchItem, dataZoomId) {
    var i = storedSnapshots.length - 1;

    for (; i >= 0; i--) {
      var snapshot = storedSnapshots[i];

      if (snapshot[dataZoomId]) {
        break;
      }
    }

    if (i < 0) {
      // No origin range set, create one by current range.
      var dataZoomModel = ecModel.queryComponents({
        mainType: 'dataZoom',
        subType: 'select',
        id: dataZoomId
      })[0];

      if (dataZoomModel) {
        var percentRange = dataZoomModel.getPercentRange();
        storedSnapshots[0][dataZoomId] = {
          dataZoomId: dataZoomId,
          start: percentRange[0],
          end: percentRange[1]
        };
      }
    }
  });
  storedSnapshots.push(newSnapshot);
}
function pop(ecModel) {
  var storedSnapshots = getStoreSnapshots(ecModel);
  var head = storedSnapshots[storedSnapshots.length - 1];
  storedSnapshots.length > 1 && storedSnapshots.pop(); // Find top for all dataZoom.

  var snapshot = {};
  each(head, function (batchItem, dataZoomId) {
    for (var i = storedSnapshots.length - 1; i >= 0; i--) {
      batchItem = storedSnapshots[i][dataZoomId];

      if (batchItem) {
        snapshot[dataZoomId] = batchItem;
        break;
      }
    }
  });
  return snapshot;
}
function clear(ecModel) {
  inner(ecModel).snapshots = null;
}
function count(ecModel) {
  return getStoreSnapshots(ecModel).length;
}
/**
 * History length of each dataZoom may be different.
 * this._history[0] is used to store origin range.
 */

function getStoreSnapshots(ecModel) {
  var store = inner(ecModel);

  if (!store.snapshots) {
    store.snapshots = [{}];
  }

  return store.snapshots;
}

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InsideZoomModel_js__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InsideZoomView_js__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__roams_js__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__installCommon_js__ = __webpack_require__(319);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




function install(registers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__installCommon_js__["a" /* default */])(registers);
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_0__InsideZoomModel_js__["a" /* default */]);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_1__InsideZoomView_js__["a" /* default */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__roams_js__["a" /* installDataZoomRoamProcessor */])(registers);
}

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SliderZoomModel_js__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SliderZoomView_js__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__installCommon_js__ = __webpack_require__(319);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



function install(registers) {
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_0__SliderZoomModel_js__["a" /* default */]);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_1__SliderZoomView_js__["a" /* default */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__installCommon_js__["a" /* default */])(registers);
}

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = setViewInfoToCoordSysRecord;
/* harmony export (immutable) */ __webpack_exports__["c"] = disposeCoordSysRecordIfNeeded;
/* harmony export (immutable) */ __webpack_exports__["a"] = installDataZoomRoamProcessor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_helper_RoamController_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_throttle_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_js__ = __webpack_require__(153);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Only create one roam controller for each coordinate system.
// one roam controller might be refered by two inside data zoom
// components (for example, one for x and one for y). When user
// pan or zoom, only dispatch one action for those data zoom
// components.





var inner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_model_js__["a" /* makeInner */])();
function setViewInfoToCoordSysRecord(api, dataZoomModel, getRange) {
  inner(api).coordSysRecordMap.each(function (coordSysRecord) {
    var dzInfo = coordSysRecord.dataZoomInfoMap.get(dataZoomModel.uid);

    if (dzInfo) {
      dzInfo.getRange = getRange;
    }
  });
}
function disposeCoordSysRecordIfNeeded(api, dataZoomModel) {
  var coordSysRecordMap = inner(api).coordSysRecordMap;
  var coordSysKeyArr = coordSysRecordMap.keys();

  for (var i = 0; i < coordSysKeyArr.length; i++) {
    var coordSysKey = coordSysKeyArr[i];
    var coordSysRecord = coordSysRecordMap.get(coordSysKey);
    var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap;

    if (dataZoomInfoMap) {
      var dzUid = dataZoomModel.uid;
      var dzInfo = dataZoomInfoMap.get(dzUid);

      if (dzInfo) {
        dataZoomInfoMap.removeKey(dzUid);

        if (!dataZoomInfoMap.keys().length) {
          disposeCoordSysRecord(coordSysRecordMap, coordSysRecord);
        }
      }
    }
  }
}

function disposeCoordSysRecord(coordSysRecordMap, coordSysRecord) {
  if (coordSysRecord) {
    coordSysRecordMap.removeKey(coordSysRecord.model.uid);
    var controller = coordSysRecord.controller;
    controller && controller.dispose();
  }
}

function createCoordSysRecord(api, coordSysModel) {
  // These init props will never change after record created.
  var coordSysRecord = {
    model: coordSysModel,
    containsPoint: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["curry"])(containsPoint, coordSysModel),
    dispatchAction: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["curry"])(dispatchAction, api),
    dataZoomInfoMap: null,
    controller: null
  }; // Must not do anything depends on coordSysRecord outside the event handler here,
  // because coordSysRecord not completed yet.

  var controller = coordSysRecord.controller = new __WEBPACK_IMPORTED_MODULE_0__component_helper_RoamController_js__["a" /* default */](api.getZr());
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(['pan', 'zoom', 'scrollMove'], function (eventName) {
    controller.on(eventName, function (event) {
      var batch = [];
      coordSysRecord.dataZoomInfoMap.each(function (dzInfo) {
        // Check whether the behaviors (zoomOnMouseWheel, moveOnMouseMove,
        // moveOnMouseWheel, ...) enabled.
        if (!event.isAvailableBehavior(dzInfo.model.option)) {
          return;
        }

        var method = (dzInfo.getRange || {})[eventName];
        var range = method && method(dzInfo.dzReferCoordSysInfo, coordSysRecord.model.mainType, coordSysRecord.controller, event);
        !dzInfo.model.get('disabled', true) && range && batch.push({
          dataZoomId: dzInfo.model.id,
          start: range[0],
          end: range[1]
        });
      });
      batch.length && coordSysRecord.dispatchAction(batch);
    });
  });
  return coordSysRecord;
}
/**
 * This action will be throttled.
 */


function dispatchAction(api, batch) {
  if (!api.isDisposed()) {
    api.dispatchAction({
      type: 'dataZoom',
      animation: {
        easing: 'cubicOut',
        duration: 100
      },
      batch: batch
    });
  }
}

function containsPoint(coordSysModel, e, x, y) {
  return coordSysModel.coordinateSystem.containPoint([x, y]);
}
/**
 * Merge roamController settings when multiple dataZooms share one roamController.
 */


function mergeControllerParams(dataZoomInfoMap) {
  var controlType; // DO NOT use reserved word (true, false, undefined) as key literally. Even if encapsulated
  // as string, it is probably revert to reserved word by compress tool. See #7411.

  var prefix = 'type_';
  var typePriority = {
    'type_true': 2,
    'type_move': 1,
    'type_false': 0,
    'type_undefined': -1
  };
  var preventDefaultMouseMove = true;
  dataZoomInfoMap.each(function (dataZoomInfo) {
    var dataZoomModel = dataZoomInfo.model;
    var oneType = dataZoomModel.get('disabled', true) ? false : dataZoomModel.get('zoomLock', true) ? 'move' : true;

    if (typePriority[prefix + oneType] > typePriority[prefix + controlType]) {
      controlType = oneType;
    } // Prevent default move event by default. If one false, do not prevent. Otherwise
    // users may be confused why it does not work when multiple insideZooms exist.


    preventDefaultMouseMove = preventDefaultMouseMove && dataZoomModel.get('preventDefaultMouseMove', true);
  });
  return {
    controlType: controlType,
    opt: {
      // RoamController will enable all of these functionalities,
      // and the final behavior is determined by its event listener
      // provided by each inside zoom.
      zoomOnMouseWheel: true,
      moveOnMouseMove: true,
      moveOnMouseWheel: true,
      preventDefaultMouseMove: !!preventDefaultMouseMove
    }
  };
}

function installDataZoomRoamProcessor(registers) {
  registers.registerProcessor(registers.PRIORITY.PROCESSOR.FILTER, function (ecModel, api) {
    var apiInner = inner(api);
    var coordSysRecordMap = apiInner.coordSysRecordMap || (apiInner.coordSysRecordMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["createHashMap"])());
    coordSysRecordMap.each(function (coordSysRecord) {
      // `coordSysRecordMap` always exists (becuase it hold the `roam controller`, which should
      // better not re-create each time), but clear `dataZoomInfoMap` each round of the workflow.
      coordSysRecord.dataZoomInfoMap = null;
    });
    ecModel.eachComponent({
      mainType: 'dataZoom',
      subType: 'inside'
    }, function (dataZoomModel) {
      var dzReferCoordSysWrap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helper_js__["d" /* collectReferCoordSysModelInfo */])(dataZoomModel);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(dzReferCoordSysWrap.infoList, function (dzCoordSysInfo) {
        var coordSysUid = dzCoordSysInfo.model.uid;
        var coordSysRecord = coordSysRecordMap.get(coordSysUid) || coordSysRecordMap.set(coordSysUid, createCoordSysRecord(api, dzCoordSysInfo.model));
        var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap || (coordSysRecord.dataZoomInfoMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["createHashMap"])()); // Notice these props might be changed each time for a single dataZoomModel.

        dataZoomInfoMap.set(dataZoomModel.uid, {
          dzReferCoordSysInfo: dzCoordSysInfo,
          model: dataZoomModel,
          getRange: null
        });
      });
    }); // (1) Merge dataZoom settings for each coord sys and set to the roam controller.
    // (2) Clear coord sys if not refered by any dataZoom.

    coordSysRecordMap.each(function (coordSysRecord) {
      var controller = coordSysRecord.controller;
      var firstDzInfo;
      var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap;

      if (dataZoomInfoMap) {
        var firstDzKey = dataZoomInfoMap.keys()[0];

        if (firstDzKey != null) {
          firstDzInfo = dataZoomInfoMap.get(firstDzKey);
        }
      }

      if (!firstDzInfo) {
        disposeCoordSysRecord(coordSysRecordMap, coordSysRecord);
        return;
      }

      var controllerParams = mergeControllerParams(dataZoomInfoMap);
      controller.enable(controllerParams.controlType, controllerParams.opt);
      controller.setPointerChecker(coordSysRecord.containsPoint);
      __WEBPACK_IMPORTED_MODULE_1__util_throttle_js__["a" /* createOrUpdate */](coordSysRecord, 'dispatchAction', firstDzInfo.model.get('throttle', true), 'fixRate');
    });
  });
}

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coord_geo_GeoModel_js__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__coord_geo_geoCreator_js__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_roamHelper_js__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GeoView_js__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__coord_geo_geoSourceManager_js__ = __webpack_require__(156);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







function registerMap(mapName, geoJson, specialAreas) {
  __WEBPACK_IMPORTED_MODULE_5__coord_geo_geoSourceManager_js__["a" /* default */].registerMap(mapName, geoJson, specialAreas);
}

function install(registers) {
  registers.registerCoordinateSystem('geo', __WEBPACK_IMPORTED_MODULE_1__coord_geo_geoCreator_js__["a" /* default */]);
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_0__coord_geo_GeoModel_js__["a" /* default */]);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_4__GeoView_js__["a" /* default */]);
  registers.registerImpl('registerMap', registerMap);
  registers.registerImpl('getMap', function (mapName) {
    return __WEBPACK_IMPORTED_MODULE_5__coord_geo_geoSourceManager_js__["a" /* default */].getMapForUser(mapName);
  });

  function makeAction(method, actionInfo) {
    actionInfo.update = 'geo:updateSelectStatus';
    registers.registerAction(actionInfo, function (payload, ecModel) {
      var selected = {};
      var allSelected = [];
      ecModel.eachComponent({
        mainType: 'geo',
        query: payload
      }, function (geoModel) {
        geoModel[method](payload.name);
        var geo = geoModel.coordinateSystem;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(geo.regions, function (region) {
          selected[region.name] = geoModel.isSelected(region.name) || false;
        }); // Notice: there might be duplicated name in different regions.

        var names = [];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(selected, function (v, name) {
          selected[name] && names.push(name);
        });
        allSelected.push({
          geoIndex: geoModel.componentIndex,
          // Use singular, the same naming convention as the event `selectchanged`.
          name: names
        });
      });
      return {
        selected: selected,
        allSelected: allSelected,
        name: payload.name
      };
    });
  }

  makeAction('toggleSelected', {
    type: 'geoToggleSelect',
    event: 'geoselectchanged'
  });
  makeAction('select', {
    type: 'geoSelect',
    event: 'geoselected'
  });
  makeAction('unSelect', {
    type: 'geoUnSelect',
    event: 'geounselected'
  });
  /**
   * @payload
   * @property {string} [componentType=series]
   * @property {number} [dx]
   * @property {number} [dy]
   * @property {number} [zoom]
   * @property {number} [originX]
   * @property {number} [originY]
   */

  registers.registerAction({
    type: 'geoRoam',
    event: 'geoRoam',
    update: 'updateTransform'
  }, function (payload, ecModel) {
    var componentType = payload.componentType || 'series';
    ecModel.eachComponent({
      mainType: componentType,
      query: payload
    }, function (componentModel) {
      var geo = componentModel.coordinateSystem;

      if (geo.type !== 'geo') {
        return;
      }

      var res = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_roamHelper_js__["a" /* updateCenterAndZoom */])(geo, payload, componentModel.get('scaleLimit'));
      componentModel.setCenter && componentModel.setCenter(res.center);
      componentModel.setZoom && componentModel.setZoom(res.zoom); // All map series with same `map` use the same geo coordinate system
      // So the center and zoom must be in sync. Include the series not selected by legend

      if (componentType === 'series') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(componentModel.seriesGroup, function (seriesModel) {
          seriesModel.setCenter(res.center);
          seriesModel.setZoom(res.zoom);
        });
      }
    });
  });
}

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__brushHelper_js__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



 // FIXME
// how to genarialize to more coordinate systems.

var INCLUDE_FINDER_MAIN_TYPES = ['grid', 'xAxis', 'yAxis', 'geo', 'graph', 'polar', 'radiusAxis', 'angleAxis', 'bmap'];

var BrushTargetManager =
/** @class */
function () {
  /**
   * @param finder contains Index/Id/Name of xAxis/yAxis/geo/grid
   *        Each can be {number|Array.<number>}. like: {xAxisIndex: [3, 4]}
   * @param opt.include include coordinate system types.
   */
  function BrushTargetManager(finder, ecModel, opt) {
    var _this = this;

    this._targetInfoList = [];
    var foundCpts = parseFinder(ecModel, finder);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(targetInfoBuilders, function (builder, type) {
      if (!opt || !opt.include || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"])(opt.include, type) >= 0) {
        builder(foundCpts, _this._targetInfoList);
      }
    });
  }

  BrushTargetManager.prototype.setOutputRanges = function (areas, ecModel) {
    this.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
      (area.coordRanges || (area.coordRanges = [])).push(coordRange); // area.coordRange is the first of area.coordRanges

      if (!area.coordRange) {
        area.coordRange = coordRange; // In 'category' axis, coord to pixel is not reversible, so we can not
        // rebuild range by coordRange accrately, which may bring trouble when
        // brushing only one item. So we use __rangeOffset to rebuilding range
        // by coordRange. And this it only used in brush component so it is no
        // need to be adapted to coordRanges.

        var result = coordConvert[area.brushType](0, coordSys, coordRange);
        area.__rangeOffset = {
          offset: diffProcessor[area.brushType](result.values, area.range, [1, 1]),
          xyMinMax: result.xyMinMax
        };
      }
    });
    return areas;
  };

  BrushTargetManager.prototype.matchOutputRanges = function (areas, ecModel, cb) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(areas, function (area) {
      var targetInfo = this.findTargetInfo(area, ecModel);

      if (targetInfo && targetInfo !== true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(targetInfo.coordSyses, function (coordSys) {
          var result = coordConvert[area.brushType](1, coordSys, area.range, true);
          cb(area, result.values, coordSys, ecModel);
        });
      }
    }, this);
  };
  /**
   * the `areas` is `BrushModel.areas`.
   * Called in layout stage.
   * convert `area.coordRange` to global range and set panelId to `area.range`.
   */


  BrushTargetManager.prototype.setInputRanges = function (areas, ecModel) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(areas, function (area) {
      var targetInfo = this.findTargetInfo(area, ecModel);

      if (true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(!targetInfo || targetInfo === true || area.coordRange, 'coordRange must be specified when coord index specified.');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(!targetInfo || targetInfo !== true || area.range, 'range must be specified in global brush.');
      }

      area.range = area.range || []; // convert coordRange to global range and set panelId.

      if (targetInfo && targetInfo !== true) {
        area.panelId = targetInfo.panelId; // (1) area.range shoule always be calculate from coordRange but does
        // not keep its original value, for the sake of the dataZoom scenario,
        // where area.coordRange remains unchanged but area.range may be changed.
        // (2) Only support converting one coordRange to pixel range in brush
        // component. So do not consider `coordRanges`.
        // (3) About __rangeOffset, see comment above.

        var result = coordConvert[area.brushType](0, targetInfo.coordSys, area.coordRange);
        var rangeOffset = area.__rangeOffset;
        area.range = rangeOffset ? diffProcessor[area.brushType](result.values, rangeOffset.offset, getScales(result.xyMinMax, rangeOffset.xyMinMax)) : result.values;
      }
    }, this);
  };

  BrushTargetManager.prototype.makePanelOpts = function (api, getDefaultBrushType) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])(this._targetInfoList, function (targetInfo) {
      var rect = targetInfo.getPanelRect();
      return {
        panelId: targetInfo.panelId,
        defaultBrushType: getDefaultBrushType ? getDefaultBrushType(targetInfo) : null,
        clipPath: __WEBPACK_IMPORTED_MODULE_2__brushHelper_js__["a" /* makeRectPanelClipPath */](rect),
        isTargetByCursor: __WEBPACK_IMPORTED_MODULE_2__brushHelper_js__["b" /* makeRectIsTargetByCursor */](rect, api, targetInfo.coordSysModel),
        getLinearBrushOtherExtent: __WEBPACK_IMPORTED_MODULE_2__brushHelper_js__["c" /* makeLinearBrushOtherExtent */](rect)
      };
    });
  };

  BrushTargetManager.prototype.controlSeries = function (area, seriesModel, ecModel) {
    // Check whether area is bound in coord, and series do not belong to that coord.
    // If do not do this check, some brush (like lineX) will controll all axes.
    var targetInfo = this.findTargetInfo(area, ecModel);
    return targetInfo === true || targetInfo && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"])(targetInfo.coordSyses, seriesModel.coordinateSystem) >= 0;
  };
  /**
   * If return Object, a coord found.
   * If reutrn true, global found.
   * Otherwise nothing found.
   */


  BrushTargetManager.prototype.findTargetInfo = function (area, ecModel) {
    var targetInfoList = this._targetInfoList;
    var foundCpts = parseFinder(ecModel, area);

    for (var i = 0; i < targetInfoList.length; i++) {
      var targetInfo = targetInfoList[i];
      var areaPanelId = area.panelId;

      if (areaPanelId) {
        if (targetInfo.panelId === areaPanelId) {
          return targetInfo;
        }
      } else {
        for (var j = 0; j < targetInfoMatchers.length; j++) {
          if (targetInfoMatchers[j](foundCpts, targetInfo)) {
            return targetInfo;
          }
        }
      }
    }

    return true;
  };

  return BrushTargetManager;
}();

function formatMinMax(minMax) {
  minMax[0] > minMax[1] && minMax.reverse();
  return minMax;
}

function parseFinder(ecModel, finder) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_model_js__["l" /* parseFinder */])(ecModel, finder, {
    includeMainTypes: INCLUDE_FINDER_MAIN_TYPES
  });
}

var targetInfoBuilders = {
  grid: function (foundCpts, targetInfoList) {
    var xAxisModels = foundCpts.xAxisModels;
    var yAxisModels = foundCpts.yAxisModels;
    var gridModels = foundCpts.gridModels; // Remove duplicated.

    var gridModelMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();
    var xAxesHas = {};
    var yAxesHas = {};

    if (!xAxisModels && !yAxisModels && !gridModels) {
      return;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(xAxisModels, function (axisModel) {
      var gridModel = axisModel.axis.grid.model;
      gridModelMap.set(gridModel.id, gridModel);
      xAxesHas[gridModel.id] = true;
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(yAxisModels, function (axisModel) {
      var gridModel = axisModel.axis.grid.model;
      gridModelMap.set(gridModel.id, gridModel);
      yAxesHas[gridModel.id] = true;
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(gridModels, function (gridModel) {
      gridModelMap.set(gridModel.id, gridModel);
      xAxesHas[gridModel.id] = true;
      yAxesHas[gridModel.id] = true;
    });
    gridModelMap.each(function (gridModel) {
      var grid = gridModel.coordinateSystem;
      var cartesians = [];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(grid.getCartesians(), function (cartesian, index) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"])(xAxisModels, cartesian.getAxis('x').model) >= 0 || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"])(yAxisModels, cartesian.getAxis('y').model) >= 0) {
          cartesians.push(cartesian);
        }
      });
      targetInfoList.push({
        panelId: 'grid--' + gridModel.id,
        gridModel: gridModel,
        coordSysModel: gridModel,
        // Use the first one as the representitive coordSys.
        coordSys: cartesians[0],
        coordSyses: cartesians,
        getPanelRect: panelRectBuilders.grid,
        xAxisDeclared: xAxesHas[gridModel.id],
        yAxisDeclared: yAxesHas[gridModel.id]
      });
    });
  },
  geo: function (foundCpts, targetInfoList) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(foundCpts.geoModels, function (geoModel) {
      var coordSys = geoModel.coordinateSystem;
      targetInfoList.push({
        panelId: 'geo--' + geoModel.id,
        geoModel: geoModel,
        coordSysModel: geoModel,
        coordSys: coordSys,
        coordSyses: [coordSys],
        getPanelRect: panelRectBuilders.geo
      });
    });
  }
};
var targetInfoMatchers = [// grid
function (foundCpts, targetInfo) {
  var xAxisModel = foundCpts.xAxisModel;
  var yAxisModel = foundCpts.yAxisModel;
  var gridModel = foundCpts.gridModel;
  !gridModel && xAxisModel && (gridModel = xAxisModel.axis.grid.model);
  !gridModel && yAxisModel && (gridModel = yAxisModel.axis.grid.model);
  return gridModel && gridModel === targetInfo.gridModel;
}, // geo
function (foundCpts, targetInfo) {
  var geoModel = foundCpts.geoModel;
  return geoModel && geoModel === targetInfo.geoModel;
}];
var panelRectBuilders = {
  grid: function () {
    // grid is not Transformable.
    return this.coordSys.master.getRect().clone();
  },
  geo: function () {
    var coordSys = this.coordSys;
    var rect = coordSys.getBoundingRect().clone(); // geo roam and zoom transform

    rect.applyTransform(__WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["getTransform"](coordSys));
    return rect;
  }
};
var coordConvert = {
  lineX: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["curry"])(axisConvert, 0),
  lineY: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["curry"])(axisConvert, 1),
  rect: function (to, coordSys, rangeOrCoordRange, clamp) {
    var xminymin = to ? coordSys.pointToData([rangeOrCoordRange[0][0], rangeOrCoordRange[1][0]], clamp) : coordSys.dataToPoint([rangeOrCoordRange[0][0], rangeOrCoordRange[1][0]], clamp);
    var xmaxymax = to ? coordSys.pointToData([rangeOrCoordRange[0][1], rangeOrCoordRange[1][1]], clamp) : coordSys.dataToPoint([rangeOrCoordRange[0][1], rangeOrCoordRange[1][1]], clamp);
    var values = [formatMinMax([xminymin[0], xmaxymax[0]]), formatMinMax([xminymin[1], xmaxymax[1]])];
    return {
      values: values,
      xyMinMax: values
    };
  },
  polygon: function (to, coordSys, rangeOrCoordRange, clamp) {
    var xyMinMax = [[Infinity, -Infinity], [Infinity, -Infinity]];
    var values = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])(rangeOrCoordRange, function (item) {
      var p = to ? coordSys.pointToData(item, clamp) : coordSys.dataToPoint(item, clamp);
      xyMinMax[0][0] = Math.min(xyMinMax[0][0], p[0]);
      xyMinMax[1][0] = Math.min(xyMinMax[1][0], p[1]);
      xyMinMax[0][1] = Math.max(xyMinMax[0][1], p[0]);
      xyMinMax[1][1] = Math.max(xyMinMax[1][1], p[1]);
      return p;
    });
    return {
      values: values,
      xyMinMax: xyMinMax
    };
  }
};

function axisConvert(axisNameIndex, to, coordSys, rangeOrCoordRange) {
  if (true) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(coordSys.type === 'cartesian2d', 'lineX/lineY brush is available only in cartesian2d.');
  }

  var axis = coordSys.getAxis(['x', 'y'][axisNameIndex]);
  var values = formatMinMax(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])([0, 1], function (i) {
    return to ? axis.coordToData(axis.toLocalCoord(rangeOrCoordRange[i]), true) : axis.toGlobalCoord(axis.dataToCoord(rangeOrCoordRange[i]));
  }));
  var xyMinMax = [];
  xyMinMax[axisNameIndex] = values;
  xyMinMax[1 - axisNameIndex] = [NaN, NaN];
  return {
    values: values,
    xyMinMax: xyMinMax
  };
}

var diffProcessor = {
  lineX: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["curry"])(axisDiffProcessor, 0),
  lineY: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["curry"])(axisDiffProcessor, 1),
  rect: function (values, refer, scales) {
    return [[values[0][0] - scales[0] * refer[0][0], values[0][1] - scales[0] * refer[0][1]], [values[1][0] - scales[1] * refer[1][0], values[1][1] - scales[1] * refer[1][1]]];
  },
  polygon: function (values, refer, scales) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])(values, function (item, idx) {
      return [item[0] - scales[0] * refer[idx][0], item[1] - scales[1] * refer[idx][1]];
    });
  }
};

function axisDiffProcessor(axisNameIndex, values, refer, scales) {
  return [values[0] - scales[axisNameIndex] * refer[0], values[1] - scales[axisNameIndex] * refer[1]];
} // We have to process scale caused by dataZoom manually,
// although it might be not accurate.
// Return [0~1, 0~1]


function getScales(xyMinMaxCurr, xyMinMaxOrigin) {
  var sizeCurr = getSize(xyMinMaxCurr);
  var sizeOrigin = getSize(xyMinMaxOrigin);
  var scales = [sizeCurr[0] / sizeOrigin[0], sizeCurr[1] / sizeOrigin[1]];
  isNaN(scales[0]) && (scales[0] = 1);
  isNaN(scales[1]) && (scales[1] = 1);
  return scales;
}

function getSize(xyMinMax) {
  return xyMinMax ? [xyMinMax[0][1] - xyMinMax[0][0], xyMinMax[1][1] - xyMinMax[1][0]] : [NaN, NaN];
}

/* harmony default export */ __webpack_exports__["a"] = (BrushTargetManager);

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RoamController_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_helper_roamHelper_js__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_helper_cursorHelper_js__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__coord_geo_geoSourceManager_js__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_component_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_decal_js__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_zrender_lib_graphic_Displayable_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/













/**
 * Only these tags enable use `itemStyle` if they are named in SVG.
 * Other tags like <text> <tspan> <image> might not suitable for `itemStyle`.
 * They will not be considered to be styled until some requirements come.
 */

var OPTION_STYLE_ENABLED_TAGS = ['rect', 'circle', 'line', 'ellipse', 'polygon', 'polyline', 'path'];
var OPTION_STYLE_ENABLED_TAG_MAP = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"](OPTION_STYLE_ENABLED_TAGS);
var STATE_TRIGGER_TAG_MAP = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"](OPTION_STYLE_ENABLED_TAGS.concat(['g']));
var LABEL_HOST_MAP = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"](OPTION_STYLE_ENABLED_TAGS.concat(['g']));
var mapLabelRaw = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_model_js__["a" /* makeInner */])();

function getFixedItemStyle(model) {
  var itemStyle = model.getItemStyle();
  var areaColor = model.get('areaColor'); // If user want the color not to be changed when hover,
  // they should both set areaColor and color to be null.

  if (areaColor != null) {
    itemStyle.fill = areaColor;
  }

  return itemStyle;
} // Only stroke can be used for line.
// Using fill in style if stroke not exits.
// TODO Not sure yet. Perhaps a separate `lineStyle`?


function fixLineStyle(styleHost) {
  var style = styleHost.style;

  if (style) {
    style.stroke = style.stroke || style.fill;
    style.fill = null;
  }
}

var MapDraw =
/** @class */
function () {
  function MapDraw(api) {
    var group = new __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["Group"]();
    this.uid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_component_js__["a" /* getUID */])('ec_map_draw');
    this._controller = new __WEBPACK_IMPORTED_MODULE_1__RoamController_js__["a" /* default */](api.getZr());
    this._controllerHost = {
      target: group
    };
    this.group = group;
    group.add(this._regionsGroup = new __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["Group"]());
    group.add(this._svgGroup = new __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["Group"]());
  }

  MapDraw.prototype.draw = function (mapOrGeoModel, ecModel, api, fromView, payload) {
    var isGeo = mapOrGeoModel.mainType === 'geo'; // Map series has data. GEO model that controlled by map series
    // will be assigned with map data. Other GEO model has no data.

    var data = mapOrGeoModel.getData && mapOrGeoModel.getData();
    isGeo && ecModel.eachComponent({
      mainType: 'series',
      subType: 'map'
    }, function (mapSeries) {
      if (!data && mapSeries.getHostGeoModel() === mapOrGeoModel) {
        data = mapSeries.getData();
      }
    });
    var geo = mapOrGeoModel.coordinateSystem;
    var regionsGroup = this._regionsGroup;
    var group = this.group;
    var transformInfo = geo.getTransformInfo();
    var transformInfoRaw = transformInfo.raw;
    var transformInfoRoam = transformInfo.roam; // No animation when first draw or in action

    var isFirstDraw = !regionsGroup.childAt(0) || payload;

    if (isFirstDraw) {
      group.x = transformInfoRoam.x;
      group.y = transformInfoRoam.y;
      group.scaleX = transformInfoRoam.scaleX;
      group.scaleY = transformInfoRoam.scaleY;
      group.dirty();
    } else {
      __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["updateProps"](group, transformInfoRoam, mapOrGeoModel);
    }

    var isVisualEncodedByVisualMap = data && data.getVisual('visualMeta') && data.getVisual('visualMeta').length > 0;
    var viewBuildCtx = {
      api: api,
      geo: geo,
      mapOrGeoModel: mapOrGeoModel,
      data: data,
      isVisualEncodedByVisualMap: isVisualEncodedByVisualMap,
      isGeo: isGeo,
      transformInfoRaw: transformInfoRaw
    };

    if (geo.resourceType === 'geoJSON') {
      this._buildGeoJSON(viewBuildCtx);
    } else if (geo.resourceType === 'geoSVG') {
      this._buildSVG(viewBuildCtx);
    }

    this._updateController(mapOrGeoModel, ecModel, api);

    this._updateMapSelectHandler(mapOrGeoModel, regionsGroup, api, fromView);
  };

  MapDraw.prototype._buildGeoJSON = function (viewBuildCtx) {
    var regionsGroupByName = this._regionsGroupByName = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"]();
    var regionsInfoByName = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"]();
    var regionsGroup = this._regionsGroup;
    var transformInfoRaw = viewBuildCtx.transformInfoRaw;
    var mapOrGeoModel = viewBuildCtx.mapOrGeoModel;
    var data = viewBuildCtx.data;
    var projection = viewBuildCtx.geo.projection;
    var projectionStream = projection && projection.stream;

    function transformPoint(point, project) {
      if (project) {
        // projection may return null point.
        point = project(point);
      }

      return point && [point[0] * transformInfoRaw.scaleX + transformInfoRaw.x, point[1] * transformInfoRaw.scaleY + transformInfoRaw.y];
    }

    ;

    function transformPolygonPoints(inPoints) {
      var outPoints = []; // If projectionStream is provided. Use it instead of single point project.

      var project = !projectionStream && projection && projection.project;

      for (var i = 0; i < inPoints.length; ++i) {
        var newPt = transformPoint(inPoints[i], project);
        newPt && outPoints.push(newPt);
      }

      return outPoints;
    }

    function getPolyShape(points) {
      return {
        shape: {
          points: transformPolygonPoints(points)
        }
      };
    }

    regionsGroup.removeAll(); // Only when the resource is GeoJSON, there is `geo.regions`.

    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](viewBuildCtx.geo.regions, function (region) {
      var regionName = region.name; // Consider in GeoJson properties.name may be duplicated, for example,
      // there is multiple region named "United Kindom" or "France" (so many
      // colonies). And it is not appropriate to merge them in geo, which
      // will make them share the same label and bring trouble in label
      // location calculation.

      var regionGroup = regionsGroupByName.get(regionName);

      var _a = regionsInfoByName.get(regionName) || {},
          dataIdx = _a.dataIdx,
          regionModel = _a.regionModel;

      if (!regionGroup) {
        regionGroup = regionsGroupByName.set(regionName, new __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["Group"]());
        regionsGroup.add(regionGroup);
        dataIdx = data ? data.indexOfName(regionName) : null;
        regionModel = viewBuildCtx.isGeo ? mapOrGeoModel.getRegionModel(regionName) : data ? data.getItemModel(dataIdx) : null;
        regionsInfoByName.set(regionName, {
          dataIdx: dataIdx,
          regionModel: regionModel
        });
      }

      var polygonSubpaths = [];
      var polylineSubpaths = [];
      __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](region.geometries, function (geometry) {
        // Polygon and MultiPolygon
        if (geometry.type === 'polygon') {
          var polys = [geometry.exterior].concat(geometry.interiors || []);

          if (projectionStream) {
            polys = projectPolys(polys, projectionStream);
          }

          __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](polys, function (poly) {
            polygonSubpaths.push(new __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["Polygon"](getPolyShape(poly)));
          });
        } // LineString and MultiLineString
        else {
            var points = geometry.points;

            if (projectionStream) {
              points = projectPolys(points, projectionStream, true);
            }

            __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](points, function (points) {
              polylineSubpaths.push(new __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["Polyline"](getPolyShape(points)));
            });
          }
      });
      var centerPt = transformPoint(region.getCenter(), projection && projection.project);

      function createCompoundPath(subpaths, isLine) {
        if (!subpaths.length) {
          return;
        }

        var compoundPath = new __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["CompoundPath"]({
          culling: true,
          segmentIgnoreThreshold: 1,
          shape: {
            paths: subpaths
          }
        });
        regionGroup.add(compoundPath);
        applyOptionStyleForRegion(viewBuildCtx, compoundPath, dataIdx, regionModel);
        resetLabelForRegion(viewBuildCtx, compoundPath, regionName, regionModel, mapOrGeoModel, dataIdx, centerPt);

        if (isLine) {
          fixLineStyle(compoundPath);
          __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](compoundPath.states, fixLineStyle);
        }
      }

      createCompoundPath(polygonSubpaths);
      createCompoundPath(polylineSubpaths, true);
    }); // Ensure children have been added to `regionGroup` before calling them.

    regionsGroupByName.each(function (regionGroup, regionName) {
      var _a = regionsInfoByName.get(regionName),
          dataIdx = _a.dataIdx,
          regionModel = _a.regionModel;

      resetEventTriggerForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel, dataIdx);
      resetTooltipForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel);
      resetStateTriggerForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel);
    }, this);
  };

  MapDraw.prototype._buildSVG = function (viewBuildCtx) {
    var mapName = viewBuildCtx.geo.map;
    var transformInfoRaw = viewBuildCtx.transformInfoRaw;
    this._svgGroup.x = transformInfoRaw.x;
    this._svgGroup.y = transformInfoRaw.y;
    this._svgGroup.scaleX = transformInfoRaw.scaleX;
    this._svgGroup.scaleY = transformInfoRaw.scaleY;

    if (this._svgResourceChanged(mapName)) {
      this._freeSVG();

      this._useSVG(mapName);
    }

    var svgDispatcherMap = this._svgDispatcherMap = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"]();
    var focusSelf = false;
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](this._svgGraphicRecord.named, function (namedItem) {
      // Note that we also allow different elements have the same name.
      // For example, a glyph of a city and the label of the city have
      // the same name and their tooltip info can be defined in a single
      // region option.
      var regionName = namedItem.name;
      var mapOrGeoModel = viewBuildCtx.mapOrGeoModel;
      var data = viewBuildCtx.data;
      var svgNodeTagLower = namedItem.svgNodeTagLower;
      var el = namedItem.el;
      var dataIdx = data ? data.indexOfName(regionName) : null;
      var regionModel = mapOrGeoModel.getRegionModel(regionName);

      if (OPTION_STYLE_ENABLED_TAG_MAP.get(svgNodeTagLower) != null && el instanceof __WEBPACK_IMPORTED_MODULE_11_zrender_lib_graphic_Displayable_js__["c" /* default */]) {
        applyOptionStyleForRegion(viewBuildCtx, el, dataIdx, regionModel);
      }

      if (el instanceof __WEBPACK_IMPORTED_MODULE_11_zrender_lib_graphic_Displayable_js__["c" /* default */]) {
        el.culling = true;
      } // We do not know how the SVG like so we'd better not to change z2.
      // Otherwise it might bring some unexpected result. For example,
      // an area hovered that make some inner city can not be clicked.


      el.z2EmphasisLift = 0; // If self named:

      if (!namedItem.namedFrom) {
        // label should batter to be displayed based on the center of <g>
        // if it is named rather than displayed on each child.
        if (LABEL_HOST_MAP.get(svgNodeTagLower) != null) {
          resetLabelForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, dataIdx, null);
        }

        resetEventTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, dataIdx);
        resetTooltipForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel);

        if (STATE_TRIGGER_TAG_MAP.get(svgNodeTagLower) != null) {
          var focus_1 = resetStateTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel);

          if (focus_1 === 'self') {
            focusSelf = true;
          }

          var els = svgDispatcherMap.get(regionName) || svgDispatcherMap.set(regionName, []);
          els.push(el);
        }
      }
    }, this);

    this._enableBlurEntireSVG(focusSelf, viewBuildCtx);
  };

  MapDraw.prototype._enableBlurEntireSVG = function (focusSelf, viewBuildCtx) {
    // It's a little complicated to support blurring the entire geoSVG in series-map.
    // So do not suport it until some requirements come.
    // At present, in series-map, only regions can be blurred.
    if (focusSelf && viewBuildCtx.isGeo) {
      var blurStyle = viewBuildCtx.mapOrGeoModel.getModel(['blur', 'itemStyle']).getItemStyle(); // Only suport `opacity` here. Because not sure that other props are suitable for
      // all of the elements generated by SVG (especially for Text/TSpan/Image/... ).

      var opacity_1 = blurStyle.opacity;

      this._svgGraphicRecord.root.traverse(function (el) {
        if (!el.isGroup) {
          // PENDING: clear those settings to SVG elements when `_freeSVG`.
          // (Currently it happen not to be needed.)
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_states_js__["H" /* setDefaultStateProxy */])(el);
          var style = el.ensureState('blur').style || {}; // Do not overwrite the region style that already set from region option.

          if (style.opacity == null && opacity_1 != null) {
            style.opacity = opacity_1;
          } // If `ensureState('blur').style = {}`, there will be default opacity.
          // Enable `stateTransition` (animation).


          el.ensureState('emphasis');
        }
      });
    }
  };

  MapDraw.prototype.remove = function () {
    this._regionsGroup.removeAll();

    this._regionsGroupByName = null;

    this._svgGroup.removeAll();

    this._freeSVG();

    this._controller.dispose();

    this._controllerHost = null;
  };

  MapDraw.prototype.findHighDownDispatchers = function (name, geoModel) {
    if (name == null) {
      return [];
    }

    var geo = geoModel.coordinateSystem;

    if (geo.resourceType === 'geoJSON') {
      var regionsGroupByName = this._regionsGroupByName;

      if (regionsGroupByName) {
        var regionGroup = regionsGroupByName.get(name);
        return regionGroup ? [regionGroup] : [];
      }
    } else if (geo.resourceType === 'geoSVG') {
      return this._svgDispatcherMap && this._svgDispatcherMap.get(name) || [];
    }
  };

  MapDraw.prototype._svgResourceChanged = function (mapName) {
    return this._svgMapName !== mapName;
  };

  MapDraw.prototype._useSVG = function (mapName) {
    var resource = __WEBPACK_IMPORTED_MODULE_6__coord_geo_geoSourceManager_js__["a" /* default */].getGeoResource(mapName);

    if (resource && resource.type === 'geoSVG') {
      var svgGraphic = resource.useGraphic(this.uid);

      this._svgGroup.add(svgGraphic.root);

      this._svgGraphicRecord = svgGraphic;
      this._svgMapName = mapName;
    }
  };

  MapDraw.prototype._freeSVG = function () {
    var mapName = this._svgMapName;

    if (mapName == null) {
      return;
    }

    var resource = __WEBPACK_IMPORTED_MODULE_6__coord_geo_geoSourceManager_js__["a" /* default */].getGeoResource(mapName);

    if (resource && resource.type === 'geoSVG') {
      resource.freeGraphic(this.uid);
    }

    this._svgGraphicRecord = null;
    this._svgDispatcherMap = null;

    this._svgGroup.removeAll();

    this._svgMapName = null;
  };

  MapDraw.prototype._updateController = function (mapOrGeoModel, ecModel, api) {
    var geo = mapOrGeoModel.coordinateSystem;
    var controller = this._controller;
    var controllerHost = this._controllerHost; // @ts-ignore FIXME:TS

    controllerHost.zoomLimit = mapOrGeoModel.get('scaleLimit');
    controllerHost.zoom = geo.getZoom(); // roamType is will be set default true if it is null
    // @ts-ignore FIXME:TS

    controller.enable(mapOrGeoModel.get('roam') || false);
    var mainType = mapOrGeoModel.mainType;

    function makeActionBase() {
      var action = {
        type: 'geoRoam',
        componentType: mainType
      };
      action[mainType + 'Id'] = mapOrGeoModel.id;
      return action;
    }

    controller.off('pan').on('pan', function (e) {
      this._mouseDownFlag = false;
      __WEBPACK_IMPORTED_MODULE_2__component_helper_roamHelper_js__["a" /* updateViewOnPan */](controllerHost, e.dx, e.dy);
      api.dispatchAction(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"](makeActionBase(), {
        dx: e.dx,
        dy: e.dy,
        animation: {
          duration: 0
        }
      }));
    }, this);
    controller.off('zoom').on('zoom', function (e) {
      this._mouseDownFlag = false;
      __WEBPACK_IMPORTED_MODULE_2__component_helper_roamHelper_js__["b" /* updateViewOnZoom */](controllerHost, e.scale, e.originX, e.originY);
      api.dispatchAction(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"](makeActionBase(), {
        zoom: e.scale,
        originX: e.originX,
        originY: e.originY,
        animation: {
          duration: 0
        }
      }));
    }, this);
    controller.setPointerChecker(function (e, x, y) {
      return geo.containPoint([x, y]) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__component_helper_cursorHelper_js__["a" /* onIrrelevantElement */])(e, api, mapOrGeoModel);
    });
  };
  /**
   * FIXME: this is a temporarily workaround.
   * When `geoRoam` the elements need to be reset in `MapView['render']`, because the props like
   * `ignore` might have been modified by `LabelManager`, and `LabelManager#addLabelsOfSeries`
   * will subsequently cache `defaultAttr` like `ignore`. If do not do this reset, the modified
   * props will have no chance to be restored.
   * Note: this reset should be after `clearStates` in `renderSeries` becuase `useStates` in
   * `renderSeries` will cache the modified `ignore` to `el._normalState`.
   * TODO:
   * Use clone/immutable in `LabelManager`?
   */


  MapDraw.prototype.resetForLabelLayout = function () {
    this.group.traverse(function (el) {
      var label = el.getTextContent();

      if (label) {
        label.ignore = mapLabelRaw(label).ignore;
      }
    });
  };

  MapDraw.prototype._updateMapSelectHandler = function (mapOrGeoModel, regionsGroup, api, fromView) {
    var mapDraw = this;
    regionsGroup.off('mousedown');
    regionsGroup.off('click'); // @ts-ignore FIXME:TS resolve type conflict

    if (mapOrGeoModel.get('selectedMode')) {
      regionsGroup.on('mousedown', function () {
        mapDraw._mouseDownFlag = true;
      });
      regionsGroup.on('click', function (e) {
        if (!mapDraw._mouseDownFlag) {
          return;
        }

        mapDraw._mouseDownFlag = false;
      });
    }
  };

  return MapDraw;
}();

;

function applyOptionStyleForRegion(viewBuildCtx, el, dataIndex, regionModel) {
  // All of the path are using `itemStyle`, becuase
  // (1) Some SVG also use fill on polyline (The different between
  // polyline and polygon is "open" or "close" but not fill or not).
  // (2) For the common props like opacity, if some use itemStyle
  // and some use `lineStyle`, it might confuse users.
  // (3) Most SVG use <path>, where can not detect wether draw a "line"
  // or a filled shape, so use `itemStyle` for <path>.
  var normalStyleModel = regionModel.getModel('itemStyle');
  var emphasisStyleModel = regionModel.getModel(['emphasis', 'itemStyle']);
  var blurStyleModel = regionModel.getModel(['blur', 'itemStyle']);
  var selectStyleModel = regionModel.getModel(['select', 'itemStyle']); // NOTE: DONT use 'style' in visual when drawing map.
  // This component is used for drawing underlying map for both geo component and map series.

  var normalStyle = getFixedItemStyle(normalStyleModel);
  var emphasisStyle = getFixedItemStyle(emphasisStyleModel);
  var selectStyle = getFixedItemStyle(selectStyleModel);
  var blurStyle = getFixedItemStyle(blurStyleModel); // Update the itemStyle if has data visual

  var data = viewBuildCtx.data;

  if (data) {
    // Only visual color of each item will be used. It can be encoded by visualMap
    // But visual color of series is used in symbol drawing
    // Visual color for each series is for the symbol draw
    var style = data.getItemVisual(dataIndex, 'style');
    var decal = data.getItemVisual(dataIndex, 'decal');

    if (viewBuildCtx.isVisualEncodedByVisualMap && style.fill) {
      normalStyle.fill = style.fill;
    }

    if (decal) {
      normalStyle.decal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_decal_js__["a" /* createOrUpdatePatternFromDecal */])(decal, viewBuildCtx.api);
    }
  } // SVG text, tspan and image can be named but not supporeted
  // to be styled by region option yet.


  el.setStyle(normalStyle);
  el.style.strokeNoScale = true;
  el.ensureState('emphasis').style = emphasisStyle;
  el.ensureState('select').style = selectStyle;
  el.ensureState('blur').style = blurStyle; // Enable blur

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_states_js__["H" /* setDefaultStateProxy */])(el);
}

function resetLabelForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, // Exist only if `viewBuildCtx.data` exists.
dataIdx, // If labelXY not provided, use `textConfig.position: 'inside'`
labelXY) {
  var data = viewBuildCtx.data;
  var isGeo = viewBuildCtx.isGeo;
  var isDataNaN = data && isNaN(data.get(data.mapDimension('value'), dataIdx));
  var itemLayout = data && data.getItemLayout(dataIdx); // In the following cases label will be drawn
  // 1. In map series and data value is NaN
  // 2. In geo component
  // 3. Region has no series legendIcon, which will be add a showLabel flag in mapSymbolLayout

  if (isGeo || isDataNaN || itemLayout && itemLayout.showLabel) {
    var query = !isGeo ? dataIdx : regionName;
    var labelFetcher = void 0; // Consider dataIdx not found.

    if (!data || dataIdx >= 0) {
      labelFetcher = mapOrGeoModel;
    }

    var specifiedTextOpt = labelXY ? {
      normal: {
        align: 'center',
        verticalAlign: 'middle'
      }
    } : null; // Caveat: must be called after `setDefaultStateProxy(el);` called.
    // because textContent will be assign with `el.stateProxy` inside.

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__label_labelStyle_js__["e" /* setLabelStyle */])(el, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__label_labelStyle_js__["f" /* getLabelStatesModels */])(regionModel), {
      labelFetcher: labelFetcher,
      labelDataIndex: query,
      defaultText: regionName
    }, specifiedTextOpt);
    var textEl = el.getTextContent();

    if (textEl) {
      mapLabelRaw(textEl).ignore = textEl.ignore;

      if (el.textConfig && labelXY) {
        // Compute a relative offset based on the el bounding rect.
        var rect = el.getBoundingRect().clone(); // Need to make sure the percent position base on the same rect in normal and
        // emphasis state. Otherwise if using boundingRect of el, but the emphasis state
        // has borderWidth (even 0.5px), the text position will be changed obviously
        // if the position is very big like ['1234%', '1345%'].

        el.textConfig.layoutRect = rect;
        el.textConfig.position = [(labelXY[0] - rect.x) / rect.width * 100 + '%', (labelXY[1] - rect.y) / rect.height * 100 + '%'];
      }
    } // PENDING:
    // If labelLayout is enabled (test/label-layout.html), el.dataIndex should be specified.
    // But el.dataIndex is also used to determine whether user event should be triggered,
    // where el.seriesIndex or el.dataModel must be specified. At present for a single el
    // there is not case that "only label layout enabled but user event disabled", so here
    // we depends `resetEventTriggerForRegion` to do the job of setting `el.dataIndex`.


    el.disableLabelAnimation = true;
  } else {
    el.removeTextContent();
    el.removeTextConfig();
    el.disableLabelAnimation = null;
  }
}

function resetEventTriggerForRegion(viewBuildCtx, eventTrigger, regionName, regionModel, mapOrGeoModel, // Exist only if `viewBuildCtx.data` exists.
dataIdx) {
  // setItemGraphicEl, setHoverStyle after all polygons and labels
  // are added to the rigionGroup
  if (viewBuildCtx.data) {
    // FIXME: when series-map use a SVG map, and there are duplicated name specified
    // on different SVG elements, after `data.setItemGraphicEl(...)`:
    // (1) all of them will be mounted with `dataIndex`, `seriesIndex`, so that tooltip
    // can be triggered only mouse hover. That's correct.
    // (2) only the last element will be kept in `data`, so that if trigger tooltip
    // by `dispatchAction`, only the last one can be found and triggered. That might be
    // not correct. We will fix it in future if anyone demanding that.
    viewBuildCtx.data.setItemGraphicEl(dataIdx, eventTrigger);
  } // series-map will not trigger "geoselectchange" no matter it is
  // based on a declared geo component. Becuause series-map will
  // trigger "selectchange". If it trigger both the two events,
  // If users call `chart.dispatchAction({type: 'toggleSelect'})`,
  // it not easy to also fire event "geoselectchanged".
  else {
      // Package custom mouse event for geo component
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_innerStore_js__["a" /* getECData */])(eventTrigger).eventData = {
        componentType: 'geo',
        componentIndex: mapOrGeoModel.componentIndex,
        geoIndex: mapOrGeoModel.componentIndex,
        name: regionName,
        region: regionModel && regionModel.option || {}
      };
    }
}

function resetTooltipForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel) {
  if (!viewBuildCtx.data) {
    __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["setTooltipConfig"]({
      el: el,
      componentModel: mapOrGeoModel,
      itemName: regionName,
      // @ts-ignore FIXME:TS fix the "compatible with each other"?
      itemTooltipOption: regionModel.get('tooltip')
    });
  }
}

function resetStateTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel) {
  // @ts-ignore FIXME:TS fix the "compatible with each other"?
  el.highDownSilentOnTouch = !!mapOrGeoModel.get('selectedMode'); // @ts-ignore FIXME:TS fix the "compatible with each other"?

  var emphasisModel = regionModel.getModel('emphasis');
  var focus = emphasisModel.get('focus');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_states_js__["G" /* toggleHoverEmphasis */])(el, focus, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));

  if (viewBuildCtx.isGeo) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_states_js__["I" /* enableComponentHighDownFeatures */])(el, mapOrGeoModel, regionName);
  }

  return focus;
}

function projectPolys(rings, // Polygons include exterior and interiors. Or polylines.
createStream, isLine) {
  var polygons = [];
  var curPoly;

  function startPolygon() {
    curPoly = [];
  }

  function endPolygon() {
    if (curPoly.length) {
      polygons.push(curPoly);
      curPoly = [];
    }
  }

  var stream = createStream({
    polygonStart: startPolygon,
    polygonEnd: endPolygon,
    lineStart: startPolygon,
    lineEnd: endPolygon,
    point: function (x, y) {
      // May have NaN values from stream.
      if (isFinite(x) && isFinite(y)) {
        curPoly.push([x, y]);
      }
    },
    sphere: function () {}
  });
  !isLine && stream.polygonStart();
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](rings, function (ring) {
    stream.lineStart();

    for (var i = 0; i < ring.length; i++) {
      stream.point(ring[i][0], ring[i][1]);
    }

    stream.lineEnd();
  });
  !isLine && stream.polygonEnd();
  return polygons;
}

/* harmony default export */ __webpack_exports__["a"] = (MapDraw); // @ts-ignore FIXME:TS fix the "compatible with each other"?

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRectPanelClipPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = makeLinearBrushOtherExtent;
/* harmony export (immutable) */ __webpack_exports__["b"] = makeRectIsTargetByCursor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cursorHelper_js__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__ = __webpack_require__(4);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



function makeRectPanelClipPath(rect) {
  rect = normalizeRect(rect);
  return function (localPoints) {
    return __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["clipPointsByRect"](localPoints, rect);
  };
}
function makeLinearBrushOtherExtent(rect, specifiedXYIndex) {
  rect = normalizeRect(rect);
  return function (xyIndex) {
    var idx = specifiedXYIndex != null ? specifiedXYIndex : xyIndex;
    var brushWidth = idx ? rect.width : rect.height;
    var base = idx ? rect.x : rect.y;
    return [base, base + (brushWidth || 0)];
  };
}
function makeRectIsTargetByCursor(rect, api, targetModel) {
  var boundingRect = normalizeRect(rect);
  return function (e, localCursorPoint) {
    return boundingRect.contain(localCursorPoint[0], localCursorPoint[1]) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cursorHelper_js__["a" /* onIrrelevantElement */])(e, api, targetModel);
  };
} // Consider width/height is negative.

function normalizeRect(rect) {
  return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_BoundingRect_js__["a" /* default */].create(rect);
}

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = take;
/* harmony export (immutable) */ __webpack_exports__["c"] = release;
/* harmony export (immutable) */ __webpack_exports__["a"] = isTaken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// @ts-nocheck


var ATTR = '\0_ec_interaction_mutex';
function take(zr, resourceKey, userKey) {
  var store = getStore(zr);
  store[resourceKey] = userKey;
}
function release(zr, resourceKey, userKey) {
  var store = getStore(zr);
  var uKey = store[resourceKey];

  if (uKey === userKey) {
    store[resourceKey] = null;
  }
}
function isTaken(zr, resourceKey) {
  return !!getStore(zr)[resourceKey];
}

function getStore(zr) {
  return zr[ATTR] || (zr[ATTR] = {});
}
/**
 * payload: {
 *     type: 'takeGlobalCursor',
 *     key: 'dataZoomSelect', or 'brush', or ...,
 *         If no userKey, release global cursor.
 * }
 */
// TODO: SELF REGISTERED.


__WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["a" /* registerAction */]({
  type: 'takeGlobalCursor',
  event: 'globalCursorTaken',
  update: 'update'
}, __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["noop"]);

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = layout;
/* harmony export (immutable) */ __webpack_exports__["a"] = makeBackground;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_format_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__ = __webpack_require__(4);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// @ts-nocheck



/**
 * Layout list like component.
 * It will box layout each items in group of component and then position the whole group in the viewport
 * @param {module:zrender/group/Group} group
 * @param {module:echarts/model/Component} componentModel
 * @param {module:echarts/ExtensionAPI}
 */

function layout(group, componentModel, api) {
  var boxLayoutParams = componentModel.getBoxLayoutParams();
  var padding = componentModel.get('padding');
  var viewportSize = {
    width: api.getWidth(),
    height: api.getHeight()
  };
  var rect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_layout_js__["f" /* getLayoutRect */])(boxLayoutParams, viewportSize, padding);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_layout_js__["d" /* box */])(componentModel.get('orient'), group, componentModel.get('itemGap'), rect.width, rect.height);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_layout_js__["e" /* positionElement */])(group, boxLayoutParams, viewportSize, padding);
}
function makeBackground(rect, componentModel) {
  var padding = __WEBPACK_IMPORTED_MODULE_1__util_format_js__["f" /* normalizeCssArray */](componentModel.get('padding'));
  var style = componentModel.getItemStyle(['color', 'opacity']);
  style.fill = componentModel.get('backgroundColor');
  rect = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Rect"]({
    shape: {
      x: rect.x - padding[3],
      y: rect.y - padding[0],
      width: rect.width + padding[1] + padding[3],
      height: rect.height + padding[0] + padding[2],
      r: componentModel.get('borderRadius')
    },
    style: style,
    silent: true,
    z2: -1
  }); // FIXME
  // `subPixelOptimizeRect` may bring some gap between edge of viewpart
  // and background rect when setting like `left: 0`, `top: 0`.
  // graphic.subPixelOptimizeRect(rect);

  return rect;
}

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_Model_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_Component_js__ = __webpack_require__(21);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






var getDefaultSelectorOptions = function (ecModel, type) {
  if (type === 'all') {
    return {
      type: 'all',
      title: ecModel.getLocaleModel().get(['legend', 'selector', 'all'])
    };
  } else if (type === 'inverse') {
    return {
      type: 'inverse',
      title: ecModel.getLocaleModel().get(['legend', 'selector', 'inverse'])
    };
  }
};

var LegendModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(LegendModel, _super);

  function LegendModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = LegendModel.type;
    _this.layoutMode = {
      type: 'box',
      // legend.width/height are maxWidth/maxHeight actually,
      // whereas realy width/height is calculated by its content.
      // (Setting {left: 10, right: 10} does not make sense).
      // So consider the case:
      // `setOption({legend: {left: 10});`
      // then `setOption({legend: {right: 10});`
      // The previous `left` should be cleared by setting `ignoreSize`.
      ignoreSize: true
    };
    return _this;
  }

  LegendModel.prototype.init = function (option, parentModel, ecModel) {
    this.mergeDefaultAndTheme(option, ecModel);
    option.selected = option.selected || {};

    this._updateSelector(option);
  };

  LegendModel.prototype.mergeOption = function (option, ecModel) {
    _super.prototype.mergeOption.call(this, option, ecModel);

    this._updateSelector(option);
  };

  LegendModel.prototype._updateSelector = function (option) {
    var selector = option.selector;
    var ecModel = this.ecModel;

    if (selector === true) {
      selector = option.selector = ['all', 'inverse'];
    }

    if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](selector)) {
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](selector, function (item, index) {
        __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"](item) && (item = {
          type: item
        });
        selector[index] = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"](item, getDefaultSelectorOptions(ecModel, item.type));
      });
    }
  };

  LegendModel.prototype.optionUpdated = function () {
    this._updateData(this.ecModel);

    var legendData = this._data; // If selectedMode is single, try to select one

    if (legendData[0] && this.get('selectedMode') === 'single') {
      var hasSelected = false; // If has any selected in option.selected

      for (var i = 0; i < legendData.length; i++) {
        var name_1 = legendData[i].get('name');

        if (this.isSelected(name_1)) {
          // Force to unselect others
          this.select(name_1);
          hasSelected = true;
          break;
        }
      } // Try select the first if selectedMode is single


      !hasSelected && this.select(legendData[0].get('name'));
    }
  };

  LegendModel.prototype._updateData = function (ecModel) {
    var potentialData = [];
    var availableNames = [];
    ecModel.eachRawSeries(function (seriesModel) {
      var seriesName = seriesModel.name;
      availableNames.push(seriesName);
      var isPotential;

      if (seriesModel.legendVisualProvider) {
        var provider = seriesModel.legendVisualProvider;
        var names = provider.getAllNames();

        if (!ecModel.isSeriesFiltered(seriesModel)) {
          availableNames = availableNames.concat(names);
        }

        if (names.length) {
          potentialData = potentialData.concat(names);
        } else {
          isPotential = true;
        }
      } else {
        isPotential = true;
      }

      if (isPotential && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_model_js__["f" /* isNameSpecified */])(seriesModel)) {
        potentialData.push(seriesModel.name);
      }
    });
    /**
     * @type {Array.<string>}
     * @private
     */

    this._availableNames = availableNames; // If legend.data not specified in option, use availableNames as data,
    // which is convinient for user preparing option.

    var rawData = this.get('data') || potentialData;
    var legendData = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"](rawData, function (dataItem) {
      // Can be string or number
      if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"](dataItem) || __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isNumber"](dataItem)) {
        dataItem = {
          name: dataItem
        };
      }

      return new __WEBPACK_IMPORTED_MODULE_2__model_Model_js__["a" /* default */](dataItem, this, this.ecModel);
    }, this);
    /**
     * @type {Array.<module:echarts/model/Model>}
     * @private
     */

    this._data = legendData;
  };

  LegendModel.prototype.getData = function () {
    return this._data;
  };

  LegendModel.prototype.select = function (name) {
    var selected = this.option.selected;
    var selectedMode = this.get('selectedMode');

    if (selectedMode === 'single') {
      var data = this._data;
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](data, function (dataItem) {
        selected[dataItem.get('name')] = false;
      });
    }

    selected[name] = true;
  };

  LegendModel.prototype.unSelect = function (name) {
    if (this.get('selectedMode') !== 'single') {
      this.option.selected[name] = false;
    }
  };

  LegendModel.prototype.toggleSelected = function (name) {
    var selected = this.option.selected; // Default is true

    if (!selected.hasOwnProperty(name)) {
      selected[name] = true;
    }

    this[selected[name] ? 'unSelect' : 'select'](name);
  };

  LegendModel.prototype.allSelect = function () {
    var data = this._data;
    var selected = this.option.selected;
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](data, function (dataItem) {
      selected[dataItem.get('name', true)] = true;
    });
  };

  LegendModel.prototype.inverseSelect = function () {
    var data = this._data;
    var selected = this.option.selected;
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](data, function (dataItem) {
      var name = dataItem.get('name', true); // Initially, default value is true

      if (!selected.hasOwnProperty(name)) {
        selected[name] = true;
      }

      selected[name] = !selected[name];
    });
  };

  LegendModel.prototype.isSelected = function (name) {
    var selected = this.option.selected;
    return !(selected.hasOwnProperty(name) && !selected[name]) && __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["indexOf"](this._availableNames, name) >= 0;
  };

  LegendModel.prototype.getOrient = function () {
    return this.get('orient') === 'vertical' ? {
      index: 1,
      name: 'vertical'
    } : {
      index: 0,
      name: 'horizontal'
    };
  };

  LegendModel.type = 'legend.plain';
  LegendModel.dependencies = ['series'];
  LegendModel.defaultOption = {
    // zlevel: 0,
    z: 4,
    show: true,
    orient: 'horizontal',
    left: 'center',
    // right: 'center',
    top: 0,
    // bottom: null,
    align: 'auto',
    backgroundColor: 'rgba(0,0,0,0)',
    borderColor: '#ccc',
    borderRadius: 0,
    borderWidth: 0,
    padding: 5,
    itemGap: 10,
    itemWidth: 25,
    itemHeight: 14,
    symbolRotate: 'inherit',
    symbolKeepAspect: true,
    inactiveColor: '#ccc',
    inactiveBorderColor: '#ccc',
    inactiveBorderWidth: 'auto',
    itemStyle: {
      color: 'inherit',
      opacity: 'inherit',
      borderColor: 'inherit',
      borderWidth: 'auto',
      borderCap: 'inherit',
      borderJoin: 'inherit',
      borderDashOffset: 'inherit',
      borderMiterLimit: 'inherit'
    },
    lineStyle: {
      width: 'auto',
      color: 'inherit',
      inactiveColor: '#ccc',
      inactiveWidth: 2,
      opacity: 'inherit',
      type: 'inherit',
      cap: 'inherit',
      join: 'inherit',
      dashOffset: 'inherit',
      miterLimit: 'inherit'
    },
    textStyle: {
      color: '#333'
    },
    selectedMode: true,
    selector: false,
    selectorLabel: {
      show: true,
      borderRadius: 10,
      padding: [3, 5, 3, 5],
      fontSize: 12,
      fontFamily: 'sans-serif',
      color: '#666',
      borderWidth: 1,
      borderColor: '#666'
    },
    emphasis: {
      selectorLabel: {
        show: true,
        color: '#eee',
        backgroundColor: '#666'
      }
    },
    selectorPosition: 'auto',
    selectorItemGap: 7,
    selectorButtonGap: 10,
    tooltip: {
      show: false
    }
  };
  return LegendModel;
}(__WEBPACK_IMPORTED_MODULE_4__model_Component_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (LegendModel);

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_tool_color_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_listComponent_js__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__view_Component_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_symbol_js__ = __webpack_require__(37);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/










var curry = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["curry"];
var each = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"];
var Group = __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Group"];

var LegendView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(LegendView, _super);

  function LegendView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = LegendView.type;
    _this.newlineDisabled = false;
    return _this;
  }

  LegendView.prototype.init = function () {
    this.group.add(this._contentGroup = new Group());
    this.group.add(this._selectorGroup = new Group());
    this._isFirstRender = true;
  };
  /**
   * @protected
   */


  LegendView.prototype.getContentGroup = function () {
    return this._contentGroup;
  };
  /**
   * @protected
   */


  LegendView.prototype.getSelectorGroup = function () {
    return this._selectorGroup;
  };
  /**
   * @override
   */


  LegendView.prototype.render = function (legendModel, ecModel, api) {
    var isFirstRender = this._isFirstRender;
    this._isFirstRender = false;
    this.resetInner();

    if (!legendModel.get('show', true)) {
      return;
    }

    var itemAlign = legendModel.get('align');
    var orient = legendModel.get('orient');

    if (!itemAlign || itemAlign === 'auto') {
      itemAlign = legendModel.get('left') === 'right' && orient === 'vertical' ? 'right' : 'left';
    } // selector has been normalized to an array in model


    var selector = legendModel.get('selector', true);
    var selectorPosition = legendModel.get('selectorPosition', true);

    if (selector && (!selectorPosition || selectorPosition === 'auto')) {
      selectorPosition = orient === 'horizontal' ? 'end' : 'start';
    }

    this.renderInner(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition); // Perform layout.

    var positionInfo = legendModel.getBoxLayoutParams();
    var viewportSize = {
      width: api.getWidth(),
      height: api.getHeight()
    };
    var padding = legendModel.get('padding');
    var maxSize = __WEBPACK_IMPORTED_MODULE_7__util_layout_js__["f" /* getLayoutRect */](positionInfo, viewportSize, padding);
    var mainRect = this.layoutInner(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition); // Place mainGroup, based on the calculated `mainRect`.

    var layoutRect = __WEBPACK_IMPORTED_MODULE_7__util_layout_js__["f" /* getLayoutRect */](__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"]({
      width: mainRect.width,
      height: mainRect.height
    }, positionInfo), viewportSize, padding);
    this.group.x = layoutRect.x - mainRect.x;
    this.group.y = layoutRect.y - mainRect.y;
    this.group.markRedraw(); // Render background after group is layout.

    this.group.add(this._backgroundEl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helper_listComponent_js__["a" /* makeBackground */])(mainRect, legendModel));
  };

  LegendView.prototype.resetInner = function () {
    this.getContentGroup().removeAll();
    this._backgroundEl && this.group.remove(this._backgroundEl);
    this.getSelectorGroup().removeAll();
  };

  LegendView.prototype.renderInner = function (itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
    var contentGroup = this.getContentGroup();
    var legendDrawnMap = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"]();
    var selectMode = legendModel.get('selectedMode');
    var excludeSeriesId = [];
    ecModel.eachRawSeries(function (seriesModel) {
      !seriesModel.get('legendHoverLink') && excludeSeriesId.push(seriesModel.id);
    });
    each(legendModel.getData(), function (legendItemModel, dataIndex) {
      var name = legendItemModel.get('name'); // Use empty string or \n as a newline string

      if (!this.newlineDisabled && (name === '' || name === '\n')) {
        var g = new Group(); // @ts-ignore

        g.newline = true;
        contentGroup.add(g);
        return;
      } // Representitive series.


      var seriesModel = ecModel.getSeriesByName(name)[0];

      if (legendDrawnMap.get(name)) {
        // Have been drawed
        return;
      } // Legend to control series.


      if (seriesModel) {
        var data = seriesModel.getData();
        var lineVisualStyle = data.getVisual('legendLineStyle') || {};
        var legendIcon = data.getVisual('legendIcon');
        /**
         * `data.getVisual('style')` may be the color from the register
         * in series. For example, for line series,
         */

        var style = data.getVisual('style');

        var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, style, legendIcon, selectMode);

        itemGroup.on('click', curry(dispatchSelectAction, name, null, api, excludeSeriesId)).on('mouseover', curry(dispatchHighlightAction, seriesModel.name, null, api, excludeSeriesId)).on('mouseout', curry(dispatchDownplayAction, seriesModel.name, null, api, excludeSeriesId));
        legendDrawnMap.set(name, true);
      } else {
        // Legend to control data. In pie and funnel.
        ecModel.eachRawSeries(function (seriesModel) {
          // In case multiple series has same data name
          if (legendDrawnMap.get(name)) {
            return;
          }

          if (seriesModel.legendVisualProvider) {
            var provider = seriesModel.legendVisualProvider;

            if (!provider.containName(name)) {
              return;
            }

            var idx = provider.indexOfName(name);
            var style = provider.getItemVisual(idx, 'style');
            var legendIcon = provider.getItemVisual(idx, 'legendIcon');
            var colorArr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_tool_color_js__["parse"])(style.fill); // Color may be set to transparent in visualMap when data is out of range.
            // Do not show nothing.

            if (colorArr && colorArr[3] === 0) {
              colorArr[3] = 0.2; // TODO color is set to 0, 0, 0, 0. Should show correct RGBA

              style = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"](__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"]({}, style), {
                fill: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_tool_color_js__["stringify"])(colorArr, 'rgba')
              });
            }

            var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, {}, style, legendIcon, selectMode); // FIXME: consider different series has items with the same name.


            itemGroup.on('click', curry(dispatchSelectAction, null, name, api, excludeSeriesId)) // Should not specify the series name, consider legend controls
            // more than one pie series.
            .on('mouseover', curry(dispatchHighlightAction, null, name, api, excludeSeriesId)).on('mouseout', curry(dispatchDownplayAction, null, name, api, excludeSeriesId));
            legendDrawnMap.set(name, true);
          }
        }, this);
      }

      if (true) {
        if (!legendDrawnMap.get(name)) {
          console.warn(name + ' series not exists. Legend data should be same with series name or data name.');
        }
      }
    }, this);

    if (selector) {
      this._createSelector(selector, legendModel, api, orient, selectorPosition);
    }
  };

  LegendView.prototype._createSelector = function (selector, legendModel, api, orient, selectorPosition) {
    var selectorGroup = this.getSelectorGroup();
    each(selector, function createSelectorButton(selectorItem) {
      var type = selectorItem.type;
      var labelText = new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Text"]({
        style: {
          x: 0,
          y: 0,
          align: 'center',
          verticalAlign: 'middle'
        },
        onclick: function () {
          api.dispatchAction({
            type: type === 'all' ? 'legendAllSelect' : 'legendInverseSelect'
          });
        }
      });
      selectorGroup.add(labelText);
      var labelModel = legendModel.getModel('selectorLabel');
      var emphasisLabelModel = legendModel.getModel(['emphasis', 'selectorLabel']);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__label_labelStyle_js__["e" /* setLabelStyle */])(labelText, {
        normal: labelModel,
        emphasis: emphasisLabelModel
      }, {
        defaultText: selectorItem.title
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_states_js__["d" /* enableHoverEmphasis */])(labelText);
    });
  };

  LegendView.prototype._createItem = function (seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, itemVisualStyle, legendIcon, selectMode) {
    var drawType = seriesModel.visualDrawType;
    var itemWidth = legendModel.get('itemWidth');
    var itemHeight = legendModel.get('itemHeight');
    var isSelected = legendModel.isSelected(name);
    var iconRotate = legendItemModel.get('symbolRotate');
    var symbolKeepAspect = legendItemModel.get('symbolKeepAspect');
    var legendIconType = legendItemModel.get('icon');
    legendIcon = legendIconType || legendIcon || 'roundRect';
    var style = getLegendStyle(legendIcon, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected);
    var itemGroup = new Group();
    var textStyleModel = legendItemModel.getModel('textStyle');

    if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isFunction"](seriesModel.getLegendIcon) && (!legendIconType || legendIconType === 'inherit')) {
      // Series has specific way to define legend icon
      itemGroup.add(seriesModel.getLegendIcon({
        itemWidth: itemWidth,
        itemHeight: itemHeight,
        icon: legendIcon,
        iconRotate: iconRotate,
        itemStyle: style.itemStyle,
        lineStyle: style.lineStyle,
        symbolKeepAspect: symbolKeepAspect
      }));
    } else {
      // Use default legend icon policy for most series
      var rotate = legendIconType === 'inherit' && seriesModel.getData().getVisual('symbol') ? iconRotate === 'inherit' ? seriesModel.getData().getVisual('symbolRotate') : iconRotate : 0; // No rotation for no icon

      itemGroup.add(getDefaultLegendIcon({
        itemWidth: itemWidth,
        itemHeight: itemHeight,
        icon: legendIcon,
        iconRotate: rotate,
        itemStyle: style.itemStyle,
        lineStyle: style.lineStyle,
        symbolKeepAspect: symbolKeepAspect
      }));
    }

    var textX = itemAlign === 'left' ? itemWidth + 5 : -5;
    var textAlign = itemAlign;
    var formatter = legendModel.get('formatter');
    var content = name;

    if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"](formatter) && formatter) {
      content = formatter.replace('{name}', name != null ? name : '');
    } else if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isFunction"](formatter)) {
      content = formatter(name);
    }

    var inactiveColor = legendItemModel.get('inactiveColor');
    itemGroup.add(new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Text"]({
      style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__label_labelStyle_js__["d" /* createTextStyle */])(textStyleModel, {
        text: content,
        x: textX,
        y: itemHeight / 2,
        fill: isSelected ? textStyleModel.getTextColor() : inactiveColor,
        align: textAlign,
        verticalAlign: 'middle'
      })
    })); // Add a invisible rect to increase the area of mouse hover

    var hitRect = new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Rect"]({
      shape: itemGroup.getBoundingRect(),
      invisible: true
    });
    var tooltipModel = legendItemModel.getModel('tooltip');

    if (tooltipModel.get('show')) {
      __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["setTooltipConfig"]({
        el: hitRect,
        componentModel: legendModel,
        itemName: name,
        itemTooltipOption: tooltipModel.option
      });
    }

    itemGroup.add(hitRect);
    itemGroup.eachChild(function (child) {
      child.silent = true;
    });
    hitRect.silent = !selectMode;
    this.getContentGroup().add(itemGroup);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_states_js__["d" /* enableHoverEmphasis */])(itemGroup); // @ts-ignore

    itemGroup.__legendDataIndex = dataIndex;
    return itemGroup;
  };

  LegendView.prototype.layoutInner = function (legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
    var contentGroup = this.getContentGroup();
    var selectorGroup = this.getSelectorGroup(); // Place items in contentGroup.

    __WEBPACK_IMPORTED_MODULE_7__util_layout_js__["d" /* box */](legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), maxSize.width, maxSize.height);
    var contentRect = contentGroup.getBoundingRect();
    var contentPos = [-contentRect.x, -contentRect.y];
    selectorGroup.markRedraw();
    contentGroup.markRedraw();

    if (selector) {
      // Place buttons in selectorGroup
      __WEBPACK_IMPORTED_MODULE_7__util_layout_js__["d" /* box */]( // Buttons in selectorGroup always layout horizontally
      'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
      var selectorRect = selectorGroup.getBoundingRect();
      var selectorPos = [-selectorRect.x, -selectorRect.y];
      var selectorButtonGap = legendModel.get('selectorButtonGap', true);
      var orientIdx = legendModel.getOrient().index;
      var wh = orientIdx === 0 ? 'width' : 'height';
      var hw = orientIdx === 0 ? 'height' : 'width';
      var yx = orientIdx === 0 ? 'y' : 'x';

      if (selectorPosition === 'end') {
        selectorPos[orientIdx] += contentRect[wh] + selectorButtonGap;
      } else {
        contentPos[orientIdx] += selectorRect[wh] + selectorButtonGap;
      } //Always align selector to content as 'middle'


      selectorPos[1 - orientIdx] += contentRect[hw] / 2 - selectorRect[hw] / 2;
      selectorGroup.x = selectorPos[0];
      selectorGroup.y = selectorPos[1];
      contentGroup.x = contentPos[0];
      contentGroup.y = contentPos[1];
      var mainRect = {
        x: 0,
        y: 0
      };
      mainRect[wh] = contentRect[wh] + selectorButtonGap + selectorRect[wh];
      mainRect[hw] = Math.max(contentRect[hw], selectorRect[hw]);
      mainRect[yx] = Math.min(0, selectorRect[yx] + selectorPos[1 - orientIdx]);
      return mainRect;
    } else {
      contentGroup.x = contentPos[0];
      contentGroup.y = contentPos[1];
      return this.group.getBoundingRect();
    }
  };
  /**
   * @protected
   */


  LegendView.prototype.remove = function () {
    this.getContentGroup().removeAll();
    this._isFirstRender = true;
  };

  LegendView.type = 'legend.plain';
  return LegendView;
}(__WEBPACK_IMPORTED_MODULE_8__view_Component_js__["a" /* default */]);

function getLegendStyle(iconType, legendModel, lineVisualStyle, itemVisualStyle, drawType, isSelected) {
  /**
   * Use series style if is inherit;
   * elsewise, use legend style
   */
  function handleCommonProps(style, visualStyle) {
    // If lineStyle.width is 'auto', it is set to be 2 if series has border
    if (style.lineWidth === 'auto') {
      style.lineWidth = visualStyle.lineWidth > 0 ? 2 : 0;
    }

    each(style, function (propVal, propName) {
      style[propName] === 'inherit' && (style[propName] = visualStyle[propName]);
    });
  } // itemStyle


  var legendItemModel = legendModel.getModel('itemStyle');
  var itemStyle = legendItemModel.getItemStyle();
  var iconBrushType = iconType.lastIndexOf('empty', 0) === 0 ? 'fill' : 'stroke';
  itemStyle.decal = itemVisualStyle.decal;

  if (itemStyle.fill === 'inherit') {
    /**
     * Series with visualDrawType as 'stroke' should have
     * series stroke as legend fill
     */
    itemStyle.fill = itemVisualStyle[drawType];
  }

  if (itemStyle.stroke === 'inherit') {
    /**
     * icon type with "emptyXXX" should use fill color
     * in visual style
     */
    itemStyle.stroke = itemVisualStyle[iconBrushType];
  }

  if (itemStyle.opacity === 'inherit') {
    /**
     * Use lineStyle.opacity if drawType is stroke
     */
    itemStyle.opacity = (drawType === 'fill' ? itemVisualStyle : lineVisualStyle).opacity;
  }

  handleCommonProps(itemStyle, itemVisualStyle); // lineStyle

  var legendLineModel = legendModel.getModel('lineStyle');
  var lineStyle = legendLineModel.getLineStyle();
  handleCommonProps(lineStyle, lineVisualStyle); // Fix auto color to real color

  itemStyle.fill === 'auto' && (itemStyle.fill = itemVisualStyle.fill);
  itemStyle.stroke === 'auto' && (itemStyle.stroke = itemVisualStyle.fill);
  lineStyle.stroke === 'auto' && (lineStyle.stroke = itemVisualStyle.fill);

  if (!isSelected) {
    var borderWidth = legendModel.get('inactiveBorderWidth');
    /**
     * Since stroke is set to be inactiveBorderColor, it may occur that
     * there is no border in series but border in legend, so we need to
     * use border only when series has border if is set to be auto
     */

    var visualHasBorder = itemStyle[iconBrushType];
    itemStyle.lineWidth = borderWidth === 'auto' ? itemVisualStyle.lineWidth > 0 && visualHasBorder ? 2 : 0 : itemStyle.lineWidth;
    itemStyle.fill = legendModel.get('inactiveColor');
    itemStyle.stroke = legendModel.get('inactiveBorderColor');
    lineStyle.stroke = legendLineModel.get('inactiveColor');
    lineStyle.lineWidth = legendLineModel.get('inactiveWidth');
  }

  return {
    itemStyle: itemStyle,
    lineStyle: lineStyle
  };
}

function getDefaultLegendIcon(opt) {
  var symboType = opt.icon || 'roundRect';
  var icon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_symbol_js__["a" /* createSymbol */])(symboType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill, opt.symbolKeepAspect);
  icon.setStyle(opt.itemStyle);
  icon.rotation = (opt.iconRotate || 0) * Math.PI / 180;
  icon.setOrigin([opt.itemWidth / 2, opt.itemHeight / 2]);

  if (symboType.indexOf('empty') > -1) {
    icon.style.stroke = icon.style.fill;
    icon.style.fill = '#fff';
    icon.style.lineWidth = 2;
  }

  return icon;
}

function dispatchSelectAction(seriesName, dataName, api, excludeSeriesId) {
  // downplay before unselect
  dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId);
  api.dispatchAction({
    type: 'legendToggleSelect',
    name: seriesName != null ? seriesName : dataName
  }); // highlight after select
  // TODO higlight immediately may cause animation loss.

  dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId);
}

function isUseHoverLayer(api) {
  var list = api.getZr().storage.getDisplayList();
  var emphasisState;
  var i = 0;
  var len = list.length;

  while (i < len && !(emphasisState = list[i].states.emphasis)) {
    i++;
  }

  return emphasisState && emphasisState.hoverLayer;
}

function dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId) {
  // If element hover will move to a hoverLayer.
  if (!isUseHoverLayer(api)) {
    api.dispatchAction({
      type: 'highlight',
      seriesName: seriesName,
      name: dataName,
      excludeSeriesId: excludeSeriesId
    });
  }
}

function dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId) {
  // If element hover will move to a hoverLayer.
  if (!isUseHoverLayer(api)) {
    api.dispatchAction({
      type: 'downplay',
      seriesName: seriesName,
      name: dataName,
      excludeSeriesId: excludeSeriesId
    });
  }
}

/* harmony default export */ __webpack_exports__["a"] = (LegendView);

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extension_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__installLegendPlain_js__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScrollableLegendModel_js__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ScrollableLegendView_js__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scrollableLegendAction_js__ = __webpack_require__(1237);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





function install(registers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_1__installLegendPlain_js__["a" /* install */]);
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_2__ScrollableLegendModel_js__["a" /* default */]);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_3__ScrollableLegendView_js__["a" /* default */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__scrollableLegendAction_js__["a" /* default */])(registers);
}

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coord_parallel_parallelPreprocessor_js__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ParallelView_js__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__coord_parallel_ParallelModel_js__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__coord_parallel_parallelCreator_js__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__coord_axisModelCreator_js__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__coord_parallel_AxisModel_js__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__axis_ParallelAxisView_js__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__axis_parallelAxisAction_js__ = __webpack_require__(1201);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/








var defaultAxisOption = {
  type: 'value',
  areaSelectStyle: {
    width: 20,
    borderWidth: 1,
    borderColor: 'rgba(160,197,232)',
    color: 'rgba(160,197,232)',
    opacity: 0.3
  },
  realtime: true,
  z: 10
};
function install(registers) {
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_1__ParallelView_js__["a" /* default */]);
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_2__coord_parallel_ParallelModel_js__["a" /* default */]);
  registers.registerCoordinateSystem('parallel', __WEBPACK_IMPORTED_MODULE_3__coord_parallel_parallelCreator_js__["a" /* default */]);
  registers.registerPreprocessor(__WEBPACK_IMPORTED_MODULE_0__coord_parallel_parallelPreprocessor_js__["a" /* default */]);
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_5__coord_parallel_AxisModel_js__["a" /* default */]);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_6__axis_ParallelAxisView_js__["a" /* default */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__coord_axisModelCreator_js__["a" /* default */])(registers, 'parallel', __WEBPACK_IMPORTED_MODULE_5__coord_parallel_AxisModel_js__["a" /* default */], defaultAxisOption);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__axis_parallelAxisAction_js__["a" /* installParallelActions */])(registers);
}

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coord_radar_RadarModel_js__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RadarView_js__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__coord_radar_Radar_js__ = __webpack_require__(1319);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



function install(registers) {
  registers.registerCoordinateSystem('radar', __WEBPACK_IMPORTED_MODULE_2__coord_radar_Radar_js__["a" /* default */]);
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_0__coord_radar_RadarModel_js__["a" /* default */]);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_1__RadarView_js__["a" /* default */]);
  registers.registerVisual({
    seriesType: 'radar',
    reset: function (seriesModel) {
      var data = seriesModel.getData(); // itemVisual symbol is for selected data

      data.each(function (idx) {
        data.setItemVisual(idx, 'legendIcon', 'roundRect');
      }); // visual is for unselected data

      data.setVisual('legendIcon', 'roundRect');
    }
  });
}

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shouldTooltipConfine;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRANSFORM_VENDOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRANSITION_VENDOR; });
/* harmony export (immutable) */ __webpack_exports__["b"] = toCSSVendorPrefix;
/* harmony export (immutable) */ __webpack_exports__["e"] = getComputedStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_format_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_env_js__ = __webpack_require__(35);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/* global document */

function shouldTooltipConfine(tooltipModel) {
  var confineOption = tooltipModel.get('confine');
  return confineOption != null ? !!confineOption // In richText mode, the outside part can not be visible.
  : tooltipModel.get('renderMode') === 'richText';
}

function testStyle(styleProps) {
  if (!__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_env_js__["a" /* default */].domSupported) {
    return;
  }

  var style = document.documentElement.style;

  for (var i = 0, len = styleProps.length; i < len; i++) {
    if (styleProps[i] in style) {
      return styleProps[i];
    }
  }
}

var TRANSFORM_VENDOR = testStyle(['transform', 'webkitTransform', 'OTransform', 'MozTransform', 'msTransform']);
var TRANSITION_VENDOR = testStyle(['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);
function toCSSVendorPrefix(styleVendor, styleProp) {
  if (!styleVendor) {
    return styleProp;
  }

  styleProp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_format_js__["i" /* toCamelCase */])(styleProp, true);
  var idx = styleVendor.indexOf(styleProp);
  styleVendor = idx === -1 ? styleProp : "-" + styleVendor.slice(0, idx) + "-" + styleProp;
  return styleVendor.toLowerCase();
}
function getComputedStyle(el, style) {
  var stl = el.currentStyle || document.defaultView && document.defaultView.getComputedStyle(el);
  return stl ? style ? stl[style] : stl : null;
}

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultSeriesFormatTooltip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tooltipMarkup_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_helper_dataProvider_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




function defaultSeriesFormatTooltip(opt) {
  var series = opt.series;
  var dataIndex = opt.dataIndex;
  var multipleSeries = opt.multipleSeries;
  var data = series.getData();
  var tooltipDims = data.mapDimensionsAll('defaultedTooltip');
  var tooltipDimLen = tooltipDims.length;
  var value = series.getRawValue(dataIndex);
  var isValueArr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"])(value);
  var markerColor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tooltipMarkup_js__["a" /* retrieveVisualColorForTooltipMarker */])(series, dataIndex); // Complicated rule for pretty tooltip.

  var inlineValue;
  var inlineValueType;
  var subBlocks;
  var sortParam;

  if (tooltipDimLen > 1 || isValueArr && !tooltipDimLen) {
    var formatArrResult = formatTooltipArrayValue(value, series, dataIndex, tooltipDims, markerColor);
    inlineValue = formatArrResult.inlineValues;
    inlineValueType = formatArrResult.inlineValueTypes;
    subBlocks = formatArrResult.blocks; // Only support tooltip sort by the first inline value. It's enough in most cases.

    sortParam = formatArrResult.inlineValues[0];
  } else if (tooltipDimLen) {
    var dimInfo = data.getDimensionInfo(tooltipDims[0]);
    sortParam = inlineValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_helper_dataProvider_js__["a" /* retrieveRawValue */])(data, dataIndex, tooltipDims[0]);
    inlineValueType = dimInfo.type;
  } else {
    sortParam = inlineValue = isValueArr ? value[0] : value;
  } // Do not show generated series name. It might not be readable.


  var seriesNameSpecified = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_model_js__["f" /* isNameSpecified */])(series);
  var seriesName = seriesNameSpecified && series.name || '';
  var itemName = data.getName(dataIndex);
  var inlineName = multipleSeries ? seriesName : itemName;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tooltipMarkup_js__["b" /* createTooltipMarkup */])('section', {
    header: seriesName,
    // When series name not specified, do not show a header line with only '-'.
    // This case alway happen in tooltip.trigger: 'item'.
    noHeader: multipleSeries || !seriesNameSpecified,
    sortParam: sortParam,
    blocks: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tooltipMarkup_js__["b" /* createTooltipMarkup */])('nameValue', {
      markerType: 'item',
      markerColor: markerColor,
      // Do not mix display seriesName and itemName in one tooltip,
      // which might confuses users.
      name: inlineName,
      // name dimension might be auto assigned, where the name might
      // be not readable. So we check trim here.
      noName: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["trim"])(inlineName),
      value: inlineValue,
      valueType: inlineValueType
    })].concat(subBlocks || [])
  });
}

function formatTooltipArrayValue(value, series, dataIndex, tooltipDims, colorStr) {
  // check: category-no-encode-has-axis-data in dataset.html
  var data = series.getData();
  var isValueMultipleLine = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["reduce"])(value, function (isValueMultipleLine, val, idx) {
    var dimItem = data.getDimensionInfo(idx);
    return isValueMultipleLine = isValueMultipleLine || dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
  }, false);
  var inlineValues = [];
  var inlineValueTypes = [];
  var blocks = [];
  tooltipDims.length ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(tooltipDims, function (dim) {
    setEachItem(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_helper_dataProvider_js__["a" /* retrieveRawValue */])(data, dataIndex, dim), dim);
  }) // By default, all dims is used on tooltip.
  : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(value, setEachItem);

  function setEachItem(val, dim) {
    var dimInfo = data.getDimensionInfo(dim); // If `dimInfo.tooltip` is not set, show tooltip.

    if (!dimInfo || dimInfo.otherDims.tooltip === false) {
      return;
    }

    if (isValueMultipleLine) {
      blocks.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tooltipMarkup_js__["b" /* createTooltipMarkup */])('nameValue', {
        markerType: 'subItem',
        markerColor: colorStr,
        name: dimInfo.displayName,
        value: val,
        valueType: dimInfo.type
      }));
    } else {
      inlineValues.push(val);
      inlineValueTypes.push(dimInfo.type);
    }
  }

  return {
    inlineValues: inlineValues,
    inlineValueTypes: inlineValueTypes,
    blocks: blocks
  };
}

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__visual_visualDefault_js__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__visual_VisualMapping_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__visual_visualSolution_js__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_Component_js__ = __webpack_require__(21);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/








var mapVisual = __WEBPACK_IMPORTED_MODULE_3__visual_VisualMapping_js__["a" /* default */].mapVisual;
var eachVisual = __WEBPACK_IMPORTED_MODULE_3__visual_VisualMapping_js__["a" /* default */].eachVisual;
var isArray = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"];
var each = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"];
var asc = __WEBPACK_IMPORTED_MODULE_6__util_number_js__["j" /* asc */];
var linearMap = __WEBPACK_IMPORTED_MODULE_6__util_number_js__["h" /* linearMap */];

var VisualMapModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(VisualMapModel, _super);

  function VisualMapModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = VisualMapModel.type;
    _this.stateList = ['inRange', 'outOfRange'];
    _this.replacableOptionKeys = ['inRange', 'outOfRange', 'target', 'controller', 'color'];
    _this.layoutMode = {
      type: 'box',
      ignoreSize: true
    };
    /**
     * [lowerBound, upperBound]
     */

    _this.dataBound = [-Infinity, Infinity];
    _this.targetVisuals = {};
    _this.controllerVisuals = {};
    return _this;
  }

  VisualMapModel.prototype.init = function (option, parentModel, ecModel) {
    this.mergeDefaultAndTheme(option, ecModel);
  };
  /**
   * @protected
   */


  VisualMapModel.prototype.optionUpdated = function (newOption, isInit) {
    var thisOption = this.option;
    !isInit && __WEBPACK_IMPORTED_MODULE_4__visual_visualSolution_js__["b" /* replaceVisualOption */](thisOption, newOption, this.replacableOptionKeys);
    this.textStyleModel = this.getModel('textStyle');
    this.resetItemSize();
    this.completeVisualOption();
  };
  /**
   * @protected
   */


  VisualMapModel.prototype.resetVisual = function (supplementVisualOption) {
    var stateList = this.stateList;
    supplementVisualOption = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"](supplementVisualOption, this);
    this.controllerVisuals = __WEBPACK_IMPORTED_MODULE_4__visual_visualSolution_js__["c" /* createVisualMappings */](this.option.controller, stateList, supplementVisualOption);
    this.targetVisuals = __WEBPACK_IMPORTED_MODULE_4__visual_visualSolution_js__["c" /* createVisualMappings */](this.option.target, stateList, supplementVisualOption);
  };
  /**
   * @public
   */


  VisualMapModel.prototype.getItemSymbol = function () {
    return null;
  };
  /**
   * @protected
   * @return {Array.<number>} An array of series indices.
   */


  VisualMapModel.prototype.getTargetSeriesIndices = function () {
    var optionSeriesIndex = this.option.seriesIndex;
    var seriesIndices = [];

    if (optionSeriesIndex == null || optionSeriesIndex === 'all') {
      this.ecModel.eachSeries(function (seriesModel, index) {
        seriesIndices.push(index);
      });
    } else {
      seriesIndices = __WEBPACK_IMPORTED_MODULE_5__util_model_js__["d" /* normalizeToArray */](optionSeriesIndex);
    }

    return seriesIndices;
  };
  /**
   * @public
   */


  VisualMapModel.prototype.eachTargetSeries = function (callback, context) {
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](this.getTargetSeriesIndices(), function (seriesIndex) {
      var seriesModel = this.ecModel.getSeriesByIndex(seriesIndex);

      if (seriesModel) {
        callback.call(context, seriesModel);
      }
    }, this);
  };
  /**
   * @pubilc
   */


  VisualMapModel.prototype.isTargetSeries = function (seriesModel) {
    var is = false;
    this.eachTargetSeries(function (model) {
      model === seriesModel && (is = true);
    });
    return is;
  };
  /**
   * @example
   * this.formatValueText(someVal); // format single numeric value to text.
   * this.formatValueText(someVal, true); // format single category value to text.
   * this.formatValueText([min, max]); // format numeric min-max to text.
   * this.formatValueText([this.dataBound[0], max]); // using data lower bound.
   * this.formatValueText([min, this.dataBound[1]]); // using data upper bound.
   *
   * @param value Real value, or this.dataBound[0 or 1].
   * @param isCategory Only available when value is number.
   * @param edgeSymbols Open-close symbol when value is interval.
   * @protected
   */


  VisualMapModel.prototype.formatValueText = function (value, isCategory, edgeSymbols) {
    var option = this.option;
    var precision = option.precision;
    var dataBound = this.dataBound;
    var formatter = option.formatter;
    var isMinMax;
    edgeSymbols = edgeSymbols || ['<', '>'];

    if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](value)) {
      value = value.slice();
      isMinMax = true;
    }

    var textValue = isCategory ? value // Value is string when isCategory
    : isMinMax ? [toFixed(value[0]), toFixed(value[1])] : toFixed(value);

    if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"](formatter)) {
      return formatter.replace('{value}', isMinMax ? textValue[0] : textValue).replace('{value2}', isMinMax ? textValue[1] : textValue);
    } else if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isFunction"](formatter)) {
      return isMinMax ? formatter(value[0], value[1]) : formatter(value);
    }

    if (isMinMax) {
      if (value[0] === dataBound[0]) {
        return edgeSymbols[0] + ' ' + textValue[1];
      } else if (value[1] === dataBound[1]) {
        return edgeSymbols[1] + ' ' + textValue[0];
      } else {
        return textValue[0] + ' - ' + textValue[1];
      }
    } else {
      // Format single value (includes category case).
      return textValue;
    }

    function toFixed(val) {
      return val === dataBound[0] ? 'min' : val === dataBound[1] ? 'max' : (+val).toFixed(Math.min(precision, 20));
    }
  };
  /**
   * @protected
   */


  VisualMapModel.prototype.resetExtent = function () {
    var thisOption = this.option; // Can not calculate data extent by data here.
    // Because series and data may be modified in processing stage.
    // So we do not support the feature "auto min/max".

    var extent = asc([thisOption.min, thisOption.max]);
    this._dataExtent = extent;
  };
  /**
   * PENDING:
   * delete this method if no outer usage.
   *
   * Return  Concrete dimention. If return null/undefined, no dimension used.
   */
  // getDataDimension(data: SeriesData) {
  //     const optDim = this.option.dimension;
  //     if (optDim != null) {
  //         return data.getDimension(optDim);
  //     }
  //     const dimNames = data.dimensions;
  //     for (let i = dimNames.length - 1; i >= 0; i--) {
  //         const dimName = dimNames[i];
  //         const dimInfo = data.getDimensionInfo(dimName);
  //         if (!dimInfo.isCalculationCoord) {
  //             return dimName;
  //         }
  //     }
  // }


  VisualMapModel.prototype.getDataDimensionIndex = function (data) {
    var optDim = this.option.dimension;

    if (optDim != null) {
      return data.getDimensionIndex(optDim);
    }

    var dimNames = data.dimensions;

    for (var i = dimNames.length - 1; i >= 0; i--) {
      var dimName = dimNames[i];
      var dimInfo = data.getDimensionInfo(dimName);

      if (!dimInfo.isCalculationCoord) {
        return dimInfo.storeDimIndex;
      }
    }
  };

  VisualMapModel.prototype.getExtent = function () {
    return this._dataExtent.slice();
  };

  VisualMapModel.prototype.completeVisualOption = function () {
    var ecModel = this.ecModel;
    var thisOption = this.option;
    var base = {
      inRange: thisOption.inRange,
      outOfRange: thisOption.outOfRange
    };
    var target = thisOption.target || (thisOption.target = {});
    var controller = thisOption.controller || (thisOption.controller = {});
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"](target, base); // Do not override

    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"](controller, base); // Do not override

    var isCategory = this.isCategory();
    completeSingle.call(this, target);
    completeSingle.call(this, controller);
    completeInactive.call(this, target, 'inRange', 'outOfRange'); // completeInactive.call(this, target, 'outOfRange', 'inRange');

    completeController.call(this, controller);

    function completeSingle(base) {
      // Compatible with ec2 dataRange.color.
      // The mapping order of dataRange.color is: [high value, ..., low value]
      // whereas inRange.color and outOfRange.color is [low value, ..., high value]
      // Notice: ec2 has no inverse.
      if (isArray(thisOption.color) // If there has been inRange: {symbol: ...}, adding color is a mistake.
      // So adding color only when no inRange defined.
      && !base.inRange) {
        base.inRange = {
          color: thisOption.color.slice().reverse()
        };
      } // Compatible with previous logic, always give a defautl color, otherwise
      // simple config with no inRange and outOfRange will not work.
      // Originally we use visualMap.color as the default color, but setOption at
      // the second time the default color will be erased. So we change to use
      // constant DEFAULT_COLOR.
      // If user do not want the default color, set inRange: {color: null}.


      base.inRange = base.inRange || {
        color: ecModel.get('gradientColor')
      };
    }

    function completeInactive(base, stateExist, stateAbsent) {
      var optExist = base[stateExist];
      var optAbsent = base[stateAbsent];

      if (optExist && !optAbsent) {
        optAbsent = base[stateAbsent] = {};
        each(optExist, function (visualData, visualType) {
          if (!__WEBPACK_IMPORTED_MODULE_3__visual_VisualMapping_js__["a" /* default */].isValidType(visualType)) {
            return;
          }

          var defa = __WEBPACK_IMPORTED_MODULE_2__visual_visualDefault_js__["a" /* default */].get(visualType, 'inactive', isCategory);

          if (defa != null) {
            optAbsent[visualType] = defa; // Compatibable with ec2:
            // Only inactive color to rgba(0,0,0,0) can not
            // make label transparent, so use opacity also.

            if (visualType === 'color' && !optAbsent.hasOwnProperty('opacity') && !optAbsent.hasOwnProperty('colorAlpha')) {
              optAbsent.opacity = [0, 0];
            }
          }
        });
      }
    }

    function completeController(controller) {
      var symbolExists = (controller.inRange || {}).symbol || (controller.outOfRange || {}).symbol;
      var symbolSizeExists = (controller.inRange || {}).symbolSize || (controller.outOfRange || {}).symbolSize;
      var inactiveColor = this.get('inactiveColor');
      var itemSymbol = this.getItemSymbol();
      var defaultSymbol = itemSymbol || 'roundRect';
      each(this.stateList, function (state) {
        var itemSize = this.itemSize;
        var visuals = controller[state]; // Set inactive color for controller if no other color
        // attr (like colorAlpha) specified.

        if (!visuals) {
          visuals = controller[state] = {
            color: isCategory ? inactiveColor : [inactiveColor]
          };
        } // Consistent symbol and symbolSize if not specified.


        if (visuals.symbol == null) {
          visuals.symbol = symbolExists && __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"](symbolExists) || (isCategory ? defaultSymbol : [defaultSymbol]);
        }

        if (visuals.symbolSize == null) {
          visuals.symbolSize = symbolSizeExists && __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"](symbolSizeExists) || (isCategory ? itemSize[0] : [itemSize[0], itemSize[0]]);
        } // Filter none


        visuals.symbol = mapVisual(visuals.symbol, function (symbol) {
          return symbol === 'none' ? defaultSymbol : symbol;
        }); // Normalize symbolSize

        var symbolSize = visuals.symbolSize;

        if (symbolSize != null) {
          var max_1 = -Infinity; // symbolSize can be object when categories defined.

          eachVisual(symbolSize, function (value) {
            value > max_1 && (max_1 = value);
          });
          visuals.symbolSize = mapVisual(symbolSize, function (value) {
            return linearMap(value, [0, max_1], [0, itemSize[0]], true);
          });
        }
      }, this);
    }
  };

  VisualMapModel.prototype.resetItemSize = function () {
    this.itemSize = [parseFloat(this.get('itemWidth')), parseFloat(this.get('itemHeight'))];
  };

  VisualMapModel.prototype.isCategory = function () {
    return !!this.option.categories;
  };
  /**
   * @public
   * @abstract
   */


  VisualMapModel.prototype.setSelected = function (selected) {};

  VisualMapModel.prototype.getSelected = function () {
    return null;
  };
  /**
   * @public
   * @abstract
   */


  VisualMapModel.prototype.getValueState = function (value) {
    return null;
  };
  /**
   * FIXME
   * Do not publish to thirt-part-dev temporarily
   * util the interface is stable. (Should it return
   * a function but not visual meta?)
   *
   * @pubilc
   * @abstract
   * @param getColorVisual
   *        params: value, valueState
   *        return: color
   * @return {Object} visualMeta
   *        should includes {stops, outerColors}
   *        outerColor means [colorBeyondMinValue, colorBeyondMaxValue]
   */


  VisualMapModel.prototype.getVisualMeta = function (getColorVisual) {
    return null;
  };

  VisualMapModel.type = 'visualMap';
  VisualMapModel.dependencies = ['series'];
  VisualMapModel.defaultOption = {
    show: true,
    // zlevel: 0,
    z: 4,
    seriesIndex: 'all',
    min: 0,
    max: 200,
    left: 0,
    right: null,
    top: null,
    bottom: 0,
    itemWidth: null,
    itemHeight: null,
    inverse: false,
    orient: 'vertical',
    backgroundColor: 'rgba(0,0,0,0)',
    borderColor: '#ccc',
    contentColor: '#5793f3',
    inactiveColor: '#aaa',
    borderWidth: 0,
    padding: 5,
    // 接受数组分别设定上右下左边距，同css
    textGap: 10,
    precision: 0,
    textStyle: {
      color: '#333' // 值域文字颜色

    }
  };
  return VisualMapModel;
}(__WEBPACK_IMPORTED_MODULE_7__model_Component_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (VisualMapModel);

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_format_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__visual_VisualMapping_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_Component_js__ = __webpack_require__(30);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/








var VisualMapView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(VisualMapView, _super);

  function VisualMapView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = VisualMapView.type;
    _this.autoPositionValues = {
      left: 1,
      right: 1,
      top: 1,
      bottom: 1
    };
    return _this;
  }

  VisualMapView.prototype.init = function (ecModel, api) {
    this.ecModel = ecModel;
    this.api = api;
  };
  /**
   * @protected
   */


  VisualMapView.prototype.render = function (visualMapModel, ecModel, api, payload // TODO: TYPE
  ) {
    this.visualMapModel = visualMapModel;

    if (visualMapModel.get('show') === false) {
      this.group.removeAll();
      return;
    }

    this.doRender(visualMapModel, ecModel, api, payload);
  };
  /**
   * @protected
   */


  VisualMapView.prototype.renderBackground = function (group) {
    var visualMapModel = this.visualMapModel;
    var padding = __WEBPACK_IMPORTED_MODULE_3__util_format_js__["f" /* normalizeCssArray */](visualMapModel.get('padding') || 0);
    var rect = group.getBoundingRect();
    group.add(new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Rect"]({
      z2: -1,
      silent: true,
      shape: {
        x: rect.x - padding[3],
        y: rect.y - padding[0],
        width: rect.width + padding[3] + padding[1],
        height: rect.height + padding[0] + padding[2]
      },
      style: {
        fill: visualMapModel.get('backgroundColor'),
        stroke: visualMapModel.get('borderColor'),
        lineWidth: visualMapModel.get('borderWidth')
      }
    }));
  };
  /**
   * @protected
   * @param targetValue can be Infinity or -Infinity
   * @param visualCluster Only can be 'color' 'opacity' 'symbol' 'symbolSize'
   * @param opts
   * @param opts.forceState Specify state, instead of using getValueState method.
   * @param opts.convertOpacityToAlpha For color gradient in controller widget.
   * @return {*} Visual value.
   */


  VisualMapView.prototype.getControllerVisual = function (targetValue, visualCluster, opts) {
    opts = opts || {};
    var forceState = opts.forceState;
    var visualMapModel = this.visualMapModel;
    var visualObj = {}; // Default values.

    if (visualCluster === 'color') {
      var defaultColor = visualMapModel.get('contentColor');
      visualObj.color = defaultColor;
    }

    function getter(key) {
      return visualObj[key];
    }

    function setter(key, value) {
      visualObj[key] = value;
    }

    var mappings = visualMapModel.controllerVisuals[forceState || visualMapModel.getValueState(targetValue)];
    var visualTypes = __WEBPACK_IMPORTED_MODULE_5__visual_VisualMapping_js__["a" /* default */].prepareVisualTypes(mappings);
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](visualTypes, function (type) {
      var visualMapping = mappings[type];

      if (opts.convertOpacityToAlpha && type === 'opacity') {
        type = 'colorAlpha';
        visualMapping = mappings.__alphaForOpacity;
      }

      if (__WEBPACK_IMPORTED_MODULE_5__visual_VisualMapping_js__["a" /* default */].dependsOn(type, visualCluster)) {
        visualMapping && visualMapping.applyVisual(targetValue, getter, setter);
      }
    });
    return visualObj[visualCluster];
  };

  VisualMapView.prototype.positionGroup = function (group) {
    var model = this.visualMapModel;
    var api = this.api;
    __WEBPACK_IMPORTED_MODULE_4__util_layout_js__["e" /* positionElement */](group, model.getBoxLayoutParams(), {
      width: api.getWidth(),
      height: api.getHeight()
    });
  };

  VisualMapView.prototype.doRender = function (visualMapModel, ecModel, api, payload) {};

  VisualMapView.type = 'visualMap';
  return VisualMapView;
}(__WEBPACK_IMPORTED_MODULE_6__view_Component_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (VisualMapView);

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getItemAlign;
/* harmony export (immutable) */ __webpack_exports__["a"] = makeHighDownBatch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_layout_js__ = __webpack_require__(19);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


var paramsSet = [['left', 'right', 'width'], ['top', 'bottom', 'height']];
/**
 * @param visualMapModel
 * @param api
 * @param itemSize always [short, long]
 * @return {string} 'left' or 'right' or 'top' or 'bottom'
 */

function getItemAlign(visualMapModel, api, itemSize) {
  var modelOption = visualMapModel.option;
  var itemAlign = modelOption.align;

  if (itemAlign != null && itemAlign !== 'auto') {
    return itemAlign;
  } // Auto decision align.


  var ecSize = {
    width: api.getWidth(),
    height: api.getHeight()
  };
  var realIndex = modelOption.orient === 'horizontal' ? 1 : 0;
  var reals = paramsSet[realIndex];
  var fakeValue = [0, null, 10];
  var layoutInput = {};

  for (var i = 0; i < 3; i++) {
    layoutInput[paramsSet[1 - realIndex][i]] = fakeValue[i];
    layoutInput[reals[i]] = i === 2 ? itemSize[0] : modelOption[reals[i]];
  }

  var rParam = [['x', 'width', 3], ['y', 'height', 0]][realIndex];
  var rect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_layout_js__["f" /* getLayoutRect */])(layoutInput, ecSize, modelOption.padding);
  return reals[(rect.margin[rParam[2]] || 0) + rect[rParam[0]] + rect[rParam[1]] * 0.5 < ecSize[rParam[1]] * 0.5 ? 0 : 1];
}
/**
 * Prepare dataIndex for outside usage, where dataIndex means rawIndex, and
 * dataIndexInside means filtered index.
 */
// TODO: TYPE more specified payload types.

function makeHighDownBatch(batch, visualMapModel) {
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](batch || [], function (batchItem) {
    if (batchItem.dataIndex != null) {
      batchItem.dataIndexInside = batchItem.dataIndex;
      batchItem.dataIndex = null;
    }

    batchItem.highlightKey = 'visualMap' + (visualMapModel ? visualMapModel.componentIndex : '');
  });
  return batch;
}

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = installCommon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__visualMapAction_js__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__visualEncoding_js__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__preprocessor_js__ = __webpack_require__(1282);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var installed = false;
function installCommon(registers) {
  if (installed) {
    return;
  }

  installed = true;
  registers.registerSubTypeDefaulter('visualMap', function (option) {
    // Compatible with ec2, when splitNumber === 0, continuous visualMap will be used.
    return !option.categories && (!(option.pieces ? option.pieces.length > 0 : option.splitNumber > 0) || option.calculable) ? 'continuous' : 'piecewise';
  });
  registers.registerAction(__WEBPACK_IMPORTED_MODULE_0__visualMapAction_js__["a" /* visualMapActionInfo */], __WEBPACK_IMPORTED_MODULE_0__visualMapAction_js__["b" /* visualMapActionHander */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(__WEBPACK_IMPORTED_MODULE_1__visualEncoding_js__["a" /* visualMapEncodingHandlers */], function (handler) {
    registers.registerVisual(registers.PRIORITY.VISUAL.COMPONENT, handler);
  });
  registers.registerPreprocessor(__WEBPACK_IMPORTED_MODULE_3__preprocessor_js__["a" /* default */]);
}

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContinuousModel_js__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContinuousView_js__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__installCommon_js__ = __webpack_require__(481);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



function install(registers) {
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_0__ContinuousModel_js__["a" /* default */]);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_1__ContinuousView_js__["a" /* default */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__installCommon_js__["a" /* default */])(registers);
}

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PiecewiseModel_js__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PiecewiseView_js__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__installCommon_js__ = __webpack_require__(481);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



function install(registers) {
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_0__PiecewiseModel_js__["a" /* default */]);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_1__PiecewiseView_js__["a" /* default */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__installCommon_js__["a" /* default */])(registers);
}

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = alignScaleTicks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scale_Interval_js__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axisHelper_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_log_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scale_helper_js__ = __webpack_require__(135);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var mathLog = Math.log;
function alignScaleTicks(scale, axisModel, alignToScale) {
  var intervalScaleProto = __WEBPACK_IMPORTED_MODULE_1__scale_Interval_js__["a" /* default */].prototype; // NOTE: There is a precondition for log scale  here:
  // In log scale we store _interval and _extent of exponent value.
  // So if we use the method of InternalScale to set/get these data.
  // It process the exponent value, which is linear and what we want here.

  var alignToTicks = intervalScaleProto.getTicks.call(alignToScale);
  var alignToNicedTicks = intervalScaleProto.getTicks.call(alignToScale, true);
  var alignToSplitNumber = alignToTicks.length - 1;
  var alignToInterval = intervalScaleProto.getInterval.call(alignToScale);
  var scaleExtent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__axisHelper_js__["h" /* getScaleExtent */])(scale, axisModel);
  var rawExtent = scaleExtent.extent;
  var isMinFixed = scaleExtent.fixMin;
  var isMaxFixed = scaleExtent.fixMax;

  if (scale.type === 'log') {
    var logBase = mathLog(scale.base);
    rawExtent = [mathLog(rawExtent[0]) / logBase, mathLog(rawExtent[1]) / logBase];
  }

  scale.setExtent(rawExtent[0], rawExtent[1]);
  scale.calcNiceExtent({
    splitNumber: alignToSplitNumber,
    fixMin: isMinFixed,
    fixMax: isMaxFixed
  });
  var extent = intervalScaleProto.getExtent.call(scale); // Need to update the rawExtent.
  // Because value in rawExtent may be not parsed. e.g. 'dataMin', 'dataMax'

  if (isMinFixed) {
    rawExtent[0] = extent[0];
  }

  if (isMaxFixed) {
    rawExtent[1] = extent[1];
  }

  var interval = intervalScaleProto.getInterval.call(scale);
  var min = rawExtent[0];
  var max = rawExtent[1];

  if (isMinFixed && isMaxFixed) {
    // User set min, max, divide to get new interval
    interval = (max - min) / alignToSplitNumber;
  } else if (isMinFixed) {
    max = rawExtent[0] + interval * alignToSplitNumber; // User set min, expand extent on the other side

    while (max < rawExtent[1] && isFinite(max) && isFinite(rawExtent[1])) {
      interval = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__scale_helper_js__["f" /* increaseInterval */])(interval);
      max = rawExtent[0] + interval * alignToSplitNumber;
    }
  } else if (isMaxFixed) {
    // User set max, expand extent on the other side
    min = rawExtent[1] - interval * alignToSplitNumber;

    while (min > rawExtent[0] && isFinite(min) && isFinite(rawExtent[0])) {
      interval = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__scale_helper_js__["f" /* increaseInterval */])(interval);
      min = rawExtent[1] - interval * alignToSplitNumber;
    }
  } else {
    var nicedSplitNumber = scale.getTicks().length - 1;

    if (nicedSplitNumber > alignToSplitNumber) {
      interval = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__scale_helper_js__["f" /* increaseInterval */])(interval);
    }

    var range = interval * alignToSplitNumber;
    max = Math.ceil(rawExtent[1] / interval) * interval;
    min = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["d" /* round */])(max - range); // Not change the result that crossing zero.

    if (min < 0 && rawExtent[0] >= 0) {
      min = 0;
      max = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["d" /* round */])(range);
    } else if (max > 0 && rawExtent[1] <= 0) {
      max = 0;
      min = -__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["d" /* round */])(range);
    }
  } // Adjust min, max based on the extent of alignTo. When min or max is set in alignTo scale


  var t0 = (alignToTicks[0].value - alignToNicedTicks[0].value) / alignToInterval;
  var t1 = (alignToTicks[alignToSplitNumber].value - alignToNicedTicks[alignToSplitNumber].value) / alignToInterval; // NOTE: Must in setExtent -> setInterval -> setNiceExtent order.

  intervalScaleProto.setExtent.call(scale, min + interval * t0, max + interval * t1);
  intervalScaleProto.setInterval.call(scale, interval);

  if (t0 || t1) {
    intervalScaleProto.setNiceExtent.call(scale, min + interval, max - interval);
  }

  if (true) {
    var ticks = intervalScaleProto.getTicks.call(scale);

    if (ticks[1] && (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__scale_helper_js__["g" /* isValueNice */])(interval) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["s" /* getPrecisionSafe */])(ticks[1].value) > __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["s" /* getPrecisionSafe */])(interval))) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_log_js__["b" /* warn */])( // eslint-disable-next-line
      "The ticks may be not readable when set min: " + axisModel.get('min') + ", max: " + axisModel.get('max') + " and alignTicks: true");
    }
  }
}

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var defaultOption = {
  show: true,
  // zlevel: 0,
  z: 0,
  // Inverse the axis.
  inverse: false,
  // Axis name displayed.
  name: '',
  // 'start' | 'middle' | 'end'
  nameLocation: 'end',
  // By degree. By default auto rotate by nameLocation.
  nameRotate: null,
  nameTruncate: {
    maxWidth: null,
    ellipsis: '...',
    placeholder: '.'
  },
  // Use global text style by default.
  nameTextStyle: {},
  // The gap between axisName and axisLine.
  nameGap: 15,
  // Default `false` to support tooltip.
  silent: false,
  // Default `false` to avoid legacy user event listener fail.
  triggerEvent: false,
  tooltip: {
    show: false
  },
  axisPointer: {},
  axisLine: {
    show: true,
    onZero: true,
    onZeroAxisIndex: null,
    lineStyle: {
      color: '#6E7079',
      width: 1,
      type: 'solid'
    },
    // The arrow at both ends the the axis.
    symbol: ['none', 'none'],
    symbolSize: [10, 15]
  },
  axisTick: {
    show: true,
    // Whether axisTick is inside the grid or outside the grid.
    inside: false,
    // The length of axisTick.
    length: 5,
    lineStyle: {
      width: 1
    }
  },
  axisLabel: {
    show: true,
    // Whether axisLabel is inside the grid or outside the grid.
    inside: false,
    rotate: 0,
    // true | false | null/undefined (auto)
    showMinLabel: null,
    // true | false | null/undefined (auto)
    showMaxLabel: null,
    margin: 8,
    // formatter: null,
    fontSize: 12
  },
  splitLine: {
    show: true,
    lineStyle: {
      color: ['#E0E6F1'],
      width: 1,
      type: 'solid'
    }
  },
  splitArea: {
    show: false,
    areaStyle: {
      color: ['rgba(250,250,250,0.2)', 'rgba(210,219,238,0.2)']
    }
  }
};
var categoryAxis = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["merge"]({
  // The gap at both ends of the axis. For categoryAxis, boolean.
  boundaryGap: true,
  // Set false to faster category collection.
  deduplication: null,
  // splitArea: {
  // show: false
  // },
  splitLine: {
    show: false
  },
  axisTick: {
    // If tick is align with label when boundaryGap is true
    alignWithLabel: false,
    interval: 'auto'
  },
  axisLabel: {
    interval: 'auto'
  }
}, defaultOption);
var valueAxis = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["merge"]({
  boundaryGap: [0, 0],
  axisLine: {
    // Not shown when other axis is categoryAxis in cartesian
    show: 'auto'
  },
  axisTick: {
    // Not shown when other axis is categoryAxis in cartesian
    show: 'auto'
  },
  // TODO
  // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
  splitNumber: 5,
  minorTick: {
    // Minor tick, not available for cateogry axis.
    show: false,
    // Split number of minor ticks. The value should be in range of (0, 100)
    splitNumber: 5,
    // Lenght of minor tick
    length: 3,
    // Line style
    lineStyle: {// Default to be same with axisTick
    }
  },
  minorSplitLine: {
    show: false,
    lineStyle: {
      color: '#F4F7FD',
      width: 1
    }
  }
}, defaultOption);
var timeAxis = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["merge"]({
  splitNumber: 6,
  axisLabel: {
    // To eliminate labels that are not nice
    showMinLabel: false,
    showMaxLabel: false,
    rich: {
      primary: {
        fontWeight: 'bold'
      }
    }
  },
  splitLine: {
    show: false
  }
}, valueAxis);
var logAxis = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["defaults"]({
  logBase: 10
}, valueAxis);
/* harmony default export */ __webpack_exports__["a"] = ({
  category: categoryAxis,
  value: valueAxis,
  time: timeAxis,
  log: logAxis
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Geo_js__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__geoSourceManager_js__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_vector_js__ = __webpack_require__(23);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






/**
 * Resize method bound to the geo
 */

function resizeGeo(geoModel, api) {
  var boundingCoords = geoModel.get('boundingCoords');

  if (boundingCoords != null) {
    var leftTop_1 = boundingCoords[0];
    var rightBottom_1 = boundingCoords[1];

    if (!(isFinite(leftTop_1[0]) && isFinite(leftTop_1[1]) && isFinite(rightBottom_1[0]) && isFinite(rightBottom_1[1]))) {
      if (true) {
        console.error('Invalid boundingCoords');
      }
    } else {
      // Sample around the lng/lat rect and use projection to calculate actual bounding rect.
      var projection_1 = this.projection;

      if (projection_1) {
        var xMin = leftTop_1[0];
        var yMin = leftTop_1[1];
        var xMax = rightBottom_1[0];
        var yMax = rightBottom_1[1];
        leftTop_1 = [Infinity, Infinity];
        rightBottom_1 = [-Infinity, -Infinity]; // TODO better way?

        var sampleLine = function (x0, y0, x1, y1) {
          var dx = x1 - x0;
          var dy = y1 - y0;

          for (var i = 0; i <= 100; i++) {
            var p = i / 100;
            var pt = projection_1.project([x0 + dx * p, y0 + dy * p]);
            __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_vector_js__["min"](leftTop_1, leftTop_1, pt);
            __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_vector_js__["max"](rightBottom_1, rightBottom_1, pt);
          }
        }; // Top


        sampleLine(xMin, yMin, xMax, yMin); // Right

        sampleLine(xMax, yMin, xMax, yMax); // Bottom

        sampleLine(xMax, yMax, xMin, yMax); // Left

        sampleLine(xMin, yMax, xMax, yMin);
      }

      this.setBoundingRect(leftTop_1[0], leftTop_1[1], rightBottom_1[0] - leftTop_1[0], rightBottom_1[1] - leftTop_1[1]);
    }
  }

  var rect = this.getBoundingRect();
  var centerOption = geoModel.get('layoutCenter');
  var sizeOption = geoModel.get('layoutSize');
  var viewWidth = api.getWidth();
  var viewHeight = api.getHeight();
  var aspect = rect.width / rect.height * this.aspectScale;
  var useCenterAndSize = false;
  var center;
  var size;

  if (centerOption && sizeOption) {
    center = [__WEBPACK_IMPORTED_MODULE_3__util_number_js__["a" /* parsePercent */](centerOption[0], viewWidth), __WEBPACK_IMPORTED_MODULE_3__util_number_js__["a" /* parsePercent */](centerOption[1], viewHeight)];
    size = __WEBPACK_IMPORTED_MODULE_3__util_number_js__["a" /* parsePercent */](sizeOption, Math.min(viewWidth, viewHeight));

    if (!isNaN(center[0]) && !isNaN(center[1]) && !isNaN(size)) {
      useCenterAndSize = true;
    } else {
      if (true) {
        console.warn('Given layoutCenter or layoutSize data are invalid. Use left/top/width/height instead.');
      }
    }
  }

  var viewRect;

  if (useCenterAndSize) {
    viewRect = {};

    if (aspect > 1) {
      // Width is same with size
      viewRect.width = size;
      viewRect.height = size / aspect;
    } else {
      viewRect.height = size;
      viewRect.width = size * aspect;
    }

    viewRect.y = center[1] - viewRect.height / 2;
    viewRect.x = center[0] - viewRect.width / 2;
  } else {
    // Use left/top/width/height
    var boxLayoutOption = geoModel.getBoxLayoutParams();
    boxLayoutOption.aspect = aspect;
    viewRect = __WEBPACK_IMPORTED_MODULE_2__util_layout_js__["f" /* getLayoutRect */](boxLayoutOption, {
      width: viewWidth,
      height: viewHeight
    });
  }

  this.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
  this.setCenter(geoModel.get('center'));
  this.setZoom(geoModel.get('zoom'));
} // Back compat for ECharts2, where the coord map is set on map series:
// {type: 'map', geoCoord: {'cityA': [116.46,39.92], 'cityA': [119.12,24.61]}},


function setGeoCoords(geo, model) {
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](model.get('geoCoord'), function (geoCoord, name) {
    geo.addGeoCoord(name, geoCoord);
  });
}

var GeoCreator =
/** @class */
function () {
  function GeoCreator() {
    // For deciding which dimensions to use when creating list data
    this.dimensions = __WEBPACK_IMPORTED_MODULE_1__Geo_js__["a" /* geo2DDimensions */];
  }

  GeoCreator.prototype.create = function (ecModel, api) {
    var geoList = [];

    function getCommonGeoProperties(model) {
      return {
        nameProperty: model.get('nameProperty'),
        aspectScale: model.get('aspectScale'),
        projection: model.get('projection')
      };
    } // FIXME Create each time may be slow


    ecModel.eachComponent('geo', function (geoModel, idx) {
      var mapName = geoModel.get('map');
      var geo = new __WEBPACK_IMPORTED_MODULE_1__Geo_js__["b" /* default */](mapName + idx, mapName, __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"]({
        nameMap: geoModel.get('nameMap')
      }, getCommonGeoProperties(geoModel)));
      geo.zoomLimit = geoModel.get('scaleLimit');
      geoList.push(geo); // setGeoCoords(geo, geoModel);

      geoModel.coordinateSystem = geo;
      geo.model = geoModel; // Inject resize method

      geo.resize = resizeGeo;
      geo.resize(geoModel, api);
    });
    ecModel.eachSeries(function (seriesModel) {
      var coordSys = seriesModel.get('coordinateSystem');

      if (coordSys === 'geo') {
        var geoIndex = seriesModel.get('geoIndex') || 0;
        seriesModel.coordinateSystem = geoList[geoIndex];
      }
    }); // If has map series

    var mapModelGroupBySeries = {};
    ecModel.eachSeriesByType('map', function (seriesModel) {
      if (!seriesModel.getHostGeoModel()) {
        var mapType = seriesModel.getMapType();
        mapModelGroupBySeries[mapType] = mapModelGroupBySeries[mapType] || [];
        mapModelGroupBySeries[mapType].push(seriesModel);
      }
    });
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](mapModelGroupBySeries, function (mapSeries, mapType) {
      var nameMapList = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"](mapSeries, function (singleMapSeries) {
        return singleMapSeries.get('nameMap');
      });
      var geo = new __WEBPACK_IMPORTED_MODULE_1__Geo_js__["b" /* default */](mapType, mapType, __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"]({
        nameMap: __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["mergeAll"](nameMapList)
      }, getCommonGeoProperties(mapSeries[0])));
      geo.zoomLimit = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve"].apply(null, __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"](mapSeries, function (singleMapSeries) {
        return singleMapSeries.get('scaleLimit');
      }));
      geoList.push(geo); // Inject resize method

      geo.resize = resizeGeo;
      geo.resize(mapSeries[0], api);
      __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](mapSeries, function (singleMapSeries) {
        singleMapSeries.coordinateSystem = geo;
        setGeoCoords(geo, singleMapSeries);
      });
    });
    return geoList;
  };
  /**
   * Fill given regions array
   */


  GeoCreator.prototype.getFilledRegions = function (originRegionArr, mapName, nameMap, nameProperty) {
    // Not use the original
    var regionsArr = (originRegionArr || []).slice();
    var dataNameMap = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"]();

    for (var i = 0; i < regionsArr.length; i++) {
      dataNameMap.set(regionsArr[i].name, regionsArr[i]);
    }

    var source = __WEBPACK_IMPORTED_MODULE_4__geoSourceManager_js__["a" /* default */].load(mapName, nameMap, nameProperty);
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](source.regions, function (region) {
      var name = region.name;
      !dataNameMap.get(name) && regionsArr.push({
        name: name
      });
    });
    return regionsArr;
  };

  return GeoCreator;
}();

var geoCreator = new GeoCreator();
/* harmony default export */ __webpack_exports__["a"] = (geoCreator);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ScaleRawExtentInfo */
/* harmony export (immutable) */ __webpack_exports__["a"] = ensureScaleRawExtentInfo;
/* unused harmony export parseAxisModelMinMax */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_contain_text_js__ = __webpack_require__(47);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var ScaleRawExtentInfo =
/** @class */
function () {
  function ScaleRawExtentInfo(scale, model, // Usually: data extent from all series on this axis.
  originalExtent) {
    this._prepareParams(scale, model, originalExtent);
  }
  /**
   * Parameters depending on ouside (like model, user callback)
   * are prepared and fixed here.
   */


  ScaleRawExtentInfo.prototype._prepareParams = function (scale, model, // Usually: data extent from all series on this axis.
  dataExtent) {
    if (dataExtent[1] < dataExtent[0]) {
      dataExtent = [NaN, NaN];
    }

    this._dataMin = dataExtent[0];
    this._dataMax = dataExtent[1];
    var isOrdinal = this._isOrdinal = scale.type === 'ordinal';
    this._needCrossZero = scale.type === 'interval' && model.getNeedCrossZero && model.getNeedCrossZero();
    var modelMinRaw = this._modelMinRaw = model.get('min', true);

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"])(modelMinRaw)) {
      // This callback alway provide users the full data extent (before data filtered).
      this._modelMinNum = parseAxisModelMinMax(scale, modelMinRaw({
        min: dataExtent[0],
        max: dataExtent[1]
      }));
    } else if (modelMinRaw !== 'dataMin') {
      this._modelMinNum = parseAxisModelMinMax(scale, modelMinRaw);
    }

    var modelMaxRaw = this._modelMaxRaw = model.get('max', true);

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"])(modelMaxRaw)) {
      // This callback alway provide users the full data extent (before data filtered).
      this._modelMaxNum = parseAxisModelMinMax(scale, modelMaxRaw({
        min: dataExtent[0],
        max: dataExtent[1]
      }));
    } else if (modelMaxRaw !== 'dataMax') {
      this._modelMaxNum = parseAxisModelMinMax(scale, modelMaxRaw);
    }

    if (isOrdinal) {
      // FIXME: there is a flaw here: if there is no "block" data processor like `dataZoom`,
      // and progressive rendering is using, here the category result might just only contain
      // the processed chunk rather than the entire result.
      this._axisDataLen = model.getCategories().length;
    } else {
      var boundaryGap = model.get('boundaryGap');
      var boundaryGapArr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"])(boundaryGap) ? boundaryGap : [boundaryGap || 0, boundaryGap || 0];

      if (typeof boundaryGapArr[0] === 'boolean' || typeof boundaryGapArr[1] === 'boolean') {
        if (true) {
          console.warn('Boolean type for boundaryGap is only ' + 'allowed for ordinal axis. Please use string in ' + 'percentage instead, e.g., "20%". Currently, ' + 'boundaryGap is set to be 0.');
        }

        this._boundaryGapInner = [0, 0];
      } else {
        this._boundaryGapInner = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_contain_text_js__["b" /* parsePercent */])(boundaryGapArr[0], 1), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_contain_text_js__["b" /* parsePercent */])(boundaryGapArr[1], 1)];
      }
    }
  };
  /**
   * Calculate extent by prepared parameters.
   * This method has no external dependency and can be called duplicatedly,
   * getting the same result.
   * If parameters changed, should call this method to recalcuate.
   */


  ScaleRawExtentInfo.prototype.calculate = function () {
    // Notice: When min/max is not set (that is, when there are null/undefined,
    // which is the most common case), these cases should be ensured:
    // (1) For 'ordinal', show all axis.data.
    // (2) For others:
    //      + `boundaryGap` is applied (if min/max set, boundaryGap is
    //      disabled).
    //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
    //      be the result that originalExtent enlarged by boundaryGap.
    // (3) If no data, it should be ensured that `scale.setBlank` is set.
    var isOrdinal = this._isOrdinal;
    var dataMin = this._dataMin;
    var dataMax = this._dataMax;
    var axisDataLen = this._axisDataLen;
    var boundaryGapInner = this._boundaryGapInner;
    var span = !isOrdinal ? dataMax - dataMin || Math.abs(dataMin) : null; // Currently if a `'value'` axis model min is specified as 'dataMin'/'dataMax',
    // `boundaryGap` will not be used. It's the different from specifying as `null`/`undefined`.

    var min = this._modelMinRaw === 'dataMin' ? dataMin : this._modelMinNum;
    var max = this._modelMaxRaw === 'dataMax' ? dataMax : this._modelMaxNum; // If `_modelMinNum`/`_modelMaxNum` is `null`/`undefined`, should not be fixed.

    var minFixed = min != null;
    var maxFixed = max != null;

    if (min == null) {
      min = isOrdinal ? axisDataLen ? 0 : NaN : dataMin - boundaryGapInner[0] * span;
    }

    if (max == null) {
      max = isOrdinal ? axisDataLen ? axisDataLen - 1 : NaN : dataMax + boundaryGapInner[1] * span;
    }

    (min == null || !isFinite(min)) && (min = NaN);
    (max == null || !isFinite(max)) && (max = NaN);
    var isBlank = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["eqNaN"])(min) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["eqNaN"])(max) || isOrdinal && !axisDataLen; // If data extent modified, need to recalculated to ensure cross zero.

    if (this._needCrossZero) {
      // Axis is over zero and min is not set
      if (min > 0 && max > 0 && !minFixed) {
        min = 0; // minFixed = true;
      } // Axis is under zero and max is not set


      if (min < 0 && max < 0 && !maxFixed) {
        max = 0; // maxFixed = true;
      } // PENDING:
      // When `needCrossZero` and all data is positive/negative, should it be ensured
      // that the results processed by boundaryGap are positive/negative?
      // If so, here `minFixed`/`maxFixed` need to be set.

    }

    var determinedMin = this._determinedMin;
    var determinedMax = this._determinedMax;

    if (determinedMin != null) {
      min = determinedMin;
      minFixed = true;
    }

    if (determinedMax != null) {
      max = determinedMax;
      maxFixed = true;
    } // Ensure min/max be finite number or NaN here. (not to be null/undefined)
    // `NaN` means min/max axis is blank.


    return {
      min: min,
      max: max,
      minFixed: minFixed,
      maxFixed: maxFixed,
      isBlank: isBlank
    };
  };

  ScaleRawExtentInfo.prototype.modifyDataMinMax = function (minMaxName, val) {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(!this.frozen);
    }

    this[DATA_MIN_MAX_ATTR[minMaxName]] = val;
  };

  ScaleRawExtentInfo.prototype.setDeterminedMinMax = function (minMaxName, val) {
    var attr = DETERMINED_MIN_MAX_ATTR[minMaxName];

    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(!this.frozen // Earse them usually means logic flaw.
      && this[attr] == null);
    }

    this[attr] = val;
  };

  ScaleRawExtentInfo.prototype.freeze = function () {
    // @ts-ignore
    this.frozen = true;
  };

  return ScaleRawExtentInfo;
}();


var DETERMINED_MIN_MAX_ATTR = {
  min: '_determinedMin',
  max: '_determinedMax'
};
var DATA_MIN_MAX_ATTR = {
  min: '_dataMin',
  max: '_dataMax'
};
/**
 * Get scale min max and related info only depends on model settings.
 * This method can be called after coordinate system created.
 * For example, in data processing stage.
 *
 * Scale extent info probably be required multiple times during a workflow.
 * For example:
 * (1) `dataZoom` depends it to get the axis extent in "100%" state.
 * (2) `processor/extentCalculator` depends it to make sure whether axis extent is specified.
 * (3) `coordSys.update` use it to finally decide the scale extent.
 * But the callback of `min`/`max` should not be called multiple times.
 * The code below should not be implemented repeatedly either.
 * So we cache the result in the scale instance, which will be recreated at the begining
 * of the workflow (because `scale` instance will be recreated each round of the workflow).
 */

function ensureScaleRawExtentInfo(scale, model, // Usually: data extent from all series on this axis.
originalExtent) {
  // Do not permit to recreate.
  var rawExtentInfo = scale.rawExtentInfo;

  if (rawExtentInfo) {
    return rawExtentInfo;
  }

  rawExtentInfo = new ScaleRawExtentInfo(scale, model, originalExtent); // @ts-ignore

  scale.rawExtentInfo = rawExtentInfo;
  return rawExtentInfo;
}
function parseAxisModelMinMax(scale, minMax) {
  return minMax == null ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["eqNaN"])(minMax) ? NaN : scale.parse(minMax);
}

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = layout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

function layout(axisModel, opt) {
  opt = opt || {};
  var single = axisModel.coordinateSystem;
  var axis = axisModel.axis;
  var layout = {};
  var axisPosition = axis.position;
  var orient = axis.orient;
  var rect = single.getRect();
  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
  var positionMap = {
    horizontal: {
      top: rectBound[2],
      bottom: rectBound[3]
    },
    vertical: {
      left: rectBound[0],
      right: rectBound[1]
    }
  };
  layout.position = [orient === 'vertical' ? positionMap.vertical[axisPosition] : rectBound[0], orient === 'horizontal' ? positionMap.horizontal[axisPosition] : rectBound[3]];
  var r = {
    horizontal: 0,
    vertical: 1
  };
  layout.rotation = Math.PI / 2 * r[orient];
  var directionMap = {
    top: -1,
    bottom: 1,
    right: 1,
    left: -1
  };
  layout.labelDirection = layout.tickDirection = layout.nameDirection = directionMap[axisPosition];

  if (axisModel.get(['axisTick', 'inside'])) {
    layout.tickDirection = -layout.tickDirection;
  }

  if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve"](opt.labelInside, axisModel.get(['axisLabel', 'inside']))) {
    layout.labelDirection = -layout.labelDirection;
  }

  var labelRotation = opt.rotate;
  labelRotation == null && (labelRotation = axisModel.get(['axisLabel', 'rotate']));
  layout.labelRotation = axisPosition === 'top' ? -labelRotation : labelRotation;
  layout.z2 = 1;
  return layout;
}

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var availableMethods = ['getDom', 'getZr', 'getWidth', 'getHeight', 'getDevicePixelRatio', 'dispatchAction', 'isSSR', 'isDisposed', 'on', 'off', 'getDataURL', 'getConnectedDataURL', // 'getModel',
'getOption', // 'getViewOfComponentModel',
// 'getViewOfSeriesModel',
'getId', 'updateLabelLayout'];

var ExtensionAPI =
/** @class */
function () {
  function ExtensionAPI(ecInstance) {
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](availableMethods, function (methodName) {
      this[methodName] = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["bind"](ecInstance[methodName], ecInstance);
    }, this);
  }

  return ExtensionAPI;
}();

/* harmony default export */ __webpack_exports__["a"] = (ExtensionAPI);

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = registerImpl;
/* harmony export (immutable) */ __webpack_exports__["a"] = getImpl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_log_js__ = __webpack_require__(14);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
 // Implementation of exported APIs. For example registerMap, getMap.
// The implentations will be registered when installing the component.
// Avoid these code being bundled to the core module.

var implsStore = {}; // TODO Type

function registerImpl(name, impl) {
  if (true) {
    if (implsStore[name]) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_log_js__["c" /* error */])("Already has an implementation of " + name + ".");
    }
  }

  implsStore[name] = impl;
}
function getImpl(name) {
  if (true) {
    if (!implsStore[name]) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_log_js__["c" /* error */])("Implementation of " + name + " doesn't exists.");
    }
  }

  return implsStore[name];
}

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var uidBase = 0;

var OrdinalMeta =
/** @class */
function () {
  function OrdinalMeta(opt) {
    this.categories = opt.categories || [];
    this._needCollect = opt.needCollect;
    this._deduplication = opt.deduplication;
    this.uid = ++uidBase;
  }

  OrdinalMeta.createByAxisModel = function (axisModel) {
    var option = axisModel.option;
    var data = option.data;
    var categories = data && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])(data, getName);
    return new OrdinalMeta({
      categories: categories,
      needCollect: !categories,
      // deduplication is default in axis.
      deduplication: option.dedplication !== false
    });
  };

  ;

  OrdinalMeta.prototype.getOrdinal = function (category) {
    // @ts-ignore
    return this._getOrCreateMap().get(category);
  };
  /**
   * @return The ordinal. If not found, return NaN.
   */


  OrdinalMeta.prototype.parseAndCollect = function (category) {
    var index;
    var needCollect = this._needCollect; // The value of category dim can be the index of the given category set.
    // This feature is only supported when !needCollect, because we should
    // consider a common case: a value is 2017, which is a number but is
    // expected to be tread as a category. This case usually happen in dataset,
    // where it happent to be no need of the index feature.

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"])(category) && !needCollect) {
      return category;
    } // Optimize for the scenario:
    // category is ['2012-01-01', '2012-01-02', ...], where the input
    // data has been ensured not duplicate and is large data.
    // Notice, if a dataset dimension provide categroies, usually echarts
    // should remove duplication except user tell echarts dont do that
    // (set axis.deduplication = false), because echarts do not know whether
    // the values in the category dimension has duplication (consider the
    // parallel-aqi example)


    if (needCollect && !this._deduplication) {
      index = this.categories.length;
      this.categories[index] = category;
      return index;
    }

    var map = this._getOrCreateMap(); // @ts-ignore


    index = map.get(category);

    if (index == null) {
      if (needCollect) {
        index = this.categories.length;
        this.categories[index] = category; // @ts-ignore

        map.set(category, index);
      } else {
        index = NaN;
      }
    }

    return index;
  }; // Consider big data, do not create map until needed.


  OrdinalMeta.prototype._getOrCreateMap = function () {
    return this._map || (this._map = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])(this.categories));
  };

  return OrdinalMeta;
}();

function getName(obj) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"])(obj) && obj.value != null) {
    return obj.value;
  } else {
    return obj + '';
  }
}

/* harmony default export */ __webpack_exports__["a"] = (OrdinalMeta);

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


var SeriesDimensionDefine =
/** @class */
function () {
  /**
   * @param opt All of the fields will be shallow copied.
   */
  function SeriesDimensionDefine(opt) {
    /**
     * The format of `otherDims` is:
     * ```js
     * {
     *     tooltip?: number
     *     label?: number
     *     itemName?: number
     *     seriesName?: number
     * }
     * ```
     *
     * A `series.encode` can specified these fields:
     * ```js
     * encode: {
     *     // "3, 1, 5" is the index of data dimension.
     *     tooltip: [3, 1, 5],
     *     label: [0, 3],
     *     ...
     * }
     * ```
     * `otherDims` is the parse result of the `series.encode` above, like:
     * ```js
     * // Suppose the index of this data dimension is `3`.
     * this.otherDims = {
     *     // `3` is at the index `0` of the `encode.tooltip`
     *     tooltip: 0,
     *     // `3` is at the index `1` of the `encode.label`
     *     label: 1
     * };
     * ```
     *
     * This prop should never be `null`/`undefined` after initialized.
     */
    this.otherDims = {};

    if (opt != null) {
      __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"](this, opt);
    }
  }

  return SeriesDimensionDefine;
}();

;
/* harmony default export */ __webpack_exports__["a"] = (SeriesDimensionDefine);

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Link lists and struct (graph or tree)
 */


var inner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_model_js__["a" /* makeInner */])();

function linkSeriesData(opt) {
  var mainData = opt.mainData;
  var datas = opt.datas;

  if (!datas) {
    datas = {
      main: mainData
    };
    opt.datasAttr = {
      main: 'data'
    };
  }

  opt.datas = opt.mainData = null;
  linkAll(mainData, datas, opt); // Porxy data original methods.

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(datas, function (data) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(mainData.TRANSFERABLE_METHODS, function (methodName) {
      data.wrapMethod(methodName, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["curry"])(transferInjection, opt));
    });
  }); // Beyond transfer, additional features should be added to `cloneShallow`.

  mainData.wrapMethod('cloneShallow', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["curry"])(cloneShallowInjection, opt)); // Only mainData trigger change, because struct.update may trigger
  // another changable methods, which may bring about dead lock.

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(mainData.CHANGABLE_METHODS, function (methodName) {
    mainData.wrapMethod(methodName, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["curry"])(changeInjection, opt));
  }); // Make sure datas contains mainData.

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(datas[mainData.dataType] === mainData);
}

function transferInjection(opt, res) {
  if (isMainData(this)) {
    // Transfer datas to new main data.
    var datas = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"])({}, inner(this).datas);
    datas[this.dataType] = res;
    linkAll(res, datas, opt);
  } else {
    // Modify the reference in main data to point newData.
    linkSingle(res, this.dataType, inner(this).mainData, opt);
  }

  return res;
}

function changeInjection(opt, res) {
  opt.struct && opt.struct.update();
  return res;
}

function cloneShallowInjection(opt, res) {
  // cloneShallow, which brings about some fragilities, may be inappropriate
  // to be exposed as an API. So for implementation simplicity we can make
  // the restriction that cloneShallow of not-mainData should not be invoked
  // outside, but only be invoked here.
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(inner(res).datas, function (data, dataType) {
    data !== res && linkSingle(data.cloneShallow(), dataType, res, opt);
  });
  return res;
}
/**
 * Supplement method to List.
 *
 * @public
 * @param [dataType] If not specified, return mainData.
 */


function getLinkedData(dataType) {
  var mainData = inner(this).mainData;
  return dataType == null || mainData == null ? mainData : inner(mainData).datas[dataType];
}
/**
 * Get list of all linked data
 */


function getLinkedDataAll() {
  var mainData = inner(this).mainData;
  return mainData == null ? [{
    data: mainData
  }] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["keys"])(inner(mainData).datas), function (type) {
    return {
      type: type,
      data: inner(mainData).datas[type]
    };
  });
}

function isMainData(data) {
  return inner(data).mainData === data;
}

function linkAll(mainData, datas, opt) {
  inner(mainData).datas = {};
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(datas, function (data, dataType) {
    linkSingle(data, dataType, mainData, opt);
  });
}

function linkSingle(data, dataType, mainData, opt) {
  inner(mainData).datas[dataType] = data;
  inner(data).mainData = mainData;
  data.dataType = dataType;

  if (opt.struct) {
    data[opt.structAttr] = opt.struct;
    opt.struct[opt.datasAttr[dataType]] = data;
  } // Supplement method.


  data.getLinkedData = getLinkedData;
  data.getLinkedDataAll = getLinkedDataAll;
}

/* harmony default export */ __webpack_exports__["a"] = (linkSeriesData);

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SourceManager; });
/* harmony export (immutable) */ __webpack_exports__["b"] = disableTransformOptionMerge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Source_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_types_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sourceHelper_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__transform_js__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DataStore_js__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dataProvider_js__ = __webpack_require__(159);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







/**
 * [REQUIREMENT_MEMO]:
 * (0) `metaRawOption` means `dimensions`/`sourceHeader`/`seriesLayoutBy` in raw option.
 * (1) Keep support the feature: `metaRawOption` can be specified both on `series` and
 * `root-dataset`. Them on `series` has higher priority.
 * (2) Do not support to set `metaRawOption` on a `non-root-dataset`, because it might
 * confuse users: whether those props indicate how to visit the upstream source or visit
 * the transform result source, and some transforms has nothing to do with these props,
 * and some transforms might have multiple upstream.
 * (3) Transforms should specify `metaRawOption` in each output, just like they can be
 * declared in `root-dataset`.
 * (4) At present only support visit source in `SERIES_LAYOUT_BY_COLUMN` in transforms.
 * That is for reducing complexity in transfroms.
 * PENDING: Whether to provide transposition transform?
 *
 * [IMPLEMENTAION_MEMO]:
 * "sourceVisitConfig" are calculated from `metaRawOption` and `data`.
 * They will not be calculated until `source` is about to be visited (to prevent from
 * duplicate calcuation). `source` is visited only in series and input to transforms.
 *
 * [DIMENSION_INHERIT_RULE]:
 * By default the dimensions are inherited from ancestors, unless a transform return
 * a new dimensions definition.
 * Consider the case:
 * ```js
 * dataset: [{
 *     source: [ ['Product', 'Sales', 'Prise'], ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * dataset: [{
 *     dimension: ['Product', 'Sales', 'Prise'],
 *     source: [ ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * ```
 * The two types of option should have the same behavior after transform.
 *
 *
 * [SCENARIO]:
 * (1) Provide source data directly:
 * ```js
 * series: {
 *     encode: {...},
 *     dimensions: [...]
 *     seriesLayoutBy: 'row',
 *     data: [[...]]
 * }
 * ```
 * (2) Series refer to dataset.
 * ```js
 * series: [{
 *     encode: {...}
 *     // Ignore datasetIndex means `datasetIndex: 0`
 *     // and the dimensions defination in dataset is used
 * }, {
 *     encode: {...},
 *     seriesLayoutBy: 'column',
 *     datasetIndex: 1
 * }]
 * ```
 * (3) dataset transform
 * ```js
 * dataset: [{
 *     source: [...]
 * }, {
 *     source: [...]
 * }, {
 *     // By default from 0.
 *     transform: { type: 'filter', config: {...} }
 * }, {
 *     // Piped.
 *     transform: [
 *         { type: 'filter', config: {...} },
 *         { type: 'sort', config: {...} }
 *     ]
 * }, {
 *     id: 'regressionData',
 *     fromDatasetIndex: 1,
 *     // Third-party transform
 *     transform: { type: 'ecStat:regression', config: {...} }
 * }, {
 *     // retrieve the extra result.
 *     id: 'regressionFormula',
 *     fromDatasetId: 'regressionData',
 *     fromTransformResult: 1
 * }]
 * ```
 */

var SourceManager =
/** @class */
function () {
  function SourceManager(sourceHost) {
    // Cached source. Do not repeat calculating if not dirty.
    this._sourceList = [];
    this._storeList = []; // version sign of each upstream source manager.

    this._upstreamSignList = [];
    this._versionSignBase = 0;
    this._dirty = true;
    this._sourceHost = sourceHost;
  }
  /**
   * Mark dirty.
   */


  SourceManager.prototype.dirty = function () {
    this._setLocalSource([], []);

    this._storeList = [];
    this._dirty = true;
  };

  SourceManager.prototype._setLocalSource = function (sourceList, upstreamSignList) {
    this._sourceList = sourceList;
    this._upstreamSignList = upstreamSignList;
    this._versionSignBase++;

    if (this._versionSignBase > 9e10) {
      this._versionSignBase = 0;
    }
  };
  /**
   * For detecting whether the upstream source is dirty, so that
   * the local cached source (in `_sourceList`) should be discarded.
   */


  SourceManager.prototype._getVersionSign = function () {
    return this._sourceHost.uid + '_' + this._versionSignBase;
  };
  /**
   * Always return a source instance. Otherwise throw error.
   */


  SourceManager.prototype.prepareSource = function () {
    // For the case that call `setOption` multiple time but no data changed,
    // cache the result source to prevent from repeating transform.
    if (this._isDirty()) {
      this._createSource();

      this._dirty = false;
    }
  };

  SourceManager.prototype._createSource = function () {
    this._setLocalSource([], []);

    var sourceHost = this._sourceHost;

    var upSourceMgrList = this._getUpstreamSourceManagers();

    var hasUpstream = !!upSourceMgrList.length;
    var resultSourceList;
    var upstreamSignList;

    if (isSeries(sourceHost)) {
      var seriesModel = sourceHost;
      var data = void 0;
      var sourceFormat = void 0;
      var upSource = void 0; // Has upstream dataset

      if (hasUpstream) {
        var upSourceMgr = upSourceMgrList[0];
        upSourceMgr.prepareSource();
        upSource = upSourceMgr.getSource();
        data = upSource.data;
        sourceFormat = upSource.sourceFormat;
        upstreamSignList = [upSourceMgr._getVersionSign()];
      } // Series data is from own.
      else {
          data = seriesModel.get('data', true);
          sourceFormat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isTypedArray"])(data) ? __WEBPACK_IMPORTED_MODULE_2__util_types_js__["a" /* SOURCE_FORMAT_TYPED_ARRAY */] : __WEBPACK_IMPORTED_MODULE_2__util_types_js__["g" /* SOURCE_FORMAT_ORIGINAL */];
          upstreamSignList = [];
        } // See [REQUIREMENT_MEMO], merge settings on series and parent dataset if it is root.


      var newMetaRawOption = this._getSourceMetaRawOption() || {};
      var upMetaRawOption = upSource && upSource.metaRawOption || {};
      var seriesLayoutBy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve2"])(newMetaRawOption.seriesLayoutBy, upMetaRawOption.seriesLayoutBy) || null;
      var sourceHeader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve2"])(newMetaRawOption.sourceHeader, upMetaRawOption.sourceHeader); // Note here we should not use `upSource.dimensionsDefine`. Consider the case:
      // `upSource.dimensionsDefine` is detected by `seriesLayoutBy: 'column'`,
      // but series need `seriesLayoutBy: 'row'`.

      var dimensions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve2"])(newMetaRawOption.dimensions, upMetaRawOption.dimensions); // We share source with dataset as much as possible
      // to avoid extra memroy cost of high dimensional data.

      var needsCreateSource = seriesLayoutBy !== upMetaRawOption.seriesLayoutBy || !!sourceHeader !== !!upMetaRawOption.sourceHeader || dimensions;
      resultSourceList = needsCreateSource ? [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Source_js__["c" /* createSource */])(data, {
        seriesLayoutBy: seriesLayoutBy,
        sourceHeader: sourceHeader,
        dimensions: dimensions
      }, sourceFormat)] : [];
    } else {
      var datasetModel = sourceHost; // Has upstream dataset.

      if (hasUpstream) {
        var result = this._applyTransform(upSourceMgrList);

        resultSourceList = result.sourceList;
        upstreamSignList = result.upstreamSignList;
      } // Is root dataset.
      else {
          var sourceData = datasetModel.get('source', true);
          resultSourceList = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Source_js__["c" /* createSource */])(sourceData, this._getSourceMetaRawOption(), null)];
          upstreamSignList = [];
        }
    }

    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(resultSourceList && upstreamSignList);
    }

    this._setLocalSource(resultSourceList, upstreamSignList);
  };

  SourceManager.prototype._applyTransform = function (upMgrList) {
    var datasetModel = this._sourceHost;
    var transformOption = datasetModel.get('transform', true);
    var fromTransformResult = datasetModel.get('fromTransformResult', true);

    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(fromTransformResult != null || transformOption != null);
    }

    if (fromTransformResult != null) {
      var errMsg = '';

      if (upMgrList.length !== 1) {
        if (true) {
          errMsg = 'When using `fromTransformResult`, there should be only one upstream dataset';
        }

        doThrow(errMsg);
      }
    }

    var sourceList;
    var upSourceList = [];
    var upstreamSignList = [];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(upMgrList, function (upMgr) {
      upMgr.prepareSource();
      var upSource = upMgr.getSource(fromTransformResult || 0);
      var errMsg = '';

      if (fromTransformResult != null && !upSource) {
        if (true) {
          errMsg = 'Can not retrieve result by `fromTransformResult`: ' + fromTransformResult;
        }

        doThrow(errMsg);
      }

      upSourceList.push(upSource);
      upstreamSignList.push(upMgr._getVersionSign());
    });

    if (transformOption) {
      sourceList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__transform_js__["a" /* applyDataTransform */])(transformOption, upSourceList, {
        datasetIndex: datasetModel.componentIndex
      });
    } else if (fromTransformResult != null) {
      sourceList = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Source_js__["d" /* cloneSourceShallow */])(upSourceList[0])];
    }

    return {
      sourceList: sourceList,
      upstreamSignList: upstreamSignList
    };
  };

  SourceManager.prototype._isDirty = function () {
    if (this._dirty) {
      return true;
    } // All sourceList is from the some upsteam.


    var upSourceMgrList = this._getUpstreamSourceManagers();

    for (var i = 0; i < upSourceMgrList.length; i++) {
      var upSrcMgr = upSourceMgrList[i];

      if ( // Consider the case that there is ancestor diry, call it recursively.
      // The performance is probably not an issue because usually the chain is not long.
      upSrcMgr._isDirty() || this._upstreamSignList[i] !== upSrcMgr._getVersionSign()) {
        return true;
      }
    }
  };
  /**
   * @param sourceIndex By defualt 0, means "main source".
   *                    Most cases there is only one source.
   */


  SourceManager.prototype.getSource = function (sourceIndex) {
    sourceIndex = sourceIndex || 0;
    var source = this._sourceList[sourceIndex];

    if (!source) {
      // Series may share source instance with dataset.
      var upSourceMgrList = this._getUpstreamSourceManagers();

      return upSourceMgrList[0] && upSourceMgrList[0].getSource(sourceIndex);
    }

    return source;
  };
  /**
   *
   * Get a data store which can be shared across series.
   * Only available for series.
   *
   * @param seriesDimRequest Dimensions that are generated in series.
   *        Should have been sorted by `storeDimIndex` asc.
   */


  SourceManager.prototype.getSharedDataStore = function (seriesDimRequest) {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(isSeries(this._sourceHost), 'Can only call getDataStore on series source manager.');
    }

    var schema = seriesDimRequest.makeStoreSchema();
    return this._innerGetDataStore(schema.dimensions, seriesDimRequest.source, schema.hash);
  };

  SourceManager.prototype._innerGetDataStore = function (storeDims, seriesSource, sourceReadKey) {
    // TODO Can use other sourceIndex?
    var sourceIndex = 0;
    var storeList = this._storeList;
    var cachedStoreMap = storeList[sourceIndex];

    if (!cachedStoreMap) {
      cachedStoreMap = storeList[sourceIndex] = {};
    }

    var cachedStore = cachedStoreMap[sourceReadKey];

    if (!cachedStore) {
      var upSourceMgr = this._getUpstreamSourceManagers()[0];

      if (isSeries(this._sourceHost) && upSourceMgr) {
        cachedStore = upSourceMgr._innerGetDataStore(storeDims, seriesSource, sourceReadKey);
      } else {
        cachedStore = new __WEBPACK_IMPORTED_MODULE_5__DataStore_js__["a" /* default */](); // Always create store from source of series.

        cachedStore.initData(new __WEBPACK_IMPORTED_MODULE_6__dataProvider_js__["b" /* DefaultDataProvider */](seriesSource, storeDims.length), storeDims);
      }

      cachedStoreMap[sourceReadKey] = cachedStore;
    }

    return cachedStore;
  };
  /**
   * PEDING: Is it fast enough?
   * If no upstream, return empty array.
   */


  SourceManager.prototype._getUpstreamSourceManagers = function () {
    // Always get the relationship from the raw option.
    // Do not cache the link of the dependency graph, so that
    // no need to update them when change happen.
    var sourceHost = this._sourceHost;

    if (isSeries(sourceHost)) {
      var datasetModel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sourceHelper_js__["c" /* querySeriesUpstreamDatasetModel */])(sourceHost);
      return !datasetModel ? [] : [datasetModel.getSourceManager()];
    } else {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sourceHelper_js__["d" /* queryDatasetUpstreamDatasetModels */])(sourceHost), function (datasetModel) {
        return datasetModel.getSourceManager();
      });
    }
  };

  SourceManager.prototype._getSourceMetaRawOption = function () {
    var sourceHost = this._sourceHost;
    var seriesLayoutBy;
    var sourceHeader;
    var dimensions;

    if (isSeries(sourceHost)) {
      seriesLayoutBy = sourceHost.get('seriesLayoutBy', true);
      sourceHeader = sourceHost.get('sourceHeader', true);
      dimensions = sourceHost.get('dimensions', true);
    } // See [REQUIREMENT_MEMO], `non-root-dataset` do not support them.
    else if (!this._getUpstreamSourceManagers().length) {
        var model = sourceHost;
        seriesLayoutBy = model.get('seriesLayoutBy', true);
        sourceHeader = model.get('sourceHeader', true);
        dimensions = model.get('dimensions', true);
      }

    return {
      seriesLayoutBy: seriesLayoutBy,
      sourceHeader: sourceHeader,
      dimensions: dimensions
    };
  };

  return SourceManager;
}();

 // Call this method after `super.init` and `super.mergeOption` to
// disable the transform merge, but do not disable transfrom clone from rawOption.

function disableTransformOptionMerge(datasetModel) {
  var transformOption = datasetModel.option.transform;
  transformOption && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["setAsPrimitive"])(datasetModel.option.transform);
}

function isSeries(sourceHost) {
  // Avoid circular dependency with Series.ts
  return sourceHost.mainType === 'series';
}

function doThrow(errMsg) {
  throw new Error(errMsg);
}

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ExternalSource */
/* harmony export (immutable) */ __webpack_exports__["b"] = registerExternalTransform;
/* harmony export (immutable) */ __webpack_exports__["a"] = applyDataTransform;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_types_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dataProvider_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dataValueHelper_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_log_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Source_js__ = __webpack_require__(114);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







/**
 * TODO: disable writable.
 * This structure will be exposed to users.
 */

var ExternalSource =
/** @class */
function () {
  function ExternalSource() {}

  ExternalSource.prototype.getRawData = function () {
    // Only built-in transform available.
    throw new Error('not supported');
  };

  ExternalSource.prototype.getRawDataItem = function (dataIndex) {
    // Only built-in transform available.
    throw new Error('not supported');
  };

  ExternalSource.prototype.cloneRawData = function () {
    return;
  };
  /**
   * @return If dimension not found, return null/undefined.
   */


  ExternalSource.prototype.getDimensionInfo = function (dim) {
    return;
  };
  /**
   * dimensions defined if and only if either:
   * (a) dataset.dimensions are declared.
   * (b) dataset data include dimensions definitions in data (detected or via specified `sourceHeader`).
   * If dimensions are defined, `dimensionInfoAll` is corresponding to
   * the defined dimensions.
   * Otherwise, `dimensionInfoAll` is determined by data columns.
   * @return Always return an array (even empty array).
   */


  ExternalSource.prototype.cloneAllDimensionInfo = function () {
    return;
  };

  ExternalSource.prototype.count = function () {
    return;
  };
  /**
   * Only support by dimension index.
   * No need to support by dimension name in transform function,
   * becuase transform function is not case-specific, no need to use name literally.
   */


  ExternalSource.prototype.retrieveValue = function (dataIndex, dimIndex) {
    return;
  };

  ExternalSource.prototype.retrieveValueFromItem = function (dataItem, dimIndex) {
    return;
  };

  ExternalSource.prototype.convertValue = function (rawVal, dimInfo) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dataValueHelper_js__["b" /* parseDataValue */])(rawVal, dimInfo);
  };

  return ExternalSource;
}();



function createExternalSource(internalSource, externalTransform) {
  var extSource = new ExternalSource();
  var data = internalSource.data;
  var sourceFormat = extSource.sourceFormat = internalSource.sourceFormat;
  var sourceHeaderCount = internalSource.startIndex;
  var errMsg = '';

  if (internalSource.seriesLayoutBy !== __WEBPACK_IMPORTED_MODULE_0__util_types_js__["c" /* SERIES_LAYOUT_BY_COLUMN */]) {
    // For the logic simplicity in transformer, only 'culumn' is
    // supported in data transform. Otherwise, the `dimensionsDefine`
    // might be detected by 'row', which probably confuses users.
    if (true) {
      errMsg = '`seriesLayoutBy` of upstream dataset can only be "column" in data transform.';
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_log_js__["e" /* throwError */])(errMsg);
  } // [MEMO]
  // Create a new dimensions structure for exposing.
  // Do not expose all dimension info to users directly.
  // Becuase the dimension is probably auto detected from data and not might reliable.
  // Should not lead the transformers to think that is relialbe and return it.
  // See [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.


  var dimensions = [];
  var dimsByName = {};
  var dimsDef = internalSource.dimensionsDefine;

  if (dimsDef) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(dimsDef, function (dimDef, idx) {
      var name = dimDef.name;
      var dimDefExt = {
        index: idx,
        name: name,
        displayName: dimDef.displayName
      };
      dimensions.push(dimDefExt); // Users probably not sepcify dimension name. For simplicity, data transform
      // do not generate dimension name.

      if (name != null) {
        // Dimension name should not be duplicated.
        // For simplicity, data transform forbid name duplication, do not generate
        // new name like module `completeDimensions.ts` did, but just tell users.
        var errMsg_1 = '';

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["hasOwn"])(dimsByName, name)) {
          if (true) {
            errMsg_1 = 'dimension name "' + name + '" duplicated.';
          }

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_log_js__["e" /* throwError */])(errMsg_1);
        }

        dimsByName[name] = dimDefExt;
      }
    });
  } // If dimension definitions are not defined and can not be detected.
  // e.g., pure data `[[11, 22], ...]`.
  else {
      for (var i = 0; i < internalSource.dimensionsDetectedCount || 0; i++) {
        // Do not generete name or anything others. The consequence process in
        // `transform` or `series` probably have there own name generation strategry.
        dimensions.push({
          index: i
        });
      }
    } // Implement public methods:


  var rawItemGetter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dataProvider_js__["c" /* getRawSourceItemGetter */])(sourceFormat, __WEBPACK_IMPORTED_MODULE_0__util_types_js__["c" /* SERIES_LAYOUT_BY_COLUMN */]);

  if (externalTransform.__isBuiltIn) {
    extSource.getRawDataItem = function (dataIndex) {
      return rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
    };

    extSource.getRawData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["bind"])(getRawData, null, internalSource);
  }

  extSource.cloneRawData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["bind"])(cloneRawData, null, internalSource);
  var rawCounter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dataProvider_js__["d" /* getRawSourceDataCounter */])(sourceFormat, __WEBPACK_IMPORTED_MODULE_0__util_types_js__["c" /* SERIES_LAYOUT_BY_COLUMN */]);
  extSource.count = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["bind"])(rawCounter, null, data, sourceHeaderCount, dimensions);
  var rawValueGetter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dataProvider_js__["e" /* getRawSourceValueGetter */])(sourceFormat);

  extSource.retrieveValue = function (dataIndex, dimIndex) {
    var rawItem = rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
    return retrieveValueFromItem(rawItem, dimIndex);
  };

  var retrieveValueFromItem = extSource.retrieveValueFromItem = function (dataItem, dimIndex) {
    if (dataItem == null) {
      return;
    }

    var dimDef = dimensions[dimIndex]; // When `dimIndex` is `null`, `rawValueGetter` return the whole item.

    if (dimDef) {
      return rawValueGetter(dataItem, dimIndex, dimDef.name);
    }
  };

  extSource.getDimensionInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["bind"])(getDimensionInfo, null, dimensions, dimsByName);
  extSource.cloneAllDimensionInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["bind"])(cloneAllDimensionInfo, null, dimensions);
  return extSource;
}

function getRawData(upstream) {
  var sourceFormat = upstream.sourceFormat;

  if (!isSupportedSourceFormat(sourceFormat)) {
    var errMsg = '';

    if (true) {
      errMsg = '`getRawData` is not supported in source format ' + sourceFormat;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_log_js__["e" /* throwError */])(errMsg);
  }

  return upstream.data;
}

function cloneRawData(upstream) {
  var sourceFormat = upstream.sourceFormat;
  var data = upstream.data;

  if (!isSupportedSourceFormat(sourceFormat)) {
    var errMsg = '';

    if (true) {
      errMsg = '`cloneRawData` is not supported in source format ' + sourceFormat;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_log_js__["e" /* throwError */])(errMsg);
  }

  if (sourceFormat === __WEBPACK_IMPORTED_MODULE_0__util_types_js__["b" /* SOURCE_FORMAT_ARRAY_ROWS */]) {
    var result = [];

    for (var i = 0, len = data.length; i < len; i++) {
      // Not strictly clone for performance
      result.push(data[i].slice());
    }

    return result;
  } else if (sourceFormat === __WEBPACK_IMPORTED_MODULE_0__util_types_js__["e" /* SOURCE_FORMAT_OBJECT_ROWS */]) {
    var result = [];

    for (var i = 0, len = data.length; i < len; i++) {
      // Not strictly clone for performance
      result.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["extend"])({}, data[i]));
    }

    return result;
  }
}

function getDimensionInfo(dimensions, dimsByName, dim) {
  if (dim == null) {
    return;
  } // Keep the same logic as `List::getDimension` did.


  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isNumber"])(dim) // If being a number-like string but not being defined a dimension name.
  || !isNaN(dim) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["hasOwn"])(dimsByName, dim)) {
    return dimensions[dim];
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["hasOwn"])(dimsByName, dim)) {
    return dimsByName[dim];
  }
}

function cloneAllDimensionInfo(dimensions) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["clone"])(dimensions);
}

var externalTransformMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["createHashMap"])();
function registerExternalTransform(externalTransform) {
  externalTransform = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["clone"])(externalTransform);
  var type = externalTransform.type;
  var errMsg = '';

  if (!type) {
    if (true) {
      errMsg = 'Must have a `type` when `registerTransform`.';
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_log_js__["e" /* throwError */])(errMsg);
  }

  var typeParsed = type.split(':');

  if (typeParsed.length !== 2) {
    if (true) {
      errMsg = 'Name must include namespace like "ns:regression".';
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_log_js__["e" /* throwError */])(errMsg);
  } // Namespace 'echarts:xxx' is official namespace, where the transforms should
  // be called directly via 'xxx' rather than 'echarts:xxx'.


  var isBuiltIn = false;

  if (typeParsed[0] === 'echarts') {
    type = typeParsed[1];
    isBuiltIn = true;
  }

  externalTransform.__isBuiltIn = isBuiltIn;
  externalTransformMap.set(type, externalTransform);
}
function applyDataTransform(rawTransOption, sourceList, infoForPrint) {
  var pipedTransOption = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_model_js__["d" /* normalizeToArray */])(rawTransOption);
  var pipeLen = pipedTransOption.length;
  var errMsg = '';

  if (!pipeLen) {
    if (true) {
      errMsg = 'If `transform` declared, it should at least contain one transform.';
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_log_js__["e" /* throwError */])(errMsg);
  }

  for (var i = 0, len = pipeLen; i < len; i++) {
    var transOption = pipedTransOption[i];
    sourceList = applySingleDataTransform(transOption, sourceList, infoForPrint, pipeLen === 1 ? null : i); // piped transform only support single input, except the fist one.
    // piped transform only support single output, except the last one.

    if (i !== len - 1) {
      sourceList.length = Math.max(sourceList.length, 1);
    }
  }

  return sourceList;
}

function applySingleDataTransform(transOption, upSourceList, infoForPrint, // If `pipeIndex` is null/undefined, no piped transform.
pipeIndex) {
  var errMsg = '';

  if (!upSourceList.length) {
    if (true) {
      errMsg = 'Must have at least one upstream dataset.';
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_log_js__["e" /* throwError */])(errMsg);
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isObject"])(transOption)) {
    if (true) {
      errMsg = 'transform declaration must be an object rather than ' + typeof transOption + '.';
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_log_js__["e" /* throwError */])(errMsg);
  }

  var transType = transOption.type;
  var externalTransform = externalTransformMap.get(transType);

  if (!externalTransform) {
    if (true) {
      errMsg = 'Can not find transform on type "' + transType + '".';
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_log_js__["e" /* throwError */])(errMsg);
  } // Prepare source


  var extUpSourceList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["map"])(upSourceList, function (upSource) {
    return createExternalSource(upSource, externalTransform);
  });
  var resultList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_model_js__["d" /* normalizeToArray */])(externalTransform.transform({
    upstream: extUpSourceList[0],
    upstreamList: extUpSourceList,
    config: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["clone"])(transOption.config)
  }));

  if (true) {
    if (transOption.print) {
      var printStrArr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["map"])(resultList, function (extSource) {
        var pipeIndexStr = pipeIndex != null ? ' === pipe index: ' + pipeIndex : '';
        return ['=== dataset index: ' + infoForPrint.datasetIndex + pipeIndexStr + ' ===', '- transform result data:', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_log_js__["d" /* makePrintable */])(extSource.data), '- transform result dimensions:', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_log_js__["d" /* makePrintable */])(extSource.dimensions)].join('\n');
      }).join('\n');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_log_js__["f" /* log */])(printStrArr);
    }
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["map"])(resultList, function (result, resultIndex) {
    var errMsg = '';

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isObject"])(result)) {
      if (true) {
        errMsg = 'A transform should not return some empty results.';
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_log_js__["e" /* throwError */])(errMsg);
    }

    if (!result.data) {
      if (true) {
        errMsg = 'Transform result data should be not be null or undefined';
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_log_js__["e" /* throwError */])(errMsg);
    }

    var sourceFormat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__Source_js__["f" /* detectSourceFormat */])(result.data);

    if (!isSupportedSourceFormat(sourceFormat)) {
      if (true) {
        errMsg = 'Transform result data should be array rows or object rows.';
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_log_js__["e" /* throwError */])(errMsg);
    }

    var resultMetaRawOption;
    var firstUpSource = upSourceList[0];
    /**
     * Intuitively, the end users known the content of the original `dataset.source`,
     * calucating the transform result in mind.
     * Suppose the original `dataset.source` is:
     * ```js
     * [
     *     ['product', '2012', '2013', '2014', '2015'],
     *     ['AAA', 41.1, 30.4, 65.1, 53.3],
     *     ['BBB', 86.5, 92.1, 85.7, 83.1],
     *     ['CCC', 24.1, 67.2, 79.5, 86.4]
     * ]
     * ```
     * The dimension info have to be detected from the source data.
     * Some of the transformers (like filter, sort) will follow the dimension info
     * of upstream, while others use new dimensions (like aggregate).
     * Transformer can output a field `dimensions` to define the its own output dimensions.
     * We also allow transformers to ignore the output `dimensions` field, and
     * inherit the upstream dimensions definition. It can reduce the burden of handling
     * dimensions in transformers.
     *
     * See also [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
     */

    if (firstUpSource && resultIndex === 0 // If transformer returns `dimensions`, it means that the transformer has different
    // dimensions definitions. We do not inherit anything from upstream.
    && !result.dimensions) {
      var startIndex = firstUpSource.startIndex; // We copy the header of upstream to the result becuase:
      // (1) The returned data always does not contain header line and can not be used
      // as dimension-detection. In this case we can not use "detected dimensions" of
      // upstream directly, because it might be detected based on different `seriesLayoutBy`.
      // (2) We should support that the series read the upstream source in `seriesLayoutBy: 'row'`.
      // So the original detected header should be add to the result, otherwise they can not be read.

      if (startIndex) {
        result.data = firstUpSource.data.slice(0, startIndex).concat(result.data);
      }

      resultMetaRawOption = {
        seriesLayoutBy: __WEBPACK_IMPORTED_MODULE_0__util_types_js__["c" /* SERIES_LAYOUT_BY_COLUMN */],
        sourceHeader: startIndex,
        dimensions: firstUpSource.metaRawOption.dimensions
      };
    } else {
      resultMetaRawOption = {
        seriesLayoutBy: __WEBPACK_IMPORTED_MODULE_0__util_types_js__["c" /* SERIES_LAYOUT_BY_COLUMN */],
        sourceHeader: 0,
        dimensions: result.dimensions
      };
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__Source_js__["c" /* createSource */])(result.data, resultMetaRawOption, null);
  });
}

function isSupportedSourceFormat(sourceFormat) {
  return sourceFormat === __WEBPACK_IMPORTED_MODULE_0__util_types_js__["b" /* SOURCE_FORMAT_ARRAY_ROWS */] || sourceFormat === __WEBPACK_IMPORTED_MODULE_0__util_types_js__["e" /* SOURCE_FORMAT_OBJECT_ROWS */];
}

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = installLabelLayout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LabelManager_js__ = __webpack_require__(1343);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


var getLabelManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_model_js__["a" /* makeInner */])();
function installLabelLayout(registers) {
  registers.registerUpdateLifecycle('series:beforeupdate', function (ecModel, api, params) {
    // TODO api provide an namespace that can save stuff per instance
    var labelManager = getLabelManager(api).labelManager;

    if (!labelManager) {
      labelManager = getLabelManager(api).labelManager = new __WEBPACK_IMPORTED_MODULE_1__LabelManager_js__["a" /* default */]();
    }

    labelManager.clearLabels();
  });
  registers.registerUpdateLifecycle('series:layoutlabels', function (ecModel, api, params) {
    var labelManager = getLabelManager(api).labelManager;
    params.updatedSeries.forEach(function (series) {
      labelManager.addLabelsOfSeries(api.getViewOfSeriesModel(series));
    });
    labelManager.updateLayoutConfig(api);
    labelManager.layout(api);
    labelManager.processLabelsOverall();
  });
}

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Model_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Component_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__globalDefault_js__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_helper_sourceHelper_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__internalComponentCreator_js__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixin_palette_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_log_js__ = __webpack_require__(14);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Caution: If the mechanism should be changed some day, these cases
 * should be considered:
 *
 * (1) In `merge option` mode, if using the same option to call `setOption`
 * many times, the result should be the same (try our best to ensure that).
 * (2) In `merge option` mode, if a component has no id/name specified, it
 * will be merged by index, and the result sequence of the components is
 * consistent to the original sequence.
 * (3) In `replaceMerge` mode, keep the result sequence of the components is
 * consistent to the original sequence, even though there might result in "hole".
 * (4) `reset` feature (in toolbox). Find detailed info in comments about
 * `mergeOption` in module:echarts/model/OptionManager.
 */









 // -----------------------
// Internal method names:
// -----------------------

var reCreateSeriesIndices;
var assertSeriesInitialized;
var initBase;
var OPTION_INNER_KEY = '\0_ec_inner';
var OPTION_INNER_VALUE = 1;
var BUITIN_COMPONENTS_MAP = {
  grid: 'GridComponent',
  polar: 'PolarComponent',
  geo: 'GeoComponent',
  singleAxis: 'SingleAxisComponent',
  parallel: 'ParallelComponent',
  calendar: 'CalendarComponent',
  graphic: 'GraphicComponent',
  toolbox: 'ToolboxComponent',
  tooltip: 'TooltipComponent',
  axisPointer: 'AxisPointerComponent',
  brush: 'BrushComponent',
  title: 'TitleComponent',
  timeline: 'TimelineComponent',
  markPoint: 'MarkPointComponent',
  markLine: 'MarkLineComponent',
  markArea: 'MarkAreaComponent',
  legend: 'LegendComponent',
  dataZoom: 'DataZoomComponent',
  visualMap: 'VisualMapComponent',
  // aria: 'AriaComponent',
  // dataset: 'DatasetComponent',
  // Dependencies
  xAxis: 'GridComponent',
  yAxis: 'GridComponent',
  angleAxis: 'PolarComponent',
  radiusAxis: 'PolarComponent'
};
var BUILTIN_CHARTS_MAP = {
  line: 'LineChart',
  bar: 'BarChart',
  pie: 'PieChart',
  scatter: 'ScatterChart',
  radar: 'RadarChart',
  map: 'MapChart',
  tree: 'TreeChart',
  treemap: 'TreemapChart',
  graph: 'GraphChart',
  gauge: 'GaugeChart',
  funnel: 'FunnelChart',
  parallel: 'ParallelChart',
  sankey: 'SankeyChart',
  boxplot: 'BoxplotChart',
  candlestick: 'CandlestickChart',
  effectScatter: 'EffectScatterChart',
  lines: 'LinesChart',
  heatmap: 'HeatmapChart',
  pictorialBar: 'PictorialBarChart',
  themeRiver: 'ThemeRiverChart',
  sunburst: 'SunburstChart',
  custom: 'CustomChart'
};
var componetsMissingLogPrinted = {};

function checkMissingComponents(option) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(option, function (componentOption, mainType) {
    if (!__WEBPACK_IMPORTED_MODULE_4__Component_js__["a" /* default */].hasClass(mainType)) {
      var componentImportName = BUITIN_COMPONENTS_MAP[mainType];

      if (componentImportName && !componetsMissingLogPrinted[componentImportName]) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_log_js__["c" /* error */])("Component " + mainType + " is used but not imported.\nimport { " + componentImportName + " } from 'echarts/components';\necharts.use([" + componentImportName + "]);");
        componetsMissingLogPrinted[componentImportName] = true;
      }
    }
  });
}

var GlobalModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(GlobalModel, _super);

  function GlobalModel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  GlobalModel.prototype.init = function (option, parentModel, ecModel, theme, locale, optionManager) {
    theme = theme || {};
    this.option = null; // Mark as not initialized.

    this._theme = new __WEBPACK_IMPORTED_MODULE_3__Model_js__["a" /* default */](theme);
    this._locale = new __WEBPACK_IMPORTED_MODULE_3__Model_js__["a" /* default */](locale);
    this._optionManager = optionManager;
  };

  GlobalModel.prototype.setOption = function (option, opts, optionPreprocessorFuncs) {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"])(option != null, 'option is null/undefined');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"])(option[OPTION_INNER_KEY] !== OPTION_INNER_VALUE, 'please use chart.getOption()');
    }

    var innerOpt = normalizeSetOptionInput(opts);

    this._optionManager.setOption(option, optionPreprocessorFuncs, innerOpt);

    this._resetOption(null, innerOpt);
  };
  /**
   * @param type null/undefined: reset all.
   *        'recreate': force recreate all.
   *        'timeline': only reset timeline option
   *        'media': only reset media query option
   * @return Whether option changed.
   */


  GlobalModel.prototype.resetOption = function (type, opt) {
    return this._resetOption(type, normalizeSetOptionInput(opt));
  };

  GlobalModel.prototype._resetOption = function (type, opt) {
    var optionChanged = false;
    var optionManager = this._optionManager;

    if (!type || type === 'recreate') {
      var baseOption = optionManager.mountOption(type === 'recreate');

      if (true) {
        checkMissingComponents(baseOption);
      }

      if (!this.option || type === 'recreate') {
        initBase(this, baseOption);
      } else {
        this.restoreData();

        this._mergeOption(baseOption, opt);
      }

      optionChanged = true;
    }

    if (type === 'timeline' || type === 'media') {
      this.restoreData();
    } // By design, if `setOption(option2)` at the second time, and `option2` is a `ECUnitOption`,
    // it should better not have the same props with `MediaUnit['option']`.
    // Becuase either `option2` or `MediaUnit['option']` will be always merged to "current option"
    // rather than original "baseOption". If they both override a prop, the result might be
    // unexpected when media state changed after `setOption` called.
    // If we really need to modify a props in each `MediaUnit['option']`, use the full version
    // (`{baseOption, media}`) in `setOption`.
    // For `timeline`, the case is the same.


    if (!type || type === 'recreate' || type === 'timeline') {
      var timelineOption = optionManager.getTimelineOption(this);

      if (timelineOption) {
        optionChanged = true;

        this._mergeOption(timelineOption, opt);
      }
    }

    if (!type || type === 'recreate' || type === 'media') {
      var mediaOptions = optionManager.getMediaOption(this);

      if (mediaOptions.length) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(mediaOptions, function (mediaOption) {
          optionChanged = true;

          this._mergeOption(mediaOption, opt);
        }, this);
      }
    }

    return optionChanged;
  };

  GlobalModel.prototype.mergeOption = function (option) {
    this._mergeOption(option, null);
  };

  GlobalModel.prototype._mergeOption = function (newOption, opt) {
    var option = this.option;
    var componentsMap = this._componentsMap;
    var componentsCount = this._componentsCount;
    var newCmptTypes = [];
    var newCmptTypeMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"])();
    var replaceMergeMainTypeMap = opt && opt.replaceMergeMainTypeMap;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__data_helper_sourceHelper_js__["e" /* resetSourceDefaulter */])(this); // If no component class, merge directly.
    // For example: color, animaiton options, etc.

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(newOption, function (componentOption, mainType) {
      if (componentOption == null) {
        return;
      }

      if (!__WEBPACK_IMPORTED_MODULE_4__Component_js__["a" /* default */].hasClass(mainType)) {
        // globalSettingTask.dirty();
        option[mainType] = option[mainType] == null ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"])(componentOption) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"])(option[mainType], componentOption, true);
      } else if (mainType) {
        newCmptTypes.push(mainType);
        newCmptTypeMap.set(mainType, true);
      }
    });

    if (replaceMergeMainTypeMap) {
      // If there is a mainType `xxx` in `replaceMerge` but not declared in option,
      // we trade it as it is declared in option as `{xxx: []}`. Because:
      // (1) for normal merge, `{xxx: null/undefined}` are the same meaning as `{xxx: []}`.
      // (2) some preprocessor may convert some of `{xxx: null/undefined}` to `{xxx: []}`.
      replaceMergeMainTypeMap.each(function (val, mainTypeInReplaceMerge) {
        if (__WEBPACK_IMPORTED_MODULE_4__Component_js__["a" /* default */].hasClass(mainTypeInReplaceMerge) && !newCmptTypeMap.get(mainTypeInReplaceMerge)) {
          newCmptTypes.push(mainTypeInReplaceMerge);
          newCmptTypeMap.set(mainTypeInReplaceMerge, true);
        }
      });
    }

    __WEBPACK_IMPORTED_MODULE_4__Component_js__["a" /* default */].topologicalTravel(newCmptTypes, __WEBPACK_IMPORTED_MODULE_4__Component_js__["a" /* default */].getAllClassMainTypes(), visitComponent, this);

    function visitComponent(mainType) {
      var newCmptOptionList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__internalComponentCreator_js__["a" /* concatInternalOptions */])(this, mainType, __WEBPACK_IMPORTED_MODULE_2__util_model_js__["d" /* normalizeToArray */](newOption[mainType]));
      var oldCmptList = componentsMap.get(mainType);
      var mergeMode = // `!oldCmptList` means init. See the comment in `mappingToExists`
      !oldCmptList ? 'replaceAll' : replaceMergeMainTypeMap && replaceMergeMainTypeMap.get(mainType) ? 'replaceMerge' : 'normalMerge';
      var mappingResult = __WEBPACK_IMPORTED_MODULE_2__util_model_js__["q" /* mappingToExists */](oldCmptList, newCmptOptionList, mergeMode); // Set mainType and complete subType.

      __WEBPACK_IMPORTED_MODULE_2__util_model_js__["r" /* setComponentTypeToKeyInfo */](mappingResult, mainType, __WEBPACK_IMPORTED_MODULE_4__Component_js__["a" /* default */]); // Empty it before the travel, in order to prevent `this._componentsMap`
      // from being used in the `init`/`mergeOption`/`optionUpdated` of some
      // components, which is probably incorrect logic.

      option[mainType] = null;
      componentsMap.set(mainType, null);
      componentsCount.set(mainType, 0);
      var optionsByMainType = [];
      var cmptsByMainType = [];
      var cmptsCountByMainType = 0;
      var tooltipExists;
      var tooltipWarningLogged;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(mappingResult, function (resultItem, index) {
        var componentModel = resultItem.existing;
        var newCmptOption = resultItem.newOption;

        if (!newCmptOption) {
          if (componentModel) {
            // Consider where is no new option and should be merged using {},
            // see removeEdgeAndAdd in topologicalTravel and
            // ComponentModel.getAllClassMainTypes.
            componentModel.mergeOption({}, this);
            componentModel.optionUpdated({}, false);
          } // If no both `resultItem.exist` and `resultItem.option`,
          // either it is in `replaceMerge` and not matched by any id,
          // or it has been removed in previous `replaceMerge` and left a "hole" in this component index.

        } else {
          var isSeriesType = mainType === 'series';
          var ComponentModelClass = __WEBPACK_IMPORTED_MODULE_4__Component_js__["a" /* default */].getClass(mainType, resultItem.keyInfo.subType, !isSeriesType // Give a more detailed warn later if series don't exists
          );

          if (!ComponentModelClass) {
            if (true) {
              var subType = resultItem.keyInfo.subType;
              var seriesImportName = BUILTIN_CHARTS_MAP[subType];

              if (!componetsMissingLogPrinted[subType]) {
                componetsMissingLogPrinted[subType] = true;

                if (seriesImportName) {
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_log_js__["c" /* error */])("Series " + subType + " is used but not imported.\nimport { " + seriesImportName + " } from 'echarts/charts';\necharts.use([" + seriesImportName + "]);");
                } else {
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_log_js__["c" /* error */])("Unkown series " + subType);
                }
              }
            }

            return;
          } // TODO Before multiple tooltips get supported, we do this check to avoid unexpected exception.


          if (mainType === 'tooltip') {
            if (tooltipExists) {
              if (true) {
                if (!tooltipWarningLogged) {
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_log_js__["b" /* warn */])('Currently only one tooltip component is allowed.');
                  tooltipWarningLogged = true;
                }
              }

              return;
            }

            tooltipExists = true;
          }

          if (componentModel && componentModel.constructor === ComponentModelClass) {
            componentModel.name = resultItem.keyInfo.name; // componentModel.settingTask && componentModel.settingTask.dirty();

            componentModel.mergeOption(newCmptOption, this);
            componentModel.optionUpdated(newCmptOption, false);
          } else {
            // PENDING Global as parent ?
            var extraOpt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])({
              componentIndex: index
            }, resultItem.keyInfo);
            componentModel = new ComponentModelClass(newCmptOption, this, this, extraOpt); // Assign `keyInfo`

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])(componentModel, extraOpt);

            if (resultItem.brandNew) {
              componentModel.__requireNewView = true;
            }

            componentModel.init(newCmptOption, this, this); // Call optionUpdated after init.
            // newCmptOption has been used as componentModel.option
            // and may be merged with theme and default, so pass null
            // to avoid confusion.

            componentModel.optionUpdated(null, true);
          }
        }

        if (componentModel) {
          optionsByMainType.push(componentModel.option);
          cmptsByMainType.push(componentModel);
          cmptsCountByMainType++;
        } else {
          // Always do assign to avoid elided item in array.
          optionsByMainType.push(void 0);
          cmptsByMainType.push(void 0);
        }
      }, this);
      option[mainType] = optionsByMainType;
      componentsMap.set(mainType, cmptsByMainType);
      componentsCount.set(mainType, cmptsCountByMainType); // Backup series for filtering.

      if (mainType === 'series') {
        reCreateSeriesIndices(this);
      }
    } // If no series declared, ensure `_seriesIndices` initialized.


    if (!this._seriesIndices) {
      reCreateSeriesIndices(this);
    }
  };
  /**
   * Get option for output (cloned option and inner info removed)
   */


  GlobalModel.prototype.getOption = function () {
    var option = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"])(this.option);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(option, function (optInMainType, mainType) {
      if (__WEBPACK_IMPORTED_MODULE_4__Component_js__["a" /* default */].hasClass(mainType)) {
        var opts = __WEBPACK_IMPORTED_MODULE_2__util_model_js__["d" /* normalizeToArray */](optInMainType); // Inner cmpts need to be removed.
        // Inner cmpts might not be at last since ec5.0, but still
        // compatible for users: if inner cmpt at last, splice the returned array.

        var realLen = opts.length;
        var metNonInner = false;

        for (var i = realLen - 1; i >= 0; i--) {
          // Remove options with inner id.
          if (opts[i] && !__WEBPACK_IMPORTED_MODULE_2__util_model_js__["s" /* isComponentIdInternal */](opts[i])) {
            metNonInner = true;
          } else {
            opts[i] = null;
            !metNonInner && realLen--;
          }
        }

        opts.length = realLen;
        option[mainType] = opts;
      }
    });
    delete option[OPTION_INNER_KEY];
    return option;
  };

  GlobalModel.prototype.getTheme = function () {
    return this._theme;
  };

  GlobalModel.prototype.getLocaleModel = function () {
    return this._locale;
  };

  GlobalModel.prototype.setUpdatePayload = function (payload) {
    this._payload = payload;
  };

  GlobalModel.prototype.getUpdatePayload = function () {
    return this._payload;
  };
  /**
   * @param idx If not specified, return the first one.
   */


  GlobalModel.prototype.getComponent = function (mainType, idx) {
    var list = this._componentsMap.get(mainType);

    if (list) {
      var cmpt = list[idx || 0];

      if (cmpt) {
        return cmpt;
      } else if (idx == null) {
        for (var i = 0; i < list.length; i++) {
          if (list[i]) {
            return list[i];
          }
        }
      }
    }
  };
  /**
   * @return Never be null/undefined.
   */


  GlobalModel.prototype.queryComponents = function (condition) {
    var mainType = condition.mainType;

    if (!mainType) {
      return [];
    }

    var index = condition.index;
    var id = condition.id;
    var name = condition.name;

    var cmpts = this._componentsMap.get(mainType);

    if (!cmpts || !cmpts.length) {
      return [];
    }

    var result;

    if (index != null) {
      result = [];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(__WEBPACK_IMPORTED_MODULE_2__util_model_js__["d" /* normalizeToArray */](index), function (idx) {
        cmpts[idx] && result.push(cmpts[idx]);
      });
    } else if (id != null) {
      result = queryByIdOrName('id', id, cmpts);
    } else if (name != null) {
      result = queryByIdOrName('name', name, cmpts);
    } else {
      // Return all non-empty components in that mainType
      result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["filter"])(cmpts, function (cmpt) {
        return !!cmpt;
      });
    }

    return filterBySubType(result, condition);
  };
  /**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * let result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series',
   *     filter: function (model, index) {...}}
   * );
   * // result like [component0, componnet1, ...]
   */


  GlobalModel.prototype.findComponents = function (condition) {
    var query = condition.query;
    var mainType = condition.mainType;
    var queryCond = getQueryCond(query);
    var result = queryCond ? this.queryComponents(queryCond) // Retrieve all non-empty components.
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["filter"])(this._componentsMap.get(mainType), function (cmpt) {
      return !!cmpt;
    });
    return doFilter(filterBySubType(result, condition));

    function getQueryCond(q) {
      var indexAttr = mainType + 'Index';
      var idAttr = mainType + 'Id';
      var nameAttr = mainType + 'Name';
      return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
        mainType: mainType,
        // subType will be filtered finally.
        index: q[indexAttr],
        id: q[idAttr],
        name: q[nameAttr]
      } : null;
    }

    function doFilter(res) {
      return condition.filter ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["filter"])(res, condition.filter) : res;
    }
  };

  GlobalModel.prototype.eachComponent = function (mainType, cb, context) {
    var componentsMap = this._componentsMap;

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isFunction"])(mainType)) {
      var ctxForAll_1 = cb;
      var cbForAll_1 = mainType;
      componentsMap.each(function (cmpts, componentType) {
        for (var i = 0; cmpts && i < cmpts.length; i++) {
          var cmpt = cmpts[i];
          cmpt && cbForAll_1.call(ctxForAll_1, componentType, cmpt, cmpt.componentIndex);
        }
      });
    } else {
      var cmpts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"])(mainType) ? componentsMap.get(mainType) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isObject"])(mainType) ? this.findComponents(mainType) : null;

      for (var i = 0; cmpts && i < cmpts.length; i++) {
        var cmpt = cmpts[i];
        cmpt && cb.call(context, cmpt, cmpt.componentIndex);
      }
    }
  };
  /**
   * Get series list before filtered by name.
   */


  GlobalModel.prototype.getSeriesByName = function (name) {
    var nameStr = __WEBPACK_IMPORTED_MODULE_2__util_model_js__["n" /* convertOptionIdName */](name, null);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["filter"])(this._componentsMap.get('series'), function (oneSeries) {
      return !!oneSeries && nameStr != null && oneSeries.name === nameStr;
    });
  };
  /**
   * Get series list before filtered by index.
   */


  GlobalModel.prototype.getSeriesByIndex = function (seriesIndex) {
    return this._componentsMap.get('series')[seriesIndex];
  };
  /**
   * Get series list before filtered by type.
   * FIXME: rename to getRawSeriesByType?
   */


  GlobalModel.prototype.getSeriesByType = function (subType) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["filter"])(this._componentsMap.get('series'), function (oneSeries) {
      return !!oneSeries && oneSeries.subType === subType;
    });
  };
  /**
   * Get all series before filtered.
   */


  GlobalModel.prototype.getSeries = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["filter"])(this._componentsMap.get('series'), function (oneSeries) {
      return !!oneSeries;
    });
  };
  /**
   * Count series before filtered.
   */


  GlobalModel.prototype.getSeriesCount = function () {
    return this._componentsCount.get('series');
  };
  /**
   * After filtering, series may be different
   * frome raw series.
   */


  GlobalModel.prototype.eachSeries = function (cb, context) {
    assertSeriesInitialized(this);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(this._seriesIndices, function (rawSeriesIndex) {
      var series = this._componentsMap.get('series')[rawSeriesIndex];

      cb.call(context, series, rawSeriesIndex);
    }, this);
  };
  /**
   * Iterate raw series before filtered.
   *
   * @param {Function} cb
   * @param {*} context
   */


  GlobalModel.prototype.eachRawSeries = function (cb, context) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(this._componentsMap.get('series'), function (series) {
      series && cb.call(context, series, series.componentIndex);
    });
  };
  /**
   * After filtering, series may be different.
   * frome raw series.
   */


  GlobalModel.prototype.eachSeriesByType = function (subType, cb, context) {
    assertSeriesInitialized(this);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(this._seriesIndices, function (rawSeriesIndex) {
      var series = this._componentsMap.get('series')[rawSeriesIndex];

      if (series.subType === subType) {
        cb.call(context, series, rawSeriesIndex);
      }
    }, this);
  };
  /**
   * Iterate raw series before filtered of given type.
   */


  GlobalModel.prototype.eachRawSeriesByType = function (subType, cb, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(this.getSeriesByType(subType), cb, context);
  };

  GlobalModel.prototype.isSeriesFiltered = function (seriesModel) {
    assertSeriesInitialized(this);
    return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
  };

  GlobalModel.prototype.getCurrentSeriesIndices = function () {
    return (this._seriesIndices || []).slice();
  };

  GlobalModel.prototype.filterSeries = function (cb, context) {
    assertSeriesInitialized(this);
    var newSeriesIndices = [];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(this._seriesIndices, function (seriesRawIdx) {
      var series = this._componentsMap.get('series')[seriesRawIdx];

      cb.call(context, series, seriesRawIdx) && newSeriesIndices.push(seriesRawIdx);
    }, this);
    this._seriesIndices = newSeriesIndices;
    this._seriesIndicesMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"])(newSeriesIndices);
  };

  GlobalModel.prototype.restoreData = function (payload) {
    reCreateSeriesIndices(this);
    var componentsMap = this._componentsMap;
    var componentTypes = [];
    componentsMap.each(function (components, componentType) {
      if (__WEBPACK_IMPORTED_MODULE_4__Component_js__["a" /* default */].hasClass(componentType)) {
        componentTypes.push(componentType);
      }
    });
    __WEBPACK_IMPORTED_MODULE_4__Component_js__["a" /* default */].topologicalTravel(componentTypes, __WEBPACK_IMPORTED_MODULE_4__Component_js__["a" /* default */].getAllClassMainTypes(), function (componentType) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(componentsMap.get(componentType), function (component) {
        if (component && (componentType !== 'series' || !isNotTargetSeries(component, payload))) {
          component.restoreData();
        }
      });
    });
  };

  GlobalModel.internalField = function () {
    reCreateSeriesIndices = function (ecModel) {
      var seriesIndices = ecModel._seriesIndices = [];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(ecModel._componentsMap.get('series'), function (series) {
        // series may have been removed by `replaceMerge`.
        series && seriesIndices.push(series.componentIndex);
      });
      ecModel._seriesIndicesMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"])(seriesIndices);
    };

    assertSeriesInitialized = function (ecModel) {
      // Components that use _seriesIndices should depends on series component,
      // which make sure that their initialization is after series.
      if (true) {
        if (!ecModel._seriesIndices) {
          throw new Error('Option should contains series.');
        }
      }
    };

    initBase = function (ecModel, baseOption) {
      // Using OPTION_INNER_KEY to mark that this option can not be used outside,
      // i.e. `chart.setOption(chart.getModel().option);` is forbiden.
      ecModel.option = {};
      ecModel.option[OPTION_INNER_KEY] = OPTION_INNER_VALUE; // Init with series: [], in case of calling findSeries method
      // before series initialized.

      ecModel._componentsMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"])({
        series: []
      });
      ecModel._componentsCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"])(); // If user spefied `option.aria`, aria will be enable. This detection should be
      // performed before theme and globalDefault merge.

      var airaOption = baseOption.aria;

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isObject"])(airaOption) && airaOption.enabled == null) {
        airaOption.enabled = true;
      }

      mergeTheme(baseOption, ecModel._theme.option); // TODO Needs clone when merging to the unexisted property

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"])(baseOption, __WEBPACK_IMPORTED_MODULE_5__globalDefault_js__["a" /* default */], false);

      ecModel._mergeOption(baseOption, null);
    };
  }();

  return GlobalModel;
}(__WEBPACK_IMPORTED_MODULE_3__Model_js__["a" /* default */]);

function isNotTargetSeries(seriesModel, payload) {
  if (payload) {
    var index = payload.seriesIndex;
    var id = payload.seriesId;
    var name_1 = payload.seriesName;
    return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name_1 != null && seriesModel.name !== name_1;
  }
}

function mergeTheme(option, theme) {
  // PENDING
  // NOT use `colorLayer` in theme if option has `color`
  var notMergeColorLayer = option.color && !option.colorLayer;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(theme, function (themeItem, name) {
    if (name === 'colorLayer' && notMergeColorLayer) {
      return;
    } // If it is component model mainType, the model handles that merge later.
    // otherwise, merge them here.


    if (!__WEBPACK_IMPORTED_MODULE_4__Component_js__["a" /* default */].hasClass(name)) {
      if (typeof themeItem === 'object') {
        option[name] = !option[name] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"])(themeItem) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"])(option[name], themeItem, false);
      } else {
        if (option[name] == null) {
          option[name] = themeItem;
        }
      }
    }
  });
}

function queryByIdOrName(attr, idOrName, cmpts) {
  // Here is a break from echarts4: string and number are
  // treated as equal.
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(idOrName)) {
    var keyMap_1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"])();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(idOrName, function (idOrNameItem) {
      if (idOrNameItem != null) {
        var idName = __WEBPACK_IMPORTED_MODULE_2__util_model_js__["n" /* convertOptionIdName */](idOrNameItem, null);
        idName != null && keyMap_1.set(idOrNameItem, true);
      }
    });
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["filter"])(cmpts, function (cmpt) {
      return cmpt && keyMap_1.get(cmpt[attr]);
    });
  } else {
    var idName_1 = __WEBPACK_IMPORTED_MODULE_2__util_model_js__["n" /* convertOptionIdName */](idOrName, null);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["filter"])(cmpts, function (cmpt) {
      return cmpt && idName_1 != null && cmpt[attr] === idName_1;
    });
  }
}

function filterBySubType(components, condition) {
  // Using hasOwnProperty for restrict. Consider
  // subType is undefined in user payload.
  return condition.hasOwnProperty('subType') ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["filter"])(components, function (cmpt) {
    return cmpt && cmpt.subType === condition.subType;
  }) : components;
}

function normalizeSetOptionInput(opts) {
  var replaceMergeMainTypeMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"])();
  opts && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(__WEBPACK_IMPORTED_MODULE_2__util_model_js__["d" /* normalizeToArray */](opts.replaceMerge), function (mainType) {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"])(__WEBPACK_IMPORTED_MODULE_4__Component_js__["a" /* default */].hasClass(mainType), '"' + mainType + '" is not valid component main type in "replaceMerge"');
    }

    replaceMergeMainTypeMap.set(mainType, true);
  });
  return {
    replaceMergeMainTypeMap: replaceMergeMainTypeMap
  };
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["mixin"])(GlobalModel, __WEBPACK_IMPORTED_MODULE_8__mixin_palette_js__["a" /* PaletteMixin */]);
/* harmony default export */ __webpack_exports__["a"] = (GlobalModel);

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = registerInternalOptionCreator;
/* harmony export (immutable) */ __webpack_exports__["a"] = concatInternalOptions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


var internalOptionCreatorMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();
function registerInternalOptionCreator(mainType, creator) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(internalOptionCreatorMap.get(mainType) == null && creator);
  internalOptionCreatorMap.set(mainType, creator);
}
function concatInternalOptions(ecModel, mainType, newCmptOptionList) {
  var internalOptionCreator = internalOptionCreatorMap.get(mainType);

  if (!internalOptionCreator) {
    return newCmptOptionList;
  }

  var internalOptions = internalOptionCreator(ecModel);

  if (!internalOptions) {
    return newCmptOptionList;
  }

  if (true) {
    for (var i = 0; i < internalOptions.length; i++) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_model_js__["s" /* isComponentIdInternal */])(internalOptions[i]));
    }
  }

  return newCmptOptionList.concat(internalOptions);
}

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ITEM_STYLE_KEY_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemStyleMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__makeStyleMapper_js__ = __webpack_require__(160);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var ITEM_STYLE_KEY_MAP = [['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor'], ['lineDash', 'borderType'], ['lineDashOffset', 'borderDashOffset'], ['lineCap', 'borderCap'], ['lineJoin', 'borderJoin'], ['miterLimit', 'borderMiterLimit'] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
// So do not transfer decal directly.
];
var getItemStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__makeStyleMapper_js__["a" /* default */])(ITEM_STYLE_KEY_MAP);

var ItemStyleMixin =
/** @class */
function () {
  function ItemStyleMixin() {}

  ItemStyleMixin.prototype.getItemStyle = function (excludes, includes) {
    return getItemStyle(this, excludes, includes);
  };

  return ItemStyleMixin;
}();



/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LINE_STYLE_KEY_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LineStyleMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__makeStyleMapper_js__ = __webpack_require__(160);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var LINE_STYLE_KEY_MAP = [['lineWidth', 'width'], ['stroke', 'color'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor'], ['lineDash', 'type'], ['lineDashOffset', 'dashOffset'], ['lineCap', 'cap'], ['lineJoin', 'join'], ['miterLimit'] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
// So do not transfer decal directly.
];
var getLineStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__makeStyleMapper_js__["a" /* default */])(LINE_STYLE_KEY_MAP);

var LineStyleMixin =
/** @class */
function () {
  function LineStyleMixin() {}

  LineStyleMixin.prototype.getLineStyle = function (excludes) {
    return getLineStyle(this, excludes);
  };

  return LineStyleMixin;
}();

;


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dataSample;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var samplers = {
  average: function (frame) {
    var sum = 0;
    var count = 0;

    for (var i = 0; i < frame.length; i++) {
      if (!isNaN(frame[i])) {
        sum += frame[i];
        count++;
      }
    } // Return NaN if count is 0


    return count === 0 ? NaN : sum / count;
  },
  sum: function (frame) {
    var sum = 0;

    for (var i = 0; i < frame.length; i++) {
      // Ignore NaN
      sum += frame[i] || 0;
    }

    return sum;
  },
  max: function (frame) {
    var max = -Infinity;

    for (var i = 0; i < frame.length; i++) {
      frame[i] > max && (max = frame[i]);
    } // NaN will cause illegal axis extent.


    return isFinite(max) ? max : NaN;
  },
  min: function (frame) {
    var min = Infinity;

    for (var i = 0; i < frame.length; i++) {
      frame[i] < min && (min = frame[i]);
    } // NaN will cause illegal axis extent.


    return isFinite(min) ? min : NaN;
  },
  // TODO
  // Median
  nearest: function (frame) {
    return frame[0];
  }
};

var indexSampler = function (frame) {
  return Math.round(frame.length / 2);
};

function dataSample(seriesType) {
  return {
    seriesType: seriesType,
    // FIXME:TS never used, so comment it
    // modifyOutputEnd: true,
    reset: function (seriesModel, ecModel, api) {
      var data = seriesModel.getData();
      var sampling = seriesModel.get('sampling');
      var coordSys = seriesModel.coordinateSystem;
      var count = data.count(); // Only cartesian2d support down sampling. Disable it when there is few data.

      if (count > 10 && coordSys.type === 'cartesian2d' && sampling) {
        var baseAxis = coordSys.getBaseAxis();
        var valueAxis = coordSys.getOtherAxis(baseAxis);
        var extent = baseAxis.getExtent();
        var dpr = api.getDevicePixelRatio(); // Coordinste system has been resized

        var size = Math.abs(extent[1] - extent[0]) * (dpr || 1);
        var rate = Math.round(count / size);

        if (isFinite(rate) && rate > 1) {
          if (sampling === 'lttb') {
            seriesModel.setData(data.lttbDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
          }

          var sampler = void 0;

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"])(sampling)) {
            sampler = samplers[sampling];
          } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"])(sampling)) {
            sampler = sampling;
          }

          if (sampler) {
            // Only support sample the first dim mapped from value axis.
            seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, indexSampler));
          }
        }
      }
    }
  };
}

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Scale_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_OrdinalMeta_js__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Linear continuous scale
 * http://en.wikipedia.org/wiki/Level_of_measurement
 */
// FIXME only one data






var OrdinalScale =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(OrdinalScale, _super);

  function OrdinalScale(setting) {
    var _this = _super.call(this, setting) || this;

    _this.type = 'ordinal';

    var ordinalMeta = _this.getSetting('ordinalMeta'); // Caution: Should not use instanceof, consider ec-extensions using
    // import approach to get OrdinalMeta class.


    if (!ordinalMeta) {
      ordinalMeta = new __WEBPACK_IMPORTED_MODULE_2__data_OrdinalMeta_js__["a" /* default */]({});
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["isArray"])(ordinalMeta)) {
      ordinalMeta = new __WEBPACK_IMPORTED_MODULE_2__data_OrdinalMeta_js__["a" /* default */]({
        categories: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["map"])(ordinalMeta, function (item) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["isObject"])(item) ? item.value : item;
        })
      });
    }

    _this._ordinalMeta = ordinalMeta;
    _this._extent = _this.getSetting('extent') || [0, ordinalMeta.categories.length - 1];
    return _this;
  }

  OrdinalScale.prototype.parse = function (val) {
    // Caution: Math.round(null) will return `0` rather than `NaN`
    if (val == null) {
      return NaN;
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["isString"])(val) ? this._ordinalMeta.getOrdinal(val) // val might be float.
    : Math.round(val);
  };

  OrdinalScale.prototype.contain = function (rank) {
    rank = this.parse(rank);
    return __WEBPACK_IMPORTED_MODULE_3__helper_js__["a" /* contain */](rank, this._extent) && this._ordinalMeta.categories[rank] != null;
  };
  /**
   * Normalize given rank or name to linear [0, 1]
   * @param val raw ordinal number.
   * @return normalized value in [0, 1].
   */


  OrdinalScale.prototype.normalize = function (val) {
    val = this._getTickNumber(this.parse(val));
    return __WEBPACK_IMPORTED_MODULE_3__helper_js__["b" /* normalize */](val, this._extent);
  };
  /**
   * @param val normalized value in [0, 1].
   * @return raw ordinal number.
   */


  OrdinalScale.prototype.scale = function (val) {
    val = Math.round(__WEBPACK_IMPORTED_MODULE_3__helper_js__["c" /* scale */](val, this._extent));
    return this.getRawOrdinalNumber(val);
  };

  OrdinalScale.prototype.getTicks = function () {
    var ticks = [];
    var extent = this._extent;
    var rank = extent[0];

    while (rank <= extent[1]) {
      ticks.push({
        value: rank
      });
      rank++;
    }

    return ticks;
  };

  OrdinalScale.prototype.getMinorTicks = function (splitNumber) {
    // Not support.
    return;
  };
  /**
   * @see `Ordinal['_ordinalNumbersByTick']`
   */


  OrdinalScale.prototype.setSortInfo = function (info) {
    if (info == null) {
      this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
      return;
    }

    var infoOrdinalNumbers = info.ordinalNumbers;
    var ordinalsByTick = this._ordinalNumbersByTick = [];
    var ticksByOrdinal = this._ticksByOrdinalNumber = []; // Unnecessary support negative tick in `realtimeSort`.

    var tickNum = 0;
    var allCategoryLen = this._ordinalMeta.categories.length;

    for (var len = Math.min(allCategoryLen, infoOrdinalNumbers.length); tickNum < len; ++tickNum) {
      var ordinalNumber = infoOrdinalNumbers[tickNum];
      ordinalsByTick[tickNum] = ordinalNumber;
      ticksByOrdinal[ordinalNumber] = tickNum;
    } // Handle that `series.data` only covers part of the `axis.category.data`.


    var unusedOrdinal = 0;

    for (; tickNum < allCategoryLen; ++tickNum) {
      while (ticksByOrdinal[unusedOrdinal] != null) {
        unusedOrdinal++;
      }

      ;
      ordinalsByTick.push(unusedOrdinal);
      ticksByOrdinal[unusedOrdinal] = tickNum;
    }
  };

  OrdinalScale.prototype._getTickNumber = function (ordinal) {
    var ticksByOrdinalNumber = this._ticksByOrdinalNumber; // also support ordinal out of range of `ordinalMeta.categories.length`,
    // where ordinal numbers are used as tick value directly.

    return ticksByOrdinalNumber && ordinal >= 0 && ordinal < ticksByOrdinalNumber.length ? ticksByOrdinalNumber[ordinal] : ordinal;
  };
  /**
   * @usage
   * ```js
   * const ordinalNumber = ordinalScale.getRawOrdinalNumber(tickVal);
   *
   * // case0
   * const rawOrdinalValue = axisModel.getCategories()[ordinalNumber];
   * // case1
   * const rawOrdinalValue = this._ordinalMeta.categories[ordinalNumber];
   * // case2
   * const coord = axis.dataToCoord(ordinalNumber);
   * ```
   *
   * @param {OrdinalNumber} tickNumber index of display
   */


  OrdinalScale.prototype.getRawOrdinalNumber = function (tickNumber) {
    var ordinalNumbersByTick = this._ordinalNumbersByTick; // tickNumber may be out of range, e.g., when axis max is larger than `ordinalMeta.categories.length`.,
    // where ordinal numbers are used as tick value directly.

    return ordinalNumbersByTick && tickNumber >= 0 && tickNumber < ordinalNumbersByTick.length ? ordinalNumbersByTick[tickNumber] : tickNumber;
  };
  /**
   * Get item on tick
   */


  OrdinalScale.prototype.getLabel = function (tick) {
    if (!this.isBlank()) {
      var ordinalNumber = this.getRawOrdinalNumber(tick.value);
      var cateogry = this._ordinalMeta.categories[ordinalNumber]; // Note that if no data, ordinalMeta.categories is an empty array.
      // Return empty if it's not exist.

      return cateogry == null ? '' : cateogry + '';
    }
  };

  OrdinalScale.prototype.count = function () {
    return this._extent[1] - this._extent[0] + 1;
  };

  OrdinalScale.prototype.unionExtentFromData = function (data, dim) {
    this.unionExtent(data.getApproximateExtent(dim));
  };
  /**
   * @override
   * If value is in extent range
   */


  OrdinalScale.prototype.isInExtentRange = function (value) {
    value = this._getTickNumber(value);
    return this._extent[0] <= value && this._extent[1] >= value;
  };

  OrdinalScale.prototype.getOrdinalMeta = function () {
    return this._ordinalMeta;
  };

  OrdinalScale.prototype.calcNiceTicks = function () {};

  OrdinalScale.prototype.calcNiceExtent = function () {};

  OrdinalScale.type = 'ordinal';
  return OrdinalScale;
}(__WEBPACK_IMPORTED_MODULE_1__Scale_js__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1__Scale_js__["a" /* default */].registerClass(OrdinalScale);
/* harmony default export */ __webpack_exports__["a"] = (OrdinalScale);

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_time_js__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Interval_js__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Scale_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_log_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* A third-party license is embeded for some of the code in this file:
* The "scaleLevels" was originally copied from "d3.js" with some
* modifications made for this project.
* (See more details in the comment on the definition of "scaleLevels" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/
// [About UTC and local time zone]:
// In most cases, `number.parseDate` will treat input data string as local time
// (except time zone is specified in time string). And `format.formateTime` returns
// local time by default. option.useUTC is false by default. This design have
// concidered these common case:
// (1) Time that is persistent in server is in UTC, but it is needed to be diplayed
// in local time by default.
// (2) By default, the input data string (e.g., '2011-01-02') should be displayed
// as its original time, without any time difference.







 // FIXME 公用？

var bisect = function (a, x, lo, hi) {
  while (lo < hi) {
    var mid = lo + hi >>> 1;

    if (a[mid][1] < x) {
      lo = mid + 1;
    } else {
      hi = mid;
    }
  }

  return lo;
};

var TimeScale =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(TimeScale, _super);

  function TimeScale(settings) {
    var _this = _super.call(this, settings) || this;

    _this.type = 'time';
    return _this;
  }
  /**
   * Get label is mainly for other components like dataZoom, tooltip.
   */


  TimeScale.prototype.getLabel = function (tick) {
    var useUTC = this.getSetting('useUTC');
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["a" /* format */])(tick.value, __WEBPACK_IMPORTED_MODULE_2__util_time_js__["c" /* fullLeveledFormatter */][__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["d" /* getDefaultFormatPrecisionOfInterval */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["e" /* getPrimaryTimeUnit */])(this._minLevelUnit))] || __WEBPACK_IMPORTED_MODULE_2__util_time_js__["c" /* fullLeveledFormatter */].second, useUTC, this.getSetting('locale'));
  };

  TimeScale.prototype.getFormattedLabel = function (tick, idx, labelFormatter) {
    var isUTC = this.getSetting('useUTC');
    var lang = this.getSetting('locale');
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["f" /* leveledFormat */])(tick, idx, labelFormatter, lang, isUTC);
  };
  /**
   * @override
   */


  TimeScale.prototype.getTicks = function () {
    var interval = this._interval;
    var extent = this._extent;
    var ticks = []; // If interval is 0, return [];

    if (!interval) {
      return ticks;
    }

    ticks.push({
      value: extent[0],
      level: 0
    });
    var useUTC = this.getSetting('useUTC');
    var innerTicks = getIntervalTicks(this._minLevelUnit, this._approxInterval, useUTC, extent);
    ticks = ticks.concat(innerTicks);
    ticks.push({
      value: extent[1],
      level: 0
    });
    return ticks;
  };

  TimeScale.prototype.calcNiceExtent = function (opt) {
    var extent = this._extent; // If extent start and end are same, expand them

    if (extent[0] === extent[1]) {
      // Expand extent
      extent[0] -= __WEBPACK_IMPORTED_MODULE_2__util_time_js__["g" /* ONE_DAY */];
      extent[1] += __WEBPACK_IMPORTED_MODULE_2__util_time_js__["g" /* ONE_DAY */];
    } // If there are no data and extent are [Infinity, -Infinity]


    if (extent[1] === -Infinity && extent[0] === Infinity) {
      var d = new Date();
      extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
      extent[0] = extent[1] - __WEBPACK_IMPORTED_MODULE_2__util_time_js__["g" /* ONE_DAY */];
    }

    this.calcNiceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
  };

  TimeScale.prototype.calcNiceTicks = function (approxTickNum, minInterval, maxInterval) {
    approxTickNum = approxTickNum || 10;
    var extent = this._extent;
    var span = extent[1] - extent[0];
    this._approxInterval = span / approxTickNum;

    if (minInterval != null && this._approxInterval < minInterval) {
      this._approxInterval = minInterval;
    }

    if (maxInterval != null && this._approxInterval > maxInterval) {
      this._approxInterval = maxInterval;
    }

    var scaleIntervalsLen = scaleIntervals.length;
    var idx = Math.min(bisect(scaleIntervals, this._approxInterval, 0, scaleIntervalsLen), scaleIntervalsLen - 1); // Interval that can be used to calculate ticks

    this._interval = scaleIntervals[idx][1]; // Min level used when picking ticks from top down.
    // We check one more level to avoid the ticks are to sparse in some case.

    this._minLevelUnit = scaleIntervals[Math.max(idx - 1, 0)][0];
  };

  TimeScale.prototype.parse = function (val) {
    // val might be float.
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_util_js__["isNumber"])(val) ? val : +__WEBPACK_IMPORTED_MODULE_1__util_number_js__["f" /* parseDate */](val);
  };

  TimeScale.prototype.contain = function (val) {
    return __WEBPACK_IMPORTED_MODULE_3__helper_js__["a" /* contain */](this.parse(val), this._extent);
  };

  TimeScale.prototype.normalize = function (val) {
    return __WEBPACK_IMPORTED_MODULE_3__helper_js__["b" /* normalize */](this.parse(val), this._extent);
  };

  TimeScale.prototype.scale = function (val) {
    return __WEBPACK_IMPORTED_MODULE_3__helper_js__["c" /* scale */](val, this._extent);
  };

  TimeScale.type = 'time';
  return TimeScale;
}(__WEBPACK_IMPORTED_MODULE_4__Interval_js__["a" /* default */]);
/**
 * This implementation was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */


var scaleIntervals = [// Format                           interval
['second', __WEBPACK_IMPORTED_MODULE_2__util_time_js__["h" /* ONE_SECOND */]], ['minute', __WEBPACK_IMPORTED_MODULE_2__util_time_js__["i" /* ONE_MINUTE */]], ['hour', __WEBPACK_IMPORTED_MODULE_2__util_time_js__["j" /* ONE_HOUR */]], ['quarter-day', __WEBPACK_IMPORTED_MODULE_2__util_time_js__["j" /* ONE_HOUR */] * 6], ['half-day', __WEBPACK_IMPORTED_MODULE_2__util_time_js__["j" /* ONE_HOUR */] * 12], ['day', __WEBPACK_IMPORTED_MODULE_2__util_time_js__["g" /* ONE_DAY */] * 1.2], ['half-week', __WEBPACK_IMPORTED_MODULE_2__util_time_js__["g" /* ONE_DAY */] * 3.5], ['week', __WEBPACK_IMPORTED_MODULE_2__util_time_js__["g" /* ONE_DAY */] * 7], ['month', __WEBPACK_IMPORTED_MODULE_2__util_time_js__["g" /* ONE_DAY */] * 31], ['quarter', __WEBPACK_IMPORTED_MODULE_2__util_time_js__["g" /* ONE_DAY */] * 95], ['half-year', __WEBPACK_IMPORTED_MODULE_2__util_time_js__["k" /* ONE_YEAR */] / 2], ['year', __WEBPACK_IMPORTED_MODULE_2__util_time_js__["k" /* ONE_YEAR */]] // 1Y
];

function isUnitValueSame(unit, valueA, valueB, isUTC) {
  var dateA = __WEBPACK_IMPORTED_MODULE_1__util_number_js__["f" /* parseDate */](valueA);
  var dateB = __WEBPACK_IMPORTED_MODULE_1__util_number_js__["f" /* parseDate */](valueB);

  var isSame = function (unit) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["l" /* getUnitValue */])(dateA, unit, isUTC) === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["l" /* getUnitValue */])(dateB, unit, isUTC);
  };

  var isSameYear = function () {
    return isSame('year');
  }; // const isSameHalfYear = () => isSameYear() && isSame('half-year');
  // const isSameQuater = () => isSameYear() && isSame('quarter');


  var isSameMonth = function () {
    return isSameYear() && isSame('month');
  };

  var isSameDay = function () {
    return isSameMonth() && isSame('day');
  }; // const isSameHalfDay = () => isSameDay() && isSame('half-day');


  var isSameHour = function () {
    return isSameDay() && isSame('hour');
  };

  var isSameMinute = function () {
    return isSameHour() && isSame('minute');
  };

  var isSameSecond = function () {
    return isSameMinute() && isSame('second');
  };

  var isSameMilliSecond = function () {
    return isSameSecond() && isSame('millisecond');
  };

  switch (unit) {
    case 'year':
      return isSameYear();

    case 'month':
      return isSameMonth();

    case 'day':
      return isSameDay();

    case 'hour':
      return isSameHour();

    case 'minute':
      return isSameMinute();

    case 'second':
      return isSameSecond();

    case 'millisecond':
      return isSameMilliSecond();
  }
} // const primaryUnitGetters = {
//     year: fullYearGetterName(),
//     month: monthGetterName(),
//     day: dateGetterName(),
//     hour: hoursGetterName(),
//     minute: minutesGetterName(),
//     second: secondsGetterName(),
//     millisecond: millisecondsGetterName()
// };
// const primaryUnitUTCGetters = {
//     year: fullYearGetterName(true),
//     month: monthGetterName(true),
//     day: dateGetterName(true),
//     hour: hoursGetterName(true),
//     minute: minutesGetterName(true),
//     second: secondsGetterName(true),
//     millisecond: millisecondsGetterName(true)
// };
// function moveTick(date: Date, unitName: TimeUnit, step: number, isUTC: boolean) {
//     step = step || 1;
//     switch (getPrimaryTimeUnit(unitName)) {
//         case 'year':
//             date[fullYearSetterName(isUTC)](date[fullYearGetterName(isUTC)]() + step);
//             break;
//         case 'month':
//             date[monthSetterName(isUTC)](date[monthGetterName(isUTC)]() + step);
//             break;
//         case 'day':
//             date[dateSetterName(isUTC)](date[dateGetterName(isUTC)]() + step);
//             break;
//         case 'hour':
//             date[hoursSetterName(isUTC)](date[hoursGetterName(isUTC)]() + step);
//             break;
//         case 'minute':
//             date[minutesSetterName(isUTC)](date[minutesGetterName(isUTC)]() + step);
//             break;
//         case 'second':
//             date[secondsSetterName(isUTC)](date[secondsGetterName(isUTC)]() + step);
//             break;
//         case 'millisecond':
//             date[millisecondsSetterName(isUTC)](date[millisecondsGetterName(isUTC)]() + step);
//             break;
//     }
//     return date.getTime();
// }
// const DATE_INTERVALS = [[8, 7.5], [4, 3.5], [2, 1.5]];
// const MONTH_INTERVALS = [[6, 5.5], [3, 2.5], [2, 1.5]];
// const MINUTES_SECONDS_INTERVALS = [[30, 30], [20, 20], [15, 15], [10, 10], [5, 5], [2, 2]];


function getDateInterval(approxInterval, daysInMonth) {
  approxInterval /= __WEBPACK_IMPORTED_MODULE_2__util_time_js__["g" /* ONE_DAY */];
  return approxInterval > 16 ? 16 // Math.floor(daysInMonth / 2) + 1  // In this case we only want one tick betwen two month.
  : approxInterval > 7.5 ? 7 // TODO week 7 or day 8?
  : approxInterval > 3.5 ? 4 : approxInterval > 1.5 ? 2 : 1;
}

function getMonthInterval(approxInterval) {
  var APPROX_ONE_MONTH = 30 * __WEBPACK_IMPORTED_MODULE_2__util_time_js__["g" /* ONE_DAY */];
  approxInterval /= APPROX_ONE_MONTH;
  return approxInterval > 6 ? 6 : approxInterval > 3 ? 3 : approxInterval > 2 ? 2 : 1;
}

function getHourInterval(approxInterval) {
  approxInterval /= __WEBPACK_IMPORTED_MODULE_2__util_time_js__["j" /* ONE_HOUR */];
  return approxInterval > 12 ? 12 : approxInterval > 6 ? 6 : approxInterval > 3.5 ? 4 : approxInterval > 2 ? 2 : 1;
}

function getMinutesAndSecondsInterval(approxInterval, isMinutes) {
  approxInterval /= isMinutes ? __WEBPACK_IMPORTED_MODULE_2__util_time_js__["i" /* ONE_MINUTE */] : __WEBPACK_IMPORTED_MODULE_2__util_time_js__["h" /* ONE_SECOND */];
  return approxInterval > 30 ? 30 : approxInterval > 20 ? 20 : approxInterval > 15 ? 15 : approxInterval > 10 ? 10 : approxInterval > 5 ? 5 : approxInterval > 2 ? 2 : 1;
}

function getMillisecondsInterval(approxInterval) {
  return __WEBPACK_IMPORTED_MODULE_1__util_number_js__["m" /* nice */](approxInterval, true);
}

function getFirstTimestampOfUnit(date, unitName, isUTC) {
  var outDate = new Date(date);

  switch (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["e" /* getPrimaryTimeUnit */])(unitName)) {
    case 'year':
    case 'month':
      outDate[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["m" /* monthSetterName */])(isUTC)](0);

    case 'day':
      outDate[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["n" /* dateSetterName */])(isUTC)](1);

    case 'hour':
      outDate[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["o" /* hoursSetterName */])(isUTC)](0);

    case 'minute':
      outDate[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["p" /* minutesSetterName */])(isUTC)](0);

    case 'second':
      outDate[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["q" /* secondsSetterName */])(isUTC)](0);
      outDate[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["r" /* millisecondsSetterName */])(isUTC)](0);
  }

  return outDate.getTime();
}

function getIntervalTicks(bottomUnitName, approxInterval, isUTC, extent) {
  var safeLimit = 10000;
  var unitNames = __WEBPACK_IMPORTED_MODULE_2__util_time_js__["s" /* timeUnits */];
  var iter = 0;

  function addTicksInSpan(interval, minTimestamp, maxTimestamp, getMethodName, setMethodName, isDate, out) {
    var date = new Date(minTimestamp);
    var dateTime = minTimestamp;
    var d = date[getMethodName](); // if (isDate) {
    //     d -= 1; // Starts with 0;   PENDING
    // }

    while (dateTime < maxTimestamp && dateTime <= extent[1]) {
      out.push({
        value: dateTime
      });
      d += interval;
      date[setMethodName](d);
      dateTime = date.getTime();
    } // This extra tick is for calcuating ticks of next level. Will not been added to the final result


    out.push({
      value: dateTime,
      notAdd: true
    });
  }

  function addLevelTicks(unitName, lastLevelTicks, levelTicks) {
    var newAddedTicks = [];
    var isFirstLevel = !lastLevelTicks.length;

    if (isUnitValueSame(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["e" /* getPrimaryTimeUnit */])(unitName), extent[0], extent[1], isUTC)) {
      return;
    }

    if (isFirstLevel) {
      lastLevelTicks = [{
        // TODO Optimize. Not include so may ticks.
        value: getFirstTimestampOfUnit(new Date(extent[0]), unitName, isUTC)
      }, {
        value: extent[1]
      }];
    }

    for (var i = 0; i < lastLevelTicks.length - 1; i++) {
      var startTick = lastLevelTicks[i].value;
      var endTick = lastLevelTicks[i + 1].value;

      if (startTick === endTick) {
        continue;
      }

      var interval = void 0;
      var getterName = void 0;
      var setterName = void 0;
      var isDate = false;

      switch (unitName) {
        case 'year':
          interval = Math.max(1, Math.round(approxInterval / __WEBPACK_IMPORTED_MODULE_2__util_time_js__["g" /* ONE_DAY */] / 365));
          getterName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["t" /* fullYearGetterName */])(isUTC);
          setterName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["u" /* fullYearSetterName */])(isUTC);
          break;

        case 'half-year':
        case 'quarter':
        case 'month':
          interval = getMonthInterval(approxInterval);
          getterName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["v" /* monthGetterName */])(isUTC);
          setterName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["m" /* monthSetterName */])(isUTC);
          break;

        case 'week': // PENDING If week is added. Ignore day.

        case 'half-week':
        case 'day':
          interval = getDateInterval(approxInterval, 31); // Use 32 days and let interval been 16

          getterName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["w" /* dateGetterName */])(isUTC);
          setterName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["n" /* dateSetterName */])(isUTC);
          isDate = true;
          break;

        case 'half-day':
        case 'quarter-day':
        case 'hour':
          interval = getHourInterval(approxInterval);
          getterName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["x" /* hoursGetterName */])(isUTC);
          setterName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["o" /* hoursSetterName */])(isUTC);
          break;

        case 'minute':
          interval = getMinutesAndSecondsInterval(approxInterval, true);
          getterName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["y" /* minutesGetterName */])(isUTC);
          setterName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["p" /* minutesSetterName */])(isUTC);
          break;

        case 'second':
          interval = getMinutesAndSecondsInterval(approxInterval, false);
          getterName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["z" /* secondsGetterName */])(isUTC);
          setterName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["q" /* secondsSetterName */])(isUTC);
          break;

        case 'millisecond':
          interval = getMillisecondsInterval(approxInterval);
          getterName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["A" /* millisecondsGetterName */])(isUTC);
          setterName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["r" /* millisecondsSetterName */])(isUTC);
          break;
      }

      addTicksInSpan(interval, startTick, endTick, getterName, setterName, isDate, newAddedTicks);

      if (unitName === 'year' && levelTicks.length > 1 && i === 0) {
        // Add nearest years to the left extent.
        levelTicks.unshift({
          value: levelTicks[0].value - interval
        });
      }
    }

    for (var i = 0; i < newAddedTicks.length; i++) {
      levelTicks.push(newAddedTicks[i]);
    } // newAddedTicks.length && console.log(unitName, newAddedTicks);


    return newAddedTicks;
  }

  var levelsTicks = [];
  var currentLevelTicks = [];
  var tickCount = 0;
  var lastLevelTickCount = 0;

  for (var i = 0; i < unitNames.length && iter++ < safeLimit; ++i) {
    var primaryTimeUnit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["e" /* getPrimaryTimeUnit */])(unitNames[i]);

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["B" /* isPrimaryTimeUnit */])(unitNames[i])) {
      // TODO
      continue;
    }

    addLevelTicks(unitNames[i], levelsTicks[levelsTicks.length - 1] || [], currentLevelTicks);
    var nextPrimaryTimeUnit = unitNames[i + 1] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_time_js__["e" /* getPrimaryTimeUnit */])(unitNames[i + 1]) : null;

    if (primaryTimeUnit !== nextPrimaryTimeUnit) {
      if (currentLevelTicks.length) {
        lastLevelTickCount = tickCount; // Remove the duplicate so the tick count can be precisely.

        currentLevelTicks.sort(function (a, b) {
          return a.value - b.value;
        });
        var levelTicksRemoveDuplicated = [];

        for (var i_1 = 0; i_1 < currentLevelTicks.length; ++i_1) {
          var tickValue = currentLevelTicks[i_1].value;

          if (i_1 === 0 || currentLevelTicks[i_1 - 1].value !== tickValue) {
            levelTicksRemoveDuplicated.push(currentLevelTicks[i_1]);

            if (tickValue >= extent[0] && tickValue <= extent[1]) {
              tickCount++;
            }
          }
        }

        var targetTickNum = (extent[1] - extent[0]) / approxInterval; // Added too much in this level and not too less in last level

        if (tickCount > targetTickNum * 1.5 && lastLevelTickCount > targetTickNum / 1.5) {
          break;
        } // Only treat primary time unit as one level.


        levelsTicks.push(levelTicksRemoveDuplicated);

        if (tickCount > targetTickNum || bottomUnitName === unitNames[i]) {
          break;
        }
      } // Reset if next unitName is primary


      currentLevelTicks = [];
    }
  }

  if (true) {
    if (iter >= safeLimit) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_log_js__["b" /* warn */])('Exceed safe limit.');
    }
  }

  var levelsTicksInExtent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_util_js__["filter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_util_js__["map"])(levelsTicks, function (levelTicks) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_util_js__["filter"])(levelTicks, function (tick) {
      return tick.value >= extent[0] && tick.value <= extent[1] && !tick.notAdd;
    });
  }), function (levelTicks) {
    return levelTicks.length > 0;
  });
  var ticks = [];
  var maxLevel = levelsTicksInExtent.length - 1;

  for (var i = 0; i < levelsTicksInExtent.length; ++i) {
    var levelTicks = levelsTicksInExtent[i];

    for (var k = 0; k < levelTicks.length; ++k) {
      ticks.push({
        value: levelTicks[k].value,
        level: maxLevel - i
      });
    }
  }

  ticks.sort(function (a, b) {
    return a.value - b.value;
  }); // Remove duplicates

  var result = [];

  for (var i = 0; i < ticks.length; ++i) {
    if (i === 0 || ticks[i].value !== ticks[i - 1].value) {
      result.push(ticks[i]);
    }
  }

  return result;
}

__WEBPACK_IMPORTED_MODULE_5__Scale_js__["a" /* default */].registerClass(TimeScale);
/* harmony default export */ __webpack_exports__["a"] = (TimeScale);

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphic_js__ = __webpack_require__(4);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * Sausage: similar to sector, but have half circle on both sides
 */

var SausageShape =
/** @class */
function () {
  function SausageShape() {
    this.cx = 0;
    this.cy = 0;
    this.r0 = 0;
    this.r = 0;
    this.startAngle = 0;
    this.endAngle = Math.PI * 2;
    this.clockwise = true;
  }

  return SausageShape;
}();

var SausagePath =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(SausagePath, _super);

  function SausagePath(opts) {
    var _this = _super.call(this, opts) || this;

    _this.type = 'sausage';
    return _this;
  }

  SausagePath.prototype.getDefaultShape = function () {
    return new SausageShape();
  };

  SausagePath.prototype.buildPath = function (ctx, shape) {
    var cx = shape.cx;
    var cy = shape.cy;
    var r0 = Math.max(shape.r0 || 0, 0);
    var r = Math.max(shape.r, 0);
    var dr = (r - r0) * 0.5;
    var rCenter = r0 + dr;
    var startAngle = shape.startAngle;
    var endAngle = shape.endAngle;
    var clockwise = shape.clockwise;
    var PI2 = Math.PI * 2;
    var lessThanCircle = clockwise ? endAngle - startAngle < PI2 : startAngle - endAngle < PI2;

    if (!lessThanCircle) {
      // Normalize angles
      startAngle = endAngle - (clockwise ? PI2 : -PI2);
    }

    var unitStartX = Math.cos(startAngle);
    var unitStartY = Math.sin(startAngle);
    var unitEndX = Math.cos(endAngle);
    var unitEndY = Math.sin(endAngle);

    if (lessThanCircle) {
      ctx.moveTo(unitStartX * r0 + cx, unitStartY * r0 + cy);
      ctx.arc(unitStartX * rCenter + cx, unitStartY * rCenter + cy, dr, -Math.PI + startAngle, startAngle, !clockwise);
    } else {
      ctx.moveTo(unitStartX * r + cx, unitStartY * r + cy);
    }

    ctx.arc(cx, cy, r, startAngle, endAngle, !clockwise);
    ctx.arc(unitEndX * rCenter + cx, unitEndY * rCenter + cy, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);

    if (r0 !== 0) {
      ctx.arc(cx, cy, r0, endAngle, startAngle, clockwise);
    } // ctx.closePath();

  };

  return SausagePath;
}(__WEBPACK_IMPORTED_MODULE_1__graphic_js__["Path"]);

/* harmony default export */ __webpack_exports__["a"] = (SausagePath);

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isEC4CompatibleStyle;
/* harmony export (immutable) */ __webpack_exports__["b"] = convertFromEC4CompatibleStyle;
/* harmony export (immutable) */ __webpack_exports__["d"] = convertToEC4StyleForCustomSerise;
/* harmony export (immutable) */ __webpack_exports__["c"] = warnDeprecated;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var deprecatedLogs = {};
/**
 * Whether need to call `convertEC4CompatibleStyle`.
 */

function isEC4CompatibleStyle(style, elType, hasOwnTextContentOption, hasOwnTextConfig) {
  // Since echarts5, `RectText` is separated from its host element and style.text
  // does not exist any more. The compat work brings some extra burden on performance.
  // So we provide:
  // `legacy: true` force make compat.
  // `legacy: false`, force do not compat.
  // `legacy` not set: auto detect wheter legacy.
  //     But in this case we do not compat (difficult to detect and rare case):
  //     Becuse custom series and graphic component support "merge", users may firstly
  //     only set `textStrokeWidth` style or secondly only set `text`.
  return style && (style.legacy || style.legacy !== false && !hasOwnTextContentOption && !hasOwnTextConfig && elType !== 'tspan' // Difficult to detect whether legacy for a "text" el.
  && (elType === 'text' || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(style, 'text')));
}
/**
 * `EC4CompatibleStyle` is style that might be in echarts4 format or echarts5 format.
 * @param hostStyle The properties might be modified.
 * @return If be text el, `textContentStyle` and `textConfig` will not be retured.
 *         Otherwise a `textContentStyle` and `textConfig` will be created, whose props area
 *         retried from the `hostStyle`.
 */

function convertFromEC4CompatibleStyle(hostStyle, elType, isNormal) {
  var srcStyle = hostStyle;
  var textConfig;
  var textContent;
  var textContentStyle;

  if (elType === 'text') {
    textContentStyle = srcStyle;
  } else {
    textContentStyle = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(srcStyle, 'text') && (textContentStyle.text = srcStyle.text);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(srcStyle, 'rich') && (textContentStyle.rich = srcStyle.rich);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(srcStyle, 'textFill') && (textContentStyle.fill = srcStyle.textFill);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(srcStyle, 'textStroke') && (textContentStyle.stroke = srcStyle.textStroke);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(srcStyle, 'fontFamily') && (textContentStyle.fontFamily = srcStyle.fontFamily);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(srcStyle, 'fontSize') && (textContentStyle.fontSize = srcStyle.fontSize);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(srcStyle, 'fontStyle') && (textContentStyle.fontStyle = srcStyle.fontStyle);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(srcStyle, 'fontWeight') && (textContentStyle.fontWeight = srcStyle.fontWeight);
    textContent = {
      type: 'text',
      style: textContentStyle,
      // ec4 do not support rectText trigger.
      // And when text postion is different in normal and emphasis
      // => hover text trigger emphasis;
      // => text position changed, leave mouse pointer immediately;
      // That might cause state incorrect.
      silent: true
    };
    textConfig = {};
    var hasOwnPos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(srcStyle, 'textPosition');

    if (isNormal) {
      textConfig.position = hasOwnPos ? srcStyle.textPosition : 'inside';
    } else {
      hasOwnPos && (textConfig.position = srcStyle.textPosition);
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(srcStyle, 'textPosition') && (textConfig.position = srcStyle.textPosition);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(srcStyle, 'textOffset') && (textConfig.offset = srcStyle.textOffset);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(srcStyle, 'textRotation') && (textConfig.rotation = srcStyle.textRotation);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(srcStyle, 'textDistance') && (textConfig.distance = srcStyle.textDistance);
  }

  convertEC4CompatibleRichItem(textContentStyle, hostStyle);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(textContentStyle.rich, function (richItem) {
    convertEC4CompatibleRichItem(richItem, richItem);
  });
  return {
    textConfig: textConfig,
    textContent: textContent
  };
}
/**
 * The result will be set to `out`.
 */

function convertEC4CompatibleRichItem(out, richItem) {
  if (!richItem) {
    return;
  } // (1) For simplicity, make textXXX properties (deprecated since ec5) has
  // higher priority. For example, consider in ec4 `borderColor: 5, textBorderColor: 10`
  // on a rect means `borderColor: 4` on the rect and `borderColor: 10` on an attached
  // richText in ec5.
  // (2) `out === richItem` if and only if `out` is text el or rich item.
  // So we can overwite existing props in `out` since textXXX has higher priority.


  richItem.font = richItem.textFont || richItem.font;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'textStrokeWidth') && (out.lineWidth = richItem.textStrokeWidth);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'textAlign') && (out.align = richItem.textAlign);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'textVerticalAlign') && (out.verticalAlign = richItem.textVerticalAlign);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'textLineHeight') && (out.lineHeight = richItem.textLineHeight);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'textWidth') && (out.width = richItem.textWidth);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'textHeight') && (out.height = richItem.textHeight);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'textBackgroundColor') && (out.backgroundColor = richItem.textBackgroundColor);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'textPadding') && (out.padding = richItem.textPadding);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'textBorderColor') && (out.borderColor = richItem.textBorderColor);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'textBorderWidth') && (out.borderWidth = richItem.textBorderWidth);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'textBorderRadius') && (out.borderRadius = richItem.textBorderRadius);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'textBoxShadowColor') && (out.shadowColor = richItem.textBoxShadowColor);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'textBoxShadowBlur') && (out.shadowBlur = richItem.textBoxShadowBlur);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'textBoxShadowOffsetX') && (out.shadowOffsetX = richItem.textBoxShadowOffsetX);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'textBoxShadowOffsetY') && (out.shadowOffsetY = richItem.textBoxShadowOffsetY);
}
/**
 * Convert to pure echarts4 format style.
 * `itemStyle` will be modified, added with ec4 style properties from
 * `textStyle` and `textConfig`.
 *
 * [Caveat]: For simplicity, `insideRollback` in ec4 does not compat, where
 * `styleEmphasis: {textFill: 'red'}` will remove the normal auto added stroke.
 */


function convertToEC4StyleForCustomSerise(itemStl, txStl, txCfg) {
  var out = itemStl; // See `custom.ts`, a trick to set extra `textPosition` firstly.

  out.textPosition = out.textPosition || txCfg.position || 'inside';
  txCfg.offset != null && (out.textOffset = txCfg.offset);
  txCfg.rotation != null && (out.textRotation = txCfg.rotation);
  txCfg.distance != null && (out.textDistance = txCfg.distance);
  var isInside = out.textPosition.indexOf('inside') >= 0;
  var hostFill = itemStl.fill || '#000';
  convertToEC4RichItem(out, txStl);
  var textFillNotSet = out.textFill == null;

  if (isInside) {
    if (textFillNotSet) {
      out.textFill = txCfg.insideFill || '#fff';
      !out.textStroke && txCfg.insideStroke && (out.textStroke = txCfg.insideStroke);
      !out.textStroke && (out.textStroke = hostFill);
      out.textStrokeWidth == null && (out.textStrokeWidth = 2);
    }
  } else {
    if (textFillNotSet) {
      out.textFill = itemStl.fill || txCfg.outsideFill || '#000';
    }

    !out.textStroke && txCfg.outsideStroke && (out.textStroke = txCfg.outsideStroke);
  }

  out.text = txStl.text;
  out.rich = txStl.rich;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(txStl.rich, function (richItem) {
    convertToEC4RichItem(richItem, richItem);
  });
  return out;
}

function convertToEC4RichItem(out, richItem) {
  if (!richItem) {
    return;
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'fill') && (out.textFill = richItem.fill);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'stroke') && (out.textStroke = richItem.fill);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'lineWidth') && (out.textStrokeWidth = richItem.lineWidth);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'font') && (out.font = richItem.font);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'fontStyle') && (out.fontStyle = richItem.fontStyle);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'fontWeight') && (out.fontWeight = richItem.fontWeight);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'fontSize') && (out.fontSize = richItem.fontSize);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'fontFamily') && (out.fontFamily = richItem.fontFamily);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'align') && (out.textAlign = richItem.align);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'verticalAlign') && (out.textVerticalAlign = richItem.verticalAlign);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'lineHeight') && (out.textLineHeight = richItem.lineHeight);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'width') && (out.textWidth = richItem.width);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'height') && (out.textHeight = richItem.height);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'backgroundColor') && (out.textBackgroundColor = richItem.backgroundColor);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'padding') && (out.textPadding = richItem.padding);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'borderColor') && (out.textBorderColor = richItem.borderColor);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'borderWidth') && (out.textBorderWidth = richItem.borderWidth);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'borderRadius') && (out.textBorderRadius = richItem.borderRadius);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'shadowColor') && (out.textBoxShadowColor = richItem.shadowColor);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'shadowBlur') && (out.textBoxShadowBlur = richItem.shadowBlur);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'shadowOffsetX') && (out.textBoxShadowOffsetX = richItem.shadowOffsetX);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'shadowOffsetY') && (out.textBoxShadowOffsetY = richItem.shadowOffsetY);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'textShadowColor') && (out.textShadowColor = richItem.textShadowColor);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'textShadowBlur') && (out.textShadowBlur = richItem.textShadowBlur);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'textShadowOffsetX') && (out.textShadowOffsetX = richItem.textShadowOffsetX);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(richItem, 'textShadowOffsetY') && (out.textShadowOffsetY = richItem.textShadowOffsetY);
}

function warnDeprecated(deprecated, insteadApproach) {
  if (true) {
    var key = deprecated + '^_^' + insteadApproach;

    if (!deprecatedLogs[key]) {
      console.warn("[ECharts] DEPRECATED: \"" + deprecated + "\" has been deprecated. " + insteadApproach);
      deprecatedLogs[key] = true;
    }
  }
}

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * @file Visual mapping.
 */

var visualDefault = {
  /**
   * @public
   */
  get: function (visualType, key, isCategory) {
    var value = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["clone"]((defaultOption[visualType] || {})[key]);
    return isCategory ? __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](value) ? value[value.length - 1] : value : value;
  }
};
var defaultOption = {
  color: {
    active: ['#006edd', '#e0ffff'],
    inactive: ['rgba(0,0,0,0)']
  },
  colorHue: {
    active: [0, 360],
    inactive: [0, 0]
  },
  colorSaturation: {
    active: [0.3, 1],
    inactive: [0, 0]
  },
  colorLightness: {
    active: [0.9, 0.5],
    inactive: [0, 0]
  },
  colorAlpha: {
    active: [0.3, 1],
    inactive: [0, 0]
  },
  opacity: {
    active: [0.3, 1],
    inactive: [0, 0]
  },
  symbol: {
    active: ['circle', 'roundRect', 'diamond'],
    inactive: ['none']
  },
  symbolSize: {
    active: [10, 50],
    inactive: [0, 0]
  }
};
/* harmony default export */ __webpack_exports__["a"] = (visualDefault);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__ = __webpack_require__(1444);






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__["a" /* default */];
MapCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__["a" /* default */];
MapCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__["a" /* default */];
MapCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__["a" /* default */];
MapCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (MapCache);


/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stackClear_js__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stackGet_js__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stackHas_js__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stackSet_js__ = __webpack_require__(1455);







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */](entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = __WEBPACK_IMPORTED_MODULE_1__stackClear_js__["a" /* default */];
Stack.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__["a" /* default */];
Stack.prototype.get = __WEBPACK_IMPORTED_MODULE_3__stackGet_js__["a" /* default */];
Stack.prototype.has = __WEBPACK_IMPORTED_MODULE_4__stackHas_js__["a" /* default */];
Stack.prototype.set = __WEBPACK_IMPORTED_MODULE_5__stackSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Stack);


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ __webpack_exports__["a"] = (apply);


/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBuffer_js__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIndex_js__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__ = __webpack_require__(534);







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value),
      isArg = !isArr && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value),
      isBuff = !isArr && !isArg && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isBuffer_js__["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__["a" /* default */])(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__isIndex_js__["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayLikeKeys);


/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(250);



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(object[key], value)) ||
      (value === undefined && !(key in object))) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignMergeValue);


/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayEach_js__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assignValue_js__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseAssign_js__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseAssignIn_js__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cloneBuffer_js__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__copyArray_js__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__copySymbols_js__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__copySymbolsIn_js__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getAllKeys_js__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__getAllKeysIn_js__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__getTag_js__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__initCloneArray_js__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__initCloneByTag_js__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__initCloneObject_js__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__isArray_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__isBuffer_js__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__isMap_js__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__isObject_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__isSet_js__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__keys_js__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__keysIn_js__ = __webpack_require__(201);























/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__isObject_js__["a" /* default */])(value)) {
    return value;
  }
  var isArr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__isArray_js__["a" /* default */])(value);
  if (isArr) {
    result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__initCloneArray_js__["a" /* default */])(value);
    if (!isDeep) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__copyArray_js__["a" /* default */])(value, result);
    }
  } else {
    var tag = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__getTag_js__["a" /* default */])(value),
        isFunc = tag == funcTag || tag == genTag;

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__isBuffer_js__["a" /* default */])(value)) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__cloneBuffer_js__["a" /* default */])(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__initCloneObject_js__["a" /* default */])(value);
      if (!isDeep) {
        return isFlat
          ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__copySymbolsIn_js__["a" /* default */])(value, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__baseAssignIn_js__["a" /* default */])(result, value))
          : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__copySymbols_js__["a" /* default */])(value, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseAssign_js__["a" /* default */])(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__initCloneByTag_js__["a" /* default */])(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__isSet_js__["a" /* default */])(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__isMap_js__["a" /* default */])(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? __WEBPACK_IMPORTED_MODULE_10__getAllKeysIn_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_9__getAllKeys_js__["a" /* default */])
    : (isFlat ? __WEBPACK_IMPORTED_MODULE_21__keysIn_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_20__keys_js__["a" /* default */]);

  var props = isArr ? undefined : keysFunc(value);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__arrayEach_js__["a" /* default */])(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assignValue_js__["a" /* default */])(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseClone);


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toKey_js__ = __webpack_require__(249);



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toKey_js__["a" /* default */])(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (baseGet);


/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(101);



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(object) ? result : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, symbolsFunc(object));
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetAllKeys);


/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseFor_js__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isObject_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keysIn_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__safeGet_js__ = __webpack_require__(529);








/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseFor_js__["a" /* default */])(source, function(srcValue, key) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__isObject_js__["a" /* default */])(srcValue)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__["a" /* default */])(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__safeGet_js__["a" /* default */])(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__["a" /* default */])(object, key, newValue);
    }
  }, __WEBPACK_IMPORTED_MODULE_5__keysIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMerge);


/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overRest_js__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setToString_js__ = __webpack_require__(530);




/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__setToString_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__overRest_js__["a" /* default */])(func, start, __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */]), func + '');
}

/* harmony default export */ __webpack_exports__["a"] = (baseRest);


/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(87);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(357)(module)))

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(342);


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneTypedArray);


/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (copyArray);


/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(137);


var defineProperty = (function() {
  try {
    var func = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (defineProperty);


/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flatten_js__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overRest_js__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setToString_js__ = __webpack_require__(530);




/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__setToString_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__overRest_js__["a" /* default */])(func, undefined, __WEBPACK_IMPORTED_MODULE_0__flatten_js__["a" /* default */]), func + '');
}

/* harmony default export */ __webpack_exports__["a"] = (flatRest);


/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(50)))

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keysIn_js__ = __webpack_require__(201);




/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keysIn_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeysIn);


/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getSymbols_js__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stubArray_js__ = __webpack_require__(535);





/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_3__stubArray_js__["a" /* default */] : function(object) {
  var result = [];
  while (object) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getSymbols_js__["a" /* default */])(object));
    object = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object);
  }
  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbolsIn);


/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isPrototype_js__ = __webpack_require__(346);




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isPrototype_js__["a" /* default */])(object))
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object))
    : {};
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneObject);


/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(509);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(func, this, otherArgs);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overRest);


/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (safeGet);


/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortOut_js__ = __webpack_require__(1450);



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shortOut_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (setToString);


/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (identity);


/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(115);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(347);




/* Node.js helper references. */
var nodeIsTypedArray = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsTypedArray) : __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isTypedArray);


/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (stubArray);


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1479);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50)))

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1643)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(629),
  /* template */
  __webpack_require__(1574),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4d5edbb1",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/common/CommonScore.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CommonScore.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4d5edbb1", Component.options)
  } else {
    hotAPI.reload("data-v-4d5edbb1", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1675)
  __webpack_require__(1674)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(637),
  /* template */
  __webpack_require__(1604),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d4c1c57a",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/bizmanagement/budget/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d4c1c57a", Component.options)
  } else {
    hotAPI.reload("data-v-d4c1c57a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1667)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(638),
  /* template */
  __webpack_require__(1597),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-acafa2c2",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/bizmanagement/domainresult/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-acafa2c2", Component.options)
  } else {
    hotAPI.reload("data-v-acafa2c2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1637)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(639),
  /* template */
  __webpack_require__(1568),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-421f5da2",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/bizmanagement/hospitallevel/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-421f5da2", Component.options)
  } else {
    hotAPI.reload("data-v-421f5da2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1631)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(640),
  /* template */
  __webpack_require__(1563),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3a9422a3",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/bizmanagement/speakerlevel/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3a9422a3", Component.options)
  } else {
    hotAPI.reload("data-v-3a9422a3", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1676)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(641),
  /* template */
  __webpack_require__(1605),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e8ad199e",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/bizmanagement/strategy/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e8ad199e", Component.options)
  } else {
    hotAPI.reload("data-v-e8ad199e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1681)
  __webpack_require__(1680)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(642),
  /* template */
  __webpack_require__(1609),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f8e3b742",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/dashboard/budget/index-old.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index-old.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f8e3b742", Component.options)
  } else {
    hotAPI.reload("data-v-f8e3b742", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1644)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(643),
  /* template */
  __webpack_require__(1575),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e0dfd05",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/dashboard/budget/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4e0dfd05", Component.options)
  } else {
    hotAPI.reload("data-v-4e0dfd05", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1654)
  __webpack_require__(1653)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(644),
  /* template */
  __webpack_require__(1584),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6911dd6e",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/dashboard/effectiveness/index-old.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index-old.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6911dd6e", Component.options)
  } else {
    hotAPI.reload("data-v-6911dd6e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1624)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(645),
  /* template */
  __webpack_require__(1556),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-25be9594",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/dashboard/effectiveness/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-25be9594", Component.options)
  } else {
    hotAPI.reload("data-v-25be9594", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1684)
  __webpack_require__(1683)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(647),
  /* template */
  __webpack_require__(1611),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fc17aeaa",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/dashboard/meeting/index-old.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index-old.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fc17aeaa", Component.options)
  } else {
    hotAPI.reload("data-v-fc17aeaa", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1636)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(648),
  /* template */
  __webpack_require__(1567),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-415a0751",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/dashboard/meeting/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-415a0751", Component.options)
  } else {
    hotAPI.reload("data-v-415a0751", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1620)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(649),
  /* template */
  __webpack_require__(1551),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/dashboard/sample/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1375c92a", Component.options)
  } else {
    hotAPI.reload("data-v-1375c92a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1633)
  __webpack_require__(1632)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(650),
  /* template */
  __webpack_require__(1564),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ddf5019",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/meetingplan/application/edit/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3ddf5019", Component.options)
  } else {
    hotAPI.reload("data-v-3ddf5019", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1616)
  __webpack_require__(1615)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(651),
  /* template */
  __webpack_require__(1547),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-04a6ca76",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/meetingplan/application/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-04a6ca76", Component.options)
  } else {
    hotAPI.reload("data-v-04a6ca76", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1678)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(652),
  /* template */
  __webpack_require__(1607),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f3df5218",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/meetingplan/application/view/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f3df5218", Component.options)
  } else {
    hotAPI.reload("data-v-f3df5218", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1621)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(653),
  /* template */
  __webpack_require__(1553),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1aae7a60",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/meetingplan/authorizedtask/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1aae7a60", Component.options)
  } else {
    hotAPI.reload("data-v-1aae7a60", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1618)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(654),
  /* template */
  __webpack_require__(1549),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-07c4f24c",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/meetingplan/authorizedtask/view/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-07c4f24c", Component.options)
  } else {
    hotAPI.reload("data-v-07c4f24c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1659)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(655),
  /* template */
  __webpack_require__(1589),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-79d0c4be",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/meetingplan/library/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-79d0c4be", Component.options)
  } else {
    hotAPI.reload("data-v-79d0c4be", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1671)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(656),
  /* template */
  __webpack_require__(1601),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b4e872ae",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/meetingplan/library/view/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b4e872ae", Component.options)
  } else {
    hotAPI.reload("data-v-b4e872ae", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1627)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(657),
  /* template */
  __webpack_require__(1559),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3240deb5",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/meetingplan/task/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3240deb5", Component.options)
  } else {
    hotAPI.reload("data-v-3240deb5", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1646)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(658),
  /* template */
  __webpack_require__(1577),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-55241215",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/meetingplan/task/view/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-55241215", Component.options)
  } else {
    hotAPI.reload("data-v-55241215", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1650)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(659),
  /* template */
  __webpack_require__(1581),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-60b986d2",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/messages/list/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-60b986d2", Component.options)
  } else {
    hotAPI.reload("data-v-60b986d2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1658)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(662),
  /* template */
  __webpack_require__(1588),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-778fac58",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/sysmanagement/dictlist/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-778fac58", Component.options)
  } else {
    hotAPI.reload("data-v-778fac58", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1649)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(663),
  /* template */
  __webpack_require__(1580),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5ac98730",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/sysmanagement/emailtemplate/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5ac98730", Component.options)
  } else {
    hotAPI.reload("data-v-5ac98730", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1623)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(664),
  /* template */
  __webpack_require__(1555),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-22555b23",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/sysmanagement/menu/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-22555b23", Component.options)
  } else {
    hotAPI.reload("data-v-22555b23", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1679)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(665),
  /* template */
  __webpack_require__(1608),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f6034e3e",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/sysmanagement/monthadjust/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f6034e3e", Component.options)
  } else {
    hotAPI.reload("data-v-f6034e3e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1663)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(666),
  /* template */
  __webpack_require__(1593),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-81adb67a",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/sysmanagement/privilege/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-81adb67a", Component.options)
  } else {
    hotAPI.reload("data-v-81adb67a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1662)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(667),
  /* template */
  __webpack_require__(1592),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7f1a157a",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/sysmanagement/role/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7f1a157a", Component.options)
  } else {
    hotAPI.reload("data-v-7f1a157a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1666)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(669),
  /* template */
  __webpack_require__(1596),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a48d6594",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/sysmanagement/seasonadjust/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a48d6594", Component.options)
  } else {
    hotAPI.reload("data-v-a48d6594", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1682)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(670),
  /* template */
  __webpack_require__(1610),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f99456ea",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/sysmanagement/systemnotice/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f99456ea", Component.options)
  } else {
    hotAPI.reload("data-v-f99456ea", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1622)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(672),
  /* template */
  __webpack_require__(1554),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21495f3c",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/user/authorizedlevel/add/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-21495f3c", Component.options)
  } else {
    hotAPI.reload("data-v-21495f3c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1645)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(673),
  /* template */
  __webpack_require__(1576),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4f13d1ac",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/user/authorizedlevel/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4f13d1ac", Component.options)
  } else {
    hotAPI.reload("data-v-4f13d1ac", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1648)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(674),
  /* template */
  __webpack_require__(1579),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a8124dd",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/user/authorizelm/add/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5a8124dd", Component.options)
  } else {
    hotAPI.reload("data-v-5a8124dd", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1640)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(675),
  /* template */
  __webpack_require__(1571),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4628556a",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/user/authorizelm/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4628556a", Component.options)
  } else {
    hotAPI.reload("data-v-4628556a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1634)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(676),
  /* template */
  __webpack_require__(1565),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f6fd5ea",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/user/center/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3f6fd5ea", Component.options)
  } else {
    hotAPI.reload("data-v-3f6fd5ea", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1619)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(677),
  /* template */
  __webpack_require__(1550),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0bd5cfca",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/page/user/manual/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0bd5cfca", Component.options)
  } else {
    hotAPI.reload("data-v-0bd5cfca", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PRESERVED_NORMAL_STATE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_Transformable_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__animation_Animator_js__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_Eventful_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contain_text_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_js__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tool_color_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphic_constants_js__ = __webpack_require__(139);









var PRESERVED_NORMAL_STATE = '__zr_normal__';
var PRIMARY_STATES_KEYS = __WEBPACK_IMPORTED_MODULE_0__core_Transformable_js__["b" /* TRANSFORMABLE_PROPS */].concat(['ignore']);
var DEFAULT_ANIMATABLE_MAP = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["reduce"])(__WEBPACK_IMPORTED_MODULE_0__core_Transformable_js__["b" /* TRANSFORMABLE_PROPS */], function (obj, key) {
    obj[key] = true;
    return obj;
}, { ignore: false });
var tmpTextPosCalcRes = {};
var tmpBoundingRect = new __WEBPACK_IMPORTED_MODULE_2__core_BoundingRect_js__["a" /* default */](0, 0, 0, 0);
var Element = (function () {
    function Element(props) {
        this.id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["guid"])();
        this.animators = [];
        this.currentStates = [];
        this.states = {};
        this._init(props);
    }
    Element.prototype._init = function (props) {
        this.attr(props);
    };
    Element.prototype.drift = function (dx, dy, e) {
        switch (this.draggable) {
            case 'horizontal':
                dy = 0;
                break;
            case 'vertical':
                dx = 0;
                break;
        }
        var m = this.transform;
        if (!m) {
            m = this.transform = [1, 0, 0, 1, 0, 0];
        }
        m[4] += dx;
        m[5] += dy;
        this.decomposeTransform();
        this.markRedraw();
    };
    Element.prototype.beforeUpdate = function () { };
    Element.prototype.afterUpdate = function () { };
    Element.prototype.update = function () {
        this.updateTransform();
        if (this.__dirty) {
            this.updateInnerText();
        }
    };
    Element.prototype.updateInnerText = function (forceUpdate) {
        var textEl = this._textContent;
        if (textEl && (!textEl.ignore || forceUpdate)) {
            if (!this.textConfig) {
                this.textConfig = {};
            }
            var textConfig = this.textConfig;
            var isLocal = textConfig.local;
            var innerTransformable = textEl.innerTransformable;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var textStyleChanged = false;
            innerTransformable.parent = isLocal ? this : null;
            var innerOrigin = false;
            innerTransformable.copyTransform(textEl);
            if (textConfig.position != null) {
                var layoutRect = tmpBoundingRect;
                if (textConfig.layoutRect) {
                    layoutRect.copy(textConfig.layoutRect);
                }
                else {
                    layoutRect.copy(this.getBoundingRect());
                }
                if (!isLocal) {
                    layoutRect.applyTransform(this.transform);
                }
                if (this.calculateTextPosition) {
                    this.calculateTextPosition(tmpTextPosCalcRes, textConfig, layoutRect);
                }
                else {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__contain_text_js__["a" /* calculateTextPosition */])(tmpTextPosCalcRes, textConfig, layoutRect);
                }
                innerTransformable.x = tmpTextPosCalcRes.x;
                innerTransformable.y = tmpTextPosCalcRes.y;
                textAlign = tmpTextPosCalcRes.align;
                textVerticalAlign = tmpTextPosCalcRes.verticalAlign;
                var textOrigin = textConfig.origin;
                if (textOrigin && textConfig.rotation != null) {
                    var relOriginX = void 0;
                    var relOriginY = void 0;
                    if (textOrigin === 'center') {
                        relOriginX = layoutRect.width * 0.5;
                        relOriginY = layoutRect.height * 0.5;
                    }
                    else {
                        relOriginX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__contain_text_js__["b" /* parsePercent */])(textOrigin[0], layoutRect.width);
                        relOriginY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__contain_text_js__["b" /* parsePercent */])(textOrigin[1], layoutRect.height);
                    }
                    innerOrigin = true;
                    innerTransformable.originX = -innerTransformable.x + relOriginX + (isLocal ? 0 : layoutRect.x);
                    innerTransformable.originY = -innerTransformable.y + relOriginY + (isLocal ? 0 : layoutRect.y);
                }
            }
            if (textConfig.rotation != null) {
                innerTransformable.rotation = textConfig.rotation;
            }
            var textOffset = textConfig.offset;
            if (textOffset) {
                innerTransformable.x += textOffset[0];
                innerTransformable.y += textOffset[1];
                if (!innerOrigin) {
                    innerTransformable.originX = -textOffset[0];
                    innerTransformable.originY = -textOffset[1];
                }
            }
            var isInside = textConfig.inside == null
                ? (typeof textConfig.position === 'string' && textConfig.position.indexOf('inside') >= 0)
                : textConfig.inside;
            var innerTextDefaultStyle = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {});
            var textFill = void 0;
            var textStroke = void 0;
            var autoStroke = void 0;
            if (isInside && this.canBeInsideText()) {
                textFill = textConfig.insideFill;
                textStroke = textConfig.insideStroke;
                if (textFill == null || textFill === 'auto') {
                    textFill = this.getInsideTextFill();
                }
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getInsideTextStroke(textFill);
                    autoStroke = true;
                }
            }
            else {
                textFill = textConfig.outsideFill;
                textStroke = textConfig.outsideStroke;
                if (textFill == null || textFill === 'auto') {
                    textFill = this.getOutsideFill();
                }
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getOutsideStroke(textFill);
                    autoStroke = true;
                }
            }
            textFill = textFill || '#000';
            if (textFill !== innerTextDefaultStyle.fill
                || textStroke !== innerTextDefaultStyle.stroke
                || autoStroke !== innerTextDefaultStyle.autoStroke
                || textAlign !== innerTextDefaultStyle.align
                || textVerticalAlign !== innerTextDefaultStyle.verticalAlign) {
                textStyleChanged = true;
                innerTextDefaultStyle.fill = textFill;
                innerTextDefaultStyle.stroke = textStroke;
                innerTextDefaultStyle.autoStroke = autoStroke;
                innerTextDefaultStyle.align = textAlign;
                innerTextDefaultStyle.verticalAlign = textVerticalAlign;
                textEl.setDefaultTextStyle(innerTextDefaultStyle);
            }
            textEl.__dirty |= __WEBPACK_IMPORTED_MODULE_8__graphic_constants_js__["a" /* REDRAW_BIT */];
            if (textStyleChanged) {
                textEl.dirtyStyle(true);
            }
        }
    };
    Element.prototype.canBeInsideText = function () {
        return true;
    };
    Element.prototype.getInsideTextFill = function () {
        return '#fff';
    };
    Element.prototype.getInsideTextStroke = function (textFill) {
        return '#000';
    };
    Element.prototype.getOutsideFill = function () {
        return this.__zr && this.__zr.isDarkMode() ? __WEBPACK_IMPORTED_MODULE_6__config_js__["c" /* LIGHT_LABEL_COLOR */] : __WEBPACK_IMPORTED_MODULE_6__config_js__["a" /* DARK_LABEL_COLOR */];
    };
    Element.prototype.getOutsideStroke = function (textFill) {
        var backgroundColor = this.__zr && this.__zr.getBackgroundColor();
        var colorArr = typeof backgroundColor === 'string' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tool_color_js__["parse"])(backgroundColor);
        if (!colorArr) {
            colorArr = [255, 255, 255, 1];
        }
        var alpha = colorArr[3];
        var isDark = this.__zr.isDarkMode();
        for (var i = 0; i < 3; i++) {
            colorArr[i] = colorArr[i] * alpha + (isDark ? 0 : 255) * (1 - alpha);
        }
        colorArr[3] = 1;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__tool_color_js__["stringify"])(colorArr, 'rgba');
    };
    Element.prototype.traverse = function (cb, context) { };
    Element.prototype.attrKV = function (key, value) {
        if (key === 'textConfig') {
            this.setTextConfig(value);
        }
        else if (key === 'textContent') {
            this.setTextContent(value);
        }
        else if (key === 'clipPath') {
            this.setClipPath(value);
        }
        else if (key === 'extra') {
            this.extra = this.extra || {};
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["extend"])(this.extra, value);
        }
        else {
            this[key] = value;
        }
    };
    Element.prototype.hide = function () {
        this.ignore = true;
        this.markRedraw();
    };
    Element.prototype.show = function () {
        this.ignore = false;
        this.markRedraw();
    };
    Element.prototype.attr = function (keyOrObj, value) {
        if (typeof keyOrObj === 'string') {
            this.attrKV(keyOrObj, value);
        }
        else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["isObject"])(keyOrObj)) {
            var obj = keyOrObj;
            var keysArr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["keys"])(obj);
            for (var i = 0; i < keysArr.length; i++) {
                var key = keysArr[i];
                this.attrKV(key, keyOrObj[key]);
            }
        }
        this.markRedraw();
        return this;
    };
    Element.prototype.saveCurrentToNormalState = function (toState) {
        this._innerSaveToNormal(toState);
        var normalState = this._normalState;
        for (var i = 0; i < this.animators.length; i++) {
            var animator = this.animators[i];
            var fromStateTransition = animator.__fromStateTransition;
            if (animator.getLoop() || fromStateTransition && fromStateTransition !== PRESERVED_NORMAL_STATE) {
                continue;
            }
            var targetName = animator.targetName;
            var target = targetName
                ? normalState[targetName] : normalState;
            animator.saveTo(target);
        }
    };
    Element.prototype._innerSaveToNormal = function (toState) {
        var normalState = this._normalState;
        if (!normalState) {
            normalState = this._normalState = {};
        }
        if (toState.textConfig && !normalState.textConfig) {
            normalState.textConfig = this.textConfig;
        }
        this._savePrimaryToNormal(toState, normalState, PRIMARY_STATES_KEYS);
    };
    Element.prototype._savePrimaryToNormal = function (toState, normalState, primaryKeys) {
        for (var i = 0; i < primaryKeys.length; i++) {
            var key = primaryKeys[i];
            if (toState[key] != null && !(key in normalState)) {
                normalState[key] = this[key];
            }
        }
    };
    Element.prototype.hasState = function () {
        return this.currentStates.length > 0;
    };
    Element.prototype.getState = function (name) {
        return this.states[name];
    };
    Element.prototype.ensureState = function (name) {
        var states = this.states;
        if (!states[name]) {
            states[name] = {};
        }
        return states[name];
    };
    Element.prototype.clearStates = function (noAnimation) {
        this.useState(PRESERVED_NORMAL_STATE, false, noAnimation);
    };
    Element.prototype.useState = function (stateName, keepCurrentStates, noAnimation, forceUseHoverLayer) {
        var toNormalState = stateName === PRESERVED_NORMAL_STATE;
        var hasStates = this.hasState();
        if (!hasStates && toNormalState) {
            return;
        }
        var currentStates = this.currentStates;
        var animationCfg = this.stateTransition;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["indexOf"])(currentStates, stateName) >= 0 && (keepCurrentStates || currentStates.length === 1)) {
            return;
        }
        var state;
        if (this.stateProxy && !toNormalState) {
            state = this.stateProxy(stateName);
        }
        if (!state) {
            state = (this.states && this.states[stateName]);
        }
        if (!state && !toNormalState) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["logError"])("State " + stateName + " not exists.");
            return;
        }
        if (!toNormalState) {
            this.saveCurrentToNormalState(state);
        }
        var useHoverLayer = !!((state && state.hoverLayer) || forceUseHoverLayer);
        if (useHoverLayer) {
            this._toggleHoverLayerFlag(true);
        }
        this._applyStateObj(stateName, state, this._normalState, keepCurrentStates, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) {
            textContent.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        }
        if (textGuide) {
            textGuide.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        }
        if (toNormalState) {
            this.currentStates = [];
            this._normalState = {};
        }
        else {
            if (!keepCurrentStates) {
                this.currentStates = [stateName];
            }
            else {
                this.currentStates.push(stateName);
            }
        }
        this._updateAnimationTargets();
        this.markRedraw();
        if (!useHoverLayer && this.__inHover) {
            this._toggleHoverLayerFlag(false);
            this.__dirty &= ~__WEBPACK_IMPORTED_MODULE_8__graphic_constants_js__["a" /* REDRAW_BIT */];
        }
        return state;
    };
    Element.prototype.useStates = function (states, noAnimation, forceUseHoverLayer) {
        if (!states.length) {
            this.clearStates();
        }
        else {
            var stateObjects = [];
            var currentStates = this.currentStates;
            var len = states.length;
            var notChange = len === currentStates.length;
            if (notChange) {
                for (var i = 0; i < len; i++) {
                    if (states[i] !== currentStates[i]) {
                        notChange = false;
                        break;
                    }
                }
            }
            if (notChange) {
                return;
            }
            for (var i = 0; i < len; i++) {
                var stateName = states[i];
                var stateObj = void 0;
                if (this.stateProxy) {
                    stateObj = this.stateProxy(stateName, states);
                }
                if (!stateObj) {
                    stateObj = this.states[stateName];
                }
                if (stateObj) {
                    stateObjects.push(stateObj);
                }
            }
            var lastStateObj = stateObjects[len - 1];
            var useHoverLayer = !!((lastStateObj && lastStateObj.hoverLayer) || forceUseHoverLayer);
            if (useHoverLayer) {
                this._toggleHoverLayerFlag(true);
            }
            var mergedState = this._mergeStates(stateObjects);
            var animationCfg = this.stateTransition;
            this.saveCurrentToNormalState(mergedState);
            this._applyStateObj(states.join(','), mergedState, this._normalState, false, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
            var textContent = this._textContent;
            var textGuide = this._textGuide;
            if (textContent) {
                textContent.useStates(states, noAnimation, useHoverLayer);
            }
            if (textGuide) {
                textGuide.useStates(states, noAnimation, useHoverLayer);
            }
            this._updateAnimationTargets();
            this.currentStates = states.slice();
            this.markRedraw();
            if (!useHoverLayer && this.__inHover) {
                this._toggleHoverLayerFlag(false);
                this.__dirty &= ~__WEBPACK_IMPORTED_MODULE_8__graphic_constants_js__["a" /* REDRAW_BIT */];
            }
        }
    };
    Element.prototype._updateAnimationTargets = function () {
        for (var i = 0; i < this.animators.length; i++) {
            var animator = this.animators[i];
            if (animator.targetName) {
                animator.changeTarget(this[animator.targetName]);
            }
        }
    };
    Element.prototype.removeState = function (state) {
        var idx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["indexOf"])(this.currentStates, state);
        if (idx >= 0) {
            var currentStates = this.currentStates.slice();
            currentStates.splice(idx, 1);
            this.useStates(currentStates);
        }
    };
    Element.prototype.replaceState = function (oldState, newState, forceAdd) {
        var currentStates = this.currentStates.slice();
        var idx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["indexOf"])(currentStates, oldState);
        var newStateExists = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["indexOf"])(currentStates, newState) >= 0;
        if (idx >= 0) {
            if (!newStateExists) {
                currentStates[idx] = newState;
            }
            else {
                currentStates.splice(idx, 1);
            }
        }
        else if (forceAdd && !newStateExists) {
            currentStates.push(newState);
        }
        this.useStates(currentStates);
    };
    Element.prototype.toggleState = function (state, enable) {
        if (enable) {
            this.useState(state, true);
        }
        else {
            this.removeState(state);
        }
    };
    Element.prototype._mergeStates = function (states) {
        var mergedState = {};
        var mergedTextConfig;
        for (var i = 0; i < states.length; i++) {
            var state = states[i];
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["extend"])(mergedState, state);
            if (state.textConfig) {
                mergedTextConfig = mergedTextConfig || {};
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["extend"])(mergedTextConfig, state.textConfig);
            }
        }
        if (mergedTextConfig) {
            mergedState.textConfig = mergedTextConfig;
        }
        return mergedState;
    };
    Element.prototype._applyStateObj = function (stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        var needsRestoreToNormal = !(state && keepCurrentStates);
        if (state && state.textConfig) {
            this.textConfig = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["extend"])({}, keepCurrentStates ? this.textConfig : normalState.textConfig);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["extend"])(this.textConfig, state.textConfig);
        }
        else if (needsRestoreToNormal) {
            if (normalState.textConfig) {
                this.textConfig = normalState.textConfig;
            }
        }
        var transitionTarget = {};
        var hasTransition = false;
        for (var i = 0; i < PRIMARY_STATES_KEYS.length; i++) {
            var key = PRIMARY_STATES_KEYS[i];
            var propNeedsTransition = transition && DEFAULT_ANIMATABLE_MAP[key];
            if (state && state[key] != null) {
                if (propNeedsTransition) {
                    hasTransition = true;
                    transitionTarget[key] = state[key];
                }
                else {
                    this[key] = state[key];
                }
            }
            else if (needsRestoreToNormal) {
                if (normalState[key] != null) {
                    if (propNeedsTransition) {
                        hasTransition = true;
                        transitionTarget[key] = normalState[key];
                    }
                    else {
                        this[key] = normalState[key];
                    }
                }
            }
        }
        if (!transition) {
            for (var i = 0; i < this.animators.length; i++) {
                var animator = this.animators[i];
                var targetName = animator.targetName;
                if (!animator.getLoop()) {
                    animator.__changeFinalValue(targetName
                        ? (state || normalState)[targetName]
                        : (state || normalState));
                }
            }
        }
        if (hasTransition) {
            this._transitionState(stateName, transitionTarget, animationCfg);
        }
    };
    Element.prototype._attachComponent = function (componentEl) {
        if (componentEl.__zr && !componentEl.__hostTarget) {
            if (true) {
                throw new Error('Text element has been added to zrender.');
            }
            return;
        }
        if (componentEl === this) {
            if (true) {
                throw new Error('Recursive component attachment.');
            }
            return;
        }
        var zr = this.__zr;
        if (zr) {
            componentEl.addSelfToZr(zr);
        }
        componentEl.__zr = zr;
        componentEl.__hostTarget = this;
    };
    Element.prototype._detachComponent = function (componentEl) {
        if (componentEl.__zr) {
            componentEl.removeSelfFromZr(componentEl.__zr);
        }
        componentEl.__zr = null;
        componentEl.__hostTarget = null;
    };
    Element.prototype.getClipPath = function () {
        return this._clipPath;
    };
    Element.prototype.setClipPath = function (clipPath) {
        if (this._clipPath && this._clipPath !== clipPath) {
            this.removeClipPath();
        }
        this._attachComponent(clipPath);
        this._clipPath = clipPath;
        this.markRedraw();
    };
    Element.prototype.removeClipPath = function () {
        var clipPath = this._clipPath;
        if (clipPath) {
            this._detachComponent(clipPath);
            this._clipPath = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextContent = function () {
        return this._textContent;
    };
    Element.prototype.setTextContent = function (textEl) {
        var previousTextContent = this._textContent;
        if (previousTextContent === textEl) {
            return;
        }
        if (previousTextContent && previousTextContent !== textEl) {
            this.removeTextContent();
        }
        if (true) {
            if (textEl.__zr && !textEl.__hostTarget) {
                throw new Error('Text element has been added to zrender.');
            }
        }
        textEl.innerTransformable = new __WEBPACK_IMPORTED_MODULE_0__core_Transformable_js__["a" /* default */]();
        this._attachComponent(textEl);
        this._textContent = textEl;
        this.markRedraw();
    };
    Element.prototype.setTextConfig = function (cfg) {
        if (!this.textConfig) {
            this.textConfig = {};
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["extend"])(this.textConfig, cfg);
        this.markRedraw();
    };
    Element.prototype.removeTextConfig = function () {
        this.textConfig = null;
        this.markRedraw();
    };
    Element.prototype.removeTextContent = function () {
        var textEl = this._textContent;
        if (textEl) {
            textEl.innerTransformable = null;
            this._detachComponent(textEl);
            this._textContent = null;
            this._innerTextDefaultStyle = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextGuideLine = function () {
        return this._textGuide;
    };
    Element.prototype.setTextGuideLine = function (guideLine) {
        if (this._textGuide && this._textGuide !== guideLine) {
            this.removeTextGuideLine();
        }
        this._attachComponent(guideLine);
        this._textGuide = guideLine;
        this.markRedraw();
    };
    Element.prototype.removeTextGuideLine = function () {
        var textGuide = this._textGuide;
        if (textGuide) {
            this._detachComponent(textGuide);
            this._textGuide = null;
            this.markRedraw();
        }
    };
    Element.prototype.markRedraw = function () {
        this.__dirty |= __WEBPACK_IMPORTED_MODULE_8__graphic_constants_js__["a" /* REDRAW_BIT */];
        var zr = this.__zr;
        if (zr) {
            if (this.__inHover) {
                zr.refreshHover();
            }
            else {
                zr.refresh();
            }
        }
        if (this.__hostTarget) {
            this.__hostTarget.markRedraw();
        }
    };
    Element.prototype.dirty = function () {
        this.markRedraw();
    };
    Element.prototype._toggleHoverLayerFlag = function (inHover) {
        this.__inHover = inHover;
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) {
            textContent.__inHover = inHover;
        }
        if (textGuide) {
            textGuide.__inHover = inHover;
        }
    };
    Element.prototype.addSelfToZr = function (zr) {
        if (this.__zr === zr) {
            return;
        }
        this.__zr = zr;
        var animators = this.animators;
        if (animators) {
            for (var i = 0; i < animators.length; i++) {
                zr.animation.addAnimator(animators[i]);
            }
        }
        if (this._clipPath) {
            this._clipPath.addSelfToZr(zr);
        }
        if (this._textContent) {
            this._textContent.addSelfToZr(zr);
        }
        if (this._textGuide) {
            this._textGuide.addSelfToZr(zr);
        }
    };
    Element.prototype.removeSelfFromZr = function (zr) {
        if (!this.__zr) {
            return;
        }
        this.__zr = null;
        var animators = this.animators;
        if (animators) {
            for (var i = 0; i < animators.length; i++) {
                zr.animation.removeAnimator(animators[i]);
            }
        }
        if (this._clipPath) {
            this._clipPath.removeSelfFromZr(zr);
        }
        if (this._textContent) {
            this._textContent.removeSelfFromZr(zr);
        }
        if (this._textGuide) {
            this._textGuide.removeSelfFromZr(zr);
        }
    };
    Element.prototype.animate = function (key, loop, allowDiscreteAnimation) {
        var target = key ? this[key] : this;
        if (true) {
            if (!target) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["logError"])('Property "'
                    + key
                    + '" is not existed in element '
                    + this.id);
                return;
            }
        }
        var animator = new __WEBPACK_IMPORTED_MODULE_1__animation_Animator_js__["a" /* default */](target, loop, allowDiscreteAnimation);
        key && (animator.targetName = key);
        this.addAnimator(animator, key);
        return animator;
    };
    Element.prototype.addAnimator = function (animator, key) {
        var zr = this.__zr;
        var el = this;
        animator.during(function () {
            el.updateDuringAnimation(key);
        }).done(function () {
            var animators = el.animators;
            var idx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["indexOf"])(animators, animator);
            if (idx >= 0) {
                animators.splice(idx, 1);
            }
        });
        this.animators.push(animator);
        if (zr) {
            zr.animation.addAnimator(animator);
        }
        zr && zr.wakeUp();
    };
    Element.prototype.updateDuringAnimation = function (key) {
        this.markRedraw();
    };
    Element.prototype.stopAnimation = function (scope, forwardToLast) {
        var animators = this.animators;
        var len = animators.length;
        var leftAnimators = [];
        for (var i = 0; i < len; i++) {
            var animator = animators[i];
            if (!scope || scope === animator.scope) {
                animator.stop(forwardToLast);
            }
            else {
                leftAnimators.push(animator);
            }
        }
        this.animators = leftAnimators;
        return this;
    };
    Element.prototype.animateTo = function (target, cfg, animationProps) {
        animateTo(this, target, cfg, animationProps);
    };
    Element.prototype.animateFrom = function (target, cfg, animationProps) {
        animateTo(this, target, cfg, animationProps, true);
    };
    Element.prototype._transitionState = function (stateName, target, cfg, animationProps) {
        var animators = animateTo(this, target, cfg, animationProps);
        for (var i = 0; i < animators.length; i++) {
            animators[i].__fromStateTransition = stateName;
        }
    };
    Element.prototype.getBoundingRect = function () {
        return null;
    };
    Element.prototype.getPaintRect = function () {
        return null;
    };
    Element.initDefaultProps = (function () {
        var elProto = Element.prototype;
        elProto.type = 'element';
        elProto.name = '';
        elProto.ignore =
            elProto.silent =
                elProto.isGroup =
                    elProto.draggable =
                        elProto.dragging =
                            elProto.ignoreClip =
                                elProto.__inHover = false;
        elProto.__dirty = __WEBPACK_IMPORTED_MODULE_8__graphic_constants_js__["a" /* REDRAW_BIT */];
        var logs = {};
        function logDeprecatedError(key, xKey, yKey) {
            if (!logs[key + xKey + yKey]) {
                console.warn("DEPRECATED: '" + key + "' has been deprecated. use '" + xKey + "', '" + yKey + "' instead");
                logs[key + xKey + yKey] = true;
            }
        }
        function createLegacyProperty(key, privateKey, xKey, yKey) {
            Object.defineProperty(elProto, key, {
                get: function () {
                    if (true) {
                        logDeprecatedError(key, xKey, yKey);
                    }
                    if (!this[privateKey]) {
                        var pos = this[privateKey] = [];
                        enhanceArray(this, pos);
                    }
                    return this[privateKey];
                },
                set: function (pos) {
                    if (true) {
                        logDeprecatedError(key, xKey, yKey);
                    }
                    this[xKey] = pos[0];
                    this[yKey] = pos[1];
                    this[privateKey] = pos;
                    enhanceArray(this, pos);
                }
            });
            function enhanceArray(self, pos) {
                Object.defineProperty(pos, 0, {
                    get: function () {
                        return self[xKey];
                    },
                    set: function (val) {
                        self[xKey] = val;
                    }
                });
                Object.defineProperty(pos, 1, {
                    get: function () {
                        return self[yKey];
                    },
                    set: function (val) {
                        self[yKey] = val;
                    }
                });
            }
        }
        if (Object.defineProperty) {
            createLegacyProperty('position', '_legacyPos', 'x', 'y');
            createLegacyProperty('scale', '_legacyScale', 'scaleX', 'scaleY');
            createLegacyProperty('origin', '_legacyOrigin', 'originX', 'originY');
        }
    })();
    return Element;
}());
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["mixin"])(Element, __WEBPACK_IMPORTED_MODULE_3__core_Eventful_js__["a" /* default */]);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["mixin"])(Element, __WEBPACK_IMPORTED_MODULE_0__core_Transformable_js__["a" /* default */]);
function animateTo(animatable, target, cfg, animationProps, reverse) {
    cfg = cfg || {};
    var animators = [];
    animateToShallow(animatable, '', animatable, target, cfg, animationProps, animators, reverse);
    var finishCount = animators.length;
    var doneHappened = false;
    var cfgDone = cfg.done;
    var cfgAborted = cfg.aborted;
    var doneCb = function () {
        doneHappened = true;
        finishCount--;
        if (finishCount <= 0) {
            doneHappened
                ? (cfgDone && cfgDone())
                : (cfgAborted && cfgAborted());
        }
    };
    var abortedCb = function () {
        finishCount--;
        if (finishCount <= 0) {
            doneHappened
                ? (cfgDone && cfgDone())
                : (cfgAborted && cfgAborted());
        }
    };
    if (!finishCount) {
        cfgDone && cfgDone();
    }
    if (animators.length > 0 && cfg.during) {
        animators[0].during(function (target, percent) {
            cfg.during(percent);
        });
    }
    for (var i = 0; i < animators.length; i++) {
        var animator = animators[i];
        if (doneCb) {
            animator.done(doneCb);
        }
        if (abortedCb) {
            animator.aborted(abortedCb);
        }
        if (cfg.force) {
            animator.duration(cfg.duration);
        }
        animator.start(cfg.easing);
    }
    return animators;
}
function copyArrShallow(source, target, len) {
    for (var i = 0; i < len; i++) {
        source[i] = target[i];
    }
}
function is2DArray(value) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["isArrayLike"])(value[0]);
}
function copyValue(target, source, key) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["isArrayLike"])(source[key])) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["isArrayLike"])(target[key])) {
            target[key] = [];
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["isTypedArray"])(source[key])) {
            var len = source[key].length;
            if (target[key].length !== len) {
                target[key] = new (source[key].constructor)(len);
                copyArrShallow(target[key], source[key], len);
            }
        }
        else {
            var sourceArr = source[key];
            var targetArr = target[key];
            var len0 = sourceArr.length;
            if (is2DArray(sourceArr)) {
                var len1 = sourceArr[0].length;
                for (var i = 0; i < len0; i++) {
                    if (!targetArr[i]) {
                        targetArr[i] = Array.prototype.slice.call(sourceArr[i]);
                    }
                    else {
                        copyArrShallow(targetArr[i], sourceArr[i], len1);
                    }
                }
            }
            else {
                copyArrShallow(targetArr, sourceArr, len0);
            }
            targetArr.length = sourceArr.length;
        }
    }
    else {
        target[key] = source[key];
    }
}
function isValueSame(val1, val2) {
    return val1 === val2
        || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["isArrayLike"])(val1) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["isArrayLike"])(val2) && is1DArraySame(val1, val2);
}
function is1DArraySame(arr0, arr1) {
    var len = arr0.length;
    if (len !== arr1.length) {
        return false;
    }
    for (var i = 0; i < len; i++) {
        if (arr0[i] !== arr1[i]) {
            return false;
        }
    }
    return true;
}
function animateToShallow(animatable, topKey, animateObj, target, cfg, animationProps, animators, reverse) {
    var targetKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["keys"])(target);
    var duration = cfg.duration;
    var delay = cfg.delay;
    var additive = cfg.additive;
    var setToFinal = cfg.setToFinal;
    var animateAll = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["isObject"])(animationProps);
    var existsAnimators = animatable.animators;
    var animationKeys = [];
    for (var k = 0; k < targetKeys.length; k++) {
        var innerKey = targetKeys[k];
        var targetVal = target[innerKey];
        if (targetVal != null && animateObj[innerKey] != null
            && (animateAll || animationProps[innerKey])) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["isObject"])(targetVal)
                && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["isArrayLike"])(targetVal)
                && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["isGradientObject"])(targetVal)) {
                if (topKey) {
                    if (!reverse) {
                        animateObj[innerKey] = targetVal;
                        animatable.updateDuringAnimation(topKey);
                    }
                    continue;
                }
                animateToShallow(animatable, innerKey, animateObj[innerKey], targetVal, cfg, animationProps && animationProps[innerKey], animators, reverse);
            }
            else {
                animationKeys.push(innerKey);
            }
        }
        else if (!reverse) {
            animateObj[innerKey] = targetVal;
            animatable.updateDuringAnimation(topKey);
            animationKeys.push(innerKey);
        }
    }
    var keyLen = animationKeys.length;
    if (!additive && keyLen) {
        for (var i = 0; i < existsAnimators.length; i++) {
            var animator = existsAnimators[i];
            if (animator.targetName === topKey) {
                var allAborted = animator.stopTracks(animationKeys);
                if (allAborted) {
                    var idx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["indexOf"])(existsAnimators, animator);
                    existsAnimators.splice(idx, 1);
                }
            }
        }
    }
    if (!cfg.force) {
        animationKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["filter"])(animationKeys, function (key) { return !isValueSame(target[key], animateObj[key]); });
        keyLen = animationKeys.length;
    }
    if (keyLen > 0
        || (cfg.force && !animators.length)) {
        var revertedSource = void 0;
        var reversedTarget = void 0;
        var sourceClone = void 0;
        if (reverse) {
            reversedTarget = {};
            if (setToFinal) {
                revertedSource = {};
            }
            for (var i = 0; i < keyLen; i++) {
                var innerKey = animationKeys[i];
                reversedTarget[innerKey] = animateObj[innerKey];
                if (setToFinal) {
                    revertedSource[innerKey] = target[innerKey];
                }
                else {
                    animateObj[innerKey] = target[innerKey];
                }
            }
        }
        else if (setToFinal) {
            sourceClone = {};
            for (var i = 0; i < keyLen; i++) {
                var innerKey = animationKeys[i];
                sourceClone[innerKey] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__animation_Animator_js__["b" /* cloneValue */])(animateObj[innerKey]);
                copyValue(animateObj, target, innerKey);
            }
        }
        var animator = new __WEBPACK_IMPORTED_MODULE_1__animation_Animator_js__["a" /* default */](animateObj, false, false, additive ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["filter"])(existsAnimators, function (animator) { return animator.targetName === topKey; }) : null);
        animator.targetName = topKey;
        if (cfg.scope) {
            animator.scope = cfg.scope;
        }
        if (setToFinal && revertedSource) {
            animator.whenWithKeys(0, revertedSource, animationKeys);
        }
        if (sourceClone) {
            animator.whenWithKeys(0, sourceClone, animationKeys);
        }
        animator.whenWithKeys(duration == null ? 500 : duration, reverse ? reversedTarget : target, animationKeys).delay(delay || 0);
        animatable.addAnimator(animator, topKey);
        animators.push(animator);
    }
}
/* harmony default export */ __webpack_exports__["a"] = (Element);


/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var easingFuncs = {
    linear: function (k) {
        return k;
    },
    quadraticIn: function (k) {
        return k * k;
    },
    quadraticOut: function (k) {
        return k * (2 - k);
    },
    quadraticInOut: function (k) {
        if ((k *= 2) < 1) {
            return 0.5 * k * k;
        }
        return -0.5 * (--k * (k - 2) - 1);
    },
    cubicIn: function (k) {
        return k * k * k;
    },
    cubicOut: function (k) {
        return --k * k * k + 1;
    },
    cubicInOut: function (k) {
        if ((k *= 2) < 1) {
            return 0.5 * k * k * k;
        }
        return 0.5 * ((k -= 2) * k * k + 2);
    },
    quarticIn: function (k) {
        return k * k * k * k;
    },
    quarticOut: function (k) {
        return 1 - (--k * k * k * k);
    },
    quarticInOut: function (k) {
        if ((k *= 2) < 1) {
            return 0.5 * k * k * k * k;
        }
        return -0.5 * ((k -= 2) * k * k * k - 2);
    },
    quinticIn: function (k) {
        return k * k * k * k * k;
    },
    quinticOut: function (k) {
        return --k * k * k * k * k + 1;
    },
    quinticInOut: function (k) {
        if ((k *= 2) < 1) {
            return 0.5 * k * k * k * k * k;
        }
        return 0.5 * ((k -= 2) * k * k * k * k + 2);
    },
    sinusoidalIn: function (k) {
        return 1 - Math.cos(k * Math.PI / 2);
    },
    sinusoidalOut: function (k) {
        return Math.sin(k * Math.PI / 2);
    },
    sinusoidalInOut: function (k) {
        return 0.5 * (1 - Math.cos(Math.PI * k));
    },
    exponentialIn: function (k) {
        return k === 0 ? 0 : Math.pow(1024, k - 1);
    },
    exponentialOut: function (k) {
        return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
    },
    exponentialInOut: function (k) {
        if (k === 0) {
            return 0;
        }
        if (k === 1) {
            return 1;
        }
        if ((k *= 2) < 1) {
            return 0.5 * Math.pow(1024, k - 1);
        }
        return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
    },
    circularIn: function (k) {
        return 1 - Math.sqrt(1 - k * k);
    },
    circularOut: function (k) {
        return Math.sqrt(1 - (--k * k));
    },
    circularInOut: function (k) {
        if ((k *= 2) < 1) {
            return -0.5 * (Math.sqrt(1 - k * k) - 1);
        }
        return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
    },
    elasticIn: function (k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) {
            return 0;
        }
        if (k === 1) {
            return 1;
        }
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        }
        else {
            s = p * Math.asin(1 / a) / (2 * Math.PI);
        }
        return -(a * Math.pow(2, 10 * (k -= 1))
            * Math.sin((k - s) * (2 * Math.PI) / p));
    },
    elasticOut: function (k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) {
            return 0;
        }
        if (k === 1) {
            return 1;
        }
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        }
        else {
            s = p * Math.asin(1 / a) / (2 * Math.PI);
        }
        return (a * Math.pow(2, -10 * k)
            * Math.sin((k - s) * (2 * Math.PI) / p) + 1);
    },
    elasticInOut: function (k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) {
            return 0;
        }
        if (k === 1) {
            return 1;
        }
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        }
        else {
            s = p * Math.asin(1 / a) / (2 * Math.PI);
        }
        if ((k *= 2) < 1) {
            return -0.5 * (a * Math.pow(2, 10 * (k -= 1))
                * Math.sin((k - s) * (2 * Math.PI) / p));
        }
        return a * Math.pow(2, -10 * (k -= 1))
            * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
    },
    backIn: function (k) {
        var s = 1.70158;
        return k * k * ((s + 1) * k - s);
    },
    backOut: function (k) {
        var s = 1.70158;
        return --k * k * ((s + 1) * k + s) + 1;
    },
    backInOut: function (k) {
        var s = 1.70158 * 1.525;
        if ((k *= 2) < 1) {
            return 0.5 * (k * k * ((s + 1) * k - s));
        }
        return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
    },
    bounceIn: function (k) {
        return 1 - easingFuncs.bounceOut(1 - k);
    },
    bounceOut: function (k) {
        if (k < (1 / 2.75)) {
            return 7.5625 * k * k;
        }
        else if (k < (2 / 2.75)) {
            return 7.5625 * (k -= (1.5 / 2.75)) * k + 0.75;
        }
        else if (k < (2.5 / 2.75)) {
            return 7.5625 * (k -= (2.25 / 2.75)) * k + 0.9375;
        }
        else {
            return 7.5625 * (k -= (2.625 / 2.75)) * k + 0.984375;
        }
    },
    bounceInOut: function (k) {
        if (k < 0.5) {
            return easingFuncs.bounceIn(k * 2) * 0.5;
        }
        return easingFuncs.bounceOut(k * 2 - 1) * 0.5 + 0.5;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (easingFuncs);


/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_env_js__ = __webpack_require__(35);

var requestAnimationFrame;
requestAnimationFrame = (__WEBPACK_IMPORTED_MODULE_0__core_env_js__["a" /* default */].hasGlobalWindow
    && ((window.requestAnimationFrame && window.requestAnimationFrame.bind(window))
        || (window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window))
        || window.mozRequestAnimationFrame
        || window.webkitRequestAnimationFrame)) || function (func) {
    return setTimeout(func, 16);
};
/* harmony default export */ __webpack_exports__["a"] = (requestAnimationFrame);


/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export normalizeLineDash */
/* harmony export (immutable) */ __webpack_exports__["a"] = getLineDash;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_util_js__ = __webpack_require__(0);

function normalizeLineDash(lineType, lineWidth) {
    if (!lineType || lineType === 'solid' || !(lineWidth > 0)) {
        return null;
    }
    return lineType === 'dashed'
        ? [4 * lineWidth, 2 * lineWidth]
        : lineType === 'dotted'
            ? [lineWidth]
            : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["isNumber"])(lineType)
                ? [lineType] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["isArray"])(lineType) ? lineType : null;
}
function getLineDash(el) {
    var style = el.style;
    var lineDash = style.lineDash && style.lineWidth > 0 && normalizeLineDash(style.lineDash, style.lineWidth);
    var lineDashOffset = style.lineDashOffset;
    if (lineDash) {
        var lineScale_1 = (style.strokeNoScale && el.getLineScale) ? el.getLineScale() : 1;
        if (lineScale_1 && lineScale_1 !== 1) {
            lineDash = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["map"])(lineDash, function (rawVal) {
                return rawVal / lineScale_1;
            });
            lineDashOffset /= lineScale_1;
        }
    }
    return [lineDash, lineDashOffset];
}


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = containStroke;
function containStroke(x0, y0, x1, y1, lineWidth, x, y) {
    if (lineWidth === 0) {
        return false;
    }
    var _l = lineWidth;
    var _a = 0;
    var _b = x0;
    if ((y > y0 + _l && y > y1 + _l)
        || (y < y0 - _l && y < y1 - _l)
        || (x > x0 + _l && x > x1 + _l)
        || (x < x0 - _l && x < x1 - _l)) {
        return false;
    }
    if (x0 !== x1) {
        _a = (y0 - y1) / (x0 - x1);
        _b = (x0 * y1 - x1 * y0) / (x0 - x1);
    }
    else {
        return Math.abs(x - x0) <= _l / 2;
    }
    var tmp = _a * x - y + _b;
    var _s = tmp * tmp / (_a * _a + 1);
    return _s <= _l / 2 * _l / 2;
}


/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contain;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__windingLine_js__ = __webpack_require__(582);

var EPSILON = 1e-8;
function isAroundEqual(a, b) {
    return Math.abs(a - b) < EPSILON;
}
function contain(points, x, y) {
    var w = 0;
    var p = points[0];
    if (!p) {
        return false;
    }
    for (var i = 1; i < points.length; i++) {
        var p2 = points[i];
        w += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__windingLine_js__["a" /* default */])(p[0], p[1], p2[0], p2[1], x, y);
        p = p2;
    }
    var p0 = points[0];
    if (!isAroundEqual(p[0], p0[0]) || !isAroundEqual(p[1], p0[1])) {
        w += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__windingLine_js__["a" /* default */])(p[0], p[1], p0[0], p0[1], x, y);
    }
    return w !== 0;
}


/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = containStroke;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_curve_js__ = __webpack_require__(57);

function containStroke(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
    if (lineWidth === 0) {
        return false;
    }
    var _l = lineWidth;
    if ((y > y0 + _l && y > y1 + _l && y > y2 + _l)
        || (y < y0 - _l && y < y1 - _l && y < y2 - _l)
        || (x > x0 + _l && x > x1 + _l && x > x2 + _l)
        || (x < x0 - _l && x < x1 - _l && x < x2 - _l)) {
        return false;
    }
    var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_curve_js__["g" /* quadraticProjectPoint */])(x0, y0, x1, y1, x2, y2, x, y, null);
    return d <= _l / 2;
}


/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeRadian;
var PI2 = Math.PI * 2;
function normalizeRadian(angle) {
    angle %= PI2;
    if (angle < 0) {
        angle += PI2;
    }
    return angle;
}


/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = windingLine;
function windingLine(x0, y0, x1, y1, x, y) {
    if ((y > y0 && y > y1) || (y < y0 && y < y1)) {
        return 0;
    }
    if (y1 === y0) {
        return 0;
    }
    var t = (y - y0) / (y1 - y0);
    var dir = y1 < y0 ? 1 : -1;
    if (t === 1 || t === 0) {
        dir = y1 < y0 ? 0.5 : -0.5;
    }
    var x_ = t * (x1 - x0) + x0;
    return x_ === x ? Infinity : x_ > x ? dir : 0;
}


/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = transformLocalCoord;
/* harmony export (immutable) */ __webpack_exports__["b"] = transformCoordWithViewport;
/* harmony export (immutable) */ __webpack_exports__["a"] = isCanvasEl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fourPointsTransform_js__ = __webpack_require__(1702);


var EVENT_SAVED_PROP = '___zrEVENTSAVED';
var _calcOut = [];
function transformLocalCoord(out, elFrom, elTarget, inX, inY) {
    return transformCoordWithViewport(_calcOut, elFrom, inX, inY, true)
        && transformCoordWithViewport(out, elTarget, _calcOut[0], _calcOut[1]);
}
function transformCoordWithViewport(out, el, inX, inY, inverse) {
    if (el.getBoundingClientRect && __WEBPACK_IMPORTED_MODULE_0__env_js__["a" /* default */].domSupported && !isCanvasEl(el)) {
        var saved = el[EVENT_SAVED_PROP] || (el[EVENT_SAVED_PROP] = {});
        var markers = prepareCoordMarkers(el, saved);
        var transformer = preparePointerTransformer(markers, saved, inverse);
        if (transformer) {
            transformer(out, inX, inY);
            return true;
        }
    }
    return false;
}
function prepareCoordMarkers(el, saved) {
    var markers = saved.markers;
    if (markers) {
        return markers;
    }
    markers = saved.markers = [];
    var propLR = ['left', 'right'];
    var propTB = ['top', 'bottom'];
    for (var i = 0; i < 4; i++) {
        var marker = document.createElement('div');
        var stl = marker.style;
        var idxLR = i % 2;
        var idxTB = (i >> 1) % 2;
        stl.cssText = [
            'position: absolute',
            'visibility: hidden',
            'padding: 0',
            'margin: 0',
            'border-width: 0',
            'user-select: none',
            'width:0',
            'height:0',
            propLR[idxLR] + ':0',
            propTB[idxTB] + ':0',
            propLR[1 - idxLR] + ':auto',
            propTB[1 - idxTB] + ':auto',
            ''
        ].join('!important;');
        el.appendChild(marker);
        markers.push(marker);
    }
    return markers;
}
function preparePointerTransformer(markers, saved, inverse) {
    var transformerName = inverse ? 'invTrans' : 'trans';
    var transformer = saved[transformerName];
    var oldSrcCoords = saved.srcCoords;
    var srcCoords = [];
    var destCoords = [];
    var oldCoordTheSame = true;
    for (var i = 0; i < 4; i++) {
        var rect = markers[i].getBoundingClientRect();
        var ii = 2 * i;
        var x = rect.left;
        var y = rect.top;
        srcCoords.push(x, y);
        oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
        destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
    }
    return (oldCoordTheSame && transformer)
        ? transformer
        : (saved.srcCoords = srcCoords,
            saved[transformerName] = inverse
                ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__fourPointsTransform_js__["a" /* buildTransformer */])(destCoords, srcCoords)
                : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__fourPointsTransform_js__["a" /* buildTransformer */])(srcCoords, destCoords));
}
function isCanvasEl(el) {
    return el.nodeName.toUpperCase() === 'CANVAS';
}


/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sort;
var DEFAULT_MIN_MERGE = 32;
var DEFAULT_MIN_GALLOPING = 7;
var DEFAULT_TMP_STORAGE_LENGTH = 256;
function minRunLength(n) {
    var r = 0;
    while (n >= DEFAULT_MIN_MERGE) {
        r |= n & 1;
        n >>= 1;
    }
    return n + r;
}
function makeAscendingRun(array, lo, hi, compare) {
    var runHi = lo + 1;
    if (runHi === hi) {
        return 1;
    }
    if (compare(array[runHi++], array[lo]) < 0) {
        while (runHi < hi && compare(array[runHi], array[runHi - 1]) < 0) {
            runHi++;
        }
        reverseRun(array, lo, runHi);
    }
    else {
        while (runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0) {
            runHi++;
        }
    }
    return runHi - lo;
}
function reverseRun(array, lo, hi) {
    hi--;
    while (lo < hi) {
        var t = array[lo];
        array[lo++] = array[hi];
        array[hi--] = t;
    }
}
function binaryInsertionSort(array, lo, hi, start, compare) {
    if (start === lo) {
        start++;
    }
    for (; start < hi; start++) {
        var pivot = array[start];
        var left = lo;
        var right = start;
        var mid;
        while (left < right) {
            mid = left + right >>> 1;
            if (compare(pivot, array[mid]) < 0) {
                right = mid;
            }
            else {
                left = mid + 1;
            }
        }
        var n = start - left;
        switch (n) {
            case 3:
                array[left + 3] = array[left + 2];
            case 2:
                array[left + 2] = array[left + 1];
            case 1:
                array[left + 1] = array[left];
                break;
            default:
                while (n > 0) {
                    array[left + n] = array[left + n - 1];
                    n--;
                }
        }
        array[left] = pivot;
    }
}
function gallopLeft(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) > 0) {
        maxOffset = length - hint;
        while (offset < maxOffset && compare(value, array[start + hint + offset]) > 0) {
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) {
                offset = maxOffset;
            }
        }
        if (offset > maxOffset) {
            offset = maxOffset;
        }
        lastOffset += hint;
        offset += hint;
    }
    else {
        maxOffset = hint + 1;
        while (offset < maxOffset && compare(value, array[start + hint - offset]) <= 0) {
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) {
                offset = maxOffset;
            }
        }
        if (offset > maxOffset) {
            offset = maxOffset;
        }
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    }
    lastOffset++;
    while (lastOffset < offset) {
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) > 0) {
            lastOffset = m + 1;
        }
        else {
            offset = m;
        }
    }
    return offset;
}
function gallopRight(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) < 0) {
        maxOffset = hint + 1;
        while (offset < maxOffset && compare(value, array[start + hint - offset]) < 0) {
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) {
                offset = maxOffset;
            }
        }
        if (offset > maxOffset) {
            offset = maxOffset;
        }
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    }
    else {
        maxOffset = length - hint;
        while (offset < maxOffset && compare(value, array[start + hint + offset]) >= 0) {
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) {
                offset = maxOffset;
            }
        }
        if (offset > maxOffset) {
            offset = maxOffset;
        }
        lastOffset += hint;
        offset += hint;
    }
    lastOffset++;
    while (lastOffset < offset) {
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) < 0) {
            offset = m;
        }
        else {
            lastOffset = m + 1;
        }
    }
    return offset;
}
function TimSort(array, compare) {
    var minGallop = DEFAULT_MIN_GALLOPING;
    var length = 0;
    var tmpStorageLength = DEFAULT_TMP_STORAGE_LENGTH;
    var stackLength = 0;
    var runStart;
    var runLength;
    var stackSize = 0;
    length = array.length;
    if (length < 2 * DEFAULT_TMP_STORAGE_LENGTH) {
        tmpStorageLength = length >>> 1;
    }
    var tmp = [];
    stackLength = length < 120 ? 5 : length < 1542 ? 10 : length < 119151 ? 19 : 40;
    runStart = [];
    runLength = [];
    function pushRun(_runStart, _runLength) {
        runStart[stackSize] = _runStart;
        runLength[stackSize] = _runLength;
        stackSize += 1;
    }
    function mergeRuns() {
        while (stackSize > 1) {
            var n = stackSize - 2;
            if ((n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1])
                || (n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1])) {
                if (runLength[n - 1] < runLength[n + 1]) {
                    n--;
                }
            }
            else if (runLength[n] > runLength[n + 1]) {
                break;
            }
            mergeAt(n);
        }
    }
    function forceMergeRuns() {
        while (stackSize > 1) {
            var n = stackSize - 2;
            if (n > 0 && runLength[n - 1] < runLength[n + 1]) {
                n--;
            }
            mergeAt(n);
        }
    }
    function mergeAt(i) {
        var start1 = runStart[i];
        var length1 = runLength[i];
        var start2 = runStart[i + 1];
        var length2 = runLength[i + 1];
        runLength[i] = length1 + length2;
        if (i === stackSize - 3) {
            runStart[i + 1] = runStart[i + 2];
            runLength[i + 1] = runLength[i + 2];
        }
        stackSize--;
        var k = gallopRight(array[start2], array, start1, length1, 0, compare);
        start1 += k;
        length1 -= k;
        if (length1 === 0) {
            return;
        }
        length2 = gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
        if (length2 === 0) {
            return;
        }
        if (length1 <= length2) {
            mergeLow(start1, length1, start2, length2);
        }
        else {
            mergeHigh(start1, length1, start2, length2);
        }
    }
    function mergeLow(start1, length1, start2, length2) {
        var i = 0;
        for (i = 0; i < length1; i++) {
            tmp[i] = array[start1 + i];
        }
        var cursor1 = 0;
        var cursor2 = start2;
        var dest = start1;
        array[dest++] = array[cursor2++];
        if (--length2 === 0) {
            for (i = 0; i < length1; i++) {
                array[dest + i] = tmp[cursor1 + i];
            }
            return;
        }
        if (length1 === 1) {
            for (i = 0; i < length2; i++) {
                array[dest + i] = array[cursor2 + i];
            }
            array[dest + length2] = tmp[cursor1];
            return;
        }
        var _minGallop = minGallop;
        var count1;
        var count2;
        var exit;
        while (1) {
            count1 = 0;
            count2 = 0;
            exit = false;
            do {
                if (compare(array[cursor2], tmp[cursor1]) < 0) {
                    array[dest++] = array[cursor2++];
                    count2++;
                    count1 = 0;
                    if (--length2 === 0) {
                        exit = true;
                        break;
                    }
                }
                else {
                    array[dest++] = tmp[cursor1++];
                    count1++;
                    count2 = 0;
                    if (--length1 === 1) {
                        exit = true;
                        break;
                    }
                }
            } while ((count1 | count2) < _minGallop);
            if (exit) {
                break;
            }
            do {
                count1 = gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
                if (count1 !== 0) {
                    for (i = 0; i < count1; i++) {
                        array[dest + i] = tmp[cursor1 + i];
                    }
                    dest += count1;
                    cursor1 += count1;
                    length1 -= count1;
                    if (length1 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = array[cursor2++];
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
                count2 = gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
                if (count2 !== 0) {
                    for (i = 0; i < count2; i++) {
                        array[dest + i] = array[cursor2 + i];
                    }
                    dest += count2;
                    cursor2 += count2;
                    length2 -= count2;
                    if (length2 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = tmp[cursor1++];
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
                _minGallop--;
            } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);
            if (exit) {
                break;
            }
            if (_minGallop < 0) {
                _minGallop = 0;
            }
            _minGallop += 2;
        }
        minGallop = _minGallop;
        minGallop < 1 && (minGallop = 1);
        if (length1 === 1) {
            for (i = 0; i < length2; i++) {
                array[dest + i] = array[cursor2 + i];
            }
            array[dest + length2] = tmp[cursor1];
        }
        else if (length1 === 0) {
            throw new Error();
        }
        else {
            for (i = 0; i < length1; i++) {
                array[dest + i] = tmp[cursor1 + i];
            }
        }
    }
    function mergeHigh(start1, length1, start2, length2) {
        var i = 0;
        for (i = 0; i < length2; i++) {
            tmp[i] = array[start2 + i];
        }
        var cursor1 = start1 + length1 - 1;
        var cursor2 = length2 - 1;
        var dest = start2 + length2 - 1;
        var customCursor = 0;
        var customDest = 0;
        array[dest--] = array[cursor1--];
        if (--length1 === 0) {
            customCursor = dest - (length2 - 1);
            for (i = 0; i < length2; i++) {
                array[customCursor + i] = tmp[i];
            }
            return;
        }
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for (i = length1 - 1; i >= 0; i--) {
                array[customDest + i] = array[customCursor + i];
            }
            array[dest] = tmp[cursor2];
            return;
        }
        var _minGallop = minGallop;
        while (true) {
            var count1 = 0;
            var count2 = 0;
            var exit = false;
            do {
                if (compare(tmp[cursor2], array[cursor1]) < 0) {
                    array[dest--] = array[cursor1--];
                    count1++;
                    count2 = 0;
                    if (--length1 === 0) {
                        exit = true;
                        break;
                    }
                }
                else {
                    array[dest--] = tmp[cursor2--];
                    count2++;
                    count1 = 0;
                    if (--length2 === 1) {
                        exit = true;
                        break;
                    }
                }
            } while ((count1 | count2) < _minGallop);
            if (exit) {
                break;
            }
            do {
                count1 = length1 - gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
                if (count1 !== 0) {
                    dest -= count1;
                    cursor1 -= count1;
                    length1 -= count1;
                    customDest = dest + 1;
                    customCursor = cursor1 + 1;
                    for (i = count1 - 1; i >= 0; i--) {
                        array[customDest + i] = array[customCursor + i];
                    }
                    if (length1 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = tmp[cursor2--];
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
                count2 = length2 - gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
                if (count2 !== 0) {
                    dest -= count2;
                    cursor2 -= count2;
                    length2 -= count2;
                    customDest = dest + 1;
                    customCursor = cursor2 + 1;
                    for (i = 0; i < count2; i++) {
                        array[customDest + i] = tmp[customCursor + i];
                    }
                    if (length2 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = array[cursor1--];
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
                _minGallop--;
            } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);
            if (exit) {
                break;
            }
            if (_minGallop < 0) {
                _minGallop = 0;
            }
            _minGallop += 2;
        }
        minGallop = _minGallop;
        if (minGallop < 1) {
            minGallop = 1;
        }
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for (i = length1 - 1; i >= 0; i--) {
                array[customDest + i] = array[customCursor + i];
            }
            array[dest] = tmp[cursor2];
        }
        else if (length2 === 0) {
            throw new Error();
        }
        else {
            customCursor = dest - (length2 - 1);
            for (i = 0; i < length2; i++) {
                array[customCursor + i] = tmp[i];
            }
        }
    }
    return {
        mergeRuns: mergeRuns,
        forceMergeRuns: forceMergeRuns,
        pushRun: pushRun
    };
}
function sort(array, compare, lo, hi) {
    if (!lo) {
        lo = 0;
    }
    if (!hi) {
        hi = array.length;
    }
    var remaining = hi - lo;
    if (remaining < 2) {
        return;
    }
    var runLength = 0;
    if (remaining < DEFAULT_MIN_MERGE) {
        runLength = makeAscendingRun(array, lo, hi, compare);
        binaryInsertionSort(array, lo, hi, lo + runLength, compare);
        return;
    }
    var ts = TimSort(array, compare);
    var minRun = minRunLength(remaining);
    do {
        runLength = makeAscendingRun(array, lo, hi, compare);
        if (runLength < minRun) {
            var force = remaining;
            if (force > minRun) {
                force = minRun;
            }
            binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
            runLength = force;
        }
        ts.pushRun(lo, runLength);
        ts.mergeRuns();
        remaining -= runLength;
        lo += runLength;
    } while (remaining !== 0);
    ts.forceMergeRuns();
}


/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Path_js__ = __webpack_require__(24);


var CompoundPath = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(CompoundPath, _super);
    function CompoundPath() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'compound';
        return _this;
    }
    CompoundPath.prototype._updatePathDirty = function () {
        var paths = this.shape.paths;
        var dirtyPath = this.shapeChanged();
        for (var i = 0; i < paths.length; i++) {
            dirtyPath = dirtyPath || paths[i].shapeChanged();
        }
        if (dirtyPath) {
            this.dirtyShape();
        }
    };
    CompoundPath.prototype.beforeBrush = function () {
        this._updatePathDirty();
        var paths = this.shape.paths || [];
        var scale = this.getGlobalScale();
        for (var i = 0; i < paths.length; i++) {
            if (!paths[i].path) {
                paths[i].createPathProxy();
            }
            paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
        }
    };
    CompoundPath.prototype.buildPath = function (ctx, shape) {
        var paths = shape.paths || [];
        for (var i = 0; i < paths.length; i++) {
            paths[i].buildPath(ctx, paths[i].shape, true);
        }
    };
    CompoundPath.prototype.afterBrush = function () {
        var paths = this.shape.paths || [];
        for (var i = 0; i < paths.length; i++) {
            paths[i].pathUpdated();
        }
    };
    CompoundPath.prototype.getBoundingRect = function () {
        this._updatePathDirty.call(this);
        return __WEBPACK_IMPORTED_MODULE_1__Path_js__["a" /* default */].prototype.getBoundingRect.call(this);
    };
    return CompoundPath;
}(__WEBPACK_IMPORTED_MODULE_1__Path_js__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (CompoundPath);


/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Gradient = (function () {
    function Gradient(colorStops) {
        this.colorStops = colorStops || [];
    }
    Gradient.prototype.addColorStop = function (offset, color) {
        this.colorStops.push({
            offset: offset,
            color: color
        });
    };
    return Gradient;
}());
/* harmony default export */ __webpack_exports__["a"] = (Gradient);


/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Gradient_js__ = __webpack_require__(586);


var RadialGradient = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(RadialGradient, _super);
    function RadialGradient(x, y, r, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0.5 : x;
        _this.y = y == null ? 0.5 : y;
        _this.r = r == null ? 0.5 : r;
        _this.type = 'radial';
        _this.global = globalCoord || false;
        return _this;
    }
    return RadialGradient;
}(__WEBPACK_IMPORTED_MODULE_1__Gradient_js__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (RadialGradient);


/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = truncateText;
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePlainText;
/* unused harmony export RichTextContentBlock */
/* harmony export (immutable) */ __webpack_exports__["b"] = parseRichText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_image_js__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contain_text_js__ = __webpack_require__(47);



var STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
function truncateText(text, containerWidth, font, ellipsis, options) {
    if (!containerWidth) {
        return '';
    }
    var textLines = (text + '').split('\n');
    options = prepareTruncateOptions(containerWidth, font, ellipsis, options);
    for (var i = 0, len = textLines.length; i < len; i++) {
        textLines[i] = truncateSingleLine(textLines[i], options);
    }
    return textLines.join('\n');
}
function prepareTruncateOptions(containerWidth, font, ellipsis, options) {
    options = options || {};
    var preparedOpts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_util_js__["extend"])({}, options);
    preparedOpts.font = font;
    ellipsis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_util_js__["retrieve2"])(ellipsis, '...');
    preparedOpts.maxIterations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_util_js__["retrieve2"])(options.maxIterations, 2);
    var minChar = preparedOpts.minChar = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_util_js__["retrieve2"])(options.minChar, 0);
    preparedOpts.cnCharWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__contain_text_js__["e" /* getWidth */])('国', font);
    var ascCharWidth = preparedOpts.ascCharWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__contain_text_js__["e" /* getWidth */])('a', font);
    preparedOpts.placeholder = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_util_js__["retrieve2"])(options.placeholder, '');
    var contentWidth = containerWidth = Math.max(0, containerWidth - 1);
    for (var i = 0; i < minChar && contentWidth >= ascCharWidth; i++) {
        contentWidth -= ascCharWidth;
    }
    var ellipsisWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__contain_text_js__["e" /* getWidth */])(ellipsis, font);
    if (ellipsisWidth > contentWidth) {
        ellipsis = '';
        ellipsisWidth = 0;
    }
    contentWidth = containerWidth - ellipsisWidth;
    preparedOpts.ellipsis = ellipsis;
    preparedOpts.ellipsisWidth = ellipsisWidth;
    preparedOpts.contentWidth = contentWidth;
    preparedOpts.containerWidth = containerWidth;
    return preparedOpts;
}
function truncateSingleLine(textLine, options) {
    var containerWidth = options.containerWidth;
    var font = options.font;
    var contentWidth = options.contentWidth;
    if (!containerWidth) {
        return '';
    }
    var lineWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__contain_text_js__["e" /* getWidth */])(textLine, font);
    if (lineWidth <= containerWidth) {
        return textLine;
    }
    for (var j = 0;; j++) {
        if (lineWidth <= contentWidth || j >= options.maxIterations) {
            textLine += options.ellipsis;
            break;
        }
        var subLength = j === 0
            ? estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth)
            : lineWidth > 0
                ? Math.floor(textLine.length * contentWidth / lineWidth)
                : 0;
        textLine = textLine.substr(0, subLength);
        lineWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__contain_text_js__["e" /* getWidth */])(textLine, font);
    }
    if (textLine === '') {
        textLine = options.placeholder;
    }
    return textLine;
}
function estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
    var width = 0;
    var i = 0;
    for (var len = text.length; i < len && width < contentWidth; i++) {
        var charCode = text.charCodeAt(i);
        width += (0 <= charCode && charCode <= 127) ? ascCharWidth : cnCharWidth;
    }
    return i;
}
function parsePlainText(text, style) {
    text != null && (text += '');
    var overflow = style.overflow;
    var padding = style.padding;
    var font = style.font;
    var truncate = overflow === 'truncate';
    var calculatedLineHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__contain_text_js__["f" /* getLineHeight */])(font);
    var lineHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_util_js__["retrieve2"])(style.lineHeight, calculatedLineHeight);
    var bgColorDrawn = !!(style.backgroundColor);
    var truncateLineOverflow = style.lineOverflow === 'truncate';
    var width = style.width;
    var lines;
    if (width != null && (overflow === 'break' || overflow === 'breakAll')) {
        lines = text ? wrapText(text, style.font, width, overflow === 'breakAll', 0).lines : [];
    }
    else {
        lines = text ? text.split('\n') : [];
    }
    var contentHeight = lines.length * lineHeight;
    var height = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_util_js__["retrieve2"])(style.height, contentHeight);
    if (contentHeight > height && truncateLineOverflow) {
        var lineCount = Math.floor(height / lineHeight);
        lines = lines.slice(0, lineCount);
    }
    if (text && truncate && width != null) {
        var options = prepareTruncateOptions(width, font, style.ellipsis, {
            minChar: style.truncateMinChar,
            placeholder: style.placeholder
        });
        for (var i = 0; i < lines.length; i++) {
            lines[i] = truncateSingleLine(lines[i], options);
        }
    }
    var outerHeight = height;
    var contentWidth = 0;
    for (var i = 0; i < lines.length; i++) {
        contentWidth = Math.max(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__contain_text_js__["e" /* getWidth */])(lines[i], font), contentWidth);
    }
    if (width == null) {
        width = contentWidth;
    }
    var outerWidth = contentWidth;
    if (padding) {
        outerHeight += padding[0] + padding[2];
        outerWidth += padding[1] + padding[3];
        width += padding[1] + padding[3];
    }
    if (bgColorDrawn) {
        outerWidth = width;
    }
    return {
        lines: lines,
        height: height,
        outerWidth: outerWidth,
        outerHeight: outerHeight,
        lineHeight: lineHeight,
        calculatedLineHeight: calculatedLineHeight,
        contentWidth: contentWidth,
        contentHeight: contentHeight,
        width: width
    };
}
var RichTextToken = (function () {
    function RichTextToken() {
    }
    return RichTextToken;
}());
var RichTextLine = (function () {
    function RichTextLine(tokens) {
        this.tokens = [];
        if (tokens) {
            this.tokens = tokens;
        }
    }
    return RichTextLine;
}());
var RichTextContentBlock = (function () {
    function RichTextContentBlock() {
        this.width = 0;
        this.height = 0;
        this.contentWidth = 0;
        this.contentHeight = 0;
        this.outerWidth = 0;
        this.outerHeight = 0;
        this.lines = [];
    }
    return RichTextContentBlock;
}());

function parseRichText(text, style) {
    var contentBlock = new RichTextContentBlock();
    text != null && (text += '');
    if (!text) {
        return contentBlock;
    }
    var topWidth = style.width;
    var topHeight = style.height;
    var overflow = style.overflow;
    var wrapInfo = (overflow === 'break' || overflow === 'breakAll') && topWidth != null
        ? { width: topWidth, accumWidth: 0, breakAll: overflow === 'breakAll' }
        : null;
    var lastIndex = STYLE_REG.lastIndex = 0;
    var result;
    while ((result = STYLE_REG.exec(text)) != null) {
        var matchedIndex = result.index;
        if (matchedIndex > lastIndex) {
            pushTokens(contentBlock, text.substring(lastIndex, matchedIndex), style, wrapInfo);
        }
        pushTokens(contentBlock, result[2], style, wrapInfo, result[1]);
        lastIndex = STYLE_REG.lastIndex;
    }
    if (lastIndex < text.length) {
        pushTokens(contentBlock, text.substring(lastIndex, text.length), style, wrapInfo);
    }
    var pendingList = [];
    var calculatedHeight = 0;
    var calculatedWidth = 0;
    var stlPadding = style.padding;
    var truncate = overflow === 'truncate';
    var truncateLine = style.lineOverflow === 'truncate';
    function finishLine(line, lineWidth, lineHeight) {
        line.width = lineWidth;
        line.lineHeight = lineHeight;
        calculatedHeight += lineHeight;
        calculatedWidth = Math.max(calculatedWidth, lineWidth);
    }
    outer: for (var i = 0; i < contentBlock.lines.length; i++) {
        var line = contentBlock.lines[i];
        var lineHeight = 0;
        var lineWidth = 0;
        for (var j = 0; j < line.tokens.length; j++) {
            var token = line.tokens[j];
            var tokenStyle = token.styleName && style.rich[token.styleName] || {};
            var textPadding = token.textPadding = tokenStyle.padding;
            var paddingH = textPadding ? textPadding[1] + textPadding[3] : 0;
            var font = token.font = tokenStyle.font || style.font;
            token.contentHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__contain_text_js__["f" /* getLineHeight */])(font);
            var tokenHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_util_js__["retrieve2"])(tokenStyle.height, token.contentHeight);
            token.innerHeight = tokenHeight;
            textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
            token.height = tokenHeight;
            token.lineHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_util_js__["retrieve3"])(tokenStyle.lineHeight, style.lineHeight, tokenHeight);
            token.align = tokenStyle && tokenStyle.align || style.align;
            token.verticalAlign = tokenStyle && tokenStyle.verticalAlign || 'middle';
            if (truncateLine && topHeight != null && calculatedHeight + token.lineHeight > topHeight) {
                if (j > 0) {
                    line.tokens = line.tokens.slice(0, j);
                    finishLine(line, lineWidth, lineHeight);
                    contentBlock.lines = contentBlock.lines.slice(0, i + 1);
                }
                else {
                    contentBlock.lines = contentBlock.lines.slice(0, i);
                }
                break outer;
            }
            var styleTokenWidth = tokenStyle.width;
            var tokenWidthNotSpecified = styleTokenWidth == null || styleTokenWidth === 'auto';
            if (typeof styleTokenWidth === 'string' && styleTokenWidth.charAt(styleTokenWidth.length - 1) === '%') {
                token.percentWidth = styleTokenWidth;
                pendingList.push(token);
                token.contentWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__contain_text_js__["e" /* getWidth */])(token.text, font);
            }
            else {
                if (tokenWidthNotSpecified) {
                    var textBackgroundColor = tokenStyle.backgroundColor;
                    var bgImg = textBackgroundColor && textBackgroundColor.image;
                    if (bgImg) {
                        bgImg = __WEBPACK_IMPORTED_MODULE_0__helper_image_js__["a" /* findExistImage */](bgImg);
                        if (__WEBPACK_IMPORTED_MODULE_0__helper_image_js__["b" /* isImageReady */](bgImg)) {
                            token.width = Math.max(token.width, bgImg.width * tokenHeight / bgImg.height);
                        }
                    }
                }
                var remainTruncWidth = truncate && topWidth != null
                    ? topWidth - lineWidth : null;
                if (remainTruncWidth != null && remainTruncWidth < token.width) {
                    if (!tokenWidthNotSpecified || remainTruncWidth < paddingH) {
                        token.text = '';
                        token.width = token.contentWidth = 0;
                    }
                    else {
                        token.text = truncateText(token.text, remainTruncWidth - paddingH, font, style.ellipsis, { minChar: style.truncateMinChar });
                        token.width = token.contentWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__contain_text_js__["e" /* getWidth */])(token.text, font);
                    }
                }
                else {
                    token.contentWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__contain_text_js__["e" /* getWidth */])(token.text, font);
                }
            }
            token.width += paddingH;
            lineWidth += token.width;
            tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
        }
        finishLine(line, lineWidth, lineHeight);
    }
    contentBlock.outerWidth = contentBlock.width = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_util_js__["retrieve2"])(topWidth, calculatedWidth);
    contentBlock.outerHeight = contentBlock.height = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_util_js__["retrieve2"])(topHeight, calculatedHeight);
    contentBlock.contentHeight = calculatedHeight;
    contentBlock.contentWidth = calculatedWidth;
    if (stlPadding) {
        contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
        contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
    }
    for (var i = 0; i < pendingList.length; i++) {
        var token = pendingList[i];
        var percentWidth = token.percentWidth;
        token.width = parseInt(percentWidth, 10) / 100 * contentBlock.width;
    }
    return contentBlock;
}
function pushTokens(block, str, style, wrapInfo, styleName) {
    var isEmptyStr = str === '';
    var tokenStyle = styleName && style.rich[styleName] || {};
    var lines = block.lines;
    var font = tokenStyle.font || style.font;
    var newLine = false;
    var strLines;
    var linesWidths;
    if (wrapInfo) {
        var tokenPadding = tokenStyle.padding;
        var tokenPaddingH = tokenPadding ? tokenPadding[1] + tokenPadding[3] : 0;
        if (tokenStyle.width != null && tokenStyle.width !== 'auto') {
            var outerWidth_1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__contain_text_js__["b" /* parsePercent */])(tokenStyle.width, wrapInfo.width) + tokenPaddingH;
            if (lines.length > 0) {
                if (outerWidth_1 + wrapInfo.accumWidth > wrapInfo.width) {
                    strLines = str.split('\n');
                    newLine = true;
                }
            }
            wrapInfo.accumWidth = outerWidth_1;
        }
        else {
            var res = wrapText(str, font, wrapInfo.width, wrapInfo.breakAll, wrapInfo.accumWidth);
            wrapInfo.accumWidth = res.accumWidth + tokenPaddingH;
            linesWidths = res.linesWidths;
            strLines = res.lines;
        }
    }
    else {
        strLines = str.split('\n');
    }
    for (var i = 0; i < strLines.length; i++) {
        var text = strLines[i];
        var token = new RichTextToken();
        token.styleName = styleName;
        token.text = text;
        token.isLineHolder = !text && !isEmptyStr;
        if (typeof tokenStyle.width === 'number') {
            token.width = tokenStyle.width;
        }
        else {
            token.width = linesWidths
                ? linesWidths[i]
                : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__contain_text_js__["e" /* getWidth */])(text, font);
        }
        if (!i && !newLine) {
            var tokens = (lines[lines.length - 1] || (lines[0] = new RichTextLine())).tokens;
            var tokensLen = tokens.length;
            (tokensLen === 1 && tokens[0].isLineHolder)
                ? (tokens[0] = token)
                : ((text || !tokensLen || isEmptyStr) && tokens.push(token));
        }
        else {
            lines.push(new RichTextLine([token]));
        }
    }
}
function isLatin(ch) {
    var code = ch.charCodeAt(0);
    return code >= 0x21 && code <= 0x17F;
}
var breakCharMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_util_js__["reduce"])(',&?/;] '.split(''), function (obj, ch) {
    obj[ch] = true;
    return obj;
}, {});
function isWordBreakChar(ch) {
    if (isLatin(ch)) {
        if (breakCharMap[ch]) {
            return true;
        }
        return false;
    }
    return true;
}
function wrapText(text, font, lineWidth, isBreakAll, lastAccumWidth) {
    var lines = [];
    var linesWidths = [];
    var line = '';
    var currentWord = '';
    var currentWordWidth = 0;
    var accumWidth = 0;
    for (var i = 0; i < text.length; i++) {
        var ch = text.charAt(i);
        if (ch === '\n') {
            if (currentWord) {
                line += currentWord;
                accumWidth += currentWordWidth;
            }
            lines.push(line);
            linesWidths.push(accumWidth);
            line = '';
            currentWord = '';
            currentWordWidth = 0;
            accumWidth = 0;
            continue;
        }
        var chWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__contain_text_js__["e" /* getWidth */])(ch, font);
        var inWord = isBreakAll ? false : !isWordBreakChar(ch);
        if (!lines.length
            ? lastAccumWidth + accumWidth + chWidth > lineWidth
            : accumWidth + chWidth > lineWidth) {
            if (!accumWidth) {
                if (inWord) {
                    lines.push(currentWord);
                    linesWidths.push(currentWordWidth);
                    currentWord = ch;
                    currentWordWidth = chWidth;
                }
                else {
                    lines.push(ch);
                    linesWidths.push(chWidth);
                }
            }
            else if (line || currentWord) {
                if (inWord) {
                    if (!line) {
                        line = currentWord;
                        currentWord = '';
                        currentWordWidth = 0;
                        accumWidth = currentWordWidth;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth - currentWordWidth);
                    currentWord += ch;
                    currentWordWidth += chWidth;
                    line = '';
                    accumWidth = currentWordWidth;
                }
                else {
                    if (currentWord) {
                        line += currentWord;
                        currentWord = '';
                        currentWordWidth = 0;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth);
                    line = ch;
                    accumWidth = chWidth;
                }
            }
            continue;
        }
        accumWidth += chWidth;
        if (inWord) {
            currentWord += ch;
            currentWordWidth += chWidth;
        }
        else {
            if (currentWord) {
                line += currentWord;
                currentWord = '';
                currentWordWidth = 0;
            }
            line += ch;
        }
    }
    if (!lines.length && !line) {
        line = text;
        currentWord = '';
        currentWordWidth = 0;
    }
    if (currentWord) {
        line += currentWord;
    }
    if (line) {
        lines.push(line);
        linesWidths.push(accumWidth);
    }
    if (lines.length === 1) {
        accumWidth += lastAccumWidth;
    }
    return {
        accumWidth: accumWidth,
        lines: lines,
        linesWidths: linesWidths
    };
}


/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__smoothBezier_js__ = __webpack_require__(1707);

function buildPath(ctx, shape, closePath) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (points && points.length >= 2) {
        if (smooth) {
            var controlPoints = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__smoothBezier_js__["a" /* default */])(points, smooth, closePath, shape.smoothConstraint);
            ctx.moveTo(points[0][0], points[0][1]);
            var len = points.length;
            for (var i = 0; i < (closePath ? len : len - 1); i++) {
                var cp1 = controlPoints[i * 2];
                var cp2 = controlPoints[i * 2 + 1];
                var p = points[(i + 1) % len];
                ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
            }
        }
        else {
            ctx.moveTo(points[0][0], points[0][1]);
            for (var i = 1, l = points.length; i < l; i++) {
                ctx.lineTo(points[i][0], points[i][1]);
            }
        }
        closePath && ctx.closePath();
    }
}


/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CircleShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Path_js__ = __webpack_require__(24);


var CircleShape = (function () {
    function CircleShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
    }
    return CircleShape;
}());

var Circle = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Circle, _super);
    function Circle(opts) {
        return _super.call(this, opts) || this;
    }
    Circle.prototype.getDefaultShape = function () {
        return new CircleShape();
    };
    Circle.prototype.buildPath = function (ctx, shape) {
        ctx.moveTo(shape.cx + shape.r, shape.cy);
        ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2);
    };
    return Circle;
}(__WEBPACK_IMPORTED_MODULE_1__Path_js__["a" /* default */]));
;
Circle.prototype.type = 'circle';
/* harmony default export */ __webpack_exports__["a"] = (Circle);


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EllipseShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Path_js__ = __webpack_require__(24);


var EllipseShape = (function () {
    function EllipseShape() {
        this.cx = 0;
        this.cy = 0;
        this.rx = 0;
        this.ry = 0;
    }
    return EllipseShape;
}());

var Ellipse = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Ellipse, _super);
    function Ellipse(opts) {
        return _super.call(this, opts) || this;
    }
    Ellipse.prototype.getDefaultShape = function () {
        return new EllipseShape();
    };
    Ellipse.prototype.buildPath = function (ctx, shape) {
        var k = 0.5522848;
        var x = shape.cx;
        var y = shape.cy;
        var a = shape.rx;
        var b = shape.ry;
        var ox = a * k;
        var oy = b * k;
        ctx.moveTo(x - a, y);
        ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
        ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
        ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
        ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
        ctx.closePath();
    };
    return Ellipse;
}(__WEBPACK_IMPORTED_MODULE_1__Path_js__["a" /* default */]));
Ellipse.prototype.type = 'ellipse';
/* harmony default export */ __webpack_exports__["a"] = (Ellipse);


/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LineShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Path_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_subPixelOptimize_js__ = __webpack_require__(362);



var subPixelOptimizeOutputShape = {};
var LineShape = (function () {
    function LineShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return LineShape;
}());

var Line = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Line, _super);
    function Line(opts) {
        return _super.call(this, opts) || this;
    }
    Line.prototype.getDefaultStyle = function () {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Line.prototype.getDefaultShape = function () {
        return new LineShape();
    };
    Line.prototype.buildPath = function (ctx, shape) {
        var x1;
        var y1;
        var x2;
        var y2;
        if (this.subPixelOptimize) {
            var optimizedShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_subPixelOptimize_js__["b" /* subPixelOptimizeLine */])(subPixelOptimizeOutputShape, shape, this.style);
            x1 = optimizedShape.x1;
            y1 = optimizedShape.y1;
            x2 = optimizedShape.x2;
            y2 = optimizedShape.y2;
        }
        else {
            x1 = shape.x1;
            y1 = shape.y1;
            x2 = shape.x2;
            y2 = shape.y2;
        }
        var percent = shape.percent;
        if (percent === 0) {
            return;
        }
        ctx.moveTo(x1, y1);
        if (percent < 1) {
            x2 = x1 * (1 - percent) + x2 * percent;
            y2 = y1 * (1 - percent) + y2 * percent;
        }
        ctx.lineTo(x2, y2);
    };
    Line.prototype.pointAt = function (p) {
        var shape = this.shape;
        return [
            shape.x1 * (1 - p) + shape.x2 * p,
            shape.y1 * (1 - p) + shape.y2 * p
        ];
    };
    return Line;
}(__WEBPACK_IMPORTED_MODULE_1__Path_js__["a" /* default */]));
Line.prototype.type = 'line';
/* harmony default export */ __webpack_exports__["a"] = (Line);


/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PolylineShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Path_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_poly_js__ = __webpack_require__(589);



var PolylineShape = (function () {
    function PolylineShape() {
        this.points = null;
        this.percent = 1;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolylineShape;
}());

var Polyline = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Polyline, _super);
    function Polyline(opts) {
        return _super.call(this, opts) || this;
    }
    Polyline.prototype.getDefaultStyle = function () {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Polyline.prototype.getDefaultShape = function () {
        return new PolylineShape();
    };
    Polyline.prototype.buildPath = function (ctx, shape) {
        __WEBPACK_IMPORTED_MODULE_2__helper_poly_js__["a" /* buildPath */](ctx, shape, false);
    };
    return Polyline;
}(__WEBPACK_IMPORTED_MODULE_1__Path_js__["a" /* default */]));
Polyline.prototype.type = 'polyline';
/* harmony default export */ __webpack_exports__["a"] = (Polyline);


/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SectorShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Path_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_roundSector_js__ = __webpack_require__(1706);



var SectorShape = (function () {
    function SectorShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
        this.cornerRadius = 0;
    }
    return SectorShape;
}());

var Sector = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Sector, _super);
    function Sector(opts) {
        return _super.call(this, opts) || this;
    }
    Sector.prototype.getDefaultShape = function () {
        return new SectorShape();
    };
    Sector.prototype.buildPath = function (ctx, shape) {
        __WEBPACK_IMPORTED_MODULE_2__helper_roundSector_js__["a" /* buildPath */](ctx, shape);
    };
    Sector.prototype.isZeroArea = function () {
        return this.shape.startAngle === this.shape.endAngle
            || this.shape.r === this.shape.r0;
    };
    return Sector;
}(__WEBPACK_IMPORTED_MODULE_1__Path_js__["a" /* default */]));
Sector.prototype.type = 'sector';
/* harmony default export */ __webpack_exports__["a"] = (Sector);


/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_js__ = __webpack_require__(168);

var mathSin = Math.sin;
var mathCos = Math.cos;
var PI = Math.PI;
var PI2 = Math.PI * 2;
var degree = 180 / PI;
var SVGPathRebuilder = (function () {
    function SVGPathRebuilder() {
    }
    SVGPathRebuilder.prototype.reset = function (precision) {
        this._start = true;
        this._d = [];
        this._str = '';
        this._p = Math.pow(10, precision || 4);
    };
    SVGPathRebuilder.prototype.moveTo = function (x, y) {
        this._add('M', x, y);
    };
    SVGPathRebuilder.prototype.lineTo = function (x, y) {
        this._add('L', x, y);
    };
    SVGPathRebuilder.prototype.bezierCurveTo = function (x, y, x2, y2, x3, y3) {
        this._add('C', x, y, x2, y2, x3, y3);
    };
    SVGPathRebuilder.prototype.quadraticCurveTo = function (x, y, x2, y2) {
        this._add('Q', x, y, x2, y2);
    };
    SVGPathRebuilder.prototype.arc = function (cx, cy, r, startAngle, endAngle, anticlockwise) {
        this.ellipse(cx, cy, r, r, 0, startAngle, endAngle, anticlockwise);
    };
    SVGPathRebuilder.prototype.ellipse = function (cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise) {
        var dTheta = endAngle - startAngle;
        var clockwise = !anticlockwise;
        var dThetaPositive = Math.abs(dTheta);
        var isCircle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["g" /* isAroundZero */])(dThetaPositive - PI2)
            || (clockwise ? dTheta >= PI2 : -dTheta >= PI2);
        var unifiedTheta = dTheta > 0 ? dTheta % PI2 : (dTheta % PI2 + PI2);
        var large = false;
        if (isCircle) {
            large = true;
        }
        else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["g" /* isAroundZero */])(dThetaPositive)) {
            large = false;
        }
        else {
            large = (unifiedTheta >= PI) === !!clockwise;
        }
        var x0 = cx + rx * mathCos(startAngle);
        var y0 = cy + ry * mathSin(startAngle);
        if (this._start) {
            this._add('M', x0, y0);
        }
        var xRot = Math.round(psi * degree);
        if (isCircle) {
            var p = 1 / this._p;
            var dTheta_1 = (clockwise ? 1 : -1) * (PI2 - p);
            this._add('A', rx, ry, xRot, 1, +clockwise, cx + rx * mathCos(startAngle + dTheta_1), cy + ry * mathSin(startAngle + dTheta_1));
            if (p > 1e-2) {
                this._add('A', rx, ry, xRot, 0, +clockwise, x0, y0);
            }
        }
        else {
            var x = cx + rx * mathCos(endAngle);
            var y = cy + ry * mathSin(endAngle);
            this._add('A', rx, ry, xRot, +large, +clockwise, x, y);
        }
    };
    SVGPathRebuilder.prototype.rect = function (x, y, w, h) {
        this._add('M', x, y);
        this._add('l', w, 0);
        this._add('l', 0, h);
        this._add('l', -w, 0);
        this._add('Z');
    };
    SVGPathRebuilder.prototype.closePath = function () {
        if (this._d.length > 0) {
            this._add('Z');
        }
    };
    SVGPathRebuilder.prototype._add = function (cmd, a, b, c, d, e, f, g, h) {
        var vals = [];
        var p = this._p;
        for (var i = 1; i < arguments.length; i++) {
            var val = arguments[i];
            if (isNaN(val)) {
                this._invalid = true;
                return;
            }
            vals.push(Math.round(val * p) / p);
        }
        this._d.push(cmd + vals.join(' '));
        this._start = cmd === 'Z';
    };
    SVGPathRebuilder.prototype.generateStr = function () {
        this._str = this._invalid ? '' : this._d.join('');
        this._d = [];
    };
    SVGPathRebuilder.prototype.getStr = function () {
        return this._str;
    };
    return SVGPathRebuilder;
}());
/* harmony default export */ __webpack_exports__["a"] = (SVGPathRebuilder);


/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pathToBezierCurves;
/* harmony export (immutable) */ __webpack_exports__["b"] = pathToPolygons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_curve_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_PathProxy_js__ = __webpack_require__(91);


var CMD = __WEBPACK_IMPORTED_MODULE_1__core_PathProxy_js__["a" /* default */].CMD;
function aroundEqual(a, b) {
    return Math.abs(a - b) < 1e-5;
}
function pathToBezierCurves(path) {
    var data = path.data;
    var len = path.len();
    var bezierArrayGroups = [];
    var currentSubpath;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    function createNewSubpath(x, y) {
        if (currentSubpath && currentSubpath.length > 2) {
            bezierArrayGroups.push(currentSubpath);
        }
        currentSubpath = [x, y];
    }
    function addLine(x0, y0, x1, y1) {
        if (!(aroundEqual(x0, x1) && aroundEqual(y0, y1))) {
            currentSubpath.push(x0, y0, x1, y1, x1, y1);
        }
    }
    function addArc(startAngle, endAngle, cx, cy, rx, ry) {
        var delta = Math.abs(endAngle - startAngle);
        var len = Math.tan(delta / 4) * 4 / 3;
        var dir = endAngle < startAngle ? -1 : 1;
        var c1 = Math.cos(startAngle);
        var s1 = Math.sin(startAngle);
        var c2 = Math.cos(endAngle);
        var s2 = Math.sin(endAngle);
        var x1 = c1 * rx + cx;
        var y1 = s1 * ry + cy;
        var x4 = c2 * rx + cx;
        var y4 = s2 * ry + cy;
        var hx = rx * len * dir;
        var hy = ry * len * dir;
        currentSubpath.push(x1 - hx * s1, y1 + hy * c1, x4 + hx * s2, y4 - hy * c2, x4, y4);
    }
    var x1;
    var y1;
    var x2;
    var y2;
    for (var i = 0; i < len;) {
        var cmd = data[i++];
        var isFirst = i === 1;
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
            if (cmd === CMD.L || cmd === CMD.C || cmd === CMD.Q) {
                currentSubpath = [x0, y0];
            }
        }
        switch (cmd) {
            case CMD.M:
                xi = x0 = data[i++];
                yi = y0 = data[i++];
                createNewSubpath(x0, y0);
                break;
            case CMD.L:
                x1 = data[i++];
                y1 = data[i++];
                addLine(xi, yi, x1, y1);
                xi = x1;
                yi = y1;
                break;
            case CMD.C:
                currentSubpath.push(data[i++], data[i++], data[i++], data[i++], xi = data[i++], yi = data[i++]);
                break;
            case CMD.Q:
                x1 = data[i++];
                y1 = data[i++];
                x2 = data[i++];
                y2 = data[i++];
                currentSubpath.push(xi + 2 / 3 * (x1 - xi), yi + 2 / 3 * (y1 - yi), x2 + 2 / 3 * (x1 - x2), y2 + 2 / 3 * (y1 - y2), x2, y2);
                xi = x2;
                yi = y2;
                break;
            case CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var startAngle = data[i++];
                var endAngle = data[i++] + startAngle;
                i += 1;
                var anticlockwise = !data[i++];
                x1 = Math.cos(startAngle) * rx + cx;
                y1 = Math.sin(startAngle) * ry + cy;
                if (isFirst) {
                    x0 = x1;
                    y0 = y1;
                    createNewSubpath(x0, y0);
                }
                else {
                    addLine(xi, yi, x1, y1);
                }
                xi = Math.cos(endAngle) * rx + cx;
                yi = Math.sin(endAngle) * ry + cy;
                var step = (anticlockwise ? -1 : 1) * Math.PI / 2;
                for (var angle = startAngle; anticlockwise ? angle > endAngle : angle < endAngle; angle += step) {
                    var nextAngle = anticlockwise ? Math.max(angle + step, endAngle)
                        : Math.min(angle + step, endAngle);
                    addArc(angle, nextAngle, cx, cy, rx, ry);
                }
                break;
            case CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                x1 = x0 + data[i++];
                y1 = y0 + data[i++];
                createNewSubpath(x1, y0);
                addLine(x1, y0, x1, y1);
                addLine(x1, y1, x0, y1);
                addLine(x0, y1, x0, y0);
                addLine(x0, y0, x1, y0);
                break;
            case CMD.Z:
                currentSubpath && addLine(xi, yi, x0, y0);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (currentSubpath && currentSubpath.length > 2) {
        bezierArrayGroups.push(currentSubpath);
    }
    return bezierArrayGroups;
}
function adpativeBezier(x0, y0, x1, y1, x2, y2, x3, y3, out, scale) {
    if (aroundEqual(x0, x1) && aroundEqual(y0, y1) && aroundEqual(x2, x3) && aroundEqual(y2, y3)) {
        out.push(x3, y3);
        return;
    }
    var PIXEL_DISTANCE = 2 / scale;
    var PIXEL_DISTANCE_SQR = PIXEL_DISTANCE * PIXEL_DISTANCE;
    var dx = x3 - x0;
    var dy = y3 - y0;
    var d = Math.sqrt(dx * dx + dy * dy);
    dx /= d;
    dy /= d;
    var dx1 = x1 - x0;
    var dy1 = y1 - y0;
    var dx2 = x2 - x3;
    var dy2 = y2 - y3;
    var cp1LenSqr = dx1 * dx1 + dy1 * dy1;
    var cp2LenSqr = dx2 * dx2 + dy2 * dy2;
    if (cp1LenSqr < PIXEL_DISTANCE_SQR && cp2LenSqr < PIXEL_DISTANCE_SQR) {
        out.push(x3, y3);
        return;
    }
    var projLen1 = dx * dx1 + dy * dy1;
    var projLen2 = -dx * dx2 - dy * dy2;
    var d1Sqr = cp1LenSqr - projLen1 * projLen1;
    var d2Sqr = cp2LenSqr - projLen2 * projLen2;
    if (d1Sqr < PIXEL_DISTANCE_SQR && projLen1 >= 0
        && d2Sqr < PIXEL_DISTANCE_SQR && projLen2 >= 0) {
        out.push(x3, y3);
        return;
    }
    var tmpSegX = [];
    var tmpSegY = [];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_curve_js__["k" /* cubicSubdivide */])(x0, x1, x2, x3, 0.5, tmpSegX);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_curve_js__["k" /* cubicSubdivide */])(y0, y1, y2, y3, 0.5, tmpSegY);
    adpativeBezier(tmpSegX[0], tmpSegY[0], tmpSegX[1], tmpSegY[1], tmpSegX[2], tmpSegY[2], tmpSegX[3], tmpSegY[3], out, scale);
    adpativeBezier(tmpSegX[4], tmpSegY[4], tmpSegX[5], tmpSegY[5], tmpSegX[6], tmpSegY[6], tmpSegX[7], tmpSegY[7], out, scale);
}
function pathToPolygons(path, scale) {
    var bezierArrayGroups = pathToBezierCurves(path);
    var polygons = [];
    scale = scale || 1;
    for (var i = 0; i < bezierArrayGroups.length; i++) {
        var beziers = bezierArrayGroups[i];
        var polygon = [];
        var x0 = beziers[0];
        var y0 = beziers[1];
        polygon.push(x0, y0);
        for (var k = 2; k < beziers.length;) {
            var x1 = beziers[k++];
            var y1 = beziers[k++];
            var x2 = beziers[k++];
            var y2 = beziers[k++];
            var x3 = beziers[k++];
            var y3 = beziers[k++];
            adpativeBezier(x0, y0, x1, y1, x2, y2, x3, y3, polygon, scale);
            x0 = x3;
            y0 = y3;
        }
        polygons.push(polygon);
    }
    return polygons;
}


/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseXML;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_util_js__ = __webpack_require__(0);

function parseXML(svg) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["isString"])(svg)) {
        var parser = new DOMParser();
        svg = parser.parseFromString(svg, 'text/xml');
    }
    var svgNode = svg;
    if (svgNode.nodeType === 9) {
        svgNode = svgNode.firstChild;
    }
    while (svgNode.nodeName.toLowerCase() !== 'svg' || svgNode.nodeType !== 1) {
        svgNode = svgNode.nextSibling;
    }
    return svgNode;
}


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(1007);

__webpack_require__(1478);

__webpack_require__(755);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50)))

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
(function(e,h){ true?module.exports=h():"function"===typeof define&&define.amd?define(h):(e=e||self,e.AMapLoader=h())})(this,function(){function e(a,d){var c=Object.keys(a);if(Object.getOwnPropertySymbols){var b=Object.getOwnPropertySymbols(a);d&&(b=b.filter(function(b){return Object.getOwnPropertyDescriptor(a,b).enumerable}));c.push.apply(c,b)}return c}function h(a){for(var d=1;d<arguments.length;d++){var c=null!=arguments[d]?arguments[d]:
{};d%2?e(Object(c),!0).forEach(function(b){var d=c[b];b in a?Object.defineProperty(a,b,{value:d,enumerable:!0,configurable:!0,writable:!0}):a[b]=d}):Object.getOwnPropertyDescriptors?Object.defineProperties(a,Object.getOwnPropertyDescriptors(c)):e(Object(c)).forEach(function(b){Object.defineProperty(a,b,Object.getOwnPropertyDescriptor(c,b))})}return a}if(!window)throw Error("AMap JSAPI can only be used in Browser.");var f="notload",k={key:"",version:"1.4.15",plugins:[]},n=[],p=function(a){"function"==
typeof a&&("loaded"==f?a(window.AMap):n.push(a))};return{load:function(a){return new Promise(function(d,c){if("notload"==f){var b=h({},k,{},a),g=b.key,e=b.version;b=b.plugins;if(g){window.AMap&&c("\u7981\u6b62\u591a\u79cdAPI\u52a0\u8f7d\u65b9\u5f0f\u6df7\u7528");k={key:g,version:e,plugins:b};f="loading";var q=document.body||document.head;window.___onAPILoaded=function(a){delete window.___onAPILoaded;a?(f="failed",c(a)):(f="loaded",d(window.AMap));for(;n.length;)n.splice(0,1)[0]()};var m=document.createElement("script");
m.type="text/javascript";m.src="https://webapi.amap.com/maps?callback=___onAPILoaded&v="+e+"&key="+g+"&plugin="+b.join(",");m.onerror=function(a){f="failed";c(a)};q.appendChild(m)}else c("\u8bf7\u586b\u5199key")}else if(a.key&&a.key!==k.key)c("\u591a\u4e2a\u4e0d\u4e00\u81f4\u7684 key");else if(a.version&&a.version!==k.version)c("\u4e0d\u5141\u8bb8\u591a\u4e2a\u7248\u672c JSAPI \u6df7\u7528");else{"failed"==f&&c("\u524d\u6b21\u52a0\u8f7d\u5df2\u7ecf\u5931\u8d25");var l=[];if(a.plugins)for(g=0;g<a.plugins.length;g+=
1)-1==k.plugins.indexOf(a.plugins[g])&&l.push(a.plugins[g]);"loaded"==f?l.length?window.AMap.plugin(l,function(){d(window.AMap)}):d(window.AMap):"loading"==f&&p(function(){l.length?window.AMap.plugin(l,function(){d(window.AMap)}):d(window.AMap)})}})}}})


/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScriptLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils__ = __webpack_require__(367);
/**
 * Copyright (c) 2018-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var createState = function () {
    return {
        listeners: [],
        scriptId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Utils__["d" /* uuid */])('tiny-script'),
        scriptLoaded: false
    };
};
var CreateScriptLoader = function () {
    var state = createState();
    var injectScriptTag = function (scriptId, doc, url, callback) {
        var scriptTag = doc.createElement('script');
        scriptTag.referrerPolicy = 'origin';
        scriptTag.type = 'application/javascript';
        scriptTag.id = scriptId;
        scriptTag.src = url;
        var handler = function () {
            scriptTag.removeEventListener('load', handler);
            callback();
        };
        scriptTag.addEventListener('load', handler);
        if (doc.head) {
            doc.head.appendChild(scriptTag);
        }
    };
    var load = function (doc, url, callback) {
        if (state.scriptLoaded) {
            callback();
        }
        else {
            state.listeners.push(callback);
            if (!doc.getElementById(state.scriptId)) {
                injectScriptTag(state.scriptId, doc, url, function () {
                    state.listeners.forEach(function (fn) { return fn(); });
                    state.scriptLoaded = true;
                });
            }
        }
    };
    // Only to be used by tests.
    var reinitialize = function () {
        state = createState();
    };
    return {
        load: load,
        reinitialize: reinitialize
    };
};
var ScriptLoader = CreateScriptLoader();



/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTinymce; });
/**
 * Copyright (c) 2018-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var getGlobal = function () { return (typeof window !== 'undefined' ? window : global); };
var getTinymce = function () {
    var global = getGlobal();
    return global && global.tinymce ? global.tinymce : null;
};


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(50)))

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Editor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScriptLoader__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TinyMCE__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utils__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditorPropTypes__ = __webpack_require__(603);
/**
 * Copyright (c) 2018-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




var renderInline = function (h, id, tagName) {
    return h(tagName ? tagName : 'div', {
        attrs: { id: id }
    });
};
var renderIframe = function (h, id) {
    return h('textarea', {
        attrs: { id: id },
        style: { visibility: 'hidden' }
    });
};
var initialise = function (ctx) { return function () {
    var finalInit = __assign(__assign({}, ctx.$props.init), { readonly: ctx.$props.disabled, selector: "#" + ctx.elementId, plugins: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Utils__["a" /* mergePlugins */])(ctx.$props.init && ctx.$props.init.plugins, ctx.$props.plugins), toolbar: ctx.$props.toolbar || (ctx.$props.init && ctx.$props.init.toolbar), inline: ctx.inlineEditor, setup: function (editor) {
            ctx.editor = editor;
            editor.on('init', function (e) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Utils__["b" /* initEditor */])(e, ctx, editor); });
            if (ctx.$props.init && typeof ctx.$props.init.setup === 'function') {
                ctx.$props.init.setup(editor);
            }
        } });
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Utils__["c" /* isTextarea */])(ctx.element)) {
        ctx.element.style.visibility = '';
        ctx.element.style.display = '';
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__TinyMCE__["a" /* getTinymce */])().init(finalInit);
}; };
var Editor = {
    props: __WEBPACK_IMPORTED_MODULE_3__EditorPropTypes__["a" /* editorProps */],
    created: function () {
        this.elementId = this.$props.id || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Utils__["d" /* uuid */])('tiny-vue');
        this.inlineEditor = (this.$props.init && this.$props.init.inline) || this.$props.inline;
        this.initialized = false;
    },
    watch: {
        disabled: function () {
            this.editor.setMode(this.disabled ? 'readonly' : 'design');
        }
    },
    mounted: function () {
        this.element = this.$el;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__TinyMCE__["a" /* getTinymce */])() !== null) {
            initialise(this)();
        }
        else if (this.element && this.element.ownerDocument) {
            var channel = this.$props.cloudChannel ? this.$props.cloudChannel : '5';
            var apiKey = this.$props.apiKey ? this.$props.apiKey : 'no-api-key';
            var scriptSrc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Utils__["e" /* isNullOrUndefined */])(this.$props.tinymceScriptSrc) ?
                "https://cdn.tiny.cloud/1/" + apiKey + "/tinymce/" + channel + "/tinymce.min.js" :
                this.$props.tinymceScriptSrc;
            __WEBPACK_IMPORTED_MODULE_0__ScriptLoader__["a" /* ScriptLoader */].load(this.element.ownerDocument, scriptSrc, initialise(this));
        }
    },
    beforeDestroy: function () {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__TinyMCE__["a" /* getTinymce */])() !== null) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__TinyMCE__["a" /* getTinymce */])().remove(this.editor);
        }
    },
    deactivated: function () {
        var _a;
        if (!this.inlineEditor) {
            this.cache = this.editor.getContent();
            (_a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__TinyMCE__["a" /* getTinymce */])()) === null || _a === void 0 ? void 0 : _a.remove(this.editor);
        }
    },
    activated: function () {
        if (!this.inlineEditor && this.initialized) {
            initialise(this)();
        }
    },
    render: function (h) {
        return this.inlineEditor ? renderInline(h, this.elementId, this.$props.tagName) : renderIframe(h, this.elementId);
    }
};


/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return editorProps; });
/**
 * Copyright (c) 2018-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var editorProps = {
    apiKey: String,
    cloudChannel: String,
    id: String,
    init: Object,
    initialValue: String,
    inline: Boolean,
    modelEvents: [String, Array],
    plugins: [String, Array],
    tagName: String,
    toolbar: [String, Array],
    value: String,
    disabled: Boolean,
    tinymceScriptSrc: String,
    outputFormat: {
        type: String,
        validator: function (prop) { return prop === 'html' || prop === 'text'; }
    },
};


/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Editor__ = __webpack_require__(602);
/**
 * Copyright (c) 2018-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components_Editor__["a" /* Editor */]);


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(606);

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(51);
var bind = __webpack_require__(374);
var Axios = __webpack_require__(608);
var mergeConfig = __webpack_require__(372);
var defaults = __webpack_require__(373);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(369);
axios.CancelToken = __webpack_require__(607);
axios.isCancel = __webpack_require__(370);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(621);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(369);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(51);
var buildURL = __webpack_require__(375);
var InterceptorManager = __webpack_require__(609);
var dispatchRequest = __webpack_require__(611);
var mergeConfig = __webpack_require__(372);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(51);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(617);
var combineURLs = __webpack_require__(615);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(51);
var transformData = __webpack_require__(614);
var isCancel = __webpack_require__(370);
var defaults = __webpack_require__(373);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(371);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(51);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(51);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(51);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(51);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(51);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eventHub__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);


//
//
//
//
//
//
//
//
//




var whitePathList = ['login'];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  data: function data() {
    return {
      hasPermission: true,
      loading: false,
      message: []
    };
  },

  components: {},
  mounted: function mounted() {
    var _this = this;

    document.onkeydown = function () {
      var evt = window.event || arguments[0];
      if (evt && evt.keyCode === 13 && evt.target.nodeName.includes('BUTTON')) {
        if (typeof evt.cancelBubble != 'undefined') {
          evt.cancelBubble = true;
        }
        if (typeof evt.stopPropagation == 'function') {
          evt.stopPropagation();
        }
        return false;
      }
      return true;
    };
    __WEBPACK_IMPORTED_MODULE_2__eventHub__["a" /* default */].$on('authentication_failed', function () {
      if (_this.$route.path !== '/login') {
        _this.$myMessage({
          message: '没有访问权限',
          type: 'warn'
        });
      }
      _this.$router.replace('/login');
    });
    __WEBPACK_IMPORTED_MODULE_2__eventHub__["a" /* default */].$on('show-loading', function () {
      _this.loading = true;
    });
    __WEBPACK_IMPORTED_MODULE_2__eventHub__["a" /* default */].$on('hide-loading', function () {
      _this.loading = false;
    });
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', function () {
      sessionStorage.setItem('store', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.$store.state));
    });
    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      window.addEventListener('hashchange', function () {
        var currentPath = window.location.hash.slice(1);
        if (_this.$route.path !== currentPath) {
          _this.$router.push(currentPath); // 主动更改路由界面
        }
      }, false);
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['getUserInfo']))
  //   mounted() {}
});

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        'dialogVisiable': {
            type: Boolean,
            required: true
        },
        'confirm': {
            type: Function,
            required: true
        },
        'reject': {
            type: Function,
            required: true
        },
        'type': {
            type: String,
            required: true
        },
        'cancel': {
            type: Function
        },
        'appendToDialog': {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            reason: ''
        };
    },

    methods: {
        handleConfirmOK: function handleConfirmOK() {
            this.$emit('update:dialogVisiable', false);
            if (this.type == 'confirm') {
                if (this.confirm) {
                    this.confirm(this.reason);
                }
            } else {
                if (this.reject) {
                    this.reject(this.reason);
                }
            }
        },
        closeDialog: function closeDialog(done) {
            // done(); //使用done会有js报错
            this.$emit('update:dialogVisiable', false);
            if (this.cancel) {
                this.cancel();
            }
        }
    }
});

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      default: ''
    },
    placeholder: {
      default: ''
    },
    disabled: Boolean,
    valueFixed: {
      default: 0
    }
  },
  data: function data() {
    return {
      isFocus: false,
      innerValue: ''
    };
  },

  computed: {
    valueComputed: {
      get: function get() {
        if (this.isFocus) {
          return this.innerValue;
        } else {
          return this.formatInputPrice(this.value);
        }
      },
      set: function set(val) {
        val = val.replace(/([^\d\.]|^0(\d+))/g, '$2').replace(/(\.)(\d*)(\1*)/g, '$1$2').replace(/(\.)(\d{1,2})\d*/g, '$1$2');
        this.$emit('input', val);
      }
    }
  },
  watch: {
    value: function value(_value) {
      //   console.log('cnyinput watch+++', value);
      this.innerValue = this.formatInputPrice(_value);
      //   console.log('cnyinput this.innerValue+++', this.innerValue);
    }
  },
  mounted: function mounted() {
    this.innerValue = this.formatInputPrice(this.value);
  },

  methods: {
    focusOnPrice: function focusOnPrice() {
      this.isFocus = true;
      this.innerValue = this.innerValue.toString().replaceAll(',', '');
    },
    formatDetailBudget: function formatDetailBudget() {
      var str = this.innerValue + '';
      var strTemp = str.replace(/\.$/, '');
      if (str !== strTemp) {
        this.innerValue = strTemp;
      }

      this.innerValue = this.formatInputPrice(strTemp);

      var output = this.innerValue.toString().replaceAll(',', '');
      output = !isNaN(Number(output)) ? Number(output) : '';
      this.$emit('input', output);
      this.$emit('blur', output);
      this.isFocus = false;
    },
    formatInputPrice: function formatInputPrice(param) {
      param = param.toString().replaceAll(',', '');

      param = isNaN(Number(param)) || !param || param === '' ? 0 : param;

      param = param.toString().replace(/[^\d.]/g, '');

      // 必须保证第一个为数字而不是.
      param = param.toString().replace(/^\./g, '');
      // 保证只有出现一个.而没有多个.
      param = param.toString().replace(/\.{2,}/g, '');
      // 保证.只出现一次，而不能出现两次以上
      param = param.toString().replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');

      return this.formatPrice(param);
    },

    formatPrice: function formatPrice(param) {
      if (param) {
        var result = parseFloat(param).toFixed(this.valueFixed).toString().replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
        return result;
      } else {
        return '0.00';
      }
    }
  }
});

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        'dialogVisiable': {
            type: Boolean,
            required: true
        },
        'confirm': {
            type: Function,
            required: true
        },
        'cancel': {
            type: Function
        },
        'appendToDialog': {
            type: Boolean,
            default: false
        },
        'icon': {
            type: String,
            default: 'icon-jingshi'
        },
        'iconColor': {
            type: String,
            default: '#FFC300'
        }
    },
    methods: {
        handleConfirmOK: function handleConfirmOK() {
            this.$emit('update:dialogVisiable', false);
            if (this.confirm) {
                this.confirm();
            }
        },
        closeDialog: function closeDialog(done) {
            // done(); //使用done会有js报错
            this.$emit('update:dialogVisiable', false);
            if (this.cancel) {
                this.cancel();
            }
        }
    }
});

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        'addNewOrEditData': {
            type: Object,
            required: false
        },
        'searchData': {
            type: Object,
            required: true
        },
        'searchDataLikeField': {
            type: Object,
            required: false,
            default: function _default() {
                return {};
            }
        },
        'showPageData': {
            type: Boolean,
            required: false,
            default: true
        },
        'tableData': {
            type: Array,
            required: true
        },
        'crudApi': {
            type: Object,
            required: true
        },
        'itemIdName': {
            type: String,
            required: false,
            default: 'id'
        },
        'showEditFormTitle': {
            type: Boolean,
            required: false,
            default: true
        },
        'editFormLabelPosition': {
            type: String,
            required: false,
            default: 'top'
        },
        'handleSearchResult': {
            type: Function,
            required: false
        },
        'handleSelectionChangeResult': {
            type: Function,
            required: false
        },
        'beforeSave': {
            type: Function,
            required: false
        },
        'afterSave': {
            type: Function,
            required: false
        },
        'beforeDelete': {
            type: Function,
            required: false
        },
        'afterDelete': {
            type: Function,
            required: false
        },
        'otherValid': {
            type: Function,
            required: false
        },
        'resetEditForm': {
            type: Function,
            required: false
        },
        'rules': {
            type: Object,
            required: false
        },
        'editDialogClass': {
            type: String,
            required: false,
            default: 'common-crud-edit-dialog'
        },
        'rowKey': {
            type: String,
            required: false,
            default: 'id'
        },
        'labelWidth': {
            type: String,
            required: false,
            default: 'auto'
        },
        'selectedDataArray': {
            type: Array,
            required: false
        },
        'defaultPageSize': {
            type: Number,
            required: false,
            default: 20
        },
        'customListResult': {
            type: Boolean,
            required: false,
            default: false
        },
        'deleteSuccessMessages': {
            type: String,
            required: false,
            default: ''
        },
        'deleteBatchSuccessMessages': {
            type: String,
            required: false,
            default: ''
        },
        'addSuccessMessages': {
            type: String,
            required: false,
            default: ''
        },
        'editSuccessMessages': {
            type: String,
            required: false,
            default: ''
        }
    },
    data: function data() {
        return {
            editVisible: false,
            confirmEditSaveVisible: false,
            confirmDeleteVisible: false,
            confirmBatchDeleteVisible: false,
            tipsFormVisible: false,
            pageData: {
                pageNo: 1,
                pageSize: this.defaultPageSize,
                total: 0
            },
            sortData: null,
            selectedData: [],
            editType: "",
            currentData: null
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['basedataGetName'])),
    methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['initBaseDataByTypes']), {
        formatDateTime2Date: function formatDateTime2Date(row, column, cellValue, index) {
            if (!cellValue) return '';

            return moment(cellValue).format('YYYY-MM-DD');
        },
        indexMethod: function indexMethod(index) {
            return index + (this.pageData.pageNo - 1) * this.pageData.pageSize + 1;
        },
        handleSearch: function handleSearch(pageNo) {
            var _this = this;

            var conditionData = {};
            for (var key in this.searchData) {
                if (this.searchData.hasOwnProperty.call(this.searchData, key)) {
                    var element = this.searchData[key];
                    if (element || element === 0) {
                        var val = element;

                        //支持多选查询
                        if (Array.isArray(element)) {
                            val = element.join(',');
                        }

                        if (this.searchDataLikeField && this.searchDataLikeField[key] && val) {
                            val = this.searchDataLikeField[key] + val + this.searchDataLikeField[key];
                        }

                        conditionData[key] = val;
                    }
                }
            }
            conditionData.pageNo = pageNo || this.pageData.pageNo;
            conditionData.pageSize = this.pageData.pageSize;

            if (this.sortData) {
                conditionData.column = this.sortData.column;
                conditionData.order = this.sortData.order;
            }

            this.crudApi.list(conditionData).then(function (res) {
                if (Array.isArray(res)) {
                    var temp = {
                        records: res
                    };
                    res = temp;
                }

                if (_this.handleSearchResult) {
                    _this.handleSearchResult(res);
                } else {
                    _this.$emit('update:tableData', res.records);
                }

                _this.pageData.pageNo = res.current;
                _this.pageData.total = res.total;
            });
        },
        resetObject: function resetObject(obj) {
            for (var key in obj) {
                if (obj.hasOwnProperty.call(obj, key)) {
                    if (Array.isArray(obj[key])) {
                        obj[key] = [];
                    } else if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj[key]) == 'object') {
                        obj[key] = {};
                    } else {
                        obj[key] = '';
                    }
                }
            }
        },
        handleAddNew: function handleAddNew(specItems) {
            //第一次打开时，没有生成form
            if (this.$refs['form']) {
                this.$refs['form'].resetFields();
            }

            if (this.resetEditForm) {
                this.resetEditForm();
            } else {
                this.resetObject(this.addNewOrEditData);

                if (specItems) {
                    _.extend(this.addNewOrEditData, specItems);
                }
            }

            this.editType = "新增";
            this.editVisible = true;
        },
        handleEdit: function handleEdit(item, specItems) {
            if (this.$refs['form']) {
                this.$refs['form'].resetFields();
            }

            _.extend(this.addNewOrEditData, item);

            if (specItems) {
                _.extend(this.addNewOrEditData, specItems);
            }

            this.currentData = item;

            this.editType = "编辑";
            this.editVisible = true;
        },
        handleEditConfirmClick: function handleEditConfirmClick() {
            var _this2 = this;

            var otherValid = true;
            if (this.otherValid) {
                otherValid = this.otherValid();
            }
            this.$refs['form'].validate(function (valid) {
                if (valid && otherValid) {
                    _this2.confirmEditSaveVisible = true;
                } else {
                    _this2.$message.error(_this2.basedataGetName('SysErrorTip', 1));
                }
            });
        },
        handlerEditSaveConfirmOK: function handlerEditSaveConfirmOK() {
            var _this3 = this;

            var funName = this.editType == "新增" ? 'add' : 'edit';
            var saveData = _.clone(this.addNewOrEditData);
            saveData.id = this.editType == "编辑" ? this.currentData[this.itemIdName] : '';

            if (this.beforeSave) {
                this.beforeSave(saveData);
            }

            var skipField = ['delFlag', 'createBy', 'createTime', 'updateBy', 'updateTime'];
            skipField.forEach(function (el) {
                if (saveData.hasOwnProperty.call(saveData, el)) {
                    delete saveData[el];
                }
            });

            this.crudApi[funName](saveData).then(function (res) {
                if (_this3.editType == '新增' && _this3.addSuccessMessages) {
                    _this3.$message.success(_this3.addSuccessMessages);
                }

                if (_this3.editType == '编辑' && _this3.editSuccessMessages) {
                    _this3.$message.success(_this3.editSuccessMessages);
                }

                _this3.editVisible = false;
                _this3.handleSearch();

                if (_this3.afterSave) {
                    _this3.afterSave();
                }
            });
        },
        handleDelete: function handleDelete(item) {
            this.currentData = item;
            this.confirmDeleteVisible = true;
        },
        handlerDeleteConfirmOK: function handlerDeleteConfirmOK() {
            var _this4 = this;

            var deleteData = {};
            deleteData[this.itemIdName] = this.currentData[this.itemIdName];
            this.crudApi.delete(deleteData).then(function (res) {
                if (_this4.deleteSuccessMessages) {
                    _this4.$message.success(_this4.deleteSuccessMessages);
                }

                _this4.confirmDeleteVisible = false;
                if (_this4.tableData.length == 1) {
                    _this4.handleSearch(1);
                } else {
                    _this4.handleSearch();
                }

                if (_this4.afterDelete) {
                    _this4.afterDelete();
                }
            });
        },
        handleSelectionChange: function handleSelectionChange(val) {
            this.selectedData = val;
            this.$emit('update:selectedDataArray', val);
            if (this.handleSelectionChangeResult) {
                this.handleSelectionChangeResult(val);
            }
        },
        handleBatchDelete: function handleBatchDelete() {
            if (this.selectedData.length > 0) {
                this.confirmBatchDeleteVisible = true;
            }
        },
        handlerBatchDeleteConfirmOK: function handlerBatchDeleteConfirmOK() {
            var _this5 = this;

            if (this.selectedData.length > 0) {
                var ids = [];
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var data = _step.value;

                        ids.push(data.id);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                this.crudApi.deleteBatch({ ids: ids.join(',') }).then(function (res) {
                    if (_this5.deleteBatchSuccessMessages) {
                        _this5.$message.success(_this5.deleteBatchSuccessMessages);
                    }

                    if (_this5.tableData.length == _this5.selectedData.length) {
                        _this5.handleSearch(1);
                    } else {
                        _this5.handleSearch();
                    }
                    _this5.confirmBatchDeleteVisible = false;
                });
            }
        },
        handleTips: function handleTips() {
            this.tipsFormVisible = true;
        },
        handlerTipsFormVisibleOK: function handlerTipsFormVisibleOK() {
            this.tipsFormVisible = false;
        },
        handlerExportExcel: function handlerExportExcel(fileName, extendData) {
            var params = null;
            if (this.selectedData.length > 0) {
                var ids = [];
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedData), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var data = _step2.value;

                        ids.push(data.id);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                params = { id: ids.join(',') };
            } else {
                params = {};

                for (var key in this.searchData) {
                    if (this.searchData.hasOwnProperty.call(this.searchData, key)) {
                        var element = this.searchData[key];
                        if (element || element === 0) {
                            var val = element;

                            //支持多选查询
                            if (Array.isArray(element)) {
                                val = element.join(',');
                            }

                            if (this.searchDataLikeField && this.searchDataLikeField[key] && val) {
                                val = this.searchDataLikeField[key] + val + this.searchDataLikeField[key];
                            }

                            params[key] = val;
                        }
                    }
                }
            }

            if (extendData) {
                _.extend(params, extendData);
            }
            var conditionData = {};
            for (var _key in params) {
                if (params.hasOwnProperty.call(params, _key)) {
                    var _element = params[_key];
                    if (_element || _element === 0) {
                        conditionData[_key] = _element;
                    }
                }
            }

            this.crudApi.exportXls(conditionData).then(function (res) {
                // 将`blob`对象转化成一个可访问的`url`
                var url = window.URL.createObjectURL(new Blob([res.data]));
                var link = document.createElement('a');
                link.style.display = 'none';
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
        },
        handleSortChange: function handleSortChange(data) {
            //只有1页，排序改变不查后台
            if (this.pageData.total <= this.pageData.pageSize) {
                return;
            }

            if (data.order === 'ascending') {
                this.sortData = {};
                this.sortData.order = 'asc';
                this.sortData.column = data.prop;
            } else if (data.order === 'descending') {
                this.sortData = {};
                this.sortData.order = 'desc';
                this.sortData.column = data.prop;
            } else {
                this.sortData = null;
            }

            this.handleSearch();
        }
    }),
    mounted: function mounted() {
        this.initBaseDataByTypes(['SysErrorTip']).then(function () {});
    }
});

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        'chartClass': {
            type: String,
            required: true
        },
        'datasetDimensions': {
            type: Array,
            required: true
        },
        'datasetSource': {
            type: Array,
            required: true
        },
        'option': {
            type: Object,
            required: true
        }
    },
    mounted: function mounted() {
        this.initEchars();
    },
    data: function data() {
        return {
            myChart: {},
            echarOption: {}
        };
    },

    methods: {
        initEchars: function initEchars() {
            var dom = this.$refs.myChart;
            this.myChart = echarts.init(dom);
            this.echarOption = {
                dataset: {
                    dimensions: this.datasetDimensions,
                    source: this.datasetSource
                }
            };
            _.extend(this.echarOption, this.option);

            this.myChart.setOption(this.echarOption, {
                notMerge: true
            });
        },
        chartChange: function chartChange() {
            this.initEchars();
        }
    }
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tinymce_tinymce__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tinymce_tinymce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tinymce_tinymce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tinymce_tinymce_vue__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tinymce_themes_silver_theme__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tinymce_themes_silver_theme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tinymce_themes_silver_theme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tinymce_plugins_image__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tinymce_plugins_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_tinymce_plugins_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tinymce_plugins_link__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tinymce_plugins_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_tinymce_plugins_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tinymce_plugins_code__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tinymce_plugins_code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_tinymce_plugins_code__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tinymce_plugins_table__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tinymce_plugins_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_tinymce_plugins_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_tinymce_plugins_lists__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_tinymce_plugins_lists___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_tinymce_plugins_lists__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tinymce_plugins_contextmenu__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tinymce_plugins_contextmenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_tinymce_plugins_contextmenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_tinymce_plugins_wordcount__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_tinymce_plugins_wordcount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_tinymce_plugins_wordcount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_tinymce_plugins_colorpicker__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_tinymce_plugins_colorpicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_tinymce_plugins_colorpicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_tinymce_plugins_textcolor__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_tinymce_plugins_textcolor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_tinymce_plugins_textcolor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_tinymce_plugins_media__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_tinymce_plugins_media___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_tinymce_plugins_media__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_tinymce_plugins_fullscreen__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_tinymce_plugins_fullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_tinymce_plugins_fullscreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_tinymce_plugins_preview__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_tinymce_plugins_preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_tinymce_plugins_preview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_tinymce_plugins_pagebreak__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_tinymce_plugins_pagebreak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_tinymce_plugins_pagebreak__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_tinymce_plugins_insertdatetime__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_tinymce_plugins_insertdatetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_tinymce_plugins_insertdatetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_tinymce_plugins_hr__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_tinymce_plugins_hr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_tinymce_plugins_hr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_tinymce_plugins_paste__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_tinymce_plugins_paste___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_tinymce_plugins_paste__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_tinymce_plugins_codesample__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_tinymce_plugins_codesample___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_tinymce_plugins_codesample__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 //tinymce默认hidden，不引入不显示
 //编辑器引入
 //编辑器主题

















// import "tinymce/plugins/emoticons"

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        'value': {},
        'disabled': {},
        'editorId': {
            default: 'tinymceId'
        },
        'editorHeight': {
            default: 500
        },
        'placeholder': {}
    },
    event: 'change',
    components: {
        Editor: __WEBPACK_IMPORTED_MODULE_1__tinymce_tinymce_vue__["a" /* default */]
    },
    data: function data() {
        return {
            content: '',
            isUpdated: true
        };
    },

    computed: {
        innerValue: {
            get: function get() {
                return this.value;
            },
            set: function set(val) {
                this.$emit('input', val); //这里多用于子组件间没有input元素中,通过在computed属性中监听值变化事emit input事件
            }
        },
        init: function init() {
            return {
                selector: '#' + this.editorId,
                language_url: './static/tinymce/zh-Hans.js', //汉化路径是自定义的，一般放在public或static里面
                language: 'zh-Hans',
                height: this.editorHeight,
                skin_url: "./static/tinymce/skins/ui/oxide", //编辑器需要一个skin才能正常工作，所以要设置一个skin_url指向之前复制出来的skin文件
                content_css: './static/tinymce/skins/content/default/content.css',
                content_style: 'body {background: @bgColor;font-family: "Arial", "Helvetica", sans-serif, "SimHei", "Microsoft YaHei";} a,h1,h2,h3 { margin: 0;  padding: 0;}div {  box-sizing: border-box;} a {text-decoration: none;} li {list-style: inherit;}',
                menubar: "", //菜单条
                plugins: "placeholder link lists image code table wordcount media table fullscreen preview pagebreak insertdatetime hr paste codesample", //插件
                toolbar: "bold italic underline strikethrough  | fontselect | fontsizeselect | formatselect  | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | removeformat| undo redo | link unlink image media insertdatetime table  hr pagebreak codesample", //工具条
                font_formats: "Arial=arial,helvetica,sans-serif;宋体=SimSun;微软雅黑=Microsoft Yahei;Impact=impact,chicago;", //字体
                fontsize_formats: "11px 12px 14px 16px 18px 24px 36px 48px 64px 72px", //文字大小
                branding: false, //水印
                elementpath: false, //底部元素路径
                paste_data_images: true, //允许粘贴图片
                file_picker_types: "media",
                paste_retain_style_properties: "all",
                toolbar_drawer: 'false'
            };
        }
    },
    methods: {
        refresh: function refresh() {
            var _this = this;

            this.isUpdated = false;
            this.$nextTick(function () {
                _this.isUpdated = true;
            });
        }
    },
    watch: {},
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_0_tinymce_tinymce___default.a.init({});
    }
});

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_bizmanagement_scoreExport__ = __webpack_require__(692);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        'title': {
            type: String,
            required: true
        },
        'type': { //strategyHospital4Strategy, strategyOffice, strategyOffice, speakerMeetingType
            type: String,
            required: true
        },
        'fileName': {
            type: String,
            required: true
        },
        'getExportParams': {
            type: Function,
            required: true
        },
        'disabledDownload': {
            type: Boolean,
            required: false,
            default: false
        },
        'required': {
            type: Boolean,
            required: false,
            default: false
        },
        'tipCode': {
            type: String,
            required: false,
            default: ''
        }
    },
    data: function data() {
        return {
            acceptType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
            error: false,
            disabledUpload: false
        };
    },
    methods: {
        handleExport: function handleExport() {
            var _this = this;

            var params = this.getExportParams();

            __WEBPACK_IMPORTED_MODULE_0__api_bizmanagement_scoreExport__["a" /* default */][this.type](params).then(function (res) {
                // 将`blob`对象转化成一个可访问的`url`
                var url = window.URL.createObjectURL(new Blob([res.data]));
                var link = document.createElement('a');
                link.style.display = 'none';
                link.href = url;
                link.setAttribute('download', _this.fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
        },
        getFile: function getFile() {
            return this.$refs.upload.uploadFiles[0];
        },
        clearFile: function clearFile() {
            if (this.$refs.upload) {
                this.$refs.upload.clearFiles();
                this.error = false;
                this.disabledUpload = false;
            }
        },
        valid: function valid() {
            this.disabledUpload = this.$refs.upload.uploadFiles.length > 0;

            if (this.$refs.upload.uploadFiles.length > 0) {
                this.$message.success('上传成功');
            }

            if (!this.required || this.$refs.upload.uploadFiles.length > 0) {
                this.error = false;
                return true;
            } else {
                this.error = true;
                return false;
            }
        }
    }
});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);

//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        'tipCode': {
            required: true
        }
    },
    data: function data() {
        return {
            tooltipVisible: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['basedataGetName']), {
        isPad: function isPad() {
            var target = this.$getWindowTarget();
            return target === '_self';
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['initBaseDataByTypes']), {
        showTooltip: function showTooltip() {
            var _this = this;

            this.tooltipVisible = true;
            setTimeout(function () {
                _this.tooltipVisible = false;
            }, 3000);
        }
    }),
    mounted: function mounted() {
        this.initBaseDataByTypes(['SysTip']).then(function () {});
    }
});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_common__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        'importApi': {
            type: Object,
            required: true
        },
        'importType': {
            type: String,
            required: true,
            validator: function validator(value) {
                return ['Excel'].indexOf(value) !== -1;
            }
        },
        'onSuccess': {
            type: Function,
            required: false
        }
    },
    data: function data() {
        return {
            importValidErrorVisible: false,
            importValidErrorMessage: '',
            importValidUpdateVisible: false,
            currentFile: null
        };
    },

    computed: {
        importUrl: function importUrl() {
            return this.importApi['importUrl4' + this.importType]();
        },
        importValidUrl: function importValidUrl() {
            return this.importApi['importValidUrl4' + this.importType]();
        },
        acceptType: function acceptType() {
            switch (this.importType) {
                case 'Excel':
                    return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
                default:
                    return '';
            }
        }
    },
    methods: {
        handleUpload: function handleUpload() {
            var _this = this;

            this.currentFile = this.$refs.upload.uploadFiles[0].raw;
            this.$refs.upload.clearFiles();
            this.importApi['importValidUrl4' + this.importType]({ file: this.currentFile }).then(function (res) {
                if (res.errorMsg) {
                    _this.importValidErrorMessage = '';
                    var errors = res.errorMsg.split('#');
                    errors.forEach(function (err) {
                        if (err) {
                            _this.importValidErrorMessage += '<div class="error-msg">' + err + '</div>';
                        }
                    });
                    _this.importValidErrorVisible = true;
                    return;
                }

                if (res.isUpdate) {
                    _this.importValidUpdateVisible = true;
                    return;
                }

                _this.importExcel();
            });
        },
        importExcel: function importExcel() {
            var _this2 = this;

            this.importApi['importUrl4' + this.importType]({ file: this.currentFile }).then(function (res) {
                if (_this2.onSuccess) {
                    _this2.onSuccess();
                }
            });
        }
    }
});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      imgTableSrc: __webpack_require__(1519)
    };
  },

  props: {
    type: {
      type: String, // 可以传入 table / text / file ，对应文字版的not found 和图片版的not found file||table
      default: 'image',
      validator: function validator(value) {
        return ['image', 'text'].indexOf(value) !== -1;
      }
    },
    height: String
  },
  methods: {},
  mounted: function mounted() {}
});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        // v-model绑定
        value: {
            type: [String, Number],
            default: ''
        },
        // 树形的数据
        data: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        // 每个树节点用来作为唯一标识的属性
        nodeKey: {
            type: [String, Number],
            default: 'id'
        },
        // tree的props配置
        props: {
            type: Object,
            default: function _default() {
                return {
                    label: 'label',
                    children: 'children'
                };
            }
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            optionData: {
                id: '',
                name: ''
            }
        };
    },

    watch: {
        'value': function value(val) {
            if (!this.isEmpty(this.data)) {
                this.init(val);
            }
        },
        'data': function data(val) {
            if (!this.isEmpty(val)) {
                this.init(this.value);
            }
        }
    },
    mounted: function mounted() {
        if (!this.isEmpty(this.data)) {
            this.init(this.value);
        }
    },

    methods: {
        // 是否为空
        isEmpty: function isEmpty(val) {
            for (var key in val) {
                return false;
            }
            return true;
        },
        handleNodeClick: function handleNodeClick(data) {
            var label = this.props.label || 'name';
            this.$emit('input', data[this.nodeKey]);
            this.optionData.id = data[this.nodeKey];
            this.optionData.name = data[label];
            this.$refs.select.visible = false;
        },
        init: function init(val) {
            var _this = this;

            if (val) {
                this.$nextTick(function () {
                    var label = _this.props.label || 'name';
                    _this.$refs.tree.setCurrentKey(val);
                    var node = _this.$refs.tree.getNode(val);
                    _this.optionData.id = val;
                    _this.optionData.name = node.label;
                });
            } else {
                this.$refs.tree.setCurrentKey(null);
            }
        },
        visibleChange: function visibleChange(e) {
            var _this2 = this;

            if (e) {
                var selectDom = document.querySelector('.is-current');
                setTimeout(function () {
                    _this2.$refs.select.scrollToOption({ $el: selectDom });
                }, 0);
            }
        },
        clear: function clear() {
            this.$emit('input', '');
        }
    }
});

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Tableau',
    props: {
        url: '',
        options: {},
        width: '',
        height: '',
        filters: {}
        // apiUrl: {
        //     // default: 'https://public.tableau.com/javascripts/api/tableau-2.2.2.min.js'
        //     default: ''
        // }
    },
    data: function data() {
        return {
            viz: {},
            workBook: {}
        };
    },

    watch: {
        url: function url() {
            if (this.viz) {
                console.log('---------------------------------url-------------------------------');
                this.viz.dispose();
            }
            this.initViz();
        },
        height: function height(val) {
            this.viz.setFrameSize(parseInt(this.width), parseInt(val));
        },
        width: function width(val) {
            this.viz.setFrameSize(parseInt(val), parseInt(this.height));
        },
        filters: function filters() {
            if (this.viz) {
                console.log('---------------------------------filters-------------------------------');
                this.viz.dispose();
            }
            this.initViz();
        }
    },
    computed: {
        worksheet: function worksheet() {
            return this.workBook.getActiveSheet();
        }
    },
    methods: {
        initViz: function initViz() {
            var _this = this;

            var containerDiv = document.getElementById("tableau");
            // Setting up constructor options
            var options = {};
            if (!this.options) {
                console.log(this.width, this.height);
                options = {
                    height: this.height ? this.height : 1000,
                    width: this.width ? this.width : 1000,
                    hideTabs: true,
                    hideToolbar: true,
                    onFirstInteractive: function onFirstInteractive() {
                        _this.workBook = _this.viz.getWorkbook();
                    }
                };
                if (this.filters) {
                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters).map(function (el) {
                        options[el.toString()] = _this.filters[el.toString()];
                    });
                }
            } else {
                options = this.options;
            }
            this.viz = new window.tableau.Viz(containerDiv, this.url, options);
        }
    },
    mounted: function mounted() {
        // let recaptchaScript = document.createElement('script')
        // // recaptchaScript.async = true
        // recaptchaScript.setAttribute('src', this.apiUrl)
        // this.tableauScript = document.head.appendChild(recaptchaScript)

        // window.addEventListener('load', () => {
        //     this.initViz()
        // })
        this.initViz();
    },
    beforeDestroy: function beforeDestroy() {
        console.log('---------------------------------beforeDestroy-------------------------------');
        this.viz.dispose();
    }
});

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_axios__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SingleUpload__ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SingleUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__SingleUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_NoDataFound__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_NoDataFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_common_NoDataFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constant_common__ = __webpack_require__(171);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      keyId: 0,
      localFileList: [],
      checkedFilesList: []
    };
  },

  props: {
    fileList: {
      // 文件列表
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    label: {
      // 显示的标题
      type: String
    },
    subLabel: {
      // 显示的标题
      type: String
    },
    action: {
      type: String, // 上传地址,自动上传时需要
      default: ''
    },
    params: {}, // 自动上传文件时需要传递的form
    accept: {
      type: String, // 接受上传的文件类型 ex: .pdf,.png, 全部类型为 '*'
      default: '*'
    },
    maxFileSize: {
      type: Number, // 最大上传文件大小，单位为 M
      default: 30
    },
    disabled: {
      type: Boolean, // 是否禁止上传
      default: false
    },
    disabledDelete: {
      type: Boolean, // 是否禁止删除
      default: false
    },
    download: {
      type: Boolean, // 是否允许下载
      default: false
    },
    preview: {
      type: Boolean, // 是否允许预览
      default: true
    },
    autoUpload: {
      type: Boolean, // 是否自动上传
      default: true
    },
    limit: {
      // 最大允许上传个数
      type: Number,
      default: 10000
    },
    success: {
      // 成功的回调函数,用于自动上传
      type: Function
    },
    error: {
      // 失败的回调函数,用于自动上传
      type: Function
    },
    selectChange: {
      // 选中的回调函数,用于自动上传
      type: Function
    },
    change: {
      // change的回调函数,用于手动上传
      type: Function
    },
    deleteFile: {
      // 删除文件的事件， need return promise, 传递 file 参数
      type: Function
    },
    lineNum: {
      type: Number,
      default: 3
    }, // 单行显示的文件数量
    icon: {
      // 文件前显示的 icon 图标样式
      type: String
    },
    deleteMode: {
      // 删除模式 add: 只能增加，不能删除历史的数据， write: 可以修改所有文件
      type: String,
      default: 'write'
    },
    fullS3Path: {
      type: String,
      default: ''
    },
    showDate: {
      type: Boolean,
      default: false
    },
    isHco: {
      type: Boolean,
      default: false
    },
    select: {
      type: Boolean,
      default: false
    },
    selectedFileList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    downloadFun: {
      type: Function
    }
  },
  model: {
    props: 'value',
    event: 'changeFile'
  },
  components: {
    SingleUpload: __WEBPACK_IMPORTED_MODULE_7__SingleUpload___default.a,
    NoDataFound: __WEBPACK_IMPORTED_MODULE_8__components_common_NoDataFound___default.a
  },
  computed: {
    forEachFileList: function forEachFileList() {
      var _this = this;

      var list = [];
      var tmpArr = [];
      this.localFileList.map(function (item, index) {
        tmpArr.push(item);
        if (tmpArr.length % _this.lineNum == 0) {
          list.push(tmpArr);
          tmpArr = [];
        }
        if (_this.localFileList.length == index + 1) {
          if (tmpArr.length > 0) {
            // 如果小于当前需要显示的数量，使用空的 div 进行数量补齐，否则 flex space-between 会产生两端对齐的样式
            if (tmpArr.length < _this.lineNum) {
              var emplyFile = {};
              var sub = _this.lineNum - tmpArr.length;
              for (var i = 0; i < sub; i++) {
                tmpArr.push(emplyFile);
              }
            }
            list.push(tmpArr);
          }
        }
      });
      return list;
    },
    // accept 显示的信息获取
    forEachAccept: function forEachAccept() {
      var _this2 = this;

      var accepts = this.accept.split(',');
      var acceptArray = [];
      accepts.map(function (acceptItem, acceptIndex) {
        var localAccept = acceptItem.trim().toLowerCase();
        if (__WEBPACK_IMPORTED_MODULE_9__constant_common__["c" /* File_Type_Name_Mapping */][localAccept]) {
          acceptArray.push(_this2.$languageChoose(__WEBPACK_IMPORTED_MODULE_9__constant_common__["c" /* File_Type_Name_Mapping */][localAccept]));
        }
      });
      return acceptArray.join('/');
    }
  },
  methods: {
    // 通知父组件更新 文件列表
    updateParentFileList: function updateParentFileList() {
      this.$emit('update:fileList', this.localFileList);
      this.$emit('update:selectedFileList', this.checkedFilesList);
    },
    beforeUpload: function beforeUpload(file) {
      if (this.limit <= this.localFileList.length) {
        this.$message({
          type: 'error',
          message: this.$t('component.filebox.limit_prefix') + ('' + this.limit) + this.$t('component.filebox.limit_suffix') + (this.localFileList.length > 1 ? this.$t('system.plural_suffix') : '')
        });
        return false;
      }
      return true;
    },
    onChange: function onChange(file) {
      if (!this.autoUpload) {
        this.localFileList.push(file);
        this.updateParentFileList();
      }
      if (this.change) {
        this.change(file);
      }
    },
    onSuccess: function onSuccess(file) {
      this.localFileList.push(file);
      this.updateParentFileList();
      if (this.success) {
        this.success(file);
      }
    },
    onError: function onError(err, file) {
      if (this.error) {
        this.error(err, file);
      }
    },
    delFile: function delFile(file) {
      var _this3 = this;

      var index = this.localFileList.indexOf(file);
      var id = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(file.id) == 'object' ? file.id.id : file.id;
      var checkedFilesList = this.checkedFilesList;

      if (checkedFilesList.length > 0) {
        checkedFilesList.forEach(function (x, i) {
          var checkedId = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(x.id) == 'object' ? x.id.id : x.id;
          if (checkedId === id || checkedId === id) {
            _this3.checkedFilesList.splice(i, 1);
          }
        });
      }
      this.$messageBox({
        icon: 'warning', // --->弹窗类型 非必填 [success √,warning ！,error X]
        severity: 'high', // --->危险等级 非必填  [low 蓝,medium 黄,high 红]
        title: this.$t('component.filebox.confirm_delete_file'), // --->主标题 必填
        btnText: this.$t('btn.confirm'), // -->按钮内文字 非必填
        callBack: function callBack() {
          if (index >= 0) {
            if (file.id) {
              var p = _this3.deleteFile ? _this3.deleteFile(file) : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
              if (!p) {
                console.error('deleteFile need return a promise');
                p = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
              }
              p.then(function (res) {
                _this3.localFileList.splice(index, 1);
                _this3.updateParentFileList();
                _this3.$emit('afterDelete');
              });
            } else if (_this3.isHco) {
              var _p = _this3.deleteFile ? _this3.deleteFile(file) : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
              if (!_p) {
                console.error('deleteFile need return a promise');
                _p = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
              }
              _p.then(function (res) {
                _this3.localFileList.splice(index, 1);
                _this3.updateParentFileList();
              });
            } else {
              // 没有文件id 说明为本地上传的文件，删除本地上传文件不需要发送请求
              _this3.localFileList.splice(index, 1);
              _this3.updateParentFileList();
              //  this.$emit('foreupdate');
            }
          } else {}
        } // -->点击按钮后回调函数 非必填
      });
    },
    getFileTypeByFilename: function getFileTypeByFilename(fileName) {
      var fileType = '';
      var nameParts = fileName.split('.');
      var suffix = nameParts[nameParts.length - 1].toLowerCase();

      var _loop = function _loop(typeKey) {
        __WEBPACK_IMPORTED_MODULE_9__constant_common__["d" /* E2E_FILE_TYPE_ENUM */][typeKey].map(function (item, index) {
          if (item === suffix) {
            fileType = typeKey;
          }
        });
      };

      for (var typeKey in __WEBPACK_IMPORTED_MODULE_9__constant_common__["d" /* E2E_FILE_TYPE_ENUM */]) {
        _loop(typeKey);
      }
      return fileType;
    },
    onlinePreview: function onlinePreview(file) {
      var url = location.origin + '/static/file/' + file.fileS3Path;
      console.log(url);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_axios__["a" /* default */])({
        url: url,
        // url: '/static/file/manual.pdf',
        method: 'GET',
        responseType: 'arraybuffer'
      });
    },

    // 是否允许删除, deleteMode 为add 只有新上传的文件可以删除，deleteMode 为 write 则所有文件可以删除
    // fileSize 文件的 fileSize 属性存在代表该文件为历史文件
    allowDelete: function allowDelete(file) {
      var allow = true;
      if (this.deleteMode == 'add' && file && file.status === '1') {
        allow = false;
      }
      return allow;
    },

    // 显示日期
    showDatePage: function showDatePage(file) {
      var date = '';
      if (!file) {
        return;
      }
      if (file.updateTime) {
        date = file.updateTime.replace(/-/g, '/').split(' ')[0];
      } else if (file.createTime) {
        date = file.createTime.replace(/-/g, '/').split(' ')[0];
      } else {
        var now = new Date();
        var year = now.getFullYear();
        var month = now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1;
        var day = now.getDate() + 1 < 10 ? '0' + now.getDate() : now.getDate();
        date = year + '/' + month + '/' + day;
      }
      return date;
    },
    previewFile: function previewFile(file) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var filename, fileType, params, fullS3Path, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                filename = file.name || file.fileName;
                fileType = _this4.getFileTypeByFilename(filename);
                _context.t0 = fileType;
                _context.next = _context.t0 === 'pdf' ? 5 : _context.t0 === 'excel' ? 18 : _context.t0 === 'image' ? 20 : 22;
                break;

              case 5:
                params = {};
                // 如果没有特别指定s3完整地址，就用file数据里的fileS3Path字段

                fullS3Path = _this4.fullS3Path !== '' ? _this4.fullS3Path : file.fileS3Path;

                if (!fullS3Path) {
                  _context.next = 14;
                  break;
                }

                _context.next = 10;
                return _this4.onlinePreview(file);

              case 10:
                res = _context.sent;

                params = {
                  fileData: res.data,
                  title: filename,
                  s3Path: fullS3Path
                };
                _context.next = 15;
                break;

              case 14:
                params = {
                  fileData: file.raw,
                  title: filename
                };

              case 15:
                params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(params, {
                  download: file.download
                });

                _this4.$PDFViewer(params);
                return _context.abrupt('break', 24);

              case 18:
                if (file.fileS3Path) {
                  _this4.onlinePreview(file).then(function (res) {
                    _this4.$previewExcel({
                      data: res.data,
                      title: filename,
                      download: true
                    });
                  });
                } else {
                  _this4.$previewExcel({
                    data: file.raw,
                    title: filename,
                    download: true
                  });
                }
                return _context.abrupt('break', 24);

              case 20:
                if (file.fileS3Path) {
                  _this4.onlinePreview(file).then(function (res) {
                    _this4.$previewImg({
                      data: res.data,
                      title: filename,
                      download: true
                    });
                  });
                } else {
                  _this4.$previewImg({
                    data: file.raw,
                    title: filename,
                    download: true
                  });
                }
                return _context.abrupt('break', 24);

              case 22:
                _this4.$message.info(_this4.$t('component.filebox.not_support_preview'));
                return _context.abrupt('break', 24);

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    downloadFile: function downloadFile(file) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var v, _filename, link, res;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this5.downloadFun) {
                  _context2.next = 4;
                  break;
                }

                _this5.downloadFun();
                _context2.next = 24;
                break;

              case 4:
                v = _this5.versions();
                _filename = file.name || file.fileName;

                if (!file.fileS3Path) {
                  _context2.next = 23;
                  break;
                }

                if (!(v.iPhone || v.iPad)) {
                  _context2.next = 17;
                  break;
                }

                link = document.createElement('a');

                link.style.display = 'none';
                link.href = file.fileS3Url;
                link.setAttribute('download', file.fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link); // 下载完成移除元素
                _context2.next = 21;
                break;

              case 17:
                _context2.next = 19;
                return _this5.onlinePreview(file);

              case 19:
                res = _context2.sent;

                _this5.$downloadFile(res.data, _filename, res.headers['content-type']);

              case 21:
                _context2.next = 24;
                break;

              case 23:
                _this5.$downloadFile(file.raw, _filename);

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    getIconByFileName: function getIconByFileName(file) {
      var icon = '';
      var filename = file.name || file.fileName;
      var nameParts = filename.split('.');
      var suffix = nameParts[nameParts.length - 1].toLowerCase();

      var _loop2 = function _loop2(typeKey) {
        __WEBPACK_IMPORTED_MODULE_9__constant_common__["d" /* E2E_FILE_TYPE_ENUM */][typeKey].map(function (item, index) {
          if (item === suffix) {
            icon = 'gsk-icon-' + typeKey;
          }
        });
      };

      for (var typeKey in __WEBPACK_IMPORTED_MODULE_9__constant_common__["d" /* E2E_FILE_TYPE_ENUM */]) {
        _loop2(typeKey);
      }
      return icon || 'gsk-icon-file';
    },
    versions: function versions() {
      var u = navigator.userAgent;
      return {
        trident: u.indexOf('Trident') > -1, // IE内核
        presto: u.indexOf('Presto') > -1, // opera内核
        webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, // 火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // android终端
        iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, // 是否iPad
        webApp: u.indexOf('Safari') == -1, // 是否web应该程序，没有头部与底部
        weixin: u.indexOf('MicroMessenger') > -1, // 是否微信 （2015-01-22新增）
        qq: u.match(/\sQQ/i) == ' qq' // 是否QQ
      };
    },
    handleCheckFile: function handleCheckFile(val) {
      this.updateParentFileList();
      if (this.selectChange) {
        this.selectChange(val);
      }
    }
    // disableCheck(file) {
    //   if (this.checkedFilesList.length > 0) {
    //     const id = typeof file.id == 'object' ? file.id.id : file.id;
    //     const { checkedFilesList } = this;
    //     return checkedFilesList.some(x => x !== id);
    //   } else {
    //     return false;
    //   }
    // }

  },
  watch: {
    fileList: {
      handler: function handler(newValue, oldValue) {
        this.localFileList = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(newValue);
      },

      deep: true
    },
    selectedFileList: function selectedFileList(newValue, oldValue) {
      this.checkedFilesList = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(newValue);
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.$nextTick(function () {
      _this6.localFileList = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(_this6.fileList);
      _this6.checkedFilesList = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(_this6.selectedFileList);
    });
  }
});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_common__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_axios__ = __webpack_require__(60);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    action: {
      type: String, // 上传地址,自动上传时需要
      default: ''
    },
    multiple: {
      type: Boolean, // 是否允许多文件上传
      default: false
    },
    accept: {
      type: String, // 接受上传的文件类型 ex: .pdf,.png, 全部类型为 '*'
      //   required: true
      default: '*'
    },
    maxFileSize: {
      type: Number, // 最大上传文件大小，单位为 M
      default: 50
    },
    disabled: {
      type: Boolean, // 是否允许上传
      default: false
    },
    autoUpload: {
      type: Boolean, // 是否自动上传
      default: true
    },
    params: {},
    limit: { // 最大允许上传个数
      type: Number,
      default: 0
    },
    success: { // 成功的回调函数
      type: Function
      //   required: true
    },
    error: { // 失败的回调函数
      type: Function
    },
    change: { // change的回调函数
      type: Function
    },
    beforeUpload: {
      type: Function
    },
    showSuccessTip: { // 是否显示上传成功提示
      type: Boolean, // 是否自动上传
      default: true
    }
  },
  components: {},
  data: function data() {
    var _headers;

    return {
      baseURL: __WEBPACK_IMPORTED_MODULE_2__util_axios__["b" /* baseURL */],
      headers: (_headers = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_headers, __WEBPACK_IMPORTED_MODULE_1__constant_common__["e" /* E2E_TOKEN_NAME */], localStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__constant_common__["e" /* E2E_TOKEN_NAME */])), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_headers, __WEBPACK_IMPORTED_MODULE_1__constant_common__["a" /* E2E_INTL_HEADER */], localStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__constant_common__["b" /* E2E_LANGUAGE_STORAGE_KEY */])), _headers),
      loading: undefined
    };
  },

  computed: {
    localAccept: function localAccept() {
      var accept = [];
      if (this.accept === '*') {
        return '*';
      }
      var allowKeys = this.accept.split(',');
      allowKeys = allowKeys.map(function (x) {
        return x.trim();
      });
      for (var typeKey in __WEBPACK_IMPORTED_MODULE_1__constant_common__["d" /* E2E_FILE_TYPE_ENUM */]) {
        if (allowKeys.indexOf(typeKey) != -1) {
          __WEBPACK_IMPORTED_MODULE_1__constant_common__["d" /* E2E_FILE_TYPE_ENUM */][typeKey].map(function (item, index) {
            accept.push('.' + item);
          });
        }
      }
      if (accept.length == 0) {
        return '*';
      }
      return accept.join(',');
    },
    localAction: function localAction() {
      var l_action = '';
      if (this.action) {
        if (this.action.substr(0, 1) == '/') {
          l_action = __WEBPACK_IMPORTED_MODULE_2__util_axios__["b" /* baseURL */] ? __WEBPACK_IMPORTED_MODULE_2__util_axios__["b" /* baseURL */] + this.action : this.action;
        } else {
          l_action = __WEBPACK_IMPORTED_MODULE_2__util_axios__["b" /* baseURL */] ? __WEBPACK_IMPORTED_MODULE_2__util_axios__["b" /* baseURL */] + '/' + this.action : '/' + this.action;
        }
      }
      return l_action;
    }
  },
  watch: {},
  methods: {
    onExceed: function onExceed() {
      this.$message({
        type: 'error',
        message: this.$t('component.filebox.limit_prefix') + ('' + this.limit) + this.$t('component.filebox.limit_suffix') + (this.limit.length > 1 ? this.$t('system.plural_suffix') : '')
      });
    },
    localBeforeUpload: function localBeforeUpload(file) {
      if (!this.checkFileFormat(file)) {
        return false;
      }
      var allowUpload = true;
      var fileSize = file.size / 1024 / 1024;
      if (fileSize > this.maxFileSize) {
        this.$message({
          type: 'error',
          message: this.$t('component.singleupload.max_size_prefix') + ('' + this.maxFileSize) + this.$t('component.singleupload.max_size_suffix')
        });
        return false;
      }
      if (this.beforeUpload) {
        allowUpload = this.beforeUpload(file);
      }
      if (allowUpload) {
        this.loading = this.$loading({
          lock: true,
          text: this.$t('component.singleupload.uploading')
        });
      }
      return allowUpload;
    },
    onChange: function onChange(file, fileList) {
      var fileSize = file.size / 1024 / 1024;
      if (!this.checkFileFormat(file)) {
        return false;
      }
      if (fileSize > this.maxFileSize) {
        this.$message({
          type: 'error',
          message: this.$t('component.singleupload.max_size_prefix') + ('' + this.maxFileSize) + this.$t('component.singleupload.max_size_suffix')
        });
        return false;
      }
      if (this.change) {
        this.change(file);
      }
    },
    checkFileFormat: function checkFileFormat(file) {
      if (this.localAccept == '*') {
        return true;
      }
      var fileSuffix = this.$getFileSuffix(file.name).toLowerCase();
      if (this.localAccept.split(',').indexOf('.' + fileSuffix) == -1) {
        this.$message.error(this.$t('component.singleupload.error_file_format'));
        return false;
      }
      return true;
    },
    onSuccess: function onSuccess(response, file, fileList) {
      if (response.code == 200) {
        if (this.showSuccessTip) {
          this.$message.success(this.$t('component.singleupload.upload_success'));
        }
        this.loading.close();
        var fileId = file.response.result[0];
        file.id = fileId;
        this.success(file, response);
        this.$refs.upload.clearFiles();
      } else {
        this.loading.close();
        this.success(file, response);
        this.$refs.upload.clearFiles();
      }
    },
    onError: function onError(err, file, fileList) {
      this.loading.close();
      this.$message.error(this.$t('component.singleupload.upload_failed'));
      if (this.error) {
        this.error(err, file);
      }
    }
  },
  mounted: function mounted() {
    // console.log('single upload', this.params);
  }
});

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_costCenterAndWbs__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_bizmanagement_budget__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_bizmanagement_index__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_sysmanagement_externalprivilege__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_basedata__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_SessionStorageService__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_organizationUtil__ = __webpack_require__(52);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isConfigurationData: true,
      departsList: [],
      medicalFieldList: [],
      teamList: [],
      budgetDetailData: [],
      searchMainData: {
        year: '',
        departId: '',
        medicalField: '',
        teamL4: ''
      },
      searchData: {
        quarter: '',
        costCenter: '',
        wbsCode: '',
        pid: ''
      },
      addNewOrEditData: {
        costType: 1, // 默认值为1
        companyCode: '', // 法律实体，默认取登录用户法律实体
        departId: '',
        medicalField: '',
        teamL4: '',
        prodIds: [],
        year: '',
        quarter: '',
        costCenter: '',
        costCenterName: '',
        wbsCode: '',
        wbsCodeName: '',
        budgAmt: 0,
        isMedicalField: '',
        owner: '',
        ownerName: ''
      },
      mainData: {},
      mainDataTemp: {},
      crudApi: __WEBPACK_IMPORTED_MODULE_3__api_bizmanagement_budget__["a" /* default */],
      editMainBudget: false,
      confirmEditMainBudgetSaveVisible: false,
      isEdit: false,
      budgetDetailCount: 0,
      budgetDetailAmt: 0,
      selectedData: [],
      companyCodeArray: [], // 法律实体字典数据(company_code)
      costCenterArray: [],
      wbsCodeArray: [],
      costCenter4EditArray: [],
      wbsCode4EditArray: [],
      filterCostCenter4EditArray: [],
      filterWbsCode4EditArray: [], // 新增：用于远程搜索过滤的WBS code数组
      allWbsCode4EditArray: [], // 新增：存储所有WBS code数据
      remoteOwnerArray: [],
      filterCostCenterByQuarter: null, //null 代表没有查询；空字符串代码没有记录需过滤
      retryExternalCostCenterArray: 3
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(['userInfo', 'baseDataRecords', 'basedataGetName', 'basedataGetNameByRowIdField'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapActions */])(['initBaseDataByTypes']), {
    getMedicalFieldArray: function getMedicalFieldArray(departId) {
      return __WEBPACK_IMPORTED_MODULE_9__util_organizationUtil__["a" /* franchiseArray */](departId);
    },
    getTeamArray: function getTeamArray(departId, medicalField) {
      return __WEBPACK_IMPORTED_MODULE_9__util_organizationUtil__["c" /* teamArray */](departId, medicalField);
    },
    resetMedicalField: function resetMedicalField() {
      this.searchMainData.medicalField = (this.baseDataRecords.Organization[0][this.searchMainData.departId][0] || {}).id;
      this.resetTeamField();
    },
    resetTeamField: function resetTeamField() {
      var medicalList = this.baseDataRecords.Organization[0][this.searchMainData.departId];
      for (var i = 0; i < medicalList.length; i++) {
        if (medicalList[i].id == this.searchMainData.medicalField) {
          this.searchMainData.teamL4 = (medicalList[i].teams[0] || {}).id;
          return;
        }
      }
    },
    formatDateTime2Date: function formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    formatBaseData: function formatBaseData(row, column, cellValue, index) {
      if (column.property == 'prodIds') {
        if (row.prodIds) {
          var ids = row.prodIds;
          if (typeof ids == 'string') {
            ids = ids.split(',');
          }
          var prodNames = [];
          for (var pidIndex = 0; pidIndex < ids.length; pidIndex++) {
            prodNames.push(this.basedataGetName('Product', ids[pidIndex]));
          }
          return prodNames.join(',');
        }
        return row.prodIds;
      }

      return this.basedataGetNameByRowIdField(column.property, row);
    },
    indexMethod: function indexMethod(index) {
      return this.$refs['crud'].indexMethod(index);
    },
    handleSearch: function handleSearch() {
      this.$refs['crud'].handleSearch(1);
    },
    handleSearchResult: function handleSearchResult(res) {
      this.budgetDetailCount = res.rowCount;
      this.budgetDetailAmt = res.sumBudgAmt;

      res.current = res.pageList.current;
      res.total = res.pageList.total;

      this.budgetDetailData = res.pageList.records;
    },
    handleAddNewClick: function handleAddNewClick() {
      var _this = this;

      this.wbsCode4EditArray = [];
      this.allWbsCode4EditArray = []; // 清空 allWbsCode4EditArray
      this.isEdit = false; // 设置为新增模式
      this.filterCostCenterByQuarter = null;

      // 先调用handleAddNew
      this.$refs['crud'].handleAddNew(this.mainData);
      this.addNewOrEditData.budgAmt = 0;

      // 设置默认类型为1，并且确保类型切换方法可以被触发
      this.$nextTick(function () {
        _this.addNewOrEditData.costType = 1;
        // 默认法律实体为登录用户法律实体
        _this.addNewOrEditData.companyCode = _this.userInfo.companyCode;
        // 如果需要加载相关数据
        _this.loadExternalCostCenter();
      });
    },
    handleEditClick: function handleEditClick(item) {
      var _this2 = this;

      item.isMedicalField = item.isMedicalField == '1';
      this.isEdit = true; // 设置为编辑模式
      if (typeof item.prodIds == 'string') {
        item.prodIds = item.prodIds.split(',');
      }

      // 确保 costType 是数字类型，而不是字符串
      if (item.costType !== undefined) {
        item.costType = Number(item.costType); // 转换为数字，确保与option的value匹配
      }

      // 根据 costType 设置不同的数据
      if (item.costType === 1) {
        this.filterCostCenter4EditArray = [{
          costCenter: item.costCenter,
          description: item.costCenterName
        }];
        this.wbsCode4EditArray = [{
          wbsElement: item.wbsCode,
          description: item.wbsCodeName
        }];

        // 如果有owner，设置owner相关数据
        if (item.owner) {
          this.remoteOwnerArray = [{
            username: item.owner,
            realname: item.ownerName || item.owner
          }];
        }
      } else {
        // 类型2：设置 WBS code 相关数据
        this.allWbsCode4EditArray = [{
          wbsElement: item.wbsCode,
          description: item.wbsCodeName
        }];
        // 清空成本中心相关数据
        this.filterCostCenter4EditArray = [];
        this.remoteOwnerArray = [];
      }

      this.$refs['crud'].handleEdit(item);
      this.$nextTick(function () {
        if (item.costType === 1) {
          // 重新加载完整的成本中心列表和WBS code列表
          _this2.loadExternalCostCenter();
        } else {
          // 重新加载完整的 WBS code 列表
          _this2.loadExternalWbsCode();
        }

        // 强制刷新选择器的显示
        if (_this2.$refs['crud'] && _this2.$refs['crud'].$refs.editForm) {
          _this2.$refs['crud'].$refs.editForm.clearValidate();
        }
      });
    },
    beforeSave: function beforeSave(saveData) {
      saveData.pid = this.mainData.id;
      saveData.prodIds = saveData.prodIds.join(',');
      saveData.isMedicalField = saveData.isMedicalField ? '1' : '0';
    },
    handleDeleteClick: function handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleBatchDeleteClick: function handleBatchDeleteClick() {
      this.$refs['crud'].handleBatchDelete();
    },
    handlerExportExcelClick: function handlerExportExcelClick() {
      this.$refs['crud'].handlerExportExcel('预算拆分.xlsx');
    },
    handleUpdateSuccess: function handleUpdateSuccess() {
      this.handleSearch();
    },
    handleMainEdit: function handleMainEdit() {
      this.editMainBudget = true;
    },
    handleCancleMainEditClick: function handleCancleMainEditClick() {
      this.mainData = _.clone(this.mainDataTemp);
      this.editMainBudget = false;
    },
    handleConfirmMainEditClick: function handleConfirmMainEditClick() {
      this.confirmEditMainBudgetSaveVisible = true;
    },
    handlerEditMainBudgetSaveConfirmOK: function handlerEditMainBudgetSaveConfirmOK() {
      var _this3 = this;

      if (!this.mainData.id) {
        this.mainData.year = this.searchMainData.year;
        this.mainData.departId = this.searchMainData.departId;
        this.mainData.medicalField = this.searchMainData.medicalField;
        this.mainData.teamL4 = this.searchMainData.teamL4;
      }
      __WEBPACK_IMPORTED_MODULE_3__api_bizmanagement_budget__["a" /* default */].editMainBudget(this.mainData).then(function (res) {
        _this3.$message.success('编辑年度/季度预算成功');
        _this3.mainDataTemp = _.clone(_this3.mainData);
        _this3.confirmEditMainBudgetSaveVisible = false;
        _this3.editMainBudget = false;

        _this3.handleBudgetMainSearch();
      });
    },
    handleBudgetMainSearch: function handleBudgetMainSearch() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_3__api_bizmanagement_budget__["a" /* default */].queryMainBudget(this.searchMainData).then(function (res) {
        res.teamL4 = _this4.searchMainData.teamL4;
        _this4.mainData = res;
        if (!_this4.mainData.id) {
          _this4.mainData = {
            "yearBudgAmt": 0,
            "q1BudgAmt": 0,
            "q2BudgAmt": 0,
            "q3BudgAmt": 0,
            "q4BudgAmt": 0
          };
        }
        _this4.mainDataTemp = _.clone(_this4.mainData);

        _this4.searchData.quarter = '';
        _this4.searchData.costCenter = '';
        _this4.searchData.wbsCode = '';
        _this4.searchData.pid = _this4.mainData.id;

        _this4.budgetDetailCount = 0;
        _this4.budgetDetailAmt = 0;

        if (!_this4.searchData.pid) {
          //没有数据，直接清空table数据
          _this4.budgetDetailData = [];
        } else {
          _this4.handleSearch();
        }
      });
    },
    getNameFromArray: function getNameFromArray(arr, idField, nameField, id) {
      if (arr) {
        for (var index = 0; index < arr.length; index++) {
          var element = arr[index];
          if (element[idField] == id) {
            return element[nameField];
          }
        }
      }

      return '';
    },
    handleSearchCostCenterChange: function handleSearchCostCenterChange() {
      var _this5 = this;

      this.searchData.wbsCode = '';
      this.wbsCodeArray = [];

      if (!this.searchData.costCenter) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_2__api_costCenterAndWbs__["a" /* default */].listLocalWbsCode({
        companyCode: this.userInfo.companyCode,
        costCenter: this.searchData.costCenter
      }).then(function (res) {
        _this5.wbsCodeArray = res;
      });
    },
    handleEditCostCenterChange: function handleEditCostCenterChange() {
      var _this6 = this;

      this.addNewOrEditData.wbsCode = '';
      this.addNewOrEditData.wbsCodeName = '';
      this.wbsCode4EditArray = [];

      if (!this.addNewOrEditData.costCenter) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_2__api_costCenterAndWbs__["a" /* default */].listExternalWbsCode({
        companyCode: this.addNewOrEditData.companyCode,
        costCenter: this.addNewOrEditData.costCenter,
        costType: 1
      }).then(function (res) {
        _this6.wbsCode4EditArray = res;
      });
    },
    handleCostCenter4EditFilter: function handleCostCenter4EditFilter(query) {
      if (!query) {
        this.filterCostCenter4EditArray = [];
        return;
      }

      this.filterCostCenter4EditArray = this.costCenter4EditArray.filter(function (item) {
        var description = item.description ? item.description.toLowerCase() : '';
        var costCenter = item.costCenter ? item.costCenter.toLowerCase() : '';
        var queryLower = query ? query.toLowerCase() : '';

        return description.indexOf(queryLower) > -1 || costCenter.indexOf(queryLower) > -1;
      });
    },

    // 新增：WBS code远程搜索过滤方法
    handleWbsCodeRemoteFilter: function handleWbsCodeRemoteFilter(query) {
      if (!query) {
        this.filterWbsCode4EditArray = [];
        return;
      }

      // 从 allWbsCode4EditArray 中过滤匹配的数据
      this.filterWbsCode4EditArray = this.allWbsCode4EditArray.filter(function (item) {
        var queryLower = query ? query.toLowerCase() : '';
        return item.description && item.description.toLowerCase().indexOf(queryLower) > -1 || item.wbsElement && item.wbsElement.toLowerCase().indexOf(queryLower) > -1;
      });
    },


    // 新增：WBS code变更处理方法
    handleWbsCodeChange: function handleWbsCodeChange() {
      // 当选择WBS code后，保存对应的描述信息
      this.addNewOrEditData.wbsCodeName = this.getNameFromArray(this.allWbsCode4EditArray, 'wbsElement', 'description', this.addNewOrEditData.wbsCode);
      // 清空过滤数组，避免显示过多选项
      this.filterWbsCode4EditArray = [];
    },
    handleOwnerFilter: function handleOwnerFilter(query) {
      var _this7 = this;

      if (!query) {
        this.remoteOwnerArray = [];
        return;
      }

      this.remoteOwnerArray = [];

      __WEBPACK_IMPORTED_MODULE_5__api_sysmanagement_externalprivilege__["a" /* default */].getEdcByAd({
        ad: query
      }).then(function (res) {
        if (res && res.username) {
          _this7.remoteOwnerArray = [res];
        }
      });
    },
    getName: function getName(value, array, idField, nameField) {
      for (var index = 0; index < array.length; index++) {
        var element = array[index];
        if (element[idField] == value) {
          return element[nameField];
        }
      }

      return '';
    },

    // 修改 unique 方法
    unique: function unique(arr) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'costCenter';

      var res = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
      if (type === 'wbs') {
        // 针对 WBS code 数据，使用 wbsElement 作为唯一标识
        return arr.filter(function (item) {
          return !res.has(item.wbsElement) && res.set(item.wbsElement, 1);
        });
      } else {
        // 针对成本中心数据，使用 costCenter 作为唯一标识
        return arr.filter(function (item) {
          return !res.has(item.costCenter) && res.set(item.costCenter, 1);
        });
      }
    },
    loadExternalCostCenter: function loadExternalCostCenter() {
      var _this8 = this;

      // 法律实体由表单选择决定，新增时默认登录用户法律实体
      var companyCode = this.addNewOrEditData.companyCode || this.userInfo.companyCode;
      // 缓存 key 按法律实体区分，避免切换法律实体后命中旧数据
      var cacheKey = 'budget-extenal-cost-center:' + companyCode;
      var tempArr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_SessionStorageService__["a" /* getItem */])(cacheKey);
      if (tempArr) {
        var arr1 = this.unique(tempArr);
        this.costCenter4EditArray = arr1;
        return;
      }

      this.retryExternalCostCenterArray = this.retryExternalCostCenterArray - 1;
      __WEBPACK_IMPORTED_MODULE_2__api_costCenterAndWbs__["a" /* default */].listExternalCostCenter({ companyCode: companyCode }).then(function (res) {
        var arr1 = _this8.unique(res);
        _this8.costCenter4EditArray = arr1;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_SessionStorageService__["b" /* setItem */])(cacheKey, _this8.costCenter4EditArray);
      }, function (err) {
        if (_this8.retryExternalCostCenterArray > 0) {
          _this8.loadExternalCostCenter();
        }
      });
    },
    handleBudgetChange: function handleBudgetChange() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_2__api_costCenterAndWbs__["a" /* default */].listLocalCostCenter({ companyCode: this.userInfo.companyCode }).then(function (res) {
        _this9.costCenterArray = res;
      });
    },

    // 加载法律实体字典(company_code)
    loadCompanyCode: function loadCompanyCode() {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_6__api_basedata__["a" /* default */].listCompanyCode().then(function (res) {
        _this10.companyCodeArray = res || [];
      });
    },
    getCustomizationArray: function getCustomizationArray(arr) {
      if (arr.length > 0) {
        var customizationArray = arr.map(function (ele) {
          var data = {
            id: ele,
            teamName: ele
          };
          return data;
        });
        return customizationArray;
      } else return [];
    },

    // 处理类型变更
    handleCostTypeChange: function handleCostTypeChange(value) {
      var _this11 = this;

      // 清空成本中心相关字段
      this.addNewOrEditData.costCenter = '';
      this.addNewOrEditData.owner = '';
      this.addNewOrEditData.ownerName = '';

      // 清空WBS code
      this.addNewOrEditData.wbsCode = '';
      this.addNewOrEditData.wbsCodeName = '';
      this.filterWbsCode4EditArray = []; // 清空过滤数组

      // 触发表单校验更新
      this.$nextTick(function () {
        if (_this11.$refs['crud'] && _this11.$refs['crud'].$refs.editForm) {
          _this11.$refs['crud'].$refs.editForm.clearValidate(['costCenter', 'wbsCode']);
        }
      });

      if (value == '2') {
        this.loadExternalWbsCode();
      }
    },


    // 处理法律实体变更：清空成本中心/WBS 已选值并按类型重新加载列表
    handleCompanyCodeChange: function handleCompanyCodeChange() {
      var _this12 = this;

      // 清空成本中心相关字段与数组
      this.addNewOrEditData.costCenter = '';
      this.addNewOrEditData.costCenterName = '';
      this.addNewOrEditData.owner = '';
      this.addNewOrEditData.ownerName = '';
      this.filterCostCenter4EditArray = [];
      this.costCenter4EditArray = [];

      // 清空 WBS code 相关字段与数组
      this.addNewOrEditData.wbsCode = '';
      this.addNewOrEditData.wbsCodeName = '';
      this.wbsCode4EditArray = [];
      this.filterWbsCode4EditArray = [];
      this.allWbsCode4EditArray = [];

      // 触发表单校验更新
      this.$nextTick(function () {
        if (_this12.$refs['crud'] && _this12.$refs['crud'].$refs.editForm) {
          _this12.$refs['crud'].$refs.editForm.clearValidate(['costCenter', 'wbsCode']);
        }
      });

      // 按当前类型重新加载对应法律实体的数据
      if (this.addNewOrEditData.costType === 1) {
        this.loadExternalCostCenter();
      } else if (this.addNewOrEditData.costType === 2) {
        this.loadExternalWbsCode();
      }
    },


    // 修改 loadExternalWbsCode 方法
    loadExternalWbsCode: function loadExternalWbsCode() {
      var _this13 = this;

      // 法律实体由表单选择决定，新增时默认登录用户法律实体
      var companyCode = this.addNewOrEditData.companyCode || this.userInfo.companyCode;
      // 缓存 key 按法律实体区分，避免切换法律实体后命中旧数据
      var cacheKey = 'budget-extenal-wbs-code:' + companyCode;
      var tempArr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_SessionStorageService__["a" /* getItem */])(cacheKey);
      if (tempArr) {
        var arr1 = this.unique(tempArr, 'wbs');
        this.allWbsCode4EditArray = arr1;
        return;
      }

      __WEBPACK_IMPORTED_MODULE_2__api_costCenterAndWbs__["a" /* default */].listExternalWbsCode({
        companyCode: companyCode,
        costType: 2,
        costCenter: ''
      }).then(function (res) {
        var arr1 = _this13.unique(res, 'wbs');
        _this13.allWbsCode4EditArray = arr1;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_SessionStorageService__["b" /* setItem */])(cacheKey, _this13.allWbsCode4EditArray);
      });
    }
  }),
  mounted: function mounted() {
    var _this14 = this;

    __WEBPACK_IMPORTED_MODULE_4__api_bizmanagement_index__["a" /* default */].queryBusDataOrg().then(function (res) {
      _this14.isConfigurationData = res.isConfigurationData;
      _this14.searchMainData.year = new Date().getFullYear();
      if (_this14.isConfigurationData) {
        _this14.departsList = _this14.getCustomizationArray(res.departList);
        _this14.searchMainData.departId = res.departList.length > 0 ? res.departList[0] : '';
        _this14.medicalFieldList = _this14.getCustomizationArray(res.medicalFieldList);
        _this14.searchMainData.medicalField = res.medicalFieldList.length > 0 ? res.medicalFieldList[0] : '';
        _this14.teamList = _this14.getCustomizationArray(res.teamList);
        _this14.searchMainData.teamL4 = res.teamList.length > 0 ? res.teamList[0] : '';
        // this.resetMedicalField();
        _this14.handleBudgetMainSearch();
      } else {
        _this14.initBaseDataByTypes(['Depart', 'MedicalField', 'Year', 'Quarter', 'Product']).then(function () {
          _this14.searchMainData.departId = _this14.userInfo.loginDeparts.length > 0 ? _this14.userInfo.loginDeparts[0].id : '';
          var tempMedicalFieldArray = _this14.getMedicalFieldArray(_this14.searchMainData.departId);
          _this14.searchMainData.medicalField = tempMedicalFieldArray.length > 0 ? tempMedicalFieldArray[0].id : '';
          var tempTeamArray = _this14.getTeamArray(_this14.searchMainData.departId, _this14.searchMainData.medicalField);
          _this14.searchMainData.teamL4 = tempTeamArray.length > 0 ? tempTeamArray[0].id : '';
          _this14.resetMedicalField();
          _this14.handleBudgetMainSearch();
        });
      }
    });

    this.handleBudgetChange();

    this.loadExternalCostCenter();

    this.loadCompanyCode();
  }
});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_bizmanagement_domainresult__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_organizationUtil__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_bizmanagement_index__ = __webpack_require__(173);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isConfigurationData: true,
      departsList: [],
      medicalFieldList: [],
      teamList: [],
      domainresultData: [],
      searchData: {
        treatAreaResult: '',
        departId: '',
        medicalField: '',
        teamL4: '',
        productId: ''
      },
      addNewOrEditData: {
        treatAreaResult: '',
        departId: '',
        medicalField: '',
        teamL4: '',
        productId: ''
      },
      crudApi: __WEBPACK_IMPORTED_MODULE_1__api_bizmanagement_domainresult__["a" /* default */],
      selectedData: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['baseDataRecords', 'basedataGetName', 'basedataGetNameByRowIdField', 'userInfo'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['reloadBaseDataByType', 'initBaseDataByTypes']), {
    getMedicalFieldArray: function getMedicalFieldArray(departId, independ) {
      return __WEBPACK_IMPORTED_MODULE_3__util_organizationUtil__["a" /* franchiseArray */](departId, independ);
    },
    getTeamArray: function getTeamArray(departId, medicalField, independ) {
      return __WEBPACK_IMPORTED_MODULE_3__util_organizationUtil__["c" /* teamArray */](departId, medicalField, independ);
    },
    formatDateTime2Date: function formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    formatBaseData: function formatBaseData(row, column, cellValue, index) {
      return this.basedataGetNameByRowIdField(column.property, row);
    },
    indexMethod: function indexMethod(index) {
      return this.$refs['crud'].indexMethod(index);
    },
    handleSearch: function handleSearch() {
      this.$refs['crud'].handleSearch(1);
    },
    handleAddNewClick: function handleAddNewClick() {
      this.$refs['crud'].handleAddNew();
    },
    handleEditClick: function handleEditClick(item) {
      this.$refs['crud'].handleEdit(item);
    },
    beforeSave: function beforeSave(saveData) {},
    handleDeleteClick: function handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleBatchDeleteClick: function handleBatchDeleteClick() {
      this.$refs['crud'].handleBatchDelete();
    },
    handlerExportExcelClick: function handlerExportExcelClick() {
      this.$refs['crud'].handlerExportExcel('业务结果.xlsx');
    },
    handleUpdateSuccess: function handleUpdateSuccess() {
      this.handleSearch();
    },
    handleDomainResultChange: function handleDomainResultChange() {
      this.reloadBaseDataByType('DomainResult');
    },
    getCustomizationArray: function getCustomizationArray(arr) {
      if (arr.length > 0) {
        var customizationArray = arr.map(function (ele) {
          var data = {
            id: ele,
            teamName: ele
          };
          return data;
        });
        return customizationArray;
      } else return [];
    }
  }),
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4__api_bizmanagement_index__["a" /* default */].queryBusDataOrg().then(function (res) {
      _this.isConfigurationData = res.isConfigurationData;
      _this.departsList = _this.getCustomizationArray(res.departList);
      _this.medicalFieldList = _this.getCustomizationArray(res.medicalFieldList);
      _this.teamList = _this.getCustomizationArray(res.teamList);
      _this.initBaseDataByTypes(['Depart', 'MedicalField', 'Product']).then(function () {
        _this.handleSearch();
      });
    });
  }
});

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_bizmanagement_hospitallevel__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_organizationUtil__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_bizmanagement_index__ = __webpack_require__(173);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isConfigurationData: true,
      departsList: [],
      medicalFieldList: [],
      teamList: [],
      hospitallevelData: [],
      searchData: {
        departId: '',
        medicalField: '',
        teamL4: '',
        hospitalLevel: ''
      },
      addNewOrEditData: {
        departId: '',
        medicalField: '',
        teamL4: '',
        hospitalLevel: '',
        prodIds: [],
        modelScore: ''
      },
      crudApi: __WEBPACK_IMPORTED_MODULE_1__api_bizmanagement_hospitallevel__["a" /* default */],
      selectedData: [],
      isEdit: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['baseDataRecords', 'basedataGetName', 'basedataGetNameByRowIdField', 'userInfo']), {
    canDownload: function canDownload() {
      return this.addNewOrEditData.departId && this.addNewOrEditData.medicalField && this.addNewOrEditData.hospitalLevel && this.addNewOrEditData.prodIds.length > 0;
    },
    canBatchDelete: function canBatchDelete() {
      if (this.selectedData.length <= 0) {
        return false;
      }

      for (var index = 0; index < this.selectedData.length; index++) {
        var element = this.selectedData[index];
        if (element.typeId == "0") {
          return false;
        }
      }

      return true;
    },
    hospitalLevelNames: function hospitalLevelNames() {
      return _.uniqBy(this.baseDataRecords.HospitalLevel, 'hospitalLevel');
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['reloadBaseDataByType', 'initBaseDataByTypes']), {
    getMedicalFieldArray: function getMedicalFieldArray(departId, independ) {
      return __WEBPACK_IMPORTED_MODULE_3__util_organizationUtil__["a" /* franchiseArray */](departId, independ);
    },
    getTeamArray: function getTeamArray(departId, medicalField, independ) {
      return __WEBPACK_IMPORTED_MODULE_3__util_organizationUtil__["c" /* teamArray */](departId, medicalField, independ);
    },
    formatDateTime2Date: function formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    formatBaseData: function formatBaseData(row, column, cellValue, index) {
      if (column.property == 'departId' || column.property == 'medicalField') {
        return row[column.property] ? row[column.property] : '全部';
      }

      if (column.property == 'prodIds') {
        if (row.prodIds) {
          var ids = row.prodIds;
          if (typeof ids == 'string') {
            ids = ids.split(',');
          }
          var prodNames = [];
          for (var pidIndex = 0; pidIndex < ids.length; pidIndex++) {
            prodNames.push(this.basedataGetName('Product', ids[pidIndex]));
          }
          return prodNames.join(',');
        }
        return '全部';
      }

      if (column.property == 'typeId') {
        return row.typeId == '1' ? '自定义' : '标准';
      }

      return this.basedataGetNameByRowIdField(column.property, row);
    },
    indexMethod: function indexMethod(index) {
      return this.$refs['crud'].indexMethod(index);
    },
    handleSearch: function handleSearch() {
      this.$refs['crud'].handleSearch(1);
    },
    handleAddNewClick: function handleAddNewClick() {
      if (this.$refs.strategyHospital4Hospital) {
        this.$refs.strategyHospital4Hospital.clearFile();
      }
      this.$refs['crud'].handleAddNew();
      this.isEdit = false;
    },
    handleEditClick: function handleEditClick(item) {
      if (this.$refs.strategyHospital4Hospital) {
        this.$refs.strategyHospital4Hospital.clearFile();
      }
      if (typeof item.prodIds == 'string') {
        item.prodIds = item.prodIds.split(',');
      }
      this.$refs['crud'].handleEdit(item);
      this.isEdit = true;
    },
    beforeSave: function beforeSave(saveData) {
      saveData.departName = this.basedataGetName('Depart', saveData.departId);
      saveData.medicalFieldName = this.basedataGetName('MedicalField', saveData.medicalField);
      saveData.file = this.$refs.strategyHospital4Hospital.getFile() ? this.$refs.strategyHospital4Hospital.getFile().raw : null;
      saveData.prodIds = saveData.prodIds.join(',');
    },
    validUpload: function validUpload() {
      return this.$refs.strategyHospital4Hospital.valid();
    },
    handleDeleteClick: function handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleBatchDeleteClick: function handleBatchDeleteClick() {
      this.$refs['crud'].handleBatchDelete();
    },
    handlerExportExcelClick: function handlerExportExcelClick() {
      this.$refs['crud'].handlerExportExcel('医院层级管理.xlsx');
    },
    handleHospitalLevelChange: function handleHospitalLevelChange() {
      this.reloadBaseDataByType('HospitalLevel');
    },
    getScoreExportParams: function getScoreExportParams() {
      var params = _.clone(this.addNewOrEditData);
      params.flag = this.isEdit ? 2 : 1;
      params.departName = this.basedataGetName('Depart', params.departId);
      params.medicalFieldName = this.basedataGetName('MedicalField', params.medicalField);
      params.productName = this.basedataGetName('Product', params.prodIds);
      params.productId = params.prodIds.join(',');
      delete params.prodIds;
      if (params.id) {
        params.hospitalLevelId = params.id;
      }

      return params;
    },
    getCustomizationArray: function getCustomizationArray(arr) {
      if (arr.length > 0) {
        var customizationArray = arr.map(function (ele) {
          var data = {
            id: ele,
            teamName: ele
          };
          return data;
        });
        return customizationArray;
      } else return [];
    }
  }),
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4__api_bizmanagement_index__["a" /* default */].queryBusDataOrg().then(function (res) {
      _this.isConfigurationData = res.isConfigurationData;
      _this.departsList = _this.getCustomizationArray(res.departList);
      _this.medicalFieldList = _this.getCustomizationArray(res.medicalFieldList);
      _this.teamList = _this.getCustomizationArray(res.teamList);
      _this.initBaseDataByTypes(['Depart', 'MedicalField', 'Product', 'HospitalLevel']).then(function () {
        _this.handleSearch();
      });
    });

    window._self = this;
  }
});

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_bizmanagement_speakerlevel__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_organizationUtil__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_bizmanagement_index__ = __webpack_require__(173);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isConfigurationData: true,
      departsList: [],
      medicalFieldList: [],
      teamList: [],
      speakerLevelData: [],
      searchData: {
        departId: '',
        medicalField: '',
        teamL4: '',
        departName: '',
        speakerLevel: ''
      },
      addNewOrEditData: {
        departId: '',
        medicalField: '',
        teamL4: '',
        speakerLevel: '',
        modelScore: ''
      },
      crudApi: __WEBPACK_IMPORTED_MODULE_1__api_bizmanagement_speakerlevel__["a" /* default */],
      selectedData: [],
      isEdit: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['baseDataRecords', 'basedataGetName', 'basedataGetNameByRowIdField', 'userInfo']), {
    canDownload: function canDownload() {
      return this.addNewOrEditData.departId && this.addNewOrEditData.medicalField && this.addNewOrEditData.speakerLevel;
    },
    canBatchDelete: function canBatchDelete() {
      if (this.selectedData.length <= 0) {
        return false;
      }

      for (var index = 0; index < this.selectedData.length; index++) {
        var element = this.selectedData[index];
        if (element.typeId == "0") {
          return false;
        }
      }

      return true;
    },
    speakerLevelNames: function speakerLevelNames() {
      return _.uniqBy(this.baseDataRecords.SpeakerLevel, 'speakerLevel');
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['reloadBaseDataByType', 'initBaseDataByTypes']), {
    getMedicalFieldArray: function getMedicalFieldArray(departId, independ) {
      return __WEBPACK_IMPORTED_MODULE_3__util_organizationUtil__["a" /* franchiseArray */](departId, independ);
    },
    getTeamArray: function getTeamArray(departId, medicalField, independ) {
      return __WEBPACK_IMPORTED_MODULE_3__util_organizationUtil__["c" /* teamArray */](departId, medicalField, independ);
    },
    formatDateTime2Date: function formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    formatBaseData: function formatBaseData(row, column, cellValue, index) {
      if (column.property == 'departId' || column.property == 'medicalField') {
        return row[column.property] ? row[column.property] : '全部';
      }

      switch (column.property) {
        case 'typeId':
          return row.typeId == '1' ? '自定义' : '标准';
      }
      return row;
    },
    indexMethod: function indexMethod(index) {
      return this.$refs['crud'].indexMethod(index);
    },
    handleSearch: function handleSearch() {
      this.$refs['crud'].handleSearch(1);
    },
    handleAddNewClick: function handleAddNewClick() {
      if (this.$refs.speakerMeetingType) {
        this.$refs.speakerMeetingType.clearFile();
      }
      this.$refs['crud'].handleAddNew();
      this.isEdit = false;
    },
    handleEditClick: function handleEditClick(item) {
      if (this.$refs.speakerMeetingType) {
        this.$refs.speakerMeetingType.clearFile();
      }
      this.$refs['crud'].handleEdit(item);
      this.isEdit = true;
    },
    beforeSave: function beforeSave(saveData) {
      saveData.departName = this.basedataGetName('Depart', saveData.departId);
      saveData.medicalFieldName = this.basedataGetName('MedicalField', saveData.medicalField);
      saveData.file = this.$refs.speakerMeetingType.getFile() ? this.$refs.speakerMeetingType.getFile().raw : null;
    },
    validUpload: function validUpload() {
      return this.$refs.speakerMeetingType.valid();
    },
    handleDeleteClick: function handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleBatchDeleteClick: function handleBatchDeleteClick() {
      this.$refs['crud'].handleBatchDelete();
    },
    handlerExportExcelClick: function handlerExportExcelClick() {
      this.$refs['crud'].handlerExportExcel('讲者级别管理.xlsx');
    },
    handleSpeakerLevelChange: function handleSpeakerLevelChange() {
      this.reloadBaseDataByType('SpeakerLevel');
    },
    getScoreExportParams: function getScoreExportParams() {
      var params = _.clone(this.addNewOrEditData);
      params.flag = this.isEdit ? 2 : 1;
      params.departName = this.basedataGetName('Depart', params.departId);
      params.medicalFieldName = this.basedataGetName('MedicalField', params.medicalField);
      params.speakerLevelName = params.speakerLevel;
      if (params.id) {
        params.speakerLevelId = params.id;
      }

      return params;
    },
    getCustomizationArray: function getCustomizationArray(arr) {
      if (arr.length > 0) {
        var customizationArray = arr.map(function (ele) {
          var data = {
            id: ele,
            teamName: ele
          };
          return data;
        });
        return customizationArray;
      } else return [];
    }
  }),
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4__api_bizmanagement_index__["a" /* default */].queryBusDataOrg().then(function (res) {
      _this.isConfigurationData = res.isConfigurationData;
      _this.departsList = _this.getCustomizationArray(res.departList);
      _this.medicalFieldList = _this.getCustomizationArray(res.medicalFieldList);
      _this.teamList = _this.getCustomizationArray(res.teamList);
      _this.initBaseDataByTypes(['Depart', 'MedicalField', 'SpeakerLevel']).then(function () {
        _this.handleSearch();
      });
    });
  }
});

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_bizmanagement_strategy__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_CommonScore_vue__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_CommonScore_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_CommonScore_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_organizationUtil__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_bizmanagement_index__ = __webpack_require__(173);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { CommonScore: __WEBPACK_IMPORTED_MODULE_3__common_CommonScore_vue___default.a },
  data: function data() {
    return {
      isConfigurationData: true,
      departsList: [],
      medicalFieldList: [],
      teamList: [],
      strategyData: [],
      searchData: {
        keynote: '',
        departId: '',
        medicalField: '',
        teamL4: '',
        productId: ''
      },
      addNewOrEditData: {
        keynote: '',
        departId: '',
        medicalField: '',
        teamL4: '',
        productId: ''
      },
      crudApi: __WEBPACK_IMPORTED_MODULE_1__api_bizmanagement_strategy__["a" /* default */],
      selectedData: [],
      isEdit: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['baseDataRecords', 'basedataGetName', 'basedataGetNameByRowIdField', 'userInfo']), {
    canDownload: function canDownload() {
      return this.addNewOrEditData.departId && this.addNewOrEditData.medicalField && this.addNewOrEditData.teamL4 && this.addNewOrEditData.productId && this.addNewOrEditData.keynote;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['reloadBaseDataByType', 'initBaseDataByTypes']), {
    getMedicalFieldArray: function getMedicalFieldArray(departId, independ) {
      return __WEBPACK_IMPORTED_MODULE_4__util_organizationUtil__["a" /* franchiseArray */](departId, independ);
    },
    getTeamArray: function getTeamArray(departId, medicalField, independ) {
      return __WEBPACK_IMPORTED_MODULE_4__util_organizationUtil__["c" /* teamArray */](departId, medicalField, independ);
    },
    formatDateTime2Date: function formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    formatBaseData: function formatBaseData(row, column, cellValue, index) {
      return this.basedataGetNameByRowIdField(column.property, row);
    },
    indexMethod: function indexMethod(index) {
      return this.$refs['crud'].indexMethod(index);
    },
    handleSearch: function handleSearch() {
      this.$refs['crud'].handleSearch(1);
    },
    handleAddNewClick: function handleAddNewClick() {
      if (this.$refs.strategyHospital4Strategy) {
        this.$refs.strategyHospital4Strategy.clearFile();
      }
      if (this.$refs.strategyOffice) {
        this.$refs.strategyOffice.clearFile();
      }
      this.$refs['crud'].handleAddNew();
      this.isEdit = false;
    },
    handleEditClick: function handleEditClick(item) {
      if (this.$refs.strategyHospital4Strategy) {
        this.$refs.strategyHospital4Strategy.clearFile();
      }
      if (this.$refs.strategyOffice) {
        this.$refs.strategyOffice.clearFile();
      }
      this.$refs['crud'].handleEdit(item);
      this.isEdit = true;
    },
    beforeSave: function beforeSave(saveData) {
      saveData.departName = this.basedataGetName('Depart', saveData.departId);
      saveData.medicalFieldName = this.basedataGetName('MedicalField', saveData.medicalField);
      saveData.productName = this.basedataGetName('Product', saveData.productId);
      saveData.file = this.$refs.strategyHospital4Strategy.getFile() ? this.$refs.strategyHospital4Strategy.getFile().raw : null;
      saveData.file2 = this.$refs.strategyOffice.getFile() ? this.$refs.strategyOffice.getFile().raw : null;
    },
    validUpload: function validUpload() {
      var file1Valid = this.$refs.strategyHospital4Strategy.valid();
      var file2Valid = this.$refs.strategyOffice.valid();

      return file1Valid && file2Valid;
    },
    handleDeleteClick: function handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleBatchDeleteClick: function handleBatchDeleteClick() {
      this.$refs['crud'].handleBatchDelete();
    },
    handlerExportExcelClick: function handlerExportExcelClick() {
      this.$refs['crud'].handlerExportExcel('策略管理.xlsx');
    },
    handleUpdateSuccess: function handleUpdateSuccess() {
      this.handleSearch();
    },
    handleStrategyChange: function handleStrategyChange() {
      this.reloadBaseDataByType('Strategy');
    },
    getScoreExportParams: function getScoreExportParams() {
      var params = _.clone(this.addNewOrEditData);
      params.keynoteId = params.id;
      params.keynoteName = params.keynote;
      params.flag = this.isEdit ? 2 : 1;
      params.departName = this.basedataGetName('Depart', params.departId);
      params.medicalFieldName = this.basedataGetName('MedicalField', params.medicalField);
      params.productName = this.basedataGetName('Product', params.productId);

      return params;
    },
    getCustomizationArray: function getCustomizationArray(arr) {
      if (arr.length > 0) {
        var customizationArray = arr.map(function (ele) {
          var data = {
            id: ele,
            teamName: ele
          };
          return data;
        });
        return customizationArray;
      } else return [];
    }
  }),
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_5__api_bizmanagement_index__["a" /* default */].queryBusDataOrg().then(function (res) {
      _this.isConfigurationData = res.isConfigurationData;
      _this.departsList = _this.getCustomizationArray(res.departList);
      _this.medicalFieldList = _this.getCustomizationArray(res.medicalFieldList);
      _this.teamList = _this.getCustomizationArray(res.teamList);
      _this.initBaseDataByTypes(['Depart', 'MedicalField', 'Product']).then(function () {
        _this.handleSearch();
      });
    });
    this.$refs['crud'].handleTips();
  }
});

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_dashboard_index__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_organizationUtil__ = __webpack_require__(52);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      medicalFieldArr: [''],
      teamFieldArr: [''],
      productIdArr: [''],
      costCenterArr: [''],
      wbsCodeArr: [''],
      searchMainData: {
        year: '',
        meetingSystem: '',
        departId: '',
        medicalFieldList: '',
        teamFieldList: '',
        productIdList: '',
        costCenterList: '',
        wbsCodeList: ''
      },
      data1Remain: 100,
      data2Remain: 100,
      //1、年度预算分配
      data1: [],
      option1: {
        tooltip: { show: false },
        color: ['#2D82F0'],
        series: [{
          type: 'gauge',
          splitNumber: 5,
          progress: {
            show: true,
            width: 18
          },
          axisLine: {
            lineStyle: {
              width: 18
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            length: 8,
            distance: 0,
            lineStyle: {
              width: 2,
              color: '#999'
            }
          },
          axisLabel: {
            show: false
          },
          anchor: {
            show: true,
            showAbove: true,
            size: 14,
            itemStyle: {
              borderWidth: 0,
              color: '#2D82F0'
            }
          },
          title: {
            show: false
          },
          detail: {
            valueAnimation: true,
            fontSize: 16,
            color: '#333333',
            offsetCenter: [0, '45%'],
            formatter: function formatter(value) {
              return value + '%';
            }
          }
        }]
      },
      //2、年度预算分配
      data2: [],
      option2: {
        tooltip: { show: false },
        color: ['#0B41CD'],
        series: [{
          type: 'gauge',
          splitNumber: 5,
          progress: {
            show: true,
            width: 18
          },
          axisLine: {
            lineStyle: {
              width: 18
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            length: 8,
            distance: 0,
            lineStyle: {
              width: 2,
              color: '#999'
            }
          },
          axisLabel: {
            show: false
          },
          anchor: {
            show: true,
            showAbove: true,
            size: 14,
            itemStyle: {
              borderWidth: 0,
              color: '#0B41CD'
            }
          },
          title: {
            show: false
          },
          detail: {
            valueAnimation: true,
            fontSize: 16,
            color: '#333333',
            offsetCenter: [0, '45%'],
            formatter: function formatter(value) {
              return value + '%';
            }
          }
        }]
      },
      //3、预算计划与执行进度
      data3: [],
      option3: {
        color: ['rgba(11, 65, 205, 0.8)', 'rgba(11, 65, 205, 0.65)', 'rgba(11, 65, 205, 0.5)', 'rgba(11, 65, 205, 0.35)'],
        legend: {
          data: ['已计划预算', '已执行金额', '待执行预算', '计划外预算'],
          icon: 'rect',
          left: -5,
          itemWidth: 8,
          itemHeight: 8
        },
        tooltip: {
          trigger: 'item',
          formatter: this.progressFormater
        },
        xAxis: { axisLabel: { show: false } },
        yAxis: { type: 'category', axisLabel: { show: false } },
        series: [{ type: 'bar', label: { show: true, position: 'top', formatter: this.formatValue }, name: '已计划预算' }, { type: 'bar', label: { rotate: -10, distance: 15, show: true, position: 'bottom', formatter: this.formatValue }, stack: 'detail' }, { type: 'bar', label: { rotate: -10, distance: 15, show: true, position: 'bottom', formatter: this.formatValue }, stack: 'detail' }, { type: 'bar', label: { rotate: -10, distance: 15, show: true, position: 'bottom', formatter: this.formatValue }, stack: 'detail' }]
      },
      //4、预算计划与执行季度趋势
      data4: [],
      option4: {
        grid: {
          width: 475
        },
        color: ['rgba(11, 65, 205, 0.8)', 'rgba(11, 65, 205, 0.65)', 'rgba(11, 65, 205, 0.5)', 'rgba(11, 65, 205, 0.35)', 'rgba(45, 130, 240, 1)'],
        legend: {
          data: [{ name: '已计划', icon: 'rect' }, { name: '已执行', icon: 'rect' }, { name: '待执行', icon: 'rect' }, { name: '计划外', icon: 'rect' }, { name: '已分配预算', lineStyle: { width: 4 }, itemStyle: { opacity: 0 } }],
          left: 0,
          itemWidth: 8,
          itemHeight: 8
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          textStyle: {
            color: 'rgba(255, 255, 255, 1)'
          },
          padding: 0,
          formatter: this.quarterTrendFormater
        },
        xAxis: {
          type: 'category'
        },
        yAxis: {
          axisLabel: {
            formatter: this.formatLabelValue
          }
        },
        series: [{ type: 'bar', label: { show: false, formatter: this.formatChartValue } }, { type: 'bar', label: { show: false, formatter: this.formatChartValue }, stack: 'detail' }, { type: 'bar', label: { show: false, formatter: this.formatChartValue }, stack: 'detail' }, { type: 'bar', label: { show: false, formatter: this.formatChartValue }, stack: 'detail' }, { type: 'line', symbolSize: 0, label: { show: false, formatter: this.formatChartValue, position: 'top', color: '#000' } }]
      },
      //5、预算计划与执行月度趋势
      data5: [],
      option5: {
        grid: {
          width: 475
        },
        color: ['rgba(11, 65, 205, 0.65)', 'rgba(11, 65, 205, 0.5)', 'rgba(11, 65, 205, 0.35)', 'rgba(11, 65, 205, 0.8)'],
        legend: {
          data: [{ name: '已执行', icon: 'rect' }, { name: '待执行', icon: 'rect' }, { name: '计划外', icon: 'rect' }, { name: '已计划', lineStyle: { width: 4 }, itemStyle: { opacity: 0 } }],
          left: 0,
          itemWidth: 8,
          itemHeight: 8
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          textStyle: {
            color: 'rgba(255, 255, 255, 1)'
          },
          padding: 0,
          formatter: this.monthTrendFormater
        },
        xAxis: { type: 'category' },
        yAxis: {
          axisLabel: {
            formatter: this.formatLabelValue
          }
        },
        series: [{ type: 'bar', label: { show: false, formatter: this.formatChartValue }, stack: 'detail', name: '已执行', encode: { y: '已执行', x: '月度' } }, { type: 'bar', label: { show: false, formatter: this.formatChartValue }, stack: 'detail', name: '待执行', encode: { y: '待执行', x: '月度' } }, { type: 'bar', label: { show: false, formatter: this.formatChartValue }, stack: 'detail', name: '计划外', encode: { y: '计划外', x: '月度' } }, { type: 'line', symbolSize: 0, label: { show: false, formatter: this.formatChartValue, position: 'top', color: '#000' }, name: '已计划', encode: { y: '已计划', x: '月度' } }]
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['userInfo', 'baseDataRecords', 'basedataGetName', 'basedataGetNameByRowIdField']), {
    onlyBudgetPlan: function onlyBudgetPlan() {
      return this.searchMainData.meetingSystem || this.searchMainData.productIdList || this.searchMainData.costCenterList || this.searchMainData.wbsCodeList;
    }
  }),
  watch: {
    'medicalFieldArr': function medicalFieldArr(newVal, oldVal) {
      this.do(newVal, oldVal, 'medicalFieldArr');
    },
    'teamFieldArr': function teamFieldArr(newVal, oldVal) {
      this.do(newVal, oldVal, 'teamFieldArr');
    },
    'productIdArr': function productIdArr(newVal, oldVal) {
      this.do(newVal, oldVal, 'productIdArr');
    },
    'costCenterArr': function costCenterArr(newVal, oldVal) {
      this.do(newVal, oldVal, 'costCenterArr');
    },
    'wbsCodeArr': function wbsCodeArr(newVal, oldVal) {
      this.do(newVal, oldVal, 'wbsCodeArr');
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['initBaseDataByTypes']), {
    getMedicalFieldArray: function getMedicalFieldArray(departId, independ) {
      return __WEBPACK_IMPORTED_MODULE_4__util_organizationUtil__["a" /* franchiseArray */](departId, independ);
    },
    getTeamArray: function getTeamArray(departId, medicalFieldArray, independ) {
      return __WEBPACK_IMPORTED_MODULE_4__util_organizationUtil__["b" /* teamArrayByArray */](departId, medicalFieldArray, independ);
    },
    do: function _do(newVal, oldVal, field) {
      if (oldVal.indexOf('') >= 0 && newVal.indexOf('') >= 0 && newVal.length > 1) {
        this[field].splice(this[field].indexOf(''), 1);
      } else if (oldVal.indexOf('') < 0 && newVal.indexOf('') >= 0 || newVal.length == 0) {
        this[field] = [''];
      }
    },
    progressFormater: function progressFormater(params) {
      var str = '';
      str += params.seriesName + '<br/>';
      str += params.marker + params.name + ' : 　<span style="font-weight:bold">' + this.$formatMoney(this.$toThousand(params.value[params.seriesName], 1, 2)) + ' K</span>';
      return str;
    },
    quarterTrendFormater: function quarterTrendFormater(params) {
      console.log(params);
      if (params.length > 0) {
        var quarter = params[0].axisValue;
        var str = '<div style="padding: 10px 10px 0 10px">\u7B2C' + quarter + '</div>';
        str += '<div style="display:flex;padding:5px 0;border-bottom:1px solid rgba(255, 255, 255, 0.15)"><span style="margin-left:10px;display:inline-block;margin-right:4px;margin-top:8px;width:6px;height:6px;background-color:rgba(255, 255, 255, 1);"></span><span style="margin-right:15px">\u5DF2\u5206\u914D\uFF1A' + this.$formatMoney(this.$toThousand(params[0].value['已分配预算'], 1, 2)) + ' K</span></div>';
        str += '<div style="display:flex;padding:5px 0;border-bottom:1px solid rgba(255, 255, 255, 0.15)"><span style="margin-left:10px;display:inline-block;margin-right:4px;margin-top:8px;width:6px;height:6px;background-color:rgba(255, 255, 255, 1);"></span><span style="margin-right:15px">\u5DF2\u8BA1\u5212\uFF1A' + this.$formatMoney(this.$toThousand(params[0].value['已计划'], 1, 2)) + ' K</span></div>';
        str += '<div style="display:flex;padding:5px 0;"><span style="margin-left:10px;display:inline-block;margin-right:4px;margin-top:8px;width:6px;height:6px;background-color:rgba(255, 255, 255, 1);"></span><span style="margin-right:15px">\u5DF2\u6267\u884C\uFF1A' + this.$formatMoney(this.$toThousand(params[0].value['已执行'], 1, 2)) + ' K</span></div>';
        str += '<div style="display:flex;padding:5px 0;border-bottom:1px solid rgba(255, 255, 255, 0.15)"><span style="margin-left:10px;display:inline-block;margin-right:4px;margin-top:8px;width:6px;height:6px;background-color:rgba(255, 255, 255, 1);"></span><span style="margin-right:15px">\u5F85\u6267\u884C\uFF1A' + this.$formatMoney(this.$toThousand(params[0].value['待执行'], 1, 2)) + ' K</span></div>';
        str += '<div style="display:flex;padding:5px 0;"><span style="margin-left:10px;display:inline-block;margin-right:4px;margin-top:8px;width:6px;height:6px;background-color:rgba(255, 255, 255, 1);"></span><span style="margin-right:15px">\u8BA1\u5212\u5916\uFF1A' + this.$formatMoney(this.$toThousand(params[0].value['计划外'], 1, 2)) + ' K</span></div>';

        return str;
      }
    },
    monthTrendFormater: function monthTrendFormater(params) {
      console.log(params);
      if (params.length > 0) {
        var quarter = params[0].axisValue;
        var str = '<div style="padding: 10px 10px 0 10px">\u7B2C' + quarter + '</div>';
        str += '<div style="display:flex;padding:5px 0;border-bottom:1px solid rgba(255, 255, 255, 0.15)"><span style="margin-left:10px;display:inline-block;margin-right:4px;margin-top:8px;width:6px;height:6px;background-color:rgba(255, 255, 255, 1);"></span><span style="margin-right:15px">\u5DF2\u8BA1\u5212\uFF1A' + this.$formatMoney(this.$toThousand(params[0].value['已计划'], 1, 2)) + ' K</span></div>';
        str += '<div style="display:flex;padding:5px 0;"><span style="margin-left:10px;display:inline-block;margin-right:4px;margin-top:8px;width:6px;height:6px;background-color:rgba(255, 255, 255, 1);"></span><span style="margin-right:15px">\u5DF2\u6267\u884C\uFF1A' + this.$formatMoney(this.$toThousand(params[0].value['已执行'], 1, 2)) + ' K</span></div>';
        str += '<div style="display:flex;padding:5px 0;border-bottom:1px solid rgba(255, 255, 255, 0.15)"><span style="margin-left:10px;display:inline-block;margin-right:4px;margin-top:8px;width:6px;height:6px;background-color:rgba(255, 255, 255, 1);"></span><span style="margin-right:15px">\u5F85\u6267\u884C\uFF1A' + this.$formatMoney(this.$toThousand(params[0].value['待执行'], 1, 2)) + ' K</span></div>';
        str += '<div style="display:flex;padding:5px 0;"><span style="margin-left:10px;display:inline-block;margin-right:4px;margin-top:8px;width:6px;height:6px;background-color:rgba(255, 255, 255, 1);"></span><span style="margin-right:15px">\u8BA1\u5212\u5916\uFF1A' + this.$formatMoney(this.$toThousand(params[0].value['计划外'], 1, 2)) + ' K</span></div>';

        return str;
      }
    },
    trimSpace: function trimSpace(array) {
      for (var i = 0; i < array.length; i++) {
        //这里为过滤的值
        if (array.length > 1 && (array[i] == '' || array[i] == null || typeof array[i] == "undefined" || array[i] == ' ')) {
          array.splice(i, 1);
          i = i - 1;
        }
      }
      return array;
    },
    handleArrar4All: function handleArrar4All(arrName) {
      if (this[arrName].length > 0 && this[arrName][this[arrName].length - 1] == '') {
        this[arrName] = [''];
      }
    },
    handleMainSearch: function handleMainSearch() {
      var _this = this;

      this.handleArrar4All('medicalFieldArr');
      this.handleArrar4All('teamFieldArr');
      this.handleArrar4All('productIdArr');
      this.handleArrar4All('costCenterArr');
      this.handleArrar4All('wbsCodeArr');

      this.searchMainData.medicalFieldList = this.trimSpace(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.medicalFieldArr))).toString();
      this.searchMainData.teamFieldList = this.trimSpace(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.teamFieldArr))).toString();
      this.searchMainData.productIdList = this.trimSpace(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.productIdArr))).toString();
      this.searchMainData.costCenterList = this.trimSpace(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.costCenterArr))).toString();
      this.searchMainData.wbsCodeList = this.trimSpace(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.wbsCodeArr))).toString();
      __WEBPACK_IMPORTED_MODULE_2__api_dashboard_index__["a" /* default */].budget(this.searchMainData).then(function (res) {
        res.YearBudgetDist['已分配预算'] = res.YearBudgetDist['已分配预算'].replace('%', '');
        res.YearBudgetPlan['已分配预算'] = res.YearBudgetPlan['已分配预算'].replace('%', '');
        _this.data1Remain = 100 - parseFloat(res.YearBudgetDist['已分配预算']);
        _this.data2Remain = 100 - parseFloat(res.YearBudgetPlan['已分配预算']);
        _this.data1 = [res.YearBudgetDist];
        _this.data2 = [res.YearBudgetPlan];
        res.BudgetPlanProgress['已执行金额'] = res.BudgetPlanProgress['已执行预算'];
        delete res.BudgetPlanProgress['已执行预算'];
        _this.data3 = [res.BudgetPlanProgress];
        _this.data4 = res.BudgetPlanSeasonTrend;
        _this.data5 = res.BudgetPlanMonthTrend;
        _this.option2.series[0].detail.color = parseFloat(res.YearBudgetPlan['已分配预算']) > 100 ? '#f00' : '#333333';
        _this.$nextTick(function () {
          _this.$refs['chart1'].chartChange();
          _this.$refs['chart2'].chartChange();
          _this.$refs['chart3'].chartChange();
          _this.$refs['chart4'].chartChange();
          _this.$refs['chart5'].chartChange();
        });
      });
    },
    formatValue: function formatValue(params) {
      return params.seriesName + '：' + this.$formatMoney(this.$toThousand(params.value[params.seriesName], 1, 0)) + 'K';
    },
    formatLabelValue: function formatLabelValue(value) {
      return this.$toThousand(value, 1, 0) + ' K';
    },
    formatChartValue: function formatChartValue(params) {
      return this.$toThousand(params.value[params.seriesName], 1, 0);
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.searchMainData.year = new Date().getFullYear();

    this.initBaseDataByTypes(['Depart', 'MedicalField', 'Product', 'Year', 'MeetingSystem', 'CostCenter', 'WbsCode']).then(function () {
      _this2.handleMainSearch();
    });
  }
});

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_dashboard_index__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_tableau_Tableau_vue__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_tableau_Tableau_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_tableau_Tableau_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_global__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__error_ErrorSection_vue__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__error_ErrorSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__error_ErrorSection_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Tableau: __WEBPACK_IMPORTED_MODULE_4__common_tableau_Tableau_vue___default.a, ErrorSection: __WEBPACK_IMPORTED_MODULE_7__error_ErrorSection_vue___default.a },
  data: function data() {
    return {
      ticket: '',
      enterTime: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD HH:mm:ss')
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['userInfo']), {

    getZoom: __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* getZoom */],
    url: function url() {
      return __WEBPACK_IMPORTED_MODULE_6__global_global__["a" /* default */].DASHBOARD_URL + '/trusted/' + this.ticket + '/' + __WEBPACK_IMPORTED_MODULE_6__global_global__["a" /* default */].DASHBOARD_BUDGET_URL + '?adAccount=' + this.userInfo.username;
    }
  }),
  methods: {
    resizeTableau: function resizeTableau() {
      // this.tableauWidth = document.getElementsByClassName('tableau')[0].clientWidth;
    }
  },
  mounted: function mounted() {
    var _this = this;

    var width = window.screen.width / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* getZoom */])();
    var height = window.screen.height / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* getZoom */])();
    this.width = width;
    this.height = height;
    __WEBPACK_IMPORTED_MODULE_1__api_dashboard_index__["a" /* default */].getTableauTicket().then(function (result) {
      _this.ticket = result;
      _this.$refs.budgetTableau.initViz();
    });
    window.addEventListener("resize", this.resizeTableau);
    this.$nextTick(function () {
      _this.resizeTableau();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.resizeTableau);
    __WEBPACK_IMPORTED_MODULE_1__api_dashboard_index__["a" /* default */].saveStayTime({
      enterTime: this.enterTime,
      leaveTime: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format("YYYY-MM-DD HH:mm:ss"),
      description: "仪表盘-预算"
    }).then(function () {});
  }
});

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_dashboard_index__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_meetingplan_application__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_organizationUtil__ = __webpack_require__(52);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    return {
      medicalFieldArr: [''],
      teamFieldArr: [''],
      productIdArr: [''],
      strategyKeynoteArr: [''],
      searchMainData: {
        year: '',
        season: 1,
        meetingSystem: '',
        departId: '',
        medicalFieldList: '',
        teamFieldList: '',
        productIdList: '',
        strategyKeynoteList: '',
        meetingModality: '',
        meetingType: '',
        meetingProp: '',
        meetingGsdType: '',
        meetingGsdSubType: ''
      },
      meetingPropAndTypeArrays: {
        selectMeetingProp: [], //可选的会议性质
        popMeetingType: [], //推广的会议类型绑定
        nopopMeetingType: [], //非推广的会议类型绑定
        meetingPropType: [] //推广+非推广的会议类型绑定
      },
      //评分
      data1: [],
      option1: {
        grid: {
          left: 40,
          right: 100,
          top: 30
        },
        tooltip: {
          trigger: 'item',
          enterable: true,
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          textStyle: {
            color: 'rgba(255, 255, 255, 1)'
          },
          formatter: function formatter(params) {
            var budgetScore = params.value['预算合评分'];

            var info = '';
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this.data1), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var data = _step.value;

                if (data['预算合评分'] == budgetScore) {
                  info += info ? '<br/>' : '';
                  info += '<div style="display:flex">\u8BC4\u5206\uFF1A\u3000\u3000\u3000<div style="width: 120px;white-space: normal;">' + data['评分'] + '</div></div>';
                  info += '<div style="display:flex">\u9884\u7B97\uFF1A\u3000\u3000\u3000<div style="width: 120px;white-space: normal;">' + data['预算'] + 'K</div></div>';
                  info += '<div style="display:flex">\u4F1A\u8BAE\u540D\u79F0\uFF1A\u3000<div style="width: 120px;white-space: normal;">' + data['会议名称'] + '</div></div>';
                  info += '<div style="display:flex">\u6D3B\u52A8\u8D1F\u8D23\u4EBA\uFF1A<div style="width: 120px;white-space: normal;">' + data['活动负责人'] + '</div></div>';
                  info += '<div style="display:flex">\u7B56\u7565\u91CD\u70B9\uFF1A\u3000<div style="width: 120px;white-space: normal;">' + data['策略重点'] + '</div></div>';
                  info += '<div style="display:flex">\u4F1A\u8BAE\u5F62\u5F0F\uFF1A\u3000<div style="width: 120px;white-space: normal;">' + data['会议形式'] + '</div></div>';
                  info += '<div style="display:flex">\u4F1A\u8BAE\u7C7B\u578B\uFF1A\u3000<div style="width: 120px;white-space: normal;">' + data['会议类型'] + '</div></div>';
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            info = '<div style="max-height: 220px;overflow-y: auto;padding-right: 5px;">' + info + '</div>';

            return info;
          }
        },
        xAxis: {
          min: 0
        },
        yAxis: {
          axisTick: {
            show: false
          }
        },
        series: [{ type: 'scatter', symbolSize: 16 }]
      }
    };
  },

  watch: {
    'medicalFieldArr': function medicalFieldArr(newVal, oldVal) {
      this.do(newVal, oldVal, 'medicalFieldArr');
    },
    'teamFieldArr': function teamFieldArr(newVal, oldVal) {
      this.do(newVal, oldVal, 'teamFieldArr');
    },
    'productIdArr': function productIdArr(newVal, oldVal) {
      this.do(newVal, oldVal, 'productIdArr');
    },
    'strategyKeynoteArr': function strategyKeynoteArr(newVal, oldVal) {
      this.do(newVal, oldVal, 'strategyKeynoteArr');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(['userInfo', 'baseDataRecords']), {
    MeetingGsdSubTypes: function MeetingGsdSubTypes() {
      return this.baseDataRecords['MeetingGsdTypeSub' + this.searchMainData.meetingGsdType] || [];
    },
    filterMeetingType: function filterMeetingType() {
      if (!this.searchMainData.meetingProp) {
        var tempAll = [];
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.meetingPropAndTypeArrays) !== '{}') {
          this.meetingPropAndTypeArrays.popMeetingType.forEach(function (m) {
            if (!tempAll.some(function (t) {
              return t.itemValue == m.itemValue;
            })) {
              tempAll.push(m);
            }
          });
          this.meetingPropAndTypeArrays.nopopMeetingType.forEach(function (m) {
            if (!tempAll.some(function (t) {
              return t.itemValue == m.itemValue;
            })) {
              tempAll.push(m);
            }
          });
          this.meetingPropAndTypeArrays.meetingPropType.forEach(function (m) {
            if (!tempAll.some(function (t) {
              return t.itemValue == m.itemValue;
            })) {
              tempAll.push(m);
            }
          });
        }
        return tempAll;
      }
      switch (this.basedataGetName('MeetingProp', this.searchMainData.meetingProp)) {
        case '推广':
          return this.meetingPropAndTypeArrays.popMeetingType;
        case '非推广':
          return this.meetingPropAndTypeArrays.nopopMeetingType;
        default:
          return this.meetingPropAndTypeArrays.meetingPropType;
      }
    },
    filterStrategy: function filterStrategy() {
      var _this2 = this;

      var temp = [];
      var productIds = this.searchMainData.productId;
      this.baseDataRecords.Strategy.forEach(function (strategy) {
        if (_this2.searchMainData.departId && _this2.searchMainData.departId != strategy.departId) {
          return;
        }
        if (_this2.searchMainData.medicalField && _this2.searchMainData.medicalField != strategy.medicalField) {
          return;
        }
        if (productIds && productIds.indexOf(strategy.productId) < 0) {
          return;
        }

        temp.push(strategy);
      });

      return temp;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapActions */])(['initBaseDataByTypes']), {
    getMedicalFieldArray: function getMedicalFieldArray(departId, independ) {
      return __WEBPACK_IMPORTED_MODULE_6__util_organizationUtil__["a" /* franchiseArray */](departId, independ);
    },
    getTeamArray: function getTeamArray(departId, medicalFieldArray, independ) {
      return __WEBPACK_IMPORTED_MODULE_6__util_organizationUtil__["b" /* teamArrayByArray */](departId, medicalFieldArray, independ);
    },
    do: function _do(newVal, oldVal, field) {
      if (oldVal.indexOf('') >= 0 && newVal.indexOf('') >= 0 && newVal.length > 1) {
        this[field].splice(this[field].indexOf(''), 1);
      } else if (oldVal.indexOf('') < 0 && newVal.indexOf('') >= 0 || newVal.length == 0) {
        this[field] = [''];
      }
    },
    trimSpace: function trimSpace(array) {
      for (var i = 0; i < array.length; i++) {
        //这里为过滤的值
        if (array[i] == '' || array[i] == null || typeof array[i] == "undefined" || array[i] == ' ') {
          array.splice(i, 1);
          i = i - 1;
        }
      }
      return array;
    },
    handleArrar4All: function handleArrar4All(arrName) {
      if (this[arrName].length > 0 && this[arrName][this[arrName].length - 1] == '') {
        this[arrName] = [''];
      }
    },
    handleMainSearch: function handleMainSearch() {
      var _this3 = this;

      this.handleArrar4All('medicalFieldArr');
      this.handleArrar4All('teamFieldArr');
      this.handleArrar4All('productIdArr');
      this.handleArrar4All('strategyKeynoteArr');

      this.searchMainData.medicalFieldList = this.trimSpace(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.medicalFieldArr))).toString();
      this.searchMainData.teamFieldList = this.trimSpace(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.teamFieldArr))).toString();
      this.searchMainData.productIdList = this.trimSpace(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.productIdArr))).toString();
      this.searchMainData.strategyKeynoteList = this.trimSpace(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.strategyKeynoteArr))).toString();
      __WEBPACK_IMPORTED_MODULE_3__api_dashboard_index__["a" /* default */].effectiveness(this.searchMainData).then(function (res) {
        _this3.data1 = [];
        res.forEach(function (el) {
          el['预算'] = parseFloat((el['预算'] / 1000).toFixed(2));
          _this3.data1.push(el);
        });

        _this3.$nextTick(function () {
          _this3.$refs['chart1'].chartChange();
        });
      });
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    this.searchMainData.year = new Date().getFullYear();

    this.initBaseDataByTypes(['Depart', 'MedicalField', 'Product', 'Year', 'MeetingSystem', 'Strategy', 'MeetingModality', 'MeetingType', 'MeetingProp']).then(function () {
      __WEBPACK_IMPORTED_MODULE_4__api_meetingplan_application__["a" /* default */].queryMeetingPropAndTypeSelect().then(function (res) {
        _this4.meetingPropAndTypeArrays = res;
        _this4.handleMainSearch();
      });
    });
  }
});

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_dashboard_index__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_tableau_Tableau_vue__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_tableau_Tableau_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_tableau_Tableau_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_global__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__error_ErrorSection_vue__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__error_ErrorSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__error_ErrorSection_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Tableau: __WEBPACK_IMPORTED_MODULE_4__common_tableau_Tableau_vue___default.a, ErrorSection: __WEBPACK_IMPORTED_MODULE_7__error_ErrorSection_vue___default.a },
  data: function data() {
    return {
      ticket: "",
      tableauWidth: "100%",
      enterTime: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format("YYYY-MM-DD HH:mm:ss")
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["userInfo"]), {
    getZoom: __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* getZoom */],
    url: function url() {
      return __WEBPACK_IMPORTED_MODULE_6__global_global__["a" /* default */].DASHBOARD_URL + '/trusted/' + this.ticket + '/' + __WEBPACK_IMPORTED_MODULE_6__global_global__["a" /* default */].DASHBOARD_SCORE_URL + '?adAccount=' + this.userInfo.username;
    }
  }),
  methods: {
    resizeTableau: function resizeTableau() {
      // this.tableauWidth = document.getElementsByClassName('tableau')[0].clientWidth - 10 + 'px';
    }
  },
  mounted: function mounted() {
    var _this = this;

    var width = window.screen.width / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* getZoom */])();
    var height = window.screen.height / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* getZoom */])();
    this.width = width;
    this.height = height;
    __WEBPACK_IMPORTED_MODULE_1__api_dashboard_index__["a" /* default */].getTableauTicket().then(function (result) {
      _this.ticket = result;
      _this.$nextTick(function () {
        _this.$refs.effectivenessTableau.initViz();
      });
    });
    window.addEventListener("resize", this.resizeTableau);
    this.$nextTick(function () {
      _this.resizeTableau();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.resizeTableau);
    __WEBPACK_IMPORTED_MODULE_1__api_dashboard_index__["a" /* default */].saveStayTime({
      enterTime: this.enterTime,
      leaveTime: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format("YYYY-MM-DD HH:mm:ss"),
      description: "仪表盘-评分"
    }).then(function () {});
  }
});

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_dashboard_index__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_organizationUtil__ = __webpack_require__(52);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      seasonArr: [''],
      monthArr: [''],
      medicalFieldArr: [''],
      teamFieldArr: [''],
      productIdArr: [''],
      strategyKeynoteArr: [''],
      searchMainData: {
        year: '',
        seasonList: '',
        monthList: '',
        meetingSystem: '',
        departId: '',
        medicalFieldList: '',
        teamFieldList: '',
        productIdList: '',
        strategyKeynoteList: '',
        meetingModality: '',
        meetingType: '',
        meetingGsdType: '',
        meetingGsdSubType: '',
        meetingProp: '',
        planRateType: '',
        distributeType: '',
        selectMeetingStatus: ''
      },
      meetingPropAndTypeArrays: {
        selectMeetingProp: [], //可选的会议性质
        popMeetingType: [], //推广的会议类型绑定
        nopopMeetingType: [], //非推广的会议类型绑定
        meetingPropType: [] //推广+非推广的会议类型绑定
      },
      //1、策略计划占比
      data1: [],
      option1: {
        color: ['rgba(45, 130, 240, 0.65)', 'rgba(23, 178, 251, 0.65)', 'rgba(14, 199, 113, 0.65)', 'rgba(255, 181, 42, 0.65)', 'rgba(255, 133, 33, 0.65)', 'rgba(251, 48, 77, 0.65)', 'rgba(149, 93, 243, 0.65)', 'rgba(100, 116, 147, 0.65)'],
        tooltip: {
          trigger: 'item',
          formatter: this.percentFormater
        },
        series: [{
          type: 'pie',
          label: {
            show: true,
            formatter: function formatter(params) {
              var html = '';
              html += params.name + '\n';
              html += params.percent + '%';
              return html;
            }
          }
        }]
      },
      data1Remain: 100,
      data2Remain: 100,
      //2、会议计划占比
      data2: [],
      option2: {
        color: ['rgba(45, 130, 240, 0.65)', 'rgba(23, 178, 251, 0.65)', 'rgba(14, 199, 113, 0.65)', 'rgba(255, 181, 42, 0.65)', 'rgba(255, 133, 33, 0.65)', 'rgba(251, 48, 77, 0.65)', 'rgba(149, 93, 243, 0.65)', 'rgba(100, 116, 147, 0.65)'],
        tooltip: {
          trigger: 'item',
          formatter: this.percentFormater
        },
        series: [{
          type: 'pie',
          label: {
            show: true,
            formatter: function formatter(params) {
              var html = '';
              html += params.name + '\n';
              html += params.percent + '%';
              return html;
            }
          }
        }]
      },
      //3、执行进度
      data3: [],
      option3: {
        grid: {
          left: 80,
          right: 25
        },
        color: [],
        legend: {
          data: [],
          icon: 'rect',
          left: 0,
          itemWidth: 8,
          itemHeight: 8
        },
        tooltip: {
          trigger: 'item',
          formatter: this.progressFormater
        },
        xAxis: {
          axisLabel: {
            formatter: this.formatLabelValue
          }
        },
        yAxis: {
          type: 'category',
          axisLabel: {
            interval: 0,
            overflow: 'truncate',
            ellipsis: '...',
            width: 60,
            fontSize: 10
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        series: []
      },
      //4、月度趋势
      data4: {
        "strategyNames": [],
        "data": []
      },
      option4: {
        color: ['rgba(45, 130, 240, 0.65)', 'rgba(23, 178, 251, 0.65)', 'rgba(14, 199, 113, 0.65)', 'rgba(255, 181, 42, 0.65)', 'rgba(255, 133, 33, 0.65)', 'rgba(251, 48, 77, 0.65)', 'rgba(149, 93, 243, 0.65)', 'rgba(100, 116, 147, 0.65)'],
        legend: {
          icon: 'rect',
          left: -4,
          padding: [5, 300, 5, 5],
          itemWidth: 8,
          itemHeight: 4
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          textStyle: {
            color: 'rgba(255, 255, 255, 1)'
          },
          formatter: this.trendFormater
        },
        xAxis: { type: 'category' },
        yAxis: {
          axisLabel: {
            formatter: this.formatLabelValue
          }
        },
        series: []
      }
    };
  },

  watch: {
    'medicalFieldArr': function medicalFieldArr(newVal, oldVal) {
      this.do(newVal, oldVal, 'medicalFieldArr');
    },
    'teamFieldArr': function teamFieldArr(newVal, oldVal) {
      this.do(newVal, oldVal, 'teamFieldArr');
    },
    'productIdArr': function productIdArr(newVal, oldVal) {
      this.do(newVal, oldVal, 'productIdArr');
    },
    'strategyKeynoteArr': function strategyKeynoteArr(newVal, oldVal) {
      this.do(newVal, oldVal, 'strategyKeynoteArr');
    },
    'seasonArr': function seasonArr(newVal, oldVal) {
      if (oldVal.indexOf('') >= 0 && newVal.indexOf('') >= 0 && newVal.length > 1) {
        this.seasonArr.splice(this.seasonArr.indexOf(''), 1);
      } else if (oldVal.indexOf('') < 0 && newVal.indexOf('') >= 0) {
        this.seasonArr = [''];
      }
    },
    'monthArr': function monthArr(newVal, oldVal) {
      if (oldVal.indexOf('') >= 0 && newVal.indexOf('') >= 0 && newVal.length > 1) {
        this.monthArr.splice(this.monthArr.indexOf(''), 1);
      } else if (oldVal.indexOf('') < 0 && newVal.indexOf('') >= 0) {
        this.monthArr = [''];
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['userInfo', 'baseDataRecords', 'basedataGetName', 'basedataGetNameByRowIdField']), {
    MeetingGsdSubTypes: function MeetingGsdSubTypes() {
      return this.baseDataRecords['MeetingGsdTypeSub' + this.searchMainData.meetingGsdType] || [];
    },
    filterMeetingType: function filterMeetingType() {
      if (!this.searchMainData.meetingProp) {
        var tempAll = [];
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.meetingPropAndTypeArrays) !== '{}') {
          this.meetingPropAndTypeArrays.popMeetingType.forEach(function (m) {
            if (!tempAll.some(function (t) {
              return t.itemValue == m.itemValue;
            })) {
              tempAll.push(m);
            }
          });
          this.meetingPropAndTypeArrays.nopopMeetingType.forEach(function (m) {
            if (!tempAll.some(function (t) {
              return t.itemValue == m.itemValue;
            })) {
              tempAll.push(m);
            }
          });
          this.meetingPropAndTypeArrays.meetingPropType.forEach(function (m) {
            if (!tempAll.some(function (t) {
              return t.itemValue == m.itemValue;
            })) {
              tempAll.push(m);
            }
          });
        }
        return tempAll;
      }
      switch (this.basedataGetName('MeetingProp', this.searchMainData.meetingProp)) {
        case '推广':
          return this.meetingPropAndTypeArrays.popMeetingType;
        case '非推广':
          return this.meetingPropAndTypeArrays.nopopMeetingType;
        default:
          return this.meetingPropAndTypeArrays.meetingPropType;
      }
    },
    dimensions4: function dimensions4() {
      this.option4.series = [];
      for (var index = 0; index < this.data4.strategyNames.length; index++) {
        this.option4.series.push({ type: 'line' });
      }
      var dimensions = _.clone(this.data4.strategyNames);
      dimensions.unshift('月度');
      return dimensions;
    },
    color3: function color3() {
      return this.searchMainData.planRateType != '1' ? ['rgba(11, 65, 205, 0.65)', 'rgba(11, 65, 205, 0.5)', 'rgba(11, 65, 205, 0.35)', 'rgba(11, 65, 205, 0.8)'] : ['rgba(11, 65, 205, 0.65)', 'rgba(11, 65, 205, 0.5)', 'rgba(11, 65, 205, 0.8)'];
    },
    legendData3: function legendData3() {
      return this.searchMainData.planRateType != '1' ? ['名称', '已计划', '已执行', '待执行', '计划外'] : ['名称', '已计划', '已执行', '待执行'];
    },
    series3: function series3() {
      return this.searchMainData.planRateType != '1' ? [{ type: 'bar', label: { show: true, position: 'insideRight', formatter: this.formatChartValue }, stack: 'detail', name: '已执行', encode: { x: '已执行', y: '名称' } }, { type: 'bar', label: { show: true, position: 'insideRight', formatter: this.formatChartValue }, stack: 'detail', name: '待执行', encode: { x: '待执行', y: '名称' } }, { type: 'bar', label: { show: true, position: 'insideRight', formatter: this.formatChartValue }, stack: 'detail', name: '计划外', encode: { x: '计划外', y: '名称' } }, { type: 'bar', label: { show: true, position: 'insideRight', formatter: this.formatChartValue }, name: '已计划', encode: { x: '已计划', y: '名称' } }] : [{ type: 'bar', label: { show: true, position: 'insideRight', formatter: this.formatChartValue }, stack: 'detail', name: '已执行', encode: { x: '已执行', y: '名称' } }, { type: 'bar', label: { show: true, position: 'insideRight', formatter: this.formatChartValue }, stack: 'detail', name: '待执行', encode: { x: '待执行', y: '名称' } }, { type: 'bar', label: { show: true, position: 'insideRight', formatter: this.formatChartValue }, name: '已计划', encode: { x: '已计划', y: '名称' } }];
    },
    dimensions3: function dimensions3() {
      return this.searchMainData.planRateType != '1' ? ['名称', '已执行', '待执行', '计划外', '已计划'] : ['名称', '已执行', '待执行', '已计划'];
    },
    source4: function source4() {
      return this.data4.data;
    },
    dimensions1: function dimensions1() {
      this.option1.series = [];
      for (var index = 0; index < this.data1.strategyNames.length; index++) {
        this.option1.series.push(this.data1.seriesTemplate);
      }
      var dimensions = _.clone(this.data1.strategyNames);
      dimensions.unshift('策略名');
      return dimensions;
    },
    source1: function source1() {
      return this.data1.data;
    },
    filterStrategy: function filterStrategy() {
      var _this = this;

      var temp = [];
      var productIds = this.productIdArr;
      this.baseDataRecords.Strategy.forEach(function (strategy) {
        if (_this.searchMainData.departId && _this.searchMainData.departId != strategy.departId) {
          return;
        }
        // if(this.searchMainData.medicalField && this.searchMainData.medicalField != strategy.medicalField){
        //     return;
        // }
        if (!productIds || productIds.length == 0 || productIds.indexOf('') == 0) {
          temp.push(strategy);
          return;
        }
        if (productIds && productIds.indexOf(strategy.productId) < 0) {
          return;
        }
        temp.push(strategy);
      });

      return temp;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['initBaseDataByTypes']), {
    getMedicalFieldArray: function getMedicalFieldArray(departId, independ) {
      return __WEBPACK_IMPORTED_MODULE_5__util_organizationUtil__["a" /* franchiseArray */](departId, independ);
    },
    getTeamArray: function getTeamArray(departId, medicalFieldArray, independ) {
      return __WEBPACK_IMPORTED_MODULE_5__util_organizationUtil__["b" /* teamArrayByArray */](departId, medicalFieldArray, independ);
    },
    do: function _do(newVal, oldVal, field) {
      if (oldVal.indexOf('') >= 0 && newVal.indexOf('') >= 0 && newVal.length > 1) {
        this[field].splice(this[field].indexOf(''), 1);
      } else if (oldVal.indexOf('') < 0 && newVal.indexOf('') >= 0 || newVal.length == 0) {
        this[field] = [''];
      }
    },
    formatLabelValue: function formatLabelValue(value) {
      if (this.searchMainData.distributeType == '1') {
        return value;
      } else {
        return this.$toThousand(value) + ' K';
      }
    },
    formatChartValue: function formatChartValue(params) {
      console.log(params);
      if (!params.value[params.seriesName]) {
        return '';
      } else {
        if (parseFloat(params.value[params.seriesName]) == 0) {
          return '';
        }
      }

      if (this.searchMainData.distributeType == '1') {
        return params.value[params.seriesName];
      } else {
        return this.$toThousand(params.value[params.seriesName], 1, 0);
      }
    },
    percentFormater: function percentFormater(params) {
      var str = '';
      str += params.seriesName + '<br/>';
      if (this.searchMainData.distributeType == '1') {
        str += params.marker + params.name + ' : 　<span style="font-weight:bold">' + params.value['占比'] + '场</span>';
      } else {
        str += params.marker + params.name + ' : 　<span style="font-weight:bold">' + this.$formatMoney(this.$toThousand(params.value['占比'], 1, 2)) + ' K</span>';
      }
      return str;
    },
    progressFormater: function progressFormater(params) {
      var str = '';
      str += params.seriesName + '<br/>';
      if (this.searchMainData.distributeType == '1') {
        str += params.marker + params.name + ' : 　<span style="font-weight:bold">' + params.value[params.seriesName] + '场</span>';
      } else {
        str += params.marker + params.name + ' : 　<span style="font-weight:bold">' + this.$formatMoney(this.$toThousand(params.value[params.seriesName], 1, 2)) + ' K</span>';
      }
      return str;
    },
    trendFormater: function trendFormater(params) {
      if (params.length > 0) {
        var dataObj = params[0].data;
        var str = '';
        for (var field in dataObj) {
          if (field != '月度') {
            if (this.searchMainData.distributeType == '1') {
              str += '<div style="display:flex"><div style="width:auto;white-space: normal;">' + field + ' : </div>　<span style="font-weight:bold;margin-left: auto;">' + dataObj[field] + '场</span></div>';
            } else {
              str += '<div style="display:flex"><div style="width:auto;white-space: normal;">' + field + ' : </div>　<span style="font-weight:bold;margin-left: auto;">' + this.$formatMoney(this.$toThousand(dataObj[field], 1, 2)) + ' K</span></div>';
            }
          }
        }
        return str;
      }
    },
    trimSpace: function trimSpace(array) {
      for (var i = 0; i < array.length; i++) {
        //这里为过滤的值
        if (array[i] == '' || array[i] == null || typeof array[i] == "undefined" || array[i] == ' ') {
          array.splice(i, 1);
          i = i - 1;
        }
      }
      return array;
    },
    handleArrar4All: function handleArrar4All(arrName) {
      if (this[arrName].length > 0 && this[arrName][this[arrName].length - 1] == '') {
        this[arrName] = [''];
      }
    },
    handleMainSearch: function handleMainSearch(isAoneExeStatusChange) {
      var _this2 = this;

      if (!isAoneExeStatusChange) {
        this.searchMainData.selectMeetingStatus = '1';
      }
      this.option3.color = this.color3;
      this.option3.legend.data = this.legendData3;
      this.option3.series = this.series3;

      this.handleArrar4All('medicalFieldArr');
      this.handleArrar4All('teamFieldArr');
      this.handleArrar4All('productIdArr');
      this.handleArrar4All('strategyKeynoteArr');
      this.handleArrar4All('seasonArr');
      this.handleArrar4All('monthArr');
      this.searchMainData.medicalFieldList = this.trimSpace(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.medicalFieldArr))).toString();
      this.searchMainData.teamFieldList = this.trimSpace(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.teamFieldArr))).toString();
      this.searchMainData.productIdList = this.trimSpace(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.productIdArr))).toString();
      this.searchMainData.strategyKeynoteList = this.trimSpace(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.strategyKeynoteArr))).toString();
      this.searchMainData.seasonList = this.trimSpace(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.seasonArr))).toString();
      this.searchMainData.monthList = this.trimSpace(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.monthArr))).toString();
      __WEBPACK_IMPORTED_MODULE_2__api_dashboard_index__["a" /* default */].meeting(this.searchMainData).then(function (res) {
        if (!isAoneExeStatusChange) {
          _this2.data1 = [];
          if (res.planPropList) {
            res.planPropList.forEach(function (el) {
              _this2.data1.push({
                '类型': el.name,
                '占比': el.rate
              });
            });
          };

          _this2.data2 = [];
          if (res.planPropList) {
            res.planPropList.forEach(function (el) {
              _this2.data2.push({
                '类型': el.name,
                '占比': el.rate
              });
            });
          }
          _this2.data3 = [];
          if (res.rateOfProgressList) {
            res.rateOfProgressList.forEach(function (el) {
              if (_this2.searchMainData.planRateType != '1') {
                _this2.data3.push({
                  '名称': el['name'],
                  '已计划': el['已计划'],
                  '已执行': el['已执行'],
                  '待执行': el['待执行'],
                  '计划外': el['计划外']
                });
              } else {
                _this2.data3.push({
                  '名称': el['name'],
                  '已计划': el['已计划'],
                  '已执行': el['已执行'],
                  '待执行': el['待执行']
                });
              }
            });
          };
        }

        _this2.data4.strategyNames = [];
        _this2.data4.data = [];

        if (res.meetingMonthTrendModel && res.meetingMonthTrendModel.names && res.meetingMonthTrendModel.monthTrend) {
          _this2.data4.strategyNames = res.meetingMonthTrendModel.names;

          res.meetingMonthTrendModel.monthTrend.forEach(function (el) {
            el['月度'] = el['month'];
            delete el['month'];
          });
          _this2.data4.data = res.meetingMonthTrendModel.monthTrend;
        };

        _this2.$nextTick(function () {
          if (!isAoneExeStatusChange) {
            _this2.$refs['chart1'].chartChange();
            _this2.$refs['chart2'].chartChange();
            _this2.$refs['chart3'].chartChange();
          }
          _this2.$refs['chart4'].chartChange();
        });
      });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    this.searchMainData.year = new Date().getFullYear();
    this.searchMainData.planRateType = '1';
    this.searchMainData.distributeType = '1';
    this.searchMainData.selectMeetingStatus = '1';

    this.initBaseDataByTypes(['Organization', 'Depart', 'MedicalField', 'Product', 'Year', 'MeetingSystem', 'Strategy', 'MeetingModality', 'MeetingType', 'MeetingProp', 'MeetingGsdType', 'MeetingGsdTypeSub1', 'MeetingGsdTypeSub2', 'MeetingGsdTypeSub3']).then(function () {
      __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__["a" /* default */].queryMeetingPropAndTypeSelect().then(function (res) {
        _this3.meetingPropAndTypeArrays = res;

        // if(this.baseDataRecords.Depart.length > 0) {
        //     this.searchMainData.departId = this.baseDataRecords.Depart[0].id;
        // }
        // if(this.baseDataRecords.Organization && this.baseDataRecords.Organization[0][this.searchMainData.departId].length > 0) {
        //     this.searchMainData.medicalField = this.baseDataRecords.Organization[0][this.searchMainData.departId][0].id;
        // }
        // if(this.baseDataRecords.Product.length > 0) {
        //     this.productIdArr.push(this.baseDataRecords.Product[0].id);
        // }
        _this3.handleMainSearch();
      });
    });
    window._self = this;
  }
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_dashboard_index__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_tableau_Tableau_vue__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_tableau_Tableau_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_tableau_Tableau_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_global__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__error_ErrorSection_vue__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__error_ErrorSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__error_ErrorSection_vue__);

//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Tableau: __WEBPACK_IMPORTED_MODULE_4__common_tableau_Tableau_vue___default.a, ErrorSection: __WEBPACK_IMPORTED_MODULE_7__error_ErrorSection_vue___default.a },
  data: function data() {
    return {
      ticket: "",
      enterTime: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format("YYYY-MM-DD HH:mm:ss")
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["userInfo"]), {
    getZoom: __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* getZoom */],
    url: function url() {
      return __WEBPACK_IMPORTED_MODULE_6__global_global__["a" /* default */].DASHBOARD_URL + '/trusted/' + this.ticket + '/' + __WEBPACK_IMPORTED_MODULE_6__global_global__["a" /* default */].DASHBOARD_MEETING_URL + '?adAccount=' + this.userInfo.username;
    }
  }),
  methods: {
    resizeTableau: function resizeTableau() {
      // this.tableauWidth = document.getElementsByClassName('tableau')[0].clientWidth;
    }
  },
  mounted: function mounted() {
    var _this = this;

    var header = document.querySelector(".header");
    var headerHeight = header.clientHeight;
    var minWidth = 1180;
    var minHeight = 664;
    var maxWidth = 1920;
    var maxHeight = 1080;
    var width = window.screen.width / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* getZoom */])();
    var height = window.screen.height / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* getZoom */])();
    this.width = width;
    this.height = height;
    __WEBPACK_IMPORTED_MODULE_1__api_dashboard_index__["a" /* default */].getTableauTicket().then(function (result) {
      _this.ticket = result;
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.resizeTableau);
    __WEBPACK_IMPORTED_MODULE_1__api_dashboard_index__["a" /* default */].saveStayTime({
      enterTime: this.enterTime,
      leaveTime: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format("YYYY-MM-DD HH:mm:ss"),
      description: "仪表盘-会议"
    }).then(function () {});
  }
});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import CommonEchars from '../../../common/CommonEchars.vue';
/* harmony default export */ __webpack_exports__["default"] = ({
  // components: { CommonEchars },
  data: function data() {
    var _this = this;

    return {
      sampledata: '',
      sampletype: '',
      //1、年度预算分配、年度预算计划
      data1: [{
        '已分配预算': '70'
      }],
      option1: {
        title: { text: '1、年度预算分配、年度预算计划' },
        tooltip: { trigger: 'item' },
        series: [{
          type: 'gauge',
          progress: {
            show: true,
            width: 18
          },
          axisLine: {
            lineStyle: {
              width: 18
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            length: 15,
            lineStyle: {
              width: 2,
              color: '#999'
            }
          },
          axisLabel: {
            distance: 25,
            color: '#999',
            fontSize: 14
          },
          anchor: {
            show: true,
            showAbove: true,
            size: 14,
            itemStyle: {
              borderWidth: 10
            }
          },
          title: {
            show: false
          },
          detail: {
            valueAnimation: true,
            fontSize: 24,
            offsetCenter: [0, '70%']
          }
        }]
      },
      //2、预算计划与执行进度
      data2: [{
        '进度': '进度',
        '已计划预算': 600,
        '已执行预算': 250,
        '待执行预算': 350,
        '计划外预算': 30
      }],
      option2: {
        title: { text: '2、预算计划与执行进度' },
        tooltip: { trigger: 'item' },
        xAxis: {},
        yAxis: { type: 'category' },
        series: [{ type: 'bar' }, { type: 'bar', stack: 'detail' }, { type: 'bar', stack: 'detail' }, { type: 'bar', stack: 'detail' }]
      },
      //3、预算计划与执行季度趋势
      data3: [{
        '季度': '第一季度',
        '已计划': 380,
        '已执行': 400,
        '待执行': 15,
        '计划外': 5,
        '已分配预算': 400
      }, {
        '季度': '第二季度',
        '已计划': 420,
        '已执行': 300,
        '待执行': 60,
        '计划外': 30,
        '已分配预算': 420
      }, {
        '季度': '第三季度',
        '已计划': 310,
        '已执行': 200,
        '待执行': 0,
        '计划外': 30,
        '已分配预算': 300
      }, {
        '季度': '第四季度',
        '已计划': 330,
        '已执行': 330,
        '待执行': 0,
        '计划外': 0,
        '已分配预算': 330
      }],
      option3: {
        title: { text: '3、预算计划与执行季度趋势' },
        tooltip: { trigger: 'item' },
        xAxis: { type: 'category' },
        yAxis: {},
        series: [{ type: 'bar' }, { type: 'bar', stack: 'detail' }, { type: 'bar', stack: 'detail' }, { type: 'bar', stack: 'detail' }, { type: 'line' }]
      },
      //4、预算计划与执行月度趋势
      data4: [{
        '月度': '一月',
        '已计划': 58,
        '已执行': 33,
        '待执行': 15,
        '计划外': 10
      }, {
        '月度': '二月',
        '已计划': 75,
        '已执行': 42,
        '待执行': 20,
        '计划外': 13
      }, {
        '月度': '三月',
        '已计划': 50,
        '已执行': 34,
        '待执行': 6,
        '计划外': 10
      }, {
        '月度': '四月',
        '已计划': 74,
        '已执行': 46,
        '待执行': 15,
        '计划外': 13
      }, {
        '月度': '五月',
        '已计划': 64
      }, {
        '月度': '六月',
        '已计划': 55
      }, {
        '月度': '七月',
        '已计划': 64
      }, {
        '月度': '八月',
        '已计划': 51
      }, {
        '月度': '九月',
        '已计划': 71
      }, {
        '月度': '十月',
        '已计划': 55
      }, {
        '月度': '十一月',
        '已计划': 71
      }, {
        '月度': '十二月',
        '已计划': 48
      }],
      option4: {
        legend: {
          data: ['已计划', '已执行', '待执行', '计划外']
        },
        title: { text: '4、预算计划与执行月度趋势' },
        tooltip: { trigger: 'item' },
        xAxis: { type: 'category' },
        yAxis: {},
        series: [{ type: 'line' }, { type: 'bar', stack: 'detail' }, { type: 'bar', stack: 'detail' }, { type: 'bar', stack: 'detail' }]
      },
      //5、策略计划占比
      data5: [{
        '策略名': '策略一',
        '占比': 98
      }, {
        '策略名': '策略二',
        '占比': 90
      }, {
        '策略名': '策略三',
        '占比': 75
      }, {
        '策略名': '新策略',
        '占比': 83
      }],
      option5: {
        title: { text: '5、策略计划占比' },
        tooltip: { trigger: 'item' },
        polar: {
          radius: [30, '80%']
        },
        angleAxis: {},
        radiusAxis: {
          type: 'category'
        },
        series: {
          type: 'bar',
          coordinateSystem: 'polar'
        }
      },
      //6、策略执行进度、会议执行进度
      data6: [{
        '策略名': '策略一',
        '已计划': 98,
        '已执行': 55,
        '待执行': 45,
        '计划外': 8
      }, {
        '策略名': '策略二',
        '已计划': 90,
        '已执行': 38,
        '待执行': 63,
        '计划外': 10
      }, {
        '策略名': '策略三',
        '已计划': 75,
        '已执行': 42,
        '待执行': 33,
        '计划外': 0
      }, {
        '策略名': '新策略',
        '已计划': 83,
        '已执行': 38,
        '待执行': 47,
        '计划外': 0
      }],
      option6: {
        title: { text: '6、策略执行进度、会议执行进度' },
        tooltip: { trigger: 'item' },
        xAxis: {},
        yAxis: { type: 'category' },
        series: [{ type: 'bar', stack: 'detail' }, { type: 'bar', stack: 'detail' }, { type: 'bar', stack: 'detail' }, { type: 'bar' }]
      },
      //7、策略月度趋势
      data7: {
        "strategyNames": ["策略一", "策略二", "策略三"],
        "data": [{
          "月度": "一月",
          "策略一": 98,
          "策略二": 55
        }, {
          "月度": "二月",
          "策略一": 103,
          "策略二": 42
        }, {
          "月度": "三月",
          "策略一": 75,
          "策略二": 63
        }, {
          "月度": "四月",
          "策略一": 66,
          "策略二": 78,
          "策略三": 48
        }, {
          "月度": "五月",
          "策略一": 80,
          "策略二": 62,
          "策略三": 73
        }, {
          "月度": "六月",
          "策略一": 93,
          "策略二": 91,
          "策略三": 79
        }, {
          "月度": "七月",
          "策略一": 73,
          "策略二": 80,
          "策略三": 93
        }, {
          "月度": "八月",
          "策略一": 65,
          "策略三": 91
        }, {
          "月度": "九月",
          "策略一": 55,
          "策略三": 80
        }, {
          "月度": "十月",
          "策略一": 84,
          "策略三": 86
        }, {
          "月度": "十一月",
          "策略一": 100,
          "策略三": 80
        }, {
          "月度": "十二月",
          "策略一": 120,
          "策略三": 87
        }]
      },
      option7: {
        title: { text: '7、策略月度趋势' },
        tooltip: {
          trigger: 'item',
          formatter: function formatter(params) {
            var info = '';
            for (var key in params.value) {
              if (Object.hasOwnProperty.call(params.value, key)) {
                if (key != '月度') {
                  info += key + '：' + params.value[key] + '<br\>';
                }
              }
            }

            return info;
          }
        },
        xAxis: { type: 'category' },
        yAxis: {},
        series: []
      },
      //8、会议计划占比
      data8: [{
        '类型': '线上会',
        '占比': 1000
      }, {
        '类型': '线下会',
        '占比': 900
      }, {
        '类型': '线上+线下会',
        '占比': 750
      }],
      option8: {
        title: { text: '8、会议计划占比' },
        tooltip: { trigger: 'item' },
        series: [{ type: 'pie' }]
      },
      //9、评分
      data9: [{
        '预算合评分': '150+6',
        '预算': 150,
        '评分': 6,
        '会议名称': 'XXX1',
        '活动负责人': 'YYY1',
        '策略重点': 'aaa1',
        '会议形式': 'bbb1',
        '会议类型': 'ccc1'
      }, {
        '预算合评分': '150+6',
        '预算': 150,
        '评分': 6,
        '会议名称': 'XXX2',
        '活动负责人': 'YYY2',
        '策略重点': 'aaa2',
        '会议形式': 'bbb2',
        '会议类型': 'ccc2'
      }, {
        '预算合评分': '200+7',
        '预算': 200,
        '评分': 7,
        '会议名称': 'XXX3',
        '活动负责人': 'YYY3',
        '策略重点': 'aaa3',
        '会议形式': 'bbb3',
        '会议类型': 'ccc3'
      }, {
        '预算合评分': '100+3',
        '预算': 100,
        '评分': 3,
        '会议名称': 'XXX4',
        '活动负责人': 'YYY4',
        '策略重点': 'aaa4',
        '会议形式': 'bbb4',
        '会议类型': 'ccc4'
      }, {
        '预算合评分': '200+10',
        '预算': 200,
        '评分': 10,
        '会议名称': 'XXX5',
        '活动负责人': 'YYY5',
        '策略重点': 'aaa5',
        '会议形式': 'bbb5',
        '会议类型': 'ccc5'
      }],
      option9: {
        title: { text: '9、评分' },
        tooltip: {
          trigger: 'item',
          formatter: function formatter(params) {
            var budgetScore = params.value['预算合评分'];

            var info = '';
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this.data9), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var data = _step.value;

                if (data['预算合评分'] == budgetScore) {
                  info += info ? '<br/><br/>' : '';
                  info += '\u8BC4\u5206\uFF1A' + data['评分'] + '<br>\'';
                  info += '\u9884\u7B97\uFF1A' + data['预算'] + 'K<br>\'';
                  info += '\u4F1A\u8BAE\u540D\u79F0\uFF1A' + data['会议名称'] + '<br>\'';
                  info += '\u6D3B\u52A8\u8D1F\u8D23\u4EBA\uFF1A' + data['活动负责人'] + '<br>\'';
                  info += '\u7B56\u7565\u91CD\u70B9\uFF1A' + data['策略重点'] + '<br>\'';
                  info += '\u4F1A\u8BAE\u5F62\u5F0F\uFF1A' + data['会议形式'] + '<br>\'';
                  info += '\u4F1A\u8BAE\u7C7B\u578B\uFF1A' + data['会议类型'] + '\'';
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            return info;
          }
        },
        xAxis: {},
        yAxis: {},
        series: [{ type: 'scatter', symbolSize: 20 }]
      }
    };
  },

  computed: {
    dimensions7: function dimensions7() {
      this.option7.series = [];
      for (var index = 0; index < this.data7.strategyNames.length; index++) {
        this.option7.series.push({ type: 'line' });
      }
      var dimensions = _.clone(this.data7.strategyNames);
      dimensions.unshift('月度');
      return dimensions;
    },
    source7: function source7() {
      return this.data7.data;
    }
  },
  methods: {
    sampleChange: function sampleChange() {
      this.sampledata = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this['data' + this.sampletype], null, 4);
    },
    setSample: function setSample() {
      var _this2 = this;

      this['data' + this.sampletype] = JSON.parse(this.sampledata);
      this.$nextTick(function () {
        return _this2.$refs['sample' + _this2.sampletype].chartChange();
      });
    }
  }
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_costCenterAndWbs__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_meetingplan_application__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_sysmanagement_privilege__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_basedata__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_utils__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_organizationUtil__ = __webpack_require__(52);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this2 = this;

        return {
            addNewOrEditData: {
                costType: '1',
                meetingName: '',
                meetingType: '',
                meetingGsdType: '',
                isGsd: '',
                meetingGsdSubType: '',
                meetingProp: '',
                meetingModality: '',
                meetingSystem: [],
                departId: '',
                medicalField: '',
                teamL4: '',
                treatmentArea: '',
                diseaseArea: '',
                productId: [],
                companyStrategy: [],
                strategyKeynote: [],
                medicalFieldResult: [],
                medicalFieldResultDes: '',
                meetingBeginDate: '',
                meetingEndDate: '',
                meetingTimeInt: '',
                country: '',
                countryName: '',
                province: '',
                provinceName: '',
                city: '',
                cityName: '',
                meetingPlace: '',
                hospitalLevelId: '',
                hospitalCount: '',
                hospitalName: '',
                hospitalId: '',
                recipientSocietyStr: '',
                universityStr: '',
                patientOrgStr: '',
                otherStr: '',
                offices: [],
                speakerLevel: '',
                speakerCount: '',
                attendCount: '',
                rocheCount: '',
                totalAmount: '',
                costCenter: '',
                costCenterName: '',
                wbsCode: '',
                wbsCodeName: '',
                a1Amount: '',
                gsdAmount: '',
                meetingOrganizerId: '',
                meetingOrganizerName: '',
                meetingOrganizerCnname: '',
                includeSpeaker: '',
                extendData: {
                    hospitalInfos: [],
                    speakerInfos: []
                }
            },
            startPickerOptions: {
                disabledDate: function disabledDate(time) {
                    time = new Date(moment(time).format('YYYY-MM-DD'));
                    if (_this2.seasonStartDate.getTime && time.getTime() < _this2.seasonStartDate.getTime()) {
                        return true;
                    }

                    if (_this2.seasonEndDate.getTime && time.getTime() > _this2.seasonEndDate.getTime()) {
                        return true;
                    }

                    if (!_this2.addNewOrEditData.meetingEndDate) {
                        return false;
                    }
                    var endDate = new Date(moment(new Date(_this2.addNewOrEditData.meetingEndDate)).format('YYYY-MM-DD'));
                    return time.getTime() > endDate.getTime();
                }
            },
            endPickerOptions: {
                disabledDate: function disabledDate(time) {
                    time = new Date(moment(time).format('YYYY-MM-DD'));
                    if (_this2.seasonStartDate.getTime && time.getTime() < _this2.seasonStartDate.getTime()) {
                        return true;
                    }

                    if (!_this2.addNewOrEditData.meetingBeginDate) {
                        return false;
                    }
                    var startDate = new Date(moment(new Date(_this2.addNewOrEditData.meetingBeginDate)).format('YYYY-MM-DD'));
                    return time.getTime() < startDate.getTime();
                }
            },
            remoteCitiesData: [],
            remoteProvinceData: [],
            remoteMeetingOrganizerData: [],
            remoteHospitalData: [],
            remoteHospitalDataTemp: [],
            seasonStartDate: '',
            seasonEndDate: '',
            confirmSaveVisible: false,
            confirmDeleteVisible: false,
            editType: '',
            strategyData: [],
            domainResultData: [],
            hospitalLevelData: [],
            speakerLevelData: [],
            speakerLevelDataObject: {},
            hospitalLevelDataObject: {},
            costCenterData: [],
            wbsCodeData: [],
            monthlyTypeMessage: '',
            recipientSocietyOrHospital: 1,
            moreThenOneHospital: 0,
            currentUserSelectVisibled: false,
            hiddenTime: null,
            meetingPropAndTypeArrays: {
                selectMeetingProp: [], //可选的会议性质
                popMeetingType: [], //推广的会议类型绑定
                nopopMeetingType: [], //非推广的会议类型绑定
                meetingPropType: [] //推广+非推广的会议类型绑定
            },
            waitBack: false,
            areaRelationObject: {
                '0': [],
                '1': [],
                '2': []
            }
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(['userInfo', 'baseDataRecords', 'basedataGetName', 'basedataGetIdByName', 'basedataGetObject']), {
        MeetingGsdSubTypes: function MeetingGsdSubTypes() {
            return this.baseDataRecords['MeetingGsdTypeSub' + this.addNewOrEditData.meetingGsdType] || [];
        },
        productArray: function productArray() {
            if (!this.addNewOrEditData.meetingProp) {
                return [];
            }

            var areaDbId = this.addNewOrEditData.diseaseArea;
            if (this.basedataGetName('MeetingProp', this.addNewOrEditData.meetingProp) == '推广') {
                areaDbId = this.addNewOrEditData.treatmentArea;
            }
            if (!areaDbId) {
                return [];
            }

            var areaObject = this.areaRelationObject[this.addNewOrEditData.meetingProp].filter(function (a) {
                return a.areaDbId == areaDbId;
            })[0];

            if (areaObject) {
                return areaObject.productArray;
            } else {
                return [];
            }
        },
        filterMeetingType: function filterMeetingType() {
            if (!this.addNewOrEditData.meetingProp) {
                return [];
            }
            switch (this.basedataGetName('MeetingProp', this.addNewOrEditData.meetingProp)) {
                case '推广':
                    return this.meetingPropAndTypeArrays.popMeetingType;
                case '非推广':
                    return this.meetingPropAndTypeArrays.nopopMeetingType;
                default:
                    return this.meetingPropAndTypeArrays.meetingPropType;
            }
        },
        disableSpeakerType: function disableSpeakerType() {
            var typeId = '';
            if (this.addNewOrEditData.speakerLevel) {
                typeId = this.speakerLevelDataObject[this.addNewOrEditData.speakerLevel].typeId;
            } else {
                for (var index = 0; index < this.addNewOrEditData.extendData.speakerInfos.length; index++) {
                    var element = this.addNewOrEditData.extendData.speakerInfos[index];
                    if (element.speakerLevel) {
                        typeId = this.speakerLevelDataObject[element.speakerLevel].typeId;
                        break;
                    }
                }
            }

            if (typeId === '0') {
                typeId = '1';
            } else if (typeId === '1') {
                typeId = '0';
            }

            return typeId;
        },
        disableHospitalType: function disableHospitalType() {
            var typeId = '';
            if (this.addNewOrEditData.hospitalLevelId) {
                typeId = this.hospitalLevelDataObject[this.addNewOrEditData.hospitalLevelId].typeId;
            } else {
                for (var index = 0; index < this.addNewOrEditData.extendData.hospitalInfos.length; index++) {
                    var element = this.addNewOrEditData.extendData.hospitalInfos[index];
                    if (element.hospitalLevelId) {
                        typeId = this.hospitalLevelDataObject[element.hospitalLevelId].typeId;
                        break;
                    }
                }
            }

            if (typeId === '0') {
                typeId = '1';
            } else if (typeId === '1') {
                typeId = '0';
            }

            return typeId;
        },
        disableTotalAmount: function disableTotalAmount() {
            return false;
            //   return !!(this.addNewOrEditData.meetingType === '24' && this.isCEDepart());
        },
        meetingSystemType: function meetingSystemType() {
            //GSD、A1、All、None
            if (this.addNewOrEditData.meetingSystem.length == 0) {
                return 'None';
            }
            if (this.addNewOrEditData.meetingSystem.length == 2) {
                return 'All';
            }
            if (this.addNewOrEditData.meetingSystem.length == 1) {
                return this.basedataGetName('MeetingSystem', this.addNewOrEditData.meetingSystem);
            }
        },
        filterStrategy: function filterStrategy() {
            var _this3 = this;

            var temp = [];
            var productIds = this.addNewOrEditData.productId.join(',');
            this.strategyData.forEach(function (strategy) {
                if (_this3.addNewOrEditData.departId && _this3.addNewOrEditData.departId != strategy.departId) {
                    return;
                }
                if (_this3.addNewOrEditData.medicalField && _this3.addNewOrEditData.medicalField != strategy.medicalField) {
                    return;
                }
                if (_this3.addNewOrEditData.teamL4 && _this3.addNewOrEditData.teamL4 != strategy.teamL4) {
                    return;
                }
                if (productIds && productIds.indexOf(strategy.productId) < 0) {
                    return;
                }

                temp.push(strategy);
            });

            return temp;
        },
        filterSpeakerLevel: function filterSpeakerLevel() {
            var _this4 = this;

            var temp = [];
            this.speakerLevelData.forEach(function (speaker) {
                if (speaker.typeId == '1') {
                    if (speaker.departId && _this4.addNewOrEditData.departId && _this4.addNewOrEditData.departId != speaker.departId) {
                        return;
                    }
                    if (speaker.medicalField && _this4.addNewOrEditData.medicalField && _this4.addNewOrEditData.medicalField != speaker.medicalField) {
                        return;
                    }
                    if (speaker.teamL4 && _this4.addNewOrEditData.teamL4 && _this4.addNewOrEditData.teamL4 != speaker.teamL4) {
                        return;
                    }
                }

                temp.push(speaker);
            });

            return temp;
        },
        filterHospitalLevel: function filterHospitalLevel() {
            var _this5 = this;

            var temp = [];
            var productIds = this.addNewOrEditData.productId.join(',');
            this.hospitalLevelData.forEach(function (hospital) {
                if (hospital.typeId == '1') {
                    if (hospital.departId && _this5.addNewOrEditData.departId && _this5.addNewOrEditData.departId != hospital.departId) {
                        return;
                    }
                    if (hospital.medicalField && _this5.addNewOrEditData.medicalField && _this5.addNewOrEditData.medicalField != hospital.medicalField) {
                        return;
                    }
                    if (hospital.teamL4 && _this5.addNewOrEditData.teamL4 && _this5.addNewOrEditData.teamL4 != hospital.teamL4) {
                        return;
                    }
                    if (hospital.prodIds && productIds) {
                        if (!hospital.prodIds) {
                            return;
                        }
                        var hospitalProdIds = hospital.prodIds.split(',');
                        var match = false;
                        for (var index = 0; index < hospitalProdIds.length; index++) {
                            var element = hospitalProdIds[index];
                            if (productIds.indexOf(element) >= 0) {
                                match = true;
                                break;
                            }
                        }
                        if (!match) {
                            return;
                        }
                    }
                }

                temp.push(hospital);
            });

            return temp;
        },
        filterDomainResult: function filterDomainResult() {
            var _this6 = this;

            var temp = [];
            var productIds = this.addNewOrEditData.productId.join(',');
            this.domainResultData.forEach(function (domainresult) {
                if (_this6.addNewOrEditData.departId && _this6.addNewOrEditData.departId != domainresult.departId) {
                    return;
                }
                if (_this6.addNewOrEditData.medicalField && _this6.addNewOrEditData.medicalField != domainresult.medicalField) {
                    return;
                }
                if (_this6.addNewOrEditData.teamL4 && _this6.addNewOrEditData.teamL4 != domainresult.teamL4) {
                    return;
                }
                if (productIds && productIds.indexOf(domainresult.productId) < 0) {
                    return;
                }

                temp.push(domainresult);
            });

            return temp;
        },
        isSeasonlyType: function isSeasonlyType() {
            if (this.addNewOrEditData.meetingDateType) {
                return this.addNewOrEditData.meetingDateType == '1';
            }

            if (this.addNewOrEditData.meetingBeginDate) {
                if (new Date().getFullYear() != new Date(this.addNewOrEditData.meetingBeginDate).getFullYear() || new Date().getMonth() != new Date(this.addNewOrEditData.meetingBeginDate).getMonth()) {
                    return true;
                }
            }

            return false;
        },
        isMeCostCenter: function isMeCostCenter() {
            if (this.addNewOrEditData.costCenter && this.costCenterData && this.costCenterData.length > 0) {
                for (var index = 0; index < this.costCenterData.length; index++) {
                    var element = this.costCenterData[index];

                    if (this.addNewOrEditData.costCenter == element.costCenter && element.isMe === '1') {
                        return true;
                    }
                }
            }

            return false;
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapActions */])(['initBaseDataByTypes']), {
        handleCostTypeChange: function handleCostTypeChange(value) {
            var _this7 = this;

            if (value == '2') {
                // 切换到Real Wbs Code时，清空成本中心
                this.addNewOrEditData.costCenter = '';
                this.addNewOrEditData.costCenterName = '';
                this.addNewOrEditData.wbsCode = '';
                this.addNewOrEditData.wbsCodeName = '';

                if (!this.addNewOrEditData.departId || !this.addNewOrEditData.medicalField || !this.addNewOrEditData.teamL4) {
                    return;
                }
                __WEBPACK_IMPORTED_MODULE_1__api_costCenterAndWbs__["a" /* default */].listRealWbsCode({
                    year: this.addNewOrEditData.year,
                    quarter: this.addNewOrEditData.season,
                    departId: this.addNewOrEditData.departId,
                    medicalField: this.addNewOrEditData.medicalField,
                    teamL4: this.addNewOrEditData.teamL4
                }).then(function (res) {
                    _this7.wbsCodeData = res;
                });
            } else {
                // 切换到成本中心时，清空WBS Code
                this.addNewOrEditData.wbsCode = '';
                this.addNewOrEditData.wbsCodeName = '';
                this.wbsCodeData = [];
            }
        },
        getMedicalFieldArray: function getMedicalFieldArray(departId, independ) {
            return __WEBPACK_IMPORTED_MODULE_7__util_organizationUtil__["a" /* franchiseArray */](departId, independ);
        },
        getTeamArray: function getTeamArray(departId, medicalField, independ) {
            return __WEBPACK_IMPORTED_MODULE_7__util_organizationUtil__["c" /* teamArray */](departId, medicalField, independ);
        },
        handleMeetingPropChange: function handleMeetingPropChange() {
            this.addNewOrEditData.meetingType = '';
            this.addNewOrEditData.treatmentArea = '';
            this.addNewOrEditData.diseaseArea = '';
            this.addNewOrEditData.productId = [];
            this.resetRelativeFields();
        },
        handleMeetingTypeChange: function handleMeetingTypeChange() {
            this.addNewOrEditData.isGsd = '';
            this.checkTotalAmount();
        },
        handleDepartChange: function handleDepartChange() {
            this.addNewOrEditData.medicalField = '';
            this.addNewOrEditData.teamL4 = '';
            this.addNewOrEditData.isGsd = '';
            this.checkTotalAmount();
            this.resetRelativeFields();
        },
        checkTotalAmount: function checkTotalAmount() {
            if (this.disableTotalAmount) {
                this.addNewOrEditData.totalAmount = 1;
            }
        },
        handleAreaChange: function handleAreaChange() {
            this.addNewOrEditData.productId = [];
            this.resetRelativeFields();
        },
        isSelectedHospitalLevel: function isSelectedHospitalLevel(hospitalLevelId) {
            if (hospitalLevelId == this.addNewOrEditData.hospitalLevelId) {
                return true;
            }

            if (this.addNewOrEditData.extendData.hospitalInfos) {
                for (var index = 0; index < this.addNewOrEditData.extendData.hospitalInfos.length; index++) {
                    var element = this.addNewOrEditData.extendData.hospitalInfos[index];

                    if (element.hospitalLevelId == hospitalLevelId) {
                        return true;
                    }
                }
            }

            return false;
        },
        isSelectedSpeakerLevel: function isSelectedSpeakerLevel(speakerLevelId) {
            if (speakerLevelId == this.addNewOrEditData.speakerLevel) {
                return true;
            }

            if (this.addNewOrEditData.extendData.speakerInfos) {
                for (var index = 0; index < this.addNewOrEditData.extendData.speakerInfos.length; index++) {
                    var element = this.addNewOrEditData.extendData.speakerInfos[index];

                    if (element.speakerLevel == speakerLevelId) {
                        return true;
                    }
                }
            }

            return false;
        },
        handleHospitalCountCheck: function handleHospitalCountCheck() {
            if (this.meetingSystemType == 'A1' || !this.recipientSocietyOrHospital) {
                if (!this.isOneHospital() && this.moreThenOneHospital) {
                    var hospitalTotalCount = this.addNewOrEditData.hospitalCount;

                    this.addNewOrEditData.extendData.hospitalInfos.forEach(function (hs) {
                        hospitalTotalCount += hs.hospitalCount;
                    });

                    if (hospitalTotalCount < 2) {
                        this.$message.error(this.basedataGetName('SysErrorTip', 4));
                        return false;
                    }
                }
            }

            return true;
        },
        handleAmountCheck: function handleAmountCheck() {
            if (this.addNewOrEditData.meetingSystem.length == 2 && this.addNewOrEditData.totalAmount > 0 && this.addNewOrEditData.a1Amount > 0 && this.addNewOrEditData.gsdAmount > 0 && this.addNewOrEditData.totalAmount != this.addNewOrEditData.a1Amount + this.addNewOrEditData.gsdAmount) {
                this.$message.error(this.basedataGetName('SysErrorTip', 2));
                return false;
            }

            return true;
        },
        isCEDepart: function isCEDepart() {
            return this.addNewOrEditData.departId === 'CE-OMNI' || this.addNewOrEditData.departId === 'CE-ONCO';
        },
        isOneHospital: function isOneHospital(hospitalObj) {
            return this.basedataGetName('MeetingType', this.addNewOrEditData.meetingType) == '科室会' || this.basedataGetName('MeetingType', this.addNewOrEditData.meetingType) == '院内会';
        },
        AddNewHospitalInfo: function AddNewHospitalInfo() {
            this.addNewOrEditData.extendData.hospitalInfos.push({});
        },
        removeHosiptalInfo: function removeHosiptalInfo(index) {
            this.addNewOrEditData.extendData.hospitalInfos = this.addNewOrEditData.extendData.hospitalInfos.slice(0, index).concat(this.addNewOrEditData.extendData.hospitalInfos.slice(index + 1, this.addNewOrEditData.extendData.hospitalInfos.length));
        },
        AddNewSpeakerInfo: function AddNewSpeakerInfo() {
            this.addNewOrEditData.extendData.speakerInfos.push({});
        },
        removeSpeakerInfo: function removeSpeakerInfo(index) {
            this.addNewOrEditData.extendData.speakerInfos = this.addNewOrEditData.extendData.speakerInfos.slice(0, index).concat(this.addNewOrEditData.extendData.speakerInfos.slice(index + 1, this.addNewOrEditData.extendData.speakerInfos.length));
        },
        handleMeetingOrganizerFilter: function handleMeetingOrganizerFilter(query) {
            var _this8 = this;

            if (!query) {
                this.remoteMeetingOrganizerData = [];
                return;
            }

            __WEBPACK_IMPORTED_MODULE_2__api_meetingplan_application__["a" /* default */].filterMeetingOrganizer({ 'name': query }).then(function (res) {
                _this8.remoteMeetingOrganizerData = res;
            });
        },
        handleHospitalFilter: function handleHospitalFilter(query) {
            var _this9 = this;

            if (!query || this.isOneHospital() && !this.addNewOrEditData.cityName) {
                this.remoteHospitalData = [];
                this.remoteHospitalDataTemp = [];
                return;
            }

            var cityName = this.isOneHospital() ? this.addNewOrEditData.cityName : '';

            __WEBPACK_IMPORTED_MODULE_2__api_meetingplan_application__["a" /* default */].filterHospital({ 'hospitalName': query }).then(function (res) {
                _this9.remoteHospitalData = res.records;
                _this9.remoteHospitalDataTemp = res.records;
            });
        },
        handleCountryChange: function handleCountryChange() {
            var _this10 = this;

            this.addNewOrEditData.countryName = this.basedataGetName('Country', this.addNewOrEditData.country);
            this.addNewOrEditData.province = '';
            this.addNewOrEditData.provinceName = '';
            this.addNewOrEditData.city = '';
            this.addNewOrEditData.cityName = '';
            this.clearHospital();
            if (this.addNewOrEditData.country) {
                __WEBPACK_IMPORTED_MODULE_4__api_basedata__["a" /* default */].listProvince({ countryId: this.addNewOrEditData.country }).then(function (res) {
                    _this10.remoteProvinceData = res.records;
                });
            } else {
                this.remoteProvinceData = [];
                this.remoteCitiesData = [];
            }
        },
        handleProvinceChange: function handleProvinceChange() {
            var _this11 = this;

            this.addNewOrEditData.provinceName = this.getName(this.addNewOrEditData.province, this.remoteProvinceData, 'id', 'name');
            this.addNewOrEditData.city = '';
            this.addNewOrEditData.cityName = '';
            this.clearHospital();
            if (this.addNewOrEditData.province) {
                __WEBPACK_IMPORTED_MODULE_4__api_basedata__["a" /* default */].listCity({ provinceId: this.addNewOrEditData.province }).then(function (res) {
                    _this11.remoteCitiesData = res.records;
                });
            } else {
                this.remoteCitiesData = [];
            }
        },
        clearHospital: function clearHospital() {
            this.addNewOrEditData.hospitalId = '';
            this.addNewOrEditData.hospitalName = '';
        },
        resetCostCenterList: function resetCostCenterList() {
            var _this12 = this;

            this.costCenterData = [];
            this.wbsCodeData = [];
            this.addNewOrEditData.costCenter = '';
            this.addNewOrEditData.wbsCode = '';
            if (!this.addNewOrEditData.departId || !this.addNewOrEditData.medicalField || !this.addNewOrEditData.teamL4) {
                return;
            }

            __WEBPACK_IMPORTED_MODULE_1__api_costCenterAndWbs__["a" /* default */].listMeetingCostCenter({
                departId: this.addNewOrEditData.departId,
                medicalField: this.addNewOrEditData.medicalField,
                teamL4: this.addNewOrEditData.teamL4
            }).then(function (res) {
                _this12.costCenterData = res;
            });
        },
        handleCostCenterChange: function handleCostCenterChange() {
            var _this13 = this;

            this.addNewOrEditData.wbsCode = '';
            this.wbsCodeData = [];

            if (!this.addNewOrEditData.costCenter) {
                return;
            }

            __WEBPACK_IMPORTED_MODULE_1__api_costCenterAndWbs__["a" /* default */].listLocalWbsCode({
                companyCode: this.userInfo.companyCode,
                costCenter: this.addNewOrEditData.costCenter
            }).then(function (res) {
                _this13.wbsCodeData = res;
            });
        },
        handlerUserCostCenterFieldClick: function handlerUserCostCenterFieldClick() {
            if (!this.currentUserSelectVisibled && new Date() - this.hiddenTime > 500) {
                //大于 500 毫秒才判定是手工触发
                this.$refs.costCenter.selectOption();
            } else {
                this.$refs.costCenter.blur();
            }
        },
        handleCostCenterSelectVisibleChange: function handleCostCenterSelectVisibleChange(visibled) {
            this.currentUserSelectVisibled = visibled;
            if (!this.currentUserSelectVisibled) {
                this.hiddenTime = new Date();
            }
        },
        handlerSave: function handlerSave() {
            var _this14 = this;

            this.$refs['form'].validate(function (valid) {
                if (valid && _this14.handleAmountCheck() && _this14.handleHospitalCountCheck()) {
                    if (_this14.isSeasonlyType) {
                        _this14.confirmSaveVisible = true;
                    } else {
                        var saveData = _this14.getSaveData();
                        __WEBPACK_IMPORTED_MODULE_2__api_meetingplan_application__["a" /* default */].saveMeetingApprove(saveData).then(function (res) {
                            _this14.monthlyTypeMessage = res;
                            _this14.confirmSaveVisible = true;
                        });
                    }
                } else {
                    if (!valid) {
                        _this14.$message.error(_this14.basedataGetName('SysErrorTip', 1));
                    }
                }
            });
        },
        getSaveData: function getSaveData() {
            //治疗领域、疾病领域根据系统情况确定是否清空
            if (this.basedataGetName('MeetingProp', this.addNewOrEditData.meetingProp) != '推广') {
                this.addNewOrEditData.treatmentArea = '';
            }

            if (this.basedataGetName('MeetingProp', this.addNewOrEditData.meetingProp).indexOf('非推广') < 0) {
                this.addNewOrEditData.diseaseArea = '';
            }

            if (this.meetingSystemType == 'GSD') {
                this.addNewOrEditData.meetingType = '';
            }

            if (this.meetingSystemType == 'A1') {
                this.addNewOrEditData.meetingGsdType = '';
                this.addNewOrEditData.meetingGsdSubType = '';
            }

            //治疗领域业务结果（自定义描述）根据治疗领域业务结果是否清空
            if (this.addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') < 0) {
                this.addNewOrEditData.medicalFieldResultDes = '';
            }

            //医院名称及受赠学会根据系统情况确定是否清空
            if (this.meetingSystemType == 'A1' || !this.recipientSocietyOrHospital) {
                //医院输入
                this.addNewOrEditData.recipientSocietyStr = '';
                this.addNewOrEditData.universityStr = '';
                this.addNewOrEditData.patientOrgStr = '';
                this.addNewOrEditData.otherStr = '';

                if (this.isOneHospital() || !this.moreThenOneHospital) {
                    //一家医院
                    this.addNewOrEditData.hospitalCount = 1;
                    this.addNewOrEditData.extendData.hospitalInfos = [];
                } else {
                    //多家医院
                    this.addNewOrEditData.hospitalId = '';
                    this.addNewOrEditData.hospitalName = '';

                    this.addNewOrEditData.extendData.hospitalInfos.forEach(function (hs) {
                        hs.hospitalId = '';
                        hs.hospitalName = '';
                    });
                }
            } else {
                //受赠输入
                this.addNewOrEditData.hospitalLevelId = '';
                this.addNewOrEditData.hospitalCount = '';
                this.addNewOrEditData.hospitalId = '';
                this.addNewOrEditData.hospitalName = '';
                this.addNewOrEditData.extendData.hospitalInfos = [];
                this.addNewOrEditData.offices = [];

                if (this.recipientSocietyOrHospital !== 1) {
                    this.addNewOrEditData.recipientSocietyStr = '';
                }
                if (this.recipientSocietyOrHospital !== 2) {
                    this.addNewOrEditData.universityStr = '';
                }
                if (this.recipientSocietyOrHospital !== 3) {
                    this.addNewOrEditData.patientOrgStr = '';
                }
                if (this.recipientSocietyOrHospital !== 4) {
                    this.addNewOrEditData.otherStr = '';
                }
            }

            //A1预算、GSD预算根据系统情况确定是否清空
            if (this.addNewOrEditData.meetingSystem.length != 2) {
                this.addNewOrEditData.a1Amount = 0;
                this.addNewOrEditData.gsdAmount = 0;
            }

            //是否包含讲者根据系统情况确定是否清空
            //下面代码增加讲者信息时已经处理

            var temp = _.clone(this.addNewOrEditData);

            //转换日期格式
            temp.meetingBeginDate = moment(temp.meetingBeginDate).format('YYYY-MM-DD HH:mm:ss');
            temp.meetingEndDate = moment(temp.meetingEndDate).format('YYYY-MM-DD HH:mm:ss');

            //转换多选项
            temp.companyStrategy = temp.companyStrategy.join(',');
            temp.medicalFieldResult = temp.medicalFieldResult.join(',');
            temp.meetingSystem = temp.meetingSystem.join(',');
            temp.offices = temp.offices.join(',');
            temp.productId = temp.productId.join(',');
            temp.strategyKeynote = temp.strategyKeynote.join(',');

            //转换医院信息
            temp.pubMeetingHospitalLevelList = [];
            if (this.addNewOrEditData.hospitalLevelId) {
                temp.pubMeetingHospitalLevelList.push({
                    hospitalLevelId: this.addNewOrEditData.hospitalLevelId,
                    count: this.addNewOrEditData.hospitalCount,
                    hospitalId: this.addNewOrEditData.hospitalId,
                    hospitalName: this.addNewOrEditData.hospitalName
                });
            }
            temp.hospitalLevelId = '';
            temp.hospitalCount = '';
            temp.hospitalId = '';
            temp.hospitalName = '';

            this.addNewOrEditData.extendData.hospitalInfos.forEach(function (hospital) {
                temp.pubMeetingHospitalLevelList.push({
                    hospitalLevelId: hospital.hospitalLevelId,
                    count: hospital.hospitalCount,
                    hospitalId: hospital.hospitalId,
                    hospitalName: hospital.hospitalName
                });
            });

            //转换讲者信息
            temp.pubMeetingSpeakerLevelList = [];
            if (this.addNewOrEditData.includeSpeaker) {
                temp.pubMeetingSpeakerLevelList.push({
                    speakerLevel: this.addNewOrEditData.speakerLevel,
                    count: this.addNewOrEditData.speakerCount
                });
            }
            temp.speakerLevel = '';
            temp.speakerCount = '';

            if (this.addNewOrEditData.includeSpeaker) {
                this.addNewOrEditData.extendData.speakerInfos.forEach(function (speaker) {
                    temp.pubMeetingSpeakerLevelList.push({
                        speakerLevel: speaker.speakerLevel,
                        count: speaker.speakerCount
                    });
                });
            }

            temp.extendData = '';

            return temp;
        },
        handlerSaveConfirmOK: function handlerSaveConfirmOK() {
            var _this15 = this;

            var temp = this.getSaveData();

            var funName = this.editType == 'add' || this.editType == 'copy' ? 'add' : 'edit';

            if (this.editType == 'add' || this.editType == 'copy') {
                delete temp.id;
            }

            __WEBPACK_IMPORTED_MODULE_2__api_meetingplan_application__["a" /* default */][funName](temp).then(function (res) {
                var msgType = '编辑';
                switch (_this15.editType) {
                    case 'add':
                        msgType = '添加';
                        break;
                    case 'copy':
                        msgType = '复制';
                        break;
                    case 'change':
                        msgType = '变更';
                        break;
                }
                _this15.$message.success(msgType + '会议成功');
                _this15.waitBack = true;

                setTimeout(function () {
                    _this15.$router.push({
                        name: 'meetingplan-application'
                    });
                }, 3000);
            });
        },
        handleDeleteClick: function handleDeleteClick() {
            this.confirmDeleteVisible = true;
        },
        handlerDeleteConfirmOK: function handlerDeleteConfirmOK() {
            var _this16 = this;

            __WEBPACK_IMPORTED_MODULE_2__api_meetingplan_application__["a" /* default */].delete({ id: this.$route.params.id }).then(function (res) {
                _this16.$message.success('删除会议成功');
                _this16.waitBack = true;

                setTimeout(function () {
                    _this16.$router.push({
                        name: 'meetingplan-application'
                    });
                }, 3000);
            });
        },
        goBack: function goBack() {
            history.back();
        },
        getName: function getName(value, array, idField, nameField) {
            for (var index = 0; index < array.length; index++) {
                var element = array[index];
                if (element[idField] == value) {
                    return element[nameField];
                }
            }

            return '';
        },
        initCreateMeetingInfo: function initCreateMeetingInfo() {
            var _this17 = this;

            __WEBPACK_IMPORTED_MODULE_2__api_meetingplan_application__["a" /* default */].getCanCreateMeeting({
                year: this.$route.params.year || this.addNewOrEditData.year,
                season: this.$route.params.season || this.addNewOrEditData.season
            }).then(function (res) {
                var today = moment().format('YYYY-MM-DD');
                _this17.seasonStartDate = res.meetingBeginDateStart >= today ? res.meetingBeginDateStart : today;
                _this17.seasonStartDate = new Date(_this17.seasonStartDate);
                _this17.seasonEndDate = res.meetingBeginDateEnd;
                _this17.seasonEndDate = new Date(_this17.seasonEndDate);
            });
        },
        resetRelativeFields: function resetRelativeFields() {
            this.addNewOrEditData.strategyKeynote = [];

            this.addNewOrEditData.speakerLevel = '';
            this.addNewOrEditData.extendData.speakerInfos.forEach(function (innerSpeaker) {
                innerSpeaker.speakerLevel = '';
            });

            this.addNewOrEditData.hospitalLevelId = '';
            this.addNewOrEditData.extendData.hospitalInfos.forEach(function (innerSpeaker) {
                innerSpeaker.hospitalLevelId = '';
            });

            this.addNewOrEditData.medicalFieldResult = [];

            this.resetCostCenterList();
        },
        filterListArray: function filterListArray(array, valueFieldName, valueArray) {
            var _this = this;
            var resArr = valueArray.filter(function (value) {
                return _this.hasValue(array, valueFieldName, value);
            });
            return resArr;
        },
        hasValue: function hasValue(array, valueFieldName, value) {
            for (var index = 0; index < array.length; index++) {
                var element = array[index];
                if (element[valueFieldName] == value) {
                    return true;
                }
            }

            return false;
        },
        init: function init() {
            var _this18 = this;

            if (this.editType == 'add') {
                this.addNewOrEditData.year = this.$route.params.year;
                this.addNewOrEditData.season = this.$route.params.season;

                this.addNewOrEditData.departId = this.baseDataRecords.Depart.length > 0 ? this.baseDataRecords.Depart[0].id : '';
                var tempMedicalFieldArray = this.getMedicalFieldArray(this.addNewOrEditData.departId);
                this.addNewOrEditData.medicalField = tempMedicalFieldArray.length > 0 ? tempMedicalFieldArray[0].id : '';
                var tempTeamArray = this.getTeamArray(this.addNewOrEditData.departId, this.addNewOrEditData.medicalField);
                this.addNewOrEditData.teamL4 = tempTeamArray.length > 0 ? tempTeamArray[0].id : '';

                this.addNewOrEditData.country = this.basedataGetIdByName('Country', '中国');
                this.handleCountryChange();

                this.addNewOrEditData.includeSpeaker = 1;

                this.initCreateMeetingInfo();
                this.resetCostCenterList();
                this.addNewOrEditData.costType = '1'; // 新增默认值
            } else {
                __WEBPACK_IMPORTED_MODULE_2__api_meetingplan_application__["a" /* default */].queryById({ id: this.$route.params.id }).then(function (res) {
                    var hasOtherMedicalFieldResult = res.medicalFieldResult ? res.medicalFieldResult.indexOf('999999') >= 0 : false;
                    //转换多选项
                    res.companyStrategy = res.companyStrategy ? res.companyStrategy.split(',') : [];
                    res.medicalFieldResult = res.medicalFieldResult ? res.medicalFieldResult.split(',') : [];
                    res.meetingSystem = res.meetingSystem ? res.meetingSystem.split(',') : [];
                    res.offices = res.offices ? res.offices.split(',') : [];
                    res.productId = res.productId ? res.productId.split(',') : [];
                    res.strategyKeynote = res.strategyKeynote ? res.strategyKeynote.split(',') : [];

                    //新需求字段初始化
                    res.meetingGsdType = res.meetingGsdType || '';
                    res.meetingGsdSubType = res.meetingGsdSubType || '';
                    res.universityStr = res.universityStr || '';
                    res.patientOrgStr = res.patientOrgStr || '';
                    res.otherStr = res.otherStr || '';
                    res.teamL4 = res.teamL4 || '';

                    res.extendData = {
                        hospitalInfos: [],
                        speakerInfos: []
                    };
                    res.costType = res.costType || '1'; // 如果后端返回了costType字段则使用，否则默认1

                    //设置省份、城市
                    __WEBPACK_IMPORTED_MODULE_4__api_basedata__["a" /* default */].listProvince({ countryId: res.country }).then(function (countryRes) {
                        _this18.remoteProvinceData = countryRes.records;
                    });
                    __WEBPACK_IMPORTED_MODULE_4__api_basedata__["a" /* default */].listCity({ provinceId: res.province }).then(function (provinceRes) {
                        _this18.remoteCitiesData = provinceRes.records;
                    });

                    //设置成本部中心、wbsCode
                    __WEBPACK_IMPORTED_MODULE_1__api_costCenterAndWbs__["a" /* default */].listMeetingCostCenter({
                        departId: res.departId,
                        medicalField: res.medicalField,
                        teamL4: res.teamL4
                    }).then(function (res) {
                        _this18.costCenterData = res;
                    });
                    if (res.costType === '1') {
                        __WEBPACK_IMPORTED_MODULE_1__api_costCenterAndWbs__["a" /* default */].listLocalWbsCode({
                            companyCode: _this18.userInfo.companyCode,
                            costCenter: res.costCenter
                        }).then(function (res) {
                            _this18.wbsCodeData = res;
                        });
                    }

                    if (res.costType === '2') {
                        // Real Wbs Code 模式：加载 Real Wbs Code 列表
                        if (res.departId && res.medicalField && res.teamL4) {
                            __WEBPACK_IMPORTED_MODULE_1__api_costCenterAndWbs__["a" /* default */].listRealWbsCode({
                                year: res.year,
                                quarter: res.season,
                                departId: res.departId,
                                medicalField: res.medicalField,
                                teamL4: res.teamL4
                            }).then(function (wbsRes) {
                                _this18.wbsCodeData = wbsRes || [];
                            }).catch(function (err) {
                                console.error('加载Real Wbs Code失败:', err);
                                _this18.wbsCodeData = [];
                            });
                        }
                    }

                    //模糊查询设置
                    if (res.meetingOrganizerId) {
                        _this18.remoteMeetingOrganizerData = [];
                        _this18.remoteMeetingOrganizerData.push({
                            AD: res.meetingOrganizerName,
                            Id: res.meetingOrganizerId,
                            CName: res.meetingOrganizerCnname
                        });
                    }
                    if (res.pubMeetingHospitalLevelList.length > 0) {
                        _this18.remoteHospitalData = [];
                        _this18.remoteHospitalDataTemp = [];
                    }

                    //转换医院信息
                    var tempRemoteHospitalDataObj = {};
                    if (res.pubMeetingHospitalLevelList.length > 0) {
                        _this18.remoteHospitalData.push({
                            hospitalName: res.pubMeetingHospitalLevelList[0].hospitalName,
                            id: res.pubMeetingHospitalLevelList[0].hospitalId
                        });
                        _this18.remoteHospitalDataTemp = _this18.remoteHospitalData;
                        tempRemoteHospitalDataObj[res.pubMeetingHospitalLevelList[0].hospitalId] = 1;
                        res.hospitalLevelId = res.pubMeetingHospitalLevelList[0].hospitalLevelId;
                        res.hospitalCount = res.pubMeetingHospitalLevelList[0].count;
                        res.hospitalId = res.pubMeetingHospitalLevelList[0].hospitalId;
                        res.hospitalName = res.pubMeetingHospitalLevelList[0].hospitalName;
                    }
                    if (res.pubMeetingHospitalLevelList.length > 1) {
                        for (var index = 1; index < res.pubMeetingHospitalLevelList.length; index++) {
                            var element = res.pubMeetingHospitalLevelList[index];

                            res.extendData.hospitalInfos.push({
                                hospitalLevelId: element.hospitalLevelId,
                                hospitalCount: element.count,
                                hospitalId: element.hospitalId,
                                hospitalName: element.hospitalName
                            });
                        }
                    }
                    res.pubMeetingHospitalLevelList = '';

                    //转换讲者信息
                    res.includeSpeaker = res.pubMeetingSpeakerLevelList.length > 0 ? 1 : 0;
                    if (res.pubMeetingSpeakerLevelList.length > 0) {
                        res.speakerLevel = res.pubMeetingSpeakerLevelList[0].speakerLevel;
                        res.speakerCount = res.pubMeetingSpeakerLevelList[0].count;
                    }
                    if (res.pubMeetingSpeakerLevelList.length > 1) {
                        for (var _index = 1; _index < res.pubMeetingSpeakerLevelList.length; _index++) {
                            var _element = res.pubMeetingSpeakerLevelList[_index];

                            res.extendData.speakerInfos.push({
                                speakerLevel: _element.speakerLevel,
                                speakerCount: _element.count
                            });
                        }
                    }
                    res.pubMeetingSpeakerLevelList = '';

                    if (_this18.editType == 'copy') {
                        var today = new Date(new Date().toDateString());

                        if (res.meetingBeginDate && Date.parse(res.meetingBeginDate) < today) {
                            res.meetingBeginDate = '';
                        }

                        if (res.meetingEndDate && Date.parse(res.meetingEndDate) < today) {
                            res.meetingEndDate = '';
                        }
                    }

                    _this18.addNewOrEditData = res;

                    _this18.addNewOrEditData.strategyKeynote = _this18.filterListArray(_this18.filterStrategy, 'id', _this18.addNewOrEditData.strategyKeynote);
                    _this18.addNewOrEditData.medicalFieldResult = _this18.filterListArray(_this18.filterDomainResult, 'id', _this18.addNewOrEditData.medicalFieldResult);
                    if (hasOtherMedicalFieldResult) {
                        _this18.addNewOrEditData.medicalFieldResult.push('999999');
                    }
                    _this18.addNewOrEditData.hospitalLevelId = _this18.hasValue(_this18.filterHospitalLevel, 'id', _this18.addNewOrEditData.hospitalLevelId) ? _this18.addNewOrEditData.hospitalLevelId : '';
                    _this18.addNewOrEditData.extendData.hospitalInfos.forEach(function (hos) {
                        hos.hospitalLevelId = _this18.hasValue(_this18.filterHospitalLevel, 'id', hos.hospitalLevelId) ? hos.hospitalLevelId : '';
                    });
                    if (_this18.addNewOrEditData.includeSpeaker) {
                        _this18.addNewOrEditData.speakerLevel = _this18.hasValue(_this18.filterSpeakerLevel, 'id', _this18.addNewOrEditData.speakerLevel) ? _this18.addNewOrEditData.speakerLevel : '';
                        _this18.addNewOrEditData.extendData.speakerInfos.forEach(function (spk) {
                            spk.speakerLevel = _this18.hasValue(_this18.filterSpeakerLevel, 'id', spk.speakerLevel) ? spk.speakerLevel : '';
                        });
                    }
                    if (_this18.addNewOrEditData.extendData.hospitalInfos.length > 0) {
                        _this18.recipientSocietyOrHospital = 0;
                        _this18.moreThenOneHospital = 1;
                    } else {
                        if (_this18.addNewOrEditData.hospitalId || _this18.addNewOrEditData.hospitalCount > 0) {
                            if (_this18.addNewOrEditData.hospitalCount > 1) {
                                _this18.recipientSocietyOrHospital = 0;
                                _this18.moreThenOneHospital = 1;
                            } else {
                                _this18.recipientSocietyOrHospital = 0;
                                _this18.moreThenOneHospital = 0;
                            }
                        } else {
                            if (_this18.addNewOrEditData.recipientSocietyStr) {
                                _this18.recipientSocietyOrHospital = 1;
                            }
                            if (_this18.addNewOrEditData.universityStr) {
                                _this18.recipientSocietyOrHospital = 2;
                            }
                            if (_this18.addNewOrEditData.patientOrgStr) {
                                _this18.recipientSocietyOrHospital = 3;
                            }
                            if (_this18.addNewOrEditData.otherStr) {
                                _this18.recipientSocietyOrHospital = 4;
                            }
                            _this18.moreThenOneHospital = 0;
                        }
                    }
                    _this18.$nextTick(function () {
                        _this18.remoteHospitalData = [];
                        _this18.remoteMeetingOrganizerData = [];
                    });

                    _this18.initCreateMeetingInfo();
                });
            }
        }
    }),
    mounted: function mounted() {
        var _this19 = this;

        this.editType = this.$route.name.replace('meetingplan-application-', '');

        this.initBaseDataByTypes(['MeetingModality', 'MeetingSystem', 'Depart', 'MedicalField', 'TreatmentArea', 'DiseaseArea', 'Product', 'CompanyStrategy', 'MeetingTimeInt', 'Country', 'Office', 'CostCenter', 'WbsCode', 'SysErrorTip', 'MeetingGsdType', 'MeetingGsdTypeSub1', 'MeetingGsdTypeSub2', 'MeetingGsdTypeSub3']).then(function () {
            __WEBPACK_IMPORTED_MODULE_6__util_utils__["a" /* default */].$all([__WEBPACK_IMPORTED_MODULE_4__api_basedata__["a" /* default */].listStrategy(), __WEBPACK_IMPORTED_MODULE_4__api_basedata__["a" /* default */].listDomainResult(), __WEBPACK_IMPORTED_MODULE_4__api_basedata__["a" /* default */].listHospitalLevel(), __WEBPACK_IMPORTED_MODULE_4__api_basedata__["a" /* default */].listSpeakerLevel(), __WEBPACK_IMPORTED_MODULE_2__api_meetingplan_application__["a" /* default */].queryMeetingPropAndTypeSelect(), __WEBPACK_IMPORTED_MODULE_2__api_meetingplan_application__["a" /* default */].queryAreaRelationList({ pageNo: 1, pageSize: 999999 })]).then(function (resList) {
                _this19.strategyData = resList[0].records;
                _this19.domainResultData = resList[1].records;
                _this19.hospitalLevelData = resList[2].records;
                _this19.hospitalLevelData.forEach(function (hp) {
                    _this19.hospitalLevelDataObject[hp.id] = hp;
                });
                _this19.speakerLevelData = resList[3].records;
                _this19.speakerLevelData.forEach(function (sp) {
                    _this19.speakerLevelDataObject[sp.id] = sp;
                });
                _this19.meetingPropAndTypeArrays = resList[4];
                resList[5].records.forEach(function (r) {
                    var areaObjectArray = _this19.areaRelationObject[r.meetingProp];

                    var areaObject = areaObjectArray.filter(function (a) {
                        return a.areaDbId == r.areaDbId;
                    })[0];
                    if (!areaObject) {
                        areaObject = {
                            areaDbId: r.areaDbId,
                            areaName: r.areaName,
                            productArray: []
                        };
                        areaObjectArray.push(areaObject);
                    }

                    var productObject = areaObject.productArray.filter(function (p) {
                        return p.productDbId == r.productDbId;
                    })[0];
                    if (!productObject) {
                        productObject = {
                            productDbId: r.productDbId,
                            productName: r.productName
                        };
                        areaObject.productArray.push(productObject);
                    }
                });
                _this19.init();
            });
        });
    }
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_costCenterAndWbs__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_basedata__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_StorageService__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_organizationUtil__ = __webpack_require__(52);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      applicationDetailData: [],
      searchMainData: {
        year: '',
        quarter: 'Q1'
      },
      searchData: {
        status: [],
        queueTaskStatus: '',
        departId: '',
        medicalField: '',
        teamL4: '',
        productId: '',
        city: '',
        dateRange: null,
        createDateRange: null,
        wbsCode: '',
        meetingGsdType: '',
        meetingGsdSubType: ''
      },
      mainData: {
        '1': {},
        '2': {},
        '4': {},
        '5': {}
      },
      crudApi: __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__["a" /* default */],
      isEdit: false,
      applicationDetailCount: 0,
      applicationDetailAmt: 0,
      searchMainQuarters: ['Q1', 'Q2', 'Q3', 'Q4'],
      advancedSearchVisible: false,
      citiesData: [],
      remoteMeetingCodeData: [],
      remoteMeetingCreatorData: [],
      remoteMeetingOrganizerData: [],
      selectedData: [],
      confirmBatchSubmitVisible: false,
      canCreateMeeting: false,
      monthlyTypeMessage: '',
      costCenterArray: [],
      wbsCodeArray: [],
      inQueueNumber: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(['userInfo', 'baseDataRecords', 'basedataGetName', 'basedataGetNameByRowIdField']), {
    MeetingGsdSubTypes: function MeetingGsdSubTypes() {
      return this.baseDataRecords['MeetingGsdTypeSub' + this.searchData.meetingGsdType] || [];
    },
    canBatchSubmit: function canBatchSubmit() {
      for (var index = 0; index < this.selectedData.length; index++) {
        var element = this.selectedData[index];
        if (element.queueTaskStatus === '排队中') {
          return false;
        } else if (element.meetingWebStatus != '待提交') {
          return false;
        }
      }

      return this.selectedData.length > 0;
    },
    selectedTotalAmount: function selectedTotalAmount() {
      var amount = 0;
      this.selectedData.forEach(function (data) {
        amount += data.totalAmount;
      });

      return amount;
    },
    isSeasonlyType: function isSeasonlyType() {
      if (this.selectedData && this.selectedData.length > 0) {
        return this.selectedData[0].meetingDateType == '1';
      }

      return false;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapActions */])(['initBaseDataByTypes']), {
    getMedicalFieldArray: function getMedicalFieldArray(departId, independ) {
      return __WEBPACK_IMPORTED_MODULE_7__util_organizationUtil__["a" /* franchiseArray */](departId, independ);
    },
    getTeamArray: function getTeamArray(departId, medicalField, independ) {
      return __WEBPACK_IMPORTED_MODULE_7__util_organizationUtil__["c" /* teamArray */](departId, medicalField, independ);
    },
    formatDateTime2Date: function formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    formatBaseData: function formatBaseData(row, column, cellValue, index) {
      if (column.property == 'productId') {
        if (row.productId) {
          var ids = row.productId;
          if (typeof ids == 'string') {
            ids = ids.split(',');
          }
          var names = [];
          for (var pidIndex = 0; pidIndex < ids.length; pidIndex++) {
            names.push(this.basedataGetName('Product', ids[pidIndex]));
          }
          return names.join(',');
        }
        return row.prodIds;
      }
      if (column.property == 'meetingSystem') {
        if (row.meetingSystem) {
          var _ids = row.meetingSystem;
          if (typeof _ids == 'string') {
            _ids = _ids.split(',');
          }
          var _names = [];
          for (var _pidIndex = 0; _pidIndex < _ids.length; _pidIndex++) {
            _names.push(this.basedataGetName('MeetingSystem', _ids[_pidIndex]));
          }
          return _names.join(',');
        }
        return row.prodIds;
      }

      return this.basedataGetNameByRowIdField(column.property, row);
    },
    indexMethod: function indexMethod(index) {
      return this.$refs['crud'].indexMethod(index);
    },
    handleSearch: function handleSearch() {
      //查询时不传dateRange，查询后重新赋值，用于界面查看
      var tempDateRange = this.searchData.dateRange;
      if (this.searchData.dateRange && this.searchData.dateRange.length == 2) {
        this.searchData.meetingBeginDate = moment(this.searchData.dateRange[0]).format('YYYY-MM-DD HH:mm:ss');
        this.searchData.meetingEndDate = moment(this.searchData.dateRange[1]).format('YYYY-MM-DD HH:mm:ss');
        this.searchData.dateRange = null;
      } else {
        this.searchData.meetingBeginDate = '';
        this.searchData.meetingEndDate = '';
        this.searchData.dateRange = null;
      }
      //查询时不传dateRange，查询后重新赋值，用于界面查看
      var tempCreateDateRange = this.searchData.createDateRange;
      if (this.searchData.createDateRange && this.searchData.createDateRange.length == 2) {
        this.searchData.createBeginDate = moment(this.searchData.createDateRange[0]).format('YYYY-MM-DD HH:mm:ss');
        this.searchData.createEndDate = moment(this.searchData.createDateRange[1]).format('YYYY-MM-DD HH:mm:ss');
        this.searchData.createDateRange = null;
      } else {
        this.searchData.createBeginDate = '';
        this.searchData.createEndDate = '';
        this.searchData.createDateRange = null;
      }

      this.searchData.year = this.searchMainData.year;
      this.searchData.season = this.searchMainData.season;

      __WEBPACK_IMPORTED_MODULE_6__util_StorageService__["d" /* setItem */](__WEBPACK_IMPORTED_MODULE_6__util_StorageService__["b" /* keys */].MyApplicationSearchDetailData, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.searchData));

      var statusAll = false;
      if (this.searchData.status.length == 0) {
        statusAll = true;

        this.searchData.status = this.baseDataRecords.MyApplicationStatus.map(function (s) {
          return s.value;
        });
      }

      this.$refs['crud'].handleSearch(1);
      this.advancedSearchVisible = false;
      this.searchData.dateRange = tempDateRange;
      this.searchData.createDateRange = tempCreateDateRange;
      if (statusAll) {
        this.searchData.status = '';
      }
    },
    handleResetSearchCondition: function handleResetSearchCondition() {
      this.$refs['crud'].resetObject(this.searchData);
      this.searchData.minModelScore = undefined;
      this.searchData.maxModelScore = undefined;
      this.searchData.status = ['1'];
      this.wbsCodeArray = [];
    },
    handleSearchResult: function handleSearchResult(res) {
      this.applicationDetailCount = res.rowCount;
      this.applicationDetailAmt = res.sumTotalAmt;
      this.inQueueNumber = res.watingCount;

      res.current = res.pageList.current;
      res.total = res.pageList.total;

      this.applicationDetailData = res.pageList.records;
    },
    handleViewClick: function handleViewClick(item) {
      this.$router.push({
        name: 'meetingplan-application-view',
        params: {
          'id': item.id
        }
      });
    },
    handleEditClick: function handleEditClick(item) {
      this.$router.push({
        name: 'meetingplan-application-edit',
        params: {
          'id': item.id
        }
      });
    },
    handleCopyClick: function handleCopyClick(item) {
      this.$router.push({
        name: 'meetingplan-application-copy',
        params: {
          'id': item.id
        }
      });
    },
    handleAddClick: function handleAddClick(item) {
      this.$router.push({
        name: 'meetingplan-application-add',
        params: {
          'year': this.searchMainData.year,
          'season': this.searchMainData.quarter.replace('Q', '')
        }
      });
    },
    handleDeleteClick: function handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleApplicationDeleted: function handleApplicationDeleted() {
      this.handleMainSearch(this.searchMainData.quarter);
    },
    handleMainSearch: function handleMainSearch(quarter) {
      var _this = this;

      if (quarter) {
        this.searchMainData.quarter = quarter;
        this.searchMainData.season = quarter.replace('Q', '');
      }
      __WEBPACK_IMPORTED_MODULE_6__util_StorageService__["d" /* setItem */](__WEBPACK_IMPORTED_MODULE_6__util_StorageService__["b" /* keys */].MyApplicationSearchMainData, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.searchMainData));
      __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__["a" /* default */].queryMainApplication(this.searchMainData).then(function (res) {
        _this.mainData = {};
        res.forEach(function (data) {
          data.statusName = _this.basedataGetName('MyApplicationStatus', data.status);
          _this.mainData[data.status.toString()] = data;
        });

        _this.initCreateMeetingInfo();

        _this.handleSearch();
      });
    },
    handleAdvancedSearchClick: function handleAdvancedSearchClick() {
      this.advancedSearchVisible = true;
    },
    handleProvinceChange: function handleProvinceChange() {
      var _this2 = this;

      this.searchData.city = '';
      if (this.searchData.province) {
        __WEBPACK_IMPORTED_MODULE_4__api_basedata__["a" /* default */].listCity({ provinceId: this.searchData.province }).then(function (res) {
          _this2.citiesData = res.records;
        });
      } else {
        this.citiesData = [];
      }
    },
    handleMeetingCodeFilter: function handleMeetingCodeFilter(query) {
      var _this3 = this;

      if (!query) {
        this.remoteMeetingCodeData = [];
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__["a" /* default */].filterMeetingCode({
        'code': query,
        year: this.searchMainData.year,
        season: this.searchMainData.season
      }).then(function (res) {
        _this3.remoteMeetingCodeData = res;
      });
    },
    handleMeetingCreatorFilter: function handleMeetingCreatorFilter(query) {
      var _this4 = this;

      if (!query) {
        this.remoteMeetingCreatorData = [];
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__["a" /* default */].filterMeetingCreator({ 'name': query }).then(function (res) {
        _this4.remoteMeetingCreatorData = res;
      });
    },
    handleMeetingOrganizerFilter: function handleMeetingOrganizerFilter(query) {
      var _this5 = this;

      if (!query) {
        this.remoteMeetingOrganizerData = [];
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__["a" /* default */].filterMeetingOrganizer({ 'name': query }).then(function (res) {
        _this5.remoteMeetingOrganizerData = res;
      });
    },
    handleBatchSubmit: function handleBatchSubmit() {
      var _this6 = this;

      if (this.isSeasonlyType) {
        this.confirmBatchSubmitVisible = true;
      } else {
        var tempIds = [];
        this.selectedData.forEach(function (meeting) {
          tempIds.push(meeting.id);
        });
        __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__["a" /* default */].submitMeetingApprove({
          year: this.searchMainData.year,
          season: this.searchMainData.season,
          id: tempIds.join(',')
        }).then(function (res) {
          _this6.monthlyTypeMessage = res;
          _this6.confirmBatchSubmitVisible = true;
        });
      }
    },
    handlerBatchSubmitConfirmOK: function handlerBatchSubmitConfirmOK() {
      var _this7 = this;

      var tempIds = [];
      this.selectedData.forEach(function (meeting) {
        tempIds.push(meeting.id);
      });

      __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__["a" /* default */].batchSubmit({
        year: this.searchMainData.year,
        season: this.searchMainData.season,
        id: tempIds.join(',')
      }).then(function (res) {
        _this7.$message.success(res.resultTxt);
        _this7.handleSearch();
      });
    },
    initCreateMeetingInfo: function initCreateMeetingInfo() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__["a" /* default */].getCanCreateMeeting({
        year: this.searchMainData.year,
        season: this.searchMainData.season
      }).then(function (res) {
        _this8.canCreateMeeting = res.canCreateMeeting;
      });
    },
    handlerExportExcelClick: function handlerExportExcelClick() {
      this.$refs['crud'].handlerExportExcel('我的申请.xlsx', { meetingFrom: 0 });
    },
    handleSearchCostCenterChange: function handleSearchCostCenterChange() {
      var _this9 = this;

      this.searchData.wbsCode = '';
      this.wbsCodeArray = [];

      if (!this.searchData.costCenter) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_2__api_costCenterAndWbs__["a" /* default */].listLocalWbsCode({
        companyCode: this.userInfo.companyCode,
        costCenter: this.searchData.costCenter
      }).then(function (res) {
        _this9.wbsCodeArray = res;
      });
    }
  }),
  mounted: function mounted() {
    var _this10 = this;

    // this.searchData.queueTaskStatus = '0';
    var searchDetailDataTemp = __WEBPACK_IMPORTED_MODULE_6__util_StorageService__["a" /* getItem */](__WEBPACK_IMPORTED_MODULE_6__util_StorageService__["b" /* keys */].MyApplicationSearchDetailData);
    if (searchDetailDataTemp) {
      this.searchData = JSON.parse(searchDetailDataTemp);
    } else {
      this.searchData.status = ['1'];
    }

    var searchMainDataTemp = __WEBPACK_IMPORTED_MODULE_6__util_StorageService__["a" /* getItem */](__WEBPACK_IMPORTED_MODULE_6__util_StorageService__["b" /* keys */].MyApplicationSearchMainData);

    if (searchMainDataTemp) {
      this.searchMainData = JSON.parse(searchMainDataTemp);
    } else {
      this.searchMainData.year = new Date().getFullYear();
      this.searchMainData.quarter = 'Q' + Math.ceil((new Date().getMonth() + 1) / 3);
    }

    this.initBaseDataByTypes(['Year', 'MyApplicationStatus', 'AoneExeStatus', 'QueueTaskStatus', 'MeetingType', 'MeetingProp', 'MeetingModality', 'MeetingSystem', 'Depart', 'MedicalField', 'TreatmentArea', 'DiseaseArea', 'Product', 'CompanyStrategy', 'Strategy', 'DomainResult', 'MeetingTimeInt', 'HospitalLevel', 'Country', 'Province', 'Office', 'SpeakerLevel', 'CostCenter', 'WbsCode', 'SysErrorTip', 'MeetingGsdType', 'MeetingGsdTypeSub1', 'MeetingGsdTypeSub2', 'MeetingGsdTypeSub3']).then(function () {
      _this10.handleMainSearch(_this10.searchMainData.quarter);
    });

    __WEBPACK_IMPORTED_MODULE_2__api_costCenterAndWbs__["a" /* default */].listLocalCostCenter({ companyCode: this.userInfo.companyCode }).then(function (res) {
      _this10.costCenterArray = res;
    });
  }
});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_meetingplan_application__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            addNewOrEditData: {
                meetingName: '',
                meetingType: '',
                meetingGsdType: '',
                meetingGsdSubType: '',
                meetingProp: '',
                meetingModality: '',
                meetingSystem: [],
                departId: '',
                medicalField: '',
                treatmentArea: '',
                diseaseArea: '',
                productId: [],
                companyStrategy: [],
                strategyKeynote: [],
                medicalFieldResult: [],
                medicalFieldResultDes: '',
                meetingBeginDate: '',
                meetingEndDate: '',
                meetingTimeInt: '',
                country: '',
                province: '',
                city: '',
                meetingPlace: '',
                hospitalLevelId: '',
                hospitalCount: '',
                hospitalName: '',
                recipientSociety: '',
                universityStr: '',
                patientOrgStr: '',
                otherStr: '',
                offices: [],
                speakerLevel: '',
                speakerCount: '',
                attendCount: '',
                rocheCount: '',
                totalAmount: '',
                costCenter: '',
                wbsCode: '',
                a1Amount: '',
                gsdAmount: '',
                meetingOrganizer: '',
                includeSpeaker: '',
                extendData: {
                    hospitalInfos: [],
                    speakerInfos: []
                },
                isAutoReject: '0'
            },
            confirmChangeVisible: false,
            confirmCancleVisible: false,
            recipientSocietyOrHospital: 1,
            moreThenOneHospital: 0
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['baseDataRecords', 'basedataGetName', 'basedataGetIdByName', 'basedataGetObject']), {
        MeetingGsdSubTypes: function MeetingGsdSubTypes() {
            return 'MeetingGsdTypeSub' + this.addNewOrEditData.meetingGsdType;
        },
        meetingSystemType: function meetingSystemType() {
            //GSD、A1、All、None
            if (this.addNewOrEditData.meetingSystem.length == 0) {
                return 'None';
            }
            if (this.addNewOrEditData.meetingSystem.length == 2) {
                return 'All';
            }
            if (this.addNewOrEditData.meetingSystem.length == 1) {
                return this.basedataGetName('MeetingSystem', this.addNewOrEditData.meetingSystem);
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['initBaseDataByTypes']), {
        approvalStatusClass: function approvalStatusClass(status) {
            switch (status) {
                case '2':
                    return 'approval-submit';
                case '3':
                    return 'approval-padding';
                case '4':
                    return 'approval-comfirm';
                case '5':
                    return 'approval-reject';
                case '7':
                    return 'approval-cancle';
            }
            return '';
        },
        showHospitalName: function showHospitalName(hospitalObj) {
            return hospitalObj.hospitalCount == 1 || this.basedataGetName('MeetingType', this.addNewOrEditData.meetingType) == '科室会' || this.basedataGetName('MeetingType', this.addNewOrEditData.meetingType) == '院内会';
        },
        handleCancleClick: function handleCancleClick() {
            this.confirmCancleVisible = true;
        },
        handlerCancleConfirmOK: function handlerCancleConfirmOK() {
            __WEBPACK_IMPORTED_MODULE_1__api_meetingplan_application__["a" /* default */].cancle({ id: this.addNewOrEditData.id }).then(function (res) {
                history.back();
            });
        },
        handlerChangeClick: function handlerChangeClick() {
            this.confirmChangeVisible = true;
        },
        handlerChangeConfirmOK: function handlerChangeConfirmOK() {
            this.$router.push({
                name: 'meetingplan-application-change',
                params: { 'id': this.addNewOrEditData.id }
            });
        },
        isOneHospital: function isOneHospital(hospitalObj) {
            return this.basedataGetName('MeetingType', this.addNewOrEditData.meetingType) == '科室会' || this.basedataGetName('MeetingType', this.addNewOrEditData.meetingType) == '院内会';
        },
        isCEDepart: function isCEDepart() {
            return this.addNewOrEditData.departId === 'CE-OMNI' || this.addNewOrEditData.departId === 'CE-ONCO';
        }
    }),
    mounted: function mounted() {
        var _this = this;

        this.initBaseDataByTypes(['MeetingType', 'MeetingProp', 'MeetingModality', 'MeetingSystem', 'Depart', 'MedicalField', 'TreatmentArea', 'DiseaseArea', 'Product', 'CompanyStrategy', 'MeetingTimeInt', 'Country', 'Office', 'CostCenter', 'WbsCode', 'MeetingGsdType', 'MeetingGsdTypeSub1', 'MeetingGsdTypeSub2', 'MeetingGsdTypeSub3']).then(function () {
            __WEBPACK_IMPORTED_MODULE_1__api_meetingplan_application__["a" /* default */].queryById({ id: _this.$route.params.id }).then(function (res) {
                //转换多选项
                res.companyStrategy = res.companyStrategy.split(',');
                res.medicalFieldResult = res.medicalFieldResult == null ? ''.split(',') : res.medicalFieldResult.split(',');
                res.meetingSystem = res.meetingSystem.split(',');
                res.offices = res.offices == null ? '' : res.offices.split(',');
                res.productId = res.productId.split(',');
                res.strategyKeynote = res.strategyKeynote.split(',');

                //新需求字段初始化
                res.meetingGsdType = res.meetingGsdType || '';
                res.meetingGsdSubType = res.meetingGsdSubType || '';
                res.universityStr = res.universityStr || '';
                res.patientOrgStr = res.patientOrgStr || '';
                res.otherStr = res.otherStr || '';
                res.teamL4 = res.teamL4 || '';

                res.extendData = {
                    hospitalInfos: [],
                    speakerInfos: []
                };
                //转换医院信息
                if (res.pubMeetingHospitalLevelList.length > 0) {
                    res.hospitalLevelId = res.pubMeetingHospitalLevelList[0].hospitalLevelId;
                    res.hospitalLevelName = res.pubMeetingHospitalLevelList[0].hospitalLevelName;
                    res.hospitalCount = res.pubMeetingHospitalLevelList[0].count;
                    res.hospitalName = res.pubMeetingHospitalLevelList[0].hospitalName;
                    res.recipientSociety = res.pubMeetingHospitalLevelList[0].recipientSociety;
                }
                if (res.pubMeetingHospitalLevelList.length > 1) {
                    for (var index = 1; index < res.pubMeetingHospitalLevelList.length; index++) {
                        var element = res.pubMeetingHospitalLevelList[index];

                        res.extendData.hospitalInfos.push({
                            hospitalLevelId: element.hospitalLevelId,
                            hospitalLevelName: element.hospitalLevelName,
                            hospitalCount: element.count,
                            hospitalName: element.hospitalName,
                            recipientSociety: element.recipientSociety
                        });
                    }
                }
                res.pubMeetingHospitalLevelList = '';

                //转换讲者信息
                res.includeSpeaker = res.pubMeetingSpeakerLevelList.length > 0 ? 1 : 0;
                if (res.pubMeetingSpeakerLevelList.length > 0) {
                    res.speakerLevel = res.pubMeetingSpeakerLevelList[0].speakerLevel;
                    res.speakerLevelName = res.pubMeetingSpeakerLevelList[0].speakerLevelName;
                    res.speakerCount = res.pubMeetingSpeakerLevelList[0].count;
                }
                if (res.pubMeetingSpeakerLevelList.length > 1) {
                    for (var _index = 1; _index < res.pubMeetingSpeakerLevelList.length; _index++) {
                        var _element = res.pubMeetingSpeakerLevelList[_index];

                        res.extendData.speakerInfos.push({
                            speakerLevel: _element.speakerLevel,
                            speakerLevelName: _element.speakerLevelName,
                            speakerCount: _element.count
                        });
                    }
                }
                if (res.extendData.hospitalInfos.length > 0) {
                    _this.recipientSocietyOrHospital = 0;
                    _this.moreThenOneHospital = 1;
                } else {
                    if (res.hospitalId || res.hospitalCount > 0) {
                        if (res.hospitalCount > 1) {
                            _this.recipientSocietyOrHospital = 0;
                            _this.moreThenOneHospital = 1;
                        } else {
                            _this.recipientSocietyOrHospital = 0;
                            _this.moreThenOneHospital = 0;
                        }
                    } else {
                        if (res.recipientSocietyStr) {
                            _this.recipientSocietyOrHospital = 1;
                        }
                        if (res.universityStr) {
                            _this.recipientSocietyOrHospital = 2;
                        }
                        if (res.patientOrgStr) {
                            _this.recipientSocietyOrHospital = 3;
                        }
                        if (res.otherStr) {
                            _this.recipientSocietyOrHospital = 4;
                        }
                        _this.moreThenOneHospital = 0;
                    }
                }
                res.pubMeetingSpeakerLevelList = '';

                _this.addNewOrEditData = res;
            });
        });
    }
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_costCenterAndWbs__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_meetingplan_authorizedtask__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_basedata__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_StorageService__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_organizationUtil__ = __webpack_require__(52);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      applicationDetailData: [],
      searchMainData: {
        year: '',
        quarter: 'Q1',
        selectRoleId: ' '
      },
      searchData: {
        queueTaskStatus: '',
        status: [],
        departId: '',
        medicalField: '',
        teamL4: '',
        productId: '',
        city: '',
        dateRange: null,
        createDateRange: null,
        wbsCode: '',
        meetingGsdType: '',
        meetingGsdSubType: ''
      },
      mainData: {
        '预算使用进度': {},
        '3': {},
        '4': {},
        '5': {}
      },
      crudApi: __WEBPACK_IMPORTED_MODULE_4__api_meetingplan_authorizedtask__["a" /* default */],
      isEdit: false,
      applicationDetailCount: 0,
      applicationDetailAmt: 0,
      searchMainQuarters: ['Q1', 'Q2', 'Q3', 'Q4'],
      advancedSearchVisible: false,
      citiesData: [],
      remoteMeetingCodeData: [],
      remoteMeetingCreatorData: [],
      remoteMeetingOrganizerData: [],
      selectedData: [],
      approvalDailogVisible: false,
      approvalType: '',
      userRoles: [],
      costCenterArray: [],
      wbsCodeArray: [],
      inQueueNumber: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(['userInfo', 'baseDataRecords', 'basedataGetName', 'basedataGetNameByRowIdField']), {
    MeetingGsdSubTypes: function MeetingGsdSubTypes() {
      return this.baseDataRecords['MeetingGsdTypeSub' + this.searchData.meetingGsdType] || [];
    },
    canBatchSubmit: function canBatchSubmit() {
      for (var index = 0; index < this.selectedData.length; index++) {
        var element = this.selectedData[index];
        if (element.queueTaskStatus === '排队中') {
          return false;
        } else if (element.meetingWebStatus != '待审批') {
          return false;
        }
      }

      return this.selectedData.length > 0;
    },
    selectedTotalAmount: function selectedTotalAmount() {
      var amount = 0;
      this.selectedData.forEach(function (data) {
        amount += data.totalAmount;
      });

      return amount;
    },
    selectedRole: function selectedRole() {
      var _this = this;

      var roleName = '';
      this.userRoles.forEach(function (r) {
        if (r.id == _this.searchMainData.selectRoleId) {
          roleName = r.roleName;
        }
      });

      if (roleName == 'VP-1') {
        return '3';
      } else {
        return '2';
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])(['hideUnapproveCount']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapActions */])(['initBaseDataByTypes']), {
    getMedicalFieldArray: function getMedicalFieldArray(departId, independ) {
      return __WEBPACK_IMPORTED_MODULE_8__util_organizationUtil__["a" /* franchiseArray */](departId, independ);
    },
    getTeamArray: function getTeamArray(departId, medicalField, independ) {
      return __WEBPACK_IMPORTED_MODULE_8__util_organizationUtil__["c" /* teamArray */](departId, medicalField, independ);
    },
    formatDateTime2Date: function formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    formatBaseData: function formatBaseData(row, column, cellValue, index) {
      if (column.property == 'productId') {
        if (row.productId) {
          var ids = row.productId;
          if (typeof ids == 'string') {
            ids = ids.split(',');
          }
          var names = [];
          for (var pidIndex = 0; pidIndex < ids.length; pidIndex++) {
            names.push(this.basedataGetName('Product', ids[pidIndex]));
          }
          return names.join(',');
        }
        return row.prodIds;
      }
      if (column.property == 'meetingSystem') {
        if (row.meetingSystem) {
          var _ids = row.meetingSystem;
          if (typeof _ids == 'string') {
            _ids = _ids.split(',');
          }
          var _names = [];
          for (var _pidIndex = 0; _pidIndex < _ids.length; _pidIndex++) {
            _names.push(this.basedataGetName('MeetingSystem', _ids[_pidIndex]));
          }
          return _names.join(',');
        }
        return row.prodIds;
      }

      return this.basedataGetNameByRowIdField(column.property, row);
    },
    indexMethod: function indexMethod(index) {
      return this.$refs['crud'].indexMethod(index);
    },
    handleSearch: function handleSearch() {
      //查询时不传dateRange，查询后重新赋值，用于界面查看
      var tempDateRange = this.searchData.dateRange;
      if (this.searchData.dateRange && this.searchData.dateRange.length == 2) {
        this.searchData.meetingBeginDate = moment(this.searchData.dateRange[0]).format('YYYY-MM-DD HH:mm:ss');
        this.searchData.meetingEndDate = moment(this.searchData.dateRange[1]).format('YYYY-MM-DD HH:mm:ss');
        this.searchData.dateRange = null;
      } else {
        this.searchData.meetingBeginDate = '';
        this.searchData.meetingEndDate = '';
        this.searchData.dateRange = null;
      }
      //查询时不传dateRange，查询后重新赋值，用于界面查看
      var tempCreateDateRange = this.searchData.createDateRange;
      if (this.searchData.createDateRange && this.searchData.createDateRange.length == 2) {
        this.searchData.createBeginDate = moment(this.searchData.createDateRange[0]).format('YYYY-MM-DD HH:mm:ss');
        this.searchData.createEndDate = moment(this.searchData.createDateRange[1]).format('YYYY-MM-DD HH:mm:ss');
        this.searchData.createDateRange = null;
      } else {
        this.searchData.createBeginDate = '';
        this.searchData.createEndDate = '';
        this.searchData.createDateRange = null;
      }

      this.searchData.year = this.searchMainData.year;
      this.searchData.season = this.searchMainData.season;
      this.searchData.selectRoleId = this.searchMainData.selectRoleId;

      __WEBPACK_IMPORTED_MODULE_7__util_StorageService__["d" /* setItem */](__WEBPACK_IMPORTED_MODULE_7__util_StorageService__["b" /* keys */].MyAuthorizedTaskSearchDetailData, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.searchData));

      var statusAll = false;
      if (this.searchData.status.length == 0) {
        statusAll = true;

        this.searchData.status = this.baseDataRecords.MyTaskStatus.map(function (s) {
          return s.value;
        });
      }

      this.$refs['crud'].handleSearch(1);
      this.advancedSearchVisible = false;
      this.searchData.dateRange = tempDateRange;
      this.searchData.createDateRange = tempCreateDateRange;
      if (statusAll) {
        this.searchData.status = '';
      }
    },
    handleResetSearchCondition: function handleResetSearchCondition() {
      this.$refs['crud'].resetObject(this.searchData);
      this.searchData.minModelScore = undefined;
      this.searchData.maxModelScore = undefined;
      this.searchData.status = ['3'];
      this.wbsCodeArray = [];
    },
    handleSearchResult: function handleSearchResult(res) {
      this.applicationDetailCount = res.rowCount;
      this.applicationDetailAmt = res.sumTotalAmt;
      this.inQueueNumber = res.watingCount;

      res.current = res.pageList.current;
      res.total = res.pageList.total;

      this.applicationDetailData = res.pageList.records;
    },
    handleViewClick: function handleViewClick(item) {
      this.$router.push({
        name: 'meetingplan-authorizedtask-view',
        params: { 'id': item.id }
      });
    },
    handleMainSearch: function handleMainSearch(quarter) {
      if (quarter) {
        this.searchMainData.quarter = quarter;
        this.searchMainData.season = quarter.replace('Q', '');
      }
      __WEBPACK_IMPORTED_MODULE_7__util_StorageService__["d" /* setItem */](__WEBPACK_IMPORTED_MODULE_7__util_StorageService__["b" /* keys */].MyAuthorizedTaskSearchMainData, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.searchMainData));
      __WEBPACK_IMPORTED_MODULE_7__util_StorageService__["d" /* setItem */](__WEBPACK_IMPORTED_MODULE_7__util_StorageService__["b" /* keys */].UserSelectedRoleInMyTask, this.searchMainData.selectRoleId);
      // authorizedtask.queryMainTask(this.searchMainData)
      //     .then(res => {
      //       this.mainData = {};
      //       res.forEach(data => {
      //         data.statusName = this.basedataGetName('MyTaskStatus',data.status == 2?3:data.status); 
      //         data.ratioNum = parseFloat(data.ratio.replace('%'));
      //         this.mainData[data.status.toString()] = data;
      //       });

      this.handleSearch();
      // })
    },
    handleAdvancedSearchClick: function handleAdvancedSearchClick() {
      this.advancedSearchVisible = true;
    },
    handleProvinceChange: function handleProvinceChange() {
      var _this2 = this;

      this.searchData.city = '';
      if (this.searchData.province) {
        __WEBPACK_IMPORTED_MODULE_5__api_basedata__["a" /* default */].listCity({ provinceId: this.searchData.province }).then(function (res) {
          _this2.citiesData = res.records;
        });
      } else {
        this.citiesData = [];
      }
    },
    handleMeetingCodeFilter: function handleMeetingCodeFilter(query) {
      var _this3 = this;

      if (!query) {
        this.remoteMeetingCodeData = [];
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__["a" /* default */].filterMeetingCode({
        'code': query,
        year: this.searchMainData.year,
        season: this.searchMainData.season
      }).then(function (res) {
        _this3.remoteMeetingCodeData = res;
      });
    },
    handleMeetingCreatorFilter: function handleMeetingCreatorFilter(query) {
      var _this4 = this;

      if (!query) {
        this.remoteMeetingCreatorData = [];
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__["a" /* default */].filterMeetingCreator({ 'name': query }).then(function (res) {
        _this4.remoteMeetingCreatorData = res;
      });
    },
    handleMeetingOrganizerFilter: function handleMeetingOrganizerFilter(query) {
      var _this5 = this;

      if (!query) {
        this.remoteMeetingOrganizerData = [];
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__["a" /* default */].filterMeetingOrganizer({ 'name': query }).then(function (res) {
        _this5.remoteMeetingOrganizerData = res;
      });
    },
    handleApprovalConfirmClick: function handleApprovalConfirmClick() {
      this.approvalType = 'confirm';
      this.approvalDailogVisible = true;
    },
    handleApprovalRejectClick: function handleApprovalRejectClick() {
      this.approvalType = 'reject';
      this.approvalDailogVisible = true;
    },
    handleApprovalConfirm: function handleApprovalConfirm(reason) {
      this.handleApproval(reason, 2);
    },
    handleApprovalReject: function handleApprovalReject(reason) {
      this.handleApproval(reason, 3);
    },
    handleApproval: function handleApproval(reason, meetStatus) {
      var _this6 = this;

      var tempIds = [];
      this.selectedData.forEach(function (meeting) {
        tempIds.push(meeting.id);
      });

      __WEBPACK_IMPORTED_MODULE_4__api_meetingplan_authorizedtask__["a" /* default */].apprvoal({
        ids: tempIds.join(','),
        year: this.searchMainData.year,
        quarter: this.searchMainData.season,
        meetStatus: meetStatus,
        remark: reason
      }).then(function (res) {
        _this6.$message.success(res.resultTxt);
        //this.$message.success(res.message);    
        //this.$message.success((meetStatus == 2)?'审批通过会议成功':'审批拒绝会议成功');
        _this6.handleSearch();
      });
    },
    handlerExportExcelClick: function handlerExportExcelClick() {
      this.$refs['crud'].handlerExportExcel('我的任务.xlsx', { meetingFrom: 0 });
    },
    handleSearchCostCenterChange: function handleSearchCostCenterChange() {
      var _this7 = this;

      this.searchData.wbsCode = '';
      this.wbsCodeArray = [];

      if (!this.searchData.costCenter) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_2__api_costCenterAndWbs__["a" /* default */].listLocalWbsCode({
        companyCode: this.userInfo.companyCode,
        costCenter: this.searchData.costCenter
      }).then(function (res) {
        _this7.wbsCodeArray = res;
      });
    }
  }),
  mounted: function mounted() {
    var _this8 = this;

    for (var key in this.userInfo.meetingAuthorizeRole) {
      if (Object.hasOwnProperty.call(this.userInfo.meetingAuthorizeRole, key)) {
        var element = this.userInfo.meetingAuthorizeRole[key];
        this.userRoles.push({
          id: key,
          roleName: element
        });
      }
    }

    var searchDetailDataTemp = __WEBPACK_IMPORTED_MODULE_7__util_StorageService__["a" /* getItem */](__WEBPACK_IMPORTED_MODULE_7__util_StorageService__["b" /* keys */].MyAuthorizedTaskSearchDetailData);
    if (searchDetailDataTemp) {
      this.searchData = JSON.parse(searchDetailDataTemp);
    } else {
      this.searchData.status = ['3'];
    }

    var searchMainDataTemp = __WEBPACK_IMPORTED_MODULE_7__util_StorageService__["a" /* getItem */](__WEBPACK_IMPORTED_MODULE_7__util_StorageService__["b" /* keys */].MyAuthorizedTaskSearchMainData);

    if (searchMainDataTemp) {
      this.searchMainData = JSON.parse(searchMainDataTemp);
    } else {
      this.searchMainData.year = new Date().getFullYear();
      this.searchMainData.quarter = 'Q' + Math.ceil((new Date().getMonth() + 1) / 3);
    }

    this.searchMainData.selectRoleId = __WEBPACK_IMPORTED_MODULE_7__util_StorageService__["a" /* getItem */](__WEBPACK_IMPORTED_MODULE_7__util_StorageService__["b" /* keys */].UserSelectedRoleInMyTask);
    var preRoleName = this.userInfo.meetingAuthorizeRole[this.searchMainData.selectRoleId];
    if (!preRoleName) {
      //该用户没有之前的角色，或该用户第一次登录
      this.searchMainData.selectRoleId = this.userRoles.length > 0 ? this.userRoles[0].id.toString() : '';
    }

    this.initBaseDataByTypes(['Year', 'MyTaskStatus', 'AoneExeStatus', 'QueueTaskStatus', 'MeetingType', 'MeetingProp', 'MeetingModality', 'MeetingSystem', 'Depart', 'MedicalField', 'TreatmentArea', 'DiseaseArea', 'Product', 'CompanyStrategy', 'Strategy', 'DomainResult', 'MeetingTimeInt', 'HospitalLevel', 'Country', 'Province', 'Office', 'SpeakerLevel', 'CostCenter', 'WbsCode', 'SysErrorTip', 'MeetingGsdType', 'MeetingGsdTypeSub1', 'MeetingGsdTypeSub2', 'MeetingGsdTypeSub3']).then(function () {
      _this8.handleMainSearch(_this8.searchMainData.quarter);

      __WEBPACK_IMPORTED_MODULE_7__util_StorageService__["d" /* setItem */](__WEBPACK_IMPORTED_MODULE_7__util_StorageService__["b" /* keys */].MyTaskActionDate, moment(new Date()).format('YYYY-MM-DD'));
      _this8.hideUnapproveCount();
    });

    __WEBPACK_IMPORTED_MODULE_2__api_costCenterAndWbs__["a" /* default */].listLocalCostCenter({ companyCode: this.userInfo.companyCode }).then(function (res) {
      _this8.costCenterArray = res;
    });
  }
});

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_meetingplan_application__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_meetingplan_authorizedtask__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            addNewOrEditData: {
                id: '',
                meetingName: '',
                meetingType: '',
                meetingGsdType: '',
                meetingGsdSubType: '',
                meetingProp: '',
                meetingModality: '',
                meetingSystem: [],
                departId: '',
                medicalField: '',
                treatmentArea: '',
                diseaseArea: '',
                productId: [],
                companyStrategy: [],
                strategyKeynote: [],
                medicalFieldResult: [],
                medicalFieldResultDes: '',
                meetingBeginDate: '',
                meetingEndDate: '',
                meetingTimeInt: '',
                country: '',
                province: '',
                city: '',
                meetingPlace: '',
                hospitalLevelId: '',
                hospitalCount: '',
                hospitalName: '',
                recipientSociety: '',
                universityStr: '',
                patientOrgStr: '',
                otherStr: '',
                offices: [],
                speakerLevel: '',
                speakerCount: '',
                attendCount: '',
                rocheCount: '',
                totalAmount: '',
                costCenter: '',
                wbsCode: '',
                a1Amount: '',
                gsdAmount: '',
                meetingOrganizer: '',
                includeSpeaker: '',
                extendData: {
                    hospitalInfos: [],
                    speakerInfos: []
                }
            },
            approvalDailogVisible: false,
            approvalType: '',
            recipientSocietyOrHospital: 1,
            moreThenOneHospital: 0,
            waitBack: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['baseDataRecords', 'basedataGetName', 'basedataGetIdByName', 'basedataGetObject']), {
        MeetingGsdSubTypes: function MeetingGsdSubTypes() {
            return 'MeetingGsdTypeSub' + this.addNewOrEditData.meetingGsdType;
        },
        meetingSystemType: function meetingSystemType() {
            //GSD、A1、All、None
            if (this.addNewOrEditData.meetingSystem.length == 0) {
                return 'None';
            }
            if (this.addNewOrEditData.meetingSystem.length == 2) {
                return 'All';
            }
            if (this.addNewOrEditData.meetingSystem.length == 1) {
                return this.basedataGetName('MeetingSystem', this.addNewOrEditData.meetingSystem);
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['initBaseDataByTypes']), {
        approvalStatusClass: function approvalStatusClass(status) {
            switch (status) {
                case '2':
                    return 'approval-submit';
                case '3':
                    return 'approval-padding';
                case '4':
                    return 'approval-comfirm';
                case '5':
                    return 'approval-reject';
                case '7':
                    return 'approval-cancle';
            }
            return '';
        },
        showHospitalName: function showHospitalName(hospitalObj) {
            return hospitalObj.hospitalCount == 1 || this.basedataGetName('MeetingType', this.addNewOrEditData.meetingType) == '科室会' || this.basedataGetName('MeetingType', this.addNewOrEditData.meetingType) == '院内会';
        },
        handleApprovalConfirmClick: function handleApprovalConfirmClick() {
            this.approvalType = 'confirm';
            this.approvalDailogVisible = true;
        },
        handleApprovalRejectClick: function handleApprovalRejectClick() {
            this.approvalType = 'reject';
            this.approvalDailogVisible = true;
        },
        handleApprovalConfirm: function handleApprovalConfirm(reason) {
            this.handleApproval(reason, 2);
        },
        handleApprovalReject: function handleApprovalReject(reason) {
            this.handleApproval(reason, 3);
        },
        handleApproval: function handleApproval(reason, meetStatus) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_2__api_meetingplan_authorizedtask__["a" /* default */].apprvoal({
                ids: this.addNewOrEditData.id,
                year: this.addNewOrEditData.year,
                quarter: this.addNewOrEditData.season,
                meetStatus: meetStatus,
                remark: reason
            }).then(function (res) {
                _this.$message.success(res.resultTxt);
                //this.$message.success((meetStatus == 2)?'审批通过会议成功':'审批拒绝会议成功');
                _this.waitBack = true;

                setTimeout(function () {
                    _this.$router.push({
                        name: 'meetingplan-authorizedtask'
                    });
                }, 3000);
            });
        },
        isOneHospital: function isOneHospital(hospitalObj) {
            return this.basedataGetName('MeetingType', this.addNewOrEditData.meetingType) == '科室会' || this.basedataGetName('MeetingType', this.addNewOrEditData.meetingType) == '院内会';
        }
    }),
    mounted: function mounted() {
        var _this2 = this;

        this.initBaseDataByTypes(['MeetingType', 'MeetingProp', 'MeetingModality', 'MeetingSystem', 'Depart', 'MedicalField', 'TreatmentArea', 'DiseaseArea', 'Product', 'CompanyStrategy', 'MeetingTimeInt', 'Country', 'Office', 'CostCenter', 'WbsCode', 'MeetingGsdType', 'MeetingGsdTypeSub1', 'MeetingGsdTypeSub2', 'MeetingGsdTypeSub3']).then(function () {
            __WEBPACK_IMPORTED_MODULE_1__api_meetingplan_application__["a" /* default */].queryById({ id: _this2.$route.params.id }).then(function (res) {
                //转换多选项
                res.companyStrategy = res.companyStrategy.split(',');
                res.medicalFieldResult = res.medicalFieldResult == null ? ''.split(',') : res.medicalFieldResult.split(',');
                res.meetingSystem = res.meetingSystem.split(',');
                res.offices = res.offices.split(',');
                res.productId = res.productId.split(',');
                res.strategyKeynote = res.strategyKeynote.split(',');

                //新需求字段初始化
                res.meetingGsdType = res.meetingGsdType || '';
                res.meetingGsdSubType = res.meetingGsdSubType || '';
                res.universityStr = res.universityStr || '';
                res.patientOrgStr = res.patientOrgStr || '';
                res.otherStr = res.otherStr || '';
                res.teamL4 = res.teamL4 || '';

                res.extendData = {
                    hospitalInfos: [],
                    speakerInfos: []
                };
                //转换医院信息
                if (res.pubMeetingHospitalLevelList.length > 0) {
                    res.hospitalLevelId = res.pubMeetingHospitalLevelList[0].hospitalLevelId;
                    res.hospitalLevelName = res.pubMeetingHospitalLevelList[0].hospitalLevelName;
                    res.hospitalCount = res.pubMeetingHospitalLevelList[0].count;
                    res.hospitalName = res.pubMeetingHospitalLevelList[0].hospitalName;
                    res.recipientSociety = res.pubMeetingHospitalLevelList[0].recipientSociety;
                }
                if (res.pubMeetingHospitalLevelList.length > 1) {
                    for (var index = 1; index < res.pubMeetingHospitalLevelList.length; index++) {
                        var element = res.pubMeetingHospitalLevelList[index];

                        res.extendData.hospitalInfos.push({
                            hospitalLevelId: element.hospitalLevelId,
                            hospitalLevelName: element.hospitalLevelName,
                            hospitalCount: element.count,
                            hospitalName: element.hospitalName,
                            recipientSociety: element.recipientSociety
                        });
                    }
                }
                res.pubMeetingHospitalLevelList = '';

                //转换讲者信息
                res.includeSpeaker = res.pubMeetingSpeakerLevelList.length > 0 ? 1 : 0;
                if (res.pubMeetingSpeakerLevelList.length > 0) {
                    res.speakerLevel = res.pubMeetingSpeakerLevelList[0].speakerLevel;
                    res.speakerLevelName = res.pubMeetingSpeakerLevelList[0].speakerLevelName;
                    res.speakerCount = res.pubMeetingSpeakerLevelList[0].count;
                }
                if (res.pubMeetingSpeakerLevelList.length > 1) {
                    for (var _index = 1; _index < res.pubMeetingSpeakerLevelList.length; _index++) {
                        var _element = res.pubMeetingSpeakerLevelList[_index];

                        res.extendData.speakerInfos.push({
                            speakerLevel: _element.speakerLevel,
                            speakerLevelName: _element.speakerLevelName,
                            speakerCount: _element.count
                        });
                    }
                }
                if (res.extendData.hospitalInfos.length > 0) {
                    _this2.recipientSocietyOrHospital = 0;
                    _this2.moreThenOneHospital = 1;
                } else {
                    if (res.hospitalId || res.hospitalCount > 0) {
                        if (res.hospitalCount > 1) {
                            _this2.recipientSocietyOrHospital = 0;
                            _this2.moreThenOneHospital = 1;
                        } else {
                            _this2.recipientSocietyOrHospital = 0;
                            _this2.moreThenOneHospital = 0;
                        }
                    } else {
                        if (res.recipientSocietyStr) {
                            _this2.recipientSocietyOrHospital = 1;
                        }
                        if (res.universityStr) {
                            _this2.recipientSocietyOrHospital = 2;
                        }
                        if (res.patientOrgStr) {
                            _this2.recipientSocietyOrHospital = 3;
                        }
                        if (res.otherStr) {
                            _this2.recipientSocietyOrHospital = 4;
                        }
                        _this2.moreThenOneHospital = 0;
                    }
                }
                res.pubMeetingSpeakerLevelList = '';

                _this2.addNewOrEditData = res;

                _this2.waitBack = res.queueTaskStatus === '排队中';
            });
        });
    }
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_costCenterAndWbs__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_meetingplan_library__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_basedata__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_StorageService__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_organizationUtil__ = __webpack_require__(52);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      applicationDetailData: [],
      searchMainData: {
        year: '',
        quarter: 'Q1'
      },
      searchData: {
        status: [],
        departId: '',
        medicalField: '',
        teamL4: '',
        productId: '',
        city: '',
        dateRange: null,
        createDateRange: null,
        wbsCode: '',
        meetingGsdType: '',
        meetingGsdSubType: '',
        budgetAmount: '季度总预算'
      },
      mainData: {
        '预算使用进度': {},
        '3': {},
        '4': {},
        '5': {}
      },
      crudApi: __WEBPACK_IMPORTED_MODULE_4__api_meetingplan_library__["a" /* default */],
      isEdit: false,
      applicationDetailCount: 0,
      applicationDetailAmt: 0,
      searchMainQuarters: ['Q1', 'Q2', 'Q3', 'Q4', 'Year'],
      advancedSearchVisible: false,
      citiesData: [],
      remoteMeetingCodeData: [],
      remoteMeetingCreatorData: [],
      remoteMeetingOrganizerData: [],
      selectedData: [],
      approvalDailogVisible: false,
      approvalType: '',
      costCenterArray: [],
      wbsCodeArray: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(['userInfo', 'baseDataRecords', 'basedataGetName', 'basedataGetNameByRowIdField']), {
    MeetingGsdSubTypes: function MeetingGsdSubTypes() {
      return this.baseDataRecords['MeetingGsdTypeSub' + this.searchData.meetingGsdType] || [];
    },
    tabTipCode: function tabTipCode() {
      var _this = this;

      var tipCode = 16; //'会议组织者
      this.userInfo.roleNames.forEach(function (r) {
        switch (r) {
          case '公司管理者':
          case '管理人员':
            tipCode = 11;
            break;
          case 'VP':
            if (tipCode > 12) {
              tipCode = 12;
            }
            break;
          case 'Compliance':
          case 'FEP Local':
          case 'Operation':
            if (tipCode > 13) {
              tipCode = 13;
            }
            break;
          case '业务部门管理员':
            if (tipCode > 14) {
              tipCode = 14;
            }
            break;
          case '直线经理':
          case 'VP-1':
          case '二级审批人':
            if (['MD', 'FH', 'DAH', 'NMAH', 'MCEH', 'HKAH'].some(function (p) {
              return p == _this.userInfo.positionTitle;
            })) {
              if (tipCode > 14) {
                tipCode = 14;
              }
            } else {
              if (tipCode > 15) {
                tipCode = 15;
              }
            }
            break;
        }
      });

      return tipCode.toString();
    },
    canBatchSubmit: function canBatchSubmit() {
      for (var index = 0; index < this.selectedData.length; index++) {
        var element = this.selectedData[index];
        if (element.meetingWebStatus != '待审批') {
          return false;
        }
      }

      return this.selectedData.length > 0;
    },
    selectedTotalAmount: function selectedTotalAmount() {
      var amount = 0;
      this.selectedData.forEach(function (data) {
        amount += data.totalAmount;
      });

      return amount;
    },
    mainRole: function mainRole() {
      var roleName = '会议组织者';
      this.userInfo.roleNames.forEach(function (r) {
        switch (r) {
          case '直线经理':
          case 'VP-1':
          case '二级审批人':
          case '业务部门管理员':
          case 'VP':
          case 'Compliance':
          case 'FEP Local':
          case 'Operation':
          case '公司管理者':
          case '管理人员':
            roleName = r;
        }
      });

      return roleName;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapActions */])(['initBaseDataByTypes']), {
    getMedicalFieldArray: function getMedicalFieldArray(departId, independ) {
      return __WEBPACK_IMPORTED_MODULE_8__util_organizationUtil__["a" /* franchiseArray */](departId, independ);
    },
    getTeamArray: function getTeamArray(departId, medicalField, independ) {
      return __WEBPACK_IMPORTED_MODULE_8__util_organizationUtil__["c" /* teamArray */](departId, medicalField, independ);
    },
    formatDateTime2Date: function formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    formatBaseData: function formatBaseData(row, column, cellValue, index) {
      if (column.property == 'productId') {
        if (row.productId) {
          var ids = row.productId;
          if (typeof ids == 'string') {
            ids = ids.split(',');
          }
          var names = [];
          for (var pidIndex = 0; pidIndex < ids.length; pidIndex++) {
            names.push(this.basedataGetName('Product', ids[pidIndex]));
          }
          return names.join(',');
        }
        return row.prodIds;
      }
      if (column.property == 'meetingSystem') {
        if (row.meetingSystem) {
          var _ids = row.meetingSystem;
          if (typeof _ids == 'string') {
            _ids = _ids.split(',');
          }
          var _names = [];
          for (var _pidIndex = 0; _pidIndex < _ids.length; _pidIndex++) {
            _names.push(this.basedataGetName('MeetingSystem', _ids[_pidIndex]));
          }
          return _names.join(',');
        }
        return row.prodIds;
      }

      return this.basedataGetNameByRowIdField(column.property, row);
    },
    indexMethod: function indexMethod(index) {
      return this.$refs['crud'].indexMethod(index);
    },
    handleSearch: function handleSearch() {
      //查询时不传dateRange，查询后重新赋值，用于界面查看
      var tempDateRange = this.searchData.dateRange;
      if (this.searchData.dateRange && this.searchData.dateRange.length == 2) {
        this.searchData.meetingBeginDate = moment(this.searchData.dateRange[0]).format('YYYY-MM-DD HH:mm:ss');
        this.searchData.meetingEndDate = moment(this.searchData.dateRange[1]).format('YYYY-MM-DD HH:mm:ss');
        this.searchData.dateRange = null;
      } else {
        this.searchData.meetingBeginDate = '';
        this.searchData.meetingEndDate = '';
        this.searchData.dateRange = null;
      }
      //查询时不传dateRange，查询后重新赋值，用于界面查看
      var tempCreateDateRange = this.searchData.createDateRange;
      if (this.searchData.createDateRange && this.searchData.createDateRange.length == 2) {
        this.searchData.createBeginDate = moment(this.searchData.createDateRange[0]).format('YYYY-MM-DD HH:mm:ss');
        this.searchData.createEndDate = moment(this.searchData.createDateRange[1]).format('YYYY-MM-DD HH:mm:ss');
        this.searchData.createDateRange = null;
      } else {
        this.searchData.createBeginDate = '';
        this.searchData.createEndDate = '';
        this.searchData.createDateRange = null;
      }

      this.searchData.year = this.searchMainData.year;
      this.searchData.season = this.searchMainData.season;

      __WEBPACK_IMPORTED_MODULE_7__util_StorageService__["d" /* setItem */](__WEBPACK_IMPORTED_MODULE_7__util_StorageService__["b" /* keys */].MyLibrarySearchDetailData, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.searchData));

      var statusAll = false;
      if (this.searchData.status.length == 0) {
        statusAll = true;

        this.searchData.status = this.baseDataRecords.MyLibraryStatus.map(function (s) {
          return s.value;
        });
      }

      this.$refs['crud'].handleSearch(1);
      this.advancedSearchVisible = false;
      this.searchData.dateRange = tempDateRange;
      this.searchData.createDateRange = tempCreateDateRange;
      if (statusAll) {
        this.searchData.status = '';
      }
    },
    handleResetSearchCondition: function handleResetSearchCondition() {
      this.$refs['crud'].resetObject(this.searchData);
      this.searchData.minModelScore = undefined;
      this.searchData.maxModelScore = undefined;
      this.searchData.status = ['3'];
      this.wbsCodeArray = [];
    },
    handleSearchResult: function handleSearchResult(res) {
      this.applicationDetailCount = res.rowCount;
      this.applicationDetailAmt = res.sumTotalAmt;

      res.current = res.pageList.current;
      res.total = res.pageList.total;

      this.applicationDetailData = res.pageList.records;
    },
    handleViewClick: function handleViewClick(item) {
      this.$router.push({
        name: 'meetingplan-library-view',
        params: {
          'id': item.id
        }
      });
    },
    handleMainSearch: function handleMainSearch(quarter) {
      var _this2 = this;

      if (quarter) {
        this.searchMainData.quarter = quarter;
        if (quarter == 'Year') {
          this.searchMainData.season = 0;
          this.budgetAmount = '年度总预算';
        } else {
          this.searchMainData.season = quarter.replace('Q', '');
          this.budgetAmount = '季度总预算';
        }
      }
      __WEBPACK_IMPORTED_MODULE_7__util_StorageService__["d" /* setItem */](__WEBPACK_IMPORTED_MODULE_7__util_StorageService__["b" /* keys */].MyLibrarySearchMainData, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.searchMainData));
      __WEBPACK_IMPORTED_MODULE_4__api_meetingplan_library__["a" /* default */].queryMainApplication(this.searchMainData).then(function (res) {
        _this2.mainData = {};
        res.forEach(function (data) {
          data.statusName = _this2.basedataGetName('MyLibraryStatus', data.status);
          data.ratioNum = parseFloat(data.ratio.replace('%'));
          _this2.mainData[data.status.toString()] = data;
        });

        _this2.handleSearch();
      });
    },
    handleAdvancedSearchClick: function handleAdvancedSearchClick() {
      this.advancedSearchVisible = true;
    },
    handleProvinceChange: function handleProvinceChange() {
      var _this3 = this;

      this.searchData.city = '';
      if (this.searchData.province) {
        __WEBPACK_IMPORTED_MODULE_5__api_basedata__["a" /* default */].listCity({ provinceId: this.searchData.province }).then(function (res) {
          _this3.citiesData = res.records;
        });
      } else {
        this.citiesData = [];
      }
    },
    handleMeetingCodeFilter: function handleMeetingCodeFilter(query) {
      var _this4 = this;

      if (!query) {
        this.remoteMeetingCodeData = [];
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__["a" /* default */].filterMeetingCode({
        'code': query,
        year: this.searchMainData.year,
        season: this.searchMainData.season
      }).then(function (res) {
        _this4.remoteMeetingCodeData = res;
      });
    },
    handleMeetingCreatorFilter: function handleMeetingCreatorFilter(query) {
      var _this5 = this;

      if (!query) {
        this.remoteMeetingCreatorData = [];
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__["a" /* default */].filterMeetingCreator({ 'name': query }).then(function (res) {
        _this5.remoteMeetingCreatorData = res;
      });
    },
    handleMeetingOrganizerFilter: function handleMeetingOrganizerFilter(query) {
      var _this6 = this;

      if (!query) {
        this.remoteMeetingOrganizerData = [];
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__["a" /* default */].filterMeetingOrganizer({ 'name': query }).then(function (res) {
        _this6.remoteMeetingOrganizerData = res;
      });
    },
    handleApprovalConfirmClick: function handleApprovalConfirmClick() {
      this.approvalType = 'confirm';
      this.approvalDailogVisible = true;
    },
    handleApprovalRejectClick: function handleApprovalRejectClick() {
      this.approvalType = 'reject';
      this.approvalDailogVisible = true;
    },
    handleApprovalConfirm: function handleApprovalConfirm(reason) {
      this.handleApproval(reason, 2);
    },
    handleApprovalReject: function handleApprovalReject(reason) {
      this.handleApproval(reason, 3);
    },
    handleApproval: function handleApproval(reason, meetStatus) {
      var _this7 = this;

      var tempIds = [];
      this.selectedData.forEach(function (meeting) {
        tempIds.push(meeting.id);
      });

      task.apprvoal({
        ids: tempIds.join(','),
        year: this.searchMainData.year,
        quarter: this.searchMainData.season,
        meetStatus: meetStatus,
        remark: reason
      }).then(function (res) {
        _this7.$message.success(res.resultTxt);
        //this.$message.success((meetStatus == 2)?'审批通过会议成功':'审批拒绝会议成功');
        _this7.handleSearch();
      });
    },
    handlerExportExcelClick: function handlerExportExcelClick() {
      this.$refs['crud'].handlerExportExcel('我的计划.xlsx', { meetingFrom: 0 });
    },
    handleSearchCostCenterChange: function handleSearchCostCenterChange() {
      var _this8 = this;

      this.searchData.wbsCode = '';
      this.wbsCodeArray = [];

      if (!this.searchData.costCenter) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_2__api_costCenterAndWbs__["a" /* default */].listLocalWbsCode({
        companyCode: this.userInfo.companyCode,
        costCenter: this.searchData.costCenter
      }).then(function (res) {
        _this8.wbsCodeArray = res;
      });
    }
  }),
  mounted: function mounted() {
    var _this9 = this;

    var searchDetailDataTemp = __WEBPACK_IMPORTED_MODULE_7__util_StorageService__["a" /* getItem */](__WEBPACK_IMPORTED_MODULE_7__util_StorageService__["b" /* keys */].MyLibrarySearchDetailData);
    if (searchDetailDataTemp) {
      this.searchData = JSON.parse(searchDetailDataTemp);
    } else {
      this.searchData.status = ['3'];
    }

    var searchMainDataTemp = __WEBPACK_IMPORTED_MODULE_7__util_StorageService__["a" /* getItem */](__WEBPACK_IMPORTED_MODULE_7__util_StorageService__["b" /* keys */].MyLibrarySearchMainData);

    if (searchMainDataTemp) {
      this.searchMainData = JSON.parse(searchMainDataTemp);
    } else {
      this.searchMainData.year = new Date().getFullYear();
      this.searchMainData.quarter = 'Q' + Math.ceil((new Date().getMonth() + 1) / 3);
    }

    this.initBaseDataByTypes(['Year', 'MyLibraryStatus', 'AoneExeStatus', 'MeetingType', 'MeetingProp', 'MeetingModality', 'MeetingSystem', 'Depart', 'MedicalField', 'TreatmentArea', 'DiseaseArea', 'Product', 'CompanyStrategy', 'Strategy', 'DomainResult', 'MeetingTimeInt', 'HospitalLevel', 'Country', 'Province', 'Office', 'SpeakerLevel', 'CostCenter', 'WbsCode', 'SysErrorTip', 'MeetingGsdType', 'MeetingGsdTypeSub1', 'MeetingGsdTypeSub2', 'MeetingGsdTypeSub3']).then(function () {
      _this9.handleMainSearch(_this9.searchMainData.quarter);
    });

    __WEBPACK_IMPORTED_MODULE_2__api_costCenterAndWbs__["a" /* default */].listLocalCostCenter({ companyCode: this.userInfo.companyCode }).then(function (res) {
      _this9.costCenterArray = res;
    });
  }
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_meetingplan_application__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            addNewOrEditData: {
                meetingName: '',
                meetingType: '',
                meetingGsdType: '',
                meetingGsdSubType: '',
                meetingProp: '',
                meetingModality: '',
                meetingSystem: [],
                departId: '',
                medicalField: '',
                treatmentArea: '',
                diseaseArea: '',
                productId: [],
                companyStrategy: [],
                strategyKeynote: [],
                medicalFieldResult: [],
                medicalFieldResultDes: '',
                meetingBeginDate: '',
                meetingEndDate: '',
                meetingTimeInt: '',
                country: '',
                province: '',
                city: '',
                meetingPlace: '',
                hospitalLevelId: '',
                hospitalCount: '',
                hospitalName: '',
                recipientSociety: '',
                universityStr: '',
                patientOrgStr: '',
                otherStr: '',
                offices: [],
                speakerLevel: '',
                speakerCount: '',
                attendCount: '',
                rocheCount: '',
                totalAmount: '',
                costCenter: '',
                wbsCode: '',
                a1Amount: '',
                gsdAmount: '',
                meetingOrganizer: '',
                includeSpeaker: '',
                extendData: {
                    hospitalInfos: [],
                    speakerInfos: []
                }
            },
            confirmChangeVisible: false,
            confirmCancleVisible: false,
            recipientSocietyOrHospital: 1,
            moreThenOneHospital: 0
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['baseDataRecords', 'basedataGetName', 'basedataGetIdByName', 'basedataGetObject']), {
        MeetingGsdSubTypes: function MeetingGsdSubTypes() {
            return 'MeetingGsdTypeSub' + this.addNewOrEditData.meetingGsdType;
        },
        meetingSystemType: function meetingSystemType() {
            //GSD、A1、All、None
            if (this.addNewOrEditData.meetingSystem.length == 0) {
                return 'None';
            }
            if (this.addNewOrEditData.meetingSystem.length == 2) {
                return 'All';
            }
            if (this.addNewOrEditData.meetingSystem.length == 1) {
                return this.basedataGetName('MeetingSystem', this.addNewOrEditData.meetingSystem);
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['initBaseDataByTypes']), {
        approvalStatusClass: function approvalStatusClass(status) {
            switch (status) {
                case '2':
                    return 'approval-submit';
                case '3':
                    return 'approval-padding';
                case '4':
                    return 'approval-comfirm';
                case '5':
                    return 'approval-reject';
                case '7':
                    return 'approval-cancle';
            }
            return '';
        },
        showHospitalName: function showHospitalName(hospitalObj) {
            return hospitalObj.hospitalCount == 1 || this.basedataGetName('MeetingType', this.addNewOrEditData.meetingType) == '科室会' || this.basedataGetName('MeetingType', this.addNewOrEditData.meetingType) == '院内会';
        },
        handleCancleClick: function handleCancleClick() {
            this.confirmCancleVisible = true;
        },
        handlerCancleConfirmOK: function handlerCancleConfirmOK() {
            __WEBPACK_IMPORTED_MODULE_1__api_meetingplan_application__["a" /* default */].cancle({ id: this.addNewOrEditData.id }).then(function (res) {
                history.back();
            });
        },
        handlerChangeClick: function handlerChangeClick() {
            this.confirmChangeVisible = true;
        },
        handlerChangeConfirmOK: function handlerChangeConfirmOK() {
            this.$router.push({
                name: 'meetingplan-application-change',
                params: { 'id': this.addNewOrEditData.id }
            });
        },
        isOneHospital: function isOneHospital(hospitalObj) {
            return this.basedataGetName('MeetingType', this.addNewOrEditData.meetingType) == '科室会' || this.basedataGetName('MeetingType', this.addNewOrEditData.meetingType) == '院内会';
        }
    }),
    mounted: function mounted() {
        var _this = this;

        this.initBaseDataByTypes(['MeetingType', 'MeetingProp', 'MeetingModality', 'MeetingSystem', 'Depart', 'MedicalField', 'TreatmentArea', 'DiseaseArea', 'Product', 'CompanyStrategy', 'MeetingTimeInt', 'Country', 'Office', 'CostCenter', 'WbsCode', 'MeetingGsdType', 'MeetingGsdTypeSub1', 'MeetingGsdTypeSub2', 'MeetingGsdTypeSub3']).then(function () {
            __WEBPACK_IMPORTED_MODULE_1__api_meetingplan_application__["a" /* default */].queryById({ id: _this.$route.params.id }).then(function (res) {
                //转换多选项
                res.companyStrategy = res.companyStrategy.split(',');
                res.medicalFieldResult = res.medicalFieldResult == null ? ''.split(',') : res.medicalFieldResult.split(',');
                res.meetingSystem = res.meetingSystem.split(',');
                res.offices = res.offices.split(',');
                res.productId = res.productId.split(',');
                res.strategyKeynote = res.strategyKeynote.split(',');

                //新需求字段初始化
                res.meetingGsdType = res.meetingGsdType || '';
                res.meetingGsdSubType = res.meetingGsdSubType || '';
                res.universityStr = res.universityStr || '';
                res.patientOrgStr = res.patientOrgStr || '';
                res.otherStr = res.otherStr || '';
                res.teamL4 = res.teamL4 || '';

                res.extendData = {
                    hospitalInfos: [],
                    speakerInfos: []
                };
                //转换医院信息
                if (res.pubMeetingHospitalLevelList.length > 0) {
                    res.hospitalLevelId = res.pubMeetingHospitalLevelList[0].hospitalLevelId;
                    res.hospitalLevelName = res.pubMeetingHospitalLevelList[0].hospitalLevelName;
                    res.hospitalCount = res.pubMeetingHospitalLevelList[0].count;
                    res.hospitalName = res.pubMeetingHospitalLevelList[0].hospitalName;
                    res.recipientSociety = res.pubMeetingHospitalLevelList[0].recipientSociety;
                }
                if (res.pubMeetingHospitalLevelList.length > 1) {
                    for (var index = 1; index < res.pubMeetingHospitalLevelList.length; index++) {
                        var element = res.pubMeetingHospitalLevelList[index];

                        res.extendData.hospitalInfos.push({
                            hospitalLevelId: element.hospitalLevelId,
                            hospitalLevelName: element.hospitalLevelName,
                            hospitalCount: element.count,
                            hospitalName: element.hospitalName,
                            recipientSociety: element.recipientSociety
                        });
                    }
                }
                res.pubMeetingHospitalLevelList = '';

                //转换讲者信息
                res.includeSpeaker = res.pubMeetingSpeakerLevelList.length > 0 ? 1 : 0;
                if (res.pubMeetingSpeakerLevelList.length > 0) {
                    res.speakerLevel = res.pubMeetingSpeakerLevelList[0].speakerLevel;
                    res.speakerLevelName = res.pubMeetingSpeakerLevelList[0].speakerLevelName;
                    res.speakerCount = res.pubMeetingSpeakerLevelList[0].count;
                }
                if (res.pubMeetingSpeakerLevelList.length > 1) {
                    for (var _index = 1; _index < res.pubMeetingSpeakerLevelList.length; _index++) {
                        var _element = res.pubMeetingSpeakerLevelList[_index];

                        res.extendData.speakerInfos.push({
                            speakerLevel: _element.speakerLevel,
                            speakerLevelName: _element.speakerLevelName,
                            speakerCount: _element.count
                        });
                    }
                }
                if (res.extendData.hospitalInfos.length > 0) {
                    _this.recipientSocietyOrHospital = 0;
                    _this.moreThenOneHospital = 1;
                } else {
                    if (res.hospitalId || res.hospitalCount > 0) {
                        if (res.hospitalCount > 1) {
                            _this.recipientSocietyOrHospital = 0;
                            _this.moreThenOneHospital = 1;
                        } else {
                            _this.recipientSocietyOrHospital = 0;
                            _this.moreThenOneHospital = 0;
                        }
                    } else {
                        if (res.recipientSocietyStr) {
                            _this.recipientSocietyOrHospital = 1;
                        }
                        if (res.universityStr) {
                            _this.recipientSocietyOrHospital = 2;
                        }
                        if (res.patientOrgStr) {
                            _this.recipientSocietyOrHospital = 3;
                        }
                        if (res.otherStr) {
                            _this.recipientSocietyOrHospital = 4;
                        }
                        _this.moreThenOneHospital = 0;
                    }
                }
                res.pubMeetingSpeakerLevelList = '';

                _this.addNewOrEditData = res;
            });
        });
    }
});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_costCenterAndWbs__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_meetingplan_task__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_basedata__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_StorageService__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_organizationUtil__ = __webpack_require__(52);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      applicationDetailData: [],
      searchMainData: {
        year: '',
        quarter: 'Q1',
        selectRoleId: ' '
      },
      searchData: {
        queueTaskStatus: '',
        status: [],
        departId: '',
        medicalField: '',
        teamL4: '',
        productId: '',
        city: '',
        dateRange: null,
        createDateRange: null,
        wbsCode: '',
        meetingGsdType: '',
        meetingGsdSubType: ''
      },
      mainData: {
        '预算使用进度': {},
        '3': {},
        '4': {},
        '5': {}
      },
      crudApi: __WEBPACK_IMPORTED_MODULE_4__api_meetingplan_task__["a" /* default */],
      isEdit: false,
      applicationDetailCount: 0,
      applicationDetailAmt: 0,
      searchMainQuarters: ['Q1', 'Q2', 'Q3', 'Q4'],
      advancedSearchVisible: false,
      citiesData: [],
      remoteMeetingCodeData: [],
      remoteMeetingCreatorData: [],
      remoteMeetingOrganizerData: [],
      selectedData: [],
      approvalDailogVisible: false,
      approvalType: '',
      userRoles: [],
      costCenterArray: [],
      wbsCodeArray: [],
      inQueueNumber: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(['userInfo', 'baseDataRecords', 'basedataGetName', 'basedataGetNameByRowIdField']), {
    MeetingGsdSubTypes: function MeetingGsdSubTypes() {
      return this.baseDataRecords['MeetingGsdTypeSub' + this.searchData.meetingGsdType] || [];
    },
    canBatchSubmit: function canBatchSubmit() {
      for (var index = 0; index < this.selectedData.length; index++) {
        var element = this.selectedData[index];
        if (element.queueTaskStatus === '排队中') {
          return false;
        } else if (element.meetingWebStatus != '待审批') {
          return false;
        }
      }

      return this.selectedData.length > 0;
    },
    selectedTotalAmount: function selectedTotalAmount() {
      var amount = 0;
      this.selectedData.forEach(function (data) {
        amount += data.totalAmount;
      });

      return amount;
    },
    selectedRole: function selectedRole() {
      var _this = this;

      var roleName = '';
      this.userRoles.forEach(function (r) {
        if (r.id == _this.searchMainData.selectRoleId) {
          roleName = r.roleName;
        }
      });

      if (roleName == 'VP-1') {
        return '3';
      } else {
        return '2';
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])(['hideUnapproveCount']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapActions */])(['initBaseDataByTypes']), {
    getMedicalFieldArray: function getMedicalFieldArray(departId, independ) {
      return __WEBPACK_IMPORTED_MODULE_8__util_organizationUtil__["a" /* franchiseArray */](departId, independ);
    },
    getTeamArray: function getTeamArray(departId, medicalField, independ) {
      return __WEBPACK_IMPORTED_MODULE_8__util_organizationUtil__["c" /* teamArray */](departId, medicalField, independ);
    },
    formatDateTime2Date: function formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    formatBaseData: function formatBaseData(row, column, cellValue, index) {
      if (column.property == 'productId') {
        if (row.productId) {
          var ids = row.productId;
          if (typeof ids == 'string') {
            ids = ids.split(',');
          }
          var names = [];
          for (var pidIndex = 0; pidIndex < ids.length; pidIndex++) {
            names.push(this.basedataGetName('Product', ids[pidIndex]));
          }
          return names.join(',');
        }
        return row.prodIds;
      }
      if (column.property == 'meetingSystem') {
        if (row.meetingSystem) {
          var _ids = row.meetingSystem;
          if (typeof _ids == 'string') {
            _ids = _ids.split(',');
          }
          var _names = [];
          for (var _pidIndex = 0; _pidIndex < _ids.length; _pidIndex++) {
            _names.push(this.basedataGetName('MeetingSystem', _ids[_pidIndex]));
          }
          return _names.join(',');
        }
        return row.prodIds;
      }

      return this.basedataGetNameByRowIdField(column.property, row);
    },
    indexMethod: function indexMethod(index) {
      return this.$refs['crud'].indexMethod(index);
    },
    handleSearch: function handleSearch() {
      //查询时不传dateRange，查询后重新赋值，用于界面查看
      var tempDateRange = this.searchData.dateRange;
      if (this.searchData.dateRange && this.searchData.dateRange.length == 2) {
        this.searchData.meetingBeginDate = moment(this.searchData.dateRange[0]).format('YYYY-MM-DD HH:mm:ss');
        this.searchData.meetingEndDate = moment(this.searchData.dateRange[1]).format('YYYY-MM-DD HH:mm:ss');
        this.searchData.dateRange = null;
      } else {
        this.searchData.meetingBeginDate = '';
        this.searchData.meetingEndDate = '';
        this.searchData.dateRange = null;
      }
      //查询时不传dateRange，查询后重新赋值，用于界面查看
      var tempCreateDateRange = this.searchData.createDateRange;
      if (this.searchData.createDateRange && this.searchData.createDateRange.length == 2) {
        this.searchData.createBeginDate = moment(this.searchData.createDateRange[0]).format('YYYY-MM-DD HH:mm:ss');
        this.searchData.createEndDate = moment(this.searchData.createDateRange[1]).format('YYYY-MM-DD HH:mm:ss');
        this.searchData.createDateRange = null;
      } else {
        this.searchData.createBeginDate = '';
        this.searchData.createEndDate = '';
        this.searchData.createDateRange = null;
      }

      this.searchData.year = this.searchMainData.year;
      this.searchData.season = this.searchMainData.season;
      this.searchData.selectRoleId = this.searchMainData.selectRoleId;

      __WEBPACK_IMPORTED_MODULE_7__util_StorageService__["d" /* setItem */](__WEBPACK_IMPORTED_MODULE_7__util_StorageService__["b" /* keys */].MyTaskSearchDetailData, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.searchData));

      var statusAll = false;
      if (this.searchData.status.length == 0) {
        statusAll = true;

        this.searchData.status = this.baseDataRecords.MyTaskStatus.map(function (s) {
          return s.value;
        });
      }

      this.$refs['crud'].handleSearch(1);
      this.advancedSearchVisible = false;
      this.searchData.dateRange = tempDateRange;
      this.searchData.createDateRange = tempCreateDateRange;
      if (statusAll) {
        this.searchData.status = '';
      }
    },
    handleResetSearchCondition: function handleResetSearchCondition() {
      this.$refs['crud'].resetObject(this.searchData);
      this.searchData.minModelScore = undefined;
      this.searchData.maxModelScore = undefined;
      this.searchData.status = ['3'];
      this.wbsCodeArray = [];
    },
    handleSearchResult: function handleSearchResult(res) {
      this.applicationDetailCount = res.rowCount;
      this.applicationDetailAmt = res.sumTotalAmt;
      this.inQueueNumber = res.watingCount;

      res.current = res.pageList.current;
      res.total = res.pageList.total;

      this.applicationDetailData = res.pageList.records;
    },
    handleViewClick: function handleViewClick(item) {
      this.$router.push({
        name: 'meetingplan-task-view',
        params: { 'id': item.id }
      });
    },
    handleMainSearch: function handleMainSearch(quarter) {
      var _this2 = this;

      if (quarter) {
        this.searchMainData.quarter = quarter;
        this.searchMainData.season = quarter.replace('Q', '');
      }
      __WEBPACK_IMPORTED_MODULE_7__util_StorageService__["d" /* setItem */](__WEBPACK_IMPORTED_MODULE_7__util_StorageService__["b" /* keys */].MyTaskSearchMainData, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.searchMainData));
      __WEBPACK_IMPORTED_MODULE_7__util_StorageService__["d" /* setItem */](__WEBPACK_IMPORTED_MODULE_7__util_StorageService__["b" /* keys */].UserSelectedRoleInMyTask, this.searchMainData.selectRoleId);
      __WEBPACK_IMPORTED_MODULE_4__api_meetingplan_task__["a" /* default */].queryMainTask(this.searchMainData).then(function (res) {
        _this2.mainData = {};
        res.forEach(function (data) {
          data.statusName = _this2.basedataGetName('MyTaskStatus', data.status == 2 ? 3 : data.status);
          data.ratioNum = parseFloat(data.ratio.replace('%'));
          _this2.mainData[data.status.toString()] = data;
        });

        _this2.handleSearch();
      });
    },
    handleAdvancedSearchClick: function handleAdvancedSearchClick() {
      this.advancedSearchVisible = true;
    },
    handleProvinceChange: function handleProvinceChange() {
      var _this3 = this;

      this.searchData.city = '';
      if (this.searchData.province) {
        __WEBPACK_IMPORTED_MODULE_5__api_basedata__["a" /* default */].listCity({ provinceId: this.searchData.province }).then(function (res) {
          _this3.citiesData = res.records;
        });
      } else {
        this.citiesData = [];
      }
    },
    handleMeetingCodeFilter: function handleMeetingCodeFilter(query) {
      var _this4 = this;

      if (!query) {
        this.remoteMeetingCodeData = [];
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__["a" /* default */].filterMeetingCode({
        'code': query,
        year: this.searchMainData.year,
        season: this.searchMainData.season
      }).then(function (res) {
        _this4.remoteMeetingCodeData = res;
      });
    },
    handleMeetingCreatorFilter: function handleMeetingCreatorFilter(query) {
      var _this5 = this;

      if (!query) {
        this.remoteMeetingCreatorData = [];
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__["a" /* default */].filterMeetingCreator({ 'name': query }).then(function (res) {
        _this5.remoteMeetingCreatorData = res;
      });
    },
    handleMeetingOrganizerFilter: function handleMeetingOrganizerFilter(query) {
      var _this6 = this;

      if (!query) {
        this.remoteMeetingOrganizerData = [];
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3__api_meetingplan_application__["a" /* default */].filterMeetingOrganizer({ 'name': query }).then(function (res) {
        _this6.remoteMeetingOrganizerData = res;
      });
    },
    handleApprovalConfirmClick: function handleApprovalConfirmClick() {
      this.approvalType = 'confirm';
      this.approvalDailogVisible = true;
    },
    handleApprovalRejectClick: function handleApprovalRejectClick() {
      this.approvalType = 'reject';
      this.approvalDailogVisible = true;
    },
    handleApprovalConfirm: function handleApprovalConfirm(reason) {
      this.handleApproval(reason, 2);
    },
    handleApprovalReject: function handleApprovalReject(reason) {
      this.handleApproval(reason, 3);
    },
    handleApproval: function handleApproval(reason, meetStatus) {
      var _this7 = this;

      var tempIds = [];
      this.selectedData.forEach(function (meeting) {
        tempIds.push(meeting.id);
      });

      __WEBPACK_IMPORTED_MODULE_4__api_meetingplan_task__["a" /* default */].apprvoal({
        ids: tempIds.join(','),
        year: this.searchMainData.year,
        quarter: this.searchMainData.season,
        meetStatus: meetStatus,
        remark: reason
      }).then(function (res) {
        _this7.$message.success(res.resultTxt);
        //this.$message.success(res.message);    
        //this.$message.success((meetStatus == 2)?'审批通过会议成功':'审批拒绝会议成功');
        _this7.handleSearch();
      });
    },
    handlerExportExcelClick: function handlerExportExcelClick() {
      this.$refs['crud'].handlerExportExcel('我的任务.xlsx', { meetingFrom: 0 });
    },
    handleSearchCostCenterChange: function handleSearchCostCenterChange() {
      var _this8 = this;

      this.searchData.wbsCode = '';
      this.wbsCodeArray = [];

      if (!this.searchData.costCenter) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_2__api_costCenterAndWbs__["a" /* default */].listLocalWbsCode({
        companyCode: this.userInfo.companyCode,
        costCenter: this.searchData.costCenter
      }).then(function (res) {
        _this8.wbsCodeArray = res;
      });
    }
  }),
  mounted: function mounted() {
    var _this9 = this;

    for (var key in this.userInfo.meetingApproveRole) {
      if (Object.hasOwnProperty.call(this.userInfo.meetingApproveRole, key)) {
        var element = this.userInfo.meetingApproveRole[key];
        this.userRoles.push({
          id: key,
          roleName: element
        });
      }
    }

    var searchDetailDataTemp = __WEBPACK_IMPORTED_MODULE_7__util_StorageService__["a" /* getItem */](__WEBPACK_IMPORTED_MODULE_7__util_StorageService__["b" /* keys */].MyTaskSearchDetailData);
    if (searchDetailDataTemp) {
      this.searchData = JSON.parse(searchDetailDataTemp);
    } else {
      this.searchData.status = ['3'];
    }

    var searchMainDataTemp = __WEBPACK_IMPORTED_MODULE_7__util_StorageService__["a" /* getItem */](__WEBPACK_IMPORTED_MODULE_7__util_StorageService__["b" /* keys */].MyTaskSearchMainData);

    if (searchMainDataTemp) {
      this.searchMainData = JSON.parse(searchMainDataTemp);
    } else {
      this.searchMainData.year = new Date().getFullYear();
      this.searchMainData.quarter = 'Q' + Math.ceil((new Date().getMonth() + 1) / 3);
    }

    this.searchMainData.selectRoleId = __WEBPACK_IMPORTED_MODULE_7__util_StorageService__["a" /* getItem */](__WEBPACK_IMPORTED_MODULE_7__util_StorageService__["b" /* keys */].UserSelectedRoleInMyTask);
    var preRoleName = this.userInfo.meetingApproveRole[this.searchMainData.selectRoleId];
    if (!preRoleName) {
      //该用户没有之前的角色，或该用户第一次登录
      this.searchMainData.selectRoleId = this.userRoles.length > 0 ? this.userRoles[0].id.toString() : '';
    }

    this.initBaseDataByTypes(['Year', 'MyTaskStatus', 'AoneExeStatus', 'QueueTaskStatus', 'MeetingType', 'MeetingProp', 'MeetingModality', 'MeetingSystem', 'Depart', 'MedicalField', 'TreatmentArea', 'DiseaseArea', 'Product', 'CompanyStrategy', 'Strategy', 'DomainResult', 'MeetingTimeInt', 'HospitalLevel', 'Country', 'Province', 'Office', 'SpeakerLevel', 'CostCenter', 'WbsCode', 'SysErrorTip', 'MeetingGsdType', 'MeetingGsdTypeSub1', 'MeetingGsdTypeSub2', 'MeetingGsdTypeSub3']).then(function () {
      _this9.handleMainSearch(_this9.searchMainData.quarter);

      __WEBPACK_IMPORTED_MODULE_7__util_StorageService__["d" /* setItem */](__WEBPACK_IMPORTED_MODULE_7__util_StorageService__["b" /* keys */].MyTaskActionDate, moment(new Date()).format('YYYY-MM-DD'));
      _this9.hideUnapproveCount();
    });

    __WEBPACK_IMPORTED_MODULE_2__api_costCenterAndWbs__["a" /* default */].listLocalCostCenter({ companyCode: this.userInfo.companyCode }).then(function (res) {
      _this9.costCenterArray = res;
    });
  }
});

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_meetingplan_application__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_meetingplan_task__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            addNewOrEditData: {
                id: '',
                meetingName: '',
                meetingType: '',
                meetingGsdType: '',
                meetingGsdSubType: '',
                meetingProp: '',
                meetingModality: '',
                meetingSystem: [],
                departId: '',
                medicalField: '',
                treatmentArea: '',
                diseaseArea: '',
                productId: [],
                companyStrategy: [],
                strategyKeynote: [],
                medicalFieldResult: [],
                medicalFieldResultDes: '',
                meetingBeginDate: '',
                meetingEndDate: '',
                meetingTimeInt: '',
                country: '',
                province: '',
                city: '',
                meetingPlace: '',
                hospitalLevelId: '',
                hospitalCount: '',
                hospitalName: '',
                recipientSociety: '',
                universityStr: '',
                patientOrgStr: '',
                otherStr: '',
                offices: [],
                speakerLevel: '',
                speakerCount: '',
                attendCount: '',
                rocheCount: '',
                totalAmount: '',
                costCenter: '',
                wbsCode: '',
                a1Amount: '',
                gsdAmount: '',
                meetingOrganizer: '',
                includeSpeaker: '',
                extendData: {
                    hospitalInfos: [],
                    speakerInfos: []
                }
            },
            approvalDailogVisible: false,
            approvalType: '',
            recipientSocietyOrHospital: 1,
            moreThenOneHospital: 0,
            waitBack: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['baseDataRecords', 'basedataGetName', 'basedataGetIdByName', 'basedataGetObject']), {
        MeetingGsdSubTypes: function MeetingGsdSubTypes() {
            return 'MeetingGsdTypeSub' + this.addNewOrEditData.meetingGsdType;
        },
        meetingSystemType: function meetingSystemType() {
            //GSD、A1、All、None
            if (this.addNewOrEditData.meetingSystem.length == 0) {
                return 'None';
            }
            if (this.addNewOrEditData.meetingSystem.length == 2) {
                return 'All';
            }
            if (this.addNewOrEditData.meetingSystem.length == 1) {
                return this.basedataGetName('MeetingSystem', this.addNewOrEditData.meetingSystem);
            }
        }
    }),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['initBaseDataByTypes']), {
        approvalStatusClass: function approvalStatusClass(status) {
            switch (status) {
                case '2':
                    return 'approval-submit';
                case '3':
                    return 'approval-padding';
                case '4':
                    return 'approval-comfirm';
                case '5':
                    return 'approval-reject';
                case '7':
                    return 'approval-cancle';
            }
            return '';
        },
        showHospitalName: function showHospitalName(hospitalObj) {
            return hospitalObj.hospitalCount == 1 || this.basedataGetName('MeetingType', this.addNewOrEditData.meetingType) == '科室会' || this.basedataGetName('MeetingType', this.addNewOrEditData.meetingType) == '院内会';
        },
        handleApprovalConfirmClick: function handleApprovalConfirmClick() {
            this.approvalType = 'confirm';
            this.approvalDailogVisible = true;
        },
        handleApprovalRejectClick: function handleApprovalRejectClick() {
            this.approvalType = 'reject';
            this.approvalDailogVisible = true;
        },
        handleApprovalConfirm: function handleApprovalConfirm(reason) {
            this.handleApproval(reason, 2);
        },
        handleApprovalReject: function handleApprovalReject(reason) {
            this.handleApproval(reason, 3);
        },
        handleApproval: function handleApproval(reason, meetStatus) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_2__api_meetingplan_task__["a" /* default */].apprvoal({
                ids: this.addNewOrEditData.id,
                year: this.addNewOrEditData.year,
                quarter: this.addNewOrEditData.season,
                meetStatus: meetStatus,
                remark: reason
            }).then(function (res) {
                _this.$message.success(res.resultTxt);
                //this.$message.success((meetStatus == 2)?'审批通过会议成功':'审批拒绝会议成功');
                _this.waitBack = true;

                setTimeout(function () {
                    _this.$router.push({
                        name: 'meetingplan-task'
                    });
                }, 3000);
            });
        },
        isOneHospital: function isOneHospital(hospitalObj) {
            return this.basedataGetName('MeetingType', this.addNewOrEditData.meetingType) == '科室会' || this.basedataGetName('MeetingType', this.addNewOrEditData.meetingType) == '院内会';
        }
    }),
    mounted: function mounted() {
        var _this2 = this;

        this.initBaseDataByTypes(['MeetingType', 'MeetingProp', 'MeetingModality', 'MeetingSystem', 'Depart', 'MedicalField', 'TreatmentArea', 'DiseaseArea', 'Product', 'CompanyStrategy', 'MeetingTimeInt', 'Country', 'Office', 'CostCenter', 'WbsCode', 'MeetingGsdType', 'MeetingGsdTypeSub1', 'MeetingGsdTypeSub2', 'MeetingGsdTypeSub3']).then(function () {
            __WEBPACK_IMPORTED_MODULE_1__api_meetingplan_application__["a" /* default */].queryById({ id: _this2.$route.params.id }).then(function (res) {
                debugger;
                //转换多选项
                res.companyStrategy = res.companyStrategy.split(',');
                res.medicalFieldResult = res.medicalFieldResult == null ? ''.split(',') : res.medicalFieldResult.split(',');
                res.meetingSystem = res.meetingSystem.split(',');
                res.offices = res.offices.split(',');
                res.productId = res.productId.split(',');
                res.strategyKeynote = res.strategyKeynote.split(',');

                //新需求字段初始化
                res.meetingGsdType = res.meetingGsdType || '';
                res.meetingGsdSubType = res.meetingGsdSubType || '';
                res.universityStr = res.universityStr || '';
                res.patientOrgStr = res.patientOrgStr || '';
                res.otherStr = res.otherStr || '';
                res.teamL4 = res.teamL4 || '';

                res.extendData = {
                    hospitalInfos: [],
                    speakerInfos: []
                };
                //转换医院信息
                if (res.pubMeetingHospitalLevelList.length > 0) {
                    res.hospitalLevelId = res.pubMeetingHospitalLevelList[0].hospitalLevelId;
                    res.hospitalLevelName = res.pubMeetingHospitalLevelList[0].hospitalLevelName;
                    res.hospitalCount = res.pubMeetingHospitalLevelList[0].count;
                    res.hospitalName = res.pubMeetingHospitalLevelList[0].hospitalName;
                    res.recipientSociety = res.pubMeetingHospitalLevelList[0].recipientSociety;
                }
                if (res.pubMeetingHospitalLevelList.length > 1) {
                    for (var index = 1; index < res.pubMeetingHospitalLevelList.length; index++) {
                        var element = res.pubMeetingHospitalLevelList[index];

                        res.extendData.hospitalInfos.push({
                            hospitalLevelId: element.hospitalLevelId,
                            hospitalLevelName: element.hospitalLevelName,
                            hospitalCount: element.count,
                            hospitalName: element.hospitalName,
                            recipientSociety: element.recipientSociety
                        });
                    }
                }
                res.pubMeetingHospitalLevelList = '';

                //转换讲者信息
                res.includeSpeaker = res.pubMeetingSpeakerLevelList.length > 0 ? 1 : 0;
                if (res.pubMeetingSpeakerLevelList.length > 0) {
                    res.speakerLevel = res.pubMeetingSpeakerLevelList[0].speakerLevel;
                    res.speakerLevelName = res.pubMeetingSpeakerLevelList[0].speakerLevelName;
                    res.speakerCount = res.pubMeetingSpeakerLevelList[0].count;
                }
                if (res.pubMeetingSpeakerLevelList.length > 1) {
                    for (var _index = 1; _index < res.pubMeetingSpeakerLevelList.length; _index++) {
                        var _element = res.pubMeetingSpeakerLevelList[_index];

                        res.extendData.speakerInfos.push({
                            speakerLevel: _element.speakerLevel,
                            speakerLevelName: _element.speakerLevelName,
                            speakerCount: _element.count
                        });
                    }
                }
                if (res.extendData.hospitalInfos.length > 0) {
                    _this2.recipientSocietyOrHospital = 0;
                    _this2.moreThenOneHospital = 1;
                } else {
                    if (res.hospitalId || res.hospitalCount > 0) {
                        if (res.hospitalCount > 1) {
                            _this2.recipientSocietyOrHospital = 0;
                            _this2.moreThenOneHospital = 1;
                        } else {
                            _this2.recipientSocietyOrHospital = 0;
                            _this2.moreThenOneHospital = 0;
                        }
                    } else {
                        if (res.recipientSocietyStr) {
                            _this2.recipientSocietyOrHospital = 1;
                        }
                        if (res.universityStr) {
                            _this2.recipientSocietyOrHospital = 2;
                        }
                        if (res.patientOrgStr) {
                            _this2.recipientSocietyOrHospital = 3;
                        }
                        if (res.otherStr) {
                            _this2.recipientSocietyOrHospital = 4;
                        }
                        _this2.moreThenOneHospital = 0;
                    }
                }
                res.pubMeetingSpeakerLevelList = '';

                _this2.addNewOrEditData = res;

                _this2.waitBack = res.queueTaskStatus === '排队中';
            });
        });
    }
});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_messages_list__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      messagesData: [],
      searchData: {},
      addNewOrEditData: {},
      crudApi: __WEBPACK_IMPORTED_MODULE_1__api_messages_list__["a" /* default */],
      selectedData: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['baseDataRecords', 'basedataGetName', 'basedataGetNameByRowIdField'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['reloadBaseDataByType']), {
    formatDateTime2Date: function formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    formatBaseData: function formatBaseData(row, column, cellValue, index) {
      return this.basedataGetNameByRowIdField(column.property, row);
    },
    indexMethod: function indexMethod(index) {
      return this.$refs['crud'].indexMethod(index);
    },
    handleSearch: function handleSearch() {
      this.$refs['crud'].handleSearch(1);
    },
    handleAddNewClick: function handleAddNewClick() {
      this.$refs['crud'].handleAddNew();
    },
    handleEditClick: function handleEditClick(item) {
      this.$refs['crud'].handleEdit(item);
    },
    beforeSave: function beforeSave(saveData) {},
    handleDeleteClick: function handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleBatchDeleteClick: function handleBatchDeleteClick() {
      this.$refs['crud'].handleBatchDelete();
    },
    handlerExportExcelClick: function handlerExportExcelClick() {
      this.$refs['crud'].handlerExportExcel('医院层级管理.xlsx');
    },
    handleHospitalLevelChange: function handleHospitalLevelChange() {
      this.reloadBaseDataByType('HospitalLevel');
    },
    handleViewClick: function handleViewClick(data) {
      if (data.readFlag == '0') {
        __WEBPACK_IMPORTED_MODULE_1__api_messages_list__["a" /* default */].readMessageByAnntId({ anntIds: [data.anntId] });
      }

      if (data.myMeeting == '1') {
        this.$router.push({
          name: 'meetingplan-application-view',
          params: { 'id': data.meetingId }
        });
      } else {
        this.$router.push({
          name: 'meetingplan-task-view',
          params: { 'id': data.meetingId }
        });
      }
    }
  }),
  mounted: function mounted() {
    this.handleSearch();
  }
});

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      options: [{
        icon: 'icon-shijian1',
        text: this.$t('sysmanagement.time-config'),
        routeName: 'sysmanagement-season-adjust',
        children: [2, 3]
      }, {
        icon: '',
        text: this.$t('sysmanagement.season-adjust'),
        routeName: 'sysmanagement-season-adjust',
        parent: 1
      }, {
        icon: '',
        text: this.$t('sysmanagement.month-adjust'),
        routeName: 'sysmanagement-month-adjust',
        parent: 1
      }, {
        icon: 'icon-gonggao',
        text: this.$t('sysmanagement.system-notice'),
        routeName: 'sysmanagement-system-notice'
      }, {
        icon: 'icon-yonghuquanxian',
        text: this.$t('sysmanagement.privilege'),
        routeName: 'sysmanagement-privilege'
      }, {
        icon: 'icon-caidan',
        text: this.$t('sysmanagement.menu'),
        routeName: 'sysmanagement-menu'
      }, {
        icon: 'icon-jiaoseguanli',
        text: this.$t('sysmanagement.role'),
        routeName: 'sysmanagement-role'
      }, {
        icon: 'icon-shujuzidian',
        text: this.$t('sysmanagement.dict-list'),
        routeName: 'sysmanagement-dict-list'
      }, {
        icon: 'icon-xiaoxi1',
        text: this.$t('sysmanagement.email-template'),
        routeName: 'sysmanagement-email-template'
      }],
      showOther: false
    };
  },

  methods: {
    handleTabClick: function handleTabClick(item, index) {
      if (this.$route.name != item.routeName) {
        this.$router.push({
          name: item.routeName
        });
      }
    },
    isActiveSubMenu: function isActiveSubMenu(subMenu) {
      if (subMenu.children) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(subMenu.children), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var child = _step.value;

            if (this.$route.name == this.options[child - 1].routeName) {
              return true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return false;
      }

      return this.$route.name == subMenu.routeName;
    },
    isShow: function isShow(subMenu) {
      if (subMenu.parent) {
        return this.isActiveSubMenu(this.options[subMenu.parent - 1]);
      } else {
        return true;
      }
    }
  }
});

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_sysmanagement_dictitem__ = __webpack_require__(698);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'dictId': {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      dictItemData: [],
      searchData: {
        itemText: '',
        itemTextEn: '',
        status: ''
      },
      addNewOrEditData: {
        itemText: '',
        itemTextEn: '',
        itemValue: '',
        itemAbbreviation: '',
        description: '',
        sortOrder: '',
        status: true
      },
      crudApi: __WEBPACK_IMPORTED_MODULE_0__api_sysmanagement_dictitem__["a" /* default */]
    };
  },

  methods: {
    formatStatusData: function formatStatusData(row, column, cellValue, index) {
      return row.status == '1' ? '正常' : '禁用';
    },
    handleResetSearchField: function handleResetSearchField() {
      this.searchData.itemText = '';
      this.searchData.itemTextEn = '';
      this.searchData.status = '';
      this.handleSearch();
    },
    handleSearch: function handleSearch() {
      this.searchData['dictId'] = this.dictId;
      this.$refs['crud'].handleSearch(1);
    },
    handleAddNewClick: function handleAddNewClick() {
      this.$refs['crud'].handleAddNew({ status: true });
    },
    handleEditDictItemClick: function handleEditDictItemClick(item) {
      this.$refs['crud'].handleEdit(item, { status: item.status ? true : false });
    },
    beforeSave: function beforeSave(saveData) {
      saveData.status = saveData.status ? 1 : 0;
      saveData.dictId = this.dictId;
    },
    handleDeleteClick: function handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    }
  }
});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_sysmanagement_dictlist__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LeftBar__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LeftBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LeftBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dictitem__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dictitem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__dictitem__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LeftBar: __WEBPACK_IMPORTED_MODULE_1__LeftBar___default.a,
    DictItem: __WEBPACK_IMPORTED_MODULE_2__dictitem___default.a
  },
  data: function data() {
    return {
      dictData: [],
      dictItemDrawer: false,
      dictItemId: '',
      dictName: '',
      searchData: {
        dictName: '',
        dictCode: ''
      },
      addNewOrEditData: {
        dictName: '',
        dictCode: '',
        description: ''
      },
      crudApi: __WEBPACK_IMPORTED_MODULE_0__api_sysmanagement_dictlist__["a" /* default */]
    };
  },

  methods: {
    handleResetSearchField: function handleResetSearchField() {
      this.searchData.dictName = '';
      this.searchData.dictCode = '';

      this.handleSearch();
    },
    handleSearch: function handleSearch() {
      this.$refs['crud'].handleSearch(1);
    },
    handleAddNewClick: function handleAddNewClick() {
      this.$refs['crud'].handleAddNew();
    },
    handleEditClick: function handleEditClick(item) {
      this.$refs['crud'].handleEdit(item);
    },
    handleDeleteClick: function handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleShowDictItemClick: function handleShowDictItemClick(item) {
      var _this = this;

      this.dictItemId = item.id;
      this.dictName = item.dictName;
      this.dictItemDrawer = true;
      this.$nextTick(function () {
        return _this.$refs['dictItem'].handleResetSearchField();
      });
    }
  },
  mounted: function mounted() {
    this.handleSearch();
  }
});

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_sysmanagement_emailtemplate__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LeftBar__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LeftBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LeftBar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LeftBar: __WEBPACK_IMPORTED_MODULE_1__LeftBar___default.a
  },
  data: function data() {
    return {
      emailTemplateData: [],
      searchData: {},
      addNewOrEditData: {
        templateCode: '',
        templateName: '',
        templateContent: ''

      },
      crudApi: __WEBPACK_IMPORTED_MODULE_0__api_sysmanagement_emailtemplate__["a" /* default */]
    };
  },

  methods: {
    formatDateTime2Date: function formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    handleSearch: function handleSearch() {
      this.$refs['crud'].handleSearch(1);
    },
    handleEditClick: function handleEditClick(item) {
      this.$refs['crud'].handleEdit(item);
      if (this.$refs.editor) {
        this.$refs.editor.refresh();
      }
    },
    beforeSave: function beforeSave(saveData) {}
  },
  mounted: function mounted() {
    this.handleSearch();
  }
});

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_sysmanagement_menulist__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LeftBar__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LeftBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LeftBar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LeftBar: __WEBPACK_IMPORTED_MODULE_1__LeftBar___default.a
  },
  data: function data() {
    return {
      menuData: [],
      searchData: {},
      addNewOrEditData: {
        menuType: '',
        name: '',
        url: '',
        sortNo: '',
        parentId: ''
      },
      crudApi: __WEBPACK_IMPORTED_MODULE_0__api_sysmanagement_menulist__["a" /* default */],
      menuTreeProps: {
        label: 'name',
        children: 'children'
      },
      selectedData: []
    };
  },

  methods: {
    formatBaseData: function formatBaseData(row, column, cellValue, index) {
      if (column.property == 'menuType') {
        return row.menuType == 2 ? '按钮' : '菜单';
      }
      return '';
    },
    handleSearch: function handleSearch() {
      this.$refs['crud'].handleSearch(1);
    },
    handleAddNewClick: function handleAddNewClick() {
      this.$refs['crud'].handleAddNew();
    },
    handleEditClick: function handleEditClick(item) {
      this.$refs['crud'].handleEdit(item);
    },
    handleDeleteClick: function handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleBatchDeleteClick: function handleBatchDeleteClick() {
      this.$refs['crud'].handleBatchDelete();
    }
  },
  mounted: function mounted() {
    this.handleSearch();
  }
});

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_sysmanagement_sysdateconfig__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LeftBar__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LeftBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__LeftBar__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LeftBar: __WEBPACK_IMPORTED_MODULE_3__LeftBar___default.a
  },
  data: function data() {
    return {
      editVisible: false,
      confirmEditSaveVisible: false,
      contentData: { configType: 2 },
      contentDataTemp: { configType: 2 }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['basedataGetName'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['initBaseDataByTypes']), {
    handleSearch: function handleSearch() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__api_sysmanagement_sysdateconfig__["a" /* default */].list({
        configType: 2,
        pageNo: 1,
        pageSize: 1
      }).then(function (res) {
        if (res.records.length > 0) {
          _this.contentDataTemp = res.records[0];
          _this.contentData = _.clone(_this.contentDataTemp);
        }
      });
    },
    handleEditClick: function handleEditClick() {
      this.editVisible = true;
    },
    handleCancelEditClick: function handleCancelEditClick() {
      this.contentData = _.clone(this.contentDataTemp);
      this.editVisible = false;
    },
    handleEditConfirmClick: function handleEditConfirmClick() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this2.confirmEditSaveVisible = true;
        } else {
          _this2.$message.error(_this2.basedataGetName('SysErrorTip', 1));
        }
      });
    },
    handlerEditSaveConfirmOK: function handlerEditSaveConfirmOK() {
      var _this3 = this;

      var funName = this.contentData.id ? 'edit' : 'add';
      __WEBPACK_IMPORTED_MODULE_2__api_sysmanagement_sysdateconfig__["a" /* default */][funName](this.contentData).then(function (res) {
        _this3.$message.success('编辑月度申请开放周期成功');
        _this3.contentDataTemp = _.clone(_this3.contentData);
        _this3.confirmEditSaveVisible = false;
        _this3.editVisible = false;
      });
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    this.initBaseDataByTypes(['SysErrorTip']).then(function () {
      _this4.handleSearch();
    });
  }
});

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_sysmanagement_externalprivilege__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LeftBar__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LeftBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LeftBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LeftBar: __WEBPACK_IMPORTED_MODULE_2__LeftBar___default.a
  },
  data: function data() {
    return {
      privilegeData: [],
      searchData: {},
      addNewOrEditData: {
        username: '',
        realname: '',
        departIds: [],
        allowDepartIds: [],
        medicalField: [],
        roleIds: []
      },
      crudApi: __WEBPACK_IMPORTED_MODULE_1__api_sysmanagement_externalprivilege__["a" /* default */],
      selectedData: [],
      actionType: '',
      adSearchText: '',
      allowDeparts: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['userInfo', 'baseDataRecords', 'basedataGetName', 'basedataGetNameByRowIdField'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['initBaseDataByTypes']), {
    formatDateTime2Date: function formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    formatBaseData: function formatBaseData(row, column, cellValue, index) {
      if (column.property == 'roleIds') {
        if (row.roleIds) {
          var ids = row.roleIds;
          if (typeof ids == 'string') {
            ids = ids.split(',');
          }
          var roleNames = [];
          for (var pidIndex = 0; pidIndex < ids.length; pidIndex++) {
            roleNames.push(this.basedataGetName('Role', ids[pidIndex]));
          }
          return roleNames.join(',');
        }
        return row.roleIds;
      }

      if (column.property == 'departIds') {
        if (row.departIds) {
          var _ids = row.departIds;
          if (typeof _ids == 'string') {
            _ids = _ids.split(',');
          }
          var departNames = [];
          for (var _pidIndex = 0; _pidIndex < _ids.length; _pidIndex++) {
            departNames.push(this.basedataGetName('Depart', _ids[_pidIndex]));
          }
          return departNames.join(',');
        }
        return row.departIds;
      }

      if (column.property == 'medicalField') {
        if (row.medicalField) {
          var _ids2 = row.medicalField;
          if (typeof _ids2 == 'string') {
            _ids2 = _ids2.split(',');
          }
          var medicalFieldNames = [];
          for (var _pidIndex2 = 0; _pidIndex2 < _ids2.length; _pidIndex2++) {
            medicalFieldNames.push(this.basedataGetName('MedicalField', _ids2[_pidIndex2]));
          }
          return medicalFieldNames.join(',');
        }
        return row.medicalField;
      }

      return this.basedataGetNameByRowIdField(column.property, row);
    },
    indexMethod: function indexMethod(index) {
      return this.$refs['crud'].indexMethod(index);
    },
    handleSearch: function handleSearch() {
      this.$refs['crud'].handleSearch(1);
    },
    handleAddNewClick: function handleAddNewClick() {
      this.actionType = 'add';
      this.$refs['crud'].handleAddNew();
    },
    handleEditClick: function handleEditClick(item) {
      this.actionType = 'edit';
      if (typeof item.roleIds == 'string') {
        item.roleIds = item.roleIds.split(',');
      }
      if (typeof item.departIds == 'string') {
        item.departIds = item.departIds.split(',');
      }
      if (typeof item.medicalField == 'string') {
        item.medicalField = item.medicalField.split(',');
      }
      if (typeof item.allowDepartIds == 'string') {
        item.allowDepartIds = item.allowDepartIds.split(',');
      }
      this.$refs['crud'].handleEdit(item);
    },
    beforeSave: function beforeSave(saveData) {
      saveData.roleIds = saveData.roleIds.join(',');
      saveData.departIds = saveData.departIds.join(',');
      saveData.medicalField = saveData.medicalField.join(',');
      saveData.allowDepartIds = saveData.allowDepartIds.join(',');
    },
    handleDeleteClick: function handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleBatchDeleteClick: function handleBatchDeleteClick() {
      this.$refs['crud'].handleBatchDelete();
    },
    handlerExportExcelClick: function handlerExportExcelClick() {
      this.$refs['crud'].handlerExportExcel('用户权限.xlsx');
    },
    handleUpdateSuccess: function handleUpdateSuccess() {
      this.handleSearch();
    },
    handleSearchAD: function handleSearchAD() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__api_sysmanagement_externalprivilege__["a" /* default */].getEdcByAd({
        ad: this.adSearchText
      }).then(function (res) {
        if (res && res.username) {
          _this.addNewOrEditData.username = res.username;
          _this.addNewOrEditData.realname = res.realname;
          _this.addNewOrEditData.departIds = res.departIds.split(',');
          _this.addNewOrEditData.medicalField = res.medicalField.split(',');
        }
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.initBaseDataByTypes(['SysErrorTip', 'Role', 'Depart', 'MedicalField']).then(function () {
      __WEBPACK_IMPORTED_MODULE_1__api_sysmanagement_externalprivilege__["a" /* default */].getAllowDeparts().then(function (res) {
        res.records.forEach(function (element) {
          element.id = element.departId;
        });
        _this2.allowDeparts = res.records;
      });
      _this2.handleSearch();
    });
  }
});

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_sysmanagement_role__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LeftBar__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LeftBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LeftBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__roleprivilege__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__roleprivilege___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__roleprivilege__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LeftBar: __WEBPACK_IMPORTED_MODULE_1__LeftBar___default.a,
    RolePrivilege: __WEBPACK_IMPORTED_MODULE_2__roleprivilege___default.a
  },
  data: function data() {
    return {
      roleData: [],
      roleName: '',
      roleId: '',
      searchData: {
        roleName: ''
      },
      addNewOrEditData: {
        roleName: '',
        roleCode: '',
        description: ''
      },
      crudApi: __WEBPACK_IMPORTED_MODULE_0__api_sysmanagement_role__["a" /* default */],
      rolePrivilegeDrawer: false,
      selectedData: []
    };
  },

  methods: {
    formatDateTime2Date: function formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    handleSearch: function handleSearch() {
      this.$refs['crud'].handleSearch(1);
    },
    handleAddNewClick: function handleAddNewClick() {
      this.$refs['crud'].handleAddNew();
    },
    handleEditClick: function handleEditClick(item) {
      this.$refs['crud'].handleEdit(item);
    },
    beforeSave: function beforeSave(saveData) {},
    handleDeleteClick: function handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleBatchDeleteClick: function handleBatchDeleteClick() {
      this.$refs['crud'].handleBatchDelete();
    },
    handleRolePrivilegeClick: function handleRolePrivilegeClick(item) {
      var _this = this;

      this.roleId = item.id;
      this.roleName = item.roleName;
      this.rolePrivilegeDrawer = true;

      this.$nextTick(function () {
        return _this.$refs['rolePrivilege'].refreshRolePrivilege();
      });
    },
    handleAfterSavePrivilege: function handleAfterSavePrivilege() {
      this.rolePrivilegeDrawer = false;
    }
  },
  mounted: function mounted() {
    this.handleSearch();
  }
});

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_sysmanagement_menulist__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_sysmanagement_role__ = __webpack_require__(381);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    'roleId': {
      type: String,
      required: true
    },
    'afterSave': {
      type: Function,
      required: false
    }
  },
  data: function data() {
    return {
      menuData: [],
      menuTreeProps: {
        label: 'name',
        children: 'children'
      },
      defaultCheckedKeys: [],
      confirmSaveVisible: false
    };
  },

  methods: {
    loadMenu: function loadMenu() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__api_sysmanagement_menulist__["a" /* default */].list({}).then(function (res) {
        _this.menuData = res;
      });
    },
    refreshRolePrivilege: function refreshRolePrivilege() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__api_sysmanagement_role__["a" /* default */].queryRolePrivilege({ roleId: this.roleId }).then(function (res) {
        _this2.defaultCheckedKeys = res;
        _this2.$refs['menuTree'].setCheckedKeys(res);
      });
    },
    handleSaveClick: function handleSaveClick() {
      this.confirmSaveVisible = true;
    },
    handlerSaveConfirmOK: function handlerSaveConfirmOK() {
      var _this3 = this;

      var params = {
        roleId: this.roleId,
        permissionIds: this.$refs['menuTree'].getCheckedKeys().join(','),
        lastpermissionIds: this.defaultCheckedKeys.join(',')
      };

      __WEBPACK_IMPORTED_MODULE_1__api_sysmanagement_role__["a" /* default */].saveRolePrivilege(params).then(function (res) {
        _this3.$message.success('保存角色权限成功');
        if (_this3.afterSave) {
          _this3.afterSave();
        }
      });
    }
  },
  mounted: function mounted() {
    this.loadMenu();
  }
});

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_sysmanagement_sysdateconfig__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LeftBar__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LeftBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__LeftBar__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LeftBar: __WEBPACK_IMPORTED_MODULE_3__LeftBar___default.a
  },
  data: function data() {
    return {
      editVisible: false,
      confirmEditSaveVisible: false,
      contentData: { configType: 1 },
      contentDataTemp: { configType: 1 }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['basedataGetName'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['initBaseDataByTypes']), {
    handleSearch: function handleSearch() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__api_sysmanagement_sysdateconfig__["a" /* default */].list({
        configType: 1,
        pageNo: 1,
        pageSize: 1
      }).then(function (res) {
        if (res.records.length > 0) {
          _this.contentDataTemp = res.records[0];
          _this.contentData = _.clone(_this.contentDataTemp);
        }
      });
    },
    handleEditClick: function handleEditClick() {
      this.editVisible = true;
    },
    handleCancelEditClick: function handleCancelEditClick() {
      this.contentData = _.clone(this.contentDataTemp);
      this.editVisible = false;
    },
    handleEditConfirmClick: function handleEditConfirmClick() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this2.confirmEditSaveVisible = true;
        } else {
          _this2.$message.error(_this2.basedataGetName('SysErrorTip', 1));
        }
      });
    },
    handlerEditSaveConfirmOK: function handlerEditSaveConfirmOK() {
      var _this3 = this;

      var funName = this.contentData.id ? 'edit' : 'add';
      __WEBPACK_IMPORTED_MODULE_2__api_sysmanagement_sysdateconfig__["a" /* default */][funName](this.contentData).then(function (res) {
        _this3.$message.success('编辑季度申请开放周期成功');
        _this3.contentDataTemp = _.clone(_this3.contentData);
        _this3.confirmEditSaveVisible = false;
        _this3.editVisible = false;
      });
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    this.initBaseDataByTypes(['SysErrorTip']).then(function () {
      _this4.handleSearch();
    });
  }
});

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_sysmanagement_systemnotice__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LeftBar__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LeftBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LeftBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LeftBar: __WEBPACK_IMPORTED_MODULE_2__LeftBar___default.a
  },
  data: function data() {
    var _this = this;

    return {
      noticeData: [],
      searchData: {
        contentCn: '',
        releaseTime: '',
        removeTime: '',
        createBy: ''
      },
      addNewOrEditData: {
        contentCn: '',
        releaseTime: '',
        removeTime: ''
      },
      selectedData: [],
      crudApi: __WEBPACK_IMPORTED_MODULE_1__api_sysmanagement_systemnotice__["a" /* default */],
      startPickerOptions: {
        disabledDate: function disabledDate(time) {
          time = new Date(moment(time).format('YYYY-MM-DD'));
          if (!_this.addNewOrEditData.removeTime) {
            return false;
          }
          return time.getTime() > _this.addNewOrEditData.removeTime;
        }
      },
      endPickerOptions: {
        disabledDate: function disabledDate(time) {
          time = new Date(moment(time).format('YYYY-MM-DD'));
          if (!_this.addNewOrEditData.releaseTime) {
            return false;
          }
          return time.getTime() < _this.addNewOrEditData.releaseTime;
        }
      },
      remoteCreateByDataAll: [],
      remoteCreateByData: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['initSystemNotices']), {
    formatDateTime2Date: function formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    handleSearch: function handleSearch() {
      if (this.searchData.releaseTime) {
        this.searchData.releaseTime = moment(this.searchData.releaseTime).format('YYYY-MM-DD HH:mm:ss');
      }
      if (this.searchData.removeTime) {
        this.searchData.removeTime = moment(this.searchData.removeTime).format('YYYY-MM-DD HH:mm:ss');
      }
      this.$refs['crud'].handleSearch(1);
    },
    handleAddNewClick: function handleAddNewClick() {
      this.$refs['crud'].handleAddNew();
    },
    handleEditClick: function handleEditClick(item) {
      this.$refs['crud'].handleEdit(item);
    },
    beforeSave: function beforeSave(saveData) {
      saveData.releaseTime = moment(saveData.releaseTime).format('YYYY-MM-DD HH:mm:ss');
      saveData.removeTime = moment(saveData.removeTime).format('YYYY-MM-DD HH:mm:ss');
    },
    handleDeleteClick: function handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleBatchDeleteClick: function handleBatchDeleteClick() {
      this.$refs['crud'].handleBatchDelete();
    },
    handlerExportExcelClick: function handlerExportExcelClick() {
      this.$refs['crud'].handlerExportExcel('系统公告.xlsx');
    },
    handleSystemNoticesChange: function handleSystemNoticesChange() {
      this.initSystemNotices();
      this.initUserList();
    },
    handleUpdateByFilter: function handleUpdateByFilter(query) {
      if (!query) {
        this.remoteCreateByData = [];
        return;
      }

      this.remoteCreateByData = this.remoteCreateByDataAll.filter(function (r) {
        return r.username.toLowerCase().indexOf(query.toLowerCase()) >= 0;
      });
    },
    initUserList: function initUserList() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__api_sysmanagement_systemnotice__["a" /* default */].getUserList().then(function (res) {
        _this2.remoteCreateByDataAll = res;
      });
    }
  }),
  mounted: function mounted() {
    this.handleSearch();
    this.initUserList();
  }
});

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isAdmin: false,
      options: [{
        icon: 'icon-yonghuquanxian',
        text: this.$t('user.personal-center'),
        name: 'user-personal-center'
      }, {
        icon: 'icon-yonghushouce',
        text: this.$t('user.manual'),
        name: 'user-manual'
      }, {
        icon: 'icon-yonghushouce',
        text: this.$t('user.authorizelm'),
        name: 'user-authorizelm'
      }, {
        icon: 'icon-yonghushouce',
        text: this.$t('user.authorizedlevel'),
        name: 'user-authorizedlevel'
      }]
    };
  },

  props: {
    tab: {
      // 当前选中的是第几个 选项
      type: Number | String,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['userInfo'])),
  methods: {
    handleTabClick: function handleTabClick(item, index) {
      if (index + 1 != this.tab) {
        this.$router.push({
          name: item.name
        });
      }
    }
  },
  mounted: function mounted() {
    var tempOptions = [];
    if (this.$hasPermissionByRouteName(this.options[0].name)) {
      tempOptions.push(this.options[0]);
    }
    tempOptions.push(this.options[1]);
    for (var index = 0; index < this.userInfo.roleCodes.length; index++) {
      var element = this.userInfo.roleCodes[index];
      if (element == 140) {
        this.isAdmin = true;
        tempOptions.push(this.options[2]);
        tempOptions.push(this.options[3]);
        break;
      }
    }

    if (!this.isAdmin) {
      for (var key in this.userInfo.meetingApproveRole) {
        if (key == 135) {
          tempOptions.push(this.options[2]);
        }
        if (key == 198) {
          tempOptions.push(this.options[3]);
        }
      }
    }

    this.options = tempOptions;
  }
});

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_user_authorize__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LeftBar__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LeftBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LeftBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LeftBar: __WEBPACK_IMPORTED_MODULE_2__LeftBar___default.a
  },
  data: function data() {
    return {
      authorizedPersonName: '',
      form: {
        authorizationType: "2"
      },
      isAdmin: false,
      licensorList: [],
      authorizedPersonList: [],
      authorizationTeamList: [],
      daysList: [{ id: 30, label: "30天" }, { id: 60, label: "60天" }, { id: 90, label: "90天" }, { id: 180, label: "180天" }],
      radio: "1",
      dialogVisible: false,
      dialogText1: "",
      dialogText2: "",
      dialogText3: "",
      rules: {
        licensorAd: [{ required: true, message: "请选择授权人AD", trigger: "change" }],
        days: [{ required: true, message: "请选择授权天数", trigger: "change" }],
        date: [{
          type: "date",
          required: true,
          message: "请选择授权日期",
          trigger: "change"
        }],
        authorizationTeam: [{ required: true, message: "请选择授权团队", trigger: "change" }],
        authorizedPersonAd: [{ required: true, message: "请选择被授权人AD", trigger: "change" }]
      },
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          time = new Date(moment(time).format("YYYY-MM-DD"));
          var diyDate = new Date();
          var startDate = new Date(diyDate.setDate(diyDate.getDate() - 1));
          var endDate = new Date(diyDate.setDate(diyDate.getDate() + 180));
          if (time.getTime() < startDate.getTime()) {
            return true;
          }
          if (time.getTime() > endDate.getTime()) {
            return true;
          }
          return false;
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["userInfo"])),
  methods: {
    changeAuthorizedPersonAd: function changeAuthorizedPersonAd(val) {
      console.log(val);
      var authorizedPersonSelected = this.authorizedPersonList.filter(function (item) {
        return item.adAccount === val;
      });
      this.authorizedPersonName = authorizedPersonSelected[0].workerNameLocal;
    },
    submitForm: function submitForm(formName) {
      var _this = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this.radio === "1") {
            _this.form.authorizationDeadline = undefined;
            _this.form.authorizationDays = _this.form.days;
          } else {
            _this.form.authorizationDays = undefined;
            _this.form.authorizationDeadline = moment(_this.form.date).format("YYYY-MM-DD HH:mm:ss");
          }
          __WEBPACK_IMPORTED_MODULE_1__api_user_authorize__["a" /* default */].check(_this.form).then(function (res) {
            if (res.isSameFranchise) {
              _this.dialogText1 = "\u5373\u5C06\u628A\u3010\u4E8C\u7EA7\u5BA1\u6279\u4EBA\u3011\u5BA1\u6279\u6743\u9650\u8D4B\u4E88\u7ED9" + _this.authorizedPersonName + "\u3002";
              _this.dialogText2 = "•点击确认按钮后赋权生效，本账户将失去【二级审批人】审批权限。";
              _this.dialogText3 = "•可以在授权页面查看和维护授权功能。";
              _this.dialogVisible = true;
            } else {
              _this.dialogText1 = "\u5373\u5C06\u628A\u3010\u4E8C\u7EA7\u5BA1\u6279\u4EBA\u3011\u5BA1\u6279\u6743\u9650\u8D4B\u4E88\u7ED9" + _this.authorizedPersonName + "\uFF0C" + _this.authorizedPersonName + "\u4E0D\u5C5E\u4E8E" + res.authorizationTeam + "\u56E2\u961F\uFF0C\u8BF7\u786E\u8BA4\u6388\u6743\u5BF9\u8C61\u3002";
              _this.dialogText2 = "•点击确认按钮后赋权生效，本账户将失去【二级审批人】审批权限。";
              _this.dialogText3 = "•可以在授权页面查看和维护授权功能。";
              _this.dialogVisible = true;
            }
          });
        } else {
          return false;
        }
      });
    },
    remoteMethodLAD: function remoteMethodLAD(query) {
      var _this2 = this;

      if (query !== "") {
        __WEBPACK_IMPORTED_MODULE_1__api_user_authorize__["a" /* default */].approveUser({
          authorizationType: this.form.authorizationType,
          licensorAd: query
        }).then(function (res) {
          _this2.licensorList = res;
        });
      } else {
        this.licensorList = [];
      }
    },
    getAuthorizationTeamList: function getAuthorizationTeamList() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__api_user_authorize__["a" /* default */].team({ licensorAd: this.form.licensorAd }).then(function (res) {
        _this3.authorizationTeamList = res;
      });
    },
    remoteMethodAPAD: function remoteMethodAPAD(query) {
      var _this4 = this;

      if (query !== "") {
        __WEBPACK_IMPORTED_MODULE_1__api_user_authorize__["a" /* default */].selectUser({ authorizedPersonAd: query }).then(function (res) {
          _this4.authorizedPersonList = res;
        });
      } else {
        this.authorizedPersonList = [];
      }
    },
    handlerOK: function handlerOK() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_1__api_user_authorize__["a" /* default */].save(this.form).then(function (res) {
        if (res) {
          _this5.$router.go(-1);
        }
        _this5.dialogVisible = false;
      });
    }
  },
  mounted: function mounted() {
    for (var index = 0; index < this.userInfo.roleCodes.length; index++) {
      var element = this.userInfo.roleCodes[index];
      if (element == 140) {
        this.isAdmin = true;
        break;
      }
    }
    if (!this.isAdmin) {
      this.getAuthorizationTeamList();
    }
  }
});

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_user_authorize__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LeftBar__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LeftBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LeftBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LeftBar: __WEBPACK_IMPORTED_MODULE_2__LeftBar___default.a
  },
  data: function data() {
    return {
      tableData: [],
      isAdmin: false,
      confirmDeleteVisible: false,
      rowId: ""
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["userInfo"])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(["initBaseDataByTypes"]), {
    getList: function getList() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__api_user_authorize__["a" /* default */].list({ authorizationType: "2" }).then(function (res) {
        if (Array.isArray(res)) {
          _this.tableData = res;
        }
      });
    },
    handleAddNewClick: function handleAddNewClick() {
      this.$router.push({
        name: "user-authorizedlevel-add"
      });
    },
    handleDeleteClick: function handleDeleteClick(data) {
      this.confirmDeleteVisible = true;
      this.rowId = data.id;
    },
    handlerDeleteConfirmOK: function handlerDeleteConfirmOK() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__api_user_authorize__["a" /* default */].stop({ id: this.rowId }).then(function (res) {
        if (res) {
          _this2.getList();
          _this2.$message({
            type: "success",
            message: "删除成功!"
          });
        } else {
          _this2.$message({
            type: "error",
            message: "删除失败"
          });
        }
      });
    }
  }),
  mounted: function mounted() {
    for (var index = 0; index < this.userInfo.roleCodes.length; index++) {
      var element = this.userInfo.roleCodes[index];
      if (element == 140) {
        this.isAdmin = true;
        break;
      }
    }
    this.getList();
  }
});

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_user_authorize__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LeftBar__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LeftBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LeftBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LeftBar: __WEBPACK_IMPORTED_MODULE_2__LeftBar___default.a
  },
  data: function data() {
    return {
      authorizedPersonName: '',
      form: {
        authorizationType: "1"
      },
      isAdmin: false,
      licensorList: [],
      authorizedPersonList: [],
      daysList: [{ id: 30, label: "30天" }, { id: 60, label: "60天" }, { id: 90, label: "90天" }, { id: 180, label: "180天" }],
      radio: "1",
      dialogVisible: false,
      dialogText1: "",
      dialogText2: "",
      dialogText3: "",
      rules: {
        licensorAd: [{ required: true, message: "请选择授权人AD", trigger: "change" }],
        days: [{ required: true, message: "请选择授权天数", trigger: "change" }],
        date: [{
          type: "date",
          required: true,
          message: "请选择授权日期",
          trigger: "change"
        }],
        authorizedPersonAd: [{ required: true, message: "请选择被授权人AD", trigger: "change" }]
      },
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          time = new Date(moment(time).format("YYYY-MM-DD"));
          var diyDate = new Date();
          var startDate = new Date(diyDate.setDate(diyDate.getDate() - 1));
          var endDate = new Date(diyDate.setDate(diyDate.getDate() + 180));
          if (time.getTime() < startDate.getTime()) {
            return true;
          }
          if (time.getTime() > endDate.getTime()) {
            return true;
          }
          return false;
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["userInfo"])),
  methods: {
    changeAuthorizedPersonAd: function changeAuthorizedPersonAd(val) {
      console.log(val);
      var authorizedPersonSelected = this.authorizedPersonList.filter(function (item) {
        return item.adAccount === val;
      });
      this.authorizedPersonName = authorizedPersonSelected[0].workerNameLocal;
    },
    submitForm: function submitForm(formName) {
      var _this = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this.radio === "1") {
            _this.form.authorizationDeadline = undefined;
            _this.form.authorizationDays = _this.form.days;
          } else {
            _this.form.authorizationDays = undefined;
            _this.form.authorizationDeadline = moment(_this.form.date).format("YYYY-MM-DD HH:mm:ss");
          }
          __WEBPACK_IMPORTED_MODULE_1__api_user_authorize__["a" /* default */].check(_this.form).then(function (res) {
            if (res.isSameFranchise) {
              _this.dialogText1 = "\u5373\u5C06\u628A\u3010\u76F4\u7EBF\u7ECF\u7406\u3011\u5BA1\u6279\u6743\u9650\u8D4B\u4E88\u7ED9" + _this.authorizedPersonName + "\u3002";
              _this.dialogText2 = "•点击确认按钮后赋权生效，本账户将失去【直线经理】审批权限。";
              _this.dialogText3 = "•可以在授权页面查看和维护授权功能。";
              _this.dialogVisible = true;
            } else {
              _this.dialogText1 = "\u5373\u5C06\u628A\u3010\u76F4\u7EBF\u7ECF\u7406\u3011\u5BA1\u6279\u6743\u9650\u8D4B\u4E88\u7ED9" + _this.authorizedPersonName + "\uFF0C" + _this.authorizedPersonName + "\u4E0D\u5C5E\u4E8E" + res.authorizationTeam + "\u56E2\u961F\uFF0C\u8BF7\u786E\u8BA4\u6388\u6743\u5BF9\u8C61\u3002";
              _this.dialogText2 = "•点击确认按钮后赋权生效，本账户将失去【直线经理】审批权限。";
              _this.dialogText3 = "•可以在授权页面查看和维护授权功能。";
              _this.dialogVisible = true;
            }
          });
        } else {
          return false;
        }
      });
    },
    remoteMethodLAD: function remoteMethodLAD(query) {
      var _this2 = this;

      if (query !== "") {
        __WEBPACK_IMPORTED_MODULE_1__api_user_authorize__["a" /* default */].approveUser({
          authorizationType: this.form.authorizationType,
          licensorAd: query
        }).then(function (res) {
          _this2.licensorList = res;
        });
      } else {
        this.licensorList = [];
      }
    },
    remoteMethodAPAD: function remoteMethodAPAD(query) {
      var _this3 = this;

      if (query !== "") {
        __WEBPACK_IMPORTED_MODULE_1__api_user_authorize__["a" /* default */].selectUser({ authorizedPersonAd: query }).then(function (res) {
          _this3.authorizedPersonList = res;
        });
      } else {
        this.authorizedPersonList = [];
      }
    },
    handlerOK: function handlerOK() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1__api_user_authorize__["a" /* default */].save(this.form).then(function (res) {
        if (res) {
          _this4.$router.go(-1);
        }
        _this4.dialogVisible = false;
      });
    }
  },
  mounted: function mounted() {
    for (var index = 0; index < this.userInfo.roleCodes.length; index++) {
      var element = this.userInfo.roleCodes[index];
      if (element == 140) {
        this.isAdmin = true;
        break;
      }
    }
  }
});

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_user_authorize__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LeftBar__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LeftBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LeftBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LeftBar: __WEBPACK_IMPORTED_MODULE_2__LeftBar___default.a
  },
  data: function data() {
    return {
      tableData: [],
      isAdmin: false,
      confirmDeleteVisible: false,
      rowId: ""
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["userInfo"])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(["initBaseDataByTypes"]), {
    getList: function getList() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__api_user_authorize__["a" /* default */].list({ authorizationType: "1" }).then(function (res) {
        if (Array.isArray(res)) {
          _this.tableData = res;
        }
      });
    },
    handleAddNewClick: function handleAddNewClick() {
      this.$router.push({
        name: "user-authorizelm-add"
      });
    },
    handleDeleteClick: function handleDeleteClick(data) {
      this.confirmDeleteVisible = true;
      this.rowId = data.id;
    },
    handlerDeleteConfirmOK: function handlerDeleteConfirmOK() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__api_user_authorize__["a" /* default */].stop({ id: this.rowId }).then(function (res) {
        if (res) {
          _this2.getList();
          _this2.$message({
            type: "success",
            message: "删除成功!"
          });
        } else {
          _this2.$message({
            type: "error",
            message: "删除失败"
          });
        }
      });
    }
  }),
  mounted: function mounted() {
    for (var index = 0; index < this.userInfo.roleCodes.length; index++) {
      var element = this.userInfo.roleCodes[index];
      if (element == 140) {
        this.isAdmin = true;
        break;
      }
    }
    this.getList();
  }
});

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_user_center__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LeftBar__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LeftBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LeftBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LeftBar: __WEBPACK_IMPORTED_MODULE_2__LeftBar___default.a
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['basedataGetName', 'userInfo'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['initBaseDataByTypes'])),
  mounted: function mounted() {}
});

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LeftBar__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LeftBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__LeftBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_upload_FileBox_vue__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_upload_FileBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_upload_FileBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_home_manual__ = __webpack_require__(695);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LeftBar: __WEBPACK_IMPORTED_MODULE_0__LeftBar___default.a,
    FileBox: __WEBPACK_IMPORTED_MODULE_1__components_common_upload_FileBox_vue___default.a
  },
  data: function data() {
    return {
      fileList: [],
      hco: undefined,
      hospital_level: undefined
    };
  },

  methods: {
    handleDownloadManual: function handleDownloadManual() {
      var _this = this;

      var filePath = '';
      if (this.fileList.length) {
        var manualFile = this.fileList[0];
        filePath = manualFile.fileS3Path;
      }
      var form = {
        fileS3Url: filePath
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_home_manual__["a" /* downloadManual */])(form).then(function (res) {
        _this.$checkFileStream(res).then(function () {
          _this.$downloadFile(res.data, res);
        }, function (err) {
          console.error('err', err);
          _this.$message.error(_this.$t('popup.download_fail'));
        });
      });
    },

    // 获取用户手册信息
    loadManualInfo: function loadManualInfo() {
      this.fileList = [{
        "id": "1174511106530525186",
        "createBy": "admin",
        "createTime": "2020-11-24 17:33:22",
        "type": "0",
        "fileName": "会议计划平台用户手册V1.0.pdf",
        "fileS3Path": "会议计划平台用户手册V1.0.pdf",
        "fileSize": 5248906,
        "description": "会议计划平台用户手册V1.0",
        "delFlag": "0"
      }];
    }
  },
  mounted: function mounted() {
    this.loadManualInfo();
  }
});

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfjs_dist_es5_build_pdf_js__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfjs_dist_es5_build_pdf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pdfjs_dist_es5_build_pdf_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_axios__ = __webpack_require__(60);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var loadingTask = void 0;




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PDFViewer',
  props: {
    fileData: {
      type: Object,
      default: function _default() {
        return {};
      },
      require: true
    },
    download: {
      type: Boolean,
      default: false,
      require: false
    },
    s3Path: {
      type: String,
      default: '',
      require: false
    }
  },
  data: function data() {
    return {
      innerData: {},
      title: '',
      fileName: 'file',
      visible: false,
      canvasVisible: false,
      flipingFlag: false,
      pagination: {
        page: 1,
        limit: null
      },
      canvasStyle: {
        opacity: 0,
        transition: 'all 1s'
      }
    };
  },

  computed: {
    atBegining: function atBegining() {
      return this.pagination.page === 1;
    },
    atEnd: function atEnd() {
      return this.pagination.page === this.pagination.limit;
    }
  },
  watch: {
    fileData: function fileData(value) {
      this.innerData = value;
    },
    innerData: function innerData(value) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var base64Data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                value = value.data ? value.data : value;
                base64Data = '';

                if (!(typeof value === 'string' && _this.isBase64(value))) {
                  _context.next = 6;
                  break;
                }

                base64Data = value;
                _context.next = 15;
                break;

              case 6:
                if (!(value instanceof Blob)) {
                  _context.next = 12;
                  break;
                }

                _context.next = 9;
                return _this.blobToBase64(value);

              case 9:
                base64Data = _context.sent;
                _context.next = 15;
                break;

              case 12:
                _context.next = 14;
                return _this.arraybufferToBase64(value);

              case 14:
                base64Data = _context.sent;

              case 15:
                _this.base64Data = base64Data;
                _this.init(base64Data);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    visible: function visible(value) {
      if (!value) {
        this.pagination.page = 1;
        this.canvasStyle.opacity = 0;
      } else {
        var canvas = document.getElementById('the-canvas');
        if (canvas) {
          canvas.scrollTop = 0;
        }
      }
    }
  },
  mounted: function mounted() {},


  methods: {
    handleClose: function handleClose() {
      this.visible = false;
    },
    blobToBase64: function blobToBase64(blob) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        try {
          var reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = function (event) {
            resolve(event.target.result);
          };
        } catch (error) {
          reject(error);
        }
      });
    },
    arraybufferToBase64: function arraybufferToBase64(data) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        try {
          var blob = new Blob([data]);
          var reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = function (event) {
            resolve(event.target.result);
          };
        } catch (error) {
          reject(error);
        }
      });
    },
    init: function init(base64Data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var protocol, workerFileLocation, CMAP_URL;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // 获取当前主机地址和端口号
                protocol = window.location.protocol;

                // const host = window.location.host;
                // const workerFileLocation = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.4.456/build/pdf.worker.min.js';
                // const workerFileLocation = '/static/js/pdf.worker.min.js';
                //   const workerFileLocation = './static/js/pdf.worker.es5.min.js';

                workerFileLocation = './static/js/pdf.worker.js';

                // set pdf worker

                base64Data = base64Data.substr(base64Data.indexOf('base64,') + 7, base64Data.length);

                __WEBPACK_IMPORTED_MODULE_3_pdfjs_dist_es5_build_pdf_js___default.a.GlobalWorkerOptions.workerSrc = workerFileLocation;
                CMAP_URL = './static/fonts/pdfjs/cmaps/';
                // pdfjsLib.GlobalWorkerOptions.workerSrc = require("pdfjs-dist/build/pdf.worker.js");

                try {
                  loadingTask = __WEBPACK_IMPORTED_MODULE_3_pdfjs_dist_es5_build_pdf_js___default.a.getDocument({
                    data: atob(base64Data),
                    cMapUrl: CMAP_URL,
                    cMapPacked: true
                  });
                  // console.log(loadingTask)
                  _this2.renderPage(base64Data);
                } catch (error) {
                  console.log(error);
                  _this2.$messageBox({
                    icon: 'error', // --->弹窗类型 非必填 [success √,warning ！,error X]
                    title: _this2.$t('pdfViewer.data_error') + '3', // -->副标题 非必填
                    btnText: _this2.$t('Confirm')
                  });
                }

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    renderPage: function renderPage(base64Data) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var pdf;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return loadingTask.promise;

              case 2:
                pdf = _context3.sent;

                console.log('loadingTask.promise');
                // const pdfFile = 'https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/web/compressed.tracemonkey-pldi-09.pdf'
                console.log('renderPage++++');
                console.log(pdf);

                _this3.pagination.limit = pdf.numPages;
                pdf.getPage(_this3.pagination.page).then(function (page) {
                  // you can now use *page* here
                  var scale = 2;
                  var viewport = page.getViewport({ scale: scale });
                  var canvas = document.getElementById('the-canvas');
                  var context = canvas.getContext('2d');
                  canvas.height = viewport.height;
                  canvas.width = viewport.width;
                  var renderContext = {
                    canvasContext: context,
                    viewport: viewport
                  };

                  page.render(renderContext);

                  setTimeout(function () {
                    _this3.canvasStyle = {
                      opacity: 1,
                      transition: 'all 0.3s'
                    };
                  }, 500);

                  // this.canvasVisible = false;

                  setTimeout(function () {
                    _this3.canvasVisible = true;
                  }, 2500);
                }).catch(function (error) {
                  _this3.$messageBox({
                    icon: 'error', // --->弹窗类型 非必填 [success √,warning ！,error X]
                    title: _this3.$t('pdfViewer.data_error') + '2', // -->副标题 非必填
                    btnText: _this3.$t('Confirm')
                  });
                  console.log('error 2+++++++');
                  console.log(error);
                });

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    handleGoPage: function handleGoPage(pageNumber) {
      if (this.pagination.page > this.pagination.limit) {
        return;
      }

      this.pagination.page = pageNumber;
      this.canvasStyle = {
        transition: 'all 0s',
        opacity: 0
      };

      this.renderPage();
    },
    handlePrevious: function handlePrevious() {
      var _this4 = this;

      if (this.flipingFlag) {
        return false;
      }
      this.flipingFlag = false;
      var pageNumber = this.pagination.page > 1 ? this.pagination.page - 1 : 1;
      this.handleGoPage(pageNumber);
      setTimeout(function () {
        _this4.flipingFlag = false;
      }, 500);
    },
    handleNext: function handleNext() {
      var _this5 = this;

      if (this.flipingFlag) {
        return false;
      }
      this.flipingFlag = false;
      var pageNumber = this.pagination.page < this.pagination.limit ? this.pagination.page + 1 : this.pagination.limit;

      this.handleGoPage(pageNumber);
      setTimeout(function () {
        _this5.flipingFlag = false;
      }, 500);
    },
    handleCurrentChange: function handleCurrentChange(pageNumber) {
      this.handleGoPage(pageNumber);
    },
    isBase64: function isBase64(str) {
      if (str === '' || str.trim() === '') {
        return false;
      }
      try {
        return btoa(atob(str)) == str;
      } catch (err) {
        return false;
      }
    },
    handleDownloadStreamData: function handleDownloadStreamData() {
      var blob = this.dataURLtoBlob(this.base64Data);
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, this.title);
      } else {
        // location.href = URL.createObjectURL(blob);
        var eleLink = document.createElement('a');
        eleLink.download = !!this.title && this.title !== '' ? this.title : 'fIle_' + Date.parse(new Date());
        eleLink.style.display = 'none';
        eleLink.href = URL.createObjectURL(blob);
        document.body.appendChild(eleLink);
        eleLink.click();
      }
    },
    handleDownloadFile2: function handleDownloadFile2() {
      var s3Path = this.s3Path;

      if (!!s3Path && s3Path !== '') {
        var result = '';
        if (!!this.fileName && this.fileName !== 'file') {
          // 有传文件名
          var fileName = this.fileName.replace('.pdf', '');
          result = __WEBPACK_IMPORTED_MODULE_4__util_axios__["b" /* baseURL */] + '/e2estservice/meeting/meetingFile/downloadFileWithName?url=' + encodeURIComponent(s3Path);
          result += '&filename=' + fileName + '.pdf';
        } else {
          // 没有传文件名
          result = __WEBPACK_IMPORTED_MODULE_4__util_axios__["b" /* baseURL */] + '/e2estservice/meeting/meetingFile/downloadFile?url=' + encodeURIComponent(s3Path);
        }

        console.log(result);

        var aTag = document.createElement('a');
        aTag.href = result;
        aTag.target = '_blank';
        // aTag.download = this.title || 'file.pdf';
        aTag.click();
      } else {
        this.handleDownloadStreamData();
      }
    },
    dataURLtoBlob: function dataURLtoBlob(dataurl) {
      var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    myBrowser: function myBrowser() {
      var userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
      var isOpera = userAgent.indexOf('Opera') > -1; // 判断是否Opera浏览器
      var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera; // 判断是否IE浏览器
      var isEdge = userAgent.indexOf('Edge') > -1; // 判断是否IE的Edge浏览器
      var isFF = userAgent.indexOf('Firefox') > -1; // 判断是否Firefox浏览器
      var isSafari = userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') == -1; // 判断是否Safari浏览器
      var isChrome = userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1; // 判断Chrome浏览器

      if (isIE) {
        // var reIE = new RegExp('MSIE (\\d+\\.\\d+);');
        // reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp['$1']);
        if (fIEVersion == 7) {
          return 'IE7';
        } else if (fIEVersion == 8) {
          return 'IE8';
        } else if (fIEVersion == 9) {
          return 'IE9';
        } else if (fIEVersion == 10) {
          return 'IE10';
        } else if (fIEVersion == 11) {
          return 'IE11';
        } else {
          return '0';
        } // IE版本过低
        // return 'IE';
      }
      if (isOpera) {
        return 'Opera';
      }
      if (isEdge) {
        return 'Edge';
      }
      if (isFF) {
        return 'FF';
      }
      if (isSafari) {
        return 'Safari';
      }
      if (isChrome) {
        return 'Chrome';
      }
    },
    downloadByForm: function downloadByForm(s3Path) {
      var form = document.createElement('form');
      var iframe = document.createElement('iframe');
      form.target = 'aaa';
      iframe.id = 'aaa';
      iframe.name = 'aaa';
      form.method = 'POST';
      form.action = s3Path;
      document.body.appendChild(iframe);
      document.body.appendChild(form);
      form.submit();
    }
  }
});

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amap_amap_jsapi_loader__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__amap_amap_jsapi_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__amap_amap_jsapi_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_global__ = __webpack_require__(170);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var MARKER_PREFIX = 'marker_';


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      keyword: '',
      address: '', // 当前地址
      map: undefined,
      aMap: undefined,
      //   key: '4660673a7aff6e995fec5bcc74caf03a',
      key: __WEBPACK_IMPORTED_MODULE_6__global_global__["a" /* default */].AMAP_KEY,
      loading: true,
      markers: [], // 地图标记物
      pickMarker: undefined, // 点击的 marker
      pois: [], // 关键字search 的result列表
      searchTimer: undefined, // 计时器,用于用户输入后 固定事件间隔开始搜索
      loadingResult: false, // 是否正在根据用户输入进行搜索
      marker_green: __webpack_require__(1517),
      marker_red: __webpack_require__(1518),
      markerZIndex: 20,
      targetMarker: undefined, // 当前显示的marker
      visible: true
    };
  },

  props: {
    mode: {
      type: String, // ['search','pick'], search 为搜索模块，pick 为在地图上点击模式
      default: 'search'
    },
    lnglat: {
      type: Array // [经度,纬度]
    },
    location: {
      type: String // 地址
    },
    title: {
      type: String // dialog title
    },
    confirm: {
      type: Function,
      require: true
    },
    confirmMsg: {
      type: String
    }
  },
  methods: {
    loadMap: function loadMap() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4__amap_amap_jsapi_loader___default.a.load({
        'key': this.key, // 申请好的Web端开发者Key，首次调用 load 时必填
        'version': '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        'plugins': ['AMap.PlaceSearch', 'AMap.Geocoder'] // 插件列表
      }).then(function (AMap) {
        _this.aMap = AMap;
        _this.map = new AMap.Map(_this.$refs.mapContainer);
        _this.loading = false;
        _this.$refs.mapSearch.focus();
        // 注册地图事件
        _this.registerMapEvent();
        // 如果传参过来了就初始化地图数据
        _this.initMapData();
      }).catch(function (err) {
        _this.$message.error(_this.$t('component.mapbox.load_map_error'));
      });
    },

    // 注册地图事件
    registerMapEvent: function registerMapEvent() {
      var that = this;
      if (this.mode.indexOf('pick') > -1) {
        this.map.setDefaultCursor('pointer');
        this.map.on('click', function (ev) {
          that.handleMapClick(ev);
        });
      }
    },

    // 地图点击事件
    handleMapClick: function handleMapClick(ev) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, _ref2, err, address, marker;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$awaitWrap(_this2.searchByPoint(ev));

              case 2:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                err = _ref2[0];
                address = _ref2[1];

                if (address) {
                  // 添加点击的marker
                  marker = new _this2.aMap.Marker({
                    icon: _this2.marker_red,
                    anchor: 'bottom-center',
                    position: ev.lnglat, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                    title: address,
                    extData: {
                      id: MARKER_PREFIX + 'pick',
                      address: address,
                      search: false
                    }
                  });

                  _this2.pickMarker = marker;
                  _this2.updateCurrentMarker(marker);
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },

    // 更新最新标记的marker
    updateCurrentMarker: function updateCurrentMarker(marker) {
      // 如果当前已经有 目标 marker，search 回来的更新icon，pick 的删除
      var targetMarker = this.targetMarker;
      if (targetMarker) {
        var extData = targetMarker.getExtData();
        if (extData.search) {
          this.updateTargetMarkerIcon(targetMarker, this.marker_green);
        } else {
          this.map.remove(targetMarker);
        }
      }
      // 添加新的marker
      this.addMarker(marker);
      var currentExtData = marker.getExtData();
      this.address = currentExtData.address;
      if (currentExtData.search) {
        // 设置当前icon 为 红色
        this.updateTargetMarkerIcon(marker, this.marker_red);
      }
      // 设置新的 marker 为当前的目标marker
      this.targetMarker = marker;
    },
    onSearchChange: function onSearchChange(value) {
      var _this3 = this;

      var waitTime = 600;
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      if (value == '') {
        // 没有值时直接开始搜索
        waitTime = 10;
      }
      this.searchTimer = setTimeout(function () {
        _this3.clearMap();
        _this3.searchByKeyword(value);
        clearTimeout(_this3.searchTimer);
      }, waitTime);
    },

    // 根据地图坐标进行查询具体地址
    searchByPoint: function searchByPoint(ev) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var geocoder;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                geocoder = new _this4.aMap.Geocoder();
                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  geocoder.getAddress(ev.lnglat, function (status, result) {
                    if (status == 'complete') {
                      var regeocode = result.regeocode;
                      var address = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(regeocode, 'formattedAddress');
                      resolve(address);
                    } else if (status == 'no_data') {
                      _this4.$message.info(_this4.$t('tip.no_data_found'));
                      reject();
                    }
                  });
                }));

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    searchByKeyword: function searchByKeyword(keyword) {
      this.loadingResult = true;
      var placeSearch = new this.aMap.PlaceSearch();
      var that = this;
      placeSearch.search(keyword, function (status, result) {
        // 查询成功时，result即对应匹配的POI信息
        if (result.poiList && result.poiList.pois) {
          var pois = result.poiList.pois;
          var markers = [];
          that.loadingResult = false;
          for (var i = 0; i < pois.length; i++) {
            var poi = pois[i];
            var marker = new that.aMap.Marker({
              icon: that.marker_green,
              anchor: 'bottom-center',
              position: poi.location, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
              title: poi.name,
              extData: {
                id: MARKER_PREFIX + (i + 1),
                address: poi.name,
                search: true
              }
            });
            that.addMarker(marker);
            // 将创建的点标记添加到已有的地图实例：
            markers.push(marker);
          }
          that.pois = pois;
          that.markers = markers;
          that.map.setFitView();
        }
      });
    },

    // 添加地图marker
    addMarker: function addMarker(marker) {
      this.map.add(marker);
      // 注册marker 点击事件
      marker.on('click', this.handleMarkerClick);
    },

    // marker 点击事件
    handleMarkerClick: function handleMarkerClick(e) {
      // 设置为 target marker
      this.updateCurrentMarker(e.target);
    },

    // 清除地图覆盖物
    clearMap: function clearMap() {
      if (this.markers.length) {
        this.map.remove(this.markers);
        this.markers = [];
      }
      // 清除pick 的marker
      if (this.pickMarker) {
        this.map.remove(this.pickMarker);
        this.pickMarker = undefined;
      }
      // 清除pick 的marker
      if (this.targetMarker) {
        this.map.remove(this.targetMarker);
      }
    },

    // 点击搜索结果地图缩放到对应位置
    handleSearchResultClick: function handleSearchResultClick(item, index) {
      this.map.setZoom(15);
      this.map.panTo(item.location);
      this.updateMarkerBySearchIndex(item, index);
    },

    // 根据当前选中项和索引更新 当前的marker
    updateMarkerBySearchIndex: function updateMarkerBySearchIndex(item, index) {
      // 在地图上获取当前地名对应的marker对应
      var targetMarker = void 0;
      // 根据index 从当前 marker 列表获取当前电机的 marker
      for (var i = 0; i < this.markers.length; i++) {
        var marker = this.markers[i];
        var extData = marker.getExtData();
        if (extData.id == MARKER_PREFIX + (index + 1)) {
          targetMarker = marker;
        }
      }
      if (targetMarker) {
        this.updateTargetMarkerIcon(targetMarker, this.marker_red);
        this.updateCurrentMarker(targetMarker);
      }
    },

    // 更新最新使用的 marker
    updateTargetMarkerIcon: function updateTargetMarkerIcon(marker, icon) {
      marker.setIcon(icon);
      marker.setzIndex(this.markerZIndex++);
    },
    clearAddress: function clearAddress() {
      this.clearMap();
      this.keyword = '';
      this.pois = [];
      this.address = '';
      this.targetMarker = undefined;
    },
    hide: function hide() {
      this.visible = false;
    },
    handleCancle: function handleCancle() {
      this.hide();
    },
    handleConfirm: function handleConfirm() {
      this.$messageBox({
        icon: 'warning', // --->弹窗类型 非必填 [success √,warning ！,error X]
        severity: 'medium',
        title: this.confirmMsg || this.$t('component.mapbox.default_confirm_title'), // -->副标题 非必填
        btnText: this.$t('btn.confirm'), // -->按钮内文字 非必填,
        callBack: this.confirmAddress
      });
    },
    confirmAddress: function confirmAddress() {
      var position = this.targetMarker.getPosition();
      var lnglat = [position.lng, position.lat];
      if (this.confirm) {
        this.confirm(lnglat, this.address);
      }
      this.hide();
    },
    initMapData: function initMapData() {
      if (this.lnglat && this.lnglat.length) {
        var lnglat = this.lnglat;
        // 添加该点为初始化 marker
        var marker = new this.aMap.Marker({
          icon: this.marker_red,
          anchor: 'bottom-center',
          position: lnglat, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          title: this.location,
          extData: {
            id: MARKER_PREFIX + 'init',
            address: this.location,
            search: false
          }
        });
        this.map.setZoom(15);
        this.map.panTo(lnglat);
        this.updateCurrentMarker(marker);
      }
    },
    handleClose: function handleClose() {}
  },
  computed: {
    disabled: function disabled() {
      return !this.address;
    }
  },
  watch: {
    // lnglat(val, oldVal) {
    //   // oldVal 不存在说明是第一个加载
    //   if (this.map) {
    //     this.clearAddress();
    //     if (val && val.length) {
    //       this.initMapData();
    //     }
    //   }
    // },
    mode: function mode(val, oldVal) {
      // 模式变化需要更新map 事件
    }
  },
  updated: function updated() {},
  mounted: function mounted() {
    this.loadMap();
  },
  destory: function destory() {
    // 注销地图事件
  }
});

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_language__ = __webpack_require__(261);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Index',
  props: {
    type: {
      type: String,
      require: true
    },
    callBack: {
      type: Function,
      default: function (event) {
        this.default.methods.close();
      }.bind(this)
    },
    valid: {
      type: Boolean,
      require: false
    },
    approvePlaceholder: {
      type: String
    },
    rejectPlaceholder: {
      type: String
    },
    title: {
      // 弹出框的 title
      type: String
    }
  },
  data: function data() {
    return {
      approvalVisiable: false,
      disabled: false,
      form: {
        comment: ''
      }
    };
  },
  created: function created() {},

  methods: {
    confirm: function confirm(param) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, _ref2, err, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.disabled = true;

                if (!_this.callBack) {
                  _context.next = 8;
                  break;
                }

                _context.next = 4;
                return _this.$awaitWrap(_this.callBack(param));

              case 4:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                err = _ref2[0];
                data = _ref2[1];

              case 8:
                _this.disabled = false;
                _this.close();

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    confirmApproval: function confirmApproval() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this2.confirm(_this2.form.comment);
        }
      });
    },
    close: function close() {
      this.approvalVisiable = false;
      this.disabled = false;
    }
  },
  computed: {
    // 默认的提示信息，如果传入了 approvePlaceholder 或者 rejectPlaceholder，使用传入的值，没有传入使用默认值，默认值需要根据 valid true 或者false 增加选填必填提示
    placeholder: function placeholder() {
      var placeholder = '';
      var approvePlaceholder = this.approvePlaceholder,
          rejectPlaceholder = this.rejectPlaceholder;

      if (approvePlaceholder || rejectPlaceholder) {
        // 存在使用传入的值
        placeholder = approvePlaceholder || rejectPlaceholder;
      } else {
        // 不存在使用默认的值
        placeholder = this.type === 'approve' ? this.$t('popup.approve_placeholder') : this.$t('popup.reject_placeholder');
        // 根据是否必填增加 optional 或者 required 信息,reject 情况下一定必填，valid 为 true 一定必填
        if (this.valid || this.type === 'reject') {
          placeholder += '(' + this.$t('popup.required') + ')';
        } else {
          placeholder += '(' + this.$t('popup.optional') + ')';
        }
      }
      return placeholder;
    },
    changeRules: function changeRules() {
      var rules = void 0;
      if (this.type === 'reject' || this.valid) {
        rules = {
          comment: [{ required: true, message: 'Comment is required', trigger: 'blur' }]
        };
      } else {
        rules = { comment: [] };
      }
      return rules;
    }
  }
});

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Index',
  props: {
    callBack: {
      type: Function,
      default: function (event) {
        this.default.methods.close();
      }.bind(this)
    },
    title: {
      // 弹出框的 title
      type: String
    },
    placeholder: {
      // 弹出框的 title
      type: String
    }
  },
  data: function data() {
    return {
      commentBoxVisiable: false,
      disabled: false,
      form: {
        comment: ''
      }
    };
  },
  created: function created() {},

  methods: {
    confirm: function confirm(param) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, _ref2, err, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.disabled = true;

                if (!_this.callBack) {
                  _context.next = 8;
                  break;
                }

                _context.next = 4;
                return _this.$awaitWrap(_this.callBack(param));

              case 4:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                err = _ref2[0];
                data = _ref2[1];

              case 8:
                _this.disabled = false;
                _this.close();

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleConfirm: function handleConfirm() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this2.confirm(_this2.form.comment);
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    handleCommentBlur: function handleCommentBlur() {
      this.form.comment = this.form.comment.trim();
    },
    close: function close() {
      this.commentBoxVisiable = false;
      this.disabled = false;
    }
  },
  computed: {
    rules: function rules() {
      var rules = {
        comment: [{ required: true, message: this.placeholder, trigger: 'blur' }]
      };
      return rules;
    }
  }
});

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);

//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dict',
  props: {
    code: { // 字典表对应的key
      type: String,
      require: true
    },
    value: { // 字典表对应的key
      type: [String, Number],
      require: true
    },
    abbr: { // 是否是简称模式,简称模式下直接显示简称
      type: Boolean,
      default: false
    },
    empty: { // 控制显示的内容，例如'-'
      type: String
    }
  },
  data: function data() {
    return {};
  },

  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['dictMap']), {
    getValueSting: function getValueSting() {
      var _this = this;

      var dict_str = this.empty || '';
      if (this.dictMap[this.code] && (this.value || this.isZero(this.value))) {
        var options = this.dictMap[this.code].options;
        options.map(function (item, index) {
          if (item.value.toLowerCase() == _this.value.toLowerCase()) {
            if (_this.abbr) {
              dict_str = item.abbreviation;
            } else {
              dict_str = _this.$languageChoose({
                zh: item.text,
                en: item.textEn
              });
            }
          }
        });
      }
      return dict_str;
    }
  }),
  created: function created() {
    if (!this.dictMap[this.code]) {
      this.initDictData();
    }
  },

  methods: {
    // 获取字典数据
    initDictData: function initDictData() {
      // 根据字典Code, 初始化字典数组
      this.$getDictionary(this.code).then(function (res) {});
    },
    isZero: function isZero(str) {
      return str == '0' || str == 0;
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var whiteCodeList = ['city', 'province', 'airba_category']; // 需要单独请求和处理
// import { getDictItemsByCode } from '@/api/dict/dict';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DictSelect',
  props: {
    code: { // 字典表对应的key
      type: String,
      require: true
    },
    type: { // 选择类型, radio/checkbox/select, 默认为 select
      type: String,
      default: 'select'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    collapseTags: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    },
    disabled: Boolean, // 是否禁用
    value: [String, Number],
    all: { // 是否需要添加 All 选项
      type: Boolean,
      default: false
    },
    allKey: { // 选择 all 时 set 的key, 默认为 undefined
      default: undefined
    },
    clearable: {
      type: Boolean,
      default: true
    },
    changeCallback: {
      type: Function
    },
    disabledOptions: {
      type: Function,
      default: function _default() {
        return false;
      }
    }
  },
  model: {
    prop: 'value',
    event: 'changeCodeValue'
  },
  data: function data() {
    return {
      localValue: undefined
    };
  },

  watch: {
    code: {
      immediate: true,
      handler: function handler() {
        this.initDictData();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['dictMap']), {
    getValueSting: function getValueSting() {
      return this.value && this.dictMap[this.code] ? this.multiple ? this.value : this.value.toString() : undefined;
    },
    dictOptions: function dictOptions() {
      var options = [];
      if (this.all) {
        // 添加all 选项
        options.push({
          text: '全部',
          textEn: 'All',
          value: this.allKey
        });
      }
      if (this.dictMap[this.code]) {
        options = options.concat(this.dictMap[this.code].options);
      }
      return options;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['getDictProvinceList', 'getDictAribaCategoryList']), {
    // 获取字典数据
    initDictData: function initDictData() {
      if (whiteCodeList.indexOf(this.code) != -1) {
        switch (this.code) {
          case 'province':
            this.getDictProvinceList();
            break;
          case 'airba_category':
            this.getDictAribaCategoryList();
            break;
        }
      } else {
        // 根据字典Code, 初始化字典数组
        this.$getDictionary(this.code).then(function (res) {});
      }
    },
    handleChange: function handleChange(val) {
      this.$emit('changeCodeValue', val);
      // 触发change 事件
      if (this.code === 'airba_category') {
        this.$emit('change', val, this.dictOptions, this.code);
      } else {
        this.$emit('change', val, this.code);
      }
    }
  }),
  mounted: function mounted() {}
});

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VMessage',
  mounted: function mounted() {
    this.StartTime();
  },
  data: function data() {
    return {
      message: '',
      show: false,
      timer: null
    };
  },

  methods: {
    StartTime: function StartTime() {
      var _this = this;

      this.show = true;
      if (this.timer) {
        window.clearTimeOut(this.timer);
      } else {
        this.timer = setTimeout(function () {
          // this.ref.vmessages.className += ' message-out'
          _this.show = false;
        }, 3000);
      }
    }
  }
});

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Index',
  props: {
    icon: {
      type: String
    },
    severity: {
      type: String,
      default: 'medium'
    },
    title: {
      type: String,
      require: true
    },
    subTitle: {
      type: String
    },
    btnText: {
      type: String,
      default: 'Confirm'
    },
    callBack: {
      type: Function,
      default: function (event) {
        this.default.methods.close();
      }.bind(this)
    },
    cancelCallBack: {
      type: Function,
      default: function (event) {
        this.default.methods.close();
      }.bind(this)
    },
    onClose: {
      type: Function,
      default: function (event) {
        this.default.methods.close();
      }.bind(this)
    },
    showClose: {
      type: Boolean,
      default: false
    },
    showCancel: {
      type: Boolean,
      default: false
    },
    autoConfirm: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      centerDialogVisible: false,
      disabled: false
    };
  },

  methods: {
    confirm: function confirm() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.disabled = true;

                if (!_this.callBack) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return _this.$awaitWrap(_this.callBack());

              case 4:
                _this.close();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    cancel: function cancel() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.disabled = true;

                if (!_this2.cancelCallBack) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return _this2.$awaitWrap(_this2.cancelCallBack());

              case 4:
                _this2.close();

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleClose: function handleClose() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.disabled = true;

                if (!_this3.onClose) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 4;
                return _this3.$awaitWrap(_this3.onClose());

              case 4:
                _this3.close();

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    close: function close() {
      this.centerDialogVisible = false;
      this.disabled = false;
    }
  }
});

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_xlsx__ = __webpack_require__(1728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_xlsx__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Index',
  props: {
    data: Object || String,
    title: String,
    download: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      centerDialogVisible: false,
      sheetNames: [], // sheet 名称数组
      activeSheet: '',
      sheetContent: undefined,
      workbook: undefined
    };
  },

  methods: {
    parseExcelFile: function parseExcelFile(file) {
      var reader = new FileReader();
      var that = this;
      reader.onloadend = function (event) {
        var arrayBuffer = reader.result;
        var options = { type: 'array' };
        var workbook = __WEBPACK_IMPORTED_MODULE_0_xlsx___default.a.read(arrayBuffer, options);
        var sheetNames = workbook.SheetNames;
        that.sheetNames = sheetNames;
        that.workbook = workbook;
        that.activeSheet = sheetNames[0];
        that.setSheetContent(that.activeSheet);
      };
      var blob = void 0;
      if (!(file instanceof Blob)) {
        blob = new Blob([file]);
      } else {
        blob = file;
      }
      try {
        reader.readAsArrayBuffer(blob);
      } catch (e) {
        this.$message.error(e);
      }
    },
    handleSheetClick: function handleSheetClick(tab, event) {
      this.setSheetContent(tab.name);
    },
    setSheetContent: function setSheetContent(sheetName) {
      if (this.workbook) {
        var sheet = this.workbook.Sheets[sheetName];
        if (__WEBPACK_IMPORTED_MODULE_0_xlsx___default.a.utils.sheet_to_row_object_array(sheet).length) {
          var sheetContent = __WEBPACK_IMPORTED_MODULE_0_xlsx___default.a.utils.sheet_to_html(sheet);
          this.$refs.result.innerHTML = sheetContent;
        } else {
          this.$refs.result.innerHTML = 'No Items';
        }
      }
    },
    handleDownload: function handleDownload() {
      this.$downloadFile(this.data, this.title);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.parseExcelFile(_this.data);
    });
  }
});

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Index',
  props: {
    data: Object || String,
    title: String,
    download: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      centerDialogVisible: false,
      imageUrl: ''
    };
  },

  methods: {
    toBase64: function toBase64(file) {
      var that = this;
      var reader = new FileReader();
      reader.onloadend = function () {
        that.imageUrl = reader.result;
      };
      var blob = void 0;
      if (!(file instanceof Blob)) {
        blob = new Blob([file]);
      } else {
        blob = file;
      }
      reader.readAsDataURL(blob);
    },
    handleDownload: function handleDownload() {
      this.$downloadFile(this.data, this.title);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.toBase64(_this.data);
    });
  }
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = ({
  list: function list(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/bus/busBudgetDetail/list', params);
  },
  add: function add(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].post('/rocheManage/bus/busBudgetDetail/add', params);
  },
  edit: function edit(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].put('/rocheManage/bus/busBudgetDetail/edit', params);
  },
  delete: function _delete(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].delete('/rocheManage/bus/busBudgetDetail/delete', params);
  },
  deleteBatch: function deleteBatch(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].delete('/rocheManage/bus/busBudgetDetail/deleteBatch', params);
  },
  exportXls: function exportXls(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/bus/busBudgetDetail/exportXls', params, { responseType: 'blob' });
  },
  queryMainBudget: function queryMainBudget(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/bus/busBudgetMain/queryByEntity', params);
  },
  editMainBudget: function editMainBudget(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].put('/rocheManage/bus/busBudgetMain/edit', params);
  },
  importUrl4Excel: function importUrl4Excel(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].postForm('/rocheManage/bus/busBudgetDetail/importExcel', params);
  },
  importValidUrl4Excel: function importValidUrl4Excel(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].postForm('/rocheManage/bus/busBudgetDetail/importExcelValid', params);
  }
});

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = ({
  list: function list(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/bus/busTreatResult/list', params);
  },
  add: function add(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].post('/rocheManage/bus/busTreatResult/add', params);
  },
  edit: function edit(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].put('/rocheManage/bus/busTreatResult/edit', params);
  },
  delete: function _delete(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].delete('/rocheManage/bus/busTreatResult/delete', params);
  },
  deleteBatch: function deleteBatch(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].delete('/rocheManage/bus/busTreatResult/deleteBatch', params);
  },
  exportXls: function exportXls(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/bus/busTreatResult/exportXls', params, { responseType: 'blob' });
  },
  importUrl4Excel: function importUrl4Excel(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].postForm('/rocheManage/bus/busTreatResult/importExcel', params);
  },
  importValidUrl4Excel: function importValidUrl4Excel(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].postForm('/rocheManage/bus/busTreatResult/importExcelValid', params);
  }
});

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = ({
  list: function list(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/bus/busHospitalLevel/list', params);
  },
  add: function add(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].postForm('/rocheManage/bus/busHospitalLevel/add', params);
  },
  edit: function edit(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].putForm('/rocheManage/bus/busHospitalLevel/edit', params);
  },
  delete: function _delete(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].delete('/rocheManage/bus/busHospitalLevel/delete', params);
  },
  deleteBatch: function deleteBatch(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].delete('/rocheManage/bus/busHospitalLevel/deleteBatch', params);
  },
  exportXls: function exportXls(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/bus/busHospitalLevel/exportXls', params, { responseType: 'blob' });
  }
});

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = ({
    strategyHospital4Strategy: function strategyHospital4Strategy(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/bus/busStrategyHospital/exportXls', params, { responseType: 'blob' });
    },
    strategyOffice: function strategyOffice(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/bus/busStrategyOffice/exportXls', params, { responseType: 'blob' });
    },
    strategyHospital4Hospital: function strategyHospital4Hospital(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/bus/busStrategyHospital/exportStrategyHospitalXls', params, { responseType: 'blob' });
    },
    speakerMeetingType: function speakerMeetingType(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/bus/busSpeakerMeetingType/exportXls', params, { responseType: 'blob' });
    }
});

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = ({
  list: function list(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/bus/busSpeakerLevel/list', params);
  },
  add: function add(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].postForm('/rocheManage/bus/busSpeakerLevel/add', params);
  },
  edit: function edit(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].putForm('/rocheManage/bus/busSpeakerLevel/edit', params);
  },
  delete: function _delete(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].delete('/rocheManage/bus/busSpeakerLevel/delete', params);
  },
  deleteBatch: function deleteBatch(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].delete('/rocheManage/bus/busSpeakerLevel/deleteBatch', params);
  },
  exportXls: function exportXls(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/bus/busSpeakerLevel/exportXls', params, { responseType: 'blob' });
  }
});

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = ({
  list: function list(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/bus/busStrategy/list', params);
  },
  add: function add(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].postForm('/rocheManage/bus/busStrategy/add', params);
  },
  edit: function edit(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].putForm('/rocheManage/bus/busStrategy/edit', params);
  },
  delete: function _delete(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].delete('/rocheManage/bus/busStrategy/delete', params);
  },
  deleteBatch: function deleteBatch(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].delete('/rocheManage/bus/busStrategy/deleteBatch', params);
  },
  exportXls: function exportXls(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/bus/busStrategy/exportXls', params, { responseType: 'blob' });
  },
  importUrl4Excel: function importUrl4Excel(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].postForm('/rocheManage/bus/busStrategy/importExcel', params);
  },
  importValidUrl4Excel: function importValidUrl4Excel(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].postForm('/rocheManage/bus/busStrategy/importExcelValid', params);
  }
});

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return downloadManual; });
/* unused harmony export getManualInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_axios__ = __webpack_require__(60);
var _this = this;



// 获取首页所有task 列表
var downloadManual = function downloadManual(params) {
  var requestURL = '/e2estservice/upload/preview';
  var fileS3Url = params.fileS3Url;

  if (!fileS3Url) {
    _this.$message.error('缺少请求参数');
    return;
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_axios__["a" /* default */])({
    url: requestURL + '?fileS3Url=' + fileS3Url,
    method: 'post',
    responseType: 'arraybuffer'
  });
};

// 获取用户手册信息
var getManualInfo = function getManualInfo(params) {
  var requestURL = '/e2estservice/sys/file/queryByType';
  return __WEBPACK_IMPORTED_MODULE_0__util_axios__["a" /* default */].get(requestURL, { params: params });
};

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_axios__ = __webpack_require__(60);




/* harmony default export */ __webpack_exports__["a"] = ({
  userTokenLogin: function userTokenLogin(params) {
    // debugger
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__util_axios__["a" /* default */].get('/rocheManage/sys/loginByToken?token=' + params.token).then(function (response) {
        resolve(response);
      }, function (err) {
        reject(err);
      });
    });
  },
  userCookieLogin: function userCookieLogin(params) {
    // debugger
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__util_axios__["a" /* default */].post('/rocheManage/sys/login3', {
        username: params.username,
        password: params.password
      }).then(function (response) {
        resolve(response);
      }, function (err) {
        reject(err);
      });
    });
  },


  // 获取用户信息
  getUserInfo: function getUserInfo(params) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__util_axios__["a" /* default */].post('/rocheManage/sys/userInfo').then(function (response) {
        resolve(response);
      }, function () {});
    });
  }
});

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = ({
  list: function list(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/meeting/pubMeeting/planLibraryList', params);
  },
  exportXls: function exportXls(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/meeting/pubMeeting/planLibraryExportXls', params, { responseType: 'blob' });
  },
  queryMainApplication: function queryMainApplication(params) {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/meeting/pubMeeting/planLibraryMeetingSummary', params);
  }
});

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = ({
    list: function list(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/sys/dictItem/list', params);
    },
    add: function add(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].post('/rocheManage/sys/dictItem/add', params);
    },
    edit: function edit(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].put('/rocheManage/sys/dictItem/edit', params);
    },
    delete: function _delete(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].delete('/rocheManage/sys/dictItem/delete', params);
    }
});

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = ({
    list: function list(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/message/sysMessageTemplate/list', params);
    },
    edit: function edit(params) {
        return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].put('/rocheManage/message/sysMessageTemplate/edit', params);
    }
});

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_axios__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(20);



/* unused harmony default export */ var _unused_webpack_default_export = ({
    list: function list(params) {
        return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/user/list', params);
    },
    add: function add(params) {
        return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].post('/rocheManage/sys/user/add', params);
    },
    edit: function edit(params) {
        return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].put('/rocheManage/sys/user/edit', params);
    },
    delete: function _delete(params) {
        return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].delete('/rocheManage/sys/user/delete', params);
    },
    deleteBatch: function deleteBatch(params) {
        return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].delete('/rocheManage/sys/user/deleteBatch', params);
    },
    exportXls: function exportXls(params) {
        return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].get('/rocheManage/sys/user/exportXls', params, { responseType: 'blob' });
    },
    importUrl4Excel: function importUrl4Excel() {
        return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].getBaseURL() + '/rocheManage/sys/user/importExcel';
    }
});

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(20);


/* unused harmony default export */ var _unused_webpack_default_export = ({
  getUserInfo: function getUserInfo() {
    return __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].get('/rocheManage/home/user/userInfo', {});
  }
});

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: '确定',
      clear: '清空'
    },
    datepicker: {
      now: '此刻',
      today: '今天',
      cancel: '取消',
      clear: '清空',
      confirm: '确定',
      selectDate: '选择日期',
      selectTime: '选择时间',
      startDate: '开始日期',
      startTime: '开始时间',
      endDate: '结束日期',
      endTime: '结束时间',
      prevYear: '前一年',
      nextYear: '后一年',
      prevMonth: '上个月',
      nextMonth: '下个月',
      year: '年',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      // week: '周次',
      weeks: {
        sun: '日',
        mon: '一',
        tue: '二',
        wed: '三',
        thu: '四',
        fri: '五',
        sat: '六'
      },
      months: {
        jan: '一月',
        feb: '二月',
        mar: '三月',
        apr: '四月',
        may: '五月',
        jun: '六月',
        jul: '七月',
        aug: '八月',
        sep: '九月',
        oct: '十月',
        nov: '十一月',
        dec: '十二月'
      }
    },
    select: {
      loading: '加载中',
      noMatch: '无匹配数据',
      noData: '无数据',
      placeholder: '请选择'
    },
    cascader: {
      noMatch: '无匹配数据',
      loading: '加载中',
      placeholder: '请选择',
      noData: '暂无数据'
    },
    pagination: {
      goto: '跳至',
      pagesize: '条/页',
      total: '共 {total} 条',
      pageClassifier: '页'
    },
    messagebox: {
      title: '提示',
      confirm: '确定',
      cancel: '取消',
      error: '输入的数据不合法!'
    },
    upload: {
      deleteTip: '按 delete 键可删除',
      delete: '删除',
      preview: '查看图片',
      continue: '继续上传'
    },
    table: {
      emptyText: '暂无数据',
      confirmFilter: '筛选',
      resetFilter: '重置',
      clearFilter: '全部',
      sumText: '合计'
    },
    tree: {
      emptyText: '暂无数据'
    },
    transfer: {
      noMatch: '无匹配数据',
      noData: '无数据',
      titles: ['列表 1', '列表 2'],
      filterPlaceholder: '请输入搜索内容',
      noCheckedFormat: '共 {total} 项',
      hasCheckedFormat: '已选 {checked}/{total} 项'
    },
    image: {
      error: '加载失败'
    },
    pageHeader: {
      title: '返回'
    },
    popconfirm: {
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    }
  }
};

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export filterGlobalPermission */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(174);




__WEBPACK_IMPORTED_MODULE_1_vue___default.a.directive('has', {
  inserted: function inserted(el, binding, vnode) {
    // console.log("页面权限控制----");
    filterGlobalPermission(el, binding, vnode);
  }
});

/**
 * 全局权限控制
 */
function filterGlobalPermission(el, binding, vnode) {
  // 设置全局配置是否有命中
  var invalidFlag = true; // 无效命中

  var perms = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user.perms;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(perms.auth), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var auth = _step.value;

      // console.log('auauth.type == ', auth);
      // 2 代表按钮权限
      if (auth.type == 1 && auth.action === binding.value) {
        invalidFlag = false;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (invalidFlag) {
    el.parentNode.removeChild(el);
  }
}

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hasPermission__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__positive__ = __webpack_require__(705);



/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);

// 针对 el-input做的限制，只能输入正整数
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.directive('positive', {
  bind: function bind(el) {
    var input = el.getElementsByTagName('input')[0];
    input.onkeyup = function (e) {
      if (input.value.length === 1) {
        input.value = input.value.replace(/[^0-9]/g, '');
      } else {
        input.value = input.value.replace(/[^\d]/g, '');
      }
      trigger(input, 'input');
    };
    input.onblur = function (e) {
      if (input.value.length === 1) {
        input.value = input.value.replace(/[^0-9]/g, '');
      } else {
        input.value = input.value.replace(/[^\d]/g, '');
      }
      trigger(input, 'input');
    };
  }
});
var trigger = function trigger(el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
};

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);


var eventHub = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a();

/* harmony default export */ __webpack_exports__["a"] = (eventHub);

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_utils__ = __webpack_require__(207);





// 空值过滤器
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('emptyFilter', function (value) {
  return __WEBPACK_IMPORTED_MODULE_1__main__["default"].$isNotEmpty(value) ? value : '-';
});

// 时间显示
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('TimeFormat', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('YYYY/MM/DD,HH:mm:ss');
  }
  return '';
});

// 时间显示
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('SimpleTimeFormat', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('YYYY/MM/DD');
  }
  return '';
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('DateFormat', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('YYYY-MM-DD');
  }
  return '-';
});

// 时间显示
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('HourMinutesFormat', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('HH:mm');
  }
  return '-';
});

// 时间显示
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('DateHourMinutesFormat', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('YYYY-MM-DD HH:mm');
  }
  return '-';
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$formatMoney = function (value) {
  if (value && value != null) {
    value = String(Math.round(value * 100) / 100);
    var left = value.split('.')[0];
    var right = value.split('.')[1];
    right = right ? right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0' : '.00';
    var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
    return (Number(value) < 0 ? '-' : '') + temp.join(',').split('').reverse().join('') + right;
  } else if (value === 0) {
    return '0.00';
  } else {
    return '-';
  }
};

// 金额万元
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('TenThousandMoneyFormat', function (value) {
  return (value / 100 / 100).toFixed(2);
});

// 金额千元
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('ThousandMoneyFormat', function (value) {
  return __WEBPACK_IMPORTED_MODULE_3__util_utils__["a" /* default */].$toThousand(value, 1, 0);
});

// 金额千分符
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('MoneyFormat', function (value) {
  return value ? value.toLocaleString() : value === 0 ? 0 : '';
});

// 金额千分符
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('MoneyFormatWithDefaultValue', function (value) {
  if (value && value != null) {
    value = String(Math.round(value * 100) / 100);
    var left = value.split('.')[0];
    var right = value.split('.')[1];
    right = right ? right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0' : '.00';
    var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
    return (Number(value) < 0 ? '-' : '') + temp.join(',').split('').reverse().join('') + right;
  } else if (value === 0) {
    return '0.00';
  } else {
    return '-';
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('FileSizeFormat', function (value) {
  if (!value) return 0;
  var kb = 1024,
      mb = 1024 * 1024,
      gb = 1024 * 1024 * 1024;
  if (value > gb) {
    return (value / gb).toFixed(2) + 'G';
  } else if (value > mb) {
    return (value / mb).toFixed(2) + 'M';
  } else if (value > kb) {
    return (value / kb).toFixed(2) + 'K';
  } else {
    return value + 'B';
  }
});

// 获取文件后缀名
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('FileSuffixName', function (value) {
  if (!value) return '';
  var arr = value.split('.');
  return arr[arr.length - 1];
});

// 后台返回时间处理成日期
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('Time2Date', function (value) {
  if (!value) return '';
  var result = '';
  result = __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('YYYY/MM/DD');
  return result;
});

// 去掉html
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('removeHtmlTag', function (value) {
  return value.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '').replace(/<[^>]+?>/g, '').replace(/\s+/g, ' ').replace(/ /g, ' ').replace(/>/g, ' ').replace(/&nbsp;/g, ' ');
});

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);

// const PDFViewer = Vue.extend(require('./PDFViewer.vue'));
// import PDFViewer from './PDFViewer.vue'
var PDFViewer = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.extend(__webpack_require__(1534));
var pdfViewerInstance = void 0;
var pdfViewer = function pdfViewer(options) {
  // 生成组件

  // 组件需要挂载在dom元素上
  // const pdfviewerEl = document.querySelectorAll('.common_pdfviewer_wrapper')


  if (!pdfViewerInstance) {
    pdfViewerInstance = new PDFViewer({
      // innerData: options.fileData
    });
    pdfViewerInstance.vm = pdfViewerInstance.$mount();
    pdfViewerInstance.dom = pdfViewerInstance.vm.$el;
    document.body.appendChild(pdfViewerInstance.dom);
  }
  pdfViewerInstance.visible = true;
  pdfViewerInstance.innerData = options.fileData;
  pdfViewerInstance.title = options.title;
  pdfViewerInstance.fileName = options.fileName;
  pdfViewerInstance.download = options.download;
  pdfViewerInstance.s3Path = options.s3Path;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.$PDFViewer = pdfViewer;
  }
});

// export default pdfViewer

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.$checkAfterMeeting = function (meetingType, startDate, endDate) {
      meetingType = 'COMM_ST';
      var meetingCodeObj = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.breadcrumbList.filter(function (x) {
        return ['stlifecycle', 'splifecycle', 'mdlifecycle'].some(function (v) {
          return x.name === v;
        });
      });
      var meetingCode = '';
      if (meetingCodeObj.length > 0) {
        if (meetingCodeObj[0].title.includes('~')) {
          var meetingCodeArr = meetingCodeObj[0].title.split('-');
          meetingCodeArr.pop();
          meetingCode = meetingCodeArr.join('-');
        } else {
          meetingCode = meetingCodeObj[0].title;
        }
      }
      if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.unlockMeetingMap[meetingCode] && __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.unlockMeetingMap[meetingCode].meetingLock === '1') {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()().isAfter(__WEBPACK_IMPORTED_MODULE_1_moment___default()(endDate).add(5000, 'days'), 'days');
      }
      var check = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.afterMeetingDays.filter(function (x) {
        return x.meetingType.toLowerCase() === meetingType.toLowerCase();
      });
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()().isAfter(__WEBPACK_IMPORTED_MODULE_1_moment___default()(endDate).add(check[0].days * 1, 'days'), 'days');
    };
  }
});

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_vue__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);



var mapInstance = void 0;
var mapBox = function mapBox(opts) {
  var MapConstructor = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.extend(__WEBPACK_IMPORTED_MODULE_0__index_vue___default.a);

  var mapWrap = document.createElement('div');
  mapWrap.className = 'map-box-warp';
  //   if (!mapInstance) {

  //   }
  mapInstance = new MapConstructor({
    el: mapWrap
  });
  document.body.appendChild(mapInstance.$el);
  if (opts) {
    mapInstance.mode = opts.mode;
    mapInstance.lnglat = opts.lnglat;
    mapInstance.location = opts.location;
    mapInstance.title = opts.title;
    mapInstance.confirm = opts.confirm;
    mapInstance.confirmMsg = opts.confirmMsg;
  }
  mapInstance.visible = true;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.$mapBox = mapBox;
  }
});

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RewriteLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_vue__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_vue__);


var _i18n = null;

// 国际化问题
function RewriteLocale(i18n) {
  _i18n = i18n;
}

/* harmony default export */ __webpack_exports__["b"] = ({
  install: function install(Vue, options) {
    Vue.prototype._i18n = _i18n;
    Vue.prototype.$approvalBox = function (opts) {
      // 继承approvalBox组件
      var ApprovalConstructor = Vue.extend(__WEBPACK_IMPORTED_MODULE_0__index_vue___default.a);
      // 创建一个新元素
      var approvalWrap = document.createElement('div');
      approvalWrap.className = 'approval-box-wrap';
      // 实例化approvalBox组件，并将组件挂在到新创建的approval-box-wrap元素上
      var approvalInstace = new ApprovalConstructor({
        el: approvalWrap
      });
      // 或者使用 approvalInstace.$mount(approvalWrap)挂载
      document.body.appendChild(approvalInstace.$el);
      // 显示组件内容
      if (opts) {
        approvalInstace.type = opts.type;
        approvalInstace.callBack = opts.callBack;
        approvalInstace.valid = opts.valid;
        approvalInstace.approvePlaceholder = opts.approvePlaceholder;
        approvalInstace.rejectPlaceholder = opts.rejectPlaceholder;
        approvalInstace.title = opts.title;
      }
      approvalInstace.approvalVisiable = true;
    };
  }
});

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_vue__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_vue__);


/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.$commentBox = function (opts) {
      // 继承approvalBox组件
      var CommentConstructor = Vue.extend(__WEBPACK_IMPORTED_MODULE_0__index_vue___default.a);
      // 创建一个新元素
      var commentWrap = document.createElement('div');
      commentWrap.className = 'comment-box-wrap';
      // 实例化approvalBox组件，并将组件挂在到新创建的approval-box-wrap元素上
      var approvalInstace = new CommentConstructor({
        el: commentWrap
      });
      // 或者使用 approvalInstace.$mount(commentWrap)挂载
      document.body.appendChild(approvalInstace.$el);
      // 显示组件内容
      if (opts) {
        approvalInstace.callBack = opts.callBack;
        approvalInstace.placeholder = opts.placeholder;
        approvalInstace.title = opts.title;
      }
      approvalInstace.commentBoxVisiable = true;
    };
  }
});

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/**
 * @author 阿怼
 * @date 2020-11-23 17:24
 */


var vCopy = {
  /*
    bind 钩子函数，第一次绑定时调用，可以在这里做初始化设置
    el: 作用的 dom 对象
    value: 传给指令的值，也就是我们要 copy 的值
  */
  bind: function bind(el, _ref) {
    var value = _ref.value;

    el.$value = value; // 用一个全局属性来存传进来的值，因为这个值在别的钩子函数里还会用到
    el.handler = function () {
      if (!el.$value) {
        return;
      }
      // 动态创建 textarea 标签
      var textarea = document.createElement('textarea');
      // 将该 textarea 设为 readonly 防止 iOS 下自动唤起键盘，同时将 textarea 移出可视区域
      textarea.readOnly = true;
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      // 将要 copy 的值赋给 textarea 标签的 value 属性
      textarea.value = el.$value;
      // 将 textarea 插入到 body 中
      document.body.appendChild(textarea);
      // 选中值并复制
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);
      var result = document.execCommand('Copy');
      if (result) {
        __WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$message.success('复制成功');
      }
      document.body.removeChild(textarea);
    };
    // 绑定点击事件，就是所谓的一键 copy 啦
    el.addEventListener('click', el.handler);
  },

  // 当传进来的值更新的时候触发
  componentUpdated: function componentUpdated(el, _ref2) {
    var value = _ref2.value;

    el.$value = value;
  },

  // 指令与元素解绑的时候，移除事件绑定
  unbind: function unbind(el) {
    el.removeEventListener('click', el.handler);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (vCopy);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__copy_js__ = __webpack_require__(713);

/**
 * @author 阿怼
 * @date 2020-11-23 17:25
 */

// 自定义指令
var directives = {
  copy: __WEBPACK_IMPORTED_MODULE_1__copy_js__["a" /* default */]
};
// 这种写法可以批量注册指令
/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(directives).forEach(function (key) {
      Vue.directive(key, directives[key]);
    });
  }
});

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DictSelect_vue__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DictSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DictSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dict_vue__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dict_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Dict_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(174);




// 获取字典表接口


var DictSelect = {
  install: function install(Vue) {
    Vue.component('DictSelect', __WEBPACK_IMPORTED_MODULE_1__DictSelect_vue___default.a);
    Vue.component('Dict', __WEBPACK_IMPORTED_MODULE_2__Dict_vue___default.a);

    // 获取某个字典项
    Vue.prototype.$getDictionary = function (code, value) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('getDictItemsByCode', code).then(function (res) {
          resolve(res);
        });
      });
    };
  }
};
/* harmony default export */ __webpack_exports__["a"] = (DictSelect);

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_common__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);





/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.$downloadFile = function (data, fileName, contentType) {
      console.log('filename', fileName);
      var filename = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(fileName);
      var fileType = void 0,
          suffix = void 0;
      console.log(contentType);
      if (typeof fileName === 'string') {
        var nameParts = fileName.split('.');
        suffix = nameParts[nameParts.length - 1].toLowerCase();

        var _loop = function _loop(typeKey) {
          __WEBPACK_IMPORTED_MODULE_1__constant_common__["d" /* E2E_FILE_TYPE_ENUM */][typeKey].map(function (item, index) {
            if (item === suffix) {
              fileType = typeKey;
            }
          });
        };

        for (var typeKey in __WEBPACK_IMPORTED_MODULE_1__constant_common__["d" /* E2E_FILE_TYPE_ENUM */]) {
          _loop(typeKey);
        }
      } else if (filename.headers['content-disposition']) {
        var contentDisposition = decodeURIComponent(filename.headers['content-disposition']);
        var str = contentDisposition.split(';')[1];
        filename = str.split('=')[1];
        fileType = filename.split('.')[1];
      } else {
        filename = 'file';
      }

      // if (!fileType) return this.$message.error('无法识别文件类型');
      // let type = '';
      // if (navigator.userAgent.indexOf('Firefox') == -1) {
      //   switch (fileType) {
      //     case 'pdf':
      //       type = 'application/pdf';
      //       break;
      //     case 'excel':
      //       type = 'application/vnd.ms-excel';
      //       break;
      //     case 'word':
      //       type = 'application/msword';
      //       break;
      //     case 'image':
      //       type = 'image/jpeg';
      //       break;
      //     case 'ppt':
      //       type = 'application/vnd.ms-powerpoint';
      //       break;
      //     case 'msg':
      //       type = 'application/octet-stream';
      //       break;
      //     default:
      //       type = '';
      //       return;
      //   }
      // }
      if (navigator.userAgent.indexOf('Edge') > -1 || 'msSaveOrOpenBlob' in navigator) {
        var blob = new Blob([data], filename);
        console.log(blob);
        console.log(window.navigator.msSaveOrOpenBlob(blob, filename));
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_file_saver__["saveAs"])(blob, filename);
        return;
      }
      // if (navigator.userAgent.indexOf('Safari')) {
      //   const oPop = window.open(window.URL.createObjectURL(new Blob([data], filename)), '', 'width=1, height=1, top=5000, left=5000');
      //   oPop.document.execCommand('SaveAs');
      //   oPop.close();
      // }
      var file = new File([data], filename, { type: contentType });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_file_saver__["saveAs"])(file);
      // const url = window.URL.createObjectURL(new Blob([data], { type }));
      // const link = document.createElement('a');
      // link.style.display = 'none';
      // link.href = url;
      // link.setAttribute('download', filename);
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link); // 下载完成移除元素
      // window.URL.revokeObjectURL(url); // 释放掉blob对象
    };

    // 检查返回的数据是否是文件流数据
    Vue.prototype.$checkFileStream = function (data) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var ab = new Buffer(data.data);
        try {
          var resJson = JSON.parse(ab); // 成功返回文件流这行会报错
          // 未获取到文件流，请求以json 格式成功返回了
          reject(resJson);
        } catch (e) {
          // 获取到文件流
          resolve(data);
        }
      });
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(264).Buffer))

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    // 异步事件包装
    Vue.prototype.$awaitWrap = function (promise) {
      if (promise instanceof __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a) {
        return promise.then(function (data) {
          return [null, data];
        }).catch(function (err) {
          console.log(err);
          return [err, null];
        });
      } else {
        console.error('param is not a promise');
        return [null, promise];
      }
    };

    // 异步事件包装
    Vue.prototype.$removeSpace = function (str) {
      var resultStr = '';
      if (str) {
        resultStr = str.replace(/\r\n/g, '').replace(/\n/g, '').replace(/\s/g, '');
      }
      return resultStr;
    };

    // 获取文件名后缀
    Vue.prototype.$getFileSuffix = function (fileName) {
      var fileNameArr = fileName.split('.');
      if (fileNameArr.length > 1) {
        return fileNameArr[fileNameArr.length - 1];
      } else {
        return '';
      }
    };

    // 获取文件名
    Vue.prototype.$getFileNameFromResponse = function (response) {
      var filename = '';
      var contentDisposition = decodeURIComponent(response.headers['content-disposition']);
      var str = contentDisposition.split(';')[1];
      filename = str.split('=')[1];
      return filename;
    };

    // 首字符大写
    Vue.prototype.$upperFirstChar = function (str) {
      if (str.length > 0) {
        return str.replace(str[0], str[0].toUpperCase());
      } else {
        return str;
      }
    };

    // 检查数据是否有重复值
    Vue.prototype.$arrRepeat = function (arr) {
      for (var i = 0; i < arr.length; i++) {
        if (arr.indexOf(arr[i]) != arr.lastIndexOf(arr[i])) {
          return true;
        }
      };
      return false;
    };
  }
});

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_language__ = __webpack_require__(261);


/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.$languageChoose = function (opts) {
      return opts[__WEBPACK_IMPORTED_MODULE_0__util_language__["a" /* default */]] || '-';
    };
  }
});

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loading_vue__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Loading_vue__);

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.component('loading', __WEBPACK_IMPORTED_MODULE_0__Loading_vue___default.a);
  }
});

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);

var MessageBox = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.extend(__webpack_require__(1541));
var instance = void 0;
var message = function message(options) {
  if (typeof options === 'string') {
    options = {
      message: options
    };
  }
  // 生成组件
  instance = new MessageBox({
    data: options
  });
  // 组件需要挂载在dom元素上
  instance.vm = instance.$mount();
  // 根据不同的类型，设置不同消息的背景颜色
  if (options.type) {
    instance.vm.$el.children[0].className += ' ' + options.type;
  }
  document.body.appendChild(instance.vm.$el);
  return instance.vm;
};

var type = ['success', 'info', 'warn', 'error'];
type.forEach(function (type) {
  // console.log('tupe',type)
  message[type] = function (options) {
    if (typeof options === 'string') {
      options = {
        message: options
      };
    }
    options.type = type;
    return message(options);
  };
});

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.$myMessage = message;
    Object.defineProperty(Vue.prototype, '$myMessage', {
      value: message
    });
  }
});

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_vue__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_vue__);


/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.$messageBox = function (opts) {
      // 继承messageBox组件
      var MessageConstructor = Vue.extend(__WEBPACK_IMPORTED_MODULE_0__index_vue___default.a);
      // 创建一个新元素
      var messageWrap = document.createElement('div');
      messageWrap.className = 'message-box-wrap';
      // 实例化messageBox组件，并将组件挂在到新创建的message-box-wrap元素上
      var messageInstace = new MessageConstructor({
        el: messageWrap
      });
      // 或者使用 messageInstace.$mount(messageWrap)挂载
      document.body.appendChild(messageInstace.$el);
      // 显示组件内容
      if (opts) {
        messageInstace.icon = opts.icon;
        messageInstace.severity = opts.severity;
        messageInstace.confirmTitle = opts.confirmTitle;
        messageInstace.title = opts.title;
        messageInstace.subTitle = opts.subTitle;
        messageInstace.list = opts.list;
        messageInstace.confirmText = opts.confirmText;
        messageInstace.btnText = opts.btnText;
        messageInstace.callBack = opts.callBack;
        messageInstace.onClose = opts.onClose;
        messageInstace.showCancel = opts.showCancel;
        messageInstace.showClose = opts.showClose;
        messageInstace.autoConfirm = opts.autoConfirm;
        messageInstace.cancelCallBack = opts.cancelCallBack;
      }
      messageInstace.centerDialogVisible = true;
      if (messageInstace.autoConfirm) {
        setTimeout(function () {
          console.log(messageInstace);
          messageInstace.confirm();
        }, 1500);
      }
    };
  }
});

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(174);



/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.$hasPermissionByRouteName = function (routeName) {
      var perms = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.perms;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(perms), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var auth = _step.value;

          if (auth.url === routeName || routeName.indexOf(auth.url + '-') === 0) {
            //子页面也允许
            return true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    };
  }
});

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_vue__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_vue__);


/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.$previewExcel = function (opt) {
      // 继承messageBox组件
      var PreviewExcelConstructor = Vue.extend(__WEBPACK_IMPORTED_MODULE_0__index_vue___default.a);
      // 创建一个新元素
      var PreviewExcelWrap = document.createElement('div');
      PreviewExcelWrap.className = 'preview-excel-wrap';
      // 实例化messageBox组件，并将组件挂在到新创建的message-box-wrap元素上
      var PreviewExcelInstace = new PreviewExcelConstructor({
        el: PreviewExcelWrap
      });
      // 或者使用 messageInstace.$mount(messageWrap)挂载
      document.body.appendChild(PreviewExcelInstace.$el);
      // 显示组件内容
      if (opt) {
        PreviewExcelInstace.data = opt.data;
        PreviewExcelInstace.title = opt.title;
        PreviewExcelInstace.download = opt.download;
      }
      PreviewExcelInstace.centerDialogVisible = true;
    };
  }
});

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_vue__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_vue__);


/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.$previewImg = function (opt) {
      // 继承messageBox组件
      var PreviewImgConstructor = Vue.extend(__WEBPACK_IMPORTED_MODULE_0__index_vue___default.a);
      // 创建一个新元素
      var PreviewImgWrap = document.createElement('div');
      PreviewImgWrap.className = 'preview-Img-wrap';
      // 实例化messageBox组件，并将组件挂在到新创建的message-box-wrap元素上
      var PreviewImgInstace = new PreviewImgConstructor({
        el: PreviewImgWrap
      });
      // 或者使用 messageInstace.$mount(messageWrap)挂载
      document.body.appendChild(PreviewImgInstace.$el);
      // 显示组件内容
      if (opt) {
        PreviewImgInstace.data = opt.data;
        PreviewImgInstace.title = opt.title;
        PreviewImgInstace.download = opt.download;
      }
      PreviewImgInstace.centerDialogVisible = true;
    };
  }
});

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var AppLayout = function AppLayout(resolve) {
  return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(104)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var _import = function _import(path, subPath) {
  return __webpack_require__(1723)("./" + path + (subPath ? '/' + subPath : '/index'));
};

var routes = {
  path: '/bizmanagement',
  component: AppLayout,
  meta: {
    title: 'meetingplan',
    hidden: true
  },
  redirect: 'budget',
  children: [{
    path: 'budget',
    name: 'bizmanagement-budget',
    meta: {
      title: 'bizmanagement.budget'
    },
    component: _import('budget')
  }, {
    path: 'strategy',
    name: 'bizmanagement-strategy',
    meta: {
      title: 'bizmanagement.strategy'
    },
    component: _import('strategy')
  }, {
    path: 'domainresult',
    name: 'bizmanagement-domain-result',
    meta: {
      title: 'bizmanagement.domain-result'
    },
    component: _import('domainresult')
  }, {
    path: 'hospitallevel',
    name: 'bizmanagement-hospital-level',
    meta: {
      title: 'bizmanagement.hospital-level'
    },
    component: _import('hospitallevel')
  }, {
    path: 'speakerlevel',
    name: 'bizmanagement-speaker-level',
    meta: {
      title: 'bizmanagement.speaker-level'
    },
    component: _import('speakerlevel')
  }]
};

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var AppLayout = function AppLayout(resolve) {
  return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(104)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var _import = function _import(path, subPath) {
  return __webpack_require__(1724)("./" + path + (subPath ? '/' + subPath : '/index'));
};

var routes = {
  path: '/dashboard',
  component: AppLayout,
  meta: {
    title: 'dashboard',
    hidden: true
  },
  redirect: 'budget',
  children: [{
    path: 'sample',
    name: 'dashboard-sample',
    meta: {
      title: 'dashboard.sample',
      hidden: true
    },
    component: _import('sample')
  }, {
    path: 'budget',
    name: 'dashboard-budget',
    meta: {
      title: 'dashboard.budget',
      hidden: true
    },
    component: _import('budget')
  }, {
    path: 'meeting',
    name: 'dashboard-meeting',
    meta: {
      title: 'dashboard.meeting',
      hidden: true
    },
    component: _import('meeting')
  }, {
    path: 'effectiveness',
    name: 'dashboard-effectiveness',
    meta: {
      title: 'dashboard.effectiveness',
      hidden: true
    },
    component: _import('effectiveness')
  }]
};

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meetingplan__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__meetingplanlibrary__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__meetingplantask__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__meetingplanauthorizedtask__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bizManagement__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dashboard__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sysmanagement__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__messages__ = __webpack_require__(732);













var Login = function Login(resolve) {
  return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1739)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var LoginSSO = function LoginSSO(resolve) {
  return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1740)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var timeOutPage = function timeOutPage(resolve) {
  return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1735)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var NotFoundPage = function NotFoundPage(resolve) {
  return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1737)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var ErrorPage = function ErrorPage(resolve) {
  return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1738)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var RulesErrorPage = function RulesErrorPage(resolve) {
  return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1736)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var whileList = ',login,login2,loginSSO,NotFoundPage,user-manual,';

//获取原型对象上的push函数
var originalPush = __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */].prototype.push;
__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */].prototype.push = function push(location) {
  return originalPush.call(this, location).catch(function (err) {
    return err;
  });
};

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/login'
  }, __WEBPACK_IMPORTED_MODULE_3__meetingplan__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__meetingplantask__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__meetingplanauthorizedtask__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__meetingplanlibrary__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__bizManagement__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__dashboard__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__sysmanagement__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__user__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__messages__["a" /* default */], {
    path: '/login',
    name: 'login',
    component: LoginSSO,
    label: '用户登录'
  }, {
    path: '/login2',
    name: 'login2',
    component: Login,
    label: '用户登录'
  }, {
    path: '/loginSSO',
    name: 'loginSSO',
    component: LoginSSO,
    label: '用户登录'
  }, {
    path: '/401',
    component: timeOutPage,
    label: '401'
  }, {
    path: '/404',
    component: NotFoundPage,
    label: '404'
  }, {
    path: '/500',
    component: ErrorPage,
    label: '500'
  }, {
    path: '/403',
    component: RulesErrorPage,
    label: '403'
  }, {
    path: '*',
    redirect: '/404'
  }],
  // mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});

router.beforeEach(function (to, from, next) {
  if (whileList.indexOf(to.name) < 0 && to.name) {
    if (!__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$hasPermissionByRouteName(to.name) //没有权限) 
    ) {
        next({ name: 'login' });
        return;
      }
  }

  next();
});

router.afterEach(function (to) {});

router.onError(function (error) {
  console.log(error);
  //   const pattern = /Loading chunk/g;
  var pattern = /Loading chunk (\d)+ failed/g;
  var isChunkLoadFailed = error.message.match(pattern);

  var targetPath = router.history.pending.fullPath;
  console.log('targetPath', targetPath);
  if (isChunkLoadFailed && targetPath) {
    console.log('chunkfailed catched');
    router.push(targetPath);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var AppLayout = function AppLayout(resolve) {
  return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(104)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var _import = function _import(path, subPath) {
  return __webpack_require__(259)("./" + path + (subPath ? '/' + subPath + '/index' : '/index'));
};

var routes = {
  path: '/meetingplan',
  component: AppLayout,
  meta: {
    title: 'meetingplan.application.title',
    hidden: false,
    name: 'meetingplan-application'
  },
  redirect: 'application',
  children: [{
    path: 'application',
    name: 'meetingplan-application',
    meta: {
      title: 'meetingplan.application',
      hidden: true
    },
    component: _import('application')
  }, {
    path: 'application/add/:year/:season',
    name: 'meetingplan-application-add',
    meta: {
      title: 'meetingplan.application.add',
      hidden: false
    },
    component: _import('application', 'edit')
  }, {
    path: 'application/copy/:id',
    name: 'meetingplan-application-copy',
    meta: {
      title: 'meetingplan.application.copy',
      hidden: false
    },
    component: _import('application', 'edit')
  }, {
    path: 'application/edit/:id',
    name: 'meetingplan-application-edit',
    meta: {
      title: 'meetingplan.application.edit',
      hidden: false
    },
    component: _import('application', 'edit')
  }, {
    path: 'application/change/:id',
    name: 'meetingplan-application-change',
    meta: {
      title: 'meetingplan.application.change',
      hidden: false
    },
    component: _import('application', 'edit')
  }, {
    path: 'application/view/:id',
    name: 'meetingplan-application-view',
    meta: {
      title: 'meetingplan.application.view',
      hidden: false
    },
    component: _import('application', 'view')
  }]
};

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var AppLayout = function AppLayout(resolve) {
  return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(104)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var _import = function _import(path, subPath) {
  return __webpack_require__(259)("./" + path + (subPath ? '/' + subPath + '/index' : '/index'));
};

var routes = {
  path: '/meetingplan',
  component: AppLayout,
  meta: {
    title: 'meetingplan.authorizedtask.title',
    hidden: false,
    name: 'meetingplan-authorizedtask'
  },
  redirect: 'authorizedtask',
  children: [{
    path: 'authorizedtask',
    name: 'meetingplan-authorizedtask',
    meta: {
      title: 'meetingplan.authorizedtask',
      hidden: true
    },
    component: _import('authorizedtask')
  }, {
    path: 'authorizedtask/view/:id',
    name: 'meetingplan-authorizedtask-view',
    meta: {
      title: 'meetingplan.authorizedtask.view',
      hidden: false
    },
    component: _import('authorizedtask', 'view')
  }]
};

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var AppLayout = function AppLayout(resolve) {
  return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(104)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var _import = function _import(path, subPath) {
  return __webpack_require__(259)("./" + path + (subPath ? '/' + subPath + '/index' : '/index'));
};

var routes = {
  path: '/meetingplan',
  component: AppLayout,
  meta: {
    title: 'meetingplan.library.title',
    hidden: false,
    name: 'meetingplan-library'
  },
  redirect: 'library',
  children: [{
    path: 'library',
    name: 'meetingplan-library',
    meta: {
      title: 'meetingplan.library',
      hidden: true
    },
    component: _import('library')
  }, {
    path: 'library/view/:id',
    name: 'meetingplan-library-view',
    meta: {
      title: 'meetingplan.library.view',
      hidden: false
    },
    component: _import('library', 'view')
  }]
};

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var AppLayout = function AppLayout(resolve) {
  return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(104)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var _import = function _import(path, subPath) {
  return __webpack_require__(259)("./" + path + (subPath ? '/' + subPath + '/index' : '/index'));
};

var routes = {
  path: '/meetingplan',
  component: AppLayout,
  meta: {
    title: 'meetingplan.task.title',
    hidden: false,
    name: 'meetingplan-task'
  },
  redirect: 'task',
  children: [{
    path: 'task',
    name: 'meetingplan-task',
    meta: {
      title: 'meetingplan.task',
      hidden: true
    },
    component: _import('task')
  }, {
    path: 'task/view/:id',
    name: 'meetingplan-task-view',
    meta: {
      title: 'meetingplan.task.view',
      hidden: false
    },
    component: _import('task', 'view')
  }]
};

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var AppLayout = function AppLayout(resolve) {
  return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(104)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var _import = function _import(path, subPath) {
  return __webpack_require__(1725)("./" + path + (subPath ? '/' + subPath : '/index'));
};

var routes = {
  path: '/messages',
  component: AppLayout,
  meta: {
    title: 'messages',
    hidden: true
  },
  redirect: 'list',
  children: [{
    path: 'list',
    name: 'messages-list',
    meta: {
      title: 'messages.list'
    },
    component: _import('list')
  }]
};

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var AppLayout = function AppLayout(resolve) {
  return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(104)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var _import = function _import(path, subPath) {
  return __webpack_require__(1726)("./" + path + (subPath ? '/' + subPath : '/index'));
};

var routes = {
  path: '/sysmanagement',
  name: 'sysmanagement',
  component: AppLayout,
  meta: {
    title: 'sysmanagement',
    hidden: true
  },
  redirect: '/sysmanagement/seasonadjust',
  children: [{
    path: 'seasonadjust',
    name: 'sysmanagement-season-adjust',
    meta: {
      title: 'sysmanagement.season-adjust',
      hidden: true
    },
    component: _import('seasonadjust')
  }, {
    path: 'monthadjust',
    name: 'sysmanagement-month-adjust',
    meta: {
      title: 'sysmanagement.month-adjust',
      hidden: true
    },
    component: _import('monthadjust')
  }, {
    path: 'systemnotice',
    name: 'sysmanagement-system-notice',
    meta: {
      title: 'sysmanagement.system-notice',
      hidden: true
    },
    component: _import('systemnotice')
  }, {
    path: 'privilege',
    name: 'sysmanagement-privilege',
    meta: {
      title: 'sysmanagement.privilege',
      hidden: true
    },
    component: _import('privilege')
  }, {
    path: 'menu',
    name: 'sysmanagement-menu',
    meta: {
      title: 'sysmanagement.menu',
      hidden: true
    },
    component: _import('menu')
  }, {
    path: 'role',
    name: 'sysmanagement-role',
    meta: {
      title: 'sysmanagement.role',
      hidden: true
    },
    component: _import('role')
  }, {
    path: 'dictlist',
    name: 'sysmanagement-dict-list',
    meta: {
      title: 'sysmanagement.dict-list',
      hidden: true
    },
    component: _import('dictlist')
  }, {
    path: 'emailtemplate',
    name: 'sysmanagement-email-template',
    meta: {
      title: 'sysmanagement.email-template',
      hidden: true
    },
    component: _import('emailtemplate')
  }]
};

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var AppLayout = function AppLayout(resolve) {
  return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(104)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var _import = function _import(path, subPath) {
  return __webpack_require__(1727)("./" + path + (subPath ? '/' + subPath + '/index' : '/index'));
};

var routes = {
  path: '/user',
  component: AppLayout,
  meta: {
    title: 'user',
    hidden: true
  },
  redirect: 'center',
  children: [{
    path: 'center',
    name: 'user-personal-center',
    meta: {
      title: 'user.personal-center',
      hidden: true
    },
    component: _import('center')
  }, {
    path: 'manual',
    name: 'user-manual',
    meta: {
      title: 'user.manual',
      hidden: true
    },
    component: _import('manual')
  }, {
    path: 'authorizelm',
    name: 'user-authorizelm',
    meta: {
      title: 'user.authorizelm',
      hidden: true
    },
    component: _import('authorizelm')
  }, {
    path: 'authorizelm/add',
    name: 'user-authorizelm-add',
    meta: {
      title: 'user.authorizelm.add',
      hidden: true
    },
    component: _import('authorizelm', 'add')
  }, {
    path: 'authorizedlevel',
    name: 'user-authorizedlevel',
    meta: {
      title: 'user.authorizedlevel',
      hidden: true
    },
    component: _import('authorizedlevel')
  }, {
    path: 'authorizedlevel/add',
    name: 'user-authorizedlevel-add',
    meta: {
      title: 'user.authorizedlevel.add',
      hidden: true
    },
    component: _import('authorizedlevel', 'add')
  }]
};

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadFile", function() { return uploadFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadImage", function() { return uploadImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);



var uploadFile = function uploadFile(_ref, file) {
  var commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_vue___default.a.http.post('upload', file).then(function (_ref2) {
      var body = _ref2.body;

      console.log('body', body);
      resolve(body);
    }, function (error) {
      reject(error);
    });
  });
};

var uploadImage = function uploadImage(_ref3, data) {
  var commit = _ref3.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_vue___default.a.http.post('uploadImgBase64', {
      imageUrl: data.url
    }).then(function (_ref4) {
      var body = _ref4.body;

      resolve(body);
    }, function (error) {
      reject(error);
    });
  });
};

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_basedata__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_utils__ = __webpack_require__(207);






var _actions;





var baseDataTypes = {
    'Organization': {
        idField: 'id',
        nameField: 'organizName',
        rowIdField: 'organizId'
    },
    'MedicalField': {
        idField: 'id',
        nameField: 'medicalFieldName',
        rowIdField: 'medicalField'
    },
    'Teams': {
        idField: 'id',
        nameField: 'teamName',
        rowIdField: 'teamId'
    },
    'Product': {
        idField: 'id',
        nameField: 'productName',
        rowIdField: 'productId'
    },
    'Depart': {
        idField: 'id',
        nameField: 'departName',
        rowIdField: 'departId'
    },
    'TreatmentArea': {
        idField: 'id',
        nameField: 'treatmentAreaName',
        rowIdField: 'treatmentAreaId'
    },
    'DiseaseArea': {
        idField: 'id',
        nameField: 'diseaseAreaName',
        rowIdField: 'diseaseAreaId'
    },
    'Country': {
        idField: 'id',
        nameField: 'name'
    },
    'Province': {
        idField: 'id',
        nameField: 'name'
    },
    'HospitalLevel': {
        idField: 'id',
        nameField: 'hospitalLevel'
    },
    'SpeakerLevel': {
        idField: 'id',
        nameField: 'speakerLevel'
    },
    'DomainResult': {
        idField: 'id',
        nameField: 'treatAreaResult'
    },
    'Strategy': {
        idField: 'id',
        nameField: 'keynote'
    },
    'Office': {
        idField: 'id',
        nameField: 'officeName'
    },
    'Year': {
        idField: 'id',
        nameField: 'yearName'
    },
    'Quarter': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'quarter'
    },
    'CostCenter': {
        idField: 'id',
        nameField: 'costName',
        rowIdField: 'costCenter'
    },
    'WbsCode': {
        idField: 'id',
        nameField: 'costName',
        rowIdField: 'wbsCode'
    },
    'MyApplicationStatus': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'status'
    },
    'MyLibraryStatus': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'status'
    },
    'MyTaskStatus': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'status'
    },
    'MeetingStatus': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'meetingWebStatus'
    },
    'QueueTaskStatus': {
        idField: 'value',
        nameField: 'text'
    },
    'CompanyStrategy': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'companyStrategy'
    },
    'MeetingProp': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'meetingProp'
    },
    'MeetingModality': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'meetingModality'
    },
    'MeetingType': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'meetingType'
    },
    'Role': {
        idField: 'id',
        nameField: 'roleName',
        rowIdField: 'roleId'
    },
    'MeetingSystem': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'meetingSystem'
    },
    'AoneExeStatus': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'aoneExeStatus'
    },
    'MeetingTimeInt': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'meetingTimeInt'
    },
    'SysErrorTip': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'sysErrorTip'
    },
    'SysTip': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'sysTip'
    },
    'MeetingGsdType': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'meetingGsdType'
    },
    'MeetingGsdTypeSub1': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'meetingGsdTypeSub1'
    },
    'MeetingGsdTypeSub2': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'meetingGsdTypeSub2'
    },
    'MeetingGsdTypeSub3': {
        idField: 'value',
        nameField: 'text',
        rowIdField: 'meetingGsdTypeSub3'
    }
};

var state = {
    baseDataRecords: {},
    baseDataRecordsById: {}
};

var getters = {
    baseDataRecordByType: function baseDataRecordByType(state) {
        return function (type) {
            return state.baseDataRecords[type];
        };
    },
    baseDataRecords: function baseDataRecords(state) {
        return state.baseDataRecords;
    },

    basedataGetIdByName: function basedataGetIdByName(state) {
        return function (type, name) {
            for (var index = 0; index < state.baseDataRecords[type].length; index++) {
                var element = state.baseDataRecords[type][index];

                if (element[baseDataTypes[type].nameField] == name) {
                    return element[baseDataTypes[type].idField];
                }
            }

            return '';
        };
    },
    basedataGetName: function basedataGetName(state) {
        return function (type, id, extend) {
            if (!id) {
                return '';
            }

            if (Array.isArray(id)) {
                var names = [];
                id.forEach(function (el) {
                    if (extend && extend[el]) {

                        names.push(extend[el]);
                    } else if (state.baseDataRecordsById[type][el]) {
                        names.push(state.baseDataRecordsById[type][el][baseDataTypes[type].nameField]);
                    }
                });

                return names.join('，');
            }

            if (extend && extend[id]) {
                return extend[id];
            }

            if (!state.baseDataRecordsById[type][id]) {
                return 'id: ' + id + ' \u4E0D\u5B58\u5728';
            }
            return state.baseDataRecordsById[type][id][baseDataTypes[type].nameField];
        };
    },
    basedataGetObject: function basedataGetObject(state) {
        return function (type, id) {
            if (!state.baseDataRecordsById[type][id]) {
                return 'id: ' + id + ' \u4E0D\u5B58\u5728';
            }
            return state.baseDataRecordsById[type][id];
        };
    },
    basedataGetNameByRowIdField: function basedataGetNameByRowIdField(state, getters) {
        return function (rowIdField, row) {
            var type = '';
            for (var typeTemp in baseDataTypes) {
                if (baseDataTypes.hasOwnProperty.call(baseDataTypes, typeTemp)) {
                    var element = baseDataTypes[typeTemp];
                    if (element.rowIdField == rowIdField) {
                        type = typeTemp;
                        break;
                    }
                }
            }
            var id = row[baseDataTypes[type].rowIdField];

            return getters.basedataGetName(type, id);
        };
    }
};

var mutations = {
    baseDataSet: function baseDataSet(state, payload) {
        var typeInfo = baseDataTypes[payload.typeName];

        state.baseDataRecords[payload.typeName] = payload.data;
        state.baseDataRecordsById[payload.typeName] = {};

        state.baseDataRecords[payload.typeName].forEach(function (record) {
            state.baseDataRecordsById[payload.typeName][record[typeInfo.idField]] = record;
        });
    }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'reloadBaseDataByType', function reloadBaseDataByType(_ref, typeName) {
    var _this = this;

    var commit = _ref.commit,
        rootGetters = _ref.rootGetters;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var typeInfo, res, data, tempData;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        typeInfo = baseDataTypes[typeName];
                        _context.next = 3;
                        return __WEBPACK_IMPORTED_MODULE_5__api_basedata__["a" /* default */]['list' + typeName]();

                    case 3:
                        res = _context.sent;
                        data = res.records;

                        if (!data) {
                            //res 是数组
                            data = [];
                            res.forEach(function (resdata) {
                                var temp = {};
                                if ((typeof resdata === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(resdata)) == 'object') {
                                    temp = resdata;
                                } else {
                                    temp[typeInfo.idField] = resdata;
                                    temp[typeInfo.nameField] = resdata;
                                }
                                data.push(temp);
                            });
                        }

                        if (typeInfo.userInfoField) {
                            tempData = [];

                            data.forEach(function (resdata) {
                                var info = rootGetters.userInfo[typeInfo.userInfoField];
                                if (info && info.indexOf(resdata[typeInfo.idField]) >= 0) {
                                    tempData.push(resdata);
                                }
                            });

                            data = tempData;
                        }

                        commit('baseDataSet', { data: data, typeName: typeName });

                    case 8:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'initBaseData', function initBaseData(_ref2) {
    var _this2 = this;

    var dispatch = _ref2.dispatch;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var typeName;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        for (typeName in baseDataTypes) {
                            dispatch('reloadBaseDataByType', typeName);
                        }

                    case 1:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, _this2);
    }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'initBaseDataByTypes', function initBaseDataByTypes(_ref3, typeNameArray) {
    var _this3 = this;

    var dispatch = _ref3.dispatch,
        state = _ref3.state;
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var reloadFuncArr, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, typeName;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        reloadFuncArr = [];
                        _iteratorNormalCompletion = true;
                        _didIteratorError = false;
                        _iteratorError = undefined;
                        _context3.prev = 4;

                        for (_iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(typeNameArray); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            typeName = _step.value;

                            if (!state.baseDataRecords[typeName]) {
                                reloadFuncArr.push(dispatch('reloadBaseDataByType', typeName));
                            }
                        }

                        _context3.next = 12;
                        break;

                    case 8:
                        _context3.prev = 8;
                        _context3.t0 = _context3['catch'](4);
                        _didIteratorError = true;
                        _iteratorError = _context3.t0;

                    case 12:
                        _context3.prev = 12;
                        _context3.prev = 13;

                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }

                    case 15:
                        _context3.prev = 15;

                        if (!_didIteratorError) {
                            _context3.next = 18;
                            break;
                        }

                        throw _iteratorError;

                    case 18:
                        return _context3.finish(15);

                    case 19:
                        return _context3.finish(12);

                    case 20:
                        if (!(reloadFuncArr.length > 0)) {
                            _context3.next = 23;
                            break;
                        }

                        _context3.next = 23;
                        return __WEBPACK_IMPORTED_MODULE_7__util_utils__["a" /* default */].$all(reloadFuncArr);

                    case 23:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, _this3, [[4, 8, 12, 20], [13,, 15, 19]]);
    }))();
}), _actions);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_login__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(384);



var _mutations;





var state = {
  userInfo: {},
  perms: []
};

var getters = {
  userInfo: function userInfo(state) {
    return state.userInfo;
  },
  perms: function perms(state) {
    return state.perms;
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* SET_USERINFO */], function (state, _ref) {
  var userInfo = _ref.userInfo;

  state.userInfo = userInfo;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* SET_USER_PERMS */], function (state, _ref2) {
  var perms = _ref2.perms;

  state.perms = perms;
}), _mutations);

var actions = {
  userTokenLogin: function userTokenLogin(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_login__["a" /* default */].userTokenLogin(payload).then(function (response) {
        if (response.code == 200) {
          response.result.userInfo.loginDeparts = [];
          response.result.userInfo.loginMedicalFields = [];
          response.result.userInfo.loginTeams = [];

          response.result.userInfo.departIdList.sort(function (a, b) {
            return a > b ? 1 : -1;
          }).forEach(function (d) {
            response.result.userInfo.loginDeparts.push({
              id: d,
              departName: d
            });
          });

          response.result.userInfo.medicalFieldList.sort(function (a, b) {
            return a > b ? 1 : -1;
          }).forEach(function (d) {
            response.result.userInfo.loginMedicalFields.push({
              id: d,
              medicalFieldName: d
            });
          });

          if (response.result.userInfo.teamField) {
            response.result.userInfo.loginTeams = response.result.userInfo.teamField.split(',').map(function (t) {
              return {
                'id': t,
                'teamName': t
              };
            });
          }

          commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* SET_USERINFO */], {
            userInfo: response.result.userInfo
          });
          commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* SET_USER_PERMS */], { perms: response.result.permissionList });
        }
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  userCookieLogin: function userCookieLogin(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_login__["a" /* default */].userCookieLogin(payload).then(function (response) {
        if (response.code == 200) {
          response.result.userInfo.loginDeparts = [];
          response.result.userInfo.loginMedicalFields = [];
          response.result.userInfo.loginTeams = [];

          response.result.userInfo.departIdList.sort(function (a, b) {
            return a > b ? 1 : -1;
          }).forEach(function (d) {
            response.result.userInfo.loginDeparts.push({
              id: d,
              departName: d
            });
          });

          response.result.userInfo.medicalFieldList.sort(function (a, b) {
            return a > b ? 1 : -1;
          }).forEach(function (d) {
            response.result.userInfo.loginMedicalFields.push({
              id: d,
              medicalFieldName: d
            });
          });

          if (response.result.userInfo.teamField) {
            response.result.userInfo.loginTeams = response.result.userInfo.teamField.split(',').map(function (t) {
              return {
                'id': t,
                'teamName': t
              };
            });
          }

          commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* SET_USERINFO */], {
            userInfo: response.result.userInfo
          });
          commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* SET_USER_PERMS */], { perms: response.result.permissionList });
        }
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  },
  getUserInfo: function getUserInfo(_ref5, payload) {
    var commit = _ref5.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_login__["a" /* default */].getUserInfo(payload).then(function (response) {
        response.result.userInfo.meetingApproveRole = payload.result.userInfo.meetingApproveRole;
        response.result.userInfo.userCanEditDepart = response.result.userCanEditDepart;
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* SET_USERINFO */], {
          userInfo: response.result.userInfo
        });
        resolve(response);
      }, function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_sysmanagement_dictlist__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_locker__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);









var state = {
  dictMap: {},
  lockerManager: {},
  afterMeetingDays: []
};

var getters = {
  dictMap: function dictMap(state) {
    return state.dictMap;
  },
  afterMeetingDays: function afterMeetingDays(state) {
    return state.afterMeetingDays;
  }
};

var mutations = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* SET_DICT_ITEM */], function (state, _ref) {
  var dictMap = _ref.dictMap;

  state.dictMap = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.assign({}, state.dictMap, dictMap);
});

var actions = {
  getDictItemsByCode: function getDictItemsByCode(_ref2, code) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    var lockerKey = 'dict:' + code;
    while (__WEBPACK_IMPORTED_MODULE_3__util_locker__["a" /* default */].getLocker(lockerKey)) {
      return;
    }
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var dictMap = state.dictMap;

      if (dictMap[code]) {
        __WEBPACK_IMPORTED_MODULE_3__util_locker__["a" /* default */].releaseLocker(lockerKey);
        resolve(dictMap[code].res);
      } else {
        __WEBPACK_IMPORTED_MODULE_2__api_sysmanagement_dictlist__["a" /* default */].getDictItemsByCode(code).then(function (res) {
          __WEBPACK_IMPORTED_MODULE_3__util_locker__["a" /* default */].releaseLocker(lockerKey);
          if (res.success) {
            var newMap = {};
            newMap[code] = {
              name: code,
              options: res.result,
              res: res
            };
            commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* SET_DICT_ITEM */], {
              dictMap: newMap
            });
          }
          resolve(res);
        }, function (err) {
          console.error('err', err);
          __WEBPACK_IMPORTED_MODULE_3__util_locker__["a" /* default */].releaseLocker(lockerKey);
        });
      }
    });
  },
  getDictProvinceList: function getDictProvinceList(_ref3, code) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    var lockerKey = 'dict:province';
    while (__WEBPACK_IMPORTED_MODULE_3__util_locker__["a" /* default */].getLocker(lockerKey)) {
      return;
    }
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var dictMap = state.dictMap;

      if (dictMap[code]) {
        __WEBPACK_IMPORTED_MODULE_3__util_locker__["a" /* default */].releaseLocker(lockerKey);
        resolve(dictMap[code].res);
      } else {
        __WEBPACK_IMPORTED_MODULE_2__api_sysmanagement_dictlist__["a" /* default */].getProvinceList(code).then(function (res) {
          __WEBPACK_IMPORTED_MODULE_3__util_locker__["a" /* default */].releaseLocker(lockerKey);
          if (res.success) {
            // reset result key to dict key
            res.result.map(function (option) {
              option.value = option.id;
              option.text = option.name;
              option.textEn = option.nameEn;
            });
            var newMap = {};
            newMap.province = {
              name: code,
              options: res.result,
              res: res
            };
            commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* SET_DICT_ITEM */], {
              dictMap: newMap
            });
          }
          resolve(res);
        }, function (err) {
          console.error('err', err);
          __WEBPACK_IMPORTED_MODULE_3__util_locker__["a" /* default */].releaseLocker(lockerKey);
        });
      }
    });
  },
  getDictAribaCategoryList: function getDictAribaCategoryList(_ref4, code) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    var lockerKey = 'dict:airba_category';
    while (__WEBPACK_IMPORTED_MODULE_3__util_locker__["a" /* default */].getLocker(lockerKey)) {
      return;
    }
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var dictMap = state.dictMap;

      if (dictMap[code]) {
        __WEBPACK_IMPORTED_MODULE_3__util_locker__["a" /* default */].releaseLocker(lockerKey);
        resolve(dictMap[code].res);
      } else {
        __WEBPACK_IMPORTED_MODULE_2__api_sysmanagement_dictlist__["a" /* default */].getAribaCategoryList(code).then(function (res) {
          __WEBPACK_IMPORTED_MODULE_3__util_locker__["a" /* default */].releaseLocker(lockerKey);
          if (res.success) {
            // reset result key to dict key
            res.result.map(function (option) {
              option.value = option.commodityCode;
              option.text = option.categoryName;
              option.textEn = option.categoryName;
            });
            var newMap = {};
            newMap.airba_category = {
              name: code,
              options: res.result,
              res: res
            };
            commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* SET_DICT_ITEM */], {
              dictMap: newMap
            });
          }
          resolve(res);
        }, function (err) {
          console.error('err', err);
          __WEBPACK_IMPORTED_MODULE_3__util_locker__["a" /* default */].releaseLocker(lockerKey);
        });
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_sysmanagement_systemnotice__ = __webpack_require__(383);




var _actions;



var state = {
    systemNotices: []
};

var getters = {
    systemNotices: function systemNotices(state) {
        return state.systemNotices;
    },
    hasSystemNotices: function hasSystemNotices(state) {
        return state.systemNotices.length > 0;
    }
};

var mutations = {
    systemNoticesSet: function systemNoticesSet(state, notices) {
        state.systemNotices = notices;
    },
    hideSystemNotice: function hideSystemNotice(state) {
        state.systemNotices = [];
    }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'initSystemNotices', function initSystemNotices(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return __WEBPACK_IMPORTED_MODULE_3__api_sysmanagement_systemnotice__["a" /* default */].getNoticeHomeList();

                    case 2:
                        res = _context.sent;


                        commit('systemNoticesSet', res);

                    case 4:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'hideSystemNotice', function hideSystemNotice(_ref2) {
    var commit = _ref2.commit;

    commit('hideSystemNotice');
}), _actions);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_messages_list__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_StorageService__ = __webpack_require__(172);




var _actions;




var state = {
    unapproveCount: 0,
    hideUnapproveCount: false
};

var getters = {
    hasUnapproveCount: function hasUnapproveCount(state) {
        return state.unapproveCount > 0 && !state.hideUnapproveCount;
    }
};

var mutations = {
    unapproveCountSet: function unapproveCountSet(state, count) {
        state.unapproveCount = count;
    },
    hideUnapproveCount: function hideUnapproveCount(state) {
        state.hideUnapproveCount = true;
    }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'initUnapproveCount', function initUnapproveCount(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var preTaskDate, count;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        preTaskDate = __WEBPACK_IMPORTED_MODULE_4__util_StorageService__["a" /* getItem */](__WEBPACK_IMPORTED_MODULE_4__util_StorageService__["b" /* keys */].MyTaskActionDate);

                        if (!(preTaskDate != moment(new Date()).format('YYYY-MM-DD'))) {
                            _context.next = 8;
                            break;
                        }

                        _context.next = 4;
                        return __WEBPACK_IMPORTED_MODULE_3__api_messages_list__["a" /* default */].getUnApproveCount({});

                    case 4:
                        count = _context.sent;


                        commit('unapproveCountSet', count);
                        _context.next = 9;
                        break;

                    case 8:
                        commit('hideUnapproveCount');

                    case 9:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }))();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'hideUnapproveCount', function hideUnapproveCount(_ref2) {
    var commit = _ref2.commit;

    commit('hideUnapproveCount');
}), _actions);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setItem; });
/* unused harmony export removeItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var getItem = function getItem(key) {
  if (sessionStorage.getItem(key)) {
    return JSON.parse(sessionStorage.getItem(key));
  }
  return null;
};
var setItem = function setItem(key, value) {
  console.log('setItem', key);
  sessionStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
};

var removeItem = function removeItem(key) {
  sessionStorage.removeItem(key);
};

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_CommonConfirm__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_CommonConfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_CommonConfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_CommonCrud__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_CommonCrud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_CommonCrud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_CommonScore__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_CommonScore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_CommonScore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_CommonUpload__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_CommonUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_CommonUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_CNYInput__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_CNYInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_CNYInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_SelectTree__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_SelectTree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_common_SelectTree__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_CommonEchars__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_CommonEchars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_common_CommonEchars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_ApprovalDialog__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_ApprovalDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_common_ApprovalDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_CommonEditor__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_CommonEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_common_CommonEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_CommonTooltip__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_CommonTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_common_CommonTooltip__);













__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component("common-confirm", __WEBPACK_IMPORTED_MODULE_1__components_common_CommonConfirm___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component("common-crud", __WEBPACK_IMPORTED_MODULE_2__components_common_CommonCrud___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component("common-score", __WEBPACK_IMPORTED_MODULE_3__components_common_CommonScore___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component("common-upload", __WEBPACK_IMPORTED_MODULE_4__components_common_CommonUpload___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component("cny-input", __WEBPACK_IMPORTED_MODULE_5__components_common_CNYInput___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component("select-tree", __WEBPACK_IMPORTED_MODULE_6__components_common_SelectTree___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component("common-echars", __WEBPACK_IMPORTED_MODULE_7__components_common_CommonEchars___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component("approval-dialog", __WEBPACK_IMPORTED_MODULE_8__components_common_ApprovalDialog___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component("common-editor", __WEBPACK_IMPORTED_MODULE_9__components_common_CommonEditor___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component("common-tooltip", __WEBPACK_IMPORTED_MODULE_10__components_common_CommonTooltip___default.a);

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// 添加锁机制，可以对某个 key 进行加锁
var lockerManager = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  // 添加 locker
  addLocker: function addLocker(key) {
    if (lockerManager[getLockerKey(key)]) {
      return false;
    } else {
      lockerManager[getLockerKey(key)] = true;
      return true;
    }
  },


  // 获取 locker
  getLocker: function getLocker(key) {
    if (this.addLocker(key)) {
      return false;
    } else {
      return true;
    }
  },


  // 释放 locker
  releaseLocker: function releaseLocker(key) {
    lockerManager[getLockerKey(key)] = false;
    delete lockerManager[getLockerKey(key)];
  }
});

function getLockerKey(key) {
  return 'locker:' + key;
}

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(756), __esModule: true };

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(758), __esModule: true };

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(760), __esModule: true };

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(762), __esModule: true };

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(765), __esModule: true };

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(766), __esModule: true };

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(752);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 752 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 754 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(815);
module.exports = __webpack_require__(73).RegExp.escape;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(146);
__webpack_require__(794);
module.exports = __webpack_require__(36).Array.from;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(182);
__webpack_require__(146);
module.exports = __webpack_require__(792);


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(182);
__webpack_require__(146);
module.exports = __webpack_require__(793);


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(36);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(283);
__webpack_require__(146);
__webpack_require__(182);
__webpack_require__(796);
__webpack_require__(804);
__webpack_require__(803);
__webpack_require__(802);
module.exports = __webpack_require__(36).Map;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(797);
module.exports = __webpack_require__(36).Object.assign;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(798);
var $Object = __webpack_require__(36).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(799);
module.exports = __webpack_require__(36).Object.keys;


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(283);
__webpack_require__(146);
__webpack_require__(182);
__webpack_require__(800);
__webpack_require__(805);
__webpack_require__(806);
module.exports = __webpack_require__(36).Promise;


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(801);
__webpack_require__(283);
__webpack_require__(807);
__webpack_require__(808);
module.exports = __webpack_require__(36).Symbol;


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(146);
__webpack_require__(182);
module.exports = __webpack_require__(281).f('iterator');


/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(177);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(144);
var toLength = __webpack_require__(212);
var toAbsoluteIndex = __webpack_require__(790);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(105);
var IObject = __webpack_require__(269);
var toObject = __webpack_require__(145);
var toLength = __webpack_require__(212);
var asc = __webpack_require__(772);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(80);
var isArray = __webpack_require__(391);
var SPECIES = __webpack_require__(45)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(771);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(71).f;
var create = __webpack_require__(273);
var redefineAll = __webpack_require__(275);
var ctx = __webpack_require__(105);
var anInstance = __webpack_require__(265);
var forOf = __webpack_require__(177);
var $iterDefine = __webpack_require__(270);
var step = __webpack_require__(394);
var setSpecies = __webpack_require__(400);
var DESCRIPTORS = __webpack_require__(70);
var fastKey = __webpack_require__(271).fastKey;
var validate = __webpack_require__(403);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(210);
var from = __webpack_require__(768);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(44);
var $export = __webpack_require__(53);
var meta = __webpack_require__(271);
var fails = __webpack_require__(119);
var hide = __webpack_require__(106);
var redefineAll = __webpack_require__(275);
var forOf = __webpack_require__(177);
var anInstance = __webpack_require__(265);
var isObject = __webpack_require__(80);
var setToStringTag = __webpack_require__(181);
var dP = __webpack_require__(71).f;
var each = __webpack_require__(770)(0);
var DESCRIPTORS = __webpack_require__(70);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(71);
var createDesc = __webpack_require__(180);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(179);
var gOPS = __webpack_require__(274);
var pIE = __webpack_require__(211);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 778 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(273);
var descriptor = __webpack_require__(180);
var setToStringTag = __webpack_require__(181);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(106)(IteratorPrototype, __webpack_require__(45)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(44);
var macrotask = __webpack_require__(402).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(176)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(70);
var getKeys = __webpack_require__(179);
var gOPS = __webpack_require__(274);
var pIE = __webpack_require__(211);
var toObject = __webpack_require__(145);
var IObject = __webpack_require__(269);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(119)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(71);
var anObject = __webpack_require__(94);
var getKeys = __webpack_require__(179);

module.exports = __webpack_require__(70) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(211);
var createDesc = __webpack_require__(180);
var toIObject = __webpack_require__(144);
var toPrimitive = __webpack_require__(279);
var has = __webpack_require__(120);
var IE8_DOM_DEFINE = __webpack_require__(389);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(70) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(144);
var gOPN = __webpack_require__(395).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(120);
var toObject = __webpack_require__(145);
var IE_PROTO = __webpack_require__(276)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(53);
var core = __webpack_require__(36);
var fails = __webpack_require__(119);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(53);
var aFunction = __webpack_require__(175);
var ctx = __webpack_require__(105);
var forOf = __webpack_require__(177);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(53);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(278);
var defined = __webpack_require__(266);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(278);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(44);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(94);
var get = __webpack_require__(282);
module.exports = __webpack_require__(36).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(210);
var ITERATOR = __webpack_require__(45)('iterator');
var Iterators = __webpack_require__(143);
module.exports = __webpack_require__(36).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(105);
var $export = __webpack_require__(53);
var toObject = __webpack_require__(145);
var call = __webpack_require__(392);
var isArrayIter = __webpack_require__(390);
var toLength = __webpack_require__(212);
var createProperty = __webpack_require__(776);
var getIterFn = __webpack_require__(282);

$export($export.S + $export.F * !__webpack_require__(393)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(767);
var step = __webpack_require__(394);
var Iterators = __webpack_require__(143);
var toIObject = __webpack_require__(144);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(270)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(773);
var validate = __webpack_require__(403);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(775)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(53);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(781) });


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(53);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(70), 'Object', { defineProperty: __webpack_require__(71).f });


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(145);
var $keys = __webpack_require__(179);

__webpack_require__(786)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(178);
var global = __webpack_require__(44);
var ctx = __webpack_require__(105);
var classof = __webpack_require__(210);
var $export = __webpack_require__(53);
var isObject = __webpack_require__(80);
var aFunction = __webpack_require__(175);
var anInstance = __webpack_require__(265);
var forOf = __webpack_require__(177);
var speciesConstructor = __webpack_require__(401);
var task = __webpack_require__(402).set;
var microtask = __webpack_require__(780)();
var newPromiseCapabilityModule = __webpack_require__(272);
var perform = __webpack_require__(397);
var userAgent = __webpack_require__(791);
var promiseResolve = __webpack_require__(398);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(45)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(275)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(181)($Promise, PROMISE);
__webpack_require__(400)(PROMISE);
Wrapper = __webpack_require__(36)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(393)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(44);
var has = __webpack_require__(120);
var DESCRIPTORS = __webpack_require__(70);
var $export = __webpack_require__(53);
var redefine = __webpack_require__(399);
var META = __webpack_require__(271).KEY;
var $fails = __webpack_require__(119);
var shared = __webpack_require__(277);
var setToStringTag = __webpack_require__(181);
var uid = __webpack_require__(213);
var wks = __webpack_require__(45);
var wksExt = __webpack_require__(281);
var wksDefine = __webpack_require__(280);
var enumKeys = __webpack_require__(777);
var isArray = __webpack_require__(391);
var anObject = __webpack_require__(94);
var isObject = __webpack_require__(80);
var toObject = __webpack_require__(145);
var toIObject = __webpack_require__(144);
var toPrimitive = __webpack_require__(279);
var createDesc = __webpack_require__(180);
var _create = __webpack_require__(273);
var gOPNExt = __webpack_require__(784);
var $GOPD = __webpack_require__(783);
var $GOPS = __webpack_require__(274);
var $DP = __webpack_require__(71);
var $keys = __webpack_require__(179);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(395).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(211).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(178)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(106)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(787)('Map');


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(788)('Map');


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(53);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(774)('Map') });


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(53);
var core = __webpack_require__(36);
var global = __webpack_require__(44);
var speciesConstructor = __webpack_require__(401);
var promiseResolve = __webpack_require__(398);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(53);
var newPromiseCapability = __webpack_require__(272);
var perform = __webpack_require__(397);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(280)('asyncIterator');


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(280)('observable');


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(18);
var isArray = __webpack_require__(217);
var SPECIES = __webpack_require__(25)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(16);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(9);
var toPrimitive = __webpack_require__(84);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(125);
var gOPS = __webpack_require__(221);
var pIE = __webpack_require__(185);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(186)('native-function-to-string', Function.toString);


/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(2);
var $re = __webpack_require__(814)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(2);

$export($export.P, 'Array', { copyWithin: __webpack_require__(405) });

__webpack_require__(107)('copyWithin');


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $every = __webpack_require__(81)(4);

$export($export.P + $export.F * !__webpack_require__(75)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(2);

$export($export.P, 'Array', { fill: __webpack_require__(285) });

__webpack_require__(107)('fill');


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $filter = __webpack_require__(81)(2);

$export($export.P + $export.F * !__webpack_require__(75)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(2);
var $find = __webpack_require__(81)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(107)(KEY);


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(2);
var $find = __webpack_require__(81)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(107)(KEY);


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $forEach = __webpack_require__(81)(0);
var STRICT = __webpack_require__(75)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(74);
var $export = __webpack_require__(2);
var toObject = __webpack_require__(34);
var call = __webpack_require__(416);
var isArrayIter = __webpack_require__(293);
var toLength = __webpack_require__(29);
var createProperty = __webpack_require__(287);
var getIterFn = __webpack_require__(309);

$export($export.S + $export.F * !__webpack_require__(219)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $indexOf = __webpack_require__(214)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(75)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(2);

$export($export.S, 'Array', { isArray: __webpack_require__(217) });


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(2);
var toIObject = __webpack_require__(64);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(184) != Object || !__webpack_require__(75)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toIObject = __webpack_require__(64);
var toInteger = __webpack_require__(76);
var toLength = __webpack_require__(29);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(75)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $map = __webpack_require__(81)(1);

$export($export.P + $export.F * !__webpack_require__(75)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var createProperty = __webpack_require__(287);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(16)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $reduce = __webpack_require__(407);

$export($export.P + $export.F * !__webpack_require__(75)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $reduce = __webpack_require__(407);

$export($export.P + $export.F * !__webpack_require__(75)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var html = __webpack_require__(291);
var cof = __webpack_require__(72);
var toAbsoluteIndex = __webpack_require__(129);
var toLength = __webpack_require__(29);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(16)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $some = __webpack_require__(81)(3);

$export($export.P + $export.F * !__webpack_require__(75)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var aFunction = __webpack_require__(46);
var toObject = __webpack_require__(34);
var fails = __webpack_require__(16);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(75)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(128)('Array');


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(2);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(2);
var toISOString = __webpack_require__(810);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(34);
var toPrimitive = __webpack_require__(84);

$export($export.P + $export.F * __webpack_require__(16)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(25)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(54)(proto, TO_PRIMITIVE, __webpack_require__(811));


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(55)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(2);

$export($export.P, 'Function', { bind: __webpack_require__(408) });


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(18);
var getPrototypeOf = __webpack_require__(63);
var HAS_INSTANCE = __webpack_require__(25)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(33).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(33).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(31) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(2);
var log1p = __webpack_require__(419);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(2);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(2);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(2);
var sign = __webpack_require__(297);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(2);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(2);
var $expm1 = __webpack_require__(296);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { fround: __webpack_require__(418) });


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(2);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(2);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(16)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { log1p: __webpack_require__(419) });


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { sign: __webpack_require__(297) });


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(2);
var expm1 = __webpack_require__(296);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(16)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(2);
var expm1 = __webpack_require__(296);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(13);
var has = __webpack_require__(61);
var cof = __webpack_require__(72);
var inheritIfRequired = __webpack_require__(292);
var toPrimitive = __webpack_require__(84);
var fails = __webpack_require__(16);
var gOPN = __webpack_require__(124).f;
var gOPD = __webpack_require__(62).f;
var dP = __webpack_require__(33).f;
var $trim = __webpack_require__(150).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(123)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(31) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(55)(global, NUMBER, $Number);
}


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(2);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(2);
var _isFinite = __webpack_require__(13).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(2);

$export($export.S, 'Number', { isInteger: __webpack_require__(415) });


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(2);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(2);
var isInteger = __webpack_require__(415);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(2);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(2);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseFloat = __webpack_require__(427);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseInt = __webpack_require__(428);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toInteger = __webpack_require__(76);
var aNumberValue = __webpack_require__(404);
var repeat = __webpack_require__(304);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(16)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $fails = __webpack_require__(16);
var aNumberValue = __webpack_require__(404);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(2);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(421) });


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(123) });


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(31), 'Object', { defineProperties: __webpack_require__(422) });


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(31), 'Object', { defineProperty: __webpack_require__(33).f });


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(18);
var meta = __webpack_require__(109).onFreeze;

__webpack_require__(83)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(64);
var $getOwnPropertyDescriptor = __webpack_require__(62).f;

__webpack_require__(83)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(83)('getOwnPropertyNames', function () {
  return __webpack_require__(423).f;
});


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(34);
var $getPrototypeOf = __webpack_require__(63);

__webpack_require__(83)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(18);

__webpack_require__(83)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(18);

__webpack_require__(83)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(18);

__webpack_require__(83)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(2);
$export($export.S, 'Object', { is: __webpack_require__(431) });


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(34);
var $keys = __webpack_require__(125);

__webpack_require__(83)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(18);
var meta = __webpack_require__(109).onFreeze;

__webpack_require__(83)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(18);
var meta = __webpack_require__(109).onFreeze;

__webpack_require__(83)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(2);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(301).set });


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(147);
var test = {};
test[__webpack_require__(25)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(55)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseFloat = __webpack_require__(427);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseInt = __webpack_require__(428);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(108);
var global = __webpack_require__(13);
var ctx = __webpack_require__(74);
var classof = __webpack_require__(147);
var $export = __webpack_require__(2);
var isObject = __webpack_require__(18);
var aFunction = __webpack_require__(46);
var anInstance = __webpack_require__(121);
var forOf = __webpack_require__(122);
var speciesConstructor = __webpack_require__(187);
var task = __webpack_require__(306).set;
var microtask = __webpack_require__(298)();
var newPromiseCapabilityModule = __webpack_require__(299);
var perform = __webpack_require__(429);
var userAgent = __webpack_require__(227);
var promiseResolve = __webpack_require__(430);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(25)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(127)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(149)($Promise, PROMISE);
__webpack_require__(128)(PROMISE);
Wrapper = __webpack_require__(73)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(219)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(2);
var aFunction = __webpack_require__(46);
var anObject = __webpack_require__(9);
var rApply = (__webpack_require__(13).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(16)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(2);
var create = __webpack_require__(123);
var aFunction = __webpack_require__(46);
var anObject = __webpack_require__(9);
var isObject = __webpack_require__(18);
var fails = __webpack_require__(16);
var bind = __webpack_require__(408);
var rConstruct = (__webpack_require__(13).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(33);
var $export = __webpack_require__(2);
var anObject = __webpack_require__(9);
var toPrimitive = __webpack_require__(84);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(16)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(2);
var gOPD = __webpack_require__(62).f;
var anObject = __webpack_require__(9);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(9);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(294)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(62);
var $export = __webpack_require__(2);
var anObject = __webpack_require__(9);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(2);
var getProto = __webpack_require__(63);
var anObject = __webpack_require__(9);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(62);
var getPrototypeOf = __webpack_require__(63);
var has = __webpack_require__(61);
var $export = __webpack_require__(2);
var isObject = __webpack_require__(18);
var anObject = __webpack_require__(9);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(2);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(9);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(2);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(426) });


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(9);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(2);
var setProto = __webpack_require__(301);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(33);
var gOPD = __webpack_require__(62);
var getPrototypeOf = __webpack_require__(63);
var has = __webpack_require__(61);
var $export = __webpack_require__(2);
var createDesc = __webpack_require__(126);
var anObject = __webpack_require__(9);
var isObject = __webpack_require__(18);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var inheritIfRequired = __webpack_require__(292);
var dP = __webpack_require__(33).f;
var gOPN = __webpack_require__(124).f;
var isRegExp = __webpack_require__(218);
var $flags = __webpack_require__(183);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(31) && (!CORRECT_NEW || __webpack_require__(16)(function () {
  re2[__webpack_require__(25)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(55)(global, 'RegExp', $RegExp);
}

__webpack_require__(128)('RegExp');


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(9);
var toLength = __webpack_require__(29);
var advanceStringIndex = __webpack_require__(284);
var regExpExec = __webpack_require__(222);

// @@match logic
__webpack_require__(216)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(9);
var toObject = __webpack_require__(34);
var toLength = __webpack_require__(29);
var toInteger = __webpack_require__(76);
var advanceStringIndex = __webpack_require__(284);
var regExpExec = __webpack_require__(222);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(216)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(9);
var sameValue = __webpack_require__(431);
var regExpExec = __webpack_require__(222);

// @@search logic
__webpack_require__(216)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(218);
var anObject = __webpack_require__(9);
var speciesConstructor = __webpack_require__(187);
var advanceStringIndex = __webpack_require__(284);
var toLength = __webpack_require__(29);
var callRegExpExec = __webpack_require__(222);
var regexpExec = __webpack_require__(300);
var fails = __webpack_require__(16);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(216)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(437);
var anObject = __webpack_require__(9);
var $flags = __webpack_require__(183);
var DESCRIPTORS = __webpack_require__(31);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(55)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(16)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(56)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(56)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(56)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(56)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $at = __webpack_require__(225)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(2);
var toLength = __webpack_require__(29);
var context = __webpack_require__(303);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(290)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(56)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(56)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(56)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var toAbsoluteIndex = __webpack_require__(129);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(2);
var context = __webpack_require__(303);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(290)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(56)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(225)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(295)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(56)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var toIObject = __webpack_require__(64);
var toLength = __webpack_require__(29);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(304)
});


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(56)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(2);
var toLength = __webpack_require__(29);
var context = __webpack_require__(303);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(290)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(56)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(56)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(56)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(150)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(13);
var has = __webpack_require__(61);
var DESCRIPTORS = __webpack_require__(31);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(55);
var META = __webpack_require__(109).KEY;
var $fails = __webpack_require__(16);
var shared = __webpack_require__(186);
var setToStringTag = __webpack_require__(149);
var uid = __webpack_require__(130);
var wks = __webpack_require__(25);
var wksExt = __webpack_require__(434);
var wksDefine = __webpack_require__(308);
var enumKeys = __webpack_require__(812);
var isArray = __webpack_require__(217);
var anObject = __webpack_require__(9);
var isObject = __webpack_require__(18);
var toObject = __webpack_require__(34);
var toIObject = __webpack_require__(64);
var toPrimitive = __webpack_require__(84);
var createDesc = __webpack_require__(126);
var _create = __webpack_require__(123);
var gOPNExt = __webpack_require__(423);
var $GOPD = __webpack_require__(62);
var $GOPS = __webpack_require__(221);
var $DP = __webpack_require__(33);
var $keys = __webpack_require__(125);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(124).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(185).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(108)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(54)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $typed = __webpack_require__(226);
var buffer = __webpack_require__(307);
var anObject = __webpack_require__(9);
var toAbsoluteIndex = __webpack_require__(129);
var toLength = __webpack_require__(29);
var isObject = __webpack_require__(18);
var ArrayBuffer = __webpack_require__(13).ArrayBuffer;
var speciesConstructor = __webpack_require__(187);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(16)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(128)(ARRAY_BUFFER);


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
$export($export.G + $export.W + $export.F * !__webpack_require__(226).ABV, {
  DataView: __webpack_require__(307).DataView
});


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(411);
var validate = __webpack_require__(131);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(215)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(2);
var flattenIntoArray = __webpack_require__(412);
var toObject = __webpack_require__(34);
var toLength = __webpack_require__(29);
var aFunction = __webpack_require__(46);
var arraySpeciesCreate = __webpack_require__(286);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(107)('flatMap');


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(2);
var flattenIntoArray = __webpack_require__(412);
var toObject = __webpack_require__(34);
var toLength = __webpack_require__(29);
var toInteger = __webpack_require__(76);
var arraySpeciesCreate = __webpack_require__(286);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(107)('flatten');


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(2);
var $includes = __webpack_require__(214)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(107)('includes');


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(2);
var microtask = __webpack_require__(298)();
var process = __webpack_require__(13).process;
var isNode = __webpack_require__(72)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(2);
var cof = __webpack_require__(72);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(2);

$export($export.G, { global: __webpack_require__(13) });


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(223)('Map');


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(224)('Map');


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(2);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(410)('Map') });


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);
var scale = __webpack_require__(420);
var fround = __webpack_require__(418);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);

$export($export.S, 'Math', { scale: __webpack_require__(420) });


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(2);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(34);
var aFunction = __webpack_require__(46);
var $defineProperty = __webpack_require__(33);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(31) && $export($export.P + __webpack_require__(220), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(34);
var aFunction = __webpack_require__(46);
var $defineProperty = __webpack_require__(33);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(31) && $export($export.P + __webpack_require__(220), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(2);
var $entries = __webpack_require__(425)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(2);
var ownKeys = __webpack_require__(426);
var toIObject = __webpack_require__(64);
var gOPD = __webpack_require__(62);
var createProperty = __webpack_require__(287);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(34);
var toPrimitive = __webpack_require__(84);
var getPrototypeOf = __webpack_require__(63);
var getOwnPropertyDescriptor = __webpack_require__(62).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(31) && $export($export.P + __webpack_require__(220), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(34);
var toPrimitive = __webpack_require__(84);
var getPrototypeOf = __webpack_require__(63);
var getOwnPropertyDescriptor = __webpack_require__(62).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(31) && $export($export.P + __webpack_require__(220), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(2);
var $values = __webpack_require__(425)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(2);
var global = __webpack_require__(13);
var core = __webpack_require__(73);
var microtask = __webpack_require__(298)();
var OBSERVABLE = __webpack_require__(25)('observable');
var aFunction = __webpack_require__(46);
var anObject = __webpack_require__(9);
var anInstance = __webpack_require__(121);
var redefineAll = __webpack_require__(127);
var hide = __webpack_require__(54);
var forOf = __webpack_require__(122);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(128)('Observable');


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(2);
var core = __webpack_require__(73);
var global = __webpack_require__(13);
var speciesConstructor = __webpack_require__(187);
var promiseResolve = __webpack_require__(430);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(2);
var newPromiseCapability = __webpack_require__(299);
var perform = __webpack_require__(429);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(95);
var anObject = __webpack_require__(9);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(95);
var anObject = __webpack_require__(9);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(438);
var from = __webpack_require__(406);
var metadata = __webpack_require__(95);
var anObject = __webpack_require__(9);
var getPrototypeOf = __webpack_require__(63);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(95);
var anObject = __webpack_require__(9);
var getPrototypeOf = __webpack_require__(63);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(95);
var anObject = __webpack_require__(9);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(95);
var anObject = __webpack_require__(9);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(95);
var anObject = __webpack_require__(9);
var getPrototypeOf = __webpack_require__(63);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(95);
var anObject = __webpack_require__(9);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(95);
var anObject = __webpack_require__(9);
var aFunction = __webpack_require__(46);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(223)('Set');


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(224)('Set');


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(2);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(410)('Set') });


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(2);
var $at = __webpack_require__(225)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(2);
var defined = __webpack_require__(82);
var toLength = __webpack_require__(29);
var isRegExp = __webpack_require__(218);
var getFlags = __webpack_require__(183);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(294)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(2);
var $pad = __webpack_require__(432);
var userAgent = __webpack_require__(227);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(2);
var $pad = __webpack_require__(432);
var userAgent = __webpack_require__(227);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(150)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(150)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(308)('asyncIterator');


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(308)('observable');


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(2);

$export($export.S, 'System', { global: __webpack_require__(13) });


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(223)('WeakMap');


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(224)('WeakMap');


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(223)('WeakSet');


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(224)('WeakSet');


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(310);
var getKeys = __webpack_require__(125);
var redefine = __webpack_require__(55);
var global = __webpack_require__(13);
var hide = __webpack_require__(54);
var Iterators = __webpack_require__(148);
var wks = __webpack_require__(25);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $task = __webpack_require__(306);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(13);
var $export = __webpack_require__(2);
var userAgent = __webpack_require__(227);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(935);
__webpack_require__(874);
__webpack_require__(876);
__webpack_require__(875);
__webpack_require__(878);
__webpack_require__(880);
__webpack_require__(885);
__webpack_require__(879);
__webpack_require__(877);
__webpack_require__(887);
__webpack_require__(886);
__webpack_require__(882);
__webpack_require__(883);
__webpack_require__(881);
__webpack_require__(873);
__webpack_require__(884);
__webpack_require__(888);
__webpack_require__(889);
__webpack_require__(841);
__webpack_require__(843);
__webpack_require__(842);
__webpack_require__(891);
__webpack_require__(890);
__webpack_require__(861);
__webpack_require__(871);
__webpack_require__(872);
__webpack_require__(862);
__webpack_require__(863);
__webpack_require__(864);
__webpack_require__(865);
__webpack_require__(866);
__webpack_require__(867);
__webpack_require__(868);
__webpack_require__(869);
__webpack_require__(870);
__webpack_require__(844);
__webpack_require__(845);
__webpack_require__(846);
__webpack_require__(847);
__webpack_require__(848);
__webpack_require__(849);
__webpack_require__(850);
__webpack_require__(851);
__webpack_require__(852);
__webpack_require__(853);
__webpack_require__(854);
__webpack_require__(855);
__webpack_require__(856);
__webpack_require__(857);
__webpack_require__(858);
__webpack_require__(859);
__webpack_require__(860);
__webpack_require__(922);
__webpack_require__(927);
__webpack_require__(934);
__webpack_require__(925);
__webpack_require__(917);
__webpack_require__(918);
__webpack_require__(923);
__webpack_require__(928);
__webpack_require__(930);
__webpack_require__(913);
__webpack_require__(914);
__webpack_require__(915);
__webpack_require__(916);
__webpack_require__(919);
__webpack_require__(920);
__webpack_require__(921);
__webpack_require__(924);
__webpack_require__(926);
__webpack_require__(929);
__webpack_require__(931);
__webpack_require__(932);
__webpack_require__(933);
__webpack_require__(836);
__webpack_require__(838);
__webpack_require__(837);
__webpack_require__(840);
__webpack_require__(839);
__webpack_require__(825);
__webpack_require__(823);
__webpack_require__(829);
__webpack_require__(826);
__webpack_require__(832);
__webpack_require__(834);
__webpack_require__(822);
__webpack_require__(828);
__webpack_require__(819);
__webpack_require__(833);
__webpack_require__(817);
__webpack_require__(831);
__webpack_require__(830);
__webpack_require__(824);
__webpack_require__(827);
__webpack_require__(816);
__webpack_require__(818);
__webpack_require__(821);
__webpack_require__(820);
__webpack_require__(835);
__webpack_require__(310);
__webpack_require__(907);
__webpack_require__(436);
__webpack_require__(912);
__webpack_require__(437);
__webpack_require__(908);
__webpack_require__(909);
__webpack_require__(910);
__webpack_require__(911);
__webpack_require__(892);
__webpack_require__(435);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(947);
__webpack_require__(936);
__webpack_require__(937);
__webpack_require__(942);
__webpack_require__(945);
__webpack_require__(946);
__webpack_require__(940);
__webpack_require__(943);
__webpack_require__(941);
__webpack_require__(944);
__webpack_require__(938);
__webpack_require__(939);
__webpack_require__(893);
__webpack_require__(894);
__webpack_require__(895);
__webpack_require__(896);
__webpack_require__(897);
__webpack_require__(900);
__webpack_require__(898);
__webpack_require__(899);
__webpack_require__(901);
__webpack_require__(902);
__webpack_require__(903);
__webpack_require__(904);
__webpack_require__(906);
__webpack_require__(905);
__webpack_require__(950);
__webpack_require__(948);
__webpack_require__(949);
__webpack_require__(991);
__webpack_require__(994);
__webpack_require__(993);
__webpack_require__(995);
__webpack_require__(996);
__webpack_require__(992);
__webpack_require__(997);
__webpack_require__(998);
__webpack_require__(972);
__webpack_require__(975);
__webpack_require__(971);
__webpack_require__(969);
__webpack_require__(970);
__webpack_require__(973);
__webpack_require__(974);
__webpack_require__(956);
__webpack_require__(990);
__webpack_require__(955);
__webpack_require__(989);
__webpack_require__(1001);
__webpack_require__(1003);
__webpack_require__(954);
__webpack_require__(988);
__webpack_require__(1000);
__webpack_require__(1002);
__webpack_require__(953);
__webpack_require__(999);
__webpack_require__(952);
__webpack_require__(957);
__webpack_require__(958);
__webpack_require__(959);
__webpack_require__(960);
__webpack_require__(961);
__webpack_require__(963);
__webpack_require__(962);
__webpack_require__(964);
__webpack_require__(965);
__webpack_require__(966);
__webpack_require__(968);
__webpack_require__(967);
__webpack_require__(977);
__webpack_require__(978);
__webpack_require__(979);
__webpack_require__(980);
__webpack_require__(982);
__webpack_require__(981);
__webpack_require__(984);
__webpack_require__(983);
__webpack_require__(985);
__webpack_require__(986);
__webpack_require__(987);
__webpack_require__(951);
__webpack_require__(976);
__webpack_require__(1006);
__webpack_require__(1005);
__webpack_require__(1004);
module.exports = __webpack_require__(73);


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-00377641],\nbody[data-v-00377641] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-00377641]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-00377641] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-00377641] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-00377641] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-00377641],\n  .page-contain[data-v-00377641],\n  .page-submenu[data-v-00377641] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-00377641] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-00377641] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-00377641] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-00377641] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-00377641] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-00377641] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-00377641] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-00377641] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-00377641],\n  .page-submenu[data-v-00377641] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-00377641] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-00377641] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-00377641] {\n    width: 76.3vw;\n}\n.v-main[data-v-00377641] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-00377641] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-00377641] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-00377641] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-00377641] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-00377641] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-00377641] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-00377641],\n  .page-submenu[data-v-00377641] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-00377641] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-00377641] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-00377641] {\n    width: 76.3vw;\n}\n.v-main[data-v-00377641] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-00377641] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-00377641] {\n  margin-top: 0.252525rem;\n}\n[data-v-00377641]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-00377641]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-00377641] {\n  text-align: right;\n}\n.aligncenter[data-v-00377641] {\n  text-align: center;\n}\n.alignleft[data-v-00377641] {\n  text-align: left;\n}\n.actiongroupborder[data-v-00377641] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-00377641] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-00377641] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-00377641] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-00377641] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-00377641] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-00377641] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-00377641] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-00377641] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-00377641] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-00377641] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-00377641] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-00377641] {\n  text-align: center;\n}\n.alignleft[data-v-00377641] {\n  text-align: left;\n}\n.alignright[data-v-00377641] {\n  text-align: right;\n}\n.e2e-container[data-v-00377641] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-00377641] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-00377641] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-00377641] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-00377641] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-00377641] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-00377641] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-00377641] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-00377641] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-00377641] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-00377641] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-00377641],\n.e2e-red-point-left[data-v-00377641] {\n  position: relative;\n}\n.e2e-red-point[data-v-00377641]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-00377641]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-00377641] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-00377641] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-00377641] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-00377641] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-00377641] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-00377641] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-00377641] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-00377641] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-00377641] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-00377641] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-00377641] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-00377641] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-00377641] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-00377641]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-00377641] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-00377641] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-00377641],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-00377641] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-00377641],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-00377641] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-00377641],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-00377641] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-00377641],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-00377641] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-00377641],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-00377641] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-00377641],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-00377641] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-00377641] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-00377641] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-00377641] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-00377641] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-00377641] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-00377641] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-00377641] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-00377641] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-00377641]:hover,\n.el-button--primary[data-v-00377641]:active,\n.el-button--primary[data-v-00377641]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-00377641] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-00377641]:hover,\n.el-button--primary.is-plain[data-v-00377641]:active,\n.el-button--primary.is-plain[data-v-00377641]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-00377641] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-00377641]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-00377641]:active,\n.el-button--primary.is-plain.is-disabled[data-v-00377641]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-00377641] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-00377641]:hover,\n.el-button--primary.is-disabled[data-v-00377641]:active,\n.el-button--primary.is-disabled[data-v-00377641]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-00377641] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-00377641]:hover,\n.el-button--default[data-v-00377641]:active,\n.el-button--default[data-v-00377641]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-00377641] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-00377641]:hover,\n.el-button--text[data-v-00377641]:active,\n.el-button--text[data-v-00377641]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-00377641] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-00377641],\n.operate a + .el-button[data-v-00377641],\n.operate span + .el-button[data-v-00377641],\n.operate a + span[data-v-00377641] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-00377641] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-00377641] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-00377641] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-00377641] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-00377641] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-00377641] {\n  color: #fff;\n}\n.el-loading-mask[data-v-00377641] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-00377641] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-00377641]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-00377641]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-00377641]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-00377641]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-00377641] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-00377641] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-00377641] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-00377641] {\n  color: #999;\n}\n.el-select-dropdown[data-v-00377641] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-00377641] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-00377641] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-00377641] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-00377641] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-00377641] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-00377641] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-00377641]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-00377641] {\n  display: none;\n}\n.el-table th > .cell[data-v-00377641] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-00377641] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-00377641] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-00377641] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-00377641]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-00377641]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-00377641] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-00377641] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-00377641] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-00377641] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-00377641] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-00377641] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-00377641] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-00377641] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-00377641],\n.el-pagination .btn-next[data-v-00377641] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-00377641],\n.el-pagination .btn-next span[data-v-00377641] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-00377641] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-00377641] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-00377641] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-00377641] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-00377641] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-00377641] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-00377641] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-00377641] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-00377641] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-00377641] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-00377641] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-00377641] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-00377641] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-00377641] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-00377641] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-00377641] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-00377641] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-00377641] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-00377641] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-00377641] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-00377641] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-00377641] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-00377641] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-00377641] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-00377641] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-00377641] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-00377641] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-00377641] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-00377641] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-00377641]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-00377641] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-00377641] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-00377641] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-00377641] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-00377641] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-00377641] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-00377641] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-00377641] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-00377641] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-00377641] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-00377641] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-00377641],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-00377641] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-00377641] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-00377641] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-00377641] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-00377641] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-00377641] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-00377641] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-00377641] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-00377641] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-00377641] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-00377641] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-00377641] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-00377641] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-00377641] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-00377641] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-00377641] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-00377641] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-00377641] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-00377641] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-00377641] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-00377641] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-00377641] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-00377641] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-00377641] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-00377641] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-00377641] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-00377641] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-00377641] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-00377641] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-00377641]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-00377641] {\n  color: #666666;\n}\n.el-radio__inner[data-v-00377641]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-00377641] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-00377641] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-00377641] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-00377641] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-00377641] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-00377641] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-00377641] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-00377641] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-00377641],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-00377641]:hover,\n.el-input__icon.el-icon-circle-close[data-v-00377641],\n.el-input__icon.el-icon-circle-close[data-v-00377641]:hover {\n  color: #FB304D;\n}\n*[data-v-00377641],\n*[data-v-00377641]:before,\n*[data-v-00377641]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-00377641],\ntextarea[data-v-00377641] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-00377641]:focus {\n  outline: none;\n}\n.error-content[data-v-00377641] {\n  color: #f56c6c;\n  background: #fee0e0;\n  padding: 0.050505rem 0;\n  text-align: center;\n}\n.error-content p[data-v-00377641] {\n  line-height: 0.121212rem;\n}", ""]);

// exports


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-0318f77e],\nbody[data-v-0318f77e] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-0318f77e]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-0318f77e] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-0318f77e] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-0318f77e] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-0318f77e],\n  .page-contain[data-v-0318f77e],\n  .page-submenu[data-v-0318f77e] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-0318f77e] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-0318f77e] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-0318f77e] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-0318f77e] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-0318f77e] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-0318f77e] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-0318f77e] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-0318f77e] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-0318f77e],\n  .page-submenu[data-v-0318f77e] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-0318f77e] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-0318f77e] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-0318f77e] {\n    width: 76.3vw;\n}\n.v-main[data-v-0318f77e] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-0318f77e] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-0318f77e] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-0318f77e] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-0318f77e] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-0318f77e] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-0318f77e] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-0318f77e],\n  .page-submenu[data-v-0318f77e] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-0318f77e] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-0318f77e] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-0318f77e] {\n    width: 76.3vw;\n}\n.v-main[data-v-0318f77e] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-0318f77e] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-0318f77e] {\n  margin-top: 0.252525rem;\n}\n[data-v-0318f77e]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-0318f77e]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-0318f77e] {\n  text-align: right;\n}\n.aligncenter[data-v-0318f77e] {\n  text-align: center;\n}\n.alignleft[data-v-0318f77e] {\n  text-align: left;\n}\n.actiongroupborder[data-v-0318f77e] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-0318f77e] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-0318f77e] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-0318f77e] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-0318f77e] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-0318f77e] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-0318f77e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-0318f77e] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-0318f77e] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-0318f77e] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-0318f77e] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-0318f77e] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-0318f77e] {\n  text-align: center;\n}\n.alignleft[data-v-0318f77e] {\n  text-align: left;\n}\n.alignright[data-v-0318f77e] {\n  text-align: right;\n}\n.e2e-container[data-v-0318f77e] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-0318f77e] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-0318f77e] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-0318f77e] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-0318f77e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-0318f77e] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-0318f77e] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-0318f77e] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-0318f77e] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-0318f77e] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-0318f77e] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-0318f77e],\n.e2e-red-point-left[data-v-0318f77e] {\n  position: relative;\n}\n.e2e-red-point[data-v-0318f77e]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-0318f77e]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-0318f77e] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-0318f77e] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-0318f77e] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-0318f77e] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-0318f77e] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-0318f77e] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-0318f77e] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-0318f77e] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-0318f77e] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-0318f77e] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-0318f77e] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-0318f77e] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-0318f77e] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-0318f77e]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-0318f77e] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-0318f77e] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-0318f77e],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-0318f77e] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-0318f77e],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-0318f77e] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-0318f77e],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-0318f77e] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-0318f77e],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-0318f77e] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-0318f77e],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-0318f77e] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-0318f77e],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-0318f77e] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-0318f77e] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-0318f77e] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-0318f77e] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-0318f77e] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-0318f77e] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-0318f77e] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-0318f77e] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-0318f77e] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-0318f77e]:hover,\n.el-button--primary[data-v-0318f77e]:active,\n.el-button--primary[data-v-0318f77e]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-0318f77e] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-0318f77e]:hover,\n.el-button--primary.is-plain[data-v-0318f77e]:active,\n.el-button--primary.is-plain[data-v-0318f77e]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-0318f77e] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-0318f77e]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-0318f77e]:active,\n.el-button--primary.is-plain.is-disabled[data-v-0318f77e]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-0318f77e] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-0318f77e]:hover,\n.el-button--primary.is-disabled[data-v-0318f77e]:active,\n.el-button--primary.is-disabled[data-v-0318f77e]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-0318f77e] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-0318f77e]:hover,\n.el-button--default[data-v-0318f77e]:active,\n.el-button--default[data-v-0318f77e]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-0318f77e] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-0318f77e]:hover,\n.el-button--text[data-v-0318f77e]:active,\n.el-button--text[data-v-0318f77e]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-0318f77e] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-0318f77e],\n.operate a + .el-button[data-v-0318f77e],\n.operate span + .el-button[data-v-0318f77e],\n.operate a + span[data-v-0318f77e] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-0318f77e] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-0318f77e] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-0318f77e] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-0318f77e] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-0318f77e] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-0318f77e] {\n  color: #fff;\n}\n.el-loading-mask[data-v-0318f77e] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-0318f77e] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-0318f77e]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-0318f77e]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-0318f77e]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-0318f77e]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-0318f77e] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-0318f77e] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-0318f77e] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-0318f77e] {\n  color: #999;\n}\n.el-select-dropdown[data-v-0318f77e] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-0318f77e] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-0318f77e] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-0318f77e] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-0318f77e] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-0318f77e] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-0318f77e] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-0318f77e]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-0318f77e] {\n  display: none;\n}\n.el-table th > .cell[data-v-0318f77e] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-0318f77e] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-0318f77e] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-0318f77e] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-0318f77e]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-0318f77e]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-0318f77e] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-0318f77e] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-0318f77e] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-0318f77e] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-0318f77e] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-0318f77e] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-0318f77e] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-0318f77e] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-0318f77e],\n.el-pagination .btn-next[data-v-0318f77e] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-0318f77e],\n.el-pagination .btn-next span[data-v-0318f77e] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-0318f77e] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-0318f77e] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-0318f77e] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-0318f77e] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-0318f77e] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-0318f77e] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-0318f77e] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-0318f77e] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-0318f77e] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-0318f77e] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-0318f77e] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-0318f77e] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-0318f77e] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-0318f77e] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-0318f77e] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-0318f77e] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-0318f77e] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-0318f77e] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-0318f77e] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-0318f77e] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-0318f77e] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-0318f77e] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-0318f77e] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-0318f77e] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-0318f77e] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-0318f77e] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-0318f77e] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-0318f77e] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-0318f77e] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-0318f77e]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-0318f77e] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-0318f77e] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-0318f77e] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-0318f77e] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-0318f77e] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-0318f77e] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-0318f77e] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-0318f77e] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-0318f77e] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-0318f77e] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-0318f77e] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-0318f77e],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-0318f77e] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-0318f77e] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-0318f77e] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-0318f77e] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-0318f77e] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-0318f77e] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-0318f77e] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-0318f77e] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-0318f77e] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-0318f77e] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-0318f77e] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-0318f77e] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-0318f77e] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-0318f77e] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-0318f77e] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-0318f77e] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-0318f77e] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-0318f77e] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-0318f77e] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-0318f77e] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-0318f77e] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-0318f77e] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-0318f77e] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-0318f77e] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-0318f77e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-0318f77e] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-0318f77e] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-0318f77e] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-0318f77e] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-0318f77e]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-0318f77e] {\n  color: #666666;\n}\n.el-radio__inner[data-v-0318f77e]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-0318f77e] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-0318f77e] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-0318f77e] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-0318f77e] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-0318f77e] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-0318f77e] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-0318f77e] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-0318f77e] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-0318f77e],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-0318f77e]:hover,\n.el-input__icon.el-icon-circle-close[data-v-0318f77e],\n.el-input__icon.el-icon-circle-close[data-v-0318f77e]:hover {\n  color: #FB304D;\n}\n*[data-v-0318f77e],\n*[data-v-0318f77e]:before,\n*[data-v-0318f77e]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-0318f77e],\ntextarea[data-v-0318f77e] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-0318f77e]:focus {\n  outline: none;\n}\n.e2e-single-upload[data-v-0318f77e] {\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-button + .e2e-single-upload-container[data-v-0318f77e] {\n  margin: 0 0 0 0.040404rem;\n}\n.e2e-single-upload-container[data-v-0318f77e] {\n  display: inline-block;\n}\n.e2e-single-upload-container + .el-button[data-v-0318f77e] {\n  margin: 0 0 0 0.040404rem;\n}", ""]);

// exports


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml,\nbody {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.v-main,\n  .page-contain,\n  .page-submenu {\n    width: 6.060606rem;\n}\n.page-submenu_left {\n    width: 1.313131rem;\n}\n.page-submenu_right {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n.has-header {\n  margin-top: 0.252525rem;\n}\n::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright {\n  text-align: right;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.common_reddot_item {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label {\n  line-height: 0.10101rem;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.alignright {\n  text-align: right;\n}\n.e2e-container {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell {\n  overflow: visible;\n}\n.e2e-red-point,\n.e2e-red-point-left {\n  position: relative;\n}\n.e2e-red-point::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small /deep/ input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small /deep/ input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray /deep/ input {\n  background: #efefef;\n}\n.e2e-radio-large /deep/ .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money {\n  color: #0B41CD;\n}\n.e2e-copy {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy:before {\n  content: '\\E787';\n}\n.e2e-warning {\n  color: #e02020;\n}\n.e2e-warning-blue {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button {\n  font-size: 0.065657rem;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.el-button {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary:hover,\n.el-button--primary:active,\n.el-button--primary:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain:hover,\n.el-button--primary.is-plain:active,\n.el-button--primary.is-plain:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled:hover,\n.el-button--primary.is-plain.is-disabled:active,\n.el-button--primary.is-plain.is-disabled:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled:hover,\n.el-button--primary.is-disabled:active,\n.el-button--primary.is-disabled:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default:hover,\n.el-button--default:active,\n.el-button--default:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text:hover,\n.el-button--text:active,\n.el-button--text:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled {\n  color: #6D7278;\n}\n.operate .el-button + .el-button,\n.operate a + .el-button,\n.operate span + .el-button,\n.operate a + span {\n  margin-left: 0.121212rem;\n}\n.operate span > div {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text {\n  color: #fff;\n}\n.el-loading-mask {\n  z-index: 9998;\n}\n.el-input__inner {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.is-disabled.el-input :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.el-select-dropdown {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label {\n  padding: 0;\n}\n.header-menu-dropdown {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow {\n  display: none;\n}\n.el-table th > .cell {\n  font-weight: bold !important;\n}\n.el-table .cell {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell {\n  padding-left: 0.070707rem;\n}\n.el-table td {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev,\n.el-pagination .btn-next {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span,\n.el-pagination .btn-next span {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog {\n  border-radius: 0.020202rem;\n}\n.el-drawer {\n  overflow: auto;\n}\n.common-confirm-dialog {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog {\n  width: 3.030303rem !important;\n}\n.approval-dialog {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select,\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer {\n  text-align: center;\n}\n.application-search-content-main-fields .active {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label {\n  color: #666666;\n}\n.el-radio__inner:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label {\n  color: #E64100;\n}\n.tox-tinymce-aux {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper {\n  width: 0.757576rem;\n}\n.custom-tooltip {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close,\n.el-select__caret.el-input__icon.el-icon-circle-close:hover,\n.el-input__icon.el-icon-circle-close,\n.el-input__icon.el-icon-circle-close:hover {\n  color: #FB304D;\n}\n*,\n*:before,\n*:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput,\ntextarea {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput:focus {\n  outline: none;\n}\n.meetingplan-application .common-confirm-info div + div {\n  margin-top: 0.025253rem !important;\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}", ""]);

// exports


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-04a6ca76],\nbody[data-v-04a6ca76] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-04a6ca76]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-04a6ca76] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-04a6ca76] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-04a6ca76] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-04a6ca76],\n  .page-contain[data-v-04a6ca76],\n  .page-submenu[data-v-04a6ca76] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-04a6ca76] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-04a6ca76] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-04a6ca76] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-04a6ca76] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-04a6ca76] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-04a6ca76] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-04a6ca76] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-04a6ca76] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-04a6ca76],\n  .page-submenu[data-v-04a6ca76] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-04a6ca76] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-04a6ca76] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-04a6ca76] {\n    width: 76.3vw;\n}\n.v-main[data-v-04a6ca76] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-04a6ca76] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-04a6ca76] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-04a6ca76] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-04a6ca76] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-04a6ca76] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-04a6ca76] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-04a6ca76],\n  .page-submenu[data-v-04a6ca76] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-04a6ca76] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-04a6ca76] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-04a6ca76] {\n    width: 76.3vw;\n}\n.v-main[data-v-04a6ca76] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-04a6ca76] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-04a6ca76] {\n  margin-top: 0.252525rem;\n}\n[data-v-04a6ca76]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-04a6ca76]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-04a6ca76] {\n  text-align: right;\n}\n.aligncenter[data-v-04a6ca76] {\n  text-align: center;\n}\n.alignleft[data-v-04a6ca76] {\n  text-align: left;\n}\n.actiongroupborder[data-v-04a6ca76] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-04a6ca76] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-04a6ca76] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-04a6ca76] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-04a6ca76] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-04a6ca76] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-04a6ca76] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-04a6ca76] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-04a6ca76] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-04a6ca76] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-04a6ca76] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-04a6ca76] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-04a6ca76] {\n  text-align: center;\n}\n.alignleft[data-v-04a6ca76] {\n  text-align: left;\n}\n.alignright[data-v-04a6ca76] {\n  text-align: right;\n}\n.e2e-container[data-v-04a6ca76] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-04a6ca76] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-04a6ca76] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-04a6ca76] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-04a6ca76] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-04a6ca76] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-04a6ca76] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-04a6ca76] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-04a6ca76] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-04a6ca76] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-04a6ca76] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-04a6ca76],\n.e2e-red-point-left[data-v-04a6ca76] {\n  position: relative;\n}\n.e2e-red-point[data-v-04a6ca76]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-04a6ca76]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-04a6ca76] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-04a6ca76] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-04a6ca76] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-04a6ca76] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-04a6ca76] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-04a6ca76] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-04a6ca76] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-04a6ca76] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-04a6ca76] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-04a6ca76] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-04a6ca76] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-04a6ca76] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-04a6ca76] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-04a6ca76]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-04a6ca76] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-04a6ca76] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-04a6ca76],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-04a6ca76] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-04a6ca76],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-04a6ca76] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-04a6ca76],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-04a6ca76] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-04a6ca76],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-04a6ca76] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-04a6ca76],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-04a6ca76] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-04a6ca76],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-04a6ca76] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-04a6ca76] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-04a6ca76] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-04a6ca76] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-04a6ca76] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-04a6ca76] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-04a6ca76] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-04a6ca76] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-04a6ca76] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-04a6ca76]:hover,\n.el-button--primary[data-v-04a6ca76]:active,\n.el-button--primary[data-v-04a6ca76]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-04a6ca76] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-04a6ca76]:hover,\n.el-button--primary.is-plain[data-v-04a6ca76]:active,\n.el-button--primary.is-plain[data-v-04a6ca76]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-04a6ca76] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-04a6ca76]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-04a6ca76]:active,\n.el-button--primary.is-plain.is-disabled[data-v-04a6ca76]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-04a6ca76] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-04a6ca76]:hover,\n.el-button--primary.is-disabled[data-v-04a6ca76]:active,\n.el-button--primary.is-disabled[data-v-04a6ca76]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-04a6ca76] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-04a6ca76]:hover,\n.el-button--default[data-v-04a6ca76]:active,\n.el-button--default[data-v-04a6ca76]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-04a6ca76] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-04a6ca76]:hover,\n.el-button--text[data-v-04a6ca76]:active,\n.el-button--text[data-v-04a6ca76]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-04a6ca76] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-04a6ca76],\n.operate a + .el-button[data-v-04a6ca76],\n.operate span + .el-button[data-v-04a6ca76],\n.operate a + span[data-v-04a6ca76] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-04a6ca76] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-04a6ca76] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-04a6ca76] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-04a6ca76] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-04a6ca76] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-04a6ca76] {\n  color: #fff;\n}\n.el-loading-mask[data-v-04a6ca76] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-04a6ca76] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-04a6ca76]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-04a6ca76]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-04a6ca76]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-04a6ca76]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-04a6ca76] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-04a6ca76] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-04a6ca76] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-04a6ca76] {\n  color: #999;\n}\n.el-select-dropdown[data-v-04a6ca76] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-04a6ca76] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-04a6ca76] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-04a6ca76] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-04a6ca76] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-04a6ca76] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-04a6ca76] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-04a6ca76]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-04a6ca76] {\n  display: none;\n}\n.el-table th > .cell[data-v-04a6ca76] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-04a6ca76] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-04a6ca76] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-04a6ca76] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-04a6ca76]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-04a6ca76]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-04a6ca76] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-04a6ca76] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-04a6ca76] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-04a6ca76] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-04a6ca76] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-04a6ca76] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-04a6ca76] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-04a6ca76] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-04a6ca76],\n.el-pagination .btn-next[data-v-04a6ca76] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-04a6ca76],\n.el-pagination .btn-next span[data-v-04a6ca76] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-04a6ca76] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-04a6ca76] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-04a6ca76] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-04a6ca76] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-04a6ca76] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-04a6ca76] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-04a6ca76] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-04a6ca76] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-04a6ca76] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-04a6ca76] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-04a6ca76] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-04a6ca76] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-04a6ca76] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-04a6ca76] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-04a6ca76] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-04a6ca76] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-04a6ca76] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-04a6ca76] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-04a6ca76] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-04a6ca76] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-04a6ca76] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-04a6ca76] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-04a6ca76] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-04a6ca76] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-04a6ca76] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-04a6ca76] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-04a6ca76] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-04a6ca76] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-04a6ca76] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-04a6ca76]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-04a6ca76] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-04a6ca76] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-04a6ca76] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-04a6ca76] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-04a6ca76] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-04a6ca76] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-04a6ca76] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-04a6ca76] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-04a6ca76] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-04a6ca76] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-04a6ca76] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-04a6ca76],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-04a6ca76] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-04a6ca76] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-04a6ca76] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-04a6ca76] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-04a6ca76] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-04a6ca76] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-04a6ca76] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-04a6ca76] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-04a6ca76] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-04a6ca76] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-04a6ca76] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-04a6ca76] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-04a6ca76] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-04a6ca76] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-04a6ca76] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-04a6ca76] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-04a6ca76] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-04a6ca76] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-04a6ca76] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-04a6ca76] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-04a6ca76] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-04a6ca76] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-04a6ca76] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-04a6ca76] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-04a6ca76] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-04a6ca76] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-04a6ca76] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-04a6ca76] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-04a6ca76] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-04a6ca76]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-04a6ca76] {\n  color: #666666;\n}\n.el-radio__inner[data-v-04a6ca76]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-04a6ca76] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-04a6ca76] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-04a6ca76] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-04a6ca76] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-04a6ca76] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-04a6ca76] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-04a6ca76] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-04a6ca76] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-04a6ca76],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-04a6ca76]:hover,\n.el-input__icon.el-icon-circle-close[data-v-04a6ca76],\n.el-input__icon.el-icon-circle-close[data-v-04a6ca76]:hover {\n  color: #FB304D;\n}\n*[data-v-04a6ca76],\n*[data-v-04a6ca76]:before,\n*[data-v-04a6ca76]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-04a6ca76],\ntextarea[data-v-04a6ca76] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-04a6ca76]:focus {\n  outline: none;\n}\n.page-contain-tab[data-v-04a6ca76] {\n  margin-bottom: 0.353535rem !important;\n}\n.application-search-content-main[data-v-04a6ca76] {\n  background-color: #fff;\n  padding: 0.040404rem 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  font-size: 0.080808rem;\n}\n.application-search-content-main-add[data-v-04a6ca76] {\n  float: right;\n}\n.application-search-content-main-fields-year[data-v-04a6ca76] {\n  width: 0.40404rem;\n  margin-right: 0 !important;\n}\n.application-search-content-main-fields-quarter[data-v-04a6ca76] {\n  margin-left: 0.151515rem;\n}\n.application-search-content-main-fields-quarter label[data-v-04a6ca76] {\n  cursor: pointer;\n}\n.application-search-content-main-fields-quarter-lines[data-v-04a6ca76] {\n  margin-left: 0.409091rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.application-search-content-main-fields-quarter-lines .line-active[data-v-04a6ca76] {\n  border-bottom: 0.015152rem solid #0b41cd;\n  margin-bottom: -0.040404rem;\n}\n.application-search-content-main-fields-quarter-lines-line[data-v-04a6ca76] {\n  border-bottom: 0.015152rem solid #0b41cd;\n  width: 0.20202rem;\n  border-bottom: none;\n}\n.application-search-content-main-fields-quarter-lines-line-q1[data-v-04a6ca76] {\n  margin-left: 0.121212rem;\n}\n.application-search-content-main-fields-quarter-lines-line-q2[data-v-04a6ca76] {\n  margin-left: 0.060606rem;\n}\n.application-search-content-main-fields-quarter-lines-line-q3[data-v-04a6ca76] {\n  margin-left: 0.050505rem;\n}\n.application-search-content-main-fields-quarter-lines-line-q4[data-v-04a6ca76] {\n  margin-left: 0.060606rem;\n}\n.page-contain-main-tab[data-v-04a6ca76] {\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  background-color: transparent !important;\n}\n.page-contain-main-tab .main-blocks[data-v-04a6ca76] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row nowrap;\n          flex-flow: row nowrap;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-contain-main-tab .main-block[data-v-04a6ca76] {\n  height: 0.757576rem;\n  width: 1.449495rem;\n  display: inline-block;\n  border: none;\n  background: #fff;\n  border-radius: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain[data-v-04a6ca76] {\n  display: inline-block;\n  width: 1.186869rem;\n}\n.page-contain-main-tab .main-block-contain-title[data-v-04a6ca76] {\n  margin-left: 0.121212rem;\n  margin-top: 0.080808rem;\n  height: 0.111111rem;\n  line-height: 0.111111rem;\n  font-size: 0.080808rem;\n  color: #666666;\n  width: 100%;\n}\n.page-contain-main-tab .main-block-contain-title .iconfont[data-v-04a6ca76] {\n  float: right;\n  font-size: 0.070707rem;\n}\n.page-contain-main-tab .main-block-contain-application[data-v-04a6ca76] {\n  margin-left: 0.121212rem;\n  margin-top: 0.090909rem;\n  height: 0.151515rem;\n  line-height: 0.151515rem;\n  font-size: 0.111111rem;\n  width: 100%;\n}\n.page-contain-main-tab .main-block-contain-application label[data-v-04a6ca76] {\n  color: rgba(0, 0, 0, 0.85);\n}\n.page-contain-main-tab .main-block-contain-application .iconfont[data-v-04a6ca76] {\n  font-size: 0.141414rem;\n}\n.page-contain-main-tab .main-block-contain-application .icon-yitijiao[data-v-04a6ca76] {\n  color: #2D82F0;\n}\n.page-contain-main-tab .main-block-contain-application .icon-shenpizhong[data-v-04a6ca76] {\n  color: #FFB52A;\n}\n.page-contain-main-tab .main-block-contain-application .icon-shenpitongguo[data-v-04a6ca76] {\n  color: #0EC771;\n}\n.page-contain-main-tab .main-block-contain-application .icon-shenpijujue[data-v-04a6ca76] {\n  color: #FB304D;\n}\n.page-contain-main-tab .main-block-contain-split-line[data-v-04a6ca76] {\n  border-top: 0.005051rem solid #E8E8E8;\n  width: 1.10101rem;\n  margin: 0.10101rem 0 0 0.121212rem;\n}\n.page-contain-main-tab .main-block-contain-total[data-v-04a6ca76] {\n  margin: 0.045455rem 0 0 0.121212rem;\n  font-size: 0.070707rem;\n  color: rgba(0, 0, 0, 0.65);\n}\n.page-contain-main-tab .main-block-contain-total label[data-v-04a6ca76] {\n  margin-left: 0.040404rem;\n  color: rgba(0, 0, 0, 0.85);\n}\n.search-content[data-v-04a6ca76] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 0.131313rem;\n}\n.search-content .search-content-fields[data-v-04a6ca76] {\n  display: contents;\n}\n.search-content .search-content-fields-operate[data-v-04a6ca76] {\n  margin-left: auto !important;\n}\n.search-content .el-form-item + .el-form-item[data-v-04a6ca76] {\n  margin-left: 0.116162rem;\n}\n.l-user-item[data-v-04a6ca76] {\n  width: 100%;\n  height: 0.287879rem;\n  padding: 0.090909rem 0.111111rem;\n  border-bottom: 0.005051rem solid #dfdfdf;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.l-user-item-icon[data-v-04a6ca76] {\n  font-size: 0.080808rem;\n  padding: 0.010101rem;\n}\n.toolbar[data-v-04a6ca76] {\n  height: 0.191919rem;\n}\n.toolbar .application-detail-info[data-v-04a6ca76] {\n  float: left;\n  height: 0.111111rem;\n  line-height: 0.111111rem;\n  font-size: 0.070707rem;\n  color: #333333;\n}\n.toolbar .operate[data-v-04a6ca76] {\n  float: right;\n  height: 0.111111rem;\n  line-height: 0.111111rem;\n}\n.toolbar .operate-export[data-v-04a6ca76] {\n  font-size: 0.070707rem;\n}\n.toolbar .operate-export a[data-v-04a6ca76] {\n  color: #0B41CD;\n}\n.toolbar .operate-export i[data-v-04a6ca76] {\n  font-size: 0.070707rem;\n}\n.main-application-info-block[data-v-04a6ca76] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-bottom: 0.080808rem;\n}\n.main-application-info-block-name[data-v-04a6ca76] {\n  width: 50%;\n}\n.main-application-info-block-name label[data-v-04a6ca76] {\n  float: right;\n  font-size: 0.070707rem;\n  color: #666666;\n}\n.main-application-info-block-value[data-v-04a6ca76] {\n  font-size: 0.070707rem;\n  color: #333333;\n}\n.bottom-info[data-v-04a6ca76] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: fixed;\n  background-color: #fff;\n  width: 100%;\n  left: 0;\n  height: 0.222222rem;\n  -webkit-box-shadow: -0.005051rem 0 0.020202rem 0 rgba(51, 51, 51, 0.35);\n          box-shadow: -0.005051rem 0 0.020202rem 0 rgba(51, 51, 51, 0.35);\n  bottom: 0;\n  z-index: 5;\n}\n.bottom-info-info[data-v-04a6ca76] {\n  margin-left: 0.606061rem;\n  line-height: 0.222222rem;\n}\n.bottom-info-operate[data-v-04a6ca76] {\n  position: absolute;\n  right: 0.606061rem;\n  line-height: 0.232323rem;\n}\n.advanced-search-dialog[data-v-04a6ca76] {\n  padding: 0;\n}\n.advanced-search-dialog .advanced-search-dialog-close[data-v-04a6ca76] {\n  font-size: 0.070707rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right[data-v-04a6ca76] {\n  margin-bottom: 0.025253rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row[data-v-04a6ca76] {\n  padding: 0.141414rem 0 0 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .advanced-search-form-title[data-v-04a6ca76] {\n  height: 0.20202rem;\n  line-height: 0.20202rem;\n  width: 0.454545rem;\n  font-weight: bold;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .advanced-search-form-title .iconfont[data-v-04a6ca76] {\n  font-size: 0.070707rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col[data-v-04a6ca76] {\n  width: 1.212121rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col .el-form-item__label[data-v-04a6ca76] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col .el-form-item__content[data-v-04a6ca76] {\n  padding-top: 0.010101rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col .el-form-item__content .el-select[data-v-04a6ca76],\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col .el-form-item__content .el-input[data-v-04a6ca76] {\n  width: 1.212121rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col .el-form-item__content label[data-v-04a6ca76] {\n  margin-left: 0.050505rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col + .el-col[data-v-04a6ca76] {\n  margin-left: 0.621212rem;\n}\n.advanced-search-dialog-close[data-v-04a6ca76] {\n  margin-left: 0.126263rem;\n  cursor: pointer;\n}\n.advanced-search-dialog-score-model[data-v-04a6ca76] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 1.212121rem;\n}\n.advanced-search-dialog-score-model .el-input-number[data-v-04a6ca76] {\n  width: 0.484848rem !important;\n}\n.advanced-search-dialog-score-model span[data-v-04a6ca76] {\n  margin: auto 0.10101rem;\n  width: 0.050505rem;\n  border-bottom: 0.010101rem solid #666666;\n}\n.advanced-search-dialog-queue-model[data-v-04a6ca76] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 1.212121rem;\n}\n.advanced-search-dialog-queue-model .el-input-number[data-v-04a6ca76] {\n  width: 0.484848rem !important;\n}\n.advanced-search-dialog-queue-model span[data-v-04a6ca76] {\n  margin: auto 0.10101rem;\n  width: 0.050505rem;\n  border-bottom: 0.010101rem solid #666666;\n}\n.advanced-search-dialog .l-user-item[data-v-04a6ca76] {\n  width: 100%;\n  height: 0.20202rem;\n  padding: 0 0.111111rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.advanced-search-dialog .l-user-item-icon[data-v-04a6ca76] {\n  font-size: 0.080808rem;\n  padding: 0.010101rem;\n  width: 0.10101rem;\n}\n.advanced-search-dialog .l-user-item-text[data-v-04a6ca76] {\n  margin-left: 0.025253rem;\n  font-size: 0.070707rem;\n  line-height: 0.10101rem;\n  display: inline-block;\n}\n.advanced-search-dialog .l-user-item[data-v-04a6ca76]:hover {\n  color: #0B41CD;\n  cursor: pointer;\n}\n.advanced-search-dialog .l-user-item[data-v-04a6ca76]:last-child {\n  border-bottom: none;\n}", ""]);

// exports


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "/* html,\nbody,\n#app {\n  margin: 0;\n  height: 100%;\n} */\n#app {\n  font-family: \"PingFangSC\", \"PingFangSC-Medium\", \"Arial\", \"Helvetica\", sans-serif, \"SimHei\", \"Microsoft YaHei\";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #2c3e50;\n}\nul,\nli,\na,\nh1,\nh2,\nh3 {\n  margin: 0;\n  padding: 0;\n}\ndiv {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\nli {\n  list-style: none;\n}\na {\n  text-decoration: none;\n}", ""]);

// exports


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-07c4f24c],\nbody[data-v-07c4f24c] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-07c4f24c]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-07c4f24c] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-07c4f24c] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-07c4f24c] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-07c4f24c],\n  .page-contain[data-v-07c4f24c],\n  .page-submenu[data-v-07c4f24c] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-07c4f24c] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-07c4f24c] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-07c4f24c] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-07c4f24c] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-07c4f24c] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-07c4f24c] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-07c4f24c] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-07c4f24c] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-07c4f24c],\n  .page-submenu[data-v-07c4f24c] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-07c4f24c] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-07c4f24c] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-07c4f24c] {\n    width: 76.3vw;\n}\n.v-main[data-v-07c4f24c] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-07c4f24c] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-07c4f24c] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-07c4f24c] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-07c4f24c] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-07c4f24c] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-07c4f24c] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-07c4f24c],\n  .page-submenu[data-v-07c4f24c] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-07c4f24c] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-07c4f24c] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-07c4f24c] {\n    width: 76.3vw;\n}\n.v-main[data-v-07c4f24c] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-07c4f24c] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-07c4f24c] {\n  margin-top: 0.252525rem;\n}\n[data-v-07c4f24c]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-07c4f24c]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-07c4f24c] {\n  text-align: right;\n}\n.aligncenter[data-v-07c4f24c] {\n  text-align: center;\n}\n.alignleft[data-v-07c4f24c] {\n  text-align: left;\n}\n.actiongroupborder[data-v-07c4f24c] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-07c4f24c] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-07c4f24c] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-07c4f24c] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-07c4f24c] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-07c4f24c] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-07c4f24c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-07c4f24c] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-07c4f24c] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-07c4f24c] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-07c4f24c] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-07c4f24c] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-07c4f24c] {\n  text-align: center;\n}\n.alignleft[data-v-07c4f24c] {\n  text-align: left;\n}\n.alignright[data-v-07c4f24c] {\n  text-align: right;\n}\n.e2e-container[data-v-07c4f24c] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-07c4f24c] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-07c4f24c] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-07c4f24c] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-07c4f24c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-07c4f24c] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-07c4f24c] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-07c4f24c] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-07c4f24c] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-07c4f24c] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-07c4f24c] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-07c4f24c],\n.e2e-red-point-left[data-v-07c4f24c] {\n  position: relative;\n}\n.e2e-red-point[data-v-07c4f24c]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-07c4f24c]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-07c4f24c] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-07c4f24c] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-07c4f24c] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-07c4f24c] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-07c4f24c] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-07c4f24c] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-07c4f24c] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-07c4f24c] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-07c4f24c] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-07c4f24c] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-07c4f24c] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-07c4f24c] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-07c4f24c] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-07c4f24c]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-07c4f24c] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-07c4f24c] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-07c4f24c],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-07c4f24c] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-07c4f24c],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-07c4f24c] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-07c4f24c],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-07c4f24c] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-07c4f24c],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-07c4f24c] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-07c4f24c],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-07c4f24c] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-07c4f24c],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-07c4f24c] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-07c4f24c] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-07c4f24c] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-07c4f24c] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-07c4f24c] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-07c4f24c] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-07c4f24c] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-07c4f24c] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-07c4f24c] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-07c4f24c]:hover,\n.el-button--primary[data-v-07c4f24c]:active,\n.el-button--primary[data-v-07c4f24c]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-07c4f24c] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-07c4f24c]:hover,\n.el-button--primary.is-plain[data-v-07c4f24c]:active,\n.el-button--primary.is-plain[data-v-07c4f24c]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-07c4f24c] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-07c4f24c]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-07c4f24c]:active,\n.el-button--primary.is-plain.is-disabled[data-v-07c4f24c]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-07c4f24c] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-07c4f24c]:hover,\n.el-button--primary.is-disabled[data-v-07c4f24c]:active,\n.el-button--primary.is-disabled[data-v-07c4f24c]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-07c4f24c] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-07c4f24c]:hover,\n.el-button--default[data-v-07c4f24c]:active,\n.el-button--default[data-v-07c4f24c]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-07c4f24c] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-07c4f24c]:hover,\n.el-button--text[data-v-07c4f24c]:active,\n.el-button--text[data-v-07c4f24c]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-07c4f24c] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-07c4f24c],\n.operate a + .el-button[data-v-07c4f24c],\n.operate span + .el-button[data-v-07c4f24c],\n.operate a + span[data-v-07c4f24c] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-07c4f24c] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-07c4f24c] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-07c4f24c] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-07c4f24c] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-07c4f24c] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-07c4f24c] {\n  color: #fff;\n}\n.el-loading-mask[data-v-07c4f24c] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-07c4f24c] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-07c4f24c]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-07c4f24c]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-07c4f24c]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-07c4f24c]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-07c4f24c] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-07c4f24c] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-07c4f24c] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-07c4f24c] {\n  color: #999;\n}\n.el-select-dropdown[data-v-07c4f24c] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-07c4f24c] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-07c4f24c] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-07c4f24c] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-07c4f24c] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-07c4f24c] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-07c4f24c] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-07c4f24c]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-07c4f24c] {\n  display: none;\n}\n.el-table th > .cell[data-v-07c4f24c] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-07c4f24c] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-07c4f24c] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-07c4f24c] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-07c4f24c]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-07c4f24c]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-07c4f24c] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-07c4f24c] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-07c4f24c] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-07c4f24c] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-07c4f24c] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-07c4f24c] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-07c4f24c] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-07c4f24c] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-07c4f24c],\n.el-pagination .btn-next[data-v-07c4f24c] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-07c4f24c],\n.el-pagination .btn-next span[data-v-07c4f24c] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-07c4f24c] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-07c4f24c] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-07c4f24c] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-07c4f24c] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-07c4f24c] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-07c4f24c] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-07c4f24c] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-07c4f24c] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-07c4f24c] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-07c4f24c] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-07c4f24c] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-07c4f24c] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-07c4f24c] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-07c4f24c] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-07c4f24c] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-07c4f24c] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-07c4f24c] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-07c4f24c] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-07c4f24c] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-07c4f24c] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-07c4f24c] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-07c4f24c] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-07c4f24c] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-07c4f24c] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-07c4f24c] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-07c4f24c] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-07c4f24c] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-07c4f24c] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-07c4f24c] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-07c4f24c]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-07c4f24c] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-07c4f24c] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-07c4f24c] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-07c4f24c] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-07c4f24c] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-07c4f24c] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-07c4f24c] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-07c4f24c] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-07c4f24c] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-07c4f24c] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-07c4f24c] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-07c4f24c],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-07c4f24c] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-07c4f24c] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-07c4f24c] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-07c4f24c] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-07c4f24c] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-07c4f24c] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-07c4f24c] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-07c4f24c] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-07c4f24c] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-07c4f24c] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-07c4f24c] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-07c4f24c] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-07c4f24c] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-07c4f24c] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-07c4f24c] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-07c4f24c] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-07c4f24c] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-07c4f24c] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-07c4f24c] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-07c4f24c] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-07c4f24c] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-07c4f24c] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-07c4f24c] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-07c4f24c] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-07c4f24c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-07c4f24c] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-07c4f24c] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-07c4f24c] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-07c4f24c] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-07c4f24c]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-07c4f24c] {\n  color: #666666;\n}\n.el-radio__inner[data-v-07c4f24c]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-07c4f24c] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-07c4f24c] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-07c4f24c] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-07c4f24c] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-07c4f24c] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-07c4f24c] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-07c4f24c] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-07c4f24c] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-07c4f24c],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-07c4f24c]:hover,\n.el-input__icon.el-icon-circle-close[data-v-07c4f24c],\n.el-input__icon.el-icon-circle-close[data-v-07c4f24c]:hover {\n  color: #FB304D;\n}\n*[data-v-07c4f24c],\n*[data-v-07c4f24c]:before,\n*[data-v-07c4f24c]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-07c4f24c],\ntextarea[data-v-07c4f24c] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-07c4f24c]:focus {\n  outline: none;\n}\n.page-contain .page-contain-tab[data-v-07c4f24c] {\n  padding: 0 0.282828rem 0.161616rem 0.282828rem;\n  margin-bottom: 0.121212rem;\n}\n.page-contain .page-contain-tab .recipientSocietyOrHospital-text span[data-v-07c4f24c] {\n  color: #0B41CD;\n}\n.page-contain .page-contain-tab .recipientSociety-input[data-v-07c4f24c] {\n  font-size: 0.070707rem;\n  margin-left: 0.050505rem;\n  padding-top: 0.040404rem !important;\n}\n.page-contain .page-contain-tab .more-tab[data-v-07c4f24c] {\n  background: #F6F6F6;\n  border-radius: 0.010101rem;\n  width: 3.959596rem;\n  margin-top: 0.040404rem !important;\n  margin-left: -0.080808rem !important;\n  padding-left: 0.080808rem !important;\n  padding-top: 0.080808rem !important;\n  padding-bottom: 0.060606rem !important;\n}\n.page-contain .page-contain-tab .more-tab-div[data-v-07c4f24c] {\n  margin-top: 0.080808rem;\n}\n.page-contain .approval-workflow[data-v-07c4f24c] {\n  width: auto !important;\n}\n.page-contain .approval-workflow-title[data-v-07c4f24c] {\n  font-size: 0.070707rem;\n  margin-left: 0.050505rem;\n  padding-top: 0.121212rem;\n}\n.page-contain .approval-workflow-title div[data-v-07c4f24c] {\n  border-top: 0.005051rem solid #E8E8E8;\n  margin: 0.121212rem -0.282828rem 0 -0.333333rem;\n}\n.page-contain .approval-status[data-v-07c4f24c] {\n  margin-left: 0.10101rem;\n  padding: 0.025253rem;\n  border-radius: 0.010101rem;\n  height: 0.111111rem;\n  font-size: 0.060606rem;\n}\n.page-contain .approval-padding[data-v-07c4f24c] {\n  border: 0.005051rem solid #FFDA95;\n  background-color: #FFF8EA;\n  color: #FFB52A;\n}\n.page-contain .approval-comfirm[data-v-07c4f24c] {\n  border: 0.005051rem solid #8BE9BE;\n  background-color: #EDFFF6;\n  color: #0EC771;\n}\n.page-contain .approval-reject[data-v-07c4f24c] {\n  border: 0.005051rem solid #FF9CAA;\n  background-color: #FFEFF1;\n  color: #FB304D;\n}\n.page-contain .approval-cancle[data-v-07c4f24c] {\n  border: 0.005051rem solid #D6D6D6;\n  background-color: #F6F6F6;\n  color: #666666;\n}\n.page-contain .approval-submit[data-v-07c4f24c] {\n  border: 0.005051rem solid #A2CBFF;\n  background-color: #EBF4FF;\n  color: #2D82F0;\n}\n.bottom-info[data-v-07c4f24c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: fixed;\n  background-color: #fff;\n  width: 100%;\n  left: 0;\n  height: 0.222222rem;\n  -webkit-box-shadow: -0.005051rem 0 0.020202rem 0 rgba(51, 51, 51, 0.35);\n          box-shadow: -0.005051rem 0 0.020202rem 0 rgba(51, 51, 51, 0.35);\n  bottom: 0;\n}\n.bottom-info-info[data-v-07c4f24c] {\n  margin-left: 0.606061rem;\n  line-height: 0.222222rem;\n}\n.bottom-info-operate[data-v-07c4f24c] {\n  position: absolute;\n  right: 0.606061rem;\n  line-height: 0.232323rem;\n}\n.col-add-remove[data-v-07c4f24c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.operate-add-remove[data-v-07c4f24c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 0.10101rem;\n  margin: 0.191919rem 0 0 0.050505rem;\n}\n.operate-add-remove span[data-v-07c4f24c] {\n  cursor: pointer;\n}\n.operate-add-remove span + span[data-v-07c4f24c] {\n  margin-left: 0.050505rem;\n}\n.view-meeting-plan[data-v-07c4f24c] {\n  padding: 0;\n  margin-bottom: 0.429293rem;\n}\n.view-meeting-plan .edit-form-title[data-v-07c4f24c] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row[data-v-07c4f24c] {\n  padding: 0.121212rem 0 0 0;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full[data-v-07c4f24c] {\n  width: 5.494949rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-input__inner[data-v-07c4f24c] {\n  width: 5.494949rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-textarea__inner[data-v-07c4f24c] {\n  height: 0.555556rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-form-item__label[data-v-07c4f24c] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-form-item__content[data-v-07c4f24c] {\n  padding-top: 0.010101rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-form-item__content label[data-v-07c4f24c] {\n  margin-left: 0.050505rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col[data-v-07c4f24c] {\n  width: 1.616162rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-07c4f24c] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-07c4f24c] {\n  padding-top: 0.010101rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-07c4f24c],\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-07c4f24c] {\n  width: 1.616162rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__content label[data-v-07c4f24c] {\n  margin-left: 0.050505rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-07c4f24c] {\n  margin-left: 0.323232rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .col-no-3[data-v-07c4f24c] {\n  margin-left: 3.878788rem;\n}\n.view-meeting-plan .el-form.el-form--label-right .el-row[data-v-07c4f24c] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}", ""]);

// exports


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-0bd5cfca],\nbody[data-v-0bd5cfca] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-0bd5cfca]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-0bd5cfca] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-0bd5cfca] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-0bd5cfca] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-0bd5cfca],\n  .page-contain[data-v-0bd5cfca],\n  .page-submenu[data-v-0bd5cfca] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-0bd5cfca] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-0bd5cfca] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-0bd5cfca] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-0bd5cfca] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-0bd5cfca] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-0bd5cfca] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-0bd5cfca] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-0bd5cfca] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-0bd5cfca],\n  .page-submenu[data-v-0bd5cfca] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-0bd5cfca] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-0bd5cfca] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-0bd5cfca] {\n    width: 76.3vw;\n}\n.v-main[data-v-0bd5cfca] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-0bd5cfca] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-0bd5cfca] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-0bd5cfca] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-0bd5cfca] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-0bd5cfca] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-0bd5cfca] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-0bd5cfca],\n  .page-submenu[data-v-0bd5cfca] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-0bd5cfca] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-0bd5cfca] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-0bd5cfca] {\n    width: 76.3vw;\n}\n.v-main[data-v-0bd5cfca] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-0bd5cfca] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-0bd5cfca] {\n  margin-top: 0.252525rem;\n}\n[data-v-0bd5cfca]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-0bd5cfca]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-0bd5cfca] {\n  text-align: right;\n}\n.aligncenter[data-v-0bd5cfca] {\n  text-align: center;\n}\n.alignleft[data-v-0bd5cfca] {\n  text-align: left;\n}\n.actiongroupborder[data-v-0bd5cfca] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-0bd5cfca] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-0bd5cfca] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-0bd5cfca] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-0bd5cfca] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-0bd5cfca] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-0bd5cfca] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-0bd5cfca] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-0bd5cfca] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-0bd5cfca] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-0bd5cfca] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-0bd5cfca] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-0bd5cfca] {\n  text-align: center;\n}\n.alignleft[data-v-0bd5cfca] {\n  text-align: left;\n}\n.alignright[data-v-0bd5cfca] {\n  text-align: right;\n}\n.e2e-container[data-v-0bd5cfca] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-0bd5cfca] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-0bd5cfca] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-0bd5cfca] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-0bd5cfca] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-0bd5cfca] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-0bd5cfca] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-0bd5cfca] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-0bd5cfca] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-0bd5cfca] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-0bd5cfca] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-0bd5cfca],\n.e2e-red-point-left[data-v-0bd5cfca] {\n  position: relative;\n}\n.e2e-red-point[data-v-0bd5cfca]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-0bd5cfca]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-0bd5cfca] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-0bd5cfca] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-0bd5cfca] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-0bd5cfca] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-0bd5cfca] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-0bd5cfca] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-0bd5cfca] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-0bd5cfca] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-0bd5cfca] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-0bd5cfca] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-0bd5cfca] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-0bd5cfca] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-0bd5cfca] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-0bd5cfca]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-0bd5cfca] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-0bd5cfca] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-0bd5cfca],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-0bd5cfca] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-0bd5cfca],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-0bd5cfca] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-0bd5cfca],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-0bd5cfca] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-0bd5cfca],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-0bd5cfca] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-0bd5cfca],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-0bd5cfca] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-0bd5cfca],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-0bd5cfca] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-0bd5cfca] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-0bd5cfca] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-0bd5cfca] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-0bd5cfca] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-0bd5cfca] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-0bd5cfca] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-0bd5cfca] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-0bd5cfca] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-0bd5cfca]:hover,\n.el-button--primary[data-v-0bd5cfca]:active,\n.el-button--primary[data-v-0bd5cfca]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-0bd5cfca] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-0bd5cfca]:hover,\n.el-button--primary.is-plain[data-v-0bd5cfca]:active,\n.el-button--primary.is-plain[data-v-0bd5cfca]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-0bd5cfca] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-0bd5cfca]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-0bd5cfca]:active,\n.el-button--primary.is-plain.is-disabled[data-v-0bd5cfca]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-0bd5cfca] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-0bd5cfca]:hover,\n.el-button--primary.is-disabled[data-v-0bd5cfca]:active,\n.el-button--primary.is-disabled[data-v-0bd5cfca]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-0bd5cfca] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-0bd5cfca]:hover,\n.el-button--default[data-v-0bd5cfca]:active,\n.el-button--default[data-v-0bd5cfca]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-0bd5cfca] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-0bd5cfca]:hover,\n.el-button--text[data-v-0bd5cfca]:active,\n.el-button--text[data-v-0bd5cfca]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-0bd5cfca] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-0bd5cfca],\n.operate a + .el-button[data-v-0bd5cfca],\n.operate span + .el-button[data-v-0bd5cfca],\n.operate a + span[data-v-0bd5cfca] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-0bd5cfca] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-0bd5cfca] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-0bd5cfca] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-0bd5cfca] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-0bd5cfca] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-0bd5cfca] {\n  color: #fff;\n}\n.el-loading-mask[data-v-0bd5cfca] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-0bd5cfca] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-0bd5cfca]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-0bd5cfca]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-0bd5cfca]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-0bd5cfca]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-0bd5cfca] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-0bd5cfca] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-0bd5cfca] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-0bd5cfca] {\n  color: #999;\n}\n.el-select-dropdown[data-v-0bd5cfca] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-0bd5cfca] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-0bd5cfca] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-0bd5cfca] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-0bd5cfca] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-0bd5cfca] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-0bd5cfca] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-0bd5cfca]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-0bd5cfca] {\n  display: none;\n}\n.el-table th > .cell[data-v-0bd5cfca] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-0bd5cfca] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-0bd5cfca] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-0bd5cfca] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-0bd5cfca]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-0bd5cfca]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-0bd5cfca] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-0bd5cfca] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-0bd5cfca] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-0bd5cfca] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-0bd5cfca] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-0bd5cfca] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-0bd5cfca] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-0bd5cfca] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-0bd5cfca],\n.el-pagination .btn-next[data-v-0bd5cfca] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-0bd5cfca],\n.el-pagination .btn-next span[data-v-0bd5cfca] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-0bd5cfca] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-0bd5cfca] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-0bd5cfca] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-0bd5cfca] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-0bd5cfca] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-0bd5cfca] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-0bd5cfca] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-0bd5cfca] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-0bd5cfca] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-0bd5cfca] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-0bd5cfca] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-0bd5cfca] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-0bd5cfca] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-0bd5cfca] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-0bd5cfca] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-0bd5cfca] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-0bd5cfca] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-0bd5cfca] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-0bd5cfca] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-0bd5cfca] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-0bd5cfca] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-0bd5cfca] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-0bd5cfca] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-0bd5cfca] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-0bd5cfca] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-0bd5cfca] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-0bd5cfca] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-0bd5cfca] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-0bd5cfca] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-0bd5cfca]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-0bd5cfca] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-0bd5cfca] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-0bd5cfca] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-0bd5cfca] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-0bd5cfca] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-0bd5cfca] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-0bd5cfca] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-0bd5cfca] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-0bd5cfca] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-0bd5cfca] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-0bd5cfca] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-0bd5cfca],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-0bd5cfca] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-0bd5cfca] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-0bd5cfca] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-0bd5cfca] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-0bd5cfca] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-0bd5cfca] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-0bd5cfca] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-0bd5cfca] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-0bd5cfca] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-0bd5cfca] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-0bd5cfca] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-0bd5cfca] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-0bd5cfca] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-0bd5cfca] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-0bd5cfca] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-0bd5cfca] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-0bd5cfca] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-0bd5cfca] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-0bd5cfca] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-0bd5cfca] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-0bd5cfca] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-0bd5cfca] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-0bd5cfca] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-0bd5cfca] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-0bd5cfca] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-0bd5cfca] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-0bd5cfca] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-0bd5cfca] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-0bd5cfca] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-0bd5cfca]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-0bd5cfca] {\n  color: #666666;\n}\n.el-radio__inner[data-v-0bd5cfca]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-0bd5cfca] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-0bd5cfca] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-0bd5cfca] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-0bd5cfca] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-0bd5cfca] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-0bd5cfca] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-0bd5cfca] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-0bd5cfca] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-0bd5cfca],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-0bd5cfca]:hover,\n.el-input__icon.el-icon-circle-close[data-v-0bd5cfca],\n.el-input__icon.el-icon-circle-close[data-v-0bd5cfca]:hover {\n  color: #FB304D;\n}\n*[data-v-0bd5cfca],\n*[data-v-0bd5cfca]:before,\n*[data-v-0bd5cfca]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-0bd5cfca],\ntextarea[data-v-0bd5cfca] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-0bd5cfca]:focus {\n  outline: none;\n}\n.manual-container[data-v-0bd5cfca] {\n  padding: 0.181818rem 0.40404rem;\n}\n.manual-container .manual-desc[data-v-0bd5cfca] {\n  height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.manual-container .manual-desc + .manual-desc[data-v-0bd5cfca] {\n  margin-top: 0.121212rem;\n}\n.download-btn[data-v-0bd5cfca] {\n  height: 0.161616rem;\n  background: #0B41CD;\n  border: 0.005051rem solid #0B41CD;\n  border-radius: 0.020202rem;\n  padding: 0.020202rem 0.075758rem 0.020202rem 0.090909rem;\n  color: #fff;\n}", ""]);

// exports


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml,\nbody {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.v-main,\n  .page-contain,\n  .page-submenu {\n    width: 6.060606rem;\n}\n.page-submenu_left {\n    width: 1.313131rem;\n}\n.page-submenu_right {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n.has-header {\n  margin-top: 0.252525rem;\n}\n::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright {\n  text-align: right;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.common_reddot_item {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label {\n  line-height: 0.10101rem;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.alignright {\n  text-align: right;\n}\n.e2e-container {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell {\n  overflow: visible;\n}\n.e2e-red-point,\n.e2e-red-point-left {\n  position: relative;\n}\n.e2e-red-point::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small /deep/ input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small /deep/ input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray /deep/ input {\n  background: #efefef;\n}\n.e2e-radio-large /deep/ .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money {\n  color: #0B41CD;\n}\n.e2e-copy {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy:before {\n  content: '\\E787';\n}\n.e2e-warning {\n  color: #e02020;\n}\n.e2e-warning-blue {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button {\n  font-size: 0.065657rem;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.el-button {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary:hover,\n.el-button--primary:active,\n.el-button--primary:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain:hover,\n.el-button--primary.is-plain:active,\n.el-button--primary.is-plain:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled:hover,\n.el-button--primary.is-plain.is-disabled:active,\n.el-button--primary.is-plain.is-disabled:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled:hover,\n.el-button--primary.is-disabled:active,\n.el-button--primary.is-disabled:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default:hover,\n.el-button--default:active,\n.el-button--default:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text:hover,\n.el-button--text:active,\n.el-button--text:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled {\n  color: #6D7278;\n}\n.operate .el-button + .el-button,\n.operate a + .el-button,\n.operate span + .el-button,\n.operate a + span {\n  margin-left: 0.121212rem;\n}\n.operate span > div {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text {\n  color: #fff;\n}\n.el-loading-mask {\n  z-index: 9998;\n}\n.el-input__inner {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.is-disabled.el-input :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.el-select-dropdown {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label {\n  padding: 0;\n}\n.header-menu-dropdown {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow {\n  display: none;\n}\n.el-table th > .cell {\n  font-weight: bold !important;\n}\n.el-table .cell {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell {\n  padding-left: 0.070707rem;\n}\n.el-table td {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev,\n.el-pagination .btn-next {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span,\n.el-pagination .btn-next span {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog {\n  border-radius: 0.020202rem;\n}\n.el-drawer {\n  overflow: auto;\n}\n.common-confirm-dialog {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog {\n  width: 3.030303rem !important;\n}\n.approval-dialog {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select,\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer {\n  text-align: center;\n}\n.application-search-content-main-fields .active {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label {\n  color: #666666;\n}\n.el-radio__inner:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label {\n  color: #E64100;\n}\n.tox-tinymce-aux {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper {\n  width: 0.757576rem;\n}\n.custom-tooltip {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close,\n.el-select__caret.el-input__icon.el-icon-circle-close:hover,\n.el-input__icon.el-icon-circle-close,\n.el-input__icon.el-icon-circle-close:hover {\n  color: #FB304D;\n}\n*,\n*:before,\n*:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput,\ntextarea {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput:focus {\n  outline: none;\n}\n.dashboard-sample .chart-class {\n  width: 1.515152rem;\n  height: 1.515152rem;\n}", ""]);

// exports


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-1aae7a60],\nbody[data-v-1aae7a60] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-1aae7a60]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-1aae7a60] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-1aae7a60] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-1aae7a60] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-1aae7a60],\n  .page-contain[data-v-1aae7a60],\n  .page-submenu[data-v-1aae7a60] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-1aae7a60] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-1aae7a60] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-1aae7a60] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-1aae7a60] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-1aae7a60] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-1aae7a60] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-1aae7a60] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-1aae7a60] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-1aae7a60],\n  .page-submenu[data-v-1aae7a60] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-1aae7a60] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-1aae7a60] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-1aae7a60] {\n    width: 76.3vw;\n}\n.v-main[data-v-1aae7a60] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-1aae7a60] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-1aae7a60] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-1aae7a60] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-1aae7a60] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-1aae7a60] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-1aae7a60] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-1aae7a60],\n  .page-submenu[data-v-1aae7a60] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-1aae7a60] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-1aae7a60] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-1aae7a60] {\n    width: 76.3vw;\n}\n.v-main[data-v-1aae7a60] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-1aae7a60] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-1aae7a60] {\n  margin-top: 0.252525rem;\n}\n[data-v-1aae7a60]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-1aae7a60]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-1aae7a60] {\n  text-align: right;\n}\n.aligncenter[data-v-1aae7a60] {\n  text-align: center;\n}\n.alignleft[data-v-1aae7a60] {\n  text-align: left;\n}\n.actiongroupborder[data-v-1aae7a60] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-1aae7a60] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-1aae7a60] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-1aae7a60] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-1aae7a60] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-1aae7a60] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-1aae7a60] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-1aae7a60] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-1aae7a60] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-1aae7a60] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-1aae7a60] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-1aae7a60] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-1aae7a60] {\n  text-align: center;\n}\n.alignleft[data-v-1aae7a60] {\n  text-align: left;\n}\n.alignright[data-v-1aae7a60] {\n  text-align: right;\n}\n.e2e-container[data-v-1aae7a60] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-1aae7a60] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-1aae7a60] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-1aae7a60] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-1aae7a60] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-1aae7a60] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-1aae7a60] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-1aae7a60] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-1aae7a60] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-1aae7a60] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-1aae7a60] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-1aae7a60],\n.e2e-red-point-left[data-v-1aae7a60] {\n  position: relative;\n}\n.e2e-red-point[data-v-1aae7a60]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-1aae7a60]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-1aae7a60] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-1aae7a60] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-1aae7a60] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-1aae7a60] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-1aae7a60] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-1aae7a60] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-1aae7a60] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-1aae7a60] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-1aae7a60] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-1aae7a60] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-1aae7a60] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-1aae7a60] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-1aae7a60] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-1aae7a60]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-1aae7a60] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-1aae7a60] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-1aae7a60],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-1aae7a60] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-1aae7a60],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-1aae7a60] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-1aae7a60],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-1aae7a60] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-1aae7a60],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-1aae7a60] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-1aae7a60],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-1aae7a60] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-1aae7a60],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-1aae7a60] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-1aae7a60] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-1aae7a60] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-1aae7a60] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-1aae7a60] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-1aae7a60] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-1aae7a60] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-1aae7a60] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-1aae7a60] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-1aae7a60]:hover,\n.el-button--primary[data-v-1aae7a60]:active,\n.el-button--primary[data-v-1aae7a60]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-1aae7a60] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-1aae7a60]:hover,\n.el-button--primary.is-plain[data-v-1aae7a60]:active,\n.el-button--primary.is-plain[data-v-1aae7a60]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-1aae7a60] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-1aae7a60]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-1aae7a60]:active,\n.el-button--primary.is-plain.is-disabled[data-v-1aae7a60]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-1aae7a60] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-1aae7a60]:hover,\n.el-button--primary.is-disabled[data-v-1aae7a60]:active,\n.el-button--primary.is-disabled[data-v-1aae7a60]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-1aae7a60] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-1aae7a60]:hover,\n.el-button--default[data-v-1aae7a60]:active,\n.el-button--default[data-v-1aae7a60]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-1aae7a60] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-1aae7a60]:hover,\n.el-button--text[data-v-1aae7a60]:active,\n.el-button--text[data-v-1aae7a60]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-1aae7a60] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-1aae7a60],\n.operate a + .el-button[data-v-1aae7a60],\n.operate span + .el-button[data-v-1aae7a60],\n.operate a + span[data-v-1aae7a60] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-1aae7a60] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-1aae7a60] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-1aae7a60] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-1aae7a60] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-1aae7a60] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-1aae7a60] {\n  color: #fff;\n}\n.el-loading-mask[data-v-1aae7a60] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-1aae7a60] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-1aae7a60]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-1aae7a60]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-1aae7a60]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-1aae7a60]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-1aae7a60] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-1aae7a60] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-1aae7a60] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-1aae7a60] {\n  color: #999;\n}\n.el-select-dropdown[data-v-1aae7a60] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-1aae7a60] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-1aae7a60] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-1aae7a60] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-1aae7a60] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-1aae7a60] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-1aae7a60] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-1aae7a60]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-1aae7a60] {\n  display: none;\n}\n.el-table th > .cell[data-v-1aae7a60] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-1aae7a60] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-1aae7a60] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-1aae7a60] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-1aae7a60]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-1aae7a60]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-1aae7a60] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-1aae7a60] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-1aae7a60] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-1aae7a60] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-1aae7a60] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-1aae7a60] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-1aae7a60] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-1aae7a60] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-1aae7a60],\n.el-pagination .btn-next[data-v-1aae7a60] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-1aae7a60],\n.el-pagination .btn-next span[data-v-1aae7a60] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-1aae7a60] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-1aae7a60] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-1aae7a60] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-1aae7a60] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-1aae7a60] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-1aae7a60] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-1aae7a60] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-1aae7a60] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-1aae7a60] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-1aae7a60] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-1aae7a60] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-1aae7a60] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-1aae7a60] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-1aae7a60] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-1aae7a60] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-1aae7a60] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-1aae7a60] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-1aae7a60] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-1aae7a60] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-1aae7a60] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-1aae7a60] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-1aae7a60] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-1aae7a60] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-1aae7a60] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-1aae7a60] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-1aae7a60] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-1aae7a60] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-1aae7a60] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-1aae7a60] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-1aae7a60]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-1aae7a60] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-1aae7a60] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-1aae7a60] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-1aae7a60] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-1aae7a60] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-1aae7a60] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-1aae7a60] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-1aae7a60] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-1aae7a60] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-1aae7a60] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-1aae7a60] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-1aae7a60],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-1aae7a60] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-1aae7a60] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-1aae7a60] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-1aae7a60] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-1aae7a60] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-1aae7a60] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-1aae7a60] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-1aae7a60] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-1aae7a60] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-1aae7a60] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-1aae7a60] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-1aae7a60] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-1aae7a60] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-1aae7a60] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-1aae7a60] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-1aae7a60] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-1aae7a60] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-1aae7a60] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-1aae7a60] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-1aae7a60] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-1aae7a60] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-1aae7a60] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-1aae7a60] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-1aae7a60] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-1aae7a60] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-1aae7a60] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-1aae7a60] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-1aae7a60] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-1aae7a60] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-1aae7a60]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-1aae7a60] {\n  color: #666666;\n}\n.el-radio__inner[data-v-1aae7a60]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-1aae7a60] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-1aae7a60] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-1aae7a60] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-1aae7a60] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-1aae7a60] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-1aae7a60] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-1aae7a60] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-1aae7a60] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-1aae7a60],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-1aae7a60]:hover,\n.el-input__icon.el-icon-circle-close[data-v-1aae7a60],\n.el-input__icon.el-icon-circle-close[data-v-1aae7a60]:hover {\n  color: #FB304D;\n}\n*[data-v-1aae7a60],\n*[data-v-1aae7a60]:before,\n*[data-v-1aae7a60]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-1aae7a60],\ntextarea[data-v-1aae7a60] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-1aae7a60]:focus {\n  outline: none;\n}\n.page-contain-tab[data-v-1aae7a60] {\n  margin-bottom: 0.353535rem !important;\n}\n.application-search-content-main[data-v-1aae7a60] {\n  background-color: #fff;\n  padding: 0.040404rem 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  font-size: 0.080808rem;\n}\n.application-search-content-main-roles[data-v-1aae7a60] {\n  float: right;\n}\n.application-search-content-main-fields-year[data-v-1aae7a60] {\n  width: 0.40404rem;\n  margin-right: 0 !important;\n}\n.application-search-content-main-fields-quarter[data-v-1aae7a60] {\n  margin-left: 0.151515rem;\n}\n.application-search-content-main-fields-quarter label[data-v-1aae7a60] {\n  cursor: pointer;\n}\n.application-search-content-main-fields-quarter-lines[data-v-1aae7a60] {\n  margin-left: 0.409091rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.application-search-content-main-fields-quarter-lines .line-active[data-v-1aae7a60] {\n  border-bottom: 0.015152rem solid #0b41cd;\n  margin-bottom: -0.040404rem;\n}\n.application-search-content-main-fields-quarter-lines-line[data-v-1aae7a60] {\n  border-bottom: 0.015152rem solid #0b41cd;\n  width: 0.20202rem;\n  border-bottom: none;\n}\n.application-search-content-main-fields-quarter-lines-line-q1[data-v-1aae7a60] {\n  margin-left: 0.121212rem;\n}\n.application-search-content-main-fields-quarter-lines-line-q2[data-v-1aae7a60] {\n  margin-left: 0.060606rem;\n}\n.application-search-content-main-fields-quarter-lines-line-q3[data-v-1aae7a60] {\n  margin-left: 0.050505rem;\n}\n.application-search-content-main-fields-quarter-lines-line-q4[data-v-1aae7a60] {\n  margin-left: 0.060606rem;\n}\n.page-contain-main-tab[data-v-1aae7a60] {\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  background-color: transparent !important;\n}\n.page-contain-main-tab .main-blocks[data-v-1aae7a60] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row nowrap;\n          flex-flow: row nowrap;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-contain-main-tab .main-block[data-v-1aae7a60] {\n  height: 0.757576rem;\n  width: 1.449495rem;\n  display: inline-block;\n  border: none;\n  background: #fff;\n  border-radius: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain[data-v-1aae7a60] {\n  margin: 0 0.121212rem;\n}\n.page-contain-main-tab .main-block-contain-title[data-v-1aae7a60] {\n  margin-top: 0.080808rem;\n  height: 0.111111rem;\n  line-height: 0.111111rem;\n  font-size: 0.080808rem;\n  color: #666666;\n}\n.page-contain-main-tab .main-block-contain-title .iconfont[data-v-1aae7a60] {\n  float: right;\n  font-size: 0.070707rem;\n}\n.page-contain-main-tab .main-block-contain-budget[data-v-1aae7a60] {\n  margin-top: 0.090909rem;\n  height: 0.151515rem;\n  line-height: 0.151515rem;\n  font-size: 0.111111rem;\n  width: 100%;\n}\n.page-contain-main-tab .main-block-contain-budget-amount[data-v-1aae7a60] {\n  color: rgba(0, 0, 0, 0.85);\n}\n.page-contain-main-tab .main-block-contain-budget-percent[data-v-1aae7a60] {\n  float: right;\n}\n.page-contain-main-tab .main-block-contain-budget-percent-alert[data-v-1aae7a60] {\n  color: #FB304D !important;\n}\n.page-contain-main-tab .main-block-contain-budget-percent-title[data-v-1aae7a60] {\n  float: right;\n  font-size: 0.070707rem;\n  color: rgba(0, 0, 0, 0.65);\n  margin-right: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain-budget .iconfont[data-v-1aae7a60] {\n  font-size: 0.141414rem;\n}\n.page-contain-main-tab .main-block-contain-budget .icon-yitijiao[data-v-1aae7a60] {\n  color: #2D82F0;\n}\n.page-contain-main-tab .main-block-contain-budget .icon-shenpizhong[data-v-1aae7a60] {\n  color: #FFB52A;\n}\n.page-contain-main-tab .main-block-contain-budget .icon-shenpitongguo[data-v-1aae7a60] {\n  color: #0EC771;\n}\n.page-contain-main-tab .main-block-contain-budget .icon-shenpijujue[data-v-1aae7a60] {\n  color: #FB304D;\n}\n.page-contain-main-tab .main-block-contain-split-line[data-v-1aae7a60] {\n  width: 1.212121rem;\n  margin: 0.065657rem 0 0 0;\n  height: 0.040404rem;\n  background-color: #F0F2F5;\n  border-radius: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain-split-line .progress[data-v-1aae7a60] {\n  height: 0.040404rem;\n  background-color: #2D82F0;\n  border-radius: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain-split-line .pass[data-v-1aae7a60] {\n  height: 0.040404rem;\n  background-color: #0EC771;\n  border-radius: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain-split-line .pending[data-v-1aae7a60] {\n  height: 0.040404rem;\n  background-color: #FFB52A;\n  border-radius: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain-split-line .reject[data-v-1aae7a60] {\n  height: 0.040404rem;\n  background-color: #FB304D;\n  border-radius: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain-info[data-v-1aae7a60] {\n  margin-top: 0.045455rem;\n}\n.page-contain-main-tab .main-block-contain-season-amount[data-v-1aae7a60] {\n  font-size: 0.070707rem;\n  color: rgba(0, 0, 0, 0.65);\n}\n.page-contain-main-tab .main-block-contain-total[data-v-1aae7a60] {\n  float: right;\n  font-size: 0.070707rem;\n  color: rgba(0, 0, 0, 0.65);\n}\n.page-contain-main-tab .main-block-contain-total label[data-v-1aae7a60] {\n  margin-left: 0.040404rem;\n  color: rgba(0, 0, 0, 0.85);\n}\n.search-content[data-v-1aae7a60] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 0.111111rem;\n}\n.search-content .search-content-fields[data-v-1aae7a60] {\n  display: contents;\n}\n.search-content .search-content-fields-operate[data-v-1aae7a60] {\n  margin-left: auto !important;\n}\n.search-content .el-form-item + .el-form-item[data-v-1aae7a60] {\n  margin-left: 0.116162rem;\n}\n.operate[data-v-1aae7a60] {\n  float: right;\n  margin-bottom: 0.040404rem;\n}\n.operate-export[data-v-1aae7a60] {\n  font-size: 0.070707rem;\n}\n.operate-export a[data-v-1aae7a60] {\n  color: #0B41CD;\n}\n.operate-export i[data-v-1aae7a60] {\n  font-size: 0.070707rem;\n}\n.l-user-item[data-v-1aae7a60] {\n  width: 100%;\n  height: 0.287879rem;\n  padding: 0.090909rem 0.111111rem;\n  border-bottom: 0.005051rem solid #dfdfdf;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.l-user-item-icon[data-v-1aae7a60] {\n  font-size: 0.080808rem;\n  padding: 0.010101rem;\n}\n.budget-detail-info[data-v-1aae7a60] {\n  float: left;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  font-size: 0.070707rem;\n  color: #333333;\n}\n.main-budget-info-block[data-v-1aae7a60] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-bottom: 0.080808rem;\n}\n.main-budget-info-block-name[data-v-1aae7a60] {\n  width: 50%;\n}\n.main-budget-info-block-name label[data-v-1aae7a60] {\n  float: right;\n  font-size: 0.070707rem;\n  color: #666666;\n}\n.main-budget-info-block-value[data-v-1aae7a60] {\n  font-size: 0.070707rem;\n  color: #333333;\n}\n.bottom-info[data-v-1aae7a60] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: fixed;\n  background-color: #fff;\n  width: 100%;\n  left: 0;\n  height: 0.222222rem;\n  -webkit-box-shadow: -0.005051rem 0 0.020202rem 0 rgba(51, 51, 51, 0.35);\n          box-shadow: -0.005051rem 0 0.020202rem 0 rgba(51, 51, 51, 0.35);\n  bottom: 0;\n  z-index: 5;\n}\n.bottom-info-info[data-v-1aae7a60] {\n  margin-left: 0.606061rem;\n  line-height: 0.222222rem;\n}\n.bottom-info-operate[data-v-1aae7a60] {\n  position: absolute;\n  right: 0.606061rem;\n  line-height: 0.232323rem;\n}\n.advanced-search-dialog[data-v-1aae7a60] {\n  padding: 0;\n}\n.advanced-search-dialog .advanced-search-dialog-close[data-v-1aae7a60] {\n  font-size: 0.070707rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right[data-v-1aae7a60] {\n  margin-bottom: 0.025253rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row[data-v-1aae7a60] {\n  padding: 0.141414rem 0 0 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .advanced-search-form-title[data-v-1aae7a60] {\n  height: 0.20202rem;\n  line-height: 0.20202rem;\n  width: 0.454545rem;\n  font-weight: bold;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .advanced-search-form-title .iconfont[data-v-1aae7a60] {\n  font-size: 0.070707rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col[data-v-1aae7a60] {\n  width: 1.212121rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col .el-form-item__label[data-v-1aae7a60] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col .el-form-item__content[data-v-1aae7a60] {\n  padding-top: 0.010101rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col .el-form-item__content .el-select[data-v-1aae7a60],\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col .el-form-item__content .el-input[data-v-1aae7a60] {\n  width: 1.212121rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col .el-form-item__content label[data-v-1aae7a60] {\n  margin-left: 0.050505rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col + .el-col[data-v-1aae7a60] {\n  margin-left: 0.621212rem;\n}\n.advanced-search-dialog-close[data-v-1aae7a60] {\n  margin-left: 0.126263rem;\n  cursor: pointer;\n}\n.advanced-search-dialog-score-model[data-v-1aae7a60] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 1.212121rem;\n}\n.advanced-search-dialog-score-model .el-input-number[data-v-1aae7a60] {\n  width: 0.484848rem !important;\n}\n.advanced-search-dialog-score-model span[data-v-1aae7a60] {\n  margin: auto 0.10101rem;\n  width: 0.050505rem;\n  border-bottom: 0.010101rem solid #666666;\n}\n.advanced-search-dialog .l-user-item[data-v-1aae7a60] {\n  width: 100%;\n  height: 0.20202rem;\n  padding: 0 0.111111rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.advanced-search-dialog .l-user-item-icon[data-v-1aae7a60] {\n  font-size: 0.080808rem;\n  padding: 0.010101rem;\n  width: 0.10101rem;\n}\n.advanced-search-dialog .l-user-item-text[data-v-1aae7a60] {\n  margin-left: 0.025253rem;\n  font-size: 0.070707rem;\n  line-height: 0.10101rem;\n  display: inline-block;\n}\n.advanced-search-dialog .l-user-item[data-v-1aae7a60]:hover {\n  color: #0B41CD;\n  cursor: pointer;\n}\n.advanced-search-dialog .l-user-item[data-v-1aae7a60]:last-child {\n  border-bottom: none;\n}\n.toolbar[data-v-1aae7a60] {\n  height: 0.191919rem;\n}\n.toolbar .application-detail-info[data-v-1aae7a60] {\n  float: left;\n  height: 0.111111rem;\n  line-height: 0.111111rem;\n  font-size: 0.070707rem;\n  color: #333333;\n}\n.toolbar .operate[data-v-1aae7a60] {\n  float: right;\n  height: 0.111111rem;\n  line-height: 0.111111rem;\n}\n.toolbar .operate-export[data-v-1aae7a60] {\n  font-size: 0.070707rem;\n}\n.toolbar .operate-export i[data-v-1aae7a60] {\n  font-size: 0.070707rem;\n}", ""]);

// exports


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-21495f3c],\nbody[data-v-21495f3c] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-21495f3c]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-21495f3c] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-21495f3c] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-21495f3c] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-21495f3c],\n  .page-contain[data-v-21495f3c],\n  .page-submenu[data-v-21495f3c] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-21495f3c] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-21495f3c] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-21495f3c] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-21495f3c] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-21495f3c] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-21495f3c] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-21495f3c] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-21495f3c] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-21495f3c],\n  .page-submenu[data-v-21495f3c] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-21495f3c] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-21495f3c] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-21495f3c] {\n    width: 76.3vw;\n}\n.v-main[data-v-21495f3c] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-21495f3c] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-21495f3c] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-21495f3c] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-21495f3c] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-21495f3c] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-21495f3c] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-21495f3c],\n  .page-submenu[data-v-21495f3c] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-21495f3c] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-21495f3c] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-21495f3c] {\n    width: 76.3vw;\n}\n.v-main[data-v-21495f3c] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-21495f3c] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-21495f3c] {\n  margin-top: 0.252525rem;\n}\n[data-v-21495f3c]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-21495f3c]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-21495f3c] {\n  text-align: right;\n}\n.aligncenter[data-v-21495f3c] {\n  text-align: center;\n}\n.alignleft[data-v-21495f3c] {\n  text-align: left;\n}\n.actiongroupborder[data-v-21495f3c] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-21495f3c] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-21495f3c] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-21495f3c] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-21495f3c] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-21495f3c] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-21495f3c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-21495f3c] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-21495f3c] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-21495f3c] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-21495f3c] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-21495f3c] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-21495f3c] {\n  text-align: center;\n}\n.alignleft[data-v-21495f3c] {\n  text-align: left;\n}\n.alignright[data-v-21495f3c] {\n  text-align: right;\n}\n.e2e-container[data-v-21495f3c] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-21495f3c] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-21495f3c] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-21495f3c] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-21495f3c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-21495f3c] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-21495f3c] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-21495f3c] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-21495f3c] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-21495f3c] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-21495f3c] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-21495f3c],\n.e2e-red-point-left[data-v-21495f3c] {\n  position: relative;\n}\n.e2e-red-point[data-v-21495f3c]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-21495f3c]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-21495f3c] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-21495f3c] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-21495f3c] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-21495f3c] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-21495f3c] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-21495f3c] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-21495f3c] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-21495f3c] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-21495f3c] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-21495f3c] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-21495f3c] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-21495f3c] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-21495f3c] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-21495f3c]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-21495f3c] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-21495f3c] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-21495f3c],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-21495f3c] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-21495f3c],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-21495f3c] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-21495f3c],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-21495f3c] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-21495f3c],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-21495f3c] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-21495f3c],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-21495f3c] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-21495f3c],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-21495f3c] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-21495f3c] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-21495f3c] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-21495f3c] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-21495f3c] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-21495f3c] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-21495f3c] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-21495f3c] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-21495f3c] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-21495f3c]:hover,\n.el-button--primary[data-v-21495f3c]:active,\n.el-button--primary[data-v-21495f3c]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-21495f3c] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-21495f3c]:hover,\n.el-button--primary.is-plain[data-v-21495f3c]:active,\n.el-button--primary.is-plain[data-v-21495f3c]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-21495f3c] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-21495f3c]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-21495f3c]:active,\n.el-button--primary.is-plain.is-disabled[data-v-21495f3c]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-21495f3c] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-21495f3c]:hover,\n.el-button--primary.is-disabled[data-v-21495f3c]:active,\n.el-button--primary.is-disabled[data-v-21495f3c]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-21495f3c] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-21495f3c]:hover,\n.el-button--default[data-v-21495f3c]:active,\n.el-button--default[data-v-21495f3c]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-21495f3c] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-21495f3c]:hover,\n.el-button--text[data-v-21495f3c]:active,\n.el-button--text[data-v-21495f3c]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-21495f3c] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-21495f3c],\n.operate a + .el-button[data-v-21495f3c],\n.operate span + .el-button[data-v-21495f3c],\n.operate a + span[data-v-21495f3c] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-21495f3c] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-21495f3c] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-21495f3c] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-21495f3c] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-21495f3c] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-21495f3c] {\n  color: #fff;\n}\n.el-loading-mask[data-v-21495f3c] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-21495f3c] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-21495f3c]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-21495f3c]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-21495f3c]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-21495f3c]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-21495f3c] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-21495f3c] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-21495f3c] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-21495f3c] {\n  color: #999;\n}\n.el-select-dropdown[data-v-21495f3c] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-21495f3c] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-21495f3c] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-21495f3c] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-21495f3c] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-21495f3c] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-21495f3c] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-21495f3c]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-21495f3c] {\n  display: none;\n}\n.el-table th > .cell[data-v-21495f3c] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-21495f3c] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-21495f3c] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-21495f3c] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-21495f3c]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-21495f3c]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-21495f3c] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-21495f3c] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-21495f3c] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-21495f3c] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-21495f3c] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-21495f3c] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-21495f3c] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-21495f3c] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-21495f3c],\n.el-pagination .btn-next[data-v-21495f3c] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-21495f3c],\n.el-pagination .btn-next span[data-v-21495f3c] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-21495f3c] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-21495f3c] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-21495f3c] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-21495f3c] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-21495f3c] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-21495f3c] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-21495f3c] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-21495f3c] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-21495f3c] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-21495f3c] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-21495f3c] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-21495f3c] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-21495f3c] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-21495f3c] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-21495f3c] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-21495f3c] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-21495f3c] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-21495f3c] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-21495f3c] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-21495f3c] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-21495f3c] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-21495f3c] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-21495f3c] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-21495f3c] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-21495f3c] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-21495f3c] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-21495f3c] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-21495f3c] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-21495f3c] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-21495f3c]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-21495f3c] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-21495f3c] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-21495f3c] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-21495f3c] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-21495f3c] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-21495f3c] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-21495f3c] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-21495f3c] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-21495f3c] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-21495f3c] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-21495f3c] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-21495f3c],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-21495f3c] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-21495f3c] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-21495f3c] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-21495f3c] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-21495f3c] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-21495f3c] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-21495f3c] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-21495f3c] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-21495f3c] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-21495f3c] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-21495f3c] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-21495f3c] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-21495f3c] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-21495f3c] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-21495f3c] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-21495f3c] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-21495f3c] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-21495f3c] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-21495f3c] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-21495f3c] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-21495f3c] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-21495f3c] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-21495f3c] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-21495f3c] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-21495f3c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-21495f3c] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-21495f3c] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-21495f3c] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-21495f3c] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-21495f3c]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-21495f3c] {\n  color: #666666;\n}\n.el-radio__inner[data-v-21495f3c]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-21495f3c] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-21495f3c] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-21495f3c] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-21495f3c] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-21495f3c] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-21495f3c] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-21495f3c] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-21495f3c] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-21495f3c],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-21495f3c]:hover,\n.el-input__icon.el-icon-circle-close[data-v-21495f3c],\n.el-input__icon.el-icon-circle-close[data-v-21495f3c]:hover {\n  color: #FB304D;\n}\n*[data-v-21495f3c],\n*[data-v-21495f3c]:before,\n*[data-v-21495f3c]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-21495f3c],\ntextarea[data-v-21495f3c] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-21495f3c]:focus {\n  outline: none;\n}\n.el-form[data-v-21495f3c] .el-form-item__content {\n  margin-bottom: 0.10101rem;\n}\n.user-container[data-v-21495f3c] {\n  padding: 0.242424rem 0.40404rem 0.282828rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.user-container .form-item[data-v-21495f3c] {\n  padding: 0.050505rem 0 0.020202rem 0;\n}\n.user-container .form-item .radio-after-text[data-v-21495f3c] {\n  font-size: 0.070707rem;\n}", ""]);

// exports


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-22555b23],\nbody[data-v-22555b23] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-22555b23]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-22555b23] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-22555b23] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-22555b23] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-22555b23],\n  .page-contain[data-v-22555b23],\n  .page-submenu[data-v-22555b23] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-22555b23] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-22555b23] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-22555b23] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-22555b23] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-22555b23] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-22555b23] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-22555b23] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-22555b23] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-22555b23],\n  .page-submenu[data-v-22555b23] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-22555b23] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-22555b23] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-22555b23] {\n    width: 76.3vw;\n}\n.v-main[data-v-22555b23] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-22555b23] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-22555b23] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-22555b23] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-22555b23] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-22555b23] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-22555b23] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-22555b23],\n  .page-submenu[data-v-22555b23] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-22555b23] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-22555b23] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-22555b23] {\n    width: 76.3vw;\n}\n.v-main[data-v-22555b23] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-22555b23] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-22555b23] {\n  margin-top: 0.252525rem;\n}\n[data-v-22555b23]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-22555b23]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-22555b23] {\n  text-align: right;\n}\n.aligncenter[data-v-22555b23] {\n  text-align: center;\n}\n.alignleft[data-v-22555b23] {\n  text-align: left;\n}\n.actiongroupborder[data-v-22555b23] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-22555b23] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-22555b23] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-22555b23] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-22555b23] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-22555b23] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-22555b23] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-22555b23] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-22555b23] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-22555b23] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-22555b23] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-22555b23] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-22555b23] {\n  text-align: center;\n}\n.alignleft[data-v-22555b23] {\n  text-align: left;\n}\n.alignright[data-v-22555b23] {\n  text-align: right;\n}\n.e2e-container[data-v-22555b23] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-22555b23] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-22555b23] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-22555b23] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-22555b23] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-22555b23] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-22555b23] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-22555b23] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-22555b23] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-22555b23] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-22555b23] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-22555b23],\n.e2e-red-point-left[data-v-22555b23] {\n  position: relative;\n}\n.e2e-red-point[data-v-22555b23]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-22555b23]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-22555b23] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-22555b23] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-22555b23] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-22555b23] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-22555b23] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-22555b23] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-22555b23] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-22555b23] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-22555b23] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-22555b23] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-22555b23] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-22555b23] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-22555b23] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-22555b23]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-22555b23] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-22555b23] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-22555b23],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-22555b23] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-22555b23],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-22555b23] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-22555b23],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-22555b23] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-22555b23],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-22555b23] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-22555b23],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-22555b23] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-22555b23],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-22555b23] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-22555b23] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-22555b23] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-22555b23] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-22555b23] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-22555b23] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-22555b23] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-22555b23] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-22555b23] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-22555b23]:hover,\n.el-button--primary[data-v-22555b23]:active,\n.el-button--primary[data-v-22555b23]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-22555b23] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-22555b23]:hover,\n.el-button--primary.is-plain[data-v-22555b23]:active,\n.el-button--primary.is-plain[data-v-22555b23]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-22555b23] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-22555b23]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-22555b23]:active,\n.el-button--primary.is-plain.is-disabled[data-v-22555b23]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-22555b23] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-22555b23]:hover,\n.el-button--primary.is-disabled[data-v-22555b23]:active,\n.el-button--primary.is-disabled[data-v-22555b23]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-22555b23] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-22555b23]:hover,\n.el-button--default[data-v-22555b23]:active,\n.el-button--default[data-v-22555b23]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-22555b23] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-22555b23]:hover,\n.el-button--text[data-v-22555b23]:active,\n.el-button--text[data-v-22555b23]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-22555b23] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-22555b23],\n.operate a + .el-button[data-v-22555b23],\n.operate span + .el-button[data-v-22555b23],\n.operate a + span[data-v-22555b23] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-22555b23] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-22555b23] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-22555b23] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-22555b23] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-22555b23] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-22555b23] {\n  color: #fff;\n}\n.el-loading-mask[data-v-22555b23] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-22555b23] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-22555b23]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-22555b23]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-22555b23]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-22555b23]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-22555b23] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-22555b23] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-22555b23] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-22555b23] {\n  color: #999;\n}\n.el-select-dropdown[data-v-22555b23] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-22555b23] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-22555b23] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-22555b23] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-22555b23] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-22555b23] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-22555b23] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-22555b23]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-22555b23] {\n  display: none;\n}\n.el-table th > .cell[data-v-22555b23] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-22555b23] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-22555b23] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-22555b23] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-22555b23]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-22555b23]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-22555b23] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-22555b23] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-22555b23] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-22555b23] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-22555b23] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-22555b23] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-22555b23] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-22555b23] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-22555b23],\n.el-pagination .btn-next[data-v-22555b23] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-22555b23],\n.el-pagination .btn-next span[data-v-22555b23] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-22555b23] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-22555b23] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-22555b23] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-22555b23] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-22555b23] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-22555b23] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-22555b23] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-22555b23] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-22555b23] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-22555b23] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-22555b23] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-22555b23] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-22555b23] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-22555b23] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-22555b23] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-22555b23] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-22555b23] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-22555b23] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-22555b23] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-22555b23] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-22555b23] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-22555b23] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-22555b23] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-22555b23] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-22555b23] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-22555b23] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-22555b23] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-22555b23] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-22555b23] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-22555b23]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-22555b23] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-22555b23] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-22555b23] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-22555b23] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-22555b23] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-22555b23] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-22555b23] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-22555b23] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-22555b23] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-22555b23] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-22555b23] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-22555b23],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-22555b23] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-22555b23] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-22555b23] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-22555b23] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-22555b23] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-22555b23] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-22555b23] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-22555b23] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-22555b23] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-22555b23] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-22555b23] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-22555b23] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-22555b23] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-22555b23] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-22555b23] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-22555b23] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-22555b23] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-22555b23] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-22555b23] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-22555b23] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-22555b23] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-22555b23] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-22555b23] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-22555b23] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-22555b23] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-22555b23] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-22555b23] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-22555b23] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-22555b23] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-22555b23]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-22555b23] {\n  color: #666666;\n}\n.el-radio__inner[data-v-22555b23]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-22555b23] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-22555b23] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-22555b23] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-22555b23] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-22555b23] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-22555b23] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-22555b23] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-22555b23] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-22555b23],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-22555b23]:hover,\n.el-input__icon.el-icon-circle-close[data-v-22555b23],\n.el-input__icon.el-icon-circle-close[data-v-22555b23]:hover {\n  color: #FB304D;\n}\n*[data-v-22555b23],\n*[data-v-22555b23]:before,\n*[data-v-22555b23]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-22555b23],\ntextarea[data-v-22555b23] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-22555b23]:focus {\n  outline: none;\n}\n.search-content[data-v-22555b23] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 0.111111rem;\n}\n.search-content .search-content-fields[data-v-22555b23] {\n  width: 4.040404rem;\n}\n.operate[data-v-22555b23] {\n  float: right;\n  margin-bottom: 0.151515rem;\n}", ""]);

// exports


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-25be9594],\nbody[data-v-25be9594] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-25be9594]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-25be9594] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-25be9594] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-25be9594] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-25be9594],\n  .page-contain[data-v-25be9594],\n  .page-submenu[data-v-25be9594] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-25be9594] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-25be9594] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-25be9594] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-25be9594] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-25be9594] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-25be9594] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-25be9594] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-25be9594] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-25be9594],\n  .page-submenu[data-v-25be9594] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-25be9594] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-25be9594] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-25be9594] {\n    width: 76.3vw;\n}\n.v-main[data-v-25be9594] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-25be9594] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-25be9594] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-25be9594] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-25be9594] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-25be9594] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-25be9594] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-25be9594],\n  .page-submenu[data-v-25be9594] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-25be9594] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-25be9594] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-25be9594] {\n    width: 76.3vw;\n}\n.v-main[data-v-25be9594] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-25be9594] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-25be9594] {\n  margin-top: 0.252525rem;\n}\n[data-v-25be9594]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-25be9594]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-25be9594] {\n  text-align: right;\n}\n.aligncenter[data-v-25be9594] {\n  text-align: center;\n}\n.alignleft[data-v-25be9594] {\n  text-align: left;\n}\n.actiongroupborder[data-v-25be9594] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-25be9594] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-25be9594] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-25be9594] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-25be9594] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-25be9594] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-25be9594] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-25be9594] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-25be9594] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-25be9594] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-25be9594] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-25be9594] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-25be9594] {\n  text-align: center;\n}\n.alignleft[data-v-25be9594] {\n  text-align: left;\n}\n.alignright[data-v-25be9594] {\n  text-align: right;\n}\n.e2e-container[data-v-25be9594] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-25be9594] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-25be9594] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-25be9594] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-25be9594] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-25be9594] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-25be9594] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-25be9594] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-25be9594] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-25be9594] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-25be9594] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-25be9594],\n.e2e-red-point-left[data-v-25be9594] {\n  position: relative;\n}\n.e2e-red-point[data-v-25be9594]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-25be9594]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-25be9594] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-25be9594] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-25be9594] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-25be9594] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-25be9594] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-25be9594] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-25be9594] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-25be9594] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-25be9594] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-25be9594] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-25be9594] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-25be9594] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-25be9594] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-25be9594]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-25be9594] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-25be9594] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-25be9594],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-25be9594] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-25be9594],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-25be9594] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-25be9594],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-25be9594] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-25be9594],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-25be9594] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-25be9594],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-25be9594] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-25be9594],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-25be9594] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-25be9594] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-25be9594] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-25be9594] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-25be9594] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-25be9594] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-25be9594] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-25be9594] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-25be9594] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-25be9594]:hover,\n.el-button--primary[data-v-25be9594]:active,\n.el-button--primary[data-v-25be9594]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-25be9594] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-25be9594]:hover,\n.el-button--primary.is-plain[data-v-25be9594]:active,\n.el-button--primary.is-plain[data-v-25be9594]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-25be9594] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-25be9594]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-25be9594]:active,\n.el-button--primary.is-plain.is-disabled[data-v-25be9594]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-25be9594] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-25be9594]:hover,\n.el-button--primary.is-disabled[data-v-25be9594]:active,\n.el-button--primary.is-disabled[data-v-25be9594]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-25be9594] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-25be9594]:hover,\n.el-button--default[data-v-25be9594]:active,\n.el-button--default[data-v-25be9594]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-25be9594] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-25be9594]:hover,\n.el-button--text[data-v-25be9594]:active,\n.el-button--text[data-v-25be9594]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-25be9594] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-25be9594],\n.operate a + .el-button[data-v-25be9594],\n.operate span + .el-button[data-v-25be9594],\n.operate a + span[data-v-25be9594] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-25be9594] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-25be9594] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-25be9594] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-25be9594] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-25be9594] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-25be9594] {\n  color: #fff;\n}\n.el-loading-mask[data-v-25be9594] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-25be9594] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-25be9594]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-25be9594]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-25be9594]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-25be9594]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-25be9594] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-25be9594] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-25be9594] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-25be9594] {\n  color: #999;\n}\n.el-select-dropdown[data-v-25be9594] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-25be9594] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-25be9594] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-25be9594] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-25be9594] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-25be9594] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-25be9594] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-25be9594]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-25be9594] {\n  display: none;\n}\n.el-table th > .cell[data-v-25be9594] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-25be9594] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-25be9594] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-25be9594] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-25be9594]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-25be9594]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-25be9594] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-25be9594] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-25be9594] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-25be9594] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-25be9594] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-25be9594] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-25be9594] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-25be9594] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-25be9594],\n.el-pagination .btn-next[data-v-25be9594] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-25be9594],\n.el-pagination .btn-next span[data-v-25be9594] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-25be9594] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-25be9594] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-25be9594] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-25be9594] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-25be9594] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-25be9594] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-25be9594] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-25be9594] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-25be9594] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-25be9594] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-25be9594] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-25be9594] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-25be9594] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-25be9594] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-25be9594] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-25be9594] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-25be9594] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-25be9594] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-25be9594] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-25be9594] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-25be9594] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-25be9594] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-25be9594] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-25be9594] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-25be9594] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-25be9594] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-25be9594] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-25be9594] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-25be9594] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-25be9594]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-25be9594] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-25be9594] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-25be9594] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-25be9594] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-25be9594] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-25be9594] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-25be9594] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-25be9594] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-25be9594] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-25be9594] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-25be9594] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-25be9594],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-25be9594] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-25be9594] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-25be9594] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-25be9594] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-25be9594] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-25be9594] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-25be9594] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-25be9594] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-25be9594] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-25be9594] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-25be9594] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-25be9594] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-25be9594] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-25be9594] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-25be9594] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-25be9594] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-25be9594] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-25be9594] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-25be9594] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-25be9594] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-25be9594] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-25be9594] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-25be9594] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-25be9594] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-25be9594] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-25be9594] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-25be9594] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-25be9594] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-25be9594] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-25be9594]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-25be9594] {\n  color: #666666;\n}\n.el-radio__inner[data-v-25be9594]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-25be9594] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-25be9594] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-25be9594] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-25be9594] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-25be9594] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-25be9594] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-25be9594] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-25be9594] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-25be9594],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-25be9594]:hover,\n.el-input__icon.el-icon-circle-close[data-v-25be9594],\n.el-input__icon.el-icon-circle-close[data-v-25be9594]:hover {\n  color: #FB304D;\n}\n*[data-v-25be9594],\n*[data-v-25be9594]:before,\n*[data-v-25be9594]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-25be9594],\ntextarea[data-v-25be9594] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-25be9594]:focus {\n  outline: none;\n}\n.tableau[data-v-25be9594] {\n  overflow-x: hidden;\n}", ""]);

// exports


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-30cf0563],\nbody[data-v-30cf0563] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-30cf0563]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-30cf0563] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-30cf0563] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-30cf0563] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-30cf0563],\n  .page-contain[data-v-30cf0563],\n  .page-submenu[data-v-30cf0563] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-30cf0563] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-30cf0563] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-30cf0563] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-30cf0563] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-30cf0563] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-30cf0563] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-30cf0563] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-30cf0563] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-30cf0563],\n  .page-submenu[data-v-30cf0563] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-30cf0563] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-30cf0563] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-30cf0563] {\n    width: 76.3vw;\n}\n.v-main[data-v-30cf0563] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-30cf0563] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-30cf0563] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-30cf0563] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-30cf0563] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-30cf0563] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-30cf0563] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-30cf0563],\n  .page-submenu[data-v-30cf0563] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-30cf0563] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-30cf0563] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-30cf0563] {\n    width: 76.3vw;\n}\n.v-main[data-v-30cf0563] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-30cf0563] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-30cf0563] {\n  margin-top: 0.252525rem;\n}\n[data-v-30cf0563]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-30cf0563]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-30cf0563] {\n  text-align: right;\n}\n.aligncenter[data-v-30cf0563] {\n  text-align: center;\n}\n.alignleft[data-v-30cf0563] {\n  text-align: left;\n}\n.actiongroupborder[data-v-30cf0563] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-30cf0563] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-30cf0563] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-30cf0563] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-30cf0563] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-30cf0563] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-30cf0563] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-30cf0563] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-30cf0563] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-30cf0563] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-30cf0563] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-30cf0563] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-30cf0563] {\n  text-align: center;\n}\n.alignleft[data-v-30cf0563] {\n  text-align: left;\n}\n.alignright[data-v-30cf0563] {\n  text-align: right;\n}\n.e2e-container[data-v-30cf0563] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-30cf0563] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-30cf0563] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-30cf0563] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-30cf0563] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-30cf0563] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-30cf0563] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-30cf0563] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-30cf0563] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-30cf0563] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-30cf0563] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-30cf0563],\n.e2e-red-point-left[data-v-30cf0563] {\n  position: relative;\n}\n.e2e-red-point[data-v-30cf0563]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-30cf0563]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-30cf0563] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-30cf0563] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-30cf0563] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-30cf0563] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-30cf0563] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-30cf0563] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-30cf0563] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-30cf0563] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-30cf0563] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-30cf0563] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-30cf0563] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-30cf0563] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-30cf0563] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-30cf0563]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-30cf0563] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-30cf0563] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-30cf0563],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-30cf0563] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-30cf0563],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-30cf0563] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-30cf0563],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-30cf0563] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-30cf0563],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-30cf0563] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-30cf0563],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-30cf0563] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-30cf0563],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-30cf0563] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-30cf0563] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-30cf0563] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-30cf0563] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-30cf0563] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-30cf0563] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-30cf0563] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-30cf0563] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-30cf0563] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-30cf0563]:hover,\n.el-button--primary[data-v-30cf0563]:active,\n.el-button--primary[data-v-30cf0563]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-30cf0563] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-30cf0563]:hover,\n.el-button--primary.is-plain[data-v-30cf0563]:active,\n.el-button--primary.is-plain[data-v-30cf0563]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-30cf0563] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-30cf0563]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-30cf0563]:active,\n.el-button--primary.is-plain.is-disabled[data-v-30cf0563]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-30cf0563] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-30cf0563]:hover,\n.el-button--primary.is-disabled[data-v-30cf0563]:active,\n.el-button--primary.is-disabled[data-v-30cf0563]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-30cf0563] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-30cf0563]:hover,\n.el-button--default[data-v-30cf0563]:active,\n.el-button--default[data-v-30cf0563]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-30cf0563] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-30cf0563]:hover,\n.el-button--text[data-v-30cf0563]:active,\n.el-button--text[data-v-30cf0563]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-30cf0563] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-30cf0563],\n.operate a + .el-button[data-v-30cf0563],\n.operate span + .el-button[data-v-30cf0563],\n.operate a + span[data-v-30cf0563] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-30cf0563] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-30cf0563] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-30cf0563] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-30cf0563] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-30cf0563] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-30cf0563] {\n  color: #fff;\n}\n.el-loading-mask[data-v-30cf0563] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-30cf0563] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-30cf0563]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-30cf0563]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-30cf0563]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-30cf0563]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-30cf0563] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-30cf0563] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-30cf0563] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-30cf0563] {\n  color: #999;\n}\n.el-select-dropdown[data-v-30cf0563] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-30cf0563] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-30cf0563] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-30cf0563] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-30cf0563] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-30cf0563] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-30cf0563] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-30cf0563]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-30cf0563] {\n  display: none;\n}\n.el-table th > .cell[data-v-30cf0563] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-30cf0563] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-30cf0563] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-30cf0563] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-30cf0563]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-30cf0563]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-30cf0563] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-30cf0563] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-30cf0563] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-30cf0563] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-30cf0563] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-30cf0563] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-30cf0563] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-30cf0563] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-30cf0563],\n.el-pagination .btn-next[data-v-30cf0563] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-30cf0563],\n.el-pagination .btn-next span[data-v-30cf0563] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-30cf0563] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-30cf0563] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-30cf0563] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-30cf0563] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-30cf0563] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-30cf0563] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-30cf0563] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-30cf0563] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-30cf0563] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-30cf0563] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-30cf0563] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-30cf0563] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-30cf0563] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-30cf0563] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-30cf0563] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-30cf0563] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-30cf0563] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-30cf0563] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-30cf0563] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-30cf0563] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-30cf0563] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-30cf0563] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-30cf0563] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-30cf0563] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-30cf0563] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-30cf0563] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-30cf0563] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-30cf0563] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-30cf0563] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-30cf0563]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-30cf0563] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-30cf0563] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-30cf0563] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-30cf0563] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-30cf0563] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-30cf0563] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-30cf0563] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-30cf0563] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-30cf0563] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-30cf0563] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-30cf0563] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-30cf0563],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-30cf0563] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-30cf0563] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-30cf0563] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-30cf0563] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-30cf0563] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-30cf0563] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-30cf0563] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-30cf0563] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-30cf0563] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-30cf0563] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-30cf0563] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-30cf0563] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-30cf0563] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-30cf0563] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-30cf0563] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-30cf0563] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-30cf0563] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-30cf0563] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-30cf0563] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-30cf0563] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-30cf0563] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-30cf0563] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-30cf0563] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-30cf0563] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-30cf0563] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-30cf0563] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-30cf0563] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-30cf0563] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-30cf0563] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-30cf0563]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-30cf0563] {\n  color: #666666;\n}\n.el-radio__inner[data-v-30cf0563]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-30cf0563] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-30cf0563] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-30cf0563] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-30cf0563] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-30cf0563] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-30cf0563] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-30cf0563] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-30cf0563] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-30cf0563],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-30cf0563]:hover,\n.el-input__icon.el-icon-circle-close[data-v-30cf0563],\n.el-input__icon.el-icon-circle-close[data-v-30cf0563]:hover {\n  color: #FB304D;\n}\n*[data-v-30cf0563],\n*[data-v-30cf0563]:before,\n*[data-v-30cf0563]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-30cf0563],\ntextarea[data-v-30cf0563] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-30cf0563]:focus {\n  outline: none;\n}\n.v-loading-container[data-v-30cf0563] {\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 10000;\n  background-color: #000000;\n  opacity: 0.5;\n}\n.v-loading-container .v-loading[data-v-30cf0563] {\n  border-radius: 0.020202rem;\n  position: absolute;\n  height: 0.30303rem;\n  width: 0.30303rem;\n  top: 50%;\n  left: 50%;\n  color: #666;\n  margin-left: -0.151515rem;\n  margin-top: -0.151515rem;\n  text-align: center;\n  padding-top: 0.070707rem;\n}\n.v-loading-container .v-loading .img[data-v-30cf0563] {\n  border: none;\n}", ""]);

// exports


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml,\nbody {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.v-main,\n  .page-contain,\n  .page-submenu {\n    width: 6.060606rem;\n}\n.page-submenu_left {\n    width: 1.313131rem;\n}\n.page-submenu_right {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n.has-header {\n  margin-top: 0.252525rem;\n}\n::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright {\n  text-align: right;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.common_reddot_item {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label {\n  line-height: 0.10101rem;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.alignright {\n  text-align: right;\n}\n.e2e-container {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell {\n  overflow: visible;\n}\n.e2e-red-point,\n.e2e-red-point-left {\n  position: relative;\n}\n.e2e-red-point::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small /deep/ input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small /deep/ input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray /deep/ input {\n  background: #efefef;\n}\n.e2e-radio-large /deep/ .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money {\n  color: #0B41CD;\n}\n.e2e-copy {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy:before {\n  content: '\\E787';\n}\n.e2e-warning {\n  color: #e02020;\n}\n.e2e-warning-blue {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button {\n  font-size: 0.065657rem;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.el-button {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary:hover,\n.el-button--primary:active,\n.el-button--primary:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain:hover,\n.el-button--primary.is-plain:active,\n.el-button--primary.is-plain:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled:hover,\n.el-button--primary.is-plain.is-disabled:active,\n.el-button--primary.is-plain.is-disabled:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled:hover,\n.el-button--primary.is-disabled:active,\n.el-button--primary.is-disabled:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default:hover,\n.el-button--default:active,\n.el-button--default:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text:hover,\n.el-button--text:active,\n.el-button--text:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled {\n  color: #6D7278;\n}\n.operate .el-button + .el-button,\n.operate a + .el-button,\n.operate span + .el-button,\n.operate a + span {\n  margin-left: 0.121212rem;\n}\n.operate span > div {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text {\n  color: #fff;\n}\n.el-loading-mask {\n  z-index: 9998;\n}\n.el-input__inner {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.is-disabled.el-input :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.el-select-dropdown {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label {\n  padding: 0;\n}\n.header-menu-dropdown {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow {\n  display: none;\n}\n.el-table th > .cell {\n  font-weight: bold !important;\n}\n.el-table .cell {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell {\n  padding-left: 0.070707rem;\n}\n.el-table td {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev,\n.el-pagination .btn-next {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span,\n.el-pagination .btn-next span {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog {\n  border-radius: 0.020202rem;\n}\n.el-drawer {\n  overflow: auto;\n}\n.common-confirm-dialog {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog {\n  width: 3.030303rem !important;\n}\n.approval-dialog {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select,\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer {\n  text-align: center;\n}\n.application-search-content-main-fields .active {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label {\n  color: #666666;\n}\n.el-radio__inner:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label {\n  color: #E64100;\n}\n.tox-tinymce-aux {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper {\n  width: 0.757576rem;\n}\n.custom-tooltip {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close,\n.el-select__caret.el-input__icon.el-icon-circle-close:hover,\n.el-input__icon.el-icon-circle-close,\n.el-input__icon.el-icon-circle-close:hover {\n  color: #FB304D;\n}\n*,\n*:before,\n*:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput,\ntextarea {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput:focus {\n  outline: none;\n}\n.message_box_icon,\n.message_box_title,\n.message_box_sub_Title {\n  text-align: center;\n  max-height: 2.020202rem;\n  overflow: auto;\n}\n.message_box_icon {\n  font-size: 0.30303rem;\n}\n.message_content_icon {\n  font-size: 0.080808rem;\n}\n.message_box_title {\n  font-size: 0.080808rem;\n  font-weight: 700;\n  color: #333;\n  margin-top: 0.10101rem;\n  word-break: break-word;\n}\n.message_box_content {\n  font-size: 0.080808rem;\n  font-weight: 700;\n  color: #333;\n  margin-top: 0.10101rem;\n  word-break: keep-all;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row nowrap;\n          flex-flow: row nowrap;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.message_box_content .content_title {\n  width: 1.111111rem;\n}\n.message_box_sub_Title {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999;\n  margin-top: 0.10101rem;\n  word-break: keep-all;\n}\n.message_box_confirm_Text {\n  font-size: 0.080808rem;\n  font-weight: 700;\n  color: #333;\n  margin-top: 0.10101rem;\n  word-break: keep-all;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row nowrap;\n          flex-flow: row nowrap;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.message_box_confirm_Text .content_title {\n  width: 1.010101rem;\n}\n.message_box {\n  border-radius: 0.050505rem;\n  width: 2.272727rem !important;\n}\n.message_box .el-dialog__headerbtn {\n  width: 0.10101rem;\n  height: 0.10101rem;\n  background: #efeeee;\n  border-radius: 50%;\n}\n.message_box .el-dialog__headerbtn .el-dialog__close {\n  color: #fff;\n}\n.message_box .el-dialog__footer {\n  margin-top: 0.252525rem;\n}\n.message_box .el-dialog__footer .message_box_btn {\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  padding: 0 0.075758rem;\n}\n.confirm-text-dialog__footer .el-dialog__footer {\n  margin-top: 0 !important;\n}\n.row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row nowrap;\n          flex-flow: row nowrap;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 100%;\n}\n.row .content {\n  width: 1.010101rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row nowrap;\n          flex-flow: row nowrap;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}", ""]);

// exports


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-3240deb5],\nbody[data-v-3240deb5] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-3240deb5]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-3240deb5] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-3240deb5] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-3240deb5] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-3240deb5],\n  .page-contain[data-v-3240deb5],\n  .page-submenu[data-v-3240deb5] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-3240deb5] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-3240deb5] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-3240deb5] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-3240deb5] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-3240deb5] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-3240deb5] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-3240deb5] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-3240deb5] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-3240deb5],\n  .page-submenu[data-v-3240deb5] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-3240deb5] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-3240deb5] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-3240deb5] {\n    width: 76.3vw;\n}\n.v-main[data-v-3240deb5] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-3240deb5] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-3240deb5] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-3240deb5] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-3240deb5] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-3240deb5] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-3240deb5] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-3240deb5],\n  .page-submenu[data-v-3240deb5] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-3240deb5] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-3240deb5] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-3240deb5] {\n    width: 76.3vw;\n}\n.v-main[data-v-3240deb5] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-3240deb5] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-3240deb5] {\n  margin-top: 0.252525rem;\n}\n[data-v-3240deb5]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-3240deb5]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-3240deb5] {\n  text-align: right;\n}\n.aligncenter[data-v-3240deb5] {\n  text-align: center;\n}\n.alignleft[data-v-3240deb5] {\n  text-align: left;\n}\n.actiongroupborder[data-v-3240deb5] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-3240deb5] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-3240deb5] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-3240deb5] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-3240deb5] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-3240deb5] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-3240deb5] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-3240deb5] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-3240deb5] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-3240deb5] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-3240deb5] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-3240deb5] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-3240deb5] {\n  text-align: center;\n}\n.alignleft[data-v-3240deb5] {\n  text-align: left;\n}\n.alignright[data-v-3240deb5] {\n  text-align: right;\n}\n.e2e-container[data-v-3240deb5] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-3240deb5] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-3240deb5] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-3240deb5] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-3240deb5] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-3240deb5] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-3240deb5] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-3240deb5] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-3240deb5] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-3240deb5] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-3240deb5] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-3240deb5],\n.e2e-red-point-left[data-v-3240deb5] {\n  position: relative;\n}\n.e2e-red-point[data-v-3240deb5]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-3240deb5]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-3240deb5] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-3240deb5] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-3240deb5] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-3240deb5] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-3240deb5] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-3240deb5] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-3240deb5] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-3240deb5] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-3240deb5] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-3240deb5] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-3240deb5] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-3240deb5] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-3240deb5] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-3240deb5]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-3240deb5] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-3240deb5] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-3240deb5],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-3240deb5] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-3240deb5],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-3240deb5] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-3240deb5],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-3240deb5] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-3240deb5],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-3240deb5] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-3240deb5],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-3240deb5] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-3240deb5],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-3240deb5] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-3240deb5] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-3240deb5] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-3240deb5] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-3240deb5] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-3240deb5] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-3240deb5] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-3240deb5] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-3240deb5] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-3240deb5]:hover,\n.el-button--primary[data-v-3240deb5]:active,\n.el-button--primary[data-v-3240deb5]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-3240deb5] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-3240deb5]:hover,\n.el-button--primary.is-plain[data-v-3240deb5]:active,\n.el-button--primary.is-plain[data-v-3240deb5]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-3240deb5] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-3240deb5]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-3240deb5]:active,\n.el-button--primary.is-plain.is-disabled[data-v-3240deb5]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-3240deb5] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-3240deb5]:hover,\n.el-button--primary.is-disabled[data-v-3240deb5]:active,\n.el-button--primary.is-disabled[data-v-3240deb5]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-3240deb5] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-3240deb5]:hover,\n.el-button--default[data-v-3240deb5]:active,\n.el-button--default[data-v-3240deb5]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-3240deb5] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-3240deb5]:hover,\n.el-button--text[data-v-3240deb5]:active,\n.el-button--text[data-v-3240deb5]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-3240deb5] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-3240deb5],\n.operate a + .el-button[data-v-3240deb5],\n.operate span + .el-button[data-v-3240deb5],\n.operate a + span[data-v-3240deb5] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-3240deb5] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-3240deb5] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-3240deb5] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-3240deb5] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-3240deb5] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-3240deb5] {\n  color: #fff;\n}\n.el-loading-mask[data-v-3240deb5] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-3240deb5] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-3240deb5]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-3240deb5]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-3240deb5]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-3240deb5]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-3240deb5] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-3240deb5] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-3240deb5] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-3240deb5] {\n  color: #999;\n}\n.el-select-dropdown[data-v-3240deb5] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-3240deb5] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-3240deb5] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-3240deb5] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-3240deb5] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-3240deb5] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-3240deb5] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-3240deb5]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-3240deb5] {\n  display: none;\n}\n.el-table th > .cell[data-v-3240deb5] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-3240deb5] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-3240deb5] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-3240deb5] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-3240deb5]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-3240deb5]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-3240deb5] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-3240deb5] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-3240deb5] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-3240deb5] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-3240deb5] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-3240deb5] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-3240deb5] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-3240deb5] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-3240deb5],\n.el-pagination .btn-next[data-v-3240deb5] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-3240deb5],\n.el-pagination .btn-next span[data-v-3240deb5] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-3240deb5] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-3240deb5] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-3240deb5] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-3240deb5] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-3240deb5] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-3240deb5] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-3240deb5] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-3240deb5] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-3240deb5] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-3240deb5] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-3240deb5] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-3240deb5] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-3240deb5] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-3240deb5] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-3240deb5] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-3240deb5] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-3240deb5] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-3240deb5] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-3240deb5] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-3240deb5] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-3240deb5] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-3240deb5] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-3240deb5] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-3240deb5] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-3240deb5] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-3240deb5] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-3240deb5] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-3240deb5] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-3240deb5] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-3240deb5]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-3240deb5] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-3240deb5] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-3240deb5] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-3240deb5] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-3240deb5] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-3240deb5] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-3240deb5] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-3240deb5] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-3240deb5] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-3240deb5] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-3240deb5] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-3240deb5],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-3240deb5] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-3240deb5] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-3240deb5] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-3240deb5] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-3240deb5] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-3240deb5] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-3240deb5] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-3240deb5] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-3240deb5] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-3240deb5] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-3240deb5] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-3240deb5] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-3240deb5] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-3240deb5] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-3240deb5] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-3240deb5] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-3240deb5] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-3240deb5] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-3240deb5] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-3240deb5] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-3240deb5] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-3240deb5] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-3240deb5] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-3240deb5] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-3240deb5] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-3240deb5] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-3240deb5] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-3240deb5] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-3240deb5] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-3240deb5]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-3240deb5] {\n  color: #666666;\n}\n.el-radio__inner[data-v-3240deb5]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-3240deb5] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-3240deb5] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-3240deb5] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-3240deb5] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-3240deb5] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-3240deb5] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-3240deb5] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-3240deb5] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-3240deb5],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-3240deb5]:hover,\n.el-input__icon.el-icon-circle-close[data-v-3240deb5],\n.el-input__icon.el-icon-circle-close[data-v-3240deb5]:hover {\n  color: #FB304D;\n}\n*[data-v-3240deb5],\n*[data-v-3240deb5]:before,\n*[data-v-3240deb5]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-3240deb5],\ntextarea[data-v-3240deb5] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-3240deb5]:focus {\n  outline: none;\n}\n.page-contain-tab[data-v-3240deb5] {\n  margin-bottom: 0.353535rem !important;\n}\n.application-search-content-main[data-v-3240deb5] {\n  background-color: #fff;\n  padding: 0.040404rem 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  font-size: 0.080808rem;\n}\n.application-search-content-main-roles[data-v-3240deb5] {\n  float: right;\n}\n.application-search-content-main-fields-year[data-v-3240deb5] {\n  width: 0.40404rem;\n  margin-right: 0 !important;\n}\n.application-search-content-main-fields-quarter[data-v-3240deb5] {\n  margin-left: 0.151515rem;\n}\n.application-search-content-main-fields-quarter label[data-v-3240deb5] {\n  cursor: pointer;\n}\n.application-search-content-main-fields-quarter-lines[data-v-3240deb5] {\n  margin-left: 0.409091rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.application-search-content-main-fields-quarter-lines .line-active[data-v-3240deb5] {\n  border-bottom: 0.015152rem solid #0b41cd;\n  margin-bottom: -0.040404rem;\n}\n.application-search-content-main-fields-quarter-lines-line[data-v-3240deb5] {\n  border-bottom: 0.015152rem solid #0b41cd;\n  width: 0.20202rem;\n  border-bottom: none;\n}\n.application-search-content-main-fields-quarter-lines-line-q1[data-v-3240deb5] {\n  margin-left: 0.121212rem;\n}\n.application-search-content-main-fields-quarter-lines-line-q2[data-v-3240deb5] {\n  margin-left: 0.060606rem;\n}\n.application-search-content-main-fields-quarter-lines-line-q3[data-v-3240deb5] {\n  margin-left: 0.050505rem;\n}\n.application-search-content-main-fields-quarter-lines-line-q4[data-v-3240deb5] {\n  margin-left: 0.060606rem;\n}\n.page-contain-main-tab[data-v-3240deb5] {\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  background-color: transparent !important;\n}\n.page-contain-main-tab .main-blocks[data-v-3240deb5] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row nowrap;\n          flex-flow: row nowrap;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-contain-main-tab .main-block[data-v-3240deb5] {\n  height: 0.757576rem;\n  width: 1.449495rem;\n  display: inline-block;\n  border: none;\n  background: #fff;\n  border-radius: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain[data-v-3240deb5] {\n  margin: 0 0.121212rem;\n}\n.page-contain-main-tab .main-block-contain-title[data-v-3240deb5] {\n  margin-top: 0.080808rem;\n  height: 0.111111rem;\n  line-height: 0.111111rem;\n  font-size: 0.080808rem;\n  color: #666666;\n}\n.page-contain-main-tab .main-block-contain-title .iconfont[data-v-3240deb5] {\n  float: right;\n  font-size: 0.070707rem;\n}\n.page-contain-main-tab .main-block-contain-budget[data-v-3240deb5] {\n  margin-top: 0.090909rem;\n  height: 0.151515rem;\n  line-height: 0.151515rem;\n  font-size: 0.111111rem;\n  width: 100%;\n}\n.page-contain-main-tab .main-block-contain-budget-amount[data-v-3240deb5] {\n  color: rgba(0, 0, 0, 0.85);\n}\n.page-contain-main-tab .main-block-contain-budget-percent[data-v-3240deb5] {\n  float: right;\n}\n.page-contain-main-tab .main-block-contain-budget-percent-alert[data-v-3240deb5] {\n  color: #FB304D !important;\n}\n.page-contain-main-tab .main-block-contain-budget-percent-title[data-v-3240deb5] {\n  float: right;\n  font-size: 0.070707rem;\n  color: rgba(0, 0, 0, 0.65);\n  margin-right: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain-budget .iconfont[data-v-3240deb5] {\n  font-size: 0.141414rem;\n}\n.page-contain-main-tab .main-block-contain-budget .icon-yitijiao[data-v-3240deb5] {\n  color: #2D82F0;\n}\n.page-contain-main-tab .main-block-contain-budget .icon-shenpizhong[data-v-3240deb5] {\n  color: #FFB52A;\n}\n.page-contain-main-tab .main-block-contain-budget .icon-shenpitongguo[data-v-3240deb5] {\n  color: #0EC771;\n}\n.page-contain-main-tab .main-block-contain-budget .icon-shenpijujue[data-v-3240deb5] {\n  color: #FB304D;\n}\n.page-contain-main-tab .main-block-contain-split-line[data-v-3240deb5] {\n  width: 1.212121rem;\n  margin: 0.065657rem 0 0 0;\n  height: 0.040404rem;\n  background-color: #F0F2F5;\n  border-radius: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain-split-line .progress[data-v-3240deb5] {\n  height: 0.040404rem;\n  background-color: #2D82F0;\n  border-radius: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain-split-line .pass[data-v-3240deb5] {\n  height: 0.040404rem;\n  background-color: #0EC771;\n  border-radius: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain-split-line .pending[data-v-3240deb5] {\n  height: 0.040404rem;\n  background-color: #FFB52A;\n  border-radius: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain-split-line .reject[data-v-3240deb5] {\n  height: 0.040404rem;\n  background-color: #FB304D;\n  border-radius: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain-info[data-v-3240deb5] {\n  margin-top: 0.045455rem;\n}\n.page-contain-main-tab .main-block-contain-season-amount[data-v-3240deb5] {\n  font-size: 0.070707rem;\n  color: rgba(0, 0, 0, 0.65);\n}\n.page-contain-main-tab .main-block-contain-total[data-v-3240deb5] {\n  float: right;\n  font-size: 0.070707rem;\n  color: rgba(0, 0, 0, 0.65);\n}\n.page-contain-main-tab .main-block-contain-total label[data-v-3240deb5] {\n  margin-left: 0.040404rem;\n  color: rgba(0, 0, 0, 0.85);\n}\n.search-content[data-v-3240deb5] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 0.111111rem;\n}\n.search-content .search-content-fields[data-v-3240deb5] {\n  display: contents;\n}\n.search-content .search-content-fields-operate[data-v-3240deb5] {\n  margin-left: auto !important;\n}\n.search-content .el-form-item + .el-form-item[data-v-3240deb5] {\n  margin-left: 0.116162rem;\n}\n.operate[data-v-3240deb5] {\n  float: right;\n  margin-bottom: 0.040404rem;\n}\n.operate-export[data-v-3240deb5] {\n  font-size: 0.070707rem;\n}\n.operate-export a[data-v-3240deb5] {\n  color: #0B41CD;\n}\n.operate-export i[data-v-3240deb5] {\n  font-size: 0.070707rem;\n}\n.l-user-item[data-v-3240deb5] {\n  width: 100%;\n  height: 0.287879rem;\n  padding: 0.090909rem 0.111111rem;\n  border-bottom: 0.005051rem solid #dfdfdf;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.l-user-item-icon[data-v-3240deb5] {\n  font-size: 0.080808rem;\n  padding: 0.010101rem;\n}\n.budget-detail-info[data-v-3240deb5] {\n  float: left;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  font-size: 0.070707rem;\n  color: #333333;\n}\n.main-budget-info-block[data-v-3240deb5] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-bottom: 0.080808rem;\n}\n.main-budget-info-block-name[data-v-3240deb5] {\n  width: 50%;\n}\n.main-budget-info-block-name label[data-v-3240deb5] {\n  float: right;\n  font-size: 0.070707rem;\n  color: #666666;\n}\n.main-budget-info-block-value[data-v-3240deb5] {\n  font-size: 0.070707rem;\n  color: #333333;\n}\n.bottom-info[data-v-3240deb5] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: fixed;\n  background-color: #fff;\n  width: 100%;\n  left: 0;\n  height: 0.222222rem;\n  -webkit-box-shadow: -0.005051rem 0 0.020202rem 0 rgba(51, 51, 51, 0.35);\n          box-shadow: -0.005051rem 0 0.020202rem 0 rgba(51, 51, 51, 0.35);\n  bottom: 0;\n  z-index: 5;\n}\n.bottom-info-info[data-v-3240deb5] {\n  margin-left: 0.606061rem;\n  line-height: 0.222222rem;\n}\n.bottom-info-operate[data-v-3240deb5] {\n  position: absolute;\n  right: 0.606061rem;\n  line-height: 0.232323rem;\n}\n.advanced-search-dialog[data-v-3240deb5] {\n  padding: 0;\n}\n.advanced-search-dialog .advanced-search-dialog-close[data-v-3240deb5] {\n  font-size: 0.070707rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right[data-v-3240deb5] {\n  margin-bottom: 0.025253rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row[data-v-3240deb5] {\n  padding: 0.141414rem 0 0 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .advanced-search-form-title[data-v-3240deb5] {\n  height: 0.20202rem;\n  line-height: 0.20202rem;\n  width: 0.454545rem;\n  font-weight: bold;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .advanced-search-form-title .iconfont[data-v-3240deb5] {\n  font-size: 0.070707rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col[data-v-3240deb5] {\n  width: 1.212121rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col .el-form-item__label[data-v-3240deb5] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col .el-form-item__content[data-v-3240deb5] {\n  padding-top: 0.010101rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col .el-form-item__content .el-select[data-v-3240deb5],\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col .el-form-item__content .el-input[data-v-3240deb5] {\n  width: 1.212121rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col .el-form-item__content label[data-v-3240deb5] {\n  margin-left: 0.050505rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col + .el-col[data-v-3240deb5] {\n  margin-left: 0.621212rem;\n}\n.advanced-search-dialog-close[data-v-3240deb5] {\n  margin-left: 0.126263rem;\n  cursor: pointer;\n}\n.advanced-search-dialog-score-model[data-v-3240deb5] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 1.212121rem;\n}\n.advanced-search-dialog-score-model .el-input-number[data-v-3240deb5] {\n  width: 0.484848rem !important;\n}\n.advanced-search-dialog-score-model span[data-v-3240deb5] {\n  margin: auto 0.10101rem;\n  width: 0.050505rem;\n  border-bottom: 0.010101rem solid #666666;\n}\n.advanced-search-dialog .l-user-item[data-v-3240deb5] {\n  width: 100%;\n  height: 0.20202rem;\n  padding: 0 0.111111rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.advanced-search-dialog .l-user-item-icon[data-v-3240deb5] {\n  font-size: 0.080808rem;\n  padding: 0.010101rem;\n  width: 0.10101rem;\n}\n.advanced-search-dialog .l-user-item-text[data-v-3240deb5] {\n  margin-left: 0.025253rem;\n  font-size: 0.070707rem;\n  line-height: 0.10101rem;\n  display: inline-block;\n}\n.advanced-search-dialog .l-user-item[data-v-3240deb5]:hover {\n  color: #0B41CD;\n  cursor: pointer;\n}\n.advanced-search-dialog .l-user-item[data-v-3240deb5]:last-child {\n  border-bottom: none;\n}\n.toolbar[data-v-3240deb5] {\n  height: 0.191919rem;\n}\n.toolbar .application-detail-info[data-v-3240deb5] {\n  float: left;\n  height: 0.111111rem;\n  line-height: 0.111111rem;\n  font-size: 0.070707rem;\n  color: #333333;\n}\n.toolbar .operate[data-v-3240deb5] {\n  float: right;\n  height: 0.111111rem;\n  line-height: 0.111111rem;\n}\n.toolbar .operate-export[data-v-3240deb5] {\n  font-size: 0.070707rem;\n}\n.toolbar .operate-export i[data-v-3240deb5] {\n  font-size: 0.070707rem;\n}", ""]);

// exports


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml,\nbody {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.v-main,\n  .page-contain,\n  .page-submenu {\n    width: 6.060606rem;\n}\n.page-submenu_left {\n    width: 1.313131rem;\n}\n.page-submenu_right {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n.has-header {\n  margin-top: 0.252525rem;\n}\n::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright {\n  text-align: right;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.common_reddot_item {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label {\n  line-height: 0.10101rem;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.alignright {\n  text-align: right;\n}\n.e2e-container {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell {\n  overflow: visible;\n}\n.e2e-red-point,\n.e2e-red-point-left {\n  position: relative;\n}\n.e2e-red-point::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small /deep/ input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small /deep/ input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray /deep/ input {\n  background: #efefef;\n}\n.e2e-radio-large /deep/ .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money {\n  color: #0B41CD;\n}\n.e2e-copy {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy:before {\n  content: '\\E787';\n}\n.e2e-warning {\n  color: #e02020;\n}\n.e2e-warning-blue {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button {\n  font-size: 0.065657rem;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.el-button {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary:hover,\n.el-button--primary:active,\n.el-button--primary:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain:hover,\n.el-button--primary.is-plain:active,\n.el-button--primary.is-plain:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled:hover,\n.el-button--primary.is-plain.is-disabled:active,\n.el-button--primary.is-plain.is-disabled:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled:hover,\n.el-button--primary.is-disabled:active,\n.el-button--primary.is-disabled:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default:hover,\n.el-button--default:active,\n.el-button--default:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text:hover,\n.el-button--text:active,\n.el-button--text:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled {\n  color: #6D7278;\n}\n.operate .el-button + .el-button,\n.operate a + .el-button,\n.operate span + .el-button,\n.operate a + span {\n  margin-left: 0.121212rem;\n}\n.operate span > div {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text {\n  color: #fff;\n}\n.el-loading-mask {\n  z-index: 9998;\n}\n.el-input__inner {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.is-disabled.el-input :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.el-select-dropdown {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label {\n  padding: 0;\n}\n.header-menu-dropdown {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow {\n  display: none;\n}\n.el-table th > .cell {\n  font-weight: bold !important;\n}\n.el-table .cell {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell {\n  padding-left: 0.070707rem;\n}\n.el-table td {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev,\n.el-pagination .btn-next {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span,\n.el-pagination .btn-next span {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog {\n  border-radius: 0.020202rem;\n}\n.el-drawer {\n  overflow: auto;\n}\n.common-confirm-dialog {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog {\n  width: 3.030303rem !important;\n}\n.approval-dialog {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select,\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer {\n  text-align: center;\n}\n.application-search-content-main-fields .active {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label {\n  color: #666666;\n}\n.el-radio__inner:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label {\n  color: #E64100;\n}\n.tox-tinymce-aux {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper {\n  width: 0.757576rem;\n}\n.custom-tooltip {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close,\n.el-select__caret.el-input__icon.el-icon-circle-close:hover,\n.el-input__icon.el-icon-circle-close,\n.el-input__icon.el-icon-circle-close:hover {\n  color: #FB304D;\n}\n*,\n*:before,\n*:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput,\ntextarea {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput:focus {\n  outline: none;\n}\n.comment_box {\n  width: 4.040404rem;\n  border-radius: 0.050505rem;\n}\n.comment_box /deep/ .el-dialog__header {\n  height: 0.30303rem;\n  font-size: 0.070707rem;\n  font-weight: bolder;\n  line-height: 0.30303rem;\n}\n.comment_box /deep/ .el-form-item {\n  margin-bottom: 0;\n}\n.comment_box .dialog-footer /deep/ .el-button {\n  margin: 0.252525rem 0.151515rem;\n}", ""]);

// exports


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-351a0cf9],\nbody[data-v-351a0cf9] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-351a0cf9]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-351a0cf9] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-351a0cf9] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-351a0cf9] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-351a0cf9],\n  .page-contain[data-v-351a0cf9],\n  .page-submenu[data-v-351a0cf9] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-351a0cf9] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-351a0cf9] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-351a0cf9] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-351a0cf9] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-351a0cf9] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-351a0cf9] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-351a0cf9] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-351a0cf9] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-351a0cf9],\n  .page-submenu[data-v-351a0cf9] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-351a0cf9] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-351a0cf9] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-351a0cf9] {\n    width: 76.3vw;\n}\n.v-main[data-v-351a0cf9] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-351a0cf9] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-351a0cf9] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-351a0cf9] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-351a0cf9] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-351a0cf9] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-351a0cf9] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-351a0cf9],\n  .page-submenu[data-v-351a0cf9] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-351a0cf9] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-351a0cf9] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-351a0cf9] {\n    width: 76.3vw;\n}\n.v-main[data-v-351a0cf9] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-351a0cf9] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-351a0cf9] {\n  margin-top: 0.252525rem;\n}\n[data-v-351a0cf9]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-351a0cf9]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-351a0cf9] {\n  text-align: right;\n}\n.aligncenter[data-v-351a0cf9] {\n  text-align: center;\n}\n.alignleft[data-v-351a0cf9] {\n  text-align: left;\n}\n.actiongroupborder[data-v-351a0cf9] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-351a0cf9] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-351a0cf9] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-351a0cf9] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-351a0cf9] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-351a0cf9] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-351a0cf9] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-351a0cf9] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-351a0cf9] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-351a0cf9] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-351a0cf9] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-351a0cf9] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-351a0cf9] {\n  text-align: center;\n}\n.alignleft[data-v-351a0cf9] {\n  text-align: left;\n}\n.alignright[data-v-351a0cf9] {\n  text-align: right;\n}\n.e2e-container[data-v-351a0cf9] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-351a0cf9] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-351a0cf9] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-351a0cf9] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-351a0cf9] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-351a0cf9] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-351a0cf9] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-351a0cf9] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-351a0cf9] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-351a0cf9] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-351a0cf9] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-351a0cf9],\n.e2e-red-point-left[data-v-351a0cf9] {\n  position: relative;\n}\n.e2e-red-point[data-v-351a0cf9]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-351a0cf9]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-351a0cf9] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-351a0cf9] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-351a0cf9] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-351a0cf9] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-351a0cf9] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-351a0cf9] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-351a0cf9] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-351a0cf9] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-351a0cf9] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-351a0cf9] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-351a0cf9] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-351a0cf9] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-351a0cf9] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-351a0cf9]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-351a0cf9] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-351a0cf9] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-351a0cf9],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-351a0cf9] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-351a0cf9],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-351a0cf9] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-351a0cf9],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-351a0cf9] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-351a0cf9],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-351a0cf9] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-351a0cf9],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-351a0cf9] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-351a0cf9],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-351a0cf9] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-351a0cf9] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-351a0cf9] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-351a0cf9] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-351a0cf9] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-351a0cf9] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-351a0cf9] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-351a0cf9] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-351a0cf9] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-351a0cf9]:hover,\n.el-button--primary[data-v-351a0cf9]:active,\n.el-button--primary[data-v-351a0cf9]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-351a0cf9] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-351a0cf9]:hover,\n.el-button--primary.is-plain[data-v-351a0cf9]:active,\n.el-button--primary.is-plain[data-v-351a0cf9]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-351a0cf9] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-351a0cf9]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-351a0cf9]:active,\n.el-button--primary.is-plain.is-disabled[data-v-351a0cf9]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-351a0cf9] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-351a0cf9]:hover,\n.el-button--primary.is-disabled[data-v-351a0cf9]:active,\n.el-button--primary.is-disabled[data-v-351a0cf9]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-351a0cf9] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-351a0cf9]:hover,\n.el-button--default[data-v-351a0cf9]:active,\n.el-button--default[data-v-351a0cf9]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-351a0cf9] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-351a0cf9]:hover,\n.el-button--text[data-v-351a0cf9]:active,\n.el-button--text[data-v-351a0cf9]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-351a0cf9] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-351a0cf9],\n.operate a + .el-button[data-v-351a0cf9],\n.operate span + .el-button[data-v-351a0cf9],\n.operate a + span[data-v-351a0cf9] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-351a0cf9] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-351a0cf9] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-351a0cf9] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-351a0cf9] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-351a0cf9] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-351a0cf9] {\n  color: #fff;\n}\n.el-loading-mask[data-v-351a0cf9] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-351a0cf9] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-351a0cf9]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-351a0cf9]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-351a0cf9]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-351a0cf9]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-351a0cf9] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-351a0cf9] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-351a0cf9] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-351a0cf9] {\n  color: #999;\n}\n.el-select-dropdown[data-v-351a0cf9] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-351a0cf9] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-351a0cf9] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-351a0cf9] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-351a0cf9] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-351a0cf9] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-351a0cf9] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-351a0cf9]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-351a0cf9] {\n  display: none;\n}\n.el-table th > .cell[data-v-351a0cf9] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-351a0cf9] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-351a0cf9] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-351a0cf9] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-351a0cf9]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-351a0cf9]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-351a0cf9] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-351a0cf9] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-351a0cf9] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-351a0cf9] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-351a0cf9] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-351a0cf9] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-351a0cf9] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-351a0cf9] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-351a0cf9],\n.el-pagination .btn-next[data-v-351a0cf9] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-351a0cf9],\n.el-pagination .btn-next span[data-v-351a0cf9] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-351a0cf9] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-351a0cf9] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-351a0cf9] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-351a0cf9] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-351a0cf9] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-351a0cf9] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-351a0cf9] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-351a0cf9] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-351a0cf9] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-351a0cf9] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-351a0cf9] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-351a0cf9] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-351a0cf9] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-351a0cf9] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-351a0cf9] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-351a0cf9] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-351a0cf9] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-351a0cf9] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-351a0cf9] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-351a0cf9] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-351a0cf9] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-351a0cf9] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-351a0cf9] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-351a0cf9] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-351a0cf9] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-351a0cf9] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-351a0cf9] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-351a0cf9] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-351a0cf9] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-351a0cf9]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-351a0cf9] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-351a0cf9] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-351a0cf9] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-351a0cf9] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-351a0cf9] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-351a0cf9] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-351a0cf9] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-351a0cf9] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-351a0cf9] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-351a0cf9] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-351a0cf9] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-351a0cf9],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-351a0cf9] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-351a0cf9] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-351a0cf9] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-351a0cf9] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-351a0cf9] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-351a0cf9] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-351a0cf9] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-351a0cf9] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-351a0cf9] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-351a0cf9] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-351a0cf9] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-351a0cf9] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-351a0cf9] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-351a0cf9] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-351a0cf9] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-351a0cf9] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-351a0cf9] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-351a0cf9] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-351a0cf9] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-351a0cf9] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-351a0cf9] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-351a0cf9] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-351a0cf9] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-351a0cf9] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-351a0cf9] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-351a0cf9] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-351a0cf9] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-351a0cf9] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-351a0cf9] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-351a0cf9]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-351a0cf9] {\n  color: #666666;\n}\n.el-radio__inner[data-v-351a0cf9]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-351a0cf9] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-351a0cf9] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-351a0cf9] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-351a0cf9] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-351a0cf9] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-351a0cf9] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-351a0cf9] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-351a0cf9] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-351a0cf9],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-351a0cf9]:hover,\n.el-input__icon.el-icon-circle-close[data-v-351a0cf9],\n.el-input__icon.el-icon-circle-close[data-v-351a0cf9]:hover {\n  color: #FB304D;\n}\n*[data-v-351a0cf9],\n*[data-v-351a0cf9]:before,\n*[data-v-351a0cf9]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-351a0cf9],\ntextarea[data-v-351a0cf9] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-351a0cf9]:focus {\n  outline: none;\n}\n.message-box[data-v-351a0cf9] {\n  position: fixed;\n  min-height: 1.515152rem;\n  width: 1.515152rem;\n  left: 50%;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  margin-left: -0.757576rem;\n  text-align: center;\n  top: 0;\n  cursor: pointer;\n  -webkit-transform: all ease-in-out 3s;\n          transform: all ease-in-out 3s;\n  height: auto;\n  z-index: 999;\n}\n.message-box .message[data-v-351a0cf9] {\n  position: relative;\n  padding: 0.050505rem;\n  font-size: 0.070707rem;\n  background-color: #fff;\n  -webkit-transform: all ease-in-out 3s;\n          transform: all ease-in-out 3s;\n  height: 0.19697rem;\n}\n.message-box .success[data-v-351a0cf9] {\n  background-color: #DEFCD5;\n  color: #52A954;\n}\n.message-box .warn[data-v-351a0cf9] {\n  background-color: #F1D7D7;\n  color: #A95252;\n}\n.message-box .message-out[data-v-351a0cf9] {\n  height: 0;\n}", ""]);

// exports


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml,\nbody {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.v-main,\n  .page-contain,\n  .page-submenu {\n    width: 6.060606rem;\n}\n.page-submenu_left {\n    width: 1.313131rem;\n}\n.page-submenu_right {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n.has-header {\n  margin-top: 0.252525rem;\n}\n::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright {\n  text-align: right;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.common_reddot_item {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label {\n  line-height: 0.10101rem;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.alignright {\n  text-align: right;\n}\n.e2e-container {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell {\n  overflow: visible;\n}\n.e2e-red-point,\n.e2e-red-point-left {\n  position: relative;\n}\n.e2e-red-point::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small /deep/ input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small /deep/ input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray /deep/ input {\n  background: #efefef;\n}\n.e2e-radio-large /deep/ .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money {\n  color: #0B41CD;\n}\n.e2e-copy {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy:before {\n  content: '\\E787';\n}\n.e2e-warning {\n  color: #e02020;\n}\n.e2e-warning-blue {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button {\n  font-size: 0.065657rem;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.el-button {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary:hover,\n.el-button--primary:active,\n.el-button--primary:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain:hover,\n.el-button--primary.is-plain:active,\n.el-button--primary.is-plain:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled:hover,\n.el-button--primary.is-plain.is-disabled:active,\n.el-button--primary.is-plain.is-disabled:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled:hover,\n.el-button--primary.is-disabled:active,\n.el-button--primary.is-disabled:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default:hover,\n.el-button--default:active,\n.el-button--default:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text:hover,\n.el-button--text:active,\n.el-button--text:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled {\n  color: #6D7278;\n}\n.operate .el-button + .el-button,\n.operate a + .el-button,\n.operate span + .el-button,\n.operate a + span {\n  margin-left: 0.121212rem;\n}\n.operate span > div {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text {\n  color: #fff;\n}\n.el-loading-mask {\n  z-index: 9998;\n}\n.el-input__inner {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.is-disabled.el-input :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.el-select-dropdown {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label {\n  padding: 0;\n}\n.header-menu-dropdown {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow {\n  display: none;\n}\n.el-table th > .cell {\n  font-weight: bold !important;\n}\n.el-table .cell {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell {\n  padding-left: 0.070707rem;\n}\n.el-table td {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev,\n.el-pagination .btn-next {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span,\n.el-pagination .btn-next span {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog {\n  border-radius: 0.020202rem;\n}\n.el-drawer {\n  overflow: auto;\n}\n.common-confirm-dialog {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog {\n  width: 3.030303rem !important;\n}\n.approval-dialog {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select,\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer {\n  text-align: center;\n}\n.application-search-content-main-fields .active {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label {\n  color: #666666;\n}\n.el-radio__inner:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label {\n  color: #E64100;\n}\n.tox-tinymce-aux {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper {\n  width: 0.757576rem;\n}\n.custom-tooltip {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close,\n.el-select__caret.el-input__icon.el-icon-circle-close:hover,\n.el-input__icon.el-icon-circle-close,\n.el-input__icon.el-icon-circle-close:hover {\n  color: #FB304D;\n}\n*,\n*:before,\n*:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput,\ntextarea {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput:focus {\n  outline: none;\n}\n.common_pdfviewer_wrapper {\n  z-index: 10000 !important;\n}\n.common_pdfviewer_wrapper .el-dialog__body {\n  padding: 0 0.10101rem 0.151515rem 0.10101rem;\n}\n.common_pdfviewer_wrapper .maincontent {\n  height: 75vh;\n  text-align: center;\n}\n.common_pdfviewer_wrapper .maincontent .header {\n  margin: 0 auto 0.10101rem;\n  padding: 0.050505rem 0.151515rem;\n  width: 100%;\n  text-align: right;\n  position: absolute;\n  left: 0;\n  top: 0.252525rem;\n}\n.common_pdfviewer_wrapper .maincontent .main {\n  padding: 0 0 0.050505rem 0;\n  height: 100%;\n}\n.common_pdfviewer_wrapper .maincontent .main .content {\n  display: inline-block;\n  margin: 0 0.252525rem;\n  width: 4.040404rem;\n  height: 100%;\n  overflow: auto;\n  vertical-align: middle;\n}\n.common_pdfviewer_wrapper .maincontent .main .content:before {\n  content: '';\n  display: inline-block;\n  width: 0;\n  height: 100%;\n  vertical-align: middle;\n}\n.common_pdfviewer_wrapper .maincontent .main .content canvas {\n  display: inline-block;\n  padding: 0 0 1rem 0;\n  width: 100%;\n  vertical-align: middle;\n}\n.common_pdfviewer_wrapper .maincontent .main .operator {\n  display: inline-block;\n  width: 0.30303rem;\n  vertical-align: middle;\n  z-index: 1;\n}\n.common_pdfviewer_wrapper .maincontent .main .operator i {\n  font-size: 0.30303rem;\n}\n.common_pdfviewer_wrapper .maincontent .main .operator .el-button {\n  padding: 0;\n  height: auto;\n}\n.common_pdfviewer_wrapper .maincontent .main .operator .el-button.is-disabled {\n  border-color: transparent;\n}\n.common_pdfviewer_wrapper .maincontent .main .operator .left {\n  display: inline-block;\n  width: 0.505051rem;\n  height: 0.252525rem;\n  background-color: red;\n}\n.common_pdfviewer_wrapper .maincontent .main .operator .right {\n  display: inline-block;\n  width: 0.505051rem;\n  height: 0.252525rem;\n  background-color: red;\n}\n.common_pdfviewer_wrapper .maincontent .footer {\n  margin: 0 0 0.050505rem 0;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n}\n.common_pdfviewer_wrapper .maincontent .footer .el-pagination {\n  text-align: center;\n}", ""]);

// exports


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-3a9422a3],\nbody[data-v-3a9422a3] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-3a9422a3]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-3a9422a3] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-3a9422a3] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-3a9422a3] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-3a9422a3],\n  .page-contain[data-v-3a9422a3],\n  .page-submenu[data-v-3a9422a3] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-3a9422a3] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-3a9422a3] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-3a9422a3] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-3a9422a3] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-3a9422a3] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-3a9422a3] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-3a9422a3] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-3a9422a3] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-3a9422a3],\n  .page-submenu[data-v-3a9422a3] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-3a9422a3] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-3a9422a3] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-3a9422a3] {\n    width: 76.3vw;\n}\n.v-main[data-v-3a9422a3] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-3a9422a3] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-3a9422a3] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-3a9422a3] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-3a9422a3] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-3a9422a3] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-3a9422a3] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-3a9422a3],\n  .page-submenu[data-v-3a9422a3] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-3a9422a3] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-3a9422a3] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-3a9422a3] {\n    width: 76.3vw;\n}\n.v-main[data-v-3a9422a3] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-3a9422a3] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-3a9422a3] {\n  margin-top: 0.252525rem;\n}\n[data-v-3a9422a3]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-3a9422a3]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-3a9422a3] {\n  text-align: right;\n}\n.aligncenter[data-v-3a9422a3] {\n  text-align: center;\n}\n.alignleft[data-v-3a9422a3] {\n  text-align: left;\n}\n.actiongroupborder[data-v-3a9422a3] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-3a9422a3] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-3a9422a3] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-3a9422a3] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-3a9422a3] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-3a9422a3] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-3a9422a3] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-3a9422a3] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-3a9422a3] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-3a9422a3] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-3a9422a3] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-3a9422a3] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-3a9422a3] {\n  text-align: center;\n}\n.alignleft[data-v-3a9422a3] {\n  text-align: left;\n}\n.alignright[data-v-3a9422a3] {\n  text-align: right;\n}\n.e2e-container[data-v-3a9422a3] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-3a9422a3] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-3a9422a3] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-3a9422a3] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-3a9422a3] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-3a9422a3] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-3a9422a3] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-3a9422a3] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-3a9422a3] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-3a9422a3] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-3a9422a3] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-3a9422a3],\n.e2e-red-point-left[data-v-3a9422a3] {\n  position: relative;\n}\n.e2e-red-point[data-v-3a9422a3]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-3a9422a3]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-3a9422a3] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-3a9422a3] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-3a9422a3] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-3a9422a3] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-3a9422a3] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-3a9422a3] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-3a9422a3] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-3a9422a3] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-3a9422a3] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-3a9422a3] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-3a9422a3] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-3a9422a3] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-3a9422a3] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-3a9422a3]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-3a9422a3] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-3a9422a3] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-3a9422a3],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-3a9422a3] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-3a9422a3],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-3a9422a3] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-3a9422a3],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-3a9422a3] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-3a9422a3],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-3a9422a3] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-3a9422a3],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-3a9422a3] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-3a9422a3],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-3a9422a3] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-3a9422a3] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-3a9422a3] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-3a9422a3] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-3a9422a3] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-3a9422a3] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-3a9422a3] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-3a9422a3] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-3a9422a3] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-3a9422a3]:hover,\n.el-button--primary[data-v-3a9422a3]:active,\n.el-button--primary[data-v-3a9422a3]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-3a9422a3] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-3a9422a3]:hover,\n.el-button--primary.is-plain[data-v-3a9422a3]:active,\n.el-button--primary.is-plain[data-v-3a9422a3]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-3a9422a3] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-3a9422a3]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-3a9422a3]:active,\n.el-button--primary.is-plain.is-disabled[data-v-3a9422a3]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-3a9422a3] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-3a9422a3]:hover,\n.el-button--primary.is-disabled[data-v-3a9422a3]:active,\n.el-button--primary.is-disabled[data-v-3a9422a3]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-3a9422a3] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-3a9422a3]:hover,\n.el-button--default[data-v-3a9422a3]:active,\n.el-button--default[data-v-3a9422a3]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-3a9422a3] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-3a9422a3]:hover,\n.el-button--text[data-v-3a9422a3]:active,\n.el-button--text[data-v-3a9422a3]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-3a9422a3] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-3a9422a3],\n.operate a + .el-button[data-v-3a9422a3],\n.operate span + .el-button[data-v-3a9422a3],\n.operate a + span[data-v-3a9422a3] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-3a9422a3] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-3a9422a3] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-3a9422a3] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-3a9422a3] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-3a9422a3] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-3a9422a3] {\n  color: #fff;\n}\n.el-loading-mask[data-v-3a9422a3] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-3a9422a3] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-3a9422a3]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-3a9422a3]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-3a9422a3]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-3a9422a3]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-3a9422a3] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-3a9422a3] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-3a9422a3] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-3a9422a3] {\n  color: #999;\n}\n.el-select-dropdown[data-v-3a9422a3] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-3a9422a3] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-3a9422a3] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-3a9422a3] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-3a9422a3] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-3a9422a3] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-3a9422a3] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-3a9422a3]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-3a9422a3] {\n  display: none;\n}\n.el-table th > .cell[data-v-3a9422a3] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-3a9422a3] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-3a9422a3] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-3a9422a3] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-3a9422a3]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-3a9422a3]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-3a9422a3] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-3a9422a3] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-3a9422a3] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-3a9422a3] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-3a9422a3] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-3a9422a3] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-3a9422a3] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-3a9422a3] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-3a9422a3],\n.el-pagination .btn-next[data-v-3a9422a3] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-3a9422a3],\n.el-pagination .btn-next span[data-v-3a9422a3] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-3a9422a3] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-3a9422a3] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-3a9422a3] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-3a9422a3] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-3a9422a3] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-3a9422a3] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-3a9422a3] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-3a9422a3] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-3a9422a3] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-3a9422a3] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-3a9422a3] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-3a9422a3] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-3a9422a3] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-3a9422a3] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-3a9422a3] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-3a9422a3] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-3a9422a3] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-3a9422a3] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-3a9422a3] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-3a9422a3] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-3a9422a3] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-3a9422a3] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-3a9422a3] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-3a9422a3] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-3a9422a3] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-3a9422a3] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-3a9422a3] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-3a9422a3] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-3a9422a3] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-3a9422a3]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-3a9422a3] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-3a9422a3] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-3a9422a3] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-3a9422a3] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-3a9422a3] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-3a9422a3] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-3a9422a3] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-3a9422a3] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-3a9422a3] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-3a9422a3] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-3a9422a3] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-3a9422a3],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-3a9422a3] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-3a9422a3] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-3a9422a3] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-3a9422a3] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-3a9422a3] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-3a9422a3] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-3a9422a3] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-3a9422a3] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-3a9422a3] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-3a9422a3] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-3a9422a3] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-3a9422a3] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-3a9422a3] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-3a9422a3] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-3a9422a3] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-3a9422a3] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-3a9422a3] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-3a9422a3] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-3a9422a3] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-3a9422a3] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-3a9422a3] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-3a9422a3] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-3a9422a3] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-3a9422a3] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-3a9422a3] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-3a9422a3] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-3a9422a3] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-3a9422a3] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-3a9422a3] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-3a9422a3]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-3a9422a3] {\n  color: #666666;\n}\n.el-radio__inner[data-v-3a9422a3]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-3a9422a3] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-3a9422a3] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-3a9422a3] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-3a9422a3] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-3a9422a3] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-3a9422a3] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-3a9422a3] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-3a9422a3] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-3a9422a3],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-3a9422a3]:hover,\n.el-input__icon.el-icon-circle-close[data-v-3a9422a3],\n.el-input__icon.el-icon-circle-close[data-v-3a9422a3]:hover {\n  color: #FB304D;\n}\n*[data-v-3a9422a3],\n*[data-v-3a9422a3]:before,\n*[data-v-3a9422a3]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-3a9422a3],\ntextarea[data-v-3a9422a3] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-3a9422a3]:focus {\n  outline: none;\n}\n.search-content[data-v-3a9422a3] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 0.111111rem;\n}\n.search-content .search-content-fields .btn-search[data-v-3a9422a3] {\n  margin-left: 0.050505rem;\n}\n.operate[data-v-3a9422a3] {\n  float: right;\n  margin-bottom: 0.151515rem;\n}", ""]);

// exports


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml,\nbody {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.v-main,\n  .page-contain,\n  .page-submenu {\n    width: 6.060606rem;\n}\n.page-submenu_left {\n    width: 1.313131rem;\n}\n.page-submenu_right {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n.has-header {\n  margin-top: 0.252525rem;\n}\n::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright {\n  text-align: right;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.common_reddot_item {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label {\n  line-height: 0.10101rem;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.alignright {\n  text-align: right;\n}\n.e2e-container {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell {\n  overflow: visible;\n}\n.e2e-red-point,\n.e2e-red-point-left {\n  position: relative;\n}\n.e2e-red-point::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small /deep/ input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small /deep/ input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray /deep/ input {\n  background: #efefef;\n}\n.e2e-radio-large /deep/ .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money {\n  color: #0B41CD;\n}\n.e2e-copy {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy:before {\n  content: '\\E787';\n}\n.e2e-warning {\n  color: #e02020;\n}\n.e2e-warning-blue {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button {\n  font-size: 0.065657rem;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.el-button {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary:hover,\n.el-button--primary:active,\n.el-button--primary:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain:hover,\n.el-button--primary.is-plain:active,\n.el-button--primary.is-plain:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled:hover,\n.el-button--primary.is-plain.is-disabled:active,\n.el-button--primary.is-plain.is-disabled:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled:hover,\n.el-button--primary.is-disabled:active,\n.el-button--primary.is-disabled:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default:hover,\n.el-button--default:active,\n.el-button--default:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text:hover,\n.el-button--text:active,\n.el-button--text:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled {\n  color: #6D7278;\n}\n.operate .el-button + .el-button,\n.operate a + .el-button,\n.operate span + .el-button,\n.operate a + span {\n  margin-left: 0.121212rem;\n}\n.operate span > div {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text {\n  color: #fff;\n}\n.el-loading-mask {\n  z-index: 9998;\n}\n.el-input__inner {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.is-disabled.el-input :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.el-select-dropdown {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label {\n  padding: 0;\n}\n.header-menu-dropdown {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow {\n  display: none;\n}\n.el-table th > .cell {\n  font-weight: bold !important;\n}\n.el-table .cell {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell {\n  padding-left: 0.070707rem;\n}\n.el-table td {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev,\n.el-pagination .btn-next {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span,\n.el-pagination .btn-next span {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog {\n  border-radius: 0.020202rem;\n}\n.el-drawer {\n  overflow: auto;\n}\n.common-confirm-dialog {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog {\n  width: 3.030303rem !important;\n}\n.approval-dialog {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select,\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer {\n  text-align: center;\n}\n.application-search-content-main-fields .active {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label {\n  color: #666666;\n}\n.el-radio__inner:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label {\n  color: #E64100;\n}\n.tox-tinymce-aux {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper {\n  width: 0.757576rem;\n}\n.custom-tooltip {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close,\n.el-select__caret.el-input__icon.el-icon-circle-close:hover,\n.el-input__icon.el-icon-circle-close,\n.el-input__icon.el-icon-circle-close:hover {\n  color: #FB304D;\n}\n*,\n*:before,\n*:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput,\ntextarea {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput:focus {\n  outline: none;\n}\n.edit-main .common-confirm-info div + div {\n  margin-top: 0.025253rem !important;\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.edit-main .content-box .medicalFieldResultDesItem .el-form-item__content {\n  line-height: 0;\n  margin-top: 0.005051rem;\n}\n.edit-main .content-box .medicalFieldResultDes textarea {\n  height: 0.161616rem;\n}\n.edit-main .content-box .cost-center-col {\n  position: relative;\n}\n.edit-main .content-box .cost-center-col .user-cost-center-field {\n  position: absolute;\n  z-index: 1;\n  font-size: 0.070707rem;\n  background-color: #fff;\n  height: 0.141414rem;\n  line-height: 0.151515rem;\n  bottom: 0.040404rem;\n  left: 0.080808rem;\n  width: 1.383838rem;\n  cursor: pointer;\n}\n.edit-main .content-box .cost-center-col .user-cost-center-field-label {\n  width: 1.111111rem;\n  overflow: hidden;\n  display: inline-block;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.edit-main-cost-center .current-user,\n.edit-meeting-plan .current-user {\n  float: right;\n  display: block;\n  color: #fff;\n  width: 0.20202rem;\n  height: 0.121212rem;\n  background: #0066CC;\n  border-radius: 0.060606rem;\n  text-align: center;\n  line-height: 0.121212rem;\n  margin-top: 0.025253rem;\n}\n.edit-meeting-plan .current-user {\n  margin-top: 0.015152rem !important;\n}", ""]);

// exports


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-3ddf5019],\nbody[data-v-3ddf5019] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-3ddf5019]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-3ddf5019] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-3ddf5019] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-3ddf5019] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-3ddf5019],\n  .page-contain[data-v-3ddf5019],\n  .page-submenu[data-v-3ddf5019] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-3ddf5019] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-3ddf5019] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-3ddf5019] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-3ddf5019] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-3ddf5019] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-3ddf5019] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-3ddf5019] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-3ddf5019] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-3ddf5019],\n  .page-submenu[data-v-3ddf5019] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-3ddf5019] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-3ddf5019] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-3ddf5019] {\n    width: 76.3vw;\n}\n.v-main[data-v-3ddf5019] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-3ddf5019] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-3ddf5019] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-3ddf5019] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-3ddf5019] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-3ddf5019] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-3ddf5019] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-3ddf5019],\n  .page-submenu[data-v-3ddf5019] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-3ddf5019] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-3ddf5019] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-3ddf5019] {\n    width: 76.3vw;\n}\n.v-main[data-v-3ddf5019] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-3ddf5019] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-3ddf5019] {\n  margin-top: 0.252525rem;\n}\n[data-v-3ddf5019]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-3ddf5019]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-3ddf5019] {\n  text-align: right;\n}\n.aligncenter[data-v-3ddf5019] {\n  text-align: center;\n}\n.alignleft[data-v-3ddf5019] {\n  text-align: left;\n}\n.actiongroupborder[data-v-3ddf5019] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-3ddf5019] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-3ddf5019] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-3ddf5019] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-3ddf5019] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-3ddf5019] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-3ddf5019] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-3ddf5019] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-3ddf5019] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-3ddf5019] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-3ddf5019] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-3ddf5019] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-3ddf5019] {\n  text-align: center;\n}\n.alignleft[data-v-3ddf5019] {\n  text-align: left;\n}\n.alignright[data-v-3ddf5019] {\n  text-align: right;\n}\n.e2e-container[data-v-3ddf5019] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-3ddf5019] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-3ddf5019] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-3ddf5019] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-3ddf5019] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-3ddf5019] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-3ddf5019] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-3ddf5019] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-3ddf5019] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-3ddf5019] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-3ddf5019] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-3ddf5019],\n.e2e-red-point-left[data-v-3ddf5019] {\n  position: relative;\n}\n.e2e-red-point[data-v-3ddf5019]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-3ddf5019]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-3ddf5019] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-3ddf5019] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-3ddf5019] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-3ddf5019] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-3ddf5019] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-3ddf5019] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-3ddf5019] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-3ddf5019] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-3ddf5019] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-3ddf5019] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-3ddf5019] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-3ddf5019] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-3ddf5019] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-3ddf5019]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-3ddf5019] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-3ddf5019] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-3ddf5019],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-3ddf5019] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-3ddf5019],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-3ddf5019] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-3ddf5019],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-3ddf5019] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-3ddf5019],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-3ddf5019] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-3ddf5019],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-3ddf5019] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-3ddf5019],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-3ddf5019] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-3ddf5019] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-3ddf5019] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-3ddf5019] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-3ddf5019] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-3ddf5019] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-3ddf5019] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-3ddf5019] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-3ddf5019] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-3ddf5019]:hover,\n.el-button--primary[data-v-3ddf5019]:active,\n.el-button--primary[data-v-3ddf5019]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-3ddf5019] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-3ddf5019]:hover,\n.el-button--primary.is-plain[data-v-3ddf5019]:active,\n.el-button--primary.is-plain[data-v-3ddf5019]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-3ddf5019] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-3ddf5019]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-3ddf5019]:active,\n.el-button--primary.is-plain.is-disabled[data-v-3ddf5019]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-3ddf5019] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-3ddf5019]:hover,\n.el-button--primary.is-disabled[data-v-3ddf5019]:active,\n.el-button--primary.is-disabled[data-v-3ddf5019]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-3ddf5019] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-3ddf5019]:hover,\n.el-button--default[data-v-3ddf5019]:active,\n.el-button--default[data-v-3ddf5019]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-3ddf5019] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-3ddf5019]:hover,\n.el-button--text[data-v-3ddf5019]:active,\n.el-button--text[data-v-3ddf5019]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-3ddf5019] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-3ddf5019],\n.operate a + .el-button[data-v-3ddf5019],\n.operate span + .el-button[data-v-3ddf5019],\n.operate a + span[data-v-3ddf5019] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-3ddf5019] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-3ddf5019] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-3ddf5019] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-3ddf5019] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-3ddf5019] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-3ddf5019] {\n  color: #fff;\n}\n.el-loading-mask[data-v-3ddf5019] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-3ddf5019] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-3ddf5019]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-3ddf5019]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-3ddf5019]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-3ddf5019]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-3ddf5019] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-3ddf5019] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-3ddf5019] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-3ddf5019] {\n  color: #999;\n}\n.el-select-dropdown[data-v-3ddf5019] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-3ddf5019] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-3ddf5019] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-3ddf5019] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-3ddf5019] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-3ddf5019] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-3ddf5019] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-3ddf5019]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-3ddf5019] {\n  display: none;\n}\n.el-table th > .cell[data-v-3ddf5019] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-3ddf5019] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-3ddf5019] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-3ddf5019] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-3ddf5019]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-3ddf5019]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-3ddf5019] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-3ddf5019] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-3ddf5019] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-3ddf5019] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-3ddf5019] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-3ddf5019] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-3ddf5019] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-3ddf5019] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-3ddf5019],\n.el-pagination .btn-next[data-v-3ddf5019] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-3ddf5019],\n.el-pagination .btn-next span[data-v-3ddf5019] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-3ddf5019] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-3ddf5019] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-3ddf5019] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-3ddf5019] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-3ddf5019] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-3ddf5019] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-3ddf5019] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-3ddf5019] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-3ddf5019] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-3ddf5019] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-3ddf5019] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-3ddf5019] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-3ddf5019] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-3ddf5019] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-3ddf5019] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-3ddf5019] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-3ddf5019] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-3ddf5019] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-3ddf5019] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-3ddf5019] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-3ddf5019] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-3ddf5019] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-3ddf5019] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-3ddf5019] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-3ddf5019] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-3ddf5019] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-3ddf5019] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-3ddf5019] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-3ddf5019] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-3ddf5019]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-3ddf5019] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-3ddf5019] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-3ddf5019] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-3ddf5019] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-3ddf5019] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-3ddf5019] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-3ddf5019] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-3ddf5019] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-3ddf5019] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-3ddf5019] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-3ddf5019] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-3ddf5019],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-3ddf5019] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-3ddf5019] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-3ddf5019] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-3ddf5019] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-3ddf5019] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-3ddf5019] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-3ddf5019] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-3ddf5019] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-3ddf5019] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-3ddf5019] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-3ddf5019] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-3ddf5019] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-3ddf5019] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-3ddf5019] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-3ddf5019] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-3ddf5019] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-3ddf5019] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-3ddf5019] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-3ddf5019] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-3ddf5019] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-3ddf5019] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-3ddf5019] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-3ddf5019] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-3ddf5019] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-3ddf5019] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-3ddf5019] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-3ddf5019] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-3ddf5019] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-3ddf5019] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-3ddf5019]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-3ddf5019] {\n  color: #666666;\n}\n.el-radio__inner[data-v-3ddf5019]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-3ddf5019] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-3ddf5019] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-3ddf5019] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-3ddf5019] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-3ddf5019] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-3ddf5019] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-3ddf5019] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-3ddf5019] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-3ddf5019],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-3ddf5019]:hover,\n.el-input__icon.el-icon-circle-close[data-v-3ddf5019],\n.el-input__icon.el-icon-circle-close[data-v-3ddf5019]:hover {\n  color: #FB304D;\n}\n*[data-v-3ddf5019],\n*[data-v-3ddf5019]:before,\n*[data-v-3ddf5019]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-3ddf5019],\ntextarea[data-v-3ddf5019] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-3ddf5019]:focus {\n  outline: none;\n}\n.page-contain .page-contain-tab[data-v-3ddf5019] {\n  padding: 0 0.282828rem 0.161616rem 0.282828rem;\n  margin-bottom: 0.121212rem;\n}\n.page-contain .page-contain-tab .recipientSocietyOrHospital-text span[data-v-3ddf5019] {\n  color: #0B41CD;\n}\n.page-contain .page-contain-tab .recipientSociety-input[data-v-3ddf5019] {\n  padding-top: 0.040404rem !important;\n}\n.page-contain .page-contain-tab .more-tab[data-v-3ddf5019] {\n  background: #F6F6F6;\n  border-radius: 0.010101rem;\n  width: 3.959596rem;\n  margin-top: 0.040404rem !important;\n  margin-left: -0.080808rem !important;\n  padding-left: 0.080808rem !important;\n  padding-top: 0.080808rem !important;\n  padding-bottom: 0.060606rem !important;\n}\n.page-contain .page-contain-tab .more-tab-div[data-v-3ddf5019] {\n  margin-top: 0.080808rem;\n}\n.bottom-info[data-v-3ddf5019] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: fixed;\n  background-color: #fff;\n  width: 100%;\n  left: 0;\n  height: 0.222222rem;\n  -webkit-box-shadow: -0.005051rem 0 0.020202rem 0 rgba(51, 51, 51, 0.35);\n          box-shadow: -0.005051rem 0 0.020202rem 0 rgba(51, 51, 51, 0.35);\n  bottom: 0;\n  z-index: 1000;\n}\n.bottom-info-info[data-v-3ddf5019] {\n  margin-left: 0.606061rem;\n  line-height: 0.222222rem;\n}\n.bottom-info-operate[data-v-3ddf5019] {\n  position: absolute;\n  right: 0.606061rem;\n  line-height: 0.232323rem;\n}\n.meeting-place-tip[data-v-3ddf5019] {\n  font-size: 0.060606rem;\n  color: #909399;\n  line-height: 1.5;\n  white-space: nowrap;\n}\n.col-add-remove[data-v-3ddf5019] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.operate-add-remove[data-v-3ddf5019] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 0.10101rem;\n  margin: 0.191919rem 0 0 0.050505rem;\n}\n.operate-add-remove .icon-tianjia1[data-v-3ddf5019] {\n  color: #008748;\n}\n.operate-add-remove .icon-shanjian[data-v-3ddf5019] {\n  color: #E40030;\n}\n.operate-add-remove i[data-v-3ddf5019] {\n  cursor: pointer;\n  height: 0.212121rem;\n  line-height: 0.212121rem;\n}\n.operate-add-remove i + i[data-v-3ddf5019] {\n  margin-left: 0.050505rem;\n}\n.edit-meeting-plan[data-v-3ddf5019] {\n  padding: 0;\n  margin-bottom: 0.429293rem;\n}\n.edit-meeting-plan .edit-form-title[data-v-3ddf5019] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.edit-meeting-plan .el-form.el-form--label-top .el-row[data-v-3ddf5019] {\n  padding: 0.121212rem 0 0 0;\n}\n.edit-meeting-plan .el-form.el-form--label-top .el-row .col-full[data-v-3ddf5019] {\n  width: 5.494949rem;\n}\n.edit-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-input__inner[data-v-3ddf5019] {\n  width: 5.494949rem;\n}\n.edit-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-textarea__inner[data-v-3ddf5019] {\n  height: 0.555556rem;\n}\n.edit-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-form-item__label[data-v-3ddf5019] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.edit-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-form-item__content[data-v-3ddf5019] {\n  padding-top: 0.010101rem;\n}\n.edit-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-form-item__content .el-select[data-v-3ddf5019],\n.edit-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-form-item__content .el-input[data-v-3ddf5019],\n.edit-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-form-item__content .el-input-number[data-v-3ddf5019] {\n  width: 1.616162rem;\n}\n.edit-meeting-plan .el-form.el-form--label-top .el-row .el-col[data-v-3ddf5019] {\n  width: 1.616162rem;\n}\n.edit-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-3ddf5019] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.edit-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-3ddf5019] {\n  padding-top: 0.010101rem;\n}\n.edit-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-3ddf5019],\n.edit-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-3ddf5019],\n.edit-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input-number[data-v-3ddf5019] {\n  width: 1.616162rem;\n}\n.edit-meeting-plan .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-3ddf5019] {\n  margin-left: 0.323232rem;\n}\n.edit-meeting-plan .el-form.el-form--label-top .col-no-3[data-v-3ddf5019] {\n  margin-left: 3.878788rem;\n}\n.edit-meeting-plan .el-form.el-form--label-right .el-row[data-v-3ddf5019] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}", ""]);

// exports


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-3f6fd5ea],\nbody[data-v-3f6fd5ea] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-3f6fd5ea]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-3f6fd5ea] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-3f6fd5ea] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-3f6fd5ea] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-3f6fd5ea],\n  .page-contain[data-v-3f6fd5ea],\n  .page-submenu[data-v-3f6fd5ea] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-3f6fd5ea] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-3f6fd5ea] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-3f6fd5ea] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-3f6fd5ea] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-3f6fd5ea] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-3f6fd5ea] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-3f6fd5ea] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-3f6fd5ea] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-3f6fd5ea],\n  .page-submenu[data-v-3f6fd5ea] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-3f6fd5ea] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-3f6fd5ea] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-3f6fd5ea] {\n    width: 76.3vw;\n}\n.v-main[data-v-3f6fd5ea] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-3f6fd5ea] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-3f6fd5ea] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-3f6fd5ea] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-3f6fd5ea] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-3f6fd5ea] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-3f6fd5ea] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-3f6fd5ea],\n  .page-submenu[data-v-3f6fd5ea] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-3f6fd5ea] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-3f6fd5ea] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-3f6fd5ea] {\n    width: 76.3vw;\n}\n.v-main[data-v-3f6fd5ea] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-3f6fd5ea] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-3f6fd5ea] {\n  margin-top: 0.252525rem;\n}\n[data-v-3f6fd5ea]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-3f6fd5ea]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-3f6fd5ea] {\n  text-align: right;\n}\n.aligncenter[data-v-3f6fd5ea] {\n  text-align: center;\n}\n.alignleft[data-v-3f6fd5ea] {\n  text-align: left;\n}\n.actiongroupborder[data-v-3f6fd5ea] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-3f6fd5ea] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-3f6fd5ea] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-3f6fd5ea] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-3f6fd5ea] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-3f6fd5ea] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-3f6fd5ea] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-3f6fd5ea] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-3f6fd5ea] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-3f6fd5ea] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-3f6fd5ea] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-3f6fd5ea] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-3f6fd5ea] {\n  text-align: center;\n}\n.alignleft[data-v-3f6fd5ea] {\n  text-align: left;\n}\n.alignright[data-v-3f6fd5ea] {\n  text-align: right;\n}\n.e2e-container[data-v-3f6fd5ea] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-3f6fd5ea] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-3f6fd5ea] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-3f6fd5ea] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-3f6fd5ea] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-3f6fd5ea] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-3f6fd5ea] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-3f6fd5ea] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-3f6fd5ea] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-3f6fd5ea] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-3f6fd5ea] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-3f6fd5ea],\n.e2e-red-point-left[data-v-3f6fd5ea] {\n  position: relative;\n}\n.e2e-red-point[data-v-3f6fd5ea]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-3f6fd5ea]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-3f6fd5ea] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-3f6fd5ea] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-3f6fd5ea] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-3f6fd5ea] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-3f6fd5ea] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-3f6fd5ea] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-3f6fd5ea] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-3f6fd5ea] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-3f6fd5ea] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-3f6fd5ea] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-3f6fd5ea] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-3f6fd5ea] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-3f6fd5ea] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-3f6fd5ea]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-3f6fd5ea] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-3f6fd5ea] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-3f6fd5ea],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-3f6fd5ea] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-3f6fd5ea],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-3f6fd5ea] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-3f6fd5ea],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-3f6fd5ea] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-3f6fd5ea],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-3f6fd5ea] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-3f6fd5ea],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-3f6fd5ea] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-3f6fd5ea],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-3f6fd5ea] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-3f6fd5ea] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-3f6fd5ea] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-3f6fd5ea] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-3f6fd5ea] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-3f6fd5ea] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-3f6fd5ea] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-3f6fd5ea] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-3f6fd5ea] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-3f6fd5ea]:hover,\n.el-button--primary[data-v-3f6fd5ea]:active,\n.el-button--primary[data-v-3f6fd5ea]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-3f6fd5ea] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-3f6fd5ea]:hover,\n.el-button--primary.is-plain[data-v-3f6fd5ea]:active,\n.el-button--primary.is-plain[data-v-3f6fd5ea]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-3f6fd5ea] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-3f6fd5ea]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-3f6fd5ea]:active,\n.el-button--primary.is-plain.is-disabled[data-v-3f6fd5ea]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-3f6fd5ea] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-3f6fd5ea]:hover,\n.el-button--primary.is-disabled[data-v-3f6fd5ea]:active,\n.el-button--primary.is-disabled[data-v-3f6fd5ea]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-3f6fd5ea] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-3f6fd5ea]:hover,\n.el-button--default[data-v-3f6fd5ea]:active,\n.el-button--default[data-v-3f6fd5ea]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-3f6fd5ea] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-3f6fd5ea]:hover,\n.el-button--text[data-v-3f6fd5ea]:active,\n.el-button--text[data-v-3f6fd5ea]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-3f6fd5ea] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-3f6fd5ea],\n.operate a + .el-button[data-v-3f6fd5ea],\n.operate span + .el-button[data-v-3f6fd5ea],\n.operate a + span[data-v-3f6fd5ea] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-3f6fd5ea] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-3f6fd5ea] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-3f6fd5ea] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-3f6fd5ea] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-3f6fd5ea] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-3f6fd5ea] {\n  color: #fff;\n}\n.el-loading-mask[data-v-3f6fd5ea] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-3f6fd5ea] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-3f6fd5ea]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-3f6fd5ea]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-3f6fd5ea]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-3f6fd5ea]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-3f6fd5ea] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-3f6fd5ea] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-3f6fd5ea] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-3f6fd5ea] {\n  color: #999;\n}\n.el-select-dropdown[data-v-3f6fd5ea] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-3f6fd5ea] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-3f6fd5ea] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-3f6fd5ea] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-3f6fd5ea] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-3f6fd5ea] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-3f6fd5ea] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-3f6fd5ea]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-3f6fd5ea] {\n  display: none;\n}\n.el-table th > .cell[data-v-3f6fd5ea] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-3f6fd5ea] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-3f6fd5ea] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-3f6fd5ea] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-3f6fd5ea]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-3f6fd5ea]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-3f6fd5ea] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-3f6fd5ea] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-3f6fd5ea] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-3f6fd5ea] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-3f6fd5ea] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-3f6fd5ea] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-3f6fd5ea] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-3f6fd5ea] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-3f6fd5ea],\n.el-pagination .btn-next[data-v-3f6fd5ea] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-3f6fd5ea],\n.el-pagination .btn-next span[data-v-3f6fd5ea] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-3f6fd5ea] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-3f6fd5ea] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-3f6fd5ea] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-3f6fd5ea] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-3f6fd5ea] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-3f6fd5ea] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-3f6fd5ea] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-3f6fd5ea] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-3f6fd5ea] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-3f6fd5ea] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-3f6fd5ea] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-3f6fd5ea] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-3f6fd5ea] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-3f6fd5ea] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-3f6fd5ea] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-3f6fd5ea] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-3f6fd5ea] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-3f6fd5ea] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-3f6fd5ea] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-3f6fd5ea] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-3f6fd5ea] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-3f6fd5ea] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-3f6fd5ea] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-3f6fd5ea] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-3f6fd5ea] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-3f6fd5ea] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-3f6fd5ea] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-3f6fd5ea] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-3f6fd5ea] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-3f6fd5ea]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-3f6fd5ea] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-3f6fd5ea] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-3f6fd5ea] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-3f6fd5ea] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-3f6fd5ea] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-3f6fd5ea] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-3f6fd5ea] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-3f6fd5ea] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-3f6fd5ea] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-3f6fd5ea] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-3f6fd5ea] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-3f6fd5ea],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-3f6fd5ea] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-3f6fd5ea] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-3f6fd5ea] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-3f6fd5ea] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-3f6fd5ea] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-3f6fd5ea] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-3f6fd5ea] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-3f6fd5ea] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-3f6fd5ea] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-3f6fd5ea] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-3f6fd5ea] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-3f6fd5ea] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-3f6fd5ea] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-3f6fd5ea] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-3f6fd5ea] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-3f6fd5ea] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-3f6fd5ea] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-3f6fd5ea] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-3f6fd5ea] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-3f6fd5ea] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-3f6fd5ea] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-3f6fd5ea] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-3f6fd5ea] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-3f6fd5ea] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-3f6fd5ea] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-3f6fd5ea] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-3f6fd5ea] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-3f6fd5ea] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-3f6fd5ea] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-3f6fd5ea]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-3f6fd5ea] {\n  color: #666666;\n}\n.el-radio__inner[data-v-3f6fd5ea]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-3f6fd5ea] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-3f6fd5ea] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-3f6fd5ea] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-3f6fd5ea] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-3f6fd5ea] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-3f6fd5ea] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-3f6fd5ea] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-3f6fd5ea] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-3f6fd5ea],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-3f6fd5ea]:hover,\n.el-input__icon.el-icon-circle-close[data-v-3f6fd5ea],\n.el-input__icon.el-icon-circle-close[data-v-3f6fd5ea]:hover {\n  color: #FB304D;\n}\n*[data-v-3f6fd5ea],\n*[data-v-3f6fd5ea]:before,\n*[data-v-3f6fd5ea]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-3f6fd5ea],\ntextarea[data-v-3f6fd5ea] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-3f6fd5ea]:focus {\n  outline: none;\n}\n.user-container[data-v-3f6fd5ea] {\n  padding: 0.242424rem 0.40404rem 0.282828rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.user-container .e2e-form-group[data-v-3f6fd5ea] {\n  width: 2.020202rem;\n}", ""]);

// exports


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-406147de],\nbody[data-v-406147de] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-406147de]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-406147de] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-406147de] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-406147de] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-406147de],\n  .page-contain[data-v-406147de],\n  .page-submenu[data-v-406147de] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-406147de] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-406147de] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-406147de] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-406147de] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-406147de] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-406147de] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-406147de] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-406147de] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-406147de],\n  .page-submenu[data-v-406147de] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-406147de] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-406147de] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-406147de] {\n    width: 76.3vw;\n}\n.v-main[data-v-406147de] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-406147de] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-406147de] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-406147de] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-406147de] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-406147de] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-406147de] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-406147de],\n  .page-submenu[data-v-406147de] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-406147de] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-406147de] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-406147de] {\n    width: 76.3vw;\n}\n.v-main[data-v-406147de] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-406147de] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-406147de] {\n  margin-top: 0.252525rem;\n}\n[data-v-406147de]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-406147de]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-406147de] {\n  text-align: right;\n}\n.aligncenter[data-v-406147de] {\n  text-align: center;\n}\n.alignleft[data-v-406147de] {\n  text-align: left;\n}\n.actiongroupborder[data-v-406147de] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-406147de] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-406147de] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-406147de] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-406147de] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-406147de] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-406147de] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-406147de] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-406147de] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-406147de] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-406147de] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-406147de] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-406147de] {\n  text-align: center;\n}\n.alignleft[data-v-406147de] {\n  text-align: left;\n}\n.alignright[data-v-406147de] {\n  text-align: right;\n}\n.e2e-container[data-v-406147de] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-406147de] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-406147de] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-406147de] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-406147de] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-406147de] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-406147de] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-406147de] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-406147de] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-406147de] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-406147de] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-406147de],\n.e2e-red-point-left[data-v-406147de] {\n  position: relative;\n}\n.e2e-red-point[data-v-406147de]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-406147de]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-406147de] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-406147de] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-406147de] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-406147de] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-406147de] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-406147de] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-406147de] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-406147de] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-406147de] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-406147de] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-406147de] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-406147de] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-406147de] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-406147de]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-406147de] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-406147de] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-406147de],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-406147de] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-406147de],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-406147de] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-406147de],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-406147de] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-406147de],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-406147de] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-406147de],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-406147de] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-406147de],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-406147de] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-406147de] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-406147de] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-406147de] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-406147de] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-406147de] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-406147de] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-406147de] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-406147de] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-406147de]:hover,\n.el-button--primary[data-v-406147de]:active,\n.el-button--primary[data-v-406147de]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-406147de] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-406147de]:hover,\n.el-button--primary.is-plain[data-v-406147de]:active,\n.el-button--primary.is-plain[data-v-406147de]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-406147de] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-406147de]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-406147de]:active,\n.el-button--primary.is-plain.is-disabled[data-v-406147de]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-406147de] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-406147de]:hover,\n.el-button--primary.is-disabled[data-v-406147de]:active,\n.el-button--primary.is-disabled[data-v-406147de]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-406147de] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-406147de]:hover,\n.el-button--default[data-v-406147de]:active,\n.el-button--default[data-v-406147de]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-406147de] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-406147de]:hover,\n.el-button--text[data-v-406147de]:active,\n.el-button--text[data-v-406147de]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-406147de] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-406147de],\n.operate a + .el-button[data-v-406147de],\n.operate span + .el-button[data-v-406147de],\n.operate a + span[data-v-406147de] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-406147de] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-406147de] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-406147de] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-406147de] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-406147de] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-406147de] {\n  color: #fff;\n}\n.el-loading-mask[data-v-406147de] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-406147de] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-406147de]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-406147de]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-406147de]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-406147de]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-406147de] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-406147de] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-406147de] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-406147de] {\n  color: #999;\n}\n.el-select-dropdown[data-v-406147de] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-406147de] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-406147de] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-406147de] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-406147de] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-406147de] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-406147de] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-406147de]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-406147de] {\n  display: none;\n}\n.el-table th > .cell[data-v-406147de] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-406147de] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-406147de] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-406147de] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-406147de]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-406147de]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-406147de] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-406147de] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-406147de] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-406147de] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-406147de] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-406147de] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-406147de] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-406147de] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-406147de],\n.el-pagination .btn-next[data-v-406147de] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-406147de],\n.el-pagination .btn-next span[data-v-406147de] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-406147de] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-406147de] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-406147de] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-406147de] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-406147de] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-406147de] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-406147de] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-406147de] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-406147de] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-406147de] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-406147de] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-406147de] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-406147de] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-406147de] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-406147de] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-406147de] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-406147de] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-406147de] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-406147de] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-406147de] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-406147de] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-406147de] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-406147de] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-406147de] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-406147de] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-406147de] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-406147de] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-406147de] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-406147de] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-406147de]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-406147de] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-406147de] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-406147de] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-406147de] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-406147de] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-406147de] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-406147de] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-406147de] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-406147de] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-406147de] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-406147de] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-406147de],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-406147de] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-406147de] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-406147de] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-406147de] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-406147de] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-406147de] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-406147de] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-406147de] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-406147de] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-406147de] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-406147de] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-406147de] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-406147de] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-406147de] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-406147de] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-406147de] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-406147de] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-406147de] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-406147de] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-406147de] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-406147de] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-406147de] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-406147de] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-406147de] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-406147de] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-406147de] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-406147de] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-406147de] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-406147de] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-406147de]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-406147de] {\n  color: #666666;\n}\n.el-radio__inner[data-v-406147de]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-406147de] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-406147de] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-406147de] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-406147de] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-406147de] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-406147de] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-406147de] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-406147de] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-406147de],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-406147de]:hover,\n.el-input__icon.el-icon-circle-close[data-v-406147de],\n.el-input__icon.el-icon-circle-close[data-v-406147de]:hover {\n  color: #FB304D;\n}\n*[data-v-406147de],\n*[data-v-406147de]:before,\n*[data-v-406147de]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-406147de],\ntextarea[data-v-406147de] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-406147de]:focus {\n  outline: none;\n}\n.approval-dialog .iconfont[data-v-406147de] {\n  font-size: 0.121212rem;\n}\n.approval-dialog .icon-shenpijujue[data-v-406147de] {\n  color: #e40030;\n}\n.approval-dialog .icon-shenpitongguo[data-v-406147de] {\n  color: #008748;\n}\n.approval-dialog .approval-info[data-v-406147de] {\n  text-align: center;\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.approval-dialog .approval-info span[data-v-406147de] {\n  vertical-align: top;\n  height: 0.141414rem;\n  line-height: 0.141414rem;\n}\n.approval-dialog .apprvoal-reason[data-v-406147de] {\n  margin: 0.080808rem auto 0 auto;\n  width: 1.818182rem;\n}\n.approval-dialog .apprvoal-reason textarea[data-v-406147de] {\n  height: 0.909091rem;\n}", ""]);

// exports


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-415a0751],\nbody[data-v-415a0751] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-415a0751]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-415a0751] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-415a0751] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-415a0751] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-415a0751],\n  .page-contain[data-v-415a0751],\n  .page-submenu[data-v-415a0751] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-415a0751] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-415a0751] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-415a0751] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-415a0751] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-415a0751] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-415a0751] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-415a0751] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-415a0751] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-415a0751],\n  .page-submenu[data-v-415a0751] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-415a0751] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-415a0751] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-415a0751] {\n    width: 76.3vw;\n}\n.v-main[data-v-415a0751] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-415a0751] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-415a0751] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-415a0751] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-415a0751] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-415a0751] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-415a0751] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-415a0751],\n  .page-submenu[data-v-415a0751] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-415a0751] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-415a0751] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-415a0751] {\n    width: 76.3vw;\n}\n.v-main[data-v-415a0751] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-415a0751] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-415a0751] {\n  margin-top: 0.252525rem;\n}\n[data-v-415a0751]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-415a0751]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-415a0751] {\n  text-align: right;\n}\n.aligncenter[data-v-415a0751] {\n  text-align: center;\n}\n.alignleft[data-v-415a0751] {\n  text-align: left;\n}\n.actiongroupborder[data-v-415a0751] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-415a0751] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-415a0751] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-415a0751] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-415a0751] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-415a0751] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-415a0751] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-415a0751] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-415a0751] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-415a0751] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-415a0751] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-415a0751] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-415a0751] {\n  text-align: center;\n}\n.alignleft[data-v-415a0751] {\n  text-align: left;\n}\n.alignright[data-v-415a0751] {\n  text-align: right;\n}\n.e2e-container[data-v-415a0751] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-415a0751] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-415a0751] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-415a0751] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-415a0751] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-415a0751] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-415a0751] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-415a0751] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-415a0751] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-415a0751] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-415a0751] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-415a0751],\n.e2e-red-point-left[data-v-415a0751] {\n  position: relative;\n}\n.e2e-red-point[data-v-415a0751]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-415a0751]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-415a0751] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-415a0751] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-415a0751] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-415a0751] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-415a0751] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-415a0751] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-415a0751] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-415a0751] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-415a0751] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-415a0751] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-415a0751] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-415a0751] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-415a0751] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-415a0751]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-415a0751] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-415a0751] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-415a0751],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-415a0751] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-415a0751],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-415a0751] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-415a0751],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-415a0751] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-415a0751],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-415a0751] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-415a0751],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-415a0751] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-415a0751],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-415a0751] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-415a0751] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-415a0751] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-415a0751] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-415a0751] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-415a0751] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-415a0751] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-415a0751] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-415a0751] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-415a0751]:hover,\n.el-button--primary[data-v-415a0751]:active,\n.el-button--primary[data-v-415a0751]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-415a0751] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-415a0751]:hover,\n.el-button--primary.is-plain[data-v-415a0751]:active,\n.el-button--primary.is-plain[data-v-415a0751]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-415a0751] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-415a0751]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-415a0751]:active,\n.el-button--primary.is-plain.is-disabled[data-v-415a0751]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-415a0751] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-415a0751]:hover,\n.el-button--primary.is-disabled[data-v-415a0751]:active,\n.el-button--primary.is-disabled[data-v-415a0751]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-415a0751] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-415a0751]:hover,\n.el-button--default[data-v-415a0751]:active,\n.el-button--default[data-v-415a0751]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-415a0751] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-415a0751]:hover,\n.el-button--text[data-v-415a0751]:active,\n.el-button--text[data-v-415a0751]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-415a0751] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-415a0751],\n.operate a + .el-button[data-v-415a0751],\n.operate span + .el-button[data-v-415a0751],\n.operate a + span[data-v-415a0751] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-415a0751] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-415a0751] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-415a0751] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-415a0751] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-415a0751] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-415a0751] {\n  color: #fff;\n}\n.el-loading-mask[data-v-415a0751] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-415a0751] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-415a0751]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-415a0751]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-415a0751]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-415a0751]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-415a0751] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-415a0751] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-415a0751] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-415a0751] {\n  color: #999;\n}\n.el-select-dropdown[data-v-415a0751] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-415a0751] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-415a0751] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-415a0751] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-415a0751] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-415a0751] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-415a0751] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-415a0751]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-415a0751] {\n  display: none;\n}\n.el-table th > .cell[data-v-415a0751] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-415a0751] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-415a0751] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-415a0751] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-415a0751]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-415a0751]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-415a0751] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-415a0751] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-415a0751] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-415a0751] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-415a0751] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-415a0751] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-415a0751] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-415a0751] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-415a0751],\n.el-pagination .btn-next[data-v-415a0751] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-415a0751],\n.el-pagination .btn-next span[data-v-415a0751] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-415a0751] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-415a0751] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-415a0751] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-415a0751] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-415a0751] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-415a0751] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-415a0751] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-415a0751] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-415a0751] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-415a0751] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-415a0751] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-415a0751] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-415a0751] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-415a0751] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-415a0751] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-415a0751] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-415a0751] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-415a0751] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-415a0751] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-415a0751] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-415a0751] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-415a0751] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-415a0751] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-415a0751] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-415a0751] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-415a0751] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-415a0751] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-415a0751] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-415a0751] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-415a0751]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-415a0751] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-415a0751] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-415a0751] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-415a0751] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-415a0751] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-415a0751] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-415a0751] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-415a0751] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-415a0751] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-415a0751] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-415a0751] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-415a0751],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-415a0751] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-415a0751] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-415a0751] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-415a0751] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-415a0751] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-415a0751] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-415a0751] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-415a0751] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-415a0751] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-415a0751] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-415a0751] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-415a0751] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-415a0751] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-415a0751] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-415a0751] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-415a0751] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-415a0751] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-415a0751] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-415a0751] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-415a0751] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-415a0751] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-415a0751] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-415a0751] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-415a0751] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-415a0751] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-415a0751] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-415a0751] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-415a0751] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-415a0751] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-415a0751]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-415a0751] {\n  color: #666666;\n}\n.el-radio__inner[data-v-415a0751]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-415a0751] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-415a0751] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-415a0751] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-415a0751] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-415a0751] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-415a0751] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-415a0751] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-415a0751] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-415a0751],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-415a0751]:hover,\n.el-input__icon.el-icon-circle-close[data-v-415a0751],\n.el-input__icon.el-icon-circle-close[data-v-415a0751]:hover {\n  color: #FB304D;\n}\n*[data-v-415a0751],\n*[data-v-415a0751]:before,\n*[data-v-415a0751]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-415a0751],\ntextarea[data-v-415a0751] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-415a0751]:focus {\n  outline: none;\n}\n.tableau[data-v-415a0751] {\n  overflow-x: hidden;\n}", ""]);

// exports


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-421f5da2],\nbody[data-v-421f5da2] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-421f5da2]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-421f5da2] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-421f5da2] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-421f5da2] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-421f5da2],\n  .page-contain[data-v-421f5da2],\n  .page-submenu[data-v-421f5da2] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-421f5da2] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-421f5da2] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-421f5da2] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-421f5da2] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-421f5da2] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-421f5da2] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-421f5da2] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-421f5da2] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-421f5da2],\n  .page-submenu[data-v-421f5da2] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-421f5da2] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-421f5da2] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-421f5da2] {\n    width: 76.3vw;\n}\n.v-main[data-v-421f5da2] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-421f5da2] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-421f5da2] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-421f5da2] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-421f5da2] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-421f5da2] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-421f5da2] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-421f5da2],\n  .page-submenu[data-v-421f5da2] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-421f5da2] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-421f5da2] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-421f5da2] {\n    width: 76.3vw;\n}\n.v-main[data-v-421f5da2] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-421f5da2] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-421f5da2] {\n  margin-top: 0.252525rem;\n}\n[data-v-421f5da2]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-421f5da2]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-421f5da2] {\n  text-align: right;\n}\n.aligncenter[data-v-421f5da2] {\n  text-align: center;\n}\n.alignleft[data-v-421f5da2] {\n  text-align: left;\n}\n.actiongroupborder[data-v-421f5da2] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-421f5da2] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-421f5da2] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-421f5da2] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-421f5da2] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-421f5da2] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-421f5da2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-421f5da2] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-421f5da2] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-421f5da2] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-421f5da2] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-421f5da2] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-421f5da2] {\n  text-align: center;\n}\n.alignleft[data-v-421f5da2] {\n  text-align: left;\n}\n.alignright[data-v-421f5da2] {\n  text-align: right;\n}\n.e2e-container[data-v-421f5da2] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-421f5da2] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-421f5da2] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-421f5da2] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-421f5da2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-421f5da2] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-421f5da2] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-421f5da2] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-421f5da2] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-421f5da2] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-421f5da2] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-421f5da2],\n.e2e-red-point-left[data-v-421f5da2] {\n  position: relative;\n}\n.e2e-red-point[data-v-421f5da2]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-421f5da2]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-421f5da2] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-421f5da2] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-421f5da2] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-421f5da2] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-421f5da2] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-421f5da2] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-421f5da2] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-421f5da2] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-421f5da2] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-421f5da2] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-421f5da2] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-421f5da2] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-421f5da2] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-421f5da2]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-421f5da2] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-421f5da2] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-421f5da2],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-421f5da2] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-421f5da2],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-421f5da2] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-421f5da2],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-421f5da2] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-421f5da2],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-421f5da2] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-421f5da2],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-421f5da2] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-421f5da2],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-421f5da2] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-421f5da2] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-421f5da2] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-421f5da2] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-421f5da2] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-421f5da2] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-421f5da2] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-421f5da2] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-421f5da2] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-421f5da2]:hover,\n.el-button--primary[data-v-421f5da2]:active,\n.el-button--primary[data-v-421f5da2]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-421f5da2] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-421f5da2]:hover,\n.el-button--primary.is-plain[data-v-421f5da2]:active,\n.el-button--primary.is-plain[data-v-421f5da2]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-421f5da2] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-421f5da2]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-421f5da2]:active,\n.el-button--primary.is-plain.is-disabled[data-v-421f5da2]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-421f5da2] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-421f5da2]:hover,\n.el-button--primary.is-disabled[data-v-421f5da2]:active,\n.el-button--primary.is-disabled[data-v-421f5da2]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-421f5da2] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-421f5da2]:hover,\n.el-button--default[data-v-421f5da2]:active,\n.el-button--default[data-v-421f5da2]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-421f5da2] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-421f5da2]:hover,\n.el-button--text[data-v-421f5da2]:active,\n.el-button--text[data-v-421f5da2]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-421f5da2] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-421f5da2],\n.operate a + .el-button[data-v-421f5da2],\n.operate span + .el-button[data-v-421f5da2],\n.operate a + span[data-v-421f5da2] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-421f5da2] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-421f5da2] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-421f5da2] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-421f5da2] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-421f5da2] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-421f5da2] {\n  color: #fff;\n}\n.el-loading-mask[data-v-421f5da2] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-421f5da2] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-421f5da2]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-421f5da2]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-421f5da2]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-421f5da2]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-421f5da2] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-421f5da2] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-421f5da2] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-421f5da2] {\n  color: #999;\n}\n.el-select-dropdown[data-v-421f5da2] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-421f5da2] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-421f5da2] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-421f5da2] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-421f5da2] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-421f5da2] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-421f5da2] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-421f5da2]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-421f5da2] {\n  display: none;\n}\n.el-table th > .cell[data-v-421f5da2] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-421f5da2] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-421f5da2] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-421f5da2] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-421f5da2]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-421f5da2]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-421f5da2] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-421f5da2] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-421f5da2] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-421f5da2] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-421f5da2] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-421f5da2] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-421f5da2] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-421f5da2] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-421f5da2],\n.el-pagination .btn-next[data-v-421f5da2] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-421f5da2],\n.el-pagination .btn-next span[data-v-421f5da2] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-421f5da2] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-421f5da2] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-421f5da2] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-421f5da2] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-421f5da2] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-421f5da2] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-421f5da2] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-421f5da2] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-421f5da2] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-421f5da2] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-421f5da2] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-421f5da2] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-421f5da2] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-421f5da2] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-421f5da2] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-421f5da2] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-421f5da2] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-421f5da2] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-421f5da2] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-421f5da2] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-421f5da2] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-421f5da2] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-421f5da2] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-421f5da2] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-421f5da2] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-421f5da2] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-421f5da2] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-421f5da2] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-421f5da2] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-421f5da2]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-421f5da2] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-421f5da2] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-421f5da2] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-421f5da2] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-421f5da2] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-421f5da2] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-421f5da2] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-421f5da2] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-421f5da2] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-421f5da2] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-421f5da2] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-421f5da2],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-421f5da2] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-421f5da2] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-421f5da2] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-421f5da2] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-421f5da2] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-421f5da2] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-421f5da2] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-421f5da2] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-421f5da2] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-421f5da2] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-421f5da2] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-421f5da2] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-421f5da2] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-421f5da2] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-421f5da2] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-421f5da2] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-421f5da2] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-421f5da2] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-421f5da2] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-421f5da2] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-421f5da2] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-421f5da2] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-421f5da2] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-421f5da2] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-421f5da2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-421f5da2] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-421f5da2] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-421f5da2] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-421f5da2] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-421f5da2]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-421f5da2] {\n  color: #666666;\n}\n.el-radio__inner[data-v-421f5da2]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-421f5da2] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-421f5da2] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-421f5da2] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-421f5da2] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-421f5da2] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-421f5da2] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-421f5da2] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-421f5da2] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-421f5da2],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-421f5da2]:hover,\n.el-input__icon.el-icon-circle-close[data-v-421f5da2],\n.el-input__icon.el-icon-circle-close[data-v-421f5da2]:hover {\n  color: #FB304D;\n}\n*[data-v-421f5da2],\n*[data-v-421f5da2]:before,\n*[data-v-421f5da2]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-421f5da2],\ntextarea[data-v-421f5da2] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-421f5da2]:focus {\n  outline: none;\n}\n.search-content[data-v-421f5da2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 0.111111rem;\n}\n.search-content .search-content-fields .btn-search[data-v-421f5da2] {\n  margin-left: 0.050505rem;\n}\n.operate[data-v-421f5da2] {\n  float: right;\n  margin-bottom: 0.151515rem;\n}", ""]);

// exports


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-454b3b23],\nbody[data-v-454b3b23] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-454b3b23]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-454b3b23] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-454b3b23] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-454b3b23] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-454b3b23],\n  .page-contain[data-v-454b3b23],\n  .page-submenu[data-v-454b3b23] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-454b3b23] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-454b3b23] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-454b3b23] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-454b3b23] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-454b3b23] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-454b3b23] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-454b3b23] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-454b3b23] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-454b3b23],\n  .page-submenu[data-v-454b3b23] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-454b3b23] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-454b3b23] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-454b3b23] {\n    width: 76.3vw;\n}\n.v-main[data-v-454b3b23] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-454b3b23] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-454b3b23] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-454b3b23] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-454b3b23] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-454b3b23] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-454b3b23] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-454b3b23],\n  .page-submenu[data-v-454b3b23] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-454b3b23] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-454b3b23] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-454b3b23] {\n    width: 76.3vw;\n}\n.v-main[data-v-454b3b23] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-454b3b23] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-454b3b23] {\n  margin-top: 0.252525rem;\n}\n[data-v-454b3b23]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-454b3b23]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-454b3b23] {\n  text-align: right;\n}\n.aligncenter[data-v-454b3b23] {\n  text-align: center;\n}\n.alignleft[data-v-454b3b23] {\n  text-align: left;\n}\n.actiongroupborder[data-v-454b3b23] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-454b3b23] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-454b3b23] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-454b3b23] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-454b3b23] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-454b3b23] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-454b3b23] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-454b3b23] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-454b3b23] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-454b3b23] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-454b3b23] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-454b3b23] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-454b3b23] {\n  text-align: center;\n}\n.alignleft[data-v-454b3b23] {\n  text-align: left;\n}\n.alignright[data-v-454b3b23] {\n  text-align: right;\n}\n.e2e-container[data-v-454b3b23] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-454b3b23] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-454b3b23] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-454b3b23] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-454b3b23] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-454b3b23] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-454b3b23] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-454b3b23] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-454b3b23] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-454b3b23] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-454b3b23] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-454b3b23],\n.e2e-red-point-left[data-v-454b3b23] {\n  position: relative;\n}\n.e2e-red-point[data-v-454b3b23]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-454b3b23]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-454b3b23] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-454b3b23] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-454b3b23] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-454b3b23] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-454b3b23] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-454b3b23] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-454b3b23] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-454b3b23] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-454b3b23] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-454b3b23] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-454b3b23] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-454b3b23] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-454b3b23] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-454b3b23]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-454b3b23] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-454b3b23] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-454b3b23],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-454b3b23] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-454b3b23],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-454b3b23] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-454b3b23],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-454b3b23] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-454b3b23],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-454b3b23] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-454b3b23],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-454b3b23] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-454b3b23],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-454b3b23] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-454b3b23] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-454b3b23] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-454b3b23] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-454b3b23] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-454b3b23] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-454b3b23] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-454b3b23] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-454b3b23] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-454b3b23]:hover,\n.el-button--primary[data-v-454b3b23]:active,\n.el-button--primary[data-v-454b3b23]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-454b3b23] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-454b3b23]:hover,\n.el-button--primary.is-plain[data-v-454b3b23]:active,\n.el-button--primary.is-plain[data-v-454b3b23]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-454b3b23] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-454b3b23]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-454b3b23]:active,\n.el-button--primary.is-plain.is-disabled[data-v-454b3b23]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-454b3b23] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-454b3b23]:hover,\n.el-button--primary.is-disabled[data-v-454b3b23]:active,\n.el-button--primary.is-disabled[data-v-454b3b23]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-454b3b23] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-454b3b23]:hover,\n.el-button--default[data-v-454b3b23]:active,\n.el-button--default[data-v-454b3b23]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-454b3b23] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-454b3b23]:hover,\n.el-button--text[data-v-454b3b23]:active,\n.el-button--text[data-v-454b3b23]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-454b3b23] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-454b3b23],\n.operate a + .el-button[data-v-454b3b23],\n.operate span + .el-button[data-v-454b3b23],\n.operate a + span[data-v-454b3b23] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-454b3b23] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-454b3b23] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-454b3b23] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-454b3b23] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-454b3b23] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-454b3b23] {\n  color: #fff;\n}\n.el-loading-mask[data-v-454b3b23] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-454b3b23] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-454b3b23]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-454b3b23]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-454b3b23]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-454b3b23]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-454b3b23] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-454b3b23] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-454b3b23] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-454b3b23] {\n  color: #999;\n}\n.el-select-dropdown[data-v-454b3b23] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-454b3b23] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-454b3b23] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-454b3b23] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-454b3b23] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-454b3b23] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-454b3b23] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-454b3b23]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-454b3b23] {\n  display: none;\n}\n.el-table th > .cell[data-v-454b3b23] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-454b3b23] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-454b3b23] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-454b3b23] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-454b3b23]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-454b3b23]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-454b3b23] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-454b3b23] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-454b3b23] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-454b3b23] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-454b3b23] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-454b3b23] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-454b3b23] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-454b3b23] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-454b3b23],\n.el-pagination .btn-next[data-v-454b3b23] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-454b3b23],\n.el-pagination .btn-next span[data-v-454b3b23] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-454b3b23] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-454b3b23] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-454b3b23] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-454b3b23] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-454b3b23] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-454b3b23] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-454b3b23] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-454b3b23] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-454b3b23] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-454b3b23] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-454b3b23] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-454b3b23] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-454b3b23] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-454b3b23] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-454b3b23] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-454b3b23] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-454b3b23] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-454b3b23] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-454b3b23] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-454b3b23] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-454b3b23] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-454b3b23] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-454b3b23] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-454b3b23] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-454b3b23] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-454b3b23] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-454b3b23] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-454b3b23] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-454b3b23] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-454b3b23]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-454b3b23] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-454b3b23] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-454b3b23] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-454b3b23] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-454b3b23] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-454b3b23] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-454b3b23] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-454b3b23] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-454b3b23] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-454b3b23] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-454b3b23] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-454b3b23],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-454b3b23] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-454b3b23] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-454b3b23] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-454b3b23] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-454b3b23] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-454b3b23] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-454b3b23] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-454b3b23] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-454b3b23] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-454b3b23] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-454b3b23] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-454b3b23] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-454b3b23] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-454b3b23] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-454b3b23] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-454b3b23] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-454b3b23] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-454b3b23] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-454b3b23] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-454b3b23] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-454b3b23] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-454b3b23] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-454b3b23] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-454b3b23] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-454b3b23] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-454b3b23] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-454b3b23] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-454b3b23] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-454b3b23] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-454b3b23]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-454b3b23] {\n  color: #666666;\n}\n.el-radio__inner[data-v-454b3b23]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-454b3b23] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-454b3b23] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-454b3b23] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-454b3b23] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-454b3b23] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-454b3b23] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-454b3b23] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-454b3b23] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-454b3b23],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-454b3b23]:hover,\n.el-input__icon.el-icon-circle-close[data-v-454b3b23],\n.el-input__icon.el-icon-circle-close[data-v-454b3b23]:hover {\n  color: #FB304D;\n}\n*[data-v-454b3b23],\n*[data-v-454b3b23]:before,\n*[data-v-454b3b23]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-454b3b23],\ntextarea[data-v-454b3b23] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-454b3b23]:focus {\n  outline: none;\n}\n.page-drawer[data-v-454b3b23] {\n  width: 4.040404rem;\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}", ""]);

// exports


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml,\nbody {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.v-main,\n  .page-contain,\n  .page-submenu {\n    width: 6.060606rem;\n}\n.page-submenu_left {\n    width: 1.313131rem;\n}\n.page-submenu_right {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n.has-header {\n  margin-top: 0.252525rem;\n}\n::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright {\n  text-align: right;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.common_reddot_item {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label {\n  line-height: 0.10101rem;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.alignright {\n  text-align: right;\n}\n.e2e-container {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell {\n  overflow: visible;\n}\n.e2e-red-point,\n.e2e-red-point-left {\n  position: relative;\n}\n.e2e-red-point::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small /deep/ input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small /deep/ input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray /deep/ input {\n  background: #efefef;\n}\n.e2e-radio-large /deep/ .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money {\n  color: #0B41CD;\n}\n.e2e-copy {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy:before {\n  content: '\\E787';\n}\n.e2e-warning {\n  color: #e02020;\n}\n.e2e-warning-blue {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button {\n  font-size: 0.065657rem;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.el-button {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary:hover,\n.el-button--primary:active,\n.el-button--primary:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain:hover,\n.el-button--primary.is-plain:active,\n.el-button--primary.is-plain:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled:hover,\n.el-button--primary.is-plain.is-disabled:active,\n.el-button--primary.is-plain.is-disabled:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled:hover,\n.el-button--primary.is-disabled:active,\n.el-button--primary.is-disabled:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default:hover,\n.el-button--default:active,\n.el-button--default:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text:hover,\n.el-button--text:active,\n.el-button--text:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled {\n  color: #6D7278;\n}\n.operate .el-button + .el-button,\n.operate a + .el-button,\n.operate span + .el-button,\n.operate a + span {\n  margin-left: 0.121212rem;\n}\n.operate span > div {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text {\n  color: #fff;\n}\n.el-loading-mask {\n  z-index: 9998;\n}\n.el-input__inner {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.is-disabled.el-input :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.el-select-dropdown {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label {\n  padding: 0;\n}\n.header-menu-dropdown {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow {\n  display: none;\n}\n.el-table th > .cell {\n  font-weight: bold !important;\n}\n.el-table .cell {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell {\n  padding-left: 0.070707rem;\n}\n.el-table td {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev,\n.el-pagination .btn-next {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span,\n.el-pagination .btn-next span {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog {\n  border-radius: 0.020202rem;\n}\n.el-drawer {\n  overflow: auto;\n}\n.common-confirm-dialog {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog {\n  width: 3.030303rem !important;\n}\n.approval-dialog {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select,\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer {\n  text-align: center;\n}\n.application-search-content-main-fields .active {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label {\n  color: #666666;\n}\n.el-radio__inner:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label {\n  color: #E64100;\n}\n.tox-tinymce-aux {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper {\n  width: 0.757576rem;\n}\n.custom-tooltip {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close,\n.el-select__caret.el-input__icon.el-icon-circle-close:hover,\n.el-input__icon.el-icon-circle-close,\n.el-input__icon.el-icon-circle-close:hover {\n  color: #FB304D;\n}\n*,\n*:before,\n*:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput,\ntextarea {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput:focus {\n  outline: none;\n}\n.approval_box {\n  width: 2.272727rem;\n  border-radius: 0.050505rem;\n}\n.approval_box /deep/ .el-dialog__header {\n  height: 0.30303rem;\n  font-size: 0.070707rem;\n  font-weight: bolder;\n  line-height: 0.30303rem;\n}\n.approval_box /deep/ .el-form-item {\n  margin-bottom: 0;\n}\n.approval_box .dialog-footer /deep/ .el-button {\n  margin: 0 0.151515rem;\n}", ""]);

// exports


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-4628556a],\nbody[data-v-4628556a] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-4628556a]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-4628556a] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-4628556a] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-4628556a] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-4628556a],\n  .page-contain[data-v-4628556a],\n  .page-submenu[data-v-4628556a] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-4628556a] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-4628556a] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-4628556a] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-4628556a] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-4628556a] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-4628556a] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-4628556a] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-4628556a] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-4628556a],\n  .page-submenu[data-v-4628556a] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-4628556a] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-4628556a] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-4628556a] {\n    width: 76.3vw;\n}\n.v-main[data-v-4628556a] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-4628556a] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-4628556a] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-4628556a] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-4628556a] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-4628556a] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-4628556a] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-4628556a],\n  .page-submenu[data-v-4628556a] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-4628556a] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-4628556a] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-4628556a] {\n    width: 76.3vw;\n}\n.v-main[data-v-4628556a] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-4628556a] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-4628556a] {\n  margin-top: 0.252525rem;\n}\n[data-v-4628556a]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-4628556a]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-4628556a] {\n  text-align: right;\n}\n.aligncenter[data-v-4628556a] {\n  text-align: center;\n}\n.alignleft[data-v-4628556a] {\n  text-align: left;\n}\n.actiongroupborder[data-v-4628556a] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-4628556a] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-4628556a] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-4628556a] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-4628556a] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-4628556a] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-4628556a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-4628556a] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-4628556a] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-4628556a] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-4628556a] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-4628556a] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-4628556a] {\n  text-align: center;\n}\n.alignleft[data-v-4628556a] {\n  text-align: left;\n}\n.alignright[data-v-4628556a] {\n  text-align: right;\n}\n.e2e-container[data-v-4628556a] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-4628556a] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-4628556a] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-4628556a] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-4628556a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-4628556a] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-4628556a] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-4628556a] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-4628556a] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-4628556a] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-4628556a] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-4628556a],\n.e2e-red-point-left[data-v-4628556a] {\n  position: relative;\n}\n.e2e-red-point[data-v-4628556a]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-4628556a]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-4628556a] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-4628556a] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-4628556a] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-4628556a] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-4628556a] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-4628556a] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-4628556a] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-4628556a] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-4628556a] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-4628556a] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-4628556a] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-4628556a] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-4628556a] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-4628556a]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-4628556a] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-4628556a] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-4628556a],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-4628556a] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-4628556a],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-4628556a] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-4628556a],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-4628556a] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-4628556a],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-4628556a] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-4628556a],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-4628556a] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-4628556a],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-4628556a] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-4628556a] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-4628556a] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-4628556a] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-4628556a] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-4628556a] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-4628556a] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-4628556a] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-4628556a] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-4628556a]:hover,\n.el-button--primary[data-v-4628556a]:active,\n.el-button--primary[data-v-4628556a]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-4628556a] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-4628556a]:hover,\n.el-button--primary.is-plain[data-v-4628556a]:active,\n.el-button--primary.is-plain[data-v-4628556a]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-4628556a] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-4628556a]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-4628556a]:active,\n.el-button--primary.is-plain.is-disabled[data-v-4628556a]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-4628556a] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-4628556a]:hover,\n.el-button--primary.is-disabled[data-v-4628556a]:active,\n.el-button--primary.is-disabled[data-v-4628556a]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-4628556a] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-4628556a]:hover,\n.el-button--default[data-v-4628556a]:active,\n.el-button--default[data-v-4628556a]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-4628556a] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-4628556a]:hover,\n.el-button--text[data-v-4628556a]:active,\n.el-button--text[data-v-4628556a]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-4628556a] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-4628556a],\n.operate a + .el-button[data-v-4628556a],\n.operate span + .el-button[data-v-4628556a],\n.operate a + span[data-v-4628556a] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-4628556a] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-4628556a] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-4628556a] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-4628556a] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-4628556a] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-4628556a] {\n  color: #fff;\n}\n.el-loading-mask[data-v-4628556a] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-4628556a] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-4628556a]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-4628556a]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-4628556a]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-4628556a]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-4628556a] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-4628556a] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-4628556a] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-4628556a] {\n  color: #999;\n}\n.el-select-dropdown[data-v-4628556a] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-4628556a] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-4628556a] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-4628556a] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-4628556a] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-4628556a] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-4628556a] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-4628556a]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-4628556a] {\n  display: none;\n}\n.el-table th > .cell[data-v-4628556a] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-4628556a] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-4628556a] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-4628556a] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-4628556a]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-4628556a]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-4628556a] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-4628556a] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-4628556a] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-4628556a] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-4628556a] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-4628556a] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-4628556a] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-4628556a] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-4628556a],\n.el-pagination .btn-next[data-v-4628556a] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-4628556a],\n.el-pagination .btn-next span[data-v-4628556a] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-4628556a] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-4628556a] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-4628556a] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-4628556a] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-4628556a] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-4628556a] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-4628556a] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-4628556a] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-4628556a] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-4628556a] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-4628556a] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-4628556a] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-4628556a] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-4628556a] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-4628556a] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-4628556a] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-4628556a] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-4628556a] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-4628556a] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-4628556a] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-4628556a] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-4628556a] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-4628556a] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-4628556a] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-4628556a] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-4628556a] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-4628556a] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-4628556a] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-4628556a] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-4628556a]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-4628556a] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-4628556a] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-4628556a] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-4628556a] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-4628556a] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-4628556a] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-4628556a] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-4628556a] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-4628556a] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-4628556a] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-4628556a] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-4628556a],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-4628556a] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-4628556a] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-4628556a] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-4628556a] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-4628556a] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-4628556a] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-4628556a] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-4628556a] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-4628556a] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-4628556a] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-4628556a] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-4628556a] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-4628556a] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-4628556a] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-4628556a] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-4628556a] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-4628556a] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-4628556a] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-4628556a] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-4628556a] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-4628556a] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-4628556a] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-4628556a] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-4628556a] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-4628556a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-4628556a] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-4628556a] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-4628556a] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-4628556a] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-4628556a]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-4628556a] {\n  color: #666666;\n}\n.el-radio__inner[data-v-4628556a]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-4628556a] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-4628556a] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-4628556a] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-4628556a] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-4628556a] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-4628556a] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-4628556a] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-4628556a] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-4628556a],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-4628556a]:hover,\n.el-input__icon.el-icon-circle-close[data-v-4628556a],\n.el-input__icon.el-icon-circle-close[data-v-4628556a]:hover {\n  color: #FB304D;\n}\n*[data-v-4628556a],\n*[data-v-4628556a]:before,\n*[data-v-4628556a]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-4628556a],\ntextarea[data-v-4628556a] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-4628556a]:focus {\n  outline: none;\n}\n.el-message-box__wrapper[data-v-4628556a] {\n  margin: 0.10101rem;\n}\n.el-message-box[data-v-4628556a] {\n  margin: 0.10101rem;\n}\n.el-message-box .el-button--primary[data-v-4628556a] {\n  background-color: #0b41cd;\n  color: #fff;\n  border-color: #0b41cd;\n}\n.user-container[data-v-4628556a] {\n  padding: 0.242424rem 0.40404rem 0.282828rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.user-container .user-basic-container[data-v-4628556a] {\n  width: 100%;\n}\n.user-container .authorizelm-text[data-v-4628556a] {\n  margin-bottom: 0.111111rem;\n}\n.user-container .search-content[data-v-4628556a] {\n  margin-bottom: 0.111111rem;\n}", ""]);

// exports


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-4a5e30e8],\nbody[data-v-4a5e30e8] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-4a5e30e8]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-4a5e30e8] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-4a5e30e8] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-4a5e30e8] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-4a5e30e8],\n  .page-contain[data-v-4a5e30e8],\n  .page-submenu[data-v-4a5e30e8] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-4a5e30e8] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-4a5e30e8] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-4a5e30e8] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-4a5e30e8] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-4a5e30e8] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-4a5e30e8] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-4a5e30e8] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-4a5e30e8] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-4a5e30e8],\n  .page-submenu[data-v-4a5e30e8] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-4a5e30e8] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-4a5e30e8] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-4a5e30e8] {\n    width: 76.3vw;\n}\n.v-main[data-v-4a5e30e8] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-4a5e30e8] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-4a5e30e8] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-4a5e30e8] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-4a5e30e8] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-4a5e30e8] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-4a5e30e8] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-4a5e30e8],\n  .page-submenu[data-v-4a5e30e8] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-4a5e30e8] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-4a5e30e8] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-4a5e30e8] {\n    width: 76.3vw;\n}\n.v-main[data-v-4a5e30e8] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-4a5e30e8] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-4a5e30e8] {\n  margin-top: 0.252525rem;\n}\n[data-v-4a5e30e8]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-4a5e30e8]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-4a5e30e8] {\n  text-align: right;\n}\n.aligncenter[data-v-4a5e30e8] {\n  text-align: center;\n}\n.alignleft[data-v-4a5e30e8] {\n  text-align: left;\n}\n.actiongroupborder[data-v-4a5e30e8] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-4a5e30e8] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-4a5e30e8] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-4a5e30e8] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-4a5e30e8] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-4a5e30e8] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-4a5e30e8] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-4a5e30e8] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-4a5e30e8] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-4a5e30e8] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-4a5e30e8] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-4a5e30e8] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-4a5e30e8] {\n  text-align: center;\n}\n.alignleft[data-v-4a5e30e8] {\n  text-align: left;\n}\n.alignright[data-v-4a5e30e8] {\n  text-align: right;\n}\n.e2e-container[data-v-4a5e30e8] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-4a5e30e8] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-4a5e30e8] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-4a5e30e8] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-4a5e30e8] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-4a5e30e8] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-4a5e30e8] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-4a5e30e8] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-4a5e30e8] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-4a5e30e8] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-4a5e30e8] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-4a5e30e8],\n.e2e-red-point-left[data-v-4a5e30e8] {\n  position: relative;\n}\n.e2e-red-point[data-v-4a5e30e8]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-4a5e30e8]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-4a5e30e8] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-4a5e30e8] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-4a5e30e8] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-4a5e30e8] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-4a5e30e8] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-4a5e30e8] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-4a5e30e8] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-4a5e30e8] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-4a5e30e8] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-4a5e30e8] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-4a5e30e8] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-4a5e30e8] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-4a5e30e8] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-4a5e30e8]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-4a5e30e8] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-4a5e30e8] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-4a5e30e8],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-4a5e30e8] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-4a5e30e8],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-4a5e30e8] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-4a5e30e8],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-4a5e30e8] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-4a5e30e8],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-4a5e30e8] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-4a5e30e8],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-4a5e30e8] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-4a5e30e8],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-4a5e30e8] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-4a5e30e8] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-4a5e30e8] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-4a5e30e8] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-4a5e30e8] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-4a5e30e8] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-4a5e30e8] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-4a5e30e8] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-4a5e30e8] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-4a5e30e8]:hover,\n.el-button--primary[data-v-4a5e30e8]:active,\n.el-button--primary[data-v-4a5e30e8]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-4a5e30e8] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-4a5e30e8]:hover,\n.el-button--primary.is-plain[data-v-4a5e30e8]:active,\n.el-button--primary.is-plain[data-v-4a5e30e8]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-4a5e30e8] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-4a5e30e8]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-4a5e30e8]:active,\n.el-button--primary.is-plain.is-disabled[data-v-4a5e30e8]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-4a5e30e8] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-4a5e30e8]:hover,\n.el-button--primary.is-disabled[data-v-4a5e30e8]:active,\n.el-button--primary.is-disabled[data-v-4a5e30e8]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-4a5e30e8] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-4a5e30e8]:hover,\n.el-button--default[data-v-4a5e30e8]:active,\n.el-button--default[data-v-4a5e30e8]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-4a5e30e8] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-4a5e30e8]:hover,\n.el-button--text[data-v-4a5e30e8]:active,\n.el-button--text[data-v-4a5e30e8]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-4a5e30e8] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-4a5e30e8],\n.operate a + .el-button[data-v-4a5e30e8],\n.operate span + .el-button[data-v-4a5e30e8],\n.operate a + span[data-v-4a5e30e8] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-4a5e30e8] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-4a5e30e8] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-4a5e30e8] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-4a5e30e8] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-4a5e30e8] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-4a5e30e8] {\n  color: #fff;\n}\n.el-loading-mask[data-v-4a5e30e8] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-4a5e30e8] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-4a5e30e8]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-4a5e30e8]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-4a5e30e8]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-4a5e30e8]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-4a5e30e8] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-4a5e30e8] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-4a5e30e8] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-4a5e30e8] {\n  color: #999;\n}\n.el-select-dropdown[data-v-4a5e30e8] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-4a5e30e8] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-4a5e30e8] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-4a5e30e8] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-4a5e30e8] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-4a5e30e8] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-4a5e30e8] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-4a5e30e8]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-4a5e30e8] {\n  display: none;\n}\n.el-table th > .cell[data-v-4a5e30e8] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-4a5e30e8] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-4a5e30e8] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-4a5e30e8] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-4a5e30e8]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-4a5e30e8]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-4a5e30e8] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-4a5e30e8] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-4a5e30e8] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-4a5e30e8] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-4a5e30e8] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-4a5e30e8] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-4a5e30e8] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-4a5e30e8] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-4a5e30e8],\n.el-pagination .btn-next[data-v-4a5e30e8] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-4a5e30e8],\n.el-pagination .btn-next span[data-v-4a5e30e8] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-4a5e30e8] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-4a5e30e8] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-4a5e30e8] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-4a5e30e8] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-4a5e30e8] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-4a5e30e8] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-4a5e30e8] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-4a5e30e8] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-4a5e30e8] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-4a5e30e8] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-4a5e30e8] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-4a5e30e8] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-4a5e30e8] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-4a5e30e8] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-4a5e30e8] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-4a5e30e8] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-4a5e30e8] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-4a5e30e8] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-4a5e30e8] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-4a5e30e8] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-4a5e30e8] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-4a5e30e8] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-4a5e30e8] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-4a5e30e8] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-4a5e30e8] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-4a5e30e8] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-4a5e30e8] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-4a5e30e8] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-4a5e30e8] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-4a5e30e8]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-4a5e30e8] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-4a5e30e8] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-4a5e30e8] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-4a5e30e8] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-4a5e30e8] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-4a5e30e8] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-4a5e30e8] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-4a5e30e8] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-4a5e30e8] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-4a5e30e8] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-4a5e30e8] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-4a5e30e8],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-4a5e30e8] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-4a5e30e8] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-4a5e30e8] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-4a5e30e8] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-4a5e30e8] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-4a5e30e8] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-4a5e30e8] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-4a5e30e8] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-4a5e30e8] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-4a5e30e8] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-4a5e30e8] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-4a5e30e8] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-4a5e30e8] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-4a5e30e8] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-4a5e30e8] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-4a5e30e8] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-4a5e30e8] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-4a5e30e8] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-4a5e30e8] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-4a5e30e8] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-4a5e30e8] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-4a5e30e8] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-4a5e30e8] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-4a5e30e8] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-4a5e30e8] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-4a5e30e8] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-4a5e30e8] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-4a5e30e8] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-4a5e30e8] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-4a5e30e8]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-4a5e30e8] {\n  color: #666666;\n}\n.el-radio__inner[data-v-4a5e30e8]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-4a5e30e8] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-4a5e30e8] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-4a5e30e8] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-4a5e30e8] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-4a5e30e8] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-4a5e30e8] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-4a5e30e8] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-4a5e30e8] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-4a5e30e8],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-4a5e30e8]:hover,\n.el-input__icon.el-icon-circle-close[data-v-4a5e30e8],\n.el-input__icon.el-icon-circle-close[data-v-4a5e30e8]:hover {\n  color: #FB304D;\n}\n*[data-v-4a5e30e8],\n*[data-v-4a5e30e8]:before,\n*[data-v-4a5e30e8]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-4a5e30e8],\ntextarea[data-v-4a5e30e8] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-4a5e30e8]:focus {\n  outline: none;\n}\n.tabs[data-v-4a5e30e8] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.tabs .el-tabs[data-v-4a5e30e8] {\n  overflow: hidden;\n  -webkit-box-flex: 9;\n      -ms-flex: 9;\n          flex: 9;\n}\n.tabs .el-tabs[data-v-4a5e30e8] .el-tabs__nav-prev,\n.tabs .el-tabs[data-v-4a5e30e8] .el-tabs__nav-next {\n  line-height: 0.282828rem;\n}\n.tabs .btn[data-v-4a5e30e8] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  margin-left: 0.121212rem;\n}\n[data-v-4a5e30e8].excel-container {\n  background-color: #fff;\n  padding: 0.10101rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  max-height: 3.030303rem;\n  overflow: auto;\n}\n[data-v-4a5e30e8].excel-container table {\n  border-collapse: collapse;\n}\n[data-v-4a5e30e8].excel-container td {\n  text-align: center;\n  border: 0.005051rem solid #ebeef5;\n  padding: 0.060606rem;\n  white-space: nowrap;\n}\n[data-v-4a5e30e8].excel-container tr:first-child {\n  font-weight: 600;\n  background-color: #f6f6f6;\n  color: #333;\n}\n[data-v-4a5e30e8].excel-container tr:hover {\n  background-color: #f6f6f6;\n}", ""]);

// exports


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-4d5edbb1],\nbody[data-v-4d5edbb1] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-4d5edbb1]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-4d5edbb1] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-4d5edbb1] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-4d5edbb1] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-4d5edbb1],\n  .page-contain[data-v-4d5edbb1],\n  .page-submenu[data-v-4d5edbb1] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-4d5edbb1] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-4d5edbb1] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-4d5edbb1] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-4d5edbb1] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-4d5edbb1] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-4d5edbb1] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-4d5edbb1] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-4d5edbb1] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-4d5edbb1],\n  .page-submenu[data-v-4d5edbb1] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-4d5edbb1] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-4d5edbb1] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-4d5edbb1] {\n    width: 76.3vw;\n}\n.v-main[data-v-4d5edbb1] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-4d5edbb1] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-4d5edbb1] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-4d5edbb1] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-4d5edbb1] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-4d5edbb1] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-4d5edbb1] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-4d5edbb1],\n  .page-submenu[data-v-4d5edbb1] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-4d5edbb1] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-4d5edbb1] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-4d5edbb1] {\n    width: 76.3vw;\n}\n.v-main[data-v-4d5edbb1] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-4d5edbb1] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-4d5edbb1] {\n  margin-top: 0.252525rem;\n}\n[data-v-4d5edbb1]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-4d5edbb1]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-4d5edbb1] {\n  text-align: right;\n}\n.aligncenter[data-v-4d5edbb1] {\n  text-align: center;\n}\n.alignleft[data-v-4d5edbb1] {\n  text-align: left;\n}\n.actiongroupborder[data-v-4d5edbb1] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-4d5edbb1] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-4d5edbb1] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-4d5edbb1] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-4d5edbb1] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-4d5edbb1] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-4d5edbb1] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-4d5edbb1] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-4d5edbb1] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-4d5edbb1] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-4d5edbb1] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-4d5edbb1] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-4d5edbb1] {\n  text-align: center;\n}\n.alignleft[data-v-4d5edbb1] {\n  text-align: left;\n}\n.alignright[data-v-4d5edbb1] {\n  text-align: right;\n}\n.e2e-container[data-v-4d5edbb1] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-4d5edbb1] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-4d5edbb1] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-4d5edbb1] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-4d5edbb1] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-4d5edbb1] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-4d5edbb1] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-4d5edbb1] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-4d5edbb1] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-4d5edbb1] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-4d5edbb1] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-4d5edbb1],\n.e2e-red-point-left[data-v-4d5edbb1] {\n  position: relative;\n}\n.e2e-red-point[data-v-4d5edbb1]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-4d5edbb1]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-4d5edbb1] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-4d5edbb1] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-4d5edbb1] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-4d5edbb1] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-4d5edbb1] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-4d5edbb1] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-4d5edbb1] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-4d5edbb1] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-4d5edbb1] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-4d5edbb1] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-4d5edbb1] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-4d5edbb1] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-4d5edbb1] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-4d5edbb1]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-4d5edbb1] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-4d5edbb1] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-4d5edbb1],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-4d5edbb1] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-4d5edbb1],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-4d5edbb1] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-4d5edbb1],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-4d5edbb1] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-4d5edbb1],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-4d5edbb1] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-4d5edbb1],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-4d5edbb1] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-4d5edbb1],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-4d5edbb1] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-4d5edbb1] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-4d5edbb1] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-4d5edbb1] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-4d5edbb1] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-4d5edbb1] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-4d5edbb1] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-4d5edbb1] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-4d5edbb1] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-4d5edbb1]:hover,\n.el-button--primary[data-v-4d5edbb1]:active,\n.el-button--primary[data-v-4d5edbb1]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-4d5edbb1] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-4d5edbb1]:hover,\n.el-button--primary.is-plain[data-v-4d5edbb1]:active,\n.el-button--primary.is-plain[data-v-4d5edbb1]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-4d5edbb1] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-4d5edbb1]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-4d5edbb1]:active,\n.el-button--primary.is-plain.is-disabled[data-v-4d5edbb1]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-4d5edbb1] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-4d5edbb1]:hover,\n.el-button--primary.is-disabled[data-v-4d5edbb1]:active,\n.el-button--primary.is-disabled[data-v-4d5edbb1]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-4d5edbb1] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-4d5edbb1]:hover,\n.el-button--default[data-v-4d5edbb1]:active,\n.el-button--default[data-v-4d5edbb1]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-4d5edbb1] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-4d5edbb1]:hover,\n.el-button--text[data-v-4d5edbb1]:active,\n.el-button--text[data-v-4d5edbb1]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-4d5edbb1] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-4d5edbb1],\n.operate a + .el-button[data-v-4d5edbb1],\n.operate span + .el-button[data-v-4d5edbb1],\n.operate a + span[data-v-4d5edbb1] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-4d5edbb1] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-4d5edbb1] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-4d5edbb1] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-4d5edbb1] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-4d5edbb1] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-4d5edbb1] {\n  color: #fff;\n}\n.el-loading-mask[data-v-4d5edbb1] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-4d5edbb1] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-4d5edbb1]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-4d5edbb1]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-4d5edbb1]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-4d5edbb1]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-4d5edbb1] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-4d5edbb1] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-4d5edbb1] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-4d5edbb1] {\n  color: #999;\n}\n.el-select-dropdown[data-v-4d5edbb1] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-4d5edbb1] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-4d5edbb1] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-4d5edbb1] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-4d5edbb1] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-4d5edbb1] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-4d5edbb1] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-4d5edbb1]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-4d5edbb1] {\n  display: none;\n}\n.el-table th > .cell[data-v-4d5edbb1] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-4d5edbb1] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-4d5edbb1] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-4d5edbb1] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-4d5edbb1]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-4d5edbb1]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-4d5edbb1] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-4d5edbb1] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-4d5edbb1] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-4d5edbb1] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-4d5edbb1] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-4d5edbb1] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-4d5edbb1] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-4d5edbb1] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-4d5edbb1],\n.el-pagination .btn-next[data-v-4d5edbb1] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-4d5edbb1],\n.el-pagination .btn-next span[data-v-4d5edbb1] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-4d5edbb1] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-4d5edbb1] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-4d5edbb1] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-4d5edbb1] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-4d5edbb1] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-4d5edbb1] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-4d5edbb1] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-4d5edbb1] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-4d5edbb1] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-4d5edbb1] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-4d5edbb1] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-4d5edbb1] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-4d5edbb1] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-4d5edbb1] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-4d5edbb1] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-4d5edbb1] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-4d5edbb1] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-4d5edbb1] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-4d5edbb1] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-4d5edbb1] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-4d5edbb1] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-4d5edbb1] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-4d5edbb1] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-4d5edbb1] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-4d5edbb1] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-4d5edbb1] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-4d5edbb1] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-4d5edbb1] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-4d5edbb1] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-4d5edbb1]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-4d5edbb1] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-4d5edbb1] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-4d5edbb1] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-4d5edbb1] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-4d5edbb1] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-4d5edbb1] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-4d5edbb1] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-4d5edbb1] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-4d5edbb1] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-4d5edbb1] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-4d5edbb1] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-4d5edbb1],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-4d5edbb1] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-4d5edbb1] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-4d5edbb1] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-4d5edbb1] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-4d5edbb1] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-4d5edbb1] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-4d5edbb1] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-4d5edbb1] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-4d5edbb1] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-4d5edbb1] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-4d5edbb1] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-4d5edbb1] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-4d5edbb1] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-4d5edbb1] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-4d5edbb1] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-4d5edbb1] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-4d5edbb1] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-4d5edbb1] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-4d5edbb1] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-4d5edbb1] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-4d5edbb1] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-4d5edbb1] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-4d5edbb1] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-4d5edbb1] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-4d5edbb1] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-4d5edbb1] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-4d5edbb1] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-4d5edbb1] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-4d5edbb1] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-4d5edbb1]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-4d5edbb1] {\n  color: #666666;\n}\n.el-radio__inner[data-v-4d5edbb1]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-4d5edbb1] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-4d5edbb1] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-4d5edbb1] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-4d5edbb1] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-4d5edbb1] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-4d5edbb1] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-4d5edbb1] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-4d5edbb1] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-4d5edbb1],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-4d5edbb1]:hover,\n.el-input__icon.el-icon-circle-close[data-v-4d5edbb1],\n.el-input__icon.el-icon-circle-close[data-v-4d5edbb1]:hover {\n  color: #FB304D;\n}\n*[data-v-4d5edbb1],\n*[data-v-4d5edbb1]:before,\n*[data-v-4d5edbb1]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-4d5edbb1],\ntextarea[data-v-4d5edbb1] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-4d5edbb1]:focus {\n  outline: none;\n}\n.title[data-v-4d5edbb1] {\n  margin-bottom: 0.050505rem;\n}\n.actions[data-v-4d5edbb1] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.actions .upload[data-v-4d5edbb1] {\n  margin-left: 0.050505rem;\n  width: 0.757576rem;\n}\n.not-required[data-v-4d5edbb1] {\n  display: none;\n}\n.required[data-v-4d5edbb1] {\n  display: inline;\n  color: #E64100;\n  margin-right: 0.025253rem;\n}\n.btn-upload.error[data-v-4d5edbb1] {\n  border: 0.005051rem solid #e64100 !important;\n}\n.tooltip[data-v-4d5edbb1] {\n  margin-left: 0.025253rem;\n}", ""]);

// exports


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-4e0dfd05],\nbody[data-v-4e0dfd05] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-4e0dfd05]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-4e0dfd05] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-4e0dfd05] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-4e0dfd05] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-4e0dfd05],\n  .page-contain[data-v-4e0dfd05],\n  .page-submenu[data-v-4e0dfd05] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-4e0dfd05] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-4e0dfd05] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-4e0dfd05] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-4e0dfd05] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-4e0dfd05] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-4e0dfd05] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-4e0dfd05] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-4e0dfd05] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-4e0dfd05],\n  .page-submenu[data-v-4e0dfd05] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-4e0dfd05] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-4e0dfd05] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-4e0dfd05] {\n    width: 76.3vw;\n}\n.v-main[data-v-4e0dfd05] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-4e0dfd05] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-4e0dfd05] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-4e0dfd05] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-4e0dfd05] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-4e0dfd05] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-4e0dfd05] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-4e0dfd05],\n  .page-submenu[data-v-4e0dfd05] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-4e0dfd05] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-4e0dfd05] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-4e0dfd05] {\n    width: 76.3vw;\n}\n.v-main[data-v-4e0dfd05] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-4e0dfd05] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-4e0dfd05] {\n  margin-top: 0.252525rem;\n}\n[data-v-4e0dfd05]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-4e0dfd05]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-4e0dfd05] {\n  text-align: right;\n}\n.aligncenter[data-v-4e0dfd05] {\n  text-align: center;\n}\n.alignleft[data-v-4e0dfd05] {\n  text-align: left;\n}\n.actiongroupborder[data-v-4e0dfd05] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-4e0dfd05] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-4e0dfd05] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-4e0dfd05] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-4e0dfd05] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-4e0dfd05] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-4e0dfd05] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-4e0dfd05] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-4e0dfd05] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-4e0dfd05] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-4e0dfd05] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-4e0dfd05] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-4e0dfd05] {\n  text-align: center;\n}\n.alignleft[data-v-4e0dfd05] {\n  text-align: left;\n}\n.alignright[data-v-4e0dfd05] {\n  text-align: right;\n}\n.e2e-container[data-v-4e0dfd05] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-4e0dfd05] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-4e0dfd05] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-4e0dfd05] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-4e0dfd05] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-4e0dfd05] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-4e0dfd05] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-4e0dfd05] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-4e0dfd05] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-4e0dfd05] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-4e0dfd05] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-4e0dfd05],\n.e2e-red-point-left[data-v-4e0dfd05] {\n  position: relative;\n}\n.e2e-red-point[data-v-4e0dfd05]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-4e0dfd05]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-4e0dfd05] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-4e0dfd05] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-4e0dfd05] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-4e0dfd05] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-4e0dfd05] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-4e0dfd05] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-4e0dfd05] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-4e0dfd05] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-4e0dfd05] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-4e0dfd05] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-4e0dfd05] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-4e0dfd05] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-4e0dfd05] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-4e0dfd05]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-4e0dfd05] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-4e0dfd05] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-4e0dfd05],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-4e0dfd05] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-4e0dfd05],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-4e0dfd05] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-4e0dfd05],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-4e0dfd05] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-4e0dfd05],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-4e0dfd05] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-4e0dfd05],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-4e0dfd05] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-4e0dfd05],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-4e0dfd05] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-4e0dfd05] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-4e0dfd05] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-4e0dfd05] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-4e0dfd05] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-4e0dfd05] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-4e0dfd05] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-4e0dfd05] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-4e0dfd05] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-4e0dfd05]:hover,\n.el-button--primary[data-v-4e0dfd05]:active,\n.el-button--primary[data-v-4e0dfd05]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-4e0dfd05] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-4e0dfd05]:hover,\n.el-button--primary.is-plain[data-v-4e0dfd05]:active,\n.el-button--primary.is-plain[data-v-4e0dfd05]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-4e0dfd05] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-4e0dfd05]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-4e0dfd05]:active,\n.el-button--primary.is-plain.is-disabled[data-v-4e0dfd05]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-4e0dfd05] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-4e0dfd05]:hover,\n.el-button--primary.is-disabled[data-v-4e0dfd05]:active,\n.el-button--primary.is-disabled[data-v-4e0dfd05]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-4e0dfd05] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-4e0dfd05]:hover,\n.el-button--default[data-v-4e0dfd05]:active,\n.el-button--default[data-v-4e0dfd05]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-4e0dfd05] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-4e0dfd05]:hover,\n.el-button--text[data-v-4e0dfd05]:active,\n.el-button--text[data-v-4e0dfd05]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-4e0dfd05] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-4e0dfd05],\n.operate a + .el-button[data-v-4e0dfd05],\n.operate span + .el-button[data-v-4e0dfd05],\n.operate a + span[data-v-4e0dfd05] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-4e0dfd05] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-4e0dfd05] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-4e0dfd05] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-4e0dfd05] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-4e0dfd05] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-4e0dfd05] {\n  color: #fff;\n}\n.el-loading-mask[data-v-4e0dfd05] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-4e0dfd05] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-4e0dfd05]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-4e0dfd05]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-4e0dfd05]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-4e0dfd05]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-4e0dfd05] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-4e0dfd05] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-4e0dfd05] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-4e0dfd05] {\n  color: #999;\n}\n.el-select-dropdown[data-v-4e0dfd05] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-4e0dfd05] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-4e0dfd05] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-4e0dfd05] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-4e0dfd05] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-4e0dfd05] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-4e0dfd05] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-4e0dfd05]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-4e0dfd05] {\n  display: none;\n}\n.el-table th > .cell[data-v-4e0dfd05] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-4e0dfd05] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-4e0dfd05] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-4e0dfd05] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-4e0dfd05]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-4e0dfd05]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-4e0dfd05] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-4e0dfd05] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-4e0dfd05] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-4e0dfd05] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-4e0dfd05] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-4e0dfd05] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-4e0dfd05] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-4e0dfd05] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-4e0dfd05],\n.el-pagination .btn-next[data-v-4e0dfd05] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-4e0dfd05],\n.el-pagination .btn-next span[data-v-4e0dfd05] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-4e0dfd05] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-4e0dfd05] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-4e0dfd05] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-4e0dfd05] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-4e0dfd05] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-4e0dfd05] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-4e0dfd05] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-4e0dfd05] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-4e0dfd05] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-4e0dfd05] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-4e0dfd05] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-4e0dfd05] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-4e0dfd05] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-4e0dfd05] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-4e0dfd05] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-4e0dfd05] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-4e0dfd05] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-4e0dfd05] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-4e0dfd05] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-4e0dfd05] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-4e0dfd05] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-4e0dfd05] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-4e0dfd05] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-4e0dfd05] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-4e0dfd05] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-4e0dfd05] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-4e0dfd05] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-4e0dfd05] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-4e0dfd05] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-4e0dfd05]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-4e0dfd05] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-4e0dfd05] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-4e0dfd05] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-4e0dfd05] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-4e0dfd05] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-4e0dfd05] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-4e0dfd05] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-4e0dfd05] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-4e0dfd05] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-4e0dfd05] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-4e0dfd05] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-4e0dfd05],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-4e0dfd05] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-4e0dfd05] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-4e0dfd05] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-4e0dfd05] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-4e0dfd05] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-4e0dfd05] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-4e0dfd05] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-4e0dfd05] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-4e0dfd05] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-4e0dfd05] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-4e0dfd05] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-4e0dfd05] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-4e0dfd05] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-4e0dfd05] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-4e0dfd05] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-4e0dfd05] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-4e0dfd05] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-4e0dfd05] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-4e0dfd05] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-4e0dfd05] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-4e0dfd05] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-4e0dfd05] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-4e0dfd05] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-4e0dfd05] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-4e0dfd05] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-4e0dfd05] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-4e0dfd05] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-4e0dfd05] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-4e0dfd05] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-4e0dfd05]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-4e0dfd05] {\n  color: #666666;\n}\n.el-radio__inner[data-v-4e0dfd05]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-4e0dfd05] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-4e0dfd05] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-4e0dfd05] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-4e0dfd05] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-4e0dfd05] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-4e0dfd05] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-4e0dfd05] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-4e0dfd05] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-4e0dfd05],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-4e0dfd05]:hover,\n.el-input__icon.el-icon-circle-close[data-v-4e0dfd05],\n.el-input__icon.el-icon-circle-close[data-v-4e0dfd05]:hover {\n  color: #FB304D;\n}\n*[data-v-4e0dfd05],\n*[data-v-4e0dfd05]:before,\n*[data-v-4e0dfd05]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-4e0dfd05],\ntextarea[data-v-4e0dfd05] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-4e0dfd05]:focus {\n  outline: none;\n}\n.tableau[data-v-4e0dfd05] {\n  overflow-x: hidden;\n}", ""]);

// exports


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-4f13d1ac],\nbody[data-v-4f13d1ac] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-4f13d1ac]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-4f13d1ac] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-4f13d1ac] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-4f13d1ac] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-4f13d1ac],\n  .page-contain[data-v-4f13d1ac],\n  .page-submenu[data-v-4f13d1ac] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-4f13d1ac] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-4f13d1ac] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-4f13d1ac] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-4f13d1ac] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-4f13d1ac] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-4f13d1ac] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-4f13d1ac] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-4f13d1ac] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-4f13d1ac],\n  .page-submenu[data-v-4f13d1ac] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-4f13d1ac] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-4f13d1ac] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-4f13d1ac] {\n    width: 76.3vw;\n}\n.v-main[data-v-4f13d1ac] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-4f13d1ac] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-4f13d1ac] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-4f13d1ac] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-4f13d1ac] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-4f13d1ac] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-4f13d1ac] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-4f13d1ac],\n  .page-submenu[data-v-4f13d1ac] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-4f13d1ac] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-4f13d1ac] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-4f13d1ac] {\n    width: 76.3vw;\n}\n.v-main[data-v-4f13d1ac] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-4f13d1ac] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-4f13d1ac] {\n  margin-top: 0.252525rem;\n}\n[data-v-4f13d1ac]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-4f13d1ac]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-4f13d1ac] {\n  text-align: right;\n}\n.aligncenter[data-v-4f13d1ac] {\n  text-align: center;\n}\n.alignleft[data-v-4f13d1ac] {\n  text-align: left;\n}\n.actiongroupborder[data-v-4f13d1ac] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-4f13d1ac] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-4f13d1ac] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-4f13d1ac] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-4f13d1ac] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-4f13d1ac] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-4f13d1ac] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-4f13d1ac] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-4f13d1ac] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-4f13d1ac] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-4f13d1ac] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-4f13d1ac] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-4f13d1ac] {\n  text-align: center;\n}\n.alignleft[data-v-4f13d1ac] {\n  text-align: left;\n}\n.alignright[data-v-4f13d1ac] {\n  text-align: right;\n}\n.e2e-container[data-v-4f13d1ac] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-4f13d1ac] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-4f13d1ac] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-4f13d1ac] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-4f13d1ac] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-4f13d1ac] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-4f13d1ac] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-4f13d1ac] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-4f13d1ac] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-4f13d1ac] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-4f13d1ac] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-4f13d1ac],\n.e2e-red-point-left[data-v-4f13d1ac] {\n  position: relative;\n}\n.e2e-red-point[data-v-4f13d1ac]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-4f13d1ac]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-4f13d1ac] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-4f13d1ac] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-4f13d1ac] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-4f13d1ac] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-4f13d1ac] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-4f13d1ac] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-4f13d1ac] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-4f13d1ac] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-4f13d1ac] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-4f13d1ac] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-4f13d1ac] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-4f13d1ac] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-4f13d1ac] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-4f13d1ac]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-4f13d1ac] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-4f13d1ac] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-4f13d1ac],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-4f13d1ac] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-4f13d1ac],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-4f13d1ac] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-4f13d1ac],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-4f13d1ac] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-4f13d1ac],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-4f13d1ac] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-4f13d1ac],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-4f13d1ac] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-4f13d1ac],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-4f13d1ac] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-4f13d1ac] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-4f13d1ac] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-4f13d1ac] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-4f13d1ac] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-4f13d1ac] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-4f13d1ac] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-4f13d1ac] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-4f13d1ac] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-4f13d1ac]:hover,\n.el-button--primary[data-v-4f13d1ac]:active,\n.el-button--primary[data-v-4f13d1ac]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-4f13d1ac] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-4f13d1ac]:hover,\n.el-button--primary.is-plain[data-v-4f13d1ac]:active,\n.el-button--primary.is-plain[data-v-4f13d1ac]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-4f13d1ac] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-4f13d1ac]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-4f13d1ac]:active,\n.el-button--primary.is-plain.is-disabled[data-v-4f13d1ac]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-4f13d1ac] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-4f13d1ac]:hover,\n.el-button--primary.is-disabled[data-v-4f13d1ac]:active,\n.el-button--primary.is-disabled[data-v-4f13d1ac]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-4f13d1ac] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-4f13d1ac]:hover,\n.el-button--default[data-v-4f13d1ac]:active,\n.el-button--default[data-v-4f13d1ac]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-4f13d1ac] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-4f13d1ac]:hover,\n.el-button--text[data-v-4f13d1ac]:active,\n.el-button--text[data-v-4f13d1ac]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-4f13d1ac] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-4f13d1ac],\n.operate a + .el-button[data-v-4f13d1ac],\n.operate span + .el-button[data-v-4f13d1ac],\n.operate a + span[data-v-4f13d1ac] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-4f13d1ac] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-4f13d1ac] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-4f13d1ac] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-4f13d1ac] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-4f13d1ac] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-4f13d1ac] {\n  color: #fff;\n}\n.el-loading-mask[data-v-4f13d1ac] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-4f13d1ac] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-4f13d1ac]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-4f13d1ac]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-4f13d1ac]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-4f13d1ac]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-4f13d1ac] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-4f13d1ac] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-4f13d1ac] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-4f13d1ac] {\n  color: #999;\n}\n.el-select-dropdown[data-v-4f13d1ac] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-4f13d1ac] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-4f13d1ac] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-4f13d1ac] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-4f13d1ac] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-4f13d1ac] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-4f13d1ac] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-4f13d1ac]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-4f13d1ac] {\n  display: none;\n}\n.el-table th > .cell[data-v-4f13d1ac] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-4f13d1ac] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-4f13d1ac] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-4f13d1ac] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-4f13d1ac]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-4f13d1ac]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-4f13d1ac] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-4f13d1ac] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-4f13d1ac] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-4f13d1ac] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-4f13d1ac] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-4f13d1ac] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-4f13d1ac] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-4f13d1ac] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-4f13d1ac],\n.el-pagination .btn-next[data-v-4f13d1ac] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-4f13d1ac],\n.el-pagination .btn-next span[data-v-4f13d1ac] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-4f13d1ac] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-4f13d1ac] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-4f13d1ac] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-4f13d1ac] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-4f13d1ac] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-4f13d1ac] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-4f13d1ac] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-4f13d1ac] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-4f13d1ac] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-4f13d1ac] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-4f13d1ac] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-4f13d1ac] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-4f13d1ac] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-4f13d1ac] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-4f13d1ac] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-4f13d1ac] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-4f13d1ac] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-4f13d1ac] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-4f13d1ac] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-4f13d1ac] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-4f13d1ac] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-4f13d1ac] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-4f13d1ac] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-4f13d1ac] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-4f13d1ac] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-4f13d1ac] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-4f13d1ac] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-4f13d1ac] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-4f13d1ac] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-4f13d1ac]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-4f13d1ac] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-4f13d1ac] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-4f13d1ac] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-4f13d1ac] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-4f13d1ac] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-4f13d1ac] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-4f13d1ac] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-4f13d1ac] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-4f13d1ac] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-4f13d1ac] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-4f13d1ac] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-4f13d1ac],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-4f13d1ac] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-4f13d1ac] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-4f13d1ac] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-4f13d1ac] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-4f13d1ac] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-4f13d1ac] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-4f13d1ac] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-4f13d1ac] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-4f13d1ac] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-4f13d1ac] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-4f13d1ac] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-4f13d1ac] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-4f13d1ac] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-4f13d1ac] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-4f13d1ac] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-4f13d1ac] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-4f13d1ac] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-4f13d1ac] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-4f13d1ac] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-4f13d1ac] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-4f13d1ac] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-4f13d1ac] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-4f13d1ac] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-4f13d1ac] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-4f13d1ac] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-4f13d1ac] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-4f13d1ac] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-4f13d1ac] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-4f13d1ac] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-4f13d1ac]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-4f13d1ac] {\n  color: #666666;\n}\n.el-radio__inner[data-v-4f13d1ac]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-4f13d1ac] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-4f13d1ac] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-4f13d1ac] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-4f13d1ac] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-4f13d1ac] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-4f13d1ac] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-4f13d1ac] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-4f13d1ac] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-4f13d1ac],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-4f13d1ac]:hover,\n.el-input__icon.el-icon-circle-close[data-v-4f13d1ac],\n.el-input__icon.el-icon-circle-close[data-v-4f13d1ac]:hover {\n  color: #FB304D;\n}\n*[data-v-4f13d1ac],\n*[data-v-4f13d1ac]:before,\n*[data-v-4f13d1ac]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-4f13d1ac],\ntextarea[data-v-4f13d1ac] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-4f13d1ac]:focus {\n  outline: none;\n}\n.user-container[data-v-4f13d1ac] {\n  padding: 0.242424rem 0.40404rem 0.282828rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.user-container .user-basic-container[data-v-4f13d1ac] {\n  width: 100%;\n}\n.user-container .authorizelm-text[data-v-4f13d1ac] {\n  margin-bottom: 0.111111rem;\n}\n.user-container .search-content[data-v-4f13d1ac] {\n  margin-bottom: 0.111111rem;\n}", ""]);

// exports


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-55241215],\nbody[data-v-55241215] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-55241215]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-55241215] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-55241215] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-55241215] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-55241215],\n  .page-contain[data-v-55241215],\n  .page-submenu[data-v-55241215] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-55241215] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-55241215] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-55241215] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-55241215] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-55241215] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-55241215] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-55241215] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-55241215] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-55241215],\n  .page-submenu[data-v-55241215] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-55241215] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-55241215] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-55241215] {\n    width: 76.3vw;\n}\n.v-main[data-v-55241215] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-55241215] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-55241215] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-55241215] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-55241215] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-55241215] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-55241215] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-55241215],\n  .page-submenu[data-v-55241215] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-55241215] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-55241215] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-55241215] {\n    width: 76.3vw;\n}\n.v-main[data-v-55241215] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-55241215] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-55241215] {\n  margin-top: 0.252525rem;\n}\n[data-v-55241215]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-55241215]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-55241215] {\n  text-align: right;\n}\n.aligncenter[data-v-55241215] {\n  text-align: center;\n}\n.alignleft[data-v-55241215] {\n  text-align: left;\n}\n.actiongroupborder[data-v-55241215] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-55241215] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-55241215] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-55241215] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-55241215] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-55241215] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-55241215] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-55241215] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-55241215] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-55241215] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-55241215] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-55241215] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-55241215] {\n  text-align: center;\n}\n.alignleft[data-v-55241215] {\n  text-align: left;\n}\n.alignright[data-v-55241215] {\n  text-align: right;\n}\n.e2e-container[data-v-55241215] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-55241215] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-55241215] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-55241215] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-55241215] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-55241215] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-55241215] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-55241215] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-55241215] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-55241215] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-55241215] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-55241215],\n.e2e-red-point-left[data-v-55241215] {\n  position: relative;\n}\n.e2e-red-point[data-v-55241215]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-55241215]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-55241215] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-55241215] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-55241215] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-55241215] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-55241215] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-55241215] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-55241215] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-55241215] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-55241215] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-55241215] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-55241215] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-55241215] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-55241215] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-55241215]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-55241215] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-55241215] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-55241215],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-55241215] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-55241215],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-55241215] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-55241215],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-55241215] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-55241215],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-55241215] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-55241215],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-55241215] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-55241215],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-55241215] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-55241215] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-55241215] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-55241215] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-55241215] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-55241215] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-55241215] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-55241215] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-55241215] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-55241215]:hover,\n.el-button--primary[data-v-55241215]:active,\n.el-button--primary[data-v-55241215]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-55241215] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-55241215]:hover,\n.el-button--primary.is-plain[data-v-55241215]:active,\n.el-button--primary.is-plain[data-v-55241215]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-55241215] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-55241215]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-55241215]:active,\n.el-button--primary.is-plain.is-disabled[data-v-55241215]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-55241215] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-55241215]:hover,\n.el-button--primary.is-disabled[data-v-55241215]:active,\n.el-button--primary.is-disabled[data-v-55241215]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-55241215] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-55241215]:hover,\n.el-button--default[data-v-55241215]:active,\n.el-button--default[data-v-55241215]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-55241215] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-55241215]:hover,\n.el-button--text[data-v-55241215]:active,\n.el-button--text[data-v-55241215]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-55241215] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-55241215],\n.operate a + .el-button[data-v-55241215],\n.operate span + .el-button[data-v-55241215],\n.operate a + span[data-v-55241215] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-55241215] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-55241215] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-55241215] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-55241215] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-55241215] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-55241215] {\n  color: #fff;\n}\n.el-loading-mask[data-v-55241215] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-55241215] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-55241215]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-55241215]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-55241215]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-55241215]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-55241215] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-55241215] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-55241215] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-55241215] {\n  color: #999;\n}\n.el-select-dropdown[data-v-55241215] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-55241215] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-55241215] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-55241215] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-55241215] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-55241215] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-55241215] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-55241215]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-55241215] {\n  display: none;\n}\n.el-table th > .cell[data-v-55241215] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-55241215] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-55241215] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-55241215] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-55241215]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-55241215]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-55241215] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-55241215] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-55241215] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-55241215] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-55241215] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-55241215] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-55241215] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-55241215] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-55241215],\n.el-pagination .btn-next[data-v-55241215] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-55241215],\n.el-pagination .btn-next span[data-v-55241215] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-55241215] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-55241215] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-55241215] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-55241215] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-55241215] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-55241215] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-55241215] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-55241215] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-55241215] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-55241215] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-55241215] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-55241215] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-55241215] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-55241215] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-55241215] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-55241215] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-55241215] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-55241215] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-55241215] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-55241215] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-55241215] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-55241215] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-55241215] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-55241215] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-55241215] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-55241215] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-55241215] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-55241215] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-55241215] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-55241215]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-55241215] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-55241215] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-55241215] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-55241215] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-55241215] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-55241215] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-55241215] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-55241215] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-55241215] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-55241215] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-55241215] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-55241215],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-55241215] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-55241215] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-55241215] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-55241215] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-55241215] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-55241215] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-55241215] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-55241215] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-55241215] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-55241215] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-55241215] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-55241215] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-55241215] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-55241215] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-55241215] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-55241215] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-55241215] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-55241215] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-55241215] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-55241215] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-55241215] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-55241215] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-55241215] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-55241215] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-55241215] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-55241215] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-55241215] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-55241215] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-55241215] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-55241215]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-55241215] {\n  color: #666666;\n}\n.el-radio__inner[data-v-55241215]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-55241215] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-55241215] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-55241215] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-55241215] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-55241215] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-55241215] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-55241215] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-55241215] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-55241215],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-55241215]:hover,\n.el-input__icon.el-icon-circle-close[data-v-55241215],\n.el-input__icon.el-icon-circle-close[data-v-55241215]:hover {\n  color: #FB304D;\n}\n*[data-v-55241215],\n*[data-v-55241215]:before,\n*[data-v-55241215]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-55241215],\ntextarea[data-v-55241215] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-55241215]:focus {\n  outline: none;\n}\n.page-contain .page-contain-tab[data-v-55241215] {\n  padding: 0 0.282828rem 0.161616rem 0.282828rem;\n  margin-bottom: 0.121212rem;\n}\n.page-contain .page-contain-tab .recipientSocietyOrHospital-text span[data-v-55241215] {\n  color: #0B41CD;\n}\n.page-contain .page-contain-tab .recipientSociety-input[data-v-55241215] {\n  font-size: 0.070707rem;\n  margin-left: 0.050505rem;\n  padding-top: 0.040404rem !important;\n}\n.page-contain .page-contain-tab .more-tab[data-v-55241215] {\n  background: #F6F6F6;\n  border-radius: 0.010101rem;\n  width: 3.959596rem;\n  margin-top: 0.040404rem !important;\n  margin-left: -0.080808rem !important;\n  padding-left: 0.080808rem !important;\n  padding-top: 0.080808rem !important;\n  padding-bottom: 0.060606rem !important;\n}\n.page-contain .page-contain-tab .more-tab-div[data-v-55241215] {\n  margin-top: 0.080808rem;\n}\n.page-contain .approval-workflow[data-v-55241215] {\n  width: auto !important;\n}\n.page-contain .approval-workflow-title[data-v-55241215] {\n  font-size: 0.070707rem;\n  margin-left: 0.050505rem;\n  padding-top: 0.121212rem;\n}\n.page-contain .approval-workflow-title div[data-v-55241215] {\n  border-top: 0.005051rem solid #E8E8E8;\n  margin: 0.121212rem -0.282828rem 0 -0.333333rem;\n}\n.page-contain .approval-status[data-v-55241215] {\n  margin-left: 0.10101rem;\n  padding: 0.025253rem;\n  border-radius: 0.010101rem;\n  height: 0.111111rem;\n  font-size: 0.060606rem;\n}\n.page-contain .approval-padding[data-v-55241215] {\n  border: 0.005051rem solid #FFDA95;\n  background-color: #FFF8EA;\n  color: #FFB52A;\n}\n.page-contain .approval-comfirm[data-v-55241215] {\n  border: 0.005051rem solid #8BE9BE;\n  background-color: #EDFFF6;\n  color: #0EC771;\n}\n.page-contain .approval-reject[data-v-55241215] {\n  border: 0.005051rem solid #FF9CAA;\n  background-color: #FFEFF1;\n  color: #FB304D;\n}\n.page-contain .approval-cancle[data-v-55241215] {\n  border: 0.005051rem solid #D6D6D6;\n  background-color: #F6F6F6;\n  color: #666666;\n}\n.page-contain .approval-submit[data-v-55241215] {\n  border: 0.005051rem solid #A2CBFF;\n  background-color: #EBF4FF;\n  color: #2D82F0;\n}\n.bottom-info[data-v-55241215] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: fixed;\n  background-color: #fff;\n  width: 100%;\n  left: 0;\n  height: 0.222222rem;\n  -webkit-box-shadow: -0.005051rem 0 0.020202rem 0 rgba(51, 51, 51, 0.35);\n          box-shadow: -0.005051rem 0 0.020202rem 0 rgba(51, 51, 51, 0.35);\n  bottom: 0;\n}\n.bottom-info-info[data-v-55241215] {\n  margin-left: 0.606061rem;\n  line-height: 0.222222rem;\n}\n.bottom-info-operate[data-v-55241215] {\n  position: absolute;\n  right: 0.606061rem;\n  line-height: 0.232323rem;\n}\n.col-add-remove[data-v-55241215] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.operate-add-remove[data-v-55241215] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 0.10101rem;\n  margin: 0.191919rem 0 0 0.050505rem;\n}\n.operate-add-remove span[data-v-55241215] {\n  cursor: pointer;\n}\n.operate-add-remove span + span[data-v-55241215] {\n  margin-left: 0.050505rem;\n}\n.view-meeting-plan[data-v-55241215] {\n  padding: 0;\n  margin-bottom: 0.429293rem;\n}\n.view-meeting-plan .edit-form-title[data-v-55241215] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row[data-v-55241215] {\n  padding: 0.121212rem 0 0 0;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full[data-v-55241215] {\n  width: 5.494949rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-input__inner[data-v-55241215] {\n  width: 5.494949rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-textarea__inner[data-v-55241215] {\n  height: 0.555556rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-form-item__label[data-v-55241215] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-form-item__content[data-v-55241215] {\n  padding-top: 0.010101rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-form-item__content label[data-v-55241215] {\n  margin-left: 0.050505rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col[data-v-55241215] {\n  width: 1.616162rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-55241215] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-55241215] {\n  padding-top: 0.010101rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-55241215],\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-55241215] {\n  width: 1.616162rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__content label[data-v-55241215] {\n  margin-left: 0.050505rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-55241215] {\n  margin-left: 0.323232rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .col-no-3[data-v-55241215] {\n  margin-left: 3.878788rem;\n}\n.view-meeting-plan .el-form.el-form--label-right .el-row[data-v-55241215] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}", ""]);

// exports


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-59f49474],\nbody[data-v-59f49474] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-59f49474]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-59f49474] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-59f49474] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-59f49474] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-59f49474],\n  .page-contain[data-v-59f49474],\n  .page-submenu[data-v-59f49474] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-59f49474] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-59f49474] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-59f49474] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-59f49474] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-59f49474] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-59f49474] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-59f49474] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-59f49474] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-59f49474],\n  .page-submenu[data-v-59f49474] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-59f49474] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-59f49474] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-59f49474] {\n    width: 76.3vw;\n}\n.v-main[data-v-59f49474] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-59f49474] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-59f49474] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-59f49474] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-59f49474] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-59f49474] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-59f49474] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-59f49474],\n  .page-submenu[data-v-59f49474] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-59f49474] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-59f49474] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-59f49474] {\n    width: 76.3vw;\n}\n.v-main[data-v-59f49474] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-59f49474] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-59f49474] {\n  margin-top: 0.252525rem;\n}\n[data-v-59f49474]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-59f49474]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-59f49474] {\n  text-align: right;\n}\n.aligncenter[data-v-59f49474] {\n  text-align: center;\n}\n.alignleft[data-v-59f49474] {\n  text-align: left;\n}\n.actiongroupborder[data-v-59f49474] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-59f49474] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-59f49474] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-59f49474] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-59f49474] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-59f49474] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-59f49474] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-59f49474] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-59f49474] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-59f49474] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-59f49474] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-59f49474] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-59f49474] {\n  text-align: center;\n}\n.alignleft[data-v-59f49474] {\n  text-align: left;\n}\n.alignright[data-v-59f49474] {\n  text-align: right;\n}\n.e2e-container[data-v-59f49474] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-59f49474] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-59f49474] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-59f49474] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-59f49474] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-59f49474] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-59f49474] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-59f49474] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-59f49474] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-59f49474] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-59f49474] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-59f49474],\n.e2e-red-point-left[data-v-59f49474] {\n  position: relative;\n}\n.e2e-red-point[data-v-59f49474]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-59f49474]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-59f49474] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-59f49474] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-59f49474] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-59f49474] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-59f49474] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-59f49474] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-59f49474] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-59f49474] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-59f49474] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-59f49474] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-59f49474] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-59f49474] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-59f49474] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-59f49474]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-59f49474] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-59f49474] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-59f49474],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-59f49474] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-59f49474],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-59f49474] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-59f49474],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-59f49474] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-59f49474],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-59f49474] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-59f49474],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-59f49474] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-59f49474],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-59f49474] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-59f49474] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-59f49474] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-59f49474] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-59f49474] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-59f49474] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-59f49474] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-59f49474] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-59f49474] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-59f49474]:hover,\n.el-button--primary[data-v-59f49474]:active,\n.el-button--primary[data-v-59f49474]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-59f49474] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-59f49474]:hover,\n.el-button--primary.is-plain[data-v-59f49474]:active,\n.el-button--primary.is-plain[data-v-59f49474]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-59f49474] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-59f49474]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-59f49474]:active,\n.el-button--primary.is-plain.is-disabled[data-v-59f49474]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-59f49474] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-59f49474]:hover,\n.el-button--primary.is-disabled[data-v-59f49474]:active,\n.el-button--primary.is-disabled[data-v-59f49474]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-59f49474] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-59f49474]:hover,\n.el-button--default[data-v-59f49474]:active,\n.el-button--default[data-v-59f49474]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-59f49474] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-59f49474]:hover,\n.el-button--text[data-v-59f49474]:active,\n.el-button--text[data-v-59f49474]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-59f49474] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-59f49474],\n.operate a + .el-button[data-v-59f49474],\n.operate span + .el-button[data-v-59f49474],\n.operate a + span[data-v-59f49474] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-59f49474] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-59f49474] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-59f49474] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-59f49474] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-59f49474] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-59f49474] {\n  color: #fff;\n}\n.el-loading-mask[data-v-59f49474] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-59f49474] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-59f49474]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-59f49474]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-59f49474]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-59f49474]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-59f49474] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-59f49474] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-59f49474] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-59f49474] {\n  color: #999;\n}\n.el-select-dropdown[data-v-59f49474] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-59f49474] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-59f49474] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-59f49474] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-59f49474] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-59f49474] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-59f49474] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-59f49474]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-59f49474] {\n  display: none;\n}\n.el-table th > .cell[data-v-59f49474] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-59f49474] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-59f49474] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-59f49474] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-59f49474]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-59f49474]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-59f49474] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-59f49474] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-59f49474] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-59f49474] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-59f49474] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-59f49474] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-59f49474] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-59f49474] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-59f49474],\n.el-pagination .btn-next[data-v-59f49474] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-59f49474],\n.el-pagination .btn-next span[data-v-59f49474] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-59f49474] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-59f49474] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-59f49474] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-59f49474] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-59f49474] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-59f49474] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-59f49474] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-59f49474] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-59f49474] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-59f49474] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-59f49474] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-59f49474] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-59f49474] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-59f49474] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-59f49474] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-59f49474] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-59f49474] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-59f49474] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-59f49474] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-59f49474] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-59f49474] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-59f49474] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-59f49474] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-59f49474] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-59f49474] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-59f49474] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-59f49474] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-59f49474] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-59f49474] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-59f49474]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-59f49474] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-59f49474] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-59f49474] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-59f49474] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-59f49474] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-59f49474] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-59f49474] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-59f49474] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-59f49474] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-59f49474] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-59f49474] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-59f49474],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-59f49474] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-59f49474] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-59f49474] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-59f49474] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-59f49474] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-59f49474] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-59f49474] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-59f49474] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-59f49474] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-59f49474] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-59f49474] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-59f49474] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-59f49474] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-59f49474] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-59f49474] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-59f49474] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-59f49474] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-59f49474] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-59f49474] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-59f49474] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-59f49474] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-59f49474] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-59f49474] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-59f49474] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-59f49474] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-59f49474] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-59f49474] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-59f49474] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-59f49474] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-59f49474]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-59f49474] {\n  color: #666666;\n}\n.el-radio__inner[data-v-59f49474]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-59f49474] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-59f49474] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-59f49474] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-59f49474] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-59f49474] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-59f49474] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-59f49474] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-59f49474] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-59f49474],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-59f49474]:hover,\n.el-input__icon.el-icon-circle-close[data-v-59f49474],\n.el-input__icon.el-icon-circle-close[data-v-59f49474]:hover {\n  color: #FB304D;\n}\n*[data-v-59f49474],\n*[data-v-59f49474]:before,\n*[data-v-59f49474]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-59f49474],\ntextarea[data-v-59f49474] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-59f49474]:focus {\n  outline: none;\n}\nimg[data-v-59f49474] {\n  width: 100%;\n}", ""]);

// exports


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-5a8124dd],\nbody[data-v-5a8124dd] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-5a8124dd]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-5a8124dd] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-5a8124dd] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-5a8124dd] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-5a8124dd],\n  .page-contain[data-v-5a8124dd],\n  .page-submenu[data-v-5a8124dd] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-5a8124dd] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-5a8124dd] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-5a8124dd] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-5a8124dd] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-5a8124dd] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-5a8124dd] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-5a8124dd] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-5a8124dd] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-5a8124dd],\n  .page-submenu[data-v-5a8124dd] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-5a8124dd] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-5a8124dd] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-5a8124dd] {\n    width: 76.3vw;\n}\n.v-main[data-v-5a8124dd] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-5a8124dd] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-5a8124dd] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-5a8124dd] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-5a8124dd] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-5a8124dd] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-5a8124dd] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-5a8124dd],\n  .page-submenu[data-v-5a8124dd] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-5a8124dd] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-5a8124dd] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-5a8124dd] {\n    width: 76.3vw;\n}\n.v-main[data-v-5a8124dd] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-5a8124dd] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-5a8124dd] {\n  margin-top: 0.252525rem;\n}\n[data-v-5a8124dd]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-5a8124dd]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-5a8124dd] {\n  text-align: right;\n}\n.aligncenter[data-v-5a8124dd] {\n  text-align: center;\n}\n.alignleft[data-v-5a8124dd] {\n  text-align: left;\n}\n.actiongroupborder[data-v-5a8124dd] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-5a8124dd] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-5a8124dd] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-5a8124dd] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-5a8124dd] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-5a8124dd] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-5a8124dd] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-5a8124dd] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-5a8124dd] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-5a8124dd] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-5a8124dd] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-5a8124dd] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-5a8124dd] {\n  text-align: center;\n}\n.alignleft[data-v-5a8124dd] {\n  text-align: left;\n}\n.alignright[data-v-5a8124dd] {\n  text-align: right;\n}\n.e2e-container[data-v-5a8124dd] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-5a8124dd] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-5a8124dd] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-5a8124dd] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-5a8124dd] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-5a8124dd] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-5a8124dd] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-5a8124dd] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-5a8124dd] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-5a8124dd] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-5a8124dd] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-5a8124dd],\n.e2e-red-point-left[data-v-5a8124dd] {\n  position: relative;\n}\n.e2e-red-point[data-v-5a8124dd]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-5a8124dd]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-5a8124dd] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-5a8124dd] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-5a8124dd] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-5a8124dd] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-5a8124dd] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-5a8124dd] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-5a8124dd] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-5a8124dd] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-5a8124dd] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-5a8124dd] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-5a8124dd] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-5a8124dd] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-5a8124dd] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-5a8124dd]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-5a8124dd] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-5a8124dd] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-5a8124dd],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-5a8124dd] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-5a8124dd],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-5a8124dd] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-5a8124dd],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-5a8124dd] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-5a8124dd],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-5a8124dd] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-5a8124dd],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-5a8124dd] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-5a8124dd],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-5a8124dd] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-5a8124dd] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-5a8124dd] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-5a8124dd] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-5a8124dd] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-5a8124dd] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-5a8124dd] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-5a8124dd] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-5a8124dd] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-5a8124dd]:hover,\n.el-button--primary[data-v-5a8124dd]:active,\n.el-button--primary[data-v-5a8124dd]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-5a8124dd] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-5a8124dd]:hover,\n.el-button--primary.is-plain[data-v-5a8124dd]:active,\n.el-button--primary.is-plain[data-v-5a8124dd]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-5a8124dd] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-5a8124dd]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-5a8124dd]:active,\n.el-button--primary.is-plain.is-disabled[data-v-5a8124dd]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-5a8124dd] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-5a8124dd]:hover,\n.el-button--primary.is-disabled[data-v-5a8124dd]:active,\n.el-button--primary.is-disabled[data-v-5a8124dd]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-5a8124dd] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-5a8124dd]:hover,\n.el-button--default[data-v-5a8124dd]:active,\n.el-button--default[data-v-5a8124dd]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-5a8124dd] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-5a8124dd]:hover,\n.el-button--text[data-v-5a8124dd]:active,\n.el-button--text[data-v-5a8124dd]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-5a8124dd] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-5a8124dd],\n.operate a + .el-button[data-v-5a8124dd],\n.operate span + .el-button[data-v-5a8124dd],\n.operate a + span[data-v-5a8124dd] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-5a8124dd] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-5a8124dd] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-5a8124dd] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-5a8124dd] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-5a8124dd] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-5a8124dd] {\n  color: #fff;\n}\n.el-loading-mask[data-v-5a8124dd] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-5a8124dd] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-5a8124dd]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-5a8124dd]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-5a8124dd]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-5a8124dd]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-5a8124dd] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-5a8124dd] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-5a8124dd] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-5a8124dd] {\n  color: #999;\n}\n.el-select-dropdown[data-v-5a8124dd] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-5a8124dd] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-5a8124dd] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-5a8124dd] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-5a8124dd] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-5a8124dd] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-5a8124dd] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-5a8124dd]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-5a8124dd] {\n  display: none;\n}\n.el-table th > .cell[data-v-5a8124dd] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-5a8124dd] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-5a8124dd] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-5a8124dd] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-5a8124dd]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-5a8124dd]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-5a8124dd] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-5a8124dd] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-5a8124dd] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-5a8124dd] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-5a8124dd] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-5a8124dd] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-5a8124dd] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-5a8124dd] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-5a8124dd],\n.el-pagination .btn-next[data-v-5a8124dd] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-5a8124dd],\n.el-pagination .btn-next span[data-v-5a8124dd] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-5a8124dd] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-5a8124dd] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-5a8124dd] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-5a8124dd] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-5a8124dd] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-5a8124dd] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-5a8124dd] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-5a8124dd] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-5a8124dd] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-5a8124dd] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-5a8124dd] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-5a8124dd] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-5a8124dd] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-5a8124dd] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-5a8124dd] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-5a8124dd] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-5a8124dd] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-5a8124dd] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-5a8124dd] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-5a8124dd] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-5a8124dd] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-5a8124dd] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-5a8124dd] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-5a8124dd] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-5a8124dd] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-5a8124dd] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-5a8124dd] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-5a8124dd] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-5a8124dd] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-5a8124dd]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-5a8124dd] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-5a8124dd] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-5a8124dd] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-5a8124dd] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-5a8124dd] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-5a8124dd] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-5a8124dd] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-5a8124dd] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-5a8124dd] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-5a8124dd] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-5a8124dd] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-5a8124dd],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-5a8124dd] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-5a8124dd] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-5a8124dd] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-5a8124dd] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-5a8124dd] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-5a8124dd] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-5a8124dd] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-5a8124dd] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-5a8124dd] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-5a8124dd] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-5a8124dd] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-5a8124dd] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-5a8124dd] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-5a8124dd] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-5a8124dd] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-5a8124dd] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-5a8124dd] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-5a8124dd] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-5a8124dd] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-5a8124dd] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-5a8124dd] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-5a8124dd] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-5a8124dd] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-5a8124dd] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-5a8124dd] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-5a8124dd] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-5a8124dd] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-5a8124dd] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-5a8124dd] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-5a8124dd]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-5a8124dd] {\n  color: #666666;\n}\n.el-radio__inner[data-v-5a8124dd]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-5a8124dd] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-5a8124dd] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-5a8124dd] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-5a8124dd] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-5a8124dd] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-5a8124dd] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-5a8124dd] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-5a8124dd] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-5a8124dd],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-5a8124dd]:hover,\n.el-input__icon.el-icon-circle-close[data-v-5a8124dd],\n.el-input__icon.el-icon-circle-close[data-v-5a8124dd]:hover {\n  color: #FB304D;\n}\n*[data-v-5a8124dd],\n*[data-v-5a8124dd]:before,\n*[data-v-5a8124dd]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-5a8124dd],\ntextarea[data-v-5a8124dd] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-5a8124dd]:focus {\n  outline: none;\n}\n.el-form[data-v-5a8124dd] .el-form-item__content {\n  margin-bottom: 0.10101rem;\n}\n.user-container[data-v-5a8124dd] {\n  padding: 0.242424rem 0.40404rem 0.282828rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.user-container .form-item[data-v-5a8124dd] {\n  padding: 0.050505rem 0 0.020202rem 0;\n}\n.user-container .form-item .radio-after-text[data-v-5a8124dd] {\n  font-size: 0.070707rem;\n}", ""]);

// exports


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-5ac98730],\nbody[data-v-5ac98730] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-5ac98730]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-5ac98730] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-5ac98730] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-5ac98730] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-5ac98730],\n  .page-contain[data-v-5ac98730],\n  .page-submenu[data-v-5ac98730] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-5ac98730] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-5ac98730] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-5ac98730] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-5ac98730] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-5ac98730] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-5ac98730] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-5ac98730] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-5ac98730] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-5ac98730],\n  .page-submenu[data-v-5ac98730] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-5ac98730] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-5ac98730] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-5ac98730] {\n    width: 76.3vw;\n}\n.v-main[data-v-5ac98730] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-5ac98730] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-5ac98730] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-5ac98730] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-5ac98730] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-5ac98730] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-5ac98730] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-5ac98730],\n  .page-submenu[data-v-5ac98730] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-5ac98730] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-5ac98730] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-5ac98730] {\n    width: 76.3vw;\n}\n.v-main[data-v-5ac98730] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-5ac98730] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-5ac98730] {\n  margin-top: 0.252525rem;\n}\n[data-v-5ac98730]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-5ac98730]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-5ac98730] {\n  text-align: right;\n}\n.aligncenter[data-v-5ac98730] {\n  text-align: center;\n}\n.alignleft[data-v-5ac98730] {\n  text-align: left;\n}\n.actiongroupborder[data-v-5ac98730] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-5ac98730] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-5ac98730] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-5ac98730] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-5ac98730] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-5ac98730] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-5ac98730] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-5ac98730] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-5ac98730] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-5ac98730] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-5ac98730] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-5ac98730] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-5ac98730] {\n  text-align: center;\n}\n.alignleft[data-v-5ac98730] {\n  text-align: left;\n}\n.alignright[data-v-5ac98730] {\n  text-align: right;\n}\n.e2e-container[data-v-5ac98730] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-5ac98730] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-5ac98730] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-5ac98730] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-5ac98730] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-5ac98730] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-5ac98730] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-5ac98730] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-5ac98730] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-5ac98730] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-5ac98730] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-5ac98730],\n.e2e-red-point-left[data-v-5ac98730] {\n  position: relative;\n}\n.e2e-red-point[data-v-5ac98730]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-5ac98730]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-5ac98730] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-5ac98730] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-5ac98730] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-5ac98730] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-5ac98730] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-5ac98730] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-5ac98730] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-5ac98730] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-5ac98730] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-5ac98730] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-5ac98730] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-5ac98730] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-5ac98730] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-5ac98730]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-5ac98730] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-5ac98730] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-5ac98730],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-5ac98730] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-5ac98730],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-5ac98730] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-5ac98730],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-5ac98730] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-5ac98730],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-5ac98730] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-5ac98730],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-5ac98730] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-5ac98730],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-5ac98730] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-5ac98730] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-5ac98730] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-5ac98730] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-5ac98730] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-5ac98730] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-5ac98730] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-5ac98730] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-5ac98730] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-5ac98730]:hover,\n.el-button--primary[data-v-5ac98730]:active,\n.el-button--primary[data-v-5ac98730]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-5ac98730] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-5ac98730]:hover,\n.el-button--primary.is-plain[data-v-5ac98730]:active,\n.el-button--primary.is-plain[data-v-5ac98730]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-5ac98730] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-5ac98730]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-5ac98730]:active,\n.el-button--primary.is-plain.is-disabled[data-v-5ac98730]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-5ac98730] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-5ac98730]:hover,\n.el-button--primary.is-disabled[data-v-5ac98730]:active,\n.el-button--primary.is-disabled[data-v-5ac98730]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-5ac98730] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-5ac98730]:hover,\n.el-button--default[data-v-5ac98730]:active,\n.el-button--default[data-v-5ac98730]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-5ac98730] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-5ac98730]:hover,\n.el-button--text[data-v-5ac98730]:active,\n.el-button--text[data-v-5ac98730]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-5ac98730] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-5ac98730],\n.operate a + .el-button[data-v-5ac98730],\n.operate span + .el-button[data-v-5ac98730],\n.operate a + span[data-v-5ac98730] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-5ac98730] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-5ac98730] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-5ac98730] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-5ac98730] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-5ac98730] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-5ac98730] {\n  color: #fff;\n}\n.el-loading-mask[data-v-5ac98730] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-5ac98730] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-5ac98730]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-5ac98730]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-5ac98730]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-5ac98730]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-5ac98730] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-5ac98730] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-5ac98730] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-5ac98730] {\n  color: #999;\n}\n.el-select-dropdown[data-v-5ac98730] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-5ac98730] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-5ac98730] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-5ac98730] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-5ac98730] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-5ac98730] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-5ac98730] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-5ac98730]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-5ac98730] {\n  display: none;\n}\n.el-table th > .cell[data-v-5ac98730] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-5ac98730] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-5ac98730] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-5ac98730] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-5ac98730]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-5ac98730]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-5ac98730] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-5ac98730] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-5ac98730] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-5ac98730] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-5ac98730] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-5ac98730] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-5ac98730] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-5ac98730] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-5ac98730],\n.el-pagination .btn-next[data-v-5ac98730] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-5ac98730],\n.el-pagination .btn-next span[data-v-5ac98730] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-5ac98730] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-5ac98730] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-5ac98730] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-5ac98730] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-5ac98730] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-5ac98730] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-5ac98730] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-5ac98730] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-5ac98730] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-5ac98730] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-5ac98730] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-5ac98730] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-5ac98730] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-5ac98730] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-5ac98730] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-5ac98730] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-5ac98730] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-5ac98730] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-5ac98730] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-5ac98730] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-5ac98730] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-5ac98730] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-5ac98730] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-5ac98730] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-5ac98730] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-5ac98730] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-5ac98730] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-5ac98730] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-5ac98730] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-5ac98730]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-5ac98730] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-5ac98730] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-5ac98730] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-5ac98730] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-5ac98730] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-5ac98730] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-5ac98730] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-5ac98730] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-5ac98730] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-5ac98730] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-5ac98730] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-5ac98730],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-5ac98730] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-5ac98730] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-5ac98730] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-5ac98730] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-5ac98730] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-5ac98730] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-5ac98730] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-5ac98730] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-5ac98730] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-5ac98730] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-5ac98730] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-5ac98730] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-5ac98730] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-5ac98730] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-5ac98730] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-5ac98730] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-5ac98730] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-5ac98730] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-5ac98730] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-5ac98730] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-5ac98730] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-5ac98730] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-5ac98730] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-5ac98730] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-5ac98730] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-5ac98730] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-5ac98730] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-5ac98730] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-5ac98730] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-5ac98730]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-5ac98730] {\n  color: #666666;\n}\n.el-radio__inner[data-v-5ac98730]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-5ac98730] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-5ac98730] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-5ac98730] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-5ac98730] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-5ac98730] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-5ac98730] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-5ac98730] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-5ac98730] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-5ac98730],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-5ac98730]:hover,\n.el-input__icon.el-icon-circle-close[data-v-5ac98730],\n.el-input__icon.el-icon-circle-close[data-v-5ac98730]:hover {\n  color: #FB304D;\n}\n*[data-v-5ac98730],\n*[data-v-5ac98730]:before,\n*[data-v-5ac98730]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-5ac98730],\ntextarea[data-v-5ac98730] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-5ac98730]:focus {\n  outline: none;\n}\n.search-content[data-v-5ac98730] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 0.111111rem;\n}\n.search-content .search-content-fields[data-v-5ac98730] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.search-content .search-content-fields .el-row .col-full[data-v-5ac98730] {\n  width: 3.525253rem;\n}\n.search-content .search-content-fields .el-row .el-col[data-v-5ac98730] {\n  width: 1.111111rem;\n}\n.search-content .search-content-fields .el-row .el-col + .el-col[data-v-5ac98730] {\n  margin-left: 0.141414rem;\n}\n.search-content .search-content-fields .search-btn[data-v-5ac98730] {\n  margin-top: 0.631313rem;\n  margin-left: 0.070707rem;\n}\n.search-content .search-content-fields .search-btn button[data-v-5ac98730] {\n  width: 0.606061rem;\n}\n.operate[data-v-5ac98730] {\n  float: right;\n  margin-bottom: 0.151515rem;\n}\n.operate .add-btn[data-v-5ac98730] {\n  width: 0.606061rem;\n}\n.operate .batch-download-btn[data-v-5ac98730],\n.operate .batch-delete-btn[data-v-5ac98730] {\n  width: 0.439394rem;\n  padding: 0;\n}\n.operate .el-button + .el-button[data-v-5ac98730] {\n  margin-left: 0.131313rem;\n}", ""]);

// exports


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-60b986d2],\nbody[data-v-60b986d2] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-60b986d2]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-60b986d2] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-60b986d2] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-60b986d2] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-60b986d2],\n  .page-contain[data-v-60b986d2],\n  .page-submenu[data-v-60b986d2] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-60b986d2] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-60b986d2] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-60b986d2] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-60b986d2] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-60b986d2] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-60b986d2] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-60b986d2] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-60b986d2] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-60b986d2],\n  .page-submenu[data-v-60b986d2] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-60b986d2] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-60b986d2] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-60b986d2] {\n    width: 76.3vw;\n}\n.v-main[data-v-60b986d2] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-60b986d2] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-60b986d2] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-60b986d2] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-60b986d2] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-60b986d2] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-60b986d2] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-60b986d2],\n  .page-submenu[data-v-60b986d2] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-60b986d2] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-60b986d2] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-60b986d2] {\n    width: 76.3vw;\n}\n.v-main[data-v-60b986d2] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-60b986d2] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-60b986d2] {\n  margin-top: 0.252525rem;\n}\n[data-v-60b986d2]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-60b986d2]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-60b986d2] {\n  text-align: right;\n}\n.aligncenter[data-v-60b986d2] {\n  text-align: center;\n}\n.alignleft[data-v-60b986d2] {\n  text-align: left;\n}\n.actiongroupborder[data-v-60b986d2] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-60b986d2] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-60b986d2] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-60b986d2] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-60b986d2] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-60b986d2] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-60b986d2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-60b986d2] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-60b986d2] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-60b986d2] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-60b986d2] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-60b986d2] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-60b986d2] {\n  text-align: center;\n}\n.alignleft[data-v-60b986d2] {\n  text-align: left;\n}\n.alignright[data-v-60b986d2] {\n  text-align: right;\n}\n.e2e-container[data-v-60b986d2] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-60b986d2] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-60b986d2] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-60b986d2] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-60b986d2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-60b986d2] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-60b986d2] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-60b986d2] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-60b986d2] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-60b986d2] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-60b986d2] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-60b986d2],\n.e2e-red-point-left[data-v-60b986d2] {\n  position: relative;\n}\n.e2e-red-point[data-v-60b986d2]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-60b986d2]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-60b986d2] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-60b986d2] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-60b986d2] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-60b986d2] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-60b986d2] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-60b986d2] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-60b986d2] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-60b986d2] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-60b986d2] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-60b986d2] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-60b986d2] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-60b986d2] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-60b986d2] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-60b986d2]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-60b986d2] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-60b986d2] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-60b986d2],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-60b986d2] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-60b986d2],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-60b986d2] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-60b986d2],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-60b986d2] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-60b986d2],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-60b986d2] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-60b986d2],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-60b986d2] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-60b986d2],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-60b986d2] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-60b986d2] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-60b986d2] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-60b986d2] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-60b986d2] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-60b986d2] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-60b986d2] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-60b986d2] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-60b986d2] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-60b986d2]:hover,\n.el-button--primary[data-v-60b986d2]:active,\n.el-button--primary[data-v-60b986d2]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-60b986d2] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-60b986d2]:hover,\n.el-button--primary.is-plain[data-v-60b986d2]:active,\n.el-button--primary.is-plain[data-v-60b986d2]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-60b986d2] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-60b986d2]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-60b986d2]:active,\n.el-button--primary.is-plain.is-disabled[data-v-60b986d2]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-60b986d2] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-60b986d2]:hover,\n.el-button--primary.is-disabled[data-v-60b986d2]:active,\n.el-button--primary.is-disabled[data-v-60b986d2]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-60b986d2] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-60b986d2]:hover,\n.el-button--default[data-v-60b986d2]:active,\n.el-button--default[data-v-60b986d2]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-60b986d2] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-60b986d2]:hover,\n.el-button--text[data-v-60b986d2]:active,\n.el-button--text[data-v-60b986d2]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-60b986d2] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-60b986d2],\n.operate a + .el-button[data-v-60b986d2],\n.operate span + .el-button[data-v-60b986d2],\n.operate a + span[data-v-60b986d2] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-60b986d2] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-60b986d2] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-60b986d2] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-60b986d2] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-60b986d2] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-60b986d2] {\n  color: #fff;\n}\n.el-loading-mask[data-v-60b986d2] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-60b986d2] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-60b986d2]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-60b986d2]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-60b986d2]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-60b986d2]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-60b986d2] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-60b986d2] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-60b986d2] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-60b986d2] {\n  color: #999;\n}\n.el-select-dropdown[data-v-60b986d2] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-60b986d2] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-60b986d2] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-60b986d2] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-60b986d2] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-60b986d2] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-60b986d2] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-60b986d2]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-60b986d2] {\n  display: none;\n}\n.el-table th > .cell[data-v-60b986d2] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-60b986d2] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-60b986d2] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-60b986d2] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-60b986d2]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-60b986d2]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-60b986d2] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-60b986d2] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-60b986d2] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-60b986d2] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-60b986d2] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-60b986d2] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-60b986d2] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-60b986d2] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-60b986d2],\n.el-pagination .btn-next[data-v-60b986d2] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-60b986d2],\n.el-pagination .btn-next span[data-v-60b986d2] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-60b986d2] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-60b986d2] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-60b986d2] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-60b986d2] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-60b986d2] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-60b986d2] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-60b986d2] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-60b986d2] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-60b986d2] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-60b986d2] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-60b986d2] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-60b986d2] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-60b986d2] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-60b986d2] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-60b986d2] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-60b986d2] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-60b986d2] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-60b986d2] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-60b986d2] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-60b986d2] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-60b986d2] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-60b986d2] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-60b986d2] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-60b986d2] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-60b986d2] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-60b986d2] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-60b986d2] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-60b986d2] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-60b986d2] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-60b986d2]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-60b986d2] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-60b986d2] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-60b986d2] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-60b986d2] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-60b986d2] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-60b986d2] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-60b986d2] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-60b986d2] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-60b986d2] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-60b986d2] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-60b986d2] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-60b986d2],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-60b986d2] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-60b986d2] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-60b986d2] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-60b986d2] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-60b986d2] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-60b986d2] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-60b986d2] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-60b986d2] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-60b986d2] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-60b986d2] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-60b986d2] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-60b986d2] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-60b986d2] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-60b986d2] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-60b986d2] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-60b986d2] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-60b986d2] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-60b986d2] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-60b986d2] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-60b986d2] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-60b986d2] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-60b986d2] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-60b986d2] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-60b986d2] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-60b986d2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-60b986d2] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-60b986d2] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-60b986d2] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-60b986d2] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-60b986d2]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-60b986d2] {\n  color: #666666;\n}\n.el-radio__inner[data-v-60b986d2]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-60b986d2] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-60b986d2] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-60b986d2] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-60b986d2] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-60b986d2] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-60b986d2] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-60b986d2] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-60b986d2] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-60b986d2],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-60b986d2]:hover,\n.el-input__icon.el-icon-circle-close[data-v-60b986d2],\n.el-input__icon.el-icon-circle-close[data-v-60b986d2]:hover {\n  color: #FB304D;\n}\n*[data-v-60b986d2],\n*[data-v-60b986d2]:before,\n*[data-v-60b986d2]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-60b986d2],\ntextarea[data-v-60b986d2] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-60b986d2]:focus {\n  outline: none;\n}\n.message-box[data-v-60b986d2] {\n  width: 4.040404rem;\n  background: #f8f8f8;\n  border-radius: 0.020202rem;\n  margin-left: 1.010101rem;\n  min-height: 0.454545rem;\n}\n.message-box-title[data-v-60b986d2] {\n  font-size: 0.070707rem;\n  font-weight: bold;\n  color: #333333;\n  height: 0.10101rem;\n  line-height: 0.10101rem;\n  padding: 0.121212rem 0 0 0.121212rem;\n}\n.message-box-content[data-v-60b986d2] {\n  margin-top: 0.126263rem;\n  padding-bottom: 0.111111rem;\n}\n.message-box-content-info[data-v-60b986d2] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.10101rem;\n  margin-left: 0.121212rem;\n  width: 3.535354rem;\n}\n.message-box-content-operator[data-v-60b986d2] {\n  float: right;\n  margin: -0.131313rem 0.09596rem 0 0;\n}\n.message-box + .message-box[data-v-60b986d2] {\n  margin-top: 0.121212rem;\n}", ""]);

// exports


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-648200e0],\nbody[data-v-648200e0] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-648200e0]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-648200e0] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-648200e0] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-648200e0] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-648200e0],\n  .page-contain[data-v-648200e0],\n  .page-submenu[data-v-648200e0] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-648200e0] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-648200e0] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-648200e0] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-648200e0] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-648200e0] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-648200e0] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-648200e0] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-648200e0] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-648200e0],\n  .page-submenu[data-v-648200e0] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-648200e0] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-648200e0] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-648200e0] {\n    width: 76.3vw;\n}\n.v-main[data-v-648200e0] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-648200e0] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-648200e0] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-648200e0] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-648200e0] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-648200e0] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-648200e0] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-648200e0],\n  .page-submenu[data-v-648200e0] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-648200e0] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-648200e0] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-648200e0] {\n    width: 76.3vw;\n}\n.v-main[data-v-648200e0] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-648200e0] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-648200e0] {\n  margin-top: 0.252525rem;\n}\n[data-v-648200e0]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-648200e0]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-648200e0] {\n  text-align: right;\n}\n.aligncenter[data-v-648200e0] {\n  text-align: center;\n}\n.alignleft[data-v-648200e0] {\n  text-align: left;\n}\n.actiongroupborder[data-v-648200e0] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-648200e0] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-648200e0] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-648200e0] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-648200e0] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-648200e0] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-648200e0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-648200e0] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-648200e0] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-648200e0] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-648200e0] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-648200e0] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-648200e0] {\n  text-align: center;\n}\n.alignleft[data-v-648200e0] {\n  text-align: left;\n}\n.alignright[data-v-648200e0] {\n  text-align: right;\n}\n.e2e-container[data-v-648200e0] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-648200e0] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-648200e0] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-648200e0] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-648200e0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-648200e0] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-648200e0] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-648200e0] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-648200e0] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-648200e0] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-648200e0] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-648200e0],\n.e2e-red-point-left[data-v-648200e0] {\n  position: relative;\n}\n.e2e-red-point[data-v-648200e0]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-648200e0]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-648200e0] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-648200e0] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-648200e0] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-648200e0] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-648200e0] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-648200e0] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-648200e0] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-648200e0] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-648200e0] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-648200e0] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-648200e0] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-648200e0] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-648200e0] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-648200e0]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-648200e0] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-648200e0] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-648200e0],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-648200e0] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-648200e0],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-648200e0] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-648200e0],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-648200e0] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-648200e0],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-648200e0] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-648200e0],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-648200e0] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-648200e0],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-648200e0] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-648200e0] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-648200e0] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-648200e0] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-648200e0] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-648200e0] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-648200e0] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-648200e0] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-648200e0] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-648200e0]:hover,\n.el-button--primary[data-v-648200e0]:active,\n.el-button--primary[data-v-648200e0]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-648200e0] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-648200e0]:hover,\n.el-button--primary.is-plain[data-v-648200e0]:active,\n.el-button--primary.is-plain[data-v-648200e0]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-648200e0] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-648200e0]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-648200e0]:active,\n.el-button--primary.is-plain.is-disabled[data-v-648200e0]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-648200e0] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-648200e0]:hover,\n.el-button--primary.is-disabled[data-v-648200e0]:active,\n.el-button--primary.is-disabled[data-v-648200e0]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-648200e0] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-648200e0]:hover,\n.el-button--default[data-v-648200e0]:active,\n.el-button--default[data-v-648200e0]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-648200e0] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-648200e0]:hover,\n.el-button--text[data-v-648200e0]:active,\n.el-button--text[data-v-648200e0]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-648200e0] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-648200e0],\n.operate a + .el-button[data-v-648200e0],\n.operate span + .el-button[data-v-648200e0],\n.operate a + span[data-v-648200e0] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-648200e0] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-648200e0] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-648200e0] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-648200e0] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-648200e0] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-648200e0] {\n  color: #fff;\n}\n.el-loading-mask[data-v-648200e0] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-648200e0] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-648200e0]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-648200e0]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-648200e0]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-648200e0]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-648200e0] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-648200e0] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-648200e0] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-648200e0] {\n  color: #999;\n}\n.el-select-dropdown[data-v-648200e0] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-648200e0] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-648200e0] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-648200e0] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-648200e0] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-648200e0] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-648200e0] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-648200e0]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-648200e0] {\n  display: none;\n}\n.el-table th > .cell[data-v-648200e0] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-648200e0] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-648200e0] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-648200e0] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-648200e0]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-648200e0]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-648200e0] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-648200e0] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-648200e0] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-648200e0] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-648200e0] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-648200e0] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-648200e0] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-648200e0] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-648200e0],\n.el-pagination .btn-next[data-v-648200e0] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-648200e0],\n.el-pagination .btn-next span[data-v-648200e0] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-648200e0] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-648200e0] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-648200e0] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-648200e0] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-648200e0] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-648200e0] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-648200e0] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-648200e0] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-648200e0] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-648200e0] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-648200e0] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-648200e0] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-648200e0] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-648200e0] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-648200e0] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-648200e0] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-648200e0] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-648200e0] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-648200e0] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-648200e0] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-648200e0] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-648200e0] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-648200e0] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-648200e0] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-648200e0] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-648200e0] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-648200e0] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-648200e0] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-648200e0] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-648200e0]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-648200e0] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-648200e0] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-648200e0] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-648200e0] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-648200e0] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-648200e0] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-648200e0] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-648200e0] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-648200e0] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-648200e0] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-648200e0] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-648200e0],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-648200e0] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-648200e0] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-648200e0] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-648200e0] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-648200e0] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-648200e0] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-648200e0] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-648200e0] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-648200e0] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-648200e0] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-648200e0] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-648200e0] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-648200e0] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-648200e0] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-648200e0] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-648200e0] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-648200e0] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-648200e0] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-648200e0] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-648200e0] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-648200e0] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-648200e0] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-648200e0] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-648200e0] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-648200e0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-648200e0] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-648200e0] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-648200e0] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-648200e0] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-648200e0]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-648200e0] {\n  color: #666666;\n}\n.el-radio__inner[data-v-648200e0]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-648200e0] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-648200e0] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-648200e0] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-648200e0] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-648200e0] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-648200e0] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-648200e0] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-648200e0] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-648200e0],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-648200e0]:hover,\n.el-input__icon.el-icon-circle-close[data-v-648200e0],\n.el-input__icon.el-icon-circle-close[data-v-648200e0]:hover {\n  color: #FB304D;\n}\n*[data-v-648200e0],\n*[data-v-648200e0]:before,\n*[data-v-648200e0]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-648200e0],\ntextarea[data-v-648200e0] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-648200e0]:focus {\n  outline: none;\n}\n.option[data-v-648200e0] {\n  height: auto;\n  line-height: 1;\n  padding: 0;\n  background-color: #fff;\n}\n.tree[data-v-648200e0] {\n  padding: 0.020202rem 0.10101rem;\n  font-weight: 400;\n}", ""]);

// exports


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-686a6933],\nbody[data-v-686a6933] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-686a6933]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-686a6933] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-686a6933] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-686a6933] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-686a6933],\n  .page-contain[data-v-686a6933],\n  .page-submenu[data-v-686a6933] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-686a6933] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-686a6933] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-686a6933] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-686a6933] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-686a6933] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-686a6933] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-686a6933] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-686a6933] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-686a6933],\n  .page-submenu[data-v-686a6933] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-686a6933] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-686a6933] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-686a6933] {\n    width: 76.3vw;\n}\n.v-main[data-v-686a6933] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-686a6933] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-686a6933] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-686a6933] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-686a6933] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-686a6933] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-686a6933] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-686a6933],\n  .page-submenu[data-v-686a6933] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-686a6933] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-686a6933] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-686a6933] {\n    width: 76.3vw;\n}\n.v-main[data-v-686a6933] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-686a6933] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-686a6933] {\n  margin-top: 0.252525rem;\n}\n[data-v-686a6933]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-686a6933]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-686a6933] {\n  text-align: right;\n}\n.aligncenter[data-v-686a6933] {\n  text-align: center;\n}\n.alignleft[data-v-686a6933] {\n  text-align: left;\n}\n.actiongroupborder[data-v-686a6933] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-686a6933] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-686a6933] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-686a6933] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-686a6933] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-686a6933] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-686a6933] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-686a6933] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-686a6933] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-686a6933] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-686a6933] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-686a6933] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-686a6933] {\n  text-align: center;\n}\n.alignleft[data-v-686a6933] {\n  text-align: left;\n}\n.alignright[data-v-686a6933] {\n  text-align: right;\n}\n.e2e-container[data-v-686a6933] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-686a6933] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-686a6933] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-686a6933] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-686a6933] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-686a6933] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-686a6933] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-686a6933] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-686a6933] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-686a6933] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-686a6933] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-686a6933],\n.e2e-red-point-left[data-v-686a6933] {\n  position: relative;\n}\n.e2e-red-point[data-v-686a6933]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-686a6933]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-686a6933] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-686a6933] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-686a6933] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-686a6933] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-686a6933] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-686a6933] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-686a6933] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-686a6933] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-686a6933] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-686a6933] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-686a6933] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-686a6933] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-686a6933] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-686a6933]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-686a6933] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-686a6933] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-686a6933],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-686a6933] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-686a6933],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-686a6933] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-686a6933],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-686a6933] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-686a6933],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-686a6933] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-686a6933],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-686a6933] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-686a6933],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-686a6933] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-686a6933] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-686a6933] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-686a6933] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-686a6933] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-686a6933] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-686a6933] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-686a6933] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-686a6933] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-686a6933]:hover,\n.el-button--primary[data-v-686a6933]:active,\n.el-button--primary[data-v-686a6933]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-686a6933] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-686a6933]:hover,\n.el-button--primary.is-plain[data-v-686a6933]:active,\n.el-button--primary.is-plain[data-v-686a6933]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-686a6933] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-686a6933]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-686a6933]:active,\n.el-button--primary.is-plain.is-disabled[data-v-686a6933]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-686a6933] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-686a6933]:hover,\n.el-button--primary.is-disabled[data-v-686a6933]:active,\n.el-button--primary.is-disabled[data-v-686a6933]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-686a6933] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-686a6933]:hover,\n.el-button--default[data-v-686a6933]:active,\n.el-button--default[data-v-686a6933]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-686a6933] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-686a6933]:hover,\n.el-button--text[data-v-686a6933]:active,\n.el-button--text[data-v-686a6933]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-686a6933] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-686a6933],\n.operate a + .el-button[data-v-686a6933],\n.operate span + .el-button[data-v-686a6933],\n.operate a + span[data-v-686a6933] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-686a6933] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-686a6933] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-686a6933] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-686a6933] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-686a6933] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-686a6933] {\n  color: #fff;\n}\n.el-loading-mask[data-v-686a6933] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-686a6933] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-686a6933]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-686a6933]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-686a6933]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-686a6933]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-686a6933] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-686a6933] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-686a6933] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-686a6933] {\n  color: #999;\n}\n.el-select-dropdown[data-v-686a6933] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-686a6933] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-686a6933] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-686a6933] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-686a6933] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-686a6933] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-686a6933] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-686a6933]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-686a6933] {\n  display: none;\n}\n.el-table th > .cell[data-v-686a6933] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-686a6933] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-686a6933] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-686a6933] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-686a6933]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-686a6933]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-686a6933] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-686a6933] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-686a6933] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-686a6933] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-686a6933] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-686a6933] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-686a6933] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-686a6933] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-686a6933],\n.el-pagination .btn-next[data-v-686a6933] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-686a6933],\n.el-pagination .btn-next span[data-v-686a6933] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-686a6933] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-686a6933] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-686a6933] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-686a6933] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-686a6933] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-686a6933] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-686a6933] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-686a6933] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-686a6933] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-686a6933] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-686a6933] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-686a6933] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-686a6933] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-686a6933] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-686a6933] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-686a6933] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-686a6933] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-686a6933] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-686a6933] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-686a6933] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-686a6933] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-686a6933] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-686a6933] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-686a6933] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-686a6933] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-686a6933] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-686a6933] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-686a6933] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-686a6933] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-686a6933]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-686a6933] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-686a6933] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-686a6933] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-686a6933] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-686a6933] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-686a6933] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-686a6933] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-686a6933] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-686a6933] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-686a6933] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-686a6933] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-686a6933],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-686a6933] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-686a6933] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-686a6933] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-686a6933] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-686a6933] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-686a6933] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-686a6933] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-686a6933] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-686a6933] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-686a6933] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-686a6933] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-686a6933] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-686a6933] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-686a6933] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-686a6933] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-686a6933] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-686a6933] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-686a6933] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-686a6933] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-686a6933] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-686a6933] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-686a6933] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-686a6933] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-686a6933] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-686a6933] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-686a6933] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-686a6933] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-686a6933] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-686a6933] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-686a6933]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-686a6933] {\n  color: #666666;\n}\n.el-radio__inner[data-v-686a6933]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-686a6933] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-686a6933] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-686a6933] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-686a6933] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-686a6933] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-686a6933] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-686a6933] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-686a6933] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-686a6933],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-686a6933]:hover,\n.el-input__icon.el-icon-circle-close[data-v-686a6933],\n.el-input__icon.el-icon-circle-close[data-v-686a6933]:hover {\n  color: #FB304D;\n}\n*[data-v-686a6933],\n*[data-v-686a6933]:before,\n*[data-v-686a6933]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-686a6933],\ntextarea[data-v-686a6933] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-686a6933]:focus {\n  outline: none;\n}\n.page-drawer[data-v-686a6933] {\n  width: 4.141414rem;\n  height: 4.040404rem;\n  overflow-y: auto;\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.search-content[data-v-686a6933] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.search-content .search-content-fields[data-v-686a6933] {\n  width: 4.040404rem;\n}\n.operate[data-v-686a6933] {\n  float: right;\n}\n.search-result[data-v-686a6933] {\n  margin-top: 0.313131rem;\n}", ""]);

// exports


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml,\nbody {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.v-main,\n  .page-contain,\n  .page-submenu {\n    width: 6.060606rem;\n}\n.page-submenu_left {\n    width: 1.313131rem;\n}\n.page-submenu_right {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n.has-header {\n  margin-top: 0.252525rem;\n}\n::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright {\n  text-align: right;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.common_reddot_item {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label {\n  line-height: 0.10101rem;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.alignright {\n  text-align: right;\n}\n.e2e-container {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell {\n  overflow: visible;\n}\n.e2e-red-point,\n.e2e-red-point-left {\n  position: relative;\n}\n.e2e-red-point::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small /deep/ input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small /deep/ input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray /deep/ input {\n  background: #efefef;\n}\n.e2e-radio-large /deep/ .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money {\n  color: #0B41CD;\n}\n.e2e-copy {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy:before {\n  content: '\\E787';\n}\n.e2e-warning {\n  color: #e02020;\n}\n.e2e-warning-blue {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button {\n  font-size: 0.065657rem;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.el-button {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary:hover,\n.el-button--primary:active,\n.el-button--primary:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain:hover,\n.el-button--primary.is-plain:active,\n.el-button--primary.is-plain:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled:hover,\n.el-button--primary.is-plain.is-disabled:active,\n.el-button--primary.is-plain.is-disabled:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled:hover,\n.el-button--primary.is-disabled:active,\n.el-button--primary.is-disabled:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default:hover,\n.el-button--default:active,\n.el-button--default:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text:hover,\n.el-button--text:active,\n.el-button--text:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled {\n  color: #6D7278;\n}\n.operate .el-button + .el-button,\n.operate a + .el-button,\n.operate span + .el-button,\n.operate a + span {\n  margin-left: 0.121212rem;\n}\n.operate span > div {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text {\n  color: #fff;\n}\n.el-loading-mask {\n  z-index: 9998;\n}\n.el-input__inner {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.is-disabled.el-input :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.el-select-dropdown {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label {\n  padding: 0;\n}\n.header-menu-dropdown {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow {\n  display: none;\n}\n.el-table th > .cell {\n  font-weight: bold !important;\n}\n.el-table .cell {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell {\n  padding-left: 0.070707rem;\n}\n.el-table td {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev,\n.el-pagination .btn-next {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span,\n.el-pagination .btn-next span {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog {\n  border-radius: 0.020202rem;\n}\n.el-drawer {\n  overflow: auto;\n}\n.common-confirm-dialog {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog {\n  width: 3.030303rem !important;\n}\n.approval-dialog {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select,\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer {\n  text-align: center;\n}\n.application-search-content-main-fields .active {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label {\n  color: #666666;\n}\n.el-radio__inner:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label {\n  color: #E64100;\n}\n.tox-tinymce-aux {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper {\n  width: 0.757576rem;\n}\n.custom-tooltip {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close,\n.el-select__caret.el-input__icon.el-icon-circle-close:hover,\n.el-input__icon.el-icon-circle-close,\n.el-input__icon.el-icon-circle-close:hover {\n  color: #FB304D;\n}\n*,\n*:before,\n*:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput,\ntextarea {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput:focus {\n  outline: none;\n}\n.search-content-main-fields .el-tag--info {\n  max-width: 0.707071rem;\n  min-width: 0.227273rem;\n  padding-right: 0.075758rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  position: relative;\n}\n.search-content-main-fields .el-tag--info .el-tag__close {\n  position: absolute;\n  right: -0.005051rem;\n  top: 0.025253rem;\n}\n.dashboard-effectiveness .chart-class-1 {\n  margin: 0.080808rem 0.121212rem;\n  height: 2.525253rem;\n  width: 100%;\n}", ""]);

// exports


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-6911dd6e],\nbody[data-v-6911dd6e] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-6911dd6e]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-6911dd6e] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-6911dd6e] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-6911dd6e] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-6911dd6e],\n  .page-contain[data-v-6911dd6e],\n  .page-submenu[data-v-6911dd6e] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-6911dd6e] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-6911dd6e] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-6911dd6e] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-6911dd6e] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-6911dd6e] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-6911dd6e] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-6911dd6e] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-6911dd6e] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-6911dd6e],\n  .page-submenu[data-v-6911dd6e] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-6911dd6e] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-6911dd6e] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-6911dd6e] {\n    width: 76.3vw;\n}\n.v-main[data-v-6911dd6e] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-6911dd6e] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-6911dd6e] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-6911dd6e] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-6911dd6e] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-6911dd6e] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-6911dd6e] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-6911dd6e],\n  .page-submenu[data-v-6911dd6e] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-6911dd6e] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-6911dd6e] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-6911dd6e] {\n    width: 76.3vw;\n}\n.v-main[data-v-6911dd6e] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-6911dd6e] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-6911dd6e] {\n  margin-top: 0.252525rem;\n}\n[data-v-6911dd6e]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-6911dd6e]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-6911dd6e] {\n  text-align: right;\n}\n.aligncenter[data-v-6911dd6e] {\n  text-align: center;\n}\n.alignleft[data-v-6911dd6e] {\n  text-align: left;\n}\n.actiongroupborder[data-v-6911dd6e] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-6911dd6e] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-6911dd6e] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-6911dd6e] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-6911dd6e] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-6911dd6e] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-6911dd6e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-6911dd6e] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-6911dd6e] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-6911dd6e] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-6911dd6e] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-6911dd6e] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-6911dd6e] {\n  text-align: center;\n}\n.alignleft[data-v-6911dd6e] {\n  text-align: left;\n}\n.alignright[data-v-6911dd6e] {\n  text-align: right;\n}\n.e2e-container[data-v-6911dd6e] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-6911dd6e] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-6911dd6e] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-6911dd6e] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-6911dd6e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-6911dd6e] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-6911dd6e] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-6911dd6e] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-6911dd6e] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-6911dd6e] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-6911dd6e] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-6911dd6e],\n.e2e-red-point-left[data-v-6911dd6e] {\n  position: relative;\n}\n.e2e-red-point[data-v-6911dd6e]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-6911dd6e]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-6911dd6e] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-6911dd6e] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-6911dd6e] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-6911dd6e] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-6911dd6e] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-6911dd6e] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-6911dd6e] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-6911dd6e] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-6911dd6e] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-6911dd6e] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-6911dd6e] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-6911dd6e] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-6911dd6e] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-6911dd6e]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-6911dd6e] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-6911dd6e] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-6911dd6e],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-6911dd6e] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-6911dd6e],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-6911dd6e] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-6911dd6e],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-6911dd6e] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-6911dd6e],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-6911dd6e] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-6911dd6e],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-6911dd6e] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-6911dd6e],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-6911dd6e] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-6911dd6e] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-6911dd6e] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-6911dd6e] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-6911dd6e] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-6911dd6e] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-6911dd6e] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-6911dd6e] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-6911dd6e] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-6911dd6e]:hover,\n.el-button--primary[data-v-6911dd6e]:active,\n.el-button--primary[data-v-6911dd6e]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-6911dd6e] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-6911dd6e]:hover,\n.el-button--primary.is-plain[data-v-6911dd6e]:active,\n.el-button--primary.is-plain[data-v-6911dd6e]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-6911dd6e] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-6911dd6e]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-6911dd6e]:active,\n.el-button--primary.is-plain.is-disabled[data-v-6911dd6e]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-6911dd6e] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-6911dd6e]:hover,\n.el-button--primary.is-disabled[data-v-6911dd6e]:active,\n.el-button--primary.is-disabled[data-v-6911dd6e]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-6911dd6e] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-6911dd6e]:hover,\n.el-button--default[data-v-6911dd6e]:active,\n.el-button--default[data-v-6911dd6e]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-6911dd6e] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-6911dd6e]:hover,\n.el-button--text[data-v-6911dd6e]:active,\n.el-button--text[data-v-6911dd6e]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-6911dd6e] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-6911dd6e],\n.operate a + .el-button[data-v-6911dd6e],\n.operate span + .el-button[data-v-6911dd6e],\n.operate a + span[data-v-6911dd6e] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-6911dd6e] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-6911dd6e] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-6911dd6e] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-6911dd6e] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-6911dd6e] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-6911dd6e] {\n  color: #fff;\n}\n.el-loading-mask[data-v-6911dd6e] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-6911dd6e] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-6911dd6e]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-6911dd6e]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-6911dd6e]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-6911dd6e]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-6911dd6e] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-6911dd6e] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-6911dd6e] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-6911dd6e] {\n  color: #999;\n}\n.el-select-dropdown[data-v-6911dd6e] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-6911dd6e] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-6911dd6e] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-6911dd6e] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-6911dd6e] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-6911dd6e] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-6911dd6e] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-6911dd6e]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-6911dd6e] {\n  display: none;\n}\n.el-table th > .cell[data-v-6911dd6e] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-6911dd6e] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-6911dd6e] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-6911dd6e] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-6911dd6e]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-6911dd6e]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-6911dd6e] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-6911dd6e] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-6911dd6e] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-6911dd6e] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-6911dd6e] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-6911dd6e] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-6911dd6e] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-6911dd6e] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-6911dd6e],\n.el-pagination .btn-next[data-v-6911dd6e] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-6911dd6e],\n.el-pagination .btn-next span[data-v-6911dd6e] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-6911dd6e] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-6911dd6e] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-6911dd6e] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-6911dd6e] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-6911dd6e] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-6911dd6e] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-6911dd6e] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-6911dd6e] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-6911dd6e] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-6911dd6e] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-6911dd6e] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-6911dd6e] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-6911dd6e] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-6911dd6e] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-6911dd6e] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-6911dd6e] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-6911dd6e] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-6911dd6e] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-6911dd6e] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-6911dd6e] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-6911dd6e] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-6911dd6e] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-6911dd6e] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-6911dd6e] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-6911dd6e] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-6911dd6e] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-6911dd6e] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-6911dd6e] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-6911dd6e] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-6911dd6e]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-6911dd6e] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-6911dd6e] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-6911dd6e] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-6911dd6e] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-6911dd6e] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-6911dd6e] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-6911dd6e] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-6911dd6e] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-6911dd6e] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-6911dd6e] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-6911dd6e] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-6911dd6e],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-6911dd6e] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-6911dd6e] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-6911dd6e] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-6911dd6e] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-6911dd6e] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-6911dd6e] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-6911dd6e] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-6911dd6e] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-6911dd6e] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-6911dd6e] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-6911dd6e] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-6911dd6e] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-6911dd6e] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-6911dd6e] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-6911dd6e] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-6911dd6e] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-6911dd6e] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-6911dd6e] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-6911dd6e] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-6911dd6e] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-6911dd6e] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-6911dd6e] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-6911dd6e] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-6911dd6e] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-6911dd6e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-6911dd6e] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-6911dd6e] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-6911dd6e] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-6911dd6e] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-6911dd6e]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-6911dd6e] {\n  color: #666666;\n}\n.el-radio__inner[data-v-6911dd6e]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-6911dd6e] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-6911dd6e] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-6911dd6e] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-6911dd6e] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-6911dd6e] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-6911dd6e] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-6911dd6e] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-6911dd6e] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-6911dd6e],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-6911dd6e]:hover,\n.el-input__icon.el-icon-circle-close[data-v-6911dd6e],\n.el-input__icon.el-icon-circle-close[data-v-6911dd6e]:hover {\n  color: #FB304D;\n}\n*[data-v-6911dd6e],\n*[data-v-6911dd6e]:before,\n*[data-v-6911dd6e]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-6911dd6e],\ntextarea[data-v-6911dd6e] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-6911dd6e]:focus {\n  outline: none;\n}\n.page-header[data-v-6911dd6e] {\n  padding: 0.040404rem 0;\n  margin-top: -0.121212rem;\n  font-size: 0.080808rem;\n  font-weight: bold;\n  color: #666666;\n  line-height: 0.161616rem;\n  height: 0.242424rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.page-header-title[data-v-6911dd6e] {\n  font-weight: 400;\n}\n.page-header-subinfo[data-v-6911dd6e] {\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  margin-left: auto;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  color: #0B41CD;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-header-subinfo i[data-v-6911dd6e] {\n  margin-right: 0.040404rem;\n}\n.page-header-subinfo-role[data-v-6911dd6e] {\n  width: 0.909091rem;\n}\n.page-header-subinfo-role label[data-v-6911dd6e] {\n  margin-right: 0.050505rem;\n  color: #666666;\n}\n.page-header-subinfo-role div[data-v-6911dd6e] {\n  width: 0.606061rem;\n}\n.search-content-main[data-v-6911dd6e] {\n  display: inline-block;\n  margin-bottom: 0.030303rem;\n}\n.search-content-main .search-content-main-fields[data-v-6911dd6e] {\n  float: left;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.search-content-main .search-content-main-fields .el-form-item + .el-form-item[data-v-6911dd6e] {\n  margin-left: 0.080808rem;\n}\n.search-content-main .search-content-main-fields-year[data-v-6911dd6e] {\n  width: 0.606061rem;\n}\n.search-content-main .search-content-main-fields-medicalField[data-v-6911dd6e] {\n  width: 0.909091rem;\n}\n.search-content-main .search-content-main-fields-departId[data-v-6911dd6e] {\n  width: 0.909091rem;\n}\n.search-content-main .search-content-main-fields + .search-content-main-fields[data-v-6911dd6e] {\n  margin-top: 0.030303rem;\n}\n.search-content-other[data-v-6911dd6e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 0.282828rem;\n  background: #FFFFFF;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.060606rem;\n  position: relative;\n}\n.search-content-other-rate-types[data-v-6911dd6e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: 0.121212rem;\n}\n.search-content-other-rate-types-item[data-v-6911dd6e] {\n  line-height: 0.282828rem;\n  height: 0.282828rem;\n  font-size: 0.070707rem;\n  color: #333333;\n  width: 0.40404rem;\n  text-align: center;\n  cursor: pointer;\n}\n.search-content-other-rate-types-item.active[data-v-6911dd6e] {\n  color: #0B41CD;\n  border-bottom: 0.015152rem solid #0B41CD;\n}\n.search-content-other-distribute-types[data-v-6911dd6e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  width: 0.646465rem;\n  background-color: #e8eaec;\n  border-radius: 0.080808rem;\n  margin-top: 0.060606rem;\n  position: absolute;\n  right: 0.121212rem;\n}\n.search-content-other-distribute-types-item[data-v-6911dd6e] {\n  width: 0.323232rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  font-size: 0.070707rem;\n  color: #333333;\n  border-radius: 0.080808rem;\n  text-align: center;\n  cursor: pointer;\n}\n.search-content-other-distribute-types-item.active[data-v-6911dd6e] {\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.charts-row[data-v-6911dd6e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.charts-row .chart[data-v-6911dd6e] {\n  height: 2.626263rem;\n  width: 2.989899rem;\n  background: #fff;\n}\n.charts-row .chart .title[data-v-6911dd6e] {\n  color: #333333;\n  font-size: 0.090909rem;\n  margin: 0.075758rem 0 0 0.121212rem;\n}\n.charts-row .chart .title i[data-v-6911dd6e] {\n  font-size: 0.080808rem;\n  margin-right: 0.030303rem;\n  color: rgba(11, 65, 205, 0.5);\n}\n.charts-row .chart .yAxisLabel[data-v-6911dd6e] {\n  font-size: 0.070707rem;\n  position: absolute;\n  left: 0.30303rem;\n  top: 0.252525rem;\n}\n.charts-row .chart .xAxisLabel[data-v-6911dd6e] {\n  font-size: 0.070707rem;\n  position: absolute;\n  right: 0.151515rem;\n  bottom: 0.20202rem;\n}\n.charts-row .chart-full[data-v-6911dd6e] {\n  width: 100%;\n}\n.charts-row .chart-right[data-v-6911dd6e] {\n  margin-left: 0.080808rem;\n}\n.charts-row .search-content-trend[data-v-6911dd6e] {\n  position: absolute;\n  right: 0.121212rem;\n  top: 0.262626rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  z-index: 200;\n}\n.charts-row .search-content-trend-item[data-v-6911dd6e] {\n  width: 0.30303rem;\n  height: 0.121212rem;\n  border: 0.005051rem solid #999999;\n  font-weight: 400;\n  color: #666666;\n  font-size: 0.060606rem;\n  text-align: center;\n  line-height: 0.121212rem;\n  cursor: pointer;\n}\n.charts-row .search-content-trend-item[data-v-6911dd6e]:first-child {\n  border-radius: 0.020202rem 0 0 0.020202rem;\n}\n.charts-row .search-content-trend-item[data-v-6911dd6e]:last-child {\n  border-radius: 0 0.020202rem 0.020202rem 0;\n}\n.charts-row .search-content-trend-item.active[data-v-6911dd6e] {\n  border-color: #0B41CD;\n  color: #0B41CD;\n}\n.charts-row .search-content-trend .search-content-trend-item + .search-content-trend-item[data-v-6911dd6e] {\n  margin-left: -0.005051rem;\n}\n.charts-row .search-content-trend .search-content-trend-item.active + .search-content-trend-item[data-v-6911dd6e] {\n  border-left-color: #0B41CD;\n}\n.charts-row + .charts-row[data-v-6911dd6e] {\n  margin-top: 0.085859rem;\n}\n.gauge-legend[data-v-6911dd6e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 0.080808rem 0 0 0.121212rem;\n  font-size: 0.060606rem;\n  color: #666666;\n}\n.gauge-legend-value[data-v-6911dd6e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: 0.060606rem;\n}\n.gauge-legend-value div[data-v-6911dd6e] {\n  height: 0.045455rem;\n  width: 0.045455rem;\n  border-radius: 0.022727rem;\n  margin: 0.010101rem 0.040404rem 0 0;\n}\n.gauge-legend-value-1 div[data-v-6911dd6e] {\n  background-color: #2D82F0;\n}\n.gauge-legend-value-2 div[data-v-6911dd6e] {\n  background-color: #E8EAEC;\n}\n.gauge-legend-value-3 div[data-v-6911dd6e] {\n  background-color: #0B41CD;\n}\n.axis-label[data-v-6911dd6e] {\n  height: 0;\n}\n.axis-label-0[data-v-6911dd6e] {\n  position: relative;\n  top: 0.732323rem;\n  left: 0.378788rem;\n  font-size: 0.070707rem;\n  color: rgba(0, 0, 0, 0.45);\n}\n.axis-label-100[data-v-6911dd6e] {\n  position: relative;\n  top: 0.732323rem;\n  left: 0.984848rem;\n  font-size: 0.070707rem;\n  color: rgba(0, 0, 0, 0.45);\n}\n.axis-label-remain[data-v-6911dd6e] {\n  position: relative;\n  top: 0.580808rem;\n  left: 0.858586rem;\n  font-size: 0.080808rem;\n  color: #333333;\n  font-weight: bold;\n  width: 0.181818rem;\n}\n.message-info[data-v-6911dd6e] {\n  margin-top: -0.176768rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 0.20202rem;\n  font-size: 0.060606rem;\n  color: #333333;\n  line-height: 0.10101rem;\n}\n.message-info div[data-v-6911dd6e] {\n  margin: 0 auto;\n}", ""]);

// exports


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-6a6df71f],\nbody[data-v-6a6df71f] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-6a6df71f]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-6a6df71f] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-6a6df71f] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-6a6df71f] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-6a6df71f],\n  .page-contain[data-v-6a6df71f],\n  .page-submenu[data-v-6a6df71f] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-6a6df71f] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-6a6df71f] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-6a6df71f] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-6a6df71f] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-6a6df71f] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-6a6df71f] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-6a6df71f] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-6a6df71f] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-6a6df71f],\n  .page-submenu[data-v-6a6df71f] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-6a6df71f] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-6a6df71f] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-6a6df71f] {\n    width: 76.3vw;\n}\n.v-main[data-v-6a6df71f] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-6a6df71f] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-6a6df71f] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-6a6df71f] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-6a6df71f] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-6a6df71f] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-6a6df71f] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-6a6df71f],\n  .page-submenu[data-v-6a6df71f] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-6a6df71f] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-6a6df71f] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-6a6df71f] {\n    width: 76.3vw;\n}\n.v-main[data-v-6a6df71f] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-6a6df71f] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-6a6df71f] {\n  margin-top: 0.252525rem;\n}\n[data-v-6a6df71f]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-6a6df71f]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-6a6df71f] {\n  text-align: right;\n}\n.aligncenter[data-v-6a6df71f] {\n  text-align: center;\n}\n.alignleft[data-v-6a6df71f] {\n  text-align: left;\n}\n.actiongroupborder[data-v-6a6df71f] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-6a6df71f] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-6a6df71f] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-6a6df71f] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-6a6df71f] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-6a6df71f] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-6a6df71f] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-6a6df71f] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-6a6df71f] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-6a6df71f] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-6a6df71f] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-6a6df71f] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-6a6df71f] {\n  text-align: center;\n}\n.alignleft[data-v-6a6df71f] {\n  text-align: left;\n}\n.alignright[data-v-6a6df71f] {\n  text-align: right;\n}\n.e2e-container[data-v-6a6df71f] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-6a6df71f] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-6a6df71f] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-6a6df71f] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-6a6df71f] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-6a6df71f] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-6a6df71f] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-6a6df71f] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-6a6df71f] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-6a6df71f] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-6a6df71f] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-6a6df71f],\n.e2e-red-point-left[data-v-6a6df71f] {\n  position: relative;\n}\n.e2e-red-point[data-v-6a6df71f]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-6a6df71f]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-6a6df71f] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-6a6df71f] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-6a6df71f] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-6a6df71f] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-6a6df71f] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-6a6df71f] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-6a6df71f] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-6a6df71f] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-6a6df71f] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-6a6df71f] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-6a6df71f] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-6a6df71f] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-6a6df71f] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-6a6df71f]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-6a6df71f] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-6a6df71f] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-6a6df71f],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-6a6df71f] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-6a6df71f],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-6a6df71f] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-6a6df71f],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-6a6df71f] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-6a6df71f],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-6a6df71f] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-6a6df71f],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-6a6df71f] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-6a6df71f],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-6a6df71f] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-6a6df71f] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-6a6df71f] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-6a6df71f] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-6a6df71f] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-6a6df71f] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-6a6df71f] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-6a6df71f] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-6a6df71f] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-6a6df71f]:hover,\n.el-button--primary[data-v-6a6df71f]:active,\n.el-button--primary[data-v-6a6df71f]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-6a6df71f] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-6a6df71f]:hover,\n.el-button--primary.is-plain[data-v-6a6df71f]:active,\n.el-button--primary.is-plain[data-v-6a6df71f]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-6a6df71f] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-6a6df71f]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-6a6df71f]:active,\n.el-button--primary.is-plain.is-disabled[data-v-6a6df71f]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-6a6df71f] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-6a6df71f]:hover,\n.el-button--primary.is-disabled[data-v-6a6df71f]:active,\n.el-button--primary.is-disabled[data-v-6a6df71f]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-6a6df71f] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-6a6df71f]:hover,\n.el-button--default[data-v-6a6df71f]:active,\n.el-button--default[data-v-6a6df71f]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-6a6df71f] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-6a6df71f]:hover,\n.el-button--text[data-v-6a6df71f]:active,\n.el-button--text[data-v-6a6df71f]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-6a6df71f] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-6a6df71f],\n.operate a + .el-button[data-v-6a6df71f],\n.operate span + .el-button[data-v-6a6df71f],\n.operate a + span[data-v-6a6df71f] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-6a6df71f] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-6a6df71f] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-6a6df71f] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-6a6df71f] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-6a6df71f] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-6a6df71f] {\n  color: #fff;\n}\n.el-loading-mask[data-v-6a6df71f] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-6a6df71f] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-6a6df71f]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-6a6df71f]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-6a6df71f]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-6a6df71f]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-6a6df71f] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-6a6df71f] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-6a6df71f] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-6a6df71f] {\n  color: #999;\n}\n.el-select-dropdown[data-v-6a6df71f] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-6a6df71f] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-6a6df71f] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-6a6df71f] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-6a6df71f] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-6a6df71f] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-6a6df71f] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-6a6df71f]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-6a6df71f] {\n  display: none;\n}\n.el-table th > .cell[data-v-6a6df71f] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-6a6df71f] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-6a6df71f] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-6a6df71f] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-6a6df71f]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-6a6df71f]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-6a6df71f] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-6a6df71f] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-6a6df71f] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-6a6df71f] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-6a6df71f] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-6a6df71f] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-6a6df71f] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-6a6df71f] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-6a6df71f],\n.el-pagination .btn-next[data-v-6a6df71f] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-6a6df71f],\n.el-pagination .btn-next span[data-v-6a6df71f] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-6a6df71f] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-6a6df71f] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-6a6df71f] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-6a6df71f] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-6a6df71f] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-6a6df71f] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-6a6df71f] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-6a6df71f] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-6a6df71f] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-6a6df71f] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-6a6df71f] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-6a6df71f] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-6a6df71f] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-6a6df71f] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-6a6df71f] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-6a6df71f] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-6a6df71f] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-6a6df71f] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-6a6df71f] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-6a6df71f] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-6a6df71f] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-6a6df71f] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-6a6df71f] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-6a6df71f] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-6a6df71f] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-6a6df71f] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-6a6df71f] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-6a6df71f] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-6a6df71f] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-6a6df71f]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-6a6df71f] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-6a6df71f] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-6a6df71f] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-6a6df71f] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-6a6df71f] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-6a6df71f] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-6a6df71f] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-6a6df71f] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-6a6df71f] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-6a6df71f] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-6a6df71f] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-6a6df71f],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-6a6df71f] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-6a6df71f] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-6a6df71f] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-6a6df71f] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-6a6df71f] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-6a6df71f] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-6a6df71f] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-6a6df71f] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-6a6df71f] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-6a6df71f] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-6a6df71f] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-6a6df71f] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-6a6df71f] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-6a6df71f] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-6a6df71f] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-6a6df71f] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-6a6df71f] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-6a6df71f] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-6a6df71f] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-6a6df71f] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-6a6df71f] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-6a6df71f] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-6a6df71f] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-6a6df71f] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-6a6df71f] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-6a6df71f] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-6a6df71f] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-6a6df71f] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-6a6df71f] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-6a6df71f]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-6a6df71f] {\n  color: #666666;\n}\n.el-radio__inner[data-v-6a6df71f]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-6a6df71f] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-6a6df71f] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-6a6df71f] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-6a6df71f] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-6a6df71f] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-6a6df71f] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-6a6df71f] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-6a6df71f] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-6a6df71f],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-6a6df71f]:hover,\n.el-input__icon.el-icon-circle-close[data-v-6a6df71f],\n.el-input__icon.el-icon-circle-close[data-v-6a6df71f]:hover {\n  color: #FB304D;\n}\n*[data-v-6a6df71f],\n*[data-v-6a6df71f]:before,\n*[data-v-6a6df71f]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-6a6df71f],\ntextarea[data-v-6a6df71f] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-6a6df71f]:focus {\n  outline: none;\n}\n.common-confirm-dialog .iconfont[data-v-6a6df71f] {\n  font-size: 0.269343rem;\n  text-align: center;\n  display: block;\n  margin-top: 0.070707rem;\n}\n.common-confirm-dialog .common-confirm-info[data-v-6a6df71f] {\n  text-align: center;\n  font-size: 0.080808rem;\n  font-weight: bold;\n  margin-top: 0.126263rem;\n  margin-bottom: 0.075758rem;\n}\n.tips-form-class .iconfont[data-v-6a6df71f] {\n  display: none;\n}", ""]);

// exports


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-707e1f82],\nbody[data-v-707e1f82] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-707e1f82]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-707e1f82] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-707e1f82] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-707e1f82] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-707e1f82],\n  .page-contain[data-v-707e1f82],\n  .page-submenu[data-v-707e1f82] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-707e1f82] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-707e1f82] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-707e1f82] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-707e1f82] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-707e1f82] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-707e1f82] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-707e1f82] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-707e1f82] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-707e1f82],\n  .page-submenu[data-v-707e1f82] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-707e1f82] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-707e1f82] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-707e1f82] {\n    width: 76.3vw;\n}\n.v-main[data-v-707e1f82] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-707e1f82] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-707e1f82] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-707e1f82] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-707e1f82] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-707e1f82] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-707e1f82] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-707e1f82],\n  .page-submenu[data-v-707e1f82] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-707e1f82] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-707e1f82] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-707e1f82] {\n    width: 76.3vw;\n}\n.v-main[data-v-707e1f82] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-707e1f82] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-707e1f82] {\n  margin-top: 0.252525rem;\n}\n[data-v-707e1f82]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-707e1f82]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-707e1f82] {\n  text-align: right;\n}\n.aligncenter[data-v-707e1f82] {\n  text-align: center;\n}\n.alignleft[data-v-707e1f82] {\n  text-align: left;\n}\n.actiongroupborder[data-v-707e1f82] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-707e1f82] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-707e1f82] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-707e1f82] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-707e1f82] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-707e1f82] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-707e1f82] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-707e1f82] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-707e1f82] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-707e1f82] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-707e1f82] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-707e1f82] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-707e1f82] {\n  text-align: center;\n}\n.alignleft[data-v-707e1f82] {\n  text-align: left;\n}\n.alignright[data-v-707e1f82] {\n  text-align: right;\n}\n.e2e-container[data-v-707e1f82] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-707e1f82] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-707e1f82] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-707e1f82] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-707e1f82] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-707e1f82] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-707e1f82] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-707e1f82] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-707e1f82] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-707e1f82] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-707e1f82] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-707e1f82],\n.e2e-red-point-left[data-v-707e1f82] {\n  position: relative;\n}\n.e2e-red-point[data-v-707e1f82]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-707e1f82]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-707e1f82] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-707e1f82] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-707e1f82] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-707e1f82] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-707e1f82] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-707e1f82] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-707e1f82] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-707e1f82] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-707e1f82] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-707e1f82] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-707e1f82] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-707e1f82] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-707e1f82] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-707e1f82]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-707e1f82] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-707e1f82] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-707e1f82],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-707e1f82] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-707e1f82],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-707e1f82] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-707e1f82],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-707e1f82] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-707e1f82],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-707e1f82] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-707e1f82],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-707e1f82] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-707e1f82],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-707e1f82] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-707e1f82] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-707e1f82] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-707e1f82] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-707e1f82] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-707e1f82] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-707e1f82] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-707e1f82] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-707e1f82] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-707e1f82]:hover,\n.el-button--primary[data-v-707e1f82]:active,\n.el-button--primary[data-v-707e1f82]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-707e1f82] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-707e1f82]:hover,\n.el-button--primary.is-plain[data-v-707e1f82]:active,\n.el-button--primary.is-plain[data-v-707e1f82]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-707e1f82] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-707e1f82]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-707e1f82]:active,\n.el-button--primary.is-plain.is-disabled[data-v-707e1f82]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-707e1f82] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-707e1f82]:hover,\n.el-button--primary.is-disabled[data-v-707e1f82]:active,\n.el-button--primary.is-disabled[data-v-707e1f82]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-707e1f82] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-707e1f82]:hover,\n.el-button--default[data-v-707e1f82]:active,\n.el-button--default[data-v-707e1f82]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-707e1f82] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-707e1f82]:hover,\n.el-button--text[data-v-707e1f82]:active,\n.el-button--text[data-v-707e1f82]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-707e1f82] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-707e1f82],\n.operate a + .el-button[data-v-707e1f82],\n.operate span + .el-button[data-v-707e1f82],\n.operate a + span[data-v-707e1f82] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-707e1f82] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-707e1f82] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-707e1f82] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-707e1f82] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-707e1f82] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-707e1f82] {\n  color: #fff;\n}\n.el-loading-mask[data-v-707e1f82] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-707e1f82] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-707e1f82]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-707e1f82]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-707e1f82]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-707e1f82]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-707e1f82] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-707e1f82] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-707e1f82] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-707e1f82] {\n  color: #999;\n}\n.el-select-dropdown[data-v-707e1f82] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-707e1f82] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-707e1f82] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-707e1f82] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-707e1f82] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-707e1f82] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-707e1f82] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-707e1f82]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-707e1f82] {\n  display: none;\n}\n.el-table th > .cell[data-v-707e1f82] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-707e1f82] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-707e1f82] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-707e1f82] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-707e1f82]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-707e1f82]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-707e1f82] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-707e1f82] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-707e1f82] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-707e1f82] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-707e1f82] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-707e1f82] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-707e1f82] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-707e1f82] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-707e1f82],\n.el-pagination .btn-next[data-v-707e1f82] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-707e1f82],\n.el-pagination .btn-next span[data-v-707e1f82] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-707e1f82] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-707e1f82] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-707e1f82] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-707e1f82] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-707e1f82] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-707e1f82] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-707e1f82] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-707e1f82] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-707e1f82] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-707e1f82] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-707e1f82] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-707e1f82] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-707e1f82] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-707e1f82] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-707e1f82] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-707e1f82] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-707e1f82] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-707e1f82] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-707e1f82] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-707e1f82] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-707e1f82] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-707e1f82] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-707e1f82] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-707e1f82] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-707e1f82] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-707e1f82] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-707e1f82] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-707e1f82] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-707e1f82] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-707e1f82]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-707e1f82] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-707e1f82] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-707e1f82] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-707e1f82] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-707e1f82] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-707e1f82] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-707e1f82] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-707e1f82] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-707e1f82] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-707e1f82] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-707e1f82] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-707e1f82],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-707e1f82] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-707e1f82] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-707e1f82] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-707e1f82] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-707e1f82] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-707e1f82] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-707e1f82] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-707e1f82] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-707e1f82] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-707e1f82] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-707e1f82] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-707e1f82] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-707e1f82] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-707e1f82] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-707e1f82] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-707e1f82] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-707e1f82] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-707e1f82] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-707e1f82] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-707e1f82] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-707e1f82] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-707e1f82] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-707e1f82] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-707e1f82] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-707e1f82] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-707e1f82] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-707e1f82] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-707e1f82] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-707e1f82] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-707e1f82]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-707e1f82] {\n  color: #666666;\n}\n.el-radio__inner[data-v-707e1f82]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-707e1f82] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-707e1f82] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-707e1f82] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-707e1f82] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-707e1f82] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-707e1f82] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-707e1f82] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-707e1f82] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-707e1f82],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-707e1f82]:hover,\n.el-input__icon.el-icon-circle-close[data-v-707e1f82],\n.el-input__icon.el-icon-circle-close[data-v-707e1f82]:hover {\n  color: #FB304D;\n}\n*[data-v-707e1f82],\n*[data-v-707e1f82]:before,\n*[data-v-707e1f82]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-707e1f82],\ntextarea[data-v-707e1f82] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-707e1f82]:focus {\n  outline: none;\n}\n#tableau[data-v-707e1f82] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}", ""]);

// exports


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-75bd0e6f],\nbody[data-v-75bd0e6f] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-75bd0e6f]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-75bd0e6f] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-75bd0e6f] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-75bd0e6f] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-75bd0e6f],\n  .page-contain[data-v-75bd0e6f],\n  .page-submenu[data-v-75bd0e6f] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-75bd0e6f] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-75bd0e6f] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-75bd0e6f] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-75bd0e6f] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-75bd0e6f] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-75bd0e6f] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-75bd0e6f] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-75bd0e6f] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-75bd0e6f],\n  .page-submenu[data-v-75bd0e6f] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-75bd0e6f] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-75bd0e6f] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-75bd0e6f] {\n    width: 76.3vw;\n}\n.v-main[data-v-75bd0e6f] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-75bd0e6f] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-75bd0e6f] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-75bd0e6f] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-75bd0e6f] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-75bd0e6f] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-75bd0e6f] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-75bd0e6f],\n  .page-submenu[data-v-75bd0e6f] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-75bd0e6f] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-75bd0e6f] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-75bd0e6f] {\n    width: 76.3vw;\n}\n.v-main[data-v-75bd0e6f] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-75bd0e6f] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-75bd0e6f] {\n  margin-top: 0.252525rem;\n}\n[data-v-75bd0e6f]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-75bd0e6f]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-75bd0e6f] {\n  text-align: right;\n}\n.aligncenter[data-v-75bd0e6f] {\n  text-align: center;\n}\n.alignleft[data-v-75bd0e6f] {\n  text-align: left;\n}\n.actiongroupborder[data-v-75bd0e6f] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-75bd0e6f] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-75bd0e6f] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-75bd0e6f] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-75bd0e6f] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-75bd0e6f] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-75bd0e6f] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-75bd0e6f] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-75bd0e6f] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-75bd0e6f] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-75bd0e6f] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-75bd0e6f] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-75bd0e6f] {\n  text-align: center;\n}\n.alignleft[data-v-75bd0e6f] {\n  text-align: left;\n}\n.alignright[data-v-75bd0e6f] {\n  text-align: right;\n}\n.e2e-container[data-v-75bd0e6f] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-75bd0e6f] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-75bd0e6f] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-75bd0e6f] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-75bd0e6f] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-75bd0e6f] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-75bd0e6f] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-75bd0e6f] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-75bd0e6f] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-75bd0e6f] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-75bd0e6f] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-75bd0e6f],\n.e2e-red-point-left[data-v-75bd0e6f] {\n  position: relative;\n}\n.e2e-red-point[data-v-75bd0e6f]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-75bd0e6f]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-75bd0e6f] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-75bd0e6f] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-75bd0e6f] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-75bd0e6f] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-75bd0e6f] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-75bd0e6f] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-75bd0e6f] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-75bd0e6f] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-75bd0e6f] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-75bd0e6f] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-75bd0e6f] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-75bd0e6f] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-75bd0e6f] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-75bd0e6f]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-75bd0e6f] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-75bd0e6f] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-75bd0e6f],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-75bd0e6f] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-75bd0e6f],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-75bd0e6f] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-75bd0e6f],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-75bd0e6f] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-75bd0e6f],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-75bd0e6f] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-75bd0e6f],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-75bd0e6f] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-75bd0e6f],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-75bd0e6f] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-75bd0e6f] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-75bd0e6f] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-75bd0e6f] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-75bd0e6f] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-75bd0e6f] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-75bd0e6f] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-75bd0e6f] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-75bd0e6f] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-75bd0e6f]:hover,\n.el-button--primary[data-v-75bd0e6f]:active,\n.el-button--primary[data-v-75bd0e6f]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-75bd0e6f] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-75bd0e6f]:hover,\n.el-button--primary.is-plain[data-v-75bd0e6f]:active,\n.el-button--primary.is-plain[data-v-75bd0e6f]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-75bd0e6f] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-75bd0e6f]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-75bd0e6f]:active,\n.el-button--primary.is-plain.is-disabled[data-v-75bd0e6f]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-75bd0e6f] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-75bd0e6f]:hover,\n.el-button--primary.is-disabled[data-v-75bd0e6f]:active,\n.el-button--primary.is-disabled[data-v-75bd0e6f]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-75bd0e6f] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-75bd0e6f]:hover,\n.el-button--default[data-v-75bd0e6f]:active,\n.el-button--default[data-v-75bd0e6f]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-75bd0e6f] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-75bd0e6f]:hover,\n.el-button--text[data-v-75bd0e6f]:active,\n.el-button--text[data-v-75bd0e6f]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-75bd0e6f] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-75bd0e6f],\n.operate a + .el-button[data-v-75bd0e6f],\n.operate span + .el-button[data-v-75bd0e6f],\n.operate a + span[data-v-75bd0e6f] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-75bd0e6f] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-75bd0e6f] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-75bd0e6f] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-75bd0e6f] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-75bd0e6f] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-75bd0e6f] {\n  color: #fff;\n}\n.el-loading-mask[data-v-75bd0e6f] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-75bd0e6f] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-75bd0e6f]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-75bd0e6f]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-75bd0e6f]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-75bd0e6f]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-75bd0e6f] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-75bd0e6f] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-75bd0e6f] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-75bd0e6f] {\n  color: #999;\n}\n.el-select-dropdown[data-v-75bd0e6f] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-75bd0e6f] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-75bd0e6f] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-75bd0e6f] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-75bd0e6f] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-75bd0e6f] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-75bd0e6f] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-75bd0e6f]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-75bd0e6f] {\n  display: none;\n}\n.el-table th > .cell[data-v-75bd0e6f] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-75bd0e6f] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-75bd0e6f] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-75bd0e6f] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-75bd0e6f]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-75bd0e6f]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-75bd0e6f] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-75bd0e6f] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-75bd0e6f] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-75bd0e6f] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-75bd0e6f] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-75bd0e6f] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-75bd0e6f] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-75bd0e6f] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-75bd0e6f],\n.el-pagination .btn-next[data-v-75bd0e6f] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-75bd0e6f],\n.el-pagination .btn-next span[data-v-75bd0e6f] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-75bd0e6f] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-75bd0e6f] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-75bd0e6f] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-75bd0e6f] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-75bd0e6f] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-75bd0e6f] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-75bd0e6f] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-75bd0e6f] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-75bd0e6f] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-75bd0e6f] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-75bd0e6f] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-75bd0e6f] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-75bd0e6f] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-75bd0e6f] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-75bd0e6f] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-75bd0e6f] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-75bd0e6f] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-75bd0e6f] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-75bd0e6f] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-75bd0e6f] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-75bd0e6f] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-75bd0e6f] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-75bd0e6f] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-75bd0e6f] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-75bd0e6f] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-75bd0e6f] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-75bd0e6f] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-75bd0e6f] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-75bd0e6f] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-75bd0e6f]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-75bd0e6f] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-75bd0e6f] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-75bd0e6f] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-75bd0e6f] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-75bd0e6f] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-75bd0e6f] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-75bd0e6f] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-75bd0e6f] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-75bd0e6f] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-75bd0e6f] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-75bd0e6f] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-75bd0e6f],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-75bd0e6f] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-75bd0e6f] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-75bd0e6f] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-75bd0e6f] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-75bd0e6f] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-75bd0e6f] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-75bd0e6f] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-75bd0e6f] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-75bd0e6f] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-75bd0e6f] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-75bd0e6f] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-75bd0e6f] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-75bd0e6f] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-75bd0e6f] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-75bd0e6f] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-75bd0e6f] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-75bd0e6f] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-75bd0e6f] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-75bd0e6f] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-75bd0e6f] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-75bd0e6f] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-75bd0e6f] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-75bd0e6f] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-75bd0e6f] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-75bd0e6f] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-75bd0e6f] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-75bd0e6f] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-75bd0e6f] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-75bd0e6f] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-75bd0e6f]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-75bd0e6f] {\n  color: #666666;\n}\n.el-radio__inner[data-v-75bd0e6f]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-75bd0e6f] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-75bd0e6f] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-75bd0e6f] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-75bd0e6f] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-75bd0e6f] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-75bd0e6f] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-75bd0e6f] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-75bd0e6f] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-75bd0e6f],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-75bd0e6f]:hover,\n.el-input__icon.el-icon-circle-close[data-v-75bd0e6f],\n.el-input__icon.el-icon-circle-close[data-v-75bd0e6f]:hover {\n  color: #FB304D;\n}\n*[data-v-75bd0e6f],\n*[data-v-75bd0e6f]:before,\n*[data-v-75bd0e6f]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-75bd0e6f],\ntextarea[data-v-75bd0e6f] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-75bd0e6f]:focus {\n  outline: none;\n}\n.common-confirm-dialog .common-confirm-info[data-v-75bd0e6f] {\n  text-align: center;\n}", ""]);

// exports


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-778fac58],\nbody[data-v-778fac58] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-778fac58]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-778fac58] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-778fac58] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-778fac58] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-778fac58],\n  .page-contain[data-v-778fac58],\n  .page-submenu[data-v-778fac58] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-778fac58] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-778fac58] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-778fac58] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-778fac58] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-778fac58] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-778fac58] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-778fac58] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-778fac58] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-778fac58],\n  .page-submenu[data-v-778fac58] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-778fac58] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-778fac58] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-778fac58] {\n    width: 76.3vw;\n}\n.v-main[data-v-778fac58] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-778fac58] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-778fac58] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-778fac58] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-778fac58] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-778fac58] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-778fac58] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-778fac58],\n  .page-submenu[data-v-778fac58] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-778fac58] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-778fac58] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-778fac58] {\n    width: 76.3vw;\n}\n.v-main[data-v-778fac58] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-778fac58] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-778fac58] {\n  margin-top: 0.252525rem;\n}\n[data-v-778fac58]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-778fac58]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-778fac58] {\n  text-align: right;\n}\n.aligncenter[data-v-778fac58] {\n  text-align: center;\n}\n.alignleft[data-v-778fac58] {\n  text-align: left;\n}\n.actiongroupborder[data-v-778fac58] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-778fac58] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-778fac58] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-778fac58] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-778fac58] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-778fac58] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-778fac58] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-778fac58] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-778fac58] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-778fac58] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-778fac58] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-778fac58] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-778fac58] {\n  text-align: center;\n}\n.alignleft[data-v-778fac58] {\n  text-align: left;\n}\n.alignright[data-v-778fac58] {\n  text-align: right;\n}\n.e2e-container[data-v-778fac58] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-778fac58] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-778fac58] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-778fac58] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-778fac58] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-778fac58] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-778fac58] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-778fac58] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-778fac58] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-778fac58] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-778fac58] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-778fac58],\n.e2e-red-point-left[data-v-778fac58] {\n  position: relative;\n}\n.e2e-red-point[data-v-778fac58]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-778fac58]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-778fac58] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-778fac58] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-778fac58] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-778fac58] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-778fac58] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-778fac58] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-778fac58] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-778fac58] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-778fac58] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-778fac58] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-778fac58] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-778fac58] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-778fac58] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-778fac58]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-778fac58] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-778fac58] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-778fac58],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-778fac58] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-778fac58],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-778fac58] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-778fac58],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-778fac58] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-778fac58],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-778fac58] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-778fac58],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-778fac58] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-778fac58],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-778fac58] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-778fac58] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-778fac58] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-778fac58] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-778fac58] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-778fac58] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-778fac58] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-778fac58] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-778fac58] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-778fac58]:hover,\n.el-button--primary[data-v-778fac58]:active,\n.el-button--primary[data-v-778fac58]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-778fac58] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-778fac58]:hover,\n.el-button--primary.is-plain[data-v-778fac58]:active,\n.el-button--primary.is-plain[data-v-778fac58]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-778fac58] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-778fac58]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-778fac58]:active,\n.el-button--primary.is-plain.is-disabled[data-v-778fac58]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-778fac58] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-778fac58]:hover,\n.el-button--primary.is-disabled[data-v-778fac58]:active,\n.el-button--primary.is-disabled[data-v-778fac58]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-778fac58] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-778fac58]:hover,\n.el-button--default[data-v-778fac58]:active,\n.el-button--default[data-v-778fac58]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-778fac58] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-778fac58]:hover,\n.el-button--text[data-v-778fac58]:active,\n.el-button--text[data-v-778fac58]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-778fac58] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-778fac58],\n.operate a + .el-button[data-v-778fac58],\n.operate span + .el-button[data-v-778fac58],\n.operate a + span[data-v-778fac58] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-778fac58] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-778fac58] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-778fac58] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-778fac58] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-778fac58] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-778fac58] {\n  color: #fff;\n}\n.el-loading-mask[data-v-778fac58] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-778fac58] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-778fac58]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-778fac58]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-778fac58]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-778fac58]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-778fac58] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-778fac58] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-778fac58] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-778fac58] {\n  color: #999;\n}\n.el-select-dropdown[data-v-778fac58] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-778fac58] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-778fac58] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-778fac58] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-778fac58] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-778fac58] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-778fac58] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-778fac58]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-778fac58] {\n  display: none;\n}\n.el-table th > .cell[data-v-778fac58] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-778fac58] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-778fac58] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-778fac58] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-778fac58]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-778fac58]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-778fac58] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-778fac58] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-778fac58] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-778fac58] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-778fac58] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-778fac58] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-778fac58] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-778fac58] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-778fac58],\n.el-pagination .btn-next[data-v-778fac58] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-778fac58],\n.el-pagination .btn-next span[data-v-778fac58] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-778fac58] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-778fac58] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-778fac58] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-778fac58] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-778fac58] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-778fac58] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-778fac58] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-778fac58] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-778fac58] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-778fac58] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-778fac58] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-778fac58] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-778fac58] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-778fac58] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-778fac58] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-778fac58] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-778fac58] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-778fac58] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-778fac58] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-778fac58] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-778fac58] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-778fac58] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-778fac58] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-778fac58] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-778fac58] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-778fac58] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-778fac58] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-778fac58] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-778fac58] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-778fac58]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-778fac58] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-778fac58] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-778fac58] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-778fac58] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-778fac58] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-778fac58] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-778fac58] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-778fac58] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-778fac58] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-778fac58] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-778fac58] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-778fac58],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-778fac58] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-778fac58] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-778fac58] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-778fac58] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-778fac58] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-778fac58] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-778fac58] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-778fac58] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-778fac58] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-778fac58] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-778fac58] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-778fac58] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-778fac58] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-778fac58] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-778fac58] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-778fac58] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-778fac58] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-778fac58] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-778fac58] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-778fac58] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-778fac58] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-778fac58] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-778fac58] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-778fac58] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-778fac58] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-778fac58] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-778fac58] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-778fac58] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-778fac58] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-778fac58]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-778fac58] {\n  color: #666666;\n}\n.el-radio__inner[data-v-778fac58]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-778fac58] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-778fac58] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-778fac58] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-778fac58] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-778fac58] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-778fac58] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-778fac58] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-778fac58] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-778fac58],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-778fac58]:hover,\n.el-input__icon.el-icon-circle-close[data-v-778fac58],\n.el-input__icon.el-icon-circle-close[data-v-778fac58]:hover {\n  color: #FB304D;\n}\n*[data-v-778fac58],\n*[data-v-778fac58]:before,\n*[data-v-778fac58]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-778fac58],\ntextarea[data-v-778fac58] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-778fac58]:focus {\n  outline: none;\n}\n.search-content[data-v-778fac58] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 0.111111rem;\n}\n.search-content .search-content-fields[data-v-778fac58] {\n  width: 4.040404rem;\n}\n.operate[data-v-778fac58] {\n  float: right;\n  margin-bottom: 0.151515rem;\n}", ""]);

// exports


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-79d0c4be],\nbody[data-v-79d0c4be] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-79d0c4be]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-79d0c4be] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-79d0c4be] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-79d0c4be] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-79d0c4be],\n  .page-contain[data-v-79d0c4be],\n  .page-submenu[data-v-79d0c4be] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-79d0c4be] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-79d0c4be] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-79d0c4be] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-79d0c4be] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-79d0c4be] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-79d0c4be] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-79d0c4be] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-79d0c4be] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-79d0c4be],\n  .page-submenu[data-v-79d0c4be] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-79d0c4be] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-79d0c4be] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-79d0c4be] {\n    width: 76.3vw;\n}\n.v-main[data-v-79d0c4be] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-79d0c4be] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-79d0c4be] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-79d0c4be] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-79d0c4be] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-79d0c4be] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-79d0c4be] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-79d0c4be],\n  .page-submenu[data-v-79d0c4be] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-79d0c4be] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-79d0c4be] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-79d0c4be] {\n    width: 76.3vw;\n}\n.v-main[data-v-79d0c4be] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-79d0c4be] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-79d0c4be] {\n  margin-top: 0.252525rem;\n}\n[data-v-79d0c4be]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-79d0c4be]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-79d0c4be] {\n  text-align: right;\n}\n.aligncenter[data-v-79d0c4be] {\n  text-align: center;\n}\n.alignleft[data-v-79d0c4be] {\n  text-align: left;\n}\n.actiongroupborder[data-v-79d0c4be] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-79d0c4be] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-79d0c4be] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-79d0c4be] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-79d0c4be] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-79d0c4be] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-79d0c4be] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-79d0c4be] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-79d0c4be] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-79d0c4be] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-79d0c4be] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-79d0c4be] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-79d0c4be] {\n  text-align: center;\n}\n.alignleft[data-v-79d0c4be] {\n  text-align: left;\n}\n.alignright[data-v-79d0c4be] {\n  text-align: right;\n}\n.e2e-container[data-v-79d0c4be] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-79d0c4be] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-79d0c4be] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-79d0c4be] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-79d0c4be] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-79d0c4be] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-79d0c4be] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-79d0c4be] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-79d0c4be] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-79d0c4be] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-79d0c4be] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-79d0c4be],\n.e2e-red-point-left[data-v-79d0c4be] {\n  position: relative;\n}\n.e2e-red-point[data-v-79d0c4be]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-79d0c4be]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-79d0c4be] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-79d0c4be] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-79d0c4be] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-79d0c4be] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-79d0c4be] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-79d0c4be] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-79d0c4be] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-79d0c4be] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-79d0c4be] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-79d0c4be] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-79d0c4be] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-79d0c4be] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-79d0c4be] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-79d0c4be]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-79d0c4be] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-79d0c4be] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-79d0c4be],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-79d0c4be] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-79d0c4be],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-79d0c4be] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-79d0c4be],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-79d0c4be] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-79d0c4be],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-79d0c4be] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-79d0c4be],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-79d0c4be] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-79d0c4be],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-79d0c4be] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-79d0c4be] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-79d0c4be] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-79d0c4be] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-79d0c4be] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-79d0c4be] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-79d0c4be] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-79d0c4be] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-79d0c4be] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-79d0c4be]:hover,\n.el-button--primary[data-v-79d0c4be]:active,\n.el-button--primary[data-v-79d0c4be]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-79d0c4be] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-79d0c4be]:hover,\n.el-button--primary.is-plain[data-v-79d0c4be]:active,\n.el-button--primary.is-plain[data-v-79d0c4be]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-79d0c4be] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-79d0c4be]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-79d0c4be]:active,\n.el-button--primary.is-plain.is-disabled[data-v-79d0c4be]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-79d0c4be] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-79d0c4be]:hover,\n.el-button--primary.is-disabled[data-v-79d0c4be]:active,\n.el-button--primary.is-disabled[data-v-79d0c4be]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-79d0c4be] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-79d0c4be]:hover,\n.el-button--default[data-v-79d0c4be]:active,\n.el-button--default[data-v-79d0c4be]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-79d0c4be] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-79d0c4be]:hover,\n.el-button--text[data-v-79d0c4be]:active,\n.el-button--text[data-v-79d0c4be]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-79d0c4be] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-79d0c4be],\n.operate a + .el-button[data-v-79d0c4be],\n.operate span + .el-button[data-v-79d0c4be],\n.operate a + span[data-v-79d0c4be] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-79d0c4be] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-79d0c4be] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-79d0c4be] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-79d0c4be] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-79d0c4be] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-79d0c4be] {\n  color: #fff;\n}\n.el-loading-mask[data-v-79d0c4be] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-79d0c4be] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-79d0c4be]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-79d0c4be]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-79d0c4be]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-79d0c4be]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-79d0c4be] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-79d0c4be] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-79d0c4be] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-79d0c4be] {\n  color: #999;\n}\n.el-select-dropdown[data-v-79d0c4be] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-79d0c4be] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-79d0c4be] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-79d0c4be] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-79d0c4be] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-79d0c4be] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-79d0c4be] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-79d0c4be]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-79d0c4be] {\n  display: none;\n}\n.el-table th > .cell[data-v-79d0c4be] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-79d0c4be] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-79d0c4be] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-79d0c4be] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-79d0c4be]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-79d0c4be]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-79d0c4be] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-79d0c4be] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-79d0c4be] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-79d0c4be] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-79d0c4be] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-79d0c4be] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-79d0c4be] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-79d0c4be] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-79d0c4be],\n.el-pagination .btn-next[data-v-79d0c4be] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-79d0c4be],\n.el-pagination .btn-next span[data-v-79d0c4be] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-79d0c4be] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-79d0c4be] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-79d0c4be] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-79d0c4be] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-79d0c4be] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-79d0c4be] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-79d0c4be] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-79d0c4be] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-79d0c4be] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-79d0c4be] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-79d0c4be] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-79d0c4be] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-79d0c4be] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-79d0c4be] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-79d0c4be] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-79d0c4be] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-79d0c4be] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-79d0c4be] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-79d0c4be] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-79d0c4be] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-79d0c4be] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-79d0c4be] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-79d0c4be] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-79d0c4be] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-79d0c4be] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-79d0c4be] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-79d0c4be] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-79d0c4be] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-79d0c4be] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-79d0c4be]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-79d0c4be] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-79d0c4be] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-79d0c4be] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-79d0c4be] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-79d0c4be] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-79d0c4be] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-79d0c4be] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-79d0c4be] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-79d0c4be] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-79d0c4be] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-79d0c4be] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-79d0c4be],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-79d0c4be] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-79d0c4be] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-79d0c4be] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-79d0c4be] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-79d0c4be] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-79d0c4be] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-79d0c4be] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-79d0c4be] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-79d0c4be] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-79d0c4be] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-79d0c4be] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-79d0c4be] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-79d0c4be] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-79d0c4be] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-79d0c4be] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-79d0c4be] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-79d0c4be] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-79d0c4be] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-79d0c4be] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-79d0c4be] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-79d0c4be] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-79d0c4be] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-79d0c4be] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-79d0c4be] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-79d0c4be] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-79d0c4be] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-79d0c4be] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-79d0c4be] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-79d0c4be] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-79d0c4be]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-79d0c4be] {\n  color: #666666;\n}\n.el-radio__inner[data-v-79d0c4be]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-79d0c4be] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-79d0c4be] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-79d0c4be] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-79d0c4be] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-79d0c4be] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-79d0c4be] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-79d0c4be] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-79d0c4be] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-79d0c4be],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-79d0c4be]:hover,\n.el-input__icon.el-icon-circle-close[data-v-79d0c4be],\n.el-input__icon.el-icon-circle-close[data-v-79d0c4be]:hover {\n  color: #FB304D;\n}\n*[data-v-79d0c4be],\n*[data-v-79d0c4be]:before,\n*[data-v-79d0c4be]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-79d0c4be],\ntextarea[data-v-79d0c4be] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-79d0c4be]:focus {\n  outline: none;\n}\n.invisible[data-v-79d0c4be] {\n  visibility: hidden;\n}\n.page-contain-tab[data-v-79d0c4be] {\n  margin-bottom: 0.353535rem !important;\n}\n.application-search-content-main[data-v-79d0c4be] {\n  background-color: #fff;\n  padding: 0.040404rem 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  font-size: 0.080808rem;\n}\n.application-search-content-main-roles[data-v-79d0c4be] {\n  float: right;\n}\n.application-search-content-main-fields-year[data-v-79d0c4be] {\n  width: 0.40404rem;\n  margin-right: 0 !important;\n}\n.application-search-content-main-fields-quarter[data-v-79d0c4be] {\n  margin-left: 0.151515rem;\n}\n.application-search-content-main-fields-quarter label[data-v-79d0c4be] {\n  cursor: pointer;\n}\n.application-search-content-main-fields-quarter-lines[data-v-79d0c4be] {\n  margin-left: 0.409091rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.application-search-content-main-fields-quarter-lines .line-active[data-v-79d0c4be] {\n  border-bottom: 0.015152rem solid #0b41cd;\n  margin-bottom: -0.040404rem;\n}\n.application-search-content-main-fields-quarter-lines-line[data-v-79d0c4be] {\n  border-bottom: 0.015152rem solid #0b41cd;\n  width: 0.20202rem;\n  border-bottom: none;\n}\n.application-search-content-main-fields-quarter-lines-line-q1[data-v-79d0c4be] {\n  margin-left: 0.121212rem;\n}\n.application-search-content-main-fields-quarter-lines-line-q2[data-v-79d0c4be] {\n  margin-left: 0.060606rem;\n}\n.application-search-content-main-fields-quarter-lines-line-q3[data-v-79d0c4be] {\n  margin-left: 0.050505rem;\n}\n.application-search-content-main-fields-quarter-lines-line-q4[data-v-79d0c4be] {\n  margin-left: 0.060606rem;\n}\n.application-search-content-main-fields-quarter-lines-line-q5[data-v-79d0c4be] {\n  margin-left: 0.090909rem;\n}\n.page-contain-main-tab[data-v-79d0c4be] {\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  background-color: transparent !important;\n}\n.page-contain-main-tab .main-blocks[data-v-79d0c4be] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row nowrap;\n          flex-flow: row nowrap;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-contain-main-tab .main-block[data-v-79d0c4be] {\n  height: 0.757576rem;\n  width: 1.449495rem;\n  display: inline-block;\n  border: none;\n  background: #fff;\n  border-radius: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain[data-v-79d0c4be] {\n  margin: 0 0.121212rem;\n}\n.page-contain-main-tab .main-block-contain-title[data-v-79d0c4be] {\n  margin-top: 0.080808rem;\n  height: 0.111111rem;\n  line-height: 0.111111rem;\n  font-size: 0.080808rem;\n  color: #666666;\n}\n.page-contain-main-tab .main-block-contain-title .iconfont[data-v-79d0c4be] {\n  float: right;\n  font-size: 0.070707rem;\n}\n.page-contain-main-tab .main-block-contain-budget[data-v-79d0c4be] {\n  margin-top: 0.090909rem;\n  height: 0.151515rem;\n  line-height: 0.151515rem;\n  font-size: 0.111111rem;\n  width: 100%;\n}\n.page-contain-main-tab .main-block-contain-budget-amount[data-v-79d0c4be] {\n  color: rgba(0, 0, 0, 0.85);\n}\n.page-contain-main-tab .main-block-contain-budget-percent[data-v-79d0c4be] {\n  float: right;\n}\n.page-contain-main-tab .main-block-contain-budget-percent-alert[data-v-79d0c4be] {\n  color: #FB304D;\n}\n.page-contain-main-tab .main-block-contain-budget-percent-title[data-v-79d0c4be] {\n  float: right;\n  font-size: 0.070707rem;\n  color: rgba(0, 0, 0, 0.65);\n  margin-right: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain-budget .iconfont[data-v-79d0c4be] {\n  font-size: 0.141414rem;\n}\n.page-contain-main-tab .main-block-contain-budget .icon-yitijiao[data-v-79d0c4be] {\n  color: #2D82F0;\n}\n.page-contain-main-tab .main-block-contain-budget .icon-shenpizhong[data-v-79d0c4be] {\n  color: #FFB52A;\n}\n.page-contain-main-tab .main-block-contain-budget .icon-shenpitongguo[data-v-79d0c4be] {\n  color: #0EC771;\n}\n.page-contain-main-tab .main-block-contain-budget .icon-shenpijujue[data-v-79d0c4be] {\n  color: #FB304D;\n}\n.page-contain-main-tab .main-block-contain-split-line[data-v-79d0c4be] {\n  width: 1.212121rem;\n  margin: 0.065657rem 0 0 0;\n  height: 0.040404rem;\n  background-color: #F0F2F5;\n  border-radius: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain-split-line .progress[data-v-79d0c4be] {\n  height: 0.040404rem;\n  background-color: #2D82F0;\n  border-radius: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain-split-line .pass[data-v-79d0c4be] {\n  height: 0.040404rem;\n  background-color: #0EC771;\n  border-radius: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain-split-line .pending[data-v-79d0c4be] {\n  height: 0.040404rem;\n  background-color: #FFB52A;\n  border-radius: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain-split-line .reject[data-v-79d0c4be] {\n  height: 0.040404rem;\n  background-color: #FB304D;\n  border-radius: 0.020202rem;\n}\n.page-contain-main-tab .main-block-contain-info[data-v-79d0c4be] {\n  margin-top: 0.045455rem;\n}\n.page-contain-main-tab .main-block-contain-season-amount[data-v-79d0c4be] {\n  font-size: 0.070707rem;\n  color: rgba(0, 0, 0, 0.65);\n}\n.page-contain-main-tab .main-block-contain-total[data-v-79d0c4be] {\n  float: right;\n  font-size: 0.070707rem;\n  color: rgba(0, 0, 0, 0.65);\n}\n.page-contain-main-tab .main-block-contain-total label[data-v-79d0c4be] {\n  margin-left: 0.040404rem;\n  color: rgba(0, 0, 0, 0.85);\n}\n.search-content[data-v-79d0c4be] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 0.111111rem;\n}\n.search-content .search-content-fields[data-v-79d0c4be] {\n  display: contents;\n}\n.search-content .search-content-fields-operate[data-v-79d0c4be] {\n  margin-left: auto !important;\n}\n.search-content .el-form-item + .el-form-item[data-v-79d0c4be] {\n  margin-left: 0.116162rem;\n}\n.operate[data-v-79d0c4be] {\n  float: right;\n  margin-bottom: 0.040404rem;\n}\n.operate-export[data-v-79d0c4be] {\n  font-size: 0.070707rem;\n}\n.operate-export a[data-v-79d0c4be] {\n  color: #0B41CD;\n}\n.operate-export i[data-v-79d0c4be] {\n  font-size: 0.070707rem;\n}\n.l-user-item[data-v-79d0c4be] {\n  width: 100%;\n  height: 0.287879rem;\n  padding: 0.090909rem 0.111111rem;\n  border-bottom: 0.005051rem solid #dfdfdf;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.l-user-item-icon[data-v-79d0c4be] {\n  font-size: 0.080808rem;\n  padding: 0.010101rem;\n}\n.budget-detail-info[data-v-79d0c4be] {\n  float: left;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  font-size: 0.070707rem;\n  color: #333333;\n}\n.main-budget-info-block[data-v-79d0c4be] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-bottom: 0.080808rem;\n}\n.main-budget-info-block-name[data-v-79d0c4be] {\n  width: 50%;\n}\n.main-budget-info-block-name label[data-v-79d0c4be] {\n  float: right;\n  font-size: 0.070707rem;\n  color: #666666;\n}\n.main-budget-info-block-value[data-v-79d0c4be] {\n  font-size: 0.070707rem;\n  color: #333333;\n}\n.bottom-info[data-v-79d0c4be] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: fixed;\n  background-color: #fff;\n  width: 100%;\n  left: 0;\n  height: 0.222222rem;\n  -webkit-box-shadow: -0.005051rem 0 0.020202rem 0 rgba(51, 51, 51, 0.35);\n          box-shadow: -0.005051rem 0 0.020202rem 0 rgba(51, 51, 51, 0.35);\n  bottom: 0;\n  z-index: 5;\n}\n.bottom-info-info[data-v-79d0c4be] {\n  margin-left: 0.606061rem;\n  line-height: 0.222222rem;\n}\n.bottom-info-operate[data-v-79d0c4be] {\n  position: absolute;\n  right: 0.606061rem;\n  line-height: 0.232323rem;\n}\n.advanced-search-dialog[data-v-79d0c4be] {\n  padding: 0;\n}\n.advanced-search-dialog .advanced-search-dialog-close[data-v-79d0c4be] {\n  font-size: 0.070707rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right[data-v-79d0c4be] {\n  margin-bottom: 0.025253rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row[data-v-79d0c4be] {\n  padding: 0.141414rem 0 0 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .advanced-search-form-title[data-v-79d0c4be] {\n  height: 0.20202rem;\n  line-height: 0.20202rem;\n  width: 0.454545rem;\n  font-weight: bold;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .advanced-search-form-title .iconfont[data-v-79d0c4be] {\n  font-size: 0.070707rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col[data-v-79d0c4be] {\n  width: 1.212121rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col .el-form-item__label[data-v-79d0c4be] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col .el-form-item__content[data-v-79d0c4be] {\n  padding-top: 0.010101rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col .el-form-item__content .el-select[data-v-79d0c4be],\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col .el-form-item__content .el-input[data-v-79d0c4be] {\n  width: 1.212121rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col .el-form-item__content label[data-v-79d0c4be] {\n  margin-left: 0.050505rem;\n}\n.advanced-search-dialog .el-form.el-form--label-right .el-row .el-col + .el-col[data-v-79d0c4be] {\n  margin-left: 0.621212rem;\n}\n.advanced-search-dialog-close[data-v-79d0c4be] {\n  margin-left: 0.126263rem;\n  cursor: pointer;\n}\n.advanced-search-dialog-score-model[data-v-79d0c4be] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 1.212121rem;\n}\n.advanced-search-dialog-score-model .el-input-number[data-v-79d0c4be] {\n  width: 0.484848rem !important;\n}\n.advanced-search-dialog-score-model span[data-v-79d0c4be] {\n  margin: auto 0.10101rem;\n  width: 0.050505rem;\n  border-bottom: 0.010101rem solid #666666;\n}\n.advanced-search-dialog .l-user-item[data-v-79d0c4be] {\n  width: 100%;\n  height: 0.20202rem;\n  padding: 0 0.111111rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.advanced-search-dialog .l-user-item-icon[data-v-79d0c4be] {\n  font-size: 0.080808rem;\n  padding: 0.010101rem;\n  width: 0.10101rem;\n}\n.advanced-search-dialog .l-user-item-text[data-v-79d0c4be] {\n  margin-left: 0.025253rem;\n  font-size: 0.070707rem;\n  line-height: 0.10101rem;\n  display: inline-block;\n}\n.advanced-search-dialog .l-user-item[data-v-79d0c4be]:hover {\n  color: #0B41CD;\n  cursor: pointer;\n}\n.advanced-search-dialog .l-user-item[data-v-79d0c4be]:last-child {\n  border-bottom: none;\n}\n.toolbar[data-v-79d0c4be] {\n  height: 0.191919rem;\n}\n.toolbar .application-detail-info[data-v-79d0c4be] {\n  float: left;\n  height: 0.111111rem;\n  line-height: 0.111111rem;\n  font-size: 0.070707rem;\n  color: #333333;\n}\n.toolbar .operate[data-v-79d0c4be] {\n  float: right;\n  height: 0.111111rem;\n  line-height: 0.111111rem;\n}\n.toolbar .operate-export[data-v-79d0c4be] {\n  font-size: 0.070707rem;\n}\n.toolbar .operate-export i[data-v-79d0c4be] {\n  font-size: 0.070707rem;\n}", ""]);

// exports


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-7c3e3aee],\nbody[data-v-7c3e3aee] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-7c3e3aee]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-7c3e3aee] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-7c3e3aee] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-7c3e3aee] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-7c3e3aee],\n  .page-contain[data-v-7c3e3aee],\n  .page-submenu[data-v-7c3e3aee] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-7c3e3aee] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-7c3e3aee] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-7c3e3aee] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-7c3e3aee] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-7c3e3aee] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-7c3e3aee] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-7c3e3aee] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-7c3e3aee] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-7c3e3aee],\n  .page-submenu[data-v-7c3e3aee] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-7c3e3aee] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-7c3e3aee] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-7c3e3aee] {\n    width: 76.3vw;\n}\n.v-main[data-v-7c3e3aee] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-7c3e3aee] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-7c3e3aee] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-7c3e3aee] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-7c3e3aee] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-7c3e3aee] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-7c3e3aee] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-7c3e3aee],\n  .page-submenu[data-v-7c3e3aee] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-7c3e3aee] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-7c3e3aee] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-7c3e3aee] {\n    width: 76.3vw;\n}\n.v-main[data-v-7c3e3aee] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-7c3e3aee] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-7c3e3aee] {\n  margin-top: 0.252525rem;\n}\n[data-v-7c3e3aee]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-7c3e3aee]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-7c3e3aee] {\n  text-align: right;\n}\n.aligncenter[data-v-7c3e3aee] {\n  text-align: center;\n}\n.alignleft[data-v-7c3e3aee] {\n  text-align: left;\n}\n.actiongroupborder[data-v-7c3e3aee] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-7c3e3aee] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-7c3e3aee] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-7c3e3aee] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-7c3e3aee] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-7c3e3aee] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-7c3e3aee] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-7c3e3aee] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-7c3e3aee] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-7c3e3aee] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-7c3e3aee] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-7c3e3aee] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-7c3e3aee] {\n  text-align: center;\n}\n.alignleft[data-v-7c3e3aee] {\n  text-align: left;\n}\n.alignright[data-v-7c3e3aee] {\n  text-align: right;\n}\n.e2e-container[data-v-7c3e3aee] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-7c3e3aee] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-7c3e3aee] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-7c3e3aee] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-7c3e3aee] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-7c3e3aee] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-7c3e3aee] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-7c3e3aee] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-7c3e3aee] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-7c3e3aee] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-7c3e3aee] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-7c3e3aee],\n.e2e-red-point-left[data-v-7c3e3aee] {\n  position: relative;\n}\n.e2e-red-point[data-v-7c3e3aee]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-7c3e3aee]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-7c3e3aee] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-7c3e3aee] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-7c3e3aee] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-7c3e3aee] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-7c3e3aee] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-7c3e3aee] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-7c3e3aee] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-7c3e3aee] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-7c3e3aee] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-7c3e3aee] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-7c3e3aee] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-7c3e3aee] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-7c3e3aee] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-7c3e3aee]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-7c3e3aee] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-7c3e3aee] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-7c3e3aee],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-7c3e3aee] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-7c3e3aee],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-7c3e3aee] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-7c3e3aee],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-7c3e3aee] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-7c3e3aee],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-7c3e3aee] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-7c3e3aee],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-7c3e3aee] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-7c3e3aee],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-7c3e3aee] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-7c3e3aee] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-7c3e3aee] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-7c3e3aee] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-7c3e3aee] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-7c3e3aee] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-7c3e3aee] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-7c3e3aee] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-7c3e3aee] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-7c3e3aee]:hover,\n.el-button--primary[data-v-7c3e3aee]:active,\n.el-button--primary[data-v-7c3e3aee]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-7c3e3aee] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-7c3e3aee]:hover,\n.el-button--primary.is-plain[data-v-7c3e3aee]:active,\n.el-button--primary.is-plain[data-v-7c3e3aee]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-7c3e3aee] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-7c3e3aee]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-7c3e3aee]:active,\n.el-button--primary.is-plain.is-disabled[data-v-7c3e3aee]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-7c3e3aee] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-7c3e3aee]:hover,\n.el-button--primary.is-disabled[data-v-7c3e3aee]:active,\n.el-button--primary.is-disabled[data-v-7c3e3aee]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-7c3e3aee] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-7c3e3aee]:hover,\n.el-button--default[data-v-7c3e3aee]:active,\n.el-button--default[data-v-7c3e3aee]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-7c3e3aee] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-7c3e3aee]:hover,\n.el-button--text[data-v-7c3e3aee]:active,\n.el-button--text[data-v-7c3e3aee]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-7c3e3aee] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-7c3e3aee],\n.operate a + .el-button[data-v-7c3e3aee],\n.operate span + .el-button[data-v-7c3e3aee],\n.operate a + span[data-v-7c3e3aee] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-7c3e3aee] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-7c3e3aee] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-7c3e3aee] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-7c3e3aee] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-7c3e3aee] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-7c3e3aee] {\n  color: #fff;\n}\n.el-loading-mask[data-v-7c3e3aee] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-7c3e3aee] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-7c3e3aee]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-7c3e3aee]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-7c3e3aee]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-7c3e3aee]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-7c3e3aee] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-7c3e3aee] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-7c3e3aee] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-7c3e3aee] {\n  color: #999;\n}\n.el-select-dropdown[data-v-7c3e3aee] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-7c3e3aee] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-7c3e3aee] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-7c3e3aee] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-7c3e3aee] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-7c3e3aee] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-7c3e3aee] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-7c3e3aee]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-7c3e3aee] {\n  display: none;\n}\n.el-table th > .cell[data-v-7c3e3aee] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-7c3e3aee] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-7c3e3aee] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-7c3e3aee] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-7c3e3aee]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-7c3e3aee]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-7c3e3aee] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-7c3e3aee] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-7c3e3aee] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-7c3e3aee] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-7c3e3aee] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-7c3e3aee] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-7c3e3aee] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-7c3e3aee] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-7c3e3aee],\n.el-pagination .btn-next[data-v-7c3e3aee] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-7c3e3aee],\n.el-pagination .btn-next span[data-v-7c3e3aee] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-7c3e3aee] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-7c3e3aee] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-7c3e3aee] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-7c3e3aee] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-7c3e3aee] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-7c3e3aee] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-7c3e3aee] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-7c3e3aee] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-7c3e3aee] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-7c3e3aee] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-7c3e3aee] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-7c3e3aee] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-7c3e3aee] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-7c3e3aee] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-7c3e3aee] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-7c3e3aee] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-7c3e3aee] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-7c3e3aee] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-7c3e3aee] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-7c3e3aee] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-7c3e3aee] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-7c3e3aee] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-7c3e3aee] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-7c3e3aee] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-7c3e3aee] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-7c3e3aee] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-7c3e3aee] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-7c3e3aee] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-7c3e3aee] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-7c3e3aee]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-7c3e3aee] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-7c3e3aee] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-7c3e3aee] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-7c3e3aee] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-7c3e3aee] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-7c3e3aee] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-7c3e3aee] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-7c3e3aee] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-7c3e3aee] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-7c3e3aee] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-7c3e3aee] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-7c3e3aee],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-7c3e3aee] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-7c3e3aee] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-7c3e3aee] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-7c3e3aee] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-7c3e3aee] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-7c3e3aee] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-7c3e3aee] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-7c3e3aee] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-7c3e3aee] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-7c3e3aee] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-7c3e3aee] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-7c3e3aee] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-7c3e3aee] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-7c3e3aee] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-7c3e3aee] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-7c3e3aee] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-7c3e3aee] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-7c3e3aee] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-7c3e3aee] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-7c3e3aee] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-7c3e3aee] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-7c3e3aee] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-7c3e3aee] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-7c3e3aee] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-7c3e3aee] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-7c3e3aee] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-7c3e3aee] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-7c3e3aee] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-7c3e3aee] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-7c3e3aee]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-7c3e3aee] {\n  color: #666666;\n}\n.el-radio__inner[data-v-7c3e3aee]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-7c3e3aee] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-7c3e3aee] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-7c3e3aee] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-7c3e3aee] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-7c3e3aee] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-7c3e3aee] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-7c3e3aee] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-7c3e3aee] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-7c3e3aee],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-7c3e3aee]:hover,\n.el-input__icon.el-icon-circle-close[data-v-7c3e3aee],\n.el-input__icon.el-icon-circle-close[data-v-7c3e3aee]:hover {\n  color: #FB304D;\n}\n*[data-v-7c3e3aee],\n*[data-v-7c3e3aee]:before,\n*[data-v-7c3e3aee]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-7c3e3aee],\ntextarea[data-v-7c3e3aee] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-7c3e3aee]:focus {\n  outline: none;\n}", ""]);

// exports


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-7db47407],\nbody[data-v-7db47407] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-7db47407]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-7db47407] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-7db47407] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-7db47407] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-7db47407],\n  .page-contain[data-v-7db47407],\n  .page-submenu[data-v-7db47407] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-7db47407] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-7db47407] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-7db47407] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-7db47407] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-7db47407] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-7db47407] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-7db47407] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-7db47407] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-7db47407],\n  .page-submenu[data-v-7db47407] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-7db47407] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-7db47407] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-7db47407] {\n    width: 76.3vw;\n}\n.v-main[data-v-7db47407] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-7db47407] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-7db47407] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-7db47407] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-7db47407] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-7db47407] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-7db47407] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-7db47407],\n  .page-submenu[data-v-7db47407] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-7db47407] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-7db47407] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-7db47407] {\n    width: 76.3vw;\n}\n.v-main[data-v-7db47407] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-7db47407] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-7db47407] {\n  margin-top: 0.252525rem;\n}\n[data-v-7db47407]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-7db47407]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-7db47407] {\n  text-align: right;\n}\n.aligncenter[data-v-7db47407] {\n  text-align: center;\n}\n.alignleft[data-v-7db47407] {\n  text-align: left;\n}\n.actiongroupborder[data-v-7db47407] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-7db47407] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-7db47407] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-7db47407] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-7db47407] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-7db47407] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-7db47407] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-7db47407] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-7db47407] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-7db47407] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-7db47407] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-7db47407] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-7db47407] {\n  text-align: center;\n}\n.alignleft[data-v-7db47407] {\n  text-align: left;\n}\n.alignright[data-v-7db47407] {\n  text-align: right;\n}\n.e2e-container[data-v-7db47407] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-7db47407] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-7db47407] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-7db47407] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-7db47407] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-7db47407] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-7db47407] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-7db47407] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-7db47407] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-7db47407] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-7db47407] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-7db47407],\n.e2e-red-point-left[data-v-7db47407] {\n  position: relative;\n}\n.e2e-red-point[data-v-7db47407]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-7db47407]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-7db47407] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-7db47407] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-7db47407] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-7db47407] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-7db47407] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-7db47407] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-7db47407] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-7db47407] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-7db47407] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-7db47407] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-7db47407] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-7db47407] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-7db47407] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-7db47407]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-7db47407] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-7db47407] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-7db47407],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-7db47407] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-7db47407],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-7db47407] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-7db47407],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-7db47407] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-7db47407],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-7db47407] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-7db47407],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-7db47407] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-7db47407],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-7db47407] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-7db47407] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-7db47407] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-7db47407] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-7db47407] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-7db47407] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-7db47407] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-7db47407] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-7db47407] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-7db47407]:hover,\n.el-button--primary[data-v-7db47407]:active,\n.el-button--primary[data-v-7db47407]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-7db47407] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-7db47407]:hover,\n.el-button--primary.is-plain[data-v-7db47407]:active,\n.el-button--primary.is-plain[data-v-7db47407]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-7db47407] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-7db47407]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-7db47407]:active,\n.el-button--primary.is-plain.is-disabled[data-v-7db47407]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-7db47407] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-7db47407]:hover,\n.el-button--primary.is-disabled[data-v-7db47407]:active,\n.el-button--primary.is-disabled[data-v-7db47407]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-7db47407] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-7db47407]:hover,\n.el-button--default[data-v-7db47407]:active,\n.el-button--default[data-v-7db47407]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-7db47407] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-7db47407]:hover,\n.el-button--text[data-v-7db47407]:active,\n.el-button--text[data-v-7db47407]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-7db47407] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-7db47407],\n.operate a + .el-button[data-v-7db47407],\n.operate span + .el-button[data-v-7db47407],\n.operate a + span[data-v-7db47407] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-7db47407] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-7db47407] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-7db47407] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-7db47407] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-7db47407] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-7db47407] {\n  color: #fff;\n}\n.el-loading-mask[data-v-7db47407] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-7db47407] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-7db47407]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-7db47407]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-7db47407]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-7db47407]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-7db47407] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-7db47407] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-7db47407] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-7db47407] {\n  color: #999;\n}\n.el-select-dropdown[data-v-7db47407] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-7db47407] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-7db47407] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-7db47407] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-7db47407] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-7db47407] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-7db47407] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-7db47407]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-7db47407] {\n  display: none;\n}\n.el-table th > .cell[data-v-7db47407] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-7db47407] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-7db47407] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-7db47407] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-7db47407]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-7db47407]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-7db47407] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-7db47407] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-7db47407] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-7db47407] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-7db47407] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-7db47407] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-7db47407] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-7db47407] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-7db47407],\n.el-pagination .btn-next[data-v-7db47407] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-7db47407],\n.el-pagination .btn-next span[data-v-7db47407] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-7db47407] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-7db47407] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-7db47407] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-7db47407] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-7db47407] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-7db47407] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-7db47407] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-7db47407] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-7db47407] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-7db47407] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-7db47407] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-7db47407] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-7db47407] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-7db47407] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-7db47407] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-7db47407] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-7db47407] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-7db47407] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-7db47407] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-7db47407] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-7db47407] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-7db47407] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-7db47407] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-7db47407] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-7db47407] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-7db47407] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-7db47407] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-7db47407] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-7db47407] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-7db47407]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-7db47407] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-7db47407] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-7db47407] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-7db47407] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-7db47407] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-7db47407] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-7db47407] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-7db47407] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-7db47407] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-7db47407] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-7db47407] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-7db47407],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-7db47407] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-7db47407] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-7db47407] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-7db47407] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-7db47407] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-7db47407] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-7db47407] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-7db47407] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-7db47407] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-7db47407] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-7db47407] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-7db47407] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-7db47407] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-7db47407] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-7db47407] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-7db47407] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-7db47407] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-7db47407] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-7db47407] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-7db47407] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-7db47407] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-7db47407] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-7db47407] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-7db47407] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-7db47407] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-7db47407] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-7db47407] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-7db47407] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-7db47407] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-7db47407]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-7db47407] {\n  color: #666666;\n}\n.el-radio__inner[data-v-7db47407]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-7db47407] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-7db47407] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-7db47407] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-7db47407] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-7db47407] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-7db47407] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-7db47407] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-7db47407] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-7db47407],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-7db47407]:hover,\n.el-input__icon.el-icon-circle-close[data-v-7db47407],\n.el-input__icon.el-icon-circle-close[data-v-7db47407]:hover {\n  color: #FB304D;\n}\n*[data-v-7db47407],\n*[data-v-7db47407]:before,\n*[data-v-7db47407]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-7db47407],\ntextarea[data-v-7db47407] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-7db47407]:focus {\n  outline: none;\n}\n.e2e-upload-container .label-box[data-v-7db47407] {\n  width: 1.616162rem;\n  white-space: nowrap;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 0 0 0.040404rem 0;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.e2e-upload-container .label-box .label-item[data-v-7db47407] {\n  height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-upload-container .label-box .upload-item[data-v-7db47407] {\n  height: 0.121212rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.e2e-upload-container .label-box .upload-item .btn-add-text[data-v-7db47407] {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #0B41CD;\n  line-height: 0.080808rem;\n}\n.e2e-upload-container .label-box .upload-item[data-v-7db47407] .el-upload {\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.e2e-upload-container .file-box .line-file-box[data-v-7db47407] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-top: 0.10101rem;\n}\n.e2e-upload-container .file-box .line-file-box[data-v-7db47407]:nth-child(1) {\n  margin-top: 0;\n}\n.e2e-upload-container .file-box .file-item[data-v-7db47407] {\n  width: 1.616162rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 0.040404rem 0.080808rem 0.040404rem 0;\n  border-radius: 0.020202rem;\n  border: 0.005051rem solid #ccc;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.e2e-upload-container .file-box .file-item .file-type-box[data-v-7db47407] {\n  padding: 0.020202rem 0.040404rem;\n  height: 0.242424rem;\n}\n.e2e-upload-container .file-box .file-item .file-action-box[data-v-7db47407] {\n  height: 0.242424rem;\n  font-size: 0.070707rem;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  font-weight: 400;\n  color: #999999;\n  line-height: 0.121212rem;\n  letter-spacing: 0;\n}\n.e2e-upload-container .file-box .file-item .file-action-box .line[data-v-7db47407] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n}\n.e2e-upload-container .file-box .file-item .file-action-box .line .line-file-name[data-v-7db47407] {\n  max-width: 0.707071rem;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  cursor: pointer;\n}\n.e2e-upload-container .file-box .file-item .file-action-box .line .line-file-delete[data-v-7db47407] {\n  text-align: right;\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #e40030;\n  letter-spacing: 0;\n  cursor: pointer;\n}\n.e2e-upload-container .file-box .file-item .file-action-box .line .line-file-download[data-v-7db47407],\n.e2e-upload-container .file-box .file-item .file-action-box .line .line-file-preview[data-v-7db47407] {\n  text-align: right;\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #008748;\n  letter-spacing: 0;\n  cursor: pointer;\n}\n.e2e-upload-container .file-box .file-item .file-action-box .line .line-file-download[data-v-7db47407] {\n  margin-left: 0.025253rem;\n}\n.e2e-upload-container .file-box .empty-file-item[data-v-7db47407] {\n  border: none;\n}\n.empty-box[data-v-7db47407] {\n  width: 100%;\n  padding: 0.10101rem;\n  text-align: center;\n}\n.empty-box .empty-upload[data-v-7db47407] .e2e-single-upload-container .e2e-single-upload {\n  display: block;\n}\n.el-checkbox[data-v-7db47407] {\n  margin-right: 0;\n  line-height: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding: 0 0.025253rem;\n}\n.el-checkbox[data-v-7db47407] .el-checkbox__label {\n  display: none;\n}\n.el-checkbox.empty-file-item[data-v-7db47407] {\n  display: none;\n}", ""]);

// exports


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-7f1a157a],\nbody[data-v-7f1a157a] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-7f1a157a]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-7f1a157a] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-7f1a157a] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-7f1a157a] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-7f1a157a],\n  .page-contain[data-v-7f1a157a],\n  .page-submenu[data-v-7f1a157a] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-7f1a157a] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-7f1a157a] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-7f1a157a] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-7f1a157a] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-7f1a157a] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-7f1a157a] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-7f1a157a] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-7f1a157a] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-7f1a157a],\n  .page-submenu[data-v-7f1a157a] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-7f1a157a] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-7f1a157a] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-7f1a157a] {\n    width: 76.3vw;\n}\n.v-main[data-v-7f1a157a] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-7f1a157a] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-7f1a157a] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-7f1a157a] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-7f1a157a] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-7f1a157a] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-7f1a157a] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-7f1a157a],\n  .page-submenu[data-v-7f1a157a] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-7f1a157a] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-7f1a157a] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-7f1a157a] {\n    width: 76.3vw;\n}\n.v-main[data-v-7f1a157a] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-7f1a157a] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-7f1a157a] {\n  margin-top: 0.252525rem;\n}\n[data-v-7f1a157a]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-7f1a157a]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-7f1a157a] {\n  text-align: right;\n}\n.aligncenter[data-v-7f1a157a] {\n  text-align: center;\n}\n.alignleft[data-v-7f1a157a] {\n  text-align: left;\n}\n.actiongroupborder[data-v-7f1a157a] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-7f1a157a] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-7f1a157a] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-7f1a157a] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-7f1a157a] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-7f1a157a] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-7f1a157a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-7f1a157a] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-7f1a157a] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-7f1a157a] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-7f1a157a] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-7f1a157a] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-7f1a157a] {\n  text-align: center;\n}\n.alignleft[data-v-7f1a157a] {\n  text-align: left;\n}\n.alignright[data-v-7f1a157a] {\n  text-align: right;\n}\n.e2e-container[data-v-7f1a157a] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-7f1a157a] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-7f1a157a] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-7f1a157a] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-7f1a157a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-7f1a157a] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-7f1a157a] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-7f1a157a] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-7f1a157a] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-7f1a157a] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-7f1a157a] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-7f1a157a],\n.e2e-red-point-left[data-v-7f1a157a] {\n  position: relative;\n}\n.e2e-red-point[data-v-7f1a157a]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-7f1a157a]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-7f1a157a] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-7f1a157a] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-7f1a157a] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-7f1a157a] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-7f1a157a] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-7f1a157a] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-7f1a157a] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-7f1a157a] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-7f1a157a] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-7f1a157a] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-7f1a157a] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-7f1a157a] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-7f1a157a] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-7f1a157a]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-7f1a157a] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-7f1a157a] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-7f1a157a],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-7f1a157a] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-7f1a157a],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-7f1a157a] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-7f1a157a],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-7f1a157a] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-7f1a157a],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-7f1a157a] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-7f1a157a],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-7f1a157a] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-7f1a157a],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-7f1a157a] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-7f1a157a] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-7f1a157a] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-7f1a157a] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-7f1a157a] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-7f1a157a] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-7f1a157a] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-7f1a157a] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-7f1a157a] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-7f1a157a]:hover,\n.el-button--primary[data-v-7f1a157a]:active,\n.el-button--primary[data-v-7f1a157a]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-7f1a157a] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-7f1a157a]:hover,\n.el-button--primary.is-plain[data-v-7f1a157a]:active,\n.el-button--primary.is-plain[data-v-7f1a157a]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-7f1a157a] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-7f1a157a]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-7f1a157a]:active,\n.el-button--primary.is-plain.is-disabled[data-v-7f1a157a]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-7f1a157a] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-7f1a157a]:hover,\n.el-button--primary.is-disabled[data-v-7f1a157a]:active,\n.el-button--primary.is-disabled[data-v-7f1a157a]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-7f1a157a] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-7f1a157a]:hover,\n.el-button--default[data-v-7f1a157a]:active,\n.el-button--default[data-v-7f1a157a]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-7f1a157a] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-7f1a157a]:hover,\n.el-button--text[data-v-7f1a157a]:active,\n.el-button--text[data-v-7f1a157a]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-7f1a157a] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-7f1a157a],\n.operate a + .el-button[data-v-7f1a157a],\n.operate span + .el-button[data-v-7f1a157a],\n.operate a + span[data-v-7f1a157a] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-7f1a157a] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-7f1a157a] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-7f1a157a] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-7f1a157a] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-7f1a157a] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-7f1a157a] {\n  color: #fff;\n}\n.el-loading-mask[data-v-7f1a157a] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-7f1a157a] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-7f1a157a]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-7f1a157a]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-7f1a157a]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-7f1a157a]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-7f1a157a] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-7f1a157a] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-7f1a157a] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-7f1a157a] {\n  color: #999;\n}\n.el-select-dropdown[data-v-7f1a157a] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-7f1a157a] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-7f1a157a] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-7f1a157a] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-7f1a157a] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-7f1a157a] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-7f1a157a] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-7f1a157a]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-7f1a157a] {\n  display: none;\n}\n.el-table th > .cell[data-v-7f1a157a] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-7f1a157a] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-7f1a157a] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-7f1a157a] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-7f1a157a]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-7f1a157a]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-7f1a157a] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-7f1a157a] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-7f1a157a] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-7f1a157a] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-7f1a157a] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-7f1a157a] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-7f1a157a] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-7f1a157a] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-7f1a157a],\n.el-pagination .btn-next[data-v-7f1a157a] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-7f1a157a],\n.el-pagination .btn-next span[data-v-7f1a157a] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-7f1a157a] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-7f1a157a] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-7f1a157a] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-7f1a157a] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-7f1a157a] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-7f1a157a] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-7f1a157a] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-7f1a157a] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-7f1a157a] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-7f1a157a] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-7f1a157a] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-7f1a157a] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-7f1a157a] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-7f1a157a] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-7f1a157a] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-7f1a157a] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-7f1a157a] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-7f1a157a] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-7f1a157a] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-7f1a157a] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-7f1a157a] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-7f1a157a] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-7f1a157a] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-7f1a157a] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-7f1a157a] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-7f1a157a] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-7f1a157a] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-7f1a157a] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-7f1a157a] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-7f1a157a]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-7f1a157a] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-7f1a157a] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-7f1a157a] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-7f1a157a] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-7f1a157a] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-7f1a157a] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-7f1a157a] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-7f1a157a] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-7f1a157a] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-7f1a157a] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-7f1a157a] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-7f1a157a],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-7f1a157a] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-7f1a157a] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-7f1a157a] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-7f1a157a] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-7f1a157a] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-7f1a157a] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-7f1a157a] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-7f1a157a] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-7f1a157a] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-7f1a157a] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-7f1a157a] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-7f1a157a] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-7f1a157a] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-7f1a157a] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-7f1a157a] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-7f1a157a] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-7f1a157a] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-7f1a157a] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-7f1a157a] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-7f1a157a] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-7f1a157a] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-7f1a157a] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-7f1a157a] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-7f1a157a] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-7f1a157a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-7f1a157a] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-7f1a157a] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-7f1a157a] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-7f1a157a] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-7f1a157a]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-7f1a157a] {\n  color: #666666;\n}\n.el-radio__inner[data-v-7f1a157a]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-7f1a157a] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-7f1a157a] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-7f1a157a] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-7f1a157a] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-7f1a157a] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-7f1a157a] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-7f1a157a] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-7f1a157a] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-7f1a157a],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-7f1a157a]:hover,\n.el-input__icon.el-icon-circle-close[data-v-7f1a157a],\n.el-input__icon.el-icon-circle-close[data-v-7f1a157a]:hover {\n  color: #FB304D;\n}\n*[data-v-7f1a157a],\n*[data-v-7f1a157a]:before,\n*[data-v-7f1a157a]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-7f1a157a],\ntextarea[data-v-7f1a157a] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-7f1a157a]:focus {\n  outline: none;\n}\n.search-content[data-v-7f1a157a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 0.111111rem;\n}\n.search-content .search-content-fields[data-v-7f1a157a] {\n  width: 4.040404rem;\n}\n.operate[data-v-7f1a157a] {\n  float: right;\n  margin-bottom: 0.151515rem;\n}", ""]);

// exports


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-81adb67a],\nbody[data-v-81adb67a] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-81adb67a]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-81adb67a] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-81adb67a] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-81adb67a] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-81adb67a],\n  .page-contain[data-v-81adb67a],\n  .page-submenu[data-v-81adb67a] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-81adb67a] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-81adb67a] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-81adb67a] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-81adb67a] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-81adb67a] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-81adb67a] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-81adb67a] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-81adb67a] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-81adb67a],\n  .page-submenu[data-v-81adb67a] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-81adb67a] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-81adb67a] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-81adb67a] {\n    width: 76.3vw;\n}\n.v-main[data-v-81adb67a] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-81adb67a] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-81adb67a] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-81adb67a] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-81adb67a] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-81adb67a] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-81adb67a] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-81adb67a],\n  .page-submenu[data-v-81adb67a] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-81adb67a] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-81adb67a] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-81adb67a] {\n    width: 76.3vw;\n}\n.v-main[data-v-81adb67a] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-81adb67a] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-81adb67a] {\n  margin-top: 0.252525rem;\n}\n[data-v-81adb67a]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-81adb67a]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-81adb67a] {\n  text-align: right;\n}\n.aligncenter[data-v-81adb67a] {\n  text-align: center;\n}\n.alignleft[data-v-81adb67a] {\n  text-align: left;\n}\n.actiongroupborder[data-v-81adb67a] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-81adb67a] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-81adb67a] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-81adb67a] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-81adb67a] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-81adb67a] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-81adb67a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-81adb67a] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-81adb67a] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-81adb67a] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-81adb67a] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-81adb67a] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-81adb67a] {\n  text-align: center;\n}\n.alignleft[data-v-81adb67a] {\n  text-align: left;\n}\n.alignright[data-v-81adb67a] {\n  text-align: right;\n}\n.e2e-container[data-v-81adb67a] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-81adb67a] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-81adb67a] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-81adb67a] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-81adb67a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-81adb67a] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-81adb67a] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-81adb67a] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-81adb67a] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-81adb67a] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-81adb67a] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-81adb67a],\n.e2e-red-point-left[data-v-81adb67a] {\n  position: relative;\n}\n.e2e-red-point[data-v-81adb67a]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-81adb67a]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-81adb67a] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-81adb67a] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-81adb67a] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-81adb67a] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-81adb67a] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-81adb67a] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-81adb67a] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-81adb67a] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-81adb67a] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-81adb67a] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-81adb67a] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-81adb67a] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-81adb67a] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-81adb67a]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-81adb67a] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-81adb67a] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-81adb67a],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-81adb67a] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-81adb67a],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-81adb67a] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-81adb67a],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-81adb67a] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-81adb67a],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-81adb67a] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-81adb67a],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-81adb67a] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-81adb67a],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-81adb67a] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-81adb67a] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-81adb67a] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-81adb67a] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-81adb67a] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-81adb67a] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-81adb67a] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-81adb67a] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-81adb67a] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-81adb67a]:hover,\n.el-button--primary[data-v-81adb67a]:active,\n.el-button--primary[data-v-81adb67a]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-81adb67a] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-81adb67a]:hover,\n.el-button--primary.is-plain[data-v-81adb67a]:active,\n.el-button--primary.is-plain[data-v-81adb67a]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-81adb67a] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-81adb67a]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-81adb67a]:active,\n.el-button--primary.is-plain.is-disabled[data-v-81adb67a]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-81adb67a] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-81adb67a]:hover,\n.el-button--primary.is-disabled[data-v-81adb67a]:active,\n.el-button--primary.is-disabled[data-v-81adb67a]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-81adb67a] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-81adb67a]:hover,\n.el-button--default[data-v-81adb67a]:active,\n.el-button--default[data-v-81adb67a]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-81adb67a] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-81adb67a]:hover,\n.el-button--text[data-v-81adb67a]:active,\n.el-button--text[data-v-81adb67a]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-81adb67a] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-81adb67a],\n.operate a + .el-button[data-v-81adb67a],\n.operate span + .el-button[data-v-81adb67a],\n.operate a + span[data-v-81adb67a] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-81adb67a] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-81adb67a] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-81adb67a] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-81adb67a] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-81adb67a] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-81adb67a] {\n  color: #fff;\n}\n.el-loading-mask[data-v-81adb67a] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-81adb67a] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-81adb67a]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-81adb67a]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-81adb67a]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-81adb67a]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-81adb67a] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-81adb67a] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-81adb67a] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-81adb67a] {\n  color: #999;\n}\n.el-select-dropdown[data-v-81adb67a] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-81adb67a] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-81adb67a] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-81adb67a] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-81adb67a] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-81adb67a] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-81adb67a] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-81adb67a]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-81adb67a] {\n  display: none;\n}\n.el-table th > .cell[data-v-81adb67a] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-81adb67a] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-81adb67a] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-81adb67a] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-81adb67a]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-81adb67a]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-81adb67a] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-81adb67a] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-81adb67a] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-81adb67a] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-81adb67a] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-81adb67a] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-81adb67a] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-81adb67a] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-81adb67a],\n.el-pagination .btn-next[data-v-81adb67a] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-81adb67a],\n.el-pagination .btn-next span[data-v-81adb67a] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-81adb67a] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-81adb67a] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-81adb67a] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-81adb67a] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-81adb67a] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-81adb67a] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-81adb67a] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-81adb67a] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-81adb67a] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-81adb67a] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-81adb67a] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-81adb67a] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-81adb67a] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-81adb67a] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-81adb67a] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-81adb67a] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-81adb67a] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-81adb67a] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-81adb67a] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-81adb67a] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-81adb67a] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-81adb67a] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-81adb67a] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-81adb67a] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-81adb67a] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-81adb67a] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-81adb67a] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-81adb67a] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-81adb67a] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-81adb67a]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-81adb67a] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-81adb67a] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-81adb67a] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-81adb67a] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-81adb67a] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-81adb67a] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-81adb67a] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-81adb67a] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-81adb67a] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-81adb67a] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-81adb67a] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-81adb67a],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-81adb67a] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-81adb67a] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-81adb67a] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-81adb67a] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-81adb67a] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-81adb67a] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-81adb67a] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-81adb67a] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-81adb67a] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-81adb67a] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-81adb67a] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-81adb67a] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-81adb67a] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-81adb67a] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-81adb67a] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-81adb67a] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-81adb67a] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-81adb67a] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-81adb67a] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-81adb67a] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-81adb67a] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-81adb67a] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-81adb67a] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-81adb67a] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-81adb67a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-81adb67a] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-81adb67a] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-81adb67a] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-81adb67a] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-81adb67a]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-81adb67a] {\n  color: #666666;\n}\n.el-radio__inner[data-v-81adb67a]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-81adb67a] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-81adb67a] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-81adb67a] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-81adb67a] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-81adb67a] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-81adb67a] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-81adb67a] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-81adb67a] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-81adb67a],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-81adb67a]:hover,\n.el-input__icon.el-icon-circle-close[data-v-81adb67a],\n.el-input__icon.el-icon-circle-close[data-v-81adb67a]:hover {\n  color: #FB304D;\n}\n*[data-v-81adb67a],\n*[data-v-81adb67a]:before,\n*[data-v-81adb67a]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-81adb67a],\ntextarea[data-v-81adb67a] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-81adb67a]:focus {\n  outline: none;\n}\n.search-content[data-v-81adb67a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 0.111111rem;\n}\n.search-content .search-content-fields[data-v-81adb67a] {\n  width: 4.040404rem;\n}\n.search-content .search-content-fields .el-input[data-v-81adb67a] {\n  width: 1.010101rem;\n}\n.search-content .search-content-fields .el-button[data-v-81adb67a] {\n  margin-top: 0.20202rem;\n}\n.operate[data-v-81adb67a] {\n  float: right;\n  margin-bottom: 0.151515rem;\n}", ""]);

// exports


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-88141bec],\nbody[data-v-88141bec] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-88141bec]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-88141bec] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-88141bec] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-88141bec] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-88141bec],\n  .page-contain[data-v-88141bec],\n  .page-submenu[data-v-88141bec] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-88141bec] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-88141bec] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-88141bec] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-88141bec] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-88141bec] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-88141bec] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-88141bec] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-88141bec] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-88141bec],\n  .page-submenu[data-v-88141bec] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-88141bec] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-88141bec] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-88141bec] {\n    width: 76.3vw;\n}\n.v-main[data-v-88141bec] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-88141bec] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-88141bec] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-88141bec] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-88141bec] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-88141bec] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-88141bec] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-88141bec],\n  .page-submenu[data-v-88141bec] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-88141bec] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-88141bec] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-88141bec] {\n    width: 76.3vw;\n}\n.v-main[data-v-88141bec] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-88141bec] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-88141bec] {\n  margin-top: 0.252525rem;\n}\n[data-v-88141bec]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-88141bec]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-88141bec] {\n  text-align: right;\n}\n.aligncenter[data-v-88141bec] {\n  text-align: center;\n}\n.alignleft[data-v-88141bec] {\n  text-align: left;\n}\n.actiongroupborder[data-v-88141bec] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-88141bec] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-88141bec] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-88141bec] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-88141bec] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-88141bec] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-88141bec] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-88141bec] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-88141bec] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-88141bec] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-88141bec] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-88141bec] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-88141bec] {\n  text-align: center;\n}\n.alignleft[data-v-88141bec] {\n  text-align: left;\n}\n.alignright[data-v-88141bec] {\n  text-align: right;\n}\n.e2e-container[data-v-88141bec] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-88141bec] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-88141bec] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-88141bec] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-88141bec] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-88141bec] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-88141bec] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-88141bec] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-88141bec] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-88141bec] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-88141bec] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-88141bec],\n.e2e-red-point-left[data-v-88141bec] {\n  position: relative;\n}\n.e2e-red-point[data-v-88141bec]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-88141bec]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-88141bec] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-88141bec] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-88141bec] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-88141bec] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-88141bec] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-88141bec] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-88141bec] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-88141bec] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-88141bec] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-88141bec] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-88141bec] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-88141bec] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-88141bec] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-88141bec]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-88141bec] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-88141bec] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-88141bec],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-88141bec] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-88141bec],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-88141bec] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-88141bec],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-88141bec] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-88141bec],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-88141bec] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-88141bec],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-88141bec] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-88141bec],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-88141bec] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-88141bec] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-88141bec] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-88141bec] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-88141bec] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-88141bec] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-88141bec] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-88141bec] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-88141bec] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-88141bec]:hover,\n.el-button--primary[data-v-88141bec]:active,\n.el-button--primary[data-v-88141bec]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-88141bec] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-88141bec]:hover,\n.el-button--primary.is-plain[data-v-88141bec]:active,\n.el-button--primary.is-plain[data-v-88141bec]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-88141bec] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-88141bec]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-88141bec]:active,\n.el-button--primary.is-plain.is-disabled[data-v-88141bec]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-88141bec] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-88141bec]:hover,\n.el-button--primary.is-disabled[data-v-88141bec]:active,\n.el-button--primary.is-disabled[data-v-88141bec]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-88141bec] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-88141bec]:hover,\n.el-button--default[data-v-88141bec]:active,\n.el-button--default[data-v-88141bec]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-88141bec] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-88141bec]:hover,\n.el-button--text[data-v-88141bec]:active,\n.el-button--text[data-v-88141bec]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-88141bec] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-88141bec],\n.operate a + .el-button[data-v-88141bec],\n.operate span + .el-button[data-v-88141bec],\n.operate a + span[data-v-88141bec] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-88141bec] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-88141bec] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-88141bec] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-88141bec] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-88141bec] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-88141bec] {\n  color: #fff;\n}\n.el-loading-mask[data-v-88141bec] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-88141bec] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-88141bec]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-88141bec]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-88141bec]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-88141bec]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-88141bec] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-88141bec] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-88141bec] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-88141bec] {\n  color: #999;\n}\n.el-select-dropdown[data-v-88141bec] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-88141bec] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-88141bec] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-88141bec] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-88141bec] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-88141bec] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-88141bec] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-88141bec]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-88141bec] {\n  display: none;\n}\n.el-table th > .cell[data-v-88141bec] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-88141bec] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-88141bec] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-88141bec] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-88141bec]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-88141bec]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-88141bec] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-88141bec] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-88141bec] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-88141bec] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-88141bec] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-88141bec] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-88141bec] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-88141bec] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-88141bec],\n.el-pagination .btn-next[data-v-88141bec] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-88141bec],\n.el-pagination .btn-next span[data-v-88141bec] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-88141bec] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-88141bec] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-88141bec] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-88141bec] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-88141bec] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-88141bec] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-88141bec] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-88141bec] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-88141bec] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-88141bec] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-88141bec] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-88141bec] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-88141bec] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-88141bec] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-88141bec] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-88141bec] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-88141bec] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-88141bec] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-88141bec] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-88141bec] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-88141bec] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-88141bec] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-88141bec] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-88141bec] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-88141bec] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-88141bec] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-88141bec] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-88141bec] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-88141bec] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-88141bec]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-88141bec] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-88141bec] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-88141bec] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-88141bec] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-88141bec] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-88141bec] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-88141bec] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-88141bec] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-88141bec] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-88141bec] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-88141bec] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-88141bec],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-88141bec] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-88141bec] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-88141bec] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-88141bec] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-88141bec] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-88141bec] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-88141bec] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-88141bec] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-88141bec] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-88141bec] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-88141bec] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-88141bec] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-88141bec] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-88141bec] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-88141bec] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-88141bec] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-88141bec] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-88141bec] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-88141bec] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-88141bec] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-88141bec] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-88141bec] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-88141bec] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-88141bec] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-88141bec] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-88141bec] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-88141bec] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-88141bec] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-88141bec] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-88141bec]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-88141bec] {\n  color: #666666;\n}\n.el-radio__inner[data-v-88141bec]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-88141bec] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-88141bec] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-88141bec] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-88141bec] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-88141bec] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-88141bec] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-88141bec] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-88141bec] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-88141bec],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-88141bec]:hover,\n.el-input__icon.el-icon-circle-close[data-v-88141bec],\n.el-input__icon.el-icon-circle-close[data-v-88141bec]:hover {\n  color: #FB304D;\n}\n*[data-v-88141bec],\n*[data-v-88141bec]:before,\n*[data-v-88141bec]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-88141bec],\ntextarea[data-v-88141bec] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-88141bec]:focus {\n  outline: none;\n}\n.l-user-item[data-v-88141bec] {\n  width: 100%;\n  height: 0.287879rem;\n  padding: 0.090909rem 0.111111rem;\n  border-bottom: 0.005051rem solid #dfdfdf;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.l-user-item-icon[data-v-88141bec] {\n  font-size: 0.080808rem;\n  padding: 0.010101rem;\n  font-style: normal;\n}\n.l-user-item-text[data-v-88141bec] {\n  margin-left: 0.035354rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.10101rem;\n  display: inline-block;\n}\n.l-user-item[data-v-88141bec]:hover {\n  color: #0B41CD;\n  cursor: pointer;\n}\n.l-user-item[data-v-88141bec]:last-child {\n  border-bottom: none;\n}\n.selected[data-v-88141bec] {\n  color: #0B41CD;\n}", ""]);

// exports


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-a103c38a],\nbody[data-v-a103c38a] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-a103c38a]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-a103c38a] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-a103c38a] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-a103c38a] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-a103c38a],\n  .page-contain[data-v-a103c38a],\n  .page-submenu[data-v-a103c38a] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-a103c38a] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-a103c38a] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-a103c38a] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-a103c38a] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-a103c38a] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-a103c38a] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-a103c38a] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-a103c38a] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-a103c38a],\n  .page-submenu[data-v-a103c38a] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-a103c38a] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-a103c38a] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-a103c38a] {\n    width: 76.3vw;\n}\n.v-main[data-v-a103c38a] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-a103c38a] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-a103c38a] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-a103c38a] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-a103c38a] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-a103c38a] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-a103c38a] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-a103c38a],\n  .page-submenu[data-v-a103c38a] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-a103c38a] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-a103c38a] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-a103c38a] {\n    width: 76.3vw;\n}\n.v-main[data-v-a103c38a] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-a103c38a] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-a103c38a] {\n  margin-top: 0.252525rem;\n}\n[data-v-a103c38a]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-a103c38a]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-a103c38a] {\n  text-align: right;\n}\n.aligncenter[data-v-a103c38a] {\n  text-align: center;\n}\n.alignleft[data-v-a103c38a] {\n  text-align: left;\n}\n.actiongroupborder[data-v-a103c38a] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-a103c38a] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-a103c38a] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-a103c38a] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-a103c38a] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-a103c38a] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-a103c38a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-a103c38a] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-a103c38a] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-a103c38a] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-a103c38a] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-a103c38a] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-a103c38a] {\n  text-align: center;\n}\n.alignleft[data-v-a103c38a] {\n  text-align: left;\n}\n.alignright[data-v-a103c38a] {\n  text-align: right;\n}\n.e2e-container[data-v-a103c38a] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-a103c38a] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-a103c38a] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-a103c38a] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-a103c38a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-a103c38a] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-a103c38a] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-a103c38a] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-a103c38a] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-a103c38a] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-a103c38a] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-a103c38a],\n.e2e-red-point-left[data-v-a103c38a] {\n  position: relative;\n}\n.e2e-red-point[data-v-a103c38a]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-a103c38a]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-a103c38a] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-a103c38a] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-a103c38a] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-a103c38a] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-a103c38a] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-a103c38a] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-a103c38a] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-a103c38a] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-a103c38a] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-a103c38a] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-a103c38a] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-a103c38a] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-a103c38a] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-a103c38a]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-a103c38a] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-a103c38a] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-a103c38a],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-a103c38a] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-a103c38a],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-a103c38a] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-a103c38a],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-a103c38a] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-a103c38a],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-a103c38a] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-a103c38a],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-a103c38a] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-a103c38a],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-a103c38a] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-a103c38a] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-a103c38a] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-a103c38a] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-a103c38a] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-a103c38a] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-a103c38a] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-a103c38a] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-a103c38a] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-a103c38a]:hover,\n.el-button--primary[data-v-a103c38a]:active,\n.el-button--primary[data-v-a103c38a]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-a103c38a] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-a103c38a]:hover,\n.el-button--primary.is-plain[data-v-a103c38a]:active,\n.el-button--primary.is-plain[data-v-a103c38a]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-a103c38a] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-a103c38a]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-a103c38a]:active,\n.el-button--primary.is-plain.is-disabled[data-v-a103c38a]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-a103c38a] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-a103c38a]:hover,\n.el-button--primary.is-disabled[data-v-a103c38a]:active,\n.el-button--primary.is-disabled[data-v-a103c38a]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-a103c38a] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-a103c38a]:hover,\n.el-button--default[data-v-a103c38a]:active,\n.el-button--default[data-v-a103c38a]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-a103c38a] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-a103c38a]:hover,\n.el-button--text[data-v-a103c38a]:active,\n.el-button--text[data-v-a103c38a]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-a103c38a] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-a103c38a],\n.operate a + .el-button[data-v-a103c38a],\n.operate span + .el-button[data-v-a103c38a],\n.operate a + span[data-v-a103c38a] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-a103c38a] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-a103c38a] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-a103c38a] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-a103c38a] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-a103c38a] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-a103c38a] {\n  color: #fff;\n}\n.el-loading-mask[data-v-a103c38a] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-a103c38a] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-a103c38a]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-a103c38a]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-a103c38a]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-a103c38a]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-a103c38a] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-a103c38a] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-a103c38a] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-a103c38a] {\n  color: #999;\n}\n.el-select-dropdown[data-v-a103c38a] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-a103c38a] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-a103c38a] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-a103c38a] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-a103c38a] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-a103c38a] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-a103c38a] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-a103c38a]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-a103c38a] {\n  display: none;\n}\n.el-table th > .cell[data-v-a103c38a] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-a103c38a] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-a103c38a] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-a103c38a] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-a103c38a]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-a103c38a]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-a103c38a] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-a103c38a] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-a103c38a] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-a103c38a] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-a103c38a] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-a103c38a] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-a103c38a] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-a103c38a] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-a103c38a],\n.el-pagination .btn-next[data-v-a103c38a] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-a103c38a],\n.el-pagination .btn-next span[data-v-a103c38a] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-a103c38a] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-a103c38a] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-a103c38a] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-a103c38a] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-a103c38a] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-a103c38a] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-a103c38a] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-a103c38a] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-a103c38a] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-a103c38a] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-a103c38a] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-a103c38a] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-a103c38a] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-a103c38a] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-a103c38a] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-a103c38a] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-a103c38a] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-a103c38a] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-a103c38a] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-a103c38a] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-a103c38a] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-a103c38a] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-a103c38a] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-a103c38a] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-a103c38a] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-a103c38a] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-a103c38a] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-a103c38a] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-a103c38a] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-a103c38a]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-a103c38a] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-a103c38a] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-a103c38a] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-a103c38a] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-a103c38a] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-a103c38a] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-a103c38a] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-a103c38a] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-a103c38a] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-a103c38a] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-a103c38a] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-a103c38a],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-a103c38a] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-a103c38a] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-a103c38a] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-a103c38a] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-a103c38a] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-a103c38a] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-a103c38a] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-a103c38a] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-a103c38a] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-a103c38a] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-a103c38a] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-a103c38a] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-a103c38a] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-a103c38a] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-a103c38a] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-a103c38a] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-a103c38a] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-a103c38a] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-a103c38a] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-a103c38a] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-a103c38a] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-a103c38a] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-a103c38a] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-a103c38a] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-a103c38a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-a103c38a] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-a103c38a] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-a103c38a] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-a103c38a] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-a103c38a]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-a103c38a] {\n  color: #666666;\n}\n.el-radio__inner[data-v-a103c38a]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-a103c38a] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-a103c38a] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-a103c38a] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-a103c38a] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-a103c38a] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-a103c38a] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-a103c38a] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-a103c38a] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-a103c38a],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-a103c38a]:hover,\n.el-input__icon.el-icon-circle-close[data-v-a103c38a],\n.el-input__icon.el-icon-circle-close[data-v-a103c38a]:hover {\n  color: #FB304D;\n}\n*[data-v-a103c38a],\n*[data-v-a103c38a]:before,\n*[data-v-a103c38a]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-a103c38a],\ntextarea[data-v-a103c38a] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-a103c38a]:focus {\n  outline: none;\n}\n.l-container[data-v-a103c38a] {\n  color: #333333;\n}\n.l-container .l-user-item[data-v-a103c38a] {\n  width: 100%;\n  height: 0.20202rem;\n  padding: 0 0.111111rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.l-container .l-user-item-icon[data-v-a103c38a] {\n  font-size: 0.080808rem;\n  width: 0.080808rem;\n}\n.l-container .l-user-item-text[data-v-a103c38a] {\n  margin-left: 0.040404rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.10101rem;\n  display: inline-block;\n}\n.l-container .l-user-item[data-v-a103c38a]:hover {\n  color: #0066CC;\n  cursor: pointer;\n}\n.l-container .l-user-item[data-v-a103c38a]:last-child {\n  border-bottom: none;\n}\n.selected[data-v-a103c38a] {\n  color: #0066CC;\n}", ""]);

// exports


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-a48d6594],\nbody[data-v-a48d6594] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-a48d6594]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-a48d6594] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-a48d6594] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-a48d6594] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-a48d6594],\n  .page-contain[data-v-a48d6594],\n  .page-submenu[data-v-a48d6594] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-a48d6594] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-a48d6594] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-a48d6594] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-a48d6594] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-a48d6594] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-a48d6594] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-a48d6594] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-a48d6594] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-a48d6594],\n  .page-submenu[data-v-a48d6594] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-a48d6594] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-a48d6594] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-a48d6594] {\n    width: 76.3vw;\n}\n.v-main[data-v-a48d6594] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-a48d6594] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-a48d6594] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-a48d6594] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-a48d6594] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-a48d6594] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-a48d6594] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-a48d6594],\n  .page-submenu[data-v-a48d6594] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-a48d6594] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-a48d6594] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-a48d6594] {\n    width: 76.3vw;\n}\n.v-main[data-v-a48d6594] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-a48d6594] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-a48d6594] {\n  margin-top: 0.252525rem;\n}\n[data-v-a48d6594]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-a48d6594]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-a48d6594] {\n  text-align: right;\n}\n.aligncenter[data-v-a48d6594] {\n  text-align: center;\n}\n.alignleft[data-v-a48d6594] {\n  text-align: left;\n}\n.actiongroupborder[data-v-a48d6594] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-a48d6594] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-a48d6594] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-a48d6594] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-a48d6594] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-a48d6594] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-a48d6594] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-a48d6594] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-a48d6594] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-a48d6594] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-a48d6594] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-a48d6594] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-a48d6594] {\n  text-align: center;\n}\n.alignleft[data-v-a48d6594] {\n  text-align: left;\n}\n.alignright[data-v-a48d6594] {\n  text-align: right;\n}\n.e2e-container[data-v-a48d6594] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-a48d6594] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-a48d6594] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-a48d6594] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-a48d6594] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-a48d6594] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-a48d6594] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-a48d6594] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-a48d6594] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-a48d6594] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-a48d6594] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-a48d6594],\n.e2e-red-point-left[data-v-a48d6594] {\n  position: relative;\n}\n.e2e-red-point[data-v-a48d6594]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-a48d6594]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-a48d6594] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-a48d6594] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-a48d6594] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-a48d6594] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-a48d6594] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-a48d6594] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-a48d6594] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-a48d6594] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-a48d6594] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-a48d6594] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-a48d6594] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-a48d6594] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-a48d6594] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-a48d6594]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-a48d6594] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-a48d6594] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-a48d6594],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-a48d6594] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-a48d6594],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-a48d6594] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-a48d6594],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-a48d6594] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-a48d6594],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-a48d6594] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-a48d6594],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-a48d6594] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-a48d6594],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-a48d6594] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-a48d6594] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-a48d6594] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-a48d6594] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-a48d6594] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-a48d6594] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-a48d6594] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-a48d6594] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-a48d6594] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-a48d6594]:hover,\n.el-button--primary[data-v-a48d6594]:active,\n.el-button--primary[data-v-a48d6594]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-a48d6594] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-a48d6594]:hover,\n.el-button--primary.is-plain[data-v-a48d6594]:active,\n.el-button--primary.is-plain[data-v-a48d6594]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-a48d6594] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-a48d6594]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-a48d6594]:active,\n.el-button--primary.is-plain.is-disabled[data-v-a48d6594]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-a48d6594] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-a48d6594]:hover,\n.el-button--primary.is-disabled[data-v-a48d6594]:active,\n.el-button--primary.is-disabled[data-v-a48d6594]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-a48d6594] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-a48d6594]:hover,\n.el-button--default[data-v-a48d6594]:active,\n.el-button--default[data-v-a48d6594]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-a48d6594] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-a48d6594]:hover,\n.el-button--text[data-v-a48d6594]:active,\n.el-button--text[data-v-a48d6594]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-a48d6594] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-a48d6594],\n.operate a + .el-button[data-v-a48d6594],\n.operate span + .el-button[data-v-a48d6594],\n.operate a + span[data-v-a48d6594] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-a48d6594] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-a48d6594] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-a48d6594] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-a48d6594] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-a48d6594] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-a48d6594] {\n  color: #fff;\n}\n.el-loading-mask[data-v-a48d6594] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-a48d6594] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-a48d6594]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-a48d6594]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-a48d6594]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-a48d6594]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-a48d6594] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-a48d6594] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-a48d6594] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-a48d6594] {\n  color: #999;\n}\n.el-select-dropdown[data-v-a48d6594] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-a48d6594] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-a48d6594] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-a48d6594] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-a48d6594] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-a48d6594] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-a48d6594] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-a48d6594]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-a48d6594] {\n  display: none;\n}\n.el-table th > .cell[data-v-a48d6594] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-a48d6594] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-a48d6594] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-a48d6594] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-a48d6594]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-a48d6594]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-a48d6594] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-a48d6594] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-a48d6594] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-a48d6594] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-a48d6594] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-a48d6594] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-a48d6594] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-a48d6594] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-a48d6594],\n.el-pagination .btn-next[data-v-a48d6594] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-a48d6594],\n.el-pagination .btn-next span[data-v-a48d6594] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-a48d6594] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-a48d6594] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-a48d6594] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-a48d6594] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-a48d6594] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-a48d6594] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-a48d6594] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-a48d6594] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-a48d6594] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-a48d6594] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-a48d6594] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-a48d6594] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-a48d6594] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-a48d6594] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-a48d6594] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-a48d6594] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-a48d6594] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-a48d6594] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-a48d6594] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-a48d6594] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-a48d6594] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-a48d6594] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-a48d6594] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-a48d6594] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-a48d6594] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-a48d6594] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-a48d6594] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-a48d6594] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-a48d6594] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-a48d6594]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-a48d6594] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-a48d6594] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-a48d6594] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-a48d6594] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-a48d6594] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-a48d6594] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-a48d6594] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-a48d6594] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-a48d6594] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-a48d6594] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-a48d6594] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-a48d6594],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-a48d6594] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-a48d6594] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-a48d6594] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-a48d6594] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-a48d6594] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-a48d6594] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-a48d6594] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-a48d6594] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-a48d6594] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-a48d6594] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-a48d6594] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-a48d6594] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-a48d6594] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-a48d6594] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-a48d6594] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-a48d6594] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-a48d6594] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-a48d6594] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-a48d6594] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-a48d6594] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-a48d6594] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-a48d6594] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-a48d6594] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-a48d6594] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-a48d6594] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-a48d6594] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-a48d6594] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-a48d6594] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-a48d6594] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-a48d6594]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-a48d6594] {\n  color: #666666;\n}\n.el-radio__inner[data-v-a48d6594]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-a48d6594] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-a48d6594] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-a48d6594] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-a48d6594] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-a48d6594] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-a48d6594] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-a48d6594] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-a48d6594] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-a48d6594],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-a48d6594]:hover,\n.el-input__icon.el-icon-circle-close[data-v-a48d6594],\n.el-input__icon.el-icon-circle-close[data-v-a48d6594]:hover {\n  color: #FB304D;\n}\n*[data-v-a48d6594],\n*[data-v-a48d6594]:before,\n*[data-v-a48d6594]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-a48d6594],\ntextarea[data-v-a48d6594] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-a48d6594]:focus {\n  outline: none;\n}\n.operate[data-v-a48d6594] {\n  margin-top: 0.10101rem;\n  text-align: center;\n}\n.inline-items label[data-v-a48d6594] {\n  width: 0.909091rem;\n}\n.inline-items div[data-v-a48d6594] {\n  display: inline-block;\n}", ""]);

// exports


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-acafa2c2],\nbody[data-v-acafa2c2] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-acafa2c2]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-acafa2c2] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-acafa2c2] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-acafa2c2] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-acafa2c2],\n  .page-contain[data-v-acafa2c2],\n  .page-submenu[data-v-acafa2c2] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-acafa2c2] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-acafa2c2] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-acafa2c2] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-acafa2c2] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-acafa2c2] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-acafa2c2] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-acafa2c2] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-acafa2c2] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-acafa2c2],\n  .page-submenu[data-v-acafa2c2] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-acafa2c2] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-acafa2c2] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-acafa2c2] {\n    width: 76.3vw;\n}\n.v-main[data-v-acafa2c2] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-acafa2c2] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-acafa2c2] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-acafa2c2] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-acafa2c2] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-acafa2c2] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-acafa2c2] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-acafa2c2],\n  .page-submenu[data-v-acafa2c2] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-acafa2c2] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-acafa2c2] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-acafa2c2] {\n    width: 76.3vw;\n}\n.v-main[data-v-acafa2c2] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-acafa2c2] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-acafa2c2] {\n  margin-top: 0.252525rem;\n}\n[data-v-acafa2c2]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-acafa2c2]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-acafa2c2] {\n  text-align: right;\n}\n.aligncenter[data-v-acafa2c2] {\n  text-align: center;\n}\n.alignleft[data-v-acafa2c2] {\n  text-align: left;\n}\n.actiongroupborder[data-v-acafa2c2] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-acafa2c2] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-acafa2c2] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-acafa2c2] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-acafa2c2] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-acafa2c2] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-acafa2c2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-acafa2c2] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-acafa2c2] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-acafa2c2] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-acafa2c2] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-acafa2c2] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-acafa2c2] {\n  text-align: center;\n}\n.alignleft[data-v-acafa2c2] {\n  text-align: left;\n}\n.alignright[data-v-acafa2c2] {\n  text-align: right;\n}\n.e2e-container[data-v-acafa2c2] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-acafa2c2] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-acafa2c2] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-acafa2c2] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-acafa2c2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-acafa2c2] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-acafa2c2] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-acafa2c2] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-acafa2c2] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-acafa2c2] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-acafa2c2] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-acafa2c2],\n.e2e-red-point-left[data-v-acafa2c2] {\n  position: relative;\n}\n.e2e-red-point[data-v-acafa2c2]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-acafa2c2]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-acafa2c2] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-acafa2c2] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-acafa2c2] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-acafa2c2] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-acafa2c2] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-acafa2c2] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-acafa2c2] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-acafa2c2] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-acafa2c2] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-acafa2c2] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-acafa2c2] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-acafa2c2] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-acafa2c2] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-acafa2c2]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-acafa2c2] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-acafa2c2] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-acafa2c2],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-acafa2c2] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-acafa2c2],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-acafa2c2] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-acafa2c2],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-acafa2c2] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-acafa2c2],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-acafa2c2] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-acafa2c2],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-acafa2c2] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-acafa2c2],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-acafa2c2] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-acafa2c2] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-acafa2c2] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-acafa2c2] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-acafa2c2] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-acafa2c2] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-acafa2c2] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-acafa2c2] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-acafa2c2] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-acafa2c2]:hover,\n.el-button--primary[data-v-acafa2c2]:active,\n.el-button--primary[data-v-acafa2c2]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-acafa2c2] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-acafa2c2]:hover,\n.el-button--primary.is-plain[data-v-acafa2c2]:active,\n.el-button--primary.is-plain[data-v-acafa2c2]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-acafa2c2] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-acafa2c2]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-acafa2c2]:active,\n.el-button--primary.is-plain.is-disabled[data-v-acafa2c2]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-acafa2c2] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-acafa2c2]:hover,\n.el-button--primary.is-disabled[data-v-acafa2c2]:active,\n.el-button--primary.is-disabled[data-v-acafa2c2]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-acafa2c2] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-acafa2c2]:hover,\n.el-button--default[data-v-acafa2c2]:active,\n.el-button--default[data-v-acafa2c2]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-acafa2c2] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-acafa2c2]:hover,\n.el-button--text[data-v-acafa2c2]:active,\n.el-button--text[data-v-acafa2c2]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-acafa2c2] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-acafa2c2],\n.operate a + .el-button[data-v-acafa2c2],\n.operate span + .el-button[data-v-acafa2c2],\n.operate a + span[data-v-acafa2c2] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-acafa2c2] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-acafa2c2] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-acafa2c2] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-acafa2c2] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-acafa2c2] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-acafa2c2] {\n  color: #fff;\n}\n.el-loading-mask[data-v-acafa2c2] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-acafa2c2] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-acafa2c2]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-acafa2c2]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-acafa2c2]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-acafa2c2]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-acafa2c2] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-acafa2c2] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-acafa2c2] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-acafa2c2] {\n  color: #999;\n}\n.el-select-dropdown[data-v-acafa2c2] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-acafa2c2] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-acafa2c2] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-acafa2c2] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-acafa2c2] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-acafa2c2] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-acafa2c2] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-acafa2c2]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-acafa2c2] {\n  display: none;\n}\n.el-table th > .cell[data-v-acafa2c2] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-acafa2c2] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-acafa2c2] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-acafa2c2] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-acafa2c2]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-acafa2c2]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-acafa2c2] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-acafa2c2] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-acafa2c2] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-acafa2c2] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-acafa2c2] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-acafa2c2] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-acafa2c2] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-acafa2c2] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-acafa2c2],\n.el-pagination .btn-next[data-v-acafa2c2] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-acafa2c2],\n.el-pagination .btn-next span[data-v-acafa2c2] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-acafa2c2] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-acafa2c2] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-acafa2c2] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-acafa2c2] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-acafa2c2] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-acafa2c2] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-acafa2c2] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-acafa2c2] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-acafa2c2] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-acafa2c2] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-acafa2c2] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-acafa2c2] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-acafa2c2] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-acafa2c2] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-acafa2c2] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-acafa2c2] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-acafa2c2] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-acafa2c2] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-acafa2c2] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-acafa2c2] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-acafa2c2] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-acafa2c2] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-acafa2c2] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-acafa2c2] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-acafa2c2] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-acafa2c2] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-acafa2c2] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-acafa2c2] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-acafa2c2] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-acafa2c2]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-acafa2c2] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-acafa2c2] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-acafa2c2] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-acafa2c2] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-acafa2c2] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-acafa2c2] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-acafa2c2] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-acafa2c2] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-acafa2c2] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-acafa2c2] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-acafa2c2] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-acafa2c2],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-acafa2c2] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-acafa2c2] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-acafa2c2] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-acafa2c2] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-acafa2c2] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-acafa2c2] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-acafa2c2] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-acafa2c2] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-acafa2c2] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-acafa2c2] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-acafa2c2] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-acafa2c2] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-acafa2c2] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-acafa2c2] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-acafa2c2] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-acafa2c2] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-acafa2c2] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-acafa2c2] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-acafa2c2] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-acafa2c2] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-acafa2c2] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-acafa2c2] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-acafa2c2] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-acafa2c2] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-acafa2c2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-acafa2c2] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-acafa2c2] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-acafa2c2] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-acafa2c2] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-acafa2c2]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-acafa2c2] {\n  color: #666666;\n}\n.el-radio__inner[data-v-acafa2c2]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-acafa2c2] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-acafa2c2] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-acafa2c2] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-acafa2c2] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-acafa2c2] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-acafa2c2] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-acafa2c2] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-acafa2c2] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-acafa2c2],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-acafa2c2]:hover,\n.el-input__icon.el-icon-circle-close[data-v-acafa2c2],\n.el-input__icon.el-icon-circle-close[data-v-acafa2c2]:hover {\n  color: #FB304D;\n}\n*[data-v-acafa2c2],\n*[data-v-acafa2c2]:before,\n*[data-v-acafa2c2]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-acafa2c2],\ntextarea[data-v-acafa2c2] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-acafa2c2]:focus {\n  outline: none;\n}\n.search-content[data-v-acafa2c2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 0.111111rem;\n}\n.search-content .search-content-fields[data-v-acafa2c2] {\n  width: 90%;\n}\n.operate[data-v-acafa2c2] {\n  float: right;\n  margin-bottom: 0.151515rem;\n}", ""]);

// exports


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-ad351d18],\nbody[data-v-ad351d18] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-ad351d18]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-ad351d18] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-ad351d18] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-ad351d18] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-ad351d18],\n  .page-contain[data-v-ad351d18],\n  .page-submenu[data-v-ad351d18] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-ad351d18] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-ad351d18] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-ad351d18] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-ad351d18] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-ad351d18] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-ad351d18] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-ad351d18] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-ad351d18] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-ad351d18],\n  .page-submenu[data-v-ad351d18] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-ad351d18] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-ad351d18] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-ad351d18] {\n    width: 76.3vw;\n}\n.v-main[data-v-ad351d18] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-ad351d18] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-ad351d18] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-ad351d18] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-ad351d18] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-ad351d18] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-ad351d18] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-ad351d18],\n  .page-submenu[data-v-ad351d18] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-ad351d18] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-ad351d18] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-ad351d18] {\n    width: 76.3vw;\n}\n.v-main[data-v-ad351d18] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-ad351d18] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-ad351d18] {\n  margin-top: 0.252525rem;\n}\n[data-v-ad351d18]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-ad351d18]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-ad351d18] {\n  text-align: right;\n}\n.aligncenter[data-v-ad351d18] {\n  text-align: center;\n}\n.alignleft[data-v-ad351d18] {\n  text-align: left;\n}\n.actiongroupborder[data-v-ad351d18] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-ad351d18] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-ad351d18] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-ad351d18] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-ad351d18] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-ad351d18] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-ad351d18] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-ad351d18] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-ad351d18] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-ad351d18] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-ad351d18] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-ad351d18] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-ad351d18] {\n  text-align: center;\n}\n.alignleft[data-v-ad351d18] {\n  text-align: left;\n}\n.alignright[data-v-ad351d18] {\n  text-align: right;\n}\n.e2e-container[data-v-ad351d18] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-ad351d18] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-ad351d18] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-ad351d18] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-ad351d18] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-ad351d18] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-ad351d18] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-ad351d18] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-ad351d18] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-ad351d18] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-ad351d18] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-ad351d18],\n.e2e-red-point-left[data-v-ad351d18] {\n  position: relative;\n}\n.e2e-red-point[data-v-ad351d18]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-ad351d18]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-ad351d18] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-ad351d18] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-ad351d18] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-ad351d18] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-ad351d18] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-ad351d18] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-ad351d18] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-ad351d18] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-ad351d18] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-ad351d18] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-ad351d18] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-ad351d18] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-ad351d18] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-ad351d18]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-ad351d18] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-ad351d18] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-ad351d18],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-ad351d18] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-ad351d18],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-ad351d18] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-ad351d18],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-ad351d18] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-ad351d18],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-ad351d18] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-ad351d18],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-ad351d18] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-ad351d18],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-ad351d18] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-ad351d18] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-ad351d18] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-ad351d18] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-ad351d18] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-ad351d18] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-ad351d18] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-ad351d18] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-ad351d18] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-ad351d18]:hover,\n.el-button--primary[data-v-ad351d18]:active,\n.el-button--primary[data-v-ad351d18]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-ad351d18] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-ad351d18]:hover,\n.el-button--primary.is-plain[data-v-ad351d18]:active,\n.el-button--primary.is-plain[data-v-ad351d18]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-ad351d18] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-ad351d18]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-ad351d18]:active,\n.el-button--primary.is-plain.is-disabled[data-v-ad351d18]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-ad351d18] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-ad351d18]:hover,\n.el-button--primary.is-disabled[data-v-ad351d18]:active,\n.el-button--primary.is-disabled[data-v-ad351d18]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-ad351d18] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-ad351d18]:hover,\n.el-button--default[data-v-ad351d18]:active,\n.el-button--default[data-v-ad351d18]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-ad351d18] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-ad351d18]:hover,\n.el-button--text[data-v-ad351d18]:active,\n.el-button--text[data-v-ad351d18]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-ad351d18] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-ad351d18],\n.operate a + .el-button[data-v-ad351d18],\n.operate span + .el-button[data-v-ad351d18],\n.operate a + span[data-v-ad351d18] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-ad351d18] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-ad351d18] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-ad351d18] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-ad351d18] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-ad351d18] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-ad351d18] {\n  color: #fff;\n}\n.el-loading-mask[data-v-ad351d18] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-ad351d18] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-ad351d18]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-ad351d18]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-ad351d18]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-ad351d18]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-ad351d18] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-ad351d18] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-ad351d18] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-ad351d18] {\n  color: #999;\n}\n.el-select-dropdown[data-v-ad351d18] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-ad351d18] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-ad351d18] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-ad351d18] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-ad351d18] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-ad351d18] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-ad351d18] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-ad351d18]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-ad351d18] {\n  display: none;\n}\n.el-table th > .cell[data-v-ad351d18] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-ad351d18] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-ad351d18] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-ad351d18] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-ad351d18]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-ad351d18]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-ad351d18] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-ad351d18] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-ad351d18] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-ad351d18] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-ad351d18] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-ad351d18] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-ad351d18] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-ad351d18] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-ad351d18],\n.el-pagination .btn-next[data-v-ad351d18] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-ad351d18],\n.el-pagination .btn-next span[data-v-ad351d18] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-ad351d18] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-ad351d18] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-ad351d18] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-ad351d18] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-ad351d18] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-ad351d18] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-ad351d18] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-ad351d18] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-ad351d18] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-ad351d18] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-ad351d18] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-ad351d18] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-ad351d18] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-ad351d18] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-ad351d18] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-ad351d18] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-ad351d18] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-ad351d18] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-ad351d18] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-ad351d18] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-ad351d18] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-ad351d18] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-ad351d18] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-ad351d18] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-ad351d18] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-ad351d18] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-ad351d18] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-ad351d18] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-ad351d18] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-ad351d18]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-ad351d18] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-ad351d18] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-ad351d18] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-ad351d18] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-ad351d18] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-ad351d18] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-ad351d18] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-ad351d18] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-ad351d18] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-ad351d18] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-ad351d18] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-ad351d18],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-ad351d18] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-ad351d18] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-ad351d18] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-ad351d18] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-ad351d18] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-ad351d18] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-ad351d18] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-ad351d18] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-ad351d18] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-ad351d18] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-ad351d18] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-ad351d18] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-ad351d18] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-ad351d18] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-ad351d18] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-ad351d18] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-ad351d18] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-ad351d18] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-ad351d18] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-ad351d18] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-ad351d18] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-ad351d18] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-ad351d18] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-ad351d18] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-ad351d18] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-ad351d18] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-ad351d18] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-ad351d18] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-ad351d18] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-ad351d18]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-ad351d18] {\n  color: #666666;\n}\n.el-radio__inner[data-v-ad351d18]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-ad351d18] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-ad351d18] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-ad351d18] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-ad351d18] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-ad351d18] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-ad351d18] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-ad351d18] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-ad351d18] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-ad351d18],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-ad351d18]:hover,\n.el-input__icon.el-icon-circle-close[data-v-ad351d18],\n.el-input__icon.el-icon-circle-close[data-v-ad351d18]:hover {\n  color: #FB304D;\n}\n*[data-v-ad351d18],\n*[data-v-ad351d18]:before,\n*[data-v-ad351d18]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-ad351d18],\ntextarea[data-v-ad351d18] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-ad351d18]:focus {\n  outline: none;\n}\n.e2e-amap-container[data-v-ad351d18] {\n  height: 2.525253rem;\n  width: 100%;\n  position: relative;\n  z-index: 199;\n}\n.e2e-amap-container .search-container[data-v-ad351d18] {\n  position: absolute;\n  top: 0.252525rem;\n  left: 0.252525rem;\n  width: 1.414141rem;\n  z-index: 999;\n}\n.e2e-amap-container .address-container[data-v-ad351d18] {\n  position: absolute;\n  top: 2.272727rem;\n  left: 3.030303rem;\n  width: 2.020202rem;\n  z-index: 999;\n}\n.e2e-amap-container .address-container .btn-clear[data-v-ad351d18] {\n  cursor: pointer;\n}\n.e2e-amap-container .search-result-warpper[data-v-ad351d18] {\n  width: 100%;\n  margin-top: 0.050505rem;\n  background: #ffffff;\n  border-radius: 0.020202rem;\n}\n.e2e-amap-container .search-result-warpper .search-result-container[data-v-ad351d18] {\n  overflow: auto;\n  max-height: 2.020202rem;\n}\n.e2e-amap-container .search-result-warpper .search-result-container .result-warpper[data-v-ad351d18] {\n  padding-left: 0.10101rem;\n  padding-right: 0.10101rem;\n}\n.e2e-amap-container .search-result-warpper .search-result-container .result-warpper .result-item[data-v-ad351d18] {\n  color: #0B41CD;\n  padding: 0.040404rem 0.060606rem;\n  border-bottom: 0.005051rem solid #DCDEE2;\n  cursor: pointer;\n  font-size: 0.070707rem;\n  line-height: 0.10101rem;\n}\n.e2e-amap-container .search-result-warpper .search-result-container .result-warpper[data-v-ad351d18]:hover {\n  background-color: #F2F4F8;\n}\n.e2e-amap-container .search-result-warpper .search-result-container .result-warpper:last-child .result-item[data-v-ad351d18] {\n  border-bottom: none;\n}\n.e2e-amap-container .search-result-warpper .search-result-container[data-v-ad351d18]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #F1F1F1;\n  border-radius: 0.020202rem;\n}\n.e2e-amap-container .search-result-warpper .search-result-container[data-v-ad351d18]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.020202rem;\n  width: 0.050505rem;\n}", ""]);

// exports


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-ae5c7cfe],\nbody[data-v-ae5c7cfe] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-ae5c7cfe]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-ae5c7cfe] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-ae5c7cfe] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-ae5c7cfe] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-ae5c7cfe],\n  .page-contain[data-v-ae5c7cfe],\n  .page-submenu[data-v-ae5c7cfe] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-ae5c7cfe] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-ae5c7cfe] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-ae5c7cfe] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-ae5c7cfe] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-ae5c7cfe] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-ae5c7cfe] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-ae5c7cfe] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-ae5c7cfe] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-ae5c7cfe],\n  .page-submenu[data-v-ae5c7cfe] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-ae5c7cfe] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-ae5c7cfe] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-ae5c7cfe] {\n    width: 76.3vw;\n}\n.v-main[data-v-ae5c7cfe] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-ae5c7cfe] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-ae5c7cfe] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-ae5c7cfe] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-ae5c7cfe] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-ae5c7cfe] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-ae5c7cfe] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-ae5c7cfe],\n  .page-submenu[data-v-ae5c7cfe] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-ae5c7cfe] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-ae5c7cfe] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-ae5c7cfe] {\n    width: 76.3vw;\n}\n.v-main[data-v-ae5c7cfe] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-ae5c7cfe] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-ae5c7cfe] {\n  margin-top: 0.252525rem;\n}\n[data-v-ae5c7cfe]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-ae5c7cfe]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-ae5c7cfe] {\n  text-align: right;\n}\n.aligncenter[data-v-ae5c7cfe] {\n  text-align: center;\n}\n.alignleft[data-v-ae5c7cfe] {\n  text-align: left;\n}\n.actiongroupborder[data-v-ae5c7cfe] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-ae5c7cfe] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-ae5c7cfe] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-ae5c7cfe] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-ae5c7cfe] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-ae5c7cfe] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-ae5c7cfe] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-ae5c7cfe] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-ae5c7cfe] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-ae5c7cfe] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-ae5c7cfe] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-ae5c7cfe] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-ae5c7cfe] {\n  text-align: center;\n}\n.alignleft[data-v-ae5c7cfe] {\n  text-align: left;\n}\n.alignright[data-v-ae5c7cfe] {\n  text-align: right;\n}\n.e2e-container[data-v-ae5c7cfe] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-ae5c7cfe] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-ae5c7cfe] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-ae5c7cfe] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-ae5c7cfe] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-ae5c7cfe] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-ae5c7cfe] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-ae5c7cfe] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-ae5c7cfe] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-ae5c7cfe] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-ae5c7cfe] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-ae5c7cfe],\n.e2e-red-point-left[data-v-ae5c7cfe] {\n  position: relative;\n}\n.e2e-red-point[data-v-ae5c7cfe]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-ae5c7cfe]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-ae5c7cfe] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-ae5c7cfe] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-ae5c7cfe] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-ae5c7cfe] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-ae5c7cfe] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-ae5c7cfe] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-ae5c7cfe] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-ae5c7cfe] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-ae5c7cfe] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-ae5c7cfe] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-ae5c7cfe] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-ae5c7cfe] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-ae5c7cfe] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-ae5c7cfe]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-ae5c7cfe] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-ae5c7cfe] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-ae5c7cfe],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-ae5c7cfe] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-ae5c7cfe],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-ae5c7cfe] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-ae5c7cfe],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-ae5c7cfe] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-ae5c7cfe],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-ae5c7cfe] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-ae5c7cfe],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-ae5c7cfe] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-ae5c7cfe],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-ae5c7cfe] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-ae5c7cfe] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-ae5c7cfe] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-ae5c7cfe] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-ae5c7cfe] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-ae5c7cfe] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-ae5c7cfe] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-ae5c7cfe] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-ae5c7cfe] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-ae5c7cfe]:hover,\n.el-button--primary[data-v-ae5c7cfe]:active,\n.el-button--primary[data-v-ae5c7cfe]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-ae5c7cfe] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-ae5c7cfe]:hover,\n.el-button--primary.is-plain[data-v-ae5c7cfe]:active,\n.el-button--primary.is-plain[data-v-ae5c7cfe]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-ae5c7cfe] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-ae5c7cfe]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-ae5c7cfe]:active,\n.el-button--primary.is-plain.is-disabled[data-v-ae5c7cfe]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-ae5c7cfe] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-ae5c7cfe]:hover,\n.el-button--primary.is-disabled[data-v-ae5c7cfe]:active,\n.el-button--primary.is-disabled[data-v-ae5c7cfe]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-ae5c7cfe] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-ae5c7cfe]:hover,\n.el-button--default[data-v-ae5c7cfe]:active,\n.el-button--default[data-v-ae5c7cfe]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-ae5c7cfe] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-ae5c7cfe]:hover,\n.el-button--text[data-v-ae5c7cfe]:active,\n.el-button--text[data-v-ae5c7cfe]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-ae5c7cfe] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-ae5c7cfe],\n.operate a + .el-button[data-v-ae5c7cfe],\n.operate span + .el-button[data-v-ae5c7cfe],\n.operate a + span[data-v-ae5c7cfe] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-ae5c7cfe] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-ae5c7cfe] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-ae5c7cfe] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-ae5c7cfe] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-ae5c7cfe] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-ae5c7cfe] {\n  color: #fff;\n}\n.el-loading-mask[data-v-ae5c7cfe] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-ae5c7cfe] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-ae5c7cfe]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-ae5c7cfe]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-ae5c7cfe]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-ae5c7cfe]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-ae5c7cfe] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-ae5c7cfe] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-ae5c7cfe] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-ae5c7cfe] {\n  color: #999;\n}\n.el-select-dropdown[data-v-ae5c7cfe] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-ae5c7cfe] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-ae5c7cfe] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-ae5c7cfe] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-ae5c7cfe] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-ae5c7cfe] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-ae5c7cfe] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-ae5c7cfe]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-ae5c7cfe] {\n  display: none;\n}\n.el-table th > .cell[data-v-ae5c7cfe] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-ae5c7cfe] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-ae5c7cfe] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-ae5c7cfe] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-ae5c7cfe]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-ae5c7cfe]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-ae5c7cfe] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-ae5c7cfe] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-ae5c7cfe] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-ae5c7cfe] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-ae5c7cfe] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-ae5c7cfe] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-ae5c7cfe] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-ae5c7cfe] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-ae5c7cfe],\n.el-pagination .btn-next[data-v-ae5c7cfe] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-ae5c7cfe],\n.el-pagination .btn-next span[data-v-ae5c7cfe] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-ae5c7cfe] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-ae5c7cfe] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-ae5c7cfe] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-ae5c7cfe] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-ae5c7cfe] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-ae5c7cfe] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-ae5c7cfe] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-ae5c7cfe] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-ae5c7cfe] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-ae5c7cfe] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-ae5c7cfe] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-ae5c7cfe] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-ae5c7cfe] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-ae5c7cfe] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-ae5c7cfe] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-ae5c7cfe] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-ae5c7cfe] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-ae5c7cfe] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-ae5c7cfe] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-ae5c7cfe] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-ae5c7cfe] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-ae5c7cfe] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-ae5c7cfe] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-ae5c7cfe] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-ae5c7cfe] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-ae5c7cfe] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-ae5c7cfe] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-ae5c7cfe] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-ae5c7cfe] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-ae5c7cfe]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-ae5c7cfe] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-ae5c7cfe] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-ae5c7cfe] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-ae5c7cfe] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-ae5c7cfe] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-ae5c7cfe] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-ae5c7cfe] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-ae5c7cfe] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-ae5c7cfe] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-ae5c7cfe] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-ae5c7cfe] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-ae5c7cfe],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-ae5c7cfe] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-ae5c7cfe] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-ae5c7cfe] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-ae5c7cfe] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-ae5c7cfe] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-ae5c7cfe] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-ae5c7cfe] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-ae5c7cfe] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-ae5c7cfe] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-ae5c7cfe] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-ae5c7cfe] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-ae5c7cfe] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-ae5c7cfe] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-ae5c7cfe] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-ae5c7cfe] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-ae5c7cfe] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-ae5c7cfe] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-ae5c7cfe] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-ae5c7cfe] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-ae5c7cfe] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-ae5c7cfe] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-ae5c7cfe] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-ae5c7cfe] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-ae5c7cfe] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-ae5c7cfe] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-ae5c7cfe] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-ae5c7cfe] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-ae5c7cfe] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-ae5c7cfe] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-ae5c7cfe]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-ae5c7cfe] {\n  color: #666666;\n}\n.el-radio__inner[data-v-ae5c7cfe]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-ae5c7cfe] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-ae5c7cfe] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-ae5c7cfe] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-ae5c7cfe] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-ae5c7cfe] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-ae5c7cfe] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-ae5c7cfe] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-ae5c7cfe] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-ae5c7cfe],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-ae5c7cfe]:hover,\n.el-input__icon.el-icon-circle-close[data-v-ae5c7cfe],\n.el-input__icon.el-icon-circle-close[data-v-ae5c7cfe]:hover {\n  color: #FB304D;\n}\n*[data-v-ae5c7cfe],\n*[data-v-ae5c7cfe]:before,\n*[data-v-ae5c7cfe]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-ae5c7cfe],\ntextarea[data-v-ae5c7cfe] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-ae5c7cfe]:focus {\n  outline: none;\n}\n.c-e2e-not-found[data-v-ae5c7cfe] {\n  width: 100%;\n  position: relative;\n  z-index: 2;\n}\n.c-e2e-not-found .e2e-not-found-container[data-v-ae5c7cfe] {\n  padding: 0.10101rem;\n  text-align: center;\n}", ""]);

// exports


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-b41f7a44],\nbody[data-v-b41f7a44] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-b41f7a44]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-b41f7a44] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-b41f7a44] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-b41f7a44] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-b41f7a44],\n  .page-contain[data-v-b41f7a44],\n  .page-submenu[data-v-b41f7a44] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-b41f7a44] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-b41f7a44] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-b41f7a44] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-b41f7a44] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-b41f7a44] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-b41f7a44] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-b41f7a44] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-b41f7a44] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-b41f7a44],\n  .page-submenu[data-v-b41f7a44] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-b41f7a44] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-b41f7a44] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-b41f7a44] {\n    width: 76.3vw;\n}\n.v-main[data-v-b41f7a44] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-b41f7a44] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-b41f7a44] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-b41f7a44] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-b41f7a44] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-b41f7a44] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-b41f7a44] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-b41f7a44],\n  .page-submenu[data-v-b41f7a44] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-b41f7a44] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-b41f7a44] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-b41f7a44] {\n    width: 76.3vw;\n}\n.v-main[data-v-b41f7a44] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-b41f7a44] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-b41f7a44] {\n  margin-top: 0.252525rem;\n}\n[data-v-b41f7a44]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-b41f7a44]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-b41f7a44] {\n  text-align: right;\n}\n.aligncenter[data-v-b41f7a44] {\n  text-align: center;\n}\n.alignleft[data-v-b41f7a44] {\n  text-align: left;\n}\n.actiongroupborder[data-v-b41f7a44] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-b41f7a44] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-b41f7a44] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-b41f7a44] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-b41f7a44] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-b41f7a44] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-b41f7a44] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-b41f7a44] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-b41f7a44] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-b41f7a44] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-b41f7a44] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-b41f7a44] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-b41f7a44] {\n  text-align: center;\n}\n.alignleft[data-v-b41f7a44] {\n  text-align: left;\n}\n.alignright[data-v-b41f7a44] {\n  text-align: right;\n}\n.e2e-container[data-v-b41f7a44] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-b41f7a44] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-b41f7a44] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-b41f7a44] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-b41f7a44] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-b41f7a44] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-b41f7a44] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-b41f7a44] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-b41f7a44] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-b41f7a44] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-b41f7a44] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-b41f7a44],\n.e2e-red-point-left[data-v-b41f7a44] {\n  position: relative;\n}\n.e2e-red-point[data-v-b41f7a44]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-b41f7a44]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-b41f7a44] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-b41f7a44] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-b41f7a44] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-b41f7a44] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-b41f7a44] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-b41f7a44] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-b41f7a44] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-b41f7a44] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-b41f7a44] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-b41f7a44] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-b41f7a44] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-b41f7a44] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-b41f7a44] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-b41f7a44]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-b41f7a44] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-b41f7a44] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-b41f7a44],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-b41f7a44] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-b41f7a44],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-b41f7a44] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-b41f7a44],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-b41f7a44] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-b41f7a44],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-b41f7a44] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-b41f7a44],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-b41f7a44] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-b41f7a44],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-b41f7a44] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-b41f7a44] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-b41f7a44] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-b41f7a44] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-b41f7a44] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-b41f7a44] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-b41f7a44] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-b41f7a44] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-b41f7a44] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-b41f7a44]:hover,\n.el-button--primary[data-v-b41f7a44]:active,\n.el-button--primary[data-v-b41f7a44]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-b41f7a44] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-b41f7a44]:hover,\n.el-button--primary.is-plain[data-v-b41f7a44]:active,\n.el-button--primary.is-plain[data-v-b41f7a44]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-b41f7a44] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-b41f7a44]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-b41f7a44]:active,\n.el-button--primary.is-plain.is-disabled[data-v-b41f7a44]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-b41f7a44] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-b41f7a44]:hover,\n.el-button--primary.is-disabled[data-v-b41f7a44]:active,\n.el-button--primary.is-disabled[data-v-b41f7a44]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-b41f7a44] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-b41f7a44]:hover,\n.el-button--default[data-v-b41f7a44]:active,\n.el-button--default[data-v-b41f7a44]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-b41f7a44] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-b41f7a44]:hover,\n.el-button--text[data-v-b41f7a44]:active,\n.el-button--text[data-v-b41f7a44]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-b41f7a44] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-b41f7a44],\n.operate a + .el-button[data-v-b41f7a44],\n.operate span + .el-button[data-v-b41f7a44],\n.operate a + span[data-v-b41f7a44] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-b41f7a44] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-b41f7a44] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-b41f7a44] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-b41f7a44] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-b41f7a44] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-b41f7a44] {\n  color: #fff;\n}\n.el-loading-mask[data-v-b41f7a44] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-b41f7a44] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-b41f7a44]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-b41f7a44]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-b41f7a44]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-b41f7a44]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-b41f7a44] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-b41f7a44] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-b41f7a44] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-b41f7a44] {\n  color: #999;\n}\n.el-select-dropdown[data-v-b41f7a44] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-b41f7a44] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-b41f7a44] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-b41f7a44] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-b41f7a44] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-b41f7a44] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-b41f7a44] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-b41f7a44]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-b41f7a44] {\n  display: none;\n}\n.el-table th > .cell[data-v-b41f7a44] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-b41f7a44] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-b41f7a44] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-b41f7a44] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-b41f7a44]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-b41f7a44]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-b41f7a44] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-b41f7a44] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-b41f7a44] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-b41f7a44] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-b41f7a44] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-b41f7a44] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-b41f7a44] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-b41f7a44] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-b41f7a44],\n.el-pagination .btn-next[data-v-b41f7a44] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-b41f7a44],\n.el-pagination .btn-next span[data-v-b41f7a44] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-b41f7a44] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-b41f7a44] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-b41f7a44] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-b41f7a44] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-b41f7a44] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-b41f7a44] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-b41f7a44] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-b41f7a44] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-b41f7a44] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-b41f7a44] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-b41f7a44] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-b41f7a44] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-b41f7a44] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-b41f7a44] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-b41f7a44] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-b41f7a44] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-b41f7a44] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-b41f7a44] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-b41f7a44] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-b41f7a44] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-b41f7a44] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-b41f7a44] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-b41f7a44] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-b41f7a44] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-b41f7a44] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-b41f7a44] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-b41f7a44] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-b41f7a44] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-b41f7a44] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-b41f7a44]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-b41f7a44] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-b41f7a44] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-b41f7a44] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-b41f7a44] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-b41f7a44] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-b41f7a44] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-b41f7a44] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-b41f7a44] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-b41f7a44] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-b41f7a44] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-b41f7a44] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-b41f7a44],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-b41f7a44] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-b41f7a44] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-b41f7a44] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-b41f7a44] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-b41f7a44] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-b41f7a44] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-b41f7a44] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-b41f7a44] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-b41f7a44] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-b41f7a44] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-b41f7a44] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-b41f7a44] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-b41f7a44] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-b41f7a44] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-b41f7a44] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-b41f7a44] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-b41f7a44] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-b41f7a44] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-b41f7a44] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-b41f7a44] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-b41f7a44] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-b41f7a44] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-b41f7a44] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-b41f7a44] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-b41f7a44] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-b41f7a44] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-b41f7a44] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-b41f7a44] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-b41f7a44] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-b41f7a44]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-b41f7a44] {\n  color: #666666;\n}\n.el-radio__inner[data-v-b41f7a44]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-b41f7a44] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-b41f7a44] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-b41f7a44] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-b41f7a44] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-b41f7a44] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-b41f7a44] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-b41f7a44] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-b41f7a44] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-b41f7a44],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-b41f7a44]:hover,\n.el-input__icon.el-icon-circle-close[data-v-b41f7a44],\n.el-input__icon.el-icon-circle-close[data-v-b41f7a44]:hover {\n  color: #FB304D;\n}\n*[data-v-b41f7a44],\n*[data-v-b41f7a44]:before,\n*[data-v-b41f7a44]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-b41f7a44],\ntextarea[data-v-b41f7a44] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-b41f7a44]:focus {\n  outline: none;\n}", ""]);

// exports


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-b4e872ae],\nbody[data-v-b4e872ae] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-b4e872ae]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-b4e872ae] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-b4e872ae] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-b4e872ae] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-b4e872ae],\n  .page-contain[data-v-b4e872ae],\n  .page-submenu[data-v-b4e872ae] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-b4e872ae] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-b4e872ae] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-b4e872ae] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-b4e872ae] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-b4e872ae] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-b4e872ae] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-b4e872ae] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-b4e872ae] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-b4e872ae],\n  .page-submenu[data-v-b4e872ae] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-b4e872ae] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-b4e872ae] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-b4e872ae] {\n    width: 76.3vw;\n}\n.v-main[data-v-b4e872ae] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-b4e872ae] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-b4e872ae] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-b4e872ae] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-b4e872ae] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-b4e872ae] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-b4e872ae] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-b4e872ae],\n  .page-submenu[data-v-b4e872ae] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-b4e872ae] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-b4e872ae] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-b4e872ae] {\n    width: 76.3vw;\n}\n.v-main[data-v-b4e872ae] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-b4e872ae] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-b4e872ae] {\n  margin-top: 0.252525rem;\n}\n[data-v-b4e872ae]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-b4e872ae]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-b4e872ae] {\n  text-align: right;\n}\n.aligncenter[data-v-b4e872ae] {\n  text-align: center;\n}\n.alignleft[data-v-b4e872ae] {\n  text-align: left;\n}\n.actiongroupborder[data-v-b4e872ae] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-b4e872ae] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-b4e872ae] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-b4e872ae] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-b4e872ae] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-b4e872ae] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-b4e872ae] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-b4e872ae] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-b4e872ae] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-b4e872ae] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-b4e872ae] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-b4e872ae] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-b4e872ae] {\n  text-align: center;\n}\n.alignleft[data-v-b4e872ae] {\n  text-align: left;\n}\n.alignright[data-v-b4e872ae] {\n  text-align: right;\n}\n.e2e-container[data-v-b4e872ae] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-b4e872ae] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-b4e872ae] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-b4e872ae] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-b4e872ae] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-b4e872ae] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-b4e872ae] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-b4e872ae] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-b4e872ae] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-b4e872ae] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-b4e872ae] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-b4e872ae],\n.e2e-red-point-left[data-v-b4e872ae] {\n  position: relative;\n}\n.e2e-red-point[data-v-b4e872ae]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-b4e872ae]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-b4e872ae] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-b4e872ae] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-b4e872ae] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-b4e872ae] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-b4e872ae] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-b4e872ae] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-b4e872ae] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-b4e872ae] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-b4e872ae] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-b4e872ae] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-b4e872ae] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-b4e872ae] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-b4e872ae] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-b4e872ae]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-b4e872ae] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-b4e872ae] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-b4e872ae],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-b4e872ae] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-b4e872ae],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-b4e872ae] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-b4e872ae],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-b4e872ae] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-b4e872ae],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-b4e872ae] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-b4e872ae],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-b4e872ae] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-b4e872ae],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-b4e872ae] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-b4e872ae] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-b4e872ae] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-b4e872ae] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-b4e872ae] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-b4e872ae] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-b4e872ae] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-b4e872ae] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-b4e872ae] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-b4e872ae]:hover,\n.el-button--primary[data-v-b4e872ae]:active,\n.el-button--primary[data-v-b4e872ae]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-b4e872ae] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-b4e872ae]:hover,\n.el-button--primary.is-plain[data-v-b4e872ae]:active,\n.el-button--primary.is-plain[data-v-b4e872ae]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-b4e872ae] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-b4e872ae]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-b4e872ae]:active,\n.el-button--primary.is-plain.is-disabled[data-v-b4e872ae]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-b4e872ae] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-b4e872ae]:hover,\n.el-button--primary.is-disabled[data-v-b4e872ae]:active,\n.el-button--primary.is-disabled[data-v-b4e872ae]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-b4e872ae] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-b4e872ae]:hover,\n.el-button--default[data-v-b4e872ae]:active,\n.el-button--default[data-v-b4e872ae]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-b4e872ae] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-b4e872ae]:hover,\n.el-button--text[data-v-b4e872ae]:active,\n.el-button--text[data-v-b4e872ae]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-b4e872ae] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-b4e872ae],\n.operate a + .el-button[data-v-b4e872ae],\n.operate span + .el-button[data-v-b4e872ae],\n.operate a + span[data-v-b4e872ae] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-b4e872ae] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-b4e872ae] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-b4e872ae] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-b4e872ae] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-b4e872ae] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-b4e872ae] {\n  color: #fff;\n}\n.el-loading-mask[data-v-b4e872ae] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-b4e872ae] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-b4e872ae]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-b4e872ae]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-b4e872ae]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-b4e872ae]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-b4e872ae] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-b4e872ae] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-b4e872ae] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-b4e872ae] {\n  color: #999;\n}\n.el-select-dropdown[data-v-b4e872ae] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-b4e872ae] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-b4e872ae] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-b4e872ae] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-b4e872ae] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-b4e872ae] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-b4e872ae] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-b4e872ae]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-b4e872ae] {\n  display: none;\n}\n.el-table th > .cell[data-v-b4e872ae] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-b4e872ae] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-b4e872ae] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-b4e872ae] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-b4e872ae]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-b4e872ae]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-b4e872ae] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-b4e872ae] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-b4e872ae] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-b4e872ae] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-b4e872ae] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-b4e872ae] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-b4e872ae] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-b4e872ae] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-b4e872ae],\n.el-pagination .btn-next[data-v-b4e872ae] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-b4e872ae],\n.el-pagination .btn-next span[data-v-b4e872ae] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-b4e872ae] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-b4e872ae] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-b4e872ae] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-b4e872ae] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-b4e872ae] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-b4e872ae] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-b4e872ae] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-b4e872ae] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-b4e872ae] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-b4e872ae] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-b4e872ae] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-b4e872ae] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-b4e872ae] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-b4e872ae] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-b4e872ae] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-b4e872ae] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-b4e872ae] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-b4e872ae] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-b4e872ae] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-b4e872ae] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-b4e872ae] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-b4e872ae] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-b4e872ae] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-b4e872ae] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-b4e872ae] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-b4e872ae] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-b4e872ae] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-b4e872ae] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-b4e872ae] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-b4e872ae]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-b4e872ae] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-b4e872ae] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-b4e872ae] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-b4e872ae] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-b4e872ae] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-b4e872ae] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-b4e872ae] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-b4e872ae] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-b4e872ae] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-b4e872ae] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-b4e872ae] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-b4e872ae],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-b4e872ae] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-b4e872ae] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-b4e872ae] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-b4e872ae] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-b4e872ae] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-b4e872ae] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-b4e872ae] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-b4e872ae] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-b4e872ae] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-b4e872ae] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-b4e872ae] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-b4e872ae] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-b4e872ae] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-b4e872ae] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-b4e872ae] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-b4e872ae] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-b4e872ae] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-b4e872ae] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-b4e872ae] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-b4e872ae] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-b4e872ae] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-b4e872ae] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-b4e872ae] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-b4e872ae] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-b4e872ae] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-b4e872ae] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-b4e872ae] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-b4e872ae] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-b4e872ae] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-b4e872ae]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-b4e872ae] {\n  color: #666666;\n}\n.el-radio__inner[data-v-b4e872ae]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-b4e872ae] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-b4e872ae] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-b4e872ae] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-b4e872ae] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-b4e872ae] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-b4e872ae] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-b4e872ae] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-b4e872ae] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-b4e872ae],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-b4e872ae]:hover,\n.el-input__icon.el-icon-circle-close[data-v-b4e872ae],\n.el-input__icon.el-icon-circle-close[data-v-b4e872ae]:hover {\n  color: #FB304D;\n}\n*[data-v-b4e872ae],\n*[data-v-b4e872ae]:before,\n*[data-v-b4e872ae]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-b4e872ae],\ntextarea[data-v-b4e872ae] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-b4e872ae]:focus {\n  outline: none;\n}\n.page-contain .page-contain-tab[data-v-b4e872ae] {\n  padding: 0 0.282828rem 0.161616rem 0.282828rem;\n  margin-bottom: 0.121212rem;\n}\n.page-contain .page-contain-tab .recipientSocietyOrHospital-text span[data-v-b4e872ae] {\n  color: #0B41CD;\n}\n.page-contain .page-contain-tab .recipientSociety-input[data-v-b4e872ae] {\n  font-size: 0.070707rem;\n  margin-left: 0.050505rem;\n  padding-top: 0.040404rem !important;\n}\n.page-contain .page-contain-tab .more-tab[data-v-b4e872ae] {\n  background: #F6F6F6;\n  border-radius: 0.010101rem;\n  width: 3.959596rem;\n  margin-top: 0.040404rem !important;\n  margin-left: -0.080808rem !important;\n  padding-left: 0.080808rem !important;\n  padding-top: 0.080808rem !important;\n  padding-bottom: 0.060606rem !important;\n}\n.page-contain .page-contain-tab .more-tab-div[data-v-b4e872ae] {\n  margin-top: 0.080808rem;\n}\n.page-contain .approval-workflow[data-v-b4e872ae] {\n  width: auto !important;\n}\n.page-contain .approval-workflow-title[data-v-b4e872ae] {\n  font-size: 0.070707rem;\n  margin-left: 0.050505rem;\n  padding-top: 0.121212rem;\n}\n.page-contain .approval-workflow-title div[data-v-b4e872ae] {\n  border-top: 0.005051rem solid #E8E8E8;\n  margin: 0.121212rem -0.282828rem 0 -0.333333rem;\n}\n.page-contain .approval-status[data-v-b4e872ae] {\n  margin-left: 0.10101rem;\n  padding: 0.025253rem;\n  border-radius: 0.010101rem;\n  height: 0.111111rem;\n  font-size: 0.060606rem;\n}\n.page-contain .approval-padding[data-v-b4e872ae] {\n  border: 0.005051rem solid #FFDA95;\n  background-color: #FFF8EA;\n  color: #FFB52A;\n}\n.page-contain .approval-comfirm[data-v-b4e872ae] {\n  border: 0.005051rem solid #8BE9BE;\n  background-color: #EDFFF6;\n  color: #0EC771;\n}\n.page-contain .approval-reject[data-v-b4e872ae] {\n  border: 0.005051rem solid #FF9CAA;\n  background-color: #FFEFF1;\n  color: #FB304D;\n}\n.page-contain .approval-cancle[data-v-b4e872ae] {\n  border: 0.005051rem solid #D6D6D6;\n  background-color: #F6F6F6;\n  color: #666666;\n}\n.page-contain .approval-submit[data-v-b4e872ae] {\n  border: 0.005051rem solid #A2CBFF;\n  background-color: #EBF4FF;\n  color: #2D82F0;\n}\n.bottom-info[data-v-b4e872ae] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: fixed;\n  background-color: #fff;\n  width: 100%;\n  left: 0;\n  height: 0.222222rem;\n  -webkit-box-shadow: -0.005051rem 0 0.020202rem 0 rgba(51, 51, 51, 0.35);\n          box-shadow: -0.005051rem 0 0.020202rem 0 rgba(51, 51, 51, 0.35);\n  bottom: 0;\n}\n.bottom-info-info[data-v-b4e872ae] {\n  margin-left: 0.606061rem;\n  line-height: 0.222222rem;\n}\n.bottom-info-operate[data-v-b4e872ae] {\n  position: absolute;\n  right: 0.606061rem;\n  line-height: 0.232323rem;\n}\n.col-add-remove[data-v-b4e872ae] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.operate-add-remove[data-v-b4e872ae] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 0.10101rem;\n  margin: 0.191919rem 0 0 0.050505rem;\n}\n.operate-add-remove span[data-v-b4e872ae] {\n  cursor: pointer;\n}\n.operate-add-remove span + span[data-v-b4e872ae] {\n  margin-left: 0.050505rem;\n}\n.view-meeting-plan[data-v-b4e872ae] {\n  padding: 0;\n  margin-bottom: 0.429293rem;\n}\n.view-meeting-plan .edit-form-title[data-v-b4e872ae] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row[data-v-b4e872ae] {\n  padding: 0.121212rem 0 0 0;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full[data-v-b4e872ae] {\n  width: 5.494949rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-input__inner[data-v-b4e872ae] {\n  width: 5.494949rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-textarea__inner[data-v-b4e872ae] {\n  height: 0.555556rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-form-item__label[data-v-b4e872ae] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-form-item__content[data-v-b4e872ae] {\n  padding-top: 0.010101rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-form-item__content label[data-v-b4e872ae] {\n  margin-left: 0.050505rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col[data-v-b4e872ae] {\n  width: 1.616162rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-b4e872ae] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-b4e872ae] {\n  padding-top: 0.010101rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-b4e872ae],\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-b4e872ae] {\n  width: 1.616162rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__content label[data-v-b4e872ae] {\n  margin-left: 0.050505rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-b4e872ae] {\n  margin-left: 0.323232rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .col-no-3[data-v-b4e872ae] {\n  margin-left: 3.878788rem;\n}\n.view-meeting-plan .el-form.el-form--label-right .el-row[data-v-b4e872ae] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.cancle-alert-info[data-v-b4e872ae] {\n  margin-top: 0.030303rem;\n}", ""]);

// exports


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-be6888bc],\nbody[data-v-be6888bc] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-be6888bc]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-be6888bc] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-be6888bc] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-be6888bc] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-be6888bc],\n  .page-contain[data-v-be6888bc],\n  .page-submenu[data-v-be6888bc] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-be6888bc] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-be6888bc] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-be6888bc] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-be6888bc] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-be6888bc] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-be6888bc] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-be6888bc] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-be6888bc] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-be6888bc],\n  .page-submenu[data-v-be6888bc] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-be6888bc] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-be6888bc] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-be6888bc] {\n    width: 76.3vw;\n}\n.v-main[data-v-be6888bc] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-be6888bc] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-be6888bc] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-be6888bc] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-be6888bc] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-be6888bc] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-be6888bc] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-be6888bc],\n  .page-submenu[data-v-be6888bc] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-be6888bc] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-be6888bc] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-be6888bc] {\n    width: 76.3vw;\n}\n.v-main[data-v-be6888bc] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-be6888bc] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-be6888bc] {\n  margin-top: 0.252525rem;\n}\n[data-v-be6888bc]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-be6888bc]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-be6888bc] {\n  text-align: right;\n}\n.aligncenter[data-v-be6888bc] {\n  text-align: center;\n}\n.alignleft[data-v-be6888bc] {\n  text-align: left;\n}\n.actiongroupborder[data-v-be6888bc] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-be6888bc] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-be6888bc] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-be6888bc] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-be6888bc] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-be6888bc] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-be6888bc] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-be6888bc] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-be6888bc] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-be6888bc] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-be6888bc] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-be6888bc] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-be6888bc] {\n  text-align: center;\n}\n.alignleft[data-v-be6888bc] {\n  text-align: left;\n}\n.alignright[data-v-be6888bc] {\n  text-align: right;\n}\n.e2e-container[data-v-be6888bc] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-be6888bc] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-be6888bc] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-be6888bc] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-be6888bc] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-be6888bc] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-be6888bc] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-be6888bc] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-be6888bc] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-be6888bc] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-be6888bc] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-be6888bc],\n.e2e-red-point-left[data-v-be6888bc] {\n  position: relative;\n}\n.e2e-red-point[data-v-be6888bc]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-be6888bc]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-be6888bc] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-be6888bc] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-be6888bc] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-be6888bc] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-be6888bc] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-be6888bc] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-be6888bc] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-be6888bc] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-be6888bc] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-be6888bc] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-be6888bc] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-be6888bc] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-be6888bc] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-be6888bc]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-be6888bc] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-be6888bc] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-be6888bc],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-be6888bc] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-be6888bc],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-be6888bc] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-be6888bc],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-be6888bc] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-be6888bc],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-be6888bc] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-be6888bc],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-be6888bc] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-be6888bc],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-be6888bc] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-be6888bc] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-be6888bc] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-be6888bc] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-be6888bc] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-be6888bc] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-be6888bc] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-be6888bc] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-be6888bc] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-be6888bc]:hover,\n.el-button--primary[data-v-be6888bc]:active,\n.el-button--primary[data-v-be6888bc]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-be6888bc] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-be6888bc]:hover,\n.el-button--primary.is-plain[data-v-be6888bc]:active,\n.el-button--primary.is-plain[data-v-be6888bc]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-be6888bc] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-be6888bc]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-be6888bc]:active,\n.el-button--primary.is-plain.is-disabled[data-v-be6888bc]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-be6888bc] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-be6888bc]:hover,\n.el-button--primary.is-disabled[data-v-be6888bc]:active,\n.el-button--primary.is-disabled[data-v-be6888bc]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-be6888bc] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-be6888bc]:hover,\n.el-button--default[data-v-be6888bc]:active,\n.el-button--default[data-v-be6888bc]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-be6888bc] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-be6888bc]:hover,\n.el-button--text[data-v-be6888bc]:active,\n.el-button--text[data-v-be6888bc]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-be6888bc] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-be6888bc],\n.operate a + .el-button[data-v-be6888bc],\n.operate span + .el-button[data-v-be6888bc],\n.operate a + span[data-v-be6888bc] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-be6888bc] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-be6888bc] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-be6888bc] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-be6888bc] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-be6888bc] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-be6888bc] {\n  color: #fff;\n}\n.el-loading-mask[data-v-be6888bc] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-be6888bc] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-be6888bc]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-be6888bc]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-be6888bc]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-be6888bc]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-be6888bc] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-be6888bc] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-be6888bc] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-be6888bc] {\n  color: #999;\n}\n.el-select-dropdown[data-v-be6888bc] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-be6888bc] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-be6888bc] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-be6888bc] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-be6888bc] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-be6888bc] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-be6888bc] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-be6888bc]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-be6888bc] {\n  display: none;\n}\n.el-table th > .cell[data-v-be6888bc] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-be6888bc] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-be6888bc] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-be6888bc] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-be6888bc]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-be6888bc]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-be6888bc] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-be6888bc] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-be6888bc] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-be6888bc] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-be6888bc] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-be6888bc] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-be6888bc] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-be6888bc] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-be6888bc],\n.el-pagination .btn-next[data-v-be6888bc] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-be6888bc],\n.el-pagination .btn-next span[data-v-be6888bc] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-be6888bc] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-be6888bc] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-be6888bc] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-be6888bc] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-be6888bc] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-be6888bc] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-be6888bc] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-be6888bc] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-be6888bc] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-be6888bc] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-be6888bc] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-be6888bc] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-be6888bc] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-be6888bc] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-be6888bc] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-be6888bc] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-be6888bc] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-be6888bc] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-be6888bc] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-be6888bc] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-be6888bc] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-be6888bc] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-be6888bc] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-be6888bc] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-be6888bc] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-be6888bc] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-be6888bc] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-be6888bc] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-be6888bc] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-be6888bc]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-be6888bc] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-be6888bc] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-be6888bc] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-be6888bc] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-be6888bc] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-be6888bc] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-be6888bc] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-be6888bc] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-be6888bc] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-be6888bc] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-be6888bc] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-be6888bc],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-be6888bc] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-be6888bc] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-be6888bc] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-be6888bc] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-be6888bc] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-be6888bc] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-be6888bc] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-be6888bc] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-be6888bc] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-be6888bc] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-be6888bc] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-be6888bc] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-be6888bc] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-be6888bc] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-be6888bc] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-be6888bc] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-be6888bc] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-be6888bc] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-be6888bc] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-be6888bc] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-be6888bc] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-be6888bc] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-be6888bc] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-be6888bc] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-be6888bc] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-be6888bc] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-be6888bc] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-be6888bc] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-be6888bc] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-be6888bc]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-be6888bc] {\n  color: #666666;\n}\n.el-radio__inner[data-v-be6888bc]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-be6888bc] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-be6888bc] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-be6888bc] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-be6888bc] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-be6888bc] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-be6888bc] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-be6888bc] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-be6888bc] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-be6888bc],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-be6888bc]:hover,\n.el-input__icon.el-icon-circle-close[data-v-be6888bc],\n.el-input__icon.el-icon-circle-close[data-v-be6888bc]:hover {\n  color: #FB304D;\n}\n*[data-v-be6888bc],\n*[data-v-be6888bc]:before,\n*[data-v-be6888bc]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-be6888bc],\ntextarea[data-v-be6888bc] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-be6888bc]:focus {\n  outline: none;\n}", ""]);

// exports


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml,\nbody {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.v-main,\n  .page-contain,\n  .page-submenu {\n    width: 6.060606rem;\n}\n.page-submenu_left {\n    width: 1.313131rem;\n}\n.page-submenu_right {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n.has-header {\n  margin-top: 0.252525rem;\n}\n::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright {\n  text-align: right;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.common_reddot_item {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label {\n  line-height: 0.10101rem;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.alignright {\n  text-align: right;\n}\n.e2e-container {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell {\n  overflow: visible;\n}\n.e2e-red-point,\n.e2e-red-point-left {\n  position: relative;\n}\n.e2e-red-point::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small /deep/ input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small /deep/ input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray /deep/ input {\n  background: #efefef;\n}\n.e2e-radio-large /deep/ .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money {\n  color: #0B41CD;\n}\n.e2e-copy {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy:before {\n  content: '\\E787';\n}\n.e2e-warning {\n  color: #e02020;\n}\n.e2e-warning-blue {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button {\n  font-size: 0.065657rem;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.el-button {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary:hover,\n.el-button--primary:active,\n.el-button--primary:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain:hover,\n.el-button--primary.is-plain:active,\n.el-button--primary.is-plain:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled:hover,\n.el-button--primary.is-plain.is-disabled:active,\n.el-button--primary.is-plain.is-disabled:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled:hover,\n.el-button--primary.is-disabled:active,\n.el-button--primary.is-disabled:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default:hover,\n.el-button--default:active,\n.el-button--default:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text:hover,\n.el-button--text:active,\n.el-button--text:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled {\n  color: #6D7278;\n}\n.operate .el-button + .el-button,\n.operate a + .el-button,\n.operate span + .el-button,\n.operate a + span {\n  margin-left: 0.121212rem;\n}\n.operate span > div {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text {\n  color: #fff;\n}\n.el-loading-mask {\n  z-index: 9998;\n}\n.el-input__inner {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.is-disabled.el-input :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.el-select-dropdown {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label {\n  padding: 0;\n}\n.header-menu-dropdown {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow {\n  display: none;\n}\n.el-table th > .cell {\n  font-weight: bold !important;\n}\n.el-table .cell {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell {\n  padding-left: 0.070707rem;\n}\n.el-table td {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev,\n.el-pagination .btn-next {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span,\n.el-pagination .btn-next span {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog {\n  border-radius: 0.020202rem;\n}\n.el-drawer {\n  overflow: auto;\n}\n.common-confirm-dialog {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog {\n  width: 3.030303rem !important;\n}\n.approval-dialog {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select,\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer {\n  text-align: center;\n}\n.application-search-content-main-fields .active {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label {\n  color: #666666;\n}\n.el-radio__inner:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label {\n  color: #E64100;\n}\n.tox-tinymce-aux {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper {\n  width: 0.757576rem;\n}\n.custom-tooltip {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close,\n.el-select__caret.el-input__icon.el-icon-circle-close:hover,\n.el-input__icon.el-icon-circle-close,\n.el-input__icon.el-icon-circle-close:hover {\n  color: #FB304D;\n}\n*,\n*:before,\n*:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput,\ntextarea {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput:focus {\n  outline: none;\n}\n.biz-budget-detail-edit-dialog .isMedicalField {\n  position: absolute;\n  top: 0;\n  left: 1.161616rem;\n}\n.biz-budget-detail-edit-dialog .el-checkbox__input.is-checked .el-checkbox__inner::after {\n  left: 0.025253rem;\n  top: 0.010101rem;\n}", ""]);

// exports


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-d4c1c57a],\nbody[data-v-d4c1c57a] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-d4c1c57a]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-d4c1c57a] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-d4c1c57a] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-d4c1c57a] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-d4c1c57a],\n  .page-contain[data-v-d4c1c57a],\n  .page-submenu[data-v-d4c1c57a] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-d4c1c57a] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-d4c1c57a] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-d4c1c57a] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-d4c1c57a] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-d4c1c57a] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-d4c1c57a] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-d4c1c57a] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-d4c1c57a] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-d4c1c57a],\n  .page-submenu[data-v-d4c1c57a] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-d4c1c57a] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-d4c1c57a] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-d4c1c57a] {\n    width: 76.3vw;\n}\n.v-main[data-v-d4c1c57a] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-d4c1c57a] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-d4c1c57a] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-d4c1c57a] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-d4c1c57a] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-d4c1c57a] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-d4c1c57a] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-d4c1c57a],\n  .page-submenu[data-v-d4c1c57a] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-d4c1c57a] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-d4c1c57a] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-d4c1c57a] {\n    width: 76.3vw;\n}\n.v-main[data-v-d4c1c57a] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-d4c1c57a] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-d4c1c57a] {\n  margin-top: 0.252525rem;\n}\n[data-v-d4c1c57a]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-d4c1c57a]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-d4c1c57a] {\n  text-align: right;\n}\n.aligncenter[data-v-d4c1c57a] {\n  text-align: center;\n}\n.alignleft[data-v-d4c1c57a] {\n  text-align: left;\n}\n.actiongroupborder[data-v-d4c1c57a] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-d4c1c57a] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-d4c1c57a] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-d4c1c57a] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-d4c1c57a] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-d4c1c57a] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-d4c1c57a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-d4c1c57a] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-d4c1c57a] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-d4c1c57a] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-d4c1c57a] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-d4c1c57a] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-d4c1c57a] {\n  text-align: center;\n}\n.alignleft[data-v-d4c1c57a] {\n  text-align: left;\n}\n.alignright[data-v-d4c1c57a] {\n  text-align: right;\n}\n.e2e-container[data-v-d4c1c57a] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-d4c1c57a] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-d4c1c57a] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-d4c1c57a] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-d4c1c57a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-d4c1c57a] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-d4c1c57a] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-d4c1c57a] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-d4c1c57a] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-d4c1c57a] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-d4c1c57a] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-d4c1c57a],\n.e2e-red-point-left[data-v-d4c1c57a] {\n  position: relative;\n}\n.e2e-red-point[data-v-d4c1c57a]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-d4c1c57a]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-d4c1c57a] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-d4c1c57a] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-d4c1c57a] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-d4c1c57a] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-d4c1c57a] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-d4c1c57a] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-d4c1c57a] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-d4c1c57a] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-d4c1c57a] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-d4c1c57a] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-d4c1c57a] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-d4c1c57a] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-d4c1c57a] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-d4c1c57a]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-d4c1c57a] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-d4c1c57a] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-d4c1c57a],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-d4c1c57a] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-d4c1c57a],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-d4c1c57a] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-d4c1c57a],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-d4c1c57a] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-d4c1c57a],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-d4c1c57a] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-d4c1c57a],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-d4c1c57a] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-d4c1c57a],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-d4c1c57a] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-d4c1c57a] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-d4c1c57a] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-d4c1c57a] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-d4c1c57a] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-d4c1c57a] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-d4c1c57a] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-d4c1c57a] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-d4c1c57a] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-d4c1c57a]:hover,\n.el-button--primary[data-v-d4c1c57a]:active,\n.el-button--primary[data-v-d4c1c57a]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-d4c1c57a] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-d4c1c57a]:hover,\n.el-button--primary.is-plain[data-v-d4c1c57a]:active,\n.el-button--primary.is-plain[data-v-d4c1c57a]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-d4c1c57a] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-d4c1c57a]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-d4c1c57a]:active,\n.el-button--primary.is-plain.is-disabled[data-v-d4c1c57a]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-d4c1c57a] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-d4c1c57a]:hover,\n.el-button--primary.is-disabled[data-v-d4c1c57a]:active,\n.el-button--primary.is-disabled[data-v-d4c1c57a]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-d4c1c57a] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-d4c1c57a]:hover,\n.el-button--default[data-v-d4c1c57a]:active,\n.el-button--default[data-v-d4c1c57a]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-d4c1c57a] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-d4c1c57a]:hover,\n.el-button--text[data-v-d4c1c57a]:active,\n.el-button--text[data-v-d4c1c57a]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-d4c1c57a] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-d4c1c57a],\n.operate a + .el-button[data-v-d4c1c57a],\n.operate span + .el-button[data-v-d4c1c57a],\n.operate a + span[data-v-d4c1c57a] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-d4c1c57a] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-d4c1c57a] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-d4c1c57a] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-d4c1c57a] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-d4c1c57a] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-d4c1c57a] {\n  color: #fff;\n}\n.el-loading-mask[data-v-d4c1c57a] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-d4c1c57a] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-d4c1c57a]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-d4c1c57a]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-d4c1c57a]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-d4c1c57a]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-d4c1c57a] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-d4c1c57a] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-d4c1c57a] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-d4c1c57a] {\n  color: #999;\n}\n.el-select-dropdown[data-v-d4c1c57a] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-d4c1c57a] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-d4c1c57a] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-d4c1c57a] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-d4c1c57a] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-d4c1c57a] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-d4c1c57a] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-d4c1c57a]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-d4c1c57a] {\n  display: none;\n}\n.el-table th > .cell[data-v-d4c1c57a] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-d4c1c57a] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-d4c1c57a] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-d4c1c57a] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-d4c1c57a]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-d4c1c57a]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-d4c1c57a] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-d4c1c57a] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-d4c1c57a] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-d4c1c57a] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-d4c1c57a] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-d4c1c57a] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-d4c1c57a] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-d4c1c57a] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-d4c1c57a],\n.el-pagination .btn-next[data-v-d4c1c57a] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-d4c1c57a],\n.el-pagination .btn-next span[data-v-d4c1c57a] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-d4c1c57a] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-d4c1c57a] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-d4c1c57a] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-d4c1c57a] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-d4c1c57a] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-d4c1c57a] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-d4c1c57a] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-d4c1c57a] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-d4c1c57a] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-d4c1c57a] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-d4c1c57a] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-d4c1c57a] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-d4c1c57a] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-d4c1c57a] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-d4c1c57a] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-d4c1c57a] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-d4c1c57a] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-d4c1c57a] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-d4c1c57a] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-d4c1c57a] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-d4c1c57a] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-d4c1c57a] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-d4c1c57a] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-d4c1c57a] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-d4c1c57a] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-d4c1c57a] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-d4c1c57a] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-d4c1c57a] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-d4c1c57a] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-d4c1c57a]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-d4c1c57a] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-d4c1c57a] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-d4c1c57a] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-d4c1c57a] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-d4c1c57a] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-d4c1c57a] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-d4c1c57a] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-d4c1c57a] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-d4c1c57a] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-d4c1c57a] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-d4c1c57a] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-d4c1c57a],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-d4c1c57a] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-d4c1c57a] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-d4c1c57a] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-d4c1c57a] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-d4c1c57a] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-d4c1c57a] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-d4c1c57a] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-d4c1c57a] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-d4c1c57a] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-d4c1c57a] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-d4c1c57a] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-d4c1c57a] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-d4c1c57a] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-d4c1c57a] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-d4c1c57a] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-d4c1c57a] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-d4c1c57a] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-d4c1c57a] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-d4c1c57a] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-d4c1c57a] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-d4c1c57a] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-d4c1c57a] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-d4c1c57a] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-d4c1c57a] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-d4c1c57a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-d4c1c57a] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-d4c1c57a] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-d4c1c57a] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-d4c1c57a] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-d4c1c57a]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-d4c1c57a] {\n  color: #666666;\n}\n.el-radio__inner[data-v-d4c1c57a]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-d4c1c57a] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-d4c1c57a] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-d4c1c57a] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-d4c1c57a] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-d4c1c57a] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-d4c1c57a] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-d4c1c57a] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-d4c1c57a] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-d4c1c57a],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-d4c1c57a]:hover,\n.el-input__icon.el-icon-circle-close[data-v-d4c1c57a],\n.el-input__icon.el-icon-circle-close[data-v-d4c1c57a]:hover {\n  color: #FB304D;\n}\n*[data-v-d4c1c57a],\n*[data-v-d4c1c57a]:before,\n*[data-v-d4c1c57a]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-d4c1c57a],\ntextarea[data-v-d4c1c57a] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-d4c1c57a]:focus {\n  outline: none;\n}\n.search-content-main[data-v-d4c1c57a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 0.060606rem;\n}\n.search-content-main .search-content-main-fields[data-v-d4c1c57a] {\n  float: left;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.search-content-main .search-content-main-fields .el-form-item + .el-form-item[data-v-d4c1c57a] {\n  margin-left: 0.080808rem;\n}\n.search-content-main .search-content-main-fields-year[data-v-d4c1c57a] {\n  width: 0.606061rem;\n}\n.search-content-main .search-content-main-fields-medicalField[data-v-d4c1c57a] {\n  width: 0.909091rem;\n}\n.search-content-main .search-content-main-fields-departId[data-v-d4c1c57a] {\n  width: 0.909091rem;\n}\n.main-edit[data-v-d4c1c57a] {\n  margin-left: auto;\n  margin-top: 0.090909rem;\n  cursor: pointer;\n}\n.main-edit label[data-v-d4c1c57a],\n.main-edit i[data-v-d4c1c57a] {\n  font-size: 0.070707rem;\n  color: #666666;\n  height: 0.111111rem;\n  line-height: 0.111111rem;\n  cursor: pointer;\n}\n.main-edit .el-button[data-v-d4c1c57a] {\n  height: 0.111111rem;\n  color: #0B41CD;\n  font-size: 0.070707rem;\n}\n.main-edit .el-button.main-edit-cancle[data-v-d4c1c57a] {\n  height: 0.111111rem;\n  color: #333333;\n  font-size: 0.070707rem;\n}\n.search-content[data-v-d4c1c57a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 0.111111rem;\n}\n.search-content .search-content-fields[data-v-d4c1c57a] {\n  float: left;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.search-content .search-content-fields div[data-v-d4c1c57a] {\n  width: 0.909091rem;\n}\n.search-content .el-form-item + .el-form-item[data-v-d4c1c57a] {\n  margin-left: 0.080808rem;\n}\n.operate[data-v-d4c1c57a] {\n  float: right;\n  margin-bottom: 0.151515rem;\n}\n.l-user-item[data-v-d4c1c57a] {\n  width: 100%;\n  height: 0.287879rem;\n  padding: 0.090909rem 0.111111rem;\n  border-bottom: 0.005051rem solid #dfdfdf;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.l-user-item-icon[data-v-d4c1c57a] {\n  font-size: 0.080808rem;\n  padding: 0.010101rem;\n}\n.main-blocks[data-v-d4c1c57a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row nowrap;\n          flex-flow: row nowrap;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.main-block[data-v-d4c1c57a] {\n  height: 0.606061rem;\n  width: 1.186869rem;\n  display: inline-block;\n  border: none;\n}\n.main-block-contain[data-v-d4c1c57a] {\n  display: inline-block;\n  width: 1.186869rem;\n}\n.main-block-contain-title[data-v-d4c1c57a] {\n  margin-left: 0.121212rem;\n  margin-top: 0.080808rem;\n  height: 0.111111rem;\n  line-height: 0.111111rem;\n  font-size: 0.080808rem;\n  color: #666666;\n}\n.main-block-contain-budget[data-v-d4c1c57a] {\n  margin-left: 0.121212rem;\n  margin-top: 0.090909rem;\n  height: 0.151515rem;\n  line-height: 0.151515rem;\n  font-size: 0.121212rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.main-block-contain-budget i[data-v-d4c1c57a] {\n  font-size: 0.141414rem;\n  color: #2D82F0;\n}\n.main-block-contain-budget .icon-qiandaizi[data-v-d4c1c57a] {\n  color: #FFB52A;\n}\n.main-block-contain-budget label[data-v-d4c1c57a] {\n  color: rgba(0, 0, 0, 0.85);\n  margin-left: 0.080808rem;\n}\n.main-block + .main-block .main-block-contain[data-v-d4c1c57a] {\n  border-left: 0.005051rem solid #E8E8E8;\n  height: 0.40404rem;\n  margin-top: 0.10101rem;\n}\n.main-block + .main-block .main-block-contain .main-block-contain-title[data-v-d4c1c57a] {\n  margin-top: -0.020202rem;\n}\n.budget-detail-info[data-v-d4c1c57a] {\n  float: left;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  font-size: 0.070707rem;\n  color: #333333;\n}\n.main-budget-info-block[data-v-d4c1c57a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-bottom: 0.080808rem;\n}\n.main-budget-info-block-name[data-v-d4c1c57a] {\n  width: 50%;\n}\n.main-budget-info-block-name label[data-v-d4c1c57a] {\n  float: right;\n  font-size: 0.070707rem;\n  color: #666666;\n}\n.main-budget-info-block-value[data-v-d4c1c57a] {\n  font-size: 0.070707rem;\n  color: #333333;\n}", ""]);

// exports


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-e8ad199e],\nbody[data-v-e8ad199e] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-e8ad199e]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-e8ad199e] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-e8ad199e] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-e8ad199e] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-e8ad199e],\n  .page-contain[data-v-e8ad199e],\n  .page-submenu[data-v-e8ad199e] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-e8ad199e] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-e8ad199e] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-e8ad199e] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-e8ad199e] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-e8ad199e] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-e8ad199e] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-e8ad199e] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-e8ad199e] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-e8ad199e],\n  .page-submenu[data-v-e8ad199e] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-e8ad199e] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-e8ad199e] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-e8ad199e] {\n    width: 76.3vw;\n}\n.v-main[data-v-e8ad199e] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-e8ad199e] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-e8ad199e] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-e8ad199e] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-e8ad199e] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-e8ad199e] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-e8ad199e] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-e8ad199e],\n  .page-submenu[data-v-e8ad199e] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-e8ad199e] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-e8ad199e] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-e8ad199e] {\n    width: 76.3vw;\n}\n.v-main[data-v-e8ad199e] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-e8ad199e] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-e8ad199e] {\n  margin-top: 0.252525rem;\n}\n[data-v-e8ad199e]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-e8ad199e]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-e8ad199e] {\n  text-align: right;\n}\n.aligncenter[data-v-e8ad199e] {\n  text-align: center;\n}\n.alignleft[data-v-e8ad199e] {\n  text-align: left;\n}\n.actiongroupborder[data-v-e8ad199e] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-e8ad199e] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-e8ad199e] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-e8ad199e] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-e8ad199e] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-e8ad199e] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-e8ad199e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-e8ad199e] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-e8ad199e] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-e8ad199e] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-e8ad199e] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-e8ad199e] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-e8ad199e] {\n  text-align: center;\n}\n.alignleft[data-v-e8ad199e] {\n  text-align: left;\n}\n.alignright[data-v-e8ad199e] {\n  text-align: right;\n}\n.e2e-container[data-v-e8ad199e] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-e8ad199e] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-e8ad199e] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-e8ad199e] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-e8ad199e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-e8ad199e] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-e8ad199e] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-e8ad199e] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-e8ad199e] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-e8ad199e] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-e8ad199e] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-e8ad199e],\n.e2e-red-point-left[data-v-e8ad199e] {\n  position: relative;\n}\n.e2e-red-point[data-v-e8ad199e]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-e8ad199e]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-e8ad199e] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-e8ad199e] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-e8ad199e] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-e8ad199e] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-e8ad199e] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-e8ad199e] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-e8ad199e] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-e8ad199e] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-e8ad199e] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-e8ad199e] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-e8ad199e] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-e8ad199e] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-e8ad199e] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-e8ad199e]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-e8ad199e] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-e8ad199e] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-e8ad199e],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-e8ad199e] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-e8ad199e],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-e8ad199e] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-e8ad199e],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-e8ad199e] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-e8ad199e],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-e8ad199e] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-e8ad199e],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-e8ad199e] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-e8ad199e],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-e8ad199e] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-e8ad199e] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-e8ad199e] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-e8ad199e] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-e8ad199e] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-e8ad199e] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-e8ad199e] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-e8ad199e] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-e8ad199e] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-e8ad199e]:hover,\n.el-button--primary[data-v-e8ad199e]:active,\n.el-button--primary[data-v-e8ad199e]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-e8ad199e] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-e8ad199e]:hover,\n.el-button--primary.is-plain[data-v-e8ad199e]:active,\n.el-button--primary.is-plain[data-v-e8ad199e]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-e8ad199e] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-e8ad199e]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-e8ad199e]:active,\n.el-button--primary.is-plain.is-disabled[data-v-e8ad199e]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-e8ad199e] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-e8ad199e]:hover,\n.el-button--primary.is-disabled[data-v-e8ad199e]:active,\n.el-button--primary.is-disabled[data-v-e8ad199e]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-e8ad199e] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-e8ad199e]:hover,\n.el-button--default[data-v-e8ad199e]:active,\n.el-button--default[data-v-e8ad199e]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-e8ad199e] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-e8ad199e]:hover,\n.el-button--text[data-v-e8ad199e]:active,\n.el-button--text[data-v-e8ad199e]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-e8ad199e] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-e8ad199e],\n.operate a + .el-button[data-v-e8ad199e],\n.operate span + .el-button[data-v-e8ad199e],\n.operate a + span[data-v-e8ad199e] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-e8ad199e] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-e8ad199e] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-e8ad199e] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-e8ad199e] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-e8ad199e] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-e8ad199e] {\n  color: #fff;\n}\n.el-loading-mask[data-v-e8ad199e] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-e8ad199e] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-e8ad199e]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-e8ad199e]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-e8ad199e]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-e8ad199e]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-e8ad199e] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-e8ad199e] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-e8ad199e] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-e8ad199e] {\n  color: #999;\n}\n.el-select-dropdown[data-v-e8ad199e] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-e8ad199e] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-e8ad199e] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-e8ad199e] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-e8ad199e] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-e8ad199e] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-e8ad199e] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-e8ad199e]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-e8ad199e] {\n  display: none;\n}\n.el-table th > .cell[data-v-e8ad199e] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-e8ad199e] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-e8ad199e] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-e8ad199e] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-e8ad199e]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-e8ad199e]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-e8ad199e] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-e8ad199e] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-e8ad199e] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-e8ad199e] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-e8ad199e] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-e8ad199e] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-e8ad199e] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-e8ad199e] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-e8ad199e],\n.el-pagination .btn-next[data-v-e8ad199e] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-e8ad199e],\n.el-pagination .btn-next span[data-v-e8ad199e] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-e8ad199e] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-e8ad199e] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-e8ad199e] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-e8ad199e] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-e8ad199e] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-e8ad199e] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-e8ad199e] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-e8ad199e] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-e8ad199e] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-e8ad199e] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-e8ad199e] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-e8ad199e] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-e8ad199e] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-e8ad199e] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-e8ad199e] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-e8ad199e] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-e8ad199e] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-e8ad199e] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-e8ad199e] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-e8ad199e] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-e8ad199e] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-e8ad199e] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-e8ad199e] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-e8ad199e] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-e8ad199e] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-e8ad199e] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-e8ad199e] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-e8ad199e] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-e8ad199e] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-e8ad199e]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-e8ad199e] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-e8ad199e] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-e8ad199e] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-e8ad199e] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-e8ad199e] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-e8ad199e] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-e8ad199e] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-e8ad199e] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-e8ad199e] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-e8ad199e] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-e8ad199e] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-e8ad199e],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-e8ad199e] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-e8ad199e] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-e8ad199e] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-e8ad199e] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-e8ad199e] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-e8ad199e] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-e8ad199e] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-e8ad199e] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-e8ad199e] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-e8ad199e] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-e8ad199e] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-e8ad199e] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-e8ad199e] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-e8ad199e] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-e8ad199e] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-e8ad199e] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-e8ad199e] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-e8ad199e] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-e8ad199e] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-e8ad199e] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-e8ad199e] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-e8ad199e] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-e8ad199e] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-e8ad199e] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-e8ad199e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-e8ad199e] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-e8ad199e] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-e8ad199e] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-e8ad199e] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-e8ad199e]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-e8ad199e] {\n  color: #666666;\n}\n.el-radio__inner[data-v-e8ad199e]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-e8ad199e] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-e8ad199e] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-e8ad199e] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-e8ad199e] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-e8ad199e] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-e8ad199e] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-e8ad199e] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-e8ad199e] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-e8ad199e],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-e8ad199e]:hover,\n.el-input__icon.el-icon-circle-close[data-v-e8ad199e],\n.el-input__icon.el-icon-circle-close[data-v-e8ad199e]:hover {\n  color: #FB304D;\n}\n*[data-v-e8ad199e],\n*[data-v-e8ad199e]:before,\n*[data-v-e8ad199e]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-e8ad199e],\ntextarea[data-v-e8ad199e] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-e8ad199e]:focus {\n  outline: none;\n}\n.search-content[data-v-e8ad199e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 0.111111rem;\n}\n.search-content .search-content-fields[data-v-e8ad199e] {\n  width: 90%;\n}\n.search-content .btn-search[data-v-e8ad199e] {\n  margin-left: 0.10101rem;\n}\n.operate[data-v-e8ad199e] {\n  float: right;\n  margin-bottom: 0.151515rem;\n}\n.tipsFormDivClass[data-v-e8ad199e] {\n  text-align: left;\n  font-weight: normal;\n  margin-top: 0.050505rem;\n}", ""]);

// exports


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-f046f23c],\nbody[data-v-f046f23c] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-f046f23c]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-f046f23c] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-f046f23c] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-f046f23c] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-f046f23c],\n  .page-contain[data-v-f046f23c],\n  .page-submenu[data-v-f046f23c] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-f046f23c] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-f046f23c] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-f046f23c] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-f046f23c] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-f046f23c] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-f046f23c] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-f046f23c] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-f046f23c] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-f046f23c],\n  .page-submenu[data-v-f046f23c] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-f046f23c] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-f046f23c] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-f046f23c] {\n    width: 76.3vw;\n}\n.v-main[data-v-f046f23c] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-f046f23c] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-f046f23c] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-f046f23c] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-f046f23c] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-f046f23c] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-f046f23c] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-f046f23c],\n  .page-submenu[data-v-f046f23c] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-f046f23c] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-f046f23c] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-f046f23c] {\n    width: 76.3vw;\n}\n.v-main[data-v-f046f23c] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-f046f23c] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-f046f23c] {\n  margin-top: 0.252525rem;\n}\n[data-v-f046f23c]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-f046f23c]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-f046f23c] {\n  text-align: right;\n}\n.aligncenter[data-v-f046f23c] {\n  text-align: center;\n}\n.alignleft[data-v-f046f23c] {\n  text-align: left;\n}\n.actiongroupborder[data-v-f046f23c] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-f046f23c] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-f046f23c] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-f046f23c] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-f046f23c] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-f046f23c] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-f046f23c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-f046f23c] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-f046f23c] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-f046f23c] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-f046f23c] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-f046f23c] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-f046f23c] {\n  text-align: center;\n}\n.alignleft[data-v-f046f23c] {\n  text-align: left;\n}\n.alignright[data-v-f046f23c] {\n  text-align: right;\n}\n.e2e-container[data-v-f046f23c] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-f046f23c] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-f046f23c] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-f046f23c] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-f046f23c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-f046f23c] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-f046f23c] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-f046f23c] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-f046f23c] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-f046f23c] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-f046f23c] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-f046f23c],\n.e2e-red-point-left[data-v-f046f23c] {\n  position: relative;\n}\n.e2e-red-point[data-v-f046f23c]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-f046f23c]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-f046f23c] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-f046f23c] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-f046f23c] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-f046f23c] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-f046f23c] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-f046f23c] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-f046f23c] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-f046f23c] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-f046f23c] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-f046f23c] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-f046f23c] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-f046f23c] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-f046f23c] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-f046f23c]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-f046f23c] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-f046f23c] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-f046f23c],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-f046f23c] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-f046f23c],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-f046f23c] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-f046f23c],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-f046f23c] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-f046f23c],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-f046f23c] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-f046f23c],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-f046f23c] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-f046f23c],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-f046f23c] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-f046f23c] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-f046f23c] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-f046f23c] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-f046f23c] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-f046f23c] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-f046f23c] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-f046f23c] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-f046f23c] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-f046f23c]:hover,\n.el-button--primary[data-v-f046f23c]:active,\n.el-button--primary[data-v-f046f23c]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-f046f23c] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-f046f23c]:hover,\n.el-button--primary.is-plain[data-v-f046f23c]:active,\n.el-button--primary.is-plain[data-v-f046f23c]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-f046f23c] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-f046f23c]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-f046f23c]:active,\n.el-button--primary.is-plain.is-disabled[data-v-f046f23c]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-f046f23c] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-f046f23c]:hover,\n.el-button--primary.is-disabled[data-v-f046f23c]:active,\n.el-button--primary.is-disabled[data-v-f046f23c]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-f046f23c] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-f046f23c]:hover,\n.el-button--default[data-v-f046f23c]:active,\n.el-button--default[data-v-f046f23c]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-f046f23c] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-f046f23c]:hover,\n.el-button--text[data-v-f046f23c]:active,\n.el-button--text[data-v-f046f23c]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-f046f23c] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-f046f23c],\n.operate a + .el-button[data-v-f046f23c],\n.operate span + .el-button[data-v-f046f23c],\n.operate a + span[data-v-f046f23c] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-f046f23c] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-f046f23c] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-f046f23c] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-f046f23c] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-f046f23c] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-f046f23c] {\n  color: #fff;\n}\n.el-loading-mask[data-v-f046f23c] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-f046f23c] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-f046f23c]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-f046f23c]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-f046f23c]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-f046f23c]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-f046f23c] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-f046f23c] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-f046f23c] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-f046f23c] {\n  color: #999;\n}\n.el-select-dropdown[data-v-f046f23c] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-f046f23c] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-f046f23c] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-f046f23c] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-f046f23c] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-f046f23c] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-f046f23c] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-f046f23c]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-f046f23c] {\n  display: none;\n}\n.el-table th > .cell[data-v-f046f23c] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-f046f23c] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-f046f23c] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-f046f23c] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-f046f23c]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-f046f23c]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-f046f23c] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-f046f23c] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-f046f23c] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-f046f23c] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-f046f23c] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-f046f23c] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-f046f23c] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-f046f23c] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-f046f23c],\n.el-pagination .btn-next[data-v-f046f23c] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-f046f23c],\n.el-pagination .btn-next span[data-v-f046f23c] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-f046f23c] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-f046f23c] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-f046f23c] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-f046f23c] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-f046f23c] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-f046f23c] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-f046f23c] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-f046f23c] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-f046f23c] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-f046f23c] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-f046f23c] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-f046f23c] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-f046f23c] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-f046f23c] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-f046f23c] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-f046f23c] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-f046f23c] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-f046f23c] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-f046f23c] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-f046f23c] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-f046f23c] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-f046f23c] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-f046f23c] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-f046f23c] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-f046f23c] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-f046f23c] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-f046f23c] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-f046f23c] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-f046f23c] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-f046f23c]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-f046f23c] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-f046f23c] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-f046f23c] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-f046f23c] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-f046f23c] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-f046f23c] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-f046f23c] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-f046f23c] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-f046f23c] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-f046f23c] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-f046f23c] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-f046f23c],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-f046f23c] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-f046f23c] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-f046f23c] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-f046f23c] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-f046f23c] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-f046f23c] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-f046f23c] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-f046f23c] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-f046f23c] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-f046f23c] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-f046f23c] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-f046f23c] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-f046f23c] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-f046f23c] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-f046f23c] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-f046f23c] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-f046f23c] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-f046f23c] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-f046f23c] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-f046f23c] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-f046f23c] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-f046f23c] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-f046f23c] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-f046f23c] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-f046f23c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-f046f23c] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-f046f23c] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-f046f23c] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-f046f23c] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-f046f23c]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-f046f23c] {\n  color: #666666;\n}\n.el-radio__inner[data-v-f046f23c]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-f046f23c] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-f046f23c] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-f046f23c] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-f046f23c] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-f046f23c] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-f046f23c] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-f046f23c] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-f046f23c] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-f046f23c],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-f046f23c]:hover,\n.el-input__icon.el-icon-circle-close[data-v-f046f23c],\n.el-input__icon.el-icon-circle-close[data-v-f046f23c]:hover {\n  color: #FB304D;\n}\n*[data-v-f046f23c],\n*[data-v-f046f23c]:before,\n*[data-v-f046f23c]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-f046f23c],\ntextarea[data-v-f046f23c] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-f046f23c]:focus {\n  outline: none;\n}\n.iconfont[data-v-f046f23c] {\n  font-size: 0.070707rem;\n}", ""]);

// exports


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-f3df5218],\nbody[data-v-f3df5218] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-f3df5218]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-f3df5218] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-f3df5218] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-f3df5218] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-f3df5218],\n  .page-contain[data-v-f3df5218],\n  .page-submenu[data-v-f3df5218] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-f3df5218] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-f3df5218] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-f3df5218] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-f3df5218] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-f3df5218] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-f3df5218] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-f3df5218] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-f3df5218] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-f3df5218],\n  .page-submenu[data-v-f3df5218] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-f3df5218] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-f3df5218] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-f3df5218] {\n    width: 76.3vw;\n}\n.v-main[data-v-f3df5218] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-f3df5218] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-f3df5218] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-f3df5218] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-f3df5218] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-f3df5218] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-f3df5218] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-f3df5218],\n  .page-submenu[data-v-f3df5218] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-f3df5218] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-f3df5218] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-f3df5218] {\n    width: 76.3vw;\n}\n.v-main[data-v-f3df5218] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-f3df5218] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-f3df5218] {\n  margin-top: 0.252525rem;\n}\n[data-v-f3df5218]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-f3df5218]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-f3df5218] {\n  text-align: right;\n}\n.aligncenter[data-v-f3df5218] {\n  text-align: center;\n}\n.alignleft[data-v-f3df5218] {\n  text-align: left;\n}\n.actiongroupborder[data-v-f3df5218] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-f3df5218] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-f3df5218] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-f3df5218] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-f3df5218] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-f3df5218] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-f3df5218] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-f3df5218] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-f3df5218] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-f3df5218] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-f3df5218] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-f3df5218] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-f3df5218] {\n  text-align: center;\n}\n.alignleft[data-v-f3df5218] {\n  text-align: left;\n}\n.alignright[data-v-f3df5218] {\n  text-align: right;\n}\n.e2e-container[data-v-f3df5218] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-f3df5218] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-f3df5218] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-f3df5218] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-f3df5218] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-f3df5218] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-f3df5218] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-f3df5218] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-f3df5218] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-f3df5218] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-f3df5218] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-f3df5218],\n.e2e-red-point-left[data-v-f3df5218] {\n  position: relative;\n}\n.e2e-red-point[data-v-f3df5218]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-f3df5218]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-f3df5218] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-f3df5218] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-f3df5218] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-f3df5218] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-f3df5218] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-f3df5218] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-f3df5218] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-f3df5218] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-f3df5218] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-f3df5218] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-f3df5218] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-f3df5218] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-f3df5218] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-f3df5218]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-f3df5218] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-f3df5218] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-f3df5218],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-f3df5218] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-f3df5218],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-f3df5218] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-f3df5218],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-f3df5218] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-f3df5218],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-f3df5218] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-f3df5218],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-f3df5218] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-f3df5218],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-f3df5218] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-f3df5218] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-f3df5218] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-f3df5218] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-f3df5218] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-f3df5218] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-f3df5218] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-f3df5218] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-f3df5218] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-f3df5218]:hover,\n.el-button--primary[data-v-f3df5218]:active,\n.el-button--primary[data-v-f3df5218]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-f3df5218] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-f3df5218]:hover,\n.el-button--primary.is-plain[data-v-f3df5218]:active,\n.el-button--primary.is-plain[data-v-f3df5218]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-f3df5218] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-f3df5218]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-f3df5218]:active,\n.el-button--primary.is-plain.is-disabled[data-v-f3df5218]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-f3df5218] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-f3df5218]:hover,\n.el-button--primary.is-disabled[data-v-f3df5218]:active,\n.el-button--primary.is-disabled[data-v-f3df5218]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-f3df5218] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-f3df5218]:hover,\n.el-button--default[data-v-f3df5218]:active,\n.el-button--default[data-v-f3df5218]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-f3df5218] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-f3df5218]:hover,\n.el-button--text[data-v-f3df5218]:active,\n.el-button--text[data-v-f3df5218]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-f3df5218] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-f3df5218],\n.operate a + .el-button[data-v-f3df5218],\n.operate span + .el-button[data-v-f3df5218],\n.operate a + span[data-v-f3df5218] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-f3df5218] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-f3df5218] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-f3df5218] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-f3df5218] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-f3df5218] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-f3df5218] {\n  color: #fff;\n}\n.el-loading-mask[data-v-f3df5218] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-f3df5218] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-f3df5218]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-f3df5218]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-f3df5218]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-f3df5218]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-f3df5218] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-f3df5218] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-f3df5218] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-f3df5218] {\n  color: #999;\n}\n.el-select-dropdown[data-v-f3df5218] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-f3df5218] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-f3df5218] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-f3df5218] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-f3df5218] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-f3df5218] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-f3df5218] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-f3df5218]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-f3df5218] {\n  display: none;\n}\n.el-table th > .cell[data-v-f3df5218] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-f3df5218] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-f3df5218] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-f3df5218] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-f3df5218]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-f3df5218]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-f3df5218] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-f3df5218] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-f3df5218] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-f3df5218] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-f3df5218] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-f3df5218] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-f3df5218] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-f3df5218] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-f3df5218],\n.el-pagination .btn-next[data-v-f3df5218] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-f3df5218],\n.el-pagination .btn-next span[data-v-f3df5218] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-f3df5218] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-f3df5218] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-f3df5218] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-f3df5218] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-f3df5218] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-f3df5218] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-f3df5218] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-f3df5218] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-f3df5218] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-f3df5218] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-f3df5218] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-f3df5218] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-f3df5218] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-f3df5218] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-f3df5218] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-f3df5218] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-f3df5218] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-f3df5218] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-f3df5218] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-f3df5218] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-f3df5218] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-f3df5218] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-f3df5218] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-f3df5218] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-f3df5218] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-f3df5218] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-f3df5218] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-f3df5218] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-f3df5218] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-f3df5218]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-f3df5218] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-f3df5218] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-f3df5218] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-f3df5218] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-f3df5218] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-f3df5218] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-f3df5218] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-f3df5218] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-f3df5218] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-f3df5218] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-f3df5218] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-f3df5218],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-f3df5218] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-f3df5218] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-f3df5218] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-f3df5218] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-f3df5218] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-f3df5218] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-f3df5218] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-f3df5218] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-f3df5218] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-f3df5218] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-f3df5218] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-f3df5218] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-f3df5218] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-f3df5218] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-f3df5218] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-f3df5218] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-f3df5218] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-f3df5218] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-f3df5218] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-f3df5218] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-f3df5218] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-f3df5218] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-f3df5218] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-f3df5218] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-f3df5218] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-f3df5218] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-f3df5218] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-f3df5218] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-f3df5218] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-f3df5218]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-f3df5218] {\n  color: #666666;\n}\n.el-radio__inner[data-v-f3df5218]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-f3df5218] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-f3df5218] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-f3df5218] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-f3df5218] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-f3df5218] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-f3df5218] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-f3df5218] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-f3df5218] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-f3df5218],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-f3df5218]:hover,\n.el-input__icon.el-icon-circle-close[data-v-f3df5218],\n.el-input__icon.el-icon-circle-close[data-v-f3df5218]:hover {\n  color: #FB304D;\n}\n*[data-v-f3df5218],\n*[data-v-f3df5218]:before,\n*[data-v-f3df5218]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-f3df5218],\ntextarea[data-v-f3df5218] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-f3df5218]:focus {\n  outline: none;\n}\n.page-contain .page-contain-tab[data-v-f3df5218] {\n  padding: 0 0.282828rem 0.161616rem 0.282828rem;\n  margin-bottom: 0.121212rem;\n}\n.page-contain .page-contain-tab .recipientSocietyOrHospital-text span[data-v-f3df5218] {\n  color: #0B41CD;\n}\n.page-contain .page-contain-tab .recipientSociety-input[data-v-f3df5218] {\n  font-size: 0.070707rem;\n  margin-left: 0.050505rem;\n  padding-top: 0.040404rem !important;\n}\n.page-contain .page-contain-tab .more-tab[data-v-f3df5218] {\n  background: #F6F6F6;\n  border-radius: 0.010101rem;\n  width: 3.959596rem;\n  margin-top: 0.040404rem !important;\n  margin-left: -0.080808rem !important;\n  padding-left: 0.080808rem !important;\n  padding-top: 0.080808rem !important;\n  padding-bottom: 0.060606rem !important;\n}\n.page-contain .page-contain-tab .more-tab-div[data-v-f3df5218] {\n  margin-top: 0.080808rem;\n}\n.page-contain .approval-workflow[data-v-f3df5218] {\n  width: auto !important;\n}\n.page-contain .approval-workflow-title[data-v-f3df5218] {\n  font-size: 0.070707rem;\n  margin-left: 0.050505rem;\n  padding-top: 0.121212rem;\n}\n.page-contain .approval-workflow-title div[data-v-f3df5218] {\n  border-top: 0.005051rem solid #E8E8E8;\n  margin: 0.121212rem -0.282828rem 0 -0.333333rem;\n}\n.page-contain .approval-status[data-v-f3df5218] {\n  margin-left: 0.10101rem;\n  padding: 0.025253rem;\n  border-radius: 0.010101rem;\n  height: 0.111111rem;\n  font-size: 0.060606rem;\n}\n.page-contain .approval-padding[data-v-f3df5218] {\n  border: 0.005051rem solid #FFDA95;\n  background-color: #FFF8EA;\n  color: #FFB52A;\n}\n.page-contain .approval-comfirm[data-v-f3df5218] {\n  border: 0.005051rem solid #8BE9BE;\n  background-color: #EDFFF6;\n  color: #0EC771;\n}\n.page-contain .approval-reject[data-v-f3df5218] {\n  border: 0.005051rem solid #FF9CAA;\n  background-color: #FFEFF1;\n  color: #FB304D;\n}\n.page-contain .approval-cancle[data-v-f3df5218] {\n  border: 0.005051rem solid #D6D6D6;\n  background-color: #F6F6F6;\n  color: #666666;\n}\n.page-contain .approval-submit[data-v-f3df5218] {\n  border: 0.005051rem solid #A2CBFF;\n  background-color: #EBF4FF;\n  color: #2D82F0;\n}\n.bottom-info[data-v-f3df5218] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: fixed;\n  background-color: #fff;\n  width: 100%;\n  left: 0;\n  height: 0.222222rem;\n  -webkit-box-shadow: -0.005051rem 0 0.020202rem 0 rgba(51, 51, 51, 0.35);\n          box-shadow: -0.005051rem 0 0.020202rem 0 rgba(51, 51, 51, 0.35);\n  bottom: 0;\n}\n.bottom-info-info[data-v-f3df5218] {\n  margin-left: 0.606061rem;\n  line-height: 0.222222rem;\n}\n.bottom-info-operate[data-v-f3df5218] {\n  position: absolute;\n  right: 0.606061rem;\n  line-height: 0.232323rem;\n}\n.col-add-remove[data-v-f3df5218] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.operate-add-remove[data-v-f3df5218] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 0.10101rem;\n  margin: 0.191919rem 0 0 0.050505rem;\n}\n.operate-add-remove span[data-v-f3df5218] {\n  cursor: pointer;\n}\n.operate-add-remove span + span[data-v-f3df5218] {\n  margin-left: 0.050505rem;\n}\n.view-meeting-plan[data-v-f3df5218] {\n  padding: 0;\n  margin-bottom: 0.429293rem;\n}\n.view-meeting-plan .edit-form-title[data-v-f3df5218] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row[data-v-f3df5218] {\n  padding: 0.121212rem 0 0 0;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full[data-v-f3df5218] {\n  width: 5.494949rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-input__inner[data-v-f3df5218] {\n  width: 5.494949rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-textarea__inner[data-v-f3df5218] {\n  height: 0.555556rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-form-item__label[data-v-f3df5218] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-form-item__content[data-v-f3df5218] {\n  padding-top: 0.010101rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .col-full .el-form-item__content label[data-v-f3df5218] {\n  margin-left: 0.050505rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col[data-v-f3df5218] {\n  width: 1.616162rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-f3df5218] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-f3df5218] {\n  padding-top: 0.010101rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-f3df5218],\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-f3df5218] {\n  width: 1.616162rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col .el-form-item__content label[data-v-f3df5218] {\n  margin-left: 0.050505rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-f3df5218] {\n  margin-left: 0.323232rem;\n}\n.view-meeting-plan .el-form.el-form--label-top .col-no-3[data-v-f3df5218] {\n  margin-left: 3.878788rem;\n}\n.view-meeting-plan .el-form.el-form--label-right .el-row[data-v-f3df5218] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.cancle-alert-info[data-v-f3df5218] {\n  margin-top: 0.030303rem;\n}", ""]);

// exports


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-f6034e3e],\nbody[data-v-f6034e3e] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-f6034e3e]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-f6034e3e] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-f6034e3e] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-f6034e3e] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-f6034e3e],\n  .page-contain[data-v-f6034e3e],\n  .page-submenu[data-v-f6034e3e] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-f6034e3e] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-f6034e3e] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-f6034e3e] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-f6034e3e] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-f6034e3e] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-f6034e3e] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-f6034e3e] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-f6034e3e] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-f6034e3e],\n  .page-submenu[data-v-f6034e3e] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-f6034e3e] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-f6034e3e] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-f6034e3e] {\n    width: 76.3vw;\n}\n.v-main[data-v-f6034e3e] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-f6034e3e] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-f6034e3e] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-f6034e3e] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-f6034e3e] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-f6034e3e] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-f6034e3e] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-f6034e3e],\n  .page-submenu[data-v-f6034e3e] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-f6034e3e] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-f6034e3e] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-f6034e3e] {\n    width: 76.3vw;\n}\n.v-main[data-v-f6034e3e] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-f6034e3e] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-f6034e3e] {\n  margin-top: 0.252525rem;\n}\n[data-v-f6034e3e]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-f6034e3e]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-f6034e3e] {\n  text-align: right;\n}\n.aligncenter[data-v-f6034e3e] {\n  text-align: center;\n}\n.alignleft[data-v-f6034e3e] {\n  text-align: left;\n}\n.actiongroupborder[data-v-f6034e3e] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-f6034e3e] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-f6034e3e] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-f6034e3e] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-f6034e3e] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-f6034e3e] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-f6034e3e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-f6034e3e] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-f6034e3e] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-f6034e3e] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-f6034e3e] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-f6034e3e] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-f6034e3e] {\n  text-align: center;\n}\n.alignleft[data-v-f6034e3e] {\n  text-align: left;\n}\n.alignright[data-v-f6034e3e] {\n  text-align: right;\n}\n.e2e-container[data-v-f6034e3e] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-f6034e3e] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-f6034e3e] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-f6034e3e] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-f6034e3e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-f6034e3e] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-f6034e3e] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-f6034e3e] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-f6034e3e] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-f6034e3e] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-f6034e3e] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-f6034e3e],\n.e2e-red-point-left[data-v-f6034e3e] {\n  position: relative;\n}\n.e2e-red-point[data-v-f6034e3e]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-f6034e3e]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-f6034e3e] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-f6034e3e] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-f6034e3e] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-f6034e3e] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-f6034e3e] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-f6034e3e] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-f6034e3e] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-f6034e3e] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-f6034e3e] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-f6034e3e] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-f6034e3e] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-f6034e3e] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-f6034e3e] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-f6034e3e]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-f6034e3e] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-f6034e3e] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-f6034e3e],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-f6034e3e] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-f6034e3e],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-f6034e3e] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-f6034e3e],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-f6034e3e] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-f6034e3e],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-f6034e3e] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-f6034e3e],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-f6034e3e] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-f6034e3e],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-f6034e3e] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-f6034e3e] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-f6034e3e] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-f6034e3e] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-f6034e3e] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-f6034e3e] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-f6034e3e] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-f6034e3e] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-f6034e3e] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-f6034e3e]:hover,\n.el-button--primary[data-v-f6034e3e]:active,\n.el-button--primary[data-v-f6034e3e]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-f6034e3e] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-f6034e3e]:hover,\n.el-button--primary.is-plain[data-v-f6034e3e]:active,\n.el-button--primary.is-plain[data-v-f6034e3e]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-f6034e3e] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-f6034e3e]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-f6034e3e]:active,\n.el-button--primary.is-plain.is-disabled[data-v-f6034e3e]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-f6034e3e] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-f6034e3e]:hover,\n.el-button--primary.is-disabled[data-v-f6034e3e]:active,\n.el-button--primary.is-disabled[data-v-f6034e3e]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-f6034e3e] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-f6034e3e]:hover,\n.el-button--default[data-v-f6034e3e]:active,\n.el-button--default[data-v-f6034e3e]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-f6034e3e] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-f6034e3e]:hover,\n.el-button--text[data-v-f6034e3e]:active,\n.el-button--text[data-v-f6034e3e]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-f6034e3e] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-f6034e3e],\n.operate a + .el-button[data-v-f6034e3e],\n.operate span + .el-button[data-v-f6034e3e],\n.operate a + span[data-v-f6034e3e] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-f6034e3e] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-f6034e3e] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-f6034e3e] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-f6034e3e] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-f6034e3e] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-f6034e3e] {\n  color: #fff;\n}\n.el-loading-mask[data-v-f6034e3e] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-f6034e3e] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-f6034e3e]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-f6034e3e]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-f6034e3e]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-f6034e3e]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-f6034e3e] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-f6034e3e] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-f6034e3e] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-f6034e3e] {\n  color: #999;\n}\n.el-select-dropdown[data-v-f6034e3e] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-f6034e3e] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-f6034e3e] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-f6034e3e] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-f6034e3e] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-f6034e3e] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-f6034e3e] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-f6034e3e]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-f6034e3e] {\n  display: none;\n}\n.el-table th > .cell[data-v-f6034e3e] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-f6034e3e] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-f6034e3e] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-f6034e3e] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-f6034e3e]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-f6034e3e]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-f6034e3e] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-f6034e3e] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-f6034e3e] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-f6034e3e] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-f6034e3e] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-f6034e3e] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-f6034e3e] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-f6034e3e] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-f6034e3e],\n.el-pagination .btn-next[data-v-f6034e3e] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-f6034e3e],\n.el-pagination .btn-next span[data-v-f6034e3e] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-f6034e3e] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-f6034e3e] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-f6034e3e] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-f6034e3e] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-f6034e3e] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-f6034e3e] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-f6034e3e] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-f6034e3e] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-f6034e3e] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-f6034e3e] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-f6034e3e] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-f6034e3e] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-f6034e3e] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-f6034e3e] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-f6034e3e] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-f6034e3e] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-f6034e3e] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-f6034e3e] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-f6034e3e] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-f6034e3e] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-f6034e3e] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-f6034e3e] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-f6034e3e] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-f6034e3e] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-f6034e3e] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-f6034e3e] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-f6034e3e] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-f6034e3e] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-f6034e3e] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-f6034e3e]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-f6034e3e] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-f6034e3e] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-f6034e3e] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-f6034e3e] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-f6034e3e] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-f6034e3e] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-f6034e3e] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-f6034e3e] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-f6034e3e] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-f6034e3e] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-f6034e3e] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-f6034e3e],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-f6034e3e] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-f6034e3e] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-f6034e3e] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-f6034e3e] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-f6034e3e] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-f6034e3e] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-f6034e3e] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-f6034e3e] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-f6034e3e] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-f6034e3e] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-f6034e3e] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-f6034e3e] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-f6034e3e] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-f6034e3e] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-f6034e3e] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-f6034e3e] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-f6034e3e] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-f6034e3e] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-f6034e3e] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-f6034e3e] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-f6034e3e] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-f6034e3e] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-f6034e3e] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-f6034e3e] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-f6034e3e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-f6034e3e] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-f6034e3e] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-f6034e3e] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-f6034e3e] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-f6034e3e]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-f6034e3e] {\n  color: #666666;\n}\n.el-radio__inner[data-v-f6034e3e]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-f6034e3e] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-f6034e3e] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-f6034e3e] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-f6034e3e] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-f6034e3e] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-f6034e3e] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-f6034e3e] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-f6034e3e] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-f6034e3e],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-f6034e3e]:hover,\n.el-input__icon.el-icon-circle-close[data-v-f6034e3e],\n.el-input__icon.el-icon-circle-close[data-v-f6034e3e]:hover {\n  color: #FB304D;\n}\n*[data-v-f6034e3e],\n*[data-v-f6034e3e]:before,\n*[data-v-f6034e3e]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-f6034e3e],\ntextarea[data-v-f6034e3e] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-f6034e3e]:focus {\n  outline: none;\n}\n.operate[data-v-f6034e3e] {\n  margin-top: 0.10101rem;\n  text-align: center;\n}\n.inline-items label[data-v-f6034e3e] {\n  width: 0.909091rem;\n}\n.inline-items div[data-v-f6034e3e] {\n  display: inline-block;\n}", ""]);

// exports


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml,\nbody {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.v-main,\n  .page-contain,\n  .page-submenu {\n    width: 6.060606rem;\n}\n.page-submenu_left {\n    width: 1.313131rem;\n}\n.page-submenu_right {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n.has-header {\n  margin-top: 0.252525rem;\n}\n::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright {\n  text-align: right;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.common_reddot_item {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label {\n  line-height: 0.10101rem;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.alignright {\n  text-align: right;\n}\n.e2e-container {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell {\n  overflow: visible;\n}\n.e2e-red-point,\n.e2e-red-point-left {\n  position: relative;\n}\n.e2e-red-point::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small /deep/ input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small /deep/ input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray /deep/ input {\n  background: #efefef;\n}\n.e2e-radio-large /deep/ .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money {\n  color: #0B41CD;\n}\n.e2e-copy {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy:before {\n  content: '\\E787';\n}\n.e2e-warning {\n  color: #e02020;\n}\n.e2e-warning-blue {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button {\n  font-size: 0.065657rem;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.el-button {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary:hover,\n.el-button--primary:active,\n.el-button--primary:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain:hover,\n.el-button--primary.is-plain:active,\n.el-button--primary.is-plain:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled:hover,\n.el-button--primary.is-plain.is-disabled:active,\n.el-button--primary.is-plain.is-disabled:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled:hover,\n.el-button--primary.is-disabled:active,\n.el-button--primary.is-disabled:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default:hover,\n.el-button--default:active,\n.el-button--default:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text:hover,\n.el-button--text:active,\n.el-button--text:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled {\n  color: #6D7278;\n}\n.operate .el-button + .el-button,\n.operate a + .el-button,\n.operate span + .el-button,\n.operate a + span {\n  margin-left: 0.121212rem;\n}\n.operate span > div {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text {\n  color: #fff;\n}\n.el-loading-mask {\n  z-index: 9998;\n}\n.el-input__inner {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.is-disabled.el-input :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.el-select-dropdown {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label {\n  padding: 0;\n}\n.header-menu-dropdown {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow {\n  display: none;\n}\n.el-table th > .cell {\n  font-weight: bold !important;\n}\n.el-table .cell {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell {\n  padding-left: 0.070707rem;\n}\n.el-table td {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev,\n.el-pagination .btn-next {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span,\n.el-pagination .btn-next span {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog {\n  border-radius: 0.020202rem;\n}\n.el-drawer {\n  overflow: auto;\n}\n.common-confirm-dialog {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog {\n  width: 3.030303rem !important;\n}\n.approval-dialog {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select,\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer {\n  text-align: center;\n}\n.application-search-content-main-fields .active {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label {\n  color: #666666;\n}\n.el-radio__inner:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label {\n  color: #E64100;\n}\n.tox-tinymce-aux {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper {\n  width: 0.757576rem;\n}\n.custom-tooltip {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close,\n.el-select__caret.el-input__icon.el-icon-circle-close:hover,\n.el-input__icon.el-icon-circle-close,\n.el-input__icon.el-icon-circle-close:hover {\n  color: #FB304D;\n}\n*,\n*:before,\n*:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput,\ntextarea {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput:focus {\n  outline: none;\n}\n.search-content-main-fields .el-tag--info {\n  max-width: 0.707071rem;\n  min-width: 0.227273rem;\n  padding-right: 0.075758rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  position: relative;\n}\n.search-content-main-fields .el-tag--info .el-tag__close {\n  position: absolute;\n  right: -0.005051rem;\n  top: 0.025253rem;\n}\n.dashboard-budget .chart-class-1,\n.dashboard-budget .chart-class-2 {\n  margin: 0 auto;\n  width: 1.010101rem;\n  height: 1.010101rem;\n}\n.dashboard-budget .chart-class-3 {\n  margin: 0.080808rem 0.121212rem;\n  width: 2.747475rem;\n  height: 1.212121rem;\n}\n.dashboard-budget .chart-class-4,\n.dashboard-budget .chart-class-5 {\n  margin-top: 0.075758rem;\n  margin-left: auto;\n  width: 2.888889rem;\n  height: 1.414141rem;\n}", ""]);

// exports


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-f8e3b742],\nbody[data-v-f8e3b742] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-f8e3b742]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-f8e3b742] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-f8e3b742] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-f8e3b742] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-f8e3b742],\n  .page-contain[data-v-f8e3b742],\n  .page-submenu[data-v-f8e3b742] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-f8e3b742] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-f8e3b742] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-f8e3b742] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-f8e3b742] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-f8e3b742] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-f8e3b742] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-f8e3b742] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-f8e3b742] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-f8e3b742],\n  .page-submenu[data-v-f8e3b742] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-f8e3b742] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-f8e3b742] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-f8e3b742] {\n    width: 76.3vw;\n}\n.v-main[data-v-f8e3b742] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-f8e3b742] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-f8e3b742] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-f8e3b742] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-f8e3b742] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-f8e3b742] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-f8e3b742] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-f8e3b742],\n  .page-submenu[data-v-f8e3b742] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-f8e3b742] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-f8e3b742] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-f8e3b742] {\n    width: 76.3vw;\n}\n.v-main[data-v-f8e3b742] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-f8e3b742] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-f8e3b742] {\n  margin-top: 0.252525rem;\n}\n[data-v-f8e3b742]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-f8e3b742]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-f8e3b742] {\n  text-align: right;\n}\n.aligncenter[data-v-f8e3b742] {\n  text-align: center;\n}\n.alignleft[data-v-f8e3b742] {\n  text-align: left;\n}\n.actiongroupborder[data-v-f8e3b742] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-f8e3b742] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-f8e3b742] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-f8e3b742] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-f8e3b742] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-f8e3b742] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-f8e3b742] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-f8e3b742] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-f8e3b742] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-f8e3b742] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-f8e3b742] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-f8e3b742] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-f8e3b742] {\n  text-align: center;\n}\n.alignleft[data-v-f8e3b742] {\n  text-align: left;\n}\n.alignright[data-v-f8e3b742] {\n  text-align: right;\n}\n.e2e-container[data-v-f8e3b742] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-f8e3b742] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-f8e3b742] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-f8e3b742] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-f8e3b742] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-f8e3b742] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-f8e3b742] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-f8e3b742] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-f8e3b742] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-f8e3b742] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-f8e3b742] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-f8e3b742],\n.e2e-red-point-left[data-v-f8e3b742] {\n  position: relative;\n}\n.e2e-red-point[data-v-f8e3b742]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-f8e3b742]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-f8e3b742] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-f8e3b742] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-f8e3b742] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-f8e3b742] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-f8e3b742] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-f8e3b742] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-f8e3b742] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-f8e3b742] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-f8e3b742] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-f8e3b742] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-f8e3b742] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-f8e3b742] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-f8e3b742] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-f8e3b742]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-f8e3b742] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-f8e3b742] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-f8e3b742],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-f8e3b742] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-f8e3b742],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-f8e3b742] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-f8e3b742],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-f8e3b742] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-f8e3b742],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-f8e3b742] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-f8e3b742],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-f8e3b742] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-f8e3b742],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-f8e3b742] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-f8e3b742] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-f8e3b742] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-f8e3b742] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-f8e3b742] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-f8e3b742] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-f8e3b742] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-f8e3b742] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-f8e3b742] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-f8e3b742]:hover,\n.el-button--primary[data-v-f8e3b742]:active,\n.el-button--primary[data-v-f8e3b742]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-f8e3b742] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-f8e3b742]:hover,\n.el-button--primary.is-plain[data-v-f8e3b742]:active,\n.el-button--primary.is-plain[data-v-f8e3b742]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-f8e3b742] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-f8e3b742]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-f8e3b742]:active,\n.el-button--primary.is-plain.is-disabled[data-v-f8e3b742]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-f8e3b742] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-f8e3b742]:hover,\n.el-button--primary.is-disabled[data-v-f8e3b742]:active,\n.el-button--primary.is-disabled[data-v-f8e3b742]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-f8e3b742] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-f8e3b742]:hover,\n.el-button--default[data-v-f8e3b742]:active,\n.el-button--default[data-v-f8e3b742]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-f8e3b742] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-f8e3b742]:hover,\n.el-button--text[data-v-f8e3b742]:active,\n.el-button--text[data-v-f8e3b742]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-f8e3b742] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-f8e3b742],\n.operate a + .el-button[data-v-f8e3b742],\n.operate span + .el-button[data-v-f8e3b742],\n.operate a + span[data-v-f8e3b742] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-f8e3b742] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-f8e3b742] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-f8e3b742] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-f8e3b742] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-f8e3b742] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-f8e3b742] {\n  color: #fff;\n}\n.el-loading-mask[data-v-f8e3b742] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-f8e3b742] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-f8e3b742]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-f8e3b742]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-f8e3b742]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-f8e3b742]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-f8e3b742] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-f8e3b742] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-f8e3b742] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-f8e3b742] {\n  color: #999;\n}\n.el-select-dropdown[data-v-f8e3b742] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-f8e3b742] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-f8e3b742] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-f8e3b742] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-f8e3b742] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-f8e3b742] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-f8e3b742] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-f8e3b742]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-f8e3b742] {\n  display: none;\n}\n.el-table th > .cell[data-v-f8e3b742] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-f8e3b742] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-f8e3b742] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-f8e3b742] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-f8e3b742]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-f8e3b742]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-f8e3b742] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-f8e3b742] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-f8e3b742] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-f8e3b742] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-f8e3b742] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-f8e3b742] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-f8e3b742] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-f8e3b742] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-f8e3b742],\n.el-pagination .btn-next[data-v-f8e3b742] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-f8e3b742],\n.el-pagination .btn-next span[data-v-f8e3b742] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-f8e3b742] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-f8e3b742] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-f8e3b742] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-f8e3b742] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-f8e3b742] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-f8e3b742] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-f8e3b742] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-f8e3b742] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-f8e3b742] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-f8e3b742] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-f8e3b742] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-f8e3b742] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-f8e3b742] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-f8e3b742] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-f8e3b742] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-f8e3b742] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-f8e3b742] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-f8e3b742] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-f8e3b742] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-f8e3b742] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-f8e3b742] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-f8e3b742] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-f8e3b742] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-f8e3b742] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-f8e3b742] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-f8e3b742] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-f8e3b742] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-f8e3b742] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-f8e3b742] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-f8e3b742]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-f8e3b742] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-f8e3b742] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-f8e3b742] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-f8e3b742] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-f8e3b742] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-f8e3b742] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-f8e3b742] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-f8e3b742] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-f8e3b742] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-f8e3b742] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-f8e3b742] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-f8e3b742],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-f8e3b742] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-f8e3b742] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-f8e3b742] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-f8e3b742] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-f8e3b742] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-f8e3b742] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-f8e3b742] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-f8e3b742] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-f8e3b742] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-f8e3b742] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-f8e3b742] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-f8e3b742] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-f8e3b742] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-f8e3b742] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-f8e3b742] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-f8e3b742] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-f8e3b742] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-f8e3b742] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-f8e3b742] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-f8e3b742] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-f8e3b742] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-f8e3b742] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-f8e3b742] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-f8e3b742] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-f8e3b742] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-f8e3b742] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-f8e3b742] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-f8e3b742] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-f8e3b742] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-f8e3b742]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-f8e3b742] {\n  color: #666666;\n}\n.el-radio__inner[data-v-f8e3b742]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-f8e3b742] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-f8e3b742] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-f8e3b742] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-f8e3b742] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-f8e3b742] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-f8e3b742] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-f8e3b742] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-f8e3b742] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-f8e3b742],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-f8e3b742]:hover,\n.el-input__icon.el-icon-circle-close[data-v-f8e3b742],\n.el-input__icon.el-icon-circle-close[data-v-f8e3b742]:hover {\n  color: #FB304D;\n}\n*[data-v-f8e3b742],\n*[data-v-f8e3b742]:before,\n*[data-v-f8e3b742]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-f8e3b742],\ntextarea[data-v-f8e3b742] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-f8e3b742]:focus {\n  outline: none;\n}\n.page-header[data-v-f8e3b742] {\n  padding: 0.040404rem 0;\n  margin-top: -0.121212rem;\n  font-size: 0.080808rem;\n  font-weight: bold;\n  color: #666666;\n  line-height: 0.161616rem;\n  height: 0.242424rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.page-header-title[data-v-f8e3b742] {\n  font-weight: 400;\n}\n.page-header-subinfo[data-v-f8e3b742] {\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  margin-left: auto;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  color: #0B41CD;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-header-subinfo i[data-v-f8e3b742] {\n  margin-right: 0.040404rem;\n}\n.page-header-subinfo-role[data-v-f8e3b742] {\n  width: 0.909091rem;\n}\n.page-header-subinfo-role label[data-v-f8e3b742] {\n  margin-right: 0.050505rem;\n  color: #666666;\n}\n.page-header-subinfo-role div[data-v-f8e3b742] {\n  width: 0.606061rem;\n}\n.search-content-main[data-v-f8e3b742] {\n  display: inline-block;\n  margin-bottom: 0.030303rem;\n}\n.search-content-main .search-content-main-fields[data-v-f8e3b742] {\n  float: left;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.search-content-main .search-content-main-fields .el-form-item + .el-form-item[data-v-f8e3b742] {\n  margin-left: 0.080808rem;\n}\n.search-content-main .search-content-main-fields-year[data-v-f8e3b742] {\n  width: 0.606061rem;\n}\n.search-content-main .search-content-main-fields-medicalField[data-v-f8e3b742] {\n  width: 0.909091rem;\n}\n.search-content-main .search-content-main-fields-departId[data-v-f8e3b742] {\n  width: 0.909091rem;\n}\n.charts-row[data-v-f8e3b742] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.charts-row .chart[data-v-f8e3b742] {\n  height: 1.616162rem;\n  width: 2.989899rem;\n  background: #fff;\n}\n.charts-row .chart .title[data-v-f8e3b742] {\n  color: #333333;\n  font-size: 0.090909rem;\n  margin: 0.075758rem 0 0 0.121212rem;\n}\n.charts-row .chart .title i[data-v-f8e3b742] {\n  font-size: 0.080808rem;\n  margin-right: 0.030303rem;\n  color: rgba(11, 65, 205, 0.5);\n}\n.charts-row .chart-small[data-v-f8e3b742] {\n  height: 1.414141rem;\n  width: 1.454545rem;\n}\n.charts-row .chart-small-long[data-v-f8e3b742] {\n  height: 1.414141rem;\n}\n.charts-row .chart-small-long2[data-v-f8e3b742] {\n  height: 1.414141rem;\n  margin-left: 0 !important;\n}\n.charts-row .chart + .chart[data-v-f8e3b742] {\n  margin-left: 0.080808rem;\n}\n.charts-row + .charts-row[data-v-f8e3b742] {\n  margin-top: 0.085859rem;\n}\n.gauge-legend[data-v-f8e3b742] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 0.080808rem 0 0 0.126263rem;\n  font-size: 0.060606rem;\n  color: #666666;\n}\n.gauge-legend-value[data-v-f8e3b742] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: 0.060606rem;\n}\n.gauge-legend-value div[data-v-f8e3b742] {\n  height: 0.045455rem;\n  width: 0.045455rem;\n  border-radius: 0.022727rem;\n  margin: 0.010101rem 0.040404rem 0 0;\n}\n.gauge-legend-value-1 div[data-v-f8e3b742] {\n  background-color: #2D82F0;\n}\n.gauge-legend-value-2 div[data-v-f8e3b742] {\n  background-color: #E8EAEC;\n}\n.gauge-legend-value-3 div[data-v-f8e3b742] {\n  background-color: #0B41CD;\n}\n.axis-label[data-v-f8e3b742] {\n  height: 0;\n}\n.axis-label-0[data-v-f8e3b742] {\n  position: relative;\n  top: 0.732323rem;\n  left: 0.378788rem;\n  font-size: 0.070707rem;\n  color: rgba(0, 0, 0, 0.45);\n}\n.axis-label-100[data-v-f8e3b742] {\n  position: relative;\n  top: 0.732323rem;\n  left: 0.984848rem;\n  font-size: 0.070707rem;\n  color: rgba(0, 0, 0, 0.45);\n}\n.axis-label-remain[data-v-f8e3b742] {\n  position: relative;\n  top: 0.580808rem;\n  left: 0.858586rem;\n  font-size: 0.080808rem;\n  color: #333333;\n  font-weight: bold;\n  width: 0.181818rem;\n}\n.axis-label-long[data-v-f8e3b742] {\n  margin-left: 0.767677rem;\n}\n.message-info[data-v-f8e3b742] {\n  margin-top: -0.176768rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 0.20202rem;\n  font-size: 0.060606rem;\n  color: #333333;\n  line-height: 0.10101rem;\n}\n.message-info div[data-v-f8e3b742] {\n  margin: 0 auto;\n}", ""]);

// exports


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-f99456ea],\nbody[data-v-f99456ea] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-f99456ea]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-f99456ea] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-f99456ea] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-f99456ea] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-f99456ea],\n  .page-contain[data-v-f99456ea],\n  .page-submenu[data-v-f99456ea] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-f99456ea] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-f99456ea] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-f99456ea] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-f99456ea] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-f99456ea] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-f99456ea] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-f99456ea] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-f99456ea] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-f99456ea],\n  .page-submenu[data-v-f99456ea] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-f99456ea] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-f99456ea] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-f99456ea] {\n    width: 76.3vw;\n}\n.v-main[data-v-f99456ea] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-f99456ea] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-f99456ea] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-f99456ea] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-f99456ea] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-f99456ea] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-f99456ea] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-f99456ea],\n  .page-submenu[data-v-f99456ea] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-f99456ea] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-f99456ea] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-f99456ea] {\n    width: 76.3vw;\n}\n.v-main[data-v-f99456ea] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-f99456ea] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-f99456ea] {\n  margin-top: 0.252525rem;\n}\n[data-v-f99456ea]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-f99456ea]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-f99456ea] {\n  text-align: right;\n}\n.aligncenter[data-v-f99456ea] {\n  text-align: center;\n}\n.alignleft[data-v-f99456ea] {\n  text-align: left;\n}\n.actiongroupborder[data-v-f99456ea] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-f99456ea] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-f99456ea] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-f99456ea] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-f99456ea] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-f99456ea] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-f99456ea] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-f99456ea] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-f99456ea] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-f99456ea] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-f99456ea] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-f99456ea] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-f99456ea] {\n  text-align: center;\n}\n.alignleft[data-v-f99456ea] {\n  text-align: left;\n}\n.alignright[data-v-f99456ea] {\n  text-align: right;\n}\n.e2e-container[data-v-f99456ea] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-f99456ea] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-f99456ea] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-f99456ea] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-f99456ea] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-f99456ea] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-f99456ea] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-f99456ea] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-f99456ea] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-f99456ea] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-f99456ea] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-f99456ea],\n.e2e-red-point-left[data-v-f99456ea] {\n  position: relative;\n}\n.e2e-red-point[data-v-f99456ea]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-f99456ea]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-f99456ea] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-f99456ea] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-f99456ea] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-f99456ea] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-f99456ea] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-f99456ea] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-f99456ea] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-f99456ea] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-f99456ea] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-f99456ea] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-f99456ea] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-f99456ea] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-f99456ea] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-f99456ea]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-f99456ea] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-f99456ea] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-f99456ea],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-f99456ea] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-f99456ea],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-f99456ea] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-f99456ea],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-f99456ea] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-f99456ea],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-f99456ea] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-f99456ea],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-f99456ea] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-f99456ea],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-f99456ea] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-f99456ea] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-f99456ea] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-f99456ea] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-f99456ea] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-f99456ea] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-f99456ea] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-f99456ea] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-f99456ea] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-f99456ea]:hover,\n.el-button--primary[data-v-f99456ea]:active,\n.el-button--primary[data-v-f99456ea]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-f99456ea] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-f99456ea]:hover,\n.el-button--primary.is-plain[data-v-f99456ea]:active,\n.el-button--primary.is-plain[data-v-f99456ea]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-f99456ea] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-f99456ea]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-f99456ea]:active,\n.el-button--primary.is-plain.is-disabled[data-v-f99456ea]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-f99456ea] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-f99456ea]:hover,\n.el-button--primary.is-disabled[data-v-f99456ea]:active,\n.el-button--primary.is-disabled[data-v-f99456ea]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-f99456ea] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-f99456ea]:hover,\n.el-button--default[data-v-f99456ea]:active,\n.el-button--default[data-v-f99456ea]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-f99456ea] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-f99456ea]:hover,\n.el-button--text[data-v-f99456ea]:active,\n.el-button--text[data-v-f99456ea]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-f99456ea] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-f99456ea],\n.operate a + .el-button[data-v-f99456ea],\n.operate span + .el-button[data-v-f99456ea],\n.operate a + span[data-v-f99456ea] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-f99456ea] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-f99456ea] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-f99456ea] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-f99456ea] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-f99456ea] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-f99456ea] {\n  color: #fff;\n}\n.el-loading-mask[data-v-f99456ea] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-f99456ea] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-f99456ea]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-f99456ea]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-f99456ea]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-f99456ea]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-f99456ea] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-f99456ea] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-f99456ea] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-f99456ea] {\n  color: #999;\n}\n.el-select-dropdown[data-v-f99456ea] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-f99456ea] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-f99456ea] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-f99456ea] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-f99456ea] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-f99456ea] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-f99456ea] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-f99456ea]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-f99456ea] {\n  display: none;\n}\n.el-table th > .cell[data-v-f99456ea] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-f99456ea] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-f99456ea] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-f99456ea] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-f99456ea]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-f99456ea]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-f99456ea] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-f99456ea] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-f99456ea] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-f99456ea] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-f99456ea] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-f99456ea] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-f99456ea] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-f99456ea] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-f99456ea],\n.el-pagination .btn-next[data-v-f99456ea] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-f99456ea],\n.el-pagination .btn-next span[data-v-f99456ea] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-f99456ea] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-f99456ea] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-f99456ea] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-f99456ea] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-f99456ea] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-f99456ea] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-f99456ea] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-f99456ea] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-f99456ea] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-f99456ea] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-f99456ea] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-f99456ea] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-f99456ea] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-f99456ea] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-f99456ea] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-f99456ea] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-f99456ea] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-f99456ea] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-f99456ea] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-f99456ea] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-f99456ea] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-f99456ea] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-f99456ea] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-f99456ea] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-f99456ea] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-f99456ea] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-f99456ea] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-f99456ea] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-f99456ea] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-f99456ea]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-f99456ea] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-f99456ea] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-f99456ea] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-f99456ea] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-f99456ea] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-f99456ea] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-f99456ea] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-f99456ea] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-f99456ea] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-f99456ea] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-f99456ea] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-f99456ea],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-f99456ea] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-f99456ea] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-f99456ea] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-f99456ea] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-f99456ea] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-f99456ea] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-f99456ea] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-f99456ea] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-f99456ea] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-f99456ea] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-f99456ea] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-f99456ea] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-f99456ea] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-f99456ea] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-f99456ea] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-f99456ea] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-f99456ea] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-f99456ea] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-f99456ea] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-f99456ea] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-f99456ea] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-f99456ea] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-f99456ea] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-f99456ea] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-f99456ea] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-f99456ea] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-f99456ea] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-f99456ea] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-f99456ea] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-f99456ea]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-f99456ea] {\n  color: #666666;\n}\n.el-radio__inner[data-v-f99456ea]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-f99456ea] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-f99456ea] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-f99456ea] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-f99456ea] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-f99456ea] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-f99456ea] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-f99456ea] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-f99456ea] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-f99456ea],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-f99456ea]:hover,\n.el-input__icon.el-icon-circle-close[data-v-f99456ea],\n.el-input__icon.el-icon-circle-close[data-v-f99456ea]:hover {\n  color: #FB304D;\n}\n*[data-v-f99456ea],\n*[data-v-f99456ea]:before,\n*[data-v-f99456ea]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-f99456ea],\ntextarea[data-v-f99456ea] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-f99456ea]:focus {\n  outline: none;\n}\n.search-content[data-v-f99456ea] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 0.111111rem;\n}\n.search-content .search-content-fields[data-v-f99456ea] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.search-content .search-content-fields .el-row .col-full[data-v-f99456ea] {\n  width: 3.525253rem;\n}\n.search-content .search-content-fields .el-row .el-col[data-v-f99456ea] {\n  width: 1.111111rem;\n}\n.search-content .search-content-fields .el-row .el-col + .el-col[data-v-f99456ea] {\n  margin-left: 0.141414rem;\n}\n.search-content .search-content-fields .search-btn[data-v-f99456ea] {\n  margin-top: 0.631313rem;\n  margin-left: 0.070707rem;\n}\n.search-content .search-content-fields .search-btn button[data-v-f99456ea] {\n  width: 0.606061rem;\n}\n.operate[data-v-f99456ea] {\n  float: right;\n  margin-bottom: 0.151515rem;\n}\n.operate .add-btn[data-v-f99456ea] {\n  width: 0.606061rem;\n}\n.operate .batch-download-btn[data-v-f99456ea],\n.operate .batch-delete-btn[data-v-f99456ea] {\n  width: 0.439394rem;\n  padding: 0;\n}\n.operate .el-button + .el-button[data-v-f99456ea] {\n  margin-left: 0.131313rem;\n}", ""]);

// exports


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml,\nbody {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.v-main,\n  .page-contain,\n  .page-submenu {\n    width: 6.060606rem;\n}\n.page-submenu_left {\n    width: 1.313131rem;\n}\n.page-submenu_right {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container {\n    padding-left: 0.050505rem !important;\n}\n.page-header {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain,\n  .page-submenu {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left {\n    width: 21.6vw;\n}\n.page-submenu_right {\n    width: 76.3vw;\n}\n.v-main {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog {\n    width: 98.5vw;\n}\n}\n.has-header {\n  margin-top: 0.252525rem;\n}\n::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright {\n  text-align: right;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.common_reddot_item {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label {\n  line-height: 0.10101rem;\n}\n.aligncenter {\n  text-align: center;\n}\n.alignleft {\n  text-align: left;\n}\n.alignright {\n  text-align: right;\n}\n.e2e-container {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell {\n  overflow: visible;\n}\n.e2e-red-point,\n.e2e-red-point-left {\n  position: relative;\n}\n.e2e-red-point::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small /deep/ input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small /deep/ input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small /deep/ .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray /deep/ input {\n  background: #efefef;\n}\n.e2e-radio-large /deep/ .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money {\n  color: #0B41CD;\n}\n.e2e-copy {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy:before {\n  content: '\\E787';\n}\n.e2e-warning {\n  color: #e02020;\n}\n.e2e-warning-blue {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span,\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button {\n  font-size: 0.065657rem;\n}\n.actiongroupborder {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container {\n  margin-top: 0.121212rem;\n}\n.el-button {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary:hover,\n.el-button--primary:active,\n.el-button--primary:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain:hover,\n.el-button--primary.is-plain:active,\n.el-button--primary.is-plain:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled:hover,\n.el-button--primary.is-plain.is-disabled:active,\n.el-button--primary.is-plain.is-disabled:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled:hover,\n.el-button--primary.is-disabled:active,\n.el-button--primary.is-disabled:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default:hover,\n.el-button--default:active,\n.el-button--default:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text:hover,\n.el-button--text:active,\n.el-button--text:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled {\n  color: #6D7278;\n}\n.operate .el-button + .el-button,\n.operate a + .el-button,\n.operate span + .el-button,\n.operate a + span {\n  margin-left: 0.121212rem;\n}\n.operate span > div {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text {\n  color: #fff;\n}\n.el-loading-mask {\n  z-index: 9998;\n}\n.el-input__inner {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.is-disabled.el-input :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner {\n  color: #999;\n}\n.el-select-dropdown {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label {\n  padding: 0;\n}\n.header-menu-dropdown {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow {\n  display: none;\n}\n.el-table th > .cell {\n  font-weight: bold !important;\n}\n.el-table .cell {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell {\n  padding-left: 0.070707rem;\n}\n.el-table td {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev,\n.el-pagination .btn-next {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span,\n.el-pagination .btn-next span {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog {\n  border-radius: 0.020202rem;\n}\n.el-drawer {\n  overflow: auto;\n}\n.common-confirm-dialog {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog {\n  width: 3.030303rem !important;\n}\n.approval-dialog {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select,\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer {\n  text-align: center;\n}\n.application-search-content-main-fields .active {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label {\n  color: #666666;\n}\n.el-radio__inner:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label {\n  color: #E64100;\n}\n.tox-tinymce-aux {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper {\n  width: 0.757576rem;\n}\n.custom-tooltip {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close,\n.el-select__caret.el-input__icon.el-icon-circle-close:hover,\n.el-input__icon.el-icon-circle-close,\n.el-input__icon.el-icon-circle-close:hover {\n  color: #FB304D;\n}\n*,\n*:before,\n*:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput,\ntextarea {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput:focus {\n  outline: none;\n}\n.search-content-main-fields .el-tag--info {\n  max-width: 0.580808rem;\n  min-width: 0.227273rem;\n  padding-right: 0.075758rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  position: relative;\n}\n.search-content-main-fields .el-tag--info .el-tag__close {\n  position: absolute;\n  right: -0.005051rem;\n  top: 0.025253rem;\n}\n.dashboard-meeting .chart-class-1 {\n  margin-top: 0.075758rem;\n  margin-left: auto;\n  width: 2.893939rem;\n  height: 1.414141rem;\n}\n.dashboard-meeting .chart-class-2 {\n  margin-top: 0.075758rem;\n  margin-left: auto;\n  width: 2.888889rem;\n  height: 1.414141rem;\n}\n.dashboard-meeting .chart-class-3 {\n  margin-top: 0.075758rem;\n  margin-left: auto;\n  width: 2.888889rem;\n  height: 1.414141rem;\n}\n.dashboard-meeting .chart-class-4 {\n  margin: 0.080808rem 0.121212rem;\n  height: 1.515152rem;\n  width: 100%;\n}", ""]);

// exports


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "\nhtml[data-v-fc17aeaa],\nbody[data-v-fc17aeaa] {\n  background: #F2F4F8;\n  font-family: 'Arial', 'Helvetica', sans-serif, 'SimHei', 'Microsoft YaHei';\n}\n[data-v-fc17aeaa]:root {\n  overflow-y: auto;\n  overflow-x: auto;\n}\n@media screen and (min-width: 1220px) {\nhtml[data-v-fc17aeaa] {\n    overflow-y: scroll;\n    min-width: 6.060606rem;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-fc17aeaa] {\n    margin-left: 0.292929rem;\n}\n.fix-header .header .nav[data-v-fc17aeaa] {\n    margin-right: 0.393939rem;\n}\n.v-main[data-v-fc17aeaa],\n  .page-contain[data-v-fc17aeaa],\n  .page-submenu[data-v-fc17aeaa] {\n    width: 6.060606rem;\n}\n.page-submenu_left[data-v-fc17aeaa] {\n    width: 1.313131rem;\n}\n.page-submenu_right[data-v-fc17aeaa] {\n    width: 4.626263rem;\n}\n.advanced-search-dialog .el-dialog[data-v-fc17aeaa] {\n    width: 6.060606rem;\n}\n}\n@media screen and (min-width: 1000px) and (max-width: 1219px) {\nhtml[data-v-fc17aeaa] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-fc17aeaa] {\n    margin-left: 0.161616rem;\n}\n.fix-header .header .nav[data-v-fc17aeaa] {\n    margin-right: 0.393939rem;\n}\n.breadcrumb-container[data-v-fc17aeaa] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-fc17aeaa] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-fc17aeaa],\n  .page-submenu[data-v-fc17aeaa] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-fc17aeaa] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-fc17aeaa] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-fc17aeaa] {\n    width: 76.3vw;\n}\n.v-main[data-v-fc17aeaa] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-fc17aeaa] {\n    width: 98.5vw;\n}\n}\n@media screen and (max-width: 999px) {\nhtml[data-v-fc17aeaa] {\n    overflow-y: scroll;\n    min-width: 100vw;\n}\n.fix-header .header .header-menu .header-menu-main[data-v-fc17aeaa] {\n    margin-left: 0.050505rem;\n}\n.fix-header .header .nav[data-v-fc17aeaa] {\n    margin-right: 0.10101rem;\n}\n.breadcrumb-container[data-v-fc17aeaa] {\n    padding-left: 0.050505rem !important;\n}\n.page-header[data-v-fc17aeaa] {\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain[data-v-fc17aeaa],\n  .page-submenu[data-v-fc17aeaa] {\n    width: 100vw;\n    padding-left: 0.050505rem !important;\n    padding-right: 0.050505rem !important;\n}\n.page-contain .page-contain-tab[data-v-fc17aeaa] {\n    padding-left: 0.151515rem !important;\n    padding-right: 0.151515rem !important;\n}\n.page-submenu_left[data-v-fc17aeaa] {\n    width: 21.6vw;\n}\n.page-submenu_right[data-v-fc17aeaa] {\n    width: 76.3vw;\n}\n.v-main[data-v-fc17aeaa] {\n    width: 100vw;\n}\n.advanced-search-dialog .el-dialog[data-v-fc17aeaa] {\n    width: 98.5vw;\n}\n}\n.has-header[data-v-fc17aeaa] {\n  margin-top: 0.252525rem;\n}\n[data-v-fc17aeaa]::-webkit-scrollbar {\n  width: 0.040404rem;\n  height: 0.040404rem;\n  background-color: #f1f1f1;\n  border-radius: 0.020202rem;\n}\n[data-v-fc17aeaa]::-webkit-scrollbar-thumb {\n  cursor: pointer;\n  background-color: #cccccc;\n  border-radius: 0.040404rem;\n  width: 0.050505rem;\n}\n.alignright[data-v-fc17aeaa] {\n  text-align: right;\n}\n.aligncenter[data-v-fc17aeaa] {\n  text-align: center;\n}\n.alignleft[data-v-fc17aeaa] {\n  text-align: left;\n}\n.actiongroupborder[data-v-fc17aeaa] {\n  height: 0 !important;\n}\n.common_reddot_item[data-v-fc17aeaa] {\n  display: inline-block;\n  width: 0.030303rem;\n  height: 0.030303rem;\n  background-color: red;\n  border-radius: 50%;\n  vertical-align: top;\n}\n.page-submenu[data-v-fc17aeaa] {\n  margin: 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.page-submenu .content-box[data-v-fc17aeaa] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.page-submenu .page-submenu_right .content-box[data-v-fc17aeaa] {\n  padding: 0.10101rem 0.217172rem 0.10101rem 0.116162rem;\n  margin-bottom: 0.10101rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.table-header-cell[data-v-fc17aeaa] {\n  background-color: #F6F6F6 !important;\n  color: #333333 !important;\n  font-weight: bold !important;\n  font-size: 0.070707rem;\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.table-header-cell .table-column-operate[data-v-fc17aeaa] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.pagination[data-v-fc17aeaa] {\n  text-align: center;\n  margin: 0.121212rem 0.121212rem 0.020202rem 0.121212rem;\n}\n.header-messagebox[data-v-fc17aeaa] {\n  padding: 0;\n}\n.page-contain .page-contain-main-tab[data-v-fc17aeaa] {\n  background-color: #fff;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-contain .page-contain-tab[data-v-fc17aeaa] {\n  background-color: #fff;\n  padding: 0.10101rem;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.070707rem;\n}\n.franchise-form-label[data-v-fc17aeaa] {\n  line-height: 0.10101rem;\n}\n.aligncenter[data-v-fc17aeaa] {\n  text-align: center;\n}\n.alignleft[data-v-fc17aeaa] {\n  text-align: left;\n}\n.alignright[data-v-fc17aeaa] {\n  text-align: right;\n}\n.e2e-container[data-v-fc17aeaa] {\n  width: 6.060606rem;\n  margin: 0 auto;\n  display: block;\n}\n.e2e-content-box[data-v-fc17aeaa] {\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.020202rem;\n}\n.e2e-content-box .content-title[data-v-fc17aeaa] {\n  padding: 0.085859rem 0.146465rem;\n  font-size: 0.080808rem;\n  font-weight: 500;\n  color: #333333;\n  line-height: 0.111111rem;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 0.005051rem solid #dfdfdf;\n}\n.e2e-content-box .home-search-box[data-v-fc17aeaa] {\n  padding: 0.040404rem 0.505051rem 0.121212rem 0.20202rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.e2e-form .e2e-form-row[data-v-fc17aeaa] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 0.040404rem;\n}\n.e2e-form-group .e2e-form-label[data-v-fc17aeaa] {\n  padding: 0.040404rem 0 0.060606rem 0;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #666666;\n  line-height: 0.121212rem;\n  letter-spacing: 0.005051rem;\n}\n.e2e-form-group .e2e-form-item[data-v-fc17aeaa] {\n  width: 100%;\n  line-height: 0.121212rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n  letter-spacing: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.custom-btn[data-v-fc17aeaa] {\n  width: 0.484848rem;\n  background-color: #ff4d4f;\n}\n.custom-btn-search[data-v-fc17aeaa] {\n  width: 0.606061rem;\n}\n.custom-btn-slot-search[data-v-fc17aeaa] {\n  width: 0.363636rem;\n}\n.e2e-table-index-box .cell[data-v-fc17aeaa] {\n  overflow: visible;\n}\n.e2e-red-point[data-v-fc17aeaa],\n.e2e-red-point-left[data-v-fc17aeaa] {\n  position: relative;\n}\n.e2e-red-point[data-v-fc17aeaa]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  right: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-red-point-left[data-v-fc17aeaa]::before {\n  content: ' ';\n  border: 0.015152rem solid #ff4d4f;\n  /*设置红色*/\n  background-color: #ff4d4f;\n  border-radius: 0.015152rem;\n  /*设置圆角*/\n  position: absolute;\n  z-index: 1000;\n  left: 0%;\n  top: 0;\n  margin-right: -0.015152rem;\n  margin-top: -0.015152rem;\n}\n.e2e-module-nav-container[data-v-fc17aeaa] {\n  margin-top: 0.121212rem;\n}\n.e2e-input-small[data-v-fc17aeaa] input {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem;\n  padding-left: 0.045455rem;\n  border-radius: 0.010101rem;\n}\n.e2e-input-small .el-input__inner[data-v-fc17aeaa] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.e2e-input-small[data-v-fc17aeaa] input::-webkit-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-fc17aeaa] input::-moz-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-fc17aeaa] input::-ms-input-placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-fc17aeaa] input::placeholder {\n  font-size: 0.060606rem;\n  font-weight: 400;\n  color: #999999;\n}\n.e2e-input-small[data-v-fc17aeaa] .el-input__icon {\n  line-height: 0.161616rem;\n}\n.e2e-input-gray[data-v-fc17aeaa] input {\n  background: #efefef;\n}\n.e2e-radio-large[data-v-fc17aeaa] .el-radio__inner {\n  width: 0.10101rem;\n  height: 0.10101rem;\n}\n.e2e-link[data-v-fc17aeaa] {\n  color: #0091FF;\n  cursor: pointer;\n}\n.e2e-money[data-v-fc17aeaa] {\n  color: #0B41CD;\n}\n.e2e-copy[data-v-fc17aeaa] {\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: baseline;\n  display: inline-block;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  right: 100%;\n  top: 35%;\n  cursor: pointer;\n}\n.e2e-copy[data-v-fc17aeaa]:before {\n  content: '\\E787';\n}\n.e2e-warning[data-v-fc17aeaa] {\n  color: #e02020;\n}\n.e2e-warning-blue[data-v-fc17aeaa] {\n  color: #0091FF;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th[data-v-fc17aeaa],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th[data-v-fc17aeaa] {\n  background-color: #f6f6f6;\n}\n.e2e_table_wrapper.el-table .el-table__header-wrapper table thead tr th .cell[data-v-fc17aeaa],\n.e2e_table_wrapper.el-table .el-table__fixed-header-wrapper table thead tr th .cell[data-v-fc17aeaa] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell[data-v-fc17aeaa],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell[data-v-fc17aeaa] {\n  word-break: keep-all;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-fc17aeaa],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text span[data-v-fc17aeaa] {\n  color: #0091ff;\n  font-size: 0.065657rem;\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-fc17aeaa],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.is-disabled span[data-v-fc17aeaa] {\n  color: rgba(0, 0, 0, 0.25);\n}\n.e2e_table_wrapper.el-table .el-table__body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-fc17aeaa],\n.e2e_table_wrapper.el-table .el-table__fixed-body-wrapper .el-table__body tbody tr td .cell .el-button.el-button--text.danger span[data-v-fc17aeaa] {\n  color: #f56c6c;\n}\n.e2e_actionbtn_item[data-v-fc17aeaa] {\n  color: #0091ff;\n}\n.e2e_actionbtn_item.el-button[data-v-fc17aeaa] {\n  font-size: 0.065657rem;\n}\n.actiongroupborder[data-v-fc17aeaa] {\n  height: 0 !important;\n}\n.c-module-layout-container .c-module-nav-container[data-v-fc17aeaa] {\n  margin-top: 0.121212rem;\n}\n.el-button[data-v-fc17aeaa] {\n  padding: 0.025253rem 0.090909rem 0.025253rem 0.090909rem;\n  font-size: 0.070707rem;\n  font-weight: 400;\n  line-height: 0.111111rem;\n  letter-spacing: 0;\n  height: 0.161616rem;\n}\n.el-button.is-round[data-v-fc17aeaa] {\n  padding: 0.020202rem 0.050505rem 0.020202rem 0.050505rem;\n}\n.el-button.el-button--mini[data-v-fc17aeaa] {\n  font-size: 0.060606rem;\n  padding: 0.020202rem 0.040404rem 0.020202rem 0.040404rem;\n}\n.el-button--primary[data-v-fc17aeaa] {\n  background-color: #0B41CD;\n  color: #fff;\n  border-color: #0B41CD;\n}\n.el-button--primary[data-v-fc17aeaa]:hover,\n.el-button--primary[data-v-fc17aeaa]:active,\n.el-button--primary[data-v-fc17aeaa]:focus {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-fc17aeaa] {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain[data-v-fc17aeaa]:hover,\n.el-button--primary.is-plain[data-v-fc17aeaa]:active,\n.el-button--primary.is-plain[data-v-fc17aeaa]:focus {\n  background-color: #fff;\n  color: #0B41CD;\n  border-color: #0B41CD;\n}\n.el-button--primary.is-plain.is-disabled[data-v-fc17aeaa] {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-plain.is-disabled[data-v-fc17aeaa]:hover,\n.el-button--primary.is-plain.is-disabled[data-v-fc17aeaa]:active,\n.el-button--primary.is-plain.is-disabled[data-v-fc17aeaa]:focus {\n  background-color: rgba(255, 255, 255, 0.7);\n  color: rgba(11, 65, 205, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-fc17aeaa] {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--primary.is-disabled[data-v-fc17aeaa]:hover,\n.el-button--primary.is-disabled[data-v-fc17aeaa]:active,\n.el-button--primary.is-disabled[data-v-fc17aeaa]:focus {\n  background-color: rgba(11, 65, 205, 0.7);\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(11, 65, 205, 0.7);\n}\n.el-button--default[data-v-fc17aeaa] {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--default[data-v-fc17aeaa]:hover,\n.el-button--default[data-v-fc17aeaa]:active,\n.el-button--default[data-v-fc17aeaa]:focus {\n  background-color: #fff;\n  color: #333333;\n  border-color: #CCCCCC;\n}\n.el-button--text[data-v-fc17aeaa] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n  padding: 0%;\n}\n.el-button--text[data-v-fc17aeaa]:hover,\n.el-button--text[data-v-fc17aeaa]:active,\n.el-button--text[data-v-fc17aeaa]:focus {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #2d82f0;\n}\nbutton.el-button.el-button--text.is-disabled[data-v-fc17aeaa] {\n  color: #6D7278;\n}\n.operate .el-button + .el-button[data-v-fc17aeaa],\n.operate a + .el-button[data-v-fc17aeaa],\n.operate span + .el-button[data-v-fc17aeaa],\n.operate a + span[data-v-fc17aeaa] {\n  margin-left: 0.121212rem;\n}\n.operate span > div[data-v-fc17aeaa] {\n  display: inline-block;\n}\n.el-loading-mask.e2e-loading[data-v-fc17aeaa] {\n  z-index: 9999 !important;\n  background-color: transparent;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner[data-v-fc17aeaa] {\n  width: 0.606061rem;\n  height: 0.606061rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  border-radius: 0.050505rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-icon-loading[data-v-fc17aeaa] {\n  color: #fff;\n  font-size: 0.212121rem;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .path[data-v-fc17aeaa] {\n  stroke: #fff;\n}\n.el-loading-mask.e2e-loading .el-loading-spinner .el-loading-text[data-v-fc17aeaa] {\n  color: #fff;\n}\n.el-loading-mask[data-v-fc17aeaa] {\n  z-index: 9998;\n}\n.el-input__inner[data-v-fc17aeaa] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n  border-color: #DCDEE2;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n}\n.el-input__inner[data-v-fc17aeaa]::-webkit-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-fc17aeaa]::-moz-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-fc17aeaa]::-ms-input-placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n.el-input__inner[data-v-fc17aeaa]::placeholder {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #999999;\n}\n:-ms-input-placeholder.el-input__inner[data-v-fc17aeaa] {\n  color: #999;\n}\n:-ms-input-placeholder.el-textarea__inner[data-v-fc17aeaa] {\n  color: #999;\n}\n.is-disabled.el-input[data-v-fc17aeaa] :-ms-input-placeholder {\n  color: #999;\n}\n.is-disabled.el-textarea :-ms-input-placeholder.el-textarea__inner[data-v-fc17aeaa] {\n  color: #999;\n}\n.el-select-dropdown[data-v-fc17aeaa] {\n  max-width: 100%;\n}\n.el-select .el-input .el-select__caret[data-v-fc17aeaa] {\n  color: #666666;\n  line-height: 0.161616rem;\n}\n.el-form-item[data-v-fc17aeaa] {\n  margin-top: 0;\n  margin-right: 0 !important;\n  margin-left: 0;\n  margin-bottom: 0;\n}\n.el-form-item .el-form-item__label[data-v-fc17aeaa] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: #333333;\n}\n.el-form--label-top .el-form-item__label[data-v-fc17aeaa] {\n  padding: 0;\n}\n.header-menu-dropdown[data-v-fc17aeaa] {\n  background-color: #0B41CD;\n  border-color: #0B41CD;\n  min-width: 0.808081rem;\n  padding: 0;\n  border: 0;\n  margin-top: 0.040404rem !important;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-fc17aeaa] {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.070707rem;\n  font-weight: 400;\n  padding: 0.045455rem 0.080808rem 0.045455rem 0.080808rem;\n  line-height: 0.111111rem;\n}\n.header-menu-dropdown .el-dropdown-menu__item[data-v-fc17aeaa]:not(.is-disabled):hover {\n  background-color: transparent;\n  color: #fff;\n}\n.header-menu-dropdown .popper__arrow[data-v-fc17aeaa] {\n  display: none;\n}\n.el-table th > .cell[data-v-fc17aeaa] {\n  font-weight: bold !important;\n}\n.el-table .cell[data-v-fc17aeaa] {\n  color: #333333;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-table .el-table-column--selection .cell[data-v-fc17aeaa] {\n  padding-left: 0.070707rem;\n}\n.el-table td[data-v-fc17aeaa] {\n  border-bottom: 0.005051rem solid #EDEDED !important;\n}\n.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-fc17aeaa]::before {\n  top: 0.030303rem;\n}\n.el-table .el-checkbox__input.is-checked .el-checkbox__inner[data-v-fc17aeaa]::after {\n  top: 0.010101rem;\n  left: 0.025253rem;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td[data-v-fc17aeaa] {\n  background-color: rgba(45, 130, 240, 0.07) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text[data-v-fc17aeaa] {\n  color: rgba(45, 130, 240, 0.7) !important;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td .el-button--text.is-disabled[data-v-fc17aeaa] {\n  color: rgba(109, 114, 120, 0.7) !important;\n}\n.el-checkbox__inner[data-v-fc17aeaa] {\n  border: 0.005051rem solid #DCDEE2;\n  height: 0.080808rem;\n  width: 0.080808rem;\n}\n.el-pagination[data-v-fc17aeaa] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-select .el-input[data-v-fc17aeaa] {\n  margin: 0 0.080808rem;\n}\n.el-pagination .el-select .el-input .el-input__inner[data-v-fc17aeaa] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__total[data-v-fc17aeaa] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  margin-right: 0.093434rem;\n}\n.el-pagination .btn-prev[data-v-fc17aeaa],\n.el-pagination .btn-next[data-v-fc17aeaa] {\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n  background: #ffffff;\n  border: 0.005051rem solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.010101rem;\n  padding: 0%;\n}\n.el-pagination .btn-prev span[data-v-fc17aeaa],\n.el-pagination .btn-next span[data-v-fc17aeaa] {\n  min-width: 0.161616rem;\n  width: 0.161616rem;\n  height: 0.161616rem;\n}\n.el-pagination .el-pagination__sizes[data-v-fc17aeaa] {\n  margin-right: 0;\n}\n.el-pagination .el-pagination__sizes .el-select .el-input[data-v-fc17aeaa] {\n  width: 0.484848rem !important;\n}\n.el-pagination .el-pagination__jump[data-v-fc17aeaa] {\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem !important;\n  margin-left: 0 !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor[data-v-fc17aeaa] {\n  margin: 0 0.050505rem 0 0.040404rem;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input[data-v-fc17aeaa] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pagination__jump .el-pagination__editor.el-input .el-input__inner[data-v-fc17aeaa] {\n  min-width: 0.161616rem !important;\n  width: 0.161616rem !important;\n  height: 0.161616rem !important;\n  line-height: 0.161616rem !important;\n}\n.el-pagination .el-pager[data-v-fc17aeaa] {\n  margin: 0 0.020202rem;\n}\n.el-pagination .el-pager li:not(.disabled).active[data-v-fc17aeaa] {\n  background-color: #fff;\n  border: solid 0.005051rem #2d82f0;\n  padding: 0;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  color: #2d82f0;\n  font-weight: 400;\n  font-size: 0.070707rem;\n}\n.el-pagination .el-pager li[data-v-fc17aeaa] {\n  background-color: #fff;\n  border: solid 0.005051rem rgba(0, 0, 0, 0.15);\n  color: #666666;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  padding: 0;\n  margin: 0 0.020202rem;\n  min-width: 0.161616rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  border-radius: 0.020202rem;\n}\n.el-pagination .el-pager li.active + li[data-v-fc17aeaa] {\n  border-left: solid 0.005051rem rgba(0, 0, 0, 0.15) !important;\n}\n.system-notice .el-alert[data-v-fc17aeaa] {\n  background-color: #FFFBE6;\n  border-radius: 0;\n  height: 0.20202rem;\n  border: 0.005051rem solid #ffe58f;\n}\n.system-notice .el-alert .el-alert__icon[data-v-fc17aeaa] {\n  color: #FAAD14;\n  width: 0.070707rem;\n  height: 0.070707rem;\n  line-height: 0.070707rem;\n}\n.system-notice .el-alert .el-alert__content[data-v-fc17aeaa] {\n  font-size: 0.070707rem;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.65);\n}\n.system-notice .el-alert .el-alert__content .el-alert__description[data-v-fc17aeaa] {\n  margin-top: 0;\n}\n.system-notice .el-alert__icon.is-big[data-v-fc17aeaa] {\n  font-size: initial;\n}\n.menu-main-badge .el-badge__content.is-fixed.is-dot[data-v-fc17aeaa] {\n  top: 0.151515rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.menu-sub-badge .el-badge__content.is-fixed.is-dot[data-v-fc17aeaa] {\n  top: 0.025253rem;\n  right: -0.015152rem;\n  height: 0.050505rem;\n  width: 0.050505rem;\n  border: 0;\n  background: #ff4d4f;\n}\n.header-item-messagebox .el-badge__content.is-fixed[data-v-fc17aeaa] {\n  background: #ff4d4f;\n  border: 0.005051rem solid #ff4d4f;\n  line-height: 0.088384rem;\n}\n.el-input-number__decrease[data-v-fc17aeaa] {\n  line-height: 0.075758rem;\n  bottom: 0.020202rem;\n}\n.el-input-number__increase[data-v-fc17aeaa] {\n  line-height: 0.075758rem;\n  top: 0.020202rem;\n}\n.el-dialog__wrapper[data-v-fc17aeaa] {\n  display: grid;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.el-dialog__wrapper .el-dialog[data-v-fc17aeaa] {\n  border-radius: 0.020202rem;\n}\n.el-drawer[data-v-fc17aeaa] {\n  overflow: auto;\n}\n.common-confirm-dialog[data-v-fc17aeaa] {\n  width: 2.272727rem !important;\n  min-height: 1.515152rem !important;\n  height: auto !important;\n}\n.common-confirm-dialog .el-dialog__body[data-v-fc17aeaa] {\n  padding: 0;\n  min-height: 0.818182rem;\n}\n.tips-form-class .common-confirm-dialog[data-v-fc17aeaa] {\n  width: 3.030303rem !important;\n}\n.approval-dialog[data-v-fc17aeaa] {\n  width: 2.272727rem !important;\n  height: 1.717172rem !important;\n}\n.approval-dialog .el-dialog__body[data-v-fc17aeaa] {\n  padding: 0;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-fc17aeaa] {\n  height: 0.909091rem;\n  background-color: #F8F8F8;\n  border-color: #eeeeee;\n}\n.approval-dialog .el-dialog__body .apprvoal-reason textarea[data-v-fc17aeaa]::-webkit-input-placeholder {\n  color: #999999;\n}\n.approval-dialog .el-dialog__footer[data-v-fc17aeaa] {\n  bottom: 0.060606rem;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.approval-dialog .el-dialog__footer .el-button[data-v-fc17aeaa] {\n  width: 0.484848rem;\n}\n.common-crud-dialog .el-dialog[data-v-fc17aeaa] {\n  width: auto;\n}\n.common-crud-dialog .el-dialog .el-dialog__header[data-v-fc17aeaa] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body[data-v-fc17aeaa] {\n  padding: 0;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .edit-form-title[data-v-fc17aeaa] {\n  padding: 0.131313rem 0 0 0.171717rem;\n  color: #0066CC;\n  font-size: 0.080808rem;\n  display: block;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row[data-v-fc17aeaa] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .col-full[data-v-fc17aeaa] {\n  width: 3.838384rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col[data-v-fc17aeaa] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__label[data-v-fc17aeaa] {\n  height: 0.121212rem;\n  line-height: 0.121212rem;\n  color: #666666;\n  font-size: 0.070707rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content[data-v-fc17aeaa] {\n  padding-top: 0.010101rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-select[data-v-fc17aeaa],\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col .el-form-item__content .el-input[data-v-fc17aeaa] {\n  width: 1.111111rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-top .el-row .el-col + .el-col[data-v-fc17aeaa] {\n  margin-left: 0.252525rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__body .el-form.el-form--label-right .el-row[data-v-fc17aeaa] {\n  padding: 0.106061rem 0.171717rem 0 0.171717rem;\n}\n.common-crud-dialog .el-dialog .el-dialog__footer[data-v-fc17aeaa] {\n  padding: 0.20202rem;\n}\n.main-block-contain-budget .cny-input[data-v-fc17aeaa] {\n  margin: -0.015152rem 0 0 0.080808rem;\n}\n.main-block-contain-budget .cny-input .el-input__inner[data-v-fc17aeaa] {\n  width: 0.707071rem;\n}\n.main-edit-confirm .el-dialog__header[data-v-fc17aeaa] {\n  padding-top: 0.111111rem;\n  padding-left: 0.191919rem;\n}\n.main-edit-confirm .el-dialog__header .el-dialog__title[data-v-fc17aeaa] {\n  font-size: 0.080808rem;\n  color: #333333;\n}\n.main-edit-confirm .el-dialog__body[data-v-fc17aeaa] {\n  padding-top: 0.040404rem;\n  padding-bottom: 0.020202rem;\n}\n.main-edit-confirm .el-dialog__footer[data-v-fc17aeaa] {\n  text-align: center;\n}\n.application-search-content-main-fields .active[data-v-fc17aeaa] {\n  color: #0b41cd;\n}\n.application-search-content-main-fields-year[data-v-fc17aeaa] {\n  width: 0.40404rem;\n}\n.application-search-content-main-fields-year .el-input__inner[data-v-fc17aeaa] {\n  border: none;\n  font-size: 0.080808rem;\n  padding-left: 0.040404rem;\n}\n.application-search-content-main-fields-year-items[data-v-fc17aeaa] {\n  font-size: 0.080808rem;\n}\n.application-search-content-main .el-form-item__content[data-v-fc17aeaa] {\n  font-size: 0.080808rem;\n  font-weight: bold;\n}\n.application-search-content-main-roles .el-form-item__content[data-v-fc17aeaa] {\n  width: 0.606061rem;\n}\n.advanced-search-dialog .el-dialog__header[data-v-fc17aeaa] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__body[data-v-fc17aeaa] {\n  padding: 0 0.10101rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor[data-v-fc17aeaa] {\n  width: 1.212121rem;\n  vertical-align: middle;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-icon-date[data-v-fc17aeaa] {\n  height: 0.161616rem !important;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range-separator[data-v-fc17aeaa] {\n  height: 0.161616rem !important;\n  margin-right: 0.060606rem;\n}\n.advanced-search-dialog .el-dialog__body .el-date-editor .el-range__close-icon[data-v-fc17aeaa] {\n  display: none;\n}\n.advanced-search-dialog .el-dialog__footer[data-v-fc17aeaa] {\n  padding: 0.136364rem;\n}\n.edit-meeting-plan .el-input-number input[data-v-fc17aeaa] {\n  text-align: left;\n}\n.edit-meeting-plan .el-select .el-tag[data-v-fc17aeaa] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.edit-meeting-plan .el-select .el-tag span[data-v-fc17aeaa] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 1.212121rem;\n  white-space: nowrap;\n}\n.edit-meeting-plan .el-select .el-tag i[data-v-fc17aeaa] {\n  margin-top: 0.010101rem;\n}\n.view-meeting-plan .not-required .el-form-item__label[data-v-fc17aeaa] {\n  margin-left: 0.050505rem;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-fc17aeaa] {\n  border-color: #0B41CD;\n  background: #fff;\n}\n.el-radio__input.is-checked .el-radio__inner[data-v-fc17aeaa]::after {\n  background-color: #0B41CD;\n  width: 0.030303rem;\n  height: 0.030303rem;\n}\n.el-radio__input.is-checked + .el-radio__label[data-v-fc17aeaa] {\n  color: #666666;\n}\n.el-radio__inner[data-v-fc17aeaa]:hover {\n  border-color: #0B41CD;\n}\n.el-form-item.is-error .el-radio-group .el-radio__inner[data-v-fc17aeaa] {\n  border-color: #E64100;\n}\n.el-form-item.is-error .el-radio-group label[data-v-fc17aeaa] {\n  color: #E64100;\n}\n.tox-tinymce-aux[data-v-fc17aeaa] {\n  z-index: 709826033 !important;\n}\n.el-tooltip__popper[data-v-fc17aeaa] {\n  width: 0.757576rem;\n}\n.custom-tooltip[data-v-fc17aeaa] {\n  width: 2.525253rem !important;\n}\n.tooltip-header-text i[data-v-fc17aeaa] {\n  margin-left: 0.025253rem;\n}\n.sys-privilege-edit-dialog .ad-search[data-v-fc17aeaa] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.common-upload-confirm .error-msg[data-v-fc17aeaa] {\n  line-height: 0.121212rem;\n  padding: 0 0.10101rem;\n}\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-fc17aeaa],\n.el-select__caret.el-input__icon.el-icon-circle-close[data-v-fc17aeaa]:hover,\n.el-input__icon.el-icon-circle-close[data-v-fc17aeaa],\n.el-input__icon.el-icon-circle-close[data-v-fc17aeaa]:hover {\n  color: #FB304D;\n}\n*[data-v-fc17aeaa],\n*[data-v-fc17aeaa]:before,\n*[data-v-fc17aeaa]:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-fc17aeaa],\ntextarea[data-v-fc17aeaa] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ninput[data-v-fc17aeaa]:focus {\n  outline: none;\n}\n.page-contain[data-v-fc17aeaa] {\n  margin-bottom: 0.10101rem;\n}\n.page-header[data-v-fc17aeaa] {\n  padding: 0.040404rem 0;\n  margin-top: -0.121212rem;\n  font-size: 0.080808rem;\n  font-weight: bold;\n  color: #666666;\n  line-height: 0.161616rem;\n  height: 0.242424rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.page-header-title[data-v-fc17aeaa] {\n  font-weight: 400;\n}\n.page-header-subinfo[data-v-fc17aeaa] {\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  margin-left: auto;\n  font-weight: 400;\n  font-size: 0.070707rem;\n  color: #0B41CD;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.page-header-subinfo i[data-v-fc17aeaa] {\n  margin-right: 0.040404rem;\n}\n.page-header-subinfo-role[data-v-fc17aeaa] {\n  width: 0.909091rem;\n}\n.page-header-subinfo-role label[data-v-fc17aeaa] {\n  margin-right: 0.050505rem;\n  color: #666666;\n}\n.page-header-subinfo-role div[data-v-fc17aeaa] {\n  width: 0.606061rem;\n}\n.search-content-main[data-v-fc17aeaa] {\n  display: inline-block;\n  margin-bottom: 0.030303rem;\n}\n.search-content-main .search-content-main-fields[data-v-fc17aeaa] {\n  float: left;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.search-content-main .search-content-main-fields .el-form-item + .el-form-item[data-v-fc17aeaa] {\n  margin-left: 0.080808rem;\n}\n.search-content-main .search-content-main-fields-year[data-v-fc17aeaa] {\n  width: 0.606061rem;\n}\n.search-content-main .search-content-main-fields-medicalField[data-v-fc17aeaa] {\n  width: 0.909091rem;\n}\n.search-content-main .search-content-main-fields-departId[data-v-fc17aeaa] {\n  width: 0.909091rem;\n}\n.search-content-main .search-content-main-fields + .search-content-main-fields[data-v-fc17aeaa] {\n  margin-top: 0.030303rem;\n}\n.search-content-other[data-v-fc17aeaa] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 0.282828rem;\n  background: #FFFFFF;\n  border-radius: 0.020202rem;\n  margin-bottom: 0.080808rem;\n  position: relative;\n}\n.search-content-other-rate-types[data-v-fc17aeaa] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: 0.121212rem;\n}\n.search-content-other-rate-types-item[data-v-fc17aeaa] {\n  line-height: 0.282828rem;\n  height: 0.282828rem;\n  font-size: 0.070707rem;\n  color: #333333;\n  width: 0.40404rem;\n  text-align: center;\n  cursor: pointer;\n}\n.search-content-other-rate-types-item.active[data-v-fc17aeaa] {\n  color: #0B41CD;\n  border-bottom: 0.015152rem solid #0B41CD;\n}\n.search-content-other-distribute-types[data-v-fc17aeaa] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  width: 0.646465rem;\n  background-color: #e8eaec;\n  border-radius: 0.080808rem;\n  margin-top: 0.060606rem;\n  position: absolute;\n  right: 0.121212rem;\n}\n.search-content-other-distribute-types-item[data-v-fc17aeaa] {\n  width: 0.323232rem;\n  height: 0.161616rem;\n  line-height: 0.161616rem;\n  font-size: 0.070707rem;\n  color: #333333;\n  border-radius: 0.080808rem;\n  text-align: center;\n  cursor: pointer;\n}\n.search-content-other-distribute-types-item.active[data-v-fc17aeaa] {\n  background-color: #0B41CD;\n  color: #ffffff;\n}\n.charts-row[data-v-fc17aeaa] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n}\n.charts-row .chart[data-v-fc17aeaa] {\n  height: 1.616162rem;\n  width: 2.989899rem;\n  background: #fff;\n}\n.charts-row .chart .title[data-v-fc17aeaa] {\n  color: #333333;\n  font-size: 0.090909rem;\n  margin: 0.075758rem 0 0 0.121212rem;\n}\n.charts-row .chart .title i[data-v-fc17aeaa] {\n  font-size: 0.080808rem;\n  margin-right: 0.030303rem;\n  color: rgba(11, 65, 205, 0.5);\n}\n.charts-row .chart-full[data-v-fc17aeaa] {\n  width: 100%;\n}\n.charts-row .chart-right[data-v-fc17aeaa] {\n  margin-left: 0.080808rem;\n}\n.charts-row .search-content-trend[data-v-fc17aeaa] {\n  position: absolute;\n  right: 0.121212rem;\n  top: 0.262626rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  z-index: 200;\n}\n.charts-row .search-content-trend-item[data-v-fc17aeaa] {\n  width: 0.30303rem;\n  height: 0.121212rem;\n  border: 0.005051rem solid #999999;\n  font-weight: 400;\n  color: #666666;\n  font-size: 0.060606rem;\n  text-align: center;\n  line-height: 0.121212rem;\n  cursor: pointer;\n}\n.charts-row .search-content-trend-item[data-v-fc17aeaa]:first-child {\n  border-radius: 0.020202rem 0 0 0.020202rem;\n}\n.charts-row .search-content-trend-item[data-v-fc17aeaa]:last-child {\n  border-radius: 0 0.020202rem 0.020202rem 0;\n}\n.charts-row .search-content-trend-item.active[data-v-fc17aeaa] {\n  border-color: #0B41CD;\n  color: #0B41CD;\n}\n.charts-row .search-content-trend .search-content-trend-item + .search-content-trend-item[data-v-fc17aeaa] {\n  margin-left: -0.005051rem;\n}\n.charts-row .search-content-trend .search-content-trend-item.active + .search-content-trend-item[data-v-fc17aeaa] {\n  border-left-color: #0B41CD;\n}\n.charts-row + .charts-row[data-v-fc17aeaa] {\n  margin-top: 0.080808rem;\n}\n.gauge-legend[data-v-fc17aeaa] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 0.080808rem 0 0 0.121212rem;\n  font-size: 0.060606rem;\n  color: #666666;\n}\n.gauge-legend-value[data-v-fc17aeaa] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: 0.060606rem;\n}\n.gauge-legend-value div[data-v-fc17aeaa] {\n  height: 0.045455rem;\n  width: 0.045455rem;\n  border-radius: 0.022727rem;\n  margin: 0.010101rem 0.040404rem 0 0;\n}\n.gauge-legend-value-1 div[data-v-fc17aeaa] {\n  background-color: #2D82F0;\n}\n.gauge-legend-value-2 div[data-v-fc17aeaa] {\n  background-color: #E8EAEC;\n}\n.gauge-legend-value-3 div[data-v-fc17aeaa] {\n  background-color: #0B41CD;\n}\n.axis-label[data-v-fc17aeaa] {\n  height: 0;\n}\n.axis-label-0[data-v-fc17aeaa] {\n  position: relative;\n  top: 0.732323rem;\n  left: 0.378788rem;\n  font-size: 0.070707rem;\n  color: rgba(0, 0, 0, 0.45);\n}\n.axis-label-100[data-v-fc17aeaa] {\n  position: relative;\n  top: 0.732323rem;\n  left: 0.984848rem;\n  font-size: 0.070707rem;\n  color: rgba(0, 0, 0, 0.45);\n}\n.axis-label-remain[data-v-fc17aeaa] {\n  position: relative;\n  top: 0.580808rem;\n  left: 0.858586rem;\n  font-size: 0.080808rem;\n  color: #333333;\n  font-weight: bold;\n  width: 0.181818rem;\n}\n.message-info[data-v-fc17aeaa] {\n  margin-top: -0.176768rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 0.20202rem;\n  font-size: 0.060606rem;\n  color: #333333;\n  line-height: 0.10101rem;\n}\n.message-info div[data-v-fc17aeaa] {\n  margin: 0 auto;\n}", ""]);

// exports


/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_extension_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__ = __webpack_require__(1338);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "version", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "dependencies", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PRIORITY", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "init", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "disConnect", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "disconnect", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "dispose", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getInstanceByDom", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getInstanceById", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "registerTheme", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "registerPreprocessor", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "registerProcessor", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "registerPostInit", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "registerPostUpdate", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "registerUpdateLifecycle", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "registerAction", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "registerCoordinateSystem", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCoordinateSystemDimensions", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "registerLocale", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "registerLayout", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "registerVisual", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "registerLoading", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setCanvasCreator", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "registerMap", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getMap", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "registerTransform", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "dataTool", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "zrender", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "matrix", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "vector", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["E"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "zrUtil", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["F"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "color", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["G"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["H"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "helper", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["I"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "use", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["J"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setPlatformAPI", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["K"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "parseGeoJSON", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["L"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "parseGeoJson", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["M"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "number", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["N"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "time", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["O"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "graphic", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["P"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "format", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["Q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "util", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["R"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "env", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["S"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "List", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["T"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Model", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["U"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Axis", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["V"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ComponentModel", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["W"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ComponentView", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["X"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "SeriesModel", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["Y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ChartView", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["Z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "innerDrawElementOnCanvas", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["_0"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "extendComponentModel", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["_1"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "extendComponentView", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["_2"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "extendSeriesModel", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["_3"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "extendChartView", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_export_core_js__["_4"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_export_renderers_js__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_export_features_js__ = __webpack_require__(1339);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

 // ----------------------------------------------
// All of the modules that are allowed to be
// imported are listed below.
//
// Users MUST NOT import other modules that are
// not included in this list.
// ----------------------------------------------




 // -----------------
// Render engines
// -----------------
// Render via Canvas.
// echarts.init(dom, null, { renderer: 'canvas' })

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])([__WEBPACK_IMPORTED_MODULE_2__lib_export_renderers_js__["a" /* CanvasRenderer */]]); // Render via SVG.
// echarts.init(dom, null, { renderer: 'svg' })

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])([__WEBPACK_IMPORTED_MODULE_2__lib_export_renderers_js__["b" /* SVGRenderer */]]); // ----------------
// Charts (series)
// ----------------
// All of the series types, for example:
// chart.setOption({
//     series: [{
//         type: 'line' // or 'bar', 'pie', ...
//     }]
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])([__WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["a" /* LineChart */], __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["b" /* BarChart */], __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["c" /* PieChart */], __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["d" /* ScatterChart */], __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["e" /* RadarChart */], __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["f" /* MapChart */], __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["g" /* TreeChart */], __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["h" /* TreemapChart */], __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["i" /* GraphChart */], __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["j" /* GaugeChart */], __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["k" /* FunnelChart */], __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["l" /* ParallelChart */], __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["m" /* SankeyChart */], __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["n" /* BoxplotChart */], __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["o" /* CandlestickChart */], __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["p" /* EffectScatterChart */], __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["q" /* LinesChart */], __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["r" /* HeatmapChart */], __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["s" /* PictorialBarChart */], __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["t" /* ThemeRiverChart */], __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["u" /* SunburstChart */], __WEBPACK_IMPORTED_MODULE_3__lib_export_charts_js__["v" /* CustomChart */]]); // -------------------
// Coordinate systems
// -------------------
// All of the axis modules have been included in the
// coordinate system module below, do not need to
// make extra import.
// `cartesian` coordinate system. For some historical
// reasons, it is named as grid, for example:
// chart.setOption({
//     grid: {...},
//     xAxis: {...},
//     yAxis: {...},
//     series: [{...}]
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["a" /* GridComponent */]); // `polar` coordinate system, for example:
// chart.setOption({
//     polar: {...},
//     radiusAxis: {...},
//     angleAxis: {...},
//     series: [{
//         coordinateSystem: 'polar'
//     }]
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["b" /* PolarComponent */]); // `geo` coordinate system, for example:
// chart.setOption({
//     geo: {...},
//     series: [{
//         coordinateSystem: 'geo'
//     }]
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["c" /* GeoComponent */]); // `singleAxis` coordinate system (notice, it is a coordinate system
// with only one axis, work for chart like theme river), for example:
// chart.setOption({
//     singleAxis: {...}
//     series: [{type: 'themeRiver', ...}]
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["d" /* SingleAxisComponent */]); // `parallel` coordinate system, only work for parallel series, for example:
// chart.setOption({
//     parallel: {...},
//     parallelAxis: [{...}, ...],
//     series: [{
//         type: 'parallel'
//     }]
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["e" /* ParallelComponent */]); // `calendar` coordinate system. for example,
// chart.setOptionp({
//     calendar: {...},
//     series: [{
//         coordinateSystem: 'calendar'
//     }]
// );

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["f" /* CalendarComponent */]); // ------------------
// Other components
// ------------------
// `graphic` component, for example:
// chart.setOption({
//     graphic: {...}
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["g" /* GraphicComponent */]); // `toolbox` component, for example:
// chart.setOption({
//     toolbox: {...}
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["h" /* ToolboxComponent */]); // `tooltip` component, for example:
// chart.setOption({
//     tooltip: {...}
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["i" /* TooltipComponent */]); // `axisPointer` component, for example:
// chart.setOption({
//     tooltip: {axisPointer: {...}, ...}
// });
// Or
// chart.setOption({
//     axisPointer: {...}
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["j" /* AxisPointerComponent */]); // `brush` component, for example:
// chart.setOption({
//     brush: {...}
// });
// Or
// chart.setOption({
//     tooltip: {feature: {brush: {...}}
// })

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["k" /* BrushComponent */]); // `title` component, for example:
// chart.setOption({
//     title: {...}
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["l" /* TitleComponent */]); // `timeline` component, for example:
// chart.setOption({
//     timeline: {...}
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["m" /* TimelineComponent */]); // `markPoint` component, for example:
// chart.setOption({
//     series: [{markPoint: {...}}]
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["n" /* MarkPointComponent */]); // `markLine` component, for example:
// chart.setOption({
//     series: [{markLine: {...}}]
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["o" /* MarkLineComponent */]); // `markArea` component, for example:
// chart.setOption({
//     series: [{markArea: {...}}]
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["p" /* MarkAreaComponent */]); // `legend` component not scrollable. for example:
// chart.setOption({
//     legend: {...}
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["q" /* LegendComponent */]); // `dataZoom` component including both `dataZoomInside` and `dataZoomSlider`.

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["r" /* DataZoomComponent */]); // `dataZoom` component providing drag, pinch, wheel behaviors
// inside coodinate system, for example:
// chart.setOption({
//     dataZoom: {type: 'inside'}
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["s" /* DataZoomInsideComponent */]); // `dataZoom` component providing a slider bar, for example:
// chart.setOption({
//     dataZoom: {type: 'slider'}
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["t" /* DataZoomSliderComponent */]); // `visualMap` component including both `visualMapContinuous` and `visualMapPiecewise`.

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["u" /* VisualMapComponent */]); // `visualMap` component providing continuous bar, for example:
// chart.setOption({
//     visualMap: {type: 'continuous'}
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["v" /* VisualMapContinuousComponent */]); // `visualMap` component providing pieces bar, for example:
// chart.setOption({
//     visualMap: {type: 'piecewise'}
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["w" /* VisualMapPiecewiseComponent */]); // `aria` component providing aria, for example:
// chart.setOption({
//     aria: {...}
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["x" /* AriaComponent */]); // dataset transform
// chart.setOption({
//     dataset: {
//          transform: []
//     }
// });

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["y" /* TransformComponent */]);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__lib_export_components_js__["z" /* DatasetComponent */]); // universal transition
// chart.setOption({
//     series: {
//         universalTransition: { enabled: true }
//     }
// })

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_5__lib_export_features_js__["a" /* UniversalTransition */]); // label layout
// chart.setOption({
//     series: {
//         labelLayout: { hideOverlap: true }
//     }
// })

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_5__lib_export_features_js__["b" /* LabelLayout */]);

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMorphAnimation;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPathList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_tool_morphPath_js__ = __webpack_require__(1719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__basicTrasition_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_tool_path_js__ = __webpack_require__(205);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






function isMultiple(elements) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isArray"])(elements[0]);
}

function prepareMorphBatches(one, many) {
  var batches = [];
  var batchCount = one.length;

  for (var i = 0; i < batchCount; i++) {
    batches.push({
      one: one[i],
      many: []
    });
  }

  for (var i = 0; i < many.length; i++) {
    var len = many[i].length;
    var k = void 0;

    for (k = 0; k < len; k++) {
      batches[k % batchCount].many.push(many[i][k]);
    }
  }

  var off = 0; // If one has more paths than each one of many. average them.

  for (var i = batchCount - 1; i >= 0; i--) {
    if (!batches[i].many.length) {
      var moveFrom = batches[off].many;

      if (moveFrom.length <= 1) {
        // Not enough
        // Start from the first one.
        if (off) {
          off = 0;
        } else {
          return batches;
        }
      }

      var len = moveFrom.length;
      var mid = Math.ceil(len / 2);
      batches[i].many = moveFrom.slice(mid, len);
      batches[off].many = moveFrom.slice(0, mid);
      off++;
    }
  }

  return batches;
}

var pathDividers = {
  clone: function (params) {
    var ret = []; // Fitting the alpha

    var approxOpacity = 1 - Math.pow(1 - params.path.style.opacity, 1 / params.count);

    for (var i = 0; i < params.count; i++) {
      var cloned = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_tool_path_js__["d" /* clonePath */])(params.path);
      cloned.setStyle('opacity', approxOpacity);
      ret.push(cloned);
    }

    return ret;
  },
  // Use the default divider
  split: null
};
function applyMorphAnimation(from, to, divideShape, seriesModel, dataIndex, animateOtherProps) {
  if (!from.length || !to.length) {
    return;
  }

  var updateAnimationCfg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__basicTrasition_js__["d" /* getAnimationConfig */])('update', seriesModel, dataIndex);

  if (!(updateAnimationCfg && updateAnimationCfg.duration > 0)) {
    return;
  }

  var animationDelay = seriesModel.getModel('universalTransition').get('delay');
  var animationCfg = Object.assign({
    // Need to setToFinal so the further calculation based on the style can be correct.
    // Like emphasis color.
    setToFinal: true
  }, updateAnimationCfg);
  var many;
  var one;

  if (isMultiple(from)) {
    // manyToOne
    many = from;
    one = to;
  }

  if (isMultiple(to)) {
    // oneToMany
    many = to;
    one = from;
  }

  function morphOneBatch(batch, fromIsMany, animateIndex, animateCount, forceManyOne) {
    var batchMany = batch.many;
    var batchOne = batch.one;

    if (batchMany.length === 1 && !forceManyOne) {
      // Is one to one
      var batchFrom = fromIsMany ? batchMany[0] : batchOne;
      var batchTo = fromIsMany ? batchOne : batchMany[0];

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_tool_morphPath_js__["a" /* isCombineMorphing */])(batchFrom)) {
        // Keep doing combine animation.
        morphOneBatch({
          many: [batchFrom],
          one: batchTo
        }, true, animateIndex, animateCount, true);
      } else {
        var individualAnimationCfg = animationDelay ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["defaults"])({
          delay: animationDelay(animateIndex, animateCount)
        }, animationCfg) : animationCfg;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_tool_morphPath_js__["b" /* morphPath */])(batchFrom, batchTo, individualAnimationCfg);
        animateOtherProps(batchFrom, batchTo, batchFrom, batchTo, individualAnimationCfg);
      }
    } else {
      var separateAnimationCfg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["defaults"])({
        dividePath: pathDividers[divideShape],
        individualDelay: animationDelay && function (idx, count, fromPath, toPath) {
          return animationDelay(idx + animateIndex, animateCount);
        }
      }, animationCfg);

      var _a = fromIsMany ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_tool_morphPath_js__["c" /* combineMorph */])(batchMany, batchOne, separateAnimationCfg) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_tool_morphPath_js__["d" /* separateMorph */])(batchOne, batchMany, separateAnimationCfg),
          fromIndividuals = _a.fromIndividuals,
          toIndividuals = _a.toIndividuals;

      var count = fromIndividuals.length;

      for (var k = 0; k < count; k++) {
        var individualAnimationCfg = animationDelay ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["defaults"])({
          delay: animationDelay(k, count)
        }, animationCfg) : animationCfg;
        animateOtherProps(fromIndividuals[k], toIndividuals[k], fromIsMany ? batchMany[k] : batch.one, fromIsMany ? batch.one : batchMany[k], individualAnimationCfg);
      }
    }
  }

  var fromIsMany = many ? many === from // Is one to one. If the path number not match. also needs do merge and separate morphing.
  : from.length > to.length;
  var morphBatches = many ? prepareMorphBatches(one, many) : prepareMorphBatches(fromIsMany ? to : from, [fromIsMany ? from : to]);
  var animateCount = 0;

  for (var i = 0; i < morphBatches.length; i++) {
    animateCount += morphBatches[i].many.length;
  }

  var animateIndex = 0;

  for (var i = 0; i < morphBatches.length; i++) {
    morphOneBatch(morphBatches[i], fromIsMany, animateIndex, animateCount);
    animateIndex += morphBatches[i].many.length;
  }
}
function getPathList(elements) {
  if (!elements) {
    return [];
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isArray"])(elements)) {
    var pathList_1 = [];

    for (var i = 0; i < elements.length; i++) {
      pathList_1.push(getPathList(elements[i]));
    }

    return pathList_1;
  }

  var pathList = [];
  elements.traverse(function (el) {
    if (el instanceof __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Path"] && !el.disableMorphing && !el.invisible && !el.ignore) {
      pathList.push(el);
    }
  });
  return pathList;
}

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = installUniversalTransition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_Series_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__morphTransitionHelper_js__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_graphic_Path_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_DataDiffer_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_log_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__basicTrasition_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_zrender_lib_graphic_Displayable_js__ = __webpack_require__(68);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Universal transitions that can animate between any shapes(series) and any properties in any amounts.










var DATA_COUNT_THRESHOLD = 1e4;
;
var getUniversalTransitionGlobalStore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_model_js__["a" /* makeInner */])();

function getGroupIdDimension(data) {
  var dimensions = data.dimensions;

  for (var i = 0; i < dimensions.length; i++) {
    var dimInfo = data.getDimensionInfo(dimensions[i]);

    if (dimInfo && dimInfo.otherDims.itemGroupId === 0) {
      return dimensions[i];
    }
  }
}

function flattenDataDiffItems(list) {
  var items = [];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(list, function (seriesInfo) {
    var data = seriesInfo.data;

    if (data.count() > DATA_COUNT_THRESHOLD) {
      if (true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_log_js__["b" /* warn */])('Universal transition is disabled on large data > 10k.');
      }

      return;
    }

    var indices = data.getIndices();
    var groupDim = getGroupIdDimension(data);

    for (var dataIndex = 0; dataIndex < indices.length; dataIndex++) {
      items.push({
        data: data,
        dim: seriesInfo.dim || groupDim,
        divide: seriesInfo.divide,
        dataIndex: dataIndex
      });
    }
  });
  return items;
}

function fadeInElement(newEl, newSeries, newIndex) {
  newEl.traverse(function (el) {
    if (el instanceof __WEBPACK_IMPORTED_MODULE_3_zrender_lib_graphic_Path_js__["a" /* default */]) {
      // TODO use fade in animation for target element.
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["initProps"])(el, {
        style: {
          opacity: 0
        }
      }, newSeries, {
        dataIndex: newIndex,
        isFrom: true
      });
    }
  });
}

function removeEl(el) {
  if (el.parent) {
    // Bake parent transform to element.
    // So it can still have proper transform to transition after it's removed.
    var computedTransform = el.getComputedTransform();
    el.setLocalTransform(computedTransform);
    el.parent.remove(el);
  }
}

function stopAnimation(el) {
  el.stopAnimation();

  if (el.isGroup) {
    el.traverse(function (child) {
      child.stopAnimation();
    });
  }
}

function animateElementStyles(el, dataIndex, seriesModel) {
  var animationConfig = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__basicTrasition_js__["d" /* getAnimationConfig */])('update', seriesModel, dataIndex);
  animationConfig && el.traverse(function (child) {
    if (child instanceof __WEBPACK_IMPORTED_MODULE_9_zrender_lib_graphic_Displayable_js__["c" /* default */]) {
      var oldStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__basicTrasition_js__["e" /* getOldStyle */])(child);

      if (oldStyle) {
        child.animateFrom({
          style: oldStyle
        }, animationConfig);
      }
    }
  });
}

function isAllIdSame(oldDiffItems, newDiffItems) {
  var len = oldDiffItems.length;

  if (len !== newDiffItems.length) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    var oldItem = oldDiffItems[i];
    var newItem = newDiffItems[i];

    if (oldItem.data.getId(oldItem.dataIndex) !== newItem.data.getId(newItem.dataIndex)) {
      return false;
    }
  }

  return true;
}

function transitionBetween(oldList, newList, api) {
  var oldDiffItems = flattenDataDiffItems(oldList);
  var newDiffItems = flattenDataDiffItems(newList);

  function updateMorphingPathProps(from, to, rawFrom, rawTo, animationCfg) {
    if (rawFrom || from) {
      to.animateFrom({
        style: rawFrom && rawFrom !== from ? // dividingMethod like clone may override the style(opacity)
        // So extend it to raw style.
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])({}, rawFrom.style), from.style) : from.style
      }, animationCfg);
    }
  }

  function findKeyDim(items) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].dim) {
        return items[i].dim;
      }
    }
  }

  var oldKeyDim = findKeyDim(oldDiffItems);
  var newKeyDim = findKeyDim(newDiffItems);
  var hasMorphAnimation = false;

  function createKeyGetter(isOld, onlyGetId) {
    return function (diffItem) {
      var data = diffItem.data;
      var dataIndex = diffItem.dataIndex; // TODO if specified dim

      if (onlyGetId) {
        return data.getId(dataIndex);
      } // Use group id as transition key by default.
      // So we can achieve multiple to multiple animation like drilldown / up naturally.
      // If group id not exits. Use id instead. If so, only one to one transition will be applied.


      var dataGroupId = data.hostModel && data.hostModel.get('dataGroupId'); // If specified key dimension(itemGroupId by default). Use this same dimension from other data.
      // PENDING: If only use key dimension of newData.

      var keyDim = isOld ? oldKeyDim || newKeyDim : newKeyDim || oldKeyDim;
      var dimInfo = keyDim && data.getDimensionInfo(keyDim);
      var dimOrdinalMeta = dimInfo && dimInfo.ordinalMeta;

      if (dimInfo) {
        // Get from encode.itemGroupId.
        var key = data.get(dimInfo.name, dataIndex);

        if (dimOrdinalMeta) {
          return dimOrdinalMeta.categories[key] || key + '';
        }

        return key + '';
      } // Get groupId from raw item. { groupId: '' }


      var itemVal = data.getRawDataItem(dataIndex);

      if (itemVal && itemVal.groupId) {
        return itemVal.groupId + '';
      }

      return dataGroupId || data.getId(dataIndex);
    };
  } // Use id if it's very likely to be an one to one animation
  // It's more robust than groupId
  // TODO Check if key dimension is specified.


  var useId = isAllIdSame(oldDiffItems, newDiffItems);
  var isElementStillInChart = {};

  if (!useId) {
    // We may have different diff strategy with basicTransition if we use other dimension as key.
    // If so, we can't simply check if oldEl is same with newEl. We need a map to check if oldEl is still being used in the new chart.
    // We can't use the elements that already being morphed. Let it keep it's original basic transition.
    for (var i = 0; i < newDiffItems.length; i++) {
      var newItem = newDiffItems[i];
      var el = newItem.data.getItemGraphicEl(newItem.dataIndex);

      if (el) {
        isElementStillInChart[el.id] = true;
      }
    }
  }

  function updateOneToOne(newIndex, oldIndex) {
    var oldItem = oldDiffItems[oldIndex];
    var newItem = newDiffItems[newIndex];
    var newSeries = newItem.data.hostModel; // TODO Mark this elements is morphed and don't morph them anymore

    var oldEl = oldItem.data.getItemGraphicEl(oldItem.dataIndex);
    var newEl = newItem.data.getItemGraphicEl(newItem.dataIndex); // Can't handle same elements.

    if (oldEl === newEl) {
      newEl && animateElementStyles(newEl, newItem.dataIndex, newSeries);
      return;
    }

    if ( // We can't use the elements that already being morphed
    oldEl && isElementStillInChart[oldEl.id]) {
      return;
    }

    if (newEl) {
      // TODO: If keep animating the group in case
      // some of the elements don't want to be morphed.
      // TODO Label?
      stopAnimation(newEl);

      if (oldEl) {
        stopAnimation(oldEl); // If old element is doing leaving animation. stop it and remove it immediately.

        removeEl(oldEl);
        hasMorphAnimation = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__morphTransitionHelper_js__["a" /* applyMorphAnimation */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__morphTransitionHelper_js__["b" /* getPathList */])(oldEl), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__morphTransitionHelper_js__["b" /* getPathList */])(newEl), newItem.divide, newSeries, newIndex, updateMorphingPathProps);
      } else {
        fadeInElement(newEl, newSeries, newIndex);
      }
    } // else keep oldEl leaving animation.

  }

  new __WEBPACK_IMPORTED_MODULE_5__data_DataDiffer_js__["a" /* default */](oldDiffItems, newDiffItems, createKeyGetter(true, useId), createKeyGetter(false, useId), null, 'multiple').update(updateOneToOne).updateManyToOne(function (newIndex, oldIndices) {
    var newItem = newDiffItems[newIndex];
    var newData = newItem.data;
    var newSeries = newData.hostModel;
    var newEl = newData.getItemGraphicEl(newItem.dataIndex);
    var oldElsList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["filter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"])(oldIndices, function (idx) {
      return oldDiffItems[idx].data.getItemGraphicEl(oldDiffItems[idx].dataIndex);
    }), function (oldEl) {
      return oldEl && oldEl !== newEl && !isElementStillInChart[oldEl.id];
    });

    if (newEl) {
      stopAnimation(newEl);

      if (oldElsList.length) {
        // If old element is doing leaving animation. stop it and remove it immediately.
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(oldElsList, function (oldEl) {
          stopAnimation(oldEl);
          removeEl(oldEl);
        });
        hasMorphAnimation = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__morphTransitionHelper_js__["a" /* applyMorphAnimation */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__morphTransitionHelper_js__["b" /* getPathList */])(oldElsList), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__morphTransitionHelper_js__["b" /* getPathList */])(newEl), newItem.divide, newSeries, newIndex, updateMorphingPathProps);
      } else {
        fadeInElement(newEl, newSeries, newItem.dataIndex);
      }
    } // else keep oldEl leaving animation.

  }).updateOneToMany(function (newIndices, oldIndex) {
    var oldItem = oldDiffItems[oldIndex];
    var oldEl = oldItem.data.getItemGraphicEl(oldItem.dataIndex); // We can't use the elements that already being morphed

    if (oldEl && isElementStillInChart[oldEl.id]) {
      return;
    }

    var newElsList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["filter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"])(newIndices, function (idx) {
      return newDiffItems[idx].data.getItemGraphicEl(newDiffItems[idx].dataIndex);
    }), function (el) {
      return el && el !== oldEl;
    });
    var newSeris = newDiffItems[newIndices[0]].data.hostModel;

    if (newElsList.length) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(newElsList, function (newEl) {
        return stopAnimation(newEl);
      });

      if (oldEl) {
        stopAnimation(oldEl); // If old element is doing leaving animation. stop it and remove it immediately.

        removeEl(oldEl);
        hasMorphAnimation = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__morphTransitionHelper_js__["a" /* applyMorphAnimation */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__morphTransitionHelper_js__["b" /* getPathList */])(oldEl), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__morphTransitionHelper_js__["b" /* getPathList */])(newElsList), oldItem.divide, // Use divide on old.
        newSeris, newIndices[0], updateMorphingPathProps);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(newElsList, function (newEl) {
          return fadeInElement(newEl, newSeris, newIndices[0]);
        });
      }
    } // else keep oldEl leaving animation.

  }).updateManyToMany(function (newIndices, oldIndices) {
    // If two data are same and both have groupId.
    // Normally they should be diff by id.
    new __WEBPACK_IMPORTED_MODULE_5__data_DataDiffer_js__["a" /* default */](oldIndices, newIndices, function (rawIdx) {
      return oldDiffItems[rawIdx].data.getId(oldDiffItems[rawIdx].dataIndex);
    }, function (rawIdx) {
      return newDiffItems[rawIdx].data.getId(newDiffItems[rawIdx].dataIndex);
    }).update(function (newIndex, oldIndex) {
      // Use the original index
      updateOneToOne(newIndices[newIndex], oldIndices[oldIndex]);
    }).execute();
  }).execute();

  if (hasMorphAnimation) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(newList, function (_a) {
      var data = _a.data;
      var seriesModel = data.hostModel;
      var view = seriesModel && api.getViewOfSeriesModel(seriesModel);
      var animationCfg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__basicTrasition_js__["d" /* getAnimationConfig */])('update', seriesModel, 0); // use 0 index.

      if (view && seriesModel.isAnimationEnabled() && animationCfg && animationCfg.duration > 0) {
        view.group.traverse(function (el) {
          if (el instanceof __WEBPACK_IMPORTED_MODULE_3_zrender_lib_graphic_Path_js__["a" /* default */] && !el.animators.length) {
            // We can't accept there still exists element that has no animation
            // if universalTransition is enabled
            el.animateFrom({
              style: {
                opacity: 0
              }
            }, animationCfg);
          }
        });
      }
    });
  }
}

function getSeriesTransitionKey(series) {
  var seriesKey = series.getModel('universalTransition').get('seriesKey');

  if (!seriesKey) {
    // Use series id by default.
    return series.id;
  }

  return seriesKey;
}

function convertArraySeriesKeyToString(seriesKey) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(seriesKey)) {
    // Order independent.
    return seriesKey.sort().join(',');
  }

  return seriesKey;
}

function getDivideShapeFromData(data) {
  if (data.hostModel) {
    return data.hostModel.getModel('universalTransition').get('divideShape');
  }
}

function findTransitionSeriesBatches(globalStore, params) {
  var updateBatches = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"])();
  var oldDataMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"])(); // Map that only store key in array seriesKey.
  // Which is used to query the old data when transition from one to multiple series.

  var oldDataMapForSplit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(globalStore.oldSeries, function (series, idx) {
    var oldData = globalStore.oldData[idx];
    var transitionKey = getSeriesTransitionKey(series);
    var transitionKeyStr = convertArraySeriesKeyToString(transitionKey);
    oldDataMap.set(transitionKeyStr, oldData);

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(transitionKey)) {
      // Same key can't in different array seriesKey.
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(transitionKey, function (key) {
        oldDataMapForSplit.set(key, {
          data: oldData,
          key: transitionKeyStr
        });
      });
    }
  });

  function checkTransitionSeriesKeyDuplicated(transitionKeyStr) {
    if (updateBatches.get(transitionKeyStr)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_log_js__["b" /* warn */])("Duplicated seriesKey in universalTransition " + transitionKeyStr);
    }
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(params.updatedSeries, function (series) {
    if (series.isUniversalTransitionEnabled() && series.isAnimationEnabled()) {
      var newData = series.getData();
      var transitionKey = getSeriesTransitionKey(series);
      var transitionKeyStr = convertArraySeriesKeyToString(transitionKey); // Only transition between series with same id.

      var oldData = oldDataMap.get(transitionKeyStr); // string transition key is the best match.

      if (oldData) {
        if (true) {
          checkTransitionSeriesKeyDuplicated(transitionKeyStr);
        } // TODO check if data is same?


        updateBatches.set(transitionKeyStr, {
          oldSeries: [{
            divide: getDivideShapeFromData(oldData),
            data: oldData
          }],
          newSeries: [{
            divide: getDivideShapeFromData(newData),
            data: newData
          }]
        });
      } else {
        // Transition from multiple series.
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(transitionKey)) {
          if (true) {
            checkTransitionSeriesKeyDuplicated(transitionKeyStr);
          }

          var oldSeries_1 = [];
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(transitionKey, function (key) {
            var oldData = oldDataMap.get(key);

            if (oldData) {
              oldSeries_1.push({
                divide: getDivideShapeFromData(oldData),
                data: oldData
              });
            }
          });

          if (oldSeries_1.length) {
            updateBatches.set(transitionKeyStr, {
              oldSeries: oldSeries_1,
              newSeries: [{
                data: newData,
                divide: getDivideShapeFromData(newData)
              }]
            });
          }
        } else {
          // Try transition to multiple series.
          var oldData_1 = oldDataMapForSplit.get(transitionKey);

          if (oldData_1) {
            var batch = updateBatches.get(oldData_1.key);

            if (!batch) {
              batch = {
                oldSeries: [{
                  data: oldData_1.data,
                  divide: getDivideShapeFromData(oldData_1.data)
                }],
                newSeries: []
              };
              updateBatches.set(oldData_1.key, batch);
            }

            batch.newSeries.push({
              data: newData,
              divide: getDivideShapeFromData(newData)
            });
          }
        }
      }
    }
  });
  return updateBatches;
}

function querySeries(series, finder) {
  for (var i = 0; i < series.length; i++) {
    var found = finder.seriesIndex != null && finder.seriesIndex === series[i].seriesIndex || finder.seriesId != null && finder.seriesId === series[i].id;

    if (found) {
      return i;
    }
  }
}

function transitionSeriesFromOpt(transitionOpt, globalStore, params, api) {
  var from = [];
  var to = [];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_model_js__["d" /* normalizeToArray */])(transitionOpt.from), function (finder) {
    var idx = querySeries(globalStore.oldSeries, finder);

    if (idx >= 0) {
      from.push({
        data: globalStore.oldData[idx],
        // TODO can specify divideShape in transition.
        divide: getDivideShapeFromData(globalStore.oldData[idx]),
        dim: finder.dimension
      });
    }
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_model_js__["d" /* normalizeToArray */])(transitionOpt.to), function (finder) {
    var idx = querySeries(params.updatedSeries, finder);

    if (idx >= 0) {
      var data = params.updatedSeries[idx].getData();
      to.push({
        data: data,
        divide: getDivideShapeFromData(data),
        dim: finder.dimension
      });
    }
  });

  if (from.length > 0 && to.length > 0) {
    transitionBetween(from, to, api);
  }
}

function installUniversalTransition(registers) {
  registers.registerUpdateLifecycle('series:beforeupdate', function (ecMOdel, api, params) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_model_js__["d" /* normalizeToArray */])(params.seriesTransition), function (transOpt) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_model_js__["d" /* normalizeToArray */])(transOpt.to), function (finder) {
        var series = params.updatedSeries;

        for (var i = 0; i < series.length; i++) {
          if (finder.seriesIndex != null && finder.seriesIndex === series[i].seriesIndex || finder.seriesId != null && finder.seriesId === series[i].id) {
            series[i][__WEBPACK_IMPORTED_MODULE_0__model_Series_js__["a" /* SERIES_UNIVERSAL_TRANSITION_PROP */]] = true;
          }
        }
      });
    });
  });
  registers.registerUpdateLifecycle('series:transition', function (ecModel, api, params) {
    // TODO api provide an namespace that can save stuff per instance
    var globalStore = getUniversalTransitionGlobalStore(api); // TODO multiple to multiple series.

    if (globalStore.oldSeries && params.updatedSeries && params.optionChanged) {
      // Use give transition config if its' give;
      var transitionOpt = params.seriesTransition;

      if (transitionOpt) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_model_js__["d" /* normalizeToArray */])(transitionOpt), function (opt) {
          transitionSeriesFromOpt(opt, globalStore, params, api);
        });
      } else {
        // Else guess from series based on transition series key.
        var updateBatches_1 = findTransitionSeriesBatches(globalStore, params);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(updateBatches_1.keys(), function (key) {
          var batch = updateBatches_1.get(key);
          transitionBetween(batch.oldSeries, batch.newSeries, api);
        });
      } // Reset


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(params.updatedSeries, function (series) {
        // Reset;
        if (series[__WEBPACK_IMPORTED_MODULE_0__model_Series_js__["a" /* SERIES_UNIVERSAL_TRANSITION_PROP */]]) {
          series[__WEBPACK_IMPORTED_MODULE_0__model_Series_js__["a" /* SERIES_UNIVERSAL_TRANSITION_PROP */]] = false;
        }
      });
    } // Save all series of current update. Not only the updated one.


    var allSeries = ecModel.getSeries();
    var savedSeries = globalStore.oldSeries = [];
    var savedData = globalStore.oldData = [];

    for (var i = 0; i < allSeries.length; i++) {
      var data = allSeries[i].getData(); // Only save the data that can have transition.
      // Avoid large data costing too much extra memory

      if (data.count() < DATA_COUNT_THRESHOLD) {
        savedSeries.push(allSeries[i]);
        savedData.push(data);
      }
    }
  });
}

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseBarSeries_js__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_createSeriesData_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_component_js__ = __webpack_require__(49);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var BarSeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(BarSeriesModel, _super);

  function BarSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = BarSeriesModel.type;
    return _this;
  }

  BarSeriesModel.prototype.getInitialData = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_createSeriesData_js__["a" /* default */])(null, this, {
      useEncodeDefaulter: true,
      createInvertedIndices: !!this.get('realtimeSort', true) || null
    });
  };
  /**
   * @override
   */


  BarSeriesModel.prototype.getProgressive = function () {
    // Do not support progressive in normal mode.
    return this.get('large') ? this.get('progressive') : false;
  };
  /**
   * @override
   */


  BarSeriesModel.prototype.getProgressiveThreshold = function () {
    // Do not support progressive in normal mode.
    var progressiveThreshold = this.get('progressiveThreshold');
    var largeThreshold = this.get('largeThreshold');

    if (largeThreshold > progressiveThreshold) {
      progressiveThreshold = largeThreshold;
    }

    return progressiveThreshold;
  };

  BarSeriesModel.prototype.brushSelector = function (dataIndex, data, selectors) {
    return selectors.rect(data.getItemLayout(dataIndex));
  };

  BarSeriesModel.type = 'series.bar';
  BarSeriesModel.dependencies = ['grid', 'polar'];
  BarSeriesModel.defaultOption = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_component_js__["d" /* inheritDefaultOption */])(__WEBPACK_IMPORTED_MODULE_1__BaseBarSeries_js__["a" /* default */].defaultOption, {
    // If clipped
    // Only available on cartesian2d
    clip: true,
    roundCap: false,
    showBackground: false,
    backgroundStyle: {
      color: 'rgba(180, 180, 180, 0.2)',
      borderColor: null,
      borderWidth: 0,
      borderType: 'solid',
      borderRadius: 0,
      shadowBlur: 0,
      shadowColor: null,
      shadowOffsetX: 0,
      shadowOffsetY: 0,
      opacity: 1
    },
    select: {
      itemStyle: {
        borderColor: '#212121'
      }
    },
    realtimeSort: false
  });
  return BarSeriesModel;
}(__WEBPACK_IMPORTED_MODULE_1__BaseBarSeries_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (BarSeriesModel);

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_graphic_Path_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_graphic_Group_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_throttle_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helper_createClipPathFromCoordSys_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_shape_sausage_js__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__coord_CoordinateSystem_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helper_labelHelper_js__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_log_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__label_sectorLabel_js__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__animation_basicTrasition_js__ = __webpack_require__(40);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

















var mathMax = Math.max;
var mathMin = Math.min;

function getClipArea(coord, data) {
  var coordSysClipArea = coord.getArea && coord.getArea();

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__coord_CoordinateSystem_js__["a" /* isCoordinateSystemType */])(coord, 'cartesian2d')) {
    var baseAxis = coord.getBaseAxis(); // When boundaryGap is false or using time axis. bar may exceed the grid.
    // We should not clip this part.
    // See test/bar2.html

    if (baseAxis.type !== 'category' || !baseAxis.onBand) {
      var expandWidth = data.getLayout('bandWidth');

      if (baseAxis.isHorizontal()) {
        coordSysClipArea.x -= expandWidth;
        coordSysClipArea.width += expandWidth * 2;
      } else {
        coordSysClipArea.y -= expandWidth;
        coordSysClipArea.height += expandWidth * 2;
      }
    }
  }

  return coordSysClipArea;
}

var BarView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(BarView, _super);

  function BarView() {
    var _this = _super.call(this) || this;

    _this.type = BarView.type;
    _this._isFirstFrame = true;
    return _this;
  }

  BarView.prototype.render = function (seriesModel, ecModel, api, payload) {
    this._model = seriesModel;

    this._removeOnRenderedListener(api);

    this._updateDrawMode(seriesModel);

    var coordinateSystemType = seriesModel.get('coordinateSystem');

    if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') {
      // Clear previously rendered progressive elements.
      this._progressiveEls = null;
      this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api, payload);
    } else if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_log_js__["b" /* warn */])('Only cartesian2d and polar supported for bar.');
    }
  };

  BarView.prototype.incrementalPrepareRender = function (seriesModel) {
    this._clear();

    this._updateDrawMode(seriesModel); // incremental also need to clip, otherwise might be overlow.
    // But must not set clip in each frame, otherwise all of the children will be marked redraw.


    this._updateLargeClip(seriesModel);
  };

  BarView.prototype.incrementalRender = function (params, seriesModel) {
    // Reset
    this._progressiveEls = []; // Do not support progressive in normal mode.

    this._incrementalRenderLarge(params, seriesModel);
  };

  BarView.prototype.eachRendered = function (cb) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["traverseElements"])(this._progressiveEls || this.group, cb);
  };

  BarView.prototype._updateDrawMode = function (seriesModel) {
    var isLargeDraw = seriesModel.pipelineContext.large;

    if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
      this._isLargeDraw = isLargeDraw;

      this._clear();
    }
  };

  BarView.prototype._renderNormal = function (seriesModel, ecModel, api, payload) {
    var group = this.group;
    var data = seriesModel.getData();
    var oldData = this._data;
    var coord = seriesModel.coordinateSystem;
    var baseAxis = coord.getBaseAxis();
    var isHorizontalOrRadial;

    if (coord.type === 'cartesian2d') {
      isHorizontalOrRadial = baseAxis.isHorizontal();
    } else if (coord.type === 'polar') {
      isHorizontalOrRadial = baseAxis.dim === 'angle';
    }

    var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
    var realtimeSortCfg = shouldRealtimeSort(seriesModel, coord);

    if (realtimeSortCfg) {
      this._enableRealtimeSort(realtimeSortCfg, data, api);
    }

    var needsClip = seriesModel.get('clip', true) || realtimeSortCfg;
    var coordSysClipArea = getClipArea(coord, data); // If there is clipPath created in large mode. Remove it.

    group.removeClipPath(); // We don't use clipPath in normal mode because we needs a perfect animation
    // And don't want the label are clipped.

    var roundCap = seriesModel.get('roundCap', true);
    var drawBackground = seriesModel.get('showBackground', true);
    var backgroundModel = seriesModel.getModel('backgroundStyle');
    var barBorderRadius = backgroundModel.get('borderRadius') || 0;
    var bgEls = [];
    var oldBgEls = this._backgroundEls;
    var isInitSort = payload && payload.isInitSort;
    var isChangeOrder = payload && payload.type === 'changeAxisOrder';

    function createBackground(dataIndex) {
      var bgLayout = getLayout[coord.type](data, dataIndex);
      var bgEl = createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
      bgEl.useStyle(backgroundModel.getItemStyle()); // Only cartesian2d support borderRadius.

      if (coord.type === 'cartesian2d') {
        bgEl.setShape('r', barBorderRadius);
      }

      bgEls[dataIndex] = bgEl;
      return bgEl;
    }

    ;
    data.diff(oldData).add(function (dataIndex) {
      var itemModel = data.getItemModel(dataIndex);
      var layout = getLayout[coord.type](data, dataIndex, itemModel);

      if (drawBackground) {
        createBackground(dataIndex);
      } // If dataZoom in filteMode: 'empty', the baseValue can be set as NaN in "axisProxy".


      if (!data.hasValue(dataIndex) || !isValidLayout[coord.type](layout)) {
        return;
      }

      var isClipped = false;

      if (needsClip) {
        // Clip will modify the layout params.
        // And return a boolean to determine if the shape are fully clipped.
        isClipped = clip[coord.type](coordSysClipArea, layout);
      }

      var el = elementCreator[coord.type](seriesModel, data, dataIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, false, roundCap);

      if (realtimeSortCfg) {
        /**
         * Force label animation because even if the element is
         * ignored because it's clipped, it may not be clipped after
         * changing order. Then, if not using forceLabelAnimation,
         * the label animation was never started, in which case,
         * the label will be the final value and doesn't have label
         * animation.
         */
        el.forceLabelAnimation = true;
      }

      updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');

      if (isInitSort) {
        el.attr({
          shape: layout
        });
      } else if (realtimeSortCfg) {
        updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, dataIndex, isHorizontalOrRadial, false, false);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["initProps"])(el, {
          shape: layout
        }, seriesModel, dataIndex);
      }

      data.setItemGraphicEl(dataIndex, el);
      group.add(el);
      el.ignore = isClipped;
    }).update(function (newIndex, oldIndex) {
      var itemModel = data.getItemModel(newIndex);
      var layout = getLayout[coord.type](data, newIndex, itemModel);

      if (drawBackground) {
        var bgEl = void 0;

        if (oldBgEls.length === 0) {
          bgEl = createBackground(oldIndex);
        } else {
          bgEl = oldBgEls[oldIndex];
          bgEl.useStyle(backgroundModel.getItemStyle()); // Only cartesian2d support borderRadius.

          if (coord.type === 'cartesian2d') {
            bgEl.setShape('r', barBorderRadius);
          }

          bgEls[newIndex] = bgEl;
        }

        var bgLayout = getLayout[coord.type](data, newIndex);
        var shape = createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["updateProps"])(bgEl, {
          shape: shape
        }, animationModel, newIndex);
      }

      var el = oldData.getItemGraphicEl(oldIndex);

      if (!data.hasValue(newIndex) || !isValidLayout[coord.type](layout)) {
        group.remove(el);
        return;
      }

      var isClipped = false;

      if (needsClip) {
        isClipped = clip[coord.type](coordSysClipArea, layout);

        if (isClipped) {
          group.remove(el);
        }
      }

      if (!el) {
        el = elementCreator[coord.type](seriesModel, data, newIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, !!el, roundCap);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__animation_basicTrasition_js__["f" /* saveOldStyle */])(el);
      }

      if (realtimeSortCfg) {
        el.forceLabelAnimation = true;
      }

      if (isChangeOrder) {
        var textEl = el.getTextContent();

        if (textEl) {
          var labelInnerStore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__["a" /* labelInner */])(textEl);

          if (labelInnerStore.prevValue != null) {
            /**
             * Set preValue to be value so that no new label
             * should be started, otherwise, it will take a full
             * `animationDurationUpdate` time to finish the
             * animation, which is not expected.
             */
            labelInnerStore.prevValue = labelInnerStore.value;
          }
        }
      } // Not change anything if only order changed.
      // Especially not change label.
      else {
          updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
        }

      if (isInitSort) {
        el.attr({
          shape: layout
        });
      } else if (realtimeSortCfg) {
        updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, newIndex, isHorizontalOrRadial, true, isChangeOrder);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["updateProps"])(el, {
          shape: layout
        }, seriesModel, newIndex, null);
      }

      data.setItemGraphicEl(newIndex, el);
      el.ignore = isClipped;
      group.add(el);
    }).remove(function (dataIndex) {
      var el = oldData.getItemGraphicEl(dataIndex);
      el && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["removeElementWithFadeOut"])(el, seriesModel, dataIndex);
    }).execute();
    var bgGroup = this._backgroundGroup || (this._backgroundGroup = new __WEBPACK_IMPORTED_MODULE_2_zrender_lib_graphic_Group_js__["a" /* default */]());
    bgGroup.removeAll();

    for (var i = 0; i < bgEls.length; ++i) {
      bgGroup.add(bgEls[i]);
    }

    group.add(bgGroup);
    this._backgroundEls = bgEls;
    this._data = data;
  };

  BarView.prototype._renderLarge = function (seriesModel, ecModel, api) {
    this._clear();

    createLarge(seriesModel, this.group);

    this._updateLargeClip(seriesModel);
  };

  BarView.prototype._incrementalRenderLarge = function (params, seriesModel) {
    this._removeBackground();

    createLarge(seriesModel, this.group, this._progressiveEls, true);
  };

  BarView.prototype._updateLargeClip = function (seriesModel) {
    // Use clipPath in large mode.
    var clipPath = seriesModel.get('clip', true) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_createClipPathFromCoordSys_js__["a" /* createClipPath */])(seriesModel.coordinateSystem, false, seriesModel);
    var group = this.group;

    if (clipPath) {
      group.setClipPath(clipPath);
    } else {
      group.removeClipPath();
    }
  };

  BarView.prototype._enableRealtimeSort = function (realtimeSortCfg, data, api) {
    var _this = this; // If no data in the first frame, wait for data to initSort


    if (!data.count()) {
      return;
    }

    var baseAxis = realtimeSortCfg.baseAxis;

    if (this._isFirstFrame) {
      this._dispatchInitSort(data, realtimeSortCfg, api);

      this._isFirstFrame = false;
    } else {
      var orderMapping_1 = function (idx) {
        var el = data.getItemGraphicEl(idx);
        var shape = el && el.shape;
        return shape && // The result should be consistent with the initial sort by data value.
        // Do not support the case that both positive and negative exist.
        Math.abs(baseAxis.isHorizontal() ? shape.height : shape.width) // If data is NaN, shape.xxx may be NaN, so use || 0 here in case
        || 0;
      };

      this._onRendered = function () {
        _this._updateSortWithinSameData(data, orderMapping_1, baseAxis, api);
      };

      api.getZr().on('rendered', this._onRendered);
    }
  };

  BarView.prototype._dataSort = function (data, baseAxis, orderMapping) {
    var info = [];
    data.each(data.mapDimension(baseAxis.dim), function (ordinalNumber, dataIdx) {
      var mappedValue = orderMapping(dataIdx);
      mappedValue = mappedValue == null ? NaN : mappedValue;
      info.push({
        dataIndex: dataIdx,
        mappedValue: mappedValue,
        ordinalNumber: ordinalNumber
      });
    });
    info.sort(function (a, b) {
      // If NaN, it will be treated as min val.
      return b.mappedValue - a.mappedValue;
    });
    return {
      ordinalNumbers: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["map"])(info, function (item) {
        return item.ordinalNumber;
      })
    };
  };

  BarView.prototype._isOrderChangedWithinSameData = function (data, orderMapping, baseAxis) {
    var scale = baseAxis.scale;
    var ordinalDataDim = data.mapDimension(baseAxis.dim);
    var lastValue = Number.MAX_VALUE;

    for (var tickNum = 0, len = scale.getOrdinalMeta().categories.length; tickNum < len; ++tickNum) {
      var rawIdx = data.rawIndexOf(ordinalDataDim, scale.getRawOrdinalNumber(tickNum));
      var value = rawIdx < 0 // If some tick have no bar, the tick will be treated as min.
      ? Number.MIN_VALUE // PENDING: if dataZoom on baseAxis exits, is it a performance issue?
      : orderMapping(data.indexOfRawIndex(rawIdx));

      if (value > lastValue) {
        return true;
      }

      lastValue = value;
    }

    return false;
  };
  /*
   * Consider the case when A and B changed order, whose representing
   * bars are both out of sight, we don't wish to trigger reorder action
   * as long as the order in the view doesn't change.
   */


  BarView.prototype._isOrderDifferentInView = function (orderInfo, baseAxis) {
    var scale = baseAxis.scale;
    var extent = scale.getExtent();
    var tickNum = Math.max(0, extent[0]);
    var tickMax = Math.min(extent[1], scale.getOrdinalMeta().categories.length - 1);

    for (; tickNum <= tickMax; ++tickNum) {
      if (orderInfo.ordinalNumbers[tickNum] !== scale.getRawOrdinalNumber(tickNum)) {
        return true;
      }
    }
  };

  BarView.prototype._updateSortWithinSameData = function (data, orderMapping, baseAxis, api) {
    if (!this._isOrderChangedWithinSameData(data, orderMapping, baseAxis)) {
      return;
    }

    var sortInfo = this._dataSort(data, baseAxis, orderMapping);

    if (this._isOrderDifferentInView(sortInfo, baseAxis)) {
      this._removeOnRenderedListener(api);

      api.dispatchAction({
        type: 'changeAxisOrder',
        componentType: baseAxis.dim + 'Axis',
        axisId: baseAxis.index,
        sortInfo: sortInfo
      });
    }
  };

  BarView.prototype._dispatchInitSort = function (data, realtimeSortCfg, api) {
    var baseAxis = realtimeSortCfg.baseAxis;

    var sortResult = this._dataSort(data, baseAxis, function (dataIdx) {
      return data.get(data.mapDimension(realtimeSortCfg.otherAxis.dim), dataIdx);
    });

    api.dispatchAction({
      type: 'changeAxisOrder',
      componentType: baseAxis.dim + 'Axis',
      isInitSort: true,
      axisId: baseAxis.index,
      sortInfo: sortResult
    });
  };

  BarView.prototype.remove = function (ecModel, api) {
    this._clear(this._model);

    this._removeOnRenderedListener(api);
  };

  BarView.prototype.dispose = function (ecModel, api) {
    this._removeOnRenderedListener(api);
  };

  BarView.prototype._removeOnRenderedListener = function (api) {
    if (this._onRendered) {
      api.getZr().off('rendered', this._onRendered);
      this._onRendered = null;
    }
  };

  BarView.prototype._clear = function (model) {
    var group = this.group;
    var data = this._data;

    if (model && model.isAnimationEnabled() && data && !this._isLargeDraw) {
      this._removeBackground();

      this._backgroundEls = [];
      data.eachItemGraphicEl(function (el) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["removeElementWithFadeOut"])(el, model, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_innerStore_js__["a" /* getECData */])(el).dataIndex);
      });
    } else {
      group.removeAll();
    }

    this._data = null;
    this._isFirstFrame = true;
  };

  BarView.prototype._removeBackground = function () {
    this.group.remove(this._backgroundGroup);
    this._backgroundGroup = null;
  };

  BarView.type = 'bar';
  return BarView;
}(__WEBPACK_IMPORTED_MODULE_11__view_Chart_js__["a" /* default */]);

var clip = {
  cartesian2d: function (coordSysBoundingRect, layout) {
    var signWidth = layout.width < 0 ? -1 : 1;
    var signHeight = layout.height < 0 ? -1 : 1; // Needs positive width and height

    if (signWidth < 0) {
      layout.x += layout.width;
      layout.width = -layout.width;
    }

    if (signHeight < 0) {
      layout.y += layout.height;
      layout.height = -layout.height;
    }

    var coordSysX2 = coordSysBoundingRect.x + coordSysBoundingRect.width;
    var coordSysY2 = coordSysBoundingRect.y + coordSysBoundingRect.height;
    var x = mathMax(layout.x, coordSysBoundingRect.x);
    var x2 = mathMin(layout.x + layout.width, coordSysX2);
    var y = mathMax(layout.y, coordSysBoundingRect.y);
    var y2 = mathMin(layout.y + layout.height, coordSysY2);
    var xClipped = x2 < x;
    var yClipped = y2 < y; // When xClipped or yClipped, the element will be marked as `ignore`.
    // But we should also place the element at the edge of the coord sys bounding rect.
    // Beause if data changed and the bar show again, its transition animaiton
    // will begin at this place.

    layout.x = xClipped && x > coordSysX2 ? x2 : x;
    layout.y = yClipped && y > coordSysY2 ? y2 : y;
    layout.width = xClipped ? 0 : x2 - x;
    layout.height = yClipped ? 0 : y2 - y; // Reverse back

    if (signWidth < 0) {
      layout.x += layout.width;
      layout.width = -layout.width;
    }

    if (signHeight < 0) {
      layout.y += layout.height;
      layout.height = -layout.height;
    }

    return xClipped || yClipped;
  },
  polar: function (coordSysClipArea, layout) {
    var signR = layout.r0 <= layout.r ? 1 : -1; // Make sure r is larger than r0

    if (signR < 0) {
      var tmp = layout.r;
      layout.r = layout.r0;
      layout.r0 = tmp;
    }

    var r = mathMin(layout.r, coordSysClipArea.r);
    var r0 = mathMax(layout.r0, coordSysClipArea.r0);
    layout.r = r;
    layout.r0 = r0;
    var clipped = r - r0 < 0; // Reverse back

    if (signR < 0) {
      var tmp = layout.r;
      layout.r = layout.r0;
      layout.r0 = tmp;
    }

    return clipped;
  }
};
var elementCreator = {
  cartesian2d: function (seriesModel, data, newIndex, layout, isHorizontal, animationModel, axisModel, isUpdate, roundCap) {
    var rect = new __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["Rect"]({
      shape: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["extend"])({}, layout),
      z2: 1
    });
    rect.__dataIndex = newIndex;
    rect.name = 'item';

    if (animationModel) {
      var rectShape = rect.shape;
      var animateProperty = isHorizontal ? 'height' : 'width';
      rectShape[animateProperty] = 0;
    }

    return rect;
  },
  polar: function (seriesModel, data, newIndex, layout, isRadial, animationModel, axisModel, isUpdate, roundCap) {
    var ShapeClass = !isRadial && roundCap ? __WEBPACK_IMPORTED_MODULE_10__util_shape_sausage_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["Sector"];
    var sector = new ShapeClass({
      shape: layout,
      z2: 1
    });
    sector.name = 'item';
    var positionMap = createPolarPositionMapping(isRadial);
    sector.calculateTextPosition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__label_sectorLabel_js__["a" /* createSectorCalculateTextPosition */])(positionMap, {
      isRoundCap: ShapeClass === __WEBPACK_IMPORTED_MODULE_10__util_shape_sausage_js__["a" /* default */]
    }); // Animation

    if (animationModel) {
      var sectorShape = sector.shape;
      var animateProperty = isRadial ? 'r' : 'endAngle';
      var animateTarget = {};
      sectorShape[animateProperty] = isRadial ? 0 : layout.startAngle;
      animateTarget[animateProperty] = layout[animateProperty];
      (isUpdate ? __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["updateProps"] : __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["initProps"])(sector, {
        shape: animateTarget // __value: typeof dataValue === 'string' ? parseInt(dataValue, 10) : dataValue

      }, animationModel);
    }

    return sector;
  }
};

function shouldRealtimeSort(seriesModel, coordSys) {
  var realtimeSortOption = seriesModel.get('realtimeSort', true);
  var baseAxis = coordSys.getBaseAxis();

  if (true) {
    if (realtimeSortOption) {
      if (baseAxis.type !== 'category') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_log_js__["b" /* warn */])('`realtimeSort` will not work because this bar series is not based on a category axis.');
      }

      if (coordSys.type !== 'cartesian2d') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_log_js__["b" /* warn */])('`realtimeSort` will not work because this bar series is not on cartesian2d.');
      }
    }
  }

  if (realtimeSortOption && baseAxis.type === 'category' && coordSys.type === 'cartesian2d') {
    return {
      baseAxis: baseAxis,
      otherAxis: coordSys.getOtherAxis(baseAxis)
    };
  }
}

function updateRealtimeAnimation(realtimeSortCfg, seriesAnimationModel, el, layout, newIndex, isHorizontal, isUpdate, isChangeOrder) {
  var seriesTarget;
  var axisTarget;

  if (isHorizontal) {
    axisTarget = {
      x: layout.x,
      width: layout.width
    };
    seriesTarget = {
      y: layout.y,
      height: layout.height
    };
  } else {
    axisTarget = {
      y: layout.y,
      height: layout.height
    };
    seriesTarget = {
      x: layout.x,
      width: layout.width
    };
  }

  if (!isChangeOrder) {
    // Keep the original growth animation if only axis order changed.
    // Not start a new animation.
    (isUpdate ? __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["updateProps"] : __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["initProps"])(el, {
      shape: seriesTarget
    }, seriesAnimationModel, newIndex, null);
  }

  var axisAnimationModel = seriesAnimationModel ? realtimeSortCfg.baseAxis.model : null;
  (isUpdate ? __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["updateProps"] : __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["initProps"])(el, {
    shape: axisTarget
  }, axisAnimationModel, newIndex);
}

function checkPropertiesNotValid(obj, props) {
  for (var i = 0; i < props.length; i++) {
    if (!isFinite(obj[props[i]])) {
      return true;
    }
  }

  return false;
}

var rectPropties = ['x', 'y', 'width', 'height'];
var polarPropties = ['cx', 'cy', 'r', 'startAngle', 'endAngle'];
var isValidLayout = {
  cartesian2d: function (layout) {
    return !checkPropertiesNotValid(layout, rectPropties);
  },
  polar: function (layout) {
    return !checkPropertiesNotValid(layout, polarPropties);
  }
};
var getLayout = {
  // itemModel is only used to get borderWidth, which is not needed
  // when calculating bar background layout.
  cartesian2d: function (data, dataIndex, itemModel) {
    var layout = data.getItemLayout(dataIndex);
    var fixedLineWidth = itemModel ? getLineWidth(itemModel, layout) : 0; // fix layout with lineWidth

    var signX = layout.width > 0 ? 1 : -1;
    var signY = layout.height > 0 ? 1 : -1;
    return {
      x: layout.x + signX * fixedLineWidth / 2,
      y: layout.y + signY * fixedLineWidth / 2,
      width: layout.width - signX * fixedLineWidth,
      height: layout.height - signY * fixedLineWidth
    };
  },
  polar: function (data, dataIndex, itemModel) {
    var layout = data.getItemLayout(dataIndex);
    return {
      cx: layout.cx,
      cy: layout.cy,
      r0: layout.r0,
      r: layout.r,
      startAngle: layout.startAngle,
      endAngle: layout.endAngle,
      clockwise: layout.clockwise
    };
  }
};

function isZeroOnPolar(layout) {
  return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
}

function createPolarPositionMapping(isRadial) {
  return function (isRadial) {
    var arcOrAngle = isRadial ? 'Arc' : 'Angle';
    return function (position) {
      switch (position) {
        case 'start':
        case 'insideStart':
        case 'end':
        case 'insideEnd':
          return position + arcOrAngle;

        default:
          return position;
      }
    };
  }(isRadial);
}

function updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, isPolar) {
  var style = data.getItemVisual(dataIndex, 'style');

  if (!isPolar) {
    el.setShape('r', itemModel.get(['itemStyle', 'borderRadius']) || 0);
  }

  el.useStyle(style);
  var cursorStyle = itemModel.getShallow('cursor');
  cursorStyle && el.attr('cursor', cursorStyle);
  var labelPositionOutside = isPolar ? isHorizontalOrRadial ? layout.r >= layout.r0 ? 'endArc' : 'startArc' : layout.endAngle >= layout.startAngle ? 'endAngle' : 'startAngle' : isHorizontalOrRadial ? layout.height >= 0 ? 'bottom' : 'top' : layout.width >= 0 ? 'right' : 'left';
  var labelStatesModels = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__["f" /* getLabelStatesModels */])(itemModel);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__["e" /* setLabelStyle */])(el, labelStatesModels, {
    labelFetcher: seriesModel,
    labelDataIndex: dataIndex,
    defaultText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__helper_labelHelper_js__["a" /* getDefaultLabel */])(seriesModel.getData(), dataIndex),
    inheritColor: style.fill,
    defaultOpacity: style.opacity,
    defaultOutsidePosition: labelPositionOutside
  });
  var label = el.getTextContent();

  if (isPolar && label) {
    var position = itemModel.get(['label', 'position']);
    el.textConfig.inside = position === 'middle' ? true : null;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__label_sectorLabel_js__["b" /* setSectorTextRotation */])(el, position === 'outside' ? labelPositionOutside : position, createPolarPositionMapping(isHorizontalOrRadial), itemModel.get(['label', 'rotate']));
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__["h" /* setLabelValueAnimation */])(label, labelStatesModels, seriesModel.getRawValue(dataIndex), function (value) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__helper_labelHelper_js__["b" /* getDefaultInterpolatedLabel */])(data, value);
  });
  var emphasisModel = itemModel.getModel(['emphasis']);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_states_js__["G" /* toggleHoverEmphasis */])(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_states_js__["F" /* setStatesStylesFromModel */])(el, itemModel);

  if (isZeroOnPolar(layout)) {
    el.style.fill = 'none';
    el.style.stroke = 'none';
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(el.states, function (state) {
      if (state.style) {
        state.style.fill = state.style.stroke = 'none';
      }
    });
  }
} // In case width or height are too small.


function getLineWidth(itemModel, rawLayout) {
  // Has no border.
  var borderColor = itemModel.get(['itemStyle', 'borderColor']);

  if (!borderColor || borderColor === 'none') {
    return 0;
  }

  var lineWidth = itemModel.get(['itemStyle', 'borderWidth']) || 0; // width or height may be NaN for empty data

  var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
  var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
  return Math.min(lineWidth, width, height);
}

var LagePathShape =
/** @class */
function () {
  function LagePathShape() {}

  return LagePathShape;
}();

var LargePath =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(LargePath, _super);

  function LargePath(opts) {
    var _this = _super.call(this, opts) || this;

    _this.type = 'largeBar';
    return _this;
  }

  LargePath.prototype.getDefaultShape = function () {
    return new LagePathShape();
  };

  LargePath.prototype.buildPath = function (ctx, shape) {
    // Drawing lines is more efficient than drawing
    // a whole line or drawing rects.
    var points = shape.points;
    var baseDimIdx = this.baseDimIdx;
    var valueDimIdx = 1 - this.baseDimIdx;
    var startPoint = [];
    var size = [];
    var barWidth = this.barWidth;

    for (var i = 0; i < points.length; i += 3) {
      size[baseDimIdx] = barWidth;
      size[valueDimIdx] = points[i + 2];
      startPoint[baseDimIdx] = points[i + baseDimIdx];
      startPoint[valueDimIdx] = points[i + valueDimIdx];
      ctx.rect(startPoint[0], startPoint[1], size[0], size[1]);
    }
  };

  return LargePath;
}(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_graphic_Path_js__["a" /* default */]);

function createLarge(seriesModel, group, progressiveEls, incremental) {
  // TODO support polar
  var data = seriesModel.getData();
  var baseDimIdx = data.getLayout('valueAxisHorizontal') ? 1 : 0;
  var largeDataIndices = data.getLayout('largeDataIndices');
  var barWidth = data.getLayout('size');
  var backgroundModel = seriesModel.getModel('backgroundStyle');
  var bgPoints = data.getLayout('largeBackgroundPoints');

  if (bgPoints) {
    var bgEl = new LargePath({
      shape: {
        points: bgPoints
      },
      incremental: !!incremental,
      silent: true,
      z2: 0
    });
    bgEl.baseDimIdx = baseDimIdx;
    bgEl.largeDataIndices = largeDataIndices;
    bgEl.barWidth = barWidth;
    bgEl.useStyle(backgroundModel.getItemStyle());
    group.add(bgEl);
    progressiveEls && progressiveEls.push(bgEl);
  }

  var el = new LargePath({
    shape: {
      points: data.getLayout('largePoints')
    },
    incremental: !!incremental,
    z2: 1
  });
  el.baseDimIdx = baseDimIdx;
  el.largeDataIndices = largeDataIndices;
  el.barWidth = barWidth;
  group.add(el);
  el.useStyle(data.getVisual('style')); // Enable tooltip and user mouse/touch event handlers.

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_innerStore_js__["a" /* getECData */])(el).seriesIndex = seriesModel.seriesIndex;

  if (!seriesModel.get('silent')) {
    el.on('mousedown', largePathUpdateDataIndex);
    el.on('mousemove', largePathUpdateDataIndex);
  }

  progressiveEls && progressiveEls.push(el);
} // Use throttle to avoid frequently traverse to find dataIndex.


var largePathUpdateDataIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_throttle_js__["c" /* throttle */])(function (event) {
  var largePath = this;
  var dataIndex = largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_innerStore_js__["a" /* getECData */])(largePath).dataIndex = dataIndex >= 0 ? dataIndex : null;
}, 30, false);

function largePathFindDataIndex(largePath, x, y) {
  var baseDimIdx = largePath.baseDimIdx;
  var valueDimIdx = 1 - baseDimIdx;
  var points = largePath.shape.points;
  var largeDataIndices = largePath.largeDataIndices;
  var startPoint = [];
  var size = [];
  var barWidth = largePath.barWidth;

  for (var i = 0, len = points.length / 3; i < len; i++) {
    var ii = i * 3;
    size[baseDimIdx] = barWidth;
    size[valueDimIdx] = points[ii + 2];
    startPoint[baseDimIdx] = points[ii + baseDimIdx];
    startPoint[valueDimIdx] = points[ii + valueDimIdx];

    if (size[valueDimIdx] < 0) {
      startPoint[valueDimIdx] += size[valueDimIdx];
      size[valueDimIdx] = -size[valueDimIdx];
    }

    if (x >= startPoint[0] && x <= startPoint[0] + size[0] && y >= startPoint[1] && y <= startPoint[1] + size[1]) {
      return largeDataIndices[i];
    }
  }

  return -1;
}

function createBackgroundShape(isHorizontalOrRadial, layout, coord) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__coord_CoordinateSystem_js__["a" /* isCoordinateSystemType */])(coord, 'cartesian2d')) {
    var rectShape = layout;
    var coordLayout = coord.getArea();
    return {
      x: isHorizontalOrRadial ? rectShape.x : coordLayout.x,
      y: isHorizontalOrRadial ? coordLayout.y : rectShape.y,
      width: isHorizontalOrRadial ? rectShape.width : coordLayout.width,
      height: isHorizontalOrRadial ? coordLayout.height : rectShape.height
    };
  } else {
    var coordLayout = coord.getArea();
    var sectorShape = layout;
    return {
      cx: coordLayout.cx,
      cy: coordLayout.cy,
      r0: isHorizontalOrRadial ? coordLayout.r0 : sectorShape.r0,
      r: isHorizontalOrRadial ? coordLayout.r : sectorShape.r,
      startAngle: isHorizontalOrRadial ? sectorShape.startAngle : 0,
      endAngle: isHorizontalOrRadial ? sectorShape.endAngle : Math.PI * 2
    };
  }
}

function createBackgroundEl(coord, isHorizontalOrRadial, layout) {
  var ElementClz = coord.type === 'polar' ? __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["Sector"] : __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["Rect"];
  return new ElementClz({
    shape: createBackgroundShape(isHorizontalOrRadial, layout, coord),
    silent: true,
    z2: 0
  });
}

/* harmony default export */ __webpack_exports__["a"] = (BarView);

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseBarSeries_js__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_component_js__ = __webpack_require__(49);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var PictorialBarSeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(PictorialBarSeriesModel, _super);

  function PictorialBarSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = PictorialBarSeriesModel.type;
    _this.hasSymbolVisual = true;
    _this.defaultSymbol = 'roundRect';
    return _this;
  }

  PictorialBarSeriesModel.prototype.getInitialData = function (option) {
    // Disable stack.
    option.stack = null;
    return _super.prototype.getInitialData.apply(this, arguments);
  };

  PictorialBarSeriesModel.type = 'series.pictorialBar';
  PictorialBarSeriesModel.dependencies = ['grid'];
  PictorialBarSeriesModel.defaultOption = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_component_js__["d" /* inheritDefaultOption */])(__WEBPACK_IMPORTED_MODULE_1__BaseBarSeries_js__["a" /* default */].defaultOption, {
    symbol: 'circle',
    symbolSize: null,
    symbolRotate: null,
    symbolPosition: null,
    symbolOffset: null,
    symbolMargin: null,
    symbolRepeat: false,
    symbolRepeatDirection: 'end',
    symbolClip: false,
    symbolBoundingData: null,
    symbolPatternSize: 400,
    barGap: '-100%',
    // z can be set in data item, which is z2 actually.
    // Disable progressive
    progressive: 0,
    emphasis: {
      // By default pictorialBar do not hover scale. Hover scale is not suitable
      // for the case that both has foreground and background.
      scale: false
    },
    select: {
      itemStyle: {
        borderColor: '#212121'
      }
    }
  });
  return PictorialBarSeriesModel;
}(__WEBPACK_IMPORTED_MODULE_1__BaseBarSeries_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PictorialBarSeriesModel);

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_symbol_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helper_labelHelper_js__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_zrender_lib_graphic_Image_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_innerStore_js__ = __webpack_require__(17);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/











var BAR_BORDER_WIDTH_QUERY = ['itemStyle', 'borderWidth']; // index: +isHorizontal

var LAYOUT_ATTRS = [{
  xy: 'x',
  wh: 'width',
  index: 0,
  posDesc: ['left', 'right']
}, {
  xy: 'y',
  wh: 'height',
  index: 1,
  posDesc: ['top', 'bottom']
}];
var pathForLineWidth = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Circle"]();

var PictorialBarView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(PictorialBarView, _super);

  function PictorialBarView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = PictorialBarView.type;
    return _this;
  }

  PictorialBarView.prototype.render = function (seriesModel, ecModel, api) {
    var group = this.group;
    var data = seriesModel.getData();
    var oldData = this._data;
    var cartesian = seriesModel.coordinateSystem;
    var baseAxis = cartesian.getBaseAxis();
    var isHorizontal = baseAxis.isHorizontal();
    var coordSysRect = cartesian.master.getRect();
    var opt = {
      ecSize: {
        width: api.getWidth(),
        height: api.getHeight()
      },
      seriesModel: seriesModel,
      coordSys: cartesian,
      coordSysExtent: [[coordSysRect.x, coordSysRect.x + coordSysRect.width], [coordSysRect.y, coordSysRect.y + coordSysRect.height]],
      isHorizontal: isHorizontal,
      valueDim: LAYOUT_ATTRS[+isHorizontal],
      categoryDim: LAYOUT_ATTRS[1 - +isHorizontal]
    };
    data.diff(oldData).add(function (dataIndex) {
      if (!data.hasValue(dataIndex)) {
        return;
      }

      var itemModel = getItemModel(data, dataIndex);
      var symbolMeta = getSymbolMeta(data, dataIndex, itemModel, opt);
      var bar = createBar(data, opt, symbolMeta);
      data.setItemGraphicEl(dataIndex, bar);
      group.add(bar);
      updateCommon(bar, opt, symbolMeta);
    }).update(function (newIndex, oldIndex) {
      var bar = oldData.getItemGraphicEl(oldIndex);

      if (!data.hasValue(newIndex)) {
        group.remove(bar);
        return;
      }

      var itemModel = getItemModel(data, newIndex);
      var symbolMeta = getSymbolMeta(data, newIndex, itemModel, opt);
      var pictorialShapeStr = getShapeStr(data, symbolMeta);

      if (bar && pictorialShapeStr !== bar.__pictorialShapeStr) {
        group.remove(bar);
        data.setItemGraphicEl(newIndex, null);
        bar = null;
      }

      if (bar) {
        updateBar(bar, opt, symbolMeta);
      } else {
        bar = createBar(data, opt, symbolMeta, true);
      }

      data.setItemGraphicEl(newIndex, bar);
      bar.__pictorialSymbolMeta = symbolMeta; // Add back

      group.add(bar);
      updateCommon(bar, opt, symbolMeta);
    }).remove(function (dataIndex) {
      var bar = oldData.getItemGraphicEl(dataIndex);
      bar && removeBar(oldData, dataIndex, bar.__pictorialSymbolMeta.animationModel, bar);
    }).execute();
    this._data = data;
    return this.group;
  };

  PictorialBarView.prototype.remove = function (ecModel, api) {
    var group = this.group;
    var data = this._data;

    if (ecModel.get('animation')) {
      if (data) {
        data.eachItemGraphicEl(function (bar) {
          removeBar(data, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_innerStore_js__["a" /* getECData */])(bar).dataIndex, ecModel, bar);
        });
      }
    } else {
      group.removeAll();
    }
  };

  PictorialBarView.type = 'pictorialBar';
  return PictorialBarView;
}(__WEBPACK_IMPORTED_MODULE_6__view_Chart_js__["a" /* default */]); // Set or calculate default value about symbol, and calculate layout info.


function getSymbolMeta(data, dataIndex, itemModel, opt) {
  var layout = data.getItemLayout(dataIndex);
  var symbolRepeat = itemModel.get('symbolRepeat');
  var symbolClip = itemModel.get('symbolClip');
  var symbolPosition = itemModel.get('symbolPosition') || 'start';
  var symbolRotate = itemModel.get('symbolRotate');
  var rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
  var symbolPatternSize = itemModel.get('symbolPatternSize') || 2;
  var isAnimationEnabled = itemModel.isAnimationEnabled();
  var symbolMeta = {
    dataIndex: dataIndex,
    layout: layout,
    itemModel: itemModel,
    symbolType: data.getItemVisual(dataIndex, 'symbol') || 'circle',
    style: data.getItemVisual(dataIndex, 'style'),
    symbolClip: symbolClip,
    symbolRepeat: symbolRepeat,
    symbolRepeatDirection: itemModel.get('symbolRepeatDirection'),
    symbolPatternSize: symbolPatternSize,
    rotation: rotation,
    animationModel: isAnimationEnabled ? itemModel : null,
    hoverScale: isAnimationEnabled && itemModel.get(['emphasis', 'scale']),
    z2: itemModel.getShallow('z', true) || 0
  };
  prepareBarLength(itemModel, symbolRepeat, layout, opt, symbolMeta);
  prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, symbolMeta.boundingLength, symbolMeta.pxSign, symbolPatternSize, opt, symbolMeta);
  prepareLineWidth(itemModel, symbolMeta.symbolScale, rotation, opt, symbolMeta);
  var symbolSize = symbolMeta.symbolSize;
  var symbolOffset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_symbol_js__["d" /* normalizeSymbolOffset */])(itemModel.get('symbolOffset'), symbolSize);
  prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, symbolMeta.valueLineWidth, symbolMeta.boundingLength, symbolMeta.repeatCutLength, opt, symbolMeta);
  return symbolMeta;
} // bar length can be negative.


function prepareBarLength(itemModel, symbolRepeat, layout, opt, outputSymbolMeta) {
  var valueDim = opt.valueDim;
  var symbolBoundingData = itemModel.get('symbolBoundingData');
  var valueAxis = opt.coordSys.getOtherAxis(opt.coordSys.getBaseAxis());
  var zeroPx = valueAxis.toGlobalCoord(valueAxis.dataToCoord(0));
  var pxSignIdx = 1 - +(layout[valueDim.wh] <= 0);
  var boundingLength;

  if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](symbolBoundingData)) {
    var symbolBoundingExtent = [convertToCoordOnAxis(valueAxis, symbolBoundingData[0]) - zeroPx, convertToCoordOnAxis(valueAxis, symbolBoundingData[1]) - zeroPx];
    symbolBoundingExtent[1] < symbolBoundingExtent[0] && symbolBoundingExtent.reverse();
    boundingLength = symbolBoundingExtent[pxSignIdx];
  } else if (symbolBoundingData != null) {
    boundingLength = convertToCoordOnAxis(valueAxis, symbolBoundingData) - zeroPx;
  } else if (symbolRepeat) {
    boundingLength = opt.coordSysExtent[valueDim.index][pxSignIdx] - zeroPx;
  } else {
    boundingLength = layout[valueDim.wh];
  }

  outputSymbolMeta.boundingLength = boundingLength;

  if (symbolRepeat) {
    outputSymbolMeta.repeatCutLength = layout[valueDim.wh];
  } // if 'pxSign' means sign of pixel,  it can't be zero, or symbolScale will be zero
  // and when borderWidth be settled, the actual linewidth will be NaN


  outputSymbolMeta.pxSign = boundingLength > 0 ? 1 : -1;
}

function convertToCoordOnAxis(axis, value) {
  return axis.toGlobalCoord(axis.dataToCoord(axis.scale.parse(value)));
} // Support ['100%', '100%']


function prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, boundingLength, pxSign, symbolPatternSize, opt, outputSymbolMeta) {
  var valueDim = opt.valueDim;
  var categoryDim = opt.categoryDim;
  var categorySize = Math.abs(layout[categoryDim.wh]);
  var symbolSize = data.getItemVisual(dataIndex, 'symbolSize');
  var parsedSymbolSize;

  if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](symbolSize)) {
    parsedSymbolSize = symbolSize.slice();
  } else {
    if (symbolSize == null) {
      // will parse to number below
      parsedSymbolSize = ['100%', '100%'];
    } else {
      parsedSymbolSize = [symbolSize, symbolSize];
    }
  } // Note: percentage symbolSize (like '100%') do not consider lineWidth, because it is
  // to complicated to calculate real percent value if considering scaled lineWidth.
  // So the actual size will bigger than layout size if lineWidth is bigger than zero,
  // which can be tolerated in pictorial chart.


  parsedSymbolSize[categoryDim.index] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_number_js__["a" /* parsePercent */])(parsedSymbolSize[categoryDim.index], categorySize);
  parsedSymbolSize[valueDim.index] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_number_js__["a" /* parsePercent */])(parsedSymbolSize[valueDim.index], symbolRepeat ? categorySize : Math.abs(boundingLength));
  outputSymbolMeta.symbolSize = parsedSymbolSize; // If x or y is less than zero, show reversed shape.

  var symbolScale = outputSymbolMeta.symbolScale = [parsedSymbolSize[0] / symbolPatternSize, parsedSymbolSize[1] / symbolPatternSize]; // Follow convention, 'right' and 'top' is the normal scale.

  symbolScale[valueDim.index] *= (opt.isHorizontal ? -1 : 1) * pxSign;
}

function prepareLineWidth(itemModel, symbolScale, rotation, opt, outputSymbolMeta) {
  // In symbols are drawn with scale, so do not need to care about the case that width
  // or height are too small. But symbol use strokeNoScale, where acture lineWidth should
  // be calculated.
  var valueLineWidth = itemModel.get(BAR_BORDER_WIDTH_QUERY) || 0;

  if (valueLineWidth) {
    pathForLineWidth.attr({
      scaleX: symbolScale[0],
      scaleY: symbolScale[1],
      rotation: rotation
    });
    pathForLineWidth.updateTransform();
    valueLineWidth /= pathForLineWidth.getLineScale();
    valueLineWidth *= symbolScale[opt.valueDim.index];
  }

  outputSymbolMeta.valueLineWidth = valueLineWidth || 0;
}

function prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, valueLineWidth, boundingLength, repeatCutLength, opt, outputSymbolMeta) {
  var categoryDim = opt.categoryDim;
  var valueDim = opt.valueDim;
  var pxSign = outputSymbolMeta.pxSign;
  var unitLength = Math.max(symbolSize[valueDim.index] + valueLineWidth, 0);
  var pathLen = unitLength; // Note: rotation will not effect the layout of symbols, because user may
  // want symbols to rotate on its center, which should not be translated
  // when rotating.

  if (symbolRepeat) {
    var absBoundingLength = Math.abs(boundingLength);
    var symbolMargin = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["retrieve"](itemModel.get('symbolMargin'), '15%') + '';
    var hasEndGap = false;

    if (symbolMargin.lastIndexOf('!') === symbolMargin.length - 1) {
      hasEndGap = true;
      symbolMargin = symbolMargin.slice(0, symbolMargin.length - 1);
    }

    var symbolMarginNumeric = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_number_js__["a" /* parsePercent */])(symbolMargin, symbolSize[valueDim.index]);
    var uLenWithMargin = Math.max(unitLength + symbolMarginNumeric * 2, 0); // When symbol margin is less than 0, margin at both ends will be subtracted
    // to ensure that all of the symbols will not be overflow the given area.

    var endFix = hasEndGap ? 0 : symbolMarginNumeric * 2; // Both final repeatTimes and final symbolMarginNumeric area calculated based on
    // boundingLength.

    var repeatSpecified = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_number_js__["b" /* isNumeric */])(symbolRepeat);
    var repeatTimes = repeatSpecified ? symbolRepeat : toIntTimes((absBoundingLength + endFix) / uLenWithMargin); // Adjust calculate margin, to ensure each symbol is displayed
    // entirely in the given layout area.

    var mDiff = absBoundingLength - repeatTimes * unitLength;
    symbolMarginNumeric = mDiff / 2 / (hasEndGap ? repeatTimes : Math.max(repeatTimes - 1, 1));
    uLenWithMargin = unitLength + symbolMarginNumeric * 2;
    endFix = hasEndGap ? 0 : symbolMarginNumeric * 2; // Update repeatTimes when not all symbol will be shown.

    if (!repeatSpecified && symbolRepeat !== 'fixed') {
      repeatTimes = repeatCutLength ? toIntTimes((Math.abs(repeatCutLength) + endFix) / uLenWithMargin) : 0;
    }

    pathLen = repeatTimes * uLenWithMargin - endFix;
    outputSymbolMeta.repeatTimes = repeatTimes;
    outputSymbolMeta.symbolMargin = symbolMarginNumeric;
  }

  var sizeFix = pxSign * (pathLen / 2);
  var pathPosition = outputSymbolMeta.pathPosition = [];
  pathPosition[categoryDim.index] = layout[categoryDim.wh] / 2;
  pathPosition[valueDim.index] = symbolPosition === 'start' ? sizeFix : symbolPosition === 'end' ? boundingLength - sizeFix : boundingLength / 2; // 'center'

  if (symbolOffset) {
    pathPosition[0] += symbolOffset[0];
    pathPosition[1] += symbolOffset[1];
  }

  var bundlePosition = outputSymbolMeta.bundlePosition = [];
  bundlePosition[categoryDim.index] = layout[categoryDim.xy];
  bundlePosition[valueDim.index] = layout[valueDim.xy];
  var barRectShape = outputSymbolMeta.barRectShape = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"]({}, layout);
  barRectShape[valueDim.wh] = pxSign * Math.max(Math.abs(layout[valueDim.wh]), Math.abs(pathPosition[valueDim.index] + sizeFix));
  barRectShape[categoryDim.wh] = layout[categoryDim.wh];
  var clipShape = outputSymbolMeta.clipShape = {}; // Consider that symbol may be overflow layout rect.

  clipShape[categoryDim.xy] = -layout[categoryDim.xy];
  clipShape[categoryDim.wh] = opt.ecSize[categoryDim.wh];
  clipShape[valueDim.xy] = 0;
  clipShape[valueDim.wh] = layout[valueDim.wh];
}

function createPath(symbolMeta) {
  var symbolPatternSize = symbolMeta.symbolPatternSize;
  var path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_symbol_js__["a" /* createSymbol */])( // Consider texture img, make a big size.
  symbolMeta.symbolType, -symbolPatternSize / 2, -symbolPatternSize / 2, symbolPatternSize, symbolPatternSize);
  path.attr({
    culling: true
  });
  path.type !== 'image' && path.setStyle({
    strokeNoScale: true
  });
  return path;
}

function createOrUpdateRepeatSymbols(bar, opt, symbolMeta, isUpdate) {
  var bundle = bar.__pictorialBundle;
  var symbolSize = symbolMeta.symbolSize;
  var valueLineWidth = symbolMeta.valueLineWidth;
  var pathPosition = symbolMeta.pathPosition;
  var valueDim = opt.valueDim;
  var repeatTimes = symbolMeta.repeatTimes || 0;
  var index = 0;
  var unit = symbolSize[opt.valueDim.index] + valueLineWidth + symbolMeta.symbolMargin * 2;
  eachPath(bar, function (path) {
    path.__pictorialAnimationIndex = index;
    path.__pictorialRepeatTimes = repeatTimes;

    if (index < repeatTimes) {
      updateAttr(path, null, makeTarget(index), symbolMeta, isUpdate);
    } else {
      updateAttr(path, null, {
        scaleX: 0,
        scaleY: 0
      }, symbolMeta, isUpdate, function () {
        bundle.remove(path);
      });
    } // updateHoverAnimation(path, symbolMeta);


    index++;
  });

  for (; index < repeatTimes; index++) {
    var path = createPath(symbolMeta);
    path.__pictorialAnimationIndex = index;
    path.__pictorialRepeatTimes = repeatTimes;
    bundle.add(path);
    var target = makeTarget(index);
    updateAttr(path, {
      x: target.x,
      y: target.y,
      scaleX: 0,
      scaleY: 0
    }, {
      scaleX: target.scaleX,
      scaleY: target.scaleY,
      rotation: target.rotation
    }, symbolMeta, isUpdate);
  }

  function makeTarget(index) {
    var position = pathPosition.slice(); // (start && pxSign > 0) || (end && pxSign < 0): i = repeatTimes - index
    // Otherwise: i = index;

    var pxSign = symbolMeta.pxSign;
    var i = index;

    if (symbolMeta.symbolRepeatDirection === 'start' ? pxSign > 0 : pxSign < 0) {
      i = repeatTimes - 1 - index;
    }

    position[valueDim.index] = unit * (i - repeatTimes / 2 + 0.5) + pathPosition[valueDim.index];
    return {
      x: position[0],
      y: position[1],
      scaleX: symbolMeta.symbolScale[0],
      scaleY: symbolMeta.symbolScale[1],
      rotation: symbolMeta.rotation
    };
  }
}

function createOrUpdateSingleSymbol(bar, opt, symbolMeta, isUpdate) {
  var bundle = bar.__pictorialBundle;
  var mainPath = bar.__pictorialMainPath;

  if (!mainPath) {
    mainPath = bar.__pictorialMainPath = createPath(symbolMeta);
    bundle.add(mainPath);
    updateAttr(mainPath, {
      x: symbolMeta.pathPosition[0],
      y: symbolMeta.pathPosition[1],
      scaleX: 0,
      scaleY: 0,
      rotation: symbolMeta.rotation
    }, {
      scaleX: symbolMeta.symbolScale[0],
      scaleY: symbolMeta.symbolScale[1]
    }, symbolMeta, isUpdate);
  } else {
    updateAttr(mainPath, null, {
      x: symbolMeta.pathPosition[0],
      y: symbolMeta.pathPosition[1],
      scaleX: symbolMeta.symbolScale[0],
      scaleY: symbolMeta.symbolScale[1],
      rotation: symbolMeta.rotation
    }, symbolMeta, isUpdate);
  }
} // bar rect is used for label.


function createOrUpdateBarRect(bar, symbolMeta, isUpdate) {
  var rectShape = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"]({}, symbolMeta.barRectShape);
  var barRect = bar.__pictorialBarRect;

  if (!barRect) {
    barRect = bar.__pictorialBarRect = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Rect"]({
      z2: 2,
      shape: rectShape,
      silent: true,
      style: {
        stroke: 'transparent',
        fill: 'transparent',
        lineWidth: 0
      }
    });
    barRect.disableMorphing = true;
    bar.add(barRect);
  } else {
    updateAttr(barRect, null, {
      shape: rectShape
    }, symbolMeta, isUpdate);
  }
}

function createOrUpdateClip(bar, opt, symbolMeta, isUpdate) {
  // If not clip, symbol will be remove and rebuilt.
  if (symbolMeta.symbolClip) {
    var clipPath = bar.__pictorialClipPath;
    var clipShape = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"]({}, symbolMeta.clipShape);
    var valueDim = opt.valueDim;
    var animationModel = symbolMeta.animationModel;
    var dataIndex = symbolMeta.dataIndex;

    if (clipPath) {
      __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["updateProps"](clipPath, {
        shape: clipShape
      }, animationModel, dataIndex);
    } else {
      clipShape[valueDim.wh] = 0;
      clipPath = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Rect"]({
        shape: clipShape
      });

      bar.__pictorialBundle.setClipPath(clipPath);

      bar.__pictorialClipPath = clipPath;
      var target = {};
      target[valueDim.wh] = symbolMeta.clipShape[valueDim.wh];
      __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__[isUpdate ? 'updateProps' : 'initProps'](clipPath, {
        shape: target
      }, animationModel, dataIndex);
    }
  }
}

function getItemModel(data, dataIndex) {
  var itemModel = data.getItemModel(dataIndex);
  itemModel.getAnimationDelayParams = getAnimationDelayParams;
  itemModel.isAnimationEnabled = isAnimationEnabled;
  return itemModel;
}

function getAnimationDelayParams(path) {
  // The order is the same as the z-order, see `symbolRepeatDiretion`.
  return {
    index: path.__pictorialAnimationIndex,
    count: path.__pictorialRepeatTimes
  };
}

function isAnimationEnabled() {
  // `animation` prop can be set on itemModel in pictorial bar chart.
  return this.parentModel.isAnimationEnabled() && !!this.getShallow('animation');
}

function createBar(data, opt, symbolMeta, isUpdate) {
  // bar is the main element for each data.
  var bar = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Group"](); // bundle is used for location and clip.

  var bundle = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Group"]();
  bar.add(bundle);
  bar.__pictorialBundle = bundle;
  bundle.x = symbolMeta.bundlePosition[0];
  bundle.y = symbolMeta.bundlePosition[1];

  if (symbolMeta.symbolRepeat) {
    createOrUpdateRepeatSymbols(bar, opt, symbolMeta);
  } else {
    createOrUpdateSingleSymbol(bar, opt, symbolMeta);
  }

  createOrUpdateBarRect(bar, symbolMeta, isUpdate);
  createOrUpdateClip(bar, opt, symbolMeta, isUpdate);
  bar.__pictorialShapeStr = getShapeStr(data, symbolMeta);
  bar.__pictorialSymbolMeta = symbolMeta;
  return bar;
}

function updateBar(bar, opt, symbolMeta) {
  var animationModel = symbolMeta.animationModel;
  var dataIndex = symbolMeta.dataIndex;
  var bundle = bar.__pictorialBundle;
  __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["updateProps"](bundle, {
    x: symbolMeta.bundlePosition[0],
    y: symbolMeta.bundlePosition[1]
  }, animationModel, dataIndex);

  if (symbolMeta.symbolRepeat) {
    createOrUpdateRepeatSymbols(bar, opt, symbolMeta, true);
  } else {
    createOrUpdateSingleSymbol(bar, opt, symbolMeta, true);
  }

  createOrUpdateBarRect(bar, symbolMeta, true);
  createOrUpdateClip(bar, opt, symbolMeta, true);
}

function removeBar(data, dataIndex, animationModel, bar) {
  // Not show text when animating
  var labelRect = bar.__pictorialBarRect;
  labelRect && labelRect.removeTextContent();
  var pathes = [];
  eachPath(bar, function (path) {
    pathes.push(path);
  });
  bar.__pictorialMainPath && pathes.push(bar.__pictorialMainPath); // I do not find proper remove animation for clip yet.

  bar.__pictorialClipPath && (animationModel = null);
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](pathes, function (path) {
    __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["removeElement"](path, {
      scaleX: 0,
      scaleY: 0
    }, animationModel, dataIndex, function () {
      bar.parent && bar.parent.remove(bar);
    });
  });
  data.setItemGraphicEl(dataIndex, null);
}

function getShapeStr(data, symbolMeta) {
  return [data.getItemVisual(symbolMeta.dataIndex, 'symbol') || 'none', !!symbolMeta.symbolRepeat, !!symbolMeta.symbolClip].join(':');
}

function eachPath(bar, cb, context) {
  // Do not use Group#eachChild, because it do not support remove.
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](bar.__pictorialBundle.children(), function (el) {
    el !== bar.__pictorialBarRect && cb.call(context, el);
  });
}

function updateAttr(el, immediateAttrs, animationAttrs, symbolMeta, isUpdate, cb) {
  immediateAttrs && el.attr(immediateAttrs); // when symbolCip used, only clip path has init animation, otherwise it would be weird effect.

  if (symbolMeta.symbolClip && !isUpdate) {
    animationAttrs && el.attr(animationAttrs);
  } else {
    animationAttrs && __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__[isUpdate ? 'updateProps' : 'initProps'](el, animationAttrs, symbolMeta.animationModel, symbolMeta.dataIndex, cb);
  }
}

function updateCommon(bar, opt, symbolMeta) {
  var dataIndex = symbolMeta.dataIndex;
  var itemModel = symbolMeta.itemModel; // Color must be excluded.
  // Because symbol provide setColor individually to set fill and stroke

  var emphasisModel = itemModel.getModel('emphasis');
  var emphasisStyle = emphasisModel.getModel('itemStyle').getItemStyle();
  var blurStyle = itemModel.getModel(['blur', 'itemStyle']).getItemStyle();
  var selectStyle = itemModel.getModel(['select', 'itemStyle']).getItemStyle();
  var cursorStyle = itemModel.getShallow('cursor');
  var focus = emphasisModel.get('focus');
  var blurScope = emphasisModel.get('blurScope');
  var hoverScale = emphasisModel.get('scale');
  eachPath(bar, function (path) {
    if (path instanceof __WEBPACK_IMPORTED_MODULE_9_zrender_lib_graphic_Image_js__["a" /* default */]) {
      var pathStyle = path.style;
      path.useStyle(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"]({
        // TODO other properties like dx, dy ?
        image: pathStyle.image,
        x: pathStyle.x,
        y: pathStyle.y,
        width: pathStyle.width,
        height: pathStyle.height
      }, symbolMeta.style));
    } else {
      path.useStyle(symbolMeta.style);
    }

    var emphasisState = path.ensureState('emphasis');
    emphasisState.style = emphasisStyle;

    if (hoverScale) {
      // NOTE: Must after scale is set after updateAttr
      emphasisState.scaleX = path.scaleX * 1.1;
      emphasisState.scaleY = path.scaleY * 1.1;
    }

    path.ensureState('blur').style = blurStyle;
    path.ensureState('select').style = selectStyle;
    cursorStyle && (path.cursor = cursorStyle);
    path.z2 = symbolMeta.z2;
  });
  var barPositionOutside = opt.valueDim.posDesc[+(symbolMeta.boundingLength > 0)];
  var barRect = bar.__pictorialBarRect;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__label_labelStyle_js__["e" /* setLabelStyle */])(barRect, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__label_labelStyle_js__["f" /* getLabelStatesModels */])(itemModel), {
    labelFetcher: opt.seriesModel,
    labelDataIndex: dataIndex,
    defaultText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helper_labelHelper_js__["a" /* getDefaultLabel */])(opt.seriesModel.getData(), dataIndex),
    inheritColor: symbolMeta.style.fill,
    defaultOpacity: symbolMeta.style.opacity,
    defaultOutsidePosition: barPositionOutside
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_states_js__["G" /* toggleHoverEmphasis */])(bar, focus, blurScope, emphasisModel.get('disabled'));
}

function toIntTimes(times) {
  var roundedTimes = Math.round(times); // Escapse accurate error

  return Math.abs(times - roundedTimes) < 1e-4 ? roundedTimes : Math.ceil(times);
}

/* harmony default export */ __webpack_exports__["a"] = (PictorialBarView);

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_barGrid_js__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__processor_dataSample_js__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BarSeries_js__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BarView_js__ = __webpack_require__(1084);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





function install(registers) {
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_4__BarView_js__["a" /* default */]);
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_3__BarSeries_js__["a" /* default */]);
  registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["curry"](__WEBPACK_IMPORTED_MODULE_1__layout_barGrid_js__["e" /* layout */], 'bar')); // Do layout after other overall layout, which can preapre some informations.

  registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__layout_barGrid_js__["f" /* createProgressiveLayout */])('bar')); // Down sample after filter

  registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__processor_dataSample_js__["a" /* default */])('bar'));
  /**
   * @payload
   * @property {string} [componentType=series]
   * @property {number} [dx]
   * @property {number} [dy]
   * @property {number} [zoom]
   * @property {number} [originX]
   * @property {number} [originY]
   */

  registers.registerAction({
    type: 'changeAxisOrder',
    event: 'changeAxisOrder',
    update: 'update'
  }, function (payload, ecModel) {
    var componentType = payload.componentType || 'series';
    ecModel.eachComponent({
      mainType: componentType,
      query: payload
    }, function (componentModel) {
      if (payload.sortInfo) {
        componentModel.axis.setCategorySortInfo(payload.sortInfo);
      }
    });
  });
}

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PictorialBarView_js__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PictorialBarSeries_js__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_barGrid_js__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




function install(registers) {
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_0__PictorialBarView_js__["a" /* default */]);
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_1__PictorialBarSeries_js__["a" /* default */]);
  registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["curry"])(__WEBPACK_IMPORTED_MODULE_2__layout_barGrid_js__["e" /* layout */], 'pictorialBar')); // Do layout after other overall layout, which can preapre some informations.

  registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__layout_barGrid_js__["f" /* createProgressiveLayout */])('pictorialBar'));
}

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_Series_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_whiskerBoxCommon_js__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var BoxplotSeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(BoxplotSeriesModel, _super);

  function BoxplotSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = BoxplotSeriesModel.type; // TODO
    // box width represents group size, so dimension should have 'size'.

    /**
     * @see <https://en.wikipedia.org/wiki/Box_plot>
     * The meanings of 'min' and 'max' depend on user,
     * and echarts do not need to know it.
     * @readOnly
     */

    _this.defaultValueDimensions = [{
      name: 'min',
      defaultTooltip: true
    }, {
      name: 'Q1',
      defaultTooltip: true
    }, {
      name: 'median',
      defaultTooltip: true
    }, {
      name: 'Q3',
      defaultTooltip: true
    }, {
      name: 'max',
      defaultTooltip: true
    }];
    _this.visualDrawType = 'stroke';
    return _this;
  }

  BoxplotSeriesModel.type = 'series.boxplot';
  BoxplotSeriesModel.dependencies = ['xAxis', 'yAxis', 'grid'];
  BoxplotSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    coordinateSystem: 'cartesian2d',
    legendHoverLink: true,
    layout: null,
    boxWidth: [7, 50],
    itemStyle: {
      color: '#fff',
      borderWidth: 1
    },
    emphasis: {
      scale: true,
      itemStyle: {
        borderWidth: 2,
        shadowBlur: 5,
        shadowOffsetX: 1,
        shadowOffsetY: 1,
        shadowColor: 'rgba(0,0,0,0.2)'
      }
    },
    animationDuration: 800
  };
  return BoxplotSeriesModel;
}(__WEBPACK_IMPORTED_MODULE_1__model_Series_js__["b" /* default */]);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["mixin"])(BoxplotSeriesModel, __WEBPACK_IMPORTED_MODULE_2__helper_whiskerBoxCommon_js__["a" /* WhiskerBoxCommonMixin */], true);
/* harmony default export */ __webpack_exports__["a"] = (BoxplotSeriesModel);

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zrender_lib_graphic_Path_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__animation_basicTrasition_js__ = __webpack_require__(40);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/








var BoxplotView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(BoxplotView, _super);

  function BoxplotView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = BoxplotView.type;
    return _this;
  }

  BoxplotView.prototype.render = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var group = this.group;
    var oldData = this._data; // There is no old data only when first rendering or switching from
    // stream mode to normal mode, where previous elements should be removed.

    if (!this._data) {
      group.removeAll();
    }

    var constDim = seriesModel.get('layout') === 'horizontal' ? 1 : 0;
    data.diff(oldData).add(function (newIdx) {
      if (data.hasValue(newIdx)) {
        var itemLayout = data.getItemLayout(newIdx);
        var symbolEl = createNormalBox(itemLayout, data, newIdx, constDim, true);
        data.setItemGraphicEl(newIdx, symbolEl);
        group.add(symbolEl);
      }
    }).update(function (newIdx, oldIdx) {
      var symbolEl = oldData.getItemGraphicEl(oldIdx); // Empty data

      if (!data.hasValue(newIdx)) {
        group.remove(symbolEl);
        return;
      }

      var itemLayout = data.getItemLayout(newIdx);

      if (!symbolEl) {
        symbolEl = createNormalBox(itemLayout, data, newIdx, constDim);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__animation_basicTrasition_js__["f" /* saveOldStyle */])(symbolEl);
        updateNormalBoxData(itemLayout, symbolEl, data, newIdx);
      }

      group.add(symbolEl);
      data.setItemGraphicEl(newIdx, symbolEl);
    }).remove(function (oldIdx) {
      var el = oldData.getItemGraphicEl(oldIdx);
      el && group.remove(el);
    }).execute();
    this._data = data;
  };

  BoxplotView.prototype.remove = function (ecModel) {
    var group = this.group;
    var data = this._data;
    this._data = null;
    data && data.eachItemGraphicEl(function (el) {
      el && group.remove(el);
    });
  };

  BoxplotView.type = 'boxplot';
  return BoxplotView;
}(__WEBPACK_IMPORTED_MODULE_2__view_Chart_js__["a" /* default */]);

var BoxPathShape =
/** @class */
function () {
  function BoxPathShape() {}

  return BoxPathShape;
}();

var BoxPath =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(BoxPath, _super);

  function BoxPath(opts) {
    var _this = _super.call(this, opts) || this;

    _this.type = 'boxplotBoxPath';
    return _this;
  }

  BoxPath.prototype.getDefaultShape = function () {
    return new BoxPathShape();
  };

  BoxPath.prototype.buildPath = function (ctx, shape) {
    var ends = shape.points;
    var i = 0;
    ctx.moveTo(ends[i][0], ends[i][1]);
    i++;

    for (; i < 4; i++) {
      ctx.lineTo(ends[i][0], ends[i][1]);
    }

    ctx.closePath();

    for (; i < ends.length; i++) {
      ctx.moveTo(ends[i][0], ends[i][1]);
      i++;
      ctx.lineTo(ends[i][0], ends[i][1]);
    }
  };

  return BoxPath;
}(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_graphic_Path_js__["a" /* default */]);

function createNormalBox(itemLayout, data, dataIndex, constDim, isInit) {
  var ends = itemLayout.ends;
  var el = new BoxPath({
    shape: {
      points: isInit ? transInit(ends, constDim, itemLayout) : ends
    }
  });
  updateNormalBoxData(itemLayout, el, data, dataIndex, isInit);
  return el;
}

function updateNormalBoxData(itemLayout, el, data, dataIndex, isInit) {
  var seriesModel = data.hostModel;
  var updateMethod = __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__[isInit ? 'initProps' : 'updateProps'];
  updateMethod(el, {
    shape: {
      points: itemLayout.ends
    }
  }, seriesModel, dataIndex);
  el.useStyle(data.getItemVisual(dataIndex, 'style'));
  el.style.strokeNoScale = true;
  el.z2 = 100;
  var itemModel = data.getItemModel(dataIndex);
  var emphasisModel = itemModel.getModel('emphasis');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_states_js__["F" /* setStatesStylesFromModel */])(el, itemModel);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_states_js__["G" /* toggleHoverEmphasis */])(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
}

function transInit(points, dim, itemLayout) {
  return __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"](points, function (point) {
    point = point.slice();
    point[dim] = itemLayout.initBaseline;
    return point;
  });
}

/* harmony default export */ __webpack_exports__["a"] = (BoxplotView);

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = boxplotLayout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_number_js__ = __webpack_require__(8);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


var each = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"];
function boxplotLayout(ecModel) {
  var groupResult = groupSeriesByAxis(ecModel);
  each(groupResult, function (groupItem) {
    var seriesModels = groupItem.seriesModels;

    if (!seriesModels.length) {
      return;
    }

    calculateBase(groupItem);
    each(seriesModels, function (seriesModel, idx) {
      layoutSingleSeries(seriesModel, groupItem.boxOffsetList[idx], groupItem.boxWidthList[idx]);
    });
  });
}
/**
 * Group series by axis.
 */

function groupSeriesByAxis(ecModel) {
  var result = [];
  var axisList = [];
  ecModel.eachSeriesByType('boxplot', function (seriesModel) {
    var baseAxis = seriesModel.getBaseAxis();
    var idx = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"](axisList, baseAxis);

    if (idx < 0) {
      idx = axisList.length;
      axisList[idx] = baseAxis;
      result[idx] = {
        axis: baseAxis,
        seriesModels: []
      };
    }

    result[idx].seriesModels.push(seriesModel);
  });
  return result;
}
/**
 * Calculate offset and box width for each series.
 */


function calculateBase(groupItem) {
  var baseAxis = groupItem.axis;
  var seriesModels = groupItem.seriesModels;
  var seriesCount = seriesModels.length;
  var boxWidthList = groupItem.boxWidthList = [];
  var boxOffsetList = groupItem.boxOffsetList = [];
  var boundList = [];
  var bandWidth;

  if (baseAxis.type === 'category') {
    bandWidth = baseAxis.getBandWidth();
  } else {
    var maxDataCount_1 = 0;
    each(seriesModels, function (seriesModel) {
      maxDataCount_1 = Math.max(maxDataCount_1, seriesModel.getData().count());
    });
    var extent = baseAxis.getExtent();
    bandWidth = Math.abs(extent[1] - extent[0]) / maxDataCount_1;
  }

  each(seriesModels, function (seriesModel) {
    var boxWidthBound = seriesModel.get('boxWidth');

    if (!__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](boxWidthBound)) {
      boxWidthBound = [boxWidthBound, boxWidthBound];
    }

    boundList.push([__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["a" /* parsePercent */])(boxWidthBound[0], bandWidth) || 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["a" /* parsePercent */])(boxWidthBound[1], bandWidth) || 0]);
  });
  var availableWidth = bandWidth * 0.8 - 2;
  var boxGap = availableWidth / seriesCount * 0.3;
  var boxWidth = (availableWidth - boxGap * (seriesCount - 1)) / seriesCount;
  var base = boxWidth / 2 - availableWidth / 2;
  each(seriesModels, function (seriesModel, idx) {
    boxOffsetList.push(base);
    base += boxGap + boxWidth;
    boxWidthList.push(Math.min(Math.max(boxWidth, boundList[idx][0]), boundList[idx][1]));
  });
}
/**
 * Calculate points location for each series.
 */


function layoutSingleSeries(seriesModel, offset, boxWidth) {
  var coordSys = seriesModel.coordinateSystem;
  var data = seriesModel.getData();
  var halfWidth = boxWidth / 2;
  var cDimIdx = seriesModel.get('layout') === 'horizontal' ? 0 : 1;
  var vDimIdx = 1 - cDimIdx;
  var coordDims = ['x', 'y'];
  var cDim = data.mapDimension(coordDims[cDimIdx]);
  var vDims = data.mapDimensionsAll(coordDims[vDimIdx]);

  if (cDim == null || vDims.length < 5) {
    return;
  }

  for (var dataIndex = 0; dataIndex < data.count(); dataIndex++) {
    var axisDimVal = data.get(cDim, dataIndex);
    var median = getPoint(axisDimVal, vDims[2], dataIndex);
    var end1 = getPoint(axisDimVal, vDims[0], dataIndex);
    var end2 = getPoint(axisDimVal, vDims[1], dataIndex);
    var end4 = getPoint(axisDimVal, vDims[3], dataIndex);
    var end5 = getPoint(axisDimVal, vDims[4], dataIndex);
    var ends = [];
    addBodyEnd(ends, end2, false);
    addBodyEnd(ends, end4, true);
    ends.push(end1, end2, end5, end4);
    layEndLine(ends, end1);
    layEndLine(ends, end5);
    layEndLine(ends, median);
    data.setItemLayout(dataIndex, {
      initBaseline: median[vDimIdx],
      ends: ends
    });
  }

  function getPoint(axisDimVal, dim, dataIndex) {
    var val = data.get(dim, dataIndex);
    var p = [];
    p[cDimIdx] = axisDimVal;
    p[vDimIdx] = val;
    var point;

    if (isNaN(axisDimVal) || isNaN(val)) {
      point = [NaN, NaN];
    } else {
      point = coordSys.dataToPoint(p);
      point[cDimIdx] += offset;
    }

    return point;
  }

  function addBodyEnd(ends, point, start) {
    var point1 = point.slice();
    var point2 = point.slice();
    point1[cDimIdx] += halfWidth;
    point2[cDimIdx] -= halfWidth;
    start ? ends.push(point1, point2) : ends.push(point2, point1);
  }

  function layEndLine(ends, endCenter) {
    var from = endCenter.slice();
    var to = endCenter.slice();
    from[cDimIdx] -= halfWidth;
    to[cDimIdx] += halfWidth;
    ends.push(from, to);
  }
}

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return boxplotTransform; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__prepareBoxplotData_js__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_log_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_types_js__ = __webpack_require__(66);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var boxplotTransform = {
  type: 'echarts:boxplot',
  transform: function transform(params) {
    var upstream = params.upstream;

    if (upstream.sourceFormat !== __WEBPACK_IMPORTED_MODULE_2__util_types_js__["b" /* SOURCE_FORMAT_ARRAY_ROWS */]) {
      var errMsg = '';

      if (true) {
        errMsg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_log_js__["d" /* makePrintable */])('source data is not applicable for this boxplot transform. Expect number[][].');
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_log_js__["e" /* throwError */])(errMsg);
    }

    var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__prepareBoxplotData_js__["a" /* default */])(upstream.getRawData(), params.config);
    return [{
      dimensions: ['ItemName', 'Low', 'Q1', 'Q2', 'Q3', 'High'],
      data: result.boxData
    }, {
      data: result.outliers
    }];
  }
};

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = boxplotVisual;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function boxplotVisual(ecModel, api) {}

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BoxplotSeries_js__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BoxplotView_js__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__boxplotVisual_js__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__boxplotLayout_js__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__boxplotTransform_js__ = __webpack_require__(1092);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





function install(registers) {
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_0__BoxplotSeries_js__["a" /* default */]);
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_1__BoxplotView_js__["a" /* default */]);
  registers.registerVisual(__WEBPACK_IMPORTED_MODULE_2__boxplotVisual_js__["a" /* default */]);
  registers.registerLayout(__WEBPACK_IMPORTED_MODULE_3__boxplotLayout_js__["a" /* default */]);
  registers.registerTransform(__WEBPACK_IMPORTED_MODULE_4__boxplotTransform_js__["a" /* boxplotTransform */]);
}

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = prepareBoxplotData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * See:
 *  <https://en.wikipedia.org/wiki/Box_plot#cite_note-frigge_hoaglin_iglewicz-2>
 *  <http://stat.ethz.ch/R-manual/R-devel/library/grDevices/html/boxplot.stats.html>
 *
 * Helper method for preparing data.
 *
 * @param rawData like
 *        [
 *            [12,232,443], (raw data set for the first box)
 *            [3843,5545,1232], (raw data set for the second box)
 *            ...
 *        ]
 * @param opt.boundIQR=1.5 Data less than min bound is outlier.
 *      default 1.5, means Q1 - 1.5 * (Q3 - Q1).
 *      If 'none'/0 passed, min bound will not be used.
 */

function prepareBoxplotData(rawData, opt) {
  opt = opt || {};
  var boxData = [];
  var outliers = [];
  var boundIQR = opt.boundIQR;
  var useExtreme = boundIQR === 'none' || boundIQR === 0;

  for (var i = 0; i < rawData.length; i++) {
    var ascList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["j" /* asc */])(rawData[i].slice());
    var Q1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["t" /* quantile */])(ascList, 0.25);
    var Q2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["t" /* quantile */])(ascList, 0.5);
    var Q3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["t" /* quantile */])(ascList, 0.75);
    var min = ascList[0];
    var max = ascList[ascList.length - 1];
    var bound = (boundIQR == null ? 1.5 : boundIQR) * (Q3 - Q1);
    var low = useExtreme ? min : Math.max(min, Q1 - bound);
    var high = useExtreme ? max : Math.min(max, Q3 + bound);
    var itemNameFormatter = opt.itemNameFormatter;
    var itemName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isFunction"])(itemNameFormatter) ? itemNameFormatter({
      value: i
    }) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"])(itemNameFormatter) ? itemNameFormatter.replace('{value}', i + '') : i + '';
    boxData.push([itemName, low, Q1, Q2, Q3, high]);

    for (var j = 0; j < ascList.length; j++) {
      var dataItem = ascList[j];

      if (dataItem < low || dataItem > high) {
        var outlier = [itemName, dataItem];
        outliers.push(outlier);
      }
    }
  }

  return {
    boxData: boxData,
    outliers: outliers
  };
}

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_Series_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_whiskerBoxCommon_js__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var CandlestickSeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(CandlestickSeriesModel, _super);

  function CandlestickSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = CandlestickSeriesModel.type;
    _this.defaultValueDimensions = [{
      name: 'open',
      defaultTooltip: true
    }, {
      name: 'close',
      defaultTooltip: true
    }, {
      name: 'lowest',
      defaultTooltip: true
    }, {
      name: 'highest',
      defaultTooltip: true
    }];
    return _this;
  }
  /**
   * Get dimension for shadow in dataZoom
   * @return dimension name
   */


  CandlestickSeriesModel.prototype.getShadowDim = function () {
    return 'open';
  };

  CandlestickSeriesModel.prototype.brushSelector = function (dataIndex, data, selectors) {
    var itemLayout = data.getItemLayout(dataIndex);
    return itemLayout && selectors.rect(itemLayout.brushRect);
  };

  CandlestickSeriesModel.type = 'series.candlestick';
  CandlestickSeriesModel.dependencies = ['xAxis', 'yAxis', 'grid'];
  CandlestickSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    coordinateSystem: 'cartesian2d',
    legendHoverLink: true,
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    layout: null,
    clip: true,
    itemStyle: {
      color: '#eb5454',
      color0: '#47b262',
      borderColor: '#eb5454',
      borderColor0: '#47b262',
      // borderColor: '#d24040',
      // borderColor0: '#398f4f',
      borderWidth: 1
    },
    emphasis: {
      scale: true,
      itemStyle: {
        borderWidth: 2
      }
    },
    barMaxWidth: null,
    barMinWidth: null,
    barWidth: null,
    large: true,
    largeThreshold: 600,
    progressive: 3e3,
    progressiveThreshold: 1e4,
    progressiveChunkMode: 'mod',
    animationEasing: 'linear',
    animationDuration: 300
  };
  return CandlestickSeriesModel;
}(__WEBPACK_IMPORTED_MODULE_1__model_Series_js__["b" /* default */]);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["mixin"])(CandlestickSeriesModel, __WEBPACK_IMPORTED_MODULE_2__helper_whiskerBoxCommon_js__["a" /* WhiskerBoxCommonMixin */], true);
/* harmony default export */ __webpack_exports__["a"] = (CandlestickSeriesModel);

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zrender_lib_graphic_Path_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_createClipPathFromCoordSys_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__animation_basicTrasition_js__ = __webpack_require__(40);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/








var SKIP_PROPS = ['color', 'borderColor'];

var CandlestickView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(CandlestickView, _super);

  function CandlestickView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = CandlestickView.type;
    return _this;
  }

  CandlestickView.prototype.render = function (seriesModel, ecModel, api) {
    // If there is clipPath created in large mode. Remove it.
    this.group.removeClipPath(); // Clear previously rendered progressive elements.

    this._progressiveEls = null;

    this._updateDrawMode(seriesModel);

    this._isLargeDraw ? this._renderLarge(seriesModel) : this._renderNormal(seriesModel);
  };

  CandlestickView.prototype.incrementalPrepareRender = function (seriesModel, ecModel, api) {
    this._clear();

    this._updateDrawMode(seriesModel);
  };

  CandlestickView.prototype.incrementalRender = function (params, seriesModel, ecModel, api) {
    this._progressiveEls = [];
    this._isLargeDraw ? this._incrementalRenderLarge(params, seriesModel) : this._incrementalRenderNormal(params, seriesModel);
  };

  CandlestickView.prototype.eachRendered = function (cb) {
    __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["traverseElements"](this._progressiveEls || this.group, cb);
  };

  CandlestickView.prototype._updateDrawMode = function (seriesModel) {
    var isLargeDraw = seriesModel.pipelineContext.large;

    if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
      this._isLargeDraw = isLargeDraw;

      this._clear();
    }
  };

  CandlestickView.prototype._renderNormal = function (seriesModel) {
    var data = seriesModel.getData();
    var oldData = this._data;
    var group = this.group;
    var isSimpleBox = data.getLayout('isSimpleBox');
    var needsClip = seriesModel.get('clip', true);
    var coord = seriesModel.coordinateSystem;
    var clipArea = coord.getArea && coord.getArea(); // There is no old data only when first rendering or switching from
    // stream mode to normal mode, where previous elements should be removed.

    if (!this._data) {
      group.removeAll();
    }

    data.diff(oldData).add(function (newIdx) {
      if (data.hasValue(newIdx)) {
        var itemLayout = data.getItemLayout(newIdx);

        if (needsClip && isNormalBoxClipped(clipArea, itemLayout)) {
          return;
        }

        var el = createNormalBox(itemLayout, newIdx, true);
        __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["initProps"](el, {
          shape: {
            points: itemLayout.ends
          }
        }, seriesModel, newIdx);
        setBoxCommon(el, data, newIdx, isSimpleBox);
        group.add(el);
        data.setItemGraphicEl(newIdx, el);
      }
    }).update(function (newIdx, oldIdx) {
      var el = oldData.getItemGraphicEl(oldIdx); // Empty data

      if (!data.hasValue(newIdx)) {
        group.remove(el);
        return;
      }

      var itemLayout = data.getItemLayout(newIdx);

      if (needsClip && isNormalBoxClipped(clipArea, itemLayout)) {
        group.remove(el);
        return;
      }

      if (!el) {
        el = createNormalBox(itemLayout, newIdx);
      } else {
        __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["updateProps"](el, {
          shape: {
            points: itemLayout.ends
          }
        }, seriesModel, newIdx);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__animation_basicTrasition_js__["f" /* saveOldStyle */])(el);
      }

      setBoxCommon(el, data, newIdx, isSimpleBox);
      group.add(el);
      data.setItemGraphicEl(newIdx, el);
    }).remove(function (oldIdx) {
      var el = oldData.getItemGraphicEl(oldIdx);
      el && group.remove(el);
    }).execute();
    this._data = data;
  };

  CandlestickView.prototype._renderLarge = function (seriesModel) {
    this._clear();

    createLarge(seriesModel, this.group);
    var clipPath = seriesModel.get('clip', true) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helper_createClipPathFromCoordSys_js__["a" /* createClipPath */])(seriesModel.coordinateSystem, false, seriesModel) : null;

    if (clipPath) {
      this.group.setClipPath(clipPath);
    } else {
      this.group.removeClipPath();
    }
  };

  CandlestickView.prototype._incrementalRenderNormal = function (params, seriesModel) {
    var data = seriesModel.getData();
    var isSimpleBox = data.getLayout('isSimpleBox');
    var dataIndex;

    while ((dataIndex = params.next()) != null) {
      var itemLayout = data.getItemLayout(dataIndex);
      var el = createNormalBox(itemLayout, dataIndex);
      setBoxCommon(el, data, dataIndex, isSimpleBox);
      el.incremental = true;
      this.group.add(el);

      this._progressiveEls.push(el);
    }
  };

  CandlestickView.prototype._incrementalRenderLarge = function (params, seriesModel) {
    createLarge(seriesModel, this.group, this._progressiveEls, true);
  };

  CandlestickView.prototype.remove = function (ecModel) {
    this._clear();
  };

  CandlestickView.prototype._clear = function () {
    this.group.removeAll();
    this._data = null;
  };

  CandlestickView.type = 'candlestick';
  return CandlestickView;
}(__WEBPACK_IMPORTED_MODULE_2__view_Chart_js__["a" /* default */]);

var NormalBoxPathShape =
/** @class */
function () {
  function NormalBoxPathShape() {}

  return NormalBoxPathShape;
}();

var NormalBoxPath =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(NormalBoxPath, _super);

  function NormalBoxPath(opts) {
    var _this = _super.call(this, opts) || this;

    _this.type = 'normalCandlestickBox';
    return _this;
  }

  NormalBoxPath.prototype.getDefaultShape = function () {
    return new NormalBoxPathShape();
  };

  NormalBoxPath.prototype.buildPath = function (ctx, shape) {
    var ends = shape.points;

    if (this.__simpleBox) {
      ctx.moveTo(ends[4][0], ends[4][1]);
      ctx.lineTo(ends[6][0], ends[6][1]);
    } else {
      ctx.moveTo(ends[0][0], ends[0][1]);
      ctx.lineTo(ends[1][0], ends[1][1]);
      ctx.lineTo(ends[2][0], ends[2][1]);
      ctx.lineTo(ends[3][0], ends[3][1]);
      ctx.closePath();
      ctx.moveTo(ends[4][0], ends[4][1]);
      ctx.lineTo(ends[5][0], ends[5][1]);
      ctx.moveTo(ends[6][0], ends[6][1]);
      ctx.lineTo(ends[7][0], ends[7][1]);
    }
  };

  return NormalBoxPath;
}(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_graphic_Path_js__["a" /* default */]);

function createNormalBox(itemLayout, dataIndex, isInit) {
  var ends = itemLayout.ends;
  return new NormalBoxPath({
    shape: {
      points: isInit ? transInit(ends, itemLayout) : ends
    },
    z2: 100
  });
}

function isNormalBoxClipped(clipArea, itemLayout) {
  var clipped = true;

  for (var i = 0; i < itemLayout.ends.length; i++) {
    // If any point are in the region.
    if (clipArea.contain(itemLayout.ends[i][0], itemLayout.ends[i][1])) {
      clipped = false;
      break;
    }
  }

  return clipped;
}

function setBoxCommon(el, data, dataIndex, isSimpleBox) {
  var itemModel = data.getItemModel(dataIndex);
  el.useStyle(data.getItemVisual(dataIndex, 'style'));
  el.style.strokeNoScale = true;
  el.__simpleBox = isSimpleBox;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_states_js__["F" /* setStatesStylesFromModel */])(el, itemModel);
}

function transInit(points, itemLayout) {
  return __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"](points, function (point) {
    point = point.slice();
    point[1] = itemLayout.initBaseline;
    return point;
  });
}

var LargeBoxPathShape =
/** @class */
function () {
  function LargeBoxPathShape() {}

  return LargeBoxPathShape;
}();

var LargeBoxPath =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(LargeBoxPath, _super);

  function LargeBoxPath(opts) {
    var _this = _super.call(this, opts) || this;

    _this.type = 'largeCandlestickBox';
    return _this;
  }

  LargeBoxPath.prototype.getDefaultShape = function () {
    return new LargeBoxPathShape();
  };

  LargeBoxPath.prototype.buildPath = function (ctx, shape) {
    // Drawing lines is more efficient than drawing
    // a whole line or drawing rects.
    var points = shape.points;

    for (var i = 0; i < points.length;) {
      if (this.__sign === points[i++]) {
        var x = points[i++];
        ctx.moveTo(x, points[i++]);
        ctx.lineTo(x, points[i++]);
      } else {
        i += 3;
      }
    }
  };

  return LargeBoxPath;
}(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_graphic_Path_js__["a" /* default */]);

function createLarge(seriesModel, group, progressiveEls, incremental) {
  var data = seriesModel.getData();
  var largePoints = data.getLayout('largePoints');
  var elP = new LargeBoxPath({
    shape: {
      points: largePoints
    },
    __sign: 1
  });
  group.add(elP);
  var elN = new LargeBoxPath({
    shape: {
      points: largePoints
    },
    __sign: -1
  });
  group.add(elN);
  setLargeStyle(1, elP, seriesModel, data);
  setLargeStyle(-1, elN, seriesModel, data);

  if (incremental) {
    elP.incremental = true;
    elN.incremental = true;
  }

  if (progressiveEls) {
    progressiveEls.push(elP, elN);
  }
}

function setLargeStyle(sign, el, seriesModel, data) {
  // TODO put in visual?
  var borderColor = seriesModel.get(['itemStyle', sign > 0 ? 'borderColor' : 'borderColor0']) || seriesModel.get(['itemStyle', sign > 0 ? 'color' : 'color0']); // Color must be excluded.
  // Because symbol provide setColor individually to set fill and stroke

  var itemStyle = seriesModel.getModel('itemStyle').getItemStyle(SKIP_PROPS);
  el.useStyle(itemStyle);
  el.style.fill = null;
  el.style.stroke = borderColor;
}

/* harmony default export */ __webpack_exports__["a"] = (CandlestickView);

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_createRenderPlanner_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_vendor_js__ = __webpack_require__(198);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var candlestickLayout = {
  seriesType: 'candlestick',
  plan: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper_createRenderPlanner_js__["a" /* default */])(),
  reset: function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    var data = seriesModel.getData();
    var candleWidth = calculateCandleWidth(seriesModel, data);
    var cDimIdx = 0;
    var vDimIdx = 1;
    var coordDims = ['x', 'y'];
    var cDimI = data.getDimensionIndex(data.mapDimension(coordDims[cDimIdx]));
    var vDimsI = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["map"])(data.mapDimensionsAll(coordDims[vDimIdx]), data.getDimensionIndex, data);
    var openDimI = vDimsI[0];
    var closeDimI = vDimsI[1];
    var lowestDimI = vDimsI[2];
    var highestDimI = vDimsI[3];
    data.setLayout({
      candleWidth: candleWidth,
      // The value is experimented visually.
      isSimpleBox: candleWidth <= 1.3
    });

    if (cDimI < 0 || vDimsI.length < 4) {
      return;
    }

    return {
      progress: seriesModel.pipelineContext.large ? largeProgress : normalProgress
    };

    function normalProgress(params, data) {
      var dataIndex;
      var store = data.getStore();

      while ((dataIndex = params.next()) != null) {
        var axisDimVal = store.get(cDimI, dataIndex);
        var openVal = store.get(openDimI, dataIndex);
        var closeVal = store.get(closeDimI, dataIndex);
        var lowestVal = store.get(lowestDimI, dataIndex);
        var highestVal = store.get(highestDimI, dataIndex);
        var ocLow = Math.min(openVal, closeVal);
        var ocHigh = Math.max(openVal, closeVal);
        var ocLowPoint = getPoint(ocLow, axisDimVal);
        var ocHighPoint = getPoint(ocHigh, axisDimVal);
        var lowestPoint = getPoint(lowestVal, axisDimVal);
        var highestPoint = getPoint(highestVal, axisDimVal);
        var ends = [];
        addBodyEnd(ends, ocHighPoint, 0);
        addBodyEnd(ends, ocLowPoint, 1);
        ends.push(subPixelOptimizePoint(highestPoint), subPixelOptimizePoint(ocHighPoint), subPixelOptimizePoint(lowestPoint), subPixelOptimizePoint(ocLowPoint));
        data.setItemLayout(dataIndex, {
          sign: getSign(store, dataIndex, openVal, closeVal, closeDimI),
          initBaseline: openVal > closeVal ? ocHighPoint[vDimIdx] : ocLowPoint[vDimIdx],
          ends: ends,
          brushRect: makeBrushRect(lowestVal, highestVal, axisDimVal)
        });
      }

      function getPoint(val, axisDimVal) {
        var p = [];
        p[cDimIdx] = axisDimVal;
        p[vDimIdx] = val;
        return isNaN(axisDimVal) || isNaN(val) ? [NaN, NaN] : coordSys.dataToPoint(p);
      }

      function addBodyEnd(ends, point, start) {
        var point1 = point.slice();
        var point2 = point.slice();
        point1[cDimIdx] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["subPixelOptimize"])(point1[cDimIdx] + candleWidth / 2, 1, false);
        point2[cDimIdx] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["subPixelOptimize"])(point2[cDimIdx] - candleWidth / 2, 1, true);
        start ? ends.push(point1, point2) : ends.push(point2, point1);
      }

      function makeBrushRect(lowestVal, highestVal, axisDimVal) {
        var pmin = getPoint(lowestVal, axisDimVal);
        var pmax = getPoint(highestVal, axisDimVal);
        pmin[cDimIdx] -= candleWidth / 2;
        pmax[cDimIdx] -= candleWidth / 2;
        return {
          x: pmin[0],
          y: pmin[1],
          width: vDimIdx ? candleWidth : pmax[0] - pmin[0],
          height: vDimIdx ? pmax[1] - pmin[1] : candleWidth
        };
      }

      function subPixelOptimizePoint(point) {
        point[cDimIdx] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["subPixelOptimize"])(point[cDimIdx], 1);
        return point;
      }
    }

    function largeProgress(params, data) {
      // Structure: [sign, x, yhigh, ylow, sign, x, yhigh, ylow, ...]
      var points = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_vendor_js__["a" /* createFloat32Array */])(params.count * 4);
      var offset = 0;
      var point;
      var tmpIn = [];
      var tmpOut = [];
      var dataIndex;
      var store = data.getStore();

      while ((dataIndex = params.next()) != null) {
        var axisDimVal = store.get(cDimI, dataIndex);
        var openVal = store.get(openDimI, dataIndex);
        var closeVal = store.get(closeDimI, dataIndex);
        var lowestVal = store.get(lowestDimI, dataIndex);
        var highestVal = store.get(highestDimI, dataIndex);

        if (isNaN(axisDimVal) || isNaN(lowestVal) || isNaN(highestVal)) {
          points[offset++] = NaN;
          offset += 3;
          continue;
        }

        points[offset++] = getSign(store, dataIndex, openVal, closeVal, closeDimI);
        tmpIn[cDimIdx] = axisDimVal;
        tmpIn[vDimIdx] = lowestVal;
        point = coordSys.dataToPoint(tmpIn, null, tmpOut);
        points[offset++] = point ? point[0] : NaN;
        points[offset++] = point ? point[1] : NaN;
        tmpIn[vDimIdx] = highestVal;
        point = coordSys.dataToPoint(tmpIn, null, tmpOut);
        points[offset++] = point ? point[1] : NaN;
      }

      data.setLayout('largePoints', points);
    }
  }
};

function getSign(store, dataIndex, openVal, closeVal, closeDimI) {
  var sign;

  if (openVal > closeVal) {
    sign = -1;
  } else if (openVal < closeVal) {
    sign = 1;
  } else {
    sign = dataIndex > 0 // If close === open, compare with close of last record
    ? store.get(closeDimI, dataIndex - 1) <= closeVal ? 1 : -1 : // No record of previous, set to be positive
    1;
  }

  return sign;
}

function calculateCandleWidth(seriesModel, data) {
  var baseAxis = seriesModel.getBaseAxis();
  var extent;
  var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : (extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / data.count());
  var barMaxWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_number_js__["a" /* parsePercent */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["retrieve2"])(seriesModel.get('barMaxWidth'), bandWidth), bandWidth);
  var barMinWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_number_js__["a" /* parsePercent */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["retrieve2"])(seriesModel.get('barMinWidth'), 1), bandWidth);
  var barWidth = seriesModel.get('barWidth');
  return barWidth != null ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_number_js__["a" /* parsePercent */])(barWidth, bandWidth) // Put max outer to ensure bar visible in spite of overlap.
  : Math.max(Math.min(bandWidth / 2, barMaxWidth), barMinWidth);
}

/* harmony default export */ __webpack_exports__["a"] = (candlestickLayout);

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_createRenderPlanner_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


var positiveBorderColorQuery = ['itemStyle', 'borderColor'];
var negativeBorderColorQuery = ['itemStyle', 'borderColor0'];
var positiveColorQuery = ['itemStyle', 'color'];
var negativeColorQuery = ['itemStyle', 'color0'];
var candlestickVisual = {
  seriesType: 'candlestick',
  plan: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_createRenderPlanner_js__["a" /* default */])(),
  // For legend.
  performRawSeries: true,
  reset: function (seriesModel, ecModel) {
    function getColor(sign, model) {
      return model.get(sign > 0 ? positiveColorQuery : negativeColorQuery);
    }

    function getBorderColor(sign, model) {
      return model.get(sign > 0 ? positiveBorderColorQuery : negativeBorderColorQuery);
    } // Only visible series has each data be visual encoded


    if (ecModel.isSeriesFiltered(seriesModel)) {
      return;
    }

    var isLargeRender = seriesModel.pipelineContext.large;
    return !isLargeRender && {
      progress: function (params, data) {
        var dataIndex;

        while ((dataIndex = params.next()) != null) {
          var itemModel = data.getItemModel(dataIndex);
          var sign = data.getItemLayout(dataIndex).sign;
          var style = itemModel.getItemStyle();
          style.fill = getColor(sign, itemModel);
          style.stroke = getBorderColor(sign, itemModel) || style.fill;
          var existsStyle = data.ensureUniqueItemVisual(dataIndex, 'style');
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])(existsStyle, style);
        }
      }
    };
  }
};
/* harmony default export */ __webpack_exports__["a"] = (candlestickVisual);

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CandlestickView_js__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CandlestickSeries_js__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__preprocessor_js__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__candlestickVisual_js__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__candlestickLayout_js__ = __webpack_require__(1098);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





function install(registers) {
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_0__CandlestickView_js__["a" /* default */]);
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_1__CandlestickSeries_js__["a" /* default */]);
  registers.registerPreprocessor(__WEBPACK_IMPORTED_MODULE_2__preprocessor_js__["a" /* default */]);
  registers.registerVisual(__WEBPACK_IMPORTED_MODULE_3__candlestickVisual_js__["a" /* default */]);
  registers.registerLayout(__WEBPACK_IMPORTED_MODULE_4__candlestickLayout_js__["a" /* default */]);
}

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = candlestickPreprocessor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

function candlestickPreprocessor(option) {
  if (!option || !__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](option.series)) {
    return;
  } // Translate 'k' to 'candlestick'.


  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](option.series, function (seriesItem) {
    if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"](seriesItem) && seriesItem.type === 'k') {
      seriesItem.type = 'candlestick';
    }
  });
}

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_labelHelper_js__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_barGrid_js__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_DataDiffer_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helper_createClipPathFromCoordSys_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__coord_cartesian_prepareCustom_js__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__coord_geo_prepareCustom_js__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__coord_single_prepareCustom_js__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__coord_polar_prepareCustom_js__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__coord_calendar_prepareCustom_js__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_zrender_lib_graphic_Displayable_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_styleCompat_js__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_log_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_decal_js__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CustomSeries_js__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__animation_customGraphicTransition_js__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__animation_customGraphicKeyframeAnimation_js__ = __webpack_require__(440);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






















var EMPHASIS = 'emphasis';
var NORMAL = 'normal';
var BLUR = 'blur';
var SELECT = 'select';
var STATES = [NORMAL, EMPHASIS, BLUR, SELECT];
var PATH_ITEM_STYLE = {
  normal: ['itemStyle'],
  emphasis: [EMPHASIS, 'itemStyle'],
  blur: [BLUR, 'itemStyle'],
  select: [SELECT, 'itemStyle']
};
var PATH_LABEL = {
  normal: ['label'],
  emphasis: [EMPHASIS, 'label'],
  blur: [BLUR, 'label'],
  select: [SELECT, 'label']
};
var DEFAULT_TRANSITION = ['x', 'y']; // Use prefix to avoid index to be the same as el.name,
// which will cause weird update animation.

var GROUP_DIFF_PREFIX = 'e\0\0';
var attachedTxInfoTmp = {
  normal: {},
  emphasis: {},
  blur: {},
  select: {}
};
/**
 * To reduce total package size of each coordinate systems, the modules `prepareCustom`
 * of each coordinate systems are not required by each coordinate systems directly, but
 * required by the module `custom`.
 *
 * prepareInfoForCustomSeries {Function}: optional
 *     @return {Object} {coordSys: {...}, api: {
 *         coord: function (data, clamp) {}, // return point in global.
 *         size: function (dataSize, dataItem) {} // return size of each axis in coordSys.
 *     }}
 */

var prepareCustoms = {
  cartesian2d: __WEBPACK_IMPORTED_MODULE_10__coord_cartesian_prepareCustom_js__["a" /* default */],
  geo: __WEBPACK_IMPORTED_MODULE_11__coord_geo_prepareCustom_js__["a" /* default */],
  singleAxis: __WEBPACK_IMPORTED_MODULE_12__coord_single_prepareCustom_js__["a" /* default */],
  polar: __WEBPACK_IMPORTED_MODULE_13__coord_polar_prepareCustom_js__["a" /* default */],
  calendar: __WEBPACK_IMPORTED_MODULE_14__coord_calendar_prepareCustom_js__["a" /* default */]
};

function isPath(el) {
  return el instanceof __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Path"];
}

function isDisplayable(el) {
  return el instanceof __WEBPACK_IMPORTED_MODULE_15_zrender_lib_graphic_Displayable_js__["c" /* default */];
}

function copyElement(sourceEl, targetEl) {
  targetEl.copyTransform(sourceEl);

  if (isDisplayable(targetEl) && isDisplayable(sourceEl)) {
    targetEl.setStyle(sourceEl.style);
    targetEl.z = sourceEl.z;
    targetEl.z2 = sourceEl.z2;
    targetEl.zlevel = sourceEl.zlevel;
    targetEl.invisible = sourceEl.invisible;
    targetEl.ignore = sourceEl.ignore;

    if (isPath(targetEl) && isPath(sourceEl)) {
      targetEl.setShape(sourceEl.shape);
    }
  }
}

var CustomChartView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(CustomChartView, _super);

  function CustomChartView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = CustomChartView.type;
    return _this;
  }

  CustomChartView.prototype.render = function (customSeries, ecModel, api, payload) {
    // Clear previously rendered progressive elements.
    this._progressiveEls = null;
    var oldData = this._data;
    var data = customSeries.getData();
    var group = this.group;
    var renderItem = makeRenderItem(customSeries, data, ecModel, api);

    if (!oldData) {
      // Previous render is incremental render or first render.
      // Needs remove the incremental rendered elements.
      group.removeAll();
    }

    data.diff(oldData).add(function (newIdx) {
      createOrUpdateItem(api, null, newIdx, renderItem(newIdx, payload), customSeries, group, data);
    }).remove(function (oldIdx) {
      var el = oldData.getItemGraphicEl(oldIdx);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__animation_customGraphicTransition_js__["d" /* applyLeaveTransition */])(el, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__CustomSeries_js__["b" /* customInnerStore */])(el).option, customSeries);
    }).update(function (newIdx, oldIdx) {
      var oldEl = oldData.getItemGraphicEl(oldIdx);
      createOrUpdateItem(api, oldEl, newIdx, renderItem(newIdx, payload), customSeries, group, data);
    }).execute(); // Do clipping

    var clipPath = customSeries.get('clip', true) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_createClipPathFromCoordSys_js__["a" /* createClipPath */])(customSeries.coordinateSystem, false, customSeries) : null;

    if (clipPath) {
      group.setClipPath(clipPath);
    } else {
      group.removeClipPath();
    }

    this._data = data;
  };

  CustomChartView.prototype.incrementalPrepareRender = function (customSeries, ecModel, api) {
    this.group.removeAll();
    this._data = null;
  };

  CustomChartView.prototype.incrementalRender = function (params, customSeries, ecModel, api, payload) {
    var data = customSeries.getData();
    var renderItem = makeRenderItem(customSeries, data, ecModel, api);
    var progressiveEls = this._progressiveEls = [];

    function setIncrementalAndHoverLayer(el) {
      if (!el.isGroup) {
        el.incremental = true;
        el.ensureState('emphasis').hoverLayer = true;
      }
    }

    for (var idx = params.start; idx < params.end; idx++) {
      var el = createOrUpdateItem(null, null, idx, renderItem(idx, payload), customSeries, this.group, data);

      if (el) {
        el.traverse(setIncrementalAndHoverLayer);
        progressiveEls.push(el);
      }
    }
  };

  CustomChartView.prototype.eachRendered = function (cb) {
    __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["traverseElements"](this._progressiveEls || this.group, cb);
  };

  CustomChartView.prototype.filterForExposedEvent = function (eventType, query, targetEl, packedEvent) {
    var elementName = query.element;

    if (elementName == null || targetEl.name === elementName) {
      return true;
    } // Enable to give a name on a group made by `renderItem`, and listen
    // events that triggerd by its descendents.


    while ((targetEl = targetEl.__hostTarget || targetEl.parent) && targetEl !== this.group) {
      if (targetEl.name === elementName) {
        return true;
      }
    }

    return false;
  };

  CustomChartView.type = 'custom';
  return CustomChartView;
}(__WEBPACK_IMPORTED_MODULE_8__view_Chart_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CustomChartView);

function createEl(elOption) {
  var graphicType = elOption.type;
  var el; // Those graphic elements are not shapes. They should not be
  // overwritten by users, so do them first.

  if (graphicType === 'path') {
    var shape = elOption.shape; // Using pathRect brings convenience to users sacle svg path.

    var pathRect = shape.width != null && shape.height != null ? {
      x: shape.x || 0,
      y: shape.y || 0,
      width: shape.width,
      height: shape.height
    } : null;
    var pathData = getPathData(shape); // Path is also used for icon, so layout 'center' by default.

    el = __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["makePath"](pathData, null, pathRect, shape.layout || 'center');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__CustomSeries_js__["b" /* customInnerStore */])(el).customPathData = pathData;
  } else if (graphicType === 'image') {
    el = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Image"]({});
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__CustomSeries_js__["b" /* customInnerStore */])(el).customImagePath = elOption.style.image;
  } else if (graphicType === 'text') {
    el = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Text"]({}); // customInnerStore(el).customText = (elOption.style as TextStyleProps).text;
  } else if (graphicType === 'group') {
    el = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Group"]();
  } else if (graphicType === 'compoundPath') {
    throw new Error('"compoundPath" is not supported yet.');
  } else {
    var Clz = __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["getShapeClass"](graphicType);

    if (!Clz) {
      var errMsg = '';

      if (true) {
        errMsg = 'graphic type "' + graphicType + '" can not be found.';
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_log_js__["e" /* throwError */])(errMsg);
    }

    el = new Clz();
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__CustomSeries_js__["b" /* customInnerStore */])(el).customGraphicType = graphicType;
  el.name = elOption.name; // Compat ec4: the default z2 lift is 1. If changing the number,
  // some cases probably be broken: hierarchy layout along z, like circle packing,
  // where emphasis only intending to modify color/border rather than lift z2.

  el.z2EmphasisLift = 1;
  el.z2SelectLift = 1;
  return el;
}

function updateElNormal( // Can be null/undefined
api, el, dataIndex, elOption, attachedTxInfo, seriesModel, isInit) {
  // Stop and restore before update any other attributes.
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__animation_customGraphicKeyframeAnimation_js__["a" /* stopPreviousKeyframeAnimationAndRestore */])(el);
  var txCfgOpt = attachedTxInfo && attachedTxInfo.normal.cfg;

  if (txCfgOpt) {
    // PENDING: whether use user object directly rather than clone?
    // TODO:5.0 textConfig transition animation?
    el.setTextConfig(txCfgOpt);
  } // Default transition ['x', 'y']


  if (elOption && elOption.transition == null) {
    elOption.transition = DEFAULT_TRANSITION;
  } // Do some normalization on style.


  var styleOpt = elOption && elOption.style;

  if (styleOpt) {
    if (el.type === 'text') {
      var textOptionStyle = styleOpt; // Compatible with ec4: if `textFill` or `textStroke` exists use them.

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["hasOwn"])(textOptionStyle, 'textFill') && (textOptionStyle.fill = textOptionStyle.textFill);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["hasOwn"])(textOptionStyle, 'textStroke') && (textOptionStyle.stroke = textOptionStyle.textStroke);
    }

    var decalPattern = void 0;
    var decalObj = isPath(el) ? styleOpt.decal : null;

    if (api && decalObj) {
      decalObj.dirty = true;
      decalPattern = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_decal_js__["a" /* createOrUpdatePatternFromDecal */])(decalObj, api);
    } // Always overwrite in case user specify this prop.


    styleOpt.__decalPattern = decalPattern;
  }

  if (isDisplayable(el)) {
    if (styleOpt) {
      var decalPattern = styleOpt.__decalPattern;

      if (decalPattern) {
        styleOpt.decal = decalPattern;
      }
    }
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__animation_customGraphicTransition_js__["a" /* applyUpdateTransition */])(el, elOption, seriesModel, {
    dataIndex: dataIndex,
    isInit: isInit,
    clearStyle: true
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__animation_customGraphicKeyframeAnimation_js__["b" /* applyKeyframeAnimation */])(el, elOption.keyframeAnimation, seriesModel);
}

function updateElOnState(state, el, elStateOpt, styleOpt, attachedTxInfo) {
  var elDisplayable = el.isGroup ? null : el;
  var txCfgOpt = attachedTxInfo && attachedTxInfo[state].cfg; // PENDING:5.0 support customize scale change and transition animation?

  if (elDisplayable) {
    // By default support auto lift color when hover whether `emphasis` specified.
    var stateObj = elDisplayable.ensureState(state);

    if (styleOpt === false) {
      var existingEmphasisState = elDisplayable.getState(state);

      if (existingEmphasisState) {
        existingEmphasisState.style = null;
      }
    } else {
      // style is needed to enable defaut emphasis.
      stateObj.style = styleOpt || null;
    } // If `elOption.styleEmphasis` or `elOption.emphasis.style` is `false`,
    // remove hover style.
    // If `elOption.textConfig` or `elOption.emphasis.textConfig` is null/undefined, it does not
    // make sense. So for simplicity, we do not ditinguish `hasOwnProperty` and null/undefined.


    if (txCfgOpt) {
      stateObj.textConfig = txCfgOpt;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_states_js__["H" /* setDefaultStateProxy */])(elDisplayable);
  }
}

function updateZ(el, elOption, seriesModel) {
  // Group not support textContent and not support z yet.
  if (el.isGroup) {
    return;
  }

  var elDisplayable = el;
  var currentZ = seriesModel.currentZ;
  var currentZLevel = seriesModel.currentZLevel; // Always erase.

  elDisplayable.z = currentZ;
  elDisplayable.zlevel = currentZLevel; // z2 must not be null/undefined, otherwise sort error may occur.

  var optZ2 = elOption.z2;
  optZ2 != null && (elDisplayable.z2 = optZ2 || 0);

  for (var i = 0; i < STATES.length; i++) {
    updateZForEachState(elDisplayable, elOption, STATES[i]);
  }
}

function updateZForEachState(elDisplayable, elOption, state) {
  var isNormal = state === NORMAL;
  var elStateOpt = isNormal ? elOption : retrieveStateOption(elOption, state);
  var optZ2 = elStateOpt ? elStateOpt.z2 : null;
  var stateObj;

  if (optZ2 != null) {
    // Do not `ensureState` until required.
    stateObj = isNormal ? elDisplayable : elDisplayable.ensureState(state);
    stateObj.z2 = optZ2 || 0;
  }
}

function makeRenderItem(customSeries, data, ecModel, api) {
  var renderItem = customSeries.get('renderItem');
  var coordSys = customSeries.coordinateSystem;
  var prepareResult = {};

  if (coordSys) {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"])(renderItem, 'series.render is required.');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"])(coordSys.prepareCustoms || prepareCustoms[coordSys.type], 'This coordSys does not support custom series.');
    } // `coordSys.prepareCustoms` is used for external coord sys like bmap.


    prepareResult = coordSys.prepareCustoms ? coordSys.prepareCustoms(coordSys) : prepareCustoms[coordSys.type](coordSys);
  }

  var userAPI = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"])({
    getWidth: api.getWidth,
    getHeight: api.getHeight,
    getZr: api.getZr,
    getDevicePixelRatio: api.getDevicePixelRatio,
    value: value,
    style: style,
    ordinalRawValue: ordinalRawValue,
    styleEmphasis: styleEmphasis,
    visual: visual,
    barLayout: barLayout,
    currentSeriesIndices: currentSeriesIndices,
    font: font
  }, prepareResult.api || {});
  var userParams = {
    // The life cycle of context: current round of rendering.
    // The global life cycle is probably not necessary, because
    // user can store global status by themselves.
    context: {},
    seriesId: customSeries.id,
    seriesName: customSeries.name,
    seriesIndex: customSeries.seriesIndex,
    coordSys: prepareResult.coordSys,
    dataInsideLength: data.count(),
    encode: wrapEncodeDef(customSeries.getData())
  }; // If someday intending to refactor them to a class, should consider do not
  // break change: currently these attribute member are encapsulated in a closure
  // so that do not need to force user to call these method with a scope.
  // Do not support call `api` asynchronously without dataIndexInside input.

  var currDataIndexInside;
  var currItemModel;
  var currItemStyleModels = {};
  var currLabelModels = {};
  var seriesItemStyleModels = {};
  var seriesLabelModels = {};

  for (var i = 0; i < STATES.length; i++) {
    var stateName = STATES[i];
    seriesItemStyleModels[stateName] = customSeries.getModel(PATH_ITEM_STYLE[stateName]);
    seriesLabelModels[stateName] = customSeries.getModel(PATH_LABEL[stateName]);
  }

  function getItemModel(dataIndexInside) {
    return dataIndexInside === currDataIndexInside ? currItemModel || (currItemModel = data.getItemModel(dataIndexInside)) : data.getItemModel(dataIndexInside);
  }

  function getItemStyleModel(dataIndexInside, state) {
    return !data.hasItemOption ? seriesItemStyleModels[state] : dataIndexInside === currDataIndexInside ? currItemStyleModels[state] || (currItemStyleModels[state] = getItemModel(dataIndexInside).getModel(PATH_ITEM_STYLE[state])) : getItemModel(dataIndexInside).getModel(PATH_ITEM_STYLE[state]);
  }

  function getLabelModel(dataIndexInside, state) {
    return !data.hasItemOption ? seriesLabelModels[state] : dataIndexInside === currDataIndexInside ? currLabelModels[state] || (currLabelModels[state] = getItemModel(dataIndexInside).getModel(PATH_LABEL[state])) : getItemModel(dataIndexInside).getModel(PATH_LABEL[state]);
  }

  return function (dataIndexInside, payload) {
    currDataIndexInside = dataIndexInside;
    currItemModel = null;
    currItemStyleModels = {};
    currLabelModels = {};
    return renderItem && renderItem(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"])({
      dataIndexInside: dataIndexInside,
      dataIndex: data.getRawIndex(dataIndexInside),
      // Can be used for optimization when zoom or roam.
      actionType: payload ? payload.type : null
    }, userParams), userAPI);
  };
  /**
   * @public
   * @param dim by default 0.
   * @param dataIndexInside by default `currDataIndexInside`.
   */

  function value(dim, dataIndexInside) {
    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
    return data.getStore().get(data.getDimensionIndex(dim || 0), dataIndexInside);
  }
  /**
   * @public
   * @param dim by default 0.
   * @param dataIndexInside by default `currDataIndexInside`.
   */


  function ordinalRawValue(dim, dataIndexInside) {
    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
    dim = dim || 0;
    var dimInfo = data.getDimensionInfo(dim);

    if (!dimInfo) {
      var dimIndex = data.getDimensionIndex(dim);
      return dimIndex >= 0 ? data.getStore().get(dimIndex, dataIndexInside) : undefined;
    }

    var val = data.get(dimInfo.name, dataIndexInside);
    var ordinalMeta = dimInfo && dimInfo.ordinalMeta;
    return ordinalMeta ? ordinalMeta.categories[val] : val;
  }
  /**
   * @deprecated The orgininal intention of `api.style` is enable to set itemStyle
   * like other series. But it not necessary and not easy to give a strict definition
   * of what it return. And since echarts5 it needs to be make compat work. So
   * deprecates it since echarts5.
   *
   * By default, `visual` is applied to style (to support visualMap).
   * `visual.color` is applied at `fill`. If user want apply visual.color on `stroke`,
   * it can be implemented as:
   * `api.style({stroke: api.visual('color'), fill: null})`;
   *
   * [Compat]: since ec5, RectText has been separated from its hosts el.
   * so `api.style()` will only return the style from `itemStyle` but not handle `label`
   * any more. But `series.label` config is never published in doc.
   * We still compat it in `api.style()`. But not encourage to use it and will still not
   * to pulish it to doc.
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */


  function style(userProps, dataIndexInside) {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_styleCompat_js__["c" /* warnDeprecated */])('api.style', 'Please write literal style directly instead.');
    }

    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
    var style = data.getItemVisual(dataIndexInside, 'style');
    var visualColor = style && style.fill;
    var opacity = style && style.opacity;
    var itemStyle = getItemStyleModel(dataIndexInside, NORMAL).getItemStyle();
    visualColor != null && (itemStyle.fill = visualColor);
    opacity != null && (itemStyle.opacity = opacity);
    var opt = {
      inheritColor: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"])(visualColor) ? visualColor : '#000'
    };
    var labelModel = getLabelModel(dataIndexInside, NORMAL); // Now that the feture of "auto adjust text fill/stroke" has been migrated to zrender
    // since ec5, we should set `isAttached` as `false` here and make compat in
    // `convertToEC4StyleForCustomSerise`.

    var textStyle = __WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["d" /* createTextStyle */](labelModel, null, opt, false, true);
    textStyle.text = labelModel.getShallow('show') ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["retrieve2"])(customSeries.getFormattedLabel(dataIndexInside, NORMAL), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helper_labelHelper_js__["a" /* getDefaultLabel */])(data, dataIndexInside)) : null;
    var textConfig = __WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["g" /* createTextConfig */](labelModel, opt, false);
    preFetchFromExtra(userProps, itemStyle);
    itemStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_styleCompat_js__["d" /* convertToEC4StyleForCustomSerise */])(itemStyle, textStyle, textConfig);
    userProps && applyUserPropsAfter(itemStyle, userProps);
    itemStyle.legacy = true;
    return itemStyle;
  }
  /**
   * @deprecated The reason see `api.style()`
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */


  function styleEmphasis(userProps, dataIndexInside) {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_styleCompat_js__["c" /* warnDeprecated */])('api.styleEmphasis', 'Please write literal style directly instead.');
    }

    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
    var itemStyle = getItemStyleModel(dataIndexInside, EMPHASIS).getItemStyle();
    var labelModel = getLabelModel(dataIndexInside, EMPHASIS);
    var textStyle = __WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["d" /* createTextStyle */](labelModel, null, null, true, true);
    textStyle.text = labelModel.getShallow('show') ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["retrieve3"])(customSeries.getFormattedLabel(dataIndexInside, EMPHASIS), customSeries.getFormattedLabel(dataIndexInside, NORMAL), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helper_labelHelper_js__["a" /* getDefaultLabel */])(data, dataIndexInside)) : null;
    var textConfig = __WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["g" /* createTextConfig */](labelModel, null, true);
    preFetchFromExtra(userProps, itemStyle);
    itemStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_styleCompat_js__["d" /* convertToEC4StyleForCustomSerise */])(itemStyle, textStyle, textConfig);
    userProps && applyUserPropsAfter(itemStyle, userProps);
    itemStyle.legacy = true;
    return itemStyle;
  }

  function applyUserPropsAfter(itemStyle, extra) {
    for (var key in extra) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["hasOwn"])(extra, key)) {
        itemStyle[key] = extra[key];
      }
    }
  }

  function preFetchFromExtra(extra, itemStyle) {
    // A trick to retrieve those props firstly, which are used to
    // apply auto inside fill/stroke in `convertToEC4StyleForCustomSerise`.
    // (It's not reasonable but only for a degree of compat)
    if (extra) {
      extra.textFill && (itemStyle.textFill = extra.textFill);
      extra.textPosition && (itemStyle.textPosition = extra.textPosition);
    }
  }
  /**
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */


  function visual(visualType, dataIndexInside) {
    dataIndexInside == null && (dataIndexInside = currDataIndexInside);

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["hasOwn"])(__WEBPACK_IMPORTED_MODULE_19__CustomSeries_js__["c" /* STYLE_VISUAL_TYPE */], visualType)) {
      var style_1 = data.getItemVisual(dataIndexInside, 'style');
      return style_1 ? style_1[__WEBPACK_IMPORTED_MODULE_19__CustomSeries_js__["c" /* STYLE_VISUAL_TYPE */][visualType]] : null;
    } // Only support these visuals. Other visual might be inner tricky
    // for performance (like `style`), do not expose to users.


    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["hasOwn"])(__WEBPACK_IMPORTED_MODULE_19__CustomSeries_js__["d" /* NON_STYLE_VISUAL_PROPS */], visualType)) {
      return data.getItemVisual(dataIndexInside, visualType);
    }
  }
  /**
   * @public
   * @return If not support, return undefined.
   */


  function barLayout(opt) {
    if (coordSys.type === 'cartesian2d') {
      var baseAxis = coordSys.getBaseAxis();
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__layout_barGrid_js__["d" /* getLayoutOnAxis */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"])({
        axis: baseAxis
      }, opt));
    }
  }
  /**
   * @public
   */


  function currentSeriesIndices() {
    return ecModel.getCurrentSeriesIndices();
  }
  /**
   * @public
   * @return font string
   */


  function font(opt) {
    return __WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["c" /* getFont */](opt, ecModel);
  }
}

function wrapEncodeDef(data) {
  var encodeDef = {};
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(data.dimensions, function (dimName) {
    var dimInfo = data.getDimensionInfo(dimName);

    if (!dimInfo.isExtraCoord) {
      var coordDim = dimInfo.coordDim;
      var dataDims = encodeDef[coordDim] = encodeDef[coordDim] || [];
      dataDims[dimInfo.coordDimIndex] = data.getDimensionIndex(dimName);
    }
  });
  return encodeDef;
}

function createOrUpdateItem(api, existsEl, dataIndex, elOption, seriesModel, group, data) {
  // [Rule]
  // If `renderItem` returns `null`/`undefined`/`false`, remove the previous el if existing.
  //     (It seems that violate the "merge" principle, but most of users probably intuitively
  //     regard "return;" as "show nothing element whatever", so make a exception to meet the
  //     most cases.)
  // The rule or "merge" see [STRATEGY_MERGE].
  // If `elOption` is `null`/`undefined`/`false` (when `renderItem` returns nothing).
  if (!elOption) {
    group.remove(existsEl);
    return;
  }

  var el = doCreateOrUpdateEl(api, existsEl, dataIndex, elOption, seriesModel, group);
  el && data.setItemGraphicEl(dataIndex, el);
  el && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_states_js__["G" /* toggleHoverEmphasis */])(el, elOption.focus, elOption.blurScope, elOption.emphasisDisabled);
  return el;
}

function doCreateOrUpdateEl(api, existsEl, dataIndex, elOption, seriesModel, group) {
  if (true) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"])(elOption, 'should not have an null/undefined element setting');
  }

  var toBeReplacedIdx = -1;
  var oldEl = existsEl;

  if (existsEl && doesElNeedRecreate(existsEl, elOption, seriesModel) // || (
  //     // PENDING: even in one-to-one mapping case, if el is marked as morph,
  //     // do not sure whether the el will be mapped to another el with different
  //     // hierarchy in Group tree. So always recreate el rather than reuse the el.
  //     morphHelper && morphHelper.isOneToOneFrom(el)
  // )
  ) {
    // Should keep at the original index, otherwise "merge by index" will be incorrect.
    toBeReplacedIdx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["indexOf"])(group.childrenRef(), existsEl);
    existsEl = null;
  }

  var isInit = !existsEl;
  var el = existsEl;

  if (!el) {
    el = createEl(elOption);

    if (oldEl) {
      copyElement(oldEl, el);
    }
  } else {
    // FIMXE:NEXT unified clearState?
    // If in some case the performance issue arised, consider
    // do not clearState but update cached normal state directly.
    el.clearStates();
  } // Need to set morph: false explictly to disable automatically morphing.


  if (elOption.morph === false) {
    el.disableMorphing = true;
  } else if (el.disableMorphing) {
    el.disableMorphing = false;
  }

  attachedTxInfoTmp.normal.cfg = attachedTxInfoTmp.normal.conOpt = attachedTxInfoTmp.emphasis.cfg = attachedTxInfoTmp.emphasis.conOpt = attachedTxInfoTmp.blur.cfg = attachedTxInfoTmp.blur.conOpt = attachedTxInfoTmp.select.cfg = attachedTxInfoTmp.select.conOpt = null;
  attachedTxInfoTmp.isLegacy = false;
  doCreateOrUpdateAttachedTx(el, dataIndex, elOption, seriesModel, isInit, attachedTxInfoTmp);
  doCreateOrUpdateClipPath(el, dataIndex, elOption, seriesModel, isInit);
  updateElNormal(api, el, dataIndex, elOption, attachedTxInfoTmp, seriesModel, isInit); // `elOption.info` enables user to mount some info on
  // elements and use them in event handlers.
  // Update them only when user specified, otherwise, remain.

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["hasOwn"])(elOption, 'info') && (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__CustomSeries_js__["b" /* customInnerStore */])(el).info = elOption.info);

  for (var i = 0; i < STATES.length; i++) {
    var stateName = STATES[i];

    if (stateName !== NORMAL) {
      var otherStateOpt = retrieveStateOption(elOption, stateName);
      var otherStyleOpt = retrieveStyleOptionOnState(elOption, otherStateOpt, stateName);
      updateElOnState(stateName, el, otherStateOpt, otherStyleOpt, attachedTxInfoTmp);
    }
  }

  updateZ(el, elOption, seriesModel);

  if (elOption.type === 'group') {
    mergeChildren(api, el, dataIndex, elOption, seriesModel);
  }

  if (toBeReplacedIdx >= 0) {
    group.replaceAt(el, toBeReplacedIdx);
  } else {
    group.add(el);
  }

  return el;
} // `el` must not be null/undefined.


function doesElNeedRecreate(el, elOption, seriesModel) {
  var elInner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__CustomSeries_js__["b" /* customInnerStore */])(el);
  var elOptionType = elOption.type;
  var elOptionShape = elOption.shape;
  var elOptionStyle = elOption.style;
  return (// Always create new if universal transition is enabled.
    // Because we do transition after render. It needs to know what old element is. Replacement will loose it.
    seriesModel.isUniversalTransitionEnabled() // If `elOptionType` is `null`, follow the merge principle.
    || elOptionType != null && elOptionType !== elInner.customGraphicType || elOptionType === 'path' && hasOwnPathData(elOptionShape) && getPathData(elOptionShape) !== elInner.customPathData || elOptionType === 'image' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["hasOwn"])(elOptionStyle, 'image') && elOptionStyle.image !== elInner.customImagePath // // FIXME test and remove this restriction?
    // || (elOptionType === 'text'
    //     && hasOwn(elOptionStyle, 'text')
    //     && (elOptionStyle as TextStyleProps).text !== elInner.customText
    // )

  );
}

function doCreateOrUpdateClipPath(el, dataIndex, elOption, seriesModel, isInit) {
  // Based on the "merge" principle, if no clipPath provided,
  // do nothing. The exists clip will be totally removed only if
  // `el.clipPath` is `false`. Otherwise it will be merged/replaced.
  var clipPathOpt = elOption.clipPath;

  if (clipPathOpt === false) {
    if (el && el.getClipPath()) {
      el.removeClipPath();
    }
  } else if (clipPathOpt) {
    var clipPath = el.getClipPath();

    if (clipPath && doesElNeedRecreate(clipPath, clipPathOpt, seriesModel)) {
      clipPath = null;
    }

    if (!clipPath) {
      clipPath = createEl(clipPathOpt);

      if (true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"])(isPath(clipPath), 'Only any type of `path` can be used in `clipPath`, rather than ' + clipPath.type + '.');
      }

      el.setClipPath(clipPath);
    }

    updateElNormal(null, clipPath, dataIndex, clipPathOpt, null, seriesModel, isInit);
  } // If not define `clipPath` in option, do nothing unnecessary.

}

function doCreateOrUpdateAttachedTx(el, dataIndex, elOption, seriesModel, isInit, attachedTxInfo) {
  // group do not support textContent temporarily untill necessary.
  if (el.isGroup) {
    return;
  } // Normal must be called before emphasis, for `isLegacy` detection.


  processTxInfo(elOption, null, attachedTxInfo);
  processTxInfo(elOption, EMPHASIS, attachedTxInfo); // If `elOption.textConfig` or `elOption.textContent` is null/undefined, it does not make sence.
  // So for simplicity, if "elOption hasOwnProperty of them but be null/undefined", we do not
  // trade them as set to null to el.
  // Especially:
  // `elOption.textContent: false` means remove textContent.
  // `elOption.textContent.emphasis.style: false` means remove the style from emphasis state.

  var txConOptNormal = attachedTxInfo.normal.conOpt;
  var txConOptEmphasis = attachedTxInfo.emphasis.conOpt;
  var txConOptBlur = attachedTxInfo.blur.conOpt;
  var txConOptSelect = attachedTxInfo.select.conOpt;

  if (txConOptNormal != null || txConOptEmphasis != null || txConOptSelect != null || txConOptBlur != null) {
    var textContent = el.getTextContent();

    if (txConOptNormal === false) {
      textContent && el.removeTextContent();
    } else {
      txConOptNormal = attachedTxInfo.normal.conOpt = txConOptNormal || {
        type: 'text'
      };

      if (!textContent) {
        textContent = createEl(txConOptNormal);
        el.setTextContent(textContent);
      } else {
        // If in some case the performance issue arised, consider
        // do not clearState but update cached normal state directly.
        textContent.clearStates();
      }

      updateElNormal(null, textContent, dataIndex, txConOptNormal, null, seriesModel, isInit);
      var txConStlOptNormal = txConOptNormal && txConOptNormal.style;

      for (var i = 0; i < STATES.length; i++) {
        var stateName = STATES[i];

        if (stateName !== NORMAL) {
          var txConOptOtherState = attachedTxInfo[stateName].conOpt;
          updateElOnState(stateName, textContent, txConOptOtherState, retrieveStyleOptionOnState(txConOptNormal, txConOptOtherState, stateName), null);
        }
      }

      txConStlOptNormal ? textContent.dirty() : textContent.markRedraw();
    }
  }
}

function processTxInfo(elOption, state, attachedTxInfo) {
  var stateOpt = !state ? elOption : retrieveStateOption(elOption, state);
  var styleOpt = !state ? elOption.style : retrieveStyleOptionOnState(elOption, stateOpt, EMPHASIS);
  var elType = elOption.type;
  var txCfg = stateOpt ? stateOpt.textConfig : null;
  var txConOptNormal = elOption.textContent;
  var txConOpt = !txConOptNormal ? null : !state ? txConOptNormal : retrieveStateOption(txConOptNormal, state);

  if (styleOpt && ( // Because emphasis style has little info to detect legacy,
  // if normal is legacy, emphasis is trade as legacy.
  attachedTxInfo.isLegacy || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_styleCompat_js__["a" /* isEC4CompatibleStyle */])(styleOpt, elType, !!txCfg, !!txConOpt))) {
    attachedTxInfo.isLegacy = true;
    var convertResult = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_styleCompat_js__["b" /* convertFromEC4CompatibleStyle */])(styleOpt, elType, !state); // Explicitly specified `textConfig` and `textContent` has higher priority than
    // the ones generated by legacy style. Otherwise if users use them and `api.style`
    // at the same time, they not both work and hardly to known why.

    if (!txCfg && convertResult.textConfig) {
      txCfg = convertResult.textConfig;
    }

    if (!txConOpt && convertResult.textContent) {
      txConOpt = convertResult.textContent;
    }
  }

  if (!state && txConOpt) {
    var txConOptNormal_1 = txConOpt; // `textContent: {type: 'text'}`, the "type" is easy to be missing. So we tolerate it.

    !txConOptNormal_1.type && (txConOptNormal_1.type = 'text');

    if (true) {
      // Do not tolerate incorret type for forward compat.
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"])(txConOptNormal_1.type === 'text', 'textContent.type must be "text"');
    }
  }

  var info = !state ? attachedTxInfo.normal : attachedTxInfo[state];
  info.cfg = txCfg;
  info.conOpt = txConOpt;
}

function retrieveStateOption(elOption, state) {
  return !state ? elOption : elOption ? elOption[state] : null;
}

function retrieveStyleOptionOnState(stateOptionNormal, stateOption, state) {
  var style = stateOption && stateOption.style;

  if (style == null && state === EMPHASIS && stateOptionNormal) {
    style = stateOptionNormal.styleEmphasis;
  }

  return style;
} // Usage:
// (1) By default, `elOption.$mergeChildren` is `'byIndex'`, which indicates that
//     the existing children will not be removed, and enables the feature that
//     update some of the props of some of the children simply by construct
//     the returned children of `renderItem` like:
//     `var children = group.children = []; children[3] = {opacity: 0.5};`
// (2) If `elOption.$mergeChildren` is `'byName'`, add/update/remove children
//     by child.name. But that might be lower performance.
// (3) If `elOption.$mergeChildren` is `false`, the existing children will be
//     replaced totally.
// (4) If `!elOption.children`, following the "merge" principle, nothing will happen.
//
// For implementation simpleness, do not provide a direct way to remove sinlge
// child (otherwise the total indicies of the children array have to be modified).
// User can remove a single child by set its `ignore` as `true`.


function mergeChildren(api, el, dataIndex, elOption, seriesModel) {
  var newChildren = elOption.children;
  var newLen = newChildren ? newChildren.length : 0;
  var mergeChildren = elOption.$mergeChildren; // `diffChildrenByName` has been deprecated.

  var byName = mergeChildren === 'byName' || elOption.diffChildrenByName;
  var notMerge = mergeChildren === false; // For better performance on roam update, only enter if necessary.

  if (!newLen && !byName && !notMerge) {
    return;
  }

  if (byName) {
    diffGroupChildren({
      api: api,
      oldChildren: el.children() || [],
      newChildren: newChildren || [],
      dataIndex: dataIndex,
      seriesModel: seriesModel,
      group: el
    });
    return;
  }

  notMerge && el.removeAll(); // Mapping children of a group simply by index, which
  // might be better performance.

  var index = 0;

  for (; index < newLen; index++) {
    newChildren[index] && doCreateOrUpdateEl(api, el.childAt(index), dataIndex, newChildren[index], seriesModel, el);
  }

  for (var i = el.childCount() - 1; i >= index; i--) {
    // Do not supprot leave elements that are not mentioned in the latest
    // `renderItem` return. Otherwise users may not have a clear and simple
    // concept that how to contorl all of the elements.
    var child = el.childAt(i);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__animation_customGraphicTransition_js__["d" /* applyLeaveTransition */])(child, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__CustomSeries_js__["b" /* customInnerStore */])(el).option, seriesModel);
  }
}

function diffGroupChildren(context) {
  new __WEBPACK_IMPORTED_MODULE_7__data_DataDiffer_js__["a" /* default */](context.oldChildren, context.newChildren, getKey, getKey, context).add(processAddUpdate).update(processAddUpdate).remove(processRemove).execute();
}

function getKey(item, idx) {
  var name = item && item.name;
  return name != null ? name : GROUP_DIFF_PREFIX + idx;
}

function processAddUpdate(newIndex, oldIndex) {
  var context = this.context;
  var childOption = newIndex != null ? context.newChildren[newIndex] : null;
  var child = oldIndex != null ? context.oldChildren[oldIndex] : null;
  doCreateOrUpdateEl(context.api, child, context.dataIndex, childOption, context.seriesModel, context.group);
}

function processRemove(oldIndex) {
  var context = this.context;
  var child = context.oldChildren[oldIndex];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__animation_customGraphicTransition_js__["d" /* applyLeaveTransition */])(child, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__CustomSeries_js__["b" /* customInnerStore */])(child).option, context.seriesModel);
}
/**
 * @return SVG Path data.
 */


function getPathData(shape) {
  // "d" follows the SVG convention.
  return shape && (shape.pathData || shape.d);
}

function hasOwnPathData(shape) {
  return shape && (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["hasOwn"])(shape, 'pathData') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["hasOwn"])(shape, 'd'));
}

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CustomSeries_js__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CustomView_js__ = __webpack_require__(1102);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


function install(registers) {
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_1__CustomView_js__["a" /* default */]);
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_0__CustomSeries_js__["a" /* default */]);
}

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_createSeriesData_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_Series_js__ = __webpack_require__(26);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var EffectScatterSeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(EffectScatterSeriesModel, _super);

  function EffectScatterSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = EffectScatterSeriesModel.type;
    _this.hasSymbolVisual = true;
    return _this;
  }

  EffectScatterSeriesModel.prototype.getInitialData = function (option, ecModel) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper_createSeriesData_js__["a" /* default */])(null, this, {
      useEncodeDefaulter: true
    });
  };

  EffectScatterSeriesModel.prototype.brushSelector = function (dataIndex, data, selectors) {
    return selectors.point(data.getItemLayout(dataIndex));
  };

  EffectScatterSeriesModel.type = 'series.effectScatter';
  EffectScatterSeriesModel.dependencies = ['grid', 'polar'];
  EffectScatterSeriesModel.defaultOption = {
    coordinateSystem: 'cartesian2d',
    // zlevel: 0,
    z: 2,
    legendHoverLink: true,
    effectType: 'ripple',
    progressive: 0,
    // When to show the effect, option: 'render'|'emphasis'
    showEffectOn: 'render',
    clip: true,
    // Ripple effect config
    rippleEffect: {
      period: 4,
      // Scale of ripple
      scale: 2.5,
      // Brush type can be fill or stroke
      brushType: 'fill',
      // Ripple number
      number: 3
    },
    universalTransition: {
      divideShape: 'clone'
    },
    // Cartesian coordinate system
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // Polar coordinate system
    // polarIndex: 0,
    // Geo coordinate system
    // geoIndex: 0,
    // symbol: null,        // 图形类型
    symbolSize: 10 // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
    // symbolRotate: null,  // 图形旋转控制
    // itemStyle: {
    //     opacity: 1
    // }

  };
  return EffectScatterSeriesModel;
}(__WEBPACK_IMPORTED_MODULE_2__model_Series_js__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (EffectScatterSeriesModel);

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_SymbolDraw_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_EffectSymbol_js__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_matrix_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_points_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_Chart_js__ = __webpack_require__(27);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







var EffectScatterView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(EffectScatterView, _super);

  function EffectScatterView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = EffectScatterView.type;
    return _this;
  }

  EffectScatterView.prototype.init = function () {
    this._symbolDraw = new __WEBPACK_IMPORTED_MODULE_1__helper_SymbolDraw_js__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2__helper_EffectSymbol_js__["a" /* default */]);
  };

  EffectScatterView.prototype.render = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var effectSymbolDraw = this._symbolDraw;
    effectSymbolDraw.updateData(data, {
      clipShape: this._getClipShape(seriesModel)
    });
    this.group.add(effectSymbolDraw.group);
  };

  EffectScatterView.prototype._getClipShape = function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
    return seriesModel.get('clip', true) ? clipArea : null;
  };

  EffectScatterView.prototype.updateTransform = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    this.group.dirty();
    var res = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__layout_points_js__["a" /* default */])('').reset(seriesModel, ecModel, api);

    if (res.progress) {
      res.progress({
        start: 0,
        end: data.count(),
        count: data.count()
      }, data);
    }

    this._symbolDraw.updateLayout();
  };

  EffectScatterView.prototype._updateGroupTransform = function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys && coordSys.getRoamTransform) {
      this.group.transform = __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_matrix_js__["clone"](coordSys.getRoamTransform());
      this.group.decomposeTransform();
    }
  };

  EffectScatterView.prototype.remove = function (ecModel, api) {
    this._symbolDraw && this._symbolDraw.remove(true);
  };

  EffectScatterView.type = 'effectScatter';
  return EffectScatterView;
}(__WEBPACK_IMPORTED_MODULE_5__view_Chart_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (EffectScatterView);

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EffectScatterView_js__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EffectScatterSeries_js__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_points_js__ = __webpack_require__(195);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



function install(registers) {
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_0__EffectScatterView_js__["a" /* default */]);
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_1__EffectScatterSeries_js__["a" /* default */]);
  registers.registerLayout(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__layout_points_js__["a" /* default */])('effectScatter'));
}

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_createSeriesDataSimply_js__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_helper_sourceHelper_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__visual_LegendVisualProvider_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_Series_js__ = __webpack_require__(26);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/








var FunnelSeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(FunnelSeriesModel, _super);

  function FunnelSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = FunnelSeriesModel.type;
    return _this;
  }

  FunnelSeriesModel.prototype.init = function (option) {
    _super.prototype.init.apply(this, arguments); // Enable legend selection for each data item
    // Use a function instead of direct access because data reference may changed


    this.legendVisualProvider = new __WEBPACK_IMPORTED_MODULE_5__visual_LegendVisualProvider_js__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"](this.getData, this), __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"](this.getRawData, this)); // Extend labelLine emphasis

    this._defaultLabelLine(option);
  };

  FunnelSeriesModel.prototype.getInitialData = function (option, ecModel) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_createSeriesDataSimply_js__["a" /* default */])(this, {
      coordDimensions: ['value'],
      encodeDefaulter: __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["curry"](__WEBPACK_IMPORTED_MODULE_4__data_helper_sourceHelper_js__["g" /* makeSeriesEncodeForNameBased */], this)
    });
  };

  FunnelSeriesModel.prototype._defaultLabelLine = function (option) {
    // Extend labelLine emphasis
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_model_js__["e" /* defaultEmphasis */])(option, 'labelLine', ['show']);
    var labelLineNormalOpt = option.labelLine;
    var labelLineEmphasisOpt = option.emphasis.labelLine; // Not show label line if `label.normal.show = false`

    labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
    labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
  }; // Overwrite


  FunnelSeriesModel.prototype.getDataParams = function (dataIndex) {
    var data = this.getData();

    var params = _super.prototype.getDataParams.call(this, dataIndex);

    var valueDim = data.mapDimension('value');
    var sum = data.getSum(valueDim); // Percent is 0 if sum is 0

    params.percent = !sum ? 0 : +(data.get(valueDim, dataIndex) / sum * 100).toFixed(2);
    params.$vars.push('percent');
    return params;
  };

  FunnelSeriesModel.type = 'series.funnel';
  FunnelSeriesModel.defaultOption = {
    // zlevel: 0,                  // 一级层叠
    z: 2,
    legendHoverLink: true,
    colorBy: 'data',
    left: 80,
    top: 60,
    right: 80,
    bottom: 60,
    // width: {totalWidth} - left - right,
    // height: {totalHeight} - top - bottom,
    // 默认取数据最小最大值
    // min: 0,
    // max: 100,
    minSize: '0%',
    maxSize: '100%',
    sort: 'descending',
    orient: 'vertical',
    gap: 0,
    funnelAlign: 'center',
    label: {
      show: true,
      position: 'outer' // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调

    },
    labelLine: {
      show: true,
      length: 20,
      lineStyle: {
        // color: 各异,
        width: 1
      }
    },
    itemStyle: {
      // color: 各异,
      borderColor: '#fff',
      borderWidth: 1
    },
    emphasis: {
      label: {
        show: true
      }
    },
    select: {
      itemStyle: {
        borderColor: '#212121'
      }
    }
  };
  return FunnelSeriesModel;
}(__WEBPACK_IMPORTED_MODULE_6__model_Series_js__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (FunnelSeriesModel);

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__label_labelGuideHelper_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__animation_basicTrasition_js__ = __webpack_require__(40);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







var opacityAccessPath = ['itemStyle', 'opacity'];
/**
 * Piece of pie including Sector, Label, LabelLine
 */

var FunnelPiece =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(FunnelPiece, _super);

  function FunnelPiece(data, idx) {
    var _this = _super.call(this) || this;

    var polygon = _this;
    var labelLine = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Polyline"]();
    var text = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Text"]();
    polygon.setTextContent(text);

    _this.setTextGuideLine(labelLine);

    _this.updateData(data, idx, true);

    return _this;
  }

  FunnelPiece.prototype.updateData = function (data, idx, firstCreate) {
    var polygon = this;
    var seriesModel = data.hostModel;
    var itemModel = data.getItemModel(idx);
    var layout = data.getItemLayout(idx);
    var emphasisModel = itemModel.getModel('emphasis');
    var opacity = itemModel.get(opacityAccessPath);
    opacity = opacity == null ? 1 : opacity;

    if (!firstCreate) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__animation_basicTrasition_js__["f" /* saveOldStyle */])(polygon);
    } // Update common style


    polygon.useStyle(data.getItemVisual(idx, 'style'));
    polygon.style.lineJoin = 'round';

    if (firstCreate) {
      polygon.setShape({
        points: layout.points
      });
      polygon.style.opacity = 0;
      __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["initProps"](polygon, {
        style: {
          opacity: opacity
        }
      }, seriesModel, idx);
    } else {
      __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["updateProps"](polygon, {
        style: {
          opacity: opacity
        },
        shape: {
          points: layout.points
        }
      }, seriesModel, idx);
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_states_js__["F" /* setStatesStylesFromModel */])(polygon, itemModel);

    this._updateLabel(data, idx);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_states_js__["G" /* toggleHoverEmphasis */])(this, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
  };

  FunnelPiece.prototype._updateLabel = function (data, idx) {
    var polygon = this;
    var labelLine = this.getTextGuideLine();
    var labelText = polygon.getTextContent();
    var seriesModel = data.hostModel;
    var itemModel = data.getItemModel(idx);
    var layout = data.getItemLayout(idx);
    var labelLayout = layout.label;
    var style = data.getItemVisual(idx, 'style');
    var visualColor = style.fill;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__label_labelStyle_js__["e" /* setLabelStyle */])( // position will not be used in setLabelStyle
    labelText, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__label_labelStyle_js__["f" /* getLabelStatesModels */])(itemModel), {
      labelFetcher: data.hostModel,
      labelDataIndex: idx,
      defaultOpacity: style.opacity,
      defaultText: data.getName(idx)
    }, {
      normal: {
        align: labelLayout.textAlign,
        verticalAlign: labelLayout.verticalAlign
      }
    });
    polygon.setTextConfig({
      local: true,
      inside: !!labelLayout.inside,
      insideStroke: visualColor,
      // insideFill: 'auto',
      outsideFill: visualColor
    });
    var linePoints = labelLayout.linePoints;
    labelLine.setShape({
      points: linePoints
    });
    polygon.textGuideLineConfig = {
      anchor: linePoints ? new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Point"](linePoints[0][0], linePoints[0][1]) : null
    }; // Make sure update style on labelText after setLabelStyle.
    // Because setLabelStyle will replace a new style on it.

    __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["updateProps"](labelText, {
      style: {
        x: labelLayout.x,
        y: labelLayout.y
      }
    }, seriesModel, idx);
    labelText.attr({
      rotation: labelLayout.rotation,
      originX: labelLayout.x,
      originY: labelLayout.y,
      z2: 10
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__label_labelGuideHelper_js__["b" /* setLabelLineStyle */])(polygon, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__label_labelGuideHelper_js__["c" /* getLabelLineStatesModels */])(itemModel), {
      // Default use item visual color
      stroke: visualColor
    });
  };

  return FunnelPiece;
}(__WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Polygon"]);

var FunnelView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(FunnelView, _super);

  function FunnelView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = FunnelView.type;
    _this.ignoreLabelLineUpdate = true;
    return _this;
  }

  FunnelView.prototype.render = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var oldData = this._data;
    var group = this.group;
    data.diff(oldData).add(function (idx) {
      var funnelPiece = new FunnelPiece(data, idx);
      data.setItemGraphicEl(idx, funnelPiece);
      group.add(funnelPiece);
    }).update(function (newIdx, oldIdx) {
      var piece = oldData.getItemGraphicEl(oldIdx);
      piece.updateData(data, newIdx);
      group.add(piece);
      data.setItemGraphicEl(newIdx, piece);
    }).remove(function (idx) {
      var piece = oldData.getItemGraphicEl(idx);
      __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["removeElementWithFadeOut"](piece, seriesModel, idx);
    }).execute();
    this._data = data;
  };

  FunnelView.prototype.remove = function () {
    this.group.removeAll();
    this._data = null;
  };

  FunnelView.prototype.dispose = function () {};

  FunnelView.type = 'funnel';
  return FunnelView;
}(__WEBPACK_IMPORTED_MODULE_3__view_Chart_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (FunnelView);

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = funnelLayout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




function getViewRect(seriesModel, api) {
  return __WEBPACK_IMPORTED_MODULE_0__util_layout_js__["f" /* getLayoutRect */](seriesModel.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  });
}

function getSortedIndices(data, sort) {
  var valueDim = data.mapDimension('value');
  var valueArr = data.mapArray(valueDim, function (val) {
    return val;
  });
  var indices = [];
  var isAscending = sort === 'ascending';

  for (var i = 0, len = data.count(); i < len; i++) {
    indices[i] = i;
  } // Add custom sortable function & none sortable opetion by "options.sort"


  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isFunction"])(sort)) {
    indices.sort(sort);
  } else if (sort !== 'none') {
    indices.sort(function (a, b) {
      return isAscending ? valueArr[a] - valueArr[b] : valueArr[b] - valueArr[a];
    });
  }

  return indices;
}

function labelLayout(data) {
  var seriesModel = data.hostModel;
  var orient = seriesModel.get('orient');
  data.each(function (idx) {
    var itemModel = data.getItemModel(idx);
    var labelModel = itemModel.getModel('label');
    var labelPosition = labelModel.get('position');
    var labelLineModel = itemModel.getModel('labelLine');
    var layout = data.getItemLayout(idx);
    var points = layout.points;
    var isLabelInside = labelPosition === 'inner' || labelPosition === 'inside' || labelPosition === 'center' || labelPosition === 'insideLeft' || labelPosition === 'insideRight';
    var textAlign;
    var textX;
    var textY;
    var linePoints;

    if (isLabelInside) {
      if (labelPosition === 'insideLeft') {
        textX = (points[0][0] + points[3][0]) / 2 + 5;
        textY = (points[0][1] + points[3][1]) / 2;
        textAlign = 'left';
      } else if (labelPosition === 'insideRight') {
        textX = (points[1][0] + points[2][0]) / 2 - 5;
        textY = (points[1][1] + points[2][1]) / 2;
        textAlign = 'right';
      } else {
        textX = (points[0][0] + points[1][0] + points[2][0] + points[3][0]) / 4;
        textY = (points[0][1] + points[1][1] + points[2][1] + points[3][1]) / 4;
        textAlign = 'center';
      }

      linePoints = [[textX, textY], [textX, textY]];
    } else {
      var x1 = void 0;
      var y1 = void 0;
      var x2 = void 0;
      var y2 = void 0;
      var labelLineLen = labelLineModel.get('length');

      if (true) {
        if (orient === 'vertical' && ['top', 'bottom'].indexOf(labelPosition) > -1) {
          labelPosition = 'left';
          console.warn('Position error: Funnel chart on vertical orient dose not support top and bottom.');
        }

        if (orient === 'horizontal' && ['left', 'right'].indexOf(labelPosition) > -1) {
          labelPosition = 'bottom';
          console.warn('Position error: Funnel chart on horizontal orient dose not support left and right.');
        }
      }

      if (labelPosition === 'left') {
        // Left side
        x1 = (points[3][0] + points[0][0]) / 2;
        y1 = (points[3][1] + points[0][1]) / 2;
        x2 = x1 - labelLineLen;
        textX = x2 - 5;
        textAlign = 'right';
      } else if (labelPosition === 'right') {
        // Right side
        x1 = (points[1][0] + points[2][0]) / 2;
        y1 = (points[1][1] + points[2][1]) / 2;
        x2 = x1 + labelLineLen;
        textX = x2 + 5;
        textAlign = 'left';
      } else if (labelPosition === 'top') {
        // Top side
        x1 = (points[3][0] + points[0][0]) / 2;
        y1 = (points[3][1] + points[0][1]) / 2;
        y2 = y1 - labelLineLen;
        textY = y2 - 5;
        textAlign = 'center';
      } else if (labelPosition === 'bottom') {
        // Bottom side
        x1 = (points[1][0] + points[2][0]) / 2;
        y1 = (points[1][1] + points[2][1]) / 2;
        y2 = y1 + labelLineLen;
        textY = y2 + 5;
        textAlign = 'center';
      } else if (labelPosition === 'rightTop') {
        // RightTop side
        x1 = orient === 'horizontal' ? points[3][0] : points[1][0];
        y1 = orient === 'horizontal' ? points[3][1] : points[1][1];

        if (orient === 'horizontal') {
          y2 = y1 - labelLineLen;
          textY = y2 - 5;
          textAlign = 'center';
        } else {
          x2 = x1 + labelLineLen;
          textX = x2 + 5;
          textAlign = 'top';
        }
      } else if (labelPosition === 'rightBottom') {
        // RightBottom side
        x1 = points[2][0];
        y1 = points[2][1];

        if (orient === 'horizontal') {
          y2 = y1 + labelLineLen;
          textY = y2 + 5;
          textAlign = 'center';
        } else {
          x2 = x1 + labelLineLen;
          textX = x2 + 5;
          textAlign = 'bottom';
        }
      } else if (labelPosition === 'leftTop') {
        // LeftTop side
        x1 = points[0][0];
        y1 = orient === 'horizontal' ? points[0][1] : points[1][1];

        if (orient === 'horizontal') {
          y2 = y1 - labelLineLen;
          textY = y2 - 5;
          textAlign = 'center';
        } else {
          x2 = x1 - labelLineLen;
          textX = x2 - 5;
          textAlign = 'right';
        }
      } else if (labelPosition === 'leftBottom') {
        // LeftBottom side
        x1 = orient === 'horizontal' ? points[1][0] : points[3][0];
        y1 = orient === 'horizontal' ? points[1][1] : points[2][1];

        if (orient === 'horizontal') {
          y2 = y1 + labelLineLen;
          textY = y2 + 5;
          textAlign = 'center';
        } else {
          x2 = x1 - labelLineLen;
          textX = x2 - 5;
          textAlign = 'right';
        }
      } else {
        // Right side or Bottom side
        x1 = (points[1][0] + points[2][0]) / 2;
        y1 = (points[1][1] + points[2][1]) / 2;

        if (orient === 'horizontal') {
          y2 = y1 + labelLineLen;
          textY = y2 + 5;
          textAlign = 'center';
        } else {
          x2 = x1 + labelLineLen;
          textX = x2 + 5;
          textAlign = 'left';
        }
      }

      if (orient === 'horizontal') {
        x2 = x1;
        textX = x2;
      } else {
        y2 = y1;
        textY = y2;
      }

      linePoints = [[x1, y1], [x2, y2]];
    }

    layout.label = {
      linePoints: linePoints,
      x: textX,
      y: textY,
      verticalAlign: 'middle',
      textAlign: textAlign,
      inside: isLabelInside
    };
  });
}

function funnelLayout(ecModel, api) {
  ecModel.eachSeriesByType('funnel', function (seriesModel) {
    var data = seriesModel.getData();
    var valueDim = data.mapDimension('value');
    var sort = seriesModel.get('sort');
    var viewRect = getViewRect(seriesModel, api);
    var orient = seriesModel.get('orient');
    var viewWidth = viewRect.width;
    var viewHeight = viewRect.height;
    var indices = getSortedIndices(data, sort);
    var x = viewRect.x;
    var y = viewRect.y;
    var sizeExtent = orient === 'horizontal' ? [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["a" /* parsePercent */])(seriesModel.get('minSize'), viewHeight), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["a" /* parsePercent */])(seriesModel.get('maxSize'), viewHeight)] : [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["a" /* parsePercent */])(seriesModel.get('minSize'), viewWidth), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["a" /* parsePercent */])(seriesModel.get('maxSize'), viewWidth)];
    var dataExtent = data.getDataExtent(valueDim);
    var min = seriesModel.get('min');
    var max = seriesModel.get('max');

    if (min == null) {
      min = Math.min(dataExtent[0], 0);
    }

    if (max == null) {
      max = dataExtent[1];
    }

    var funnelAlign = seriesModel.get('funnelAlign');
    var gap = seriesModel.get('gap');
    var viewSize = orient === 'horizontal' ? viewWidth : viewHeight;
    var itemSize = (viewSize - gap * (data.count() - 1)) / data.count();

    var getLinePoints = function (idx, offset) {
      // End point index is data.count() and we assign it 0
      if (orient === 'horizontal') {
        var val_1 = data.get(valueDim, idx) || 0;
        var itemHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["h" /* linearMap */])(val_1, [min, max], sizeExtent, true);
        var y0 = void 0;

        switch (funnelAlign) {
          case 'top':
            y0 = y;
            break;

          case 'center':
            y0 = y + (viewHeight - itemHeight) / 2;
            break;

          case 'bottom':
            y0 = y + (viewHeight - itemHeight);
            break;
        }

        return [[offset, y0], [offset, y0 + itemHeight]];
      }

      var val = data.get(valueDim, idx) || 0;
      var itemWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["h" /* linearMap */])(val, [min, max], sizeExtent, true);
      var x0;

      switch (funnelAlign) {
        case 'left':
          x0 = x;
          break;

        case 'center':
          x0 = x + (viewWidth - itemWidth) / 2;
          break;

        case 'right':
          x0 = x + viewWidth - itemWidth;
          break;
      }

      return [[x0, offset], [x0 + itemWidth, offset]];
    };

    if (sort === 'ascending') {
      // From bottom to top
      itemSize = -itemSize;
      gap = -gap;

      if (orient === 'horizontal') {
        x += viewWidth;
      } else {
        y += viewHeight;
      }

      indices = indices.reverse();
    }

    for (var i = 0; i < indices.length; i++) {
      var idx = indices[i];
      var nextIdx = indices[i + 1];
      var itemModel = data.getItemModel(idx);

      if (orient === 'horizontal') {
        var width = itemModel.get(['itemStyle', 'width']);

        if (width == null) {
          width = itemSize;
        } else {
          width = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["a" /* parsePercent */])(width, viewWidth);

          if (sort === 'ascending') {
            width = -width;
          }
        }

        var start = getLinePoints(idx, x);
        var end = getLinePoints(nextIdx, x + width);
        x += width + gap;
        data.setItemLayout(idx, {
          points: start.concat(end.slice().reverse())
        });
      } else {
        var height = itemModel.get(['itemStyle', 'height']);

        if (height == null) {
          height = itemSize;
        } else {
          height = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["a" /* parsePercent */])(height, viewHeight);

          if (sort === 'ascending') {
            height = -height;
          }
        }

        var start = getLinePoints(idx, y);
        var end = getLinePoints(nextIdx, y + height);
        y += height + gap;
        data.setItemLayout(idx, {
          points: start.concat(end.slice().reverse())
        });
      }
    }

    labelLayout(data);
  });
}

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FunnelView_js__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FunnelSeries_js__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__funnelLayout_js__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__processor_dataFilter_js__ = __webpack_require__(196);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




function install(registers) {
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_0__FunnelView_js__["a" /* default */]);
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_1__FunnelSeries_js__["a" /* default */]);
  registers.registerLayout(__WEBPACK_IMPORTED_MODULE_2__funnelLayout_js__["a" /* default */]);
  registers.registerProcessor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__processor_dataFilter_js__["a" /* default */])('funnel'));
}

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_createSeriesDataSimply_js__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_Series_js__ = __webpack_require__(26);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var GaugeSeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(GaugeSeriesModel, _super);

  function GaugeSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = GaugeSeriesModel.type;
    _this.visualStyleAccessPath = 'itemStyle';
    return _this;
  }

  GaugeSeriesModel.prototype.getInitialData = function (option, ecModel) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper_createSeriesDataSimply_js__["a" /* default */])(this, ['value']);
  };

  GaugeSeriesModel.type = 'series.gauge';
  GaugeSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    colorBy: 'data',
    // 默认全局居中
    center: ['50%', '50%'],
    legendHoverLink: true,
    radius: '75%',
    startAngle: 225,
    endAngle: -45,
    clockwise: true,
    // 最小值
    min: 0,
    // 最大值
    max: 100,
    // 分割段数，默认为10
    splitNumber: 10,
    // 坐标轴线
    axisLine: {
      // 默认显示，属性show控制显示与否
      show: true,
      roundCap: false,
      lineStyle: {
        color: [[1, '#E6EBF8']],
        width: 10
      }
    },
    // 坐标轴线
    progress: {
      // 默认显示，属性show控制显示与否
      show: false,
      overlap: true,
      width: 10,
      roundCap: false,
      clip: true
    },
    // 分隔线
    splitLine: {
      // 默认显示，属性show控制显示与否
      show: true,
      // 属性length控制线长
      length: 10,
      distance: 10,
      // 属性lineStyle（详见lineStyle）控制线条样式
      lineStyle: {
        color: '#63677A',
        width: 3,
        type: 'solid'
      }
    },
    // 坐标轴小标记
    axisTick: {
      // 属性show控制显示与否，默认不显示
      show: true,
      // 每份split细分多少段
      splitNumber: 5,
      // 属性length控制线长
      length: 6,
      distance: 10,
      // 属性lineStyle控制线条样式
      lineStyle: {
        color: '#63677A',
        width: 1,
        type: 'solid'
      }
    },
    axisLabel: {
      show: true,
      distance: 15,
      // formatter: null,
      color: '#464646',
      fontSize: 12
    },
    pointer: {
      icon: null,
      offsetCenter: [0, 0],
      show: true,
      showAbove: true,
      length: '60%',
      width: 6,
      keepAspect: false
    },
    anchor: {
      show: false,
      showAbove: false,
      size: 6,
      icon: 'circle',
      offsetCenter: [0, 0],
      keepAspect: false,
      itemStyle: {
        color: '#fff',
        borderWidth: 0,
        borderColor: '#5470c6'
      }
    },
    title: {
      show: true,
      // x, y，单位px
      offsetCenter: [0, '20%'],
      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
      color: '#464646',
      fontSize: 16,
      valueAnimation: false
    },
    detail: {
      show: true,
      backgroundColor: 'rgba(0,0,0,0)',
      borderWidth: 0,
      borderColor: '#ccc',
      width: 100,
      height: null,
      padding: [5, 10],
      // x, y，单位px
      offsetCenter: [0, '40%'],
      // formatter: null,
      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
      color: '#464646',
      fontSize: 30,
      fontWeight: 'bold',
      lineHeight: 30,
      valueAnimation: false
    }
  };
  return GaugeSeriesModel;
}(__WEBPACK_IMPORTED_MODULE_2__model_Series_js__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (GaugeSeriesModel);

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PointerPath_js__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_shape_sausage_js__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_symbol_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_zrender_lib_graphic_Image_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_zrender_lib_core_PathProxy_js__ = __webpack_require__(91);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/














function parsePosition(seriesModel, api) {
  var center = seriesModel.get('center');
  var width = api.getWidth();
  var height = api.getHeight();
  var size = Math.min(width, height);
  var cx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(center[0], api.getWidth());
  var cy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(center[1], api.getHeight());
  var r = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(seriesModel.get('radius'), size / 2);
  return {
    cx: cx,
    cy: cy,
    r: r
  };
}

function formatLabel(value, labelFormatter) {
  var label = value == null ? '' : value + '';

  if (labelFormatter) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["isString"])(labelFormatter)) {
      label = labelFormatter.replace('{value}', label);
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["isFunction"])(labelFormatter)) {
      label = labelFormatter(value);
    }
  }

  return label;
}

var GaugeView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(GaugeView, _super);

  function GaugeView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = GaugeView.type;
    return _this;
  }

  GaugeView.prototype.render = function (seriesModel, ecModel, api) {
    this.group.removeAll();
    var colorList = seriesModel.get(['axisLine', 'lineStyle', 'color']);
    var posInfo = parsePosition(seriesModel, api);

    this._renderMain(seriesModel, ecModel, api, colorList, posInfo);

    this._data = seriesModel.getData();
  };

  GaugeView.prototype.dispose = function () {};

  GaugeView.prototype._renderMain = function (seriesModel, ecModel, api, colorList, posInfo) {
    var group = this.group;
    var clockwise = seriesModel.get('clockwise');
    var startAngle = -seriesModel.get('startAngle') / 180 * Math.PI;
    var endAngle = -seriesModel.get('endAngle') / 180 * Math.PI;
    var axisLineModel = seriesModel.getModel('axisLine');
    var roundCap = axisLineModel.get('roundCap');
    var MainPath = roundCap ? __WEBPACK_IMPORTED_MODULE_7__util_shape_sausage_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Sector"];
    var showAxis = axisLineModel.get('show');
    var lineStyleModel = axisLineModel.getModel('lineStyle');
    var axisLineWidth = lineStyleModel.get('width');
    var angles = [startAngle, endAngle];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_zrender_lib_core_PathProxy_js__["b" /* normalizeArcAngles */])(angles, !clockwise);
    startAngle = angles[0];
    endAngle = angles[1];
    var angleRangeSpan = endAngle - startAngle;
    var prevEndAngle = startAngle;

    for (var i = 0; showAxis && i < colorList.length; i++) {
      // Clamp
      var percent = Math.min(Math.max(colorList[i][0], 0), 1);
      endAngle = startAngle + angleRangeSpan * percent;
      var sector = new MainPath({
        shape: {
          startAngle: prevEndAngle,
          endAngle: endAngle,
          cx: posInfo.cx,
          cy: posInfo.cy,
          clockwise: clockwise,
          r0: posInfo.r - axisLineWidth,
          r: posInfo.r
        },
        silent: true
      });
      sector.setStyle({
        fill: colorList[i][1]
      });
      sector.setStyle(lineStyleModel.getLineStyle( // Because we use sector to simulate arc
      // so the properties for stroking are useless
      ['color', 'width']));
      group.add(sector);
      prevEndAngle = endAngle;
    }

    var getColor = function (percent) {
      // Less than 0
      if (percent <= 0) {
        return colorList[0][1];
      }

      var i;

      for (i = 0; i < colorList.length; i++) {
        if (colorList[i][0] >= percent && (i === 0 ? 0 : colorList[i - 1][0]) < percent) {
          return colorList[i][1];
        }
      } // More than 1


      return colorList[i - 1][1];
    };

    this._renderTicks(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth);

    this._renderTitleAndDetail(seriesModel, ecModel, api, getColor, posInfo);

    this._renderAnchor(seriesModel, posInfo);

    this._renderPointer(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth);
  };

  GaugeView.prototype._renderTicks = function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth) {
    var group = this.group;
    var cx = posInfo.cx;
    var cy = posInfo.cy;
    var r = posInfo.r;
    var minVal = +seriesModel.get('min');
    var maxVal = +seriesModel.get('max');
    var splitLineModel = seriesModel.getModel('splitLine');
    var tickModel = seriesModel.getModel('axisTick');
    var labelModel = seriesModel.getModel('axisLabel');
    var splitNumber = seriesModel.get('splitNumber');
    var subSplitNumber = tickModel.get('splitNumber');
    var splitLineLen = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(splitLineModel.get('length'), r);
    var tickLen = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(tickModel.get('length'), r);
    var angle = startAngle;
    var step = (endAngle - startAngle) / splitNumber;
    var subStep = step / subSplitNumber;
    var splitLineStyle = splitLineModel.getModel('lineStyle').getLineStyle();
    var tickLineStyle = tickModel.getModel('lineStyle').getLineStyle();
    var splitLineDistance = splitLineModel.get('distance');
    var unitX;
    var unitY;

    for (var i = 0; i <= splitNumber; i++) {
      unitX = Math.cos(angle);
      unitY = Math.sin(angle); // Split line

      if (splitLineModel.get('show')) {
        var distance = splitLineDistance ? splitLineDistance + axisLineWidth : axisLineWidth;
        var splitLine = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Line"]({
          shape: {
            x1: unitX * (r - distance) + cx,
            y1: unitY * (r - distance) + cy,
            x2: unitX * (r - splitLineLen - distance) + cx,
            y2: unitY * (r - splitLineLen - distance) + cy
          },
          style: splitLineStyle,
          silent: true
        });

        if (splitLineStyle.stroke === 'auto') {
          splitLine.setStyle({
            stroke: getColor(i / splitNumber)
          });
        }

        group.add(splitLine);
      } // Label


      if (labelModel.get('show')) {
        var distance = labelModel.get('distance') + splitLineDistance;
        var label = formatLabel(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["d" /* round */])(i / splitNumber * (maxVal - minVal) + minVal), labelModel.get('formatter'));
        var autoColor = getColor(i / splitNumber);
        group.add(new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Text"]({
          style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["d" /* createTextStyle */])(labelModel, {
            text: label,
            x: unitX * (r - splitLineLen - distance) + cx,
            y: unitY * (r - splitLineLen - distance) + cy,
            verticalAlign: unitY < -0.8 ? 'top' : unitY > 0.8 ? 'bottom' : 'middle',
            align: unitX < -0.4 ? 'left' : unitX > 0.4 ? 'right' : 'center'
          }, {
            inheritColor: autoColor
          }),
          silent: true
        }));
      } // Axis tick


      if (tickModel.get('show') && i !== splitNumber) {
        var distance = tickModel.get('distance');
        distance = distance ? distance + axisLineWidth : axisLineWidth;

        for (var j = 0; j <= subSplitNumber; j++) {
          unitX = Math.cos(angle);
          unitY = Math.sin(angle);
          var tickLine = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Line"]({
            shape: {
              x1: unitX * (r - distance) + cx,
              y1: unitY * (r - distance) + cy,
              x2: unitX * (r - tickLen - distance) + cx,
              y2: unitY * (r - tickLen - distance) + cy
            },
            silent: true,
            style: tickLineStyle
          });

          if (tickLineStyle.stroke === 'auto') {
            tickLine.setStyle({
              stroke: getColor((i + j / subSplitNumber) / splitNumber)
            });
          }

          group.add(tickLine);
          angle += subStep;
        }

        angle -= subStep;
      } else {
        angle += step;
      }
    }
  };

  GaugeView.prototype._renderPointer = function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth) {
    var group = this.group;
    var oldData = this._data;
    var oldProgressData = this._progressEls;
    var progressList = [];
    var showPointer = seriesModel.get(['pointer', 'show']);
    var progressModel = seriesModel.getModel('progress');
    var showProgress = progressModel.get('show');
    var data = seriesModel.getData();
    var valueDim = data.mapDimension('value');
    var minVal = +seriesModel.get('min');
    var maxVal = +seriesModel.get('max');
    var valueExtent = [minVal, maxVal];
    var angleExtent = [startAngle, endAngle];

    function createPointer(idx, angle) {
      var itemModel = data.getItemModel(idx);
      var pointerModel = itemModel.getModel('pointer');
      var pointerWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(pointerModel.get('width'), posInfo.r);
      var pointerLength = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(pointerModel.get('length'), posInfo.r);
      var pointerStr = seriesModel.get(['pointer', 'icon']);
      var pointerOffset = pointerModel.get('offsetCenter');
      var pointerOffsetX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(pointerOffset[0], posInfo.r);
      var pointerOffsetY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(pointerOffset[1], posInfo.r);
      var pointerKeepAspect = pointerModel.get('keepAspect');
      var pointer; // not exist icon type will be set 'rect'

      if (pointerStr) {
        pointer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_symbol_js__["a" /* createSymbol */])(pointerStr, pointerOffsetX - pointerWidth / 2, pointerOffsetY - pointerLength, pointerWidth, pointerLength, null, pointerKeepAspect);
      } else {
        pointer = new __WEBPACK_IMPORTED_MODULE_1__PointerPath_js__["a" /* default */]({
          shape: {
            angle: -Math.PI / 2,
            width: pointerWidth,
            r: pointerLength,
            x: pointerOffsetX,
            y: pointerOffsetY
          }
        });
      }

      pointer.rotation = -(angle + Math.PI / 2);
      pointer.x = posInfo.cx;
      pointer.y = posInfo.cy;
      return pointer;
    }

    function createProgress(idx, endAngle) {
      var roundCap = progressModel.get('roundCap');
      var ProgressPath = roundCap ? __WEBPACK_IMPORTED_MODULE_7__util_shape_sausage_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Sector"];
      var isOverlap = progressModel.get('overlap');
      var progressWidth = isOverlap ? progressModel.get('width') : axisLineWidth / data.count();
      var r0 = isOverlap ? posInfo.r - progressWidth : posInfo.r - (idx + 1) * progressWidth;
      var r = isOverlap ? posInfo.r : posInfo.r - idx * progressWidth;
      var progress = new ProgressPath({
        shape: {
          startAngle: startAngle,
          endAngle: endAngle,
          cx: posInfo.cx,
          cy: posInfo.cy,
          clockwise: clockwise,
          r0: r0,
          r: r
        }
      });
      isOverlap && (progress.z2 = maxVal - data.get(valueDim, idx) % maxVal);
      return progress;
    }

    if (showProgress || showPointer) {
      data.diff(oldData).add(function (idx) {
        var val = data.get(valueDim, idx);

        if (showPointer) {
          var pointer = createPointer(idx, startAngle); // TODO hide pointer on NaN value?

          __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["initProps"](pointer, {
            rotation: -((isNaN(+val) ? angleExtent[0] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["h" /* linearMap */])(val, valueExtent, angleExtent, true)) + Math.PI / 2)
          }, seriesModel);
          group.add(pointer);
          data.setItemGraphicEl(idx, pointer);
        }

        if (showProgress) {
          var progress = createProgress(idx, startAngle);
          var isClip = progressModel.get('clip');
          __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["initProps"](progress, {
            shape: {
              endAngle: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["h" /* linearMap */])(val, valueExtent, angleExtent, isClip)
            }
          }, seriesModel);
          group.add(progress); // Add data index and series index for indexing the data by element
          // Useful in tooltip

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_innerStore_js__["b" /* setCommonECData */])(seriesModel.seriesIndex, data.dataType, idx, progress);
          progressList[idx] = progress;
        }
      }).update(function (newIdx, oldIdx) {
        var val = data.get(valueDim, newIdx);

        if (showPointer) {
          var previousPointer = oldData.getItemGraphicEl(oldIdx);
          var previousRotate = previousPointer ? previousPointer.rotation : startAngle;
          var pointer = createPointer(newIdx, previousRotate);
          pointer.rotation = previousRotate;
          __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["updateProps"](pointer, {
            rotation: -((isNaN(+val) ? angleExtent[0] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["h" /* linearMap */])(val, valueExtent, angleExtent, true)) + Math.PI / 2)
          }, seriesModel);
          group.add(pointer);
          data.setItemGraphicEl(newIdx, pointer);
        }

        if (showProgress) {
          var previousProgress = oldProgressData[oldIdx];
          var previousEndAngle = previousProgress ? previousProgress.shape.endAngle : startAngle;
          var progress = createProgress(newIdx, previousEndAngle);
          var isClip = progressModel.get('clip');
          __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["updateProps"](progress, {
            shape: {
              endAngle: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["h" /* linearMap */])(val, valueExtent, angleExtent, isClip)
            }
          }, seriesModel);
          group.add(progress); // Add data index and series index for indexing the data by element
          // Useful in tooltip

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_innerStore_js__["b" /* setCommonECData */])(seriesModel.seriesIndex, data.dataType, newIdx, progress);
          progressList[newIdx] = progress;
        }
      }).execute();
      data.each(function (idx) {
        var itemModel = data.getItemModel(idx);
        var emphasisModel = itemModel.getModel('emphasis');
        var focus = emphasisModel.get('focus');
        var blurScope = emphasisModel.get('blurScope');
        var emphasisDisabled = emphasisModel.get('disabled');

        if (showPointer) {
          var pointer = data.getItemGraphicEl(idx);
          var symbolStyle = data.getItemVisual(idx, 'style');
          var visualColor = symbolStyle.fill;

          if (pointer instanceof __WEBPACK_IMPORTED_MODULE_9_zrender_lib_graphic_Image_js__["a" /* default */]) {
            var pathStyle = pointer.style;
            pointer.useStyle(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["extend"])({
              image: pathStyle.image,
              x: pathStyle.x,
              y: pathStyle.y,
              width: pathStyle.width,
              height: pathStyle.height
            }, symbolStyle));
          } else {
            pointer.useStyle(symbolStyle);
            pointer.type !== 'pointer' && pointer.setColor(visualColor);
          }

          pointer.setStyle(itemModel.getModel(['pointer', 'itemStyle']).getItemStyle());

          if (pointer.style.fill === 'auto') {
            pointer.setStyle('fill', getColor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["h" /* linearMap */])(data.get(valueDim, idx), valueExtent, [0, 1], true)));
          }

          pointer.z2EmphasisLift = 0;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_states_js__["F" /* setStatesStylesFromModel */])(pointer, itemModel);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_states_js__["G" /* toggleHoverEmphasis */])(pointer, focus, blurScope, emphasisDisabled);
        }

        if (showProgress) {
          var progress = progressList[idx];
          progress.useStyle(data.getItemVisual(idx, 'style'));
          progress.setStyle(itemModel.getModel(['progress', 'itemStyle']).getItemStyle());
          progress.z2EmphasisLift = 0;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_states_js__["F" /* setStatesStylesFromModel */])(progress, itemModel);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_states_js__["G" /* toggleHoverEmphasis */])(progress, focus, blurScope, emphasisDisabled);
        }
      });
      this._progressEls = progressList;
    }
  };

  GaugeView.prototype._renderAnchor = function (seriesModel, posInfo) {
    var anchorModel = seriesModel.getModel('anchor');
    var showAnchor = anchorModel.get('show');

    if (showAnchor) {
      var anchorSize = anchorModel.get('size');
      var anchorType = anchorModel.get('icon');
      var offsetCenter = anchorModel.get('offsetCenter');
      var anchorKeepAspect = anchorModel.get('keepAspect');
      var anchor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_symbol_js__["a" /* createSymbol */])(anchorType, posInfo.cx - anchorSize / 2 + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(offsetCenter[0], posInfo.r), posInfo.cy - anchorSize / 2 + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(offsetCenter[1], posInfo.r), anchorSize, anchorSize, null, anchorKeepAspect);
      anchor.z2 = anchorModel.get('showAbove') ? 1 : 0;
      anchor.setStyle(anchorModel.getModel('itemStyle').getItemStyle());
      this.group.add(anchor);
    }
  };

  GaugeView.prototype._renderTitleAndDetail = function (seriesModel, ecModel, api, getColor, posInfo) {
    var _this = this;

    var data = seriesModel.getData();
    var valueDim = data.mapDimension('value');
    var minVal = +seriesModel.get('min');
    var maxVal = +seriesModel.get('max');
    var contentGroup = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Group"]();
    var newTitleEls = [];
    var newDetailEls = [];
    var hasAnimation = seriesModel.isAnimationEnabled();
    var showPointerAbove = seriesModel.get(['pointer', 'showAbove']);
    data.diff(this._data).add(function (idx) {
      newTitleEls[idx] = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Text"]({
        silent: true
      });
      newDetailEls[idx] = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Text"]({
        silent: true
      });
    }).update(function (idx, oldIdx) {
      newTitleEls[idx] = _this._titleEls[oldIdx];
      newDetailEls[idx] = _this._detailEls[oldIdx];
    }).execute();
    data.each(function (idx) {
      var itemModel = data.getItemModel(idx);
      var value = data.get(valueDim, idx);
      var itemGroup = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Group"]();
      var autoColor = getColor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["h" /* linearMap */])(value, [minVal, maxVal], [0, 1], true));
      var itemTitleModel = itemModel.getModel('title');

      if (itemTitleModel.get('show')) {
        var titleOffsetCenter = itemTitleModel.get('offsetCenter');
        var titleX = posInfo.cx + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(titleOffsetCenter[0], posInfo.r);
        var titleY = posInfo.cy + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(titleOffsetCenter[1], posInfo.r);
        var labelEl = newTitleEls[idx];
        labelEl.attr({
          z2: showPointerAbove ? 0 : 2,
          style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["d" /* createTextStyle */])(itemTitleModel, {
            x: titleX,
            y: titleY,
            text: data.getName(idx),
            align: 'center',
            verticalAlign: 'middle'
          }, {
            inheritColor: autoColor
          })
        });
        itemGroup.add(labelEl);
      }

      var itemDetailModel = itemModel.getModel('detail');

      if (itemDetailModel.get('show')) {
        var detailOffsetCenter = itemDetailModel.get('offsetCenter');
        var detailX = posInfo.cx + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(detailOffsetCenter[0], posInfo.r);
        var detailY = posInfo.cy + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(detailOffsetCenter[1], posInfo.r);
        var width = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(itemDetailModel.get('width'), posInfo.r);
        var height = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(itemDetailModel.get('height'), posInfo.r);
        var detailColor = seriesModel.get(['progress', 'show']) ? data.getItemVisual(idx, 'style').fill : autoColor;
        var labelEl = newDetailEls[idx];
        var formatter_1 = itemDetailModel.get('formatter');
        labelEl.attr({
          z2: showPointerAbove ? 0 : 2,
          style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["d" /* createTextStyle */])(itemDetailModel, {
            x: detailX,
            y: detailY,
            text: formatLabel(value, formatter_1),
            width: isNaN(width) ? null : width,
            height: isNaN(height) ? null : height,
            align: 'center',
            verticalAlign: 'middle'
          }, {
            inheritColor: detailColor
          })
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["h" /* setLabelValueAnimation */])(labelEl, {
          normal: itemDetailModel
        }, value, function (value) {
          return formatLabel(value, formatter_1);
        });
        hasAnimation && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["b" /* animateLabelValue */])(labelEl, idx, data, seriesModel, {
          getFormattedLabel: function (labelDataIndex, status, dataType, labelDimIndex, fmt, extendParams) {
            return formatLabel(extendParams ? extendParams.interpolatedValue : value, formatter_1);
          }
        });
        itemGroup.add(labelEl);
      }

      contentGroup.add(itemGroup);
    });
    this.group.add(contentGroup);
    this._titleEls = newTitleEls;
    this._detailEls = newDetailEls;
  };

  GaugeView.type = 'gauge';
  return GaugeView;
}(__WEBPACK_IMPORTED_MODULE_5__view_Chart_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (GaugeView);

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_graphic_Path_js__ = __webpack_require__(24);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var PointerShape =
/** @class */
function () {
  function PointerShape() {
    this.angle = 0;
    this.width = 10;
    this.r = 10;
    this.x = 0;
    this.y = 0;
  }

  return PointerShape;
}();

var PointerPath =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(PointerPath, _super);

  function PointerPath(opts) {
    var _this = _super.call(this, opts) || this;

    _this.type = 'pointer';
    return _this;
  }

  PointerPath.prototype.getDefaultShape = function () {
    return new PointerShape();
  };

  PointerPath.prototype.buildPath = function (ctx, shape) {
    var mathCos = Math.cos;
    var mathSin = Math.sin;
    var r = shape.r;
    var width = shape.width;
    var angle = shape.angle;
    var x = shape.x - mathCos(angle) * width * (width >= r / 3 ? 1 : 2);
    var y = shape.y - mathSin(angle) * width * (width >= r / 3 ? 1 : 2);
    angle = shape.angle - Math.PI / 2;
    ctx.moveTo(x, y);
    ctx.lineTo(shape.x + mathCos(angle) * width, shape.y + mathSin(angle) * width);
    ctx.lineTo(shape.x + mathCos(shape.angle) * r, shape.y + mathSin(shape.angle) * r);
    ctx.lineTo(shape.x - mathCos(angle) * width, shape.y - mathSin(angle) * width);
    ctx.lineTo(x, y);
  };

  return PointerPath;
}(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_graphic_Path_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PointerPath);

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GaugeView_js__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GaugeSeries_js__ = __webpack_require__(1111);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


function install(registers) {
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_0__GaugeView_js__["a" /* default */]);
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_1__GaugeSeries_js__["a" /* default */]);
}

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_SeriesData_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_Model_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_createGraphFromNodeEdge_js__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__visual_LegendVisualProvider_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_Series_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_tooltip_tooltipMarkup_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component_tooltip_seriesFormatTooltip_js__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helper_multipleGraphEdgeHelper_js__ = __webpack_require__(229);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/












var GraphSeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(GraphSeriesModel, _super);

  function GraphSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = GraphSeriesModel.type;
    _this.hasSymbolVisual = true;
    return _this;
  }

  GraphSeriesModel.prototype.init = function (option) {
    _super.prototype.init.apply(this, arguments);

    var self = this;

    function getCategoriesData() {
      return self._categoriesData;
    } // Provide data for legend select


    this.legendVisualProvider = new __WEBPACK_IMPORTED_MODULE_6__visual_LegendVisualProvider_js__["a" /* default */](getCategoriesData, getCategoriesData);
    this.fillDataTextStyle(option.edges || option.links);

    this._updateCategoriesData();
  };

  GraphSeriesModel.prototype.mergeOption = function (option) {
    _super.prototype.mergeOption.apply(this, arguments);

    this.fillDataTextStyle(option.edges || option.links);

    this._updateCategoriesData();
  };

  GraphSeriesModel.prototype.mergeDefaultAndTheme = function (option) {
    _super.prototype.mergeDefaultAndTheme.apply(this, arguments);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_model_js__["e" /* defaultEmphasis */])(option, 'edgeLabel', ['show']);
  };

  GraphSeriesModel.prototype.getInitialData = function (option, ecModel) {
    var edges = option.edges || option.links || [];
    var nodes = option.data || option.nodes || [];
    var self = this;

    if (nodes && edges) {
      // auto curveness
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helper_multipleGraphEdgeHelper_js__["b" /* initCurvenessList */])(this);
      var graph = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helper_createGraphFromNodeEdge_js__["a" /* default */])(nodes, edges, this, true, beforeLink);
      __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"](graph.edges, function (edge) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helper_multipleGraphEdgeHelper_js__["c" /* createEdgeMapForCurveness */])(edge.node1, edge.node2, this, edge.dataIndex);
      }, this);
      return graph.data;
    }

    function beforeLink(nodeData, edgeData) {
      // Overwrite nodeData.getItemModel to
      nodeData.wrapMethod('getItemModel', function (model) {
        var categoriesModels = self._categoriesModels;
        var categoryIdx = model.getShallow('category');
        var categoryModel = categoriesModels[categoryIdx];

        if (categoryModel) {
          categoryModel.parentModel = model.parentModel;
          model.parentModel = categoryModel;
        }

        return model;
      }); // TODO Inherit resolveParentPath by default in Model#getModel?

      var oldGetModel = __WEBPACK_IMPORTED_MODULE_4__model_Model_js__["a" /* default */].prototype.getModel;

      function newGetModel(path, parentModel) {
        var model = oldGetModel.call(this, path, parentModel);
        model.resolveParentPath = resolveParentPath;
        return model;
      }

      edgeData.wrapMethod('getItemModel', function (model) {
        model.resolveParentPath = resolveParentPath;
        model.getModel = newGetModel;
        return model;
      });

      function resolveParentPath(pathArr) {
        if (pathArr && (pathArr[0] === 'label' || pathArr[1] === 'label')) {
          var newPathArr = pathArr.slice();

          if (pathArr[0] === 'label') {
            newPathArr[0] = 'edgeLabel';
          } else if (pathArr[1] === 'label') {
            newPathArr[1] = 'edgeLabel';
          }

          return newPathArr;
        }

        return pathArr;
      }
    }
  };

  GraphSeriesModel.prototype.getGraph = function () {
    return this.getData().graph;
  };

  GraphSeriesModel.prototype.getEdgeData = function () {
    return this.getGraph().edgeData;
  };

  GraphSeriesModel.prototype.getCategoriesData = function () {
    return this._categoriesData;
  };

  GraphSeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    if (dataType === 'edge') {
      var nodeData = this.getData();
      var params = this.getDataParams(dataIndex, dataType);
      var edge = nodeData.graph.getEdgeByIndex(dataIndex);
      var sourceName = nodeData.getName(edge.node1.dataIndex);
      var targetName = nodeData.getName(edge.node2.dataIndex);
      var nameArr = [];
      sourceName != null && nameArr.push(sourceName);
      targetName != null && nameArr.push(targetName);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__component_tooltip_tooltipMarkup_js__["b" /* createTooltipMarkup */])('nameValue', {
        name: nameArr.join(' > '),
        value: params.value,
        noValue: params.value == null
      });
    } // dataType === 'node' or empty


    var nodeMarkup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__component_tooltip_seriesFormatTooltip_js__["a" /* defaultSeriesFormatTooltip */])({
      series: this,
      dataIndex: dataIndex,
      multipleSeries: multipleSeries
    });
    return nodeMarkup;
  };

  GraphSeriesModel.prototype._updateCategoriesData = function () {
    var categories = __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["map"](this.option.categories || [], function (category) {
      // Data must has value
      return category.value != null ? category : __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["extend"]({
        value: 0
      }, category);
    });
    var categoriesData = new __WEBPACK_IMPORTED_MODULE_1__data_SeriesData_js__["a" /* default */](['value'], this);
    categoriesData.initData(categories);
    this._categoriesData = categoriesData;
    this._categoriesModels = categoriesData.mapArray(function (idx) {
      return categoriesData.getItemModel(idx);
    });
  };

  GraphSeriesModel.prototype.setZoom = function (zoom) {
    this.option.zoom = zoom;
  };

  GraphSeriesModel.prototype.setCenter = function (center) {
    this.option.center = center;
  };

  GraphSeriesModel.prototype.isAnimationEnabled = function () {
    return _super.prototype.isAnimationEnabled.call(this) // Not enable animation when do force layout
    && !(this.get('layout') === 'force' && this.get(['force', 'layoutAnimation']));
  };

  GraphSeriesModel.type = 'series.graph';
  GraphSeriesModel.dependencies = ['grid', 'polar', 'geo', 'singleAxis', 'calendar'];
  GraphSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    coordinateSystem: 'view',
    // Default option for all coordinate systems
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // polarIndex: 0,
    // geoIndex: 0,
    legendHoverLink: true,
    layout: null,
    // Configuration of circular layout
    circular: {
      rotateLabel: false
    },
    // Configuration of force directed layout
    force: {
      initLayout: null,
      // Node repulsion. Can be an array to represent range.
      repulsion: [0, 50],
      gravity: 0.1,
      // Initial friction
      friction: 0.6,
      // Edge length. Can be an array to represent range.
      edgeLength: 30,
      layoutAnimation: true
    },
    left: 'center',
    top: 'center',
    // right: null,
    // bottom: null,
    // width: '80%',
    // height: '80%',
    symbol: 'circle',
    symbolSize: 10,
    edgeSymbol: ['none', 'none'],
    edgeSymbolSize: 10,
    edgeLabel: {
      position: 'middle',
      distance: 5
    },
    draggable: false,
    roam: false,
    // Default on center of graph
    center: null,
    zoom: 1,
    // Symbol size scale ratio in roam
    nodeScaleRatio: 0.6,
    // cursor: null,
    // categories: [],
    // data: []
    // Or
    // nodes: []
    //
    // links: []
    // Or
    // edges: []
    label: {
      show: false,
      formatter: '{b}'
    },
    itemStyle: {},
    lineStyle: {
      color: '#aaa',
      width: 1,
      opacity: 0.5
    },
    emphasis: {
      scale: true,
      label: {
        show: true
      }
    },
    select: {
      itemStyle: {
        borderColor: '#212121'
      }
    }
  };
  return GraphSeriesModel;
}(__WEBPACK_IMPORTED_MODULE_7__model_Series_js__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (GraphSeriesModel);

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_SymbolDraw_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_LineDraw_js__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component_helper_RoamController_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_helper_roamHelper_js__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_helper_cursorHelper_js__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__adjustEdge_js__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__graphHelper_js__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_innerStore_js__ = __webpack_require__(17);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/













function isViewCoordSys(coordSys) {
  return coordSys.type === 'view';
}

var GraphView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(GraphView, _super);

  function GraphView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = GraphView.type;
    return _this;
  }

  GraphView.prototype.init = function (ecModel, api) {
    var symbolDraw = new __WEBPACK_IMPORTED_MODULE_2__helper_SymbolDraw_js__["a" /* default */]();
    var lineDraw = new __WEBPACK_IMPORTED_MODULE_3__helper_LineDraw_js__["a" /* default */]();
    var group = this.group;
    this._controller = new __WEBPACK_IMPORTED_MODULE_4__component_helper_RoamController_js__["a" /* default */](api.getZr());
    this._controllerHost = {
      target: group
    };
    group.add(symbolDraw.group);
    group.add(lineDraw.group);
    this._symbolDraw = symbolDraw;
    this._lineDraw = lineDraw;
    this._firstRender = true;
  };

  GraphView.prototype.render = function (seriesModel, ecModel, api) {
    var _this = this;

    var coordSys = seriesModel.coordinateSystem;
    this._model = seriesModel;
    var symbolDraw = this._symbolDraw;
    var lineDraw = this._lineDraw;
    var group = this.group;

    if (isViewCoordSys(coordSys)) {
      var groupNewProp = {
        x: coordSys.x,
        y: coordSys.y,
        scaleX: coordSys.scaleX,
        scaleY: coordSys.scaleY
      };

      if (this._firstRender) {
        group.attr(groupNewProp);
      } else {
        __WEBPACK_IMPORTED_MODULE_7__util_graphic_js__["updateProps"](group, groupNewProp, seriesModel);
      }
    } // Fix edge contact point with node


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__adjustEdge_js__["a" /* default */])(seriesModel.getGraph(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__graphHelper_js__["a" /* getNodeGlobalScale */])(seriesModel));
    var data = seriesModel.getData();
    symbolDraw.updateData(data);
    var edgeData = seriesModel.getEdgeData(); // TODO: TYPE

    lineDraw.updateData(edgeData);

    this._updateNodeAndLinkScale();

    this._updateController(seriesModel, ecModel, api);

    clearTimeout(this._layoutTimeout);
    var forceLayout = seriesModel.forceLayout;
    var layoutAnimation = seriesModel.get(['force', 'layoutAnimation']);

    if (forceLayout) {
      this._startForceLayoutIteration(forceLayout, layoutAnimation);
    }

    data.graph.eachNode(function (node) {
      var idx = node.dataIndex;
      var el = node.getGraphicEl();
      var itemModel = node.getModel();

      if (!el) {
        return;
      } // Update draggable


      el.off('drag').off('dragend');
      var draggable = itemModel.get('draggable');

      if (draggable) {
        el.on('drag', function () {
          if (forceLayout) {
            forceLayout.warmUp();
            !_this._layouting && _this._startForceLayoutIteration(forceLayout, layoutAnimation);
            forceLayout.setFixed(idx); // Write position back to layout

            data.setItemLayout(idx, [el.x, el.y]);
          }
        }).on('dragend', function () {
          if (forceLayout) {
            forceLayout.setUnfixed(idx);
          }
        });
      }

      el.setDraggable(draggable && !!forceLayout);
      var focus = itemModel.get(['emphasis', 'focus']);

      if (focus === 'adjacency') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_innerStore_js__["a" /* getECData */])(el).focus = node.getAdjacentDataIndices();
      }
    });
    data.graph.eachEdge(function (edge) {
      var el = edge.getGraphicEl();
      var focus = edge.getModel().get(['emphasis', 'focus']);

      if (!el) {
        return;
      }

      if (focus === 'adjacency') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_innerStore_js__["a" /* getECData */])(el).focus = {
          edge: [edge.dataIndex],
          node: [edge.node1.dataIndex, edge.node2.dataIndex]
        };
      }
    });
    var circularRotateLabel = seriesModel.get('layout') === 'circular' && seriesModel.get(['circular', 'rotateLabel']);
    var cx = data.getLayout('cx');
    var cy = data.getLayout('cy');
    data.eachItemGraphicEl(function (el, idx) {
      var itemModel = data.getItemModel(idx);
      var labelRotate = itemModel.get(['label', 'rotate']) || 0;
      var symbolPath = el.getSymbolPath();

      if (circularRotateLabel) {
        var pos = data.getItemLayout(idx);
        var rad = Math.atan2(pos[1] - cy, pos[0] - cx);

        if (rad < 0) {
          rad = Math.PI * 2 + rad;
        }

        var isLeft = pos[0] < cx;

        if (isLeft) {
          rad = rad - Math.PI;
        }

        var textPosition = isLeft ? 'left' : 'right';
        symbolPath.setTextConfig({
          rotation: -rad,
          position: textPosition,
          origin: 'center'
        });
        var emphasisState = symbolPath.ensureState('emphasis');
        __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"](emphasisState.textConfig || (emphasisState.textConfig = {}), {
          position: textPosition
        });
      } else {
        symbolPath.setTextConfig({
          rotation: labelRotate *= Math.PI / 180
        });
      }
    });
    this._firstRender = false;
  };

  GraphView.prototype.dispose = function () {
    this._controller && this._controller.dispose();
    this._controllerHost = null;
  };

  GraphView.prototype._startForceLayoutIteration = function (forceLayout, layoutAnimation) {
    var self = this;

    (function step() {
      forceLayout.step(function (stopped) {
        self.updateLayout(self._model);
        (self._layouting = !stopped) && (layoutAnimation ? self._layoutTimeout = setTimeout(step, 16) : step());
      });
    })();
  };

  GraphView.prototype._updateController = function (seriesModel, ecModel, api) {
    var _this = this;

    var controller = this._controller;
    var controllerHost = this._controllerHost;
    var group = this.group;
    controller.setPointerChecker(function (e, x, y) {
      var rect = group.getBoundingRect();
      rect.applyTransform(group.transform);
      return rect.contain(x, y) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__component_helper_cursorHelper_js__["a" /* onIrrelevantElement */])(e, api, seriesModel);
    });

    if (!isViewCoordSys(seriesModel.coordinateSystem)) {
      controller.disable();
      return;
    }

    controller.enable(seriesModel.get('roam'));
    controllerHost.zoomLimit = seriesModel.get('scaleLimit');
    controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
    controller.off('pan').off('zoom').on('pan', function (e) {
      __WEBPACK_IMPORTED_MODULE_5__component_helper_roamHelper_js__["a" /* updateViewOnPan */](controllerHost, e.dx, e.dy);
      api.dispatchAction({
        seriesId: seriesModel.id,
        type: 'graphRoam',
        dx: e.dx,
        dy: e.dy
      });
    }).on('zoom', function (e) {
      __WEBPACK_IMPORTED_MODULE_5__component_helper_roamHelper_js__["b" /* updateViewOnZoom */](controllerHost, e.scale, e.originX, e.originY);
      api.dispatchAction({
        seriesId: seriesModel.id,
        type: 'graphRoam',
        zoom: e.scale,
        originX: e.originX,
        originY: e.originY
      });

      _this._updateNodeAndLinkScale();

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__adjustEdge_js__["a" /* default */])(seriesModel.getGraph(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__graphHelper_js__["a" /* getNodeGlobalScale */])(seriesModel));

      _this._lineDraw.updateLayout(); // Only update label layout on zoom


      api.updateLabelLayout();
    });
  };

  GraphView.prototype._updateNodeAndLinkScale = function () {
    var seriesModel = this._model;
    var data = seriesModel.getData();
    var nodeScale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__graphHelper_js__["a" /* getNodeGlobalScale */])(seriesModel);
    data.eachItemGraphicEl(function (el, idx) {
      el && el.setSymbolScale(nodeScale);
    });
  };

  GraphView.prototype.updateLayout = function (seriesModel) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__adjustEdge_js__["a" /* default */])(seriesModel.getGraph(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__graphHelper_js__["a" /* getNodeGlobalScale */])(seriesModel));

    this._symbolDraw.updateLayout();

    this._lineDraw.updateLayout();
  };

  GraphView.prototype.remove = function (ecModel, api) {
    this._symbolDraw && this._symbolDraw.remove();
    this._lineDraw && this._lineDraw.remove();
  };

  GraphView.type = 'graph';
  return GraphView;
}(__WEBPACK_IMPORTED_MODULE_10__view_Chart_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (GraphView);

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = adjustEdge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_curve_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphHelper_js__ = __webpack_require__(313);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var v1 = [];
var v2 = [];
var v3 = [];
var quadraticAt = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_curve_js__["f" /* quadraticAt */];
var v2DistSquare = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["distSquare"];
var mathAbs = Math.abs;

function intersectCurveCircle(curvePoints, center, radius) {
  var p0 = curvePoints[0];
  var p1 = curvePoints[1];
  var p2 = curvePoints[2];
  var d = Infinity;
  var t;
  var radiusSquare = radius * radius;
  var interval = 0.1;

  for (var _t = 0.1; _t <= 0.9; _t += 0.1) {
    v1[0] = quadraticAt(p0[0], p1[0], p2[0], _t);
    v1[1] = quadraticAt(p0[1], p1[1], p2[1], _t);
    var diff = mathAbs(v2DistSquare(v1, center) - radiusSquare);

    if (diff < d) {
      d = diff;
      t = _t;
    }
  } // Assume the segment is monotone，Find root through Bisection method
  // At most 32 iteration


  for (var i = 0; i < 32; i++) {
    // let prev = t - interval;
    var next = t + interval; // v1[0] = quadraticAt(p0[0], p1[0], p2[0], prev);
    // v1[1] = quadraticAt(p0[1], p1[1], p2[1], prev);

    v2[0] = quadraticAt(p0[0], p1[0], p2[0], t);
    v2[1] = quadraticAt(p0[1], p1[1], p2[1], t);
    v3[0] = quadraticAt(p0[0], p1[0], p2[0], next);
    v3[1] = quadraticAt(p0[1], p1[1], p2[1], next);
    var diff = v2DistSquare(v2, center) - radiusSquare;

    if (mathAbs(diff) < 1e-2) {
      break;
    } // let prevDiff = v2DistSquare(v1, center) - radiusSquare;


    var nextDiff = v2DistSquare(v3, center) - radiusSquare;
    interval /= 2;

    if (diff < 0) {
      if (nextDiff >= 0) {
        t = t + interval;
      } else {
        t = t - interval;
      }
    } else {
      if (nextDiff >= 0) {
        t = t - interval;
      } else {
        t = t + interval;
      }
    }
  }

  return t;
} // Adjust edge to avoid


function adjustEdge(graph, scale) {
  var tmp0 = [];
  var quadraticSubdivide = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_curve_js__["l" /* quadraticSubdivide */];
  var pts = [[], [], []];
  var pts2 = [[], []];
  var v = [];
  scale /= 2;
  graph.eachEdge(function (edge, idx) {
    var linePoints = edge.getLayout();
    var fromSymbol = edge.getVisual('fromSymbol');
    var toSymbol = edge.getVisual('toSymbol');

    if (!linePoints.__original) {
      linePoints.__original = [__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["clone"](linePoints[0]), __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["clone"](linePoints[1])];

      if (linePoints[2]) {
        linePoints.__original.push(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["clone"](linePoints[2]));
      }
    }

    var originalPoints = linePoints.__original; // Quadratic curve

    if (linePoints[2] != null) {
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["copy"](pts[0], originalPoints[0]);
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["copy"](pts[1], originalPoints[2]);
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["copy"](pts[2], originalPoints[1]);

      if (fromSymbol && fromSymbol !== 'none') {
        var symbolSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__graphHelper_js__["b" /* getSymbolSize */])(edge.node1);
        var t = intersectCurveCircle(pts, originalPoints[0], symbolSize * scale); // Subdivide and get the second

        quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
        pts[0][0] = tmp0[3];
        pts[1][0] = tmp0[4];
        quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
        pts[0][1] = tmp0[3];
        pts[1][1] = tmp0[4];
      }

      if (toSymbol && toSymbol !== 'none') {
        var symbolSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__graphHelper_js__["b" /* getSymbolSize */])(edge.node2);
        var t = intersectCurveCircle(pts, originalPoints[1], symbolSize * scale); // Subdivide and get the first

        quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
        pts[1][0] = tmp0[1];
        pts[2][0] = tmp0[2];
        quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
        pts[1][1] = tmp0[1];
        pts[2][1] = tmp0[2];
      } // Copy back to layout


      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["copy"](linePoints[0], pts[0]);
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["copy"](linePoints[1], pts[2]);
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["copy"](linePoints[2], pts[1]);
    } // Line
    else {
        __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["copy"](pts2[0], originalPoints[0]);
        __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["copy"](pts2[1], originalPoints[1]);
        __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["sub"](v, pts2[1], pts2[0]);
        __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["normalize"](v, v);

        if (fromSymbol && fromSymbol !== 'none') {
          var symbolSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__graphHelper_js__["b" /* getSymbolSize */])(edge.node1);
          __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["scaleAndAdd"](pts2[0], pts2[0], v, symbolSize * scale);
        }

        if (toSymbol && toSymbol !== 'none') {
          var symbolSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__graphHelper_js__["b" /* getSymbolSize */])(edge.node2);
          __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["scaleAndAdd"](pts2[1], pts2[1], v, -symbolSize * scale);
        }

        __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["copy"](linePoints[0], pts2[0]);
        __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_vector_js__["copy"](linePoints[1], pts2[1]);
      }
  });
}

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = categoryFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

function categoryFilter(ecModel) {
  var legendModels = ecModel.findComponents({
    mainType: 'legend'
  });

  if (!legendModels || !legendModels.length) {
    return;
  }

  ecModel.eachSeriesByType('graph', function (graphSeries) {
    var categoriesData = graphSeries.getCategoriesData();
    var graph = graphSeries.getGraph();
    var data = graph.data;
    var categoryNames = categoriesData.mapArray(categoriesData.getName);
    data.filterSelf(function (idx) {
      var model = data.getItemModel(idx);
      var category = model.getShallow('category');

      if (category != null) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isNumber"])(category)) {
          category = categoryNames[category];
        } // If in any legend component the status is not selected.


        for (var i = 0; i < legendModels.length; i++) {
          if (!legendModels[i].isSelected(category)) {
            return false;
          }
        }
      }

      return true;
    });
  });
}

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = categoryVisual;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

function categoryVisual(ecModel) {
  var paletteScope = {};
  ecModel.eachSeriesByType('graph', function (seriesModel) {
    var categoriesData = seriesModel.getCategoriesData();
    var data = seriesModel.getData();
    var categoryNameIdxMap = {};
    categoriesData.each(function (idx) {
      var name = categoriesData.getName(idx); // Add prefix to avoid conflict with Object.prototype.

      categoryNameIdxMap['ec-' + name] = idx;
      var itemModel = categoriesData.getItemModel(idx);
      var style = itemModel.getModel('itemStyle').getItemStyle();

      if (!style.fill) {
        // Get color from palette.
        style.fill = seriesModel.getColorFromPalette(name, paletteScope);
      }

      categoriesData.setItemVisual(idx, 'style', style);
      var symbolVisualList = ['symbol', 'symbolSize', 'symbolKeepAspect'];

      for (var i = 0; i < symbolVisualList.length; i++) {
        var symbolVisual = itemModel.getShallow(symbolVisualList[i], true);

        if (symbolVisual != null) {
          categoriesData.setItemVisual(idx, symbolVisualList[i], symbolVisual);
        }
      }
    }); // Assign category color to visual

    if (categoriesData.count()) {
      data.each(function (idx) {
        var model = data.getItemModel(idx);
        var categoryIdx = model.getShallow('category');

        if (categoryIdx != null) {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"])(categoryIdx)) {
            categoryIdx = categoryNameIdxMap['ec-' + categoryIdx];
          }

          var categoryStyle = categoriesData.getItemVisual(categoryIdx, 'style');
          var style = data.ensureUniqueItemVisual(idx, 'style');
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"])(style, categoryStyle);
          var visualList = ['symbol', 'symbolSize', 'symbolKeepAspect'];

          for (var i = 0; i < visualList.length; i++) {
            data.setItemVisual(idx, visualList[i], categoriesData.getItemVisual(categoryIdx, visualList[i]));
          }
        }
      });
    }
  });
}

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = graphCircularLayout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__circularLayoutHelper_js__ = __webpack_require__(443);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

function graphCircularLayout(ecModel) {
  ecModel.eachSeriesByType('graph', function (seriesModel) {
    if (seriesModel.get('layout') === 'circular') {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__circularLayoutHelper_js__["a" /* circularLayout */])(seriesModel, 'symbolSize');
    }
  });
}

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createViewCoordSys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coord_View_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_bbox_js__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// FIXME Where to create the simple view coordinate system





function getViewRect(seriesModel, api, aspect) {
  var option = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["extend"])(seriesModel.getBoxLayoutParams(), {
    aspect: aspect
  });
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_layout_js__["f" /* getLayoutRect */])(option, {
    width: api.getWidth(),
    height: api.getHeight()
  });
}

function createViewCoordSys(ecModel, api) {
  var viewList = [];
  ecModel.eachSeriesByType('graph', function (seriesModel) {
    var coordSysType = seriesModel.get('coordinateSystem');

    if (!coordSysType || coordSysType === 'view') {
      var data_1 = seriesModel.getData();
      var positions = data_1.mapArray(function (idx) {
        var itemModel = data_1.getItemModel(idx);
        return [+itemModel.get('x'), +itemModel.get('y')];
      });
      var min = [];
      var max = [];
      __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_bbox_js__["e" /* fromPoints */](positions, min, max); // If width or height is 0

      if (max[0] - min[0] === 0) {
        max[0] += 1;
        min[0] -= 1;
      }

      if (max[1] - min[1] === 0) {
        max[1] += 1;
        min[1] -= 1;
      }

      var aspect = (max[0] - min[0]) / (max[1] - min[1]); // FIXME If get view rect after data processed?

      var viewRect = getViewRect(seriesModel, api, aspect); // Position may be NaN, use view rect instead

      if (isNaN(aspect)) {
        min = [viewRect.x, viewRect.y];
        max = [viewRect.x + viewRect.width, viewRect.y + viewRect.height];
      }

      var bbWidth = max[0] - min[0];
      var bbHeight = max[1] - min[1];
      var viewWidth = viewRect.width;
      var viewHeight = viewRect.height;
      var viewCoordSys = seriesModel.coordinateSystem = new __WEBPACK_IMPORTED_MODULE_0__coord_View_js__["a" /* default */]();
      viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
      viewCoordSys.setBoundingRect(min[0], min[1], bbWidth, bbHeight);
      viewCoordSys.setViewRect(viewRect.x, viewRect.y, viewWidth, viewHeight); // Update roam info

      viewCoordSys.setCenter(seriesModel.get('center'));
      viewCoordSys.setZoom(seriesModel.get('zoom'));
      viewList.push(viewCoordSys);
    }
  });
  return viewList;
}

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = graphEdgeVisual;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


function normalize(a) {
  if (!(a instanceof Array)) {
    a = [a, a];
  }

  return a;
}

function graphEdgeVisual(ecModel) {
  ecModel.eachSeriesByType('graph', function (seriesModel) {
    var graph = seriesModel.getGraph();
    var edgeData = seriesModel.getEdgeData();
    var symbolType = normalize(seriesModel.get('edgeSymbol'));
    var symbolSize = normalize(seriesModel.get('edgeSymbolSize')); // const colorQuery = ['lineStyle', 'color'] as const;
    // const opacityQuery = ['lineStyle', 'opacity'] as const;

    edgeData.setVisual('fromSymbol', symbolType && symbolType[0]);
    edgeData.setVisual('toSymbol', symbolType && symbolType[1]);
    edgeData.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
    edgeData.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
    edgeData.setVisual('style', seriesModel.getModel('lineStyle').getLineStyle());
    edgeData.each(function (idx) {
      var itemModel = edgeData.getItemModel(idx);
      var edge = graph.getEdgeByIndex(idx);
      var symbolType = normalize(itemModel.getShallow('symbol', true));
      var symbolSize = normalize(itemModel.getShallow('symbolSize', true)); // Edge visual must after node visual

      var style = itemModel.getModel('lineStyle').getLineStyle();
      var existsStyle = edgeData.ensureUniqueItemVisual(idx, 'style');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"])(existsStyle, style);

      switch (existsStyle.stroke) {
        case 'source':
          {
            var nodeStyle = edge.node1.getVisual('style');
            existsStyle.stroke = nodeStyle && nodeStyle.fill;
            break;
          }

        case 'target':
          {
            var nodeStyle = edge.node2.getVisual('style');
            existsStyle.stroke = nodeStyle && nodeStyle.fill;
            break;
          }
      }

      symbolType[0] && edge.setVisual('fromSymbol', symbolType[0]);
      symbolType[1] && edge.setVisual('toSymbol', symbolType[1]);
      symbolSize[0] && edge.setVisual('fromSymbolSize', symbolSize[0]);
      symbolSize[1] && edge.setVisual('toSymbolSize', symbolSize[1]);
    });
  });
}

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = forceLayout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_vector_js__ = __webpack_require__(23);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* A third-party license is embeded for some of the code in this file:
* Some formulas were originally copied from "d3.js" with some
* modifications made for this project.
* (See more details in the comment of the method "step" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/

var scaleAndAdd = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_vector_js__["scaleAndAdd"]; // function adjacentNode(n, e) {
//     return e.n1 === n ? e.n2 : e.n1;
// }

function forceLayout(inNodes, inEdges, opts) {
  var nodes = inNodes;
  var edges = inEdges;
  var rect = opts.rect;
  var width = rect.width;
  var height = rect.height;
  var center = [rect.x + width / 2, rect.y + height / 2]; // let scale = opts.scale || 1;

  var gravity = opts.gravity == null ? 0.1 : opts.gravity; // for (let i = 0; i < edges.length; i++) {
  //     let e = edges[i];
  //     let n1 = e.n1;
  //     let n2 = e.n2;
  //     n1.edges = n1.edges || [];
  //     n2.edges = n2.edges || [];
  //     n1.edges.push(e);
  //     n2.edges.push(e);
  // }
  // Init position

  for (var i = 0; i < nodes.length; i++) {
    var n = nodes[i];

    if (!n.p) {
      n.p = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_vector_js__["create"](width * (Math.random() - 0.5) + center[0], height * (Math.random() - 0.5) + center[1]);
    }

    n.pp = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_vector_js__["clone"](n.p);
    n.edges = null;
  } // Formula in 'Graph Drawing by Force-directed Placement'
  // let k = scale * Math.sqrt(width * height / nodes.length);
  // let k2 = k * k;


  var initialFriction = opts.friction == null ? 0.6 : opts.friction;
  var friction = initialFriction;
  var beforeStepCallback;
  var afterStepCallback;
  return {
    warmUp: function () {
      friction = initialFriction * 0.8;
    },
    setFixed: function (idx) {
      nodes[idx].fixed = true;
    },
    setUnfixed: function (idx) {
      nodes[idx].fixed = false;
    },

    /**
     * Before step hook
     */
    beforeStep: function (cb) {
      beforeStepCallback = cb;
    },

    /**
     * After step hook
     */
    afterStep: function (cb) {
      afterStepCallback = cb;
    },

    /**
     * Some formulas were originally copied from "d3.js"
     * https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/layout/force.js
     * with some modifications made for this project.
     * See the license statement at the head of this file.
     */
    step: function (cb) {
      beforeStepCallback && beforeStepCallback(nodes, edges);
      var v12 = [];
      var nLen = nodes.length;

      for (var i = 0; i < edges.length; i++) {
        var e = edges[i];

        if (e.ignoreForceLayout) {
          continue;
        }

        var n1 = e.n1;
        var n2 = e.n2;
        __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_vector_js__["sub"](v12, n2.p, n1.p);
        var d = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_vector_js__["len"](v12) - e.d;
        var w = n2.w / (n1.w + n2.w);

        if (isNaN(w)) {
          w = 0;
        }

        __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_vector_js__["normalize"](v12, v12);
        !n1.fixed && scaleAndAdd(n1.p, n1.p, v12, w * d * friction);
        !n2.fixed && scaleAndAdd(n2.p, n2.p, v12, -(1 - w) * d * friction);
      } // Gravity


      for (var i = 0; i < nLen; i++) {
        var n = nodes[i];

        if (!n.fixed) {
          __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_vector_js__["sub"](v12, center, n.p); // let d = vec2.len(v12);
          // vec2.scale(v12, v12, 1 / d);
          // let gravityFactor = gravity;

          scaleAndAdd(n.p, n.p, v12, gravity * friction);
        }
      } // Repulsive
      // PENDING


      for (var i = 0; i < nLen; i++) {
        var n1 = nodes[i];

        for (var j = i + 1; j < nLen; j++) {
          var n2 = nodes[j];
          __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_vector_js__["sub"](v12, n2.p, n1.p);
          var d = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_vector_js__["len"](v12);

          if (d === 0) {
            // Random repulse
            __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_vector_js__["set"](v12, Math.random() - 0.5, Math.random() - 0.5);
            d = 1;
          }

          var repFact = (n1.rep + n2.rep) / d / d;
          !n1.fixed && scaleAndAdd(n1.pp, n1.pp, v12, repFact);
          !n2.fixed && scaleAndAdd(n2.pp, n2.pp, v12, -repFact);
        }
      }

      var v = [];

      for (var i = 0; i < nLen; i++) {
        var n = nodes[i];

        if (!n.fixed) {
          __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_vector_js__["sub"](v, n.p, n.pp);
          scaleAndAdd(n.p, n.p, v, friction);
          __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_vector_js__["copy"](n.pp, n.p);
        }
      }

      friction = friction * 0.992;
      var finished = friction < 0.01;
      afterStepCallback && afterStepCallback(nodes, edges, finished);
      cb && cb(finished);
    }
  };
}

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = graphForceLayout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__forceHelper_js__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__simpleLayoutHelper_js__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__circularLayoutHelper_js__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_vector_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_multipleGraphEdgeHelper_js__ = __webpack_require__(229);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







function graphForceLayout(ecModel) {
  ecModel.eachSeriesByType('graph', function (graphSeries) {
    var coordSys = graphSeries.coordinateSystem;

    if (coordSys && coordSys.type !== 'view') {
      return;
    }

    if (graphSeries.get('layout') === 'force') {
      var preservedPoints_1 = graphSeries.preservedPoints || {};
      var graph_1 = graphSeries.getGraph();
      var nodeData_1 = graph_1.data;
      var edgeData = graph_1.edgeData;
      var forceModel = graphSeries.getModel('force');
      var initLayout = forceModel.get('initLayout');

      if (graphSeries.preservedPoints) {
        nodeData_1.each(function (idx) {
          var id = nodeData_1.getId(idx);
          nodeData_1.setItemLayout(idx, preservedPoints_1[id] || [NaN, NaN]);
        });
      } else if (!initLayout || initLayout === 'none') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__simpleLayoutHelper_js__["a" /* simpleLayout */])(graphSeries);
      } else if (initLayout === 'circular') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__circularLayoutHelper_js__["a" /* circularLayout */])(graphSeries, 'value');
      }

      var nodeDataExtent_1 = nodeData_1.getDataExtent('value');
      var edgeDataExtent_1 = edgeData.getDataExtent('value'); // let edgeDataExtent = edgeData.getDataExtent('value');

      var repulsion = forceModel.get('repulsion');
      var edgeLength = forceModel.get('edgeLength');
      var repulsionArr_1 = __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["isArray"](repulsion) ? repulsion : [repulsion, repulsion];
      var edgeLengthArr_1 = __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["isArray"](edgeLength) ? edgeLength : [edgeLength, edgeLength]; // Larger value has smaller length

      edgeLengthArr_1 = [edgeLengthArr_1[1], edgeLengthArr_1[0]];
      var nodes_1 = nodeData_1.mapArray('value', function (value, idx) {
        var point = nodeData_1.getItemLayout(idx);
        var rep = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_number_js__["h" /* linearMap */])(value, nodeDataExtent_1, repulsionArr_1);

        if (isNaN(rep)) {
          rep = (repulsionArr_1[0] + repulsionArr_1[1]) / 2;
        }

        return {
          w: rep,
          rep: rep,
          fixed: nodeData_1.getItemModel(idx).get('fixed'),
          p: !point || isNaN(point[0]) || isNaN(point[1]) ? null : point
        };
      });
      var edges = edgeData.mapArray('value', function (value, idx) {
        var edge = graph_1.getEdgeByIndex(idx);
        var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_number_js__["h" /* linearMap */])(value, edgeDataExtent_1, edgeLengthArr_1);

        if (isNaN(d)) {
          d = (edgeLengthArr_1[0] + edgeLengthArr_1[1]) / 2;
        }

        var edgeModel = edge.getModel();
        var curveness = __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["retrieve3"](edge.getModel().get(['lineStyle', 'curveness']), -__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helper_multipleGraphEdgeHelper_js__["a" /* getCurvenessForEdge */])(edge, graphSeries, idx, true), 0);
        return {
          n1: nodes_1[edge.node1.dataIndex],
          n2: nodes_1[edge.node2.dataIndex],
          d: d,
          curveness: curveness,
          ignoreForceLayout: edgeModel.get('ignoreForceLayout')
        };
      }); // let coordSys = graphSeries.coordinateSystem;

      var rect = coordSys.getBoundingRect();
      var forceInstance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__forceHelper_js__["a" /* forceLayout */])(nodes_1, edges, {
        rect: rect,
        gravity: forceModel.get('gravity'),
        friction: forceModel.get('friction')
      });
      forceInstance.beforeStep(function (nodes, edges) {
        for (var i = 0, l = nodes.length; i < l; i++) {
          if (nodes[i].fixed) {
            // Write back to layout instance
            __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_vector_js__["copy"](nodes[i].p, graph_1.getNodeByIndex(i).getLayout());
          }
        }
      });
      forceInstance.afterStep(function (nodes, edges, stopped) {
        for (var i = 0, l = nodes.length; i < l; i++) {
          if (!nodes[i].fixed) {
            graph_1.getNodeByIndex(i).setLayout(nodes[i].p);
          }

          preservedPoints_1[nodeData_1.getId(i)] = nodes[i].p;
        }

        for (var i = 0, l = edges.length; i < l; i++) {
          var e = edges[i];
          var edge = graph_1.getEdgeByIndex(i);
          var p1 = e.n1.p;
          var p2 = e.n2.p;
          var points = edge.getLayout();
          points = points ? points.slice() : [];
          points[0] = points[0] || [];
          points[1] = points[1] || [];
          __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_vector_js__["copy"](points[0], p1);
          __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_vector_js__["copy"](points[1], p2);

          if (+e.curveness) {
            points[2] = [(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * e.curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * e.curveness];
          }

          edge.setLayout(points);
        }
      });
      graphSeries.forceLayout = forceInstance;
      graphSeries.preservedPoints = preservedPoints_1; // Step to get the layout

      forceInstance.step();
    } else {
      // Remove prev injected forceLayout instance
      graphSeries.forceLayout = null;
    }
  });
}

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__categoryFilter_js__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__categoryVisual_js__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__edgeVisual_js__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__simpleLayout_js__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__circularLayout_js__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__forceLayout_js__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createView_js__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__coord_View_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__GraphView_js__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GraphSeries_js__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__action_roamHelper_js__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/












var actionInfo = {
  type: 'graphRoam',
  event: 'graphRoam',
  update: 'none'
};
function install(registers) {
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_8__GraphView_js__["a" /* default */]);
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_9__GraphSeries_js__["a" /* default */]);
  registers.registerProcessor(__WEBPACK_IMPORTED_MODULE_0__categoryFilter_js__["a" /* default */]);
  registers.registerVisual(__WEBPACK_IMPORTED_MODULE_1__categoryVisual_js__["a" /* default */]);
  registers.registerVisual(__WEBPACK_IMPORTED_MODULE_2__edgeVisual_js__["a" /* default */]);
  registers.registerLayout(__WEBPACK_IMPORTED_MODULE_3__simpleLayout_js__["a" /* default */]);
  registers.registerLayout(registers.PRIORITY.VISUAL.POST_CHART_LAYOUT, __WEBPACK_IMPORTED_MODULE_4__circularLayout_js__["a" /* default */]);
  registers.registerLayout(__WEBPACK_IMPORTED_MODULE_5__forceLayout_js__["a" /* default */]);
  registers.registerCoordinateSystem('graphView', {
    dimensions: __WEBPACK_IMPORTED_MODULE_7__coord_View_js__["a" /* default */].dimensions,
    create: __WEBPACK_IMPORTED_MODULE_6__createView_js__["a" /* default */]
  }); // Register legacy focus actions

  registers.registerAction({
    type: 'focusNodeAdjacency',
    event: 'focusNodeAdjacency',
    update: 'series:focusNodeAdjacency'
  }, __WEBPACK_IMPORTED_MODULE_11_zrender_lib_core_util_js__["noop"]);
  registers.registerAction({
    type: 'unfocusNodeAdjacency',
    event: 'unfocusNodeAdjacency',
    update: 'series:unfocusNodeAdjacency'
  }, __WEBPACK_IMPORTED_MODULE_11_zrender_lib_core_util_js__["noop"]); // Register roam action.

  registers.registerAction(actionInfo, function (payload, ecModel) {
    ecModel.eachComponent({
      mainType: 'series',
      query: payload
    }, function (seriesModel) {
      var coordSys = seriesModel.coordinateSystem;
      var res = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__action_roamHelper_js__["a" /* updateCenterAndZoom */])(coordSys, payload);
      seriesModel.setCenter && seriesModel.setCenter(res.center);
      seriesModel.setZoom && seriesModel.setZoom(res.zoom);
    });
  });
}

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = graphSimpleLayout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__simpleLayoutHelper_js__ = __webpack_require__(444);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


function graphSimpleLayout(ecModel, api) {
  ecModel.eachSeriesByType('graph', function (seriesModel) {
    var layout = seriesModel.get('layout');
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys && coordSys.type !== 'view') {
      var data_1 = seriesModel.getData();
      var dimensions_1 = [];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(coordSys.dimensions, function (coordDim) {
        dimensions_1 = dimensions_1.concat(data_1.mapDimensionsAll(coordDim));
      });

      for (var dataIndex = 0; dataIndex < data_1.count(); dataIndex++) {
        var value = [];
        var hasValue = false;

        for (var i = 0; i < dimensions_1.length; i++) {
          var val = data_1.get(dimensions_1[i], dataIndex);

          if (!isNaN(val)) {
            hasValue = true;
          }

          value.push(val);
        }

        if (hasValue) {
          data_1.setItemLayout(dataIndex, coordSys.dataToPoint(value));
        } else {
          // Also {Array.<number>}, not undefined to avoid if...else... statement
          data_1.setItemLayout(dataIndex, [NaN, NaN]);
        }
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__simpleLayoutHelper_js__["b" /* simpleLayoutEdge */])(data_1.graph, seriesModel);
    } else if (!layout || layout === 'none') {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__simpleLayoutHelper_js__["a" /* simpleLayout */])(seriesModel);
    }
  });
}

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_platform_js__ = __webpack_require__(67);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/* global Uint8ClampedArray */

var GRADIENT_LEVELS = 256;

var HeatmapLayer =
/** @class */
function () {
  function HeatmapLayer() {
    this.blurSize = 30;
    this.pointSize = 20;
    this.maxOpacity = 1;
    this.minOpacity = 0;
    this._gradientPixels = {
      inRange: null,
      outOfRange: null
    };
    var canvas = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_platform_js__["a" /* platformApi */].createCanvas();
    this.canvas = canvas;
  }
  /**
   * Renders Heatmap and returns the rendered canvas
   * @param data array of data, each has x, y, value
   * @param width canvas width
   * @param height canvas height
   */


  HeatmapLayer.prototype.update = function (data, width, height, normalize, colorFunc, isInRange) {
    var brush = this._getBrush();

    var gradientInRange = this._getGradient(colorFunc, 'inRange');

    var gradientOutOfRange = this._getGradient(colorFunc, 'outOfRange');

    var r = this.pointSize + this.blurSize;
    var canvas = this.canvas;
    var ctx = canvas.getContext('2d');
    var len = data.length;
    canvas.width = width;
    canvas.height = height;

    for (var i = 0; i < len; ++i) {
      var p = data[i];
      var x = p[0];
      var y = p[1];
      var value = p[2]; // calculate alpha using value

      var alpha = normalize(value); // draw with the circle brush with alpha

      ctx.globalAlpha = alpha;
      ctx.drawImage(brush, x - r, y - r);
    }

    if (!canvas.width || !canvas.height) {
      // Avoid "Uncaught DOMException: Failed to execute 'getImageData' on
      // 'CanvasRenderingContext2D': The source height is 0."
      return canvas;
    } // colorize the canvas using alpha value and set with gradient


    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var pixels = imageData.data;
    var offset = 0;
    var pixelLen = pixels.length;
    var minOpacity = this.minOpacity;
    var maxOpacity = this.maxOpacity;
    var diffOpacity = maxOpacity - minOpacity;

    while (offset < pixelLen) {
      var alpha = pixels[offset + 3] / 256;
      var gradientOffset = Math.floor(alpha * (GRADIENT_LEVELS - 1)) * 4; // Simple optimize to ignore the empty data

      if (alpha > 0) {
        var gradient = isInRange(alpha) ? gradientInRange : gradientOutOfRange; // Any alpha > 0 will be mapped to [minOpacity, maxOpacity]

        alpha > 0 && (alpha = alpha * diffOpacity + minOpacity);
        pixels[offset++] = gradient[gradientOffset];
        pixels[offset++] = gradient[gradientOffset + 1];
        pixels[offset++] = gradient[gradientOffset + 2];
        pixels[offset++] = gradient[gradientOffset + 3] * alpha * 256;
      } else {
        offset += 4;
      }
    }

    ctx.putImageData(imageData, 0, 0);
    return canvas;
  };
  /**
   * get canvas of a black circle brush used for canvas to draw later
   */


  HeatmapLayer.prototype._getBrush = function () {
    var brushCanvas = this._brushCanvas || (this._brushCanvas = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_platform_js__["a" /* platformApi */].createCanvas()); // set brush size

    var r = this.pointSize + this.blurSize;
    var d = r * 2;
    brushCanvas.width = d;
    brushCanvas.height = d;
    var ctx = brushCanvas.getContext('2d');
    ctx.clearRect(0, 0, d, d); // in order to render shadow without the distinct circle,
    // draw the distinct circle in an invisible place,
    // and use shadowOffset to draw shadow in the center of the canvas

    ctx.shadowOffsetX = d;
    ctx.shadowBlur = this.blurSize; // draw the shadow in black, and use alpha and shadow blur to generate
    // color in color map

    ctx.shadowColor = '#000'; // draw circle in the left to the canvas

    ctx.beginPath();
    ctx.arc(-r, r, this.pointSize, 0, Math.PI * 2, true);
    ctx.closePath();
    ctx.fill();
    return brushCanvas;
  };
  /**
   * get gradient color map
   * @private
   */


  HeatmapLayer.prototype._getGradient = function (colorFunc, state) {
    var gradientPixels = this._gradientPixels;
    var pixelsSingleState = gradientPixels[state] || (gradientPixels[state] = new Uint8ClampedArray(256 * 4));
    var color = [0, 0, 0, 0];
    var off = 0;

    for (var i = 0; i < 256; i++) {
      colorFunc[state](i / 255, true, color);
      pixelsSingleState[off++] = color[0];
      pixelsSingleState[off++] = color[1];
      pixelsSingleState[off++] = color[2];
      pixelsSingleState[off++] = color[3];
    }

    return pixelsSingleState;
  };

  return HeatmapLayer;
}();

/* harmony default export */ __webpack_exports__["a"] = (HeatmapLayer);

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_Series_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_createSeriesData_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_CoordinateSystem_js__ = __webpack_require__(194);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var HeatmapSeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(HeatmapSeriesModel, _super);

  function HeatmapSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = HeatmapSeriesModel.type;
    return _this;
  }

  HeatmapSeriesModel.prototype.getInitialData = function (option, ecModel) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_createSeriesData_js__["a" /* default */])(null, this, {
      generateCoord: 'value'
    });
  };

  HeatmapSeriesModel.prototype.preventIncremental = function () {
    var coordSysCreator = __WEBPACK_IMPORTED_MODULE_3__core_CoordinateSystem_js__["a" /* default */].get(this.get('coordinateSystem'));

    if (coordSysCreator && coordSysCreator.dimensions) {
      return coordSysCreator.dimensions[0] === 'lng' && coordSysCreator.dimensions[1] === 'lat';
    }
  };

  HeatmapSeriesModel.type = 'series.heatmap';
  HeatmapSeriesModel.dependencies = ['grid', 'geo', 'calendar'];
  HeatmapSeriesModel.defaultOption = {
    coordinateSystem: 'cartesian2d',
    // zlevel: 0,
    z: 2,
    // Cartesian coordinate system
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // Geo coordinate system
    geoIndex: 0,
    blurSize: 30,
    pointSize: 20,
    maxOpacity: 1,
    minOpacity: 0,
    select: {
      itemStyle: {
        borderColor: '#212121'
      }
    }
  };
  return HeatmapSeriesModel;
}(__WEBPACK_IMPORTED_MODULE_1__model_Series_js__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (HeatmapSeriesModel);

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeatmapLayer_js__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__coord_CoordinateSystem_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__ = __webpack_require__(15);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/









function getIsInPiecewiseRange(dataExtent, pieceList, selected) {
  var dataSpan = dataExtent[1] - dataExtent[0];
  pieceList = __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["map"](pieceList, function (piece) {
    return {
      interval: [(piece.interval[0] - dataExtent[0]) / dataSpan, (piece.interval[1] - dataExtent[0]) / dataSpan]
    };
  });
  var len = pieceList.length;
  var lastIndex = 0;
  return function (val) {
    var i; // Try to find in the location of the last found

    for (i = lastIndex; i < len; i++) {
      var interval = pieceList[i].interval;

      if (interval[0] <= val && val <= interval[1]) {
        lastIndex = i;
        break;
      }
    }

    if (i === len) {
      // Not found, back interation
      for (i = lastIndex - 1; i >= 0; i--) {
        var interval = pieceList[i].interval;

        if (interval[0] <= val && val <= interval[1]) {
          lastIndex = i;
          break;
        }
      }
    }

    return i >= 0 && i < len && selected[i];
  };
}

function getIsInContinuousRange(dataExtent, range) {
  var dataSpan = dataExtent[1] - dataExtent[0];
  range = [(range[0] - dataExtent[0]) / dataSpan, (range[1] - dataExtent[0]) / dataSpan];
  return function (val) {
    return val >= range[0] && val <= range[1];
  };
}

function isGeoCoordSys(coordSys) {
  var dimensions = coordSys.dimensions; // Not use coorSys.type === 'geo' because coordSys maybe extended

  return dimensions[0] === 'lng' && dimensions[1] === 'lat';
}

var HeatmapView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(HeatmapView, _super);

  function HeatmapView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = HeatmapView.type;
    return _this;
  }

  HeatmapView.prototype.render = function (seriesModel, ecModel, api) {
    var visualMapOfThisSeries;
    ecModel.eachComponent('visualMap', function (visualMap) {
      visualMap.eachTargetSeries(function (targetSeries) {
        if (targetSeries === seriesModel) {
          visualMapOfThisSeries = visualMap;
        }
      });
    });

    if (true) {
      if (!visualMapOfThisSeries) {
        throw new Error('Heatmap must use with visualMap');
      }
    } // Clear previously rendered progressive elements.


    this._progressiveEls = null;
    this.group.removeAll();
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys.type === 'cartesian2d' || coordSys.type === 'calendar') {
      this._renderOnCartesianAndCalendar(seriesModel, api, 0, seriesModel.getData().count());
    } else if (isGeoCoordSys(coordSys)) {
      this._renderOnGeo(coordSys, seriesModel, visualMapOfThisSeries, api);
    }
  };

  HeatmapView.prototype.incrementalPrepareRender = function (seriesModel, ecModel, api) {
    this.group.removeAll();
  };

  HeatmapView.prototype.incrementalRender = function (params, seriesModel, ecModel, api) {
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys) {
      // geo does not support incremental rendering?
      if (isGeoCoordSys(coordSys)) {
        this.render(seriesModel, ecModel, api);
      } else {
        this._progressiveEls = [];

        this._renderOnCartesianAndCalendar(seriesModel, api, params.start, params.end, true);
      }
    }
  };

  HeatmapView.prototype.eachRendered = function (cb) {
    __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["traverseElements"](this._progressiveEls || this.group, cb);
  };

  HeatmapView.prototype._renderOnCartesianAndCalendar = function (seriesModel, api, start, end, incremental) {
    var coordSys = seriesModel.coordinateSystem;
    var isCartesian2d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__coord_CoordinateSystem_js__["a" /* isCoordinateSystemType */])(coordSys, 'cartesian2d');
    var width;
    var height;
    var xAxisExtent;
    var yAxisExtent;

    if (isCartesian2d) {
      var xAxis = coordSys.getAxis('x');
      var yAxis = coordSys.getAxis('y');

      if (true) {
        if (!(xAxis.type === 'category' && yAxis.type === 'category')) {
          throw new Error('Heatmap on cartesian must have two category axes');
        }

        if (!(xAxis.onBand && yAxis.onBand)) {
          throw new Error('Heatmap on cartesian must have two axes with boundaryGap true');
        }
      } // add 0.5px to avoid the gaps


      width = xAxis.getBandWidth() + .5;
      height = yAxis.getBandWidth() + .5;
      xAxisExtent = xAxis.scale.getExtent();
      yAxisExtent = yAxis.scale.getExtent();
    }

    var group = this.group;
    var data = seriesModel.getData();
    var emphasisStyle = seriesModel.getModel(['emphasis', 'itemStyle']).getItemStyle();
    var blurStyle = seriesModel.getModel(['blur', 'itemStyle']).getItemStyle();
    var selectStyle = seriesModel.getModel(['select', 'itemStyle']).getItemStyle();
    var borderRadius = seriesModel.get(['itemStyle', 'borderRadius']);
    var labelStatesModels = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__["f" /* getLabelStatesModels */])(seriesModel);
    var emphasisModel = seriesModel.getModel('emphasis');
    var focus = emphasisModel.get('focus');
    var blurScope = emphasisModel.get('blurScope');
    var emphasisDisabled = emphasisModel.get('disabled');
    var dataDims = isCartesian2d ? [data.mapDimension('x'), data.mapDimension('y'), data.mapDimension('value')] : [data.mapDimension('time'), data.mapDimension('value')];

    for (var idx = start; idx < end; idx++) {
      var rect = void 0;
      var style = data.getItemVisual(idx, 'style');

      if (isCartesian2d) {
        var dataDimX = data.get(dataDims[0], idx);
        var dataDimY = data.get(dataDims[1], idx); // Ignore empty data and out of extent data

        if (isNaN(data.get(dataDims[2], idx)) || dataDimX < xAxisExtent[0] || dataDimX > xAxisExtent[1] || dataDimY < yAxisExtent[0] || dataDimY > yAxisExtent[1]) {
          continue;
        }

        var point = coordSys.dataToPoint([dataDimX, dataDimY]);
        rect = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Rect"]({
          shape: {
            x: point[0] - width / 2,
            y: point[1] - height / 2,
            width: width,
            height: height
          },
          style: style
        });
      } else {
        // Ignore empty data
        if (isNaN(data.get(dataDims[1], idx))) {
          continue;
        }

        rect = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Rect"]({
          z2: 1,
          shape: coordSys.dataToRect([data.get(dataDims[0], idx)]).contentShape,
          style: style
        });
      } // Optimization for large datset


      if (data.hasItemOption) {
        var itemModel = data.getItemModel(idx);
        var emphasisModel_1 = itemModel.getModel('emphasis');
        emphasisStyle = emphasisModel_1.getModel('itemStyle').getItemStyle();
        blurStyle = itemModel.getModel(['blur', 'itemStyle']).getItemStyle();
        selectStyle = itemModel.getModel(['select', 'itemStyle']).getItemStyle(); // Each item value struct in the data would be firstly
        // {
        //     itemStyle: { borderRadius: [30, 30] },
        //     value: [2022, 02, 22]
        // }

        borderRadius = itemModel.get(['itemStyle', 'borderRadius']);
        focus = emphasisModel_1.get('focus');
        blurScope = emphasisModel_1.get('blurScope');
        emphasisDisabled = emphasisModel_1.get('disabled');
        labelStatesModels = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__["f" /* getLabelStatesModels */])(itemModel);
      }

      rect.shape.r = borderRadius;
      var rawValue = seriesModel.getRawValue(idx);
      var defaultText = '-';

      if (rawValue && rawValue[2] != null) {
        defaultText = rawValue[2] + '';
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__["e" /* setLabelStyle */])(rect, labelStatesModels, {
        labelFetcher: seriesModel,
        labelDataIndex: idx,
        defaultOpacity: style.opacity,
        defaultText: defaultText
      });
      rect.ensureState('emphasis').style = emphasisStyle;
      rect.ensureState('blur').style = blurStyle;
      rect.ensureState('select').style = selectStyle;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_states_js__["G" /* toggleHoverEmphasis */])(rect, focus, blurScope, emphasisDisabled);
      rect.incremental = incremental; // PENDING

      if (incremental) {
        // Rect must use hover layer if it's incremental.
        rect.states.emphasis.hoverLayer = true;
      }

      group.add(rect);
      data.setItemGraphicEl(idx, rect);

      if (this._progressiveEls) {
        this._progressiveEls.push(rect);
      }
    }
  };

  HeatmapView.prototype._renderOnGeo = function (geo, seriesModel, visualMapModel, api) {
    var inRangeVisuals = visualMapModel.targetVisuals.inRange;
    var outOfRangeVisuals = visualMapModel.targetVisuals.outOfRange; // if (!visualMapping) {
    //     throw new Error('Data range must have color visuals');
    // }

    var data = seriesModel.getData();
    var hmLayer = this._hmLayer || this._hmLayer || new __WEBPACK_IMPORTED_MODULE_3__HeatmapLayer_js__["a" /* default */]();
    hmLayer.blurSize = seriesModel.get('blurSize');
    hmLayer.pointSize = seriesModel.get('pointSize');
    hmLayer.minOpacity = seriesModel.get('minOpacity');
    hmLayer.maxOpacity = seriesModel.get('maxOpacity');
    var rect = geo.getViewRect().clone();
    var roamTransform = geo.getRoamTransform();
    rect.applyTransform(roamTransform); // Clamp on viewport

    var x = Math.max(rect.x, 0);
    var y = Math.max(rect.y, 0);
    var x2 = Math.min(rect.width + rect.x, api.getWidth());
    var y2 = Math.min(rect.height + rect.y, api.getHeight());
    var width = x2 - x;
    var height = y2 - y;
    var dims = [data.mapDimension('lng'), data.mapDimension('lat'), data.mapDimension('value')];
    var points = data.mapArray(dims, function (lng, lat, value) {
      var pt = geo.dataToPoint([lng, lat]);
      pt[0] -= x;
      pt[1] -= y;
      pt.push(value);
      return pt;
    });
    var dataExtent = visualMapModel.getExtent();
    var isInRange = visualMapModel.type === 'visualMap.continuous' ? getIsInContinuousRange(dataExtent, visualMapModel.option.range) : getIsInPiecewiseRange(dataExtent, visualMapModel.getPieceList(), visualMapModel.option.selected);
    hmLayer.update(points, width, height, inRangeVisuals.color.getNormalizer(), {
      inRange: inRangeVisuals.color.getColorMapper(),
      outOfRange: outOfRangeVisuals.color.getColorMapper()
    }, isInRange);
    var img = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Image"]({
      style: {
        width: width,
        height: height,
        x: x,
        y: y,
        image: hmLayer.canvas
      },
      silent: true
    });
    this.group.add(img);
  };

  HeatmapView.type = 'heatmap';
  return HeatmapView;
}(__WEBPACK_IMPORTED_MODULE_5__view_Chart_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (HeatmapView);

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeatmapView_js__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HeatmapSeries_js__ = __webpack_require__(1128);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


function install(registers) {
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_0__HeatmapView_js__["a" /* default */]);
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_1__HeatmapSeries_js__["a" /* default */]);
}

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Polyline_js__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EffectLine_js__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_vector_js__ = __webpack_require__(23);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var EffectPolyline =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(EffectPolyline, _super);

  function EffectPolyline() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this._lastFrame = 0;
    _this._lastFramePercent = 0;
    return _this;
  } // Override


  EffectPolyline.prototype.createLine = function (lineData, idx, seriesScope) {
    return new __WEBPACK_IMPORTED_MODULE_1__Polyline_js__["a" /* default */](lineData, idx, seriesScope);
  };

  ; // Override

  EffectPolyline.prototype._updateAnimationPoints = function (symbol, points) {
    this._points = points;
    var accLenArr = [0];
    var len = 0;

    for (var i = 1; i < points.length; i++) {
      var p1 = points[i - 1];
      var p2 = points[i];
      len += __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_vector_js__["dist"](p1, p2);
      accLenArr.push(len);
    }

    if (len === 0) {
      this._length = 0;
      return;
    }

    for (var i = 0; i < accLenArr.length; i++) {
      accLenArr[i] /= len;
    }

    this._offsets = accLenArr;
    this._length = len;
  };

  ; // Override

  EffectPolyline.prototype._getLineLength = function () {
    return this._length;
  };

  ; // Override

  EffectPolyline.prototype._updateSymbolPosition = function (symbol) {
    var t = symbol.__t;
    var points = this._points;
    var offsets = this._offsets;
    var len = points.length;

    if (!offsets) {
      // Has length 0
      return;
    }

    var lastFrame = this._lastFrame;
    var frame;

    if (t < this._lastFramePercent) {
      // Start from the next frame
      // PENDING start from lastFrame ?
      var start = Math.min(lastFrame + 1, len - 1);

      for (frame = start; frame >= 0; frame--) {
        if (offsets[frame] <= t) {
          break;
        }
      } // PENDING really need to do this ?


      frame = Math.min(frame, len - 2);
    } else {
      for (frame = lastFrame; frame < len; frame++) {
        if (offsets[frame] > t) {
          break;
        }
      }

      frame = Math.min(frame - 1, len - 2);
    }

    var p = (t - offsets[frame]) / (offsets[frame + 1] - offsets[frame]);
    var p0 = points[frame];
    var p1 = points[frame + 1];
    symbol.x = p0[0] * (1 - p) + p * p1[0];
    symbol.y = p0[1] * (1 - p) + p * p1[1];
    var tx = p1[0] - p0[0];
    var ty = p1[1] - p0[1];
    symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
    this._lastFrame = frame;
    this._lastFramePercent = t;
    symbol.ignore = false;
  };

  ;
  return EffectPolyline;
}(__WEBPACK_IMPORTED_MODULE_2__EffectLine_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (EffectPolyline);

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_symbol_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Symbol_js__ = __webpack_require__(228);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






function updateRipplePath(rippleGroup, effectCfg) {
  var color = effectCfg.rippleEffectColor || effectCfg.color;
  rippleGroup.eachChild(function (ripplePath) {
    ripplePath.attr({
      z: effectCfg.z,
      zlevel: effectCfg.zlevel,
      style: {
        stroke: effectCfg.brushType === 'stroke' ? color : null,
        fill: effectCfg.brushType === 'fill' ? color : null
      }
    });
  });
}

var EffectSymbol =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(EffectSymbol, _super);

  function EffectSymbol(data, idx) {
    var _this = _super.call(this) || this;

    var symbol = new __WEBPACK_IMPORTED_MODULE_4__Symbol_js__["a" /* default */](data, idx);
    var rippleGroup = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Group"]();

    _this.add(symbol);

    _this.add(rippleGroup);

    _this.updateData(data, idx);

    return _this;
  }

  EffectSymbol.prototype.stopEffectAnimation = function () {
    this.childAt(1).removeAll();
  };

  EffectSymbol.prototype.startEffectAnimation = function (effectCfg) {
    var symbolType = effectCfg.symbolType;
    var color = effectCfg.color;
    var rippleNumber = effectCfg.rippleNumber;
    var rippleGroup = this.childAt(1);

    for (var i = 0; i < rippleNumber; i++) {
      // If width/height are set too small (e.g., set to 1) on ios10
      // and macOS Sierra, a circle stroke become a rect, no matter what
      // the scale is set. So we set width/height as 2. See #4136.
      var ripplePath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_symbol_js__["a" /* createSymbol */])(symbolType, -1, -1, 2, 2, color);
      ripplePath.attr({
        style: {
          strokeNoScale: true
        },
        z2: 99,
        silent: true,
        scaleX: 0.5,
        scaleY: 0.5
      });
      var delay = -i / rippleNumber * effectCfg.period + effectCfg.effectOffset;
      ripplePath.animate('', true).when(effectCfg.period, {
        scaleX: effectCfg.rippleScale / 2,
        scaleY: effectCfg.rippleScale / 2
      }).delay(delay).start();
      ripplePath.animateStyle(true).when(effectCfg.period, {
        opacity: 0
      }).delay(delay).start();
      rippleGroup.add(ripplePath);
    }

    updateRipplePath(rippleGroup, effectCfg);
  };
  /**
   * Update effect symbol
   */


  EffectSymbol.prototype.updateEffectAnimation = function (effectCfg) {
    var oldEffectCfg = this._effectCfg;
    var rippleGroup = this.childAt(1); // Must reinitialize effect if following configuration changed

    var DIFFICULT_PROPS = ['symbolType', 'period', 'rippleScale', 'rippleNumber'];

    for (var i = 0; i < DIFFICULT_PROPS.length; i++) {
      var propName = DIFFICULT_PROPS[i];

      if (oldEffectCfg[propName] !== effectCfg[propName]) {
        this.stopEffectAnimation();
        this.startEffectAnimation(effectCfg);
        return;
      }
    }

    updateRipplePath(rippleGroup, effectCfg);
  };
  /**
   * Highlight symbol
   */


  EffectSymbol.prototype.highlight = function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_states_js__["j" /* enterEmphasis */])(this);
  };
  /**
   * Downplay symbol
   */


  EffectSymbol.prototype.downplay = function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_states_js__["k" /* leaveEmphasis */])(this);
  };

  EffectSymbol.prototype.getSymbolType = function () {
    var symbol = this.childAt(0);
    return symbol && symbol.getSymbolType();
  };
  /**
   * Update symbol properties
   */


  EffectSymbol.prototype.updateData = function (data, idx) {
    var _this = this;

    var seriesModel = data.hostModel;
    this.childAt(0).updateData(data, idx);
    var rippleGroup = this.childAt(1);
    var itemModel = data.getItemModel(idx);
    var symbolType = data.getItemVisual(idx, 'symbol');
    var symbolSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_symbol_js__["c" /* normalizeSymbolSize */])(data.getItemVisual(idx, 'symbolSize'));
    var symbolStyle = data.getItemVisual(idx, 'style');
    var color = symbolStyle && symbolStyle.fill;
    var emphasisModel = itemModel.getModel('emphasis');
    rippleGroup.setScale(symbolSize);
    rippleGroup.traverse(function (ripplePath) {
      ripplePath.setStyle('fill', color);
    });
    var symbolOffset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_symbol_js__["d" /* normalizeSymbolOffset */])(data.getItemVisual(idx, 'symbolOffset'), symbolSize);

    if (symbolOffset) {
      rippleGroup.x = symbolOffset[0];
      rippleGroup.y = symbolOffset[1];
    }

    var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
    rippleGroup.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
    var effectCfg = {};
    effectCfg.showEffectOn = seriesModel.get('showEffectOn');
    effectCfg.rippleScale = itemModel.get(['rippleEffect', 'scale']);
    effectCfg.brushType = itemModel.get(['rippleEffect', 'brushType']);
    effectCfg.period = itemModel.get(['rippleEffect', 'period']) * 1000;
    effectCfg.effectOffset = idx / data.count();
    effectCfg.z = seriesModel.getShallow('z') || 0;
    effectCfg.zlevel = seriesModel.getShallow('zlevel') || 0;
    effectCfg.symbolType = symbolType;
    effectCfg.color = color;
    effectCfg.rippleEffectColor = itemModel.get(['rippleEffect', 'color']);
    effectCfg.rippleNumber = itemModel.get(['rippleEffect', 'number']);

    if (effectCfg.showEffectOn === 'render') {
      this._effectCfg ? this.updateEffectAnimation(effectCfg) : this.startEffectAnimation(effectCfg);
      this._effectCfg = effectCfg;
    } else {
      // Not keep old effect config
      this._effectCfg = null;
      this.stopEffectAnimation();

      this.onHoverStateChange = function (toState) {
        if (toState === 'emphasis') {
          if (effectCfg.showEffectOn !== 'render') {
            _this.startEffectAnimation(effectCfg);
          }
        } else if (toState === 'normal') {
          if (effectCfg.showEffectOn !== 'render') {
            _this.stopEffectAnimation();
          }
        }
      };
    }

    this._effectCfg = effectCfg;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_states_js__["G" /* toggleHoverEmphasis */])(this, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
  };

  ;

  EffectSymbol.prototype.fadeOut = function (cb) {
    cb && cb();
  };

  ;
  return EffectSymbol;
}(__WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Group"]);

/* harmony default export */ __webpack_exports__["a"] = (EffectSymbol);

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_contain_line_js__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_contain_quadratic_js__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_innerStore_js__ = __webpack_require__(17);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
 // TODO Batch by color






var LargeLinesPathShape =
/** @class */
function () {
  function LargeLinesPathShape() {
    this.polyline = false;
    this.curveness = 0;
    this.segs = [];
  }

  return LargeLinesPathShape;
}();

var LargeLinesPath =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(LargeLinesPath, _super);

  function LargeLinesPath(opts) {
    var _this = _super.call(this, opts) || this;

    _this._off = 0;
    _this.hoverDataIdx = -1;
    return _this;
  }

  LargeLinesPath.prototype.reset = function () {
    this.notClear = false;
    this._off = 0;
  };

  LargeLinesPath.prototype.getDefaultStyle = function () {
    return {
      stroke: '#000',
      fill: null
    };
  };

  LargeLinesPath.prototype.getDefaultShape = function () {
    return new LargeLinesPathShape();
  };

  LargeLinesPath.prototype.buildPath = function (ctx, shape) {
    var segs = shape.segs;
    var curveness = shape.curveness;
    var i;

    if (shape.polyline) {
      for (i = this._off; i < segs.length;) {
        var count = segs[i++];

        if (count > 0) {
          ctx.moveTo(segs[i++], segs[i++]);

          for (var k = 1; k < count; k++) {
            ctx.lineTo(segs[i++], segs[i++]);
          }
        }
      }
    } else {
      for (i = this._off; i < segs.length;) {
        var x0 = segs[i++];
        var y0 = segs[i++];
        var x1 = segs[i++];
        var y1 = segs[i++];
        ctx.moveTo(x0, y0);

        if (curveness > 0) {
          var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
          var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
          ctx.quadraticCurveTo(x2, y2, x1, y1);
        } else {
          ctx.lineTo(x1, y1);
        }
      }
    }

    if (this.incremental) {
      this._off = i;
      this.notClear = true;
    }
  };

  LargeLinesPath.prototype.findDataIndex = function (x, y) {
    var shape = this.shape;
    var segs = shape.segs;
    var curveness = shape.curveness;
    var lineWidth = this.style.lineWidth;

    if (shape.polyline) {
      var dataIndex = 0;

      for (var i = 0; i < segs.length;) {
        var count = segs[i++];

        if (count > 0) {
          var x0 = segs[i++];
          var y0 = segs[i++];

          for (var k = 1; k < count; k++) {
            var x1 = segs[i++];
            var y1 = segs[i++];

            if (__WEBPACK_IMPORTED_MODULE_2_zrender_lib_contain_line_js__["a" /* containStroke */](x0, y0, x1, y1, lineWidth, x, y)) {
              return dataIndex;
            }
          }
        }

        dataIndex++;
      }
    } else {
      var dataIndex = 0;

      for (var i = 0; i < segs.length;) {
        var x0 = segs[i++];
        var y0 = segs[i++];
        var x1 = segs[i++];
        var y1 = segs[i++];

        if (curveness > 0) {
          var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
          var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;

          if (__WEBPACK_IMPORTED_MODULE_3_zrender_lib_contain_quadratic_js__["a" /* containStroke */](x0, y0, x2, y2, x1, y1, lineWidth, x, y)) {
            return dataIndex;
          }
        } else {
          if (__WEBPACK_IMPORTED_MODULE_2_zrender_lib_contain_line_js__["a" /* containStroke */](x0, y0, x1, y1, lineWidth, x, y)) {
            return dataIndex;
          }
        }

        dataIndex++;
      }
    }

    return -1;
  };

  LargeLinesPath.prototype.contain = function (x, y) {
    var localPos = this.transformCoordToLocal(x, y);
    var rect = this.getBoundingRect();
    x = localPos[0];
    y = localPos[1];

    if (rect.contain(x, y)) {
      // Cache found data index.
      var dataIdx = this.hoverDataIdx = this.findDataIndex(x, y);
      return dataIdx >= 0;
    }

    this.hoverDataIdx = -1;
    return false;
  };

  LargeLinesPath.prototype.getBoundingRect = function () {
    // Ignore stroke for large symbol draw.
    var rect = this._rect;

    if (!rect) {
      var shape = this.shape;
      var points = shape.segs;
      var minX = Infinity;
      var minY = Infinity;
      var maxX = -Infinity;
      var maxY = -Infinity;

      for (var i = 0; i < points.length;) {
        var x = points[i++];
        var y = points[i++];
        minX = Math.min(x, minX);
        maxX = Math.max(x, maxX);
        minY = Math.min(y, minY);
        maxY = Math.max(y, maxY);
      }

      rect = this._rect = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["BoundingRect"](minX, minY, maxX, maxY);
    }

    return rect;
  };

  return LargeLinesPath;
}(__WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Path"]);

var LargeLineDraw =
/** @class */
function () {
  function LargeLineDraw() {
    this.group = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Group"]();
  }
  /**
   * Update symbols draw by new data
   */


  LargeLineDraw.prototype.updateData = function (data) {
    this._clear();

    var lineEl = this._create();

    lineEl.setShape({
      segs: data.getLayout('linesPoints')
    });

    this._setCommon(lineEl, data);
  };

  ;
  /**
   * @override
   */

  LargeLineDraw.prototype.incrementalPrepareUpdate = function (data) {
    this.group.removeAll();

    this._clear();
  };

  ;
  /**
   * @override
   */

  LargeLineDraw.prototype.incrementalUpdate = function (taskParams, data) {
    var lastAdded = this._newAdded[0];
    var linePoints = data.getLayout('linesPoints');
    var oldSegs = lastAdded && lastAdded.shape.segs; // Merging the exists. Each element has 1e4 points.
    // Consider the performance balance between too much elements and too much points in one shape(may affect hover optimization)

    if (oldSegs && oldSegs.length < 2e4) {
      var oldLen = oldSegs.length;
      var newSegs = new Float32Array(oldLen + linePoints.length); // Concat two array

      newSegs.set(oldSegs);
      newSegs.set(linePoints, oldLen);
      lastAdded.setShape({
        segs: newSegs
      });
    } else {
      // Clear
      this._newAdded = [];

      var lineEl = this._create();

      lineEl.incremental = true;
      lineEl.setShape({
        segs: linePoints
      });

      this._setCommon(lineEl, data);

      lineEl.__startIndex = taskParams.start;
    }
  };
  /**
   * @override
   */


  LargeLineDraw.prototype.remove = function () {
    this._clear();
  };

  LargeLineDraw.prototype.eachRendered = function (cb) {
    this._newAdded[0] && cb(this._newAdded[0]);
  };

  LargeLineDraw.prototype._create = function () {
    var lineEl = new LargeLinesPath({
      cursor: 'default'
    });

    this._newAdded.push(lineEl);

    this.group.add(lineEl);
    return lineEl;
  };

  LargeLineDraw.prototype._setCommon = function (lineEl, data, isIncremental) {
    var hostModel = data.hostModel;
    lineEl.setShape({
      polyline: hostModel.get('polyline'),
      curveness: hostModel.get(['lineStyle', 'curveness'])
    });
    lineEl.useStyle(hostModel.getModel('lineStyle').getLineStyle());
    lineEl.style.strokeNoScale = true;
    var style = data.getVisual('style');

    if (style && style.stroke) {
      lineEl.setStyle('stroke', style.stroke);
    }

    lineEl.setStyle('fill', null);
    var ecData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_innerStore_js__["a" /* getECData */])(lineEl); // Enable tooltip
    // PENDING May have performance issue when path is extremely large

    ecData.seriesIndex = hostModel.seriesIndex;
    lineEl.on('mousemove', function (e) {
      ecData.dataIndex = null;
      var dataIndex = lineEl.hoverDataIdx;

      if (dataIndex > 0) {
        // Provide dataIndex for tooltip
        ecData.dataIndex = dataIndex + lineEl.__startIndex;
      }
    });
  };

  ;

  LargeLineDraw.prototype._clear = function () {
    this._newAdded = [];
    this.group.removeAll();
  };

  ;
  return LargeLineDraw;
}();

/* harmony default export */ __webpack_exports__["a"] = (LargeLineDraw);

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_symbol_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_innerStore_js__ = __webpack_require__(17);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/* global Float32Array */
// TODO Batch by color




var BOOST_SIZE_THRESHOLD = 4;

var LargeSymbolPathShape =
/** @class */
function () {
  function LargeSymbolPathShape() {}

  return LargeSymbolPathShape;
}();

var LargeSymbolPath =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(LargeSymbolPath, _super);

  function LargeSymbolPath(opts) {
    var _this = _super.call(this, opts) || this;

    _this._off = 0;
    _this.hoverDataIdx = -1;
    return _this;
  }

  LargeSymbolPath.prototype.getDefaultShape = function () {
    return new LargeSymbolPathShape();
  };

  LargeSymbolPath.prototype.reset = function () {
    this.notClear = false;
    this._off = 0;
  };

  LargeSymbolPath.prototype.buildPath = function (path, shape) {
    var points = shape.points;
    var size = shape.size;
    var symbolProxy = this.symbolProxy;
    var symbolProxyShape = symbolProxy.shape;
    var ctx = path.getContext ? path.getContext() : path;
    var canBoost = ctx && size[0] < BOOST_SIZE_THRESHOLD;
    var softClipShape = this.softClipShape;
    var i; // Do draw in afterBrush.

    if (canBoost) {
      this._ctx = ctx;
      return;
    }

    this._ctx = null;

    for (i = this._off; i < points.length;) {
      var x = points[i++];
      var y = points[i++];

      if (isNaN(x) || isNaN(y)) {
        continue;
      }

      if (softClipShape && !softClipShape.contain(x, y)) {
        continue;
      }

      symbolProxyShape.x = x - size[0] / 2;
      symbolProxyShape.y = y - size[1] / 2;
      symbolProxyShape.width = size[0];
      symbolProxyShape.height = size[1];
      symbolProxy.buildPath(path, symbolProxyShape, true);
    }

    if (this.incremental) {
      this._off = i;
      this.notClear = true;
    }
  };

  LargeSymbolPath.prototype.afterBrush = function () {
    var shape = this.shape;
    var points = shape.points;
    var size = shape.size;
    var ctx = this._ctx;
    var softClipShape = this.softClipShape;
    var i;

    if (!ctx) {
      return;
    } // PENDING If style or other canvas status changed?


    for (i = this._off; i < points.length;) {
      var x = points[i++];
      var y = points[i++];

      if (isNaN(x) || isNaN(y)) {
        continue;
      }

      if (softClipShape && !softClipShape.contain(x, y)) {
        continue;
      } // fillRect is faster than building a rect path and draw.
      // And it support light globalCompositeOperation.


      ctx.fillRect(x - size[0] / 2, y - size[1] / 2, size[0], size[1]);
    }

    if (this.incremental) {
      this._off = i;
      this.notClear = true;
    }
  };

  LargeSymbolPath.prototype.findDataIndex = function (x, y) {
    // TODO ???
    // Consider transform
    var shape = this.shape;
    var points = shape.points;
    var size = shape.size;
    var w = Math.max(size[0], 4);
    var h = Math.max(size[1], 4); // Not consider transform
    // Treat each element as a rect
    // top down traverse

    for (var idx = points.length / 2 - 1; idx >= 0; idx--) {
      var i = idx * 2;
      var x0 = points[i] - w / 2;
      var y0 = points[i + 1] - h / 2;

      if (x >= x0 && y >= y0 && x <= x0 + w && y <= y0 + h) {
        return idx;
      }
    }

    return -1;
  };

  LargeSymbolPath.prototype.contain = function (x, y) {
    var localPos = this.transformCoordToLocal(x, y);
    var rect = this.getBoundingRect();
    x = localPos[0];
    y = localPos[1];

    if (rect.contain(x, y)) {
      // Cache found data index.
      var dataIdx = this.hoverDataIdx = this.findDataIndex(x, y);
      return dataIdx >= 0;
    }

    this.hoverDataIdx = -1;
    return false;
  };

  LargeSymbolPath.prototype.getBoundingRect = function () {
    // Ignore stroke for large symbol draw.
    var rect = this._rect;

    if (!rect) {
      var shape = this.shape;
      var points = shape.points;
      var size = shape.size;
      var w = size[0];
      var h = size[1];
      var minX = Infinity;
      var minY = Infinity;
      var maxX = -Infinity;
      var maxY = -Infinity;

      for (var i = 0; i < points.length;) {
        var x = points[i++];
        var y = points[i++];
        minX = Math.min(x, minX);
        maxX = Math.max(x, maxX);
        minY = Math.min(y, minY);
        maxY = Math.max(y, maxY);
      }

      rect = this._rect = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["BoundingRect"](minX - w / 2, minY - h / 2, maxX - minX + w, maxY - minY + h);
    }

    return rect;
  };

  return LargeSymbolPath;
}(__WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Path"]);

var LargeSymbolDraw =
/** @class */
function () {
  function LargeSymbolDraw() {
    this.group = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Group"]();
  }
  /**
   * Update symbols draw by new data
   */


  LargeSymbolDraw.prototype.updateData = function (data, opt) {
    this._clear();

    var symbolEl = this._create();

    symbolEl.setShape({
      points: data.getLayout('points')
    });

    this._setCommon(symbolEl, data, opt);
  };

  LargeSymbolDraw.prototype.updateLayout = function (data) {
    var points = data.getLayout('points');
    this.group.eachChild(function (child) {
      if (child.startIndex != null) {
        var len = (child.endIndex - child.startIndex) * 2;
        var byteOffset = child.startIndex * 4 * 2;
        points = new Float32Array(points.buffer, byteOffset, len);
      }

      child.setShape('points', points); // Reset draw cursor.

      child.reset();
    });
  };

  LargeSymbolDraw.prototype.incrementalPrepareUpdate = function (data) {
    this._clear();
  };

  LargeSymbolDraw.prototype.incrementalUpdate = function (taskParams, data, opt) {
    var lastAdded = this._newAdded[0];
    var points = data.getLayout('points');
    var oldPoints = lastAdded && lastAdded.shape.points; // Merging the exists. Each element has 1e4 points.
    // Consider the performance balance between too much elements and too much points in one shape(may affect hover optimization)

    if (oldPoints && oldPoints.length < 2e4) {
      var oldLen = oldPoints.length;
      var newPoints = new Float32Array(oldLen + points.length); // Concat two array

      newPoints.set(oldPoints);
      newPoints.set(points, oldLen); // Update endIndex

      lastAdded.endIndex = taskParams.end;
      lastAdded.setShape({
        points: newPoints
      });
    } else {
      // Clear
      this._newAdded = [];

      var symbolEl = this._create();

      symbolEl.startIndex = taskParams.start;
      symbolEl.endIndex = taskParams.end;
      symbolEl.incremental = true;
      symbolEl.setShape({
        points: points
      });

      this._setCommon(symbolEl, data, opt);
    }
  };

  LargeSymbolDraw.prototype.eachRendered = function (cb) {
    this._newAdded[0] && cb(this._newAdded[0]);
  };

  LargeSymbolDraw.prototype._create = function () {
    var symbolEl = new LargeSymbolPath({
      cursor: 'default'
    });
    this.group.add(symbolEl);

    this._newAdded.push(symbolEl);

    return symbolEl;
  };

  LargeSymbolDraw.prototype._setCommon = function (symbolEl, data, opt) {
    var hostModel = data.hostModel;
    opt = opt || {};
    var size = data.getVisual('symbolSize');
    symbolEl.setShape('size', size instanceof Array ? size : [size, size]);
    symbolEl.softClipShape = opt.clipShape || null; // Create symbolProxy to build path for each data

    symbolEl.symbolProxy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_symbol_js__["a" /* createSymbol */])(data.getVisual('symbol'), 0, 0, 0, 0); // Use symbolProxy setColor method

    symbolEl.setColor = symbolEl.symbolProxy.setColor;
    var extrudeShadow = symbolEl.shape.size[0] < BOOST_SIZE_THRESHOLD;
    symbolEl.useStyle( // Draw shadow when doing fillRect is extremely slow.
    hostModel.getModel('itemStyle').getItemStyle(extrudeShadow ? ['color', 'shadowBlur', 'shadowColor'] : ['color']));
    var globalStyle = data.getVisual('style');
    var visualColor = globalStyle && globalStyle.fill;

    if (visualColor) {
      symbolEl.setColor(visualColor);
    }

    var ecData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_innerStore_js__["a" /* getECData */])(symbolEl); // Enable tooltip
    // PENDING May have performance issue when path is extremely large

    ecData.seriesIndex = hostModel.seriesIndex;
    symbolEl.on('mousemove', function (e) {
      ecData.dataIndex = null;
      var dataIndex = symbolEl.hoverDataIdx;

      if (dataIndex >= 0) {
        // Provide dataIndex for tooltip
        ecData.dataIndex = dataIndex + (symbolEl.startIndex || 0);
      }
    });
  };

  LargeSymbolDraw.prototype.remove = function () {
    this._clear();
  };

  LargeSymbolDraw.prototype._clear = function () {
    this._newAdded = [];
    this.group.removeAll();
  };

  return LargeSymbolDraw;
}();

/* harmony default export */ __webpack_exports__["a"] = (LargeSymbolDraw);

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_vector_js__ = __webpack_require__(23);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Line path for bezier and straight line draw
 */



var straightLineProto = __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Line"].prototype;
var bezierCurveProto = __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["BezierCurve"].prototype;

var StraightLineShape =
/** @class */
function () {
  function StraightLineShape() {
    // Start point
    this.x1 = 0;
    this.y1 = 0; // End point

    this.x2 = 0;
    this.y2 = 0;
    this.percent = 1;
  }

  return StraightLineShape;
}();

var CurveShape =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(CurveShape, _super);

  function CurveShape() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return CurveShape;
}(StraightLineShape);

function isStraightLine(shape) {
  return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
}

var ECLinePath =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ECLinePath, _super);

  function ECLinePath(opts) {
    var _this = _super.call(this, opts) || this;

    _this.type = 'ec-line';
    return _this;
  }

  ECLinePath.prototype.getDefaultStyle = function () {
    return {
      stroke: '#000',
      fill: null
    };
  };

  ECLinePath.prototype.getDefaultShape = function () {
    return new StraightLineShape();
  };

  ECLinePath.prototype.buildPath = function (ctx, shape) {
    if (isStraightLine(shape)) {
      straightLineProto.buildPath.call(this, ctx, shape);
    } else {
      bezierCurveProto.buildPath.call(this, ctx, shape);
    }
  };

  ECLinePath.prototype.pointAt = function (t) {
    if (isStraightLine(this.shape)) {
      return straightLineProto.pointAt.call(this, t);
    } else {
      return bezierCurveProto.pointAt.call(this, t);
    }
  };

  ECLinePath.prototype.tangentAt = function (t) {
    var shape = this.shape;
    var p = isStraightLine(shape) ? [shape.x2 - shape.x1, shape.y2 - shape.y1] : bezierCurveProto.tangentAt.call(this, t);
    return __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_vector_js__["normalize"](p, p);
  };

  return ECLinePath;
}(__WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Path"]);

/* harmony default export */ __webpack_exports__["a"] = (ECLinePath);

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_createSeriesData_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_Series_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_symbol_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__ = __webpack_require__(4);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






var LineSeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(LineSeriesModel, _super);

  function LineSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = LineSeriesModel.type;
    _this.hasSymbolVisual = true;
    return _this;
  }

  LineSeriesModel.prototype.getInitialData = function (option) {
    if (true) {
      var coordSys = option.coordinateSystem;

      if (coordSys !== 'polar' && coordSys !== 'cartesian2d') {
        throw new Error('Line not support coordinateSystem besides cartesian and polar');
      }
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper_createSeriesData_js__["a" /* default */])(null, this, {
      useEncodeDefaulter: true
    });
  };

  LineSeriesModel.prototype.getLegendIcon = function (opt) {
    var group = new __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["Group"]();
    var line = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_symbol_js__["a" /* createSymbol */])('line', 0, opt.itemHeight / 2, opt.itemWidth, 0, opt.lineStyle.stroke, false);
    group.add(line);
    line.setStyle(opt.lineStyle);
    var visualType = this.getData().getVisual('symbol');
    var visualRotate = this.getData().getVisual('symbolRotate');
    var symbolType = visualType === 'none' ? 'circle' : visualType; // Symbol size is 80% when there is a line

    var size = opt.itemHeight * 0.8;
    var symbol = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_symbol_js__["a" /* createSymbol */])(symbolType, (opt.itemWidth - size) / 2, (opt.itemHeight - size) / 2, size, size, opt.itemStyle.fill);
    group.add(symbol);
    symbol.setStyle(opt.itemStyle);
    var symbolRotate = opt.iconRotate === 'inherit' ? visualRotate : opt.iconRotate || 0;
    symbol.rotation = symbolRotate * Math.PI / 180;
    symbol.setOrigin([opt.itemWidth / 2, opt.itemHeight / 2]);

    if (symbolType.indexOf('empty') > -1) {
      symbol.style.stroke = symbol.style.fill;
      symbol.style.fill = '#fff';
      symbol.style.lineWidth = 2;
    }

    return group;
  };

  LineSeriesModel.type = 'series.line';
  LineSeriesModel.dependencies = ['grid', 'polar'];
  LineSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 3,
    coordinateSystem: 'cartesian2d',
    legendHoverLink: true,
    clip: true,
    label: {
      position: 'top'
    },
    // itemStyle: {
    // },
    endLabel: {
      show: false,
      valueAnimation: true,
      distance: 8
    },
    lineStyle: {
      width: 2,
      type: 'solid'
    },
    emphasis: {
      scale: true
    },
    // areaStyle: {
    // origin of areaStyle. Valid values:
    // `'auto'/null/undefined`: from axisLine to data
    // `'start'`: from min to data
    // `'end'`: from data to max
    // origin: 'auto'
    // },
    // false, 'start', 'end', 'middle'
    step: false,
    // Disabled if step is true
    smooth: false,
    smoothMonotone: null,
    symbol: 'emptyCircle',
    symbolSize: 4,
    symbolRotate: null,
    showSymbol: true,
    // `false`: follow the label interval strategy.
    // `true`: show all symbols.
    // `'auto'`: If possible, show all symbols, otherwise
    //           follow the label interval strategy.
    showAllSymbol: 'auto',
    // Whether to connect break point.
    connectNulls: false,
    // Sampling for large data. Can be: 'average', 'max', 'min', 'sum', 'lttb'.
    sampling: 'none',
    animationEasing: 'linear',
    // Disable progressive
    progressive: 0,
    hoverLayerThreshold: Infinity,
    universalTransition: {
      divideShape: 'clone'
    },
    triggerLineEvent: false
  };
  return LineSeriesModel;
}(__WEBPACK_IMPORTED_MODULE_2__model_Series_js__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (LineSeriesModel);

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_SymbolDraw_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_Symbol_js__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lineAnimationDiff_js__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__poly_js__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helper_js__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helper_createClipPathFromCoordSys_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__coord_CoordinateSystem_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helper_labelHelper_js__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_vendor_js__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_format_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_zrender_lib_tool_color_js__ = __webpack_require__(58);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
 // FIXME step not support polar




















function isPointsSame(points1, points2) {
  if (points1.length !== points2.length) {
    return;
  }

  for (var i = 0; i < points1.length; i++) {
    if (points1[i] !== points2[i]) {
      return;
    }
  }

  return true;
}

function bboxFromPoints(points) {
  var minX = Infinity;
  var minY = Infinity;
  var maxX = -Infinity;
  var maxY = -Infinity;

  for (var i = 0; i < points.length;) {
    var x = points[i++];
    var y = points[i++];

    if (!isNaN(x)) {
      minX = Math.min(x, minX);
      maxX = Math.max(x, maxX);
    }

    if (!isNaN(y)) {
      minY = Math.min(y, minY);
      maxY = Math.max(y, maxY);
    }
  }

  return [[minX, minY], [maxX, maxY]];
}

function getBoundingDiff(points1, points2) {
  var _a = bboxFromPoints(points1),
      min1 = _a[0],
      max1 = _a[1];

  var _b = bboxFromPoints(points2),
      min2 = _b[0],
      max2 = _b[1]; // Get a max value from each corner of two boundings.


  return Math.max(Math.abs(min1[0] - min2[0]), Math.abs(min1[1] - min2[1]), Math.abs(max1[0] - max2[0]), Math.abs(max1[1] - max2[1]));
}

function getSmooth(smooth) {
  return __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isNumber"](smooth) ? smooth : smooth ? 0.5 : 0;
}

function getStackedOnPoints(coordSys, data, dataCoordInfo) {
  if (!dataCoordInfo.valueDim) {
    return [];
  }

  var len = data.count();
  var points = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_vendor_js__["a" /* createFloat32Array */])(len * 2);

  for (var idx = 0; idx < len; idx++) {
    var pt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_js__["a" /* getStackedOnPoint */])(dataCoordInfo, coordSys, data, idx);
    points[idx * 2] = pt[0];
    points[idx * 2 + 1] = pt[1];
  }

  return points;
}

function turnPointsIntoStep(points, coordSys, stepTurnAt, connectNulls) {
  var baseAxis = coordSys.getBaseAxis();
  var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
  var stepPoints = [];
  var i = 0;
  var stepPt = [];
  var pt = [];
  var nextPt = [];
  var filteredPoints = [];

  if (connectNulls) {
    for (i = 0; i < points.length; i += 2) {
      if (!isNaN(points[i]) && !isNaN(points[i + 1])) {
        filteredPoints.push(points[i], points[i + 1]);
      }
    }

    points = filteredPoints;
  }

  for (i = 0; i < points.length - 2; i += 2) {
    nextPt[0] = points[i + 2];
    nextPt[1] = points[i + 3];
    pt[0] = points[i];
    pt[1] = points[i + 1];
    stepPoints.push(pt[0], pt[1]);

    switch (stepTurnAt) {
      case 'end':
        stepPt[baseIndex] = nextPt[baseIndex];
        stepPt[1 - baseIndex] = pt[1 - baseIndex];
        stepPoints.push(stepPt[0], stepPt[1]);
        break;

      case 'middle':
        var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
        var stepPt2 = [];
        stepPt[baseIndex] = stepPt2[baseIndex] = middle;
        stepPt[1 - baseIndex] = pt[1 - baseIndex];
        stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
        stepPoints.push(stepPt[0], stepPt[1]);
        stepPoints.push(stepPt2[0], stepPt2[1]);
        break;

      default:
        // default is start
        stepPt[baseIndex] = pt[baseIndex];
        stepPt[1 - baseIndex] = nextPt[1 - baseIndex];
        stepPoints.push(stepPt[0], stepPt[1]);
    }
  } // Last points


  stepPoints.push(points[i++], points[i++]);
  return stepPoints;
}
/**
 * Clip color stops to edge. Avoid creating too large gradients.
 * Which may lead to blurry when GPU acceleration is enabled. See #15680
 *
 * The stops has been sorted from small to large.
 */


function clipColorStops(colorStops, maxSize) {
  var newColorStops = [];
  var len = colorStops.length; // coord will always < 0 in prevOutOfRangeColorStop.

  var prevOutOfRangeColorStop;
  var prevInRangeColorStop;

  function lerpStop(stop0, stop1, clippedCoord) {
    var coord0 = stop0.coord;
    var p = (clippedCoord - coord0) / (stop1.coord - coord0);
    var color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_zrender_lib_tool_color_js__["lerp"])(p, [stop0.color, stop1.color]);
    return {
      coord: clippedCoord,
      color: color
    };
  }

  for (var i = 0; i < len; i++) {
    var stop_1 = colorStops[i];
    var coord = stop_1.coord;

    if (coord < 0) {
      prevOutOfRangeColorStop = stop_1;
    } else if (coord > maxSize) {
      if (prevInRangeColorStop) {
        newColorStops.push(lerpStop(prevInRangeColorStop, stop_1, maxSize));
      } else if (prevOutOfRangeColorStop) {
        // If there are two stops and coord range is between these two stops
        newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0), lerpStop(prevOutOfRangeColorStop, stop_1, maxSize));
      } // All following stop will be out of range. So just ignore them.


      break;
    } else {
      if (prevOutOfRangeColorStop) {
        newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0)); // Reset

        prevOutOfRangeColorStop = null;
      }

      newColorStops.push(stop_1);
      prevInRangeColorStop = stop_1;
    }
  }

  return newColorStops;
}

function getVisualGradient(data, coordSys, api) {
  var visualMetaList = data.getVisual('visualMeta');

  if (!visualMetaList || !visualMetaList.length || !data.count()) {
    // When data.count() is 0, gradient range can not be calculated.
    return;
  }

  if (coordSys.type !== 'cartesian2d') {
    if (true) {
      console.warn('Visual map on line style is only supported on cartesian2d.');
    }

    return;
  }

  var coordDim;
  var visualMeta;

  for (var i = visualMetaList.length - 1; i >= 0; i--) {
    var dimInfo = data.getDimensionInfo(visualMetaList[i].dimension);
    coordDim = dimInfo && dimInfo.coordDim; // Can only be x or y

    if (coordDim === 'x' || coordDim === 'y') {
      visualMeta = visualMetaList[i];
      break;
    }
  }

  if (!visualMeta) {
    if (true) {
      console.warn('Visual map on line style only support x or y dimension.');
    }

    return;
  } // If the area to be rendered is bigger than area defined by LinearGradient,
  // the canvas spec prescribes that the color of the first stop and the last
  // stop should be used. But if two stops are added at offset 0, in effect
  // browsers use the color of the second stop to render area outside
  // LinearGradient. So we can only infinitesimally extend area defined in
  // LinearGradient to render `outerColors`.


  var axis = coordSys.getAxis(coordDim); // dataToCoord mapping may not be linear, but must be monotonic.

  var colorStops = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"](visualMeta.stops, function (stop) {
    // offset will be calculated later.
    return {
      coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
      color: stop.color
    };
  });
  var stopLen = colorStops.length;
  var outerColors = visualMeta.outerColors.slice();

  if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
    colorStops.reverse();
    outerColors.reverse();
  }

  var colorStopsInRange = clipColorStops(colorStops, coordDim === 'x' ? api.getWidth() : api.getHeight());
  var inRangeStopLen = colorStopsInRange.length;

  if (!inRangeStopLen && stopLen) {
    // All stops are out of range. All will be the same color.
    return colorStops[0].coord < 0 ? outerColors[1] ? outerColors[1] : colorStops[stopLen - 1].color : outerColors[0] ? outerColors[0] : colorStops[0].color;
  }

  var tinyExtent = 10; // Arbitrary value: 10px

  var minCoord = colorStopsInRange[0].coord - tinyExtent;
  var maxCoord = colorStopsInRange[inRangeStopLen - 1].coord + tinyExtent;
  var coordSpan = maxCoord - minCoord;

  if (coordSpan < 1e-3) {
    return 'transparent';
  }

  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](colorStopsInRange, function (stop) {
    stop.offset = (stop.coord - minCoord) / coordSpan;
  });
  colorStopsInRange.push({
    // NOTE: inRangeStopLen may still be 0 if stoplen is zero.
    offset: inRangeStopLen ? colorStopsInRange[inRangeStopLen - 1].offset : 0.5,
    color: outerColors[1] || 'transparent'
  });
  colorStopsInRange.unshift({
    offset: inRangeStopLen ? colorStopsInRange[0].offset : 0.5,
    color: outerColors[0] || 'transparent'
  });
  var gradient = new __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["LinearGradient"](0, 0, 0, 0, colorStopsInRange, true);
  gradient[coordDim] = minCoord;
  gradient[coordDim + '2'] = maxCoord;
  return gradient;
}

function getIsIgnoreFunc(seriesModel, data, coordSys) {
  var showAllSymbol = seriesModel.get('showAllSymbol');
  var isAuto = showAllSymbol === 'auto';

  if (showAllSymbol && !isAuto) {
    return;
  }

  var categoryAxis = coordSys.getAxesByScale('ordinal')[0];

  if (!categoryAxis) {
    return;
  } // Note that category label interval strategy might bring some weird effect
  // in some scenario: users may wonder why some of the symbols are not
  // displayed. So we show all symbols as possible as we can.


  if (isAuto // Simplify the logic, do not determine label overlap here.
  && canShowAllSymbolForCategory(categoryAxis, data)) {
    return;
  } // Otherwise follow the label interval strategy on category axis.


  var categoryDataDim = data.mapDimension(categoryAxis.dim);
  var labelMap = {};
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](categoryAxis.getViewLabels(), function (labelItem) {
    var ordinalNumber = categoryAxis.scale.getRawOrdinalNumber(labelItem.tickValue);
    labelMap[ordinalNumber] = 1;
  });
  return function (dataIndex) {
    return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
  };
}

function canShowAllSymbolForCategory(categoryAxis, data) {
  // In mose cases, line is monotonous on category axis, and the label size
  // is close with each other. So we check the symbol size and some of the
  // label size alone with the category axis to estimate whether all symbol
  // can be shown without overlap.
  var axisExtent = categoryAxis.getExtent();
  var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
  isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
  // Sampling some points, max 5.

  var dataLen = data.count();
  var step = Math.max(1, Math.round(dataLen / 5));

  for (var dataIndex = 0; dataIndex < dataLen; dataIndex += step) {
    if (__WEBPACK_IMPORTED_MODULE_3__helper_Symbol_js__["a" /* default */].getSymbolSize(data, dataIndex // Only for cartesian, where `isHorizontal` exists.
    )[categoryAxis.isHorizontal() ? 1 : 0] // Empirical number
    * 1.5 > availSize) {
      return false;
    }
  }

  return true;
}

function isPointNull(x, y) {
  return isNaN(x) || isNaN(y);
}

function getLastIndexNotNull(points) {
  var len = points.length / 2;

  for (; len > 0; len--) {
    if (!isPointNull(points[len * 2 - 2], points[len * 2 - 1])) {
      break;
    }
  }

  return len - 1;
}

function getPointAtIndex(points, idx) {
  return [points[idx * 2], points[idx * 2 + 1]];
}

function getIndexRange(points, xOrY, dim) {
  var len = points.length / 2;
  var dimIdx = dim === 'x' ? 0 : 1;
  var a;
  var b;
  var prevIndex = 0;
  var nextIndex = -1;

  for (var i = 0; i < len; i++) {
    b = points[i * 2 + dimIdx];

    if (isNaN(b) || isNaN(points[i * 2 + 1 - dimIdx])) {
      continue;
    }

    if (i === 0) {
      a = b;
      continue;
    }

    if (a <= xOrY && b >= xOrY || a >= xOrY && b <= xOrY) {
      nextIndex = i;
      break;
    }

    prevIndex = i;
    a = b;
  }

  return {
    range: [prevIndex, nextIndex],
    t: (xOrY - a) / (b - a)
  };
}

function anyStateShowEndLabel(seriesModel) {
  if (seriesModel.get(['endLabel', 'show'])) {
    return true;
  }

  for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_12__util_states_js__["a" /* SPECIAL_STATES */].length; i++) {
    if (seriesModel.get([__WEBPACK_IMPORTED_MODULE_12__util_states_js__["a" /* SPECIAL_STATES */][i], 'endLabel', 'show'])) {
      return true;
    }
  }

  return false;
}

function createLineClipPath(lineView, coordSys, hasAnimation, seriesModel) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__coord_CoordinateSystem_js__["a" /* isCoordinateSystemType */])(coordSys, 'cartesian2d')) {
    var endLabelModel_1 = seriesModel.getModel('endLabel');
    var valueAnimation_1 = endLabelModel_1.get('valueAnimation');
    var data_1 = seriesModel.getData();
    var labelAnimationRecord_1 = {
      lastFrameIndex: 0
    };
    var during = anyStateShowEndLabel(seriesModel) ? function (percent, clipRect) {
      lineView._endLabelOnDuring(percent, clipRect, data_1, labelAnimationRecord_1, valueAnimation_1, endLabelModel_1, coordSys);
    } : null;
    var isHorizontal = coordSys.getBaseAxis().isHorizontal();
    var clipPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helper_createClipPathFromCoordSys_js__["b" /* createGridClipPath */])(coordSys, hasAnimation, seriesModel, function () {
      var endLabel = lineView._endLabel;

      if (endLabel && hasAnimation) {
        if (labelAnimationRecord_1.originalX != null) {
          endLabel.attr({
            x: labelAnimationRecord_1.originalX,
            y: labelAnimationRecord_1.originalY
          });
        }
      }
    }, during); // Expand clip shape to avoid clipping when line value exceeds axis

    if (!seriesModel.get('clip', true)) {
      var rectShape = clipPath.shape;
      var expandSize = Math.max(rectShape.width, rectShape.height);

      if (isHorizontal) {
        rectShape.y -= expandSize;
        rectShape.height += expandSize * 2;
      } else {
        rectShape.x -= expandSize;
        rectShape.width += expandSize * 2;
      }
    } // Set to the final frame. To make sure label layout is right.


    if (during) {
      during(1, clipPath);
    }

    return clipPath;
  } else {
    if (true) {
      if (seriesModel.get(['endLabel', 'show'])) {
        console.warn('endLabel is not supported for lines in polar systems.');
      }
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helper_createClipPathFromCoordSys_js__["c" /* createPolarClipPath */])(coordSys, hasAnimation, seriesModel);
  }
}

function getEndLabelStateSpecified(endLabelModel, coordSys) {
  var baseAxis = coordSys.getBaseAxis();
  var isHorizontal = baseAxis.isHorizontal();
  var isBaseInversed = baseAxis.inverse;
  var align = isHorizontal ? isBaseInversed ? 'right' : 'left' : 'center';
  var verticalAlign = isHorizontal ? 'middle' : isBaseInversed ? 'top' : 'bottom';
  return {
    normal: {
      align: endLabelModel.get('align') || align,
      verticalAlign: endLabelModel.get('verticalAlign') || verticalAlign
    }
  };
}

var LineView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(LineView, _super);

  function LineView() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  LineView.prototype.init = function () {
    var lineGroup = new __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["Group"]();
    var symbolDraw = new __WEBPACK_IMPORTED_MODULE_2__helper_SymbolDraw_js__["a" /* default */]();
    this.group.add(symbolDraw.group);
    this._symbolDraw = symbolDraw;
    this._lineGroup = lineGroup;
  };

  LineView.prototype.render = function (seriesModel, ecModel, api) {
    var _this = this;

    var coordSys = seriesModel.coordinateSystem;
    var group = this.group;
    var data = seriesModel.getData();
    var lineStyleModel = seriesModel.getModel('lineStyle');
    var areaStyleModel = seriesModel.getModel('areaStyle');
    var points = data.getLayout('points') || [];
    var isCoordSysPolar = coordSys.type === 'polar';
    var prevCoordSys = this._coordSys;
    var symbolDraw = this._symbolDraw;
    var polyline = this._polyline;
    var polygon = this._polygon;
    var lineGroup = this._lineGroup;
    var hasAnimation = seriesModel.get('animation');
    var isAreaChart = !areaStyleModel.isEmpty();
    var valueOrigin = areaStyleModel.get('origin');
    var dataCoordInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_js__["b" /* prepareDataCoordInfo */])(coordSys, data, valueOrigin);
    var stackedOnPoints = isAreaChart && getStackedOnPoints(coordSys, data, dataCoordInfo);
    var showSymbol = seriesModel.get('showSymbol');
    var connectNulls = seriesModel.get('connectNulls');
    var isIgnoreFunc = showSymbol && !isCoordSysPolar && getIsIgnoreFunc(seriesModel, data, coordSys); // Remove temporary symbols

    var oldData = this._data;
    oldData && oldData.eachItemGraphicEl(function (el, idx) {
      if (el.__temp) {
        group.remove(el);
        oldData.setItemGraphicEl(idx, null);
      }
    }); // Remove previous created symbols if showSymbol changed to false

    if (!showSymbol) {
      symbolDraw.remove();
    }

    group.add(lineGroup); // FIXME step not support polar

    var step = !isCoordSysPolar ? seriesModel.get('step') : false;
    var clipShapeForSymbol;

    if (coordSys && coordSys.getArea && seriesModel.get('clip', true)) {
      clipShapeForSymbol = coordSys.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
      // See #7913 and `test/dataZoom-clip.html`.

      if (clipShapeForSymbol.width != null) {
        clipShapeForSymbol.x -= 0.1;
        clipShapeForSymbol.y -= 0.1;
        clipShapeForSymbol.width += 0.2;
        clipShapeForSymbol.height += 0.2;
      } else if (clipShapeForSymbol.r0) {
        clipShapeForSymbol.r0 -= 0.5;
        clipShapeForSymbol.r += 0.5;
      }
    }

    this._clipShapeForSymbol = clipShapeForSymbol;
    var visualColor = getVisualGradient(data, coordSys, api) || data.getVisual('style')[data.getVisual('drawType')]; // Initialization animation or coordinate system changed

    if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
      showSymbol && symbolDraw.updateData(data, {
        isIgnore: isIgnoreFunc,
        clipShape: clipShapeForSymbol,
        disableAnimation: true,
        getSymbolPoint: function (idx) {
          return [points[idx * 2], points[idx * 2 + 1]];
        }
      });
      hasAnimation && this._initSymbolLabelAnimation(data, coordSys, clipShapeForSymbol);

      if (step) {
        // TODO If stacked series is not step
        points = turnPointsIntoStep(points, coordSys, step, connectNulls);

        if (stackedOnPoints) {
          stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step, connectNulls);
        }
      }

      polyline = this._newPolyline(points);

      if (isAreaChart) {
        polygon = this._newPolygon(points, stackedOnPoints);
      } // NOTE: Must update _endLabel before setClipPath.


      if (!isCoordSysPolar) {
        this._initOrUpdateEndLabel(seriesModel, coordSys, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_format_js__["d" /* convertToColorString */])(visualColor));
      }

      lineGroup.setClipPath(createLineClipPath(this, coordSys, true, seriesModel));
    } else {
      if (isAreaChart && !polygon) {
        // If areaStyle is added
        polygon = this._newPolygon(points, stackedOnPoints);
      } else if (polygon && !isAreaChart) {
        // If areaStyle is removed
        lineGroup.remove(polygon);
        polygon = this._polygon = null;
      } // NOTE: Must update _endLabel before setClipPath.


      if (!isCoordSysPolar) {
        this._initOrUpdateEndLabel(seriesModel, coordSys, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_format_js__["d" /* convertToColorString */])(visualColor));
      } // Update clipPath


      var oldClipPath = lineGroup.getClipPath();

      if (oldClipPath) {
        var newClipPath = createLineClipPath(this, coordSys, false, seriesModel);
        __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["initProps"](oldClipPath, {
          shape: newClipPath.shape
        }, seriesModel);
      } else {
        lineGroup.setClipPath(createLineClipPath(this, coordSys, true, seriesModel));
      } // Always update, or it is wrong in the case turning on legend
      // because points are not changed


      showSymbol && symbolDraw.updateData(data, {
        isIgnore: isIgnoreFunc,
        clipShape: clipShapeForSymbol,
        disableAnimation: true,
        getSymbolPoint: function (idx) {
          return [points[idx * 2], points[idx * 2 + 1]];
        }
      }); // In the case data zoom triggerred refreshing frequently
      // Data may not change if line has a category axis. So it should animate nothing

      if (!isPointsSame(this._stackedOnPoints, stackedOnPoints) || !isPointsSame(this._points, points)) {
        if (hasAnimation) {
          this._doUpdateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls);
        } else {
          // Not do it in update with animation
          if (step) {
            // TODO If stacked series is not step
            points = turnPointsIntoStep(points, coordSys, step, connectNulls);

            if (stackedOnPoints) {
              stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step, connectNulls);
            }
          }

          polyline.setShape({
            points: points
          });
          polygon && polygon.setShape({
            points: points,
            stackedOnPoints: stackedOnPoints
          });
        }
      }
    }

    var emphasisModel = seriesModel.getModel('emphasis');
    var focus = emphasisModel.get('focus');
    var blurScope = emphasisModel.get('blurScope');
    var emphasisDisabled = emphasisModel.get('disabled');
    polyline.useStyle(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"]( // Use color in lineStyle first
    lineStyleModel.getLineStyle(), {
      fill: 'none',
      stroke: visualColor,
      lineJoin: 'bevel'
    }));
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_states_js__["F" /* setStatesStylesFromModel */])(polyline, seriesModel, 'lineStyle');

    if (polyline.style.lineWidth > 0 && seriesModel.get(['emphasis', 'lineStyle', 'width']) === 'bolder') {
      var emphasisLineStyle = polyline.getState('emphasis').style;
      emphasisLineStyle.lineWidth = +polyline.style.lineWidth + 1;
    } // Needs seriesIndex for focus


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_innerStore_js__["a" /* getECData */])(polyline).seriesIndex = seriesModel.seriesIndex;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_states_js__["G" /* toggleHoverEmphasis */])(polyline, focus, blurScope, emphasisDisabled);
    var smooth = getSmooth(seriesModel.get('smooth'));
    var smoothMonotone = seriesModel.get('smoothMonotone');
    polyline.setShape({
      smooth: smooth,
      smoothMonotone: smoothMonotone,
      connectNulls: connectNulls
    });

    if (polygon) {
      var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
      var stackedOnSmooth = 0;
      polygon.useStyle(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"](areaStyleModel.getAreaStyle(), {
        fill: visualColor,
        opacity: 0.7,
        lineJoin: 'bevel',
        decal: data.getVisual('style').decal
      }));

      if (stackedOnSeries) {
        stackedOnSmooth = getSmooth(stackedOnSeries.get('smooth'));
      }

      polygon.setShape({
        smooth: smooth,
        stackedOnSmooth: stackedOnSmooth,
        smoothMonotone: smoothMonotone,
        connectNulls: connectNulls
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_states_js__["F" /* setStatesStylesFromModel */])(polygon, seriesModel, 'areaStyle'); // Needs seriesIndex for focus

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_innerStore_js__["a" /* getECData */])(polygon).seriesIndex = seriesModel.seriesIndex;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_states_js__["G" /* toggleHoverEmphasis */])(polygon, focus, blurScope, emphasisDisabled);
    }

    var changePolyState = function (toState) {
      _this._changePolyState(toState);
    };

    data.eachItemGraphicEl(function (el) {
      // Switch polyline / polygon state if element changed its state.
      el && (el.onHoverStateChange = changePolyState);
    });
    this._polyline.onHoverStateChange = changePolyState;
    this._data = data; // Save the coordinate system for transition animation when data changed

    this._coordSys = coordSys;
    this._stackedOnPoints = stackedOnPoints;
    this._points = points;
    this._step = step;
    this._valueOrigin = valueOrigin;

    if (seriesModel.get('triggerLineEvent')) {
      this.packEventData(seriesModel, polyline);
      polygon && this.packEventData(seriesModel, polygon);
    }
  };

  LineView.prototype.packEventData = function (seriesModel, el) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_innerStore_js__["a" /* getECData */])(el).eventData = {
      componentType: 'series',
      componentSubType: 'line',
      componentIndex: seriesModel.componentIndex,
      seriesIndex: seriesModel.seriesIndex,
      seriesName: seriesModel.name,
      seriesType: 'line'
    };
  };

  LineView.prototype.highlight = function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData();
    var dataIndex = __WEBPACK_IMPORTED_MODULE_6__util_model_js__["c" /* queryDataIndex */](data, payload);

    this._changePolyState('emphasis');

    if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
      var points = data.getLayout('points');
      var symbol = data.getItemGraphicEl(dataIndex);

      if (!symbol) {
        // Create a temporary symbol if it is not exists
        var x = points[dataIndex * 2];
        var y = points[dataIndex * 2 + 1];

        if (isNaN(x) || isNaN(y)) {
          // Null data
          return;
        } // fix #11360: should't draw symbol outside clipShapeForSymbol


        if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(x, y)) {
          return;
        }

        var zlevel = seriesModel.get('zlevel');
        var z = seriesModel.get('z');
        symbol = new __WEBPACK_IMPORTED_MODULE_3__helper_Symbol_js__["a" /* default */](data, dataIndex);
        symbol.x = x;
        symbol.y = y;
        symbol.setZ(zlevel, z); // ensure label text of the temporary symbol is in front of line and area polygon

        var symbolLabel = symbol.getSymbolPath().getTextContent();

        if (symbolLabel) {
          symbolLabel.zlevel = zlevel;
          symbolLabel.z = z;
          symbolLabel.z2 = this._polyline.z2 + 1;
        }

        symbol.__temp = true;
        data.setItemGraphicEl(dataIndex, symbol); // Stop scale animation

        symbol.stopSymbolAnimation(true);
        this.group.add(symbol);
      }

      symbol.highlight();
    } else {
      // Highlight whole series
      __WEBPACK_IMPORTED_MODULE_8__view_Chart_js__["a" /* default */].prototype.highlight.call(this, seriesModel, ecModel, api, payload);
    }
  };

  LineView.prototype.downplay = function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData();
    var dataIndex = __WEBPACK_IMPORTED_MODULE_6__util_model_js__["c" /* queryDataIndex */](data, payload);

    this._changePolyState('normal');

    if (dataIndex != null && dataIndex >= 0) {
      var symbol = data.getItemGraphicEl(dataIndex);

      if (symbol) {
        if (symbol.__temp) {
          data.setItemGraphicEl(dataIndex, null);
          this.group.remove(symbol);
        } else {
          symbol.downplay();
        }
      }
    } else {
      // FIXME
      // can not downplay completely.
      // Downplay whole series
      __WEBPACK_IMPORTED_MODULE_8__view_Chart_js__["a" /* default */].prototype.downplay.call(this, seriesModel, ecModel, api, payload);
    }
  };

  LineView.prototype._changePolyState = function (toState) {
    var polygon = this._polygon;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_states_js__["L" /* setStatesFlag */])(this._polyline, toState);
    polygon && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_states_js__["L" /* setStatesFlag */])(polygon, toState);
  };

  LineView.prototype._newPolyline = function (points) {
    var polyline = this._polyline; // Remove previous created polyline

    if (polyline) {
      this._lineGroup.remove(polyline);
    }

    polyline = new __WEBPACK_IMPORTED_MODULE_7__poly_js__["b" /* ECPolyline */]({
      shape: {
        points: points
      },
      segmentIgnoreThreshold: 2,
      z2: 10
    });

    this._lineGroup.add(polyline);

    this._polyline = polyline;
    return polyline;
  };

  LineView.prototype._newPolygon = function (points, stackedOnPoints) {
    var polygon = this._polygon; // Remove previous created polygon

    if (polygon) {
      this._lineGroup.remove(polygon);
    }

    polygon = new __WEBPACK_IMPORTED_MODULE_7__poly_js__["a" /* ECPolygon */]({
      shape: {
        points: points,
        stackedOnPoints: stackedOnPoints
      },
      segmentIgnoreThreshold: 2
    });

    this._lineGroup.add(polygon);

    this._polygon = polygon;
    return polygon;
  };

  LineView.prototype._initSymbolLabelAnimation = function (data, coordSys, clipShape) {
    var isHorizontalOrRadial;
    var isCoordSysPolar;
    var baseAxis = coordSys.getBaseAxis();
    var isAxisInverse = baseAxis.inverse;

    if (coordSys.type === 'cartesian2d') {
      isHorizontalOrRadial = baseAxis.isHorizontal();
      isCoordSysPolar = false;
    } else if (coordSys.type === 'polar') {
      isHorizontalOrRadial = baseAxis.dim === 'angle';
      isCoordSysPolar = true;
    }

    var seriesModel = data.hostModel;
    var seriesDuration = seriesModel.get('animationDuration');

    if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isFunction"](seriesDuration)) {
      seriesDuration = seriesDuration(null);
    }

    var seriesDalay = seriesModel.get('animationDelay') || 0;
    var seriesDalayValue = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isFunction"](seriesDalay) ? seriesDalay(null) : seriesDalay;
    data.eachItemGraphicEl(function (symbol, idx) {
      var el = symbol;

      if (el) {
        var point = [symbol.x, symbol.y];
        var start = void 0;
        var end = void 0;
        var current = void 0;

        if (clipShape) {
          if (isCoordSysPolar) {
            var polarClip = clipShape;
            var coord = coordSys.pointToCoord(point);

            if (isHorizontalOrRadial) {
              start = polarClip.startAngle;
              end = polarClip.endAngle;
              current = -coord[1] / 180 * Math.PI;
            } else {
              start = polarClip.r0;
              end = polarClip.r;
              current = coord[0];
            }
          } else {
            var gridClip = clipShape;

            if (isHorizontalOrRadial) {
              start = gridClip.x;
              end = gridClip.x + gridClip.width;
              current = symbol.x;
            } else {
              start = gridClip.y + gridClip.height;
              end = gridClip.y;
              current = symbol.y;
            }
          }
        }

        var ratio = end === start ? 0 : (current - start) / (end - start);

        if (isAxisInverse) {
          ratio = 1 - ratio;
        }

        var delay = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isFunction"](seriesDalay) ? seriesDalay(idx) : seriesDuration * ratio + seriesDalayValue;
        var symbolPath = el.getSymbolPath();
        var text = symbolPath.getTextContent();
        el.attr({
          scaleX: 0,
          scaleY: 0
        });
        el.animateTo({
          scaleX: 1,
          scaleY: 1
        }, {
          duration: 200,
          setToFinal: true,
          delay: delay
        });

        if (text) {
          text.animateFrom({
            style: {
              opacity: 0
            }
          }, {
            duration: 300,
            delay: delay
          });
        }

        symbolPath.disableLabelAnimation = true;
      }
    });
  };

  LineView.prototype._initOrUpdateEndLabel = function (seriesModel, coordSys, inheritColor) {
    var endLabelModel = seriesModel.getModel('endLabel');

    if (anyStateShowEndLabel(seriesModel)) {
      var data_2 = seriesModel.getData();
      var polyline = this._polyline; // series may be filtered.

      var points = data_2.getLayout('points');

      if (!points) {
        polyline.removeTextContent();
        this._endLabel = null;
        return;
      }

      var endLabel = this._endLabel;

      if (!endLabel) {
        endLabel = this._endLabel = new __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["Text"]({
          z2: 200 // should be higher than item symbol

        });
        endLabel.ignoreClip = true;
        polyline.setTextContent(this._endLabel);
        polyline.disableLabelAnimation = true;
      } // Find last non-NaN data to display data


      var dataIndex = getLastIndexNotNull(points);

      if (dataIndex >= 0) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__label_labelStyle_js__["e" /* setLabelStyle */])(polyline, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__label_labelStyle_js__["f" /* getLabelStatesModels */])(seriesModel, 'endLabel'), {
          inheritColor: inheritColor,
          labelFetcher: seriesModel,
          labelDataIndex: dataIndex,
          defaultText: function (dataIndex, opt, interpolatedValue) {
            return interpolatedValue != null ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helper_labelHelper_js__["b" /* getDefaultInterpolatedLabel */])(data_2, interpolatedValue) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helper_labelHelper_js__["a" /* getDefaultLabel */])(data_2, dataIndex);
          },
          enableTextSetter: true
        }, getEndLabelStateSpecified(endLabelModel, coordSys));
        polyline.textConfig.position = null;
      }
    } else if (this._endLabel) {
      this._polyline.removeTextContent();

      this._endLabel = null;
    }
  };

  LineView.prototype._endLabelOnDuring = function (percent, clipRect, data, animationRecord, valueAnimation, endLabelModel, coordSys) {
    var endLabel = this._endLabel;
    var polyline = this._polyline;

    if (endLabel) {
      // NOTE: Don't remove percent < 1. percent === 1 means the first frame during render.
      // The label is not prepared at this time.
      if (percent < 1 && animationRecord.originalX == null) {
        animationRecord.originalX = endLabel.x;
        animationRecord.originalY = endLabel.y;
      }

      var points = data.getLayout('points');
      var seriesModel = data.hostModel;
      var connectNulls = seriesModel.get('connectNulls');
      var precision = endLabelModel.get('precision');
      var distance = endLabelModel.get('distance') || 0;
      var baseAxis = coordSys.getBaseAxis();
      var isHorizontal = baseAxis.isHorizontal();
      var isBaseInversed = baseAxis.inverse;
      var clipShape = clipRect.shape;
      var xOrY = isBaseInversed ? isHorizontal ? clipShape.x : clipShape.y + clipShape.height : isHorizontal ? clipShape.x + clipShape.width : clipShape.y;
      var distanceX = (isHorizontal ? distance : 0) * (isBaseInversed ? -1 : 1);
      var distanceY = (isHorizontal ? 0 : -distance) * (isBaseInversed ? -1 : 1);
      var dim = isHorizontal ? 'x' : 'y';
      var dataIndexRange = getIndexRange(points, xOrY, dim);
      var indices = dataIndexRange.range;
      var diff = indices[1] - indices[0];
      var value = void 0;

      if (diff >= 1) {
        // diff > 1 && connectNulls, which is on the null data.
        if (diff > 1 && !connectNulls) {
          var pt = getPointAtIndex(points, indices[0]);
          endLabel.attr({
            x: pt[0] + distanceX,
            y: pt[1] + distanceY
          });
          valueAnimation && (value = seriesModel.getRawValue(indices[0]));
        } else {
          var pt = polyline.getPointOn(xOrY, dim);
          pt && endLabel.attr({
            x: pt[0] + distanceX,
            y: pt[1] + distanceY
          });
          var startValue = seriesModel.getRawValue(indices[0]);
          var endValue = seriesModel.getRawValue(indices[1]);
          valueAnimation && (value = __WEBPACK_IMPORTED_MODULE_6__util_model_js__["b" /* interpolateRawValues */](data, precision, startValue, endValue, dataIndexRange.t));
        }

        animationRecord.lastFrameIndex = indices[0];
      } else {
        // If diff <= 0, which is the range is not found(Include NaN)
        // Choose the first point or last point.
        var idx = percent === 1 || animationRecord.lastFrameIndex > 0 ? indices[0] : 0;
        var pt = getPointAtIndex(points, idx);
        valueAnimation && (value = seriesModel.getRawValue(idx));
        endLabel.attr({
          x: pt[0] + distanceX,
          y: pt[1] + distanceY
        });
      }

      if (valueAnimation) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__label_labelStyle_js__["a" /* labelInner */])(endLabel).setLabelText(value);
      }
    }
  };
  /**
   * @private
   */
  // FIXME Two value axis


  LineView.prototype._doUpdateAnimation = function (data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls) {
    var polyline = this._polyline;
    var polygon = this._polygon;
    var seriesModel = data.hostModel;
    var diff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lineAnimationDiff_js__["a" /* default */])(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
    var current = diff.current;
    var stackedOnCurrent = diff.stackedOnCurrent;
    var next = diff.next;
    var stackedOnNext = diff.stackedOnNext;

    if (step) {
      // TODO If stacked series is not step
      current = turnPointsIntoStep(diff.current, coordSys, step, connectNulls);
      stackedOnCurrent = turnPointsIntoStep(diff.stackedOnCurrent, coordSys, step, connectNulls);
      next = turnPointsIntoStep(diff.next, coordSys, step, connectNulls);
      stackedOnNext = turnPointsIntoStep(diff.stackedOnNext, coordSys, step, connectNulls);
    } // Don't apply animation if diff is large.
    // For better result and avoid memory explosion problems like
    // https://github.com/apache/incubator-echarts/issues/12229


    if (getBoundingDiff(current, next) > 3000 || polygon && getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
      polyline.stopAnimation();
      polyline.setShape({
        points: next
      });

      if (polygon) {
        polygon.stopAnimation();
        polygon.setShape({
          points: next,
          stackedOnPoints: stackedOnNext
        });
      }

      return;
    }

    polyline.shape.__points = diff.current;
    polyline.shape.points = current;
    var target = {
      shape: {
        points: next
      }
    }; // Also animate the original points.
    // If points reference is changed when turning into step line.

    if (diff.current !== current) {
      target.shape.__points = diff.next;
    } // Stop previous animation.


    polyline.stopAnimation();
    __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["updateProps"](polyline, target, seriesModel);

    if (polygon) {
      polygon.setShape({
        // Reuse the points with polyline.
        points: current,
        stackedOnPoints: stackedOnCurrent
      });
      polygon.stopAnimation();
      __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["updateProps"](polygon, {
        shape: {
          stackedOnPoints: stackedOnNext
        }
      }, seriesModel); // If use attr directly in updateProps.

      if (polyline.shape.points !== polygon.shape.points) {
        polygon.shape.points = polyline.shape.points;
      }
    }

    var updatedDataInfo = [];
    var diffStatus = diff.status;

    for (var i = 0; i < diffStatus.length; i++) {
      var cmd = diffStatus[i].cmd;

      if (cmd === '=') {
        var el = data.getItemGraphicEl(diffStatus[i].idx1);

        if (el) {
          updatedDataInfo.push({
            el: el,
            ptIdx: i // Index of points

          });
        }
      }
    }

    if (polyline.animators && polyline.animators.length) {
      polyline.animators[0].during(function () {
        polygon && polygon.dirtyShape();
        var points = polyline.shape.__points;

        for (var i = 0; i < updatedDataInfo.length; i++) {
          var el = updatedDataInfo[i].el;
          var offset = updatedDataInfo[i].ptIdx * 2;
          el.x = points[offset];
          el.y = points[offset + 1];
          el.markRedraw();
        }
      });
    }
  };

  LineView.prototype.remove = function (ecModel) {
    var group = this.group;
    var oldData = this._data;

    this._lineGroup.removeAll();

    this._symbolDraw.remove(true); // Remove temporary created elements when highlighting


    oldData && oldData.eachItemGraphicEl(function (el, idx) {
      if (el.__temp) {
        group.remove(el);
        oldData.setItemGraphicEl(idx, null);
      }
    });
    this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._endLabel = this._data = null;
  };

  LineView.type = 'line';
  return LineView;
}(__WEBPACK_IMPORTED_MODULE_8__view_Chart_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (LineView);

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LineSeries_js__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LineView_js__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_points_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__processor_dataSample_js__ = __webpack_require__(501);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

 // In case developer forget to include grid component



function install(registers) {
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_1__LineView_js__["a" /* default */]);
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_0__LineSeries_js__["a" /* default */]);
  registers.registerLayout(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__layout_points_js__["a" /* default */])('line', true));
  registers.registerVisual({
    seriesType: 'line',
    reset: function (seriesModel) {
      var data = seriesModel.getData(); // Visual coding for legend

      var lineStyle = seriesModel.getModel('lineStyle').getLineStyle();

      if (lineStyle && !lineStyle.stroke) {
        // Fill in visual should be palette color if
        // has color callback
        lineStyle.stroke = data.getVisual('style').fill;
      }

      data.setVisual('legendLineStyle', lineStyle);
    }
  }); // Down sample after filter

  registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__processor_dataSample_js__["a" /* default */])('line'));
}

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lineAnimationDiff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_js__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_vendor_js__ = __webpack_require__(198);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



function diffData(oldData, newData) {
  var diffResult = [];
  newData.diff(oldData).add(function (idx) {
    diffResult.push({
      cmd: '+',
      idx: idx
    });
  }).update(function (newIdx, oldIdx) {
    diffResult.push({
      cmd: '=',
      idx: oldIdx,
      idx1: newIdx
    });
  }).remove(function (idx) {
    diffResult.push({
      cmd: '-',
      idx: idx
    });
  }).execute();
  return diffResult;
}

function lineAnimationDiff(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
  var diff = diffData(oldData, newData); // let newIdList = newData.mapArray(newData.getId);
  // let oldIdList = oldData.mapArray(oldData.getId);
  // convertToIntId(newIdList, oldIdList);
  // // FIXME One data ?
  // diff = arrayDiff(oldIdList, newIdList);

  var currPoints = [];
  var nextPoints = []; // Points for stacking base line

  var currStackedPoints = [];
  var nextStackedPoints = [];
  var status = [];
  var sortedIndices = [];
  var rawIndices = [];
  var newDataOldCoordInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["b" /* prepareDataCoordInfo */])(oldCoordSys, newData, oldValueOrigin); // const oldDataNewCoordInfo = prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);

  var oldPoints = oldData.getLayout('points') || [];
  var newPoints = newData.getLayout('points') || [];

  for (var i = 0; i < diff.length; i++) {
    var diffItem = diff[i];
    var pointAdded = true;
    var oldIdx2 = void 0;
    var newIdx2 = void 0; // FIXME, animation is not so perfect when dataZoom window moves fast
    // Which is in case remvoing or add more than one data in the tail or head

    switch (diffItem.cmd) {
      case '=':
        oldIdx2 = diffItem.idx * 2;
        newIdx2 = diffItem.idx1 * 2;
        var currentX = oldPoints[oldIdx2];
        var currentY = oldPoints[oldIdx2 + 1];
        var nextX = newPoints[newIdx2];
        var nextY = newPoints[newIdx2 + 1]; // If previous data is NaN, use next point directly

        if (isNaN(currentX) || isNaN(currentY)) {
          currentX = nextX;
          currentY = nextY;
        }

        currPoints.push(currentX, currentY);
        nextPoints.push(nextX, nextY);
        currStackedPoints.push(oldStackedOnPoints[oldIdx2], oldStackedOnPoints[oldIdx2 + 1]);
        nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
        rawIndices.push(newData.getRawIndex(diffItem.idx1));
        break;

      case '+':
        var newIdx = diffItem.idx;
        var newDataDimsForPoint = newDataOldCoordInfo.dataDimsForPoint;
        var oldPt = oldCoordSys.dataToPoint([newData.get(newDataDimsForPoint[0], newIdx), newData.get(newDataDimsForPoint[1], newIdx)]);
        newIdx2 = newIdx * 2;
        currPoints.push(oldPt[0], oldPt[1]);
        nextPoints.push(newPoints[newIdx2], newPoints[newIdx2 + 1]);
        var stackedOnPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["a" /* getStackedOnPoint */])(newDataOldCoordInfo, oldCoordSys, newData, newIdx);
        currStackedPoints.push(stackedOnPoint[0], stackedOnPoint[1]);
        nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
        rawIndices.push(newData.getRawIndex(newIdx));
        break;

      case '-':
        pointAdded = false;
    } // Original indices


    if (pointAdded) {
      status.push(diffItem);
      sortedIndices.push(sortedIndices.length);
    }
  } // Diff result may be crossed if all items are changed
  // Sort by data index


  sortedIndices.sort(function (a, b) {
    return rawIndices[a] - rawIndices[b];
  });
  var len = currPoints.length;
  var sortedCurrPoints = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_vendor_js__["a" /* createFloat32Array */])(len);
  var sortedNextPoints = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_vendor_js__["a" /* createFloat32Array */])(len);
  var sortedCurrStackedPoints = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_vendor_js__["a" /* createFloat32Array */])(len);
  var sortedNextStackedPoints = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_vendor_js__["a" /* createFloat32Array */])(len);
  var sortedStatus = [];

  for (var i = 0; i < sortedIndices.length; i++) {
    var idx = sortedIndices[i];
    var i2 = i * 2;
    var idx2 = idx * 2;
    sortedCurrPoints[i2] = currPoints[idx2];
    sortedCurrPoints[i2 + 1] = currPoints[idx2 + 1];
    sortedNextPoints[i2] = nextPoints[idx2];
    sortedNextPoints[i2 + 1] = nextPoints[idx2 + 1];
    sortedCurrStackedPoints[i2] = currStackedPoints[idx2];
    sortedCurrStackedPoints[i2 + 1] = currStackedPoints[idx2 + 1];
    sortedNextStackedPoints[i2] = nextStackedPoints[idx2];
    sortedNextStackedPoints[i2 + 1] = nextStackedPoints[idx2 + 1];
    sortedStatus[i] = status[idx];
  }

  return {
    current: sortedCurrPoints,
    next: sortedNextPoints,
    stackedOnCurrent: sortedCurrStackedPoints,
    stackedOnNext: sortedNextStackedPoints,
    status: sortedStatus
  };
}

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_Series_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_SeriesData_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_CoordinateSystem_js__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_tooltip_tooltipMarkup_js__ = __webpack_require__(48);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/* global Uint32Array, Float64Array, Float32Array */






var Uint32Arr = typeof Uint32Array === 'undefined' ? Array : Uint32Array;
var Float64Arr = typeof Float64Array === 'undefined' ? Array : Float64Array;

function compatEc2(seriesOpt) {
  var data = seriesOpt.data;

  if (data && data[0] && data[0][0] && data[0][0].coord) {
    if (true) {
      console.warn('Lines data configuration has been changed to' + ' { coords:[[1,2],[2,3]] }');
    }

    seriesOpt.data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["map"])(data, function (itemOpt) {
      var coords = [itemOpt[0].coord, itemOpt[1].coord];
      var target = {
        coords: coords
      };

      if (itemOpt[0].name) {
        target.fromName = itemOpt[0].name;
      }

      if (itemOpt[1].name) {
        target.toName = itemOpt[1].name;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["mergeAll"])([target, itemOpt[0], itemOpt[1]]);
    });
  }
}

var LinesSeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(LinesSeriesModel, _super);

  function LinesSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = LinesSeriesModel.type;
    _this.visualStyleAccessPath = 'lineStyle';
    _this.visualDrawType = 'stroke';
    return _this;
  }

  LinesSeriesModel.prototype.init = function (option) {
    // The input data may be null/undefined.
    option.data = option.data || []; // Not using preprocessor because mergeOption may not have series.type

    compatEc2(option);

    var result = this._processFlatCoordsArray(option.data);

    this._flatCoords = result.flatCoords;
    this._flatCoordsOffset = result.flatCoordsOffset;

    if (result.flatCoords) {
      option.data = new Float32Array(result.count);
    }

    _super.prototype.init.apply(this, arguments);
  };

  LinesSeriesModel.prototype.mergeOption = function (option) {
    compatEc2(option);

    if (option.data) {
      // Only update when have option data to merge.
      var result = this._processFlatCoordsArray(option.data);

      this._flatCoords = result.flatCoords;
      this._flatCoordsOffset = result.flatCoordsOffset;

      if (result.flatCoords) {
        option.data = new Float32Array(result.count);
      }
    }

    _super.prototype.mergeOption.apply(this, arguments);
  };

  LinesSeriesModel.prototype.appendData = function (params) {
    var result = this._processFlatCoordsArray(params.data);

    if (result.flatCoords) {
      if (!this._flatCoords) {
        this._flatCoords = result.flatCoords;
        this._flatCoordsOffset = result.flatCoordsOffset;
      } else {
        this._flatCoords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["concatArray"])(this._flatCoords, result.flatCoords);
        this._flatCoordsOffset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["concatArray"])(this._flatCoordsOffset, result.flatCoordsOffset);
      }

      params.data = new Float32Array(result.count);
    }

    this.getRawData().appendData(params.data);
  };

  LinesSeriesModel.prototype._getCoordsFromItemModel = function (idx) {
    var itemModel = this.getData().getItemModel(idx);
    var coords = itemModel.option instanceof Array ? itemModel.option : itemModel.getShallow('coords');

    if (true) {
      if (!(coords instanceof Array && coords.length > 0 && coords[0] instanceof Array)) {
        throw new Error('Invalid coords ' + JSON.stringify(coords) + '. Lines must have 2d coords array in data item.');
      }
    }

    return coords;
  };

  LinesSeriesModel.prototype.getLineCoordsCount = function (idx) {
    if (this._flatCoordsOffset) {
      return this._flatCoordsOffset[idx * 2 + 1];
    } else {
      return this._getCoordsFromItemModel(idx).length;
    }
  };

  LinesSeriesModel.prototype.getLineCoords = function (idx, out) {
    if (this._flatCoordsOffset) {
      var offset = this._flatCoordsOffset[idx * 2];
      var len = this._flatCoordsOffset[idx * 2 + 1];

      for (var i = 0; i < len; i++) {
        out[i] = out[i] || [];
        out[i][0] = this._flatCoords[offset + i * 2];
        out[i][1] = this._flatCoords[offset + i * 2 + 1];
      }

      return len;
    } else {
      var coords = this._getCoordsFromItemModel(idx);

      for (var i = 0; i < coords.length; i++) {
        out[i] = out[i] || [];
        out[i][0] = coords[i][0];
        out[i][1] = coords[i][1];
      }

      return coords.length;
    }
  };

  LinesSeriesModel.prototype._processFlatCoordsArray = function (data) {
    var startOffset = 0;

    if (this._flatCoords) {
      startOffset = this._flatCoords.length;
    } // Stored as a typed array. In format
    // Points Count(2) | x | y | x | y | Points Count(3) | x |  y | x | y | x | y |


    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["isNumber"])(data[0])) {
      var len = data.length; // Store offset and len of each segment

      var coordsOffsetAndLenStorage = new Uint32Arr(len);
      var coordsStorage = new Float64Arr(len);
      var coordsCursor = 0;
      var offsetCursor = 0;
      var dataCount = 0;

      for (var i = 0; i < len;) {
        dataCount++;
        var count = data[i++]; // Offset

        coordsOffsetAndLenStorage[offsetCursor++] = coordsCursor + startOffset; // Len

        coordsOffsetAndLenStorage[offsetCursor++] = count;

        for (var k = 0; k < count; k++) {
          var x = data[i++];
          var y = data[i++];
          coordsStorage[coordsCursor++] = x;
          coordsStorage[coordsCursor++] = y;

          if (i > len) {
            if (true) {
              throw new Error('Invalid data format.');
            }
          }
        }
      }

      return {
        flatCoordsOffset: new Uint32Array(coordsOffsetAndLenStorage.buffer, 0, offsetCursor),
        flatCoords: coordsStorage,
        count: dataCount
      };
    }

    return {
      flatCoordsOffset: null,
      flatCoords: null,
      count: data.length
    };
  };

  LinesSeriesModel.prototype.getInitialData = function (option, ecModel) {
    if (true) {
      var CoordSys = __WEBPACK_IMPORTED_MODULE_4__core_CoordinateSystem_js__["a" /* default */].get(option.coordinateSystem);

      if (!CoordSys) {
        throw new Error('Unkown coordinate system ' + option.coordinateSystem);
      }
    }

    var lineData = new __WEBPACK_IMPORTED_MODULE_2__data_SeriesData_js__["a" /* default */](['value'], this);
    lineData.hasItemOption = false;
    lineData.initData(option.data, [], function (dataItem, dimName, dataIndex, dimIndex) {
      // dataItem is simply coords
      if (dataItem instanceof Array) {
        return NaN;
      } else {
        lineData.hasItemOption = true;
        var value = dataItem.value;

        if (value != null) {
          return value instanceof Array ? value[dimIndex] : value;
        }
      }
    });
    return lineData;
  };

  LinesSeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    var data = this.getData();
    var itemModel = data.getItemModel(dataIndex);
    var name = itemModel.get('name');

    if (name) {
      return name;
    }

    var fromName = itemModel.get('fromName');
    var toName = itemModel.get('toName');
    var nameArr = [];
    fromName != null && nameArr.push(fromName);
    toName != null && nameArr.push(toName);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__component_tooltip_tooltipMarkup_js__["b" /* createTooltipMarkup */])('nameValue', {
      name: nameArr.join(' > ')
    });
  };

  LinesSeriesModel.prototype.preventIncremental = function () {
    return !!this.get(['effect', 'show']);
  };

  LinesSeriesModel.prototype.getProgressive = function () {
    var progressive = this.option.progressive;

    if (progressive == null) {
      return this.option.large ? 1e4 : this.get('progressive');
    }

    return progressive;
  };

  LinesSeriesModel.prototype.getProgressiveThreshold = function () {
    var progressiveThreshold = this.option.progressiveThreshold;

    if (progressiveThreshold == null) {
      return this.option.large ? 2e4 : this.get('progressiveThreshold');
    }

    return progressiveThreshold;
  };

  LinesSeriesModel.prototype.getZLevelKey = function () {
    var effectModel = this.getModel('effect');
    var trailLength = effectModel.get('trailLength');
    return this.getData().count() > this.getProgressiveThreshold() // Each progressive series has individual key.
    ? this.id : effectModel.get('show') && trailLength > 0 ? trailLength + '' : '';
  };

  LinesSeriesModel.type = 'series.lines';
  LinesSeriesModel.dependencies = ['grid', 'polar', 'geo', 'calendar'];
  LinesSeriesModel.defaultOption = {
    coordinateSystem: 'geo',
    // zlevel: 0,
    z: 2,
    legendHoverLink: true,
    // Cartesian coordinate system
    xAxisIndex: 0,
    yAxisIndex: 0,
    symbol: ['none', 'none'],
    symbolSize: [10, 10],
    // Geo coordinate system
    geoIndex: 0,
    effect: {
      show: false,
      period: 4,
      constantSpeed: 0,
      symbol: 'circle',
      symbolSize: 3,
      loop: true,
      trailLength: 0.2
    },
    large: false,
    // Available when large is true
    largeThreshold: 2000,
    polyline: false,
    clip: true,
    label: {
      show: false,
      position: 'end' // distance: 5,
      // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调

    },
    lineStyle: {
      opacity: 0.5
    }
  };
  return LinesSeriesModel;
}(__WEBPACK_IMPORTED_MODULE_1__model_Series_js__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (LinesSeriesModel);

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_LineDraw_js__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_EffectLine_js__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_Line_js__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_Polyline_js__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_EffectPolyline_js__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_LargeLineDraw_js__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__linesLayout_js__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helper_createClipPathFromCoordSys_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__view_Chart_js__ = __webpack_require__(27);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/











var LinesView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(LinesView, _super);

  function LinesView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = LinesView.type;
    return _this;
  }

  LinesView.prototype.render = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();

    var lineDraw = this._updateLineDraw(data, seriesModel);

    var zlevel = seriesModel.get('zlevel');
    var trailLength = seriesModel.get(['effect', 'trailLength']);
    var zr = api.getZr(); // Avoid the drag cause ghost shadow
    // FIXME Better way ?
    // SVG doesn't support

    var isSvg = zr.painter.getType() === 'svg';

    if (!isSvg) {
      zr.painter.getLayer(zlevel).clear(true);
    } // Config layer with motion blur


    if (this._lastZlevel != null && !isSvg) {
      zr.configLayer(this._lastZlevel, {
        motionBlur: false
      });
    }

    if (this._showEffect(seriesModel) && trailLength > 0) {
      if (!isSvg) {
        zr.configLayer(zlevel, {
          motionBlur: true,
          lastFrameAlpha: Math.max(Math.min(trailLength / 10 + 0.9, 1), 0)
        });
      } else if (true) {
        console.warn('SVG render mode doesn\'t support lines with trail effect');
      }
    }

    lineDraw.updateData(data);
    var clipPath = seriesModel.get('clip', true) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helper_createClipPathFromCoordSys_js__["a" /* createClipPath */])(seriesModel.coordinateSystem, false, seriesModel);

    if (clipPath) {
      this.group.setClipPath(clipPath);
    } else {
      this.group.removeClipPath();
    }

    this._lastZlevel = zlevel;
    this._finished = true;
  };

  LinesView.prototype.incrementalPrepareRender = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();

    var lineDraw = this._updateLineDraw(data, seriesModel);

    lineDraw.incrementalPrepareUpdate(data);

    this._clearLayer(api);

    this._finished = false;
  };

  LinesView.prototype.incrementalRender = function (taskParams, seriesModel, ecModel) {
    this._lineDraw.incrementalUpdate(taskParams, seriesModel.getData());

    this._finished = taskParams.end === seriesModel.getData().count();
  };

  LinesView.prototype.eachRendered = function (cb) {
    this._lineDraw && this._lineDraw.eachRendered(cb);
  };

  LinesView.prototype.updateTransform = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var pipelineContext = seriesModel.pipelineContext;

    if (!this._finished || pipelineContext.large || pipelineContext.progressiveRender) {
      // TODO Don't have to do update in large mode. Only do it when there are millions of data.
      return {
        update: true
      };
    } else {
      // TODO Use same logic with ScatterView.
      // Manually update layout
      var res = __WEBPACK_IMPORTED_MODULE_7__linesLayout_js__["a" /* default */].reset(seriesModel, ecModel, api);

      if (res.progress) {
        res.progress({
          start: 0,
          end: data.count(),
          count: data.count()
        }, data);
      } // Not in large mode


      this._lineDraw.updateLayout();

      this._clearLayer(api);
    }
  };

  LinesView.prototype._updateLineDraw = function (data, seriesModel) {
    var lineDraw = this._lineDraw;

    var hasEffect = this._showEffect(seriesModel);

    var isPolyline = !!seriesModel.get('polyline');
    var pipelineContext = seriesModel.pipelineContext;
    var isLargeDraw = pipelineContext.large;

    if (true) {
      if (hasEffect && isLargeDraw) {
        console.warn('Large lines not support effect');
      }
    }

    if (!lineDraw || hasEffect !== this._hasEffet || isPolyline !== this._isPolyline || isLargeDraw !== this._isLargeDraw) {
      if (lineDraw) {
        lineDraw.remove();
      }

      lineDraw = this._lineDraw = isLargeDraw ? new __WEBPACK_IMPORTED_MODULE_6__helper_LargeLineDraw_js__["a" /* default */]() : new __WEBPACK_IMPORTED_MODULE_1__helper_LineDraw_js__["a" /* default */](isPolyline ? hasEffect ? __WEBPACK_IMPORTED_MODULE_5__helper_EffectPolyline_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_4__helper_Polyline_js__["a" /* default */] : hasEffect ? __WEBPACK_IMPORTED_MODULE_2__helper_EffectLine_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_3__helper_Line_js__["a" /* default */]);
      this._hasEffet = hasEffect;
      this._isPolyline = isPolyline;
      this._isLargeDraw = isLargeDraw;
    }

    this.group.add(lineDraw.group);
    return lineDraw;
  };

  LinesView.prototype._showEffect = function (seriesModel) {
    return !!seriesModel.get(['effect', 'show']);
  };

  LinesView.prototype._clearLayer = function (api) {
    // Not use motion when dragging or zooming
    var zr = api.getZr();
    var isSvg = zr.painter.getType() === 'svg';

    if (!isSvg && this._lastZlevel != null) {
      zr.painter.getLayer(this._lastZlevel).clear(true);
    }
  };

  LinesView.prototype.remove = function (ecModel, api) {
    this._lineDraw && this._lineDraw.remove();
    this._lineDraw = null; // Clear motion when lineDraw is removed

    this._clearLayer(api);
  };

  LinesView.prototype.dispose = function (ecModel, api) {
    this.remove(ecModel, api);
  };

  LinesView.type = 'lines';
  return LinesView;
}(__WEBPACK_IMPORTED_MODULE_9__view_Chart_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (LinesView);

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LinesView_js__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LinesSeries_js__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linesLayout_js__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__linesVisual_js__ = __webpack_require__(1143);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




function install(registers) {
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_0__LinesView_js__["a" /* default */]);
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_1__LinesSeries_js__["a" /* default */]);
  registers.registerLayout(__WEBPACK_IMPORTED_MODULE_2__linesLayout_js__["a" /* default */]);
  registers.registerVisual(__WEBPACK_IMPORTED_MODULE_3__linesVisual_js__["a" /* default */]);
}

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function normalize(a) {
  if (!(a instanceof Array)) {
    a = [a, a];
  }

  return a;
}

var linesVisual = {
  seriesType: 'lines',
  reset: function (seriesModel) {
    var symbolType = normalize(seriesModel.get('symbol'));
    var symbolSize = normalize(seriesModel.get('symbolSize'));
    var data = seriesModel.getData();
    data.setVisual('fromSymbol', symbolType && symbolType[0]);
    data.setVisual('toSymbol', symbolType && symbolType[1]);
    data.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
    data.setVisual('toSymbolSize', symbolSize && symbolSize[1]);

    function dataEach(data, idx) {
      var itemModel = data.getItemModel(idx);
      var symbolType = normalize(itemModel.getShallow('symbol', true));
      var symbolSize = normalize(itemModel.getShallow('symbolSize', true));
      symbolType[0] && data.setItemVisual(idx, 'fromSymbol', symbolType[0]);
      symbolType[1] && data.setItemVisual(idx, 'toSymbol', symbolType[1]);
      symbolSize[0] && data.setItemVisual(idx, 'fromSymbolSize', symbolSize[0]);
      symbolSize[1] && data.setItemVisual(idx, 'toSymbolSize', symbolSize[1]);
    }

    return {
      dataEach: data.hasItemOption ? dataEach : null
    };
  }
};
/* harmony default export */ __webpack_exports__["a"] = (linesVisual);

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_createSeriesDataSimply_js__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_Series_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__coord_geo_geoSourceManager_js__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_helper_sourceHelper_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_tooltip_tooltipMarkup_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_symbol_js__ = __webpack_require__(37);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/









var MapSeries =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(MapSeries, _super);

  function MapSeries() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = MapSeries.type; // Only first map series of same mapType will drawMap.

    _this.needsDrawMap = false; // Group of all map series with same mapType

    _this.seriesGroup = [];

    _this.getTooltipPosition = function (dataIndex) {
      if (dataIndex != null) {
        var name_1 = this.getData().getName(dataIndex);
        var geo = this.coordinateSystem;
        var region = geo.getRegion(name_1);
        return region && geo.dataToPoint(region.getCenter());
      }
    };

    return _this;
  }

  MapSeries.prototype.getInitialData = function (option) {
    var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_createSeriesDataSimply_js__["a" /* default */])(this, {
      coordDimensions: ['value'],
      encodeDefaulter: __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["curry"](__WEBPACK_IMPORTED_MODULE_5__data_helper_sourceHelper_js__["g" /* makeSeriesEncodeForNameBased */], this)
    });
    var dataNameMap = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"]();
    var toAppendNames = [];

    for (var i = 0, len = data.count(); i < len; i++) {
      var name_2 = data.getName(i);
      dataNameMap.set(name_2, true);
    }

    var geoSource = __WEBPACK_IMPORTED_MODULE_4__coord_geo_geoSourceManager_js__["a" /* default */].load(this.getMapType(), this.option.nameMap, this.option.nameProperty);
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](geoSource.regions, function (region) {
      var name = region.name;

      if (!dataNameMap.get(name)) {
        toAppendNames.push(name);
      }
    }); // Complete data with missing regions. The consequent processes (like visual
    // map and render) can not be performed without a "full data". For example,
    // find `dataIndex` by name.

    data.appendValues([], toAppendNames);
    return data;
  };
  /**
   * If no host geo model, return null, which means using a
   * inner exclusive geo model.
   */


  MapSeries.prototype.getHostGeoModel = function () {
    var geoIndex = this.option.geoIndex;
    return geoIndex != null ? this.ecModel.getComponent('geo', geoIndex) : null;
  };

  MapSeries.prototype.getMapType = function () {
    return (this.getHostGeoModel() || this).option.map;
  }; // _fillOption(option, mapName) {
  // Shallow clone
  // option = zrUtil.extend({}, option);
  // option.data = geoCreator.getFilledRegions(option.data, mapName, option.nameMap);
  // return option;
  // }


  MapSeries.prototype.getRawValue = function (dataIndex) {
    // Use value stored in data instead because it is calculated from multiple series
    // FIXME Provide all value of multiple series ?
    var data = this.getData();
    return data.get(data.mapDimension('value'), dataIndex);
  };
  /**
   * Get model of region
   */


  MapSeries.prototype.getRegionModel = function (regionName) {
    var data = this.getData();
    return data.getItemModel(data.indexOfName(regionName));
  };
  /**
   * Map tooltip formatter
   */


  MapSeries.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    // FIXME orignalData and data is a bit confusing
    var data = this.getData();
    var value = this.getRawValue(dataIndex);
    var name = data.getName(dataIndex);
    var seriesGroup = this.seriesGroup;
    var seriesNames = [];

    for (var i = 0; i < seriesGroup.length; i++) {
      var otherIndex = seriesGroup[i].originalData.indexOfName(name);
      var valueDim = data.mapDimension('value');

      if (!isNaN(seriesGroup[i].originalData.get(valueDim, otherIndex))) {
        seriesNames.push(seriesGroup[i].name);
      }
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__component_tooltip_tooltipMarkup_js__["b" /* createTooltipMarkup */])('section', {
      header: seriesNames.join(', '),
      noHeader: !seriesNames.length,
      blocks: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__component_tooltip_tooltipMarkup_js__["b" /* createTooltipMarkup */])('nameValue', {
        name: name,
        value: value
      })]
    });
  };

  MapSeries.prototype.setZoom = function (zoom) {
    this.option.zoom = zoom;
  };

  MapSeries.prototype.setCenter = function (center) {
    this.option.center = center;
  };

  MapSeries.prototype.getLegendIcon = function (opt) {
    var iconType = opt.icon || 'roundRect';
    var icon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_symbol_js__["a" /* createSymbol */])(iconType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill);
    icon.setStyle(opt.itemStyle); // Map do not use itemStyle.borderWidth as border width

    icon.style.stroke = 'none'; // No rotation because no series visual symbol for map

    if (iconType.indexOf('empty') > -1) {
      icon.style.stroke = icon.style.fill;
      icon.style.fill = '#fff';
      icon.style.lineWidth = 2;
    }

    return icon;
  };

  MapSeries.type = 'series.map';
  MapSeries.dependencies = ['geo'];
  MapSeries.layoutMode = 'box';
  MapSeries.defaultOption = {
    // 一级层叠
    // zlevel: 0,
    // 二级层叠
    z: 2,
    coordinateSystem: 'geo',
    // map should be explicitly specified since ec3.
    map: '',
    // If `geoIndex` is not specified, a exclusive geo will be
    // created. Otherwise use the specified geo component, and
    // `map` and `mapType` are ignored.
    // geoIndex: 0,
    // 'center' | 'left' | 'right' | 'x%' | {number}
    left: 'center',
    // 'center' | 'top' | 'bottom' | 'x%' | {number}
    top: 'center',
    // right
    // bottom
    // width:
    // height
    // Aspect is width / height. Inited to be geoJson bbox aspect
    // This parameter is used for scale this aspect
    // Default value:
    // for geoSVG source: 1,
    // for geoJSON source: 0.75.
    aspectScale: null,
    ///// Layout with center and size
    // If you wan't to put map in a fixed size box with right aspect ratio
    // This two properties may more conveninet
    // layoutCenter: [50%, 50%]
    // layoutSize: 100
    showLegendSymbol: true,
    // Define left-top, right-bottom coords to control view
    // For example, [ [180, 90], [-180, -90] ],
    // higher priority than center and zoom
    boundingCoords: null,
    // Default on center of map
    center: null,
    zoom: 1,
    scaleLimit: null,
    selectedMode: true,
    label: {
      show: false,
      color: '#000'
    },
    // scaleLimit: null,
    itemStyle: {
      borderWidth: 0.5,
      borderColor: '#444',
      areaColor: '#eee'
    },
    emphasis: {
      label: {
        show: true,
        color: 'rgb(100,0,0)'
      },
      itemStyle: {
        areaColor: 'rgba(255,215,0,0.8)'
      }
    },
    select: {
      label: {
        show: true,
        color: 'rgb(100,0,0)'
      },
      itemStyle: {
        color: 'rgba(255,215,0,0.8)'
      }
    },
    nameProperty: 'name'
  };
  return MapSeries;
}(__WEBPACK_IMPORTED_MODULE_3__model_Series_js__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MapSeries);

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_helper_MapDraw_js__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_states_js__ = __webpack_require__(12);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







var MapView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(MapView, _super);

  function MapView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = MapView.type;
    return _this;
  }

  MapView.prototype.render = function (mapModel, ecModel, api, payload) {
    // Not render if it is an toggleSelect action from self
    if (payload && payload.type === 'mapToggleSelect' && payload.from === this.uid) {
      return;
    }

    var group = this.group;
    group.removeAll();

    if (mapModel.getHostGeoModel()) {
      return;
    }

    if (this._mapDraw && payload && payload.type === 'geoRoam') {
      this._mapDraw.resetForLabelLayout();
    } // Not update map if it is an roam action from self


    if (!(payload && payload.type === 'geoRoam' && payload.componentType === 'series' && payload.seriesId === mapModel.id)) {
      if (mapModel.needsDrawMap) {
        var mapDraw = this._mapDraw || new __WEBPACK_IMPORTED_MODULE_2__component_helper_MapDraw_js__["a" /* default */](api);
        group.add(mapDraw.group);
        mapDraw.draw(mapModel, ecModel, api, this, payload);
        this._mapDraw = mapDraw;
      } else {
        // Remove drawed map
        this._mapDraw && this._mapDraw.remove();
        this._mapDraw = null;
      }
    } else {
      var mapDraw = this._mapDraw;
      mapDraw && group.add(mapDraw.group);
    }

    mapModel.get('showLegendSymbol') && ecModel.getComponent('legend') && this._renderSymbols(mapModel, ecModel, api);
  };

  MapView.prototype.remove = function () {
    this._mapDraw && this._mapDraw.remove();
    this._mapDraw = null;
    this.group.removeAll();
  };

  MapView.prototype.dispose = function () {
    this._mapDraw && this._mapDraw.remove();
    this._mapDraw = null;
  };

  MapView.prototype._renderSymbols = function (mapModel, ecModel, api) {
    var originalData = mapModel.originalData;
    var group = this.group;
    originalData.each(originalData.mapDimension('value'), function (value, originalDataIndex) {
      if (isNaN(value)) {
        return;
      }

      var layout = originalData.getItemLayout(originalDataIndex);

      if (!layout || !layout.point) {
        // Not exists in map
        return;
      }

      var point = layout.point;
      var offset = layout.offset;
      var circle = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Circle"]({
        style: {
          // Because the special of map draw.
          // Which needs statistic of multiple series and draw on one map.
          // And each series also need a symbol with legend color
          //
          // Layout and visual are put one the different data
          // TODO
          fill: mapModel.getData().getVisual('style').fill
        },
        shape: {
          cx: point[0] + offset * 9,
          cy: point[1],
          r: 3
        },
        silent: true,
        // Do not overlap the first series, on which labels are displayed.
        z2: 8 + (!offset ? __WEBPACK_IMPORTED_MODULE_5__util_states_js__["J" /* Z2_EMPHASIS_LIFT */] + 1 : 0)
      }); // Only the series that has the first value on the same region is in charge of rendering the label.
      // But consider the case:
      // series: [
      //     {id: 'X', type: 'map', map: 'm', {data: [{name: 'A', value: 11}, {name: 'B', {value: 22}]},
      //     {id: 'Y', type: 'map', map: 'm', {data: [{name: 'A', value: 21}, {name: 'C', {value: 33}]}
      // ]
      // The offset `0` of item `A` is at series `X`, but of item `C` is at series `Y`.
      // For backward compatibility, we follow the rule that render label `A` by the
      // settings on series `X` but render label `C` by the settings on series `Y`.

      if (!offset) {
        var fullData = mapModel.mainSeries.getData();
        var name_1 = originalData.getName(originalDataIndex);
        var fullIndex_1 = fullData.indexOfName(name_1);
        var itemModel = originalData.getItemModel(originalDataIndex);
        var labelModel = itemModel.getModel('label');
        var regionGroup = fullData.getItemGraphicEl(fullIndex_1); // `getFormattedLabel` needs to use `getData` inside. Here
        // `mapModel.getData()` is shallow cloned from `mainSeries.getData()`.
        // FIXME
        // If this is not the `mainSeries`, the item model (like label formatter)
        // set on original data item will never get. But it has been working
        // like that from the begining, and this scenario is rarely encountered.
        // So it won't be fixed until have to.

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["e" /* setLabelStyle */])(circle, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["f" /* getLabelStatesModels */])(itemModel), {
          labelFetcher: {
            getFormattedLabel: function (idx, state) {
              return mapModel.getFormattedLabel(fullIndex_1, state);
            }
          },
          defaultText: name_1
        });
        circle.disableLabelAnimation = true;

        if (!labelModel.get('position')) {
          circle.setTextConfig({
            position: 'bottom'
          });
        }

        regionGroup.onHoverStateChange = function (toState) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_states_js__["L" /* setStatesFlag */])(circle, toState);
        };
      }

      group.add(circle);
    });
  };

  MapView.type = 'map';
  return MapView;
}(__WEBPACK_IMPORTED_MODULE_3__view_Chart_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MapView);

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extension_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MapView_js__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MapSeries_js__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapDataStatistic_js__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapSymbolLayout_js__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__legacy_dataSelectAction_js__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_geo_install_js__ = __webpack_require__(465);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







function install(registers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_6__component_geo_install_js__["a" /* install */]);
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_1__MapView_js__["a" /* default */]);
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_2__MapSeries_js__["a" /* default */]);
  registers.registerLayout(__WEBPACK_IMPORTED_MODULE_4__mapSymbolLayout_js__["a" /* default */]);
  registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, __WEBPACK_IMPORTED_MODULE_3__mapDataStatistic_js__["a" /* default */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__legacy_dataSelectAction_js__["b" /* createLegacyDataSelectAction */])('map', registers.registerAction);
}

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapDataStatistic;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
 // FIXME 公用？

function dataStatistics(datas, statisticType) {
  var dataNameMap = {};
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](datas, function (data) {
    data.each(data.mapDimension('value'), function (value, idx) {
      // Add prefix to avoid conflict with Object.prototype.
      var mapKey = 'ec-' + data.getName(idx);
      dataNameMap[mapKey] = dataNameMap[mapKey] || [];

      if (!isNaN(value)) {
        dataNameMap[mapKey].push(value);
      }
    });
  });
  return datas[0].map(datas[0].mapDimension('value'), function (value, idx) {
    var mapKey = 'ec-' + datas[0].getName(idx);
    var sum = 0;
    var min = Infinity;
    var max = -Infinity;
    var len = dataNameMap[mapKey].length;

    for (var i = 0; i < len; i++) {
      min = Math.min(min, dataNameMap[mapKey][i]);
      max = Math.max(max, dataNameMap[mapKey][i]);
      sum += dataNameMap[mapKey][i];
    }

    var result;

    if (statisticType === 'min') {
      result = min;
    } else if (statisticType === 'max') {
      result = max;
    } else if (statisticType === 'average') {
      result = sum / len;
    } else {
      result = sum;
    }

    return len === 0 ? NaN : result;
  });
}

function mapDataStatistic(ecModel) {
  var seriesGroups = {};
  ecModel.eachSeriesByType('map', function (seriesModel) {
    var hostGeoModel = seriesModel.getHostGeoModel();
    var key = hostGeoModel ? 'o' + hostGeoModel.id : 'i' + seriesModel.getMapType();
    (seriesGroups[key] = seriesGroups[key] || []).push(seriesModel);
  });
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](seriesGroups, function (seriesList, key) {
    var data = dataStatistics(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"](seriesList, function (seriesModel) {
      return seriesModel.getData();
    }), seriesList[0].get('mapValueCalculation'));

    for (var i = 0; i < seriesList.length; i++) {
      seriesList[i].originalData = seriesList[i].getData();
    } // FIXME Put where?


    for (var i = 0; i < seriesList.length; i++) {
      seriesList[i].seriesGroup = seriesList;
      seriesList[i].needsDrawMap = i === 0 && !seriesList[i].getHostGeoModel();
      seriesList[i].setData(data.cloneShallow());
      seriesList[i].mainSeries = seriesList[0];
    }
  });
}

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapSymbolLayout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

function mapSymbolLayout(ecModel) {
  var processedMapType = {};
  ecModel.eachSeriesByType('map', function (mapSeries) {
    var mapType = mapSeries.getMapType();

    if (mapSeries.getHostGeoModel() || processedMapType[mapType]) {
      return;
    }

    var mapSymbolOffsets = {};
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](mapSeries.seriesGroup, function (subMapSeries) {
      var geo = subMapSeries.coordinateSystem;
      var data = subMapSeries.originalData;

      if (subMapSeries.get('showLegendSymbol') && ecModel.getComponent('legend')) {
        data.each(data.mapDimension('value'), function (value, idx) {
          var name = data.getName(idx);
          var region = geo.getRegion(name); // If input series.data is [11, 22, '-'/null/undefined, 44],
          // it will be filled with NaN: [11, 22, NaN, 44] and NaN will
          // not be drawn. So here must validate if value is NaN.

          if (!region || isNaN(value)) {
            return;
          }

          var offset = mapSymbolOffsets[name] || 0;
          var point = geo.dataToPoint(region.getCenter());
          mapSymbolOffsets[name] = offset + 1;
          data.setItemLayout(idx, {
            point: point,
            offset: offset
          });
        });
      }
    }); // Show label of those region not has legendIcon (which is offset 0)

    var data = mapSeries.getData();
    data.each(function (idx) {
      var name = data.getName(idx);
      var layout = data.getItemLayout(idx) || {};
      layout.showLabel = !mapSymbolOffsets[name];
      data.setItemLayout(idx, layout);
    });
    processedMapType[mapType] = true;
  });
}

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_Series_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_createSeriesData_js__ = __webpack_require__(85);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var ParallelSeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ParallelSeriesModel, _super);

  function ParallelSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ParallelSeriesModel.type;
    _this.visualStyleAccessPath = 'lineStyle';
    _this.visualDrawType = 'stroke';
    return _this;
  }

  ParallelSeriesModel.prototype.getInitialData = function (option, ecModel) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_createSeriesData_js__["a" /* default */])(null, this, {
      useEncodeDefaulter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(makeDefaultEncode, null, this)
    });
  };
  /**
   * User can get data raw indices on 'axisAreaSelected' event received.
   *
   * @return Raw indices
   */


  ParallelSeriesModel.prototype.getRawIndicesByActiveState = function (activeState) {
    var coordSys = this.coordinateSystem;
    var data = this.getData();
    var indices = [];
    coordSys.eachActiveState(data, function (theActiveState, dataIndex) {
      if (activeState === theActiveState) {
        indices.push(data.getRawIndex(dataIndex));
      }
    });
    return indices;
  };

  ParallelSeriesModel.type = 'series.parallel';
  ParallelSeriesModel.dependencies = ['parallel'];
  ParallelSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    coordinateSystem: 'parallel',
    parallelIndex: 0,
    label: {
      show: false
    },
    inactiveOpacity: 0.05,
    activeOpacity: 1,
    lineStyle: {
      width: 1,
      opacity: 0.45,
      type: 'solid'
    },
    emphasis: {
      label: {
        show: false
      }
    },
    progressive: 500,
    smooth: false,
    animationEasing: 'linear'
  };
  return ParallelSeriesModel;
}(__WEBPACK_IMPORTED_MODULE_2__model_Series_js__["b" /* default */]);

function makeDefaultEncode(seriesModel) {
  // The mapping of parallelAxis dimension to data dimension can
  // be specified in parallelAxis.option.dim. For example, if
  // parallelAxis.option.dim is 'dim3', it mapping to the third
  // dimension of data. But `data.encode` has higher priority.
  // Moreover, parallelModel.dimension should not be regarded as data
  // dimensions. Consider dimensions = ['dim4', 'dim2', 'dim6'];
  var parallelModel = seriesModel.ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));

  if (!parallelModel) {
    return;
  }

  var encodeDefine = {};
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(parallelModel.dimensions, function (axisDim) {
    var dataDimIndex = convertDimNameToNumber(axisDim);
    encodeDefine[axisDim] = dataDimIndex;
  });
  return encodeDefine;
}

function convertDimNameToNumber(dimName) {
  return +dimName.replace('dim', '');
}

/* harmony default export */ __webpack_exports__["a"] = (ParallelSeriesModel);

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__animation_basicTrasition_js__ = __webpack_require__(40);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







var DEFAULT_SMOOTH = 0.3;

var ParallelView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ParallelView, _super);

  function ParallelView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ParallelView.type;
    _this._dataGroup = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Group"]();
    _this._initialized = false;
    return _this;
  }

  ParallelView.prototype.init = function () {
    this.group.add(this._dataGroup);
  };
  /**
   * @override
   */


  ParallelView.prototype.render = function (seriesModel, ecModel, api, payload) {
    // Clear previously rendered progressive elements.
    this._progressiveEls = null;
    var dataGroup = this._dataGroup;
    var data = seriesModel.getData();
    var oldData = this._data;
    var coordSys = seriesModel.coordinateSystem;
    var dimensions = coordSys.dimensions;
    var seriesScope = makeSeriesScope(seriesModel);
    data.diff(oldData).add(add).update(update).remove(remove).execute();

    function add(newDataIndex) {
      var line = addEl(data, dataGroup, newDataIndex, dimensions, coordSys);
      updateElCommon(line, data, newDataIndex, seriesScope);
    }

    function update(newDataIndex, oldDataIndex) {
      var line = oldData.getItemGraphicEl(oldDataIndex);
      var points = createLinePoints(data, newDataIndex, dimensions, coordSys);
      data.setItemGraphicEl(newDataIndex, line);
      __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["updateProps"](line, {
        shape: {
          points: points
        }
      }, seriesModel, newDataIndex);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__animation_basicTrasition_js__["f" /* saveOldStyle */])(line);
      updateElCommon(line, data, newDataIndex, seriesScope);
    }

    function remove(oldDataIndex) {
      var line = oldData.getItemGraphicEl(oldDataIndex);
      dataGroup.remove(line);
    } // First create


    if (!this._initialized) {
      this._initialized = true;
      var clipPath = createGridClipShape(coordSys, seriesModel, function () {
        // Callback will be invoked immediately if there is no animation
        setTimeout(function () {
          dataGroup.removeClipPath();
        });
      });
      dataGroup.setClipPath(clipPath);
    }

    this._data = data;
  };

  ParallelView.prototype.incrementalPrepareRender = function (seriesModel, ecModel, api) {
    this._initialized = true;
    this._data = null;

    this._dataGroup.removeAll();
  };

  ParallelView.prototype.incrementalRender = function (taskParams, seriesModel, ecModel) {
    var data = seriesModel.getData();
    var coordSys = seriesModel.coordinateSystem;
    var dimensions = coordSys.dimensions;
    var seriesScope = makeSeriesScope(seriesModel);
    var progressiveEls = this._progressiveEls = [];

    for (var dataIndex = taskParams.start; dataIndex < taskParams.end; dataIndex++) {
      var line = addEl(data, this._dataGroup, dataIndex, dimensions, coordSys);
      line.incremental = true;
      updateElCommon(line, data, dataIndex, seriesScope);
      progressiveEls.push(line);
    }
  };

  ParallelView.prototype.remove = function () {
    this._dataGroup && this._dataGroup.removeAll();
    this._data = null;
  };

  ParallelView.type = 'parallel';
  return ParallelView;
}(__WEBPACK_IMPORTED_MODULE_3__view_Chart_js__["a" /* default */]);

function createGridClipShape(coordSys, seriesModel, cb) {
  var parallelModel = coordSys.model;
  var rect = coordSys.getRect();
  var rectEl = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Rect"]({
    shape: {
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    }
  });
  var dim = parallelModel.get('layout') === 'horizontal' ? 'width' : 'height';
  rectEl.setShape(dim, 0);
  __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["initProps"](rectEl, {
    shape: {
      width: rect.width,
      height: rect.height
    }
  }, seriesModel, cb);
  return rectEl;
}

function createLinePoints(data, dataIndex, dimensions, coordSys) {
  var points = [];

  for (var i = 0; i < dimensions.length; i++) {
    var dimName = dimensions[i];
    var value = data.get(data.mapDimension(dimName), dataIndex);

    if (!isEmptyValue(value, coordSys.getAxis(dimName).type)) {
      points.push(coordSys.dataToPoint(value, dimName));
    }
  }

  return points;
}

function addEl(data, dataGroup, dataIndex, dimensions, coordSys) {
  var points = createLinePoints(data, dataIndex, dimensions, coordSys);
  var line = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Polyline"]({
    shape: {
      points: points
    },
    // silent: true,
    z2: 10
  });
  dataGroup.add(line);
  data.setItemGraphicEl(dataIndex, line);
  return line;
}

function makeSeriesScope(seriesModel) {
  var smooth = seriesModel.get('smooth', true);
  smooth === true && (smooth = DEFAULT_SMOOTH);
  smooth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_number_js__["g" /* numericToNumber */])(smooth);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["eqNaN"])(smooth) && (smooth = 0);
  return {
    smooth: smooth
  };
}

function updateElCommon(el, data, dataIndex, seriesScope) {
  el.useStyle(data.getItemVisual(dataIndex, 'style'));
  el.style.fill = null;
  el.setShape('smooth', seriesScope.smooth);
  var itemModel = data.getItemModel(dataIndex);
  var emphasisModel = itemModel.getModel('emphasis');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_states_js__["F" /* setStatesStylesFromModel */])(el, itemModel, 'lineStyle');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_states_js__["G" /* toggleHoverEmphasis */])(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
} // function simpleDiff(oldData, newData, dimensions) {
//     let oldLen;
//     if (!oldData
//         || !oldData.__plProgressive
//         || (oldLen = oldData.count()) !== newData.count()
//     ) {
//         return true;
//     }
//     let dimLen = dimensions.length;
//     for (let i = 0; i < oldLen; i++) {
//         for (let j = 0; j < dimLen; j++) {
//             if (oldData.get(dimensions[j], i) !== newData.get(dimensions[j], i)) {
//                 return true;
//             }
//         }
//     }
//     return false;
// }
// FIXME put in common util?


function isEmptyValue(val, axisType) {
  return axisType === 'category' ? val == null : val == null || isNaN(val); // axisType === 'value'
}

/* harmony default export */ __webpack_exports__["a"] = (ParallelView);

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extension_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ParallelView_js__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ParallelSeries_js__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parallelVisual_js__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component_parallel_install_js__ = __webpack_require__(474);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





function install(registers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__component_parallel_install_js__["a" /* install */]);
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_1__ParallelView_js__["a" /* default */]);
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_2__ParallelSeries_js__["a" /* default */]);
  registers.registerVisual(registers.PRIORITY.VISUAL.BRUSH, __WEBPACK_IMPORTED_MODULE_3__parallelVisual_js__["a" /* default */]);
}

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var opacityAccessPath = ['lineStyle', 'opacity'];
var parallelVisual = {
  seriesType: 'parallel',
  reset: function (seriesModel, ecModel) {
    var coordSys = seriesModel.coordinateSystem;
    var opacityMap = {
      normal: seriesModel.get(['lineStyle', 'opacity']),
      active: seriesModel.get('activeOpacity'),
      inactive: seriesModel.get('inactiveOpacity')
    };
    return {
      progress: function (params, data) {
        coordSys.eachActiveState(data, function (activeState, dataIndex) {
          var opacity = opacityMap[activeState];

          if (activeState === 'normal' && data.hasItemOption) {
            var itemOpacity = data.getItemModel(dataIndex).get(opacityAccessPath, true);
            itemOpacity != null && (opacity = itemOpacity);
          }

          var existsStyle = data.ensureUniqueItemVisual(dataIndex, 'style');
          existsStyle.opacity = opacity;
        }, params.start, params.end);
      }
    };
  }
};
/* harmony default export */ __webpack_exports__["a"] = (parallelVisual);

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_createSeriesDataSimply_js__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_helper_sourceHelper_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__visual_LegendVisualProvider_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_Series_js__ = __webpack_require__(26);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/









var PieSeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(PieSeriesModel, _super);

  function PieSeriesModel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @overwrite
   */


  PieSeriesModel.prototype.init = function (option) {
    _super.prototype.init.apply(this, arguments); // Enable legend selection for each data item
    // Use a function instead of direct access because data reference may changed


    this.legendVisualProvider = new __WEBPACK_IMPORTED_MODULE_6__visual_LegendVisualProvider_js__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["bind"](this.getData, this), __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["bind"](this.getRawData, this));

    this._defaultLabelLine(option);
  };
  /**
   * @overwrite
   */


  PieSeriesModel.prototype.mergeOption = function () {
    _super.prototype.mergeOption.apply(this, arguments);
  };
  /**
   * @overwrite
   */


  PieSeriesModel.prototype.getInitialData = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper_createSeriesDataSimply_js__["a" /* default */])(this, {
      coordDimensions: ['value'],
      encodeDefaulter: __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["curry"](__WEBPACK_IMPORTED_MODULE_5__data_helper_sourceHelper_js__["g" /* makeSeriesEncodeForNameBased */], this)
    });
  };
  /**
   * @overwrite
   */


  PieSeriesModel.prototype.getDataParams = function (dataIndex) {
    var data = this.getData();

    var params = _super.prototype.getDataParams.call(this, dataIndex); // FIXME toFixed?


    var valueList = [];
    data.each(data.mapDimension('value'), function (value) {
      valueList.push(value);
    });
    params.percent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_number_js__["v" /* getPercentWithPrecision */])(valueList, dataIndex, data.hostModel.get('percentPrecision'));
    params.$vars.push('percent');
    return params;
  };

  PieSeriesModel.prototype._defaultLabelLine = function (option) {
    // Extend labelLine emphasis
    __WEBPACK_IMPORTED_MODULE_3__util_model_js__["e" /* defaultEmphasis */](option, 'labelLine', ['show']);
    var labelLineNormalOpt = option.labelLine;
    var labelLineEmphasisOpt = option.emphasis.labelLine; // Not show label line if `label.normal.show = false`

    labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
    labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
  };

  PieSeriesModel.type = 'series.pie';
  PieSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    legendHoverLink: true,
    colorBy: 'data',
    // 默认全局居中
    center: ['50%', '50%'],
    radius: [0, '75%'],
    // 默认顺时针
    clockwise: true,
    startAngle: 90,
    // 最小角度改为0
    minAngle: 0,
    // If the angle of a sector less than `minShowLabelAngle`,
    // the label will not be displayed.
    minShowLabelAngle: 0,
    // 选中时扇区偏移量
    selectedOffset: 10,
    // 选择模式，默认关闭，可选single，multiple
    // selectedMode: false,
    // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
    // roseType: null,
    percentPrecision: 2,
    // If still show when all data zero.
    stillShowZeroSum: true,
    // cursor: null,
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    width: null,
    height: null,
    label: {
      // color: 'inherit',
      // If rotate around circle
      rotate: 0,
      show: true,
      overflow: 'truncate',
      // 'outer', 'inside', 'center'
      position: 'outer',
      // 'none', 'labelLine', 'edge'. Works only when position is 'outer'
      alignTo: 'none',
      // Closest distance between label and chart edge.
      // Works only position is 'outer' and alignTo is 'edge'.
      edgeDistance: '25%',
      // Works only position is 'outer' and alignTo is not 'edge'.
      bleedMargin: 10,
      // Distance between text and label line.
      distanceToLabelLine: 5 // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
      // 默认使用全局文本样式，详见TEXTSTYLE
      // distance: 当position为inner时有效，为label位置到圆心的距离与圆半径(环状图为内外半径和)的比例系数

    },
    // Enabled when label.normal.position is 'outer'
    labelLine: {
      show: true,
      // 引导线两段中的第一段长度
      length: 15,
      // 引导线两段中的第二段长度
      length2: 15,
      smooth: false,
      minTurnAngle: 90,
      maxSurfaceAngle: 90,
      lineStyle: {
        // color: 各异,
        width: 1,
        type: 'solid'
      }
    },
    itemStyle: {
      borderWidth: 1,
      borderJoin: 'round'
    },
    showEmptyCircle: true,
    emptyCircleStyle: {
      color: 'lightgray',
      opacity: 1
    },
    labelLayout: {
      // Hide the overlapped label.
      hideOverlap: true
    },
    emphasis: {
      scale: true,
      scaleSize: 5
    },
    // If use strategy to avoid label overlapping
    avoidLabelOverlap: true,
    // Animation type. Valid values: expansion, scale
    animationType: 'expansion',
    animationDuration: 1000,
    // Animation type when update. Valid values: transition, expansion
    animationTypeUpdate: 'transition',
    animationEasingUpdate: 'cubicInOut',
    animationDurationUpdate: 500,
    animationEasing: 'cubicInOut'
  };
  return PieSeriesModel;
}(__WEBPACK_IMPORTED_MODULE_7__model_Series_js__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PieSeriesModel);

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__labelLayout_js__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__label_labelGuideHelper_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helper_pieHelper_js__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__animation_basicTrasition_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pieLayout_js__ = __webpack_require__(454);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/











/**
 * Piece of pie including Sector, Label, LabelLine
 */

var PiePiece =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(PiePiece, _super);

  function PiePiece(data, idx, startAngle) {
    var _this = _super.call(this) || this;

    _this.z2 = 2;
    var text = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Text"]();

    _this.setTextContent(text);

    _this.updateData(data, idx, startAngle, true);

    return _this;
  }

  PiePiece.prototype.updateData = function (data, idx, startAngle, firstCreate) {
    var sector = this;
    var seriesModel = data.hostModel;
    var itemModel = data.getItemModel(idx);
    var emphasisModel = itemModel.getModel('emphasis');
    var layout = data.getItemLayout(idx); // cornerRadius & innerCornerRadius doesn't exist in the item layout. Use `0` if null value is specified.
    // see `setItemLayout` in `pieLayout.ts`.

    var sectorShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helper_pieHelper_js__["a" /* getSectorCornerRadius */])(itemModel.getModel('itemStyle'), layout, true), layout); // Ignore NaN data.

    if (isNaN(sectorShape.startAngle)) {
      // Use NaN shape to avoid drawing shape.
      sector.setShape(sectorShape);
      return;
    }

    if (firstCreate) {
      sector.setShape(sectorShape);
      var animationType = seriesModel.getShallow('animationType');

      if (seriesModel.ecModel.ssr) {
        // Use scale animation in SSR mode(opacity?)
        // Because CSS SVG animation doesn't support very customized shape animation.
        __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["initProps"](sector, {
          scaleX: 0,
          scaleY: 0
        }, seriesModel, {
          dataIndex: idx,
          isFrom: true
        });
        sector.originX = sectorShape.cx;
        sector.originY = sectorShape.cy;
      } else if (animationType === 'scale') {
        sector.shape.r = layout.r0;
        __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["initProps"](sector, {
          shape: {
            r: layout.r
          }
        }, seriesModel, idx);
      } // Expansion
      else {
          if (startAngle != null) {
            sector.setShape({
              startAngle: startAngle,
              endAngle: startAngle
            });
            __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["initProps"](sector, {
              shape: {
                startAngle: layout.startAngle,
                endAngle: layout.endAngle
              }
            }, seriesModel, idx);
          } else {
            sector.shape.endAngle = layout.startAngle;
            __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["updateProps"](sector, {
              shape: {
                endAngle: layout.endAngle
              }
            }, seriesModel, idx);
          }
        }
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__animation_basicTrasition_js__["f" /* saveOldStyle */])(sector); // Transition animation from the old shape

      __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["updateProps"](sector, {
        shape: sectorShape
      }, seriesModel, idx);
    }

    sector.useStyle(data.getItemVisual(idx, 'style'));
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_states_js__["F" /* setStatesStylesFromModel */])(sector, itemModel);
    var midAngle = (layout.startAngle + layout.endAngle) / 2;
    var offset = seriesModel.get('selectedOffset');
    var dx = Math.cos(midAngle) * offset;
    var dy = Math.sin(midAngle) * offset;
    var cursorStyle = itemModel.getShallow('cursor');
    cursorStyle && sector.attr('cursor', cursorStyle);

    this._updateLabel(seriesModel, data, idx);

    sector.ensureState('emphasis').shape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])({
      r: layout.r + (emphasisModel.get('scale') ? emphasisModel.get('scaleSize') || 0 : 0)
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helper_pieHelper_js__["a" /* getSectorCornerRadius */])(emphasisModel.getModel('itemStyle'), layout));
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])(sector.ensureState('select'), {
      x: dx,
      y: dy,
      shape: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helper_pieHelper_js__["a" /* getSectorCornerRadius */])(itemModel.getModel(['select', 'itemStyle']), layout)
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])(sector.ensureState('blur'), {
      shape: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helper_pieHelper_js__["a" /* getSectorCornerRadius */])(itemModel.getModel(['blur', 'itemStyle']), layout)
    });
    var labelLine = sector.getTextGuideLine();
    var labelText = sector.getTextContent();
    labelLine && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])(labelLine.ensureState('select'), {
      x: dx,
      y: dy
    }); // TODO: needs dx, dy in zrender?

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])(labelText.ensureState('select'), {
      x: dx,
      y: dy
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_states_js__["G" /* toggleHoverEmphasis */])(this, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
  };

  PiePiece.prototype._updateLabel = function (seriesModel, data, idx) {
    var sector = this;
    var itemModel = data.getItemModel(idx);
    var labelLineModel = itemModel.getModel('labelLine');
    var style = data.getItemVisual(idx, 'style');
    var visualColor = style && style.fill;
    var visualOpacity = style && style.opacity;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__["e" /* setLabelStyle */])(sector, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__["f" /* getLabelStatesModels */])(itemModel), {
      labelFetcher: data.hostModel,
      labelDataIndex: idx,
      inheritColor: visualColor,
      defaultOpacity: visualOpacity,
      defaultText: seriesModel.getFormattedLabel(idx, 'normal') || data.getName(idx)
    });
    var labelText = sector.getTextContent(); // Set textConfig on sector.

    sector.setTextConfig({
      // reset position, rotation
      position: null,
      rotation: null
    }); // Make sure update style on labelText after setLabelStyle.
    // Because setLabelStyle will replace a new style on it.

    labelText.attr({
      z2: 10
    });
    var labelPosition = seriesModel.get(['label', 'position']);

    if (labelPosition !== 'outside' && labelPosition !== 'outer') {
      sector.removeTextGuideLine();
    } else {
      var polyline = this.getTextGuideLine();

      if (!polyline) {
        polyline = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Polyline"]();
        this.setTextGuideLine(polyline);
      } // Default use item visual color


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__label_labelGuideHelper_js__["b" /* setLabelLineStyle */])(this, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__label_labelGuideHelper_js__["c" /* getLabelLineStatesModels */])(itemModel), {
        stroke: visualColor,
        opacity: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["retrieve3"])(labelLineModel.get(['lineStyle', 'opacity']), visualOpacity, 1)
      });
    }
  };

  return PiePiece;
}(__WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Sector"]); // Pie view


var PieView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(PieView, _super);

  function PieView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.ignoreLabelLineUpdate = true;
    return _this;
  }

  PieView.prototype.render = function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData();
    var oldData = this._data;
    var group = this.group;
    var startAngle; // First render

    if (!oldData && data.count() > 0) {
      var shape = data.getItemLayout(0);

      for (var s = 1; isNaN(shape && shape.startAngle) && s < data.count(); ++s) {
        shape = data.getItemLayout(s);
      }

      if (shape) {
        startAngle = shape.startAngle;
      }
    } // remove empty-circle if it exists


    if (this._emptyCircleSector) {
      group.remove(this._emptyCircleSector);
    } // when all data are filtered, show lightgray empty circle


    if (data.count() === 0 && seriesModel.get('showEmptyCircle')) {
      var sector = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Sector"]({
        shape: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__pieLayout_js__["b" /* getBasicPieLayout */])(seriesModel, api)
      });
      sector.useStyle(seriesModel.getModel('emptyCircleStyle').getItemStyle());
      this._emptyCircleSector = sector;
      group.add(sector);
    }

    data.diff(oldData).add(function (idx) {
      var piePiece = new PiePiece(data, idx, startAngle);
      data.setItemGraphicEl(idx, piePiece);
      group.add(piePiece);
    }).update(function (newIdx, oldIdx) {
      var piePiece = oldData.getItemGraphicEl(oldIdx);
      piePiece.updateData(data, newIdx, startAngle);
      piePiece.off('click');
      group.add(piePiece);
      data.setItemGraphicEl(newIdx, piePiece);
    }).remove(function (idx) {
      var piePiece = oldData.getItemGraphicEl(idx);
      __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["removeElementWithFadeOut"](piePiece, seriesModel, idx);
    }).execute();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__labelLayout_js__["a" /* default */])(seriesModel); // Always use initial animation.

    if (seriesModel.get('animationTypeUpdate') !== 'expansion') {
      this._data = data;
    }
  };

  PieView.prototype.dispose = function () {};

  PieView.prototype.containPoint = function (point, seriesModel) {
    var data = seriesModel.getData();
    var itemLayout = data.getItemLayout(0);

    if (itemLayout) {
      var dx = point[0] - itemLayout.cx;
      var dy = point[1] - itemLayout.cy;
      var radius = Math.sqrt(dx * dx + dy * dy);
      return radius <= itemLayout.r && radius >= itemLayout.r0;
    }
  };

  PieView.type = 'pie';
  return PieView;
}(__WEBPACK_IMPORTED_MODULE_4__view_Chart_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PieView);

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__legacy_dataSelectAction_js__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pie_pieLayout_js__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__processor_dataFilter_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PieView_js__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PieSeries_js__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__processor_negativeDataFilter_js__ = __webpack_require__(1356);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







function install(registers) {
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_4__PieView_js__["a" /* default */]);
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_5__PieSeries_js__["a" /* default */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__legacy_dataSelectAction_js__["b" /* createLegacyDataSelectAction */])('pie', registers.registerAction);
  registers.registerLayout(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["curry"])(__WEBPACK_IMPORTED_MODULE_1__pie_pieLayout_js__["a" /* default */], 'pie'));
  registers.registerProcessor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__processor_dataFilter_js__["a" /* default */])('pie'));
  registers.registerProcessor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__processor_negativeDataFilter_js__["a" /* default */])('pie'));
}

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pieLabelLayout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__label_labelGuideHelper_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__label_labelLayoutHelper_js__ = __webpack_require__(334);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// FIXME emphasis label position is not same with normal label position





var RADIAN = Math.PI / 180;

function adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight, viewLeft, viewTop, farthestX) {
  if (list.length < 2) {
    return;
  }

  ;

  function recalculateXOnSemiToAlignOnEllipseCurve(semi) {
    var rB = semi.rB;
    var rB2 = rB * rB;

    for (var i = 0; i < semi.list.length; i++) {
      var item = semi.list[i];
      var dy = Math.abs(item.label.y - cy); // horizontal r is always same with original r because x is not changed.

      var rA = r + item.len;
      var rA2 = rA * rA; // Use ellipse implicit function to calculate x

      var dx = Math.sqrt((1 - Math.abs(dy * dy / rB2)) * rA2);
      var newX = cx + (dx + item.len2) * dir;
      var deltaX = newX - item.label.x;
      var newTargetWidth = item.targetTextWidth - deltaX * dir; // text x is changed, so need to recalculate width.

      constrainTextWidth(item, newTargetWidth, true);
      item.label.x = newX;
    }
  } // Adjust X based on the shifted y. Make tight labels aligned on an ellipse curve.


  function recalculateX(items) {
    // Extremes of
    var topSemi = {
      list: [],
      maxY: 0
    };
    var bottomSemi = {
      list: [],
      maxY: 0
    };

    for (var i = 0; i < items.length; i++) {
      if (items[i].labelAlignTo !== 'none') {
        continue;
      }

      var item = items[i];
      var semi = item.label.y > cy ? bottomSemi : topSemi;
      var dy = Math.abs(item.label.y - cy);

      if (dy >= semi.maxY) {
        var dx = item.label.x - cx - item.len2 * dir; // horizontal r is always same with original r because x is not changed.

        var rA = r + item.len; // Canculate rB based on the topest / bottemest label.

        var rB = Math.abs(dx) < rA ? Math.sqrt(dy * dy / (1 - dx * dx / rA / rA)) : rA;
        semi.rB = rB;
        semi.maxY = dy;
      }

      semi.list.push(item);
    }

    recalculateXOnSemiToAlignOnEllipseCurve(topSemi);
    recalculateXOnSemiToAlignOnEllipseCurve(bottomSemi);
  }

  var len = list.length;

  for (var i = 0; i < len; i++) {
    if (list[i].position === 'outer' && list[i].labelAlignTo === 'labelLine') {
      var dx = list[i].label.x - farthestX;
      list[i].linePoints[1][0] += dx;
      list[i].label.x = farthestX;
    }
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__label_labelLayoutHelper_js__["c" /* shiftLayoutOnY */])(list, viewTop, viewTop + viewHeight)) {
    recalculateX(list);
  }
}

function avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop) {
  var leftList = [];
  var rightList = [];
  var leftmostX = Number.MAX_VALUE;
  var rightmostX = -Number.MAX_VALUE;

  for (var i = 0; i < labelLayoutList.length; i++) {
    var label = labelLayoutList[i].label;

    if (isPositionCenter(labelLayoutList[i])) {
      continue;
    }

    if (label.x < cx) {
      leftmostX = Math.min(leftmostX, label.x);
      leftList.push(labelLayoutList[i]);
    } else {
      rightmostX = Math.max(rightmostX, label.x);
      rightList.push(labelLayoutList[i]);
    }
  }

  for (var i = 0; i < labelLayoutList.length; i++) {
    var layout = labelLayoutList[i];

    if (!isPositionCenter(layout) && layout.linePoints) {
      if (layout.labelStyleWidth != null) {
        continue;
      }

      var label = layout.label;
      var linePoints = layout.linePoints;
      var targetTextWidth = void 0;

      if (layout.labelAlignTo === 'edge') {
        if (label.x < cx) {
          targetTextWidth = linePoints[2][0] - layout.labelDistance - viewLeft - layout.edgeDistance;
        } else {
          targetTextWidth = viewLeft + viewWidth - layout.edgeDistance - linePoints[2][0] - layout.labelDistance;
        }
      } else if (layout.labelAlignTo === 'labelLine') {
        if (label.x < cx) {
          targetTextWidth = leftmostX - viewLeft - layout.bleedMargin;
        } else {
          targetTextWidth = viewLeft + viewWidth - rightmostX - layout.bleedMargin;
        }
      } else {
        if (label.x < cx) {
          targetTextWidth = label.x - viewLeft - layout.bleedMargin;
        } else {
          targetTextWidth = viewLeft + viewWidth - label.x - layout.bleedMargin;
        }
      }

      layout.targetTextWidth = targetTextWidth;
      constrainTextWidth(layout, targetTextWidth);
    }
  }

  adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight, viewLeft, viewTop, rightmostX);
  adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight, viewLeft, viewTop, leftmostX);

  for (var i = 0; i < labelLayoutList.length; i++) {
    var layout = labelLayoutList[i];

    if (!isPositionCenter(layout) && layout.linePoints) {
      var label = layout.label;
      var linePoints = layout.linePoints;
      var isAlignToEdge = layout.labelAlignTo === 'edge';
      var padding = label.style.padding;
      var paddingH = padding ? padding[1] + padding[3] : 0; // textRect.width already contains paddingH if bgColor is set

      var extraPaddingH = label.style.backgroundColor ? 0 : paddingH;
      var realTextWidth = layout.rect.width + extraPaddingH;
      var dist = linePoints[1][0] - linePoints[2][0];

      if (isAlignToEdge) {
        if (label.x < cx) {
          linePoints[2][0] = viewLeft + layout.edgeDistance + realTextWidth + layout.labelDistance;
        } else {
          linePoints[2][0] = viewLeft + viewWidth - layout.edgeDistance - realTextWidth - layout.labelDistance;
        }
      } else {
        if (label.x < cx) {
          linePoints[2][0] = label.x + layout.labelDistance;
        } else {
          linePoints[2][0] = label.x - layout.labelDistance;
        }

        linePoints[1][0] = linePoints[2][0] + dist;
      }

      linePoints[1][1] = linePoints[2][1] = label.y;
    }
  }
}
/**
 * Set max width of each label, and then wrap each label to the max width.
 *
 * @param layout label layout
 * @param availableWidth max width for the label to display
 * @param forceRecalculate recaculate the text layout even if the current width
 * is smaller than `availableWidth`. This is useful when the text was previously
 * wrapped by calling `constrainTextWidth` but now `availableWidth` changed, in
 * which case, previous wrapping should be redo.
 */


function constrainTextWidth(layout, availableWidth, forceRecalculate) {
  if (forceRecalculate === void 0) {
    forceRecalculate = false;
  }

  if (layout.labelStyleWidth != null) {
    // User-defined style.width has the highest priority.
    return;
  }

  var label = layout.label;
  var style = label.style;
  var textRect = layout.rect;
  var bgColor = style.backgroundColor;
  var padding = style.padding;
  var paddingH = padding ? padding[1] + padding[3] : 0;
  var overflow = style.overflow; // textRect.width already contains paddingH if bgColor is set

  var oldOuterWidth = textRect.width + (bgColor ? 0 : paddingH);

  if (availableWidth < oldOuterWidth || forceRecalculate) {
    var oldHeight = textRect.height;

    if (overflow && overflow.match('break')) {
      // Temporarily set background to be null to calculate
      // the bounding box without backgroud.
      label.setStyle('backgroundColor', null); // Set constraining width

      label.setStyle('width', availableWidth - paddingH); // This is the real bounding box of the text without padding

      var innerRect = label.getBoundingRect();
      label.setStyle('width', Math.ceil(innerRect.width));
      label.setStyle('backgroundColor', bgColor);
    } else {
      var availableInnerWidth = availableWidth - paddingH;
      var newWidth = availableWidth < oldOuterWidth // Current text is too wide, use `availableWidth` as max width.
      ? availableInnerWidth : // Current available width is enough, but the text may have
      // already been wrapped with a smaller available width.
      forceRecalculate ? availableInnerWidth > layout.unconstrainedWidth // Current available is larger than text width,
      // so don't constrain width (otherwise it may have
      // empty space in the background).
      ? null // Current available is smaller than text width, so
      // use the current available width as constraining
      // width.
      : availableInnerWidth : // Current available width is enough, so no need to
      // constrain.
      null;
      label.setStyle('width', newWidth);
    }

    var newRect = label.getBoundingRect();
    textRect.width = newRect.width;
    var margin = (label.style.margin || 0) + 2.1;
    textRect.height = newRect.height + margin;
    textRect.y -= (textRect.height - oldHeight) / 2;
  }
}

function isPositionCenter(sectorShape) {
  // Not change x for center label
  return sectorShape.position === 'center';
}

function pieLabelLayout(seriesModel) {
  var data = seriesModel.getData();
  var labelLayoutList = [];
  var cx;
  var cy;
  var hasLabelRotate = false;
  var minShowLabelRadian = (seriesModel.get('minShowLabelAngle') || 0) * RADIAN;
  var viewRect = data.getLayout('viewRect');
  var r = data.getLayout('r');
  var viewWidth = viewRect.width;
  var viewLeft = viewRect.x;
  var viewTop = viewRect.y;
  var viewHeight = viewRect.height;

  function setNotShow(el) {
    el.ignore = true;
  }

  function isLabelShown(label) {
    if (!label.ignore) {
      return true;
    }

    for (var key in label.states) {
      if (label.states[key].ignore === false) {
        return true;
      }
    }

    return false;
  }

  data.each(function (idx) {
    var sector = data.getItemGraphicEl(idx);
    var sectorShape = sector.shape;
    var label = sector.getTextContent();
    var labelLine = sector.getTextGuideLine();
    var itemModel = data.getItemModel(idx);
    var labelModel = itemModel.getModel('label'); // Use position in normal or emphasis

    var labelPosition = labelModel.get('position') || itemModel.get(['emphasis', 'label', 'position']);
    var labelDistance = labelModel.get('distanceToLabelLine');
    var labelAlignTo = labelModel.get('alignTo');
    var edgeDistance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["a" /* parsePercent */])(labelModel.get('edgeDistance'), viewWidth);
    var bleedMargin = labelModel.get('bleedMargin');
    var labelLineModel = itemModel.getModel('labelLine');
    var labelLineLen = labelLineModel.get('length');
    labelLineLen = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["a" /* parsePercent */])(labelLineLen, viewWidth);
    var labelLineLen2 = labelLineModel.get('length2');
    labelLineLen2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["a" /* parsePercent */])(labelLineLen2, viewWidth);

    if (Math.abs(sectorShape.endAngle - sectorShape.startAngle) < minShowLabelRadian) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(label.states, setNotShow);
      label.ignore = true;
      return;
    }

    if (!isLabelShown(label)) {
      return;
    }

    var midAngle = (sectorShape.startAngle + sectorShape.endAngle) / 2;
    var nx = Math.cos(midAngle);
    var ny = Math.sin(midAngle);
    var textX;
    var textY;
    var linePoints;
    var textAlign;
    cx = sectorShape.cx;
    cy = sectorShape.cy;
    var isLabelInside = labelPosition === 'inside' || labelPosition === 'inner';

    if (labelPosition === 'center') {
      textX = sectorShape.cx;
      textY = sectorShape.cy;
      textAlign = 'center';
    } else {
      var x1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * nx : sectorShape.r * nx) + cx;
      var y1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * ny : sectorShape.r * ny) + cy;
      textX = x1 + nx * 3;
      textY = y1 + ny * 3;

      if (!isLabelInside) {
        // For roseType
        var x2 = x1 + nx * (labelLineLen + r - sectorShape.r);
        var y2 = y1 + ny * (labelLineLen + r - sectorShape.r);
        var x3 = x2 + (nx < 0 ? -1 : 1) * labelLineLen2;
        var y3 = y2;

        if (labelAlignTo === 'edge') {
          // Adjust textX because text align of edge is opposite
          textX = nx < 0 ? viewLeft + edgeDistance : viewLeft + viewWidth - edgeDistance;
        } else {
          textX = x3 + (nx < 0 ? -labelDistance : labelDistance);
        }

        textY = y3;
        linePoints = [[x1, y1], [x2, y2], [x3, y3]];
      }

      textAlign = isLabelInside ? 'center' : labelAlignTo === 'edge' ? nx > 0 ? 'right' : 'left' : nx > 0 ? 'left' : 'right';
    }

    var PI = Math.PI;
    var labelRotate = 0;
    var rotate = labelModel.get('rotate');

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isNumber"])(rotate)) {
      labelRotate = rotate * (PI / 180);
    } else if (labelPosition === 'center') {
      labelRotate = 0;
    } else if (rotate === 'radial' || rotate === true) {
      var radialAngle = nx < 0 ? -midAngle + PI : -midAngle;
      labelRotate = radialAngle;
    } else if (rotate === 'tangential' && labelPosition !== 'outside' && labelPosition !== 'outer') {
      var rad = Math.atan2(nx, ny);

      if (rad < 0) {
        rad = PI * 2 + rad;
      }

      var isDown = ny > 0;

      if (isDown) {
        rad = PI + rad;
      }

      labelRotate = rad - PI;
    }

    hasLabelRotate = !!labelRotate;
    label.x = textX;
    label.y = textY;
    label.rotation = labelRotate;
    label.setStyle({
      verticalAlign: 'middle'
    }); // Not sectorShape the inside label

    if (!isLabelInside) {
      var textRect = label.getBoundingRect().clone();
      textRect.applyTransform(label.getComputedTransform()); // Text has a default 1px stroke. Exclude this.

      var margin = (label.style.margin || 0) + 2.1;
      textRect.y -= margin / 2;
      textRect.height += margin;
      labelLayoutList.push({
        label: label,
        labelLine: labelLine,
        position: labelPosition,
        len: labelLineLen,
        len2: labelLineLen2,
        minTurnAngle: labelLineModel.get('minTurnAngle'),
        maxSurfaceAngle: labelLineModel.get('maxSurfaceAngle'),
        surfaceNormal: new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Point"](nx, ny),
        linePoints: linePoints,
        textAlign: textAlign,
        labelDistance: labelDistance,
        labelAlignTo: labelAlignTo,
        edgeDistance: edgeDistance,
        bleedMargin: bleedMargin,
        rect: textRect,
        unconstrainedWidth: textRect.width,
        labelStyleWidth: label.style.width
      });
    } else {
      label.setStyle({
        align: textAlign
      });
      var selectState = label.states.select;

      if (selectState) {
        selectState.x += label.x;
        selectState.y += label.y;
      }
    }

    sector.setTextConfig({
      inside: isLabelInside
    });
  });

  if (!hasLabelRotate && seriesModel.get('avoidLabelOverlap')) {
    avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop);
  }

  for (var i = 0; i < labelLayoutList.length; i++) {
    var layout = labelLayoutList[i];
    var label = layout.label;
    var labelLine = layout.labelLine;
    var notShowLabel = isNaN(label.x) || isNaN(label.y);

    if (label) {
      label.setStyle({
        align: layout.textAlign
      });

      if (notShowLabel) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(label.states, setNotShow);
        label.ignore = true;
      }

      var selectState = label.states.select;

      if (selectState) {
        selectState.x += label.x;
        selectState.y += label.y;
      }
    }

    if (labelLine) {
      var linePoints = layout.linePoints;

      if (notShowLabel || !linePoints) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(labelLine.states, setNotShow);
        labelLine.ignore = true;
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__label_labelGuideHelper_js__["d" /* limitTurnAngle */])(linePoints, layout.minTurnAngle);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__label_labelGuideHelper_js__["e" /* limitSurfaceAngle */])(linePoints, layout.surfaceNormal, layout.maxSurfaceAngle);
        labelLine.setShape({
          points: linePoints
        }); // Set the anchor to the midpoint of sector

        label.__hostTarget.textGuideLineConfig = {
          anchor: new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Point"](linePoints[0][0], linePoints[0][1])
        };
      }
    }
  }
}

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_Series_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_createSeriesDataSimply_js__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__visual_LegendVisualProvider_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_tooltip_tooltipMarkup_js__ = __webpack_require__(48);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







var RadarSeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(RadarSeriesModel, _super);

  function RadarSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = RadarSeriesModel.type;
    _this.hasSymbolVisual = true;
    return _this;
  } // Overwrite


  RadarSeriesModel.prototype.init = function (option) {
    _super.prototype.init.apply(this, arguments); // Enable legend selection for each data item
    // Use a function instead of direct access because data reference may changed


    this.legendVisualProvider = new __WEBPACK_IMPORTED_MODULE_4__visual_LegendVisualProvider_js__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["bind"](this.getData, this), __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["bind"](this.getRawData, this));
  };

  RadarSeriesModel.prototype.getInitialData = function (option, ecModel) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_createSeriesDataSimply_js__["a" /* default */])(this, {
      generateCoord: 'indicator_',
      generateCoordCount: Infinity
    });
  };

  RadarSeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    var data = this.getData();
    var coordSys = this.coordinateSystem;
    var indicatorAxes = coordSys.getIndicatorAxes();
    var name = this.getData().getName(dataIndex);
    var nameToDisplay = name === '' ? this.name : name;
    var markerColor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__component_tooltip_tooltipMarkup_js__["a" /* retrieveVisualColorForTooltipMarker */])(this, dataIndex);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__component_tooltip_tooltipMarkup_js__["b" /* createTooltipMarkup */])('section', {
      header: nameToDisplay,
      sortBlocks: true,
      blocks: __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["map"](indicatorAxes, function (axis) {
        var val = data.get(data.mapDimension(axis.dim), dataIndex);
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__component_tooltip_tooltipMarkup_js__["b" /* createTooltipMarkup */])('nameValue', {
          markerType: 'subItem',
          markerColor: markerColor,
          name: axis.name,
          value: val,
          sortParam: val
        });
      })
    });
  };

  RadarSeriesModel.prototype.getTooltipPosition = function (dataIndex) {
    if (dataIndex != null) {
      var data_1 = this.getData();
      var coordSys = this.coordinateSystem;
      var values = data_1.getValues(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["map"](coordSys.dimensions, function (dim) {
        return data_1.mapDimension(dim);
      }), dataIndex);

      for (var i = 0, len = values.length; i < len; i++) {
        if (!isNaN(values[i])) {
          var indicatorAxes = coordSys.getIndicatorAxes();
          return coordSys.coordToPoint(indicatorAxes[i].dataToCoord(values[i]), i);
        }
      }
    }
  };

  RadarSeriesModel.type = 'series.radar';
  RadarSeriesModel.dependencies = ['radar'];
  RadarSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    colorBy: 'data',
    coordinateSystem: 'radar',
    legendHoverLink: true,
    radarIndex: 0,
    lineStyle: {
      width: 2,
      type: 'solid',
      join: 'round'
    },
    label: {
      position: 'top'
    },
    // areaStyle: {
    // },
    // itemStyle: {}
    symbolSize: 8 // symbolRotate: null

  };
  return RadarSeriesModel;
}(__WEBPACK_IMPORTED_MODULE_1__model_Series_js__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (RadarSeriesModel);

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_symbol_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_zrender_lib_graphic_Image_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__animation_basicTrasition_js__ = __webpack_require__(40);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/










var RadarView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(RadarView, _super);

  function RadarView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = RadarView.type;
    return _this;
  }

  RadarView.prototype.render = function (seriesModel, ecModel, api) {
    var polar = seriesModel.coordinateSystem;
    var group = this.group;
    var data = seriesModel.getData();
    var oldData = this._data;

    function createSymbol(data, idx) {
      var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';

      if (symbolType === 'none') {
        return;
      }

      var symbolSize = __WEBPACK_IMPORTED_MODULE_4__util_symbol_js__["c" /* normalizeSymbolSize */](data.getItemVisual(idx, 'symbolSize'));
      var symbolPath = __WEBPACK_IMPORTED_MODULE_4__util_symbol_js__["a" /* createSymbol */](symbolType, -1, -1, 2, 2);
      var symbolRotate = data.getItemVisual(idx, 'symbolRotate') || 0;
      symbolPath.attr({
        style: {
          strokeNoScale: true
        },
        z2: 100,
        scaleX: symbolSize[0] / 2,
        scaleY: symbolSize[1] / 2,
        rotation: symbolRotate * Math.PI / 180 || 0
      });
      return symbolPath;
    }

    function updateSymbols(oldPoints, newPoints, symbolGroup, data, idx, isInit) {
      // Simply rerender all
      symbolGroup.removeAll();

      for (var i = 0; i < newPoints.length - 1; i++) {
        var symbolPath = createSymbol(data, idx);

        if (symbolPath) {
          symbolPath.__dimIdx = i;

          if (oldPoints[i]) {
            symbolPath.setPosition(oldPoints[i]);
            __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__[isInit ? 'initProps' : 'updateProps'](symbolPath, {
              x: newPoints[i][0],
              y: newPoints[i][1]
            }, seriesModel, idx);
          } else {
            symbolPath.setPosition(newPoints[i]);
          }

          symbolGroup.add(symbolPath);
        }
      }
    }

    function getInitialPoints(points) {
      return __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["map"](points, function (pt) {
        return [polar.cx, polar.cy];
      });
    }

    data.diff(oldData).add(function (idx) {
      var points = data.getItemLayout(idx);

      if (!points) {
        return;
      }

      var polygon = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Polygon"]();
      var polyline = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Polyline"]();
      var target = {
        shape: {
          points: points
        }
      };
      polygon.shape.points = getInitialPoints(points);
      polyline.shape.points = getInitialPoints(points);
      __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["initProps"](polygon, target, seriesModel, idx);
      __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["initProps"](polyline, target, seriesModel, idx);
      var itemGroup = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Group"]();
      var symbolGroup = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Group"]();
      itemGroup.add(polyline);
      itemGroup.add(polygon);
      itemGroup.add(symbolGroup);
      updateSymbols(polyline.shape.points, points, symbolGroup, data, idx, true);
      data.setItemGraphicEl(idx, itemGroup);
    }).update(function (newIdx, oldIdx) {
      var itemGroup = oldData.getItemGraphicEl(oldIdx);
      var polyline = itemGroup.childAt(0);
      var polygon = itemGroup.childAt(1);
      var symbolGroup = itemGroup.childAt(2);
      var target = {
        shape: {
          points: data.getItemLayout(newIdx)
        }
      };

      if (!target.shape.points) {
        return;
      }

      updateSymbols(polyline.shape.points, target.shape.points, symbolGroup, data, newIdx, false);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__animation_basicTrasition_js__["f" /* saveOldStyle */])(polygon);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__animation_basicTrasition_js__["f" /* saveOldStyle */])(polyline);
      __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["updateProps"](polyline, target, seriesModel);
      __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["updateProps"](polygon, target, seriesModel);
      data.setItemGraphicEl(newIdx, itemGroup);
    }).remove(function (idx) {
      group.remove(oldData.getItemGraphicEl(idx));
    }).execute();
    data.eachItemGraphicEl(function (itemGroup, idx) {
      var itemModel = data.getItemModel(idx);
      var polyline = itemGroup.childAt(0);
      var polygon = itemGroup.childAt(1);
      var symbolGroup = itemGroup.childAt(2); // Radar uses the visual encoded from itemStyle.

      var itemStyle = data.getItemVisual(idx, 'style');
      var color = itemStyle.fill;
      group.add(itemGroup);
      polyline.useStyle(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["defaults"](itemModel.getModel('lineStyle').getLineStyle(), {
        fill: 'none',
        stroke: color
      }));
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_states_js__["F" /* setStatesStylesFromModel */])(polyline, itemModel, 'lineStyle');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_states_js__["F" /* setStatesStylesFromModel */])(polygon, itemModel, 'areaStyle');
      var areaStyleModel = itemModel.getModel('areaStyle');
      var polygonIgnore = areaStyleModel.isEmpty() && areaStyleModel.parentModel.isEmpty();
      polygon.ignore = polygonIgnore;
      __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"](['emphasis', 'select', 'blur'], function (stateName) {
        var stateModel = itemModel.getModel([stateName, 'areaStyle']);
        var stateIgnore = stateModel.isEmpty() && stateModel.parentModel.isEmpty(); // Won't be ignore if normal state is not ignore.

        polygon.ensureState(stateName).ignore = stateIgnore && polygonIgnore;
      });
      polygon.useStyle(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["defaults"](areaStyleModel.getAreaStyle(), {
        fill: color,
        opacity: 0.7,
        decal: itemStyle.decal
      }));
      var emphasisModel = itemModel.getModel('emphasis');
      var itemHoverStyle = emphasisModel.getModel('itemStyle').getItemStyle();
      symbolGroup.eachChild(function (symbolPath) {
        if (symbolPath instanceof __WEBPACK_IMPORTED_MODULE_7_zrender_lib_graphic_Image_js__["a" /* default */]) {
          var pathStyle = symbolPath.style;
          symbolPath.useStyle(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["extend"]({
            // TODO other properties like x, y ?
            image: pathStyle.image,
            x: pathStyle.x,
            y: pathStyle.y,
            width: pathStyle.width,
            height: pathStyle.height
          }, itemStyle));
        } else {
          symbolPath.useStyle(itemStyle);
          symbolPath.setColor(color);
          symbolPath.style.strokeNoScale = true;
        }

        var pathEmphasisState = symbolPath.ensureState('emphasis');
        pathEmphasisState.style = __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["clone"](itemHoverStyle);
        var defaultText = data.getStore().get(data.getDimensionIndex(symbolPath.__dimIdx), idx);
        (defaultText == null || isNaN(defaultText)) && (defaultText = '');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__label_labelStyle_js__["e" /* setLabelStyle */])(symbolPath, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__label_labelStyle_js__["f" /* getLabelStatesModels */])(itemModel), {
          labelFetcher: data.hostModel,
          labelDataIndex: idx,
          labelDimIndex: symbolPath.__dimIdx,
          defaultText: defaultText,
          inheritColor: color,
          defaultOpacity: itemStyle.opacity
        });
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_states_js__["G" /* toggleHoverEmphasis */])(itemGroup, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    });
    this._data = data;
  };

  RadarView.prototype.remove = function () {
    this.group.removeAll();
    this._data = null;
  };

  RadarView.type = 'radar';
  return RadarView;
}(__WEBPACK_IMPORTED_MODULE_5__view_Chart_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (RadarView);

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = radarBackwardCompat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// @ts-nocheck
// Backward compat for radar chart in 2

function radarBackwardCompat(option) {
  var polarOptArr = option.polar;

  if (polarOptArr) {
    if (!__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](polarOptArr)) {
      polarOptArr = [polarOptArr];
    }

    var polarNotRadar_1 = [];
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](polarOptArr, function (polarOpt, idx) {
      if (polarOpt.indicator) {
        if (polarOpt.type && !polarOpt.shape) {
          polarOpt.shape = polarOpt.type;
        }

        option.radar = option.radar || [];

        if (!__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](option.radar)) {
          option.radar = [option.radar];
        }

        option.radar.push(polarOpt);
      } else {
        polarNotRadar_1.push(polarOpt);
      }
    });
    option.polar = polarNotRadar_1;
  }

  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](option.series, function (seriesOpt) {
    if (seriesOpt && seriesOpt.type === 'radar' && seriesOpt.polarIndex) {
      seriesOpt.radarIndex = seriesOpt.polarIndex;
    }
  });
}

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extension_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__radar_radarLayout_js__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__processor_dataFilter_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__radar_backwardCompat_js__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RadarView_js__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RadarSeries_js__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_radar_install_js__ = __webpack_require__(475);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







function install(registers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_6__component_radar_install_js__["a" /* install */]);
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_4__RadarView_js__["a" /* default */]);
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_5__RadarSeries_js__["a" /* default */]);
  registers.registerLayout(__WEBPACK_IMPORTED_MODULE_1__radar_radarLayout_js__["a" /* default */]);
  registers.registerProcessor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__processor_dataFilter_js__["a" /* default */])('radar'));
  registers.registerPreprocessor(__WEBPACK_IMPORTED_MODULE_3__radar_backwardCompat_js__["a" /* default */]);
}

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = radarLayout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

function radarLayout(ecModel) {
  ecModel.eachSeriesByType('radar', function (seriesModel) {
    var data = seriesModel.getData();
    var points = [];
    var coordSys = seriesModel.coordinateSystem;

    if (!coordSys) {
      return;
    }

    var axes = coordSys.getIndicatorAxes();
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](axes, function (axis, axisIndex) {
      data.each(data.mapDimension(axes[axisIndex].dim), function (val, dataIndex) {
        points[dataIndex] = points[dataIndex] || [];
        var point = coordSys.dataToPoint(val, axisIndex);
        points[dataIndex][axisIndex] = isValidPoint(point) ? point : getValueMissingPoint(coordSys);
      });
    }); // Close polygon

    data.each(function (idx) {
      // TODO
      // Is it appropriate to connect to the next data when some data is missing?
      // Or, should trade it like `connectNull` in line chart?
      var firstPoint = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["find"](points[idx], function (point) {
        return isValidPoint(point);
      }) || getValueMissingPoint(coordSys); // Copy the first actual point to the end of the array

      points[idx].push(firstPoint.slice());
      data.setItemLayout(idx, points[idx]);
    });
  });
}

function isValidPoint(point) {
  return !isNaN(point[0]) && !isNaN(point[1]);
}

function getValueMissingPoint(coordSys) {
  // It is error-prone to input [NaN, NaN] into polygon, polygon.
  // (probably cause problem when refreshing or animating)
  return [coordSys.cx, coordSys.cy];
}

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_Series_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_createGraphFromNodeEdge_js__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_Model_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component_tooltip_tooltipMarkup_js__ = __webpack_require__(48);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






var SankeySeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(SankeySeriesModel, _super);

  function SankeySeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SankeySeriesModel.type;
    return _this;
  }
  /**
   * Init a graph data structure from data in option series
   */


  SankeySeriesModel.prototype.getInitialData = function (option, ecModel) {
    var links = option.edges || option.links;
    var nodes = option.data || option.nodes;
    var levels = option.levels;
    this.levelModels = [];
    var levelModels = this.levelModels;

    for (var i = 0; i < levels.length; i++) {
      if (levels[i].depth != null && levels[i].depth >= 0) {
        levelModels[levels[i].depth] = new __WEBPACK_IMPORTED_MODULE_3__model_Model_js__["a" /* default */](levels[i], this, ecModel);
      } else {
        if (true) {
          throw new Error('levels[i].depth is mandatory and should be natural number');
        }
      }
    }

    if (nodes && links) {
      var graph = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_createGraphFromNodeEdge_js__["a" /* default */])(nodes, links, this, true, beforeLink);
      return graph.data;
    }

    function beforeLink(nodeData, edgeData) {
      nodeData.wrapMethod('getItemModel', function (model, idx) {
        var seriesModel = model.parentModel;
        var layout = seriesModel.getData().getItemLayout(idx);

        if (layout) {
          var nodeDepth = layout.depth;
          var levelModel = seriesModel.levelModels[nodeDepth];

          if (levelModel) {
            model.parentModel = levelModel;
          }
        }

        return model;
      });
      edgeData.wrapMethod('getItemModel', function (model, idx) {
        var seriesModel = model.parentModel;
        var edge = seriesModel.getGraph().getEdgeByIndex(idx);
        var layout = edge.node1.getLayout();

        if (layout) {
          var depth = layout.depth;
          var levelModel = seriesModel.levelModels[depth];

          if (levelModel) {
            model.parentModel = levelModel;
          }
        }

        return model;
      });
    }
  };

  SankeySeriesModel.prototype.setNodePosition = function (dataIndex, localPosition) {
    var nodes = this.option.data || this.option.nodes;
    var dataItem = nodes[dataIndex];
    dataItem.localX = localPosition[0];
    dataItem.localY = localPosition[1];
  };
  /**
   * Return the graphic data structure
   *
   * @return graphic data structure
   */


  SankeySeriesModel.prototype.getGraph = function () {
    return this.getData().graph;
  };
  /**
   * Get edge data of graphic data structure
   *
   * @return data structure of list
   */


  SankeySeriesModel.prototype.getEdgeData = function () {
    return this.getGraph().edgeData;
  };

  SankeySeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    function noValue(val) {
      return isNaN(val) || val == null;
    } // dataType === 'node' or empty do not show tooltip by default


    if (dataType === 'edge') {
      var params = this.getDataParams(dataIndex, dataType);
      var rawDataOpt = params.data;
      var edgeValue = params.value;
      var edgeName = rawDataOpt.source + ' -- ' + rawDataOpt.target;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__component_tooltip_tooltipMarkup_js__["b" /* createTooltipMarkup */])('nameValue', {
        name: edgeName,
        value: edgeValue,
        noValue: noValue(edgeValue)
      });
    } // dataType === 'node'
    else {
        var node = this.getGraph().getNodeByIndex(dataIndex);
        var value = node.getLayout().value;
        var name_1 = this.getDataParams(dataIndex, dataType).data.name;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__component_tooltip_tooltipMarkup_js__["b" /* createTooltipMarkup */])('nameValue', {
          name: name_1 != null ? name_1 + '' : null,
          value: value,
          noValue: noValue(value)
        });
      }
  };

  SankeySeriesModel.prototype.optionUpdated = function () {}; // Override Series.getDataParams()


  SankeySeriesModel.prototype.getDataParams = function (dataIndex, dataType) {
    var params = _super.prototype.getDataParams.call(this, dataIndex, dataType);

    if (params.value == null && dataType === 'node') {
      var node = this.getGraph().getNodeByIndex(dataIndex);
      var nodeValue = node.getLayout().value;
      params.value = nodeValue;
    }

    return params;
  };

  SankeySeriesModel.type = 'series.sankey';
  SankeySeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    coordinateSystem: 'view',
    left: '5%',
    top: '5%',
    right: '20%',
    bottom: '5%',
    orient: 'horizontal',
    nodeWidth: 20,
    nodeGap: 8,
    draggable: true,
    layoutIterations: 32,
    label: {
      show: true,
      position: 'right',
      fontSize: 12
    },
    levels: [],
    nodeAlign: 'justify',
    lineStyle: {
      color: '#314656',
      opacity: 0.2,
      curveness: 0.5
    },
    emphasis: {
      label: {
        show: true
      },
      lineStyle: {
        opacity: 0.5
      }
    },
    select: {
      itemStyle: {
        borderColor: '#212121'
      }
    },
    animationEasing: 'linear',
    animationDuration: 1000
  };
  return SankeySeriesModel;
}(__WEBPACK_IMPORTED_MODULE_1__model_Series_js__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SankeySeriesModel);

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/








var SankeyPathShape =
/** @class */
function () {
  function SankeyPathShape() {
    this.x1 = 0;
    this.y1 = 0;
    this.x2 = 0;
    this.y2 = 0;
    this.cpx1 = 0;
    this.cpy1 = 0;
    this.cpx2 = 0;
    this.cpy2 = 0;
    this.extent = 0;
  }

  return SankeyPathShape;
}();

var SankeyPath =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(SankeyPath, _super);

  function SankeyPath(opts) {
    return _super.call(this, opts) || this;
  }

  SankeyPath.prototype.getDefaultShape = function () {
    return new SankeyPathShape();
  };

  SankeyPath.prototype.buildPath = function (ctx, shape) {
    var extent = shape.extent;
    ctx.moveTo(shape.x1, shape.y1);
    ctx.bezierCurveTo(shape.cpx1, shape.cpy1, shape.cpx2, shape.cpy2, shape.x2, shape.y2);

    if (shape.orient === 'vertical') {
      ctx.lineTo(shape.x2 + extent, shape.y2);
      ctx.bezierCurveTo(shape.cpx2 + extent, shape.cpy2, shape.cpx1 + extent, shape.cpy1, shape.x1 + extent, shape.y1);
    } else {
      ctx.lineTo(shape.x2, shape.y2 + extent);
      ctx.bezierCurveTo(shape.cpx2, shape.cpy2 + extent, shape.cpx1, shape.cpy1 + extent, shape.x1, shape.y1 + extent);
    }

    ctx.closePath();
  };

  SankeyPath.prototype.highlight = function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_states_js__["j" /* enterEmphasis */])(this);
  };

  SankeyPath.prototype.downplay = function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_states_js__["k" /* leaveEmphasis */])(this);
  };

  return SankeyPath;
}(__WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Path"]);

var SankeyView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(SankeyView, _super);

  function SankeyView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SankeyView.type;
    _this._focusAdjacencyDisabled = false;
    return _this;
  }

  SankeyView.prototype.render = function (seriesModel, ecModel, api) {
    var sankeyView = this;
    var graph = seriesModel.getGraph();
    var group = this.group;
    var layoutInfo = seriesModel.layoutInfo; // view width

    var width = layoutInfo.width; // view height

    var height = layoutInfo.height;
    var nodeData = seriesModel.getData();
    var edgeData = seriesModel.getData('edge');
    var orient = seriesModel.get('orient');
    this._model = seriesModel;
    group.removeAll();
    group.x = layoutInfo.x;
    group.y = layoutInfo.y; // generate a bezire Curve for each edge

    graph.eachEdge(function (edge) {
      var curve = new SankeyPath();
      var ecData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_innerStore_js__["a" /* getECData */])(curve);
      ecData.dataIndex = edge.dataIndex;
      ecData.seriesIndex = seriesModel.seriesIndex;
      ecData.dataType = 'edge';
      var edgeModel = edge.getModel();
      var lineStyleModel = edgeModel.getModel('lineStyle');
      var curvature = lineStyleModel.get('curveness');
      var n1Layout = edge.node1.getLayout();
      var node1Model = edge.node1.getModel();
      var dragX1 = node1Model.get('localX');
      var dragY1 = node1Model.get('localY');
      var n2Layout = edge.node2.getLayout();
      var node2Model = edge.node2.getModel();
      var dragX2 = node2Model.get('localX');
      var dragY2 = node2Model.get('localY');
      var edgeLayout = edge.getLayout();
      var x1;
      var y1;
      var x2;
      var y2;
      var cpx1;
      var cpy1;
      var cpx2;
      var cpy2;
      curve.shape.extent = Math.max(1, edgeLayout.dy);
      curve.shape.orient = orient;

      if (orient === 'vertical') {
        x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + edgeLayout.sy;
        y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + n1Layout.dy;
        x2 = (dragX2 != null ? dragX2 * width : n2Layout.x) + edgeLayout.ty;
        y2 = dragY2 != null ? dragY2 * height : n2Layout.y;
        cpx1 = x1;
        cpy1 = y1 * (1 - curvature) + y2 * curvature;
        cpx2 = x2;
        cpy2 = y1 * curvature + y2 * (1 - curvature);
      } else {
        x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + n1Layout.dx;
        y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + edgeLayout.sy;
        x2 = dragX2 != null ? dragX2 * width : n2Layout.x;
        y2 = (dragY2 != null ? dragY2 * height : n2Layout.y) + edgeLayout.ty;
        cpx1 = x1 * (1 - curvature) + x2 * curvature;
        cpy1 = y1;
        cpx2 = x1 * curvature + x2 * (1 - curvature);
        cpy2 = y2;
      }

      curve.setShape({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        cpx1: cpx1,
        cpy1: cpy1,
        cpx2: cpx2,
        cpy2: cpy2
      });
      curve.useStyle(lineStyleModel.getItemStyle()); // Special color, use source node color or target node color

      switch (curve.style.fill) {
        case 'source':
          curve.style.fill = edge.node1.getVisual('color');
          curve.style.decal = edge.node1.getVisual('style').decal;
          break;

        case 'target':
          curve.style.fill = edge.node2.getVisual('color');
          curve.style.decal = edge.node2.getVisual('style').decal;
          break;

        case 'gradient':
          var sourceColor = edge.node1.getVisual('color');
          var targetColor = edge.node2.getVisual('color');

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["isString"])(sourceColor) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["isString"])(targetColor)) {
            curve.style.fill = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["LinearGradient"](0, 0, +(orient === 'horizontal'), +(orient === 'vertical'), [{
              color: sourceColor,
              offset: 0
            }, {
              color: targetColor,
              offset: 1
            }]);
          }

      }

      var emphasisModel = edgeModel.getModel('emphasis');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_states_js__["F" /* setStatesStylesFromModel */])(curve, edgeModel, 'lineStyle', function (model) {
        return model.getItemStyle();
      });
      group.add(curve);
      edgeData.setItemGraphicEl(edge.dataIndex, curve);
      var focus = emphasisModel.get('focus');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_states_js__["G" /* toggleHoverEmphasis */])(curve, focus === 'adjacency' ? edge.getAdjacentDataIndices() : focus, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_innerStore_js__["a" /* getECData */])(curve).dataType = 'edge';
    }); // Generate a rect for each node

    graph.eachNode(function (node) {
      var layout = node.getLayout();
      var itemModel = node.getModel();
      var dragX = itemModel.get('localX');
      var dragY = itemModel.get('localY');
      var emphasisModel = itemModel.getModel('emphasis');
      var rect = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Rect"]({
        shape: {
          x: dragX != null ? dragX * width : layout.x,
          y: dragY != null ? dragY * height : layout.y,
          width: layout.dx,
          height: layout.dy
        },
        style: itemModel.getModel('itemStyle').getItemStyle(),
        z2: 10
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["e" /* setLabelStyle */])(rect, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["f" /* getLabelStatesModels */])(itemModel), {
        labelFetcher: seriesModel,
        labelDataIndex: node.dataIndex,
        defaultText: node.id
      });
      rect.disableLabelAnimation = true;
      rect.setStyle('fill', node.getVisual('color'));
      rect.setStyle('decal', node.getVisual('style').decal);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_states_js__["F" /* setStatesStylesFromModel */])(rect, itemModel);
      group.add(rect);
      nodeData.setItemGraphicEl(node.dataIndex, rect);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_innerStore_js__["a" /* getECData */])(rect).dataType = 'node';
      var focus = emphasisModel.get('focus');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_states_js__["G" /* toggleHoverEmphasis */])(rect, focus === 'adjacency' ? node.getAdjacentDataIndices() : focus, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    });
    nodeData.eachItemGraphicEl(function (el, dataIndex) {
      var itemModel = nodeData.getItemModel(dataIndex);

      if (itemModel.get('draggable')) {
        el.drift = function (dx, dy) {
          sankeyView._focusAdjacencyDisabled = true;
          this.shape.x += dx;
          this.shape.y += dy;
          this.dirty();
          api.dispatchAction({
            type: 'dragNode',
            seriesId: seriesModel.id,
            dataIndex: nodeData.getRawIndex(dataIndex),
            localX: this.shape.x / width,
            localY: this.shape.y / height
          });
        };

        el.ondragend = function () {
          sankeyView._focusAdjacencyDisabled = false;
        };

        el.draggable = true;
        el.cursor = 'move';
      }
    });

    if (!this._data && seriesModel.isAnimationEnabled()) {
      group.setClipPath(createGridClipShape(group.getBoundingRect(), seriesModel, function () {
        group.removeClipPath();
      }));
    }

    this._data = seriesModel.getData();
  };

  SankeyView.prototype.dispose = function () {};

  SankeyView.type = 'sankey';
  return SankeyView;
}(__WEBPACK_IMPORTED_MODULE_3__view_Chart_js__["a" /* default */]); // Add animation to the view


function createGridClipShape(rect, seriesModel, cb) {
  var rectEl = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Rect"]({
    shape: {
      x: rect.x - 10,
      y: rect.y - 10,
      width: 0,
      height: rect.height + 20
    }
  });
  __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["initProps"](rectEl, {
    shape: {
      width: rect.width + 20
    }
  }, seriesModel, cb);
  return rectEl;
}

/* harmony default export */ __webpack_exports__["a"] = (SankeyView);

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SankeyView_js__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SankeySeries_js__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sankeyLayout_js__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sankeyVisual_js__ = __webpack_require__(1166);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




function install(registers) {
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_0__SankeyView_js__["a" /* default */]);
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_1__SankeySeries_js__["a" /* default */]);
  registers.registerLayout(__WEBPACK_IMPORTED_MODULE_2__sankeyLayout_js__["a" /* default */]);
  registers.registerVisual(__WEBPACK_IMPORTED_MODULE_3__sankeyVisual_js__["a" /* default */]);
  registers.registerAction({
    type: 'dragNode',
    event: 'dragnode',
    // here can only use 'update' now, other value is not support in echarts.
    update: 'update'
  }, function (payload, ecModel) {
    ecModel.eachComponent({
      mainType: 'series',
      subType: 'sankey',
      query: payload
    }, function (seriesModel) {
      seriesModel.setNodePosition(payload.dataIndex, [payload.localX, payload.localY]);
    });
  });
}

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sankeyLayout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



function sankeyLayout(ecModel, api) {
  ecModel.eachSeriesByType('sankey', function (seriesModel) {
    var nodeWidth = seriesModel.get('nodeWidth');
    var nodeGap = seriesModel.get('nodeGap');
    var layoutInfo = getViewRect(seriesModel, api);
    seriesModel.layoutInfo = layoutInfo;
    var width = layoutInfo.width;
    var height = layoutInfo.height;
    var graph = seriesModel.getGraph();
    var nodes = graph.nodes;
    var edges = graph.edges;
    computeNodeValues(nodes);
    var filteredNodes = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["filter"](nodes, function (node) {
      return node.getLayout().value === 0;
    });
    var iterations = filteredNodes.length !== 0 ? 0 : seriesModel.get('layoutIterations');
    var orient = seriesModel.get('orient');
    var nodeAlign = seriesModel.get('nodeAlign');
    layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign);
  });
}
/**
 * Get the layout position of the whole view
 */

function getViewRect(seriesModel, api) {
  return __WEBPACK_IMPORTED_MODULE_0__util_layout_js__["f" /* getLayoutRect */](seriesModel.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  });
}

function layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign) {
  computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign);
  computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient);
  computeEdgeDepths(nodes, orient);
}
/**
 * Compute the value of each node by summing the associated edge's value
 */


function computeNodeValues(nodes) {
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](nodes, function (node) {
    var value1 = sum(node.outEdges, getEdgeValue);
    var value2 = sum(node.inEdges, getEdgeValue);
    var nodeRawValue = node.getValue() || 0;
    var value = Math.max(value1, value2, nodeRawValue);
    node.setLayout({
      value: value
    }, true);
  });
}
/**
 * Compute the x-position for each node.
 *
 * Here we use Kahn algorithm to detect cycle when we traverse
 * the node to computer the initial x position.
 */


function computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign) {
  // Used to mark whether the edge is deleted. if it is deleted,
  // the value is 0, otherwise it is 1.
  var remainEdges = []; // Storage each node's indegree.

  var indegreeArr = []; //Used to storage the node with indegree is equal to 0.

  var zeroIndegrees = [];
  var nextTargetNode = [];
  var x = 0; // let kx = 0;

  for (var i = 0; i < edges.length; i++) {
    remainEdges[i] = 1;
  }

  for (var i = 0; i < nodes.length; i++) {
    indegreeArr[i] = nodes[i].inEdges.length;

    if (indegreeArr[i] === 0) {
      zeroIndegrees.push(nodes[i]);
    }
  }

  var maxNodeDepth = -1; // Traversing nodes using topological sorting to calculate the
  // horizontal(if orient === 'horizontal') or vertical(if orient === 'vertical')
  // position of the nodes.

  while (zeroIndegrees.length) {
    for (var idx = 0; idx < zeroIndegrees.length; idx++) {
      var node = zeroIndegrees[idx];
      var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
      var isItemDepth = item.depth != null && item.depth >= 0;

      if (isItemDepth && item.depth > maxNodeDepth) {
        maxNodeDepth = item.depth;
      }

      node.setLayout({
        depth: isItemDepth ? item.depth : x
      }, true);
      orient === 'vertical' ? node.setLayout({
        dy: nodeWidth
      }, true) : node.setLayout({
        dx: nodeWidth
      }, true);

      for (var edgeIdx = 0; edgeIdx < node.outEdges.length; edgeIdx++) {
        var edge = node.outEdges[edgeIdx];
        var indexEdge = edges.indexOf(edge);
        remainEdges[indexEdge] = 0;
        var targetNode = edge.node2;
        var nodeIndex = nodes.indexOf(targetNode);

        if (--indegreeArr[nodeIndex] === 0 && nextTargetNode.indexOf(targetNode) < 0) {
          nextTargetNode.push(targetNode);
        }
      }
    }

    ++x;
    zeroIndegrees = nextTargetNode;
    nextTargetNode = [];
  }

  for (var i = 0; i < remainEdges.length; i++) {
    if (remainEdges[i] === 1) {
      throw new Error('Sankey is a DAG, the original data has cycle!');
    }
  }

  var maxDepth = maxNodeDepth > x - 1 ? maxNodeDepth : x - 1;

  if (nodeAlign && nodeAlign !== 'left') {
    adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth);
  }

  var kx = orient === 'vertical' ? (height - nodeWidth) / maxDepth : (width - nodeWidth) / maxDepth;
  scaleNodeBreadths(nodes, kx, orient);
}

function isNodeDepth(node) {
  var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
  return item.depth != null && item.depth >= 0;
}

function adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth) {
  if (nodeAlign === 'right') {
    var nextSourceNode = [];
    var remainNodes = nodes;
    var nodeHeight = 0;

    while (remainNodes.length) {
      for (var i = 0; i < remainNodes.length; i++) {
        var node = remainNodes[i];
        node.setLayout({
          skNodeHeight: nodeHeight
        }, true);

        for (var j = 0; j < node.inEdges.length; j++) {
          var edge = node.inEdges[j];

          if (nextSourceNode.indexOf(edge.node1) < 0) {
            nextSourceNode.push(edge.node1);
          }
        }
      }

      remainNodes = nextSourceNode;
      nextSourceNode = [];
      ++nodeHeight;
    }

    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](nodes, function (node) {
      if (!isNodeDepth(node)) {
        node.setLayout({
          depth: Math.max(0, maxDepth - node.getLayout().skNodeHeight)
        }, true);
      }
    });
  } else if (nodeAlign === 'justify') {
    moveSinksRight(nodes, maxDepth);
  }
}
/**
 * All the node without outEgdes are assigned maximum x-position and
 *     be aligned in the last column.
 *
 * @param nodes.  node of sankey view.
 * @param maxDepth.  use to assign to node without outEdges as x-position.
 */


function moveSinksRight(nodes, maxDepth) {
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](nodes, function (node) {
    if (!isNodeDepth(node) && !node.outEdges.length) {
      node.setLayout({
        depth: maxDepth
      }, true);
    }
  });
}
/**
 * Scale node x-position to the width
 *
 * @param nodes  node of sankey view
 * @param kx   multiple used to scale nodes
 */


function scaleNodeBreadths(nodes, kx, orient) {
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](nodes, function (node) {
    var nodeDepth = node.getLayout().depth * kx;
    orient === 'vertical' ? node.setLayout({
      y: nodeDepth
    }, true) : node.setLayout({
      x: nodeDepth
    }, true);
  });
}
/**
 * Using Gauss-Seidel iterations method to compute the node depth(y-position)
 *
 * @param nodes  node of sankey view
 * @param edges  edge of sankey view
 * @param height  the whole height of the area to draw the view
 * @param nodeGap  the vertical distance between two nodes
 *     in the same column.
 * @param iterations  the number of iterations for the algorithm
 */


function computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient) {
  var nodesByBreadth = prepareNodesByBreadth(nodes, orient);
  initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient);
  resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);

  for (var alpha = 1; iterations > 0; iterations--) {
    // 0.99 is a experience parameter, ensure that each iterations of
    // changes as small as possible.
    alpha *= 0.99;
    relaxRightToLeft(nodesByBreadth, alpha, orient);
    resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
    relaxLeftToRight(nodesByBreadth, alpha, orient);
    resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
  }
}

function prepareNodesByBreadth(nodes, orient) {
  var nodesByBreadth = [];
  var keyAttr = orient === 'vertical' ? 'y' : 'x';
  var groupResult = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_model_js__["x" /* groupData */])(nodes, function (node) {
    return node.getLayout()[keyAttr];
  });
  groupResult.keys.sort(function (a, b) {
    return a - b;
  });
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](groupResult.keys, function (key) {
    nodesByBreadth.push(groupResult.buckets.get(key));
  });
  return nodesByBreadth;
}
/**
 * Compute the original y-position for each node
 */


function initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient) {
  var minKy = Infinity;
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](nodesByBreadth, function (nodes) {
    var n = nodes.length;
    var sum = 0;
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](nodes, function (node) {
      sum += node.getLayout().value;
    });
    var ky = orient === 'vertical' ? (width - (n - 1) * nodeGap) / sum : (height - (n - 1) * nodeGap) / sum;

    if (ky < minKy) {
      minKy = ky;
    }
  });
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](nodesByBreadth, function (nodes) {
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](nodes, function (node, i) {
      var nodeDy = node.getLayout().value * minKy;

      if (orient === 'vertical') {
        node.setLayout({
          x: i
        }, true);
        node.setLayout({
          dx: nodeDy
        }, true);
      } else {
        node.setLayout({
          y: i
        }, true);
        node.setLayout({
          dy: nodeDy
        }, true);
      }
    });
  });
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](edges, function (edge) {
    var edgeDy = +edge.getValue() * minKy;
    edge.setLayout({
      dy: edgeDy
    }, true);
  });
}
/**
 * Resolve the collision of initialized depth (y-position)
 */


function resolveCollisions(nodesByBreadth, nodeGap, height, width, orient) {
  var keyAttr = orient === 'vertical' ? 'x' : 'y';
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](nodesByBreadth, function (nodes) {
    nodes.sort(function (a, b) {
      return a.getLayout()[keyAttr] - b.getLayout()[keyAttr];
    });
    var nodeX;
    var node;
    var dy;
    var y0 = 0;
    var n = nodes.length;
    var nodeDyAttr = orient === 'vertical' ? 'dx' : 'dy';

    for (var i = 0; i < n; i++) {
      node = nodes[i];
      dy = y0 - node.getLayout()[keyAttr];

      if (dy > 0) {
        nodeX = node.getLayout()[keyAttr] + dy;
        orient === 'vertical' ? node.setLayout({
          x: nodeX
        }, true) : node.setLayout({
          y: nodeX
        }, true);
      }

      y0 = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap;
    }

    var viewWidth = orient === 'vertical' ? width : height; // If the bottommost node goes outside the bounds, push it back up

    dy = y0 - nodeGap - viewWidth;

    if (dy > 0) {
      nodeX = node.getLayout()[keyAttr] - dy;
      orient === 'vertical' ? node.setLayout({
        x: nodeX
      }, true) : node.setLayout({
        y: nodeX
      }, true);
      y0 = nodeX;

      for (var i = n - 2; i >= 0; --i) {
        node = nodes[i];
        dy = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap - y0;

        if (dy > 0) {
          nodeX = node.getLayout()[keyAttr] - dy;
          orient === 'vertical' ? node.setLayout({
            x: nodeX
          }, true) : node.setLayout({
            y: nodeX
          }, true);
        }

        y0 = node.getLayout()[keyAttr];
      }
    }
  });
}
/**
 * Change the y-position of the nodes, except most the right side nodes
 * @param nodesByBreadth
 * @param alpha  parameter used to adjust the nodes y-position
 */


function relaxRightToLeft(nodesByBreadth, alpha, orient) {
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](nodesByBreadth.slice().reverse(), function (nodes) {
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](nodes, function (node) {
      if (node.outEdges.length) {
        var y = sum(node.outEdges, weightedTarget, orient) / sum(node.outEdges, getEdgeValue);

        if (isNaN(y)) {
          var len = node.outEdges.length;
          y = len ? sum(node.outEdges, centerTarget, orient) / len : 0;
        }

        if (orient === 'vertical') {
          var nodeX = node.getLayout().x + (y - center(node, orient)) * alpha;
          node.setLayout({
            x: nodeX
          }, true);
        } else {
          var nodeY = node.getLayout().y + (y - center(node, orient)) * alpha;
          node.setLayout({
            y: nodeY
          }, true);
        }
      }
    });
  });
}

function weightedTarget(edge, orient) {
  return center(edge.node2, orient) * edge.getValue();
}

function centerTarget(edge, orient) {
  return center(edge.node2, orient);
}

function weightedSource(edge, orient) {
  return center(edge.node1, orient) * edge.getValue();
}

function centerSource(edge, orient) {
  return center(edge.node1, orient);
}

function center(node, orient) {
  return orient === 'vertical' ? node.getLayout().x + node.getLayout().dx / 2 : node.getLayout().y + node.getLayout().dy / 2;
}

function getEdgeValue(edge) {
  return edge.getValue();
}

function sum(array, cb, orient) {
  var sum = 0;
  var len = array.length;
  var i = -1;

  while (++i < len) {
    var value = +cb(array[i], orient);

    if (!isNaN(value)) {
      sum += value;
    }
  }

  return sum;
}
/**
 * Change the y-position of the nodes, except most the left side nodes
 */


function relaxLeftToRight(nodesByBreadth, alpha, orient) {
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](nodesByBreadth, function (nodes) {
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](nodes, function (node) {
      if (node.inEdges.length) {
        var y = sum(node.inEdges, weightedSource, orient) / sum(node.inEdges, getEdgeValue);

        if (isNaN(y)) {
          var len = node.inEdges.length;
          y = len ? sum(node.inEdges, centerSource, orient) / len : 0;
        }

        if (orient === 'vertical') {
          var nodeX = node.getLayout().x + (y - center(node, orient)) * alpha;
          node.setLayout({
            x: nodeX
          }, true);
        } else {
          var nodeY = node.getLayout().y + (y - center(node, orient)) * alpha;
          node.setLayout({
            y: nodeY
          }, true);
        }
      }
    });
  });
}
/**
 * Compute the depth(y-position) of each edge
 */


function computeEdgeDepths(nodes, orient) {
  var keyAttr = orient === 'vertical' ? 'x' : 'y';
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](nodes, function (node) {
    node.outEdges.sort(function (a, b) {
      return a.node2.getLayout()[keyAttr] - b.node2.getLayout()[keyAttr];
    });
    node.inEdges.sort(function (a, b) {
      return a.node1.getLayout()[keyAttr] - b.node1.getLayout()[keyAttr];
    });
  });
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](nodes, function (node) {
    var sy = 0;
    var ty = 0;
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](node.outEdges, function (edge) {
      edge.setLayout({
        sy: sy
      }, true);
      sy += edge.getLayout().dy;
    });
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](node.inEdges, function (edge) {
      edge.setLayout({
        ty: ty
      }, true);
      ty += edge.getLayout().dy;
    });
  });
}

/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sankeyVisual;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__visual_VisualMapping_js__ = __webpack_require__(136);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


function sankeyVisual(ecModel) {
  ecModel.eachSeriesByType('sankey', function (seriesModel) {
    var graph = seriesModel.getGraph();
    var nodes = graph.nodes;

    if (nodes.length) {
      var minValue_1 = Infinity;
      var maxValue_1 = -Infinity;
      __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](nodes, function (node) {
        var nodeValue = node.getLayout().value;

        if (nodeValue < minValue_1) {
          minValue_1 = nodeValue;
        }

        if (nodeValue > maxValue_1) {
          maxValue_1 = nodeValue;
        }
      });
      __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](nodes, function (node) {
        var mapping = new __WEBPACK_IMPORTED_MODULE_1__visual_VisualMapping_js__["a" /* default */]({
          type: 'color',
          mappingMethod: 'linear',
          dataExtent: [minValue_1, maxValue_1],
          visual: seriesModel.get('color')
        });
        var mapValueToColor = mapping.mapValueToVisual(node.getLayout().value);
        var customColor = node.getModel().get(['itemStyle', 'color']);

        if (customColor != null) {
          node.setVisual('color', customColor);
          node.setVisual('style', {
            fill: customColor
          });
        } else {
          node.setVisual('color', mapValueToColor);
          node.setVisual('style', {
            fill: mapValueToColor
          });
        }
      });
    }
  });
}

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_createSeriesData_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_Series_js__ = __webpack_require__(26);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var ScatterSeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ScatterSeriesModel, _super);

  function ScatterSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ScatterSeriesModel.type;
    _this.hasSymbolVisual = true;
    return _this;
  }

  ScatterSeriesModel.prototype.getInitialData = function (option, ecModel) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper_createSeriesData_js__["a" /* default */])(null, this, {
      useEncodeDefaulter: true
    });
  };

  ScatterSeriesModel.prototype.getProgressive = function () {
    var progressive = this.option.progressive;

    if (progressive == null) {
      // PENDING
      return this.option.large ? 5e3 : this.get('progressive');
    }

    return progressive;
  };

  ScatterSeriesModel.prototype.getProgressiveThreshold = function () {
    var progressiveThreshold = this.option.progressiveThreshold;

    if (progressiveThreshold == null) {
      // PENDING
      return this.option.large ? 1e4 : this.get('progressiveThreshold');
    }

    return progressiveThreshold;
  };

  ScatterSeriesModel.prototype.brushSelector = function (dataIndex, data, selectors) {
    return selectors.point(data.getItemLayout(dataIndex));
  };

  ScatterSeriesModel.prototype.getZLevelKey = function () {
    // Each progressive series has individual key.
    return this.getData().count() > this.getProgressiveThreshold() ? this.id : '';
  };

  ScatterSeriesModel.type = 'series.scatter';
  ScatterSeriesModel.dependencies = ['grid', 'polar', 'geo', 'singleAxis', 'calendar'];
  ScatterSeriesModel.defaultOption = {
    coordinateSystem: 'cartesian2d',
    // zlevel: 0,
    z: 2,
    legendHoverLink: true,
    symbolSize: 10,
    // symbolRotate: null,  // 图形旋转控制
    large: false,
    // Available when large is true
    largeThreshold: 2000,
    // cursor: null,
    itemStyle: {
      opacity: 0.8 // color: 各异

    },
    emphasis: {
      scale: true
    },
    // If clip the overflow graphics
    // Works on cartesian / polar series
    clip: true,
    select: {
      itemStyle: {
        borderColor: '#212121'
      }
    },
    universalTransition: {
      divideShape: 'clone'
    } // progressive: null

  };
  return ScatterSeriesModel;
}(__WEBPACK_IMPORTED_MODULE_2__model_Series_js__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ScatterSeriesModel);

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_SymbolDraw_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_LargeSymbolDraw_js__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_points_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_Chart_js__ = __webpack_require__(27);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






var ScatterView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ScatterView, _super);

  function ScatterView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ScatterView.type;
    return _this;
  }

  ScatterView.prototype.render = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();

    var symbolDraw = this._updateSymbolDraw(data, seriesModel);

    symbolDraw.updateData(data, {
      // TODO
      // If this parameter should be a shape or a bounding volume
      // shape will be more general.
      // But bounding volume like bounding rect will be much faster in the contain calculation
      clipShape: this._getClipShape(seriesModel)
    });
    this._finished = true;
  };

  ScatterView.prototype.incrementalPrepareRender = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();

    var symbolDraw = this._updateSymbolDraw(data, seriesModel);

    symbolDraw.incrementalPrepareUpdate(data);
    this._finished = false;
  };

  ScatterView.prototype.incrementalRender = function (taskParams, seriesModel, ecModel) {
    this._symbolDraw.incrementalUpdate(taskParams, seriesModel.getData(), {
      clipShape: this._getClipShape(seriesModel)
    });

    this._finished = taskParams.end === seriesModel.getData().count();
  };

  ScatterView.prototype.updateTransform = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData(); // Must mark group dirty and make sure the incremental layer will be cleared
    // PENDING

    this.group.dirty();

    if (!this._finished || data.count() > 1e4) {
      return {
        update: true
      };
    } else {
      var res = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__layout_points_js__["a" /* default */])('').reset(seriesModel, ecModel, api);

      if (res.progress) {
        res.progress({
          start: 0,
          end: data.count(),
          count: data.count()
        }, data);
      }

      this._symbolDraw.updateLayout(data);
    }
  };

  ScatterView.prototype.eachRendered = function (cb) {
    this._symbolDraw && this._symbolDraw.eachRendered(cb);
  };

  ScatterView.prototype._getClipShape = function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
    return seriesModel.get('clip', true) ? clipArea : null;
  };

  ScatterView.prototype._updateSymbolDraw = function (data, seriesModel) {
    var symbolDraw = this._symbolDraw;
    var pipelineContext = seriesModel.pipelineContext;
    var isLargeDraw = pipelineContext.large;

    if (!symbolDraw || isLargeDraw !== this._isLargeDraw) {
      symbolDraw && symbolDraw.remove();
      symbolDraw = this._symbolDraw = isLargeDraw ? new __WEBPACK_IMPORTED_MODULE_2__helper_LargeSymbolDraw_js__["a" /* default */]() : new __WEBPACK_IMPORTED_MODULE_1__helper_SymbolDraw_js__["a" /* default */]();
      this._isLargeDraw = isLargeDraw;
      this.group.removeAll();
    }

    this.group.add(symbolDraw.group);
    return symbolDraw;
  };

  ScatterView.prototype.remove = function (ecModel, api) {
    this._symbolDraw && this._symbolDraw.remove(true);
    this._symbolDraw = null;
  };

  ScatterView.prototype.dispose = function () {};

  ScatterView.type = 'scatter';
  return ScatterView;
}(__WEBPACK_IMPORTED_MODULE_4__view_Chart_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ScatterView);

/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extension_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScatterSeries_js__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScatterView_js__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_grid_installSimple_js__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_points_js__ = __webpack_require__(195);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





function install(registers) {
  // In case developer forget to include grid component
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_3__component_grid_installSimple_js__["a" /* install */]);
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_1__ScatterSeries_js__["a" /* default */]);
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_2__ScatterView_js__["a" /* default */]);
  registers.registerLayout(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__layout_points_js__["a" /* default */])('scatter'));
}

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_pieHelper_js__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_decal_js__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__animation_basicTrasition_js__ = __webpack_require__(40);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/









var DEFAULT_SECTOR_Z = 2;
var DEFAULT_TEXT_Z = 4;
/**
 * Sunburstce of Sunburst including Sector, Label, LabelLine
 */

var SunburstPiece =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(SunburstPiece, _super);

  function SunburstPiece(node, seriesModel, ecModel, api) {
    var _this = _super.call(this) || this;

    _this.z2 = DEFAULT_SECTOR_Z;
    _this.textConfig = {
      inside: true
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_innerStore_js__["a" /* getECData */])(_this).seriesIndex = seriesModel.seriesIndex;
    var text = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Text"]({
      z2: DEFAULT_TEXT_Z,
      silent: node.getModel().get(['label', 'silent'])
    });

    _this.setTextContent(text);

    _this.updateData(true, node, seriesModel, ecModel, api);

    return _this;
  }

  SunburstPiece.prototype.updateData = function (firstCreate, node, // state: 'emphasis' | 'normal' | 'highlight' | 'downplay',
  seriesModel, ecModel, api) {
    this.node = node;
    node.piece = this;
    seriesModel = seriesModel || this._seriesModel;
    ecModel = ecModel || this._ecModel;
    var sector = this;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_innerStore_js__["a" /* getECData */])(sector).dataIndex = node.dataIndex;
    var itemModel = node.getModel();
    var emphasisModel = itemModel.getModel('emphasis');
    var layout = node.getLayout();
    var sectorShape = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"]({}, layout);
    sectorShape.label = null;
    var normalStyle = node.getVisual('style');
    normalStyle.lineJoin = 'bevel';
    var decal = node.getVisual('decal');

    if (decal) {
      normalStyle.decal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_decal_js__["a" /* createOrUpdatePatternFromDecal */])(decal, api);
    }

    var cornerRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helper_pieHelper_js__["a" /* getSectorCornerRadius */])(itemModel.getModel('itemStyle'), sectorShape, true);
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"](sectorShape, cornerRadius);
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](__WEBPACK_IMPORTED_MODULE_3__util_states_js__["a" /* SPECIAL_STATES */], function (stateName) {
      var state = sector.ensureState(stateName);
      var itemStyleModel = itemModel.getModel([stateName, 'itemStyle']);
      state.style = itemStyleModel.getItemStyle(); // border radius

      var cornerRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helper_pieHelper_js__["a" /* getSectorCornerRadius */])(itemStyleModel, sectorShape);

      if (cornerRadius) {
        state.shape = cornerRadius;
      }
    });

    if (firstCreate) {
      sector.setShape(sectorShape);
      sector.shape.r = layout.r0;
      __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["updateProps"](sector, {
        shape: {
          r: layout.r
        }
      }, seriesModel, node.dataIndex);
    } else {
      // Disable animation for gradient since no interpolation method
      // is supported for gradient
      __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["updateProps"](sector, {
        shape: sectorShape
      }, seriesModel);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__animation_basicTrasition_js__["f" /* saveOldStyle */])(sector);
    }

    sector.useStyle(normalStyle);

    this._updateLabel(seriesModel);

    var cursorStyle = itemModel.getShallow('cursor');
    cursorStyle && sector.attr('cursor', cursorStyle);
    this._seriesModel = seriesModel || this._seriesModel;
    this._ecModel = ecModel || this._ecModel;
    var focus = emphasisModel.get('focus');
    var focusOrIndices = focus === 'ancestor' ? node.getAncestorsIndices() : focus === 'descendant' ? node.getDescendantIndices() : focus;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_states_js__["G" /* toggleHoverEmphasis */])(this, focusOrIndices, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
  };

  SunburstPiece.prototype._updateLabel = function (seriesModel) {
    var _this = this;

    var itemModel = this.node.getModel();
    var normalLabelModel = itemModel.getModel('label');
    var layout = this.node.getLayout();
    var angle = layout.endAngle - layout.startAngle;
    var midAngle = (layout.startAngle + layout.endAngle) / 2;
    var dx = Math.cos(midAngle);
    var dy = Math.sin(midAngle);
    var sector = this;
    var label = sector.getTextContent();
    var dataIndex = this.node.dataIndex;
    var labelMinAngle = normalLabelModel.get('minAngle') / 180 * Math.PI;
    var isNormalShown = normalLabelModel.get('show') && !(labelMinAngle != null && Math.abs(angle) < labelMinAngle);
    label.ignore = !isNormalShown; // TODO use setLabelStyle

    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](__WEBPACK_IMPORTED_MODULE_3__util_states_js__["b" /* DISPLAY_STATES */], function (stateName) {
      var labelStateModel = stateName === 'normal' ? itemModel.getModel('label') : itemModel.getModel([stateName, 'label']);
      var isNormal = stateName === 'normal';
      var state = isNormal ? label : label.ensureState(stateName);
      var text = seriesModel.getFormattedLabel(dataIndex, stateName);

      if (isNormal) {
        text = text || _this.node.name;
      }

      state.style = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["d" /* createTextStyle */])(labelStateModel, {}, null, stateName !== 'normal', true);

      if (text) {
        state.style.text = text;
      } // Not displaying text when angle is too small


      var isShown = labelStateModel.get('show');

      if (isShown != null && !isNormal) {
        state.ignore = !isShown;
      }

      var labelPosition = getLabelAttr(labelStateModel, 'position');
      var sectorState = isNormal ? sector : sector.states[stateName];
      var labelColor = sectorState.style.fill;
      sectorState.textConfig = {
        outsideFill: labelStateModel.get('color') === 'inherit' ? labelColor : null,
        inside: labelPosition !== 'outside'
      };
      var r;
      var labelPadding = getLabelAttr(labelStateModel, 'distance') || 0;
      var textAlign = getLabelAttr(labelStateModel, 'align');

      if (labelPosition === 'outside') {
        r = layout.r + labelPadding;
        textAlign = midAngle > Math.PI / 2 ? 'right' : 'left';
      } else {
        if (!textAlign || textAlign === 'center') {
          // Put label in the center if it's a circle
          if (angle === 2 * Math.PI && layout.r0 === 0) {
            r = 0;
          } else {
            r = (layout.r + layout.r0) / 2;
          }

          textAlign = 'center';
        } else if (textAlign === 'left') {
          r = layout.r0 + labelPadding;

          if (midAngle > Math.PI / 2) {
            textAlign = 'right';
          }
        } else if (textAlign === 'right') {
          r = layout.r - labelPadding;

          if (midAngle > Math.PI / 2) {
            textAlign = 'left';
          }
        }
      }

      state.style.align = textAlign;
      state.style.verticalAlign = getLabelAttr(labelStateModel, 'verticalAlign') || 'middle';
      state.x = r * dx + layout.cx;
      state.y = r * dy + layout.cy;
      var rotateType = getLabelAttr(labelStateModel, 'rotate');
      var rotate = 0;

      if (rotateType === 'radial') {
        rotate = -midAngle;

        if (rotate < -Math.PI / 2) {
          rotate += Math.PI;
        }
      } else if (rotateType === 'tangential') {
        rotate = Math.PI / 2 - midAngle;

        if (rotate > Math.PI / 2) {
          rotate -= Math.PI;
        } else if (rotate < -Math.PI / 2) {
          rotate += Math.PI;
        }
      } else if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isNumber"](rotateType)) {
        rotate = rotateType * Math.PI / 180;
      }

      state.rotation = rotate;
    });

    function getLabelAttr(model, name) {
      var stateAttr = model.get(name);

      if (stateAttr == null) {
        return normalLabelModel.get(name);
      }

      return stateAttr;
    }

    label.dirtyStyle();
  };

  return SunburstPiece;
}(__WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Sector"]);

/* harmony default export */ __webpack_exports__["a"] = (SunburstPiece);

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_Series_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_Tree_js__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_treeHelper_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_Model_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_enableAriaDecalForTree_js__ = __webpack_require__(448);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/








var SunburstSeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(SunburstSeriesModel, _super);

  function SunburstSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SunburstSeriesModel.type;
    _this.ignoreStyleOnData = true;
    return _this;
  }

  SunburstSeriesModel.prototype.getInitialData = function (option, ecModel) {
    // Create a virtual root.
    var root = {
      name: option.name,
      children: option.data
    };
    completeTreeValue(root);
    var levelModels = this._levelModels = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"](option.levels || [], function (levelDefine) {
      return new __WEBPACK_IMPORTED_MODULE_5__model_Model_js__["a" /* default */](levelDefine, this, ecModel);
    }, this); // Make sure always a new tree is created when setOption,
    // in TreemapView, we check whether oldTree === newTree
    // to choose mappings approach among old shapes and new shapes.

    var tree = __WEBPACK_IMPORTED_MODULE_3__data_Tree_js__["a" /* default */].createTree(root, this, beforeLink);

    function beforeLink(nodeData) {
      nodeData.wrapMethod('getItemModel', function (model, idx) {
        var node = tree.getNodeByDataIndex(idx);
        var levelModel = levelModels[node.depth];
        levelModel && (model.parentModel = levelModel);
        return model;
      });
    }

    return tree.data;
  };

  SunburstSeriesModel.prototype.optionUpdated = function () {
    this.resetViewRoot();
  };
  /*
   * @override
   */


  SunburstSeriesModel.prototype.getDataParams = function (dataIndex) {
    var params = _super.prototype.getDataParams.apply(this, arguments);

    var node = this.getData().tree.getNodeByDataIndex(dataIndex);
    params.treePathInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helper_treeHelper_js__["c" /* wrapTreePathInfo */])(node, this);
    return params;
  };

  SunburstSeriesModel.prototype.getLevelModel = function (node) {
    return this._levelModels && this._levelModels[node.depth];
  };

  SunburstSeriesModel.prototype.getViewRoot = function () {
    return this._viewRoot;
  };

  SunburstSeriesModel.prototype.resetViewRoot = function (viewRoot) {
    viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
    var root = this.getRawData().tree.root;

    if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) {
      this._viewRoot = root;
    }
  };

  SunburstSeriesModel.prototype.enableAriaDecal = function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helper_enableAriaDecalForTree_js__["a" /* default */])(this);
  };

  SunburstSeriesModel.type = 'series.sunburst';
  SunburstSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    // 默认全局居中
    center: ['50%', '50%'],
    radius: [0, '75%'],
    // 默认顺时针
    clockwise: true,
    startAngle: 90,
    // 最小角度改为0
    minAngle: 0,
    // If still show when all data zero.
    stillShowZeroSum: true,
    // 'rootToNode', 'link', or false
    nodeClick: 'rootToNode',
    renderLabelForZeroData: false,
    label: {
      // could be: 'radial', 'tangential', or 'none'
      rotate: 'radial',
      show: true,
      opacity: 1,
      // 'left' is for inner side of inside, and 'right' is for outter
      // side for inside
      align: 'center',
      position: 'inside',
      distance: 5,
      silent: true
    },
    itemStyle: {
      borderWidth: 1,
      borderColor: 'white',
      borderType: 'solid',
      shadowBlur: 0,
      shadowColor: 'rgba(0, 0, 0, 0.2)',
      shadowOffsetX: 0,
      shadowOffsetY: 0,
      opacity: 1
    },
    emphasis: {
      focus: 'descendant'
    },
    blur: {
      itemStyle: {
        opacity: 0.2
      },
      label: {
        opacity: 0.1
      }
    },
    // Animation type canbe expansion, scale
    animationType: 'expansion',
    animationDuration: 1000,
    animationDurationUpdate: 500,
    data: [],

    /**
     * Sort order.
     *
     * Valid values: 'desc', 'asc', null, or callback function.
     * 'desc' and 'asc' for descend and ascendant order;
     * null for not sorting;
     * example of callback function:
     * function(nodeA, nodeB) {
     *     return nodeA.getValue() - nodeB.getValue();
     * }
     */
    sort: 'desc'
  };
  return SunburstSeriesModel;
}(__WEBPACK_IMPORTED_MODULE_2__model_Series_js__["b" /* default */]);

function completeTreeValue(dataNode) {
  // Postorder travel tree.
  // If value of none-leaf node is not set,
  // calculate it by suming up the value of all children.
  var sum = 0;
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](dataNode.children, function (child) {
    completeTreeValue(child);
    var childValue = child.value; // TODO First value of array must be a number

    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](childValue) && (childValue = childValue[0]);
    sum += childValue;
  });
  var thisValue = dataNode.value;

  if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](thisValue)) {
    thisValue = thisValue[0];
  }

  if (thisValue == null || isNaN(thisValue)) {
    thisValue = sum;
  } // Value should not less than 0.


  if (thisValue < 0) {
    thisValue = 0;
  }

  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
}

/* harmony default export */ __webpack_exports__["a"] = (SunburstSeriesModel);

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SunburstPiece_js__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_DataDiffer_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sunburstAction_js__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_format_js__ = __webpack_require__(42);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/








var SunburstView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(SunburstView, _super);

  function SunburstView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SunburstView.type;
    return _this;
  }

  SunburstView.prototype.render = function (seriesModel, ecModel, api, // @ts-ignore
  payload) {
    var self = this;
    this.seriesModel = seriesModel;
    this.api = api;
    this.ecModel = ecModel;
    var data = seriesModel.getData();
    var virtualRoot = data.tree.root;
    var newRoot = seriesModel.getViewRoot();
    var group = this.group;
    var renderLabelForZeroData = seriesModel.get('renderLabelForZeroData');
    var newChildren = [];
    newRoot.eachNode(function (node) {
      newChildren.push(node);
    });
    var oldChildren = this._oldChildren || [];
    dualTravel(newChildren, oldChildren);
    renderRollUp(virtualRoot, newRoot);

    this._initEvents();

    this._oldChildren = newChildren;

    function dualTravel(newChildren, oldChildren) {
      if (newChildren.length === 0 && oldChildren.length === 0) {
        return;
      }

      new __WEBPACK_IMPORTED_MODULE_4__data_DataDiffer_js__["a" /* default */](oldChildren, newChildren, getKey, getKey).add(processNode).update(processNode).remove(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["curry"](processNode, null)).execute();

      function getKey(node) {
        return node.getId();
      }

      function processNode(newIdx, oldIdx) {
        var newNode = newIdx == null ? null : newChildren[newIdx];
        var oldNode = oldIdx == null ? null : oldChildren[oldIdx];
        doRenderNode(newNode, oldNode);
      }
    }

    function doRenderNode(newNode, oldNode) {
      if (!renderLabelForZeroData && newNode && !newNode.getValue()) {
        // Not render data with value 0
        newNode = null;
      }

      if (newNode !== virtualRoot && oldNode !== virtualRoot) {
        if (oldNode && oldNode.piece) {
          if (newNode) {
            // Update
            oldNode.piece.updateData(false, newNode, seriesModel, ecModel, api); // For tooltip

            data.setItemGraphicEl(newNode.dataIndex, oldNode.piece);
          } else {
            // Remove
            removeNode(oldNode);
          }
        } else if (newNode) {
          // Add
          var piece = new __WEBPACK_IMPORTED_MODULE_3__SunburstPiece_js__["a" /* default */](newNode, seriesModel, ecModel, api);
          group.add(piece); // For tooltip

          data.setItemGraphicEl(newNode.dataIndex, piece);
        }
      }
    }

    function removeNode(node) {
      if (!node) {
        return;
      }

      if (node.piece) {
        group.remove(node.piece);
        node.piece = null;
      }
    }

    function renderRollUp(virtualRoot, viewRoot) {
      if (viewRoot.depth > 0) {
        // Render
        if (self.virtualPiece) {
          // Update
          self.virtualPiece.updateData(false, virtualRoot, seriesModel, ecModel, api);
        } else {
          // Add
          self.virtualPiece = new __WEBPACK_IMPORTED_MODULE_3__SunburstPiece_js__["a" /* default */](virtualRoot, seriesModel, ecModel, api);
          group.add(self.virtualPiece);
        } // TODO event scope


        viewRoot.piece.off('click');
        self.virtualPiece.on('click', function (e) {
          self._rootToNode(viewRoot.parentNode);
        });
      } else if (self.virtualPiece) {
        // Remove
        group.remove(self.virtualPiece);
        self.virtualPiece = null;
      }
    }
  };
  /**
   * @private
   */


  SunburstView.prototype._initEvents = function () {
    var _this = this;

    this.group.off('click');
    this.group.on('click', function (e) {
      var targetFound = false;

      var viewRoot = _this.seriesModel.getViewRoot();

      viewRoot.eachNode(function (node) {
        if (!targetFound && node.piece && node.piece === e.target) {
          var nodeClick = node.getModel().get('nodeClick');

          if (nodeClick === 'rootToNode') {
            _this._rootToNode(node);
          } else if (nodeClick === 'link') {
            var itemModel = node.getModel();
            var link = itemModel.get('link');

            if (link) {
              var linkTarget = itemModel.get('target', true) || '_blank';
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_format_js__["h" /* windowOpen */])(link, linkTarget);
            }
          }

          targetFound = true;
        }
      });
    });
  };
  /**
   * @private
   */


  SunburstView.prototype._rootToNode = function (node) {
    if (node !== this.seriesModel.getViewRoot()) {
      this.api.dispatchAction({
        type: __WEBPACK_IMPORTED_MODULE_5__sunburstAction_js__["b" /* ROOT_TO_NODE_ACTION */],
        from: this.uid,
        seriesId: this.seriesModel.id,
        targetNode: node
      });
    }
  };
  /**
   * @implement
   */


  SunburstView.prototype.containPoint = function (point, seriesModel) {
    var treeRoot = seriesModel.getData();
    var itemLayout = treeRoot.getItemLayout(0);

    if (itemLayout) {
      var dx = point[0] - itemLayout.cx;
      var dy = point[1] - itemLayout.cy;
      var radius = Math.sqrt(dx * dx + dy * dy);
      return radius <= itemLayout.r && radius >= itemLayout.r0;
    }
  };

  SunburstView.type = 'sunburst';
  return SunburstView;
}(__WEBPACK_IMPORTED_MODULE_2__view_Chart_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SunburstView);

/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SunburstView_js__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SunburstSeries_js__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sunburstLayout_js__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sunburstVisual_js__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__processor_dataFilter_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sunburstAction_js__ = __webpack_require__(455);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







function install(registers) {
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_0__SunburstView_js__["a" /* default */]);
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_1__SunburstSeries_js__["a" /* default */]);
  registers.registerLayout(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["curry"])(__WEBPACK_IMPORTED_MODULE_2__sunburstLayout_js__["a" /* default */], 'sunburst'));
  registers.registerProcessor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["curry"])(__WEBPACK_IMPORTED_MODULE_4__processor_dataFilter_js__["a" /* default */], 'sunburst'));
  registers.registerVisual(__WEBPACK_IMPORTED_MODULE_3__sunburstVisual_js__["a" /* default */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__sunburstAction_js__["a" /* installSunburstAction */])(registers);
}

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sunburstLayout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

 // let PI2 = Math.PI * 2;

var RADIAN = Math.PI / 180;
function sunburstLayout(seriesType, ecModel, api) {
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    var center = seriesModel.get('center');
    var radius = seriesModel.get('radius');

    if (!__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](radius)) {
      radius = [0, radius];
    }

    if (!__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](center)) {
      center = [center, center];
    }

    var width = api.getWidth();
    var height = api.getHeight();
    var size = Math.min(width, height);
    var cx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["a" /* parsePercent */])(center[0], width);
    var cy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["a" /* parsePercent */])(center[1], height);
    var r0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["a" /* parsePercent */])(radius[0], size / 2);
    var r = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["a" /* parsePercent */])(radius[1], size / 2);
    var startAngle = -seriesModel.get('startAngle') * RADIAN;
    var minAngle = seriesModel.get('minAngle') * RADIAN;
    var virtualRoot = seriesModel.getData().tree.root;
    var treeRoot = seriesModel.getViewRoot();
    var rootDepth = treeRoot.depth;
    var sort = seriesModel.get('sort');

    if (sort != null) {
      initChildren(treeRoot, sort);
    }

    var validDataCount = 0;
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](treeRoot.children, function (child) {
      !isNaN(child.getValue()) && validDataCount++;
    });
    var sum = treeRoot.getValue(); // Sum may be 0

    var unitRadian = Math.PI / (sum || validDataCount) * 2;
    var renderRollupNode = treeRoot.depth > 0;
    var levels = treeRoot.height - (renderRollupNode ? -1 : 1);
    var rPerLevel = (r - r0) / (levels || 1);
    var clockwise = seriesModel.get('clockwise');
    var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // In the case some sector angle is smaller than minAngle
    // let restAngle = PI2;
    // let valueSumLargerThanMinAngle = 0;

    var dir = clockwise ? 1 : -1;
    /**
     * Render a tree
     * @return increased angle
     */

    var renderNode = function (node, startAngle) {
      if (!node) {
        return;
      }

      var endAngle = startAngle; // Render self

      if (node !== virtualRoot) {
        // Tree node is virtual, so it doesn't need to be drawn
        var value = node.getValue();
        var angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;

        if (angle < minAngle) {
          angle = minAngle; // restAngle -= minAngle;
        } // else {
        //     valueSumLargerThanMinAngle += value;
        // }


        endAngle = startAngle + dir * angle;
        var depth = node.depth - rootDepth - (renderRollupNode ? -1 : 1);
        var rStart = r0 + rPerLevel * depth;
        var rEnd = r0 + rPerLevel * (depth + 1);
        var levelModel = seriesModel.getLevelModel(node);

        if (levelModel) {
          var r0_1 = levelModel.get('r0', true);
          var r_1 = levelModel.get('r', true);
          var radius_1 = levelModel.get('radius', true);

          if (radius_1 != null) {
            r0_1 = radius_1[0];
            r_1 = radius_1[1];
          }

          r0_1 != null && (rStart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["a" /* parsePercent */])(r0_1, size / 2));
          r_1 != null && (rEnd = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_number_js__["a" /* parsePercent */])(r_1, size / 2));
        }

        node.setLayout({
          angle: angle,
          startAngle: startAngle,
          endAngle: endAngle,
          clockwise: clockwise,
          cx: cx,
          cy: cy,
          r0: rStart,
          r: rEnd
        });
      } // Render children


      if (node.children && node.children.length) {
        // currentAngle = startAngle;
        var siblingAngle_1 = 0;
        __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](node.children, function (node) {
          siblingAngle_1 += renderNode(node, startAngle + siblingAngle_1);
        });
      }

      return endAngle - startAngle;
    }; // Virtual root node for roll up


    if (renderRollupNode) {
      var rStart = r0;
      var rEnd = r0 + rPerLevel;
      var angle = Math.PI * 2;
      virtualRoot.setLayout({
        angle: angle,
        startAngle: startAngle,
        endAngle: startAngle + angle,
        clockwise: clockwise,
        cx: cx,
        cy: cy,
        r0: rStart,
        r: rEnd
      });
    }

    renderNode(treeRoot, startAngle);
  });
}
/**
 * Init node children by order and update visual
 */

function initChildren(node, sortOrder) {
  var children = node.children || [];
  node.children = sort(children, sortOrder); // Init children recursively

  if (children.length) {
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](node.children, function (child) {
      initChildren(child, sortOrder);
    });
  }
}
/**
 * Sort children nodes
 *
 * @param {TreeNode[]}               children children of node to be sorted
 * @param {string | function | null} sort sort method
 *                                   See SunburstSeries.js for details.
 */


function sort(children, sortOrder) {
  if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isFunction"](sortOrder)) {
    var sortTargets = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"](children, function (child, idx) {
      var value = child.getValue();
      return {
        params: {
          depth: child.depth,
          height: child.height,
          dataIndex: child.dataIndex,
          getValue: function () {
            return value;
          }
        },
        index: idx
      };
    });
    sortTargets.sort(function (a, b) {
      return sortOrder(a.params, b.params);
    });
    return __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"](sortTargets, function (target) {
      return children[target.index];
    });
  } else {
    var isAsc_1 = sortOrder === 'asc';
    return children.sort(function (a, b) {
      var diff = (a.getValue() - b.getValue()) * (isAsc_1 ? 1 : -1);
      return diff === 0 ? (a.dataIndex - b.dataIndex) * (isAsc_1 ? -1 : 1) : diff;
    });
  }
}

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sunburstVisual;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_tool_color_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


function sunburstVisual(ecModel) {
  var paletteScope = {}; // Default color strategy

  function pickColor(node, seriesModel, treeHeight) {
    // Choose color from palette based on the first level.
    var current = node;

    while (current && current.depth > 1) {
      current = current.parentNode;
    }

    var color = seriesModel.getColorFromPalette(current.name || current.dataIndex + '', paletteScope);

    if (node.depth > 1 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"])(color)) {
      // Lighter on the deeper level.
      color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_tool_color_js__["lift"])(color, (node.depth - 1) / (treeHeight - 1) * 0.5);
    }

    return color;
  }

  ecModel.eachSeriesByType('sunburst', function (seriesModel) {
    var data = seriesModel.getData();
    var tree = data.tree;
    tree.eachNode(function (node) {
      var model = node.getModel();
      var style = model.getModel('itemStyle').getItemStyle();

      if (!style.fill) {
        style.fill = pickColor(node, seriesModel, tree.root.height);
      }

      var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, 'style');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])(existsStyle, style);
    });
  });
}

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_Series_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_helper_createDimensions_js__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_helper_dimensionHelper_js__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_SeriesData_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__visual_LegendVisualProvider_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_tooltip_tooltipMarkup_js__ = __webpack_require__(48);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/









var DATA_NAME_INDEX = 2;

var ThemeRiverSeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ThemeRiverSeriesModel, _super);

  function ThemeRiverSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ThemeRiverSeriesModel.type;
    return _this;
  }
  /**
   * @override
   */


  ThemeRiverSeriesModel.prototype.init = function (option) {
    // eslint-disable-next-line
    _super.prototype.init.apply(this, arguments); // Put this function here is for the sake of consistency of code style.
    // Enable legend selection for each data item
    // Use a function instead of direct access because data reference may changed


    this.legendVisualProvider = new __WEBPACK_IMPORTED_MODULE_7__visual_LegendVisualProvider_js__["a" /* default */](__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["bind"](this.getData, this), __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["bind"](this.getRawData, this));
  };
  /**
   * If there is no value of a certain point in the time for some event,set it value to 0.
   *
   * @param {Array} data  initial data in the option
   * @return {Array}
   */


  ThemeRiverSeriesModel.prototype.fixData = function (data) {
    var rawDataLength = data.length;
    /**
     * Make sure every layer data get the same keys.
     * The value index tells which layer has visited.
     * {
     *  2014/01/01: -1
     * }
     */

    var timeValueKeys = {}; // grouped data by name

    var groupResult = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_model_js__["x" /* groupData */])(data, function (item) {
      if (!timeValueKeys.hasOwnProperty(item[0] + '')) {
        timeValueKeys[item[0] + ''] = -1;
      }

      return item[2];
    });
    var layerData = [];
    groupResult.buckets.each(function (items, key) {
      layerData.push({
        name: key,
        dataList: items
      });
    });
    var layerNum = layerData.length;

    for (var k = 0; k < layerNum; ++k) {
      var name_1 = layerData[k].name;

      for (var j = 0; j < layerData[k].dataList.length; ++j) {
        var timeValue = layerData[k].dataList[j][0] + '';
        timeValueKeys[timeValue] = k;
      }

      for (var timeValue in timeValueKeys) {
        if (timeValueKeys.hasOwnProperty(timeValue) && timeValueKeys[timeValue] !== k) {
          timeValueKeys[timeValue] = k;
          data[rawDataLength] = [timeValue, 0, name_1];
          rawDataLength++;
        }
      }
    }

    return data;
  };
  /**
   * @override
   * @param  option  the initial option that user gived
   * @param  ecModel  the model object for themeRiver option
   */


  ThemeRiverSeriesModel.prototype.getInitialData = function (option, ecModel) {
    var singleAxisModel = this.getReferringComponents('singleAxis', __WEBPACK_IMPORTED_MODULE_6__util_model_js__["i" /* SINGLE_REFERRING */]).models[0];
    var axisType = singleAxisModel.get('type'); // filter the data item with the value of label is undefined

    var filterData = __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["filter"](option.data, function (dataItem) {
      return dataItem[2] !== undefined;
    }); // ??? TODO design a stage to transfer data for themeRiver and lines?

    var data = this.fixData(filterData || []);
    var nameList = [];
    var nameMap = this.nameMap = __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["createHashMap"]();
    var count = 0;

    for (var i = 0; i < data.length; ++i) {
      nameList.push(data[i][DATA_NAME_INDEX]);

      if (!nameMap.get(data[i][DATA_NAME_INDEX])) {
        nameMap.set(data[i][DATA_NAME_INDEX], count);
        count++;
      }
    }

    var dimensions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_helper_createDimensions_js__["a" /* default */])(data, {
      coordDimensions: ['single'],
      dimensionsDefine: [{
        name: 'time',
        type: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__data_helper_dimensionHelper_js__["b" /* getDimensionTypeByAxis */])(axisType)
      }, {
        name: 'value',
        type: 'float'
      }, {
        name: 'name',
        type: 'ordinal'
      }],
      encodeDefine: {
        single: 0,
        value: 1,
        itemName: 2
      }
    }).dimensions;
    var list = new __WEBPACK_IMPORTED_MODULE_4__data_SeriesData_js__["a" /* default */](dimensions, this);
    list.initData(data);
    return list;
  };
  /**
   * The raw data is divided into multiple layers and each layer
   *     has same name.
   */


  ThemeRiverSeriesModel.prototype.getLayerSeries = function () {
    var data = this.getData();
    var lenCount = data.count();
    var indexArr = [];

    for (var i = 0; i < lenCount; ++i) {
      indexArr[i] = i;
    }

    var timeDim = data.mapDimension('single'); // data group by name

    var groupResult = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_model_js__["x" /* groupData */])(indexArr, function (index) {
      return data.get('name', index);
    });
    var layerSeries = [];
    groupResult.buckets.each(function (items, key) {
      items.sort(function (index1, index2) {
        return data.get(timeDim, index1) - data.get(timeDim, index2);
      });
      layerSeries.push({
        name: key,
        indices: items
      });
    });
    return layerSeries;
  };
  /**
   * Get data indices for show tooltip content
   */


  ThemeRiverSeriesModel.prototype.getAxisTooltipData = function (dim, value, baseAxis) {
    if (!__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["isArray"](dim)) {
      dim = dim ? [dim] : [];
    }

    var data = this.getData();
    var layerSeries = this.getLayerSeries();
    var indices = [];
    var layerNum = layerSeries.length;
    var nestestValue;

    for (var i = 0; i < layerNum; ++i) {
      var minDist = Number.MAX_VALUE;
      var nearestIdx = -1;
      var pointNum = layerSeries[i].indices.length;

      for (var j = 0; j < pointNum; ++j) {
        var theValue = data.get(dim[0], layerSeries[i].indices[j]);
        var dist = Math.abs(theValue - value);

        if (dist <= minDist) {
          nestestValue = theValue;
          minDist = dist;
          nearestIdx = layerSeries[i].indices[j];
        }
      }

      indices.push(nearestIdx);
    }

    return {
      dataIndices: indices,
      nestestValue: nestestValue
    };
  };

  ThemeRiverSeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    var data = this.getData();
    var name = data.getName(dataIndex);
    var value = data.get(data.mapDimension('value'), dataIndex);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__component_tooltip_tooltipMarkup_js__["b" /* createTooltipMarkup */])('nameValue', {
      name: name,
      value: value
    });
  };

  ThemeRiverSeriesModel.type = 'series.themeRiver';
  ThemeRiverSeriesModel.dependencies = ['singleAxis'];
  ThemeRiverSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    colorBy: 'data',
    coordinateSystem: 'singleAxis',
    // gap in axis's orthogonal orientation
    boundaryGap: ['10%', '10%'],
    // legendHoverLink: true,
    singleAxisIndex: 0,
    animationEasing: 'linear',
    label: {
      margin: 4,
      show: true,
      position: 'left',
      fontSize: 11
    },
    emphasis: {
      label: {
        show: true
      }
    }
  };
  return ThemeRiverSeriesModel;
}(__WEBPACK_IMPORTED_MODULE_1__model_Series_js__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ThemeRiverSeriesModel);

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line_poly_js__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_DataDiffer_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__animation_basicTrasition_js__ = __webpack_require__(40);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/










var ThemeRiverView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ThemeRiverView, _super);

  function ThemeRiverView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ThemeRiverView.type;
    _this._layers = [];
    return _this;
  }

  ThemeRiverView.prototype.render = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var self = this;
    var group = this.group;
    var layersSeries = seriesModel.getLayerSeries();
    var layoutInfo = data.getLayout('layoutInfo');
    var rect = layoutInfo.rect;
    var boundaryGap = layoutInfo.boundaryGap;
    group.x = 0;
    group.y = rect.y + boundaryGap[0];

    function keyGetter(item) {
      return item.name;
    }

    var dataDiffer = new __WEBPACK_IMPORTED_MODULE_6__data_DataDiffer_js__["a" /* default */](this._layersSeries || [], layersSeries, keyGetter, keyGetter);
    var newLayersGroups = [];
    dataDiffer.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["bind"])(process, this, 'add')).update(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["bind"])(process, this, 'update')).remove(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_util_js__["bind"])(process, this, 'remove')).execute();

    function process(status, idx, oldIdx) {
      var oldLayersGroups = self._layers;

      if (status === 'remove') {
        group.remove(oldLayersGroups[idx]);
        return;
      }

      var points0 = [];
      var points1 = [];
      var style;
      var indices = layersSeries[idx].indices;
      var j = 0;

      for (; j < indices.length; j++) {
        var layout = data.getItemLayout(indices[j]);
        var x = layout.x;
        var y0 = layout.y0;
        var y = layout.y;
        points0.push(x, y0);
        points1.push(x, y0 + y);
        style = data.getItemVisual(indices[j], 'style');
      }

      var polygon;
      var textLayout = data.getItemLayout(indices[0]);
      var labelModel = seriesModel.getModel('label');
      var margin = labelModel.get('margin');
      var emphasisModel = seriesModel.getModel('emphasis');

      if (status === 'add') {
        var layerGroup = newLayersGroups[idx] = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Group"]();
        polygon = new __WEBPACK_IMPORTED_MODULE_1__line_poly_js__["a" /* ECPolygon */]({
          shape: {
            points: points0,
            stackedOnPoints: points1,
            smooth: 0.4,
            stackedOnSmooth: 0.4,
            smoothConstraint: false
          },
          z2: 0
        });
        layerGroup.add(polygon);
        group.add(layerGroup);

        if (seriesModel.isAnimationEnabled()) {
          polygon.setClipPath(createGridClipShape(polygon.getBoundingRect(), seriesModel, function () {
            polygon.removeClipPath();
          }));
        }
      } else {
        var layerGroup = oldLayersGroups[oldIdx];
        polygon = layerGroup.childAt(0);
        group.add(layerGroup);
        newLayersGroups[idx] = layerGroup;
        __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["updateProps"](polygon, {
          shape: {
            points: points0,
            stackedOnPoints: points1
          }
        }, seriesModel);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__animation_basicTrasition_js__["f" /* saveOldStyle */])(polygon);
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["e" /* setLabelStyle */])(polygon, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["f" /* getLabelStatesModels */])(seriesModel), {
        labelDataIndex: indices[j - 1],
        defaultText: data.getName(indices[j - 1]),
        inheritColor: style.fill
      }, {
        normal: {
          verticalAlign: 'middle' // align: 'right'

        }
      });
      polygon.setTextConfig({
        position: null,
        local: true
      });
      var labelEl = polygon.getTextContent(); // TODO More label position options.

      if (labelEl) {
        labelEl.x = textLayout.x - margin;
        labelEl.y = textLayout.y0 + textLayout.y / 2;
      }

      polygon.useStyle(style);
      data.setItemGraphicEl(idx, polygon);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_states_js__["F" /* setStatesStylesFromModel */])(polygon, seriesModel);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_states_js__["G" /* toggleHoverEmphasis */])(polygon, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    }

    this._layersSeries = layersSeries;
    this._layers = newLayersGroups;
  };

  ThemeRiverView.type = 'themeRiver';
  return ThemeRiverView;
}(__WEBPACK_IMPORTED_MODULE_7__view_Chart_js__["a" /* default */]);

; // add animation to the view

function createGridClipShape(rect, seriesModel, cb) {
  var rectEl = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Rect"]({
    shape: {
      x: rect.x - 10,
      y: rect.y - 10,
      width: 0,
      height: rect.height + 20
    }
  });
  __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["initProps"](rectEl, {
    shape: {
      x: rect.x - 50,
      width: rect.width + 100,
      height: rect.height + 20
    }
  }, seriesModel, cb);
  return rectEl;
}

/* harmony default export */ __webpack_exports__["a"] = (ThemeRiverView);

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ThemeRiverView_js__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ThemeRiverSeries_js__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themeRiverLayout_js__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__processor_dataFilter_js__ = __webpack_require__(196);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */





function install(registers) {
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_0__ThemeRiverView_js__["a" /* default */]);
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_1__ThemeRiverSeries_js__["a" /* default */]);
  registers.registerLayout(__WEBPACK_IMPORTED_MODULE_2__themeRiverLayout_js__["a" /* default */]);
  registers.registerProcessor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__processor_dataFilter_js__["a" /* default */])('themeRiver'));
}

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = themeRiverLayout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_number_js__ = __webpack_require__(8);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


function themeRiverLayout(ecModel, api) {
  ecModel.eachSeriesByType('themeRiver', function (seriesModel) {
    var data = seriesModel.getData();
    var single = seriesModel.coordinateSystem;
    var layoutInfo = {}; // use the axis boundingRect for view

    var rect = single.getRect();
    layoutInfo.rect = rect;
    var boundaryGap = seriesModel.get('boundaryGap');
    var axis = single.getAxis();
    layoutInfo.boundaryGap = boundaryGap;

    if (axis.orient === 'horizontal') {
      boundaryGap[0] = __WEBPACK_IMPORTED_MODULE_1__util_number_js__["a" /* parsePercent */](boundaryGap[0], rect.height);
      boundaryGap[1] = __WEBPACK_IMPORTED_MODULE_1__util_number_js__["a" /* parsePercent */](boundaryGap[1], rect.height);
      var height = rect.height - boundaryGap[0] - boundaryGap[1];
      doThemeRiverLayout(data, seriesModel, height);
    } else {
      boundaryGap[0] = __WEBPACK_IMPORTED_MODULE_1__util_number_js__["a" /* parsePercent */](boundaryGap[0], rect.width);
      boundaryGap[1] = __WEBPACK_IMPORTED_MODULE_1__util_number_js__["a" /* parsePercent */](boundaryGap[1], rect.width);
      var width = rect.width - boundaryGap[0] - boundaryGap[1];
      doThemeRiverLayout(data, seriesModel, width);
    }

    data.setLayout('layoutInfo', layoutInfo);
  });
}
/**
 * The layout information about themeriver
 *
 * @param data  data in the series
 * @param seriesModel  the model object of themeRiver series
 * @param height  value used to compute every series height
 */

function doThemeRiverLayout(data, seriesModel, height) {
  if (!data.count()) {
    return;
  }

  var coordSys = seriesModel.coordinateSystem; // the data in each layer are organized into a series.

  var layerSeries = seriesModel.getLayerSeries(); // the points in each layer.

  var timeDim = data.mapDimension('single');
  var valueDim = data.mapDimension('value');
  var layerPoints = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"](layerSeries, function (singleLayer) {
    return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"](singleLayer.indices, function (idx) {
      var pt = coordSys.dataToPoint(data.get(timeDim, idx));
      pt[1] = data.get(valueDim, idx);
      return pt;
    });
  });
  var base = computeBaseline(layerPoints);
  var baseLine = base.y0;
  var ky = height / base.max; // set layout information for each item.

  var n = layerSeries.length;
  var m = layerSeries[0].indices.length;
  var baseY0;

  for (var j = 0; j < m; ++j) {
    baseY0 = baseLine[j] * ky;
    data.setItemLayout(layerSeries[0].indices[j], {
      layerIndex: 0,
      x: layerPoints[0][j][0],
      y0: baseY0,
      y: layerPoints[0][j][1] * ky
    });

    for (var i = 1; i < n; ++i) {
      baseY0 += layerPoints[i - 1][j][1] * ky;
      data.setItemLayout(layerSeries[i].indices[j], {
        layerIndex: i,
        x: layerPoints[i][j][0],
        y0: baseY0,
        y: layerPoints[i][j][1] * ky
      });
    }
  }
}
/**
 * Compute the baseLine of the rawdata
 * Inspired by Lee Byron's paper Stacked Graphs - Geometry & Aesthetics
 *
 * @param  data  the points in each layer
 */


function computeBaseline(data) {
  var layerNum = data.length;
  var pointNum = data[0].length;
  var sums = [];
  var y0 = [];
  var max = 0;

  for (var i = 0; i < pointNum; ++i) {
    var temp = 0;

    for (var j = 0; j < layerNum; ++j) {
      temp += data[j][i][1];
    }

    if (temp > max) {
      max = temp;
    }

    sums.push(temp);
  }

  for (var k = 0; k < pointNum; ++k) {
    y0[k] = (max - sums[k]) / 2;
  }

  max = 0;

  for (var l = 0; l < pointNum; ++l) {
    var sum = sums[l] + y0[l];

    if (sum > max) {
      max = sum;
    }
  }

  return {
    y0: y0,
    max: max
  };
}

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_Series_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_Tree_js__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_Model_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component_tooltip_tooltipMarkup_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_treeHelper_js__ = __webpack_require__(110);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







var TreeSeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(TreeSeriesModel, _super);

  function TreeSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.hasSymbolVisual = true; // Do it self.

    _this.ignoreStyleOnData = true;
    return _this;
  }
  /**
   * Init a tree data structure from data in option series
   */


  TreeSeriesModel.prototype.getInitialData = function (option) {
    //create an virtual root
    var root = {
      name: option.name,
      children: option.data
    };
    var leaves = option.leaves || {};
    var leavesModel = new __WEBPACK_IMPORTED_MODULE_3__model_Model_js__["a" /* default */](leaves, this, this.ecModel);
    var tree = __WEBPACK_IMPORTED_MODULE_2__data_Tree_js__["a" /* default */].createTree(root, this, beforeLink);

    function beforeLink(nodeData) {
      nodeData.wrapMethod('getItemModel', function (model, idx) {
        var node = tree.getNodeByDataIndex(idx);

        if (!(node && node.children.length && node.isExpand)) {
          model.parentModel = leavesModel;
        }

        return model;
      });
    }

    var treeDepth = 0;
    tree.eachNode('preorder', function (node) {
      if (node.depth > treeDepth) {
        treeDepth = node.depth;
      }
    });
    var expandAndCollapse = option.expandAndCollapse;
    var expandTreeDepth = expandAndCollapse && option.initialTreeDepth >= 0 ? option.initialTreeDepth : treeDepth;
    tree.root.eachNode('preorder', function (node) {
      var item = node.hostTree.data.getRawDataItem(node.dataIndex); // Add item.collapsed != null, because users can collapse node original in the series.data.

      node.isExpand = item && item.collapsed != null ? !item.collapsed : node.depth <= expandTreeDepth;
    });
    return tree.data;
  };
  /**
   * Make the configuration 'orient' backward compatibly, with 'horizontal = LR', 'vertical = TB'.
   * @returns {string} orient
   */


  TreeSeriesModel.prototype.getOrient = function () {
    var orient = this.get('orient');

    if (orient === 'horizontal') {
      orient = 'LR';
    } else if (orient === 'vertical') {
      orient = 'TB';
    }

    return orient;
  };

  TreeSeriesModel.prototype.setZoom = function (zoom) {
    this.option.zoom = zoom;
  };

  TreeSeriesModel.prototype.setCenter = function (center) {
    this.option.center = center;
  };

  TreeSeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    var tree = this.getData().tree;
    var realRoot = tree.root.children[0];
    var node = tree.getNodeByDataIndex(dataIndex);
    var value = node.getValue();
    var name = node.name;

    while (node && node !== realRoot) {
      name = node.parentNode.name + '.' + name;
      node = node.parentNode;
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__component_tooltip_tooltipMarkup_js__["b" /* createTooltipMarkup */])('nameValue', {
      name: name,
      value: value,
      noValue: isNaN(value) || value == null
    });
  }; // Add tree path to tooltip param


  TreeSeriesModel.prototype.getDataParams = function (dataIndex) {
    var params = _super.prototype.getDataParams.apply(this, arguments);

    var node = this.getData().tree.getNodeByDataIndex(dataIndex);
    params.treeAncestors = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helper_treeHelper_js__["c" /* wrapTreePathInfo */])(node, this);
    params.collapsed = !node.isExpand;
    return params;
  };

  TreeSeriesModel.type = 'series.tree'; // can support the position parameters 'left', 'top','right','bottom', 'width',
  // 'height' in the setOption() with 'merge' mode normal.

  TreeSeriesModel.layoutMode = 'box';
  TreeSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    coordinateSystem: 'view',
    // the position of the whole view
    left: '12%',
    top: '12%',
    right: '12%',
    bottom: '12%',
    // the layout of the tree, two value can be selected, 'orthogonal' or 'radial'
    layout: 'orthogonal',
    // value can be 'polyline'
    edgeShape: 'curve',
    edgeForkPosition: '50%',
    // true | false | 'move' | 'scale', see module:component/helper/RoamController.
    roam: false,
    // Symbol size scale ratio in roam
    nodeScaleRatio: 0.4,
    // Default on center of graph
    center: null,
    zoom: 1,
    orient: 'LR',
    symbol: 'emptyCircle',
    symbolSize: 7,
    expandAndCollapse: true,
    initialTreeDepth: 2,
    lineStyle: {
      color: '#ccc',
      width: 1.5,
      curveness: 0.5
    },
    itemStyle: {
      color: 'lightsteelblue',
      // borderColor: '#c23531',
      borderWidth: 1.5
    },
    label: {
      show: true
    },
    animationEasing: 'linear',
    animationDuration: 700,
    animationDurationUpdate: 500
  };
  return TreeSeriesModel;
}(__WEBPACK_IMPORTED_MODULE_1__model_Series_js__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TreeSeriesModel);

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_Symbol_js__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layoutHelper_js__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_bbox_js__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__coord_View_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_helper_roamHelper_js__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component_helper_RoamController_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component_helper_cursorHelper_js__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_zrender_lib_graphic_Path_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_states_js__ = __webpack_require__(12);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
















var TreeEdgeShape =
/** @class */
function () {
  function TreeEdgeShape() {
    this.parentPoint = [];
    this.childPoints = [];
  }

  return TreeEdgeShape;
}();

var TreePath =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(TreePath, _super);

  function TreePath(opts) {
    return _super.call(this, opts) || this;
  }

  TreePath.prototype.getDefaultStyle = function () {
    return {
      stroke: '#000',
      fill: null
    };
  };

  TreePath.prototype.getDefaultShape = function () {
    return new TreeEdgeShape();
  };

  TreePath.prototype.buildPath = function (ctx, shape) {
    var childPoints = shape.childPoints;
    var childLen = childPoints.length;
    var parentPoint = shape.parentPoint;
    var firstChildPos = childPoints[0];
    var lastChildPos = childPoints[childLen - 1];

    if (childLen === 1) {
      ctx.moveTo(parentPoint[0], parentPoint[1]);
      ctx.lineTo(firstChildPos[0], firstChildPos[1]);
      return;
    }

    var orient = shape.orient;
    var forkDim = orient === 'TB' || orient === 'BT' ? 0 : 1;
    var otherDim = 1 - forkDim;
    var forkPosition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_number_js__["a" /* parsePercent */])(shape.forkPosition, 1);
    var tmpPoint = [];
    tmpPoint[forkDim] = parentPoint[forkDim];
    tmpPoint[otherDim] = parentPoint[otherDim] + (lastChildPos[otherDim] - parentPoint[otherDim]) * forkPosition;
    ctx.moveTo(parentPoint[0], parentPoint[1]);
    ctx.lineTo(tmpPoint[0], tmpPoint[1]);
    ctx.moveTo(firstChildPos[0], firstChildPos[1]);
    tmpPoint[forkDim] = firstChildPos[forkDim];
    ctx.lineTo(tmpPoint[0], tmpPoint[1]);
    tmpPoint[forkDim] = lastChildPos[forkDim];
    ctx.lineTo(tmpPoint[0], tmpPoint[1]);
    ctx.lineTo(lastChildPos[0], lastChildPos[1]);

    for (var i = 1; i < childLen - 1; i++) {
      var point = childPoints[i];
      ctx.moveTo(point[0], point[1]);
      tmpPoint[forkDim] = point[forkDim];
      ctx.lineTo(tmpPoint[0], tmpPoint[1]);
    }
  };

  return TreePath;
}(__WEBPACK_IMPORTED_MODULE_13_zrender_lib_graphic_Path_js__["a" /* default */]);

var TreeView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(TreeView, _super);

  function TreeView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = TreeView.type;
    _this._mainGroup = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Group"]();
    return _this;
  }

  TreeView.prototype.init = function (ecModel, api) {
    this._controller = new __WEBPACK_IMPORTED_MODULE_9__component_helper_RoamController_js__["a" /* default */](api.getZr());
    this._controllerHost = {
      target: this.group
    };
    this.group.add(this._mainGroup);
  };

  TreeView.prototype.render = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var layoutInfo = seriesModel.layoutInfo;
    var group = this._mainGroup;
    var layout = seriesModel.get('layout');

    if (layout === 'radial') {
      group.x = layoutInfo.x + layoutInfo.width / 2;
      group.y = layoutInfo.y + layoutInfo.height / 2;
    } else {
      group.x = layoutInfo.x;
      group.y = layoutInfo.y;
    }

    this._updateViewCoordSys(seriesModel);

    this._updateController(seriesModel, ecModel, api);

    var oldData = this._data;
    data.diff(oldData).add(function (newIdx) {
      if (symbolNeedsDraw(data, newIdx)) {
        // Create node and edge
        updateNode(data, newIdx, null, group, seriesModel);
      }
    }).update(function (newIdx, oldIdx) {
      var symbolEl = oldData.getItemGraphicEl(oldIdx);

      if (!symbolNeedsDraw(data, newIdx)) {
        symbolEl && removeNode(oldData, oldIdx, symbolEl, group, seriesModel);
        return;
      } // Update node and edge


      updateNode(data, newIdx, symbolEl, group, seriesModel);
    }).remove(function (oldIdx) {
      var symbolEl = oldData.getItemGraphicEl(oldIdx); // When remove a collapsed node of subtree, since the collapsed
      // node haven't been initialized with a symbol element,
      // you can't found it's symbol element through index.
      // so if we want to remove the symbol element we should insure
      // that the symbol element is not null.

      if (symbolEl) {
        removeNode(oldData, oldIdx, symbolEl, group, seriesModel);
      }
    }).execute();
    this._nodeScaleRatio = seriesModel.get('nodeScaleRatio');

    this._updateNodeAndLinkScale(seriesModel);

    if (seriesModel.get('expandAndCollapse') === true) {
      data.eachItemGraphicEl(function (el, dataIndex) {
        el.off('click').on('click', function () {
          api.dispatchAction({
            type: 'treeExpandAndCollapse',
            seriesId: seriesModel.id,
            dataIndex: dataIndex
          });
        });
      });
    }

    this._data = data;
  };

  TreeView.prototype._updateViewCoordSys = function (seriesModel) {
    var data = seriesModel.getData();
    var points = [];
    data.each(function (idx) {
      var layout = data.getItemLayout(idx);

      if (layout && !isNaN(layout.x) && !isNaN(layout.y)) {
        points.push([+layout.x, +layout.y]);
      }
    });
    var min = [];
    var max = [];
    __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_bbox_js__["e" /* fromPoints */](points, min, max); // If don't Store min max when collapse the root node after roam,
    // the root node will disappear.

    var oldMin = this._min;
    var oldMax = this._max; // If width or height is 0

    if (max[0] - min[0] === 0) {
      min[0] = oldMin ? oldMin[0] : min[0] - 1;
      max[0] = oldMax ? oldMax[0] : max[0] + 1;
    }

    if (max[1] - min[1] === 0) {
      min[1] = oldMin ? oldMin[1] : min[1] - 1;
      max[1] = oldMax ? oldMax[1] : max[1] + 1;
    }

    var viewCoordSys = seriesModel.coordinateSystem = new __WEBPACK_IMPORTED_MODULE_7__coord_View_js__["a" /* default */]();
    viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
    viewCoordSys.setBoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
    viewCoordSys.setCenter(seriesModel.get('center'));
    viewCoordSys.setZoom(seriesModel.get('zoom')); // Here we use viewCoordSys just for computing the 'position' and 'scale' of the group

    this.group.attr({
      x: viewCoordSys.x,
      y: viewCoordSys.y,
      scaleX: viewCoordSys.scaleX,
      scaleY: viewCoordSys.scaleY
    });
    this._min = min;
    this._max = max;
  };

  TreeView.prototype._updateController = function (seriesModel, ecModel, api) {
    var _this = this;

    var controller = this._controller;
    var controllerHost = this._controllerHost;
    var group = this.group;
    controller.setPointerChecker(function (e, x, y) {
      var rect = group.getBoundingRect();
      rect.applyTransform(group.transform);
      return rect.contain(x, y) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__component_helper_cursorHelper_js__["a" /* onIrrelevantElement */])(e, api, seriesModel);
    });
    controller.enable(seriesModel.get('roam'));
    controllerHost.zoomLimit = seriesModel.get('scaleLimit');
    controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
    controller.off('pan').off('zoom').on('pan', function (e) {
      __WEBPACK_IMPORTED_MODULE_8__component_helper_roamHelper_js__["a" /* updateViewOnPan */](controllerHost, e.dx, e.dy);
      api.dispatchAction({
        seriesId: seriesModel.id,
        type: 'treeRoam',
        dx: e.dx,
        dy: e.dy
      });
    }).on('zoom', function (e) {
      __WEBPACK_IMPORTED_MODULE_8__component_helper_roamHelper_js__["b" /* updateViewOnZoom */](controllerHost, e.scale, e.originX, e.originY);
      api.dispatchAction({
        seriesId: seriesModel.id,
        type: 'treeRoam',
        zoom: e.scale,
        originX: e.originX,
        originY: e.originY
      });

      _this._updateNodeAndLinkScale(seriesModel); // Only update label layout on zoom


      api.updateLabelLayout();
    });
  };

  TreeView.prototype._updateNodeAndLinkScale = function (seriesModel) {
    var data = seriesModel.getData();

    var nodeScale = this._getNodeGlobalScale(seriesModel);

    data.eachItemGraphicEl(function (el, idx) {
      el.setSymbolScale(nodeScale);
    });
  };

  TreeView.prototype._getNodeGlobalScale = function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys.type !== 'view') {
      return 1;
    }

    var nodeScaleRatio = this._nodeScaleRatio;
    var groupZoom = coordSys.scaleX || 1; // Scale node when zoom changes

    var roamZoom = coordSys.getZoom();
    var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
    return nodeScale / groupZoom;
  };

  TreeView.prototype.dispose = function () {
    this._controller && this._controller.dispose();
    this._controllerHost = null;
  };

  TreeView.prototype.remove = function () {
    this._mainGroup.removeAll();

    this._data = null;
  };

  TreeView.type = 'tree';
  return TreeView;
}(__WEBPACK_IMPORTED_MODULE_12__view_Chart_js__["a" /* default */]);

function symbolNeedsDraw(data, dataIndex) {
  var layout = data.getItemLayout(dataIndex);
  return layout && !isNaN(layout.x) && !isNaN(layout.y);
}

function updateNode(data, dataIndex, symbolEl, group, seriesModel) {
  var isInit = !symbolEl;
  var node = data.tree.getNodeByDataIndex(dataIndex);
  var itemModel = node.getModel();
  var visualColor = node.getVisual('style').fill;
  var symbolInnerColor = node.isExpand === false && node.children.length !== 0 ? visualColor : '#fff';
  var virtualRoot = data.tree.root;
  var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
  var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
  var sourceLayout = source.getLayout();
  var sourceOldLayout = sourceSymbolEl ? {
    x: sourceSymbolEl.__oldX,
    y: sourceSymbolEl.__oldY,
    rawX: sourceSymbolEl.__radialOldRawX,
    rawY: sourceSymbolEl.__radialOldRawY
  } : sourceLayout;
  var targetLayout = node.getLayout();

  if (isInit) {
    symbolEl = new __WEBPACK_IMPORTED_MODULE_4__helper_Symbol_js__["a" /* default */](data, dataIndex, null, {
      symbolInnerColor: symbolInnerColor,
      useNameLabel: true
    });
    symbolEl.x = sourceOldLayout.x;
    symbolEl.y = sourceOldLayout.y;
  } else {
    symbolEl.updateData(data, dataIndex, null, {
      symbolInnerColor: symbolInnerColor,
      useNameLabel: true
    });
  }

  symbolEl.__radialOldRawX = symbolEl.__radialRawX;
  symbolEl.__radialOldRawY = symbolEl.__radialRawY;
  symbolEl.__radialRawX = targetLayout.rawX;
  symbolEl.__radialRawY = targetLayout.rawY;
  group.add(symbolEl);
  data.setItemGraphicEl(dataIndex, symbolEl);
  symbolEl.__oldX = symbolEl.x;
  symbolEl.__oldY = symbolEl.y;
  __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["updateProps"](symbolEl, {
    x: targetLayout.x,
    y: targetLayout.y
  }, seriesModel);
  var symbolPath = symbolEl.getSymbolPath();

  if (seriesModel.get('layout') === 'radial') {
    var realRoot = virtualRoot.children[0];
    var rootLayout = realRoot.getLayout();
    var length_1 = realRoot.children.length;
    var rad = void 0;
    var isLeft = void 0;

    if (targetLayout.x === rootLayout.x && node.isExpand === true) {
      var center = {
        x: (realRoot.children[0].getLayout().x + realRoot.children[length_1 - 1].getLayout().x) / 2,
        y: (realRoot.children[0].getLayout().y + realRoot.children[length_1 - 1].getLayout().y) / 2
      };
      rad = Math.atan2(center.y - rootLayout.y, center.x - rootLayout.x);

      if (rad < 0) {
        rad = Math.PI * 2 + rad;
      }

      isLeft = center.x < rootLayout.x;

      if (isLeft) {
        rad = rad - Math.PI;
      }
    } else {
      rad = Math.atan2(targetLayout.y - rootLayout.y, targetLayout.x - rootLayout.x);

      if (rad < 0) {
        rad = Math.PI * 2 + rad;
      }

      if (node.children.length === 0 || node.children.length !== 0 && node.isExpand === false) {
        isLeft = targetLayout.x < rootLayout.x;

        if (isLeft) {
          rad = rad - Math.PI;
        }
      } else {
        isLeft = targetLayout.x > rootLayout.x;

        if (!isLeft) {
          rad = rad - Math.PI;
        }
      }
    }

    var textPosition = isLeft ? 'left' : 'right';
    var normalLabelModel = itemModel.getModel('label');
    var rotate = normalLabelModel.get('rotate');
    var labelRotateRadian = rotate * (Math.PI / 180);
    var textContent = symbolPath.getTextContent();

    if (textContent) {
      symbolPath.setTextConfig({
        position: normalLabelModel.get('position') || textPosition,
        rotation: rotate == null ? -rad : labelRotateRadian,
        origin: 'center'
      });
      textContent.setStyle('verticalAlign', 'middle');
    }
  } // Handle status


  var focus = itemModel.get(['emphasis', 'focus']);
  var focusDataIndices = focus === 'ancestor' ? node.getAncestorsIndices() : focus === 'descendant' ? node.getDescendantIndices() : null;

  if (focusDataIndices) {
    // Modify the focus to data indices.
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_innerStore_js__["a" /* getECData */])(symbolEl).focus = focusDataIndices;
  }

  drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group);

  if (symbolEl.__edge) {
    symbolEl.onHoverStateChange = function (toState) {
      if (toState !== 'blur') {
        // NOTE: Ensure the parent elements will been blurred firstly.
        // According to the return of getAncestorsIndices and getDescendantIndices
        // TODO: A bit tricky.
        var parentEl = node.parentNode && data.getItemGraphicEl(node.parentNode.dataIndex);

        if (!(parentEl && parentEl.hoverState === __WEBPACK_IMPORTED_MODULE_14__util_states_js__["u" /* HOVER_STATE_BLUR */])) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_states_js__["L" /* setStatesFlag */])(symbolEl.__edge, toState);
        }
      }
    };
  }
}

function drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group) {
  var itemModel = node.getModel();
  var edgeShape = seriesModel.get('edgeShape');
  var layout = seriesModel.get('layout');
  var orient = seriesModel.getOrient();
  var curvature = seriesModel.get(['lineStyle', 'curveness']);
  var edgeForkPosition = seriesModel.get('edgeForkPosition');
  var lineStyle = itemModel.getModel('lineStyle').getLineStyle();
  var edge = symbolEl.__edge;

  if (edgeShape === 'curve') {
    if (node.parentNode && node.parentNode !== virtualRoot) {
      if (!edge) {
        edge = symbolEl.__edge = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["BezierCurve"]({
          shape: getEdgeShape(layout, orient, curvature, sourceOldLayout, sourceOldLayout)
        });
      }

      __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["updateProps"](edge, {
        shape: getEdgeShape(layout, orient, curvature, sourceLayout, targetLayout)
      }, seriesModel);
    }
  } else if (edgeShape === 'polyline') {
    if (layout === 'orthogonal') {
      if (node !== virtualRoot && node.children && node.children.length !== 0 && node.isExpand === true) {
        var children = node.children;
        var childPoints = [];

        for (var i = 0; i < children.length; i++) {
          var childLayout = children[i].getLayout();
          childPoints.push([childLayout.x, childLayout.y]);
        }

        if (!edge) {
          edge = symbolEl.__edge = new TreePath({
            shape: {
              parentPoint: [targetLayout.x, targetLayout.y],
              childPoints: [[targetLayout.x, targetLayout.y]],
              orient: orient,
              forkPosition: edgeForkPosition
            }
          });
        }

        __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["updateProps"](edge, {
          shape: {
            parentPoint: [targetLayout.x, targetLayout.y],
            childPoints: childPoints
          }
        }, seriesModel);
      }
    } else {
      if (true) {
        throw new Error('The polyline edgeShape can only be used in orthogonal layout');
      }
    }
  }

  if (edge) {
    edge.useStyle(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"]({
      strokeNoScale: true,
      fill: null
    }, lineStyle));
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_states_js__["F" /* setStatesStylesFromModel */])(edge, itemModel, 'lineStyle');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_states_js__["H" /* setDefaultStateProxy */])(edge);
    group.add(edge);
  }
}

function removeNodeEdge(node, data, group, seriesModel, removeAnimationOpt) {
  var virtualRoot = data.tree.root;

  var _a = getSourceNode(virtualRoot, node),
      source = _a.source,
      sourceLayout = _a.sourceLayout;

  var symbolEl = data.getItemGraphicEl(node.dataIndex);

  if (!symbolEl) {
    return;
  }

  var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
  var sourceEdge = sourceSymbolEl.__edge; // 1. when expand the sub tree, delete the children node should delete the edge of
  // the source at the same time. because the polyline edge shape is only owned by the source.
  // 2.when the node is the only children of the source, delete the node should delete the edge of
  // the source at the same time. the same reason as above.

  var edge = symbolEl.__edge || (source.isExpand === false || source.children.length === 1 ? sourceEdge : undefined);
  var edgeShape = seriesModel.get('edgeShape');
  var layoutOpt = seriesModel.get('layout');
  var orient = seriesModel.get('orient');
  var curvature = seriesModel.get(['lineStyle', 'curveness']);

  if (edge) {
    if (edgeShape === 'curve') {
      __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["removeElement"](edge, {
        shape: getEdgeShape(layoutOpt, orient, curvature, sourceLayout, sourceLayout),
        style: {
          opacity: 0
        }
      }, seriesModel, {
        cb: function () {
          group.remove(edge);
        },
        removeOpt: removeAnimationOpt
      });
    } else if (edgeShape === 'polyline' && seriesModel.get('layout') === 'orthogonal') {
      __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["removeElement"](edge, {
        shape: {
          parentPoint: [sourceLayout.x, sourceLayout.y],
          childPoints: [[sourceLayout.x, sourceLayout.y]]
        },
        style: {
          opacity: 0
        }
      }, seriesModel, {
        cb: function () {
          group.remove(edge);
        },
        removeOpt: removeAnimationOpt
      });
    }
  }
}

function getSourceNode(virtualRoot, node) {
  var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
  var sourceLayout;

  while (sourceLayout = source.getLayout(), sourceLayout == null) {
    source = source.parentNode === virtualRoot ? source : source.parentNode || source;
  }

  return {
    source: source,
    sourceLayout: sourceLayout
  };
}

function removeNode(data, dataIndex, symbolEl, group, seriesModel) {
  var node = data.tree.getNodeByDataIndex(dataIndex);
  var virtualRoot = data.tree.root;
  var sourceLayout = getSourceNode(virtualRoot, node).sourceLayout; // Use same duration and easing with update to have more consistent animation.

  var removeAnimationOpt = {
    duration: seriesModel.get('animationDurationUpdate'),
    easing: seriesModel.get('animationEasingUpdate')
  };
  __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["removeElement"](symbolEl, {
    x: sourceLayout.x + 1,
    y: sourceLayout.y + 1
  }, seriesModel, {
    cb: function () {
      group.remove(symbolEl);
      data.setItemGraphicEl(dataIndex, null);
    },
    removeOpt: removeAnimationOpt
  });
  symbolEl.fadeOut(null, data.hostModel, {
    fadeLabel: true,
    animation: removeAnimationOpt
  }); // remove edge as parent node

  node.children.forEach(function (childNode) {
    removeNodeEdge(childNode, data, group, seriesModel, removeAnimationOpt);
  }); // remove edge as child node

  removeNodeEdge(node, data, group, seriesModel, removeAnimationOpt);
}

function getEdgeShape(layoutOpt, orient, curvature, sourceLayout, targetLayout) {
  var cpx1;
  var cpy1;
  var cpx2;
  var cpy2;
  var x1;
  var x2;
  var y1;
  var y2;

  if (layoutOpt === 'radial') {
    x1 = sourceLayout.rawX;
    y1 = sourceLayout.rawY;
    x2 = targetLayout.rawX;
    y2 = targetLayout.rawY;
    var radialCoor1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__layoutHelper_js__["f" /* radialCoordinate */])(x1, y1);
    var radialCoor2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__layoutHelper_js__["f" /* radialCoordinate */])(x1, y1 + (y2 - y1) * curvature);
    var radialCoor3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__layoutHelper_js__["f" /* radialCoordinate */])(x2, y2 + (y1 - y2) * curvature);
    var radialCoor4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__layoutHelper_js__["f" /* radialCoordinate */])(x2, y2);
    return {
      x1: radialCoor1.x || 0,
      y1: radialCoor1.y || 0,
      x2: radialCoor4.x || 0,
      y2: radialCoor4.y || 0,
      cpx1: radialCoor2.x || 0,
      cpy1: radialCoor2.y || 0,
      cpx2: radialCoor3.x || 0,
      cpy2: radialCoor3.y || 0
    };
  } else {
    x1 = sourceLayout.x;
    y1 = sourceLayout.y;
    x2 = targetLayout.x;
    y2 = targetLayout.y;

    if (orient === 'LR' || orient === 'RL') {
      cpx1 = x1 + (x2 - x1) * curvature;
      cpy1 = y1;
      cpx2 = x2 + (x1 - x2) * curvature;
      cpy2 = y2;
    }

    if (orient === 'TB' || orient === 'BT') {
      cpx1 = x1;
      cpy1 = y1 + (y2 - y1) * curvature;
      cpx2 = x2;
      cpy2 = y2 + (y1 - y2) * curvature;
    }
  }

  return {
    x1: x1,
    y1: y1,
    x2: x2,
    y2: y2,
    cpx1: cpx1,
    cpy1: cpy1,
    cpx2: cpx2,
    cpy2: cpy2
  };
}

/* harmony default export */ __webpack_exports__["a"] = (TreeView);

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TreeView_js__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TreeSeries_js__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__treeLayout_js__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__treeVisual_js__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__treeAction_js__ = __webpack_require__(1184);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





function install(registers) {
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_0__TreeView_js__["a" /* default */]);
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_1__TreeSeries_js__["a" /* default */]);
  registers.registerLayout(__WEBPACK_IMPORTED_MODULE_2__treeLayout_js__["a" /* default */]);
  registers.registerVisual(__WEBPACK_IMPORTED_MODULE_3__treeVisual_js__["a" /* default */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__treeAction_js__["a" /* installTreeAction */])(registers);
}

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eachAfter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return eachBefore; });

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Traverse the tree from bottom to top and do something
 */
function eachAfter(root, callback, separation) {
  var nodes = [root];
  var next = [];
  var node;

  while (node = nodes.pop()) {
    // jshint ignore:line
    next.push(node);

    if (node.isExpand) {
      var children = node.children;

      if (children.length) {
        for (var i = 0; i < children.length; i++) {
          nodes.push(children[i]);
        }
      }
    }
  }

  while (node = next.pop()) {
    // jshint ignore:line
    callback(node, separation);
  }
}
/**
 * Traverse the tree from top to bottom and do something
 */


function eachBefore(root, callback) {
  var nodes = [root];
  var node;

  while (node = nodes.pop()) {
    // jshint ignore:line
    callback(node);

    if (node.isExpand) {
      var children = node.children;

      if (children.length) {
        for (var i = children.length - 1; i >= 0; i--) {
          nodes.push(children[i]);
        }
      }
    }
  }
}



/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = installTreeAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_roamHelper_js__ = __webpack_require__(311);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

function installTreeAction(registers) {
  registers.registerAction({
    type: 'treeExpandAndCollapse',
    event: 'treeExpandAndCollapse',
    update: 'update'
  }, function (payload, ecModel) {
    ecModel.eachComponent({
      mainType: 'series',
      subType: 'tree',
      query: payload
    }, function (seriesModel) {
      var dataIndex = payload.dataIndex;
      var tree = seriesModel.getData().tree;
      var node = tree.getNodeByDataIndex(dataIndex);
      node.isExpand = !node.isExpand;
    });
  });
  registers.registerAction({
    type: 'treeRoam',
    event: 'treeRoam',
    // Here we set 'none' instead of 'update', because roam action
    // just need to update the transform matrix without having to recalculate
    // the layout. So don't need to go through the whole update process, such
    // as 'dataPrcocess', 'coordSystemUpdate', 'layout' and so on.
    update: 'none'
  }, function (payload, ecModel) {
    ecModel.eachComponent({
      mainType: 'series',
      subType: 'tree',
      query: payload
    }, function (seriesModel) {
      var coordSys = seriesModel.coordinateSystem;
      var res = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__action_roamHelper_js__["a" /* updateCenterAndZoom */])(coordSys, payload);
      seriesModel.setCenter && seriesModel.setCenter(res.center);
      seriesModel.setZoom && seriesModel.setZoom(res.zoom);
    });
  });
}

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = treeLayout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__traversalHelper_js__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layoutHelper_js__ = __webpack_require__(456);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


function treeLayout(ecModel, api) {
  ecModel.eachSeriesByType('tree', function (seriesModel) {
    commonLayout(seriesModel, api);
  });
}

function commonLayout(seriesModel, api) {
  var layoutInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__layoutHelper_js__["a" /* getViewRect */])(seriesModel, api);
  seriesModel.layoutInfo = layoutInfo;
  var layout = seriesModel.get('layout');
  var width = 0;
  var height = 0;
  var separation = null;

  if (layout === 'radial') {
    width = 2 * Math.PI;
    height = Math.min(layoutInfo.height, layoutInfo.width) / 2;
    separation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__layoutHelper_js__["b" /* separation */])(function (node1, node2) {
      return (node1.parentNode === node2.parentNode ? 1 : 2) / node1.depth;
    });
  } else {
    width = layoutInfo.width;
    height = layoutInfo.height;
    separation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__layoutHelper_js__["b" /* separation */])();
  }

  var virtualRoot = seriesModel.getData().tree.root;
  var realRoot = virtualRoot.children[0];

  if (realRoot) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__layoutHelper_js__["c" /* init */])(virtualRoot);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__traversalHelper_js__["a" /* eachAfter */])(realRoot, __WEBPACK_IMPORTED_MODULE_1__layoutHelper_js__["d" /* firstWalk */], separation);
    virtualRoot.hierNode.modifier = -realRoot.hierNode.prelim;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__traversalHelper_js__["b" /* eachBefore */])(realRoot, __WEBPACK_IMPORTED_MODULE_1__layoutHelper_js__["e" /* secondWalk */]);
    var left_1 = realRoot;
    var right_1 = realRoot;
    var bottom_1 = realRoot;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__traversalHelper_js__["b" /* eachBefore */])(realRoot, function (node) {
      var x = node.getLayout().x;

      if (x < left_1.getLayout().x) {
        left_1 = node;
      }

      if (x > right_1.getLayout().x) {
        right_1 = node;
      }

      if (node.depth > bottom_1.depth) {
        bottom_1 = node;
      }
    });
    var delta = left_1 === right_1 ? 1 : separation(left_1, right_1) / 2;
    var tx_1 = delta - left_1.getLayout().x;
    var kx_1 = 0;
    var ky_1 = 0;
    var coorX_1 = 0;
    var coorY_1 = 0;

    if (layout === 'radial') {
      kx_1 = width / (right_1.getLayout().x + delta + tx_1); // here we use (node.depth - 1), bucause the real root's depth is 1

      ky_1 = height / (bottom_1.depth - 1 || 1);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__traversalHelper_js__["b" /* eachBefore */])(realRoot, function (node) {
        coorX_1 = (node.getLayout().x + tx_1) * kx_1;
        coorY_1 = (node.depth - 1) * ky_1;
        var finalCoor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__layoutHelper_js__["f" /* radialCoordinate */])(coorX_1, coorY_1);
        node.setLayout({
          x: finalCoor.x,
          y: finalCoor.y,
          rawX: coorX_1,
          rawY: coorY_1
        }, true);
      });
    } else {
      var orient_1 = seriesModel.getOrient();

      if (orient_1 === 'RL' || orient_1 === 'LR') {
        ky_1 = height / (right_1.getLayout().x + delta + tx_1);
        kx_1 = width / (bottom_1.depth - 1 || 1);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__traversalHelper_js__["b" /* eachBefore */])(realRoot, function (node) {
          coorY_1 = (node.getLayout().x + tx_1) * ky_1;
          coorX_1 = orient_1 === 'LR' ? (node.depth - 1) * kx_1 : width - (node.depth - 1) * kx_1;
          node.setLayout({
            x: coorX_1,
            y: coorY_1
          }, true);
        });
      } else if (orient_1 === 'TB' || orient_1 === 'BT') {
        kx_1 = width / (right_1.getLayout().x + delta + tx_1);
        ky_1 = height / (bottom_1.depth - 1 || 1);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__traversalHelper_js__["b" /* eachBefore */])(realRoot, function (node) {
          coorX_1 = (node.getLayout().x + tx_1) * kx_1;
          coorY_1 = orient_1 === 'TB' ? (node.depth - 1) * ky_1 : height - (node.depth - 1) * ky_1;
          node.setLayout({
            x: coorX_1,
            y: coorY_1
          }, true);
        });
      }
    }
  }
}

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = treeVisual;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

function treeVisual(ecModel) {
  ecModel.eachSeriesByType('tree', function (seriesModel) {
    var data = seriesModel.getData();
    var tree = data.tree;
    tree.eachNode(function (node) {
      var model = node.getModel(); // TODO Optimize

      var style = model.getModel('itemStyle').getItemStyle();
      var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, 'style');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"])(existsStyle, style);
    });
  });
}

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_treeHelper_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_states_js__ = __webpack_require__(12);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







var TEXT_PADDING = 8;
var ITEM_GAP = 8;
var ARRAY_LENGTH = 5;

var Breadcrumb =
/** @class */
function () {
  function Breadcrumb(containerGroup) {
    this.group = new __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Group"]();
    containerGroup.add(this.group);
  }

  Breadcrumb.prototype.render = function (seriesModel, api, targetNode, onSelect) {
    var model = seriesModel.getModel('breadcrumb');
    var thisGroup = this.group;
    thisGroup.removeAll();

    if (!model.get('show') || !targetNode) {
      return;
    }

    var normalStyleModel = model.getModel('itemStyle'); // let emphasisStyleModel = model.getModel('emphasis.itemStyle');

    var textStyleModel = normalStyleModel.getModel('textStyle');
    var layoutParam = {
      pos: {
        left: model.get('left'),
        right: model.get('right'),
        top: model.get('top'),
        bottom: model.get('bottom')
      },
      box: {
        width: api.getWidth(),
        height: api.getHeight()
      },
      emptyItemWidth: model.get('emptyItemWidth'),
      totalWidth: 0,
      renderList: []
    };

    this._prepare(targetNode, layoutParam, textStyleModel);

    this._renderContent(seriesModel, layoutParam, normalStyleModel, textStyleModel, onSelect);

    __WEBPACK_IMPORTED_MODULE_2__util_layout_js__["e" /* positionElement */](thisGroup, layoutParam.pos, layoutParam.box);
  };
  /**
   * Prepare render list and total width
   * @private
   */


  Breadcrumb.prototype._prepare = function (targetNode, layoutParam, textStyleModel) {
    for (var node = targetNode; node; node = node.parentNode) {
      var text = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_model_js__["n" /* convertOptionIdName */])(node.getModel().get('name'), '');
      var textRect = textStyleModel.getTextRect(text);
      var itemWidth = Math.max(textRect.width + TEXT_PADDING * 2, layoutParam.emptyItemWidth);
      layoutParam.totalWidth += itemWidth + ITEM_GAP;
      layoutParam.renderList.push({
        node: node,
        text: text,
        width: itemWidth
      });
    }
  };
  /**
   * @private
   */


  Breadcrumb.prototype._renderContent = function (seriesModel, layoutParam, normalStyleModel, textStyleModel, onSelect) {
    // Start rendering.
    var lastX = 0;
    var emptyItemWidth = layoutParam.emptyItemWidth;
    var height = seriesModel.get(['breadcrumb', 'height']);
    var availableSize = __WEBPACK_IMPORTED_MODULE_2__util_layout_js__["j" /* getAvailableSize */](layoutParam.pos, layoutParam.box);
    var totalWidth = layoutParam.totalWidth;
    var renderList = layoutParam.renderList;

    for (var i = renderList.length - 1; i >= 0; i--) {
      var item = renderList[i];
      var itemNode = item.node;
      var itemWidth = item.width;
      var text = item.text; // Hdie text and shorten width if necessary.

      if (totalWidth > availableSize.width) {
        totalWidth -= itemWidth - emptyItemWidth;
        itemWidth = emptyItemWidth;
        text = null;
      }

      var el = new __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Polygon"]({
        shape: {
          points: makeItemPoints(lastX, 0, itemWidth, height, i === renderList.length - 1, i === 0)
        },
        style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["defaults"])(normalStyleModel.getItemStyle(), {
          lineJoin: 'bevel'
        }),
        textContent: new __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Text"]({
          style: {
            text: text,
            fill: textStyleModel.getTextColor(),
            font: textStyleModel.getFont()
          }
        }),
        textConfig: {
          position: 'inside'
        },
        z2: __WEBPACK_IMPORTED_MODULE_6__util_states_js__["J" /* Z2_EMPHASIS_LIFT */] * 1e4,
        onclick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["curry"])(onSelect, itemNode)
      });
      el.disableLabelAnimation = true;
      this.group.add(el);
      packEventData(el, seriesModel, itemNode);
      lastX += itemWidth + ITEM_GAP;
    }
  };

  Breadcrumb.prototype.remove = function () {
    this.group.removeAll();
  };

  return Breadcrumb;
}();

function makeItemPoints(x, y, itemWidth, itemHeight, head, tail) {
  var points = [[head ? x : x - ARRAY_LENGTH, y], [x + itemWidth, y], [x + itemWidth, y + itemHeight], [head ? x : x - ARRAY_LENGTH, y + itemHeight]];
  !tail && points.splice(2, 0, [x + itemWidth + ARRAY_LENGTH, y + itemHeight / 2]);
  !head && points.push([x, y + itemHeight / 2]);
  return points;
} // Package custom mouse event.


function packEventData(el, seriesModel, itemNode) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_innerStore_js__["a" /* getECData */])(el).eventData = {
    componentType: 'series',
    componentSubType: 'treemap',
    componentIndex: seriesModel.componentIndex,
    seriesIndex: seriesModel.seriesIndex,
    seriesName: seriesModel.name,
    seriesType: 'treemap',
    selfType: 'breadcrumb',
    nodeData: {
      dataIndex: itemNode && itemNode.dataIndex,
      name: itemNode && itemNode.name
    },
    treePathInfo: itemNode && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper_treeHelper_js__["c" /* wrapTreePathInfo */])(itemNode, seriesModel)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Breadcrumb);

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_Series_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_Tree_js__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_Model_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_treeHelper_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_tooltip_tooltipMarkup_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helper_enableAriaDecalForTree_js__ = __webpack_require__(448);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/










var TreemapSeriesModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(TreemapSeriesModel, _super);

  function TreemapSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = TreemapSeriesModel.type;
    _this.preventUsingHoverLayer = true;
    return _this;
  }
  /**
   * @override
   */


  TreemapSeriesModel.prototype.getInitialData = function (option, ecModel) {
    // Create a virtual root.
    var root = {
      name: option.name,
      children: option.data
    };
    completeTreeValue(root);
    var levels = option.levels || []; // Used in "visual priority" in `treemapVisual.js`.
    // This way is a little tricky, must satisfy the precondition:
    //   1. There is no `treeNode.getModel('itemStyle.xxx')` used.
    //   2. The `Model.prototype.getModel()` will not use any clone-like way.

    var designatedVisualItemStyle = this.designatedVisualItemStyle = {};
    var designatedVisualModel = new __WEBPACK_IMPORTED_MODULE_4__model_Model_js__["a" /* default */]({
      itemStyle: designatedVisualItemStyle
    }, this, ecModel);
    levels = option.levels = setDefault(levels, ecModel);
    var levelModels = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"](levels || [], function (levelDefine) {
      return new __WEBPACK_IMPORTED_MODULE_4__model_Model_js__["a" /* default */](levelDefine, designatedVisualModel, ecModel);
    }, this); // Make sure always a new tree is created when setOption,
    // in TreemapView, we check whether oldTree === newTree
    // to choose mappings approach among old shapes and new shapes.

    var tree = __WEBPACK_IMPORTED_MODULE_3__data_Tree_js__["a" /* default */].createTree(root, this, beforeLink);

    function beforeLink(nodeData) {
      nodeData.wrapMethod('getItemModel', function (model, idx) {
        var node = tree.getNodeByDataIndex(idx);
        var levelModel = node ? levelModels[node.depth] : null; // If no levelModel, we also need `designatedVisualModel`.

        model.parentModel = levelModel || designatedVisualModel;
        return model;
      });
    }

    return tree.data;
  };

  TreemapSeriesModel.prototype.optionUpdated = function () {
    this.resetViewRoot();
  };
  /**
   * @override
   * @param {number} dataIndex
   * @param {boolean} [mutipleSeries=false]
   */


  TreemapSeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    var data = this.getData();
    var value = this.getRawValue(dataIndex);
    var name = data.getName(dataIndex);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__component_tooltip_tooltipMarkup_js__["b" /* createTooltipMarkup */])('nameValue', {
      name: name,
      value: value
    });
  };
  /**
   * Add tree path to tooltip param
   *
   * @override
   * @param {number} dataIndex
   * @return {Object}
   */


  TreemapSeriesModel.prototype.getDataParams = function (dataIndex) {
    var params = _super.prototype.getDataParams.apply(this, arguments);

    var node = this.getData().tree.getNodeByDataIndex(dataIndex);
    params.treeAncestors = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helper_treeHelper_js__["c" /* wrapTreePathInfo */])(node, this); // compatitable the previous code.

    params.treePathInfo = params.treeAncestors;
    return params;
  };
  /**
   * @public
   * @param {Object} layoutInfo {
   *                                x: containerGroup x
   *                                y: containerGroup y
   *                                width: containerGroup width
   *                                height: containerGroup height
   *                            }
   */


  TreemapSeriesModel.prototype.setLayoutInfo = function (layoutInfo) {
    /**
     * @readOnly
     * @type {Object}
     */
    this.layoutInfo = this.layoutInfo || {};
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"](this.layoutInfo, layoutInfo);
  };
  /**
   * @param  {string} id
   * @return {number} index
   */


  TreemapSeriesModel.prototype.mapIdToIndex = function (id) {
    // A feature is implemented:
    // index is monotone increasing with the sequence of
    // input id at the first time.
    // This feature can make sure that each data item and its
    // mapped color have the same index between data list and
    // color list at the beginning, which is useful for user
    // to adjust data-color mapping.

    /**
     * @private
     * @type {Object}
     */
    var idIndexMap = this._idIndexMap;

    if (!idIndexMap) {
      idIndexMap = this._idIndexMap = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"]();
      /**
       * @private
       * @type {number}
       */

      this._idIndexMapCount = 0;
    }

    var index = idIndexMap.get(id);

    if (index == null) {
      idIndexMap.set(id, index = this._idIndexMapCount++);
    }

    return index;
  };

  TreemapSeriesModel.prototype.getViewRoot = function () {
    return this._viewRoot;
  };

  TreemapSeriesModel.prototype.resetViewRoot = function (viewRoot) {
    viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
    var root = this.getRawData().tree.root;

    if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) {
      this._viewRoot = root;
    }
  };

  TreemapSeriesModel.prototype.enableAriaDecal = function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helper_enableAriaDecalForTree_js__["a" /* default */])(this);
  };

  TreemapSeriesModel.type = 'series.treemap';
  TreemapSeriesModel.layoutMode = 'box';
  TreemapSeriesModel.defaultOption = {
    // Disable progressive rendering
    progressive: 0,
    // size: ['80%', '80%'],            // deprecated, compatible with ec2.
    left: 'center',
    top: 'middle',
    width: '80%',
    height: '80%',
    sort: true,
    clipWindow: 'origin',
    squareRatio: 0.5 * (1 + Math.sqrt(5)),
    leafDepth: null,
    drillDownIcon: '▶',
    // to align specialized icon. ▷▶❒❐▼✚
    zoomToNodeRatio: 0.32 * 0.32,
    roam: true,
    nodeClick: 'zoomToNode',
    animation: true,
    animationDurationUpdate: 900,
    animationEasing: 'quinticInOut',
    breadcrumb: {
      show: true,
      height: 22,
      left: 'center',
      top: 'bottom',
      // right
      // bottom
      emptyItemWidth: 25,
      itemStyle: {
        color: 'rgba(0,0,0,0.7)',
        textStyle: {
          color: '#fff'
        }
      }
    },
    label: {
      show: true,
      // Do not use textDistance, for ellipsis rect just the same as treemap node rect.
      distance: 0,
      padding: 5,
      position: 'inside',
      // formatter: null,
      color: '#fff',
      overflow: 'truncate' // align
      // verticalAlign

    },
    upperLabel: {
      show: false,
      position: [0, '50%'],
      height: 20,
      // formatter: null,
      // color: '#fff',
      overflow: 'truncate',
      // align: null,
      verticalAlign: 'middle'
    },
    itemStyle: {
      color: null,
      colorAlpha: null,
      colorSaturation: null,
      borderWidth: 0,
      gapWidth: 0,
      borderColor: '#fff',
      borderColorSaturation: null // If specified, borderColor will be ineffective, and the
      // border color is evaluated by color of current node and
      // borderColorSaturation.

    },
    emphasis: {
      upperLabel: {
        show: true,
        position: [0, '50%'],
        overflow: 'truncate',
        verticalAlign: 'middle'
      }
    },
    visualDimension: 0,
    visualMin: null,
    visualMax: null,
    color: [],
    // level[n].color (if necessary).
    // + Specify color list of each level. level[0].color would be global
    // color list if not specified. (see method `setDefault`).
    // + But set as a empty array to forbid fetch color from global palette
    // when using nodeModel.get('color'), otherwise nodes on deep level
    // will always has color palette set and are not able to inherit color
    // from parent node.
    // + TreemapSeries.color can not be set as 'none', otherwise effect
    // legend color fetching (see seriesColor.js).
    colorAlpha: null,
    colorSaturation: null,
    colorMappingBy: 'index',
    visibleMin: 10,
    // be rendered. Only works when sort is 'asc' or 'desc'.
    childrenVisibleMin: null,
    // grandchildren will not show.
    // Why grandchildren? If not grandchildren but children,
    // some siblings show children and some not,
    // the appearance may be mess and not consistent,
    levels: [] // Each item: {
    //     visibleMin, itemStyle, visualDimension, label
    // }
    // data: {
    //      value: [],
    //      children: [],
    //      link: 'http://xxx.xxx.xxx',
    //      target: 'blank' or 'self'
    // }

  };
  return TreemapSeriesModel;
}(__WEBPACK_IMPORTED_MODULE_2__model_Series_js__["b" /* default */]);
/**
 * @param {Object} dataNode
 */


function completeTreeValue(dataNode) {
  // Postorder travel tree.
  // If value of none-leaf node is not set,
  // calculate it by suming up the value of all children.
  var sum = 0;
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](dataNode.children, function (child) {
    completeTreeValue(child);
    var childValue = child.value;
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](childValue) && (childValue = childValue[0]);
    sum += childValue;
  });
  var thisValue = dataNode.value;

  if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](thisValue)) {
    thisValue = thisValue[0];
  }

  if (thisValue == null || isNaN(thisValue)) {
    thisValue = sum;
  } // Value should not less than 0.


  if (thisValue < 0) {
    thisValue = 0;
  }

  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
}
/**
 * set default to level configuration
 */


function setDefault(levels, ecModel) {
  var globalColorList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_model_js__["d" /* normalizeToArray */])(ecModel.get('color'));
  var globalDecalList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_model_js__["d" /* normalizeToArray */])(ecModel.get(['aria', 'decal', 'decals']));

  if (!globalColorList) {
    return;
  }

  levels = levels || [];
  var hasColorDefine;
  var hasDecalDefine;
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](levels, function (levelDefine) {
    var model = new __WEBPACK_IMPORTED_MODULE_4__model_Model_js__["a" /* default */](levelDefine);
    var modelColor = model.get('color');
    var modelDecal = model.get('decal');

    if (model.get(['itemStyle', 'color']) || modelColor && modelColor !== 'none') {
      hasColorDefine = true;
    }

    if (model.get(['itemStyle', 'decal']) || modelDecal && modelDecal !== 'none') {
      hasDecalDefine = true;
    }
  });
  var level0 = levels[0] || (levels[0] = {});

  if (!hasColorDefine) {
    level0.color = globalColorList.slice();
  }

  if (!hasDecalDefine && globalDecalList) {
    level0.decal = globalDecalList.slice();
  }

  return levels;
}

/* harmony default export */ __webpack_exports__["a"] = (TreemapSeriesModel);

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_DataDiffer_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_treeHelper_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Breadcrumb_js__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_helper_RoamController_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_zrender_lib_core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_matrix_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_animation_js__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__model_mixin_makeStyleMapper_js__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_zrender_lib_graphic_Displayable_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_format_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__label_labelStyle_js__ = __webpack_require__(15);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


















var Group = __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Group"];
var Rect = __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Rect"];
var DRAG_THRESHOLD = 3;
var PATH_LABEL_NOAMAL = 'label';
var PATH_UPPERLABEL_NORMAL = 'upperLabel'; // Should larger than emphasis states lift z

var Z2_BASE = __WEBPACK_IMPORTED_MODULE_4__util_states_js__["J" /* Z2_EMPHASIS_LIFT */] * 10; // Should bigger than every z2.

var Z2_BG = __WEBPACK_IMPORTED_MODULE_4__util_states_js__["J" /* Z2_EMPHASIS_LIFT */] * 2;
var Z2_CONTENT = __WEBPACK_IMPORTED_MODULE_4__util_states_js__["J" /* Z2_EMPHASIS_LIFT */] * 3;
var getStateItemStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__model_mixin_makeStyleMapper_js__["a" /* default */])([['fill', 'color'], // `borderColor` and `borderWidth` has been occupied,
// so use `stroke` to indicate the stroke of the rect.
['stroke', 'strokeColor'], ['lineWidth', 'strokeWidth'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor'] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
// So do not transfer decal directly.
]);

var getItemStyleNormal = function (model) {
  // Normal style props should include emphasis style props.
  var itemStyle = getStateItemStyle(model); // Clear styles set by emphasis.

  itemStyle.stroke = itemStyle.fill = itemStyle.lineWidth = null;
  return itemStyle;
};

var inner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_model_js__["a" /* makeInner */])();

var TreemapView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(TreemapView, _super);

  function TreemapView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = TreemapView.type;
    _this._state = 'ready';
    _this._storage = createStorage();
    return _this;
  }
  /**
   * @override
   */


  TreemapView.prototype.render = function (seriesModel, ecModel, api, payload) {
    var models = ecModel.findComponents({
      mainType: 'series',
      subType: 'treemap',
      query: payload
    });

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["indexOf"])(models, seriesModel) < 0) {
      return;
    }

    this.seriesModel = seriesModel;
    this.api = api;
    this.ecModel = ecModel;
    var types = ['treemapZoomToNode', 'treemapRootToNode'];
    var targetInfo = __WEBPACK_IMPORTED_MODULE_6__helper_treeHelper_js__["a" /* retrieveTargetInfo */](payload, types, seriesModel);
    var payloadType = payload && payload.type;
    var layoutInfo = seriesModel.layoutInfo;
    var isInit = !this._oldTree;
    var thisStorage = this._storage; // Mark new root when action is treemapRootToNode.

    var reRoot = payloadType === 'treemapRootToNode' && targetInfo && thisStorage ? {
      rootNodeGroup: thisStorage.nodeGroup[targetInfo.node.getRawIndex()],
      direction: payload.direction
    } : null;

    var containerGroup = this._giveContainerGroup(layoutInfo);

    var hasAnimation = seriesModel.get('animation');

    var renderResult = this._doRender(containerGroup, seriesModel, reRoot);

    hasAnimation && !isInit && (!payloadType || payloadType === 'treemapZoomToNode' || payloadType === 'treemapRootToNode') ? this._doAnimation(containerGroup, renderResult, seriesModel, reRoot) : renderResult.renderFinally();

    this._resetController(api);

    this._renderBreadcrumb(seriesModel, api, targetInfo);
  };

  TreemapView.prototype._giveContainerGroup = function (layoutInfo) {
    var containerGroup = this._containerGroup;

    if (!containerGroup) {
      // FIXME
      // 加一层containerGroup是为了clip，但是现在clip功能并没有实现。
      containerGroup = this._containerGroup = new Group();

      this._initEvents(containerGroup);

      this.group.add(containerGroup);
    }

    containerGroup.x = layoutInfo.x;
    containerGroup.y = layoutInfo.y;
    return containerGroup;
  };

  TreemapView.prototype._doRender = function (containerGroup, seriesModel, reRoot) {
    var thisTree = seriesModel.getData().tree;
    var oldTree = this._oldTree; // Clear last shape records.

    var lastsForAnimation = createStorage();
    var thisStorage = createStorage();
    var oldStorage = this._storage;
    var willInvisibleEls = [];

    function doRenderNode(thisNode, oldNode, parentGroup, depth) {
      return renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth);
    } // Notice: when thisTree and oldTree are the same tree (see list.cloneShallow),
    // the oldTree is actually losted, so we can not find all of the old graphic
    // elements from tree. So we use this stragegy: make element storage, move
    // from old storage to new storage, clear old storage.


    dualTravel(thisTree.root ? [thisTree.root] : [], oldTree && oldTree.root ? [oldTree.root] : [], containerGroup, thisTree === oldTree || !oldTree, 0); // Process all removing.

    var willDeleteEls = clearStorage(oldStorage);
    this._oldTree = thisTree;
    this._storage = thisStorage;
    return {
      lastsForAnimation: lastsForAnimation,
      willDeleteEls: willDeleteEls,
      renderFinally: renderFinally
    };

    function dualTravel(thisViewChildren, oldViewChildren, parentGroup, sameTree, depth) {
      // When 'render' is triggered by action,
      // 'this' and 'old' may be the same tree,
      // we use rawIndex in that case.
      if (sameTree) {
        oldViewChildren = thisViewChildren;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(thisViewChildren, function (child, index) {
          !child.isRemoved() && processNode(index, index);
        });
      } // Diff hierarchically (diff only in each subtree, but not whole).
      // because, consistency of view is important.
      else {
          new __WEBPACK_IMPORTED_MODULE_5__data_DataDiffer_js__["a" /* default */](oldViewChildren, thisViewChildren, getKey, getKey).add(processNode).update(processNode).remove(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["curry"])(processNode, null)).execute();
        }

      function getKey(node) {
        // Identify by name or raw index.
        return node.getId();
      }

      function processNode(newIndex, oldIndex) {
        var thisNode = newIndex != null ? thisViewChildren[newIndex] : null;
        var oldNode = oldIndex != null ? oldViewChildren[oldIndex] : null;
        var group = doRenderNode(thisNode, oldNode, parentGroup, depth);
        group && dualTravel(thisNode && thisNode.viewChildren || [], oldNode && oldNode.viewChildren || [], group, sameTree, depth + 1);
      }
    }

    function clearStorage(storage) {
      var willDeleteEls = createStorage();
      storage && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(storage, function (store, storageName) {
        var delEls = willDeleteEls[storageName];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(store, function (el) {
          el && (delEls.push(el), inner(el).willDelete = true);
        });
      });
      return willDeleteEls;
    }

    function renderFinally() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(willDeleteEls, function (els) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(els, function (el) {
          el.parent && el.parent.remove(el);
        });
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(willInvisibleEls, function (el) {
        el.invisible = true; // Setting invisible is for optimizing, so no need to set dirty,
        // just mark as invisible.

        el.dirty();
      });
    }
  };

  TreemapView.prototype._doAnimation = function (containerGroup, renderResult, seriesModel, reRoot) {
    var durationOption = seriesModel.get('animationDurationUpdate');
    var easingOption = seriesModel.get('animationEasing'); // TODO: do not support function until necessary.

    var duration = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isFunction"])(durationOption) ? 0 : durationOption) || 0;
    var easing = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isFunction"])(easingOption) ? null : easingOption) || 'cubicOut';
    var animationWrap = __WEBPACK_IMPORTED_MODULE_11__util_animation_js__["a" /* createWrap */](); // Make delete animations.

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(renderResult.willDeleteEls, function (store, storageName) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(store, function (el, rawIndex) {
        if (el.invisible) {
          return;
        }

        var parent = el.parent; // Always has parent, and parent is nodeGroup.

        var target;
        var innerStore = inner(parent);

        if (reRoot && reRoot.direction === 'drillDown') {
          target = parent === reRoot.rootNodeGroup // This is the content element of view root.
          // Only `content` will enter this branch, because
          // `background` and `nodeGroup` will not be deleted.
          ? {
            shape: {
              x: 0,
              y: 0,
              width: innerStore.nodeWidth,
              height: innerStore.nodeHeight
            },
            style: {
              opacity: 0
            }
          } // Others.
          : {
            style: {
              opacity: 0
            }
          };
        } else {
          var targetX = 0;
          var targetY = 0;

          if (!innerStore.willDelete) {
            // Let node animate to right-bottom corner, cooperating with fadeout,
            // which is appropriate for user understanding.
            // Divided by 2 for reRoot rolling up effect.
            targetX = innerStore.nodeWidth / 2;
            targetY = innerStore.nodeHeight / 2;
          }

          target = storageName === 'nodeGroup' ? {
            x: targetX,
            y: targetY,
            style: {
              opacity: 0
            }
          } : {
            shape: {
              x: targetX,
              y: targetY,
              width: 0,
              height: 0
            },
            style: {
              opacity: 0
            }
          };
        } // TODO: do not support delay until necessary.


        target && animationWrap.add(el, target, duration, 0, easing);
      });
    }); // Make other animations

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(this._storage, function (store, storageName) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(store, function (el, rawIndex) {
        var last = renderResult.lastsForAnimation[storageName][rawIndex];
        var target = {};

        if (!last) {
          return;
        }

        if (el instanceof __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Group"]) {
          if (last.oldX != null) {
            target.x = el.x;
            target.y = el.y;
            el.x = last.oldX;
            el.y = last.oldY;
          }
        } else {
          if (last.oldShape) {
            target.shape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])({}, el.shape);
            el.setShape(last.oldShape);
          }

          if (last.fadein) {
            el.setStyle('opacity', 0);
            target.style = {
              opacity: 1
            };
          } // When animation is stopped for succedent animation starting,
          // el.style.opacity might not be 1
          else if (el.style.opacity !== 1) {
              target.style = {
                opacity: 1
              };
            }
        }

        animationWrap.add(el, target, duration, 0, easing);
      });
    }, this);
    this._state = 'animating';
    animationWrap.finished(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(function () {
      this._state = 'ready';
      renderResult.renderFinally();
    }, this)).start();
  };

  TreemapView.prototype._resetController = function (api) {
    var controller = this._controller; // Init controller.

    if (!controller) {
      controller = this._controller = new __WEBPACK_IMPORTED_MODULE_8__component_helper_RoamController_js__["a" /* default */](api.getZr());
      controller.enable(this.seriesModel.get('roam'));
      controller.on('pan', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(this._onPan, this));
      controller.on('zoom', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(this._onZoom, this));
    }

    var rect = new __WEBPACK_IMPORTED_MODULE_9_zrender_lib_core_BoundingRect_js__["a" /* default */](0, 0, api.getWidth(), api.getHeight());
    controller.setPointerChecker(function (e, x, y) {
      return rect.contain(x, y);
    });
  };

  TreemapView.prototype._clearController = function () {
    var controller = this._controller;

    if (controller) {
      controller.dispose();
      controller = null;
    }
  };

  TreemapView.prototype._onPan = function (e) {
    if (this._state !== 'animating' && (Math.abs(e.dx) > DRAG_THRESHOLD || Math.abs(e.dy) > DRAG_THRESHOLD)) {
      // These param must not be cached.
      var root = this.seriesModel.getData().tree.root;

      if (!root) {
        return;
      }

      var rootLayout = root.getLayout();

      if (!rootLayout) {
        return;
      }

      this.api.dispatchAction({
        type: 'treemapMove',
        from: this.uid,
        seriesId: this.seriesModel.id,
        rootRect: {
          x: rootLayout.x + e.dx,
          y: rootLayout.y + e.dy,
          width: rootLayout.width,
          height: rootLayout.height
        }
      });
    }
  };

  TreemapView.prototype._onZoom = function (e) {
    var mouseX = e.originX;
    var mouseY = e.originY;

    if (this._state !== 'animating') {
      // These param must not be cached.
      var root = this.seriesModel.getData().tree.root;

      if (!root) {
        return;
      }

      var rootLayout = root.getLayout();

      if (!rootLayout) {
        return;
      }

      var rect = new __WEBPACK_IMPORTED_MODULE_9_zrender_lib_core_BoundingRect_js__["a" /* default */](rootLayout.x, rootLayout.y, rootLayout.width, rootLayout.height);
      var layoutInfo = this.seriesModel.layoutInfo; // Transform mouse coord from global to containerGroup.

      mouseX -= layoutInfo.x;
      mouseY -= layoutInfo.y; // Scale root bounding rect.

      var m = __WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_matrix_js__["create"]();
      __WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_matrix_js__["translate"](m, m, [-mouseX, -mouseY]);
      __WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_matrix_js__["scale"](m, m, [e.scale, e.scale]);
      __WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_matrix_js__["translate"](m, m, [mouseX, mouseY]);
      rect.applyTransform(m);
      this.api.dispatchAction({
        type: 'treemapRender',
        from: this.uid,
        seriesId: this.seriesModel.id,
        rootRect: {
          x: rect.x,
          y: rect.y,
          width: rect.width,
          height: rect.height
        }
      });
    }
  };

  TreemapView.prototype._initEvents = function (containerGroup) {
    var _this = this;

    containerGroup.on('click', function (e) {
      if (_this._state !== 'ready') {
        return;
      }

      var nodeClick = _this.seriesModel.get('nodeClick', true);

      if (!nodeClick) {
        return;
      }

      var targetInfo = _this.findTarget(e.offsetX, e.offsetY);

      if (!targetInfo) {
        return;
      }

      var node = targetInfo.node;

      if (node.getLayout().isLeafRoot) {
        _this._rootToNode(targetInfo);
      } else {
        if (nodeClick === 'zoomToNode') {
          _this._zoomToNode(targetInfo);
        } else if (nodeClick === 'link') {
          var itemModel = node.hostTree.data.getItemModel(node.dataIndex);
          var link = itemModel.get('link', true);
          var linkTarget = itemModel.get('target', true) || 'blank';
          link && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_format_js__["h" /* windowOpen */])(link, linkTarget);
        }
      }
    }, this);
  };

  TreemapView.prototype._renderBreadcrumb = function (seriesModel, api, targetInfo) {
    var _this = this;

    if (!targetInfo) {
      targetInfo = seriesModel.get('leafDepth', true) != null ? {
        node: seriesModel.getViewRoot()
      } // FIXME
      // better way?
      // Find breadcrumb tail on center of containerGroup.
      : this.findTarget(api.getWidth() / 2, api.getHeight() / 2);

      if (!targetInfo) {
        targetInfo = {
          node: seriesModel.getData().tree.root
        };
      }
    }

    (this._breadcrumb || (this._breadcrumb = new __WEBPACK_IMPORTED_MODULE_7__Breadcrumb_js__["a" /* default */](this.group))).render(seriesModel, api, targetInfo.node, function (node) {
      if (_this._state !== 'animating') {
        __WEBPACK_IMPORTED_MODULE_6__helper_treeHelper_js__["b" /* aboveViewRoot */](seriesModel.getViewRoot(), node) ? _this._rootToNode({
          node: node
        }) : _this._zoomToNode({
          node: node
        });
      }
    });
  };
  /**
   * @override
   */


  TreemapView.prototype.remove = function () {
    this._clearController();

    this._containerGroup && this._containerGroup.removeAll();
    this._storage = createStorage();
    this._state = 'ready';
    this._breadcrumb && this._breadcrumb.remove();
  };

  TreemapView.prototype.dispose = function () {
    this._clearController();
  };

  TreemapView.prototype._zoomToNode = function (targetInfo) {
    this.api.dispatchAction({
      type: 'treemapZoomToNode',
      from: this.uid,
      seriesId: this.seriesModel.id,
      targetNode: targetInfo.node
    });
  };

  TreemapView.prototype._rootToNode = function (targetInfo) {
    this.api.dispatchAction({
      type: 'treemapRootToNode',
      from: this.uid,
      seriesId: this.seriesModel.id,
      targetNode: targetInfo.node
    });
  };
  /**
   * @public
   * @param {number} x Global coord x.
   * @param {number} y Global coord y.
   * @return {Object} info If not found, return undefined;
   * @return {number} info.node Target node.
   * @return {number} info.offsetX x refer to target node.
   * @return {number} info.offsetY y refer to target node.
   */


  TreemapView.prototype.findTarget = function (x, y) {
    var targetInfo;
    var viewRoot = this.seriesModel.getViewRoot();
    viewRoot.eachNode({
      attr: 'viewChildren',
      order: 'preorder'
    }, function (node) {
      var bgEl = this._storage.background[node.getRawIndex()]; // If invisible, there might be no element.


      if (bgEl) {
        var point = bgEl.transformCoordToLocal(x, y);
        var shape = bgEl.shape; // For performance consideration, dont use 'getBoundingRect'.

        if (shape.x <= point[0] && point[0] <= shape.x + shape.width && shape.y <= point[1] && point[1] <= shape.y + shape.height) {
          targetInfo = {
            node: node,
            offsetX: point[0],
            offsetY: point[1]
          };
        } else {
          return false; // Suppress visit subtree.
        }
      }
    }, this);
    return targetInfo;
  };

  TreemapView.type = 'treemap';
  return TreemapView;
}(__WEBPACK_IMPORTED_MODULE_13__view_Chart_js__["a" /* default */]);
/**
 * @inner
 */


function createStorage() {
  return {
    nodeGroup: [],
    background: [],
    content: []
  };
}
/**
 * @inner
 * @return Return undefined means do not travel further.
 */


function renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth) {
  // Whether under viewRoot.
  if (!thisNode) {
    // Deleting nodes will be performed finally. This method just find
    // element from old storage, or create new element, set them to new
    // storage, and set styles.
    return;
  } // -------------------------------------------------------------------
  // Start of closure variables available in "Procedures in renderNode".


  var thisLayout = thisNode.getLayout();
  var data = seriesModel.getData();
  var nodeModel = thisNode.getModel(); // Only for enabling highlight/downplay. Clear firstly.
  // Because some node will not be rendered.

  data.setItemGraphicEl(thisNode.dataIndex, null);

  if (!thisLayout || !thisLayout.isInView) {
    return;
  }

  var thisWidth = thisLayout.width;
  var thisHeight = thisLayout.height;
  var borderWidth = thisLayout.borderWidth;
  var thisInvisible = thisLayout.invisible;
  var thisRawIndex = thisNode.getRawIndex();
  var oldRawIndex = oldNode && oldNode.getRawIndex();
  var thisViewChildren = thisNode.viewChildren;
  var upperHeight = thisLayout.upperHeight;
  var isParent = thisViewChildren && thisViewChildren.length;
  var itemStyleNormalModel = nodeModel.getModel('itemStyle');
  var itemStyleEmphasisModel = nodeModel.getModel(['emphasis', 'itemStyle']);
  var itemStyleBlurModel = nodeModel.getModel(['blur', 'itemStyle']);
  var itemStyleSelectModel = nodeModel.getModel(['select', 'itemStyle']);
  var borderRadius = itemStyleNormalModel.get('borderRadius') || 0; // End of closure ariables available in "Procedures in renderNode".
  // -----------------------------------------------------------------
  // Node group

  var group = giveGraphic('nodeGroup', Group);

  if (!group) {
    return;
  }

  parentGroup.add(group); // x,y are not set when el is above view root.

  group.x = thisLayout.x || 0;
  group.y = thisLayout.y || 0;
  group.markRedraw();
  inner(group).nodeWidth = thisWidth;
  inner(group).nodeHeight = thisHeight;

  if (thisLayout.isAboveViewRoot) {
    return group;
  } // Background


  var bg = giveGraphic('background', Rect, depth, Z2_BG);
  bg && renderBackground(group, bg, isParent && thisLayout.upperLabelHeight);
  var emphasisModel = nodeModel.getModel('emphasis');
  var focus = emphasisModel.get('focus');
  var blurScope = emphasisModel.get('blurScope');
  var isDisabled = emphasisModel.get('disabled');
  var focusOrIndices = focus === 'ancestor' ? thisNode.getAncestorsIndices() : focus === 'descendant' ? thisNode.getDescendantIndices() : focus; // No children, render content.

  if (isParent) {
    // Because of the implementation about "traverse" in graphic hover style, we
    // can not set hover listener on the "group" of non-leaf node. Otherwise the
    // hover event from the descendents will be listenered.
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_states_js__["q" /* isHighDownDispatcher */])(group)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_states_js__["c" /* setAsHighDownDispatcher */])(group, false);
    }

    if (bg) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_states_js__["c" /* setAsHighDownDispatcher */])(bg, !isDisabled); // Only for enabling highlight/downplay.

      data.setItemGraphicEl(thisNode.dataIndex, bg);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_states_js__["K" /* enableHoverFocus */])(bg, focusOrIndices, blurScope);
    }
  } else {
    var content = giveGraphic('content', Rect, depth, Z2_CONTENT);
    content && renderContent(group, content);
    bg.disableMorphing = true;

    if (bg && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_states_js__["q" /* isHighDownDispatcher */])(bg)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_states_js__["c" /* setAsHighDownDispatcher */])(bg, false);
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_states_js__["c" /* setAsHighDownDispatcher */])(group, !isDisabled); // Only for enabling highlight/downplay.

    data.setItemGraphicEl(thisNode.dataIndex, group);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_states_js__["K" /* enableHoverFocus */])(group, focusOrIndices, blurScope);
  }

  return group; // ----------------------------
  // | Procedures in renderNode |
  // ----------------------------

  function renderBackground(group, bg, useUpperLabel) {
    var ecData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_innerStore_js__["a" /* getECData */])(bg); // For tooltip.

    ecData.dataIndex = thisNode.dataIndex;
    ecData.seriesIndex = seriesModel.seriesIndex;
    bg.setShape({
      x: 0,
      y: 0,
      width: thisWidth,
      height: thisHeight,
      r: borderRadius
    });

    if (thisInvisible) {
      // If invisible, do not set visual, otherwise the element will
      // change immediately before animation. We think it is OK to
      // remain its origin color when moving out of the view window.
      processInvisible(bg);
    } else {
      bg.invisible = false;
      var style = thisNode.getVisual('style');
      var visualBorderColor = style.stroke;
      var normalStyle = getItemStyleNormal(itemStyleNormalModel);
      normalStyle.fill = visualBorderColor;
      var emphasisStyle = getStateItemStyle(itemStyleEmphasisModel);
      emphasisStyle.fill = itemStyleEmphasisModel.get('borderColor');
      var blurStyle = getStateItemStyle(itemStyleBlurModel);
      blurStyle.fill = itemStyleBlurModel.get('borderColor');
      var selectStyle = getStateItemStyle(itemStyleSelectModel);
      selectStyle.fill = itemStyleSelectModel.get('borderColor');

      if (useUpperLabel) {
        var upperLabelWidth = thisWidth - 2 * borderWidth;
        prepareText( // PENDING: convert ZRColor to ColorString for text.
        bg, visualBorderColor, style.opacity, {
          x: borderWidth,
          y: 0,
          width: upperLabelWidth,
          height: upperHeight
        });
      } // For old bg.
      else {
          bg.removeTextContent();
        }

      bg.setStyle(normalStyle);
      bg.ensureState('emphasis').style = emphasisStyle;
      bg.ensureState('blur').style = blurStyle;
      bg.ensureState('select').style = selectStyle;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_states_js__["H" /* setDefaultStateProxy */])(bg);
    }

    group.add(bg);
  }

  function renderContent(group, content) {
    var ecData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_innerStore_js__["a" /* getECData */])(content); // For tooltip.

    ecData.dataIndex = thisNode.dataIndex;
    ecData.seriesIndex = seriesModel.seriesIndex;
    var contentWidth = Math.max(thisWidth - 2 * borderWidth, 0);
    var contentHeight = Math.max(thisHeight - 2 * borderWidth, 0);
    content.culling = true;
    content.setShape({
      x: borderWidth,
      y: borderWidth,
      width: contentWidth,
      height: contentHeight,
      r: borderRadius
    });

    if (thisInvisible) {
      // If invisible, do not set visual, otherwise the element will
      // change immediately before animation. We think it is OK to
      // remain its origin color when moving out of the view window.
      processInvisible(content);
    } else {
      content.invisible = false;
      var nodeStyle = thisNode.getVisual('style');
      var visualColor = nodeStyle.fill;
      var normalStyle = getItemStyleNormal(itemStyleNormalModel);
      normalStyle.fill = visualColor;
      normalStyle.decal = nodeStyle.decal;
      var emphasisStyle = getStateItemStyle(itemStyleEmphasisModel);
      var blurStyle = getStateItemStyle(itemStyleBlurModel);
      var selectStyle = getStateItemStyle(itemStyleSelectModel); // PENDING: convert ZRColor to ColorString for text.

      prepareText(content, visualColor, nodeStyle.opacity, null);
      content.setStyle(normalStyle);
      content.ensureState('emphasis').style = emphasisStyle;
      content.ensureState('blur').style = blurStyle;
      content.ensureState('select').style = selectStyle;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_states_js__["H" /* setDefaultStateProxy */])(content);
    }

    group.add(content);
  }

  function processInvisible(element) {
    // Delay invisible setting utill animation finished,
    // avoid element vanish suddenly before animation.
    !element.invisible && willInvisibleEls.push(element);
  }

  function prepareText(rectEl, visualColor, visualOpacity, // Can be null/undefined
  upperLabelRect) {
    var normalLabelModel = nodeModel.getModel(upperLabelRect ? PATH_UPPERLABEL_NORMAL : PATH_LABEL_NOAMAL);
    var defaultText = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_model_js__["n" /* convertOptionIdName */])(nodeModel.get('name'), null);
    var isShow = normalLabelModel.getShallow('show');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__label_labelStyle_js__["e" /* setLabelStyle */])(rectEl, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__label_labelStyle_js__["f" /* getLabelStatesModels */])(nodeModel, upperLabelRect ? PATH_UPPERLABEL_NORMAL : PATH_LABEL_NOAMAL), {
      defaultText: isShow ? defaultText : null,
      inheritColor: visualColor,
      defaultOpacity: visualOpacity,
      labelFetcher: seriesModel,
      labelDataIndex: thisNode.dataIndex
    });
    var textEl = rectEl.getTextContent();

    if (!textEl) {
      return;
    }

    var textStyle = textEl.style;
    var textPadding = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["normalizeCssArray"])(textStyle.padding || 0);

    if (upperLabelRect) {
      rectEl.setTextConfig({
        layoutRect: upperLabelRect
      });
      textEl.disableLabelLayout = true;
    }

    textEl.beforeUpdate = function () {
      var width = Math.max((upperLabelRect ? upperLabelRect.width : rectEl.shape.width) - textPadding[1] - textPadding[3], 0);
      var height = Math.max((upperLabelRect ? upperLabelRect.height : rectEl.shape.height) - textPadding[0] - textPadding[2], 0);

      if (textStyle.width !== width || textStyle.height !== height) {
        textEl.setStyle({
          width: width,
          height: height
        });
      }
    };

    textStyle.truncateMinChar = 2;
    textStyle.lineOverflow = 'truncate';
    addDrillDownIcon(textStyle, upperLabelRect, thisLayout);
    var textEmphasisState = textEl.getState('emphasis');
    addDrillDownIcon(textEmphasisState ? textEmphasisState.style : null, upperLabelRect, thisLayout);
  }

  function addDrillDownIcon(style, upperLabelRect, thisLayout) {
    var text = style ? style.text : null;

    if (!upperLabelRect && thisLayout.isLeafRoot && text != null) {
      var iconChar = seriesModel.get('drillDownIcon', true);
      style.text = iconChar ? iconChar + ' ' + text : text;
    }
  }

  function giveGraphic(storageName, Ctor, depth, z) {
    var element = oldRawIndex != null && oldStorage[storageName][oldRawIndex];
    var lasts = lastsForAnimation[storageName];

    if (element) {
      // Remove from oldStorage
      oldStorage[storageName][oldRawIndex] = null;
      prepareAnimationWhenHasOld(lasts, element);
    } // If invisible and no old element, do not create new element (for optimizing).
    else if (!thisInvisible) {
        element = new Ctor();

        if (element instanceof __WEBPACK_IMPORTED_MODULE_14_zrender_lib_graphic_Displayable_js__["c" /* default */]) {
          element.z2 = calculateZ2(depth, z);
        }

        prepareAnimationWhenNoOld(lasts, element);
      } // Set to thisStorage


    return thisStorage[storageName][thisRawIndex] = element;
  }

  function prepareAnimationWhenHasOld(lasts, element) {
    var lastCfg = lasts[thisRawIndex] = {};

    if (element instanceof Group) {
      lastCfg.oldX = element.x;
      lastCfg.oldY = element.y;
    } else {
      lastCfg.oldShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])({}, element.shape);
    }
  } // If a element is new, we need to find the animation start point carefully,
  // otherwise it will looks strange when 'zoomToNode'.


  function prepareAnimationWhenNoOld(lasts, element) {
    var lastCfg = lasts[thisRawIndex] = {};
    var parentNode = thisNode.parentNode;
    var isGroup = element instanceof __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Group"];

    if (parentNode && (!reRoot || reRoot.direction === 'drillDown')) {
      var parentOldX = 0;
      var parentOldY = 0; // New nodes appear from right-bottom corner in 'zoomToNode' animation.
      // For convenience, get old bounding rect from background.

      var parentOldBg = lastsForAnimation.background[parentNode.getRawIndex()];

      if (!reRoot && parentOldBg && parentOldBg.oldShape) {
        parentOldX = parentOldBg.oldShape.width;
        parentOldY = parentOldBg.oldShape.height;
      } // When no parent old shape found, its parent is new too,
      // so we can just use {x:0, y:0}.


      if (isGroup) {
        lastCfg.oldX = 0;
        lastCfg.oldY = parentOldY;
      } else {
        lastCfg.oldShape = {
          x: parentOldX,
          y: parentOldY,
          width: 0,
          height: 0
        };
      }
    } // Fade in, user can be aware that these nodes are new.


    lastCfg.fadein = !isGroup;
  }
} // We can not set all backgroud with the same z, Because the behaviour of
// drill down and roll up differ background creation sequence from tree
// hierarchy sequence, which cause that lowser background element overlap
// upper ones. So we calculate z based on depth.
// Moreover, we try to shrink down z interval to [0, 1] to avoid that
// treemap with large z overlaps other components.


function calculateZ2(depth, z2InLevel) {
  return depth * Z2_BASE + z2InLevel;
}

/* harmony default export */ __webpack_exports__["a"] = (TreemapView);

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__treemapAction_js__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TreemapSeries_js__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TreemapView_js__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__treemapVisual_js__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__treemapLayout_js__ = __webpack_require__(1192);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





function install(registers) {
  registers.registerSeriesModel(__WEBPACK_IMPORTED_MODULE_1__TreemapSeries_js__["a" /* default */]);
  registers.registerChartView(__WEBPACK_IMPORTED_MODULE_2__TreemapView_js__["a" /* default */]);
  registers.registerVisual(__WEBPACK_IMPORTED_MODULE_3__treemapVisual_js__["a" /* default */]);
  registers.registerLayout(__WEBPACK_IMPORTED_MODULE_4__treemapLayout_js__["a" /* default */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__treemapAction_js__["a" /* installTreemapAction */])(registers);
}

/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = installTreemapAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_treeHelper_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


var actionTypes = ['treemapZoomToNode', 'treemapRender', 'treemapMove'];
function installTreemapAction(registers) {
  for (var i = 0; i < actionTypes.length; i++) {
    registers.registerAction({
      type: actionTypes[i],
      update: 'updateView'
    }, __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["noop"]);
  }

  registers.registerAction({
    type: 'treemapRootToNode',
    update: 'updateView'
  }, function (payload, ecModel) {
    ecModel.eachComponent({
      mainType: 'series',
      subType: 'treemap',
      query: payload
    }, handleRootToNode);

    function handleRootToNode(model, index) {
      var types = ['treemapZoomToNode', 'treemapRootToNode'];
      var targetInfo = __WEBPACK_IMPORTED_MODULE_0__helper_treeHelper_js__["a" /* retrieveTargetInfo */](payload, types, model);

      if (targetInfo) {
        var originViewRoot = model.getViewRoot();

        if (originViewRoot) {
          payload.direction = __WEBPACK_IMPORTED_MODULE_0__helper_treeHelper_js__["b" /* aboveViewRoot */](originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
        }

        model.resetViewRoot(targetInfo.node);
      }
    }
  });
}

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_treeHelper_js__ = __webpack_require__(110);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/*
* A third-party license is embeded for some of the code in this file:
* The treemap layout implementation was originally copied from
* "d3.js" with some modifications made for this project.
* (See more details in the comment of the method "squarify" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/





var mathMax = Math.max;
var mathMin = Math.min;
var retrieveValue = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve"];
var each = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"];
var PATH_BORDER_WIDTH = ['itemStyle', 'borderWidth'];
var PATH_GAP_WIDTH = ['itemStyle', 'gapWidth'];
var PATH_UPPER_LABEL_SHOW = ['upperLabel', 'show'];
var PATH_UPPER_LABEL_HEIGHT = ['upperLabel', 'height'];
;
/**
 * @public
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  seriesType: 'treemap',
  reset: function (seriesModel, ecModel, api, payload) {
    // Layout result in each node:
    // {x, y, width, height, area, borderWidth}
    var ecWidth = api.getWidth();
    var ecHeight = api.getHeight();
    var seriesOption = seriesModel.option;
    var layoutInfo = __WEBPACK_IMPORTED_MODULE_3__util_layout_js__["f" /* getLayoutRect */](seriesModel.getBoxLayoutParams(), {
      width: api.getWidth(),
      height: api.getHeight()
    });
    var size = seriesOption.size || []; // Compatible with ec2.

    var containerWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_number_js__["a" /* parsePercent */])(retrieveValue(layoutInfo.width, size[0]), ecWidth);
    var containerHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_number_js__["a" /* parsePercent */])(retrieveValue(layoutInfo.height, size[1]), ecHeight); // Fetch payload info.

    var payloadType = payload && payload.type;
    var types = ['treemapZoomToNode', 'treemapRootToNode'];
    var targetInfo = __WEBPACK_IMPORTED_MODULE_4__helper_treeHelper_js__["a" /* retrieveTargetInfo */](payload, types, seriesModel);
    var rootRect = payloadType === 'treemapRender' || payloadType === 'treemapMove' ? payload.rootRect : null;
    var viewRoot = seriesModel.getViewRoot();
    var viewAbovePath = __WEBPACK_IMPORTED_MODULE_4__helper_treeHelper_js__["d" /* getPathToRoot */](viewRoot);

    if (payloadType !== 'treemapMove') {
      var rootSize = payloadType === 'treemapZoomToNode' ? estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) : rootRect ? [rootRect.width, rootRect.height] : [containerWidth, containerHeight];
      var sort_1 = seriesOption.sort;

      if (sort_1 && sort_1 !== 'asc' && sort_1 !== 'desc') {
        // Default to be desc order.
        sort_1 = 'desc';
      }

      var options = {
        squareRatio: seriesOption.squareRatio,
        sort: sort_1,
        leafDepth: seriesOption.leafDepth
      }; // layout should be cleared because using updateView but not update.

      viewRoot.hostTree.clearLayouts(); // TODO
      // optimize: if out of view clip, do not layout.
      // But take care that if do not render node out of view clip,
      // how to calculate start po

      var viewRootLayout_1 = {
        x: 0,
        y: 0,
        width: rootSize[0],
        height: rootSize[1],
        area: rootSize[0] * rootSize[1]
      };
      viewRoot.setLayout(viewRootLayout_1);
      squarify(viewRoot, options, false, 0); // Supplement layout.

      viewRootLayout_1 = viewRoot.getLayout();
      each(viewAbovePath, function (node, index) {
        var childValue = (viewAbovePath[index + 1] || viewRoot).getValue();
        node.setLayout(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"]({
          dataExtent: [childValue, childValue],
          borderWidth: 0,
          upperHeight: 0
        }, viewRootLayout_1));
      });
    }

    var treeRoot = seriesModel.getData().tree.root;
    treeRoot.setLayout(calculateRootPosition(layoutInfo, rootRect, targetInfo), true);
    seriesModel.setLayoutInfo(layoutInfo); // FIXME
    // 现在没有clip功能，暂时取ec高宽。

    prunning(treeRoot, // Transform to base element coordinate system.
    new __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_BoundingRect_js__["a" /* default */](-layoutInfo.x, -layoutInfo.y, ecWidth, ecHeight), viewAbovePath, viewRoot, 0);
  }
});
/**
 * Layout treemap with squarify algorithm.
 * The original presentation of this algorithm
 * was made by Mark Bruls, Kees Huizing, and Jarke J. van Wijk
 * <https://graphics.ethz.ch/teaching/scivis_common/Literature/squarifiedTreeMaps.pdf>.
 * The implementation of this algorithm was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/layout/treemap.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * @protected
 * @param {module:echarts/data/Tree~TreeNode} node
 * @param {Object} options
 * @param {string} options.sort 'asc' or 'desc'
 * @param {number} options.squareRatio
 * @param {boolean} hideChildren
 * @param {number} depth
 */

function squarify(node, options, hideChildren, depth) {
  var width;
  var height;

  if (node.isRemoved()) {
    return;
  }

  var thisLayout = node.getLayout();
  width = thisLayout.width;
  height = thisLayout.height; // Considering border and gap

  var nodeModel = node.getModel();
  var borderWidth = nodeModel.get(PATH_BORDER_WIDTH);
  var halfGapWidth = nodeModel.get(PATH_GAP_WIDTH) / 2;
  var upperLabelHeight = getUpperLabelHeight(nodeModel);
  var upperHeight = Math.max(borderWidth, upperLabelHeight);
  var layoutOffset = borderWidth - halfGapWidth;
  var layoutOffsetUpper = upperHeight - halfGapWidth;
  node.setLayout({
    borderWidth: borderWidth,
    upperHeight: upperHeight,
    upperLabelHeight: upperLabelHeight
  }, true);
  width = mathMax(width - 2 * layoutOffset, 0);
  height = mathMax(height - layoutOffset - layoutOffsetUpper, 0);
  var totalArea = width * height;
  var viewChildren = initChildren(node, nodeModel, totalArea, options, hideChildren, depth);

  if (!viewChildren.length) {
    return;
  }

  var rect = {
    x: layoutOffset,
    y: layoutOffsetUpper,
    width: width,
    height: height
  };
  var rowFixedLength = mathMin(width, height);
  var best = Infinity; // the best row score so far

  var row = [];
  row.area = 0;

  for (var i = 0, len = viewChildren.length; i < len;) {
    var child = viewChildren[i];
    row.push(child);
    row.area += child.getLayout().area;
    var score = worst(row, rowFixedLength, options.squareRatio); // continue with this orientation

    if (score <= best) {
      i++;
      best = score;
    } // abort, and try a different orientation
    else {
        row.area -= row.pop().getLayout().area;
        position(row, rowFixedLength, rect, halfGapWidth, false);
        rowFixedLength = mathMin(rect.width, rect.height);
        row.length = row.area = 0;
        best = Infinity;
      }
  }

  if (row.length) {
    position(row, rowFixedLength, rect, halfGapWidth, true);
  }

  if (!hideChildren) {
    var childrenVisibleMin = nodeModel.get('childrenVisibleMin');

    if (childrenVisibleMin != null && totalArea < childrenVisibleMin) {
      hideChildren = true;
    }
  }

  for (var i = 0, len = viewChildren.length; i < len; i++) {
    squarify(viewChildren[i], options, hideChildren, depth + 1);
  }
}
/**
 * Set area to each child, and calculate data extent for visual coding.
 */


function initChildren(node, nodeModel, totalArea, options, hideChildren, depth) {
  var viewChildren = node.children || [];
  var orderBy = options.sort;
  orderBy !== 'asc' && orderBy !== 'desc' && (orderBy = null);
  var overLeafDepth = options.leafDepth != null && options.leafDepth <= depth; // leafDepth has higher priority.

  if (hideChildren && !overLeafDepth) {
    return node.viewChildren = [];
  } // Sort children, order by desc.


  viewChildren = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["filter"](viewChildren, function (child) {
    return !child.isRemoved();
  });
  sort(viewChildren, orderBy);
  var info = statistic(nodeModel, viewChildren, orderBy);

  if (info.sum === 0) {
    return node.viewChildren = [];
  }

  info.sum = filterByThreshold(nodeModel, totalArea, info.sum, orderBy, viewChildren);

  if (info.sum === 0) {
    return node.viewChildren = [];
  } // Set area to each child.


  for (var i = 0, len = viewChildren.length; i < len; i++) {
    var area = viewChildren[i].getValue() / info.sum * totalArea; // Do not use setLayout({...}, true), because it is needed to clear last layout.

    viewChildren[i].setLayout({
      area: area
    });
  }

  if (overLeafDepth) {
    viewChildren.length && node.setLayout({
      isLeafRoot: true
    }, true);
    viewChildren.length = 0;
  }

  node.viewChildren = viewChildren;
  node.setLayout({
    dataExtent: info.dataExtent
  }, true);
  return viewChildren;
}
/**
 * Consider 'visibleMin'. Modify viewChildren and get new sum.
 */


function filterByThreshold(nodeModel, totalArea, sum, orderBy, orderedChildren) {
  // visibleMin is not supported yet when no option.sort.
  if (!orderBy) {
    return sum;
  }

  var visibleMin = nodeModel.get('visibleMin');
  var len = orderedChildren.length;
  var deletePoint = len; // Always travel from little value to big value.

  for (var i = len - 1; i >= 0; i--) {
    var value = orderedChildren[orderBy === 'asc' ? len - i - 1 : i].getValue();

    if (value / sum * totalArea < visibleMin) {
      deletePoint = i;
      sum -= value;
    }
  }

  orderBy === 'asc' ? orderedChildren.splice(0, len - deletePoint) : orderedChildren.splice(deletePoint, len - deletePoint);
  return sum;
}
/**
 * Sort
 */


function sort(viewChildren, orderBy) {
  if (orderBy) {
    viewChildren.sort(function (a, b) {
      var diff = orderBy === 'asc' ? a.getValue() - b.getValue() : b.getValue() - a.getValue();
      return diff === 0 ? orderBy === 'asc' ? a.dataIndex - b.dataIndex : b.dataIndex - a.dataIndex : diff;
    });
  }

  return viewChildren;
}
/**
 * Statistic
 */


function statistic(nodeModel, children, orderBy) {
  // Calculate sum.
  var sum = 0;

  for (var i = 0, len = children.length; i < len; i++) {
    sum += children[i].getValue();
  } // Statistic data extent for latter visual coding.
  // Notice: data extent should be calculate based on raw children
  // but not filtered view children, otherwise visual mapping will not
  // be stable when zoom (where children is filtered by visibleMin).


  var dimension = nodeModel.get('visualDimension');
  var dataExtent; // The same as area dimension.

  if (!children || !children.length) {
    dataExtent = [NaN, NaN];
  } else if (dimension === 'value' && orderBy) {
    dataExtent = [children[children.length - 1].getValue(), children[0].getValue()];
    orderBy === 'asc' && dataExtent.reverse();
  } // Other dimension.
  else {
      dataExtent = [Infinity, -Infinity];
      each(children, function (child) {
        var value = child.getValue(dimension);
        value < dataExtent[0] && (dataExtent[0] = value);
        value > dataExtent[1] && (dataExtent[1] = value);
      });
    }

  return {
    sum: sum,
    dataExtent: dataExtent
  };
}
/**
 * Computes the score for the specified row,
 * as the worst aspect ratio.
 */


function worst(row, rowFixedLength, ratio) {
  var areaMax = 0;
  var areaMin = Infinity;

  for (var i = 0, area = void 0, len = row.length; i < len; i++) {
    area = row[i].getLayout().area;

    if (area) {
      area < areaMin && (areaMin = area);
      area > areaMax && (areaMax = area);
    }
  }

  var squareArea = row.area * row.area;
  var f = rowFixedLength * rowFixedLength * ratio;
  return squareArea ? mathMax(f * areaMax / squareArea, squareArea / (f * areaMin)) : Infinity;
}
/**
 * Positions the specified row of nodes. Modifies `rect`.
 */


function position(row, rowFixedLength, rect, halfGapWidth, flush) {
  // When rowFixedLength === rect.width,
  // it is horizontal subdivision,
  // rowFixedLength is the width of the subdivision,
  // rowOtherLength is the height of the subdivision,
  // and nodes will be positioned from left to right.
  // wh[idx0WhenH] means: when horizontal,
  //      wh[idx0WhenH] => wh[0] => 'width'.
  //      xy[idx1WhenH] => xy[1] => 'y'.
  var idx0WhenH = rowFixedLength === rect.width ? 0 : 1;
  var idx1WhenH = 1 - idx0WhenH;
  var xy = ['x', 'y'];
  var wh = ['width', 'height'];
  var last = rect[xy[idx0WhenH]];
  var rowOtherLength = rowFixedLength ? row.area / rowFixedLength : 0;

  if (flush || rowOtherLength > rect[wh[idx1WhenH]]) {
    rowOtherLength = rect[wh[idx1WhenH]]; // over+underflow
  }

  for (var i = 0, rowLen = row.length; i < rowLen; i++) {
    var node = row[i];
    var nodeLayout = {};
    var step = rowOtherLength ? node.getLayout().area / rowOtherLength : 0;
    var wh1 = nodeLayout[wh[idx1WhenH]] = mathMax(rowOtherLength - 2 * halfGapWidth, 0); // We use Math.max/min to avoid negative width/height when considering gap width.

    var remain = rect[xy[idx0WhenH]] + rect[wh[idx0WhenH]] - last;
    var modWH = i === rowLen - 1 || remain < step ? remain : step;
    var wh0 = nodeLayout[wh[idx0WhenH]] = mathMax(modWH - 2 * halfGapWidth, 0);
    nodeLayout[xy[idx1WhenH]] = rect[xy[idx1WhenH]] + mathMin(halfGapWidth, wh1 / 2);
    nodeLayout[xy[idx0WhenH]] = last + mathMin(halfGapWidth, wh0 / 2);
    last += modWH;
    node.setLayout(nodeLayout, true);
  }

  rect[xy[idx1WhenH]] += rowOtherLength;
  rect[wh[idx1WhenH]] -= rowOtherLength;
} // Return [containerWidth, containerHeight] as default.


function estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) {
  // If targetInfo.node exists, we zoom to the node,
  // so estimate whold width and heigth by target node.
  var currNode = (targetInfo || {}).node;
  var defaultSize = [containerWidth, containerHeight];

  if (!currNode || currNode === viewRoot) {
    return defaultSize;
  }

  var parent;
  var viewArea = containerWidth * containerHeight;
  var area = viewArea * seriesModel.option.zoomToNodeRatio;

  while (parent = currNode.parentNode) {
    // jshint ignore:line
    var sum = 0;
    var siblings = parent.children;

    for (var i = 0, len = siblings.length; i < len; i++) {
      sum += siblings[i].getValue();
    }

    var currNodeValue = currNode.getValue();

    if (currNodeValue === 0) {
      return defaultSize;
    }

    area *= sum / currNodeValue; // Considering border, suppose aspect ratio is 1.

    var parentModel = parent.getModel();
    var borderWidth = parentModel.get(PATH_BORDER_WIDTH);
    var upperHeight = Math.max(borderWidth, getUpperLabelHeight(parentModel));
    area += 4 * borderWidth * borderWidth + (3 * borderWidth + upperHeight) * Math.pow(area, 0.5);
    area > __WEBPACK_IMPORTED_MODULE_2__util_number_js__["u" /* MAX_SAFE_INTEGER */] && (area = __WEBPACK_IMPORTED_MODULE_2__util_number_js__["u" /* MAX_SAFE_INTEGER */]);
    currNode = parent;
  }

  area < viewArea && (area = viewArea);
  var scale = Math.pow(area / viewArea, 0.5);
  return [containerWidth * scale, containerHeight * scale];
} // Root postion base on coord of containerGroup


function calculateRootPosition(layoutInfo, rootRect, targetInfo) {
  if (rootRect) {
    return {
      x: rootRect.x,
      y: rootRect.y
    };
  }

  var defaultPosition = {
    x: 0,
    y: 0
  };

  if (!targetInfo) {
    return defaultPosition;
  } // If targetInfo is fetched by 'retrieveTargetInfo',
  // old tree and new tree are the same tree,
  // so the node still exists and we can visit it.


  var targetNode = targetInfo.node;
  var layout = targetNode.getLayout();

  if (!layout) {
    return defaultPosition;
  } // Transform coord from local to container.


  var targetCenter = [layout.width / 2, layout.height / 2];
  var node = targetNode;

  while (node) {
    var nodeLayout = node.getLayout();
    targetCenter[0] += nodeLayout.x;
    targetCenter[1] += nodeLayout.y;
    node = node.parentNode;
  }

  return {
    x: layoutInfo.width / 2 - targetCenter[0],
    y: layoutInfo.height / 2 - targetCenter[1]
  };
} // Mark nodes visible for prunning when visual coding and rendering.
// Prunning depends on layout and root position, so we have to do it after layout.


function prunning(node, clipRect, viewAbovePath, viewRoot, depth) {
  var nodeLayout = node.getLayout();
  var nodeInViewAbovePath = viewAbovePath[depth];
  var isAboveViewRoot = nodeInViewAbovePath && nodeInViewAbovePath === node;

  if (nodeInViewAbovePath && !isAboveViewRoot || depth === viewAbovePath.length && node !== viewRoot) {
    return;
  }

  node.setLayout({
    // isInView means: viewRoot sub tree + viewAbovePath
    isInView: true,
    // invisible only means: outside view clip so that the node can not
    // see but still layout for animation preparation but not render.
    invisible: !isAboveViewRoot && !clipRect.intersect(nodeLayout),
    isAboveViewRoot: isAboveViewRoot
  }, true); // Transform to child coordinate.

  var childClipRect = new __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_BoundingRect_js__["a" /* default */](clipRect.x - nodeLayout.x, clipRect.y - nodeLayout.y, clipRect.width, clipRect.height);
  each(node.viewChildren || [], function (child) {
    prunning(child, childClipRect, viewAbovePath, viewRoot, depth + 1);
  });
}

function getUpperLabelHeight(model) {
  return model.get(PATH_UPPER_LABEL_SHOW) ? model.get(PATH_UPPER_LABEL_HEIGHT) : 0;
}

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__visual_VisualMapping_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_tool_color_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var ITEM_STYLE_NORMAL = 'itemStyle';
var inner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_model_js__["a" /* makeInner */])();
/* harmony default export */ __webpack_exports__["a"] = ({
  seriesType: 'treemap',
  reset: function (seriesModel) {
    var tree = seriesModel.getData().tree;
    var root = tree.root;

    if (root.isRemoved()) {
      return;
    }

    travelTree(root, // Visual should calculate from tree root but not view root.
    {}, seriesModel.getViewRoot().getAncestors(), seriesModel);
  }
});

function travelTree(node, designatedVisual, viewRootAncestors, seriesModel) {
  var nodeModel = node.getModel();
  var nodeLayout = node.getLayout();
  var data = node.hostTree.data; // Optimize

  if (!nodeLayout || nodeLayout.invisible || !nodeLayout.isInView) {
    return;
  }

  var nodeItemStyleModel = nodeModel.getModel(ITEM_STYLE_NORMAL);
  var visuals = buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel);
  var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, 'style'); // calculate border color

  var borderColor = nodeItemStyleModel.get('borderColor');
  var borderColorSaturation = nodeItemStyleModel.get('borderColorSaturation');
  var thisNodeColor;

  if (borderColorSaturation != null) {
    // For performance, do not always execute 'calculateColor'.
    thisNodeColor = calculateColor(visuals);
    borderColor = calculateBorderColor(borderColorSaturation, thisNodeColor);
  }

  existsStyle.stroke = borderColor;
  var viewChildren = node.viewChildren;

  if (!viewChildren || !viewChildren.length) {
    thisNodeColor = calculateColor(visuals); // Apply visual to this node.

    existsStyle.fill = thisNodeColor;
  } else {
    var mapping_1 = buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren); // Designate visual to children.

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(viewChildren, function (child, index) {
      // If higher than viewRoot, only ancestors of viewRoot is needed to visit.
      if (child.depth >= viewRootAncestors.length || child === viewRootAncestors[child.depth]) {
        var childVisual = mapVisual(nodeModel, visuals, child, index, mapping_1, seriesModel);
        travelTree(child, childVisual, viewRootAncestors, seriesModel);
      }
    });
  }
}

function buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel) {
  var visuals = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])({}, designatedVisual);
  var designatedVisualItemStyle = seriesModel.designatedVisualItemStyle;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(['color', 'colorAlpha', 'colorSaturation'], function (visualName) {
    // Priority: thisNode > thisLevel > parentNodeDesignated > seriesModel
    designatedVisualItemStyle[visualName] = designatedVisual[visualName];
    var val = nodeItemStyleModel.get(visualName);
    designatedVisualItemStyle[visualName] = null;
    val != null && (visuals[visualName] = val);
  });
  return visuals;
}

function calculateColor(visuals) {
  var color = getValueVisualDefine(visuals, 'color');

  if (color) {
    var colorAlpha = getValueVisualDefine(visuals, 'colorAlpha');
    var colorSaturation = getValueVisualDefine(visuals, 'colorSaturation');

    if (colorSaturation) {
      color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_tool_color_js__["modifyHSL"])(color, null, null, colorSaturation);
    }

    if (colorAlpha) {
      color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_tool_color_js__["modifyAlpha"])(color, colorAlpha);
    }

    return color;
  }
}

function calculateBorderColor(borderColorSaturation, thisNodeColor) {
  return thisNodeColor != null // Can only be string
  ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_tool_color_js__["modifyHSL"])(thisNodeColor, null, null, borderColorSaturation) : null;
}

function getValueVisualDefine(visuals, name) {
  var value = visuals[name];

  if (value != null && value !== 'none') {
    return value;
  }
}

function buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren) {
  if (!viewChildren || !viewChildren.length) {
    return;
  }

  var rangeVisual = getRangeVisual(nodeModel, 'color') || visuals.color != null && visuals.color !== 'none' && (getRangeVisual(nodeModel, 'colorAlpha') || getRangeVisual(nodeModel, 'colorSaturation'));

  if (!rangeVisual) {
    return;
  }

  var visualMin = nodeModel.get('visualMin');
  var visualMax = nodeModel.get('visualMax');
  var dataExtent = nodeLayout.dataExtent.slice();
  visualMin != null && visualMin < dataExtent[0] && (dataExtent[0] = visualMin);
  visualMax != null && visualMax > dataExtent[1] && (dataExtent[1] = visualMax);
  var colorMappingBy = nodeModel.get('colorMappingBy');
  var opt = {
    type: rangeVisual.name,
    dataExtent: dataExtent,
    visual: rangeVisual.range
  };

  if (opt.type === 'color' && (colorMappingBy === 'index' || colorMappingBy === 'id')) {
    opt.mappingMethod = 'category';
    opt.loop = true; // categories is ordinal, so do not set opt.categories.
  } else {
    opt.mappingMethod = 'linear';
  }

  var mapping = new __WEBPACK_IMPORTED_MODULE_0__visual_VisualMapping_js__["a" /* default */](opt);
  inner(mapping).drColorMappingBy = colorMappingBy;
  return mapping;
} // Notice: If we dont have the attribute 'colorRange', but only use
// attribute 'color' to represent both concepts of 'colorRange' and 'color',
// (It means 'colorRange' when 'color' is Array, means 'color' when not array),
// this problem will be encountered:
// If a level-1 node dont have children, and its siblings has children,
// and colorRange is set on level-1, then the node can not be colored.
// So we separate 'colorRange' and 'color' to different attributes.


function getRangeVisual(nodeModel, name) {
  // 'colorRange', 'colorARange', 'colorSRange'.
  // If not exsits on this node, fetch from levels and series.
  var range = nodeModel.get(name);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(range) && range.length ? {
    name: name,
    range: range
  } : null;
}

function mapVisual(nodeModel, visuals, child, index, mapping, seriesModel) {
  var childVisuals = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])({}, visuals);

  if (mapping) {
    // Only support color, colorAlpha, colorSaturation.
    var mappingType = mapping.type;
    var colorMappingBy = mappingType === 'color' && inner(mapping).drColorMappingBy;
    var value = colorMappingBy === 'index' ? index : colorMappingBy === 'id' ? seriesModel.mapIdToIndex(child.getId()) : child.getValue(nodeModel.get('visualDimension'));
    childVisuals[mappingType] = mapping.mapValueToVisual(value);
  }

  return childVisuals;
}

/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__visual_aria_js__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preprocessor_js__ = __webpack_require__(1195);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


function install(registers) {
  registers.registerPreprocessor(__WEBPACK_IMPORTED_MODULE_1__preprocessor_js__["a" /* default */]);
  registers.registerVisual(registers.PRIORITY.VISUAL.ARIA, __WEBPACK_IMPORTED_MODULE_0__visual_aria_js__["a" /* default */]);
}

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ariaPreprocessor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

function ariaPreprocessor(option) {
  if (!option || !option.aria) {
    return;
  }

  var aria = option.aria; // aria.show is deprecated and should use aria.enabled instead

  if (aria.show != null) {
    aria.enabled = aria.show;
  }

  aria.label = aria.label || {}; // move description, general, series, data to be under aria.label

  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](['description', 'general', 'series', 'data'], function (name) {
    if (aria[name] != null) {
      aria.label[name] = aria[name];
    }
  });
}

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_Model_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AxisView_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AxisBuilder_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_innerStore_js__ = __webpack_require__(17);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/








var elementList = ['axisLine', 'axisLabel', 'axisTick', 'minorTick', 'splitLine', 'minorSplitLine', 'splitArea'];

function getAxisLineShape(polar, rExtent, angle) {
  rExtent[1] > rExtent[0] && (rExtent = rExtent.slice().reverse());
  var start = polar.coordToPoint([rExtent[0], angle]);
  var end = polar.coordToPoint([rExtent[1], angle]);
  return {
    x1: start[0],
    y1: start[1],
    x2: end[0],
    y2: end[1]
  };
}

function getRadiusIdx(polar) {
  var radiusAxis = polar.getRadiusAxis();
  return radiusAxis.inverse ? 0 : 1;
} // Remove the last tick which will overlap the first tick


function fixAngleOverlap(list) {
  var firstItem = list[0];
  var lastItem = list[list.length - 1];

  if (firstItem && lastItem && Math.abs(Math.abs(firstItem.coord - lastItem.coord) - 360) < 1e-4) {
    list.pop();
  }
}

var AngleAxisView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(AngleAxisView, _super);

  function AngleAxisView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = AngleAxisView.type;
    _this.axisPointerClass = 'PolarAxisPointer';
    return _this;
  }

  AngleAxisView.prototype.render = function (angleAxisModel, ecModel) {
    this.group.removeAll();

    if (!angleAxisModel.get('show')) {
      return;
    }

    var angleAxis = angleAxisModel.axis;
    var polar = angleAxis.polar;
    var radiusExtent = polar.getRadiusAxis().getExtent();
    var ticksAngles = angleAxis.getTicksCoords();
    var minorTickAngles = angleAxis.getMinorTicksCoords();
    var labels = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"](angleAxis.getViewLabels(), function (labelItem) {
      labelItem = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"](labelItem);
      var scale = angleAxis.scale;
      var tickValue = scale.type === 'ordinal' ? scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
      labelItem.coord = angleAxis.dataToCoord(tickValue);
      return labelItem;
    });
    fixAngleOverlap(labels);
    fixAngleOverlap(ticksAngles);
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](elementList, function (name) {
      if (angleAxisModel.get([name, 'show']) && (!angleAxis.scale.isBlank() || name === 'axisLine')) {
        angelAxisElementsBuilders[name](this.group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels);
      }
    }, this);
  };

  AngleAxisView.type = 'angleAxis';
  return AngleAxisView;
}(__WEBPACK_IMPORTED_MODULE_5__AxisView_js__["a" /* default */]);

var angelAxisElementsBuilders = {
  axisLine: function (group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
    var lineStyleModel = angleAxisModel.getModel(['axisLine', 'lineStyle']); // extent id of the axis radius (r0 and r)

    var rId = getRadiusIdx(polar);
    var r0Id = rId ? 0 : 1;
    var shape;

    if (radiusExtent[r0Id] === 0) {
      shape = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Circle"]({
        shape: {
          cx: polar.cx,
          cy: polar.cy,
          r: radiusExtent[rId]
        },
        style: lineStyleModel.getLineStyle(),
        z2: 1,
        silent: true
      });
    } else {
      shape = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Ring"]({
        shape: {
          cx: polar.cx,
          cy: polar.cy,
          r: radiusExtent[rId],
          r0: radiusExtent[r0Id]
        },
        style: lineStyleModel.getLineStyle(),
        z2: 1,
        silent: true
      });
    }

    shape.style.fill = null;
    group.add(shape);
  },
  axisTick: function (group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
    var tickModel = angleAxisModel.getModel('axisTick');
    var tickLen = (tickModel.get('inside') ? -1 : 1) * tickModel.get('length');
    var radius = radiusExtent[getRadiusIdx(polar)];
    var lines = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"](ticksAngles, function (tickAngleItem) {
      return new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Line"]({
        shape: getAxisLineShape(polar, [radius, radius + tickLen], tickAngleItem.coord)
      });
    });
    group.add(__WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["mergePath"](lines, {
      style: __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"](tickModel.getModel('lineStyle').getLineStyle(), {
        stroke: angleAxisModel.get(['axisLine', 'lineStyle', 'color'])
      })
    }));
  },
  minorTick: function (group, angleAxisModel, polar, tickAngles, minorTickAngles, radiusExtent) {
    if (!minorTickAngles.length) {
      return;
    }

    var tickModel = angleAxisModel.getModel('axisTick');
    var minorTickModel = angleAxisModel.getModel('minorTick');
    var tickLen = (tickModel.get('inside') ? -1 : 1) * minorTickModel.get('length');
    var radius = radiusExtent[getRadiusIdx(polar)];
    var lines = [];

    for (var i = 0; i < minorTickAngles.length; i++) {
      for (var k = 0; k < minorTickAngles[i].length; k++) {
        lines.push(new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Line"]({
          shape: getAxisLineShape(polar, [radius, radius + tickLen], minorTickAngles[i][k].coord)
        }));
      }
    }

    group.add(__WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["mergePath"](lines, {
      style: __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"](minorTickModel.getModel('lineStyle').getLineStyle(), __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"](tickModel.getLineStyle(), {
        stroke: angleAxisModel.get(['axisLine', 'lineStyle', 'color'])
      }))
    }));
  },
  axisLabel: function (group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels) {
    var rawCategoryData = angleAxisModel.getCategories(true);
    var commonLabelModel = angleAxisModel.getModel('axisLabel');
    var labelMargin = commonLabelModel.get('margin');
    var triggerEvent = angleAxisModel.get('triggerEvent'); // Use length of ticksAngles because it may remove the last tick to avoid overlapping

    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](labels, function (labelItem, idx) {
      var labelModel = commonLabelModel;
      var tickValue = labelItem.tickValue;
      var r = radiusExtent[getRadiusIdx(polar)];
      var p = polar.coordToPoint([r + labelMargin, labelItem.coord]);
      var cx = polar.cx;
      var cy = polar.cy;
      var labelTextAlign = Math.abs(p[0] - cx) / r < 0.3 ? 'center' : p[0] > cx ? 'left' : 'right';
      var labelTextVerticalAlign = Math.abs(p[1] - cy) / r < 0.3 ? 'middle' : p[1] > cy ? 'top' : 'bottom';

      if (rawCategoryData && rawCategoryData[tickValue]) {
        var rawCategoryItem = rawCategoryData[tickValue];

        if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isObject"](rawCategoryItem) && rawCategoryItem.textStyle) {
          labelModel = new __WEBPACK_IMPORTED_MODULE_4__model_Model_js__["a" /* default */](rawCategoryItem.textStyle, commonLabelModel, commonLabelModel.ecModel);
        }
      }

      var textEl = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Text"]({
        silent: __WEBPACK_IMPORTED_MODULE_6__AxisBuilder_js__["a" /* default */].isLabelSilent(angleAxisModel),
        style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__label_labelStyle_js__["d" /* createTextStyle */])(labelModel, {
          x: p[0],
          y: p[1],
          fill: labelModel.getTextColor() || angleAxisModel.get(['axisLine', 'lineStyle', 'color']),
          text: labelItem.formattedLabel,
          align: labelTextAlign,
          verticalAlign: labelTextVerticalAlign
        })
      });
      group.add(textEl); // Pack data for mouse event

      if (triggerEvent) {
        var eventData = __WEBPACK_IMPORTED_MODULE_6__AxisBuilder_js__["a" /* default */].makeAxisEventDataBase(angleAxisModel);
        eventData.targetType = 'axisLabel';
        eventData.value = labelItem.rawLabel;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_innerStore_js__["a" /* getECData */])(textEl).eventData = eventData;
      }
    }, this);
  },
  splitLine: function (group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
    var splitLineModel = angleAxisModel.getModel('splitLine');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var lineColors = lineStyleModel.get('color');
    var lineCount = 0;
    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
    var splitLines = [];

    for (var i = 0; i < ticksAngles.length; i++) {
      var colorIndex = lineCount++ % lineColors.length;
      splitLines[colorIndex] = splitLines[colorIndex] || [];
      splitLines[colorIndex].push(new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Line"]({
        shape: getAxisLineShape(polar, radiusExtent, ticksAngles[i].coord)
      }));
    } // Simple optimization
    // Batching the lines if color are the same


    for (var i = 0; i < splitLines.length; i++) {
      group.add(__WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["mergePath"](splitLines[i], {
        style: __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"]({
          stroke: lineColors[i % lineColors.length]
        }, lineStyleModel.getLineStyle()),
        silent: true,
        z: angleAxisModel.get('z')
      }));
    }
  },
  minorSplitLine: function (group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
    if (!minorTickAngles.length) {
      return;
    }

    var minorSplitLineModel = angleAxisModel.getModel('minorSplitLine');
    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
    var lines = [];

    for (var i = 0; i < minorTickAngles.length; i++) {
      for (var k = 0; k < minorTickAngles[i].length; k++) {
        lines.push(new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Line"]({
          shape: getAxisLineShape(polar, radiusExtent, minorTickAngles[i][k].coord)
        }));
      }
    }

    group.add(__WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["mergePath"](lines, {
      style: lineStyleModel.getLineStyle(),
      silent: true,
      z: angleAxisModel.get('z')
    }));
  },
  splitArea: function (group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
    if (!ticksAngles.length) {
      return;
    }

    var splitAreaModel = angleAxisModel.getModel('splitArea');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var areaColors = areaStyleModel.get('color');
    var lineCount = 0;
    areaColors = areaColors instanceof Array ? areaColors : [areaColors];
    var splitAreas = [];
    var RADIAN = Math.PI / 180;
    var prevAngle = -ticksAngles[0].coord * RADIAN;
    var r0 = Math.min(radiusExtent[0], radiusExtent[1]);
    var r1 = Math.max(radiusExtent[0], radiusExtent[1]);
    var clockwise = angleAxisModel.get('clockwise');

    for (var i = 1, len = ticksAngles.length; i <= len; i++) {
      var coord = i === len ? ticksAngles[0].coord : ticksAngles[i].coord;
      var colorIndex = lineCount++ % areaColors.length;
      splitAreas[colorIndex] = splitAreas[colorIndex] || [];
      splitAreas[colorIndex].push(new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Sector"]({
        shape: {
          cx: polar.cx,
          cy: polar.cy,
          r0: r0,
          r: r1,
          startAngle: prevAngle,
          endAngle: -coord * RADIAN,
          clockwise: clockwise
        },
        silent: true
      }));
      prevAngle = -coord * RADIAN;
    } // Simple optimization
    // Batching the lines if color are the same


    for (var i = 0; i < splitAreas.length; i++) {
      group.add(__WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["mergePath"](splitAreas[i], {
        style: __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"]({
          fill: areaColors[i % areaColors.length]
        }, areaStyleModel.getAreaStyle()),
        silent: true
      }));
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (AngleAxisView);

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CartesianXAxisView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CartesianYAxisView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AxisBuilder_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AxisView_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__coord_cartesian_cartesianAxisHelper_js__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__axisSplitHelper_js__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scale_helper_js__ = __webpack_require__(135);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/








var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
var selfBuilderAttrs = ['splitArea', 'splitLine', 'minorSplitLine'];

var CartesianAxisView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(CartesianAxisView, _super);

  function CartesianAxisView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = CartesianAxisView.type;
    _this.axisPointerClass = 'CartesianAxisPointer';
    return _this;
  }
  /**
   * @override
   */


  CartesianAxisView.prototype.render = function (axisModel, ecModel, api, payload) {
    this.group.removeAll();
    var oldAxisGroup = this._axisGroup;
    this._axisGroup = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Group"]();
    this.group.add(this._axisGroup);

    if (!axisModel.get('show')) {
      return;
    }

    var gridModel = axisModel.getCoordSysModel();
    var layout = __WEBPACK_IMPORTED_MODULE_5__coord_cartesian_cartesianAxisHelper_js__["a" /* layout */](gridModel, axisModel);
    var axisBuilder = new __WEBPACK_IMPORTED_MODULE_3__AxisBuilder_js__["a" /* default */](axisModel, __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"]({
      handleAutoShown: function (elementType) {
        var cartesians = gridModel.coordinateSystem.getCartesians();

        for (var i = 0; i < cartesians.length; i++) {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__scale_helper_js__["h" /* isIntervalOrLogScale */])(cartesians[i].getOtherAxis(axisModel.axis).scale)) {
            // Still show axis tick or axisLine if other axis is value / log
            return true;
          }
        } // Not show axisTick or axisLine if other axis is category / time


        return false;
      }
    }, layout));
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](axisBuilderAttrs, axisBuilder.add, axisBuilder);

    this._axisGroup.add(axisBuilder.getGroup());

    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](selfBuilderAttrs, function (name) {
      if (axisModel.get([name, 'show'])) {
        axisElementBuilders[name](this, this._axisGroup, axisModel, gridModel);
      }
    }, this); // THIS is a special case for bar racing chart.
    // Update the axis label from the natural initial layout to
    // sorted layout should has no animation.

    var isInitialSortFromBarRacing = payload && payload.type === 'changeAxisOrder' && payload.isInitSort;

    if (!isInitialSortFromBarRacing) {
      __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["groupTransition"](oldAxisGroup, this._axisGroup, axisModel);
    }

    _super.prototype.render.call(this, axisModel, ecModel, api, payload);
  };

  CartesianAxisView.prototype.remove = function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__axisSplitHelper_js__["a" /* rectCoordAxisHandleRemove */])(this);
  };

  CartesianAxisView.type = 'cartesianAxis';
  return CartesianAxisView;
}(__WEBPACK_IMPORTED_MODULE_4__AxisView_js__["a" /* default */]);

var axisElementBuilders = {
  splitLine: function (axisView, axisGroup, axisModel, gridModel) {
    var axis = axisModel.axis;

    if (axis.scale.isBlank()) {
      return;
    }

    var splitLineModel = axisModel.getModel('splitLine');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var lineColors = lineStyleModel.get('color');
    lineColors = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](lineColors) ? lineColors : [lineColors];
    var gridRect = gridModel.coordinateSystem.getRect();
    var isHorizontal = axis.isHorizontal();
    var lineCount = 0;
    var ticksCoords = axis.getTicksCoords({
      tickModel: splitLineModel
    });
    var p1 = [];
    var p2 = [];
    var lineStyle = lineStyleModel.getLineStyle();

    for (var i = 0; i < ticksCoords.length; i++) {
      var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);

      if (isHorizontal) {
        p1[0] = tickCoord;
        p1[1] = gridRect.y;
        p2[0] = tickCoord;
        p2[1] = gridRect.y + gridRect.height;
      } else {
        p1[0] = gridRect.x;
        p1[1] = tickCoord;
        p2[0] = gridRect.x + gridRect.width;
        p2[1] = tickCoord;
      }

      var colorIndex = lineCount++ % lineColors.length;
      var tickValue = ticksCoords[i].tickValue;
      axisGroup.add(new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Line"]({
        anid: tickValue != null ? 'line_' + ticksCoords[i].tickValue : null,
        subPixelOptimize: true,
        autoBatch: true,
        shape: {
          x1: p1[0],
          y1: p1[1],
          x2: p2[0],
          y2: p2[1]
        },
        style: __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"]({
          stroke: lineColors[colorIndex]
        }, lineStyle),
        silent: true
      }));
    }
  },
  minorSplitLine: function (axisView, axisGroup, axisModel, gridModel) {
    var axis = axisModel.axis;
    var minorSplitLineModel = axisModel.getModel('minorSplitLine');
    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
    var gridRect = gridModel.coordinateSystem.getRect();
    var isHorizontal = axis.isHorizontal();
    var minorTicksCoords = axis.getMinorTicksCoords();

    if (!minorTicksCoords.length) {
      return;
    }

    var p1 = [];
    var p2 = [];
    var lineStyle = lineStyleModel.getLineStyle();

    for (var i = 0; i < minorTicksCoords.length; i++) {
      for (var k = 0; k < minorTicksCoords[i].length; k++) {
        var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);

        if (isHorizontal) {
          p1[0] = tickCoord;
          p1[1] = gridRect.y;
          p2[0] = tickCoord;
          p2[1] = gridRect.y + gridRect.height;
        } else {
          p1[0] = gridRect.x;
          p1[1] = tickCoord;
          p2[0] = gridRect.x + gridRect.width;
          p2[1] = tickCoord;
        }

        axisGroup.add(new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Line"]({
          anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
          subPixelOptimize: true,
          autoBatch: true,
          shape: {
            x1: p1[0],
            y1: p1[1],
            x2: p2[0],
            y2: p2[1]
          },
          style: lineStyle,
          silent: true
        }));
      }
    }
  },
  splitArea: function (axisView, axisGroup, axisModel, gridModel) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__axisSplitHelper_js__["b" /* rectCoordAxisBuildSplitArea */])(axisView, axisGroup, axisModel, gridModel);
  }
};

var CartesianXAxisView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(CartesianXAxisView, _super);

  function CartesianXAxisView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = CartesianXAxisView.type;
    return _this;
  }

  CartesianXAxisView.type = 'xAxis';
  return CartesianXAxisView;
}(CartesianAxisView);



var CartesianYAxisView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(CartesianYAxisView, _super);

  function CartesianYAxisView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = CartesianXAxisView.type;
    return _this;
  }

  CartesianYAxisView.type = 'yAxis';
  return CartesianYAxisView;
}(CartesianAxisView);


/* unused harmony default export */ var _unused_webpack_default_export = (CartesianAxisView);

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AxisBuilder_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_BrushController_js__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_brushHelper_js__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_Component_js__ = __webpack_require__(30);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







var elementList = ['axisLine', 'axisTickLabel', 'axisName'];

var ParallelAxisView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ParallelAxisView, _super);

  function ParallelAxisView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ParallelAxisView.type;
    return _this;
  }

  ParallelAxisView.prototype.init = function (ecModel, api) {
    _super.prototype.init.apply(this, arguments);

    (this._brushController = new __WEBPACK_IMPORTED_MODULE_3__helper_BrushController_js__["a" /* default */](api.getZr())).on('brush', __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"](this._onBrush, this));
  };

  ParallelAxisView.prototype.render = function (axisModel, ecModel, api, payload) {
    if (fromAxisAreaSelect(axisModel, ecModel, payload)) {
      return;
    }

    this.axisModel = axisModel;
    this.api = api;
    this.group.removeAll();
    var oldAxisGroup = this._axisGroup;
    this._axisGroup = new __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["Group"]();
    this.group.add(this._axisGroup);

    if (!axisModel.get('show')) {
      return;
    }

    var coordSysModel = getCoordSysModel(axisModel, ecModel);
    var coordSys = coordSysModel.coordinateSystem;
    var areaSelectStyle = axisModel.getAreaSelectStyle();
    var areaWidth = areaSelectStyle.width;
    var dim = axisModel.axis.dim;
    var axisLayout = coordSys.getAxisLayout(dim);
    var builderOpt = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"]({
      strokeContainThreshold: areaWidth
    }, axisLayout);
    var axisBuilder = new __WEBPACK_IMPORTED_MODULE_2__AxisBuilder_js__["a" /* default */](axisModel, builderOpt);
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](elementList, axisBuilder.add, axisBuilder);

    this._axisGroup.add(axisBuilder.getGroup());

    this._refreshBrushController(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api);

    __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["groupTransition"](oldAxisGroup, this._axisGroup, axisModel);
  }; // /**
  //  * @override
  //  */
  // updateVisual(axisModel, ecModel, api, payload) {
  //     this._brushController && this._brushController
  //         .updateCovers(getCoverInfoList(axisModel));
  // }


  ParallelAxisView.prototype._refreshBrushController = function (builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api) {
    // After filtering, axis may change, select area needs to be update.
    var extent = axisModel.axis.getExtent();
    var extentLen = extent[1] - extent[0];
    var extra = Math.min(30, Math.abs(extentLen) * 0.1); // Arbitrary value.
    // width/height might be negative, which will be
    // normalized in BoundingRect.

    var rect = __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["BoundingRect"].create({
      x: extent[0],
      y: -areaWidth / 2,
      width: extentLen,
      height: areaWidth
    });
    rect.x -= extra;
    rect.width += 2 * extra;

    this._brushController.mount({
      enableGlobalPan: true,
      rotation: builderOpt.rotation,
      x: builderOpt.position[0],
      y: builderOpt.position[1]
    }).setPanels([{
      panelId: 'pl',
      clipPath: __WEBPACK_IMPORTED_MODULE_4__helper_brushHelper_js__["a" /* makeRectPanelClipPath */](rect),
      isTargetByCursor: __WEBPACK_IMPORTED_MODULE_4__helper_brushHelper_js__["b" /* makeRectIsTargetByCursor */](rect, api, coordSysModel),
      getLinearBrushOtherExtent: __WEBPACK_IMPORTED_MODULE_4__helper_brushHelper_js__["c" /* makeLinearBrushOtherExtent */](rect, 0)
    }]).enableBrush({
      brushType: 'lineX',
      brushStyle: areaSelectStyle,
      removeOnClick: true
    }).updateCovers(getCoverInfoList(axisModel));
  };

  ParallelAxisView.prototype._onBrush = function (eventParam) {
    var coverInfoList = eventParam.areas; // Do not cache these object, because the mey be changed.

    var axisModel = this.axisModel;
    var axis = axisModel.axis;
    var intervals = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"](coverInfoList, function (coverInfo) {
      return [axis.coordToData(coverInfo.range[0], true), axis.coordToData(coverInfo.range[1], true)];
    }); // If realtime is true, action is not dispatched on drag end, because
    // the drag end emits the same params with the last drag move event,
    // and may have some delay when using touch pad.

    if (!axisModel.option.realtime === eventParam.isEnd || eventParam.removeOnClick) {
      // jshint ignore:line
      this.api.dispatchAction({
        type: 'axisAreaSelect',
        parallelAxisId: axisModel.id,
        intervals: intervals
      });
    }
  };

  ParallelAxisView.prototype.dispose = function () {
    this._brushController.dispose();
  };

  ParallelAxisView.type = 'parallelAxis';
  return ParallelAxisView;
}(__WEBPACK_IMPORTED_MODULE_6__view_Component_js__["a" /* default */]);

function fromAxisAreaSelect(axisModel, ecModel, payload) {
  return payload && payload.type === 'axisAreaSelect' && ecModel.findComponents({
    mainType: 'parallelAxis',
    query: payload
  })[0] === axisModel;
}

function getCoverInfoList(axisModel) {
  var axis = axisModel.axis;
  return __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"](axisModel.activeIntervals, function (interval) {
    return {
      brushType: 'lineX',
      panelId: 'pl',
      range: [axis.dataToCoord(interval[0], true), axis.dataToCoord(interval[1], true)]
    };
  });
}

function getCoordSysModel(axisModel, ecModel) {
  return ecModel.getComponent('parallel', axisModel.get('parallelIndex'));
}

/* harmony default export */ __webpack_exports__["a"] = (ParallelAxisView);

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AxisBuilder_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AxisView_js__ = __webpack_require__(132);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
var selfBuilderAttrs = ['splitLine', 'splitArea', 'minorSplitLine'];

var RadiusAxisView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(RadiusAxisView, _super);

  function RadiusAxisView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = RadiusAxisView.type;
    _this.axisPointerClass = 'PolarAxisPointer';
    return _this;
  }

  RadiusAxisView.prototype.render = function (radiusAxisModel, ecModel) {
    this.group.removeAll();

    if (!radiusAxisModel.get('show')) {
      return;
    }

    var oldAxisGroup = this._axisGroup;
    var newAxisGroup = this._axisGroup = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Group"]();
    this.group.add(newAxisGroup);
    var radiusAxis = radiusAxisModel.axis;
    var polar = radiusAxis.polar;
    var angleAxis = polar.getAngleAxis();
    var ticksCoords = radiusAxis.getTicksCoords();
    var minorTicksCoords = radiusAxis.getMinorTicksCoords();
    var axisAngle = angleAxis.getExtent()[0];
    var radiusExtent = radiusAxis.getExtent();
    var layout = layoutAxis(polar, radiusAxisModel, axisAngle);
    var axisBuilder = new __WEBPACK_IMPORTED_MODULE_3__AxisBuilder_js__["a" /* default */](radiusAxisModel, layout);
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](axisBuilderAttrs, axisBuilder.add, axisBuilder);
    newAxisGroup.add(axisBuilder.getGroup());
    __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["groupTransition"](oldAxisGroup, newAxisGroup, radiusAxisModel);
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](selfBuilderAttrs, function (name) {
      if (radiusAxisModel.get([name, 'show']) && !radiusAxis.scale.isBlank()) {
        axisElementBuilders[name](this.group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords);
      }
    }, this);
  };

  RadiusAxisView.type = 'radiusAxis';
  return RadiusAxisView;
}(__WEBPACK_IMPORTED_MODULE_4__AxisView_js__["a" /* default */]);

var axisElementBuilders = {
  splitLine: function (group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
    var splitLineModel = radiusAxisModel.getModel('splitLine');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var lineColors = lineStyleModel.get('color');
    var lineCount = 0;
    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
    var splitLines = [];

    for (var i = 0; i < ticksCoords.length; i++) {
      var colorIndex = lineCount++ % lineColors.length;
      splitLines[colorIndex] = splitLines[colorIndex] || [];
      splitLines[colorIndex].push(new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Circle"]({
        shape: {
          cx: polar.cx,
          cy: polar.cy,
          // ensure circle radius >= 0
          r: Math.max(ticksCoords[i].coord, 0)
        }
      }));
    } // Simple optimization
    // Batching the lines if color are the same


    for (var i = 0; i < splitLines.length; i++) {
      group.add(__WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["mergePath"](splitLines[i], {
        style: __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"]({
          stroke: lineColors[i % lineColors.length],
          fill: null
        }, lineStyleModel.getLineStyle()),
        silent: true
      }));
    }
  },
  minorSplitLine: function (group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords) {
    if (!minorTicksCoords.length) {
      return;
    }

    var minorSplitLineModel = radiusAxisModel.getModel('minorSplitLine');
    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
    var lines = [];

    for (var i = 0; i < minorTicksCoords.length; i++) {
      for (var k = 0; k < minorTicksCoords[i].length; k++) {
        lines.push(new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Circle"]({
          shape: {
            cx: polar.cx,
            cy: polar.cy,
            r: minorTicksCoords[i][k].coord
          }
        }));
      }
    }

    group.add(__WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["mergePath"](lines, {
      style: __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"]({
        fill: null
      }, lineStyleModel.getLineStyle()),
      silent: true
    }));
  },
  splitArea: function (group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
    if (!ticksCoords.length) {
      return;
    }

    var splitAreaModel = radiusAxisModel.getModel('splitArea');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var areaColors = areaStyleModel.get('color');
    var lineCount = 0;
    areaColors = areaColors instanceof Array ? areaColors : [areaColors];
    var splitAreas = [];
    var prevRadius = ticksCoords[0].coord;

    for (var i = 1; i < ticksCoords.length; i++) {
      var colorIndex = lineCount++ % areaColors.length;
      splitAreas[colorIndex] = splitAreas[colorIndex] || [];
      splitAreas[colorIndex].push(new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Sector"]({
        shape: {
          cx: polar.cx,
          cy: polar.cy,
          r0: prevRadius,
          r: ticksCoords[i].coord,
          startAngle: 0,
          endAngle: Math.PI * 2
        },
        silent: true
      }));
      prevRadius = ticksCoords[i].coord;
    } // Simple optimization
    // Batching the lines if color are the same


    for (var i = 0; i < splitAreas.length; i++) {
      group.add(__WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["mergePath"](splitAreas[i], {
        style: __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"]({
          fill: areaColors[i % areaColors.length]
        }, areaStyleModel.getAreaStyle()),
        silent: true
      }));
    }
  }
};
/**
 * @inner
 */

function layoutAxis(polar, radiusAxisModel, axisAngle) {
  return {
    position: [polar.cx, polar.cy],
    rotation: axisAngle / 180 * Math.PI,
    labelDirection: -1,
    tickDirection: -1,
    nameDirection: 1,
    labelRotate: radiusAxisModel.getModel('axisLabel').get('rotate'),
    // Over splitLine and splitArea
    z2: 1
  };
}

/* harmony default export */ __webpack_exports__["a"] = (RadiusAxisView);

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AxisBuilder_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__coord_single_singleAxisHelper_js__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AxisView_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__axisSplitHelper_js__ = __webpack_require__(457);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
var selfBuilderAttrs = ['splitArea', 'splitLine'];

var SingleAxisView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(SingleAxisView, _super);

  function SingleAxisView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SingleAxisView.type;
    _this.axisPointerClass = 'SingleAxisPointer';
    return _this;
  }

  SingleAxisView.prototype.render = function (axisModel, ecModel, api, payload) {
    var group = this.group;
    group.removeAll();
    var oldAxisGroup = this._axisGroup;
    this._axisGroup = new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Group"]();
    var layout = __WEBPACK_IMPORTED_MODULE_4__coord_single_singleAxisHelper_js__["a" /* layout */](axisModel);
    var axisBuilder = new __WEBPACK_IMPORTED_MODULE_2__AxisBuilder_js__["a" /* default */](axisModel, layout);
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](axisBuilderAttrs, axisBuilder.add, axisBuilder);
    group.add(this._axisGroup);
    group.add(axisBuilder.getGroup());
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](selfBuilderAttrs, function (name) {
      if (axisModel.get([name, 'show'])) {
        axisElementBuilders[name](this, this.group, this._axisGroup, axisModel);
      }
    }, this);
    __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["groupTransition"](oldAxisGroup, this._axisGroup, axisModel);

    _super.prototype.render.call(this, axisModel, ecModel, api, payload);
  };

  SingleAxisView.prototype.remove = function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__axisSplitHelper_js__["a" /* rectCoordAxisHandleRemove */])(this);
  };

  SingleAxisView.type = 'singleAxis';
  return SingleAxisView;
}(__WEBPACK_IMPORTED_MODULE_5__AxisView_js__["a" /* default */]);

var axisElementBuilders = {
  splitLine: function (axisView, group, axisGroup, axisModel) {
    var axis = axisModel.axis;

    if (axis.scale.isBlank()) {
      return;
    }

    var splitLineModel = axisModel.getModel('splitLine');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var lineColors = lineStyleModel.get('color');
    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
    var gridRect = axisModel.coordinateSystem.getRect();
    var isHorizontal = axis.isHorizontal();
    var splitLines = [];
    var lineCount = 0;
    var ticksCoords = axis.getTicksCoords({
      tickModel: splitLineModel
    });
    var p1 = [];
    var p2 = [];

    for (var i = 0; i < ticksCoords.length; ++i) {
      var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);

      if (isHorizontal) {
        p1[0] = tickCoord;
        p1[1] = gridRect.y;
        p2[0] = tickCoord;
        p2[1] = gridRect.y + gridRect.height;
      } else {
        p1[0] = gridRect.x;
        p1[1] = tickCoord;
        p2[0] = gridRect.x + gridRect.width;
        p2[1] = tickCoord;
      }

      var colorIndex = lineCount++ % lineColors.length;
      splitLines[colorIndex] = splitLines[colorIndex] || [];
      splitLines[colorIndex].push(new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Line"]({
        subPixelOptimize: true,
        shape: {
          x1: p1[0],
          y1: p1[1],
          x2: p2[0],
          y2: p2[1]
        },
        silent: true
      }));
    }

    var lineStyle = lineStyleModel.getLineStyle(['color']);

    for (var i = 0; i < splitLines.length; ++i) {
      group.add(__WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["mergePath"](splitLines[i], {
        style: __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"]({
          stroke: lineColors[i % lineColors.length]
        }, lineStyle),
        silent: true
      }));
    }
  },
  splitArea: function (axisView, group, axisGroup, axisModel) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__axisSplitHelper_js__["b" /* rectCoordAxisBuildSplitArea */])(axisView, axisGroup, axisModel, axisModel);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (SingleAxisView);

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = installParallelActions;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var actionInfo = {
  type: 'axisAreaSelect',
  event: 'axisAreaSelected' // update: 'updateVisual'

};
function installParallelActions(registers) {
  registers.registerAction(actionInfo, function (payload, ecModel) {
    ecModel.eachComponent({
      mainType: 'parallelAxis',
      query: payload
    }, function (parallelAxisModel) {
      parallelAxisModel.axis.model.setActiveIntervals(payload.intervals);
    });
  });
  /**
   * @payload
   */

  registers.registerAction('parallelAxisExpand', function (payload, ecModel) {
    ecModel.eachComponent({
      mainType: 'parallel',
      query: payload
    }, function (parallelModel) {
      parallelModel.setAxisExpand(payload);
    });
  });
}

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_Component_js__ = __webpack_require__(21);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var AxisPointerModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(AxisPointerModel, _super);

  function AxisPointerModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = AxisPointerModel.type;
    return _this;
  }

  AxisPointerModel.type = 'axisPointer';
  AxisPointerModel.defaultOption = {
    // 'auto' means that show when triggered by tooltip or handle.
    show: 'auto',
    // zlevel: 0,
    z: 50,
    type: 'line',
    // axispointer triggered by tootip determine snap automatically,
    // see `modelHelper`.
    snap: false,
    triggerTooltip: true,
    value: null,
    status: null,
    link: [],
    // Do not set 'auto' here, otherwise global animation: false
    // will not effect at this axispointer.
    animation: null,
    animationDurationUpdate: 200,
    lineStyle: {
      color: '#B9BEC9',
      width: 1,
      type: 'dashed'
    },
    shadowStyle: {
      color: 'rgba(210,219,238,0.2)'
    },
    label: {
      show: true,
      formatter: null,
      precision: 'auto',
      margin: 3,
      color: '#fff',
      padding: [5, 7, 5, 7],
      backgroundColor: 'auto',
      borderColor: null,
      borderWidth: 0,
      borderRadius: 3
    },
    handle: {
      show: false,
      // eslint-disable-next-line
      icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
      size: 45,
      // handle margin is from symbol center to axis, which is stable when circular move.
      margin: 50,
      // color: '#1b8bbd'
      // color: '#2f4554'
      color: '#333',
      shadowBlur: 3,
      shadowColor: '#aaa',
      shadowOffsetX: 0,
      shadowOffsetY: 2,
      // For mobile performance
      throttle: 40
    }
  };
  return AxisPointerModel;
}(__WEBPACK_IMPORTED_MODULE_1__model_Component_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AxisPointerModel);

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globalListener_js__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_Component_js__ = __webpack_require__(30);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var AxisPointerView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(AxisPointerView, _super);

  function AxisPointerView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = AxisPointerView.type;
    return _this;
  }

  AxisPointerView.prototype.render = function (globalAxisPointerModel, ecModel, api) {
    var globalTooltipModel = ecModel.getComponent('tooltip');
    var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click'; // Register global listener in AxisPointerView to enable
    // AxisPointerView to be independent to Tooltip.

    __WEBPACK_IMPORTED_MODULE_1__globalListener_js__["a" /* register */]('axisPointer', api, function (currTrigger, e, dispatchAction) {
      // If 'none', it is not controlled by mouse totally.
      if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) {
        dispatchAction({
          type: 'updateAxisPointer',
          currTrigger: currTrigger,
          x: e && e.offsetX,
          y: e && e.offsetY
        });
      }
    });
  };

  AxisPointerView.prototype.remove = function (ecModel, api) {
    __WEBPACK_IMPORTED_MODULE_1__globalListener_js__["b" /* unregister */]('axisPointer', api);
  };

  AxisPointerView.prototype.dispose = function (ecModel, api) {
    __WEBPACK_IMPORTED_MODULE_1__globalListener_js__["b" /* unregister */]('axisPointer', api);
  };

  AxisPointerView.type = 'axisPointer';
  return AxisPointerView;
}(__WEBPACK_IMPORTED_MODULE_2__view_Component_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AxisPointerView);

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseAxisPointer_js__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__viewHelper_js__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__coord_cartesian_cartesianAxisHelper_js__ = __webpack_require__(327);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var CartesianAxisPointer =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(CartesianAxisPointer, _super);

  function CartesianAxisPointer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @override
   */


  CartesianAxisPointer.prototype.makeElOption = function (elOption, value, axisModel, axisPointerModel, api) {
    var axis = axisModel.axis;
    var grid = axis.grid;
    var axisPointerType = axisPointerModel.get('type');
    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
    var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));

    if (axisPointerType && axisPointerType !== 'none') {
      var elStyle = __WEBPACK_IMPORTED_MODULE_2__viewHelper_js__["a" /* buildElStyle */](axisPointerModel);
      var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
      pointerOption.style = elStyle;
      elOption.graphicKey = pointerOption.type;
      elOption.pointer = pointerOption;
    }

    var layoutInfo = __WEBPACK_IMPORTED_MODULE_3__coord_cartesian_cartesianAxisHelper_js__["a" /* layout */](grid.model, axisModel);
    __WEBPACK_IMPORTED_MODULE_2__viewHelper_js__["b" /* buildCartesianSingleLabelElOption */]( // @ts-ignore
    value, elOption, layoutInfo, axisModel, axisPointerModel, api);
  };
  /**
   * @override
   */


  CartesianAxisPointer.prototype.getHandleTransform = function (value, axisModel, axisPointerModel) {
    var layoutInfo = __WEBPACK_IMPORTED_MODULE_3__coord_cartesian_cartesianAxisHelper_js__["a" /* layout */](axisModel.axis.grid.model, axisModel, {
      labelInside: false
    }); // @ts-ignore

    layoutInfo.labelMargin = axisPointerModel.get(['handle', 'margin']);
    var pos = __WEBPACK_IMPORTED_MODULE_2__viewHelper_js__["c" /* getTransformedPosition */](axisModel.axis, value, layoutInfo);
    return {
      x: pos[0],
      y: pos[1],
      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
    };
  };
  /**
   * @override
   */


  CartesianAxisPointer.prototype.updateHandleTransform = function (transform, delta, axisModel, axisPointerModel) {
    var axis = axisModel.axis;
    var grid = axis.grid;
    var axisExtent = axis.getGlobalExtent(true);
    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
    var dimIndex = axis.dim === 'x' ? 0 : 1;
    var currPosition = [transform.x, transform.y];
    currPosition[dimIndex] += delta[dimIndex];
    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
    var cursorPoint = [cursorOtherValue, cursorOtherValue];
    cursorPoint[dimIndex] = currPosition[dimIndex]; // Make tooltip do not overlap axisPointer and in the middle of the grid.

    var tooltipOptions = [{
      verticalAlign: 'middle'
    }, {
      align: 'center'
    }];
    return {
      x: currPosition[0],
      y: currPosition[1],
      rotation: transform.rotation,
      cursorPoint: cursorPoint,
      tooltipOption: tooltipOptions[dimIndex]
    };
  };

  return CartesianAxisPointer;
}(__WEBPACK_IMPORTED_MODULE_1__BaseAxisPointer_js__["a" /* default */]);

function getCartesian(grid, axis) {
  var opt = {};
  opt[axis.dim + 'AxisIndex'] = axis.index;
  return grid.getCartesian(opt);
}

var pointerShapeBuilder = {
  line: function (axis, pixelValue, otherExtent) {
    var targetShape = __WEBPACK_IMPORTED_MODULE_2__viewHelper_js__["d" /* makeLineShape */]([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getAxisDimIndex(axis));
    return {
      type: 'Line',
      subPixelOptimize: true,
      shape: targetShape
    };
  },
  shadow: function (axis, pixelValue, otherExtent) {
    var bandWidth = Math.max(1, axis.getBandWidth());
    var span = otherExtent[1] - otherExtent[0];
    return {
      type: 'Rect',
      shape: __WEBPACK_IMPORTED_MODULE_2__viewHelper_js__["e" /* makeRectShape */]([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getAxisDimIndex(axis))
    };
  }
};

function getAxisDimIndex(axis) {
  return axis.dim === 'x' ? 0 : 1;
}

/* harmony default export */ __webpack_exports__["a"] = (CartesianAxisPointer);

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseAxisPointer_js__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewHelper_js__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_matrix_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__axis_AxisBuilder_js__ = __webpack_require__(111);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







var PolarAxisPointer =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(PolarAxisPointer, _super);

  function PolarAxisPointer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @override
   */


  PolarAxisPointer.prototype.makeElOption = function (elOption, value, axisModel, axisPointerModel, api) {
    var axis = axisModel.axis;

    if (axis.dim === 'angle') {
      this.animationThreshold = Math.PI / 18;
    }

    var polar = axis.polar;
    var otherAxis = polar.getOtherAxis(axis);
    var otherExtent = otherAxis.getExtent();
    var coordValue = axis.dataToCoord(value);
    var axisPointerType = axisPointerModel.get('type');

    if (axisPointerType && axisPointerType !== 'none') {
      var elStyle = __WEBPACK_IMPORTED_MODULE_3__viewHelper_js__["a" /* buildElStyle */](axisPointerModel);
      var pointerOption = pointerShapeBuilder[axisPointerType](axis, polar, coordValue, otherExtent);
      pointerOption.style = elStyle;
      elOption.graphicKey = pointerOption.type;
      elOption.pointer = pointerOption;
    }

    var labelMargin = axisPointerModel.get(['label', 'margin']);
    var labelPos = getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin);
    __WEBPACK_IMPORTED_MODULE_3__viewHelper_js__["g" /* buildLabelElOption */](elOption, axisModel, axisPointerModel, api, labelPos);
  };

  return PolarAxisPointer;
}(__WEBPACK_IMPORTED_MODULE_1__BaseAxisPointer_js__["a" /* default */]);

;

function getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin) {
  var axis = axisModel.axis;
  var coord = axis.dataToCoord(value);
  var axisAngle = polar.getAngleAxis().getExtent()[0];
  axisAngle = axisAngle / 180 * Math.PI;
  var radiusExtent = polar.getRadiusAxis().getExtent();
  var position;
  var align;
  var verticalAlign;

  if (axis.dim === 'radius') {
    var transform = __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_matrix_js__["create"]();
    __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_matrix_js__["rotate"](transform, transform, axisAngle);
    __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_matrix_js__["translate"](transform, transform, [polar.cx, polar.cy]);
    position = __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["applyTransform"]([coord, -labelMargin], transform);
    var labelRotation = axisModel.getModel('axisLabel').get('rotate') || 0; // @ts-ignore

    var labelLayout = __WEBPACK_IMPORTED_MODULE_5__axis_AxisBuilder_js__["a" /* default */].innerTextLayout(axisAngle, labelRotation * Math.PI / 180, -1);
    align = labelLayout.textAlign;
    verticalAlign = labelLayout.textVerticalAlign;
  } else {
    // angle axis
    var r = radiusExtent[1];
    position = polar.coordToPoint([r + labelMargin, coord]);
    var cx = polar.cx;
    var cy = polar.cy;
    align = Math.abs(position[0] - cx) / r < 0.3 ? 'center' : position[0] > cx ? 'left' : 'right';
    verticalAlign = Math.abs(position[1] - cy) / r < 0.3 ? 'middle' : position[1] > cy ? 'top' : 'bottom';
  }

  return {
    position: position,
    align: align,
    verticalAlign: verticalAlign
  };
}

var pointerShapeBuilder = {
  line: function (axis, polar, coordValue, otherExtent) {
    return axis.dim === 'angle' ? {
      type: 'Line',
      shape: __WEBPACK_IMPORTED_MODULE_3__viewHelper_js__["d" /* makeLineShape */](polar.coordToPoint([otherExtent[0], coordValue]), polar.coordToPoint([otherExtent[1], coordValue]))
    } : {
      type: 'Circle',
      shape: {
        cx: polar.cx,
        cy: polar.cy,
        r: coordValue
      }
    };
  },
  shadow: function (axis, polar, coordValue, otherExtent) {
    var bandWidth = Math.max(1, axis.getBandWidth());
    var radian = Math.PI / 180;
    return axis.dim === 'angle' ? {
      type: 'Sector',
      shape: __WEBPACK_IMPORTED_MODULE_3__viewHelper_js__["h" /* makeSectorShape */](polar.cx, polar.cy, otherExtent[0], otherExtent[1], // In ECharts y is negative if angle is positive
      (-coordValue - bandWidth / 2) * radian, (-coordValue + bandWidth / 2) * radian)
    } : {
      type: 'Sector',
      shape: __WEBPACK_IMPORTED_MODULE_3__viewHelper_js__["h" /* makeSectorShape */](polar.cx, polar.cy, coordValue - bandWidth / 2, coordValue + bandWidth / 2, 0, Math.PI * 2)
    };
  }
};
/* harmony default export */ __webpack_exports__["a"] = (PolarAxisPointer);

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseAxisPointer_js__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__viewHelper_js__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__coord_single_singleAxisHelper_js__ = __webpack_require__(488);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var XY = ['x', 'y'];
var WH = ['width', 'height'];

var SingleAxisPointer =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(SingleAxisPointer, _super);

  function SingleAxisPointer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @override
   */


  SingleAxisPointer.prototype.makeElOption = function (elOption, value, axisModel, axisPointerModel, api) {
    var axis = axisModel.axis;
    var coordSys = axis.coordinateSystem;
    var otherExtent = getGlobalExtent(coordSys, 1 - getPointDimIndex(axis));
    var pixelValue = coordSys.dataToPoint(value)[0];
    var axisPointerType = axisPointerModel.get('type');

    if (axisPointerType && axisPointerType !== 'none') {
      var elStyle = __WEBPACK_IMPORTED_MODULE_2__viewHelper_js__["a" /* buildElStyle */](axisPointerModel);
      var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
      pointerOption.style = elStyle;
      elOption.graphicKey = pointerOption.type;
      elOption.pointer = pointerOption;
    }

    var layoutInfo = __WEBPACK_IMPORTED_MODULE_3__coord_single_singleAxisHelper_js__["a" /* layout */](axisModel);
    __WEBPACK_IMPORTED_MODULE_2__viewHelper_js__["b" /* buildCartesianSingleLabelElOption */]( // @ts-ignore
    value, elOption, layoutInfo, axisModel, axisPointerModel, api);
  };
  /**
   * @override
   */


  SingleAxisPointer.prototype.getHandleTransform = function (value, axisModel, axisPointerModel) {
    var layoutInfo = __WEBPACK_IMPORTED_MODULE_3__coord_single_singleAxisHelper_js__["a" /* layout */](axisModel, {
      labelInside: false
    }); // @ts-ignore

    layoutInfo.labelMargin = axisPointerModel.get(['handle', 'margin']);
    var position = __WEBPACK_IMPORTED_MODULE_2__viewHelper_js__["c" /* getTransformedPosition */](axisModel.axis, value, layoutInfo);
    return {
      x: position[0],
      y: position[1],
      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
    };
  };
  /**
   * @override
   */


  SingleAxisPointer.prototype.updateHandleTransform = function (transform, delta, axisModel, axisPointerModel) {
    var axis = axisModel.axis;
    var coordSys = axis.coordinateSystem;
    var dimIndex = getPointDimIndex(axis);
    var axisExtent = getGlobalExtent(coordSys, dimIndex);
    var currPosition = [transform.x, transform.y];
    currPosition[dimIndex] += delta[dimIndex];
    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
    var otherExtent = getGlobalExtent(coordSys, 1 - dimIndex);
    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
    var cursorPoint = [cursorOtherValue, cursorOtherValue];
    cursorPoint[dimIndex] = currPosition[dimIndex];
    return {
      x: currPosition[0],
      y: currPosition[1],
      rotation: transform.rotation,
      cursorPoint: cursorPoint,
      tooltipOption: {
        verticalAlign: 'middle'
      }
    };
  };

  return SingleAxisPointer;
}(__WEBPACK_IMPORTED_MODULE_1__BaseAxisPointer_js__["a" /* default */]);

var pointerShapeBuilder = {
  line: function (axis, pixelValue, otherExtent) {
    var targetShape = __WEBPACK_IMPORTED_MODULE_2__viewHelper_js__["d" /* makeLineShape */]([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getPointDimIndex(axis));
    return {
      type: 'Line',
      subPixelOptimize: true,
      shape: targetShape
    };
  },
  shadow: function (axis, pixelValue, otherExtent) {
    var bandWidth = axis.getBandWidth();
    var span = otherExtent[1] - otherExtent[0];
    return {
      type: 'Rect',
      shape: __WEBPACK_IMPORTED_MODULE_2__viewHelper_js__["e" /* makeRectShape */]([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getPointDimIndex(axis))
    };
  }
};

function getPointDimIndex(axis) {
  return axis.isHorizontal() ? 0 : 1;
}

function getGlobalExtent(coordSys, dimIndex) {
  var rect = coordSys.getRect();
  return [rect[XY[dimIndex]], rect[XY[dimIndex]] + rect[WH[dimIndex]]];
}

/* harmony default export */ __webpack_exports__["a"] = (SingleAxisPointer);

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = axisTrigger;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modelHelper_js__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__findPointFromSeries_js__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var inner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_model_js__["a" /* makeInner */])();
/**
 * Basic logic: check all axis, if they do not demand show/highlight,
 * then hide/downplay them.
 *
 * @return content of event obj for echarts.connect.
 */

function axisTrigger(payload, ecModel, api) {
  var currTrigger = payload.currTrigger;
  var point = [payload.x, payload.y];
  var finder = payload;
  var dispatchAction = payload.dispatchAction || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["bind"])(api.dispatchAction, api);
  var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo; // Pending
  // See #6121. But we are not able to reproduce it yet.

  if (!coordSysAxesInfo) {
    return;
  }

  if (illegalPoint(point)) {
    // Used in the default behavior of `connection`: use the sample seriesIndex
    // and dataIndex. And also used in the tooltipView trigger.
    point = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__findPointFromSeries_js__["a" /* default */])({
      seriesIndex: finder.seriesIndex,
      // Do not use dataIndexInside from other ec instance.
      // FIXME: auto detect it?
      dataIndex: finder.dataIndex
    }, ecModel).point;
  }

  var isIllegalPoint = illegalPoint(point); // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
  // Notice: In this case, it is difficult to get the `point` (which is necessary to show
  // tooltip, so if point is not given, we just use the point found by sample seriesIndex
  // and dataIndex.

  var inputAxesInfo = finder.axesInfo;
  var axesInfo = coordSysAxesInfo.axesInfo;
  var shouldHide = currTrigger === 'leave' || illegalPoint(point);
  var outputPayload = {};
  var showValueMap = {};
  var dataByCoordSys = {
    list: [],
    map: {}
  };
  var updaters = {
    showPointer: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["curry"])(showPointer, showValueMap),
    showTooltip: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["curry"])(showTooltip, dataByCoordSys)
  }; // Process for triggered axes.

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(coordSysAxesInfo.coordSysMap, function (coordSys, coordSysKey) {
    // If a point given, it must be contained by the coordinate system.
    var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function (axisInfo, key) {
      var axis = axisInfo.axis;
      var inputAxisInfo = findInputAxisInfo(inputAxesInfo, axisInfo); // If no inputAxesInfo, no axis is restricted.

      if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
        var val = inputAxisInfo && inputAxisInfo.value;

        if (val == null && !isIllegalPoint) {
          val = axis.pointToData(point);
        }

        val != null && processOnAxis(axisInfo, val, updaters, false, outputPayload);
      }
    });
  }); // Process for linked axes.

  var linkTriggers = {};
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(axesInfo, function (tarAxisInfo, tarKey) {
    var linkGroup = tarAxisInfo.linkGroup; // If axis has been triggered in the previous stage, it should not be triggered by link.

    if (linkGroup && !showValueMap[tarKey]) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(linkGroup.axesInfo, function (srcAxisInfo, srcKey) {
        var srcValItem = showValueMap[srcKey]; // If srcValItem exist, source axis is triggered, so link to target axis.

        if (srcAxisInfo !== tarAxisInfo && srcValItem) {
          var val = srcValItem.value;
          linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, makeMapperParam(srcAxisInfo), makeMapperParam(tarAxisInfo))));
          linkTriggers[tarAxisInfo.key] = val;
        }
      });
    }
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(linkTriggers, function (val, tarKey) {
    processOnAxis(axesInfo[tarKey], val, updaters, true, outputPayload);
  });
  updateModelActually(showValueMap, axesInfo, outputPayload);
  dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
  dispatchHighDownActually(axesInfo, dispatchAction, api);
  return outputPayload;
}

function processOnAxis(axisInfo, newValue, updaters, noSnap, outputFinder) {
  var axis = axisInfo.axis;

  if (axis.scale.isBlank() || !axis.containData(newValue)) {
    return;
  }

  if (!axisInfo.involveSeries) {
    updaters.showPointer(axisInfo, newValue);
    return;
  } // Heavy calculation. So put it after axis.containData checking.


  var payloadInfo = buildPayloadsBySeries(newValue, axisInfo);
  var payloadBatch = payloadInfo.payloadBatch;
  var snapToValue = payloadInfo.snapToValue; // Fill content of event obj for echarts.connect.
  // By default use the first involved series data as a sample to connect.

  if (payloadBatch[0] && outputFinder.seriesIndex == null) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["extend"])(outputFinder, payloadBatch[0]);
  } // If no linkSource input, this process is for collecting link
  // target, where snap should not be accepted.


  if (!noSnap && axisInfo.snap) {
    if (axis.containData(snapToValue) && snapToValue != null) {
      newValue = snapToValue;
    }
  }

  updaters.showPointer(axisInfo, newValue, payloadBatch); // Tooltip should always be snapToValue, otherwise there will be
  // incorrect "axis value ~ series value" mapping displayed in tooltip.

  updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
}

function buildPayloadsBySeries(value, axisInfo) {
  var axis = axisInfo.axis;
  var dim = axis.dim;
  var snapToValue = value;
  var payloadBatch = [];
  var minDist = Number.MAX_VALUE;
  var minDiff = -1;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(axisInfo.seriesModels, function (series, idx) {
    var dataDim = series.getData().mapDimensionsAll(dim);
    var seriesNestestValue;
    var dataIndices;

    if (series.getAxisTooltipData) {
      var result = series.getAxisTooltipData(dataDim, value, axis);
      dataIndices = result.dataIndices;
      seriesNestestValue = result.nestestValue;
    } else {
      dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
      // when data length is not same.
      // false,
      axis.type === 'category' ? 0.5 : null);

      if (!dataIndices.length) {
        return;
      }

      seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
    }

    if (seriesNestestValue == null || !isFinite(seriesNestestValue)) {
      return;
    }

    var diff = value - seriesNestestValue;
    var dist = Math.abs(diff); // Consider category case

    if (dist <= minDist) {
      if (dist < minDist || diff >= 0 && minDiff < 0) {
        minDist = dist;
        minDiff = diff;
        snapToValue = seriesNestestValue;
        payloadBatch.length = 0;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(dataIndices, function (dataIndex) {
        payloadBatch.push({
          seriesIndex: series.seriesIndex,
          dataIndexInside: dataIndex,
          dataIndex: series.getData().getRawIndex(dataIndex)
        });
      });
    }
  });
  return {
    payloadBatch: payloadBatch,
    snapToValue: snapToValue
  };
}

function showPointer(showValueMap, axisInfo, value, payloadBatch) {
  showValueMap[axisInfo.key] = {
    value: value,
    payloadBatch: payloadBatch
  };
}

function showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
  var payloadBatch = payloadInfo.payloadBatch;
  var axis = axisInfo.axis;
  var axisModel = axis.model;
  var axisPointerModel = axisInfo.axisPointerModel; // If no data, do not create anything in dataByCoordSys,
  // whose length will be used to judge whether dispatch action.

  if (!axisInfo.triggerTooltip || !payloadBatch.length) {
    return;
  }

  var coordSysModel = axisInfo.coordSys.model;
  var coordSysKey = __WEBPACK_IMPORTED_MODULE_1__modelHelper_js__["b" /* makeKey */](coordSysModel);
  var coordSysItem = dataByCoordSys.map[coordSysKey];

  if (!coordSysItem) {
    coordSysItem = dataByCoordSys.map[coordSysKey] = {
      coordSysId: coordSysModel.id,
      coordSysIndex: coordSysModel.componentIndex,
      coordSysType: coordSysModel.type,
      coordSysMainType: coordSysModel.mainType,
      dataByAxis: []
    };
    dataByCoordSys.list.push(coordSysItem);
  }

  coordSysItem.dataByAxis.push({
    axisDim: axis.dim,
    axisIndex: axisModel.componentIndex,
    axisType: axisModel.type,
    axisId: axisModel.id,
    value: value,
    // Caustion: viewHelper.getValueLabel is actually on "view stage", which
    // depends that all models have been updated. So it should not be performed
    // here. Considering axisPointerModel used here is volatile, which is hard
    // to be retrieve in TooltipView, we prepare parameters here.
    valueLabelOpt: {
      precision: axisPointerModel.get(['label', 'precision']),
      formatter: axisPointerModel.get(['label', 'formatter'])
    },
    seriesDataIndices: payloadBatch.slice()
  });
}

function updateModelActually(showValueMap, axesInfo, outputPayload) {
  var outputAxesInfo = outputPayload.axesInfo = []; // Basic logic: If no 'show' required, 'hide' this axisPointer.

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(axesInfo, function (axisInfo, key) {
    var option = axisInfo.axisPointerModel.option;
    var valItem = showValueMap[key];

    if (valItem) {
      !axisInfo.useHandle && (option.status = 'show');
      option.value = valItem.value; // For label formatter param and highlight.

      option.seriesDataIndices = (valItem.payloadBatch || []).slice();
    } // When always show (e.g., handle used), remain
    // original value and status.
    else {
        // If hide, value still need to be set, consider
        // click legend to toggle axis blank.
        !axisInfo.useHandle && (option.status = 'hide');
      } // If status is 'hide', should be no info in payload.


    option.status === 'show' && outputAxesInfo.push({
      axisDim: axisInfo.axis.dim,
      axisIndex: axisInfo.axis.model.componentIndex,
      value: option.value
    });
  });
}

function dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
  // Basic logic: If no showTip required, hideTip will be dispatched.
  if (illegalPoint(point) || !dataByCoordSys.list.length) {
    dispatchAction({
      type: 'hideTip'
    });
    return;
  } // In most case only one axis (or event one series is used). It is
  // convinient to fetch payload.seriesIndex and payload.dataIndex
  // dirtectly. So put the first seriesIndex and dataIndex of the first
  // axis on the payload.


  var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
  dispatchAction({
    type: 'showTip',
    escapeConnect: true,
    x: point[0],
    y: point[1],
    tooltipOption: payload.tooltipOption,
    position: payload.position,
    dataIndexInside: sampleItem.dataIndexInside,
    dataIndex: sampleItem.dataIndex,
    seriesIndex: sampleItem.seriesIndex,
    dataByCoordSys: dataByCoordSys.list
  });
}

function dispatchHighDownActually(axesInfo, dispatchAction, api) {
  // FIXME
  // highlight status modification shoule be a stage of main process?
  // (Consider confilct (e.g., legend and axisPointer) and setOption)
  var zr = api.getZr();
  var highDownKey = 'axisPointerLastHighlights';
  var lastHighlights = inner(zr)[highDownKey] || {};
  var newHighlights = inner(zr)[highDownKey] = {}; // Update highlight/downplay status according to axisPointer model.
  // Build hash map and remove duplicate incidentally.

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(axesInfo, function (axisInfo, key) {
    var option = axisInfo.axisPointerModel.option;
    option.status === 'show' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(option.seriesDataIndices, function (batchItem) {
      var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
      newHighlights[key] = batchItem;
    });
  }); // Diff.

  var toHighlight = [];
  var toDownplay = [];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(lastHighlights, function (batchItem, key) {
    !newHighlights[key] && toDownplay.push(batchItem);
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(newHighlights, function (batchItem, key) {
    !lastHighlights[key] && toHighlight.push(batchItem);
  });
  toDownplay.length && api.dispatchAction({
    type: 'downplay',
    escapeConnect: true,
    // Not blur others when highlight in axisPointer.
    notBlur: true,
    batch: toDownplay
  });
  toHighlight.length && api.dispatchAction({
    type: 'highlight',
    escapeConnect: true,
    // Not blur others when highlight in axisPointer.
    notBlur: true,
    batch: toHighlight
  });
}

function findInputAxisInfo(inputAxesInfo, axisInfo) {
  for (var i = 0; i < (inputAxesInfo || []).length; i++) {
    var inputAxisInfo = inputAxesInfo[i];

    if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) {
      return inputAxisInfo;
    }
  }
}

function makeMapperParam(axisInfo) {
  var axisModel = axisInfo.axis.model;
  var item = {};
  var dim = item.axisDim = axisInfo.axis.dim;
  item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
  item.axisName = item[dim + 'AxisName'] = axisModel.name;
  item.axisId = item[dim + 'AxisId'] = axisModel.id;
  return item;
}

function illegalPoint(point) {
  return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
}

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__visual_visualSolution_js__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_Model_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_Component_js__ = __webpack_require__(21);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var DEFAULT_OUT_OF_BRUSH_COLOR = '#ddd';

var BrushModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(BrushModel, _super);

  function BrushModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = BrushModel.type;
    /**
     * @readOnly
     */

    _this.areas = [];
    /**
     * Current brush painting area settings.
     * @readOnly
     */

    _this.brushOption = {};
    return _this;
  }

  BrushModel.prototype.optionUpdated = function (newOption, isInit) {
    var thisOption = this.option;
    !isInit && __WEBPACK_IMPORTED_MODULE_2__visual_visualSolution_js__["b" /* replaceVisualOption */](thisOption, newOption, ['inBrush', 'outOfBrush']);
    var inBrush = thisOption.inBrush = thisOption.inBrush || {}; // Always give default visual, consider setOption at the second time.

    thisOption.outOfBrush = thisOption.outOfBrush || {
      color: DEFAULT_OUT_OF_BRUSH_COLOR
    };

    if (!inBrush.hasOwnProperty('liftZ')) {
      // Bigger than the highlight z lift, otherwise it will
      // be effected by the highlight z when brush.
      inBrush.liftZ = 5;
    }
  };
  /**
   * If `areas` is null/undefined, range state remain.
   */


  BrushModel.prototype.setAreas = function (areas) {
    if (true) {
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"](__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](areas));
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](areas, function (area) {
        __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"](area.brushType, 'Illegal areas');
      });
    } // If areas is null/undefined, range state remain.
    // This helps user to dispatchAction({type: 'brush'}) with no areas
    // set but just want to get the current brush select info from a `brush` event.


    if (!areas) {
      return;
    }

    this.areas = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"](areas, function (area) {
      return generateBrushOption(this.option, area);
    }, this);
  };
  /**
   * Set the current painting brush option.
   */


  BrushModel.prototype.setBrushOption = function (brushOption) {
    this.brushOption = generateBrushOption(this.option, brushOption);
    this.brushType = this.brushOption.brushType;
  };

  BrushModel.type = 'brush';
  BrushModel.dependencies = ['geo', 'grid', 'xAxis', 'yAxis', 'parallel', 'series'];
  BrushModel.defaultOption = {
    seriesIndex: 'all',
    brushType: 'rect',
    brushMode: 'single',
    transformable: true,
    brushStyle: {
      borderWidth: 1,
      color: 'rgba(210,219,238,0.3)',
      borderColor: '#D2DBEE'
    },
    throttleType: 'fixRate',
    throttleDelay: 0,
    removeOnClick: true,
    z: 10000
  };
  return BrushModel;
}(__WEBPACK_IMPORTED_MODULE_4__model_Component_js__["a" /* default */]);

function generateBrushOption(option, brushOption) {
  return __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"]({
    brushType: option.brushType,
    brushMode: option.brushMode,
    transformable: option.transformable,
    brushStyle: new __WEBPACK_IMPORTED_MODULE_3__model_Model_js__["a" /* default */](option.brushStyle).getItemStyle(),
    removeOnClick: option.removeOnClick,
    z: option.z
  }, brushOption, true);
}

/* harmony default export */ __webpack_exports__["a"] = (BrushModel);

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_BrushController_js__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__visualEncoding_js__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_Component_js__ = __webpack_require__(30);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






var BrushView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(BrushView, _super);

  function BrushView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = BrushView.type;
    return _this;
  }

  BrushView.prototype.init = function (ecModel, api) {
    this.ecModel = ecModel;
    this.api = api;
    this.model;
    (this._brushController = new __WEBPACK_IMPORTED_MODULE_2__helper_BrushController_js__["a" /* default */](api.getZr())).on('brush', __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"](this._onBrush, this)).mount();
  };

  BrushView.prototype.render = function (brushModel, ecModel, api, payload) {
    this.model = brushModel;

    this._updateController(brushModel, ecModel, api, payload);
  };

  BrushView.prototype.updateTransform = function (brushModel, ecModel, api, payload) {
    // PENDING: `updateTransform` is a little tricky, whose layout need
    // to be calculate mandatorily and other stages will not be performed.
    // Take care the correctness of the logic. See #11754 .
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__visualEncoding_js__["b" /* layoutCovers */])(ecModel);

    this._updateController(brushModel, ecModel, api, payload);
  };

  BrushView.prototype.updateVisual = function (brushModel, ecModel, api, payload) {
    this.updateTransform(brushModel, ecModel, api, payload);
  };

  BrushView.prototype.updateView = function (brushModel, ecModel, api, payload) {
    this._updateController(brushModel, ecModel, api, payload);
  };

  BrushView.prototype._updateController = function (brushModel, ecModel, api, payload) {
    // Do not update controller when drawing.
    (!payload || payload.$from !== brushModel.id) && this._brushController.setPanels(brushModel.brushTargetManager.makePanelOpts(api)).enableBrush(brushModel.brushOption).updateCovers(brushModel.areas.slice());
  }; // updateLayout: updateController,
  // updateVisual: updateController,


  BrushView.prototype.dispose = function () {
    this._brushController.dispose();
  };

  BrushView.prototype._onBrush = function (eventParam) {
    var modelId = this.model.id;
    var areas = this.model.brushTargetManager.setOutputRanges(eventParam.areas, this.ecModel); // Action is not dispatched on drag end, because the drag end
    // emits the same params with the last drag move event, and
    // may have some delay when using touch pad, which makes
    // animation not smooth (when using debounce).

    (!eventParam.isEnd || eventParam.removeOnClick) && this.api.dispatchAction({
      type: 'brush',
      brushId: modelId,
      areas: __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"](areas),
      $from: modelId
    });
    eventParam.isEnd && this.api.dispatchAction({
      type: 'brushEnd',
      brushId: modelId,
      areas: __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"](areas),
      $from: modelId
    });
  };

  BrushView.type = 'brush';
  return BrushView;
}(__WEBPACK_IMPORTED_MODULE_4__view_Component_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (BrushView);

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__preprocessor_js__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BrushView_js__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BrushModel_js__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__visualEncoding_js__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toolbox_feature_Brush_js__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toolbox_featureManager_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



 // TODO




function install(registers) {
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_1__BrushView_js__["a" /* default */]);
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_2__BrushModel_js__["a" /* default */]);
  registers.registerPreprocessor(__WEBPACK_IMPORTED_MODULE_0__preprocessor_js__["a" /* default */]);
  registers.registerVisual(registers.PRIORITY.VISUAL.BRUSH, __WEBPACK_IMPORTED_MODULE_3__visualEncoding_js__["a" /* default */]);
  registers.registerAction({
    type: 'brush',
    event: 'brush',
    update: 'updateVisual'
  }, function (payload, ecModel) {
    ecModel.eachComponent({
      mainType: 'brush',
      query: payload
    }, function (brushModel) {
      brushModel.setAreas(payload.areas);
    });
  });
  /**
   * payload: {
   *      brushComponents: [
   *          {
   *              brushId,
   *              brushIndex,
   *              brushName,
   *              series: [
   *                  {
   *                      seriesId,
   *                      seriesIndex,
   *                      seriesName,
   *                      rawIndices: [21, 34, ...]
   *                  },
   *                  ...
   *              ]
   *          },
   *          ...
   *      ]
   * }
   */

  registers.registerAction({
    type: 'brushSelect',
    event: 'brushSelected',
    update: 'none'
  }, __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["noop"]);
  registers.registerAction({
    type: 'brushEnd',
    event: 'brushEnd',
    update: 'none'
  }, __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["noop"]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__toolbox_featureManager_js__["a" /* registerFeature */])('brush', __WEBPACK_IMPORTED_MODULE_4__toolbox_feature_Brush_js__["a" /* default */]);
}

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = brushPreprocessor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


var DEFAULT_TOOLBOX_BTNS = ['rect', 'polygon', 'keep', 'clear'];
function brushPreprocessor(option, isNew) {
  var brushComponents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_model_js__["d" /* normalizeToArray */])(option ? option.brush : []);

  if (!brushComponents.length) {
    return;
  }

  var brushComponentSpecifiedBtns = [];
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](brushComponents, function (brushOpt) {
    var tbs = brushOpt.hasOwnProperty('toolbox') ? brushOpt.toolbox : [];

    if (tbs instanceof Array) {
      brushComponentSpecifiedBtns = brushComponentSpecifiedBtns.concat(tbs);
    }
  });
  var toolbox = option && option.toolbox;

  if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](toolbox)) {
    toolbox = toolbox[0];
  }

  if (!toolbox) {
    toolbox = {
      feature: {}
    };
    option.toolbox = [toolbox];
  }

  var toolboxFeature = toolbox.feature || (toolbox.feature = {});
  var toolboxBrush = toolboxFeature.brush || (toolboxFeature.brush = {});
  var brushTypes = toolboxBrush.type || (toolboxBrush.type = []);
  brushTypes.push.apply(brushTypes, brushComponentSpecifiedBtns);
  removeDuplicate(brushTypes);

  if (isNew && !brushTypes.length) {
    brushTypes.push.apply(brushTypes, DEFAULT_TOOLBOX_BTNS);
  }
}

function removeDuplicate(arr) {
  var map = {};
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](arr, function (val) {
    map[val] = 1;
  });
  arr.length = 0;
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](map, function (flag, val) {
    arr.push(val);
  });
}

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeBrushCommonSelectorForSeries;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_contain_polygon_js__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__ = __webpack_require__(4);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



function makeBrushCommonSelectorForSeries(area) {
  var brushType = area.brushType; // Do not use function binding or curry for performance.

  var selectors = {
    point: function (itemLayout) {
      return selector[brushType].point(itemLayout, selectors, area);
    },
    rect: function (itemLayout) {
      return selector[brushType].rect(itemLayout, selectors, area);
    }
  };
  return selectors;
}
var selector = {
  lineX: getLineSelectors(0),
  lineY: getLineSelectors(1),
  rect: {
    point: function (itemLayout, selectors, area) {
      return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]);
    },
    rect: function (itemLayout, selectors, area) {
      return itemLayout && area.boundingRect.intersect(itemLayout);
    }
  },
  polygon: {
    point: function (itemLayout, selectors, area) {
      return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]) && __WEBPACK_IMPORTED_MODULE_0_zrender_lib_contain_polygon_js__["a" /* contain */](area.range, itemLayout[0], itemLayout[1]);
    },
    rect: function (itemLayout, selectors, area) {
      var points = area.range;

      if (!itemLayout || points.length <= 1) {
        return false;
      }

      var x = itemLayout.x;
      var y = itemLayout.y;
      var width = itemLayout.width;
      var height = itemLayout.height;
      var p = points[0];

      if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_contain_polygon_js__["a" /* contain */](points, x, y) || __WEBPACK_IMPORTED_MODULE_0_zrender_lib_contain_polygon_js__["a" /* contain */](points, x + width, y) || __WEBPACK_IMPORTED_MODULE_0_zrender_lib_contain_polygon_js__["a" /* contain */](points, x, y + height) || __WEBPACK_IMPORTED_MODULE_0_zrender_lib_contain_polygon_js__["a" /* contain */](points, x + width, y + height) || __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_BoundingRect_js__["a" /* default */].create(itemLayout).contain(p[0], p[1]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["linePolygonIntersect"])(x, y, x + width, y, points) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["linePolygonIntersect"])(x, y, x, y + height, points) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["linePolygonIntersect"])(x + width, y, x + width, y + height, points) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["linePolygonIntersect"])(x, y + height, x + width, y + height, points)) {
        return true;
      }
    }
  }
};

function getLineSelectors(xyIndex) {
  var xy = ['x', 'y'];
  var wh = ['width', 'height'];
  return {
    point: function (itemLayout, selectors, area) {
      if (itemLayout) {
        var range = area.range;
        var p = itemLayout[xyIndex];
        return inLineRange(p, range);
      }
    },
    rect: function (itemLayout, selectors, area) {
      if (itemLayout) {
        var range = area.range;
        var layoutRange = [itemLayout[xy[xyIndex]], itemLayout[xy[xyIndex]] + itemLayout[wh[xyIndex]]];
        layoutRange[1] < layoutRange[0] && layoutRange.reverse();
        return inLineRange(layoutRange[0], range) || inLineRange(layoutRange[1], range) || inLineRange(range[0], layoutRange) || inLineRange(range[1], layoutRange);
      }
    }
  };
}

function inLineRange(p, range) {
  return range[0] <= p && p <= range[1];
}

/* unused harmony default export */ var _unused_webpack_default_export = (selector);

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_format_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_Component_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_locale_js__ = __webpack_require__(235);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/









var CalendarView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(CalendarView, _super);

  function CalendarView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = CalendarView.type;
    return _this;
  }

  CalendarView.prototype.render = function (calendarModel, ecModel, api) {
    var group = this.group;
    group.removeAll();
    var coordSys = calendarModel.coordinateSystem; // range info

    var rangeData = coordSys.getRangeInfo();
    var orient = coordSys.getOrient(); // locale

    var localeModel = ecModel.getLocaleModel();

    this._renderDayRect(calendarModel, rangeData, group); // _renderLines must be called prior to following function


    this._renderLines(calendarModel, rangeData, orient, group);

    this._renderYearText(calendarModel, rangeData, orient, group);

    this._renderMonthText(calendarModel, localeModel, orient, group);

    this._renderWeekText(calendarModel, localeModel, rangeData, orient, group);
  }; // render day rect


  CalendarView.prototype._renderDayRect = function (calendarModel, rangeData, group) {
    var coordSys = calendarModel.coordinateSystem;
    var itemRectStyleModel = calendarModel.getModel('itemStyle').getItemStyle();
    var sw = coordSys.getCellWidth();
    var sh = coordSys.getCellHeight();

    for (var i = rangeData.start.time; i <= rangeData.end.time; i = coordSys.getNextNDay(i, 1).time) {
      var point = coordSys.dataToRect([i], false).tl; // every rect

      var rect = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Rect"]({
        shape: {
          x: point[0],
          y: point[1],
          width: sw,
          height: sh
        },
        cursor: 'default',
        style: itemRectStyleModel
      });
      group.add(rect);
    }
  }; // render separate line


  CalendarView.prototype._renderLines = function (calendarModel, rangeData, orient, group) {
    var self = this;
    var coordSys = calendarModel.coordinateSystem;
    var lineStyleModel = calendarModel.getModel(['splitLine', 'lineStyle']).getLineStyle();
    var show = calendarModel.get(['splitLine', 'show']);
    var lineWidth = lineStyleModel.lineWidth;
    this._tlpoints = [];
    this._blpoints = [];
    this._firstDayOfMonth = [];
    this._firstDayPoints = [];
    var firstDay = rangeData.start;

    for (var i = 0; firstDay.time <= rangeData.end.time; i++) {
      addPoints(firstDay.formatedDate);

      if (i === 0) {
        firstDay = coordSys.getDateInfo(rangeData.start.y + '-' + rangeData.start.m);
      }

      var date = firstDay.date;
      date.setMonth(date.getMonth() + 1);
      firstDay = coordSys.getDateInfo(date);
    }

    addPoints(coordSys.getNextNDay(rangeData.end.time, 1).formatedDate);

    function addPoints(date) {
      self._firstDayOfMonth.push(coordSys.getDateInfo(date));

      self._firstDayPoints.push(coordSys.dataToRect([date], false).tl);

      var points = self._getLinePointsOfOneWeek(calendarModel, date, orient);

      self._tlpoints.push(points[0]);

      self._blpoints.push(points[points.length - 1]);

      show && self._drawSplitline(points, lineStyleModel, group);
    } // render top/left line


    show && this._drawSplitline(self._getEdgesPoints(self._tlpoints, lineWidth, orient), lineStyleModel, group); // render bottom/right line

    show && this._drawSplitline(self._getEdgesPoints(self._blpoints, lineWidth, orient), lineStyleModel, group);
  }; // get points at both ends


  CalendarView.prototype._getEdgesPoints = function (points, lineWidth, orient) {
    var rs = [points[0].slice(), points[points.length - 1].slice()];
    var idx = orient === 'horizontal' ? 0 : 1; // both ends of the line are extend half lineWidth

    rs[0][idx] = rs[0][idx] - lineWidth / 2;
    rs[1][idx] = rs[1][idx] + lineWidth / 2;
    return rs;
  }; // render split line


  CalendarView.prototype._drawSplitline = function (points, lineStyle, group) {
    var poyline = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Polyline"]({
      z2: 20,
      shape: {
        points: points
      },
      style: lineStyle
    });
    group.add(poyline);
  }; // render month line of one week points


  CalendarView.prototype._getLinePointsOfOneWeek = function (calendarModel, date, orient) {
    var coordSys = calendarModel.coordinateSystem;
    var parsedDate = coordSys.getDateInfo(date);
    var points = [];

    for (var i = 0; i < 7; i++) {
      var tmpD = coordSys.getNextNDay(parsedDate.time, i);
      var point = coordSys.dataToRect([tmpD.time], false);
      points[2 * tmpD.day] = point.tl;
      points[2 * tmpD.day + 1] = point[orient === 'horizontal' ? 'bl' : 'tr'];
    }

    return points;
  };

  CalendarView.prototype._formatterLabel = function (formatter, params) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"])(formatter) && formatter) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_format_js__["j" /* formatTplSimple */])(formatter, params);
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isFunction"])(formatter)) {
      return formatter(params);
    }

    return params.nameMap;
  };

  CalendarView.prototype._yearTextPositionControl = function (textEl, point, orient, position, margin) {
    var x = point[0];
    var y = point[1];
    var aligns = ['center', 'bottom'];

    if (position === 'bottom') {
      y += margin;
      aligns = ['center', 'top'];
    } else if (position === 'left') {
      x -= margin;
    } else if (position === 'right') {
      x += margin;
      aligns = ['center', 'top'];
    } else {
      // top
      y -= margin;
    }

    var rotate = 0;

    if (position === 'left' || position === 'right') {
      rotate = Math.PI / 2;
    }

    return {
      rotation: rotate,
      x: x,
      y: y,
      style: {
        align: aligns[0],
        verticalAlign: aligns[1]
      }
    };
  }; // render year


  CalendarView.prototype._renderYearText = function (calendarModel, rangeData, orient, group) {
    var yearLabel = calendarModel.getModel('yearLabel');

    if (!yearLabel.get('show')) {
      return;
    }

    var margin = yearLabel.get('margin');
    var pos = yearLabel.get('position');

    if (!pos) {
      pos = orient !== 'horizontal' ? 'top' : 'left';
    }

    var points = [this._tlpoints[this._tlpoints.length - 1], this._blpoints[0]];
    var xc = (points[0][0] + points[1][0]) / 2;
    var yc = (points[0][1] + points[1][1]) / 2;
    var idx = orient === 'horizontal' ? 0 : 1;
    var posPoints = {
      top: [xc, points[idx][1]],
      bottom: [xc, points[1 - idx][1]],
      left: [points[1 - idx][0], yc],
      right: [points[idx][0], yc]
    };
    var name = rangeData.start.y;

    if (+rangeData.end.y > +rangeData.start.y) {
      name = name + '-' + rangeData.end.y;
    }

    var formatter = yearLabel.get('formatter');
    var params = {
      start: rangeData.start.y,
      end: rangeData.end.y,
      nameMap: name
    };

    var content = this._formatterLabel(formatter, params);

    var yearText = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Text"]({
      z2: 30,
      style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__label_labelStyle_js__["d" /* createTextStyle */])(yearLabel, {
        text: content
      })
    });
    yearText.attr(this._yearTextPositionControl(yearText, posPoints[pos], orient, pos, margin));
    group.add(yearText);
  };

  CalendarView.prototype._monthTextPositionControl = function (point, isCenter, orient, position, margin) {
    var align = 'left';
    var vAlign = 'top';
    var x = point[0];
    var y = point[1];

    if (orient === 'horizontal') {
      y = y + margin;

      if (isCenter) {
        align = 'center';
      }

      if (position === 'start') {
        vAlign = 'bottom';
      }
    } else {
      x = x + margin;

      if (isCenter) {
        vAlign = 'middle';
      }

      if (position === 'start') {
        align = 'right';
      }
    }

    return {
      x: x,
      y: y,
      align: align,
      verticalAlign: vAlign
    };
  }; // render month and year text


  CalendarView.prototype._renderMonthText = function (calendarModel, localeModel, orient, group) {
    var monthLabel = calendarModel.getModel('monthLabel');

    if (!monthLabel.get('show')) {
      return;
    }

    var nameMap = monthLabel.get('nameMap');
    var margin = monthLabel.get('margin');
    var pos = monthLabel.get('position');
    var align = monthLabel.get('align');
    var termPoints = [this._tlpoints, this._blpoints];

    if (!nameMap || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"])(nameMap)) {
      if (nameMap) {
        // case-sensitive
        localeModel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__core_locale_js__["a" /* getLocaleModel */])(nameMap) || localeModel;
      } // PENDING
      // for ZH locale, original form is `一月` but current form is `1月`


      nameMap = localeModel.get(['time', 'monthAbbr']) || [];
    }

    var idx = pos === 'start' ? 0 : 1;
    var axis = orient === 'horizontal' ? 0 : 1;
    margin = pos === 'start' ? -margin : margin;
    var isCenter = align === 'center';

    for (var i = 0; i < termPoints[idx].length - 1; i++) {
      var tmp = termPoints[idx][i].slice();
      var firstDay = this._firstDayOfMonth[i];

      if (isCenter) {
        var firstDayPoints = this._firstDayPoints[i];
        tmp[axis] = (firstDayPoints[axis] + termPoints[0][i + 1][axis]) / 2;
      }

      var formatter = monthLabel.get('formatter');
      var name_1 = nameMap[+firstDay.m - 1];
      var params = {
        yyyy: firstDay.y,
        yy: (firstDay.y + '').slice(2),
        MM: firstDay.m,
        M: +firstDay.m,
        nameMap: name_1
      };

      var content = this._formatterLabel(formatter, params);

      var monthText = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Text"]({
        z2: 30,
        style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__label_labelStyle_js__["d" /* createTextStyle */])(monthLabel, {
          text: content
        }), this._monthTextPositionControl(tmp, isCenter, orient, pos, margin))
      });
      group.add(monthText);
    }
  };

  CalendarView.prototype._weekTextPositionControl = function (point, orient, position, margin, cellSize) {
    var align = 'center';
    var vAlign = 'middle';
    var x = point[0];
    var y = point[1];
    var isStart = position === 'start';

    if (orient === 'horizontal') {
      x = x + margin + (isStart ? 1 : -1) * cellSize[0] / 2;
      align = isStart ? 'right' : 'left';
    } else {
      y = y + margin + (isStart ? 1 : -1) * cellSize[1] / 2;
      vAlign = isStart ? 'bottom' : 'top';
    }

    return {
      x: x,
      y: y,
      align: align,
      verticalAlign: vAlign
    };
  }; // render weeks


  CalendarView.prototype._renderWeekText = function (calendarModel, localeModel, rangeData, orient, group) {
    var dayLabel = calendarModel.getModel('dayLabel');

    if (!dayLabel.get('show')) {
      return;
    }

    var coordSys = calendarModel.coordinateSystem;
    var pos = dayLabel.get('position');
    var nameMap = dayLabel.get('nameMap');
    var margin = dayLabel.get('margin');
    var firstDayOfWeek = coordSys.getFirstDayOfWeek();

    if (!nameMap || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"])(nameMap)) {
      if (nameMap) {
        // case-sensitive
        localeModel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__core_locale_js__["a" /* getLocaleModel */])(nameMap) || localeModel;
      } // Use the first letter of `dayOfWeekAbbr` if `dayOfWeekShort` doesn't exist in the locale file


      var dayOfWeekShort = localeModel.get(['time', 'dayOfWeekShort']);
      nameMap = dayOfWeekShort || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"])(localeModel.get(['time', 'dayOfWeekAbbr']), function (val) {
        return val[0];
      });
    }

    var start = coordSys.getNextNDay(rangeData.end.time, 7 - rangeData.lweek).time;
    var cellSize = [coordSys.getCellWidth(), coordSys.getCellHeight()];
    margin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_number_js__["a" /* parsePercent */])(margin, Math.min(cellSize[1], cellSize[0]));

    if (pos === 'start') {
      start = coordSys.getNextNDay(rangeData.start.time, -(7 + rangeData.fweek)).time;
      margin = -margin;
    }

    for (var i = 0; i < 7; i++) {
      var tmpD = coordSys.getNextNDay(start, i);
      var point = coordSys.dataToRect([tmpD.time], false).center;
      var day = i;
      day = Math.abs((i + firstDayOfWeek) % 7);
      var weekText = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Text"]({
        z2: 30,
        style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__label_labelStyle_js__["d" /* createTextStyle */])(dayLabel, {
          text: nameMap[day]
        }), this._weekTextPositionControl(point, orient, pos, margin, cellSize))
      });
      group.add(weekText);
    }
  };

  CalendarView.type = 'calendar';
  return CalendarView;
}(__WEBPACK_IMPORTED_MODULE_6__view_Component_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CalendarView);

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coord_calendar_CalendarModel_js__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CalendarView_js__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__coord_calendar_Calendar_js__ = __webpack_require__(1287);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



function install(registers) {
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_0__coord_calendar_CalendarModel_js__["a" /* default */]);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_1__CalendarView_js__["a" /* default */]);
  registers.registerCoordinateSystem('calendar', __WEBPACK_IMPORTED_MODULE_2__coord_calendar_Calendar_js__["a" /* default */]);
}

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_sliderMove_js__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__coord_axisHelper_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__coord_scaleRawExtentInfo_js__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_js__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







var each = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"];
var asc = __WEBPACK_IMPORTED_MODULE_1__util_number_js__["j" /* asc */];
/**
 * Operate single axis.
 * One axis can only operated by one axis operator.
 * Different dataZoomModels may be defined to operate the same axis.
 * (i.e. 'inside' data zoom and 'slider' data zoom components)
 * So dataZoomModels share one axisProxy in that case.
 */

var AxisProxy =
/** @class */
function () {
  function AxisProxy(dimName, axisIndex, dataZoomModel, ecModel) {
    this._dimName = dimName;
    this._axisIndex = axisIndex;
    this.ecModel = ecModel;
    this._dataZoomModel = dataZoomModel; // /**
    //  * @readOnly
    //  * @private
    //  */
    // this.hasSeriesStacked;
  }
  /**
   * Whether the axisProxy is hosted by dataZoomModel.
   */


  AxisProxy.prototype.hostedBy = function (dataZoomModel) {
    return this._dataZoomModel === dataZoomModel;
  };
  /**
   * @return Value can only be NaN or finite value.
   */


  AxisProxy.prototype.getDataValueWindow = function () {
    return this._valueWindow.slice();
  };
  /**
   * @return {Array.<number>}
   */


  AxisProxy.prototype.getDataPercentWindow = function () {
    return this._percentWindow.slice();
  };

  AxisProxy.prototype.getTargetSeriesModels = function () {
    var seriesModels = [];
    this.ecModel.eachSeries(function (seriesModel) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helper_js__["c" /* isCoordSupported */])(seriesModel)) {
        var axisMainType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helper_js__["b" /* getAxisMainType */])(this._dimName);
        var axisModel = seriesModel.getReferringComponents(axisMainType, __WEBPACK_IMPORTED_MODULE_6__util_model_js__["i" /* SINGLE_REFERRING */]).models[0];

        if (axisModel && this._axisIndex === axisModel.componentIndex) {
          seriesModels.push(seriesModel);
        }
      }
    }, this);
    return seriesModels;
  };

  AxisProxy.prototype.getAxisModel = function () {
    return this.ecModel.getComponent(this._dimName + 'Axis', this._axisIndex);
  };

  AxisProxy.prototype.getMinMaxSpan = function () {
    return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["clone"](this._minMaxSpan);
  };
  /**
   * Only calculate by given range and this._dataExtent, do not change anything.
   */


  AxisProxy.prototype.calculateDataWindow = function (opt) {
    var dataExtent = this._dataExtent;
    var axisModel = this.getAxisModel();
    var scale = axisModel.axis.scale;

    var rangePropMode = this._dataZoomModel.getRangePropMode();

    var percentExtent = [0, 100];
    var percentWindow = [];
    var valueWindow = [];
    var hasPropModeValue;
    each(['start', 'end'], function (prop, idx) {
      var boundPercent = opt[prop];
      var boundValue = opt[prop + 'Value']; // Notice: dataZoom is based either on `percentProp` ('start', 'end') or
      // on `valueProp` ('startValue', 'endValue'). (They are based on the data extent
      // but not min/max of axis, which will be calculated by data window then).
      // The former one is suitable for cases that a dataZoom component controls multiple
      // axes with different unit or extent, and the latter one is suitable for accurate
      // zoom by pixel (e.g., in dataZoomSelect).
      // we use `getRangePropMode()` to mark which prop is used. `rangePropMode` is updated
      // only when setOption or dispatchAction, otherwise it remains its original value.
      // (Why not only record `percentProp` and always map to `valueProp`? Because
      // the map `valueProp` -> `percentProp` -> `valueProp` probably not the original
      // `valueProp`. consider two axes constrolled by one dataZoom. They have different
      // data extent. All of values that are overflow the `dataExtent` will be calculated
      // to percent '100%').

      if (rangePropMode[idx] === 'percent') {
        boundPercent == null && (boundPercent = percentExtent[idx]); // Use scale.parse to math round for category or time axis.

        boundValue = scale.parse(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["h" /* linearMap */](boundPercent, percentExtent, dataExtent));
      } else {
        hasPropModeValue = true;
        boundValue = boundValue == null ? dataExtent[idx] : scale.parse(boundValue); // Calculating `percent` from `value` may be not accurate, because
        // This calculation can not be inversed, because all of values that
        // are overflow the `dataExtent` will be calculated to percent '100%'

        boundPercent = __WEBPACK_IMPORTED_MODULE_1__util_number_js__["h" /* linearMap */](boundValue, dataExtent, percentExtent);
      } // valueWindow[idx] = round(boundValue);
      // percentWindow[idx] = round(boundPercent);


      valueWindow[idx] = boundValue;
      percentWindow[idx] = boundPercent;
    });
    asc(valueWindow);
    asc(percentWindow); // The windows from user calling of `dispatchAction` might be out of the extent,
    // or do not obey the `min/maxSpan`, `min/maxValueSpan`. But we dont restrict window
    // by `zoomLock` here, because we see `zoomLock` just as a interaction constraint,
    // where API is able to initialize/modify the window size even though `zoomLock`
    // specified.

    var spans = this._minMaxSpan;
    hasPropModeValue ? restrictSet(valueWindow, percentWindow, dataExtent, percentExtent, false) : restrictSet(percentWindow, valueWindow, percentExtent, dataExtent, true);

    function restrictSet(fromWindow, toWindow, fromExtent, toExtent, toValue) {
      var suffix = toValue ? 'Span' : 'ValueSpan';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_sliderMove_js__["a" /* default */])(0, fromWindow, fromExtent, 'all', spans['min' + suffix], spans['max' + suffix]);

      for (var i = 0; i < 2; i++) {
        toWindow[i] = __WEBPACK_IMPORTED_MODULE_1__util_number_js__["h" /* linearMap */](fromWindow[i], fromExtent, toExtent, true);
        toValue && (toWindow[i] = scale.parse(toWindow[i]));
      }
    }

    return {
      valueWindow: valueWindow,
      percentWindow: percentWindow
    };
  };
  /**
   * Notice: reset should not be called before series.restoreData() called,
   * so it is recommanded to be called in "process stage" but not "model init
   * stage".
   */


  AxisProxy.prototype.reset = function (dataZoomModel) {
    if (dataZoomModel !== this._dataZoomModel) {
      return;
    }

    var targetSeries = this.getTargetSeriesModels(); // Culculate data window and data extent, and record them.

    this._dataExtent = calculateDataExtent(this, this._dimName, targetSeries); // `calculateDataWindow` uses min/maxSpan.

    this._updateMinMaxSpan();

    var dataWindow = this.calculateDataWindow(dataZoomModel.settledOption);
    this._valueWindow = dataWindow.valueWindow;
    this._percentWindow = dataWindow.percentWindow; // Update axis setting then.

    this._setAxisModel();
  };

  AxisProxy.prototype.filterData = function (dataZoomModel, api) {
    if (dataZoomModel !== this._dataZoomModel) {
      return;
    }

    var axisDim = this._dimName;
    var seriesModels = this.getTargetSeriesModels();
    var filterMode = dataZoomModel.get('filterMode');
    var valueWindow = this._valueWindow;

    if (filterMode === 'none') {
      return;
    } // FIXME
    // Toolbox may has dataZoom injected. And if there are stacked bar chart
    // with NaN data, NaN will be filtered and stack will be wrong.
    // So we need to force the mode to be set empty.
    // In fect, it is not a big deal that do not support filterMode-'filter'
    // when using toolbox#dataZoom, utill tooltip#dataZoom support "single axis
    // selection" some day, which might need "adapt to data extent on the
    // otherAxis", which is disabled by filterMode-'empty'.
    // But currently, stack has been fixed to based on value but not index,
    // so this is not an issue any more.
    // let otherAxisModel = this.getOtherAxisModel();
    // if (dataZoomModel.get('$fromToolbox')
    //     && otherAxisModel
    //     && otherAxisModel.hasSeriesStacked
    // ) {
    //     filterMode = 'empty';
    // }
    // TODO
    // filterMode 'weakFilter' and 'empty' is not optimized for huge data yet.


    each(seriesModels, function (seriesModel) {
      var seriesData = seriesModel.getData();
      var dataDims = seriesData.mapDimensionsAll(axisDim);

      if (!dataDims.length) {
        return;
      }

      if (filterMode === 'weakFilter') {
        var store_1 = seriesData.getStore();
        var dataDimIndices_1 = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"](dataDims, function (dim) {
          return seriesData.getDimensionIndex(dim);
        }, seriesData);
        seriesData.filterSelf(function (dataIndex) {
          var leftOut;
          var rightOut;
          var hasValue;

          for (var i = 0; i < dataDims.length; i++) {
            var value = store_1.get(dataDimIndices_1[i], dataIndex);
            var thisHasValue = !isNaN(value);
            var thisLeftOut = value < valueWindow[0];
            var thisRightOut = value > valueWindow[1];

            if (thisHasValue && !thisLeftOut && !thisRightOut) {
              return true;
            }

            thisHasValue && (hasValue = true);
            thisLeftOut && (leftOut = true);
            thisRightOut && (rightOut = true);
          } // If both left out and right out, do not filter.


          return hasValue && leftOut && rightOut;
        });
      } else {
        each(dataDims, function (dim) {
          if (filterMode === 'empty') {
            seriesModel.setData(seriesData = seriesData.map(dim, function (value) {
              return !isInWindow(value) ? NaN : value;
            }));
          } else {
            var range = {};
            range[dim] = valueWindow; // console.time('select');

            seriesData.selectRange(range); // console.timeEnd('select');
          }
        });
      }

      each(dataDims, function (dim) {
        seriesData.setApproximateExtent(valueWindow, dim);
      });
    });

    function isInWindow(value) {
      return value >= valueWindow[0] && value <= valueWindow[1];
    }
  };

  AxisProxy.prototype._updateMinMaxSpan = function () {
    var minMaxSpan = this._minMaxSpan = {};
    var dataZoomModel = this._dataZoomModel;
    var dataExtent = this._dataExtent;
    each(['min', 'max'], function (minMax) {
      var percentSpan = dataZoomModel.get(minMax + 'Span');
      var valueSpan = dataZoomModel.get(minMax + 'ValueSpan');
      valueSpan != null && (valueSpan = this.getAxisModel().axis.scale.parse(valueSpan)); // minValueSpan and maxValueSpan has higher priority than minSpan and maxSpan

      if (valueSpan != null) {
        percentSpan = __WEBPACK_IMPORTED_MODULE_1__util_number_js__["h" /* linearMap */](dataExtent[0] + valueSpan, dataExtent, [0, 100], true);
      } else if (percentSpan != null) {
        valueSpan = __WEBPACK_IMPORTED_MODULE_1__util_number_js__["h" /* linearMap */](percentSpan, [0, 100], dataExtent, true) - dataExtent[0];
      }

      minMaxSpan[minMax + 'Span'] = percentSpan;
      minMaxSpan[minMax + 'ValueSpan'] = valueSpan;
    }, this);
  };

  AxisProxy.prototype._setAxisModel = function () {
    var axisModel = this.getAxisModel();
    var percentWindow = this._percentWindow;
    var valueWindow = this._valueWindow;

    if (!percentWindow) {
      return;
    } // [0, 500]: arbitrary value, guess axis extent.


    var precision = __WEBPACK_IMPORTED_MODULE_1__util_number_js__["k" /* getPixelPrecision */](valueWindow, [0, 500]);
    precision = Math.min(precision, 20); // For value axis, if min/max/scale are not set, we just use the extent obtained
    // by series data, which may be a little different from the extent calculated by
    // `axisHelper.getScaleExtent`. But the different just affects the experience a
    // little when zooming. So it will not be fixed until some users require it strongly.

    var rawExtentInfo = axisModel.axis.scale.rawExtentInfo;

    if (percentWindow[0] !== 0) {
      rawExtentInfo.setDeterminedMinMax('min', +valueWindow[0].toFixed(precision));
    }

    if (percentWindow[1] !== 100) {
      rawExtentInfo.setDeterminedMinMax('max', +valueWindow[1].toFixed(precision));
    }

    rawExtentInfo.freeze();
  };

  return AxisProxy;
}();

function calculateDataExtent(axisProxy, axisDim, seriesModels) {
  var dataExtent = [Infinity, -Infinity];
  each(seriesModels, function (seriesModel) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__coord_axisHelper_js__["a" /* unionAxisExtentFromData */])(dataExtent, seriesModel.getData(), axisDim);
  }); // It is important to get "consistent" extent when more then one axes is
  // controlled by a `dataZoom`, otherwise those axes will not be synchronized
  // when zooming. But it is difficult to know what is "consistent", considering
  // axes have different type or even different meanings (For example, two
  // time axes are used to compare data of the same date in different years).
  // So basically dataZoom just obtains extent by series.data (in category axis
  // extent can be obtained from axis.data).
  // Nevertheless, user can set min/max/scale on axes to make extent of axes
  // consistent.

  var axisModel = axisProxy.getAxisModel();
  var rawExtentResult = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__coord_scaleRawExtentInfo_js__["a" /* ensureScaleRawExtentInfo */])(axisModel.axis.scale, axisModel, dataExtent).calculate();
  return [rawExtentResult.min, rawExtentResult.max];
}

/* harmony default export */ __webpack_exports__["a"] = (AxisProxy);

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DataZoomModel_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_component_js__ = __webpack_require__(49);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var InsideZoomModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(InsideZoomModel, _super);

  function InsideZoomModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = InsideZoomModel.type;
    return _this;
  }

  InsideZoomModel.type = 'dataZoom.inside';
  InsideZoomModel.defaultOption = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_component_js__["d" /* inheritDefaultOption */])(__WEBPACK_IMPORTED_MODULE_1__DataZoomModel_js__["a" /* default */].defaultOption, {
    disabled: false,
    zoomLock: false,
    zoomOnMouseWheel: true,
    moveOnMouseMove: true,
    moveOnMouseWheel: false,
    preventDefaultMouseMove: true
  });
  return InsideZoomModel;
}(__WEBPACK_IMPORTED_MODULE_1__DataZoomModel_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (InsideZoomModel);

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DataZoomView_js__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_sliderMove_js__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__roams_js__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






var InsideZoomView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(InsideZoomView, _super);

  function InsideZoomView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = 'dataZoom.inside';
    return _this;
  }

  InsideZoomView.prototype.render = function (dataZoomModel, ecModel, api) {
    _super.prototype.render.apply(this, arguments);

    if (dataZoomModel.noTarget()) {
      this._clear();

      return;
    } // Hence the `throttle` util ensures to preserve command order,
    // here simply updating range all the time will not cause missing
    // any of the the roam change.


    this.range = dataZoomModel.getPercentRange(); // Reset controllers.

    __WEBPACK_IMPORTED_MODULE_3__roams_js__["b" /* setViewInfoToCoordSysRecord */](api, dataZoomModel, {
      pan: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["bind"])(getRangeHandlers.pan, this),
      zoom: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["bind"])(getRangeHandlers.zoom, this),
      scrollMove: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["bind"])(getRangeHandlers.scrollMove, this)
    });
  };

  InsideZoomView.prototype.dispose = function () {
    this._clear();

    _super.prototype.dispose.apply(this, arguments);
  };

  InsideZoomView.prototype._clear = function () {
    __WEBPACK_IMPORTED_MODULE_3__roams_js__["c" /* disposeCoordSysRecordIfNeeded */](this.api, this.dataZoomModel);
    this.range = null;
  };

  InsideZoomView.type = 'dataZoom.inside';
  return InsideZoomView;
}(__WEBPACK_IMPORTED_MODULE_1__DataZoomView_js__["a" /* default */]);

var getRangeHandlers = {
  zoom: function (coordSysInfo, coordSysMainType, controller, e) {
    var lastRange = this.range;
    var range = lastRange.slice(); // Calculate transform by the first axis.

    var axisModel = coordSysInfo.axisModels[0];

    if (!axisModel) {
      return;
    }

    var directionInfo = getDirectionInfo[coordSysMainType](null, [e.originX, e.originY], axisModel, controller, coordSysInfo);
    var percentPoint = (directionInfo.signal > 0 ? directionInfo.pixelStart + directionInfo.pixelLength - directionInfo.pixel : directionInfo.pixel - directionInfo.pixelStart) / directionInfo.pixelLength * (range[1] - range[0]) + range[0];
    var scale = Math.max(1 / e.scale, 0);
    range[0] = (range[0] - percentPoint) * scale + percentPoint;
    range[1] = (range[1] - percentPoint) * scale + percentPoint; // Restrict range.

    var minMaxSpan = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_sliderMove_js__["a" /* default */])(0, range, [0, 100], 0, minMaxSpan.minSpan, minMaxSpan.maxSpan);
    this.range = range;

    if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) {
      return range;
    }
  },
  pan: makeMover(function (range, axisModel, coordSysInfo, coordSysMainType, controller, e) {
    var directionInfo = getDirectionInfo[coordSysMainType]([e.oldX, e.oldY], [e.newX, e.newY], axisModel, controller, coordSysInfo);
    return directionInfo.signal * (range[1] - range[0]) * directionInfo.pixel / directionInfo.pixelLength;
  }),
  scrollMove: makeMover(function (range, axisModel, coordSysInfo, coordSysMainType, controller, e) {
    var directionInfo = getDirectionInfo[coordSysMainType]([0, 0], [e.scrollDelta, e.scrollDelta], axisModel, controller, coordSysInfo);
    return directionInfo.signal * (range[1] - range[0]) * e.scrollDelta;
  })
};

function makeMover(getPercentDelta) {
  return function (coordSysInfo, coordSysMainType, controller, e) {
    var lastRange = this.range;
    var range = lastRange.slice(); // Calculate transform by the first axis.

    var axisModel = coordSysInfo.axisModels[0];

    if (!axisModel) {
      return;
    }

    var percentDelta = getPercentDelta(range, axisModel, coordSysInfo, coordSysMainType, controller, e);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_sliderMove_js__["a" /* default */])(percentDelta, range, [0, 100], 'all');
    this.range = range;

    if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) {
      return range;
    }
  };
}

var getDirectionInfo = {
  grid: function (oldPoint, newPoint, axisModel, controller, coordSysInfo) {
    var axis = axisModel.axis;
    var ret = {};
    var rect = coordSysInfo.model.coordinateSystem.getRect();
    oldPoint = oldPoint || [0, 0];

    if (axis.dim === 'x') {
      ret.pixel = newPoint[0] - oldPoint[0];
      ret.pixelLength = rect.width;
      ret.pixelStart = rect.x;
      ret.signal = axis.inverse ? 1 : -1;
    } else {
      // axis.dim === 'y'
      ret.pixel = newPoint[1] - oldPoint[1];
      ret.pixelLength = rect.height;
      ret.pixelStart = rect.y;
      ret.signal = axis.inverse ? -1 : 1;
    }

    return ret;
  },
  polar: function (oldPoint, newPoint, axisModel, controller, coordSysInfo) {
    var axis = axisModel.axis;
    var ret = {};
    var polar = coordSysInfo.model.coordinateSystem;
    var radiusExtent = polar.getRadiusAxis().getExtent();
    var angleExtent = polar.getAngleAxis().getExtent();
    oldPoint = oldPoint ? polar.pointToCoord(oldPoint) : [0, 0];
    newPoint = polar.pointToCoord(newPoint);

    if (axisModel.mainType === 'radiusAxis') {
      ret.pixel = newPoint[0] - oldPoint[0]; // ret.pixelLength = Math.abs(radiusExtent[1] - radiusExtent[0]);
      // ret.pixelStart = Math.min(radiusExtent[0], radiusExtent[1]);

      ret.pixelLength = radiusExtent[1] - radiusExtent[0];
      ret.pixelStart = radiusExtent[0];
      ret.signal = axis.inverse ? 1 : -1;
    } else {
      // 'angleAxis'
      ret.pixel = newPoint[1] - oldPoint[1]; // ret.pixelLength = Math.abs(angleExtent[1] - angleExtent[0]);
      // ret.pixelStart = Math.min(angleExtent[0], angleExtent[1]);

      ret.pixelLength = angleExtent[1] - angleExtent[0];
      ret.pixelStart = angleExtent[0];
      ret.signal = axis.inverse ? -1 : 1;
    }

    return ret;
  },
  singleAxis: function (oldPoint, newPoint, axisModel, controller, coordSysInfo) {
    var axis = axisModel.axis;
    var rect = coordSysInfo.model.coordinateSystem.getRect();
    var ret = {};
    oldPoint = oldPoint || [0, 0];

    if (axis.orient === 'horizontal') {
      ret.pixel = newPoint[0] - oldPoint[0];
      ret.pixelLength = rect.width;
      ret.pixelStart = rect.x;
      ret.signal = axis.inverse ? 1 : -1;
    } else {
      // 'vertical'
      ret.pixel = newPoint[1] - oldPoint[1];
      ret.pixelLength = rect.height;
      ret.pixelStart = rect.y;
      ret.signal = axis.inverse ? -1 : 1;
    }

    return ret;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (InsideZoomView);

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DataZoomModel_js__ = __webpack_require__(317);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var SelectDataZoomModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(SelectDataZoomModel, _super);

  function SelectDataZoomModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SelectDataZoomModel.type;
    return _this;
  }

  SelectDataZoomModel.type = 'dataZoom.select';
  return SelectDataZoomModel;
}(__WEBPACK_IMPORTED_MODULE_1__DataZoomModel_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SelectDataZoomModel);

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DataZoomView_js__ = __webpack_require__(318);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var SelectDataZoomView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(SelectDataZoomView, _super);

  function SelectDataZoomView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SelectDataZoomView.type;
    return _this;
  }

  SelectDataZoomView.type = 'dataZoom.select';
  return SelectDataZoomView;
}(__WEBPACK_IMPORTED_MODULE_1__DataZoomView_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SelectDataZoomView);

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DataZoomModel_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_component_js__ = __webpack_require__(49);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var SliderZoomModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(SliderZoomModel, _super);

  function SliderZoomModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SliderZoomModel.type;
    return _this;
  }

  SliderZoomModel.type = 'dataZoom.slider';
  SliderZoomModel.layoutMode = 'box';
  SliderZoomModel.defaultOption = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_component_js__["d" /* inheritDefaultOption */])(__WEBPACK_IMPORTED_MODULE_1__DataZoomModel_js__["a" /* default */].defaultOption, {
    show: true,
    // deault value can only be drived in view stage.
    right: 'ph',
    top: 'ph',
    width: 'ph',
    height: 'ph',
    left: null,
    bottom: null,
    borderColor: '#d2dbee',
    borderRadius: 3,
    backgroundColor: 'rgba(47,69,84,0)',
    // dataBackgroundColor: '#ddd',
    dataBackground: {
      lineStyle: {
        color: '#d2dbee',
        width: 0.5
      },
      areaStyle: {
        color: '#d2dbee',
        opacity: 0.2
      }
    },
    selectedDataBackground: {
      lineStyle: {
        color: '#8fb0f7',
        width: 0.5
      },
      areaStyle: {
        color: '#8fb0f7',
        opacity: 0.2
      }
    },
    // Color of selected window.
    fillerColor: 'rgba(135,175,274,0.2)',
    handleIcon: 'path://M-9.35,34.56V42m0-40V9.5m-2,0h4a2,2,0,0,1,2,2v21a2,2,0,0,1-2,2h-4a2,2,0,0,1-2-2v-21A2,2,0,0,1-11.35,9.5Z',
    // Percent of the slider height
    handleSize: '100%',
    handleStyle: {
      color: '#fff',
      borderColor: '#ACB8D1'
    },
    moveHandleSize: 7,
    moveHandleIcon: 'path://M-320.9-50L-320.9-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-348-41-339-50-320.9-50z M-212.3-50L-212.3-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-239.4-41-230.4-50-212.3-50z M-103.7-50L-103.7-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-130.9-41-121.8-50-103.7-50z',
    moveHandleStyle: {
      color: '#D2DBEE',
      opacity: 0.7
    },
    showDetail: true,
    showDataShadow: 'auto',
    realtime: true,
    zoomLock: false,
    textStyle: {
      color: '#6E7079'
    },
    brushSelect: true,
    brushStyle: {
      color: 'rgba(135,175,274,0.15)'
    },
    emphasis: {
      handleStyle: {
        borderColor: '#8FB0F7'
      },
      moveHandleStyle: {
        color: '#8FB0F7'
      }
    }
  });
  return SliderZoomModel;
}(__WEBPACK_IMPORTED_MODULE_1__DataZoomModel_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SliderZoomModel);

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_event_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_throttle_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DataZoomView_js__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helper_sliderMove_js__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helper_js__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_symbol_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_log_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__label_labelStyle_js__ = __webpack_require__(15);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/














var Rect = __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Rect"]; // Constants

var DEFAULT_LOCATION_EDGE_GAP = 7;
var DEFAULT_FRAME_BORDER_WIDTH = 1;
var DEFAULT_FILLER_SIZE = 30;
var DEFAULT_MOVE_HANDLE_SIZE = 7;
var HORIZONTAL = 'horizontal';
var VERTICAL = 'vertical';
var LABEL_GAP = 5;
var SHOW_DATA_SHADOW_SERIES_TYPE = ['line', 'bar', 'candlestick', 'scatter'];
var REALTIME_ANIMATION_CONFIG = {
  easing: 'cubicOut',
  duration: 100,
  delay: 0
};

var SliderZoomView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(SliderZoomView, _super);

  function SliderZoomView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SliderZoomView.type;
    _this._displayables = {};
    return _this;
  }

  SliderZoomView.prototype.init = function (ecModel, api) {
    this.api = api; // A unique handler for each dataZoom component

    this._onBrush = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(this._onBrush, this);
    this._onBrushEnd = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(this._onBrushEnd, this);
  };

  SliderZoomView.prototype.render = function (dataZoomModel, ecModel, api, payload) {
    _super.prototype.render.apply(this, arguments);

    __WEBPACK_IMPORTED_MODULE_4__util_throttle_js__["a" /* createOrUpdate */](this, '_dispatchZoomAction', dataZoomModel.get('throttle'), 'fixRate');
    this._orient = dataZoomModel.getOrient();

    if (dataZoomModel.get('show') === false) {
      this.group.removeAll();
      return;
    }

    if (dataZoomModel.noTarget()) {
      this._clear();

      this.group.removeAll();
      return;
    } // Notice: this._resetInterval() should not be executed when payload.type
    // is 'dataZoom', origin this._range should be maintained, otherwise 'pan'
    // or 'zoom' info will be missed because of 'throttle' of this.dispatchAction,


    if (!payload || payload.type !== 'dataZoom' || payload.from !== this.uid) {
      this._buildView();
    }

    this._updateView();
  };

  SliderZoomView.prototype.dispose = function () {
    this._clear();

    _super.prototype.dispose.apply(this, arguments);
  };

  SliderZoomView.prototype._clear = function () {
    __WEBPACK_IMPORTED_MODULE_4__util_throttle_js__["b" /* clear */](this, '_dispatchZoomAction');
    var zr = this.api.getZr();
    zr.off('mousemove', this._onBrush);
    zr.off('mouseup', this._onBrushEnd);
  };

  SliderZoomView.prototype._buildView = function () {
    var thisGroup = this.group;
    thisGroup.removeAll();
    this._brushing = false;
    this._displayables.brushRect = null;

    this._resetLocation();

    this._resetInterval();

    var barGroup = this._displayables.sliderGroup = new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Group"]();

    this._renderBackground();

    this._renderHandle();

    this._renderDataShadow();

    thisGroup.add(barGroup);

    this._positionGroup();
  };

  SliderZoomView.prototype._resetLocation = function () {
    var dataZoomModel = this.dataZoomModel;
    var api = this.api;
    var showMoveHandle = dataZoomModel.get('brushSelect');
    var moveHandleSize = showMoveHandle ? DEFAULT_MOVE_HANDLE_SIZE : 0; // If some of x/y/width/height are not specified,
    // auto-adapt according to target grid.

    var coordRect = this._findCoordRect();

    var ecSize = {
      width: api.getWidth(),
      height: api.getHeight()
    }; // Default align by coordinate system rect.

    var positionInfo = this._orient === HORIZONTAL ? {
      // Why using 'right', because right should be used in vertical,
      // and it is better to be consistent for dealing with position param merge.
      right: ecSize.width - coordRect.x - coordRect.width,
      top: ecSize.height - DEFAULT_FILLER_SIZE - DEFAULT_LOCATION_EDGE_GAP - moveHandleSize,
      width: coordRect.width,
      height: DEFAULT_FILLER_SIZE
    } : {
      right: DEFAULT_LOCATION_EDGE_GAP,
      top: coordRect.y,
      width: DEFAULT_FILLER_SIZE,
      height: coordRect.height
    }; // Do not write back to option and replace value 'ph', because
    // the 'ph' value should be recalculated when resize.

    var layoutParams = __WEBPACK_IMPORTED_MODULE_7__util_layout_js__["b" /* getLayoutParams */](dataZoomModel.option); // Replace the placeholder value.

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(['right', 'top', 'width', 'height'], function (name) {
      if (layoutParams[name] === 'ph') {
        layoutParams[name] = positionInfo[name];
      }
    });
    var layoutRect = __WEBPACK_IMPORTED_MODULE_7__util_layout_js__["f" /* getLayoutRect */](layoutParams, ecSize);
    this._location = {
      x: layoutRect.x,
      y: layoutRect.y
    };
    this._size = [layoutRect.width, layoutRect.height];
    this._orient === VERTICAL && this._size.reverse();
  };

  SliderZoomView.prototype._positionGroup = function () {
    var thisGroup = this.group;
    var location = this._location;
    var orient = this._orient; // Just use the first axis to determine mapping.

    var targetAxisModel = this.dataZoomModel.getFirstTargetAxisModel();
    var inverse = targetAxisModel && targetAxisModel.get('inverse');
    var sliderGroup = this._displayables.sliderGroup;
    var otherAxisInverse = (this._dataShadowInfo || {}).otherAxisInverse; // Transform barGroup.

    sliderGroup.attr(orient === HORIZONTAL && !inverse ? {
      scaleY: otherAxisInverse ? 1 : -1,
      scaleX: 1
    } : orient === HORIZONTAL && inverse ? {
      scaleY: otherAxisInverse ? 1 : -1,
      scaleX: -1
    } : orient === VERTICAL && !inverse ? {
      scaleY: otherAxisInverse ? -1 : 1,
      scaleX: 1,
      rotation: Math.PI / 2
    } // Dont use Math.PI, considering shadow direction.
    : {
      scaleY: otherAxisInverse ? -1 : 1,
      scaleX: -1,
      rotation: Math.PI / 2
    }); // Position barGroup

    var rect = thisGroup.getBoundingRect([sliderGroup]);
    thisGroup.x = location.x - rect.x;
    thisGroup.y = location.y - rect.y;
    thisGroup.markRedraw();
  };

  SliderZoomView.prototype._getViewExtent = function () {
    return [0, this._size[0]];
  };

  SliderZoomView.prototype._renderBackground = function () {
    var dataZoomModel = this.dataZoomModel;
    var size = this._size;
    var barGroup = this._displayables.sliderGroup;
    var brushSelect = dataZoomModel.get('brushSelect');
    barGroup.add(new Rect({
      silent: true,
      shape: {
        x: 0,
        y: 0,
        width: size[0],
        height: size[1]
      },
      style: {
        fill: dataZoomModel.get('backgroundColor')
      },
      z2: -40
    })); // Click panel, over shadow, below handles.

    var clickPanel = new Rect({
      shape: {
        x: 0,
        y: 0,
        width: size[0],
        height: size[1]
      },
      style: {
        fill: 'transparent'
      },
      z2: 0,
      onclick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(this._onClickPanel, this)
    });
    var zr = this.api.getZr();

    if (brushSelect) {
      clickPanel.on('mousedown', this._onBrushStart, this);
      clickPanel.cursor = 'crosshair';
      zr.on('mousemove', this._onBrush);
      zr.on('mouseup', this._onBrushEnd);
    } else {
      zr.off('mousemove', this._onBrush);
      zr.off('mouseup', this._onBrushEnd);
    }

    barGroup.add(clickPanel);
  };

  SliderZoomView.prototype._renderDataShadow = function () {
    var info = this._dataShadowInfo = this._prepareDataShadowInfo();

    this._displayables.dataShadowSegs = [];

    if (!info) {
      return;
    }

    var size = this._size;
    var oldSize = this._shadowSize || [];
    var seriesModel = info.series;
    var data = seriesModel.getRawData();
    var otherDim = seriesModel.getShadowDim ? seriesModel.getShadowDim() // @see candlestick
    : info.otherDim;

    if (otherDim == null) {
      return;
    }

    var polygonPts = this._shadowPolygonPts;
    var polylinePts = this._shadowPolylinePts; // Not re-render if data doesn't change.

    if (data !== this._shadowData || otherDim !== this._shadowDim || size[0] !== oldSize[0] || size[1] !== oldSize[1]) {
      var otherDataExtent_1 = data.getDataExtent(otherDim); // Nice extent.

      var otherOffset = (otherDataExtent_1[1] - otherDataExtent_1[0]) * 0.3;
      otherDataExtent_1 = [otherDataExtent_1[0] - otherOffset, otherDataExtent_1[1] + otherOffset];
      var otherShadowExtent_1 = [0, size[1]];
      var thisShadowExtent = [0, size[0]];
      var areaPoints_1 = [[size[0], 0], [0, 0]];
      var linePoints_1 = [];
      var step_1 = thisShadowExtent[1] / (data.count() - 1);
      var thisCoord_1 = 0; // Optimize for large data shadow

      var stride_1 = Math.round(data.count() / size[0]);
      var lastIsEmpty_1;
      data.each([otherDim], function (value, index) {
        if (stride_1 > 0 && index % stride_1) {
          thisCoord_1 += step_1;
          return;
        } // FIXME
        // Should consider axis.min/axis.max when drawing dataShadow.
        // FIXME
        // 应该使用统一的空判断？还是在list里进行空判断？


        var isEmpty = value == null || isNaN(value) || value === ''; // See #4235.

        var otherCoord = isEmpty ? 0 : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["h" /* linearMap */])(value, otherDataExtent_1, otherShadowExtent_1, true); // Attempt to draw data shadow precisely when there are empty value.

        if (isEmpty && !lastIsEmpty_1 && index) {
          areaPoints_1.push([areaPoints_1[areaPoints_1.length - 1][0], 0]);
          linePoints_1.push([linePoints_1[linePoints_1.length - 1][0], 0]);
        } else if (!isEmpty && lastIsEmpty_1) {
          areaPoints_1.push([thisCoord_1, 0]);
          linePoints_1.push([thisCoord_1, 0]);
        }

        areaPoints_1.push([thisCoord_1, otherCoord]);
        linePoints_1.push([thisCoord_1, otherCoord]);
        thisCoord_1 += step_1;
        lastIsEmpty_1 = isEmpty;
      });
      polygonPts = this._shadowPolygonPts = areaPoints_1;
      polylinePts = this._shadowPolylinePts = linePoints_1;
    }

    this._shadowData = data;
    this._shadowDim = otherDim;
    this._shadowSize = [size[0], size[1]];
    var dataZoomModel = this.dataZoomModel;

    function createDataShadowGroup(isSelectedArea) {
      var model = dataZoomModel.getModel(isSelectedArea ? 'selectedDataBackground' : 'dataBackground');
      var group = new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Group"]();
      var polygon = new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Polygon"]({
        shape: {
          points: polygonPts
        },
        segmentIgnoreThreshold: 1,
        style: model.getModel('areaStyle').getAreaStyle(),
        silent: true,
        z2: -20
      });
      var polyline = new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Polyline"]({
        shape: {
          points: polylinePts
        },
        segmentIgnoreThreshold: 1,
        style: model.getModel('lineStyle').getLineStyle(),
        silent: true,
        z2: -19
      });
      group.add(polygon);
      group.add(polyline);
      return group;
    } // let dataBackgroundModel = dataZoomModel.getModel('dataBackground');


    for (var i = 0; i < 3; i++) {
      var group = createDataShadowGroup(i === 1);

      this._displayables.sliderGroup.add(group);

      this._displayables.dataShadowSegs.push(group);
    }
  };

  SliderZoomView.prototype._prepareDataShadowInfo = function () {
    var dataZoomModel = this.dataZoomModel;
    var showDataShadow = dataZoomModel.get('showDataShadow');

    if (showDataShadow === false) {
      return;
    } // Find a representative series.


    var result;
    var ecModel = this.ecModel;
    dataZoomModel.eachTargetAxis(function (axisDim, axisIndex) {
      var seriesModels = dataZoomModel.getAxisProxy(axisDim, axisIndex).getTargetSeriesModels();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(seriesModels, function (seriesModel) {
        if (result) {
          return;
        }

        if (showDataShadow !== true && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["indexOf"])(SHOW_DATA_SHADOW_SERIES_TYPE, seriesModel.get('type')) < 0) {
          return;
        }

        var thisAxis = ecModel.getComponent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_js__["b" /* getAxisMainType */])(axisDim), axisIndex).axis;
        var otherDim = getOtherDim(axisDim);
        var otherAxisInverse;
        var coordSys = seriesModel.coordinateSystem;

        if (otherDim != null && coordSys.getOtherAxis) {
          otherAxisInverse = coordSys.getOtherAxis(thisAxis).inverse;
        }

        otherDim = seriesModel.getData().mapDimension(otherDim);
        result = {
          thisAxis: thisAxis,
          series: seriesModel,
          thisDim: axisDim,
          otherDim: otherDim,
          otherAxisInverse: otherAxisInverse
        };
      }, this);
    }, this);
    return result;
  };

  SliderZoomView.prototype._renderHandle = function () {
    var thisGroup = this.group;
    var displayables = this._displayables;
    var handles = displayables.handles = [null, null];
    var handleLabels = displayables.handleLabels = [null, null];
    var sliderGroup = this._displayables.sliderGroup;
    var size = this._size;
    var dataZoomModel = this.dataZoomModel;
    var api = this.api;
    var borderRadius = dataZoomModel.get('borderRadius') || 0;
    var brushSelect = dataZoomModel.get('brushSelect');
    var filler = displayables.filler = new Rect({
      silent: brushSelect,
      style: {
        fill: dataZoomModel.get('fillerColor')
      },
      textConfig: {
        position: 'inside'
      }
    });
    sliderGroup.add(filler); // Frame border.

    sliderGroup.add(new Rect({
      silent: true,
      subPixelOptimize: true,
      shape: {
        x: 0,
        y: 0,
        width: size[0],
        height: size[1],
        r: borderRadius
      },
      style: {
        stroke: dataZoomModel.get('dataBackgroundColor') // deprecated option
        || dataZoomModel.get('borderColor'),
        lineWidth: DEFAULT_FRAME_BORDER_WIDTH,
        fill: 'rgba(0,0,0,0)'
      }
    })); // Left and right handle to resize

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])([0, 1], function (handleIndex) {
      var iconStr = dataZoomModel.get('handleIcon');

      if (!__WEBPACK_IMPORTED_MODULE_11__util_symbol_js__["b" /* symbolBuildProxies */][iconStr] && iconStr.indexOf('path://') < 0 && iconStr.indexOf('image://') < 0) {
        // Compatitable with the old icon parsers. Which can use a path string without path://
        iconStr = 'path://' + iconStr;

        if (true) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_log_js__["g" /* deprecateLog */])('handleIcon now needs \'path://\' prefix when using a path string');
        }
      }

      var path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_symbol_js__["a" /* createSymbol */])(iconStr, -1, 0, 2, 2, null, true);
      path.attr({
        cursor: getCursor(this._orient),
        draggable: true,
        drift: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(this._onDragMove, this, handleIndex),
        ondragend: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(this._onDragEnd, this),
        onmouseover: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(this._showDataInfo, this, true),
        onmouseout: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(this._showDataInfo, this, false),
        z2: 5
      });
      var bRect = path.getBoundingRect();
      var handleSize = dataZoomModel.get('handleSize');
      this._handleHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(handleSize, this._size[1]);
      this._handleWidth = bRect.width / bRect.height * this._handleHeight;
      path.setStyle(dataZoomModel.getModel('handleStyle').getItemStyle());
      path.style.strokeNoScale = true;
      path.rectHover = true;
      path.ensureState('emphasis').style = dataZoomModel.getModel(['emphasis', 'handleStyle']).getItemStyle();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_states_js__["d" /* enableHoverEmphasis */])(path);
      var handleColor = dataZoomModel.get('handleColor'); // deprecated option
      // Compatitable with previous version

      if (handleColor != null) {
        path.style.fill = handleColor;
      }

      sliderGroup.add(handles[handleIndex] = path);
      var textStyleModel = dataZoomModel.getModel('textStyle');
      thisGroup.add(handleLabels[handleIndex] = new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Text"]({
        silent: true,
        invisible: true,
        style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__label_labelStyle_js__["d" /* createTextStyle */])(textStyleModel, {
          x: 0,
          y: 0,
          text: '',
          verticalAlign: 'middle',
          align: 'center',
          fill: textStyleModel.getTextColor(),
          font: textStyleModel.getFont()
        }),
        z2: 10
      }));
    }, this); // Handle to move. Only visible when brushSelect is set true.

    var actualMoveZone = filler;

    if (brushSelect) {
      var moveHandleHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(dataZoomModel.get('moveHandleSize'), size[1]);
      var moveHandle_1 = displayables.moveHandle = new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Rect"]({
        style: dataZoomModel.getModel('moveHandleStyle').getItemStyle(),
        silent: true,
        shape: {
          r: [0, 0, 2, 2],
          y: size[1] - 0.5,
          height: moveHandleHeight
        }
      });
      var iconSize = moveHandleHeight * 0.8;
      var moveHandleIcon = displayables.moveHandleIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_symbol_js__["a" /* createSymbol */])(dataZoomModel.get('moveHandleIcon'), -iconSize / 2, -iconSize / 2, iconSize, iconSize, '#fff', true);
      moveHandleIcon.silent = true;
      moveHandleIcon.y = size[1] + moveHandleHeight / 2 - 0.5;
      moveHandle_1.ensureState('emphasis').style = dataZoomModel.getModel(['emphasis', 'moveHandleStyle']).getItemStyle();
      var moveZoneExpandSize = Math.min(size[1] / 2, Math.max(moveHandleHeight, 10));
      actualMoveZone = displayables.moveZone = new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Rect"]({
        invisible: true,
        shape: {
          y: size[1] - moveZoneExpandSize,
          height: moveHandleHeight + moveZoneExpandSize
        }
      });
      actualMoveZone.on('mouseover', function () {
        api.enterEmphasis(moveHandle_1);
      }).on('mouseout', function () {
        api.leaveEmphasis(moveHandle_1);
      });
      sliderGroup.add(moveHandle_1);
      sliderGroup.add(moveHandleIcon);
      sliderGroup.add(actualMoveZone);
    }

    actualMoveZone.attr({
      draggable: true,
      cursor: getCursor(this._orient),
      drift: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(this._onDragMove, this, 'all'),
      ondragstart: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(this._showDataInfo, this, true),
      ondragend: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(this._onDragEnd, this),
      onmouseover: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(this._showDataInfo, this, true),
      onmouseout: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(this._showDataInfo, this, false)
    });
  };

  SliderZoomView.prototype._resetInterval = function () {
    var range = this._range = this.dataZoomModel.getPercentRange();

    var viewExtent = this._getViewExtent();

    this._handleEnds = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["h" /* linearMap */])(range[0], [0, 100], viewExtent, true), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["h" /* linearMap */])(range[1], [0, 100], viewExtent, true)];
  };

  SliderZoomView.prototype._updateInterval = function (handleIndex, delta) {
    var dataZoomModel = this.dataZoomModel;
    var handleEnds = this._handleEnds;

    var viewExtend = this._getViewExtent();

    var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
    var percentExtent = [0, 100];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helper_sliderMove_js__["a" /* default */])(delta, handleEnds, viewExtend, dataZoomModel.get('zoomLock') ? 'all' : handleIndex, minMaxSpan.minSpan != null ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["h" /* linearMap */])(minMaxSpan.minSpan, percentExtent, viewExtend, true) : null, minMaxSpan.maxSpan != null ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["h" /* linearMap */])(minMaxSpan.maxSpan, percentExtent, viewExtend, true) : null);
    var lastRange = this._range;
    var range = this._range = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["j" /* asc */])([__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["h" /* linearMap */])(handleEnds[0], viewExtend, percentExtent, true), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["h" /* linearMap */])(handleEnds[1], viewExtend, percentExtent, true)]);
    return !lastRange || lastRange[0] !== range[0] || lastRange[1] !== range[1];
  };

  SliderZoomView.prototype._updateView = function (nonRealtime) {
    var displaybles = this._displayables;
    var handleEnds = this._handleEnds;
    var handleInterval = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["j" /* asc */])(handleEnds.slice());
    var size = this._size;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])([0, 1], function (handleIndex) {
      // Handles
      var handle = displaybles.handles[handleIndex];
      var handleHeight = this._handleHeight;
      handle.attr({
        scaleX: handleHeight / 2,
        scaleY: handleHeight / 2,
        // This is a trick, by adding an extra tiny offset to let the default handle's end point align to the drag window.
        // NOTE: It may affect some custom shapes a bit. But we prefer to have better result by default.
        x: handleEnds[handleIndex] + (handleIndex ? -1 : 1),
        y: size[1] / 2 - handleHeight / 2
      });
    }, this); // Filler

    displaybles.filler.setShape({
      x: handleInterval[0],
      y: 0,
      width: handleInterval[1] - handleInterval[0],
      height: size[1]
    });
    var viewExtent = {
      x: handleInterval[0],
      width: handleInterval[1] - handleInterval[0]
    }; // Move handle

    if (displaybles.moveHandle) {
      displaybles.moveHandle.setShape(viewExtent);
      displaybles.moveZone.setShape(viewExtent); // Force update path on the invisible object

      displaybles.moveZone.getBoundingRect();
      displaybles.moveHandleIcon && displaybles.moveHandleIcon.attr('x', viewExtent.x + viewExtent.width / 2);
    } // update clip path of shadow.


    var dataShadowSegs = displaybles.dataShadowSegs;
    var segIntervals = [0, handleInterval[0], handleInterval[1], size[0]];

    for (var i = 0; i < dataShadowSegs.length; i++) {
      var segGroup = dataShadowSegs[i];
      var clipPath = segGroup.getClipPath();

      if (!clipPath) {
        clipPath = new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Rect"]();
        segGroup.setClipPath(clipPath);
      }

      clipPath.setShape({
        x: segIntervals[i],
        y: 0,
        width: segIntervals[i + 1] - segIntervals[i],
        height: size[1]
      });
    }

    this._updateDataInfo(nonRealtime);
  };

  SliderZoomView.prototype._updateDataInfo = function (nonRealtime) {
    var dataZoomModel = this.dataZoomModel;
    var displaybles = this._displayables;
    var handleLabels = displaybles.handleLabels;
    var orient = this._orient;
    var labelTexts = ['', '']; // FIXME
    // date型，支持formatter，autoformatter（ec2 date.getAutoFormatter）

    if (dataZoomModel.get('showDetail')) {
      var axisProxy = dataZoomModel.findRepresentativeAxisProxy();

      if (axisProxy) {
        var axis = axisProxy.getAxisModel().axis;
        var range = this._range;
        var dataInterval = nonRealtime // See #4434, data and axis are not processed and reset yet in non-realtime mode.
        ? axisProxy.calculateDataWindow({
          start: range[0],
          end: range[1]
        }).valueWindow : axisProxy.getDataValueWindow();
        labelTexts = [this._formatLabel(dataInterval[0], axis), this._formatLabel(dataInterval[1], axis)];
      }
    }

    var orderedHandleEnds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["j" /* asc */])(this._handleEnds.slice());
    setLabel.call(this, 0);
    setLabel.call(this, 1);

    function setLabel(handleIndex) {
      // Label
      // Text should not transform by barGroup.
      // Ignore handlers transform
      var barTransform = __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["getTransform"](displaybles.handles[handleIndex].parent, this.group);
      var direction = __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["transformDirection"](handleIndex === 0 ? 'right' : 'left', barTransform);
      var offset = this._handleWidth / 2 + LABEL_GAP;
      var textPoint = __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["applyTransform"]([orderedHandleEnds[handleIndex] + (handleIndex === 0 ? -offset : offset), this._size[1] / 2], barTransform);
      handleLabels[handleIndex].setStyle({
        x: textPoint[0],
        y: textPoint[1],
        verticalAlign: orient === HORIZONTAL ? 'middle' : direction,
        align: orient === HORIZONTAL ? direction : 'center',
        text: labelTexts[handleIndex]
      });
    }
  };

  SliderZoomView.prototype._formatLabel = function (value, axis) {
    var dataZoomModel = this.dataZoomModel;
    var labelFormatter = dataZoomModel.get('labelFormatter');
    var labelPrecision = dataZoomModel.get('labelPrecision');

    if (labelPrecision == null || labelPrecision === 'auto') {
      labelPrecision = axis.getPixelPrecision();
    }

    var valueStr = value == null || isNaN(value) ? '' // FIXME Glue code
    : axis.type === 'category' || axis.type === 'time' ? axis.scale.getLabel({
      value: Math.round(value)
    }) // param of toFixed should less then 20.
    : value.toFixed(Math.min(labelPrecision, 20));
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isFunction"])(labelFormatter) ? labelFormatter(value, valueStr) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"])(labelFormatter) ? labelFormatter.replace('{value}', valueStr) : valueStr;
  };
  /**
   * @param showOrHide true: show, false: hide
   */


  SliderZoomView.prototype._showDataInfo = function (showOrHide) {
    // Always show when drgging.
    showOrHide = this._dragging || showOrHide;
    var displayables = this._displayables;
    var handleLabels = displayables.handleLabels;
    handleLabels[0].attr('invisible', !showOrHide);
    handleLabels[1].attr('invisible', !showOrHide); // Highlight move handle

    displayables.moveHandle && this.api[showOrHide ? 'enterEmphasis' : 'leaveEmphasis'](displayables.moveHandle, 1);
  };

  SliderZoomView.prototype._onDragMove = function (handleIndex, dx, dy, event) {
    this._dragging = true; // For mobile device, prevent screen slider on the button.

    __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_event_js__["a" /* stop */](event.event); // Transform dx, dy to bar coordination.

    var barTransform = this._displayables.sliderGroup.getLocalTransform();

    var vertex = __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["applyTransform"]([dx, dy], barTransform, true);

    var changed = this._updateInterval(handleIndex, vertex[0]);

    var realtime = this.dataZoomModel.get('realtime');

    this._updateView(!realtime); // Avoid dispatch dataZoom repeatly but range not changed,
    // which cause bad visual effect when progressive enabled.


    changed && realtime && this._dispatchZoomAction(true);
  };

  SliderZoomView.prototype._onDragEnd = function () {
    this._dragging = false;

    this._showDataInfo(false); // While in realtime mode and stream mode, dispatch action when
    // drag end will cause the whole view rerender, which is unnecessary.


    var realtime = this.dataZoomModel.get('realtime');
    !realtime && this._dispatchZoomAction(false);
  };

  SliderZoomView.prototype._onClickPanel = function (e) {
    var size = this._size;

    var localPoint = this._displayables.sliderGroup.transformCoordToLocal(e.offsetX, e.offsetY);

    if (localPoint[0] < 0 || localPoint[0] > size[0] || localPoint[1] < 0 || localPoint[1] > size[1]) {
      return;
    }

    var handleEnds = this._handleEnds;
    var center = (handleEnds[0] + handleEnds[1]) / 2;

    var changed = this._updateInterval('all', localPoint[0] - center);

    this._updateView();

    changed && this._dispatchZoomAction(false);
  };

  SliderZoomView.prototype._onBrushStart = function (e) {
    var x = e.offsetX;
    var y = e.offsetY;
    this._brushStart = new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Point"](x, y);
    this._brushing = true;
    this._brushStartTime = +new Date(); // this._updateBrushRect(x, y);
  };

  SliderZoomView.prototype._onBrushEnd = function (e) {
    if (!this._brushing) {
      return;
    }

    var brushRect = this._displayables.brushRect;
    this._brushing = false;

    if (!brushRect) {
      return;
    }

    brushRect.attr('ignore', true);
    var brushShape = brushRect.shape;
    var brushEndTime = +new Date(); // console.log(brushEndTime - this._brushStartTime);

    if (brushEndTime - this._brushStartTime < 200 && Math.abs(brushShape.width) < 5) {
      // Will treat it as a click
      return;
    }

    var viewExtend = this._getViewExtent();

    var percentExtent = [0, 100];
    this._range = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["j" /* asc */])([__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["h" /* linearMap */])(brushShape.x, viewExtend, percentExtent, true), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["h" /* linearMap */])(brushShape.x + brushShape.width, viewExtend, percentExtent, true)]);
    this._handleEnds = [brushShape.x, brushShape.x + brushShape.width];

    this._updateView();

    this._dispatchZoomAction(false);
  };

  SliderZoomView.prototype._onBrush = function (e) {
    if (this._brushing) {
      // For mobile device, prevent screen slider on the button.
      __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_event_js__["a" /* stop */](e.event);

      this._updateBrushRect(e.offsetX, e.offsetY);
    }
  };

  SliderZoomView.prototype._updateBrushRect = function (mouseX, mouseY) {
    var displayables = this._displayables;
    var dataZoomModel = this.dataZoomModel;
    var brushRect = displayables.brushRect;

    if (!brushRect) {
      brushRect = displayables.brushRect = new Rect({
        silent: true,
        style: dataZoomModel.getModel('brushStyle').getItemStyle()
      });
      displayables.sliderGroup.add(brushRect);
    }

    brushRect.attr('ignore', false);
    var brushStart = this._brushStart;
    var sliderGroup = this._displayables.sliderGroup;
    var endPoint = sliderGroup.transformCoordToLocal(mouseX, mouseY);
    var startPoint = sliderGroup.transformCoordToLocal(brushStart.x, brushStart.y);
    var size = this._size;
    endPoint[0] = Math.max(Math.min(size[0], endPoint[0]), 0);
    brushRect.setShape({
      x: startPoint[0],
      y: 0,
      width: endPoint[0] - startPoint[0],
      height: size[1]
    });
  };
  /**
   * This action will be throttled.
   */


  SliderZoomView.prototype._dispatchZoomAction = function (realtime) {
    var range = this._range;
    this.api.dispatchAction({
      type: 'dataZoom',
      from: this.uid,
      dataZoomId: this.dataZoomModel.id,
      animation: realtime ? REALTIME_ANIMATION_CONFIG : null,
      start: range[0],
      end: range[1]
    });
  };

  SliderZoomView.prototype._findCoordRect = function () {
    // Find the grid coresponding to the first axis referred by dataZoom.
    var rect;
    var coordSysInfoList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helper_js__["d" /* collectReferCoordSysModelInfo */])(this.dataZoomModel).infoList;

    if (!rect && coordSysInfoList.length) {
      var coordSys = coordSysInfoList[0].model.coordinateSystem;
      rect = coordSys.getRect && coordSys.getRect();
    }

    if (!rect) {
      var width = this.api.getWidth();
      var height = this.api.getHeight();
      rect = {
        x: width * 0.2,
        y: height * 0.2,
        width: width * 0.6,
        height: height * 0.6
      };
    }

    return rect;
  };

  SliderZoomView.type = 'dataZoom.slider';
  return SliderZoomView;
}(__WEBPACK_IMPORTED_MODULE_5__DataZoomView_js__["a" /* default */]);

function getOtherDim(thisDim) {
  // FIXME
  // 这个逻辑和getOtherAxis里一致，但是写在这里是否不好
  var map = {
    x: 'y',
    y: 'x',
    radius: 'angle',
    angle: 'radius'
  };
  return map[thisDim];
}

function getCursor(orient) {
  return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
}

/* harmony default export */ __webpack_exports__["a"] = (SliderZoomView);

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = installDataZoomAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_js__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


function installDataZoomAction(registers) {
  registers.registerAction('dataZoom', function (payload, ecModel) {
    var effectedModels = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["a" /* findEffectedDataZooms */])(ecModel, payload);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(effectedModels, function (dataZoomModel) {
      dataZoomModel.setRawRange({
        start: payload.start,
        end: payload.end,
        startValue: payload.startValue,
        endValue: payload.endValue
      });
    });
  });
}

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_js__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AxisProxy_js__ = __webpack_require__(1215);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var dataZoomProcessor = {
  // `dataZoomProcessor` will only be performed in needed series. Consider if
  // there is a line series and a pie series, it is better not to update the
  // line series if only pie series is needed to be updated.
  getTargetSeries: function (ecModel) {
    function eachAxisModel(cb) {
      ecModel.eachComponent('dataZoom', function (dataZoomModel) {
        dataZoomModel.eachTargetAxis(function (axisDim, axisIndex) {
          var axisModel = ecModel.getComponent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper_js__["b" /* getAxisMainType */])(axisDim), axisIndex);
          cb(axisDim, axisIndex, axisModel, dataZoomModel);
        });
      });
    } // FIXME: it brings side-effect to `getTargetSeries`.
    // Prepare axis proxies.


    eachAxisModel(function (axisDim, axisIndex, axisModel, dataZoomModel) {
      // dispose all last axis proxy, in case that some axis are deleted.
      axisModel.__dzAxisProxy = null;
    });
    var proxyList = [];
    eachAxisModel(function (axisDim, axisIndex, axisModel, dataZoomModel) {
      // Different dataZooms may constrol the same axis. In that case,
      // an axisProxy serves both of them.
      if (!axisModel.__dzAxisProxy) {
        // Use the first dataZoomModel as the main model of axisProxy.
        axisModel.__dzAxisProxy = new __WEBPACK_IMPORTED_MODULE_2__AxisProxy_js__["a" /* default */](axisDim, axisIndex, dataZoomModel, ecModel);
        proxyList.push(axisModel.__dzAxisProxy);
      }
    });
    var seriesModelMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(proxyList, function (axisProxy) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(axisProxy.getTargetSeriesModels(), function (seriesModel) {
        seriesModelMap.set(seriesModel.uid, seriesModel);
      });
    });
    return seriesModelMap;
  },
  // Consider appendData, where filter should be performed. Because data process is
  // in block mode currently, it is not need to worry about that the overallProgress
  // execute every frame.
  overallReset: function (ecModel, api) {
    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
      // We calculate window and reset axis here but not in model
      // init stage and not after action dispatch handler, because
      // reset should be called after seriesData.restoreData.
      dataZoomModel.eachTargetAxis(function (axisDim, axisIndex) {
        dataZoomModel.getAxisProxy(axisDim, axisIndex).reset(dataZoomModel);
      }); // Caution: data zoom filtering is order sensitive when using
      // percent range and no min/max/scale set on axis.
      // For example, we have dataZoom definition:
      // [
      //      {xAxisIndex: 0, start: 30, end: 70},
      //      {yAxisIndex: 0, start: 20, end: 80}
      // ]
      // In this case, [20, 80] of y-dataZoom should be based on data
      // that have filtered by x-dataZoom using range of [30, 70],
      // but should not be based on full raw data. Thus sliding
      // x-dataZoom will change both ranges of xAxis and yAxis,
      // while sliding y-dataZoom will only change the range of yAxis.
      // So we should filter x-axis after reset x-axis immediately,
      // and then reset y-axis and filter y-axis.

      dataZoomModel.eachTargetAxis(function (axisDim, axisIndex) {
        dataZoomModel.getAxisProxy(axisDim, axisIndex).filterData(dataZoomModel, api);
      });
    });
    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
      // Fullfill all of the range props so that user
      // is able to get them from chart.getOption().
      var axisProxy = dataZoomModel.findRepresentativeAxisProxy();

      if (axisProxy) {
        var percentRange = axisProxy.getDataPercentWindow();
        var valueRange = axisProxy.getDataValueWindow();
        dataZoomModel.setCalculatedRange({
          start: percentRange[0],
          end: percentRange[1],
          startValue: valueRange[0],
          endValue: valueRange[1]
        });
      }
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = (dataZoomProcessor);

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extension_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__installDataZoomInside_js__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__installDataZoomSlider_js__ = __webpack_require__(463);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



function install(registers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_1__installDataZoomInside_js__["a" /* install */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_2__installDataZoomSlider_js__["a" /* install */]); // Do not install './dataZoomSelect',
  // since it only work for toolbox dataZoom.
}

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SelectZoomModel_js__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SelectZoomView_js__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__installCommon_js__ = __webpack_require__(319);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



function install(registers) {
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_0__SelectZoomModel_js__["a" /* default */]);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_1__SelectZoomView_js__["a" /* default */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__installCommon_js__["a" /* default */])(registers);
}

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DatasetModel */
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_Component_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_Component_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_types_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_helper_sourceManager_js__ = __webpack_require__(494);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * This module is imported by echarts directly.
 *
 * Notice:
 * Always keep this file exists for backward compatibility.
 * Because before 4.1.0, dataset is an optional component,
 * some users may import this module manually.
 */






var DatasetModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(DatasetModel, _super);

  function DatasetModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = 'dataset';
    return _this;
  }

  DatasetModel.prototype.init = function (option, parentModel, ecModel) {
    _super.prototype.init.call(this, option, parentModel, ecModel);

    this._sourceManager = new __WEBPACK_IMPORTED_MODULE_4__data_helper_sourceManager_js__["a" /* SourceManager */](this);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__data_helper_sourceManager_js__["b" /* disableTransformOptionMerge */])(this);
  };

  DatasetModel.prototype.mergeOption = function (newOption, ecModel) {
    _super.prototype.mergeOption.call(this, newOption, ecModel);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__data_helper_sourceManager_js__["b" /* disableTransformOptionMerge */])(this);
  };

  DatasetModel.prototype.optionUpdated = function () {
    this._sourceManager.dirty();
  };

  DatasetModel.prototype.getSourceManager = function () {
    return this._sourceManager;
  };

  DatasetModel.type = 'dataset';
  DatasetModel.defaultOption = {
    seriesLayoutBy: __WEBPACK_IMPORTED_MODULE_3__util_types_js__["c" /* SERIES_LAYOUT_BY_COLUMN */]
  };
  return DatasetModel;
}(__WEBPACK_IMPORTED_MODULE_1__model_Component_js__["a" /* default */]);



var DatasetView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(DatasetView, _super);

  function DatasetView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = 'dataset';
    return _this;
  }

  DatasetView.type = 'dataset';
  return DatasetView;
}(__WEBPACK_IMPORTED_MODULE_2__view_Component_js__["a" /* default */]);

function install(registers) {
  registers.registerComponentModel(DatasetModel);
  registers.registerComponentView(DatasetView);
}

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_MapDraw_js__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_Component_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_event_js__ = __webpack_require__(336);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






var GeoView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(GeoView, _super);

  function GeoView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = GeoView.type;
    _this.focusBlurEnabled = true;
    return _this;
  }

  GeoView.prototype.init = function (ecModel, api) {
    this._api = api;
  };

  GeoView.prototype.render = function (geoModel, ecModel, api, payload) {
    this._model = geoModel;

    if (!geoModel.get('show')) {
      this._mapDraw && this._mapDraw.remove();
      this._mapDraw = null;
      return;
    }

    if (!this._mapDraw) {
      this._mapDraw = new __WEBPACK_IMPORTED_MODULE_1__helper_MapDraw_js__["a" /* default */](api);
    }

    var mapDraw = this._mapDraw;
    mapDraw.draw(geoModel, ecModel, api, this, payload);
    mapDraw.group.on('click', this._handleRegionClick, this);
    mapDraw.group.silent = geoModel.get('silent');
    this.group.add(mapDraw.group);
    this.updateSelectStatus(geoModel, ecModel, api);
  };

  GeoView.prototype._handleRegionClick = function (e) {
    var eventData;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_event_js__["a" /* findEventDispatcher */])(e.target, function (current) {
      return (eventData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_innerStore_js__["a" /* getECData */])(current).eventData) != null;
    }, true);

    if (eventData) {
      this._api.dispatchAction({
        type: 'geoToggleSelect',
        geoId: this._model.id,
        name: eventData.name
      });
    }
  };

  GeoView.prototype.updateSelectStatus = function (model, ecModel, api) {
    var _this = this;

    this._mapDraw.group.traverse(function (node) {
      var eventData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_innerStore_js__["a" /* getECData */])(node).eventData;

      if (eventData) {
        _this._model.isSelected(eventData.name) ? api.enterSelect(node) : api.leaveSelect(node); // No need to traverse children.

        return true;
      }
    });
  };

  GeoView.prototype.findHighDownDispatchers = function (name) {
    return this._mapDraw && this._mapDraw.findHighDownDispatchers(name, this._model);
  };

  GeoView.prototype.dispose = function () {
    this._mapDraw && this._mapDraw.remove();
  };

  GeoView.type = 'geo';
  return GeoView;
}(__WEBPACK_IMPORTED_MODULE_2__view_Component_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (GeoView);

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setKeyInfoToNewElOption */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GraphicComponentModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_Component_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_layout_js__ = __webpack_require__(19);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





;
;
;
function setKeyInfoToNewElOption(resultItem, newElOption) {
  var existElOption = resultItem.existing; // Set id and type after id assigned.

  newElOption.id = resultItem.keyInfo.id;
  !newElOption.type && existElOption && (newElOption.type = existElOption.type); // Set parent id if not specified

  if (newElOption.parentId == null) {
    var newElParentOption = newElOption.parentOption;

    if (newElParentOption) {
      newElOption.parentId = newElParentOption.id;
    } else if (existElOption) {
      newElOption.parentId = existElOption.parentId;
    }
  } // Clear


  newElOption.parentOption = null;
}

function isSetLoc(obj, props) {
  var isSet;
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](props, function (prop) {
    obj[prop] != null && obj[prop] !== 'auto' && (isSet = true);
  });
  return isSet;
}

function mergeNewElOptionToExist(existList, index, newElOption) {
  // Update existing options, for `getOption` feature.
  var newElOptCopy = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"]({}, newElOption);
  var existElOption = existList[index];
  var $action = newElOption.$action || 'merge';

  if ($action === 'merge') {
    if (existElOption) {
      if (true) {
        var newType = newElOption.type;
        __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"](!newType || existElOption.type === newType, 'Please set $action: "replace" to change `type`');
      } // We can ensure that newElOptCopy and existElOption are not
      // the same object, so `merge` will not change newElOptCopy.


      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"](existElOption, newElOptCopy, true); // Rigid body, use ignoreSize.

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_layout_js__["c" /* mergeLayoutParam */])(existElOption, newElOptCopy, {
        ignoreSize: true
      }); // Will be used in render.

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_layout_js__["h" /* copyLayoutParams */])(newElOption, existElOption); // Copy transition info to new option so it can be used in the transition.
      // DO IT AFTER merge

      copyTransitionInfo(newElOption, existElOption);
      copyTransitionInfo(newElOption, existElOption, 'shape');
      copyTransitionInfo(newElOption, existElOption, 'style');
      copyTransitionInfo(newElOption, existElOption, 'extra'); // Copy clipPath

      newElOption.clipPath = existElOption.clipPath;
    } else {
      existList[index] = newElOptCopy;
    }
  } else if ($action === 'replace') {
    existList[index] = newElOptCopy;
  } else if ($action === 'remove') {
    // null will be cleaned later.
    existElOption && (existList[index] = null);
  }
}

var TRANSITION_PROPS_TO_COPY = ['transition', 'enterFrom', 'leaveTo'];
var ROOT_TRANSITION_PROPS_TO_COPY = TRANSITION_PROPS_TO_COPY.concat(['enterAnimation', 'updateAnimation', 'leaveAnimation']);

function copyTransitionInfo(target, source, targetProp) {
  if (targetProp) {
    if (!target[targetProp] && source[targetProp]) {
      // TODO avoid creating this empty object when there is no transition configuration.
      target[targetProp] = {};
    }

    target = target[targetProp];
    source = source[targetProp];
  }

  if (!target || !source) {
    return;
  }

  var props = targetProp ? TRANSITION_PROPS_TO_COPY : ROOT_TRANSITION_PROPS_TO_COPY;

  for (var i = 0; i < props.length; i++) {
    var prop = props[i];

    if (target[prop] == null && source[prop] != null) {
      target[prop] = source[prop];
    }
  }
}

function setLayoutInfoToExist(existItem, newElOption) {
  if (!existItem) {
    return;
  }

  existItem.hv = newElOption.hv = [// Rigid body, dont care `width`.
  isSetLoc(newElOption, ['left', 'right']), // Rigid body, dont care `height`.
  isSetLoc(newElOption, ['top', 'bottom'])]; // Give default group size. Otherwise layout error may occur.

  if (existItem.type === 'group') {
    var existingGroupOpt = existItem;
    var newGroupOpt = newElOption;
    existingGroupOpt.width == null && (existingGroupOpt.width = newGroupOpt.width = 0);
    existingGroupOpt.height == null && (existingGroupOpt.height = newGroupOpt.height = 0);
  }
}

var GraphicComponentModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(GraphicComponentModel, _super);

  function GraphicComponentModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = GraphicComponentModel.type;
    _this.preventAutoZ = true;
    return _this;
  }

  GraphicComponentModel.prototype.mergeOption = function (option, ecModel) {
    // Prevent default merge to elements
    var elements = this.option.elements;
    this.option.elements = null;

    _super.prototype.mergeOption.call(this, option, ecModel);

    this.option.elements = elements;
  };

  GraphicComponentModel.prototype.optionUpdated = function (newOption, isInit) {
    var thisOption = this.option;
    var newList = (isInit ? thisOption : newOption).elements;
    var existList = thisOption.elements = isInit ? [] : thisOption.elements;
    var flattenedList = [];

    this._flatten(newList, flattenedList, null);

    var mappingResult = __WEBPACK_IMPORTED_MODULE_2__util_model_js__["q" /* mappingToExists */](existList, flattenedList, 'normalMerge'); // Clear elOptionsToUpdate

    var elOptionsToUpdate = this._elOptionsToUpdate = [];
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](mappingResult, function (resultItem, index) {
      var newElOption = resultItem.newOption;

      if (true) {
        __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"](__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isObject"](newElOption) || resultItem.existing, 'Empty graphic option definition');
      }

      if (!newElOption) {
        return;
      }

      elOptionsToUpdate.push(newElOption);
      setKeyInfoToNewElOption(resultItem, newElOption);
      mergeNewElOptionToExist(existList, index, newElOption);
      setLayoutInfoToExist(existList[index], newElOption);
    }, this); // Clean

    thisOption.elements = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["filter"](existList, function (item) {
      // $action should be volatile, otherwise option gotten from
      // `getOption` will contain unexpected $action.
      item && delete item.$action;
      return item != null;
    });
  };
  /**
   * Convert
   * [{
   *  type: 'group',
   *  id: 'xx',
   *  children: [{type: 'circle'}, {type: 'polygon'}]
   * }]
   * to
   * [
   *  {type: 'group', id: 'xx'},
   *  {type: 'circle', parentId: 'xx'},
   *  {type: 'polygon', parentId: 'xx'}
   * ]
   */


  GraphicComponentModel.prototype._flatten = function (optionList, result, parentOption) {
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](optionList, function (option) {
      if (!option) {
        return;
      }

      if (parentOption) {
        option.parentOption = parentOption;
      }

      result.push(option);
      var children = option.children;

      if (option.type === 'group' && children) {
        this._flatten(children, result, option);
      } // Deleting for JSON output, and for not affecting group creation.


      delete option.children;
    }, this);
  }; // FIXME
  // Pass to view using payload? setOption has a payload?


  GraphicComponentModel.prototype.useElOptionsToUpdate = function () {
    var els = this._elOptionsToUpdate; // Clear to avoid render duplicately when zooming.

    this._elOptionsToUpdate = null;
    return els;
  };

  GraphicComponentModel.type = 'graphic';
  GraphicComponentModel.defaultOption = {
    elements: [] // parentId: null

  };
  return GraphicComponentModel;
}(__WEBPACK_IMPORTED_MODULE_3__model_Component_js__["a" /* default */]);



/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export inner */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GraphicComponentView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_graphic_Displayable_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_Component_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_styleCompat_js__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__animation_customGraphicTransition_js__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__animation_basicTrasition_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__animation_customGraphicKeyframeAnimation_js__ = __webpack_require__(440);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/













var nonShapeGraphicElements = {
  // Reserved but not supported in graphic component.
  path: null,
  compoundPath: null,
  // Supported in graphic component.
  group: __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["Group"],
  image: __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["Image"],
  text: __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["Text"]
};
var inner = __WEBPACK_IMPORTED_MODULE_3__util_model_js__["a" /* makeInner */](); // ------------------------
// View
// ------------------------

var GraphicComponentView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(GraphicComponentView, _super);

  function GraphicComponentView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = GraphicComponentView.type;
    return _this;
  }

  GraphicComponentView.prototype.init = function () {
    this._elMap = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"]();
  };

  GraphicComponentView.prototype.render = function (graphicModel, ecModel, api) {
    // Having leveraged between use cases and algorithm complexity, a very
    // simple layout mechanism is used:
    // The size(width/height) can be determined by itself or its parent (not
    // implemented yet), but can not by its children. (Top-down travel)
    // The location(x/y) can be determined by the bounding rect of itself
    // (can including its descendants or not) and the size of its parent.
    // (Bottom-up travel)
    // When `chart.clear()` or `chart.setOption({...}, true)` with the same id,
    // view will be reused.
    if (graphicModel !== this._lastGraphicModel) {
      this._clear();
    }

    this._lastGraphicModel = graphicModel;

    this._updateElements(graphicModel);

    this._relocate(graphicModel, api);
  };
  /**
   * Update graphic elements.
   */


  GraphicComponentView.prototype._updateElements = function (graphicModel) {
    var elOptionsToUpdate = graphicModel.useElOptionsToUpdate();

    if (!elOptionsToUpdate) {
      return;
    }

    var elMap = this._elMap;
    var rootGroup = this.group;
    var globalZ = graphicModel.get('z');
    var globalZLevel = graphicModel.get('zlevel'); // Top-down tranverse to assign graphic settings to each elements.

    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](elOptionsToUpdate, function (elOption) {
      var id = __WEBPACK_IMPORTED_MODULE_3__util_model_js__["n" /* convertOptionIdName */](elOption.id, null);
      var elExisting = id != null ? elMap.get(id) : null;
      var parentId = __WEBPACK_IMPORTED_MODULE_3__util_model_js__["n" /* convertOptionIdName */](elOption.parentId, null);
      var targetElParent = parentId != null ? elMap.get(parentId) : rootGroup;
      var elType = elOption.type;
      var elOptionStyle = elOption.style;

      if (elType === 'text' && elOptionStyle) {
        // In top/bottom mode, textVerticalAlign should not be used, which cause
        // inaccurately locating.
        if (elOption.hv && elOption.hv[1]) {
          elOptionStyle.textVerticalAlign = elOptionStyle.textBaseline = elOptionStyle.verticalAlign = elOptionStyle.align = null;
        }
      }

      var textContentOption = elOption.textContent;
      var textConfig = elOption.textConfig;

      if (elOptionStyle && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_styleCompat_js__["a" /* isEC4CompatibleStyle */])(elOptionStyle, elType, !!textConfig, !!textContentOption)) {
        var convertResult = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_styleCompat_js__["b" /* convertFromEC4CompatibleStyle */])(elOptionStyle, elType, true);

        if (!textConfig && convertResult.textConfig) {
          textConfig = elOption.textConfig = convertResult.textConfig;
        }

        if (!textContentOption && convertResult.textContent) {
          textContentOption = convertResult.textContent;
        }
      } // Remove unnecessary props to avoid potential problems.


      var elOptionCleaned = getCleanedElOption(elOption); // For simple, do not support parent change, otherwise reorder is needed.

      if (true) {
        elExisting && __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"](targetElParent === elExisting.parent, 'Changing parent is not supported.');
      }

      var $action = elOption.$action || 'merge';
      var isMerge = $action === 'merge';
      var isReplace = $action === 'replace';

      if (isMerge) {
        var isInit = !elExisting;
        var el_1 = elExisting;

        if (isInit) {
          el_1 = createEl(id, targetElParent, elOption.type, elMap);
        } else {
          el_1 && (inner(el_1).isNew = false); // Stop and restore before update any other attributes.

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__animation_customGraphicKeyframeAnimation_js__["a" /* stopPreviousKeyframeAnimationAndRestore */])(el_1);
        }

        if (el_1) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__animation_customGraphicTransition_js__["a" /* applyUpdateTransition */])(el_1, elOptionCleaned, graphicModel, {
            isInit: isInit
          });
          updateCommonAttrs(el_1, elOption, globalZ, globalZLevel);
        }
      } else if (isReplace) {
        removeEl(elExisting, elOption, elMap, graphicModel);
        var el_2 = createEl(id, targetElParent, elOption.type, elMap);

        if (el_2) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__animation_customGraphicTransition_js__["a" /* applyUpdateTransition */])(el_2, elOptionCleaned, graphicModel, {
            isInit: true
          });
          updateCommonAttrs(el_2, elOption, globalZ, globalZLevel);
        }
      } else if ($action === 'remove') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__animation_customGraphicTransition_js__["b" /* updateLeaveTo */])(elExisting, elOption);
        removeEl(elExisting, elOption, elMap, graphicModel);
      }

      var el = elMap.get(id);

      if (el && textContentOption) {
        if (isMerge) {
          var textContentExisting = el.getTextContent();
          textContentExisting ? textContentExisting.attr(textContentOption) : el.setTextContent(new __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["Text"](textContentOption));
        } else if (isReplace) {
          el.setTextContent(new __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["Text"](textContentOption));
        }
      }

      if (el) {
        var clipPathOption = elOption.clipPath;

        if (clipPathOption) {
          var clipPathType = clipPathOption.type;
          var clipPath = void 0;
          var isInit = false;

          if (isMerge) {
            var oldClipPath = el.getClipPath();
            isInit = !oldClipPath || inner(oldClipPath).type !== clipPathType;
            clipPath = isInit ? newEl(clipPathType) : oldClipPath;
          } else if (isReplace) {
            isInit = true;
            clipPath = newEl(clipPathType);
          }

          el.setClipPath(clipPath);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__animation_customGraphicTransition_js__["a" /* applyUpdateTransition */])(clipPath, clipPathOption, graphicModel, {
            isInit: isInit
          });
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__animation_customGraphicKeyframeAnimation_js__["b" /* applyKeyframeAnimation */])(clipPath, clipPathOption.keyframeAnimation, graphicModel);
        }

        var elInner = inner(el);
        el.setTextConfig(textConfig);
        elInner.option = elOption;
        setEventData(el, graphicModel, elOption);
        __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["setTooltipConfig"]({
          el: el,
          componentModel: graphicModel,
          itemName: el.name,
          itemTooltipOption: elOption.tooltip
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__animation_customGraphicKeyframeAnimation_js__["b" /* applyKeyframeAnimation */])(el, elOption.keyframeAnimation, graphicModel);
      }
    });
  };
  /**
   * Locate graphic elements.
   */


  GraphicComponentView.prototype._relocate = function (graphicModel, api) {
    var elOptions = graphicModel.option.elements;
    var rootGroup = this.group;
    var elMap = this._elMap;
    var apiWidth = api.getWidth();
    var apiHeight = api.getHeight();
    var xy = ['x', 'y']; // Top-down to calculate percentage width/height of group

    for (var i = 0; i < elOptions.length; i++) {
      var elOption = elOptions[i];
      var id = __WEBPACK_IMPORTED_MODULE_3__util_model_js__["n" /* convertOptionIdName */](elOption.id, null);
      var el = id != null ? elMap.get(id) : null;

      if (!el || !el.isGroup) {
        continue;
      }

      var parentEl = el.parent;
      var isParentRoot = parentEl === rootGroup; // Like 'position:absolut' in css, default 0.

      var elInner = inner(el);
      var parentElInner = inner(parentEl);
      elInner.width = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(elInner.option.width, isParentRoot ? apiWidth : parentElInner.width) || 0;
      elInner.height = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(elInner.option.height, isParentRoot ? apiHeight : parentElInner.height) || 0;
    } // Bottom-up tranvese all elements (consider ec resize) to locate elements.


    for (var i = elOptions.length - 1; i >= 0; i--) {
      var elOption = elOptions[i];
      var id = __WEBPACK_IMPORTED_MODULE_3__util_model_js__["n" /* convertOptionIdName */](elOption.id, null);
      var el = id != null ? elMap.get(id) : null;

      if (!el) {
        continue;
      }

      var parentEl = el.parent;
      var parentElInner = inner(parentEl);
      var containerInfo = parentEl === rootGroup ? {
        width: apiWidth,
        height: apiHeight
      } : {
        width: parentElInner.width,
        height: parentElInner.height
      }; // PENDING
      // Currently, when `bounding: 'all'`, the union bounding rect of the group
      // does not include the rect of [0, 0, group.width, group.height], which
      // is probably weird for users. Should we make a break change for it?

      var layoutPos = {};
      var layouted = __WEBPACK_IMPORTED_MODULE_5__util_layout_js__["e" /* positionElement */](el, elOption, containerInfo, null, {
        hv: elOption.hv,
        boundingMode: elOption.bounding
      }, layoutPos);

      if (!inner(el).isNew && layouted) {
        var transition = elOption.transition;
        var animatePos = {};

        for (var k = 0; k < xy.length; k++) {
          var key = xy[k];
          var val = layoutPos[key];

          if (transition && (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__animation_customGraphicTransition_js__["c" /* isTransitionAll */])(transition) || __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["indexOf"](transition, key) >= 0)) {
            animatePos[key] = val;
          } else {
            el[key] = val;
          }
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__animation_basicTrasition_js__["a" /* updateProps */])(el, animatePos, graphicModel, 0);
      } else {
        el.attr(layoutPos);
      }
    }
  };
  /**
   * Clear all elements.
   */


  GraphicComponentView.prototype._clear = function () {
    var _this = this;

    var elMap = this._elMap;
    elMap.each(function (el) {
      removeEl(el, inner(el).option, elMap, _this._lastGraphicModel);
    });
    this._elMap = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"]();
  };

  GraphicComponentView.prototype.dispose = function () {
    this._clear();
  };

  GraphicComponentView.type = 'graphic';
  return GraphicComponentView;
}(__WEBPACK_IMPORTED_MODULE_7__view_Component_js__["a" /* default */]);



function newEl(graphicType) {
  if (true) {
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"](graphicType, 'graphic type MUST be set');
  }

  var Clz = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["hasOwn"](nonShapeGraphicElements, graphicType) // Those graphic elements are not shapes. They should not be
  // overwritten by users, so do them first.
  ? nonShapeGraphicElements[graphicType] : __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["getShapeClass"](graphicType);

  if (true) {
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["assert"](Clz, "graphic type " + graphicType + " can not be found");
  }

  var el = new Clz({});
  inner(el).type = graphicType;
  return el;
}

function createEl(id, targetElParent, graphicType, elMap) {
  var el = newEl(graphicType);
  targetElParent.add(el);
  elMap.set(id, el);
  inner(el).id = id;
  inner(el).isNew = true;
  return el;
}

function removeEl(elExisting, elOption, elMap, graphicModel) {
  var existElParent = elExisting && elExisting.parent;

  if (existElParent) {
    elExisting.type === 'group' && elExisting.traverse(function (el) {
      removeEl(el, elOption, elMap, graphicModel);
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__animation_customGraphicTransition_js__["d" /* applyLeaveTransition */])(elExisting, elOption, graphicModel);
    elMap.removeKey(inner(elExisting).id);
  }
}

function updateCommonAttrs(el, elOption, defaultZ, defaultZlevel) {
  if (!el.isGroup) {
    var elDisplayable = el;
    elDisplayable.cursor = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["retrieve2"](elOption.cursor, __WEBPACK_IMPORTED_MODULE_2_zrender_lib_graphic_Displayable_js__["c" /* default */].prototype.cursor); // We should not support configure z and zlevel in the element level.
    // But seems we didn't limit it previously. So here still use it to avoid breaking.

    elDisplayable.z = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["retrieve2"](elOption.z, defaultZ || 0);
    elDisplayable.zlevel = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["retrieve2"](elOption.zlevel, defaultZlevel || 0); // z2 must not be null/undefined, otherwise sort error may occur.

    var optZ2 = elOption.z2;
    optZ2 != null && (elDisplayable.z2 = optZ2 || 0);
  }

  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["keys"](elOption), function (key) {
    var val = elOption[key]; // Assign event handlers.
    // PENDING: should enumerate all event names or use pattern matching?

    if (key.indexOf('on') === 0 && __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isFunction"](val)) {
      el[key] = val;
    }
  });
  el.draggable = elOption.draggable; // Other attributes

  elOption.name != null && (el.name = elOption.name);
  elOption.id != null && (el.id = elOption.id);
} // Remove unnecessary props to avoid potential problems.


function getCleanedElOption(elOption) {
  elOption = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"]({}, elOption);
  __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](['id', 'parentId', '$action', 'hv', 'bounding', 'textContent', 'clipPath'].concat(__WEBPACK_IMPORTED_MODULE_5__util_layout_js__["g" /* LOCATION_PARAMS */]), function (name) {
    delete elOption[name];
  });
  return elOption;
}

function setEventData(el, graphicModel, elOption) {
  var eventData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_innerStore_js__["a" /* getECData */])(el).eventData; // Simple optimize for large amount of elements that no need event.

  if (!el.silent && !el.ignore && !eventData) {
    eventData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_innerStore_js__["a" /* getECData */])(el).eventData = {
      componentType: 'graphic',
      componentIndex: graphicModel.componentIndex,
      name: el.name
    };
  } // `elOption.info` enables user to mount some info on
  // elements and use them in event handlers.


  if (eventData) {
    eventData.info = elOption.info;
  }
}

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GraphicModel_js__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GraphicView_js__ = __webpack_require__(1229);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



function install(registers) {
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_1__GraphicModel_js__["a" /* GraphicComponentModel */]);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_2__GraphicView_js__["a" /* GraphicComponentView */]);
  registers.registerPreprocessor(function (option) {
    var graphicOption = option.graphic; // Convert
    // {graphic: [{left: 10, type: 'circle'}, ...]}
    // or
    // {graphic: {left: 10, type: 'circle'}}
    // to
    // {graphic: [{elements: [{left: 10, type: 'circle'}, ...]}]}

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"])(graphicOption)) {
      if (!graphicOption[0] || !graphicOption[0].elements) {
        option.graphic = [{
          elements: graphicOption
        }];
      } else {
        // Only one graphic instance can be instantiated. (We dont
        // want that too many views are created in echarts._viewMap)
        option.graphic = [option.graphic[0]];
      }
    } else if (graphicOption && !graphicOption.elements) {
      option.graphic = [{
        elements: [graphicOption]
      }];
    }
  });
}

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__installSimple_js__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axisPointer_install_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extension_js__ = __webpack_require__(41);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



function install(registers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_0__installSimple_js__["a" /* install */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_1__axisPointer_install_js__["a" /* install */]);
}

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LegendModel_js__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_component_js__ = __webpack_require__(49);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var ScrollableLegendModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ScrollableLegendModel, _super);

  function ScrollableLegendModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ScrollableLegendModel.type;
    return _this;
  }
  /**
   * @param {number} scrollDataIndex
   */


  ScrollableLegendModel.prototype.setScrollDataIndex = function (scrollDataIndex) {
    this.option.scrollDataIndex = scrollDataIndex;
  };

  ScrollableLegendModel.prototype.init = function (option, parentModel, ecModel) {
    var inputPositionParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_layout_js__["b" /* getLayoutParams */])(option);

    _super.prototype.init.call(this, option, parentModel, ecModel);

    mergeAndNormalizeLayoutParams(this, option, inputPositionParams);
  };
  /**
   * @override
   */


  ScrollableLegendModel.prototype.mergeOption = function (option, ecModel) {
    _super.prototype.mergeOption.call(this, option, ecModel);

    mergeAndNormalizeLayoutParams(this, this.option, option);
  };

  ScrollableLegendModel.type = 'legend.scroll';
  ScrollableLegendModel.defaultOption = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_component_js__["d" /* inheritDefaultOption */])(__WEBPACK_IMPORTED_MODULE_1__LegendModel_js__["a" /* default */].defaultOption, {
    scrollDataIndex: 0,
    pageButtonItemGap: 5,
    pageButtonGap: null,
    pageButtonPosition: 'end',
    pageFormatter: '{current}/{total}',
    pageIcons: {
      horizontal: ['M0,0L12,-10L12,10z', 'M0,0L-12,-10L-12,10z'],
      vertical: ['M0,0L20,0L10,-20z', 'M0,0L20,0L10,20z']
    },
    pageIconColor: '#2f4554',
    pageIconInactiveColor: '#aaa',
    pageIconSize: 15,
    pageTextStyle: {
      color: '#333'
    },
    animationDurationUpdate: 800
  });
  return ScrollableLegendModel;
}(__WEBPACK_IMPORTED_MODULE_1__LegendModel_js__["a" /* default */]);

; // Do not `ignoreSize` to enable setting {left: 10, right: 10}.

function mergeAndNormalizeLayoutParams(legendModel, target, raw) {
  var orient = legendModel.getOrient();
  var ignoreSize = [1, 1];
  ignoreSize[orient.index] = 0;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_layout_js__["c" /* mergeLayoutParam */])(target, raw, {
    type: 'box',
    ignoreSize: !!ignoreSize
  });
}

/* harmony default export */ __webpack_exports__["a"] = (ScrollableLegendModel);

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LegendView_js__ = __webpack_require__(472);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Separate legend and scrollable legend to reduce package size.
 */





var Group = __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Group"];
var WH = ['width', 'height'];
var XY = ['x', 'y'];

var ScrollableLegendView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ScrollableLegendView, _super);

  function ScrollableLegendView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ScrollableLegendView.type;
    _this.newlineDisabled = true;
    _this._currentIndex = 0;
    return _this;
  }

  ScrollableLegendView.prototype.init = function () {
    _super.prototype.init.call(this);

    this.group.add(this._containerGroup = new Group());

    this._containerGroup.add(this.getContentGroup());

    this.group.add(this._controllerGroup = new Group());
  };
  /**
   * @override
   */


  ScrollableLegendView.prototype.resetInner = function () {
    _super.prototype.resetInner.call(this);

    this._controllerGroup.removeAll();

    this._containerGroup.removeClipPath();

    this._containerGroup.__rectSize = null;
  };
  /**
   * @override
   */


  ScrollableLegendView.prototype.renderInner = function (itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
    var self = this; // Render content items.

    _super.prototype.renderInner.call(this, itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);

    var controllerGroup = this._controllerGroup; // FIXME: support be 'auto' adapt to size number text length,
    // e.g., '3/12345' should not overlap with the control arrow button.

    var pageIconSize = legendModel.get('pageIconSize', true);
    var pageIconSizeArr = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](pageIconSize) ? pageIconSize : [pageIconSize, pageIconSize];
    createPageButton('pagePrev', 0);
    var pageTextStyleModel = legendModel.getModel('pageTextStyle');
    controllerGroup.add(new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Text"]({
      name: 'pageText',
      style: {
        // Placeholder to calculate a proper layout.
        text: 'xx/xx',
        fill: pageTextStyleModel.getTextColor(),
        font: pageTextStyleModel.getFont(),
        verticalAlign: 'middle',
        align: 'center'
      },
      silent: true
    }));
    createPageButton('pageNext', 1);

    function createPageButton(name, iconIdx) {
      var pageDataIndexName = name + 'DataIndex';
      var icon = __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["createIcon"](legendModel.get('pageIcons', true)[legendModel.getOrient().name][iconIdx], {
        // Buttons will be created in each render, so we do not need
        // to worry about avoiding using legendModel kept in scope.
        onclick: __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"](self._pageGo, self, pageDataIndexName, legendModel, api)
      }, {
        x: -pageIconSizeArr[0] / 2,
        y: -pageIconSizeArr[1] / 2,
        width: pageIconSizeArr[0],
        height: pageIconSizeArr[1]
      });
      icon.name = name;
      controllerGroup.add(icon);
    }
  };
  /**
   * @override
   */


  ScrollableLegendView.prototype.layoutInner = function (legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
    var selectorGroup = this.getSelectorGroup();
    var orientIdx = legendModel.getOrient().index;
    var wh = WH[orientIdx];
    var xy = XY[orientIdx];
    var hw = WH[1 - orientIdx];
    var yx = XY[1 - orientIdx];
    selector && __WEBPACK_IMPORTED_MODULE_3__util_layout_js__["d" /* box */]( // Buttons in selectorGroup always layout horizontally
    'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
    var selectorButtonGap = legendModel.get('selectorButtonGap', true);
    var selectorRect = selectorGroup.getBoundingRect();
    var selectorPos = [-selectorRect.x, -selectorRect.y];
    var processMaxSize = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"](maxSize);
    selector && (processMaxSize[wh] = maxSize[wh] - selectorRect[wh] - selectorButtonGap);

    var mainRect = this._layoutContentAndController(legendModel, isFirstRender, processMaxSize, orientIdx, wh, hw, yx, xy);

    if (selector) {
      if (selectorPosition === 'end') {
        selectorPos[orientIdx] += mainRect[wh] + selectorButtonGap;
      } else {
        var offset = selectorRect[wh] + selectorButtonGap;
        selectorPos[orientIdx] -= offset;
        mainRect[xy] -= offset;
      }

      mainRect[wh] += selectorRect[wh] + selectorButtonGap;
      selectorPos[1 - orientIdx] += mainRect[yx] + mainRect[hw] / 2 - selectorRect[hw] / 2;
      mainRect[hw] = Math.max(mainRect[hw], selectorRect[hw]);
      mainRect[yx] = Math.min(mainRect[yx], selectorRect[yx] + selectorPos[1 - orientIdx]);
      selectorGroup.x = selectorPos[0];
      selectorGroup.y = selectorPos[1];
      selectorGroup.markRedraw();
    }

    return mainRect;
  };

  ScrollableLegendView.prototype._layoutContentAndController = function (legendModel, isFirstRender, maxSize, orientIdx, wh, hw, yx, xy) {
    var contentGroup = this.getContentGroup();
    var containerGroup = this._containerGroup;
    var controllerGroup = this._controllerGroup; // Place items in contentGroup.

    __WEBPACK_IMPORTED_MODULE_3__util_layout_js__["d" /* box */](legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
    __WEBPACK_IMPORTED_MODULE_3__util_layout_js__["d" /* box */]( // Buttons in controller are layout always horizontally.
    'horizontal', controllerGroup, legendModel.get('pageButtonItemGap', true));
    var contentRect = contentGroup.getBoundingRect();
    var controllerRect = controllerGroup.getBoundingRect();
    var showController = this._showController = contentRect[wh] > maxSize[wh]; // In case that the inner elements of contentGroup layout do not based on [0, 0]

    var contentPos = [-contentRect.x, -contentRect.y]; // Remain contentPos when scroll animation perfroming.
    // If first rendering, `contentGroup.position` is [0, 0], which
    // does not make sense and may cause unexepcted animation if adopted.

    if (!isFirstRender) {
      contentPos[orientIdx] = contentGroup[xy];
    } // Layout container group based on 0.


    var containerPos = [0, 0];
    var controllerPos = [-controllerRect.x, -controllerRect.y];
    var pageButtonGap = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["retrieve2"](legendModel.get('pageButtonGap', true), legendModel.get('itemGap', true)); // Place containerGroup and controllerGroup and contentGroup.

    if (showController) {
      var pageButtonPosition = legendModel.get('pageButtonPosition', true); // controller is on the right / bottom.

      if (pageButtonPosition === 'end') {
        controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
      } // controller is on the left / top.
      else {
          containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
        }
    } // Always align controller to content as 'middle'.


    controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
    contentGroup.setPosition(contentPos);
    containerGroup.setPosition(containerPos);
    controllerGroup.setPosition(controllerPos); // Calculate `mainRect` and set `clipPath`.
    // mainRect should not be calculated by `this.group.getBoundingRect()`
    // for sake of the overflow.

    var mainRect = {
      x: 0,
      y: 0
    }; // Consider content may be overflow (should be clipped).

    mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
    mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]); // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.

    mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
    containerGroup.__rectSize = maxSize[wh];

    if (showController) {
      var clipShape = {
        x: 0,
        y: 0
      };
      clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
      clipShape[hw] = mainRect[hw];
      containerGroup.setClipPath(new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Rect"]({
        shape: clipShape
      })); // Consider content may be larger than container, container rect
      // can not be obtained from `containerGroup.getBoundingRect()`.

      containerGroup.__rectSize = clipShape[wh];
    } else {
      // Do not remove or ignore controller. Keep them set as placeholders.
      controllerGroup.eachChild(function (child) {
        child.attr({
          invisible: true,
          silent: true
        });
      });
    } // Content translate animation.


    var pageInfo = this._getPageInfo(legendModel);

    pageInfo.pageIndex != null && __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["updateProps"](contentGroup, {
      x: pageInfo.contentPosition[0],
      y: pageInfo.contentPosition[1]
    }, // When switch from "show controller" to "not show controller", view should be
    // updated immediately without animation, otherwise causes weird effect.
    showController ? legendModel : null);

    this._updatePageInfoView(legendModel, pageInfo);

    return mainRect;
  };

  ScrollableLegendView.prototype._pageGo = function (to, legendModel, api) {
    var scrollDataIndex = this._getPageInfo(legendModel)[to];

    scrollDataIndex != null && api.dispatchAction({
      type: 'legendScroll',
      scrollDataIndex: scrollDataIndex,
      legendId: legendModel.id
    });
  };

  ScrollableLegendView.prototype._updatePageInfoView = function (legendModel, pageInfo) {
    var controllerGroup = this._controllerGroup;
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](['pagePrev', 'pageNext'], function (name) {
      var key = name + 'DataIndex';
      var canJump = pageInfo[key] != null;
      var icon = controllerGroup.childOfName(name);

      if (icon) {
        icon.setStyle('fill', canJump ? legendModel.get('pageIconColor', true) : legendModel.get('pageIconInactiveColor', true));
        icon.cursor = canJump ? 'pointer' : 'default';
      }
    });
    var pageText = controllerGroup.childOfName('pageText');
    var pageFormatter = legendModel.get('pageFormatter');
    var pageIndex = pageInfo.pageIndex;
    var current = pageIndex != null ? pageIndex + 1 : 0;
    var total = pageInfo.pageCount;
    pageText && pageFormatter && pageText.setStyle('text', __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"](pageFormatter) ? pageFormatter.replace('{current}', current == null ? '' : current + '').replace('{total}', total == null ? '' : total + '') : pageFormatter({
      current: current,
      total: total
    }));
  };
  /**
   *  contentPosition: Array.<number>, null when data item not found.
   *  pageIndex: number, null when data item not found.
   *  pageCount: number, always be a number, can be 0.
   *  pagePrevDataIndex: number, null when no previous page.
   *  pageNextDataIndex: number, null when no next page.
   * }
   */


  ScrollableLegendView.prototype._getPageInfo = function (legendModel) {
    var scrollDataIndex = legendModel.get('scrollDataIndex', true);
    var contentGroup = this.getContentGroup();
    var containerRectSize = this._containerGroup.__rectSize;
    var orientIdx = legendModel.getOrient().index;
    var wh = WH[orientIdx];
    var xy = XY[orientIdx];

    var targetItemIndex = this._findTargetItemIndex(scrollDataIndex);

    var children = contentGroup.children();
    var targetItem = children[targetItemIndex];
    var itemCount = children.length;
    var pCount = !itemCount ? 0 : 1;
    var result = {
      contentPosition: [contentGroup.x, contentGroup.y],
      pageCount: pCount,
      pageIndex: pCount - 1,
      pagePrevDataIndex: null,
      pageNextDataIndex: null
    };

    if (!targetItem) {
      return result;
    }

    var targetItemInfo = getItemInfo(targetItem);
    result.contentPosition[orientIdx] = -targetItemInfo.s; // Strategy:
    // (1) Always align based on the left/top most item.
    // (2) It is user-friendly that the last item shown in the
    // current window is shown at the begining of next window.
    // Otherwise if half of the last item is cut by the window,
    // it will have no chance to display entirely.
    // (3) Consider that item size probably be different, we
    // have calculate pageIndex by size rather than item index,
    // and we can not get page index directly by division.
    // (4) The window is to narrow to contain more than
    // one item, we should make sure that the page can be fliped.

    for (var i = targetItemIndex + 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i <= itemCount; ++i) {
      currItemInfo = getItemInfo(children[i]);

      if ( // Half of the last item is out of the window.
      !currItemInfo && winEndItemInfo.e > winStartItemInfo.s + containerRectSize || // If the current item does not intersect with the window, the new page
      // can be started at the current item or the last item.
      currItemInfo && !intersect(currItemInfo, winStartItemInfo.s)) {
        if (winEndItemInfo.i > winStartItemInfo.i) {
          winStartItemInfo = winEndItemInfo;
        } else {
          // e.g., when page size is smaller than item size.
          winStartItemInfo = currItemInfo;
        }

        if (winStartItemInfo) {
          if (result.pageNextDataIndex == null) {
            result.pageNextDataIndex = winStartItemInfo.i;
          }

          ++result.pageCount;
        }
      }

      winEndItemInfo = currItemInfo;
    }

    for (var i = targetItemIndex - 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i >= -1; --i) {
      currItemInfo = getItemInfo(children[i]);

      if ( // If the the end item does not intersect with the window started
      // from the current item, a page can be settled.
      (!currItemInfo || !intersect(winEndItemInfo, currItemInfo.s)) && // e.g., when page size is smaller than item size.
      winStartItemInfo.i < winEndItemInfo.i) {
        winEndItemInfo = winStartItemInfo;

        if (result.pagePrevDataIndex == null) {
          result.pagePrevDataIndex = winStartItemInfo.i;
        }

        ++result.pageCount;
        ++result.pageIndex;
      }

      winStartItemInfo = currItemInfo;
    }

    return result;

    function getItemInfo(el) {
      if (el) {
        var itemRect = el.getBoundingRect();
        var start = itemRect[xy] + el[xy];
        return {
          s: start,
          e: start + itemRect[wh],
          i: el.__legendDataIndex
        };
      }
    }

    function intersect(itemInfo, winStart) {
      return itemInfo.e >= winStart && itemInfo.s <= winStart + containerRectSize;
    }
  };

  ScrollableLegendView.prototype._findTargetItemIndex = function (targetDataIndex) {
    if (!this._showController) {
      return 0;
    }

    var index;
    var contentGroup = this.getContentGroup();
    var defaultIndex;
    contentGroup.eachChild(function (child, idx) {
      var legendDataIdx = child.__legendDataIndex; // FIXME
      // If the given targetDataIndex (from model) is illegal,
      // we use defaultIndex. But the index on the legend model and
      // action payload is still illegal. That case will not be
      // changed until some scenario requires.

      if (defaultIndex == null && legendDataIdx != null) {
        defaultIndex = idx;
      }

      if (legendDataIdx === targetDataIndex) {
        index = idx;
      }
    });
    return index != null ? index : defaultIndex;
  };

  ScrollableLegendView.type = 'legend.scroll';
  return ScrollableLegendView;
}(__WEBPACK_IMPORTED_MODULE_4__LegendView_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ScrollableLegendView);

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extension_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__installLegendPlain_js__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__installLegendScroll_js__ = __webpack_require__(473);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



function install(registers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_1__installLegendPlain_js__["a" /* install */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_2__installLegendScroll_js__["a" /* install */]);
}

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = installLegendAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// @ts-nocheck


function legendSelectActionHandler(methodName, payload, ecModel) {
  var selectedMap = {};
  var isToggleSelect = methodName === 'toggleSelected';
  var isSelected; // Update all legend components

  ecModel.eachComponent('legend', function (legendModel) {
    if (isToggleSelect && isSelected != null) {
      // Force other legend has same selected status
      // Or the first is toggled to true and other are toggled to false
      // In the case one legend has some item unSelected in option. And if other legend
      // doesn't has the item, they will assume it is selected.
      legendModel[isSelected ? 'select' : 'unSelect'](payload.name);
    } else if (methodName === 'allSelect' || methodName === 'inverseSelect') {
      legendModel[methodName]();
    } else {
      legendModel[methodName](payload.name);
      isSelected = legendModel.isSelected(payload.name);
    }

    var legendData = legendModel.getData();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(legendData, function (model) {
      var name = model.get('name'); // Wrap element

      if (name === '\n' || name === '') {
        return;
      }

      var isItemSelected = legendModel.isSelected(name);

      if (selectedMap.hasOwnProperty(name)) {
        // Unselected if any legend is unselected
        selectedMap[name] = selectedMap[name] && isItemSelected;
      } else {
        selectedMap[name] = isItemSelected;
      }
    });
  }); // Return the event explicitly

  return methodName === 'allSelect' || methodName === 'inverseSelect' ? {
    selected: selectedMap
  } : {
    name: payload.name,
    selected: selectedMap
  };
}

function installLegendAction(registers) {
  /**
   * @event legendToggleSelect
   * @type {Object}
   * @property {string} type 'legendToggleSelect'
   * @property {string} [from]
   * @property {string} name Series name or data item name
   */
  registers.registerAction('legendToggleSelect', 'legendselectchanged', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["curry"])(legendSelectActionHandler, 'toggleSelected'));
  registers.registerAction('legendAllSelect', 'legendselectall', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["curry"])(legendSelectActionHandler, 'allSelect'));
  registers.registerAction('legendInverseSelect', 'legendinverseselect', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["curry"])(legendSelectActionHandler, 'inverseSelect'));
  /**
   * @event legendSelect
   * @type {Object}
   * @property {string} type 'legendSelect'
   * @property {string} name Series name or data item name
   */

  registers.registerAction('legendSelect', 'legendselected', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["curry"])(legendSelectActionHandler, 'select'));
  /**
   * @event legendUnSelect
   * @type {Object}
   * @property {string} type 'legendUnSelect'
   * @property {string} name Series name or data item name
   */

  registers.registerAction('legendUnSelect', 'legendunselected', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["curry"])(legendSelectActionHandler, 'unSelect'));
}

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = legendFilter;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function legendFilter(ecModel) {
  var legendModels = ecModel.findComponents({
    mainType: 'legend'
  });

  if (legendModels && legendModels.length) {
    ecModel.filterSeries(function (series) {
      // If in any legend component the status is not selected.
      // Because in legend series is assumed selected when it is not in the legend data.
      for (var i = 0; i < legendModels.length; i++) {
        if (!legendModels[i].isSelected(series.name)) {
          return false;
        }
      }

      return true;
    });
  }
}

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = installScrollableLegendAction;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function installScrollableLegendAction(registers) {
  /**
   * @event legendScroll
   * @type {Object}
   * @property {string} type 'legendScroll'
   * @property {string} scrollDataIndex
   */
  registers.registerAction('legendScroll', 'legendscroll', function (payload, ecModel) {
    var scrollDataIndex = payload.scrollDataIndex;
    scrollDataIndex != null && ecModel.eachComponent({
      mainType: 'legend',
      subType: 'scroll',
      query: payload
    }, function (legendModel) {
      legendModel.setScrollDataIndex(scrollDataIndex);
    });
  });
}

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarkerModel_js__ = __webpack_require__(133);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var MarkAreaModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(MarkAreaModel, _super);

  function MarkAreaModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = MarkAreaModel.type;
    return _this;
  }

  MarkAreaModel.prototype.createMarkerModelFromSeries = function (markerOpt, masterMarkerModel, ecModel) {
    return new MarkAreaModel(markerOpt, masterMarkerModel, ecModel);
  };

  MarkAreaModel.type = 'markArea';
  MarkAreaModel.defaultOption = {
    // zlevel: 0,
    // PENDING
    z: 1,
    tooltip: {
      trigger: 'item'
    },
    // markArea should fixed on the coordinate system
    animation: false,
    label: {
      show: true,
      position: 'top'
    },
    itemStyle: {
      // color and borderColor default to use color from series
      // color: 'auto'
      // borderColor: 'auto'
      borderWidth: 0
    },
    emphasis: {
      label: {
        show: true,
        position: 'top'
      }
    }
  };
  return MarkAreaModel;
}(__WEBPACK_IMPORTED_MODULE_1__MarkerModel_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MarkAreaModel);

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_tool_color_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_SeriesData_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__markerHelper_js__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MarkerView_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__coord_CoordinateSystem_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MarkerModel_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__visual_helper_js__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data_helper_dataValueHelper_js__ = __webpack_require__(134);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
 // TODO Optimize on polar
















var inner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_model_js__["a" /* makeInner */])();

var markAreaTransform = function (seriesModel, coordSys, maModel, item) {
  var lt = __WEBPACK_IMPORTED_MODULE_6__markerHelper_js__["a" /* dataTransform */](seriesModel, item[0]);
  var rb = __WEBPACK_IMPORTED_MODULE_6__markerHelper_js__["a" /* dataTransform */](seriesModel, item[1]); // FIXME make sure lt is less than rb

  var ltCoord = lt.coord;
  var rbCoord = rb.coord;
  ltCoord[0] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_util_js__["retrieve"])(ltCoord[0], -Infinity);
  ltCoord[1] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_util_js__["retrieve"])(ltCoord[1], -Infinity);
  rbCoord[0] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_util_js__["retrieve"])(rbCoord[0], Infinity);
  rbCoord[1] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_util_js__["retrieve"])(rbCoord[1], Infinity); // Merge option into one

  var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_util_js__["mergeAll"])([{}, lt, rb]);
  result.coord = [lt.coord, rb.coord];
  result.x0 = lt.x;
  result.y0 = lt.y;
  result.x1 = rb.x;
  result.y1 = rb.y;
  return result;
};

function isInifinity(val) {
  return !isNaN(val) && !isFinite(val);
} // If a markArea has one dim


function ifMarkAreaHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
  var otherDimIndex = 1 - dimIndex;
  return isInifinity(fromCoord[otherDimIndex]) && isInifinity(toCoord[otherDimIndex]);
}

function markAreaFilter(coordSys, item) {
  var fromCoord = item.coord[0];
  var toCoord = item.coord[1];

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__coord_CoordinateSystem_js__["a" /* isCoordinateSystemType */])(coordSys, 'cartesian2d')) {
    // In case
    // {
    //  markArea: {
    //    data: [{ yAxis: 2 }]
    //  }
    // }
    if (fromCoord && toCoord && (ifMarkAreaHasOnlyDim(1, fromCoord, toCoord, coordSys) || ifMarkAreaHasOnlyDim(0, fromCoord, toCoord, coordSys))) {
      return true;
    }
  }

  return __WEBPACK_IMPORTED_MODULE_6__markerHelper_js__["b" /* dataFilter */](coordSys, {
    coord: fromCoord,
    x: item.x0,
    y: item.y0
  }) || __WEBPACK_IMPORTED_MODULE_6__markerHelper_js__["b" /* dataFilter */](coordSys, {
    coord: toCoord,
    x: item.x1,
    y: item.y1
  });
} // dims can be ['x0', 'y0'], ['x1', 'y1'], ['x0', 'y1'], ['x1', 'y0']


function getSingleMarkerEndPoint(data, idx, dims, seriesModel, api) {
  var coordSys = seriesModel.coordinateSystem;
  var itemModel = data.getItemModel(idx);
  var point;
  var xPx = __WEBPACK_IMPORTED_MODULE_3__util_number_js__["a" /* parsePercent */](itemModel.get(dims[0]), api.getWidth());
  var yPx = __WEBPACK_IMPORTED_MODULE_3__util_number_js__["a" /* parsePercent */](itemModel.get(dims[1]), api.getHeight());

  if (!isNaN(xPx) && !isNaN(yPx)) {
    point = [xPx, yPx];
  } else {
    // Chart like bar may have there own marker positioning logic
    if (seriesModel.getMarkerPosition) {
      // Use the getMarkerPoisition
      point = seriesModel.getMarkerPosition(data.getValues(dims, idx));
    } else {
      var x = data.get(dims[0], idx);
      var y = data.get(dims[1], idx);
      var pt = [x, y];
      coordSys.clampData && coordSys.clampData(pt, pt);
      point = coordSys.dataToPoint(pt, true);
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__coord_CoordinateSystem_js__["a" /* isCoordinateSystemType */])(coordSys, 'cartesian2d')) {
      // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
      var xAxis = coordSys.getAxis('x');
      var yAxis = coordSys.getAxis('y');
      var x = data.get(dims[0], idx);
      var y = data.get(dims[1], idx);

      if (isInifinity(x)) {
        point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[dims[0] === 'x0' ? 0 : 1]);
      } else if (isInifinity(y)) {
        point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[dims[1] === 'y0' ? 0 : 1]);
      }
    } // Use x, y if has any


    if (!isNaN(xPx)) {
      point[0] = xPx;
    }

    if (!isNaN(yPx)) {
      point[1] = yPx;
    }
  }

  return point;
}

var dimPermutations = [['x0', 'y0'], ['x1', 'y0'], ['x1', 'y1'], ['x0', 'y1']];

var MarkAreaView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(MarkAreaView, _super);

  function MarkAreaView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = MarkAreaView.type;
    return _this;
  }

  MarkAreaView.prototype.updateTransform = function (markAreaModel, ecModel, api) {
    ecModel.eachSeries(function (seriesModel) {
      var maModel = __WEBPACK_IMPORTED_MODULE_10__MarkerModel_js__["a" /* default */].getMarkerModelFromSeries(seriesModel, 'markArea');

      if (maModel) {
        var areaData_1 = maModel.getData();
        areaData_1.each(function (idx) {
          var points = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_util_js__["map"])(dimPermutations, function (dim) {
            return getSingleMarkerEndPoint(areaData_1, idx, dim, seriesModel, api);
          }); // Layout

          areaData_1.setItemLayout(idx, points);
          var el = areaData_1.getItemGraphicEl(idx);
          el.setShape('points', points);
        });
      }
    }, this);
  };

  MarkAreaView.prototype.renderSeries = function (seriesModel, maModel, ecModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var seriesId = seriesModel.id;
    var seriesData = seriesModel.getData();
    var areaGroupMap = this.markerGroupMap;
    var polygonGroup = areaGroupMap.get(seriesId) || areaGroupMap.set(seriesId, {
      group: new __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["Group"]()
    });
    this.group.add(polygonGroup.group);
    this.markKeep(polygonGroup);
    var areaData = createList(coordSys, seriesModel, maModel); // Line data for tooltip and formatter

    maModel.setData(areaData); // Update visual and layout of line

    areaData.each(function (idx) {
      // Layout
      var points = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_util_js__["map"])(dimPermutations, function (dim) {
        return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
      });
      var xAxisScale = coordSys.getAxis('x').scale;
      var yAxisScale = coordSys.getAxis('y').scale;
      var xAxisExtent = xAxisScale.getExtent();
      var yAxisExtent = yAxisScale.getExtent();
      var xPointExtent = [xAxisScale.parse(areaData.get('x0', idx)), xAxisScale.parse(areaData.get('x1', idx))];
      var yPointExtent = [yAxisScale.parse(areaData.get('y0', idx)), yAxisScale.parse(areaData.get('y1', idx))];
      __WEBPACK_IMPORTED_MODULE_3__util_number_js__["j" /* asc */](xPointExtent);
      __WEBPACK_IMPORTED_MODULE_3__util_number_js__["j" /* asc */](yPointExtent);
      var overlapped = !(xAxisExtent[0] > xPointExtent[1] || xAxisExtent[1] < xPointExtent[0] || yAxisExtent[0] > yPointExtent[1] || yAxisExtent[1] < yPointExtent[0]); // If none of the area is inside coordSys, allClipped is set to be true
      // in layout so that label will not be displayed. See #12591

      var allClipped = !overlapped;
      areaData.setItemLayout(idx, {
        points: points,
        allClipped: allClipped
      });
      var style = areaData.getItemModel(idx).getModel('itemStyle').getItemStyle();
      var color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__visual_helper_js__["a" /* getVisualFromData */])(seriesData, 'color');

      if (!style.fill) {
        style.fill = color;

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_util_js__["isString"])(style.fill)) {
          style.fill = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_tool_color_js__["modifyAlpha"](style.fill, 0.4);
        }
      }

      if (!style.stroke) {
        style.stroke = color;
      } // Visual


      areaData.setItemVisual(idx, 'style', style);
    });
    areaData.diff(inner(polygonGroup).data).add(function (idx) {
      var layout = areaData.getItemLayout(idx);

      if (!layout.allClipped) {
        var polygon = new __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["Polygon"]({
          shape: {
            points: layout.points
          }
        });
        areaData.setItemGraphicEl(idx, polygon);
        polygonGroup.group.add(polygon);
      }
    }).update(function (newIdx, oldIdx) {
      var polygon = inner(polygonGroup).data.getItemGraphicEl(oldIdx);
      var layout = areaData.getItemLayout(newIdx);

      if (!layout.allClipped) {
        if (polygon) {
          __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["updateProps"](polygon, {
            shape: {
              points: layout.points
            }
          }, maModel, newIdx);
        } else {
          polygon = new __WEBPACK_IMPORTED_MODULE_4__util_graphic_js__["Polygon"]({
            shape: {
              points: layout.points
            }
          });
        }

        areaData.setItemGraphicEl(newIdx, polygon);
        polygonGroup.group.add(polygon);
      } else if (polygon) {
        polygonGroup.group.remove(polygon);
      }
    }).remove(function (idx) {
      var polygon = inner(polygonGroup).data.getItemGraphicEl(idx);
      polygonGroup.group.remove(polygon);
    }).execute();
    areaData.eachItemGraphicEl(function (polygon, idx) {
      var itemModel = areaData.getItemModel(idx);
      var style = areaData.getItemVisual(idx, 'style');
      polygon.useStyle(areaData.getItemVisual(idx, 'style'));
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__label_labelStyle_js__["e" /* setLabelStyle */])(polygon, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__label_labelStyle_js__["f" /* getLabelStatesModels */])(itemModel), {
        labelFetcher: maModel,
        labelDataIndex: idx,
        defaultText: areaData.getName(idx) || '',
        inheritColor: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_util_js__["isString"])(style.fill) ? __WEBPACK_IMPORTED_MODULE_1_zrender_lib_tool_color_js__["modifyAlpha"](style.fill, 1) : '#000'
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_states_js__["F" /* setStatesStylesFromModel */])(polygon, itemModel);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_states_js__["G" /* toggleHoverEmphasis */])(polygon, null, null, itemModel.get(['emphasis', 'disabled']));
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_innerStore_js__["a" /* getECData */])(polygon).dataModel = maModel;
    });
    inner(polygonGroup).data = areaData;
    polygonGroup.group.silent = maModel.get('silent') || seriesModel.get('silent');
  };

  MarkAreaView.type = 'markArea';
  return MarkAreaView;
}(__WEBPACK_IMPORTED_MODULE_7__MarkerView_js__["a" /* default */]);

function createList(coordSys, seriesModel, maModel) {
  var areaData;
  var dataDims;
  var dims = ['x0', 'y0', 'x1', 'y1'];

  if (coordSys) {
    var coordDimsInfos_1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_util_js__["map"])(coordSys && coordSys.dimensions, function (coordDim) {
      var data = seriesModel.getData();
      var info = data.getDimensionInfo(data.mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_util_js__["extend"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_util_js__["extend"])({}, info), {
        name: coordDim,
        // DON'T use ordinalMeta to parse and collect ordinal.
        ordinalMeta: null
      });
    });
    dataDims = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_util_js__["map"])(dims, function (dim, idx) {
      return {
        name: dim,
        type: coordDimsInfos_1[idx % 2].type
      };
    });
    areaData = new __WEBPACK_IMPORTED_MODULE_2__data_SeriesData_js__["a" /* default */](dataDims, maModel);
  } else {
    dataDims = [{
      name: 'value',
      type: 'float'
    }];
    areaData = new __WEBPACK_IMPORTED_MODULE_2__data_SeriesData_js__["a" /* default */](dataDims, maModel);
  }

  var optData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_util_js__["map"])(maModel.get('data'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_util_js__["curry"])(markAreaTransform, seriesModel, coordSys, maModel));

  if (coordSys) {
    optData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_util_js__["filter"])(optData, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_util_js__["curry"])(markAreaFilter, coordSys));
  }

  var dimValueGetter = coordSys ? function (item, dimName, dataIndex, dimIndex) {
    // TODO should convert to ParsedValue?
    var rawVal = item.coord[Math.floor(dimIndex / 2)][dimIndex % 2];
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__data_helper_dataValueHelper_js__["b" /* parseDataValue */])(rawVal, dataDims[dimIndex]);
  } : function (item, dimName, dataIndex, dimIndex) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__data_helper_dataValueHelper_js__["b" /* parseDataValue */])(item.value, dataDims[dimIndex]);
  };
  areaData.initData(optData, null, dimValueGetter);
  areaData.hasItemOption = true;
  return areaData;
}

/* harmony default export */ __webpack_exports__["a"] = (MarkAreaView);

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarkerModel_js__ = __webpack_require__(133);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var MarkLineModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(MarkLineModel, _super);

  function MarkLineModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = MarkLineModel.type;
    return _this;
  }

  MarkLineModel.prototype.createMarkerModelFromSeries = function (markerOpt, masterMarkerModel, ecModel) {
    return new MarkLineModel(markerOpt, masterMarkerModel, ecModel);
  };

  MarkLineModel.type = 'markLine';
  MarkLineModel.defaultOption = {
    // zlevel: 0,
    z: 5,
    symbol: ['circle', 'arrow'],
    symbolSize: [8, 16],
    //symbolRotate: 0,
    symbolOffset: 0,
    precision: 2,
    tooltip: {
      trigger: 'item'
    },
    label: {
      show: true,
      position: 'end',
      distance: 5
    },
    lineStyle: {
      type: 'dashed'
    },
    emphasis: {
      label: {
        show: true
      },
      lineStyle: {
        width: 3
      }
    },
    animationEasing: 'linear'
  };
  return MarkLineModel;
}(__WEBPACK_IMPORTED_MODULE_1__MarkerModel_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MarkLineModel);

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_SeriesData_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__markerHelper_js__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chart_helper_LineDraw_js__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MarkerView_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_helper_dataStackHelper_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__coord_CoordinateSystem_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MarkerModel_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__visual_helper_js__ = __webpack_require__(162);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/













var inner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_model_js__["a" /* makeInner */])();

var markLineTransform = function (seriesModel, coordSys, mlModel, item) {
  var data = seriesModel.getData();
  var itemArray;

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["isArray"])(item)) {
    // Special type markLine like 'min', 'max', 'average', 'median'
    var mlType = item.type;

    if (mlType === 'min' || mlType === 'max' || mlType === 'average' || mlType === 'median' // In case
    // data: [{
    //   yAxis: 10
    // }]
    || item.xAxis != null || item.yAxis != null) {
      var valueAxis = void 0;
      var value = void 0;

      if (item.yAxis != null || item.xAxis != null) {
        valueAxis = coordSys.getAxis(item.yAxis != null ? 'y' : 'x');
        value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["retrieve"])(item.yAxis, item.xAxis);
      } else {
        var axisInfo = __WEBPACK_IMPORTED_MODULE_3__markerHelper_js__["c" /* getAxisInfo */](item, data, coordSys, seriesModel);
        valueAxis = axisInfo.valueAxis;
        var valueDataDim = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__data_helper_dataStackHelper_js__["a" /* getStackedDimension */])(data, axisInfo.valueDataDim);
        value = __WEBPACK_IMPORTED_MODULE_3__markerHelper_js__["d" /* numCalculate */](data, valueDataDim, mlType);
      }

      var valueIndex = valueAxis.dim === 'x' ? 0 : 1;
      var baseIndex = 1 - valueIndex; // Normized to 2d data with start and end point

      var mlFrom = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["clone"])(item);
      var mlTo = {
        coord: []
      };
      mlFrom.type = null;
      mlFrom.coord = [];
      mlFrom.coord[baseIndex] = -Infinity;
      mlTo.coord[baseIndex] = Infinity;
      var precision = mlModel.get('precision');

      if (precision >= 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["isNumber"])(value)) {
        value = +value.toFixed(Math.min(precision, 20));
      }

      mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
      itemArray = [mlFrom, mlTo, {
        type: mlType,
        valueIndex: item.valueIndex,
        // Force to use the value of calculated value.
        value: value
      }];
    } else {
      // Invalid data
      if (true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["logError"])('Invalid markLine data.');
      }

      itemArray = [];
    }
  } else {
    itemArray = item;
  }

  var normalizedItem = [__WEBPACK_IMPORTED_MODULE_3__markerHelper_js__["a" /* dataTransform */](seriesModel, itemArray[0]), __WEBPACK_IMPORTED_MODULE_3__markerHelper_js__["a" /* dataTransform */](seriesModel, itemArray[1]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["extend"])({}, itemArray[2])]; // Avoid line data type is extended by from(to) data type

  normalizedItem[2].type = normalizedItem[2].type || null; // Merge from option and to option into line option

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["merge"])(normalizedItem[2], normalizedItem[0]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["merge"])(normalizedItem[2], normalizedItem[1]);
  return normalizedItem;
};

function isInifinity(val) {
  return !isNaN(val) && !isFinite(val);
} // If a markLine has one dim


function ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
  var otherDimIndex = 1 - dimIndex;
  var dimName = coordSys.dimensions[dimIndex];
  return isInifinity(fromCoord[otherDimIndex]) && isInifinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
}

function markLineFilter(coordSys, item) {
  if (coordSys.type === 'cartesian2d') {
    var fromCoord = item[0].coord;
    var toCoord = item[1].coord; // In case
    // {
    //  markLine: {
    //    data: [{ yAxis: 2 }]
    //  }
    // }

    if (fromCoord && toCoord && (ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) {
      return true;
    }
  }

  return __WEBPACK_IMPORTED_MODULE_3__markerHelper_js__["b" /* dataFilter */](coordSys, item[0]) && __WEBPACK_IMPORTED_MODULE_3__markerHelper_js__["b" /* dataFilter */](coordSys, item[1]);
}

function updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
  var coordSys = seriesModel.coordinateSystem;
  var itemModel = data.getItemModel(idx);
  var point;
  var xPx = __WEBPACK_IMPORTED_MODULE_2__util_number_js__["a" /* parsePercent */](itemModel.get('x'), api.getWidth());
  var yPx = __WEBPACK_IMPORTED_MODULE_2__util_number_js__["a" /* parsePercent */](itemModel.get('y'), api.getHeight());

  if (!isNaN(xPx) && !isNaN(yPx)) {
    point = [xPx, yPx];
  } else {
    // Chart like bar may have there own marker positioning logic
    if (seriesModel.getMarkerPosition) {
      // Use the getMarkerPoisition
      point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
    } else {
      var dims = coordSys.dimensions;
      var x = data.get(dims[0], idx);
      var y = data.get(dims[1], idx);
      point = coordSys.dataToPoint([x, y]);
    } // Expand line to the edge of grid if value on one axis is Inifnity
    // In case
    //  markLine: {
    //    data: [{
    //      yAxis: 2
    //      // or
    //      type: 'average'
    //    }]
    //  }


    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__coord_CoordinateSystem_js__["a" /* isCoordinateSystemType */])(coordSys, 'cartesian2d')) {
      // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
      var xAxis = coordSys.getAxis('x');
      var yAxis = coordSys.getAxis('y');
      var dims = coordSys.dimensions;

      if (isInifinity(data.get(dims[0], idx))) {
        point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
      } else if (isInifinity(data.get(dims[1], idx))) {
        point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
      }
    } // Use x, y if has any


    if (!isNaN(xPx)) {
      point[0] = xPx;
    }

    if (!isNaN(yPx)) {
      point[1] = yPx;
    }
  }

  data.setItemLayout(idx, point);
}

var MarkLineView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(MarkLineView, _super);

  function MarkLineView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = MarkLineView.type;
    return _this;
  }

  MarkLineView.prototype.updateTransform = function (markLineModel, ecModel, api) {
    ecModel.eachSeries(function (seriesModel) {
      var mlModel = __WEBPACK_IMPORTED_MODULE_9__MarkerModel_js__["a" /* default */].getMarkerModelFromSeries(seriesModel, 'markLine');

      if (mlModel) {
        var mlData_1 = mlModel.getData();
        var fromData_1 = inner(mlModel).from;
        var toData_1 = inner(mlModel).to; // Update visual and layout of from symbol and to symbol

        fromData_1.each(function (idx) {
          updateSingleMarkerEndLayout(fromData_1, idx, true, seriesModel, api);
          updateSingleMarkerEndLayout(toData_1, idx, false, seriesModel, api);
        }); // Update layout of line

        mlData_1.each(function (idx) {
          mlData_1.setItemLayout(idx, [fromData_1.getItemLayout(idx), toData_1.getItemLayout(idx)]);
        });
        this.markerGroupMap.get(seriesModel.id).updateLayout();
      }
    }, this);
  };

  MarkLineView.prototype.renderSeries = function (seriesModel, mlModel, ecModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var seriesId = seriesModel.id;
    var seriesData = seriesModel.getData();
    var lineDrawMap = this.markerGroupMap;
    var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new __WEBPACK_IMPORTED_MODULE_4__chart_helper_LineDraw_js__["a" /* default */]());
    this.group.add(lineDraw.group);
    var mlData = createList(coordSys, seriesModel, mlModel);
    var fromData = mlData.from;
    var toData = mlData.to;
    var lineData = mlData.line;
    inner(mlModel).from = fromData;
    inner(mlModel).to = toData; // Line data for tooltip and formatter

    mlModel.setData(lineData); // TODO
    // Functionally, `symbolSize` & `symbolOffset` can also be 2D array now.
    // But the related logic and type definition are not finished yet.
    // Finish it if required

    var symbolType = mlModel.get('symbol');
    var symbolSize = mlModel.get('symbolSize');
    var symbolRotate = mlModel.get('symbolRotate');
    var symbolOffset = mlModel.get('symbolOffset'); // TODO: support callback function like markPoint

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["isArray"])(symbolType)) {
      symbolType = [symbolType, symbolType];
    }

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["isArray"])(symbolSize)) {
      symbolSize = [symbolSize, symbolSize];
    }

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["isArray"])(symbolRotate)) {
      symbolRotate = [symbolRotate, symbolRotate];
    }

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["isArray"])(symbolOffset)) {
      symbolOffset = [symbolOffset, symbolOffset];
    } // Update visual and layout of from symbol and to symbol


    mlData.from.each(function (idx) {
      updateDataVisualAndLayout(fromData, idx, true);
      updateDataVisualAndLayout(toData, idx, false);
    }); // Update visual and layout of line

    lineData.each(function (idx) {
      var lineStyle = lineData.getItemModel(idx).getModel('lineStyle').getLineStyle(); // lineData.setItemVisual(idx, {
      //     color: lineColor || fromData.getItemVisual(idx, 'color')
      // });

      lineData.setItemLayout(idx, [fromData.getItemLayout(idx), toData.getItemLayout(idx)]);

      if (lineStyle.stroke == null) {
        lineStyle.stroke = fromData.getItemVisual(idx, 'style').fill;
      }

      lineData.setItemVisual(idx, {
        fromSymbolKeepAspect: fromData.getItemVisual(idx, 'symbolKeepAspect'),
        fromSymbolOffset: fromData.getItemVisual(idx, 'symbolOffset'),
        fromSymbolRotate: fromData.getItemVisual(idx, 'symbolRotate'),
        fromSymbolSize: fromData.getItemVisual(idx, 'symbolSize'),
        fromSymbol: fromData.getItemVisual(idx, 'symbol'),
        toSymbolKeepAspect: toData.getItemVisual(idx, 'symbolKeepAspect'),
        toSymbolOffset: toData.getItemVisual(idx, 'symbolOffset'),
        toSymbolRotate: toData.getItemVisual(idx, 'symbolRotate'),
        toSymbolSize: toData.getItemVisual(idx, 'symbolSize'),
        toSymbol: toData.getItemVisual(idx, 'symbol'),
        style: lineStyle
      });
    });
    lineDraw.updateData(lineData); // Set host model for tooltip
    // FIXME

    mlData.line.eachItemGraphicEl(function (el, idx) {
      el.traverse(function (child) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_innerStore_js__["a" /* getECData */])(child).dataModel = mlModel;
      });
    });

    function updateDataVisualAndLayout(data, idx, isFrom) {
      var itemModel = data.getItemModel(idx);
      updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
      var style = itemModel.getModel('itemStyle').getItemStyle();

      if (style.fill == null) {
        style.fill = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__visual_helper_js__["a" /* getVisualFromData */])(seriesData, 'color');
      }

      data.setItemVisual(idx, {
        symbolKeepAspect: itemModel.get('symbolKeepAspect'),
        // `0` should be considered as a valid value, so use `retrieve2` instead of `||`
        symbolOffset: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["retrieve2"])(itemModel.get('symbolOffset', true), symbolOffset[isFrom ? 0 : 1]),
        symbolRotate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["retrieve2"])(itemModel.get('symbolRotate', true), symbolRotate[isFrom ? 0 : 1]),
        // TODO: when 2d array is supported, it should ignore parent
        symbolSize: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["retrieve2"])(itemModel.get('symbolSize'), symbolSize[isFrom ? 0 : 1]),
        symbol: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["retrieve2"])(itemModel.get('symbol', true), symbolType[isFrom ? 0 : 1]),
        style: style
      });
    }

    this.markKeep(lineDraw);
    lineDraw.group.silent = mlModel.get('silent') || seriesModel.get('silent');
  };

  MarkLineView.type = 'markLine';
  return MarkLineView;
}(__WEBPACK_IMPORTED_MODULE_5__MarkerView_js__["a" /* default */]);

function createList(coordSys, seriesModel, mlModel) {
  var coordDimsInfos;

  if (coordSys) {
    coordDimsInfos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["map"])(coordSys && coordSys.dimensions, function (coordDim) {
      var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["extend"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["extend"])({}, info), {
        name: coordDim,
        // DON'T use ordinalMeta to parse and collect ordinal.
        ordinalMeta: null
      });
    });
  } else {
    coordDimsInfos = [{
      name: 'value',
      type: 'float'
    }];
  }

  var fromData = new __WEBPACK_IMPORTED_MODULE_1__data_SeriesData_js__["a" /* default */](coordDimsInfos, mlModel);
  var toData = new __WEBPACK_IMPORTED_MODULE_1__data_SeriesData_js__["a" /* default */](coordDimsInfos, mlModel); // No dimensions

  var lineData = new __WEBPACK_IMPORTED_MODULE_1__data_SeriesData_js__["a" /* default */]([], mlModel);
  var optData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["map"])(mlModel.get('data'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["curry"])(markLineTransform, seriesModel, coordSys, mlModel));

  if (coordSys) {
    optData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["filter"])(optData, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["curry"])(markLineFilter, coordSys));
  }

  var dimValueGetter = __WEBPACK_IMPORTED_MODULE_3__markerHelper_js__["e" /* createMarkerDimValueGetter */](!!coordSys, coordDimsInfos);
  fromData.initData(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["map"])(optData, function (item) {
    return item[0];
  }), null, dimValueGetter);
  toData.initData(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["map"])(optData, function (item) {
    return item[1];
  }), null, dimValueGetter);
  lineData.initData(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["map"])(optData, function (item) {
    return item[2];
  }));
  lineData.hasItemOption = true;
  return {
    from: fromData,
    to: toData,
    line: lineData
  };
}

/* harmony default export */ __webpack_exports__["a"] = (MarkLineView);

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarkerModel_js__ = __webpack_require__(133);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var MarkPointModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(MarkPointModel, _super);

  function MarkPointModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = MarkPointModel.type;
    return _this;
  }

  MarkPointModel.prototype.createMarkerModelFromSeries = function (markerOpt, masterMarkerModel, ecModel) {
    return new MarkPointModel(markerOpt, masterMarkerModel, ecModel);
  };

  MarkPointModel.type = 'markPoint';
  MarkPointModel.defaultOption = {
    // zlevel: 0,
    z: 5,
    symbol: 'pin',
    symbolSize: 50,
    //symbolRotate: 0,
    //symbolOffset: [0, 0]
    tooltip: {
      trigger: 'item'
    },
    label: {
      show: true,
      position: 'inside'
    },
    itemStyle: {
      borderWidth: 2
    },
    emphasis: {
      label: {
        show: true
      }
    }
  };
  return MarkPointModel;
}(__WEBPACK_IMPORTED_MODULE_1__MarkerModel_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MarkPointModel);

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart_helper_SymbolDraw_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_SeriesData_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__markerHelper_js__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MarkerView_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MarkerModel_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__visual_helper_js__ = __webpack_require__(162);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/











function updateMarkerLayout(mpData, seriesModel, api) {
  var coordSys = seriesModel.coordinateSystem;
  mpData.each(function (idx) {
    var itemModel = mpData.getItemModel(idx);
    var point;
    var xPx = __WEBPACK_IMPORTED_MODULE_2__util_number_js__["a" /* parsePercent */](itemModel.get('x'), api.getWidth());
    var yPx = __WEBPACK_IMPORTED_MODULE_2__util_number_js__["a" /* parsePercent */](itemModel.get('y'), api.getHeight());

    if (!isNaN(xPx) && !isNaN(yPx)) {
      point = [xPx, yPx];
    } // Chart like bar may have there own marker positioning logic
    else if (seriesModel.getMarkerPosition) {
        // Use the getMarkerPoisition
        point = seriesModel.getMarkerPosition(mpData.getValues(mpData.dimensions, idx));
      } else if (coordSys) {
        var x = mpData.get(coordSys.dimensions[0], idx);
        var y = mpData.get(coordSys.dimensions[1], idx);
        point = coordSys.dataToPoint([x, y]);
      } // Use x, y if has any


    if (!isNaN(xPx)) {
      point[0] = xPx;
    }

    if (!isNaN(yPx)) {
      point[1] = yPx;
    }

    mpData.setItemLayout(idx, point);
  });
}

var MarkPointView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(MarkPointView, _super);

  function MarkPointView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = MarkPointView.type;
    return _this;
  }

  MarkPointView.prototype.updateTransform = function (markPointModel, ecModel, api) {
    ecModel.eachSeries(function (seriesModel) {
      var mpModel = __WEBPACK_IMPORTED_MODULE_6__MarkerModel_js__["a" /* default */].getMarkerModelFromSeries(seriesModel, 'markPoint');

      if (mpModel) {
        updateMarkerLayout(mpModel.getData(), seriesModel, api);
        this.markerGroupMap.get(seriesModel.id).updateLayout();
      }
    }, this);
  };

  MarkPointView.prototype.renderSeries = function (seriesModel, mpModel, ecModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var seriesId = seriesModel.id;
    var seriesData = seriesModel.getData();
    var symbolDrawMap = this.markerGroupMap;
    var symbolDraw = symbolDrawMap.get(seriesId) || symbolDrawMap.set(seriesId, new __WEBPACK_IMPORTED_MODULE_1__chart_helper_SymbolDraw_js__["a" /* default */]());
    var mpData = createData(coordSys, seriesModel, mpModel); // FIXME

    mpModel.setData(mpData);
    updateMarkerLayout(mpModel.getData(), seriesModel, api);
    mpData.each(function (idx) {
      var itemModel = mpData.getItemModel(idx);
      var symbol = itemModel.getShallow('symbol');
      var symbolSize = itemModel.getShallow('symbolSize');
      var symbolRotate = itemModel.getShallow('symbolRotate');
      var symbolOffset = itemModel.getShallow('symbolOffset');
      var symbolKeepAspect = itemModel.getShallow('symbolKeepAspect'); // TODO: refactor needed: single data item should not support callback function

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_util_js__["isFunction"])(symbol) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_util_js__["isFunction"])(symbolSize) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_util_js__["isFunction"])(symbolRotate) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_util_js__["isFunction"])(symbolOffset)) {
        var rawIdx = mpModel.getRawValue(idx);
        var dataParams = mpModel.getDataParams(idx);

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_util_js__["isFunction"])(symbol)) {
          symbol = symbol(rawIdx, dataParams);
        }

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_util_js__["isFunction"])(symbolSize)) {
          // FIXME 这里不兼容 ECharts 2.x，2.x 貌似参数是整个数据？
          symbolSize = symbolSize(rawIdx, dataParams);
        }

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_util_js__["isFunction"])(symbolRotate)) {
          symbolRotate = symbolRotate(rawIdx, dataParams);
        }

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_util_js__["isFunction"])(symbolOffset)) {
          symbolOffset = symbolOffset(rawIdx, dataParams);
        }
      }

      var style = itemModel.getModel('itemStyle').getItemStyle();
      var color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__visual_helper_js__["a" /* getVisualFromData */])(seriesData, 'color');

      if (!style.fill) {
        style.fill = color;
      }

      mpData.setItemVisual(idx, {
        symbol: symbol,
        symbolSize: symbolSize,
        symbolRotate: symbolRotate,
        symbolOffset: symbolOffset,
        symbolKeepAspect: symbolKeepAspect,
        style: style
      });
    }); // TODO Text are wrong

    symbolDraw.updateData(mpData);
    this.group.add(symbolDraw.group); // Set host model for tooltip
    // FIXME

    mpData.eachItemGraphicEl(function (el) {
      el.traverse(function (child) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_innerStore_js__["a" /* getECData */])(child).dataModel = mpModel;
      });
    });
    this.markKeep(symbolDraw);
    symbolDraw.group.silent = mpModel.get('silent') || seriesModel.get('silent');
  };

  MarkPointView.type = 'markPoint';
  return MarkPointView;
}(__WEBPACK_IMPORTED_MODULE_5__MarkerView_js__["a" /* default */]);

function createData(coordSys, seriesModel, mpModel) {
  var coordDimsInfos;

  if (coordSys) {
    coordDimsInfos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_util_js__["map"])(coordSys && coordSys.dimensions, function (coordDim) {
      var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_util_js__["extend"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_util_js__["extend"])({}, info), {
        name: coordDim,
        // DON'T use ordinalMeta to parse and collect ordinal.
        ordinalMeta: null
      });
    });
  } else {
    coordDimsInfos = [{
      name: 'value',
      type: 'float'
    }];
  }

  var mpData = new __WEBPACK_IMPORTED_MODULE_3__data_SeriesData_js__["a" /* default */](coordDimsInfos, mpModel);
  var dataOpt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_util_js__["map"])(mpModel.get('data'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_util_js__["curry"])(__WEBPACK_IMPORTED_MODULE_4__markerHelper_js__["a" /* dataTransform */], seriesModel));

  if (coordSys) {
    dataOpt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_util_js__["filter"])(dataOpt, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_util_js__["curry"])(__WEBPACK_IMPORTED_MODULE_4__markerHelper_js__["b" /* dataFilter */], coordSys));
  }

  var dimValueGetter = __WEBPACK_IMPORTED_MODULE_4__markerHelper_js__["e" /* createMarkerDimValueGetter */](!!coordSys, coordDimsInfos);
  mpData.initData(dataOpt, null, dimValueGetter);
  return mpData;
}

/* harmony default export */ __webpack_exports__["a"] = (MarkPointView);

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__checkMarkerInSeries_js__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarkAreaModel_js__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MarkAreaView_js__ = __webpack_require__(1239);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



function install(registers) {
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_1__MarkAreaModel_js__["a" /* default */]);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_2__MarkAreaView_js__["a" /* default */]);
  registers.registerPreprocessor(function (opt) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__checkMarkerInSeries_js__["a" /* default */])(opt.series, 'markArea')) {
      // Make sure markArea component is enabled
      opt.markArea = opt.markArea || {};
    }
  });
}

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__checkMarkerInSeries_js__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarkLineModel_js__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MarkLineView_js__ = __webpack_require__(1241);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */




function install(registers) {
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_1__MarkLineModel_js__["a" /* default */]);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_2__MarkLineView_js__["a" /* default */]);
  registers.registerPreprocessor(function (opt) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__checkMarkerInSeries_js__["a" /* default */])(opt.series, 'markLine')) {
      // Make sure markLine component is enabled
      opt.markLine = opt.markLine || {};
    }
  });
}

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__checkMarkerInSeries_js__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarkPointModel_js__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MarkPointView_js__ = __webpack_require__(1243);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */




function install(registers) {
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_1__MarkPointModel_js__["a" /* default */]);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_2__MarkPointView_js__["a" /* default */]);
  registers.registerPreprocessor(function (opt) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__checkMarkerInSeries_js__["a" /* default */])(opt.series, 'markPoint')) {
      // Make sure markPoint component is enabled
      opt.markPoint = opt.markPoint || {};
    }
  });
}

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_Component_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_throttle_js__ = __webpack_require__(100);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var CLICK_THRESHOLD = 5; // > 4

var ParallelView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ParallelView, _super);

  function ParallelView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ParallelView.type;
    return _this;
  }

  ParallelView.prototype.render = function (parallelModel, ecModel, api) {
    this._model = parallelModel;
    this._api = api;

    if (!this._handlers) {
      this._handlers = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(handlers, function (handler, eventName) {
        api.getZr().on(eventName, this._handlers[eventName] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["bind"])(handler, this));
      }, this);
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_throttle_js__["a" /* createOrUpdate */])(this, '_throttledDispatchExpand', parallelModel.get('axisExpandRate'), 'fixRate');
  };

  ParallelView.prototype.dispose = function (ecModel, api) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_throttle_js__["b" /* clear */])(this, '_throttledDispatchExpand');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(this._handlers, function (handler, eventName) {
      api.getZr().off(eventName, handler);
    });
    this._handlers = null;
  };
  /**
   * @internal
   * @param {Object} [opt] If null, cancle the last action triggering for debounce.
   */


  ParallelView.prototype._throttledDispatchExpand = function (opt) {
    this._dispatchExpand(opt);
  };
  /**
   * @internal
   */


  ParallelView.prototype._dispatchExpand = function (opt) {
    opt && this._api.dispatchAction(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["extend"])({
      type: 'parallelAxisExpand'
    }, opt));
  };

  ParallelView.type = 'parallel';
  return ParallelView;
}(__WEBPACK_IMPORTED_MODULE_1__view_Component_js__["a" /* default */]);

var handlers = {
  mousedown: function (e) {
    if (checkTrigger(this, 'click')) {
      this._mouseDownPoint = [e.offsetX, e.offsetY];
    }
  },
  mouseup: function (e) {
    var mouseDownPoint = this._mouseDownPoint;

    if (checkTrigger(this, 'click') && mouseDownPoint) {
      var point = [e.offsetX, e.offsetY];
      var dist = Math.pow(mouseDownPoint[0] - point[0], 2) + Math.pow(mouseDownPoint[1] - point[1], 2);

      if (dist > CLICK_THRESHOLD) {
        return;
      }

      var result = this._model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);

      result.behavior !== 'none' && this._dispatchExpand({
        axisExpandWindow: result.axisExpandWindow
      });
    }

    this._mouseDownPoint = null;
  },
  mousemove: function (e) {
    // Should do nothing when brushing.
    if (this._mouseDownPoint || !checkTrigger(this, 'mousemove')) {
      return;
    }

    var model = this._model;
    var result = model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);
    var behavior = result.behavior;
    behavior === 'jump' && this._throttledDispatchExpand.debounceNextCall(model.get('axisExpandDebounce'));

    this._throttledDispatchExpand(behavior === 'none' ? null // Cancle the last trigger, in case that mouse slide out of the area quickly.
    : {
      axisExpandWindow: result.axisExpandWindow,
      // Jumping uses animation, and sliding suppresses animation.
      animation: behavior === 'jump' ? null : {
        duration: 0 // Disable animation.

      }
    });
  }
};

function checkTrigger(view, triggerOn) {
  var model = view._model;
  return model.get('axisExpandable') && model.get('axisExpandTriggerOn') === triggerOn;
}

/* harmony default export */ __webpack_exports__["a"] = (ParallelView);

/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extension_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axis_AxisView_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axisPointer_PolarAxisPointer_js__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__axisPointer_install_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__coord_polar_PolarModel_js__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__coord_axisModelCreator_js__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__coord_polar_AxisModel_js__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__coord_polar_polarCreator_js__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__axis_AngleAxisView_js__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__axis_RadiusAxisView_js__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__view_Component_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__layout_barPolar_js__ = __webpack_require__(1345);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/














var angleAxisExtraOption = {
  startAngle: 90,
  clockwise: true,
  splitNumber: 12,
  axisLabel: {
    rotate: 0
  }
};
var radiusAxisExtraOption = {
  splitNumber: 5
};

var PolarView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(PolarView, _super);

  function PolarView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = PolarView.type;
    return _this;
  }

  PolarView.type = 'polar';
  return PolarView;
}(__WEBPACK_IMPORTED_MODULE_11__view_Component_js__["a" /* default */]);

function install(registers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_4__axisPointer_install_js__["a" /* install */]);
  __WEBPACK_IMPORTED_MODULE_2__axis_AxisView_js__["a" /* default */].registerAxisPointerClass('PolarAxisPointer', __WEBPACK_IMPORTED_MODULE_3__axisPointer_PolarAxisPointer_js__["a" /* default */]);
  registers.registerCoordinateSystem('polar', __WEBPACK_IMPORTED_MODULE_8__coord_polar_polarCreator_js__["a" /* default */]);
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_5__coord_polar_PolarModel_js__["a" /* default */]);
  registers.registerComponentView(PolarView); // Model and view for angleAxis and radiusAxis

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__coord_axisModelCreator_js__["a" /* default */])(registers, 'angle', __WEBPACK_IMPORTED_MODULE_7__coord_polar_AxisModel_js__["a" /* AngleAxisModel */], angleAxisExtraOption);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__coord_axisModelCreator_js__["a" /* default */])(registers, 'radius', __WEBPACK_IMPORTED_MODULE_7__coord_polar_AxisModel_js__["b" /* RadiusAxisModel */], radiusAxisExtraOption);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_9__axis_AngleAxisView_js__["a" /* default */]);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_10__axis_RadiusAxisView_js__["a" /* default */]);
  registers.registerLayout(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_zrender_lib_core_util_js__["curry"])(__WEBPACK_IMPORTED_MODULE_13__layout_barPolar_js__["a" /* default */], 'bar'));
}

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axis_AxisBuilder_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_Component_js__ = __webpack_require__(30);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];

var RadarView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(RadarView, _super);

  function RadarView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = RadarView.type;
    return _this;
  }

  RadarView.prototype.render = function (radarModel, ecModel, api) {
    var group = this.group;
    group.removeAll();

    this._buildAxes(radarModel);

    this._buildSplitLineAndArea(radarModel);
  };

  RadarView.prototype._buildAxes = function (radarModel) {
    var radar = radarModel.coordinateSystem;
    var indicatorAxes = radar.getIndicatorAxes();
    var axisBuilders = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"](indicatorAxes, function (indicatorAxis) {
      var axisName = indicatorAxis.model.get('showName') ? indicatorAxis.name : ''; // hide name

      var axisBuilder = new __WEBPACK_IMPORTED_MODULE_2__axis_AxisBuilder_js__["a" /* default */](indicatorAxis.model, {
        axisName: axisName,
        position: [radar.cx, radar.cy],
        rotation: indicatorAxis.angle,
        labelDirection: -1,
        tickDirection: -1,
        nameDirection: 1
      });
      return axisBuilder;
    });
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](axisBuilders, function (axisBuilder) {
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](axisBuilderAttrs, axisBuilder.add, axisBuilder);
      this.group.add(axisBuilder.getGroup());
    }, this);
  };

  RadarView.prototype._buildSplitLineAndArea = function (radarModel) {
    var radar = radarModel.coordinateSystem;
    var indicatorAxes = radar.getIndicatorAxes();

    if (!indicatorAxes.length) {
      return;
    }

    var shape = radarModel.get('shape');
    var splitLineModel = radarModel.getModel('splitLine');
    var splitAreaModel = radarModel.getModel('splitArea');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var showSplitLine = splitLineModel.get('show');
    var showSplitArea = splitAreaModel.get('show');
    var splitLineColors = lineStyleModel.get('color');
    var splitAreaColors = areaStyleModel.get('color');
    var splitLineColorsArr = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](splitLineColors) ? splitLineColors : [splitLineColors];
    var splitAreaColorsArr = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](splitAreaColors) ? splitAreaColors : [splitAreaColors];
    var splitLines = [];
    var splitAreas = [];

    function getColorIndex(areaOrLine, areaOrLineColorList, idx) {
      var colorIndex = idx % areaOrLineColorList.length;
      areaOrLine[colorIndex] = areaOrLine[colorIndex] || [];
      return colorIndex;
    }

    if (shape === 'circle') {
      var ticksRadius = indicatorAxes[0].getTicksCoords();
      var cx = radar.cx;
      var cy = radar.cy;

      for (var i = 0; i < ticksRadius.length; i++) {
        if (showSplitLine) {
          var colorIndex = getColorIndex(splitLines, splitLineColorsArr, i);
          splitLines[colorIndex].push(new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Circle"]({
            shape: {
              cx: cx,
              cy: cy,
              r: ticksRadius[i].coord
            }
          }));
        }

        if (showSplitArea && i < ticksRadius.length - 1) {
          var colorIndex = getColorIndex(splitAreas, splitAreaColorsArr, i);
          splitAreas[colorIndex].push(new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Ring"]({
            shape: {
              cx: cx,
              cy: cy,
              r0: ticksRadius[i].coord,
              r: ticksRadius[i + 1].coord
            }
          }));
        }
      }
    } // Polyyon
    else {
        var realSplitNumber_1;
        var axesTicksPoints = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"](indicatorAxes, function (indicatorAxis, idx) {
          var ticksCoords = indicatorAxis.getTicksCoords();
          realSplitNumber_1 = realSplitNumber_1 == null ? ticksCoords.length - 1 : Math.min(ticksCoords.length - 1, realSplitNumber_1);
          return __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"](ticksCoords, function (tickCoord) {
            return radar.coordToPoint(tickCoord.coord, idx);
          });
        });
        var prevPoints = [];

        for (var i = 0; i <= realSplitNumber_1; i++) {
          var points = [];

          for (var j = 0; j < indicatorAxes.length; j++) {
            points.push(axesTicksPoints[j][i]);
          } // Close


          if (points[0]) {
            points.push(points[0].slice());
          } else {
            if (true) {
              console.error('Can\'t draw value axis ' + i);
            }
          }

          if (showSplitLine) {
            var colorIndex = getColorIndex(splitLines, splitLineColorsArr, i);
            splitLines[colorIndex].push(new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Polyline"]({
              shape: {
                points: points
              }
            }));
          }

          if (showSplitArea && prevPoints) {
            var colorIndex = getColorIndex(splitAreas, splitAreaColorsArr, i - 1);
            splitAreas[colorIndex].push(new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Polygon"]({
              shape: {
                points: points.concat(prevPoints)
              }
            }));
          }

          prevPoints = points.slice().reverse();
        }
      }

    var lineStyle = lineStyleModel.getLineStyle();
    var areaStyle = areaStyleModel.getAreaStyle(); // Add splitArea before splitLine

    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](splitAreas, function (splitAreas, idx) {
      this.group.add(__WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["mergePath"](splitAreas, {
        style: __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"]({
          stroke: 'none',
          fill: splitAreaColorsArr[idx % splitAreaColorsArr.length]
        }, areaStyle),
        silent: true
      }));
    }, this);
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](splitLines, function (splitLines, idx) {
      this.group.add(__WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["mergePath"](splitLines, {
        style: __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"]({
          fill: 'none',
          stroke: splitLineColorsArr[idx % splitLineColorsArr.length]
        }, lineStyle),
        silent: true
      }));
    }, this);
  };

  RadarView.type = 'radar';
  return RadarView;
}(__WEBPACK_IMPORTED_MODULE_4__view_Component_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (RadarView);

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extension_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_Component_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axis_SingleAxisView_js__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__coord_axisModelCreator_js__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__coord_single_AxisModel_js__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__coord_single_singleCreator_js__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__axisPointer_install_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__axis_AxisView_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__axisPointer_SingleAxisPointer_js__ = __webpack_require__(1206);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/











var SingleView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(SingleView, _super);

  function SingleView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SingleView.type;
    return _this;
  }

  SingleView.type = 'single';
  return SingleView;
}(__WEBPACK_IMPORTED_MODULE_2__view_Component_js__["a" /* default */]);

function install(registers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_7__axisPointer_install_js__["a" /* install */]);
  __WEBPACK_IMPORTED_MODULE_8__axis_AxisView_js__["a" /* default */].registerAxisPointerClass('SingleAxisPointer', __WEBPACK_IMPORTED_MODULE_9__axisPointer_SingleAxisPointer_js__["a" /* default */]);
  registers.registerComponentView(SingleView); // Axis

  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_3__axis_SingleAxisView_js__["a" /* default */]);
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_5__coord_single_AxisModel_js__["a" /* default */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__coord_axisModelCreator_js__["a" /* default */])(registers, 'single', __WEBPACK_IMPORTED_MODULE_5__coord_single_AxisModel_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__coord_single_AxisModel_js__["a" /* default */].defaultOption);
  registers.registerCoordinateSystem('single', __WEBPACK_IMPORTED_MODULE_6__coord_single_singleCreator_js__["a" /* default */]);
}

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TimelineModel_js__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_mixin_dataFormat_js__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_component_js__ = __webpack_require__(49);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






var SliderTimelineModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(SliderTimelineModel, _super);

  function SliderTimelineModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SliderTimelineModel.type;
    return _this;
  }

  SliderTimelineModel.type = 'timeline.slider';
  /**
   * @protected
   */

  SliderTimelineModel.defaultOption = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_component_js__["d" /* inheritDefaultOption */])(__WEBPACK_IMPORTED_MODULE_1__TimelineModel_js__["a" /* default */].defaultOption, {
    backgroundColor: 'rgba(0,0,0,0)',
    borderColor: '#ccc',
    borderWidth: 0,
    orient: 'horizontal',
    inverse: false,
    tooltip: {
      trigger: 'item' // data item may also have tootip attr.

    },
    symbol: 'circle',
    symbolSize: 12,
    lineStyle: {
      show: true,
      width: 2,
      color: '#DAE1F5'
    },
    label: {
      position: 'auto',
      // When using number, label position is not
      // restricted by viewRect.
      // positive: right/bottom, negative: left/top
      show: true,
      interval: 'auto',
      rotate: 0,
      // formatter: null,
      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
      color: '#A4B1D7'
    },
    itemStyle: {
      color: '#A4B1D7',
      borderWidth: 1
    },
    checkpointStyle: {
      symbol: 'circle',
      symbolSize: 15,
      color: '#316bf3',
      borderColor: '#fff',
      borderWidth: 2,
      shadowBlur: 2,
      shadowOffsetX: 1,
      shadowOffsetY: 1,
      shadowColor: 'rgba(0, 0, 0, 0.3)',
      // borderColor: 'rgba(194,53,49, 0.5)',
      animation: true,
      animationDuration: 300,
      animationEasing: 'quinticInOut'
    },
    controlStyle: {
      show: true,
      showPlayBtn: true,
      showPrevBtn: true,
      showNextBtn: true,
      itemSize: 24,
      itemGap: 12,
      position: 'left',
      playIcon: 'path://M31.6,53C17.5,53,6,41.5,6,27.4S17.5,1.8,31.6,1.8C45.7,1.8,57.2,13.3,57.2,27.4S45.7,53,31.6,53z M31.6,3.3 C18.4,3.3,7.5,14.1,7.5,27.4c0,13.3,10.8,24.1,24.1,24.1C44.9,51.5,55.7,40.7,55.7,27.4C55.7,14.1,44.9,3.3,31.6,3.3z M24.9,21.3 c0-2.2,1.6-3.1,3.5-2l10.5,6.1c1.899,1.1,1.899,2.9,0,4l-10.5,6.1c-1.9,1.1-3.5,0.2-3.5-2V21.3z',
      stopIcon: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
      // eslint-disable-next-line max-len
      nextIcon: 'M2,18.5A1.52,1.52,0,0,1,.92,18a1.49,1.49,0,0,1,0-2.12L7.81,9.36,1,3.11A1.5,1.5,0,1,1,3,.89l8,7.34a1.48,1.48,0,0,1,.49,1.09,1.51,1.51,0,0,1-.46,1.1L3,18.08A1.5,1.5,0,0,1,2,18.5Z',
      // eslint-disable-next-line max-len
      prevIcon: 'M10,.5A1.52,1.52,0,0,1,11.08,1a1.49,1.49,0,0,1,0,2.12L4.19,9.64,11,15.89a1.5,1.5,0,1,1-2,2.22L1,10.77A1.48,1.48,0,0,1,.5,9.68,1.51,1.51,0,0,1,1,8.58L9,.92A1.5,1.5,0,0,1,10,.5Z',
      prevBtnSize: 18,
      nextBtnSize: 18,
      color: '#A4B1D7',
      borderColor: '#A4B1D7',
      borderWidth: 1
    },
    emphasis: {
      label: {
        show: true,
        // 其余属性默认使用全局文本样式，详见TEXTSTYLE
        color: '#6f778d'
      },
      itemStyle: {
        color: '#316BF3'
      },
      controlStyle: {
        color: '#316BF3',
        borderColor: '#316BF3',
        borderWidth: 2
      }
    },
    progress: {
      lineStyle: {
        color: '#316BF3'
      },
      itemStyle: {
        color: '#316BF3'
      },
      label: {
        color: '#6f778d'
      }
    },
    data: []
  });
  return SliderTimelineModel;
}(__WEBPACK_IMPORTED_MODULE_1__TimelineModel_js__["a" /* default */]);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["mixin"])(SliderTimelineModel, __WEBPACK_IMPORTED_MODULE_2__model_mixin_dataFormat_js__["a" /* DataFormatMixin */].prototype);
/* harmony default export */ __webpack_exports__["a"] = (SliderTimelineModel);

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_matrix_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TimelineView_js__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TimelineAxis_js__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_symbol_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__scale_Ordinal_js__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__scale_Time_js__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__scale_Interval_js__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_zrender_lib_contain_text_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__tooltip_tooltipMarkup_js__ = __webpack_require__(48);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



















var PI = Math.PI;
var labelDataIndexStore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_model_js__["a" /* makeInner */])();

var SliderTimelineView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(SliderTimelineView, _super);

  function SliderTimelineView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SliderTimelineView.type;
    return _this;
  }

  SliderTimelineView.prototype.init = function (ecModel, api) {
    this.api = api;
  };
  /**
   * @override
   */


  SliderTimelineView.prototype.render = function (timelineModel, ecModel, api) {
    this.model = timelineModel;
    this.api = api;
    this.ecModel = ecModel;
    this.group.removeAll();

    if (timelineModel.get('show', true)) {
      var layoutInfo_1 = this._layout(timelineModel, api);

      var mainGroup_1 = this._createGroup('_mainGroup');

      var labelGroup = this._createGroup('_labelGroup');

      var axis_1 = this._axis = this._createAxis(layoutInfo_1, timelineModel);

      timelineModel.formatTooltip = function (dataIndex) {
        var name = axis_1.scale.getLabel({
          value: dataIndex
        });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__tooltip_tooltipMarkup_js__["b" /* createTooltipMarkup */])('nameValue', {
          noName: true,
          value: name
        });
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["each"])(['AxisLine', 'AxisTick', 'Control', 'CurrentPointer'], function (name) {
        this['_render' + name](layoutInfo_1, mainGroup_1, axis_1, timelineModel);
      }, this);

      this._renderAxisLabel(layoutInfo_1, labelGroup, axis_1, timelineModel);

      this._position(layoutInfo_1, timelineModel);
    }

    this._doPlayStop();

    this._updateTicksStatus();
  };
  /**
   * @override
   */


  SliderTimelineView.prototype.remove = function () {
    this._clearTimer();

    this.group.removeAll();
  };
  /**
   * @override
   */


  SliderTimelineView.prototype.dispose = function () {
    this._clearTimer();
  };

  SliderTimelineView.prototype._layout = function (timelineModel, api) {
    var labelPosOpt = timelineModel.get(['label', 'position']);
    var orient = timelineModel.get('orient');
    var viewRect = getViewRect(timelineModel, api);
    var parsedLabelPos; // Auto label offset.

    if (labelPosOpt == null || labelPosOpt === 'auto') {
      parsedLabelPos = orient === 'horizontal' ? viewRect.y + viewRect.height / 2 < api.getHeight() / 2 ? '-' : '+' : viewRect.x + viewRect.width / 2 < api.getWidth() / 2 ? '+' : '-';
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["isString"])(labelPosOpt)) {
      parsedLabelPos = {
        horizontal: {
          top: '-',
          bottom: '+'
        },
        vertical: {
          left: '-',
          right: '+'
        }
      }[orient][labelPosOpt];
    } else {
      // is number
      parsedLabelPos = labelPosOpt;
    }

    var labelAlignMap = {
      horizontal: 'center',
      vertical: parsedLabelPos >= 0 || parsedLabelPos === '+' ? 'left' : 'right'
    };
    var labelBaselineMap = {
      horizontal: parsedLabelPos >= 0 || parsedLabelPos === '+' ? 'top' : 'bottom',
      vertical: 'middle'
    };
    var rotationMap = {
      horizontal: 0,
      vertical: PI / 2
    }; // Position

    var mainLength = orient === 'vertical' ? viewRect.height : viewRect.width;
    var controlModel = timelineModel.getModel('controlStyle');
    var showControl = controlModel.get('show', true);
    var controlSize = showControl ? controlModel.get('itemSize') : 0;
    var controlGap = showControl ? controlModel.get('itemGap') : 0;
    var sizePlusGap = controlSize + controlGap; // Special label rotate.

    var labelRotation = timelineModel.get(['label', 'rotate']) || 0;
    labelRotation = labelRotation * PI / 180; // To radian.

    var playPosition;
    var prevBtnPosition;
    var nextBtnPosition;
    var controlPosition = controlModel.get('position', true);
    var showPlayBtn = showControl && controlModel.get('showPlayBtn', true);
    var showPrevBtn = showControl && controlModel.get('showPrevBtn', true);
    var showNextBtn = showControl && controlModel.get('showNextBtn', true);
    var xLeft = 0;
    var xRight = mainLength; // position[0] means left, position[1] means middle.

    if (controlPosition === 'left' || controlPosition === 'bottom') {
      showPlayBtn && (playPosition = [0, 0], xLeft += sizePlusGap);
      showPrevBtn && (prevBtnPosition = [xLeft, 0], xLeft += sizePlusGap);
      showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
    } else {
      // 'top' 'right'
      showPlayBtn && (playPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
      showPrevBtn && (prevBtnPosition = [0, 0], xLeft += sizePlusGap);
      showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
    }

    var axisExtent = [xLeft, xRight];

    if (timelineModel.get('inverse')) {
      axisExtent.reverse();
    }

    return {
      viewRect: viewRect,
      mainLength: mainLength,
      orient: orient,
      rotation: rotationMap[orient],
      labelRotation: labelRotation,
      labelPosOpt: parsedLabelPos,
      labelAlign: timelineModel.get(['label', 'align']) || labelAlignMap[orient],
      labelBaseline: timelineModel.get(['label', 'verticalAlign']) || timelineModel.get(['label', 'baseline']) || labelBaselineMap[orient],
      // Based on mainGroup.
      playPosition: playPosition,
      prevBtnPosition: prevBtnPosition,
      nextBtnPosition: nextBtnPosition,
      axisExtent: axisExtent,
      controlSize: controlSize,
      controlGap: controlGap
    };
  };

  SliderTimelineView.prototype._position = function (layoutInfo, timelineModel) {
    // Position is be called finally, because bounding rect is needed for
    // adapt content to fill viewRect (auto adapt offset).
    // Timeline may be not all in the viewRect when 'offset' is specified
    // as a number, because it is more appropriate that label aligns at
    // 'offset' but not the other edge defined by viewRect.
    var mainGroup = this._mainGroup;
    var labelGroup = this._labelGroup;
    var viewRect = layoutInfo.viewRect;

    if (layoutInfo.orient === 'vertical') {
      // transform to horizontal, inverse rotate by left-top point.
      var m = __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_matrix_js__["create"]();
      var rotateOriginX = viewRect.x;
      var rotateOriginY = viewRect.y + viewRect.height;
      __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_matrix_js__["translate"](m, m, [-rotateOriginX, -rotateOriginY]);
      __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_matrix_js__["rotate"](m, m, -PI / 2);
      __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_matrix_js__["translate"](m, m, [rotateOriginX, rotateOriginY]);
      viewRect = viewRect.clone();
      viewRect.applyTransform(m);
    }

    var viewBound = getBound(viewRect);
    var mainBound = getBound(mainGroup.getBoundingRect());
    var labelBound = getBound(labelGroup.getBoundingRect());
    var mainPosition = [mainGroup.x, mainGroup.y];
    var labelsPosition = [labelGroup.x, labelGroup.y];
    labelsPosition[0] = mainPosition[0] = viewBound[0][0];
    var labelPosOpt = layoutInfo.labelPosOpt;

    if (labelPosOpt == null || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["isString"])(labelPosOpt)) {
      // '+' or '-'
      var mainBoundIdx = labelPosOpt === '+' ? 0 : 1;
      toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
      toBound(labelsPosition, labelBound, viewBound, 1, 1 - mainBoundIdx);
    } else {
      var mainBoundIdx = labelPosOpt >= 0 ? 0 : 1;
      toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
      labelsPosition[1] = mainPosition[1] + labelPosOpt;
    }

    mainGroup.setPosition(mainPosition);
    labelGroup.setPosition(labelsPosition);
    mainGroup.rotation = labelGroup.rotation = layoutInfo.rotation;
    setOrigin(mainGroup);
    setOrigin(labelGroup);

    function setOrigin(targetGroup) {
      targetGroup.originX = viewBound[0][0] - targetGroup.x;
      targetGroup.originY = viewBound[1][0] - targetGroup.y;
    }

    function getBound(rect) {
      // [[xmin, xmax], [ymin, ymax]]
      return [[rect.x, rect.x + rect.width], [rect.y, rect.y + rect.height]];
    }

    function toBound(fromPos, from, to, dimIdx, boundIdx) {
      fromPos[dimIdx] += to[dimIdx][boundIdx] - from[dimIdx][boundIdx];
    }
  };

  SliderTimelineView.prototype._createAxis = function (layoutInfo, timelineModel) {
    var data = timelineModel.getData();
    var axisType = timelineModel.get('axisType');
    var scale = createScaleByModel(timelineModel, axisType); // Customize scale. The `tickValue` is `dataIndex`.

    scale.getTicks = function () {
      return data.mapArray(['value'], function (value) {
        return {
          value: value
        };
      });
    };

    var dataExtent = data.getDataExtent('value');
    scale.setExtent(dataExtent[0], dataExtent[1]);
    scale.calcNiceTicks();
    var axis = new __WEBPACK_IMPORTED_MODULE_7__TimelineAxis_js__["a" /* default */]('value', scale, layoutInfo.axisExtent, axisType);
    axis.model = timelineModel;
    return axis;
  };

  SliderTimelineView.prototype._createGroup = function (key) {
    var newGroup = this[key] = new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Group"]();
    this.group.add(newGroup);
    return newGroup;
  };

  SliderTimelineView.prototype._renderAxisLine = function (layoutInfo, group, axis, timelineModel) {
    var axisExtent = axis.getExtent();

    if (!timelineModel.get(['lineStyle', 'show'])) {
      return;
    }

    var line = new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Line"]({
      shape: {
        x1: axisExtent[0],
        y1: 0,
        x2: axisExtent[1],
        y2: 0
      },
      style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["extend"])({
        lineCap: 'round'
      }, timelineModel.getModel('lineStyle').getLineStyle()),
      silent: true,
      z2: 1
    });
    group.add(line);
    var progressLine = this._progressLine = new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Line"]({
      shape: {
        x1: axisExtent[0],
        x2: this._currentPointer ? this._currentPointer.x : axisExtent[0],
        y1: 0,
        y2: 0
      },
      style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["defaults"])({
        lineCap: 'round',
        lineWidth: line.style.lineWidth
      }, timelineModel.getModel(['progress', 'lineStyle']).getLineStyle()),
      silent: true,
      z2: 1
    });
    group.add(progressLine);
  };

  SliderTimelineView.prototype._renderAxisTick = function (layoutInfo, group, axis, timelineModel) {
    var _this = this;

    var data = timelineModel.getData(); // Show all ticks, despite ignoring strategy.

    var ticks = axis.scale.getTicks();
    this._tickSymbols = []; // The value is dataIndex, see the costomized scale.

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["each"])(ticks, function (tick) {
      var tickCoord = axis.dataToCoord(tick.value);
      var itemModel = data.getItemModel(tick.value);
      var itemStyleModel = itemModel.getModel('itemStyle');
      var hoverStyleModel = itemModel.getModel(['emphasis', 'itemStyle']);
      var progressStyleModel = itemModel.getModel(['progress', 'itemStyle']);
      var symbolOpt = {
        x: tickCoord,
        y: 0,
        onclick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["bind"])(_this._changeTimeline, _this, tick.value)
      };
      var el = giveSymbol(itemModel, itemStyleModel, group, symbolOpt);
      el.ensureState('emphasis').style = hoverStyleModel.getItemStyle();
      el.ensureState('progress').style = progressStyleModel.getItemStyle();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["d" /* enableHoverEmphasis */])(el);
      var ecData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_innerStore_js__["a" /* getECData */])(el);

      if (itemModel.get('tooltip')) {
        ecData.dataIndex = tick.value;
        ecData.dataModel = timelineModel;
      } else {
        ecData.dataIndex = ecData.dataModel = null;
      }

      _this._tickSymbols.push(el);
    });
  };

  SliderTimelineView.prototype._renderAxisLabel = function (layoutInfo, group, axis, timelineModel) {
    var _this = this;

    var labelModel = axis.getLabelModel();

    if (!labelModel.get('show')) {
      return;
    }

    var data = timelineModel.getData();
    var labels = axis.getViewLabels();
    this._tickLabels = [];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["each"])(labels, function (labelItem) {
      // The tickValue is dataIndex, see the costomized scale.
      var dataIndex = labelItem.tickValue;
      var itemModel = data.getItemModel(dataIndex);
      var normalLabelModel = itemModel.getModel('label');
      var hoverLabelModel = itemModel.getModel(['emphasis', 'label']);
      var progressLabelModel = itemModel.getModel(['progress', 'label']);
      var tickCoord = axis.dataToCoord(labelItem.tickValue);
      var textEl = new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Text"]({
        x: tickCoord,
        y: 0,
        rotation: layoutInfo.labelRotation - layoutInfo.rotation,
        onclick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["bind"])(_this._changeTimeline, _this, dataIndex),
        silent: false,
        style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["d" /* createTextStyle */])(normalLabelModel, {
          text: labelItem.formattedLabel,
          align: layoutInfo.labelAlign,
          verticalAlign: layoutInfo.labelBaseline
        })
      });
      textEl.ensureState('emphasis').style = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["d" /* createTextStyle */])(hoverLabelModel);
      textEl.ensureState('progress').style = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["d" /* createTextStyle */])(progressLabelModel);
      group.add(textEl);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["d" /* enableHoverEmphasis */])(textEl);
      labelDataIndexStore(textEl).dataIndex = dataIndex;

      _this._tickLabels.push(textEl);
    });
  };

  SliderTimelineView.prototype._renderControl = function (layoutInfo, group, axis, timelineModel) {
    var controlSize = layoutInfo.controlSize;
    var rotation = layoutInfo.rotation;
    var itemStyle = timelineModel.getModel('controlStyle').getItemStyle();
    var hoverStyle = timelineModel.getModel(['emphasis', 'controlStyle']).getItemStyle();
    var playState = timelineModel.getPlayState();
    var inverse = timelineModel.get('inverse', true);
    makeBtn(layoutInfo.nextBtnPosition, 'next', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["bind"])(this._changeTimeline, this, inverse ? '-' : '+'));
    makeBtn(layoutInfo.prevBtnPosition, 'prev', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["bind"])(this._changeTimeline, this, inverse ? '+' : '-'));
    makeBtn(layoutInfo.playPosition, playState ? 'stop' : 'play', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["bind"])(this._handlePlayClick, this, !playState), true);

    function makeBtn(position, iconName, onclick, willRotate) {
      if (!position) {
        return;
      }

      var iconSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_zrender_lib_contain_text_js__["b" /* parsePercent */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["retrieve2"])(timelineModel.get(['controlStyle', iconName + 'BtnSize']), controlSize), controlSize);
      var rect = [0, -iconSize / 2, iconSize, iconSize];
      var btn = makeControlIcon(timelineModel, iconName + 'Icon', rect, {
        x: position[0],
        y: position[1],
        originX: controlSize / 2,
        originY: 0,
        rotation: willRotate ? -rotation : 0,
        rectHover: true,
        style: itemStyle,
        onclick: onclick
      });
      btn.ensureState('emphasis').style = hoverStyle;
      group.add(btn);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_states_js__["d" /* enableHoverEmphasis */])(btn);
    }
  };

  SliderTimelineView.prototype._renderCurrentPointer = function (layoutInfo, group, axis, timelineModel) {
    var data = timelineModel.getData();
    var currentIndex = timelineModel.getCurrentIndex();
    var pointerModel = data.getItemModel(currentIndex).getModel('checkpointStyle');
    var me = this;
    var callback = {
      onCreate: function (pointer) {
        pointer.draggable = true;
        pointer.drift = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["bind"])(me._handlePointerDrag, me);
        pointer.ondragend = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["bind"])(me._handlePointerDragend, me);
        pointerMoveTo(pointer, me._progressLine, currentIndex, axis, timelineModel, true);
      },
      onUpdate: function (pointer) {
        pointerMoveTo(pointer, me._progressLine, currentIndex, axis, timelineModel);
      }
    }; // Reuse when exists, for animation and drag.

    this._currentPointer = giveSymbol(pointerModel, pointerModel, this._mainGroup, {}, this._currentPointer, callback);
  };

  SliderTimelineView.prototype._handlePlayClick = function (nextState) {
    this._clearTimer();

    this.api.dispatchAction({
      type: 'timelinePlayChange',
      playState: nextState,
      from: this.uid
    });
  };

  SliderTimelineView.prototype._handlePointerDrag = function (dx, dy, e) {
    this._clearTimer();

    this._pointerChangeTimeline([e.offsetX, e.offsetY]);
  };

  SliderTimelineView.prototype._handlePointerDragend = function (e) {
    this._pointerChangeTimeline([e.offsetX, e.offsetY], true);
  };

  SliderTimelineView.prototype._pointerChangeTimeline = function (mousePos, trigger) {
    var toCoord = this._toAxisCoord(mousePos)[0];

    var axis = this._axis;
    var axisExtent = __WEBPACK_IMPORTED_MODULE_9__util_number_js__["j" /* asc */](axis.getExtent().slice());
    toCoord > axisExtent[1] && (toCoord = axisExtent[1]);
    toCoord < axisExtent[0] && (toCoord = axisExtent[0]);
    this._currentPointer.x = toCoord;

    this._currentPointer.markRedraw();

    this._progressLine.shape.x2 = toCoord;

    this._progressLine.dirty();

    var targetDataIndex = this._findNearestTick(toCoord);

    var timelineModel = this.model;

    if (trigger || targetDataIndex !== timelineModel.getCurrentIndex() && timelineModel.get('realtime')) {
      this._changeTimeline(targetDataIndex);
    }
  };

  SliderTimelineView.prototype._doPlayStop = function () {
    var _this = this;

    this._clearTimer();

    if (this.model.getPlayState()) {
      this._timer = setTimeout(function () {
        // Do not cache
        var timelineModel = _this.model;

        _this._changeTimeline(timelineModel.getCurrentIndex() + (timelineModel.get('rewind', true) ? -1 : 1));
      }, this.model.get('playInterval'));
    }
  };

  SliderTimelineView.prototype._toAxisCoord = function (vertex) {
    var trans = this._mainGroup.getLocalTransform();

    return __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["applyTransform"](vertex, trans, true);
  };

  SliderTimelineView.prototype._findNearestTick = function (axisCoord) {
    var data = this.model.getData();
    var dist = Infinity;
    var targetDataIndex;
    var axis = this._axis;
    data.each(['value'], function (value, dataIndex) {
      var coord = axis.dataToCoord(value);
      var d = Math.abs(coord - axisCoord);

      if (d < dist) {
        dist = d;
        targetDataIndex = dataIndex;
      }
    });
    return targetDataIndex;
  };

  SliderTimelineView.prototype._clearTimer = function () {
    if (this._timer) {
      clearTimeout(this._timer);
      this._timer = null;
    }
  };

  SliderTimelineView.prototype._changeTimeline = function (nextIndex) {
    var currentIndex = this.model.getCurrentIndex();

    if (nextIndex === '+') {
      nextIndex = currentIndex + 1;
    } else if (nextIndex === '-') {
      nextIndex = currentIndex - 1;
    }

    this.api.dispatchAction({
      type: 'timelineChange',
      currentIndex: nextIndex,
      from: this.uid
    });
  };

  SliderTimelineView.prototype._updateTicksStatus = function () {
    var currentIndex = this.model.getCurrentIndex();
    var tickSymbols = this._tickSymbols;
    var tickLabels = this._tickLabels;

    if (tickSymbols) {
      for (var i = 0; i < tickSymbols.length; i++) {
        tickSymbols && tickSymbols[i] && tickSymbols[i].toggleState('progress', i < currentIndex);
      }
    }

    if (tickLabels) {
      for (var i = 0; i < tickLabels.length; i++) {
        tickLabels && tickLabels[i] && tickLabels[i].toggleState('progress', labelDataIndexStore(tickLabels[i]).dataIndex <= currentIndex);
      }
    }
  };

  SliderTimelineView.type = 'timeline.slider';
  return SliderTimelineView;
}(__WEBPACK_IMPORTED_MODULE_6__TimelineView_js__["a" /* default */]);

function createScaleByModel(model, axisType) {
  axisType = axisType || model.get('type');

  if (axisType) {
    switch (axisType) {
      // Buildin scale
      case 'category':
        return new __WEBPACK_IMPORTED_MODULE_11__scale_Ordinal_js__["a" /* default */]({
          ordinalMeta: model.getCategories(),
          extent: [Infinity, -Infinity]
        });

      case 'time':
        return new __WEBPACK_IMPORTED_MODULE_12__scale_Time_js__["a" /* default */]({
          locale: model.ecModel.getLocaleModel(),
          useUTC: model.ecModel.get('useUTC')
        });

      default:
        // default to be value
        return new __WEBPACK_IMPORTED_MODULE_13__scale_Interval_js__["a" /* default */]();
    }
  }
}

function getViewRect(model, api) {
  return __WEBPACK_IMPORTED_MODULE_5__util_layout_js__["f" /* getLayoutRect */](model.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  }, model.get('padding'));
}

function makeControlIcon(timelineModel, objPath, rect, opts) {
  var style = opts.style;
  var icon = __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["createIcon"](timelineModel.get(['controlStyle', objPath]), opts || {}, new __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_BoundingRect_js__["a" /* default */](rect[0], rect[1], rect[2], rect[3])); // TODO createIcon won't use style in opt.

  if (style) {
    icon.setStyle(style);
  }

  return icon;
}
/**
 * Create symbol or update symbol
 * opt: basic position and event handlers
 */


function giveSymbol(hostModel, itemStyleModel, group, opt, symbol, callback) {
  var color = itemStyleModel.get('color');

  if (!symbol) {
    var symbolType = hostModel.get('symbol');
    symbol = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_symbol_js__["a" /* createSymbol */])(symbolType, -1, -1, 2, 2, color);
    symbol.setStyle('strokeNoScale', true);
    group.add(symbol);
    callback && callback.onCreate(symbol);
  } else {
    symbol.setColor(color);
    group.add(symbol); // Group may be new, also need to add.

    callback && callback.onUpdate(symbol);
  } // Style


  var itemStyle = itemStyleModel.getItemStyle(['color']);
  symbol.setStyle(itemStyle); // Transform and events.

  opt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_core_util_js__["merge"])({
    rectHover: true,
    z2: 100
  }, opt, true);
  var symbolSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_symbol_js__["c" /* normalizeSymbolSize */])(hostModel.get('symbolSize'));
  opt.scaleX = symbolSize[0] / 2;
  opt.scaleY = symbolSize[1] / 2;
  var symbolOffset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_symbol_js__["d" /* normalizeSymbolOffset */])(hostModel.get('symbolOffset'), symbolSize);

  if (symbolOffset) {
    opt.x = (opt.x || 0) + symbolOffset[0];
    opt.y = (opt.y || 0) + symbolOffset[1];
  }

  var symbolRotate = hostModel.get('symbolRotate');
  opt.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
  symbol.attr(opt); // FIXME
  // (1) When symbol.style.strokeNoScale is true and updateTransform is not performed,
  // getBoundingRect will return wrong result.
  // (This is supposed to be resolved in zrender, but it is a little difficult to
  // leverage performance and auto updateTransform)
  // (2) All of ancesters of symbol do not scale, so we can just updateTransform symbol.

  symbol.updateTransform();
  return symbol;
}

function pointerMoveTo(pointer, progressLine, dataIndex, axis, timelineModel, noAnimation) {
  if (pointer.dragging) {
    return;
  }

  var pointerModel = timelineModel.getModel('checkpointStyle');
  var toCoord = axis.dataToCoord(timelineModel.getData().get('value', dataIndex));

  if (noAnimation || !pointerModel.get('animation', true)) {
    pointer.attr({
      x: toCoord,
      y: 0
    });
    progressLine && progressLine.attr({
      shape: {
        x2: toCoord
      }
    });
  } else {
    var animationCfg = {
      duration: pointerModel.get('animationDuration', true),
      easing: pointerModel.get('animationEasing', true)
    };
    pointer.stopAnimation(null, true);
    pointer.animateTo({
      x: toCoord,
      y: 0
    }, animationCfg);
    progressLine && progressLine.animateTo({
      shape: {
        x2: toCoord
      }
    }, animationCfg);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (SliderTimelineView);

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__coord_Axis_js__ = __webpack_require__(112);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * Extend axis 2d
 */

var TimelineAxis =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(TimelineAxis, _super);

  function TimelineAxis(dim, scale, coordExtent, axisType) {
    var _this = _super.call(this, dim, scale, coordExtent) || this;

    _this.type = axisType || 'value';
    return _this;
  }
  /**
   * @override
   */


  TimelineAxis.prototype.getLabelModel = function () {
    // Force override
    return this.model.getModel('label');
  };
  /**
   * @override
   */


  TimelineAxis.prototype.isHorizontal = function () {
    return this.model.get('orient') === 'horizontal';
  };

  return TimelineAxis;
}(__WEBPACK_IMPORTED_MODULE_1__coord_Axis_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TimelineAxis);

/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_Component_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_SeriesData_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






var TimelineModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(TimelineModel, _super);

  function TimelineModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = TimelineModel.type;
    _this.layoutMode = 'box';
    return _this;
  }
  /**
   * @override
   */


  TimelineModel.prototype.init = function (option, parentModel, ecModel) {
    this.mergeDefaultAndTheme(option, ecModel);

    this._initData();
  };
  /**
   * @override
   */


  TimelineModel.prototype.mergeOption = function (option) {
    _super.prototype.mergeOption.apply(this, arguments);

    this._initData();
  };

  TimelineModel.prototype.setCurrentIndex = function (currentIndex) {
    if (currentIndex == null) {
      currentIndex = this.option.currentIndex;
    }

    var count = this._data.count();

    if (this.option.loop) {
      currentIndex = (currentIndex % count + count) % count;
    } else {
      currentIndex >= count && (currentIndex = count - 1);
      currentIndex < 0 && (currentIndex = 0);
    }

    this.option.currentIndex = currentIndex;
  };
  /**
   * @return {number} currentIndex
   */


  TimelineModel.prototype.getCurrentIndex = function () {
    return this.option.currentIndex;
  };
  /**
   * @return {boolean}
   */


  TimelineModel.prototype.isIndexMax = function () {
    return this.getCurrentIndex() >= this._data.count() - 1;
  };
  /**
   * @param {boolean} state true: play, false: stop
   */


  TimelineModel.prototype.setPlayState = function (state) {
    this.option.autoPlay = !!state;
  };
  /**
   * @return {boolean} true: play, false: stop
   */


  TimelineModel.prototype.getPlayState = function () {
    return !!this.option.autoPlay;
  };
  /**
   * @private
   */


  TimelineModel.prototype._initData = function () {
    var thisOption = this.option;
    var dataArr = thisOption.data || [];
    var axisType = thisOption.axisType;
    var names = this._names = [];
    var processedDataArr;

    if (axisType === 'category') {
      processedDataArr = [];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(dataArr, function (item, index) {
        var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_model_js__["n" /* convertOptionIdName */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_model_js__["g" /* getDataItemValue */])(item), '');
        var newItem;

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["isObject"])(item)) {
          newItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["clone"])(item);
          newItem.value = index;
        } else {
          newItem = index;
        }

        processedDataArr.push(newItem);
        names.push(value);
      });
    } else {
      processedDataArr = dataArr;
    }

    var dimType = {
      category: 'ordinal',
      time: 'time',
      value: 'number'
    }[axisType] || 'number';
    var data = this._data = new __WEBPACK_IMPORTED_MODULE_2__data_SeriesData_js__["a" /* default */]([{
      name: 'value',
      type: dimType
    }], this);
    data.initData(processedDataArr, names);
  };

  TimelineModel.prototype.getData = function () {
    return this._data;
  };
  /**
   * @public
   * @return {Array.<string>} categoreis
   */


  TimelineModel.prototype.getCategories = function () {
    if (this.get('axisType') === 'category') {
      return this._names.slice();
    }
  };

  TimelineModel.type = 'timeline';
  /**
   * @protected
   */

  TimelineModel.defaultOption = {
    // zlevel: 0,                  // 一级层叠
    z: 4,
    show: true,
    axisType: 'time',
    realtime: true,
    left: '20%',
    top: null,
    right: '20%',
    bottom: 0,
    width: null,
    height: 40,
    padding: 5,
    controlPosition: 'left',
    autoPlay: false,
    rewind: false,
    loop: true,
    playInterval: 2000,
    currentIndex: 0,
    itemStyle: {},
    label: {
      color: '#000'
    },
    data: []
  };
  return TimelineModel;
}(__WEBPACK_IMPORTED_MODULE_1__model_Component_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TimelineModel);

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_Component_js__ = __webpack_require__(30);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var TimelineView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(TimelineView, _super);

  function TimelineView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = TimelineView.type;
    return _this;
  }

  TimelineView.type = 'timeline';
  return TimelineView;
}(__WEBPACK_IMPORTED_MODULE_1__view_Component_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TimelineView);

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SliderTimelineModel_js__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SliderTimelineView_js__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timelineAction_js__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__preprocessor_js__ = __webpack_require__(1257);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */





function install(registers) {
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_0__SliderTimelineModel_js__["a" /* default */]);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_1__SliderTimelineView_js__["a" /* default */]);
  registers.registerSubTypeDefaulter('timeline', function () {
    // Only slider now.
    return 'slider';
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__timelineAction_js__["a" /* installTimelineAction */])(registers);
  registers.registerPreprocessor(__WEBPACK_IMPORTED_MODULE_3__preprocessor_js__["a" /* default */]);
}

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = timelinePreprocessor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// @ts-nocheck

function timelinePreprocessor(option) {
  var timelineOpt = option && option.timeline;

  if (!__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](timelineOpt)) {
    timelineOpt = timelineOpt ? [timelineOpt] : [];
  }

  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](timelineOpt, function (opt) {
    if (!opt) {
      return;
    }

    compatibleEC2(opt);
  });
}

function compatibleEC2(opt) {
  var type = opt.type;
  var ec2Types = {
    'number': 'value',
    'time': 'time'
  }; // Compatible with ec2

  if (ec2Types[type]) {
    opt.axisType = ec2Types[type];
    delete opt.type;
  }

  transferItem(opt);

  if (has(opt, 'controlPosition')) {
    var controlStyle = opt.controlStyle || (opt.controlStyle = {});

    if (!has(controlStyle, 'position')) {
      controlStyle.position = opt.controlPosition;
    }

    if (controlStyle.position === 'none' && !has(controlStyle, 'show')) {
      controlStyle.show = false;
      delete controlStyle.position;
    }

    delete opt.controlPosition;
  }

  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](opt.data || [], function (dataItem) {
    if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"](dataItem) && !__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](dataItem)) {
      if (!has(dataItem, 'value') && has(dataItem, 'name')) {
        // In ec2, using name as value.
        dataItem.value = dataItem.name;
      }

      transferItem(dataItem);
    }
  });
}

function transferItem(opt) {
  var itemStyle = opt.itemStyle || (opt.itemStyle = {});
  var itemStyleEmphasis = itemStyle.emphasis || (itemStyle.emphasis = {}); // Transfer label out

  var label = opt.label || opt.label || {};
  var labelNormal = label.normal || (label.normal = {});
  var excludeLabelAttr = {
    normal: 1,
    emphasis: 1
  };
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](label, function (value, name) {
    if (!excludeLabelAttr[name] && !has(labelNormal, name)) {
      labelNormal[name] = value;
    }
  });

  if (itemStyleEmphasis.label && !has(label, 'emphasis')) {
    label.emphasis = itemStyleEmphasis.label;
    delete itemStyleEmphasis.label;
  }
}

function has(obj, attr) {
  return obj.hasOwnProperty(attr);
}

/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = installTimelineAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

function installTimelineAction(registers) {
  registers.registerAction({
    type: 'timelineChange',
    event: 'timelineChanged',
    update: 'prepareAndUpdate'
  }, function (payload, ecModel, api) {
    var timelineModel = ecModel.getComponent('timeline');

    if (timelineModel && payload.currentIndex != null) {
      timelineModel.setCurrentIndex(payload.currentIndex);

      if (!timelineModel.get('loop', true) && timelineModel.isIndexMax() && timelineModel.getPlayState()) {
        timelineModel.setPlayState(false); // The timeline has played to the end, trigger event

        api.dispatchAction({
          type: 'timelinePlayChange',
          playState: false,
          from: payload.from
        });
      }
    } // Set normalized currentIndex to payload.


    ecModel.resetOption('timeline', {
      replaceMerge: timelineModel.get('replaceMerge', true)
    });
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["defaults"])({
      currentIndex: timelineModel.option.currentIndex
    }, payload);
  });
  registers.registerAction({
    type: 'timelinePlayChange',
    event: 'timelinePlayChanged',
    update: 'update'
  }, function (payload, ecModel) {
    var timelineModel = ecModel.getComponent('timeline');

    if (timelineModel && payload.playState != null) {
      timelineModel.setPlayState(payload.playState);
    }
  });
}

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_Component_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_Component_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_format_js__ = __webpack_require__(42);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/










var TitleModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(TitleModel, _super);

  function TitleModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = TitleModel.type;
    _this.layoutMode = {
      type: 'box',
      ignoreSize: true
    };
    return _this;
  }

  TitleModel.type = 'title';
  TitleModel.defaultOption = {
    // zlevel: 0,
    z: 6,
    show: true,
    text: '',
    target: 'blank',
    subtext: '',
    subtarget: 'blank',
    left: 0,
    top: 0,
    backgroundColor: 'rgba(0,0,0,0)',
    borderColor: '#ccc',
    borderWidth: 0,
    padding: 5,
    itemGap: 10,
    textStyle: {
      fontSize: 18,
      fontWeight: 'bold',
      color: '#464646'
    },
    subtextStyle: {
      fontSize: 12,
      color: '#6E7079'
    }
  };
  return TitleModel;
}(__WEBPACK_IMPORTED_MODULE_6__model_Component_js__["a" /* default */]); // View


var TitleView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(TitleView, _super);

  function TitleView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = TitleView.type;
    return _this;
  }

  TitleView.prototype.render = function (titleModel, ecModel, api) {
    this.group.removeAll();

    if (!titleModel.get('show')) {
      return;
    }

    var group = this.group;
    var textStyleModel = titleModel.getModel('textStyle');
    var subtextStyleModel = titleModel.getModel('subtextStyle');
    var textAlign = titleModel.get('textAlign');
    var textVerticalAlign = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["retrieve2"](titleModel.get('textBaseline'), titleModel.get('textVerticalAlign'));
    var textEl = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Text"]({
      style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["d" /* createTextStyle */])(textStyleModel, {
        text: titleModel.get('text'),
        fill: textStyleModel.getTextColor()
      }, {
        disableBox: true
      }),
      z2: 10
    });
    var textRect = textEl.getBoundingRect();
    var subText = titleModel.get('subtext');
    var subTextEl = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Text"]({
      style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__label_labelStyle_js__["d" /* createTextStyle */])(subtextStyleModel, {
        text: subText,
        fill: subtextStyleModel.getTextColor(),
        y: textRect.height + titleModel.get('itemGap'),
        verticalAlign: 'top'
      }, {
        disableBox: true
      }),
      z2: 10
    });
    var link = titleModel.get('link');
    var sublink = titleModel.get('sublink');
    var triggerEvent = titleModel.get('triggerEvent', true);
    textEl.silent = !link && !triggerEvent;
    subTextEl.silent = !sublink && !triggerEvent;

    if (link) {
      textEl.on('click', function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_format_js__["h" /* windowOpen */])(link, '_' + titleModel.get('target'));
      });
    }

    if (sublink) {
      subTextEl.on('click', function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_format_js__["h" /* windowOpen */])(sublink, '_' + titleModel.get('subtarget'));
      });
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_innerStore_js__["a" /* getECData */])(textEl).eventData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_innerStore_js__["a" /* getECData */])(subTextEl).eventData = triggerEvent ? {
      componentType: 'title',
      componentIndex: titleModel.componentIndex
    } : null;
    group.add(textEl);
    subText && group.add(subTextEl); // If no subText, but add subTextEl, there will be an empty line.

    var groupRect = group.getBoundingRect();
    var layoutOption = titleModel.getBoxLayoutParams();
    layoutOption.width = groupRect.width;
    layoutOption.height = groupRect.height;
    var layoutRect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_layout_js__["f" /* getLayoutRect */])(layoutOption, {
      width: api.getWidth(),
      height: api.getHeight()
    }, titleModel.get('padding')); // Adjust text align based on position

    if (!textAlign) {
      // Align left if title is on the left. center and right is same
      textAlign = titleModel.get('left') || titleModel.get('right'); // @ts-ignore

      if (textAlign === 'middle') {
        textAlign = 'center';
      } // Adjust layout by text align


      if (textAlign === 'right') {
        layoutRect.x += layoutRect.width;
      } else if (textAlign === 'center') {
        layoutRect.x += layoutRect.width / 2;
      }
    }

    if (!textVerticalAlign) {
      textVerticalAlign = titleModel.get('top') || titleModel.get('bottom'); // @ts-ignore

      if (textVerticalAlign === 'center') {
        textVerticalAlign = 'middle';
      }

      if (textVerticalAlign === 'bottom') {
        layoutRect.y += layoutRect.height;
      } else if (textVerticalAlign === 'middle') {
        layoutRect.y += layoutRect.height / 2;
      }

      textVerticalAlign = textVerticalAlign || 'top';
    }

    group.x = layoutRect.x;
    group.y = layoutRect.y;
    group.markRedraw();
    var alignStyle = {
      align: textAlign,
      verticalAlign: textVerticalAlign
    };
    textEl.setStyle(alignStyle);
    subTextEl.setStyle(alignStyle); // Render background
    // Get groupRect again because textAlign has been changed

    groupRect = group.getBoundingRect();
    var padding = layoutRect.margin;
    var style = titleModel.getItemStyle(['color', 'opacity']);
    style.fill = titleModel.get('backgroundColor');
    var rect = new __WEBPACK_IMPORTED_MODULE_2__util_graphic_js__["Rect"]({
      shape: {
        x: groupRect.x - padding[3],
        y: groupRect.y - padding[0],
        width: groupRect.width + padding[1] + padding[3],
        height: groupRect.height + padding[0] + padding[2],
        r: titleModel.get('borderRadius')
      },
      style: style,
      subPixelOptimize: true,
      silent: true
    });
    group.add(rect);
  };

  TitleView.type = 'title';
  return TitleView;
}(__WEBPACK_IMPORTED_MODULE_7__view_Component_js__["a" /* default */]);

function install(registers) {
  registers.registerComponentModel(TitleModel);
  registers.registerComponentView(TitleView);
}

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__featureManager_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_Component_js__ = __webpack_require__(21);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var ToolboxModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ToolboxModel, _super);

  function ToolboxModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ToolboxModel.type;
    return _this;
  }

  ToolboxModel.prototype.optionUpdated = function () {
    _super.prototype.optionUpdated.apply(this, arguments);

    var ecModel = this.ecModel;
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](this.option.feature, function (featureOpt, featureName) {
      var Feature = __WEBPACK_IMPORTED_MODULE_2__featureManager_js__["c" /* getFeature */](featureName);

      if (Feature) {
        if (Feature.getDefaultOption) {
          Feature.defaultOption = Feature.getDefaultOption(ecModel);
        }

        __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"](featureOpt, Feature.defaultOption);
      }
    });
  };

  ToolboxModel.type = 'toolbox';
  ToolboxModel.layoutMode = {
    type: 'box',
    ignoreSize: true
  };
  ToolboxModel.defaultOption = {
    show: true,
    z: 6,
    // zlevel: 0,
    orient: 'horizontal',
    left: 'right',
    top: 'top',
    // right
    // bottom
    backgroundColor: 'transparent',
    borderColor: '#ccc',
    borderRadius: 0,
    borderWidth: 0,
    padding: 5,
    itemSize: 15,
    itemGap: 8,
    showTitle: true,
    iconStyle: {
      borderColor: '#666',
      color: 'none'
    },
    emphasis: {
      iconStyle: {
        borderColor: '#3E98C5'
      }
    },
    // textStyle: {},
    // feature
    tooltip: {
      show: false,
      position: 'bottom'
    }
  };
  return ToolboxModel;
}(__WEBPACK_IMPORTED_MODULE_3__model_Component_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ToolboxModel);

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_contain_text_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_Model_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_DataDiffer_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helper_listComponent_js__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__view_Component_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__featureManager_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_component_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_zrender_lib_graphic_Text_js__ = __webpack_require__(167);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/













var ToolboxView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ToolboxView, _super);

  function ToolboxView() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ToolboxView.prototype.render = function (toolboxModel, ecModel, api, payload) {
    var group = this.group;
    group.removeAll();

    if (!toolboxModel.get('show')) {
      return;
    }

    var itemSize = +toolboxModel.get('itemSize');
    var isVertical = toolboxModel.get('orient') === 'vertical';
    var featureOpts = toolboxModel.get('feature') || {};
    var features = this._features || (this._features = {});
    var featureNames = [];
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](featureOpts, function (opt, name) {
      featureNames.push(name);
    });
    new __WEBPACK_IMPORTED_MODULE_6__data_DataDiffer_js__["a" /* default */](this._featureNames || [], featureNames).add(processFeature).update(processFeature).remove(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["curry"](processFeature, null)).execute(); // Keep for diff.

    this._featureNames = featureNames;

    function processFeature(newIndex, oldIndex) {
      var featureName = featureNames[newIndex];
      var oldName = featureNames[oldIndex];
      var featureOpt = featureOpts[featureName];
      var featureModel = new __WEBPACK_IMPORTED_MODULE_5__model_Model_js__["a" /* default */](featureOpt, toolboxModel, toolboxModel.ecModel);
      var feature; // FIX#11236, merge feature title from MagicType newOption. TODO: consider seriesIndex ?

      if (payload && payload.newTitle != null && payload.featureName === featureName) {
        featureOpt.title = payload.newTitle;
      }

      if (featureName && !oldName) {
        // Create
        if (isUserFeatureName(featureName)) {
          feature = {
            onclick: featureModel.option.onclick,
            featureName: featureName
          };
        } else {
          var Feature = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__featureManager_js__["c" /* getFeature */])(featureName);

          if (!Feature) {
            return;
          }

          feature = new Feature();
        }

        features[featureName] = feature;
      } else {
        feature = features[oldName]; // If feature does not exsit.

        if (!feature) {
          return;
        }
      }

      feature.uid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_component_js__["a" /* getUID */])('toolbox-feature');
      feature.model = featureModel;
      feature.ecModel = ecModel;
      feature.api = api;
      var isToolboxFeature = feature instanceof __WEBPACK_IMPORTED_MODULE_9__featureManager_js__["b" /* ToolboxFeature */];

      if (!featureName && oldName) {
        isToolboxFeature && feature.dispose && feature.dispose(ecModel, api);
        return;
      }

      if (!featureModel.get('show') || isToolboxFeature && feature.unusable) {
        isToolboxFeature && feature.remove && feature.remove(ecModel, api);
        return;
      }

      createIconPaths(featureModel, feature, featureName);

      featureModel.setIconStatus = function (iconName, status) {
        var option = this.option;
        var iconPaths = this.iconPaths;
        option.iconStatus = option.iconStatus || {};
        option.iconStatus[iconName] = status;

        if (iconPaths[iconName]) {
          (status === 'emphasis' ? __WEBPACK_IMPORTED_MODULE_4__util_states_js__["j" /* enterEmphasis */] : __WEBPACK_IMPORTED_MODULE_4__util_states_js__["k" /* leaveEmphasis */])(iconPaths[iconName]);
        }
      };

      if (feature instanceof __WEBPACK_IMPORTED_MODULE_9__featureManager_js__["b" /* ToolboxFeature */]) {
        if (feature.render) {
          feature.render(featureModel, ecModel, api, payload);
        }
      }
    }

    function createIconPaths(featureModel, feature, featureName) {
      var iconStyleModel = featureModel.getModel('iconStyle');
      var iconStyleEmphasisModel = featureModel.getModel(['emphasis', 'iconStyle']); // If one feature has mutiple icon. they are orginaized as
      // {
      //     icon: {
      //         foo: '',
      //         bar: ''
      //     },
      //     title: {
      //         foo: '',
      //         bar: ''
      //     }
      // }

      var icons = feature instanceof __WEBPACK_IMPORTED_MODULE_9__featureManager_js__["b" /* ToolboxFeature */] && feature.getIcons ? feature.getIcons() : featureModel.get('icon');
      var titles = featureModel.get('title') || {};
      var iconsMap;
      var titlesMap;

      if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"](icons)) {
        iconsMap = {};
        iconsMap[featureName] = icons;
      } else {
        iconsMap = icons;
      }

      if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"](titles)) {
        titlesMap = {};
        titlesMap[featureName] = titles;
      } else {
        titlesMap = titles;
      }

      var iconPaths = featureModel.iconPaths = {};
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](iconsMap, function (iconStr, iconName) {
        var path = __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["createIcon"](iconStr, {}, {
          x: -itemSize / 2,
          y: -itemSize / 2,
          width: itemSize,
          height: itemSize
        }); // TODO handling image

        path.setStyle(iconStyleModel.getItemStyle());
        var pathEmphasisState = path.ensureState('emphasis');
        pathEmphasisState.style = iconStyleEmphasisModel.getItemStyle(); // Text position calculation

        var textContent = new __WEBPACK_IMPORTED_MODULE_11_zrender_lib_graphic_Text_js__["a" /* default */]({
          style: {
            text: titlesMap[iconName],
            align: iconStyleEmphasisModel.get('textAlign'),
            borderRadius: iconStyleEmphasisModel.get('textBorderRadius'),
            padding: iconStyleEmphasisModel.get('textPadding'),
            fill: null
          },
          ignore: true
        });
        path.setTextContent(textContent);
        __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["setTooltipConfig"]({
          el: path,
          componentModel: toolboxModel,
          itemName: iconName,
          formatterParamsExtra: {
            title: titlesMap[iconName]
          }
        });
        path.__title = titlesMap[iconName];
        path.on('mouseover', function () {
          // Should not reuse above hoverStyle, which might be modified.
          var hoverStyle = iconStyleEmphasisModel.getItemStyle();
          var defaultTextPosition = isVertical ? toolboxModel.get('right') == null && toolboxModel.get('left') !== 'right' ? 'right' : 'left' : toolboxModel.get('bottom') == null && toolboxModel.get('top') !== 'bottom' ? 'bottom' : 'top';
          textContent.setStyle({
            fill: iconStyleEmphasisModel.get('textFill') || hoverStyle.fill || hoverStyle.stroke || '#000',
            backgroundColor: iconStyleEmphasisModel.get('textBackgroundColor')
          });
          path.setTextConfig({
            position: iconStyleEmphasisModel.get('textPosition') || defaultTextPosition
          });
          textContent.ignore = !toolboxModel.get('showTitle'); // Use enterEmphasis and leaveEmphasis provide by ec.
          // There are flags managed by the echarts.

          api.enterEmphasis(this);
        }).on('mouseout', function () {
          if (featureModel.get(['iconStatus', iconName]) !== 'emphasis') {
            api.leaveEmphasis(this);
          }

          textContent.hide();
        });
        (featureModel.get(['iconStatus', iconName]) === 'emphasis' ? __WEBPACK_IMPORTED_MODULE_4__util_states_js__["j" /* enterEmphasis */] : __WEBPACK_IMPORTED_MODULE_4__util_states_js__["k" /* leaveEmphasis */])(path);
        group.add(path);
        path.on('click', __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"](feature.onclick, feature, ecModel, api, iconName));
        iconPaths[iconName] = path;
      });
    }

    __WEBPACK_IMPORTED_MODULE_7__helper_listComponent_js__["b" /* layout */](group, toolboxModel, api); // Render background after group is layout
    // FIXME

    group.add(__WEBPACK_IMPORTED_MODULE_7__helper_listComponent_js__["a" /* makeBackground */](group.getBoundingRect(), toolboxModel)); // Adjust icon title positions to avoid them out of screen

    isVertical || group.eachChild(function (icon) {
      var titleText = icon.__title; // const hoverStyle = icon.hoverStyle;
      // TODO simplify code?

      var emphasisState = icon.ensureState('emphasis');
      var emphasisTextConfig = emphasisState.textConfig || (emphasisState.textConfig = {});
      var textContent = icon.getTextContent();
      var emphasisTextState = textContent && textContent.ensureState('emphasis'); // May be background element

      if (emphasisTextState && !__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isFunction"](emphasisTextState) && titleText) {
        var emphasisTextStyle = emphasisTextState.style || (emphasisTextState.style = {});
        var rect = __WEBPACK_IMPORTED_MODULE_2_zrender_lib_contain_text_js__["g" /* getBoundingRect */](titleText, __WEBPACK_IMPORTED_MODULE_11_zrender_lib_graphic_Text_js__["a" /* default */].makeFont(emphasisTextStyle));
        var offsetX = icon.x + group.x;
        var offsetY = icon.y + group.y + itemSize;
        var needPutOnTop = false;

        if (offsetY + rect.height > api.getHeight()) {
          emphasisTextConfig.position = 'top';
          needPutOnTop = true;
        }

        var topOffset = needPutOnTop ? -5 - rect.height : itemSize + 10;

        if (offsetX + rect.width / 2 > api.getWidth()) {
          emphasisTextConfig.position = ['100%', topOffset];
          emphasisTextStyle.align = 'right';
        } else if (offsetX - rect.width / 2 < 0) {
          emphasisTextConfig.position = [0, topOffset];
          emphasisTextStyle.align = 'left';
        }
      }
    });
  };

  ToolboxView.prototype.updateView = function (toolboxModel, ecModel, api, payload) {
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](this._features, function (feature) {
      feature instanceof __WEBPACK_IMPORTED_MODULE_9__featureManager_js__["b" /* ToolboxFeature */] && feature.updateView && feature.updateView(feature.model, ecModel, api, payload);
    });
  }; // updateLayout(toolboxModel, ecModel, api, payload) {
  //     zrUtil.each(this._features, function (feature) {
  //         feature.updateLayout && feature.updateLayout(feature.model, ecModel, api, payload);
  //     });
  // },


  ToolboxView.prototype.remove = function (ecModel, api) {
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](this._features, function (feature) {
      feature instanceof __WEBPACK_IMPORTED_MODULE_9__featureManager_js__["b" /* ToolboxFeature */] && feature.remove && feature.remove(ecModel, api);
    });
    this.group.removeAll();
  };

  ToolboxView.prototype.dispose = function (ecModel, api) {
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](this._features, function (feature) {
      feature instanceof __WEBPACK_IMPORTED_MODULE_9__featureManager_js__["b" /* ToolboxFeature */] && feature.dispose && feature.dispose(ecModel, api);
    });
  };

  ToolboxView.type = 'toolbox';
  return ToolboxView;
}(__WEBPACK_IMPORTED_MODULE_8__view_Component_js__["a" /* default */]);

function isUserFeatureName(featureName) {
  return featureName.indexOf('my') === 0;
}

/* harmony default export */ __webpack_exports__["a"] = (ToolboxView);

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__featureManager_js__ = __webpack_require__(86);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var ICON_TYPES = ['rect', 'polygon', 'lineX', 'lineY', 'keep', 'clear'];

var BrushFeature =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(BrushFeature, _super);

  function BrushFeature() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  BrushFeature.prototype.render = function (featureModel, ecModel, api) {
    var brushType;
    var brushMode;
    var isBrushed;
    ecModel.eachComponent({
      mainType: 'brush'
    }, function (brushModel) {
      brushType = brushModel.brushType;
      brushMode = brushModel.brushOption.brushMode || 'single';
      isBrushed = isBrushed || !!brushModel.areas.length;
    });
    this._brushType = brushType;
    this._brushMode = brushMode;
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](featureModel.get('type', true), function (type) {
      featureModel.setIconStatus(type, (type === 'keep' ? brushMode === 'multiple' : type === 'clear' ? isBrushed : type === brushType) ? 'emphasis' : 'normal');
    });
  };

  BrushFeature.prototype.updateView = function (featureModel, ecModel, api) {
    this.render(featureModel, ecModel, api);
  };

  BrushFeature.prototype.getIcons = function () {
    var model = this.model;
    var availableIcons = model.get('icon', true);
    var icons = {};
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](model.get('type', true), function (type) {
      if (availableIcons[type]) {
        icons[type] = availableIcons[type];
      }
    });
    return icons;
  };

  ;

  BrushFeature.prototype.onclick = function (ecModel, api, type) {
    var brushType = this._brushType;
    var brushMode = this._brushMode;

    if (type === 'clear') {
      // Trigger parallel action firstly
      api.dispatchAction({
        type: 'axisAreaSelect',
        intervals: []
      });
      api.dispatchAction({
        type: 'brush',
        command: 'clear',
        // Clear all areas of all brush components.
        areas: []
      });
    } else {
      api.dispatchAction({
        type: 'takeGlobalCursor',
        key: 'brush',
        brushOption: {
          brushType: type === 'keep' ? brushType : brushType === type ? false : type,
          brushMode: type === 'keep' ? brushMode === 'multiple' ? 'single' : 'multiple' : brushMode
        }
      });
    }
  };

  ;

  BrushFeature.getDefaultOption = function (ecModel) {
    var defaultOption = {
      show: true,
      type: ICON_TYPES.slice(),
      icon: {
        /* eslint-disable */
        rect: 'M7.3,34.7 M0.4,10V-0.2h9.8 M89.6,10V-0.2h-9.8 M0.4,60v10.2h9.8 M89.6,60v10.2h-9.8 M12.3,22.4V10.5h13.1 M33.6,10.5h7.8 M49.1,10.5h7.8 M77.5,22.4V10.5h-13 M12.3,31.1v8.2 M77.7,31.1v8.2 M12.3,47.6v11.9h13.1 M33.6,59.5h7.6 M49.1,59.5 h7.7 M77.5,47.6v11.9h-13',
        polygon: 'M55.2,34.9c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S53.5,34.9,55.2,34.9z M50.4,51c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 C47.3,52.4,48.7,51,50.4,51z M55.6,37.1l1.5-7.8 M60.1,13.5l1.6-8.7l-7.8,4 M59,19l-1,5.3 M24,16.1l6.4,4.9l6.4-3.3 M48.5,11.6 l-5.9,3.1 M19.1,12.8L9.7,5.1l1.1,7.7 M13.4,29.8l1,7.3l6.6,1.6 M11.6,18.4l1,6.1 M32.8,41.9 M26.6,40.4 M27.3,40.2l6.1,1.6 M49.9,52.1l-5.6-7.6l-4.9-1.2',
        lineX: 'M15.2,30 M19.7,15.6V1.9H29 M34.8,1.9H40.4 M55.3,15.6V1.9H45.9 M19.7,44.4V58.1H29 M34.8,58.1H40.4 M55.3,44.4 V58.1H45.9 M12.5,20.3l-9.4,9.6l9.6,9.8 M3.1,29.9h16.5 M62.5,20.3l9.4,9.6L62.3,39.7 M71.9,29.9H55.4',
        lineY: 'M38.8,7.7 M52.7,12h13.2v9 M65.9,26.6V32 M52.7,46.3h13.2v-9 M24.9,12H11.8v9 M11.8,26.6V32 M24.9,46.3H11.8v-9 M48.2,5.1l-9.3-9l-9.4,9.2 M38.9-3.9V12 M48.2,53.3l-9.3,9l-9.4-9.2 M38.9,62.3V46.4',
        keep: 'M4,10.5V1h10.3 M20.7,1h6.1 M33,1h6.1 M55.4,10.5V1H45.2 M4,17.3v6.6 M55.6,17.3v6.6 M4,30.5V40h10.3 M20.7,40 h6.1 M33,40h6.1 M55.4,30.5V40H45.2 M21,18.9h62.9v48.6H21V18.9z',
        clear: 'M22,14.7l30.9,31 M52.9,14.7L22,45.7 M4.7,16.8V4.2h13.1 M26,4.2h7.8 M41.6,4.2h7.8 M70.3,16.8V4.2H57.2 M4.7,25.9v8.6 M70.3,25.9v8.6 M4.7,43.2v12.6h13.1 M26,55.8h7.8 M41.6,55.8h7.8 M70.3,43.2v12.6H57.2' // jshint ignore:line

        /* eslint-enable */

      },
      // `rect`, `polygon`, `lineX`, `lineY`, `keep`, `clear`
      title: ecModel.getLocaleModel().get(['toolbox', 'brush', 'title'])
    };
    return defaultOption;
  };

  return BrushFeature;
}(__WEBPACK_IMPORTED_MODULE_2__featureManager_js__["b" /* ToolboxFeature */]);

/* harmony default export */ __webpack_exports__["a"] = (BrushFeature);

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_echarts_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__featureManager_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_event_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_log_js__ = __webpack_require__(14);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/* global document */






/* global document */

var BLOCK_SPLITER = new Array(60).join('-');
var ITEM_SPLITER = '\t';
/**
 * Group series into two types
 *  1. on category axis, like line, bar
 *  2. others, like scatter, pie
 */

function groupSeries(ecModel) {
  var seriesGroupByCategoryAxis = {};
  var otherSeries = [];
  var meta = [];
  ecModel.eachRawSeries(function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys && (coordSys.type === 'cartesian2d' || coordSys.type === 'polar')) {
      // TODO: TYPE Consider polar? Include polar may increase unecessary bundle size.
      var baseAxis = coordSys.getBaseAxis();

      if (baseAxis.type === 'category') {
        var key = baseAxis.dim + '_' + baseAxis.index;

        if (!seriesGroupByCategoryAxis[key]) {
          seriesGroupByCategoryAxis[key] = {
            categoryAxis: baseAxis,
            valueAxis: coordSys.getOtherAxis(baseAxis),
            series: []
          };
          meta.push({
            axisDim: baseAxis.dim,
            axisIndex: baseAxis.index
          });
        }

        seriesGroupByCategoryAxis[key].series.push(seriesModel);
      } else {
        otherSeries.push(seriesModel);
      }
    } else {
      otherSeries.push(seriesModel);
    }
  });
  return {
    seriesGroupByCategoryAxis: seriesGroupByCategoryAxis,
    other: otherSeries,
    meta: meta
  };
}
/**
 * Assemble content of series on cateogory axis
 * @inner
 */


function assembleSeriesWithCategoryAxis(groups) {
  var tables = [];
  __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"](groups, function (group, key) {
    var categoryAxis = group.categoryAxis;
    var valueAxis = group.valueAxis;
    var valueAxisDim = valueAxis.dim;
    var headers = [' '].concat(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["map"](group.series, function (series) {
      return series.name;
    })); // @ts-ignore TODO Polar

    var columns = [categoryAxis.model.getCategories()];
    __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"](group.series, function (series) {
      var rawData = series.getRawData();
      columns.push(series.getRawData().mapArray(rawData.mapDimension(valueAxisDim), function (val) {
        return val;
      }));
    }); // Assemble table content

    var lines = [headers.join(ITEM_SPLITER)];

    for (var i = 0; i < columns[0].length; i++) {
      var items = [];

      for (var j = 0; j < columns.length; j++) {
        items.push(columns[j][i]);
      }

      lines.push(items.join(ITEM_SPLITER));
    }

    tables.push(lines.join('\n'));
  });
  return tables.join('\n\n' + BLOCK_SPLITER + '\n\n');
}
/**
 * Assemble content of other series
 */


function assembleOtherSeries(series) {
  return __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["map"](series, function (series) {
    var data = series.getRawData();
    var lines = [series.name];
    var vals = [];
    data.each(data.dimensions, function () {
      var argLen = arguments.length;
      var dataIndex = arguments[argLen - 1];
      var name = data.getName(dataIndex);

      for (var i = 0; i < argLen - 1; i++) {
        vals[i] = arguments[i];
      }

      lines.push((name ? name + ITEM_SPLITER : '') + vals.join(ITEM_SPLITER));
    });
    return lines.join('\n');
  }).join('\n\n' + BLOCK_SPLITER + '\n\n');
}

function getContentFromModel(ecModel) {
  var result = groupSeries(ecModel);
  return {
    value: __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["filter"]([assembleSeriesWithCategoryAxis(result.seriesGroupByCategoryAxis), assembleOtherSeries(result.other)], function (str) {
      return !!str.replace(/[\n\t\s]/g, '');
    }).join('\n\n' + BLOCK_SPLITER + '\n\n'),
    meta: result.meta
  };
}

function trim(str) {
  return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
}
/**
 * If a block is tsv format
 */


function isTSVFormat(block) {
  // Simple method to find out if a block is tsv format
  var firstLine = block.slice(0, block.indexOf('\n'));

  if (firstLine.indexOf(ITEM_SPLITER) >= 0) {
    return true;
  }
}

var itemSplitRegex = new RegExp('[' + ITEM_SPLITER + ']+', 'g');
/**
 * @param {string} tsv
 * @return {Object}
 */

function parseTSVContents(tsv) {
  var tsvLines = tsv.split(/\n+/g);
  var headers = trim(tsvLines.shift()).split(itemSplitRegex);
  var categories = [];
  var series = __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["map"](headers, function (header) {
    return {
      name: header,
      data: []
    };
  });

  for (var i = 0; i < tsvLines.length; i++) {
    var items = trim(tsvLines[i]).split(itemSplitRegex);
    categories.push(items.shift());

    for (var j = 0; j < items.length; j++) {
      series[j] && (series[j].data[i] = items[j]);
    }
  }

  return {
    series: series,
    categories: categories
  };
}

function parseListContents(str) {
  var lines = str.split(/\n+/g);
  var seriesName = trim(lines.shift());
  var data = [];

  for (var i = 0; i < lines.length; i++) {
    // if line is empty, ignore it.
    // there is a case that a user forgot to delete `\n`.
    var line = trim(lines[i]);

    if (!line) {
      continue;
    }

    var items = line.split(itemSplitRegex);
    var name_1 = '';
    var value = void 0;
    var hasName = false;

    if (isNaN(items[0])) {
      // First item is name
      hasName = true;
      name_1 = items[0];
      items = items.slice(1);
      data[i] = {
        name: name_1,
        value: []
      };
      value = data[i].value;
    } else {
      value = data[i] = [];
    }

    for (var j = 0; j < items.length; j++) {
      value.push(+items[j]);
    }

    if (value.length === 1) {
      hasName ? data[i].value = value[0] : data[i] = value[0];
    }
  }

  return {
    name: seriesName,
    data: data
  };
}

function parseContents(str, blockMetaList) {
  var blocks = str.split(new RegExp('\n*' + BLOCK_SPLITER + '\n*', 'g'));
  var newOption = {
    series: []
  };
  __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"](blocks, function (block, idx) {
    if (isTSVFormat(block)) {
      var result = parseTSVContents(block);
      var blockMeta = blockMetaList[idx];
      var axisKey = blockMeta.axisDim + 'Axis';

      if (blockMeta) {
        newOption[axisKey] = newOption[axisKey] || [];
        newOption[axisKey][blockMeta.axisIndex] = {
          data: result.categories
        };
        newOption.series = newOption.series.concat(result.series);
      }
    } else {
      var result = parseListContents(block);
      newOption.series.push(result);
    }
  });
  return newOption;
}

var DataView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(DataView, _super);

  function DataView() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DataView.prototype.onclick = function (ecModel, api) {
    // FIXME: better way?
    setTimeout(function () {
      api.dispatchAction({
        type: 'hideTip'
      });
    });
    var container = api.getDom();
    var model = this.model;

    if (this._dom) {
      container.removeChild(this._dom);
    }

    var root = document.createElement('div'); // use padding to avoid 5px whitespace

    root.style.cssText = 'position:absolute;top:0;bottom:0;left:0;right:0;padding:5px';
    root.style.backgroundColor = model.get('backgroundColor') || '#fff'; // Create elements

    var header = document.createElement('h4');
    var lang = model.get('lang') || [];
    header.innerHTML = lang[0] || model.get('title');
    header.style.cssText = 'margin:10px 20px';
    header.style.color = model.get('textColor');
    var viewMain = document.createElement('div');
    var textarea = document.createElement('textarea');
    viewMain.style.cssText = 'overflow:auto';
    var optionToContent = model.get('optionToContent');
    var contentToOption = model.get('contentToOption');
    var result = getContentFromModel(ecModel);

    if (__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isFunction"](optionToContent)) {
      var htmlOrDom = optionToContent(api.getOption());

      if (__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isString"](htmlOrDom)) {
        viewMain.innerHTML = htmlOrDom;
      } else if (__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isDom"](htmlOrDom)) {
        viewMain.appendChild(htmlOrDom);
      }
    } else {
      // Use default textarea
      textarea.readOnly = model.get('readOnly');
      var style = textarea.style; // eslint-disable-next-line max-len

      style.cssText = 'display:block;width:100%;height:100%;font-family:monospace;font-size:14px;line-height:1.6rem;resize:none;box-sizing:border-box;outline:none';
      style.color = model.get('textColor');
      style.borderColor = model.get('textareaBorderColor');
      style.backgroundColor = model.get('textareaColor');
      textarea.value = result.value;
      viewMain.appendChild(textarea);
    }

    var blockMetaList = result.meta;
    var buttonContainer = document.createElement('div');
    buttonContainer.style.cssText = 'position:absolute;bottom:5px;left:0;right:0'; // eslint-disable-next-line max-len

    var buttonStyle = 'float:right;margin-right:20px;border:none;cursor:pointer;padding:2px 5px;font-size:12px;border-radius:3px';
    var closeButton = document.createElement('div');
    var refreshButton = document.createElement('div');
    buttonStyle += ';background-color:' + model.get('buttonColor');
    buttonStyle += ';color:' + model.get('buttonTextColor');
    var self = this;

    function close() {
      container.removeChild(root);
      self._dom = null;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_event_js__["f" /* addEventListener */])(closeButton, 'click', close);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_event_js__["f" /* addEventListener */])(refreshButton, 'click', function () {
      if (contentToOption == null && optionToContent != null || contentToOption != null && optionToContent == null) {
        if (true) {
          // eslint-disable-next-line
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_log_js__["b" /* warn */])('It seems you have just provided one of `contentToOption` and `optionToContent` functions but missed the other one. Data change is ignored.');
        }

        close();
        return;
      }

      var newOption;

      try {
        if (__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isFunction"](contentToOption)) {
          newOption = contentToOption(viewMain, api.getOption());
        } else {
          newOption = parseContents(textarea.value, blockMetaList);
        }
      } catch (e) {
        close();
        throw new Error('Data view format error ' + e);
      }

      if (newOption) {
        api.dispatchAction({
          type: 'changeDataView',
          newOption: newOption
        });
      }

      close();
    });
    closeButton.innerHTML = lang[1];
    refreshButton.innerHTML = lang[2];
    refreshButton.style.cssText = closeButton.style.cssText = buttonStyle;
    !model.get('readOnly') && buttonContainer.appendChild(refreshButton);
    buttonContainer.appendChild(closeButton);
    root.appendChild(header);
    root.appendChild(viewMain);
    root.appendChild(buttonContainer);
    viewMain.style.height = container.clientHeight - 80 + 'px';
    container.appendChild(root);
    this._dom = root;
  };

  DataView.prototype.remove = function (ecModel, api) {
    this._dom && api.getDom().removeChild(this._dom);
  };

  DataView.prototype.dispose = function (ecModel, api) {
    this.remove(ecModel, api);
  };

  DataView.getDefaultOption = function (ecModel) {
    var defaultOption = {
      show: true,
      readOnly: false,
      optionToContent: null,
      contentToOption: null,
      // eslint-disable-next-line
      icon: 'M17.5,17.3H33 M17.5,17.3H33 M45.4,29.5h-28 M11.5,2v56H51V14.8L38.4,2H11.5z M38.4,2.2v12.7H51 M45.4,41.7h-28',
      title: ecModel.getLocaleModel().get(['toolbox', 'dataView', 'title']),
      lang: ecModel.getLocaleModel().get(['toolbox', 'dataView', 'lang']),
      backgroundColor: '#fff',
      textColor: '#000',
      textareaColor: '#fff',
      textareaBorderColor: '#333',
      buttonColor: '#c23531',
      buttonTextColor: '#fff'
    };
    return defaultOption;
  };

  return DataView;
}(__WEBPACK_IMPORTED_MODULE_3__featureManager_js__["b" /* ToolboxFeature */]);
/**
 * @inner
 */


function tryMergeDataOption(newData, originalData) {
  return __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["map"](newData, function (newVal, idx) {
    var original = originalData && originalData[idx];

    if (__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isObject"](original) && !__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isArray"](original)) {
      var newValIsObject = __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isObject"](newVal) && !__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["isArray"](newVal);

      if (!newValIsObject) {
        newVal = {
          value: newVal
        };
      } // original data has name but new data has no name


      var shouldDeleteName = original.name != null && newVal.name == null; // Original data has option

      newVal = __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["defaults"](newVal, original);
      shouldDeleteName && delete newVal.name;
      return newVal;
    } else {
      return newVal;
    }
  });
} // TODO: SELF REGISTERED.


__WEBPACK_IMPORTED_MODULE_1__core_echarts_js__["a" /* registerAction */]({
  type: 'changeDataView',
  event: 'dataViewChanged',
  update: 'prepareAndUpdate'
}, function (payload, ecModel) {
  var newSeriesOptList = [];
  __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"](payload.newOption.series, function (seriesOpt) {
    var seriesModel = ecModel.getSeriesByName(seriesOpt.name)[0];

    if (!seriesModel) {
      // New created series
      // Geuss the series type
      newSeriesOptList.push(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["extend"]({
        // Default is scatter
        type: 'scatter'
      }, seriesOpt));
    } else {
      var originalData = seriesModel.get('data');
      newSeriesOptList.push({
        name: seriesOpt.name,
        data: tryMergeDataOption(seriesOpt.data, originalData)
      });
    }
  });
  ecModel.mergeOption(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["defaults"]({
    series: newSeriesOptList
  }, payload.newOption));
});
/* harmony default export */ __webpack_exports__["a"] = (DataView);

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_BrushController_js__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_BrushTargetManager_js__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dataZoom_history_js__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_sliderMove_js__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__featureManager_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_internalComponentCreator_js__ = __webpack_require__(498);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
 // TODO depends on DataZoom and Brush









var each = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"];
var DATA_ZOOM_ID_BASE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_model_js__["w" /* makeInternalComponentId */])('toolbox-dataZoom_');
var ICON_TYPES = ['zoom', 'back'];

var DataZoomFeature =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(DataZoomFeature, _super);

  function DataZoomFeature() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DataZoomFeature.prototype.render = function (featureModel, ecModel, api, payload) {
    if (!this._brushController) {
      this._brushController = new __WEBPACK_IMPORTED_MODULE_2__helper_BrushController_js__["a" /* default */](api.getZr());

      this._brushController.on('brush', __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"](this._onBrush, this)).mount();
    }

    updateZoomBtnStatus(featureModel, ecModel, this, payload, api);
    updateBackBtnStatus(featureModel, ecModel);
  };

  DataZoomFeature.prototype.onclick = function (ecModel, api, type) {
    handlers[type].call(this);
  };

  DataZoomFeature.prototype.remove = function (ecModel, api) {
    this._brushController && this._brushController.unmount();
  };

  DataZoomFeature.prototype.dispose = function (ecModel, api) {
    this._brushController && this._brushController.dispose();
  };

  DataZoomFeature.prototype._onBrush = function (eventParam) {
    var areas = eventParam.areas;

    if (!eventParam.isEnd || !areas.length) {
      return;
    }

    var snapshot = {};
    var ecModel = this.ecModel;

    this._brushController.updateCovers([]); // remove cover


    var brushTargetManager = new __WEBPACK_IMPORTED_MODULE_3__helper_BrushTargetManager_js__["a" /* default */](makeAxisFinder(this.model), ecModel, {
      include: ['grid']
    });
    brushTargetManager.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
      if (coordSys.type !== 'cartesian2d') {
        return;
      }

      var brushType = area.brushType;

      if (brushType === 'rect') {
        setBatch('x', coordSys, coordRange[0]);
        setBatch('y', coordSys, coordRange[1]);
      } else {
        setBatch({
          lineX: 'x',
          lineY: 'y'
        }[brushType], coordSys, coordRange);
      }
    });
    __WEBPACK_IMPORTED_MODULE_4__dataZoom_history_js__["b" /* push */](ecModel, snapshot);

    this._dispatchZoomAction(snapshot);

    function setBatch(dimName, coordSys, minMax) {
      var axis = coordSys.getAxis(dimName);
      var axisModel = axis.model;
      var dataZoomModel = findDataZoom(dimName, axisModel, ecModel); // Restrict range.

      var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy(axisModel).getMinMaxSpan();

      if (minMaxSpan.minValueSpan != null || minMaxSpan.maxValueSpan != null) {
        minMax = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helper_sliderMove_js__["a" /* default */])(0, minMax.slice(), axis.scale.getExtent(), 0, minMaxSpan.minValueSpan, minMaxSpan.maxValueSpan);
      }

      dataZoomModel && (snapshot[dataZoomModel.id] = {
        dataZoomId: dataZoomModel.id,
        startValue: minMax[0],
        endValue: minMax[1]
      });
    }

    function findDataZoom(dimName, axisModel, ecModel) {
      var found;
      ecModel.eachComponent({
        mainType: 'dataZoom',
        subType: 'select'
      }, function (dzModel) {
        var has = dzModel.getAxisModel(dimName, axisModel.componentIndex);
        has && (found = dzModel);
      });
      return found;
    }
  };

  ;

  DataZoomFeature.prototype._dispatchZoomAction = function (snapshot) {
    var batch = []; // Convert from hash map to array.

    each(snapshot, function (batchItem, dataZoomId) {
      batch.push(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"](batchItem));
    });
    batch.length && this.api.dispatchAction({
      type: 'dataZoom',
      from: this.uid,
      batch: batch
    });
  };

  DataZoomFeature.getDefaultOption = function (ecModel) {
    var defaultOption = {
      show: true,
      filterMode: 'filter',
      // Icon group
      icon: {
        zoom: 'M0,13.5h26.9 M13.5,26.9V0 M32.1,13.5H58V58H13.5 V32.1',
        back: 'M22,1.4L9.9,13.5l12.3,12.3 M10.3,13.5H54.9v44.6 H10.3v-26'
      },
      // `zoom`, `back`
      title: ecModel.getLocaleModel().get(['toolbox', 'dataZoom', 'title']),
      brushStyle: {
        borderWidth: 0,
        color: 'rgba(210,219,238,0.2)'
      }
    };
    return defaultOption;
  };

  return DataZoomFeature;
}(__WEBPACK_IMPORTED_MODULE_6__featureManager_js__["b" /* ToolboxFeature */]);

var handlers = {
  zoom: function () {
    var nextActive = !this._isZoomActive;
    this.api.dispatchAction({
      type: 'takeGlobalCursor',
      key: 'dataZoomSelect',
      dataZoomSelectActive: nextActive
    });
  },
  back: function () {
    this._dispatchZoomAction(__WEBPACK_IMPORTED_MODULE_4__dataZoom_history_js__["c" /* pop */](this.ecModel));
  }
};

function makeAxisFinder(dzFeatureModel) {
  var setting = {
    xAxisIndex: dzFeatureModel.get('xAxisIndex', true),
    yAxisIndex: dzFeatureModel.get('yAxisIndex', true),
    xAxisId: dzFeatureModel.get('xAxisId', true),
    yAxisId: dzFeatureModel.get('yAxisId', true)
  }; // If both `xAxisIndex` `xAxisId` not set, it means 'all'.
  // If both `yAxisIndex` `yAxisId` not set, it means 'all'.
  // Some old cases set like this below to close yAxis control but leave xAxis control:
  // `{ feature: { dataZoom: { yAxisIndex: false } }`.

  if (setting.xAxisIndex == null && setting.xAxisId == null) {
    setting.xAxisIndex = 'all';
  }

  if (setting.yAxisIndex == null && setting.yAxisId == null) {
    setting.yAxisIndex = 'all';
  }

  return setting;
}

function updateBackBtnStatus(featureModel, ecModel) {
  featureModel.setIconStatus('back', __WEBPACK_IMPORTED_MODULE_4__dataZoom_history_js__["d" /* count */](ecModel) > 1 ? 'emphasis' : 'normal');
}

function updateZoomBtnStatus(featureModel, ecModel, view, payload, api) {
  var zoomActive = view._isZoomActive;

  if (payload && payload.type === 'takeGlobalCursor') {
    zoomActive = payload.key === 'dataZoomSelect' ? payload.dataZoomSelectActive : false;
  }

  view._isZoomActive = zoomActive;
  featureModel.setIconStatus('zoom', zoomActive ? 'emphasis' : 'normal');
  var brushTargetManager = new __WEBPACK_IMPORTED_MODULE_3__helper_BrushTargetManager_js__["a" /* default */](makeAxisFinder(featureModel), ecModel, {
    include: ['grid']
  });
  var panels = brushTargetManager.makePanelOpts(api, function (targetInfo) {
    return targetInfo.xAxisDeclared && !targetInfo.yAxisDeclared ? 'lineX' : !targetInfo.xAxisDeclared && targetInfo.yAxisDeclared ? 'lineY' : 'rect';
  });

  view._brushController.setPanels(panels).enableBrush(zoomActive && panels.length ? {
    brushType: 'auto',
    brushStyle: featureModel.getModel('brushStyle').getItemStyle()
  } : false);
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__model_internalComponentCreator_js__["b" /* registerInternalOptionCreator */])('dataZoom', function (ecModel) {
  var toolboxModel = ecModel.getComponent('toolbox', 0);
  var featureDataZoomPath = ['feature', 'dataZoom'];

  if (!toolboxModel || toolboxModel.get(featureDataZoomPath) == null) {
    return;
  }

  var dzFeatureModel = toolboxModel.getModel(featureDataZoomPath);
  var dzOptions = [];
  var finder = makeAxisFinder(dzFeatureModel);
  var finderResult = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_model_js__["l" /* parseFinder */])(ecModel, finder);
  each(finderResult.xAxisModels, function (axisModel) {
    return buildInternalOptions(axisModel, 'xAxis', 'xAxisIndex');
  });
  each(finderResult.yAxisModels, function (axisModel) {
    return buildInternalOptions(axisModel, 'yAxis', 'yAxisIndex');
  });

  function buildInternalOptions(axisModel, axisMainType, axisIndexPropName) {
    var axisIndex = axisModel.componentIndex;
    var newOpt = {
      type: 'select',
      $fromToolbox: true,
      // Default to be filter
      filterMode: dzFeatureModel.get('filterMode', true) || 'filter',
      // Id for merge mapping.
      id: DATA_ZOOM_ID_BASE + axisMainType + axisIndex
    };
    newOpt[axisIndexPropName] = axisIndex;
    dzOptions.push(newOpt);
  }

  return dzOptions;
});
/* harmony default export */ __webpack_exports__["a"] = (DataZoomFeature);

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_echarts_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__featureManager_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var INNER_STACK_KEYWORD = '__ec_magicType_stack__';
var ICON_TYPES = ['line', 'bar', 'stack']; // stack and tiled appears in pair for the title

var TITLE_TYPES = ['line', 'bar', 'stack', 'tiled'];
var radioTypes = [['line', 'bar'], ['stack']];

var MagicType =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(MagicType, _super);

  function MagicType() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MagicType.prototype.getIcons = function () {
    var model = this.model;
    var availableIcons = model.get('icon');
    var icons = {};
    __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"](model.get('type'), function (type) {
      if (availableIcons[type]) {
        icons[type] = availableIcons[type];
      }
    });
    return icons;
  };

  MagicType.getDefaultOption = function (ecModel) {
    var defaultOption = {
      show: true,
      type: [],
      // Icon group
      icon: {
        line: 'M4.1,28.9h7.1l9.3-22l7.4,38l9.7-19.7l3,12.8h14.9M4.1,58h51.4',
        bar: 'M6.7,22.9h10V48h-10V22.9zM24.9,13h10v35h-10V13zM43.2,2h10v46h-10V2zM3.1,58h53.7',
        // eslint-disable-next-line
        stack: 'M8.2,38.4l-8.4,4.1l30.6,15.3L60,42.5l-8.1-4.1l-21.5,11L8.2,38.4z M51.9,30l-8.1,4.2l-13.4,6.9l-13.9-6.9L8.2,30l-8.4,4.2l8.4,4.2l22.2,11l21.5-11l8.1-4.2L51.9,30z M51.9,21.7l-8.1,4.2L35.7,30l-5.3,2.8L24.9,30l-8.4-4.1l-8.3-4.2l-8.4,4.2L8.2,30l8.3,4.2l13.9,6.9l13.4-6.9l8.1-4.2l8.1-4.1L51.9,21.7zM30.4,2.2L-0.2,17.5l8.4,4.1l8.3,4.2l8.4,4.2l5.5,2.7l5.3-2.7l8.1-4.2l8.1-4.2l8.1-4.1L30.4,2.2z' // jshint ignore:line

      },
      // `line`, `bar`, `stack`, `tiled`
      title: ecModel.getLocaleModel().get(['toolbox', 'magicType', 'title']),
      option: {},
      seriesIndex: {}
    };
    return defaultOption;
  };

  MagicType.prototype.onclick = function (ecModel, api, type) {
    var model = this.model;
    var seriesIndex = model.get(['seriesIndex', type]); // Not supported magicType

    if (!seriesOptGenreator[type]) {
      return;
    }

    var newOption = {
      series: []
    };

    var generateNewSeriesTypes = function (seriesModel) {
      var seriesType = seriesModel.subType;
      var seriesId = seriesModel.id;
      var newSeriesOpt = seriesOptGenreator[type](seriesType, seriesId, seriesModel, model);

      if (newSeriesOpt) {
        // PENDING If merge original option?
        __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["defaults"](newSeriesOpt, seriesModel.option);
        newOption.series.push(newSeriesOpt);
      } // Modify boundaryGap


      var coordSys = seriesModel.coordinateSystem;

      if (coordSys && coordSys.type === 'cartesian2d' && (type === 'line' || type === 'bar')) {
        var categoryAxis = coordSys.getAxesByScale('ordinal')[0];

        if (categoryAxis) {
          var axisDim = categoryAxis.dim;
          var axisType = axisDim + 'Axis';
          var axisModel = seriesModel.getReferringComponents(axisType, __WEBPACK_IMPORTED_MODULE_4__util_model_js__["i" /* SINGLE_REFERRING */]).models[0];
          var axisIndex = axisModel.componentIndex;
          newOption[axisType] = newOption[axisType] || [];

          for (var i = 0; i <= axisIndex; i++) {
            newOption[axisType][axisIndex] = newOption[axisType][axisIndex] || {};
          }

          newOption[axisType][axisIndex].boundaryGap = type === 'bar';
        }
      }
    };

    __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"](radioTypes, function (radio) {
      if (__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["indexOf"](radio, type) >= 0) {
        __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"](radio, function (item) {
          model.setIconStatus(item, 'normal');
        });
      }
    });
    model.setIconStatus(type, 'emphasis');
    ecModel.eachComponent({
      mainType: 'series',
      query: seriesIndex == null ? null : {
        seriesIndex: seriesIndex
      }
    }, generateNewSeriesTypes);
    var newTitle;
    var currentType = type; // Change title of stack

    if (type === 'stack') {
      // use titles in model instead of ecModel
      // as stack and tiled appears in pair, just flip them
      // no need of checking stack state
      newTitle = __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["merge"]({
        stack: model.option.title.tiled,
        tiled: model.option.title.stack
      }, model.option.title);

      if (model.get(['iconStatus', type]) !== 'emphasis') {
        currentType = 'tiled';
      }
    }

    api.dispatchAction({
      type: 'changeMagicType',
      currentType: currentType,
      newOption: newOption,
      newTitle: newTitle,
      featureName: 'magicType'
    });
  };

  return MagicType;
}(__WEBPACK_IMPORTED_MODULE_3__featureManager_js__["b" /* ToolboxFeature */]);

var seriesOptGenreator = {
  'line': function (seriesType, seriesId, seriesModel, model) {
    if (seriesType === 'bar') {
      return __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["merge"]({
        id: seriesId,
        type: 'line',
        // Preserve data related option
        data: seriesModel.get('data'),
        stack: seriesModel.get('stack'),
        markPoint: seriesModel.get('markPoint'),
        markLine: seriesModel.get('markLine')
      }, model.get(['option', 'line']) || {}, true);
    }
  },
  'bar': function (seriesType, seriesId, seriesModel, model) {
    if (seriesType === 'line') {
      return __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["merge"]({
        id: seriesId,
        type: 'bar',
        // Preserve data related option
        data: seriesModel.get('data'),
        stack: seriesModel.get('stack'),
        markPoint: seriesModel.get('markPoint'),
        markLine: seriesModel.get('markLine')
      }, model.get(['option', 'bar']) || {}, true);
    }
  },
  'stack': function (seriesType, seriesId, seriesModel, model) {
    var isStack = seriesModel.get('stack') === INNER_STACK_KEYWORD;

    if (seriesType === 'line' || seriesType === 'bar') {
      model.setIconStatus('stack', isStack ? 'normal' : 'emphasis');
      return __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["merge"]({
        id: seriesId,
        stack: isStack ? '' : INNER_STACK_KEYWORD
      }, model.get(['option', 'stack']) || {}, true);
    }
  }
}; // TODO: SELF REGISTERED.

__WEBPACK_IMPORTED_MODULE_1__core_echarts_js__["a" /* registerAction */]({
  type: 'changeMagicType',
  event: 'magicTypeChanged',
  update: 'prepareAndUpdate'
}, function (payload, ecModel) {
  ecModel.mergeOption(payload.newOption);
});
/* harmony default export */ __webpack_exports__["a"] = (MagicType);

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_echarts_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dataZoom_history_js__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__featureManager_js__ = __webpack_require__(86);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var RestoreOption =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(RestoreOption, _super);

  function RestoreOption() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  RestoreOption.prototype.onclick = function (ecModel, api) {
    __WEBPACK_IMPORTED_MODULE_2__dataZoom_history_js__["a" /* clear */](ecModel);
    api.dispatchAction({
      type: 'restore',
      from: this.uid
    });
  };

  RestoreOption.getDefaultOption = function (ecModel) {
    var defaultOption = {
      show: true,
      // eslint-disable-next-line
      icon: 'M3.8,33.4 M47,18.9h9.8V8.7 M56.3,20.1 C52.1,9,40.5,0.6,26.8,2.1C12.6,3.7,1.6,16.2,2.1,30.6 M13,41.1H3.1v10.2 M3.7,39.9c4.2,11.1,15.8,19.5,29.5,18 c14.2-1.6,25.2-14.1,24.7-28.5',
      title: ecModel.getLocaleModel().get(['toolbox', 'restore', 'title'])
    };
    return defaultOption;
  };

  return RestoreOption;
}(__WEBPACK_IMPORTED_MODULE_3__featureManager_js__["b" /* ToolboxFeature */]); // TODO: SELF REGISTERED.


__WEBPACK_IMPORTED_MODULE_1__core_echarts_js__["a" /* registerAction */]({
  type: 'restore',
  event: 'restore',
  update: 'prepareAndUpdate'
}, function (payload, ecModel) {
  ecModel.resetOption('recreate');
});
/* harmony default export */ __webpack_exports__["a"] = (RestoreOption);

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_env_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__featureManager_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/* global Uint8Array, document */




/* global window, document */

var SaveAsImage =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(SaveAsImage, _super);

  function SaveAsImage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  SaveAsImage.prototype.onclick = function (ecModel, api) {
    var model = this.model;
    var title = model.get('name') || ecModel.get('title.0.text') || 'echarts';
    var isSvg = api.getZr().painter.getType() === 'svg';
    var type = isSvg ? 'svg' : model.get('type', true) || 'png';
    var url = api.getConnectedDataURL({
      type: type,
      backgroundColor: model.get('backgroundColor', true) || ecModel.get('backgroundColor') || '#fff',
      connectedBackgroundColor: model.get('connectedBackgroundColor'),
      excludeComponents: model.get('excludeComponents'),
      pixelRatio: model.get('pixelRatio')
    });
    var browser = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_env_js__["a" /* default */].browser; // Chrome, Firefox, New Edge

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["isFunction"])(MouseEvent) && (browser.newEdge || !browser.ie && !browser.edge)) {
      var $a = document.createElement('a');
      $a.download = title + '.' + type;
      $a.target = '_blank';
      $a.href = url;
      var evt = new MouseEvent('click', {
        // some micro front-end framework， window maybe is a Proxy
        view: document.defaultView,
        bubbles: true,
        cancelable: false
      });
      $a.dispatchEvent(evt);
    } // IE or old Edge
    else {
        // @ts-ignore
        if (window.navigator.msSaveOrOpenBlob || isSvg) {
          var parts = url.split(','); // data:[<mime type>][;charset=<charset>][;base64],<encoded data>

          var base64Encoded = parts[0].indexOf('base64') > -1;
          var bstr = isSvg // should decode the svg data uri first
          ? decodeURIComponent(parts[1]) : parts[1]; // only `atob` when the data uri is encoded with base64
          // otherwise, like `svg` data uri exported by zrender,
          // there will be an error, for it's not encoded with base64.
          // (just a url-encoded string through `encodeURIComponent`)

          base64Encoded && (bstr = window.atob(bstr));
          var filename = title + '.' + type; // @ts-ignore

          if (window.navigator.msSaveOrOpenBlob) {
            var n = bstr.length;
            var u8arr = new Uint8Array(n);

            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }

            var blob = new Blob([u8arr]); // @ts-ignore

            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            var frame = document.createElement('iframe');
            document.body.appendChild(frame);
            var cw = frame.contentWindow;
            var doc = cw.document;
            doc.open('image/svg+xml', 'replace');
            doc.write(bstr);
            doc.close();
            cw.focus();
            doc.execCommand('SaveAs', true, filename);
            document.body.removeChild(frame);
          }
        } else {
          var lang = model.get('lang');
          var html = '' + '<body style="margin:0;">' + '<img src="' + url + '" style="max-width:100%;" title="' + (lang && lang[0] || '') + '" />' + '</body>';
          var tab = window.open();
          tab.document.write(html);
          tab.document.title = title;
        }
      }
  };

  SaveAsImage.getDefaultOption = function (ecModel) {
    var defaultOption = {
      show: true,
      icon: 'M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0',
      title: ecModel.getLocaleModel().get(['toolbox', 'saveAsImage', 'title']),
      type: 'png',
      // Default use option.backgroundColor
      // backgroundColor: '#fff',
      connectedBackgroundColor: '#fff',
      name: '',
      excludeComponents: ['toolbox'],
      // use current pixel ratio of device by default
      // pixelRatio: 1,
      lang: ecModel.getLocaleModel().get(['toolbox', 'saveAsImage', 'lang'])
    };
    return defaultOption;
  };

  return SaveAsImage;
}(__WEBPACK_IMPORTED_MODULE_2__featureManager_js__["b" /* ToolboxFeature */]);

/* harmony default export */ __webpack_exports__["a"] = (SaveAsImage);

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extension_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_dataZoom_installDataZoomSelect_js__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ToolboxModel_js__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ToolboxView_js__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__featureManager_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__feature_SaveAsImage_js__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__feature_MagicType_js__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__feature_DataView_js__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__feature_Restore_js__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__feature_DataZoom_js__ = __webpack_require__(1264);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



 // TODOD: REGISTER IN INSTALL







function install(registers) {
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_2__ToolboxModel_js__["a" /* default */]);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_3__ToolboxView_js__["a" /* default */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__featureManager_js__["a" /* registerFeature */])('saveAsImage', __WEBPACK_IMPORTED_MODULE_5__feature_SaveAsImage_js__["a" /* default */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__featureManager_js__["a" /* registerFeature */])('magicType', __WEBPACK_IMPORTED_MODULE_6__feature_MagicType_js__["a" /* default */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__featureManager_js__["a" /* registerFeature */])('dataView', __WEBPACK_IMPORTED_MODULE_7__feature_DataView_js__["a" /* default */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__featureManager_js__["a" /* registerFeature */])('dataZoom', __WEBPACK_IMPORTED_MODULE_9__feature_DataZoom_js__["a" /* default */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__featureManager_js__["a" /* registerFeature */])('restore', __WEBPACK_IMPORTED_MODULE_8__feature_Restore_js__["a" /* default */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_1__component_dataZoom_installDataZoomSelect_js__["a" /* install */]);
}

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_event_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_dom_js__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_env_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_format_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper_js__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tooltipMarkup_js__ = __webpack_require__(48);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







/* global document, window */

var CSS_TRANSITION_VENDOR = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helper_js__["b" /* toCSSVendorPrefix */])(__WEBPACK_IMPORTED_MODULE_5__helper_js__["c" /* TRANSITION_VENDOR */], 'transition');
var CSS_TRANSFORM_VENDOR = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helper_js__["b" /* toCSSVendorPrefix */])(__WEBPACK_IMPORTED_MODULE_5__helper_js__["d" /* TRANSFORM_VENDOR */], 'transform'); // eslint-disable-next-line

var gCssText = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;" + (__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_env_js__["a" /* default */].transform3dSupported ? 'will-change:transform;' : '');

function mirrorPos(pos) {
  pos = pos === 'left' ? 'right' : pos === 'right' ? 'left' : pos === 'top' ? 'bottom' : 'top';
  return pos;
}

function assembleArrow(tooltipModel, borderColor, arrowPosition) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"])(arrowPosition) || arrowPosition === 'inside') {
    return '';
  }

  var backgroundColor = tooltipModel.get('backgroundColor');
  var borderWidth = tooltipModel.get('borderWidth');
  borderColor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_format_js__["d" /* convertToColorString */])(borderColor);
  var arrowPos = mirrorPos(arrowPosition);
  var arrowSize = Math.max(Math.round(borderWidth) * 1.5, 6);
  var positionStyle = '';
  var transformStyle = CSS_TRANSFORM_VENDOR + ':';
  var rotateDeg;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"])(['left', 'right'], arrowPos) > -1) {
    positionStyle += 'top:50%';
    transformStyle += "translateY(-50%) rotate(" + (rotateDeg = arrowPos === 'left' ? -225 : -45) + "deg)";
  } else {
    positionStyle += 'left:50%';
    transformStyle += "translateX(-50%) rotate(" + (rotateDeg = arrowPos === 'top' ? 225 : 45) + "deg)";
  }

  var rotateRadian = rotateDeg * Math.PI / 180;
  var arrowWH = arrowSize + borderWidth;
  var rotatedWH = arrowWH * Math.abs(Math.cos(rotateRadian)) + arrowWH * Math.abs(Math.sin(rotateRadian));
  var arrowOffset = Math.round(((rotatedWH - Math.SQRT2 * borderWidth) / 2 + Math.SQRT2 * borderWidth - (rotatedWH - arrowWH) / 2) * 100) / 100;
  positionStyle += ";" + arrowPos + ":-" + arrowOffset + "px";
  var borderStyle = borderColor + " solid " + borderWidth + "px;";
  var styleCss = ["position:absolute;width:" + arrowSize + "px;height:" + arrowSize + "px;", positionStyle + ";" + transformStyle + ";", "border-bottom:" + borderStyle, "border-right:" + borderStyle, "background-color:" + backgroundColor + ";"];
  return "<div style=\"" + styleCss.join('') + "\"></div>";
}

function assembleTransition(duration, onlyFade) {
  var transitionCurve = 'cubic-bezier(0.23,1,0.32,1)';
  var transitionOption = " " + duration / 2 + "s " + transitionCurve;
  var transitionText = "opacity" + transitionOption + ",visibility" + transitionOption;

  if (!onlyFade) {
    transitionOption = " " + duration + "s " + transitionCurve;
    transitionText += __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_env_js__["a" /* default */].transformSupported ? "," + CSS_TRANSFORM_VENDOR + transitionOption : ",left" + transitionOption + ",top" + transitionOption;
  }

  return CSS_TRANSITION_VENDOR + ':' + transitionText;
}

function assembleTransform(x, y, toString) {
  // If using float on style, the final width of the dom might
  // keep changing slightly while mouse move. So `toFixed(0)` them.
  var x0 = x.toFixed(0) + 'px';
  var y0 = y.toFixed(0) + 'px'; // not support transform, use `left` and `top` instead.

  if (!__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_env_js__["a" /* default */].transformSupported) {
    return toString ? "top:" + y0 + ";left:" + x0 + ";" : [['top', y0], ['left', x0]];
  } // support transform


  var is3d = __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_env_js__["a" /* default */].transform3dSupported;
  var translate = "translate" + (is3d ? '3d' : '') + "(" + x0 + "," + y0 + (is3d ? ',0' : '') + ")";
  return toString ? 'top:0;left:0;' + CSS_TRANSFORM_VENDOR + ':' + translate + ';' : [['top', 0], ['left', 0], [__WEBPACK_IMPORTED_MODULE_5__helper_js__["d" /* TRANSFORM_VENDOR */], translate]];
}
/**
 * @param {Object} textStyle
 * @return {string}
 * @inner
 */


function assembleFont(textStyleModel) {
  var cssText = [];
  var fontSize = textStyleModel.get('fontSize');
  var color = textStyleModel.getTextColor();
  color && cssText.push('color:' + color);
  cssText.push('font:' + textStyleModel.getFont());
  fontSize // @ts-ignore, leave it to the tooltip refactor.
  && cssText.push('line-height:' + Math.round(fontSize * 3 / 2) + 'px');
  var shadowColor = textStyleModel.get('textShadowColor');
  var shadowBlur = textStyleModel.get('textShadowBlur') || 0;
  var shadowOffsetX = textStyleModel.get('textShadowOffsetX') || 0;
  var shadowOffsetY = textStyleModel.get('textShadowOffsetY') || 0;
  shadowColor && shadowBlur && cssText.push('text-shadow:' + shadowOffsetX + 'px ' + shadowOffsetY + 'px ' + shadowBlur + 'px ' + shadowColor);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(['decoration', 'align'], function (name) {
    var val = textStyleModel.get(name);
    val && cssText.push('text-' + name + ':' + val);
  });
  return cssText.join(';');
}

function assembleCssText(tooltipModel, enableTransition, onlyFade) {
  var cssText = [];
  var transitionDuration = tooltipModel.get('transitionDuration');
  var backgroundColor = tooltipModel.get('backgroundColor');
  var shadowBlur = tooltipModel.get('shadowBlur');
  var shadowColor = tooltipModel.get('shadowColor');
  var shadowOffsetX = tooltipModel.get('shadowOffsetX');
  var shadowOffsetY = tooltipModel.get('shadowOffsetY');
  var textStyleModel = tooltipModel.getModel('textStyle');
  var padding = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__tooltipMarkup_js__["e" /* getPaddingFromTooltipModel */])(tooltipModel, 'html');
  var boxShadow = shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor;
  cssText.push('box-shadow:' + boxShadow); // Animation transition. Do not animate when transitionDuration is 0.

  enableTransition && transitionDuration && cssText.push(assembleTransition(transitionDuration, onlyFade));

  if (backgroundColor) {
    cssText.push('background-color:' + backgroundColor);
  } // Border style


  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(['width', 'color', 'radius'], function (name) {
    var borderName = 'border-' + name;
    var camelCase = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_format_js__["i" /* toCamelCase */])(borderName);
    var val = tooltipModel.get(camelCase);
    val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
  }); // Text style

  cssText.push(assembleFont(textStyleModel)); // Padding

  if (padding != null) {
    cssText.push('padding:' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_format_js__["f" /* normalizeCssArray */])(padding).join('px ') + 'px');
  }

  return cssText.join(';') + ';';
} // If not able to make, do not modify the input `out`.


function makeStyleCoord(out, zr, appendToBody, zrX, zrY) {
  var zrPainter = zr && zr.painter;

  if (appendToBody) {
    var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();

    if (zrViewportRoot) {
      // Some APPs might use scale on body, so we support CSS transform here.
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_dom_js__["c" /* transformLocalCoord */])(out, zrViewportRoot, document.body, zrX, zrY);
    }
  } else {
    out[0] = zrX;
    out[1] = zrY; // xy should be based on canvas root. But tooltipContent is
    // the sibling of canvas root. So padding of ec container
    // should be considered here.

    var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();

    if (viewportRootOffset) {
      out[0] += viewportRootOffset.offsetLeft;
      out[1] += viewportRootOffset.offsetTop;
    }
  }

  out[2] = out[0] / zr.getWidth();
  out[3] = out[1] / zr.getHeight();
}

var TooltipHTMLContent =
/** @class */
function () {
  function TooltipHTMLContent(container, api, opt) {
    this._show = false;
    this._styleCoord = [0, 0, 0, 0];
    this._enterable = true;
    this._firstShow = true;
    this._longHide = true;

    if (__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_env_js__["a" /* default */].wxa) {
      return null;
    }

    var el = document.createElement('div'); // TODO: TYPE

    el.domBelongToZr = true;
    this.el = el;
    var zr = this._zr = api.getZr();
    var appendToBody = this._appendToBody = opt && opt.appendToBody;
    makeStyleCoord(this._styleCoord, zr, appendToBody, api.getWidth() / 2, api.getHeight() / 2);

    if (appendToBody) {
      document.body.appendChild(el);
    } else {
      container.appendChild(el);
    }

    this._container = container; // FIXME
    // Is it needed to trigger zr event manually if
    // the browser do not support `pointer-events: none`.

    var self = this;

    el.onmouseenter = function () {
      // clear the timeout in hideLater and keep showing tooltip
      if (self._enterable) {
        clearTimeout(self._hideTimeout);
        self._show = true;
      }

      self._inContent = true;
    };

    el.onmousemove = function (e) {
      e = e || window.event;

      if (!self._enterable) {
        // `pointer-events: none` is set to tooltip content div
        // if `enterable` is set as `false`, and `el.onmousemove`
        // can not be triggered. But in browser that do not
        // support `pointer-events`, we need to do this:
        // Try trigger zrender event to avoid mouse
        // in and out shape too frequently
        var handler = zr.handler;
        var zrViewportRoot = zr.painter.getViewportRoot();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_event_js__["d" /* normalizeEvent */])(zrViewportRoot, e, true);
        handler.dispatch('mousemove', e);
      }
    };

    el.onmouseleave = function () {
      // set `_inContent` to `false` before `hideLater`
      self._inContent = false;

      if (self._enterable) {
        if (self._show) {
          self.hideLater(self._hideDelay);
        }
      }
    };
  }
  /**
   * Update when tooltip is rendered
   */


  TooltipHTMLContent.prototype.update = function (tooltipModel) {
    // FIXME
    // Move this logic to ec main?
    var container = this._container;
    var position = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helper_js__["e" /* getComputedStyle */])(container, 'position');
    var domStyle = container.style;

    if (domStyle.position !== 'absolute' && position !== 'absolute') {
      domStyle.position = 'relative';
    } // move tooltip if chart resized


    var alwaysShowContent = tooltipModel.get('alwaysShowContent');
    alwaysShowContent && this._moveIfResized(); // update className

    this.el.className = tooltipModel.get('className') || ''; // Hide the tooltip
    // PENDING
    // this.hide();
  };

  TooltipHTMLContent.prototype.show = function (tooltipModel, nearPointColor) {
    clearTimeout(this._hideTimeout);
    clearTimeout(this._longHideTimeout);
    var el = this.el;
    var style = el.style;
    var styleCoord = this._styleCoord;

    if (!el.innerHTML) {
      style.display = 'none';
    } else {
      style.cssText = gCssText + assembleCssText(tooltipModel, !this._firstShow, this._longHide) // initial transform
      + assembleTransform(styleCoord[0], styleCoord[1], true) + ("border-color:" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_format_js__["d" /* convertToColorString */])(nearPointColor) + ";") + (tooltipModel.get('extraCssText') || '') // If mouse occasionally move over the tooltip, a mouseout event will be
      // triggered by canvas, and cause some unexpectable result like dragging
      // stop, "unfocusAdjacency". Here `pointer-events: none` is used to solve
      // it. Although it is not supported by IE8~IE10, fortunately it is a rare
      // scenario.
      + (";pointer-events:" + (this._enterable ? 'auto' : 'none'));
    }

    this._show = true;
    this._firstShow = false;
    this._longHide = false;
  };

  TooltipHTMLContent.prototype.setContent = function (content, markers, tooltipModel, borderColor, arrowPosition) {
    var el = this.el;

    if (content == null) {
      el.innerHTML = '';
      return;
    }

    var arrow = '';

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"])(arrowPosition) && tooltipModel.get('trigger') === 'item' && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helper_js__["a" /* shouldTooltipConfine */])(tooltipModel)) {
      arrow = assembleArrow(tooltipModel, borderColor, arrowPosition);
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"])(content)) {
      el.innerHTML = content + arrow;
    } else if (content) {
      // Clear previous
      el.innerHTML = '';

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"])(content)) {
        content = [content];
      }

      for (var i = 0; i < content.length; i++) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isDom"])(content[i]) && content[i].parentNode !== el) {
          el.appendChild(content[i]);
        }
      } // no arrow if empty


      if (arrow && el.childNodes.length) {
        // no need to create a new parent element, but it's not supported by IE 10 and older.
        // const arrowEl = document.createRange().createContextualFragment(arrow);
        var arrowEl = document.createElement('div');
        arrowEl.innerHTML = arrow;
        el.appendChild(arrowEl);
      }
    }
  };

  TooltipHTMLContent.prototype.setEnterable = function (enterable) {
    this._enterable = enterable;
  };

  TooltipHTMLContent.prototype.getSize = function () {
    var el = this.el;
    return [el.offsetWidth, el.offsetHeight];
  };

  TooltipHTMLContent.prototype.moveTo = function (zrX, zrY) {
    var styleCoord = this._styleCoord;
    makeStyleCoord(styleCoord, this._zr, this._appendToBody, zrX, zrY);

    if (styleCoord[0] != null && styleCoord[1] != null) {
      var style_1 = this.el.style;
      var transforms = assembleTransform(styleCoord[0], styleCoord[1]);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(transforms, function (transform) {
        style_1[transform[0]] = transform[1];
      });
    }
  };
  /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */


  TooltipHTMLContent.prototype._moveIfResized = function () {
    // The ratio of left to width
    var ratioX = this._styleCoord[2]; // The ratio of top to height

    var ratioY = this._styleCoord[3];
    this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
  };

  TooltipHTMLContent.prototype.hide = function () {
    var _this = this;

    var style = this.el.style;
    style.visibility = 'hidden';
    style.opacity = '0';
    __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_env_js__["a" /* default */].transform3dSupported && (style.willChange = '');
    this._show = false;
    this._longHideTimeout = setTimeout(function () {
      return _this._longHide = true;
    }, 500);
  };

  TooltipHTMLContent.prototype.hideLater = function (time) {
    if (this._show && !(this._inContent && this._enterable)) {
      if (time) {
        this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times

        this._show = false;
        this._hideTimeout = setTimeout(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["bind"])(this.hide, this), time);
      } else {
        this.hide();
      }
    }
  };

  TooltipHTMLContent.prototype.isShow = function () {
    return this._show;
  };

  TooltipHTMLContent.prototype.dispose = function () {
    this.el.parentNode.removeChild(this.el);
  };

  return TooltipHTMLContent;
}();

/* harmony default export */ __webpack_exports__["a"] = (TooltipHTMLContent);

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_Component_js__ = __webpack_require__(21);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var TooltipModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(TooltipModel, _super);

  function TooltipModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = TooltipModel.type;
    return _this;
  }

  TooltipModel.type = 'tooltip';
  TooltipModel.dependencies = ['axisPointer'];
  TooltipModel.defaultOption = {
    // zlevel: 0,
    z: 60,
    show: true,
    // tooltip main content
    showContent: true,
    // 'trigger' only works on coordinate system.
    // 'item' | 'axis' | 'none'
    trigger: 'item',
    // 'click' | 'mousemove' | 'none'
    triggerOn: 'mousemove|click',
    alwaysShowContent: false,
    displayMode: 'single',
    renderMode: 'auto',
    // whether restraint content inside viewRect.
    // If renderMode: 'richText', default true.
    // If renderMode: 'html', defaut false (for backward compat).
    confine: null,
    showDelay: 0,
    hideDelay: 100,
    // Animation transition time, unit is second
    transitionDuration: 0.4,
    enterable: false,
    backgroundColor: '#fff',
    // box shadow
    shadowBlur: 10,
    shadowColor: 'rgba(0, 0, 0, .2)',
    shadowOffsetX: 1,
    shadowOffsetY: 2,
    // tooltip border radius, unit is px, default is 4
    borderRadius: 4,
    // tooltip border width, unit is px, default is 0 (no border)
    borderWidth: 1,
    // Tooltip inside padding, default is 5 for all direction
    // Array is allowed to set up, right, bottom, left, same with css
    // The default value: See `tooltip/tooltipMarkup.ts#getPaddingFromTooltipModel`.
    padding: null,
    // Extra css text
    extraCssText: '',
    // axis indicator, trigger by axis
    axisPointer: {
      // default is line
      // legal values: 'line' | 'shadow' | 'cross'
      type: 'line',
      // Valid when type is line, appoint tooltip line locate on which line. Optional
      // legal values: 'x' | 'y' | 'angle' | 'radius' | 'auto'
      // default is 'auto', chose the axis which type is category.
      // for multiply y axis, cartesian coord chose x axis, polar chose angle axis
      axis: 'auto',
      animation: 'auto',
      animationDurationUpdate: 200,
      animationEasingUpdate: 'exponentialOut',
      crossStyle: {
        color: '#999',
        width: 1,
        type: 'dashed',
        // TODO formatter
        textStyle: {}
      } // lineStyle and shadowStyle should not be specified here,
      // otherwise it will always override those styles on option.axisPointer.

    },
    textStyle: {
      color: '#666',
      fontSize: 14
    }
  };
  return TooltipModel;
}(__WEBPACK_IMPORTED_MODULE_1__model_Component_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TooltipModel);

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_graphic_Text_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tooltipMarkup_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_log_js__ = __webpack_require__(14);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var TooltipRichContent =
/** @class */
function () {
  function TooltipRichContent(api) {
    this._show = false;
    this._styleCoord = [0, 0, 0, 0];
    this._enterable = true;
    this._zr = api.getZr();
    makeStyleCoord(this._styleCoord, this._zr, api.getWidth() / 2, api.getHeight() / 2);
  }
  /**
   * Update when tooltip is rendered
   */


  TooltipRichContent.prototype.update = function (tooltipModel) {
    var alwaysShowContent = tooltipModel.get('alwaysShowContent');
    alwaysShowContent && this._moveIfResized();
  };

  TooltipRichContent.prototype.show = function () {
    if (this._hideTimeout) {
      clearTimeout(this._hideTimeout);
    }

    this.el.show();
    this._show = true;
  };
  /**
   * Set tooltip content
   */


  TooltipRichContent.prototype.setContent = function (content, markupStyleCreator, tooltipModel, borderColor, arrowPosition) {
    var _this = this;

    if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"](content)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_log_js__["e" /* throwError */])( true ? 'Passing DOM nodes as content is not supported in richText tooltip!' : '');
    }

    if (this.el) {
      this._zr.remove(this.el);
    }

    var textStyleModel = tooltipModel.getModel('textStyle');
    this.el = new __WEBPACK_IMPORTED_MODULE_1_zrender_lib_graphic_Text_js__["a" /* default */]({
      style: {
        rich: markupStyleCreator.richTextStyles,
        text: content,
        lineHeight: 22,
        borderWidth: 1,
        borderColor: borderColor,
        textShadowColor: textStyleModel.get('textShadowColor'),
        fill: tooltipModel.get(['textStyle', 'color']),
        padding: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tooltipMarkup_js__["e" /* getPaddingFromTooltipModel */])(tooltipModel, 'richText'),
        verticalAlign: 'top',
        align: 'left'
      },
      z: tooltipModel.get('z')
    });
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](['backgroundColor', 'borderRadius', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY'], function (propName) {
      _this.el.style[propName] = tooltipModel.get(propName);
    });
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](['textShadowBlur', 'textShadowOffsetX', 'textShadowOffsetY'], function (propName) {
      _this.el.style[propName] = textStyleModel.get(propName) || 0;
    });

    this._zr.add(this.el);

    var self = this;
    this.el.on('mouseover', function () {
      // clear the timeout in hideLater and keep showing tooltip
      if (self._enterable) {
        clearTimeout(self._hideTimeout);
        self._show = true;
      }

      self._inContent = true;
    });
    this.el.on('mouseout', function () {
      if (self._enterable) {
        if (self._show) {
          self.hideLater(self._hideDelay);
        }
      }

      self._inContent = false;
    });
  };

  TooltipRichContent.prototype.setEnterable = function (enterable) {
    this._enterable = enterable;
  };

  TooltipRichContent.prototype.getSize = function () {
    var el = this.el;
    var bounding = this.el.getBoundingRect(); // bounding rect does not include shadow. For renderMode richText,
    // if overflow, it will be cut. So calculate them accurately.

    var shadowOuterSize = calcShadowOuterSize(el.style);
    return [bounding.width + shadowOuterSize.left + shadowOuterSize.right, bounding.height + shadowOuterSize.top + shadowOuterSize.bottom];
  };

  TooltipRichContent.prototype.moveTo = function (x, y) {
    var el = this.el;

    if (el) {
      var styleCoord = this._styleCoord;
      makeStyleCoord(styleCoord, this._zr, x, y);
      x = styleCoord[0];
      y = styleCoord[1];
      var style = el.style;
      var borderWidth = mathMaxWith0(style.borderWidth || 0);
      var shadowOuterSize = calcShadowOuterSize(style); // rich text x, y do not include border.

      el.x = x + borderWidth + shadowOuterSize.left;
      el.y = y + borderWidth + shadowOuterSize.top;
      el.markRedraw();
    }
  };
  /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */


  TooltipRichContent.prototype._moveIfResized = function () {
    // The ratio of left to width
    var ratioX = this._styleCoord[2]; // The ratio of top to height

    var ratioY = this._styleCoord[3];
    this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
  };

  TooltipRichContent.prototype.hide = function () {
    if (this.el) {
      this.el.hide();
    }

    this._show = false;
  };

  TooltipRichContent.prototype.hideLater = function (time) {
    if (this._show && !(this._inContent && this._enterable)) {
      if (time) {
        this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times

        this._show = false;
        this._hideTimeout = setTimeout(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["bind"](this.hide, this), time);
      } else {
        this.hide();
      }
    }
  };

  TooltipRichContent.prototype.isShow = function () {
    return this._show;
  };

  TooltipRichContent.prototype.dispose = function () {
    this._zr.remove(this.el);
  };

  return TooltipRichContent;
}();

function mathMaxWith0(val) {
  return Math.max(0, val);
}

function calcShadowOuterSize(style) {
  var shadowBlur = mathMaxWith0(style.shadowBlur || 0);
  var shadowOffsetX = mathMaxWith0(style.shadowOffsetX || 0);
  var shadowOffsetY = mathMaxWith0(style.shadowOffsetY || 0);
  return {
    left: mathMaxWith0(shadowBlur - shadowOffsetX),
    right: mathMaxWith0(shadowBlur + shadowOffsetX),
    top: mathMaxWith0(shadowBlur - shadowOffsetY),
    bottom: mathMaxWith0(shadowBlur + shadowOffsetY)
  };
}

function makeStyleCoord(out, zr, zrX, zrY) {
  out[0] = zrX;
  out[1] = zrY;
  out[2] = out[0] / zr.getWidth();
  out[3] = out[1] / zr.getHeight();
}

/* harmony default export */ __webpack_exports__["a"] = (TooltipRichContent);

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_env_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TooltipHTMLContent_js__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TooltipRichContent_js__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_format_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__axisPointer_findPointFromSeries_js__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__model_Model_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__axisPointer_globalListener_js__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__coord_axisHelper_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__axisPointer_viewHelper_js__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__view_Component_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_time_js__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helper_js__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__model_mixin_dataFormat_js__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__tooltipMarkup_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__util_event_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_throttle_js__ = __webpack_require__(100);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/























var proxyRect = new __WEBPACK_IMPORTED_MODULE_7__util_graphic_js__["Rect"]({
  shape: {
    x: -1,
    y: -1,
    width: 2,
    height: 2
  }
});

var TooltipView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(TooltipView, _super);

  function TooltipView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = TooltipView.type;
    return _this;
  }

  TooltipView.prototype.init = function (ecModel, api) {
    if (__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_env_js__["a" /* default */].node || !api.getDom()) {
      return;
    }

    var tooltipModel = ecModel.getComponent('tooltip');
    var renderMode = this._renderMode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_model_js__["v" /* getTooltipRenderMode */])(tooltipModel.get('renderMode'));
    this._tooltipContent = renderMode === 'richText' ? new __WEBPACK_IMPORTED_MODULE_4__TooltipRichContent_js__["a" /* default */](api) : new __WEBPACK_IMPORTED_MODULE_3__TooltipHTMLContent_js__["a" /* default */](api.getDom(), api, {
      appendToBody: tooltipModel.get('appendToBody', true)
    });
  };

  TooltipView.prototype.render = function (tooltipModel, ecModel, api) {
    if (__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_env_js__["a" /* default */].node || !api.getDom()) {
      return;
    } // Reset


    this.group.removeAll();
    this._tooltipModel = tooltipModel;
    this._ecModel = ecModel;
    this._api = api;
    /**
     * @private
     * @type {boolean}
     */

    this._alwaysShowContent = tooltipModel.get('alwaysShowContent');
    var tooltipContent = this._tooltipContent;
    tooltipContent.update(tooltipModel);
    tooltipContent.setEnterable(tooltipModel.get('enterable'));

    this._initGlobalListener();

    this._keepShow(); // PENDING
    // `mousemove` event will be triggered very frequently when the mouse moves fast,
    // which causes that the `updatePosition` function was also called frequently.
    // In Chrome with devtools open and Firefox, tooltip looks laggy and shakes. See #14695 #16101
    // To avoid frequent triggering,
    // consider throttling it in 50ms when transition is enabled


    if (this._renderMode !== 'richText' && tooltipModel.get('transitionDuration')) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__util_throttle_js__["a" /* createOrUpdate */])(this, '_updatePosition', 50, 'fixRate');
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__util_throttle_js__["b" /* clear */])(this, '_updatePosition');
    }
  };

  TooltipView.prototype._initGlobalListener = function () {
    var tooltipModel = this._tooltipModel;
    var triggerOn = tooltipModel.get('triggerOn');
    __WEBPACK_IMPORTED_MODULE_11__axisPointer_globalListener_js__["a" /* register */]('itemTooltip', this._api, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(function (currTrigger, e, dispatchAction) {
      // If 'none', it is not controlled by mouse totally.
      if (triggerOn !== 'none') {
        if (triggerOn.indexOf(currTrigger) >= 0) {
          this._tryShow(e, dispatchAction);
        } else if (currTrigger === 'leave') {
          this._hide(dispatchAction);
        }
      }
    }, this));
  };

  TooltipView.prototype._keepShow = function () {
    var tooltipModel = this._tooltipModel;
    var ecModel = this._ecModel;
    var api = this._api; // Try to keep the tooltip show when refreshing

    if (this._lastX != null && this._lastY != null // When user is willing to control tooltip totally using API,
    // self.manuallyShowTip({x, y}) might cause tooltip hide,
    // which is not expected.
    && tooltipModel.get('triggerOn') !== 'none') {
      var self_1 = this;
      clearTimeout(this._refreshUpdateTimeout);
      this._refreshUpdateTimeout = setTimeout(function () {
        // Show tip next tick after other charts are rendered
        // In case highlight action has wrong result
        // FIXME
        !api.isDisposed() && self_1.manuallyShowTip(tooltipModel, ecModel, api, {
          x: self_1._lastX,
          y: self_1._lastY,
          dataByCoordSys: self_1._lastDataByCoordSys
        });
      });
    }
  };
  /**
   * Show tip manually by
   * dispatchAction({
   *     type: 'showTip',
   *     x: 10,
   *     y: 10
   * });
   * Or
   * dispatchAction({
   *      type: 'showTip',
   *      seriesIndex: 0,
   *      dataIndex or dataIndexInside or name
   * });
   *
   *  TODO Batch
   */


  TooltipView.prototype.manuallyShowTip = function (tooltipModel, ecModel, api, payload) {
    if (payload.from === this.uid || __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_env_js__["a" /* default */].node || !api.getDom()) {
      return;
    }

    var dispatchAction = makeDispatchAction(payload, api); // Reset ticket

    this._ticket = ''; // When triggered from axisPointer.

    var dataByCoordSys = payload.dataByCoordSys;
    var cmptRef = findComponentReference(payload, ecModel, api);

    if (cmptRef) {
      var rect = cmptRef.el.getBoundingRect().clone();
      rect.applyTransform(cmptRef.el.transform);

      this._tryShow({
        offsetX: rect.x + rect.width / 2,
        offsetY: rect.y + rect.height / 2,
        target: cmptRef.el,
        position: payload.position,
        // When manully trigger, the mouse is not on the el, so we'd better to
        // position tooltip on the bottom of the el and display arrow is possible.
        positionDefault: 'bottom'
      }, dispatchAction);
    } else if (payload.tooltip && payload.x != null && payload.y != null) {
      var el = proxyRect;
      el.x = payload.x;
      el.y = payload.y;
      el.update();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_innerStore_js__["a" /* getECData */])(el).tooltipConfig = {
        name: null,
        option: payload.tooltip
      }; // Manually show tooltip while view is not using zrender elements.

      this._tryShow({
        offsetX: payload.x,
        offsetY: payload.y,
        target: el
      }, dispatchAction);
    } else if (dataByCoordSys) {
      this._tryShow({
        offsetX: payload.x,
        offsetY: payload.y,
        position: payload.position,
        dataByCoordSys: dataByCoordSys,
        tooltipOption: payload.tooltipOption
      }, dispatchAction);
    } else if (payload.seriesIndex != null) {
      if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) {
        return;
      }

      var pointInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__axisPointer_findPointFromSeries_js__["a" /* default */])(payload, ecModel);
      var cx = pointInfo.point[0];
      var cy = pointInfo.point[1];

      if (cx != null && cy != null) {
        this._tryShow({
          offsetX: cx,
          offsetY: cy,
          target: pointInfo.el,
          position: payload.position,
          // When manully trigger, the mouse is not on the el, so we'd better to
          // position tooltip on the bottom of the el and display arrow is possible.
          positionDefault: 'bottom'
        }, dispatchAction);
      }
    } else if (payload.x != null && payload.y != null) {
      // FIXME
      // should wrap dispatchAction like `axisPointer/globalListener` ?
      api.dispatchAction({
        type: 'updateAxisPointer',
        x: payload.x,
        y: payload.y
      });

      this._tryShow({
        offsetX: payload.x,
        offsetY: payload.y,
        position: payload.position,
        target: api.getZr().findHover(payload.x, payload.y).target
      }, dispatchAction);
    }
  };

  TooltipView.prototype.manuallyHideTip = function (tooltipModel, ecModel, api, payload) {
    var tooltipContent = this._tooltipContent;

    if (!this._alwaysShowContent && this._tooltipModel) {
      tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
    }

    this._lastX = this._lastY = this._lastDataByCoordSys = null;

    if (payload.from !== this.uid) {
      this._hide(makeDispatchAction(payload, api));
    }
  }; // Be compatible with previous design, that is, when tooltip.type is 'axis' and
  // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
  // and tooltip.


  TooltipView.prototype._manuallyAxisShowTip = function (tooltipModel, ecModel, api, payload) {
    var seriesIndex = payload.seriesIndex;
    var dataIndex = payload.dataIndex; // @ts-ignore

    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;

    if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) {
      return;
    }

    var seriesModel = ecModel.getSeriesByIndex(seriesIndex);

    if (!seriesModel) {
      return;
    }

    var data = seriesModel.getData();
    var tooltipCascadedModel = buildTooltipModel([data.getItemModel(dataIndex), seriesModel, (seriesModel.coordinateSystem || {}).model], this._tooltipModel);

    if (tooltipCascadedModel.get('trigger') !== 'axis') {
      return;
    }

    api.dispatchAction({
      type: 'updateAxisPointer',
      seriesIndex: seriesIndex,
      dataIndex: dataIndex,
      position: payload.position
    });
    return true;
  };

  TooltipView.prototype._tryShow = function (e, dispatchAction) {
    var el = e.target;
    var tooltipModel = this._tooltipModel;

    if (!tooltipModel) {
      return;
    } // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed


    this._lastX = e.offsetX;
    this._lastY = e.offsetY;
    var dataByCoordSys = e.dataByCoordSys;

    if (dataByCoordSys && dataByCoordSys.length) {
      this._showAxisTooltip(dataByCoordSys, e);
    } else if (el) {
      this._lastDataByCoordSys = null;
      var seriesDispatcher_1;
      var cmptDispatcher_1;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__util_event_js__["a" /* findEventDispatcher */])(el, function (target) {
        // Always show item tooltip if mouse is on the element with dataIndex
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_innerStore_js__["a" /* getECData */])(target).dataIndex != null) {
          seriesDispatcher_1 = target;
          return true;
        } // Tooltip provided directly. Like legend.


        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_innerStore_js__["a" /* getECData */])(target).tooltipConfig != null) {
          cmptDispatcher_1 = target;
          return true;
        }
      }, true);

      if (seriesDispatcher_1) {
        this._showSeriesItemTooltip(e, seriesDispatcher_1, dispatchAction);
      } else if (cmptDispatcher_1) {
        this._showComponentItemTooltip(e, cmptDispatcher_1, dispatchAction);
      } else {
        this._hide(dispatchAction);
      }
    } else {
      this._lastDataByCoordSys = null;

      this._hide(dispatchAction);
    }
  };

  TooltipView.prototype._showOrMove = function (tooltipModel, cb) {
    // showDelay is used in this case: tooltip.enterable is set
    // as true. User intent to move mouse into tooltip and click
    // something. `showDelay` makes it easier to enter the content
    // but tooltip do not move immediately.
    var delay = tooltipModel.get('showDelay');
    cb = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(cb, this);
    clearTimeout(this._showTimout);
    delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
  };

  TooltipView.prototype._showAxisTooltip = function (dataByCoordSys, e) {
    var ecModel = this._ecModel;
    var globalTooltipModel = this._tooltipModel;
    var point = [e.offsetX, e.offsetY];
    var singleTooltipModel = buildTooltipModel([e.tooltipOption], globalTooltipModel);
    var renderMode = this._renderMode;
    var cbParamsList = [];
    var articleMarkup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__tooltipMarkup_js__["b" /* createTooltipMarkup */])('section', {
      blocks: [],
      noHeader: true
    }); // Only for legacy: `Serise['formatTooltip']` returns a string.

    var markupTextArrLegacy = [];
    var markupStyleCreator = new __WEBPACK_IMPORTED_MODULE_20__tooltipMarkup_js__["c" /* TooltipMarkupStyleCreator */]();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(dataByCoordSys, function (itemCoordSys) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(itemCoordSys.dataByAxis, function (axisItem) {
        var axisModel = ecModel.getComponent(axisItem.axisDim + 'Axis', axisItem.axisIndex);
        var axisValue = axisItem.value;

        if (!axisModel || axisValue == null) {
          return;
        }

        var axisValueLabel = __WEBPACK_IMPORTED_MODULE_13__axisPointer_viewHelper_js__["f" /* getValueLabel */](axisValue, axisModel.axis, ecModel, axisItem.seriesDataIndices, axisItem.valueLabelOpt);
        var axisSectionMarkup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__tooltipMarkup_js__["b" /* createTooltipMarkup */])('section', {
          header: axisValueLabel,
          noHeader: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["trim"])(axisValueLabel),
          sortBlocks: true,
          blocks: []
        });
        articleMarkup.blocks.push(axisSectionMarkup);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(axisItem.seriesDataIndices, function (idxItem) {
          var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
          var dataIndex = idxItem.dataIndexInside;
          var cbParams = series.getDataParams(dataIndex); // Can't find data.

          if (cbParams.dataIndex < 0) {
            return;
          }

          cbParams.axisDim = axisItem.axisDim;
          cbParams.axisIndex = axisItem.axisIndex;
          cbParams.axisType = axisItem.axisType;
          cbParams.axisId = axisItem.axisId;
          cbParams.axisValue = __WEBPACK_IMPORTED_MODULE_12__coord_axisHelper_js__["e" /* getAxisRawValue */](axisModel.axis, {
            value: axisValue
          });
          cbParams.axisValueLabel = axisValueLabel; // Pre-create marker style for makers. Users can assemble richText
          // text in `formatter` callback and use those markers style.

          cbParams.marker = markupStyleCreator.makeTooltipMarker('item', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_format_js__["d" /* convertToColorString */])(cbParams.color), renderMode);
          var seriesTooltipResult = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__model_mixin_dataFormat_js__["b" /* normalizeTooltipFormatResult */])(series.formatTooltip(dataIndex, true, null));
          var frag = seriesTooltipResult.frag;

          if (frag) {
            var valueFormatter = buildTooltipModel([series], globalTooltipModel).get('valueFormatter');
            axisSectionMarkup.blocks.push(valueFormatter ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])({
              valueFormatter: valueFormatter
            }, frag) : frag);
          }

          if (seriesTooltipResult.text) {
            markupTextArrLegacy.push(seriesTooltipResult.text);
          }

          cbParamsList.push(cbParams);
        });
      });
    }); // In most cases, the second axis is displays upper on the first one.
    // So we reverse it to look better.

    articleMarkup.blocks.reverse();
    markupTextArrLegacy.reverse();
    var positionExpr = e.position;
    var orderMode = singleTooltipModel.get('order');
    var builtMarkupText = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__tooltipMarkup_js__["d" /* buildTooltipMarkup */])(articleMarkup, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), singleTooltipModel.get('textStyle'));
    builtMarkupText && markupTextArrLegacy.unshift(builtMarkupText);
    var blockBreak = renderMode === 'richText' ? '\n\n' : '<br/>';
    var allMarkupText = markupTextArrLegacy.join(blockBreak);

    this._showOrMove(singleTooltipModel, function () {
      if (this._updateContentNotChangedOnAxis(dataByCoordSys, cbParamsList)) {
        this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, cbParamsList);
      } else {
        this._showTooltipContent(singleTooltipModel, allMarkupText, cbParamsList, Math.random() + '', point[0], point[1], positionExpr, null, markupStyleCreator);
      }
    }); // Do not trigger events here, because this branch only be entered
    // from dispatchAction.

  };

  TooltipView.prototype._showSeriesItemTooltip = function (e, dispatcher, dispatchAction) {
    var ecModel = this._ecModel;
    var ecData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_innerStore_js__["a" /* getECData */])(dispatcher); // Use dataModel in element if possible
    // Used when mouseover on a element like markPoint or edge
    // In which case, the data is not main data in series.

    var seriesIndex = ecData.seriesIndex;
    var seriesModel = ecModel.getSeriesByIndex(seriesIndex); // For example, graph link.

    var dataModel = ecData.dataModel || seriesModel;
    var dataIndex = ecData.dataIndex;
    var dataType = ecData.dataType;
    var data = dataModel.getData(dataType);
    var renderMode = this._renderMode;
    var positionDefault = e.positionDefault;
    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), dataModel, seriesModel && (seriesModel.coordinateSystem || {}).model], this._tooltipModel, positionDefault ? {
      position: positionDefault
    } : null);
    var tooltipTrigger = tooltipModel.get('trigger');

    if (tooltipTrigger != null && tooltipTrigger !== 'item') {
      return;
    }

    var params = dataModel.getDataParams(dataIndex, dataType);
    var markupStyleCreator = new __WEBPACK_IMPORTED_MODULE_20__tooltipMarkup_js__["c" /* TooltipMarkupStyleCreator */](); // Pre-create marker style for makers. Users can assemble richText
    // text in `formatter` callback and use those markers style.

    params.marker = markupStyleCreator.makeTooltipMarker('item', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_format_js__["d" /* convertToColorString */])(params.color), renderMode);
    var seriesTooltipResult = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__model_mixin_dataFormat_js__["b" /* normalizeTooltipFormatResult */])(dataModel.formatTooltip(dataIndex, false, dataType));
    var orderMode = tooltipModel.get('order');
    var valueFormatter = tooltipModel.get('valueFormatter');
    var frag = seriesTooltipResult.frag;
    var markupText = frag ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__tooltipMarkup_js__["d" /* buildTooltipMarkup */])(valueFormatter ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"])({
      valueFormatter: valueFormatter
    }, frag) : frag, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), tooltipModel.get('textStyle')) : seriesTooltipResult.text;
    var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;

    this._showOrMove(tooltipModel, function () {
      this._showTooltipContent(tooltipModel, markupText, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markupStyleCreator);
    }); // FIXME
    // duplicated showtip if manuallyShowTip is called from dispatchAction.


    dispatchAction({
      type: 'showTip',
      dataIndexInside: dataIndex,
      dataIndex: data.getRawIndex(dataIndex),
      seriesIndex: seriesIndex,
      from: this.uid
    });
  };

  TooltipView.prototype._showComponentItemTooltip = function (e, el, dispatchAction) {
    var ecData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_innerStore_js__["a" /* getECData */])(el);
    var tooltipConfig = ecData.tooltipConfig;
    var tooltipOpt = tooltipConfig.option || {};

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"])(tooltipOpt)) {
      var content = tooltipOpt;
      tooltipOpt = {
        content: content,
        // Fixed formatter
        formatter: content
      };
    }

    var tooltipModelCascade = [tooltipOpt];

    var cmpt = this._ecModel.getComponent(ecData.componentMainType, ecData.componentIndex);

    if (cmpt) {
      tooltipModelCascade.push(cmpt);
    } // In most cases, component tooltip formatter has different params with series tooltip formatter,
    // so that they can not share the same formatter. Since the global tooltip formatter is used for series
    // by convension, we do not use it as the default formatter for component.


    tooltipModelCascade.push({
      formatter: tooltipOpt.content
    });
    var positionDefault = e.positionDefault;
    var subTooltipModel = buildTooltipModel(tooltipModelCascade, this._tooltipModel, positionDefault ? {
      position: positionDefault
    } : null);
    var defaultHtml = subTooltipModel.get('content');
    var asyncTicket = Math.random() + ''; // PENDING: this case do not support richText style yet.

    var markupStyleCreator = new __WEBPACK_IMPORTED_MODULE_20__tooltipMarkup_js__["c" /* TooltipMarkupStyleCreator */](); // Do not check whether `trigger` is 'none' here, because `trigger`
    // only works on coordinate system. In fact, we have not found case
    // that requires setting `trigger` nothing on component yet.

    this._showOrMove(subTooltipModel, function () {
      // Use formatterParams from element defined in component
      // Avoid users modify it.
      var formatterParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"])(subTooltipModel.get('formatterParams') || {});

      this._showTooltipContent(subTooltipModel, defaultHtml, formatterParams, asyncTicket, e.offsetX, e.offsetY, e.position, el, markupStyleCreator);
    }); // If not dispatch showTip, tip may be hide triggered by axis.


    dispatchAction({
      type: 'showTip',
      from: this.uid
    });
  };

  TooltipView.prototype._showTooltipContent = function ( // Use Model<TooltipOption> insteadof TooltipModel because this model may be from series or other options.
  // Instead of top level tooltip.
  tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markupStyleCreator) {
    // Reset ticket
    this._ticket = '';

    if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) {
      return;
    }

    var tooltipContent = this._tooltipContent;
    tooltipContent.setEnterable(tooltipModel.get('enterable'));
    var formatter = tooltipModel.get('formatter');
    positionExpr = positionExpr || tooltipModel.get('position');
    var html = defaultHtml;

    var nearPoint = this._getNearestPoint([x, y], params, tooltipModel.get('trigger'), tooltipModel.get('borderColor'));

    var nearPointColor = nearPoint.color;

    if (formatter) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"])(formatter)) {
        var useUTC = tooltipModel.ecModel.get('useUTC');
        var params0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(params) ? params[0] : params;
        var isTimeAxis = params0 && params0.axisType && params0.axisType.indexOf('time') >= 0;
        html = formatter;

        if (isTimeAxis) {
          html = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_time_js__["a" /* format */])(params0.axisValue, html, useUTC);
        }

        html = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_format_js__["a" /* formatTpl */])(html, params, true);
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isFunction"])(formatter)) {
        var callback = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(function (cbTicket, html) {
          if (cbTicket === this._ticket) {
            tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);

            this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
          }
        }, this);
        this._ticket = asyncTicket;
        html = formatter(params, asyncTicket, callback);
      } else {
        html = formatter;
      }
    }

    tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
    tooltipContent.show(tooltipModel, nearPointColor);

    this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
  };

  TooltipView.prototype._getNearestPoint = function (point, tooltipDataParams, trigger, borderColor) {
    if (trigger === 'axis' || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(tooltipDataParams)) {
      return {
        color: borderColor || (this._renderMode === 'html' ? '#fff' : 'none')
      };
    }

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(tooltipDataParams)) {
      return {
        color: borderColor || tooltipDataParams.color || tooltipDataParams.borderColor
      };
    }
  };

  TooltipView.prototype._updatePosition = function (tooltipModel, positionExpr, x, // Mouse x
  y, // Mouse y
  content, params, el) {
    var viewWidth = this._api.getWidth();

    var viewHeight = this._api.getHeight();

    positionExpr = positionExpr || tooltipModel.get('position');
    var contentSize = content.getSize();
    var align = tooltipModel.get('align');
    var vAlign = tooltipModel.get('verticalAlign');
    var rect = el && el.getBoundingRect().clone();
    el && rect.applyTransform(el.transform);

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isFunction"])(positionExpr)) {
      // Callback of position can be an array or a string specify the position
      positionExpr = positionExpr([x, y], params, content.el, rect, {
        viewSize: [viewWidth, viewHeight],
        contentSize: contentSize.slice()
      });
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(positionExpr)) {
      x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(positionExpr[0], viewWidth);
      y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_number_js__["a" /* parsePercent */])(positionExpr[1], viewHeight);
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isObject"])(positionExpr)) {
      var boxLayoutPosition = positionExpr;
      boxLayoutPosition.width = contentSize[0];
      boxLayoutPosition.height = contentSize[1];
      var layoutRect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_layout_js__["f" /* getLayoutRect */])(boxLayoutPosition, {
        width: viewWidth,
        height: viewHeight
      });
      x = layoutRect.x;
      y = layoutRect.y;
      align = null; // When positionExpr is left/top/right/bottom,
      // align and verticalAlign will not work.

      vAlign = null;
    } // Specify tooltip position by string 'top' 'bottom' 'left' 'right' around graphic element
    else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"])(positionExpr) && el) {
        var pos = calcTooltipPosition(positionExpr, rect, contentSize, tooltipModel.get('borderWidth'));
        x = pos[0];
        y = pos[1];
      } else {
        var pos = refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
        x = pos[0];
        y = pos[1];
      }

    align && (x -= isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
    vAlign && (y -= isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__helper_js__["a" /* shouldTooltipConfine */])(tooltipModel)) {
      var pos = confineTooltipPosition(x, y, content, viewWidth, viewHeight);
      x = pos[0];
      y = pos[1];
    }

    content.moveTo(x, y);
  }; // FIXME
  // Should we remove this but leave this to user?


  TooltipView.prototype._updateContentNotChangedOnAxis = function (dataByCoordSys, cbParamsList) {
    var lastCoordSys = this._lastDataByCoordSys;
    var lastCbParamsList = this._cbParamsList;
    var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
    contentNotChanged && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(lastCoordSys, function (lastItemCoordSys, indexCoordSys) {
      var lastDataByAxis = lastItemCoordSys.dataByAxis || [];
      var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
      var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
      contentNotChanged = contentNotChanged && lastDataByAxis.length === thisDataByAxis.length;
      contentNotChanged && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(lastDataByAxis, function (lastItem, indexAxis) {
        var thisItem = thisDataByAxis[indexAxis] || {};
        var lastIndices = lastItem.seriesDataIndices || [];
        var newIndices = thisItem.seriesDataIndices || [];
        contentNotChanged = contentNotChanged && lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
        contentNotChanged && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(lastIndices, function (lastIdxItem, j) {
          var newIdxItem = newIndices[j];
          contentNotChanged = contentNotChanged && lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
        }); // check is cbParams data value changed

        lastCbParamsList && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(lastItem.seriesDataIndices, function (idxItem) {
          var seriesIdx = idxItem.seriesIndex;
          var cbParams = cbParamsList[seriesIdx];
          var lastCbParams = lastCbParamsList[seriesIdx];

          if (cbParams && lastCbParams && lastCbParams.data !== cbParams.data) {
            contentNotChanged = false;
          }
        });
      });
    });
    this._lastDataByCoordSys = dataByCoordSys;
    this._cbParamsList = cbParamsList;
    return !!contentNotChanged;
  };

  TooltipView.prototype._hide = function (dispatchAction) {
    // Do not directly hideLater here, because this behavior may be prevented
    // in dispatchAction when showTip is dispatched.
    // FIXME
    // duplicated hideTip if manuallyHideTip is called from dispatchAction.
    this._lastDataByCoordSys = null;
    dispatchAction({
      type: 'hideTip',
      from: this.uid
    });
  };

  TooltipView.prototype.dispose = function (ecModel, api) {
    if (__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_env_js__["a" /* default */].node || !api.getDom()) {
      return;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__util_throttle_js__["b" /* clear */])(this, '_updatePosition');

    this._tooltipContent.dispose();

    __WEBPACK_IMPORTED_MODULE_11__axisPointer_globalListener_js__["b" /* unregister */]('itemTooltip', api);
  };

  TooltipView.type = 'tooltip';
  return TooltipView;
}(__WEBPACK_IMPORTED_MODULE_15__view_Component_js__["a" /* default */]);
/**
 * From top to bottom. (the last one should be globalTooltipModel);
 */


function buildTooltipModel(modelCascade, globalTooltipModel, defaultTooltipOption) {
  // Last is always tooltip model.
  var ecModel = globalTooltipModel.ecModel;
  var resultModel;

  if (defaultTooltipOption) {
    resultModel = new __WEBPACK_IMPORTED_MODULE_10__model_Model_js__["a" /* default */](defaultTooltipOption, ecModel, ecModel);
    resultModel = new __WEBPACK_IMPORTED_MODULE_10__model_Model_js__["a" /* default */](globalTooltipModel.option, resultModel, ecModel);
  } else {
    resultModel = globalTooltipModel;
  }

  for (var i = modelCascade.length - 1; i >= 0; i--) {
    var tooltipOpt = modelCascade[i];

    if (tooltipOpt) {
      if (tooltipOpt instanceof __WEBPACK_IMPORTED_MODULE_10__model_Model_js__["a" /* default */]) {
        tooltipOpt = tooltipOpt.get('tooltip', true);
      } // In each data item tooltip can be simply write:
      // {
      //  value: 10,
      //  tooltip: 'Something you need to know'
      // }


      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"])(tooltipOpt)) {
        tooltipOpt = {
          formatter: tooltipOpt
        };
      }

      if (tooltipOpt) {
        resultModel = new __WEBPACK_IMPORTED_MODULE_10__model_Model_js__["a" /* default */](tooltipOpt, resultModel, ecModel);
      }
    }
  }

  return resultModel;
}

function makeDispatchAction(payload, api) {
  return payload.dispatchAction || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"])(api.dispatchAction, api);
}

function refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
  var size = content.getSize();
  var width = size[0];
  var height = size[1];

  if (gapH != null) {
    // Add extra 2 pixels for this case:
    // At present the "values" in defaut tooltip are using CSS `float: right`.
    // When the right edge of the tooltip box is on the right side of the
    // viewport, the `float` layout might push the "values" to the second line.
    if (x + width + gapH + 2 > viewWidth) {
      x -= width + gapH;
    } else {
      x += gapH;
    }
  }

  if (gapV != null) {
    if (y + height + gapV > viewHeight) {
      y -= height + gapV;
    } else {
      y += gapV;
    }
  }

  return [x, y];
}

function confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
  var size = content.getSize();
  var width = size[0];
  var height = size[1];
  x = Math.min(x + width, viewWidth) - width;
  y = Math.min(y + height, viewHeight) - height;
  x = Math.max(x, 0);
  y = Math.max(y, 0);
  return [x, y];
}

function calcTooltipPosition(position, rect, contentSize, borderWidth) {
  var domWidth = contentSize[0];
  var domHeight = contentSize[1];
  var offset = Math.ceil(Math.SQRT2 * borderWidth) + 8;
  var x = 0;
  var y = 0;
  var rectWidth = rect.width;
  var rectHeight = rect.height;

  switch (position) {
    case 'inside':
      x = rect.x + rectWidth / 2 - domWidth / 2;
      y = rect.y + rectHeight / 2 - domHeight / 2;
      break;

    case 'top':
      x = rect.x + rectWidth / 2 - domWidth / 2;
      y = rect.y - domHeight - offset;
      break;

    case 'bottom':
      x = rect.x + rectWidth / 2 - domWidth / 2;
      y = rect.y + rectHeight + offset;
      break;

    case 'left':
      x = rect.x - domWidth - offset;
      y = rect.y + rectHeight / 2 - domHeight / 2;
      break;

    case 'right':
      x = rect.x + rectWidth + offset;
      y = rect.y + rectHeight / 2 - domHeight / 2;
  }

  return [x, y];
}

function isCenterAlign(align) {
  return align === 'center' || align === 'middle';
}
/**
 * Find target component by payload like:
 * ```js
 * { legendId: 'some_id', name: 'xxx' }
 * { toolboxIndex: 1, name: 'xxx' }
 * { geoName: 'some_name', name: 'xxx' }
 * ```
 * PENDING: at present only
 *
 * If not found, return null/undefined.
 */


function findComponentReference(payload, ecModel, api) {
  var queryOptionMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_model_js__["o" /* preParseFinder */])(payload).queryOptionMap;
  var componentMainType = queryOptionMap.keys()[0];

  if (!componentMainType || componentMainType === 'series') {
    return;
  }

  var queryResult = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_model_js__["h" /* queryReferringComponents */])(ecModel, componentMainType, queryOptionMap.get(componentMainType), {
    useDefault: false,
    enableAll: false,
    enableNone: false
  });
  var model = queryResult.models[0];

  if (!model) {
    return;
  }

  var view = api.getViewOfComponentModel(model);
  var el;
  view.group.traverse(function (subEl) {
    var tooltipConfig = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_innerStore_js__["a" /* getECData */])(subEl).tooltipConfig;

    if (tooltipConfig && tooltipConfig.name === payload.name) {
      el = subEl;
      return true; // stop
    }
  });

  if (el) {
    return {
      componentMainType: componentMainType,
      componentIndex: model.componentIndex,
      el: el
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (TooltipView);

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axisPointer_install_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extension_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TooltipModel_js__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TooltipView_js__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





function install(registers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_0__axisPointer_install_js__["a" /* install */]);
  registers.registerComponentModel(__WEBPACK_IMPORTED_MODULE_2__TooltipModel_js__["a" /* default */]);
  registers.registerComponentView(__WEBPACK_IMPORTED_MODULE_3__TooltipView_js__["a" /* default */]);
  /**
   * @action
   * @property {string} type
   * @property {number} seriesIndex
   * @property {number} dataIndex
   * @property {number} [x]
   * @property {number} [y]
   */

  registers.registerAction({
    type: 'showTip',
    event: 'showTip',
    update: 'tooltip:manuallyShowTip'
  }, __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["noop"]);
  registers.registerAction({
    type: 'hideTip',
    event: 'hideTip',
    update: 'tooltip:manuallyHideTip'
  }, __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_util_js__["noop"]);
}

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterTransform; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_conditionalExpression_js__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_log_js__ = __webpack_require__(14);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var filterTransform = {
  type: 'echarts:filter',
  // PEDING: enhance to filter by index rather than create new data
  transform: function (params) {
    // [Caveat] Fail-Fast:
    // Do not return the whole dataset unless user config indicate it explicitly.
    // For example, if no condition specified by mistake, return an empty result
    // is better than return the entire raw soruce for user to find the mistake.
    var upstream = params.upstream;
    var rawItem;
    var condition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_conditionalExpression_js__["a" /* parseConditionalExpression */])(params.config, {
      valueGetterAttrMap: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"])({
        dimension: true
      }),
      prepareGetValue: function (exprOption) {
        var errMsg = '';
        var dimLoose = exprOption.dimension;

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["hasOwn"])(exprOption, 'dimension')) {
          if (true) {
            errMsg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_log_js__["d" /* makePrintable */])('Relation condition must has prop "dimension" specified.', 'Illegal condition:', exprOption);
          }

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_log_js__["e" /* throwError */])(errMsg);
        }

        var dimInfo = upstream.getDimensionInfo(dimLoose);

        if (!dimInfo) {
          if (true) {
            errMsg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_log_js__["d" /* makePrintable */])('Can not find dimension info via: ' + dimLoose + '.\n', 'Existing dimensions: ', upstream.cloneAllDimensionInfo(), '.\n', 'Illegal condition:', exprOption, '.\n');
          }

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_log_js__["e" /* throwError */])(errMsg);
        }

        return {
          dimIdx: dimInfo.index
        };
      },
      getValue: function (param) {
        return upstream.retrieveValueFromItem(rawItem, param.dimIdx);
      }
    });
    var resultData = [];

    for (var i = 0, len = upstream.count(); i < len; i++) {
      rawItem = upstream.getRawDataItem(i);

      if (condition.evaluate()) {
        resultData.push(rawItem);
      }
    }

    return {
      data: resultData
    };
  }
};

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filterTransform_js__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sortTransform_js__ = __webpack_require__(1276);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


function install(registers) {
  registers.registerTransform(__WEBPACK_IMPORTED_MODULE_0__filterTransform_js__["a" /* filterTransform */]);
  registers.registerTransform(__WEBPACK_IMPORTED_MODULE_1__sortTransform_js__["a" /* sortTransform */]);
}

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sortTransform; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_types_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_log_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_helper_dataValueHelper_js__ = __webpack_require__(134);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var sampleLog = '';

if (true) {
  sampleLog = ['Valid config is like:', '{ dimension: "age", order: "asc" }', 'or [{ dimension: "age", order: "asc"], { dimension: "date", order: "desc" }]'].join(' ');
}

var sortTransform = {
  type: 'echarts:sort',
  transform: function (params) {
    var upstream = params.upstream;
    var config = params.config;
    var errMsg = ''; // Normalize
    // const orderExprList: OrderExpression[] = isArray(config[0])
    //     ? config as OrderExpression[]
    //     : [config as OrderExpression];

    var orderExprList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_model_js__["d" /* normalizeToArray */])(config);

    if (!orderExprList.length) {
      if (true) {
        errMsg = 'Empty `config` in sort transform.';
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_log_js__["e" /* throwError */])(errMsg);
    }

    var orderDefList = [];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_util_js__["each"])(orderExprList, function (orderExpr) {
      var dimLoose = orderExpr.dimension;
      var order = orderExpr.order;
      var parserName = orderExpr.parser;
      var incomparable = orderExpr.incomparable;

      if (dimLoose == null) {
        if (true) {
          errMsg = 'Sort transform config must has "dimension" specified.' + sampleLog;
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_log_js__["e" /* throwError */])(errMsg);
      }

      if (order !== 'asc' && order !== 'desc') {
        if (true) {
          errMsg = 'Sort transform config must has "order" specified.' + sampleLog;
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_log_js__["e" /* throwError */])(errMsg);
      }

      if (incomparable && incomparable !== 'min' && incomparable !== 'max') {
        var errMsg_1 = '';

        if (true) {
          errMsg_1 = 'incomparable must be "min" or "max" rather than "' + incomparable + '".';
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_log_js__["e" /* throwError */])(errMsg_1);
      }

      if (order !== 'asc' && order !== 'desc') {
        var errMsg_2 = '';

        if (true) {
          errMsg_2 = 'order must be "asc" or "desc" rather than "' + order + '".';
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_log_js__["e" /* throwError */])(errMsg_2);
      }

      var dimInfo = upstream.getDimensionInfo(dimLoose);

      if (!dimInfo) {
        if (true) {
          errMsg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_log_js__["d" /* makePrintable */])('Can not find dimension info via: ' + dimLoose + '.\n', 'Existing dimensions: ', upstream.cloneAllDimensionInfo(), '.\n', 'Illegal config:', orderExpr, '.\n');
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_log_js__["e" /* throwError */])(errMsg);
      }

      var parser = parserName ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__data_helper_dataValueHelper_js__["c" /* getRawValueParser */])(parserName) : null;

      if (parserName && !parser) {
        if (true) {
          errMsg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_log_js__["d" /* makePrintable */])('Invalid parser name ' + parserName + '.\n', 'Illegal config:', orderExpr, '.\n');
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_log_js__["e" /* throwError */])(errMsg);
      }

      orderDefList.push({
        dimIdx: dimInfo.index,
        parser: parser,
        comparator: new __WEBPACK_IMPORTED_MODULE_4__data_helper_dataValueHelper_js__["a" /* SortOrderComparator */](order, incomparable)
      });
    }); // TODO: support it?

    var sourceFormat = upstream.sourceFormat;

    if (sourceFormat !== __WEBPACK_IMPORTED_MODULE_0__util_types_js__["b" /* SOURCE_FORMAT_ARRAY_ROWS */] && sourceFormat !== __WEBPACK_IMPORTED_MODULE_0__util_types_js__["e" /* SOURCE_FORMAT_OBJECT_ROWS */]) {
      if (true) {
        errMsg = 'sourceFormat "' + sourceFormat + '" is not supported yet';
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_log_js__["e" /* throwError */])(errMsg);
    } // Other upstream format are all array.


    var resultData = [];

    for (var i = 0, len = upstream.count(); i < len; i++) {
      resultData.push(upstream.getRawDataItem(i));
    }

    resultData.sort(function (item0, item1) {
      for (var i = 0; i < orderDefList.length; i++) {
        var orderDef = orderDefList[i];
        var val0 = upstream.retrieveValueFromItem(item0, orderDef.dimIdx);
        var val1 = upstream.retrieveValueFromItem(item1, orderDef.dimIdx);

        if (orderDef.parser) {
          val0 = orderDef.parser(val0);
          val1 = orderDef.parser(val1);
        }

        var result = orderDef.comparator.evaluate(val0, val1);

        if (result !== 0) {
          return result;
        }
      }

      return 0;
    });
    return {
      data: resultData
    };
  }
};

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VisualMapModel_js__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_component_js__ = __webpack_require__(49);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




 // Constant

var DEFAULT_BAR_BOUND = [20, 140];

var ContinuousModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ContinuousModel, _super);

  function ContinuousModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ContinuousModel.type;
    return _this;
  }
  /**
   * @override
   */


  ContinuousModel.prototype.optionUpdated = function (newOption, isInit) {
    _super.prototype.optionUpdated.apply(this, arguments);

    this.resetExtent();
    this.resetVisual(function (mappingOption) {
      mappingOption.mappingMethod = 'linear';
      mappingOption.dataExtent = this.getExtent();
    });

    this._resetRange();
  };
  /**
   * @protected
   * @override
   */


  ContinuousModel.prototype.resetItemSize = function () {
    _super.prototype.resetItemSize.apply(this, arguments);

    var itemSize = this.itemSize;
    (itemSize[0] == null || isNaN(itemSize[0])) && (itemSize[0] = DEFAULT_BAR_BOUND[0]);
    (itemSize[1] == null || isNaN(itemSize[1])) && (itemSize[1] = DEFAULT_BAR_BOUND[1]);
  };
  /**
   * @private
   */


  ContinuousModel.prototype._resetRange = function () {
    var dataExtent = this.getExtent();
    var range = this.option.range;

    if (!range || range.auto) {
      // `range` should always be array (so we dont use other
      // value like 'auto') for user-friend. (consider getOption).
      dataExtent.auto = 1;
      this.option.range = dataExtent;
    } else if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](range)) {
      if (range[0] > range[1]) {
        range.reverse();
      }

      range[0] = Math.max(range[0], dataExtent[0]);
      range[1] = Math.min(range[1], dataExtent[1]);
    }
  };
  /**
   * @protected
   * @override
   */


  ContinuousModel.prototype.completeVisualOption = function () {
    _super.prototype.completeVisualOption.apply(this, arguments);

    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](this.stateList, function (state) {
      var symbolSize = this.option.controller[state].symbolSize;

      if (symbolSize && symbolSize[0] !== symbolSize[1]) {
        symbolSize[0] = symbolSize[1] / 3; // For good looking.
      }
    }, this);
  };
  /**
   * @override
   */


  ContinuousModel.prototype.setSelected = function (selected) {
    this.option.range = selected.slice();

    this._resetRange();
  };
  /**
   * @public
   */


  ContinuousModel.prototype.getSelected = function () {
    var dataExtent = this.getExtent();
    var dataInterval = __WEBPACK_IMPORTED_MODULE_3__util_number_js__["j" /* asc */]((this.get('range') || []).slice()); // Clamp

    dataInterval[0] > dataExtent[1] && (dataInterval[0] = dataExtent[1]);
    dataInterval[1] > dataExtent[1] && (dataInterval[1] = dataExtent[1]);
    dataInterval[0] < dataExtent[0] && (dataInterval[0] = dataExtent[0]);
    dataInterval[1] < dataExtent[0] && (dataInterval[1] = dataExtent[0]);
    return dataInterval;
  };
  /**
   * @override
   */


  ContinuousModel.prototype.getValueState = function (value) {
    var range = this.option.range;
    var dataExtent = this.getExtent(); // When range[0] === dataExtent[0], any value larger than dataExtent[0] maps to 'inRange'.
    // range[1] is processed likewise.

    return (range[0] <= dataExtent[0] || range[0] <= value) && (range[1] >= dataExtent[1] || value <= range[1]) ? 'inRange' : 'outOfRange';
  };

  ContinuousModel.prototype.findTargetDataIndices = function (range) {
    var result = [];
    this.eachTargetSeries(function (seriesModel) {
      var dataIndices = [];
      var data = seriesModel.getData();
      data.each(this.getDataDimensionIndex(data), function (value, dataIndex) {
        range[0] <= value && value <= range[1] && dataIndices.push(dataIndex);
      }, this);
      result.push({
        seriesId: seriesModel.id,
        dataIndex: dataIndices
      });
    }, this);
    return result;
  };
  /**
   * @implement
   */


  ContinuousModel.prototype.getVisualMeta = function (getColorVisual) {
    var oVals = getColorStopValues(this, 'outOfRange', this.getExtent());
    var iVals = getColorStopValues(this, 'inRange', this.option.range.slice());
    var stops = [];

    function setStop(value, valueState) {
      stops.push({
        value: value,
        color: getColorVisual(value, valueState)
      });
    } // Format to: outOfRange -- inRange -- outOfRange.


    var iIdx = 0;
    var oIdx = 0;
    var iLen = iVals.length;
    var oLen = oVals.length;

    for (; oIdx < oLen && (!iVals.length || oVals[oIdx] <= iVals[0]); oIdx++) {
      // If oVal[oIdx] === iVals[iIdx], oVal[oIdx] should be ignored.
      if (oVals[oIdx] < iVals[iIdx]) {
        setStop(oVals[oIdx], 'outOfRange');
      }
    }

    for (var first = 1; iIdx < iLen; iIdx++, first = 0) {
      // If range is full, value beyond min, max will be clamped.
      // make a singularity
      first && stops.length && setStop(iVals[iIdx], 'outOfRange');
      setStop(iVals[iIdx], 'inRange');
    }

    for (var first = 1; oIdx < oLen; oIdx++) {
      if (!iVals.length || iVals[iVals.length - 1] < oVals[oIdx]) {
        // make a singularity
        if (first) {
          stops.length && setStop(stops[stops.length - 1].value, 'outOfRange');
          first = 0;
        }

        setStop(oVals[oIdx], 'outOfRange');
      }
    }

    var stopsLen = stops.length;
    return {
      stops: stops,
      outerColors: [stopsLen ? stops[0].color : 'transparent', stopsLen ? stops[stopsLen - 1].color : 'transparent']
    };
  };

  ContinuousModel.type = 'visualMap.continuous';
  ContinuousModel.defaultOption = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_component_js__["d" /* inheritDefaultOption */])(__WEBPACK_IMPORTED_MODULE_2__VisualMapModel_js__["a" /* default */].defaultOption, {
    align: 'auto',
    calculable: false,
    hoverLink: true,
    realtime: true,
    handleIcon: 'path://M-11.39,9.77h0a3.5,3.5,0,0,1-3.5,3.5h-22a3.5,3.5,0,0,1-3.5-3.5h0a3.5,3.5,0,0,1,3.5-3.5h22A3.5,3.5,0,0,1-11.39,9.77Z',
    handleSize: '120%',
    handleStyle: {
      borderColor: '#fff',
      borderWidth: 1
    },
    indicatorIcon: 'circle',
    indicatorSize: '50%',
    indicatorStyle: {
      borderColor: '#fff',
      borderWidth: 2,
      shadowBlur: 2,
      shadowOffsetX: 1,
      shadowOffsetY: 1,
      shadowColor: 'rgba(0,0,0,0.2)'
    } // emphasis: {
    //     handleStyle: {
    //         shadowBlur: 3,
    //         shadowOffsetX: 1,
    //         shadowOffsetY: 1,
    //         shadowColor: 'rgba(0,0,0,0.2)'
    //     }
    // }

  });
  return ContinuousModel;
}(__WEBPACK_IMPORTED_MODULE_2__VisualMapModel_js__["a" /* default */]);

function getColorStopValues(visualMapModel, valueState, dataExtent) {
  if (dataExtent[0] === dataExtent[1]) {
    return dataExtent.slice();
  } // When using colorHue mapping, it is not linear color any more.
  // Moreover, canvas gradient seems not to be accurate linear.
  // FIXME
  // Should be arbitrary value 100? or based on pixel size?


  var count = 200;
  var step = (dataExtent[1] - dataExtent[0]) / count;
  var value = dataExtent[0];
  var stopValues = [];

  for (var i = 0; i <= count && value < dataExtent[1]; i++) {
    stopValues.push(value);
    value += step;
  }

  stopValues.push(dataExtent[1]);
  return stopValues;
}

/* harmony default export */ __webpack_exports__["a"] = (ContinuousModel);

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_graphic_LinearGradient_js__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_event_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VisualMapView_js__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helper_sliderMove_js__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helper_js__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_zrender_lib_contain_text_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_states_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_symbol_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_zrender_lib_graphic_Image_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__label_labelStyle_js__ = __webpack_require__(15);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
















var linearMap = __WEBPACK_IMPORTED_MODULE_6__util_number_js__["h" /* linearMap */];
var each = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"];
var mathMin = Math.min;
var mathMax = Math.max; // Arbitrary value

var HOVER_LINK_SIZE = 12;
var HOVER_LINK_OUT = 6; // Notice:
// Any "interval" should be by the order of [low, high].
// "handle0" (handleIndex === 0) maps to
// low data value: this._dataInterval[0] and has low coord.
// "handle1" (handleIndex === 1) maps to
// high data value: this._dataInterval[1] and has high coord.
// The logic of transform is implemented in this._createBarGroup.

var ContinuousView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ContinuousView, _super);

  function ContinuousView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ContinuousView.type;
    _this._shapes = {};
    _this._dataInterval = [];
    _this._handleEnds = [];
    _this._hoverLinkDataIndices = [];
    return _this;
  }

  ContinuousView.prototype.doRender = function (visualMapModel, ecModel, api, payload) {
    this._api = api;

    if (!payload || payload.type !== 'selectDataRange' || payload.from !== this.uid) {
      this._buildView();
    }
  };

  ContinuousView.prototype._buildView = function () {
    this.group.removeAll();
    var visualMapModel = this.visualMapModel;
    var thisGroup = this.group;
    this._orient = visualMapModel.get('orient');
    this._useHandle = visualMapModel.get('calculable');

    this._resetInterval();

    this._renderBar(thisGroup);

    var dataRangeText = visualMapModel.get('text');

    this._renderEndsText(thisGroup, dataRangeText, 0);

    this._renderEndsText(thisGroup, dataRangeText, 1); // Do this for background size calculation.


    this._updateView(true); // After updating view, inner shapes is built completely,
    // and then background can be rendered.


    this.renderBackground(thisGroup); // Real update view

    this._updateView();

    this._enableHoverLinkToSeries();

    this._enableHoverLinkFromSeries();

    this.positionGroup(thisGroup);
  };

  ContinuousView.prototype._renderEndsText = function (group, dataRangeText, endsIndex) {
    if (!dataRangeText) {
      return;
    } // Compatible with ec2, text[0] map to high value, text[1] map low value.


    var text = dataRangeText[1 - endsIndex];
    text = text != null ? text + '' : '';
    var visualMapModel = this.visualMapModel;
    var textGap = visualMapModel.get('textGap');
    var itemSize = visualMapModel.itemSize;
    var barGroup = this._shapes.mainGroup;

    var position = this._applyTransform([itemSize[0] / 2, endsIndex === 0 ? -textGap : itemSize[1] + textGap], barGroup);

    var align = this._applyTransform(endsIndex === 0 ? 'bottom' : 'top', barGroup);

    var orient = this._orient;
    var textStyleModel = this.visualMapModel.textStyleModel;
    this.group.add(new __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["Text"]({
      style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__label_labelStyle_js__["d" /* createTextStyle */])(textStyleModel, {
        x: position[0],
        y: position[1],
        verticalAlign: orient === 'horizontal' ? 'middle' : align,
        align: orient === 'horizontal' ? align : 'center',
        text: text
      })
    }));
  };

  ContinuousView.prototype._renderBar = function (targetGroup) {
    var visualMapModel = this.visualMapModel;
    var shapes = this._shapes;
    var itemSize = visualMapModel.itemSize;
    var orient = this._orient;
    var useHandle = this._useHandle;
    var itemAlign = __WEBPACK_IMPORTED_MODULE_8__helper_js__["b" /* getItemAlign */](visualMapModel, this.api, itemSize);

    var mainGroup = shapes.mainGroup = this._createBarGroup(itemAlign);

    var gradientBarGroup = new __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["Group"]();
    mainGroup.add(gradientBarGroup); // Bar

    gradientBarGroup.add(shapes.outOfRange = createPolygon());
    gradientBarGroup.add(shapes.inRange = createPolygon(null, useHandle ? getCursor(this._orient) : null, __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"](this._dragHandle, this, 'all', false), __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"](this._dragHandle, this, 'all', true))); // A border radius clip.

    gradientBarGroup.setClipPath(new __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["Rect"]({
      shape: {
        x: 0,
        y: 0,
        width: itemSize[0],
        height: itemSize[1],
        r: 3
      }
    }));
    var textRect = visualMapModel.textStyleModel.getTextRect('国');
    var textSize = mathMax(textRect.width, textRect.height); // Handle

    if (useHandle) {
      shapes.handleThumbs = [];
      shapes.handleLabels = [];
      shapes.handleLabelPoints = [];

      this._createHandle(visualMapModel, mainGroup, 0, itemSize, textSize, orient);

      this._createHandle(visualMapModel, mainGroup, 1, itemSize, textSize, orient);
    }

    this._createIndicator(visualMapModel, mainGroup, itemSize, textSize, orient);

    targetGroup.add(mainGroup);
  };

  ContinuousView.prototype._createHandle = function (visualMapModel, mainGroup, handleIndex, itemSize, textSize, orient) {
    var onDrift = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"](this._dragHandle, this, handleIndex, false);
    var onDragEnd = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"](this._dragHandle, this, handleIndex, true);
    var handleSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_contain_text_js__["b" /* parsePercent */])(visualMapModel.get('handleSize'), itemSize[0]);
    var handleThumb = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_symbol_js__["a" /* createSymbol */])(visualMapModel.get('handleIcon'), -handleSize / 2, -handleSize / 2, handleSize, handleSize, null, true);
    var cursor = getCursor(this._orient);
    handleThumb.attr({
      cursor: cursor,
      draggable: true,
      drift: onDrift,
      ondragend: onDragEnd,
      onmousemove: function (e) {
        __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_event_js__["a" /* stop */](e.event);
      }
    });
    handleThumb.x = itemSize[0] / 2;
    handleThumb.useStyle(visualMapModel.getModel('handleStyle').getItemStyle());
    handleThumb.setStyle({
      strokeNoScale: true,
      strokeFirst: true
    });
    handleThumb.style.lineWidth *= 2;
    handleThumb.ensureState('emphasis').style = visualMapModel.getModel(['emphasis', 'handleStyle']).getItemStyle();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_states_js__["c" /* setAsHighDownDispatcher */])(handleThumb, true);
    mainGroup.add(handleThumb); // Text is always horizontal layout but should not be effected by
    // transform (orient/inverse). So label is built separately but not
    // use zrender/graphic/helper/RectText, and is located based on view
    // group (according to handleLabelPoint) but not barGroup.

    var textStyleModel = this.visualMapModel.textStyleModel;
    var handleLabel = new __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["Text"]({
      cursor: cursor,
      draggable: true,
      drift: onDrift,
      onmousemove: function (e) {
        // Fot mobile devicem, prevent screen slider on the button.
        __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_event_js__["a" /* stop */](e.event);
      },
      ondragend: onDragEnd,
      style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__label_labelStyle_js__["d" /* createTextStyle */])(textStyleModel, {
        x: 0,
        y: 0,
        text: ''
      })
    });
    handleLabel.ensureState('blur').style = {
      opacity: 0.1
    };
    handleLabel.stateTransition = {
      duration: 200
    };
    this.group.add(handleLabel);
    var handleLabelPoint = [handleSize, 0];
    var shapes = this._shapes;
    shapes.handleThumbs[handleIndex] = handleThumb;
    shapes.handleLabelPoints[handleIndex] = handleLabelPoint;
    shapes.handleLabels[handleIndex] = handleLabel;
  };

  ContinuousView.prototype._createIndicator = function (visualMapModel, mainGroup, itemSize, textSize, orient) {
    var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_zrender_lib_contain_text_js__["b" /* parsePercent */])(visualMapModel.get('indicatorSize'), itemSize[0]);
    var indicator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_symbol_js__["a" /* createSymbol */])(visualMapModel.get('indicatorIcon'), -scale / 2, -scale / 2, scale, scale, null, true);
    indicator.attr({
      cursor: 'move',
      invisible: true,
      silent: true,
      x: itemSize[0] / 2
    });
    var indicatorStyle = visualMapModel.getModel('indicatorStyle').getItemStyle();

    if (indicator instanceof __WEBPACK_IMPORTED_MODULE_13_zrender_lib_graphic_Image_js__["a" /* default */]) {
      var pathStyle = indicator.style;
      indicator.useStyle(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["extend"]({
        // TODO other properties like x, y ?
        image: pathStyle.image,
        x: pathStyle.x,
        y: pathStyle.y,
        width: pathStyle.width,
        height: pathStyle.height
      }, indicatorStyle));
    } else {
      indicator.useStyle(indicatorStyle);
    }

    mainGroup.add(indicator);
    var textStyleModel = this.visualMapModel.textStyleModel;
    var indicatorLabel = new __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["Text"]({
      silent: true,
      invisible: true,
      style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__label_labelStyle_js__["d" /* createTextStyle */])(textStyleModel, {
        x: 0,
        y: 0,
        text: ''
      })
    });
    this.group.add(indicatorLabel);
    var indicatorLabelPoint = [(orient === 'horizontal' ? textSize / 2 : HOVER_LINK_OUT) + itemSize[0] / 2, 0];
    var shapes = this._shapes;
    shapes.indicator = indicator;
    shapes.indicatorLabel = indicatorLabel;
    shapes.indicatorLabelPoint = indicatorLabelPoint;
    this._firstShowIndicator = true;
  };

  ContinuousView.prototype._dragHandle = function (handleIndex, isEnd, // dx is event from ondragend if isEnd is true. It's not used
  dx, dy) {
    if (!this._useHandle) {
      return;
    }

    this._dragging = !isEnd;

    if (!isEnd) {
      // Transform dx, dy to bar coordination.
      var vertex = this._applyTransform([dx, dy], this._shapes.mainGroup, true);

      this._updateInterval(handleIndex, vertex[1]);

      this._hideIndicator(); // Considering realtime, update view should be executed
      // before dispatch action.


      this._updateView();
    } // dragEnd do not dispatch action when realtime.


    if (isEnd === !this.visualMapModel.get('realtime')) {
      // jshint ignore:line
      this.api.dispatchAction({
        type: 'selectDataRange',
        from: this.uid,
        visualMapId: this.visualMapModel.id,
        selected: this._dataInterval.slice()
      });
    }

    if (isEnd) {
      !this._hovering && this._clearHoverLinkToSeries();
    } else if (useHoverLinkOnHandle(this.visualMapModel)) {
      this._doHoverLinkToSeries(this._handleEnds[handleIndex], false);
    }
  };

  ContinuousView.prototype._resetInterval = function () {
    var visualMapModel = this.visualMapModel;
    var dataInterval = this._dataInterval = visualMapModel.getSelected();
    var dataExtent = visualMapModel.getExtent();
    var sizeExtent = [0, visualMapModel.itemSize[1]];
    this._handleEnds = [linearMap(dataInterval[0], dataExtent, sizeExtent, true), linearMap(dataInterval[1], dataExtent, sizeExtent, true)];
  };
  /**
   * @private
   * @param {(number|string)} handleIndex 0 or 1 or 'all'
   * @param {number} dx
   * @param {number} dy
   */


  ContinuousView.prototype._updateInterval = function (handleIndex, delta) {
    delta = delta || 0;
    var visualMapModel = this.visualMapModel;
    var handleEnds = this._handleEnds;
    var sizeExtent = [0, visualMapModel.itemSize[1]];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helper_sliderMove_js__["a" /* default */])(delta, handleEnds, sizeExtent, handleIndex, // cross is forbiden
    0);
    var dataExtent = visualMapModel.getExtent(); // Update data interval.

    this._dataInterval = [linearMap(handleEnds[0], sizeExtent, dataExtent, true), linearMap(handleEnds[1], sizeExtent, dataExtent, true)];
  };

  ContinuousView.prototype._updateView = function (forSketch) {
    var visualMapModel = this.visualMapModel;
    var dataExtent = visualMapModel.getExtent();
    var shapes = this._shapes;
    var outOfRangeHandleEnds = [0, visualMapModel.itemSize[1]];
    var inRangeHandleEnds = forSketch ? outOfRangeHandleEnds : this._handleEnds;

    var visualInRange = this._createBarVisual(this._dataInterval, dataExtent, inRangeHandleEnds, 'inRange');

    var visualOutOfRange = this._createBarVisual(dataExtent, dataExtent, outOfRangeHandleEnds, 'outOfRange');

    shapes.inRange.setStyle({
      fill: visualInRange.barColor // opacity: visualInRange.opacity

    }).setShape('points', visualInRange.barPoints);
    shapes.outOfRange.setStyle({
      fill: visualOutOfRange.barColor // opacity: visualOutOfRange.opacity

    }).setShape('points', visualOutOfRange.barPoints);

    this._updateHandle(inRangeHandleEnds, visualInRange);
  };

  ContinuousView.prototype._createBarVisual = function (dataInterval, dataExtent, handleEnds, forceState) {
    var opts = {
      forceState: forceState,
      convertOpacityToAlpha: true
    };

    var colorStops = this._makeColorGradient(dataInterval, opts);

    var symbolSizes = [this.getControllerVisual(dataInterval[0], 'symbolSize', opts), this.getControllerVisual(dataInterval[1], 'symbolSize', opts)];

    var barPoints = this._createBarPoints(handleEnds, symbolSizes);

    return {
      barColor: new __WEBPACK_IMPORTED_MODULE_2_zrender_lib_graphic_LinearGradient_js__["a" /* default */](0, 0, 0, 1, colorStops),
      barPoints: barPoints,
      handlesColor: [colorStops[0].color, colorStops[colorStops.length - 1].color]
    };
  };

  ContinuousView.prototype._makeColorGradient = function (dataInterval, opts) {
    // Considering colorHue, which is not linear, so we have to sample
    // to calculate gradient color stops, but not only caculate head
    // and tail.
    var sampleNumber = 100; // Arbitrary value.

    var colorStops = [];
    var step = (dataInterval[1] - dataInterval[0]) / sampleNumber;
    colorStops.push({
      color: this.getControllerVisual(dataInterval[0], 'color', opts),
      offset: 0
    });

    for (var i = 1; i < sampleNumber; i++) {
      var currValue = dataInterval[0] + step * i;

      if (currValue > dataInterval[1]) {
        break;
      }

      colorStops.push({
        color: this.getControllerVisual(currValue, 'color', opts),
        offset: i / sampleNumber
      });
    }

    colorStops.push({
      color: this.getControllerVisual(dataInterval[1], 'color', opts),
      offset: 1
    });
    return colorStops;
  };

  ContinuousView.prototype._createBarPoints = function (handleEnds, symbolSizes) {
    var itemSize = this.visualMapModel.itemSize;
    return [[itemSize[0] - symbolSizes[0], handleEnds[0]], [itemSize[0], handleEnds[0]], [itemSize[0], handleEnds[1]], [itemSize[0] - symbolSizes[1], handleEnds[1]]];
  };

  ContinuousView.prototype._createBarGroup = function (itemAlign) {
    var orient = this._orient;
    var inverse = this.visualMapModel.get('inverse');
    return new __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["Group"](orient === 'horizontal' && !inverse ? {
      scaleX: itemAlign === 'bottom' ? 1 : -1,
      rotation: Math.PI / 2
    } : orient === 'horizontal' && inverse ? {
      scaleX: itemAlign === 'bottom' ? -1 : 1,
      rotation: -Math.PI / 2
    } : orient === 'vertical' && !inverse ? {
      scaleX: itemAlign === 'left' ? 1 : -1,
      scaleY: -1
    } : {
      scaleX: itemAlign === 'left' ? 1 : -1
    });
  };

  ContinuousView.prototype._updateHandle = function (handleEnds, visualInRange) {
    if (!this._useHandle) {
      return;
    }

    var shapes = this._shapes;
    var visualMapModel = this.visualMapModel;
    var handleThumbs = shapes.handleThumbs;
    var handleLabels = shapes.handleLabels;
    var itemSize = visualMapModel.itemSize;
    var dataExtent = visualMapModel.getExtent();
    each([0, 1], function (handleIndex) {
      var handleThumb = handleThumbs[handleIndex];
      handleThumb.setStyle('fill', visualInRange.handlesColor[handleIndex]);
      handleThumb.y = handleEnds[handleIndex];
      var val = linearMap(handleEnds[handleIndex], [0, itemSize[1]], dataExtent, true);
      var symbolSize = this.getControllerVisual(val, 'symbolSize');
      handleThumb.scaleX = handleThumb.scaleY = symbolSize / itemSize[0];
      handleThumb.x = itemSize[0] - symbolSize / 2; // Update handle label position.

      var textPoint = __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["applyTransform"](shapes.handleLabelPoints[handleIndex], __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["getTransform"](handleThumb, this.group));
      handleLabels[handleIndex].setStyle({
        x: textPoint[0],
        y: textPoint[1],
        text: visualMapModel.formatValueText(this._dataInterval[handleIndex]),
        verticalAlign: 'middle',
        align: this._orient === 'vertical' ? this._applyTransform('left', shapes.mainGroup) : 'center'
      });
    }, this);
  };

  ContinuousView.prototype._showIndicator = function (cursorValue, textValue, rangeSymbol, halfHoverLinkSize) {
    var visualMapModel = this.visualMapModel;
    var dataExtent = visualMapModel.getExtent();
    var itemSize = visualMapModel.itemSize;
    var sizeExtent = [0, itemSize[1]];
    var shapes = this._shapes;
    var indicator = shapes.indicator;

    if (!indicator) {
      return;
    }

    indicator.attr('invisible', false);
    var opts = {
      convertOpacityToAlpha: true
    };
    var color = this.getControllerVisual(cursorValue, 'color', opts);
    var symbolSize = this.getControllerVisual(cursorValue, 'symbolSize');
    var y = linearMap(cursorValue, dataExtent, sizeExtent, true);
    var x = itemSize[0] - symbolSize / 2;
    var oldIndicatorPos = {
      x: indicator.x,
      y: indicator.y
    }; // Update handle label position.

    indicator.y = y;
    indicator.x = x;
    var textPoint = __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["applyTransform"](shapes.indicatorLabelPoint, __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["getTransform"](indicator, this.group));
    var indicatorLabel = shapes.indicatorLabel;
    indicatorLabel.attr('invisible', false);

    var align = this._applyTransform('left', shapes.mainGroup);

    var orient = this._orient;
    var isHorizontal = orient === 'horizontal';
    indicatorLabel.setStyle({
      text: (rangeSymbol ? rangeSymbol : '') + visualMapModel.formatValueText(textValue),
      verticalAlign: isHorizontal ? align : 'middle',
      align: isHorizontal ? 'center' : align
    });
    var indicatorNewProps = {
      x: x,
      y: y,
      style: {
        fill: color
      }
    };
    var labelNewProps = {
      style: {
        x: textPoint[0],
        y: textPoint[1]
      }
    };

    if (visualMapModel.ecModel.isAnimationEnabled() && !this._firstShowIndicator) {
      var animationCfg = {
        duration: 100,
        easing: 'cubicInOut',
        additive: true
      };
      indicator.x = oldIndicatorPos.x;
      indicator.y = oldIndicatorPos.y;
      indicator.animateTo(indicatorNewProps, animationCfg);
      indicatorLabel.animateTo(labelNewProps, animationCfg);
    } else {
      indicator.attr(indicatorNewProps);
      indicatorLabel.attr(labelNewProps);
    }

    this._firstShowIndicator = false;
    var handleLabels = this._shapes.handleLabels;

    if (handleLabels) {
      for (var i = 0; i < handleLabels.length; i++) {
        // Fade out handle labels.
        // NOTE: Must use api enter/leave on emphasis/blur/select state. Or the global states manager will change it.
        this._api.enterBlur(handleLabels[i]);
      }
    }
  };

  ContinuousView.prototype._enableHoverLinkToSeries = function () {
    var self = this;

    this._shapes.mainGroup.on('mousemove', function (e) {
      self._hovering = true;

      if (!self._dragging) {
        var itemSize = self.visualMapModel.itemSize;

        var pos = self._applyTransform([e.offsetX, e.offsetY], self._shapes.mainGroup, true, true); // For hover link show when hover handle, which might be
        // below or upper than sizeExtent.


        pos[1] = mathMin(mathMax(0, pos[1]), itemSize[1]);

        self._doHoverLinkToSeries(pos[1], 0 <= pos[0] && pos[0] <= itemSize[0]);
      }
    }).on('mouseout', function () {
      // When mouse is out of handle, hoverLink still need
      // to be displayed when realtime is set as false.
      self._hovering = false;
      !self._dragging && self._clearHoverLinkToSeries();
    });
  };

  ContinuousView.prototype._enableHoverLinkFromSeries = function () {
    var zr = this.api.getZr();

    if (this.visualMapModel.option.hoverLink) {
      zr.on('mouseover', this._hoverLinkFromSeriesMouseOver, this);
      zr.on('mouseout', this._hideIndicator, this);
    } else {
      this._clearHoverLinkFromSeries();
    }
  };

  ContinuousView.prototype._doHoverLinkToSeries = function (cursorPos, hoverOnBar) {
    var visualMapModel = this.visualMapModel;
    var itemSize = visualMapModel.itemSize;

    if (!visualMapModel.option.hoverLink) {
      return;
    }

    var sizeExtent = [0, itemSize[1]];
    var dataExtent = visualMapModel.getExtent(); // For hover link show when hover handle, which might be below or upper than sizeExtent.

    cursorPos = mathMin(mathMax(sizeExtent[0], cursorPos), sizeExtent[1]);
    var halfHoverLinkSize = getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent);
    var hoverRange = [cursorPos - halfHoverLinkSize, cursorPos + halfHoverLinkSize];
    var cursorValue = linearMap(cursorPos, sizeExtent, dataExtent, true);
    var valueRange = [linearMap(hoverRange[0], sizeExtent, dataExtent, true), linearMap(hoverRange[1], sizeExtent, dataExtent, true)]; // Consider data range is out of visualMap range, see test/visualMap-continuous.html,
    // where china and india has very large population.

    hoverRange[0] < sizeExtent[0] && (valueRange[0] = -Infinity);
    hoverRange[1] > sizeExtent[1] && (valueRange[1] = Infinity); // Do not show indicator when mouse is over handle,
    // otherwise labels overlap, especially when dragging.

    if (hoverOnBar) {
      if (valueRange[0] === -Infinity) {
        this._showIndicator(cursorValue, valueRange[1], '< ', halfHoverLinkSize);
      } else if (valueRange[1] === Infinity) {
        this._showIndicator(cursorValue, valueRange[0], '> ', halfHoverLinkSize);
      } else {
        this._showIndicator(cursorValue, cursorValue, '≈ ', halfHoverLinkSize);
      }
    } // When realtime is set as false, handles, which are in barGroup,
    // also trigger hoverLink, which help user to realize where they
    // focus on when dragging. (see test/heatmap-large.html)
    // When realtime is set as true, highlight will not show when hover
    // handle, because the label on handle, which displays a exact value
    // but not range, might mislead users.


    var oldBatch = this._hoverLinkDataIndices;
    var newBatch = [];

    if (hoverOnBar || useHoverLinkOnHandle(visualMapModel)) {
      newBatch = this._hoverLinkDataIndices = visualMapModel.findTargetDataIndices(valueRange);
    }

    var resultBatches = __WEBPACK_IMPORTED_MODULE_9__util_model_js__["j" /* compressBatches */](oldBatch, newBatch);

    this._dispatchHighDown('downplay', __WEBPACK_IMPORTED_MODULE_8__helper_js__["a" /* makeHighDownBatch */](resultBatches[0], visualMapModel));

    this._dispatchHighDown('highlight', __WEBPACK_IMPORTED_MODULE_8__helper_js__["a" /* makeHighDownBatch */](resultBatches[1], visualMapModel));
  };

  ContinuousView.prototype._hoverLinkFromSeriesMouseOver = function (e) {
    var el = e.target;
    var visualMapModel = this.visualMapModel;

    if (!el || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_innerStore_js__["a" /* getECData */])(el).dataIndex == null) {
      return;
    }

    var ecData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_innerStore_js__["a" /* getECData */])(el);
    var dataModel = this.ecModel.getSeriesByIndex(ecData.seriesIndex);

    if (!visualMapModel.isTargetSeries(dataModel)) {
      return;
    }

    var data = dataModel.getData(ecData.dataType);
    var value = data.getStore().get(visualMapModel.getDataDimensionIndex(data), ecData.dataIndex);

    if (!isNaN(value)) {
      this._showIndicator(value, value);
    }
  };

  ContinuousView.prototype._hideIndicator = function () {
    var shapes = this._shapes;
    shapes.indicator && shapes.indicator.attr('invisible', true);
    shapes.indicatorLabel && shapes.indicatorLabel.attr('invisible', true);
    var handleLabels = this._shapes.handleLabels;

    if (handleLabels) {
      for (var i = 0; i < handleLabels.length; i++) {
        // Fade out handle labels.
        // NOTE: Must use api enter/leave on emphasis/blur/select state. Or the global states manager will change it.
        this._api.leaveBlur(handleLabels[i]);
      }
    }
  };

  ContinuousView.prototype._clearHoverLinkToSeries = function () {
    this._hideIndicator();

    var indices = this._hoverLinkDataIndices;

    this._dispatchHighDown('downplay', __WEBPACK_IMPORTED_MODULE_8__helper_js__["a" /* makeHighDownBatch */](indices, this.visualMapModel));

    indices.length = 0;
  };

  ContinuousView.prototype._clearHoverLinkFromSeries = function () {
    this._hideIndicator();

    var zr = this.api.getZr();
    zr.off('mouseover', this._hoverLinkFromSeriesMouseOver);
    zr.off('mouseout', this._hideIndicator);
  };

  ContinuousView.prototype._applyTransform = function (vertex, element, inverse, global) {
    var transform = __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["getTransform"](element, global ? null : this.group);
    return __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](vertex) ? __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["applyTransform"](vertex, transform, inverse) : __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["transformDirection"](vertex, transform, inverse);
  }; // TODO: TYPE more specified payload types.


  ContinuousView.prototype._dispatchHighDown = function (type, batch) {
    batch && batch.length && this.api.dispatchAction({
      type: type,
      batch: batch
    });
  };
  /**
   * @override
   */


  ContinuousView.prototype.dispose = function () {
    this._clearHoverLinkFromSeries();

    this._clearHoverLinkToSeries();
  };
  /**
   * @override
   */


  ContinuousView.prototype.remove = function () {
    this._clearHoverLinkFromSeries();

    this._clearHoverLinkToSeries();
  };

  ContinuousView.type = 'visualMap.continuous';
  return ContinuousView;
}(__WEBPACK_IMPORTED_MODULE_4__VisualMapView_js__["a" /* default */]);

function createPolygon(points, cursor, onDrift, onDragEnd) {
  return new __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["Polygon"]({
    shape: {
      points: points
    },
    draggable: !!onDrift,
    cursor: cursor,
    drift: onDrift,
    onmousemove: function (e) {
      // Fot mobile devicem, prevent screen slider on the button.
      __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_event_js__["a" /* stop */](e.event);
    },
    ondragend: onDragEnd
  });
}

function getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent) {
  var halfHoverLinkSize = HOVER_LINK_SIZE / 2;
  var hoverLinkDataSize = visualMapModel.get('hoverLinkDataSize');

  if (hoverLinkDataSize) {
    halfHoverLinkSize = linearMap(hoverLinkDataSize, dataExtent, sizeExtent, true) / 2;
  }

  return halfHoverLinkSize;
}

function useHoverLinkOnHandle(visualMapModel) {
  var hoverLinkOnHandle = visualMapModel.get('hoverLinkOnHandle');
  return !!(hoverLinkOnHandle == null ? visualMapModel.get('realtime') : hoverLinkOnHandle);
}

function getCursor(orient) {
  return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
}

/* harmony default export */ __webpack_exports__["a"] = (ContinuousView);

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VisualMapModel_js__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__visual_VisualMapping_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__visual_visualDefault_js__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_component_js__ = __webpack_require__(49);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/








var PiecewiseModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(PiecewiseModel, _super);

  function PiecewiseModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = PiecewiseModel.type;
    /**
     * The order is always [low, ..., high].
     * [{text: string, interval: Array.<number>}, ...]
     */

    _this._pieceList = [];
    return _this;
  }

  PiecewiseModel.prototype.optionUpdated = function (newOption, isInit) {
    _super.prototype.optionUpdated.apply(this, arguments);

    this.resetExtent();

    var mode = this._mode = this._determineMode();

    this._pieceList = [];

    resetMethods[this._mode].call(this, this._pieceList);

    this._resetSelected(newOption, isInit);

    var categories = this.option.categories;
    this.resetVisual(function (mappingOption, state) {
      if (mode === 'categories') {
        mappingOption.mappingMethod = 'category';
        mappingOption.categories = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"](categories);
      } else {
        mappingOption.dataExtent = this.getExtent();
        mappingOption.mappingMethod = 'piecewise';
        mappingOption.pieceList = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"](this._pieceList, function (piece) {
          piece = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"](piece);

          if (state !== 'inRange') {
            // FIXME
            // outOfRange do not support special visual in pieces.
            piece.visual = null;
          }

          return piece;
        });
      }
    });
  };
  /**
   * @protected
   * @override
   */


  PiecewiseModel.prototype.completeVisualOption = function () {
    // Consider this case:
    // visualMap: {
    //      pieces: [{symbol: 'circle', lt: 0}, {symbol: 'rect', gte: 0}]
    // }
    // where no inRange/outOfRange set but only pieces. So we should make
    // default inRange/outOfRange for this case, otherwise visuals that only
    // appear in `pieces` will not be taken into account in visual encoding.
    var option = this.option;
    var visualTypesInPieces = {};
    var visualTypes = __WEBPACK_IMPORTED_MODULE_3__visual_VisualMapping_js__["a" /* default */].listVisualTypes();
    var isCategory = this.isCategory();
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](option.pieces, function (piece) {
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](visualTypes, function (visualType) {
        if (piece.hasOwnProperty(visualType)) {
          visualTypesInPieces[visualType] = 1;
        }
      });
    });
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](visualTypesInPieces, function (v, visualType) {
      var exists = false;
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](this.stateList, function (state) {
        exists = exists || has(option, state, visualType) || has(option.target, state, visualType);
      }, this);
      !exists && __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](this.stateList, function (state) {
        (option[state] || (option[state] = {}))[visualType] = __WEBPACK_IMPORTED_MODULE_4__visual_visualDefault_js__["a" /* default */].get(visualType, state === 'inRange' ? 'active' : 'inactive', isCategory);
      });
    }, this);

    function has(obj, state, visualType) {
      return obj && obj[state] && obj[state].hasOwnProperty(visualType);
    }

    _super.prototype.completeVisualOption.apply(this, arguments);
  };

  PiecewiseModel.prototype._resetSelected = function (newOption, isInit) {
    var thisOption = this.option;
    var pieceList = this._pieceList; // Selected do not merge but all override.

    var selected = (isInit ? thisOption : newOption).selected || {};
    thisOption.selected = selected; // Consider 'not specified' means true.

    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](pieceList, function (piece, index) {
      var key = this.getSelectedMapKey(piece);

      if (!selected.hasOwnProperty(key)) {
        selected[key] = true;
      }
    }, this);

    if (thisOption.selectedMode === 'single') {
      // Ensure there is only one selected.
      var hasSel_1 = false;
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](pieceList, function (piece, index) {
        var key = this.getSelectedMapKey(piece);

        if (selected[key]) {
          hasSel_1 ? selected[key] = false : hasSel_1 = true;
        }
      }, this);
    } // thisOption.selectedMode === 'multiple', default: all selected.

  };
  /**
   * @public
   */


  PiecewiseModel.prototype.getItemSymbol = function () {
    return this.get('itemSymbol');
  };
  /**
   * @public
   */


  PiecewiseModel.prototype.getSelectedMapKey = function (piece) {
    return this._mode === 'categories' ? piece.value + '' : piece.index + '';
  };
  /**
   * @public
   */


  PiecewiseModel.prototype.getPieceList = function () {
    return this._pieceList;
  };
  /**
   * @return {string}
   */


  PiecewiseModel.prototype._determineMode = function () {
    var option = this.option;
    return option.pieces && option.pieces.length > 0 ? 'pieces' : this.option.categories ? 'categories' : 'splitNumber';
  };
  /**
   * @override
   */


  PiecewiseModel.prototype.setSelected = function (selected) {
    this.option.selected = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"](selected);
  };
  /**
   * @override
   */


  PiecewiseModel.prototype.getValueState = function (value) {
    var index = __WEBPACK_IMPORTED_MODULE_3__visual_VisualMapping_js__["a" /* default */].findPieceIndex(value, this._pieceList);
    return index != null ? this.option.selected[this.getSelectedMapKey(this._pieceList[index])] ? 'inRange' : 'outOfRange' : 'outOfRange';
  };
  /**
   * @public
   * @param pieceIndex piece index in visualMapModel.getPieceList()
   */


  PiecewiseModel.prototype.findTargetDataIndices = function (pieceIndex) {
    var result = [];
    var pieceList = this._pieceList;
    this.eachTargetSeries(function (seriesModel) {
      var dataIndices = [];
      var data = seriesModel.getData();
      data.each(this.getDataDimensionIndex(data), function (value, dataIndex) {
        // Should always base on model pieceList, because it is order sensitive.
        var pIdx = __WEBPACK_IMPORTED_MODULE_3__visual_VisualMapping_js__["a" /* default */].findPieceIndex(value, pieceList);
        pIdx === pieceIndex && dataIndices.push(dataIndex);
      }, this);
      result.push({
        seriesId: seriesModel.id,
        dataIndex: dataIndices
      });
    }, this);
    return result;
  };
  /**
   * @private
   * @param piece piece.value or piece.interval is required.
   * @return  Can be Infinity or -Infinity
   */


  PiecewiseModel.prototype.getRepresentValue = function (piece) {
    var representValue;

    if (this.isCategory()) {
      representValue = piece.value;
    } else {
      if (piece.value != null) {
        representValue = piece.value;
      } else {
        var pieceInterval = piece.interval || [];
        representValue = pieceInterval[0] === -Infinity && pieceInterval[1] === Infinity ? 0 : (pieceInterval[0] + pieceInterval[1]) / 2;
      }
    }

    return representValue;
  };

  PiecewiseModel.prototype.getVisualMeta = function (getColorVisual) {
    // Do not support category. (category axis is ordinal, numerical)
    if (this.isCategory()) {
      return;
    }

    var stops = [];
    var outerColors = ['', ''];
    var visualMapModel = this;

    function setStop(interval, valueState) {
      var representValue = visualMapModel.getRepresentValue({
        interval: interval
      }); // Not category

      if (!valueState) {
        valueState = visualMapModel.getValueState(representValue);
      }

      var color = getColorVisual(representValue, valueState);

      if (interval[0] === -Infinity) {
        outerColors[0] = color;
      } else if (interval[1] === Infinity) {
        outerColors[1] = color;
      } else {
        stops.push({
          value: interval[0],
          color: color
        }, {
          value: interval[1],
          color: color
        });
      }
    } // Suplement


    var pieceList = this._pieceList.slice();

    if (!pieceList.length) {
      pieceList.push({
        interval: [-Infinity, Infinity]
      });
    } else {
      var edge = pieceList[0].interval[0];
      edge !== -Infinity && pieceList.unshift({
        interval: [-Infinity, edge]
      });
      edge = pieceList[pieceList.length - 1].interval[1];
      edge !== Infinity && pieceList.push({
        interval: [edge, Infinity]
      });
    }

    var curr = -Infinity;
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](pieceList, function (piece) {
      var interval = piece.interval;

      if (interval) {
        // Fulfill gap.
        interval[0] > curr && setStop([curr, interval[0]], 'outOfRange');
        setStop(interval.slice());
        curr = interval[1];
      }
    }, this);
    return {
      stops: stops,
      outerColors: outerColors
    };
  };

  PiecewiseModel.type = 'visualMap.piecewise';
  PiecewiseModel.defaultOption = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_component_js__["d" /* inheritDefaultOption */])(__WEBPACK_IMPORTED_MODULE_2__VisualMapModel_js__["a" /* default */].defaultOption, {
    selected: null,
    minOpen: false,
    maxOpen: false,
    align: 'auto',
    itemWidth: 20,
    itemHeight: 14,
    itemSymbol: 'roundRect',
    pieces: null,
    categories: null,
    splitNumber: 5,
    selectedMode: 'multiple',
    itemGap: 10,
    hoverLink: true // Enable hover highlight.

  });
  return PiecewiseModel;
}(__WEBPACK_IMPORTED_MODULE_2__VisualMapModel_js__["a" /* default */]);

;
/**
 * Key is this._mode
 * @type {Object}
 * @this {module:echarts/component/viusalMap/PiecewiseMode}
 */

var resetMethods = {
  splitNumber: function (outPieceList) {
    var thisOption = this.option;
    var precision = Math.min(thisOption.precision, 20);
    var dataExtent = this.getExtent();
    var splitNumber = thisOption.splitNumber;
    splitNumber = Math.max(parseInt(splitNumber, 10), 1);
    thisOption.splitNumber = splitNumber;
    var splitStep = (dataExtent[1] - dataExtent[0]) / splitNumber; // Precision auto-adaption

    while (+splitStep.toFixed(precision) !== splitStep && precision < 5) {
      precision++;
    }

    thisOption.precision = precision;
    splitStep = +splitStep.toFixed(precision);

    if (thisOption.minOpen) {
      outPieceList.push({
        interval: [-Infinity, dataExtent[0]],
        close: [0, 0]
      });
    }

    for (var index = 0, curr = dataExtent[0]; index < splitNumber; curr += splitStep, index++) {
      var max = index === splitNumber - 1 ? dataExtent[1] : curr + splitStep;
      outPieceList.push({
        interval: [curr, max],
        close: [1, 1]
      });
    }

    if (thisOption.maxOpen) {
      outPieceList.push({
        interval: [dataExtent[1], Infinity],
        close: [0, 0]
      });
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_number_js__["i" /* reformIntervals */])(outPieceList);
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](outPieceList, function (piece, index) {
      piece.index = index;
      piece.text = this.formatValueText(piece.interval);
    }, this);
  },
  categories: function (outPieceList) {
    var thisOption = this.option;
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](thisOption.categories, function (cate) {
      // FIXME category模式也使用pieceList，但在visualMapping中不是使用pieceList。
      // 是否改一致。
      outPieceList.push({
        text: this.formatValueText(cate, true),
        value: cate
      });
    }, this); // See "Order Rule".

    normalizeReverse(thisOption, outPieceList);
  },
  pieces: function (outPieceList) {
    var thisOption = this.option;
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](thisOption.pieces, function (pieceListItem, index) {
      if (!__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isObject"](pieceListItem)) {
        pieceListItem = {
          value: pieceListItem
        };
      }

      var item = {
        text: '',
        index: index
      };

      if (pieceListItem.label != null) {
        item.text = pieceListItem.label;
      }

      if (pieceListItem.hasOwnProperty('value')) {
        var value = item.value = pieceListItem.value;
        item.interval = [value, value];
        item.close = [1, 1];
      } else {
        // `min` `max` is legacy option.
        // `lt` `gt` `lte` `gte` is recommanded.
        var interval = item.interval = [];
        var close_1 = item.close = [0, 0];
        var closeList = [1, 0, 1];
        var infinityList = [-Infinity, Infinity];
        var useMinMax = [];

        for (var lg = 0; lg < 2; lg++) {
          var names = [['gte', 'gt', 'min'], ['lte', 'lt', 'max']][lg];

          for (var i = 0; i < 3 && interval[lg] == null; i++) {
            interval[lg] = pieceListItem[names[i]];
            close_1[lg] = closeList[i];
            useMinMax[lg] = i === 2;
          }

          interval[lg] == null && (interval[lg] = infinityList[lg]);
        }

        useMinMax[0] && interval[1] === Infinity && (close_1[0] = 0);
        useMinMax[1] && interval[0] === -Infinity && (close_1[1] = 0);

        if (true) {
          if (interval[0] > interval[1]) {
            console.warn('Piece ' + index + 'is illegal: ' + interval + ' lower bound should not greater then uppper bound.');
          }
        }

        if (interval[0] === interval[1] && close_1[0] && close_1[1]) {
          // Consider: [{min: 5, max: 5, visual: {...}}, {min: 0, max: 5}],
          // we use value to lift the priority when min === max
          item.value = interval[0];
        }
      }

      item.visual = __WEBPACK_IMPORTED_MODULE_3__visual_VisualMapping_js__["a" /* default */].retrieveVisuals(pieceListItem);
      outPieceList.push(item);
    }, this); // See "Order Rule".

    normalizeReverse(thisOption, outPieceList); // Only pieces

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_number_js__["i" /* reformIntervals */])(outPieceList);
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](outPieceList, function (piece) {
      var close = piece.close;
      var edgeSymbols = [['<', '≤'][close[1]], ['>', '≥'][close[0]]];
      piece.text = piece.text || this.formatValueText(piece.value != null ? piece.value : piece.interval, false, edgeSymbols);
    }, this);
  }
};

function normalizeReverse(thisOption, pieceList) {
  var inverse = thisOption.inverse;

  if (thisOption.orient === 'vertical' ? !inverse : inverse) {
    pieceList.reverse();
  }
}

/* harmony default export */ __webpack_exports__["a"] = (PiecewiseModel);

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VisualMapView_js__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_symbol_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helper_js__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__ = __webpack_require__(15);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/









var PiecewiseVisualMapView =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(PiecewiseVisualMapView, _super);

  function PiecewiseVisualMapView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = PiecewiseVisualMapView.type;
    return _this;
  }

  PiecewiseVisualMapView.prototype.doRender = function () {
    var thisGroup = this.group;
    thisGroup.removeAll();
    var visualMapModel = this.visualMapModel;
    var textGap = visualMapModel.get('textGap');
    var textStyleModel = visualMapModel.textStyleModel;
    var textFont = textStyleModel.getFont();
    var textFill = textStyleModel.getTextColor();

    var itemAlign = this._getItemAlign();

    var itemSize = visualMapModel.itemSize;

    var viewData = this._getViewData();

    var endsText = viewData.endsText;
    var showLabel = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["retrieve"](visualMapModel.get('showLabel', true), !endsText);
    endsText && this._renderEndsText(thisGroup, endsText[0], itemSize, showLabel, itemAlign);
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](viewData.viewPieceList, function (item) {
      var piece = item.piece;
      var itemGroup = new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Group"]();
      itemGroup.onclick = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["bind"](this._onItemClick, this, piece);

      this._enableHoverLink(itemGroup, item.indexInModelPieceList); // TODO Category


      var representValue = visualMapModel.getRepresentValue(piece);

      this._createItemSymbol(itemGroup, representValue, [0, 0, itemSize[0], itemSize[1]]);

      if (showLabel) {
        var visualState = this.visualMapModel.getValueState(representValue);
        itemGroup.add(new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Text"]({
          style: {
            x: itemAlign === 'right' ? -textGap : itemSize[0] + textGap,
            y: itemSize[1] / 2,
            text: piece.text,
            verticalAlign: 'middle',
            align: itemAlign,
            font: textFont,
            fill: textFill,
            opacity: visualState === 'outOfRange' ? 0.5 : 1
          }
        }));
      }

      thisGroup.add(itemGroup);
    }, this);
    endsText && this._renderEndsText(thisGroup, endsText[1], itemSize, showLabel, itemAlign);
    __WEBPACK_IMPORTED_MODULE_5__util_layout_js__["d" /* box */](visualMapModel.get('orient'), thisGroup, visualMapModel.get('itemGap'));
    this.renderBackground(thisGroup);
    this.positionGroup(thisGroup);
  };

  PiecewiseVisualMapView.prototype._enableHoverLink = function (itemGroup, pieceIndex) {
    var _this = this;

    itemGroup.on('mouseover', function () {
      return onHoverLink('highlight');
    }).on('mouseout', function () {
      return onHoverLink('downplay');
    });

    var onHoverLink = function (method) {
      var visualMapModel = _this.visualMapModel; // TODO: TYPE More detailed action types

      visualMapModel.option.hoverLink && _this.api.dispatchAction({
        type: method,
        batch: __WEBPACK_IMPORTED_MODULE_6__helper_js__["a" /* makeHighDownBatch */](visualMapModel.findTargetDataIndices(pieceIndex), visualMapModel)
      });
    };
  };

  PiecewiseVisualMapView.prototype._getItemAlign = function () {
    var visualMapModel = this.visualMapModel;
    var modelOption = visualMapModel.option;

    if (modelOption.orient === 'vertical') {
      return __WEBPACK_IMPORTED_MODULE_6__helper_js__["b" /* getItemAlign */](visualMapModel, this.api, visualMapModel.itemSize);
    } else {
      // horizontal, most case left unless specifying right.
      var align = modelOption.align;

      if (!align || align === 'auto') {
        align = 'left';
      }

      return align;
    }
  };

  PiecewiseVisualMapView.prototype._renderEndsText = function (group, text, itemSize, showLabel, itemAlign) {
    if (!text) {
      return;
    }

    var itemGroup = new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Group"]();
    var textStyleModel = this.visualMapModel.textStyleModel;
    itemGroup.add(new __WEBPACK_IMPORTED_MODULE_3__util_graphic_js__["Text"]({
      style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__label_labelStyle_js__["d" /* createTextStyle */])(textStyleModel, {
        x: showLabel ? itemAlign === 'right' ? itemSize[0] : 0 : itemSize[0] / 2,
        y: itemSize[1] / 2,
        verticalAlign: 'middle',
        align: showLabel ? itemAlign : 'center',
        text: text
      })
    }));
    group.add(itemGroup);
  };
  /**
   * @private
   * @return {Object} {peiceList, endsText} The order is the same as screen pixel order.
   */


  PiecewiseVisualMapView.prototype._getViewData = function () {
    var visualMapModel = this.visualMapModel;
    var viewPieceList = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"](visualMapModel.getPieceList(), function (piece, index) {
      return {
        piece: piece,
        indexInModelPieceList: index
      };
    });
    var endsText = visualMapModel.get('text'); // Consider orient and inverse.

    var orient = visualMapModel.get('orient');
    var inverse = visualMapModel.get('inverse'); // Order of model pieceList is always [low, ..., high]

    if (orient === 'horizontal' ? inverse : !inverse) {
      viewPieceList.reverse();
    } // Origin order of endsText is [high, low]
    else if (endsText) {
        endsText = endsText.slice().reverse();
      }

    return {
      viewPieceList: viewPieceList,
      endsText: endsText
    };
  };

  PiecewiseVisualMapView.prototype._createItemSymbol = function (group, representValue, shapeParam) {
    group.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_symbol_js__["a" /* createSymbol */])( // symbol will be string
    this.getControllerVisual(representValue, 'symbol'), shapeParam[0], shapeParam[1], shapeParam[2], shapeParam[3], // color will be string
    this.getControllerVisual(representValue, 'color')));
  };

  PiecewiseVisualMapView.prototype._onItemClick = function (piece) {
    var visualMapModel = this.visualMapModel;
    var option = visualMapModel.option;
    var selected = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"](option.selected);
    var newKey = visualMapModel.getSelectedMapKey(piece);

    if (option.selectedMode === 'single') {
      selected[newKey] = true;
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](selected, function (o, key) {
        selected[key] = key === newKey;
      });
    } else {
      selected[newKey] = !selected[newKey];
    }

    this.api.dispatchAction({
      type: 'selectDataRange',
      from: this.uid,
      visualMapId: this.visualMapModel.id,
      selected: selected
    });
  };

  PiecewiseVisualMapView.type = 'visualMap.piecewise';
  return PiecewiseVisualMapView;
}(__WEBPACK_IMPORTED_MODULE_2__VisualMapView_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PiecewiseVisualMapView);

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extension_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__installVisualMapContinuous_js__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__installVisualMapPiecewise_js__ = __webpack_require__(483);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



function install(registers) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_1__installVisualMapContinuous_js__["a" /* install */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_2__installVisualMapPiecewise_js__["a" /* install */]); // Do not install './dataZoomSelect',
  // since it only work for toolbox dataZoom.
}

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = visualMapPreprocessor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// @ts-nocheck

var each = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"];
function visualMapPreprocessor(option) {
  var visualMap = option && option.visualMap;

  if (!__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](visualMap)) {
    visualMap = visualMap ? [visualMap] : [];
  }

  each(visualMap, function (opt) {
    if (!opt) {
      return;
    } // rename splitList to pieces


    if (has(opt, 'splitList') && !has(opt, 'pieces')) {
      opt.pieces = opt.splitList;
      delete opt.splitList;
    }

    var pieces = opt.pieces;

    if (pieces && __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](pieces)) {
      each(pieces, function (piece) {
        if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"](piece)) {
          if (has(piece, 'start') && !has(piece, 'min')) {
            piece.min = piece.start;
          }

          if (has(piece, 'end') && !has(piece, 'max')) {
            piece.max = piece.end;
          }
        }
      });
    }
  });
}

function has(obj, name) {
  return obj && obj.hasOwnProperty && obj.hasOwnProperty(name);
}

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return visualMapEncodingHandlers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__visual_visualSolution_js__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__visual_VisualMapping_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__visual_helper_js__ = __webpack_require__(162);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var visualMapEncodingHandlers = [{
  createOnAllSeries: true,
  reset: function (seriesModel, ecModel) {
    var resetDefines = [];
    ecModel.eachComponent('visualMap', function (visualMapModel) {
      var pipelineContext = seriesModel.pipelineContext;

      if (!visualMapModel.isTargetSeries(seriesModel) || pipelineContext && pipelineContext.large) {
        return;
      }

      resetDefines.push(__WEBPACK_IMPORTED_MODULE_1__visual_visualSolution_js__["a" /* incrementalApplyVisual */](visualMapModel.stateList, visualMapModel.targetVisuals, __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["bind"](visualMapModel.getValueState, visualMapModel), visualMapModel.getDataDimensionIndex(seriesModel.getData())));
    });
    return resetDefines;
  }
}, // Only support color.
{
  createOnAllSeries: true,
  reset: function (seriesModel, ecModel) {
    var data = seriesModel.getData();
    var visualMetaList = [];
    ecModel.eachComponent('visualMap', function (visualMapModel) {
      if (visualMapModel.isTargetSeries(seriesModel)) {
        var visualMeta = visualMapModel.getVisualMeta(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["bind"](getColorVisual, null, seriesModel, visualMapModel)) || {
          stops: [],
          outerColors: []
        };
        var dimIdx = visualMapModel.getDataDimensionIndex(data);

        if (dimIdx >= 0) {
          // visualMeta.dimension should be dimension index, but not concrete dimension.
          visualMeta.dimension = dimIdx;
          visualMetaList.push(visualMeta);
        }
      }
    }); // console.log(JSON.stringify(visualMetaList.map(a => a.stops)));

    seriesModel.getData().setVisual('visualMeta', visualMetaList);
  }
}]; // FIXME
// performance and export for heatmap?
// value can be Infinity or -Infinity

function getColorVisual(seriesModel, visualMapModel, value, valueState) {
  var mappings = visualMapModel.targetVisuals[valueState];
  var visualTypes = __WEBPACK_IMPORTED_MODULE_2__visual_VisualMapping_js__["a" /* default */].prepareVisualTypes(mappings);
  var resultVisual = {
    color: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__visual_helper_js__["a" /* getVisualFromData */])(seriesModel.getData(), 'color') // default color.

  };

  for (var i = 0, len = visualTypes.length; i < len; i++) {
    var type = visualTypes[i];
    var mapping = mappings[type === 'opacity' ? '__alphaForOpacity' : type];
    mapping && mapping.applyVisual(value, getVisual, setVisual);
  }

  return resultVisual.color;

  function getVisual(key) {
    return resultVisual[key];
  }

  function setVisual(key, value) {
    resultVisual[key] = value;
  }
}

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return visualMapActionInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return visualMapActionHander; });

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var visualMapActionInfo = {
  type: 'selectDataRange',
  event: 'dataRangeSelected',
  // FIXME use updateView appears wrong
  update: 'update'
};
var visualMapActionHander = function (payload, ecModel) {
  ecModel.eachComponent({
    mainType: 'visualMap',
    query: payload
  }, function (model) {
    model.setSelected(payload.selected);
  });
};

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AXIS_TYPES; });

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var AXIS_TYPES = {
  value: 1,
  category: 1,
  time: 1,
  log: 1
};

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createAxisLabels;
/* harmony export (immutable) */ __webpack_exports__["a"] = createAxisTicks;
/* harmony export (immutable) */ __webpack_exports__["c"] = calculateCategoryInterval;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_contain_text_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axisHelper_js__ = __webpack_require__(77);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var inner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_model_js__["a" /* makeInner */])();
function createAxisLabels(axis) {
  // Only ordinal scale support tick interval
  return axis.type === 'category' ? makeCategoryLabels(axis) : makeRealNumberLabels(axis);
}
/**
 * @param {module:echats/coord/Axis} axis
 * @param {module:echarts/model/Model} tickModel For example, can be axisTick, splitLine, splitArea.
 * @return {Object} {
 *     ticks: Array.<number>
 *     tickCategoryInterval: number
 * }
 */

function createAxisTicks(axis, tickModel) {
  // Only ordinal scale support tick interval
  return axis.type === 'category' ? makeCategoryTicks(axis, tickModel) : {
    ticks: __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"](axis.scale.getTicks(), function (tick) {
      return tick.value;
    })
  };
}

function makeCategoryLabels(axis) {
  var labelModel = axis.getLabelModel();
  var result = makeCategoryLabelsActually(axis, labelModel);
  return !labelModel.get('show') || axis.scale.isBlank() ? {
    labels: [],
    labelCategoryInterval: result.labelCategoryInterval
  } : result;
}

function makeCategoryLabelsActually(axis, labelModel) {
  var labelsCache = getListCache(axis, 'labels');
  var optionLabelInterval = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__axisHelper_js__["b" /* getOptionCategoryInterval */])(labelModel);
  var result = listCacheGet(labelsCache, optionLabelInterval);

  if (result) {
    return result;
  }

  var labels;
  var numericLabelInterval;

  if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"](optionLabelInterval)) {
    labels = makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
  } else {
    numericLabelInterval = optionLabelInterval === 'auto' ? makeAutoCategoryInterval(axis) : optionLabelInterval;
    labels = makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
  } // Cache to avoid calling interval function repeatly.


  return listCacheSet(labelsCache, optionLabelInterval, {
    labels: labels,
    labelCategoryInterval: numericLabelInterval
  });
}

function makeCategoryTicks(axis, tickModel) {
  var ticksCache = getListCache(axis, 'ticks');
  var optionTickInterval = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__axisHelper_js__["b" /* getOptionCategoryInterval */])(tickModel);
  var result = listCacheGet(ticksCache, optionTickInterval);

  if (result) {
    return result;
  }

  var ticks;
  var tickCategoryInterval; // Optimize for the case that large category data and no label displayed,
  // we should not return all ticks.

  if (!tickModel.get('show') || axis.scale.isBlank()) {
    ticks = [];
  }

  if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"](optionTickInterval)) {
    ticks = makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
  } // Always use label interval by default despite label show. Consider this
  // scenario, Use multiple grid with the xAxis sync, and only one xAxis shows
  // labels. `splitLine` and `axisTick` should be consistent in this case.
  else if (optionTickInterval === 'auto') {
      var labelsResult = makeCategoryLabelsActually(axis, axis.getLabelModel());
      tickCategoryInterval = labelsResult.labelCategoryInterval;
      ticks = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"](labelsResult.labels, function (labelItem) {
        return labelItem.tickValue;
      });
    } else {
      tickCategoryInterval = optionTickInterval;
      ticks = makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
    } // Cache to avoid calling interval function repeatly.


  return listCacheSet(ticksCache, optionTickInterval, {
    ticks: ticks,
    tickCategoryInterval: tickCategoryInterval
  });
}

function makeRealNumberLabels(axis) {
  var ticks = axis.scale.getTicks();
  var labelFormatter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__axisHelper_js__["c" /* makeLabelFormatter */])(axis);
  return {
    labels: __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"](ticks, function (tick, idx) {
      return {
        level: tick.level,
        formattedLabel: labelFormatter(tick, idx),
        rawLabel: axis.scale.getLabel(tick),
        tickValue: tick.value
      };
    })
  };
}

function getListCache(axis, prop) {
  // Because key can be funciton, and cache size always be small, we use array cache.
  return inner(axis)[prop] || (inner(axis)[prop] = []);
}

function listCacheGet(cache, key) {
  for (var i = 0; i < cache.length; i++) {
    if (cache[i].key === key) {
      return cache[i].value;
    }
  }
}

function listCacheSet(cache, key, value) {
  cache.push({
    key: key,
    value: value
  });
  return value;
}

function makeAutoCategoryInterval(axis) {
  var result = inner(axis).autoInterval;
  return result != null ? result : inner(axis).autoInterval = axis.calculateCategoryInterval();
}
/**
 * Calculate interval for category axis ticks and labels.
 * To get precise result, at least one of `getRotate` and `isHorizontal`
 * should be implemented in axis.
 */


function calculateCategoryInterval(axis) {
  var params = fetchAutoCategoryIntervalCalculationParams(axis);
  var labelFormatter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__axisHelper_js__["c" /* makeLabelFormatter */])(axis);
  var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
  var ordinalScale = axis.scale;
  var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
  // avoid generating a long array by `getTicks`
  // in large category data case.

  var tickCount = ordinalScale.count();

  if (ordinalExtent[1] - ordinalExtent[0] < 1) {
    return 0;
  }

  var step = 1; // Simple optimization. Empirical value: tick count should less than 40.

  if (tickCount > 40) {
    step = Math.max(1, Math.floor(tickCount / 40));
  }

  var tickValue = ordinalExtent[0];
  var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
  var unitW = Math.abs(unitSpan * Math.cos(rotation));
  var unitH = Math.abs(unitSpan * Math.sin(rotation));
  var maxW = 0;
  var maxH = 0; // Caution: Performance sensitive for large category data.
  // Consider dataZoom, we should make appropriate step to avoid O(n) loop.

  for (; tickValue <= ordinalExtent[1]; tickValue += step) {
    var width = 0;
    var height = 0; // Not precise, do not consider align and vertical align
    // and each distance from axis line yet.

    var rect = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_contain_text_js__["g" /* getBoundingRect */](labelFormatter({
      value: tickValue
    }), params.font, 'center', 'top'); // Magic number

    width = rect.width * 1.3;
    height = rect.height * 1.3; // Min size, void long loop.

    maxW = Math.max(maxW, width, 7);
    maxH = Math.max(maxH, height, 7);
  }

  var dw = maxW / unitW;
  var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.

  isNaN(dw) && (dw = Infinity);
  isNaN(dh) && (dh = Infinity);
  var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
  var cache = inner(axis.model);
  var axisExtent = axis.getExtent();
  var lastAutoInterval = cache.lastAutoInterval;
  var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
  // otherwise the calculated interval might jitter when the zoom
  // window size is close to the interval-changing size.
  // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
  // The jitter will cause that sometimes the displayed labels are
  // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).

  if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
  // point is not the same when zooming in or zooming out.
  && lastAutoInterval > interval // If the axis change is caused by chart resize, the cache should not
  // be used. Otherwise some hiden labels might not be shown again.
  && cache.axisExtent0 === axisExtent[0] && cache.axisExtent1 === axisExtent[1]) {
    interval = lastAutoInterval;
  } // Only update cache if cache not used, otherwise the
  // changing of interval is too insensitive.
  else {
      cache.lastTickCount = tickCount;
      cache.lastAutoInterval = interval;
      cache.axisExtent0 = axisExtent[0];
      cache.axisExtent1 = axisExtent[1];
    }

  return interval;
}

function fetchAutoCategoryIntervalCalculationParams(axis) {
  var labelModel = axis.getLabelModel();
  return {
    axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
    labelRotate: labelModel.get('rotate') || 0,
    font: labelModel.getFont()
  };
}

function makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
  var labelFormatter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__axisHelper_js__["c" /* makeLabelFormatter */])(axis);
  var ordinalScale = axis.scale;
  var ordinalExtent = ordinalScale.getExtent();
  var labelModel = axis.getLabelModel();
  var result = []; // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...

  var step = Math.max((categoryInterval || 0) + 1, 1);
  var startTick = ordinalExtent[0];
  var tickCount = ordinalScale.count(); // Calculate start tick based on zero if possible to keep label consistent
  // while zooming and moving while interval > 0. Otherwise the selection
  // of displayable ticks and symbols probably keep changing.
  // 3 is empirical value.

  if (startTick !== 0 && step > 1 && tickCount / step > 2) {
    startTick = Math.round(Math.ceil(startTick / step) * step);
  } // (1) Only add min max label here but leave overlap checking
  // to render stage, which also ensure the returned list
  // suitable for splitLine and splitArea rendering.
  // (2) Scales except category always contain min max label so
  // do not need to perform this process.


  var showAllLabel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__axisHelper_js__["d" /* shouldShowAllLabels */])(axis);
  var includeMinLabel = labelModel.get('showMinLabel') || showAllLabel;
  var includeMaxLabel = labelModel.get('showMaxLabel') || showAllLabel;

  if (includeMinLabel && startTick !== ordinalExtent[0]) {
    addItem(ordinalExtent[0]);
  } // Optimize: avoid generating large array by `ordinalScale.getTicks()`.


  var tickValue = startTick;

  for (; tickValue <= ordinalExtent[1]; tickValue += step) {
    addItem(tickValue);
  }

  if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) {
    addItem(ordinalExtent[1]);
  }

  function addItem(tickValue) {
    var tickObj = {
      value: tickValue
    };
    result.push(onlyTick ? tickValue : {
      formattedLabel: labelFormatter(tickObj),
      rawLabel: ordinalScale.getLabel(tickObj),
      tickValue: tickValue
    });
  }

  return result;
}

function makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
  var ordinalScale = axis.scale;
  var labelFormatter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__axisHelper_js__["c" /* makeLabelFormatter */])(axis);
  var result = [];
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](ordinalScale.getTicks(), function (tick) {
    var rawLabel = ordinalScale.getLabel(tick);
    var tickValue = tick.value;

    if (categoryInterval(tick.value, rawLabel)) {
      result.push(onlyTick ? tickValue : {
        formattedLabel: labelFormatter(tick),
        rawLabel: rawLabel,
        tickValue: tickValue
      });
    }
  });
  return result;
}

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_number_js__ = __webpack_require__(8);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


 // (24*60*60*1000)

var PROXIMATE_ONE_DAY = 86400000;

var Calendar =
/** @class */
function () {
  function Calendar(calendarModel, ecModel, api) {
    this.type = 'calendar';
    this.dimensions = Calendar.dimensions; // Required in createListFromData

    this.getDimensionsInfo = Calendar.getDimensionsInfo;
    this._model = calendarModel;
  }

  Calendar.getDimensionsInfo = function () {
    return [{
      name: 'time',
      type: 'time'
    }, 'value'];
  };

  Calendar.prototype.getRangeInfo = function () {
    return this._rangeInfo;
  };

  Calendar.prototype.getModel = function () {
    return this._model;
  };

  Calendar.prototype.getRect = function () {
    return this._rect;
  };

  Calendar.prototype.getCellWidth = function () {
    return this._sw;
  };

  Calendar.prototype.getCellHeight = function () {
    return this._sh;
  };

  Calendar.prototype.getOrient = function () {
    return this._orient;
  };
  /**
   * getFirstDayOfWeek
   *
   * @example
   *     0 : start at Sunday
   *     1 : start at Monday
   *
   * @return {number}
   */


  Calendar.prototype.getFirstDayOfWeek = function () {
    return this._firstDayOfWeek;
  };
  /**
   * get date info
   * }
   */


  Calendar.prototype.getDateInfo = function (date) {
    date = __WEBPACK_IMPORTED_MODULE_2__util_number_js__["f" /* parseDate */](date);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var mStr = m < 10 ? '0' + m : '' + m;
    var d = date.getDate();
    var dStr = d < 10 ? '0' + d : '' + d;
    var day = date.getDay();
    day = Math.abs((day + 7 - this.getFirstDayOfWeek()) % 7);
    return {
      y: y + '',
      m: mStr,
      d: dStr,
      day: day,
      time: date.getTime(),
      formatedDate: y + '-' + mStr + '-' + dStr,
      date: date
    };
  };

  Calendar.prototype.getNextNDay = function (date, n) {
    n = n || 0;

    if (n === 0) {
      return this.getDateInfo(date);
    }

    date = new Date(this.getDateInfo(date).time);
    date.setDate(date.getDate() + n);
    return this.getDateInfo(date);
  };

  Calendar.prototype.update = function (ecModel, api) {
    this._firstDayOfWeek = +this._model.getModel('dayLabel').get('firstDay');
    this._orient = this._model.get('orient');
    this._lineWidth = this._model.getModel('itemStyle').getItemStyle().lineWidth || 0;
    this._rangeInfo = this._getRangeInfo(this._initRangeOption());
    var weeks = this._rangeInfo.weeks || 1;
    var whNames = ['width', 'height'];

    var cellSize = this._model.getCellSize().slice();

    var layoutParams = this._model.getBoxLayoutParams();

    var cellNumbers = this._orient === 'horizontal' ? [weeks, 7] : [7, weeks];
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"]([0, 1], function (idx) {
      if (cellSizeSpecified(cellSize, idx)) {
        layoutParams[whNames[idx]] = cellSize[idx] * cellNumbers[idx];
      }
    });
    var whGlobal = {
      width: api.getWidth(),
      height: api.getHeight()
    };
    var calendarRect = this._rect = __WEBPACK_IMPORTED_MODULE_1__util_layout_js__["f" /* getLayoutRect */](layoutParams, whGlobal);
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"]([0, 1], function (idx) {
      if (!cellSizeSpecified(cellSize, idx)) {
        cellSize[idx] = calendarRect[whNames[idx]] / cellNumbers[idx];
      }
    });

    function cellSizeSpecified(cellSize, idx) {
      return cellSize[idx] != null && cellSize[idx] !== 'auto';
    } // Has been calculated out number.


    this._sw = cellSize[0];
    this._sh = cellSize[1];
  };
  /**
   * Convert a time data(time, value) item to (x, y) point.
   */
  // TODO Clamp of calendar is not same with cartesian coordinate systems.
  // It will return NaN if data exceeds.


  Calendar.prototype.dataToPoint = function (data, clamp) {
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](data) && (data = data[0]);
    clamp == null && (clamp = true);
    var dayInfo = this.getDateInfo(data);
    var range = this._rangeInfo;
    var date = dayInfo.formatedDate; // if not in range return [NaN, NaN]

    if (clamp && !(dayInfo.time >= range.start.time && dayInfo.time < range.end.time + PROXIMATE_ONE_DAY)) {
      return [NaN, NaN];
    }

    var week = dayInfo.day;

    var nthWeek = this._getRangeInfo([range.start.time, date]).nthWeek;

    if (this._orient === 'vertical') {
      return [this._rect.x + week * this._sw + this._sw / 2, this._rect.y + nthWeek * this._sh + this._sh / 2];
    }

    return [this._rect.x + nthWeek * this._sw + this._sw / 2, this._rect.y + week * this._sh + this._sh / 2];
  };
  /**
   * Convert a (x, y) point to time data
   */


  Calendar.prototype.pointToData = function (point) {
    var date = this.pointToDate(point);
    return date && date.time;
  };
  /**
   * Convert a time date item to (x, y) four point.
   */


  Calendar.prototype.dataToRect = function (data, clamp) {
    var point = this.dataToPoint(data, clamp);
    return {
      contentShape: {
        x: point[0] - (this._sw - this._lineWidth) / 2,
        y: point[1] - (this._sh - this._lineWidth) / 2,
        width: this._sw - this._lineWidth,
        height: this._sh - this._lineWidth
      },
      center: point,
      tl: [point[0] - this._sw / 2, point[1] - this._sh / 2],
      tr: [point[0] + this._sw / 2, point[1] - this._sh / 2],
      br: [point[0] + this._sw / 2, point[1] + this._sh / 2],
      bl: [point[0] - this._sw / 2, point[1] + this._sh / 2]
    };
  };
  /**
   * Convert a (x, y) point to time date
   *
   * @param  {Array} point point
   * @return {Object}       date
   */


  Calendar.prototype.pointToDate = function (point) {
    var nthX = Math.floor((point[0] - this._rect.x) / this._sw) + 1;
    var nthY = Math.floor((point[1] - this._rect.y) / this._sh) + 1;
    var range = this._rangeInfo.range;

    if (this._orient === 'vertical') {
      return this._getDateByWeeksAndDay(nthY, nthX - 1, range);
    }

    return this._getDateByWeeksAndDay(nthX, nthY - 1, range);
  };

  Calendar.prototype.convertToPixel = function (ecModel, finder, value) {
    var coordSys = getCoordSys(finder);
    return coordSys === this ? coordSys.dataToPoint(value) : null;
  };

  Calendar.prototype.convertFromPixel = function (ecModel, finder, pixel) {
    var coordSys = getCoordSys(finder);
    return coordSys === this ? coordSys.pointToData(pixel) : null;
  };

  Calendar.prototype.containPoint = function (point) {
    console.warn('Not implemented.');
    return false;
  };
  /**
   * initRange
   * Normalize to an [start, end] array
   */


  Calendar.prototype._initRangeOption = function () {
    var range = this._model.get('range');

    var normalizedRange; // Convert [1990] to 1990

    if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](range) && range.length === 1) {
      range = range[0];
    }

    if (!__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](range)) {
      var rangeStr = range.toString(); // One year.

      if (/^\d{4}$/.test(rangeStr)) {
        normalizedRange = [rangeStr + '-01-01', rangeStr + '-12-31'];
      } // One month


      if (/^\d{4}[\/|-]\d{1,2}$/.test(rangeStr)) {
        var start = this.getDateInfo(rangeStr);
        var firstDay = start.date;
        firstDay.setMonth(firstDay.getMonth() + 1);
        var end = this.getNextNDay(firstDay, -1);
        normalizedRange = [start.formatedDate, end.formatedDate];
      } // One day


      if (/^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(rangeStr)) {
        normalizedRange = [rangeStr, rangeStr];
      }
    } else {
      normalizedRange = range;
    }

    if (!normalizedRange) {
      if (true) {
        __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["logError"]('Invalid date range.');
      } // Not handling it.


      return range;
    }

    var tmp = this._getRangeInfo(normalizedRange);

    if (tmp.start.time > tmp.end.time) {
      normalizedRange.reverse();
    }

    return normalizedRange;
  };
  /**
   * range info
   *
   * @private
   * @param  {Array} range range ['2017-01-01', '2017-07-08']
   *  If range[0] > range[1], they will not be reversed.
   * @return {Object}       obj
   */


  Calendar.prototype._getRangeInfo = function (range) {
    var parsedRange = [this.getDateInfo(range[0]), this.getDateInfo(range[1])];
    var reversed;

    if (parsedRange[0].time > parsedRange[1].time) {
      reversed = true;
      parsedRange.reverse();
    }

    var allDay = Math.floor(parsedRange[1].time / PROXIMATE_ONE_DAY) - Math.floor(parsedRange[0].time / PROXIMATE_ONE_DAY) + 1; // Consider case1 (#11677 #10430):
    // Set the system timezone as "UK", set the range to `['2016-07-01', '2016-12-31']`
    // Consider case2:
    // Firstly set system timezone as "Time Zone: America/Toronto",
    // ```
    // let first = new Date(1478412000000 - 3600 * 1000 * 2.5);
    // let second = new Date(1478412000000);
    // let allDays = Math.floor(second / ONE_DAY) - Math.floor(first / ONE_DAY) + 1;
    // ```
    // will get wrong result because of DST. So we should fix it.

    var date = new Date(parsedRange[0].time);
    var startDateNum = date.getDate();
    var endDateNum = parsedRange[1].date.getDate();
    date.setDate(startDateNum + allDay - 1); // The bias can not over a month, so just compare date.

    var dateNum = date.getDate();

    if (dateNum !== endDateNum) {
      var sign = date.getTime() - parsedRange[1].time > 0 ? 1 : -1;

      while ((dateNum = date.getDate()) !== endDateNum && (date.getTime() - parsedRange[1].time) * sign > 0) {
        allDay -= sign;
        date.setDate(dateNum - sign);
      }
    }

    var weeks = Math.floor((allDay + parsedRange[0].day + 6) / 7);
    var nthWeek = reversed ? -weeks + 1 : weeks - 1;
    reversed && parsedRange.reverse();
    return {
      range: [parsedRange[0].formatedDate, parsedRange[1].formatedDate],
      start: parsedRange[0],
      end: parsedRange[1],
      allDay: allDay,
      weeks: weeks,
      // From 0.
      nthWeek: nthWeek,
      fweek: parsedRange[0].day,
      lweek: parsedRange[1].day
    };
  };
  /**
   * get date by nthWeeks and week day in range
   *
   * @private
   * @param  {number} nthWeek the week
   * @param  {number} day   the week day
   * @param  {Array} range [d1, d2]
   * @return {Object}
   */


  Calendar.prototype._getDateByWeeksAndDay = function (nthWeek, day, range) {
    var rangeInfo = this._getRangeInfo(range);

    if (nthWeek > rangeInfo.weeks || nthWeek === 0 && day < rangeInfo.fweek || nthWeek === rangeInfo.weeks && day > rangeInfo.lweek) {
      return null;
    }

    var nthDay = (nthWeek - 1) * 7 - rangeInfo.fweek + day;
    var date = new Date(rangeInfo.start.time);
    date.setDate(+rangeInfo.start.d + nthDay);
    return this.getDateInfo(date);
  };

  Calendar.create = function (ecModel, api) {
    var calendarList = [];
    ecModel.eachComponent('calendar', function (calendarModel) {
      var calendar = new Calendar(calendarModel, ecModel, api);
      calendarList.push(calendar);
      calendarModel.coordinateSystem = calendar;
    });
    ecModel.eachSeries(function (calendarSeries) {
      if (calendarSeries.get('coordinateSystem') === 'calendar') {
        // Inject coordinate system
        calendarSeries.coordinateSystem = calendarList[calendarSeries.get('calendarIndex') || 0];
      }
    });
    return calendarList;
  };

  Calendar.dimensions = ['time', 'value'];
  return Calendar;
}();

function getCoordSys(finder) {
  var calendarModel = finder.calendarModel;
  var seriesModel = finder.seriesModel;
  var coordSys = calendarModel ? calendarModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem : null;
  return coordSys;
}

/* harmony default export */ __webpack_exports__["a"] = (Calendar);

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_Component_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_layout_js__ = __webpack_require__(19);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var CalendarModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(CalendarModel, _super);

  function CalendarModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = CalendarModel.type;
    return _this;
  }
  /**
   * @override
   */


  CalendarModel.prototype.init = function (option, parentModel, ecModel) {
    var inputPositionParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_layout_js__["b" /* getLayoutParams */])(option);

    _super.prototype.init.apply(this, arguments);

    mergeAndNormalizeLayoutParams(option, inputPositionParams);
  };
  /**
   * @override
   */


  CalendarModel.prototype.mergeOption = function (option) {
    _super.prototype.mergeOption.apply(this, arguments);

    mergeAndNormalizeLayoutParams(this.option, option);
  };

  CalendarModel.prototype.getCellSize = function () {
    // Has been normalized
    return this.option.cellSize;
  };

  CalendarModel.type = 'calendar';
  CalendarModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    left: 80,
    top: 60,
    cellSize: 20,
    // horizontal vertical
    orient: 'horizontal',
    // month separate line style
    splitLine: {
      show: true,
      lineStyle: {
        color: '#000',
        width: 1,
        type: 'solid'
      }
    },
    // rect style  temporarily unused emphasis
    itemStyle: {
      color: '#fff',
      borderWidth: 1,
      borderColor: '#ccc'
    },
    // week text style
    dayLabel: {
      show: true,
      firstDay: 0,
      // start end
      position: 'start',
      margin: '50%',
      color: '#000'
    },
    // month text style
    monthLabel: {
      show: true,
      // start end
      position: 'start',
      margin: 5,
      // center or left
      align: 'center',
      formatter: null,
      color: '#000'
    },
    // year text style
    yearLabel: {
      show: true,
      // top bottom left right
      position: null,
      margin: 30,
      formatter: null,
      color: '#ccc',
      fontFamily: 'sans-serif',
      fontWeight: 'bolder',
      fontSize: 20
    }
  };
  return CalendarModel;
}(__WEBPACK_IMPORTED_MODULE_2__model_Component_js__["a" /* default */]);

function mergeAndNormalizeLayoutParams(target, raw) {
  // Normalize cellSize
  var cellSize = target.cellSize;
  var cellSizeArr;

  if (!__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"](cellSize)) {
    cellSizeArr = target.cellSize = [cellSize, cellSize];
  } else {
    cellSizeArr = cellSize;
  }

  if (cellSizeArr.length === 1) {
    cellSizeArr[1] = cellSizeArr[0];
  }

  var ignoreSize = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"]([0, 1], function (hvIdx) {
    // If user have set `width` or both `left` and `right`, cellSizeArr
    // will be automatically set to 'auto', otherwise the default
    // setting of cellSizeArr will make `width` setting not work.
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_layout_js__["i" /* sizeCalculable */])(raw, hvIdx)) {
      cellSizeArr[hvIdx] = 'auto';
    }

    return cellSizeArr[hvIdx] != null && cellSizeArr[hvIdx] !== 'auto';
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_layout_js__["c" /* mergeLayoutParam */])(target, raw, {
    type: 'box',
    ignoreSize: ignoreSize
  });
}

/* harmony default export */ __webpack_exports__["a"] = (CalendarModel);

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calendarPrepareCustom;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function calendarPrepareCustom(coordSys) {
  var rect = coordSys.getRect();
  var rangeInfo = coordSys.getRangeInfo();
  return {
    coordSys: {
      type: 'calendar',
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height,
      cellWidth: coordSys.getCellWidth(),
      cellHeight: coordSys.getCellHeight(),
      rangeInfo: {
        start: rangeInfo.start,
        end: rangeInfo.end,
        weeks: rangeInfo.weeks,
        dayCount: rangeInfo.allDay
      }
    },
    api: {
      coord: function (data, clamp) {
        return coordSys.dataToPoint(data, clamp);
      }
    }
  };
}

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Axis_js__ = __webpack_require__(112);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var Axis2D =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Axis2D, _super);

  function Axis2D(dim, scale, coordExtent, axisType, position) {
    var _this = _super.call(this, dim, scale, coordExtent) || this;
    /**
     * Index of axis, can be used as key
     * Injected outside.
     */


    _this.index = 0;
    _this.type = axisType || 'value';
    _this.position = position || 'bottom';
    return _this;
  }

  Axis2D.prototype.isHorizontal = function () {
    var position = this.position;
    return position === 'top' || position === 'bottom';
  };
  /**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */


  Axis2D.prototype.getGlobalExtent = function (asc) {
    var ret = this.getExtent();
    ret[0] = this.toGlobalCoord(ret[0]);
    ret[1] = this.toGlobalCoord(ret[1]);
    asc && ret[0] > ret[1] && ret.reverse();
    return ret;
  };

  Axis2D.prototype.pointToData = function (point, clamp) {
    return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
  };
  /**
   * Set ordinalSortInfo
   * @param info new OrdinalSortInfo
   */


  Axis2D.prototype.setCategorySortInfo = function (info) {
    if (this.type !== 'category') {
      return false;
    }

    this.model.option.categorySortInfo = info;
    this.scale.setSortInfo(info);
  };

  return Axis2D;
}(__WEBPACK_IMPORTED_MODULE_1__Axis_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Axis2D);

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CartesianAxisModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_Component_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axisModelCommonMixin_js__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






var CartesianAxisModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(CartesianAxisModel, _super);

  function CartesianAxisModel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  CartesianAxisModel.prototype.getCoordSysModel = function () {
    return this.getReferringComponents('grid', __WEBPACK_IMPORTED_MODULE_4__util_model_js__["i" /* SINGLE_REFERRING */]).models[0];
  };

  CartesianAxisModel.type = 'cartesian2dAxis';
  return CartesianAxisModel;
}(__WEBPACK_IMPORTED_MODULE_2__model_Component_js__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["mixin"](CartesianAxisModel, __WEBPACK_IMPORTED_MODULE_3__axisModelCommonMixin_js__["a" /* AxisModelCommonMixin */]);
/* unused harmony default export */ var _unused_webpack_default_export = (CartesianAxisModel);

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


var Cartesian =
/** @class */
function () {
  function Cartesian(name) {
    this.type = 'cartesian';
    this._dimList = [];
    this._axes = {};
    this.name = name || '';
  }

  Cartesian.prototype.getAxis = function (dim) {
    return this._axes[dim];
  };

  Cartesian.prototype.getAxes = function () {
    return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"](this._dimList, function (dim) {
      return this._axes[dim];
    }, this);
  };

  Cartesian.prototype.getAxesByScale = function (scaleType) {
    scaleType = scaleType.toLowerCase();
    return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["filter"](this.getAxes(), function (axis) {
      return axis.scale.type === scaleType;
    });
  };

  Cartesian.prototype.addAxis = function (axis) {
    var dim = axis.dim;
    this._axes[dim] = axis;

    this._dimList.push(dim);
  };

  return Cartesian;
}();

;
/* harmony default export */ __webpack_exports__["a"] = (Cartesian);

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cartesian2DDimensions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Cartesian_js__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_matrix_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_vector_js__ = __webpack_require__(23);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var cartesian2DDimensions = ['x', 'y'];

function canCalculateAffineTransform(scale) {
  return scale.type === 'interval' || scale.type === 'time';
}

var Cartesian2D =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Cartesian2D, _super);

  function Cartesian2D() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = 'cartesian2d';
    _this.dimensions = cartesian2DDimensions;
    return _this;
  }
  /**
   * Calculate an affine transform matrix if two axes are time or value.
   * It's mainly for accelartion on the large time series data.
   */


  Cartesian2D.prototype.calcAffineTransform = function () {
    this._transform = this._invTransform = null;
    var xAxisScale = this.getAxis('x').scale;
    var yAxisScale = this.getAxis('y').scale;

    if (!canCalculateAffineTransform(xAxisScale) || !canCalculateAffineTransform(yAxisScale)) {
      return;
    }

    var xScaleExtent = xAxisScale.getExtent();
    var yScaleExtent = yAxisScale.getExtent();
    var start = this.dataToPoint([xScaleExtent[0], yScaleExtent[0]]);
    var end = this.dataToPoint([xScaleExtent[1], yScaleExtent[1]]);
    var xScaleSpan = xScaleExtent[1] - xScaleExtent[0];
    var yScaleSpan = yScaleExtent[1] - yScaleExtent[0];

    if (!xScaleSpan || !yScaleSpan) {
      return;
    } // Accelerate data to point calculation on the special large time series data.


    var scaleX = (end[0] - start[0]) / xScaleSpan;
    var scaleY = (end[1] - start[1]) / yScaleSpan;
    var translateX = start[0] - xScaleExtent[0] * scaleX;
    var translateY = start[1] - yScaleExtent[0] * scaleY;
    var m = this._transform = [scaleX, 0, 0, scaleY, translateX, translateY];
    this._invTransform = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_matrix_js__["invert"])([], m);
  };
  /**
   * Base axis will be used on stacking.
   */


  Cartesian2D.prototype.getBaseAxis = function () {
    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
  };

  Cartesian2D.prototype.containPoint = function (point) {
    var axisX = this.getAxis('x');
    var axisY = this.getAxis('y');
    return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
  };

  Cartesian2D.prototype.containData = function (data) {
    return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
  };

  Cartesian2D.prototype.dataToPoint = function (data, clamp, out) {
    out = out || [];
    var xVal = data[0];
    var yVal = data[1]; // Fast path

    if (this._transform // It's supported that if data is like `[Inifity, 123]`, where only Y pixel calculated.
    && xVal != null && isFinite(xVal) && yVal != null && isFinite(yVal)) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_vector_js__["applyTransform"])(out, data, this._transform);
    }

    var xAxis = this.getAxis('x');
    var yAxis = this.getAxis('y');
    out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(xVal, clamp));
    out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(yVal, clamp));
    return out;
  };

  Cartesian2D.prototype.clampData = function (data, out) {
    var xScale = this.getAxis('x').scale;
    var yScale = this.getAxis('y').scale;
    var xAxisExtent = xScale.getExtent();
    var yAxisExtent = yScale.getExtent();
    var x = xScale.parse(data[0]);
    var y = yScale.parse(data[1]);
    out = out || [];
    out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
    out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
    return out;
  };

  Cartesian2D.prototype.pointToData = function (point, clamp) {
    var out = [];

    if (this._invTransform) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_vector_js__["applyTransform"])(out, point, this._invTransform);
    }

    var xAxis = this.getAxis('x');
    var yAxis = this.getAxis('y');
    out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp);
    out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp);
    return out;
  };

  Cartesian2D.prototype.getOtherAxis = function (axis) {
    return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
  };
  /**
   * Get rect area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */


  Cartesian2D.prototype.getArea = function () {
    var xExtent = this.getAxis('x').getGlobalExtent();
    var yExtent = this.getAxis('y').getGlobalExtent();
    var x = Math.min(xExtent[0], xExtent[1]);
    var y = Math.min(yExtent[0], yExtent[1]);
    var width = Math.max(xExtent[0], xExtent[1]) - x;
    var height = Math.max(yExtent[0], yExtent[1]) - y;
    return new __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_BoundingRect_js__["a" /* default */](x, y, width, height);
  };

  return Cartesian2D;
}(__WEBPACK_IMPORTED_MODULE_2__Cartesian_js__["a" /* default */]);

;
/* harmony default export */ __webpack_exports__["b"] = (Cartesian2D);

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__coord_axisHelper_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Cartesian2D_js__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Axis2D_js__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cartesianAxisHelper_js__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scale_helper_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__axisAlignTicks_js__ = __webpack_require__(484);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Grid is a region which contains at most 4 cartesian systems
 *
 * TODO Default cartesian
 */










var Grid =
/** @class */
function () {
  function Grid(gridModel, ecModel, api) {
    // FIXME:TS where used (different from registered type 'cartesian2d')?
    this.type = 'grid';
    this._coordsMap = {};
    this._coordsList = [];
    this._axesMap = {};
    this._axesList = [];
    this.axisPointerEnabled = true;
    this.dimensions = __WEBPACK_IMPORTED_MODULE_3__Cartesian2D_js__["a" /* cartesian2DDimensions */];

    this._initCartesian(gridModel, ecModel, api);

    this.model = gridModel;
  }

  Grid.prototype.getRect = function () {
    return this._rect;
  };

  Grid.prototype.update = function (ecModel, api) {
    var axesMap = this._axesMap;

    this._updateScale(ecModel, this.model);

    function updateAxisTicks(axes) {
      var alignTo; // Axis is added in order of axisIndex.

      var axesIndices = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["keys"])(axes);
      var len = axesIndices.length;

      if (!len) {
        return;
      }

      var axisNeedsAlign = []; // Process once and calculate the ticks for those don't use alignTicks.

      for (var i = len - 1; i >= 0; i--) {
        var idx = +axesIndices[i]; // Convert to number.

        var axis = axes[idx];
        var model = axis.model;
        var scale = axis.scale;

        if ( // Only value and log axis without interval support alignTicks.
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__scale_helper_js__["h" /* isIntervalOrLogScale */])(scale) && model.get('alignTicks') && model.get('interval') == null) {
          axisNeedsAlign.push(axis);
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__coord_axisHelper_js__["g" /* niceScaleExtent */])(scale, model);

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__scale_helper_js__["h" /* isIntervalOrLogScale */])(scale)) {
            // Can only align to interval or log axis.
            alignTo = axis;
          }
        }
      }

      ; // All axes has set alignTicks. Pick the first one.
      // PENDING. Should we find the axis that both set interval, min, max and align to this one?

      if (axisNeedsAlign.length) {
        if (!alignTo) {
          alignTo = axisNeedsAlign.pop();
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__coord_axisHelper_js__["g" /* niceScaleExtent */])(alignTo.scale, alignTo.model);
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(axisNeedsAlign, function (axis) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__axisAlignTicks_js__["a" /* alignScaleTicks */])(axis.scale, axis.model, alignTo.scale);
        });
      }
    }

    updateAxisTicks(axesMap.x);
    updateAxisTicks(axesMap.y); // Key: axisDim_axisIndex, value: boolean, whether onZero target.

    var onZeroRecords = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(axesMap.x, function (xAxis) {
      fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(axesMap.y, function (yAxis) {
      fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
    }); // Resize again if containLabel is enabled
    // FIXME It may cause getting wrong grid size in data processing stage

    this.resize(this.model, api);
  };
  /**
   * Resize the grid
   */


  Grid.prototype.resize = function (gridModel, api, ignoreContainLabel) {
    var boxLayoutParams = gridModel.getBoxLayoutParams();
    var isContainLabel = !ignoreContainLabel && gridModel.get('containLabel');
    var gridRect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_layout_js__["f" /* getLayoutRect */])(boxLayoutParams, {
      width: api.getWidth(),
      height: api.getHeight()
    });
    this._rect = gridRect;
    var axesList = this._axesList;
    adjustAxes(); // Minus label size

    if (isContainLabel) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(axesList, function (axis) {
        if (!axis.model.get(['axisLabel', 'inside'])) {
          var labelUnionRect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__coord_axisHelper_js__["j" /* estimateLabelUnionRect */])(axis);

          if (labelUnionRect) {
            var dim = axis.isHorizontal() ? 'height' : 'width';
            var margin = axis.model.get(['axisLabel', 'margin']);
            gridRect[dim] -= labelUnionRect[dim] + margin;

            if (axis.position === 'top') {
              gridRect.y += labelUnionRect.height + margin;
            } else if (axis.position === 'left') {
              gridRect.x += labelUnionRect.width + margin;
            }
          }
        }
      });
      adjustAxes();
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(this._coordsList, function (coord) {
      // Calculate affine matrix to accelerate the data to point transform.
      // If all the axes scales are time or value.
      coord.calcAffineTransform();
    });

    function adjustAxes() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(axesList, function (axis) {
        var isHorizontal = axis.isHorizontal();
        var extent = isHorizontal ? [0, gridRect.width] : [0, gridRect.height];
        var idx = axis.inverse ? 1 : 0;
        axis.setExtent(extent[idx], extent[1 - idx]);
        updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
      });
    }
  };

  Grid.prototype.getAxis = function (dim, axisIndex) {
    var axesMapOnDim = this._axesMap[dim];

    if (axesMapOnDim != null) {
      return axesMapOnDim[axisIndex || 0];
    }
  };

  Grid.prototype.getAxes = function () {
    return this._axesList.slice();
  };

  Grid.prototype.getCartesian = function (xAxisIndex, yAxisIndex) {
    if (xAxisIndex != null && yAxisIndex != null) {
      var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
      return this._coordsMap[key];
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"])(xAxisIndex)) {
      yAxisIndex = xAxisIndex.yAxisIndex;
      xAxisIndex = xAxisIndex.xAxisIndex;
    }

    for (var i = 0, coordList = this._coordsList; i < coordList.length; i++) {
      if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) {
        return coordList[i];
      }
    }
  };

  Grid.prototype.getCartesians = function () {
    return this._coordsList.slice();
  };
  /**
   * @implements
   */


  Grid.prototype.convertToPixel = function (ecModel, finder, value) {
    var target = this._findConvertTarget(finder);

    return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
  };
  /**
   * @implements
   */


  Grid.prototype.convertFromPixel = function (ecModel, finder, value) {
    var target = this._findConvertTarget(finder);

    return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
  };

  Grid.prototype._findConvertTarget = function (finder) {
    var seriesModel = finder.seriesModel;
    var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis', __WEBPACK_IMPORTED_MODULE_5__util_model_js__["i" /* SINGLE_REFERRING */]).models[0];
    var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis', __WEBPACK_IMPORTED_MODULE_5__util_model_js__["i" /* SINGLE_REFERRING */]).models[0];
    var gridModel = finder.gridModel;
    var coordsList = this._coordsList;
    var cartesian;
    var axis;

    if (seriesModel) {
      cartesian = seriesModel.coordinateSystem;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"])(coordsList, cartesian) < 0 && (cartesian = null);
    } else if (xAxisModel && yAxisModel) {
      cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
    } else if (xAxisModel) {
      axis = this.getAxis('x', xAxisModel.componentIndex);
    } else if (yAxisModel) {
      axis = this.getAxis('y', yAxisModel.componentIndex);
    } // Lowest priority.
    else if (gridModel) {
        var grid = gridModel.coordinateSystem;

        if (grid === this) {
          cartesian = this._coordsList[0];
        }
      }

    return {
      cartesian: cartesian,
      axis: axis
    };
  };
  /**
   * @implements
   */


  Grid.prototype.containPoint = function (point) {
    var coord = this._coordsList[0];

    if (coord) {
      return coord.containPoint(point);
    }
  };
  /**
   * Initialize cartesian coordinate systems
   */


  Grid.prototype._initCartesian = function (gridModel, ecModel, api) {
    var _this = this;

    var grid = this;
    var axisPositionUsed = {
      left: false,
      right: false,
      top: false,
      bottom: false
    };
    var axesMap = {
      x: {},
      y: {}
    };
    var axesCount = {
      x: 0,
      y: 0
    }; /// Create axis

    ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
    ecModel.eachComponent('yAxis', createAxisCreator('y'), this);

    if (!axesCount.x || !axesCount.y) {
      // Roll back when there no either x or y axis
      this._axesMap = {};
      this._axesList = [];
      return;
    }

    this._axesMap = axesMap; /// Create cartesian2d

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(axesMap.x, function (xAxis, xAxisIndex) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(axesMap.y, function (yAxis, yAxisIndex) {
        var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
        var cartesian = new __WEBPACK_IMPORTED_MODULE_3__Cartesian2D_js__["b" /* default */](key);
        cartesian.master = _this;
        cartesian.model = gridModel;
        _this._coordsMap[key] = cartesian;

        _this._coordsList.push(cartesian);

        cartesian.addAxis(xAxis);
        cartesian.addAxis(yAxis);
      });
    });

    function createAxisCreator(dimName) {
      return function (axisModel, idx) {
        if (!isAxisUsedInTheGrid(axisModel, gridModel)) {
          return;
        }

        var axisPosition = axisModel.get('position');

        if (dimName === 'x') {
          // Fix position
          if (axisPosition !== 'top' && axisPosition !== 'bottom') {
            // Default bottom of X
            axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
          }
        } else {
          // Fix position
          if (axisPosition !== 'left' && axisPosition !== 'right') {
            // Default left of Y
            axisPosition = axisPositionUsed.left ? 'right' : 'left';
          }
        }

        axisPositionUsed[axisPosition] = true;
        var axis = new __WEBPACK_IMPORTED_MODULE_4__Axis2D_js__["a" /* default */](dimName, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__coord_axisHelper_js__["f" /* createScaleByModel */])(axisModel), [0, 0], axisModel.get('type'), axisPosition);
        var isCategory = axis.type === 'category';
        axis.onBand = isCategory && axisModel.get('boundaryGap');
        axis.inverse = axisModel.get('inverse'); // Inject axis into axisModel

        axisModel.axis = axis; // Inject axisModel into axis

        axis.model = axisModel; // Inject grid info axis

        axis.grid = grid; // Index of axis, can be used as key

        axis.index = idx;

        grid._axesList.push(axis);

        axesMap[dimName][idx] = axis;
        axesCount[dimName]++;
      };
    }
  };
  /**
   * Update cartesian properties from series.
   */


  Grid.prototype._updateScale = function (ecModel, gridModel) {
    // Reset scale
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(this._axesList, function (axis) {
      axis.scale.setExtent(Infinity, -Infinity);

      if (axis.type === 'category') {
        var categorySortInfo = axis.model.get('categorySortInfo');
        axis.scale.setSortInfo(categorySortInfo);
      }
    });
    ecModel.eachSeries(function (seriesModel) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__cartesianAxisHelper_js__["b" /* isCartesian2DSeries */])(seriesModel)) {
        var axesModelMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__cartesianAxisHelper_js__["c" /* findAxisModels */])(seriesModel);
        var xAxisModel = axesModelMap.xAxisModel;
        var yAxisModel = axesModelMap.yAxisModel;

        if (!isAxisUsedInTheGrid(xAxisModel, gridModel) || !isAxisUsedInTheGrid(yAxisModel, gridModel)) {
          return;
        }

        var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        var data = seriesModel.getData();
        var xAxis = cartesian.getAxis('x');
        var yAxis = cartesian.getAxis('y');
        unionExtent(data, xAxis);
        unionExtent(data, yAxis);
      }
    }, this);

    function unionExtent(data, axis) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__coord_axisHelper_js__["i" /* getDataDimensionsOnAxis */])(data, axis.dim), function (dim) {
        axis.scale.unionExtentFromData(data, dim);
      });
    }
  };
  /**
   * @param dim 'x' or 'y' or 'auto' or null/undefined
   */


  Grid.prototype.getTooltipAxes = function (dim) {
    var baseAxes = [];
    var otherAxes = [];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(this.getCartesians(), function (cartesian) {
      var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
      var otherAxis = cartesian.getOtherAxis(baseAxis);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"])(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"])(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
    });
    return {
      baseAxes: baseAxes,
      otherAxes: otherAxes
    };
  };

  Grid.create = function (ecModel, api) {
    var grids = [];
    ecModel.eachComponent('grid', function (gridModel, idx) {
      var grid = new Grid(gridModel, ecModel, api);
      grid.name = 'grid_' + idx; // dataSampling requires axis extent, so resize
      // should be performed in create stage.

      grid.resize(gridModel, api, true);
      gridModel.coordinateSystem = grid;
      grids.push(grid);
    }); // Inject the coordinateSystems into seriesModel

    ecModel.eachSeries(function (seriesModel) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__cartesianAxisHelper_js__["b" /* isCartesian2DSeries */])(seriesModel)) {
        return;
      }

      var axesModelMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__cartesianAxisHelper_js__["c" /* findAxisModels */])(seriesModel);
      var xAxisModel = axesModelMap.xAxisModel;
      var yAxisModel = axesModelMap.yAxisModel;
      var gridModel = xAxisModel.getCoordSysModel();

      if (true) {
        if (!gridModel) {
          throw new Error('Grid "' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve3"])(xAxisModel.get('gridIndex'), xAxisModel.get('gridId'), 0) + '" not found');
        }

        if (xAxisModel.getCoordSysModel() !== yAxisModel.getCoordSysModel()) {
          throw new Error('xAxis and yAxis must use the same grid');
        }
      }

      var grid = gridModel.coordinateSystem;
      seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
    });
    return grids;
  }; // For deciding which dimensions to use when creating list data


  Grid.dimensions = __WEBPACK_IMPORTED_MODULE_3__Cartesian2D_js__["a" /* cartesian2DDimensions */];
  return Grid;
}();
/**
 * Check if the axis is used in the specified grid.
 */


function isAxisUsedInTheGrid(axisModel, gridModel) {
  return axisModel.getCoordSysModel() === gridModel;
}

function fixAxisOnZero(axesMap, otherAxisDim, axis, // Key: see `getOnZeroRecordKey`
onZeroRecords) {
  axis.getAxesOnZeroOf = function () {
    // TODO: onZero of multiple axes.
    return otherAxisOnZeroOf ? [otherAxisOnZeroOf] : [];
  }; // onZero can not be enabled in these two situations:
  // 1. When any other axis is a category axis.
  // 2. When no axis is cross 0 point.


  var otherAxes = axesMap[otherAxisDim];
  var otherAxisOnZeroOf;
  var axisModel = axis.model;
  var onZero = axisModel.get(['axisLine', 'onZero']);
  var onZeroAxisIndex = axisModel.get(['axisLine', 'onZeroAxisIndex']);

  if (!onZero) {
    return;
  } // If target axis is specified.


  if (onZeroAxisIndex != null) {
    if (canOnZeroToAxis(otherAxes[onZeroAxisIndex])) {
      otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
    }
  } else {
    // Find the first available other axis.
    for (var idx in otherAxes) {
      if (otherAxes.hasOwnProperty(idx) && canOnZeroToAxis(otherAxes[idx]) // Consider that two Y axes on one value axis,
      // if both onZero, the two Y axes overlap.
      && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
        otherAxisOnZeroOf = otherAxes[idx];
        break;
      }
    }
  }

  if (otherAxisOnZeroOf) {
    onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
  }

  function getOnZeroRecordKey(axis) {
    return axis.dim + '_' + axis.index;
  }
}

function canOnZeroToAxis(axis) {
  return axis && axis.type !== 'category' && axis.type !== 'time' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__coord_axisHelper_js__["k" /* ifAxisCrossZero */])(axis);
}

function updateAxisTransform(axis, coordBase) {
  var axisExtent = axis.getExtent();
  var axisExtentSum = axisExtent[0] + axisExtent[1]; // Fast transform

  axis.toGlobalCoord = axis.dim === 'x' ? function (coord) {
    return coord + coordBase;
  } : function (coord) {
    return axisExtentSum - coord + coordBase;
  };
  axis.toLocalCoord = axis.dim === 'x' ? function (coord) {
    return coord - coordBase;
  } : function (coord) {
    return axisExtentSum - coord + coordBase;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Grid);

/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_Component_js__ = __webpack_require__(21);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var GridModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(GridModel, _super);

  function GridModel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  GridModel.type = 'grid';
  GridModel.dependencies = ['xAxis', 'yAxis'];
  GridModel.layoutMode = 'box';
  GridModel.defaultOption = {
    show: false,
    // zlevel: 0,
    z: 0,
    left: '10%',
    top: 60,
    right: '10%',
    bottom: 70,
    // If grid size contain label
    containLabel: false,
    // width: {totalWidth} - left - right,
    // height: {totalHeight} - top - bottom,
    backgroundColor: 'rgba(0,0,0,0)',
    borderWidth: 1,
    borderColor: '#ccc'
  };
  return GridModel;
}(__WEBPACK_IMPORTED_MODULE_1__model_Component_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (GridModel);

/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cartesianPrepareCustom;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


function dataToCoordSize(dataSize, dataItem) {
  // dataItem is necessary in log axis.
  dataItem = dataItem || [0, 0];
  return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"](['x', 'y'], function (dim, dimIdx) {
    var axis = this.getAxis(dim);
    var val = dataItem[dimIdx];
    var halfSize = dataSize[dimIdx] / 2;
    return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
  }, this);
}

function cartesianPrepareCustom(coordSys) {
  var rect = coordSys.master.getRect();
  return {
    coordSys: {
      // The name exposed to user is always 'cartesian2d' but not 'grid'.
      type: 'cartesian2d',
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    },
    api: {
      coord: function (data) {
        // do not provide "out" param
        return coordSys.dataToPoint(data);
      },
      size: __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["bind"](dataToCoordSize, coordSys)
    }
  };
}

/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return geo2DDimensions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__View_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__geoSourceManager_js__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_log_js__ = __webpack_require__(14);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







var GEO_DEFAULT_PARAMS = {
  'geoJSON': {
    aspectScale: 0.75,
    invertLongitute: true
  },
  'geoSVG': {
    aspectScale: 1,
    invertLongitute: false
  }
};
var geo2DDimensions = ['lng', 'lat'];

var Geo =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Geo, _super);

  function Geo(name, map, opt) {
    var _this = _super.call(this, name) || this;

    _this.dimensions = geo2DDimensions;
    _this.type = 'geo'; // Only store specified name coord via `addGeoCoord`.

    _this._nameCoordMap = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"]();
    _this.map = map;
    var projection = opt.projection;
    var source = __WEBPACK_IMPORTED_MODULE_4__geoSourceManager_js__["a" /* default */].load(map, opt.nameMap, opt.nameProperty);
    var resource = __WEBPACK_IMPORTED_MODULE_4__geoSourceManager_js__["a" /* default */].getGeoResource(map);
    var resourceType = _this.resourceType = resource ? resource.type : null;
    var regions = _this.regions = source.regions;
    var defaultParams = GEO_DEFAULT_PARAMS[resource.type];
    _this._regionsMap = source.regionsMap;
    _this.regions = source.regions;

    if ("prod" !== 'production' && projection) {
      // Do some check
      if (resourceType === 'geoSVG') {
        if (true) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_log_js__["b" /* warn */])("Map " + map + " with SVG source can't use projection. Only GeoJSON source supports projection.");
        }

        projection = null;
      }

      if (!(projection.project && projection.unproject)) {
        if (true) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_log_js__["b" /* warn */])('project and unproject must be both provided in the projeciton.');
        }

        projection = null;
      }
    }

    _this.projection = projection;
    var boundingRect;

    if (projection) {
      // Can't reuse the raw bounding rect
      for (var i = 0; i < regions.length; i++) {
        var regionRect = regions[i].getBoundingRect(projection);
        boundingRect = boundingRect || regionRect.clone();
        boundingRect.union(regionRect);
      }
    } else {
      boundingRect = source.boundingRect;
    }

    _this.setBoundingRect(boundingRect.x, boundingRect.y, boundingRect.width, boundingRect.height); // aspectScale and invertLongitute actually is the parameters default raw projection.
    // So we ignore them if projection is given.
    // Ignore default aspect scale if projection exits.


    _this.aspectScale = projection ? 1 : __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["retrieve2"](opt.aspectScale, defaultParams.aspectScale); // Not invert longitute if projection exits.

    _this._invertLongitute = projection ? false : defaultParams.invertLongitute;
    return _this;
  }

  Geo.prototype._transformTo = function (x, y, width, height) {
    var rect = this.getBoundingRect();
    var invertLongitute = this._invertLongitute;
    rect = rect.clone();

    if (invertLongitute) {
      // Longitute is inverted
      rect.y = -rect.y - rect.height;
    }

    var rawTransformable = this._rawTransformable;
    rawTransformable.transform = rect.calculateTransform(new __WEBPACK_IMPORTED_MODULE_2_zrender_lib_core_BoundingRect_js__["a" /* default */](x, y, width, height));
    var rawParent = rawTransformable.parent;
    rawTransformable.parent = null;
    rawTransformable.decomposeTransform();
    rawTransformable.parent = rawParent;

    if (invertLongitute) {
      rawTransformable.scaleY = -rawTransformable.scaleY;
    }

    this._updateTransform();
  };

  Geo.prototype.getRegion = function (name) {
    return this._regionsMap.get(name);
  };

  Geo.prototype.getRegionByCoord = function (coord) {
    var regions = this.regions;

    for (var i = 0; i < regions.length; i++) {
      var region = regions[i];

      if (region.type === 'geoJSON' && region.contain(coord)) {
        return regions[i];
      }
    }
  };
  /**
   * Add geoCoord for indexing by name
   */


  Geo.prototype.addGeoCoord = function (name, geoCoord) {
    this._nameCoordMap.set(name, geoCoord);
  };
  /**
   * Get geoCoord by name
   */


  Geo.prototype.getGeoCoord = function (name) {
    var region = this._regionsMap.get(name); // calcualte center only on demand.


    return this._nameCoordMap.get(name) || region && region.getCenter();
  };

  Geo.prototype.dataToPoint = function (data, noRoam, out) {
    if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"](data)) {
      // Map area name to geoCoord
      data = this.getGeoCoord(data);
    }

    if (data) {
      var projection = this.projection;

      if (projection) {
        // projection may return null point.
        data = projection.project(data);
      }

      return data && this.projectedToPoint(data);
    }
  };

  Geo.prototype.pointToData = function (point) {
    var projection = this.projection;

    if (projection) {
      // projection may return null point.
      point = projection.unproject(point);
    }

    return point && this.pointToProjected(point);
  };
  /**
   * Point to projected data. Same with pointToData when projection is used.
   */


  Geo.prototype.pointToProjected = function (point) {
    return _super.prototype.pointToData.call(this, point);
  };

  Geo.prototype.projectedToPoint = function (projected, noRoam, out) {
    return _super.prototype.dataToPoint.call(this, projected, noRoam, out);
  };

  Geo.prototype.convertToPixel = function (ecModel, finder, value) {
    var coordSys = getCoordSys(finder);
    return coordSys === this ? coordSys.dataToPoint(value) : null;
  };

  Geo.prototype.convertFromPixel = function (ecModel, finder, pixel) {
    var coordSys = getCoordSys(finder);
    return coordSys === this ? coordSys.pointToData(pixel) : null;
  };

  return Geo;
}(__WEBPACK_IMPORTED_MODULE_3__View_js__["a" /* default */]);

;
__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["mixin"](Geo, __WEBPACK_IMPORTED_MODULE_3__View_js__["a" /* default */]);

function getCoordSys(finder) {
  var geoModel = finder.geoModel;
  var seriesModel = finder.seriesModel;
  return geoModel ? geoModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem // For map series.
  || (seriesModel.getReferringComponents('geo', __WEBPACK_IMPORTED_MODULE_5__util_model_js__["i" /* SINGLE_REFERRING */]).models[0] || {}).coordinateSystem : null;
}

/* harmony default export */ __webpack_exports__["b"] = (Geo);

/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GeoJSONResource; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parseGeoJson_js__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fix_nanhai_js__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fix_textCoord_js__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fix_diaoyuIsland_js__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_BoundingRect_js__ = __webpack_require__(22);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

 // Built-in GEO fixer.





var DEFAULT_NAME_PROPERTY = 'name';

var GeoJSONResource =
/** @class */
function () {
  function GeoJSONResource(mapName, geoJSON, specialAreas) {
    this.type = 'geoJSON';
    this._parsedMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();
    this._mapName = mapName;
    this._specialAreas = specialAreas; // PENDING: delay the parse to the first usage to rapid up the FMP?

    this._geoJSON = parseInput(geoJSON);
  }
  /**
   * @param nameMap can be null/undefined
   * @param nameProperty can be null/undefined
   */


  GeoJSONResource.prototype.load = function (nameMap, nameProperty) {
    nameProperty = nameProperty || DEFAULT_NAME_PROPERTY;

    var parsed = this._parsedMap.get(nameProperty);

    if (!parsed) {
      var rawRegions = this._parseToRegions(nameProperty);

      parsed = this._parsedMap.set(nameProperty, {
        regions: rawRegions,
        boundingRect: calculateBoundingRect(rawRegions)
      });
    }

    var regionsMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();
    var finalRegions = [];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(parsed.regions, function (region) {
      var regionName = region.name; // Try use the alias in geoNameMap

      if (nameMap && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(nameMap, regionName)) {
        region = region.cloneShallow(regionName = nameMap[regionName]);
      }

      finalRegions.push(region);
      regionsMap.set(regionName, region);
    });
    return {
      regions: finalRegions,
      boundingRect: parsed.boundingRect || new __WEBPACK_IMPORTED_MODULE_5_zrender_lib_core_BoundingRect_js__["a" /* default */](0, 0, 0, 0),
      regionsMap: regionsMap
    };
  };

  GeoJSONResource.prototype._parseToRegions = function (nameProperty) {
    var mapName = this._mapName;
    var geoJSON = this._geoJSON;
    var rawRegions; // https://jsperf.com/try-catch-performance-overhead

    try {
      rawRegions = geoJSON ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__parseGeoJson_js__["a" /* default */])(geoJSON, nameProperty) : [];
    } catch (e) {
      throw new Error('Invalid geoJson format\n' + e.message);
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__fix_nanhai_js__["a" /* default */])(mapName, rawRegions);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(rawRegions, function (region) {
      var regionName = region.name;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fix_textCoord_js__["a" /* default */])(mapName, region);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__fix_diaoyuIsland_js__["a" /* default */])(mapName, region); // Some area like Alaska in USA map needs to be tansformed
      // to look better

      var specialArea = this._specialAreas && this._specialAreas[regionName];

      if (specialArea) {
        region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
      }
    }, this);
    return rawRegions;
  };
  /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */


  GeoJSONResource.prototype.getMapForUser = function () {
    return {
      // For backward compatibility, use geoJson
      // PENDING: it has been returning them without clone.
      // do we need to avoid outsite modification?
      geoJson: this._geoJSON,
      geoJSON: this._geoJSON,
      specialAreas: this._specialAreas
    };
  };

  return GeoJSONResource;
}();



function calculateBoundingRect(regions) {
  var rect;

  for (var i = 0; i < regions.length; i++) {
    var regionRect = regions[i].getBoundingRect();
    rect = rect || regionRect.clone();
    rect.union(regionRect);
  }

  return rect;
}

function parseInput(source) {
  return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"])(source) ? source : typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(source) : new Function('return (' + source + ');')();
}

/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_Component_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_Model_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__geoCreator_js__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__geoSourceManager_js__ = __webpack_require__(156);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







;

var GeoModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(GeoModel, _super);

  function GeoModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = GeoModel.type;
    return _this;
  }

  GeoModel.prototype.init = function (option, parentModel, ecModel) {
    var source = __WEBPACK_IMPORTED_MODULE_6__geoSourceManager_js__["a" /* default */].getGeoResource(option.map);

    if (source && source.type === 'geoJSON') {
      var itemStyle = option.itemStyle = option.itemStyle || {};

      if (!('color' in itemStyle)) {
        itemStyle.color = '#eee';
      }
    }

    this.mergeDefaultAndTheme(option, ecModel); // Default label emphasis `show`

    __WEBPACK_IMPORTED_MODULE_2__util_model_js__["e" /* defaultEmphasis */](option, 'label', ['show']);
  };

  GeoModel.prototype.optionUpdated = function () {
    var _this = this;

    var option = this.option;
    option.regions = __WEBPACK_IMPORTED_MODULE_5__geoCreator_js__["a" /* default */].getFilledRegions(option.regions, option.map, option.nameMap, option.nameProperty);
    var selectedMap = {};
    this._optionModelMap = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["reduce"](option.regions || [], function (optionModelMap, regionOpt) {
      var regionName = regionOpt.name;

      if (regionName) {
        optionModelMap.set(regionName, new __WEBPACK_IMPORTED_MODULE_4__model_Model_js__["a" /* default */](regionOpt, _this, _this.ecModel));

        if (regionOpt.selected) {
          selectedMap[regionName] = true;
        }
      }

      return optionModelMap;
    }, __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["createHashMap"]());

    if (!option.selectedMap) {
      option.selectedMap = selectedMap;
    }
  };
  /**
   * Get model of region.
   */


  GeoModel.prototype.getRegionModel = function (name) {
    return this._optionModelMap.get(name) || new __WEBPACK_IMPORTED_MODULE_4__model_Model_js__["a" /* default */](null, this, this.ecModel);
  };
  /**
   * Format label
   * @param name Region name
   */


  GeoModel.prototype.getFormattedLabel = function (name, status) {
    var regionModel = this.getRegionModel(name);
    var formatter = status === 'normal' ? regionModel.get(['label', 'formatter']) : regionModel.get(['emphasis', 'label', 'formatter']);
    var params = {
      name: name
    };

    if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isFunction"](formatter)) {
      params.status = status;
      return formatter(params);
    } else if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"](formatter)) {
      return formatter.replace('{a}', name != null ? name : '');
    }
  };

  GeoModel.prototype.setZoom = function (zoom) {
    this.option.zoom = zoom;
  };

  GeoModel.prototype.setCenter = function (center) {
    this.option.center = center;
  }; // PENGING If selectedMode is null ?


  GeoModel.prototype.select = function (name) {
    var option = this.option;
    var selectedMode = option.selectedMode;

    if (!selectedMode) {
      return;
    }

    if (selectedMode !== 'multiple') {
      option.selectedMap = null;
    }

    var selectedMap = option.selectedMap || (option.selectedMap = {});
    selectedMap[name] = true;
  };

  GeoModel.prototype.unSelect = function (name) {
    var selectedMap = this.option.selectedMap;

    if (selectedMap) {
      selectedMap[name] = false;
    }
  };

  GeoModel.prototype.toggleSelected = function (name) {
    this[this.isSelected(name) ? 'unSelect' : 'select'](name);
  };

  GeoModel.prototype.isSelected = function (name) {
    var selectedMap = this.option.selectedMap;
    return !!(selectedMap && selectedMap[name]);
  };

  GeoModel.type = 'geo';
  GeoModel.layoutMode = 'box';
  GeoModel.defaultOption = {
    // zlevel: 0,
    z: 0,
    show: true,
    left: 'center',
    top: 'center',
    // Default value:
    // for geoSVG source: 1,
    // for geoJSON source: 0.75.
    aspectScale: null,
    ///// Layout with center and size
    // If you wan't to put map in a fixed size box with right aspect ratio
    // This two properties may more conveninet
    // layoutCenter: [50%, 50%]
    // layoutSize: 100
    silent: false,
    // Map type
    map: '',
    // Define left-top, right-bottom coords to control view
    // For example, [ [180, 90], [-180, -90] ]
    boundingCoords: null,
    // Default on center of map
    center: null,
    zoom: 1,
    scaleLimit: null,
    // selectedMode: false
    label: {
      show: false,
      color: '#000'
    },
    itemStyle: {
      borderWidth: 0.5,
      borderColor: '#444' // Default color:
      // + geoJSON: #eee
      // + geoSVG: null (use SVG original `fill`)
      // color: '#eee'

    },
    emphasis: {
      label: {
        show: true,
        color: 'rgb(100,0,0)'
      },
      itemStyle: {
        color: 'rgba(255,215,0,0.8)'
      }
    },
    select: {
      label: {
        show: true,
        color: 'rgb(100,0,0)'
      },
      itemStyle: {
        color: 'rgba(255,215,0,0.8)'
      }
    },
    regions: [] // tooltip: {
    //     show: false
    // }

  };
  return GeoModel;
}(__WEBPACK_IMPORTED_MODULE_3__model_Component_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (GeoModel);

/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GeoSVGResource; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_tool_parseSVG_js__ = __webpack_require__(1720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_graphic_Group_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_graphic_shape_Rect_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zrender_lib_tool_parseXML_js__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Region_js__ = __webpack_require__(328);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







/**
 * "region available" means that: enable users to set attribute `name="xxx"` on those tags
 * to make it be a region.
 * 1. region styles and its label styles can be defined in echarts opton:
 * ```js
 * geo: {
 *     regions: [{
 *         name: 'xxx',
 *         itemStyle: { ... },
 *         label: { ... }
 *     }, {
 *         ...
 *     },
 *     ...]
 * };
 * ```
 * 2. name can be duplicated in different SVG tag. All of the tags with the same name share
 * a region option. For exampel if there are two <path> representing two lung lobes. They have
 * no common parents but both of them need to display label "lung" inside.
 */

var REGION_AVAILABLE_SVG_TAG_MAP = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["createHashMap"])(['rect', 'circle', 'line', 'ellipse', 'polygon', 'polyline', 'path', // <text> <tspan> are also enabled becuase some SVG might paint text itself,
// but still need to trigger events or tooltip.
'text', 'tspan', // <g> is also enabled because this case: if multiple tags share one name
// and need label displayed, every tags will display the name, which is not
// expected. So we can put them into a <g name="xxx">. Thereby only one label
// displayed and located based on the bounding rect of the <g>.
'g']);

var GeoSVGResource =
/** @class */
function () {
  function GeoSVGResource(mapName, svg) {
    this.type = 'geoSVG'; // All used graphics. key: hostKey, value: root

    this._usedGraphicMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["createHashMap"])(); // All unused graphics.

    this._freedGraphics = [];
    this._mapName = mapName; // Only perform parse to XML object here, which might be time
    // consiming for large SVG.
    // Although convert XML to zrender element is also time consiming,
    // if we do it here, the clone of zrender elements has to be
    // required. So we do it once for each geo instance, util real
    // performance issues call for optimizing it.

    this._parsedXML = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_zrender_lib_tool_parseXML_js__["a" /* parseXML */])(svg);
  }

  GeoSVGResource.prototype.load = function ()
  /* nameMap: NameMap */
  {
    // In the "load" stage, graphic need to be built to
    // get boundingRect for geo coordinate system.
    var firstGraphic = this._firstGraphic; // Create the return data structure only when first graphic created.
    // Because they will be used in geo coordinate system update stage,
    // and `regions` will be mounted at `geo` coordinate system,
    // in which there is no "view" info, so that it should better not to
    // make references to graphic elements.

    if (!firstGraphic) {
      firstGraphic = this._firstGraphic = this._buildGraphic(this._parsedXML);

      this._freedGraphics.push(firstGraphic);

      this._boundingRect = this._firstGraphic.boundingRect.clone(); // PENDING: `nameMap` will not be supported until some real requirement come.
      // if (nameMap) {
      //     named = applyNameMap(named, nameMap);
      // }

      var _a = createRegions(firstGraphic.named),
          regions = _a.regions,
          regionsMap = _a.regionsMap;

      this._regions = regions;
      this._regionsMap = regionsMap;
    }

    return {
      boundingRect: this._boundingRect,
      regions: this._regions,
      regionsMap: this._regionsMap
    };
  };

  GeoSVGResource.prototype._buildGraphic = function (svgXML) {
    var result;
    var rootFromParse;

    try {
      result = svgXML && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_tool_parseSVG_js__["a" /* parseSVG */])(svgXML, {
        ignoreViewBox: true,
        ignoreRootClip: true
      }) || {};
      rootFromParse = result.root;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["assert"])(rootFromParse != null);
    } catch (e) {
      throw new Error('Invalid svg format\n' + e.message);
    } // Note: we keep the covenant that the root has no transform. So always add an extra root.


    var root = new __WEBPACK_IMPORTED_MODULE_1_zrender_lib_graphic_Group_js__["a" /* default */]();
    root.add(rootFromParse);
    root.isGeoSVGGraphicRoot = true; // [THE_RULE_OF_VIEWPORT_AND_VIEWBOX]
    //
    // Consider: `<svg width="..." height="..." viewBox="...">`
    // - the `width/height` we call it `svgWidth/svgHeight` for short.
    // - `(0, 0, svgWidth, svgHeight)` defines the viewport of the SVG, or say,
    //   "viewport boundingRect", or `boundingRect` for short.
    // - `viewBox` defines the transform from the real content ot the viewport.
    //   `viewBox` has the same unit as the content of SVG.
    //   If `viewBox` exists, a transform is defined, so the unit of `svgWidth/svgHeight` become
    //   different from the content of SVG. Otherwise, they are the same.
    //
    // If both `svgWidth/svgHeight/viewBox` are specified in a SVG file, the transform rule will be:
    // 0. `boundingRect` is `(0, 0, svgWidth, svgHeight)`. Set it to Geo['_rect'] (View['_rect']).
    // 1. Make a transform from `viewBox` to `boundingRect`.
    //    Note: only suport `preserveAspectRatio 'xMidYMid'` here. That is, this transform will preserve
    //    the aspect ratio.
    // 2. Make a transform from boundingRect to Geo['_viewRect'] (View['_viewRect'])
    //    (`Geo`/`View` will do this job).
    //    Note: this transform might not preserve aspect radio, which depending on how users specify
    //    viewRect in echarts option (e.g., `geo.left/top/width/height` will not preserve aspect ratio,
    //    but `geo.layoutCenter/layoutSize` will preserve aspect ratio).
    //
    // If `svgWidth/svgHeight` not specified, we use `viewBox` as the `boundingRect` to make the SVG
    // layout look good.
    //
    // If neither `svgWidth/svgHeight` nor `viewBox` are not specified, we calculate the boundingRect
    // of the SVG content and use them to make SVG layout look good.

    var svgWidth = result.width;
    var svgHeight = result.height;
    var viewBoxRect = result.viewBoxRect;
    var boundingRect = this._boundingRect;

    if (!boundingRect) {
      var bRectX = void 0;
      var bRectY = void 0;
      var bRectWidth = void 0;
      var bRectHeight = void 0;

      if (svgWidth != null) {
        bRectX = 0;
        bRectWidth = svgWidth;
      } else if (viewBoxRect) {
        bRectX = viewBoxRect.x;
        bRectWidth = viewBoxRect.width;
      }

      if (svgHeight != null) {
        bRectY = 0;
        bRectHeight = svgHeight;
      } else if (viewBoxRect) {
        bRectY = viewBoxRect.y;
        bRectHeight = viewBoxRect.height;
      } // If both viewBox and svgWidth/svgHeight not specified,
      // we have to determine how to layout those element to make them look good.


      if (bRectX == null || bRectY == null) {
        var calculatedBoundingRect = rootFromParse.getBoundingRect();

        if (bRectX == null) {
          bRectX = calculatedBoundingRect.x;
          bRectWidth = calculatedBoundingRect.width;
        }

        if (bRectY == null) {
          bRectY = calculatedBoundingRect.y;
          bRectHeight = calculatedBoundingRect.height;
        }
      }

      boundingRect = this._boundingRect = new __WEBPACK_IMPORTED_MODULE_4_zrender_lib_core_BoundingRect_js__["a" /* default */](bRectX, bRectY, bRectWidth, bRectHeight);
    }

    if (viewBoxRect) {
      var viewBoxTransform = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_tool_parseSVG_js__["b" /* makeViewBoxTransform */])(viewBoxRect, boundingRect); // Only support `preserveAspectRatio 'xMidYMid'`

      rootFromParse.scaleX = rootFromParse.scaleY = viewBoxTransform.scale;
      rootFromParse.x = viewBoxTransform.x;
      rootFromParse.y = viewBoxTransform.y;
    } // SVG needs to clip based on `viewBox`. And some SVG files really rely on this feature.
    // They do not strictly confine all of the content inside a display rect, but deliberately
    // use a `viewBox` to define a displayable rect.
    // PENDING:
    // The drawback of the `setClipPath` here is: the region label (genereted by echarts) near the
    // edge might also be clipped, because region labels are put as `textContent` of the SVG path.


    root.setClipPath(new __WEBPACK_IMPORTED_MODULE_2_zrender_lib_graphic_shape_Rect_js__["a" /* default */]({
      shape: boundingRect.plain()
    }));
    var named = [];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(result.named, function (namedItem) {
      if (REGION_AVAILABLE_SVG_TAG_MAP.get(namedItem.svgNodeTagLower) != null) {
        named.push(namedItem);
        setSilent(namedItem.el);
      }
    });
    return {
      root: root,
      boundingRect: boundingRect,
      named: named
    };
  };
  /**
   * Consider:
   * (1) One graphic element can not be shared by different `geoView` running simultaneously.
   *     Notice, also need to consider multiple echarts instances share a `mapRecord`.
   * (2) Converting SVG to graphic elements is time consuming.
   * (3) In the current architecture, `load` should be called frequently to get boundingRect,
   *     and it is called without view info.
   * So we maintain graphic elements in this module, and enables `view` to use/return these
   * graphics from/to the pool with it's uid.
   */


  GeoSVGResource.prototype.useGraphic = function (hostKey
  /*, nameMap: NameMap */
  ) {
    var usedRootMap = this._usedGraphicMap;
    var svgGraphic = usedRootMap.get(hostKey);

    if (svgGraphic) {
      return svgGraphic;
    }

    svgGraphic = this._freedGraphics.pop() // use the first boundingRect to avoid duplicated boundingRect calculation.
    || this._buildGraphic(this._parsedXML);
    usedRootMap.set(hostKey, svgGraphic); // PENDING: `nameMap` will not be supported until some real requirement come.
    // `nameMap` can only be obtained from echarts option.
    // The original `named` must not be modified.
    // if (nameMap) {
    //     svgGraphic = extend({}, svgGraphic);
    //     svgGraphic.named = applyNameMap(svgGraphic.named, nameMap);
    // }

    return svgGraphic;
  };

  GeoSVGResource.prototype.freeGraphic = function (hostKey) {
    var usedRootMap = this._usedGraphicMap;
    var svgGraphic = usedRootMap.get(hostKey);

    if (svgGraphic) {
      usedRootMap.removeKey(hostKey);

      this._freedGraphics.push(svgGraphic);
    }
  };

  return GeoSVGResource;
}();



function setSilent(el) {
  // Only named element has silent: false, other elements should
  // act as background and has no user interaction.
  el.silent = false; // text|tspan will be converted to group.

  if (el.isGroup) {
    el.traverse(function (child) {
      child.silent = false;
    });
  }
}

function createRegions(named) {
  var regions = [];
  var regionsMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["createHashMap"])(); // Create resions only for the first graphic.

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(named, function (namedItem) {
    // Region has feature to calculate center for tooltip or other features.
    // If there is a <g name="xxx">, the center should be the center of the
    // bounding rect of the g.
    if (namedItem.namedFrom != null) {
      return;
    }

    var region = new __WEBPACK_IMPORTED_MODULE_6__Region_js__["d" /* GeoSVGRegion */](namedItem.name, namedItem.el); // PENDING: if `nameMap` supported, this region can not be mounted on
    // `this`, but can only be created each time `load()` called.

    regions.push(region); // PENDING: if multiple tag named with the same name, only one will be
    // found by `_regionsMap`. `_regionsMap` is used to find a coordinate
    // by name. We use `region.getCenter()` as the coordinate.

    regionsMap.set(namedItem.name, region);
  });
  return {
    regions: regions,
    regionsMap: regionsMap
  };
} // PENDING: `nameMap` will not be supported until some real requirement come.
// /**
//  * Use the alias in geoNameMap.
//  * The input `named` must not be modified.
//  */
// function applyNameMap(
//     named: GeoSVGGraphicRecord['named'],
//     nameMap: NameMap
// ): GeoSVGGraphicRecord['named'] {
//     const result = [] as GeoSVGGraphicRecord['named'];
//     for (let i = 0; i < named.length; i++) {
//         let regionGraphic = named[i];
//         const name = regionGraphic.name;
//         if (nameMap && nameMap.hasOwnProperty(name)) {
//             regionGraphic = extend({}, regionGraphic);
//             regionGraphic.name = name;
//         }
//         result.push(regionGraphic);
//     }
//     return result;
// }

/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fixDiaoyuIsland;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Fix for 钓鱼岛
// let Region = require('../Region');
// let zrUtil = require('zrender/lib/core/util');
// let geoCoord = [126, 25];
var points = [[[123.45165252685547, 25.73527164402261], [123.49731445312499, 25.73527164402261], [123.49731445312499, 25.750734064600884], [123.45165252685547, 25.750734064600884], [123.45165252685547, 25.73527164402261]]];
function fixDiaoyuIsland(mapType, region) {
  if (mapType === 'china' && region.name === '台湾') {
    region.geometries.push({
      type: 'polygon',
      exterior: points[0]
    });
  }
}

/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fixNanhai;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Region_js__ = __webpack_require__(328);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Fix for 南海诸岛


var geoCoord = [126, 25];
var nanhaiName = '南海诸岛';
var points = [[[0, 3.5], [7, 11.2], [15, 11.9], [30, 7], [42, 0.7], [52, 0.7], [56, 7.7], [59, 0.7], [64, 0.7], [64, 0], [5, 0], [0, 3.5]], [[13, 16.1], [19, 14.7], [16, 21.7], [11, 23.1], [13, 16.1]], [[12, 32.2], [14, 38.5], [15, 38.5], [13, 32.2], [12, 32.2]], [[16, 47.6], [12, 53.2], [13, 53.2], [18, 47.6], [16, 47.6]], [[6, 64.4], [8, 70], [9, 70], [8, 64.4], [6, 64.4]], [[23, 82.6], [29, 79.8], [30, 79.8], [25, 82.6], [23, 82.6]], [[37, 70.7], [43, 62.3], [44, 62.3], [39, 70.7], [37, 70.7]], [[48, 51.1], [51, 45.5], [53, 45.5], [50, 51.1], [48, 51.1]], [[51, 35], [51, 28.7], [53, 28.7], [53, 35], [51, 35]], [[52, 22.4], [55, 17.5], [56, 17.5], [53, 22.4], [52, 22.4]], [[58, 12.6], [62, 7], [63, 7], [60, 12.6], [58, 12.6]], [[0, 3.5], [0, 93.1], [64, 93.1], [64, 0], [63, 0], [63, 92.4], [1, 92.4], [1, 3.5], [0, 3.5]]];

for (var i = 0; i < points.length; i++) {
  for (var k = 0; k < points[i].length; k++) {
    points[i][k][0] /= 10.5;
    points[i][k][1] /= -10.5 / 0.75;
    points[i][k][0] += geoCoord[0];
    points[i][k][1] += geoCoord[1];
  }
}

function fixNanhai(mapType, regions) {
  if (mapType === 'china') {
    for (var i = 0; i < regions.length; i++) {
      // Already exists.
      if (regions[i].name === nanhaiName) {
        return;
      }
    }

    regions.push(new __WEBPACK_IMPORTED_MODULE_1__Region_js__["a" /* GeoJSONRegion */](nanhaiName, __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"](points, function (exterior) {
      return {
        type: 'polygon',
        exterior: exterior
      };
    }), geoCoord));
  }
}

/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fixTextCoords;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var coordsOffsetMap = {
  '南海诸岛': [32, 80],
  // 全国
  '广东': [0, -10],
  '香港': [10, 5],
  '澳门': [-10, 10],
  //'北京': [-10, 0],
  '天津': [5, 5]
};
function fixTextCoords(mapType, region) {
  if (mapType === 'china') {
    var coordFix = coordsOffsetMap[region.name];

    if (coordFix) {
      var cp = region.getCenter();
      cp[0] += coordFix[0] / 10.5;
      cp[1] += -coordFix[1] / (10.5 / 0.75);
      region.setCenter(cp);
    }
  }
}

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = geoPrepareCustom;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


function dataToCoordSize(dataSize, dataItem) {
  dataItem = dataItem || [0, 0];
  return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"]([0, 1], function (dimIdx) {
    var val = dataItem[dimIdx];
    var halfSize = dataSize[dimIdx] / 2;
    var p1 = [];
    var p2 = [];
    p1[dimIdx] = val - halfSize;
    p2[dimIdx] = val + halfSize;
    p1[1 - dimIdx] = p2[1 - dimIdx] = dataItem[1 - dimIdx];
    return Math.abs(this.dataToPoint(p1)[dimIdx] - this.dataToPoint(p2)[dimIdx]);
  }, this);
}

function geoPrepareCustom(coordSys) {
  var rect = coordSys.getBoundingRect();
  return {
    coordSys: {
      type: 'geo',
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height,
      zoom: coordSys.getZoom()
    },
    api: {
      coord: function (data) {
        // do not provide "out" and noRoam param,
        // Compatible with this usage:
        // echarts.util.map(item.points, api.coord)
        return coordSys.dataToPoint(data);
      },
      size: __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["bind"](dataToCoordSize, coordSys)
    }
  };
}

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_Component_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_mixin_makeStyleMapper_js__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__axisModelCommonMixin_js__ = __webpack_require__(155);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/







var ParallelAxisModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ParallelAxisModel, _super);

  function ParallelAxisModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ParallelAxisModel.type;
    /**
     * @readOnly
     */

    _this.activeIntervals = [];
    return _this;
  }

  ParallelAxisModel.prototype.getAreaSelectStyle = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__model_mixin_makeStyleMapper_js__["a" /* default */])([['fill', 'color'], ['lineWidth', 'borderWidth'], ['stroke', 'borderColor'], ['width', 'width'], ['opacity', 'opacity'] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
    // So do not transfer decal directly.
    ])(this.getModel('areaSelectStyle'));
  };
  /**
   * The code of this feature is put on AxisModel but not ParallelAxis,
   * because axisModel can be alive after echarts updating but instance of
   * ParallelAxis having been disposed. this._activeInterval should be kept
   * when action dispatched (i.e. legend click).
   *
   * @param intervals `interval.length === 0` means set all active.
   */


  ParallelAxisModel.prototype.setActiveIntervals = function (intervals) {
    var activeIntervals = this.activeIntervals = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"](intervals); // Normalize

    if (activeIntervals) {
      for (var i = activeIntervals.length - 1; i >= 0; i--) {
        __WEBPACK_IMPORTED_MODULE_4__util_number_js__["j" /* asc */](activeIntervals[i]);
      }
    }
  };
  /**
   * @param value When only attempting detect whether 'no activeIntervals set',
   *        `value` is not needed to be input.
   */


  ParallelAxisModel.prototype.getActiveState = function (value) {
    var activeIntervals = this.activeIntervals;

    if (!activeIntervals.length) {
      return 'normal';
    }

    if (value == null || isNaN(+value)) {
      return 'inactive';
    } // Simple optimization


    if (activeIntervals.length === 1) {
      var interval = activeIntervals[0];

      if (interval[0] <= value && value <= interval[1]) {
        return 'active';
      }
    } else {
      for (var i = 0, len = activeIntervals.length; i < len; i++) {
        if (activeIntervals[i][0] <= value && value <= activeIntervals[i][1]) {
          return 'active';
        }
      }
    }

    return 'inactive';
  };

  return ParallelAxisModel;
}(__WEBPACK_IMPORTED_MODULE_2__model_Component_js__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["mixin"](ParallelAxisModel, __WEBPACK_IMPORTED_MODULE_5__axisModelCommonMixin_js__["a" /* AxisModelCommonMixin */]);
/* harmony default export */ __webpack_exports__["a"] = (ParallelAxisModel);

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_matrix_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__coord_axisHelper_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ParallelAxis_js__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_helper_sliderMove_js__ = __webpack_require__(154);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Parallel Coordinates
 * <https://en.wikipedia.org/wiki/Parallel_coordinates>
 */








var each = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"];
var mathMin = Math.min;
var mathMax = Math.max;
var mathFloor = Math.floor;
var mathCeil = Math.ceil;
var round = __WEBPACK_IMPORTED_MODULE_6__util_number_js__["d" /* round */];
var PI = Math.PI;

var Parallel =
/** @class */
function () {
  function Parallel(parallelModel, ecModel, api) {
    this.type = 'parallel';
    /**
     * key: dimension
     */

    this._axesMap = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"]();
    /**
     * key: dimension
     * value: {position: [], rotation, }
     */

    this._axesLayout = {};
    this.dimensions = parallelModel.dimensions;
    this._model = parallelModel;

    this._init(parallelModel, ecModel, api);
  }

  Parallel.prototype._init = function (parallelModel, ecModel, api) {
    var dimensions = parallelModel.dimensions;
    var parallelAxisIndex = parallelModel.parallelAxisIndex;
    each(dimensions, function (dim, idx) {
      var axisIndex = parallelAxisIndex[idx];
      var axisModel = ecModel.getComponent('parallelAxis', axisIndex);

      var axis = this._axesMap.set(dim, new __WEBPACK_IMPORTED_MODULE_4__ParallelAxis_js__["a" /* default */](dim, __WEBPACK_IMPORTED_MODULE_3__coord_axisHelper_js__["f" /* createScaleByModel */](axisModel), [0, 0], axisModel.get('type'), axisIndex));

      var isCategory = axis.type === 'category';
      axis.onBand = isCategory && axisModel.get('boundaryGap');
      axis.inverse = axisModel.get('inverse'); // Injection

      axisModel.axis = axis;
      axis.model = axisModel;
      axis.coordinateSystem = axisModel.coordinateSystem = this;
    }, this);
  };
  /**
   * Update axis scale after data processed
   */


  Parallel.prototype.update = function (ecModel, api) {
    this._updateAxesFromSeries(this._model, ecModel);
  };

  Parallel.prototype.containPoint = function (point) {
    var layoutInfo = this._makeLayoutInfo();

    var axisBase = layoutInfo.axisBase;
    var layoutBase = layoutInfo.layoutBase;
    var pixelDimIndex = layoutInfo.pixelDimIndex;
    var pAxis = point[1 - pixelDimIndex];
    var pLayout = point[pixelDimIndex];
    return pAxis >= axisBase && pAxis <= axisBase + layoutInfo.axisLength && pLayout >= layoutBase && pLayout <= layoutBase + layoutInfo.layoutLength;
  };

  Parallel.prototype.getModel = function () {
    return this._model;
  };
  /**
   * Update properties from series
   */


  Parallel.prototype._updateAxesFromSeries = function (parallelModel, ecModel) {
    ecModel.eachSeries(function (seriesModel) {
      if (!parallelModel.contains(seriesModel, ecModel)) {
        return;
      }

      var data = seriesModel.getData();
      each(this.dimensions, function (dim) {
        var axis = this._axesMap.get(dim);

        axis.scale.unionExtentFromData(data, data.mapDimension(dim));
        __WEBPACK_IMPORTED_MODULE_3__coord_axisHelper_js__["g" /* niceScaleExtent */](axis.scale, axis.model);
      }, this);
    }, this);
  };
  /**
   * Resize the parallel coordinate system.
   */


  Parallel.prototype.resize = function (parallelModel, api) {
    this._rect = __WEBPACK_IMPORTED_MODULE_2__util_layout_js__["f" /* getLayoutRect */](parallelModel.getBoxLayoutParams(), {
      width: api.getWidth(),
      height: api.getHeight()
    });

    this._layoutAxes();
  };

  Parallel.prototype.getRect = function () {
    return this._rect;
  };

  Parallel.prototype._makeLayoutInfo = function () {
    var parallelModel = this._model;
    var rect = this._rect;
    var xy = ['x', 'y'];
    var wh = ['width', 'height'];
    var layout = parallelModel.get('layout');
    var pixelDimIndex = layout === 'horizontal' ? 0 : 1;
    var layoutLength = rect[wh[pixelDimIndex]];
    var layoutExtent = [0, layoutLength];
    var axisCount = this.dimensions.length;
    var axisExpandWidth = restrict(parallelModel.get('axisExpandWidth'), layoutExtent);
    var axisExpandCount = restrict(parallelModel.get('axisExpandCount') || 0, [0, axisCount]);
    var axisExpandable = parallelModel.get('axisExpandable') && axisCount > 3 && axisCount > axisExpandCount && axisExpandCount > 1 && axisExpandWidth > 0 && layoutLength > 0; // `axisExpandWindow` is According to the coordinates of [0, axisExpandLength],
    // for sake of consider the case that axisCollapseWidth is 0 (when screen is narrow),
    // where collapsed axes should be overlapped.

    var axisExpandWindow = parallelModel.get('axisExpandWindow');
    var winSize;

    if (!axisExpandWindow) {
      winSize = restrict(axisExpandWidth * (axisExpandCount - 1), layoutExtent);
      var axisExpandCenter = parallelModel.get('axisExpandCenter') || mathFloor(axisCount / 2);
      axisExpandWindow = [axisExpandWidth * axisExpandCenter - winSize / 2];
      axisExpandWindow[1] = axisExpandWindow[0] + winSize;
    } else {
      winSize = restrict(axisExpandWindow[1] - axisExpandWindow[0], layoutExtent);
      axisExpandWindow[1] = axisExpandWindow[0] + winSize;
    }

    var axisCollapseWidth = (layoutLength - winSize) / (axisCount - axisExpandCount); // Avoid axisCollapseWidth is too small.

    axisCollapseWidth < 3 && (axisCollapseWidth = 0); // Find the first and last indices > ewin[0] and < ewin[1].

    var winInnerIndices = [mathFloor(round(axisExpandWindow[0] / axisExpandWidth, 1)) + 1, mathCeil(round(axisExpandWindow[1] / axisExpandWidth, 1)) - 1]; // Pos in ec coordinates.

    var axisExpandWindow0Pos = axisCollapseWidth / axisExpandWidth * axisExpandWindow[0];
    return {
      layout: layout,
      pixelDimIndex: pixelDimIndex,
      layoutBase: rect[xy[pixelDimIndex]],
      layoutLength: layoutLength,
      axisBase: rect[xy[1 - pixelDimIndex]],
      axisLength: rect[wh[1 - pixelDimIndex]],
      axisExpandable: axisExpandable,
      axisExpandWidth: axisExpandWidth,
      axisCollapseWidth: axisCollapseWidth,
      axisExpandWindow: axisExpandWindow,
      axisCount: axisCount,
      winInnerIndices: winInnerIndices,
      axisExpandWindow0Pos: axisExpandWindow0Pos
    };
  };

  Parallel.prototype._layoutAxes = function () {
    var rect = this._rect;
    var axes = this._axesMap;
    var dimensions = this.dimensions;

    var layoutInfo = this._makeLayoutInfo();

    var layout = layoutInfo.layout;
    axes.each(function (axis) {
      var axisExtent = [0, layoutInfo.axisLength];
      var idx = axis.inverse ? 1 : 0;
      axis.setExtent(axisExtent[idx], axisExtent[1 - idx]);
    });
    each(dimensions, function (dim, idx) {
      var posInfo = (layoutInfo.axisExpandable ? layoutAxisWithExpand : layoutAxisWithoutExpand)(idx, layoutInfo);
      var positionTable = {
        horizontal: {
          x: posInfo.position,
          y: layoutInfo.axisLength
        },
        vertical: {
          x: 0,
          y: posInfo.position
        }
      };
      var rotationTable = {
        horizontal: PI / 2,
        vertical: 0
      };
      var position = [positionTable[layout].x + rect.x, positionTable[layout].y + rect.y];
      var rotation = rotationTable[layout];
      var transform = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_matrix_js__["create"]();
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_matrix_js__["rotate"](transform, transform, rotation);
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_matrix_js__["translate"](transform, transform, position); // TODO
      // tick layout info
      // TODO
      // update dimensions info based on axis order.

      this._axesLayout[dim] = {
        position: position,
        rotation: rotation,
        transform: transform,
        axisNameAvailableWidth: posInfo.axisNameAvailableWidth,
        axisLabelShow: posInfo.axisLabelShow,
        nameTruncateMaxWidth: posInfo.nameTruncateMaxWidth,
        tickDirection: 1,
        labelDirection: 1
      };
    }, this);
  };
  /**
   * Get axis by dim.
   */


  Parallel.prototype.getAxis = function (dim) {
    return this._axesMap.get(dim);
  };
  /**
   * Convert a dim value of a single item of series data to Point.
   */


  Parallel.prototype.dataToPoint = function (value, dim) {
    return this.axisCoordToPoint(this._axesMap.get(dim).dataToCoord(value), dim);
  };
  /**
   * Travel data for one time, get activeState of each data item.
   * @param start the start dataIndex that travel from.
   * @param end the next dataIndex of the last dataIndex will be travel.
   */


  Parallel.prototype.eachActiveState = function (data, callback, start, end) {
    start == null && (start = 0);
    end == null && (end = data.count());
    var axesMap = this._axesMap;
    var dimensions = this.dimensions;
    var dataDimensions = [];
    var axisModels = [];
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](dimensions, function (axisDim) {
      dataDimensions.push(data.mapDimension(axisDim));
      axisModels.push(axesMap.get(axisDim).model);
    });
    var hasActiveSet = this.hasAxisBrushed();

    for (var dataIndex = start; dataIndex < end; dataIndex++) {
      var activeState = void 0;

      if (!hasActiveSet) {
        activeState = 'normal';
      } else {
        activeState = 'active';
        var values = data.getValues(dataDimensions, dataIndex);

        for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
          var state = axisModels[j].getActiveState(values[j]);

          if (state === 'inactive') {
            activeState = 'inactive';
            break;
          }
        }
      }

      callback(activeState, dataIndex);
    }
  };
  /**
   * Whether has any activeSet.
   */


  Parallel.prototype.hasAxisBrushed = function () {
    var dimensions = this.dimensions;
    var axesMap = this._axesMap;
    var hasActiveSet = false;

    for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
      if (axesMap.get(dimensions[j]).model.getActiveState() !== 'normal') {
        hasActiveSet = true;
      }
    }

    return hasActiveSet;
  };
  /**
   * Convert coords of each axis to Point.
   *  Return point. For example: [10, 20]
   */


  Parallel.prototype.axisCoordToPoint = function (coord, dim) {
    var axisLayout = this._axesLayout[dim];
    return __WEBPACK_IMPORTED_MODULE_5__util_graphic_js__["applyTransform"]([coord, 0], axisLayout.transform);
  };
  /**
   * Get axis layout.
   */


  Parallel.prototype.getAxisLayout = function (dim) {
    return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["clone"](this._axesLayout[dim]);
  };
  /**
   * @return {Object} {axisExpandWindow, delta, behavior: 'jump' | 'slide' | 'none'}.
   */


  Parallel.prototype.getSlidedAxisExpandWindow = function (point) {
    var layoutInfo = this._makeLayoutInfo();

    var pixelDimIndex = layoutInfo.pixelDimIndex;
    var axisExpandWindow = layoutInfo.axisExpandWindow.slice();
    var winSize = axisExpandWindow[1] - axisExpandWindow[0];
    var extent = [0, layoutInfo.axisExpandWidth * (layoutInfo.axisCount - 1)]; // Out of the area of coordinate system.

    if (!this.containPoint(point)) {
      return {
        behavior: 'none',
        axisExpandWindow: axisExpandWindow
      };
    } // Conver the point from global to expand coordinates.


    var pointCoord = point[pixelDimIndex] - layoutInfo.layoutBase - layoutInfo.axisExpandWindow0Pos; // For dragging operation convenience, the window should not be
    // slided when mouse is the center area of the window.

    var delta;
    var behavior = 'slide';
    var axisCollapseWidth = layoutInfo.axisCollapseWidth;

    var triggerArea = this._model.get('axisExpandSlideTriggerArea'); // But consider touch device, jump is necessary.


    var useJump = triggerArea[0] != null;

    if (axisCollapseWidth) {
      if (useJump && axisCollapseWidth && pointCoord < winSize * triggerArea[0]) {
        behavior = 'jump';
        delta = pointCoord - winSize * triggerArea[2];
      } else if (useJump && axisCollapseWidth && pointCoord > winSize * (1 - triggerArea[0])) {
        behavior = 'jump';
        delta = pointCoord - winSize * (1 - triggerArea[2]);
      } else {
        (delta = pointCoord - winSize * triggerArea[1]) >= 0 && (delta = pointCoord - winSize * (1 - triggerArea[1])) <= 0 && (delta = 0);
      }

      delta *= layoutInfo.axisExpandWidth / axisCollapseWidth;
      delta ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__component_helper_sliderMove_js__["a" /* default */])(delta, axisExpandWindow, extent, 'all') // Avoid nonsense triger on mousemove.
      : behavior = 'none';
    } // When screen is too narrow, make it visible and slidable, although it is hard to interact.
    else {
        var winSize2 = axisExpandWindow[1] - axisExpandWindow[0];
        var pos = extent[1] * pointCoord / winSize2;
        axisExpandWindow = [mathMax(0, pos - winSize2 / 2)];
        axisExpandWindow[1] = mathMin(extent[1], axisExpandWindow[0] + winSize2);
        axisExpandWindow[0] = axisExpandWindow[1] - winSize2;
      }

    return {
      axisExpandWindow: axisExpandWindow,
      behavior: behavior
    };
  };

  return Parallel;
}();

function restrict(len, extent) {
  return mathMin(mathMax(len, extent[0]), extent[1]);
}

function layoutAxisWithoutExpand(axisIndex, layoutInfo) {
  var step = layoutInfo.layoutLength / (layoutInfo.axisCount - 1);
  return {
    position: step * axisIndex,
    axisNameAvailableWidth: step,
    axisLabelShow: true
  };
}

function layoutAxisWithExpand(axisIndex, layoutInfo) {
  var layoutLength = layoutInfo.layoutLength;
  var axisExpandWidth = layoutInfo.axisExpandWidth;
  var axisCount = layoutInfo.axisCount;
  var axisCollapseWidth = layoutInfo.axisCollapseWidth;
  var winInnerIndices = layoutInfo.winInnerIndices;
  var position;
  var axisNameAvailableWidth = axisCollapseWidth;
  var axisLabelShow = false;
  var nameTruncateMaxWidth;

  if (axisIndex < winInnerIndices[0]) {
    position = axisIndex * axisCollapseWidth;
    nameTruncateMaxWidth = axisCollapseWidth;
  } else if (axisIndex <= winInnerIndices[1]) {
    position = layoutInfo.axisExpandWindow0Pos + axisIndex * axisExpandWidth - layoutInfo.axisExpandWindow[0];
    axisNameAvailableWidth = axisExpandWidth;
    axisLabelShow = true;
  } else {
    position = layoutLength - (axisCount - 1 - axisIndex) * axisCollapseWidth;
    nameTruncateMaxWidth = axisCollapseWidth;
  }

  return {
    position: position,
    axisNameAvailableWidth: axisNameAvailableWidth,
    axisLabelShow: axisLabelShow,
    nameTruncateMaxWidth: nameTruncateMaxWidth
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Parallel);

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Axis_js__ = __webpack_require__(112);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var ParallelAxis =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ParallelAxis, _super);

  function ParallelAxis(dim, scale, coordExtent, axisType, axisIndex) {
    var _this = _super.call(this, dim, scale, coordExtent) || this;

    _this.type = axisType || 'value';
    _this.axisIndex = axisIndex;
    return _this;
  }

  ParallelAxis.prototype.isHorizontal = function () {
    return this.coordinateSystem.getModel().get('layout') !== 'horizontal';
  };

  return ParallelAxis;
}(__WEBPACK_IMPORTED_MODULE_1__Axis_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ParallelAxis);

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_Component_js__ = __webpack_require__(21);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var ParallelModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(ParallelModel, _super);

  function ParallelModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ParallelModel.type;
    return _this;
  }

  ParallelModel.prototype.init = function () {
    _super.prototype.init.apply(this, arguments);

    this.mergeOption({});
  };

  ParallelModel.prototype.mergeOption = function (newOption) {
    var thisOption = this.option;
    newOption && __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"](thisOption, newOption, true);

    this._initDimensions();
  };
  /**
   * Whether series or axis is in this coordinate system.
   */


  ParallelModel.prototype.contains = function (model, ecModel) {
    var parallelIndex = model.get('parallelIndex');
    return parallelIndex != null && ecModel.getComponent('parallel', parallelIndex) === this;
  };

  ParallelModel.prototype.setAxisExpand = function (opt) {
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](['axisExpandable', 'axisExpandCenter', 'axisExpandCount', 'axisExpandWidth', 'axisExpandWindow'], function (name) {
      if (opt.hasOwnProperty(name)) {
        // @ts-ignore FIXME: why "never" inferred in this.option[name]?
        this.option[name] = opt[name];
      }
    }, this);
  };

  ParallelModel.prototype._initDimensions = function () {
    var dimensions = this.dimensions = [];
    var parallelAxisIndex = this.parallelAxisIndex = [];
    var axisModels = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["filter"](this.ecModel.queryComponents({
      mainType: 'parallelAxis'
    }), function (axisModel) {
      // Can not use this.contains here, because
      // initialization has not been completed yet.
      return (axisModel.get('parallelIndex') || 0) === this.componentIndex;
    }, this);
    __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"](axisModels, function (axisModel) {
      dimensions.push('dim' + axisModel.get('dim'));
      parallelAxisIndex.push(axisModel.componentIndex);
    });
  };

  ParallelModel.type = 'parallel';
  ParallelModel.dependencies = ['parallelAxis'];
  ParallelModel.layoutMode = 'box';
  ParallelModel.defaultOption = {
    // zlevel: 0,
    z: 0,
    left: 80,
    top: 60,
    right: 80,
    bottom: 60,
    // width: {totalWidth} - left - right,
    // height: {totalHeight} - top - bottom,
    layout: 'horizontal',
    // FIXME
    // naming?
    axisExpandable: false,
    axisExpandCenter: null,
    axisExpandCount: 0,
    axisExpandWidth: 50,
    axisExpandRate: 17,
    axisExpandDebounce: 50,
    // [out, in, jumpTarget]. In percentage. If use [null, 0.05], null means full.
    // Do not doc to user until necessary.
    axisExpandSlideTriggerArea: [-0.15, 0.05, 0.4],
    axisExpandTriggerOn: 'click',
    parallelAxisDefault: null
  };
  return ParallelModel;
}(__WEBPACK_IMPORTED_MODULE_2__model_Component_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ParallelModel);

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Parallel_js__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Parallel coordinate system creater.
 */



function createParallelCoordSys(ecModel, api) {
  var coordSysList = [];
  ecModel.eachComponent('parallel', function (parallelModel, idx) {
    var coordSys = new __WEBPACK_IMPORTED_MODULE_0__Parallel_js__["a" /* default */](parallelModel, ecModel, api);
    coordSys.name = 'parallel_' + idx;
    coordSys.resize(parallelModel, api);
    parallelModel.coordinateSystem = coordSys;
    coordSys.model = parallelModel;
    coordSysList.push(coordSys);
  }); // Inject the coordinateSystems into seriesModel

  ecModel.eachSeries(function (seriesModel) {
    if (seriesModel.get('coordinateSystem') === 'parallel') {
      var parallelModel = seriesModel.getReferringComponents('parallel', __WEBPACK_IMPORTED_MODULE_1__util_model_js__["i" /* SINGLE_REFERRING */]).models[0];
      seriesModel.coordinateSystem = parallelModel.coordinateSystem;
    }
  });
  return coordSysList;
}

var parallelCoordSysCreator = {
  create: createParallelCoordSys
};
/* harmony default export */ __webpack_exports__["a"] = (parallelCoordSysCreator);

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parallelPreprocessor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


function parallelPreprocessor(option) {
  createParallelIfNeeded(option);
  mergeAxisOptionFromParallel(option);
}
/**
 * Create a parallel coordinate if not exists.
 * @inner
 */

function createParallelIfNeeded(option) {
  if (option.parallel) {
    return;
  }

  var hasParallelSeries = false;
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](option.series, function (seriesOpt) {
    if (seriesOpt && seriesOpt.type === 'parallel') {
      hasParallelSeries = true;
    }
  });

  if (hasParallelSeries) {
    option.parallel = [{}];
  }
}
/**
 * Merge aixs definition from parallel option (if exists) to axis option.
 * @inner
 */


function mergeAxisOptionFromParallel(option) {
  var axes = __WEBPACK_IMPORTED_MODULE_1__util_model_js__["d" /* normalizeToArray */](option.parallelAxis);
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](axes, function (axisOption) {
    if (!__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"](axisOption)) {
      return;
    }

    var parallelIndex = axisOption.parallelIndex || 0;
    var parallelOption = __WEBPACK_IMPORTED_MODULE_1__util_model_js__["d" /* normalizeToArray */](option.parallel)[parallelIndex];

    if (parallelOption && parallelOption.parallelAxisDefault) {
      __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["merge"](axisOption, parallelOption.parallelAxisDefault, false);
    }
  });
}

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_contain_text_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Axis_js__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




var inner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_model_js__["a" /* makeInner */])();

var AngleAxis =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(AngleAxis, _super);

  function AngleAxis(scale, angleExtent) {
    return _super.call(this, 'angle', scale, angleExtent || [0, 360]) || this;
  }

  AngleAxis.prototype.pointToData = function (point, clamp) {
    return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
  };
  /**
   * Only be called in category axis.
   * Angle axis uses text height to decide interval
   *
   * @override
   * @return {number} Auto interval for cateogry axis tick and label
   */


  AngleAxis.prototype.calculateCategoryInterval = function () {
    var axis = this;
    var labelModel = axis.getLabelModel();
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
    // avoid generating a long array by `getTicks`
    // in large category data case.

    var tickCount = ordinalScale.count();

    if (ordinalExtent[1] - ordinalExtent[0] < 1) {
      return 0;
    }

    var tickValue = ordinalExtent[0];
    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
    var unitH = Math.abs(unitSpan); // Not precise, just use height as text width
    // and each distance from axis line yet.

    var rect = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_contain_text_js__["g" /* getBoundingRect */](tickValue == null ? '' : tickValue + '', labelModel.getFont(), 'center', 'top');
    var maxH = Math.max(rect.height, 7);
    var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.

    isNaN(dh) && (dh = Infinity);
    var interval = Math.max(0, Math.floor(dh));
    var cache = inner(axis.model);
    var lastAutoInterval = cache.lastAutoInterval;
    var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
    // otherwise the calculated interval might jitter when the zoom
    // window size is close to the interval-changing size.

    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
    // point is not the same when zooming in or zooming out.
    && lastAutoInterval > interval) {
      interval = lastAutoInterval;
    } // Only update cache if cache not used, otherwise the
    // changing of interval is too insensitive.
    else {
        cache.lastTickCount = tickCount;
        cache.lastAutoInterval = interval;
      }

    return interval;
  };

  return AngleAxis;
}(__WEBPACK_IMPORTED_MODULE_2__Axis_js__["a" /* default */]);

AngleAxis.prototype.dataToAngle = __WEBPACK_IMPORTED_MODULE_2__Axis_js__["a" /* default */].prototype.dataToCoord;
AngleAxis.prototype.angleToData = __WEBPACK_IMPORTED_MODULE_2__Axis_js__["a" /* default */].prototype.coordToData;
/* harmony default export */ __webpack_exports__["a"] = (AngleAxis);

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PolarAxisModel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AngleAxisModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RadiusAxisModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_Component_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axisModelCommonMixin_js__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






var PolarAxisModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(PolarAxisModel, _super);

  function PolarAxisModel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PolarAxisModel.prototype.getCoordSysModel = function () {
    return this.getReferringComponents('polar', __WEBPACK_IMPORTED_MODULE_4__util_model_js__["i" /* SINGLE_REFERRING */]).models[0];
  };

  PolarAxisModel.type = 'polarAxis';
  return PolarAxisModel;
}(__WEBPACK_IMPORTED_MODULE_2__model_Component_js__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["mixin"](PolarAxisModel, __WEBPACK_IMPORTED_MODULE_3__axisModelCommonMixin_js__["a" /* AxisModelCommonMixin */]);


var AngleAxisModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(AngleAxisModel, _super);

  function AngleAxisModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = AngleAxisModel.type;
    return _this;
  }

  AngleAxisModel.type = 'angleAxis';
  return AngleAxisModel;
}(PolarAxisModel);



var RadiusAxisModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(RadiusAxisModel, _super);

  function RadiusAxisModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = RadiusAxisModel.type;
    return _this;
  }

  RadiusAxisModel.type = 'radiusAxis';
  return RadiusAxisModel;
}(PolarAxisModel);



/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return polarDimensions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RadiusAxis_js__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AngleAxis_js__ = __webpack_require__(1311);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


var polarDimensions = ['radius', 'angle'];

var Polar =
/** @class */
function () {
  function Polar(name) {
    this.dimensions = polarDimensions;
    this.type = 'polar';
    /**
     * x of polar center
     */

    this.cx = 0;
    /**
     * y of polar center
     */

    this.cy = 0;
    this._radiusAxis = new __WEBPACK_IMPORTED_MODULE_0__RadiusAxis_js__["a" /* default */]();
    this._angleAxis = new __WEBPACK_IMPORTED_MODULE_1__AngleAxis_js__["a" /* default */]();
    this.axisPointerEnabled = true;
    this.name = name || '';
    this._radiusAxis.polar = this._angleAxis.polar = this;
  }
  /**
   * If contain coord
   */


  Polar.prototype.containPoint = function (point) {
    var coord = this.pointToCoord(point);
    return this._radiusAxis.contain(coord[0]) && this._angleAxis.contain(coord[1]);
  };
  /**
   * If contain data
   */


  Polar.prototype.containData = function (data) {
    return this._radiusAxis.containData(data[0]) && this._angleAxis.containData(data[1]);
  };

  Polar.prototype.getAxis = function (dim) {
    var key = '_' + dim + 'Axis';
    return this[key];
  };

  Polar.prototype.getAxes = function () {
    return [this._radiusAxis, this._angleAxis];
  };
  /**
   * Get axes by type of scale
   */


  Polar.prototype.getAxesByScale = function (scaleType) {
    var axes = [];
    var angleAxis = this._angleAxis;
    var radiusAxis = this._radiusAxis;
    angleAxis.scale.type === scaleType && axes.push(angleAxis);
    radiusAxis.scale.type === scaleType && axes.push(radiusAxis);
    return axes;
  };

  Polar.prototype.getAngleAxis = function () {
    return this._angleAxis;
  };

  Polar.prototype.getRadiusAxis = function () {
    return this._radiusAxis;
  };

  Polar.prototype.getOtherAxis = function (axis) {
    var angleAxis = this._angleAxis;
    return axis === angleAxis ? this._radiusAxis : angleAxis;
  };
  /**
   * Base axis will be used on stacking.
   *
   */


  Polar.prototype.getBaseAxis = function () {
    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAngleAxis();
  };

  Polar.prototype.getTooltipAxes = function (dim) {
    var baseAxis = dim != null && dim !== 'auto' ? this.getAxis(dim) : this.getBaseAxis();
    return {
      baseAxes: [baseAxis],
      otherAxes: [this.getOtherAxis(baseAxis)]
    };
  };
  /**
   * Convert a single data item to (x, y) point.
   * Parameter data is an array which the first element is radius and the second is angle
   */


  Polar.prototype.dataToPoint = function (data, clamp) {
    return this.coordToPoint([this._radiusAxis.dataToRadius(data[0], clamp), this._angleAxis.dataToAngle(data[1], clamp)]);
  };
  /**
   * Convert a (x, y) point to data
   */


  Polar.prototype.pointToData = function (point, clamp) {
    var coord = this.pointToCoord(point);
    return [this._radiusAxis.radiusToData(coord[0], clamp), this._angleAxis.angleToData(coord[1], clamp)];
  };
  /**
   * Convert a (x, y) point to (radius, angle) coord
   */


  Polar.prototype.pointToCoord = function (point) {
    var dx = point[0] - this.cx;
    var dy = point[1] - this.cy;
    var angleAxis = this.getAngleAxis();
    var extent = angleAxis.getExtent();
    var minAngle = Math.min(extent[0], extent[1]);
    var maxAngle = Math.max(extent[0], extent[1]); // Fix fixed extent in polarCreator
    // FIXME

    angleAxis.inverse ? minAngle = maxAngle - 360 : maxAngle = minAngle + 360;
    var radius = Math.sqrt(dx * dx + dy * dy);
    dx /= radius;
    dy /= radius;
    var radian = Math.atan2(-dy, dx) / Math.PI * 180; // move to angleExtent

    var dir = radian < minAngle ? 1 : -1;

    while (radian < minAngle || radian > maxAngle) {
      radian += dir * 360;
    }

    return [radius, radian];
  };
  /**
   * Convert a (radius, angle) coord to (x, y) point
   */


  Polar.prototype.coordToPoint = function (coord) {
    var radius = coord[0];
    var radian = coord[1] / 180 * Math.PI;
    var x = Math.cos(radian) * radius + this.cx; // Inverse the y

    var y = -Math.sin(radian) * radius + this.cy;
    return [x, y];
  };
  /**
   * Get ring area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */


  Polar.prototype.getArea = function () {
    var angleAxis = this.getAngleAxis();
    var radiusAxis = this.getRadiusAxis();
    var radiusExtent = radiusAxis.getExtent().slice();
    radiusExtent[0] > radiusExtent[1] && radiusExtent.reverse();
    var angleExtent = angleAxis.getExtent();
    var RADIAN = Math.PI / 180;
    return {
      cx: this.cx,
      cy: this.cy,
      r0: radiusExtent[0],
      r: radiusExtent[1],
      startAngle: -angleExtent[0] * RADIAN,
      endAngle: -angleExtent[1] * RADIAN,
      clockwise: angleAxis.inverse,
      contain: function (x, y) {
        // It's a ring shape.
        // Start angle and end angle don't matter
        var dx = x - this.cx;
        var dy = y - this.cy; // minus a tiny value 1e-4 to avoid being clipped unexpectedly

        var d2 = dx * dx + dy * dy - 1e-4;
        var r = this.r;
        var r0 = this.r0;
        return d2 <= r * r && d2 >= r0 * r0;
      }
    };
  };

  Polar.prototype.convertToPixel = function (ecModel, finder, value) {
    var coordSys = getCoordSys(finder);
    return coordSys === this ? this.dataToPoint(value) : null;
  };

  Polar.prototype.convertFromPixel = function (ecModel, finder, pixel) {
    var coordSys = getCoordSys(finder);
    return coordSys === this ? this.pointToData(pixel) : null;
  };

  return Polar;
}();

function getCoordSys(finder) {
  var seriesModel = finder.seriesModel;
  var polarModel = finder.polarModel;
  return polarModel && polarModel.coordinateSystem || seriesModel && seriesModel.coordinateSystem;
}

/* harmony default export */ __webpack_exports__["b"] = (Polar);

/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_Component_js__ = __webpack_require__(21);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var PolarModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(PolarModel, _super);

  function PolarModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = PolarModel.type;
    return _this;
  }

  PolarModel.prototype.findAxisModel = function (axisType) {
    var foundAxisModel;
    var ecModel = this.ecModel;
    ecModel.eachComponent(axisType, function (axisModel) {
      if (axisModel.getCoordSysModel() === this) {
        foundAxisModel = axisModel;
      }
    }, this);
    return foundAxisModel;
  };

  PolarModel.type = 'polar';
  PolarModel.dependencies = ['radiusAxis', 'angleAxis'];
  PolarModel.defaultOption = {
    // zlevel: 0,
    z: 0,
    center: ['50%', '50%'],
    radius: '80%'
  };
  return PolarModel;
}(__WEBPACK_IMPORTED_MODULE_1__model_Component_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PolarModel);

/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Axis_js__ = __webpack_require__(112);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var RadiusAxis =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(RadiusAxis, _super);

  function RadiusAxis(scale, radiusExtent) {
    return _super.call(this, 'radius', scale, radiusExtent) || this;
  }

  RadiusAxis.prototype.pointToData = function (point, clamp) {
    return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
  };

  return RadiusAxis;
}(__WEBPACK_IMPORTED_MODULE_1__Axis_js__["a" /* default */]);

RadiusAxis.prototype.dataToRadius = __WEBPACK_IMPORTED_MODULE_1__Axis_js__["a" /* default */].prototype.dataToCoord;
RadiusAxis.prototype.radiusToData = __WEBPACK_IMPORTED_MODULE_1__Axis_js__["a" /* default */].prototype.coordToData;
/* harmony default export */ __webpack_exports__["a"] = (RadiusAxis);

/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Polar_js__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__coord_axisHelper_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// TODO Axis scale





/**
 * Resize method bound to the polar
 */

function resizePolar(polar, polarModel, api) {
  var center = polarModel.get('center');
  var width = api.getWidth();
  var height = api.getHeight();
  polar.cx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_number_js__["a" /* parsePercent */])(center[0], width);
  polar.cy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_number_js__["a" /* parsePercent */])(center[1], height);
  var radiusAxis = polar.getRadiusAxis();
  var size = Math.min(width, height) / 2;
  var radius = polarModel.get('radius');

  if (radius == null) {
    radius = [0, '100%'];
  } else if (!__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](radius)) {
    // r0 = 0
    radius = [0, radius];
  }

  var parsedRadius = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_number_js__["a" /* parsePercent */])(radius[0], size), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_number_js__["a" /* parsePercent */])(radius[1], size)];
  radiusAxis.inverse ? radiusAxis.setExtent(parsedRadius[1], parsedRadius[0]) : radiusAxis.setExtent(parsedRadius[0], parsedRadius[1]);
}
/**
 * Update polar
 */


function updatePolarScale(ecModel, api) {
  var polar = this;
  var angleAxis = polar.getAngleAxis();
  var radiusAxis = polar.getRadiusAxis(); // Reset scale

  angleAxis.scale.setExtent(Infinity, -Infinity);
  radiusAxis.scale.setExtent(Infinity, -Infinity);
  ecModel.eachSeries(function (seriesModel) {
    if (seriesModel.coordinateSystem === polar) {
      var data_1 = seriesModel.getData();
      __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__coord_axisHelper_js__["i" /* getDataDimensionsOnAxis */])(data_1, 'radius'), function (dim) {
        radiusAxis.scale.unionExtentFromData(data_1, dim);
      });
      __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__coord_axisHelper_js__["i" /* getDataDimensionsOnAxis */])(data_1, 'angle'), function (dim) {
        angleAxis.scale.unionExtentFromData(data_1, dim);
      });
    }
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__coord_axisHelper_js__["g" /* niceScaleExtent */])(angleAxis.scale, angleAxis.model);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__coord_axisHelper_js__["g" /* niceScaleExtent */])(radiusAxis.scale, radiusAxis.model); // Fix extent of category angle axis

  if (angleAxis.type === 'category' && !angleAxis.onBand) {
    var extent = angleAxis.getExtent();
    var diff = 360 / angleAxis.scale.count();
    angleAxis.inverse ? extent[1] += diff : extent[1] -= diff;
    angleAxis.setExtent(extent[0], extent[1]);
  }
}

function isAngleAxisModel(axisModel) {
  return axisModel.mainType === 'angleAxis';
}
/**
 * Set common axis properties
 */


function setAxis(axis, axisModel) {
  axis.type = axisModel.get('type');
  axis.scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__coord_axisHelper_js__["f" /* createScaleByModel */])(axisModel);
  axis.onBand = axisModel.get('boundaryGap') && axis.type === 'category';
  axis.inverse = axisModel.get('inverse');

  if (isAngleAxisModel(axisModel)) {
    axis.inverse = axis.inverse !== axisModel.get('clockwise');
    var startAngle = axisModel.get('startAngle');
    axis.setExtent(startAngle, startAngle + (axis.inverse ? -360 : 360));
  } // Inject axis instance


  axisModel.axis = axis;
  axis.model = axisModel;
}

var polarCreator = {
  dimensions: __WEBPACK_IMPORTED_MODULE_1__Polar_js__["a" /* polarDimensions */],
  create: function (ecModel, api) {
    var polarList = [];
    ecModel.eachComponent('polar', function (polarModel, idx) {
      var polar = new __WEBPACK_IMPORTED_MODULE_1__Polar_js__["b" /* default */](idx + ''); // Inject resize and update method

      polar.update = updatePolarScale;
      var radiusAxis = polar.getRadiusAxis();
      var angleAxis = polar.getAngleAxis();
      var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
      var angleAxisModel = polarModel.findAxisModel('angleAxis');
      setAxis(radiusAxis, radiusAxisModel);
      setAxis(angleAxis, angleAxisModel);
      resizePolar(polar, polarModel, api);
      polarList.push(polar);
      polarModel.coordinateSystem = polar;
      polar.model = polarModel;
    }); // Inject coordinateSystem to series

    ecModel.eachSeries(function (seriesModel) {
      if (seriesModel.get('coordinateSystem') === 'polar') {
        var polarModel = seriesModel.getReferringComponents('polar', __WEBPACK_IMPORTED_MODULE_4__util_model_js__["i" /* SINGLE_REFERRING */]).models[0];

        if (true) {
          if (!polarModel) {
            throw new Error('Polar "' + __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve"](seriesModel.get('polarIndex'), seriesModel.get('polarId'), 0) + '" not found');
          }
        }

        seriesModel.coordinateSystem = polarModel.coordinateSystem;
      }
    });
    return polarList;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (polarCreator);

/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = polarPrepareCustom;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
 // import AngleAxis from './AngleAxis.js';

function dataToCoordSize(dataSize, dataItem) {
  // dataItem is necessary in log axis.
  dataItem = dataItem || [0, 0];
  return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"](['Radius', 'Angle'], function (dim, dimIdx) {
    var getterName = 'get' + dim + 'Axis'; // TODO: TYPE Check Angle Axis

    var axis = this[getterName]();
    var val = dataItem[dimIdx];
    var halfSize = dataSize[dimIdx] / 2;
    var result = axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));

    if (dim === 'Angle') {
      result = result * Math.PI / 180;
    }

    return result;
  }, this);
}

function polarPrepareCustom(coordSys) {
  var radiusAxis = coordSys.getRadiusAxis();
  var angleAxis = coordSys.getAngleAxis();
  var radius = radiusAxis.getExtent();
  radius[0] > radius[1] && radius.reverse();
  return {
    coordSys: {
      type: 'polar',
      cx: coordSys.cx,
      cy: coordSys.cy,
      r: radius[1],
      r0: radius[0]
    },
    api: {
      coord: function (data) {
        var radius = radiusAxis.dataToRadius(data[0]);
        var angle = angleAxis.dataToAngle(data[1]);
        var coord = coordSys.coordToPoint([radius, angle]);
        coord.push(radius, angle * Math.PI / 180);
        return coord;
      },
      size: __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["bind"](dataToCoordSize, coordSys)
    }
  };
}

/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Axis_js__ = __webpack_require__(112);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var IndicatorAxis =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(IndicatorAxis, _super);

  function IndicatorAxis(dim, scale, radiusExtent) {
    var _this = _super.call(this, dim, scale, radiusExtent) || this;

    _this.type = 'value';
    _this.angle = 0;
    _this.name = '';
    return _this;
  }

  return IndicatorAxis;
}(__WEBPACK_IMPORTED_MODULE_1__Axis_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (IndicatorAxis);

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IndicatorAxis_js__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scale_Interval_js__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__axisAlignTicks_js__ = __webpack_require__(484);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// TODO clockwise






var Radar =
/** @class */
function () {
  function Radar(radarModel, ecModel, api) {
    /**
     *
     * Radar dimensions
     */
    this.dimensions = [];
    this._model = radarModel;
    this._indicatorAxes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["map"])(radarModel.getIndicatorModels(), function (indicatorModel, idx) {
      var dim = 'indicator_' + idx;
      var indicatorAxis = new __WEBPACK_IMPORTED_MODULE_0__IndicatorAxis_js__["a" /* default */](dim, new __WEBPACK_IMPORTED_MODULE_1__scale_Interval_js__["a" /* default */]() // (indicatorModel.get('axisType') === 'log') ? new LogScale() : new IntervalScale()
      );
      indicatorAxis.name = indicatorModel.get('name'); // Inject model and axis

      indicatorAxis.model = indicatorModel;
      indicatorModel.axis = indicatorAxis;
      this.dimensions.push(dim);
      return indicatorAxis;
    }, this);
    this.resize(radarModel, api);
  }

  Radar.prototype.getIndicatorAxes = function () {
    return this._indicatorAxes;
  };

  Radar.prototype.dataToPoint = function (value, indicatorIndex) {
    var indicatorAxis = this._indicatorAxes[indicatorIndex];
    return this.coordToPoint(indicatorAxis.dataToCoord(value), indicatorIndex);
  }; // TODO: API should be coordToPoint([coord, indicatorIndex])


  Radar.prototype.coordToPoint = function (coord, indicatorIndex) {
    var indicatorAxis = this._indicatorAxes[indicatorIndex];
    var angle = indicatorAxis.angle;
    var x = this.cx + coord * Math.cos(angle);
    var y = this.cy - coord * Math.sin(angle);
    return [x, y];
  };

  Radar.prototype.pointToData = function (pt) {
    var dx = pt[0] - this.cx;
    var dy = pt[1] - this.cy;
    var radius = Math.sqrt(dx * dx + dy * dy);
    dx /= radius;
    dy /= radius;
    var radian = Math.atan2(-dy, dx); // Find the closest angle
    // FIXME index can calculated directly

    var minRadianDiff = Infinity;
    var closestAxis;
    var closestAxisIdx = -1;

    for (var i = 0; i < this._indicatorAxes.length; i++) {
      var indicatorAxis = this._indicatorAxes[i];
      var diff = Math.abs(radian - indicatorAxis.angle);

      if (diff < minRadianDiff) {
        closestAxis = indicatorAxis;
        closestAxisIdx = i;
        minRadianDiff = diff;
      }
    }

    return [closestAxisIdx, +(closestAxis && closestAxis.coordToData(radius))];
  };

  Radar.prototype.resize = function (radarModel, api) {
    var center = radarModel.get('center');
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    var viewSize = Math.min(viewWidth, viewHeight) / 2;
    this.cx = __WEBPACK_IMPORTED_MODULE_2__util_number_js__["a" /* parsePercent */](center[0], viewWidth);
    this.cy = __WEBPACK_IMPORTED_MODULE_2__util_number_js__["a" /* parsePercent */](center[1], viewHeight);
    this.startAngle = radarModel.get('startAngle') * Math.PI / 180; // radius may be single value like `20`, `'80%'`, or array like `[10, '80%']`

    var radius = radarModel.get('radius');

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["isString"])(radius) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["isNumber"])(radius)) {
      radius = [0, radius];
    }

    this.r0 = __WEBPACK_IMPORTED_MODULE_2__util_number_js__["a" /* parsePercent */](radius[0], viewSize);
    this.r = __WEBPACK_IMPORTED_MODULE_2__util_number_js__["a" /* parsePercent */](radius[1], viewSize);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(this._indicatorAxes, function (indicatorAxis, idx) {
      indicatorAxis.setExtent(this.r0, this.r);
      var angle = this.startAngle + idx * Math.PI * 2 / this._indicatorAxes.length; // Normalize to [-PI, PI]

      angle = Math.atan2(Math.sin(angle), Math.cos(angle));
      indicatorAxis.angle = angle;
    }, this);
  };

  Radar.prototype.update = function (ecModel, api) {
    var indicatorAxes = this._indicatorAxes;
    var radarModel = this._model;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(indicatorAxes, function (indicatorAxis) {
      indicatorAxis.scale.setExtent(Infinity, -Infinity);
    });
    ecModel.eachSeriesByType('radar', function (radarSeries, idx) {
      if (radarSeries.get('coordinateSystem') !== 'radar' // @ts-ignore
      || ecModel.getComponent('radar', radarSeries.get('radarIndex')) !== radarModel) {
        return;
      }

      var data = radarSeries.getData();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(indicatorAxes, function (indicatorAxis) {
        indicatorAxis.scale.unionExtentFromData(data, data.mapDimension(indicatorAxis.dim));
      });
    }, this);
    var splitNumber = radarModel.get('splitNumber');
    var dummyScale = new __WEBPACK_IMPORTED_MODULE_1__scale_Interval_js__["a" /* default */]();
    dummyScale.setExtent(0, splitNumber);
    dummyScale.setInterval(1); // Force all the axis fixing the maxSplitNumber.

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(indicatorAxes, function (indicatorAxis, idx) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__axisAlignTicks_js__["a" /* alignScaleTicks */])(indicatorAxis.scale, indicatorAxis.model, dummyScale);
    });
  };

  Radar.prototype.convertToPixel = function (ecModel, finder, value) {
    console.warn('Not implemented.');
    return null;
  };

  Radar.prototype.convertFromPixel = function (ecModel, finder, pixel) {
    console.warn('Not implemented.');
    return null;
  };

  Radar.prototype.containPoint = function (point) {
    console.warn('Not implemented.');
    return false;
  };

  Radar.create = function (ecModel, api) {
    var radarList = [];
    ecModel.eachComponent('radar', function (radarModel) {
      var radar = new Radar(radarModel, ecModel, api);
      radarList.push(radar);
      radarModel.coordinateSystem = radar;
    });
    ecModel.eachSeriesByType('radar', function (radarSeries) {
      if (radarSeries.get('coordinateSystem') === 'radar') {
        // Inject coordinate system
        // @ts-ignore
        radarSeries.coordinateSystem = radarList[radarSeries.get('radarIndex') || 0];
      }
    });
    return radarList;
  };
  /**
   * Radar dimensions is based on the data
   */


  Radar.dimensions = [];
  return Radar;
}();

/* harmony default export */ __webpack_exports__["a"] = (Radar);

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axisDefault_js__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_Model_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__axisModelCommonMixin_js__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_Component_js__ = __webpack_require__(21);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






var valueAxisDefault = __WEBPACK_IMPORTED_MODULE_2__axisDefault_js__["a" /* default */].value;

function defaultsShow(opt, show) {
  return __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"]({
    show: show
  }, opt);
}

var RadarModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(RadarModel, _super);

  function RadarModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = RadarModel.type;
    return _this;
  }

  RadarModel.prototype.optionUpdated = function () {
    var boundaryGap = this.get('boundaryGap');
    var splitNumber = this.get('splitNumber');
    var scale = this.get('scale');
    var axisLine = this.get('axisLine');
    var axisTick = this.get('axisTick'); // let axisType = this.get('axisType');

    var axisLabel = this.get('axisLabel');
    var nameTextStyle = this.get('axisName');
    var showName = this.get(['axisName', 'show']);
    var nameFormatter = this.get(['axisName', 'formatter']);
    var nameGap = this.get('axisNameGap');
    var triggerEvent = this.get('triggerEvent');
    var indicatorModels = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"](this.get('indicator') || [], function (indicatorOpt) {
      // PENDING
      if (indicatorOpt.max != null && indicatorOpt.max > 0 && !indicatorOpt.min) {
        indicatorOpt.min = 0;
      } else if (indicatorOpt.min != null && indicatorOpt.min < 0 && !indicatorOpt.max) {
        indicatorOpt.max = 0;
      }

      var iNameTextStyle = nameTextStyle;

      if (indicatorOpt.color != null) {
        iNameTextStyle = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["defaults"]({
          color: indicatorOpt.color
        }, nameTextStyle);
      } // Use same configuration


      var innerIndicatorOpt = __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"](__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"](indicatorOpt), {
        boundaryGap: boundaryGap,
        splitNumber: splitNumber,
        scale: scale,
        axisLine: axisLine,
        axisTick: axisTick,
        // axisType: axisType,
        axisLabel: axisLabel,
        // Compatible with 2 and use text
        name: indicatorOpt.text,
        showName: showName,
        nameLocation: 'end',
        nameGap: nameGap,
        // min: 0,
        nameTextStyle: iNameTextStyle,
        triggerEvent: triggerEvent
      }, false);

      if (!showName) {
        innerIndicatorOpt.name = '';
      }

      if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isString"](nameFormatter)) {
        var indName = innerIndicatorOpt.name;
        innerIndicatorOpt.name = nameFormatter.replace('{value}', indName != null ? indName : '');
      } else if (__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isFunction"](nameFormatter)) {
        innerIndicatorOpt.name = nameFormatter(innerIndicatorOpt.name, innerIndicatorOpt);
      }

      var model = new __WEBPACK_IMPORTED_MODULE_3__model_Model_js__["a" /* default */](innerIndicatorOpt, null, this.ecModel);
      __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["mixin"](model, __WEBPACK_IMPORTED_MODULE_4__axisModelCommonMixin_js__["a" /* AxisModelCommonMixin */].prototype); // For triggerEvent.

      model.mainType = 'radar';
      model.componentIndex = this.componentIndex;
      return model;
    }, this);
    this._indicatorModels = indicatorModels;
  };

  RadarModel.prototype.getIndicatorModels = function () {
    return this._indicatorModels;
  };

  RadarModel.type = 'radar';
  RadarModel.defaultOption = {
    // zlevel: 0,
    z: 0,
    center: ['50%', '50%'],
    radius: '75%',
    startAngle: 90,
    axisName: {
      show: true // formatter: null
      // textStyle: {}

    },
    boundaryGap: [0, 0],
    splitNumber: 5,
    axisNameGap: 15,
    scale: false,
    // Polygon or circle
    shape: 'polygon',
    axisLine: __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["merge"]({
      lineStyle: {
        color: '#bbb'
      }
    }, valueAxisDefault.axisLine),
    axisLabel: defaultsShow(valueAxisDefault.axisLabel, false),
    axisTick: defaultsShow(valueAxisDefault.axisTick, false),
    // axisType: 'value',
    splitLine: defaultsShow(valueAxisDefault.splitLine, true),
    splitArea: defaultsShow(valueAxisDefault.splitArea, true),
    // {text, min, max}
    indicator: []
  };
  return RadarModel;
}(__WEBPACK_IMPORTED_MODULE_5__model_Component_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (RadarModel);

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_Component_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axisModelCommonMixin_js__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





var SingleAxisModel =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(SingleAxisModel, _super);

  function SingleAxisModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SingleAxisModel.type;
    return _this;
  }

  SingleAxisModel.prototype.getCoordSysModel = function () {
    return this;
  };

  SingleAxisModel.type = 'singleAxis';
  SingleAxisModel.layoutMode = 'box';
  SingleAxisModel.defaultOption = {
    left: '5%',
    top: '5%',
    right: '5%',
    bottom: '5%',
    type: 'value',
    position: 'bottom',
    orient: 'horizontal',
    axisLine: {
      show: true,
      lineStyle: {
        width: 1,
        type: 'solid'
      }
    },
    // Single coordinate system and single axis is the,
    // which is used as the parent tooltip model.
    // same model, so we set default tooltip show as true.
    tooltip: {
      show: true
    },
    axisTick: {
      show: true,
      length: 6,
      lineStyle: {
        width: 1
      }
    },
    axisLabel: {
      show: true,
      interval: 'auto'
    },
    splitLine: {
      show: true,
      lineStyle: {
        type: 'dashed',
        opacity: 0.2
      }
    }
  };
  return SingleAxisModel;
}(__WEBPACK_IMPORTED_MODULE_1__model_Component_js__["a" /* default */]);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["mixin"])(SingleAxisModel, __WEBPACK_IMPORTED_MODULE_2__axisModelCommonMixin_js__["a" /* AxisModelCommonMixin */].prototype);
/* harmony default export */ __webpack_exports__["a"] = (SingleAxisModel);

/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return singleDimensions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SingleAxis_js__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axisHelper_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Single coordinates system.
 */




var singleDimensions = ['single'];
/**
 * Create a single coordinates system.
 */

var Single =
/** @class */
function () {
  function Single(axisModel, ecModel, api) {
    this.type = 'single';
    this.dimension = 'single';
    /**
     * Add it just for draw tooltip.
     */

    this.dimensions = singleDimensions;
    this.axisPointerEnabled = true;
    this.model = axisModel;

    this._init(axisModel, ecModel, api);
  }
  /**
   * Initialize single coordinate system.
   */


  Single.prototype._init = function (axisModel, ecModel, api) {
    var dim = this.dimension;
    var axis = new __WEBPACK_IMPORTED_MODULE_0__SingleAxis_js__["a" /* default */](dim, __WEBPACK_IMPORTED_MODULE_1__axisHelper_js__["f" /* createScaleByModel */](axisModel), [0, 0], axisModel.get('type'), axisModel.get('position'));
    var isCategory = axis.type === 'category';
    axis.onBand = isCategory && axisModel.get('boundaryGap');
    axis.inverse = axisModel.get('inverse');
    axis.orient = axisModel.get('orient');
    axisModel.axis = axis;
    axis.model = axisModel;
    axis.coordinateSystem = this;
    this._axis = axis;
  };
  /**
   * Update axis scale after data processed
   */


  Single.prototype.update = function (ecModel, api) {
    ecModel.eachSeries(function (seriesModel) {
      if (seriesModel.coordinateSystem === this) {
        var data_1 = seriesModel.getData();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_util_js__["each"])(data_1.mapDimensionsAll(this.dimension), function (dim) {
          this._axis.scale.unionExtentFromData(data_1, dim);
        }, this);
        __WEBPACK_IMPORTED_MODULE_1__axisHelper_js__["g" /* niceScaleExtent */](this._axis.scale, this._axis.model);
      }
    }, this);
  };
  /**
   * Resize the single coordinate system.
   */


  Single.prototype.resize = function (axisModel, api) {
    this._rect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_layout_js__["f" /* getLayoutRect */])({
      left: axisModel.get('left'),
      top: axisModel.get('top'),
      right: axisModel.get('right'),
      bottom: axisModel.get('bottom'),
      width: axisModel.get('width'),
      height: axisModel.get('height')
    }, {
      width: api.getWidth(),
      height: api.getHeight()
    });

    this._adjustAxis();
  };

  Single.prototype.getRect = function () {
    return this._rect;
  };

  Single.prototype._adjustAxis = function () {
    var rect = this._rect;
    var axis = this._axis;
    var isHorizontal = axis.isHorizontal();
    var extent = isHorizontal ? [0, rect.width] : [0, rect.height];
    var idx = axis.reverse ? 1 : 0;
    axis.setExtent(extent[idx], extent[1 - idx]);

    this._updateAxisTransform(axis, isHorizontal ? rect.x : rect.y);
  };

  Single.prototype._updateAxisTransform = function (axis, coordBase) {
    var axisExtent = axis.getExtent();
    var extentSum = axisExtent[0] + axisExtent[1];
    var isHorizontal = axis.isHorizontal();
    axis.toGlobalCoord = isHorizontal ? function (coord) {
      return coord + coordBase;
    } : function (coord) {
      return extentSum - coord + coordBase;
    };
    axis.toLocalCoord = isHorizontal ? function (coord) {
      return coord - coordBase;
    } : function (coord) {
      return extentSum - coord + coordBase;
    };
  };
  /**
   * Get axis.
   */


  Single.prototype.getAxis = function () {
    return this._axis;
  };
  /**
   * Get axis, add it just for draw tooltip.
   */


  Single.prototype.getBaseAxis = function () {
    return this._axis;
  };

  Single.prototype.getAxes = function () {
    return [this._axis];
  };

  Single.prototype.getTooltipAxes = function () {
    return {
      baseAxes: [this.getAxis()],
      // Empty otherAxes
      otherAxes: []
    };
  };
  /**
   * If contain point.
   */


  Single.prototype.containPoint = function (point) {
    var rect = this.getRect();
    var axis = this.getAxis();
    var orient = axis.orient;

    if (orient === 'horizontal') {
      return axis.contain(axis.toLocalCoord(point[0])) && point[1] >= rect.y && point[1] <= rect.y + rect.height;
    } else {
      return axis.contain(axis.toLocalCoord(point[1])) && point[0] >= rect.y && point[0] <= rect.y + rect.height;
    }
  };

  Single.prototype.pointToData = function (point) {
    var axis = this.getAxis();
    return [axis.coordToData(axis.toLocalCoord(point[axis.orient === 'horizontal' ? 0 : 1]))];
  };
  /**
   * Convert the series data to concrete point.
   * Can be [val] | val
   */


  Single.prototype.dataToPoint = function (val) {
    var axis = this.getAxis();
    var rect = this.getRect();
    var pt = [];
    var idx = axis.orient === 'horizontal' ? 0 : 1;

    if (val instanceof Array) {
      val = val[0];
    }

    pt[idx] = axis.toGlobalCoord(axis.dataToCoord(+val));
    pt[1 - idx] = idx === 0 ? rect.y + rect.height / 2 : rect.x + rect.width / 2;
    return pt;
  };

  Single.prototype.convertToPixel = function (ecModel, finder, value) {
    var coordSys = getCoordSys(finder);
    return coordSys === this ? this.dataToPoint(value) : null;
  };

  Single.prototype.convertFromPixel = function (ecModel, finder, pixel) {
    var coordSys = getCoordSys(finder);
    return coordSys === this ? this.pointToData(pixel) : null;
  };

  return Single;
}();

function getCoordSys(finder) {
  var seriesModel = finder.seriesModel;
  var singleModel = finder.singleAxisModel;
  return singleModel && singleModel.coordinateSystem || seriesModel && seriesModel.coordinateSystem;
}

/* harmony default export */ __webpack_exports__["a"] = (Single);

/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Axis_js__ = __webpack_require__(112);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var SingleAxis =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(SingleAxis, _super);

  function SingleAxis(dim, scale, coordExtent, axisType, position) {
    var _this = _super.call(this, dim, scale, coordExtent) || this;

    _this.type = axisType || 'value';
    _this.position = position || 'bottom';
    return _this;
  }
  /**
   * Judge the orient of the axis.
   */


  SingleAxis.prototype.isHorizontal = function () {
    var position = this.position;
    return position === 'top' || position === 'bottom';
  };

  SingleAxis.prototype.pointToData = function (point, clamp) {
    return this.coordinateSystem.pointToData(point)[0];
  };

  return SingleAxis;
}(__WEBPACK_IMPORTED_MODULE_1__Axis_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SingleAxis);

/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = singlePrepareCustom;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


function dataToCoordSize(dataSize, dataItem) {
  // dataItem is necessary in log axis.
  var axis = this.getAxis();
  var val = dataItem instanceof Array ? dataItem[0] : dataItem;
  var halfSize = (dataSize instanceof Array ? dataSize[0] : dataSize) / 2;
  return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
}

function singlePrepareCustom(coordSys) {
  var rect = coordSys.getRect();
  return {
    coordSys: {
      type: 'singleAxis',
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    },
    api: {
      coord: function (val) {
        // do not provide "out" param
        return coordSys.dataToPoint(val);
      },
      size: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["bind"])(dataToCoordSize, coordSys)
    }
  };
}

/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Single_js__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Single coordinate system creator.
 */


/**
 * Create single coordinate system and inject it into seriesModel.
 */

function create(ecModel, api) {
  var singles = [];
  ecModel.eachComponent('singleAxis', function (axisModel, idx) {
    var single = new __WEBPACK_IMPORTED_MODULE_0__Single_js__["a" /* default */](axisModel, ecModel, api);
    single.name = 'single_' + idx;
    single.resize(axisModel, api);
    axisModel.coordinateSystem = single;
    singles.push(single);
  });
  ecModel.eachSeries(function (seriesModel) {
    if (seriesModel.get('coordinateSystem') === 'singleAxis') {
      var singleAxisModel = seriesModel.getReferringComponents('singleAxis', __WEBPACK_IMPORTED_MODULE_1__util_model_js__["i" /* SINGLE_REFERRING */]).models[0];
      seriesModel.coordinateSystem = singleAxisModel && singleAxisModel.coordinateSystem;
    }
  });
  return singles;
}

var singleCreator = {
  create: create,
  dimensions: __WEBPACK_IMPORTED_MODULE_0__Single_js__["b" /* singleDimensions */]
};
/* harmony default export */ __webpack_exports__["a"] = (singleCreator);

/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__task_js__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_component_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_Global_js__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ExtensionAPI_js__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






;

var Scheduler =
/** @class */
function () {
  function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
    // key: handlerUID
    this._stageTaskMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();
    this.ecInstance = ecInstance;
    this.api = api; // Fix current processors in case that in some rear cases that
    // processors might be registered after echarts instance created.
    // Register processors incrementally for a echarts instance is
    // not supported by this stream architecture.

    dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
    visualHandlers = this._visualHandlers = visualHandlers.slice();
    this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
  }

  Scheduler.prototype.restoreData = function (ecModel, payload) {
    // TODO: Only restore needed series and components, but not all components.
    // Currently `restoreData` of all of the series and component will be called.
    // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
    // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
    // and some components like coordinate system, axes, dataZoom, visualMap only
    // need their target series refresh.
    // (1) If we are implementing this feature some day, we should consider these cases:
    // if a data processor depends on a component (e.g., dataZoomProcessor depends
    // on the settings of `dataZoom`), it should be re-performed if the component
    // is modified by `setOption`.
    // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
    // it should be re-performed when the result array of `getTargetSeries` changed.
    // We use `dependencies` to cover these issues.
    // (3) How to update target series when coordinate system related components modified.
    // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
    // and this case all of the tasks will be set as dirty.
    ecModel.restoreData(payload); // Theoretically an overall task not only depends on each of its target series, but also
    // depends on all of the series.
    // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
    // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
    // that the overall task is set as dirty and to be performed, otherwise it probably cause
    // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
    // probably cause state chaos (consider `dataZoomProcessor`).

    this._stageTaskMap.each(function (taskRecord) {
      var overallTask = taskRecord.overallTask;
      overallTask && overallTask.dirty();
    });
  }; // If seriesModel provided, incremental threshold is check by series data.


  Scheduler.prototype.getPerformArgs = function (task, isBlock) {
    // For overall task
    if (!task.__pipeline) {
      return;
    }

    var pipeline = this._pipelineMap.get(task.__pipeline.id);

    var pCtx = pipeline.context;
    var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
    var step = incremental ? pipeline.step : null;
    var modDataCount = pCtx && pCtx.modDataCount;
    var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
    return {
      step: step,
      modBy: modBy,
      modDataCount: modDataCount
    };
  };

  Scheduler.prototype.getPipeline = function (pipelineId) {
    return this._pipelineMap.get(pipelineId);
  };
  /**
   * Current, progressive rendering starts from visual and layout.
   * Always detect render mode in the same stage, avoiding that incorrect
   * detection caused by data filtering.
   * Caution:
   * `updateStreamModes` use `seriesModel.getData()`.
   */


  Scheduler.prototype.updateStreamModes = function (seriesModel, view) {
    var pipeline = this._pipelineMap.get(seriesModel.uid);

    var data = seriesModel.getData();
    var dataLen = data.count(); // `progressiveRender` means that can render progressively in each
    // animation frame. Note that some types of series do not provide
    // `view.incrementalPrepareRender` but support `chart.appendData`. We
    // use the term `incremental` but not `progressive` to describe the
    // case that `chart.appendData`.

    var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
    var large = seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold'); // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
    // see `test/candlestick-large3.html`

    var modDataCount = seriesModel.get('progressiveChunkMode') === 'mod' ? dataLen : null;
    seriesModel.pipelineContext = pipeline.context = {
      progressiveRender: progressiveRender,
      modDataCount: modDataCount,
      large: large
    };
  };

  Scheduler.prototype.restorePipelines = function (ecModel) {
    var scheduler = this;
    var pipelineMap = scheduler._pipelineMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();
    ecModel.eachSeries(function (seriesModel) {
      var progressive = seriesModel.getProgressive();
      var pipelineId = seriesModel.uid;
      pipelineMap.set(pipelineId, {
        id: pipelineId,
        head: null,
        tail: null,
        threshold: seriesModel.getProgressiveThreshold(),
        progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
        blockIndex: -1,
        step: Math.round(progressive || 700),
        count: 0
      });

      scheduler._pipe(seriesModel, seriesModel.dataTask);
    });
  };

  Scheduler.prototype.prepareStageTasks = function () {
    var stageTaskMap = this._stageTaskMap;
    var ecModel = this.api.getModel();
    var api = this.api;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(this._allHandlers, function (handler) {
      var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, {});
      var errMsg = '';

      if (true) {
        // Currently do not need to support to sepecify them both.
        errMsg = '"reset" and "overallReset" must not be both specified.';
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(!(handler.reset && handler.overallReset), errMsg);
      handler.reset && this._createSeriesStageTask(handler, record, ecModel, api);
      handler.overallReset && this._createOverallStageTask(handler, record, ecModel, api);
    }, this);
  };

  Scheduler.prototype.prepareView = function (view, model, ecModel, api) {
    var renderTask = view.renderTask;
    var context = renderTask.context;
    context.model = model;
    context.ecModel = ecModel;
    context.api = api;
    renderTask.__block = !view.incrementalPrepareRender;

    this._pipe(model, renderTask);
  };

  Scheduler.prototype.performDataProcessorTasks = function (ecModel, payload) {
    // If we do not use `block` here, it should be considered when to update modes.
    this._performStageTasks(this._dataProcessorHandlers, ecModel, payload, {
      block: true
    });
  };

  Scheduler.prototype.performVisualTasks = function (ecModel, payload, opt) {
    this._performStageTasks(this._visualHandlers, ecModel, payload, opt);
  };

  Scheduler.prototype._performStageTasks = function (stageHandlers, ecModel, payload, opt) {
    opt = opt || {};
    var unfinished = false;
    var scheduler = this;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(stageHandlers, function (stageHandler, idx) {
      if (opt.visualType && opt.visualType !== stageHandler.visualType) {
        return;
      }

      var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);

      var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
      var overallTask = stageHandlerRecord.overallTask;

      if (overallTask) {
        var overallNeedDirty_1;
        var agentStubMap = overallTask.agentStubMap;
        agentStubMap.each(function (stub) {
          if (needSetDirty(opt, stub)) {
            stub.dirty();
            overallNeedDirty_1 = true;
          }
        });
        overallNeedDirty_1 && overallTask.dirty();
        scheduler.updatePayload(overallTask, payload);
        var performArgs_1 = scheduler.getPerformArgs(overallTask, opt.block); // Execute stubs firstly, which may set the overall task dirty,
        // then execute the overall task. And stub will call seriesModel.setData,
        // which ensures that in the overallTask seriesModel.getData() will not
        // return incorrect data.

        agentStubMap.each(function (stub) {
          stub.perform(performArgs_1);
        });

        if (overallTask.perform(performArgs_1)) {
          unfinished = true;
        }
      } else if (seriesTaskMap) {
        seriesTaskMap.each(function (task, pipelineId) {
          if (needSetDirty(opt, task)) {
            task.dirty();
          }

          var performArgs = scheduler.getPerformArgs(task, opt.block); // FIXME
          // if intending to decalare `performRawSeries` in handlers, only
          // stream-independent (specifically, data item independent) operations can be
          // performed. Because is a series is filtered, most of the tasks will not
          // be performed. A stream-dependent operation probably cause wrong biz logic.
          // Perhaps we should not provide a separate callback for this case instead
          // of providing the config `performRawSeries`. The stream-dependent operaions
          // and stream-independent operations should better not be mixed.

          performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
          scheduler.updatePayload(task, payload);

          if (task.perform(performArgs)) {
            unfinished = true;
          }
        });
      }
    });

    function needSetDirty(opt, task) {
      return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
    }

    this.unfinished = unfinished || this.unfinished;
  };

  Scheduler.prototype.performSeriesTasks = function (ecModel) {
    var unfinished;
    ecModel.eachSeries(function (seriesModel) {
      // Progress to the end for dataInit and dataRestore.
      unfinished = seriesModel.dataTask.perform() || unfinished;
    });
    this.unfinished = unfinished || this.unfinished;
  };

  Scheduler.prototype.plan = function () {
    // Travel pipelines, check block.
    this._pipelineMap.each(function (pipeline) {
      var task = pipeline.tail;

      do {
        if (task.__block) {
          pipeline.blockIndex = task.__idxInPipeline;
          break;
        }

        task = task.getUpstream();
      } while (task);
    });
  };

  Scheduler.prototype.updatePayload = function (task, payload) {
    payload !== 'remain' && (task.context.payload = payload);
  };

  Scheduler.prototype._createSeriesStageTask = function (stageHandler, stageHandlerRecord, ecModel, api) {
    var scheduler = this;
    var oldSeriesTaskMap = stageHandlerRecord.seriesTaskMap; // The count of stages are totally about only several dozen, so
    // do not need to reuse the map.

    var newSeriesTaskMap = stageHandlerRecord.seriesTaskMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();
    var seriesType = stageHandler.seriesType;
    var getTargetSeries = stageHandler.getTargetSeries; // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
    // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
    // it works but it may cause other irrelevant charts blocked.

    if (stageHandler.createOnAllSeries) {
      ecModel.eachRawSeries(create);
    } else if (seriesType) {
      ecModel.eachRawSeriesByType(seriesType, create);
    } else if (getTargetSeries) {
      getTargetSeries(ecModel, api).each(create);
    }

    function create(seriesModel) {
      var pipelineId = seriesModel.uid; // Init tasks for each seriesModel only once.
      // Reuse original task instance.

      var task = newSeriesTaskMap.set(pipelineId, oldSeriesTaskMap && oldSeriesTaskMap.get(pipelineId) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__task_js__["a" /* createTask */])({
        plan: seriesTaskPlan,
        reset: seriesTaskReset,
        count: seriesTaskCount
      }));
      task.context = {
        model: seriesModel,
        ecModel: ecModel,
        api: api,
        // PENDING: `useClearVisual` not used?
        useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
        plan: stageHandler.plan,
        reset: stageHandler.reset,
        scheduler: scheduler
      };

      scheduler._pipe(seriesModel, task);
    }
  };

  Scheduler.prototype._createOverallStageTask = function (stageHandler, stageHandlerRecord, ecModel, api) {
    var scheduler = this;
    var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask // For overall task, the function only be called on reset stage.
    || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__task_js__["a" /* createTask */])({
      reset: overallTaskReset
    });
    overallTask.context = {
      ecModel: ecModel,
      api: api,
      overallReset: stageHandler.overallReset,
      scheduler: scheduler
    };
    var oldAgentStubMap = overallTask.agentStubMap; // The count of stages are totally about only several dozen, so
    // do not need to reuse the map.

    var newAgentStubMap = overallTask.agentStubMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();
    var seriesType = stageHandler.seriesType;
    var getTargetSeries = stageHandler.getTargetSeries;
    var overallProgress = true;
    var shouldOverallTaskDirty = false; // FIXME:TS never used, so comment it
    // let modifyOutputEnd = stageHandler.modifyOutputEnd;
    // An overall task with seriesType detected or has `getTargetSeries`, we add
    // stub in each pipelines, it will set the overall task dirty when the pipeline
    // progress. Moreover, to avoid call the overall task each frame (too frequent),
    // we set the pipeline block.

    var errMsg = '';

    if (true) {
      errMsg = '"createOnAllSeries" do not supported for "overallReset", ' + 'becuase it will block all streams.';
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["assert"])(!stageHandler.createOnAllSeries, errMsg);

    if (seriesType) {
      ecModel.eachRawSeriesByType(seriesType, createStub);
    } else if (getTargetSeries) {
      getTargetSeries(ecModel, api).each(createStub);
    } // Otherwise, (usually it is legancy case), the overall task will only be
    // executed when upstream dirty. Otherwise the progressive rendering of all
    // pipelines will be disabled unexpectedly. But it still needs stubs to receive
    // dirty info from upsteam.
    else {
        overallProgress = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(ecModel.getSeries(), createStub);
      }

    function createStub(seriesModel) {
      var pipelineId = seriesModel.uid;
      var stub = newAgentStubMap.set(pipelineId, oldAgentStubMap && oldAgentStubMap.get(pipelineId) || ( // When the result of `getTargetSeries` changed, the overallTask
      // should be set as dirty and re-performed.
      shouldOverallTaskDirty = true, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__task_js__["a" /* createTask */])({
        reset: stubReset,
        onDirty: stubOnDirty
      })));
      stub.context = {
        model: seriesModel,
        overallProgress: overallProgress // FIXME:TS never used, so comment it
        // modifyOutputEnd: modifyOutputEnd

      };
      stub.agent = overallTask;
      stub.__block = overallProgress;

      scheduler._pipe(seriesModel, stub);
    }

    if (shouldOverallTaskDirty) {
      overallTask.dirty();
    }
  };

  Scheduler.prototype._pipe = function (seriesModel, task) {
    var pipelineId = seriesModel.uid;

    var pipeline = this._pipelineMap.get(pipelineId);

    !pipeline.head && (pipeline.head = task);
    pipeline.tail && pipeline.tail.pipe(task);
    pipeline.tail = task;
    task.__idxInPipeline = pipeline.count++;
    task.__pipeline = pipeline;
  };

  Scheduler.wrapStageHandler = function (stageHandler, visualType) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"])(stageHandler)) {
      stageHandler = {
        overallReset: stageHandler,
        seriesType: detectSeriseType(stageHandler)
      };
    }

    stageHandler.uid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_component_js__["a" /* getUID */])('stageHandler');
    visualType && (stageHandler.visualType = visualType);
    return stageHandler;
  };

  ;
  return Scheduler;
}();

function overallTaskReset(context) {
  context.overallReset(context.ecModel, context.api, context.payload);
}

function stubReset(context) {
  return context.overallProgress && stubProgress;
}

function stubProgress() {
  this.agent.dirty();
  this.getDownstream().dirty();
}

function stubOnDirty() {
  this.agent && this.agent.dirty();
}

function seriesTaskPlan(context) {
  return context.plan ? context.plan(context.model, context.ecModel, context.api, context.payload) : null;
}

function seriesTaskReset(context) {
  if (context.useClearVisual) {
    context.data.clearAllVisual();
  }

  var resetDefines = context.resetDefines = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_model_js__["d" /* normalizeToArray */])(context.reset(context.model, context.ecModel, context.api, context.payload));
  return resetDefines.length > 1 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])(resetDefines, function (v, idx) {
    return makeSeriesTaskProgress(idx);
  }) : singleSeriesTaskProgress;
}

var singleSeriesTaskProgress = makeSeriesTaskProgress(0);

function makeSeriesTaskProgress(resetDefineIdx) {
  return function (params, context) {
    var data = context.data;
    var resetDefine = context.resetDefines[resetDefineIdx];

    if (resetDefine && resetDefine.dataEach) {
      for (var i = params.start; i < params.end; i++) {
        resetDefine.dataEach(data, i);
      }
    } else if (resetDefine && resetDefine.progress) {
      resetDefine.progress(params, data);
    }
  };
}

function seriesTaskCount(context) {
  return context.data.count();
}
/**
 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
 * To ensure that they can work normally, they should work in block mode, that is,
 * they should not be started util the previous tasks finished. So they cause the
 * progressive rendering disabled. We try to detect the series type, to narrow down
 * the block range to only the series type they concern, but not all series.
 */


function detectSeriseType(legacyFunc) {
  seriesType = null;

  try {
    // Assume there is no async when calling `eachSeriesByType`.
    legacyFunc(ecModelMock, apiMock);
  } catch (e) {}

  return seriesType;
}

var ecModelMock = {};
var apiMock = {};
var seriesType;
mockMethods(ecModelMock, __WEBPACK_IMPORTED_MODULE_3__model_Global_js__["a" /* default */]);
mockMethods(apiMock, __WEBPACK_IMPORTED_MODULE_4__ExtensionAPI_js__["a" /* default */]);

ecModelMock.eachSeriesByType = ecModelMock.eachRawSeriesByType = function (type) {
  seriesType = type;
};

ecModelMock.eachComponent = function (cond) {
  if (cond.mainType === 'series' && cond.subType) {
    seriesType = cond.subType;
  }
};

function mockMethods(target, Clz) {
  /* eslint-disable */
  for (var name_1 in Clz.prototype) {
    // Do not use hasOwnProperty
    target[name_1] = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["noop"];
  }
  /* eslint-enable */

}

/* harmony default export */ __webpack_exports__["a"] = (Scheduler);

/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_Eventful_js__ = __webpack_require__(90);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

;
var lifecycle = new __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_Eventful_js__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = (lifecycle);

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GraphNode */
/* unused harmony export GraphEdge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
 // id may be function name of Object, add a prefix to avoid this problem.

function generateNodeKey(id) {
  return '_EC_' + id;
}

var Graph =
/** @class */
function () {
  function Graph(directed) {
    this.type = 'graph';
    this.nodes = [];
    this.edges = [];
    this._nodesMap = {};
    /**
     * @type {Object.<string, module:echarts/data/Graph.Edge>}
     * @private
     */

    this._edgesMap = {};
    this._directed = directed || false;
  }
  /**
   * If is directed graph
   */


  Graph.prototype.isDirected = function () {
    return this._directed;
  };

  ;
  /**
   * Add a new node
   */

  Graph.prototype.addNode = function (id, dataIndex) {
    id = id == null ? '' + dataIndex : '' + id;
    var nodesMap = this._nodesMap;

    if (nodesMap[generateNodeKey(id)]) {
      if (true) {
        console.error('Graph nodes have duplicate name or id');
      }

      return;
    }

    var node = new GraphNode(id, dataIndex);
    node.hostGraph = this;
    this.nodes.push(node);
    nodesMap[generateNodeKey(id)] = node;
    return node;
  };

  ;
  /**
   * Get node by data index
   */

  Graph.prototype.getNodeByIndex = function (dataIndex) {
    var rawIdx = this.data.getRawIndex(dataIndex);
    return this.nodes[rawIdx];
  };

  ;
  /**
   * Get node by id
   */

  Graph.prototype.getNodeById = function (id) {
    return this._nodesMap[generateNodeKey(id)];
  };

  ;
  /**
   * Add a new edge
   */

  Graph.prototype.addEdge = function (n1, n2, dataIndex) {
    var nodesMap = this._nodesMap;
    var edgesMap = this._edgesMap; // PNEDING

    if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isNumber"](n1)) {
      n1 = this.nodes[n1];
    }

    if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isNumber"](n2)) {
      n2 = this.nodes[n2];
    }

    if (!(n1 instanceof GraphNode)) {
      n1 = nodesMap[generateNodeKey(n1)];
    }

    if (!(n2 instanceof GraphNode)) {
      n2 = nodesMap[generateNodeKey(n2)];
    }

    if (!n1 || !n2) {
      return;
    }

    var key = n1.id + '-' + n2.id;
    var edge = new GraphEdge(n1, n2, dataIndex);
    edge.hostGraph = this;

    if (this._directed) {
      n1.outEdges.push(edge);
      n2.inEdges.push(edge);
    }

    n1.edges.push(edge);

    if (n1 !== n2) {
      n2.edges.push(edge);
    }

    this.edges.push(edge);
    edgesMap[key] = edge;
    return edge;
  };

  ;
  /**
   * Get edge by data index
   */

  Graph.prototype.getEdgeByIndex = function (dataIndex) {
    var rawIdx = this.edgeData.getRawIndex(dataIndex);
    return this.edges[rawIdx];
  };

  ;
  /**
   * Get edge by two linked nodes
   */

  Graph.prototype.getEdge = function (n1, n2) {
    if (n1 instanceof GraphNode) {
      n1 = n1.id;
    }

    if (n2 instanceof GraphNode) {
      n2 = n2.id;
    }

    var edgesMap = this._edgesMap;

    if (this._directed) {
      return edgesMap[n1 + '-' + n2];
    } else {
      return edgesMap[n1 + '-' + n2] || edgesMap[n2 + '-' + n1];
    }
  };

  ;
  /**
   * Iterate all nodes
   */

  Graph.prototype.eachNode = function (cb, context) {
    var nodes = this.nodes;
    var len = nodes.length;

    for (var i = 0; i < len; i++) {
      if (nodes[i].dataIndex >= 0) {
        cb.call(context, nodes[i], i);
      }
    }
  };

  ;
  /**
   * Iterate all edges
   */

  Graph.prototype.eachEdge = function (cb, context) {
    var edges = this.edges;
    var len = edges.length;

    for (var i = 0; i < len; i++) {
      if (edges[i].dataIndex >= 0 && edges[i].node1.dataIndex >= 0 && edges[i].node2.dataIndex >= 0) {
        cb.call(context, edges[i], i);
      }
    }
  };

  ;
  /**
   * Breadth first traverse
   * Return true to stop traversing
   */

  Graph.prototype.breadthFirstTraverse = function (cb, startNode, direction, context) {
    if (!(startNode instanceof GraphNode)) {
      startNode = this._nodesMap[generateNodeKey(startNode)];
    }

    if (!startNode) {
      return;
    }

    var edgeType = direction === 'out' ? 'outEdges' : direction === 'in' ? 'inEdges' : 'edges';

    for (var i = 0; i < this.nodes.length; i++) {
      this.nodes[i].__visited = false;
    }

    if (cb.call(context, startNode, null)) {
      return;
    }

    var queue = [startNode];

    while (queue.length) {
      var currentNode = queue.shift();
      var edges = currentNode[edgeType];

      for (var i = 0; i < edges.length; i++) {
        var e = edges[i];
        var otherNode = e.node1 === currentNode ? e.node2 : e.node1;

        if (!otherNode.__visited) {
          if (cb.call(context, otherNode, currentNode)) {
            // Stop traversing
            return;
          }

          queue.push(otherNode);
          otherNode.__visited = true;
        }
      }
    }
  };

  ; // TODO
  // depthFirstTraverse(
  //     cb, startNode, direction, context
  // ) {
  // };
  // Filter update

  Graph.prototype.update = function () {
    var data = this.data;
    var edgeData = this.edgeData;
    var nodes = this.nodes;
    var edges = this.edges;

    for (var i = 0, len = nodes.length; i < len; i++) {
      nodes[i].dataIndex = -1;
    }

    for (var i = 0, len = data.count(); i < len; i++) {
      nodes[data.getRawIndex(i)].dataIndex = i;
    }

    edgeData.filterSelf(function (idx) {
      var edge = edges[edgeData.getRawIndex(idx)];
      return edge.node1.dataIndex >= 0 && edge.node2.dataIndex >= 0;
    }); // Update edge

    for (var i = 0, len = edges.length; i < len; i++) {
      edges[i].dataIndex = -1;
    }

    for (var i = 0, len = edgeData.count(); i < len; i++) {
      edges[edgeData.getRawIndex(i)].dataIndex = i;
    }
  };

  ;
  /**
   * @return {module:echarts/data/Graph}
   */

  Graph.prototype.clone = function () {
    var graph = new Graph(this._directed);
    var nodes = this.nodes;
    var edges = this.edges;

    for (var i = 0; i < nodes.length; i++) {
      graph.addNode(nodes[i].id, nodes[i].dataIndex);
    }

    for (var i = 0; i < edges.length; i++) {
      var e = edges[i];
      graph.addEdge(e.node1.id, e.node2.id, e.dataIndex);
    }

    return graph;
  };

  ;
  return Graph;
}();

var GraphNode =
/** @class */
function () {
  function GraphNode(id, dataIndex) {
    this.inEdges = [];
    this.outEdges = [];
    this.edges = [];
    this.dataIndex = -1;
    this.id = id == null ? '' : id;
    this.dataIndex = dataIndex == null ? -1 : dataIndex;
  }
  /**
   * @return {number}
   */


  GraphNode.prototype.degree = function () {
    return this.edges.length;
  };
  /**
   * @return {number}
   */


  GraphNode.prototype.inDegree = function () {
    return this.inEdges.length;
  };
  /**
  * @return {number}
  */


  GraphNode.prototype.outDegree = function () {
    return this.outEdges.length;
  };

  GraphNode.prototype.getModel = function (path) {
    if (this.dataIndex < 0) {
      return;
    }

    var graph = this.hostGraph;
    var itemModel = graph.data.getItemModel(this.dataIndex);
    return itemModel.getModel(path);
  };

  GraphNode.prototype.getAdjacentDataIndices = function () {
    var dataIndices = {
      edge: [],
      node: []
    };

    for (var i = 0; i < this.edges.length; i++) {
      var adjacentEdge = this.edges[i];

      if (adjacentEdge.dataIndex < 0) {
        continue;
      }

      dataIndices.edge.push(adjacentEdge.dataIndex);
      dataIndices.node.push(adjacentEdge.node1.dataIndex, adjacentEdge.node2.dataIndex);
    }

    return dataIndices;
  };

  return GraphNode;
}();

var GraphEdge =
/** @class */
function () {
  function GraphEdge(n1, n2, dataIndex) {
    this.dataIndex = -1;
    this.node1 = n1;
    this.node2 = n2;
    this.dataIndex = dataIndex == null ? -1 : dataIndex;
  } // eslint-disable-next-line @typescript-eslint/no-unused-vars


  GraphEdge.prototype.getModel = function (path) {
    if (this.dataIndex < 0) {
      return;
    }

    var graph = this.hostGraph;
    var itemModel = graph.edgeData.getItemModel(this.dataIndex);
    return itemModel.getModel(path);
  };

  GraphEdge.prototype.getAdjacentDataIndices = function () {
    return {
      edge: [this.dataIndex],
      node: [this.node1.dataIndex, this.node2.dataIndex]
    };
  };

  return GraphEdge;
}();

function createGraphDataProxyMixin(hostName, dataName) {
  return {
    /**
     * @param Default 'value'. can be 'a', 'b', 'c', 'd', 'e'.
     */
    getValue: function (dimension) {
      var data = this[hostName][dataName];
      return data.getStore().get(data.getDimensionIndex(dimension || 'value'), this.dataIndex);
    },
    // TODO: TYPE stricter type.
    setVisual: function (key, value) {
      this.dataIndex >= 0 && this[hostName][dataName].setItemVisual(this.dataIndex, key, value);
    },
    getVisual: function (key) {
      return this[hostName][dataName].getItemVisual(this.dataIndex, key);
    },
    setLayout: function (layout, merge) {
      this.dataIndex >= 0 && this[hostName][dataName].setItemLayout(this.dataIndex, layout, merge);
    },
    getLayout: function () {
      return this[hostName][dataName].getItemLayout(this.dataIndex);
    },
    getGraphicEl: function () {
      return this[hostName][dataName].getItemGraphicEl(this.dataIndex);
    },
    getRawIndex: function () {
      return this[hostName][dataName].getRawIndex(this.dataIndex);
    }
  };
}

;
;
;
__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["mixin"](GraphNode, createGraphDataProxyMixin('hostGraph', 'data'));
__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["mixin"](GraphEdge, createGraphDataProxyMixin('hostGraph', 'edgeData'));
/* harmony default export */ __webpack_exports__["a"] = (Graph);


/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["z"] = extendComponentModel;
/* harmony export (immutable) */ __webpack_exports__["A"] = extendComponentView;
/* harmony export (immutable) */ __webpack_exports__["B"] = extendSeriesModel;
/* harmony export (immutable) */ __webpack_exports__["C"] = extendChartView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_Component_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_Component_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_Series_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_Chart_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_SeriesData_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zrender_lib_zrender_js__ = __webpack_require__(364);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5_zrender_lib_zrender_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_matrix_js__ = __webpack_require__(43);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_matrix_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_vector_js__ = __webpack_require__(23);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7_zrender_lib_core_vector_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8_zrender_lib_core_util_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_zrender_lib_tool_color_js__ = __webpack_require__(58);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_9_zrender_lib_tool_color_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_throttle_js__ = __webpack_require__(100);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__util_throttle_js__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_helper_js__ = __webpack_require__(1332);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_11__api_helper_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__extension_js__ = __webpack_require__(41);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_12__extension_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_zrender_lib_core_platform_js__ = __webpack_require__(67);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_13_zrender_lib_core_platform_js__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__coord_geo_parseGeoJson_js__ = __webpack_require__(329);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_14__coord_geo_parseGeoJson_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_14__coord_geo_parseGeoJson_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api_number_js__ = __webpack_require__(1333);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_15__api_number_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__api_time_js__ = __webpack_require__(1334);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_16__api_time_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__api_graphic_js__ = __webpack_require__(1331);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_17__api_graphic_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api_format_js__ = __webpack_require__(1330);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_18__api_format_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__api_util_js__ = __webpack_require__(1335);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_19__api_util_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_zrender_lib_core_env_js__ = __webpack_require__(35);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_20_zrender_lib_core_env_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_4__data_SeriesData_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__model_Model_js__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_21__model_Model_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__coord_Axis_js__ = __webpack_require__(112);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_22__coord_Axis_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_0__model_Component_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_1__view_Component_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_2__model_Series_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_3__view_Chart_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_zrender_lib_canvas_graphic_js__ = __webpack_require__(253);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_23_zrender_lib_canvas_graphic_js__["a"]; });

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// These APIs are for more advanced usages
// For example extend charts and components, creating graphic elements, formatting.



















 //////////////// Helper Methods /////////////////////













 //////////////// Export for Exension Usage ////////////////
// export {SeriesData};

 // TODO: Compatitable with exists echarts-gl code



 // Only for GL

 //////////////// Deprecated Extension Methods ////////////////
// Should use `ComponentModel.extend` or `class XXXX extend ComponentModel` to create class.
// Then use `registerComponentModel` in `install` parameter when `use` this extension. For example:
// class Bar3DModel extends ComponentModel {}
// export function install(registers) { regsiters.registerComponentModel(Bar3DModel); }
// echarts.use(install);

function extendComponentModel(proto) {
  var Model = __WEBPACK_IMPORTED_MODULE_0__model_Component_js__["a" /* default */].extend(proto);
  __WEBPACK_IMPORTED_MODULE_0__model_Component_js__["a" /* default */].registerClass(Model);
  return Model;
}
function extendComponentView(proto) {
  var View = __WEBPACK_IMPORTED_MODULE_1__view_Component_js__["a" /* default */].extend(proto);
  __WEBPACK_IMPORTED_MODULE_1__view_Component_js__["a" /* default */].registerClass(View);
  return View;
}
function extendSeriesModel(proto) {
  var Model = __WEBPACK_IMPORTED_MODULE_2__model_Series_js__["b" /* default */].extend(proto);
  __WEBPACK_IMPORTED_MODULE_2__model_Series_js__["b" /* default */].registerClass(Model);
  return Model;
}
function extendChartView(proto) {
  var View = __WEBPACK_IMPORTED_MODULE_3__view_Chart_js__["a" /* default */].extend(proto);
  __WEBPACK_IMPORTED_MODULE_3__view_Chart_js__["a" /* default */].registerClass(View);
  return View;
}

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_format_js__ = __webpack_require__(42);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "addCommas", function() { return __WEBPACK_IMPORTED_MODULE_0__util_format_js__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "toCamelCase", function() { return __WEBPACK_IMPORTED_MODULE_0__util_format_js__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "normalizeCssArray", function() { return __WEBPACK_IMPORTED_MODULE_0__util_format_js__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "encodeHTML", function() { return __WEBPACK_IMPORTED_MODULE_0__util_format_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatTpl", function() { return __WEBPACK_IMPORTED_MODULE_0__util_format_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getTooltipMarker", function() { return __WEBPACK_IMPORTED_MODULE_0__util_format_js__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatTime", function() { return __WEBPACK_IMPORTED_MODULE_0__util_format_js__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "capitalFirst", function() { return __WEBPACK_IMPORTED_MODULE_0__util_format_js__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "truncateText", function() { return __WEBPACK_IMPORTED_MODULE_0__util_format_js__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getTextRect", function() { return __WEBPACK_IMPORTED_MODULE_0__util_format_js__["n"]; });

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__ = __webpack_require__(4);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "extendShape", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["extendShape"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "extendPath", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["extendPath"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "makePath", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["makePath"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "makeImage", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["makeImage"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mergePath", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["mergePath"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "resizePath", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["resizePath"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["createIcon"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "updateProps", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["updateProps"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "initProps", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["initProps"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getTransform", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["getTransform"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "clipPointsByRect", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["clipPointsByRect"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "clipRectByRect", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["clipRectByRect"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "registerShape", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["registerShape"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getShapeClass", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["getShapeClass"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Group", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Group"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Image", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Image"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Text", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Text"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Circle", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Circle"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ellipse", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Ellipse"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Sector", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Sector"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ring", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Ring"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Polygon", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Polygon"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Polyline", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Polyline"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Rect", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Rect"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Line", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Line"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BezierCurve", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["BezierCurve"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Arc", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Arc"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IncrementalDisplayable", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["IncrementalDisplayable"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CompoundPath", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["CompoundPath"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LinearGradient", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["LinearGradient"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RadialGradient", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["RadialGradient"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BoundingRect", function() { return __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["BoundingRect"]; });

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["createList"] = createList;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dataStack", function() { return dataStack; });
/* harmony export (immutable) */ __webpack_exports__["createScale"] = createScale;
/* harmony export (immutable) */ __webpack_exports__["mixinAxisModelCommonMethods"] = mixinAxisModelCommonMethods;
/* harmony export (immutable) */ __webpack_exports__["createTextStyle"] = createTextStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart_helper_createSeriesData_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__coord_axisHelper_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__coord_axisModelCommonMixin_js__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_Model_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_layout_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_helper_dataStackHelper_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__label_labelStyle_js__ = __webpack_require__(15);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getLayoutRect", function() { return __WEBPACK_IMPORTED_MODULE_5__util_layout_js__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_helper_createDimensions_js__ = __webpack_require__(158);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createDimensions", function() { return __WEBPACK_IMPORTED_MODULE_9__data_helper_createDimensions_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_symbol_js__ = __webpack_require__(37);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createSymbol", function() { return __WEBPACK_IMPORTED_MODULE_10__util_symbol_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getECData", function() { return __WEBPACK_IMPORTED_MODULE_7__util_innerStore_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_states_js__ = __webpack_require__(12);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "enableHoverEmphasis", function() { return __WEBPACK_IMPORTED_MODULE_11__util_states_js__["d"]; });

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * This module exposes helper functions for developing extensions.
 */

 // import createGraphFromNodeEdge from './chart/helper/createGraphFromNodeEdge.js';








/**
 * Create a muti dimension List structure from seriesModel.
 */

function createList(seriesModel) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__chart_helper_createSeriesData_js__["a" /* default */])(null, seriesModel);
} // export function createGraph(seriesModel) {
//     let nodes = seriesModel.get('data');
//     let links = seriesModel.get('links');
//     return createGraphFromNodeEdge(nodes, links, seriesModel);
// }



var dataStack = {
  isDimensionStacked: __WEBPACK_IMPORTED_MODULE_6__data_helper_dataStackHelper_js__["b" /* isDimensionStacked */],
  enableDataStack: __WEBPACK_IMPORTED_MODULE_6__data_helper_dataStackHelper_js__["c" /* enableDataStack */],
  getStackedDimension: __WEBPACK_IMPORTED_MODULE_6__data_helper_dataStackHelper_js__["a" /* getStackedDimension */]
};
/**
 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
 * @param {string} symbolDesc
 * @param {number} x
 * @param {number} y
 * @param {number} w
 * @param {number} h
 * @param {string} color
 */


/**
 * Create scale
 * @param {Array.<number>} dataExtent
 * @param {Object|module:echarts/Model} option If `optoin.type`
 *        is secified, it can only be `'value'` currently.
 */

function createScale(dataExtent, option) {
  var axisModel = option;

  if (!(option instanceof __WEBPACK_IMPORTED_MODULE_4__model_Model_js__["a" /* default */])) {
    axisModel = new __WEBPACK_IMPORTED_MODULE_4__model_Model_js__["a" /* default */](option); // FIXME
    // Currently AxisModelCommonMixin has nothing to do with the
    // the requirements of `axisHelper.createScaleByModel`. For
    // example the method `getCategories` and `getOrdinalMeta`
    // are required for `'category'` axis, and ecModel are required
    // for `'time'` axis. But occationally echarts-gl happened
    // to only use `'value'` axis.
    // zrUtil.mixin(axisModel, AxisModelCommonMixin);
  }

  var scale = __WEBPACK_IMPORTED_MODULE_2__coord_axisHelper_js__["f" /* createScaleByModel */](axisModel);
  scale.setExtent(dataExtent[0], dataExtent[1]);
  __WEBPACK_IMPORTED_MODULE_2__coord_axisHelper_js__["g" /* niceScaleExtent */](scale, axisModel);
  return scale;
}
/**
 * Mixin common methods to axis model,
 *
 * Inlcude methods
 * `getFormattedLabels() => Array.<string>`
 * `getCategories() => Array.<string>`
 * `getMin(origin: boolean) => number`
 * `getMax(origin: boolean) => number`
 * `getNeedCrossZero() => boolean`
 */

function mixinAxisModelCommonMethods(Model) {
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["mixin"](Model, __WEBPACK_IMPORTED_MODULE_3__coord_axisModelCommonMixin_js__["a" /* AxisModelCommonMixin */]);
}


function createTextStyle(textStyleModel, opts) {
  opts = opts || {};
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__label_labelStyle_js__["d" /* createTextStyle */])(textStyleModel, null, null, opts.state !== 'normal');
}

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_number_js__ = __webpack_require__(8);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "linearMap", function() { return __WEBPACK_IMPORTED_MODULE_0__util_number_js__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "round", function() { return __WEBPACK_IMPORTED_MODULE_0__util_number_js__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "asc", function() { return __WEBPACK_IMPORTED_MODULE_0__util_number_js__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getPrecision", function() { return __WEBPACK_IMPORTED_MODULE_0__util_number_js__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getPrecisionSafe", function() { return __WEBPACK_IMPORTED_MODULE_0__util_number_js__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getPixelPrecision", function() { return __WEBPACK_IMPORTED_MODULE_0__util_number_js__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getPercentWithPrecision", function() { return __WEBPACK_IMPORTED_MODULE_0__util_number_js__["v"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_SAFE_INTEGER", function() { return __WEBPACK_IMPORTED_MODULE_0__util_number_js__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "remRadian", function() { return __WEBPACK_IMPORTED_MODULE_0__util_number_js__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isRadianAroundZero", function() { return __WEBPACK_IMPORTED_MODULE_0__util_number_js__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parseDate", function() { return __WEBPACK_IMPORTED_MODULE_0__util_number_js__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "quantity", function() { return __WEBPACK_IMPORTED_MODULE_0__util_number_js__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "quantityExponent", function() { return __WEBPACK_IMPORTED_MODULE_0__util_number_js__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "nice", function() { return __WEBPACK_IMPORTED_MODULE_0__util_number_js__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "quantile", function() { return __WEBPACK_IMPORTED_MODULE_0__util_number_js__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reformIntervals", function() { return __WEBPACK_IMPORTED_MODULE_0__util_number_js__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isNumeric", function() { return __WEBPACK_IMPORTED_MODULE_0__util_number_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "numericToNumber", function() { return __WEBPACK_IMPORTED_MODULE_0__util_number_js__["g"]; });

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_number_js__ = __webpack_require__(8);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parse", function() { return __WEBPACK_IMPORTED_MODULE_0__util_number_js__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_time_js__ = __webpack_require__(242);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "format", function() { return __WEBPACK_IMPORTED_MODULE_1__util_time_js__["a"]; });

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "map", function() { return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "each", function() { return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "indexOf", function() { return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["indexOf"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "inherits", function() { return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["inherits"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reduce", function() { return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["reduce"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["filter"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bind", function() { return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["bind"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curry", function() { return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["curry"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isArray", function() { return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isString", function() { return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isFunction", function() { return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "extend", function() { return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaults", function() { return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["defaults"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "clone", function() { return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["clone"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["merge"]; });

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chart_line_install_js__ = __webpack_require__(1138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__chart_line_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart_bar_install_js__ = __webpack_require__(1087);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__chart_bar_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chart_pie_install_js__ = __webpack_require__(1155);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__chart_pie_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chart_scatter_install_js__ = __webpack_require__(1169);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__chart_scatter_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chart_radar_install_js__ = __webpack_require__(1160);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__chart_radar_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chart_map_install_js__ = __webpack_require__(1146);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__chart_map_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chart_tree_install_js__ = __webpack_require__(1182);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__chart_tree_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chart_treemap_install_js__ = __webpack_require__(1190);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__chart_treemap_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chart_graph_install_js__ = __webpack_require__(1125);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__chart_graph_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__chart_gauge_install_js__ = __webpack_require__(1114);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__chart_gauge_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__chart_funnel_install_js__ = __webpack_require__(1110);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__chart_funnel_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__chart_parallel_install_js__ = __webpack_require__(1151);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__chart_parallel_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__chart_sankey_install_js__ = __webpack_require__(1164);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_12__chart_sankey_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__chart_boxplot_install_js__ = __webpack_require__(1094);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_13__chart_boxplot_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__chart_candlestick_install_js__ = __webpack_require__(1100);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_14__chart_candlestick_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__chart_effectScatter_install_js__ = __webpack_require__(1106);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_15__chart_effectScatter_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__chart_lines_install_js__ = __webpack_require__(1142);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_16__chart_lines_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__chart_heatmap_install_js__ = __webpack_require__(1130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_17__chart_heatmap_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__chart_bar_installPictorialBar_js__ = __webpack_require__(1088);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_18__chart_bar_installPictorialBar_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__chart_themeRiver_install_js__ = __webpack_require__(1178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_19__chart_themeRiver_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__chart_sunburst_install_js__ = __webpack_require__(1173);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_20__chart_sunburst_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__chart_custom_install_js__ = __webpack_require__(1103);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_21__chart_custom_install_js__["a"]; });

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// In somehow. If we export like
// export * as LineChart './chart/line/install'
// The exported code will be transformed to
// import * as LineChart_1 './chart/line/install'; export {LineChart_1 as LineChart};
// Treeshaking in webpack will not work even if we configured sideEffects to false in package.json























/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_grid_installSimple_js__ = __webpack_require__(320);
/* unused harmony reexport GridSimpleComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_grid_install_js__ = __webpack_require__(1231);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__component_grid_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_polar_install_js__ = __webpack_require__(1248);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__component_polar_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_radar_install_js__ = __webpack_require__(475);
/* unused harmony reexport RadarComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component_geo_install_js__ = __webpack_require__(465);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__component_geo_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_singleAxis_install_js__ = __webpack_require__(1250);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__component_singleAxis_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_parallel_install_js__ = __webpack_require__(474);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__component_parallel_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_calendar_install_js__ = __webpack_require__(1214);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__component_calendar_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_graphic_install_js__ = __webpack_require__(1230);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_8__component_graphic_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component_toolbox_install_js__ = __webpack_require__(1268);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_9__component_toolbox_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component_tooltip_install_js__ = __webpack_require__(1273);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_10__component_tooltip_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__component_axisPointer_install_js__ = __webpack_require__(191);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_11__component_axisPointer_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component_brush_install_js__ = __webpack_require__(1210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_12__component_brush_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__component_title_install_js__ = __webpack_require__(1259);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_13__component_title_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__component_timeline_install_js__ = __webpack_require__(1256);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_14__component_timeline_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__component_marker_installMarkPoint_js__ = __webpack_require__(1246);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_15__component_marker_installMarkPoint_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__component_marker_installMarkLine_js__ = __webpack_require__(1245);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_16__component_marker_installMarkLine_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__component_marker_installMarkArea_js__ = __webpack_require__(1244);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_17__component_marker_installMarkArea_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__component_legend_install_js__ = __webpack_require__(1234);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_18__component_legend_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__component_legend_installLegendScroll_js__ = __webpack_require__(473);
/* unused harmony reexport LegendScrollComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__component_legend_installLegendPlain_js__ = __webpack_require__(323);
/* unused harmony reexport LegendPlainComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__component_dataZoom_install_js__ = __webpack_require__(1224);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_21__component_dataZoom_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__component_dataZoom_installDataZoomInside_js__ = __webpack_require__(462);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_22__component_dataZoom_installDataZoomInside_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__component_dataZoom_installDataZoomSlider_js__ = __webpack_require__(463);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_23__component_dataZoom_installDataZoomSlider_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__component_visualMap_install_js__ = __webpack_require__(1281);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_24__component_visualMap_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__component_visualMap_installVisualMapContinuous_js__ = __webpack_require__(482);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_25__component_visualMap_installVisualMapContinuous_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__component_visualMap_installVisualMapPiecewise_js__ = __webpack_require__(483);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_26__component_visualMap_installVisualMapPiecewise_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__component_aria_install_js__ = __webpack_require__(1194);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_27__component_aria_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__component_transform_install_js__ = __webpack_require__(1275);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_28__component_transform_install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__component_dataset_install_js__ = __webpack_require__(1226);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_29__component_dataset_install_js__["a"]; });

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/































/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__ = __webpack_require__(157);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["A"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_0__core_echarts_js__["B"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_js__ = __webpack_require__(1329);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["A"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["B"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_1__api_js__["C"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extension_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__label_installLabelLayout_js__ = __webpack_require__(496);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Core API from echarts/src/echarts


 // Import label layout by default.
// TODO will be treeshaked.


__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__extension_js__["a" /* use */])(__WEBPACK_IMPORTED_MODULE_3__label_installLabelLayout_js__["a" /* installLabelLayout */]);

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animation_universalTransition_js__ = __webpack_require__(1082);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__animation_universalTransition_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__label_installLabelLayout_js__ = __webpack_require__(496);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__label_installLabelLayout_js__["a"]; });

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Module that exports complex but fancy features.



/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__renderer_installSVGRenderer_js__ = __webpack_require__(1358);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__renderer_installSVGRenderer_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__renderer_installCanvasRenderer_js__ = __webpack_require__(1357);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__renderer_installCanvasRenderer_js__["a"]; });

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Language: English.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  time: {
    month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthAbbr: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    dayOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayOfWeekAbbr: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  },
  legend: {
    selector: {
      all: 'All',
      inverse: 'Inv'
    }
  },
  toolbox: {
    brush: {
      title: {
        rect: 'Box Select',
        polygon: 'Lasso Select',
        lineX: 'Horizontally Select',
        lineY: 'Vertically Select',
        keep: 'Keep Selections',
        clear: 'Clear Selections'
      }
    },
    dataView: {
      title: 'Data View',
      lang: ['Data View', 'Close', 'Refresh']
    },
    dataZoom: {
      title: {
        zoom: 'Zoom',
        back: 'Zoom Reset'
      }
    },
    magicType: {
      title: {
        line: 'Switch to Line Chart',
        bar: 'Switch to Bar Chart',
        stack: 'Stack',
        tiled: 'Tile'
      }
    },
    restore: {
      title: 'Restore'
    },
    saveAsImage: {
      title: 'Save as Image',
      lang: ['Right Click to Save Image']
    }
  },
  series: {
    typeNames: {
      pie: 'Pie chart',
      bar: 'Bar chart',
      line: 'Line chart',
      scatter: 'Scatter plot',
      effectScatter: 'Ripple scatter plot',
      radar: 'Radar chart',
      tree: 'Tree',
      treemap: 'Treemap',
      boxplot: 'Boxplot',
      candlestick: 'Candlestick',
      k: 'K line chart',
      heatmap: 'Heat map',
      map: 'Map',
      parallel: 'Parallel coordinate map',
      lines: 'Line graph',
      graph: 'Relationship graph',
      sankey: 'Sankey diagram',
      funnel: 'Funnel chart',
      gauge: 'Gauge',
      pictorialBar: 'Pictorial bar',
      themeRiver: 'Theme River Map',
      sunburst: 'Sunburst'
    }
  },
  aria: {
    general: {
      withTitle: 'This is a chart about "{title}"',
      withoutTitle: 'This is a chart'
    },
    series: {
      single: {
        prefix: '',
        withName: ' with type {seriesType} named {seriesName}.',
        withoutName: ' with type {seriesType}.'
      },
      multiple: {
        prefix: '. It consists of {seriesCount} series count.',
        withName: ' The {seriesId} series is a {seriesType} representing {seriesName}.',
        withoutName: ' The {seriesId} series is a {seriesType}.',
        separator: {
          middle: '',
          end: ''
        }
      }
    },
    data: {
      allData: 'The data is as follows: ',
      partialData: 'The first {displayCnt} items are: ',
      withName: 'the data for {name} is {value}',
      withoutName: '{value}',
      separator: {
        middle: ', ',
        end: '. '
      }
    }
  }
});

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  time: {
    month: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
    monthAbbr: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    dayOfWeek: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
    dayOfWeekAbbr: ['日', '一', '二', '三', '四', '五', '六']
  },
  legend: {
    selector: {
      all: '全选',
      inverse: '反选'
    }
  },
  toolbox: {
    brush: {
      title: {
        rect: '矩形选择',
        polygon: '圈选',
        lineX: '横向选择',
        lineY: '纵向选择',
        keep: '保持选择',
        clear: '清除选择'
      }
    },
    dataView: {
      title: '数据视图',
      lang: ['数据视图', '关闭', '刷新']
    },
    dataZoom: {
      title: {
        zoom: '区域缩放',
        back: '区域缩放还原'
      }
    },
    magicType: {
      title: {
        line: '切换为折线图',
        bar: '切换为柱状图',
        stack: '切换为堆叠',
        tiled: '切换为平铺'
      }
    },
    restore: {
      title: '还原'
    },
    saveAsImage: {
      title: '保存为图片',
      lang: ['右键另存为图片']
    }
  },
  series: {
    typeNames: {
      pie: '饼图',
      bar: '柱状图',
      line: '折线图',
      scatter: '散点图',
      effectScatter: '涟漪散点图',
      radar: '雷达图',
      tree: '树图',
      treemap: '矩形树图',
      boxplot: '箱型图',
      candlestick: 'K线图',
      k: 'K线图',
      heatmap: '热力图',
      map: '地图',
      parallel: '平行坐标图',
      lines: '线图',
      graph: '关系图',
      sankey: '桑基图',
      funnel: '漏斗图',
      gauge: '仪表盘图',
      pictorialBar: '象形柱图',
      themeRiver: '主题河流图',
      sunburst: '旭日图'
    }
  },
  aria: {
    general: {
      withTitle: '这是一个关于“{title}”的图表。',
      withoutTitle: '这是一个图表，'
    },
    series: {
      single: {
        prefix: '',
        withName: '图表类型是{seriesType}，表示{seriesName}。',
        withoutName: '图表类型是{seriesType}。'
      },
      multiple: {
        prefix: '它由{seriesCount}个图表系列组成。',
        withName: '第{seriesId}个系列是一个表示{seriesName}的{seriesType}，',
        withoutName: '第{seriesId}个系列是一个{seriesType}，',
        separator: {
          middle: '；',
          end: '。'
        }
      }
    },
    data: {
      allData: '其数据是——',
      partialData: '其中，前{displayCnt}项是——',
      withName: '{name}的数据是{value}',
      withoutName: '{value}',
      separator: {
        middle: '，',
        end: ''
      }
    }
  }
});

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_innerStore_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_Transformable_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__labelGuideHelper_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__labelLayoutHelper_js__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__labelStyle_js__ = __webpack_require__(15);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// TODO: move labels out of viewport.










function cloneArr(points) {
  if (points) {
    var newPoints = [];

    for (var i = 0; i < points.length; i++) {
      newPoints.push(points[i].slice());
    }

    return newPoints;
  }
}

function prepareLayoutCallbackParams(labelItem, hostEl) {
  var label = labelItem.label;
  var labelLine = hostEl && hostEl.getTextGuideLine();
  return {
    dataIndex: labelItem.dataIndex,
    dataType: labelItem.dataType,
    seriesIndex: labelItem.seriesModel.seriesIndex,
    text: labelItem.label.style.text,
    rect: labelItem.hostRect,
    labelRect: labelItem.rect,
    // x: labelAttr.x,
    // y: labelAttr.y,
    align: label.style.align,
    verticalAlign: label.style.verticalAlign,
    labelLinePoints: cloneArr(labelLine && labelLine.shape.points)
  };
}

var LABEL_OPTION_TO_STYLE_KEYS = ['align', 'verticalAlign', 'width', 'height', 'fontSize'];
var dummyTransformable = new __WEBPACK_IMPORTED_MODULE_3_zrender_lib_core_Transformable_js__["a" /* default */]();
var labelLayoutInnerStore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_model_js__["a" /* makeInner */])();
var labelLineAnimationStore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_model_js__["a" /* makeInner */])();

function extendWithKeys(target, source, keys) {
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];

    if (source[key] != null) {
      target[key] = source[key];
    }
  }
}

var LABEL_LAYOUT_PROPS = ['x', 'y', 'rotation'];

var LabelManager =
/** @class */
function () {
  function LabelManager() {
    this._labelList = [];
    this._chartViewList = [];
  }

  LabelManager.prototype.clearLabels = function () {
    this._labelList = [];
    this._chartViewList = [];
  };
  /**
   * Add label to manager
   */


  LabelManager.prototype._addLabel = function (dataIndex, dataType, seriesModel, label, layoutOption) {
    var labelStyle = label.style;
    var hostEl = label.__hostTarget;
    var textConfig = hostEl.textConfig || {}; // TODO: If label is in other state.

    var labelTransform = label.getComputedTransform();
    var labelRect = label.getBoundingRect().plain();
    __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["BoundingRect"].applyTransform(labelRect, labelRect, labelTransform);

    if (labelTransform) {
      dummyTransformable.setLocalTransform(labelTransform);
    } else {
      // Identity transform.
      dummyTransformable.x = dummyTransformable.y = dummyTransformable.rotation = dummyTransformable.originX = dummyTransformable.originY = 0;
      dummyTransformable.scaleX = dummyTransformable.scaleY = 1;
    }

    var host = label.__hostTarget;
    var hostRect;

    if (host) {
      hostRect = host.getBoundingRect().plain();
      var transform = host.getComputedTransform();
      __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["BoundingRect"].applyTransform(hostRect, hostRect, transform);
    }

    var labelGuide = hostRect && host.getTextGuideLine();

    this._labelList.push({
      label: label,
      labelLine: labelGuide,
      seriesModel: seriesModel,
      dataIndex: dataIndex,
      dataType: dataType,
      layoutOption: layoutOption,
      computedLayoutOption: null,
      rect: labelRect,
      hostRect: hostRect,
      // Label with lower priority will be hidden when overlapped
      // Use rect size as default priority
      priority: hostRect ? hostRect.width * hostRect.height : 0,
      // Save default label attributes.
      // For restore if developers want get back to default value in callback.
      defaultAttr: {
        ignore: label.ignore,
        labelGuideIgnore: labelGuide && labelGuide.ignore,
        x: dummyTransformable.x,
        y: dummyTransformable.y,
        scaleX: dummyTransformable.scaleX,
        scaleY: dummyTransformable.scaleY,
        rotation: dummyTransformable.rotation,
        style: {
          x: labelStyle.x,
          y: labelStyle.y,
          align: labelStyle.align,
          verticalAlign: labelStyle.verticalAlign,
          width: labelStyle.width,
          height: labelStyle.height,
          fontSize: labelStyle.fontSize
        },
        cursor: label.cursor,
        attachedPos: textConfig.position,
        attachedRot: textConfig.rotation
      }
    });
  };

  LabelManager.prototype.addLabelsOfSeries = function (chartView) {
    var _this = this;

    this._chartViewList.push(chartView);

    var seriesModel = chartView.__model;
    var layoutOption = seriesModel.get('labelLayout');
    /**
     * Ignore layouting if it's not specified anything.
     */

    if (!(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["isFunction"])(layoutOption) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["keys"])(layoutOption).length)) {
      return;
    }

    chartView.group.traverse(function (child) {
      if (child.ignore) {
        return true; // Stop traverse descendants.
      } // Only support label being hosted on graphic elements.


      var textEl = child.getTextContent();
      var ecData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_innerStore_js__["a" /* getECData */])(child); // Can only attach the text on the element with dataIndex

      if (textEl && !textEl.disableLabelLayout) {
        _this._addLabel(ecData.dataIndex, ecData.dataType, seriesModel, textEl, layoutOption);
      }
    });
  };

  LabelManager.prototype.updateLayoutConfig = function (api) {
    var width = api.getWidth();
    var height = api.getHeight();

    function createDragHandler(el, labelLineModel) {
      return function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__labelGuideHelper_js__["a" /* updateLabelLinePoints */])(el, labelLineModel);
      };
    }

    for (var i = 0; i < this._labelList.length; i++) {
      var labelItem = this._labelList[i];
      var label = labelItem.label;
      var hostEl = label.__hostTarget;
      var defaultLabelAttr = labelItem.defaultAttr;
      var layoutOption = void 0; // TODO A global layout option?

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["isFunction"])(labelItem.layoutOption)) {
        layoutOption = labelItem.layoutOption(prepareLayoutCallbackParams(labelItem, hostEl));
      } else {
        layoutOption = labelItem.layoutOption;
      }

      layoutOption = layoutOption || {};
      labelItem.computedLayoutOption = layoutOption;
      var degreeToRadian = Math.PI / 180; // TODO hostEl should always exists.
      // Or label should not have parent because the x, y is all in global space.

      if (hostEl) {
        hostEl.setTextConfig({
          // Force to set local false.
          local: false,
          // Ignore position and rotation config on the host el if x or y is changed.
          position: layoutOption.x != null || layoutOption.y != null ? null : defaultLabelAttr.attachedPos,
          // Ignore rotation config on the host el if rotation is changed.
          rotation: layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.attachedRot,
          offset: [layoutOption.dx || 0, layoutOption.dy || 0]
        });
      }

      var needsUpdateLabelLine = false;

      if (layoutOption.x != null) {
        // TODO width of chart view.
        label.x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_number_js__["a" /* parsePercent */])(layoutOption.x, width);
        label.setStyle('x', 0); // Ignore movement in style. TODO: origin.

        needsUpdateLabelLine = true;
      } else {
        label.x = defaultLabelAttr.x;
        label.setStyle('x', defaultLabelAttr.style.x);
      }

      if (layoutOption.y != null) {
        // TODO height of chart view.
        label.y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_number_js__["a" /* parsePercent */])(layoutOption.y, height);
        label.setStyle('y', 0); // Ignore movement in style.

        needsUpdateLabelLine = true;
      } else {
        label.y = defaultLabelAttr.y;
        label.setStyle('y', defaultLabelAttr.style.y);
      }

      if (layoutOption.labelLinePoints) {
        var guideLine = hostEl.getTextGuideLine();

        if (guideLine) {
          guideLine.setShape({
            points: layoutOption.labelLinePoints
          }); // Not update

          needsUpdateLabelLine = false;
        }
      }

      var labelLayoutStore = labelLayoutInnerStore(label);
      labelLayoutStore.needsUpdateLabelLine = needsUpdateLabelLine;
      label.rotation = layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.rotation;
      label.scaleX = defaultLabelAttr.scaleX;
      label.scaleY = defaultLabelAttr.scaleY;

      for (var k = 0; k < LABEL_OPTION_TO_STYLE_KEYS.length; k++) {
        var key = LABEL_OPTION_TO_STYLE_KEYS[k];
        label.setStyle(key, layoutOption[key] != null ? layoutOption[key] : defaultLabelAttr.style[key]);
      }

      if (layoutOption.draggable) {
        label.draggable = true;
        label.cursor = 'move';

        if (hostEl) {
          var hostModel = labelItem.seriesModel;

          if (labelItem.dataIndex != null) {
            var data = labelItem.seriesModel.getData(labelItem.dataType);
            hostModel = data.getItemModel(labelItem.dataIndex);
          }

          label.on('drag', createDragHandler(hostEl, hostModel.getModel('labelLine')));
        }
      } else {
        // TODO Other drag functions?
        label.off('drag');
        label.cursor = defaultLabelAttr.cursor;
      }
    }
  };

  LabelManager.prototype.layout = function (api) {
    var width = api.getWidth();
    var height = api.getHeight();
    var labelList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__labelLayoutHelper_js__["a" /* prepareLayoutList */])(this._labelList);
    var labelsNeedsAdjustOnX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["filter"])(labelList, function (item) {
      return item.layoutOption.moveOverlap === 'shiftX';
    });
    var labelsNeedsAdjustOnY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["filter"])(labelList, function (item) {
      return item.layoutOption.moveOverlap === 'shiftY';
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__labelLayoutHelper_js__["b" /* shiftLayoutOnX */])(labelsNeedsAdjustOnX, 0, width);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__labelLayoutHelper_js__["c" /* shiftLayoutOnY */])(labelsNeedsAdjustOnY, 0, height);
    var labelsNeedsHideOverlap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["filter"])(labelList, function (item) {
      return item.layoutOption.hideOverlap;
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__labelLayoutHelper_js__["d" /* hideOverlap */])(labelsNeedsHideOverlap);
  };
  /**
   * Process all labels. Not only labels with layoutOption.
   */


  LabelManager.prototype.processLabelsOverall = function () {
    var _this = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["each"])(this._chartViewList, function (chartView) {
      var seriesModel = chartView.__model;
      var ignoreLabelLineUpdate = chartView.ignoreLabelLineUpdate;
      var animationEnabled = seriesModel.isAnimationEnabled();
      chartView.group.traverse(function (child) {
        if (child.ignore && !child.forceLabelAnimation) {
          return true; // Stop traverse descendants.
        }

        var needsUpdateLabelLine = !ignoreLabelLineUpdate;
        var label = child.getTextContent();

        if (!needsUpdateLabelLine && label) {
          needsUpdateLabelLine = labelLayoutInnerStore(label).needsUpdateLabelLine;
        }

        if (needsUpdateLabelLine) {
          _this._updateLabelLine(child, seriesModel);
        }

        if (animationEnabled) {
          _this._animateLabels(child, seriesModel);
        }
      });
    });
  };

  LabelManager.prototype._updateLabelLine = function (el, seriesModel) {
    // Only support label being hosted on graphic elements.
    var textEl = el.getTextContent(); // Update label line style.

    var ecData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_innerStore_js__["a" /* getECData */])(el);
    var dataIndex = ecData.dataIndex; // Only support labelLine on the labels represent data.

    if (textEl && dataIndex != null) {
      var data = seriesModel.getData(ecData.dataType);
      var itemModel = data.getItemModel(dataIndex);
      var defaultStyle = {};
      var visualStyle = data.getItemVisual(dataIndex, 'style');
      var visualType = data.getVisual('drawType'); // Default to be same with main color

      defaultStyle.stroke = visualStyle[visualType];
      var labelLineModel = itemModel.getModel('labelLine');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__labelGuideHelper_js__["b" /* setLabelLineStyle */])(el, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__labelGuideHelper_js__["c" /* getLabelLineStatesModels */])(itemModel), defaultStyle);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__labelGuideHelper_js__["a" /* updateLabelLinePoints */])(el, labelLineModel);
    }
  };

  LabelManager.prototype._animateLabels = function (el, seriesModel) {
    var textEl = el.getTextContent();
    var guideLine = el.getTextGuideLine(); // Animate

    if (textEl // `forceLabelAnimation` has the highest priority
    && (el.forceLabelAnimation || !textEl.ignore && !textEl.invisible && !el.disableLabelAnimation && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["isElementRemoved"])(el))) {
      var layoutStore = labelLayoutInnerStore(textEl);
      var oldLayout = layoutStore.oldLayout;
      var ecData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_innerStore_js__["a" /* getECData */])(el);
      var dataIndex = ecData.dataIndex;
      var newProps = {
        x: textEl.x,
        y: textEl.y,
        rotation: textEl.rotation
      };
      var data = seriesModel.getData(ecData.dataType);

      if (!oldLayout) {
        textEl.attr(newProps); // Disable fade in animation if value animation is enabled.

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__labelStyle_js__["a" /* labelInner */])(textEl).valueAnimation) {
          var oldOpacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["retrieve2"])(textEl.style.opacity, 1); // Fade in animation

          textEl.style.opacity = 0;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["initProps"])(textEl, {
            style: {
              opacity: oldOpacity
            }
          }, seriesModel, dataIndex);
        }
      } else {
        textEl.attr(oldLayout); // Make sure the animation from is in the right status.

        var prevStates = el.prevStates;

        if (prevStates) {
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["indexOf"])(prevStates, 'select') >= 0) {
            textEl.attr(layoutStore.oldLayoutSelect);
          }

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_zrender_lib_core_util_js__["indexOf"])(prevStates, 'emphasis') >= 0) {
            textEl.attr(layoutStore.oldLayoutEmphasis);
          }
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["updateProps"])(textEl, newProps, seriesModel, dataIndex);
      }

      layoutStore.oldLayout = newProps;

      if (textEl.states.select) {
        var layoutSelect = layoutStore.oldLayoutSelect = {};
        extendWithKeys(layoutSelect, newProps, LABEL_LAYOUT_PROPS);
        extendWithKeys(layoutSelect, textEl.states.select, LABEL_LAYOUT_PROPS);
      }

      if (textEl.states.emphasis) {
        var layoutEmphasis = layoutStore.oldLayoutEmphasis = {};
        extendWithKeys(layoutEmphasis, newProps, LABEL_LAYOUT_PROPS);
        extendWithKeys(layoutEmphasis, textEl.states.emphasis, LABEL_LAYOUT_PROPS);
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__labelStyle_js__["b" /* animateLabelValue */])(textEl, dataIndex, data, seriesModel, seriesModel);
    }

    if (guideLine && !guideLine.ignore && !guideLine.invisible) {
      var layoutStore = labelLineAnimationStore(guideLine);
      var oldLayout = layoutStore.oldLayout;
      var newLayout = {
        points: guideLine.shape.points
      };

      if (!oldLayout) {
        guideLine.setShape(newLayout);
        guideLine.style.strokePercent = 0;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["initProps"])(guideLine, {
          style: {
            strokePercent: 1
          }
        }, seriesModel);
      } else {
        guideLine.attr({
          shape: oldLayout
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["updateProps"])(guideLine, {
          shape: newLayout
        }, seriesModel);
      }

      layoutStore.oldLayout = newLayout;
    }
  };

  return LabelManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (LabelManager);

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSectorCalculateTextPosition;
/* harmony export (immutable) */ __webpack_exports__["b"] = setSectorTextRotation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_contain_text_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


function createSectorCalculateTextPosition(positionMapping, opts) {
  opts = opts || {};
  var isRoundCap = opts.isRoundCap;
  return function (out, opts, boundingRect) {
    var textPosition = opts.position;

    if (!textPosition || textPosition instanceof Array) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_contain_text_js__["a" /* calculateTextPosition */])(out, opts, boundingRect);
    }

    var mappedSectorPosition = positionMapping(textPosition);
    var distance = opts.distance != null ? opts.distance : 5;
    var sector = this.shape;
    var cx = sector.cx;
    var cy = sector.cy;
    var r = sector.r;
    var r0 = sector.r0;
    var middleR = (r + r0) / 2;
    var startAngle = sector.startAngle;
    var endAngle = sector.endAngle;
    var middleAngle = (startAngle + endAngle) / 2;
    var extraDist = isRoundCap ? Math.abs(r - r0) / 2 : 0;
    var mathCos = Math.cos;
    var mathSin = Math.sin; // base position: top-left

    var x = cx + r * mathCos(startAngle);
    var y = cy + r * mathSin(startAngle);
    var textAlign = 'left';
    var textVerticalAlign = 'top';

    switch (mappedSectorPosition) {
      case 'startArc':
        x = cx + (r0 - distance) * mathCos(middleAngle);
        y = cy + (r0 - distance) * mathSin(middleAngle);
        textAlign = 'center';
        textVerticalAlign = 'top';
        break;

      case 'insideStartArc':
        x = cx + (r0 + distance) * mathCos(middleAngle);
        y = cy + (r0 + distance) * mathSin(middleAngle);
        textAlign = 'center';
        textVerticalAlign = 'bottom';
        break;

      case 'startAngle':
        x = cx + middleR * mathCos(startAngle) + adjustAngleDistanceX(startAngle, distance + extraDist, false);
        y = cy + middleR * mathSin(startAngle) + adjustAngleDistanceY(startAngle, distance + extraDist, false);
        textAlign = 'right';
        textVerticalAlign = 'middle';
        break;

      case 'insideStartAngle':
        x = cx + middleR * mathCos(startAngle) + adjustAngleDistanceX(startAngle, -distance + extraDist, false);
        y = cy + middleR * mathSin(startAngle) + adjustAngleDistanceY(startAngle, -distance + extraDist, false);
        textAlign = 'left';
        textVerticalAlign = 'middle';
        break;

      case 'middle':
        x = cx + middleR * mathCos(middleAngle);
        y = cy + middleR * mathSin(middleAngle);
        textAlign = 'center';
        textVerticalAlign = 'middle';
        break;

      case 'endArc':
        x = cx + (r + distance) * mathCos(middleAngle);
        y = cy + (r + distance) * mathSin(middleAngle);
        textAlign = 'center';
        textVerticalAlign = 'bottom';
        break;

      case 'insideEndArc':
        x = cx + (r - distance) * mathCos(middleAngle);
        y = cy + (r - distance) * mathSin(middleAngle);
        textAlign = 'center';
        textVerticalAlign = 'top';
        break;

      case 'endAngle':
        x = cx + middleR * mathCos(endAngle) + adjustAngleDistanceX(endAngle, distance + extraDist, true);
        y = cy + middleR * mathSin(endAngle) + adjustAngleDistanceY(endAngle, distance + extraDist, true);
        textAlign = 'left';
        textVerticalAlign = 'middle';
        break;

      case 'insideEndAngle':
        x = cx + middleR * mathCos(endAngle) + adjustAngleDistanceX(endAngle, -distance + extraDist, true);
        y = cy + middleR * mathSin(endAngle) + adjustAngleDistanceY(endAngle, -distance + extraDist, true);
        textAlign = 'right';
        textVerticalAlign = 'middle';
        break;

      default:
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_contain_text_js__["a" /* calculateTextPosition */])(out, opts, boundingRect);
    }

    out = out || {};
    out.x = x;
    out.y = y;
    out.align = textAlign;
    out.verticalAlign = textVerticalAlign;
    return out;
  };
}
function setSectorTextRotation(sector, textPosition, positionMapping, rotateType) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isNumber"])(rotateType)) {
    // user-set rotation
    sector.setTextConfig({
      rotation: rotateType
    });
    return;
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(textPosition)) {
    // user-set position, use 0 as auto rotation
    sector.setTextConfig({
      rotation: 0
    });
    return;
  }

  var shape = sector.shape;
  var startAngle = shape.clockwise ? shape.startAngle : shape.endAngle;
  var endAngle = shape.clockwise ? shape.endAngle : shape.startAngle;
  var middleAngle = (startAngle + endAngle) / 2;
  var anchorAngle;
  var mappedSectorPosition = positionMapping(textPosition);

  switch (mappedSectorPosition) {
    case 'startArc':
    case 'insideStartArc':
    case 'middle':
    case 'insideEndArc':
    case 'endArc':
      anchorAngle = middleAngle;
      break;

    case 'startAngle':
    case 'insideStartAngle':
      anchorAngle = startAngle;
      break;

    case 'endAngle':
    case 'insideEndAngle':
      anchorAngle = endAngle;
      break;

    default:
      sector.setTextConfig({
        rotation: 0
      });
      return;
  }

  var rotate = Math.PI * 1.5 - anchorAngle;
  /**
   * TODO: labels with rotate > Math.PI / 2 should be rotate another
   * half round flipped to increase readability. However, only middle
   * position supports this for now, because in other positions, the
   * anchor point is not at the center of the text, so the positions
   * after rotating is not as expected.
   */

  if (mappedSectorPosition === 'middle' && rotate > Math.PI / 2 && rotate < Math.PI * 1.5) {
    rotate -= Math.PI;
  }

  sector.setTextConfig({
    rotation: rotate
  });
}

function adjustAngleDistanceX(angle, distance, isEnd) {
  return distance * Math.sin(angle) * (isEnd ? -1 : 1);
}

function adjustAngleDistanceY(angle, distance, isEnd) {
  return distance * Math.cos(angle) * (isEnd ? 1 : -1);
}

/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_helper_dataStackHelper_js__ = __webpack_require__(97);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




function getSeriesStackId(seriesModel) {
  return seriesModel.get('stack') || '__ec_stack_' + seriesModel.seriesIndex;
}

function getAxisKey(polar, axis) {
  return axis.dim + polar.model.componentIndex;
}

function barLayoutPolar(seriesType, ecModel, api) {
  var lastStackCoords = {};
  var barWidthAndOffset = calRadialBar(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["filter"](ecModel.getSeriesByType(seriesType), function (seriesModel) {
    return !ecModel.isSeriesFiltered(seriesModel) && seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'polar';
  }));
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    // Check series coordinate, do layout for polar only
    if (seriesModel.coordinateSystem.type !== 'polar') {
      return;
    }

    var data = seriesModel.getData();
    var polar = seriesModel.coordinateSystem;
    var baseAxis = polar.getBaseAxis();
    var axisKey = getAxisKey(polar, baseAxis);
    var stackId = getSeriesStackId(seriesModel);
    var columnLayoutInfo = barWidthAndOffset[axisKey][stackId];
    var columnOffset = columnLayoutInfo.offset;
    var columnWidth = columnLayoutInfo.width;
    var valueAxis = polar.getOtherAxis(baseAxis);
    var cx = seriesModel.coordinateSystem.cx;
    var cy = seriesModel.coordinateSystem.cy;
    var barMinHeight = seriesModel.get('barMinHeight') || 0;
    var barMinAngle = seriesModel.get('barMinAngle') || 0;
    lastStackCoords[stackId] = lastStackCoords[stackId] || [];
    var valueDim = data.mapDimension(valueAxis.dim);
    var baseDim = data.mapDimension(baseAxis.dim);
    var stacked = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_helper_dataStackHelper_js__["b" /* isDimensionStacked */])(data, valueDim
    /*, baseDim*/
    );
    var clampLayout = baseAxis.dim !== 'radius' || !seriesModel.get('roundCap', true);
    var valueAxisStart = valueAxis.dataToCoord(0);

    for (var idx = 0, len = data.count(); idx < len; idx++) {
      var value = data.get(valueDim, idx);
      var baseValue = data.get(baseDim, idx);
      var sign = value >= 0 ? 'p' : 'n';
      var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
      // stackResultDimension directly.
      // Only ordinal axis can be stacked.

      if (stacked) {
        if (!lastStackCoords[stackId][baseValue]) {
          lastStackCoords[stackId][baseValue] = {
            p: valueAxisStart,
            n: valueAxisStart // Negative stack

          };
        } // Should also consider #4243


        baseCoord = lastStackCoords[stackId][baseValue][sign];
      }

      var r0 = void 0;
      var r = void 0;
      var startAngle = void 0;
      var endAngle = void 0; // radial sector

      if (valueAxis.dim === 'radius') {
        var radiusSpan = valueAxis.dataToCoord(value) - valueAxisStart;
        var angle = baseAxis.dataToCoord(baseValue);

        if (Math.abs(radiusSpan) < barMinHeight) {
          radiusSpan = (radiusSpan < 0 ? -1 : 1) * barMinHeight;
        }

        r0 = baseCoord;
        r = baseCoord + radiusSpan;
        startAngle = angle - columnOffset;
        endAngle = startAngle - columnWidth;
        stacked && (lastStackCoords[stackId][baseValue][sign] = r);
      } // tangential sector
      else {
          var angleSpan = valueAxis.dataToCoord(value, clampLayout) - valueAxisStart;
          var radius = baseAxis.dataToCoord(baseValue);

          if (Math.abs(angleSpan) < barMinAngle) {
            angleSpan = (angleSpan < 0 ? -1 : 1) * barMinAngle;
          }

          r0 = radius + columnOffset;
          r = r0 + columnWidth;
          startAngle = baseCoord;
          endAngle = baseCoord + angleSpan; // if the previous stack is at the end of the ring,
          // add a round to differentiate it from origin
          // let extent = angleAxis.getExtent();
          // let stackCoord = angle;
          // if (stackCoord === extent[0] && value > 0) {
          //     stackCoord = extent[1];
          // }
          // else if (stackCoord === extent[1] && value < 0) {
          //     stackCoord = extent[0];
          // }

          stacked && (lastStackCoords[stackId][baseValue][sign] = endAngle);
        }

      data.setItemLayout(idx, {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r,
        // Consider that positive angle is anti-clockwise,
        // while positive radian of sector is clockwise
        startAngle: -startAngle * Math.PI / 180,
        endAngle: -endAngle * Math.PI / 180,

        /**
         * Keep the same logic with bar in catesion: use end value to
         * control direction. Notice that if clockwise is true (by
         * default), the sector will always draw clockwisely, no matter
         * whether endAngle is greater or less than startAngle.
         */
        clockwise: startAngle >= endAngle
      });
    }
  });
}
/**
 * Calculate bar width and offset for radial bar charts
 */


function calRadialBar(barSeries) {
  // Columns info on each category axis. Key is polar name
  var columnsMap = {};
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](barSeries, function (seriesModel, idx) {
    var data = seriesModel.getData();
    var polar = seriesModel.coordinateSystem;
    var baseAxis = polar.getBaseAxis();
    var axisKey = getAxisKey(polar, baseAxis);
    var axisExtent = baseAxis.getExtent();
    var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
    var columnsOnAxis = columnsMap[axisKey] || {
      bandWidth: bandWidth,
      remainedWidth: bandWidth,
      autoWidthCount: 0,
      categoryGap: '20%',
      gap: '30%',
      stacks: {}
    };
    var stacks = columnsOnAxis.stacks;
    columnsMap[axisKey] = columnsOnAxis;
    var stackId = getSeriesStackId(seriesModel);

    if (!stacks[stackId]) {
      columnsOnAxis.autoWidthCount++;
    }

    stacks[stackId] = stacks[stackId] || {
      width: 0,
      maxWidth: 0
    };
    var barWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["a" /* parsePercent */])(seriesModel.get('barWidth'), bandWidth);
    var barMaxWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["a" /* parsePercent */])(seriesModel.get('barMaxWidth'), bandWidth);
    var barGap = seriesModel.get('barGap');
    var barCategoryGap = seriesModel.get('barCategoryGap');

    if (barWidth && !stacks[stackId].width) {
      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
      stacks[stackId].width = barWidth;
      columnsOnAxis.remainedWidth -= barWidth;
    }

    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
    barGap != null && (columnsOnAxis.gap = barGap);
    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
  });
  var result = {};
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](columnsMap, function (columnsOnAxis, coordSysName) {
    result[coordSysName] = {};
    var stacks = columnsOnAxis.stacks;
    var bandWidth = columnsOnAxis.bandWidth;
    var categoryGap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["a" /* parsePercent */])(columnsOnAxis.categoryGap, bandWidth);
    var barGapPercent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["a" /* parsePercent */])(columnsOnAxis.gap, 1);
    var remainedWidth = columnsOnAxis.remainedWidth;
    var autoWidthCount = columnsOnAxis.autoWidthCount;
    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth

    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](stacks, function (column, stack) {
      var maxWidth = column.maxWidth;

      if (maxWidth && maxWidth < autoWidth) {
        maxWidth = Math.min(maxWidth, remainedWidth);

        if (column.width) {
          maxWidth = Math.min(maxWidth, column.width);
        }

        remainedWidth -= maxWidth;
        column.width = maxWidth;
        autoWidthCount--;
      }
    }); // Recalculate width again

    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = Math.max(autoWidth, 0);
    var widthSum = 0;
    var lastColumn;
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](stacks, function (column, idx) {
      if (!column.width) {
        column.width = autoWidth;
      }

      lastColumn = column;
      widthSum += column.width * (1 + barGapPercent);
    });

    if (lastColumn) {
      widthSum -= lastColumn.width * barGapPercent;
    }

    var offset = -widthSum / 2;
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](stacks, function (column, stackId) {
      result[coordSysName][stackId] = result[coordSysName][stackId] || {
        offset: offset,
        width: column.width
      };
      offset += column.width * (1 + barGapPercent);
    });
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (barLayoutPolar);

/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTextRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__ = __webpack_require__(4);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

function getTextRect(text, font, align, verticalAlign, padding, rich, truncate, lineHeight) {
  var textEl = new __WEBPACK_IMPORTED_MODULE_0__util_graphic_js__["Text"]({
    style: {
      text: text,
      font: font,
      align: align,
      verticalAlign: verticalAlign,
      padding: padding,
      rich: rich,
      overflow: truncate ? 'truncate' : null,
      lineHeight: lineHeight
    }
  });
  return textEl.getBoundingRect();
}

/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultLoading;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__ = __webpack_require__(4);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


var PI = Math.PI;
/**
 * @param {module:echarts/ExtensionAPI} api
 * @param {Object} [opts]
 * @param {string} [opts.text]
 * @param {string} [opts.color]
 * @param {string} [opts.textColor]
 * @return {module:zrender/Element}
 */

function defaultLoading(api, opts) {
  opts = opts || {};
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["defaults"](opts, {
    text: 'loading',
    textColor: '#000',
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontFamily: 'sans-serif',
    maskColor: 'rgba(255, 255, 255, 0.8)',
    showSpinner: true,
    color: '#5470c6',
    spinnerRadius: 10,
    lineWidth: 5,
    zlevel: 0
  });
  var group = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Group"]();
  var mask = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Rect"]({
    style: {
      fill: opts.maskColor
    },
    zlevel: opts.zlevel,
    z: 10000
  });
  group.add(mask);
  var textContent = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Text"]({
    style: {
      text: opts.text,
      fill: opts.textColor,
      fontSize: opts.fontSize,
      fontWeight: opts.fontWeight,
      fontStyle: opts.fontStyle,
      fontFamily: opts.fontFamily
    },
    zlevel: opts.zlevel,
    z: 10001
  });
  var labelRect = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Rect"]({
    style: {
      fill: 'none'
    },
    textContent: textContent,
    textConfig: {
      position: 'right',
      distance: 10
    },
    zlevel: opts.zlevel,
    z: 10001
  });
  group.add(labelRect);
  var arc;

  if (opts.showSpinner) {
    arc = new __WEBPACK_IMPORTED_MODULE_1__util_graphic_js__["Arc"]({
      shape: {
        startAngle: -PI / 2,
        endAngle: -PI / 2 + 0.1,
        r: opts.spinnerRadius
      },
      style: {
        stroke: opts.color,
        lineCap: 'round',
        lineWidth: opts.lineWidth
      },
      zlevel: opts.zlevel,
      z: 10001
    });
    arc.animateShape(true).when(1000, {
      endAngle: PI * 3 / 2
    }).start('circularInOut');
    arc.animateShape(true).when(1000, {
      startAngle: PI * 3 / 2
    }).delay(300).start('circularInOut');
    group.add(arc);
  } // Inject resize


  group.resize = function () {
    var textWidth = textContent.getBoundingRect().width;
    var r = opts.showSpinner ? opts.spinnerRadius : 0; // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
    // textDistance needs to be calculated when both animation and text exist

    var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 - (opts.showSpinner && textWidth ? 0 : 5 + textWidth / 2) // only show the text
    + (opts.showSpinner ? 0 : textWidth / 2) // only show the spinner
    + (textWidth ? 0 : r);
    var cy = api.getHeight() / 2;
    opts.showSpinner && arc.setShape({
      cx: cx,
      cy: cy
    });
    labelRect.setShape({
      x: cx - r,
      y: cy - r,
      width: r * 2,
      height: r * 2
    });
    mask.setShape({
      x: 0,
      y: 0,
      width: api.getWidth(),
      height: api.getHeight()
    });
  };

  group.resize();
  return group;
}

/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_log_js__ = __webpack_require__(14);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var QUERY_REG = /^(min|max)?(.+)$/; // Key: mainType
// type FakeComponentsMap = HashMap<(MappingExistingItem & { subType: string })[]>;

/**
 * TERM EXPLANATIONS:
 * See `ECOption` and `ECUnitOption` in `src/util/types.ts`.
 */

var OptionManager =
/** @class */
function () {
  // timeline.notMerge is not supported in ec3. Firstly there is rearly
  // case that notMerge is needed. Secondly supporting 'notMerge' requires
  // rawOption cloned and backuped when timeline changed, which does no
  // good to performance. What's more, that both timeline and setOption
  // method supply 'notMerge' brings complex and some problems.
  // Consider this case:
  // (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
  // (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
  function OptionManager(api) {
    this._timelineOptions = [];
    this._mediaList = [];
    /**
     * -1, means default.
     * empty means no media.
     */

    this._currentMediaIndices = [];
    this._api = api;
  }

  OptionManager.prototype.setOption = function (rawOption, optionPreprocessorFuncs, opt) {
    if (rawOption) {
      // That set dat primitive is dangerous if user reuse the data when setOption again.
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_model_js__["d" /* normalizeToArray */])(rawOption.series), function (series) {
        series && series.data && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isTypedArray"])(series.data) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["setAsPrimitive"])(series.data);
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_model_js__["d" /* normalizeToArray */])(rawOption.dataset), function (dataset) {
        dataset && dataset.source && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isTypedArray"])(dataset.source) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["setAsPrimitive"])(dataset.source);
      });
    } // Caution: some series modify option data, if do not clone,
    // it should ensure that the repeat modify correctly
    // (create a new object when modify itself).


    rawOption = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"])(rawOption); // FIXME
    // If some property is set in timeline options or media option but
    // not set in baseOption, a warning should be given.

    var optionBackup = this._optionBackup;
    var newParsedOption = parseRawOption(rawOption, optionPreprocessorFuncs, !optionBackup);
    this._newBaseOption = newParsedOption.baseOption; // For setOption at second time (using merge mode);

    if (optionBackup) {
      // FIXME
      // the restore merge solution is essentially incorrect.
      // the mapping can not be 100% consistent with ecModel, which probably brings
      // potential bug!
      // The first merge is delayed, becuase in most cases, users do not call `setOption` twice.
      // let fakeCmptsMap = this._fakeCmptsMap;
      // if (!fakeCmptsMap) {
      //     fakeCmptsMap = this._fakeCmptsMap = createHashMap();
      //     mergeToBackupOption(fakeCmptsMap, null, optionBackup.baseOption, null);
      // }
      // mergeToBackupOption(
      //     fakeCmptsMap, optionBackup.baseOption, newParsedOption.baseOption, opt
      // );
      // For simplicity, timeline options and media options do not support merge,
      // that is, if you `setOption` twice and both has timeline options, the latter
      // timeline opitons will not be merged to the formers, but just substitude them.
      if (newParsedOption.timelineOptions.length) {
        optionBackup.timelineOptions = newParsedOption.timelineOptions;
      }

      if (newParsedOption.mediaList.length) {
        optionBackup.mediaList = newParsedOption.mediaList;
      }

      if (newParsedOption.mediaDefault) {
        optionBackup.mediaDefault = newParsedOption.mediaDefault;
      }
    } else {
      this._optionBackup = newParsedOption;
    }
  };

  OptionManager.prototype.mountOption = function (isRecreate) {
    var optionBackup = this._optionBackup;
    this._timelineOptions = optionBackup.timelineOptions;
    this._mediaList = optionBackup.mediaList;
    this._mediaDefault = optionBackup.mediaDefault;
    this._currentMediaIndices = [];
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"])(isRecreate // this._optionBackup.baseOption, which is created at the first `setOption`
    // called, and is merged into every new option by inner method `mergeToBackupOption`
    // each time `setOption` called, can be only used in `isRecreate`, because
    // its reliability is under suspicion. In other cases option merge is
    // performed by `model.mergeOption`.
    ? optionBackup.baseOption : this._newBaseOption);
  };

  OptionManager.prototype.getTimelineOption = function (ecModel) {
    var option;
    var timelineOptions = this._timelineOptions;

    if (timelineOptions.length) {
      // getTimelineOption can only be called after ecModel inited,
      // so we can get currentIndex from timelineModel.
      var timelineModel = ecModel.getComponent('timeline');

      if (timelineModel) {
        option = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"])( // FIXME:TS as TimelineModel or quivlant interface
        timelineOptions[timelineModel.getCurrentIndex()]);
      }
    }

    return option;
  };

  OptionManager.prototype.getMediaOption = function (ecModel) {
    var ecWidth = this._api.getWidth();

    var ecHeight = this._api.getHeight();

    var mediaList = this._mediaList;
    var mediaDefault = this._mediaDefault;
    var indices = [];
    var result = []; // No media defined.

    if (!mediaList.length && !mediaDefault) {
      return result;
    } // Multi media may be applied, the latter defined media has higher priority.


    for (var i = 0, len = mediaList.length; i < len; i++) {
      if (applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) {
        indices.push(i);
      }
    } // FIXME
    // Whether mediaDefault should force users to provide? Otherwise
    // the change by media query can not be recorvered.


    if (!indices.length && mediaDefault) {
      indices = [-1];
    }

    if (indices.length && !indicesEquals(indices, this._currentMediaIndices)) {
      result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"])(indices, function (index) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["clone"])(index === -1 ? mediaDefault.option : mediaList[index].option);
      });
    } // Otherwise return nothing.


    this._currentMediaIndices = indices;
    return result;
  };

  return OptionManager;
}();
/**
 * [RAW_OPTION_PATTERNS]
 * (Note: "series: []" represents all other props in `ECUnitOption`)
 *
 * (1) No prop "baseOption" declared:
 * Root option is used as "baseOption" (except prop "options" and "media").
 * ```js
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 * };
 * option = {
 *     series: [],
 *     media: {},
 * };
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 *     media: {},
 * }
 * ```
 *
 * (2) Prop "baseOption" declared:
 * If "baseOption" declared, `ECUnitOption` props can only be declared
 * inside "baseOption" except prop "timeline" (compat ec2).
 * ```js
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 * };
 * option = {
 *     baseOption: {
 *         series: [],
 *     },
 *     media: []
 * };
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 *     media: []
 * };
 * option = {
 *     // ec3 compat ec2: allow (only) `timeline` declared
 *     // outside baseOption. Keep this setting for compat.
 *     timeline: {},
 *     baseOption: {
 *         series: [],
 *     },
 *     options: [],
 *     media: []
 * };
 * ```
 */


function parseRawOption( // `rawOption` May be modified
rawOption, optionPreprocessorFuncs, isNew) {
  var mediaList = [];
  var mediaDefault;
  var baseOption;
  var declaredBaseOption = rawOption.baseOption; // Compatible with ec2, [RAW_OPTION_PATTERNS] above.

  var timelineOnRoot = rawOption.timeline;
  var timelineOptionsOnRoot = rawOption.options;
  var mediaOnRoot = rawOption.media;
  var hasMedia = !!rawOption.media;
  var hasTimeline = !!(timelineOptionsOnRoot || timelineOnRoot || declaredBaseOption && declaredBaseOption.timeline);

  if (declaredBaseOption) {
    baseOption = declaredBaseOption; // For merge option.

    if (!baseOption.timeline) {
      baseOption.timeline = timelineOnRoot;
    }
  } // For convenience, enable to use the root option as the `baseOption`:
  // `{ ...normalOptionProps, media: [{ ... }, { ... }] }`
  else {
      if (hasTimeline || hasMedia) {
        rawOption.options = rawOption.media = null;
      }

      baseOption = rawOption;
    }

  if (hasMedia) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isArray"])(mediaOnRoot)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(mediaOnRoot, function (singleMedia) {
        if (true) {
          // Real case of wrong config.
          if (singleMedia && !singleMedia.option && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isObject"])(singleMedia.query) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["isObject"])(singleMedia.query.option)) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_log_js__["c" /* error */])('Illegal media option. Must be like { media: [ { query: {}, option: {} } ] }');
          }
        }

        if (singleMedia && singleMedia.option) {
          if (singleMedia.query) {
            mediaList.push(singleMedia);
          } else if (!mediaDefault) {
            // Use the first media default.
            mediaDefault = singleMedia;
          }
        }
      });
    } else {
      if (true) {
        // Real case of wrong config.
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_log_js__["c" /* error */])('Illegal media option. Must be an array. Like { media: [ {...}, {...} ] }');
      }
    }
  }

  doPreprocess(baseOption);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(timelineOptionsOnRoot, function (option) {
    return doPreprocess(option);
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(mediaList, function (media) {
    return doPreprocess(media.option);
  });

  function doPreprocess(option) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(optionPreprocessorFuncs, function (preProcess) {
      preProcess(option, isNew);
    });
  }

  return {
    baseOption: baseOption,
    timelineOptions: timelineOptionsOnRoot || [],
    mediaDefault: mediaDefault,
    mediaList: mediaList
  };
}
/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */


function applyMediaQuery(query, ecWidth, ecHeight) {
  var realMap = {
    width: ecWidth,
    height: ecHeight,
    aspectratio: ecWidth / ecHeight // lowser case for convenientce.

  };
  var applicatable = true;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["each"])(query, function (value, attr) {
    var matched = attr.match(QUERY_REG);

    if (!matched || !matched[1] || !matched[2]) {
      return;
    }

    var operator = matched[1];
    var realAttr = matched[2].toLowerCase();

    if (!compare(realMap[realAttr], value, operator)) {
      applicatable = false;
    }
  });
  return applicatable;
}

function compare(real, expect, operator) {
  if (operator === 'min') {
    return real >= expect;
  } else if (operator === 'max') {
    return real <= expect;
  } else {
    // Equals
    return real === expect;
  }
}

function indicesEquals(indices1, indices2) {
  // indices is always order by asc and has only finite number.
  return indices1.join(',') === indices2.join(',');
}
/**
 * Consider case:
 * `chart.setOption(opt1);`
 * Then user do some interaction like dataZoom, dataView changing.
 * `chart.setOption(opt2);`
 * Then user press 'reset button' in toolbox.
 *
 * After doing that all of the interaction effects should be reset, the
 * chart should be the same as the result of invoke
 * `chart.setOption(opt1); chart.setOption(opt2);`.
 *
 * Although it is not able ensure that
 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
 * `chart.setOption(merge(opt1, opt2));` exactly,
 * this might be the only simple way to implement that feature.
 *
 * MEMO: We've considered some other approaches:
 * 1. Each model handle its self restoration but not uniform treatment.
 *     (Too complex in logic and error-prone)
 * 2. Use a shadow ecModel. (Performace expensive)
 *
 * FIXME: A possible solution:
 * Add a extra level of model for each component model. The inheritance chain would be:
 * ecModel <- componentModel <- componentActionModel <- dataItemModel
 * And all of the actions can only modify the `componentActionModel` rather than
 * `componentModel`. `setOption` will only modify the `ecModel` and `componentModel`.
 * When "resotre" action triggered, model from `componentActionModel` will be discarded
 * instead of recreating the "ecModel" from the "_optionBackup".
 */
// function mergeToBackupOption(
//     fakeCmptsMap: FakeComponentsMap,
//     // `tarOption` Can be null/undefined, means init
//     tarOption: ECUnitOption,
//     newOption: ECUnitOption,
//     // Can be null/undefined
//     opt: InnerSetOptionOpts
// ): void {
//     newOption = newOption || {} as ECUnitOption;
//     const notInit = !!tarOption;
//     each(newOption, function (newOptsInMainType, mainType) {
//         if (newOptsInMainType == null) {
//             return;
//         }
//         if (!ComponentModel.hasClass(mainType)) {
//             if (tarOption) {
//                 tarOption[mainType] = merge(tarOption[mainType], newOptsInMainType, true);
//             }
//         }
//         else {
//             const oldTarOptsInMainType = notInit ? normalizeToArray(tarOption[mainType]) : null;
//             const oldFakeCmptsInMainType = fakeCmptsMap.get(mainType) || [];
//             const resultTarOptsInMainType = notInit ? (tarOption[mainType] = [] as ComponentOption[]) : null;
//             const resultFakeCmptsInMainType = fakeCmptsMap.set(mainType, []);
//             const mappingResult = mappingToExists(
//                 oldFakeCmptsInMainType,
//                 normalizeToArray(newOptsInMainType),
//                 (opt && opt.replaceMergeMainTypeMap.get(mainType)) ? 'replaceMerge' : 'normalMerge'
//             );
//             setComponentTypeToKeyInfo(mappingResult, mainType, ComponentModel as ComponentModelConstructor);
//             each(mappingResult, function (resultItem, index) {
//                 // The same logic as `Global.ts#_mergeOption`.
//                 let fakeCmpt = resultItem.existing;
//                 const newOption = resultItem.newOption;
//                 const keyInfo = resultItem.keyInfo;
//                 let fakeCmptOpt;
//                 if (!newOption) {
//                     fakeCmptOpt = oldTarOptsInMainType[index];
//                 }
//                 else {
//                     if (fakeCmpt && fakeCmpt.subType === keyInfo.subType) {
//                         fakeCmpt.name = keyInfo.name;
//                         if (notInit) {
//                             fakeCmptOpt = merge(oldTarOptsInMainType[index], newOption, true);
//                         }
//                     }
//                     else {
//                         fakeCmpt = extend({}, keyInfo);
//                         if (notInit) {
//                             fakeCmptOpt = clone(newOption);
//                         }
//                     }
//                 }
//                 if (fakeCmpt) {
//                     notInit && resultTarOptsInMainType.push(fakeCmptOpt);
//                     resultFakeCmptsInMainType.push(fakeCmpt);
//                 }
//                 else {
//                     notInit && resultTarOptsInMainType.push(void 0);
//                     resultFakeCmptsInMainType.push(void 0);
//                 }
//             });
//         }
//     });
// }


/* harmony default export */ __webpack_exports__["a"] = (OptionManager);

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var platform = ''; // Navigator not exists in node

if (typeof navigator !== 'undefined') {
  /* global navigator */
  platform = navigator.platform || '';
}

var decalColor = 'rgba(0, 0, 0, 0.2)';
/* harmony default export */ __webpack_exports__["a"] = ({
  darkMode: 'auto',
  // backgroundColor: 'rgba(0,0,0,0)',
  colorBy: 'series',
  color: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
  gradientColor: ['#f6efa6', '#d88273', '#bf444c'],
  aria: {
    decal: {
      decals: [{
        color: decalColor,
        dashArrayX: [1, 0],
        dashArrayY: [2, 5],
        symbolSize: 1,
        rotation: Math.PI / 6
      }, {
        color: decalColor,
        symbol: 'circle',
        dashArrayX: [[8, 8], [0, 8, 8, 0]],
        dashArrayY: [6, 0],
        symbolSize: 0.8
      }, {
        color: decalColor,
        dashArrayX: [1, 0],
        dashArrayY: [4, 3],
        rotation: -Math.PI / 4
      }, {
        color: decalColor,
        dashArrayX: [[6, 6], [0, 6, 6, 0]],
        dashArrayY: [6, 0]
      }, {
        color: decalColor,
        dashArrayX: [[1, 0], [1, 6]],
        dashArrayY: [1, 0, 6, 0],
        rotation: Math.PI / 4
      }, {
        color: decalColor,
        symbol: 'triangle',
        dashArrayX: [[9, 9], [0, 9, 9, 0]],
        dashArrayY: [7, 2],
        symbolSize: 0.75
      }]
    }
  },
  // If xAxis and yAxis declared, grid is created by default.
  // grid: {},
  textStyle: {
    // color: '#000',
    // decoration: 'none',
    // PENDING
    fontFamily: platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
    // fontFamily: 'Arial, Verdana, sans-serif',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 'normal'
  },
  // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
  // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
  // Default is source-over
  blendMode: null,
  stateAnimation: {
    duration: 300,
    easing: 'cubicOut'
  },
  animation: 'auto',
  animationDuration: 1000,
  animationDurationUpdate: 500,
  animationEasing: 'cubicInOut',
  animationEasingUpdate: 'cubicInOut',
  animationThreshold: 2000,
  // Configuration for progressive/incremental rendering
  progressiveThreshold: 3000,
  progressive: 400,
  // Threshold of if use single hover layer to optimize.
  // It is recommended that `hoverLayerThreshold` is equivalent to or less than
  // `progressiveThreshold`, otherwise hover will cause restart of progressive,
  // which is unexpected.
  // see example <echarts/test/heatmap-large.html>.
  hoverLayerThreshold: 3000,
  // See: module:echarts/scale/Time
  useUTC: false
});

/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AREA_STYLE_KEY_MAP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AreaStyleMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__makeStyleMapper_js__ = __webpack_require__(160);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var AREA_STYLE_KEY_MAP = [['fill', 'color'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['opacity'], ['shadowColor'] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
// So do not transfer decal directly.
];
var getAreaStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__makeStyleMapper_js__["a" /* default */])(AREA_STYLE_KEY_MAP);

var AreaStyleMixin =
/** @class */
function () {
  function AreaStyleMixin() {}

  AreaStyleMixin.prototype.getAreaStyle = function (excludes, includes) {
    return getAreaStyle(this, excludes, includes);
  };

  return AreaStyleMixin;
}();

;


/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__label_labelStyle_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_graphic_Text_js__ = __webpack_require__(167);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


var PATH_COLOR = ['textStyle', 'color'];
var textStyleParams = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily', 'padding', 'lineHeight', 'rich', 'width', 'height', 'overflow']; // TODO Performance improvement?

var tmpText = new __WEBPACK_IMPORTED_MODULE_1_zrender_lib_graphic_Text_js__["a" /* default */]();

var TextStyleMixin =
/** @class */
function () {
  function TextStyleMixin() {}
  /**
   * Get color property or get color from option.textStyle.color
   */
  // TODO Callback


  TextStyleMixin.prototype.getTextColor = function (isEmphasis) {
    var ecModel = this.ecModel;
    return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get(PATH_COLOR) : null);
  };
  /**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */


  TextStyleMixin.prototype.getFont = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__label_labelStyle_js__["c" /* getFont */])({
      fontStyle: this.getShallow('fontStyle'),
      fontWeight: this.getShallow('fontWeight'),
      fontSize: this.getShallow('fontSize'),
      fontFamily: this.getShallow('fontFamily')
    }, this.ecModel);
  };

  TextStyleMixin.prototype.getTextRect = function (text) {
    var style = {
      text: text,
      verticalAlign: this.getShallow('verticalAlign') || this.getShallow('baseline')
    };

    for (var i = 0; i < textStyleParams.length; i++) {
      style[textStyleParams[i]] = this.getShallow(textStyleParams[i]);
    }

    tmpText.useStyle(style);
    tmpText.update();
    return tmpText.getBoundingRect();
  };

  return TextStyleMixin;
}();

;
/* harmony default export */ __webpack_exports__["a"] = (TextStyleMixin);

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCoordSysInfoBySeries;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Helper for model references.
 * There are many manners to refer axis/coordSys.
 */
// TODO
// merge relevant logic to this file?
// check: "modelHelper" of tooltip and "BrushTargetManager".


/**
 * @class
 * For example:
 * {
 *     coordSysName: 'cartesian2d',
 *     coordSysDims: ['x', 'y', ...],
 *     axisMap: HashMap({
 *         x: xAxisModel,
 *         y: yAxisModel
 *     }),
 *     categoryAxisMap: HashMap({
 *         x: xAxisModel,
 *         y: undefined
 *     }),
 *     // The index of the first category axis in `coordSysDims`.
 *     // `null/undefined` means no category axis exists.
 *     firstCategoryDimIndex: 1,
 *     // To replace user specified encode.
 * }
 */

var CoordSysInfo =
/** @class */
function () {
  function CoordSysInfo(coordSysName) {
    this.coordSysDims = [];
    this.axisMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();
    this.categoryAxisMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();
    this.coordSysName = coordSysName;
  }

  return CoordSysInfo;
}();

function getCoordSysInfoBySeries(seriesModel) {
  var coordSysName = seriesModel.get('coordinateSystem');
  var result = new CoordSysInfo(coordSysName);
  var fetch = fetchers[coordSysName];

  if (fetch) {
    fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
    return result;
  }
}
var fetchers = {
  cartesian2d: function (seriesModel, result, axisMap, categoryAxisMap) {
    var xAxisModel = seriesModel.getReferringComponents('xAxis', __WEBPACK_IMPORTED_MODULE_1__util_model_js__["i" /* SINGLE_REFERRING */]).models[0];
    var yAxisModel = seriesModel.getReferringComponents('yAxis', __WEBPACK_IMPORTED_MODULE_1__util_model_js__["i" /* SINGLE_REFERRING */]).models[0];

    if (true) {
      if (!xAxisModel) {
        throw new Error('xAxis "' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve"])(seriesModel.get('xAxisIndex'), seriesModel.get('xAxisId'), 0) + '" not found');
      }

      if (!yAxisModel) {
        throw new Error('yAxis "' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["retrieve"])(seriesModel.get('xAxisIndex'), seriesModel.get('yAxisId'), 0) + '" not found');
      }
    }

    result.coordSysDims = ['x', 'y'];
    axisMap.set('x', xAxisModel);
    axisMap.set('y', yAxisModel);

    if (isCategory(xAxisModel)) {
      categoryAxisMap.set('x', xAxisModel);
      result.firstCategoryDimIndex = 0;
    }

    if (isCategory(yAxisModel)) {
      categoryAxisMap.set('y', yAxisModel);
      result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
    }
  },
  singleAxis: function (seriesModel, result, axisMap, categoryAxisMap) {
    var singleAxisModel = seriesModel.getReferringComponents('singleAxis', __WEBPACK_IMPORTED_MODULE_1__util_model_js__["i" /* SINGLE_REFERRING */]).models[0];

    if (true) {
      if (!singleAxisModel) {
        throw new Error('singleAxis should be specified.');
      }
    }

    result.coordSysDims = ['single'];
    axisMap.set('single', singleAxisModel);

    if (isCategory(singleAxisModel)) {
      categoryAxisMap.set('single', singleAxisModel);
      result.firstCategoryDimIndex = 0;
    }
  },
  polar: function (seriesModel, result, axisMap, categoryAxisMap) {
    var polarModel = seriesModel.getReferringComponents('polar', __WEBPACK_IMPORTED_MODULE_1__util_model_js__["i" /* SINGLE_REFERRING */]).models[0];
    var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
    var angleAxisModel = polarModel.findAxisModel('angleAxis');

    if (true) {
      if (!angleAxisModel) {
        throw new Error('angleAxis option not found');
      }

      if (!radiusAxisModel) {
        throw new Error('radiusAxis option not found');
      }
    }

    result.coordSysDims = ['radius', 'angle'];
    axisMap.set('radius', radiusAxisModel);
    axisMap.set('angle', angleAxisModel);

    if (isCategory(radiusAxisModel)) {
      categoryAxisMap.set('radius', radiusAxisModel);
      result.firstCategoryDimIndex = 0;
    }

    if (isCategory(angleAxisModel)) {
      categoryAxisMap.set('angle', angleAxisModel);
      result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
    }
  },
  geo: function (seriesModel, result, axisMap, categoryAxisMap) {
    result.coordSysDims = ['lng', 'lat'];
  },
  parallel: function (seriesModel, result, axisMap, categoryAxisMap) {
    var ecModel = seriesModel.ecModel;
    var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
    var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(parallelModel.parallelAxisIndex, function (axisIndex, index) {
      var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
      var axisDim = coordSysDims[index];
      axisMap.set(axisDim, axisModel);

      if (isCategory(axisModel)) {
        categoryAxisMap.set(axisDim, axisModel);

        if (result.firstCategoryDimIndex == null) {
          result.firstCategoryDimIndex = index;
        }
      }
    });
  }
};

function isCategory(axisModel) {
  return axisModel.get('type') === 'category';
}

/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = globalBackwardCompat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_compatStyle_js__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_log_js__ = __webpack_require__(14);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/





function get(opt, path) {
  var pathArr = path.split(',');
  var obj = opt;

  for (var i = 0; i < pathArr.length; i++) {
    obj = obj && obj[pathArr[i]];

    if (obj == null) {
      break;
    }
  }

  return obj;
}

function set(opt, path, val, overwrite) {
  var pathArr = path.split(',');
  var obj = opt;
  var key;
  var i = 0;

  for (; i < pathArr.length - 1; i++) {
    key = pathArr[i];

    if (obj[key] == null) {
      obj[key] = {};
    }

    obj = obj[key];
  }

  if (overwrite || obj[pathArr[i]] == null) {
    obj[pathArr[i]] = val;
  }
}

function compatLayoutProperties(option) {
  option && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(LAYOUT_PROPERTIES, function (prop) {
    if (prop[0] in option && !(prop[1] in option)) {
      option[prop[1]] = option[prop[0]];
    }
  });
}

var LAYOUT_PROPERTIES = [['x', 'left'], ['y', 'top'], ['x2', 'right'], ['y2', 'bottom']];
var COMPATITABLE_COMPONENTS = ['grid', 'geo', 'parallel', 'legend', 'toolbox', 'title', 'visualMap', 'dataZoom', 'timeline'];
var BAR_ITEM_STYLE_MAP = [['borderRadius', 'barBorderRadius'], ['borderColor', 'barBorderColor'], ['borderWidth', 'barBorderWidth']];

function compatBarItemStyle(option) {
  var itemStyle = option && option.itemStyle;

  if (itemStyle) {
    for (var i = 0; i < BAR_ITEM_STYLE_MAP.length; i++) {
      var oldName = BAR_ITEM_STYLE_MAP[i][1];
      var newName = BAR_ITEM_STYLE_MAP[i][0];

      if (itemStyle[oldName] != null) {
        itemStyle[newName] = itemStyle[oldName];

        if (true) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_log_js__["a" /* deprecateReplaceLog */])(oldName, newName);
        }
      }
    }
  }
}

function compatPieLabel(option) {
  if (!option) {
    return;
  }

  if (option.alignTo === 'edge' && option.margin != null && option.edgeDistance == null) {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_log_js__["a" /* deprecateReplaceLog */])('label.margin', 'label.edgeDistance', 'pie');
    }

    option.edgeDistance = option.margin;
  }
}

function compatSunburstState(option) {
  if (!option) {
    return;
  }

  if (option.downplay && !option.blur) {
    option.blur = option.downplay;

    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_log_js__["a" /* deprecateReplaceLog */])('downplay', 'blur', 'sunburst');
    }
  }
}

function compatGraphFocus(option) {
  if (!option) {
    return;
  }

  if (option.focusNodeAdjacency != null) {
    option.emphasis = option.emphasis || {};

    if (option.emphasis.focus == null) {
      if (true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_log_js__["a" /* deprecateReplaceLog */])('focusNodeAdjacency', 'emphasis: { focus: \'adjacency\'}', 'graph/sankey');
      }

      option.emphasis.focus = 'adjacency';
    }
  }
}

function traverseTree(data, cb) {
  if (data) {
    for (var i = 0; i < data.length; i++) {
      cb(data[i]);
      data[i] && traverseTree(data[i].children, cb);
    }
  }
}

function globalBackwardCompat(option, isTheme) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper_compatStyle_js__["a" /* default */])(option, isTheme); // Make sure series array for model initialization.

  option.series = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_model_js__["d" /* normalizeToArray */])(option.series);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(option.series, function (seriesOpt) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"])(seriesOpt)) {
      return;
    }

    var seriesType = seriesOpt.type;

    if (seriesType === 'line') {
      if (seriesOpt.clipOverflow != null) {
        seriesOpt.clip = seriesOpt.clipOverflow;

        if (true) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_log_js__["a" /* deprecateReplaceLog */])('clipOverflow', 'clip', 'line');
        }
      }
    } else if (seriesType === 'pie' || seriesType === 'gauge') {
      if (seriesOpt.clockWise != null) {
        seriesOpt.clockwise = seriesOpt.clockWise;

        if (true) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_log_js__["a" /* deprecateReplaceLog */])('clockWise', 'clockwise');
        }
      }

      compatPieLabel(seriesOpt.label);
      var data = seriesOpt.data;

      if (data && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isTypedArray"])(data)) {
        for (var i = 0; i < data.length; i++) {
          compatPieLabel(data[i]);
        }
      }

      if (seriesOpt.hoverOffset != null) {
        seriesOpt.emphasis = seriesOpt.emphasis || {};

        if (seriesOpt.emphasis.scaleSize = null) {
          if (true) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_log_js__["a" /* deprecateReplaceLog */])('hoverOffset', 'emphasis.scaleSize');
          }

          seriesOpt.emphasis.scaleSize = seriesOpt.hoverOffset;
        }
      }
    } else if (seriesType === 'gauge') {
      var pointerColor = get(seriesOpt, 'pointer.color');
      pointerColor != null && set(seriesOpt, 'itemStyle.color', pointerColor);
    } else if (seriesType === 'bar') {
      compatBarItemStyle(seriesOpt);
      compatBarItemStyle(seriesOpt.backgroundStyle);
      compatBarItemStyle(seriesOpt.emphasis);
      var data = seriesOpt.data;

      if (data && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isTypedArray"])(data)) {
        for (var i = 0; i < data.length; i++) {
          if (typeof data[i] === 'object') {
            compatBarItemStyle(data[i]);
            compatBarItemStyle(data[i] && data[i].emphasis);
          }
        }
      }
    } else if (seriesType === 'sunburst') {
      var highlightPolicy = seriesOpt.highlightPolicy;

      if (highlightPolicy) {
        seriesOpt.emphasis = seriesOpt.emphasis || {};

        if (!seriesOpt.emphasis.focus) {
          seriesOpt.emphasis.focus = highlightPolicy;

          if (true) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_log_js__["a" /* deprecateReplaceLog */])('highlightPolicy', 'emphasis.focus', 'sunburst');
          }
        }
      }

      compatSunburstState(seriesOpt);
      traverseTree(seriesOpt.data, compatSunburstState);
    } else if (seriesType === 'graph' || seriesType === 'sankey') {
      compatGraphFocus(seriesOpt); // TODO nodes, edges?
    } else if (seriesType === 'map') {
      if (seriesOpt.mapType && !seriesOpt.map) {
        if (true) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_log_js__["a" /* deprecateReplaceLog */])('mapType', 'map', 'map');
        }

        seriesOpt.map = seriesOpt.mapType;
      }

      if (seriesOpt.mapLocation) {
        if (true) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_log_js__["g" /* deprecateLog */])('`mapLocation` is not used anymore.');
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["defaults"])(seriesOpt, seriesOpt.mapLocation);
      }
    }

    if (seriesOpt.hoverAnimation != null) {
      seriesOpt.emphasis = seriesOpt.emphasis || {};

      if (seriesOpt.emphasis && seriesOpt.emphasis.scale == null) {
        if (true) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_log_js__["a" /* deprecateReplaceLog */])('hoverAnimation', 'emphasis.scale');
        }

        seriesOpt.emphasis.scale = seriesOpt.hoverAnimation;
      }
    }

    compatLayoutProperties(seriesOpt);
  }); // dataRange has changed to visualMap

  if (option.dataRange) {
    option.visualMap = option.dataRange;
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(COMPATITABLE_COMPONENTS, function (componentName) {
    var options = option[componentName];

    if (options) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"])(options)) {
        options = [options];
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(options, function (option) {
        compatLayoutProperties(option);
      });
    }
  });
}

/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = globalCompatStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_log_js__ = __webpack_require__(14);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var each = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"];
var isObject = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"];
var POSSIBLE_STYLES = ['areaStyle', 'lineStyle', 'nodeStyle', 'linkStyle', 'chordStyle', 'label', 'labelLine'];

function compatEC2ItemStyle(opt) {
  var itemStyleOpt = opt && opt.itemStyle;

  if (!itemStyleOpt) {
    return;
  }

  for (var i = 0, len = POSSIBLE_STYLES.length; i < len; i++) {
    var styleName = POSSIBLE_STYLES[i];
    var normalItemStyleOpt = itemStyleOpt.normal;
    var emphasisItemStyleOpt = itemStyleOpt.emphasis;

    if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
      if (true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_log_js__["a" /* deprecateReplaceLog */])("itemStyle.normal." + styleName, styleName);
      }

      opt[styleName] = opt[styleName] || {};

      if (!opt[styleName].normal) {
        opt[styleName].normal = normalItemStyleOpt[styleName];
      } else {
        __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["merge"](opt[styleName].normal, normalItemStyleOpt[styleName]);
      }

      normalItemStyleOpt[styleName] = null;
    }

    if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
      if (true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_log_js__["a" /* deprecateReplaceLog */])("itemStyle.emphasis." + styleName, "emphasis." + styleName);
      }

      opt[styleName] = opt[styleName] || {};

      if (!opt[styleName].emphasis) {
        opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
      } else {
        __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["merge"](opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
      }

      emphasisItemStyleOpt[styleName] = null;
    }
  }
}

function convertNormalEmphasis(opt, optType, useExtend) {
  if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
    var normalOpt = opt[optType].normal;
    var emphasisOpt = opt[optType].emphasis;

    if (normalOpt) {
      if (true) {
        // eslint-disable-next-line max-len
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_log_js__["g" /* deprecateLog */])("'normal' hierarchy in " + optType + " has been removed since 4.0. All style properties are configured in " + optType + " directly now.");
      } // Timeline controlStyle has other properties besides normal and emphasis


      if (useExtend) {
        opt[optType].normal = opt[optType].emphasis = null;
        __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["defaults"](opt[optType], normalOpt);
      } else {
        opt[optType] = normalOpt;
      }
    }

    if (emphasisOpt) {
      if (true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_log_js__["g" /* deprecateLog */])(optType + ".emphasis has been changed to emphasis." + optType + " since 4.0");
      }

      opt.emphasis = opt.emphasis || {};
      opt.emphasis[optType] = emphasisOpt; // Also compat the case user mix the style and focus together in ec3 style
      // for example: { itemStyle: { normal: {}, emphasis: {focus, shadowBlur} } }

      if (emphasisOpt.focus) {
        opt.emphasis.focus = emphasisOpt.focus;
      }

      if (emphasisOpt.blurScope) {
        opt.emphasis.blurScope = emphasisOpt.blurScope;
      }
    }
  }
}

function removeEC3NormalStatus(opt) {
  convertNormalEmphasis(opt, 'itemStyle');
  convertNormalEmphasis(opt, 'lineStyle');
  convertNormalEmphasis(opt, 'areaStyle');
  convertNormalEmphasis(opt, 'label');
  convertNormalEmphasis(opt, 'labelLine'); // treemap

  convertNormalEmphasis(opt, 'upperLabel'); // graph

  convertNormalEmphasis(opt, 'edgeLabel');
}

function compatTextStyle(opt, propName) {
  // Check whether is not object (string\null\undefined ...)
  var labelOptSingle = isObject(opt) && opt[propName];
  var textStyle = isObject(labelOptSingle) && labelOptSingle.textStyle;

  if (textStyle) {
    if (true) {
      // eslint-disable-next-line max-len
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_log_js__["g" /* deprecateLog */])("textStyle hierarchy in " + propName + " has been removed since 4.0. All textStyle properties are configured in " + propName + " directly now.");
    }

    for (var i = 0, len = __WEBPACK_IMPORTED_MODULE_1__util_model_js__["t" /* TEXT_STYLE_OPTIONS */].length; i < len; i++) {
      var textPropName = __WEBPACK_IMPORTED_MODULE_1__util_model_js__["t" /* TEXT_STYLE_OPTIONS */][i];

      if (textStyle.hasOwnProperty(textPropName)) {
        labelOptSingle[textPropName] = textStyle[textPropName];
      }
    }
  }
}

function compatEC3CommonStyles(opt) {
  if (opt) {
    removeEC3NormalStatus(opt);
    compatTextStyle(opt, 'label');
    opt.emphasis && compatTextStyle(opt.emphasis, 'label');
  }
}

function processSeries(seriesOpt) {
  if (!isObject(seriesOpt)) {
    return;
  }

  compatEC2ItemStyle(seriesOpt);
  removeEC3NormalStatus(seriesOpt);
  compatTextStyle(seriesOpt, 'label'); // treemap

  compatTextStyle(seriesOpt, 'upperLabel'); // graph

  compatTextStyle(seriesOpt, 'edgeLabel');

  if (seriesOpt.emphasis) {
    compatTextStyle(seriesOpt.emphasis, 'label'); // treemap

    compatTextStyle(seriesOpt.emphasis, 'upperLabel'); // graph

    compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
  }

  var markPoint = seriesOpt.markPoint;

  if (markPoint) {
    compatEC2ItemStyle(markPoint);
    compatEC3CommonStyles(markPoint);
  }

  var markLine = seriesOpt.markLine;

  if (markLine) {
    compatEC2ItemStyle(markLine);
    compatEC3CommonStyles(markLine);
  }

  var markArea = seriesOpt.markArea;

  if (markArea) {
    compatEC3CommonStyles(markArea);
  }

  var data = seriesOpt.data; // Break with ec3: if `setOption` again, there may be no `type` in option,
  // then the backward compat based on option type will not be performed.

  if (seriesOpt.type === 'graph') {
    data = data || seriesOpt.nodes;
    var edgeData = seriesOpt.links || seriesOpt.edges;

    if (edgeData && !__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isTypedArray"](edgeData)) {
      for (var i = 0; i < edgeData.length; i++) {
        compatEC3CommonStyles(edgeData[i]);
      }
    }

    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](seriesOpt.categories, function (opt) {
      removeEC3NormalStatus(opt);
    });
  }

  if (data && !__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isTypedArray"](data)) {
    for (var i = 0; i < data.length; i++) {
      compatEC3CommonStyles(data[i]);
    }
  } // mark point data


  markPoint = seriesOpt.markPoint;

  if (markPoint && markPoint.data) {
    var mpData = markPoint.data;

    for (var i = 0; i < mpData.length; i++) {
      compatEC3CommonStyles(mpData[i]);
    }
  } // mark line data


  markLine = seriesOpt.markLine;

  if (markLine && markLine.data) {
    var mlData = markLine.data;

    for (var i = 0; i < mlData.length; i++) {
      if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](mlData[i])) {
        compatEC3CommonStyles(mlData[i][0]);
        compatEC3CommonStyles(mlData[i][1]);
      } else {
        compatEC3CommonStyles(mlData[i]);
      }
    }
  } // Series


  if (seriesOpt.type === 'gauge') {
    compatTextStyle(seriesOpt, 'axisLabel');
    compatTextStyle(seriesOpt, 'title');
    compatTextStyle(seriesOpt, 'detail');
  } else if (seriesOpt.type === 'treemap') {
    convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](seriesOpt.levels, function (opt) {
      removeEC3NormalStatus(opt);
    });
  } else if (seriesOpt.type === 'tree') {
    removeEC3NormalStatus(seriesOpt.leaves);
  } // sunburst starts from ec4, so it does not need to compat levels.

}

function toArr(o) {
  return __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](o) ? o : o ? [o] : [];
}

function toObj(o) {
  return (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](o) ? o[0] : o) || {};
}

function globalCompatStyle(option, isTheme) {
  each(toArr(option.series), function (seriesOpt) {
    isObject(seriesOpt) && processSeries(seriesOpt);
  });
  var axes = ['xAxis', 'yAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'parallelAxis', 'radar'];
  isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
  each(axes, function (axisName) {
    each(toArr(option[axisName]), function (axisOpt) {
      if (axisOpt) {
        compatTextStyle(axisOpt, 'axisLabel');
        compatTextStyle(axisOpt.axisPointer, 'label');
      }
    });
  });
  each(toArr(option.parallel), function (parallelOpt) {
    var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
    compatTextStyle(parallelAxisDefault, 'axisLabel');
    compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
  });
  each(toArr(option.calendar), function (calendarOpt) {
    convertNormalEmphasis(calendarOpt, 'itemStyle');
    compatTextStyle(calendarOpt, 'dayLabel');
    compatTextStyle(calendarOpt, 'monthLabel');
    compatTextStyle(calendarOpt, 'yearLabel');
  }); // radar.name.textStyle

  each(toArr(option.radar), function (radarOpt) {
    compatTextStyle(radarOpt, 'name'); // Use axisName instead of name because component has name property

    if (radarOpt.name && radarOpt.axisName == null) {
      radarOpt.axisName = radarOpt.name;
      delete radarOpt.name;

      if (true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_log_js__["g" /* deprecateLog */])('name property in radar component has been changed to axisName');
      }
    }

    if (radarOpt.nameGap != null && radarOpt.axisNameGap == null) {
      radarOpt.axisNameGap = radarOpt.nameGap;
      delete radarOpt.nameGap;

      if (true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_log_js__["g" /* deprecateLog */])('nameGap property in radar component has been changed to axisNameGap');
      }
    }

    if (true) {
      each(radarOpt.indicator, function (indicatorOpt) {
        if (indicatorOpt.text) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_log_js__["a" /* deprecateReplaceLog */])('text', 'name', 'radar.indicator');
        }
      });
    }
  });
  each(toArr(option.geo), function (geoOpt) {
    if (isObject(geoOpt)) {
      compatEC3CommonStyles(geoOpt);
      each(toArr(geoOpt.regions), function (regionObj) {
        compatEC3CommonStyles(regionObj);
      });
    }
  });
  each(toArr(option.timeline), function (timelineOpt) {
    compatEC3CommonStyles(timelineOpt);
    convertNormalEmphasis(timelineOpt, 'label');
    convertNormalEmphasis(timelineOpt, 'itemStyle');
    convertNormalEmphasis(timelineOpt, 'controlStyle', true);
    var data = timelineOpt.data;
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"](data) && __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](data, function (item) {
      if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"](item)) {
        convertNormalEmphasis(item, 'label');
        convertNormalEmphasis(item, 'itemStyle');
      }
    });
  });
  each(toArr(option.toolbox), function (toolboxOpt) {
    convertNormalEmphasis(toolboxOpt, 'iconStyle');
    each(toolboxOpt.feature, function (featureOpt) {
      convertNormalEmphasis(featureOpt, 'iconStyle');
    });
  });
  compatTextStyle(toObj(option.axisPointer), 'label');
  compatTextStyle(toObj(option.tooltip).axisPointer, 'label'); // Clean logs
  // storedLogs = {};
}

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dataStack;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_number_js__ = __webpack_require__(8);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

 // (1) [Caution]: the logic is correct based on the premises:
//     data processing stage is blocked in stream.
//     See <module:echarts/stream/Scheduler#performDataProcessorTasks>
// (2) Only register once when import repeatly.
//     Should be executed after series filtered and before stack calculation.

function dataStack(ecModel) {
  var stackInfoMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();
  ecModel.eachSeries(function (seriesModel) {
    var stack = seriesModel.get('stack'); // Compatibal: when `stack` is set as '', do not stack.

    if (stack) {
      var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
      var data = seriesModel.getData();
      var stackInfo = {
        // Used for calculate axis extent automatically.
        // TODO: Type getCalculationInfo return more specific type?
        stackResultDimension: data.getCalculationInfo('stackResultDimension'),
        stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
        stackedDimension: data.getCalculationInfo('stackedDimension'),
        stackedByDimension: data.getCalculationInfo('stackedByDimension'),
        isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
        data: data,
        seriesModel: seriesModel
      }; // If stacked on axis that do not support data stack.

      if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) {
        return;
      }

      stackInfoList.length && data.setCalculationInfo('stackedOnSeries', stackInfoList[stackInfoList.length - 1].seriesModel);
      stackInfoList.push(stackInfo);
    }
  });
  stackInfoMap.each(calculateStack);
}

function calculateStack(stackInfoList) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"])(stackInfoList, function (targetStackInfo, idxInStack) {
    var resultVal = [];
    var resultNaN = [NaN, NaN];
    var dims = [targetStackInfo.stackResultDimension, targetStackInfo.stackedOverDimension];
    var targetData = targetStackInfo.data;
    var isStackedByIndex = targetStackInfo.isStackedByIndex; // Should not write on raw data, because stack series model list changes
    // depending on legend selection.

    targetData.modify(dims, function (v0, v1, dataIndex) {
      var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex); // Consider `connectNulls` of line area, if value is NaN, stackedOver
      // should also be NaN, to draw a appropriate belt area.

      if (isNaN(sum)) {
        return resultNaN;
      }

      var byValue;
      var stackedDataRawIndex;

      if (isStackedByIndex) {
        stackedDataRawIndex = targetData.getRawIndex(dataIndex);
      } else {
        byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
      } // If stackOver is NaN, chart view will render point on value start.


      var stackedOver = NaN;

      for (var j = idxInStack - 1; j >= 0; j--) {
        var stackInfo = stackInfoList[j]; // Has been optimized by inverted indices on `stackedByDimension`.

        if (!isStackedByIndex) {
          stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
        }

        if (stackedDataRawIndex >= 0) {
          var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex); // Considering positive stack, negative stack and empty data

          if (sum >= 0 && val > 0 || // Positive stack
          sum <= 0 && val < 0 // Negative stack
          ) {
              // The sum should be as less as possible to be effected
              // by floating arithmetic problem. A wrong result probably
              // filtered incorrectly by axis min/max.
              sum = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_number_js__["o" /* addSafe */])(sum, val);
              stackedOver = val;
              break;
            }
        }
      }

      resultVal[0] = sum;
      resultVal[1] = stackedOver;
      return resultVal;
    });
  });
}

/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = negativeDataFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

function negativeDataFilter(seriesType) {
  return {
    seriesType: seriesType,
    reset: function (seriesModel, ecModel) {
      var data = seriesModel.getData();
      data.filterSelf(function (idx) {
        // handle negative value condition
        var valueDim = data.mapDimension('value');
        var curValue = data.get(valueDim, idx);

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isNumber"])(curValue) && !isNaN(curValue) && curValue < 0) {
          return false;
        }

        return true;
      });
    }
  };
}

/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_canvas_Painter_js__ = __webpack_require__(1695);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

function install(registers) {
  registers.registerPainter('canvas', __WEBPACK_IMPORTED_MODULE_0_zrender_lib_canvas_Painter_js__["a" /* default */]);
}

/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_svg_Painter_js__ = __webpack_require__(1712);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

function install(registers) {
  registers.registerPainter('svg', __WEBPACK_IMPORTED_MODULE_0_zrender_lib_svg_Painter_js__["a" /* default */]);
}

/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Scale_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_number_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Interval_js__ = __webpack_require__(161);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/




 // Use some method of IntervalScale


var scaleProto = __WEBPACK_IMPORTED_MODULE_2__Scale_js__["a" /* default */].prototype; // FIXME:TS refactor: not good to call it directly with `this`?

var intervalScaleProto = __WEBPACK_IMPORTED_MODULE_5__Interval_js__["a" /* default */].prototype;
var roundingErrorFix = __WEBPACK_IMPORTED_MODULE_3__util_number_js__["d" /* round */];
var mathFloor = Math.floor;
var mathCeil = Math.ceil;
var mathPow = Math.pow;
var mathLog = Math.log;

var LogScale =
/** @class */
function (_super) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(LogScale, _super);

  function LogScale() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = 'log';
    _this.base = 10;
    _this._originalScale = new __WEBPACK_IMPORTED_MODULE_5__Interval_js__["a" /* default */](); // FIXME:TS actually used by `IntervalScale`

    _this._interval = 0;
    return _this;
  }
  /**
   * @param Whether expand the ticks to niced extent.
   */


  LogScale.prototype.getTicks = function (expandToNicedExtent) {
    var originalScale = this._originalScale;
    var extent = this._extent;
    var originalExtent = originalScale.getExtent();
    var ticks = intervalScaleProto.getTicks.call(this, expandToNicedExtent);
    return __WEBPACK_IMPORTED_MODULE_1_zrender_lib_core_util_js__["map"](ticks, function (tick) {
      var val = tick.value;
      var powVal = __WEBPACK_IMPORTED_MODULE_3__util_number_js__["d" /* round */](mathPow(this.base, val)); // Fix #4158

      powVal = val === extent[0] && this._fixMin ? fixRoundingError(powVal, originalExtent[0]) : powVal;
      powVal = val === extent[1] && this._fixMax ? fixRoundingError(powVal, originalExtent[1]) : powVal;
      return {
        value: powVal
      };
    }, this);
  };

  LogScale.prototype.setExtent = function (start, end) {
    var base = this.base;
    start = mathLog(start) / mathLog(base);
    end = mathLog(end) / mathLog(base);
    intervalScaleProto.setExtent.call(this, start, end);
  };
  /**
   * @return {number} end
   */


  LogScale.prototype.getExtent = function () {
    var base = this.base;
    var extent = scaleProto.getExtent.call(this);
    extent[0] = mathPow(base, extent[0]);
    extent[1] = mathPow(base, extent[1]); // Fix #4158

    var originalScale = this._originalScale;
    var originalExtent = originalScale.getExtent();
    this._fixMin && (extent[0] = fixRoundingError(extent[0], originalExtent[0]));
    this._fixMax && (extent[1] = fixRoundingError(extent[1], originalExtent[1]));
    return extent;
  };

  LogScale.prototype.unionExtent = function (extent) {
    this._originalScale.unionExtent(extent);

    var base = this.base;
    extent[0] = mathLog(extent[0]) / mathLog(base);
    extent[1] = mathLog(extent[1]) / mathLog(base);
    scaleProto.unionExtent.call(this, extent);
  };

  LogScale.prototype.unionExtentFromData = function (data, dim) {
    // TODO
    // filter value that <= 0
    this.unionExtent(data.getApproximateExtent(dim));
  };
  /**
   * Update interval and extent of intervals for nice ticks
   * @param approxTickNum default 10 Given approx tick number
   */


  LogScale.prototype.calcNiceTicks = function (approxTickNum) {
    approxTickNum = approxTickNum || 10;
    var extent = this._extent;
    var span = extent[1] - extent[0];

    if (span === Infinity || span <= 0) {
      return;
    }

    var interval = __WEBPACK_IMPORTED_MODULE_3__util_number_js__["n" /* quantity */](span);
    var err = approxTickNum / span * interval; // Filter ticks to get closer to the desired count.

    if (err <= 0.5) {
      interval *= 10;
    } // Interval should be integer


    while (!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0) {
      interval *= 10;
    }

    var niceExtent = [__WEBPACK_IMPORTED_MODULE_3__util_number_js__["d" /* round */](mathCeil(extent[0] / interval) * interval), __WEBPACK_IMPORTED_MODULE_3__util_number_js__["d" /* round */](mathFloor(extent[1] / interval) * interval)];
    this._interval = interval;
    this._niceExtent = niceExtent;
  };

  LogScale.prototype.calcNiceExtent = function (opt) {
    intervalScaleProto.calcNiceExtent.call(this, opt);
    this._fixMin = opt.fixMin;
    this._fixMax = opt.fixMax;
  };

  LogScale.prototype.parse = function (val) {
    return val;
  };

  LogScale.prototype.contain = function (val) {
    val = mathLog(val) / mathLog(this.base);
    return __WEBPACK_IMPORTED_MODULE_4__helper_js__["a" /* contain */](val, this._extent);
  };

  LogScale.prototype.normalize = function (val) {
    val = mathLog(val) / mathLog(this.base);
    return __WEBPACK_IMPORTED_MODULE_4__helper_js__["b" /* normalize */](val, this._extent);
  };

  LogScale.prototype.scale = function (val) {
    val = __WEBPACK_IMPORTED_MODULE_4__helper_js__["c" /* scale */](val, this._extent);
    return mathPow(this.base, val);
  };

  LogScale.type = 'log';
  return LogScale;
}(__WEBPACK_IMPORTED_MODULE_2__Scale_js__["a" /* default */]);

var proto = LogScale.prototype;
proto.getMinorTicks = intervalScaleProto.getMinorTicks;
proto.getLabel = intervalScaleProto.getLabel;

function fixRoundingError(val, originalVal) {
  return roundingErrorFix(val, __WEBPACK_IMPORTED_MODULE_3__util_number_js__["e" /* getPrecision */](originalVal));
}

__WEBPACK_IMPORTED_MODULE_2__Scale_js__["a" /* default */].registerClass(LogScale);
/* harmony default export */ __webpack_exports__["a"] = (LogScale);

/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var contrastColor = '#B9B8CE';
var backgroundColor = '#100C2A';

var axisCommon = function () {
  return {
    axisLine: {
      lineStyle: {
        color: contrastColor
      }
    },
    splitLine: {
      lineStyle: {
        color: '#484753'
      }
    },
    splitArea: {
      areaStyle: {
        color: ['rgba(255,255,255,0.02)', 'rgba(255,255,255,0.05)']
      }
    },
    minorSplitLine: {
      lineStyle: {
        color: '#20203B'
      }
    }
  };
};

var colorPalette = ['#4992ff', '#7cffb2', '#fddd60', '#ff6e76', '#58d9f9', '#05c091', '#ff8a45', '#8d48e3', '#dd79ff'];
var theme = {
  darkMode: true,
  color: colorPalette,
  backgroundColor: backgroundColor,
  axisPointer: {
    lineStyle: {
      color: '#817f91'
    },
    crossStyle: {
      color: '#817f91'
    },
    label: {
      // TODO Contrast of label backgorundColor
      color: '#fff'
    }
  },
  legend: {
    textStyle: {
      color: contrastColor
    }
  },
  textStyle: {
    color: contrastColor
  },
  title: {
    textStyle: {
      color: '#EEF1FA'
    },
    subtextStyle: {
      color: '#B9B8CE'
    }
  },
  toolbox: {
    iconStyle: {
      borderColor: contrastColor
    }
  },
  dataZoom: {
    borderColor: '#71708A',
    textStyle: {
      color: contrastColor
    },
    brushStyle: {
      color: 'rgba(135,163,206,0.3)'
    },
    handleStyle: {
      color: '#353450',
      borderColor: '#C5CBE3'
    },
    moveHandleStyle: {
      color: '#B0B6C3',
      opacity: 0.3
    },
    fillerColor: 'rgba(135,163,206,0.2)',
    emphasis: {
      handleStyle: {
        borderColor: '#91B7F2',
        color: '#4D587D'
      },
      moveHandleStyle: {
        color: '#636D9A',
        opacity: 0.7
      }
    },
    dataBackground: {
      lineStyle: {
        color: '#71708A',
        width: 1
      },
      areaStyle: {
        color: '#71708A'
      }
    },
    selectedDataBackground: {
      lineStyle: {
        color: '#87A3CE'
      },
      areaStyle: {
        color: '#87A3CE'
      }
    }
  },
  visualMap: {
    textStyle: {
      color: contrastColor
    }
  },
  timeline: {
    lineStyle: {
      color: contrastColor
    },
    label: {
      color: contrastColor
    },
    controlStyle: {
      color: contrastColor,
      borderColor: contrastColor
    }
  },
  calendar: {
    itemStyle: {
      color: backgroundColor
    },
    dayLabel: {
      color: contrastColor
    },
    monthLabel: {
      color: contrastColor
    },
    yearLabel: {
      color: contrastColor
    }
  },
  timeAxis: axisCommon(),
  logAxis: axisCommon(),
  valueAxis: axisCommon(),
  categoryAxis: axisCommon(),
  line: {
    symbol: 'circle'
  },
  graph: {
    color: colorPalette
  },
  gauge: {
    title: {
      color: contrastColor
    },
    axisLine: {
      lineStyle: {
        color: [[1, 'rgba(207,212,219,0.2)']]
      }
    },
    axisLabel: {
      color: contrastColor
    },
    detail: {
      color: '#EEF1FA'
    }
  },
  candlestick: {
    itemStyle: {
      color: '#f64e56',
      color0: '#54ea92',
      borderColor: '#f64e56',
      borderColor0: '#54ea92' // borderColor: '#ca2824',
      // borderColor0: '#09a443'

    }
  }
};
theme.categoryAxis.splitLine.show = false;
/* harmony default export */ __webpack_exports__["a"] = (theme);

/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var colorAll = ['#37A2DA', '#32C5E9', '#67E0E3', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#E062AE', '#E690D1', '#e7bcf3', '#9d96f5', '#8378EA', '#96BFFF'];
/* harmony default export */ __webpack_exports__["a"] = ({
  color: colorAll,
  colorLayer: [['#37A2DA', '#ffd85c', '#fd7b5f'], ['#37A2DA', '#67E0E3', '#FFDB5C', '#ff9f7f', '#E062AE', '#9d96f5'], ['#37A2DA', '#32C5E9', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#e7bcf3', '#8378EA', '#96BFFF'], colorAll]
});

/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ECEventProcessor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clazz_js__ = __webpack_require__(99);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * Usage of query:
 * `chart.on('click', query, handler);`
 * The `query` can be:
 * + The component type query string, only `mainType` or `mainType.subType`,
 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
 * + The component query object, like:
 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
 * + The data query object, like:
 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
 * + The other query object (cmponent customized query), like:
 *   `{element: 'some'}` (only available in custom series).
 *
 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
 * same as there is no such prop in the `query` object.
 */

var ECEventProcessor =
/** @class */
function () {
  function ECEventProcessor() {}

  ECEventProcessor.prototype.normalizeQuery = function (query) {
    var cptQuery = {};
    var dataQuery = {};
    var otherQuery = {}; // `query` is `mainType` or `mainType.subType` of component.

    if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"](query)) {
      var condCptType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__clazz_js__["f" /* parseClassType */])(query); // `.main` and `.sub` may be ''.

      cptQuery.mainType = condCptType.main || null;
      cptQuery.subType = condCptType.sub || null;
    } // `query` is an object, convert to {mainType, index, name, id}.
    else {
        // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
        // can not be used in `compomentModel.filterForExposedEvent`.
        var suffixes_1 = ['Index', 'Name', 'Id'];
        var dataKeys_1 = {
          name: 1,
          dataIndex: 1,
          dataType: 1
        };
        __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](query, function (val, key) {
          var reserved = false;

          for (var i = 0; i < suffixes_1.length; i++) {
            var propSuffix = suffixes_1[i];
            var suffixPos = key.lastIndexOf(propSuffix);

            if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
              var mainType = key.slice(0, suffixPos); // Consider `dataIndex`.

              if (mainType !== 'data') {
                cptQuery.mainType = mainType;
                cptQuery[propSuffix.toLowerCase()] = val;
                reserved = true;
              }
            }
          }

          if (dataKeys_1.hasOwnProperty(key)) {
            dataQuery[key] = val;
            reserved = true;
          }

          if (!reserved) {
            otherQuery[key] = val;
          }
        });
      }

    return {
      cptQuery: cptQuery,
      dataQuery: dataQuery,
      otherQuery: otherQuery
    };
  };

  ECEventProcessor.prototype.filter = function (eventType, query) {
    // They should be assigned before each trigger call.
    var eventInfo = this.eventInfo;

    if (!eventInfo) {
      return true;
    }

    var targetEl = eventInfo.targetEl;
    var packedEvent = eventInfo.packedEvent;
    var model = eventInfo.model;
    var view = eventInfo.view; // For event like 'globalout'.

    if (!model || !view) {
      return true;
    }

    var cptQuery = query.cptQuery;
    var dataQuery = query.dataQuery;
    return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));

    function check(query, host, prop, propOnHost) {
      return query[prop] == null || host[propOnHost || prop] === query[prop];
    }
  };

  ECEventProcessor.prototype.afterTrigger = function () {
    // Make sure the eventInfo wont be used in next trigger.
    this.eventInfo = null;
  };

  return ECEventProcessor;
}();


;

/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createWrap;

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Animate multiple elements with a single done-callback.
 *
 * @example
 *  animation
 *      .createWrap()
 *      .add(el1, {x: 10, y: 10})
 *      .add(el2, {shape: {width: 500}, style: {fill: 'red'}}, 400)
 *      .done(function () { // done })
 *      .start('cubicOut');
 */
var AnimationWrap =
/** @class */
function () {
  function AnimationWrap() {
    this._storage = [];
    this._elExistsMap = {};
  }
  /**
   * Caution: a el can only be added once, otherwise 'done'
   * might not be called. This method checks this (by el.id),
   * suppresses adding and returns false when existing el found.
   *
   * @return Whether adding succeeded.
   */


  AnimationWrap.prototype.add = function (el, target, duration, delay, easing) {
    if (this._elExistsMap[el.id]) {
      return false;
    }

    this._elExistsMap[el.id] = true;

    this._storage.push({
      el: el,
      target: target,
      duration: duration,
      delay: delay,
      easing: easing
    });

    return true;
  };
  /**
   * Only execute when animation done/aborted.
   */


  AnimationWrap.prototype.finished = function (callback) {
    this._finishedCallback = callback;
    return this;
  };
  /**
   * Will stop exist animation firstly.
   */


  AnimationWrap.prototype.start = function () {
    var _this = this;

    var count = this._storage.length;

    var checkTerminate = function () {
      count--;

      if (count <= 0) {
        // Guard.
        _this._storage.length = 0;
        _this._elExistsMap = {};
        _this._finishedCallback && _this._finishedCallback();
      }
    };

    for (var i = 0, len = this._storage.length; i < len; i++) {
      var item = this._storage[i];
      item.el.animateTo(item.target, {
        duration: item.duration,
        delay: item.delay,
        easing: item.easing,
        setToFinal: true,
        done: checkTerminate,
        aborted: checkTerminate
      });
    }

    return this;
  };

  return AnimationWrap;
}();

function createWrap() {
  return new AnimationWrap();
}

/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseConditionalExpression;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__log_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_helper_dataValueHelper_js__ = __webpack_require__(134);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



;
var RELATIONAL_EXPRESSION_OP_ALIAS_MAP = {
  value: 'eq',
  // PENDING: not good for literal semantic?
  '<': 'lt',
  '<=': 'lte',
  '>': 'gt',
  '>=': 'gte',
  '=': 'eq',
  '!=': 'ne',
  '<>': 'ne' // Might mileading for sake of the different between '==' and '===',
  // So dont support them.
  // '==': 'eq',
  // '===': 'seq',
  // '!==': 'sne'
  // PENDING: Whether support some common alias "ge", "le", "neq"?
  // ge: 'gte',
  // le: 'lte',
  // neq: 'ne',

}; // type RelationalExpressionOpEvaluate = (tarVal: unknown, condVal: unknown) => boolean;

var RegExpEvaluator =
/** @class */
function () {
  function RegExpEvaluator(rVal) {
    // Support condVal: RegExp | string
    var condValue = this._condVal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"])(rVal) ? new RegExp(rVal) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isRegExp"])(rVal) ? rVal : null;

    if (condValue == null) {
      var errMsg = '';

      if (true) {
        errMsg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__log_js__["d" /* makePrintable */])('Illegal regexp', rVal, 'in');
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__log_js__["e" /* throwError */])(errMsg);
    }
  }

  RegExpEvaluator.prototype.evaluate = function (lVal) {
    var type = typeof lVal;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"])(type) ? this._condVal.test(lVal) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isNumber"])(type) ? this._condVal.test(lVal + '') : false;
  };

  return RegExpEvaluator;
}();

var ConstConditionInternal =
/** @class */
function () {
  function ConstConditionInternal() {}

  ConstConditionInternal.prototype.evaluate = function () {
    return this.value;
  };

  return ConstConditionInternal;
}();

var AndConditionInternal =
/** @class */
function () {
  function AndConditionInternal() {}

  AndConditionInternal.prototype.evaluate = function () {
    var children = this.children;

    for (var i = 0; i < children.length; i++) {
      if (!children[i].evaluate()) {
        return false;
      }
    }

    return true;
  };

  return AndConditionInternal;
}();

var OrConditionInternal =
/** @class */
function () {
  function OrConditionInternal() {}

  OrConditionInternal.prototype.evaluate = function () {
    var children = this.children;

    for (var i = 0; i < children.length; i++) {
      if (children[i].evaluate()) {
        return true;
      }
    }

    return false;
  };

  return OrConditionInternal;
}();

var NotConditionInternal =
/** @class */
function () {
  function NotConditionInternal() {}

  NotConditionInternal.prototype.evaluate = function () {
    return !this.child.evaluate();
  };

  return NotConditionInternal;
}();

var RelationalConditionInternal =
/** @class */
function () {
  function RelationalConditionInternal() {}

  RelationalConditionInternal.prototype.evaluate = function () {
    var needParse = !!this.valueParser; // Call getValue with no `this`.

    var getValue = this.getValue;
    var tarValRaw = getValue(this.valueGetterParam);
    var tarValParsed = needParse ? this.valueParser(tarValRaw) : null; // Relational cond follow "and" logic internally.

    for (var i = 0; i < this.subCondList.length; i++) {
      if (!this.subCondList[i].evaluate(needParse ? tarValParsed : tarValRaw)) {
        return false;
      }
    }

    return true;
  };

  return RelationalConditionInternal;
}();

function parseOption(exprOption, getters) {
  if (exprOption === true || exprOption === false) {
    var cond = new ConstConditionInternal();
    cond.value = exprOption;
    return cond;
  }

  var errMsg = '';

  if (!isObjectNotArray(exprOption)) {
    if (true) {
      errMsg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__log_js__["d" /* makePrintable */])('Illegal config. Expect a plain object but actually', exprOption);
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__log_js__["e" /* throwError */])(errMsg);
  }

  if (exprOption.and) {
    return parseAndOrOption('and', exprOption, getters);
  } else if (exprOption.or) {
    return parseAndOrOption('or', exprOption, getters);
  } else if (exprOption.not) {
    return parseNotOption(exprOption, getters);
  }

  return parseRelationalOption(exprOption, getters);
}

function parseAndOrOption(op, exprOption, getters) {
  var subOptionArr = exprOption[op];
  var errMsg = '';

  if (true) {
    errMsg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__log_js__["d" /* makePrintable */])('"and"/"or" condition should only be `' + op + ': [...]` and must not be empty array.', 'Illegal condition:', exprOption);
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArray"])(subOptionArr)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__log_js__["e" /* throwError */])(errMsg);
  }

  if (!subOptionArr.length) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__log_js__["e" /* throwError */])(errMsg);
  }

  var cond = op === 'and' ? new AndConditionInternal() : new OrConditionInternal();
  cond.children = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["map"])(subOptionArr, function (subOption) {
    return parseOption(subOption, getters);
  });

  if (!cond.children.length) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__log_js__["e" /* throwError */])(errMsg);
  }

  return cond;
}

function parseNotOption(exprOption, getters) {
  var subOption = exprOption.not;
  var errMsg = '';

  if (true) {
    errMsg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__log_js__["d" /* makePrintable */])('"not" condition should only be `not: {}`.', 'Illegal condition:', exprOption);
  }

  if (!isObjectNotArray(subOption)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__log_js__["e" /* throwError */])(errMsg);
  }

  var cond = new NotConditionInternal();
  cond.child = parseOption(subOption, getters);

  if (!cond.child) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__log_js__["e" /* throwError */])(errMsg);
  }

  return cond;
}

function parseRelationalOption(exprOption, getters) {
  var errMsg = '';
  var valueGetterParam = getters.prepareGetValue(exprOption);
  var subCondList = [];
  var exprKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["keys"])(exprOption);
  var parserName = exprOption.parser;
  var valueParser = parserName ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_helper_dataValueHelper_js__["c" /* getRawValueParser */])(parserName) : null;

  for (var i = 0; i < exprKeys.length; i++) {
    var keyRaw = exprKeys[i];

    if (keyRaw === 'parser' || getters.valueGetterAttrMap.get(keyRaw)) {
      continue;
    }

    var op = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["hasOwn"])(RELATIONAL_EXPRESSION_OP_ALIAS_MAP, keyRaw) ? RELATIONAL_EXPRESSION_OP_ALIAS_MAP[keyRaw] : keyRaw;
    var condValueRaw = exprOption[keyRaw];
    var condValueParsed = valueParser ? valueParser(condValueRaw) : condValueRaw;
    var evaluator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__data_helper_dataValueHelper_js__["d" /* createFilterComparator */])(op, condValueParsed) || op === 'reg' && new RegExpEvaluator(condValueParsed);

    if (!evaluator) {
      if (true) {
        errMsg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__log_js__["d" /* makePrintable */])('Illegal relational operation: "' + keyRaw + '" in condition:', exprOption);
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__log_js__["e" /* throwError */])(errMsg);
    }

    subCondList.push(evaluator);
  }

  if (!subCondList.length) {
    if (true) {
      errMsg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__log_js__["d" /* makePrintable */])('Relational condition must have at least one operator.', 'Illegal condition:', exprOption);
    } // No relational operator always disabled in case of dangers result.


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__log_js__["e" /* throwError */])(errMsg);
  }

  var cond = new RelationalConditionInternal();
  cond.valueGetterParam = valueGetterParam;
  cond.valueParser = valueParser;
  cond.getValue = getters.getValue;
  cond.subCondList = subCondList;
  return cond;
}

function isObjectNotArray(val) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isObject"])(val) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isArrayLike"])(val);
}

var ConditionalExpressionParsed =
/** @class */
function () {
  function ConditionalExpressionParsed(exprOption, getters) {
    this._cond = parseOption(exprOption, getters);
  }

  ConditionalExpressionParsed.prototype.evaluate = function () {
    return this._cond.evaluate();
  };

  return ConditionalExpressionParsed;
}();

;
function parseConditionalExpression(exprOption, getters) {
  return new ConditionalExpressionParsed(exprOption, getters);
}

/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ariaVisual;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_model_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_mixin_palette_js__ = __webpack_require__(240);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/



var DEFAULT_OPTION = {
  label: {
    enabled: true
  },
  decal: {
    show: false
  }
};
var inner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_model_js__["a" /* makeInner */])();
var decalPaletteScope = {};
function ariaVisual(ecModel, api) {
  var ariaModel = ecModel.getModel('aria'); // See "area enabled" detection code in `GlobalModel.ts`.

  if (!ariaModel.get('enabled')) {
    return;
  }

  var defaultOption = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["clone"](DEFAULT_OPTION);
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["merge"](defaultOption.label, ecModel.getLocaleModel().get('aria'), false);
  __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["merge"](ariaModel.option, defaultOption, false);
  setDecal();
  setLabel();

  function setDecal() {
    var decalModel = ariaModel.getModel('decal');
    var useDecal = decalModel.get('show');

    if (useDecal) {
      // Each type of series use one scope.
      // Pie and funnel are using diferrent scopes
      var paletteScopeGroupByType_1 = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"]();
      ecModel.eachSeries(function (seriesModel) {
        if (seriesModel.isColorBySeries()) {
          return;
        }

        var decalScope = paletteScopeGroupByType_1.get(seriesModel.type);

        if (!decalScope) {
          decalScope = {};
          paletteScopeGroupByType_1.set(seriesModel.type, decalScope);
        }

        inner(seriesModel).scope = decalScope;
      });
      ecModel.eachRawSeries(function (seriesModel) {
        if (ecModel.isSeriesFiltered(seriesModel)) {
          return;
        }

        if (__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"](seriesModel.enableAriaDecal)) {
          // Let series define how to use decal palette on data
          seriesModel.enableAriaDecal();
          return;
        }

        var data = seriesModel.getData();

        if (!seriesModel.isColorBySeries()) {
          var dataAll_1 = seriesModel.getRawData();
          var idxMap_1 = {};
          var decalScope_1 = inner(seriesModel).scope;
          data.each(function (idx) {
            var rawIdx = data.getRawIndex(idx);
            idxMap_1[rawIdx] = idx;
          });
          var dataCount_1 = dataAll_1.count();
          dataAll_1.each(function (rawIdx) {
            var idx = idxMap_1[rawIdx];
            var name = dataAll_1.getName(rawIdx) || rawIdx + '';
            var paletteDecal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__model_mixin_palette_js__["b" /* getDecalFromPalette */])(seriesModel.ecModel, name, decalScope_1, dataCount_1);
            var specifiedDecal = data.getItemVisual(idx, 'decal');
            data.setItemVisual(idx, 'decal', mergeDecal(specifiedDecal, paletteDecal));
          });
        } else {
          var paletteDecal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__model_mixin_palette_js__["b" /* getDecalFromPalette */])(seriesModel.ecModel, seriesModel.name, decalPaletteScope, ecModel.getSeriesCount());
          var specifiedDecal = data.getVisual('decal');
          data.setVisual('decal', mergeDecal(specifiedDecal, paletteDecal));
        }

        function mergeDecal(specifiedDecal, paletteDecal) {
          // Merge decal from palette to decal from itemStyle.
          // User do not need to specify all of the decal props.
          var resultDecal = specifiedDecal ? __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"](__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"]({}, paletteDecal), specifiedDecal) : paletteDecal;
          resultDecal.dirty = true;
          return resultDecal;
        }
      });
    }
  }

  function setLabel() {
    var labelLocale = ecModel.getLocaleModel().get('aria');
    var labelModel = ariaModel.getModel('label');
    labelModel.option = __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["defaults"](labelModel.option, labelLocale);

    if (!labelModel.get('enabled')) {
      return;
    }

    var dom = api.getZr().dom;

    if (labelModel.get('description')) {
      dom.setAttribute('aria-label', labelModel.get('description'));
      return;
    }

    var seriesCnt = ecModel.getSeriesCount();
    var maxDataCnt = labelModel.get(['data', 'maxCount']) || 10;
    var maxSeriesCnt = labelModel.get(['series', 'maxCount']) || 10;
    var displaySeriesCnt = Math.min(seriesCnt, maxSeriesCnt);
    var ariaLabel;

    if (seriesCnt < 1) {
      // No series, no aria label
      return;
    } else {
      var title = getTitle();

      if (title) {
        var withTitle = labelModel.get(['general', 'withTitle']);
        ariaLabel = replace(withTitle, {
          title: title
        });
      } else {
        ariaLabel = labelModel.get(['general', 'withoutTitle']);
      }

      var seriesLabels_1 = [];
      var prefix = seriesCnt > 1 ? labelModel.get(['series', 'multiple', 'prefix']) : labelModel.get(['series', 'single', 'prefix']);
      ariaLabel += replace(prefix, {
        seriesCount: seriesCnt
      });
      ecModel.eachSeries(function (seriesModel, idx) {
        if (idx < displaySeriesCnt) {
          var seriesLabel = void 0;
          var seriesName = seriesModel.get('name');
          var withName = seriesName ? 'withName' : 'withoutName';
          seriesLabel = seriesCnt > 1 ? labelModel.get(['series', 'multiple', withName]) : labelModel.get(['series', 'single', withName]);
          seriesLabel = replace(seriesLabel, {
            seriesId: seriesModel.seriesIndex,
            seriesName: seriesModel.get('name'),
            seriesType: getSeriesTypeName(seriesModel.subType)
          });
          var data = seriesModel.getData();

          if (data.count() > maxDataCnt) {
            // Show part of data
            var partialLabel = labelModel.get(['data', 'partialData']);
            seriesLabel += replace(partialLabel, {
              displayCnt: maxDataCnt
            });
          } else {
            seriesLabel += labelModel.get(['data', 'allData']);
          }

          var middleSeparator_1 = labelModel.get(['data', 'separator', 'middle']);
          var endSeparator_1 = labelModel.get(['data', 'separator', 'end']);
          var dataLabels = [];

          for (var i = 0; i < data.count(); i++) {
            if (i < maxDataCnt) {
              var name_1 = data.getName(i);
              var value = data.getValues(i);
              var dataLabel = labelModel.get(['data', name_1 ? 'withName' : 'withoutName']);
              dataLabels.push(replace(dataLabel, {
                name: name_1,
                value: value.join(middleSeparator_1)
              }));
            }
          }

          seriesLabel += dataLabels.join(middleSeparator_1) + endSeparator_1;
          seriesLabels_1.push(seriesLabel);
        }
      });
      var separatorModel = labelModel.getModel(['series', 'multiple', 'separator']);
      var middleSeparator = separatorModel.get('middle');
      var endSeparator = separatorModel.get('end');
      ariaLabel += seriesLabels_1.join(middleSeparator) + endSeparator;
      dom.setAttribute('aria-label', ariaLabel);
    }
  }

  function replace(str, keyValues) {
    if (!__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isString"](str)) {
      return str;
    }

    var result = str;
    __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["each"](keyValues, function (value, key) {
      result = result.replace(new RegExp('\\{\\s*' + key + '\\s*\\}', 'g'), value);
    });
    return result;
  }

  function getTitle() {
    var title = ecModel.get('title');

    if (title && title.length) {
      title = title[0];
    }

    return title && title.text;
  }

  function getSeriesTypeName(type) {
    return ecModel.getLocaleModel().get(['series', 'typeNames'])[type] || '自定义图';
  }
}

/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = decalVisual;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_decal_js__ = __webpack_require__(241);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

function decalVisual(ecModel, api) {
  ecModel.eachRawSeries(function (seriesModel) {
    if (ecModel.isSeriesFiltered(seriesModel)) {
      return;
    }

    var data = seriesModel.getData();

    if (data.hasItemVisual()) {
      data.each(function (idx) {
        var decal = data.getItemVisual(idx, 'decal');

        if (decal) {
          var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
          itemStyle.decal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_decal_js__["a" /* createOrUpdatePatternFromDecal */])(decal, api);
        }
      });
    }

    var decal = data.getVisual('decal');

    if (decal) {
      var style = data.getVisual('style');
      style.decal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_decal_js__["a" /* createOrUpdatePatternFromDecal */])(decal, api);
    }
  });
}

/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return seriesStyleTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dataStyleTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dataColorPaletteTask; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_mixin_makeStyleMapper_js__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_mixin_itemStyle_js__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_mixin_lineStyle_js__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_Model_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_model_js__ = __webpack_require__(3);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/






var inner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_model_js__["a" /* makeInner */])();
var defaultStyleMappers = {
  itemStyle: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__model_mixin_makeStyleMapper_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__model_mixin_itemStyle_js__["b" /* ITEM_STYLE_KEY_MAP */], true),
  lineStyle: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__model_mixin_makeStyleMapper_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__model_mixin_lineStyle_js__["b" /* LINE_STYLE_KEY_MAP */], true)
};
var defaultColorKey = {
  lineStyle: 'stroke',
  itemStyle: 'fill'
};

function getStyleMapper(seriesModel, stylePath) {
  var styleMapper = seriesModel.visualStyleMapper || defaultStyleMappers[stylePath];

  if (!styleMapper) {
    console.warn("Unkown style type '" + stylePath + "'.");
    return defaultStyleMappers.itemStyle;
  }

  return styleMapper;
}

function getDefaultColorKey(seriesModel, stylePath) {
  // return defaultColorKey[stylePath] ||
  var colorKey = seriesModel.visualDrawType || defaultColorKey[stylePath];

  if (!colorKey) {
    console.warn("Unkown style type '" + stylePath + "'.");
    return 'fill';
  }

  return colorKey;
}

var seriesStyleTask = {
  createOnAllSeries: true,
  performRawSeries: true,
  reset: function (seriesModel, ecModel) {
    var data = seriesModel.getData();
    var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle'; // Set in itemStyle

    var styleModel = seriesModel.getModel(stylePath);
    var getStyle = getStyleMapper(seriesModel, stylePath);
    var globalStyle = getStyle(styleModel);
    var decalOption = styleModel.getShallow('decal');

    if (decalOption) {
      data.setVisual('decal', decalOption);
      decalOption.dirty = true;
    } // TODO


    var colorKey = getDefaultColorKey(seriesModel, stylePath);
    var color = globalStyle[colorKey]; // TODO style callback

    var colorCallback = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"])(color) ? color : null;
    var hasAutoColor = globalStyle.fill === 'auto' || globalStyle.stroke === 'auto'; // Get from color palette by default.

    if (!globalStyle[colorKey] || colorCallback || hasAutoColor) {
      // Note: if some series has color specified (e.g., by itemStyle.color), we DO NOT
      // make it effect palette. Bacause some scenarios users need to make some series
      // transparent or as background, which should better not effect the palette.
      var colorPalette = seriesModel.getColorFromPalette( // TODO series count changed.
      seriesModel.name, null, ecModel.getSeriesCount());

      if (!globalStyle[colorKey]) {
        globalStyle[colorKey] = colorPalette;
        data.setVisual('colorFromPalette', true);
      }

      globalStyle.fill = globalStyle.fill === 'auto' || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"])(globalStyle.fill) ? colorPalette : globalStyle.fill;
      globalStyle.stroke = globalStyle.stroke === 'auto' || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"])(globalStyle.stroke) ? colorPalette : globalStyle.stroke;
    }

    data.setVisual('style', globalStyle);
    data.setVisual('drawType', colorKey); // Only visible series has each data be visual encoded

    if (!ecModel.isSeriesFiltered(seriesModel) && colorCallback) {
      data.setVisual('colorFromPalette', false);
      return {
        dataEach: function (data, idx) {
          var dataParams = seriesModel.getDataParams(idx);
          var itemStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"])({}, globalStyle);
          itemStyle[colorKey] = colorCallback(dataParams);
          data.setItemVisual(idx, 'style', itemStyle);
        }
      };
    }
  }
};
var sharedModel = new __WEBPACK_IMPORTED_MODULE_4__model_Model_js__["a" /* default */]();
var dataStyleTask = {
  createOnAllSeries: true,
  performRawSeries: true,
  reset: function (seriesModel, ecModel) {
    if (seriesModel.ignoreStyleOnData || ecModel.isSeriesFiltered(seriesModel)) {
      return;
    }

    var data = seriesModel.getData();
    var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle'; // Set in itemStyle

    var getStyle = getStyleMapper(seriesModel, stylePath);
    var colorKey = data.getVisual('drawType');
    return {
      dataEach: data.hasItemOption ? function (data, idx) {
        // Not use getItemModel for performance considuration
        var rawItem = data.getRawDataItem(idx);

        if (rawItem && rawItem[stylePath]) {
          sharedModel.option = rawItem[stylePath];
          var style = getStyle(sharedModel);
          var existsStyle = data.ensureUniqueItemVisual(idx, 'style');
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"])(existsStyle, style);

          if (sharedModel.option.decal) {
            data.setItemVisual(idx, 'decal', sharedModel.option.decal);
            sharedModel.option.decal.dirty = true;
          }

          if (colorKey in style) {
            data.setItemVisual(idx, 'colorFromPalette', false);
          }
        }
      } : null
    };
  }
}; // Pick color from palette for the data which has not been set with color yet.
// Note: do not support stream rendering. No such cases yet.

var dataColorPaletteTask = {
  performRawSeries: true,
  overallReset: function (ecModel) {
    // Each type of series use one scope.
    // Pie and funnel are using diferrent scopes
    var paletteScopeGroupByType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["createHashMap"])();
    ecModel.eachSeries(function (seriesModel) {
      var colorBy = seriesModel.getColorBy();

      if (seriesModel.isColorBySeries()) {
        return;
      }

      var key = seriesModel.type + '-' + colorBy;
      var colorScope = paletteScopeGroupByType.get(key);

      if (!colorScope) {
        colorScope = {};
        paletteScopeGroupByType.set(key, colorScope);
      }

      inner(seriesModel).scope = colorScope;
    });
    ecModel.eachSeries(function (seriesModel) {
      if (seriesModel.isColorBySeries() || ecModel.isSeriesFiltered(seriesModel)) {
        return;
      }

      var dataAll = seriesModel.getRawData();
      var idxMap = {};
      var data = seriesModel.getData();
      var colorScope = inner(seriesModel).scope;
      var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
      var colorKey = getDefaultColorKey(seriesModel, stylePath);
      data.each(function (idx) {
        var rawIdx = data.getRawIndex(idx);
        idxMap[rawIdx] = idx;
      }); // Iterate on data before filtered. To make sure color from palette can be
      // Consistent when toggling legend.

      dataAll.each(function (rawIdx) {
        var idx = idxMap[rawIdx];
        var fromPalette = data.getItemVisual(idx, 'colorFromPalette'); // Get color from palette for each data only when the color is inherited from series color, which is
        // also picked from color palette. So following situation is not in the case:
        // 1. series.itemStyle.color is set
        // 2. color is encoded by visualMap

        if (fromPalette) {
          var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
          var name_1 = dataAll.getName(rawIdx) || rawIdx + '';
          var dataCount = dataAll.count();
          itemStyle[colorKey] = seriesModel.getColorFromPalette(name_1, colorScope, dataCount);
        }
      });
    });
  }
};


/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return seriesSymbolTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dataSymbolTask; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__ = __webpack_require__(0);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

var SYMBOL_PROPS_WITH_CB = ['symbol', 'symbolSize', 'symbolRotate', 'symbolOffset'];
var SYMBOL_PROPS = SYMBOL_PROPS_WITH_CB.concat(['symbolKeepAspect']); // Encoding visual for all series include which is filtered for legend drawing

var seriesSymbolTask = {
  createOnAllSeries: true,
  // For legend.
  performRawSeries: true,
  reset: function (seriesModel, ecModel) {
    var data = seriesModel.getData();

    if (seriesModel.legendIcon) {
      data.setVisual('legendIcon', seriesModel.legendIcon);
    }

    if (!seriesModel.hasSymbolVisual) {
      return;
    }

    var symbolOptions = {};
    var symbolOptionsCb = {};
    var hasCallback = false;

    for (var i = 0; i < SYMBOL_PROPS_WITH_CB.length; i++) {
      var symbolPropName = SYMBOL_PROPS_WITH_CB[i];
      var val = seriesModel.get(symbolPropName);

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["isFunction"])(val)) {
        hasCallback = true;
        symbolOptionsCb[symbolPropName] = val;
      } else {
        symbolOptions[symbolPropName] = val;
      }
    }

    symbolOptions.symbol = symbolOptions.symbol || seriesModel.defaultSymbol;
    data.setVisual(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["extend"])({
      legendIcon: seriesModel.legendIcon || symbolOptions.symbol,
      symbolKeepAspect: seriesModel.get('symbolKeepAspect')
    }, symbolOptions)); // Only visible series has each data be visual encoded

    if (ecModel.isSeriesFiltered(seriesModel)) {
      return;
    }

    var symbolPropsCb = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_zrender_lib_core_util_js__["keys"])(symbolOptionsCb);

    function dataEach(data, idx) {
      var rawValue = seriesModel.getRawValue(idx);
      var params = seriesModel.getDataParams(idx);

      for (var i = 0; i < symbolPropsCb.length; i++) {
        var symbolPropName = symbolPropsCb[i];
        data.setItemVisual(idx, symbolPropName, symbolOptionsCb[symbolPropName](rawValue, params));
      }
    }

    return {
      dataEach: hasCallback ? dataEach : null
    };
  }
};
var dataSymbolTask = {
  createOnAllSeries: true,
  // For legend.
  performRawSeries: true,
  reset: function (seriesModel, ecModel) {
    if (!seriesModel.hasSymbolVisual) {
      return;
    } // Only visible series has each data be visual encoded


    if (ecModel.isSeriesFiltered(seriesModel)) {
      return;
    }

    var data = seriesModel.getData();

    function dataEach(data, idx) {
      var itemModel = data.getItemModel(idx);

      for (var i = 0; i < SYMBOL_PROPS.length; i++) {
        var symbolPropName = SYMBOL_PROPS[i];
        var val = itemModel.getShallow(symbolPropName, true);

        if (val != null) {
          data.setItemVisual(idx, symbolPropName, val);
        }
      }
    }

    return {
      dataEach: data.hasItemOption ? dataEach : null
    };
  }
};


/***/ }),
/* 1369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(a,b){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)b();else{b(),a.FileSaver={exports:{}}.exports}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(b,c,d){var e=new XMLHttpRequest;e.open("GET",b),e.responseType="blob",e.onload=function(){a(e.response,c,d)},e.onerror=function(){console.error("could not download file")},e.send()}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send()}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof global&&global.global===global?global:void 0,a=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(a,b,d,e){if(e=e||open("","_blank"),e&&(e.document.title=e.document.body.innerText="downloading..."),"string"==typeof a)return c(a,b,d);var g="application/octet-stream"===a.type,h=/constructor/i.test(f.HTMLElement)||f.safari,i=/CriOS\/[\d]+/.test(navigator.userAgent);if((i||g&&h)&&"object"==typeof FileReader){var j=new FileReader;j.onloadend=function(){var a=j.result;a=i?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),e?e.location.href=a:location=a,e=null},j.readAsDataURL(a)}else{var k=f.URL||f.webkitURL,l=k.createObjectURL(a);e?e.location=l:location.href=l,e=null,setTimeout(function(){k.revokeObjectURL(l)},4E4)}});f.saveAs=a.saveAs=a,"undefined"!=typeof module&&(module.exports=a)});

//# sourceMappingURL=FileSaver.min.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50)))

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1377 */
/***/ (function(module, exports) {

module.exports = isPromise;
module.exports.default = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}


/***/ }),
/* 1378 */
/***/ (function(module, exports) {


;(function(win, lib) {
    var doc = win.document;
    var docEl = doc.documentElement;
    var metaEl = doc.querySelector('meta[name="viewport"]');
    var flexibleEl = doc.querySelector('meta[name="flexible"]');
    var dpr = 0;
    var scale = 0;
    var tid;
    var flexible = lib.flexible || (lib.flexible = {});

    if (metaEl) {
        console.warn('将根据已有的meta标签来设置缩放比例');
        var match = metaEl.getAttribute('content').match(/initial\-scale=([\d\.]+)/);
        if (match) {
            scale = parseFloat(match[1]);
            dpr = parseInt(1 / scale);
        }
    } else if (flexibleEl) {
        var content = flexibleEl.getAttribute('content');
        if (content) {
            var initialDpr = content.match(/initial\-dpr=([\d\.]+)/);
            var maximumDpr = content.match(/maximum\-dpr=([\d\.]+)/);
            if (initialDpr) {
                dpr = parseFloat(initialDpr[1]);
                scale = parseFloat((1 / dpr).toFixed(2));
            }
            if (maximumDpr) {
                dpr = parseFloat(maximumDpr[1]);
                scale = parseFloat((1 / dpr).toFixed(2));
            }
        }
    }

    if (!dpr && !scale) {
        var isAndroid = win.navigator.appVersion.match(/android/gi);
        var isIPhone = win.navigator.appVersion.match(/iphone/gi);
        var devicePixelRatio = win.devicePixelRatio;
        if (isIPhone) {
            // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
            if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
                dpr = 3;
            } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)){
                dpr = 2;
            } else {
                dpr = 1;
            }
        } else {
            // 其他设备下，仍旧使用1倍的方案
            dpr = 1;
        }
        scale = 1 / dpr;
    }

    docEl.setAttribute('data-dpr', dpr);
    if (!metaEl) {
        metaEl = doc.createElement('meta');
        metaEl.setAttribute('name', 'viewport');
        metaEl.setAttribute('content', 'initial-scale=' + scale + ', maximum-scale=' + scale + ', minimum-scale=' + scale + ', user-scalable=no');
        if (docEl.firstElementChild) {
            docEl.firstElementChild.appendChild(metaEl);
        } else {
            var wrap = doc.createElement('div');
            wrap.appendChild(metaEl);
            doc.write(wrap.innerHTML);
        }
    }

    function refreshRem(){
        var width = docEl.getBoundingClientRect().width;
        if (width / dpr < 1200) {
            width = Math.floor(1980 * (width/dpr/1220)) * dpr;
        } else if (width / dpr < 1980) {
            width = 1980 * dpr;
        } else if (width / dpr > 5760) {
            width = 5760 * dpr;
        }
        var rem = width / 10;
        docEl.style.fontSize = rem + 'px';
        flexible.rem = win.rem = rem;
    }

    win.addEventListener('resize', function() {
        clearTimeout(tid);
        tid = setTimeout(refreshRem, 300);
    }, false);
    win.addEventListener('pageshow', function(e) {
        if (e.persisted) {
            clearTimeout(tid);
            tid = setTimeout(refreshRem, 300);
        }
    }, false);

    if (doc.readyState === 'complete') {
        doc.body.style.fontSize = 12 * dpr + 'px';
    } else {
        doc.addEventListener('DOMContentLoaded', function(e) {
            doc.body.style.fontSize = 12 * dpr + 'px';
        }, false);
    }


    refreshRem();

    flexible.dpr = win.dpr = dpr;
    flexible.refreshRem = refreshRem;
    flexible.rem2px = function(d) {
        var val = parseFloat(d) * this.rem;
        if (typeof d === 'string' && d.match(/rem$/)) {
            val += 'px';
        }
        return val;
    }
    flexible.px2rem = function(d) {
        var val = parseFloat(d) / this.rem;
        if (typeof d === 'string' && d.match(/px$/)) {
            val += 'rem';
        }
        return val;
    }

})(window, window['lib'] || (window['lib'] = {}));


/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(87);



/* Built-in method references that are verified to be native. */
var DataView = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'DataView');

/* harmony default export */ __webpack_exports__["a"] = (DataView);


/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hashClear_js__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hashGet_js__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hashHas_js__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hashSet_js__ = __webpack_require__(1427);






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__hashClear_js__["a" /* default */];
Hash.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__["a" /* default */];
Hash.prototype.get = __WEBPACK_IMPORTED_MODULE_2__hashGet_js__["a" /* default */];
Hash.prototype.has = __WEBPACK_IMPORTED_MODULE_3__hashHas_js__["a" /* default */];
Hash.prototype.set = __WEBPACK_IMPORTED_MODULE_4__hashSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Hash);


/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(87);



/* Built-in method references that are verified to be native. */
var Promise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Promise');

/* harmony default export */ __webpack_exports__["a"] = (Promise);


/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(87);



/* Built-in method references that are verified to be native. */
var Set = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(87);


/** Built-in value references. */
var Uint8Array = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Uint8Array;

/* harmony default export */ __webpack_exports__["a"] = (Uint8Array);


/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(87);



/* Built-in method references that are verified to be native. */
var WeakMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayEach);


/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayFilter);


/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(352);



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(source), object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssign);


/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keysIn_js__ = __webpack_require__(201);



/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__keysIn_js__["a" /* default */])(source), object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssignIn);


/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(88);


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (baseCreate);


/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFlattenable_js__ = __webpack_require__(1430);



/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = __WEBPACK_IMPORTED_MODULE_1__isFlattenable_js__["a" /* default */]);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseFlatten);


/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__ = __webpack_require__(1416);


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (baseFor);


/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseHasIn);


/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(115);



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == argsTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArguments);


/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTag_js__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(115);



/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getTag_js__["a" /* default */])(value) == mapTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsMap);


/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMasked_js__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toSource_js__ = __webpack_require__(531);





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isMasked_js__["a" /* default */])(value)) {
    return false;
  }
  var pattern = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__toSource_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNative);


/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTag_js__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(115);



/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getTag_js__["a" /* default */])(value) == setTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsSet);


/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(115);




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) &&
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !!typedArrayTags[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value)];
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsTypedArray);


/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPrototype_js__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__ = __webpack_require__(1446);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isPrototype_js__["a" /* default */])(object)) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__["a" /* default */])(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeys);


/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPrototype_js__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__ = __webpack_require__(1447);




/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(object)) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__["a" /* default */])(object);
  }
  var isProto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isPrototype_js__["a" /* default */])(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeysIn);


/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__copyArray_js__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArguments_js__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isArray_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__ = __webpack_require__(1462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isBuffer_js__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isFunction_js__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__isObject_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__safeGet_js__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__ = __webpack_require__(1471);
















/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(object, key),
      srcValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(srcValue),
        isBuff = !isArr && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__isBuffer_js__["a" /* default */])(srcValue),
        isTyped = !isArr && !isBuff && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__["a" /* default */])(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(objValue)) {
        newValue = objValue;
      }
      else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__["a" /* default */])(objValue)) {
        newValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__copyArray_js__["a" /* default */])(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__["a" /* default */])(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__["a" /* default */])(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__["a" /* default */])(srcValue) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(srcValue)) {
      newValue = objValue;
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(objValue)) {
        newValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__["a" /* default */])(objValue);
      }
      else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__isObject_js__["a" /* default */])(objValue) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__isFunction_js__["a" /* default */])(objValue)) {
        newValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__["a" /* default */])(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, newValue);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMergeDeep);


/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basePickBy_js__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasIn_js__ = __webpack_require__(1461);



/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basePickBy_js__["a" /* default */])(object, paths, function(value, path) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__hasIn_js__["a" /* default */])(object, path);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (basePick);


/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseSet_js__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__castPath_js__ = __webpack_require__(164);




/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);

    if (predicate(value, path)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseSet_js__["a" /* default */])(result, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__castPath_js__["a" /* default */])(path, object), value);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (basePickBy);


/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignValue_js__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__castPath_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isIndex_js__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isObject_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toKey_js__ = __webpack_require__(249);






/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(object)) {
    return object;
  }
  path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__castPath_js__["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__toKey_js__["a" /* default */])(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(objValue)
          ? objValue
          : (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isIndex_js__["a" /* default */])(path[index + 1]) ? [] : {});
      }
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assignValue_js__["a" /* default */])(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/* harmony default export */ __webpack_exports__["a"] = (baseSet);


/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defineProperty_js__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(532);




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */] : function(func, string) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */])(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(string),
    'writable': true
  });
};

/* harmony default export */ __webpack_exports__["a"] = (baseSetToString);


/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseSlice);


/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTimes);


/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(351);





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(value, baseToString) + '';
  }
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToString);


/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__last_js__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parent_js__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toKey_js__ = __webpack_require__(249);





/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);
  object = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__parent_js__["a" /* default */])(object, path);
  return object == null || delete object[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__toKey_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__last_js__["a" /* default */])(path))];
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnset);


/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(342);


/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneDataView);


/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneRegExp);


/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(200);


/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/* harmony default export */ __webpack_exports__["a"] = (cloneSymbol);


/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__(344);



/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */])(source), object);
}

/* harmony default export */ __webpack_exports__["a"] = (copySymbols);


/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__ = __webpack_require__(525);



/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__["a" /* default */])(source), object);
}

/* harmony default export */ __webpack_exports__["a"] = (copySymbolsIn);


/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(87);


/** Used to detect overreaching core-js shims. */
var coreJsData = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__ = __webpack_require__(1431);



/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__["a" /* default */])(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/* harmony default export */ __webpack_exports__["a"] = (createAssigner);


/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createBaseFor);


/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMerge_js__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(88);



/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(objValue) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(srcValue)) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, objValue);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseMerge_js__["a" /* default */])(objValue, srcValue, undefined, customDefaultsMerge, stack);
    stack['delete'](srcValue);
  }
  return objValue;
}

/* harmony default export */ __webpack_exports__["a"] = (customDefaultsMerge);


/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject_js__ = __webpack_require__(533);


/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isPlainObject_js__["a" /* default */])(value) ? undefined : value;
}

/* harmony default export */ __webpack_exports__["a"] = (customOmitClone);


/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(352);




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeys);


/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(200);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (getValue);


/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isIndex_js__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isLength_js__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(249);







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */])(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__isLength_js__["a" /* default */])(length) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isIndex_js__["a" /* default */])(key, length) &&
    (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(object) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (hasPath);


/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(248);


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */])(null) : {};
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (hashClear);


/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (hashDelete);


/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(248);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */]) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (hashGet);


/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(248);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/* harmony default export */ __webpack_exports__["a"] = (hashHas);


/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(248);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (hashSet);


/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneArray);


/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloneDataView_js__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloneRegExp_js__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cloneSymbol_js__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cloneTypedArray_js__ = __webpack_require__(519);






/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cloneDataView_js__["a" /* default */])(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__cloneTypedArray_js__["a" /* default */])(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cloneRegExp_js__["a" /* default */])(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cloneSymbol_js__["a" /* default */])(object);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneByTag);


/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(101);




/** Built-in value references. */
var spreadableSymbol = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/* harmony default export */ __webpack_exports__["a"] = (isFlattenable);


/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isIndex_js__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isObject_js__ = __webpack_require__(88);





/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(object) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isIndex_js__["a" /* default */])(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(object[index], value);
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (isIterateeCall);


/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(351);



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* harmony default export */ __webpack_exports__["a"] = (isKey);


/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ __webpack_exports__["a"] = (isKeyable);


/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__(1414);


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(__WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ __webpack_exports__["a"] = (isMasked);


/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheClear);


/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(245);


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheDelete);


/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(245);


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheGet);


/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(245);


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(this.__data__, key) > -1;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheHas);


/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(245);


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheSet);


/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hash_js__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListCache_js__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map_js__ = __webpack_require__(337);




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */],
    'map': new (__WEBPACK_IMPORTED_MODULE_2__Map_js__["a" /* default */] || __WEBPACK_IMPORTED_MODULE_1__ListCache_js__["a" /* default */]),
    'string': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheClear);


/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(246);


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheDelete);


/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(246);


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheGet);


/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(246);


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheHas);


/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(246);


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheSet);


/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoize_js__ = __webpack_require__(1466);


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__memoize_js__["a" /* default */])(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeCapped);


/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(527);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.keys, Object);

/* harmony default export */ __webpack_exports__["a"] = (nativeKeys);


/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (nativeKeysIn);


/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseSlice_js__ = __webpack_require__(1405);



/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseSlice_js__["a" /* default */])(path, 0, -1));
}

/* harmony default export */ __webpack_exports__["a"] = (parent);


/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (shortOut);


/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(244);


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (stackClear);


/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (stackDelete);


/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackGet);


/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackHas);


/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MapCache_js__ = __webpack_require__(507);




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */]) {
    var pairs = data.__data__;
    if (!__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_2__MapCache_js__["a" /* default */](pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (stackSet);


/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__ = __webpack_require__(1445);


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__["a" /* default */])(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ __webpack_exports__["a"] = (stringToPath);


/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClone_js__ = __webpack_require__(513);


/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseClone_js__["a" /* default */])(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneDeep);


/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (constant);


/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseRest_js__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__customDefaultsMerge_js__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mergeWith_js__ = __webpack_require__(1467);





/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */
var defaultsDeep = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseRest_js__["a" /* default */])(function(args) {
  args.push(undefined, __WEBPACK_IMPORTED_MODULE_2__customDefaultsMerge_js__["a" /* default */]);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__mergeWith_js__["a" /* default */], undefined, args);
});

/* harmony default export */ __webpack_exports__["a"] = (defaultsDeep);


/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__ = __webpack_require__(1390);


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__["a" /* default */])(array, 1) : [];
}

/* harmony default export */ __webpack_exports__["a"] = (flatten);


/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasPath_js__ = __webpack_require__(1422);



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__hasPath_js__["a" /* default */])(object, path, __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (hasIn);


/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(115);



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLikeObject);


/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMap_js__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(347);




/* Node.js helper references. */
var nodeIsMap = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsMap) : __WEBPACK_IMPORTED_MODULE_0__baseIsMap_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isMap);


/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsSet_js__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(347);




/* Node.js helper references. */
var nodeIsSet = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsSet) : __WEBPACK_IMPORTED_MODULE_0__baseIsSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isSet);


/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (last);


/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(507);


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */]);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMerge_js__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAssigner_js__ = __webpack_require__(1415);



/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createAssigner_js__["a" /* default */])(function(object, source, srcIndex, customizer) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseMerge_js__["a" /* default */])(object, source, srcIndex, customizer);
});

/* harmony default export */ __webpack_exports__["a"] = (mergeWith);


/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseClone_js__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseUnset_js__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__castPath_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__copyObject_js__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__customOmitClone_js__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flatRest_js__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getAllKeysIn_js__ = __webpack_require__(524);









/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__flatRest_js__["a" /* default */])(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(paths, function(path) {
    path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__castPath_js__["a" /* default */])(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__copyObject_js__["a" /* default */])(object, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getAllKeysIn_js__["a" /* default */])(object), result);
  if (isDeep) {
    result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseClone_js__["a" /* default */])(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, __WEBPACK_IMPORTED_MODULE_5__customOmitClone_js__["a" /* default */]);
  }
  var length = paths.length;
  while (length--) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseUnset_js__["a" /* default */])(result, paths[length]);
  }
  return result;
});

/* harmony default export */ __webpack_exports__["a"] = (omit);


/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basePick_js__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flatRest_js__ = __webpack_require__(522);



/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__flatRest_js__["a" /* default */])(function(object, paths) {
  return object == null ? {} : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basePick_js__["a" /* default */])(object, paths);
});

/* harmony default export */ __webpack_exports__["a"] = (pick);


/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keysIn_js__ = __webpack_require__(201);



/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(value, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__keysIn_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (toPlainObject);


/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(1407);


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toString);


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var stringify = __webpack_require__(1475);

var Base = function Base(source) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === undefined ? {} : _ref$defaultValue,
      _ref$serialize = _ref.serialize,
      serialize = _ref$serialize === undefined ? stringify : _ref$serialize,
      _ref$deserialize = _ref.deserialize,
      deserialize = _ref$deserialize === undefined ? JSON.parse : _ref$deserialize;

  _classCallCheck(this, Base);

  this.source = source;
  this.defaultValue = defaultValue;
  this.serialize = serialize;
  this.deserialize = deserialize;
};

module.exports = Base;

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global localStorage */
var Base = __webpack_require__(1473);

var LocalStorage = function (_Base) {
  _inherits(LocalStorage, _Base);

  function LocalStorage() {
    _classCallCheck(this, LocalStorage);

    return _possibleConstructorReturn(this, (LocalStorage.__proto__ || Object.getPrototypeOf(LocalStorage)).apply(this, arguments));
  }

  _createClass(LocalStorage, [{
    key: 'read',
    value: function read() {
      var data = localStorage.getItem(this.source);
      if (data) {
        return this.deserialize(data);
      } else {
        localStorage.setItem(this.source, this.serialize(this.defaultValue));
        return this.defaultValue;
      }
    }
  }, {
    key: 'write',
    value: function write(data) {
      localStorage.setItem(this.source, this.serialize(data));
    }
  }]);

  return LocalStorage;
}(Base);

module.exports = LocalStorage;

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Pretty stringify
module.exports = function stringify(obj) {
  return JSON.stringify(obj, null, 2);
};

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var lodash = __webpack_require__(59);
var isPromise = __webpack_require__(1377);

module.exports = function (adapter) {
  if (typeof adapter !== 'object') {
    throw new Error('An adapter must be provided, see https://github.com/typicode/lowdb/#usage');
  }

  // Create a fresh copy of lodash
  var _ = lodash.runInContext();
  var db = _.chain({});

  // Add write function to lodash
  // Calls save before returning result
  _.prototype.write = _.wrap(_.prototype.value, function (func) {
    var funcRes = func.apply(this);
    return db.write(funcRes);
  });

  function plant(state) {
    db.__wrapped__ = state;
    return db;
  }

  // Lowdb API
  // Expose _ for mixins
  db._ = _;

  db.read = function () {
    var r = adapter.read();
    return isPromise(r) ? r.then(plant) : plant(r);
  };

  db.write = function (returnValue) {
    var w = adapter.write(db.getState());
    return isPromise(w) ? w.then(function () {
      return returnValue;
    }) : returnValue;
  };

  db.getState = function () {
    return db.__wrapped__;
  };

  db.setState = function (state) {
    return plant(state);
  };

  return db.read();
};

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, global, process) {/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2020 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pdfjs-dist/build/pdf", [], factory);
	else if(typeof exports === 'object')
		exports["pdfjs-dist/build/pdf"] = factory();
	else
		root["pdfjs-dist/build/pdf"] = root.pdfjsLib = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __w_pdfjs_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__w_pdfjs_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__w_pdfjs_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__w_pdfjs_require__.d = function(exports, name, getter) {
/******/ 		if(!__w_pdfjs_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__w_pdfjs_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__w_pdfjs_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __w_pdfjs_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__w_pdfjs_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __w_pdfjs_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__w_pdfjs_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__w_pdfjs_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__w_pdfjs_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__w_pdfjs_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __w_pdfjs_require__(__w_pdfjs_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var pdfjsVersion = '2.4.456';
var pdfjsBuild = '228a591c';

var pdfjsSharedUtil = __w_pdfjs_require__(1);

var pdfjsDisplayAPI = __w_pdfjs_require__(190);

var pdfjsDisplayTextLayer = __w_pdfjs_require__(205);

var pdfjsDisplayAnnotationLayer = __w_pdfjs_require__(206);

var pdfjsDisplayDisplayUtils = __w_pdfjs_require__(194);

var pdfjsDisplaySVG = __w_pdfjs_require__(207);

var pdfjsDisplayWorkerOptions = __w_pdfjs_require__(199);

var pdfjsDisplayAPICompatibility = __w_pdfjs_require__(196);

{
  var _require = __w_pdfjs_require__(48),
      isNodeJS = _require.isNodeJS;

  if (isNodeJS) {
    var PDFNodeStream = __w_pdfjs_require__(208).PDFNodeStream;

    pdfjsDisplayAPI.setPDFNetworkStreamFactory(function (params) {
      return new PDFNodeStream(params);
    });
  } else {
    var PDFNetworkStream = __w_pdfjs_require__(211).PDFNetworkStream;

    var PDFFetchStream;

    if (pdfjsDisplayDisplayUtils.isFetchSupported()) {
      PDFFetchStream = __w_pdfjs_require__(212).PDFFetchStream;
    }

    pdfjsDisplayAPI.setPDFNetworkStreamFactory(function (params) {
      if (PDFFetchStream && pdfjsDisplayDisplayUtils.isValidFetchUrl(params.url)) {
        return new PDFFetchStream(params);
      }

      return new PDFNetworkStream(params);
    });
  }
}
exports.build = pdfjsDisplayAPI.build;
exports.version = pdfjsDisplayAPI.version;
exports.getDocument = pdfjsDisplayAPI.getDocument;
exports.LoopbackPort = pdfjsDisplayAPI.LoopbackPort;
exports.PDFDataRangeTransport = pdfjsDisplayAPI.PDFDataRangeTransport;
exports.PDFWorker = pdfjsDisplayAPI.PDFWorker;
exports.renderTextLayer = pdfjsDisplayTextLayer.renderTextLayer;
exports.AnnotationLayer = pdfjsDisplayAnnotationLayer.AnnotationLayer;
exports.createPromiseCapability = pdfjsSharedUtil.createPromiseCapability;
exports.PasswordResponses = pdfjsSharedUtil.PasswordResponses;
exports.InvalidPDFException = pdfjsSharedUtil.InvalidPDFException;
exports.MissingPDFException = pdfjsSharedUtil.MissingPDFException;
exports.SVGGraphics = pdfjsDisplaySVG.SVGGraphics;
exports.NativeImageDecoding = pdfjsSharedUtil.NativeImageDecoding;
exports.CMapCompressionType = pdfjsSharedUtil.CMapCompressionType;
exports.PermissionFlag = pdfjsSharedUtil.PermissionFlag;
exports.UnexpectedResponseException = pdfjsSharedUtil.UnexpectedResponseException;
exports.OPS = pdfjsSharedUtil.OPS;
exports.VerbosityLevel = pdfjsSharedUtil.VerbosityLevel;
exports.UNSUPPORTED_FEATURES = pdfjsSharedUtil.UNSUPPORTED_FEATURES;
exports.createValidAbsoluteUrl = pdfjsSharedUtil.createValidAbsoluteUrl;
exports.createObjectURL = pdfjsSharedUtil.createObjectURL;
exports.removeNullCharacters = pdfjsSharedUtil.removeNullCharacters;
exports.shadow = pdfjsSharedUtil.shadow;
exports.Util = pdfjsSharedUtil.Util;
exports.RenderingCancelledException = pdfjsDisplayDisplayUtils.RenderingCancelledException;
exports.getFilenameFromUrl = pdfjsDisplayDisplayUtils.getFilenameFromUrl;
exports.LinkTarget = pdfjsDisplayDisplayUtils.LinkTarget;
exports.addLinkAttributes = pdfjsDisplayDisplayUtils.addLinkAttributes;
exports.loadScript = pdfjsDisplayDisplayUtils.loadScript;
exports.PDFDateString = pdfjsDisplayDisplayUtils.PDFDateString;
exports.GlobalWorkerOptions = pdfjsDisplayWorkerOptions.GlobalWorkerOptions;
exports.apiCompatibilityParams = pdfjsDisplayAPICompatibility.apiCompatibilityParams;

/***/ }),
/* 1 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayByteLength = arrayByteLength;
exports.arraysToBytes = arraysToBytes;
exports.assert = assert;
exports.bytesToString = bytesToString;
exports.createPromiseCapability = createPromiseCapability;
exports.getVerbosityLevel = getVerbosityLevel;
exports.info = info;
exports.isArrayBuffer = isArrayBuffer;
exports.isArrayEqual = isArrayEqual;
exports.isBool = isBool;
exports.isEmptyObj = isEmptyObj;
exports.isNum = isNum;
exports.isString = isString;
exports.isSameOrigin = isSameOrigin;
exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
exports.removeNullCharacters = removeNullCharacters;
exports.setVerbosityLevel = setVerbosityLevel;
exports.shadow = shadow;
exports.string32 = string32;
exports.stringToBytes = stringToBytes;
exports.stringToPDFString = stringToPDFString;
exports.stringToUTF8String = stringToUTF8String;
exports.utf8StringToString = utf8StringToString;
exports.warn = warn;
exports.unreachable = unreachable;
exports.IsEvalSupportedCached = exports.IsLittleEndianCached = exports.createObjectURL = exports.FormatError = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.StreamType = exports.PermissionFlag = exports.PasswordResponses = exports.PasswordException = exports.NativeImageDecoding = exports.MissingPDFException = exports.InvalidPDFException = exports.AbortException = exports.CMapCompressionType = exports.ImageKind = exports.FontType = exports.AnnotationType = exports.AnnotationStateModelType = exports.AnnotationReviewState = exports.AnnotationReplyType = exports.AnnotationMarkedState = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationBorderStyleType = exports.UNSUPPORTED_FEATURES = exports.VerbosityLevel = exports.OPS = exports.IDENTITY_MATRIX = exports.FONT_IDENTITY_MATRIX = exports.BaseException = void 0;

__w_pdfjs_require__(2);

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
var FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
var NativeImageDecoding = {
  NONE: "none",
  DECODE: "decode",
  DISPLAY: "display"
};
exports.NativeImageDecoding = NativeImageDecoding;
var PermissionFlag = {
  PRINT: 0x04,
  MODIFY_CONTENTS: 0x08,
  COPY: 0x10,
  MODIFY_ANNOTATIONS: 0x20,
  FILL_INTERACTIVE_FORMS: 0x100,
  COPY_FOR_ACCESSIBILITY: 0x200,
  ASSEMBLE: 0x400,
  PRINT_HIGH_QUALITY: 0x800
};
exports.PermissionFlag = PermissionFlag;
var TextRenderingMode = {
  FILL: 0,
  STROKE: 1,
  FILL_STROKE: 2,
  INVISIBLE: 3,
  FILL_ADD_TO_PATH: 4,
  STROKE_ADD_TO_PATH: 5,
  FILL_STROKE_ADD_TO_PATH: 6,
  ADD_TO_PATH: 7,
  FILL_STROKE_MASK: 3,
  ADD_TO_PATH_FLAG: 4
};
exports.TextRenderingMode = TextRenderingMode;
var ImageKind = {
  GRAYSCALE_1BPP: 1,
  RGB_24BPP: 2,
  RGBA_32BPP: 3
};
exports.ImageKind = ImageKind;
var AnnotationType = {
  TEXT: 1,
  LINK: 2,
  FREETEXT: 3,
  LINE: 4,
  SQUARE: 5,
  CIRCLE: 6,
  POLYGON: 7,
  POLYLINE: 8,
  HIGHLIGHT: 9,
  UNDERLINE: 10,
  SQUIGGLY: 11,
  STRIKEOUT: 12,
  STAMP: 13,
  CARET: 14,
  INK: 15,
  POPUP: 16,
  FILEATTACHMENT: 17,
  SOUND: 18,
  MOVIE: 19,
  WIDGET: 20,
  SCREEN: 21,
  PRINTERMARK: 22,
  TRAPNET: 23,
  WATERMARK: 24,
  THREED: 25,
  REDACT: 26
};
exports.AnnotationType = AnnotationType;
var AnnotationStateModelType = {
  MARKED: "Marked",
  REVIEW: "Review"
};
exports.AnnotationStateModelType = AnnotationStateModelType;
var AnnotationMarkedState = {
  MARKED: "Marked",
  UNMARKED: "Unmarked"
};
exports.AnnotationMarkedState = AnnotationMarkedState;
var AnnotationReviewState = {
  ACCEPTED: "Accepted",
  REJECTED: "Rejected",
  CANCELLED: "Cancelled",
  COMPLETED: "Completed",
  NONE: "None"
};
exports.AnnotationReviewState = AnnotationReviewState;
var AnnotationReplyType = {
  GROUP: "Group",
  REPLY: "R"
};
exports.AnnotationReplyType = AnnotationReplyType;
var AnnotationFlag = {
  INVISIBLE: 0x01,
  HIDDEN: 0x02,
  PRINT: 0x04,
  NOZOOM: 0x08,
  NOROTATE: 0x10,
  NOVIEW: 0x20,
  READONLY: 0x40,
  LOCKED: 0x80,
  TOGGLENOVIEW: 0x100,
  LOCKEDCONTENTS: 0x200
};
exports.AnnotationFlag = AnnotationFlag;
var AnnotationFieldFlag = {
  READONLY: 0x0000001,
  REQUIRED: 0x0000002,
  NOEXPORT: 0x0000004,
  MULTILINE: 0x0001000,
  PASSWORD: 0x0002000,
  NOTOGGLETOOFF: 0x0004000,
  RADIO: 0x0008000,
  PUSHBUTTON: 0x0010000,
  COMBO: 0x0020000,
  EDIT: 0x0040000,
  SORT: 0x0080000,
  FILESELECT: 0x0100000,
  MULTISELECT: 0x0200000,
  DONOTSPELLCHECK: 0x0400000,
  DONOTSCROLL: 0x0800000,
  COMB: 0x1000000,
  RICHTEXT: 0x2000000,
  RADIOSINUNISON: 0x2000000,
  COMMITONSELCHANGE: 0x4000000
};
exports.AnnotationFieldFlag = AnnotationFieldFlag;
var AnnotationBorderStyleType = {
  SOLID: 1,
  DASHED: 2,
  BEVELED: 3,
  INSET: 4,
  UNDERLINE: 5
};
exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
var StreamType = {
  UNKNOWN: "UNKNOWN",
  FLATE: "FLATE",
  LZW: "LZW",
  DCT: "DCT",
  JPX: "JPX",
  JBIG: "JBIG",
  A85: "A85",
  AHX: "AHX",
  CCF: "CCF",
  RLX: "RLX"
};
exports.StreamType = StreamType;
var FontType = {
  UNKNOWN: "UNKNOWN",
  TYPE1: "TYPE1",
  TYPE1C: "TYPE1C",
  CIDFONTTYPE0: "CIDFONTTYPE0",
  CIDFONTTYPE0C: "CIDFONTTYPE0C",
  TRUETYPE: "TRUETYPE",
  CIDFONTTYPE2: "CIDFONTTYPE2",
  TYPE3: "TYPE3",
  OPENTYPE: "OPENTYPE",
  TYPE0: "TYPE0",
  MMTYPE1: "MMTYPE1"
};
exports.FontType = FontType;
var VerbosityLevel = {
  ERRORS: 0,
  WARNINGS: 1,
  INFOS: 5
};
exports.VerbosityLevel = VerbosityLevel;
var CMapCompressionType = {
  NONE: 0,
  BINARY: 1,
  STREAM: 2
};
exports.CMapCompressionType = CMapCompressionType;
var OPS = {
  dependency: 1,
  setLineWidth: 2,
  setLineCap: 3,
  setLineJoin: 4,
  setMiterLimit: 5,
  setDash: 6,
  setRenderingIntent: 7,
  setFlatness: 8,
  setGState: 9,
  save: 10,
  restore: 11,
  transform: 12,
  moveTo: 13,
  lineTo: 14,
  curveTo: 15,
  curveTo2: 16,
  curveTo3: 17,
  closePath: 18,
  rectangle: 19,
  stroke: 20,
  closeStroke: 21,
  fill: 22,
  eoFill: 23,
  fillStroke: 24,
  eoFillStroke: 25,
  closeFillStroke: 26,
  closeEOFillStroke: 27,
  endPath: 28,
  clip: 29,
  eoClip: 30,
  beginText: 31,
  endText: 32,
  setCharSpacing: 33,
  setWordSpacing: 34,
  setHScale: 35,
  setLeading: 36,
  setFont: 37,
  setTextRenderingMode: 38,
  setTextRise: 39,
  moveText: 40,
  setLeadingMoveText: 41,
  setTextMatrix: 42,
  nextLine: 43,
  showText: 44,
  showSpacedText: 45,
  nextLineShowText: 46,
  nextLineSetSpacingShowText: 47,
  setCharWidth: 48,
  setCharWidthAndBounds: 49,
  setStrokeColorSpace: 50,
  setFillColorSpace: 51,
  setStrokeColor: 52,
  setStrokeColorN: 53,
  setFillColor: 54,
  setFillColorN: 55,
  setStrokeGray: 56,
  setFillGray: 57,
  setStrokeRGBColor: 58,
  setFillRGBColor: 59,
  setStrokeCMYKColor: 60,
  setFillCMYKColor: 61,
  shadingFill: 62,
  beginInlineImage: 63,
  beginImageData: 64,
  endInlineImage: 65,
  paintXObject: 66,
  markPoint: 67,
  markPointProps: 68,
  beginMarkedContent: 69,
  beginMarkedContentProps: 70,
  endMarkedContent: 71,
  beginCompat: 72,
  endCompat: 73,
  paintFormXObjectBegin: 74,
  paintFormXObjectEnd: 75,
  beginGroup: 76,
  endGroup: 77,
  beginAnnotations: 78,
  endAnnotations: 79,
  beginAnnotation: 80,
  endAnnotation: 81,
  paintJpegXObject: 82,
  paintImageMaskXObject: 83,
  paintImageMaskXObjectGroup: 84,
  paintImageXObject: 85,
  paintInlineImageXObject: 86,
  paintInlineImageXObjectGroup: 87,
  paintImageXObjectRepeat: 88,
  paintImageMaskXObjectRepeat: 89,
  paintSolidColorImageMask: 90,
  constructPath: 91
};
exports.OPS = OPS;
var UNSUPPORTED_FEATURES = {
  unknown: "unknown",
  forms: "forms",
  javaScript: "javaScript",
  smask: "smask",
  shadingPattern: "shadingPattern",
  font: "font"
};
exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
var PasswordResponses = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2
};
exports.PasswordResponses = PasswordResponses;
var verbosity = VerbosityLevel.WARNINGS;

function setVerbosityLevel(level) {
  if (Number.isInteger(level)) {
    verbosity = level;
  }
}

function getVerbosityLevel() {
  return verbosity;
}

function info(msg) {
  if (verbosity >= VerbosityLevel.INFOS) {
    console.log("Info: ".concat(msg));
  }
}

function warn(msg) {
  if (verbosity >= VerbosityLevel.WARNINGS) {
    console.log("Warning: ".concat(msg));
  }
}

function unreachable(msg) {
  throw new Error(msg);
}

function assert(cond, msg) {
  if (!cond) {
    unreachable(msg);
  }
}

function isSameOrigin(baseUrl, otherUrl) {
  var base;

  try {
    base = new URL(baseUrl);

    if (!base.origin || base.origin === "null") {
      return false;
    }
  } catch (e) {
    return false;
  }

  var other = new URL(otherUrl, base);
  return base.origin === other.origin;
}

function _isValidProtocol(url) {
  if (!url) {
    return false;
  }

  switch (url.protocol) {
    case "http:":
    case "https:":
    case "ftp:":
    case "mailto:":
    case "tel:":
      return true;

    default:
      return false;
  }
}

function createValidAbsoluteUrl(url, baseUrl) {
  if (!url) {
    return null;
  }

  try {
    var absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);

    if (_isValidProtocol(absoluteUrl)) {
      return absoluteUrl;
    }
  } catch (ex) {}

  return null;
}

function shadow(obj, prop, value) {
  Object.defineProperty(obj, prop, {
    value: value,
    enumerable: true,
    configurable: true,
    writable: false
  });
  return value;
}

var BaseException = function BaseExceptionClosure() {
  function BaseException(message) {
    if (this.constructor === BaseException) {
      unreachable("Cannot initialize BaseException.");
    }

    this.message = message;
    this.name = this.constructor.name;
  }

  BaseException.prototype = new Error();
  BaseException.constructor = BaseException;
  return BaseException;
}();

exports.BaseException = BaseException;

var PasswordException = /*#__PURE__*/function (_BaseException) {
  _inherits(PasswordException, _BaseException);

  function PasswordException(msg, code) {
    var _this;

    _classCallCheck(this, PasswordException);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PasswordException).call(this, msg));
    _this.code = code;
    return _this;
  }

  return PasswordException;
}(BaseException);

exports.PasswordException = PasswordException;

var UnknownErrorException = /*#__PURE__*/function (_BaseException2) {
  _inherits(UnknownErrorException, _BaseException2);

  function UnknownErrorException(msg, details) {
    var _this2;

    _classCallCheck(this, UnknownErrorException);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(UnknownErrorException).call(this, msg));
    _this2.details = details;
    return _this2;
  }

  return UnknownErrorException;
}(BaseException);

exports.UnknownErrorException = UnknownErrorException;

var InvalidPDFException = /*#__PURE__*/function (_BaseException3) {
  _inherits(InvalidPDFException, _BaseException3);

  function InvalidPDFException() {
    _classCallCheck(this, InvalidPDFException);

    return _possibleConstructorReturn(this, _getPrototypeOf(InvalidPDFException).apply(this, arguments));
  }

  return InvalidPDFException;
}(BaseException);

exports.InvalidPDFException = InvalidPDFException;

var MissingPDFException = /*#__PURE__*/function (_BaseException4) {
  _inherits(MissingPDFException, _BaseException4);

  function MissingPDFException() {
    _classCallCheck(this, MissingPDFException);

    return _possibleConstructorReturn(this, _getPrototypeOf(MissingPDFException).apply(this, arguments));
  }

  return MissingPDFException;
}(BaseException);

exports.MissingPDFException = MissingPDFException;

var UnexpectedResponseException = /*#__PURE__*/function (_BaseException5) {
  _inherits(UnexpectedResponseException, _BaseException5);

  function UnexpectedResponseException(msg, status) {
    var _this3;

    _classCallCheck(this, UnexpectedResponseException);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(UnexpectedResponseException).call(this, msg));
    _this3.status = status;
    return _this3;
  }

  return UnexpectedResponseException;
}(BaseException);

exports.UnexpectedResponseException = UnexpectedResponseException;

var FormatError = /*#__PURE__*/function (_BaseException6) {
  _inherits(FormatError, _BaseException6);

  function FormatError() {
    _classCallCheck(this, FormatError);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormatError).apply(this, arguments));
  }

  return FormatError;
}(BaseException);

exports.FormatError = FormatError;

var AbortException = /*#__PURE__*/function (_BaseException7) {
  _inherits(AbortException, _BaseException7);

  function AbortException() {
    _classCallCheck(this, AbortException);

    return _possibleConstructorReturn(this, _getPrototypeOf(AbortException).apply(this, arguments));
  }

  return AbortException;
}(BaseException);

exports.AbortException = AbortException;
var NullCharactersRegExp = /\x00/g;

function removeNullCharacters(str) {
  if (typeof str !== "string") {
    warn("The argument for removeNullCharacters must be a string.");
    return str;
  }

  return str.replace(NullCharactersRegExp, "");
}

function bytesToString(bytes) {
  assert(bytes !== null && _typeof(bytes) === "object" && bytes.length !== undefined, "Invalid argument for bytesToString");
  var length = bytes.length;
  var MAX_ARGUMENT_COUNT = 8192;

  if (length < MAX_ARGUMENT_COUNT) {
    return String.fromCharCode.apply(null, bytes);
  }

  var strBuf = [];

  for (var i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
    var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
    var chunk = bytes.subarray(i, chunkEnd);
    strBuf.push(String.fromCharCode.apply(null, chunk));
  }

  return strBuf.join("");
}

function stringToBytes(str) {
  assert(typeof str === "string", "Invalid argument for stringToBytes");
  var length = str.length;
  var bytes = new Uint8Array(length);

  for (var i = 0; i < length; ++i) {
    bytes[i] = str.charCodeAt(i) & 0xff;
  }

  return bytes;
}

function arrayByteLength(arr) {
  if (arr.length !== undefined) {
    return arr.length;
  }

  assert(arr.byteLength !== undefined);
  return arr.byteLength;
}

function arraysToBytes(arr) {
  var length = arr.length;

  if (length === 1 && arr[0] instanceof Uint8Array) {
    return arr[0];
  }

  var resultLength = 0;

  for (var i = 0; i < length; i++) {
    resultLength += arrayByteLength(arr[i]);
  }

  var pos = 0;
  var data = new Uint8Array(resultLength);

  for (var _i = 0; _i < length; _i++) {
    var item = arr[_i];

    if (!(item instanceof Uint8Array)) {
      if (typeof item === "string") {
        item = stringToBytes(item);
      } else {
        item = new Uint8Array(item);
      }
    }

    var itemLength = item.byteLength;
    data.set(item, pos);
    pos += itemLength;
  }

  return data;
}

function string32(value) {
  return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
}

function isLittleEndian() {
  var buffer8 = new Uint8Array(4);
  buffer8[0] = 1;
  var view32 = new Uint32Array(buffer8.buffer, 0, 1);
  return view32[0] === 1;
}

var IsLittleEndianCached = {
  get value() {
    return shadow(this, "value", isLittleEndian());
  }

};
exports.IsLittleEndianCached = IsLittleEndianCached;

function isEvalSupported() {
  try {
    new Function("");
    return true;
  } catch (e) {
    return false;
  }
}

var IsEvalSupportedCached = {
  get value() {
    return shadow(this, "value", isEvalSupported());
  }

};
exports.IsEvalSupportedCached = IsEvalSupportedCached;
var rgbBuf = ["rgb(", 0, ",", 0, ",", 0, ")"];

var Util = /*#__PURE__*/function () {
  function Util() {
    _classCallCheck(this, Util);
  }

  _createClass(Util, null, [{
    key: "makeCssRgb",
    value: function makeCssRgb(r, g, b) {
      rgbBuf[1] = r;
      rgbBuf[3] = g;
      rgbBuf[5] = b;
      return rgbBuf.join("");
    }
  }, {
    key: "transform",
    value: function transform(m1, m2) {
      return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
    }
  }, {
    key: "applyTransform",
    value: function applyTransform(p, m) {
      var xt = p[0] * m[0] + p[1] * m[2] + m[4];
      var yt = p[0] * m[1] + p[1] * m[3] + m[5];
      return [xt, yt];
    }
  }, {
    key: "applyInverseTransform",
    value: function applyInverseTransform(p, m) {
      var d = m[0] * m[3] - m[1] * m[2];
      var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
      var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
      return [xt, yt];
    }
  }, {
    key: "getAxialAlignedBoundingBox",
    value: function getAxialAlignedBoundingBox(r, m) {
      var p1 = Util.applyTransform(r, m);
      var p2 = Util.applyTransform(r.slice(2, 4), m);
      var p3 = Util.applyTransform([r[0], r[3]], m);
      var p4 = Util.applyTransform([r[2], r[1]], m);
      return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
    }
  }, {
    key: "inverseTransform",
    value: function inverseTransform(m) {
      var d = m[0] * m[3] - m[1] * m[2];
      return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
    }
  }, {
    key: "apply3dTransform",
    value: function apply3dTransform(m, v) {
      return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[3] * v[0] + m[4] * v[1] + m[5] * v[2], m[6] * v[0] + m[7] * v[1] + m[8] * v[2]];
    }
  }, {
    key: "singularValueDecompose2dScale",
    value: function singularValueDecompose2dScale(m) {
      var transpose = [m[0], m[2], m[1], m[3]];
      var a = m[0] * transpose[0] + m[1] * transpose[2];
      var b = m[0] * transpose[1] + m[1] * transpose[3];
      var c = m[2] * transpose[0] + m[3] * transpose[2];
      var d = m[2] * transpose[1] + m[3] * transpose[3];
      var first = (a + d) / 2;
      var second = Math.sqrt((a + d) * (a + d) - 4 * (a * d - c * b)) / 2;
      var sx = first + second || 1;
      var sy = first - second || 1;
      return [Math.sqrt(sx), Math.sqrt(sy)];
    }
  }, {
    key: "normalizeRect",
    value: function normalizeRect(rect) {
      var r = rect.slice(0);

      if (rect[0] > rect[2]) {
        r[0] = rect[2];
        r[2] = rect[0];
      }

      if (rect[1] > rect[3]) {
        r[1] = rect[3];
        r[3] = rect[1];
      }

      return r;
    }
  }, {
    key: "intersect",
    value: function intersect(rect1, rect2) {
      function compare(a, b) {
        return a - b;
      }

      var orderedX = [rect1[0], rect1[2], rect2[0], rect2[2]].sort(compare);
      var orderedY = [rect1[1], rect1[3], rect2[1], rect2[3]].sort(compare);
      var result = [];
      rect1 = Util.normalizeRect(rect1);
      rect2 = Util.normalizeRect(rect2);

      if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
        result[0] = orderedX[1];
        result[2] = orderedX[2];
      } else {
        return null;
      }

      if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
        result[1] = orderedY[1];
        result[3] = orderedY[2];
      } else {
        return null;
      }

      return result;
    }
  }]);

  return Util;
}();

exports.Util = Util;
var PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2D8, 0x2C7, 0x2C6, 0x2D9, 0x2DD, 0x2DB, 0x2DA, 0x2DC, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203A, 0x2212, 0x2030, 0x201E, 0x201C, 0x201D, 0x2018, 0x2019, 0x201A, 0x2122, 0xFB01, 0xFB02, 0x141, 0x152, 0x160, 0x178, 0x17D, 0x131, 0x142, 0x153, 0x161, 0x17E, 0, 0x20AC];

function stringToPDFString(str) {
  var length = str.length,
      strBuf = [];

  if (str[0] === "\xFE" && str[1] === "\xFF") {
    for (var i = 2; i < length; i += 2) {
      strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)));
    }
  } else if (str[0] === "\xFF" && str[1] === "\xFE") {
    for (var _i2 = 2; _i2 < length; _i2 += 2) {
      strBuf.push(String.fromCharCode(str.charCodeAt(_i2 + 1) << 8 | str.charCodeAt(_i2)));
    }
  } else {
    for (var _i3 = 0; _i3 < length; ++_i3) {
      var code = PDFStringTranslateTable[str.charCodeAt(_i3)];
      strBuf.push(code ? String.fromCharCode(code) : str.charAt(_i3));
    }
  }

  return strBuf.join("");
}

function stringToUTF8String(str) {
  return decodeURIComponent(escape(str));
}

function utf8StringToString(str) {
  return unescape(encodeURIComponent(str));
}

function isEmptyObj(obj) {
  for (var key in obj) {
    return false;
  }

  return true;
}

function isBool(v) {
  return typeof v === "boolean";
}

function isNum(v) {
  return typeof v === "number";
}

function isString(v) {
  return typeof v === "string";
}

function isArrayBuffer(v) {
  return _typeof(v) === "object" && v !== null && v.byteLength !== undefined;
}

function isArrayEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false;
  }

  return arr1.every(function (element, index) {
    return element === arr2[index];
  });
}

function createPromiseCapability() {
  var capability = Object.create(null);
  var isSettled = false;
  Object.defineProperty(capability, "settled", {
    get: function get() {
      return isSettled;
    }
  });
  capability.promise = new Promise(function (resolve, reject) {
    capability.resolve = function (data) {
      isSettled = true;
      resolve(data);
    };

    capability.reject = function (reason) {
      isSettled = true;
      reject(reason);
    };
  });
  return capability;
}

var createObjectURL = function createObjectURLClosure() {
  var digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  return function createObjectURL(data, contentType) {
    var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!forceDataSchema && URL.createObjectURL) {
      var blob = new Blob([data], {
        type: contentType
      });
      return URL.createObjectURL(blob);
    }

    var buffer = "data:".concat(contentType, ";base64,");

    for (var i = 0, ii = data.length; i < ii; i += 3) {
      var b1 = data[i] & 0xff;
      var b2 = data[i + 1] & 0xff;
      var b3 = data[i + 2] & 0xff;
      var d1 = b1 >> 2,
          d2 = (b1 & 3) << 4 | b2 >> 4;
      var d3 = i + 1 < ii ? (b2 & 0xf) << 2 | b3 >> 6 : 64;
      var d4 = i + 2 < ii ? b3 & 0x3f : 64;
      buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
    }

    return buffer;
  };
}();

exports.createObjectURL = createObjectURL;

/***/ }),
/* 2 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

if (typeof globalThis === "undefined" || !globalThis._pdfjsCompatibilityChecked) {
  if (typeof globalThis === "undefined" || globalThis.Math !== Math) {
    globalThis = __w_pdfjs_require__(3);
  }

  globalThis._pdfjsCompatibilityChecked = true;

  var _require = __w_pdfjs_require__(48),
      isNodeJS = _require.isNodeJS;

  var hasDOM = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === "object";
  var userAgent = typeof navigator !== "undefined" && navigator.userAgent || "";
  var isIE = /Trident/.test(userAgent);

  (function checkNodeBtoa() {
    if (globalThis.btoa || !isNodeJS) {
      return;
    }

    globalThis.btoa = function (chars) {
      return Buffer.from(chars, "binary").toString("base64");
    };
  })();

  (function checkNodeAtob() {
    if (globalThis.atob || !isNodeJS) {
      return;
    }

    globalThis.atob = function (input) {
      return Buffer.from(input, "base64").toString("binary");
    };
  })();

  (function checkChildNodeRemove() {
    if (!hasDOM) {
      return;
    }

    if (typeof Element.prototype.remove !== "undefined") {
      return;
    }

    Element.prototype.remove = function () {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  })();

  (function checkDOMTokenListAddRemove() {
    if (!hasDOM || isNodeJS) {
      return;
    }

    var div = document.createElement("div");
    div.classList.add("testOne", "testTwo");

    if (div.classList.contains("testOne") === true && div.classList.contains("testTwo") === true) {
      return;
    }

    var OriginalDOMTokenListAdd = DOMTokenList.prototype.add;
    var OriginalDOMTokenListRemove = DOMTokenList.prototype.remove;

    DOMTokenList.prototype.add = function () {
      for (var _len = arguments.length, tokens = new Array(_len), _key = 0; _key < _len; _key++) {
        tokens[_key] = arguments[_key];
      }

      for (var _i = 0, _tokens = tokens; _i < _tokens.length; _i++) {
        var token = _tokens[_i];
        OriginalDOMTokenListAdd.call(this, token);
      }
    };

    DOMTokenList.prototype.remove = function () {
      for (var _len2 = arguments.length, tokens = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        tokens[_key2] = arguments[_key2];
      }

      for (var _i2 = 0, _tokens2 = tokens; _i2 < _tokens2.length; _i2++) {
        var token = _tokens2[_i2];
        OriginalDOMTokenListRemove.call(this, token);
      }
    };
  })();

  (function checkDOMTokenListToggle() {
    if (!hasDOM || isNodeJS) {
      return;
    }

    var div = document.createElement("div");

    if (div.classList.toggle("test", 0) === false) {
      return;
    }

    DOMTokenList.prototype.toggle = function (token) {
      var force = arguments.length > 1 ? !!arguments[1] : !this.contains(token);
      return this[force ? "add" : "remove"](token), force;
    };
  })();

  (function checkWindowHistoryPushStateReplaceState() {
    if (!hasDOM || !isIE) {
      return;
    }

    var OriginalPushState = window.history.pushState;
    var OriginalReplaceState = window.history.replaceState;

    window.history.pushState = function (state, title, url) {
      var args = url === undefined ? [state, title] : [state, title, url];
      OriginalPushState.apply(this, args);
    };

    window.history.replaceState = function (state, title, url) {
      var args = url === undefined ? [state, title] : [state, title, url];
      OriginalReplaceState.apply(this, args);
    };
  })();

  (function checkStringStartsWith() {
    if (String.prototype.startsWith) {
      return;
    }

    __w_pdfjs_require__(49);
  })();

  (function checkStringEndsWith() {
    if (String.prototype.endsWith) {
      return;
    }

    __w_pdfjs_require__(60);
  })();

  (function checkStringIncludes() {
    if (String.prototype.includes) {
      return;
    }

    __w_pdfjs_require__(62);
  })();

  (function checkArrayIncludes() {
    if (Array.prototype.includes) {
      return;
    }

    __w_pdfjs_require__(64);
  })();

  (function checkArrayFrom() {
    if (Array.from) {
      return;
    }

    __w_pdfjs_require__(72);
  })();

  (function checkObjectAssign() {
    if (Object.assign) {
      return;
    }

    __w_pdfjs_require__(94);
  })();

  (function checkMathLog2() {
    if (Math.log2) {
      return;
    }

    Math.log2 = __w_pdfjs_require__(97);
  })();

  (function checkNumberIsNaN() {
    if (Number.isNaN) {
      return;
    }

    Number.isNaN = __w_pdfjs_require__(99);
  })();

  (function checkNumberIsInteger() {
    if (Number.isInteger) {
      return;
    }

    Number.isInteger = __w_pdfjs_require__(101);
  })();

  (function checkPromise() {
    if (globalThis.Promise && globalThis.Promise.allSettled) {
      return;
    }

    globalThis.Promise = __w_pdfjs_require__(104);
  })();

  (function checkURL() {
    globalThis.URL = __w_pdfjs_require__(128);
  })();

  (function checkReadableStream() {
    var isReadableStreamSupported = false;

    if (typeof ReadableStream !== "undefined") {
      try {
        new ReadableStream({
          start: function start(controller) {
            controller.close();
          }
        });
        isReadableStreamSupported = true;
      } catch (e) {}
    }

    if (isReadableStreamSupported) {
      return;
    }

    globalThis.ReadableStream = __w_pdfjs_require__(135).ReadableStream;
  })();

  (function checkMapEntries() {
    if (globalThis.Map && globalThis.Map.prototype.entries) {
      return;
    }

    globalThis.Map = __w_pdfjs_require__(136);
  })();

  (function checkSetEntries() {
    if (globalThis.Set && globalThis.Set.prototype.entries) {
      return;
    }

    globalThis.Set = __w_pdfjs_require__(143);
  })();

  (function checkWeakMap() {
    if (globalThis.WeakMap) {
      return;
    }

    globalThis.WeakMap = __w_pdfjs_require__(145);
  })();

  (function checkWeakSet() {
    if (globalThis.WeakSet) {
      return;
    }

    globalThis.WeakSet = __w_pdfjs_require__(151);
  })();

  (function checkStringCodePointAt() {
    if (String.prototype.codePointAt) {
      return;
    }

    __w_pdfjs_require__(153);
  })();

  (function checkStringFromCodePoint() {
    if (String.fromCodePoint) {
      return;
    }

    String.fromCodePoint = __w_pdfjs_require__(155);
  })();

  (function checkSymbol() {
    if (globalThis.Symbol) {
      return;
    }

    __w_pdfjs_require__(157);
  })();

  (function checkStringPadStart() {
    if (String.prototype.padStart) {
      return;
    }

    __w_pdfjs_require__(180);
  })();

  (function checkStringPadEnd() {
    if (String.prototype.padEnd) {
      return;
    }

    __w_pdfjs_require__(185);
  })();

  (function checkObjectValues() {
    if (Object.values) {
      return;
    }

    Object.values = __w_pdfjs_require__(187);
  })();
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(4);
module.exports = __w_pdfjs_require__(6);

/***/ }),
/* 4 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var $ = __w_pdfjs_require__(5);
var global = __w_pdfjs_require__(6);
$({ global: true }, { globalThis: global });

/***/ }),
/* 5 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var global = __w_pdfjs_require__(6);
var getOwnPropertyDescriptor = __w_pdfjs_require__(7).f;
var createNonEnumerableProperty = __w_pdfjs_require__(21);
var redefine = __w_pdfjs_require__(24);
var setGlobal = __w_pdfjs_require__(25);
var copyConstructorProperties = __w_pdfjs_require__(35);
var isForced = __w_pdfjs_require__(47);
module.exports = function (options, source) {
 var TARGET = options.target;
 var GLOBAL = options.global;
 var STATIC = options.stat;
 var FORCED, target, key, targetProperty, sourceProperty, descriptor;
 if (GLOBAL) {
  target = global;
 } else if (STATIC) {
  target = global[TARGET] || setGlobal(TARGET, {});
 } else {
  target = (global[TARGET] || {}).prototype;
 }
 if (target)
  for (key in source) {
   sourceProperty = source[key];
   if (options.noTargetGet) {
    descriptor = getOwnPropertyDescriptor(target, key);
    targetProperty = descriptor && descriptor.value;
   } else
    targetProperty = target[key];
   FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
   if (!FORCED && targetProperty !== undefined) {
    if (typeof sourceProperty === typeof targetProperty)
     continue;
    copyConstructorProperties(sourceProperty, targetProperty);
   }
   if (options.sham || targetProperty && targetProperty.sham) {
    createNonEnumerableProperty(sourceProperty, 'sham', true);
   }
   redefine(target, key, sourceProperty, options);
  }
};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

var check = function (it) {
 return it && it.Math == Math && it;
};
module.exports = check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || check(typeof self == 'object' && self) || check(typeof global == 'object' && global) || Function('return this')();

/***/ }),
/* 7 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var DESCRIPTORS = __w_pdfjs_require__(8);
var propertyIsEnumerableModule = __w_pdfjs_require__(10);
var createPropertyDescriptor = __w_pdfjs_require__(11);
var toIndexedObject = __w_pdfjs_require__(12);
var toPrimitive = __w_pdfjs_require__(16);
var has = __w_pdfjs_require__(18);
var IE8_DOM_DEFINE = __w_pdfjs_require__(19);
var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
 O = toIndexedObject(O);
 P = toPrimitive(P, true);
 if (IE8_DOM_DEFINE)
  try {
   return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) {
  }
 if (has(O, P))
  return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var fails = __w_pdfjs_require__(9);
module.exports = !fails(function () {
 return Object.defineProperty({}, 1, {
  get: function () {
   return 7;
  }
 })[1] != 7;
});

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = function (exec) {
 try {
  return !!exec();
 } catch (error) {
  return true;
 }
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
 var descriptor = getOwnPropertyDescriptor(this, V);
 return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
 return {
  enumerable: !(bitmap & 1),
  configurable: !(bitmap & 2),
  writable: !(bitmap & 4),
  value: value
 };
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var IndexedObject = __w_pdfjs_require__(13);
var requireObjectCoercible = __w_pdfjs_require__(15);
module.exports = function (it) {
 return IndexedObject(requireObjectCoercible(it));
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var fails = __w_pdfjs_require__(9);
var classof = __w_pdfjs_require__(14);
var split = ''.split;
module.exports = fails(function () {
 return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
 return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

var toString = {}.toString;
module.exports = function (it) {
 return toString.call(it).slice(8, -1);
};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = function (it) {
 if (it == undefined)
  throw TypeError("Can't call method on " + it);
 return it;
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var isObject = __w_pdfjs_require__(17);
module.exports = function (input, PREFERRED_STRING) {
 if (!isObject(input))
  return input;
 var fn, val;
 if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input)))
  return val;
 if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input)))
  return val;
 if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input)))
  return val;
 throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function (it) {
 return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 18 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
 return hasOwnProperty.call(it, key);
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var DESCRIPTORS = __w_pdfjs_require__(8);
var fails = __w_pdfjs_require__(9);
var createElement = __w_pdfjs_require__(20);
module.exports = !DESCRIPTORS && !fails(function () {
 return Object.defineProperty(createElement('div'), 'a', {
  get: function () {
   return 7;
  }
 }).a != 7;
});

/***/ }),
/* 20 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var global = __w_pdfjs_require__(6);
var isObject = __w_pdfjs_require__(17);
var document = global.document;
var EXISTS = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
 return EXISTS ? document.createElement(it) : {};
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var DESCRIPTORS = __w_pdfjs_require__(8);
var definePropertyModule = __w_pdfjs_require__(22);
var createPropertyDescriptor = __w_pdfjs_require__(11);
module.exports = DESCRIPTORS ? function (object, key, value) {
 return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
 object[key] = value;
 return object;
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var DESCRIPTORS = __w_pdfjs_require__(8);
var IE8_DOM_DEFINE = __w_pdfjs_require__(19);
var anObject = __w_pdfjs_require__(23);
var toPrimitive = __w_pdfjs_require__(16);
var nativeDefineProperty = Object.defineProperty;
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
 anObject(O);
 P = toPrimitive(P, true);
 anObject(Attributes);
 if (IE8_DOM_DEFINE)
  try {
   return nativeDefineProperty(O, P, Attributes);
  } catch (error) {
  }
 if ('get' in Attributes || 'set' in Attributes)
  throw TypeError('Accessors not supported');
 if ('value' in Attributes)
  O[P] = Attributes.value;
 return O;
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var isObject = __w_pdfjs_require__(17);
module.exports = function (it) {
 if (!isObject(it)) {
  throw TypeError(String(it) + ' is not an object');
 }
 return it;
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var global = __w_pdfjs_require__(6);
var createNonEnumerableProperty = __w_pdfjs_require__(21);
var has = __w_pdfjs_require__(18);
var setGlobal = __w_pdfjs_require__(25);
var inspectSource = __w_pdfjs_require__(26);
var InternalStateModule = __w_pdfjs_require__(28);
var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');
(module.exports = function (O, key, value, options) {
 var unsafe = options ? !!options.unsafe : false;
 var simple = options ? !!options.enumerable : false;
 var noTargetGet = options ? !!options.noTargetGet : false;
 if (typeof value == 'function') {
  if (typeof key == 'string' && !has(value, 'name'))
   createNonEnumerableProperty(value, 'name', key);
  enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
 }
 if (O === global) {
  if (simple)
   O[key] = value;
  else
   setGlobal(key, value);
  return;
 } else if (!unsafe) {
  delete O[key];
 } else if (!noTargetGet && O[key]) {
  simple = true;
 }
 if (simple)
  O[key] = value;
 else
  createNonEnumerableProperty(O, key, value);
})(Function.prototype, 'toString', function toString() {
 return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});

/***/ }),
/* 25 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var global = __w_pdfjs_require__(6);
var createNonEnumerableProperty = __w_pdfjs_require__(21);
module.exports = function (key, value) {
 try {
  createNonEnumerableProperty(global, key, value);
 } catch (error) {
  global[key] = value;
 }
 return value;
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var store = __w_pdfjs_require__(27);
var functionToString = Function.toString;
if (typeof store.inspectSource != 'function') {
 store.inspectSource = function (it) {
  return functionToString.call(it);
 };
}
module.exports = store.inspectSource;

/***/ }),
/* 27 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var global = __w_pdfjs_require__(6);
var setGlobal = __w_pdfjs_require__(25);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});
module.exports = store;

/***/ }),
/* 28 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var NATIVE_WEAK_MAP = __w_pdfjs_require__(29);
var global = __w_pdfjs_require__(6);
var isObject = __w_pdfjs_require__(17);
var createNonEnumerableProperty = __w_pdfjs_require__(21);
var objectHas = __w_pdfjs_require__(18);
var sharedKey = __w_pdfjs_require__(30);
var hiddenKeys = __w_pdfjs_require__(34);
var WeakMap = global.WeakMap;
var set, get, has;
var enforce = function (it) {
 return has(it) ? get(it) : set(it, {});
};
var getterFor = function (TYPE) {
 return function (it) {
  var state;
  if (!isObject(it) || (state = get(it)).type !== TYPE) {
   throw TypeError('Incompatible receiver, ' + TYPE + ' required');
  }
  return state;
 };
};
if (NATIVE_WEAK_MAP) {
 var store = new WeakMap();
 var wmget = store.get;
 var wmhas = store.has;
 var wmset = store.set;
 set = function (it, metadata) {
  wmset.call(store, it, metadata);
  return metadata;
 };
 get = function (it) {
  return wmget.call(store, it) || {};
 };
 has = function (it) {
  return wmhas.call(store, it);
 };
} else {
 var STATE = sharedKey('state');
 hiddenKeys[STATE] = true;
 set = function (it, metadata) {
  createNonEnumerableProperty(it, STATE, metadata);
  return metadata;
 };
 get = function (it) {
  return objectHas(it, STATE) ? it[STATE] : {};
 };
 has = function (it) {
  return objectHas(it, STATE);
 };
}
module.exports = {
 set: set,
 get: get,
 has: has,
 enforce: enforce,
 getterFor: getterFor
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var global = __w_pdfjs_require__(6);
var inspectSource = __w_pdfjs_require__(26);
var WeakMap = global.WeakMap;
module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));

/***/ }),
/* 30 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var shared = __w_pdfjs_require__(31);
var uid = __w_pdfjs_require__(33);
var keys = shared('keys');
module.exports = function (key) {
 return keys[key] || (keys[key] = uid(key));
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var IS_PURE = __w_pdfjs_require__(32);
var store = __w_pdfjs_require__(27);
(module.exports = function (key, value) {
 return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
 version: '3.6.4',
 mode: IS_PURE ? 'pure' : 'global',
 copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = false;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();
module.exports = function (key) {
 return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 35 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var has = __w_pdfjs_require__(18);
var ownKeys = __w_pdfjs_require__(36);
var getOwnPropertyDescriptorModule = __w_pdfjs_require__(7);
var definePropertyModule = __w_pdfjs_require__(22);
module.exports = function (target, source) {
 var keys = ownKeys(source);
 var defineProperty = definePropertyModule.f;
 var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
 for (var i = 0; i < keys.length; i++) {
  var key = keys[i];
  if (!has(target, key))
   defineProperty(target, key, getOwnPropertyDescriptor(source, key));
 }
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var getBuiltIn = __w_pdfjs_require__(37);
var getOwnPropertyNamesModule = __w_pdfjs_require__(39);
var getOwnPropertySymbolsModule = __w_pdfjs_require__(46);
var anObject = __w_pdfjs_require__(23);
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
 var keys = getOwnPropertyNamesModule.f(anObject(it));
 var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
 return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var path = __w_pdfjs_require__(38);
var global = __w_pdfjs_require__(6);
var aFunction = function (variable) {
 return typeof variable == 'function' ? variable : undefined;
};
module.exports = function (namespace, method) {
 return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace]) : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var global = __w_pdfjs_require__(6);
module.exports = global;

/***/ }),
/* 39 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var internalObjectKeys = __w_pdfjs_require__(40);
var enumBugKeys = __w_pdfjs_require__(45);
var hiddenKeys = enumBugKeys.concat('length', 'prototype');
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
 return internalObjectKeys(O, hiddenKeys);
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var has = __w_pdfjs_require__(18);
var toIndexedObject = __w_pdfjs_require__(12);
var indexOf = __w_pdfjs_require__(41).indexOf;
var hiddenKeys = __w_pdfjs_require__(34);
module.exports = function (object, names) {
 var O = toIndexedObject(object);
 var i = 0;
 var result = [];
 var key;
 for (key in O)
  !has(hiddenKeys, key) && has(O, key) && result.push(key);
 while (names.length > i)
  if (has(O, key = names[i++])) {
   ~indexOf(result, key) || result.push(key);
  }
 return result;
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var toIndexedObject = __w_pdfjs_require__(12);
var toLength = __w_pdfjs_require__(42);
var toAbsoluteIndex = __w_pdfjs_require__(44);
var createMethod = function (IS_INCLUDES) {
 return function ($this, el, fromIndex) {
  var O = toIndexedObject($this);
  var length = toLength(O.length);
  var index = toAbsoluteIndex(fromIndex, length);
  var value;
  if (IS_INCLUDES && el != el)
   while (length > index) {
    value = O[index++];
    if (value != value)
     return true;
   }
  else
   for (; length > index; index++) {
    if ((IS_INCLUDES || index in O) && O[index] === el)
     return IS_INCLUDES || index || 0;
   }
  return !IS_INCLUDES && -1;
 };
};
module.exports = {
 includes: createMethod(true),
 indexOf: createMethod(false)
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var toInteger = __w_pdfjs_require__(43);
var min = Math.min;
module.exports = function (argument) {
 return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0;
};

/***/ }),
/* 43 */
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (argument) {
 return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var toInteger = __w_pdfjs_require__(43);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
 var integer = toInteger(index);
 return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = [
 'constructor',
 'hasOwnProperty',
 'isPrototypeOf',
 'propertyIsEnumerable',
 'toLocaleString',
 'toString',
 'valueOf'
];

/***/ }),
/* 46 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 47 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var fails = __w_pdfjs_require__(9);
var replacement = /#|\.prototype\./;
var isForced = function (feature, detection) {
 var value = data[normalize(feature)];
 return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == 'function' ? fails(detection) : !!detection;
};
var normalize = isForced.normalize = function (string) {
 return String(string).replace(replacement, '.').toLowerCase();
};
var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';
module.exports = isForced;

/***/ }),
/* 48 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNodeJS = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isNodeJS = (typeof process === "undefined" ? "undefined" : _typeof(process)) === "object" && process + "" === "[object process]" && !process.versions["nw"] && !process.versions["electron"];
exports.isNodeJS = isNodeJS;

/***/ }),
/* 49 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(50);
var entryUnbind = __w_pdfjs_require__(57);
module.exports = entryUnbind('String', 'startsWith');

/***/ }),
/* 50 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var $ = __w_pdfjs_require__(5);
var getOwnPropertyDescriptor = __w_pdfjs_require__(7).f;
var toLength = __w_pdfjs_require__(42);
var notARegExp = __w_pdfjs_require__(51);
var requireObjectCoercible = __w_pdfjs_require__(15);
var correctIsRegExpLogic = __w_pdfjs_require__(56);
var IS_PURE = __w_pdfjs_require__(32);
var nativeStartsWith = ''.startsWith;
var min = Math.min;
var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
 var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
 return descriptor && !descriptor.writable;
}();
$({
 target: 'String',
 proto: true,
 forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC
}, {
 startsWith: function startsWith(searchString) {
  var that = String(requireObjectCoercible(this));
  notARegExp(searchString);
  var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
  var search = String(searchString);
  return nativeStartsWith ? nativeStartsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
 }
});

/***/ }),
/* 51 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var isRegExp = __w_pdfjs_require__(52);
module.exports = function (it) {
 if (isRegExp(it)) {
  throw TypeError("The method doesn't accept regular expressions");
 }
 return it;
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var isObject = __w_pdfjs_require__(17);
var classof = __w_pdfjs_require__(14);
var wellKnownSymbol = __w_pdfjs_require__(53);
var MATCH = wellKnownSymbol('match');
module.exports = function (it) {
 var isRegExp;
 return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var global = __w_pdfjs_require__(6);
var shared = __w_pdfjs_require__(31);
var has = __w_pdfjs_require__(18);
var uid = __w_pdfjs_require__(33);
var NATIVE_SYMBOL = __w_pdfjs_require__(54);
var USE_SYMBOL_AS_UID = __w_pdfjs_require__(55);
var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;
module.exports = function (name) {
 if (!has(WellKnownSymbolsStore, name)) {
  if (NATIVE_SYMBOL && has(Symbol, name))
   WellKnownSymbolsStore[name] = Symbol[name];
  else
   WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
 }
 return WellKnownSymbolsStore[name];
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var fails = __w_pdfjs_require__(9);
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
 return !String(Symbol());
});

/***/ }),
/* 55 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var NATIVE_SYMBOL = __w_pdfjs_require__(54);
module.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == 'symbol';

/***/ }),
/* 56 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var wellKnownSymbol = __w_pdfjs_require__(53);
var MATCH = wellKnownSymbol('match');
module.exports = function (METHOD_NAME) {
 var regexp = /./;
 try {
  '/./'[METHOD_NAME](regexp);
 } catch (e) {
  try {
   regexp[MATCH] = false;
   return '/./'[METHOD_NAME](regexp);
  } catch (f) {
  }
 }
 return false;
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var global = __w_pdfjs_require__(6);
var bind = __w_pdfjs_require__(58);
var call = Function.call;
module.exports = function (CONSTRUCTOR, METHOD, length) {
 return bind(call, global[CONSTRUCTOR].prototype[METHOD], length);
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var aFunction = __w_pdfjs_require__(59);
module.exports = function (fn, that, length) {
 aFunction(fn);
 if (that === undefined)
  return fn;
 switch (length) {
 case 0:
  return function () {
   return fn.call(that);
  };
 case 1:
  return function (a) {
   return fn.call(that, a);
  };
 case 2:
  return function (a, b) {
   return fn.call(that, a, b);
  };
 case 3:
  return function (a, b, c) {
   return fn.call(that, a, b, c);
  };
 }
 return function () {
  return fn.apply(that, arguments);
 };
};

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = function (it) {
 if (typeof it != 'function') {
  throw TypeError(String(it) + ' is not a function');
 }
 return it;
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(61);
var entryUnbind = __w_pdfjs_require__(57);
module.exports = entryUnbind('String', 'endsWith');

/***/ }),
/* 61 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var $ = __w_pdfjs_require__(5);
var getOwnPropertyDescriptor = __w_pdfjs_require__(7).f;
var toLength = __w_pdfjs_require__(42);
var notARegExp = __w_pdfjs_require__(51);
var requireObjectCoercible = __w_pdfjs_require__(15);
var correctIsRegExpLogic = __w_pdfjs_require__(56);
var IS_PURE = __w_pdfjs_require__(32);
var nativeEndsWith = ''.endsWith;
var min = Math.min;
var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
 var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
 return descriptor && !descriptor.writable;
}();
$({
 target: 'String',
 proto: true,
 forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC
}, {
 endsWith: function endsWith(searchString) {
  var that = String(requireObjectCoercible(this));
  notARegExp(searchString);
  var endPosition = arguments.length > 1 ? arguments[1] : undefined;
  var len = toLength(that.length);
  var end = endPosition === undefined ? len : min(toLength(endPosition), len);
  var search = String(searchString);
  return nativeEndsWith ? nativeEndsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
 }
});

/***/ }),
/* 62 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(63);
var entryUnbind = __w_pdfjs_require__(57);
module.exports = entryUnbind('String', 'includes');

/***/ }),
/* 63 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var $ = __w_pdfjs_require__(5);
var notARegExp = __w_pdfjs_require__(51);
var requireObjectCoercible = __w_pdfjs_require__(15);
var correctIsRegExpLogic = __w_pdfjs_require__(56);
$({
 target: 'String',
 proto: true,
 forced: !correctIsRegExpLogic('includes')
}, {
 includes: function includes(searchString) {
  return !!~String(requireObjectCoercible(this)).indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
 }
});

/***/ }),
/* 64 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(65);
var entryUnbind = __w_pdfjs_require__(57);
module.exports = entryUnbind('Array', 'includes');

/***/ }),
/* 65 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var $ = __w_pdfjs_require__(5);
var $includes = __w_pdfjs_require__(41).includes;
var addToUnscopables = __w_pdfjs_require__(66);
var arrayMethodUsesToLength = __w_pdfjs_require__(71);
var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', {
 ACCESSORS: true,
 1: 0
});
$({
 target: 'Array',
 proto: true,
 forced: !USES_TO_LENGTH
}, {
 includes: function includes(el) {
  return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
 }
});
addToUnscopables('includes');

/***/ }),
/* 66 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var wellKnownSymbol = __w_pdfjs_require__(53);
var create = __w_pdfjs_require__(67);
var definePropertyModule = __w_pdfjs_require__(22);
var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;
if (ArrayPrototype[UNSCOPABLES] == undefined) {
 definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
  configurable: true,
  value: create(null)
 });
}
module.exports = function (key) {
 ArrayPrototype[UNSCOPABLES][key] = true;
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var anObject = __w_pdfjs_require__(23);
var defineProperties = __w_pdfjs_require__(68);
var enumBugKeys = __w_pdfjs_require__(45);
var hiddenKeys = __w_pdfjs_require__(34);
var html = __w_pdfjs_require__(70);
var documentCreateElement = __w_pdfjs_require__(20);
var sharedKey = __w_pdfjs_require__(30);
var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');
var EmptyConstructor = function () {
};
var scriptTag = function (content) {
 return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};
var NullProtoObjectViaActiveX = function (activeXDocument) {
 activeXDocument.write(scriptTag(''));
 activeXDocument.close();
 var temp = activeXDocument.parentWindow.Object;
 activeXDocument = null;
 return temp;
};
var NullProtoObjectViaIFrame = function () {
 var iframe = documentCreateElement('iframe');
 var JS = 'java' + SCRIPT + ':';
 var iframeDocument;
 iframe.style.display = 'none';
 html.appendChild(iframe);
 iframe.src = String(JS);
 iframeDocument = iframe.contentWindow.document;
 iframeDocument.open();
 iframeDocument.write(scriptTag('document.F=Object'));
 iframeDocument.close();
 return iframeDocument.F;
};
var activeXDocument;
var NullProtoObject = function () {
 try {
  activeXDocument = document.domain && new ActiveXObject('htmlfile');
 } catch (error) {
 }
 NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
 var length = enumBugKeys.length;
 while (length--)
  delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
 return NullProtoObject();
};
hiddenKeys[IE_PROTO] = true;
module.exports = Object.create || function create(O, Properties) {
 var result;
 if (O !== null) {
  EmptyConstructor[PROTOTYPE] = anObject(O);
  result = new EmptyConstructor();
  EmptyConstructor[PROTOTYPE] = null;
  result[IE_PROTO] = O;
 } else
  result = NullProtoObject();
 return Properties === undefined ? result : defineProperties(result, Properties);
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var DESCRIPTORS = __w_pdfjs_require__(8);
var definePropertyModule = __w_pdfjs_require__(22);
var anObject = __w_pdfjs_require__(23);
var objectKeys = __w_pdfjs_require__(69);
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
 anObject(O);
 var keys = objectKeys(Properties);
 var length = keys.length;
 var index = 0;
 var key;
 while (length > index)
  definePropertyModule.f(O, key = keys[index++], Properties[key]);
 return O;
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var internalObjectKeys = __w_pdfjs_require__(40);
var enumBugKeys = __w_pdfjs_require__(45);
module.exports = Object.keys || function keys(O) {
 return internalObjectKeys(O, enumBugKeys);
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var getBuiltIn = __w_pdfjs_require__(37);
module.exports = getBuiltIn('document', 'documentElement');

/***/ }),
/* 71 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var DESCRIPTORS = __w_pdfjs_require__(8);
var fails = __w_pdfjs_require__(9);
var has = __w_pdfjs_require__(18);
var defineProperty = Object.defineProperty;
var cache = {};
var thrower = function (it) {
 throw it;
};
module.exports = function (METHOD_NAME, options) {
 if (has(cache, METHOD_NAME))
  return cache[METHOD_NAME];
 if (!options)
  options = {};
 var method = [][METHOD_NAME];
 var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
 var argument0 = has(options, 0) ? options[0] : thrower;
 var argument1 = has(options, 1) ? options[1] : undefined;
 return cache[METHOD_NAME] = !!method && !fails(function () {
  if (ACCESSORS && !DESCRIPTORS)
   return true;
  var O = { length: -1 };
  if (ACCESSORS)
   defineProperty(O, 1, {
    enumerable: true,
    get: thrower
   });
  else
   O[1] = 1;
  method.call(O, argument0, argument1);
 });
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(73);
__w_pdfjs_require__(85);
var path = __w_pdfjs_require__(38);
module.exports = path.Array.from;

/***/ }),
/* 73 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var charAt = __w_pdfjs_require__(74).charAt;
var InternalStateModule = __w_pdfjs_require__(28);
var defineIterator = __w_pdfjs_require__(75);
var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
defineIterator(String, 'String', function (iterated) {
 setInternalState(this, {
  type: STRING_ITERATOR,
  string: String(iterated),
  index: 0
 });
}, function next() {
 var state = getInternalState(this);
 var string = state.string;
 var index = state.index;
 var point;
 if (index >= string.length)
  return {
   value: undefined,
   done: true
  };
 point = charAt(string, index);
 state.index += point.length;
 return {
  value: point,
  done: false
 };
});

/***/ }),
/* 74 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var toInteger = __w_pdfjs_require__(43);
var requireObjectCoercible = __w_pdfjs_require__(15);
var createMethod = function (CONVERT_TO_STRING) {
 return function ($this, pos) {
  var S = String(requireObjectCoercible($this));
  var position = toInteger(pos);
  var size = S.length;
  var first, second;
  if (position < 0 || position >= size)
   return CONVERT_TO_STRING ? '' : undefined;
  first = S.charCodeAt(position);
  return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
 };
};
module.exports = {
 codeAt: createMethod(false),
 charAt: createMethod(true)
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var $ = __w_pdfjs_require__(5);
var createIteratorConstructor = __w_pdfjs_require__(76);
var getPrototypeOf = __w_pdfjs_require__(78);
var setPrototypeOf = __w_pdfjs_require__(83);
var setToStringTag = __w_pdfjs_require__(81);
var createNonEnumerableProperty = __w_pdfjs_require__(21);
var redefine = __w_pdfjs_require__(24);
var wellKnownSymbol = __w_pdfjs_require__(53);
var IS_PURE = __w_pdfjs_require__(32);
var Iterators = __w_pdfjs_require__(82);
var IteratorsCore = __w_pdfjs_require__(77);
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';
var returnThis = function () {
 return this;
};
module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
 createIteratorConstructor(IteratorConstructor, NAME, next);
 var getIterationMethod = function (KIND) {
  if (KIND === DEFAULT && defaultIterator)
   return defaultIterator;
  if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype)
   return IterablePrototype[KIND];
  switch (KIND) {
  case KEYS:
   return function keys() {
    return new IteratorConstructor(this, KIND);
   };
  case VALUES:
   return function values() {
    return new IteratorConstructor(this, KIND);
   };
  case ENTRIES:
   return function entries() {
    return new IteratorConstructor(this, KIND);
   };
  }
  return function () {
   return new IteratorConstructor(this);
  };
 };
 var TO_STRING_TAG = NAME + ' Iterator';
 var INCORRECT_VALUES_NAME = false;
 var IterablePrototype = Iterable.prototype;
 var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
 var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
 var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
 var CurrentIteratorPrototype, methods, KEY;
 if (anyNativeIterator) {
  CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
  if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
   if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
    if (setPrototypeOf) {
     setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
    } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
     createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
    }
   }
   setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
   if (IS_PURE)
    Iterators[TO_STRING_TAG] = returnThis;
  }
 }
 if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
  INCORRECT_VALUES_NAME = true;
  defaultIterator = function values() {
   return nativeIterator.call(this);
  };
 }
 if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
  createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
 }
 Iterators[NAME] = defaultIterator;
 if (DEFAULT) {
  methods = {
   values: getIterationMethod(VALUES),
   keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
   entries: getIterationMethod(ENTRIES)
  };
  if (FORCED)
   for (KEY in methods) {
    if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
     redefine(IterablePrototype, KEY, methods[KEY]);
    }
   }
  else
   $({
    target: NAME,
    proto: true,
    forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
   }, methods);
 }
 return methods;
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var IteratorPrototype = __w_pdfjs_require__(77).IteratorPrototype;
var create = __w_pdfjs_require__(67);
var createPropertyDescriptor = __w_pdfjs_require__(11);
var setToStringTag = __w_pdfjs_require__(81);
var Iterators = __w_pdfjs_require__(82);
var returnThis = function () {
 return this;
};
module.exports = function (IteratorConstructor, NAME, next) {
 var TO_STRING_TAG = NAME + ' Iterator';
 IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
 setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
 Iterators[TO_STRING_TAG] = returnThis;
 return IteratorConstructor;
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var getPrototypeOf = __w_pdfjs_require__(78);
var createNonEnumerableProperty = __w_pdfjs_require__(21);
var has = __w_pdfjs_require__(18);
var wellKnownSymbol = __w_pdfjs_require__(53);
var IS_PURE = __w_pdfjs_require__(32);
var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;
var returnThis = function () {
 return this;
};
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
if ([].keys) {
 arrayIterator = [].keys();
 if (!('next' in arrayIterator))
  BUGGY_SAFARI_ITERATORS = true;
 else {
  PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
  if (PrototypeOfArrayIteratorPrototype !== Object.prototype)
   IteratorPrototype = PrototypeOfArrayIteratorPrototype;
 }
}
if (IteratorPrototype == undefined)
 IteratorPrototype = {};
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
 createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}
module.exports = {
 IteratorPrototype: IteratorPrototype,
 BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var has = __w_pdfjs_require__(18);
var toObject = __w_pdfjs_require__(79);
var sharedKey = __w_pdfjs_require__(30);
var CORRECT_PROTOTYPE_GETTER = __w_pdfjs_require__(80);
var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
 O = toObject(O);
 if (has(O, IE_PROTO))
  return O[IE_PROTO];
 if (typeof O.constructor == 'function' && O instanceof O.constructor) {
  return O.constructor.prototype;
 }
 return O instanceof Object ? ObjectPrototype : null;
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var requireObjectCoercible = __w_pdfjs_require__(15);
module.exports = function (argument) {
 return Object(requireObjectCoercible(argument));
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var fails = __w_pdfjs_require__(9);
module.exports = !fails(function () {
 function F() {
 }
 F.prototype.constructor = null;
 return Object.getPrototypeOf(new F()) !== F.prototype;
});

/***/ }),
/* 81 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var defineProperty = __w_pdfjs_require__(22).f;
var has = __w_pdfjs_require__(18);
var wellKnownSymbol = __w_pdfjs_require__(53);
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
module.exports = function (it, TAG, STATIC) {
 if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
  defineProperty(it, TO_STRING_TAG, {
   configurable: true,
   value: TAG
  });
 }
};

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 83 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var anObject = __w_pdfjs_require__(23);
var aPossiblePrototype = __w_pdfjs_require__(84);
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
 var CORRECT_SETTER = false;
 var test = {};
 var setter;
 try {
  setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
  setter.call(test, []);
  CORRECT_SETTER = test instanceof Array;
 } catch (error) {
 }
 return function setPrototypeOf(O, proto) {
  anObject(O);
  aPossiblePrototype(proto);
  if (CORRECT_SETTER)
   setter.call(O, proto);
  else
   O.__proto__ = proto;
  return O;
 };
}() : undefined);

/***/ }),
/* 84 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var isObject = __w_pdfjs_require__(17);
module.exports = function (it) {
 if (!isObject(it) && it !== null) {
  throw TypeError("Can't set " + String(it) + ' as a prototype');
 }
 return it;
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var $ = __w_pdfjs_require__(5);
var from = __w_pdfjs_require__(86);
var checkCorrectnessOfIteration = __w_pdfjs_require__(93);
var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
 Array.from(iterable);
});
$({
 target: 'Array',
 stat: true,
 forced: INCORRECT_ITERATION
}, { from: from });

/***/ }),
/* 86 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var bind = __w_pdfjs_require__(58);
var toObject = __w_pdfjs_require__(79);
var callWithSafeIterationClosing = __w_pdfjs_require__(87);
var isArrayIteratorMethod = __w_pdfjs_require__(88);
var toLength = __w_pdfjs_require__(42);
var createProperty = __w_pdfjs_require__(89);
var getIteratorMethod = __w_pdfjs_require__(90);
module.exports = function from(arrayLike) {
 var O = toObject(arrayLike);
 var C = typeof this == 'function' ? this : Array;
 var argumentsLength = arguments.length;
 var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
 var mapping = mapfn !== undefined;
 var iteratorMethod = getIteratorMethod(O);
 var index = 0;
 var length, result, step, iterator, next, value;
 if (mapping)
  mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
 if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
  iterator = iteratorMethod.call(O);
  next = iterator.next;
  result = new C();
  for (; !(step = next.call(iterator)).done; index++) {
   value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [
    step.value,
    index
   ], true) : step.value;
   createProperty(result, index, value);
  }
 } else {
  length = toLength(O.length);
  result = new C(length);
  for (; length > index; index++) {
   value = mapping ? mapfn(O[index], index) : O[index];
   createProperty(result, index, value);
  }
 }
 result.length = index;
 return result;
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var anObject = __w_pdfjs_require__(23);
module.exports = function (iterator, fn, value, ENTRIES) {
 try {
  return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
 } catch (error) {
  var returnMethod = iterator['return'];
  if (returnMethod !== undefined)
   anObject(returnMethod.call(iterator));
  throw error;
 }
};

/***/ }),
/* 88 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var wellKnownSymbol = __w_pdfjs_require__(53);
var Iterators = __w_pdfjs_require__(82);
var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;
module.exports = function (it) {
 return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var toPrimitive = __w_pdfjs_require__(16);
var definePropertyModule = __w_pdfjs_require__(22);
var createPropertyDescriptor = __w_pdfjs_require__(11);
module.exports = function (object, key, value) {
 var propertyKey = toPrimitive(key);
 if (propertyKey in object)
  definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
 else
  object[propertyKey] = value;
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var classof = __w_pdfjs_require__(91);
var Iterators = __w_pdfjs_require__(82);
var wellKnownSymbol = __w_pdfjs_require__(53);
var ITERATOR = wellKnownSymbol('iterator');
module.exports = function (it) {
 if (it != undefined)
  return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var TO_STRING_TAG_SUPPORT = __w_pdfjs_require__(92);
var classofRaw = __w_pdfjs_require__(14);
var wellKnownSymbol = __w_pdfjs_require__(53);
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var CORRECT_ARGUMENTS = classofRaw(function () {
 return arguments;
}()) == 'Arguments';
var tryGet = function (it, key) {
 try {
  return it[key];
 } catch (error) {
 }
};
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
 var O, tag, result;
 return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};

/***/ }),
/* 92 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var wellKnownSymbol = __w_pdfjs_require__(53);
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};
test[TO_STRING_TAG] = 'z';
module.exports = String(test) === '[object z]';

/***/ }),
/* 93 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var wellKnownSymbol = __w_pdfjs_require__(53);
var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;
try {
 var called = 0;
 var iteratorWithReturn = {
  next: function () {
   return { done: !!called++ };
  },
  'return': function () {
   SAFE_CLOSING = true;
  }
 };
 iteratorWithReturn[ITERATOR] = function () {
  return this;
 };
 Array.from(iteratorWithReturn, function () {
  throw 2;
 });
} catch (error) {
}
module.exports = function (exec, SKIP_CLOSING) {
 if (!SKIP_CLOSING && !SAFE_CLOSING)
  return false;
 var ITERATION_SUPPORT = false;
 try {
  var object = {};
  object[ITERATOR] = function () {
   return {
    next: function () {
     return { done: ITERATION_SUPPORT = true };
    }
   };
  };
  exec(object);
 } catch (error) {
 }
 return ITERATION_SUPPORT;
};

/***/ }),
/* 94 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(95);
var path = __w_pdfjs_require__(38);
module.exports = path.Object.assign;

/***/ }),
/* 95 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var $ = __w_pdfjs_require__(5);
var assign = __w_pdfjs_require__(96);
$({
 target: 'Object',
 stat: true,
 forced: Object.assign !== assign
}, { assign: assign });

/***/ }),
/* 96 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var DESCRIPTORS = __w_pdfjs_require__(8);
var fails = __w_pdfjs_require__(9);
var objectKeys = __w_pdfjs_require__(69);
var getOwnPropertySymbolsModule = __w_pdfjs_require__(46);
var propertyIsEnumerableModule = __w_pdfjs_require__(10);
var toObject = __w_pdfjs_require__(79);
var IndexedObject = __w_pdfjs_require__(13);
var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;
module.exports = !nativeAssign || fails(function () {
 if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
   enumerable: true,
   get: function () {
    defineProperty(this, 'b', {
     value: 3,
     enumerable: false
    });
   }
  }), { b: 2 })).b !== 1)
  return true;
 var A = {};
 var B = {};
 var symbol = Symbol();
 var alphabet = 'abcdefghijklmnopqrst';
 A[symbol] = 7;
 alphabet.split('').forEach(function (chr) {
  B[chr] = chr;
 });
 return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) {
 var T = toObject(target);
 var argumentsLength = arguments.length;
 var index = 1;
 var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
 var propertyIsEnumerable = propertyIsEnumerableModule.f;
 while (argumentsLength > index) {
  var S = IndexedObject(arguments[index++]);
  var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
  var length = keys.length;
  var j = 0;
  var key;
  while (length > j) {
   key = keys[j++];
   if (!DESCRIPTORS || propertyIsEnumerable.call(S, key))
    T[key] = S[key];
  }
 }
 return T;
} : nativeAssign;

/***/ }),
/* 97 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(98);
var path = __w_pdfjs_require__(38);
module.exports = path.Math.log2;

/***/ }),
/* 98 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var $ = __w_pdfjs_require__(5);
var log = Math.log;
var LN2 = Math.LN2;
$({
 target: 'Math',
 stat: true
}, {
 log2: function log2(x) {
  return log(x) / LN2;
 }
});

/***/ }),
/* 99 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(100);
var path = __w_pdfjs_require__(38);
module.exports = path.Number.isNaN;

/***/ }),
/* 100 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var $ = __w_pdfjs_require__(5);
$({
 target: 'Number',
 stat: true
}, {
 isNaN: function isNaN(number) {
  return number != number;
 }
});

/***/ }),
/* 101 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(102);
var path = __w_pdfjs_require__(38);
module.exports = path.Number.isInteger;

/***/ }),
/* 102 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var $ = __w_pdfjs_require__(5);
var isInteger = __w_pdfjs_require__(103);
$({
 target: 'Number',
 stat: true
}, { isInteger: isInteger });

/***/ }),
/* 103 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var isObject = __w_pdfjs_require__(17);
var floor = Math.floor;
module.exports = function isInteger(it) {
 return !isObject(it) && isFinite(it) && floor(it) === it;
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(105);
__w_pdfjs_require__(73);
__w_pdfjs_require__(107);
__w_pdfjs_require__(110);
__w_pdfjs_require__(126);
__w_pdfjs_require__(127);
var path = __w_pdfjs_require__(38);
module.exports = path.Promise;

/***/ }),
/* 105 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var TO_STRING_TAG_SUPPORT = __w_pdfjs_require__(92);
var redefine = __w_pdfjs_require__(24);
var toString = __w_pdfjs_require__(106);
if (!TO_STRING_TAG_SUPPORT) {
 redefine(Object.prototype, 'toString', toString, { unsafe: true });
}

/***/ }),
/* 106 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __w_pdfjs_require__(92);
var classof = __w_pdfjs_require__(91);
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
 return '[object ' + classof(this) + ']';
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var global = __w_pdfjs_require__(6);
var DOMIterables = __w_pdfjs_require__(108);
var ArrayIteratorMethods = __w_pdfjs_require__(109);
var createNonEnumerableProperty = __w_pdfjs_require__(21);
var wellKnownSymbol = __w_pdfjs_require__(53);
var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;
for (var COLLECTION_NAME in DOMIterables) {
 var Collection = global[COLLECTION_NAME];
 var CollectionPrototype = Collection && Collection.prototype;
 if (CollectionPrototype) {
  if (CollectionPrototype[ITERATOR] !== ArrayValues)
   try {
    createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
   } catch (error) {
    CollectionPrototype[ITERATOR] = ArrayValues;
   }
  if (!CollectionPrototype[TO_STRING_TAG]) {
   createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
  }
  if (DOMIterables[COLLECTION_NAME])
   for (var METHOD_NAME in ArrayIteratorMethods) {
    if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME])
     try {
      createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
     } catch (error) {
      CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
     }
   }
 }
}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = {
 CSSRuleList: 0,
 CSSStyleDeclaration: 0,
 CSSValueList: 0,
 ClientRectList: 0,
 DOMRectList: 0,
 DOMStringList: 0,
 DOMTokenList: 1,
 DataTransferItemList: 0,
 FileList: 0,
 HTMLAllCollection: 0,
 HTMLCollection: 0,
 HTMLFormElement: 0,
 HTMLSelectElement: 0,
 MediaList: 0,
 MimeTypeArray: 0,
 NamedNodeMap: 0,
 NodeList: 1,
 PaintRequestList: 0,
 Plugin: 0,
 PluginArray: 0,
 SVGLengthList: 0,
 SVGNumberList: 0,
 SVGPathSegList: 0,
 SVGPointList: 0,
 SVGStringList: 0,
 SVGTransformList: 0,
 SourceBufferList: 0,
 StyleSheetList: 0,
 TextTrackCueList: 0,
 TextTrackList: 0,
 TouchList: 0
};

/***/ }),
/* 109 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var toIndexedObject = __w_pdfjs_require__(12);
var addToUnscopables = __w_pdfjs_require__(66);
var Iterators = __w_pdfjs_require__(82);
var InternalStateModule = __w_pdfjs_require__(28);
var defineIterator = __w_pdfjs_require__(75);
var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
 setInternalState(this, {
  type: ARRAY_ITERATOR,
  target: toIndexedObject(iterated),
  index: 0,
  kind: kind
 });
}, function () {
 var state = getInternalState(this);
 var target = state.target;
 var kind = state.kind;
 var index = state.index++;
 if (!target || index >= target.length) {
  state.target = undefined;
  return {
   value: undefined,
   done: true
  };
 }
 if (kind == 'keys')
  return {
   value: index,
   done: false
  };
 if (kind == 'values')
  return {
   value: target[index],
   done: false
  };
 return {
  value: [
   index,
   target[index]
  ],
  done: false
 };
}, 'values');
Iterators.Arguments = Iterators.Array;
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 110 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var $ = __w_pdfjs_require__(5);
var IS_PURE = __w_pdfjs_require__(32);
var global = __w_pdfjs_require__(6);
var getBuiltIn = __w_pdfjs_require__(37);
var NativePromise = __w_pdfjs_require__(111);
var redefine = __w_pdfjs_require__(24);
var redefineAll = __w_pdfjs_require__(112);
var setToStringTag = __w_pdfjs_require__(81);
var setSpecies = __w_pdfjs_require__(113);
var isObject = __w_pdfjs_require__(17);
var aFunction = __w_pdfjs_require__(59);
var anInstance = __w_pdfjs_require__(114);
var classof = __w_pdfjs_require__(14);
var inspectSource = __w_pdfjs_require__(26);
var iterate = __w_pdfjs_require__(115);
var checkCorrectnessOfIteration = __w_pdfjs_require__(93);
var speciesConstructor = __w_pdfjs_require__(116);
var task = __w_pdfjs_require__(117).set;
var microtask = __w_pdfjs_require__(120);
var promiseResolve = __w_pdfjs_require__(121);
var hostReportErrors = __w_pdfjs_require__(123);
var newPromiseCapabilityModule = __w_pdfjs_require__(122);
var perform = __w_pdfjs_require__(124);
var InternalStateModule = __w_pdfjs_require__(28);
var isForced = __w_pdfjs_require__(47);
var wellKnownSymbol = __w_pdfjs_require__(53);
var V8_VERSION = __w_pdfjs_require__(125);
var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var PromiseConstructor = NativePromise;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var $fetch = getBuiltIn('fetch');
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var IS_NODE = classof(process) == 'process';
var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;
var FORCED = isForced(PROMISE, function () {
 var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
 if (!GLOBAL_CORE_JS_PROMISE) {
  if (V8_VERSION === 66)
   return true;
  if (!IS_NODE && typeof PromiseRejectionEvent != 'function')
   return true;
 }
 if (IS_PURE && !PromiseConstructor.prototype['finally'])
  return true;
 if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor))
  return false;
 var promise = PromiseConstructor.resolve(1);
 var FakePromise = function (exec) {
  exec(function () {
  }, function () {
  });
 };
 var constructor = promise.constructor = {};
 constructor[SPECIES] = FakePromise;
 return !(promise.then(function () {
 }) instanceof FakePromise);
});
var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
 PromiseConstructor.all(iterable)['catch'](function () {
 });
});
var isThenable = function (it) {
 var then;
 return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, state, isReject) {
 if (state.notified)
  return;
 state.notified = true;
 var chain = state.reactions;
 microtask(function () {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var index = 0;
  while (chain.length > index) {
   var reaction = chain[index++];
   var handler = ok ? reaction.ok : reaction.fail;
   var resolve = reaction.resolve;
   var reject = reaction.reject;
   var domain = reaction.domain;
   var result, then, exited;
   try {
    if (handler) {
     if (!ok) {
      if (state.rejection === UNHANDLED)
       onHandleUnhandled(promise, state);
      state.rejection = HANDLED;
     }
     if (handler === true)
      result = value;
     else {
      if (domain)
       domain.enter();
      result = handler(value);
      if (domain) {
       domain.exit();
       exited = true;
      }
     }
     if (result === reaction.promise) {
      reject(TypeError('Promise-chain cycle'));
     } else if (then = isThenable(result)) {
      then.call(result, resolve, reject);
     } else
      resolve(result);
    } else
     reject(value);
   } catch (error) {
    if (domain && !exited)
     domain.exit();
    reject(error);
   }
  }
  state.reactions = [];
  state.notified = false;
  if (isReject && !state.rejection)
   onUnhandled(promise, state);
 });
};
var dispatchEvent = function (name, promise, reason) {
 var event, handler;
 if (DISPATCH_EVENT) {
  event = document.createEvent('Event');
  event.promise = promise;
  event.reason = reason;
  event.initEvent(name, false, true);
  global.dispatchEvent(event);
 } else
  event = {
   promise: promise,
   reason: reason
  };
 if (handler = global['on' + name])
  handler(event);
 else if (name === UNHANDLED_REJECTION)
  hostReportErrors('Unhandled promise rejection', reason);
};
var onUnhandled = function (promise, state) {
 task.call(global, function () {
  var value = state.value;
  var IS_UNHANDLED = isUnhandled(state);
  var result;
  if (IS_UNHANDLED) {
   result = perform(function () {
    if (IS_NODE) {
     process.emit('unhandledRejection', value, promise);
    } else
     dispatchEvent(UNHANDLED_REJECTION, promise, value);
   });
   state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
   if (result.error)
    throw result.value;
  }
 });
};
var isUnhandled = function (state) {
 return state.rejection !== HANDLED && !state.parent;
};
var onHandleUnhandled = function (promise, state) {
 task.call(global, function () {
  if (IS_NODE) {
   process.emit('rejectionHandled', promise);
  } else
   dispatchEvent(REJECTION_HANDLED, promise, state.value);
 });
};
var bind = function (fn, promise, state, unwrap) {
 return function (value) {
  fn(promise, state, value, unwrap);
 };
};
var internalReject = function (promise, state, value, unwrap) {
 if (state.done)
  return;
 state.done = true;
 if (unwrap)
  state = unwrap;
 state.value = value;
 state.state = REJECTED;
 notify(promise, state, true);
};
var internalResolve = function (promise, state, value, unwrap) {
 if (state.done)
  return;
 state.done = true;
 if (unwrap)
  state = unwrap;
 try {
  if (promise === value)
   throw TypeError("Promise can't be resolved itself");
  var then = isThenable(value);
  if (then) {
   microtask(function () {
    var wrapper = { done: false };
    try {
     then.call(value, bind(internalResolve, promise, wrapper, state), bind(internalReject, promise, wrapper, state));
    } catch (error) {
     internalReject(promise, wrapper, error, state);
    }
   });
  } else {
   state.value = value;
   state.state = FULFILLED;
   notify(promise, state, false);
  }
 } catch (error) {
  internalReject(promise, { done: false }, error, state);
 }
};
if (FORCED) {
 PromiseConstructor = function Promise(executor) {
  anInstance(this, PromiseConstructor, PROMISE);
  aFunction(executor);
  Internal.call(this);
  var state = getInternalState(this);
  try {
   executor(bind(internalResolve, this, state), bind(internalReject, this, state));
  } catch (error) {
   internalReject(this, state, error);
  }
 };
 Internal = function Promise(executor) {
  setInternalState(this, {
   type: PROMISE,
   done: false,
   notified: false,
   parent: false,
   reactions: [],
   rejection: false,
   state: PENDING,
   value: undefined
  });
 };
 Internal.prototype = redefineAll(PromiseConstructor.prototype, {
  then: function then(onFulfilled, onRejected) {
   var state = getInternalPromiseState(this);
   var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
   reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
   reaction.fail = typeof onRejected == 'function' && onRejected;
   reaction.domain = IS_NODE ? process.domain : undefined;
   state.parent = true;
   state.reactions.push(reaction);
   if (state.state != PENDING)
    notify(this, state, false);
   return reaction.promise;
  },
  'catch': function (onRejected) {
   return this.then(undefined, onRejected);
  }
 });
 OwnPromiseCapability = function () {
  var promise = new Internal();
  var state = getInternalState(promise);
  this.promise = promise;
  this.resolve = bind(internalResolve, promise, state);
  this.reject = bind(internalReject, promise, state);
 };
 newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
  return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
 };
 if (!IS_PURE && typeof NativePromise == 'function') {
  nativeThen = NativePromise.prototype.then;
  redefine(NativePromise.prototype, 'then', function then(onFulfilled, onRejected) {
   var that = this;
   return new PromiseConstructor(function (resolve, reject) {
    nativeThen.call(that, resolve, reject);
   }).then(onFulfilled, onRejected);
  }, { unsafe: true });
  if (typeof $fetch == 'function')
   $({
    global: true,
    enumerable: true,
    forced: true
   }, {
    fetch: function fetch(input) {
     return promiseResolve(PromiseConstructor, $fetch.apply(global, arguments));
    }
   });
 }
}
$({
 global: true,
 wrap: true,
 forced: FORCED
}, { Promise: PromiseConstructor });
setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);
PromiseWrapper = getBuiltIn(PROMISE);
$({
 target: PROMISE,
 stat: true,
 forced: FORCED
}, {
 reject: function reject(r) {
  var capability = newPromiseCapability(this);
  capability.reject.call(undefined, r);
  return capability.promise;
 }
});
$({
 target: PROMISE,
 stat: true,
 forced: IS_PURE || FORCED
}, {
 resolve: function resolve(x) {
  return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
 }
});
$({
 target: PROMISE,
 stat: true,
 forced: INCORRECT_ITERATION
}, {
 all: function all(iterable) {
  var C = this;
  var capability = newPromiseCapability(C);
  var resolve = capability.resolve;
  var reject = capability.reject;
  var result = perform(function () {
   var $promiseResolve = aFunction(C.resolve);
   var values = [];
   var counter = 0;
   var remaining = 1;
   iterate(iterable, function (promise) {
    var index = counter++;
    var alreadyCalled = false;
    values.push(undefined);
    remaining++;
    $promiseResolve.call(C, promise).then(function (value) {
     if (alreadyCalled)
      return;
     alreadyCalled = true;
     values[index] = value;
     --remaining || resolve(values);
    }, reject);
   });
   --remaining || resolve(values);
  });
  if (result.error)
   reject(result.value);
  return capability.promise;
 },
 race: function race(iterable) {
  var C = this;
  var capability = newPromiseCapability(C);
  var reject = capability.reject;
  var result = perform(function () {
   var $promiseResolve = aFunction(C.resolve);
   iterate(iterable, function (promise) {
    $promiseResolve.call(C, promise).then(capability.resolve, reject);
   });
  });
  if (result.error)
   reject(result.value);
  return capability.promise;
 }
});

/***/ }),
/* 111 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var global = __w_pdfjs_require__(6);
module.exports = global.Promise;

/***/ }),
/* 112 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var redefine = __w_pdfjs_require__(24);
module.exports = function (target, src, options) {
 for (var key in src)
  redefine(target, key, src[key], options);
 return target;
};

/***/ }),
/* 113 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var getBuiltIn = __w_pdfjs_require__(37);
var definePropertyModule = __w_pdfjs_require__(22);
var wellKnownSymbol = __w_pdfjs_require__(53);
var DESCRIPTORS = __w_pdfjs_require__(8);
var SPECIES = wellKnownSymbol('species');
module.exports = function (CONSTRUCTOR_NAME) {
 var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
 var defineProperty = definePropertyModule.f;
 if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
  defineProperty(Constructor, SPECIES, {
   configurable: true,
   get: function () {
    return this;
   }
  });
 }
};

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
 if (!(it instanceof Constructor)) {
  throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
 }
 return it;
};

/***/ }),
/* 115 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var anObject = __w_pdfjs_require__(23);
var isArrayIteratorMethod = __w_pdfjs_require__(88);
var toLength = __w_pdfjs_require__(42);
var bind = __w_pdfjs_require__(58);
var getIteratorMethod = __w_pdfjs_require__(90);
var callWithSafeIterationClosing = __w_pdfjs_require__(87);
var Result = function (stopped, result) {
 this.stopped = stopped;
 this.result = result;
};
var iterate = module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
 var boundFunction = bind(fn, that, AS_ENTRIES ? 2 : 1);
 var iterator, iterFn, index, length, result, next, step;
 if (IS_ITERATOR) {
  iterator = iterable;
 } else {
  iterFn = getIteratorMethod(iterable);
  if (typeof iterFn != 'function')
   throw TypeError('Target is not iterable');
  if (isArrayIteratorMethod(iterFn)) {
   for (index = 0, length = toLength(iterable.length); length > index; index++) {
    result = AS_ENTRIES ? boundFunction(anObject(step = iterable[index])[0], step[1]) : boundFunction(iterable[index]);
    if (result && result instanceof Result)
     return result;
   }
   return new Result(false);
  }
  iterator = iterFn.call(iterable);
 }
 next = iterator.next;
 while (!(step = next.call(iterator)).done) {
  result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
  if (typeof result == 'object' && result && result instanceof Result)
   return result;
 }
 return new Result(false);
};
iterate.stop = function (result) {
 return new Result(true, result);
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var anObject = __w_pdfjs_require__(23);
var aFunction = __w_pdfjs_require__(59);
var wellKnownSymbol = __w_pdfjs_require__(53);
var SPECIES = wellKnownSymbol('species');
module.exports = function (O, defaultConstructor) {
 var C = anObject(O).constructor;
 var S;
 return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};

/***/ }),
/* 117 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var global = __w_pdfjs_require__(6);
var fails = __w_pdfjs_require__(9);
var classof = __w_pdfjs_require__(14);
var bind = __w_pdfjs_require__(58);
var html = __w_pdfjs_require__(70);
var createElement = __w_pdfjs_require__(20);
var IS_IOS = __w_pdfjs_require__(118);
var location = global.location;
var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function (id) {
 if (queue.hasOwnProperty(id)) {
  var fn = queue[id];
  delete queue[id];
  fn();
 }
};
var runner = function (id) {
 return function () {
  run(id);
 };
};
var listener = function (event) {
 run(event.data);
};
var post = function (id) {
 global.postMessage(id + '', location.protocol + '//' + location.host);
};
if (!set || !clear) {
 set = function setImmediate(fn) {
  var args = [];
  var i = 1;
  while (arguments.length > i)
   args.push(arguments[i++]);
  queue[++counter] = function () {
   (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
  };
  defer(counter);
  return counter;
 };
 clear = function clearImmediate(id) {
  delete queue[id];
 };
 if (classof(process) == 'process') {
  defer = function (id) {
   process.nextTick(runner(id));
  };
 } else if (Dispatch && Dispatch.now) {
  defer = function (id) {
   Dispatch.now(runner(id));
  };
 } else if (MessageChannel && !IS_IOS) {
  channel = new MessageChannel();
  port = channel.port2;
  channel.port1.onmessage = listener;
  defer = bind(port.postMessage, port, 1);
 } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts && !fails(post)) {
  defer = post;
  global.addEventListener('message', listener, false);
 } else if (ONREADYSTATECHANGE in createElement('script')) {
  defer = function (id) {
   html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
    html.removeChild(this);
    run(id);
   };
  };
 } else {
  defer = function (id) {
   setTimeout(runner(id), 0);
  };
 }
}
module.exports = {
 set: set,
 clear: clear
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var userAgent = __w_pdfjs_require__(119);
module.exports = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);

/***/ }),
/* 119 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var getBuiltIn = __w_pdfjs_require__(37);
module.exports = getBuiltIn('navigator', 'userAgent') || '';

/***/ }),
/* 120 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var global = __w_pdfjs_require__(6);
var getOwnPropertyDescriptor = __w_pdfjs_require__(7).f;
var classof = __w_pdfjs_require__(14);
var macrotask = __w_pdfjs_require__(117).set;
var IS_IOS = __w_pdfjs_require__(118);
var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var IS_NODE = classof(process) == 'process';
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var flush, head, last, notify, toggle, node, promise, then;
if (!queueMicrotask) {
 flush = function () {
  var parent, fn;
  if (IS_NODE && (parent = process.domain))
   parent.exit();
  while (head) {
   fn = head.fn;
   head = head.next;
   try {
    fn();
   } catch (error) {
    if (head)
     notify();
    else
     last = undefined;
    throw error;
   }
  }
  last = undefined;
  if (parent)
   parent.enter();
 };
 if (IS_NODE) {
  notify = function () {
   process.nextTick(flush);
  };
 } else if (MutationObserver && !IS_IOS) {
  toggle = true;
  node = document.createTextNode('');
  new MutationObserver(flush).observe(node, { characterData: true });
  notify = function () {
   node.data = toggle = !toggle;
  };
 } else if (Promise && Promise.resolve) {
  promise = Promise.resolve(undefined);
  then = promise.then;
  notify = function () {
   then.call(promise, flush);
  };
 } else {
  notify = function () {
   macrotask.call(global, flush);
  };
 }
}
module.exports = queueMicrotask || function (fn) {
 var task = {
  fn: fn,
  next: undefined
 };
 if (last)
  last.next = task;
 if (!head) {
  head = task;
  notify();
 }
 last = task;
};

/***/ }),
/* 121 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var anObject = __w_pdfjs_require__(23);
var isObject = __w_pdfjs_require__(17);
var newPromiseCapability = __w_pdfjs_require__(122);
module.exports = function (C, x) {
 anObject(C);
 if (isObject(x) && x.constructor === C)
  return x;
 var promiseCapability = newPromiseCapability.f(C);
 var resolve = promiseCapability.resolve;
 resolve(x);
 return promiseCapability.promise;
};

/***/ }),
/* 122 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var aFunction = __w_pdfjs_require__(59);
var PromiseCapability = function (C) {
 var resolve, reject;
 this.promise = new C(function ($$resolve, $$reject) {
  if (resolve !== undefined || reject !== undefined)
   throw TypeError('Bad Promise constructor');
  resolve = $$resolve;
  reject = $$reject;
 });
 this.resolve = aFunction(resolve);
 this.reject = aFunction(reject);
};
module.exports.f = function (C) {
 return new PromiseCapability(C);
};

/***/ }),
/* 123 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var global = __w_pdfjs_require__(6);
module.exports = function (a, b) {
 var console = global.console;
 if (console && console.error) {
  arguments.length === 1 ? console.error(a) : console.error(a, b);
 }
};

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = function (exec) {
 try {
  return {
   error: false,
   value: exec()
  };
 } catch (error) {
  return {
   error: true,
   value: error
  };
 }
};

/***/ }),
/* 125 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var global = __w_pdfjs_require__(6);
var userAgent = __w_pdfjs_require__(119);
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;
if (v8) {
 match = v8.split('.');
 version = match[0] + match[1];
} else if (userAgent) {
 match = userAgent.match(/Edge\/(\d+)/);
 if (!match || match[1] >= 74) {
  match = userAgent.match(/Chrome\/(\d+)/);
  if (match)
   version = match[1];
 }
}
module.exports = version && +version;

/***/ }),
/* 126 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var $ = __w_pdfjs_require__(5);
var aFunction = __w_pdfjs_require__(59);
var newPromiseCapabilityModule = __w_pdfjs_require__(122);
var perform = __w_pdfjs_require__(124);
var iterate = __w_pdfjs_require__(115);
$({
 target: 'Promise',
 stat: true
}, {
 allSettled: function allSettled(iterable) {
  var C = this;
  var capability = newPromiseCapabilityModule.f(C);
  var resolve = capability.resolve;
  var reject = capability.reject;
  var result = perform(function () {
   var promiseResolve = aFunction(C.resolve);
   var values = [];
   var counter = 0;
   var remaining = 1;
   iterate(iterable, function (promise) {
    var index = counter++;
    var alreadyCalled = false;
    values.push(undefined);
    remaining++;
    promiseResolve.call(C, promise).then(function (value) {
     if (alreadyCalled)
      return;
     alreadyCalled = true;
     values[index] = {
      status: 'fulfilled',
      value: value
     };
     --remaining || resolve(values);
    }, function (e) {
     if (alreadyCalled)
      return;
     alreadyCalled = true;
     values[index] = {
      status: 'rejected',
      reason: e
     };
     --remaining || resolve(values);
    });
   });
   --remaining || resolve(values);
  });
  if (result.error)
   reject(result.value);
  return capability.promise;
 }
});

/***/ }),
/* 127 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var $ = __w_pdfjs_require__(5);
var IS_PURE = __w_pdfjs_require__(32);
var NativePromise = __w_pdfjs_require__(111);
var fails = __w_pdfjs_require__(9);
var getBuiltIn = __w_pdfjs_require__(37);
var speciesConstructor = __w_pdfjs_require__(116);
var promiseResolve = __w_pdfjs_require__(121);
var redefine = __w_pdfjs_require__(24);
var NON_GENERIC = !!NativePromise && fails(function () {
 NativePromise.prototype['finally'].call({
  then: function () {
  }
 }, function () {
 });
});
$({
 target: 'Promise',
 proto: true,
 real: true,
 forced: NON_GENERIC
}, {
 'finally': function (onFinally) {
  var C = speciesConstructor(this, getBuiltIn('Promise'));
  var isFunction = typeof onFinally == 'function';
  return this.then(isFunction ? function (x) {
   return promiseResolve(C, onFinally()).then(function () {
    return x;
   });
  } : onFinally, isFunction ? function (e) {
   return promiseResolve(C, onFinally()).then(function () {
    throw e;
   });
  } : onFinally);
 }
});
if (!IS_PURE && typeof NativePromise == 'function' && !NativePromise.prototype['finally']) {
 redefine(NativePromise.prototype, 'finally', getBuiltIn('Promise').prototype['finally']);
}

/***/ }),
/* 128 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(129);
__w_pdfjs_require__(134);
__w_pdfjs_require__(132);
var path = __w_pdfjs_require__(38);
module.exports = path.URL;

/***/ }),
/* 129 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

__w_pdfjs_require__(73);
var $ = __w_pdfjs_require__(5);
var DESCRIPTORS = __w_pdfjs_require__(8);
var USE_NATIVE_URL = __w_pdfjs_require__(130);
var global = __w_pdfjs_require__(6);
var defineProperties = __w_pdfjs_require__(68);
var redefine = __w_pdfjs_require__(24);
var anInstance = __w_pdfjs_require__(114);
var has = __w_pdfjs_require__(18);
var assign = __w_pdfjs_require__(96);
var arrayFrom = __w_pdfjs_require__(86);
var codeAt = __w_pdfjs_require__(74).codeAt;
var toASCII = __w_pdfjs_require__(131);
var setToStringTag = __w_pdfjs_require__(81);
var URLSearchParamsModule = __w_pdfjs_require__(132);
var InternalStateModule = __w_pdfjs_require__(28);
var NativeURL = global.URL;
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;
var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var floor = Math.floor;
var pow = Math.pow;
var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';
var ALPHA = /[A-Za-z]/;
var ALPHANUMERIC = /[\d+\-.A-Za-z]/;
var DIGIT = /\d/;
var HEX_START = /^(0x|0X)/;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\dA-Fa-f]+$/;
var FORBIDDEN_HOST_CODE_POINT = /[\u0000\u0009\u000A\u000D #%/:?@[\\]]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\u0000\u0009\u000A\u000D #/:?@[\\]]/;
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g;
var TAB_AND_NEW_LINE = /[\u0009\u000A\u000D]/g;
var EOF;
var parseHost = function (url, input) {
 var result, codePoints, index;
 if (input.charAt(0) == '[') {
  if (input.charAt(input.length - 1) != ']')
   return INVALID_HOST;
  result = parseIPv6(input.slice(1, -1));
  if (!result)
   return INVALID_HOST;
  url.host = result;
 } else if (!isSpecial(url)) {
  if (FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT.test(input))
   return INVALID_HOST;
  result = '';
  codePoints = arrayFrom(input);
  for (index = 0; index < codePoints.length; index++) {
   result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
  }
  url.host = result;
 } else {
  input = toASCII(input);
  if (FORBIDDEN_HOST_CODE_POINT.test(input))
   return INVALID_HOST;
  result = parseIPv4(input);
  if (result === null)
   return INVALID_HOST;
  url.host = result;
 }
};
var parseIPv4 = function (input) {
 var parts = input.split('.');
 var partsLength, numbers, index, part, radix, number, ipv4;
 if (parts.length && parts[parts.length - 1] == '') {
  parts.pop();
 }
 partsLength = parts.length;
 if (partsLength > 4)
  return input;
 numbers = [];
 for (index = 0; index < partsLength; index++) {
  part = parts[index];
  if (part == '')
   return input;
  radix = 10;
  if (part.length > 1 && part.charAt(0) == '0') {
   radix = HEX_START.test(part) ? 16 : 8;
   part = part.slice(radix == 8 ? 1 : 2);
  }
  if (part === '') {
   number = 0;
  } else {
   if (!(radix == 10 ? DEC : radix == 8 ? OCT : HEX).test(part))
    return input;
   number = parseInt(part, radix);
  }
  numbers.push(number);
 }
 for (index = 0; index < partsLength; index++) {
  number = numbers[index];
  if (index == partsLength - 1) {
   if (number >= pow(256, 5 - partsLength))
    return null;
  } else if (number > 255)
   return null;
 }
 ipv4 = numbers.pop();
 for (index = 0; index < numbers.length; index++) {
  ipv4 += numbers[index] * pow(256, 3 - index);
 }
 return ipv4;
};
var parseIPv6 = function (input) {
 var address = [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0
 ];
 var pieceIndex = 0;
 var compress = null;
 var pointer = 0;
 var value, length, numbersSeen, ipv4Piece, number, swaps, swap;
 var char = function () {
  return input.charAt(pointer);
 };
 if (char() == ':') {
  if (input.charAt(1) != ':')
   return;
  pointer += 2;
  pieceIndex++;
  compress = pieceIndex;
 }
 while (char()) {
  if (pieceIndex == 8)
   return;
  if (char() == ':') {
   if (compress !== null)
    return;
   pointer++;
   pieceIndex++;
   compress = pieceIndex;
   continue;
  }
  value = length = 0;
  while (length < 4 && HEX.test(char())) {
   value = value * 16 + parseInt(char(), 16);
   pointer++;
   length++;
  }
  if (char() == '.') {
   if (length == 0)
    return;
   pointer -= length;
   if (pieceIndex > 6)
    return;
   numbersSeen = 0;
   while (char()) {
    ipv4Piece = null;
    if (numbersSeen > 0) {
     if (char() == '.' && numbersSeen < 4)
      pointer++;
     else
      return;
    }
    if (!DIGIT.test(char()))
     return;
    while (DIGIT.test(char())) {
     number = parseInt(char(), 10);
     if (ipv4Piece === null)
      ipv4Piece = number;
     else if (ipv4Piece == 0)
      return;
     else
      ipv4Piece = ipv4Piece * 10 + number;
     if (ipv4Piece > 255)
      return;
     pointer++;
    }
    address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
    numbersSeen++;
    if (numbersSeen == 2 || numbersSeen == 4)
     pieceIndex++;
   }
   if (numbersSeen != 4)
    return;
   break;
  } else if (char() == ':') {
   pointer++;
   if (!char())
    return;
  } else if (char())
   return;
  address[pieceIndex++] = value;
 }
 if (compress !== null) {
  swaps = pieceIndex - compress;
  pieceIndex = 7;
  while (pieceIndex != 0 && swaps > 0) {
   swap = address[pieceIndex];
   address[pieceIndex--] = address[compress + swaps - 1];
   address[compress + --swaps] = swap;
  }
 } else if (pieceIndex != 8)
  return;
 return address;
};
var findLongestZeroSequence = function (ipv6) {
 var maxIndex = null;
 var maxLength = 1;
 var currStart = null;
 var currLength = 0;
 var index = 0;
 for (; index < 8; index++) {
  if (ipv6[index] !== 0) {
   if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
   }
   currStart = null;
   currLength = 0;
  } else {
   if (currStart === null)
    currStart = index;
   ++currLength;
  }
 }
 if (currLength > maxLength) {
  maxIndex = currStart;
  maxLength = currLength;
 }
 return maxIndex;
};
var serializeHost = function (host) {
 var result, index, compress, ignore0;
 if (typeof host == 'number') {
  result = [];
  for (index = 0; index < 4; index++) {
   result.unshift(host % 256);
   host = floor(host / 256);
  }
  return result.join('.');
 } else if (typeof host == 'object') {
  result = '';
  compress = findLongestZeroSequence(host);
  for (index = 0; index < 8; index++) {
   if (ignore0 && host[index] === 0)
    continue;
   if (ignore0)
    ignore0 = false;
   if (compress === index) {
    result += index ? ':' : '::';
    ignore0 = true;
   } else {
    result += host[index].toString(16);
    if (index < 7)
     result += ':';
   }
  }
  return '[' + result + ']';
 }
 return host;
};
var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
 ' ': 1,
 '"': 1,
 '<': 1,
 '>': 1,
 '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
 '#': 1,
 '?': 1,
 '{': 1,
 '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
 '/': 1,
 ':': 1,
 ';': 1,
 '=': 1,
 '@': 1,
 '[': 1,
 '\\': 1,
 ']': 1,
 '^': 1,
 '|': 1
});
var percentEncode = function (char, set) {
 var code = codeAt(char, 0);
 return code > 0x20 && code < 0x7F && !has(set, char) ? char : encodeURIComponent(char);
};
var specialSchemes = {
 ftp: 21,
 file: null,
 http: 80,
 https: 443,
 ws: 80,
 wss: 443
};
var isSpecial = function (url) {
 return has(specialSchemes, url.scheme);
};
var includesCredentials = function (url) {
 return url.username != '' || url.password != '';
};
var cannotHaveUsernamePasswordPort = function (url) {
 return !url.host || url.cannotBeABaseURL || url.scheme == 'file';
};
var isWindowsDriveLetter = function (string, normalized) {
 var second;
 return string.length == 2 && ALPHA.test(string.charAt(0)) && ((second = string.charAt(1)) == ':' || !normalized && second == '|');
};
var startsWithWindowsDriveLetter = function (string) {
 var third;
 return string.length > 1 && isWindowsDriveLetter(string.slice(0, 2)) && (string.length == 2 || ((third = string.charAt(2)) === '/' || third === '\\' || third === '?' || third === '#'));
};
var shortenURLsPath = function (url) {
 var path = url.path;
 var pathSize = path.length;
 if (pathSize && (url.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
  path.pop();
 }
};
var isSingleDot = function (segment) {
 return segment === '.' || segment.toLowerCase() === '%2e';
};
var isDoubleDot = function (segment) {
 segment = segment.toLowerCase();
 return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};
var parseURL = function (url, input, stateOverride, base) {
 var state = stateOverride || SCHEME_START;
 var pointer = 0;
 var buffer = '';
 var seenAt = false;
 var seenBracket = false;
 var seenPasswordToken = false;
 var codePoints, char, bufferCodePoints, failure;
 if (!stateOverride) {
  url.scheme = '';
  url.username = '';
  url.password = '';
  url.host = null;
  url.port = null;
  url.path = [];
  url.query = null;
  url.fragment = null;
  url.cannotBeABaseURL = false;
  input = input.replace(LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
 }
 input = input.replace(TAB_AND_NEW_LINE, '');
 codePoints = arrayFrom(input);
 while (pointer <= codePoints.length) {
  char = codePoints[pointer];
  switch (state) {
  case SCHEME_START:
   if (char && ALPHA.test(char)) {
    buffer += char.toLowerCase();
    state = SCHEME;
   } else if (!stateOverride) {
    state = NO_SCHEME;
    continue;
   } else
    return INVALID_SCHEME;
   break;
  case SCHEME:
   if (char && (ALPHANUMERIC.test(char) || char == '+' || char == '-' || char == '.')) {
    buffer += char.toLowerCase();
   } else if (char == ':') {
    if (stateOverride && (isSpecial(url) != has(specialSchemes, buffer) || buffer == 'file' && (includesCredentials(url) || url.port !== null) || url.scheme == 'file' && !url.host))
     return;
    url.scheme = buffer;
    if (stateOverride) {
     if (isSpecial(url) && specialSchemes[url.scheme] == url.port)
      url.port = null;
     return;
    }
    buffer = '';
    if (url.scheme == 'file') {
     state = FILE;
    } else if (isSpecial(url) && base && base.scheme == url.scheme) {
     state = SPECIAL_RELATIVE_OR_AUTHORITY;
    } else if (isSpecial(url)) {
     state = SPECIAL_AUTHORITY_SLASHES;
    } else if (codePoints[pointer + 1] == '/') {
     state = PATH_OR_AUTHORITY;
     pointer++;
    } else {
     url.cannotBeABaseURL = true;
     url.path.push('');
     state = CANNOT_BE_A_BASE_URL_PATH;
    }
   } else if (!stateOverride) {
    buffer = '';
    state = NO_SCHEME;
    pointer = 0;
    continue;
   } else
    return INVALID_SCHEME;
   break;
  case NO_SCHEME:
   if (!base || base.cannotBeABaseURL && char != '#')
    return INVALID_SCHEME;
   if (base.cannotBeABaseURL && char == '#') {
    url.scheme = base.scheme;
    url.path = base.path.slice();
    url.query = base.query;
    url.fragment = '';
    url.cannotBeABaseURL = true;
    state = FRAGMENT;
    break;
   }
   state = base.scheme == 'file' ? FILE : RELATIVE;
   continue;
  case SPECIAL_RELATIVE_OR_AUTHORITY:
   if (char == '/' && codePoints[pointer + 1] == '/') {
    state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
    pointer++;
   } else {
    state = RELATIVE;
    continue;
   }
   break;
  case PATH_OR_AUTHORITY:
   if (char == '/') {
    state = AUTHORITY;
    break;
   } else {
    state = PATH;
    continue;
   }
  case RELATIVE:
   url.scheme = base.scheme;
   if (char == EOF) {
    url.username = base.username;
    url.password = base.password;
    url.host = base.host;
    url.port = base.port;
    url.path = base.path.slice();
    url.query = base.query;
   } else if (char == '/' || char == '\\' && isSpecial(url)) {
    state = RELATIVE_SLASH;
   } else if (char == '?') {
    url.username = base.username;
    url.password = base.password;
    url.host = base.host;
    url.port = base.port;
    url.path = base.path.slice();
    url.query = '';
    state = QUERY;
   } else if (char == '#') {
    url.username = base.username;
    url.password = base.password;
    url.host = base.host;
    url.port = base.port;
    url.path = base.path.slice();
    url.query = base.query;
    url.fragment = '';
    state = FRAGMENT;
   } else {
    url.username = base.username;
    url.password = base.password;
    url.host = base.host;
    url.port = base.port;
    url.path = base.path.slice();
    url.path.pop();
    state = PATH;
    continue;
   }
   break;
  case RELATIVE_SLASH:
   if (isSpecial(url) && (char == '/' || char == '\\')) {
    state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
   } else if (char == '/') {
    state = AUTHORITY;
   } else {
    url.username = base.username;
    url.password = base.password;
    url.host = base.host;
    url.port = base.port;
    state = PATH;
    continue;
   }
   break;
  case SPECIAL_AUTHORITY_SLASHES:
   state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
   if (char != '/' || buffer.charAt(pointer + 1) != '/')
    continue;
   pointer++;
   break;
  case SPECIAL_AUTHORITY_IGNORE_SLASHES:
   if (char != '/' && char != '\\') {
    state = AUTHORITY;
    continue;
   }
   break;
  case AUTHORITY:
   if (char == '@') {
    if (seenAt)
     buffer = '%40' + buffer;
    seenAt = true;
    bufferCodePoints = arrayFrom(buffer);
    for (var i = 0; i < bufferCodePoints.length; i++) {
     var codePoint = bufferCodePoints[i];
     if (codePoint == ':' && !seenPasswordToken) {
      seenPasswordToken = true;
      continue;
     }
     var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
     if (seenPasswordToken)
      url.password += encodedCodePoints;
     else
      url.username += encodedCodePoints;
    }
    buffer = '';
   } else if (char == EOF || char == '/' || char == '?' || char == '#' || char == '\\' && isSpecial(url)) {
    if (seenAt && buffer == '')
     return INVALID_AUTHORITY;
    pointer -= arrayFrom(buffer).length + 1;
    buffer = '';
    state = HOST;
   } else
    buffer += char;
   break;
  case HOST:
  case HOSTNAME:
   if (stateOverride && url.scheme == 'file') {
    state = FILE_HOST;
    continue;
   } else if (char == ':' && !seenBracket) {
    if (buffer == '')
     return INVALID_HOST;
    failure = parseHost(url, buffer);
    if (failure)
     return failure;
    buffer = '';
    state = PORT;
    if (stateOverride == HOSTNAME)
     return;
   } else if (char == EOF || char == '/' || char == '?' || char == '#' || char == '\\' && isSpecial(url)) {
    if (isSpecial(url) && buffer == '')
     return INVALID_HOST;
    if (stateOverride && buffer == '' && (includesCredentials(url) || url.port !== null))
     return;
    failure = parseHost(url, buffer);
    if (failure)
     return failure;
    buffer = '';
    state = PATH_START;
    if (stateOverride)
     return;
    continue;
   } else {
    if (char == '[')
     seenBracket = true;
    else if (char == ']')
     seenBracket = false;
    buffer += char;
   }
   break;
  case PORT:
   if (DIGIT.test(char)) {
    buffer += char;
   } else if (char == EOF || char == '/' || char == '?' || char == '#' || char == '\\' && isSpecial(url) || stateOverride) {
    if (buffer != '') {
     var port = parseInt(buffer, 10);
     if (port > 0xFFFF)
      return INVALID_PORT;
     url.port = isSpecial(url) && port === specialSchemes[url.scheme] ? null : port;
     buffer = '';
    }
    if (stateOverride)
     return;
    state = PATH_START;
    continue;
   } else
    return INVALID_PORT;
   break;
  case FILE:
   url.scheme = 'file';
   if (char == '/' || char == '\\')
    state = FILE_SLASH;
   else if (base && base.scheme == 'file') {
    if (char == EOF) {
     url.host = base.host;
     url.path = base.path.slice();
     url.query = base.query;
    } else if (char == '?') {
     url.host = base.host;
     url.path = base.path.slice();
     url.query = '';
     state = QUERY;
    } else if (char == '#') {
     url.host = base.host;
     url.path = base.path.slice();
     url.query = base.query;
     url.fragment = '';
     state = FRAGMENT;
    } else {
     if (!startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
      url.host = base.host;
      url.path = base.path.slice();
      shortenURLsPath(url);
     }
     state = PATH;
     continue;
    }
   } else {
    state = PATH;
    continue;
   }
   break;
  case FILE_SLASH:
   if (char == '/' || char == '\\') {
    state = FILE_HOST;
    break;
   }
   if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
    if (isWindowsDriveLetter(base.path[0], true))
     url.path.push(base.path[0]);
    else
     url.host = base.host;
   }
   state = PATH;
   continue;
  case FILE_HOST:
   if (char == EOF || char == '/' || char == '\\' || char == '?' || char == '#') {
    if (!stateOverride && isWindowsDriveLetter(buffer)) {
     state = PATH;
    } else if (buffer == '') {
     url.host = '';
     if (stateOverride)
      return;
     state = PATH_START;
    } else {
     failure = parseHost(url, buffer);
     if (failure)
      return failure;
     if (url.host == 'localhost')
      url.host = '';
     if (stateOverride)
      return;
     buffer = '';
     state = PATH_START;
    }
    continue;
   } else
    buffer += char;
   break;
  case PATH_START:
   if (isSpecial(url)) {
    state = PATH;
    if (char != '/' && char != '\\')
     continue;
   } else if (!stateOverride && char == '?') {
    url.query = '';
    state = QUERY;
   } else if (!stateOverride && char == '#') {
    url.fragment = '';
    state = FRAGMENT;
   } else if (char != EOF) {
    state = PATH;
    if (char != '/')
     continue;
   }
   break;
  case PATH:
   if (char == EOF || char == '/' || char == '\\' && isSpecial(url) || !stateOverride && (char == '?' || char == '#')) {
    if (isDoubleDot(buffer)) {
     shortenURLsPath(url);
     if (char != '/' && !(char == '\\' && isSpecial(url))) {
      url.path.push('');
     }
    } else if (isSingleDot(buffer)) {
     if (char != '/' && !(char == '\\' && isSpecial(url))) {
      url.path.push('');
     }
    } else {
     if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
      if (url.host)
       url.host = '';
      buffer = buffer.charAt(0) + ':';
     }
     url.path.push(buffer);
    }
    buffer = '';
    if (url.scheme == 'file' && (char == EOF || char == '?' || char == '#')) {
     while (url.path.length > 1 && url.path[0] === '') {
      url.path.shift();
     }
    }
    if (char == '?') {
     url.query = '';
     state = QUERY;
    } else if (char == '#') {
     url.fragment = '';
     state = FRAGMENT;
    }
   } else {
    buffer += percentEncode(char, pathPercentEncodeSet);
   }
   break;
  case CANNOT_BE_A_BASE_URL_PATH:
   if (char == '?') {
    url.query = '';
    state = QUERY;
   } else if (char == '#') {
    url.fragment = '';
    state = FRAGMENT;
   } else if (char != EOF) {
    url.path[0] += percentEncode(char, C0ControlPercentEncodeSet);
   }
   break;
  case QUERY:
   if (!stateOverride && char == '#') {
    url.fragment = '';
    state = FRAGMENT;
   } else if (char != EOF) {
    if (char == "'" && isSpecial(url))
     url.query += '%27';
    else if (char == '#')
     url.query += '%23';
    else
     url.query += percentEncode(char, C0ControlPercentEncodeSet);
   }
   break;
  case FRAGMENT:
   if (char != EOF)
    url.fragment += percentEncode(char, fragmentPercentEncodeSet);
   break;
  }
  pointer++;
 }
};
var URLConstructor = function URL(url) {
 var that = anInstance(this, URLConstructor, 'URL');
 var base = arguments.length > 1 ? arguments[1] : undefined;
 var urlString = String(url);
 var state = setInternalState(that, { type: 'URL' });
 var baseState, failure;
 if (base !== undefined) {
  if (base instanceof URLConstructor)
   baseState = getInternalURLState(base);
  else {
   failure = parseURL(baseState = {}, String(base));
   if (failure)
    throw TypeError(failure);
  }
 }
 failure = parseURL(state, urlString, null, baseState);
 if (failure)
  throw TypeError(failure);
 var searchParams = state.searchParams = new URLSearchParams();
 var searchParamsState = getInternalSearchParamsState(searchParams);
 searchParamsState.updateSearchParams(state.query);
 searchParamsState.updateURL = function () {
  state.query = String(searchParams) || null;
 };
 if (!DESCRIPTORS) {
  that.href = serializeURL.call(that);
  that.origin = getOrigin.call(that);
  that.protocol = getProtocol.call(that);
  that.username = getUsername.call(that);
  that.password = getPassword.call(that);
  that.host = getHost.call(that);
  that.hostname = getHostname.call(that);
  that.port = getPort.call(that);
  that.pathname = getPathname.call(that);
  that.search = getSearch.call(that);
  that.searchParams = getSearchParams.call(that);
  that.hash = getHash.call(that);
 }
};
var URLPrototype = URLConstructor.prototype;
var serializeURL = function () {
 var url = getInternalURLState(this);
 var scheme = url.scheme;
 var username = url.username;
 var password = url.password;
 var host = url.host;
 var port = url.port;
 var path = url.path;
 var query = url.query;
 var fragment = url.fragment;
 var output = scheme + ':';
 if (host !== null) {
  output += '//';
  if (includesCredentials(url)) {
   output += username + (password ? ':' + password : '') + '@';
  }
  output += serializeHost(host);
  if (port !== null)
   output += ':' + port;
 } else if (scheme == 'file')
  output += '//';
 output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
 if (query !== null)
  output += '?' + query;
 if (fragment !== null)
  output += '#' + fragment;
 return output;
};
var getOrigin = function () {
 var url = getInternalURLState(this);
 var scheme = url.scheme;
 var port = url.port;
 if (scheme == 'blob')
  try {
   return new URL(scheme.path[0]).origin;
  } catch (error) {
   return 'null';
  }
 if (scheme == 'file' || !isSpecial(url))
  return 'null';
 return scheme + '://' + serializeHost(url.host) + (port !== null ? ':' + port : '');
};
var getProtocol = function () {
 return getInternalURLState(this).scheme + ':';
};
var getUsername = function () {
 return getInternalURLState(this).username;
};
var getPassword = function () {
 return getInternalURLState(this).password;
};
var getHost = function () {
 var url = getInternalURLState(this);
 var host = url.host;
 var port = url.port;
 return host === null ? '' : port === null ? serializeHost(host) : serializeHost(host) + ':' + port;
};
var getHostname = function () {
 var host = getInternalURLState(this).host;
 return host === null ? '' : serializeHost(host);
};
var getPort = function () {
 var port = getInternalURLState(this).port;
 return port === null ? '' : String(port);
};
var getPathname = function () {
 var url = getInternalURLState(this);
 var path = url.path;
 return url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
};
var getSearch = function () {
 var query = getInternalURLState(this).query;
 return query ? '?' + query : '';
};
var getSearchParams = function () {
 return getInternalURLState(this).searchParams;
};
var getHash = function () {
 var fragment = getInternalURLState(this).fragment;
 return fragment ? '#' + fragment : '';
};
var accessorDescriptor = function (getter, setter) {
 return {
  get: getter,
  set: setter,
  configurable: true,
  enumerable: true
 };
};
if (DESCRIPTORS) {
 defineProperties(URLPrototype, {
  href: accessorDescriptor(serializeURL, function (href) {
   var url = getInternalURLState(this);
   var urlString = String(href);
   var failure = parseURL(url, urlString);
   if (failure)
    throw TypeError(failure);
   getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
  }),
  origin: accessorDescriptor(getOrigin),
  protocol: accessorDescriptor(getProtocol, function (protocol) {
   var url = getInternalURLState(this);
   parseURL(url, String(protocol) + ':', SCHEME_START);
  }),
  username: accessorDescriptor(getUsername, function (username) {
   var url = getInternalURLState(this);
   var codePoints = arrayFrom(String(username));
   if (cannotHaveUsernamePasswordPort(url))
    return;
   url.username = '';
   for (var i = 0; i < codePoints.length; i++) {
    url.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
   }
  }),
  password: accessorDescriptor(getPassword, function (password) {
   var url = getInternalURLState(this);
   var codePoints = arrayFrom(String(password));
   if (cannotHaveUsernamePasswordPort(url))
    return;
   url.password = '';
   for (var i = 0; i < codePoints.length; i++) {
    url.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
   }
  }),
  host: accessorDescriptor(getHost, function (host) {
   var url = getInternalURLState(this);
   if (url.cannotBeABaseURL)
    return;
   parseURL(url, String(host), HOST);
  }),
  hostname: accessorDescriptor(getHostname, function (hostname) {
   var url = getInternalURLState(this);
   if (url.cannotBeABaseURL)
    return;
   parseURL(url, String(hostname), HOSTNAME);
  }),
  port: accessorDescriptor(getPort, function (port) {
   var url = getInternalURLState(this);
   if (cannotHaveUsernamePasswordPort(url))
    return;
   port = String(port);
   if (port == '')
    url.port = null;
   else
    parseURL(url, port, PORT);
  }),
  pathname: accessorDescriptor(getPathname, function (pathname) {
   var url = getInternalURLState(this);
   if (url.cannotBeABaseURL)
    return;
   url.path = [];
   parseURL(url, pathname + '', PATH_START);
  }),
  search: accessorDescriptor(getSearch, function (search) {
   var url = getInternalURLState(this);
   search = String(search);
   if (search == '') {
    url.query = null;
   } else {
    if ('?' == search.charAt(0))
     search = search.slice(1);
    url.query = '';
    parseURL(url, search, QUERY);
   }
   getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
  }),
  searchParams: accessorDescriptor(getSearchParams),
  hash: accessorDescriptor(getHash, function (hash) {
   var url = getInternalURLState(this);
   hash = String(hash);
   if (hash == '') {
    url.fragment = null;
    return;
   }
   if ('#' == hash.charAt(0))
    hash = hash.slice(1);
   url.fragment = '';
   parseURL(url, hash, FRAGMENT);
  })
 });
}
redefine(URLPrototype, 'toJSON', function toJSON() {
 return serializeURL.call(this);
}, { enumerable: true });
redefine(URLPrototype, 'toString', function toString() {
 return serializeURL.call(this);
}, { enumerable: true });
if (NativeURL) {
 var nativeCreateObjectURL = NativeURL.createObjectURL;
 var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
 if (nativeCreateObjectURL)
  redefine(URLConstructor, 'createObjectURL', function createObjectURL(blob) {
   return nativeCreateObjectURL.apply(NativeURL, arguments);
  });
 if (nativeRevokeObjectURL)
  redefine(URLConstructor, 'revokeObjectURL', function revokeObjectURL(url) {
   return nativeRevokeObjectURL.apply(NativeURL, arguments);
  });
}
setToStringTag(URLConstructor, 'URL');
$({
 global: true,
 forced: !USE_NATIVE_URL,
 sham: !DESCRIPTORS
}, { URL: URLConstructor });

/***/ }),
/* 130 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var fails = __w_pdfjs_require__(9);
var wellKnownSymbol = __w_pdfjs_require__(53);
var IS_PURE = __w_pdfjs_require__(32);
var ITERATOR = wellKnownSymbol('iterator');
module.exports = !fails(function () {
 var url = new URL('b?a=1&b=2&c=3', 'http://a');
 var searchParams = url.searchParams;
 var result = '';
 url.pathname = 'c%20d';
 searchParams.forEach(function (value, key) {
  searchParams['delete']('b');
  result += key + value;
 });
 return IS_PURE && !url.toJSON || !searchParams.sort || url.href !== 'http://a/c%20d?a=1&c=3' || searchParams.get('c') !== '3' || String(new URLSearchParams('?a=1')) !== 'a=1' || !searchParams[ITERATOR] || new URL('https://a@b').username !== 'a' || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b' || new URL('http://тест').host !== 'xn--e1aybc' || new URL('http://a#б').hash !== '#%D0%B1' || result !== 'a1c3' || new URL('http://x', undefined).host !== 'x';
});

/***/ }),
/* 131 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var maxInt = 2147483647;
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128;
var delimiter = '-';
var regexNonASCII = /[^\0-\u007E]/;
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g;
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;
var floor = Math.floor;
var stringFromCharCode = String.fromCharCode;
var ucs2decode = function (string) {
 var output = [];
 var counter = 0;
 var length = string.length;
 while (counter < length) {
  var value = string.charCodeAt(counter++);
  if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
   var extra = string.charCodeAt(counter++);
   if ((extra & 0xFC00) == 0xDC00) {
    output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
   } else {
    output.push(value);
    counter--;
   }
  } else {
   output.push(value);
  }
 }
 return output;
};
var digitToBasic = function (digit) {
 return digit + 22 + 75 * (digit < 26);
};
var adapt = function (delta, numPoints, firstTime) {
 var k = 0;
 delta = firstTime ? floor(delta / damp) : delta >> 1;
 delta += floor(delta / numPoints);
 for (; delta > baseMinusTMin * tMax >> 1; k += base) {
  delta = floor(delta / baseMinusTMin);
 }
 return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};
var encode = function (input) {
 var output = [];
 input = ucs2decode(input);
 var inputLength = input.length;
 var n = initialN;
 var delta = 0;
 var bias = initialBias;
 var i, currentValue;
 for (i = 0; i < input.length; i++) {
  currentValue = input[i];
  if (currentValue < 0x80) {
   output.push(stringFromCharCode(currentValue));
  }
 }
 var basicLength = output.length;
 var handledCPCount = basicLength;
 if (basicLength) {
  output.push(delimiter);
 }
 while (handledCPCount < inputLength) {
  var m = maxInt;
  for (i = 0; i < input.length; i++) {
   currentValue = input[i];
   if (currentValue >= n && currentValue < m) {
    m = currentValue;
   }
  }
  var handledCPCountPlusOne = handledCPCount + 1;
  if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
   throw RangeError(OVERFLOW_ERROR);
  }
  delta += (m - n) * handledCPCountPlusOne;
  n = m;
  for (i = 0; i < input.length; i++) {
   currentValue = input[i];
   if (currentValue < n && ++delta > maxInt) {
    throw RangeError(OVERFLOW_ERROR);
   }
   if (currentValue == n) {
    var q = delta;
    for (var k = base;; k += base) {
     var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
     if (q < t)
      break;
     var qMinusT = q - t;
     var baseMinusT = base - t;
     output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
     q = floor(qMinusT / baseMinusT);
    }
    output.push(stringFromCharCode(digitToBasic(q)));
    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
    delta = 0;
    ++handledCPCount;
   }
  }
  ++delta;
  ++n;
 }
 return output.join('');
};
module.exports = function (input) {
 var encoded = [];
 var labels = input.toLowerCase().replace(regexSeparators, '\u002E').split('.');
 var i, label;
 for (i = 0; i < labels.length; i++) {
  label = labels[i];
  encoded.push(regexNonASCII.test(label) ? 'xn--' + encode(label) : label);
 }
 return encoded.join('.');
};

/***/ }),
/* 132 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

__w_pdfjs_require__(109);
var $ = __w_pdfjs_require__(5);
var getBuiltIn = __w_pdfjs_require__(37);
var USE_NATIVE_URL = __w_pdfjs_require__(130);
var redefine = __w_pdfjs_require__(24);
var redefineAll = __w_pdfjs_require__(112);
var setToStringTag = __w_pdfjs_require__(81);
var createIteratorConstructor = __w_pdfjs_require__(76);
var InternalStateModule = __w_pdfjs_require__(28);
var anInstance = __w_pdfjs_require__(114);
var hasOwn = __w_pdfjs_require__(18);
var bind = __w_pdfjs_require__(58);
var classof = __w_pdfjs_require__(91);
var anObject = __w_pdfjs_require__(23);
var isObject = __w_pdfjs_require__(17);
var create = __w_pdfjs_require__(67);
var createPropertyDescriptor = __w_pdfjs_require__(11);
var getIterator = __w_pdfjs_require__(133);
var getIteratorMethod = __w_pdfjs_require__(90);
var wellKnownSymbol = __w_pdfjs_require__(53);
var $fetch = getBuiltIn('fetch');
var Headers = getBuiltIn('Headers');
var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);
var plus = /\+/g;
var sequences = Array(4);
var percentSequence = function (bytes) {
 return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};
var percentDecode = function (sequence) {
 try {
  return decodeURIComponent(sequence);
 } catch (error) {
  return sequence;
 }
};
var deserialize = function (it) {
 var result = it.replace(plus, ' ');
 var bytes = 4;
 try {
  return decodeURIComponent(result);
 } catch (error) {
  while (bytes) {
   result = result.replace(percentSequence(bytes--), percentDecode);
  }
  return result;
 }
};
var find = /[!'()~]|%20/g;
var replace = {
 '!': '%21',
 "'": '%27',
 '(': '%28',
 ')': '%29',
 '~': '%7E',
 '%20': '+'
};
var replacer = function (match) {
 return replace[match];
};
var serialize = function (it) {
 return encodeURIComponent(it).replace(find, replacer);
};
var parseSearchParams = function (result, query) {
 if (query) {
  var attributes = query.split('&');
  var index = 0;
  var attribute, entry;
  while (index < attributes.length) {
   attribute = attributes[index++];
   if (attribute.length) {
    entry = attribute.split('=');
    result.push({
     key: deserialize(entry.shift()),
     value: deserialize(entry.join('='))
    });
   }
  }
 }
};
var updateSearchParams = function (query) {
 this.entries.length = 0;
 parseSearchParams(this.entries, query);
};
var validateArgumentsLength = function (passed, required) {
 if (passed < required)
  throw TypeError('Not enough arguments');
};
var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
 setInternalState(this, {
  type: URL_SEARCH_PARAMS_ITERATOR,
  iterator: getIterator(getInternalParamsState(params).entries),
  kind: kind
 });
}, 'Iterator', function next() {
 var state = getInternalIteratorState(this);
 var kind = state.kind;
 var step = state.iterator.next();
 var entry = step.value;
 if (!step.done) {
  step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [
   entry.key,
   entry.value
  ];
 }
 return step;
});
var URLSearchParamsConstructor = function URLSearchParams() {
 anInstance(this, URLSearchParamsConstructor, URL_SEARCH_PARAMS);
 var init = arguments.length > 0 ? arguments[0] : undefined;
 var that = this;
 var entries = [];
 var iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key;
 setInternalState(that, {
  type: URL_SEARCH_PARAMS,
  entries: entries,
  updateURL: function () {
  },
  updateSearchParams: updateSearchParams
 });
 if (init !== undefined) {
  if (isObject(init)) {
   iteratorMethod = getIteratorMethod(init);
   if (typeof iteratorMethod === 'function') {
    iterator = iteratorMethod.call(init);
    next = iterator.next;
    while (!(step = next.call(iterator)).done) {
     entryIterator = getIterator(anObject(step.value));
     entryNext = entryIterator.next;
     if ((first = entryNext.call(entryIterator)).done || (second = entryNext.call(entryIterator)).done || !entryNext.call(entryIterator).done)
      throw TypeError('Expected sequence with length 2');
     entries.push({
      key: first.value + '',
      value: second.value + ''
     });
    }
   } else
    for (key in init)
     if (hasOwn(init, key))
      entries.push({
       key: key,
       value: init[key] + ''
      });
  } else {
   parseSearchParams(entries, typeof init === 'string' ? init.charAt(0) === '?' ? init.slice(1) : init : init + '');
  }
 }
};
var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;
redefineAll(URLSearchParamsPrototype, {
 append: function append(name, value) {
  validateArgumentsLength(arguments.length, 2);
  var state = getInternalParamsState(this);
  state.entries.push({
   key: name + '',
   value: value + ''
  });
  state.updateURL();
 },
 'delete': function (name) {
  validateArgumentsLength(arguments.length, 1);
  var state = getInternalParamsState(this);
  var entries = state.entries;
  var key = name + '';
  var index = 0;
  while (index < entries.length) {
   if (entries[index].key === key)
    entries.splice(index, 1);
   else
    index++;
  }
  state.updateURL();
 },
 get: function get(name) {
  validateArgumentsLength(arguments.length, 1);
  var entries = getInternalParamsState(this).entries;
  var key = name + '';
  var index = 0;
  for (; index < entries.length; index++) {
   if (entries[index].key === key)
    return entries[index].value;
  }
  return null;
 },
 getAll: function getAll(name) {
  validateArgumentsLength(arguments.length, 1);
  var entries = getInternalParamsState(this).entries;
  var key = name + '';
  var result = [];
  var index = 0;
  for (; index < entries.length; index++) {
   if (entries[index].key === key)
    result.push(entries[index].value);
  }
  return result;
 },
 has: function has(name) {
  validateArgumentsLength(arguments.length, 1);
  var entries = getInternalParamsState(this).entries;
  var key = name + '';
  var index = 0;
  while (index < entries.length) {
   if (entries[index++].key === key)
    return true;
  }
  return false;
 },
 set: function set(name, value) {
  validateArgumentsLength(arguments.length, 1);
  var state = getInternalParamsState(this);
  var entries = state.entries;
  var found = false;
  var key = name + '';
  var val = value + '';
  var index = 0;
  var entry;
  for (; index < entries.length; index++) {
   entry = entries[index];
   if (entry.key === key) {
    if (found)
     entries.splice(index--, 1);
    else {
     found = true;
     entry.value = val;
    }
   }
  }
  if (!found)
   entries.push({
    key: key,
    value: val
   });
  state.updateURL();
 },
 sort: function sort() {
  var state = getInternalParamsState(this);
  var entries = state.entries;
  var slice = entries.slice();
  var entry, entriesIndex, sliceIndex;
  entries.length = 0;
  for (sliceIndex = 0; sliceIndex < slice.length; sliceIndex++) {
   entry = slice[sliceIndex];
   for (entriesIndex = 0; entriesIndex < sliceIndex; entriesIndex++) {
    if (entries[entriesIndex].key > entry.key) {
     entries.splice(entriesIndex, 0, entry);
     break;
    }
   }
   if (entriesIndex === sliceIndex)
    entries.push(entry);
  }
  state.updateURL();
 },
 forEach: function forEach(callback) {
  var entries = getInternalParamsState(this).entries;
  var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined, 3);
  var index = 0;
  var entry;
  while (index < entries.length) {
   entry = entries[index++];
   boundFunction(entry.value, entry.key, this);
  }
 },
 keys: function keys() {
  return new URLSearchParamsIterator(this, 'keys');
 },
 values: function values() {
  return new URLSearchParamsIterator(this, 'values');
 },
 entries: function entries() {
  return new URLSearchParamsIterator(this, 'entries');
 }
}, { enumerable: true });
redefine(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries);
redefine(URLSearchParamsPrototype, 'toString', function toString() {
 var entries = getInternalParamsState(this).entries;
 var result = [];
 var index = 0;
 var entry;
 while (index < entries.length) {
  entry = entries[index++];
  result.push(serialize(entry.key) + '=' + serialize(entry.value));
 }
 return result.join('&');
}, { enumerable: true });
setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);
$({
 global: true,
 forced: !USE_NATIVE_URL
}, { URLSearchParams: URLSearchParamsConstructor });
if (!USE_NATIVE_URL && typeof $fetch == 'function' && typeof Headers == 'function') {
 $({
  global: true,
  enumerable: true,
  forced: true
 }, {
  fetch: function fetch(input) {
   var args = [input];
   var init, body, headers;
   if (arguments.length > 1) {
    init = arguments[1];
    if (isObject(init)) {
     body = init.body;
     if (classof(body) === URL_SEARCH_PARAMS) {
      headers = init.headers ? new Headers(init.headers) : new Headers();
      if (!headers.has('content-type')) {
       headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
      }
      init = create(init, {
       body: createPropertyDescriptor(0, String(body)),
       headers: createPropertyDescriptor(0, headers)
      });
     }
    }
    args.push(init);
   }
   return $fetch.apply(this, args);
  }
 });
}
module.exports = {
 URLSearchParams: URLSearchParamsConstructor,
 getState: getInternalParamsState
};

/***/ }),
/* 133 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var anObject = __w_pdfjs_require__(23);
var getIteratorMethod = __w_pdfjs_require__(90);
module.exports = function (it) {
 var iteratorMethod = getIteratorMethod(it);
 if (typeof iteratorMethod != 'function') {
  throw TypeError(String(it) + ' is not iterable');
 }
 return anObject(iteratorMethod.call(it));
};

/***/ }),
/* 134 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var $ = __w_pdfjs_require__(5);
$({
 target: 'URL',
 proto: true,
 enumerable: true
}, {
 toJSON: function toJSON() {
  return URL.prototype.toString.call(this);
 }
});

/***/ }),
/* 135 */
/***/ (function(module, exports, __w_pdfjs_require__) {

(function (global, factory) {
  true ? factory(exports) : undefined;
}(this, function (exports) {
 'use strict';
 var SymbolPolyfill = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol : function (description) {
  return "Symbol(" + description + ")";
 };
 function noop() {
 }
 var NumberIsNaN = Number.isNaN || function (x) {
  return x !== x;
 };
 var rethrowAssertionErrorRejection = noop;
 function typeIsObject(x) {
  return typeof x === 'object' && x !== null || typeof x === 'function';
 }
 function createArrayFromList(elements) {
  return elements.slice();
 }
 function ArrayBufferCopy(dest, destOffset, src, srcOffset, n) {
  new Uint8Array(dest).set(new Uint8Array(src, srcOffset, n), destOffset);
 }
 function IsFiniteNonNegativeNumber(v) {
  if (IsNonNegativeNumber(v) === false) {
   return false;
  }
  if (v === Infinity) {
   return false;
  }
  return true;
 }
 function IsNonNegativeNumber(v) {
  if (typeof v !== 'number') {
   return false;
  }
  if (NumberIsNaN(v)) {
   return false;
  }
  if (v < 0) {
   return false;
  }
  return true;
 }
 function Call(F, V, args) {
  if (typeof F !== 'function') {
   throw new TypeError('Argument is not a function');
  }
  return Function.prototype.apply.call(F, V, args);
 }
 function CreateAlgorithmFromUnderlyingMethod(underlyingObject, methodName, algoArgCount, extraArgs) {
  var method = underlyingObject[methodName];
  if (method !== undefined) {
   if (typeof method !== 'function') {
    throw new TypeError(method + " is not a method");
   }
   switch (algoArgCount) {
   case 0: {
     return function () {
      return PromiseCall(method, underlyingObject, extraArgs);
     };
    }
   case 1: {
     return function (arg) {
      var fullArgs = [arg].concat(extraArgs);
      return PromiseCall(method, underlyingObject, fullArgs);
     };
    }
   }
  }
  return function () {
   return promiseResolvedWith(undefined);
  };
 }
 function InvokeOrNoop(O, P, args) {
  var method = O[P];
  if (method === undefined) {
   return undefined;
  }
  return Call(method, O, args);
 }
 function PromiseCall(F, V, args) {
  try {
   return promiseResolvedWith(Call(F, V, args));
  } catch (value) {
   return promiseRejectedWith(value);
  }
 }
 function TransferArrayBuffer(O) {
  return O;
 }
 function IsDetachedBuffer(O) {
  return false;
 }
 function ValidateAndNormalizeHighWaterMark(highWaterMark) {
  highWaterMark = Number(highWaterMark);
  if (NumberIsNaN(highWaterMark) || highWaterMark < 0) {
   throw new RangeError('highWaterMark property of a queuing strategy must be non-negative and non-NaN');
  }
  return highWaterMark;
 }
 function MakeSizeAlgorithmFromSizeFunction(size) {
  if (size === undefined) {
   return function () {
    return 1;
   };
  }
  if (typeof size !== 'function') {
   throw new TypeError('size property of a queuing strategy must be a function');
  }
  return function (chunk) {
   return size(chunk);
  };
 }
 var originalPromise = Promise;
 var originalPromiseThen = Promise.prototype.then;
 var originalPromiseResolve = Promise.resolve.bind(originalPromise);
 var originalPromiseReject = Promise.reject.bind(originalPromise);
 function newPromise(executor) {
  return new originalPromise(executor);
 }
 function promiseResolvedWith(value) {
  return originalPromiseResolve(value);
 }
 function promiseRejectedWith(reason) {
  return originalPromiseReject(reason);
 }
 function PerformPromiseThen(promise, onFulfilled, onRejected) {
  return originalPromiseThen.call(promise, onFulfilled, onRejected);
 }
 function uponPromise(promise, onFulfilled, onRejected) {
  PerformPromiseThen(PerformPromiseThen(promise, onFulfilled, onRejected), undefined, rethrowAssertionErrorRejection);
 }
 function uponFulfillment(promise, onFulfilled) {
  uponPromise(promise, onFulfilled);
 }
 function uponRejection(promise, onRejected) {
  uponPromise(promise, undefined, onRejected);
 }
 function transformPromiseWith(promise, fulfillmentHandler, rejectionHandler) {
  return PerformPromiseThen(promise, fulfillmentHandler, rejectionHandler);
 }
 function setPromiseIsHandledToTrue(promise) {
  PerformPromiseThen(promise, undefined, rethrowAssertionErrorRejection);
 }
 var QUEUE_MAX_ARRAY_SIZE = 16384;
 var SimpleQueue = function () {
  function SimpleQueue() {
   this._cursor = 0;
   this._size = 0;
   this._front = {
    _elements: [],
    _next: undefined
   };
   this._back = this._front;
   this._cursor = 0;
   this._size = 0;
  }
  Object.defineProperty(SimpleQueue.prototype, "length", {
   get: function () {
    return this._size;
   },
   enumerable: true,
   configurable: true
  });
  SimpleQueue.prototype.push = function (element) {
   var oldBack = this._back;
   var newBack = oldBack;
   if (oldBack._elements.length === QUEUE_MAX_ARRAY_SIZE - 1) {
    newBack = {
     _elements: [],
     _next: undefined
    };
   }
   oldBack._elements.push(element);
   if (newBack !== oldBack) {
    this._back = newBack;
    oldBack._next = newBack;
   }
   ++this._size;
  };
  SimpleQueue.prototype.shift = function () {
   var oldFront = this._front;
   var newFront = oldFront;
   var oldCursor = this._cursor;
   var newCursor = oldCursor + 1;
   var elements = oldFront._elements;
   var element = elements[oldCursor];
   if (newCursor === QUEUE_MAX_ARRAY_SIZE) {
    newFront = oldFront._next;
    newCursor = 0;
   }
   --this._size;
   this._cursor = newCursor;
   if (oldFront !== newFront) {
    this._front = newFront;
   }
   elements[oldCursor] = undefined;
   return element;
  };
  SimpleQueue.prototype.forEach = function (callback) {
   var i = this._cursor;
   var node = this._front;
   var elements = node._elements;
   while (i !== elements.length || node._next !== undefined) {
    if (i === elements.length) {
     node = node._next;
     elements = node._elements;
     i = 0;
     if (elements.length === 0) {
      break;
     }
    }
    callback(elements[i]);
    ++i;
   }
  };
  SimpleQueue.prototype.peek = function () {
   var front = this._front;
   var cursor = this._cursor;
   return front._elements[cursor];
  };
  return SimpleQueue;
 }();
 function ReadableStreamCreateReadResult(value, done, forAuthorCode) {
  var prototype = null;
  if (forAuthorCode === true) {
   prototype = Object.prototype;
  }
  var obj = Object.create(prototype);
  obj.value = value;
  obj.done = done;
  return obj;
 }
 function ReadableStreamReaderGenericInitialize(reader, stream) {
  reader._forAuthorCode = true;
  reader._ownerReadableStream = stream;
  stream._reader = reader;
  if (stream._state === 'readable') {
   defaultReaderClosedPromiseInitialize(reader);
  } else if (stream._state === 'closed') {
   defaultReaderClosedPromiseInitializeAsResolved(reader);
  } else {
   defaultReaderClosedPromiseInitializeAsRejected(reader, stream._storedError);
  }
 }
 function ReadableStreamReaderGenericCancel(reader, reason) {
  var stream = reader._ownerReadableStream;
  return ReadableStreamCancel(stream, reason);
 }
 function ReadableStreamReaderGenericRelease(reader) {
  if (reader._ownerReadableStream._state === 'readable') {
   defaultReaderClosedPromiseReject(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
  } else {
   defaultReaderClosedPromiseResetToRejected(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
  }
  reader._ownerReadableStream._reader = undefined;
  reader._ownerReadableStream = undefined;
 }
 function readerLockException(name) {
  return new TypeError('Cannot ' + name + ' a stream using a released reader');
 }
 function defaultReaderClosedPromiseInitialize(reader) {
  reader._closedPromise = newPromise(function (resolve, reject) {
   reader._closedPromise_resolve = resolve;
   reader._closedPromise_reject = reject;
  });
 }
 function defaultReaderClosedPromiseInitializeAsRejected(reader, reason) {
  defaultReaderClosedPromiseInitialize(reader);
  defaultReaderClosedPromiseReject(reader, reason);
 }
 function defaultReaderClosedPromiseInitializeAsResolved(reader) {
  defaultReaderClosedPromiseInitialize(reader);
  defaultReaderClosedPromiseResolve(reader);
 }
 function defaultReaderClosedPromiseReject(reader, reason) {
  setPromiseIsHandledToTrue(reader._closedPromise);
  reader._closedPromise_reject(reason);
  reader._closedPromise_resolve = undefined;
  reader._closedPromise_reject = undefined;
 }
 function defaultReaderClosedPromiseResetToRejected(reader, reason) {
  defaultReaderClosedPromiseInitializeAsRejected(reader, reason);
 }
 function defaultReaderClosedPromiseResolve(reader) {
  reader._closedPromise_resolve(undefined);
  reader._closedPromise_resolve = undefined;
  reader._closedPromise_reject = undefined;
 }
 var CancelSteps = SymbolPolyfill('[[CancelSteps]]');
 var PullSteps = SymbolPolyfill('[[PullSteps]]');
 function AcquireReadableStreamDefaultReader(stream, forAuthorCode) {
  if (forAuthorCode === void 0) {
   forAuthorCode = false;
  }
  var reader = new ReadableStreamDefaultReader(stream);
  reader._forAuthorCode = forAuthorCode;
  return reader;
 }
 function ReadableStreamAddReadRequest(stream) {
  var promise = newPromise(function (resolve, reject) {
   var readRequest = {
    _resolve: resolve,
    _reject: reject
   };
   stream._reader._readRequests.push(readRequest);
  });
  return promise;
 }
 function ReadableStreamFulfillReadRequest(stream, chunk, done) {
  var reader = stream._reader;
  var readRequest = reader._readRequests.shift();
  readRequest._resolve(ReadableStreamCreateReadResult(chunk, done, reader._forAuthorCode));
 }
 function ReadableStreamGetNumReadRequests(stream) {
  return stream._reader._readRequests.length;
 }
 function ReadableStreamHasDefaultReader(stream) {
  var reader = stream._reader;
  if (reader === undefined) {
   return false;
  }
  if (!IsReadableStreamDefaultReader(reader)) {
   return false;
  }
  return true;
 }
 var ReadableStreamDefaultReader = function () {
  function ReadableStreamDefaultReader(stream) {
   if (IsReadableStream(stream) === false) {
    throw new TypeError('ReadableStreamDefaultReader can only be constructed with a ReadableStream instance');
   }
   if (IsReadableStreamLocked(stream) === true) {
    throw new TypeError('This stream has already been locked for exclusive reading by another reader');
   }
   ReadableStreamReaderGenericInitialize(this, stream);
   this._readRequests = new SimpleQueue();
  }
  Object.defineProperty(ReadableStreamDefaultReader.prototype, "closed", {
   get: function () {
    if (!IsReadableStreamDefaultReader(this)) {
     return promiseRejectedWith(defaultReaderBrandCheckException('closed'));
    }
    return this._closedPromise;
   },
   enumerable: true,
   configurable: true
  });
  ReadableStreamDefaultReader.prototype.cancel = function (reason) {
   if (!IsReadableStreamDefaultReader(this)) {
    return promiseRejectedWith(defaultReaderBrandCheckException('cancel'));
   }
   if (this._ownerReadableStream === undefined) {
    return promiseRejectedWith(readerLockException('cancel'));
   }
   return ReadableStreamReaderGenericCancel(this, reason);
  };
  ReadableStreamDefaultReader.prototype.read = function () {
   if (!IsReadableStreamDefaultReader(this)) {
    return promiseRejectedWith(defaultReaderBrandCheckException('read'));
   }
   if (this._ownerReadableStream === undefined) {
    return promiseRejectedWith(readerLockException('read from'));
   }
   return ReadableStreamDefaultReaderRead(this);
  };
  ReadableStreamDefaultReader.prototype.releaseLock = function () {
   if (!IsReadableStreamDefaultReader(this)) {
    throw defaultReaderBrandCheckException('releaseLock');
   }
   if (this._ownerReadableStream === undefined) {
    return;
   }
   if (this._readRequests.length > 0) {
    throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
   }
   ReadableStreamReaderGenericRelease(this);
  };
  return ReadableStreamDefaultReader;
 }();
 function IsReadableStreamDefaultReader(x) {
  if (!typeIsObject(x)) {
   return false;
  }
  if (!Object.prototype.hasOwnProperty.call(x, '_readRequests')) {
   return false;
  }
  return true;
 }
 function ReadableStreamDefaultReaderRead(reader) {
  var stream = reader._ownerReadableStream;
  stream._disturbed = true;
  if (stream._state === 'closed') {
   return promiseResolvedWith(ReadableStreamCreateReadResult(undefined, true, reader._forAuthorCode));
  }
  if (stream._state === 'errored') {
   return promiseRejectedWith(stream._storedError);
  }
  return stream._readableStreamController[PullSteps]();
 }
 function defaultReaderBrandCheckException(name) {
  return new TypeError("ReadableStreamDefaultReader.prototype." + name + " can only be used on a ReadableStreamDefaultReader");
 }
 var _a;
 var AsyncIteratorPrototype;
 if (typeof SymbolPolyfill.asyncIterator === 'symbol') {
  AsyncIteratorPrototype = (_a = {}, _a[SymbolPolyfill.asyncIterator] = function () {
   return this;
  }, _a);
  Object.defineProperty(AsyncIteratorPrototype, SymbolPolyfill.asyncIterator, { enumerable: false });
 }
 var ReadableStreamAsyncIteratorPrototype = {
  next: function () {
   if (IsReadableStreamAsyncIterator(this) === false) {
    return promiseRejectedWith(streamAsyncIteratorBrandCheckException('next'));
   }
   var reader = this._asyncIteratorReader;
   if (reader._ownerReadableStream === undefined) {
    return promiseRejectedWith(readerLockException('iterate'));
   }
   return transformPromiseWith(ReadableStreamDefaultReaderRead(reader), function (result) {
    var done = result.done;
    if (done) {
     ReadableStreamReaderGenericRelease(reader);
    }
    var value = result.value;
    return ReadableStreamCreateReadResult(value, done, true);
   });
  },
  return: function (value) {
   if (IsReadableStreamAsyncIterator(this) === false) {
    return promiseRejectedWith(streamAsyncIteratorBrandCheckException('next'));
   }
   var reader = this._asyncIteratorReader;
   if (reader._ownerReadableStream === undefined) {
    return promiseRejectedWith(readerLockException('finish iterating'));
   }
   if (reader._readRequests.length > 0) {
    return promiseRejectedWith(new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled'));
   }
   if (this._preventCancel === false) {
    var result = ReadableStreamReaderGenericCancel(reader, value);
    ReadableStreamReaderGenericRelease(reader);
    return transformPromiseWith(result, function () {
     return ReadableStreamCreateReadResult(value, true, true);
    });
   }
   ReadableStreamReaderGenericRelease(reader);
   return promiseResolvedWith(ReadableStreamCreateReadResult(value, true, true));
  }
 };
 if (AsyncIteratorPrototype !== undefined) {
  Object.setPrototypeOf(ReadableStreamAsyncIteratorPrototype, AsyncIteratorPrototype);
 }
 Object.defineProperty(ReadableStreamAsyncIteratorPrototype, 'next', { enumerable: false });
 Object.defineProperty(ReadableStreamAsyncIteratorPrototype, 'return', { enumerable: false });
 function AcquireReadableStreamAsyncIterator(stream, preventCancel) {
  if (preventCancel === void 0) {
   preventCancel = false;
  }
  var reader = AcquireReadableStreamDefaultReader(stream);
  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype);
  iterator._asyncIteratorReader = reader;
  iterator._preventCancel = Boolean(preventCancel);
  return iterator;
 }
 function IsReadableStreamAsyncIterator(x) {
  if (!typeIsObject(x)) {
   return false;
  }
  if (!Object.prototype.hasOwnProperty.call(x, '_asyncIteratorReader')) {
   return false;
  }
  return true;
 }
 function streamAsyncIteratorBrandCheckException(name) {
  return new TypeError("ReadableStreamAsyncIterator." + name + " can only be used on a ReadableSteamAsyncIterator");
 }
 function DequeueValue(container) {
  var pair = container._queue.shift();
  container._queueTotalSize -= pair.size;
  if (container._queueTotalSize < 0) {
   container._queueTotalSize = 0;
  }
  return pair.value;
 }
 function EnqueueValueWithSize(container, value, size) {
  size = Number(size);
  if (!IsFiniteNonNegativeNumber(size)) {
   throw new RangeError('Size must be a finite, non-NaN, non-negative number.');
  }
  container._queue.push({
   value: value,
   size: size
  });
  container._queueTotalSize += size;
 }
 function PeekQueueValue(container) {
  var pair = container._queue.peek();
  return pair.value;
 }
 function ResetQueue(container) {
  container._queue = new SimpleQueue();
  container._queueTotalSize = 0;
 }
 var AbortSteps = SymbolPolyfill('[[AbortSteps]]');
 var ErrorSteps = SymbolPolyfill('[[ErrorSteps]]');
 var WritableStream = function () {
  function WritableStream(underlyingSink, strategy) {
   if (underlyingSink === void 0) {
    underlyingSink = {};
   }
   if (strategy === void 0) {
    strategy = {};
   }
   InitializeWritableStream(this);
   var size = strategy.size;
   var highWaterMark = strategy.highWaterMark;
   var type = underlyingSink.type;
   if (type !== undefined) {
    throw new RangeError('Invalid type is specified');
   }
   var sizeAlgorithm = MakeSizeAlgorithmFromSizeFunction(size);
   if (highWaterMark === undefined) {
    highWaterMark = 1;
   }
   highWaterMark = ValidateAndNormalizeHighWaterMark(highWaterMark);
   SetUpWritableStreamDefaultControllerFromUnderlyingSink(this, underlyingSink, highWaterMark, sizeAlgorithm);
  }
  Object.defineProperty(WritableStream.prototype, "locked", {
   get: function () {
    if (IsWritableStream(this) === false) {
     throw streamBrandCheckException('locked');
    }
    return IsWritableStreamLocked(this);
   },
   enumerable: true,
   configurable: true
  });
  WritableStream.prototype.abort = function (reason) {
   if (IsWritableStream(this) === false) {
    return promiseRejectedWith(streamBrandCheckException('abort'));
   }
   if (IsWritableStreamLocked(this) === true) {
    return promiseRejectedWith(new TypeError('Cannot abort a stream that already has a writer'));
   }
   return WritableStreamAbort(this, reason);
  };
  WritableStream.prototype.close = function () {
   if (IsWritableStream(this) === false) {
    return promiseRejectedWith(streamBrandCheckException('close'));
   }
   if (IsWritableStreamLocked(this) === true) {
    return promiseRejectedWith(new TypeError('Cannot close a stream that already has a writer'));
   }
   if (WritableStreamCloseQueuedOrInFlight(this) === true) {
    return promiseRejectedWith(new TypeError('Cannot close an already-closing stream'));
   }
   return WritableStreamClose(this);
  };
  WritableStream.prototype.getWriter = function () {
   if (IsWritableStream(this) === false) {
    throw streamBrandCheckException('getWriter');
   }
   return AcquireWritableStreamDefaultWriter(this);
  };
  return WritableStream;
 }();
 function AcquireWritableStreamDefaultWriter(stream) {
  return new WritableStreamDefaultWriter(stream);
 }
 function CreateWritableStream(startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, highWaterMark, sizeAlgorithm) {
  if (highWaterMark === void 0) {
   highWaterMark = 1;
  }
  if (sizeAlgorithm === void 0) {
   sizeAlgorithm = function () {
    return 1;
   };
  }
  var stream = Object.create(WritableStream.prototype);
  InitializeWritableStream(stream);
  var controller = Object.create(WritableStreamDefaultController.prototype);
  SetUpWritableStreamDefaultController(stream, controller, startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, highWaterMark, sizeAlgorithm);
  return stream;
 }
 function InitializeWritableStream(stream) {
  stream._state = 'writable';
  stream._storedError = undefined;
  stream._writer = undefined;
  stream._writableStreamController = undefined;
  stream._writeRequests = new SimpleQueue();
  stream._inFlightWriteRequest = undefined;
  stream._closeRequest = undefined;
  stream._inFlightCloseRequest = undefined;
  stream._pendingAbortRequest = undefined;
  stream._backpressure = false;
 }
 function IsWritableStream(x) {
  if (!typeIsObject(x)) {
   return false;
  }
  if (!Object.prototype.hasOwnProperty.call(x, '_writableStreamController')) {
   return false;
  }
  return true;
 }
 function IsWritableStreamLocked(stream) {
  if (stream._writer === undefined) {
   return false;
  }
  return true;
 }
 function WritableStreamAbort(stream, reason) {
  var state = stream._state;
  if (state === 'closed' || state === 'errored') {
   return promiseResolvedWith(undefined);
  }
  if (stream._pendingAbortRequest !== undefined) {
   return stream._pendingAbortRequest._promise;
  }
  var wasAlreadyErroring = false;
  if (state === 'erroring') {
   wasAlreadyErroring = true;
   reason = undefined;
  }
  var promise = newPromise(function (resolve, reject) {
   stream._pendingAbortRequest = {
    _promise: undefined,
    _resolve: resolve,
    _reject: reject,
    _reason: reason,
    _wasAlreadyErroring: wasAlreadyErroring
   };
  });
  stream._pendingAbortRequest._promise = promise;
  if (wasAlreadyErroring === false) {
   WritableStreamStartErroring(stream, reason);
  }
  return promise;
 }
 function WritableStreamClose(stream) {
  var state = stream._state;
  if (state === 'closed' || state === 'errored') {
   return promiseRejectedWith(new TypeError("The stream (in " + state + " state) is not in the writable state and cannot be closed"));
  }
  var promise = newPromise(function (resolve, reject) {
   var closeRequest = {
    _resolve: resolve,
    _reject: reject
   };
   stream._closeRequest = closeRequest;
  });
  var writer = stream._writer;
  if (writer !== undefined && stream._backpressure === true && state === 'writable') {
   defaultWriterReadyPromiseResolve(writer);
  }
  WritableStreamDefaultControllerClose(stream._writableStreamController);
  return promise;
 }
 function WritableStreamAddWriteRequest(stream) {
  var promise = newPromise(function (resolve, reject) {
   var writeRequest = {
    _resolve: resolve,
    _reject: reject
   };
   stream._writeRequests.push(writeRequest);
  });
  return promise;
 }
 function WritableStreamDealWithRejection(stream, error) {
  var state = stream._state;
  if (state === 'writable') {
   WritableStreamStartErroring(stream, error);
   return;
  }
  WritableStreamFinishErroring(stream);
 }
 function WritableStreamStartErroring(stream, reason) {
  var controller = stream._writableStreamController;
  stream._state = 'erroring';
  stream._storedError = reason;
  var writer = stream._writer;
  if (writer !== undefined) {
   WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, reason);
  }
  if (WritableStreamHasOperationMarkedInFlight(stream) === false && controller._started === true) {
   WritableStreamFinishErroring(stream);
  }
 }
 function WritableStreamFinishErroring(stream) {
  stream._state = 'errored';
  stream._writableStreamController[ErrorSteps]();
  var storedError = stream._storedError;
  stream._writeRequests.forEach(function (writeRequest) {
   writeRequest._reject(storedError);
  });
  stream._writeRequests = new SimpleQueue();
  if (stream._pendingAbortRequest === undefined) {
   WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
   return;
  }
  var abortRequest = stream._pendingAbortRequest;
  stream._pendingAbortRequest = undefined;
  if (abortRequest._wasAlreadyErroring === true) {
   abortRequest._reject(storedError);
   WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
   return;
  }
  var promise = stream._writableStreamController[AbortSteps](abortRequest._reason);
  uponPromise(promise, function () {
   abortRequest._resolve();
   WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
  }, function (reason) {
   abortRequest._reject(reason);
   WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
  });
 }
 function WritableStreamFinishInFlightWrite(stream) {
  stream._inFlightWriteRequest._resolve(undefined);
  stream._inFlightWriteRequest = undefined;
 }
 function WritableStreamFinishInFlightWriteWithError(stream, error) {
  stream._inFlightWriteRequest._reject(error);
  stream._inFlightWriteRequest = undefined;
  WritableStreamDealWithRejection(stream, error);
 }
 function WritableStreamFinishInFlightClose(stream) {
  stream._inFlightCloseRequest._resolve(undefined);
  stream._inFlightCloseRequest = undefined;
  var state = stream._state;
  if (state === 'erroring') {
   stream._storedError = undefined;
   if (stream._pendingAbortRequest !== undefined) {
    stream._pendingAbortRequest._resolve();
    stream._pendingAbortRequest = undefined;
   }
  }
  stream._state = 'closed';
  var writer = stream._writer;
  if (writer !== undefined) {
   defaultWriterClosedPromiseResolve(writer);
  }
 }
 function WritableStreamFinishInFlightCloseWithError(stream, error) {
  stream._inFlightCloseRequest._reject(error);
  stream._inFlightCloseRequest = undefined;
  if (stream._pendingAbortRequest !== undefined) {
   stream._pendingAbortRequest._reject(error);
   stream._pendingAbortRequest = undefined;
  }
  WritableStreamDealWithRejection(stream, error);
 }
 function WritableStreamCloseQueuedOrInFlight(stream) {
  if (stream._closeRequest === undefined && stream._inFlightCloseRequest === undefined) {
   return false;
  }
  return true;
 }
 function WritableStreamHasOperationMarkedInFlight(stream) {
  if (stream._inFlightWriteRequest === undefined && stream._inFlightCloseRequest === undefined) {
   return false;
  }
  return true;
 }
 function WritableStreamMarkCloseRequestInFlight(stream) {
  stream._inFlightCloseRequest = stream._closeRequest;
  stream._closeRequest = undefined;
 }
 function WritableStreamMarkFirstWriteRequestInFlight(stream) {
  stream._inFlightWriteRequest = stream._writeRequests.shift();
 }
 function WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream) {
  if (stream._closeRequest !== undefined) {
   stream._closeRequest._reject(stream._storedError);
   stream._closeRequest = undefined;
  }
  var writer = stream._writer;
  if (writer !== undefined) {
   defaultWriterClosedPromiseReject(writer, stream._storedError);
  }
 }
 function WritableStreamUpdateBackpressure(stream, backpressure) {
  var writer = stream._writer;
  if (writer !== undefined && backpressure !== stream._backpressure) {
   if (backpressure === true) {
    defaultWriterReadyPromiseReset(writer);
   } else {
    defaultWriterReadyPromiseResolve(writer);
   }
  }
  stream._backpressure = backpressure;
 }
 var WritableStreamDefaultWriter = function () {
  function WritableStreamDefaultWriter(stream) {
   if (IsWritableStream(stream) === false) {
    throw new TypeError('WritableStreamDefaultWriter can only be constructed with a WritableStream instance');
   }
   if (IsWritableStreamLocked(stream) === true) {
    throw new TypeError('This stream has already been locked for exclusive writing by another writer');
   }
   this._ownerWritableStream = stream;
   stream._writer = this;
   var state = stream._state;
   if (state === 'writable') {
    if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._backpressure === true) {
     defaultWriterReadyPromiseInitialize(this);
    } else {
     defaultWriterReadyPromiseInitializeAsResolved(this);
    }
    defaultWriterClosedPromiseInitialize(this);
   } else if (state === 'erroring') {
    defaultWriterReadyPromiseInitializeAsRejected(this, stream._storedError);
    defaultWriterClosedPromiseInitialize(this);
   } else if (state === 'closed') {
    defaultWriterReadyPromiseInitializeAsResolved(this);
    defaultWriterClosedPromiseInitializeAsResolved(this);
   } else {
    var storedError = stream._storedError;
    defaultWriterReadyPromiseInitializeAsRejected(this, storedError);
    defaultWriterClosedPromiseInitializeAsRejected(this, storedError);
   }
  }
  Object.defineProperty(WritableStreamDefaultWriter.prototype, "closed", {
   get: function () {
    if (IsWritableStreamDefaultWriter(this) === false) {
     return promiseRejectedWith(defaultWriterBrandCheckException('closed'));
    }
    return this._closedPromise;
   },
   enumerable: true,
   configurable: true
  });
  Object.defineProperty(WritableStreamDefaultWriter.prototype, "desiredSize", {
   get: function () {
    if (IsWritableStreamDefaultWriter(this) === false) {
     throw defaultWriterBrandCheckException('desiredSize');
    }
    if (this._ownerWritableStream === undefined) {
     throw defaultWriterLockException('desiredSize');
    }
    return WritableStreamDefaultWriterGetDesiredSize(this);
   },
   enumerable: true,
   configurable: true
  });
  Object.defineProperty(WritableStreamDefaultWriter.prototype, "ready", {
   get: function () {
    if (IsWritableStreamDefaultWriter(this) === false) {
     return promiseRejectedWith(defaultWriterBrandCheckException('ready'));
    }
    return this._readyPromise;
   },
   enumerable: true,
   configurable: true
  });
  WritableStreamDefaultWriter.prototype.abort = function (reason) {
   if (IsWritableStreamDefaultWriter(this) === false) {
    return promiseRejectedWith(defaultWriterBrandCheckException('abort'));
   }
   if (this._ownerWritableStream === undefined) {
    return promiseRejectedWith(defaultWriterLockException('abort'));
   }
   return WritableStreamDefaultWriterAbort(this, reason);
  };
  WritableStreamDefaultWriter.prototype.close = function () {
   if (IsWritableStreamDefaultWriter(this) === false) {
    return promiseRejectedWith(defaultWriterBrandCheckException('close'));
   }
   var stream = this._ownerWritableStream;
   if (stream === undefined) {
    return promiseRejectedWith(defaultWriterLockException('close'));
   }
   if (WritableStreamCloseQueuedOrInFlight(stream) === true) {
    return promiseRejectedWith(new TypeError('Cannot close an already-closing stream'));
   }
   return WritableStreamDefaultWriterClose(this);
  };
  WritableStreamDefaultWriter.prototype.releaseLock = function () {
   if (IsWritableStreamDefaultWriter(this) === false) {
    throw defaultWriterBrandCheckException('releaseLock');
   }
   var stream = this._ownerWritableStream;
   if (stream === undefined) {
    return;
   }
   WritableStreamDefaultWriterRelease(this);
  };
  WritableStreamDefaultWriter.prototype.write = function (chunk) {
   if (IsWritableStreamDefaultWriter(this) === false) {
    return promiseRejectedWith(defaultWriterBrandCheckException('write'));
   }
   if (this._ownerWritableStream === undefined) {
    return promiseRejectedWith(defaultWriterLockException('write to'));
   }
   return WritableStreamDefaultWriterWrite(this, chunk);
  };
  return WritableStreamDefaultWriter;
 }();
 function IsWritableStreamDefaultWriter(x) {
  if (!typeIsObject(x)) {
   return false;
  }
  if (!Object.prototype.hasOwnProperty.call(x, '_ownerWritableStream')) {
   return false;
  }
  return true;
 }
 function WritableStreamDefaultWriterAbort(writer, reason) {
  var stream = writer._ownerWritableStream;
  return WritableStreamAbort(stream, reason);
 }
 function WritableStreamDefaultWriterClose(writer) {
  var stream = writer._ownerWritableStream;
  return WritableStreamClose(stream);
 }
 function WritableStreamDefaultWriterCloseWithErrorPropagation(writer) {
  var stream = writer._ownerWritableStream;
  var state = stream._state;
  if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
   return promiseResolvedWith(undefined);
  }
  if (state === 'errored') {
   return promiseRejectedWith(stream._storedError);
  }
  return WritableStreamDefaultWriterClose(writer);
 }
 function WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, error) {
  if (writer._closedPromiseState === 'pending') {
   defaultWriterClosedPromiseReject(writer, error);
  } else {
   defaultWriterClosedPromiseResetToRejected(writer, error);
  }
 }
 function WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, error) {
  if (writer._readyPromiseState === 'pending') {
   defaultWriterReadyPromiseReject(writer, error);
  } else {
   defaultWriterReadyPromiseResetToRejected(writer, error);
  }
 }
 function WritableStreamDefaultWriterGetDesiredSize(writer) {
  var stream = writer._ownerWritableStream;
  var state = stream._state;
  if (state === 'errored' || state === 'erroring') {
   return null;
  }
  if (state === 'closed') {
   return 0;
  }
  return WritableStreamDefaultControllerGetDesiredSize(stream._writableStreamController);
 }
 function WritableStreamDefaultWriterRelease(writer) {
  var stream = writer._ownerWritableStream;
  var releasedError = new TypeError('Writer was released and can no longer be used to monitor the stream\'s closedness');
  WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, releasedError);
  WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, releasedError);
  stream._writer = undefined;
  writer._ownerWritableStream = undefined;
 }
 function WritableStreamDefaultWriterWrite(writer, chunk) {
  var stream = writer._ownerWritableStream;
  var controller = stream._writableStreamController;
  var chunkSize = WritableStreamDefaultControllerGetChunkSize(controller, chunk);
  if (stream !== writer._ownerWritableStream) {
   return promiseRejectedWith(defaultWriterLockException('write to'));
  }
  var state = stream._state;
  if (state === 'errored') {
   return promiseRejectedWith(stream._storedError);
  }
  if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
   return promiseRejectedWith(new TypeError('The stream is closing or closed and cannot be written to'));
  }
  if (state === 'erroring') {
   return promiseRejectedWith(stream._storedError);
  }
  var promise = WritableStreamAddWriteRequest(stream);
  WritableStreamDefaultControllerWrite(controller, chunk, chunkSize);
  return promise;
 }
 var WritableStreamDefaultController = function () {
  function WritableStreamDefaultController() {
   throw new TypeError('WritableStreamDefaultController cannot be constructed explicitly');
  }
  WritableStreamDefaultController.prototype.error = function (e) {
   if (IsWritableStreamDefaultController(this) === false) {
    throw new TypeError('WritableStreamDefaultController.prototype.error can only be used on a WritableStreamDefaultController');
   }
   var state = this._controlledWritableStream._state;
   if (state !== 'writable') {
    return;
   }
   WritableStreamDefaultControllerError(this, e);
  };
  WritableStreamDefaultController.prototype[AbortSteps] = function (reason) {
   var result = this._abortAlgorithm(reason);
   WritableStreamDefaultControllerClearAlgorithms(this);
   return result;
  };
  WritableStreamDefaultController.prototype[ErrorSteps] = function () {
   ResetQueue(this);
  };
  return WritableStreamDefaultController;
 }();
 function IsWritableStreamDefaultController(x) {
  if (!typeIsObject(x)) {
   return false;
  }
  if (!Object.prototype.hasOwnProperty.call(x, '_controlledWritableStream')) {
   return false;
  }
  return true;
 }
 function SetUpWritableStreamDefaultController(stream, controller, startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, highWaterMark, sizeAlgorithm) {
  controller._controlledWritableStream = stream;
  stream._writableStreamController = controller;
  controller._queue = undefined;
  controller._queueTotalSize = undefined;
  ResetQueue(controller);
  controller._started = false;
  controller._strategySizeAlgorithm = sizeAlgorithm;
  controller._strategyHWM = highWaterMark;
  controller._writeAlgorithm = writeAlgorithm;
  controller._closeAlgorithm = closeAlgorithm;
  controller._abortAlgorithm = abortAlgorithm;
  var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
  WritableStreamUpdateBackpressure(stream, backpressure);
  var startResult = startAlgorithm();
  var startPromise = promiseResolvedWith(startResult);
  uponPromise(startPromise, function () {
   controller._started = true;
   WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
  }, function (r) {
   controller._started = true;
   WritableStreamDealWithRejection(stream, r);
  });
 }
 function SetUpWritableStreamDefaultControllerFromUnderlyingSink(stream, underlyingSink, highWaterMark, sizeAlgorithm) {
  var controller = Object.create(WritableStreamDefaultController.prototype);
  function startAlgorithm() {
   return InvokeOrNoop(underlyingSink, 'start', [controller]);
  }
  var writeAlgorithm = CreateAlgorithmFromUnderlyingMethod(underlyingSink, 'write', 1, [controller]);
  var closeAlgorithm = CreateAlgorithmFromUnderlyingMethod(underlyingSink, 'close', 0, []);
  var abortAlgorithm = CreateAlgorithmFromUnderlyingMethod(underlyingSink, 'abort', 1, []);
  SetUpWritableStreamDefaultController(stream, controller, startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, highWaterMark, sizeAlgorithm);
 }
 function WritableStreamDefaultControllerClearAlgorithms(controller) {
  controller._writeAlgorithm = undefined;
  controller._closeAlgorithm = undefined;
  controller._abortAlgorithm = undefined;
  controller._strategySizeAlgorithm = undefined;
 }
 function WritableStreamDefaultControllerClose(controller) {
  EnqueueValueWithSize(controller, 'close', 0);
  WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
 }
 function WritableStreamDefaultControllerGetChunkSize(controller, chunk) {
  try {
   return controller._strategySizeAlgorithm(chunk);
  } catch (chunkSizeE) {
   WritableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
   return 1;
  }
 }
 function WritableStreamDefaultControllerGetDesiredSize(controller) {
  return controller._strategyHWM - controller._queueTotalSize;
 }
 function WritableStreamDefaultControllerWrite(controller, chunk, chunkSize) {
  var writeRecord = { chunk: chunk };
  try {
   EnqueueValueWithSize(controller, writeRecord, chunkSize);
  } catch (enqueueE) {
   WritableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
   return;
  }
  var stream = controller._controlledWritableStream;
  if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._state === 'writable') {
   var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
   WritableStreamUpdateBackpressure(stream, backpressure);
  }
  WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
 }
 function WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller) {
  var stream = controller._controlledWritableStream;
  if (controller._started === false) {
   return;
  }
  if (stream._inFlightWriteRequest !== undefined) {
   return;
  }
  var state = stream._state;
  if (state === 'erroring') {
   WritableStreamFinishErroring(stream);
   return;
  }
  if (controller._queue.length === 0) {
   return;
  }
  var writeRecord = PeekQueueValue(controller);
  if (writeRecord === 'close') {
   WritableStreamDefaultControllerProcessClose(controller);
  } else {
   WritableStreamDefaultControllerProcessWrite(controller, writeRecord.chunk);
  }
 }
 function WritableStreamDefaultControllerErrorIfNeeded(controller, error) {
  if (controller._controlledWritableStream._state === 'writable') {
   WritableStreamDefaultControllerError(controller, error);
  }
 }
 function WritableStreamDefaultControllerProcessClose(controller) {
  var stream = controller._controlledWritableStream;
  WritableStreamMarkCloseRequestInFlight(stream);
  DequeueValue(controller);
  var sinkClosePromise = controller._closeAlgorithm();
  WritableStreamDefaultControllerClearAlgorithms(controller);
  uponPromise(sinkClosePromise, function () {
   WritableStreamFinishInFlightClose(stream);
  }, function (reason) {
   WritableStreamFinishInFlightCloseWithError(stream, reason);
  });
 }
 function WritableStreamDefaultControllerProcessWrite(controller, chunk) {
  var stream = controller._controlledWritableStream;
  WritableStreamMarkFirstWriteRequestInFlight(stream);
  var sinkWritePromise = controller._writeAlgorithm(chunk);
  uponPromise(sinkWritePromise, function () {
   WritableStreamFinishInFlightWrite(stream);
   var state = stream._state;
   DequeueValue(controller);
   if (WritableStreamCloseQueuedOrInFlight(stream) === false && state === 'writable') {
    var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
    WritableStreamUpdateBackpressure(stream, backpressure);
   }
   WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
  }, function (reason) {
   if (stream._state === 'writable') {
    WritableStreamDefaultControllerClearAlgorithms(controller);
   }
   WritableStreamFinishInFlightWriteWithError(stream, reason);
  });
 }
 function WritableStreamDefaultControllerGetBackpressure(controller) {
  var desiredSize = WritableStreamDefaultControllerGetDesiredSize(controller);
  return desiredSize <= 0;
 }
 function WritableStreamDefaultControllerError(controller, error) {
  var stream = controller._controlledWritableStream;
  WritableStreamDefaultControllerClearAlgorithms(controller);
  WritableStreamStartErroring(stream, error);
 }
 function streamBrandCheckException(name) {
  return new TypeError("WritableStream.prototype." + name + " can only be used on a WritableStream");
 }
 function defaultWriterBrandCheckException(name) {
  return new TypeError("WritableStreamDefaultWriter.prototype." + name + " can only be used on a WritableStreamDefaultWriter");
 }
 function defaultWriterLockException(name) {
  return new TypeError('Cannot ' + name + ' a stream using a released writer');
 }
 function defaultWriterClosedPromiseInitialize(writer) {
  writer._closedPromise = newPromise(function (resolve, reject) {
   writer._closedPromise_resolve = resolve;
   writer._closedPromise_reject = reject;
   writer._closedPromiseState = 'pending';
  });
 }
 function defaultWriterClosedPromiseInitializeAsRejected(writer, reason) {
  defaultWriterClosedPromiseInitialize(writer);
  defaultWriterClosedPromiseReject(writer, reason);
 }
 function defaultWriterClosedPromiseInitializeAsResolved(writer) {
  defaultWriterClosedPromiseInitialize(writer);
  defaultWriterClosedPromiseResolve(writer);
 }
 function defaultWriterClosedPromiseReject(writer, reason) {
  setPromiseIsHandledToTrue(writer._closedPromise);
  writer._closedPromise_reject(reason);
  writer._closedPromise_resolve = undefined;
  writer._closedPromise_reject = undefined;
  writer._closedPromiseState = 'rejected';
 }
 function defaultWriterClosedPromiseResetToRejected(writer, reason) {
  defaultWriterClosedPromiseInitializeAsRejected(writer, reason);
 }
 function defaultWriterClosedPromiseResolve(writer) {
  writer._closedPromise_resolve(undefined);
  writer._closedPromise_resolve = undefined;
  writer._closedPromise_reject = undefined;
  writer._closedPromiseState = 'resolved';
 }
 function defaultWriterReadyPromiseInitialize(writer) {
  writer._readyPromise = newPromise(function (resolve, reject) {
   writer._readyPromise_resolve = resolve;
   writer._readyPromise_reject = reject;
  });
  writer._readyPromiseState = 'pending';
 }
 function defaultWriterReadyPromiseInitializeAsRejected(writer, reason) {
  defaultWriterReadyPromiseInitialize(writer);
  defaultWriterReadyPromiseReject(writer, reason);
 }
 function defaultWriterReadyPromiseInitializeAsResolved(writer) {
  defaultWriterReadyPromiseInitialize(writer);
  defaultWriterReadyPromiseResolve(writer);
 }
 function defaultWriterReadyPromiseReject(writer, reason) {
  setPromiseIsHandledToTrue(writer._readyPromise);
  writer._readyPromise_reject(reason);
  writer._readyPromise_resolve = undefined;
  writer._readyPromise_reject = undefined;
  writer._readyPromiseState = 'rejected';
 }
 function defaultWriterReadyPromiseReset(writer) {
  defaultWriterReadyPromiseInitialize(writer);
 }
 function defaultWriterReadyPromiseResetToRejected(writer, reason) {
  defaultWriterReadyPromiseInitializeAsRejected(writer, reason);
 }
 function defaultWriterReadyPromiseResolve(writer) {
  writer._readyPromise_resolve(undefined);
  writer._readyPromise_resolve = undefined;
  writer._readyPromise_reject = undefined;
  writer._readyPromiseState = 'fulfilled';
 }
 function isAbortSignal(value) {
  if (typeof value !== 'object' || value === null) {
   return false;
  }
  try {
   return typeof value.aborted === 'boolean';
  } catch (_a) {
   return false;
  }
 }
 var NativeDOMException = typeof DOMException !== 'undefined' ? DOMException : undefined;
 function isDOMExceptionConstructor(ctor) {
  if (!(typeof ctor === 'function' || typeof ctor === 'object')) {
   return false;
  }
  try {
   new ctor();
   return true;
  } catch (_a) {
   return false;
  }
 }
 function createDOMExceptionPolyfill() {
  var ctor = function DOMException(message, name) {
   this.message = message || '';
   this.name = name || 'Error';
   if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
   }
  };
  ctor.prototype = Object.create(Error.prototype);
  Object.defineProperty(ctor.prototype, 'constructor', {
   value: ctor,
   writable: true,
   configurable: true
  });
  return ctor;
 }
 var DOMException$1 = isDOMExceptionConstructor(NativeDOMException) ? NativeDOMException : createDOMExceptionPolyfill();
 function ReadableStreamPipeTo(source, dest, preventClose, preventAbort, preventCancel, signal) {
  var reader = AcquireReadableStreamDefaultReader(source);
  var writer = AcquireWritableStreamDefaultWriter(dest);
  source._disturbed = true;
  var shuttingDown = false;
  var currentWrite = promiseResolvedWith(undefined);
  return newPromise(function (resolve, reject) {
   var abortAlgorithm;
   if (signal !== undefined) {
    abortAlgorithm = function () {
     var error = new DOMException$1('Aborted', 'AbortError');
     var actions = [];
     if (preventAbort === false) {
      actions.push(function () {
       if (dest._state === 'writable') {
        return WritableStreamAbort(dest, error);
       }
       return promiseResolvedWith(undefined);
      });
     }
     if (preventCancel === false) {
      actions.push(function () {
       if (source._state === 'readable') {
        return ReadableStreamCancel(source, error);
       }
       return promiseResolvedWith(undefined);
      });
     }
     shutdownWithAction(function () {
      return Promise.all(actions.map(function (action) {
       return action();
      }));
     }, true, error);
    };
    if (signal.aborted === true) {
     abortAlgorithm();
     return;
    }
    signal.addEventListener('abort', abortAlgorithm);
   }
   function pipeLoop() {
    return newPromise(function (resolveLoop, rejectLoop) {
     function next(done) {
      if (done) {
       resolveLoop();
      } else {
       PerformPromiseThen(pipeStep(), next, rejectLoop);
      }
     }
     next(false);
    });
   }
   function pipeStep() {
    if (shuttingDown === true) {
     return promiseResolvedWith(true);
    }
    return PerformPromiseThen(writer._readyPromise, function () {
     return PerformPromiseThen(ReadableStreamDefaultReaderRead(reader), function (_a) {
      var value = _a.value, done = _a.done;
      if (done === true) {
       return true;
      }
      currentWrite = PerformPromiseThen(WritableStreamDefaultWriterWrite(writer, value), undefined, noop);
      return false;
     });
    });
   }
   isOrBecomesErrored(source, reader._closedPromise, function (storedError) {
    if (preventAbort === false) {
     shutdownWithAction(function () {
      return WritableStreamAbort(dest, storedError);
     }, true, storedError);
    } else {
     shutdown(true, storedError);
    }
   });
   isOrBecomesErrored(dest, writer._closedPromise, function (storedError) {
    if (preventCancel === false) {
     shutdownWithAction(function () {
      return ReadableStreamCancel(source, storedError);
     }, true, storedError);
    } else {
     shutdown(true, storedError);
    }
   });
   isOrBecomesClosed(source, reader._closedPromise, function () {
    if (preventClose === false) {
     shutdownWithAction(function () {
      return WritableStreamDefaultWriterCloseWithErrorPropagation(writer);
     });
    } else {
     shutdown();
    }
   });
   if (WritableStreamCloseQueuedOrInFlight(dest) === true || dest._state === 'closed') {
    var destClosed_1 = new TypeError('the destination writable stream closed before all data could be piped to it');
    if (preventCancel === false) {
     shutdownWithAction(function () {
      return ReadableStreamCancel(source, destClosed_1);
     }, true, destClosed_1);
    } else {
     shutdown(true, destClosed_1);
    }
   }
   setPromiseIsHandledToTrue(pipeLoop());
   function waitForWritesToFinish() {
    var oldCurrentWrite = currentWrite;
    return PerformPromiseThen(currentWrite, function () {
     return oldCurrentWrite !== currentWrite ? waitForWritesToFinish() : undefined;
    });
   }
   function isOrBecomesErrored(stream, promise, action) {
    if (stream._state === 'errored') {
     action(stream._storedError);
    } else {
     uponRejection(promise, action);
    }
   }
   function isOrBecomesClosed(stream, promise, action) {
    if (stream._state === 'closed') {
     action();
    } else {
     uponFulfillment(promise, action);
    }
   }
   function shutdownWithAction(action, originalIsError, originalError) {
    if (shuttingDown === true) {
     return;
    }
    shuttingDown = true;
    if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
     uponFulfillment(waitForWritesToFinish(), doTheRest);
    } else {
     doTheRest();
    }
    function doTheRest() {
     uponPromise(action(), function () {
      return finalize(originalIsError, originalError);
     }, function (newError) {
      return finalize(true, newError);
     });
    }
   }
   function shutdown(isError, error) {
    if (shuttingDown === true) {
     return;
    }
    shuttingDown = true;
    if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
     uponFulfillment(waitForWritesToFinish(), function () {
      return finalize(isError, error);
     });
    } else {
     finalize(isError, error);
    }
   }
   function finalize(isError, error) {
    WritableStreamDefaultWriterRelease(writer);
    ReadableStreamReaderGenericRelease(reader);
    if (signal !== undefined) {
     signal.removeEventListener('abort', abortAlgorithm);
    }
    if (isError) {
     reject(error);
    } else {
     resolve(undefined);
    }
   }
  });
 }
 var ReadableStreamDefaultController = function () {
  function ReadableStreamDefaultController() {
   throw new TypeError();
  }
  Object.defineProperty(ReadableStreamDefaultController.prototype, "desiredSize", {
   get: function () {
    if (IsReadableStreamDefaultController(this) === false) {
     throw defaultControllerBrandCheckException('desiredSize');
    }
    return ReadableStreamDefaultControllerGetDesiredSize(this);
   },
   enumerable: true,
   configurable: true
  });
  ReadableStreamDefaultController.prototype.close = function () {
   if (IsReadableStreamDefaultController(this) === false) {
    throw defaultControllerBrandCheckException('close');
   }
   if (ReadableStreamDefaultControllerCanCloseOrEnqueue(this) === false) {
    throw new TypeError('The stream is not in a state that permits close');
   }
   ReadableStreamDefaultControllerClose(this);
  };
  ReadableStreamDefaultController.prototype.enqueue = function (chunk) {
   if (IsReadableStreamDefaultController(this) === false) {
    throw defaultControllerBrandCheckException('enqueue');
   }
   if (ReadableStreamDefaultControllerCanCloseOrEnqueue(this) === false) {
    throw new TypeError('The stream is not in a state that permits enqueue');
   }
   return ReadableStreamDefaultControllerEnqueue(this, chunk);
  };
  ReadableStreamDefaultController.prototype.error = function (e) {
   if (IsReadableStreamDefaultController(this) === false) {
    throw defaultControllerBrandCheckException('error');
   }
   ReadableStreamDefaultControllerError(this, e);
  };
  ReadableStreamDefaultController.prototype[CancelSteps] = function (reason) {
   ResetQueue(this);
   var result = this._cancelAlgorithm(reason);
   ReadableStreamDefaultControllerClearAlgorithms(this);
   return result;
  };
  ReadableStreamDefaultController.prototype[PullSteps] = function () {
   var stream = this._controlledReadableStream;
   if (this._queue.length > 0) {
    var chunk = DequeueValue(this);
    if (this._closeRequested === true && this._queue.length === 0) {
     ReadableStreamDefaultControllerClearAlgorithms(this);
     ReadableStreamClose(stream);
    } else {
     ReadableStreamDefaultControllerCallPullIfNeeded(this);
    }
    return promiseResolvedWith(ReadableStreamCreateReadResult(chunk, false, stream._reader._forAuthorCode));
   }
   var pendingPromise = ReadableStreamAddReadRequest(stream);
   ReadableStreamDefaultControllerCallPullIfNeeded(this);
   return pendingPromise;
  };
  return ReadableStreamDefaultController;
 }();
 function IsReadableStreamDefaultController(x) {
  if (!typeIsObject(x)) {
   return false;
  }
  if (!Object.prototype.hasOwnProperty.call(x, '_controlledReadableStream')) {
   return false;
  }
  return true;
 }
 function ReadableStreamDefaultControllerCallPullIfNeeded(controller) {
  var shouldPull = ReadableStreamDefaultControllerShouldCallPull(controller);
  if (shouldPull === false) {
   return;
  }
  if (controller._pulling === true) {
   controller._pullAgain = true;
   return;
  }
  controller._pulling = true;
  var pullPromise = controller._pullAlgorithm();
  uponPromise(pullPromise, function () {
   controller._pulling = false;
   if (controller._pullAgain === true) {
    controller._pullAgain = false;
    ReadableStreamDefaultControllerCallPullIfNeeded(controller);
   }
  }, function (e) {
   ReadableStreamDefaultControllerError(controller, e);
  });
 }
 function ReadableStreamDefaultControllerShouldCallPull(controller) {
  var stream = controller._controlledReadableStream;
  if (ReadableStreamDefaultControllerCanCloseOrEnqueue(controller) === false) {
   return false;
  }
  if (controller._started === false) {
   return false;
  }
  if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
   return true;
  }
  var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
  if (desiredSize > 0) {
   return true;
  }
  return false;
 }
 function ReadableStreamDefaultControllerClearAlgorithms(controller) {
  controller._pullAlgorithm = undefined;
  controller._cancelAlgorithm = undefined;
  controller._strategySizeAlgorithm = undefined;
 }
 function ReadableStreamDefaultControllerClose(controller) {
  var stream = controller._controlledReadableStream;
  controller._closeRequested = true;
  if (controller._queue.length === 0) {
   ReadableStreamDefaultControllerClearAlgorithms(controller);
   ReadableStreamClose(stream);
  }
 }
 function ReadableStreamDefaultControllerEnqueue(controller, chunk) {
  var stream = controller._controlledReadableStream;
  if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
   ReadableStreamFulfillReadRequest(stream, chunk, false);
  } else {
   var chunkSize = void 0;
   try {
    chunkSize = controller._strategySizeAlgorithm(chunk);
   } catch (chunkSizeE) {
    ReadableStreamDefaultControllerError(controller, chunkSizeE);
    throw chunkSizeE;
   }
   try {
    EnqueueValueWithSize(controller, chunk, chunkSize);
   } catch (enqueueE) {
    ReadableStreamDefaultControllerError(controller, enqueueE);
    throw enqueueE;
   }
  }
  ReadableStreamDefaultControllerCallPullIfNeeded(controller);
 }
 function ReadableStreamDefaultControllerError(controller, e) {
  var stream = controller._controlledReadableStream;
  if (stream._state !== 'readable') {
   return;
  }
  ResetQueue(controller);
  ReadableStreamDefaultControllerClearAlgorithms(controller);
  ReadableStreamError(stream, e);
 }
 function ReadableStreamDefaultControllerGetDesiredSize(controller) {
  var stream = controller._controlledReadableStream;
  var state = stream._state;
  if (state === 'errored') {
   return null;
  }
  if (state === 'closed') {
   return 0;
  }
  return controller._strategyHWM - controller._queueTotalSize;
 }
 function ReadableStreamDefaultControllerHasBackpressure(controller) {
  if (ReadableStreamDefaultControllerShouldCallPull(controller) === true) {
   return false;
  }
  return true;
 }
 function ReadableStreamDefaultControllerCanCloseOrEnqueue(controller) {
  var state = controller._controlledReadableStream._state;
  if (controller._closeRequested === false && state === 'readable') {
   return true;
  }
  return false;
 }
 function SetUpReadableStreamDefaultController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, sizeAlgorithm) {
  controller._controlledReadableStream = stream;
  controller._queue = undefined;
  controller._queueTotalSize = undefined;
  ResetQueue(controller);
  controller._started = false;
  controller._closeRequested = false;
  controller._pullAgain = false;
  controller._pulling = false;
  controller._strategySizeAlgorithm = sizeAlgorithm;
  controller._strategyHWM = highWaterMark;
  controller._pullAlgorithm = pullAlgorithm;
  controller._cancelAlgorithm = cancelAlgorithm;
  stream._readableStreamController = controller;
  var startResult = startAlgorithm();
  uponPromise(promiseResolvedWith(startResult), function () {
   controller._started = true;
   ReadableStreamDefaultControllerCallPullIfNeeded(controller);
  }, function (r) {
   ReadableStreamDefaultControllerError(controller, r);
  });
 }
 function SetUpReadableStreamDefaultControllerFromUnderlyingSource(stream, underlyingSource, highWaterMark, sizeAlgorithm) {
  var controller = Object.create(ReadableStreamDefaultController.prototype);
  function startAlgorithm() {
   return InvokeOrNoop(underlyingSource, 'start', [controller]);
  }
  var pullAlgorithm = CreateAlgorithmFromUnderlyingMethod(underlyingSource, 'pull', 0, [controller]);
  var cancelAlgorithm = CreateAlgorithmFromUnderlyingMethod(underlyingSource, 'cancel', 1, []);
  SetUpReadableStreamDefaultController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, sizeAlgorithm);
 }
 function defaultControllerBrandCheckException(name) {
  return new TypeError("ReadableStreamDefaultController.prototype." + name + " can only be used on a ReadableStreamDefaultController");
 }
 function ReadableStreamTee(stream, cloneForBranch2) {
  var reader = AcquireReadableStreamDefaultReader(stream);
  var reading = false;
  var canceled1 = false;
  var canceled2 = false;
  var reason1;
  var reason2;
  var branch1;
  var branch2;
  var resolveCancelPromise;
  var cancelPromise = newPromise(function (resolve) {
   resolveCancelPromise = resolve;
  });
  function pullAlgorithm() {
   if (reading === true) {
    return promiseResolvedWith(undefined);
   }
   reading = true;
   var readPromise = transformPromiseWith(ReadableStreamDefaultReaderRead(reader), function (result) {
    reading = false;
    var done = result.done;
    if (done === true) {
     if (canceled1 === false) {
      ReadableStreamDefaultControllerClose(branch1._readableStreamController);
     }
     if (canceled2 === false) {
      ReadableStreamDefaultControllerClose(branch2._readableStreamController);
     }
     return;
    }
    var value = result.value;
    var value1 = value;
    var value2 = value;
    if (canceled1 === false) {
     ReadableStreamDefaultControllerEnqueue(branch1._readableStreamController, value1);
    }
    if (canceled2 === false) {
     ReadableStreamDefaultControllerEnqueue(branch2._readableStreamController, value2);
    }
   });
   setPromiseIsHandledToTrue(readPromise);
   return promiseResolvedWith(undefined);
  }
  function cancel1Algorithm(reason) {
   canceled1 = true;
   reason1 = reason;
   if (canceled2 === true) {
    var compositeReason = createArrayFromList([
     reason1,
     reason2
    ]);
    var cancelResult = ReadableStreamCancel(stream, compositeReason);
    resolveCancelPromise(cancelResult);
   }
   return cancelPromise;
  }
  function cancel2Algorithm(reason) {
   canceled2 = true;
   reason2 = reason;
   if (canceled1 === true) {
    var compositeReason = createArrayFromList([
     reason1,
     reason2
    ]);
    var cancelResult = ReadableStreamCancel(stream, compositeReason);
    resolveCancelPromise(cancelResult);
   }
   return cancelPromise;
  }
  function startAlgorithm() {
  }
  branch1 = CreateReadableStream(startAlgorithm, pullAlgorithm, cancel1Algorithm);
  branch2 = CreateReadableStream(startAlgorithm, pullAlgorithm, cancel2Algorithm);
  uponRejection(reader._closedPromise, function (r) {
   ReadableStreamDefaultControllerError(branch1._readableStreamController, r);
   ReadableStreamDefaultControllerError(branch2._readableStreamController, r);
  });
  return [
   branch1,
   branch2
  ];
 }
 var NumberIsInteger = Number.isInteger || function (value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
 };
 var ReadableStreamBYOBRequest = function () {
  function ReadableStreamBYOBRequest() {
   throw new TypeError('ReadableStreamBYOBRequest cannot be used directly');
  }
  Object.defineProperty(ReadableStreamBYOBRequest.prototype, "view", {
   get: function () {
    if (IsReadableStreamBYOBRequest(this) === false) {
     throw byobRequestBrandCheckException('view');
    }
    return this._view;
   },
   enumerable: true,
   configurable: true
  });
  ReadableStreamBYOBRequest.prototype.respond = function (bytesWritten) {
   if (IsReadableStreamBYOBRequest(this) === false) {
    throw byobRequestBrandCheckException('respond');
   }
   if (this._associatedReadableByteStreamController === undefined) {
    throw new TypeError('This BYOB request has been invalidated');
   }
   if (IsDetachedBuffer(this._view.buffer) === true);
   ReadableByteStreamControllerRespond(this._associatedReadableByteStreamController, bytesWritten);
  };
  ReadableStreamBYOBRequest.prototype.respondWithNewView = function (view) {
   if (IsReadableStreamBYOBRequest(this) === false) {
    throw byobRequestBrandCheckException('respond');
   }
   if (this._associatedReadableByteStreamController === undefined) {
    throw new TypeError('This BYOB request has been invalidated');
   }
   if (!ArrayBuffer.isView(view)) {
    throw new TypeError('You can only respond with array buffer views');
   }
   if (IsDetachedBuffer(view.buffer) === true);
   ReadableByteStreamControllerRespondWithNewView(this._associatedReadableByteStreamController, view);
  };
  return ReadableStreamBYOBRequest;
 }();
 var ReadableByteStreamController = function () {
  function ReadableByteStreamController() {
   throw new TypeError('ReadableByteStreamController constructor cannot be used directly');
  }
  Object.defineProperty(ReadableByteStreamController.prototype, "byobRequest", {
   get: function () {
    if (IsReadableByteStreamController(this) === false) {
     throw byteStreamControllerBrandCheckException('byobRequest');
    }
    if (this._byobRequest === undefined && this._pendingPullIntos.length > 0) {
     var firstDescriptor = this._pendingPullIntos.peek();
     var view = new Uint8Array(firstDescriptor.buffer, firstDescriptor.byteOffset + firstDescriptor.bytesFilled, firstDescriptor.byteLength - firstDescriptor.bytesFilled);
     var byobRequest = Object.create(ReadableStreamBYOBRequest.prototype);
     SetUpReadableStreamBYOBRequest(byobRequest, this, view);
     this._byobRequest = byobRequest;
    }
    return this._byobRequest;
   },
   enumerable: true,
   configurable: true
  });
  Object.defineProperty(ReadableByteStreamController.prototype, "desiredSize", {
   get: function () {
    if (IsReadableByteStreamController(this) === false) {
     throw byteStreamControllerBrandCheckException('desiredSize');
    }
    return ReadableByteStreamControllerGetDesiredSize(this);
   },
   enumerable: true,
   configurable: true
  });
  ReadableByteStreamController.prototype.close = function () {
   if (IsReadableByteStreamController(this) === false) {
    throw byteStreamControllerBrandCheckException('close');
   }
   if (this._closeRequested === true) {
    throw new TypeError('The stream has already been closed; do not close it again!');
   }
   var state = this._controlledReadableByteStream._state;
   if (state !== 'readable') {
    throw new TypeError("The stream (in " + state + " state) is not in the readable state and cannot be closed");
   }
   ReadableByteStreamControllerClose(this);
  };
  ReadableByteStreamController.prototype.enqueue = function (chunk) {
   if (IsReadableByteStreamController(this) === false) {
    throw byteStreamControllerBrandCheckException('enqueue');
   }
   if (this._closeRequested === true) {
    throw new TypeError('stream is closed or draining');
   }
   var state = this._controlledReadableByteStream._state;
   if (state !== 'readable') {
    throw new TypeError("The stream (in " + state + " state) is not in the readable state and cannot be enqueued to");
   }
   if (!ArrayBuffer.isView(chunk)) {
    throw new TypeError('You can only enqueue array buffer views when using a ReadableByteStreamController');
   }
   if (IsDetachedBuffer(chunk.buffer) === true);
   ReadableByteStreamControllerEnqueue(this, chunk);
  };
  ReadableByteStreamController.prototype.error = function (e) {
   if (IsReadableByteStreamController(this) === false) {
    throw byteStreamControllerBrandCheckException('error');
   }
   ReadableByteStreamControllerError(this, e);
  };
  ReadableByteStreamController.prototype[CancelSteps] = function (reason) {
   if (this._pendingPullIntos.length > 0) {
    var firstDescriptor = this._pendingPullIntos.peek();
    firstDescriptor.bytesFilled = 0;
   }
   ResetQueue(this);
   var result = this._cancelAlgorithm(reason);
   ReadableByteStreamControllerClearAlgorithms(this);
   return result;
  };
  ReadableByteStreamController.prototype[PullSteps] = function () {
   var stream = this._controlledReadableByteStream;
   if (this._queueTotalSize > 0) {
    var entry = this._queue.shift();
    this._queueTotalSize -= entry.byteLength;
    ReadableByteStreamControllerHandleQueueDrain(this);
    var view = void 0;
    try {
     view = new Uint8Array(entry.buffer, entry.byteOffset, entry.byteLength);
    } catch (viewE) {
     return promiseRejectedWith(viewE);
    }
    return promiseResolvedWith(ReadableStreamCreateReadResult(view, false, stream._reader._forAuthorCode));
   }
   var autoAllocateChunkSize = this._autoAllocateChunkSize;
   if (autoAllocateChunkSize !== undefined) {
    var buffer = void 0;
    try {
     buffer = new ArrayBuffer(autoAllocateChunkSize);
    } catch (bufferE) {
     return promiseRejectedWith(bufferE);
    }
    var pullIntoDescriptor = {
     buffer: buffer,
     byteOffset: 0,
     byteLength: autoAllocateChunkSize,
     bytesFilled: 0,
     elementSize: 1,
     ctor: Uint8Array,
     readerType: 'default'
    };
    this._pendingPullIntos.push(pullIntoDescriptor);
   }
   var promise = ReadableStreamAddReadRequest(stream);
   ReadableByteStreamControllerCallPullIfNeeded(this);
   return promise;
  };
  return ReadableByteStreamController;
 }();
 function IsReadableByteStreamController(x) {
  if (!typeIsObject(x)) {
   return false;
  }
  if (!Object.prototype.hasOwnProperty.call(x, '_controlledReadableByteStream')) {
   return false;
  }
  return true;
 }
 function IsReadableStreamBYOBRequest(x) {
  if (!typeIsObject(x)) {
   return false;
  }
  if (!Object.prototype.hasOwnProperty.call(x, '_associatedReadableByteStreamController')) {
   return false;
  }
  return true;
 }
 function ReadableByteStreamControllerCallPullIfNeeded(controller) {
  var shouldPull = ReadableByteStreamControllerShouldCallPull(controller);
  if (shouldPull === false) {
   return;
  }
  if (controller._pulling === true) {
   controller._pullAgain = true;
   return;
  }
  controller._pulling = true;
  var pullPromise = controller._pullAlgorithm();
  uponPromise(pullPromise, function () {
   controller._pulling = false;
   if (controller._pullAgain === true) {
    controller._pullAgain = false;
    ReadableByteStreamControllerCallPullIfNeeded(controller);
   }
  }, function (e) {
   ReadableByteStreamControllerError(controller, e);
  });
 }
 function ReadableByteStreamControllerClearPendingPullIntos(controller) {
  ReadableByteStreamControllerInvalidateBYOBRequest(controller);
  controller._pendingPullIntos = new SimpleQueue();
 }
 function ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor) {
  var done = false;
  if (stream._state === 'closed') {
   done = true;
  }
  var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
  if (pullIntoDescriptor.readerType === 'default') {
   ReadableStreamFulfillReadRequest(stream, filledView, done);
  } else {
   ReadableStreamFulfillReadIntoRequest(stream, filledView, done);
  }
 }
 function ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor) {
  var bytesFilled = pullIntoDescriptor.bytesFilled;
  var elementSize = pullIntoDescriptor.elementSize;
  return new pullIntoDescriptor.ctor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, bytesFilled / elementSize);
 }
 function ReadableByteStreamControllerEnqueueChunkToQueue(controller, buffer, byteOffset, byteLength) {
  controller._queue.push({
   buffer: buffer,
   byteOffset: byteOffset,
   byteLength: byteLength
  });
  controller._queueTotalSize += byteLength;
 }
 function ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) {
  var elementSize = pullIntoDescriptor.elementSize;
  var currentAlignedBytes = pullIntoDescriptor.bytesFilled - pullIntoDescriptor.bytesFilled % elementSize;
  var maxBytesToCopy = Math.min(controller._queueTotalSize, pullIntoDescriptor.byteLength - pullIntoDescriptor.bytesFilled);
  var maxBytesFilled = pullIntoDescriptor.bytesFilled + maxBytesToCopy;
  var maxAlignedBytes = maxBytesFilled - maxBytesFilled % elementSize;
  var totalBytesToCopyRemaining = maxBytesToCopy;
  var ready = false;
  if (maxAlignedBytes > currentAlignedBytes) {
   totalBytesToCopyRemaining = maxAlignedBytes - pullIntoDescriptor.bytesFilled;
   ready = true;
  }
  var queue = controller._queue;
  while (totalBytesToCopyRemaining > 0) {
   var headOfQueue = queue.peek();
   var bytesToCopy = Math.min(totalBytesToCopyRemaining, headOfQueue.byteLength);
   var destStart = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
   ArrayBufferCopy(pullIntoDescriptor.buffer, destStart, headOfQueue.buffer, headOfQueue.byteOffset, bytesToCopy);
   if (headOfQueue.byteLength === bytesToCopy) {
    queue.shift();
   } else {
    headOfQueue.byteOffset += bytesToCopy;
    headOfQueue.byteLength -= bytesToCopy;
   }
   controller._queueTotalSize -= bytesToCopy;
   ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesToCopy, pullIntoDescriptor);
   totalBytesToCopyRemaining -= bytesToCopy;
  }
  return ready;
 }
 function ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, size, pullIntoDescriptor) {
  ReadableByteStreamControllerInvalidateBYOBRequest(controller);
  pullIntoDescriptor.bytesFilled += size;
 }
 function ReadableByteStreamControllerHandleQueueDrain(controller) {
  if (controller._queueTotalSize === 0 && controller._closeRequested === true) {
   ReadableByteStreamControllerClearAlgorithms(controller);
   ReadableStreamClose(controller._controlledReadableByteStream);
  } else {
   ReadableByteStreamControllerCallPullIfNeeded(controller);
  }
 }
 function ReadableByteStreamControllerInvalidateBYOBRequest(controller) {
  if (controller._byobRequest === undefined) {
   return;
  }
  controller._byobRequest._associatedReadableByteStreamController = undefined;
  controller._byobRequest._view = undefined;
  controller._byobRequest = undefined;
 }
 function ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller) {
  while (controller._pendingPullIntos.length > 0) {
   if (controller._queueTotalSize === 0) {
    return;
   }
   var pullIntoDescriptor = controller._pendingPullIntos.peek();
   if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
    ReadableByteStreamControllerShiftPendingPullInto(controller);
    ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableByteStream, pullIntoDescriptor);
   }
  }
 }
 function ReadableByteStreamControllerPullInto(controller, view) {
  var stream = controller._controlledReadableByteStream;
  var elementSize = 1;
  if (view.constructor !== DataView) {
   elementSize = view.constructor.BYTES_PER_ELEMENT;
  }
  var ctor = view.constructor;
  var buffer = TransferArrayBuffer(view.buffer);
  var pullIntoDescriptor = {
   buffer: buffer,
   byteOffset: view.byteOffset,
   byteLength: view.byteLength,
   bytesFilled: 0,
   elementSize: elementSize,
   ctor: ctor,
   readerType: 'byob'
  };
  if (controller._pendingPullIntos.length > 0) {
   controller._pendingPullIntos.push(pullIntoDescriptor);
   return ReadableStreamAddReadIntoRequest(stream);
  }
  if (stream._state === 'closed') {
   var emptyView = new ctor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, 0);
   return promiseResolvedWith(ReadableStreamCreateReadResult(emptyView, true, stream._reader._forAuthorCode));
  }
  if (controller._queueTotalSize > 0) {
   if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
    var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
    ReadableByteStreamControllerHandleQueueDrain(controller);
    return promiseResolvedWith(ReadableStreamCreateReadResult(filledView, false, stream._reader._forAuthorCode));
   }
   if (controller._closeRequested === true) {
    var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
    ReadableByteStreamControllerError(controller, e);
    return promiseRejectedWith(e);
   }
  }
  controller._pendingPullIntos.push(pullIntoDescriptor);
  var promise = ReadableStreamAddReadIntoRequest(stream);
  ReadableByteStreamControllerCallPullIfNeeded(controller);
  return promise;
 }
 function ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor) {
  firstDescriptor.buffer = TransferArrayBuffer(firstDescriptor.buffer);
  var stream = controller._controlledReadableByteStream;
  if (ReadableStreamHasBYOBReader(stream) === true) {
   while (ReadableStreamGetNumReadIntoRequests(stream) > 0) {
    var pullIntoDescriptor = ReadableByteStreamControllerShiftPendingPullInto(controller);
    ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor);
   }
  }
 }
 function ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, pullIntoDescriptor) {
  if (pullIntoDescriptor.bytesFilled + bytesWritten > pullIntoDescriptor.byteLength) {
   throw new RangeError('bytesWritten out of range');
  }
  ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesWritten, pullIntoDescriptor);
  if (pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize) {
   return;
  }
  ReadableByteStreamControllerShiftPendingPullInto(controller);
  var remainderSize = pullIntoDescriptor.bytesFilled % pullIntoDescriptor.elementSize;
  if (remainderSize > 0) {
   var end = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
   var remainder = pullIntoDescriptor.buffer.slice(end - remainderSize, end);
   ReadableByteStreamControllerEnqueueChunkToQueue(controller, remainder, 0, remainder.byteLength);
  }
  pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
  pullIntoDescriptor.bytesFilled -= remainderSize;
  ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableByteStream, pullIntoDescriptor);
  ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
 }
 function ReadableByteStreamControllerRespondInternal(controller, bytesWritten) {
  var firstDescriptor = controller._pendingPullIntos.peek();
  var stream = controller._controlledReadableByteStream;
  if (stream._state === 'closed') {
   if (bytesWritten !== 0) {
    throw new TypeError('bytesWritten must be 0 when calling respond() on a closed stream');
   }
   ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor);
  } else {
   ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, firstDescriptor);
  }
  ReadableByteStreamControllerCallPullIfNeeded(controller);
 }
 function ReadableByteStreamControllerShiftPendingPullInto(controller) {
  var descriptor = controller._pendingPullIntos.shift();
  ReadableByteStreamControllerInvalidateBYOBRequest(controller);
  return descriptor;
 }
 function ReadableByteStreamControllerShouldCallPull(controller) {
  var stream = controller._controlledReadableByteStream;
  if (stream._state !== 'readable') {
   return false;
  }
  if (controller._closeRequested === true) {
   return false;
  }
  if (controller._started === false) {
   return false;
  }
  if (ReadableStreamHasDefaultReader(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
   return true;
  }
  if (ReadableStreamHasBYOBReader(stream) === true && ReadableStreamGetNumReadIntoRequests(stream) > 0) {
   return true;
  }
  var desiredSize = ReadableByteStreamControllerGetDesiredSize(controller);
  if (desiredSize > 0) {
   return true;
  }
  return false;
 }
 function ReadableByteStreamControllerClearAlgorithms(controller) {
  controller._pullAlgorithm = undefined;
  controller._cancelAlgorithm = undefined;
 }
 function ReadableByteStreamControllerClose(controller) {
  var stream = controller._controlledReadableByteStream;
  if (controller._queueTotalSize > 0) {
   controller._closeRequested = true;
   return;
  }
  if (controller._pendingPullIntos.length > 0) {
   var firstPendingPullInto = controller._pendingPullIntos.peek();
   if (firstPendingPullInto.bytesFilled > 0) {
    var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
    ReadableByteStreamControllerError(controller, e);
    throw e;
   }
  }
  ReadableByteStreamControllerClearAlgorithms(controller);
  ReadableStreamClose(stream);
 }
 function ReadableByteStreamControllerEnqueue(controller, chunk) {
  var stream = controller._controlledReadableByteStream;
  var buffer = chunk.buffer;
  var byteOffset = chunk.byteOffset;
  var byteLength = chunk.byteLength;
  var transferredBuffer = TransferArrayBuffer(buffer);
  if (ReadableStreamHasDefaultReader(stream) === true) {
   if (ReadableStreamGetNumReadRequests(stream) === 0) {
    ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
   } else {
    var transferredView = new Uint8Array(transferredBuffer, byteOffset, byteLength);
    ReadableStreamFulfillReadRequest(stream, transferredView, false);
   }
  } else if (ReadableStreamHasBYOBReader(stream) === true) {
   ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
   ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
  } else {
   ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
  }
  ReadableByteStreamControllerCallPullIfNeeded(controller);
 }
 function ReadableByteStreamControllerError(controller, e) {
  var stream = controller._controlledReadableByteStream;
  if (stream._state !== 'readable') {
   return;
  }
  ReadableByteStreamControllerClearPendingPullIntos(controller);
  ResetQueue(controller);
  ReadableByteStreamControllerClearAlgorithms(controller);
  ReadableStreamError(stream, e);
 }
 function ReadableByteStreamControllerGetDesiredSize(controller) {
  var stream = controller._controlledReadableByteStream;
  var state = stream._state;
  if (state === 'errored') {
   return null;
  }
  if (state === 'closed') {
   return 0;
  }
  return controller._strategyHWM - controller._queueTotalSize;
 }
 function ReadableByteStreamControllerRespond(controller, bytesWritten) {
  bytesWritten = Number(bytesWritten);
  if (IsFiniteNonNegativeNumber(bytesWritten) === false) {
   throw new RangeError('bytesWritten must be a finite');
  }
  ReadableByteStreamControllerRespondInternal(controller, bytesWritten);
 }
 function ReadableByteStreamControllerRespondWithNewView(controller, view) {
  var firstDescriptor = controller._pendingPullIntos.peek();
  if (firstDescriptor.byteOffset + firstDescriptor.bytesFilled !== view.byteOffset) {
   throw new RangeError('The region specified by view does not match byobRequest');
  }
  if (firstDescriptor.byteLength !== view.byteLength) {
   throw new RangeError('The buffer of view has different capacity than byobRequest');
  }
  firstDescriptor.buffer = view.buffer;
  ReadableByteStreamControllerRespondInternal(controller, view.byteLength);
 }
 function SetUpReadableByteStreamController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, autoAllocateChunkSize) {
  controller._controlledReadableByteStream = stream;
  controller._pullAgain = false;
  controller._pulling = false;
  controller._byobRequest = undefined;
  controller._queue = controller._queueTotalSize = undefined;
  ResetQueue(controller);
  controller._closeRequested = false;
  controller._started = false;
  controller._strategyHWM = ValidateAndNormalizeHighWaterMark(highWaterMark);
  controller._pullAlgorithm = pullAlgorithm;
  controller._cancelAlgorithm = cancelAlgorithm;
  controller._autoAllocateChunkSize = autoAllocateChunkSize;
  controller._pendingPullIntos = new SimpleQueue();
  stream._readableStreamController = controller;
  var startResult = startAlgorithm();
  uponPromise(promiseResolvedWith(startResult), function () {
   controller._started = true;
   ReadableByteStreamControllerCallPullIfNeeded(controller);
  }, function (r) {
   ReadableByteStreamControllerError(controller, r);
  });
 }
 function SetUpReadableByteStreamControllerFromUnderlyingSource(stream, underlyingByteSource, highWaterMark) {
  var controller = Object.create(ReadableByteStreamController.prototype);
  function startAlgorithm() {
   return InvokeOrNoop(underlyingByteSource, 'start', [controller]);
  }
  var pullAlgorithm = CreateAlgorithmFromUnderlyingMethod(underlyingByteSource, 'pull', 0, [controller]);
  var cancelAlgorithm = CreateAlgorithmFromUnderlyingMethod(underlyingByteSource, 'cancel', 1, []);
  var autoAllocateChunkSize = underlyingByteSource.autoAllocateChunkSize;
  if (autoAllocateChunkSize !== undefined) {
   autoAllocateChunkSize = Number(autoAllocateChunkSize);
   if (NumberIsInteger(autoAllocateChunkSize) === false || autoAllocateChunkSize <= 0) {
    throw new RangeError('autoAllocateChunkSize must be a positive integer');
   }
  }
  SetUpReadableByteStreamController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, autoAllocateChunkSize);
 }
 function SetUpReadableStreamBYOBRequest(request, controller, view) {
  request._associatedReadableByteStreamController = controller;
  request._view = view;
 }
 function byobRequestBrandCheckException(name) {
  return new TypeError("ReadableStreamBYOBRequest.prototype." + name + " can only be used on a ReadableStreamBYOBRequest");
 }
 function byteStreamControllerBrandCheckException(name) {
  return new TypeError("ReadableByteStreamController.prototype." + name + " can only be used on a ReadableByteStreamController");
 }
 function AcquireReadableStreamBYOBReader(stream, forAuthorCode) {
  if (forAuthorCode === void 0) {
   forAuthorCode = false;
  }
  var reader = new ReadableStreamBYOBReader(stream);
  reader._forAuthorCode = forAuthorCode;
  return reader;
 }
 function ReadableStreamAddReadIntoRequest(stream) {
  var promise = newPromise(function (resolve, reject) {
   var readIntoRequest = {
    _resolve: resolve,
    _reject: reject
   };
   stream._reader._readIntoRequests.push(readIntoRequest);
  });
  return promise;
 }
 function ReadableStreamFulfillReadIntoRequest(stream, chunk, done) {
  var reader = stream._reader;
  var readIntoRequest = reader._readIntoRequests.shift();
  readIntoRequest._resolve(ReadableStreamCreateReadResult(chunk, done, reader._forAuthorCode));
 }
 function ReadableStreamGetNumReadIntoRequests(stream) {
  return stream._reader._readIntoRequests.length;
 }
 function ReadableStreamHasBYOBReader(stream) {
  var reader = stream._reader;
  if (reader === undefined) {
   return false;
  }
  if (!IsReadableStreamBYOBReader(reader)) {
   return false;
  }
  return true;
 }
 var ReadableStreamBYOBReader = function () {
  function ReadableStreamBYOBReader(stream) {
   if (!IsReadableStream(stream)) {
    throw new TypeError('ReadableStreamBYOBReader can only be constructed with a ReadableStream instance given a ' + 'byte source');
   }
   if (IsReadableByteStreamController(stream._readableStreamController) === false) {
    throw new TypeError('Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte ' + 'source');
   }
   if (IsReadableStreamLocked(stream)) {
    throw new TypeError('This stream has already been locked for exclusive reading by another reader');
   }
   ReadableStreamReaderGenericInitialize(this, stream);
   this._readIntoRequests = new SimpleQueue();
  }
  Object.defineProperty(ReadableStreamBYOBReader.prototype, "closed", {
   get: function () {
    if (!IsReadableStreamBYOBReader(this)) {
     return promiseRejectedWith(byobReaderBrandCheckException('closed'));
    }
    return this._closedPromise;
   },
   enumerable: true,
   configurable: true
  });
  ReadableStreamBYOBReader.prototype.cancel = function (reason) {
   if (!IsReadableStreamBYOBReader(this)) {
    return promiseRejectedWith(byobReaderBrandCheckException('cancel'));
   }
   if (this._ownerReadableStream === undefined) {
    return promiseRejectedWith(readerLockException('cancel'));
   }
   return ReadableStreamReaderGenericCancel(this, reason);
  };
  ReadableStreamBYOBReader.prototype.read = function (view) {
   if (!IsReadableStreamBYOBReader(this)) {
    return promiseRejectedWith(byobReaderBrandCheckException('read'));
   }
   if (this._ownerReadableStream === undefined) {
    return promiseRejectedWith(readerLockException('read from'));
   }
   if (!ArrayBuffer.isView(view)) {
    return promiseRejectedWith(new TypeError('view must be an array buffer view'));
   }
   if (IsDetachedBuffer(view.buffer) === true);
   if (view.byteLength === 0) {
    return promiseRejectedWith(new TypeError('view must have non-zero byteLength'));
   }
   return ReadableStreamBYOBReaderRead(this, view);
  };
  ReadableStreamBYOBReader.prototype.releaseLock = function () {
   if (!IsReadableStreamBYOBReader(this)) {
    throw byobReaderBrandCheckException('releaseLock');
   }
   if (this._ownerReadableStream === undefined) {
    return;
   }
   if (this._readIntoRequests.length > 0) {
    throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
   }
   ReadableStreamReaderGenericRelease(this);
  };
  return ReadableStreamBYOBReader;
 }();
 function IsReadableStreamBYOBReader(x) {
  if (!typeIsObject(x)) {
   return false;
  }
  if (!Object.prototype.hasOwnProperty.call(x, '_readIntoRequests')) {
   return false;
  }
  return true;
 }
 function ReadableStreamBYOBReaderRead(reader, view) {
  var stream = reader._ownerReadableStream;
  stream._disturbed = true;
  if (stream._state === 'errored') {
   return promiseRejectedWith(stream._storedError);
  }
  return ReadableByteStreamControllerPullInto(stream._readableStreamController, view);
 }
 function byobReaderBrandCheckException(name) {
  return new TypeError("ReadableStreamBYOBReader.prototype." + name + " can only be used on a ReadableStreamBYOBReader");
 }
 var ReadableStream = function () {
  function ReadableStream(underlyingSource, strategy) {
   if (underlyingSource === void 0) {
    underlyingSource = {};
   }
   if (strategy === void 0) {
    strategy = {};
   }
   InitializeReadableStream(this);
   var size = strategy.size;
   var highWaterMark = strategy.highWaterMark;
   var type = underlyingSource.type;
   var typeString = String(type);
   if (typeString === 'bytes') {
    if (size !== undefined) {
     throw new RangeError('The strategy for a byte stream cannot have a size function');
    }
    if (highWaterMark === undefined) {
     highWaterMark = 0;
    }
    highWaterMark = ValidateAndNormalizeHighWaterMark(highWaterMark);
    SetUpReadableByteStreamControllerFromUnderlyingSource(this, underlyingSource, highWaterMark);
   } else if (type === undefined) {
    var sizeAlgorithm = MakeSizeAlgorithmFromSizeFunction(size);
    if (highWaterMark === undefined) {
     highWaterMark = 1;
    }
    highWaterMark = ValidateAndNormalizeHighWaterMark(highWaterMark);
    SetUpReadableStreamDefaultControllerFromUnderlyingSource(this, underlyingSource, highWaterMark, sizeAlgorithm);
   } else {
    throw new RangeError('Invalid type is specified');
   }
  }
  Object.defineProperty(ReadableStream.prototype, "locked", {
   get: function () {
    if (IsReadableStream(this) === false) {
     throw streamBrandCheckException$1('locked');
    }
    return IsReadableStreamLocked(this);
   },
   enumerable: true,
   configurable: true
  });
  ReadableStream.prototype.cancel = function (reason) {
   if (IsReadableStream(this) === false) {
    return promiseRejectedWith(streamBrandCheckException$1('cancel'));
   }
   if (IsReadableStreamLocked(this) === true) {
    return promiseRejectedWith(new TypeError('Cannot cancel a stream that already has a reader'));
   }
   return ReadableStreamCancel(this, reason);
  };
  ReadableStream.prototype.getReader = function (_a) {
   var mode = (_a === void 0 ? {} : _a).mode;
   if (IsReadableStream(this) === false) {
    throw streamBrandCheckException$1('getReader');
   }
   if (mode === undefined) {
    return AcquireReadableStreamDefaultReader(this, true);
   }
   mode = String(mode);
   if (mode === 'byob') {
    return AcquireReadableStreamBYOBReader(this, true);
   }
   throw new RangeError('Invalid mode is specified');
  };
  ReadableStream.prototype.pipeThrough = function (_a, _b) {
   var writable = _a.writable, readable = _a.readable;
   var _c = _b === void 0 ? {} : _b, preventClose = _c.preventClose, preventAbort = _c.preventAbort, preventCancel = _c.preventCancel, signal = _c.signal;
   if (IsReadableStream(this) === false) {
    throw streamBrandCheckException$1('pipeThrough');
   }
   if (IsWritableStream(writable) === false) {
    throw new TypeError('writable argument to pipeThrough must be a WritableStream');
   }
   if (IsReadableStream(readable) === false) {
    throw new TypeError('readable argument to pipeThrough must be a ReadableStream');
   }
   preventClose = Boolean(preventClose);
   preventAbort = Boolean(preventAbort);
   preventCancel = Boolean(preventCancel);
   if (signal !== undefined && !isAbortSignal(signal)) {
    throw new TypeError('ReadableStream.prototype.pipeThrough\'s signal option must be an AbortSignal');
   }
   if (IsReadableStreamLocked(this) === true) {
    throw new TypeError('ReadableStream.prototype.pipeThrough cannot be used on a locked ReadableStream');
   }
   if (IsWritableStreamLocked(writable) === true) {
    throw new TypeError('ReadableStream.prototype.pipeThrough cannot be used on a locked WritableStream');
   }
   var promise = ReadableStreamPipeTo(this, writable, preventClose, preventAbort, preventCancel, signal);
   setPromiseIsHandledToTrue(promise);
   return readable;
  };
  ReadableStream.prototype.pipeTo = function (dest, _a) {
   var _b = _a === void 0 ? {} : _a, preventClose = _b.preventClose, preventAbort = _b.preventAbort, preventCancel = _b.preventCancel, signal = _b.signal;
   if (IsReadableStream(this) === false) {
    return promiseRejectedWith(streamBrandCheckException$1('pipeTo'));
   }
   if (IsWritableStream(dest) === false) {
    return promiseRejectedWith(new TypeError('ReadableStream.prototype.pipeTo\'s first argument must be a WritableStream'));
   }
   preventClose = Boolean(preventClose);
   preventAbort = Boolean(preventAbort);
   preventCancel = Boolean(preventCancel);
   if (signal !== undefined && !isAbortSignal(signal)) {
    return promiseRejectedWith(new TypeError('ReadableStream.prototype.pipeTo\'s signal option must be an AbortSignal'));
   }
   if (IsReadableStreamLocked(this) === true) {
    return promiseRejectedWith(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream'));
   }
   if (IsWritableStreamLocked(dest) === true) {
    return promiseRejectedWith(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream'));
   }
   return ReadableStreamPipeTo(this, dest, preventClose, preventAbort, preventCancel, signal);
  };
  ReadableStream.prototype.tee = function () {
   if (IsReadableStream(this) === false) {
    throw streamBrandCheckException$1('tee');
   }
   var branches = ReadableStreamTee(this);
   return createArrayFromList(branches);
  };
  ReadableStream.prototype.getIterator = function (_a) {
   var _b = (_a === void 0 ? {} : _a).preventCancel, preventCancel = _b === void 0 ? false : _b;
   if (IsReadableStream(this) === false) {
    throw streamBrandCheckException$1('getIterator');
   }
   return AcquireReadableStreamAsyncIterator(this, preventCancel);
  };
  return ReadableStream;
 }();
 if (typeof SymbolPolyfill.asyncIterator === 'symbol') {
  Object.defineProperty(ReadableStream.prototype, SymbolPolyfill.asyncIterator, {
   value: ReadableStream.prototype.getIterator,
   enumerable: false,
   writable: true,
   configurable: true
  });
 }
 function CreateReadableStream(startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, sizeAlgorithm) {
  if (highWaterMark === void 0) {
   highWaterMark = 1;
  }
  if (sizeAlgorithm === void 0) {
   sizeAlgorithm = function () {
    return 1;
   };
  }
  var stream = Object.create(ReadableStream.prototype);
  InitializeReadableStream(stream);
  var controller = Object.create(ReadableStreamDefaultController.prototype);
  SetUpReadableStreamDefaultController(stream, controller, startAlgorithm, pullAlgorithm, cancelAlgorithm, highWaterMark, sizeAlgorithm);
  return stream;
 }
 function InitializeReadableStream(stream) {
  stream._state = 'readable';
  stream._reader = undefined;
  stream._storedError = undefined;
  stream._disturbed = false;
 }
 function IsReadableStream(x) {
  if (!typeIsObject(x)) {
   return false;
  }
  if (!Object.prototype.hasOwnProperty.call(x, '_readableStreamController')) {
   return false;
  }
  return true;
 }
 function IsReadableStreamLocked(stream) {
  if (stream._reader === undefined) {
   return false;
  }
  return true;
 }
 function ReadableStreamCancel(stream, reason) {
  stream._disturbed = true;
  if (stream._state === 'closed') {
   return promiseResolvedWith(undefined);
  }
  if (stream._state === 'errored') {
   return promiseRejectedWith(stream._storedError);
  }
  ReadableStreamClose(stream);
  var sourceCancelPromise = stream._readableStreamController[CancelSteps](reason);
  return transformPromiseWith(sourceCancelPromise, noop);
 }
 function ReadableStreamClose(stream) {
  stream._state = 'closed';
  var reader = stream._reader;
  if (reader === undefined) {
   return;
  }
  if (IsReadableStreamDefaultReader(reader)) {
   reader._readRequests.forEach(function (readRequest) {
    readRequest._resolve(ReadableStreamCreateReadResult(undefined, true, reader._forAuthorCode));
   });
   reader._readRequests = new SimpleQueue();
  }
  defaultReaderClosedPromiseResolve(reader);
 }
 function ReadableStreamError(stream, e) {
  stream._state = 'errored';
  stream._storedError = e;
  var reader = stream._reader;
  if (reader === undefined) {
   return;
  }
  if (IsReadableStreamDefaultReader(reader)) {
   reader._readRequests.forEach(function (readRequest) {
    readRequest._reject(e);
   });
   reader._readRequests = new SimpleQueue();
  } else {
   reader._readIntoRequests.forEach(function (readIntoRequest) {
    readIntoRequest._reject(e);
   });
   reader._readIntoRequests = new SimpleQueue();
  }
  defaultReaderClosedPromiseReject(reader, e);
 }
 function streamBrandCheckException$1(name) {
  return new TypeError("ReadableStream.prototype." + name + " can only be used on a ReadableStream");
 }
 var ByteLengthQueuingStrategy = function () {
  function ByteLengthQueuingStrategy(_a) {
   var highWaterMark = _a.highWaterMark;
   this.highWaterMark = highWaterMark;
  }
  ByteLengthQueuingStrategy.prototype.size = function (chunk) {
   return chunk.byteLength;
  };
  return ByteLengthQueuingStrategy;
 }();
 var CountQueuingStrategy = function () {
  function CountQueuingStrategy(_a) {
   var highWaterMark = _a.highWaterMark;
   this.highWaterMark = highWaterMark;
  }
  CountQueuingStrategy.prototype.size = function () {
   return 1;
  };
  return CountQueuingStrategy;
 }();
 var TransformStream = function () {
  function TransformStream(transformer, writableStrategy, readableStrategy) {
   if (transformer === void 0) {
    transformer = {};
   }
   if (writableStrategy === void 0) {
    writableStrategy = {};
   }
   if (readableStrategy === void 0) {
    readableStrategy = {};
   }
   var writableSizeFunction = writableStrategy.size;
   var writableHighWaterMark = writableStrategy.highWaterMark;
   var readableSizeFunction = readableStrategy.size;
   var readableHighWaterMark = readableStrategy.highWaterMark;
   var writableType = transformer.writableType;
   if (writableType !== undefined) {
    throw new RangeError('Invalid writable type specified');
   }
   var writableSizeAlgorithm = MakeSizeAlgorithmFromSizeFunction(writableSizeFunction);
   if (writableHighWaterMark === undefined) {
    writableHighWaterMark = 1;
   }
   writableHighWaterMark = ValidateAndNormalizeHighWaterMark(writableHighWaterMark);
   var readableType = transformer.readableType;
   if (readableType !== undefined) {
    throw new RangeError('Invalid readable type specified');
   }
   var readableSizeAlgorithm = MakeSizeAlgorithmFromSizeFunction(readableSizeFunction);
   if (readableHighWaterMark === undefined) {
    readableHighWaterMark = 0;
   }
   readableHighWaterMark = ValidateAndNormalizeHighWaterMark(readableHighWaterMark);
   var startPromise_resolve;
   var startPromise = newPromise(function (resolve) {
    startPromise_resolve = resolve;
   });
   InitializeTransformStream(this, startPromise, writableHighWaterMark, writableSizeAlgorithm, readableHighWaterMark, readableSizeAlgorithm);
   SetUpTransformStreamDefaultControllerFromTransformer(this, transformer);
   var startResult = InvokeOrNoop(transformer, 'start', [this._transformStreamController]);
   startPromise_resolve(startResult);
  }
  Object.defineProperty(TransformStream.prototype, "readable", {
   get: function () {
    if (IsTransformStream(this) === false) {
     throw streamBrandCheckException$2('readable');
    }
    return this._readable;
   },
   enumerable: true,
   configurable: true
  });
  Object.defineProperty(TransformStream.prototype, "writable", {
   get: function () {
    if (IsTransformStream(this) === false) {
     throw streamBrandCheckException$2('writable');
    }
    return this._writable;
   },
   enumerable: true,
   configurable: true
  });
  return TransformStream;
 }();
 function InitializeTransformStream(stream, startPromise, writableHighWaterMark, writableSizeAlgorithm, readableHighWaterMark, readableSizeAlgorithm) {
  function startAlgorithm() {
   return startPromise;
  }
  function writeAlgorithm(chunk) {
   return TransformStreamDefaultSinkWriteAlgorithm(stream, chunk);
  }
  function abortAlgorithm(reason) {
   return TransformStreamDefaultSinkAbortAlgorithm(stream, reason);
  }
  function closeAlgorithm() {
   return TransformStreamDefaultSinkCloseAlgorithm(stream);
  }
  stream._writable = CreateWritableStream(startAlgorithm, writeAlgorithm, closeAlgorithm, abortAlgorithm, writableHighWaterMark, writableSizeAlgorithm);
  function pullAlgorithm() {
   return TransformStreamDefaultSourcePullAlgorithm(stream);
  }
  function cancelAlgorithm(reason) {
   TransformStreamErrorWritableAndUnblockWrite(stream, reason);
   return promiseResolvedWith(undefined);
  }
  stream._readable = CreateReadableStream(startAlgorithm, pullAlgorithm, cancelAlgorithm, readableHighWaterMark, readableSizeAlgorithm);
  stream._backpressure = undefined;
  stream._backpressureChangePromise = undefined;
  stream._backpressureChangePromise_resolve = undefined;
  TransformStreamSetBackpressure(stream, true);
  stream._transformStreamController = undefined;
 }
 function IsTransformStream(x) {
  if (!typeIsObject(x)) {
   return false;
  }
  if (!Object.prototype.hasOwnProperty.call(x, '_transformStreamController')) {
   return false;
  }
  return true;
 }
 function TransformStreamError(stream, e) {
  ReadableStreamDefaultControllerError(stream._readable._readableStreamController, e);
  TransformStreamErrorWritableAndUnblockWrite(stream, e);
 }
 function TransformStreamErrorWritableAndUnblockWrite(stream, e) {
  TransformStreamDefaultControllerClearAlgorithms(stream._transformStreamController);
  WritableStreamDefaultControllerErrorIfNeeded(stream._writable._writableStreamController, e);
  if (stream._backpressure === true) {
   TransformStreamSetBackpressure(stream, false);
  }
 }
 function TransformStreamSetBackpressure(stream, backpressure) {
  if (stream._backpressureChangePromise !== undefined) {
   stream._backpressureChangePromise_resolve();
  }
  stream._backpressureChangePromise = newPromise(function (resolve) {
   stream._backpressureChangePromise_resolve = resolve;
  });
  stream._backpressure = backpressure;
 }
 var TransformStreamDefaultController = function () {
  function TransformStreamDefaultController() {
   throw new TypeError('TransformStreamDefaultController instances cannot be created directly');
  }
  Object.defineProperty(TransformStreamDefaultController.prototype, "desiredSize", {
   get: function () {
    if (IsTransformStreamDefaultController(this) === false) {
     throw defaultControllerBrandCheckException$1('desiredSize');
    }
    var readableController = this._controlledTransformStream._readable._readableStreamController;
    return ReadableStreamDefaultControllerGetDesiredSize(readableController);
   },
   enumerable: true,
   configurable: true
  });
  TransformStreamDefaultController.prototype.enqueue = function (chunk) {
   if (IsTransformStreamDefaultController(this) === false) {
    throw defaultControllerBrandCheckException$1('enqueue');
   }
   TransformStreamDefaultControllerEnqueue(this, chunk);
  };
  TransformStreamDefaultController.prototype.error = function (reason) {
   if (IsTransformStreamDefaultController(this) === false) {
    throw defaultControllerBrandCheckException$1('error');
   }
   TransformStreamDefaultControllerError(this, reason);
  };
  TransformStreamDefaultController.prototype.terminate = function () {
   if (IsTransformStreamDefaultController(this) === false) {
    throw defaultControllerBrandCheckException$1('terminate');
   }
   TransformStreamDefaultControllerTerminate(this);
  };
  return TransformStreamDefaultController;
 }();
 function IsTransformStreamDefaultController(x) {
  if (!typeIsObject(x)) {
   return false;
  }
  if (!Object.prototype.hasOwnProperty.call(x, '_controlledTransformStream')) {
   return false;
  }
  return true;
 }
 function SetUpTransformStreamDefaultController(stream, controller, transformAlgorithm, flushAlgorithm) {
  controller._controlledTransformStream = stream;
  stream._transformStreamController = controller;
  controller._transformAlgorithm = transformAlgorithm;
  controller._flushAlgorithm = flushAlgorithm;
 }
 function SetUpTransformStreamDefaultControllerFromTransformer(stream, transformer) {
  var controller = Object.create(TransformStreamDefaultController.prototype);
  var transformAlgorithm = function (chunk) {
   try {
    TransformStreamDefaultControllerEnqueue(controller, chunk);
    return promiseResolvedWith(undefined);
   } catch (transformResultE) {
    return promiseRejectedWith(transformResultE);
   }
  };
  var transformMethod = transformer.transform;
  if (transformMethod !== undefined) {
   if (typeof transformMethod !== 'function') {
    throw new TypeError('transform is not a method');
   }
   transformAlgorithm = function (chunk) {
    return PromiseCall(transformMethod, transformer, [
     chunk,
     controller
    ]);
   };
  }
  var flushAlgorithm = CreateAlgorithmFromUnderlyingMethod(transformer, 'flush', 0, [controller]);
  SetUpTransformStreamDefaultController(stream, controller, transformAlgorithm, flushAlgorithm);
 }
 function TransformStreamDefaultControllerClearAlgorithms(controller) {
  controller._transformAlgorithm = undefined;
  controller._flushAlgorithm = undefined;
 }
 function TransformStreamDefaultControllerEnqueue(controller, chunk) {
  var stream = controller._controlledTransformStream;
  var readableController = stream._readable._readableStreamController;
  if (ReadableStreamDefaultControllerCanCloseOrEnqueue(readableController) === false) {
   throw new TypeError('Readable side is not in a state that permits enqueue');
  }
  try {
   ReadableStreamDefaultControllerEnqueue(readableController, chunk);
  } catch (e) {
   TransformStreamErrorWritableAndUnblockWrite(stream, e);
   throw stream._readable._storedError;
  }
  var backpressure = ReadableStreamDefaultControllerHasBackpressure(readableController);
  if (backpressure !== stream._backpressure) {
   TransformStreamSetBackpressure(stream, true);
  }
 }
 function TransformStreamDefaultControllerError(controller, e) {
  TransformStreamError(controller._controlledTransformStream, e);
 }
 function TransformStreamDefaultControllerPerformTransform(controller, chunk) {
  var transformPromise = controller._transformAlgorithm(chunk);
  return transformPromiseWith(transformPromise, undefined, function (r) {
   TransformStreamError(controller._controlledTransformStream, r);
   throw r;
  });
 }
 function TransformStreamDefaultControllerTerminate(controller) {
  var stream = controller._controlledTransformStream;
  var readableController = stream._readable._readableStreamController;
  if (ReadableStreamDefaultControllerCanCloseOrEnqueue(readableController) === true) {
   ReadableStreamDefaultControllerClose(readableController);
  }
  var error = new TypeError('TransformStream terminated');
  TransformStreamErrorWritableAndUnblockWrite(stream, error);
 }
 function TransformStreamDefaultSinkWriteAlgorithm(stream, chunk) {
  var controller = stream._transformStreamController;
  if (stream._backpressure === true) {
   var backpressureChangePromise = stream._backpressureChangePromise;
   return transformPromiseWith(backpressureChangePromise, function () {
    var writable = stream._writable;
    var state = writable._state;
    if (state === 'erroring') {
     throw writable._storedError;
    }
    return TransformStreamDefaultControllerPerformTransform(controller, chunk);
   });
  }
  return TransformStreamDefaultControllerPerformTransform(controller, chunk);
 }
 function TransformStreamDefaultSinkAbortAlgorithm(stream, reason) {
  TransformStreamError(stream, reason);
  return promiseResolvedWith(undefined);
 }
 function TransformStreamDefaultSinkCloseAlgorithm(stream) {
  var readable = stream._readable;
  var controller = stream._transformStreamController;
  var flushPromise = controller._flushAlgorithm();
  TransformStreamDefaultControllerClearAlgorithms(controller);
  return transformPromiseWith(flushPromise, function () {
   if (readable._state === 'errored') {
    throw readable._storedError;
   }
   var readableController = readable._readableStreamController;
   if (ReadableStreamDefaultControllerCanCloseOrEnqueue(readableController) === true) {
    ReadableStreamDefaultControllerClose(readableController);
   }
  }, function (r) {
   TransformStreamError(stream, r);
   throw readable._storedError;
  });
 }
 function TransformStreamDefaultSourcePullAlgorithm(stream) {
  TransformStreamSetBackpressure(stream, false);
  return stream._backpressureChangePromise;
 }
 function defaultControllerBrandCheckException$1(name) {
  return new TypeError("TransformStreamDefaultController.prototype." + name + " can only be used on a TransformStreamDefaultController");
 }
 function streamBrandCheckException$2(name) {
  return new TypeError("TransformStream.prototype." + name + " can only be used on a TransformStream");
 }
 exports.ByteLengthQueuingStrategy = ByteLengthQueuingStrategy;
 exports.CountQueuingStrategy = CountQueuingStrategy;
 exports.ReadableStream = ReadableStream;
 exports.TransformStream = TransformStream;
 exports.WritableStream = WritableStream;
 Object.defineProperty(exports, '__esModule', { value: true });
}));

/***/ }),
/* 136 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(137);
__w_pdfjs_require__(105);
__w_pdfjs_require__(73);
__w_pdfjs_require__(107);
var path = __w_pdfjs_require__(38);
module.exports = path.Map;

/***/ }),
/* 137 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var collection = __w_pdfjs_require__(138);
var collectionStrong = __w_pdfjs_require__(142);
module.exports = collection('Map', function (init) {
 return function Map() {
  return init(this, arguments.length ? arguments[0] : undefined);
 };
}, collectionStrong);

/***/ }),
/* 138 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var $ = __w_pdfjs_require__(5);
var global = __w_pdfjs_require__(6);
var isForced = __w_pdfjs_require__(47);
var redefine = __w_pdfjs_require__(24);
var InternalMetadataModule = __w_pdfjs_require__(139);
var iterate = __w_pdfjs_require__(115);
var anInstance = __w_pdfjs_require__(114);
var isObject = __w_pdfjs_require__(17);
var fails = __w_pdfjs_require__(9);
var checkCorrectnessOfIteration = __w_pdfjs_require__(93);
var setToStringTag = __w_pdfjs_require__(81);
var inheritIfRequired = __w_pdfjs_require__(141);
module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
 var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
 var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
 var ADDER = IS_MAP ? 'set' : 'add';
 var NativeConstructor = global[CONSTRUCTOR_NAME];
 var NativePrototype = NativeConstructor && NativeConstructor.prototype;
 var Constructor = NativeConstructor;
 var exported = {};
 var fixMethod = function (KEY) {
  var nativeMethod = NativePrototype[KEY];
  redefine(NativePrototype, KEY, KEY == 'add' ? function add(value) {
   nativeMethod.call(this, value === 0 ? 0 : value);
   return this;
  } : KEY == 'delete' ? function (key) {
   return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
  } : KEY == 'get' ? function get(key) {
   return IS_WEAK && !isObject(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
  } : KEY == 'has' ? function has(key) {
   return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
  } : function set(key, value) {
   nativeMethod.call(this, key === 0 ? 0 : key, value);
   return this;
  });
 };
 if (isForced(CONSTRUCTOR_NAME, typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
   new NativeConstructor().entries().next();
  })))) {
  Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
  InternalMetadataModule.REQUIRED = true;
 } else if (isForced(CONSTRUCTOR_NAME, true)) {
  var instance = new Constructor();
  var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
  var THROWS_ON_PRIMITIVES = fails(function () {
   instance.has(1);
  });
  var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) {
   new NativeConstructor(iterable);
  });
  var BUGGY_ZERO = !IS_WEAK && fails(function () {
   var $instance = new NativeConstructor();
   var index = 5;
   while (index--)
    $instance[ADDER](index, index);
   return !$instance.has(-0);
  });
  if (!ACCEPT_ITERABLES) {
   Constructor = wrapper(function (dummy, iterable) {
    anInstance(dummy, Constructor, CONSTRUCTOR_NAME);
    var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
    if (iterable != undefined)
     iterate(iterable, that[ADDER], that, IS_MAP);
    return that;
   });
   Constructor.prototype = NativePrototype;
   NativePrototype.constructor = Constructor;
  }
  if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
   fixMethod('delete');
   fixMethod('has');
   IS_MAP && fixMethod('get');
  }
  if (BUGGY_ZERO || HASNT_CHAINING)
   fixMethod(ADDER);
  if (IS_WEAK && NativePrototype.clear)
   delete NativePrototype.clear;
 }
 exported[CONSTRUCTOR_NAME] = Constructor;
 $({
  global: true,
  forced: Constructor != NativeConstructor
 }, exported);
 setToStringTag(Constructor, CONSTRUCTOR_NAME);
 if (!IS_WEAK)
  common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
 return Constructor;
};

/***/ }),
/* 139 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var hiddenKeys = __w_pdfjs_require__(34);
var isObject = __w_pdfjs_require__(17);
var has = __w_pdfjs_require__(18);
var defineProperty = __w_pdfjs_require__(22).f;
var uid = __w_pdfjs_require__(33);
var FREEZING = __w_pdfjs_require__(140);
var METADATA = uid('meta');
var id = 0;
var isExtensible = Object.isExtensible || function () {
 return true;
};
var setMetadata = function (it) {
 defineProperty(it, METADATA, {
  value: {
   objectID: 'O' + ++id,
   weakData: {}
  }
 });
};
var fastKey = function (it, create) {
 if (!isObject(it))
  return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
 if (!has(it, METADATA)) {
  if (!isExtensible(it))
   return 'F';
  if (!create)
   return 'E';
  setMetadata(it);
 }
 return it[METADATA].objectID;
};
var getWeakData = function (it, create) {
 if (!has(it, METADATA)) {
  if (!isExtensible(it))
   return true;
  if (!create)
   return false;
  setMetadata(it);
 }
 return it[METADATA].weakData;
};
var onFreeze = function (it) {
 if (FREEZING && meta.REQUIRED && isExtensible(it) && !has(it, METADATA))
  setMetadata(it);
 return it;
};
var meta = module.exports = {
 REQUIRED: false,
 fastKey: fastKey,
 getWeakData: getWeakData,
 onFreeze: onFreeze
};
hiddenKeys[METADATA] = true;

/***/ }),
/* 140 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var fails = __w_pdfjs_require__(9);
module.exports = !fails(function () {
 return Object.isExtensible(Object.preventExtensions({}));
});

/***/ }),
/* 141 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var isObject = __w_pdfjs_require__(17);
var setPrototypeOf = __w_pdfjs_require__(83);
module.exports = function ($this, dummy, Wrapper) {
 var NewTarget, NewTargetPrototype;
 if (setPrototypeOf && typeof (NewTarget = dummy.constructor) == 'function' && NewTarget !== Wrapper && isObject(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype)
  setPrototypeOf($this, NewTargetPrototype);
 return $this;
};

/***/ }),
/* 142 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var defineProperty = __w_pdfjs_require__(22).f;
var create = __w_pdfjs_require__(67);
var redefineAll = __w_pdfjs_require__(112);
var bind = __w_pdfjs_require__(58);
var anInstance = __w_pdfjs_require__(114);
var iterate = __w_pdfjs_require__(115);
var defineIterator = __w_pdfjs_require__(75);
var setSpecies = __w_pdfjs_require__(113);
var DESCRIPTORS = __w_pdfjs_require__(8);
var fastKey = __w_pdfjs_require__(139).fastKey;
var InternalStateModule = __w_pdfjs_require__(28);
var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
module.exports = {
 getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
  var C = wrapper(function (that, iterable) {
   anInstance(that, C, CONSTRUCTOR_NAME);
   setInternalState(that, {
    type: CONSTRUCTOR_NAME,
    index: create(null),
    first: undefined,
    last: undefined,
    size: 0
   });
   if (!DESCRIPTORS)
    that.size = 0;
   if (iterable != undefined)
    iterate(iterable, that[ADDER], that, IS_MAP);
  });
  var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
  var define = function (that, key, value) {
   var state = getInternalState(that);
   var entry = getEntry(that, key);
   var previous, index;
   if (entry) {
    entry.value = value;
   } else {
    state.last = entry = {
     index: index = fastKey(key, true),
     key: key,
     value: value,
     previous: previous = state.last,
     next: undefined,
     removed: false
    };
    if (!state.first)
     state.first = entry;
    if (previous)
     previous.next = entry;
    if (DESCRIPTORS)
     state.size++;
    else
     that.size++;
    if (index !== 'F')
     state.index[index] = entry;
   }
   return that;
  };
  var getEntry = function (that, key) {
   var state = getInternalState(that);
   var index = fastKey(key);
   var entry;
   if (index !== 'F')
    return state.index[index];
   for (entry = state.first; entry; entry = entry.next) {
    if (entry.key == key)
     return entry;
   }
  };
  redefineAll(C.prototype, {
   clear: function clear() {
    var that = this;
    var state = getInternalState(that);
    var data = state.index;
    var entry = state.first;
    while (entry) {
     entry.removed = true;
     if (entry.previous)
      entry.previous = entry.previous.next = undefined;
     delete data[entry.index];
     entry = entry.next;
    }
    state.first = state.last = undefined;
    if (DESCRIPTORS)
     state.size = 0;
    else
     that.size = 0;
   },
   'delete': function (key) {
    var that = this;
    var state = getInternalState(that);
    var entry = getEntry(that, key);
    if (entry) {
     var next = entry.next;
     var prev = entry.previous;
     delete state.index[entry.index];
     entry.removed = true;
     if (prev)
      prev.next = next;
     if (next)
      next.previous = prev;
     if (state.first == entry)
      state.first = next;
     if (state.last == entry)
      state.last = prev;
     if (DESCRIPTORS)
      state.size--;
     else
      that.size--;
    }
    return !!entry;
   },
   forEach: function forEach(callbackfn) {
    var state = getInternalState(this);
    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
    var entry;
    while (entry = entry ? entry.next : state.first) {
     boundFunction(entry.value, entry.key, this);
     while (entry && entry.removed)
      entry = entry.previous;
    }
   },
   has: function has(key) {
    return !!getEntry(this, key);
   }
  });
  redefineAll(C.prototype, IS_MAP ? {
   get: function get(key) {
    var entry = getEntry(this, key);
    return entry && entry.value;
   },
   set: function set(key, value) {
    return define(this, key === 0 ? 0 : key, value);
   }
  } : {
   add: function add(value) {
    return define(this, value = value === 0 ? 0 : value, value);
   }
  });
  if (DESCRIPTORS)
   defineProperty(C.prototype, 'size', {
    get: function () {
     return getInternalState(this).size;
    }
   });
  return C;
 },
 setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
  var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
  var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
  var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
  defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
   setInternalState(this, {
    type: ITERATOR_NAME,
    target: iterated,
    state: getInternalCollectionState(iterated),
    kind: kind,
    last: undefined
   });
  }, function () {
   var state = getInternalIteratorState(this);
   var kind = state.kind;
   var entry = state.last;
   while (entry && entry.removed)
    entry = entry.previous;
   if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
    state.target = undefined;
    return {
     value: undefined,
     done: true
    };
   }
   if (kind == 'keys')
    return {
     value: entry.key,
     done: false
    };
   if (kind == 'values')
    return {
     value: entry.value,
     done: false
    };
   return {
    value: [
     entry.key,
     entry.value
    ],
    done: false
   };
  }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
  setSpecies(CONSTRUCTOR_NAME);
 }
};

/***/ }),
/* 143 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(144);
__w_pdfjs_require__(105);
__w_pdfjs_require__(73);
__w_pdfjs_require__(107);
var path = __w_pdfjs_require__(38);
module.exports = path.Set;

/***/ }),
/* 144 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var collection = __w_pdfjs_require__(138);
var collectionStrong = __w_pdfjs_require__(142);
module.exports = collection('Set', function (init) {
 return function Set() {
  return init(this, arguments.length ? arguments[0] : undefined);
 };
}, collectionStrong);

/***/ }),
/* 145 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(105);
__w_pdfjs_require__(146);
__w_pdfjs_require__(107);
var path = __w_pdfjs_require__(38);
module.exports = path.WeakMap;

/***/ }),
/* 146 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var global = __w_pdfjs_require__(6);
var redefineAll = __w_pdfjs_require__(112);
var InternalMetadataModule = __w_pdfjs_require__(139);
var collection = __w_pdfjs_require__(138);
var collectionWeak = __w_pdfjs_require__(147);
var isObject = __w_pdfjs_require__(17);
var enforceIternalState = __w_pdfjs_require__(28).enforce;
var NATIVE_WEAK_MAP = __w_pdfjs_require__(29);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var isExtensible = Object.isExtensible;
var InternalWeakMap;
var wrapper = function (init) {
 return function WeakMap() {
  return init(this, arguments.length ? arguments[0] : undefined);
 };
};
var $WeakMap = module.exports = collection('WeakMap', wrapper, collectionWeak);
if (NATIVE_WEAK_MAP && IS_IE11) {
 InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
 InternalMetadataModule.REQUIRED = true;
 var WeakMapPrototype = $WeakMap.prototype;
 var nativeDelete = WeakMapPrototype['delete'];
 var nativeHas = WeakMapPrototype.has;
 var nativeGet = WeakMapPrototype.get;
 var nativeSet = WeakMapPrototype.set;
 redefineAll(WeakMapPrototype, {
  'delete': function (key) {
   if (isObject(key) && !isExtensible(key)) {
    var state = enforceIternalState(this);
    if (!state.frozen)
     state.frozen = new InternalWeakMap();
    return nativeDelete.call(this, key) || state.frozen['delete'](key);
   }
   return nativeDelete.call(this, key);
  },
  has: function has(key) {
   if (isObject(key) && !isExtensible(key)) {
    var state = enforceIternalState(this);
    if (!state.frozen)
     state.frozen = new InternalWeakMap();
    return nativeHas.call(this, key) || state.frozen.has(key);
   }
   return nativeHas.call(this, key);
  },
  get: function get(key) {
   if (isObject(key) && !isExtensible(key)) {
    var state = enforceIternalState(this);
    if (!state.frozen)
     state.frozen = new InternalWeakMap();
    return nativeHas.call(this, key) ? nativeGet.call(this, key) : state.frozen.get(key);
   }
   return nativeGet.call(this, key);
  },
  set: function set(key, value) {
   if (isObject(key) && !isExtensible(key)) {
    var state = enforceIternalState(this);
    if (!state.frozen)
     state.frozen = new InternalWeakMap();
    nativeHas.call(this, key) ? nativeSet.call(this, key, value) : state.frozen.set(key, value);
   } else
    nativeSet.call(this, key, value);
   return this;
  }
 });
}

/***/ }),
/* 147 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var redefineAll = __w_pdfjs_require__(112);
var getWeakData = __w_pdfjs_require__(139).getWeakData;
var anObject = __w_pdfjs_require__(23);
var isObject = __w_pdfjs_require__(17);
var anInstance = __w_pdfjs_require__(114);
var iterate = __w_pdfjs_require__(115);
var ArrayIterationModule = __w_pdfjs_require__(148);
var $has = __w_pdfjs_require__(18);
var InternalStateModule = __w_pdfjs_require__(28);
var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var id = 0;
var uncaughtFrozenStore = function (store) {
 return store.frozen || (store.frozen = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
 this.entries = [];
};
var findUncaughtFrozen = function (store, key) {
 return find(store.entries, function (it) {
  return it[0] === key;
 });
};
UncaughtFrozenStore.prototype = {
 get: function (key) {
  var entry = findUncaughtFrozen(this, key);
  if (entry)
   return entry[1];
 },
 has: function (key) {
  return !!findUncaughtFrozen(this, key);
 },
 set: function (key, value) {
  var entry = findUncaughtFrozen(this, key);
  if (entry)
   entry[1] = value;
  else
   this.entries.push([
    key,
    value
   ]);
 },
 'delete': function (key) {
  var index = findIndex(this.entries, function (it) {
   return it[0] === key;
  });
  if (~index)
   this.entries.splice(index, 1);
  return !!~index;
 }
};
module.exports = {
 getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
  var C = wrapper(function (that, iterable) {
   anInstance(that, C, CONSTRUCTOR_NAME);
   setInternalState(that, {
    type: CONSTRUCTOR_NAME,
    id: id++,
    frozen: undefined
   });
   if (iterable != undefined)
    iterate(iterable, that[ADDER], that, IS_MAP);
  });
  var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
  var define = function (that, key, value) {
   var state = getInternalState(that);
   var data = getWeakData(anObject(key), true);
   if (data === true)
    uncaughtFrozenStore(state).set(key, value);
   else
    data[state.id] = value;
   return that;
  };
  redefineAll(C.prototype, {
   'delete': function (key) {
    var state = getInternalState(this);
    if (!isObject(key))
     return false;
    var data = getWeakData(key);
    if (data === true)
     return uncaughtFrozenStore(state)['delete'](key);
    return data && $has(data, state.id) && delete data[state.id];
   },
   has: function has(key) {
    var state = getInternalState(this);
    if (!isObject(key))
     return false;
    var data = getWeakData(key);
    if (data === true)
     return uncaughtFrozenStore(state).has(key);
    return data && $has(data, state.id);
   }
  });
  redefineAll(C.prototype, IS_MAP ? {
   get: function get(key) {
    var state = getInternalState(this);
    if (isObject(key)) {
     var data = getWeakData(key);
     if (data === true)
      return uncaughtFrozenStore(state).get(key);
     return data ? data[state.id] : undefined;
    }
   },
   set: function set(key, value) {
    return define(this, key, value);
   }
  } : {
   add: function add(value) {
    return define(this, value, true);
   }
  });
  return C;
 }
};

/***/ }),
/* 148 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var bind = __w_pdfjs_require__(58);
var IndexedObject = __w_pdfjs_require__(13);
var toObject = __w_pdfjs_require__(79);
var toLength = __w_pdfjs_require__(42);
var arraySpeciesCreate = __w_pdfjs_require__(149);
var push = [].push;
var createMethod = function (TYPE) {
 var IS_MAP = TYPE == 1;
 var IS_FILTER = TYPE == 2;
 var IS_SOME = TYPE == 3;
 var IS_EVERY = TYPE == 4;
 var IS_FIND_INDEX = TYPE == 6;
 var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
 return function ($this, callbackfn, that, specificCreate) {
  var O = toObject($this);
  var self = IndexedObject(O);
  var boundFunction = bind(callbackfn, that, 3);
  var length = toLength(self.length);
  var index = 0;
  var create = specificCreate || arraySpeciesCreate;
  var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
  var value, result;
  for (; length > index; index++)
   if (NO_HOLES || index in self) {
    value = self[index];
    result = boundFunction(value, index, O);
    if (TYPE) {
     if (IS_MAP)
      target[index] = result;
     else if (result)
      switch (TYPE) {
      case 3:
       return true;
      case 5:
       return value;
      case 6:
       return index;
      case 2:
       push.call(target, value);
      }
     else if (IS_EVERY)
      return false;
    }
   }
  return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
 };
};
module.exports = {
 forEach: createMethod(0),
 map: createMethod(1),
 filter: createMethod(2),
 some: createMethod(3),
 every: createMethod(4),
 find: createMethod(5),
 findIndex: createMethod(6)
};

/***/ }),
/* 149 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var isObject = __w_pdfjs_require__(17);
var isArray = __w_pdfjs_require__(150);
var wellKnownSymbol = __w_pdfjs_require__(53);
var SPECIES = wellKnownSymbol('species');
module.exports = function (originalArray, length) {
 var C;
 if (isArray(originalArray)) {
  C = originalArray.constructor;
  if (typeof C == 'function' && (C === Array || isArray(C.prototype)))
   C = undefined;
  else if (isObject(C)) {
   C = C[SPECIES];
   if (C === null)
    C = undefined;
  }
 }
 return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};

/***/ }),
/* 150 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var classof = __w_pdfjs_require__(14);
module.exports = Array.isArray || function isArray(arg) {
 return classof(arg) == 'Array';
};

/***/ }),
/* 151 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(105);
__w_pdfjs_require__(152);
__w_pdfjs_require__(107);
var path = __w_pdfjs_require__(38);
module.exports = path.WeakSet;

/***/ }),
/* 152 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var collection = __w_pdfjs_require__(138);
var collectionWeak = __w_pdfjs_require__(147);
collection('WeakSet', function (init) {
 return function WeakSet() {
  return init(this, arguments.length ? arguments[0] : undefined);
 };
}, collectionWeak);

/***/ }),
/* 153 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(154);
var entryUnbind = __w_pdfjs_require__(57);
module.exports = entryUnbind('String', 'codePointAt');

/***/ }),
/* 154 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var $ = __w_pdfjs_require__(5);
var codeAt = __w_pdfjs_require__(74).codeAt;
$({
 target: 'String',
 proto: true
}, {
 codePointAt: function codePointAt(pos) {
  return codeAt(this, pos);
 }
});

/***/ }),
/* 155 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(156);
var path = __w_pdfjs_require__(38);
module.exports = path.String.fromCodePoint;

/***/ }),
/* 156 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var $ = __w_pdfjs_require__(5);
var toAbsoluteIndex = __w_pdfjs_require__(44);
var fromCharCode = String.fromCharCode;
var nativeFromCodePoint = String.fromCodePoint;
var INCORRECT_LENGTH = !!nativeFromCodePoint && nativeFromCodePoint.length != 1;
$({
 target: 'String',
 stat: true,
 forced: INCORRECT_LENGTH
}, {
 fromCodePoint: function fromCodePoint(x) {
  var elements = [];
  var length = arguments.length;
  var i = 0;
  var code;
  while (length > i) {
   code = +arguments[i++];
   if (toAbsoluteIndex(code, 0x10FFFF) !== code)
    throw RangeError(code + ' is not a valid code point');
   elements.push(code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00));
  }
  return elements.join('');
 }
});

/***/ }),
/* 157 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(158);
__w_pdfjs_require__(105);
__w_pdfjs_require__(160);
__w_pdfjs_require__(164);
__w_pdfjs_require__(165);
__w_pdfjs_require__(166);
__w_pdfjs_require__(167);
__w_pdfjs_require__(168);
__w_pdfjs_require__(169);
__w_pdfjs_require__(170);
__w_pdfjs_require__(171);
__w_pdfjs_require__(172);
__w_pdfjs_require__(173);
__w_pdfjs_require__(174);
__w_pdfjs_require__(175);
__w_pdfjs_require__(176);
__w_pdfjs_require__(177);
__w_pdfjs_require__(178);
__w_pdfjs_require__(179);
var path = __w_pdfjs_require__(38);
module.exports = path.Symbol;

/***/ }),
/* 158 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var $ = __w_pdfjs_require__(5);
var fails = __w_pdfjs_require__(9);
var isArray = __w_pdfjs_require__(150);
var isObject = __w_pdfjs_require__(17);
var toObject = __w_pdfjs_require__(79);
var toLength = __w_pdfjs_require__(42);
var createProperty = __w_pdfjs_require__(89);
var arraySpeciesCreate = __w_pdfjs_require__(149);
var arrayMethodHasSpeciesSupport = __w_pdfjs_require__(159);
var wellKnownSymbol = __w_pdfjs_require__(53);
var V8_VERSION = __w_pdfjs_require__(125);
var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
 var array = [];
 array[IS_CONCAT_SPREADABLE] = false;
 return array.concat()[0] !== array;
});
var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');
var isConcatSpreadable = function (O) {
 if (!isObject(O))
  return false;
 var spreadable = O[IS_CONCAT_SPREADABLE];
 return spreadable !== undefined ? !!spreadable : isArray(O);
};
var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;
$({
 target: 'Array',
 proto: true,
 forced: FORCED
}, {
 concat: function concat(arg) {
  var O = toObject(this);
  var A = arraySpeciesCreate(O, 0);
  var n = 0;
  var i, k, length, len, E;
  for (i = -1, length = arguments.length; i < length; i++) {
   E = i === -1 ? O : arguments[i];
   if (isConcatSpreadable(E)) {
    len = toLength(E.length);
    if (n + len > MAX_SAFE_INTEGER)
     throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
    for (k = 0; k < len; k++, n++)
     if (k in E)
      createProperty(A, n, E[k]);
   } else {
    if (n >= MAX_SAFE_INTEGER)
     throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
    createProperty(A, n++, E);
   }
  }
  A.length = n;
  return A;
 }
});

/***/ }),
/* 159 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var fails = __w_pdfjs_require__(9);
var wellKnownSymbol = __w_pdfjs_require__(53);
var V8_VERSION = __w_pdfjs_require__(125);
var SPECIES = wellKnownSymbol('species');
module.exports = function (METHOD_NAME) {
 return V8_VERSION >= 51 || !fails(function () {
  var array = [];
  var constructor = array.constructor = {};
  constructor[SPECIES] = function () {
   return { foo: 1 };
  };
  return array[METHOD_NAME](Boolean).foo !== 1;
 });
};

/***/ }),
/* 160 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var $ = __w_pdfjs_require__(5);
var global = __w_pdfjs_require__(6);
var getBuiltIn = __w_pdfjs_require__(37);
var IS_PURE = __w_pdfjs_require__(32);
var DESCRIPTORS = __w_pdfjs_require__(8);
var NATIVE_SYMBOL = __w_pdfjs_require__(54);
var USE_SYMBOL_AS_UID = __w_pdfjs_require__(55);
var fails = __w_pdfjs_require__(9);
var has = __w_pdfjs_require__(18);
var isArray = __w_pdfjs_require__(150);
var isObject = __w_pdfjs_require__(17);
var anObject = __w_pdfjs_require__(23);
var toObject = __w_pdfjs_require__(79);
var toIndexedObject = __w_pdfjs_require__(12);
var toPrimitive = __w_pdfjs_require__(16);
var createPropertyDescriptor = __w_pdfjs_require__(11);
var nativeObjectCreate = __w_pdfjs_require__(67);
var objectKeys = __w_pdfjs_require__(69);
var getOwnPropertyNamesModule = __w_pdfjs_require__(39);
var getOwnPropertyNamesExternal = __w_pdfjs_require__(161);
var getOwnPropertySymbolsModule = __w_pdfjs_require__(46);
var getOwnPropertyDescriptorModule = __w_pdfjs_require__(7);
var definePropertyModule = __w_pdfjs_require__(22);
var propertyIsEnumerableModule = __w_pdfjs_require__(10);
var createNonEnumerableProperty = __w_pdfjs_require__(21);
var redefine = __w_pdfjs_require__(24);
var shared = __w_pdfjs_require__(31);
var sharedKey = __w_pdfjs_require__(30);
var hiddenKeys = __w_pdfjs_require__(34);
var uid = __w_pdfjs_require__(33);
var wellKnownSymbol = __w_pdfjs_require__(53);
var wrappedWellKnownSymbolModule = __w_pdfjs_require__(162);
var defineWellKnownSymbol = __w_pdfjs_require__(163);
var setToStringTag = __w_pdfjs_require__(81);
var InternalStateModule = __w_pdfjs_require__(28);
var $forEach = __w_pdfjs_require__(148).forEach;
var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
 return nativeObjectCreate(nativeDefineProperty({}, 'a', {
  get: function () {
   return nativeDefineProperty(this, 'a', { value: 7 }).a;
  }
 })).a != 7;
}) ? function (O, P, Attributes) {
 var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
 if (ObjectPrototypeDescriptor)
  delete ObjectPrototype[P];
 nativeDefineProperty(O, P, Attributes);
 if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
  nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
 }
} : nativeDefineProperty;
var wrap = function (tag, description) {
 var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
 setInternalState(symbol, {
  type: SYMBOL,
  tag: tag,
  description: description
 });
 if (!DESCRIPTORS)
  symbol.description = description;
 return symbol;
};
var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
 return typeof it == 'symbol';
} : function (it) {
 return Object(it) instanceof $Symbol;
};
var $defineProperty = function defineProperty(O, P, Attributes) {
 if (O === ObjectPrototype)
  $defineProperty(ObjectPrototypeSymbols, P, Attributes);
 anObject(O);
 var key = toPrimitive(P, true);
 anObject(Attributes);
 if (has(AllSymbols, key)) {
  if (!Attributes.enumerable) {
   if (!has(O, HIDDEN))
    nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
   O[HIDDEN][key] = true;
  } else {
   if (has(O, HIDDEN) && O[HIDDEN][key])
    O[HIDDEN][key] = false;
   Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
  }
  return setSymbolDescriptor(O, key, Attributes);
 }
 return nativeDefineProperty(O, key, Attributes);
};
var $defineProperties = function defineProperties(O, Properties) {
 anObject(O);
 var properties = toIndexedObject(Properties);
 var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
 $forEach(keys, function (key) {
  if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key))
   $defineProperty(O, key, properties[key]);
 });
 return O;
};
var $create = function create(O, Properties) {
 return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};
var $propertyIsEnumerable = function propertyIsEnumerable(V) {
 var P = toPrimitive(V, true);
 var enumerable = nativePropertyIsEnumerable.call(this, P);
 if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P))
  return false;
 return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
 var it = toIndexedObject(O);
 var key = toPrimitive(P, true);
 if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key))
  return;
 var descriptor = nativeGetOwnPropertyDescriptor(it, key);
 if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
  descriptor.enumerable = true;
 }
 return descriptor;
};
var $getOwnPropertyNames = function getOwnPropertyNames(O) {
 var names = nativeGetOwnPropertyNames(toIndexedObject(O));
 var result = [];
 $forEach(names, function (key) {
  if (!has(AllSymbols, key) && !has(hiddenKeys, key))
   result.push(key);
 });
 return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
 var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
 var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
 var result = [];
 $forEach(names, function (key) {
  if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
   result.push(AllSymbols[key]);
  }
 });
 return result;
};
if (!NATIVE_SYMBOL) {
 $Symbol = function Symbol() {
  if (this instanceof $Symbol)
   throw TypeError('Symbol is not a constructor');
  var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
  var tag = uid(description);
  var setter = function (value) {
   if (this === ObjectPrototype)
    setter.call(ObjectPrototypeSymbols, value);
   if (has(this, HIDDEN) && has(this[HIDDEN], tag))
    this[HIDDEN][tag] = false;
   setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
  };
  if (DESCRIPTORS && USE_SETTER)
   setSymbolDescriptor(ObjectPrototype, tag, {
    configurable: true,
    set: setter
   });
  return wrap(tag, description);
 };
 redefine($Symbol[PROTOTYPE], 'toString', function toString() {
  return getInternalState(this).tag;
 });
 redefine($Symbol, 'withoutSetter', function (description) {
  return wrap(uid(description), description);
 });
 propertyIsEnumerableModule.f = $propertyIsEnumerable;
 definePropertyModule.f = $defineProperty;
 getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
 getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
 getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;
 wrappedWellKnownSymbolModule.f = function (name) {
  return wrap(wellKnownSymbol(name), name);
 };
 if (DESCRIPTORS) {
  nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
   configurable: true,
   get: function description() {
    return getInternalState(this).description;
   }
  });
  if (!IS_PURE) {
   redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
  }
 }
}
$({
 global: true,
 wrap: true,
 forced: !NATIVE_SYMBOL,
 sham: !NATIVE_SYMBOL
}, { Symbol: $Symbol });
$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
 defineWellKnownSymbol(name);
});
$({
 target: SYMBOL,
 stat: true,
 forced: !NATIVE_SYMBOL
}, {
 'for': function (key) {
  var string = String(key);
  if (has(StringToSymbolRegistry, string))
   return StringToSymbolRegistry[string];
  var symbol = $Symbol(string);
  StringToSymbolRegistry[string] = symbol;
  SymbolToStringRegistry[symbol] = string;
  return symbol;
 },
 keyFor: function keyFor(sym) {
  if (!isSymbol(sym))
   throw TypeError(sym + ' is not a symbol');
  if (has(SymbolToStringRegistry, sym))
   return SymbolToStringRegistry[sym];
 },
 useSetter: function () {
  USE_SETTER = true;
 },
 useSimple: function () {
  USE_SETTER = false;
 }
});
$({
 target: 'Object',
 stat: true,
 forced: !NATIVE_SYMBOL,
 sham: !DESCRIPTORS
}, {
 create: $create,
 defineProperty: $defineProperty,
 defineProperties: $defineProperties,
 getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});
$({
 target: 'Object',
 stat: true,
 forced: !NATIVE_SYMBOL
}, {
 getOwnPropertyNames: $getOwnPropertyNames,
 getOwnPropertySymbols: $getOwnPropertySymbols
});
$({
 target: 'Object',
 stat: true,
 forced: fails(function () {
  getOwnPropertySymbolsModule.f(1);
 })
}, {
 getOwnPropertySymbols: function getOwnPropertySymbols(it) {
  return getOwnPropertySymbolsModule.f(toObject(it));
 }
});
if ($stringify) {
 var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
  var symbol = $Symbol();
  return $stringify([symbol]) != '[null]' || $stringify({ a: symbol }) != '{}' || $stringify(Object(symbol)) != '{}';
 });
 $({
  target: 'JSON',
  stat: true,
  forced: FORCED_JSON_STRINGIFY
 }, {
  stringify: function stringify(it, replacer, space) {
   var args = [it];
   var index = 1;
   var $replacer;
   while (arguments.length > index)
    args.push(arguments[index++]);
   $replacer = replacer;
   if (!isObject(replacer) && it === undefined || isSymbol(it))
    return;
   if (!isArray(replacer))
    replacer = function (key, value) {
     if (typeof $replacer == 'function')
      value = $replacer.call(this, key, value);
     if (!isSymbol(value))
      return value;
    };
   args[1] = replacer;
   return $stringify.apply(null, args);
  }
 });
}
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
 createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
setToStringTag($Symbol, SYMBOL);
hiddenKeys[HIDDEN] = true;

/***/ }),
/* 161 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var toIndexedObject = __w_pdfjs_require__(12);
var nativeGetOwnPropertyNames = __w_pdfjs_require__(39).f;
var toString = {}.toString;
var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var getWindowNames = function (it) {
 try {
  return nativeGetOwnPropertyNames(it);
 } catch (error) {
  return windowNames.slice();
 }
};
module.exports.f = function getOwnPropertyNames(it) {
 return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : nativeGetOwnPropertyNames(toIndexedObject(it));
};

/***/ }),
/* 162 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var wellKnownSymbol = __w_pdfjs_require__(53);
exports.f = wellKnownSymbol;

/***/ }),
/* 163 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var path = __w_pdfjs_require__(38);
var has = __w_pdfjs_require__(18);
var wrappedWellKnownSymbolModule = __w_pdfjs_require__(162);
var defineProperty = __w_pdfjs_require__(22).f;
module.exports = function (NAME) {
 var Symbol = path.Symbol || (path.Symbol = {});
 if (!has(Symbol, NAME))
  defineProperty(Symbol, NAME, { value: wrappedWellKnownSymbolModule.f(NAME) });
};

/***/ }),
/* 164 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var defineWellKnownSymbol = __w_pdfjs_require__(163);
defineWellKnownSymbol('asyncIterator');

/***/ }),
/* 165 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var $ = __w_pdfjs_require__(5);
var DESCRIPTORS = __w_pdfjs_require__(8);
var global = __w_pdfjs_require__(6);
var has = __w_pdfjs_require__(18);
var isObject = __w_pdfjs_require__(17);
var defineProperty = __w_pdfjs_require__(22).f;
var copyConstructorProperties = __w_pdfjs_require__(35);
var NativeSymbol = global.Symbol;
if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) || NativeSymbol().description !== undefined)) {
 var EmptyStringDescriptionStore = {};
 var SymbolWrapper = function Symbol() {
  var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
  var result = this instanceof SymbolWrapper ? new NativeSymbol(description) : description === undefined ? NativeSymbol() : NativeSymbol(description);
  if (description === '')
   EmptyStringDescriptionStore[result] = true;
  return result;
 };
 copyConstructorProperties(SymbolWrapper, NativeSymbol);
 var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
 symbolPrototype.constructor = SymbolWrapper;
 var symbolToString = symbolPrototype.toString;
 var native = String(NativeSymbol('test')) == 'Symbol(test)';
 var regexp = /^Symbol\((.*)\)[^)]+$/;
 defineProperty(symbolPrototype, 'description', {
  configurable: true,
  get: function description() {
   var symbol = isObject(this) ? this.valueOf() : this;
   var string = symbolToString.call(symbol);
   if (has(EmptyStringDescriptionStore, symbol))
    return '';
   var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
   return desc === '' ? undefined : desc;
  }
 });
 $({
  global: true,
  forced: true
 }, { Symbol: SymbolWrapper });
}

/***/ }),
/* 166 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var defineWellKnownSymbol = __w_pdfjs_require__(163);
defineWellKnownSymbol('hasInstance');

/***/ }),
/* 167 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var defineWellKnownSymbol = __w_pdfjs_require__(163);
defineWellKnownSymbol('isConcatSpreadable');

/***/ }),
/* 168 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var defineWellKnownSymbol = __w_pdfjs_require__(163);
defineWellKnownSymbol('iterator');

/***/ }),
/* 169 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var defineWellKnownSymbol = __w_pdfjs_require__(163);
defineWellKnownSymbol('match');

/***/ }),
/* 170 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var defineWellKnownSymbol = __w_pdfjs_require__(163);
defineWellKnownSymbol('matchAll');

/***/ }),
/* 171 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var defineWellKnownSymbol = __w_pdfjs_require__(163);
defineWellKnownSymbol('replace');

/***/ }),
/* 172 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var defineWellKnownSymbol = __w_pdfjs_require__(163);
defineWellKnownSymbol('search');

/***/ }),
/* 173 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var defineWellKnownSymbol = __w_pdfjs_require__(163);
defineWellKnownSymbol('species');

/***/ }),
/* 174 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var defineWellKnownSymbol = __w_pdfjs_require__(163);
defineWellKnownSymbol('split');

/***/ }),
/* 175 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var defineWellKnownSymbol = __w_pdfjs_require__(163);
defineWellKnownSymbol('toPrimitive');

/***/ }),
/* 176 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var defineWellKnownSymbol = __w_pdfjs_require__(163);
defineWellKnownSymbol('toStringTag');

/***/ }),
/* 177 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var defineWellKnownSymbol = __w_pdfjs_require__(163);
defineWellKnownSymbol('unscopables');

/***/ }),
/* 178 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var setToStringTag = __w_pdfjs_require__(81);
setToStringTag(Math, 'Math', true);

/***/ }),
/* 179 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var global = __w_pdfjs_require__(6);
var setToStringTag = __w_pdfjs_require__(81);
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 180 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(181);
var entryUnbind = __w_pdfjs_require__(57);
module.exports = entryUnbind('String', 'padStart');

/***/ }),
/* 181 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var $ = __w_pdfjs_require__(5);
var $padStart = __w_pdfjs_require__(182).start;
var WEBKIT_BUG = __w_pdfjs_require__(184);
$({
 target: 'String',
 proto: true,
 forced: WEBKIT_BUG
}, {
 padStart: function padStart(maxLength) {
  return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
 }
});

/***/ }),
/* 182 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var toLength = __w_pdfjs_require__(42);
var repeat = __w_pdfjs_require__(183);
var requireObjectCoercible = __w_pdfjs_require__(15);
var ceil = Math.ceil;
var createMethod = function (IS_END) {
 return function ($this, maxLength, fillString) {
  var S = String(requireObjectCoercible($this));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  var fillLen, stringFiller;
  if (intMaxLength <= stringLength || fillStr == '')
   return S;
  fillLen = intMaxLength - stringLength;
  stringFiller = repeat.call(fillStr, ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen)
   stringFiller = stringFiller.slice(0, fillLen);
  return IS_END ? S + stringFiller : stringFiller + S;
 };
};
module.exports = {
 start: createMethod(false),
 end: createMethod(true)
};

/***/ }),
/* 183 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var toInteger = __w_pdfjs_require__(43);
var requireObjectCoercible = __w_pdfjs_require__(15);
module.exports = ''.repeat || function repeat(count) {
 var str = String(requireObjectCoercible(this));
 var result = '';
 var n = toInteger(count);
 if (n < 0 || n == Infinity)
  throw RangeError('Wrong number of repetitions');
 for (; n > 0; (n >>>= 1) && (str += str))
  if (n & 1)
   result += str;
 return result;
};

/***/ }),
/* 184 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var userAgent = __w_pdfjs_require__(119);
module.exports = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

/***/ }),
/* 185 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(186);
var entryUnbind = __w_pdfjs_require__(57);
module.exports = entryUnbind('String', 'padEnd');

/***/ }),
/* 186 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";

var $ = __w_pdfjs_require__(5);
var $padEnd = __w_pdfjs_require__(182).end;
var WEBKIT_BUG = __w_pdfjs_require__(184);
$({
 target: 'String',
 proto: true,
 forced: WEBKIT_BUG
}, {
 padEnd: function padEnd(maxLength) {
  return $padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
 }
});

/***/ }),
/* 187 */
/***/ (function(module, exports, __w_pdfjs_require__) {

__w_pdfjs_require__(188);
var path = __w_pdfjs_require__(38);
module.exports = path.Object.values;

/***/ }),
/* 188 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var $ = __w_pdfjs_require__(5);
var $values = __w_pdfjs_require__(189).values;
$({
 target: 'Object',
 stat: true
}, {
 values: function values(O) {
  return $values(O);
 }
});

/***/ }),
/* 189 */
/***/ (function(module, exports, __w_pdfjs_require__) {

var DESCRIPTORS = __w_pdfjs_require__(8);
var objectKeys = __w_pdfjs_require__(69);
var toIndexedObject = __w_pdfjs_require__(12);
var propertyIsEnumerable = __w_pdfjs_require__(10).f;
var createMethod = function (TO_ENTRIES) {
 return function (it) {
  var O = toIndexedObject(it);
  var keys = objectKeys(O);
  var length = keys.length;
  var i = 0;
  var result = [];
  var key;
  while (length > i) {
   key = keys[i++];
   if (!DESCRIPTORS || propertyIsEnumerable.call(O, key)) {
    result.push(TO_ENTRIES ? [
     key,
     O[key]
    ] : O[key]);
   }
  }
  return result;
 };
};
module.exports = {
 entries: createMethod(true),
 values: createMethod(false)
};

/***/ }),
/* 190 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDocument = getDocument;
exports.setPDFNetworkStreamFactory = setPDFNetworkStreamFactory;
exports.build = exports.version = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFWorker = exports.PDFDataRangeTransport = exports.LoopbackPort = void 0;

var _regenerator = _interopRequireDefault(__w_pdfjs_require__(191));

var _util = __w_pdfjs_require__(1);

var _display_utils = __w_pdfjs_require__(194);

var _font_loader = __w_pdfjs_require__(195);

var _api_compatibility = __w_pdfjs_require__(196);

var _canvas = __w_pdfjs_require__(197);

var _worker_options = __w_pdfjs_require__(199);

var _is_node = __w_pdfjs_require__(48);

var _message_handler = __w_pdfjs_require__(200);

var _metadata = __w_pdfjs_require__(201);

var _transport_stream = __w_pdfjs_require__(203);

var _webgl = __w_pdfjs_require__(204);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var DEFAULT_RANGE_CHUNK_SIZE = 65536;
var RENDERING_CANCELLED_TIMEOUT = 100;
var createPDFNetworkStream;

function setPDFNetworkStreamFactory(pdfNetworkStreamFactory) {
  createPDFNetworkStream = pdfNetworkStreamFactory;
}

function getDocument(src) {
  var task = new PDFDocumentLoadingTask();
  var source;

  if (typeof src === "string") {
    source = {
      url: src
    };
  } else if ((0, _util.isArrayBuffer)(src)) {
    source = {
      data: src
    };
  } else if (src instanceof PDFDataRangeTransport) {
    source = {
      range: src
    };
  } else {
    if (_typeof(src) !== "object") {
      throw new Error("Invalid parameter in getDocument, " + "need either Uint8Array, string or a parameter object");
    }

    if (!src.url && !src.data && !src.range) {
      throw new Error("Invalid parameter object: need either .data, .range or .url");
    }

    source = src;
  }

  var params = Object.create(null);
  var rangeTransport = null,
      worker = null;

  for (var key in source) {
    if (key === "url" && typeof window !== "undefined") {
      params[key] = new URL(source[key], window.location).href;
      continue;
    } else if (key === "range") {
      rangeTransport = source[key];
      continue;
    } else if (key === "worker") {
      worker = source[key];
      continue;
    } else if (key === "data" && !(source[key] instanceof Uint8Array)) {
      var pdfBytes = source[key];

      if (typeof pdfBytes === "string") {
        params[key] = (0, _util.stringToBytes)(pdfBytes);
      } else if (_typeof(pdfBytes) === "object" && pdfBytes !== null && !isNaN(pdfBytes.length)) {
        params[key] = new Uint8Array(pdfBytes);
      } else if ((0, _util.isArrayBuffer)(pdfBytes)) {
        params[key] = new Uint8Array(pdfBytes);
      } else {
        throw new Error("Invalid PDF binary data: either typed array, " + "string or array-like object is expected in the " + "data property.");
      }

      continue;
    }

    params[key] = source[key];
  }

  params.rangeChunkSize = params.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE;
  params.CMapReaderFactory = params.CMapReaderFactory || _display_utils.DOMCMapReaderFactory;
  params.ignoreErrors = params.stopAtErrors !== true;
  params.pdfBug = params.pdfBug === true;
  var NativeImageDecoderValues = Object.values(_util.NativeImageDecoding);

  if (params.nativeImageDecoderSupport === undefined || !NativeImageDecoderValues.includes(params.nativeImageDecoderSupport)) {
    params.nativeImageDecoderSupport = _api_compatibility.apiCompatibilityParams.nativeImageDecoderSupport || _util.NativeImageDecoding.DECODE;
  }

  if (!Number.isInteger(params.maxImageSize)) {
    params.maxImageSize = -1;
  }

  if (typeof params.isEvalSupported !== "boolean") {
    params.isEvalSupported = true;
  }

  if (typeof params.disableFontFace !== "boolean") {
    params.disableFontFace = _api_compatibility.apiCompatibilityParams.disableFontFace || false;
  }

  if (typeof params.disableRange !== "boolean") {
    params.disableRange = false;
  }

  if (typeof params.disableStream !== "boolean") {
    params.disableStream = false;
  }

  if (typeof params.disableAutoFetch !== "boolean") {
    params.disableAutoFetch = false;
  }

  if (typeof params.disableCreateObjectURL !== "boolean") {
    params.disableCreateObjectURL = _api_compatibility.apiCompatibilityParams.disableCreateObjectURL || false;
  }

  (0, _util.setVerbosityLevel)(params.verbosity);

  if (!worker) {
    var workerParams = {
      verbosity: params.verbosity,
      port: _worker_options.GlobalWorkerOptions.workerPort
    };
    worker = workerParams.port ? PDFWorker.fromPort(workerParams) : new PDFWorker(workerParams);
    task._worker = worker;
  }

  var docId = task.docId;
  worker.promise.then(function () {
    if (task.destroyed) {
      throw new Error("Loading aborted");
    }

    return _fetchDocument(worker, params, rangeTransport, docId).then(function (workerId) {
      if (task.destroyed) {
        throw new Error("Loading aborted");
      }

      var networkStream;

      if (rangeTransport) {
        networkStream = new _transport_stream.PDFDataTransportStream({
          length: params.length,
          initialData: params.initialData,
          progressiveDone: params.progressiveDone,
          disableRange: params.disableRange,
          disableStream: params.disableStream
        }, rangeTransport);
      } else if (!params.data) {
        networkStream = createPDFNetworkStream({
          url: params.url,
          length: params.length,
          httpHeaders: params.httpHeaders,
          withCredentials: params.withCredentials,
          rangeChunkSize: params.rangeChunkSize,
          disableRange: params.disableRange,
          disableStream: params.disableStream
        });
      }

      var messageHandler = new _message_handler.MessageHandler(docId, workerId, worker.port);
      messageHandler.postMessageTransfers = worker.postMessageTransfers;
      var transport = new WorkerTransport(messageHandler, task, networkStream, params);
      task._transport = transport;
      messageHandler.send("Ready", null);
    });
  })["catch"](task._capability.reject);
  return task;
}

function _fetchDocument(worker, source, pdfDataRangeTransport, docId) {
  if (worker.destroyed) {
    return Promise.reject(new Error("Worker was destroyed"));
  }

  if (pdfDataRangeTransport) {
    source.length = pdfDataRangeTransport.length;
    source.initialData = pdfDataRangeTransport.initialData;
    source.progressiveDone = pdfDataRangeTransport.progressiveDone;
  }

  return worker.messageHandler.sendWithPromise("GetDocRequest", {
    docId: docId,
    apiVersion: '2.4.456',
    source: {
      data: source.data,
      url: source.url,
      password: source.password,
      disableAutoFetch: source.disableAutoFetch,
      rangeChunkSize: source.rangeChunkSize,
      length: source.length
    },
    maxImageSize: source.maxImageSize,
    disableFontFace: source.disableFontFace,
    disableCreateObjectURL: source.disableCreateObjectURL,
    postMessageTransfers: worker.postMessageTransfers,
    docBaseUrl: source.docBaseUrl,
    nativeImageDecoderSupport: source.nativeImageDecoderSupport,
    ignoreErrors: source.ignoreErrors,
    isEvalSupported: source.isEvalSupported
  }).then(function (workerId) {
    if (worker.destroyed) {
      throw new Error("Worker was destroyed");
    }

    return workerId;
  });
}

var PDFDocumentLoadingTask = function PDFDocumentLoadingTaskClosure() {
  var nextDocumentId = 0;

  var PDFDocumentLoadingTask = /*#__PURE__*/function () {
    function PDFDocumentLoadingTask() {
      _classCallCheck(this, PDFDocumentLoadingTask);

      this._capability = (0, _util.createPromiseCapability)();
      this._transport = null;
      this._worker = null;
      this.docId = "d" + nextDocumentId++;
      this.destroyed = false;
      this.onPassword = null;
      this.onProgress = null;
      this.onUnsupportedFeature = null;
    }

    _createClass(PDFDocumentLoadingTask, [{
      key: "destroy",
      value: function destroy() {
        var _this = this;

        this.destroyed = true;
        var transportDestroyed = !this._transport ? Promise.resolve() : this._transport.destroy();
        return transportDestroyed.then(function () {
          _this._transport = null;

          if (_this._worker) {
            _this._worker.destroy();

            _this._worker = null;
          }
        });
      }
    }, {
      key: "then",
      value: function then(onFulfilled, onRejected) {
        throw new Error("Removed API method: " + "PDFDocumentLoadingTask.then, use the `promise` getter instead.");
      }
    }, {
      key: "promise",
      get: function get() {
        return this._capability.promise;
      }
    }]);

    return PDFDocumentLoadingTask;
  }();

  return PDFDocumentLoadingTask;
}();

var PDFDataRangeTransport = /*#__PURE__*/function () {
  function PDFDataRangeTransport(length, initialData) {
    var progressiveDone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, PDFDataRangeTransport);

    this.length = length;
    this.initialData = initialData;
    this.progressiveDone = progressiveDone;
    this._rangeListeners = [];
    this._progressListeners = [];
    this._progressiveReadListeners = [];
    this._progressiveDoneListeners = [];
    this._readyCapability = (0, _util.createPromiseCapability)();
  }

  _createClass(PDFDataRangeTransport, [{
    key: "addRangeListener",
    value: function addRangeListener(listener) {
      this._rangeListeners.push(listener);
    }
  }, {
    key: "addProgressListener",
    value: function addProgressListener(listener) {
      this._progressListeners.push(listener);
    }
  }, {
    key: "addProgressiveReadListener",
    value: function addProgressiveReadListener(listener) {
      this._progressiveReadListeners.push(listener);
    }
  }, {
    key: "addProgressiveDoneListener",
    value: function addProgressiveDoneListener(listener) {
      this._progressiveDoneListeners.push(listener);
    }
  }, {
    key: "onDataRange",
    value: function onDataRange(begin, chunk) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this._rangeListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var listener = _step.value;
          listener(begin, chunk);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "onDataProgress",
    value: function onDataProgress(loaded, total) {
      var _this2 = this;

      this._readyCapability.promise.then(function () {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = _this2._progressListeners[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var listener = _step2.value;
            listener(loaded, total);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
              _iterator2["return"]();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      });
    }
  }, {
    key: "onDataProgressiveRead",
    value: function onDataProgressiveRead(chunk) {
      var _this3 = this;

      this._readyCapability.promise.then(function () {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = _this3._progressiveReadListeners[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var listener = _step3.value;
            listener(chunk);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
              _iterator3["return"]();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      });
    }
  }, {
    key: "onDataProgressiveDone",
    value: function onDataProgressiveDone() {
      var _this4 = this;

      this._readyCapability.promise.then(function () {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = _this4._progressiveDoneListeners[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var listener = _step4.value;
            listener();
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
              _iterator4["return"]();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      });
    }
  }, {
    key: "transportReady",
    value: function transportReady() {
      this._readyCapability.resolve();
    }
  }, {
    key: "requestDataRange",
    value: function requestDataRange(begin, end) {
      (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
    }
  }, {
    key: "abort",
    value: function abort() {}
  }]);

  return PDFDataRangeTransport;
}();

exports.PDFDataRangeTransport = PDFDataRangeTransport;

var PDFDocumentProxy = /*#__PURE__*/function () {
  function PDFDocumentProxy(pdfInfo, transport) {
    _classCallCheck(this, PDFDocumentProxy);

    this._pdfInfo = pdfInfo;
    this._transport = transport;
  }

  _createClass(PDFDocumentProxy, [{
    key: "getPage",
    value: function getPage(pageNumber) {
      return this._transport.getPage(pageNumber);
    }
  }, {
    key: "getPageIndex",
    value: function getPageIndex(ref) {
      return this._transport.getPageIndex(ref);
    }
  }, {
    key: "getDestinations",
    value: function getDestinations() {
      return this._transport.getDestinations();
    }
  }, {
    key: "getDestination",
    value: function getDestination(id) {
      return this._transport.getDestination(id);
    }
  }, {
    key: "getPageLabels",
    value: function getPageLabels() {
      return this._transport.getPageLabels();
    }
  }, {
    key: "getPageLayout",
    value: function getPageLayout() {
      return this._transport.getPageLayout();
    }
  }, {
    key: "getPageMode",
    value: function getPageMode() {
      return this._transport.getPageMode();
    }
  }, {
    key: "getViewerPreferences",
    value: function getViewerPreferences() {
      return this._transport.getViewerPreferences();
    }
  }, {
    key: "getOpenAction",
    value: function getOpenAction() {
      return this._transport.getOpenAction();
    }
  }, {
    key: "getOpenActionDestination",
    value: function getOpenActionDestination() {
      (0, _display_utils.deprecated)("getOpenActionDestination, use getOpenAction instead.");
      return this.getOpenAction().then(function (openAction) {
        return openAction && openAction.dest ? openAction.dest : null;
      });
    }
  }, {
    key: "getAttachments",
    value: function getAttachments() {
      return this._transport.getAttachments();
    }
  }, {
    key: "getJavaScript",
    value: function getJavaScript() {
      return this._transport.getJavaScript();
    }
  }, {
    key: "getOutline",
    value: function getOutline() {
      return this._transport.getOutline();
    }
  }, {
    key: "getPermissions",
    value: function getPermissions() {
      return this._transport.getPermissions();
    }
  }, {
    key: "getMetadata",
    value: function getMetadata() {
      return this._transport.getMetadata();
    }
  }, {
    key: "getData",
    value: function getData() {
      return this._transport.getData();
    }
  }, {
    key: "getDownloadInfo",
    value: function getDownloadInfo() {
      return this._transport.downloadInfoCapability.promise;
    }
  }, {
    key: "getStats",
    value: function getStats() {
      return this._transport.getStats();
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      return this._transport.startCleanup();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return this.loadingTask.destroy();
    }
  }, {
    key: "numPages",
    get: function get() {
      return this._pdfInfo.numPages;
    }
  }, {
    key: "fingerprint",
    get: function get() {
      return this._pdfInfo.fingerprint;
    }
  }, {
    key: "loadingParams",
    get: function get() {
      return this._transport.loadingParams;
    }
  }, {
    key: "loadingTask",
    get: function get() {
      return this._transport.loadingTask;
    }
  }]);

  return PDFDocumentProxy;
}();

exports.PDFDocumentProxy = PDFDocumentProxy;

var PDFPageProxy = /*#__PURE__*/function () {
  function PDFPageProxy(pageIndex, pageInfo, transport) {
    var pdfBug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    _classCallCheck(this, PDFPageProxy);

    this._pageIndex = pageIndex;
    this._pageInfo = pageInfo;
    this._transport = transport;
    this._stats = pdfBug ? new _display_utils.StatTimer() : null;
    this._pdfBug = pdfBug;
    this.commonObjs = transport.commonObjs;
    this.objs = new PDFObjects();
    this.cleanupAfterRender = false;
    this.pendingCleanup = false;
    this.intentStates = Object.create(null);
    this.destroyed = false;
  }

  _createClass(PDFPageProxy, [{
    key: "getViewport",
    value: function getViewport() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          scale = _ref.scale,
          _ref$rotation = _ref.rotation,
          rotation = _ref$rotation === void 0 ? this.rotate : _ref$rotation,
          _ref$offsetX = _ref.offsetX,
          offsetX = _ref$offsetX === void 0 ? 0 : _ref$offsetX,
          _ref$offsetY = _ref.offsetY,
          offsetY = _ref$offsetY === void 0 ? 0 : _ref$offsetY,
          _ref$dontFlip = _ref.dontFlip,
          dontFlip = _ref$dontFlip === void 0 ? false : _ref$dontFlip;

      if (arguments.length > 1 || typeof arguments[0] === "number") {
        throw new Error("PDFPageProxy.getViewport is called with obsolete arguments.");
      }

      return new _display_utils.PageViewport({
        viewBox: this.view,
        scale: scale,
        rotation: rotation,
        offsetX: offsetX,
        offsetY: offsetY,
        dontFlip: dontFlip
      });
    }
  }, {
    key: "getAnnotations",
    value: function getAnnotations() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$intent = _ref2.intent,
          intent = _ref2$intent === void 0 ? null : _ref2$intent;

      if (!this.annotationsPromise || this.annotationsIntent !== intent) {
        this.annotationsPromise = this._transport.getAnnotations(this._pageIndex, intent);
        this.annotationsIntent = intent;
      }

      return this.annotationsPromise;
    }
  }, {
    key: "render",
    value: function render(_ref3) {
      var _this5 = this;

      var canvasContext = _ref3.canvasContext,
          viewport = _ref3.viewport,
          _ref3$intent = _ref3.intent,
          intent = _ref3$intent === void 0 ? "display" : _ref3$intent,
          _ref3$enableWebGL = _ref3.enableWebGL,
          enableWebGL = _ref3$enableWebGL === void 0 ? false : _ref3$enableWebGL,
          _ref3$renderInteracti = _ref3.renderInteractiveForms,
          renderInteractiveForms = _ref3$renderInteracti === void 0 ? false : _ref3$renderInteracti,
          _ref3$transform = _ref3.transform,
          transform = _ref3$transform === void 0 ? null : _ref3$transform,
          _ref3$imageLayer = _ref3.imageLayer,
          imageLayer = _ref3$imageLayer === void 0 ? null : _ref3$imageLayer,
          _ref3$canvasFactory = _ref3.canvasFactory,
          canvasFactory = _ref3$canvasFactory === void 0 ? null : _ref3$canvasFactory,
          _ref3$background = _ref3.background,
          background = _ref3$background === void 0 ? null : _ref3$background;

      if (this._stats) {
        this._stats.time("Overall");
      }

      var renderingIntent = intent === "print" ? "print" : "display";
      this.pendingCleanup = false;

      if (!this.intentStates[renderingIntent]) {
        this.intentStates[renderingIntent] = Object.create(null);
      }

      var intentState = this.intentStates[renderingIntent];

      if (intentState.streamReaderCancelTimeout) {
        clearTimeout(intentState.streamReaderCancelTimeout);
        intentState.streamReaderCancelTimeout = null;
      }

      var canvasFactoryInstance = canvasFactory || new _display_utils.DOMCanvasFactory();
      var webGLContext = new _webgl.WebGLContext({
        enable: enableWebGL
      });

      if (!intentState.displayReadyCapability) {
        intentState.displayReadyCapability = (0, _util.createPromiseCapability)();
        intentState.operatorList = {
          fnArray: [],
          argsArray: [],
          lastChunk: false
        };

        if (this._stats) {
          this._stats.time("Page Request");
        }

        this._pumpOperatorList({
          pageIndex: this._pageIndex,
          intent: renderingIntent,
          renderInteractiveForms: renderInteractiveForms === true
        });
      }

      var complete = function complete(error) {
        var i = intentState.renderTasks.indexOf(internalRenderTask);

        if (i >= 0) {
          intentState.renderTasks.splice(i, 1);
        }

        if (_this5.cleanupAfterRender || renderingIntent === "print") {
          _this5.pendingCleanup = true;
        }

        _this5._tryCleanup();

        if (error) {
          internalRenderTask.capability.reject(error);

          _this5._abortOperatorList({
            intentState: intentState,
            reason: error
          });
        } else {
          internalRenderTask.capability.resolve();
        }

        if (_this5._stats) {
          _this5._stats.timeEnd("Rendering");

          _this5._stats.timeEnd("Overall");
        }
      };

      var internalRenderTask = new InternalRenderTask({
        callback: complete,
        params: {
          canvasContext: canvasContext,
          viewport: viewport,
          transform: transform,
          imageLayer: imageLayer,
          background: background
        },
        objs: this.objs,
        commonObjs: this.commonObjs,
        operatorList: intentState.operatorList,
        pageIndex: this._pageIndex,
        canvasFactory: canvasFactoryInstance,
        webGLContext: webGLContext,
        useRequestAnimationFrame: renderingIntent !== "print",
        pdfBug: this._pdfBug
      });

      if (!intentState.renderTasks) {
        intentState.renderTasks = [];
      }

      intentState.renderTasks.push(internalRenderTask);
      var renderTask = internalRenderTask.task;
      intentState.displayReadyCapability.promise.then(function (transparency) {
        if (_this5.pendingCleanup) {
          complete();
          return;
        }

        if (_this5._stats) {
          _this5._stats.time("Rendering");
        }

        internalRenderTask.initializeGraphics(transparency);
        internalRenderTask.operatorListChanged();
      })["catch"](complete);
      return renderTask;
    }
  }, {
    key: "getOperatorList",
    value: function getOperatorList() {
      function operatorListChanged() {
        if (intentState.operatorList.lastChunk) {
          intentState.opListReadCapability.resolve(intentState.operatorList);
          var i = intentState.renderTasks.indexOf(opListTask);

          if (i >= 0) {
            intentState.renderTasks.splice(i, 1);
          }
        }
      }

      var renderingIntent = "oplist";

      if (!this.intentStates[renderingIntent]) {
        this.intentStates[renderingIntent] = Object.create(null);
      }

      var intentState = this.intentStates[renderingIntent];
      var opListTask;

      if (!intentState.opListReadCapability) {
        opListTask = {};
        opListTask.operatorListChanged = operatorListChanged;
        intentState.opListReadCapability = (0, _util.createPromiseCapability)();
        intentState.renderTasks = [];
        intentState.renderTasks.push(opListTask);
        intentState.operatorList = {
          fnArray: [],
          argsArray: [],
          lastChunk: false
        };

        if (this._stats) {
          this._stats.time("Page Request");
        }

        this._pumpOperatorList({
          pageIndex: this._pageIndex,
          intent: renderingIntent
        });
      }

      return intentState.opListReadCapability.promise;
    }
  }, {
    key: "streamTextContent",
    value: function streamTextContent() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$normalizeWhites = _ref4.normalizeWhitespace,
          normalizeWhitespace = _ref4$normalizeWhites === void 0 ? false : _ref4$normalizeWhites,
          _ref4$disableCombineT = _ref4.disableCombineTextItems,
          disableCombineTextItems = _ref4$disableCombineT === void 0 ? false : _ref4$disableCombineT;

      var TEXT_CONTENT_CHUNK_SIZE = 100;
      return this._transport.messageHandler.sendWithStream("GetTextContent", {
        pageIndex: this._pageIndex,
        normalizeWhitespace: normalizeWhitespace === true,
        combineTextItems: disableCombineTextItems !== true
      }, {
        highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
        size: function size(textContent) {
          return textContent.items.length;
        }
      });
    }
  }, {
    key: "getTextContent",
    value: function getTextContent() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var readableStream = this.streamTextContent(params);
      return new Promise(function (resolve, reject) {
        function pump() {
          reader.read().then(function (_ref5) {
            var _textContent$items;

            var value = _ref5.value,
                done = _ref5.done;

            if (done) {
              resolve(textContent);
              return;
            }

            Object.assign(textContent.styles, value.styles);

            (_textContent$items = textContent.items).push.apply(_textContent$items, _toConsumableArray(value.items));

            pump();
          }, reject);
        }

        var reader = readableStream.getReader();
        var textContent = {
          items: [],
          styles: Object.create(null)
        };
        pump();
      });
    }
  }, {
    key: "_destroy",
    value: function _destroy() {
      var _this6 = this;

      this.destroyed = true;
      this._transport.pageCache[this._pageIndex] = null;
      var waitOn = [];
      Object.keys(this.intentStates).forEach(function (intent) {
        var intentState = _this6.intentStates[intent];

        _this6._abortOperatorList({
          intentState: intentState,
          reason: new Error("Page was destroyed."),
          force: true
        });

        if (intent === "oplist") {
          return;
        }

        intentState.renderTasks.forEach(function (renderTask) {
          var renderCompleted = renderTask.capability.promise["catch"](function () {});
          waitOn.push(renderCompleted);
          renderTask.cancel();
        });
      });
      this.objs.clear();
      this.annotationsPromise = null;
      this.pendingCleanup = false;
      return Promise.all(waitOn);
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      var resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.pendingCleanup = true;
      return this._tryCleanup(resetStats);
    }
  }, {
    key: "_tryCleanup",
    value: function _tryCleanup() {
      var _this7 = this;

      var resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.pendingCleanup || Object.keys(this.intentStates).some(function (intent) {
        var intentState = _this7.intentStates[intent];
        return intentState.renderTasks.length !== 0 || !intentState.operatorList.lastChunk;
      })) {
        return false;
      }

      Object.keys(this.intentStates).forEach(function (intent) {
        delete _this7.intentStates[intent];
      });
      this.objs.clear();
      this.annotationsPromise = null;

      if (resetStats && this._stats) {
        this._stats = new _display_utils.StatTimer();
      }

      this.pendingCleanup = false;
      return true;
    }
  }, {
    key: "_startRenderPage",
    value: function _startRenderPage(transparency, intent) {
      var intentState = this.intentStates[intent];

      if (!intentState) {
        return;
      }

      if (this._stats) {
        this._stats.timeEnd("Page Request");
      }

      if (intentState.displayReadyCapability) {
        intentState.displayReadyCapability.resolve(transparency);
      }
    }
  }, {
    key: "_renderPageChunk",
    value: function _renderPageChunk(operatorListChunk, intentState) {
      for (var i = 0, ii = operatorListChunk.length; i < ii; i++) {
        intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
        intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
      }

      intentState.operatorList.lastChunk = operatorListChunk.lastChunk;

      for (var _i = 0; _i < intentState.renderTasks.length; _i++) {
        intentState.renderTasks[_i].operatorListChanged();
      }

      if (operatorListChunk.lastChunk) {
        this._tryCleanup();
      }
    }
  }, {
    key: "_pumpOperatorList",
    value: function _pumpOperatorList(args) {
      var _this8 = this;

      (0, _util.assert)(args.intent, 'PDFPageProxy._pumpOperatorList: Expected "intent" argument.');

      var readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", args);

      var reader = readableStream.getReader();
      var intentState = this.intentStates[args.intent];
      intentState.streamReader = reader;

      var pump = function pump() {
        reader.read().then(function (_ref6) {
          var value = _ref6.value,
              done = _ref6.done;

          if (done) {
            intentState.streamReader = null;
            return;
          }

          if (_this8._transport.destroyed) {
            return;
          }

          _this8._renderPageChunk(value, intentState);

          pump();
        }, function (reason) {
          intentState.streamReader = null;

          if (_this8._transport.destroyed) {
            return;
          }

          if (intentState.operatorList) {
            intentState.operatorList.lastChunk = true;

            for (var i = 0; i < intentState.renderTasks.length; i++) {
              intentState.renderTasks[i].operatorListChanged();
            }

            _this8._tryCleanup();
          }

          if (intentState.displayReadyCapability) {
            intentState.displayReadyCapability.reject(reason);
          } else if (intentState.opListReadCapability) {
            intentState.opListReadCapability.reject(reason);
          } else {
            throw reason;
          }
        });
      };

      pump();
    }
  }, {
    key: "_abortOperatorList",
    value: function _abortOperatorList(_ref7) {
      var _this9 = this;

      var intentState = _ref7.intentState,
          reason = _ref7.reason,
          _ref7$force = _ref7.force,
          force = _ref7$force === void 0 ? false : _ref7$force;
      (0, _util.assert)(reason instanceof Error || _typeof(reason) === "object" && reason !== null, 'PDFPageProxy._abortOperatorList: Expected "reason" argument.');

      if (!intentState.streamReader) {
        return;
      }

      if (!force) {
        if (intentState.renderTasks.length !== 0) {
          return;
        }

        if (reason instanceof _display_utils.RenderingCancelledException) {
          intentState.streamReaderCancelTimeout = setTimeout(function () {
            _this9._abortOperatorList({
              intentState: intentState,
              reason: reason,
              force: true
            });

            intentState.streamReaderCancelTimeout = null;
          }, RENDERING_CANCELLED_TIMEOUT);
          return;
        }
      }

      intentState.streamReader.cancel(new _util.AbortException(reason && reason.message));
      intentState.streamReader = null;

      if (this._transport.destroyed) {
        return;
      }

      Object.keys(this.intentStates).some(function (intent) {
        if (_this9.intentStates[intent] === intentState) {
          delete _this9.intentStates[intent];
          return true;
        }

        return false;
      });
      this.cleanup();
    }
  }, {
    key: "pageNumber",
    get: function get() {
      return this._pageIndex + 1;
    }
  }, {
    key: "rotate",
    get: function get() {
      return this._pageInfo.rotate;
    }
  }, {
    key: "ref",
    get: function get() {
      return this._pageInfo.ref;
    }
  }, {
    key: "userUnit",
    get: function get() {
      return this._pageInfo.userUnit;
    }
  }, {
    key: "view",
    get: function get() {
      return this._pageInfo.view;
    }
  }, {
    key: "stats",
    get: function get() {
      return this._stats;
    }
  }]);

  return PDFPageProxy;
}();

exports.PDFPageProxy = PDFPageProxy;

var LoopbackPort = /*#__PURE__*/function () {
  function LoopbackPort() {
    var defer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    _classCallCheck(this, LoopbackPort);

    this._listeners = [];
    this._defer = defer;
    this._deferred = Promise.resolve(undefined);
  }

  _createClass(LoopbackPort, [{
    key: "postMessage",
    value: function postMessage(obj, transfers) {
      var _this10 = this;

      function cloneValue(value) {
        if (_typeof(value) !== "object" || value === null) {
          return value;
        }

        if (cloned.has(value)) {
          return cloned.get(value);
        }

        var buffer, result;

        if ((buffer = value.buffer) && (0, _util.isArrayBuffer)(buffer)) {
          var transferable = transfers && transfers.includes(buffer);

          if (transferable) {
            result = new value.constructor(buffer, value.byteOffset, value.byteLength);
          } else {
            result = new value.constructor(value);
          }

          cloned.set(value, result);
          return result;
        }

        result = Array.isArray(value) ? [] : {};
        cloned.set(value, result);

        for (var i in value) {
          var desc = void 0,
              p = value;

          while (!(desc = Object.getOwnPropertyDescriptor(p, i))) {
            p = Object.getPrototypeOf(p);
          }

          if (typeof desc.value === "undefined") {
            continue;
          }

          if (typeof desc.value === "function") {
            if (value.hasOwnProperty && value.hasOwnProperty(i)) {
              throw new Error("LoopbackPort.postMessage - cannot clone: ".concat(value[i]));
            }

            continue;
          }

          result[i] = cloneValue(desc.value);
        }

        return result;
      }

      if (!this._defer) {
        this._listeners.forEach(function (listener) {
          listener.call(_this10, {
            data: obj
          });
        });

        return;
      }

      var cloned = new WeakMap();
      var e = {
        data: cloneValue(obj)
      };

      this._deferred.then(function () {
        _this10._listeners.forEach(function (listener) {
          listener.call(_this10, e);
        });
      });
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(name, listener) {
      this._listeners.push(listener);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(name, listener) {
      var i = this._listeners.indexOf(listener);

      this._listeners.splice(i, 1);
    }
  }, {
    key: "terminate",
    value: function terminate() {
      this._listeners.length = 0;
    }
  }]);

  return LoopbackPort;
}();

exports.LoopbackPort = LoopbackPort;

var PDFWorker = function PDFWorkerClosure() {
  var pdfWorkerPorts = new WeakMap();
  var isWorkerDisabled = false;
  var fallbackWorkerSrc;
  var nextFakeWorkerId = 0;
  var fakeWorkerCapability;

  if (_is_node.isNodeJS && "function" === "function") {
    isWorkerDisabled = true;
    fallbackWorkerSrc = "./pdf.worker.js";
  } else if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === "object" && "currentScript" in document) {
    var pdfjsFilePath = document.currentScript && document.currentScript.src;

    if (pdfjsFilePath) {
      fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2");
    }
  }

  function _getWorkerSrc() {
    if (_worker_options.GlobalWorkerOptions.workerSrc) {
      return _worker_options.GlobalWorkerOptions.workerSrc;
    }

    if (typeof fallbackWorkerSrc !== "undefined") {
      if (!_is_node.isNodeJS) {
        (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.');
      }

      return fallbackWorkerSrc;
    }

    throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
  }

  function getMainThreadWorkerMessageHandler() {
    var mainWorkerMessageHandler;

    try {
      mainWorkerMessageHandler = globalThis.pdfjsWorker && globalThis.pdfjsWorker.WorkerMessageHandler;
    } catch (ex) {}

    return mainWorkerMessageHandler || null;
  }

  function setupFakeWorkerGlobal() {
    if (fakeWorkerCapability) {
      return fakeWorkerCapability.promise;
    }

    fakeWorkerCapability = (0, _util.createPromiseCapability)();

    var loader = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var mainWorkerMessageHandler, worker;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                mainWorkerMessageHandler = getMainThreadWorkerMessageHandler();

                if (!mainWorkerMessageHandler) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", mainWorkerMessageHandler);

              case 3:
                if (!(_is_node.isNodeJS && "function" === "function")) {
                  _context.next = 6;
                  break;
                }

                worker = eval("require")(_getWorkerSrc());
                return _context.abrupt("return", worker.WorkerMessageHandler);

              case 6:
                _context.next = 8;
                return (0, _display_utils.loadScript)(_getWorkerSrc());

              case 8:
                return _context.abrupt("return", window.pdfjsWorker.WorkerMessageHandler);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function loader() {
        return _ref8.apply(this, arguments);
      };
    }();

    loader().then(fakeWorkerCapability.resolve, fakeWorkerCapability.reject);
    return fakeWorkerCapability.promise;
  }

  function createCDNWrapper(url) {
    var wrapper = "importScripts('" + url + "');";
    return URL.createObjectURL(new Blob([wrapper]));
  }

  var PDFWorker = /*#__PURE__*/function () {
    function PDFWorker() {
      var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref9$name = _ref9.name,
          name = _ref9$name === void 0 ? null : _ref9$name,
          _ref9$port = _ref9.port,
          port = _ref9$port === void 0 ? null : _ref9$port,
          _ref9$verbosity = _ref9.verbosity,
          verbosity = _ref9$verbosity === void 0 ? (0, _util.getVerbosityLevel)() : _ref9$verbosity;

      _classCallCheck(this, PDFWorker);

      if (port && pdfWorkerPorts.has(port)) {
        throw new Error("Cannot use more than one PDFWorker per port");
      }

      this.name = name;
      this.destroyed = false;
      this.postMessageTransfers = true;
      this.verbosity = verbosity;
      this._readyCapability = (0, _util.createPromiseCapability)();
      this._port = null;
      this._webWorker = null;
      this._messageHandler = null;

      if (port) {
        pdfWorkerPorts.set(port, this);

        this._initializeFromPort(port);

        return;
      }

      this._initialize();
    }

    _createClass(PDFWorker, [{
      key: "_initializeFromPort",
      value: function _initializeFromPort(port) {
        this._port = port;
        this._messageHandler = new _message_handler.MessageHandler("main", "worker", port);

        this._messageHandler.on("ready", function () {});

        this._readyCapability.resolve();
      }
    }, {
      key: "_initialize",
      value: function _initialize() {
        var _this11 = this;

        if (typeof Worker !== "undefined" && !isWorkerDisabled && !getMainThreadWorkerMessageHandler()) {
          var workerSrc = _getWorkerSrc();

          try {
            if (!(0, _util.isSameOrigin)(window.location.href, workerSrc)) {
              workerSrc = createCDNWrapper(new URL(workerSrc, window.location).href);
            }

            var worker = new Worker(workerSrc);
            var messageHandler = new _message_handler.MessageHandler("main", "worker", worker);

            var terminateEarly = function terminateEarly() {
              worker.removeEventListener("error", onWorkerError);
              messageHandler.destroy();
              worker.terminate();

              if (_this11.destroyed) {
                _this11._readyCapability.reject(new Error("Worker was destroyed"));
              } else {
                _this11._setupFakeWorker();
              }
            };

            var onWorkerError = function onWorkerError() {
              if (!_this11._webWorker) {
                terminateEarly();
              }
            };

            worker.addEventListener("error", onWorkerError);
            messageHandler.on("test", function (data) {
              worker.removeEventListener("error", onWorkerError);

              if (_this11.destroyed) {
                terminateEarly();
                return;
              }

              if (data) {
                _this11._messageHandler = messageHandler;
                _this11._port = worker;
                _this11._webWorker = worker;

                if (!data.supportTransfers) {
                  _this11.postMessageTransfers = false;
                }

                _this11._readyCapability.resolve();

                messageHandler.send("configure", {
                  verbosity: _this11.verbosity
                });
              } else {
                _this11._setupFakeWorker();

                messageHandler.destroy();
                worker.terminate();
              }
            });
            messageHandler.on("ready", function (data) {
              worker.removeEventListener("error", onWorkerError);

              if (_this11.destroyed) {
                terminateEarly();
                return;
              }

              try {
                sendTest();
              } catch (e) {
                _this11._setupFakeWorker();
              }
            });

            var sendTest = function sendTest() {
              var testObj = new Uint8Array([_this11.postMessageTransfers ? 255 : 0]);

              try {
                messageHandler.send("test", testObj, [testObj.buffer]);
              } catch (ex) {
                (0, _util.warn)("Cannot use postMessage transfers.");
                testObj[0] = 0;
                messageHandler.send("test", testObj);
              }
            };

            sendTest();
            return;
          } catch (e) {
            (0, _util.info)("The worker has been disabled.");
          }
        }

        this._setupFakeWorker();
      }
    }, {
      key: "_setupFakeWorker",
      value: function _setupFakeWorker() {
        var _this12 = this;

        if (!isWorkerDisabled) {
          (0, _util.warn)("Setting up fake worker.");
          isWorkerDisabled = true;
        }

        setupFakeWorkerGlobal().then(function (WorkerMessageHandler) {
          if (_this12.destroyed) {
            _this12._readyCapability.reject(new Error("Worker was destroyed"));

            return;
          }

          var port = new LoopbackPort();
          _this12._port = port;
          var id = "fake" + nextFakeWorkerId++;
          var workerHandler = new _message_handler.MessageHandler(id + "_worker", id, port);
          WorkerMessageHandler.setup(workerHandler, port);
          var messageHandler = new _message_handler.MessageHandler(id, id + "_worker", port);
          _this12._messageHandler = messageHandler;

          _this12._readyCapability.resolve();

          messageHandler.send("configure", {
            verbosity: _this12.verbosity
          });
        })["catch"](function (reason) {
          _this12._readyCapability.reject(new Error("Setting up fake worker failed: \"".concat(reason.message, "\".")));
        });
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.destroyed = true;

        if (this._webWorker) {
          this._webWorker.terminate();

          this._webWorker = null;
        }

        pdfWorkerPorts["delete"](this._port);
        this._port = null;

        if (this._messageHandler) {
          this._messageHandler.destroy();

          this._messageHandler = null;
        }
      }
    }, {
      key: "promise",
      get: function get() {
        return this._readyCapability.promise;
      }
    }, {
      key: "port",
      get: function get() {
        return this._port;
      }
    }, {
      key: "messageHandler",
      get: function get() {
        return this._messageHandler;
      }
    }], [{
      key: "fromPort",
      value: function fromPort(params) {
        if (!params || !params.port) {
          throw new Error("PDFWorker.fromPort - invalid method signature.");
        }

        if (pdfWorkerPorts.has(params.port)) {
          return pdfWorkerPorts.get(params.port);
        }

        return new PDFWorker(params);
      }
    }, {
      key: "getWorkerSrc",
      value: function getWorkerSrc() {
        return _getWorkerSrc();
      }
    }]);

    return PDFWorker;
  }();

  return PDFWorker;
}();

exports.PDFWorker = PDFWorker;

var WorkerTransport = /*#__PURE__*/function () {
  function WorkerTransport(messageHandler, loadingTask, networkStream, params) {
    _classCallCheck(this, WorkerTransport);

    this.messageHandler = messageHandler;
    this.loadingTask = loadingTask;
    this.commonObjs = new PDFObjects();
    this.fontLoader = new _font_loader.FontLoader({
      docId: loadingTask.docId,
      onUnsupportedFeature: this._onUnsupportedFeature.bind(this)
    });
    this._params = params;
    this.CMapReaderFactory = new params.CMapReaderFactory({
      baseUrl: params.cMapUrl,
      isCompressed: params.cMapPacked
    });
    this.destroyed = false;
    this.destroyCapability = null;
    this._passwordCapability = null;
    this._networkStream = networkStream;
    this._fullReader = null;
    this._lastProgress = null;
    this.pageCache = [];
    this.pagePromises = [];
    this.downloadInfoCapability = (0, _util.createPromiseCapability)();
    this.setupMessageHandler();
  }

  _createClass(WorkerTransport, [{
    key: "destroy",
    value: function destroy() {
      var _this13 = this;

      if (this.destroyCapability) {
        return this.destroyCapability.promise;
      }

      this.destroyed = true;
      this.destroyCapability = (0, _util.createPromiseCapability)();

      if (this._passwordCapability) {
        this._passwordCapability.reject(new Error("Worker was destroyed during onPassword callback"));
      }

      var waitOn = [];
      this.pageCache.forEach(function (page) {
        if (page) {
          waitOn.push(page._destroy());
        }
      });
      this.pageCache.length = 0;
      this.pagePromises.length = 0;
      var terminated = this.messageHandler.sendWithPromise("Terminate", null);
      waitOn.push(terminated);
      Promise.all(waitOn).then(function () {
        _this13.fontLoader.clear();

        if (_this13._networkStream) {
          _this13._networkStream.cancelAllRequests(new _util.AbortException("Worker was terminated."));
        }

        if (_this13.messageHandler) {
          _this13.messageHandler.destroy();

          _this13.messageHandler = null;
        }

        _this13.destroyCapability.resolve();
      }, this.destroyCapability.reject);
      return this.destroyCapability.promise;
    }
  }, {
    key: "setupMessageHandler",
    value: function setupMessageHandler() {
      var _this14 = this;

      var messageHandler = this.messageHandler,
          loadingTask = this.loadingTask;
      messageHandler.on("GetReader", function (data, sink) {
        (0, _util.assert)(_this14._networkStream);
        _this14._fullReader = _this14._networkStream.getFullReader();

        _this14._fullReader.onProgress = function (evt) {
          _this14._lastProgress = {
            loaded: evt.loaded,
            total: evt.total
          };
        };

        sink.onPull = function () {
          _this14._fullReader.read().then(function (_ref10) {
            var value = _ref10.value,
                done = _ref10.done;

            if (done) {
              sink.close();
              return;
            }

            (0, _util.assert)((0, _util.isArrayBuffer)(value));
            sink.enqueue(new Uint8Array(value), 1, [value]);
          })["catch"](function (reason) {
            sink.error(reason);
          });
        };

        sink.onCancel = function (reason) {
          _this14._fullReader.cancel(reason);
        };
      });
      messageHandler.on("ReaderHeadersReady", function (data) {
        var headersCapability = (0, _util.createPromiseCapability)();
        var fullReader = _this14._fullReader;
        fullReader.headersReady.then(function () {
          if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
            if (_this14._lastProgress && loadingTask.onProgress) {
              loadingTask.onProgress(_this14._lastProgress);
            }

            fullReader.onProgress = function (evt) {
              if (loadingTask.onProgress) {
                loadingTask.onProgress({
                  loaded: evt.loaded,
                  total: evt.total
                });
              }
            };
          }

          headersCapability.resolve({
            isStreamingSupported: fullReader.isStreamingSupported,
            isRangeSupported: fullReader.isRangeSupported,
            contentLength: fullReader.contentLength
          });
        }, headersCapability.reject);
        return headersCapability.promise;
      });
      messageHandler.on("GetRangeReader", function (data, sink) {
        (0, _util.assert)(_this14._networkStream);

        var rangeReader = _this14._networkStream.getRangeReader(data.begin, data.end);

        if (!rangeReader) {
          sink.close();
          return;
        }

        sink.onPull = function () {
          rangeReader.read().then(function (_ref11) {
            var value = _ref11.value,
                done = _ref11.done;

            if (done) {
              sink.close();
              return;
            }

            (0, _util.assert)((0, _util.isArrayBuffer)(value));
            sink.enqueue(new Uint8Array(value), 1, [value]);
          })["catch"](function (reason) {
            sink.error(reason);
          });
        };

        sink.onCancel = function (reason) {
          rangeReader.cancel(reason);
        };
      });
      messageHandler.on("GetDoc", function (_ref12) {
        var pdfInfo = _ref12.pdfInfo;
        _this14._numPages = pdfInfo.numPages;

        loadingTask._capability.resolve(new PDFDocumentProxy(pdfInfo, _this14));
      });
      messageHandler.on("DocException", function (ex) {
        var reason;

        switch (ex.name) {
          case "PasswordException":
            reason = new _util.PasswordException(ex.message, ex.code);
            break;

          case "InvalidPDFException":
            reason = new _util.InvalidPDFException(ex.message);
            break;

          case "MissingPDFException":
            reason = new _util.MissingPDFException(ex.message);
            break;

          case "UnexpectedResponseException":
            reason = new _util.UnexpectedResponseException(ex.message, ex.status);
            break;

          case "UnknownErrorException":
            reason = new _util.UnknownErrorException(ex.message, ex.details);
            break;
        }

        loadingTask._capability.reject(reason);
      });
      messageHandler.on("PasswordRequest", function (exception) {
        _this14._passwordCapability = (0, _util.createPromiseCapability)();

        if (loadingTask.onPassword) {
          var updatePassword = function updatePassword(password) {
            _this14._passwordCapability.resolve({
              password: password
            });
          };

          try {
            loadingTask.onPassword(updatePassword, exception.code);
          } catch (ex) {
            _this14._passwordCapability.reject(ex);
          }
        } else {
          _this14._passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
        }

        return _this14._passwordCapability.promise;
      });
      messageHandler.on("DataLoaded", function (data) {
        if (loadingTask.onProgress) {
          loadingTask.onProgress({
            loaded: data.length,
            total: data.length
          });
        }

        _this14.downloadInfoCapability.resolve(data);
      });
      messageHandler.on("StartRenderPage", function (data) {
        if (_this14.destroyed) {
          return;
        }

        var page = _this14.pageCache[data.pageIndex];

        page._startRenderPage(data.transparency, data.intent);
      });
      messageHandler.on("commonobj", function (data) {
        if (_this14.destroyed) {
          return;
        }

        var _data = _slicedToArray(data, 3),
            id = _data[0],
            type = _data[1],
            exportedData = _data[2];

        if (_this14.commonObjs.has(id)) {
          return;
        }

        switch (type) {
          case "Font":
            var params = _this14._params;

            if ("error" in exportedData) {
              var exportedError = exportedData.error;
              (0, _util.warn)("Error during font loading: ".concat(exportedError));

              _this14.commonObjs.resolve(id, exportedError);

              break;
            }

            var fontRegistry = null;

            if (params.pdfBug && globalThis.FontInspector && globalThis.FontInspector.enabled) {
              fontRegistry = {
                registerFont: function registerFont(font, url) {
                  globalThis.FontInspector.fontAdded(font, url);
                }
              };
            }

            var font = new _font_loader.FontFaceObject(exportedData, {
              isEvalSupported: params.isEvalSupported,
              disableFontFace: params.disableFontFace,
              ignoreErrors: params.ignoreErrors,
              onUnsupportedFeature: _this14._onUnsupportedFeature.bind(_this14),
              fontRegistry: fontRegistry
            });

            _this14.fontLoader.bind(font).then(function () {
              _this14.commonObjs.resolve(id, font);
            }, function (reason) {
              messageHandler.sendWithPromise("FontFallback", {
                id: id
              })["finally"](function () {
                _this14.commonObjs.resolve(id, font);
              });
            });

            break;

          case "FontPath":
          case "FontType3Res":
            _this14.commonObjs.resolve(id, exportedData);

            break;

          default:
            throw new Error("Got unknown common object type ".concat(type));
        }
      });
      messageHandler.on("obj", function (data) {
        if (_this14.destroyed) {
          return undefined;
        }

        var _data2 = _slicedToArray(data, 4),
            id = _data2[0],
            pageIndex = _data2[1],
            type = _data2[2],
            imageData = _data2[3];

        var pageProxy = _this14.pageCache[pageIndex];

        if (pageProxy.objs.has(id)) {
          return undefined;
        }

        switch (type) {
          case "JpegStream":
            return new Promise(function (resolve, reject) {
              var img = new Image();

              img.onload = function () {
                resolve(img);
              };

              img.onerror = function () {
                reject(new Error("Error during JPEG image loading"));
                (0, _display_utils.releaseImageResources)(img);
              };

              img.src = imageData;
            }).then(function (img) {
              pageProxy.objs.resolve(id, img);
            });

          case "Image":
            pageProxy.objs.resolve(id, imageData);
            var MAX_IMAGE_SIZE_TO_STORE = 8000000;

            if (imageData && "data" in imageData && imageData.data.length > MAX_IMAGE_SIZE_TO_STORE) {
              pageProxy.cleanupAfterRender = true;
            }

            break;

          default:
            throw new Error("Got unknown object type ".concat(type));
        }

        return undefined;
      });
      messageHandler.on("DocProgress", function (data) {
        if (_this14.destroyed) {
          return;
        }

        if (loadingTask.onProgress) {
          loadingTask.onProgress({
            loaded: data.loaded,
            total: data.total
          });
        }
      });
      messageHandler.on("UnsupportedFeature", this._onUnsupportedFeature.bind(this));
      messageHandler.on("JpegDecode", function (data) {
        if (_this14.destroyed) {
          return Promise.reject(new Error("Worker was destroyed"));
        }

        if (typeof document === "undefined") {
          return Promise.reject(new Error('"document" is not defined.'));
        }

        var _data3 = _slicedToArray(data, 2),
            imageUrl = _data3[0],
            components = _data3[1];

        if (components !== 3 && components !== 1) {
          return Promise.reject(new Error("Only 3 components or 1 component can be returned"));
        }

        return new Promise(function (resolve, reject) {
          var img = new Image();

          img.onload = function () {
            var width = img.width,
                height = img.height;
            var size = width * height;
            var rgbaLength = size * 4;
            var buf = new Uint8ClampedArray(size * components);
            var tmpCanvas = document.createElement("canvas");
            tmpCanvas.width = width;
            tmpCanvas.height = height;
            var tmpCtx = tmpCanvas.getContext("2d");
            tmpCtx.drawImage(img, 0, 0);
            var data = tmpCtx.getImageData(0, 0, width, height).data;

            if (components === 3) {
              for (var i = 0, j = 0; i < rgbaLength; i += 4, j += 3) {
                buf[j] = data[i];
                buf[j + 1] = data[i + 1];
                buf[j + 2] = data[i + 2];
              }
            } else if (components === 1) {
              for (var _i2 = 0, _j = 0; _i2 < rgbaLength; _i2 += 4, _j++) {
                buf[_j] = data[_i2];
              }
            }

            resolve({
              data: buf,
              width: width,
              height: height
            });
            (0, _display_utils.releaseImageResources)(img);
            tmpCanvas.width = 0;
            tmpCanvas.height = 0;
            tmpCanvas = null;
            tmpCtx = null;
          };

          img.onerror = function () {
            reject(new Error("JpegDecode failed to load image"));
            (0, _display_utils.releaseImageResources)(img);
          };

          img.src = imageUrl;
        });
      });
      messageHandler.on("FetchBuiltInCMap", function (data, sink) {
        if (_this14.destroyed) {
          sink.error(new Error("Worker was destroyed"));
          return;
        }

        var fetched = false;

        sink.onPull = function () {
          if (fetched) {
            sink.close();
            return;
          }

          fetched = true;

          _this14.CMapReaderFactory.fetch(data).then(function (builtInCMap) {
            sink.enqueue(builtInCMap, 1, [builtInCMap.cMapData.buffer]);
          })["catch"](function (reason) {
            sink.error(reason);
          });
        };
      });
    }
  }, {
    key: "_onUnsupportedFeature",
    value: function _onUnsupportedFeature(_ref13) {
      var featureId = _ref13.featureId;

      if (this.destroyed) {
        return;
      }

      if (this.loadingTask.onUnsupportedFeature) {
        this.loadingTask.onUnsupportedFeature(featureId);
      }
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.messageHandler.sendWithPromise("GetData", null);
    }
  }, {
    key: "getPage",
    value: function getPage(pageNumber) {
      var _this15 = this;

      if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) {
        return Promise.reject(new Error("Invalid page request"));
      }

      var pageIndex = pageNumber - 1;

      if (pageIndex in this.pagePromises) {
        return this.pagePromises[pageIndex];
      }

      var promise = this.messageHandler.sendWithPromise("GetPage", {
        pageIndex: pageIndex
      }).then(function (pageInfo) {
        if (_this15.destroyed) {
          throw new Error("Transport destroyed");
        }

        var page = new PDFPageProxy(pageIndex, pageInfo, _this15, _this15._params.pdfBug);
        _this15.pageCache[pageIndex] = page;
        return page;
      });
      this.pagePromises[pageIndex] = promise;
      return promise;
    }
  }, {
    key: "getPageIndex",
    value: function getPageIndex(ref) {
      return this.messageHandler.sendWithPromise("GetPageIndex", {
        ref: ref
      })["catch"](function (reason) {
        return Promise.reject(new Error(reason));
      });
    }
  }, {
    key: "getAnnotations",
    value: function getAnnotations(pageIndex, intent) {
      return this.messageHandler.sendWithPromise("GetAnnotations", {
        pageIndex: pageIndex,
        intent: intent
      });
    }
  }, {
    key: "getDestinations",
    value: function getDestinations() {
      return this.messageHandler.sendWithPromise("GetDestinations", null);
    }
  }, {
    key: "getDestination",
    value: function getDestination(id) {
      if (typeof id !== "string") {
        return Promise.reject(new Error("Invalid destination request."));
      }

      return this.messageHandler.sendWithPromise("GetDestination", {
        id: id
      });
    }
  }, {
    key: "getPageLabels",
    value: function getPageLabels() {
      return this.messageHandler.sendWithPromise("GetPageLabels", null);
    }
  }, {
    key: "getPageLayout",
    value: function getPageLayout() {
      return this.messageHandler.sendWithPromise("GetPageLayout", null);
    }
  }, {
    key: "getPageMode",
    value: function getPageMode() {
      return this.messageHandler.sendWithPromise("GetPageMode", null);
    }
  }, {
    key: "getViewerPreferences",
    value: function getViewerPreferences() {
      return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
    }
  }, {
    key: "getOpenAction",
    value: function getOpenAction() {
      return this.messageHandler.sendWithPromise("GetOpenAction", null);
    }
  }, {
    key: "getAttachments",
    value: function getAttachments() {
      return this.messageHandler.sendWithPromise("GetAttachments", null);
    }
  }, {
    key: "getJavaScript",
    value: function getJavaScript() {
      return this.messageHandler.sendWithPromise("GetJavaScript", null);
    }
  }, {
    key: "getOutline",
    value: function getOutline() {
      return this.messageHandler.sendWithPromise("GetOutline", null);
    }
  }, {
    key: "getPermissions",
    value: function getPermissions() {
      return this.messageHandler.sendWithPromise("GetPermissions", null);
    }
  }, {
    key: "getMetadata",
    value: function getMetadata() {
      var _this16 = this;

      return this.messageHandler.sendWithPromise("GetMetadata", null).then(function (results) {
        return {
          info: results[0],
          metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
          contentDispositionFilename: _this16._fullReader ? _this16._fullReader.filename : null
        };
      });
    }
  }, {
    key: "getStats",
    value: function getStats() {
      return this.messageHandler.sendWithPromise("GetStats", null);
    }
  }, {
    key: "startCleanup",
    value: function startCleanup() {
      var _this17 = this;

      return this.messageHandler.sendWithPromise("Cleanup", null).then(function () {
        for (var i = 0, ii = _this17.pageCache.length; i < ii; i++) {
          var page = _this17.pageCache[i];

          if (page) {
            var cleanupSuccessful = page.cleanup();

            if (!cleanupSuccessful) {
              throw new Error("startCleanup: Page ".concat(i + 1, " is currently rendering."));
            }
          }
        }

        _this17.commonObjs.clear();

        _this17.fontLoader.clear();
      });
    }
  }, {
    key: "loadingParams",
    get: function get() {
      var params = this._params;
      return (0, _util.shadow)(this, "loadingParams", {
        disableAutoFetch: params.disableAutoFetch,
        disableCreateObjectURL: params.disableCreateObjectURL,
        disableFontFace: params.disableFontFace,
        nativeImageDecoderSupport: params.nativeImageDecoderSupport
      });
    }
  }]);

  return WorkerTransport;
}();

var PDFObjects = /*#__PURE__*/function () {
  function PDFObjects() {
    _classCallCheck(this, PDFObjects);

    this._objs = Object.create(null);
  }

  _createClass(PDFObjects, [{
    key: "_ensureObj",
    value: function _ensureObj(objId) {
      if (this._objs[objId]) {
        return this._objs[objId];
      }

      return this._objs[objId] = {
        capability: (0, _util.createPromiseCapability)(),
        data: null,
        resolved: false
      };
    }
  }, {
    key: "get",
    value: function get(objId) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (callback) {
        this._ensureObj(objId).capability.promise.then(callback);

        return null;
      }

      var obj = this._objs[objId];

      if (!obj || !obj.resolved) {
        throw new Error("Requesting object that isn't resolved yet ".concat(objId, "."));
      }

      return obj.data;
    }
  }, {
    key: "has",
    value: function has(objId) {
      var obj = this._objs[objId];
      return obj ? obj.resolved : false;
    }
  }, {
    key: "resolve",
    value: function resolve(objId, data) {
      var obj = this._ensureObj(objId);

      obj.resolved = true;
      obj.data = data;
      obj.capability.resolve(data);
    }
  }, {
    key: "clear",
    value: function clear() {
      for (var objId in this._objs) {
        var data = this._objs[objId].data;

        if (typeof Image !== "undefined" && data instanceof Image) {
          (0, _display_utils.releaseImageResources)(data);
        }
      }

      this._objs = Object.create(null);
    }
  }]);

  return PDFObjects;
}();

var RenderTask = /*#__PURE__*/function () {
  function RenderTask(internalRenderTask) {
    _classCallCheck(this, RenderTask);

    this._internalRenderTask = internalRenderTask;
    this.onContinue = null;
  }

  _createClass(RenderTask, [{
    key: "cancel",
    value: function cancel() {
      this._internalRenderTask.cancel();
    }
  }, {
    key: "then",
    value: function then(onFulfilled, onRejected) {
      throw new Error("Removed API method: " + "RenderTask.then, use the `promise` getter instead.");
    }
  }, {
    key: "promise",
    get: function get() {
      return this._internalRenderTask.capability.promise;
    }
  }]);

  return RenderTask;
}();

var InternalRenderTask = function InternalRenderTaskClosure() {
  var canvasInRendering = new WeakSet();

  var InternalRenderTask = /*#__PURE__*/function () {
    function InternalRenderTask(_ref14) {
      var callback = _ref14.callback,
          params = _ref14.params,
          objs = _ref14.objs,
          commonObjs = _ref14.commonObjs,
          operatorList = _ref14.operatorList,
          pageIndex = _ref14.pageIndex,
          canvasFactory = _ref14.canvasFactory,
          webGLContext = _ref14.webGLContext,
          _ref14$useRequestAnim = _ref14.useRequestAnimationFrame,
          useRequestAnimationFrame = _ref14$useRequestAnim === void 0 ? false : _ref14$useRequestAnim,
          _ref14$pdfBug = _ref14.pdfBug,
          pdfBug = _ref14$pdfBug === void 0 ? false : _ref14$pdfBug;

      _classCallCheck(this, InternalRenderTask);

      this.callback = callback;
      this.params = params;
      this.objs = objs;
      this.commonObjs = commonObjs;
      this.operatorListIdx = null;
      this.operatorList = operatorList;
      this._pageIndex = pageIndex;
      this.canvasFactory = canvasFactory;
      this.webGLContext = webGLContext;
      this._pdfBug = pdfBug;
      this.running = false;
      this.graphicsReadyCallback = null;
      this.graphicsReady = false;
      this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
      this.cancelled = false;
      this.capability = (0, _util.createPromiseCapability)();
      this.task = new RenderTask(this);
      this._continueBound = this._continue.bind(this);
      this._scheduleNextBound = this._scheduleNext.bind(this);
      this._nextBound = this._next.bind(this);
      this._canvas = params.canvasContext.canvas;
    }

    _createClass(InternalRenderTask, [{
      key: "initializeGraphics",
      value: function initializeGraphics() {
        var transparency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (this.cancelled) {
          return;
        }

        if (this._canvas) {
          if (canvasInRendering.has(this._canvas)) {
            throw new Error("Cannot use the same canvas during multiple render() operations. " + "Use different canvas or ensure previous operations were " + "cancelled or completed.");
          }

          canvasInRendering.add(this._canvas);
        }

        if (this._pdfBug && globalThis.StepperManager && globalThis.StepperManager.enabled) {
          this.stepper = globalThis.StepperManager.create(this._pageIndex);
          this.stepper.init(this.operatorList);
          this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
        }

        var _this$params = this.params,
            canvasContext = _this$params.canvasContext,
            viewport = _this$params.viewport,
            transform = _this$params.transform,
            imageLayer = _this$params.imageLayer,
            background = _this$params.background;
        this.gfx = new _canvas.CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.webGLContext, imageLayer);
        this.gfx.beginDrawing({
          transform: transform,
          viewport: viewport,
          transparency: transparency,
          background: background
        });
        this.operatorListIdx = 0;
        this.graphicsReady = true;

        if (this.graphicsReadyCallback) {
          this.graphicsReadyCallback();
        }
      }
    }, {
      key: "cancel",
      value: function cancel() {
        var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        this.running = false;
        this.cancelled = true;

        if (this.gfx) {
          this.gfx.endDrawing();
        }

        if (this._canvas) {
          canvasInRendering["delete"](this._canvas);
        }

        this.callback(error || new _display_utils.RenderingCancelledException("Rendering cancelled, page ".concat(this._pageIndex + 1), "canvas"));
      }
    }, {
      key: "operatorListChanged",
      value: function operatorListChanged() {
        if (!this.graphicsReady) {
          if (!this.graphicsReadyCallback) {
            this.graphicsReadyCallback = this._continueBound;
          }

          return;
        }

        if (this.stepper) {
          this.stepper.updateOperatorList(this.operatorList);
        }

        if (this.running) {
          return;
        }

        this._continue();
      }
    }, {
      key: "_continue",
      value: function _continue() {
        this.running = true;

        if (this.cancelled) {
          return;
        }

        if (this.task.onContinue) {
          this.task.onContinue(this._scheduleNextBound);
        } else {
          this._scheduleNext();
        }
      }
    }, {
      key: "_scheduleNext",
      value: function _scheduleNext() {
        var _this18 = this;

        if (this._useRequestAnimationFrame) {
          window.requestAnimationFrame(function () {
            _this18._nextBound()["catch"](_this18.cancel.bind(_this18));
          });
        } else {
          Promise.resolve().then(this._nextBound)["catch"](this.cancel.bind(this));
        }
      }
    }, {
      key: "_next",
      value: function () {
        var _next2 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
          return _regenerator["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!this.cancelled) {
                    _context2.next = 2;
                    break;
                  }

                  return _context2.abrupt("return");

                case 2:
                  this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);

                  if (this.operatorListIdx === this.operatorList.argsArray.length) {
                    this.running = false;

                    if (this.operatorList.lastChunk) {
                      this.gfx.endDrawing();

                      if (this._canvas) {
                        canvasInRendering["delete"](this._canvas);
                      }

                      this.callback();
                    }
                  }

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function _next() {
          return _next2.apply(this, arguments);
        }

        return _next;
      }()
    }]);

    return InternalRenderTask;
  }();

  return InternalRenderTask;
}();

var version = '2.4.456';
exports.version = version;
var build = '228a591c';
exports.build = build;

/***/ }),
/* 191 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = __w_pdfjs_require__(192);

/***/ }),
/* 192 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var runtime = function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined;
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);
    generator._invoke = makeInvokeMethod(innerFn, self, context);
    return generator;
  }

  exports.wrap = wrap;

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};

  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      prototype[method] = function (arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction || (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };

  exports.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;

      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }

    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  exports.awrap = function (arg) {
    return {
      __await: arg
    };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;

        if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped;
          resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }

    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);

  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };

  exports.AsyncIterator = AsyncIterator;

  exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;
    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;

        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);

          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;
        var record = tryCatch(innerFn, self, context);

        if (record.type === "normal") {
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted;
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (method === undefined) {
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator["return"]) {
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      context[delegate.resultName] = info.value;
      context.next = delegate.nextLoc;

      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      return info;
    }

    context.delegate = null;
    return ContinueSentinel;
  }

  defineIteratorMethods(Gp);
  Gp[toStringTagSymbol] = "Generator";

  Gp[iteratorSymbol] = function () {
    return this;
  };

  Gp.toString = function () {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    keys.reverse();
    return function next() {
      while (keys.length) {
        var key = keys.pop();

        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];

      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;
          return next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  exports.values = values;

  function doneResult() {
    return {
      value: undefined,
      done: true
    };
  }

  Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;
      this.method = "next";
      this.arg = undefined;
      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },
    stop: function stop() {
      this.done = true;
      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;

      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;

      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          context.method = "next";
          context.arg = undefined;
        }

        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
  return exports;
}(( false ? undefined : _typeof(module)) === "object" ? module.exports : {});

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  Function("r", "regeneratorRuntime = r")(runtime);
}
/* WEBPACK VAR INJECTION */}.call(this, __w_pdfjs_require__(193)(module)))

/***/ }),
/* 193 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (module) {
  if (!module.webpackPolyfill) {
    module.deprecate = function () {};

    module.paths = [];
    if (!module.children) module.children = [];
    Object.defineProperty(module, "loaded", {
      enumerable: true,
      get: function get() {
        return module.l;
      }
    });
    Object.defineProperty(module, "id", {
      enumerable: true,
      get: function get() {
        return module.i;
      }
    });
    module.webpackPolyfill = 1;
  }

  return module;
};

/***/ }),
/* 194 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addLinkAttributes = addLinkAttributes;
exports.getFilenameFromUrl = getFilenameFromUrl;
exports.isFetchSupported = isFetchSupported;
exports.isValidFetchUrl = isValidFetchUrl;
exports.loadScript = loadScript;
exports.deprecated = deprecated;
exports.releaseImageResources = releaseImageResources;
exports.PDFDateString = exports.StatTimer = exports.DOMSVGFactory = exports.DOMCMapReaderFactory = exports.DOMCanvasFactory = exports.DEFAULT_LINK_REL = exports.LinkTarget = exports.RenderingCancelledException = exports.PageViewport = void 0;

var _regenerator = _interopRequireDefault(__w_pdfjs_require__(191));

var _util = __w_pdfjs_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DEFAULT_LINK_REL = "noopener noreferrer nofollow";
exports.DEFAULT_LINK_REL = DEFAULT_LINK_REL;
var SVG_NS = "http://www.w3.org/2000/svg";

var DOMCanvasFactory = /*#__PURE__*/function () {
  function DOMCanvasFactory() {
    _classCallCheck(this, DOMCanvasFactory);
  }

  _createClass(DOMCanvasFactory, [{
    key: "create",
    value: function create(width, height) {
      if (width <= 0 || height <= 0) {
        throw new Error("Invalid canvas size");
      }

      var canvas = document.createElement("canvas");
      var context = canvas.getContext("2d");
      canvas.width = width;
      canvas.height = height;
      return {
        canvas: canvas,
        context: context
      };
    }
  }, {
    key: "reset",
    value: function reset(canvasAndContext, width, height) {
      if (!canvasAndContext.canvas) {
        throw new Error("Canvas is not specified");
      }

      if (width <= 0 || height <= 0) {
        throw new Error("Invalid canvas size");
      }

      canvasAndContext.canvas.width = width;
      canvasAndContext.canvas.height = height;
    }
  }, {
    key: "destroy",
    value: function destroy(canvasAndContext) {
      if (!canvasAndContext.canvas) {
        throw new Error("Canvas is not specified");
      }

      canvasAndContext.canvas.width = 0;
      canvasAndContext.canvas.height = 0;
      canvasAndContext.canvas = null;
      canvasAndContext.context = null;
    }
  }]);

  return DOMCanvasFactory;
}();

exports.DOMCanvasFactory = DOMCanvasFactory;

var DOMCMapReaderFactory = /*#__PURE__*/function () {
  function DOMCMapReaderFactory(_ref) {
    var _ref$baseUrl = _ref.baseUrl,
        baseUrl = _ref$baseUrl === void 0 ? null : _ref$baseUrl,
        _ref$isCompressed = _ref.isCompressed,
        isCompressed = _ref$isCompressed === void 0 ? false : _ref$isCompressed;

    _classCallCheck(this, DOMCMapReaderFactory);

    this.baseUrl = baseUrl;
    this.isCompressed = isCompressed;
  }

  _createClass(DOMCMapReaderFactory, [{
    key: "fetch",
    value: function (_fetch) {
      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref3) {
        var _this = this;

        var name, url, compressionType;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                name = _ref3.name;

                if (this.baseUrl) {
                  _context2.next = 3;
                  break;
                }

                throw new Error('The CMap "baseUrl" parameter must be specified, ensure that ' + 'the "cMapUrl" and "cMapPacked" API parameters are provided.');

              case 3:
                if (name) {
                  _context2.next = 5;
                  break;
                }

                throw new Error("CMap name must be specified.");

              case 5:
                url = this.baseUrl + name + (this.isCompressed ? ".bcmap" : "");
                compressionType = this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE;

                if (!(isFetchSupported() && isValidFetchUrl(url, document.baseURI))) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", fetch(url).then( /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(response) {
                    var cMapData;
                    return _regenerator["default"].wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (response.ok) {
                              _context.next = 2;
                              break;
                            }

                            throw new Error(response.statusText);

                          case 2:
                            if (!_this.isCompressed) {
                              _context.next = 10;
                              break;
                            }

                            _context.t0 = Uint8Array;
                            _context.next = 6;
                            return response.arrayBuffer();

                          case 6:
                            _context.t1 = _context.sent;
                            cMapData = new _context.t0(_context.t1);
                            _context.next = 15;
                            break;

                          case 10:
                            _context.t2 = _util.stringToBytes;
                            _context.next = 13;
                            return response.text();

                          case 13:
                            _context.t3 = _context.sent;
                            cMapData = (0, _context.t2)(_context.t3);

                          case 15:
                            return _context.abrupt("return", {
                              cMapData: cMapData,
                              compressionType: compressionType
                            });

                          case 16:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x3) {
                    return _ref4.apply(this, arguments);
                  };
                }())["catch"](function (reason) {
                  throw new Error("Unable to load ".concat(_this.isCompressed ? "binary " : "") + "CMap at: ".concat(url));
                }));

              case 9:
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  var request = new XMLHttpRequest();
                  request.open("GET", url, true);

                  if (_this.isCompressed) {
                    request.responseType = "arraybuffer";
                  }

                  request.onreadystatechange = function () {
                    if (request.readyState !== XMLHttpRequest.DONE) {
                      return;
                    }

                    if (request.status === 200 || request.status === 0) {
                      var cMapData;

                      if (_this.isCompressed && request.response) {
                        cMapData = new Uint8Array(request.response);
                      } else if (!_this.isCompressed && request.responseText) {
                        cMapData = (0, _util.stringToBytes)(request.responseText);
                      }

                      if (cMapData) {
                        resolve({
                          cMapData: cMapData,
                          compressionType: compressionType
                        });
                        return;
                      }
                    }

                    reject(new Error(request.statusText));
                  };

                  request.send(null);
                })["catch"](function (reason) {
                  throw new Error("Unable to load ".concat(_this.isCompressed ? "binary " : "") + "CMap at: ".concat(url));
                }));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }())
  }]);

  return DOMCMapReaderFactory;
}();

exports.DOMCMapReaderFactory = DOMCMapReaderFactory;

var DOMSVGFactory = /*#__PURE__*/function () {
  function DOMSVGFactory() {
    _classCallCheck(this, DOMSVGFactory);
  }

  _createClass(DOMSVGFactory, [{
    key: "create",
    value: function create(width, height) {
      (0, _util.assert)(width > 0 && height > 0, "Invalid SVG dimensions");
      var svg = document.createElementNS(SVG_NS, "svg:svg");
      svg.setAttribute("version", "1.1");
      svg.setAttribute("width", width + "px");
      svg.setAttribute("height", height + "px");
      svg.setAttribute("preserveAspectRatio", "none");
      svg.setAttribute("viewBox", "0 0 " + width + " " + height);
      return svg;
    }
  }, {
    key: "createElement",
    value: function createElement(type) {
      (0, _util.assert)(typeof type === "string", "Invalid SVG element type");
      return document.createElementNS(SVG_NS, type);
    }
  }]);

  return DOMSVGFactory;
}();

exports.DOMSVGFactory = DOMSVGFactory;

var PageViewport = /*#__PURE__*/function () {
  function PageViewport(_ref5) {
    var viewBox = _ref5.viewBox,
        scale = _ref5.scale,
        rotation = _ref5.rotation,
        _ref5$offsetX = _ref5.offsetX,
        offsetX = _ref5$offsetX === void 0 ? 0 : _ref5$offsetX,
        _ref5$offsetY = _ref5.offsetY,
        offsetY = _ref5$offsetY === void 0 ? 0 : _ref5$offsetY,
        _ref5$dontFlip = _ref5.dontFlip,
        dontFlip = _ref5$dontFlip === void 0 ? false : _ref5$dontFlip;

    _classCallCheck(this, PageViewport);

    this.viewBox = viewBox;
    this.scale = scale;
    this.rotation = rotation;
    this.offsetX = offsetX;
    this.offsetY = offsetY;
    var centerX = (viewBox[2] + viewBox[0]) / 2;
    var centerY = (viewBox[3] + viewBox[1]) / 2;
    var rotateA, rotateB, rotateC, rotateD;
    rotation = rotation % 360;
    rotation = rotation < 0 ? rotation + 360 : rotation;

    switch (rotation) {
      case 180:
        rotateA = -1;
        rotateB = 0;
        rotateC = 0;
        rotateD = 1;
        break;

      case 90:
        rotateA = 0;
        rotateB = 1;
        rotateC = 1;
        rotateD = 0;
        break;

      case 270:
        rotateA = 0;
        rotateB = -1;
        rotateC = -1;
        rotateD = 0;
        break;

      default:
        rotateA = 1;
        rotateB = 0;
        rotateC = 0;
        rotateD = -1;
        break;
    }

    if (dontFlip) {
      rotateC = -rotateC;
      rotateD = -rotateD;
    }

    var offsetCanvasX, offsetCanvasY;
    var width, height;

    if (rotateA === 0) {
      offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
      offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
      width = Math.abs(viewBox[3] - viewBox[1]) * scale;
      height = Math.abs(viewBox[2] - viewBox[0]) * scale;
    } else {
      offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
      offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
      width = Math.abs(viewBox[2] - viewBox[0]) * scale;
      height = Math.abs(viewBox[3] - viewBox[1]) * scale;
    }

    this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
    this.width = width;
    this.height = height;
  }

  _createClass(PageViewport, [{
    key: "clone",
    value: function clone() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref6$scale = _ref6.scale,
          scale = _ref6$scale === void 0 ? this.scale : _ref6$scale,
          _ref6$rotation = _ref6.rotation,
          rotation = _ref6$rotation === void 0 ? this.rotation : _ref6$rotation,
          _ref6$offsetX = _ref6.offsetX,
          offsetX = _ref6$offsetX === void 0 ? this.offsetX : _ref6$offsetX,
          _ref6$offsetY = _ref6.offsetY,
          offsetY = _ref6$offsetY === void 0 ? this.offsetY : _ref6$offsetY,
          _ref6$dontFlip = _ref6.dontFlip,
          dontFlip = _ref6$dontFlip === void 0 ? false : _ref6$dontFlip;

      return new PageViewport({
        viewBox: this.viewBox.slice(),
        scale: scale,
        rotation: rotation,
        offsetX: offsetX,
        offsetY: offsetY,
        dontFlip: dontFlip
      });
    }
  }, {
    key: "convertToViewportPoint",
    value: function convertToViewportPoint(x, y) {
      return _util.Util.applyTransform([x, y], this.transform);
    }
  }, {
    key: "convertToViewportRectangle",
    value: function convertToViewportRectangle(rect) {
      var topLeft = _util.Util.applyTransform([rect[0], rect[1]], this.transform);

      var bottomRight = _util.Util.applyTransform([rect[2], rect[3]], this.transform);

      return [topLeft[0], topLeft[1], bottomRight[0], bottomRight[1]];
    }
  }, {
    key: "convertToPdfPoint",
    value: function convertToPdfPoint(x, y) {
      return _util.Util.applyInverseTransform([x, y], this.transform);
    }
  }]);

  return PageViewport;
}();

exports.PageViewport = PageViewport;

var RenderingCancelledException = /*#__PURE__*/function (_BaseException) {
  _inherits(RenderingCancelledException, _BaseException);

  function RenderingCancelledException(msg, type) {
    var _this2;

    _classCallCheck(this, RenderingCancelledException);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(RenderingCancelledException).call(this, msg));
    _this2.type = type;
    return _this2;
  }

  return RenderingCancelledException;
}(_util.BaseException);

exports.RenderingCancelledException = RenderingCancelledException;
var LinkTarget = {
  NONE: 0,
  SELF: 1,
  BLANK: 2,
  PARENT: 3,
  TOP: 4
};
exports.LinkTarget = LinkTarget;

function addLinkAttributes(link) {
  var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      url = _ref7.url,
      target = _ref7.target,
      rel = _ref7.rel,
      _ref7$enabled = _ref7.enabled,
      enabled = _ref7$enabled === void 0 ? true : _ref7$enabled;

  (0, _util.assert)(url && typeof url === "string", 'addLinkAttributes: A valid "url" parameter must provided.');
  var urlNullRemoved = (0, _util.removeNullCharacters)(url);

  if (enabled) {
    link.href = link.title = urlNullRemoved;
  } else {
    link.href = "";
    link.title = "Disabled: ".concat(urlNullRemoved);

    link.onclick = function () {
      return false;
    };
  }

  var targetStr = "";

  switch (target) {
    case LinkTarget.NONE:
      break;

    case LinkTarget.SELF:
      targetStr = "_self";
      break;

    case LinkTarget.BLANK:
      targetStr = "_blank";
      break;

    case LinkTarget.PARENT:
      targetStr = "_parent";
      break;

    case LinkTarget.TOP:
      targetStr = "_top";
      break;
  }

  link.target = targetStr;
  link.rel = typeof rel === "string" ? rel : DEFAULT_LINK_REL;
}

function getFilenameFromUrl(url) {
  var anchor = url.indexOf("#");
  var query = url.indexOf("?");
  var end = Math.min(anchor > 0 ? anchor : url.length, query > 0 ? query : url.length);
  return url.substring(url.lastIndexOf("/", end) + 1, end);
}

var StatTimer = /*#__PURE__*/function () {
  function StatTimer() {
    _classCallCheck(this, StatTimer);

    this.started = Object.create(null);
    this.times = [];
  }

  _createClass(StatTimer, [{
    key: "time",
    value: function time(name) {
      if (name in this.started) {
        (0, _util.warn)("Timer is already running for ".concat(name));
      }

      this.started[name] = Date.now();
    }
  }, {
    key: "timeEnd",
    value: function timeEnd(name) {
      if (!(name in this.started)) {
        (0, _util.warn)("Timer has not been started for ".concat(name));
      }

      this.times.push({
        name: name,
        start: this.started[name],
        end: Date.now()
      });
      delete this.started[name];
    }
  }, {
    key: "toString",
    value: function toString() {
      var outBuf = [];
      var longest = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.times[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var time = _step.value;
          var name = time.name;

          if (name.length > longest) {
            longest = name.length;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.times[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _time = _step2.value;
          var duration = _time.end - _time.start;
          outBuf.push("".concat(_time.name.padEnd(longest), " ").concat(duration, "ms\n"));
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return outBuf.join("");
    }
  }]);

  return StatTimer;
}();

exports.StatTimer = StatTimer;

function isFetchSupported() {
  return typeof fetch !== "undefined" && typeof Response !== "undefined" && "body" in Response.prototype && typeof ReadableStream !== "undefined";
}

function isValidFetchUrl(url, baseUrl) {
  try {
    var _ref8 = baseUrl ? new URL(url, baseUrl) : new URL(url),
        protocol = _ref8.protocol;

    return protocol === "http:" || protocol === "https:";
  } catch (ex) {
    return false;
  }
}

function loadScript(src) {
  return new Promise(function (resolve, reject) {
    var script = document.createElement("script");
    script.src = src;
    script.onload = resolve;

    script.onerror = function () {
      reject(new Error("Cannot load script at: ".concat(script.src)));
    };

    (document.head || document.documentElement).appendChild(script);
  });
}

function deprecated(details) {
  console.log("Deprecated API usage: " + details);
}

function releaseImageResources(img) {
  (0, _util.assert)(img instanceof Image, "Invalid `img` parameter.");
  var url = img.src;

  if (typeof url === "string" && url.startsWith("blob:") && URL.revokeObjectURL) {
    URL.revokeObjectURL(url);
  }

  img.removeAttribute("src");
}

var pdfDateStringRegex;

var PDFDateString = /*#__PURE__*/function () {
  function PDFDateString() {
    _classCallCheck(this, PDFDateString);
  }

  _createClass(PDFDateString, null, [{
    key: "toDateObject",
    value: function toDateObject(input) {
      if (!input || !(0, _util.isString)(input)) {
        return null;
      }

      if (!pdfDateStringRegex) {
        pdfDateStringRegex = new RegExp("^D:" + "(\\d{4})" + "(\\d{2})?" + "(\\d{2})?" + "(\\d{2})?" + "(\\d{2})?" + "(\\d{2})?" + "([Z|+|-])?" + "(\\d{2})?" + "'?" + "(\\d{2})?" + "'?");
      }

      var matches = pdfDateStringRegex.exec(input);

      if (!matches) {
        return null;
      }

      var year = parseInt(matches[1], 10);
      var month = parseInt(matches[2], 10);
      month = month >= 1 && month <= 12 ? month - 1 : 0;
      var day = parseInt(matches[3], 10);
      day = day >= 1 && day <= 31 ? day : 1;
      var hour = parseInt(matches[4], 10);
      hour = hour >= 0 && hour <= 23 ? hour : 0;
      var minute = parseInt(matches[5], 10);
      minute = minute >= 0 && minute <= 59 ? minute : 0;
      var second = parseInt(matches[6], 10);
      second = second >= 0 && second <= 59 ? second : 0;
      var universalTimeRelation = matches[7] || "Z";
      var offsetHour = parseInt(matches[8], 10);
      offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
      var offsetMinute = parseInt(matches[9], 10) || 0;
      offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;

      if (universalTimeRelation === "-") {
        hour += offsetHour;
        minute += offsetMinute;
      } else if (universalTimeRelation === "+") {
        hour -= offsetHour;
        minute -= offsetMinute;
      }

      return new Date(Date.UTC(year, month, day, hour, minute, second));
    }
  }]);

  return PDFDateString;
}();

exports.PDFDateString = PDFDateString;

/***/ }),
/* 195 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontLoader = exports.FontFaceObject = void 0;

var _regenerator = _interopRequireDefault(__w_pdfjs_require__(191));

var _util = __w_pdfjs_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var BaseFontLoader = /*#__PURE__*/function () {
  function BaseFontLoader(_ref) {
    var docId = _ref.docId,
        onUnsupportedFeature = _ref.onUnsupportedFeature;

    _classCallCheck(this, BaseFontLoader);

    if (this.constructor === BaseFontLoader) {
      (0, _util.unreachable)("Cannot initialize BaseFontLoader.");
    }

    this.docId = docId;
    this._onUnsupportedFeature = onUnsupportedFeature;
    this.nativeFontFaces = [];
    this.styleElement = null;
  }

  _createClass(BaseFontLoader, [{
    key: "addNativeFontFace",
    value: function addNativeFontFace(nativeFontFace) {
      this.nativeFontFaces.push(nativeFontFace);
      document.fonts.add(nativeFontFace);
    }
  }, {
    key: "insertRule",
    value: function insertRule(rule) {
      var styleElement = this.styleElement;

      if (!styleElement) {
        styleElement = this.styleElement = document.createElement("style");
        styleElement.id = "PDFJS_FONT_STYLE_TAG_".concat(this.docId);
        document.documentElement.getElementsByTagName("head")[0].appendChild(styleElement);
      }

      var styleSheet = styleElement.sheet;
      styleSheet.insertRule(rule, styleSheet.cssRules.length);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.nativeFontFaces.forEach(function (nativeFontFace) {
        document.fonts["delete"](nativeFontFace);
      });
      this.nativeFontFaces.length = 0;

      if (this.styleElement) {
        this.styleElement.remove();
        this.styleElement = null;
      }
    }
  }, {
    key: "bind",
    value: function () {
      var _bind = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(font) {
        var _this = this;

        var nativeFontFace, rule;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(font.attached || font.missingFile)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                font.attached = true;

                if (!this.isFontLoadingAPISupported) {
                  _context.next = 19;
                  break;
                }

                nativeFontFace = font.createNativeFontFace();

                if (!nativeFontFace) {
                  _context.next = 18;
                  break;
                }

                this.addNativeFontFace(nativeFontFace);
                _context.prev = 7;
                _context.next = 10;
                return nativeFontFace.loaded;

              case 10:
                _context.next = 18;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](7);

                this._onUnsupportedFeature({
                  featureId: _util.UNSUPPORTED_FEATURES.font
                });

                (0, _util.warn)("Failed to load font '".concat(nativeFontFace.family, "': '").concat(_context.t0, "'."));
                font.disableFontFace = true;
                throw _context.t0;

              case 18:
                return _context.abrupt("return");

              case 19:
                rule = font.createFontFaceRule();

                if (!rule) {
                  _context.next = 26;
                  break;
                }

                this.insertRule(rule);

                if (!this.isSyncFontLoadingSupported) {
                  _context.next = 24;
                  break;
                }

                return _context.abrupt("return");

              case 24:
                _context.next = 26;
                return new Promise(function (resolve) {
                  var request = _this._queueLoadingCallback(resolve);

                  _this._prepareFontLoadEvent([rule], [font], request);
                });

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 12]]);
      }));

      function bind(_x) {
        return _bind.apply(this, arguments);
      }

      return bind;
    }()
  }, {
    key: "_queueLoadingCallback",
    value: function _queueLoadingCallback(callback) {
      (0, _util.unreachable)("Abstract method `_queueLoadingCallback`.");
    }
  }, {
    key: "_prepareFontLoadEvent",
    value: function _prepareFontLoadEvent(rules, fontsToLoad, request) {
      (0, _util.unreachable)("Abstract method `_prepareFontLoadEvent`.");
    }
  }, {
    key: "isFontLoadingAPISupported",
    get: function get() {
      var supported = typeof document !== "undefined" && !!document.fonts;
      return (0, _util.shadow)(this, "isFontLoadingAPISupported", supported);
    }
  }, {
    key: "isSyncFontLoadingSupported",
    get: function get() {
      (0, _util.unreachable)("Abstract method `isSyncFontLoadingSupported`.");
    }
  }, {
    key: "_loadTestFont",
    get: function get() {
      (0, _util.unreachable)("Abstract method `_loadTestFont`.");
    }
  }]);

  return BaseFontLoader;
}();

var FontLoader;
exports.FontLoader = FontLoader;
{
  exports.FontLoader = FontLoader = /*#__PURE__*/function (_BaseFontLoader) {
    _inherits(GenericFontLoader, _BaseFontLoader);

    function GenericFontLoader(docId) {
      var _this2;

      _classCallCheck(this, GenericFontLoader);

      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(GenericFontLoader).call(this, docId));
      _this2.loadingContext = {
        requests: [],
        nextRequestId: 0
      };
      _this2.loadTestFontId = 0;
      return _this2;
    }

    _createClass(GenericFontLoader, [{
      key: "_queueLoadingCallback",
      value: function _queueLoadingCallback(callback) {
        function completeRequest() {
          (0, _util.assert)(!request.done, "completeRequest() cannot be called twice.");
          request.done = true;

          while (context.requests.length > 0 && context.requests[0].done) {
            var otherRequest = context.requests.shift();
            setTimeout(otherRequest.callback, 0);
          }
        }

        var context = this.loadingContext;
        var request = {
          id: "pdfjs-font-loading-".concat(context.nextRequestId++),
          done: false,
          complete: completeRequest,
          callback: callback
        };
        context.requests.push(request);
        return request;
      }
    }, {
      key: "_prepareFontLoadEvent",
      value: function _prepareFontLoadEvent(rules, fonts, request) {
        function int32(data, offset) {
          return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
        }

        function spliceString(s, offset, remove, insert) {
          var chunk1 = s.substring(0, offset);
          var chunk2 = s.substring(offset + remove);
          return chunk1 + insert + chunk2;
        }

        var i, ii;
        var canvas = document.createElement("canvas");
        canvas.width = 1;
        canvas.height = 1;
        var ctx = canvas.getContext("2d");
        var called = 0;

        function isFontReady(name, callback) {
          called++;

          if (called > 30) {
            (0, _util.warn)("Load test font never loaded.");
            callback();
            return;
          }

          ctx.font = "30px " + name;
          ctx.fillText(".", 0, 20);
          var imageData = ctx.getImageData(0, 0, 1, 1);

          if (imageData.data[3] > 0) {
            callback();
            return;
          }

          setTimeout(isFontReady.bind(null, name, callback));
        }

        var loadTestFontId = "lt".concat(Date.now()).concat(this.loadTestFontId++);
        var data = this._loadTestFont;
        var COMMENT_OFFSET = 976;
        data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
        var CFF_CHECKSUM_OFFSET = 16;
        var XXXX_VALUE = 0x58585858;
        var checksum = int32(data, CFF_CHECKSUM_OFFSET);

        for (i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4) {
          checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
        }

        if (i < loadTestFontId.length) {
          checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
        }

        data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
        var url = "url(data:font/opentype;base64,".concat(btoa(data), ");");
        var rule = "@font-face {font-family:\"".concat(loadTestFontId, "\";src:").concat(url, "}");
        this.insertRule(rule);
        var names = [];

        for (i = 0, ii = fonts.length; i < ii; i++) {
          names.push(fonts[i].loadedName);
        }

        names.push(loadTestFontId);
        var div = document.createElement("div");
        div.style.visibility = "hidden";
        div.style.width = div.style.height = "10px";
        div.style.position = "absolute";
        div.style.top = div.style.left = "0px";

        for (i = 0, ii = names.length; i < ii; ++i) {
          var span = document.createElement("span");
          span.textContent = "Hi";
          span.style.fontFamily = names[i];
          div.appendChild(span);
        }

        document.body.appendChild(div);
        isFontReady(loadTestFontId, function () {
          document.body.removeChild(div);
          request.complete();
        });
      }
    }, {
      key: "isSyncFontLoadingSupported",
      get: function get() {
        var supported = false;

        if (typeof navigator === "undefined") {
          supported = true;
        } else {
          var m = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);

          if (m && m[1] >= 14) {
            supported = true;
          }
        }

        return (0, _util.shadow)(this, "isSyncFontLoadingSupported", supported);
      }
    }, {
      key: "_loadTestFont",
      get: function get() {
        var getLoadTestFont = function getLoadTestFont() {
          return atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQA" + "FQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAA" + "ALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgA" + "AAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1" + "AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD" + "6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACM" + "AooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4D" + "IP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAA" + "AAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUA" + "AQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgAB" + "AAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABY" + "AAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAA" + "AC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAA" + "AAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQAC" + "AQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3" + "Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTj" + "FQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
        };

        return (0, _util.shadow)(this, "_loadTestFont", getLoadTestFont());
      }
    }]);

    return GenericFontLoader;
  }(BaseFontLoader);
}

var FontFaceObject = /*#__PURE__*/function () {
  function FontFaceObject(translatedData, _ref2) {
    var _ref2$isEvalSupported = _ref2.isEvalSupported,
        isEvalSupported = _ref2$isEvalSupported === void 0 ? true : _ref2$isEvalSupported,
        _ref2$disableFontFace = _ref2.disableFontFace,
        disableFontFace = _ref2$disableFontFace === void 0 ? false : _ref2$disableFontFace,
        _ref2$ignoreErrors = _ref2.ignoreErrors,
        ignoreErrors = _ref2$ignoreErrors === void 0 ? false : _ref2$ignoreErrors,
        _ref2$onUnsupportedFe = _ref2.onUnsupportedFeature,
        onUnsupportedFeature = _ref2$onUnsupportedFe === void 0 ? null : _ref2$onUnsupportedFe,
        _ref2$fontRegistry = _ref2.fontRegistry,
        fontRegistry = _ref2$fontRegistry === void 0 ? null : _ref2$fontRegistry;

    _classCallCheck(this, FontFaceObject);

    this.compiledGlyphs = Object.create(null);

    for (var i in translatedData) {
      this[i] = translatedData[i];
    }

    this.isEvalSupported = isEvalSupported !== false;
    this.disableFontFace = disableFontFace === true;
    this.ignoreErrors = ignoreErrors === true;
    this._onUnsupportedFeature = onUnsupportedFeature;
    this.fontRegistry = fontRegistry;
  }

  _createClass(FontFaceObject, [{
    key: "createNativeFontFace",
    value: function createNativeFontFace() {
      if (!this.data || this.disableFontFace) {
        return null;
      }

      var nativeFontFace = new FontFace(this.loadedName, this.data, {});

      if (this.fontRegistry) {
        this.fontRegistry.registerFont(this);
      }

      return nativeFontFace;
    }
  }, {
    key: "createFontFaceRule",
    value: function createFontFaceRule() {
      if (!this.data || this.disableFontFace) {
        return null;
      }

      var data = (0, _util.bytesToString)(new Uint8Array(this.data));
      var url = "url(data:".concat(this.mimetype, ";base64,").concat(btoa(data), ");");
      var rule = "@font-face {font-family:\"".concat(this.loadedName, "\";src:").concat(url, "}");

      if (this.fontRegistry) {
        this.fontRegistry.registerFont(this, url);
      }

      return rule;
    }
  }, {
    key: "getPathGenerator",
    value: function getPathGenerator(objs, character) {
      if (this.compiledGlyphs[character] !== undefined) {
        return this.compiledGlyphs[character];
      }

      var cmds, current;

      try {
        cmds = objs.get(this.loadedName + "_path_" + character);
      } catch (ex) {
        if (!this.ignoreErrors) {
          throw ex;
        }

        if (this._onUnsupportedFeature) {
          this._onUnsupportedFeature({
            featureId: _util.UNSUPPORTED_FEATURES.font
          });
        }

        (0, _util.warn)("getPathGenerator - ignoring character: \"".concat(ex, "\"."));
        return this.compiledGlyphs[character] = function (c, size) {};
      }

      if (this.isEvalSupported && _util.IsEvalSupportedCached.value) {
        var args,
            js = "";

        for (var i = 0, ii = cmds.length; i < ii; i++) {
          current = cmds[i];

          if (current.args !== undefined) {
            args = current.args.join(",");
          } else {
            args = "";
          }

          js += "c." + current.cmd + "(" + args + ");\n";
        }

        return this.compiledGlyphs[character] = new Function("c", "size", js);
      }

      return this.compiledGlyphs[character] = function (c, size) {
        for (var _i = 0, _ii = cmds.length; _i < _ii; _i++) {
          current = cmds[_i];

          if (current.cmd === "scale") {
            current.args = [size, -size];
          }

          c[current.cmd].apply(c, current.args);
        }
      };
    }
  }]);

  return FontFaceObject;
}();

exports.FontFaceObject = FontFaceObject;

/***/ }),
/* 196 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var compatibilityParams = Object.create(null);
{
  var _require = __w_pdfjs_require__(48),
      isNodeJS = _require.isNodeJS;

  var userAgent = typeof navigator !== "undefined" && navigator.userAgent || "";
  var isIE = /Trident/.test(userAgent);
  var isIOSChrome = /CriOS/.test(userAgent);

  (function checkOnBlobSupport() {
    if (isIE || isIOSChrome) {
      compatibilityParams.disableCreateObjectURL = true;
    }
  })();

  (function checkFontFaceAndImage() {
    if (isNodeJS) {
      compatibilityParams.disableFontFace = true;
      compatibilityParams.nativeImageDecoderSupport = "none";
    }
  })();
}
exports.apiCompatibilityParams = Object.freeze(compatibilityParams);

/***/ }),
/* 197 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanvasGraphics = void 0;

var _util = __w_pdfjs_require__(1);

var _pattern_helper = __w_pdfjs_require__(198);

var MIN_FONT_SIZE = 16;
var MAX_FONT_SIZE = 100;
var MAX_GROUP_SIZE = 4096;
var MIN_WIDTH_FACTOR = 0.65;
var COMPILE_TYPE3_GLYPHS = true;
var MAX_SIZE_TO_COMPILE = 1000;
var FULL_CHUNK_HEIGHT = 16;

function addContextCurrentTransform(ctx) {
  if (!ctx.mozCurrentTransform) {
    ctx._originalSave = ctx.save;
    ctx._originalRestore = ctx.restore;
    ctx._originalRotate = ctx.rotate;
    ctx._originalScale = ctx.scale;
    ctx._originalTranslate = ctx.translate;
    ctx._originalTransform = ctx.transform;
    ctx._originalSetTransform = ctx.setTransform;
    ctx._transformMatrix = ctx._transformMatrix || [1, 0, 0, 1, 0, 0];
    ctx._transformStack = [];
    Object.defineProperty(ctx, "mozCurrentTransform", {
      get: function getCurrentTransform() {
        return this._transformMatrix;
      }
    });
    Object.defineProperty(ctx, "mozCurrentTransformInverse", {
      get: function getCurrentTransformInverse() {
        var m = this._transformMatrix;
        var a = m[0],
            b = m[1],
            c = m[2],
            d = m[3],
            e = m[4],
            f = m[5];
        var ad_bc = a * d - b * c;
        var bc_ad = b * c - a * d;
        return [d / ad_bc, b / bc_ad, c / bc_ad, a / ad_bc, (d * e - c * f) / bc_ad, (b * e - a * f) / ad_bc];
      }
    });

    ctx.save = function ctxSave() {
      var old = this._transformMatrix;

      this._transformStack.push(old);

      this._transformMatrix = old.slice(0, 6);

      this._originalSave();
    };

    ctx.restore = function ctxRestore() {
      var prev = this._transformStack.pop();

      if (prev) {
        this._transformMatrix = prev;

        this._originalRestore();
      }
    };

    ctx.translate = function ctxTranslate(x, y) {
      var m = this._transformMatrix;
      m[4] = m[0] * x + m[2] * y + m[4];
      m[5] = m[1] * x + m[3] * y + m[5];

      this._originalTranslate(x, y);
    };

    ctx.scale = function ctxScale(x, y) {
      var m = this._transformMatrix;
      m[0] = m[0] * x;
      m[1] = m[1] * x;
      m[2] = m[2] * y;
      m[3] = m[3] * y;

      this._originalScale(x, y);
    };

    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
      var m = this._transformMatrix;
      this._transformMatrix = [m[0] * a + m[2] * b, m[1] * a + m[3] * b, m[0] * c + m[2] * d, m[1] * c + m[3] * d, m[0] * e + m[2] * f + m[4], m[1] * e + m[3] * f + m[5]];

      ctx._originalTransform(a, b, c, d, e, f);
    };

    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
      this._transformMatrix = [a, b, c, d, e, f];

      ctx._originalSetTransform(a, b, c, d, e, f);
    };

    ctx.rotate = function ctxRotate(angle) {
      var cosValue = Math.cos(angle);
      var sinValue = Math.sin(angle);
      var m = this._transformMatrix;
      this._transformMatrix = [m[0] * cosValue + m[2] * sinValue, m[1] * cosValue + m[3] * sinValue, m[0] * -sinValue + m[2] * cosValue, m[1] * -sinValue + m[3] * cosValue, m[4], m[5]];

      this._originalRotate(angle);
    };
  }
}

var CachedCanvases = function CachedCanvasesClosure() {
  function CachedCanvases(canvasFactory) {
    this.canvasFactory = canvasFactory;
    this.cache = Object.create(null);
  }

  CachedCanvases.prototype = {
    getCanvas: function CachedCanvases_getCanvas(id, width, height, trackTransform) {
      var canvasEntry;

      if (this.cache[id] !== undefined) {
        canvasEntry = this.cache[id];
        this.canvasFactory.reset(canvasEntry, width, height);
        canvasEntry.context.setTransform(1, 0, 0, 1, 0, 0);
      } else {
        canvasEntry = this.canvasFactory.create(width, height);
        this.cache[id] = canvasEntry;
      }

      if (trackTransform) {
        addContextCurrentTransform(canvasEntry.context);
      }

      return canvasEntry;
    },
    clear: function clear() {
      for (var id in this.cache) {
        var canvasEntry = this.cache[id];
        this.canvasFactory.destroy(canvasEntry);
        delete this.cache[id];
      }
    }
  };
  return CachedCanvases;
}();

function compileType3Glyph(imgData) {
  var POINT_TO_PROCESS_LIMIT = 1000;
  var width = imgData.width,
      height = imgData.height;
  var i,
      j,
      j0,
      width1 = width + 1;
  var points = new Uint8Array(width1 * (height + 1));
  var POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]);
  var lineSize = width + 7 & ~7,
      data0 = imgData.data;
  var data = new Uint8Array(lineSize * height),
      pos = 0,
      ii;

  for (i = 0, ii = data0.length; i < ii; i++) {
    var mask = 128,
        elem = data0[i];

    while (mask > 0) {
      data[pos++] = elem & mask ? 0 : 255;
      mask >>= 1;
    }
  }

  var count = 0;
  pos = 0;

  if (data[pos] !== 0) {
    points[0] = 1;
    ++count;
  }

  for (j = 1; j < width; j++) {
    if (data[pos] !== data[pos + 1]) {
      points[j] = data[pos] ? 2 : 1;
      ++count;
    }

    pos++;
  }

  if (data[pos] !== 0) {
    points[j] = 2;
    ++count;
  }

  for (i = 1; i < height; i++) {
    pos = i * lineSize;
    j0 = i * width1;

    if (data[pos - lineSize] !== data[pos]) {
      points[j0] = data[pos] ? 1 : 8;
      ++count;
    }

    var sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);

    for (j = 1; j < width; j++) {
      sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);

      if (POINT_TYPES[sum]) {
        points[j0 + j] = POINT_TYPES[sum];
        ++count;
      }

      pos++;
    }

    if (data[pos - lineSize] !== data[pos]) {
      points[j0 + j] = data[pos] ? 2 : 4;
      ++count;
    }

    if (count > POINT_TO_PROCESS_LIMIT) {
      return null;
    }
  }

  pos = lineSize * (height - 1);
  j0 = i * width1;

  if (data[pos] !== 0) {
    points[j0] = 8;
    ++count;
  }

  for (j = 1; j < width; j++) {
    if (data[pos] !== data[pos + 1]) {
      points[j0 + j] = data[pos] ? 4 : 8;
      ++count;
    }

    pos++;
  }

  if (data[pos] !== 0) {
    points[j0 + j] = 4;
    ++count;
  }

  if (count > POINT_TO_PROCESS_LIMIT) {
    return null;
  }

  var steps = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1]);
  var outlines = [];

  for (i = 0; count && i <= height; i++) {
    var p = i * width1;
    var end = p + width;

    while (p < end && !points[p]) {
      p++;
    }

    if (p === end) {
      continue;
    }

    var coords = [p % width1, i];
    var type = points[p],
        p0 = p,
        pp;

    do {
      var step = steps[type];

      do {
        p += step;
      } while (!points[p]);

      pp = points[p];

      if (pp !== 5 && pp !== 10) {
        type = pp;
        points[p] = 0;
      } else {
        type = pp & 0x33 * type >> 4;
        points[p] &= type >> 2 | type << 2;
      }

      coords.push(p % width1);
      coords.push(p / width1 | 0);

      if (!points[p]) {
        --count;
      }
    } while (p0 !== p);

    outlines.push(coords);
    --i;
  }

  var drawOutline = function drawOutline(c) {
    c.save();
    c.scale(1 / width, -1 / height);
    c.translate(0, -height);
    c.beginPath();

    for (var i = 0, ii = outlines.length; i < ii; i++) {
      var o = outlines[i];
      c.moveTo(o[0], o[1]);

      for (var j = 2, jj = o.length; j < jj; j += 2) {
        c.lineTo(o[j], o[j + 1]);
      }
    }

    c.fill();
    c.beginPath();
    c.restore();
  };

  return drawOutline;
}

var CanvasExtraState = function CanvasExtraStateClosure() {
  function CanvasExtraState() {
    this.alphaIsShape = false;
    this.fontSize = 0;
    this.fontSizeScale = 1;
    this.textMatrix = _util.IDENTITY_MATRIX;
    this.textMatrixScale = 1;
    this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
    this.leading = 0;
    this.x = 0;
    this.y = 0;
    this.lineX = 0;
    this.lineY = 0;
    this.charSpacing = 0;
    this.wordSpacing = 0;
    this.textHScale = 1;
    this.textRenderingMode = _util.TextRenderingMode.FILL;
    this.textRise = 0;
    this.fillColor = "#000000";
    this.strokeColor = "#000000";
    this.patternFill = false;
    this.fillAlpha = 1;
    this.strokeAlpha = 1;
    this.lineWidth = 1;
    this.activeSMask = null;
    this.resumeSMaskCtx = null;
  }

  CanvasExtraState.prototype = {
    clone: function CanvasExtraState_clone() {
      return Object.create(this);
    },
    setCurrentPoint: function CanvasExtraState_setCurrentPoint(x, y) {
      this.x = x;
      this.y = y;
    }
  };
  return CanvasExtraState;
}();

var CanvasGraphics = function CanvasGraphicsClosure() {
  var EXECUTION_TIME = 15;
  var EXECUTION_STEPS = 10;

  function CanvasGraphics(canvasCtx, commonObjs, objs, canvasFactory, webGLContext, imageLayer) {
    this.ctx = canvasCtx;
    this.current = new CanvasExtraState();
    this.stateStack = [];
    this.pendingClip = null;
    this.pendingEOFill = false;
    this.res = null;
    this.xobjs = null;
    this.commonObjs = commonObjs;
    this.objs = objs;
    this.canvasFactory = canvasFactory;
    this.webGLContext = webGLContext;
    this.imageLayer = imageLayer;
    this.groupStack = [];
    this.processingType3 = null;
    this.baseTransform = null;
    this.baseTransformStack = [];
    this.groupLevel = 0;
    this.smaskStack = [];
    this.smaskCounter = 0;
    this.tempSMask = null;
    this.cachedCanvases = new CachedCanvases(this.canvasFactory);

    if (canvasCtx) {
      addContextCurrentTransform(canvasCtx);
    }

    this._cachedGetSinglePixelWidth = null;
  }

  function putBinaryImageData(ctx, imgData) {
    if (typeof ImageData !== "undefined" && imgData instanceof ImageData) {
      ctx.putImageData(imgData, 0, 0);
      return;
    }

    var height = imgData.height,
        width = imgData.width;
    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
    var srcPos = 0,
        destPos;
    var src = imgData.data;
    var dest = chunkImgData.data;
    var i, j, thisChunkHeight, elemsInThisChunk;

    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
      var srcLength = src.byteLength;
      var dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
      var dest32DataLength = dest32.length;
      var fullSrcDiff = width + 7 >> 3;
      var white = 0xffffffff;
      var black = _util.IsLittleEndianCached.value ? 0xff000000 : 0x000000ff;

      for (i = 0; i < totalChunks; i++) {
        thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
        destPos = 0;

        for (j = 0; j < thisChunkHeight; j++) {
          var srcDiff = srcLength - srcPos;
          var k = 0;
          var kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
          var kEndUnrolled = kEnd & ~7;
          var mask = 0;
          var srcByte = 0;

          for (; k < kEndUnrolled; k += 8) {
            srcByte = src[srcPos++];
            dest32[destPos++] = srcByte & 128 ? white : black;
            dest32[destPos++] = srcByte & 64 ? white : black;
            dest32[destPos++] = srcByte & 32 ? white : black;
            dest32[destPos++] = srcByte & 16 ? white : black;
            dest32[destPos++] = srcByte & 8 ? white : black;
            dest32[destPos++] = srcByte & 4 ? white : black;
            dest32[destPos++] = srcByte & 2 ? white : black;
            dest32[destPos++] = srcByte & 1 ? white : black;
          }

          for (; k < kEnd; k++) {
            if (mask === 0) {
              srcByte = src[srcPos++];
              mask = 128;
            }

            dest32[destPos++] = srcByte & mask ? white : black;
            mask >>= 1;
          }
        }

        while (destPos < dest32DataLength) {
          dest32[destPos++] = 0;
        }

        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
      }
    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
      j = 0;
      elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;

      for (i = 0; i < fullChunks; i++) {
        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
        srcPos += elemsInThisChunk;
        ctx.putImageData(chunkImgData, 0, j);
        j += FULL_CHUNK_HEIGHT;
      }

      if (i < totalChunks) {
        elemsInThisChunk = width * partialChunkHeight * 4;
        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
        ctx.putImageData(chunkImgData, 0, j);
      }
    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
      thisChunkHeight = FULL_CHUNK_HEIGHT;
      elemsInThisChunk = width * thisChunkHeight;

      for (i = 0; i < totalChunks; i++) {
        if (i >= fullChunks) {
          thisChunkHeight = partialChunkHeight;
          elemsInThisChunk = width * thisChunkHeight;
        }

        destPos = 0;

        for (j = elemsInThisChunk; j--;) {
          dest[destPos++] = src[srcPos++];
          dest[destPos++] = src[srcPos++];
          dest[destPos++] = src[srcPos++];
          dest[destPos++] = 255;
        }

        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
      }
    } else {
      throw new Error("bad image kind: ".concat(imgData.kind));
    }
  }

  function putBinaryImageMask(ctx, imgData) {
    var height = imgData.height,
        width = imgData.width;
    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
    var srcPos = 0;
    var src = imgData.data;
    var dest = chunkImgData.data;

    for (var i = 0; i < totalChunks; i++) {
      var thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
      var destPos = 3;

      for (var j = 0; j < thisChunkHeight; j++) {
        var mask = 0;

        for (var k = 0; k < width; k++) {
          if (!mask) {
            var elem = src[srcPos++];
            mask = 128;
          }

          dest[destPos] = elem & mask ? 0 : 255;
          destPos += 4;
          mask >>= 1;
        }
      }

      ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
    }
  }

  function copyCtxState(sourceCtx, destCtx) {
    var properties = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font"];

    for (var i = 0, ii = properties.length; i < ii; i++) {
      var property = properties[i];

      if (sourceCtx[property] !== undefined) {
        destCtx[property] = sourceCtx[property];
      }
    }

    if (sourceCtx.setLineDash !== undefined) {
      destCtx.setLineDash(sourceCtx.getLineDash());
      destCtx.lineDashOffset = sourceCtx.lineDashOffset;
    }
  }

  function resetCtxToDefault(ctx) {
    ctx.strokeStyle = "#000000";
    ctx.fillStyle = "#000000";
    ctx.fillRule = "nonzero";
    ctx.globalAlpha = 1;
    ctx.lineWidth = 1;
    ctx.lineCap = "butt";
    ctx.lineJoin = "miter";
    ctx.miterLimit = 10;
    ctx.globalCompositeOperation = "source-over";
    ctx.font = "10px sans-serif";

    if (ctx.setLineDash !== undefined) {
      ctx.setLineDash([]);
      ctx.lineDashOffset = 0;
    }
  }

  function composeSMaskBackdrop(bytes, r0, g0, b0) {
    var length = bytes.length;

    for (var i = 3; i < length; i += 4) {
      var alpha = bytes[i];

      if (alpha === 0) {
        bytes[i - 3] = r0;
        bytes[i - 2] = g0;
        bytes[i - 1] = b0;
      } else if (alpha < 255) {
        var alpha_ = 255 - alpha;
        bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
        bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
        bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
      }
    }
  }

  function composeSMaskAlpha(maskData, layerData, transferMap) {
    var length = maskData.length;
    var scale = 1 / 255;

    for (var i = 3; i < length; i += 4) {
      var alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
      layerData[i] = layerData[i] * alpha * scale | 0;
    }
  }

  function composeSMaskLuminosity(maskData, layerData, transferMap) {
    var length = maskData.length;

    for (var i = 3; i < length; i += 4) {
      var y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
      layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
    }
  }

  function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap) {
    var hasBackdrop = !!backdrop;
    var r0 = hasBackdrop ? backdrop[0] : 0;
    var g0 = hasBackdrop ? backdrop[1] : 0;
    var b0 = hasBackdrop ? backdrop[2] : 0;
    var composeFn;

    if (subtype === "Luminosity") {
      composeFn = composeSMaskLuminosity;
    } else {
      composeFn = composeSMaskAlpha;
    }

    var PIXELS_TO_PROCESS = 1048576;
    var chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));

    for (var row = 0; row < height; row += chunkSize) {
      var chunkHeight = Math.min(chunkSize, height - row);
      var maskData = maskCtx.getImageData(0, row, width, chunkHeight);
      var layerData = layerCtx.getImageData(0, row, width, chunkHeight);

      if (hasBackdrop) {
        composeSMaskBackdrop(maskData.data, r0, g0, b0);
      }

      composeFn(maskData.data, layerData.data, transferMap);
      maskCtx.putImageData(layerData, 0, row);
    }
  }

  function composeSMask(ctx, smask, layerCtx, webGLContext) {
    var mask = smask.canvas;
    var maskCtx = smask.context;
    ctx.setTransform(smask.scaleX, 0, 0, smask.scaleY, smask.offsetX, smask.offsetY);
    var backdrop = smask.backdrop || null;

    if (!smask.transferMap && webGLContext.isEnabled) {
      var composed = webGLContext.composeSMask({
        layer: layerCtx.canvas,
        mask: mask,
        properties: {
          subtype: smask.subtype,
          backdrop: backdrop
        }
      });
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.drawImage(composed, smask.offsetX, smask.offsetY);
      return;
    }

    genericComposeSMask(maskCtx, layerCtx, mask.width, mask.height, smask.subtype, backdrop, smask.transferMap);
    ctx.drawImage(mask, 0, 0);
  }

  var LINE_CAP_STYLES = ["butt", "round", "square"];
  var LINE_JOIN_STYLES = ["miter", "round", "bevel"];
  var NORMAL_CLIP = {};
  var EO_CLIP = {};
  CanvasGraphics.prototype = {
    beginDrawing: function beginDrawing(_ref) {
      var transform = _ref.transform,
          viewport = _ref.viewport,
          _ref$transparency = _ref.transparency,
          transparency = _ref$transparency === void 0 ? false : _ref$transparency,
          _ref$background = _ref.background,
          background = _ref$background === void 0 ? null : _ref$background;
      var width = this.ctx.canvas.width;
      var height = this.ctx.canvas.height;
      this.ctx.save();
      this.ctx.fillStyle = background || "rgb(255, 255, 255)";
      this.ctx.fillRect(0, 0, width, height);
      this.ctx.restore();

      if (transparency) {
        var transparentCanvas = this.cachedCanvases.getCanvas("transparent", width, height, true);
        this.compositeCtx = this.ctx;
        this.transparentCanvas = transparentCanvas.canvas;
        this.ctx = transparentCanvas.context;
        this.ctx.save();
        this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
      }

      this.ctx.save();
      resetCtxToDefault(this.ctx);

      if (transform) {
        this.ctx.transform.apply(this.ctx, transform);
      }

      this.ctx.transform.apply(this.ctx, viewport.transform);
      this.baseTransform = this.ctx.mozCurrentTransform.slice();

      if (this.imageLayer) {
        this.imageLayer.beginLayout();
      }
    },
    executeOperatorList: function CanvasGraphics_executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
      var argsArray = operatorList.argsArray;
      var fnArray = operatorList.fnArray;
      var i = executionStartIdx || 0;
      var argsArrayLen = argsArray.length;

      if (argsArrayLen === i) {
        return i;
      }

      var chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === "function";
      var endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
      var steps = 0;
      var commonObjs = this.commonObjs;
      var objs = this.objs;
      var fnId;

      while (true) {
        if (stepper !== undefined && i === stepper.nextBreakPoint) {
          stepper.breakIt(i, continueCallback);
          return i;
        }

        fnId = fnArray[i];

        if (fnId !== _util.OPS.dependency) {
          this[fnId].apply(this, argsArray[i]);
        } else {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = argsArray[i][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var depObjId = _step.value;
              var objsPool = depObjId.startsWith("g_") ? commonObjs : objs;

              if (!objsPool.has(depObjId)) {
                objsPool.get(depObjId, continueCallback);
                return i;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        i++;

        if (i === argsArrayLen) {
          return i;
        }

        if (chunkOperations && ++steps > EXECUTION_STEPS) {
          if (Date.now() > endTime) {
            continueCallback();
            return i;
          }

          steps = 0;
        }
      }
    },
    endDrawing: function CanvasGraphics_endDrawing() {
      if (this.current.activeSMask !== null) {
        this.endSMaskGroup();
      }

      this.ctx.restore();

      if (this.transparentCanvas) {
        this.ctx = this.compositeCtx;
        this.ctx.save();
        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
        this.ctx.drawImage(this.transparentCanvas, 0, 0);
        this.ctx.restore();
        this.transparentCanvas = null;
      }

      this.cachedCanvases.clear();
      this.webGLContext.clear();

      if (this.imageLayer) {
        this.imageLayer.endLayout();
      }
    },
    setLineWidth: function CanvasGraphics_setLineWidth(width) {
      this.current.lineWidth = width;
      this.ctx.lineWidth = width;
    },
    setLineCap: function CanvasGraphics_setLineCap(style) {
      this.ctx.lineCap = LINE_CAP_STYLES[style];
    },
    setLineJoin: function CanvasGraphics_setLineJoin(style) {
      this.ctx.lineJoin = LINE_JOIN_STYLES[style];
    },
    setMiterLimit: function CanvasGraphics_setMiterLimit(limit) {
      this.ctx.miterLimit = limit;
    },
    setDash: function CanvasGraphics_setDash(dashArray, dashPhase) {
      var ctx = this.ctx;

      if (ctx.setLineDash !== undefined) {
        ctx.setLineDash(dashArray);
        ctx.lineDashOffset = dashPhase;
      }
    },
    setRenderingIntent: function setRenderingIntent(intent) {},
    setFlatness: function setFlatness(flatness) {},
    setGState: function CanvasGraphics_setGState(states) {
      for (var i = 0, ii = states.length; i < ii; i++) {
        var state = states[i];
        var key = state[0];
        var value = state[1];

        switch (key) {
          case "LW":
            this.setLineWidth(value);
            break;

          case "LC":
            this.setLineCap(value);
            break;

          case "LJ":
            this.setLineJoin(value);
            break;

          case "ML":
            this.setMiterLimit(value);
            break;

          case "D":
            this.setDash(value[0], value[1]);
            break;

          case "RI":
            this.setRenderingIntent(value);
            break;

          case "FL":
            this.setFlatness(value);
            break;

          case "Font":
            this.setFont(value[0], value[1]);
            break;

          case "CA":
            this.current.strokeAlpha = state[1];
            break;

          case "ca":
            this.current.fillAlpha = state[1];
            this.ctx.globalAlpha = state[1];
            break;

          case "BM":
            this.ctx.globalCompositeOperation = value;
            break;

          case "SMask":
            if (this.current.activeSMask) {
              if (this.stateStack.length > 0 && this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask) {
                this.suspendSMaskGroup();
              } else {
                this.endSMaskGroup();
              }
            }

            this.current.activeSMask = value ? this.tempSMask : null;

            if (this.current.activeSMask) {
              this.beginSMaskGroup();
            }

            this.tempSMask = null;
            break;
        }
      }
    },
    beginSMaskGroup: function CanvasGraphics_beginSMaskGroup() {
      var activeSMask = this.current.activeSMask;
      var drawnWidth = activeSMask.canvas.width;
      var drawnHeight = activeSMask.canvas.height;
      var cacheId = "smaskGroupAt" + this.groupLevel;
      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
      var currentCtx = this.ctx;
      var currentTransform = currentCtx.mozCurrentTransform;
      this.ctx.save();
      var groupCtx = scratchCanvas.context;
      groupCtx.scale(1 / activeSMask.scaleX, 1 / activeSMask.scaleY);
      groupCtx.translate(-activeSMask.offsetX, -activeSMask.offsetY);
      groupCtx.transform.apply(groupCtx, currentTransform);
      activeSMask.startTransformInverse = groupCtx.mozCurrentTransformInverse;
      copyCtxState(currentCtx, groupCtx);
      this.ctx = groupCtx;
      this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
      this.groupStack.push(currentCtx);
      this.groupLevel++;
    },
    suspendSMaskGroup: function CanvasGraphics_endSMaskGroup() {
      var groupCtx = this.ctx;
      this.groupLevel--;
      this.ctx = this.groupStack.pop();
      composeSMask(this.ctx, this.current.activeSMask, groupCtx, this.webGLContext);
      this.ctx.restore();
      this.ctx.save();
      copyCtxState(groupCtx, this.ctx);
      this.current.resumeSMaskCtx = groupCtx;

      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);

      this.ctx.transform.apply(this.ctx, deltaTransform);
      groupCtx.save();
      groupCtx.setTransform(1, 0, 0, 1, 0, 0);
      groupCtx.clearRect(0, 0, groupCtx.canvas.width, groupCtx.canvas.height);
      groupCtx.restore();
    },
    resumeSMaskGroup: function CanvasGraphics_endSMaskGroup() {
      var groupCtx = this.current.resumeSMaskCtx;
      var currentCtx = this.ctx;
      this.ctx = groupCtx;
      this.groupStack.push(currentCtx);
      this.groupLevel++;
    },
    endSMaskGroup: function CanvasGraphics_endSMaskGroup() {
      var groupCtx = this.ctx;
      this.groupLevel--;
      this.ctx = this.groupStack.pop();
      composeSMask(this.ctx, this.current.activeSMask, groupCtx, this.webGLContext);
      this.ctx.restore();
      copyCtxState(groupCtx, this.ctx);

      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);

      this.ctx.transform.apply(this.ctx, deltaTransform);
    },
    save: function CanvasGraphics_save() {
      this.ctx.save();
      var old = this.current;
      this.stateStack.push(old);
      this.current = old.clone();
      this.current.resumeSMaskCtx = null;
    },
    restore: function CanvasGraphics_restore() {
      if (this.current.resumeSMaskCtx) {
        this.resumeSMaskGroup();
      }

      if (this.current.activeSMask !== null && (this.stateStack.length === 0 || this.stateStack[this.stateStack.length - 1].activeSMask !== this.current.activeSMask)) {
        this.endSMaskGroup();
      }

      if (this.stateStack.length !== 0) {
        this.current = this.stateStack.pop();
        this.ctx.restore();
        this.pendingClip = null;
        this._cachedGetSinglePixelWidth = null;
      }
    },
    transform: function CanvasGraphics_transform(a, b, c, d, e, f) {
      this.ctx.transform(a, b, c, d, e, f);
      this._cachedGetSinglePixelWidth = null;
    },
    constructPath: function CanvasGraphics_constructPath(ops, args) {
      var ctx = this.ctx;
      var current = this.current;
      var x = current.x,
          y = current.y;

      for (var i = 0, j = 0, ii = ops.length; i < ii; i++) {
        switch (ops[i] | 0) {
          case _util.OPS.rectangle:
            x = args[j++];
            y = args[j++];
            var width = args[j++];
            var height = args[j++];

            if (width === 0) {
              width = this.getSinglePixelWidth();
            }

            if (height === 0) {
              height = this.getSinglePixelWidth();
            }

            var xw = x + width;
            var yh = y + height;
            this.ctx.moveTo(x, y);
            this.ctx.lineTo(xw, y);
            this.ctx.lineTo(xw, yh);
            this.ctx.lineTo(x, yh);
            this.ctx.lineTo(x, y);
            this.ctx.closePath();
            break;

          case _util.OPS.moveTo:
            x = args[j++];
            y = args[j++];
            ctx.moveTo(x, y);
            break;

          case _util.OPS.lineTo:
            x = args[j++];
            y = args[j++];
            ctx.lineTo(x, y);
            break;

          case _util.OPS.curveTo:
            x = args[j + 4];
            y = args[j + 5];
            ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
            j += 6;
            break;

          case _util.OPS.curveTo2:
            ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
            x = args[j + 2];
            y = args[j + 3];
            j += 4;
            break;

          case _util.OPS.curveTo3:
            x = args[j + 2];
            y = args[j + 3];
            ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
            j += 4;
            break;

          case _util.OPS.closePath:
            ctx.closePath();
            break;
        }
      }

      current.setCurrentPoint(x, y);
    },
    closePath: function CanvasGraphics_closePath() {
      this.ctx.closePath();
    },
    stroke: function CanvasGraphics_stroke(consumePath) {
      consumePath = typeof consumePath !== "undefined" ? consumePath : true;
      var ctx = this.ctx;
      var strokeColor = this.current.strokeColor;
      ctx.globalAlpha = this.current.strokeAlpha;

      if (strokeColor && strokeColor.hasOwnProperty("type") && strokeColor.type === "Pattern") {
        ctx.save();
        var transform = ctx.mozCurrentTransform;

        var scale = _util.Util.singularValueDecompose2dScale(transform)[0];

        ctx.strokeStyle = strokeColor.getPattern(ctx, this);
        ctx.lineWidth = Math.max(this.getSinglePixelWidth() * MIN_WIDTH_FACTOR, this.current.lineWidth * scale);
        ctx.stroke();
        ctx.restore();
      } else {
        ctx.lineWidth = Math.max(this.getSinglePixelWidth() * MIN_WIDTH_FACTOR, this.current.lineWidth);
        ctx.stroke();
      }

      if (consumePath) {
        this.consumePath();
      }

      ctx.globalAlpha = this.current.fillAlpha;
    },
    closeStroke: function CanvasGraphics_closeStroke() {
      this.closePath();
      this.stroke();
    },
    fill: function CanvasGraphics_fill(consumePath) {
      consumePath = typeof consumePath !== "undefined" ? consumePath : true;
      var ctx = this.ctx;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var needRestore = false;

      if (isPatternFill) {
        ctx.save();

        if (this.baseTransform) {
          ctx.setTransform.apply(ctx, this.baseTransform);
        }

        ctx.fillStyle = fillColor.getPattern(ctx, this);
        needRestore = true;
      }

      if (this.pendingEOFill) {
        ctx.fill("evenodd");
        this.pendingEOFill = false;
      } else {
        ctx.fill();
      }

      if (needRestore) {
        ctx.restore();
      }

      if (consumePath) {
        this.consumePath();
      }
    },
    eoFill: function CanvasGraphics_eoFill() {
      this.pendingEOFill = true;
      this.fill();
    },
    fillStroke: function CanvasGraphics_fillStroke() {
      this.fill(false);
      this.stroke(false);
      this.consumePath();
    },
    eoFillStroke: function CanvasGraphics_eoFillStroke() {
      this.pendingEOFill = true;
      this.fillStroke();
    },
    closeFillStroke: function CanvasGraphics_closeFillStroke() {
      this.closePath();
      this.fillStroke();
    },
    closeEOFillStroke: function CanvasGraphics_closeEOFillStroke() {
      this.pendingEOFill = true;
      this.closePath();
      this.fillStroke();
    },
    endPath: function CanvasGraphics_endPath() {
      this.consumePath();
    },
    clip: function CanvasGraphics_clip() {
      this.pendingClip = NORMAL_CLIP;
    },
    eoClip: function CanvasGraphics_eoClip() {
      this.pendingClip = EO_CLIP;
    },
    beginText: function CanvasGraphics_beginText() {
      this.current.textMatrix = _util.IDENTITY_MATRIX;
      this.current.textMatrixScale = 1;
      this.current.x = this.current.lineX = 0;
      this.current.y = this.current.lineY = 0;
    },
    endText: function CanvasGraphics_endText() {
      var paths = this.pendingTextPaths;
      var ctx = this.ctx;

      if (paths === undefined) {
        ctx.beginPath();
        return;
      }

      ctx.save();
      ctx.beginPath();

      for (var i = 0; i < paths.length; i++) {
        var path = paths[i];
        ctx.setTransform.apply(ctx, path.transform);
        ctx.translate(path.x, path.y);
        path.addToPath(ctx, path.fontSize);
      }

      ctx.restore();
      ctx.clip();
      ctx.beginPath();
      delete this.pendingTextPaths;
    },
    setCharSpacing: function CanvasGraphics_setCharSpacing(spacing) {
      this.current.charSpacing = spacing;
    },
    setWordSpacing: function CanvasGraphics_setWordSpacing(spacing) {
      this.current.wordSpacing = spacing;
    },
    setHScale: function CanvasGraphics_setHScale(scale) {
      this.current.textHScale = scale / 100;
    },
    setLeading: function CanvasGraphics_setLeading(leading) {
      this.current.leading = -leading;
    },
    setFont: function CanvasGraphics_setFont(fontRefName, size) {
      var fontObj = this.commonObjs.get(fontRefName);
      var current = this.current;

      if (!fontObj) {
        throw new Error("Can't find font for ".concat(fontRefName));
      }

      current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;

      if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
        (0, _util.warn)("Invalid font matrix for font " + fontRefName);
      }

      if (size < 0) {
        size = -size;
        current.fontDirection = -1;
      } else {
        current.fontDirection = 1;
      }

      this.current.font = fontObj;
      this.current.fontSize = size;

      if (fontObj.isType3Font) {
        return;
      }

      var name = fontObj.loadedName || "sans-serif";
      var bold = "normal";

      if (fontObj.black) {
        bold = "900";
      } else if (fontObj.bold) {
        bold = "bold";
      }

      var italic = fontObj.italic ? "italic" : "normal";
      var typeface = "\"".concat(name, "\", ").concat(fontObj.fallbackName);
      var browserFontSize = size;

      if (size < MIN_FONT_SIZE) {
        browserFontSize = MIN_FONT_SIZE;
      } else if (size > MAX_FONT_SIZE) {
        browserFontSize = MAX_FONT_SIZE;
      }

      this.current.fontSizeScale = size / browserFontSize;
      this.ctx.font = "".concat(italic, " ").concat(bold, " ").concat(browserFontSize, "px ").concat(typeface);
    },
    setTextRenderingMode: function CanvasGraphics_setTextRenderingMode(mode) {
      this.current.textRenderingMode = mode;
    },
    setTextRise: function CanvasGraphics_setTextRise(rise) {
      this.current.textRise = rise;
    },
    moveText: function CanvasGraphics_moveText(x, y) {
      this.current.x = this.current.lineX += x;
      this.current.y = this.current.lineY += y;
    },
    setLeadingMoveText: function CanvasGraphics_setLeadingMoveText(x, y) {
      this.setLeading(-y);
      this.moveText(x, y);
    },
    setTextMatrix: function CanvasGraphics_setTextMatrix(a, b, c, d, e, f) {
      this.current.textMatrix = [a, b, c, d, e, f];
      this.current.textMatrixScale = Math.sqrt(a * a + b * b);
      this.current.x = this.current.lineX = 0;
      this.current.y = this.current.lineY = 0;
    },
    nextLine: function CanvasGraphics_nextLine() {
      this.moveText(0, this.current.leading);
    },
    paintChar: function paintChar(character, x, y, patternTransform) {
      var ctx = this.ctx;
      var current = this.current;
      var font = current.font;
      var textRenderingMode = current.textRenderingMode;
      var fontSize = current.fontSize / current.fontSizeScale;
      var fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
      var isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
      var patternFill = current.patternFill && font.data;
      var addToPath;

      if (font.disableFontFace || isAddToPathSet || patternFill) {
        addToPath = font.getPathGenerator(this.commonObjs, character);
      }

      if (font.disableFontFace || patternFill) {
        ctx.save();
        ctx.translate(x, y);
        ctx.beginPath();
        addToPath(ctx, fontSize);

        if (patternTransform) {
          ctx.setTransform.apply(ctx, patternTransform);
        }

        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.fill();
        }

        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.stroke();
        }

        ctx.restore();
      } else {
        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.fillText(character, x, y);
        }

        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.strokeText(character, x, y);
        }
      }

      if (isAddToPathSet) {
        var paths = this.pendingTextPaths || (this.pendingTextPaths = []);
        paths.push({
          transform: ctx.mozCurrentTransform,
          x: x,
          y: y,
          fontSize: fontSize,
          addToPath: addToPath
        });
      }
    },

    get isFontSubpixelAAEnabled() {
      var _this$cachedCanvases$ = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10),
          ctx = _this$cachedCanvases$.context;

      ctx.scale(1.5, 1);
      ctx.fillText("I", 0, 10);
      var data = ctx.getImageData(0, 0, 10, 10).data;
      var enabled = false;

      for (var i = 3; i < data.length; i += 4) {
        if (data[i] > 0 && data[i] < 255) {
          enabled = true;
          break;
        }
      }

      return (0, _util.shadow)(this, "isFontSubpixelAAEnabled", enabled);
    },

    showText: function CanvasGraphics_showText(glyphs) {
      var current = this.current;
      var font = current.font;

      if (font.isType3Font) {
        return this.showType3Text(glyphs);
      }

      var fontSize = current.fontSize;

      if (fontSize === 0) {
        return undefined;
      }

      var ctx = this.ctx;
      var fontSizeScale = current.fontSizeScale;
      var charSpacing = current.charSpacing;
      var wordSpacing = current.wordSpacing;
      var fontDirection = current.fontDirection;
      var textHScale = current.textHScale * fontDirection;
      var glyphsLength = glyphs.length;
      var vertical = font.vertical;
      var spacingDir = vertical ? 1 : -1;
      var defaultVMetrics = font.defaultVMetrics;
      var widthAdvanceScale = fontSize * current.fontMatrix[0];
      var simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
      ctx.save();
      var patternTransform;

      if (current.patternFill) {
        ctx.save();
        var pattern = current.fillColor.getPattern(ctx, this);
        patternTransform = ctx.mozCurrentTransform;
        ctx.restore();
        ctx.fillStyle = pattern;
      }

      ctx.transform.apply(ctx, current.textMatrix);
      ctx.translate(current.x, current.y + current.textRise);

      if (fontDirection > 0) {
        ctx.scale(textHScale, -1);
      } else {
        ctx.scale(textHScale, 1);
      }

      var lineWidth = current.lineWidth;
      var scale = current.textMatrixScale;

      if (scale === 0 || lineWidth === 0) {
        var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;

        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          this._cachedGetSinglePixelWidth = null;
          lineWidth = this.getSinglePixelWidth() * MIN_WIDTH_FACTOR;
        }
      } else {
        lineWidth /= scale;
      }

      if (fontSizeScale !== 1.0) {
        ctx.scale(fontSizeScale, fontSizeScale);
        lineWidth /= fontSizeScale;
      }

      ctx.lineWidth = lineWidth;
      var x = 0,
          i;

      for (i = 0; i < glyphsLength; ++i) {
        var glyph = glyphs[i];

        if ((0, _util.isNum)(glyph)) {
          x += spacingDir * glyph * fontSize / 1000;
          continue;
        }

        var restoreNeeded = false;
        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
        var character = glyph.fontChar;
        var accent = glyph.accent;
        var scaledX, scaledY, scaledAccentX, scaledAccentY;
        var width = glyph.width;

        if (vertical) {
          var vmetric, vx, vy;
          vmetric = glyph.vmetric || defaultVMetrics;
          vx = glyph.vmetric ? vmetric[1] : width * 0.5;
          vx = -vx * widthAdvanceScale;
          vy = vmetric[2] * widthAdvanceScale;
          width = vmetric ? -vmetric[0] : width;
          scaledX = vx / fontSizeScale;
          scaledY = (x + vy) / fontSizeScale;
        } else {
          scaledX = x / fontSizeScale;
          scaledY = 0;
        }

        if (font.remeasure && width > 0) {
          var measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;

          if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
            var characterScaleX = width / measuredWidth;
            restoreNeeded = true;
            ctx.save();
            ctx.scale(characterScaleX, 1);
            scaledX /= characterScaleX;
          } else if (width !== measuredWidth) {
            scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
          }
        }

        if (glyph.isInFont || font.missingFile) {
          if (simpleFillText && !accent) {
            ctx.fillText(character, scaledX, scaledY);
          } else {
            this.paintChar(character, scaledX, scaledY, patternTransform);

            if (accent) {
              scaledAccentX = scaledX + accent.offset.x / fontSizeScale;
              scaledAccentY = scaledY - accent.offset.y / fontSizeScale;
              this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform);
            }
          }
        }

        var charWidth;

        if (vertical) {
          charWidth = width * widthAdvanceScale - spacing * fontDirection;
        } else {
          charWidth = width * widthAdvanceScale + spacing * fontDirection;
        }

        x += charWidth;

        if (restoreNeeded) {
          ctx.restore();
        }
      }

      if (vertical) {
        current.y -= x;
      } else {
        current.x += x * textHScale;
      }

      ctx.restore();
    },
    showType3Text: function CanvasGraphics_showType3Text(glyphs) {
      var ctx = this.ctx;
      var current = this.current;
      var font = current.font;
      var fontSize = current.fontSize;
      var fontDirection = current.fontDirection;
      var spacingDir = font.vertical ? 1 : -1;
      var charSpacing = current.charSpacing;
      var wordSpacing = current.wordSpacing;
      var textHScale = current.textHScale * fontDirection;
      var fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
      var glyphsLength = glyphs.length;
      var isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
      var i, glyph, width, spacingLength;

      if (isTextInvisible || fontSize === 0) {
        return;
      }

      this._cachedGetSinglePixelWidth = null;
      ctx.save();
      ctx.transform.apply(ctx, current.textMatrix);
      ctx.translate(current.x, current.y);
      ctx.scale(textHScale, fontDirection);

      for (i = 0; i < glyphsLength; ++i) {
        glyph = glyphs[i];

        if ((0, _util.isNum)(glyph)) {
          spacingLength = spacingDir * glyph * fontSize / 1000;
          this.ctx.translate(spacingLength, 0);
          current.x += spacingLength * textHScale;
          continue;
        }

        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
        var operatorList = font.charProcOperatorList[glyph.operatorListId];

        if (!operatorList) {
          (0, _util.warn)("Type3 character \"".concat(glyph.operatorListId, "\" is not available."));
          continue;
        }

        this.processingType3 = glyph;
        this.save();
        ctx.scale(fontSize, fontSize);
        ctx.transform.apply(ctx, fontMatrix);
        this.executeOperatorList(operatorList);
        this.restore();

        var transformed = _util.Util.applyTransform([glyph.width, 0], fontMatrix);

        width = transformed[0] * fontSize + spacing;
        ctx.translate(width, 0);
        current.x += width * textHScale;
      }

      ctx.restore();
      this.processingType3 = null;
    },
    setCharWidth: function CanvasGraphics_setCharWidth(xWidth, yWidth) {},
    setCharWidthAndBounds: function CanvasGraphics_setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
      this.ctx.rect(llx, lly, urx - llx, ury - lly);
      this.clip();
      this.endPath();
    },
    getColorN_Pattern: function CanvasGraphics_getColorN_Pattern(IR) {
      var _this = this;

      var pattern;

      if (IR[0] === "TilingPattern") {
        var color = IR[1];
        var baseTransform = this.baseTransform || this.ctx.mozCurrentTransform.slice();
        var canvasGraphicsFactory = {
          createCanvasGraphics: function createCanvasGraphics(ctx) {
            return new CanvasGraphics(ctx, _this.commonObjs, _this.objs, _this.canvasFactory, _this.webGLContext);
          }
        };
        pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
      } else {
        pattern = (0, _pattern_helper.getShadingPatternFromIR)(IR);
      }

      return pattern;
    },
    setStrokeColorN: function CanvasGraphics_setStrokeColorN() {
      this.current.strokeColor = this.getColorN_Pattern(arguments);
    },
    setFillColorN: function CanvasGraphics_setFillColorN() {
      this.current.fillColor = this.getColorN_Pattern(arguments);
      this.current.patternFill = true;
    },
    setStrokeRGBColor: function CanvasGraphics_setStrokeRGBColor(r, g, b) {
      var color = _util.Util.makeCssRgb(r, g, b);

      this.ctx.strokeStyle = color;
      this.current.strokeColor = color;
    },
    setFillRGBColor: function CanvasGraphics_setFillRGBColor(r, g, b) {
      var color = _util.Util.makeCssRgb(r, g, b);

      this.ctx.fillStyle = color;
      this.current.fillColor = color;
      this.current.patternFill = false;
    },
    shadingFill: function CanvasGraphics_shadingFill(patternIR) {
      var ctx = this.ctx;
      this.save();
      var pattern = (0, _pattern_helper.getShadingPatternFromIR)(patternIR);
      ctx.fillStyle = pattern.getPattern(ctx, this, true);
      var inv = ctx.mozCurrentTransformInverse;

      if (inv) {
        var canvas = ctx.canvas;
        var width = canvas.width;
        var height = canvas.height;

        var bl = _util.Util.applyTransform([0, 0], inv);

        var br = _util.Util.applyTransform([0, height], inv);

        var ul = _util.Util.applyTransform([width, 0], inv);

        var ur = _util.Util.applyTransform([width, height], inv);

        var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
        var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
        var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
        var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
        this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
      } else {
        this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
      }

      this.restore();
    },
    beginInlineImage: function CanvasGraphics_beginInlineImage() {
      (0, _util.unreachable)("Should not call beginInlineImage");
    },
    beginImageData: function CanvasGraphics_beginImageData() {
      (0, _util.unreachable)("Should not call beginImageData");
    },
    paintFormXObjectBegin: function CanvasGraphics_paintFormXObjectBegin(matrix, bbox) {
      this.save();
      this.baseTransformStack.push(this.baseTransform);

      if (Array.isArray(matrix) && matrix.length === 6) {
        this.transform.apply(this, matrix);
      }

      this.baseTransform = this.ctx.mozCurrentTransform;

      if (bbox) {
        var width = bbox[2] - bbox[0];
        var height = bbox[3] - bbox[1];
        this.ctx.rect(bbox[0], bbox[1], width, height);
        this.clip();
        this.endPath();
      }
    },
    paintFormXObjectEnd: function CanvasGraphics_paintFormXObjectEnd() {
      this.restore();
      this.baseTransform = this.baseTransformStack.pop();
    },
    beginGroup: function CanvasGraphics_beginGroup(group) {
      this.save();
      var currentCtx = this.ctx;

      if (!group.isolated) {
        (0, _util.info)("TODO: Support non-isolated groups.");
      }

      if (group.knockout) {
        (0, _util.warn)("Knockout groups not supported.");
      }

      var currentTransform = currentCtx.mozCurrentTransform;

      if (group.matrix) {
        currentCtx.transform.apply(currentCtx, group.matrix);
      }

      if (!group.bbox) {
        throw new Error("Bounding box is required.");
      }

      var bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, currentCtx.mozCurrentTransform);

      var canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
      bounds = _util.Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
      var offsetX = Math.floor(bounds[0]);
      var offsetY = Math.floor(bounds[1]);
      var drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
      var drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
      var scaleX = 1,
          scaleY = 1;

      if (drawnWidth > MAX_GROUP_SIZE) {
        scaleX = drawnWidth / MAX_GROUP_SIZE;
        drawnWidth = MAX_GROUP_SIZE;
      }

      if (drawnHeight > MAX_GROUP_SIZE) {
        scaleY = drawnHeight / MAX_GROUP_SIZE;
        drawnHeight = MAX_GROUP_SIZE;
      }

      var cacheId = "groupAt" + this.groupLevel;

      if (group.smask) {
        cacheId += "_smask_" + this.smaskCounter++ % 2;
      }

      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
      var groupCtx = scratchCanvas.context;
      groupCtx.scale(1 / scaleX, 1 / scaleY);
      groupCtx.translate(-offsetX, -offsetY);
      groupCtx.transform.apply(groupCtx, currentTransform);

      if (group.smask) {
        this.smaskStack.push({
          canvas: scratchCanvas.canvas,
          context: groupCtx,
          offsetX: offsetX,
          offsetY: offsetY,
          scaleX: scaleX,
          scaleY: scaleY,
          subtype: group.smask.subtype,
          backdrop: group.smask.backdrop,
          transferMap: group.smask.transferMap || null,
          startTransformInverse: null
        });
      } else {
        currentCtx.setTransform(1, 0, 0, 1, 0, 0);
        currentCtx.translate(offsetX, offsetY);
        currentCtx.scale(scaleX, scaleY);
      }

      copyCtxState(currentCtx, groupCtx);
      this.ctx = groupCtx;
      this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
      this.groupStack.push(currentCtx);
      this.groupLevel++;
      this.current.activeSMask = null;
    },
    endGroup: function CanvasGraphics_endGroup(group) {
      this.groupLevel--;
      var groupCtx = this.ctx;
      this.ctx = this.groupStack.pop();

      if (this.ctx.imageSmoothingEnabled !== undefined) {
        this.ctx.imageSmoothingEnabled = false;
      } else {
        this.ctx.mozImageSmoothingEnabled = false;
      }

      if (group.smask) {
        this.tempSMask = this.smaskStack.pop();
      } else {
        this.ctx.drawImage(groupCtx.canvas, 0, 0);
      }

      this.restore();
    },
    beginAnnotations: function CanvasGraphics_beginAnnotations() {
      this.save();

      if (this.baseTransform) {
        this.ctx.setTransform.apply(this.ctx, this.baseTransform);
      }
    },
    endAnnotations: function CanvasGraphics_endAnnotations() {
      this.restore();
    },
    beginAnnotation: function CanvasGraphics_beginAnnotation(rect, transform, matrix) {
      this.save();
      resetCtxToDefault(this.ctx);
      this.current = new CanvasExtraState();

      if (Array.isArray(rect) && rect.length === 4) {
        var width = rect[2] - rect[0];
        var height = rect[3] - rect[1];
        this.ctx.rect(rect[0], rect[1], width, height);
        this.clip();
        this.endPath();
      }

      this.transform.apply(this, transform);
      this.transform.apply(this, matrix);
    },
    endAnnotation: function CanvasGraphics_endAnnotation() {
      this.restore();
    },
    paintJpegXObject: function CanvasGraphics_paintJpegXObject(objId, w, h) {
      var domImage = this.processingType3 ? this.commonObjs.get(objId) : this.objs.get(objId);

      if (!domImage) {
        (0, _util.warn)("Dependent image isn't ready yet");
        return;
      }

      this.save();
      var ctx = this.ctx;
      ctx.scale(1 / w, -1 / h);
      ctx.drawImage(domImage, 0, 0, domImage.width, domImage.height, 0, -h, w, h);

      if (this.imageLayer) {
        var currentTransform = ctx.mozCurrentTransformInverse;
        var position = this.getCanvasPosition(0, 0);
        this.imageLayer.appendImage({
          objId: objId,
          left: position[0],
          top: position[1],
          width: w / currentTransform[0],
          height: h / currentTransform[3]
        });
      }

      this.restore();
    },
    paintImageMaskXObject: function CanvasGraphics_paintImageMaskXObject(img) {
      var ctx = this.ctx;
      var width = img.width,
          height = img.height;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var glyph = this.processingType3;

      if (COMPILE_TYPE3_GLYPHS && glyph && glyph.compiled === undefined) {
        if (width <= MAX_SIZE_TO_COMPILE && height <= MAX_SIZE_TO_COMPILE) {
          glyph.compiled = compileType3Glyph({
            data: img.data,
            width: width,
            height: height
          });
        } else {
          glyph.compiled = null;
        }
      }

      if (glyph && glyph.compiled) {
        glyph.compiled(ctx);
        return;
      }

      var maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
      var maskCtx = maskCanvas.context;
      maskCtx.save();
      putBinaryImageMask(maskCtx, img);
      maskCtx.globalCompositeOperation = "source-in";
      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
      maskCtx.fillRect(0, 0, width, height);
      maskCtx.restore();
      this.paintInlineImageXObject(maskCanvas.canvas);
    },
    paintImageMaskXObjectRepeat: function CanvasGraphics_paintImageMaskXObjectRepeat(imgData, scaleX, scaleY, positions) {
      var width = imgData.width;
      var height = imgData.height;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
      var maskCtx = maskCanvas.context;
      maskCtx.save();
      putBinaryImageMask(maskCtx, imgData);
      maskCtx.globalCompositeOperation = "source-in";
      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
      maskCtx.fillRect(0, 0, width, height);
      maskCtx.restore();
      var ctx = this.ctx;

      for (var i = 0, ii = positions.length; i < ii; i += 2) {
        ctx.save();
        ctx.transform(scaleX, 0, 0, scaleY, positions[i], positions[i + 1]);
        ctx.scale(1, -1);
        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
        ctx.restore();
      }
    },
    paintImageMaskXObjectGroup: function CanvasGraphics_paintImageMaskXObjectGroup(images) {
      var ctx = this.ctx;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;

      for (var i = 0, ii = images.length; i < ii; i++) {
        var image = images[i];
        var width = image.width,
            height = image.height;
        var maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
        var maskCtx = maskCanvas.context;
        maskCtx.save();
        putBinaryImageMask(maskCtx, image);
        maskCtx.globalCompositeOperation = "source-in";
        maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
        maskCtx.fillRect(0, 0, width, height);
        maskCtx.restore();
        ctx.save();
        ctx.transform.apply(ctx, image.transform);
        ctx.scale(1, -1);
        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
        ctx.restore();
      }
    },
    paintImageXObject: function CanvasGraphics_paintImageXObject(objId) {
      var imgData = this.processingType3 ? this.commonObjs.get(objId) : this.objs.get(objId);

      if (!imgData) {
        (0, _util.warn)("Dependent image isn't ready yet");
        return;
      }

      this.paintInlineImageXObject(imgData);
    },
    paintImageXObjectRepeat: function CanvasGraphics_paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
      var imgData = this.processingType3 ? this.commonObjs.get(objId) : this.objs.get(objId);

      if (!imgData) {
        (0, _util.warn)("Dependent image isn't ready yet");
        return;
      }

      var width = imgData.width;
      var height = imgData.height;
      var map = [];

      for (var i = 0, ii = positions.length; i < ii; i += 2) {
        map.push({
          transform: [scaleX, 0, 0, scaleY, positions[i], positions[i + 1]],
          x: 0,
          y: 0,
          w: width,
          h: height
        });
      }

      this.paintInlineImageXObjectGroup(imgData, map);
    },
    paintInlineImageXObject: function CanvasGraphics_paintInlineImageXObject(imgData) {
      var width = imgData.width;
      var height = imgData.height;
      var ctx = this.ctx;
      this.save();
      ctx.scale(1 / width, -1 / height);
      var currentTransform = ctx.mozCurrentTransformInverse;
      var a = currentTransform[0],
          b = currentTransform[1];
      var widthScale = Math.max(Math.sqrt(a * a + b * b), 1);
      var c = currentTransform[2],
          d = currentTransform[3];
      var heightScale = Math.max(Math.sqrt(c * c + d * d), 1);
      var imgToPaint, tmpCanvas;

      if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) {
        imgToPaint = imgData;
      } else {
        tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
        var tmpCtx = tmpCanvas.context;
        putBinaryImageData(tmpCtx, imgData);
        imgToPaint = tmpCanvas.canvas;
      }

      var paintWidth = width,
          paintHeight = height;
      var tmpCanvasId = "prescale1";

      while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
        var newWidth = paintWidth,
            newHeight = paintHeight;

        if (widthScale > 2 && paintWidth > 1) {
          newWidth = Math.ceil(paintWidth / 2);
          widthScale /= paintWidth / newWidth;
        }

        if (heightScale > 2 && paintHeight > 1) {
          newHeight = Math.ceil(paintHeight / 2);
          heightScale /= paintHeight / newHeight;
        }

        tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
        tmpCtx = tmpCanvas.context;
        tmpCtx.clearRect(0, 0, newWidth, newHeight);
        tmpCtx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
        imgToPaint = tmpCanvas.canvas;
        paintWidth = newWidth;
        paintHeight = newHeight;
        tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
      }

      ctx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, -height, width, height);

      if (this.imageLayer) {
        var position = this.getCanvasPosition(0, -height);
        this.imageLayer.appendImage({
          imgData: imgData,
          left: position[0],
          top: position[1],
          width: width / currentTransform[0],
          height: height / currentTransform[3]
        });
      }

      this.restore();
    },
    paintInlineImageXObjectGroup: function CanvasGraphics_paintInlineImageXObjectGroup(imgData, map) {
      var ctx = this.ctx;
      var w = imgData.width;
      var h = imgData.height;
      var tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w, h);
      var tmpCtx = tmpCanvas.context;
      putBinaryImageData(tmpCtx, imgData);

      for (var i = 0, ii = map.length; i < ii; i++) {
        var entry = map[i];
        ctx.save();
        ctx.transform.apply(ctx, entry.transform);
        ctx.scale(1, -1);
        ctx.drawImage(tmpCanvas.canvas, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);

        if (this.imageLayer) {
          var position = this.getCanvasPosition(entry.x, entry.y);
          this.imageLayer.appendImage({
            imgData: imgData,
            left: position[0],
            top: position[1],
            width: w,
            height: h
          });
        }

        ctx.restore();
      }
    },
    paintSolidColorImageMask: function CanvasGraphics_paintSolidColorImageMask() {
      this.ctx.fillRect(0, 0, 1, 1);
    },
    paintXObject: function CanvasGraphics_paintXObject() {
      (0, _util.warn)("Unsupported 'paintXObject' command.");
    },
    markPoint: function CanvasGraphics_markPoint(tag) {},
    markPointProps: function CanvasGraphics_markPointProps(tag, properties) {},
    beginMarkedContent: function CanvasGraphics_beginMarkedContent(tag) {},
    beginMarkedContentProps: function CanvasGraphics_beginMarkedContentProps(tag, properties) {},
    endMarkedContent: function CanvasGraphics_endMarkedContent() {},
    beginCompat: function CanvasGraphics_beginCompat() {},
    endCompat: function CanvasGraphics_endCompat() {},
    consumePath: function CanvasGraphics_consumePath() {
      var ctx = this.ctx;

      if (this.pendingClip) {
        if (this.pendingClip === EO_CLIP) {
          ctx.clip("evenodd");
        } else {
          ctx.clip();
        }

        this.pendingClip = null;
      }

      ctx.beginPath();
    },
    getSinglePixelWidth: function getSinglePixelWidth(scale) {
      if (this._cachedGetSinglePixelWidth === null) {
        var inverse = this.ctx.mozCurrentTransformInverse;
        this._cachedGetSinglePixelWidth = Math.sqrt(Math.max(inverse[0] * inverse[0] + inverse[1] * inverse[1], inverse[2] * inverse[2] + inverse[3] * inverse[3]));
      }

      return this._cachedGetSinglePixelWidth;
    },
    getCanvasPosition: function CanvasGraphics_getCanvasPosition(x, y) {
      var transform = this.ctx.mozCurrentTransform;
      return [transform[0] * x + transform[2] * y + transform[4], transform[1] * x + transform[3] * y + transform[5]];
    }
  };

  for (var op in _util.OPS) {
    CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
  }

  return CanvasGraphics;
}();

exports.CanvasGraphics = CanvasGraphics;

/***/ }),
/* 198 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShadingPatternFromIR = getShadingPatternFromIR;
exports.TilingPattern = void 0;

var _util = __w_pdfjs_require__(1);

var ShadingIRs = {};

function applyBoundingBox(ctx, bbox) {
  if (!bbox || typeof Path2D === "undefined") {
    return;
  }

  var width = bbox[2] - bbox[0];
  var height = bbox[3] - bbox[1];
  var region = new Path2D();
  region.rect(bbox[0], bbox[1], width, height);
  ctx.clip(region);
}

ShadingIRs.RadialAxial = {
  fromIR: function RadialAxial_fromIR(raw) {
    var type = raw[1];
    var bbox = raw[2];
    var colorStops = raw[3];
    var p0 = raw[4];
    var p1 = raw[5];
    var r0 = raw[6];
    var r1 = raw[7];
    return {
      type: "Pattern",
      getPattern: function RadialAxial_getPattern(ctx) {
        applyBoundingBox(ctx, bbox);
        var grad;

        if (type === "axial") {
          grad = ctx.createLinearGradient(p0[0], p0[1], p1[0], p1[1]);
        } else if (type === "radial") {
          grad = ctx.createRadialGradient(p0[0], p0[1], r0, p1[0], p1[1], r1);
        }

        for (var i = 0, ii = colorStops.length; i < ii; ++i) {
          var c = colorStops[i];
          grad.addColorStop(c[0], c[1]);
        }

        return grad;
      }
    };
  }
};

var createMeshCanvas = function createMeshCanvasClosure() {
  function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
    var coords = context.coords,
        colors = context.colors;
    var bytes = data.data,
        rowSize = data.width * 4;
    var tmp;

    if (coords[p1 + 1] > coords[p2 + 1]) {
      tmp = p1;
      p1 = p2;
      p2 = tmp;
      tmp = c1;
      c1 = c2;
      c2 = tmp;
    }

    if (coords[p2 + 1] > coords[p3 + 1]) {
      tmp = p2;
      p2 = p3;
      p3 = tmp;
      tmp = c2;
      c2 = c3;
      c3 = tmp;
    }

    if (coords[p1 + 1] > coords[p2 + 1]) {
      tmp = p1;
      p1 = p2;
      p2 = tmp;
      tmp = c1;
      c1 = c2;
      c2 = tmp;
    }

    var x1 = (coords[p1] + context.offsetX) * context.scaleX;
    var y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
    var x2 = (coords[p2] + context.offsetX) * context.scaleX;
    var y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
    var x3 = (coords[p3] + context.offsetX) * context.scaleX;
    var y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;

    if (y1 >= y3) {
      return;
    }

    var c1r = colors[c1],
        c1g = colors[c1 + 1],
        c1b = colors[c1 + 2];
    var c2r = colors[c2],
        c2g = colors[c2 + 1],
        c2b = colors[c2 + 2];
    var c3r = colors[c3],
        c3g = colors[c3 + 1],
        c3b = colors[c3 + 2];
    var minY = Math.round(y1),
        maxY = Math.round(y3);
    var xa, car, cag, cab;
    var xb, cbr, cbg, cbb;

    for (var y = minY; y <= maxY; y++) {
      if (y < y2) {
        var _k = void 0;

        if (y < y1) {
          _k = 0;
        } else if (y1 === y2) {
          _k = 1;
        } else {
          _k = (y1 - y) / (y1 - y2);
        }

        xa = x1 - (x1 - x2) * _k;
        car = c1r - (c1r - c2r) * _k;
        cag = c1g - (c1g - c2g) * _k;
        cab = c1b - (c1b - c2b) * _k;
      } else {
        var _k2 = void 0;

        if (y > y3) {
          _k2 = 1;
        } else if (y2 === y3) {
          _k2 = 0;
        } else {
          _k2 = (y2 - y) / (y2 - y3);
        }

        xa = x2 - (x2 - x3) * _k2;
        car = c2r - (c2r - c3r) * _k2;
        cag = c2g - (c2g - c3g) * _k2;
        cab = c2b - (c2b - c3b) * _k2;
      }

      var k = void 0;

      if (y < y1) {
        k = 0;
      } else if (y > y3) {
        k = 1;
      } else {
        k = (y1 - y) / (y1 - y3);
      }

      xb = x1 - (x1 - x3) * k;
      cbr = c1r - (c1r - c3r) * k;
      cbg = c1g - (c1g - c3g) * k;
      cbb = c1b - (c1b - c3b) * k;
      var x1_ = Math.round(Math.min(xa, xb));
      var x2_ = Math.round(Math.max(xa, xb));
      var j = rowSize * y + x1_ * 4;

      for (var x = x1_; x <= x2_; x++) {
        var _k3 = (xa - x) / (xa - xb);

        if (_k3 < 0) {
          _k3 = 0;
        } else if (_k3 > 1) {
          _k3 = 1;
        }

        bytes[j++] = car - (car - cbr) * _k3 | 0;
        bytes[j++] = cag - (cag - cbg) * _k3 | 0;
        bytes[j++] = cab - (cab - cbb) * _k3 | 0;
        bytes[j++] = 255;
      }
    }
  }

  function drawFigure(data, figure, context) {
    var ps = figure.coords;
    var cs = figure.colors;
    var i, ii;

    switch (figure.type) {
      case "lattice":
        var verticesPerRow = figure.verticesPerRow;
        var rows = Math.floor(ps.length / verticesPerRow) - 1;
        var cols = verticesPerRow - 1;

        for (i = 0; i < rows; i++) {
          var q = i * verticesPerRow;

          for (var j = 0; j < cols; j++, q++) {
            drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
            drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
          }
        }

        break;

      case "triangles":
        for (i = 0, ii = ps.length; i < ii; i += 3) {
          drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
        }

        break;

      default:
        throw new Error("illegal figure");
    }
  }

  function createMeshCanvas(bounds, combinesScale, coords, colors, figures, backgroundColor, cachedCanvases, webGLContext) {
    var EXPECTED_SCALE = 1.1;
    var MAX_PATTERN_SIZE = 3000;
    var BORDER_SIZE = 2;
    var offsetX = Math.floor(bounds[0]);
    var offsetY = Math.floor(bounds[1]);
    var boundsWidth = Math.ceil(bounds[2]) - offsetX;
    var boundsHeight = Math.ceil(bounds[3]) - offsetY;
    var width = Math.min(Math.ceil(Math.abs(boundsWidth * combinesScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
    var height = Math.min(Math.ceil(Math.abs(boundsHeight * combinesScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
    var scaleX = boundsWidth / width;
    var scaleY = boundsHeight / height;
    var context = {
      coords: coords,
      colors: colors,
      offsetX: -offsetX,
      offsetY: -offsetY,
      scaleX: 1 / scaleX,
      scaleY: 1 / scaleY
    };
    var paddedWidth = width + BORDER_SIZE * 2;
    var paddedHeight = height + BORDER_SIZE * 2;
    var canvas, tmpCanvas, i, ii;

    if (webGLContext.isEnabled) {
      canvas = webGLContext.drawFigures({
        width: width,
        height: height,
        backgroundColor: backgroundColor,
        figures: figures,
        context: context
      });
      tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight, false);
      tmpCanvas.context.drawImage(canvas, BORDER_SIZE, BORDER_SIZE);
      canvas = tmpCanvas.canvas;
    } else {
      tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight, false);
      var tmpCtx = tmpCanvas.context;
      var data = tmpCtx.createImageData(width, height);

      if (backgroundColor) {
        var bytes = data.data;

        for (i = 0, ii = bytes.length; i < ii; i += 4) {
          bytes[i] = backgroundColor[0];
          bytes[i + 1] = backgroundColor[1];
          bytes[i + 2] = backgroundColor[2];
          bytes[i + 3] = 255;
        }
      }

      for (i = 0; i < figures.length; i++) {
        drawFigure(data, figures[i], context);
      }

      tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
      canvas = tmpCanvas.canvas;
    }

    return {
      canvas: canvas,
      offsetX: offsetX - BORDER_SIZE * scaleX,
      offsetY: offsetY - BORDER_SIZE * scaleY,
      scaleX: scaleX,
      scaleY: scaleY
    };
  }

  return createMeshCanvas;
}();

ShadingIRs.Mesh = {
  fromIR: function Mesh_fromIR(raw) {
    var coords = raw[2];
    var colors = raw[3];
    var figures = raw[4];
    var bounds = raw[5];
    var matrix = raw[6];
    var bbox = raw[7];
    var background = raw[8];
    return {
      type: "Pattern",
      getPattern: function Mesh_getPattern(ctx, owner, shadingFill) {
        applyBoundingBox(ctx, bbox);
        var scale;

        if (shadingFill) {
          scale = _util.Util.singularValueDecompose2dScale(ctx.mozCurrentTransform);
        } else {
          scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);

          if (matrix) {
            var matrixScale = _util.Util.singularValueDecompose2dScale(matrix);

            scale = [scale[0] * matrixScale[0], scale[1] * matrixScale[1]];
          }
        }

        var temporaryPatternCanvas = createMeshCanvas(bounds, scale, coords, colors, figures, shadingFill ? null : background, owner.cachedCanvases, owner.webGLContext);

        if (!shadingFill) {
          ctx.setTransform.apply(ctx, owner.baseTransform);

          if (matrix) {
            ctx.transform.apply(ctx, matrix);
          }
        }

        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
        return ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
      }
    };
  }
};
ShadingIRs.Dummy = {
  fromIR: function Dummy_fromIR() {
    return {
      type: "Pattern",
      getPattern: function Dummy_fromIR_getPattern() {
        return "hotpink";
      }
    };
  }
};

function getShadingPatternFromIR(raw) {
  var shadingIR = ShadingIRs[raw[0]];

  if (!shadingIR) {
    throw new Error("Unknown IR type: ".concat(raw[0]));
  }

  return shadingIR.fromIR(raw);
}

var TilingPattern = function TilingPatternClosure() {
  var PaintType = {
    COLORED: 1,
    UNCOLORED: 2
  };
  var MAX_PATTERN_SIZE = 3000;

  function TilingPattern(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
    this.operatorList = IR[2];
    this.matrix = IR[3] || [1, 0, 0, 1, 0, 0];
    this.bbox = IR[4];
    this.xstep = IR[5];
    this.ystep = IR[6];
    this.paintType = IR[7];
    this.tilingType = IR[8];
    this.color = color;
    this.canvasGraphicsFactory = canvasGraphicsFactory;
    this.baseTransform = baseTransform;
    this.type = "Pattern";
    this.ctx = ctx;
  }

  TilingPattern.prototype = {
    createPatternCanvas: function TilinPattern_createPatternCanvas(owner) {
      var operatorList = this.operatorList;
      var bbox = this.bbox;
      var xstep = this.xstep;
      var ystep = this.ystep;
      var paintType = this.paintType;
      var tilingType = this.tilingType;
      var color = this.color;
      var canvasGraphicsFactory = this.canvasGraphicsFactory;
      (0, _util.info)("TilingType: " + tilingType);
      var x0 = bbox[0],
          y0 = bbox[1],
          x1 = bbox[2],
          y1 = bbox[3];

      var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);

      var curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);

      var combinedScale = [matrixScale[0] * curMatrixScale[0], matrixScale[1] * curMatrixScale[1]];
      var dimx = this.getSizeAndScale(xstep, this.ctx.canvas.width, combinedScale[0]);
      var dimy = this.getSizeAndScale(ystep, this.ctx.canvas.height, combinedScale[1]);
      var tmpCanvas = owner.cachedCanvases.getCanvas("pattern", dimx.size, dimy.size, true);
      var tmpCtx = tmpCanvas.context;
      var graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
      graphics.groupLevel = owner.groupLevel;
      this.setFillAndStrokeStyleToContext(graphics, paintType, color);
      graphics.transform(dimx.scale, 0, 0, dimy.scale, 0, 0);
      graphics.transform(1, 0, 0, 1, -x0, -y0);
      this.clipBbox(graphics, bbox, x0, y0, x1, y1);
      graphics.executeOperatorList(operatorList);
      this.ctx.transform(1, 0, 0, 1, x0, y0);
      this.ctx.scale(1 / dimx.scale, 1 / dimy.scale);
      return tmpCanvas.canvas;
    },
    getSizeAndScale: function TilingPattern_getSizeAndScale(step, realOutputSize, scale) {
      step = Math.abs(step);
      var maxSize = Math.max(MAX_PATTERN_SIZE, realOutputSize);
      var size = Math.ceil(step * scale);

      if (size >= maxSize) {
        size = maxSize;
      } else {
        scale = size / step;
      }

      return {
        scale: scale,
        size: size
      };
    },
    clipBbox: function clipBbox(graphics, bbox, x0, y0, x1, y1) {
      if (Array.isArray(bbox) && bbox.length === 4) {
        var bboxWidth = x1 - x0;
        var bboxHeight = y1 - y0;
        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
        graphics.clip();
        graphics.endPath();
      }
    },
    setFillAndStrokeStyleToContext: function setFillAndStrokeStyleToContext(graphics, paintType, color) {
      var context = graphics.ctx,
          current = graphics.current;

      switch (paintType) {
        case PaintType.COLORED:
          var ctx = this.ctx;
          context.fillStyle = ctx.fillStyle;
          context.strokeStyle = ctx.strokeStyle;
          current.fillColor = ctx.fillStyle;
          current.strokeColor = ctx.strokeStyle;
          break;

        case PaintType.UNCOLORED:
          var cssColor = _util.Util.makeCssRgb(color[0], color[1], color[2]);

          context.fillStyle = cssColor;
          context.strokeStyle = cssColor;
          current.fillColor = cssColor;
          current.strokeColor = cssColor;
          break;

        default:
          throw new _util.FormatError("Unsupported paint type: ".concat(paintType));
      }
    },
    getPattern: function TilingPattern_getPattern(ctx, owner) {
      ctx = this.ctx;
      ctx.setTransform.apply(ctx, this.baseTransform);
      ctx.transform.apply(ctx, this.matrix);
      var temporaryPatternCanvas = this.createPatternCanvas(owner);
      return ctx.createPattern(temporaryPatternCanvas, "repeat");
    }
  };
  return TilingPattern;
}();

exports.TilingPattern = TilingPattern;

/***/ }),
/* 199 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalWorkerOptions = void 0;
var GlobalWorkerOptions = Object.create(null);
exports.GlobalWorkerOptions = GlobalWorkerOptions;
GlobalWorkerOptions.workerPort = GlobalWorkerOptions.workerPort === undefined ? null : GlobalWorkerOptions.workerPort;
GlobalWorkerOptions.workerSrc = GlobalWorkerOptions.workerSrc === undefined ? "" : GlobalWorkerOptions.workerSrc;

/***/ }),
/* 200 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageHandler = void 0;

var _regenerator = _interopRequireDefault(__w_pdfjs_require__(191));

var _util = __w_pdfjs_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var CallbackKind = {
  UNKNOWN: 0,
  DATA: 1,
  ERROR: 2
};
var StreamKind = {
  UNKNOWN: 0,
  CANCEL: 1,
  CANCEL_COMPLETE: 2,
  CLOSE: 3,
  ENQUEUE: 4,
  ERROR: 5,
  PULL: 6,
  PULL_COMPLETE: 7,
  START_COMPLETE: 8
};

function wrapReason(reason) {
  if (_typeof(reason) !== "object" || reason === null) {
    return reason;
  }

  switch (reason.name) {
    case "AbortException":
      return new _util.AbortException(reason.message);

    case "MissingPDFException":
      return new _util.MissingPDFException(reason.message);

    case "UnexpectedResponseException":
      return new _util.UnexpectedResponseException(reason.message, reason.status);

    case "UnknownErrorException":
      return new _util.UnknownErrorException(reason.message, reason.details);

    default:
      return new _util.UnknownErrorException(reason.message, reason.toString());
  }
}

var MessageHandler = /*#__PURE__*/function () {
  function MessageHandler(sourceName, targetName, comObj) {
    var _this = this;

    _classCallCheck(this, MessageHandler);

    this.sourceName = sourceName;
    this.targetName = targetName;
    this.comObj = comObj;
    this.callbackId = 1;
    this.streamId = 1;
    this.postMessageTransfers = true;
    this.streamSinks = Object.create(null);
    this.streamControllers = Object.create(null);
    this.callbackCapabilities = Object.create(null);
    this.actionHandler = Object.create(null);

    this._onComObjOnMessage = function (event) {
      var data = event.data;

      if (data.targetName !== _this.sourceName) {
        return;
      }

      if (data.stream) {
        _this._processStreamMessage(data);

        return;
      }

      if (data.callback) {
        var callbackId = data.callbackId;
        var capability = _this.callbackCapabilities[callbackId];

        if (!capability) {
          throw new Error("Cannot resolve callback ".concat(callbackId));
        }

        delete _this.callbackCapabilities[callbackId];

        if (data.callback === CallbackKind.DATA) {
          capability.resolve(data.data);
        } else if (data.callback === CallbackKind.ERROR) {
          capability.reject(wrapReason(data.reason));
        } else {
          throw new Error("Unexpected callback case");
        }

        return;
      }

      var action = _this.actionHandler[data.action];

      if (!action) {
        throw new Error("Unknown action from worker: ".concat(data.action));
      }

      if (data.callbackId) {
        var _sourceName = _this.sourceName;
        var _targetName = data.sourceName;
        new Promise(function (resolve) {
          resolve(action(data.data));
        }).then(function (result) {
          comObj.postMessage({
            sourceName: _sourceName,
            targetName: _targetName,
            callback: CallbackKind.DATA,
            callbackId: data.callbackId,
            data: result
          });
        }, function (reason) {
          comObj.postMessage({
            sourceName: _sourceName,
            targetName: _targetName,
            callback: CallbackKind.ERROR,
            callbackId: data.callbackId,
            reason: wrapReason(reason)
          });
        });
        return;
      }

      if (data.streamId) {
        _this._createStreamSink(data);

        return;
      }

      action(data.data);
    };

    comObj.addEventListener("message", this._onComObjOnMessage);
  }

  _createClass(MessageHandler, [{
    key: "on",
    value: function on(actionName, handler) {
      var ah = this.actionHandler;

      if (ah[actionName]) {
        throw new Error("There is already an actionName called \"".concat(actionName, "\""));
      }

      ah[actionName] = handler;
    }
  }, {
    key: "send",
    value: function send(actionName, data, transfers) {
      this._postMessage({
        sourceName: this.sourceName,
        targetName: this.targetName,
        action: actionName,
        data: data
      }, transfers);
    }
  }, {
    key: "sendWithPromise",
    value: function sendWithPromise(actionName, data, transfers) {
      var callbackId = this.callbackId++;
      var capability = (0, _util.createPromiseCapability)();
      this.callbackCapabilities[callbackId] = capability;

      try {
        this._postMessage({
          sourceName: this.sourceName,
          targetName: this.targetName,
          action: actionName,
          callbackId: callbackId,
          data: data
        }, transfers);
      } catch (ex) {
        capability.reject(ex);
      }

      return capability.promise;
    }
  }, {
    key: "sendWithStream",
    value: function sendWithStream(actionName, data, queueingStrategy, transfers) {
      var _this2 = this;

      var streamId = this.streamId++;
      var sourceName = this.sourceName;
      var targetName = this.targetName;
      var comObj = this.comObj;
      return new ReadableStream({
        start: function start(controller) {
          var startCapability = (0, _util.createPromiseCapability)();
          _this2.streamControllers[streamId] = {
            controller: controller,
            startCall: startCapability,
            pullCall: null,
            cancelCall: null,
            isClosed: false
          };

          _this2._postMessage({
            sourceName: sourceName,
            targetName: targetName,
            action: actionName,
            streamId: streamId,
            data: data,
            desiredSize: controller.desiredSize
          }, transfers);

          return startCapability.promise;
        },
        pull: function pull(controller) {
          var pullCapability = (0, _util.createPromiseCapability)();
          _this2.streamControllers[streamId].pullCall = pullCapability;
          comObj.postMessage({
            sourceName: sourceName,
            targetName: targetName,
            stream: StreamKind.PULL,
            streamId: streamId,
            desiredSize: controller.desiredSize
          });
          return pullCapability.promise;
        },
        cancel: function cancel(reason) {
          (0, _util.assert)(reason instanceof Error, "cancel must have a valid reason");
          var cancelCapability = (0, _util.createPromiseCapability)();
          _this2.streamControllers[streamId].cancelCall = cancelCapability;
          _this2.streamControllers[streamId].isClosed = true;
          comObj.postMessage({
            sourceName: sourceName,
            targetName: targetName,
            stream: StreamKind.CANCEL,
            streamId: streamId,
            reason: wrapReason(reason)
          });
          return cancelCapability.promise;
        }
      }, queueingStrategy);
    }
  }, {
    key: "_createStreamSink",
    value: function _createStreamSink(data) {
      var self = this;
      var action = this.actionHandler[data.action];
      var streamId = data.streamId;
      var sourceName = this.sourceName;
      var targetName = data.sourceName;
      var comObj = this.comObj;
      var streamSink = {
        enqueue: function enqueue(chunk) {
          var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          var transfers = arguments.length > 2 ? arguments[2] : undefined;

          if (this.isCancelled) {
            return;
          }

          var lastDesiredSize = this.desiredSize;
          this.desiredSize -= size;

          if (lastDesiredSize > 0 && this.desiredSize <= 0) {
            this.sinkCapability = (0, _util.createPromiseCapability)();
            this.ready = this.sinkCapability.promise;
          }

          self._postMessage({
            sourceName: sourceName,
            targetName: targetName,
            stream: StreamKind.ENQUEUE,
            streamId: streamId,
            chunk: chunk
          }, transfers);
        },
        close: function close() {
          if (this.isCancelled) {
            return;
          }

          this.isCancelled = true;
          comObj.postMessage({
            sourceName: sourceName,
            targetName: targetName,
            stream: StreamKind.CLOSE,
            streamId: streamId
          });
          delete self.streamSinks[streamId];
        },
        error: function error(reason) {
          (0, _util.assert)(reason instanceof Error, "error must have a valid reason");

          if (this.isCancelled) {
            return;
          }

          this.isCancelled = true;
          comObj.postMessage({
            sourceName: sourceName,
            targetName: targetName,
            stream: StreamKind.ERROR,
            streamId: streamId,
            reason: wrapReason(reason)
          });
        },
        sinkCapability: (0, _util.createPromiseCapability)(),
        onPull: null,
        onCancel: null,
        isCancelled: false,
        desiredSize: data.desiredSize,
        ready: null
      };
      streamSink.sinkCapability.resolve();
      streamSink.ready = streamSink.sinkCapability.promise;
      this.streamSinks[streamId] = streamSink;
      new Promise(function (resolve) {
        resolve(action(data.data, streamSink));
      }).then(function () {
        comObj.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          stream: StreamKind.START_COMPLETE,
          streamId: streamId,
          success: true
        });
      }, function (reason) {
        comObj.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          stream: StreamKind.START_COMPLETE,
          streamId: streamId,
          reason: wrapReason(reason)
        });
      });
    }
  }, {
    key: "_processStreamMessage",
    value: function _processStreamMessage(data) {
      var streamId = data.streamId;
      var sourceName = this.sourceName;
      var targetName = data.sourceName;
      var comObj = this.comObj;

      switch (data.stream) {
        case StreamKind.START_COMPLETE:
          if (data.success) {
            this.streamControllers[streamId].startCall.resolve();
          } else {
            this.streamControllers[streamId].startCall.reject(wrapReason(data.reason));
          }

          break;

        case StreamKind.PULL_COMPLETE:
          if (data.success) {
            this.streamControllers[streamId].pullCall.resolve();
          } else {
            this.streamControllers[streamId].pullCall.reject(wrapReason(data.reason));
          }

          break;

        case StreamKind.PULL:
          if (!this.streamSinks[streamId]) {
            comObj.postMessage({
              sourceName: sourceName,
              targetName: targetName,
              stream: StreamKind.PULL_COMPLETE,
              streamId: streamId,
              success: true
            });
            break;
          }

          if (this.streamSinks[streamId].desiredSize <= 0 && data.desiredSize > 0) {
            this.streamSinks[streamId].sinkCapability.resolve();
          }

          this.streamSinks[streamId].desiredSize = data.desiredSize;
          var onPull = this.streamSinks[data.streamId].onPull;
          new Promise(function (resolve) {
            resolve(onPull && onPull());
          }).then(function () {
            comObj.postMessage({
              sourceName: sourceName,
              targetName: targetName,
              stream: StreamKind.PULL_COMPLETE,
              streamId: streamId,
              success: true
            });
          }, function (reason) {
            comObj.postMessage({
              sourceName: sourceName,
              targetName: targetName,
              stream: StreamKind.PULL_COMPLETE,
              streamId: streamId,
              reason: wrapReason(reason)
            });
          });
          break;

        case StreamKind.ENQUEUE:
          (0, _util.assert)(this.streamControllers[streamId], "enqueue should have stream controller");

          if (this.streamControllers[streamId].isClosed) {
            break;
          }

          this.streamControllers[streamId].controller.enqueue(data.chunk);
          break;

        case StreamKind.CLOSE:
          (0, _util.assert)(this.streamControllers[streamId], "close should have stream controller");

          if (this.streamControllers[streamId].isClosed) {
            break;
          }

          this.streamControllers[streamId].isClosed = true;
          this.streamControllers[streamId].controller.close();

          this._deleteStreamController(streamId);

          break;

        case StreamKind.ERROR:
          (0, _util.assert)(this.streamControllers[streamId], "error should have stream controller");
          this.streamControllers[streamId].controller.error(wrapReason(data.reason));

          this._deleteStreamController(streamId);

          break;

        case StreamKind.CANCEL_COMPLETE:
          if (data.success) {
            this.streamControllers[streamId].cancelCall.resolve();
          } else {
            this.streamControllers[streamId].cancelCall.reject(wrapReason(data.reason));
          }

          this._deleteStreamController(streamId);

          break;

        case StreamKind.CANCEL:
          if (!this.streamSinks[streamId]) {
            break;
          }

          var onCancel = this.streamSinks[data.streamId].onCancel;
          new Promise(function (resolve) {
            resolve(onCancel && onCancel(wrapReason(data.reason)));
          }).then(function () {
            comObj.postMessage({
              sourceName: sourceName,
              targetName: targetName,
              stream: StreamKind.CANCEL_COMPLETE,
              streamId: streamId,
              success: true
            });
          }, function (reason) {
            comObj.postMessage({
              sourceName: sourceName,
              targetName: targetName,
              stream: StreamKind.CANCEL_COMPLETE,
              streamId: streamId,
              reason: wrapReason(reason)
            });
          });
          this.streamSinks[streamId].sinkCapability.reject(wrapReason(data.reason));
          this.streamSinks[streamId].isCancelled = true;
          delete this.streamSinks[streamId];
          break;

        default:
          throw new Error("Unexpected stream case");
      }
    }
  }, {
    key: "_deleteStreamController",
    value: function () {
      var _deleteStreamController2 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(streamId) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Promise.allSettled([this.streamControllers[streamId].startCall, this.streamControllers[streamId].pullCall, this.streamControllers[streamId].cancelCall].map(function (capability) {
                  return capability && capability.promise;
                }));

              case 2:
                delete this.streamControllers[streamId];

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _deleteStreamController(_x) {
        return _deleteStreamController2.apply(this, arguments);
      }

      return _deleteStreamController;
    }()
  }, {
    key: "_postMessage",
    value: function _postMessage(message, transfers) {
      if (transfers && this.postMessageTransfers) {
        this.comObj.postMessage(message, transfers);
      } else {
        this.comObj.postMessage(message);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.comObj.removeEventListener("message", this._onComObjOnMessage);
    }
  }]);

  return MessageHandler;
}();

exports.MessageHandler = MessageHandler;

/***/ }),
/* 201 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Metadata = void 0;

var _util = __w_pdfjs_require__(1);

var _xml_parser = __w_pdfjs_require__(202);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Metadata = /*#__PURE__*/function () {
  function Metadata(data) {
    _classCallCheck(this, Metadata);

    (0, _util.assert)(typeof data === "string", "Metadata: input is not a string");
    data = this._repair(data);
    var parser = new _xml_parser.SimpleXMLParser();
    var xmlDocument = parser.parseFromString(data);
    this._metadataMap = new Map();

    if (xmlDocument) {
      this._parse(xmlDocument);
    }
  }

  _createClass(Metadata, [{
    key: "_repair",
    value: function _repair(data) {
      return data.replace(/^[^<]+/, "").replace(/>\\376\\377([^<]+)/g, function (all, codes) {
        var bytes = codes.replace(/\\([0-3])([0-7])([0-7])/g, function (code, d1, d2, d3) {
          return String.fromCharCode(d1 * 64 + d2 * 8 + d3 * 1);
        }).replace(/&(amp|apos|gt|lt|quot);/g, function (str, name) {
          switch (name) {
            case "amp":
              return "&";

            case "apos":
              return "'";

            case "gt":
              return ">";

            case "lt":
              return "<";

            case "quot":
              return '"';
          }

          throw new Error("_repair: ".concat(name, " isn't defined."));
        });
        var chars = "";

        for (var i = 0, ii = bytes.length; i < ii; i += 2) {
          var code = bytes.charCodeAt(i) * 256 + bytes.charCodeAt(i + 1);

          if (code >= 32 && code < 127 && code !== 60 && code !== 62 && code !== 38) {
            chars += String.fromCharCode(code);
          } else {
            chars += "&#x" + (0x10000 + code).toString(16).substring(1) + ";";
          }
        }

        return ">" + chars;
      });
    }
  }, {
    key: "_parse",
    value: function _parse(xmlDocument) {
      var rdf = xmlDocument.documentElement;

      if (rdf.nodeName.toLowerCase() !== "rdf:rdf") {
        rdf = rdf.firstChild;

        while (rdf && rdf.nodeName.toLowerCase() !== "rdf:rdf") {
          rdf = rdf.nextSibling;
        }
      }

      var nodeName = rdf ? rdf.nodeName.toLowerCase() : null;

      if (!rdf || nodeName !== "rdf:rdf" || !rdf.hasChildNodes()) {
        return;
      }

      var children = rdf.childNodes;

      for (var i = 0, ii = children.length; i < ii; i++) {
        var desc = children[i];

        if (desc.nodeName.toLowerCase() !== "rdf:description") {
          continue;
        }

        for (var j = 0, jj = desc.childNodes.length; j < jj; j++) {
          if (desc.childNodes[j].nodeName.toLowerCase() !== "#text") {
            var entry = desc.childNodes[j];
            var name = entry.nodeName.toLowerCase();

            this._metadataMap.set(name, entry.textContent.trim());
          }
        }
      }
    }
  }, {
    key: "get",
    value: function get(name) {
      return this._metadataMap.has(name) ? this._metadataMap.get(name) : null;
    }
  }, {
    key: "getAll",
    value: function getAll() {
      var obj = Object.create(null);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this._metadataMap[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          obj[key] = value;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return obj;
    }
  }, {
    key: "has",
    value: function has(name) {
      return this._metadataMap.has(name);
    }
  }]);

  return Metadata;
}();

exports.Metadata = Metadata;

/***/ }),
/* 202 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleXMLParser = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var XMLParserErrorCode = {
  NoError: 0,
  EndOfDocument: -1,
  UnterminatedCdat: -2,
  UnterminatedXmlDeclaration: -3,
  UnterminatedDoctypeDeclaration: -4,
  UnterminatedComment: -5,
  MalformedElement: -6,
  OutOfMemory: -7,
  UnterminatedAttributeValue: -8,
  UnterminatedElement: -9,
  ElementNeverBegun: -10
};

function isWhitespace(s, index) {
  var ch = s[index];
  return ch === " " || ch === "\n" || ch === "\r" || ch === "\t";
}

function isWhitespaceString(s) {
  for (var i = 0, ii = s.length; i < ii; i++) {
    if (!isWhitespace(s, i)) {
      return false;
    }
  }

  return true;
}

var XMLParserBase = /*#__PURE__*/function () {
  function XMLParserBase() {
    _classCallCheck(this, XMLParserBase);
  }

  _createClass(XMLParserBase, [{
    key: "_resolveEntities",
    value: function _resolveEntities(s) {
      var _this = this;

      return s.replace(/&([^;]+);/g, function (all, entity) {
        if (entity.substring(0, 2) === "#x") {
          return String.fromCharCode(parseInt(entity.substring(2), 16));
        } else if (entity.substring(0, 1) === "#") {
          return String.fromCharCode(parseInt(entity.substring(1), 10));
        }

        switch (entity) {
          case "lt":
            return "<";

          case "gt":
            return ">";

          case "amp":
            return "&";

          case "quot":
            return '"';
        }

        return _this.onResolveEntity(entity);
      });
    }
  }, {
    key: "_parseContent",
    value: function _parseContent(s, start) {
      var attributes = [];
      var pos = start;

      function skipWs() {
        while (pos < s.length && isWhitespace(s, pos)) {
          ++pos;
        }
      }

      while (pos < s.length && !isWhitespace(s, pos) && s[pos] !== ">" && s[pos] !== "/") {
        ++pos;
      }

      var name = s.substring(start, pos);
      skipWs();

      while (pos < s.length && s[pos] !== ">" && s[pos] !== "/" && s[pos] !== "?") {
        skipWs();
        var attrName = "",
            attrValue = "";

        while (pos < s.length && !isWhitespace(s, pos) && s[pos] !== "=") {
          attrName += s[pos];
          ++pos;
        }

        skipWs();

        if (s[pos] !== "=") {
          return null;
        }

        ++pos;
        skipWs();
        var attrEndChar = s[pos];

        if (attrEndChar !== '"' && attrEndChar !== "'") {
          return null;
        }

        var attrEndIndex = s.indexOf(attrEndChar, ++pos);

        if (attrEndIndex < 0) {
          return null;
        }

        attrValue = s.substring(pos, attrEndIndex);
        attributes.push({
          name: attrName,
          value: this._resolveEntities(attrValue)
        });
        pos = attrEndIndex + 1;
        skipWs();
      }

      return {
        name: name,
        attributes: attributes,
        parsed: pos - start
      };
    }
  }, {
    key: "_parseProcessingInstruction",
    value: function _parseProcessingInstruction(s, start) {
      var pos = start;

      function skipWs() {
        while (pos < s.length && isWhitespace(s, pos)) {
          ++pos;
        }
      }

      while (pos < s.length && !isWhitespace(s, pos) && s[pos] !== ">" && s[pos] !== "/") {
        ++pos;
      }

      var name = s.substring(start, pos);
      skipWs();
      var attrStart = pos;

      while (pos < s.length && (s[pos] !== "?" || s[pos + 1] !== ">")) {
        ++pos;
      }

      var value = s.substring(attrStart, pos);
      return {
        name: name,
        value: value,
        parsed: pos - start
      };
    }
  }, {
    key: "parseXml",
    value: function parseXml(s) {
      var i = 0;

      while (i < s.length) {
        var ch = s[i];
        var j = i;

        if (ch === "<") {
          ++j;
          var ch2 = s[j];
          var q = void 0;

          switch (ch2) {
            case "/":
              ++j;
              q = s.indexOf(">", j);

              if (q < 0) {
                this.onError(XMLParserErrorCode.UnterminatedElement);
                return;
              }

              this.onEndElement(s.substring(j, q));
              j = q + 1;
              break;

            case "?":
              ++j;

              var pi = this._parseProcessingInstruction(s, j);

              if (s.substring(j + pi.parsed, j + pi.parsed + 2) !== "?>") {
                this.onError(XMLParserErrorCode.UnterminatedXmlDeclaration);
                return;
              }

              this.onPi(pi.name, pi.value);
              j += pi.parsed + 2;
              break;

            case "!":
              if (s.substring(j + 1, j + 3) === "--") {
                q = s.indexOf("-->", j + 3);

                if (q < 0) {
                  this.onError(XMLParserErrorCode.UnterminatedComment);
                  return;
                }

                this.onComment(s.substring(j + 3, q));
                j = q + 3;
              } else if (s.substring(j + 1, j + 8) === "[CDATA[") {
                q = s.indexOf("]]>", j + 8);

                if (q < 0) {
                  this.onError(XMLParserErrorCode.UnterminatedCdat);
                  return;
                }

                this.onCdata(s.substring(j + 8, q));
                j = q + 3;
              } else if (s.substring(j + 1, j + 8) === "DOCTYPE") {
                var q2 = s.indexOf("[", j + 8);
                var complexDoctype = false;
                q = s.indexOf(">", j + 8);

                if (q < 0) {
                  this.onError(XMLParserErrorCode.UnterminatedDoctypeDeclaration);
                  return;
                }

                if (q2 > 0 && q > q2) {
                  q = s.indexOf("]>", j + 8);

                  if (q < 0) {
                    this.onError(XMLParserErrorCode.UnterminatedDoctypeDeclaration);
                    return;
                  }

                  complexDoctype = true;
                }

                var doctypeContent = s.substring(j + 8, q + (complexDoctype ? 1 : 0));
                this.onDoctype(doctypeContent);
                j = q + (complexDoctype ? 2 : 1);
              } else {
                this.onError(XMLParserErrorCode.MalformedElement);
                return;
              }

              break;

            default:
              var content = this._parseContent(s, j);

              if (content === null) {
                this.onError(XMLParserErrorCode.MalformedElement);
                return;
              }

              var isClosed = false;

              if (s.substring(j + content.parsed, j + content.parsed + 2) === "/>") {
                isClosed = true;
              } else if (s.substring(j + content.parsed, j + content.parsed + 1) !== ">") {
                this.onError(XMLParserErrorCode.UnterminatedElement);
                return;
              }

              this.onBeginElement(content.name, content.attributes, isClosed);
              j += content.parsed + (isClosed ? 2 : 1);
              break;
          }
        } else {
          while (j < s.length && s[j] !== "<") {
            j++;
          }

          var text = s.substring(i, j);
          this.onText(this._resolveEntities(text));
        }

        i = j;
      }
    }
  }, {
    key: "onResolveEntity",
    value: function onResolveEntity(name) {
      return "&".concat(name, ";");
    }
  }, {
    key: "onPi",
    value: function onPi(name, value) {}
  }, {
    key: "onComment",
    value: function onComment(text) {}
  }, {
    key: "onCdata",
    value: function onCdata(text) {}
  }, {
    key: "onDoctype",
    value: function onDoctype(doctypeContent) {}
  }, {
    key: "onText",
    value: function onText(text) {}
  }, {
    key: "onBeginElement",
    value: function onBeginElement(name, attributes, isEmpty) {}
  }, {
    key: "onEndElement",
    value: function onEndElement(name) {}
  }, {
    key: "onError",
    value: function onError(code) {}
  }]);

  return XMLParserBase;
}();

var SimpleDOMNode = /*#__PURE__*/function () {
  function SimpleDOMNode(nodeName, nodeValue) {
    _classCallCheck(this, SimpleDOMNode);

    this.nodeName = nodeName;
    this.nodeValue = nodeValue;
    Object.defineProperty(this, "parentNode", {
      value: null,
      writable: true
    });
  }

  _createClass(SimpleDOMNode, [{
    key: "hasChildNodes",
    value: function hasChildNodes() {
      return this.childNodes && this.childNodes.length > 0;
    }
  }, {
    key: "firstChild",
    get: function get() {
      return this.childNodes && this.childNodes[0];
    }
  }, {
    key: "nextSibling",
    get: function get() {
      var childNodes = this.parentNode.childNodes;

      if (!childNodes) {
        return undefined;
      }

      var index = childNodes.indexOf(this);

      if (index === -1) {
        return undefined;
      }

      return childNodes[index + 1];
    }
  }, {
    key: "textContent",
    get: function get() {
      if (!this.childNodes) {
        return this.nodeValue || "";
      }

      return this.childNodes.map(function (child) {
        return child.textContent;
      }).join("");
    }
  }]);

  return SimpleDOMNode;
}();

var SimpleXMLParser = /*#__PURE__*/function (_XMLParserBase) {
  _inherits(SimpleXMLParser, _XMLParserBase);

  function SimpleXMLParser() {
    var _this2;

    _classCallCheck(this, SimpleXMLParser);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(SimpleXMLParser).call(this));
    _this2._currentFragment = null;
    _this2._stack = null;
    _this2._errorCode = XMLParserErrorCode.NoError;
    return _this2;
  }

  _createClass(SimpleXMLParser, [{
    key: "parseFromString",
    value: function parseFromString(data) {
      this._currentFragment = [];
      this._stack = [];
      this._errorCode = XMLParserErrorCode.NoError;
      this.parseXml(data);

      if (this._errorCode !== XMLParserErrorCode.NoError) {
        return undefined;
      }

      var _this$_currentFragmen = _slicedToArray(this._currentFragment, 1),
          documentElement = _this$_currentFragmen[0];

      if (!documentElement) {
        return undefined;
      }

      return {
        documentElement: documentElement
      };
    }
  }, {
    key: "onResolveEntity",
    value: function onResolveEntity(name) {
      switch (name) {
        case "apos":
          return "'";
      }

      return _get(_getPrototypeOf(SimpleXMLParser.prototype), "onResolveEntity", this).call(this, name);
    }
  }, {
    key: "onText",
    value: function onText(text) {
      if (isWhitespaceString(text)) {
        return;
      }

      var node = new SimpleDOMNode("#text", text);

      this._currentFragment.push(node);
    }
  }, {
    key: "onCdata",
    value: function onCdata(text) {
      var node = new SimpleDOMNode("#text", text);

      this._currentFragment.push(node);
    }
  }, {
    key: "onBeginElement",
    value: function onBeginElement(name, attributes, isEmpty) {
      var node = new SimpleDOMNode(name);
      node.childNodes = [];

      this._currentFragment.push(node);

      if (isEmpty) {
        return;
      }

      this._stack.push(this._currentFragment);

      this._currentFragment = node.childNodes;
    }
  }, {
    key: "onEndElement",
    value: function onEndElement(name) {
      this._currentFragment = this._stack.pop() || [];
      var lastElement = this._currentFragment[this._currentFragment.length - 1];

      if (!lastElement) {
        return;
      }

      for (var i = 0, ii = lastElement.childNodes.length; i < ii; i++) {
        lastElement.childNodes[i].parentNode = lastElement;
      }
    }
  }, {
    key: "onError",
    value: function onError(code) {
      this._errorCode = code;
    }
  }]);

  return SimpleXMLParser;
}(XMLParserBase);

exports.SimpleXMLParser = SimpleXMLParser;

/***/ }),
/* 203 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFDataTransportStream = void 0;

var _regenerator = _interopRequireDefault(__w_pdfjs_require__(191));

var _util = __w_pdfjs_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PDFDataTransportStream = /*#__PURE__*/function () {
  function PDFDataTransportStream(params, pdfDataRangeTransport) {
    var _this = this;

    _classCallCheck(this, PDFDataTransportStream);

    (0, _util.assert)(pdfDataRangeTransport);
    this._queuedChunks = [];
    this._progressiveDone = params.progressiveDone || false;
    var initialData = params.initialData;

    if (initialData && initialData.length > 0) {
      var buffer = new Uint8Array(initialData).buffer;

      this._queuedChunks.push(buffer);
    }

    this._pdfDataRangeTransport = pdfDataRangeTransport;
    this._isStreamingSupported = !params.disableStream;
    this._isRangeSupported = !params.disableRange;
    this._contentLength = params.length;
    this._fullRequestReader = null;
    this._rangeReaders = [];

    this._pdfDataRangeTransport.addRangeListener(function (begin, chunk) {
      _this._onReceiveData({
        begin: begin,
        chunk: chunk
      });
    });

    this._pdfDataRangeTransport.addProgressListener(function (loaded, total) {
      _this._onProgress({
        loaded: loaded,
        total: total
      });
    });

    this._pdfDataRangeTransport.addProgressiveReadListener(function (chunk) {
      _this._onReceiveData({
        chunk: chunk
      });
    });

    this._pdfDataRangeTransport.addProgressiveDoneListener(function () {
      _this._onProgressiveDone();
    });

    this._pdfDataRangeTransport.transportReady();
  }

  _createClass(PDFDataTransportStream, [{
    key: "_onReceiveData",
    value: function _onReceiveData(args) {
      var buffer = new Uint8Array(args.chunk).buffer;

      if (args.begin === undefined) {
        if (this._fullRequestReader) {
          this._fullRequestReader._enqueue(buffer);
        } else {
          this._queuedChunks.push(buffer);
        }
      } else {
        var found = this._rangeReaders.some(function (rangeReader) {
          if (rangeReader._begin !== args.begin) {
            return false;
          }

          rangeReader._enqueue(buffer);

          return true;
        });

        (0, _util.assert)(found);
      }
    }
  }, {
    key: "_onProgress",
    value: function _onProgress(evt) {
      if (evt.total === undefined) {
        var firstReader = this._rangeReaders[0];

        if (firstReader && firstReader.onProgress) {
          firstReader.onProgress({
            loaded: evt.loaded
          });
        }
      } else {
        var fullReader = this._fullRequestReader;

        if (fullReader && fullReader.onProgress) {
          fullReader.onProgress({
            loaded: evt.loaded,
            total: evt.total
          });
        }
      }
    }
  }, {
    key: "_onProgressiveDone",
    value: function _onProgressiveDone() {
      if (this._fullRequestReader) {
        this._fullRequestReader.progressiveDone();
      }

      this._progressiveDone = true;
    }
  }, {
    key: "_removeRangeReader",
    value: function _removeRangeReader(reader) {
      var i = this._rangeReaders.indexOf(reader);

      if (i >= 0) {
        this._rangeReaders.splice(i, 1);
      }
    }
  }, {
    key: "getFullReader",
    value: function getFullReader() {
      (0, _util.assert)(!this._fullRequestReader);
      var queuedChunks = this._queuedChunks;
      this._queuedChunks = null;
      return new PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone);
    }
  }, {
    key: "getRangeReader",
    value: function getRangeReader(begin, end) {
      if (end <= this._progressiveDataLength) {
        return null;
      }

      var reader = new PDFDataTransportStreamRangeReader(this, begin, end);

      this._pdfDataRangeTransport.requestDataRange(begin, end);

      this._rangeReaders.push(reader);

      return reader;
    }
  }, {
    key: "cancelAllRequests",
    value: function cancelAllRequests(reason) {
      if (this._fullRequestReader) {
        this._fullRequestReader.cancel(reason);
      }

      var readers = this._rangeReaders.slice(0);

      readers.forEach(function (rangeReader) {
        rangeReader.cancel(reason);
      });

      this._pdfDataRangeTransport.abort();
    }
  }, {
    key: "_progressiveDataLength",
    get: function get() {
      return this._fullRequestReader ? this._fullRequestReader._loaded : 0;
    }
  }]);

  return PDFDataTransportStream;
}();

exports.PDFDataTransportStream = PDFDataTransportStream;

var PDFDataTransportStreamReader = /*#__PURE__*/function () {
  function PDFDataTransportStreamReader(stream, queuedChunks) {
    var progressiveDone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, PDFDataTransportStreamReader);

    this._stream = stream;
    this._done = progressiveDone || false;
    this._filename = null;
    this._queuedChunks = queuedChunks || [];
    this._loaded = 0;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = this._queuedChunks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var chunk = _step.value;
        this._loaded += chunk.byteLength;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    this._requests = [];
    this._headersReady = Promise.resolve();
    stream._fullRequestReader = this;
    this.onProgress = null;
  }

  _createClass(PDFDataTransportStreamReader, [{
    key: "_enqueue",
    value: function _enqueue(chunk) {
      if (this._done) {
        return;
      }

      if (this._requests.length > 0) {
        var requestCapability = this._requests.shift();

        requestCapability.resolve({
          value: chunk,
          done: false
        });
      } else {
        this._queuedChunks.push(chunk);
      }

      this._loaded += chunk.byteLength;
    }
  }, {
    key: "read",
    value: function () {
      var _read = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var chunk, requestCapability;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this._queuedChunks.length > 0)) {
                  _context.next = 3;
                  break;
                }

                chunk = this._queuedChunks.shift();
                return _context.abrupt("return", {
                  value: chunk,
                  done: false
                });

              case 3:
                if (!this._done) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", {
                  value: undefined,
                  done: true
                });

              case 5:
                requestCapability = (0, _util.createPromiseCapability)();

                this._requests.push(requestCapability);

                return _context.abrupt("return", requestCapability.promise);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function read() {
        return _read.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      this._done = true;

      this._requests.forEach(function (requestCapability) {
        requestCapability.resolve({
          value: undefined,
          done: true
        });
      });

      this._requests = [];
    }
  }, {
    key: "progressiveDone",
    value: function progressiveDone() {
      if (this._done) {
        return;
      }

      this._done = true;
    }
  }, {
    key: "headersReady",
    get: function get() {
      return this._headersReady;
    }
  }, {
    key: "filename",
    get: function get() {
      return this._filename;
    }
  }, {
    key: "isRangeSupported",
    get: function get() {
      return this._stream._isRangeSupported;
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return this._stream._isStreamingSupported;
    }
  }, {
    key: "contentLength",
    get: function get() {
      return this._stream._contentLength;
    }
  }]);

  return PDFDataTransportStreamReader;
}();

var PDFDataTransportStreamRangeReader = /*#__PURE__*/function () {
  function PDFDataTransportStreamRangeReader(stream, begin, end) {
    _classCallCheck(this, PDFDataTransportStreamRangeReader);

    this._stream = stream;
    this._begin = begin;
    this._end = end;
    this._queuedChunk = null;
    this._requests = [];
    this._done = false;
    this.onProgress = null;
  }

  _createClass(PDFDataTransportStreamRangeReader, [{
    key: "_enqueue",
    value: function _enqueue(chunk) {
      if (this._done) {
        return;
      }

      if (this._requests.length === 0) {
        this._queuedChunk = chunk;
      } else {
        var requestsCapability = this._requests.shift();

        requestsCapability.resolve({
          value: chunk,
          done: false
        });

        this._requests.forEach(function (requestCapability) {
          requestCapability.resolve({
            value: undefined,
            done: true
          });
        });

        this._requests = [];
      }

      this._done = true;

      this._stream._removeRangeReader(this);
    }
  }, {
    key: "read",
    value: function () {
      var _read2 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var chunk, requestCapability;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this._queuedChunk) {
                  _context2.next = 4;
                  break;
                }

                chunk = this._queuedChunk;
                this._queuedChunk = null;
                return _context2.abrupt("return", {
                  value: chunk,
                  done: false
                });

              case 4:
                if (!this._done) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", {
                  value: undefined,
                  done: true
                });

              case 6:
                requestCapability = (0, _util.createPromiseCapability)();

                this._requests.push(requestCapability);

                return _context2.abrupt("return", requestCapability.promise);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function read() {
        return _read2.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      this._done = true;

      this._requests.forEach(function (requestCapability) {
        requestCapability.resolve({
          value: undefined,
          done: true
        });
      });

      this._requests = [];

      this._stream._removeRangeReader(this);
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return false;
    }
  }]);

  return PDFDataTransportStreamRangeReader;
}();

/***/ }),
/* 204 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebGLContext = void 0;

var _util = __w_pdfjs_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var WebGLContext = /*#__PURE__*/function () {
  function WebGLContext(_ref) {
    var _ref$enable = _ref.enable,
        enable = _ref$enable === void 0 ? false : _ref$enable;

    _classCallCheck(this, WebGLContext);

    this._enabled = enable === true;
  }

  _createClass(WebGLContext, [{
    key: "composeSMask",
    value: function composeSMask(_ref2) {
      var layer = _ref2.layer,
          mask = _ref2.mask,
          properties = _ref2.properties;
      return WebGLUtils.composeSMask(layer, mask, properties);
    }
  }, {
    key: "drawFigures",
    value: function drawFigures(_ref3) {
      var width = _ref3.width,
          height = _ref3.height,
          backgroundColor = _ref3.backgroundColor,
          figures = _ref3.figures,
          context = _ref3.context;
      return WebGLUtils.drawFigures(width, height, backgroundColor, figures, context);
    }
  }, {
    key: "clear",
    value: function clear() {
      WebGLUtils.cleanup();
    }
  }, {
    key: "isEnabled",
    get: function get() {
      var enabled = this._enabled;

      if (enabled) {
        enabled = WebGLUtils.tryInitGL();
      }

      return (0, _util.shadow)(this, "isEnabled", enabled);
    }
  }]);

  return WebGLContext;
}();

exports.WebGLContext = WebGLContext;

var WebGLUtils = function WebGLUtilsClosure() {
  function loadShader(gl, code, shaderType) {
    var shader = gl.createShader(shaderType);
    gl.shaderSource(shader, code);
    gl.compileShader(shader);
    var compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);

    if (!compiled) {
      var errorMsg = gl.getShaderInfoLog(shader);
      throw new Error("Error during shader compilation: " + errorMsg);
    }

    return shader;
  }

  function createVertexShader(gl, code) {
    return loadShader(gl, code, gl.VERTEX_SHADER);
  }

  function createFragmentShader(gl, code) {
    return loadShader(gl, code, gl.FRAGMENT_SHADER);
  }

  function createProgram(gl, shaders) {
    var program = gl.createProgram();

    for (var i = 0, ii = shaders.length; i < ii; ++i) {
      gl.attachShader(program, shaders[i]);
    }

    gl.linkProgram(program);
    var linked = gl.getProgramParameter(program, gl.LINK_STATUS);

    if (!linked) {
      var errorMsg = gl.getProgramInfoLog(program);
      throw new Error("Error during program linking: " + errorMsg);
    }

    return program;
  }

  function createTexture(gl, image, textureId) {
    gl.activeTexture(textureId);
    var texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
    return texture;
  }

  var currentGL, currentCanvas;

  function generateGL() {
    if (currentGL) {
      return;
    }

    currentCanvas = document.createElement("canvas");
    currentGL = currentCanvas.getContext("webgl", {
      premultipliedalpha: false
    });
  }

  var smaskVertexShaderCode = "\
  attribute vec2 a_position;                                    \
  attribute vec2 a_texCoord;                                    \
                                                                \
  uniform vec2 u_resolution;                                    \
                                                                \
  varying vec2 v_texCoord;                                      \
                                                                \
  void main() {                                                 \
    vec2 clipSpace = (a_position / u_resolution) * 2.0 - 1.0;   \
    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
                                                                \
    v_texCoord = a_texCoord;                                    \
  }                                                             ";
  var smaskFragmentShaderCode = "\
  precision mediump float;                                      \
                                                                \
  uniform vec4 u_backdrop;                                      \
  uniform int u_subtype;                                        \
  uniform sampler2D u_image;                                    \
  uniform sampler2D u_mask;                                     \
                                                                \
  varying vec2 v_texCoord;                                      \
                                                                \
  void main() {                                                 \
    vec4 imageColor = texture2D(u_image, v_texCoord);           \
    vec4 maskColor = texture2D(u_mask, v_texCoord);             \
    if (u_backdrop.a > 0.0) {                                   \
      maskColor.rgb = maskColor.rgb * maskColor.a +             \
                      u_backdrop.rgb * (1.0 - maskColor.a);     \
    }                                                           \
    float lum;                                                  \
    if (u_subtype == 0) {                                       \
      lum = maskColor.a;                                        \
    } else {                                                    \
      lum = maskColor.r * 0.3 + maskColor.g * 0.59 +            \
            maskColor.b * 0.11;                                 \
    }                                                           \
    imageColor.a *= lum;                                        \
    imageColor.rgb *= imageColor.a;                             \
    gl_FragColor = imageColor;                                  \
  }                                                             ";
  var smaskCache = null;

  function initSmaskGL() {
    var canvas, gl;
    generateGL();
    canvas = currentCanvas;
    currentCanvas = null;
    gl = currentGL;
    currentGL = null;
    var vertexShader = createVertexShader(gl, smaskVertexShaderCode);
    var fragmentShader = createFragmentShader(gl, smaskFragmentShaderCode);
    var program = createProgram(gl, [vertexShader, fragmentShader]);
    gl.useProgram(program);
    var cache = {};
    cache.gl = gl;
    cache.canvas = canvas;
    cache.resolutionLocation = gl.getUniformLocation(program, "u_resolution");
    cache.positionLocation = gl.getAttribLocation(program, "a_position");
    cache.backdropLocation = gl.getUniformLocation(program, "u_backdrop");
    cache.subtypeLocation = gl.getUniformLocation(program, "u_subtype");
    var texCoordLocation = gl.getAttribLocation(program, "a_texCoord");
    var texLayerLocation = gl.getUniformLocation(program, "u_image");
    var texMaskLocation = gl.getUniformLocation(program, "u_mask");
    var texCoordBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0]), gl.STATIC_DRAW);
    gl.enableVertexAttribArray(texCoordLocation);
    gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0);
    gl.uniform1i(texLayerLocation, 0);
    gl.uniform1i(texMaskLocation, 1);
    smaskCache = cache;
  }

  function composeSMask(layer, mask, properties) {
    var width = layer.width,
        height = layer.height;

    if (!smaskCache) {
      initSmaskGL();
    }

    var cache = smaskCache,
        canvas = cache.canvas,
        gl = cache.gl;
    canvas.width = width;
    canvas.height = height;
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    gl.uniform2f(cache.resolutionLocation, width, height);

    if (properties.backdrop) {
      gl.uniform4f(cache.resolutionLocation, properties.backdrop[0], properties.backdrop[1], properties.backdrop[2], 1);
    } else {
      gl.uniform4f(cache.resolutionLocation, 0, 0, 0, 0);
    }

    gl.uniform1i(cache.subtypeLocation, properties.subtype === "Luminosity" ? 1 : 0);
    var texture = createTexture(gl, layer, gl.TEXTURE0);
    var maskTexture = createTexture(gl, mask, gl.TEXTURE1);
    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, width, 0, 0, height, 0, height, width, 0, width, height]), gl.STATIC_DRAW);
    gl.enableVertexAttribArray(cache.positionLocation);
    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
    gl.clearColor(0, 0, 0, 0);
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.drawArrays(gl.TRIANGLES, 0, 6);
    gl.flush();
    gl.deleteTexture(texture);
    gl.deleteTexture(maskTexture);
    gl.deleteBuffer(buffer);
    return canvas;
  }

  var figuresVertexShaderCode = "\
  attribute vec2 a_position;                                    \
  attribute vec3 a_color;                                       \
                                                                \
  uniform vec2 u_resolution;                                    \
  uniform vec2 u_scale;                                         \
  uniform vec2 u_offset;                                        \
                                                                \
  varying vec4 v_color;                                         \
                                                                \
  void main() {                                                 \
    vec2 position = (a_position + u_offset) * u_scale;          \
    vec2 clipSpace = (position / u_resolution) * 2.0 - 1.0;     \
    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
                                                                \
    v_color = vec4(a_color / 255.0, 1.0);                       \
  }                                                             ";
  var figuresFragmentShaderCode = "\
  precision mediump float;                                      \
                                                                \
  varying vec4 v_color;                                         \
                                                                \
  void main() {                                                 \
    gl_FragColor = v_color;                                     \
  }                                                             ";
  var figuresCache = null;

  function initFiguresGL() {
    var canvas, gl;
    generateGL();
    canvas = currentCanvas;
    currentCanvas = null;
    gl = currentGL;
    currentGL = null;
    var vertexShader = createVertexShader(gl, figuresVertexShaderCode);
    var fragmentShader = createFragmentShader(gl, figuresFragmentShaderCode);
    var program = createProgram(gl, [vertexShader, fragmentShader]);
    gl.useProgram(program);
    var cache = {};
    cache.gl = gl;
    cache.canvas = canvas;
    cache.resolutionLocation = gl.getUniformLocation(program, "u_resolution");
    cache.scaleLocation = gl.getUniformLocation(program, "u_scale");
    cache.offsetLocation = gl.getUniformLocation(program, "u_offset");
    cache.positionLocation = gl.getAttribLocation(program, "a_position");
    cache.colorLocation = gl.getAttribLocation(program, "a_color");
    figuresCache = cache;
  }

  function drawFigures(width, height, backgroundColor, figures, context) {
    if (!figuresCache) {
      initFiguresGL();
    }

    var cache = figuresCache,
        canvas = cache.canvas,
        gl = cache.gl;
    canvas.width = width;
    canvas.height = height;
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    gl.uniform2f(cache.resolutionLocation, width, height);
    var count = 0;
    var i, ii, rows;

    for (i = 0, ii = figures.length; i < ii; i++) {
      switch (figures[i].type) {
        case "lattice":
          rows = figures[i].coords.length / figures[i].verticesPerRow | 0;
          count += (rows - 1) * (figures[i].verticesPerRow - 1) * 6;
          break;

        case "triangles":
          count += figures[i].coords.length;
          break;
      }
    }

    var coords = new Float32Array(count * 2);
    var colors = new Uint8Array(count * 3);
    var coordsMap = context.coords,
        colorsMap = context.colors;
    var pIndex = 0,
        cIndex = 0;

    for (i = 0, ii = figures.length; i < ii; i++) {
      var figure = figures[i],
          ps = figure.coords,
          cs = figure.colors;

      switch (figure.type) {
        case "lattice":
          var cols = figure.verticesPerRow;
          rows = ps.length / cols | 0;

          for (var row = 1; row < rows; row++) {
            var offset = row * cols + 1;

            for (var col = 1; col < cols; col++, offset++) {
              coords[pIndex] = coordsMap[ps[offset - cols - 1]];
              coords[pIndex + 1] = coordsMap[ps[offset - cols - 1] + 1];
              coords[pIndex + 2] = coordsMap[ps[offset - cols]];
              coords[pIndex + 3] = coordsMap[ps[offset - cols] + 1];
              coords[pIndex + 4] = coordsMap[ps[offset - 1]];
              coords[pIndex + 5] = coordsMap[ps[offset - 1] + 1];
              colors[cIndex] = colorsMap[cs[offset - cols - 1]];
              colors[cIndex + 1] = colorsMap[cs[offset - cols - 1] + 1];
              colors[cIndex + 2] = colorsMap[cs[offset - cols - 1] + 2];
              colors[cIndex + 3] = colorsMap[cs[offset - cols]];
              colors[cIndex + 4] = colorsMap[cs[offset - cols] + 1];
              colors[cIndex + 5] = colorsMap[cs[offset - cols] + 2];
              colors[cIndex + 6] = colorsMap[cs[offset - 1]];
              colors[cIndex + 7] = colorsMap[cs[offset - 1] + 1];
              colors[cIndex + 8] = colorsMap[cs[offset - 1] + 2];
              coords[pIndex + 6] = coords[pIndex + 2];
              coords[pIndex + 7] = coords[pIndex + 3];
              coords[pIndex + 8] = coords[pIndex + 4];
              coords[pIndex + 9] = coords[pIndex + 5];
              coords[pIndex + 10] = coordsMap[ps[offset]];
              coords[pIndex + 11] = coordsMap[ps[offset] + 1];
              colors[cIndex + 9] = colors[cIndex + 3];
              colors[cIndex + 10] = colors[cIndex + 4];
              colors[cIndex + 11] = colors[cIndex + 5];
              colors[cIndex + 12] = colors[cIndex + 6];
              colors[cIndex + 13] = colors[cIndex + 7];
              colors[cIndex + 14] = colors[cIndex + 8];
              colors[cIndex + 15] = colorsMap[cs[offset]];
              colors[cIndex + 16] = colorsMap[cs[offset] + 1];
              colors[cIndex + 17] = colorsMap[cs[offset] + 2];
              pIndex += 12;
              cIndex += 18;
            }
          }

          break;

        case "triangles":
          for (var j = 0, jj = ps.length; j < jj; j++) {
            coords[pIndex] = coordsMap[ps[j]];
            coords[pIndex + 1] = coordsMap[ps[j] + 1];
            colors[cIndex] = colorsMap[cs[j]];
            colors[cIndex + 1] = colorsMap[cs[j] + 1];
            colors[cIndex + 2] = colorsMap[cs[j] + 2];
            pIndex += 2;
            cIndex += 3;
          }

          break;
      }
    }

    if (backgroundColor) {
      gl.clearColor(backgroundColor[0] / 255, backgroundColor[1] / 255, backgroundColor[2] / 255, 1.0);
    } else {
      gl.clearColor(0, 0, 0, 0);
    }

    gl.clear(gl.COLOR_BUFFER_BIT);
    var coordsBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, coordsBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, coords, gl.STATIC_DRAW);
    gl.enableVertexAttribArray(cache.positionLocation);
    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
    var colorsBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, colorsBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, colors, gl.STATIC_DRAW);
    gl.enableVertexAttribArray(cache.colorLocation);
    gl.vertexAttribPointer(cache.colorLocation, 3, gl.UNSIGNED_BYTE, false, 0, 0);
    gl.uniform2f(cache.scaleLocation, context.scaleX, context.scaleY);
    gl.uniform2f(cache.offsetLocation, context.offsetX, context.offsetY);
    gl.drawArrays(gl.TRIANGLES, 0, count);
    gl.flush();
    gl.deleteBuffer(coordsBuffer);
    gl.deleteBuffer(colorsBuffer);
    return canvas;
  }

  return {
    tryInitGL: function tryInitGL() {
      try {
        generateGL();
        return !!currentGL;
      } catch (ex) {}

      return false;
    },
    composeSMask: composeSMask,
    drawFigures: drawFigures,
    cleanup: function cleanup() {
      if (smaskCache && smaskCache.canvas) {
        smaskCache.canvas.width = 0;
        smaskCache.canvas.height = 0;
      }

      if (figuresCache && figuresCache.canvas) {
        figuresCache.canvas.width = 0;
        figuresCache.canvas.height = 0;
      }

      smaskCache = null;
      figuresCache = null;
    }
  };
}();

/***/ }),
/* 205 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderTextLayer = void 0;

var _util = __w_pdfjs_require__(1);

var renderTextLayer = function renderTextLayerClosure() {
  var MAX_TEXT_DIVS_TO_RENDER = 100000;
  var NonWhitespaceRegexp = /\S/;

  function isAllWhitespace(str) {
    return !NonWhitespaceRegexp.test(str);
  }

  function appendText(task, geom, styles) {
    var textDiv = document.createElement("span");
    var textDivProperties = {
      angle: 0,
      canvasWidth: 0,
      isWhitespace: false,
      originalTransform: null,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      scale: 1
    };

    task._textDivs.push(textDiv);

    if (isAllWhitespace(geom.str)) {
      textDivProperties.isWhitespace = true;

      task._textDivProperties.set(textDiv, textDivProperties);

      return;
    }

    var tx = _util.Util.transform(task._viewport.transform, geom.transform);

    var angle = Math.atan2(tx[1], tx[0]);
    var style = styles[geom.fontName];

    if (style.vertical) {
      angle += Math.PI / 2;
    }

    var fontHeight = Math.sqrt(tx[2] * tx[2] + tx[3] * tx[3]);
    var fontAscent = fontHeight;

    if (style.ascent) {
      fontAscent = style.ascent * fontAscent;
    } else if (style.descent) {
      fontAscent = (1 + style.descent) * fontAscent;
    }

    var left, top;

    if (angle === 0) {
      left = tx[4];
      top = tx[5] - fontAscent;
    } else {
      left = tx[4] + fontAscent * Math.sin(angle);
      top = tx[5] - fontAscent * Math.cos(angle);
    }

    textDiv.style.left = "".concat(left, "px");
    textDiv.style.top = "".concat(top, "px");
    textDiv.style.fontSize = "".concat(fontHeight, "px");
    textDiv.style.fontFamily = style.fontFamily;
    textDiv.textContent = geom.str;

    if (task._fontInspectorEnabled) {
      textDiv.dataset.fontName = geom.fontName;
    }

    if (angle !== 0) {
      textDivProperties.angle = angle * (180 / Math.PI);
    }

    if (geom.str.length > 1) {
      if (style.vertical) {
        textDivProperties.canvasWidth = geom.height * task._viewport.scale;
      } else {
        textDivProperties.canvasWidth = geom.width * task._viewport.scale;
      }
    }

    task._textDivProperties.set(textDiv, textDivProperties);

    if (task._textContentStream) {
      task._layoutText(textDiv);
    }

    if (task._enhanceTextSelection) {
      var angleCos = 1,
          angleSin = 0;

      if (angle !== 0) {
        angleCos = Math.cos(angle);
        angleSin = Math.sin(angle);
      }

      var divWidth = (style.vertical ? geom.height : geom.width) * task._viewport.scale;
      var divHeight = fontHeight;
      var m, b;

      if (angle !== 0) {
        m = [angleCos, angleSin, -angleSin, angleCos, left, top];
        b = _util.Util.getAxialAlignedBoundingBox([0, 0, divWidth, divHeight], m);
      } else {
        b = [left, top, left + divWidth, top + divHeight];
      }

      task._bounds.push({
        left: b[0],
        top: b[1],
        right: b[2],
        bottom: b[3],
        div: textDiv,
        size: [divWidth, divHeight],
        m: m
      });
    }
  }

  function render(task) {
    if (task._canceled) {
      return;
    }

    var textDivs = task._textDivs;
    var capability = task._capability;
    var textDivsLength = textDivs.length;

    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
      task._renderingDone = true;
      capability.resolve();
      return;
    }

    if (!task._textContentStream) {
      for (var i = 0; i < textDivsLength; i++) {
        task._layoutText(textDivs[i]);
      }
    }

    task._renderingDone = true;
    capability.resolve();
  }

  function expand(task) {
    var bounds = task._bounds;
    var viewport = task._viewport;
    var expanded = expandBounds(viewport.width, viewport.height, bounds);

    for (var i = 0; i < expanded.length; i++) {
      var div = bounds[i].div;

      var divProperties = task._textDivProperties.get(div);

      if (divProperties.angle === 0) {
        divProperties.paddingLeft = bounds[i].left - expanded[i].left;
        divProperties.paddingTop = bounds[i].top - expanded[i].top;
        divProperties.paddingRight = expanded[i].right - bounds[i].right;
        divProperties.paddingBottom = expanded[i].bottom - bounds[i].bottom;

        task._textDivProperties.set(div, divProperties);

        continue;
      }

      var e = expanded[i],
          b = bounds[i];
      var m = b.m,
          c = m[0],
          s = m[1];
      var points = [[0, 0], [0, b.size[1]], [b.size[0], 0], b.size];
      var ts = new Float64Array(64);
      points.forEach(function (p, i) {
        var t = _util.Util.applyTransform(p, m);

        ts[i + 0] = c && (e.left - t[0]) / c;
        ts[i + 4] = s && (e.top - t[1]) / s;
        ts[i + 8] = c && (e.right - t[0]) / c;
        ts[i + 12] = s && (e.bottom - t[1]) / s;
        ts[i + 16] = s && (e.left - t[0]) / -s;
        ts[i + 20] = c && (e.top - t[1]) / c;
        ts[i + 24] = s && (e.right - t[0]) / -s;
        ts[i + 28] = c && (e.bottom - t[1]) / c;
        ts[i + 32] = c && (e.left - t[0]) / -c;
        ts[i + 36] = s && (e.top - t[1]) / -s;
        ts[i + 40] = c && (e.right - t[0]) / -c;
        ts[i + 44] = s && (e.bottom - t[1]) / -s;
        ts[i + 48] = s && (e.left - t[0]) / s;
        ts[i + 52] = c && (e.top - t[1]) / -c;
        ts[i + 56] = s && (e.right - t[0]) / s;
        ts[i + 60] = c && (e.bottom - t[1]) / -c;
      });

      var findPositiveMin = function findPositiveMin(ts, offset, count) {
        var result = 0;

        for (var i = 0; i < count; i++) {
          var t = ts[offset++];

          if (t > 0) {
            result = result ? Math.min(t, result) : t;
          }
        }

        return result;
      };

      var boxScale = 1 + Math.min(Math.abs(c), Math.abs(s));
      divProperties.paddingLeft = findPositiveMin(ts, 32, 16) / boxScale;
      divProperties.paddingTop = findPositiveMin(ts, 48, 16) / boxScale;
      divProperties.paddingRight = findPositiveMin(ts, 0, 16) / boxScale;
      divProperties.paddingBottom = findPositiveMin(ts, 16, 16) / boxScale;

      task._textDivProperties.set(div, divProperties);
    }
  }

  function expandBounds(width, height, boxes) {
    var bounds = boxes.map(function (box, i) {
      return {
        x1: box.left,
        y1: box.top,
        x2: box.right,
        y2: box.bottom,
        index: i,
        x1New: undefined,
        x2New: undefined
      };
    });
    expandBoundsLTR(width, bounds);
    var expanded = new Array(boxes.length);
    bounds.forEach(function (b) {
      var i = b.index;
      expanded[i] = {
        left: b.x1New,
        top: 0,
        right: b.x2New,
        bottom: 0
      };
    });
    boxes.map(function (box, i) {
      var e = expanded[i],
          b = bounds[i];
      b.x1 = box.top;
      b.y1 = width - e.right;
      b.x2 = box.bottom;
      b.y2 = width - e.left;
      b.index = i;
      b.x1New = undefined;
      b.x2New = undefined;
    });
    expandBoundsLTR(height, bounds);
    bounds.forEach(function (b) {
      var i = b.index;
      expanded[i].top = b.x1New;
      expanded[i].bottom = b.x2New;
    });
    return expanded;
  }

  function expandBoundsLTR(width, bounds) {
    bounds.sort(function (a, b) {
      return a.x1 - b.x1 || a.index - b.index;
    });
    var fakeBoundary = {
      x1: -Infinity,
      y1: -Infinity,
      x2: 0,
      y2: Infinity,
      index: -1,
      x1New: 0,
      x2New: 0
    };
    var horizon = [{
      start: -Infinity,
      end: Infinity,
      boundary: fakeBoundary
    }];
    bounds.forEach(function (boundary) {
      var i = 0;

      while (i < horizon.length && horizon[i].end <= boundary.y1) {
        i++;
      }

      var j = horizon.length - 1;

      while (j >= 0 && horizon[j].start >= boundary.y2) {
        j--;
      }

      var horizonPart, affectedBoundary;
      var q,
          k,
          maxXNew = -Infinity;

      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        var xNew;

        if (affectedBoundary.x2 > boundary.x1) {
          xNew = affectedBoundary.index > boundary.index ? affectedBoundary.x1New : boundary.x1;
        } else if (affectedBoundary.x2New === undefined) {
          xNew = (affectedBoundary.x2 + boundary.x1) / 2;
        } else {
          xNew = affectedBoundary.x2New;
        }

        if (xNew > maxXNew) {
          maxXNew = xNew;
        }
      }

      boundary.x1New = maxXNew;

      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;

        if (affectedBoundary.x2New === undefined) {
          if (affectedBoundary.x2 > boundary.x1) {
            if (affectedBoundary.index > boundary.index) {
              affectedBoundary.x2New = affectedBoundary.x2;
            }
          } else {
            affectedBoundary.x2New = maxXNew;
          }
        } else if (affectedBoundary.x2New > maxXNew) {
          affectedBoundary.x2New = Math.max(maxXNew, affectedBoundary.x2);
        }
      }

      var changedHorizon = [],
          lastBoundary = null;

      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        var useBoundary = affectedBoundary.x2 > boundary.x2 ? affectedBoundary : boundary;

        if (lastBoundary === useBoundary) {
          changedHorizon[changedHorizon.length - 1].end = horizonPart.end;
        } else {
          changedHorizon.push({
            start: horizonPart.start,
            end: horizonPart.end,
            boundary: useBoundary
          });
          lastBoundary = useBoundary;
        }
      }

      if (horizon[i].start < boundary.y1) {
        changedHorizon[0].start = boundary.y1;
        changedHorizon.unshift({
          start: horizon[i].start,
          end: boundary.y1,
          boundary: horizon[i].boundary
        });
      }

      if (boundary.y2 < horizon[j].end) {
        changedHorizon[changedHorizon.length - 1].end = boundary.y2;
        changedHorizon.push({
          start: boundary.y2,
          end: horizon[j].end,
          boundary: horizon[j].boundary
        });
      }

      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;

        if (affectedBoundary.x2New !== undefined) {
          continue;
        }

        var used = false;

        for (k = i - 1; !used && k >= 0 && horizon[k].start >= affectedBoundary.y1; k--) {
          used = horizon[k].boundary === affectedBoundary;
        }

        for (k = j + 1; !used && k < horizon.length && horizon[k].end <= affectedBoundary.y2; k++) {
          used = horizon[k].boundary === affectedBoundary;
        }

        for (k = 0; !used && k < changedHorizon.length; k++) {
          used = changedHorizon[k].boundary === affectedBoundary;
        }

        if (!used) {
          affectedBoundary.x2New = maxXNew;
        }
      }

      Array.prototype.splice.apply(horizon, [i, j - i + 1].concat(changedHorizon));
    });
    horizon.forEach(function (horizonPart) {
      var affectedBoundary = horizonPart.boundary;

      if (affectedBoundary.x2New === undefined) {
        affectedBoundary.x2New = Math.max(width, affectedBoundary.x2);
      }
    });
  }

  function TextLayerRenderTask(_ref) {
    var _this = this;

    var textContent = _ref.textContent,
        textContentStream = _ref.textContentStream,
        container = _ref.container,
        viewport = _ref.viewport,
        textDivs = _ref.textDivs,
        textContentItemsStr = _ref.textContentItemsStr,
        enhanceTextSelection = _ref.enhanceTextSelection;
    this._textContent = textContent;
    this._textContentStream = textContentStream;
    this._container = container;
    this._viewport = viewport;
    this._textDivs = textDivs || [];
    this._textContentItemsStr = textContentItemsStr || [];
    this._enhanceTextSelection = !!enhanceTextSelection;
    this._fontInspectorEnabled = !!(globalThis.FontInspector && globalThis.FontInspector.enabled);
    this._reader = null;
    this._layoutTextLastFontSize = null;
    this._layoutTextLastFontFamily = null;
    this._layoutTextCtx = null;
    this._textDivProperties = new WeakMap();
    this._renderingDone = false;
    this._canceled = false;
    this._capability = (0, _util.createPromiseCapability)();
    this._renderTimer = null;
    this._bounds = [];

    this._capability.promise["finally"](function () {
      if (_this._layoutTextCtx) {
        _this._layoutTextCtx.canvas.width = 0;
        _this._layoutTextCtx.canvas.height = 0;
        _this._layoutTextCtx = null;
      }
    })["catch"](function () {});
  }

  TextLayerRenderTask.prototype = {
    get promise() {
      return this._capability.promise;
    },

    cancel: function TextLayer_cancel() {
      this._canceled = true;

      if (this._reader) {
        this._reader.cancel(new _util.AbortException("TextLayer task cancelled."));

        this._reader = null;
      }

      if (this._renderTimer !== null) {
        clearTimeout(this._renderTimer);
        this._renderTimer = null;
      }

      this._capability.reject(new Error("TextLayer task cancelled."));
    },
    _processItems: function _processItems(items, styleCache) {
      for (var i = 0, len = items.length; i < len; i++) {
        this._textContentItemsStr.push(items[i].str);

        appendText(this, items[i], styleCache);
      }
    },
    _layoutText: function _layoutText(textDiv) {
      var textDivProperties = this._textDivProperties.get(textDiv);

      if (textDivProperties.isWhitespace) {
        return;
      }

      var transform = "";

      if (textDivProperties.canvasWidth !== 0) {
        var _textDiv$style = textDiv.style,
            fontSize = _textDiv$style.fontSize,
            fontFamily = _textDiv$style.fontFamily;

        if (fontSize !== this._layoutTextLastFontSize || fontFamily !== this._layoutTextLastFontFamily) {
          this._layoutTextCtx.font = "".concat(fontSize, " ").concat(fontFamily);
          this._layoutTextLastFontSize = fontSize;
          this._layoutTextLastFontFamily = fontFamily;
        }

        var _this$_layoutTextCtx$ = this._layoutTextCtx.measureText(textDiv.textContent),
            width = _this$_layoutTextCtx$.width;

        if (width > 0) {
          textDivProperties.scale = textDivProperties.canvasWidth / width;
          transform = "scaleX(".concat(textDivProperties.scale, ")");
        }
      }

      if (textDivProperties.angle !== 0) {
        transform = "rotate(".concat(textDivProperties.angle, "deg) ").concat(transform);
      }

      if (transform.length > 0) {
        if (this._enhanceTextSelection) {
          textDivProperties.originalTransform = transform;
        }

        textDiv.style.transform = transform;
      }

      this._textDivProperties.set(textDiv, textDivProperties);

      this._container.appendChild(textDiv);
    },
    _render: function TextLayer_render(timeout) {
      var _this2 = this;

      var capability = (0, _util.createPromiseCapability)();
      var styleCache = Object.create(null);
      var canvas = document.createElement("canvas");
      canvas.mozOpaque = true;
      this._layoutTextCtx = canvas.getContext("2d", {
        alpha: false
      });

      if (this._textContent) {
        var textItems = this._textContent.items;
        var textStyles = this._textContent.styles;

        this._processItems(textItems, textStyles);

        capability.resolve();
      } else if (this._textContentStream) {
        var pump = function pump() {
          _this2._reader.read().then(function (_ref2) {
            var value = _ref2.value,
                done = _ref2.done;

            if (done) {
              capability.resolve();
              return;
            }

            Object.assign(styleCache, value.styles);

            _this2._processItems(value.items, styleCache);

            pump();
          }, capability.reject);
        };

        this._reader = this._textContentStream.getReader();
        pump();
      } else {
        throw new Error('Neither "textContent" nor "textContentStream"' + " parameters specified.");
      }

      capability.promise.then(function () {
        styleCache = null;

        if (!timeout) {
          render(_this2);
        } else {
          _this2._renderTimer = setTimeout(function () {
            render(_this2);
            _this2._renderTimer = null;
          }, timeout);
        }
      }, this._capability.reject);
    },
    expandTextDivs: function TextLayer_expandTextDivs(expandDivs) {
      if (!this._enhanceTextSelection || !this._renderingDone) {
        return;
      }

      if (this._bounds !== null) {
        expand(this);
        this._bounds = null;
      }

      var transformBuf = [],
          paddingBuf = [];

      for (var i = 0, ii = this._textDivs.length; i < ii; i++) {
        var div = this._textDivs[i];

        var divProps = this._textDivProperties.get(div);

        if (divProps.isWhitespace) {
          continue;
        }

        if (expandDivs) {
          transformBuf.length = 0;
          paddingBuf.length = 0;

          if (divProps.originalTransform) {
            transformBuf.push(divProps.originalTransform);
          }

          if (divProps.paddingTop > 0) {
            paddingBuf.push("".concat(divProps.paddingTop, "px"));
            transformBuf.push("translateY(".concat(-divProps.paddingTop, "px)"));
          } else {
            paddingBuf.push(0);
          }

          if (divProps.paddingRight > 0) {
            paddingBuf.push("".concat(divProps.paddingRight / divProps.scale, "px"));
          } else {
            paddingBuf.push(0);
          }

          if (divProps.paddingBottom > 0) {
            paddingBuf.push("".concat(divProps.paddingBottom, "px"));
          } else {
            paddingBuf.push(0);
          }

          if (divProps.paddingLeft > 0) {
            paddingBuf.push("".concat(divProps.paddingLeft / divProps.scale, "px"));
            transformBuf.push("translateX(".concat(-divProps.paddingLeft / divProps.scale, "px)"));
          } else {
            paddingBuf.push(0);
          }

          div.style.padding = paddingBuf.join(" ");

          if (transformBuf.length) {
            div.style.transform = transformBuf.join(" ");
          }
        } else {
          div.style.padding = null;
          div.style.transform = divProps.originalTransform;
        }
      }
    }
  };

  function renderTextLayer(renderParameters) {
    var task = new TextLayerRenderTask({
      textContent: renderParameters.textContent,
      textContentStream: renderParameters.textContentStream,
      container: renderParameters.container,
      viewport: renderParameters.viewport,
      textDivs: renderParameters.textDivs,
      textContentItemsStr: renderParameters.textContentItemsStr,
      enhanceTextSelection: renderParameters.enhanceTextSelection
    });

    task._render(renderParameters.timeout);

    return task;
  }

  return renderTextLayer;
}();

exports.renderTextLayer = renderTextLayer;

/***/ }),
/* 206 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnotationLayer = void 0;

var _display_utils = __w_pdfjs_require__(194);

var _util = __w_pdfjs_require__(1);

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AnnotationElementFactory = /*#__PURE__*/function () {
  function AnnotationElementFactory() {
    _classCallCheck(this, AnnotationElementFactory);
  }

  _createClass(AnnotationElementFactory, null, [{
    key: "create",
    value: function create(parameters) {
      var subtype = parameters.data.annotationType;

      switch (subtype) {
        case _util.AnnotationType.LINK:
          return new LinkAnnotationElement(parameters);

        case _util.AnnotationType.TEXT:
          return new TextAnnotationElement(parameters);

        case _util.AnnotationType.WIDGET:
          var fieldType = parameters.data.fieldType;

          switch (fieldType) {
            case "Tx":
              return new TextWidgetAnnotationElement(parameters);

            case "Btn":
              if (parameters.data.radioButton) {
                return new RadioButtonWidgetAnnotationElement(parameters);
              } else if (parameters.data.checkBox) {
                return new CheckboxWidgetAnnotationElement(parameters);
              }

              return new PushButtonWidgetAnnotationElement(parameters);

            case "Ch":
              return new ChoiceWidgetAnnotationElement(parameters);
          }

          return new WidgetAnnotationElement(parameters);

        case _util.AnnotationType.POPUP:
          return new PopupAnnotationElement(parameters);

        case _util.AnnotationType.FREETEXT:
          return new FreeTextAnnotationElement(parameters);

        case _util.AnnotationType.LINE:
          return new LineAnnotationElement(parameters);

        case _util.AnnotationType.SQUARE:
          return new SquareAnnotationElement(parameters);

        case _util.AnnotationType.CIRCLE:
          return new CircleAnnotationElement(parameters);

        case _util.AnnotationType.POLYLINE:
          return new PolylineAnnotationElement(parameters);

        case _util.AnnotationType.CARET:
          return new CaretAnnotationElement(parameters);

        case _util.AnnotationType.INK:
          return new InkAnnotationElement(parameters);

        case _util.AnnotationType.POLYGON:
          return new PolygonAnnotationElement(parameters);

        case _util.AnnotationType.HIGHLIGHT:
          return new HighlightAnnotationElement(parameters);

        case _util.AnnotationType.UNDERLINE:
          return new UnderlineAnnotationElement(parameters);

        case _util.AnnotationType.SQUIGGLY:
          return new SquigglyAnnotationElement(parameters);

        case _util.AnnotationType.STRIKEOUT:
          return new StrikeOutAnnotationElement(parameters);

        case _util.AnnotationType.STAMP:
          return new StampAnnotationElement(parameters);

        case _util.AnnotationType.FILEATTACHMENT:
          return new FileAttachmentAnnotationElement(parameters);

        default:
          return new AnnotationElement(parameters);
      }
    }
  }]);

  return AnnotationElementFactory;
}();

var AnnotationElement = /*#__PURE__*/function () {
  function AnnotationElement(parameters) {
    var isRenderable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var ignoreBorder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, AnnotationElement);

    this.isRenderable = isRenderable;
    this.data = parameters.data;
    this.layer = parameters.layer;
    this.page = parameters.page;
    this.viewport = parameters.viewport;
    this.linkService = parameters.linkService;
    this.downloadManager = parameters.downloadManager;
    this.imageResourcesPath = parameters.imageResourcesPath;
    this.renderInteractiveForms = parameters.renderInteractiveForms;
    this.svgFactory = parameters.svgFactory;

    if (isRenderable) {
      this.container = this._createContainer(ignoreBorder);
    }
  }

  _createClass(AnnotationElement, [{
    key: "_createContainer",
    value: function _createContainer() {
      var ignoreBorder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var data = this.data,
          page = this.page,
          viewport = this.viewport;
      var container = document.createElement("section");
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      container.setAttribute("data-annotation-id", data.id);

      var rect = _util.Util.normalizeRect([data.rect[0], page.view[3] - data.rect[1] + page.view[1], data.rect[2], page.view[3] - data.rect[3] + page.view[1]]);

      container.style.transform = "matrix(".concat(viewport.transform.join(","), ")");
      container.style.transformOrigin = "-".concat(rect[0], "px -").concat(rect[1], "px");

      if (!ignoreBorder && data.borderStyle.width > 0) {
        container.style.borderWidth = "".concat(data.borderStyle.width, "px");

        if (data.borderStyle.style !== _util.AnnotationBorderStyleType.UNDERLINE) {
          width = width - 2 * data.borderStyle.width;
          height = height - 2 * data.borderStyle.width;
        }

        var horizontalRadius = data.borderStyle.horizontalCornerRadius;
        var verticalRadius = data.borderStyle.verticalCornerRadius;

        if (horizontalRadius > 0 || verticalRadius > 0) {
          var radius = "".concat(horizontalRadius, "px / ").concat(verticalRadius, "px");
          container.style.borderRadius = radius;
        }

        switch (data.borderStyle.style) {
          case _util.AnnotationBorderStyleType.SOLID:
            container.style.borderStyle = "solid";
            break;

          case _util.AnnotationBorderStyleType.DASHED:
            container.style.borderStyle = "dashed";
            break;

          case _util.AnnotationBorderStyleType.BEVELED:
            (0, _util.warn)("Unimplemented border style: beveled");
            break;

          case _util.AnnotationBorderStyleType.INSET:
            (0, _util.warn)("Unimplemented border style: inset");
            break;

          case _util.AnnotationBorderStyleType.UNDERLINE:
            container.style.borderBottomStyle = "solid";
            break;

          default:
            break;
        }

        if (data.color) {
          container.style.borderColor = _util.Util.makeCssRgb(data.color[0] | 0, data.color[1] | 0, data.color[2] | 0);
        } else {
          container.style.borderWidth = 0;
        }
      }

      container.style.left = "".concat(rect[0], "px");
      container.style.top = "".concat(rect[1], "px");
      container.style.width = "".concat(width, "px");
      container.style.height = "".concat(height, "px");
      return container;
    }
  }, {
    key: "_createPopup",
    value: function _createPopup(container, trigger, data) {
      if (!trigger) {
        trigger = document.createElement("div");
        trigger.style.height = container.style.height;
        trigger.style.width = container.style.width;
        container.appendChild(trigger);
      }

      var popupElement = new PopupElement({
        container: container,
        trigger: trigger,
        color: data.color,
        title: data.title,
        modificationDate: data.modificationDate,
        contents: data.contents,
        hideWrapper: true
      });
      var popup = popupElement.render();
      popup.style.left = container.style.width;
      container.appendChild(popup);
    }
  }, {
    key: "render",
    value: function render() {
      (0, _util.unreachable)("Abstract method `AnnotationElement.render` called");
    }
  }]);

  return AnnotationElement;
}();

var LinkAnnotationElement = /*#__PURE__*/function (_AnnotationElement) {
  _inherits(LinkAnnotationElement, _AnnotationElement);

  function LinkAnnotationElement(parameters) {
    _classCallCheck(this, LinkAnnotationElement);

    var isRenderable = !!(parameters.data.url || parameters.data.dest || parameters.data.action);
    return _possibleConstructorReturn(this, _getPrototypeOf(LinkAnnotationElement).call(this, parameters, isRenderable));
  }

  _createClass(LinkAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = "linkAnnotation";
      var data = this.data,
          linkService = this.linkService;
      var link = document.createElement("a");

      if (data.url) {
        (0, _display_utils.addLinkAttributes)(link, {
          url: data.url,
          target: data.newWindow ? _display_utils.LinkTarget.BLANK : linkService.externalLinkTarget,
          rel: linkService.externalLinkRel,
          enabled: linkService.externalLinkEnabled
        });
      } else if (data.action) {
        this._bindNamedAction(link, data.action);
      } else {
        this._bindLink(link, data.dest);
      }

      this.container.appendChild(link);
      return this.container;
    }
  }, {
    key: "_bindLink",
    value: function _bindLink(link, destination) {
      var _this = this;

      link.href = this.linkService.getDestinationHash(destination);

      link.onclick = function () {
        if (destination) {
          _this.linkService.navigateTo(destination);
        }

        return false;
      };

      if (destination) {
        link.className = "internalLink";
      }
    }
  }, {
    key: "_bindNamedAction",
    value: function _bindNamedAction(link, action) {
      var _this2 = this;

      link.href = this.linkService.getAnchorUrl("");

      link.onclick = function () {
        _this2.linkService.executeNamedAction(action);

        return false;
      };

      link.className = "internalLink";
    }
  }]);

  return LinkAnnotationElement;
}(AnnotationElement);

var TextAnnotationElement = /*#__PURE__*/function (_AnnotationElement2) {
  _inherits(TextAnnotationElement, _AnnotationElement2);

  function TextAnnotationElement(parameters) {
    _classCallCheck(this, TextAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(TextAnnotationElement).call(this, parameters, isRenderable));
  }

  _createClass(TextAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = "textAnnotation";
      var image = document.createElement("img");
      image.style.height = this.container.style.height;
      image.style.width = this.container.style.width;
      image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
      image.alt = "[{{type}} Annotation]";
      image.dataset.l10nId = "text_annotation_type";
      image.dataset.l10nArgs = JSON.stringify({
        type: this.data.name
      });

      if (!this.data.hasPopup) {
        this._createPopup(this.container, image, this.data);
      }

      this.container.appendChild(image);
      return this.container;
    }
  }]);

  return TextAnnotationElement;
}(AnnotationElement);

var WidgetAnnotationElement = /*#__PURE__*/function (_AnnotationElement3) {
  _inherits(WidgetAnnotationElement, _AnnotationElement3);

  function WidgetAnnotationElement() {
    _classCallCheck(this, WidgetAnnotationElement);

    return _possibleConstructorReturn(this, _getPrototypeOf(WidgetAnnotationElement).apply(this, arguments));
  }

  _createClass(WidgetAnnotationElement, [{
    key: "render",
    value: function render() {
      return this.container;
    }
  }]);

  return WidgetAnnotationElement;
}(AnnotationElement);

var TextWidgetAnnotationElement = /*#__PURE__*/function (_WidgetAnnotationElem) {
  _inherits(TextWidgetAnnotationElement, _WidgetAnnotationElem);

  function TextWidgetAnnotationElement(parameters) {
    _classCallCheck(this, TextWidgetAnnotationElement);

    var isRenderable = parameters.renderInteractiveForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
    return _possibleConstructorReturn(this, _getPrototypeOf(TextWidgetAnnotationElement).call(this, parameters, isRenderable));
  }

  _createClass(TextWidgetAnnotationElement, [{
    key: "render",
    value: function render() {
      var TEXT_ALIGNMENT = ["left", "center", "right"];
      this.container.className = "textWidgetAnnotation";
      var element = null;

      if (this.renderInteractiveForms) {
        if (this.data.multiLine) {
          element = document.createElement("textarea");
          element.textContent = this.data.fieldValue;
        } else {
          element = document.createElement("input");
          element.type = "text";
          element.setAttribute("value", this.data.fieldValue);
        }

        element.disabled = this.data.readOnly;

        if (this.data.maxLen !== null) {
          element.maxLength = this.data.maxLen;
        }

        if (this.data.comb) {
          var fieldWidth = this.data.rect[2] - this.data.rect[0];
          var combWidth = fieldWidth / this.data.maxLen;
          element.classList.add("comb");
          element.style.letterSpacing = "calc(".concat(combWidth, "px - 1ch)");
        }
      } else {
        element = document.createElement("div");
        element.textContent = this.data.fieldValue;
        element.style.verticalAlign = "middle";
        element.style.display = "table-cell";
        var font = null;

        if (this.data.fontRefName && this.page.commonObjs.has(this.data.fontRefName)) {
          font = this.page.commonObjs.get(this.data.fontRefName);
        }

        this._setTextStyle(element, font);
      }

      if (this.data.textAlignment !== null) {
        element.style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
      }

      this.container.appendChild(element);
      return this.container;
    }
  }, {
    key: "_setTextStyle",
    value: function _setTextStyle(element, font) {
      var style = element.style;
      style.fontSize = "".concat(this.data.fontSize, "px");
      style.direction = this.data.fontDirection < 0 ? "rtl" : "ltr";

      if (!font) {
        return;
      }

      var bold = "normal";

      if (font.black) {
        bold = "900";
      } else if (font.bold) {
        bold = "bold";
      }

      style.fontWeight = bold;
      style.fontStyle = font.italic ? "italic" : "normal";
      var fontFamily = font.loadedName ? "\"".concat(font.loadedName, "\", ") : "";
      var fallbackName = font.fallbackName || "Helvetica, sans-serif";
      style.fontFamily = fontFamily + fallbackName;
    }
  }]);

  return TextWidgetAnnotationElement;
}(WidgetAnnotationElement);

var CheckboxWidgetAnnotationElement = /*#__PURE__*/function (_WidgetAnnotationElem2) {
  _inherits(CheckboxWidgetAnnotationElement, _WidgetAnnotationElem2);

  function CheckboxWidgetAnnotationElement(parameters) {
    _classCallCheck(this, CheckboxWidgetAnnotationElement);

    return _possibleConstructorReturn(this, _getPrototypeOf(CheckboxWidgetAnnotationElement).call(this, parameters, parameters.renderInteractiveForms));
  }

  _createClass(CheckboxWidgetAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = "buttonWidgetAnnotation checkBox";
      var element = document.createElement("input");
      element.disabled = this.data.readOnly;
      element.type = "checkbox";

      if (this.data.fieldValue && this.data.fieldValue !== "Off") {
        element.setAttribute("checked", true);
      }

      this.container.appendChild(element);
      return this.container;
    }
  }]);

  return CheckboxWidgetAnnotationElement;
}(WidgetAnnotationElement);

var RadioButtonWidgetAnnotationElement = /*#__PURE__*/function (_WidgetAnnotationElem3) {
  _inherits(RadioButtonWidgetAnnotationElement, _WidgetAnnotationElem3);

  function RadioButtonWidgetAnnotationElement(parameters) {
    _classCallCheck(this, RadioButtonWidgetAnnotationElement);

    return _possibleConstructorReturn(this, _getPrototypeOf(RadioButtonWidgetAnnotationElement).call(this, parameters, parameters.renderInteractiveForms));
  }

  _createClass(RadioButtonWidgetAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = "buttonWidgetAnnotation radioButton";
      var element = document.createElement("input");
      element.disabled = this.data.readOnly;
      element.type = "radio";
      element.name = this.data.fieldName;

      if (this.data.fieldValue === this.data.buttonValue) {
        element.setAttribute("checked", true);
      }

      this.container.appendChild(element);
      return this.container;
    }
  }]);

  return RadioButtonWidgetAnnotationElement;
}(WidgetAnnotationElement);

var PushButtonWidgetAnnotationElement = /*#__PURE__*/function (_LinkAnnotationElemen) {
  _inherits(PushButtonWidgetAnnotationElement, _LinkAnnotationElemen);

  function PushButtonWidgetAnnotationElement() {
    _classCallCheck(this, PushButtonWidgetAnnotationElement);

    return _possibleConstructorReturn(this, _getPrototypeOf(PushButtonWidgetAnnotationElement).apply(this, arguments));
  }

  _createClass(PushButtonWidgetAnnotationElement, [{
    key: "render",
    value: function render() {
      var container = _get(_getPrototypeOf(PushButtonWidgetAnnotationElement.prototype), "render", this).call(this);

      container.className = "buttonWidgetAnnotation pushButton";
      return container;
    }
  }]);

  return PushButtonWidgetAnnotationElement;
}(LinkAnnotationElement);

var ChoiceWidgetAnnotationElement = /*#__PURE__*/function (_WidgetAnnotationElem4) {
  _inherits(ChoiceWidgetAnnotationElement, _WidgetAnnotationElem4);

  function ChoiceWidgetAnnotationElement(parameters) {
    _classCallCheck(this, ChoiceWidgetAnnotationElement);

    return _possibleConstructorReturn(this, _getPrototypeOf(ChoiceWidgetAnnotationElement).call(this, parameters, parameters.renderInteractiveForms));
  }

  _createClass(ChoiceWidgetAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = "choiceWidgetAnnotation";
      var selectElement = document.createElement("select");
      selectElement.disabled = this.data.readOnly;

      if (!this.data.combo) {
        selectElement.size = this.data.options.length;

        if (this.data.multiSelect) {
          selectElement.multiple = true;
        }
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.data.options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var option = _step.value;
          var optionElement = document.createElement("option");
          optionElement.textContent = option.displayValue;
          optionElement.value = option.exportValue;

          if (this.data.fieldValue.includes(option.displayValue)) {
            optionElement.setAttribute("selected", true);
          }

          selectElement.appendChild(optionElement);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.container.appendChild(selectElement);
      return this.container;
    }
  }]);

  return ChoiceWidgetAnnotationElement;
}(WidgetAnnotationElement);

var PopupAnnotationElement = /*#__PURE__*/function (_AnnotationElement4) {
  _inherits(PopupAnnotationElement, _AnnotationElement4);

  function PopupAnnotationElement(parameters) {
    _classCallCheck(this, PopupAnnotationElement);

    var isRenderable = !!(parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(PopupAnnotationElement).call(this, parameters, isRenderable));
  }

  _createClass(PopupAnnotationElement, [{
    key: "render",
    value: function render() {
      var IGNORE_TYPES = ["Line", "Square", "Circle", "PolyLine", "Polygon", "Ink"];
      this.container.className = "popupAnnotation";

      if (IGNORE_TYPES.includes(this.data.parentType)) {
        return this.container;
      }

      var selector = "[data-annotation-id=\"".concat(this.data.parentId, "\"]");
      var parentElement = this.layer.querySelector(selector);

      if (!parentElement) {
        return this.container;
      }

      var popup = new PopupElement({
        container: this.container,
        trigger: parentElement,
        color: this.data.color,
        title: this.data.title,
        modificationDate: this.data.modificationDate,
        contents: this.data.contents
      });
      var parentLeft = parseFloat(parentElement.style.left);
      var parentWidth = parseFloat(parentElement.style.width);
      this.container.style.transformOrigin = "-".concat(parentLeft + parentWidth, "px -").concat(parentElement.style.top);
      this.container.style.left = "".concat(parentLeft + parentWidth, "px");
      this.container.appendChild(popup.render());
      return this.container;
    }
  }]);

  return PopupAnnotationElement;
}(AnnotationElement);

var PopupElement = /*#__PURE__*/function () {
  function PopupElement(parameters) {
    _classCallCheck(this, PopupElement);

    this.container = parameters.container;
    this.trigger = parameters.trigger;
    this.color = parameters.color;
    this.title = parameters.title;
    this.modificationDate = parameters.modificationDate;
    this.contents = parameters.contents;
    this.hideWrapper = parameters.hideWrapper || false;
    this.pinned = false;
  }

  _createClass(PopupElement, [{
    key: "render",
    value: function render() {
      var BACKGROUND_ENLIGHT = 0.7;
      var wrapper = document.createElement("div");
      wrapper.className = "popupWrapper";
      this.hideElement = this.hideWrapper ? wrapper : this.container;
      this.hideElement.setAttribute("hidden", true);
      var popup = document.createElement("div");
      popup.className = "popup";
      var color = this.color;

      if (color) {
        var r = BACKGROUND_ENLIGHT * (255 - color[0]) + color[0];
        var g = BACKGROUND_ENLIGHT * (255 - color[1]) + color[1];
        var b = BACKGROUND_ENLIGHT * (255 - color[2]) + color[2];
        popup.style.backgroundColor = _util.Util.makeCssRgb(r | 0, g | 0, b | 0);
      }

      var title = document.createElement("h1");
      title.textContent = this.title;
      popup.appendChild(title);

      var dateObject = _display_utils.PDFDateString.toDateObject(this.modificationDate);

      if (dateObject) {
        var modificationDate = document.createElement("span");
        modificationDate.textContent = "{{date}}, {{time}}";
        modificationDate.dataset.l10nId = "annotation_date_string";
        modificationDate.dataset.l10nArgs = JSON.stringify({
          date: dateObject.toLocaleDateString(),
          time: dateObject.toLocaleTimeString()
        });
        popup.appendChild(modificationDate);
      }

      var contents = this._formatContents(this.contents);

      popup.appendChild(contents);
      this.trigger.addEventListener("click", this._toggle.bind(this));
      this.trigger.addEventListener("mouseover", this._show.bind(this, false));
      this.trigger.addEventListener("mouseout", this._hide.bind(this, false));
      popup.addEventListener("click", this._hide.bind(this, true));
      wrapper.appendChild(popup);
      return wrapper;
    }
  }, {
    key: "_formatContents",
    value: function _formatContents(contents) {
      var p = document.createElement("p");
      var lines = contents.split(/(?:\r\n?|\n)/);

      for (var i = 0, ii = lines.length; i < ii; ++i) {
        var line = lines[i];
        p.appendChild(document.createTextNode(line));

        if (i < ii - 1) {
          p.appendChild(document.createElement("br"));
        }
      }

      return p;
    }
  }, {
    key: "_toggle",
    value: function _toggle() {
      if (this.pinned) {
        this._hide(true);
      } else {
        this._show(true);
      }
    }
  }, {
    key: "_show",
    value: function _show() {
      var pin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (pin) {
        this.pinned = true;
      }

      if (this.hideElement.hasAttribute("hidden")) {
        this.hideElement.removeAttribute("hidden");
        this.container.style.zIndex += 1;
      }
    }
  }, {
    key: "_hide",
    value: function _hide() {
      var unpin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (unpin) {
        this.pinned = false;
      }

      if (!this.hideElement.hasAttribute("hidden") && !this.pinned) {
        this.hideElement.setAttribute("hidden", true);
        this.container.style.zIndex -= 1;
      }
    }
  }]);

  return PopupElement;
}();

var FreeTextAnnotationElement = /*#__PURE__*/function (_AnnotationElement5) {
  _inherits(FreeTextAnnotationElement, _AnnotationElement5);

  function FreeTextAnnotationElement(parameters) {
    _classCallCheck(this, FreeTextAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(FreeTextAnnotationElement).call(this, parameters, isRenderable, true));
  }

  _createClass(FreeTextAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = "freeTextAnnotation";

      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }

      return this.container;
    }
  }]);

  return FreeTextAnnotationElement;
}(AnnotationElement);

var LineAnnotationElement = /*#__PURE__*/function (_AnnotationElement6) {
  _inherits(LineAnnotationElement, _AnnotationElement6);

  function LineAnnotationElement(parameters) {
    _classCallCheck(this, LineAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(LineAnnotationElement).call(this, parameters, isRenderable, true));
  }

  _createClass(LineAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = "lineAnnotation";
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var line = this.svgFactory.createElement("svg:line");
      line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
      line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
      line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
      line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
      line.setAttribute("stroke-width", data.borderStyle.width || 1);
      line.setAttribute("stroke", "transparent");
      svg.appendChild(line);
      this.container.append(svg);

      this._createPopup(this.container, line, data);

      return this.container;
    }
  }]);

  return LineAnnotationElement;
}(AnnotationElement);

var SquareAnnotationElement = /*#__PURE__*/function (_AnnotationElement7) {
  _inherits(SquareAnnotationElement, _AnnotationElement7);

  function SquareAnnotationElement(parameters) {
    _classCallCheck(this, SquareAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(SquareAnnotationElement).call(this, parameters, isRenderable, true));
  }

  _createClass(SquareAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = "squareAnnotation";
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var borderWidth = data.borderStyle.width;
      var square = this.svgFactory.createElement("svg:rect");
      square.setAttribute("x", borderWidth / 2);
      square.setAttribute("y", borderWidth / 2);
      square.setAttribute("width", width - borderWidth);
      square.setAttribute("height", height - borderWidth);
      square.setAttribute("stroke-width", borderWidth || 1);
      square.setAttribute("stroke", "transparent");
      square.setAttribute("fill", "none");
      svg.appendChild(square);
      this.container.append(svg);

      this._createPopup(this.container, square, data);

      return this.container;
    }
  }]);

  return SquareAnnotationElement;
}(AnnotationElement);

var CircleAnnotationElement = /*#__PURE__*/function (_AnnotationElement8) {
  _inherits(CircleAnnotationElement, _AnnotationElement8);

  function CircleAnnotationElement(parameters) {
    _classCallCheck(this, CircleAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(CircleAnnotationElement).call(this, parameters, isRenderable, true));
  }

  _createClass(CircleAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = "circleAnnotation";
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var borderWidth = data.borderStyle.width;
      var circle = this.svgFactory.createElement("svg:ellipse");
      circle.setAttribute("cx", width / 2);
      circle.setAttribute("cy", height / 2);
      circle.setAttribute("rx", width / 2 - borderWidth / 2);
      circle.setAttribute("ry", height / 2 - borderWidth / 2);
      circle.setAttribute("stroke-width", borderWidth || 1);
      circle.setAttribute("stroke", "transparent");
      circle.setAttribute("fill", "none");
      svg.appendChild(circle);
      this.container.append(svg);

      this._createPopup(this.container, circle, data);

      return this.container;
    }
  }]);

  return CircleAnnotationElement;
}(AnnotationElement);

var PolylineAnnotationElement = /*#__PURE__*/function (_AnnotationElement9) {
  _inherits(PolylineAnnotationElement, _AnnotationElement9);

  function PolylineAnnotationElement(parameters) {
    var _this3;

    _classCallCheck(this, PolylineAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(PolylineAnnotationElement).call(this, parameters, isRenderable, true));
    _this3.containerClassName = "polylineAnnotation";
    _this3.svgElementName = "svg:polyline";
    return _this3;
  }

  _createClass(PolylineAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = this.containerClassName;
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var points = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = data.vertices[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var coordinate = _step2.value;
          var x = coordinate.x - data.rect[0];
          var y = data.rect[3] - coordinate.y;
          points.push(x + "," + y);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      points = points.join(" ");
      var polyline = this.svgFactory.createElement(this.svgElementName);
      polyline.setAttribute("points", points);
      polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
      polyline.setAttribute("stroke", "transparent");
      polyline.setAttribute("fill", "none");
      svg.appendChild(polyline);
      this.container.append(svg);

      this._createPopup(this.container, polyline, data);

      return this.container;
    }
  }]);

  return PolylineAnnotationElement;
}(AnnotationElement);

var PolygonAnnotationElement = /*#__PURE__*/function (_PolylineAnnotationEl) {
  _inherits(PolygonAnnotationElement, _PolylineAnnotationEl);

  function PolygonAnnotationElement(parameters) {
    var _this4;

    _classCallCheck(this, PolygonAnnotationElement);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(PolygonAnnotationElement).call(this, parameters));
    _this4.containerClassName = "polygonAnnotation";
    _this4.svgElementName = "svg:polygon";
    return _this4;
  }

  return PolygonAnnotationElement;
}(PolylineAnnotationElement);

var CaretAnnotationElement = /*#__PURE__*/function (_AnnotationElement10) {
  _inherits(CaretAnnotationElement, _AnnotationElement10);

  function CaretAnnotationElement(parameters) {
    _classCallCheck(this, CaretAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(CaretAnnotationElement).call(this, parameters, isRenderable, true));
  }

  _createClass(CaretAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = "caretAnnotation";

      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }

      return this.container;
    }
  }]);

  return CaretAnnotationElement;
}(AnnotationElement);

var InkAnnotationElement = /*#__PURE__*/function (_AnnotationElement11) {
  _inherits(InkAnnotationElement, _AnnotationElement11);

  function InkAnnotationElement(parameters) {
    var _this5;

    _classCallCheck(this, InkAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(InkAnnotationElement).call(this, parameters, isRenderable, true));
    _this5.containerClassName = "inkAnnotation";
    _this5.svgElementName = "svg:polyline";
    return _this5;
  }

  _createClass(InkAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = this.containerClassName;
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = data.inkLists[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var inkList = _step3.value;
          var points = [];
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = inkList[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var coordinate = _step4.value;
              var x = coordinate.x - data.rect[0];
              var y = data.rect[3] - coordinate.y;
              points.push("".concat(x, ",").concat(y));
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
                _iterator4["return"]();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }

          points = points.join(" ");
          var polyline = this.svgFactory.createElement(this.svgElementName);
          polyline.setAttribute("points", points);
          polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
          polyline.setAttribute("stroke", "transparent");
          polyline.setAttribute("fill", "none");

          this._createPopup(this.container, polyline, data);

          svg.appendChild(polyline);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
            _iterator3["return"]();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.container.append(svg);
      return this.container;
    }
  }]);

  return InkAnnotationElement;
}(AnnotationElement);

var HighlightAnnotationElement = /*#__PURE__*/function (_AnnotationElement12) {
  _inherits(HighlightAnnotationElement, _AnnotationElement12);

  function HighlightAnnotationElement(parameters) {
    _classCallCheck(this, HighlightAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(HighlightAnnotationElement).call(this, parameters, isRenderable, true));
  }

  _createClass(HighlightAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = "highlightAnnotation";

      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }

      return this.container;
    }
  }]);

  return HighlightAnnotationElement;
}(AnnotationElement);

var UnderlineAnnotationElement = /*#__PURE__*/function (_AnnotationElement13) {
  _inherits(UnderlineAnnotationElement, _AnnotationElement13);

  function UnderlineAnnotationElement(parameters) {
    _classCallCheck(this, UnderlineAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(UnderlineAnnotationElement).call(this, parameters, isRenderable, true));
  }

  _createClass(UnderlineAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = "underlineAnnotation";

      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }

      return this.container;
    }
  }]);

  return UnderlineAnnotationElement;
}(AnnotationElement);

var SquigglyAnnotationElement = /*#__PURE__*/function (_AnnotationElement14) {
  _inherits(SquigglyAnnotationElement, _AnnotationElement14);

  function SquigglyAnnotationElement(parameters) {
    _classCallCheck(this, SquigglyAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(SquigglyAnnotationElement).call(this, parameters, isRenderable, true));
  }

  _createClass(SquigglyAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = "squigglyAnnotation";

      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }

      return this.container;
    }
  }]);

  return SquigglyAnnotationElement;
}(AnnotationElement);

var StrikeOutAnnotationElement = /*#__PURE__*/function (_AnnotationElement15) {
  _inherits(StrikeOutAnnotationElement, _AnnotationElement15);

  function StrikeOutAnnotationElement(parameters) {
    _classCallCheck(this, StrikeOutAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(StrikeOutAnnotationElement).call(this, parameters, isRenderable, true));
  }

  _createClass(StrikeOutAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = "strikeoutAnnotation";

      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }

      return this.container;
    }
  }]);

  return StrikeOutAnnotationElement;
}(AnnotationElement);

var StampAnnotationElement = /*#__PURE__*/function (_AnnotationElement16) {
  _inherits(StampAnnotationElement, _AnnotationElement16);

  function StampAnnotationElement(parameters) {
    _classCallCheck(this, StampAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(StampAnnotationElement).call(this, parameters, isRenderable, true));
  }

  _createClass(StampAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = "stampAnnotation";

      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }

      return this.container;
    }
  }]);

  return StampAnnotationElement;
}(AnnotationElement);

var FileAttachmentAnnotationElement = /*#__PURE__*/function (_AnnotationElement17) {
  _inherits(FileAttachmentAnnotationElement, _AnnotationElement17);

  function FileAttachmentAnnotationElement(parameters) {
    var _this6;

    _classCallCheck(this, FileAttachmentAnnotationElement);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(FileAttachmentAnnotationElement).call(this, parameters, true));
    var _this6$data$file = _this6.data.file,
        filename = _this6$data$file.filename,
        content = _this6$data$file.content;
    _this6.filename = (0, _display_utils.getFilenameFromUrl)(filename);
    _this6.content = content;

    if (_this6.linkService.eventBus) {
      _this6.linkService.eventBus.dispatch("fileattachmentannotation", {
        source: _assertThisInitialized(_this6),
        id: (0, _util.stringToPDFString)(filename),
        filename: filename,
        content: content
      });
    }

    return _this6;
  }

  _createClass(FileAttachmentAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = "fileAttachmentAnnotation";
      var trigger = document.createElement("div");
      trigger.style.height = this.container.style.height;
      trigger.style.width = this.container.style.width;
      trigger.addEventListener("dblclick", this._download.bind(this));

      if (!this.data.hasPopup && (this.data.title || this.data.contents)) {
        this._createPopup(this.container, trigger, this.data);
      }

      this.container.appendChild(trigger);
      return this.container;
    }
  }, {
    key: "_download",
    value: function _download() {
      if (!this.downloadManager) {
        (0, _util.warn)("Download cannot be started due to unavailable download manager");
        return;
      }

      this.downloadManager.downloadData(this.content, this.filename, "");
    }
  }]);

  return FileAttachmentAnnotationElement;
}(AnnotationElement);

var AnnotationLayer = /*#__PURE__*/function () {
  function AnnotationLayer() {
    _classCallCheck(this, AnnotationLayer);
  }

  _createClass(AnnotationLayer, null, [{
    key: "render",
    value: function render(parameters) {
      var sortedAnnotations = [],
          popupAnnotations = [];
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = parameters.annotations[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var data = _step5.value;

          if (!data) {
            continue;
          }

          if (data.annotationType === _util.AnnotationType.POPUP) {
            popupAnnotations.push(data);
            continue;
          }

          sortedAnnotations.push(data);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5["return"] != null) {
            _iterator5["return"]();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      if (popupAnnotations.length) {
        sortedAnnotations.push.apply(sortedAnnotations, popupAnnotations);
      }

      for (var _i = 0, _sortedAnnotations = sortedAnnotations; _i < _sortedAnnotations.length; _i++) {
        var _data = _sortedAnnotations[_i];
        var element = AnnotationElementFactory.create({
          data: _data,
          layer: parameters.div,
          page: parameters.page,
          viewport: parameters.viewport,
          linkService: parameters.linkService,
          downloadManager: parameters.downloadManager,
          imageResourcesPath: parameters.imageResourcesPath || "",
          renderInteractiveForms: parameters.renderInteractiveForms || false,
          svgFactory: new _display_utils.DOMSVGFactory()
        });

        if (element.isRenderable) {
          parameters.div.appendChild(element.render());
        }
      }
    }
  }, {
    key: "update",
    value: function update(parameters) {
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = parameters.annotations[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var data = _step6.value;
          var element = parameters.div.querySelector("[data-annotation-id=\"".concat(data.id, "\"]"));

          if (element) {
            element.style.transform = "matrix(".concat(parameters.viewport.transform.join(","), ")");
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6["return"] != null) {
            _iterator6["return"]();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      parameters.div.removeAttribute("hidden");
    }
  }]);

  return AnnotationLayer;
}();

exports.AnnotationLayer = AnnotationLayer;

/***/ }),
/* 207 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SVGGraphics = void 0;

var _util = __w_pdfjs_require__(1);

var _display_utils = __w_pdfjs_require__(194);

var _is_node = __w_pdfjs_require__(48);

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SVGGraphics = function SVGGraphics() {
  throw new Error("Not implemented: SVGGraphics");
};

exports.SVGGraphics = SVGGraphics;
{
  var opListToTree = function opListToTree(opList) {
    var opTree = [];
    var tmp = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = opList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var opListElement = _step.value;

        if (opListElement.fn === "save") {
          opTree.push({
            fnId: 92,
            fn: "group",
            items: []
          });
          tmp.push(opTree);
          opTree = opTree[opTree.length - 1].items;
          continue;
        }

        if (opListElement.fn === "restore") {
          opTree = tmp.pop();
        } else {
          opTree.push(opListElement);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return opTree;
  };

  var pf = function pf(value) {
    if (Number.isInteger(value)) {
      return value.toString();
    }

    var s = value.toFixed(10);
    var i = s.length - 1;

    if (s[i] !== "0") {
      return s;
    }

    do {
      i--;
    } while (s[i] === "0");

    return s.substring(0, s[i] === "." ? i : i + 1);
  };

  var pm = function pm(m) {
    if (m[4] === 0 && m[5] === 0) {
      if (m[1] === 0 && m[2] === 0) {
        if (m[0] === 1 && m[3] === 1) {
          return "";
        }

        return "scale(".concat(pf(m[0]), " ").concat(pf(m[3]), ")");
      }

      if (m[0] === m[3] && m[1] === -m[2]) {
        var a = Math.acos(m[0]) * 180 / Math.PI;
        return "rotate(".concat(pf(a), ")");
      }
    } else {
      if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) {
        return "translate(".concat(pf(m[4]), " ").concat(pf(m[5]), ")");
      }
    }

    return "matrix(".concat(pf(m[0]), " ").concat(pf(m[1]), " ").concat(pf(m[2]), " ").concat(pf(m[3]), " ").concat(pf(m[4]), " ") + "".concat(pf(m[5]), ")");
  };

  var SVG_DEFAULTS = {
    fontStyle: "normal",
    fontWeight: "normal",
    fillColor: "#000000"
  };
  var XML_NS = "http://www.w3.org/XML/1998/namespace";
  var XLINK_NS = "http://www.w3.org/1999/xlink";
  var LINE_CAP_STYLES = ["butt", "round", "square"];
  var LINE_JOIN_STYLES = ["miter", "round", "bevel"];

  var convertImgDataToPng = function () {
    var PNG_HEADER = new Uint8Array([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]);
    var CHUNK_WRAPPER_SIZE = 12;
    var crcTable = new Int32Array(256);

    for (var i = 0; i < 256; i++) {
      var c = i;

      for (var h = 0; h < 8; h++) {
        if (c & 1) {
          c = 0xedb88320 ^ c >> 1 & 0x7fffffff;
        } else {
          c = c >> 1 & 0x7fffffff;
        }
      }

      crcTable[i] = c;
    }

    function crc32(data, start, end) {
      var crc = -1;

      for (var _i = start; _i < end; _i++) {
        var a = (crc ^ data[_i]) & 0xff;
        var b = crcTable[a];
        crc = crc >>> 8 ^ b;
      }

      return crc ^ -1;
    }

    function writePngChunk(type, body, data, offset) {
      var p = offset;
      var len = body.length;
      data[p] = len >> 24 & 0xff;
      data[p + 1] = len >> 16 & 0xff;
      data[p + 2] = len >> 8 & 0xff;
      data[p + 3] = len & 0xff;
      p += 4;
      data[p] = type.charCodeAt(0) & 0xff;
      data[p + 1] = type.charCodeAt(1) & 0xff;
      data[p + 2] = type.charCodeAt(2) & 0xff;
      data[p + 3] = type.charCodeAt(3) & 0xff;
      p += 4;
      data.set(body, p);
      p += body.length;
      var crc = crc32(data, offset + 4, p);
      data[p] = crc >> 24 & 0xff;
      data[p + 1] = crc >> 16 & 0xff;
      data[p + 2] = crc >> 8 & 0xff;
      data[p + 3] = crc & 0xff;
    }

    function adler32(data, start, end) {
      var a = 1;
      var b = 0;

      for (var _i2 = start; _i2 < end; ++_i2) {
        a = (a + (data[_i2] & 0xff)) % 65521;
        b = (b + a) % 65521;
      }

      return b << 16 | a;
    }

    function deflateSync(literals) {
      if (!_is_node.isNodeJS) {
        return deflateSyncUncompressed(literals);
      }

      try {
        var input;

        if (parseInt(process.versions.node) >= 8) {
          input = literals;
        } else {
          input = Buffer.from(literals);
        }

        var output = __webpack_require__(1733).deflateSync(input, {
          level: 9
        });

        return output instanceof Uint8Array ? output : new Uint8Array(output);
      } catch (e) {
        (0, _util.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + e);
      }

      return deflateSyncUncompressed(literals);
    }

    function deflateSyncUncompressed(literals) {
      var len = literals.length;
      var maxBlockLength = 0xffff;
      var deflateBlocks = Math.ceil(len / maxBlockLength);
      var idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
      var pi = 0;
      idat[pi++] = 0x78;
      idat[pi++] = 0x9c;
      var pos = 0;

      while (len > maxBlockLength) {
        idat[pi++] = 0x00;
        idat[pi++] = 0xff;
        idat[pi++] = 0xff;
        idat[pi++] = 0x00;
        idat[pi++] = 0x00;
        idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
        pi += maxBlockLength;
        pos += maxBlockLength;
        len -= maxBlockLength;
      }

      idat[pi++] = 0x01;
      idat[pi++] = len & 0xff;
      idat[pi++] = len >> 8 & 0xff;
      idat[pi++] = ~len & 0xffff & 0xff;
      idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
      idat.set(literals.subarray(pos), pi);
      pi += literals.length - pos;
      var adler = adler32(literals, 0, literals.length);
      idat[pi++] = adler >> 24 & 0xff;
      idat[pi++] = adler >> 16 & 0xff;
      idat[pi++] = adler >> 8 & 0xff;
      idat[pi++] = adler & 0xff;
      return idat;
    }

    function encode(imgData, kind, forceDataSchema, isMask) {
      var width = imgData.width;
      var height = imgData.height;
      var bitDepth, colorType, lineSize;
      var bytes = imgData.data;

      switch (kind) {
        case _util.ImageKind.GRAYSCALE_1BPP:
          colorType = 0;
          bitDepth = 1;
          lineSize = width + 7 >> 3;
          break;

        case _util.ImageKind.RGB_24BPP:
          colorType = 2;
          bitDepth = 8;
          lineSize = width * 3;
          break;

        case _util.ImageKind.RGBA_32BPP:
          colorType = 6;
          bitDepth = 8;
          lineSize = width * 4;
          break;

        default:
          throw new Error("invalid format");
      }

      var literals = new Uint8Array((1 + lineSize) * height);
      var offsetLiterals = 0,
          offsetBytes = 0;

      for (var y = 0; y < height; ++y) {
        literals[offsetLiterals++] = 0;
        literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
        offsetBytes += lineSize;
        offsetLiterals += lineSize;
      }

      if (kind === _util.ImageKind.GRAYSCALE_1BPP && isMask) {
        offsetLiterals = 0;

        for (var _y = 0; _y < height; _y++) {
          offsetLiterals++;

          for (var _i3 = 0; _i3 < lineSize; _i3++) {
            literals[offsetLiterals++] ^= 0xff;
          }
        }
      }

      var ihdr = new Uint8Array([width >> 24 & 0xff, width >> 16 & 0xff, width >> 8 & 0xff, width & 0xff, height >> 24 & 0xff, height >> 16 & 0xff, height >> 8 & 0xff, height & 0xff, bitDepth, colorType, 0x00, 0x00, 0x00]);
      var idat = deflateSync(literals);
      var pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
      var data = new Uint8Array(pngLength);
      var offset = 0;
      data.set(PNG_HEADER, offset);
      offset += PNG_HEADER.length;
      writePngChunk("IHDR", ihdr, data, offset);
      offset += CHUNK_WRAPPER_SIZE + ihdr.length;
      writePngChunk("IDATA", idat, data, offset);
      offset += CHUNK_WRAPPER_SIZE + idat.length;
      writePngChunk("IEND", new Uint8Array(0), data, offset);
      return (0, _util.createObjectURL)(data, "image/png", forceDataSchema);
    }

    return function convertImgDataToPng(imgData, forceDataSchema, isMask) {
      var kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
      return encode(imgData, kind, forceDataSchema, isMask);
    };
  }();

  var SVGExtraState = /*#__PURE__*/function () {
    function SVGExtraState() {
      _classCallCheck(this, SVGExtraState);

      this.fontSizeScale = 1;
      this.fontWeight = SVG_DEFAULTS.fontWeight;
      this.fontSize = 0;
      this.textMatrix = _util.IDENTITY_MATRIX;
      this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
      this.leading = 0;
      this.textRenderingMode = _util.TextRenderingMode.FILL;
      this.textMatrixScale = 1;
      this.x = 0;
      this.y = 0;
      this.lineX = 0;
      this.lineY = 0;
      this.charSpacing = 0;
      this.wordSpacing = 0;
      this.textHScale = 1;
      this.textRise = 0;
      this.fillColor = SVG_DEFAULTS.fillColor;
      this.strokeColor = "#000000";
      this.fillAlpha = 1;
      this.strokeAlpha = 1;
      this.lineWidth = 1;
      this.lineJoin = "";
      this.lineCap = "";
      this.miterLimit = 0;
      this.dashArray = [];
      this.dashPhase = 0;
      this.dependencies = [];
      this.activeClipUrl = null;
      this.clipGroup = null;
      this.maskId = "";
    }

    _createClass(SVGExtraState, [{
      key: "clone",
      value: function clone() {
        return Object.create(this);
      }
    }, {
      key: "setCurrentPoint",
      value: function setCurrentPoint(x, y) {
        this.x = x;
        this.y = y;
      }
    }]);

    return SVGExtraState;
  }();

  var clipCount = 0;
  var maskCount = 0;
  var shadingCount = 0;

  exports.SVGGraphics = SVGGraphics = /*#__PURE__*/function () {
    function SVGGraphics(commonObjs, objs, forceDataSchema) {
      _classCallCheck(this, SVGGraphics);

      this.svgFactory = new _display_utils.DOMSVGFactory();
      this.current = new SVGExtraState();
      this.transformMatrix = _util.IDENTITY_MATRIX;
      this.transformStack = [];
      this.extraStack = [];
      this.commonObjs = commonObjs;
      this.objs = objs;
      this.pendingClip = null;
      this.pendingEOFill = false;
      this.embedFonts = false;
      this.embeddedFonts = Object.create(null);
      this.cssStyle = null;
      this.forceDataSchema = !!forceDataSchema;
      this._operatorIdMapping = [];

      for (var op in _util.OPS) {
        this._operatorIdMapping[_util.OPS[op]] = op;
      }
    }

    _createClass(SVGGraphics, [{
      key: "save",
      value: function save() {
        this.transformStack.push(this.transformMatrix);
        var old = this.current;
        this.extraStack.push(old);
        this.current = old.clone();
      }
    }, {
      key: "restore",
      value: function restore() {
        this.transformMatrix = this.transformStack.pop();
        this.current = this.extraStack.pop();
        this.pendingClip = null;
        this.tgrp = null;
      }
    }, {
      key: "group",
      value: function group(items) {
        this.save();
        this.executeOpTree(items);
        this.restore();
      }
    }, {
      key: "loadDependencies",
      value: function loadDependencies(operatorList) {
        var _this = this;

        var fnArray = operatorList.fnArray;
        var argsArray = operatorList.argsArray;

        for (var i = 0, ii = fnArray.length; i < ii; i++) {
          if (fnArray[i] !== _util.OPS.dependency) {
            continue;
          }

          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            var _loop = function _loop() {
              var obj = _step2.value;
              var objsPool = obj.startsWith("g_") ? _this.commonObjs : _this.objs;
              var promise = new Promise(function (resolve) {
                objsPool.get(obj, resolve);
              });

              _this.current.dependencies.push(promise);
            };

            for (var _iterator2 = argsArray[i][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              _loop();
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                _iterator2["return"]();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }

        return Promise.all(this.current.dependencies);
      }
    }, {
      key: "transform",
      value: function transform(a, b, c, d, e, f) {
        var transformMatrix = [a, b, c, d, e, f];
        this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
        this.tgrp = null;
      }
    }, {
      key: "getSVG",
      value: function getSVG(operatorList, viewport) {
        var _this2 = this;

        this.viewport = viewport;

        var svgElement = this._initialize(viewport);

        return this.loadDependencies(operatorList).then(function () {
          _this2.transformMatrix = _util.IDENTITY_MATRIX;

          _this2.executeOpTree(_this2.convertOpList(operatorList));

          return svgElement;
        });
      }
    }, {
      key: "convertOpList",
      value: function convertOpList(operatorList) {
        var operatorIdMapping = this._operatorIdMapping;
        var argsArray = operatorList.argsArray;
        var fnArray = operatorList.fnArray;
        var opList = [];

        for (var i = 0, ii = fnArray.length; i < ii; i++) {
          var fnId = fnArray[i];
          opList.push({
            fnId: fnId,
            fn: operatorIdMapping[fnId],
            args: argsArray[i]
          });
        }

        return opListToTree(opList);
      }
    }, {
      key: "executeOpTree",
      value: function executeOpTree(opTree) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = opTree[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var opTreeElement = _step3.value;
            var fn = opTreeElement.fn;
            var fnId = opTreeElement.fnId;
            var args = opTreeElement.args;

            switch (fnId | 0) {
              case _util.OPS.beginText:
                this.beginText();
                break;

              case _util.OPS.dependency:
                break;

              case _util.OPS.setLeading:
                this.setLeading(args);
                break;

              case _util.OPS.setLeadingMoveText:
                this.setLeadingMoveText(args[0], args[1]);
                break;

              case _util.OPS.setFont:
                this.setFont(args);
                break;

              case _util.OPS.showText:
                this.showText(args[0]);
                break;

              case _util.OPS.showSpacedText:
                this.showText(args[0]);
                break;

              case _util.OPS.endText:
                this.endText();
                break;

              case _util.OPS.moveText:
                this.moveText(args[0], args[1]);
                break;

              case _util.OPS.setCharSpacing:
                this.setCharSpacing(args[0]);
                break;

              case _util.OPS.setWordSpacing:
                this.setWordSpacing(args[0]);
                break;

              case _util.OPS.setHScale:
                this.setHScale(args[0]);
                break;

              case _util.OPS.setTextMatrix:
                this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                break;

              case _util.OPS.setTextRise:
                this.setTextRise(args[0]);
                break;

              case _util.OPS.setTextRenderingMode:
                this.setTextRenderingMode(args[0]);
                break;

              case _util.OPS.setLineWidth:
                this.setLineWidth(args[0]);
                break;

              case _util.OPS.setLineJoin:
                this.setLineJoin(args[0]);
                break;

              case _util.OPS.setLineCap:
                this.setLineCap(args[0]);
                break;

              case _util.OPS.setMiterLimit:
                this.setMiterLimit(args[0]);
                break;

              case _util.OPS.setFillRGBColor:
                this.setFillRGBColor(args[0], args[1], args[2]);
                break;

              case _util.OPS.setStrokeRGBColor:
                this.setStrokeRGBColor(args[0], args[1], args[2]);
                break;

              case _util.OPS.setStrokeColorN:
                this.setStrokeColorN(args);
                break;

              case _util.OPS.setFillColorN:
                this.setFillColorN(args);
                break;

              case _util.OPS.shadingFill:
                this.shadingFill(args[0]);
                break;

              case _util.OPS.setDash:
                this.setDash(args[0], args[1]);
                break;

              case _util.OPS.setRenderingIntent:
                this.setRenderingIntent(args[0]);
                break;

              case _util.OPS.setFlatness:
                this.setFlatness(args[0]);
                break;

              case _util.OPS.setGState:
                this.setGState(args[0]);
                break;

              case _util.OPS.fill:
                this.fill();
                break;

              case _util.OPS.eoFill:
                this.eoFill();
                break;

              case _util.OPS.stroke:
                this.stroke();
                break;

              case _util.OPS.fillStroke:
                this.fillStroke();
                break;

              case _util.OPS.eoFillStroke:
                this.eoFillStroke();
                break;

              case _util.OPS.clip:
                this.clip("nonzero");
                break;

              case _util.OPS.eoClip:
                this.clip("evenodd");
                break;

              case _util.OPS.paintSolidColorImageMask:
                this.paintSolidColorImageMask();
                break;

              case _util.OPS.paintJpegXObject:
                this.paintJpegXObject(args[0], args[1], args[2]);
                break;

              case _util.OPS.paintImageXObject:
                this.paintImageXObject(args[0]);
                break;

              case _util.OPS.paintInlineImageXObject:
                this.paintInlineImageXObject(args[0]);
                break;

              case _util.OPS.paintImageMaskXObject:
                this.paintImageMaskXObject(args[0]);
                break;

              case _util.OPS.paintFormXObjectBegin:
                this.paintFormXObjectBegin(args[0], args[1]);
                break;

              case _util.OPS.paintFormXObjectEnd:
                this.paintFormXObjectEnd();
                break;

              case _util.OPS.closePath:
                this.closePath();
                break;

              case _util.OPS.closeStroke:
                this.closeStroke();
                break;

              case _util.OPS.closeFillStroke:
                this.closeFillStroke();
                break;

              case _util.OPS.closeEOFillStroke:
                this.closeEOFillStroke();
                break;

              case _util.OPS.nextLine:
                this.nextLine();
                break;

              case _util.OPS.transform:
                this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
                break;

              case _util.OPS.constructPath:
                this.constructPath(args[0], args[1]);
                break;

              case _util.OPS.endPath:
                this.endPath();
                break;

              case 92:
                this.group(opTreeElement.items);
                break;

              default:
                (0, _util.warn)("Unimplemented operator ".concat(fn));
                break;
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
              _iterator3["return"]();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
    }, {
      key: "setWordSpacing",
      value: function setWordSpacing(wordSpacing) {
        this.current.wordSpacing = wordSpacing;
      }
    }, {
      key: "setCharSpacing",
      value: function setCharSpacing(charSpacing) {
        this.current.charSpacing = charSpacing;
      }
    }, {
      key: "nextLine",
      value: function nextLine() {
        this.moveText(0, this.current.leading);
      }
    }, {
      key: "setTextMatrix",
      value: function setTextMatrix(a, b, c, d, e, f) {
        var current = this.current;
        current.textMatrix = current.lineMatrix = [a, b, c, d, e, f];
        current.textMatrixScale = Math.sqrt(a * a + b * b);
        current.x = current.lineX = 0;
        current.y = current.lineY = 0;
        current.xcoords = [];
        current.tspan = this.svgFactory.createElement("svg:tspan");
        current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
        current.tspan.setAttributeNS(null, "font-size", "".concat(pf(current.fontSize), "px"));
        current.tspan.setAttributeNS(null, "y", pf(-current.y));
        current.txtElement = this.svgFactory.createElement("svg:text");
        current.txtElement.appendChild(current.tspan);
      }
    }, {
      key: "beginText",
      value: function beginText() {
        var current = this.current;
        current.x = current.lineX = 0;
        current.y = current.lineY = 0;
        current.textMatrix = _util.IDENTITY_MATRIX;
        current.lineMatrix = _util.IDENTITY_MATRIX;
        current.textMatrixScale = 1;
        current.tspan = this.svgFactory.createElement("svg:tspan");
        current.txtElement = this.svgFactory.createElement("svg:text");
        current.txtgrp = this.svgFactory.createElement("svg:g");
        current.xcoords = [];
      }
    }, {
      key: "moveText",
      value: function moveText(x, y) {
        var current = this.current;
        current.x = current.lineX += x;
        current.y = current.lineY += y;
        current.xcoords = [];
        current.tspan = this.svgFactory.createElement("svg:tspan");
        current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
        current.tspan.setAttributeNS(null, "font-size", "".concat(pf(current.fontSize), "px"));
        current.tspan.setAttributeNS(null, "y", pf(-current.y));
      }
    }, {
      key: "showText",
      value: function showText(glyphs) {
        var current = this.current;
        var font = current.font;
        var fontSize = current.fontSize;

        if (fontSize === 0) {
          return;
        }

        var charSpacing = current.charSpacing;
        var wordSpacing = current.wordSpacing;
        var fontDirection = current.fontDirection;
        var textHScale = current.textHScale * fontDirection;
        var vertical = font.vertical;
        var widthAdvanceScale = fontSize * current.fontMatrix[0];
        var x = 0;
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = glyphs[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var glyph = _step4.value;

            if (glyph === null) {
              x += fontDirection * wordSpacing;
              continue;
            } else if ((0, _util.isNum)(glyph)) {
              x += -glyph * fontSize * 0.001;
              continue;
            }

            var width = glyph.width;
            var character = glyph.fontChar;
            var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
            var charWidth = width * widthAdvanceScale + spacing * fontDirection;

            if (!glyph.isInFont && !font.missingFile) {
              x += charWidth;
              continue;
            }

            current.xcoords.push(current.x + x);
            current.tspan.textContent += character;
            x += charWidth;
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
              _iterator4["return"]();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        if (vertical) {
          current.y -= x * textHScale;
        } else {
          current.x += x * textHScale;
        }

        current.tspan.setAttributeNS(null, "x", current.xcoords.map(pf).join(" "));
        current.tspan.setAttributeNS(null, "y", pf(-current.y));
        current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
        current.tspan.setAttributeNS(null, "font-size", "".concat(pf(current.fontSize), "px"));

        if (current.fontStyle !== SVG_DEFAULTS.fontStyle) {
          current.tspan.setAttributeNS(null, "font-style", current.fontStyle);
        }

        if (current.fontWeight !== SVG_DEFAULTS.fontWeight) {
          current.tspan.setAttributeNS(null, "font-weight", current.fontWeight);
        }

        var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;

        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          if (current.fillColor !== SVG_DEFAULTS.fillColor) {
            current.tspan.setAttributeNS(null, "fill", current.fillColor);
          }

          if (current.fillAlpha < 1) {
            current.tspan.setAttributeNS(null, "fill-opacity", current.fillAlpha);
          }
        } else if (current.textRenderingMode === _util.TextRenderingMode.ADD_TO_PATH) {
          current.tspan.setAttributeNS(null, "fill", "transparent");
        } else {
          current.tspan.setAttributeNS(null, "fill", "none");
        }

        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          var lineWidthScale = 1 / (current.textMatrixScale || 1);

          this._setStrokeAttributes(current.tspan, lineWidthScale);
        }

        var textMatrix = current.textMatrix;

        if (current.textRise !== 0) {
          textMatrix = textMatrix.slice();
          textMatrix[5] += current.textRise;
        }

        current.txtElement.setAttributeNS(null, "transform", "".concat(pm(textMatrix), " scale(").concat(pf(textHScale), ", -1)"));
        current.txtElement.setAttributeNS(XML_NS, "xml:space", "preserve");
        current.txtElement.appendChild(current.tspan);
        current.txtgrp.appendChild(current.txtElement);

        this._ensureTransformGroup().appendChild(current.txtElement);
      }
    }, {
      key: "setLeadingMoveText",
      value: function setLeadingMoveText(x, y) {
        this.setLeading(-y);
        this.moveText(x, y);
      }
    }, {
      key: "addFontStyle",
      value: function addFontStyle(fontObj) {
        if (!this.cssStyle) {
          this.cssStyle = this.svgFactory.createElement("svg:style");
          this.cssStyle.setAttributeNS(null, "type", "text/css");
          this.defs.appendChild(this.cssStyle);
        }

        var url = (0, _util.createObjectURL)(fontObj.data, fontObj.mimetype, this.forceDataSchema);
        this.cssStyle.textContent += "@font-face { font-family: \"".concat(fontObj.loadedName, "\";") + " src: url(".concat(url, "); }\n");
      }
    }, {
      key: "setFont",
      value: function setFont(details) {
        var current = this.current;
        var fontObj = this.commonObjs.get(details[0]);
        var size = details[1];
        current.font = fontObj;

        if (this.embedFonts && fontObj.data && !this.embeddedFonts[fontObj.loadedName]) {
          this.addFontStyle(fontObj);
          this.embeddedFonts[fontObj.loadedName] = fontObj;
        }

        current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
        var bold = "normal";

        if (fontObj.black) {
          bold = "900";
        } else if (fontObj.bold) {
          bold = "bold";
        }

        var italic = fontObj.italic ? "italic" : "normal";

        if (size < 0) {
          size = -size;
          current.fontDirection = -1;
        } else {
          current.fontDirection = 1;
        }

        current.fontSize = size;
        current.fontFamily = fontObj.loadedName;
        current.fontWeight = bold;
        current.fontStyle = italic;
        current.tspan = this.svgFactory.createElement("svg:tspan");
        current.tspan.setAttributeNS(null, "y", pf(-current.y));
        current.xcoords = [];
      }
    }, {
      key: "endText",
      value: function endText() {
        var current = this.current;

        if (current.textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG && current.txtElement && current.txtElement.hasChildNodes()) {
          current.element = current.txtElement;
          this.clip("nonzero");
          this.endPath();
        }
      }
    }, {
      key: "setLineWidth",
      value: function setLineWidth(width) {
        if (width > 0) {
          this.current.lineWidth = width;
        }
      }
    }, {
      key: "setLineCap",
      value: function setLineCap(style) {
        this.current.lineCap = LINE_CAP_STYLES[style];
      }
    }, {
      key: "setLineJoin",
      value: function setLineJoin(style) {
        this.current.lineJoin = LINE_JOIN_STYLES[style];
      }
    }, {
      key: "setMiterLimit",
      value: function setMiterLimit(limit) {
        this.current.miterLimit = limit;
      }
    }, {
      key: "setStrokeAlpha",
      value: function setStrokeAlpha(strokeAlpha) {
        this.current.strokeAlpha = strokeAlpha;
      }
    }, {
      key: "setStrokeRGBColor",
      value: function setStrokeRGBColor(r, g, b) {
        this.current.strokeColor = _util.Util.makeCssRgb(r, g, b);
      }
    }, {
      key: "setFillAlpha",
      value: function setFillAlpha(fillAlpha) {
        this.current.fillAlpha = fillAlpha;
      }
    }, {
      key: "setFillRGBColor",
      value: function setFillRGBColor(r, g, b) {
        this.current.fillColor = _util.Util.makeCssRgb(r, g, b);
        this.current.tspan = this.svgFactory.createElement("svg:tspan");
        this.current.xcoords = [];
      }
    }, {
      key: "setStrokeColorN",
      value: function setStrokeColorN(args) {
        this.current.strokeColor = this._makeColorN_Pattern(args);
      }
    }, {
      key: "setFillColorN",
      value: function setFillColorN(args) {
        this.current.fillColor = this._makeColorN_Pattern(args);
      }
    }, {
      key: "shadingFill",
      value: function shadingFill(args) {
        var width = this.viewport.width;
        var height = this.viewport.height;

        var inv = _util.Util.inverseTransform(this.transformMatrix);

        var bl = _util.Util.applyTransform([0, 0], inv);

        var br = _util.Util.applyTransform([0, height], inv);

        var ul = _util.Util.applyTransform([width, 0], inv);

        var ur = _util.Util.applyTransform([width, height], inv);

        var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
        var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
        var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
        var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
        var rect = this.svgFactory.createElement("svg:rect");
        rect.setAttributeNS(null, "x", x0);
        rect.setAttributeNS(null, "y", y0);
        rect.setAttributeNS(null, "width", x1 - x0);
        rect.setAttributeNS(null, "height", y1 - y0);
        rect.setAttributeNS(null, "fill", this._makeShadingPattern(args));

        this._ensureTransformGroup().appendChild(rect);
      }
    }, {
      key: "_makeColorN_Pattern",
      value: function _makeColorN_Pattern(args) {
        if (args[0] === "TilingPattern") {
          return this._makeTilingPattern(args);
        }

        return this._makeShadingPattern(args);
      }
    }, {
      key: "_makeTilingPattern",
      value: function _makeTilingPattern(args) {
        var color = args[1];
        var operatorList = args[2];
        var matrix = args[3] || _util.IDENTITY_MATRIX;

        var _args$ = _slicedToArray(args[4], 4),
            x0 = _args$[0],
            y0 = _args$[1],
            x1 = _args$[2],
            y1 = _args$[3];

        var xstep = args[5];
        var ystep = args[6];
        var paintType = args[7];
        var tilingId = "shading".concat(shadingCount++);

        var _Util$applyTransform = _util.Util.applyTransform([x0, y0], matrix),
            _Util$applyTransform2 = _slicedToArray(_Util$applyTransform, 2),
            tx0 = _Util$applyTransform2[0],
            ty0 = _Util$applyTransform2[1];

        var _Util$applyTransform3 = _util.Util.applyTransform([x1, y1], matrix),
            _Util$applyTransform4 = _slicedToArray(_Util$applyTransform3, 2),
            tx1 = _Util$applyTransform4[0],
            ty1 = _Util$applyTransform4[1];

        var _Util$singularValueDe = _util.Util.singularValueDecompose2dScale(matrix),
            _Util$singularValueDe2 = _slicedToArray(_Util$singularValueDe, 2),
            xscale = _Util$singularValueDe2[0],
            yscale = _Util$singularValueDe2[1];

        var txstep = xstep * xscale;
        var tystep = ystep * yscale;
        var tiling = this.svgFactory.createElement("svg:pattern");
        tiling.setAttributeNS(null, "id", tilingId);
        tiling.setAttributeNS(null, "patternUnits", "userSpaceOnUse");
        tiling.setAttributeNS(null, "width", txstep);
        tiling.setAttributeNS(null, "height", tystep);
        tiling.setAttributeNS(null, "x", "".concat(tx0));
        tiling.setAttributeNS(null, "y", "".concat(ty0));
        var svg = this.svg;
        var transformMatrix = this.transformMatrix;
        var fillColor = this.current.fillColor;
        var strokeColor = this.current.strokeColor;
        var bbox = this.svgFactory.create(tx1 - tx0, ty1 - ty0);
        this.svg = bbox;
        this.transformMatrix = matrix;

        if (paintType === 2) {
          var cssColor = _util.Util.makeCssRgb.apply(_util.Util, _toConsumableArray(color));

          this.current.fillColor = cssColor;
          this.current.strokeColor = cssColor;
        }

        this.executeOpTree(this.convertOpList(operatorList));
        this.svg = svg;
        this.transformMatrix = transformMatrix;
        this.current.fillColor = fillColor;
        this.current.strokeColor = strokeColor;
        tiling.appendChild(bbox.childNodes[0]);
        this.defs.appendChild(tiling);
        return "url(#".concat(tilingId, ")");
      }
    }, {
      key: "_makeShadingPattern",
      value: function _makeShadingPattern(args) {
        switch (args[0]) {
          case "RadialAxial":
            var shadingId = "shading".concat(shadingCount++);
            var colorStops = args[3];
            var gradient;

            switch (args[1]) {
              case "axial":
                var point0 = args[4];
                var point1 = args[5];
                gradient = this.svgFactory.createElement("svg:linearGradient");
                gradient.setAttributeNS(null, "id", shadingId);
                gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                gradient.setAttributeNS(null, "x1", point0[0]);
                gradient.setAttributeNS(null, "y1", point0[1]);
                gradient.setAttributeNS(null, "x2", point1[0]);
                gradient.setAttributeNS(null, "y2", point1[1]);
                break;

              case "radial":
                var focalPoint = args[4];
                var circlePoint = args[5];
                var focalRadius = args[6];
                var circleRadius = args[7];
                gradient = this.svgFactory.createElement("svg:radialGradient");
                gradient.setAttributeNS(null, "id", shadingId);
                gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                gradient.setAttributeNS(null, "cx", circlePoint[0]);
                gradient.setAttributeNS(null, "cy", circlePoint[1]);
                gradient.setAttributeNS(null, "r", circleRadius);
                gradient.setAttributeNS(null, "fx", focalPoint[0]);
                gradient.setAttributeNS(null, "fy", focalPoint[1]);
                gradient.setAttributeNS(null, "fr", focalRadius);
                break;

              default:
                throw new Error("Unknown RadialAxial type: ".concat(args[1]));
            }

            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
              for (var _iterator5 = colorStops[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var colorStop = _step5.value;
                var stop = this.svgFactory.createElement("svg:stop");
                stop.setAttributeNS(null, "offset", colorStop[0]);
                stop.setAttributeNS(null, "stop-color", colorStop[1]);
                gradient.appendChild(stop);
              }
            } catch (err) {
              _didIteratorError5 = true;
              _iteratorError5 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion5 && _iterator5["return"] != null) {
                  _iterator5["return"]();
                }
              } finally {
                if (_didIteratorError5) {
                  throw _iteratorError5;
                }
              }
            }

            this.defs.appendChild(gradient);
            return "url(#".concat(shadingId, ")");

          case "Mesh":
            (0, _util.warn)("Unimplemented pattern Mesh");
            return null;

          case "Dummy":
            return "hotpink";

          default:
            throw new Error("Unknown IR type: ".concat(args[0]));
        }
      }
    }, {
      key: "setDash",
      value: function setDash(dashArray, dashPhase) {
        this.current.dashArray = dashArray;
        this.current.dashPhase = dashPhase;
      }
    }, {
      key: "constructPath",
      value: function constructPath(ops, args) {
        var current = this.current;
        var x = current.x,
            y = current.y;
        var d = [];
        var j = 0;
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = ops[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var op = _step6.value;

            switch (op | 0) {
              case _util.OPS.rectangle:
                x = args[j++];
                y = args[j++];
                var width = args[j++];
                var height = args[j++];
                var xw = x + width;
                var yh = y + height;
                d.push("M", pf(x), pf(y), "L", pf(xw), pf(y), "L", pf(xw), pf(yh), "L", pf(x), pf(yh), "Z");
                break;

              case _util.OPS.moveTo:
                x = args[j++];
                y = args[j++];
                d.push("M", pf(x), pf(y));
                break;

              case _util.OPS.lineTo:
                x = args[j++];
                y = args[j++];
                d.push("L", pf(x), pf(y));
                break;

              case _util.OPS.curveTo:
                x = args[j + 4];
                y = args[j + 5];
                d.push("C", pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
                j += 6;
                break;

              case _util.OPS.curveTo2:
                d.push("C", pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
                x = args[j + 2];
                y = args[j + 3];
                j += 4;
                break;

              case _util.OPS.curveTo3:
                x = args[j + 2];
                y = args[j + 3];
                d.push("C", pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
                j += 4;
                break;

              case _util.OPS.closePath:
                d.push("Z");
                break;
            }
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6["return"] != null) {
              _iterator6["return"]();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }

        d = d.join(" ");

        if (current.path && ops.length > 0 && ops[0] !== _util.OPS.rectangle && ops[0] !== _util.OPS.moveTo) {
          d = current.path.getAttributeNS(null, "d") + d;
        } else {
          current.path = this.svgFactory.createElement("svg:path");

          this._ensureTransformGroup().appendChild(current.path);
        }

        current.path.setAttributeNS(null, "d", d);
        current.path.setAttributeNS(null, "fill", "none");
        current.element = current.path;
        current.setCurrentPoint(x, y);
      }
    }, {
      key: "endPath",
      value: function endPath() {
        var current = this.current;
        current.path = null;

        if (!this.pendingClip) {
          return;
        }

        if (!current.element) {
          this.pendingClip = null;
          return;
        }

        var clipId = "clippath".concat(clipCount++);
        var clipPath = this.svgFactory.createElement("svg:clipPath");
        clipPath.setAttributeNS(null, "id", clipId);
        clipPath.setAttributeNS(null, "transform", pm(this.transformMatrix));
        var clipElement = current.element.cloneNode(true);

        if (this.pendingClip === "evenodd") {
          clipElement.setAttributeNS(null, "clip-rule", "evenodd");
        } else {
          clipElement.setAttributeNS(null, "clip-rule", "nonzero");
        }

        this.pendingClip = null;
        clipPath.appendChild(clipElement);
        this.defs.appendChild(clipPath);

        if (current.activeClipUrl) {
          current.clipGroup = null;
          this.extraStack.forEach(function (prev) {
            prev.clipGroup = null;
          });
          clipPath.setAttributeNS(null, "clip-path", current.activeClipUrl);
        }

        current.activeClipUrl = "url(#".concat(clipId, ")");
        this.tgrp = null;
      }
    }, {
      key: "clip",
      value: function clip(type) {
        this.pendingClip = type;
      }
    }, {
      key: "closePath",
      value: function closePath() {
        var current = this.current;

        if (current.path) {
          var d = "".concat(current.path.getAttributeNS(null, "d"), "Z");
          current.path.setAttributeNS(null, "d", d);
        }
      }
    }, {
      key: "setLeading",
      value: function setLeading(leading) {
        this.current.leading = -leading;
      }
    }, {
      key: "setTextRise",
      value: function setTextRise(textRise) {
        this.current.textRise = textRise;
      }
    }, {
      key: "setTextRenderingMode",
      value: function setTextRenderingMode(textRenderingMode) {
        this.current.textRenderingMode = textRenderingMode;
      }
    }, {
      key: "setHScale",
      value: function setHScale(scale) {
        this.current.textHScale = scale / 100;
      }
    }, {
      key: "setRenderingIntent",
      value: function setRenderingIntent(intent) {}
    }, {
      key: "setFlatness",
      value: function setFlatness(flatness) {}
    }, {
      key: "setGState",
      value: function setGState(states) {
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          for (var _iterator7 = states[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var _step7$value = _slicedToArray(_step7.value, 2),
                key = _step7$value[0],
                value = _step7$value[1];

            switch (key) {
              case "LW":
                this.setLineWidth(value);
                break;

              case "LC":
                this.setLineCap(value);
                break;

              case "LJ":
                this.setLineJoin(value);
                break;

              case "ML":
                this.setMiterLimit(value);
                break;

              case "D":
                this.setDash(value[0], value[1]);
                break;

              case "RI":
                this.setRenderingIntent(value);
                break;

              case "FL":
                this.setFlatness(value);
                break;

              case "Font":
                this.setFont(value);
                break;

              case "CA":
                this.setStrokeAlpha(value);
                break;

              case "ca":
                this.setFillAlpha(value);
                break;

              default:
                (0, _util.warn)("Unimplemented graphic state operator ".concat(key));
                break;
            }
          }
        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7["return"] != null) {
              _iterator7["return"]();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }
      }
    }, {
      key: "fill",
      value: function fill() {
        var current = this.current;

        if (current.element) {
          current.element.setAttributeNS(null, "fill", current.fillColor);
          current.element.setAttributeNS(null, "fill-opacity", current.fillAlpha);
          this.endPath();
        }
      }
    }, {
      key: "stroke",
      value: function stroke() {
        var current = this.current;

        if (current.element) {
          this._setStrokeAttributes(current.element);

          current.element.setAttributeNS(null, "fill", "none");
          this.endPath();
        }
      }
    }, {
      key: "_setStrokeAttributes",
      value: function _setStrokeAttributes(element) {
        var lineWidthScale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var current = this.current;
        var dashArray = current.dashArray;

        if (lineWidthScale !== 1 && dashArray.length > 0) {
          dashArray = dashArray.map(function (value) {
            return lineWidthScale * value;
          });
        }

        element.setAttributeNS(null, "stroke", current.strokeColor);
        element.setAttributeNS(null, "stroke-opacity", current.strokeAlpha);
        element.setAttributeNS(null, "stroke-miterlimit", pf(current.miterLimit));
        element.setAttributeNS(null, "stroke-linecap", current.lineCap);
        element.setAttributeNS(null, "stroke-linejoin", current.lineJoin);
        element.setAttributeNS(null, "stroke-width", pf(lineWidthScale * current.lineWidth) + "px");
        element.setAttributeNS(null, "stroke-dasharray", dashArray.map(pf).join(" "));
        element.setAttributeNS(null, "stroke-dashoffset", pf(lineWidthScale * current.dashPhase) + "px");
      }
    }, {
      key: "eoFill",
      value: function eoFill() {
        if (this.current.element) {
          this.current.element.setAttributeNS(null, "fill-rule", "evenodd");
        }

        this.fill();
      }
    }, {
      key: "fillStroke",
      value: function fillStroke() {
        this.stroke();
        this.fill();
      }
    }, {
      key: "eoFillStroke",
      value: function eoFillStroke() {
        if (this.current.element) {
          this.current.element.setAttributeNS(null, "fill-rule", "evenodd");
        }

        this.fillStroke();
      }
    }, {
      key: "closeStroke",
      value: function closeStroke() {
        this.closePath();
        this.stroke();
      }
    }, {
      key: "closeFillStroke",
      value: function closeFillStroke() {
        this.closePath();
        this.fillStroke();
      }
    }, {
      key: "closeEOFillStroke",
      value: function closeEOFillStroke() {
        this.closePath();
        this.eoFillStroke();
      }
    }, {
      key: "paintSolidColorImageMask",
      value: function paintSolidColorImageMask() {
        var rect = this.svgFactory.createElement("svg:rect");
        rect.setAttributeNS(null, "x", "0");
        rect.setAttributeNS(null, "y", "0");
        rect.setAttributeNS(null, "width", "1px");
        rect.setAttributeNS(null, "height", "1px");
        rect.setAttributeNS(null, "fill", this.current.fillColor);

        this._ensureTransformGroup().appendChild(rect);
      }
    }, {
      key: "paintJpegXObject",
      value: function paintJpegXObject(objId, w, h) {
        var imgObj = this.objs.get(objId);
        var imgEl = this.svgFactory.createElement("svg:image");
        imgEl.setAttributeNS(XLINK_NS, "xlink:href", imgObj.src);
        imgEl.setAttributeNS(null, "width", pf(w));
        imgEl.setAttributeNS(null, "height", pf(h));
        imgEl.setAttributeNS(null, "x", "0");
        imgEl.setAttributeNS(null, "y", pf(-h));
        imgEl.setAttributeNS(null, "transform", "scale(".concat(pf(1 / w), " ").concat(pf(-1 / h), ")"));

        this._ensureTransformGroup().appendChild(imgEl);
      }
    }, {
      key: "paintImageXObject",
      value: function paintImageXObject(objId) {
        var imgData = this.objs.get(objId);

        if (!imgData) {
          (0, _util.warn)("Dependent image with object ID ".concat(objId, " is not ready yet"));
          return;
        }

        this.paintInlineImageXObject(imgData);
      }
    }, {
      key: "paintInlineImageXObject",
      value: function paintInlineImageXObject(imgData, mask) {
        var width = imgData.width;
        var height = imgData.height;
        var imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
        var cliprect = this.svgFactory.createElement("svg:rect");
        cliprect.setAttributeNS(null, "x", "0");
        cliprect.setAttributeNS(null, "y", "0");
        cliprect.setAttributeNS(null, "width", pf(width));
        cliprect.setAttributeNS(null, "height", pf(height));
        this.current.element = cliprect;
        this.clip("nonzero");
        var imgEl = this.svgFactory.createElement("svg:image");
        imgEl.setAttributeNS(XLINK_NS, "xlink:href", imgSrc);
        imgEl.setAttributeNS(null, "x", "0");
        imgEl.setAttributeNS(null, "y", pf(-height));
        imgEl.setAttributeNS(null, "width", pf(width) + "px");
        imgEl.setAttributeNS(null, "height", pf(height) + "px");
        imgEl.setAttributeNS(null, "transform", "scale(".concat(pf(1 / width), " ").concat(pf(-1 / height), ")"));

        if (mask) {
          mask.appendChild(imgEl);
        } else {
          this._ensureTransformGroup().appendChild(imgEl);
        }
      }
    }, {
      key: "paintImageMaskXObject",
      value: function paintImageMaskXObject(imgData) {
        var current = this.current;
        var width = imgData.width;
        var height = imgData.height;
        var fillColor = current.fillColor;
        current.maskId = "mask".concat(maskCount++);
        var mask = this.svgFactory.createElement("svg:mask");
        mask.setAttributeNS(null, "id", current.maskId);
        var rect = this.svgFactory.createElement("svg:rect");
        rect.setAttributeNS(null, "x", "0");
        rect.setAttributeNS(null, "y", "0");
        rect.setAttributeNS(null, "width", pf(width));
        rect.setAttributeNS(null, "height", pf(height));
        rect.setAttributeNS(null, "fill", fillColor);
        rect.setAttributeNS(null, "mask", "url(#".concat(current.maskId, ")"));
        this.defs.appendChild(mask);

        this._ensureTransformGroup().appendChild(rect);

        this.paintInlineImageXObject(imgData, mask);
      }
    }, {
      key: "paintFormXObjectBegin",
      value: function paintFormXObjectBegin(matrix, bbox) {
        if (Array.isArray(matrix) && matrix.length === 6) {
          this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
        }

        if (bbox) {
          var width = bbox[2] - bbox[0];
          var height = bbox[3] - bbox[1];
          var cliprect = this.svgFactory.createElement("svg:rect");
          cliprect.setAttributeNS(null, "x", bbox[0]);
          cliprect.setAttributeNS(null, "y", bbox[1]);
          cliprect.setAttributeNS(null, "width", pf(width));
          cliprect.setAttributeNS(null, "height", pf(height));
          this.current.element = cliprect;
          this.clip("nonzero");
          this.endPath();
        }
      }
    }, {
      key: "paintFormXObjectEnd",
      value: function paintFormXObjectEnd() {}
    }, {
      key: "_initialize",
      value: function _initialize(viewport) {
        var svg = this.svgFactory.create(viewport.width, viewport.height);
        var definitions = this.svgFactory.createElement("svg:defs");
        svg.appendChild(definitions);
        this.defs = definitions;
        var rootGroup = this.svgFactory.createElement("svg:g");
        rootGroup.setAttributeNS(null, "transform", pm(viewport.transform));
        svg.appendChild(rootGroup);
        this.svg = rootGroup;
        return svg;
      }
    }, {
      key: "_ensureClipGroup",
      value: function _ensureClipGroup() {
        if (!this.current.clipGroup) {
          var clipGroup = this.svgFactory.createElement("svg:g");
          clipGroup.setAttributeNS(null, "clip-path", this.current.activeClipUrl);
          this.svg.appendChild(clipGroup);
          this.current.clipGroup = clipGroup;
        }

        return this.current.clipGroup;
      }
    }, {
      key: "_ensureTransformGroup",
      value: function _ensureTransformGroup() {
        if (!this.tgrp) {
          this.tgrp = this.svgFactory.createElement("svg:g");
          this.tgrp.setAttributeNS(null, "transform", pm(this.transformMatrix));

          if (this.current.activeClipUrl) {
            this._ensureClipGroup().appendChild(this.tgrp);
          } else {
            this.svg.appendChild(this.tgrp);
          }
        }

        return this.tgrp;
      }
    }]);

    return SVGGraphics;
  }();
}

/***/ }),
/* 208 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFNodeStream = void 0;

var _regenerator = _interopRequireDefault(__w_pdfjs_require__(191));

var _util = __w_pdfjs_require__(1);

var _network_utils = __w_pdfjs_require__(209);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var fs = __webpack_require__(1729);

var http = __webpack_require__(1730);

var https = __webpack_require__(1731);

var url = __webpack_require__(1732);

var fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;

function parseUrl(sourceUrl) {
  var parsedUrl = url.parse(sourceUrl);

  if (parsedUrl.protocol === "file:" || parsedUrl.host) {
    return parsedUrl;
  }

  if (/^[a-z]:[/\\]/i.test(sourceUrl)) {
    return url.parse("file:///".concat(sourceUrl));
  }

  if (!parsedUrl.host) {
    parsedUrl.protocol = "file:";
  }

  return parsedUrl;
}

var PDFNodeStream = /*#__PURE__*/function () {
  function PDFNodeStream(source) {
    _classCallCheck(this, PDFNodeStream);

    this.source = source;
    this.url = parseUrl(source.url);
    this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
    this.isFsUrl = this.url.protocol === "file:";
    this.httpHeaders = this.isHttp && source.httpHeaders || {};
    this._fullRequestReader = null;
    this._rangeRequestReaders = [];
  }

  _createClass(PDFNodeStream, [{
    key: "getFullReader",
    value: function getFullReader() {
      (0, _util.assert)(!this._fullRequestReader);
      this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
      return this._fullRequestReader;
    }
  }, {
    key: "getRangeReader",
    value: function getRangeReader(start, end) {
      if (end <= this._progressiveDataLength) {
        return null;
      }

      var rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);

      this._rangeRequestReaders.push(rangeReader);

      return rangeReader;
    }
  }, {
    key: "cancelAllRequests",
    value: function cancelAllRequests(reason) {
      if (this._fullRequestReader) {
        this._fullRequestReader.cancel(reason);
      }

      var readers = this._rangeRequestReaders.slice(0);

      readers.forEach(function (reader) {
        reader.cancel(reason);
      });
    }
  }, {
    key: "_progressiveDataLength",
    get: function get() {
      return this._fullRequestReader ? this._fullRequestReader._loaded : 0;
    }
  }]);

  return PDFNodeStream;
}();

exports.PDFNodeStream = PDFNodeStream;

var BaseFullReader = /*#__PURE__*/function () {
  function BaseFullReader(stream) {
    _classCallCheck(this, BaseFullReader);

    this._url = stream.url;
    this._done = false;
    this._storedError = null;
    this.onProgress = null;
    var source = stream.source;
    this._contentLength = source.length;
    this._loaded = 0;
    this._filename = null;
    this._disableRange = source.disableRange || false;
    this._rangeChunkSize = source.rangeChunkSize;

    if (!this._rangeChunkSize && !this._disableRange) {
      this._disableRange = true;
    }

    this._isStreamingSupported = !source.disableStream;
    this._isRangeSupported = !source.disableRange;
    this._readableStream = null;
    this._readCapability = (0, _util.createPromiseCapability)();
    this._headersCapability = (0, _util.createPromiseCapability)();
  }

  _createClass(BaseFullReader, [{
    key: "read",
    value: function () {
      var _read = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var chunk, buffer;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._readCapability.promise;

              case 2:
                if (!this._done) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", {
                  value: undefined,
                  done: true
                });

              case 4:
                if (!this._storedError) {
                  _context.next = 6;
                  break;
                }

                throw this._storedError;

              case 6:
                chunk = this._readableStream.read();

                if (!(chunk === null)) {
                  _context.next = 10;
                  break;
                }

                this._readCapability = (0, _util.createPromiseCapability)();
                return _context.abrupt("return", this.read());

              case 10:
                this._loaded += chunk.length;

                if (this.onProgress) {
                  this.onProgress({
                    loaded: this._loaded,
                    total: this._contentLength
                  });
                }

                buffer = new Uint8Array(chunk).buffer;
                return _context.abrupt("return", {
                  value: buffer,
                  done: false
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function read() {
        return _read.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      if (!this._readableStream) {
        this._error(reason);

        return;
      }

      this._readableStream.destroy(reason);
    }
  }, {
    key: "_error",
    value: function _error(reason) {
      this._storedError = reason;

      this._readCapability.resolve();
    }
  }, {
    key: "_setReadableStream",
    value: function _setReadableStream(readableStream) {
      var _this = this;

      this._readableStream = readableStream;
      readableStream.on("readable", function () {
        _this._readCapability.resolve();
      });
      readableStream.on("end", function () {
        readableStream.destroy();
        _this._done = true;

        _this._readCapability.resolve();
      });
      readableStream.on("error", function (reason) {
        _this._error(reason);
      });

      if (!this._isStreamingSupported && this._isRangeSupported) {
        this._error(new _util.AbortException("streaming is disabled"));
      }

      if (this._storedError) {
        this._readableStream.destroy(this._storedError);
      }
    }
  }, {
    key: "headersReady",
    get: function get() {
      return this._headersCapability.promise;
    }
  }, {
    key: "filename",
    get: function get() {
      return this._filename;
    }
  }, {
    key: "contentLength",
    get: function get() {
      return this._contentLength;
    }
  }, {
    key: "isRangeSupported",
    get: function get() {
      return this._isRangeSupported;
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return this._isStreamingSupported;
    }
  }]);

  return BaseFullReader;
}();

var BaseRangeReader = /*#__PURE__*/function () {
  function BaseRangeReader(stream) {
    _classCallCheck(this, BaseRangeReader);

    this._url = stream.url;
    this._done = false;
    this._storedError = null;
    this.onProgress = null;
    this._loaded = 0;
    this._readableStream = null;
    this._readCapability = (0, _util.createPromiseCapability)();
    var source = stream.source;
    this._isStreamingSupported = !source.disableStream;
  }

  _createClass(BaseRangeReader, [{
    key: "read",
    value: function () {
      var _read2 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var chunk, buffer;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._readCapability.promise;

              case 2:
                if (!this._done) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", {
                  value: undefined,
                  done: true
                });

              case 4:
                if (!this._storedError) {
                  _context2.next = 6;
                  break;
                }

                throw this._storedError;

              case 6:
                chunk = this._readableStream.read();

                if (!(chunk === null)) {
                  _context2.next = 10;
                  break;
                }

                this._readCapability = (0, _util.createPromiseCapability)();
                return _context2.abrupt("return", this.read());

              case 10:
                this._loaded += chunk.length;

                if (this.onProgress) {
                  this.onProgress({
                    loaded: this._loaded
                  });
                }

                buffer = new Uint8Array(chunk).buffer;
                return _context2.abrupt("return", {
                  value: buffer,
                  done: false
                });

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function read() {
        return _read2.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      if (!this._readableStream) {
        this._error(reason);

        return;
      }

      this._readableStream.destroy(reason);
    }
  }, {
    key: "_error",
    value: function _error(reason) {
      this._storedError = reason;

      this._readCapability.resolve();
    }
  }, {
    key: "_setReadableStream",
    value: function _setReadableStream(readableStream) {
      var _this2 = this;

      this._readableStream = readableStream;
      readableStream.on("readable", function () {
        _this2._readCapability.resolve();
      });
      readableStream.on("end", function () {
        readableStream.destroy();
        _this2._done = true;

        _this2._readCapability.resolve();
      });
      readableStream.on("error", function (reason) {
        _this2._error(reason);
      });

      if (this._storedError) {
        this._readableStream.destroy(this._storedError);
      }
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return this._isStreamingSupported;
    }
  }]);

  return BaseRangeReader;
}();

function createRequestOptions(url, headers) {
  return {
    protocol: url.protocol,
    auth: url.auth,
    host: url.hostname,
    port: url.port,
    path: url.path,
    method: "GET",
    headers: headers
  };
}

var PDFNodeStreamFullReader = /*#__PURE__*/function (_BaseFullReader) {
  _inherits(PDFNodeStreamFullReader, _BaseFullReader);

  function PDFNodeStreamFullReader(stream) {
    var _this3;

    _classCallCheck(this, PDFNodeStreamFullReader);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(PDFNodeStreamFullReader).call(this, stream));

    var handleResponse = function handleResponse(response) {
      if (response.statusCode === 404) {
        var error = new _util.MissingPDFException("Missing PDF \"".concat(_this3._url, "\"."));
        _this3._storedError = error;

        _this3._headersCapability.reject(error);

        return;
      }

      _this3._headersCapability.resolve();

      _this3._setReadableStream(response);

      var getResponseHeader = function getResponseHeader(name) {
        return _this3._readableStream.headers[name.toLowerCase()];
      };

      var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
        getResponseHeader: getResponseHeader,
        isHttp: stream.isHttp,
        rangeChunkSize: _this3._rangeChunkSize,
        disableRange: _this3._disableRange
      }),
          allowRangeRequests = _validateRangeRequest.allowRangeRequests,
          suggestedLength = _validateRangeRequest.suggestedLength;

      _this3._isRangeSupported = allowRangeRequests;
      _this3._contentLength = suggestedLength || _this3._contentLength;
      _this3._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
    };

    _this3._request = null;

    if (_this3._url.protocol === "http:") {
      _this3._request = http.request(createRequestOptions(_this3._url, stream.httpHeaders), handleResponse);
    } else {
      _this3._request = https.request(createRequestOptions(_this3._url, stream.httpHeaders), handleResponse);
    }

    _this3._request.on("error", function (reason) {
      _this3._storedError = reason;

      _this3._headersCapability.reject(reason);
    });

    _this3._request.end();

    return _this3;
  }

  return PDFNodeStreamFullReader;
}(BaseFullReader);

var PDFNodeStreamRangeReader = /*#__PURE__*/function (_BaseRangeReader) {
  _inherits(PDFNodeStreamRangeReader, _BaseRangeReader);

  function PDFNodeStreamRangeReader(stream, start, end) {
    var _this4;

    _classCallCheck(this, PDFNodeStreamRangeReader);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(PDFNodeStreamRangeReader).call(this, stream));
    _this4._httpHeaders = {};

    for (var property in stream.httpHeaders) {
      var value = stream.httpHeaders[property];

      if (typeof value === "undefined") {
        continue;
      }

      _this4._httpHeaders[property] = value;
    }

    _this4._httpHeaders["Range"] = "bytes=".concat(start, "-").concat(end - 1);

    var handleResponse = function handleResponse(response) {
      if (response.statusCode === 404) {
        var error = new _util.MissingPDFException("Missing PDF \"".concat(_this4._url, "\"."));
        _this4._storedError = error;
        return;
      }

      _this4._setReadableStream(response);
    };

    _this4._request = null;

    if (_this4._url.protocol === "http:") {
      _this4._request = http.request(createRequestOptions(_this4._url, _this4._httpHeaders), handleResponse);
    } else {
      _this4._request = https.request(createRequestOptions(_this4._url, _this4._httpHeaders), handleResponse);
    }

    _this4._request.on("error", function (reason) {
      _this4._storedError = reason;
    });

    _this4._request.end();

    return _this4;
  }

  return PDFNodeStreamRangeReader;
}(BaseRangeReader);

var PDFNodeStreamFsFullReader = /*#__PURE__*/function (_BaseFullReader2) {
  _inherits(PDFNodeStreamFsFullReader, _BaseFullReader2);

  function PDFNodeStreamFsFullReader(stream) {
    var _this5;

    _classCallCheck(this, PDFNodeStreamFsFullReader);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(PDFNodeStreamFsFullReader).call(this, stream));
    var path = decodeURIComponent(_this5._url.path);

    if (fileUriRegex.test(_this5._url.href)) {
      path = path.replace(/^\//, "");
    }

    fs.lstat(path, function (error, stat) {
      if (error) {
        if (error.code === "ENOENT") {
          error = new _util.MissingPDFException("Missing PDF \"".concat(path, "\"."));
        }

        _this5._storedError = error;

        _this5._headersCapability.reject(error);

        return;
      }

      _this5._contentLength = stat.size;

      _this5._setReadableStream(fs.createReadStream(path));

      _this5._headersCapability.resolve();
    });
    return _this5;
  }

  return PDFNodeStreamFsFullReader;
}(BaseFullReader);

var PDFNodeStreamFsRangeReader = /*#__PURE__*/function (_BaseRangeReader2) {
  _inherits(PDFNodeStreamFsRangeReader, _BaseRangeReader2);

  function PDFNodeStreamFsRangeReader(stream, start, end) {
    var _this6;

    _classCallCheck(this, PDFNodeStreamFsRangeReader);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(PDFNodeStreamFsRangeReader).call(this, stream));
    var path = decodeURIComponent(_this6._url.path);

    if (fileUriRegex.test(_this6._url.href)) {
      path = path.replace(/^\//, "");
    }

    _this6._setReadableStream(fs.createReadStream(path, {
      start: start,
      end: end - 1
    }));

    return _this6;
  }

  return PDFNodeStreamFsRangeReader;
}(BaseRangeReader);

/***/ }),
/* 209 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createResponseStatusError = createResponseStatusError;
exports.extractFilenameFromHeader = extractFilenameFromHeader;
exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
exports.validateResponseStatus = validateResponseStatus;

var _util = __w_pdfjs_require__(1);

var _content_disposition = __w_pdfjs_require__(210);

function validateRangeRequestCapabilities(_ref) {
  var getResponseHeader = _ref.getResponseHeader,
      isHttp = _ref.isHttp,
      rangeChunkSize = _ref.rangeChunkSize,
      disableRange = _ref.disableRange;
  (0, _util.assert)(rangeChunkSize > 0, "Range chunk size must be larger than zero");
  var returnValues = {
    allowRangeRequests: false,
    suggestedLength: undefined
  };
  var length = parseInt(getResponseHeader("Content-Length"), 10);

  if (!Number.isInteger(length)) {
    return returnValues;
  }

  returnValues.suggestedLength = length;

  if (length <= 2 * rangeChunkSize) {
    return returnValues;
  }

  if (disableRange || !isHttp) {
    return returnValues;
  }

  if (getResponseHeader("Accept-Ranges") !== "bytes") {
    return returnValues;
  }

  var contentEncoding = getResponseHeader("Content-Encoding") || "identity";

  if (contentEncoding !== "identity") {
    return returnValues;
  }

  returnValues.allowRangeRequests = true;
  return returnValues;
}

function extractFilenameFromHeader(getResponseHeader) {
  var contentDisposition = getResponseHeader("Content-Disposition");

  if (contentDisposition) {
    var filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);

    if (filename.includes("%")) {
      try {
        filename = decodeURIComponent(filename);
      } catch (ex) {}
    }

    if (/\.pdf$/i.test(filename)) {
      return filename;
    }
  }

  return null;
}

function createResponseStatusError(status, url) {
  if (status === 404 || status === 0 && url.startsWith("file:")) {
    return new _util.MissingPDFException('Missing PDF "' + url + '".');
  }

  return new _util.UnexpectedResponseException("Unexpected server response (" + status + ') while retrieving PDF "' + url + '".', status);
}

function validateResponseStatus(status) {
  return status === 200 || status === 206;
}

/***/ }),
/* 210 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function getFilenameFromContentDispositionHeader(contentDisposition) {
  var needsEncodingFixup = true;
  var tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);

  if (tmp) {
    tmp = tmp[1];
    var filename = rfc2616unquote(tmp);
    filename = unescape(filename);
    filename = rfc5987decode(filename);
    filename = rfc2047decode(filename);
    return fixupEncoding(filename);
  }

  tmp = rfc2231getparam(contentDisposition);

  if (tmp) {
    var _filename = rfc2047decode(tmp);

    return fixupEncoding(_filename);
  }

  tmp = toParamRegExp("filename", "i").exec(contentDisposition);

  if (tmp) {
    tmp = tmp[1];

    var _filename2 = rfc2616unquote(tmp);

    _filename2 = rfc2047decode(_filename2);
    return fixupEncoding(_filename2);
  }

  function toParamRegExp(attributePattern, flags) {
    return new RegExp("(?:^|;)\\s*" + attributePattern + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags);
  }

  function textdecode(encoding, value) {
    if (encoding) {
      if (!/^[\x00-\xFF]+$/.test(value)) {
        return value;
      }

      try {
        var decoder = new TextDecoder(encoding, {
          fatal: true
        });
        var bytes = Array.from(value, function (ch) {
          return ch.charCodeAt(0) & 0xff;
        });
        value = decoder.decode(new Uint8Array(bytes));
        needsEncodingFixup = false;
      } catch (e) {
        if (/^utf-?8$/i.test(encoding)) {
          try {
            value = decodeURIComponent(escape(value));
            needsEncodingFixup = false;
          } catch (err) {}
        }
      }
    }

    return value;
  }

  function fixupEncoding(value) {
    if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
      value = textdecode("utf-8", value);

      if (needsEncodingFixup) {
        value = textdecode("iso-8859-1", value);
      }
    }

    return value;
  }

  function rfc2231getparam(contentDisposition) {
    var matches = [];
    var match;
    var iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");

    while ((match = iter.exec(contentDisposition)) !== null) {
      var _match = match,
          _match2 = _slicedToArray(_match, 4),
          n = _match2[1],
          quot = _match2[2],
          part = _match2[3];

      n = parseInt(n, 10);

      if (n in matches) {
        if (n === 0) {
          break;
        }

        continue;
      }

      matches[n] = [quot, part];
    }

    var parts = [];

    for (var _n2 = 0; _n2 < matches.length; ++_n2) {
      if (!(_n2 in matches)) {
        break;
      }

      var _matches$_n = _slicedToArray(matches[_n2], 2),
          _quot = _matches$_n[0],
          _part = _matches$_n[1];

      _part = rfc2616unquote(_part);

      if (_quot) {
        _part = unescape(_part);

        if (_n2 === 0) {
          _part = rfc5987decode(_part);
        }
      }

      parts.push(_part);
    }

    return parts.join("");
  }

  function rfc2616unquote(value) {
    if (value.startsWith('"')) {
      var parts = value.slice(1).split('\\"');

      for (var i = 0; i < parts.length; ++i) {
        var quotindex = parts[i].indexOf('"');

        if (quotindex !== -1) {
          parts[i] = parts[i].slice(0, quotindex);
          parts.length = i + 1;
        }

        parts[i] = parts[i].replace(/\\(.)/g, "$1");
      }

      value = parts.join('"');
    }

    return value;
  }

  function rfc5987decode(extvalue) {
    var encodingend = extvalue.indexOf("'");

    if (encodingend === -1) {
      return extvalue;
    }

    var encoding = extvalue.slice(0, encodingend);
    var langvalue = extvalue.slice(encodingend + 1);
    var value = langvalue.replace(/^[^']*'/, "");
    return textdecode(encoding, value);
  }

  function rfc2047decode(value) {
    if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) {
      return value;
    }

    return value.replace(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function (_, charset, encoding, text) {
      if (encoding === "q" || encoding === "Q") {
        text = text.replace(/_/g, " ");
        text = text.replace(/=([0-9a-fA-F]{2})/g, function (_, hex) {
          return String.fromCharCode(parseInt(hex, 16));
        });
        return textdecode(charset, text);
      }

      try {
        text = atob(text);
      } catch (e) {}

      return textdecode(charset, text);
    });
  }

  return "";
}

/***/ }),
/* 211 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFNetworkStream = void 0;

var _regenerator = _interopRequireDefault(__w_pdfjs_require__(191));

var _util = __w_pdfjs_require__(1);

var _network_utils = __w_pdfjs_require__(209);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

;
var OK_RESPONSE = 200;
var PARTIAL_CONTENT_RESPONSE = 206;

function getArrayBuffer(xhr) {
  var data = xhr.response;

  if (typeof data !== "string") {
    return data;
  }

  var array = (0, _util.stringToBytes)(data);
  return array.buffer;
}

var NetworkManager = /*#__PURE__*/function () {
  function NetworkManager(url, args) {
    _classCallCheck(this, NetworkManager);

    this.url = url;
    args = args || {};
    this.isHttp = /^https?:/i.test(url);
    this.httpHeaders = this.isHttp && args.httpHeaders || {};
    this.withCredentials = args.withCredentials || false;

    this.getXhr = args.getXhr || function NetworkManager_getXhr() {
      return new XMLHttpRequest();
    };

    this.currXhrId = 0;
    this.pendingRequests = Object.create(null);
  }

  _createClass(NetworkManager, [{
    key: "requestRange",
    value: function requestRange(begin, end, listeners) {
      var args = {
        begin: begin,
        end: end
      };

      for (var prop in listeners) {
        args[prop] = listeners[prop];
      }

      return this.request(args);
    }
  }, {
    key: "requestFull",
    value: function requestFull(listeners) {
      return this.request(listeners);
    }
  }, {
    key: "request",
    value: function request(args) {
      var xhr = this.getXhr();
      var xhrId = this.currXhrId++;
      var pendingRequest = this.pendingRequests[xhrId] = {
        xhr: xhr
      };
      xhr.open("GET", this.url);
      xhr.withCredentials = this.withCredentials;

      for (var property in this.httpHeaders) {
        var value = this.httpHeaders[property];

        if (typeof value === "undefined") {
          continue;
        }

        xhr.setRequestHeader(property, value);
      }

      if (this.isHttp && "begin" in args && "end" in args) {
        xhr.setRequestHeader("Range", "bytes=".concat(args.begin, "-").concat(args.end - 1));
        pendingRequest.expectedStatus = PARTIAL_CONTENT_RESPONSE;
      } else {
        pendingRequest.expectedStatus = OK_RESPONSE;
      }

      xhr.responseType = "arraybuffer";

      if (args.onError) {
        xhr.onerror = function (evt) {
          args.onError(xhr.status);
        };
      }

      xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
      xhr.onprogress = this.onProgress.bind(this, xhrId);
      pendingRequest.onHeadersReceived = args.onHeadersReceived;
      pendingRequest.onDone = args.onDone;
      pendingRequest.onError = args.onError;
      pendingRequest.onProgress = args.onProgress;
      xhr.send(null);
      return xhrId;
    }
  }, {
    key: "onProgress",
    value: function onProgress(xhrId, evt) {
      var pendingRequest = this.pendingRequests[xhrId];

      if (!pendingRequest) {
        return;
      }

      if (pendingRequest.onProgress) {
        pendingRequest.onProgress(evt);
      }
    }
  }, {
    key: "onStateChange",
    value: function onStateChange(xhrId, evt) {
      var pendingRequest = this.pendingRequests[xhrId];

      if (!pendingRequest) {
        return;
      }

      var xhr = pendingRequest.xhr;

      if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
        pendingRequest.onHeadersReceived();
        delete pendingRequest.onHeadersReceived;
      }

      if (xhr.readyState !== 4) {
        return;
      }

      if (!(xhrId in this.pendingRequests)) {
        return;
      }

      delete this.pendingRequests[xhrId];

      if (xhr.status === 0 && this.isHttp) {
        if (pendingRequest.onError) {
          pendingRequest.onError(xhr.status);
        }

        return;
      }

      var xhrStatus = xhr.status || OK_RESPONSE;
      var ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;

      if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
        if (pendingRequest.onError) {
          pendingRequest.onError(xhr.status);
        }

        return;
      }

      var chunk = getArrayBuffer(xhr);

      if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
        var rangeHeader = xhr.getResponseHeader("Content-Range");
        var matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
        pendingRequest.onDone({
          begin: parseInt(matches[1], 10),
          chunk: chunk
        });
      } else if (chunk) {
        pendingRequest.onDone({
          begin: 0,
          chunk: chunk
        });
      } else if (pendingRequest.onError) {
        pendingRequest.onError(xhr.status);
      }
    }
  }, {
    key: "hasPendingRequests",
    value: function hasPendingRequests() {
      for (var xhrId in this.pendingRequests) {
        return true;
      }

      return false;
    }
  }, {
    key: "getRequestXhr",
    value: function getRequestXhr(xhrId) {
      return this.pendingRequests[xhrId].xhr;
    }
  }, {
    key: "isPendingRequest",
    value: function isPendingRequest(xhrId) {
      return xhrId in this.pendingRequests;
    }
  }, {
    key: "abortAllRequests",
    value: function abortAllRequests() {
      for (var xhrId in this.pendingRequests) {
        this.abortRequest(xhrId | 0);
      }
    }
  }, {
    key: "abortRequest",
    value: function abortRequest(xhrId) {
      var xhr = this.pendingRequests[xhrId].xhr;
      delete this.pendingRequests[xhrId];
      xhr.abort();
    }
  }]);

  return NetworkManager;
}();

var PDFNetworkStream = /*#__PURE__*/function () {
  function PDFNetworkStream(source) {
    _classCallCheck(this, PDFNetworkStream);

    this._source = source;
    this._manager = new NetworkManager(source.url, {
      httpHeaders: source.httpHeaders,
      withCredentials: source.withCredentials
    });
    this._rangeChunkSize = source.rangeChunkSize;
    this._fullRequestReader = null;
    this._rangeRequestReaders = [];
  }

  _createClass(PDFNetworkStream, [{
    key: "_onRangeRequestReaderClosed",
    value: function _onRangeRequestReaderClosed(reader) {
      var i = this._rangeRequestReaders.indexOf(reader);

      if (i >= 0) {
        this._rangeRequestReaders.splice(i, 1);
      }
    }
  }, {
    key: "getFullReader",
    value: function getFullReader() {
      (0, _util.assert)(!this._fullRequestReader);
      this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
      return this._fullRequestReader;
    }
  }, {
    key: "getRangeReader",
    value: function getRangeReader(begin, end) {
      var reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
      reader.onClosed = this._onRangeRequestReaderClosed.bind(this);

      this._rangeRequestReaders.push(reader);

      return reader;
    }
  }, {
    key: "cancelAllRequests",
    value: function cancelAllRequests(reason) {
      if (this._fullRequestReader) {
        this._fullRequestReader.cancel(reason);
      }

      var readers = this._rangeRequestReaders.slice(0);

      readers.forEach(function (reader) {
        reader.cancel(reason);
      });
    }
  }]);

  return PDFNetworkStream;
}();

exports.PDFNetworkStream = PDFNetworkStream;

var PDFNetworkStreamFullRequestReader = /*#__PURE__*/function () {
  function PDFNetworkStreamFullRequestReader(manager, source) {
    _classCallCheck(this, PDFNetworkStreamFullRequestReader);

    this._manager = manager;
    var args = {
      onHeadersReceived: this._onHeadersReceived.bind(this),
      onDone: this._onDone.bind(this),
      onError: this._onError.bind(this),
      onProgress: this._onProgress.bind(this)
    };
    this._url = source.url;
    this._fullRequestId = manager.requestFull(args);
    this._headersReceivedCapability = (0, _util.createPromiseCapability)();
    this._disableRange = source.disableRange || false;
    this._contentLength = source.length;
    this._rangeChunkSize = source.rangeChunkSize;

    if (!this._rangeChunkSize && !this._disableRange) {
      this._disableRange = true;
    }

    this._isStreamingSupported = false;
    this._isRangeSupported = false;
    this._cachedChunks = [];
    this._requests = [];
    this._done = false;
    this._storedError = undefined;
    this._filename = null;
    this.onProgress = null;
  }

  _createClass(PDFNetworkStreamFullRequestReader, [{
    key: "_onHeadersReceived",
    value: function _onHeadersReceived() {
      var fullRequestXhrId = this._fullRequestId;

      var fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);

      var getResponseHeader = function getResponseHeader(name) {
        return fullRequestXhr.getResponseHeader(name);
      };

      var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
        getResponseHeader: getResponseHeader,
        isHttp: this._manager.isHttp,
        rangeChunkSize: this._rangeChunkSize,
        disableRange: this._disableRange
      }),
          allowRangeRequests = _validateRangeRequest.allowRangeRequests,
          suggestedLength = _validateRangeRequest.suggestedLength;

      if (allowRangeRequests) {
        this._isRangeSupported = true;
      }

      this._contentLength = suggestedLength || this._contentLength;
      this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);

      if (this._isRangeSupported) {
        this._manager.abortRequest(fullRequestXhrId);
      }

      this._headersReceivedCapability.resolve();
    }
  }, {
    key: "_onDone",
    value: function _onDone(args) {
      if (args) {
        if (this._requests.length > 0) {
          var requestCapability = this._requests.shift();

          requestCapability.resolve({
            value: args.chunk,
            done: false
          });
        } else {
          this._cachedChunks.push(args.chunk);
        }
      }

      this._done = true;

      if (this._cachedChunks.length > 0) {
        return;
      }

      this._requests.forEach(function (requestCapability) {
        requestCapability.resolve({
          value: undefined,
          done: true
        });
      });

      this._requests = [];
    }
  }, {
    key: "_onError",
    value: function _onError(status) {
      var url = this._url;
      var exception = (0, _network_utils.createResponseStatusError)(status, url);
      this._storedError = exception;

      this._headersReceivedCapability.reject(exception);

      this._requests.forEach(function (requestCapability) {
        requestCapability.reject(exception);
      });

      this._requests = [];
      this._cachedChunks = [];
    }
  }, {
    key: "_onProgress",
    value: function _onProgress(data) {
      if (this.onProgress) {
        this.onProgress({
          loaded: data.loaded,
          total: data.lengthComputable ? data.total : this._contentLength
        });
      }
    }
  }, {
    key: "read",
    value: function () {
      var _read = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var chunk, requestCapability;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this._storedError) {
                  _context.next = 2;
                  break;
                }

                throw this._storedError;

              case 2:
                if (!(this._cachedChunks.length > 0)) {
                  _context.next = 5;
                  break;
                }

                chunk = this._cachedChunks.shift();
                return _context.abrupt("return", {
                  value: chunk,
                  done: false
                });

              case 5:
                if (!this._done) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", {
                  value: undefined,
                  done: true
                });

              case 7:
                requestCapability = (0, _util.createPromiseCapability)();

                this._requests.push(requestCapability);

                return _context.abrupt("return", requestCapability.promise);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function read() {
        return _read.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      this._done = true;

      this._headersReceivedCapability.reject(reason);

      this._requests.forEach(function (requestCapability) {
        requestCapability.resolve({
          value: undefined,
          done: true
        });
      });

      this._requests = [];

      if (this._manager.isPendingRequest(this._fullRequestId)) {
        this._manager.abortRequest(this._fullRequestId);
      }

      this._fullRequestReader = null;
    }
  }, {
    key: "filename",
    get: function get() {
      return this._filename;
    }
  }, {
    key: "isRangeSupported",
    get: function get() {
      return this._isRangeSupported;
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return this._isStreamingSupported;
    }
  }, {
    key: "contentLength",
    get: function get() {
      return this._contentLength;
    }
  }, {
    key: "headersReady",
    get: function get() {
      return this._headersReceivedCapability.promise;
    }
  }]);

  return PDFNetworkStreamFullRequestReader;
}();

var PDFNetworkStreamRangeRequestReader = /*#__PURE__*/function () {
  function PDFNetworkStreamRangeRequestReader(manager, begin, end) {
    _classCallCheck(this, PDFNetworkStreamRangeRequestReader);

    this._manager = manager;
    var args = {
      onDone: this._onDone.bind(this),
      onProgress: this._onProgress.bind(this)
    };
    this._requestId = manager.requestRange(begin, end, args);
    this._requests = [];
    this._queuedChunk = null;
    this._done = false;
    this.onProgress = null;
    this.onClosed = null;
  }

  _createClass(PDFNetworkStreamRangeRequestReader, [{
    key: "_close",
    value: function _close() {
      if (this.onClosed) {
        this.onClosed(this);
      }
    }
  }, {
    key: "_onDone",
    value: function _onDone(data) {
      var chunk = data.chunk;

      if (this._requests.length > 0) {
        var requestCapability = this._requests.shift();

        requestCapability.resolve({
          value: chunk,
          done: false
        });
      } else {
        this._queuedChunk = chunk;
      }

      this._done = true;

      this._requests.forEach(function (requestCapability) {
        requestCapability.resolve({
          value: undefined,
          done: true
        });
      });

      this._requests = [];

      this._close();
    }
  }, {
    key: "_onProgress",
    value: function _onProgress(evt) {
      if (!this.isStreamingSupported && this.onProgress) {
        this.onProgress({
          loaded: evt.loaded
        });
      }
    }
  }, {
    key: "read",
    value: function () {
      var _read2 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var chunk, requestCapability;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this._queuedChunk !== null)) {
                  _context2.next = 4;
                  break;
                }

                chunk = this._queuedChunk;
                this._queuedChunk = null;
                return _context2.abrupt("return", {
                  value: chunk,
                  done: false
                });

              case 4:
                if (!this._done) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", {
                  value: undefined,
                  done: true
                });

              case 6:
                requestCapability = (0, _util.createPromiseCapability)();

                this._requests.push(requestCapability);

                return _context2.abrupt("return", requestCapability.promise);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function read() {
        return _read2.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      this._done = true;

      this._requests.forEach(function (requestCapability) {
        requestCapability.resolve({
          value: undefined,
          done: true
        });
      });

      this._requests = [];

      if (this._manager.isPendingRequest(this._requestId)) {
        this._manager.abortRequest(this._requestId);
      }

      this._close();
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return false;
    }
  }]);

  return PDFNetworkStreamRangeRequestReader;
}();

/***/ }),
/* 212 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFFetchStream = void 0;

var _regenerator = _interopRequireDefault(__w_pdfjs_require__(191));

var _util = __w_pdfjs_require__(1);

var _network_utils = __w_pdfjs_require__(209);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function createFetchOptions(headers, withCredentials, abortController) {
  return {
    method: "GET",
    headers: headers,
    signal: abortController && abortController.signal,
    mode: "cors",
    credentials: withCredentials ? "include" : "same-origin",
    redirect: "follow"
  };
}

function createHeaders(httpHeaders) {
  var headers = new Headers();

  for (var property in httpHeaders) {
    var value = httpHeaders[property];

    if (typeof value === "undefined") {
      continue;
    }

    headers.append(property, value);
  }

  return headers;
}

var PDFFetchStream = /*#__PURE__*/function () {
  function PDFFetchStream(source) {
    _classCallCheck(this, PDFFetchStream);

    this.source = source;
    this.isHttp = /^https?:/i.test(source.url);
    this.httpHeaders = this.isHttp && source.httpHeaders || {};
    this._fullRequestReader = null;
    this._rangeRequestReaders = [];
  }

  _createClass(PDFFetchStream, [{
    key: "getFullReader",
    value: function getFullReader() {
      (0, _util.assert)(!this._fullRequestReader);
      this._fullRequestReader = new PDFFetchStreamReader(this);
      return this._fullRequestReader;
    }
  }, {
    key: "getRangeReader",
    value: function getRangeReader(begin, end) {
      if (end <= this._progressiveDataLength) {
        return null;
      }

      var reader = new PDFFetchStreamRangeReader(this, begin, end);

      this._rangeRequestReaders.push(reader);

      return reader;
    }
  }, {
    key: "cancelAllRequests",
    value: function cancelAllRequests(reason) {
      if (this._fullRequestReader) {
        this._fullRequestReader.cancel(reason);
      }

      var readers = this._rangeRequestReaders.slice(0);

      readers.forEach(function (reader) {
        reader.cancel(reason);
      });
    }
  }, {
    key: "_progressiveDataLength",
    get: function get() {
      return this._fullRequestReader ? this._fullRequestReader._loaded : 0;
    }
  }]);

  return PDFFetchStream;
}();

exports.PDFFetchStream = PDFFetchStream;

var PDFFetchStreamReader = /*#__PURE__*/function () {
  function PDFFetchStreamReader(stream) {
    var _this = this;

    _classCallCheck(this, PDFFetchStreamReader);

    this._stream = stream;
    this._reader = null;
    this._loaded = 0;
    this._filename = null;
    var source = stream.source;
    this._withCredentials = source.withCredentials || false;
    this._contentLength = source.length;
    this._headersCapability = (0, _util.createPromiseCapability)();
    this._disableRange = source.disableRange || false;
    this._rangeChunkSize = source.rangeChunkSize;

    if (!this._rangeChunkSize && !this._disableRange) {
      this._disableRange = true;
    }

    if (typeof AbortController !== "undefined") {
      this._abortController = new AbortController();
    }

    this._isStreamingSupported = !source.disableStream;
    this._isRangeSupported = !source.disableRange;
    this._headers = createHeaders(this._stream.httpHeaders);
    var url = source.url;
    fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then(function (response) {
      if (!(0, _network_utils.validateResponseStatus)(response.status)) {
        throw (0, _network_utils.createResponseStatusError)(response.status, url);
      }

      _this._reader = response.body.getReader();

      _this._headersCapability.resolve();

      var getResponseHeader = function getResponseHeader(name) {
        return response.headers.get(name);
      };

      var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
        getResponseHeader: getResponseHeader,
        isHttp: _this._stream.isHttp,
        rangeChunkSize: _this._rangeChunkSize,
        disableRange: _this._disableRange
      }),
          allowRangeRequests = _validateRangeRequest.allowRangeRequests,
          suggestedLength = _validateRangeRequest.suggestedLength;

      _this._isRangeSupported = allowRangeRequests;
      _this._contentLength = suggestedLength || _this._contentLength;
      _this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);

      if (!_this._isStreamingSupported && _this._isRangeSupported) {
        _this.cancel(new _util.AbortException("Streaming is disabled."));
      }
    })["catch"](this._headersCapability.reject);
    this.onProgress = null;
  }

  _createClass(PDFFetchStreamReader, [{
    key: "read",
    value: function () {
      var _read = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _ref, value, done, buffer;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._headersCapability.promise;

              case 2:
                _context.next = 4;
                return this._reader.read();

              case 4:
                _ref = _context.sent;
                value = _ref.value;
                done = _ref.done;

                if (!done) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", {
                  value: value,
                  done: done
                });

              case 9:
                this._loaded += value.byteLength;

                if (this.onProgress) {
                  this.onProgress({
                    loaded: this._loaded,
                    total: this._contentLength
                  });
                }

                buffer = new Uint8Array(value).buffer;
                return _context.abrupt("return", {
                  value: buffer,
                  done: false
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function read() {
        return _read.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      if (this._reader) {
        this._reader.cancel(reason);
      }

      if (this._abortController) {
        this._abortController.abort();
      }
    }
  }, {
    key: "headersReady",
    get: function get() {
      return this._headersCapability.promise;
    }
  }, {
    key: "filename",
    get: function get() {
      return this._filename;
    }
  }, {
    key: "contentLength",
    get: function get() {
      return this._contentLength;
    }
  }, {
    key: "isRangeSupported",
    get: function get() {
      return this._isRangeSupported;
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return this._isStreamingSupported;
    }
  }]);

  return PDFFetchStreamReader;
}();

var PDFFetchStreamRangeReader = /*#__PURE__*/function () {
  function PDFFetchStreamRangeReader(stream, begin, end) {
    var _this2 = this;

    _classCallCheck(this, PDFFetchStreamRangeReader);

    this._stream = stream;
    this._reader = null;
    this._loaded = 0;
    var source = stream.source;
    this._withCredentials = source.withCredentials || false;
    this._readCapability = (0, _util.createPromiseCapability)();
    this._isStreamingSupported = !source.disableStream;

    if (typeof AbortController !== "undefined") {
      this._abortController = new AbortController();
    }

    this._headers = createHeaders(this._stream.httpHeaders);

    this._headers.append("Range", "bytes=".concat(begin, "-").concat(end - 1));

    var url = source.url;
    fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then(function (response) {
      if (!(0, _network_utils.validateResponseStatus)(response.status)) {
        throw (0, _network_utils.createResponseStatusError)(response.status, url);
      }

      _this2._readCapability.resolve();

      _this2._reader = response.body.getReader();
    });
    this.onProgress = null;
  }

  _createClass(PDFFetchStreamRangeReader, [{
    key: "read",
    value: function () {
      var _read2 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var _ref2, value, done, buffer;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._readCapability.promise;

              case 2:
                _context2.next = 4;
                return this._reader.read();

              case 4:
                _ref2 = _context2.sent;
                value = _ref2.value;
                done = _ref2.done;

                if (!done) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", {
                  value: value,
                  done: done
                });

              case 9:
                this._loaded += value.byteLength;

                if (this.onProgress) {
                  this.onProgress({
                    loaded: this._loaded
                  });
                }

                buffer = new Uint8Array(value).buffer;
                return _context2.abrupt("return", {
                  value: buffer,
                  done: false
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function read() {
        return _read2.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      if (this._reader) {
        this._reader.cancel(reason);
      }

      if (this._abortController) {
        this._abortController.abort();
      }
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return this._isStreamingSupported;
    }
  }]);

  return PDFFetchStreamRangeReader;
}();

/***/ })
/******/ ]);
});
//# sourceMappingURL=pdf.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(264).Buffer, __webpack_require__(50), __webpack_require__(353)))

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50)))

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50), __webpack_require__(353)))

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "code" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/code')
//   ES2015:
//     import 'tinymce/plugins/code'
__webpack_require__(1481);

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 *
 * Version: 5.10.5 (2022-05-25)
 */
(function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var setContent = function (editor, html) {
      editor.focus();
      editor.undoManager.transact(function () {
        editor.setContent(html);
      });
      editor.selection.setCursorLocation();
      editor.nodeChanged();
    };
    var getContent = function (editor) {
      return editor.getContent({ source_view: true });
    };

    var open = function (editor) {
      var editorContent = getContent(editor);
      editor.windowManager.open({
        title: 'Source Code',
        size: 'large',
        body: {
          type: 'panel',
          items: [{
              type: 'textarea',
              name: 'code'
            }]
        },
        buttons: [
          {
            type: 'cancel',
            name: 'cancel',
            text: 'Cancel'
          },
          {
            type: 'submit',
            name: 'save',
            text: 'Save',
            primary: true
          }
        ],
        initialData: { code: editorContent },
        onSubmit: function (api) {
          setContent(editor, api.getData().code);
          api.close();
        }
      });
    };

    var register$1 = function (editor) {
      editor.addCommand('mceCodeEditor', function () {
        open(editor);
      });
    };

    var register = function (editor) {
      var onAction = function () {
        return editor.execCommand('mceCodeEditor');
      };
      editor.ui.registry.addButton('code', {
        icon: 'sourcecode',
        tooltip: 'Source code',
        onAction: onAction
      });
      editor.ui.registry.addMenuItem('code', {
        icon: 'sourcecode',
        text: 'Source code',
        onAction: onAction
      });
    };

    function Plugin () {
      global.add('code', function (editor) {
        register$1(editor);
        register(editor);
        return {};
      });
    }

    Plugin();

}());


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "codesample" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/codesample')
//   ES2015:
//     import 'tinymce/plugins/codesample'
__webpack_require__(1483);

/***/ }),
/* 1483 */
/***/ (function(module, exports) {

/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 *
 * Version: 5.10.5 (2022-05-25)
 */
(function () {
    'use strict';

    var global$2 = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var noop = function () {
    };
    var constant = function (value) {
      return function () {
        return value;
      };
    };
    var identity = function (x) {
      return x;
    };
    var never = constant(false);
    var always = constant(true);

    var none = function () {
      return NONE;
    };
    var NONE = function () {
      var call = function (thunk) {
        return thunk();
      };
      var id = identity;
      var me = {
        fold: function (n, _s) {
          return n();
        },
        isSome: never,
        isNone: always,
        getOr: id,
        getOrThunk: call,
        getOrDie: function (msg) {
          throw new Error(msg || 'error: getOrDie called on none.');
        },
        getOrNull: constant(null),
        getOrUndefined: constant(undefined),
        or: id,
        orThunk: call,
        map: none,
        each: noop,
        bind: none,
        exists: never,
        forall: always,
        filter: function () {
          return none();
        },
        toArray: function () {
          return [];
        },
        toString: constant('none()')
      };
      return me;
    }();
    var some = function (a) {
      var constant_a = constant(a);
      var self = function () {
        return me;
      };
      var bind = function (f) {
        return f(a);
      };
      var me = {
        fold: function (n, s) {
          return s(a);
        },
        isSome: always,
        isNone: never,
        getOr: constant_a,
        getOrThunk: constant_a,
        getOrDie: constant_a,
        getOrNull: constant_a,
        getOrUndefined: constant_a,
        or: self,
        orThunk: self,
        map: function (f) {
          return some(f(a));
        },
        each: function (f) {
          f(a);
        },
        bind: bind,
        exists: bind,
        forall: bind,
        filter: function (f) {
          return f(a) ? me : NONE;
        },
        toArray: function () {
          return [a];
        },
        toString: function () {
          return 'some(' + a + ')';
        }
      };
      return me;
    };
    var from = function (value) {
      return value === null || value === undefined ? NONE : some(value);
    };
    var Optional = {
      some: some,
      none: none,
      from: from
    };

    var get$1 = function (xs, i) {
      return i >= 0 && i < xs.length ? Optional.some(xs[i]) : Optional.none();
    };
    var head = function (xs) {
      return get$1(xs, 0);
    };

    var someIf = function (b, a) {
      return b ? Optional.some(a) : Optional.none();
    };

    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var isCodeSample = function (elm) {
      return elm && elm.nodeName === 'PRE' && elm.className.indexOf('language-') !== -1;
    };
    var trimArg = function (predicateFn) {
      return function (arg1, arg2) {
        return predicateFn(arg2);
      };
    };

    var Global = typeof window !== 'undefined' ? window : Function('return this;')();

    var exports$1 = {}, module = { exports: exports$1 }, global = {};
    (function (define, exports, module, require) {
      var oldprism = window.Prism;
      window.Prism = { manual: true };
      (function (global, factory) {
        typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.EphoxContactWrapper = factory());
      }(this, function () {
        var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
        var prismCore = { exports: {} };
        (function (module) {
          var _self = typeof window !== 'undefined' ? window : typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope ? self : {};
          var Prism = function (_self) {
            var lang = /\blang(?:uage)?-([\w-]+)\b/i;
            var uniqueId = 0;
            var plainTextGrammar = {};
            var _ = {
              manual: _self.Prism && _self.Prism.manual,
              disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
              util: {
                encode: function encode(tokens) {
                  if (tokens instanceof Token) {
                    return new Token(tokens.type, encode(tokens.content), tokens.alias);
                  } else if (Array.isArray(tokens)) {
                    return tokens.map(encode);
                  } else {
                    return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
                  }
                },
                type: function (o) {
                  return Object.prototype.toString.call(o).slice(8, -1);
                },
                objId: function (obj) {
                  if (!obj['__id']) {
                    Object.defineProperty(obj, '__id', { value: ++uniqueId });
                  }
                  return obj['__id'];
                },
                clone: function deepClone(o, visited) {
                  visited = visited || {};
                  var clone;
                  var id;
                  switch (_.util.type(o)) {
                  case 'Object':
                    id = _.util.objId(o);
                    if (visited[id]) {
                      return visited[id];
                    }
                    clone = {};
                    visited[id] = clone;
                    for (var key in o) {
                      if (o.hasOwnProperty(key)) {
                        clone[key] = deepClone(o[key], visited);
                      }
                    }
                    return clone;
                  case 'Array':
                    id = _.util.objId(o);
                    if (visited[id]) {
                      return visited[id];
                    }
                    clone = [];
                    visited[id] = clone;
                    o.forEach(function (v, i) {
                      clone[i] = deepClone(v, visited);
                    });
                    return clone;
                  default:
                    return o;
                  }
                },
                getLanguage: function (element) {
                  while (element && !lang.test(element.className)) {
                    element = element.parentElement;
                  }
                  if (element) {
                    return (element.className.match(lang) || [
                      ,
                      'none'
                    ])[1].toLowerCase();
                  }
                  return 'none';
                },
                currentScript: function () {
                  if (typeof document === 'undefined') {
                    return null;
                  }
                  if ('currentScript' in document && 1 < 2) {
                    return document.currentScript;
                  }
                  try {
                    throw new Error();
                  } catch (err) {
                    var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
                    if (src) {
                      var scripts = document.getElementsByTagName('script');
                      for (var i in scripts) {
                        if (scripts[i].src == src) {
                          return scripts[i];
                        }
                      }
                    }
                    return null;
                  }
                },
                isActive: function (element, className, defaultActivation) {
                  var no = 'no-' + className;
                  while (element) {
                    var classList = element.classList;
                    if (classList.contains(className)) {
                      return true;
                    }
                    if (classList.contains(no)) {
                      return false;
                    }
                    element = element.parentElement;
                  }
                  return !!defaultActivation;
                }
              },
              languages: {
                plain: plainTextGrammar,
                plaintext: plainTextGrammar,
                text: plainTextGrammar,
                txt: plainTextGrammar,
                extend: function (id, redef) {
                  var lang = _.util.clone(_.languages[id]);
                  for (var key in redef) {
                    lang[key] = redef[key];
                  }
                  return lang;
                },
                insertBefore: function (inside, before, insert, root) {
                  root = root || _.languages;
                  var grammar = root[inside];
                  var ret = {};
                  for (var token in grammar) {
                    if (grammar.hasOwnProperty(token)) {
                      if (token == before) {
                        for (var newToken in insert) {
                          if (insert.hasOwnProperty(newToken)) {
                            ret[newToken] = insert[newToken];
                          }
                        }
                      }
                      if (!insert.hasOwnProperty(token)) {
                        ret[token] = grammar[token];
                      }
                    }
                  }
                  var old = root[inside];
                  root[inside] = ret;
                  _.languages.DFS(_.languages, function (key, value) {
                    if (value === old && key != inside) {
                      this[key] = ret;
                    }
                  });
                  return ret;
                },
                DFS: function DFS(o, callback, type, visited) {
                  visited = visited || {};
                  var objId = _.util.objId;
                  for (var i in o) {
                    if (o.hasOwnProperty(i)) {
                      callback.call(o, i, o[i], type || i);
                      var property = o[i];
                      var propertyType = _.util.type(property);
                      if (propertyType === 'Object' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, null, visited);
                      } else if (propertyType === 'Array' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, i, visited);
                      }
                    }
                  }
                }
              },
              plugins: {},
              highlightAll: function (async, callback) {
                _.highlightAllUnder(document, async, callback);
              },
              highlightAllUnder: function (container, async, callback) {
                var env = {
                  callback: callback,
                  container: container,
                  selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
                };
                _.hooks.run('before-highlightall', env);
                env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
                _.hooks.run('before-all-elements-highlight', env);
                for (var i = 0, element; element = env.elements[i++];) {
                  _.highlightElement(element, async === true, env.callback);
                }
              },
              highlightElement: function (element, async, callback) {
                var language = _.util.getLanguage(element);
                var grammar = _.languages[language];
                element.className = element.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;
                var parent = element.parentElement;
                if (parent && parent.nodeName.toLowerCase() === 'pre') {
                  parent.className = parent.className.replace(lang, '').replace(/\s+/g, ' ') + ' language-' + language;
                }
                var code = element.textContent;
                var env = {
                  element: element,
                  language: language,
                  grammar: grammar,
                  code: code
                };
                function insertHighlightedCode(highlightedCode) {
                  env.highlightedCode = highlightedCode;
                  _.hooks.run('before-insert', env);
                  env.element.innerHTML = env.highlightedCode;
                  _.hooks.run('after-highlight', env);
                  _.hooks.run('complete', env);
                  callback && callback.call(env.element);
                }
                _.hooks.run('before-sanity-check', env);
                parent = env.element.parentElement;
                if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) {
                  parent.setAttribute('tabindex', '0');
                }
                if (!env.code) {
                  _.hooks.run('complete', env);
                  callback && callback.call(env.element);
                  return;
                }
                _.hooks.run('before-highlight', env);
                if (!env.grammar) {
                  insertHighlightedCode(_.util.encode(env.code));
                  return;
                }
                if (async && _self.Worker) {
                  var worker = new Worker(_.filename);
                  worker.onmessage = function (evt) {
                    insertHighlightedCode(evt.data);
                  };
                  worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                  }));
                } else {
                  insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
                }
              },
              highlight: function (text, grammar, language) {
                var env = {
                  code: text,
                  grammar: grammar,
                  language: language
                };
                _.hooks.run('before-tokenize', env);
                env.tokens = _.tokenize(env.code, env.grammar);
                _.hooks.run('after-tokenize', env);
                return Token.stringify(_.util.encode(env.tokens), env.language);
              },
              tokenize: function (text, grammar) {
                var rest = grammar.rest;
                if (rest) {
                  for (var token in rest) {
                    grammar[token] = rest[token];
                  }
                  delete grammar.rest;
                }
                var tokenList = new LinkedList();
                addAfter(tokenList, tokenList.head, text);
                matchGrammar(text, tokenList, grammar, tokenList.head, 0);
                return toArray(tokenList);
              },
              hooks: {
                all: {},
                add: function (name, callback) {
                  var hooks = _.hooks.all;
                  hooks[name] = hooks[name] || [];
                  hooks[name].push(callback);
                },
                run: function (name, env) {
                  var callbacks = _.hooks.all[name];
                  if (!callbacks || !callbacks.length) {
                    return;
                  }
                  for (var i = 0, callback; callback = callbacks[i++];) {
                    callback(env);
                  }
                }
              },
              Token: Token
            };
            _self.Prism = _;
            function Token(type, content, alias, matchedStr) {
              this.type = type;
              this.content = content;
              this.alias = alias;
              this.length = (matchedStr || '').length | 0;
            }
            Token.stringify = function stringify(o, language) {
              if (typeof o == 'string') {
                return o;
              }
              if (Array.isArray(o)) {
                var s = '';
                o.forEach(function (e) {
                  s += stringify(e, language);
                });
                return s;
              }
              var env = {
                type: o.type,
                content: stringify(o.content, language),
                tag: 'span',
                classes: [
                  'token',
                  o.type
                ],
                attributes: {},
                language: language
              };
              var aliases = o.alias;
              if (aliases) {
                if (Array.isArray(aliases)) {
                  Array.prototype.push.apply(env.classes, aliases);
                } else {
                  env.classes.push(aliases);
                }
              }
              _.hooks.run('wrap', env);
              var attributes = '';
              for (var name in env.attributes) {
                attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
              }
              return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
            };
            function matchPattern(pattern, pos, text, lookbehind) {
              pattern.lastIndex = pos;
              var match = pattern.exec(text);
              if (match && lookbehind && match[1]) {
                var lookbehindLength = match[1].length;
                match.index += lookbehindLength;
                match[0] = match[0].slice(lookbehindLength);
              }
              return match;
            }
            function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
              for (var token in grammar) {
                if (!grammar.hasOwnProperty(token) || !grammar[token]) {
                  continue;
                }
                var patterns = grammar[token];
                patterns = Array.isArray(patterns) ? patterns : [patterns];
                for (var j = 0; j < patterns.length; ++j) {
                  if (rematch && rematch.cause == token + ',' + j) {
                    return;
                  }
                  var patternObj = patterns[j];
                  var inside = patternObj.inside;
                  var lookbehind = !!patternObj.lookbehind;
                  var greedy = !!patternObj.greedy;
                  var alias = patternObj.alias;
                  if (greedy && !patternObj.pattern.global) {
                    var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                    patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
                  }
                  var pattern = patternObj.pattern || patternObj;
                  for (var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next) {
                    if (rematch && pos >= rematch.reach) {
                      break;
                    }
                    var str = currentNode.value;
                    if (tokenList.length > text.length) {
                      return;
                    }
                    if (str instanceof Token) {
                      continue;
                    }
                    var removeCount = 1;
                    var match;
                    if (greedy) {
                      match = matchPattern(pattern, pos, text, lookbehind);
                      if (!match) {
                        break;
                      }
                      var from = match.index;
                      var to = match.index + match[0].length;
                      var p = pos;
                      p += currentNode.value.length;
                      while (from >= p) {
                        currentNode = currentNode.next;
                        p += currentNode.value.length;
                      }
                      p -= currentNode.value.length;
                      pos = p;
                      if (currentNode.value instanceof Token) {
                        continue;
                      }
                      for (var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === 'string'); k = k.next) {
                        removeCount++;
                        p += k.value.length;
                      }
                      removeCount--;
                      str = text.slice(pos, p);
                      match.index -= pos;
                    } else {
                      match = matchPattern(pattern, 0, str, lookbehind);
                      if (!match) {
                        continue;
                      }
                    }
                    var from = match.index;
                    var matchStr = match[0];
                    var before = str.slice(0, from);
                    var after = str.slice(from + matchStr.length);
                    var reach = pos + str.length;
                    if (rematch && reach > rematch.reach) {
                      rematch.reach = reach;
                    }
                    var removeFrom = currentNode.prev;
                    if (before) {
                      removeFrom = addAfter(tokenList, removeFrom, before);
                      pos += before.length;
                    }
                    removeRange(tokenList, removeFrom, removeCount);
                    var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                    currentNode = addAfter(tokenList, removeFrom, wrapped);
                    if (after) {
                      addAfter(tokenList, currentNode, after);
                    }
                    if (removeCount > 1) {
                      var nestedRematch = {
                        cause: token + ',' + j,
                        reach: reach
                      };
                      matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                      if (rematch && nestedRematch.reach > rematch.reach) {
                        rematch.reach = nestedRematch.reach;
                      }
                    }
                  }
                }
              }
            }
            function LinkedList() {
              var head = {
                value: null,
                prev: null,
                next: null
              };
              var tail = {
                value: null,
                prev: head,
                next: null
              };
              head.next = tail;
              this.head = head;
              this.tail = tail;
              this.length = 0;
            }
            function addAfter(list, node, value) {
              var next = node.next;
              var newNode = {
                value: value,
                prev: node,
                next: next
              };
              node.next = newNode;
              next.prev = newNode;
              list.length++;
              return newNode;
            }
            function removeRange(list, node, count) {
              var next = node.next;
              for (var i = 0; i < count && next !== list.tail; i++) {
                next = next.next;
              }
              node.next = next;
              next.prev = node;
              list.length -= i;
            }
            function toArray(list) {
              var array = [];
              var node = list.head.next;
              while (node !== list.tail) {
                array.push(node.value);
                node = node.next;
              }
              return array;
            }
            if (!_self.document) {
              if (!_self.addEventListener) {
                return _;
              }
              if (!_.disableWorkerMessageHandler) {
                _self.addEventListener('message', function (evt) {
                  var message = JSON.parse(evt.data);
                  var lang = message.language;
                  var code = message.code;
                  var immediateClose = message.immediateClose;
                  _self.postMessage(_.highlight(code, _.languages[lang], lang));
                  if (immediateClose) {
                    _self.close();
                  }
                }, false);
              }
              return _;
            }
            var script = _.util.currentScript();
            if (script) {
              _.filename = script.src;
              if (script.hasAttribute('data-manual')) {
                _.manual = true;
              }
            }
            function highlightAutomaticallyCallback() {
              if (!_.manual) {
                _.highlightAll();
              }
            }
            if (!_.manual) {
              var readyState = document.readyState;
              if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) {
                document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
              } else {
                if (window.requestAnimationFrame) {
                  window.requestAnimationFrame(highlightAutomaticallyCallback);
                } else {
                  window.setTimeout(highlightAutomaticallyCallback, 16);
                }
              }
            }
            return _;
          }(_self);
          if (module.exports) {
            module.exports = Prism;
          }
          if (typeof commonjsGlobal !== 'undefined') {
            commonjsGlobal.Prism = Prism;
          }
        }(prismCore));
        Prism.languages.clike = {
          'comment': [
            {
              pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
              lookbehind: true,
              greedy: true
            },
            {
              pattern: /(^|[^\\:])\/\/.*/,
              lookbehind: true,
              greedy: true
            }
          ],
          'string': {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
          },
          'class-name': {
            pattern: /(\b(?:class|interface|extends|implements|trait|instanceof|new)\s+|\bcatch\s+\()[\w.\\]+/i,
            lookbehind: true,
            inside: { 'punctuation': /[.\\]/ }
          },
          'keyword': /\b(?:if|else|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/,
          'boolean': /\b(?:true|false)\b/,
          'function': /\b\w+(?=\()/,
          'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
          'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
          'punctuation': /[{}[\];(),.:]/
        };
        (function (Prism) {
          function getPlaceholder(language, index) {
            return '___' + language.toUpperCase() + index + '___';
          }
          Object.defineProperties(Prism.languages['markup-templating'] = {}, {
            buildPlaceholders: {
              value: function (env, language, placeholderPattern, replaceFilter) {
                if (env.language !== language) {
                  return;
                }
                var tokenStack = env.tokenStack = [];
                env.code = env.code.replace(placeholderPattern, function (match) {
                  if (typeof replaceFilter === 'function' && !replaceFilter(match)) {
                    return match;
                  }
                  var i = tokenStack.length;
                  var placeholder;
                  while (env.code.indexOf(placeholder = getPlaceholder(language, i)) !== -1) {
                    ++i;
                  }
                  tokenStack[i] = match;
                  return placeholder;
                });
                env.grammar = Prism.languages.markup;
              }
            },
            tokenizePlaceholders: {
              value: function (env, language) {
                if (env.language !== language || !env.tokenStack) {
                  return;
                }
                env.grammar = Prism.languages[language];
                var j = 0;
                var keys = Object.keys(env.tokenStack);
                function walkTokens(tokens) {
                  for (var i = 0; i < tokens.length; i++) {
                    if (j >= keys.length) {
                      break;
                    }
                    var token = tokens[i];
                    if (typeof token === 'string' || token.content && typeof token.content === 'string') {
                      var k = keys[j];
                      var t = env.tokenStack[k];
                      var s = typeof token === 'string' ? token : token.content;
                      var placeholder = getPlaceholder(language, k);
                      var index = s.indexOf(placeholder);
                      if (index > -1) {
                        ++j;
                        var before = s.substring(0, index);
                        var middle = new Prism.Token(language, Prism.tokenize(t, env.grammar), 'language-' + language, t);
                        var after = s.substring(index + placeholder.length);
                        var replacement = [];
                        if (before) {
                          replacement.push.apply(replacement, walkTokens([before]));
                        }
                        replacement.push(middle);
                        if (after) {
                          replacement.push.apply(replacement, walkTokens([after]));
                        }
                        if (typeof token === 'string') {
                          tokens.splice.apply(tokens, [
                            i,
                            1
                          ].concat(replacement));
                        } else {
                          token.content = replacement;
                        }
                      }
                    } else if (token.content) {
                      walkTokens(token.content);
                    }
                  }
                  return tokens;
                }
                walkTokens(env.tokens);
              }
            }
          });
        }(Prism));
        Prism.languages.c = Prism.languages.extend('clike', {
          'comment': {
            pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
            greedy: true
          },
          'class-name': {
            pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
            lookbehind: true
          },
          'keyword': /\b(?:__attribute__|_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|asm|typeof|inline|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|union|unsigned|void|volatile|while)\b/,
          'function': /\b[a-z_]\w*(?=\s*\()/i,
          'number': /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
          'operator': />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
        });
        Prism.languages.insertBefore('c', 'string', {
          'macro': {
            pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
            lookbehind: true,
            greedy: true,
            alias: 'property',
            inside: {
              'string': [
                {
                  pattern: /^(#\s*include\s*)<[^>]+>/,
                  lookbehind: true
                },
                Prism.languages.c['string']
              ],
              'comment': Prism.languages.c['comment'],
              'macro-name': [
                {
                  pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
                  lookbehind: true
                },
                {
                  pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
                  lookbehind: true,
                  alias: 'function'
                }
              ],
              'directive': {
                pattern: /^(#\s*)[a-z]+/,
                lookbehind: true,
                alias: 'keyword'
              },
              'directive-hash': /^#/,
              'punctuation': /##|\\(?=[\r\n])/,
              'expression': {
                pattern: /\S[\s\S]*/,
                inside: Prism.languages.c
              }
            }
          },
          'constant': /\b(?:__FILE__|__LINE__|__DATE__|__TIME__|__TIMESTAMP__|__func__|EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|stdin|stdout|stderr)\b/
        });
        delete Prism.languages.c['boolean'];
        (function (Prism) {
          var keyword = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char8_t|char16_t|char32_t|class|compl|concept|const|consteval|constexpr|constinit|const_cast|continue|co_await|co_return|co_yield|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int8_t|int16_t|int32_t|int64_t|uint8_t|uint16_t|uint32_t|uint64_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/;
          var modName = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function () {
            return keyword.source;
          });
          Prism.languages.cpp = Prism.languages.extend('c', {
            'class-name': [
              {
                pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function () {
                  return keyword.source;
                })),
                lookbehind: true
              },
              /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
              /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
              /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
            ],
            'keyword': keyword,
            'number': {
              pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
              greedy: true
            },
            'operator': />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
            'boolean': /\b(?:true|false)\b/
          });
          Prism.languages.insertBefore('cpp', 'string', {
            'module': {
              pattern: RegExp(/(\b(?:module|import)\s+)/.source + '(?:' + /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + '|' + /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function () {
                return modName;
              }) + ')'),
              lookbehind: true,
              greedy: true,
              inside: {
                'string': /^[<"][\s\S]+/,
                'operator': /:/,
                'punctuation': /\./
              }
            },
            'raw-string': {
              pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
              alias: 'string',
              greedy: true
            }
          });
          Prism.languages.insertBefore('cpp', 'keyword', {
            'generic-function': {
              pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
              inside: {
                'function': /^\w+/,
                'generic': {
                  pattern: /<[\s\S]+/,
                  alias: 'class-name',
                  inside: Prism.languages.cpp
                }
              }
            }
          });
          Prism.languages.insertBefore('cpp', 'operator', {
            'double-colon': {
              pattern: /::/,
              alias: 'punctuation'
            }
          });
          Prism.languages.insertBefore('cpp', 'class-name', {
            'base-clause': {
              pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
              lookbehind: true,
              greedy: true,
              inside: Prism.languages.extend('cpp', {})
            }
          });
          Prism.languages.insertBefore('inside', 'double-colon', { 'class-name': /\b[a-z_]\w*\b(?!\s*::)/i }, Prism.languages.cpp['base-clause']);
        }(Prism));
        (function (Prism) {
          function replace(pattern, replacements) {
            return pattern.replace(/<<(\d+)>>/g, function (m, index) {
              return '(?:' + replacements[+index] + ')';
            });
          }
          function re(pattern, replacements, flags) {
            return RegExp(replace(pattern, replacements), flags || '');
          }
          function nested(pattern, depthLog2) {
            for (var i = 0; i < depthLog2; i++) {
              pattern = pattern.replace(/<<self>>/g, function () {
                return '(?:' + pattern + ')';
              });
            }
            return pattern.replace(/<<self>>/g, '[^\\s\\S]');
          }
          var keywordKinds = {
            type: 'bool byte char decimal double dynamic float int long object sbyte short string uint ulong ushort var void',
            typeDeclaration: 'class enum interface record struct',
            contextual: 'add alias and ascending async await by descending from(?=\\s*(?:\\w|$)) get global group into init(?=\\s*;) join let nameof not notnull on or orderby partial remove select set unmanaged value when where with(?=\\s*{)',
            other: 'abstract as base break case catch checked const continue default delegate do else event explicit extern finally fixed for foreach goto if implicit in internal is lock namespace new null operator out override params private protected public readonly ref return sealed sizeof stackalloc static switch this throw try typeof unchecked unsafe using virtual volatile while yield'
          };
          function keywordsToPattern(words) {
            return '\\b(?:' + words.trim().replace(/ /g, '|') + ')\\b';
          }
          var typeDeclarationKeywords = keywordsToPattern(keywordKinds.typeDeclaration);
          var keywords = RegExp(keywordsToPattern(keywordKinds.type + ' ' + keywordKinds.typeDeclaration + ' ' + keywordKinds.contextual + ' ' + keywordKinds.other));
          var nonTypeKeywords = keywordsToPattern(keywordKinds.typeDeclaration + ' ' + keywordKinds.contextual + ' ' + keywordKinds.other);
          var nonContextualKeywords = keywordsToPattern(keywordKinds.type + ' ' + keywordKinds.typeDeclaration + ' ' + keywordKinds.other);
          var generic = nested(/<(?:[^<>;=+\-*/%&|^]|<<self>>)*>/.source, 2);
          var nestedRound = nested(/\((?:[^()]|<<self>>)*\)/.source, 2);
          var name = /@?\b[A-Za-z_]\w*\b/.source;
          var genericName = replace(/<<0>>(?:\s*<<1>>)?/.source, [
            name,
            generic
          ]);
          var identifier = replace(/(?!<<0>>)<<1>>(?:\s*\.\s*<<1>>)*/.source, [
            nonTypeKeywords,
            genericName
          ]);
          var array = /\[\s*(?:,\s*)*\]/.source;
          var typeExpressionWithoutTuple = replace(/<<0>>(?:\s*(?:\?\s*)?<<1>>)*(?:\s*\?)?/.source, [
            identifier,
            array
          ]);
          var tupleElement = replace(/[^,()<>[\];=+\-*/%&|^]|<<0>>|<<1>>|<<2>>/.source, [
            generic,
            nestedRound,
            array
          ]);
          var tuple = replace(/\(<<0>>+(?:,<<0>>+)+\)/.source, [tupleElement]);
          var typeExpression = replace(/(?:<<0>>|<<1>>)(?:\s*(?:\?\s*)?<<2>>)*(?:\s*\?)?/.source, [
            tuple,
            identifier,
            array
          ]);
          var typeInside = {
            'keyword': keywords,
            'punctuation': /[<>()?,.:[\]]/
          };
          var character = /'(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'/.source;
          var regularString = /"(?:\\.|[^\\"\r\n])*"/.source;
          var verbatimString = /@"(?:""|\\[\s\S]|[^\\"])*"(?!")/.source;
          Prism.languages.csharp = Prism.languages.extend('clike', {
            'string': [
              {
                pattern: re(/(^|[^$\\])<<0>>/.source, [verbatimString]),
                lookbehind: true,
                greedy: true
              },
              {
                pattern: re(/(^|[^@$\\])<<0>>/.source, [regularString]),
                lookbehind: true,
                greedy: true
              },
              {
                pattern: RegExp(character),
                greedy: true,
                alias: 'character'
              }
            ],
            'class-name': [
              {
                pattern: re(/(\busing\s+static\s+)<<0>>(?=\s*;)/.source, [identifier]),
                lookbehind: true,
                inside: typeInside
              },
              {
                pattern: re(/(\busing\s+<<0>>\s*=\s*)<<1>>(?=\s*;)/.source, [
                  name,
                  typeExpression
                ]),
                lookbehind: true,
                inside: typeInside
              },
              {
                pattern: re(/(\busing\s+)<<0>>(?=\s*=)/.source, [name]),
                lookbehind: true
              },
              {
                pattern: re(/(\b<<0>>\s+)<<1>>/.source, [
                  typeDeclarationKeywords,
                  genericName
                ]),
                lookbehind: true,
                inside: typeInside
              },
              {
                pattern: re(/(\bcatch\s*\(\s*)<<0>>/.source, [identifier]),
                lookbehind: true,
                inside: typeInside
              },
              {
                pattern: re(/(\bwhere\s+)<<0>>/.source, [name]),
                lookbehind: true
              },
              {
                pattern: re(/(\b(?:is(?:\s+not)?|as)\s+)<<0>>/.source, [typeExpressionWithoutTuple]),
                lookbehind: true,
                inside: typeInside
              },
              {
                pattern: re(/\b<<0>>(?=\s+(?!<<1>>|with\s*\{)<<2>>(?:\s*[=,;:{)\]]|\s+(?:in|when)\b))/.source, [
                  typeExpression,
                  nonContextualKeywords,
                  name
                ]),
                inside: typeInside
              }
            ],
            'keyword': keywords,
            'number': /(?:\b0(?:x[\da-f_]*[\da-f]|b[01_]*[01])|(?:\B\.\d+(?:_+\d+)*|\b\d+(?:_+\d+)*(?:\.\d+(?:_+\d+)*)?)(?:e[-+]?\d+(?:_+\d+)*)?)(?:ul|lu|[dflmu])?\b/i,
            'operator': />>=?|<<=?|[-=]>|([-+&|])\1|~|\?\?=?|[-+*/%&|^!=<>]=?/,
            'punctuation': /\?\.?|::|[{}[\];(),.:]/
          });
          Prism.languages.insertBefore('csharp', 'number', {
            'range': {
              pattern: /\.\./,
              alias: 'operator'
            }
          });
          Prism.languages.insertBefore('csharp', 'punctuation', {
            'named-parameter': {
              pattern: re(/([(,]\s*)<<0>>(?=\s*:)/.source, [name]),
              lookbehind: true,
              alias: 'punctuation'
            }
          });
          Prism.languages.insertBefore('csharp', 'class-name', {
            'namespace': {
              pattern: re(/(\b(?:namespace|using)\s+)<<0>>(?:\s*\.\s*<<0>>)*(?=\s*[;{])/.source, [name]),
              lookbehind: true,
              inside: { 'punctuation': /\./ }
            },
            'type-expression': {
              pattern: re(/(\b(?:default|typeof|sizeof)\s*\(\s*(?!\s))(?:[^()\s]|\s(?!\s)|<<0>>)*(?=\s*\))/.source, [nestedRound]),
              lookbehind: true,
              alias: 'class-name',
              inside: typeInside
            },
            'return-type': {
              pattern: re(/<<0>>(?=\s+(?:<<1>>\s*(?:=>|[({]|\.\s*this\s*\[)|this\s*\[))/.source, [
                typeExpression,
                identifier
              ]),
              inside: typeInside,
              alias: 'class-name'
            },
            'constructor-invocation': {
              pattern: re(/(\bnew\s+)<<0>>(?=\s*[[({])/.source, [typeExpression]),
              lookbehind: true,
              inside: typeInside,
              alias: 'class-name'
            },
            'generic-method': {
              pattern: re(/<<0>>\s*<<1>>(?=\s*\()/.source, [
                name,
                generic
              ]),
              inside: {
                'function': re(/^<<0>>/.source, [name]),
                'generic': {
                  pattern: RegExp(generic),
                  alias: 'class-name',
                  inside: typeInside
                }
              }
            },
            'type-list': {
              pattern: re(/\b((?:<<0>>\s+<<1>>|record\s+<<1>>\s*<<5>>|where\s+<<2>>)\s*:\s*)(?:<<3>>|<<4>>|<<1>>\s*<<5>>|<<6>>)(?:\s*,\s*(?:<<3>>|<<4>>|<<6>>))*(?=\s*(?:where|[{;]|=>|$))/.source, [
                typeDeclarationKeywords,
                genericName,
                name,
                typeExpression,
                keywords.source,
                nestedRound,
                /\bnew\s*\(\s*\)/.source
              ]),
              lookbehind: true,
              inside: {
                'record-arguments': {
                  pattern: re(/(^(?!new\s*\()<<0>>\s*)<<1>>/.source, [
                    genericName,
                    nestedRound
                  ]),
                  lookbehind: true,
                  greedy: true,
                  inside: Prism.languages.csharp
                },
                'keyword': keywords,
                'class-name': {
                  pattern: RegExp(typeExpression),
                  greedy: true,
                  inside: typeInside
                },
                'punctuation': /[,()]/
              }
            },
            'preprocessor': {
              pattern: /(^[\t ]*)#.*/m,
              lookbehind: true,
              alias: 'property',
              inside: {
                'directive': {
                  pattern: /(#)\b(?:define|elif|else|endif|endregion|error|if|line|nullable|pragma|region|undef|warning)\b/,
                  lookbehind: true,
                  alias: 'keyword'
                }
              }
            }
          });
          var regularStringOrCharacter = regularString + '|' + character;
          var regularStringCharacterOrComment = replace(/\/(?![*/])|\/\/[^\r\n]*[\r\n]|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>/.source, [regularStringOrCharacter]);
          var roundExpression = nested(replace(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [regularStringCharacterOrComment]), 2);
          var attrTarget = /\b(?:assembly|event|field|method|module|param|property|return|type)\b/.source;
          var attr = replace(/<<0>>(?:\s*\(<<1>>*\))?/.source, [
            identifier,
            roundExpression
          ]);
          Prism.languages.insertBefore('csharp', 'class-name', {
            'attribute': {
              pattern: re(/((?:^|[^\s\w>)?])\s*\[\s*)(?:<<0>>\s*:\s*)?<<1>>(?:\s*,\s*<<1>>)*(?=\s*\])/.source, [
                attrTarget,
                attr
              ]),
              lookbehind: true,
              greedy: true,
              inside: {
                'target': {
                  pattern: re(/^<<0>>(?=\s*:)/.source, [attrTarget]),
                  alias: 'keyword'
                },
                'attribute-arguments': {
                  pattern: re(/\(<<0>>*\)/.source, [roundExpression]),
                  inside: Prism.languages.csharp
                },
                'class-name': {
                  pattern: RegExp(identifier),
                  inside: { 'punctuation': /\./ }
                },
                'punctuation': /[:,]/
              }
            }
          });
          var formatString = /:[^}\r\n]+/.source;
          var mInterpolationRound = nested(replace(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [regularStringCharacterOrComment]), 2);
          var mInterpolation = replace(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
            mInterpolationRound,
            formatString
          ]);
          var sInterpolationRound = nested(replace(/[^"'/()]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>|\(<<self>>*\)/.source, [regularStringOrCharacter]), 2);
          var sInterpolation = replace(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
            sInterpolationRound,
            formatString
          ]);
          function createInterpolationInside(interpolation, interpolationRound) {
            return {
              'interpolation': {
                pattern: re(/((?:^|[^{])(?:\{\{)*)<<0>>/.source, [interpolation]),
                lookbehind: true,
                inside: {
                  'format-string': {
                    pattern: re(/(^\{(?:(?![}:])<<0>>)*)<<1>>(?=\}$)/.source, [
                      interpolationRound,
                      formatString
                    ]),
                    lookbehind: true,
                    inside: { 'punctuation': /^:/ }
                  },
                  'punctuation': /^\{|\}$/,
                  'expression': {
                    pattern: /[\s\S]+/,
                    alias: 'language-csharp',
                    inside: Prism.languages.csharp
                  }
                }
              },
              'string': /[\s\S]+/
            };
          }
          Prism.languages.insertBefore('csharp', 'string', {
            'interpolation-string': [
              {
                pattern: re(/(^|[^\\])(?:\$@|@\$)"(?:""|\\[\s\S]|\{\{|<<0>>|[^\\{"])*"/.source, [mInterpolation]),
                lookbehind: true,
                greedy: true,
                inside: createInterpolationInside(mInterpolation, mInterpolationRound)
              },
              {
                pattern: re(/(^|[^@\\])\$"(?:\\.|\{\{|<<0>>|[^\\"{])*"/.source, [sInterpolation]),
                lookbehind: true,
                greedy: true,
                inside: createInterpolationInside(sInterpolation, sInterpolationRound)
              }
            ]
          });
        }(Prism));
        Prism.languages.dotnet = Prism.languages.cs = Prism.languages.csharp;
        (function (Prism) {
          var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
          Prism.languages.css = {
            'comment': /\/\*[\s\S]*?\*\//,
            'atrule': {
              pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
              inside: {
                'rule': /^@[\w-]+/,
                'selector-function-argument': {
                  pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                  lookbehind: true,
                  alias: 'selector'
                },
                'keyword': {
                  pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                  lookbehind: true
                }
              }
            },
            'url': {
              pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
              greedy: true,
              inside: {
                'function': /^url/i,
                'punctuation': /^\(|\)$/,
                'string': {
                  pattern: RegExp('^' + string.source + '$'),
                  alias: 'url'
                }
              }
            },
            'selector': {
              pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
              lookbehind: true
            },
            'string': {
              pattern: string,
              greedy: true
            },
            'property': {
              pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
              lookbehind: true
            },
            'important': /!important\b/i,
            'function': {
              pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
              lookbehind: true
            },
            'punctuation': /[(){};:,]/
          };
          Prism.languages.css['atrule'].inside.rest = Prism.languages.css;
          var markup = Prism.languages.markup;
          if (markup) {
            markup.tag.addInlined('style', 'css');
            markup.tag.addAttribute('style', 'css');
          }
        }(Prism));
        (function (Prism) {
          var keywords = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/;
          var classNamePrefix = /(^|[^\w.])(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source;
          var className = {
            pattern: RegExp(classNamePrefix + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
            lookbehind: true,
            inside: {
              'namespace': {
                pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
                inside: { 'punctuation': /\./ }
              },
              'punctuation': /\./
            }
          };
          Prism.languages.java = Prism.languages.extend('clike', {
            'class-name': [
              className,
              {
                pattern: RegExp(classNamePrefix + /[A-Z]\w*(?=\s+\w+\s*[;,=()])/.source),
                lookbehind: true,
                inside: className.inside
              }
            ],
            'keyword': keywords,
            'function': [
              Prism.languages.clike.function,
              {
                pattern: /(::\s*)[a-z_]\w*/,
                lookbehind: true
              }
            ],
            'number': /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
            'operator': {
              pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
              lookbehind: true
            }
          });
          Prism.languages.insertBefore('java', 'string', {
            'triple-quoted-string': {
              pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
              greedy: true,
              alias: 'string'
            }
          });
          Prism.languages.insertBefore('java', 'class-name', {
            'annotation': {
              pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
              lookbehind: true,
              alias: 'punctuation'
            },
            'generics': {
              pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
              inside: {
                'class-name': className,
                'keyword': keywords,
                'punctuation': /[<>(),.:]/,
                'operator': /[?&|]/
              }
            },
            'namespace': {
              pattern: RegExp(/(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(/<keyword>/g, function () {
                return keywords.source;
              })),
              lookbehind: true,
              inside: { 'punctuation': /\./ }
            }
          });
        }(Prism));
        Prism.languages.javascript = Prism.languages.extend('clike', {
          'class-name': [
            Prism.languages.clike['class-name'],
            {
              pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:prototype|constructor))/,
              lookbehind: true
            }
          ],
          'keyword': [
            {
              pattern: /((?:^|\})\s*)catch\b/,
              lookbehind: true
            },
            {
              pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
              lookbehind: true
            }
          ],
          'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
          'number': /\b(?:(?:0[xX](?:[\dA-Fa-f](?:_[\dA-Fa-f])?)+|0[bB](?:[01](?:_[01])?)+|0[oO](?:[0-7](?:_[0-7])?)+)n?|(?:\d(?:_\d)?)+n|NaN|Infinity)\b|(?:\b(?:\d(?:_\d)?)+\.?(?:\d(?:_\d)?)*|\B\.(?:\d(?:_\d)?)+)(?:[Ee][+-]?(?:\d(?:_\d)?)+)?/,
          'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
        });
        Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|interface|extends|implements|instanceof|new)\s+)[\w.\\]+/;
        Prism.languages.insertBefore('javascript', 'keyword', {
          'regex': {
            pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/,
            lookbehind: true,
            greedy: true,
            inside: {
              'regex-source': {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: 'language-regex',
                inside: Prism.languages.regex
              },
              'regex-delimiter': /^\/|\/$/,
              'regex-flags': /^[a-z]+$/
            }
          },
          'function-variable': {
            pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
            alias: 'function'
          },
          'parameter': [
            {
              pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
              lookbehind: true,
              inside: Prism.languages.javascript
            },
            {
              pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
              lookbehind: true,
              inside: Prism.languages.javascript
            },
            {
              pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
              lookbehind: true,
              inside: Prism.languages.javascript
            },
            {
              pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
              lookbehind: true,
              inside: Prism.languages.javascript
            }
          ],
          'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
        });
        Prism.languages.insertBefore('javascript', 'string', {
          'hashbang': {
            pattern: /^#!.*/,
            greedy: true,
            alias: 'comment'
          },
          'template-string': {
            pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
            greedy: true,
            inside: {
              'template-punctuation': {
                pattern: /^`|`$/,
                alias: 'string'
              },
              'interpolation': {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                  'interpolation-punctuation': {
                    pattern: /^\$\{|\}$/,
                    alias: 'punctuation'
                  },
                  rest: Prism.languages.javascript
                }
              },
              'string': /[\s\S]+/
            }
          }
        });
        if (Prism.languages.markup) {
          Prism.languages.markup.tag.addInlined('script', 'javascript');
          Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
        }
        Prism.languages.js = Prism.languages.javascript;
        Prism.languages.markup = {
          'comment': {
            pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
            greedy: true
          },
          'prolog': {
            pattern: /<\?[\s\S]+?\?>/,
            greedy: true
          },
          'doctype': {
            pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
            greedy: true,
            inside: {
              'internal-subset': {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null
              },
              'string': {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
              },
              'punctuation': /^<!|>$|[[\]]/,
              'doctype-tag': /^DOCTYPE/i,
              'name': /[^\s<>'"]+/
            }
          },
          'cdata': {
            pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
            greedy: true
          },
          'tag': {
            pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
            greedy: true,
            inside: {
              'tag': {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                  'punctuation': /^<\/?/,
                  'namespace': /^[^\s>\/:]+:/
                }
              },
              'special-attr': [],
              'attr-value': {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                  'punctuation': [
                    {
                      pattern: /^=/,
                      alias: 'attr-equals'
                    },
                    /"|'/
                  ]
                }
              },
              'punctuation': /\/?>/,
              'attr-name': {
                pattern: /[^\s>\/]+/,
                inside: { 'namespace': /^[^\s>\/:]+:/ }
              }
            }
          },
          'entity': [
            {
              pattern: /&[\da-z]{1,8};/i,
              alias: 'named-entity'
            },
            /&#x?[\da-f]{1,8};/i
          ]
        };
        Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] = Prism.languages.markup['entity'];
        Prism.languages.markup['doctype'].inside['internal-subset'].inside = Prism.languages.markup;
        Prism.hooks.add('wrap', function (env) {
          if (env.type === 'entity') {
            env.attributes['title'] = env.content.replace(/&amp;/, '&');
          }
        });
        Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
          value: function addInlined(tagName, lang) {
            var includedCdataInside = {};
            includedCdataInside['language-' + lang] = {
              pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
              lookbehind: true,
              inside: Prism.languages[lang]
            };
            includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;
            var inside = {
              'included-cdata': {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: includedCdataInside
              }
            };
            inside['language-' + lang] = {
              pattern: /[\s\S]+/,
              inside: Prism.languages[lang]
            };
            var def = {};
            def[tagName] = {
              pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function () {
                return tagName;
              }), 'i'),
              lookbehind: true,
              greedy: true,
              inside: inside
            };
            Prism.languages.insertBefore('markup', 'cdata', def);
          }
        });
        Object.defineProperty(Prism.languages.markup.tag, 'addAttribute', {
          value: function (attrName, lang) {
            Prism.languages.markup.tag.inside['special-attr'].push({
              pattern: RegExp(/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, 'i'),
              lookbehind: true,
              inside: {
                'attr-name': /^[^\s=]+/,
                'attr-value': {
                  pattern: /=[\s\S]+/,
                  inside: {
                    'value': {
                      pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                      lookbehind: true,
                      alias: [
                        lang,
                        'language-' + lang
                      ],
                      inside: Prism.languages[lang]
                    },
                    'punctuation': [
                      {
                        pattern: /^=/,
                        alias: 'attr-equals'
                      },
                      /"|'/
                    ]
                  }
                }
              }
            });
          }
        });
        Prism.languages.html = Prism.languages.markup;
        Prism.languages.mathml = Prism.languages.markup;
        Prism.languages.svg = Prism.languages.markup;
        Prism.languages.xml = Prism.languages.extend('markup', {});
        Prism.languages.ssml = Prism.languages.xml;
        Prism.languages.atom = Prism.languages.xml;
        Prism.languages.rss = Prism.languages.xml;
        (function (Prism) {
          var comment = /\/\*[\s\S]*?\*\/|\/\/.*|#(?!\[).*/;
          var constant = [
            {
              pattern: /\b(?:false|true)\b/i,
              alias: 'boolean'
            },
            {
              pattern: /(::\s*)\b[a-z_]\w*\b(?!\s*\()/i,
              greedy: true,
              lookbehind: true
            },
            {
              pattern: /(\b(?:case|const)\s+)\b[a-z_]\w*(?=\s*[;=])/i,
              greedy: true,
              lookbehind: true
            },
            /\b(?:null)\b/i,
            /\b[A-Z_][A-Z0-9_]*\b(?!\s*\()/
          ];
          var number = /\b0b[01]+(?:_[01]+)*\b|\b0o[0-7]+(?:_[0-7]+)*\b|\b0x[\da-f]+(?:_[\da-f]+)*\b|(?:\b\d+(?:_\d+)*\.?(?:\d+(?:_\d+)*)?|\B\.\d+)(?:e[+-]?\d+)?/i;
          var operator = /<?=>|\?\?=?|\.{3}|\??->|[!=]=?=?|::|\*\*=?|--|\+\+|&&|\|\||<<|>>|[?~]|[/^|%*&<>.+-]=?/;
          var punctuation = /[{}\[\](),:;]/;
          Prism.languages.php = {
            'delimiter': {
              pattern: /\?>$|^<\?(?:php(?=\s)|=)?/i,
              alias: 'important'
            },
            'comment': comment,
            'variable': /\$+(?:\w+\b|(?=\{))/i,
            'package': {
              pattern: /(namespace\s+|use\s+(?:function\s+)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
              lookbehind: true,
              inside: { 'punctuation': /\\/ }
            },
            'class-name-definition': {
              pattern: /(\b(?:class|enum|interface|trait)\s+)\b[a-z_]\w*(?!\\)\b/i,
              lookbehind: true,
              alias: 'class-name'
            },
            'function-definition': {
              pattern: /(\bfunction\s+)[a-z_]\w*(?=\s*\()/i,
              lookbehind: true,
              alias: 'function'
            },
            'keyword': [
              {
                pattern: /(\(\s*)\b(?:bool|boolean|int|integer|float|string|object|array)\b(?=\s*\))/i,
                alias: 'type-casting',
                greedy: true,
                lookbehind: true
              },
              {
                pattern: /([(,?]\s*)\b(?:bool|int|float|string|object|array(?!\s*\()|mixed|self|static|callable|iterable|(?:null|false)(?=\s*\|))\b(?=\s*\$)/i,
                alias: 'type-hint',
                greedy: true,
                lookbehind: true
              },
              {
                pattern: /([(,?]\s*[\w|]\|\s*)(?:null|false)\b(?=\s*\$)/i,
                alias: 'type-hint',
                greedy: true,
                lookbehind: true
              },
              {
                pattern: /(\)\s*:\s*(?:\?\s*)?)\b(?:bool|int|float|string|object|void|array(?!\s*\()|mixed|self|static|callable|iterable|(?:null|false)(?=\s*\|))\b/i,
                alias: 'return-type',
                greedy: true,
                lookbehind: true
              },
              {
                pattern: /(\)\s*:\s*(?:\?\s*)?[\w|]\|\s*)(?:null|false)\b/i,
                alias: 'return-type',
                greedy: true,
                lookbehind: true
              },
              {
                pattern: /\b(?:bool|int|float|string|object|void|array(?!\s*\()|mixed|iterable|(?:null|false)(?=\s*\|))\b/i,
                alias: 'type-declaration',
                greedy: true
              },
              {
                pattern: /(\|\s*)(?:null|false)\b/i,
                alias: 'type-declaration',
                greedy: true,
                lookbehind: true
              },
              {
                pattern: /\b(?:parent|self|static)(?=\s*::)/i,
                alias: 'static-context',
                greedy: true
              },
              {
                pattern: /(\byield\s+)from\b/i,
                lookbehind: true
              },
              /\bclass\b/i,
              {
                pattern: /((?:^|[^\s>:]|(?:^|[^-])>|(?:^|[^:]):)\s*)\b(?:__halt_compiler|abstract|and|array|as|break|callable|case|catch|clone|const|continue|declare|default|die|do|echo|else|elseif|empty|enddeclare|endfor|endforeach|endif|endswitch|endwhile|enum|eval|exit|extends|final|finally|fn|for|foreach|function|global|goto|if|implements|include|include_once|instanceof|insteadof|interface|isset|list|namespace|match|new|or|parent|print|private|protected|public|require|require_once|return|self|static|switch|throw|trait|try|unset|use|var|while|xor|yield)\b/i,
                lookbehind: true
              }
            ],
            'argument-name': {
              pattern: /([(,]\s+)\b[a-z_]\w*(?=\s*:(?!:))/i,
              lookbehind: true
            },
            'class-name': [
              {
                pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self|\s+static))\s+|\bcatch\s*\()\b[a-z_]\w*(?!\\)\b/i,
                greedy: true,
                lookbehind: true
              },
              {
                pattern: /(\|\s*)\b[a-z_]\w*(?!\\)\b/i,
                greedy: true,
                lookbehind: true
              },
              {
                pattern: /\b[a-z_]\w*(?!\\)\b(?=\s*\|)/i,
                greedy: true
              },
              {
                pattern: /(\|\s*)(?:\\?\b[a-z_]\w*)+\b/i,
                alias: 'class-name-fully-qualified',
                greedy: true,
                lookbehind: true,
                inside: { 'punctuation': /\\/ }
              },
              {
                pattern: /(?:\\?\b[a-z_]\w*)+\b(?=\s*\|)/i,
                alias: 'class-name-fully-qualified',
                greedy: true,
                inside: { 'punctuation': /\\/ }
              },
              {
                pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self\b|\s+static\b))\s+|\bcatch\s*\()(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
                alias: 'class-name-fully-qualified',
                greedy: true,
                lookbehind: true,
                inside: { 'punctuation': /\\/ }
              },
              {
                pattern: /\b[a-z_]\w*(?=\s*\$)/i,
                alias: 'type-declaration',
                greedy: true
              },
              {
                pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
                alias: [
                  'class-name-fully-qualified',
                  'type-declaration'
                ],
                greedy: true,
                inside: { 'punctuation': /\\/ }
              },
              {
                pattern: /\b[a-z_]\w*(?=\s*::)/i,
                alias: 'static-context',
                greedy: true
              },
              {
                pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*::)/i,
                alias: [
                  'class-name-fully-qualified',
                  'static-context'
                ],
                greedy: true,
                inside: { 'punctuation': /\\/ }
              },
              {
                pattern: /([(,?]\s*)[a-z_]\w*(?=\s*\$)/i,
                alias: 'type-hint',
                greedy: true,
                lookbehind: true
              },
              {
                pattern: /([(,?]\s*)(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
                alias: [
                  'class-name-fully-qualified',
                  'type-hint'
                ],
                greedy: true,
                lookbehind: true,
                inside: { 'punctuation': /\\/ }
              },
              {
                pattern: /(\)\s*:\s*(?:\?\s*)?)\b[a-z_]\w*(?!\\)\b/i,
                alias: 'return-type',
                greedy: true,
                lookbehind: true
              },
              {
                pattern: /(\)\s*:\s*(?:\?\s*)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
                alias: [
                  'class-name-fully-qualified',
                  'return-type'
                ],
                greedy: true,
                lookbehind: true,
                inside: { 'punctuation': /\\/ }
              }
            ],
            'constant': constant,
            'function': {
              pattern: /(^|[^\\\w])\\?[a-z_](?:[\w\\]*\w)?(?=\s*\()/i,
              lookbehind: true,
              inside: { 'punctuation': /\\/ }
            },
            'property': {
              pattern: /(->\s*)\w+/,
              lookbehind: true
            },
            'number': number,
            'operator': operator,
            'punctuation': punctuation
          };
          var string_interpolation = {
            pattern: /\{\$(?:\{(?:\{[^{}]+\}|[^{}]+)\}|[^{}])+\}|(^|[^\\{])\$+(?:\w+(?:\[[^\r\n\[\]]+\]|->\w+)?)/,
            lookbehind: true,
            inside: Prism.languages.php
          };
          var string = [
            {
              pattern: /<<<'([^']+)'[\r\n](?:.*[\r\n])*?\1;/,
              alias: 'nowdoc-string',
              greedy: true,
              inside: {
                'delimiter': {
                  pattern: /^<<<'[^']+'|[a-z_]\w*;$/i,
                  alias: 'symbol',
                  inside: { 'punctuation': /^<<<'?|[';]$/ }
                }
              }
            },
            {
              pattern: /<<<(?:"([^"]+)"[\r\n](?:.*[\r\n])*?\1;|([a-z_]\w*)[\r\n](?:.*[\r\n])*?\2;)/i,
              alias: 'heredoc-string',
              greedy: true,
              inside: {
                'delimiter': {
                  pattern: /^<<<(?:"[^"]+"|[a-z_]\w*)|[a-z_]\w*;$/i,
                  alias: 'symbol',
                  inside: { 'punctuation': /^<<<"?|[";]$/ }
                },
                'interpolation': string_interpolation
              }
            },
            {
              pattern: /`(?:\\[\s\S]|[^\\`])*`/,
              alias: 'backtick-quoted-string',
              greedy: true
            },
            {
              pattern: /'(?:\\[\s\S]|[^\\'])*'/,
              alias: 'single-quoted-string',
              greedy: true
            },
            {
              pattern: /"(?:\\[\s\S]|[^\\"])*"/,
              alias: 'double-quoted-string',
              greedy: true,
              inside: { 'interpolation': string_interpolation }
            }
          ];
          Prism.languages.insertBefore('php', 'variable', {
            'string': string,
            'attribute': {
              pattern: /#\[(?:[^"'\/#]|\/(?![*/])|\/\/.*$|#(?!\[).*$|\/\*(?:[^*]|\*(?!\/))*\*\/|"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*')+\](?=\s*[a-z$#])/im,
              greedy: true,
              inside: {
                'attribute-content': {
                  pattern: /^(#\[)[\s\S]+(?=\]$)/,
                  lookbehind: true,
                  inside: {
                    'comment': comment,
                    'string': string,
                    'attribute-class-name': [
                      {
                        pattern: /([^:]|^)\b[a-z_]\w*(?!\\)\b/i,
                        alias: 'class-name',
                        greedy: true,
                        lookbehind: true
                      },
                      {
                        pattern: /([^:]|^)(?:\\?\b[a-z_]\w*)+/i,
                        alias: [
                          'class-name',
                          'class-name-fully-qualified'
                        ],
                        greedy: true,
                        lookbehind: true,
                        inside: { 'punctuation': /\\/ }
                      }
                    ],
                    'constant': constant,
                    'number': number,
                    'operator': operator,
                    'punctuation': punctuation
                  }
                },
                'delimiter': {
                  pattern: /^#\[|\]$/,
                  alias: 'punctuation'
                }
              }
            }
          });
          Prism.hooks.add('before-tokenize', function (env) {
            if (!/<\?/.test(env.code)) {
              return;
            }
            var phpPattern = /<\?(?:[^"'/#]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|(?:\/\/|#(?!\[))(?:[^?\n\r]|\?(?!>))*(?=$|\?>|[\r\n])|#\[|\/\*(?:[^*]|\*(?!\/))*(?:\*\/|$))*?(?:\?>|$)/gi;
            Prism.languages['markup-templating'].buildPlaceholders(env, 'php', phpPattern);
          });
          Prism.hooks.add('after-tokenize', function (env) {
            Prism.languages['markup-templating'].tokenizePlaceholders(env, 'php');
          });
        }(Prism));
        Prism.languages.python = {
          'comment': {
            pattern: /(^|[^\\])#.*/,
            lookbehind: true
          },
          'string-interpolation': {
            pattern: /(?:f|rf|fr)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
            greedy: true,
            inside: {
              'interpolation': {
                pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
                lookbehind: true,
                inside: {
                  'format-spec': {
                    pattern: /(:)[^:(){}]+(?=\}$)/,
                    lookbehind: true
                  },
                  'conversion-option': {
                    pattern: /![sra](?=[:}]$)/,
                    alias: 'punctuation'
                  },
                  rest: null
                }
              },
              'string': /[\s\S]+/
            }
          },
          'triple-quoted-string': {
            pattern: /(?:[rub]|rb|br)?("""|''')[\s\S]*?\1/i,
            greedy: true,
            alias: 'string'
          },
          'string': {
            pattern: /(?:[rub]|rb|br)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
            greedy: true
          },
          'function': {
            pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
            lookbehind: true
          },
          'class-name': {
            pattern: /(\bclass\s+)\w+/i,
            lookbehind: true
          },
          'decorator': {
            pattern: /(^[\t ]*)@\w+(?:\.\w+)*/im,
            lookbehind: true,
            alias: [
              'annotation',
              'punctuation'
            ],
            inside: { 'punctuation': /\./ }
          },
          'keyword': /\b(?:and|as|assert|async|await|break|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
          'builtin': /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
          'boolean': /\b(?:True|False|None)\b/,
          'number': /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?\b/i,
          'operator': /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
          'punctuation': /[{}[\];(),.:]/
        };
        Prism.languages.python['string-interpolation'].inside['interpolation'].inside.rest = Prism.languages.python;
        Prism.languages.py = Prism.languages.python;
        (function (Prism) {
          Prism.languages.ruby = Prism.languages.extend('clike', {
            'comment': [
              /#.*/,
              {
                pattern: /^=begin\s[\s\S]*?^=end/m,
                greedy: true
              }
            ],
            'class-name': {
              pattern: /(\b(?:class)\s+|\bcatch\s+\()[\w.\\]+/i,
              lookbehind: true,
              inside: { 'punctuation': /[.\\]/ }
            },
            'keyword': /\b(?:alias|and|BEGIN|begin|break|case|class|def|define_method|defined|do|each|else|elsif|END|end|ensure|extend|for|if|in|include|module|new|next|nil|not|or|prepend|protected|private|public|raise|redo|require|rescue|retry|return|self|super|then|throw|undef|unless|until|when|while|yield)\b/
          });
          var interpolation = {
            pattern: /#\{[^}]+\}/,
            inside: {
              'delimiter': {
                pattern: /^#\{|\}$/,
                alias: 'tag'
              },
              rest: Prism.languages.ruby
            }
          };
          delete Prism.languages.ruby.function;
          Prism.languages.insertBefore('ruby', 'keyword', {
            'regex': [
              {
                pattern: RegExp(/%r/.source + '(?:' + [
                  /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
                  /\((?:[^()\\]|\\[\s\S])*\)/.source,
                  /\{(?:[^#{}\\]|#(?:\{[^}]+\})?|\\[\s\S])*\}/.source,
                  /\[(?:[^\[\]\\]|\\[\s\S])*\]/.source,
                  /<(?:[^<>\\]|\\[\s\S])*>/.source
                ].join('|') + ')' + /[egimnosux]{0,6}/.source),
                greedy: true,
                inside: { 'interpolation': interpolation }
              },
              {
                pattern: /(^|[^/])\/(?!\/)(?:\[[^\r\n\]]+\]|\\.|[^[/\\\r\n])+\/[egimnosux]{0,6}(?=\s*(?:$|[\r\n,.;})#]))/,
                lookbehind: true,
                greedy: true,
                inside: { 'interpolation': interpolation }
              }
            ],
            'variable': /[@$]+[a-zA-Z_]\w*(?:[?!]|\b)/,
            'symbol': {
              pattern: /(^|[^:]):[a-zA-Z_]\w*(?:[?!]|\b)/,
              lookbehind: true
            },
            'method-definition': {
              pattern: /(\bdef\s+)[\w.]+/,
              lookbehind: true,
              inside: {
                'function': /\w+$/,
                rest: Prism.languages.ruby
              }
            }
          });
          Prism.languages.insertBefore('ruby', 'number', {
            'builtin': /\b(?:Array|Bignum|Binding|Class|Continuation|Dir|Exception|FalseClass|File|Stat|Fixnum|Float|Hash|Integer|IO|MatchData|Method|Module|NilClass|Numeric|Object|Proc|Range|Regexp|String|Struct|TMS|Symbol|ThreadGroup|Thread|Time|TrueClass)\b/,
            'constant': /\b[A-Z]\w*(?:[?!]|\b)/
          });
          Prism.languages.ruby.string = [
            {
              pattern: RegExp(/%[qQiIwWxs]?/.source + '(?:' + [
                /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
                /\((?:[^()\\]|\\[\s\S])*\)/.source,
                /\{(?:[^#{}\\]|#(?:\{[^}]+\})?|\\[\s\S])*\}/.source,
                /\[(?:[^\[\]\\]|\\[\s\S])*\]/.source,
                /<(?:[^<>\\]|\\[\s\S])*>/.source
              ].join('|') + ')'),
              greedy: true,
              inside: { 'interpolation': interpolation }
            },
            {
              pattern: /("|')(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|(?!\1)[^\\#\r\n])*\1/,
              greedy: true,
              inside: { 'interpolation': interpolation }
            },
            {
              pattern: /<<[-~]?([a-z_]\w*)[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
              alias: 'heredoc-string',
              greedy: true,
              inside: {
                'delimiter': {
                  pattern: /^<<[-~]?[a-z_]\w*|[a-z_]\w*$/i,
                  alias: 'symbol',
                  inside: { 'punctuation': /^<<[-~]?/ }
                },
                'interpolation': interpolation
              }
            },
            {
              pattern: /<<[-~]?'([a-z_]\w*)'[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
              alias: 'heredoc-string',
              greedy: true,
              inside: {
                'delimiter': {
                  pattern: /^<<[-~]?'[a-z_]\w*'|[a-z_]\w*$/i,
                  alias: 'symbol',
                  inside: { 'punctuation': /^<<[-~]?'|'$/ }
                }
              }
            }
          ];
          Prism.languages.rb = Prism.languages.ruby;
        }(Prism));
        var Prism$1 = prismCore.exports;
        var prismjs = { boltExport: Prism$1 };
        return prismjs;
      }));
      var prism = window.Prism;
      window.Prism = oldprism;
      return prism;
    }(undefined, exports$1, module));
    var Prism$1 = module.exports.boltExport;

    var getLanguages$1 = function (editor) {
      return editor.getParam('codesample_languages');
    };
    var useGlobalPrismJS = function (editor) {
      return editor.getParam('codesample_global_prismjs', false, 'boolean');
    };

    var get = function (editor) {
      return Global.Prism && useGlobalPrismJS(editor) ? Global.Prism : Prism$1;
    };

    var getSelectedCodeSample = function (editor) {
      var node = editor.selection ? editor.selection.getNode() : null;
      return someIf(isCodeSample(node), node);
    };
    var insertCodeSample = function (editor, language, code) {
      editor.undoManager.transact(function () {
        var node = getSelectedCodeSample(editor);
        code = global$1.DOM.encode(code);
        return node.fold(function () {
          editor.insertContent('<pre id="__new" class="language-' + language + '">' + code + '</pre>');
          editor.selection.select(editor.$('#__new').removeAttr('id')[0]);
        }, function (n) {
          editor.dom.setAttrib(n, 'class', 'language-' + language);
          n.innerHTML = code;
          get(editor).highlightElement(n);
          editor.selection.select(n);
        });
      });
    };
    var getCurrentCode = function (editor) {
      var node = getSelectedCodeSample(editor);
      return node.fold(constant(''), function (n) {
        return n.textContent;
      });
    };

    var getLanguages = function (editor) {
      var defaultLanguages = [
        {
          text: 'HTML/XML',
          value: 'markup'
        },
        {
          text: 'JavaScript',
          value: 'javascript'
        },
        {
          text: 'CSS',
          value: 'css'
        },
        {
          text: 'PHP',
          value: 'php'
        },
        {
          text: 'Ruby',
          value: 'ruby'
        },
        {
          text: 'Python',
          value: 'python'
        },
        {
          text: 'Java',
          value: 'java'
        },
        {
          text: 'C',
          value: 'c'
        },
        {
          text: 'C#',
          value: 'csharp'
        },
        {
          text: 'C++',
          value: 'cpp'
        }
      ];
      var customLanguages = getLanguages$1(editor);
      return customLanguages ? customLanguages : defaultLanguages;
    };
    var getCurrentLanguage = function (editor, fallback) {
      var node = getSelectedCodeSample(editor);
      return node.fold(function () {
        return fallback;
      }, function (n) {
        var matches = n.className.match(/language-(\w+)/);
        return matches ? matches[1] : fallback;
      });
    };

    var open = function (editor) {
      var languages = getLanguages(editor);
      var defaultLanguage = head(languages).fold(constant(''), function (l) {
        return l.value;
      });
      var currentLanguage = getCurrentLanguage(editor, defaultLanguage);
      var currentCode = getCurrentCode(editor);
      editor.windowManager.open({
        title: 'Insert/Edit Code Sample',
        size: 'large',
        body: {
          type: 'panel',
          items: [
            {
              type: 'selectbox',
              name: 'language',
              label: 'Language',
              items: languages
            },
            {
              type: 'textarea',
              name: 'code',
              label: 'Code view'
            }
          ]
        },
        buttons: [
          {
            type: 'cancel',
            name: 'cancel',
            text: 'Cancel'
          },
          {
            type: 'submit',
            name: 'save',
            text: 'Save',
            primary: true
          }
        ],
        initialData: {
          language: currentLanguage,
          code: currentCode
        },
        onSubmit: function (api) {
          var data = api.getData();
          insertCodeSample(editor, data.language, data.code);
          api.close();
        }
      });
    };

    var register$1 = function (editor) {
      editor.addCommand('codesample', function () {
        var node = editor.selection.getNode();
        if (editor.selection.isCollapsed() || isCodeSample(node)) {
          open(editor);
        } else {
          editor.formatter.toggle('code');
        }
      });
    };

    var setup = function (editor) {
      var $ = editor.$;
      editor.on('PreProcess', function (e) {
        $('pre[contenteditable=false]', e.node).filter(trimArg(isCodeSample)).each(function (idx, elm) {
          var $elm = $(elm), code = elm.textContent;
          $elm.attr('class', $.trim($elm.attr('class')));
          $elm.removeAttr('contentEditable');
          $elm.empty().append($('<code></code>').each(function () {
            this.textContent = code;
          }));
        });
      });
      editor.on('SetContent', function () {
        var unprocessedCodeSamples = $('pre').filter(trimArg(isCodeSample)).filter(function (idx, elm) {
          return elm.contentEditable !== 'false';
        });
        if (unprocessedCodeSamples.length) {
          editor.undoManager.transact(function () {
            unprocessedCodeSamples.each(function (idx, elm) {
              $(elm).find('br').each(function (idx, elm) {
                elm.parentNode.replaceChild(editor.getDoc().createTextNode('\n'), elm);
              });
              elm.contentEditable = 'false';
              elm.innerHTML = editor.dom.encode(elm.textContent);
              get(editor).highlightElement(elm);
              elm.className = $.trim(elm.className);
            });
          });
        }
      });
    };

    var isCodeSampleSelection = function (editor) {
      var node = editor.selection.getStart();
      return editor.dom.is(node, 'pre[class*="language-"]');
    };
    var register = function (editor) {
      var onAction = function () {
        return editor.execCommand('codesample');
      };
      editor.ui.registry.addToggleButton('codesample', {
        icon: 'code-sample',
        tooltip: 'Insert/edit code sample',
        onAction: onAction,
        onSetup: function (api) {
          var nodeChangeHandler = function () {
            api.setActive(isCodeSampleSelection(editor));
          };
          editor.on('NodeChange', nodeChangeHandler);
          return function () {
            return editor.off('NodeChange', nodeChangeHandler);
          };
        }
      });
      editor.ui.registry.addMenuItem('codesample', {
        text: 'Code sample...',
        icon: 'code-sample',
        onAction: onAction
      });
    };

    function Plugin () {
      global$2.add('codesample', function (editor) {
        setup(editor);
        register(editor);
        register$1(editor);
        editor.on('dblclick', function (ev) {
          if (isCodeSample(ev.target)) {
            open(editor);
          }
        });
      });
    }

    Plugin();

}());


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "colorpicker" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/colorpicker')
//   ES2015:
//     import 'tinymce/plugins/colorpicker'
__webpack_require__(1485);

/***/ }),
/* 1485 */
/***/ (function(module, exports) {

/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 *
 * Version: 5.10.5 (2022-05-25)
 */
(function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    function Plugin () {
      global.add('colorpicker', function () {
      });
    }

    Plugin();

}());


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "contextmenu" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/contextmenu')
//   ES2015:
//     import 'tinymce/plugins/contextmenu'
__webpack_require__(1487);

/***/ }),
/* 1487 */
/***/ (function(module, exports) {

/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 *
 * Version: 5.10.5 (2022-05-25)
 */
(function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    function Plugin () {
      global.add('contextmenu', function () {
      });
    }

    Plugin();

}());


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "fullscreen" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/fullscreen')
//   ES2015:
//     import 'tinymce/plugins/fullscreen'
__webpack_require__(1489);

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 *
 * Version: 5.10.5 (2022-05-25)
 */
(function () {
    'use strict';

    var Cell = function (initial) {
      var value = initial;
      var get = function () {
        return value;
      };
      var set = function (v) {
        value = v;
      };
      return {
        get: get,
        set: set
      };
    };

    var global$3 = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var get$5 = function (fullscreenState) {
      return {
        isFullscreen: function () {
          return fullscreenState.get() !== null;
        }
      };
    };

    var typeOf = function (x) {
      var t = typeof x;
      if (x === null) {
        return 'null';
      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
        return 'array';
      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
        return 'string';
      } else {
        return t;
      }
    };
    var isType$1 = function (type) {
      return function (value) {
        return typeOf(value) === type;
      };
    };
    var isSimpleType = function (type) {
      return function (value) {
        return typeof value === type;
      };
    };
    var isString = isType$1('string');
    var isArray = isType$1('array');
    var isBoolean = isSimpleType('boolean');
    var isNullable = function (a) {
      return a === null || a === undefined;
    };
    var isNonNullable = function (a) {
      return !isNullable(a);
    };
    var isFunction = isSimpleType('function');
    var isNumber = isSimpleType('number');

    var noop = function () {
    };
    var compose = function (fa, fb) {
      return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        return fa(fb.apply(null, args));
      };
    };
    var compose1 = function (fbc, fab) {
      return function (a) {
        return fbc(fab(a));
      };
    };
    var constant = function (value) {
      return function () {
        return value;
      };
    };
    var identity = function (x) {
      return x;
    };
    function curry(fn) {
      var initialArgs = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        initialArgs[_i - 1] = arguments[_i];
      }
      return function () {
        var restArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          restArgs[_i] = arguments[_i];
        }
        var all = initialArgs.concat(restArgs);
        return fn.apply(null, all);
      };
    }
    var never = constant(false);
    var always = constant(true);

    var none = function () {
      return NONE;
    };
    var NONE = function () {
      var call = function (thunk) {
        return thunk();
      };
      var id = identity;
      var me = {
        fold: function (n, _s) {
          return n();
        },
        isSome: never,
        isNone: always,
        getOr: id,
        getOrThunk: call,
        getOrDie: function (msg) {
          throw new Error(msg || 'error: getOrDie called on none.');
        },
        getOrNull: constant(null),
        getOrUndefined: constant(undefined),
        or: id,
        orThunk: call,
        map: none,
        each: noop,
        bind: none,
        exists: never,
        forall: always,
        filter: function () {
          return none();
        },
        toArray: function () {
          return [];
        },
        toString: constant('none()')
      };
      return me;
    }();
    var some = function (a) {
      var constant_a = constant(a);
      var self = function () {
        return me;
      };
      var bind = function (f) {
        return f(a);
      };
      var me = {
        fold: function (n, s) {
          return s(a);
        },
        isSome: always,
        isNone: never,
        getOr: constant_a,
        getOrThunk: constant_a,
        getOrDie: constant_a,
        getOrNull: constant_a,
        getOrUndefined: constant_a,
        or: self,
        orThunk: self,
        map: function (f) {
          return some(f(a));
        },
        each: function (f) {
          f(a);
        },
        bind: bind,
        exists: bind,
        forall: bind,
        filter: function (f) {
          return f(a) ? me : NONE;
        },
        toArray: function () {
          return [a];
        },
        toString: function () {
          return 'some(' + a + ')';
        }
      };
      return me;
    };
    var from = function (value) {
      return value === null || value === undefined ? NONE : some(value);
    };
    var Optional = {
      some: some,
      none: none,
      from: from
    };

    var __assign = function () {
      __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };

    var singleton = function (doRevoke) {
      var subject = Cell(Optional.none());
      var revoke = function () {
        return subject.get().each(doRevoke);
      };
      var clear = function () {
        revoke();
        subject.set(Optional.none());
      };
      var isSet = function () {
        return subject.get().isSome();
      };
      var get = function () {
        return subject.get();
      };
      var set = function (s) {
        revoke();
        subject.set(Optional.some(s));
      };
      return {
        clear: clear,
        isSet: isSet,
        get: get,
        set: set
      };
    };
    var unbindable = function () {
      return singleton(function (s) {
        return s.unbind();
      });
    };
    var value = function () {
      var subject = singleton(noop);
      var on = function (f) {
        return subject.get().each(f);
      };
      return __assign(__assign({}, subject), { on: on });
    };

    var nativePush = Array.prototype.push;
    var map = function (xs, f) {
      var len = xs.length;
      var r = new Array(len);
      for (var i = 0; i < len; i++) {
        var x = xs[i];
        r[i] = f(x, i);
      }
      return r;
    };
    var each$1 = function (xs, f) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        f(x, i);
      }
    };
    var filter$1 = function (xs, pred) {
      var r = [];
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i)) {
          r.push(x);
        }
      }
      return r;
    };
    var findUntil = function (xs, pred, until) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i)) {
          return Optional.some(x);
        } else if (until(x, i)) {
          break;
        }
      }
      return Optional.none();
    };
    var find$1 = function (xs, pred) {
      return findUntil(xs, pred, never);
    };
    var flatten = function (xs) {
      var r = [];
      for (var i = 0, len = xs.length; i < len; ++i) {
        if (!isArray(xs[i])) {
          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
        }
        nativePush.apply(r, xs[i]);
      }
      return r;
    };
    var bind$3 = function (xs, f) {
      return flatten(map(xs, f));
    };
    var get$4 = function (xs, i) {
      return i >= 0 && i < xs.length ? Optional.some(xs[i]) : Optional.none();
    };
    var head = function (xs) {
      return get$4(xs, 0);
    };
    var findMap = function (arr, f) {
      for (var i = 0; i < arr.length; i++) {
        var r = f(arr[i], i);
        if (r.isSome()) {
          return r;
        }
      }
      return Optional.none();
    };

    var keys = Object.keys;
    var each = function (obj, f) {
      var props = keys(obj);
      for (var k = 0, len = props.length; k < len; k++) {
        var i = props[k];
        var x = obj[i];
        f(x, i);
      }
    };

    var contains = function (str, substr) {
      return str.indexOf(substr) !== -1;
    };

    var isSupported$1 = function (dom) {
      return dom.style !== undefined && isFunction(dom.style.getPropertyValue);
    };

    var fromHtml = function (html, scope) {
      var doc = scope || document;
      var div = doc.createElement('div');
      div.innerHTML = html;
      if (!div.hasChildNodes() || div.childNodes.length > 1) {
        console.error('HTML does not have a single root node', html);
        throw new Error('HTML must have a single root node');
      }
      return fromDom(div.childNodes[0]);
    };
    var fromTag = function (tag, scope) {
      var doc = scope || document;
      var node = doc.createElement(tag);
      return fromDom(node);
    };
    var fromText = function (text, scope) {
      var doc = scope || document;
      var node = doc.createTextNode(text);
      return fromDom(node);
    };
    var fromDom = function (node) {
      if (node === null || node === undefined) {
        throw new Error('Node cannot be null or undefined');
      }
      return { dom: node };
    };
    var fromPoint = function (docElm, x, y) {
      return Optional.from(docElm.dom.elementFromPoint(x, y)).map(fromDom);
    };
    var SugarElement = {
      fromHtml: fromHtml,
      fromTag: fromTag,
      fromText: fromText,
      fromDom: fromDom,
      fromPoint: fromPoint
    };

    typeof window !== 'undefined' ? window : Function('return this;')();

    var DOCUMENT = 9;
    var DOCUMENT_FRAGMENT = 11;
    var ELEMENT = 1;
    var TEXT = 3;

    var type = function (element) {
      return element.dom.nodeType;
    };
    var isType = function (t) {
      return function (element) {
        return type(element) === t;
      };
    };
    var isElement = isType(ELEMENT);
    var isText = isType(TEXT);
    var isDocument = isType(DOCUMENT);
    var isDocumentFragment = isType(DOCUMENT_FRAGMENT);

    var cached = function (f) {
      var called = false;
      var r;
      return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        if (!called) {
          called = true;
          r = f.apply(null, args);
        }
        return r;
      };
    };

    var DeviceType = function (os, browser, userAgent, mediaMatch) {
      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
      var isiPhone = os.isiOS() && !isiPad;
      var isMobile = os.isiOS() || os.isAndroid();
      var isTouch = isMobile || mediaMatch('(pointer:coarse)');
      var isTablet = isiPad || !isiPhone && isMobile && mediaMatch('(min-device-width:768px)');
      var isPhone = isiPhone || isMobile && !isTablet;
      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
      var isDesktop = !isPhone && !isTablet && !iOSwebview;
      return {
        isiPad: constant(isiPad),
        isiPhone: constant(isiPhone),
        isTablet: constant(isTablet),
        isPhone: constant(isPhone),
        isTouch: constant(isTouch),
        isAndroid: os.isAndroid,
        isiOS: os.isiOS,
        isWebView: constant(iOSwebview),
        isDesktop: constant(isDesktop)
      };
    };

    var firstMatch = function (regexes, s) {
      for (var i = 0; i < regexes.length; i++) {
        var x = regexes[i];
        if (x.test(s)) {
          return x;
        }
      }
      return undefined;
    };
    var find = function (regexes, agent) {
      var r = firstMatch(regexes, agent);
      if (!r) {
        return {
          major: 0,
          minor: 0
        };
      }
      var group = function (i) {
        return Number(agent.replace(r, '$' + i));
      };
      return nu$2(group(1), group(2));
    };
    var detect$3 = function (versionRegexes, agent) {
      var cleanedAgent = String(agent).toLowerCase();
      if (versionRegexes.length === 0) {
        return unknown$2();
      }
      return find(versionRegexes, cleanedAgent);
    };
    var unknown$2 = function () {
      return nu$2(0, 0);
    };
    var nu$2 = function (major, minor) {
      return {
        major: major,
        minor: minor
      };
    };
    var Version = {
      nu: nu$2,
      detect: detect$3,
      unknown: unknown$2
    };

    var detectBrowser$1 = function (browsers, userAgentData) {
      return findMap(userAgentData.brands, function (uaBrand) {
        var lcBrand = uaBrand.brand.toLowerCase();
        return find$1(browsers, function (browser) {
          var _a;
          return lcBrand === ((_a = browser.brand) === null || _a === void 0 ? void 0 : _a.toLowerCase());
        }).map(function (info) {
          return {
            current: info.name,
            version: Version.nu(parseInt(uaBrand.version, 10), 0)
          };
        });
      });
    };

    var detect$2 = function (candidates, userAgent) {
      var agent = String(userAgent).toLowerCase();
      return find$1(candidates, function (candidate) {
        return candidate.search(agent);
      });
    };
    var detectBrowser = function (browsers, userAgent) {
      return detect$2(browsers, userAgent).map(function (browser) {
        var version = Version.detect(browser.versionRegexes, userAgent);
        return {
          current: browser.name,
          version: version
        };
      });
    };
    var detectOs = function (oses, userAgent) {
      return detect$2(oses, userAgent).map(function (os) {
        var version = Version.detect(os.versionRegexes, userAgent);
        return {
          current: os.name,
          version: version
        };
      });
    };

    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
    var checkContains = function (target) {
      return function (uastring) {
        return contains(uastring, target);
      };
    };
    var browsers = [
      {
        name: 'Edge',
        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
        search: function (uastring) {
          return contains(uastring, 'edge/') && contains(uastring, 'chrome') && contains(uastring, 'safari') && contains(uastring, 'applewebkit');
        }
      },
      {
        name: 'Chrome',
        brand: 'Chromium',
        versionRegexes: [
          /.*?chrome\/([0-9]+)\.([0-9]+).*/,
          normalVersionRegex
        ],
        search: function (uastring) {
          return contains(uastring, 'chrome') && !contains(uastring, 'chromeframe');
        }
      },
      {
        name: 'IE',
        versionRegexes: [
          /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
          /.*?rv:([0-9]+)\.([0-9]+).*/
        ],
        search: function (uastring) {
          return contains(uastring, 'msie') || contains(uastring, 'trident');
        }
      },
      {
        name: 'Opera',
        versionRegexes: [
          normalVersionRegex,
          /.*?opera\/([0-9]+)\.([0-9]+).*/
        ],
        search: checkContains('opera')
      },
      {
        name: 'Firefox',
        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
        search: checkContains('firefox')
      },
      {
        name: 'Safari',
        versionRegexes: [
          normalVersionRegex,
          /.*?cpu os ([0-9]+)_([0-9]+).*/
        ],
        search: function (uastring) {
          return (contains(uastring, 'safari') || contains(uastring, 'mobile/')) && contains(uastring, 'applewebkit');
        }
      }
    ];
    var oses = [
      {
        name: 'Windows',
        search: checkContains('win'),
        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
      },
      {
        name: 'iOS',
        search: function (uastring) {
          return contains(uastring, 'iphone') || contains(uastring, 'ipad');
        },
        versionRegexes: [
          /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
          /.*cpu os ([0-9]+)_([0-9]+).*/,
          /.*cpu iphone os ([0-9]+)_([0-9]+).*/
        ]
      },
      {
        name: 'Android',
        search: checkContains('android'),
        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
      },
      {
        name: 'OSX',
        search: checkContains('mac os x'),
        versionRegexes: [/.*?mac\ os\ x\ ?([0-9]+)_([0-9]+).*/]
      },
      {
        name: 'Linux',
        search: checkContains('linux'),
        versionRegexes: []
      },
      {
        name: 'Solaris',
        search: checkContains('sunos'),
        versionRegexes: []
      },
      {
        name: 'FreeBSD',
        search: checkContains('freebsd'),
        versionRegexes: []
      },
      {
        name: 'ChromeOS',
        search: checkContains('cros'),
        versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/]
      }
    ];
    var PlatformInfo = {
      browsers: constant(browsers),
      oses: constant(oses)
    };

    var edge = 'Edge';
    var chrome = 'Chrome';
    var ie = 'IE';
    var opera = 'Opera';
    var firefox = 'Firefox';
    var safari = 'Safari';
    var unknown$1 = function () {
      return nu$1({
        current: undefined,
        version: Version.unknown()
      });
    };
    var nu$1 = function (info) {
      var current = info.current;
      var version = info.version;
      var isBrowser = function (name) {
        return function () {
          return current === name;
        };
      };
      return {
        current: current,
        version: version,
        isEdge: isBrowser(edge),
        isChrome: isBrowser(chrome),
        isIE: isBrowser(ie),
        isOpera: isBrowser(opera),
        isFirefox: isBrowser(firefox),
        isSafari: isBrowser(safari)
      };
    };
    var Browser = {
      unknown: unknown$1,
      nu: nu$1,
      edge: constant(edge),
      chrome: constant(chrome),
      ie: constant(ie),
      opera: constant(opera),
      firefox: constant(firefox),
      safari: constant(safari)
    };

    var windows = 'Windows';
    var ios = 'iOS';
    var android = 'Android';
    var linux = 'Linux';
    var osx = 'OSX';
    var solaris = 'Solaris';
    var freebsd = 'FreeBSD';
    var chromeos = 'ChromeOS';
    var unknown = function () {
      return nu({
        current: undefined,
        version: Version.unknown()
      });
    };
    var nu = function (info) {
      var current = info.current;
      var version = info.version;
      var isOS = function (name) {
        return function () {
          return current === name;
        };
      };
      return {
        current: current,
        version: version,
        isWindows: isOS(windows),
        isiOS: isOS(ios),
        isAndroid: isOS(android),
        isOSX: isOS(osx),
        isLinux: isOS(linux),
        isSolaris: isOS(solaris),
        isFreeBSD: isOS(freebsd),
        isChromeOS: isOS(chromeos)
      };
    };
    var OperatingSystem = {
      unknown: unknown,
      nu: nu,
      windows: constant(windows),
      ios: constant(ios),
      android: constant(android),
      linux: constant(linux),
      osx: constant(osx),
      solaris: constant(solaris),
      freebsd: constant(freebsd),
      chromeos: constant(chromeos)
    };

    var detect$1 = function (userAgent, userAgentDataOpt, mediaMatch) {
      var browsers = PlatformInfo.browsers();
      var oses = PlatformInfo.oses();
      var browser = userAgentDataOpt.bind(function (userAgentData) {
        return detectBrowser$1(browsers, userAgentData);
      }).orThunk(function () {
        return detectBrowser(browsers, userAgent);
      }).fold(Browser.unknown, Browser.nu);
      var os = detectOs(oses, userAgent).fold(OperatingSystem.unknown, OperatingSystem.nu);
      var deviceType = DeviceType(os, browser, userAgent, mediaMatch);
      return {
        browser: browser,
        os: os,
        deviceType: deviceType
      };
    };
    var PlatformDetection = { detect: detect$1 };

    var mediaMatch = function (query) {
      return window.matchMedia(query).matches;
    };
    var platform = cached(function () {
      return PlatformDetection.detect(navigator.userAgent, Optional.from(navigator.userAgentData), mediaMatch);
    });
    var detect = function () {
      return platform();
    };

    var is = function (element, selector) {
      var dom = element.dom;
      if (dom.nodeType !== ELEMENT) {
        return false;
      } else {
        var elem = dom;
        if (elem.matches !== undefined) {
          return elem.matches(selector);
        } else if (elem.msMatchesSelector !== undefined) {
          return elem.msMatchesSelector(selector);
        } else if (elem.webkitMatchesSelector !== undefined) {
          return elem.webkitMatchesSelector(selector);
        } else if (elem.mozMatchesSelector !== undefined) {
          return elem.mozMatchesSelector(selector);
        } else {
          throw new Error('Browser lacks native selectors');
        }
      }
    };
    var bypassSelector = function (dom) {
      return dom.nodeType !== ELEMENT && dom.nodeType !== DOCUMENT && dom.nodeType !== DOCUMENT_FRAGMENT || dom.childElementCount === 0;
    };
    var all$1 = function (selector, scope) {
      var base = scope === undefined ? document : scope.dom;
      return bypassSelector(base) ? [] : map(base.querySelectorAll(selector), SugarElement.fromDom);
    };

    var eq = function (e1, e2) {
      return e1.dom === e2.dom;
    };

    var owner = function (element) {
      return SugarElement.fromDom(element.dom.ownerDocument);
    };
    var documentOrOwner = function (dos) {
      return isDocument(dos) ? dos : owner(dos);
    };
    var parent = function (element) {
      return Optional.from(element.dom.parentNode).map(SugarElement.fromDom);
    };
    var parents = function (element, isRoot) {
      var stop = isFunction(isRoot) ? isRoot : never;
      var dom = element.dom;
      var ret = [];
      while (dom.parentNode !== null && dom.parentNode !== undefined) {
        var rawParent = dom.parentNode;
        var p = SugarElement.fromDom(rawParent);
        ret.push(p);
        if (stop(p) === true) {
          break;
        } else {
          dom = rawParent;
        }
      }
      return ret;
    };
    var siblings$2 = function (element) {
      var filterSelf = function (elements) {
        return filter$1(elements, function (x) {
          return !eq(element, x);
        });
      };
      return parent(element).map(children).map(filterSelf).getOr([]);
    };
    var children = function (element) {
      return map(element.dom.childNodes, SugarElement.fromDom);
    };

    var isShadowRoot = function (dos) {
      return isDocumentFragment(dos) && isNonNullable(dos.dom.host);
    };
    var supported = isFunction(Element.prototype.attachShadow) && isFunction(Node.prototype.getRootNode);
    var isSupported = constant(supported);
    var getRootNode = supported ? function (e) {
      return SugarElement.fromDom(e.dom.getRootNode());
    } : documentOrOwner;
    var getShadowRoot = function (e) {
      var r = getRootNode(e);
      return isShadowRoot(r) ? Optional.some(r) : Optional.none();
    };
    var getShadowHost = function (e) {
      return SugarElement.fromDom(e.dom.host);
    };
    var getOriginalEventTarget = function (event) {
      if (isSupported() && isNonNullable(event.target)) {
        var el = SugarElement.fromDom(event.target);
        if (isElement(el) && isOpenShadowHost(el)) {
          if (event.composed && event.composedPath) {
            var composedPath = event.composedPath();
            if (composedPath) {
              return head(composedPath);
            }
          }
        }
      }
      return Optional.from(event.target);
    };
    var isOpenShadowHost = function (element) {
      return isNonNullable(element.dom.shadowRoot);
    };

    var inBody = function (element) {
      var dom = isText(element) ? element.dom.parentNode : element.dom;
      if (dom === undefined || dom === null || dom.ownerDocument === null) {
        return false;
      }
      var doc = dom.ownerDocument;
      return getShadowRoot(SugarElement.fromDom(dom)).fold(function () {
        return doc.body.contains(dom);
      }, compose1(inBody, getShadowHost));
    };
    var getBody = function (doc) {
      var b = doc.dom.body;
      if (b === null || b === undefined) {
        throw new Error('Body is not available yet');
      }
      return SugarElement.fromDom(b);
    };

    var rawSet = function (dom, key, value) {
      if (isString(value) || isBoolean(value) || isNumber(value)) {
        dom.setAttribute(key, value + '');
      } else {
        console.error('Invalid call to Attribute.set. Key ', key, ':: Value ', value, ':: Element ', dom);
        throw new Error('Attribute value was not simple');
      }
    };
    var set = function (element, key, value) {
      rawSet(element.dom, key, value);
    };
    var get$3 = function (element, key) {
      var v = element.dom.getAttribute(key);
      return v === null ? undefined : v;
    };
    var remove = function (element, key) {
      element.dom.removeAttribute(key);
    };

    var internalSet = function (dom, property, value) {
      if (!isString(value)) {
        console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
        throw new Error('CSS value must be a string: ' + value);
      }
      if (isSupported$1(dom)) {
        dom.style.setProperty(property, value);
      }
    };
    var setAll = function (element, css) {
      var dom = element.dom;
      each(css, function (v, k) {
        internalSet(dom, k, v);
      });
    };
    var get$2 = function (element, property) {
      var dom = element.dom;
      var styles = window.getComputedStyle(dom);
      var r = styles.getPropertyValue(property);
      return r === '' && !inBody(element) ? getUnsafeProperty(dom, property) : r;
    };
    var getUnsafeProperty = function (dom, property) {
      return isSupported$1(dom) ? dom.style.getPropertyValue(property) : '';
    };

    var mkEvent = function (target, x, y, stop, prevent, kill, raw) {
      return {
        target: target,
        x: x,
        y: y,
        stop: stop,
        prevent: prevent,
        kill: kill,
        raw: raw
      };
    };
    var fromRawEvent = function (rawEvent) {
      var target = SugarElement.fromDom(getOriginalEventTarget(rawEvent).getOr(rawEvent.target));
      var stop = function () {
        return rawEvent.stopPropagation();
      };
      var prevent = function () {
        return rawEvent.preventDefault();
      };
      var kill = compose(prevent, stop);
      return mkEvent(target, rawEvent.clientX, rawEvent.clientY, stop, prevent, kill, rawEvent);
    };
    var handle = function (filter, handler) {
      return function (rawEvent) {
        if (filter(rawEvent)) {
          handler(fromRawEvent(rawEvent));
        }
      };
    };
    var binder = function (element, event, filter, handler, useCapture) {
      var wrapped = handle(filter, handler);
      element.dom.addEventListener(event, wrapped, useCapture);
      return { unbind: curry(unbind, element, event, wrapped, useCapture) };
    };
    var bind$2 = function (element, event, filter, handler) {
      return binder(element, event, filter, handler, false);
    };
    var unbind = function (element, event, handler, useCapture) {
      element.dom.removeEventListener(event, handler, useCapture);
    };

    var filter = always;
    var bind$1 = function (element, event, handler) {
      return bind$2(element, event, filter, handler);
    };

    var r = function (left, top) {
      var translate = function (x, y) {
        return r(left + x, top + y);
      };
      return {
        left: left,
        top: top,
        translate: translate
      };
    };
    var SugarPosition = r;

    var get$1 = function (_DOC) {
      var doc = _DOC !== undefined ? _DOC.dom : document;
      var x = doc.body.scrollLeft || doc.documentElement.scrollLeft;
      var y = doc.body.scrollTop || doc.documentElement.scrollTop;
      return SugarPosition(x, y);
    };

    var get = function (_win) {
      var win = _win === undefined ? window : _win;
      if (detect().browser.isFirefox()) {
        return Optional.none();
      } else {
        return Optional.from(win['visualViewport']);
      }
    };
    var bounds = function (x, y, width, height) {
      return {
        x: x,
        y: y,
        width: width,
        height: height,
        right: x + width,
        bottom: y + height
      };
    };
    var getBounds = function (_win) {
      var win = _win === undefined ? window : _win;
      var doc = win.document;
      var scroll = get$1(SugarElement.fromDom(doc));
      return get(win).fold(function () {
        var html = win.document.documentElement;
        var width = html.clientWidth;
        var height = html.clientHeight;
        return bounds(scroll.left, scroll.top, width, height);
      }, function (visualViewport) {
        return bounds(Math.max(visualViewport.pageLeft, scroll.left), Math.max(visualViewport.pageTop, scroll.top), visualViewport.width, visualViewport.height);
      });
    };
    var bind = function (name, callback, _win) {
      return get(_win).map(function (visualViewport) {
        var handler = function (e) {
          return callback(fromRawEvent(e));
        };
        visualViewport.addEventListener(name, handler);
        return {
          unbind: function () {
            return visualViewport.removeEventListener(name, handler);
          }
        };
      }).getOrThunk(function () {
        return { unbind: noop };
      });
    };

    var global$2 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var global$1 = tinymce.util.Tools.resolve('tinymce.Env');

    var global = tinymce.util.Tools.resolve('tinymce.util.Delay');

    var fireFullscreenStateChanged = function (editor, state) {
      editor.fire('FullscreenStateChanged', { state: state });
    };

    var getFullscreenNative = function (editor) {
      return editor.getParam('fullscreen_native', false, 'boolean');
    };

    var getFullscreenRoot = function (editor) {
      var elem = SugarElement.fromDom(editor.getElement());
      return getShadowRoot(elem).map(getShadowHost).getOrThunk(function () {
        return getBody(owner(elem));
      });
    };
    var getFullscreenElement = function (root) {
      if (root.fullscreenElement !== undefined) {
        return root.fullscreenElement;
      } else if (root.msFullscreenElement !== undefined) {
        return root.msFullscreenElement;
      } else if (root.webkitFullscreenElement !== undefined) {
        return root.webkitFullscreenElement;
      } else {
        return null;
      }
    };
    var getFullscreenchangeEventName = function () {
      if (document.fullscreenElement !== undefined) {
        return 'fullscreenchange';
      } else if (document.msFullscreenElement !== undefined) {
        return 'MSFullscreenChange';
      } else if (document.webkitFullscreenElement !== undefined) {
        return 'webkitfullscreenchange';
      } else {
        return 'fullscreenchange';
      }
    };
    var requestFullscreen = function (sugarElem) {
      var elem = sugarElem.dom;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.webkitRequestFullScreen) {
        elem.webkitRequestFullScreen();
      }
    };
    var exitFullscreen = function (sugarDoc) {
      var doc = sugarDoc.dom;
      if (doc.exitFullscreen) {
        doc.exitFullscreen();
      } else if (doc.msExitFullscreen) {
        doc.msExitFullscreen();
      } else if (doc.webkitCancelFullScreen) {
        doc.webkitCancelFullScreen();
      }
    };
    var isFullscreenElement = function (elem) {
      return elem.dom === getFullscreenElement(owner(elem).dom);
    };

    var ancestors$1 = function (scope, predicate, isRoot) {
      return filter$1(parents(scope, isRoot), predicate);
    };
    var siblings$1 = function (scope, predicate) {
      return filter$1(siblings$2(scope), predicate);
    };

    var all = function (selector) {
      return all$1(selector);
    };
    var ancestors = function (scope, selector, isRoot) {
      return ancestors$1(scope, function (e) {
        return is(e, selector);
      }, isRoot);
    };
    var siblings = function (scope, selector) {
      return siblings$1(scope, function (e) {
        return is(e, selector);
      });
    };

    var attr = 'data-ephox-mobile-fullscreen-style';
    var siblingStyles = 'display:none!important;';
    var ancestorPosition = 'position:absolute!important;';
    var ancestorStyles = 'top:0!important;left:0!important;margin:0!important;padding:0!important;width:100%!important;height:100%!important;overflow:visible!important;';
    var bgFallback = 'background-color:rgb(255,255,255)!important;';
    var isAndroid = global$1.os.isAndroid();
    var matchColor = function (editorBody) {
      var color = get$2(editorBody, 'background-color');
      return color !== undefined && color !== '' ? 'background-color:' + color + '!important' : bgFallback;
    };
    var clobberStyles = function (dom, container, editorBody) {
      var gatherSiblings = function (element) {
        return siblings(element, '*:not(.tox-silver-sink)');
      };
      var clobber = function (clobberStyle) {
        return function (element) {
          var styles = get$3(element, 'style');
          var backup = styles === undefined ? 'no-styles' : styles.trim();
          if (backup === clobberStyle) {
            return;
          } else {
            set(element, attr, backup);
            setAll(element, dom.parseStyle(clobberStyle));
          }
        };
      };
      var ancestors$1 = ancestors(container, '*');
      var siblings$1 = bind$3(ancestors$1, gatherSiblings);
      var bgColor = matchColor(editorBody);
      each$1(siblings$1, clobber(siblingStyles));
      each$1(ancestors$1, clobber(ancestorPosition + ancestorStyles + bgColor));
      var containerStyles = isAndroid === true ? '' : ancestorPosition;
      clobber(containerStyles + ancestorStyles + bgColor)(container);
    };
    var restoreStyles = function (dom) {
      var clobberedEls = all('[' + attr + ']');
      each$1(clobberedEls, function (element) {
        var restore = get$3(element, attr);
        if (restore !== 'no-styles') {
          setAll(element, dom.parseStyle(restore));
        } else {
          remove(element, 'style');
        }
        remove(element, attr);
      });
    };

    var DOM = global$2.DOM;
    var getScrollPos = function () {
      return getBounds(window);
    };
    var setScrollPos = function (pos) {
      return window.scrollTo(pos.x, pos.y);
    };
    var viewportUpdate = get().fold(function () {
      return {
        bind: noop,
        unbind: noop
      };
    }, function (visualViewport) {
      var editorContainer = value();
      var resizeBinder = unbindable();
      var scrollBinder = unbindable();
      var refreshScroll = function () {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      };
      var refreshVisualViewport = function () {
        window.requestAnimationFrame(function () {
          editorContainer.on(function (container) {
            return setAll(container, {
              top: visualViewport.offsetTop + 'px',
              left: visualViewport.offsetLeft + 'px',
              height: visualViewport.height + 'px',
              width: visualViewport.width + 'px'
            });
          });
        });
      };
      var update = global.throttle(function () {
        refreshScroll();
        refreshVisualViewport();
      }, 50);
      var bind$1 = function (element) {
        editorContainer.set(element);
        update();
        resizeBinder.set(bind('resize', update));
        scrollBinder.set(bind('scroll', update));
      };
      var unbind = function () {
        editorContainer.on(function () {
          resizeBinder.clear();
          scrollBinder.clear();
        });
        editorContainer.clear();
      };
      return {
        bind: bind$1,
        unbind: unbind
      };
    });
    var toggleFullscreen = function (editor, fullscreenState) {
      var body = document.body;
      var documentElement = document.documentElement;
      var editorContainer = editor.getContainer();
      var editorContainerS = SugarElement.fromDom(editorContainer);
      var fullscreenRoot = getFullscreenRoot(editor);
      var fullscreenInfo = fullscreenState.get();
      var editorBody = SugarElement.fromDom(editor.getBody());
      var isTouch = global$1.deviceType.isTouch();
      var editorContainerStyle = editorContainer.style;
      var iframe = editor.iframeElement;
      var iframeStyle = iframe.style;
      var handleClasses = function (handler) {
        handler(body, 'tox-fullscreen');
        handler(documentElement, 'tox-fullscreen');
        handler(editorContainer, 'tox-fullscreen');
        getShadowRoot(editorContainerS).map(function (root) {
          return getShadowHost(root).dom;
        }).each(function (host) {
          handler(host, 'tox-fullscreen');
          handler(host, 'tox-shadowhost');
        });
      };
      var cleanup = function () {
        if (isTouch) {
          restoreStyles(editor.dom);
        }
        handleClasses(DOM.removeClass);
        viewportUpdate.unbind();
        Optional.from(fullscreenState.get()).each(function (info) {
          return info.fullscreenChangeHandler.unbind();
        });
      };
      if (!fullscreenInfo) {
        var fullscreenChangeHandler = bind$1(owner(fullscreenRoot), getFullscreenchangeEventName(), function (_evt) {
          if (getFullscreenNative(editor)) {
            if (!isFullscreenElement(fullscreenRoot) && fullscreenState.get() !== null) {
              toggleFullscreen(editor, fullscreenState);
            }
          }
        });
        var newFullScreenInfo = {
          scrollPos: getScrollPos(),
          containerWidth: editorContainerStyle.width,
          containerHeight: editorContainerStyle.height,
          containerTop: editorContainerStyle.top,
          containerLeft: editorContainerStyle.left,
          iframeWidth: iframeStyle.width,
          iframeHeight: iframeStyle.height,
          fullscreenChangeHandler: fullscreenChangeHandler
        };
        if (isTouch) {
          clobberStyles(editor.dom, editorContainerS, editorBody);
        }
        iframeStyle.width = iframeStyle.height = '100%';
        editorContainerStyle.width = editorContainerStyle.height = '';
        handleClasses(DOM.addClass);
        viewportUpdate.bind(editorContainerS);
        editor.on('remove', cleanup);
        fullscreenState.set(newFullScreenInfo);
        if (getFullscreenNative(editor)) {
          requestFullscreen(fullscreenRoot);
        }
        fireFullscreenStateChanged(editor, true);
      } else {
        fullscreenInfo.fullscreenChangeHandler.unbind();
        if (getFullscreenNative(editor) && isFullscreenElement(fullscreenRoot)) {
          exitFullscreen(owner(fullscreenRoot));
        }
        iframeStyle.width = fullscreenInfo.iframeWidth;
        iframeStyle.height = fullscreenInfo.iframeHeight;
        editorContainerStyle.width = fullscreenInfo.containerWidth;
        editorContainerStyle.height = fullscreenInfo.containerHeight;
        editorContainerStyle.top = fullscreenInfo.containerTop;
        editorContainerStyle.left = fullscreenInfo.containerLeft;
        cleanup();
        setScrollPos(fullscreenInfo.scrollPos);
        fullscreenState.set(null);
        fireFullscreenStateChanged(editor, false);
        editor.off('remove', cleanup);
      }
    };

    var register$1 = function (editor, fullscreenState) {
      editor.addCommand('mceFullScreen', function () {
        toggleFullscreen(editor, fullscreenState);
      });
    };

    var makeSetupHandler = function (editor, fullscreenState) {
      return function (api) {
        api.setActive(fullscreenState.get() !== null);
        var editorEventCallback = function (e) {
          return api.setActive(e.state);
        };
        editor.on('FullscreenStateChanged', editorEventCallback);
        return function () {
          return editor.off('FullscreenStateChanged', editorEventCallback);
        };
      };
    };
    var register = function (editor, fullscreenState) {
      var onAction = function () {
        return editor.execCommand('mceFullScreen');
      };
      editor.ui.registry.addToggleMenuItem('fullscreen', {
        text: 'Fullscreen',
        icon: 'fullscreen',
        shortcut: 'Meta+Shift+F',
        onAction: onAction,
        onSetup: makeSetupHandler(editor, fullscreenState)
      });
      editor.ui.registry.addToggleButton('fullscreen', {
        tooltip: 'Fullscreen',
        icon: 'fullscreen',
        onAction: onAction,
        onSetup: makeSetupHandler(editor, fullscreenState)
      });
    };

    function Plugin () {
      global$3.add('fullscreen', function (editor) {
        var fullscreenState = Cell(null);
        if (editor.inline) {
          return get$5(fullscreenState);
        }
        register$1(editor, fullscreenState);
        register(editor, fullscreenState);
        editor.addShortcut('Meta+Shift+F', '', 'mceFullScreen');
        return get$5(fullscreenState);
      });
    }

    Plugin();

}());


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "hr" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/hr')
//   ES2015:
//     import 'tinymce/plugins/hr'
__webpack_require__(1491);

/***/ }),
/* 1491 */
/***/ (function(module, exports) {

/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 *
 * Version: 5.10.5 (2022-05-25)
 */
(function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var register$1 = function (editor) {
      editor.addCommand('InsertHorizontalRule', function () {
        editor.execCommand('mceInsertContent', false, '<hr />');
      });
    };

    var register = function (editor) {
      var onAction = function () {
        return editor.execCommand('InsertHorizontalRule');
      };
      editor.ui.registry.addButton('hr', {
        icon: 'horizontal-rule',
        tooltip: 'Horizontal line',
        onAction: onAction
      });
      editor.ui.registry.addMenuItem('hr', {
        icon: 'horizontal-rule',
        text: 'Horizontal line',
        onAction: onAction
      });
    };

    function Plugin () {
      global.add('hr', function (editor) {
        register$1(editor);
        register(editor);
      });
    }

    Plugin();

}());


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "image" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/image')
//   ES2015:
//     import 'tinymce/plugins/image'
__webpack_require__(1493);

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 *
 * Version: 5.10.5 (2022-05-25)
 */
(function () {
    'use strict';

    var global$6 = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var __assign = function () {
      __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };

    var typeOf = function (x) {
      var t = typeof x;
      if (x === null) {
        return 'null';
      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
        return 'array';
      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
        return 'string';
      } else {
        return t;
      }
    };
    var isType = function (type) {
      return function (value) {
        return typeOf(value) === type;
      };
    };
    var isSimpleType = function (type) {
      return function (value) {
        return typeof value === type;
      };
    };
    var eq = function (t) {
      return function (a) {
        return t === a;
      };
    };
    var isString = isType('string');
    var isObject = isType('object');
    var isArray = isType('array');
    var isNull = eq(null);
    var isBoolean = isSimpleType('boolean');
    var isNullable = function (a) {
      return a === null || a === undefined;
    };
    var isNonNullable = function (a) {
      return !isNullable(a);
    };
    var isFunction = isSimpleType('function');
    var isNumber = isSimpleType('number');

    var noop = function () {
    };
    var constant = function (value) {
      return function () {
        return value;
      };
    };
    var identity = function (x) {
      return x;
    };
    var never = constant(false);
    var always = constant(true);

    var none = function () {
      return NONE;
    };
    var NONE = function () {
      var call = function (thunk) {
        return thunk();
      };
      var id = identity;
      var me = {
        fold: function (n, _s) {
          return n();
        },
        isSome: never,
        isNone: always,
        getOr: id,
        getOrThunk: call,
        getOrDie: function (msg) {
          throw new Error(msg || 'error: getOrDie called on none.');
        },
        getOrNull: constant(null),
        getOrUndefined: constant(undefined),
        or: id,
        orThunk: call,
        map: none,
        each: noop,
        bind: none,
        exists: never,
        forall: always,
        filter: function () {
          return none();
        },
        toArray: function () {
          return [];
        },
        toString: constant('none()')
      };
      return me;
    }();
    var some = function (a) {
      var constant_a = constant(a);
      var self = function () {
        return me;
      };
      var bind = function (f) {
        return f(a);
      };
      var me = {
        fold: function (n, s) {
          return s(a);
        },
        isSome: always,
        isNone: never,
        getOr: constant_a,
        getOrThunk: constant_a,
        getOrDie: constant_a,
        getOrNull: constant_a,
        getOrUndefined: constant_a,
        or: self,
        orThunk: self,
        map: function (f) {
          return some(f(a));
        },
        each: function (f) {
          f(a);
        },
        bind: bind,
        exists: bind,
        forall: bind,
        filter: function (f) {
          return f(a) ? me : NONE;
        },
        toArray: function () {
          return [a];
        },
        toString: function () {
          return 'some(' + a + ')';
        }
      };
      return me;
    };
    var from = function (value) {
      return value === null || value === undefined ? NONE : some(value);
    };
    var Optional = {
      some: some,
      none: none,
      from: from
    };

    var keys = Object.keys;
    var hasOwnProperty = Object.hasOwnProperty;
    var each = function (obj, f) {
      var props = keys(obj);
      for (var k = 0, len = props.length; k < len; k++) {
        var i = props[k];
        var x = obj[i];
        f(x, i);
      }
    };
    var objAcc = function (r) {
      return function (x, i) {
        r[i] = x;
      };
    };
    var internalFilter = function (obj, pred, onTrue, onFalse) {
      var r = {};
      each(obj, function (x, i) {
        (pred(x, i) ? onTrue : onFalse)(x, i);
      });
      return r;
    };
    var filter = function (obj, pred) {
      var t = {};
      internalFilter(obj, pred, objAcc(t), noop);
      return t;
    };
    var has = function (obj, key) {
      return hasOwnProperty.call(obj, key);
    };
    var hasNonNullableKey = function (obj, key) {
      return has(obj, key) && obj[key] !== undefined && obj[key] !== null;
    };

    var nativePush = Array.prototype.push;
    var flatten = function (xs) {
      var r = [];
      for (var i = 0, len = xs.length; i < len; ++i) {
        if (!isArray(xs[i])) {
          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
        }
        nativePush.apply(r, xs[i]);
      }
      return r;
    };
    var get = function (xs, i) {
      return i >= 0 && i < xs.length ? Optional.some(xs[i]) : Optional.none();
    };
    var head = function (xs) {
      return get(xs, 0);
    };
    var findMap = function (arr, f) {
      for (var i = 0; i < arr.length; i++) {
        var r = f(arr[i], i);
        if (r.isSome()) {
          return r;
        }
      }
      return Optional.none();
    };

    typeof window !== 'undefined' ? window : Function('return this;')();

    var rawSet = function (dom, key, value) {
      if (isString(value) || isBoolean(value) || isNumber(value)) {
        dom.setAttribute(key, value + '');
      } else {
        console.error('Invalid call to Attribute.set. Key ', key, ':: Value ', value, ':: Element ', dom);
        throw new Error('Attribute value was not simple');
      }
    };
    var set = function (element, key, value) {
      rawSet(element.dom, key, value);
    };
    var remove = function (element, key) {
      element.dom.removeAttribute(key);
    };

    var fromHtml = function (html, scope) {
      var doc = scope || document;
      var div = doc.createElement('div');
      div.innerHTML = html;
      if (!div.hasChildNodes() || div.childNodes.length > 1) {
        console.error('HTML does not have a single root node', html);
        throw new Error('HTML must have a single root node');
      }
      return fromDom(div.childNodes[0]);
    };
    var fromTag = function (tag, scope) {
      var doc = scope || document;
      var node = doc.createElement(tag);
      return fromDom(node);
    };
    var fromText = function (text, scope) {
      var doc = scope || document;
      var node = doc.createTextNode(text);
      return fromDom(node);
    };
    var fromDom = function (node) {
      if (node === null || node === undefined) {
        throw new Error('Node cannot be null or undefined');
      }
      return { dom: node };
    };
    var fromPoint = function (docElm, x, y) {
      return Optional.from(docElm.dom.elementFromPoint(x, y)).map(fromDom);
    };
    var SugarElement = {
      fromHtml: fromHtml,
      fromTag: fromTag,
      fromText: fromText,
      fromDom: fromDom,
      fromPoint: fromPoint
    };

    var global$5 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var global$4 = tinymce.util.Tools.resolve('tinymce.util.Promise');

    var global$3 = tinymce.util.Tools.resolve('tinymce.util.URI');

    var global$2 = tinymce.util.Tools.resolve('tinymce.util.XHR');

    var hasDimensions = function (editor) {
      return editor.getParam('image_dimensions', true, 'boolean');
    };
    var hasAdvTab = function (editor) {
      return editor.getParam('image_advtab', false, 'boolean');
    };
    var hasUploadTab = function (editor) {
      return editor.getParam('image_uploadtab', true, 'boolean');
    };
    var getPrependUrl = function (editor) {
      return editor.getParam('image_prepend_url', '', 'string');
    };
    var getClassList = function (editor) {
      return editor.getParam('image_class_list');
    };
    var hasDescription = function (editor) {
      return editor.getParam('image_description', true, 'boolean');
    };
    var hasImageTitle = function (editor) {
      return editor.getParam('image_title', false, 'boolean');
    };
    var hasImageCaption = function (editor) {
      return editor.getParam('image_caption', false, 'boolean');
    };
    var getImageList = function (editor) {
      return editor.getParam('image_list', false);
    };
    var hasUploadUrl = function (editor) {
      return isNonNullable(editor.getParam('images_upload_url'));
    };
    var hasUploadHandler = function (editor) {
      return isNonNullable(editor.getParam('images_upload_handler'));
    };
    var showAccessibilityOptions = function (editor) {
      return editor.getParam('a11y_advanced_options', false, 'boolean');
    };
    var isAutomaticUploadsEnabled = function (editor) {
      return editor.getParam('automatic_uploads', true, 'boolean');
    };

    var parseIntAndGetMax = function (val1, val2) {
      return Math.max(parseInt(val1, 10), parseInt(val2, 10));
    };
    var getImageSize = function (url) {
      return new global$4(function (callback) {
        var img = document.createElement('img');
        var done = function (dimensions) {
          img.onload = img.onerror = null;
          if (img.parentNode) {
            img.parentNode.removeChild(img);
          }
          callback(dimensions);
        };
        img.onload = function () {
          var width = parseIntAndGetMax(img.width, img.clientWidth);
          var height = parseIntAndGetMax(img.height, img.clientHeight);
          var dimensions = {
            width: width,
            height: height
          };
          done(global$4.resolve(dimensions));
        };
        img.onerror = function () {
          done(global$4.reject('Failed to get image dimensions for: ' + url));
        };
        var style = img.style;
        style.visibility = 'hidden';
        style.position = 'fixed';
        style.bottom = style.left = '0px';
        style.width = style.height = 'auto';
        document.body.appendChild(img);
        img.src = url;
      });
    };
    var removePixelSuffix = function (value) {
      if (value) {
        value = value.replace(/px$/, '');
      }
      return value;
    };
    var addPixelSuffix = function (value) {
      if (value.length > 0 && /^[0-9]+$/.test(value)) {
        value += 'px';
      }
      return value;
    };
    var mergeMargins = function (css) {
      if (css.margin) {
        var splitMargin = String(css.margin).split(' ');
        switch (splitMargin.length) {
        case 1:
          css['margin-top'] = css['margin-top'] || splitMargin[0];
          css['margin-right'] = css['margin-right'] || splitMargin[0];
          css['margin-bottom'] = css['margin-bottom'] || splitMargin[0];
          css['margin-left'] = css['margin-left'] || splitMargin[0];
          break;
        case 2:
          css['margin-top'] = css['margin-top'] || splitMargin[0];
          css['margin-right'] = css['margin-right'] || splitMargin[1];
          css['margin-bottom'] = css['margin-bottom'] || splitMargin[0];
          css['margin-left'] = css['margin-left'] || splitMargin[1];
          break;
        case 3:
          css['margin-top'] = css['margin-top'] || splitMargin[0];
          css['margin-right'] = css['margin-right'] || splitMargin[1];
          css['margin-bottom'] = css['margin-bottom'] || splitMargin[2];
          css['margin-left'] = css['margin-left'] || splitMargin[1];
          break;
        case 4:
          css['margin-top'] = css['margin-top'] || splitMargin[0];
          css['margin-right'] = css['margin-right'] || splitMargin[1];
          css['margin-bottom'] = css['margin-bottom'] || splitMargin[2];
          css['margin-left'] = css['margin-left'] || splitMargin[3];
        }
        delete css.margin;
      }
      return css;
    };
    var createImageList = function (editor, callback) {
      var imageList = getImageList(editor);
      if (isString(imageList)) {
        global$2.send({
          url: imageList,
          success: function (text) {
            callback(JSON.parse(text));
          }
        });
      } else if (isFunction(imageList)) {
        imageList(callback);
      } else {
        callback(imageList);
      }
    };
    var waitLoadImage = function (editor, data, imgElm) {
      var selectImage = function () {
        imgElm.onload = imgElm.onerror = null;
        if (editor.selection) {
          editor.selection.select(imgElm);
          editor.nodeChanged();
        }
      };
      imgElm.onload = function () {
        if (!data.width && !data.height && hasDimensions(editor)) {
          editor.dom.setAttribs(imgElm, {
            width: String(imgElm.clientWidth),
            height: String(imgElm.clientHeight)
          });
        }
        selectImage();
      };
      imgElm.onerror = selectImage;
    };
    var blobToDataUri = function (blob) {
      return new global$4(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = function () {
          reject(reader.error.message);
        };
        reader.readAsDataURL(blob);
      });
    };
    var isPlaceholderImage = function (imgElm) {
      return imgElm.nodeName === 'IMG' && (imgElm.hasAttribute('data-mce-object') || imgElm.hasAttribute('data-mce-placeholder'));
    };
    var isSafeImageUrl = function (editor, src) {
      return global$3.isDomSafe(src, 'img', editor.settings);
    };

    var DOM = global$5.DOM;
    var getHspace = function (image) {
      if (image.style.marginLeft && image.style.marginRight && image.style.marginLeft === image.style.marginRight) {
        return removePixelSuffix(image.style.marginLeft);
      } else {
        return '';
      }
    };
    var getVspace = function (image) {
      if (image.style.marginTop && image.style.marginBottom && image.style.marginTop === image.style.marginBottom) {
        return removePixelSuffix(image.style.marginTop);
      } else {
        return '';
      }
    };
    var getBorder = function (image) {
      if (image.style.borderWidth) {
        return removePixelSuffix(image.style.borderWidth);
      } else {
        return '';
      }
    };
    var getAttrib = function (image, name) {
      if (image.hasAttribute(name)) {
        return image.getAttribute(name);
      } else {
        return '';
      }
    };
    var getStyle = function (image, name) {
      return image.style[name] ? image.style[name] : '';
    };
    var hasCaption = function (image) {
      return image.parentNode !== null && image.parentNode.nodeName === 'FIGURE';
    };
    var updateAttrib = function (image, name, value) {
      if (value === '') {
        image.removeAttribute(name);
      } else {
        image.setAttribute(name, value);
      }
    };
    var wrapInFigure = function (image) {
      var figureElm = DOM.create('figure', { class: 'image' });
      DOM.insertAfter(figureElm, image);
      figureElm.appendChild(image);
      figureElm.appendChild(DOM.create('figcaption', { contentEditable: 'true' }, 'Caption'));
      figureElm.contentEditable = 'false';
    };
    var removeFigure = function (image) {
      var figureElm = image.parentNode;
      DOM.insertAfter(image, figureElm);
      DOM.remove(figureElm);
    };
    var toggleCaption = function (image) {
      if (hasCaption(image)) {
        removeFigure(image);
      } else {
        wrapInFigure(image);
      }
    };
    var normalizeStyle = function (image, normalizeCss) {
      var attrValue = image.getAttribute('style');
      var value = normalizeCss(attrValue !== null ? attrValue : '');
      if (value.length > 0) {
        image.setAttribute('style', value);
        image.setAttribute('data-mce-style', value);
      } else {
        image.removeAttribute('style');
      }
    };
    var setSize = function (name, normalizeCss) {
      return function (image, name, value) {
        if (image.style[name]) {
          image.style[name] = addPixelSuffix(value);
          normalizeStyle(image, normalizeCss);
        } else {
          updateAttrib(image, name, value);
        }
      };
    };
    var getSize = function (image, name) {
      if (image.style[name]) {
        return removePixelSuffix(image.style[name]);
      } else {
        return getAttrib(image, name);
      }
    };
    var setHspace = function (image, value) {
      var pxValue = addPixelSuffix(value);
      image.style.marginLeft = pxValue;
      image.style.marginRight = pxValue;
    };
    var setVspace = function (image, value) {
      var pxValue = addPixelSuffix(value);
      image.style.marginTop = pxValue;
      image.style.marginBottom = pxValue;
    };
    var setBorder = function (image, value) {
      var pxValue = addPixelSuffix(value);
      image.style.borderWidth = pxValue;
    };
    var setBorderStyle = function (image, value) {
      image.style.borderStyle = value;
    };
    var getBorderStyle = function (image) {
      return getStyle(image, 'borderStyle');
    };
    var isFigure = function (elm) {
      return elm.nodeName === 'FIGURE';
    };
    var isImage = function (elm) {
      return elm.nodeName === 'IMG';
    };
    var getIsDecorative = function (image) {
      return DOM.getAttrib(image, 'alt').length === 0 && DOM.getAttrib(image, 'role') === 'presentation';
    };
    var getAlt = function (image) {
      if (getIsDecorative(image)) {
        return '';
      } else {
        return getAttrib(image, 'alt');
      }
    };
    var defaultData = function () {
      return {
        src: '',
        alt: '',
        title: '',
        width: '',
        height: '',
        class: '',
        style: '',
        caption: false,
        hspace: '',
        vspace: '',
        border: '',
        borderStyle: '',
        isDecorative: false
      };
    };
    var getStyleValue = function (normalizeCss, data) {
      var image = document.createElement('img');
      updateAttrib(image, 'style', data.style);
      if (getHspace(image) || data.hspace !== '') {
        setHspace(image, data.hspace);
      }
      if (getVspace(image) || data.vspace !== '') {
        setVspace(image, data.vspace);
      }
      if (getBorder(image) || data.border !== '') {
        setBorder(image, data.border);
      }
      if (getBorderStyle(image) || data.borderStyle !== '') {
        setBorderStyle(image, data.borderStyle);
      }
      return normalizeCss(image.getAttribute('style'));
    };
    var create = function (normalizeCss, data) {
      var image = document.createElement('img');
      write(normalizeCss, __assign(__assign({}, data), { caption: false }), image);
      setAlt(image, data.alt, data.isDecorative);
      if (data.caption) {
        var figure = DOM.create('figure', { class: 'image' });
        figure.appendChild(image);
        figure.appendChild(DOM.create('figcaption', { contentEditable: 'true' }, 'Caption'));
        figure.contentEditable = 'false';
        return figure;
      } else {
        return image;
      }
    };
    var read = function (normalizeCss, image) {
      return {
        src: getAttrib(image, 'src'),
        alt: getAlt(image),
        title: getAttrib(image, 'title'),
        width: getSize(image, 'width'),
        height: getSize(image, 'height'),
        class: getAttrib(image, 'class'),
        style: normalizeCss(getAttrib(image, 'style')),
        caption: hasCaption(image),
        hspace: getHspace(image),
        vspace: getVspace(image),
        border: getBorder(image),
        borderStyle: getStyle(image, 'borderStyle'),
        isDecorative: getIsDecorative(image)
      };
    };
    var updateProp = function (image, oldData, newData, name, set) {
      if (newData[name] !== oldData[name]) {
        set(image, name, newData[name]);
      }
    };
    var setAlt = function (image, alt, isDecorative) {
      if (isDecorative) {
        DOM.setAttrib(image, 'role', 'presentation');
        var sugarImage = SugarElement.fromDom(image);
        set(sugarImage, 'alt', '');
      } else {
        if (isNull(alt)) {
          var sugarImage = SugarElement.fromDom(image);
          remove(sugarImage, 'alt');
        } else {
          var sugarImage = SugarElement.fromDom(image);
          set(sugarImage, 'alt', alt);
        }
        if (DOM.getAttrib(image, 'role') === 'presentation') {
          DOM.setAttrib(image, 'role', '');
        }
      }
    };
    var updateAlt = function (image, oldData, newData) {
      if (newData.alt !== oldData.alt || newData.isDecorative !== oldData.isDecorative) {
        setAlt(image, newData.alt, newData.isDecorative);
      }
    };
    var normalized = function (set, normalizeCss) {
      return function (image, name, value) {
        set(image, value);
        normalizeStyle(image, normalizeCss);
      };
    };
    var write = function (normalizeCss, newData, image) {
      var oldData = read(normalizeCss, image);
      updateProp(image, oldData, newData, 'caption', function (image, _name, _value) {
        return toggleCaption(image);
      });
      updateProp(image, oldData, newData, 'src', updateAttrib);
      updateProp(image, oldData, newData, 'title', updateAttrib);
      updateProp(image, oldData, newData, 'width', setSize('width', normalizeCss));
      updateProp(image, oldData, newData, 'height', setSize('height', normalizeCss));
      updateProp(image, oldData, newData, 'class', updateAttrib);
      updateProp(image, oldData, newData, 'style', normalized(function (image, value) {
        return updateAttrib(image, 'style', value);
      }, normalizeCss));
      updateProp(image, oldData, newData, 'hspace', normalized(setHspace, normalizeCss));
      updateProp(image, oldData, newData, 'vspace', normalized(setVspace, normalizeCss));
      updateProp(image, oldData, newData, 'border', normalized(setBorder, normalizeCss));
      updateProp(image, oldData, newData, 'borderStyle', normalized(setBorderStyle, normalizeCss));
      updateAlt(image, oldData, newData);
    };

    var normalizeCss$1 = function (editor, cssText) {
      var css = editor.dom.styles.parse(cssText);
      var mergedCss = mergeMargins(css);
      var compressed = editor.dom.styles.parse(editor.dom.styles.serialize(mergedCss));
      return editor.dom.styles.serialize(compressed);
    };
    var getSelectedImage = function (editor) {
      var imgElm = editor.selection.getNode();
      var figureElm = editor.dom.getParent(imgElm, 'figure.image');
      if (figureElm) {
        return editor.dom.select('img', figureElm)[0];
      }
      if (imgElm && (imgElm.nodeName !== 'IMG' || isPlaceholderImage(imgElm))) {
        return null;
      }
      return imgElm;
    };
    var splitTextBlock = function (editor, figure) {
      var dom = editor.dom;
      var textBlockElements = filter(editor.schema.getTextBlockElements(), function (_, parentElm) {
        return !editor.schema.isValidChild(parentElm, 'figure');
      });
      var textBlock = dom.getParent(figure.parentNode, function (node) {
        return hasNonNullableKey(textBlockElements, node.nodeName);
      }, editor.getBody());
      if (textBlock) {
        return dom.split(textBlock, figure);
      } else {
        return figure;
      }
    };
    var readImageDataFromSelection = function (editor) {
      var image = getSelectedImage(editor);
      return image ? read(function (css) {
        return normalizeCss$1(editor, css);
      }, image) : defaultData();
    };
    var insertImageAtCaret = function (editor, data) {
      var elm = create(function (css) {
        return normalizeCss$1(editor, css);
      }, data);
      editor.dom.setAttrib(elm, 'data-mce-id', '__mcenew');
      editor.focus();
      editor.selection.setContent(elm.outerHTML);
      var insertedElm = editor.dom.select('*[data-mce-id="__mcenew"]')[0];
      editor.dom.setAttrib(insertedElm, 'data-mce-id', null);
      if (isFigure(insertedElm)) {
        var figure = splitTextBlock(editor, insertedElm);
        editor.selection.select(figure);
      } else {
        editor.selection.select(insertedElm);
      }
    };
    var syncSrcAttr = function (editor, image) {
      editor.dom.setAttrib(image, 'src', image.getAttribute('src'));
    };
    var deleteImage = function (editor, image) {
      if (image) {
        var elm = editor.dom.is(image.parentNode, 'figure.image') ? image.parentNode : image;
        editor.dom.remove(elm);
        editor.focus();
        editor.nodeChanged();
        if (editor.dom.isEmpty(editor.getBody())) {
          editor.setContent('');
          editor.selection.setCursorLocation();
        }
      }
    };
    var writeImageDataToSelection = function (editor, data) {
      var image = getSelectedImage(editor);
      write(function (css) {
        return normalizeCss$1(editor, css);
      }, data, image);
      syncSrcAttr(editor, image);
      if (isFigure(image.parentNode)) {
        var figure = image.parentNode;
        splitTextBlock(editor, figure);
        editor.selection.select(image.parentNode);
      } else {
        editor.selection.select(image);
        waitLoadImage(editor, data, image);
      }
    };
    var sanitizeImageData = function (editor, data) {
      var src = data.src;
      return __assign(__assign({}, data), { src: isSafeImageUrl(editor, src) ? src : '' });
    };
    var insertOrUpdateImage = function (editor, partialData) {
      var image = getSelectedImage(editor);
      if (image) {
        var selectedImageData = read(function (css) {
          return normalizeCss$1(editor, css);
        }, image);
        var data = __assign(__assign({}, selectedImageData), partialData);
        var sanitizedData = sanitizeImageData(editor, data);
        if (data.src) {
          writeImageDataToSelection(editor, sanitizedData);
        } else {
          deleteImage(editor, image);
        }
      } else if (partialData.src) {
        insertImageAtCaret(editor, __assign(__assign({}, defaultData()), partialData));
      }
    };

    var deep = function (old, nu) {
      var bothObjects = isObject(old) && isObject(nu);
      return bothObjects ? deepMerge(old, nu) : nu;
    };
    var baseMerge = function (merger) {
      return function () {
        var objects = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          objects[_i] = arguments[_i];
        }
        if (objects.length === 0) {
          throw new Error('Can\'t merge zero objects');
        }
        var ret = {};
        for (var j = 0; j < objects.length; j++) {
          var curObject = objects[j];
          for (var key in curObject) {
            if (has(curObject, key)) {
              ret[key] = merger(ret[key], curObject[key]);
            }
          }
        }
        return ret;
      };
    };
    var deepMerge = baseMerge(deep);

    var isNotEmpty = function (s) {
      return s.length > 0;
    };

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.ImageUploader');

    var global = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var getValue = function (item) {
      return isString(item.value) ? item.value : '';
    };
    var getText = function (item) {
      if (isString(item.text)) {
        return item.text;
      } else if (isString(item.title)) {
        return item.title;
      } else {
        return '';
      }
    };
    var sanitizeList = function (list, extractValue) {
      var out = [];
      global.each(list, function (item) {
        var text = getText(item);
        if (item.menu !== undefined) {
          var items = sanitizeList(item.menu, extractValue);
          out.push({
            text: text,
            items: items
          });
        } else {
          var value = extractValue(item);
          out.push({
            text: text,
            value: value
          });
        }
      });
      return out;
    };
    var sanitizer = function (extractor) {
      if (extractor === void 0) {
        extractor = getValue;
      }
      return function (list) {
        if (list) {
          return Optional.from(list).map(function (list) {
            return sanitizeList(list, extractor);
          });
        } else {
          return Optional.none();
        }
      };
    };
    var sanitize = function (list) {
      return sanitizer(getValue)(list);
    };
    var isGroup = function (item) {
      return has(item, 'items');
    };
    var findEntryDelegate = function (list, value) {
      return findMap(list, function (item) {
        if (isGroup(item)) {
          return findEntryDelegate(item.items, value);
        } else if (item.value === value) {
          return Optional.some(item);
        } else {
          return Optional.none();
        }
      });
    };
    var findEntry = function (optList, value) {
      return optList.bind(function (list) {
        return findEntryDelegate(list, value);
      });
    };
    var ListUtils = {
      sanitizer: sanitizer,
      sanitize: sanitize,
      findEntry: findEntry
    };

    var makeTab$2 = function (_info) {
      return {
        title: 'Advanced',
        name: 'advanced',
        items: [
          {
            type: 'input',
            label: 'Style',
            name: 'style'
          },
          {
            type: 'grid',
            columns: 2,
            items: [
              {
                type: 'input',
                label: 'Vertical space',
                name: 'vspace',
                inputMode: 'numeric'
              },
              {
                type: 'input',
                label: 'Horizontal space',
                name: 'hspace',
                inputMode: 'numeric'
              },
              {
                type: 'input',
                label: 'Border width',
                name: 'border',
                inputMode: 'numeric'
              },
              {
                type: 'listbox',
                name: 'borderstyle',
                label: 'Border style',
                items: [
                  {
                    text: 'Select...',
                    value: ''
                  },
                  {
                    text: 'Solid',
                    value: 'solid'
                  },
                  {
                    text: 'Dotted',
                    value: 'dotted'
                  },
                  {
                    text: 'Dashed',
                    value: 'dashed'
                  },
                  {
                    text: 'Double',
                    value: 'double'
                  },
                  {
                    text: 'Groove',
                    value: 'groove'
                  },
                  {
                    text: 'Ridge',
                    value: 'ridge'
                  },
                  {
                    text: 'Inset',
                    value: 'inset'
                  },
                  {
                    text: 'Outset',
                    value: 'outset'
                  },
                  {
                    text: 'None',
                    value: 'none'
                  },
                  {
                    text: 'Hidden',
                    value: 'hidden'
                  }
                ]
              }
            ]
          }
        ]
      };
    };
    var AdvTab = { makeTab: makeTab$2 };

    var collect = function (editor) {
      var urlListSanitizer = ListUtils.sanitizer(function (item) {
        return editor.convertURL(item.value || item.url, 'src');
      });
      var futureImageList = new global$4(function (completer) {
        createImageList(editor, function (imageList) {
          completer(urlListSanitizer(imageList).map(function (items) {
            return flatten([
              [{
                  text: 'None',
                  value: ''
                }],
              items
            ]);
          }));
        });
      });
      var classList = ListUtils.sanitize(getClassList(editor));
      var hasAdvTab$1 = hasAdvTab(editor);
      var hasUploadTab$1 = hasUploadTab(editor);
      var hasUploadUrl$1 = hasUploadUrl(editor);
      var hasUploadHandler$1 = hasUploadHandler(editor);
      var image = readImageDataFromSelection(editor);
      var hasDescription$1 = hasDescription(editor);
      var hasImageTitle$1 = hasImageTitle(editor);
      var hasDimensions$1 = hasDimensions(editor);
      var hasImageCaption$1 = hasImageCaption(editor);
      var hasAccessibilityOptions = showAccessibilityOptions(editor);
      var automaticUploads = isAutomaticUploadsEnabled(editor);
      var prependURL = Optional.some(getPrependUrl(editor)).filter(function (preUrl) {
        return isString(preUrl) && preUrl.length > 0;
      });
      return futureImageList.then(function (imageList) {
        return {
          image: image,
          imageList: imageList,
          classList: classList,
          hasAdvTab: hasAdvTab$1,
          hasUploadTab: hasUploadTab$1,
          hasUploadUrl: hasUploadUrl$1,
          hasUploadHandler: hasUploadHandler$1,
          hasDescription: hasDescription$1,
          hasImageTitle: hasImageTitle$1,
          hasDimensions: hasDimensions$1,
          hasImageCaption: hasImageCaption$1,
          prependURL: prependURL,
          hasAccessibilityOptions: hasAccessibilityOptions,
          automaticUploads: automaticUploads
        };
      });
    };

    var makeItems = function (info) {
      var imageUrl = {
        name: 'src',
        type: 'urlinput',
        filetype: 'image',
        label: 'Source'
      };
      var imageList = info.imageList.map(function (items) {
        return {
          name: 'images',
          type: 'listbox',
          label: 'Image list',
          items: items
        };
      });
      var imageDescription = {
        name: 'alt',
        type: 'input',
        label: 'Alternative description',
        disabled: info.hasAccessibilityOptions && info.image.isDecorative
      };
      var imageTitle = {
        name: 'title',
        type: 'input',
        label: 'Image title'
      };
      var imageDimensions = {
        name: 'dimensions',
        type: 'sizeinput'
      };
      var isDecorative = {
        type: 'label',
        label: 'Accessibility',
        items: [{
            name: 'isDecorative',
            type: 'checkbox',
            label: 'Image is decorative'
          }]
      };
      var classList = info.classList.map(function (items) {
        return {
          name: 'classes',
          type: 'listbox',
          label: 'Class',
          items: items
        };
      });
      var caption = {
        type: 'label',
        label: 'Caption',
        items: [{
            type: 'checkbox',
            name: 'caption',
            label: 'Show caption'
          }]
      };
      var getDialogContainerType = function (useColumns) {
        return useColumns ? {
          type: 'grid',
          columns: 2
        } : { type: 'panel' };
      };
      return flatten([
        [imageUrl],
        imageList.toArray(),
        info.hasAccessibilityOptions && info.hasDescription ? [isDecorative] : [],
        info.hasDescription ? [imageDescription] : [],
        info.hasImageTitle ? [imageTitle] : [],
        info.hasDimensions ? [imageDimensions] : [],
        [__assign(__assign({}, getDialogContainerType(info.classList.isSome() && info.hasImageCaption)), {
            items: flatten([
              classList.toArray(),
              info.hasImageCaption ? [caption] : []
            ])
          })]
      ]);
    };
    var makeTab$1 = function (info) {
      return {
        title: 'General',
        name: 'general',
        items: makeItems(info)
      };
    };
    var MainTab = {
      makeTab: makeTab$1,
      makeItems: makeItems
    };

    var makeTab = function (_info) {
      var items = [{
          type: 'dropzone',
          name: 'fileinput'
        }];
      return {
        title: 'Upload',
        name: 'upload',
        items: items
      };
    };
    var UploadTab = { makeTab: makeTab };

    var createState = function (info) {
      return {
        prevImage: ListUtils.findEntry(info.imageList, info.image.src),
        prevAlt: info.image.alt,
        open: true
      };
    };
    var fromImageData = function (image) {
      return {
        src: {
          value: image.src,
          meta: {}
        },
        images: image.src,
        alt: image.alt,
        title: image.title,
        dimensions: {
          width: image.width,
          height: image.height
        },
        classes: image.class,
        caption: image.caption,
        style: image.style,
        vspace: image.vspace,
        border: image.border,
        hspace: image.hspace,
        borderstyle: image.borderStyle,
        fileinput: [],
        isDecorative: image.isDecorative
      };
    };
    var toImageData = function (data, removeEmptyAlt) {
      return {
        src: data.src.value,
        alt: data.alt.length === 0 && removeEmptyAlt ? null : data.alt,
        title: data.title,
        width: data.dimensions.width,
        height: data.dimensions.height,
        class: data.classes,
        style: data.style,
        caption: data.caption,
        hspace: data.hspace,
        vspace: data.vspace,
        border: data.border,
        borderStyle: data.borderstyle,
        isDecorative: data.isDecorative
      };
    };
    var addPrependUrl2 = function (info, srcURL) {
      if (!/^(?:[a-zA-Z]+:)?\/\//.test(srcURL)) {
        return info.prependURL.bind(function (prependUrl) {
          if (srcURL.substring(0, prependUrl.length) !== prependUrl) {
            return Optional.some(prependUrl + srcURL);
          }
          return Optional.none();
        });
      }
      return Optional.none();
    };
    var addPrependUrl = function (info, api) {
      var data = api.getData();
      addPrependUrl2(info, data.src.value).each(function (srcURL) {
        api.setData({
          src: {
            value: srcURL,
            meta: data.src.meta
          }
        });
      });
    };
    var formFillFromMeta2 = function (info, data, meta) {
      if (info.hasDescription && isString(meta.alt)) {
        data.alt = meta.alt;
      }
      if (info.hasAccessibilityOptions) {
        data.isDecorative = meta.isDecorative || data.isDecorative || false;
      }
      if (info.hasImageTitle && isString(meta.title)) {
        data.title = meta.title;
      }
      if (info.hasDimensions) {
        if (isString(meta.width)) {
          data.dimensions.width = meta.width;
        }
        if (isString(meta.height)) {
          data.dimensions.height = meta.height;
        }
      }
      if (isString(meta.class)) {
        ListUtils.findEntry(info.classList, meta.class).each(function (entry) {
          data.classes = entry.value;
        });
      }
      if (info.hasImageCaption) {
        if (isBoolean(meta.caption)) {
          data.caption = meta.caption;
        }
      }
      if (info.hasAdvTab) {
        if (isString(meta.style)) {
          data.style = meta.style;
        }
        if (isString(meta.vspace)) {
          data.vspace = meta.vspace;
        }
        if (isString(meta.border)) {
          data.border = meta.border;
        }
        if (isString(meta.hspace)) {
          data.hspace = meta.hspace;
        }
        if (isString(meta.borderstyle)) {
          data.borderstyle = meta.borderstyle;
        }
      }
    };
    var formFillFromMeta = function (info, api) {
      var data = api.getData();
      var meta = data.src.meta;
      if (meta !== undefined) {
        var newData = deepMerge({}, data);
        formFillFromMeta2(info, newData, meta);
        api.setData(newData);
      }
    };
    var calculateImageSize = function (helpers, info, state, api) {
      var data = api.getData();
      var url = data.src.value;
      var meta = data.src.meta || {};
      if (!meta.width && !meta.height && info.hasDimensions) {
        if (isNotEmpty(url)) {
          helpers.imageSize(url).then(function (size) {
            if (state.open) {
              api.setData({ dimensions: size });
            }
          }).catch(function (e) {
            return console.error(e);
          });
        } else {
          api.setData({
            dimensions: {
              width: '',
              height: ''
            }
          });
        }
      }
    };
    var updateImagesDropdown = function (info, state, api) {
      var data = api.getData();
      var image = ListUtils.findEntry(info.imageList, data.src.value);
      state.prevImage = image;
      api.setData({
        images: image.map(function (entry) {
          return entry.value;
        }).getOr('')
      });
    };
    var changeSrc = function (helpers, info, state, api) {
      addPrependUrl(info, api);
      formFillFromMeta(info, api);
      calculateImageSize(helpers, info, state, api);
      updateImagesDropdown(info, state, api);
    };
    var changeImages = function (helpers, info, state, api) {
      var data = api.getData();
      var image = ListUtils.findEntry(info.imageList, data.images);
      image.each(function (img) {
        var updateAlt = data.alt === '' || state.prevImage.map(function (image) {
          return image.text === data.alt;
        }).getOr(false);
        if (updateAlt) {
          if (img.value === '') {
            api.setData({
              src: img,
              alt: state.prevAlt
            });
          } else {
            api.setData({
              src: img,
              alt: img.text
            });
          }
        } else {
          api.setData({ src: img });
        }
      });
      state.prevImage = image;
      changeSrc(helpers, info, state, api);
    };
    var calcVSpace = function (css) {
      var matchingTopBottom = css['margin-top'] && css['margin-bottom'] && css['margin-top'] === css['margin-bottom'];
      return matchingTopBottom ? removePixelSuffix(String(css['margin-top'])) : '';
    };
    var calcHSpace = function (css) {
      var matchingLeftRight = css['margin-right'] && css['margin-left'] && css['margin-right'] === css['margin-left'];
      return matchingLeftRight ? removePixelSuffix(String(css['margin-right'])) : '';
    };
    var calcBorderWidth = function (css) {
      return css['border-width'] ? removePixelSuffix(String(css['border-width'])) : '';
    };
    var calcBorderStyle = function (css) {
      return css['border-style'] ? String(css['border-style']) : '';
    };
    var calcStyle = function (parseStyle, serializeStyle, css) {
      return serializeStyle(parseStyle(serializeStyle(css)));
    };
    var changeStyle2 = function (parseStyle, serializeStyle, data) {
      var css = mergeMargins(parseStyle(data.style));
      var dataCopy = deepMerge({}, data);
      dataCopy.vspace = calcVSpace(css);
      dataCopy.hspace = calcHSpace(css);
      dataCopy.border = calcBorderWidth(css);
      dataCopy.borderstyle = calcBorderStyle(css);
      dataCopy.style = calcStyle(parseStyle, serializeStyle, css);
      return dataCopy;
    };
    var changeStyle = function (helpers, api) {
      var data = api.getData();
      var newData = changeStyle2(helpers.parseStyle, helpers.serializeStyle, data);
      api.setData(newData);
    };
    var changeAStyle = function (helpers, info, api) {
      var data = deepMerge(fromImageData(info.image), api.getData());
      var style = getStyleValue(helpers.normalizeCss, toImageData(data, false));
      api.setData({ style: style });
    };
    var changeFileInput = function (helpers, info, state, api) {
      var data = api.getData();
      api.block('Uploading image');
      head(data.fileinput).fold(function () {
        api.unblock();
      }, function (file) {
        var blobUri = URL.createObjectURL(file);
        var finalize = function () {
          api.unblock();
          URL.revokeObjectURL(blobUri);
        };
        var updateSrcAndSwitchTab = function (url) {
          api.setData({
            src: {
              value: url,
              meta: {}
            }
          });
          api.showTab('general');
          changeSrc(helpers, info, state, api);
        };
        blobToDataUri(file).then(function (dataUrl) {
          var blobInfo = helpers.createBlobCache(file, blobUri, dataUrl);
          if (info.automaticUploads) {
            helpers.uploadImage(blobInfo).then(function (result) {
              updateSrcAndSwitchTab(result.url);
              finalize();
            }).catch(function (err) {
              finalize();
              helpers.alertErr(err);
            });
          } else {
            helpers.addToBlobCache(blobInfo);
            updateSrcAndSwitchTab(blobInfo.blobUri());
            api.unblock();
          }
        });
      });
    };
    var changeHandler = function (helpers, info, state) {
      return function (api, evt) {
        if (evt.name === 'src') {
          changeSrc(helpers, info, state, api);
        } else if (evt.name === 'images') {
          changeImages(helpers, info, state, api);
        } else if (evt.name === 'alt') {
          state.prevAlt = api.getData().alt;
        } else if (evt.name === 'style') {
          changeStyle(helpers, api);
        } else if (evt.name === 'vspace' || evt.name === 'hspace' || evt.name === 'border' || evt.name === 'borderstyle') {
          changeAStyle(helpers, info, api);
        } else if (evt.name === 'fileinput') {
          changeFileInput(helpers, info, state, api);
        } else if (evt.name === 'isDecorative') {
          if (api.getData().isDecorative) {
            api.disable('alt');
          } else {
            api.enable('alt');
          }
        }
      };
    };
    var closeHandler = function (state) {
      return function () {
        state.open = false;
      };
    };
    var makeDialogBody = function (info) {
      if (info.hasAdvTab || info.hasUploadUrl || info.hasUploadHandler) {
        var tabPanel = {
          type: 'tabpanel',
          tabs: flatten([
            [MainTab.makeTab(info)],
            info.hasAdvTab ? [AdvTab.makeTab(info)] : [],
            info.hasUploadTab && (info.hasUploadUrl || info.hasUploadHandler) ? [UploadTab.makeTab(info)] : []
          ])
        };
        return tabPanel;
      } else {
        var panel = {
          type: 'panel',
          items: MainTab.makeItems(info)
        };
        return panel;
      }
    };
    var makeDialog = function (helpers) {
      return function (info) {
        var state = createState(info);
        return {
          title: 'Insert/Edit Image',
          size: 'normal',
          body: makeDialogBody(info),
          buttons: [
            {
              type: 'cancel',
              name: 'cancel',
              text: 'Cancel'
            },
            {
              type: 'submit',
              name: 'save',
              text: 'Save',
              primary: true
            }
          ],
          initialData: fromImageData(info.image),
          onSubmit: helpers.onSubmit(info),
          onChange: changeHandler(helpers, info, state),
          onClose: closeHandler(state)
        };
      };
    };
    var submitHandler = function (editor) {
      return function (info) {
        return function (api) {
          var data = deepMerge(fromImageData(info.image), api.getData());
          editor.execCommand('mceUpdateImage', false, toImageData(data, info.hasAccessibilityOptions));
          editor.editorUpload.uploadImagesAuto();
          api.close();
        };
      };
    };
    var imageSize = function (editor) {
      return function (url) {
        if (!isSafeImageUrl(editor, url)) {
          return global$4.resolve({
            width: '',
            height: ''
          });
        } else {
          return getImageSize(editor.documentBaseURI.toAbsolute(url)).then(function (dimensions) {
            return {
              width: String(dimensions.width),
              height: String(dimensions.height)
            };
          });
        }
      };
    };
    var createBlobCache = function (editor) {
      return function (file, blobUri, dataUrl) {
        return editor.editorUpload.blobCache.create({
          blob: file,
          blobUri: blobUri,
          name: file.name ? file.name.replace(/\.[^\.]+$/, '') : null,
          filename: file.name,
          base64: dataUrl.split(',')[1]
        });
      };
    };
    var addToBlobCache = function (editor) {
      return function (blobInfo) {
        editor.editorUpload.blobCache.add(blobInfo);
      };
    };
    var alertErr = function (editor) {
      return function (message) {
        editor.windowManager.alert(message);
      };
    };
    var normalizeCss = function (editor) {
      return function (cssText) {
        return normalizeCss$1(editor, cssText);
      };
    };
    var parseStyle = function (editor) {
      return function (cssText) {
        return editor.dom.parseStyle(cssText);
      };
    };
    var serializeStyle = function (editor) {
      return function (stylesArg, name) {
        return editor.dom.serializeStyle(stylesArg, name);
      };
    };
    var uploadImage = function (editor) {
      return function (blobInfo) {
        return global$1(editor).upload([blobInfo], false).then(function (results) {
          if (results.length === 0) {
            return global$4.reject('Failed to upload image');
          } else if (results[0].status === false) {
            return global$4.reject(results[0].error.message);
          } else {
            return results[0];
          }
        });
      };
    };
    var Dialog = function (editor) {
      var helpers = {
        onSubmit: submitHandler(editor),
        imageSize: imageSize(editor),
        addToBlobCache: addToBlobCache(editor),
        createBlobCache: createBlobCache(editor),
        alertErr: alertErr(editor),
        normalizeCss: normalizeCss(editor),
        parseStyle: parseStyle(editor),
        serializeStyle: serializeStyle(editor),
        uploadImage: uploadImage(editor)
      };
      var open = function () {
        collect(editor).then(makeDialog(helpers)).then(editor.windowManager.open);
      };
      return { open: open };
    };

    var register$1 = function (editor) {
      editor.addCommand('mceImage', Dialog(editor).open);
      editor.addCommand('mceUpdateImage', function (_ui, data) {
        editor.undoManager.transact(function () {
          return insertOrUpdateImage(editor, data);
        });
      });
    };

    var hasImageClass = function (node) {
      var className = node.attr('class');
      return className && /\bimage\b/.test(className);
    };
    var toggleContentEditableState = function (state) {
      return function (nodes) {
        var i = nodes.length;
        var toggleContentEditable = function (node) {
          node.attr('contenteditable', state ? 'true' : null);
        };
        while (i--) {
          var node = nodes[i];
          if (hasImageClass(node)) {
            node.attr('contenteditable', state ? 'false' : null);
            global.each(node.getAll('figcaption'), toggleContentEditable);
          }
        }
      };
    };
    var setup = function (editor) {
      editor.on('PreInit', function () {
        editor.parser.addNodeFilter('figure', toggleContentEditableState(true));
        editor.serializer.addNodeFilter('figure', toggleContentEditableState(false));
      });
    };

    var register = function (editor) {
      editor.ui.registry.addToggleButton('image', {
        icon: 'image',
        tooltip: 'Insert/edit image',
        onAction: Dialog(editor).open,
        onSetup: function (buttonApi) {
          buttonApi.setActive(isNonNullable(getSelectedImage(editor)));
          return editor.selection.selectorChangedWithUnbind('img:not([data-mce-object],[data-mce-placeholder]),figure.image', buttonApi.setActive).unbind;
        }
      });
      editor.ui.registry.addMenuItem('image', {
        icon: 'image',
        text: 'Image...',
        onAction: Dialog(editor).open
      });
      editor.ui.registry.addContextMenu('image', {
        update: function (element) {
          return isFigure(element) || isImage(element) && !isPlaceholderImage(element) ? ['image'] : [];
        }
      });
    };

    function Plugin () {
      global$6.add('image', function (editor) {
        setup(editor);
        register(editor);
        register$1(editor);
      });
    }

    Plugin();

}());


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "insertdatetime" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/insertdatetime')
//   ES2015:
//     import 'tinymce/plugins/insertdatetime'
__webpack_require__(1495);

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 *
 * Version: 5.10.5 (2022-05-25)
 */
(function () {
    'use strict';

    var global$1 = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var getDateFormat = function (editor) {
      return editor.getParam('insertdatetime_dateformat', editor.translate('%Y-%m-%d'));
    };
    var getTimeFormat = function (editor) {
      return editor.getParam('insertdatetime_timeformat', editor.translate('%H:%M:%S'));
    };
    var getFormats = function (editor) {
      return editor.getParam('insertdatetime_formats', [
        '%H:%M:%S',
        '%Y-%m-%d',
        '%I:%M:%S %p',
        '%D'
      ]);
    };
    var getDefaultDateTime = function (editor) {
      var formats = getFormats(editor);
      return formats.length > 0 ? formats[0] : getTimeFormat(editor);
    };
    var shouldInsertTimeElement = function (editor) {
      return editor.getParam('insertdatetime_element', false);
    };

    var daysShort = 'Sun Mon Tue Wed Thu Fri Sat Sun'.split(' ');
    var daysLong = 'Sunday Monday Tuesday Wednesday Thursday Friday Saturday Sunday'.split(' ');
    var monthsShort = 'Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec'.split(' ');
    var monthsLong = 'January February March April May June July August September October November December'.split(' ');
    var addZeros = function (value, len) {
      value = '' + value;
      if (value.length < len) {
        for (var i = 0; i < len - value.length; i++) {
          value = '0' + value;
        }
      }
      return value;
    };
    var getDateTime = function (editor, fmt, date) {
      if (date === void 0) {
        date = new Date();
      }
      fmt = fmt.replace('%D', '%m/%d/%Y');
      fmt = fmt.replace('%r', '%I:%M:%S %p');
      fmt = fmt.replace('%Y', '' + date.getFullYear());
      fmt = fmt.replace('%y', '' + date.getYear());
      fmt = fmt.replace('%m', addZeros(date.getMonth() + 1, 2));
      fmt = fmt.replace('%d', addZeros(date.getDate(), 2));
      fmt = fmt.replace('%H', '' + addZeros(date.getHours(), 2));
      fmt = fmt.replace('%M', '' + addZeros(date.getMinutes(), 2));
      fmt = fmt.replace('%S', '' + addZeros(date.getSeconds(), 2));
      fmt = fmt.replace('%I', '' + ((date.getHours() + 11) % 12 + 1));
      fmt = fmt.replace('%p', '' + (date.getHours() < 12 ? 'AM' : 'PM'));
      fmt = fmt.replace('%B', '' + editor.translate(monthsLong[date.getMonth()]));
      fmt = fmt.replace('%b', '' + editor.translate(monthsShort[date.getMonth()]));
      fmt = fmt.replace('%A', '' + editor.translate(daysLong[date.getDay()]));
      fmt = fmt.replace('%a', '' + editor.translate(daysShort[date.getDay()]));
      fmt = fmt.replace('%%', '%');
      return fmt;
    };
    var updateElement = function (editor, timeElm, computerTime, userTime) {
      var newTimeElm = editor.dom.create('time', { datetime: computerTime }, userTime);
      timeElm.parentNode.insertBefore(newTimeElm, timeElm);
      editor.dom.remove(timeElm);
      editor.selection.select(newTimeElm, true);
      editor.selection.collapse(false);
    };
    var insertDateTime = function (editor, format) {
      if (shouldInsertTimeElement(editor)) {
        var userTime = getDateTime(editor, format);
        var computerTime = void 0;
        if (/%[HMSIp]/.test(format)) {
          computerTime = getDateTime(editor, '%Y-%m-%dT%H:%M');
        } else {
          computerTime = getDateTime(editor, '%Y-%m-%d');
        }
        var timeElm = editor.dom.getParent(editor.selection.getStart(), 'time');
        if (timeElm) {
          updateElement(editor, timeElm, computerTime, userTime);
        } else {
          editor.insertContent('<time datetime="' + computerTime + '">' + userTime + '</time>');
        }
      } else {
        editor.insertContent(getDateTime(editor, format));
      }
    };

    var register$1 = function (editor) {
      editor.addCommand('mceInsertDate', function (_ui, value) {
        insertDateTime(editor, value !== null && value !== void 0 ? value : getDateFormat(editor));
      });
      editor.addCommand('mceInsertTime', function (_ui, value) {
        insertDateTime(editor, value !== null && value !== void 0 ? value : getTimeFormat(editor));
      });
    };

    var Cell = function (initial) {
      var value = initial;
      var get = function () {
        return value;
      };
      var set = function (v) {
        value = v;
      };
      return {
        get: get,
        set: set
      };
    };

    var global = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var register = function (editor) {
      var formats = getFormats(editor);
      var defaultFormat = Cell(getDefaultDateTime(editor));
      var insertDateTime = function (format) {
        return editor.execCommand('mceInsertDate', false, format);
      };
      editor.ui.registry.addSplitButton('insertdatetime', {
        icon: 'insert-time',
        tooltip: 'Insert date/time',
        select: function (value) {
          return value === defaultFormat.get();
        },
        fetch: function (done) {
          done(global.map(formats, function (format) {
            return {
              type: 'choiceitem',
              text: getDateTime(editor, format),
              value: format
            };
          }));
        },
        onAction: function (_api) {
          insertDateTime(defaultFormat.get());
        },
        onItemAction: function (_api, value) {
          defaultFormat.set(value);
          insertDateTime(value);
        }
      });
      var makeMenuItemHandler = function (format) {
        return function () {
          defaultFormat.set(format);
          insertDateTime(format);
        };
      };
      editor.ui.registry.addNestedMenuItem('insertdatetime', {
        icon: 'insert-time',
        text: 'Date/time',
        getSubmenuItems: function () {
          return global.map(formats, function (format) {
            return {
              type: 'menuitem',
              text: getDateTime(editor, format),
              onAction: makeMenuItemHandler(format)
            };
          });
        }
      });
    };

    function Plugin () {
      global$1.add('insertdatetime', function (editor) {
        register$1(editor);
        register(editor);
      });
    }

    Plugin();

}());


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "link" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/link')
//   ES2015:
//     import 'tinymce/plugins/link'
__webpack_require__(1497);

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 *
 * Version: 5.10.5 (2022-05-25)
 */
(function () {
    'use strict';

    var global$7 = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$6 = tinymce.util.Tools.resolve('tinymce.util.VK');

    var typeOf = function (x) {
      var t = typeof x;
      if (x === null) {
        return 'null';
      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
        return 'array';
      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
        return 'string';
      } else {
        return t;
      }
    };
    var isType = function (type) {
      return function (value) {
        return typeOf(value) === type;
      };
    };
    var isSimpleType = function (type) {
      return function (value) {
        return typeof value === type;
      };
    };
    var eq = function (t) {
      return function (a) {
        return t === a;
      };
    };
    var isString = isType('string');
    var isArray = isType('array');
    var isNull = eq(null);
    var isBoolean = isSimpleType('boolean');
    var isFunction = isSimpleType('function');

    var noop = function () {
    };
    var constant = function (value) {
      return function () {
        return value;
      };
    };
    var identity = function (x) {
      return x;
    };
    var tripleEquals = function (a, b) {
      return a === b;
    };
    var never = constant(false);
    var always = constant(true);

    var none = function () {
      return NONE;
    };
    var NONE = function () {
      var call = function (thunk) {
        return thunk();
      };
      var id = identity;
      var me = {
        fold: function (n, _s) {
          return n();
        },
        isSome: never,
        isNone: always,
        getOr: id,
        getOrThunk: call,
        getOrDie: function (msg) {
          throw new Error(msg || 'error: getOrDie called on none.');
        },
        getOrNull: constant(null),
        getOrUndefined: constant(undefined),
        or: id,
        orThunk: call,
        map: none,
        each: noop,
        bind: none,
        exists: never,
        forall: always,
        filter: function () {
          return none();
        },
        toArray: function () {
          return [];
        },
        toString: constant('none()')
      };
      return me;
    }();
    var some = function (a) {
      var constant_a = constant(a);
      var self = function () {
        return me;
      };
      var bind = function (f) {
        return f(a);
      };
      var me = {
        fold: function (n, s) {
          return s(a);
        },
        isSome: always,
        isNone: never,
        getOr: constant_a,
        getOrThunk: constant_a,
        getOrDie: constant_a,
        getOrNull: constant_a,
        getOrUndefined: constant_a,
        or: self,
        orThunk: self,
        map: function (f) {
          return some(f(a));
        },
        each: function (f) {
          f(a);
        },
        bind: bind,
        exists: bind,
        forall: bind,
        filter: function (f) {
          return f(a) ? me : NONE;
        },
        toArray: function () {
          return [a];
        },
        toString: function () {
          return 'some(' + a + ')';
        }
      };
      return me;
    };
    var from = function (value) {
      return value === null || value === undefined ? NONE : some(value);
    };
    var Optional = {
      some: some,
      none: none,
      from: from
    };

    var nativeIndexOf = Array.prototype.indexOf;
    var nativePush = Array.prototype.push;
    var rawIndexOf = function (ts, t) {
      return nativeIndexOf.call(ts, t);
    };
    var contains = function (xs, x) {
      return rawIndexOf(xs, x) > -1;
    };
    var map = function (xs, f) {
      var len = xs.length;
      var r = new Array(len);
      for (var i = 0; i < len; i++) {
        var x = xs[i];
        r[i] = f(x, i);
      }
      return r;
    };
    var each$1 = function (xs, f) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        f(x, i);
      }
    };
    var foldl = function (xs, f, acc) {
      each$1(xs, function (x, i) {
        acc = f(acc, x, i);
      });
      return acc;
    };
    var flatten = function (xs) {
      var r = [];
      for (var i = 0, len = xs.length; i < len; ++i) {
        if (!isArray(xs[i])) {
          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
        }
        nativePush.apply(r, xs[i]);
      }
      return r;
    };
    var bind = function (xs, f) {
      return flatten(map(xs, f));
    };
    var findMap = function (arr, f) {
      for (var i = 0; i < arr.length; i++) {
        var r = f(arr[i], i);
        if (r.isSome()) {
          return r;
        }
      }
      return Optional.none();
    };

    var is = function (lhs, rhs, comparator) {
      if (comparator === void 0) {
        comparator = tripleEquals;
      }
      return lhs.exists(function (left) {
        return comparator(left, rhs);
      });
    };
    var cat = function (arr) {
      var r = [];
      var push = function (x) {
        r.push(x);
      };
      for (var i = 0; i < arr.length; i++) {
        arr[i].each(push);
      }
      return r;
    };
    var someIf = function (b, a) {
      return b ? Optional.some(a) : Optional.none();
    };

    var assumeExternalTargets = function (editor) {
      var externalTargets = editor.getParam('link_assume_external_targets', false);
      if (isBoolean(externalTargets) && externalTargets) {
        return 1;
      } else if (isString(externalTargets) && (externalTargets === 'http' || externalTargets === 'https')) {
        return externalTargets;
      }
      return 0;
    };
    var hasContextToolbar = function (editor) {
      return editor.getParam('link_context_toolbar', false, 'boolean');
    };
    var getLinkList = function (editor) {
      return editor.getParam('link_list');
    };
    var getDefaultLinkTarget = function (editor) {
      return editor.getParam('default_link_target');
    };
    var getTargetList = function (editor) {
      return editor.getParam('target_list', true);
    };
    var getRelList = function (editor) {
      return editor.getParam('rel_list', [], 'array');
    };
    var getLinkClassList = function (editor) {
      return editor.getParam('link_class_list', [], 'array');
    };
    var shouldShowLinkTitle = function (editor) {
      return editor.getParam('link_title', true, 'boolean');
    };
    var allowUnsafeLinkTarget = function (editor) {
      return editor.getParam('allow_unsafe_link_target', false, 'boolean');
    };
    var useQuickLink = function (editor) {
      return editor.getParam('link_quicklink', false, 'boolean');
    };
    var getDefaultLinkProtocol = function (editor) {
      return editor.getParam('link_default_protocol', 'http', 'string');
    };

    var global$5 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var getValue = function (item) {
      return isString(item.value) ? item.value : '';
    };
    var getText = function (item) {
      if (isString(item.text)) {
        return item.text;
      } else if (isString(item.title)) {
        return item.title;
      } else {
        return '';
      }
    };
    var sanitizeList = function (list, extractValue) {
      var out = [];
      global$5.each(list, function (item) {
        var text = getText(item);
        if (item.menu !== undefined) {
          var items = sanitizeList(item.menu, extractValue);
          out.push({
            text: text,
            items: items
          });
        } else {
          var value = extractValue(item);
          out.push({
            text: text,
            value: value
          });
        }
      });
      return out;
    };
    var sanitizeWith = function (extracter) {
      if (extracter === void 0) {
        extracter = getValue;
      }
      return function (list) {
        return Optional.from(list).map(function (list) {
          return sanitizeList(list, extracter);
        });
      };
    };
    var sanitize = function (list) {
      return sanitizeWith(getValue)(list);
    };
    var createUi = function (name, label) {
      return function (items) {
        return {
          name: name,
          type: 'listbox',
          label: label,
          items: items
        };
      };
    };
    var ListOptions = {
      sanitize: sanitize,
      sanitizeWith: sanitizeWith,
      createUi: createUi,
      getValue: getValue
    };

    var __assign = function () {
      __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };

    var keys = Object.keys;
    var hasOwnProperty = Object.hasOwnProperty;
    var each = function (obj, f) {
      var props = keys(obj);
      for (var k = 0, len = props.length; k < len; k++) {
        var i = props[k];
        var x = obj[i];
        f(x, i);
      }
    };
    var objAcc = function (r) {
      return function (x, i) {
        r[i] = x;
      };
    };
    var internalFilter = function (obj, pred, onTrue, onFalse) {
      var r = {};
      each(obj, function (x, i) {
        (pred(x, i) ? onTrue : onFalse)(x, i);
      });
      return r;
    };
    var filter = function (obj, pred) {
      var t = {};
      internalFilter(obj, pred, objAcc(t), noop);
      return t;
    };
    var has = function (obj, key) {
      return hasOwnProperty.call(obj, key);
    };
    var hasNonNullableKey = function (obj, key) {
      return has(obj, key) && obj[key] !== undefined && obj[key] !== null;
    };

    var global$4 = tinymce.util.Tools.resolve('tinymce.dom.TreeWalker');

    var global$3 = tinymce.util.Tools.resolve('tinymce.util.URI');

    var isAnchor = function (elm) {
      return elm && elm.nodeName.toLowerCase() === 'a';
    };
    var isLink = function (elm) {
      return isAnchor(elm) && !!getHref(elm);
    };
    var collectNodesInRange = function (rng, predicate) {
      if (rng.collapsed) {
        return [];
      } else {
        var contents = rng.cloneContents();
        var walker = new global$4(contents.firstChild, contents);
        var elements = [];
        var current = contents.firstChild;
        do {
          if (predicate(current)) {
            elements.push(current);
          }
        } while (current = walker.next());
        return elements;
      }
    };
    var hasProtocol = function (url) {
      return /^\w+:/i.test(url);
    };
    var getHref = function (elm) {
      var href = elm.getAttribute('data-mce-href');
      return href ? href : elm.getAttribute('href');
    };
    var applyRelTargetRules = function (rel, isUnsafe) {
      var rules = ['noopener'];
      var rels = rel ? rel.split(/\s+/) : [];
      var toString = function (rels) {
        return global$5.trim(rels.sort().join(' '));
      };
      var addTargetRules = function (rels) {
        rels = removeTargetRules(rels);
        return rels.length > 0 ? rels.concat(rules) : rules;
      };
      var removeTargetRules = function (rels) {
        return rels.filter(function (val) {
          return global$5.inArray(rules, val) === -1;
        });
      };
      var newRels = isUnsafe ? addTargetRules(rels) : removeTargetRules(rels);
      return newRels.length > 0 ? toString(newRels) : '';
    };
    var trimCaretContainers = function (text) {
      return text.replace(/\uFEFF/g, '');
    };
    var getAnchorElement = function (editor, selectedElm) {
      selectedElm = selectedElm || editor.selection.getNode();
      if (isImageFigure(selectedElm)) {
        return editor.dom.select('a[href]', selectedElm)[0];
      } else {
        return editor.dom.getParent(selectedElm, 'a[href]');
      }
    };
    var getAnchorText = function (selection, anchorElm) {
      var text = anchorElm ? anchorElm.innerText || anchorElm.textContent : selection.getContent({ format: 'text' });
      return trimCaretContainers(text);
    };
    var hasLinks = function (elements) {
      return global$5.grep(elements, isLink).length > 0;
    };
    var hasLinksInSelection = function (rng) {
      return collectNodesInRange(rng, isLink).length > 0;
    };
    var isOnlyTextSelected = function (editor) {
      var inlineTextElements = editor.schema.getTextInlineElements();
      var isElement = function (elm) {
        return elm.nodeType === 1 && !isAnchor(elm) && !has(inlineTextElements, elm.nodeName.toLowerCase());
      };
      var elements = collectNodesInRange(editor.selection.getRng(), isElement);
      return elements.length === 0;
    };
    var isImageFigure = function (elm) {
      return elm && elm.nodeName === 'FIGURE' && /\bimage\b/i.test(elm.className);
    };
    var getLinkAttrs = function (data) {
      var attrs = [
        'title',
        'rel',
        'class',
        'target'
      ];
      return foldl(attrs, function (acc, key) {
        data[key].each(function (value) {
          acc[key] = value.length > 0 ? value : null;
        });
        return acc;
      }, { href: data.href });
    };
    var handleExternalTargets = function (href, assumeExternalTargets) {
      if ((assumeExternalTargets === 'http' || assumeExternalTargets === 'https') && !hasProtocol(href)) {
        return assumeExternalTargets + '://' + href;
      }
      return href;
    };
    var applyLinkOverrides = function (editor, linkAttrs) {
      var newLinkAttrs = __assign({}, linkAttrs);
      if (!(getRelList(editor).length > 0) && allowUnsafeLinkTarget(editor) === false) {
        var newRel = applyRelTargetRules(newLinkAttrs.rel, newLinkAttrs.target === '_blank');
        newLinkAttrs.rel = newRel ? newRel : null;
      }
      if (Optional.from(newLinkAttrs.target).isNone() && getTargetList(editor) === false) {
        newLinkAttrs.target = getDefaultLinkTarget(editor);
      }
      newLinkAttrs.href = handleExternalTargets(newLinkAttrs.href, assumeExternalTargets(editor));
      return newLinkAttrs;
    };
    var updateLink = function (editor, anchorElm, text, linkAttrs) {
      text.each(function (text) {
        if (has(anchorElm, 'innerText')) {
          anchorElm.innerText = text;
        } else {
          anchorElm.textContent = text;
        }
      });
      editor.dom.setAttribs(anchorElm, linkAttrs);
      editor.selection.select(anchorElm);
    };
    var createLink = function (editor, selectedElm, text, linkAttrs) {
      if (isImageFigure(selectedElm)) {
        linkImageFigure(editor, selectedElm, linkAttrs);
      } else {
        text.fold(function () {
          editor.execCommand('mceInsertLink', false, linkAttrs);
        }, function (text) {
          editor.insertContent(editor.dom.createHTML('a', linkAttrs, editor.dom.encode(text)));
        });
      }
    };
    var linkDomMutation = function (editor, attachState, data) {
      var selectedElm = editor.selection.getNode();
      var anchorElm = getAnchorElement(editor, selectedElm);
      var linkAttrs = applyLinkOverrides(editor, getLinkAttrs(data));
      editor.undoManager.transact(function () {
        if (data.href === attachState.href) {
          attachState.attach();
        }
        if (anchorElm) {
          editor.focus();
          updateLink(editor, anchorElm, data.text, linkAttrs);
        } else {
          createLink(editor, selectedElm, data.text, linkAttrs);
        }
      });
    };
    var unlinkSelection = function (editor) {
      var dom = editor.dom, selection = editor.selection;
      var bookmark = selection.getBookmark();
      var rng = selection.getRng().cloneRange();
      var startAnchorElm = dom.getParent(rng.startContainer, 'a[href]', editor.getBody());
      var endAnchorElm = dom.getParent(rng.endContainer, 'a[href]', editor.getBody());
      if (startAnchorElm) {
        rng.setStartBefore(startAnchorElm);
      }
      if (endAnchorElm) {
        rng.setEndAfter(endAnchorElm);
      }
      selection.setRng(rng);
      editor.execCommand('unlink');
      selection.moveToBookmark(bookmark);
    };
    var unlinkDomMutation = function (editor) {
      editor.undoManager.transact(function () {
        var node = editor.selection.getNode();
        if (isImageFigure(node)) {
          unlinkImageFigure(editor, node);
        } else {
          unlinkSelection(editor);
        }
        editor.focus();
      });
    };
    var unwrapOptions = function (data) {
      var cls = data.class, href = data.href, rel = data.rel, target = data.target, text = data.text, title = data.title;
      return filter({
        class: cls.getOrNull(),
        href: href,
        rel: rel.getOrNull(),
        target: target.getOrNull(),
        text: text.getOrNull(),
        title: title.getOrNull()
      }, function (v, _k) {
        return isNull(v) === false;
      });
    };
    var sanitizeData = function (editor, data) {
      var href = data.href;
      return __assign(__assign({}, data), { href: global$3.isDomSafe(href, 'a', editor.settings) ? href : '' });
    };
    var link = function (editor, attachState, data) {
      var sanitizedData = sanitizeData(editor, data);
      editor.hasPlugin('rtc', true) ? editor.execCommand('createlink', false, unwrapOptions(sanitizedData)) : linkDomMutation(editor, attachState, sanitizedData);
    };
    var unlink = function (editor) {
      editor.hasPlugin('rtc', true) ? editor.execCommand('unlink') : unlinkDomMutation(editor);
    };
    var unlinkImageFigure = function (editor, fig) {
      var img = editor.dom.select('img', fig)[0];
      if (img) {
        var a = editor.dom.getParents(img, 'a[href]', fig)[0];
        if (a) {
          a.parentNode.insertBefore(img, a);
          editor.dom.remove(a);
        }
      }
    };
    var linkImageFigure = function (editor, fig, attrs) {
      var img = editor.dom.select('img', fig)[0];
      if (img) {
        var a = editor.dom.create('a', attrs);
        img.parentNode.insertBefore(a, img);
        a.appendChild(img);
      }
    };

    var isListGroup = function (item) {
      return hasNonNullableKey(item, 'items');
    };
    var findTextByValue = function (value, catalog) {
      return findMap(catalog, function (item) {
        if (isListGroup(item)) {
          return findTextByValue(value, item.items);
        } else {
          return someIf(item.value === value, item);
        }
      });
    };
    var getDelta = function (persistentText, fieldName, catalog, data) {
      var value = data[fieldName];
      var hasPersistentText = persistentText.length > 0;
      return value !== undefined ? findTextByValue(value, catalog).map(function (i) {
        return {
          url: {
            value: i.value,
            meta: {
              text: hasPersistentText ? persistentText : i.text,
              attach: noop
            }
          },
          text: hasPersistentText ? persistentText : i.text
        };
      }) : Optional.none();
    };
    var findCatalog = function (catalogs, fieldName) {
      if (fieldName === 'link') {
        return catalogs.link;
      } else if (fieldName === 'anchor') {
        return catalogs.anchor;
      } else {
        return Optional.none();
      }
    };
    var init = function (initialData, linkCatalog) {
      var persistentData = {
        text: initialData.text,
        title: initialData.title
      };
      var getTitleFromUrlChange = function (url) {
        return someIf(persistentData.title.length <= 0, Optional.from(url.meta.title).getOr(''));
      };
      var getTextFromUrlChange = function (url) {
        return someIf(persistentData.text.length <= 0, Optional.from(url.meta.text).getOr(url.value));
      };
      var onUrlChange = function (data) {
        var text = getTextFromUrlChange(data.url);
        var title = getTitleFromUrlChange(data.url);
        if (text.isSome() || title.isSome()) {
          return Optional.some(__assign(__assign({}, text.map(function (text) {
            return { text: text };
          }).getOr({})), title.map(function (title) {
            return { title: title };
          }).getOr({})));
        } else {
          return Optional.none();
        }
      };
      var onCatalogChange = function (data, change) {
        var catalog = findCatalog(linkCatalog, change.name).getOr([]);
        return getDelta(persistentData.text, change.name, catalog, data);
      };
      var onChange = function (getData, change) {
        var name = change.name;
        if (name === 'url') {
          return onUrlChange(getData());
        } else if (contains([
            'anchor',
            'link'
          ], name)) {
          return onCatalogChange(getData(), change);
        } else if (name === 'text' || name === 'title') {
          persistentData[name] = getData()[name];
          return Optional.none();
        } else {
          return Optional.none();
        }
      };
      return { onChange: onChange };
    };
    var DialogChanges = {
      init: init,
      getDelta: getDelta
    };

    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Delay');

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Promise');

    var delayedConfirm = function (editor, message, callback) {
      var rng = editor.selection.getRng();
      global$2.setEditorTimeout(editor, function () {
        editor.windowManager.confirm(message, function (state) {
          editor.selection.setRng(rng);
          callback(state);
        });
      });
    };
    var tryEmailTransform = function (data) {
      var url = data.href;
      var suggestMailTo = url.indexOf('@') > 0 && url.indexOf('/') === -1 && url.indexOf('mailto:') === -1;
      return suggestMailTo ? Optional.some({
        message: 'The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?',
        preprocess: function (oldData) {
          return __assign(__assign({}, oldData), { href: 'mailto:' + url });
        }
      }) : Optional.none();
    };
    var tryProtocolTransform = function (assumeExternalTargets, defaultLinkProtocol) {
      return function (data) {
        var url = data.href;
        var suggestProtocol = assumeExternalTargets === 1 && !hasProtocol(url) || assumeExternalTargets === 0 && /^\s*www(\.|\d\.)/i.test(url);
        return suggestProtocol ? Optional.some({
          message: 'The URL you entered seems to be an external link. Do you want to add the required ' + defaultLinkProtocol + ':// prefix?',
          preprocess: function (oldData) {
            return __assign(__assign({}, oldData), { href: defaultLinkProtocol + '://' + url });
          }
        }) : Optional.none();
      };
    };
    var preprocess = function (editor, data) {
      return findMap([
        tryEmailTransform,
        tryProtocolTransform(assumeExternalTargets(editor), getDefaultLinkProtocol(editor))
      ], function (f) {
        return f(data);
      }).fold(function () {
        return global$1.resolve(data);
      }, function (transform) {
        return new global$1(function (callback) {
          delayedConfirm(editor, transform.message, function (state) {
            callback(state ? transform.preprocess(data) : data);
          });
        });
      });
    };
    var DialogConfirms = { preprocess: preprocess };

    var getAnchors = function (editor) {
      var anchorNodes = editor.dom.select('a:not([href])');
      var anchors = bind(anchorNodes, function (anchor) {
        var id = anchor.name || anchor.id;
        return id ? [{
            text: id,
            value: '#' + id
          }] : [];
      });
      return anchors.length > 0 ? Optional.some([{
          text: 'None',
          value: ''
        }].concat(anchors)) : Optional.none();
    };
    var AnchorListOptions = { getAnchors: getAnchors };

    var getClasses = function (editor) {
      var list = getLinkClassList(editor);
      if (list.length > 0) {
        return ListOptions.sanitize(list);
      }
      return Optional.none();
    };
    var ClassListOptions = { getClasses: getClasses };

    var global = tinymce.util.Tools.resolve('tinymce.util.XHR');

    var parseJson = function (text) {
      try {
        return Optional.some(JSON.parse(text));
      } catch (err) {
        return Optional.none();
      }
    };
    var getLinks = function (editor) {
      var extractor = function (item) {
        return editor.convertURL(item.value || item.url, 'href');
      };
      var linkList = getLinkList(editor);
      return new global$1(function (callback) {
        if (isString(linkList)) {
          global.send({
            url: linkList,
            success: function (text) {
              return callback(parseJson(text));
            },
            error: function (_) {
              return callback(Optional.none());
            }
          });
        } else if (isFunction(linkList)) {
          linkList(function (output) {
            return callback(Optional.some(output));
          });
        } else {
          callback(Optional.from(linkList));
        }
      }).then(function (optItems) {
        return optItems.bind(ListOptions.sanitizeWith(extractor)).map(function (items) {
          if (items.length > 0) {
            var noneItem = [{
                text: 'None',
                value: ''
              }];
            return noneItem.concat(items);
          } else {
            return items;
          }
        });
      });
    };
    var LinkListOptions = { getLinks: getLinks };

    var getRels = function (editor, initialTarget) {
      var list = getRelList(editor);
      if (list.length > 0) {
        var isTargetBlank_1 = is(initialTarget, '_blank');
        var enforceSafe = allowUnsafeLinkTarget(editor) === false;
        var safeRelExtractor = function (item) {
          return applyRelTargetRules(ListOptions.getValue(item), isTargetBlank_1);
        };
        var sanitizer = enforceSafe ? ListOptions.sanitizeWith(safeRelExtractor) : ListOptions.sanitize;
        return sanitizer(list);
      }
      return Optional.none();
    };
    var RelOptions = { getRels: getRels };

    var fallbacks = [
      {
        text: 'Current window',
        value: ''
      },
      {
        text: 'New window',
        value: '_blank'
      }
    ];
    var getTargets = function (editor) {
      var list = getTargetList(editor);
      if (isArray(list)) {
        return ListOptions.sanitize(list).orThunk(function () {
          return Optional.some(fallbacks);
        });
      } else if (list === false) {
        return Optional.none();
      }
      return Optional.some(fallbacks);
    };
    var TargetOptions = { getTargets: getTargets };

    var nonEmptyAttr = function (dom, elem, name) {
      var val = dom.getAttrib(elem, name);
      return val !== null && val.length > 0 ? Optional.some(val) : Optional.none();
    };
    var extractFromAnchor = function (editor, anchor) {
      var dom = editor.dom;
      var onlyText = isOnlyTextSelected(editor);
      var text = onlyText ? Optional.some(getAnchorText(editor.selection, anchor)) : Optional.none();
      var url = anchor ? Optional.some(dom.getAttrib(anchor, 'href')) : Optional.none();
      var target = anchor ? Optional.from(dom.getAttrib(anchor, 'target')) : Optional.none();
      var rel = nonEmptyAttr(dom, anchor, 'rel');
      var linkClass = nonEmptyAttr(dom, anchor, 'class');
      var title = nonEmptyAttr(dom, anchor, 'title');
      return {
        url: url,
        text: text,
        title: title,
        target: target,
        rel: rel,
        linkClass: linkClass
      };
    };
    var collect = function (editor, linkNode) {
      return LinkListOptions.getLinks(editor).then(function (links) {
        var anchor = extractFromAnchor(editor, linkNode);
        return {
          anchor: anchor,
          catalogs: {
            targets: TargetOptions.getTargets(editor),
            rels: RelOptions.getRels(editor, anchor.target),
            classes: ClassListOptions.getClasses(editor),
            anchor: AnchorListOptions.getAnchors(editor),
            link: links
          },
          optNode: Optional.from(linkNode),
          flags: { titleEnabled: shouldShowLinkTitle(editor) }
        };
      });
    };
    var DialogInfo = { collect: collect };

    var handleSubmit = function (editor, info) {
      return function (api) {
        var data = api.getData();
        if (!data.url.value) {
          unlink(editor);
          api.close();
          return;
        }
        var getChangedValue = function (key) {
          return Optional.from(data[key]).filter(function (value) {
            return !is(info.anchor[key], value);
          });
        };
        var changedData = {
          href: data.url.value,
          text: getChangedValue('text'),
          target: getChangedValue('target'),
          rel: getChangedValue('rel'),
          class: getChangedValue('linkClass'),
          title: getChangedValue('title')
        };
        var attachState = {
          href: data.url.value,
          attach: data.url.meta !== undefined && data.url.meta.attach ? data.url.meta.attach : noop
        };
        DialogConfirms.preprocess(editor, changedData).then(function (pData) {
          link(editor, attachState, pData);
        });
        api.close();
      };
    };
    var collectData = function (editor) {
      var anchorNode = getAnchorElement(editor);
      return DialogInfo.collect(editor, anchorNode);
    };
    var getInitialData = function (info, defaultTarget) {
      var anchor = info.anchor;
      var url = anchor.url.getOr('');
      return {
        url: {
          value: url,
          meta: { original: { value: url } }
        },
        text: anchor.text.getOr(''),
        title: anchor.title.getOr(''),
        anchor: url,
        link: url,
        rel: anchor.rel.getOr(''),
        target: anchor.target.or(defaultTarget).getOr(''),
        linkClass: anchor.linkClass.getOr('')
      };
    };
    var makeDialog = function (settings, onSubmit, editor) {
      var urlInput = [{
          name: 'url',
          type: 'urlinput',
          filetype: 'file',
          label: 'URL'
        }];
      var displayText = settings.anchor.text.map(function () {
        return {
          name: 'text',
          type: 'input',
          label: 'Text to display'
        };
      }).toArray();
      var titleText = settings.flags.titleEnabled ? [{
          name: 'title',
          type: 'input',
          label: 'Title'
        }] : [];
      var defaultTarget = Optional.from(getDefaultLinkTarget(editor));
      var initialData = getInitialData(settings, defaultTarget);
      var catalogs = settings.catalogs;
      var dialogDelta = DialogChanges.init(initialData, catalogs);
      var body = {
        type: 'panel',
        items: flatten([
          urlInput,
          displayText,
          titleText,
          cat([
            catalogs.anchor.map(ListOptions.createUi('anchor', 'Anchors')),
            catalogs.rels.map(ListOptions.createUi('rel', 'Rel')),
            catalogs.targets.map(ListOptions.createUi('target', 'Open link in...')),
            catalogs.link.map(ListOptions.createUi('link', 'Link list')),
            catalogs.classes.map(ListOptions.createUi('linkClass', 'Class'))
          ])
        ])
      };
      return {
        title: 'Insert/Edit Link',
        size: 'normal',
        body: body,
        buttons: [
          {
            type: 'cancel',
            name: 'cancel',
            text: 'Cancel'
          },
          {
            type: 'submit',
            name: 'save',
            text: 'Save',
            primary: true
          }
        ],
        initialData: initialData,
        onChange: function (api, _a) {
          var name = _a.name;
          dialogDelta.onChange(api.getData, { name: name }).each(function (newData) {
            api.setData(newData);
          });
        },
        onSubmit: onSubmit
      };
    };
    var open$1 = function (editor) {
      var data = collectData(editor);
      data.then(function (info) {
        var onSubmit = handleSubmit(editor, info);
        return makeDialog(info, onSubmit, editor);
      }).then(function (spec) {
        editor.windowManager.open(spec);
      });
    };

    var appendClickRemove = function (link, evt) {
      document.body.appendChild(link);
      link.dispatchEvent(evt);
      document.body.removeChild(link);
    };
    var open = function (url) {
      var link = document.createElement('a');
      link.target = '_blank';
      link.href = url;
      link.rel = 'noreferrer noopener';
      var evt = document.createEvent('MouseEvents');
      evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      appendClickRemove(link, evt);
    };

    var getLink = function (editor, elm) {
      return editor.dom.getParent(elm, 'a[href]');
    };
    var getSelectedLink = function (editor) {
      return getLink(editor, editor.selection.getStart());
    };
    var hasOnlyAltModifier = function (e) {
      return e.altKey === true && e.shiftKey === false && e.ctrlKey === false && e.metaKey === false;
    };
    var gotoLink = function (editor, a) {
      if (a) {
        var href = getHref(a);
        if (/^#/.test(href)) {
          var targetEl = editor.$(href);
          if (targetEl.length) {
            editor.selection.scrollIntoView(targetEl[0], true);
          }
        } else {
          open(a.href);
        }
      }
    };
    var openDialog = function (editor) {
      return function () {
        open$1(editor);
      };
    };
    var gotoSelectedLink = function (editor) {
      return function () {
        gotoLink(editor, getSelectedLink(editor));
      };
    };
    var setupGotoLinks = function (editor) {
      editor.on('click', function (e) {
        var link = getLink(editor, e.target);
        if (link && global$6.metaKeyPressed(e)) {
          e.preventDefault();
          gotoLink(editor, link);
        }
      });
      editor.on('keydown', function (e) {
        var link = getSelectedLink(editor);
        if (link && e.keyCode === 13 && hasOnlyAltModifier(e)) {
          e.preventDefault();
          gotoLink(editor, link);
        }
      });
    };
    var toggleState = function (editor, toggler) {
      editor.on('NodeChange', toggler);
      return function () {
        return editor.off('NodeChange', toggler);
      };
    };
    var toggleActiveState = function (editor) {
      return function (api) {
        var updateState = function () {
          return api.setActive(!editor.mode.isReadOnly() && getAnchorElement(editor, editor.selection.getNode()) !== null);
        };
        updateState();
        return toggleState(editor, updateState);
      };
    };
    var toggleEnabledState = function (editor) {
      return function (api) {
        var updateState = function () {
          return api.setDisabled(getAnchorElement(editor, editor.selection.getNode()) === null);
        };
        updateState();
        return toggleState(editor, updateState);
      };
    };
    var toggleUnlinkState = function (editor) {
      return function (api) {
        var hasLinks$1 = function (parents) {
          return hasLinks(parents) || hasLinksInSelection(editor.selection.getRng());
        };
        var parents = editor.dom.getParents(editor.selection.getStart());
        api.setDisabled(!hasLinks$1(parents));
        return toggleState(editor, function (e) {
          return api.setDisabled(!hasLinks$1(e.parents));
        });
      };
    };

    var register = function (editor) {
      editor.addCommand('mceLink', function () {
        if (useQuickLink(editor)) {
          editor.fire('contexttoolbar-show', { toolbarKey: 'quicklink' });
        } else {
          openDialog(editor)();
        }
      });
    };

    var setup = function (editor) {
      editor.addShortcut('Meta+K', '', function () {
        editor.execCommand('mceLink');
      });
    };

    var setupButtons = function (editor) {
      editor.ui.registry.addToggleButton('link', {
        icon: 'link',
        tooltip: 'Insert/edit link',
        onAction: openDialog(editor),
        onSetup: toggleActiveState(editor)
      });
      editor.ui.registry.addButton('openlink', {
        icon: 'new-tab',
        tooltip: 'Open link',
        onAction: gotoSelectedLink(editor),
        onSetup: toggleEnabledState(editor)
      });
      editor.ui.registry.addButton('unlink', {
        icon: 'unlink',
        tooltip: 'Remove link',
        onAction: function () {
          return unlink(editor);
        },
        onSetup: toggleUnlinkState(editor)
      });
    };
    var setupMenuItems = function (editor) {
      editor.ui.registry.addMenuItem('openlink', {
        text: 'Open link',
        icon: 'new-tab',
        onAction: gotoSelectedLink(editor),
        onSetup: toggleEnabledState(editor)
      });
      editor.ui.registry.addMenuItem('link', {
        icon: 'link',
        text: 'Link...',
        shortcut: 'Meta+K',
        onAction: openDialog(editor)
      });
      editor.ui.registry.addMenuItem('unlink', {
        icon: 'unlink',
        text: 'Remove link',
        onAction: function () {
          return unlink(editor);
        },
        onSetup: toggleUnlinkState(editor)
      });
    };
    var setupContextMenu = function (editor) {
      var inLink = 'link unlink openlink';
      var noLink = 'link';
      editor.ui.registry.addContextMenu('link', {
        update: function (element) {
          return hasLinks(editor.dom.getParents(element, 'a')) ? inLink : noLink;
        }
      });
    };
    var setupContextToolbars = function (editor) {
      var collapseSelectionToEnd = function (editor) {
        editor.selection.collapse(false);
      };
      var onSetupLink = function (buttonApi) {
        var node = editor.selection.getNode();
        buttonApi.setDisabled(!getAnchorElement(editor, node));
        return noop;
      };
      var getLinkText = function (value) {
        var anchor = getAnchorElement(editor);
        var onlyText = isOnlyTextSelected(editor);
        if (!anchor && onlyText) {
          var text = getAnchorText(editor.selection, anchor);
          return Optional.some(text.length > 0 ? text : value);
        } else {
          return Optional.none();
        }
      };
      editor.ui.registry.addContextForm('quicklink', {
        launch: {
          type: 'contextformtogglebutton',
          icon: 'link',
          tooltip: 'Link',
          onSetup: toggleActiveState(editor)
        },
        label: 'Link',
        predicate: function (node) {
          return !!getAnchorElement(editor, node) && hasContextToolbar(editor);
        },
        initValue: function () {
          var elm = getAnchorElement(editor);
          return !!elm ? getHref(elm) : '';
        },
        commands: [
          {
            type: 'contextformtogglebutton',
            icon: 'link',
            tooltip: 'Link',
            primary: true,
            onSetup: function (buttonApi) {
              var node = editor.selection.getNode();
              buttonApi.setActive(!!getAnchorElement(editor, node));
              return toggleActiveState(editor)(buttonApi);
            },
            onAction: function (formApi) {
              var value = formApi.getValue();
              var text = getLinkText(value);
              var attachState = {
                href: value,
                attach: noop
              };
              link(editor, attachState, {
                href: value,
                text: text,
                title: Optional.none(),
                rel: Optional.none(),
                target: Optional.none(),
                class: Optional.none()
              });
              collapseSelectionToEnd(editor);
              formApi.hide();
            }
          },
          {
            type: 'contextformbutton',
            icon: 'unlink',
            tooltip: 'Remove link',
            onSetup: onSetupLink,
            onAction: function (formApi) {
              unlink(editor);
              formApi.hide();
            }
          },
          {
            type: 'contextformbutton',
            icon: 'new-tab',
            tooltip: 'Open link',
            onSetup: onSetupLink,
            onAction: function (formApi) {
              gotoSelectedLink(editor)();
              formApi.hide();
            }
          }
        ]
      });
    };

    function Plugin () {
      global$7.add('link', function (editor) {
        setupButtons(editor);
        setupMenuItems(editor);
        setupContextMenu(editor);
        setupContextToolbars(editor);
        setupGotoLinks(editor);
        register(editor);
        setup(editor);
      });
    }

    Plugin();

}());


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "lists" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/lists')
//   ES2015:
//     import 'tinymce/plugins/lists'
__webpack_require__(1499);

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 *
 * Version: 5.10.5 (2022-05-25)
 */
(function () {
    'use strict';

    var global$7 = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var typeOf = function (x) {
      var t = typeof x;
      if (x === null) {
        return 'null';
      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
        return 'array';
      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
        return 'string';
      } else {
        return t;
      }
    };
    var isType$1 = function (type) {
      return function (value) {
        return typeOf(value) === type;
      };
    };
    var isSimpleType = function (type) {
      return function (value) {
        return typeof value === type;
      };
    };
    var isString = isType$1('string');
    var isObject = isType$1('object');
    var isArray = isType$1('array');
    var isBoolean = isSimpleType('boolean');
    var isFunction = isSimpleType('function');
    var isNumber = isSimpleType('number');

    var noop = function () {
    };
    var constant = function (value) {
      return function () {
        return value;
      };
    };
    var identity = function (x) {
      return x;
    };
    var tripleEquals = function (a, b) {
      return a === b;
    };
    var not = function (f) {
      return function (t) {
        return !f(t);
      };
    };
    var never = constant(false);
    var always = constant(true);

    var none = function () {
      return NONE;
    };
    var NONE = function () {
      var call = function (thunk) {
        return thunk();
      };
      var id = identity;
      var me = {
        fold: function (n, _s) {
          return n();
        },
        isSome: never,
        isNone: always,
        getOr: id,
        getOrThunk: call,
        getOrDie: function (msg) {
          throw new Error(msg || 'error: getOrDie called on none.');
        },
        getOrNull: constant(null),
        getOrUndefined: constant(undefined),
        or: id,
        orThunk: call,
        map: none,
        each: noop,
        bind: none,
        exists: never,
        forall: always,
        filter: function () {
          return none();
        },
        toArray: function () {
          return [];
        },
        toString: constant('none()')
      };
      return me;
    }();
    var some = function (a) {
      var constant_a = constant(a);
      var self = function () {
        return me;
      };
      var bind = function (f) {
        return f(a);
      };
      var me = {
        fold: function (n, s) {
          return s(a);
        },
        isSome: always,
        isNone: never,
        getOr: constant_a,
        getOrThunk: constant_a,
        getOrDie: constant_a,
        getOrNull: constant_a,
        getOrUndefined: constant_a,
        or: self,
        orThunk: self,
        map: function (f) {
          return some(f(a));
        },
        each: function (f) {
          f(a);
        },
        bind: bind,
        exists: bind,
        forall: bind,
        filter: function (f) {
          return f(a) ? me : NONE;
        },
        toArray: function () {
          return [a];
        },
        toString: function () {
          return 'some(' + a + ')';
        }
      };
      return me;
    };
    var from = function (value) {
      return value === null || value === undefined ? NONE : some(value);
    };
    var Optional = {
      some: some,
      none: none,
      from: from
    };

    var nativeSlice = Array.prototype.slice;
    var nativePush = Array.prototype.push;
    var map = function (xs, f) {
      var len = xs.length;
      var r = new Array(len);
      for (var i = 0; i < len; i++) {
        var x = xs[i];
        r[i] = f(x, i);
      }
      return r;
    };
    var each$1 = function (xs, f) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        f(x, i);
      }
    };
    var filter$1 = function (xs, pred) {
      var r = [];
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i)) {
          r.push(x);
        }
      }
      return r;
    };
    var groupBy = function (xs, f) {
      if (xs.length === 0) {
        return [];
      } else {
        var wasType = f(xs[0]);
        var r = [];
        var group = [];
        for (var i = 0, len = xs.length; i < len; i++) {
          var x = xs[i];
          var type = f(x);
          if (type !== wasType) {
            r.push(group);
            group = [];
          }
          wasType = type;
          group.push(x);
        }
        if (group.length !== 0) {
          r.push(group);
        }
        return r;
      }
    };
    var foldl = function (xs, f, acc) {
      each$1(xs, function (x, i) {
        acc = f(acc, x, i);
      });
      return acc;
    };
    var findUntil = function (xs, pred, until) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i)) {
          return Optional.some(x);
        } else if (until(x, i)) {
          break;
        }
      }
      return Optional.none();
    };
    var find$1 = function (xs, pred) {
      return findUntil(xs, pred, never);
    };
    var flatten = function (xs) {
      var r = [];
      for (var i = 0, len = xs.length; i < len; ++i) {
        if (!isArray(xs[i])) {
          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
        }
        nativePush.apply(r, xs[i]);
      }
      return r;
    };
    var bind = function (xs, f) {
      return flatten(map(xs, f));
    };
    var reverse = function (xs) {
      var r = nativeSlice.call(xs, 0);
      r.reverse();
      return r;
    };
    var get$1 = function (xs, i) {
      return i >= 0 && i < xs.length ? Optional.some(xs[i]) : Optional.none();
    };
    var head = function (xs) {
      return get$1(xs, 0);
    };
    var last = function (xs) {
      return get$1(xs, xs.length - 1);
    };
    var findMap = function (arr, f) {
      for (var i = 0; i < arr.length; i++) {
        var r = f(arr[i], i);
        if (r.isSome()) {
          return r;
        }
      }
      return Optional.none();
    };

    var __assign = function () {
      __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };
    function __spreadArray(to, from, pack) {
      if (pack || arguments.length === 2)
        for (var i = 0, l = from.length, ar; i < l; i++) {
          if (ar || !(i in from)) {
            if (!ar)
              ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
          }
        }
      return to.concat(ar || Array.prototype.slice.call(from));
    }

    var cached = function (f) {
      var called = false;
      var r;
      return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        if (!called) {
          called = true;
          r = f.apply(null, args);
        }
        return r;
      };
    };

    var DeviceType = function (os, browser, userAgent, mediaMatch) {
      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
      var isiPhone = os.isiOS() && !isiPad;
      var isMobile = os.isiOS() || os.isAndroid();
      var isTouch = isMobile || mediaMatch('(pointer:coarse)');
      var isTablet = isiPad || !isiPhone && isMobile && mediaMatch('(min-device-width:768px)');
      var isPhone = isiPhone || isMobile && !isTablet;
      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
      var isDesktop = !isPhone && !isTablet && !iOSwebview;
      return {
        isiPad: constant(isiPad),
        isiPhone: constant(isiPhone),
        isTablet: constant(isTablet),
        isPhone: constant(isPhone),
        isTouch: constant(isTouch),
        isAndroid: os.isAndroid,
        isiOS: os.isiOS,
        isWebView: constant(iOSwebview),
        isDesktop: constant(isDesktop)
      };
    };

    var firstMatch = function (regexes, s) {
      for (var i = 0; i < regexes.length; i++) {
        var x = regexes[i];
        if (x.test(s)) {
          return x;
        }
      }
      return undefined;
    };
    var find = function (regexes, agent) {
      var r = firstMatch(regexes, agent);
      if (!r) {
        return {
          major: 0,
          minor: 0
        };
      }
      var group = function (i) {
        return Number(agent.replace(r, '$' + i));
      };
      return nu$2(group(1), group(2));
    };
    var detect$3 = function (versionRegexes, agent) {
      var cleanedAgent = String(agent).toLowerCase();
      if (versionRegexes.length === 0) {
        return unknown$2();
      }
      return find(versionRegexes, cleanedAgent);
    };
    var unknown$2 = function () {
      return nu$2(0, 0);
    };
    var nu$2 = function (major, minor) {
      return {
        major: major,
        minor: minor
      };
    };
    var Version = {
      nu: nu$2,
      detect: detect$3,
      unknown: unknown$2
    };

    var detectBrowser$1 = function (browsers, userAgentData) {
      return findMap(userAgentData.brands, function (uaBrand) {
        var lcBrand = uaBrand.brand.toLowerCase();
        return find$1(browsers, function (browser) {
          var _a;
          return lcBrand === ((_a = browser.brand) === null || _a === void 0 ? void 0 : _a.toLowerCase());
        }).map(function (info) {
          return {
            current: info.name,
            version: Version.nu(parseInt(uaBrand.version, 10), 0)
          };
        });
      });
    };

    var detect$2 = function (candidates, userAgent) {
      var agent = String(userAgent).toLowerCase();
      return find$1(candidates, function (candidate) {
        return candidate.search(agent);
      });
    };
    var detectBrowser = function (browsers, userAgent) {
      return detect$2(browsers, userAgent).map(function (browser) {
        var version = Version.detect(browser.versionRegexes, userAgent);
        return {
          current: browser.name,
          version: version
        };
      });
    };
    var detectOs = function (oses, userAgent) {
      return detect$2(oses, userAgent).map(function (os) {
        var version = Version.detect(os.versionRegexes, userAgent);
        return {
          current: os.name,
          version: version
        };
      });
    };

    var contains$1 = function (str, substr) {
      return str.indexOf(substr) !== -1;
    };
    var blank = function (r) {
      return function (s) {
        return s.replace(r, '');
      };
    };
    var trim = blank(/^\s+|\s+$/g);
    var isNotEmpty = function (s) {
      return s.length > 0;
    };
    var isEmpty$1 = function (s) {
      return !isNotEmpty(s);
    };

    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
    var checkContains = function (target) {
      return function (uastring) {
        return contains$1(uastring, target);
      };
    };
    var browsers = [
      {
        name: 'Edge',
        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
        search: function (uastring) {
          return contains$1(uastring, 'edge/') && contains$1(uastring, 'chrome') && contains$1(uastring, 'safari') && contains$1(uastring, 'applewebkit');
        }
      },
      {
        name: 'Chrome',
        brand: 'Chromium',
        versionRegexes: [
          /.*?chrome\/([0-9]+)\.([0-9]+).*/,
          normalVersionRegex
        ],
        search: function (uastring) {
          return contains$1(uastring, 'chrome') && !contains$1(uastring, 'chromeframe');
        }
      },
      {
        name: 'IE',
        versionRegexes: [
          /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
          /.*?rv:([0-9]+)\.([0-9]+).*/
        ],
        search: function (uastring) {
          return contains$1(uastring, 'msie') || contains$1(uastring, 'trident');
        }
      },
      {
        name: 'Opera',
        versionRegexes: [
          normalVersionRegex,
          /.*?opera\/([0-9]+)\.([0-9]+).*/
        ],
        search: checkContains('opera')
      },
      {
        name: 'Firefox',
        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
        search: checkContains('firefox')
      },
      {
        name: 'Safari',
        versionRegexes: [
          normalVersionRegex,
          /.*?cpu os ([0-9]+)_([0-9]+).*/
        ],
        search: function (uastring) {
          return (contains$1(uastring, 'safari') || contains$1(uastring, 'mobile/')) && contains$1(uastring, 'applewebkit');
        }
      }
    ];
    var oses = [
      {
        name: 'Windows',
        search: checkContains('win'),
        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
      },
      {
        name: 'iOS',
        search: function (uastring) {
          return contains$1(uastring, 'iphone') || contains$1(uastring, 'ipad');
        },
        versionRegexes: [
          /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
          /.*cpu os ([0-9]+)_([0-9]+).*/,
          /.*cpu iphone os ([0-9]+)_([0-9]+).*/
        ]
      },
      {
        name: 'Android',
        search: checkContains('android'),
        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
      },
      {
        name: 'OSX',
        search: checkContains('mac os x'),
        versionRegexes: [/.*?mac\ os\ x\ ?([0-9]+)_([0-9]+).*/]
      },
      {
        name: 'Linux',
        search: checkContains('linux'),
        versionRegexes: []
      },
      {
        name: 'Solaris',
        search: checkContains('sunos'),
        versionRegexes: []
      },
      {
        name: 'FreeBSD',
        search: checkContains('freebsd'),
        versionRegexes: []
      },
      {
        name: 'ChromeOS',
        search: checkContains('cros'),
        versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/]
      }
    ];
    var PlatformInfo = {
      browsers: constant(browsers),
      oses: constant(oses)
    };

    var edge = 'Edge';
    var chrome = 'Chrome';
    var ie = 'IE';
    var opera = 'Opera';
    var firefox = 'Firefox';
    var safari = 'Safari';
    var unknown$1 = function () {
      return nu$1({
        current: undefined,
        version: Version.unknown()
      });
    };
    var nu$1 = function (info) {
      var current = info.current;
      var version = info.version;
      var isBrowser = function (name) {
        return function () {
          return current === name;
        };
      };
      return {
        current: current,
        version: version,
        isEdge: isBrowser(edge),
        isChrome: isBrowser(chrome),
        isIE: isBrowser(ie),
        isOpera: isBrowser(opera),
        isFirefox: isBrowser(firefox),
        isSafari: isBrowser(safari)
      };
    };
    var Browser = {
      unknown: unknown$1,
      nu: nu$1,
      edge: constant(edge),
      chrome: constant(chrome),
      ie: constant(ie),
      opera: constant(opera),
      firefox: constant(firefox),
      safari: constant(safari)
    };

    var windows = 'Windows';
    var ios = 'iOS';
    var android = 'Android';
    var linux = 'Linux';
    var osx = 'OSX';
    var solaris = 'Solaris';
    var freebsd = 'FreeBSD';
    var chromeos = 'ChromeOS';
    var unknown = function () {
      return nu({
        current: undefined,
        version: Version.unknown()
      });
    };
    var nu = function (info) {
      var current = info.current;
      var version = info.version;
      var isOS = function (name) {
        return function () {
          return current === name;
        };
      };
      return {
        current: current,
        version: version,
        isWindows: isOS(windows),
        isiOS: isOS(ios),
        isAndroid: isOS(android),
        isOSX: isOS(osx),
        isLinux: isOS(linux),
        isSolaris: isOS(solaris),
        isFreeBSD: isOS(freebsd),
        isChromeOS: isOS(chromeos)
      };
    };
    var OperatingSystem = {
      unknown: unknown,
      nu: nu,
      windows: constant(windows),
      ios: constant(ios),
      android: constant(android),
      linux: constant(linux),
      osx: constant(osx),
      solaris: constant(solaris),
      freebsd: constant(freebsd),
      chromeos: constant(chromeos)
    };

    var detect$1 = function (userAgent, userAgentDataOpt, mediaMatch) {
      var browsers = PlatformInfo.browsers();
      var oses = PlatformInfo.oses();
      var browser = userAgentDataOpt.bind(function (userAgentData) {
        return detectBrowser$1(browsers, userAgentData);
      }).orThunk(function () {
        return detectBrowser(browsers, userAgent);
      }).fold(Browser.unknown, Browser.nu);
      var os = detectOs(oses, userAgent).fold(OperatingSystem.unknown, OperatingSystem.nu);
      var deviceType = DeviceType(os, browser, userAgent, mediaMatch);
      return {
        browser: browser,
        os: os,
        deviceType: deviceType
      };
    };
    var PlatformDetection = { detect: detect$1 };

    var mediaMatch = function (query) {
      return window.matchMedia(query).matches;
    };
    var platform = cached(function () {
      return PlatformDetection.detect(navigator.userAgent, Optional.from(navigator.userAgentData), mediaMatch);
    });
    var detect = function () {
      return platform();
    };

    var compareDocumentPosition = function (a, b, match) {
      return (a.compareDocumentPosition(b) & match) !== 0;
    };
    var documentPositionContainedBy = function (a, b) {
      return compareDocumentPosition(a, b, Node.DOCUMENT_POSITION_CONTAINED_BY);
    };

    var ELEMENT = 1;

    var fromHtml = function (html, scope) {
      var doc = scope || document;
      var div = doc.createElement('div');
      div.innerHTML = html;
      if (!div.hasChildNodes() || div.childNodes.length > 1) {
        console.error('HTML does not have a single root node', html);
        throw new Error('HTML must have a single root node');
      }
      return fromDom(div.childNodes[0]);
    };
    var fromTag = function (tag, scope) {
      var doc = scope || document;
      var node = doc.createElement(tag);
      return fromDom(node);
    };
    var fromText = function (text, scope) {
      var doc = scope || document;
      var node = doc.createTextNode(text);
      return fromDom(node);
    };
    var fromDom = function (node) {
      if (node === null || node === undefined) {
        throw new Error('Node cannot be null or undefined');
      }
      return { dom: node };
    };
    var fromPoint = function (docElm, x, y) {
      return Optional.from(docElm.dom.elementFromPoint(x, y)).map(fromDom);
    };
    var SugarElement = {
      fromHtml: fromHtml,
      fromTag: fromTag,
      fromText: fromText,
      fromDom: fromDom,
      fromPoint: fromPoint
    };

    var is$2 = function (element, selector) {
      var dom = element.dom;
      if (dom.nodeType !== ELEMENT) {
        return false;
      } else {
        var elem = dom;
        if (elem.matches !== undefined) {
          return elem.matches(selector);
        } else if (elem.msMatchesSelector !== undefined) {
          return elem.msMatchesSelector(selector);
        } else if (elem.webkitMatchesSelector !== undefined) {
          return elem.webkitMatchesSelector(selector);
        } else if (elem.mozMatchesSelector !== undefined) {
          return elem.mozMatchesSelector(selector);
        } else {
          throw new Error('Browser lacks native selectors');
        }
      }
    };

    var eq = function (e1, e2) {
      return e1.dom === e2.dom;
    };
    var regularContains = function (e1, e2) {
      var d1 = e1.dom;
      var d2 = e2.dom;
      return d1 === d2 ? false : d1.contains(d2);
    };
    var ieContains = function (e1, e2) {
      return documentPositionContainedBy(e1.dom, e2.dom);
    };
    var contains = function (e1, e2) {
      return detect().browser.isIE() ? ieContains(e1, e2) : regularContains(e1, e2);
    };
    var is$1 = is$2;

    var global$6 = tinymce.util.Tools.resolve('tinymce.dom.RangeUtils');

    var global$5 = tinymce.util.Tools.resolve('tinymce.dom.TreeWalker');

    var global$4 = tinymce.util.Tools.resolve('tinymce.util.VK');

    var keys = Object.keys;
    var each = function (obj, f) {
      var props = keys(obj);
      for (var k = 0, len = props.length; k < len; k++) {
        var i = props[k];
        var x = obj[i];
        f(x, i);
      }
    };
    var objAcc = function (r) {
      return function (x, i) {
        r[i] = x;
      };
    };
    var internalFilter = function (obj, pred, onTrue, onFalse) {
      var r = {};
      each(obj, function (x, i) {
        (pred(x, i) ? onTrue : onFalse)(x, i);
      });
      return r;
    };
    var filter = function (obj, pred) {
      var t = {};
      internalFilter(obj, pred, objAcc(t), noop);
      return t;
    };

    typeof window !== 'undefined' ? window : Function('return this;')();

    var name = function (element) {
      var r = element.dom.nodeName;
      return r.toLowerCase();
    };
    var type = function (element) {
      return element.dom.nodeType;
    };
    var isType = function (t) {
      return function (element) {
        return type(element) === t;
      };
    };
    var isElement = isType(ELEMENT);
    var isTag = function (tag) {
      return function (e) {
        return isElement(e) && name(e) === tag;
      };
    };

    var rawSet = function (dom, key, value) {
      if (isString(value) || isBoolean(value) || isNumber(value)) {
        dom.setAttribute(key, value + '');
      } else {
        console.error('Invalid call to Attribute.set. Key ', key, ':: Value ', value, ':: Element ', dom);
        throw new Error('Attribute value was not simple');
      }
    };
    var setAll = function (element, attrs) {
      var dom = element.dom;
      each(attrs, function (v, k) {
        rawSet(dom, k, v);
      });
    };
    var clone$1 = function (element) {
      return foldl(element.dom.attributes, function (acc, attr) {
        acc[attr.name] = attr.value;
        return acc;
      }, {});
    };

    var parent = function (element) {
      return Optional.from(element.dom.parentNode).map(SugarElement.fromDom);
    };
    var children = function (element) {
      return map(element.dom.childNodes, SugarElement.fromDom);
    };
    var child = function (element, index) {
      var cs = element.dom.childNodes;
      return Optional.from(cs[index]).map(SugarElement.fromDom);
    };
    var firstChild = function (element) {
      return child(element, 0);
    };
    var lastChild = function (element) {
      return child(element, element.dom.childNodes.length - 1);
    };

    var before$1 = function (marker, element) {
      var parent$1 = parent(marker);
      parent$1.each(function (v) {
        v.dom.insertBefore(element.dom, marker.dom);
      });
    };
    var append$1 = function (parent, element) {
      parent.dom.appendChild(element.dom);
    };

    var before = function (marker, elements) {
      each$1(elements, function (x) {
        before$1(marker, x);
      });
    };
    var append = function (parent, elements) {
      each$1(elements, function (x) {
        append$1(parent, x);
      });
    };

    var remove = function (element) {
      var dom = element.dom;
      if (dom.parentNode !== null) {
        dom.parentNode.removeChild(dom);
      }
    };

    var clone = function (original, isDeep) {
      return SugarElement.fromDom(original.dom.cloneNode(isDeep));
    };
    var deep = function (original) {
      return clone(original, true);
    };
    var shallowAs = function (original, tag) {
      var nu = SugarElement.fromTag(tag);
      var attributes = clone$1(original);
      setAll(nu, attributes);
      return nu;
    };
    var mutate = function (original, tag) {
      var nu = shallowAs(original, tag);
      before$1(original, nu);
      var children$1 = children(original);
      append(nu, children$1);
      remove(original);
      return nu;
    };

    var global$3 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var matchNodeName = function (name) {
      return function (node) {
        return node && node.nodeName.toLowerCase() === name;
      };
    };
    var matchNodeNames = function (regex) {
      return function (node) {
        return node && regex.test(node.nodeName);
      };
    };
    var isTextNode = function (node) {
      return node && node.nodeType === 3;
    };
    var isListNode = matchNodeNames(/^(OL|UL|DL)$/);
    var isOlUlNode = matchNodeNames(/^(OL|UL)$/);
    var isOlNode = matchNodeName('ol');
    var isListItemNode = matchNodeNames(/^(LI|DT|DD)$/);
    var isDlItemNode = matchNodeNames(/^(DT|DD)$/);
    var isTableCellNode = matchNodeNames(/^(TH|TD)$/);
    var isBr = matchNodeName('br');
    var isFirstChild = function (node) {
      return node.parentNode.firstChild === node;
    };
    var isTextBlock = function (editor, node) {
      return node && !!editor.schema.getTextBlockElements()[node.nodeName];
    };
    var isBlock = function (node, blockElements) {
      return node && node.nodeName in blockElements;
    };
    var isBogusBr = function (dom, node) {
      if (!isBr(node)) {
        return false;
      }
      return dom.isBlock(node.nextSibling) && !isBr(node.previousSibling);
    };
    var isEmpty = function (dom, elm, keepBookmarks) {
      var empty = dom.isEmpty(elm);
      if (keepBookmarks && dom.select('span[data-mce-type=bookmark]', elm).length > 0) {
        return false;
      }
      return empty;
    };
    var isChildOfBody = function (dom, elm) {
      return dom.isChildOf(elm, dom.getRoot());
    };

    var shouldIndentOnTab = function (editor) {
      return editor.getParam('lists_indent_on_tab', true);
    };
    var getForcedRootBlock = function (editor) {
      var block = editor.getParam('forced_root_block', 'p');
      if (block === false) {
        return '';
      } else if (block === true) {
        return 'p';
      } else {
        return block;
      }
    };
    var getForcedRootBlockAttrs = function (editor) {
      return editor.getParam('forced_root_block_attrs', {});
    };

    var createTextBlock = function (editor, contentNode) {
      var dom = editor.dom;
      var blockElements = editor.schema.getBlockElements();
      var fragment = dom.createFragment();
      var blockName = getForcedRootBlock(editor);
      var node, textBlock, hasContentNode;
      if (blockName) {
        textBlock = dom.create(blockName);
        if (textBlock.tagName === blockName.toUpperCase()) {
          dom.setAttribs(textBlock, getForcedRootBlockAttrs(editor));
        }
        if (!isBlock(contentNode.firstChild, blockElements)) {
          fragment.appendChild(textBlock);
        }
      }
      if (contentNode) {
        while (node = contentNode.firstChild) {
          var nodeName = node.nodeName;
          if (!hasContentNode && (nodeName !== 'SPAN' || node.getAttribute('data-mce-type') !== 'bookmark')) {
            hasContentNode = true;
          }
          if (isBlock(node, blockElements)) {
            fragment.appendChild(node);
            textBlock = null;
          } else {
            if (blockName) {
              if (!textBlock) {
                textBlock = dom.create(blockName);
                fragment.appendChild(textBlock);
              }
              textBlock.appendChild(node);
            } else {
              fragment.appendChild(node);
            }
          }
        }
      }
      if (!blockName) {
        fragment.appendChild(dom.create('br'));
      } else {
        if (!hasContentNode) {
          textBlock.appendChild(dom.create('br', { 'data-mce-bogus': '1' }));
        }
      }
      return fragment;
    };

    var DOM$2 = global$3.DOM;
    var splitList = function (editor, list, li) {
      var removeAndKeepBookmarks = function (targetNode) {
        global$2.each(bookmarks, function (node) {
          targetNode.parentNode.insertBefore(node, li.parentNode);
        });
        DOM$2.remove(targetNode);
      };
      var bookmarks = DOM$2.select('span[data-mce-type="bookmark"]', list);
      var newBlock = createTextBlock(editor, li);
      var tmpRng = DOM$2.createRng();
      tmpRng.setStartAfter(li);
      tmpRng.setEndAfter(list);
      var fragment = tmpRng.extractContents();
      for (var node = fragment.firstChild; node; node = node.firstChild) {
        if (node.nodeName === 'LI' && editor.dom.isEmpty(node)) {
          DOM$2.remove(node);
          break;
        }
      }
      if (!editor.dom.isEmpty(fragment)) {
        DOM$2.insertAfter(fragment, list);
      }
      DOM$2.insertAfter(newBlock, list);
      if (isEmpty(editor.dom, li.parentNode)) {
        removeAndKeepBookmarks(li.parentNode);
      }
      DOM$2.remove(li);
      if (isEmpty(editor.dom, list)) {
        DOM$2.remove(list);
      }
    };

    var isDescriptionDetail = isTag('dd');
    var isDescriptionTerm = isTag('dt');
    var outdentDlItem = function (editor, item) {
      if (isDescriptionDetail(item)) {
        mutate(item, 'dt');
      } else if (isDescriptionTerm(item)) {
        parent(item).each(function (dl) {
          return splitList(editor, dl.dom, item.dom);
        });
      }
    };
    var indentDlItem = function (item) {
      if (isDescriptionTerm(item)) {
        mutate(item, 'dd');
      }
    };
    var dlIndentation = function (editor, indentation, dlItems) {
      if (indentation === 'Indent') {
        each$1(dlItems, indentDlItem);
      } else {
        each$1(dlItems, function (item) {
          return outdentDlItem(editor, item);
        });
      }
    };

    var getNormalizedPoint = function (container, offset) {
      if (isTextNode(container)) {
        return {
          container: container,
          offset: offset
        };
      }
      var node = global$6.getNode(container, offset);
      if (isTextNode(node)) {
        return {
          container: node,
          offset: offset >= container.childNodes.length ? node.data.length : 0
        };
      } else if (node.previousSibling && isTextNode(node.previousSibling)) {
        return {
          container: node.previousSibling,
          offset: node.previousSibling.data.length
        };
      } else if (node.nextSibling && isTextNode(node.nextSibling)) {
        return {
          container: node.nextSibling,
          offset: 0
        };
      }
      return {
        container: container,
        offset: offset
      };
    };
    var normalizeRange = function (rng) {
      var outRng = rng.cloneRange();
      var rangeStart = getNormalizedPoint(rng.startContainer, rng.startOffset);
      outRng.setStart(rangeStart.container, rangeStart.offset);
      var rangeEnd = getNormalizedPoint(rng.endContainer, rng.endOffset);
      outRng.setEnd(rangeEnd.container, rangeEnd.offset);
      return outRng;
    };

    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.DomQuery');

    var getParentList = function (editor, node) {
      var selectionStart = node || editor.selection.getStart(true);
      return editor.dom.getParent(selectionStart, 'OL,UL,DL', getClosestListRootElm(editor, selectionStart));
    };
    var isParentListSelected = function (parentList, selectedBlocks) {
      return parentList && selectedBlocks.length === 1 && selectedBlocks[0] === parentList;
    };
    var findSubLists = function (parentList) {
      return filter$1(parentList.querySelectorAll('ol,ul,dl'), isListNode);
    };
    var getSelectedSubLists = function (editor) {
      var parentList = getParentList(editor);
      var selectedBlocks = editor.selection.getSelectedBlocks();
      if (isParentListSelected(parentList, selectedBlocks)) {
        return findSubLists(parentList);
      } else {
        return filter$1(selectedBlocks, function (elm) {
          return isListNode(elm) && parentList !== elm;
        });
      }
    };
    var findParentListItemsNodes = function (editor, elms) {
      var listItemsElms = global$2.map(elms, function (elm) {
        var parentLi = editor.dom.getParent(elm, 'li,dd,dt', getClosestListRootElm(editor, elm));
        return parentLi ? parentLi : elm;
      });
      return global$1.unique(listItemsElms);
    };
    var getSelectedListItems = function (editor) {
      var selectedBlocks = editor.selection.getSelectedBlocks();
      return filter$1(findParentListItemsNodes(editor, selectedBlocks), isListItemNode);
    };
    var getSelectedDlItems = function (editor) {
      return filter$1(getSelectedListItems(editor), isDlItemNode);
    };
    var getClosestListRootElm = function (editor, elm) {
      var parentTableCell = editor.dom.getParents(elm, 'TD,TH');
      return parentTableCell.length > 0 ? parentTableCell[0] : editor.getBody();
    };
    var findLastParentListNode = function (editor, elm) {
      var parentLists = editor.dom.getParents(elm, 'ol,ul', getClosestListRootElm(editor, elm));
      return last(parentLists);
    };
    var getSelectedLists = function (editor) {
      var firstList = findLastParentListNode(editor, editor.selection.getStart());
      var subsequentLists = filter$1(editor.selection.getSelectedBlocks(), isOlUlNode);
      return firstList.toArray().concat(subsequentLists);
    };
    var getSelectedListRoots = function (editor) {
      var selectedLists = getSelectedLists(editor);
      return getUniqueListRoots(editor, selectedLists);
    };
    var getUniqueListRoots = function (editor, lists) {
      var listRoots = map(lists, function (list) {
        return findLastParentListNode(editor, list).getOr(list);
      });
      return global$1.unique(listRoots);
    };

    var is = function (lhs, rhs, comparator) {
      if (comparator === void 0) {
        comparator = tripleEquals;
      }
      return lhs.exists(function (left) {
        return comparator(left, rhs);
      });
    };
    var lift2 = function (oa, ob, f) {
      return oa.isSome() && ob.isSome() ? Optional.some(f(oa.getOrDie(), ob.getOrDie())) : Optional.none();
    };

    var fromElements = function (elements, scope) {
      var doc = scope || document;
      var fragment = doc.createDocumentFragment();
      each$1(elements, function (element) {
        fragment.appendChild(element.dom);
      });
      return SugarElement.fromDom(fragment);
    };

    var fireListEvent = function (editor, action, element) {
      return editor.fire('ListMutation', {
        action: action,
        element: element
      });
    };

    var isSupported = function (dom) {
      return dom.style !== undefined && isFunction(dom.style.getPropertyValue);
    };

    var internalSet = function (dom, property, value) {
      if (!isString(value)) {
        console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
        throw new Error('CSS value must be a string: ' + value);
      }
      if (isSupported(dom)) {
        dom.style.setProperty(property, value);
      }
    };
    var set = function (element, property, value) {
      var dom = element.dom;
      internalSet(dom, property, value);
    };

    var joinSegment = function (parent, child) {
      append$1(parent.item, child.list);
    };
    var joinSegments = function (segments) {
      for (var i = 1; i < segments.length; i++) {
        joinSegment(segments[i - 1], segments[i]);
      }
    };
    var appendSegments = function (head$1, tail) {
      lift2(last(head$1), head(tail), joinSegment);
    };
    var createSegment = function (scope, listType) {
      var segment = {
        list: SugarElement.fromTag(listType, scope),
        item: SugarElement.fromTag('li', scope)
      };
      append$1(segment.list, segment.item);
      return segment;
    };
    var createSegments = function (scope, entry, size) {
      var segments = [];
      for (var i = 0; i < size; i++) {
        segments.push(createSegment(scope, entry.listType));
      }
      return segments;
    };
    var populateSegments = function (segments, entry) {
      for (var i = 0; i < segments.length - 1; i++) {
        set(segments[i].item, 'list-style-type', 'none');
      }
      last(segments).each(function (segment) {
        setAll(segment.list, entry.listAttributes);
        setAll(segment.item, entry.itemAttributes);
        append(segment.item, entry.content);
      });
    };
    var normalizeSegment = function (segment, entry) {
      if (name(segment.list) !== entry.listType) {
        segment.list = mutate(segment.list, entry.listType);
      }
      setAll(segment.list, entry.listAttributes);
    };
    var createItem = function (scope, attr, content) {
      var item = SugarElement.fromTag('li', scope);
      setAll(item, attr);
      append(item, content);
      return item;
    };
    var appendItem = function (segment, item) {
      append$1(segment.list, item);
      segment.item = item;
    };
    var writeShallow = function (scope, cast, entry) {
      var newCast = cast.slice(0, entry.depth);
      last(newCast).each(function (segment) {
        var item = createItem(scope, entry.itemAttributes, entry.content);
        appendItem(segment, item);
        normalizeSegment(segment, entry);
      });
      return newCast;
    };
    var writeDeep = function (scope, cast, entry) {
      var segments = createSegments(scope, entry, entry.depth - cast.length);
      joinSegments(segments);
      populateSegments(segments, entry);
      appendSegments(cast, segments);
      return cast.concat(segments);
    };
    var composeList = function (scope, entries) {
      var cast = foldl(entries, function (cast, entry) {
        return entry.depth > cast.length ? writeDeep(scope, cast, entry) : writeShallow(scope, cast, entry);
      }, []);
      return head(cast).map(function (segment) {
        return segment.list;
      });
    };

    var isList = function (el) {
      return is$1(el, 'OL,UL');
    };
    var hasFirstChildList = function (el) {
      return firstChild(el).exists(isList);
    };
    var hasLastChildList = function (el) {
      return lastChild(el).exists(isList);
    };

    var isIndented = function (entry) {
      return entry.depth > 0;
    };
    var isSelected = function (entry) {
      return entry.isSelected;
    };
    var cloneItemContent = function (li) {
      var children$1 = children(li);
      var content = hasLastChildList(li) ? children$1.slice(0, -1) : children$1;
      return map(content, deep);
    };
    var createEntry = function (li, depth, isSelected) {
      return parent(li).filter(isElement).map(function (list) {
        return {
          depth: depth,
          dirty: false,
          isSelected: isSelected,
          content: cloneItemContent(li),
          itemAttributes: clone$1(li),
          listAttributes: clone$1(list),
          listType: name(list)
        };
      });
    };

    var indentEntry = function (indentation, entry) {
      switch (indentation) {
      case 'Indent':
        entry.depth++;
        break;
      case 'Outdent':
        entry.depth--;
        break;
      case 'Flatten':
        entry.depth = 0;
      }
      entry.dirty = true;
    };

    var cloneListProperties = function (target, source) {
      target.listType = source.listType;
      target.listAttributes = __assign({}, source.listAttributes);
    };
    var cleanListProperties = function (entry) {
      entry.listAttributes = filter(entry.listAttributes, function (_value, key) {
        return key !== 'start';
      });
    };
    var closestSiblingEntry = function (entries, start) {
      var depth = entries[start].depth;
      var matches = function (entry) {
        return entry.depth === depth && !entry.dirty;
      };
      var until = function (entry) {
        return entry.depth < depth;
      };
      return findUntil(reverse(entries.slice(0, start)), matches, until).orThunk(function () {
        return findUntil(entries.slice(start + 1), matches, until);
      });
    };
    var normalizeEntries = function (entries) {
      each$1(entries, function (entry, i) {
        closestSiblingEntry(entries, i).fold(function () {
          if (entry.dirty) {
            cleanListProperties(entry);
          }
        }, function (matchingEntry) {
          return cloneListProperties(entry, matchingEntry);
        });
      });
      return entries;
    };

    var Cell = function (initial) {
      var value = initial;
      var get = function () {
        return value;
      };
      var set = function (v) {
        value = v;
      };
      return {
        get: get,
        set: set
      };
    };

    var parseItem = function (depth, itemSelection, selectionState, item) {
      return firstChild(item).filter(isList).fold(function () {
        itemSelection.each(function (selection) {
          if (eq(selection.start, item)) {
            selectionState.set(true);
          }
        });
        var currentItemEntry = createEntry(item, depth, selectionState.get());
        itemSelection.each(function (selection) {
          if (eq(selection.end, item)) {
            selectionState.set(false);
          }
        });
        var childListEntries = lastChild(item).filter(isList).map(function (list) {
          return parseList(depth, itemSelection, selectionState, list);
        }).getOr([]);
        return currentItemEntry.toArray().concat(childListEntries);
      }, function (list) {
        return parseList(depth, itemSelection, selectionState, list);
      });
    };
    var parseList = function (depth, itemSelection, selectionState, list) {
      return bind(children(list), function (element) {
        var parser = isList(element) ? parseList : parseItem;
        var newDepth = depth + 1;
        return parser(newDepth, itemSelection, selectionState, element);
      });
    };
    var parseLists = function (lists, itemSelection) {
      var selectionState = Cell(false);
      var initialDepth = 0;
      return map(lists, function (list) {
        return {
          sourceList: list,
          entries: parseList(initialDepth, itemSelection, selectionState, list)
        };
      });
    };

    var outdentedComposer = function (editor, entries) {
      var normalizedEntries = normalizeEntries(entries);
      return map(normalizedEntries, function (entry) {
        var content = fromElements(entry.content);
        return SugarElement.fromDom(createTextBlock(editor, content.dom));
      });
    };
    var indentedComposer = function (editor, entries) {
      var normalizedEntries = normalizeEntries(entries);
      return composeList(editor.contentDocument, normalizedEntries).toArray();
    };
    var composeEntries = function (editor, entries) {
      return bind(groupBy(entries, isIndented), function (entries) {
        var groupIsIndented = head(entries).exists(isIndented);
        return groupIsIndented ? indentedComposer(editor, entries) : outdentedComposer(editor, entries);
      });
    };
    var indentSelectedEntries = function (entries, indentation) {
      each$1(filter$1(entries, isSelected), function (entry) {
        return indentEntry(indentation, entry);
      });
    };
    var getItemSelection = function (editor) {
      var selectedListItems = map(getSelectedListItems(editor), SugarElement.fromDom);
      return lift2(find$1(selectedListItems, not(hasFirstChildList)), find$1(reverse(selectedListItems), not(hasFirstChildList)), function (start, end) {
        return {
          start: start,
          end: end
        };
      });
    };
    var listIndentation = function (editor, lists, indentation) {
      var entrySets = parseLists(lists, getItemSelection(editor));
      each$1(entrySets, function (entrySet) {
        indentSelectedEntries(entrySet.entries, indentation);
        var composedLists = composeEntries(editor, entrySet.entries);
        each$1(composedLists, function (composedList) {
          fireListEvent(editor, indentation === 'Indent' ? 'IndentList' : 'OutdentList', composedList.dom);
        });
        before(entrySet.sourceList, composedLists);
        remove(entrySet.sourceList);
      });
    };

    var selectionIndentation = function (editor, indentation) {
      var lists = map(getSelectedListRoots(editor), SugarElement.fromDom);
      var dlItems = map(getSelectedDlItems(editor), SugarElement.fromDom);
      var isHandled = false;
      if (lists.length || dlItems.length) {
        var bookmark = editor.selection.getBookmark();
        listIndentation(editor, lists, indentation);
        dlIndentation(editor, indentation, dlItems);
        editor.selection.moveToBookmark(bookmark);
        editor.selection.setRng(normalizeRange(editor.selection.getRng()));
        editor.nodeChanged();
        isHandled = true;
      }
      return isHandled;
    };
    var indentListSelection = function (editor) {
      return selectionIndentation(editor, 'Indent');
    };
    var outdentListSelection = function (editor) {
      return selectionIndentation(editor, 'Outdent');
    };
    var flattenListSelection = function (editor) {
      return selectionIndentation(editor, 'Flatten');
    };

    var global = tinymce.util.Tools.resolve('tinymce.dom.BookmarkManager');

    var DOM$1 = global$3.DOM;
    var createBookmark = function (rng) {
      var bookmark = {};
      var setupEndPoint = function (start) {
        var container = rng[start ? 'startContainer' : 'endContainer'];
        var offset = rng[start ? 'startOffset' : 'endOffset'];
        if (container.nodeType === 1) {
          var offsetNode = DOM$1.create('span', { 'data-mce-type': 'bookmark' });
          if (container.hasChildNodes()) {
            offset = Math.min(offset, container.childNodes.length - 1);
            if (start) {
              container.insertBefore(offsetNode, container.childNodes[offset]);
            } else {
              DOM$1.insertAfter(offsetNode, container.childNodes[offset]);
            }
          } else {
            container.appendChild(offsetNode);
          }
          container = offsetNode;
          offset = 0;
        }
        bookmark[start ? 'startContainer' : 'endContainer'] = container;
        bookmark[start ? 'startOffset' : 'endOffset'] = offset;
      };
      setupEndPoint(true);
      if (!rng.collapsed) {
        setupEndPoint();
      }
      return bookmark;
    };
    var resolveBookmark = function (bookmark) {
      var restoreEndPoint = function (start) {
        var node;
        var nodeIndex = function (container) {
          var node = container.parentNode.firstChild, idx = 0;
          while (node) {
            if (node === container) {
              return idx;
            }
            if (node.nodeType !== 1 || node.getAttribute('data-mce-type') !== 'bookmark') {
              idx++;
            }
            node = node.nextSibling;
          }
          return -1;
        };
        var container = node = bookmark[start ? 'startContainer' : 'endContainer'];
        var offset = bookmark[start ? 'startOffset' : 'endOffset'];
        if (!container) {
          return;
        }
        if (container.nodeType === 1) {
          offset = nodeIndex(container);
          container = container.parentNode;
          DOM$1.remove(node);
          if (!container.hasChildNodes() && DOM$1.isBlock(container)) {
            container.appendChild(DOM$1.create('br'));
          }
        }
        bookmark[start ? 'startContainer' : 'endContainer'] = container;
        bookmark[start ? 'startOffset' : 'endOffset'] = offset;
      };
      restoreEndPoint(true);
      restoreEndPoint();
      var rng = DOM$1.createRng();
      rng.setStart(bookmark.startContainer, bookmark.startOffset);
      if (bookmark.endContainer) {
        rng.setEnd(bookmark.endContainer, bookmark.endOffset);
      }
      return normalizeRange(rng);
    };

    var listToggleActionFromListName = function (listName) {
      switch (listName) {
      case 'UL':
        return 'ToggleUlList';
      case 'OL':
        return 'ToggleOlList';
      case 'DL':
        return 'ToggleDLList';
      }
    };

    var isCustomList = function (list) {
      return /\btox\-/.test(list.className);
    };
    var listState = function (editor, listName, activate) {
      var nodeChangeHandler = function (e) {
        var inList = findUntil(e.parents, isListNode, isTableCellNode).filter(function (list) {
          return list.nodeName === listName && !isCustomList(list);
        }).isSome();
        activate(inList);
      };
      var parents = editor.dom.getParents(editor.selection.getNode());
      nodeChangeHandler({ parents: parents });
      editor.on('NodeChange', nodeChangeHandler);
      return function () {
        return editor.off('NodeChange', nodeChangeHandler);
      };
    };

    var updateListStyle = function (dom, el, detail) {
      var type = detail['list-style-type'] ? detail['list-style-type'] : null;
      dom.setStyle(el, 'list-style-type', type);
    };
    var setAttribs = function (elm, attrs) {
      global$2.each(attrs, function (value, key) {
        elm.setAttribute(key, value);
      });
    };
    var updateListAttrs = function (dom, el, detail) {
      setAttribs(el, detail['list-attributes']);
      global$2.each(dom.select('li', el), function (li) {
        setAttribs(li, detail['list-item-attributes']);
      });
    };
    var updateListWithDetails = function (dom, el, detail) {
      updateListStyle(dom, el, detail);
      updateListAttrs(dom, el, detail);
    };
    var removeStyles = function (dom, element, styles) {
      global$2.each(styles, function (style) {
        var _a;
        return dom.setStyle(element, (_a = {}, _a[style] = '', _a));
      });
    };
    var getEndPointNode = function (editor, rng, start, root) {
      var container = rng[start ? 'startContainer' : 'endContainer'];
      var offset = rng[start ? 'startOffset' : 'endOffset'];
      if (container.nodeType === 1) {
        container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
      }
      if (!start && isBr(container.nextSibling)) {
        container = container.nextSibling;
      }
      while (container.parentNode !== root) {
        if (isTextBlock(editor, container)) {
          return container;
        }
        if (/^(TD|TH)$/.test(container.parentNode.nodeName)) {
          return container;
        }
        container = container.parentNode;
      }
      return container;
    };
    var getSelectedTextBlocks = function (editor, rng, root) {
      var textBlocks = [];
      var dom = editor.dom;
      var startNode = getEndPointNode(editor, rng, true, root);
      var endNode = getEndPointNode(editor, rng, false, root);
      var block;
      var siblings = [];
      for (var node = startNode; node; node = node.nextSibling) {
        siblings.push(node);
        if (node === endNode) {
          break;
        }
      }
      global$2.each(siblings, function (node) {
        if (isTextBlock(editor, node)) {
          textBlocks.push(node);
          block = null;
          return;
        }
        if (dom.isBlock(node) || isBr(node)) {
          if (isBr(node)) {
            dom.remove(node);
          }
          block = null;
          return;
        }
        var nextSibling = node.nextSibling;
        if (global.isBookmarkNode(node)) {
          if (isListNode(nextSibling) || isTextBlock(editor, nextSibling) || !nextSibling && node.parentNode === root) {
            block = null;
            return;
          }
        }
        if (!block) {
          block = dom.create('p');
          node.parentNode.insertBefore(block, node);
          textBlocks.push(block);
        }
        block.appendChild(node);
      });
      return textBlocks;
    };
    var hasCompatibleStyle = function (dom, sib, detail) {
      var sibStyle = dom.getStyle(sib, 'list-style-type');
      var detailStyle = detail ? detail['list-style-type'] : '';
      detailStyle = detailStyle === null ? '' : detailStyle;
      return sibStyle === detailStyle;
    };
    var applyList = function (editor, listName, detail) {
      var rng = editor.selection.getRng();
      var listItemName = 'LI';
      var root = getClosestListRootElm(editor, editor.selection.getStart(true));
      var dom = editor.dom;
      if (dom.getContentEditable(editor.selection.getNode()) === 'false') {
        return;
      }
      listName = listName.toUpperCase();
      if (listName === 'DL') {
        listItemName = 'DT';
      }
      var bookmark = createBookmark(rng);
      var selectedTextBlocks = getSelectedTextBlocks(editor, rng, root);
      global$2.each(selectedTextBlocks, function (block) {
        var listBlock;
        var sibling = block.previousSibling;
        var parent = block.parentNode;
        if (!isListItemNode(parent)) {
          if (sibling && isListNode(sibling) && sibling.nodeName === listName && hasCompatibleStyle(dom, sibling, detail)) {
            listBlock = sibling;
            block = dom.rename(block, listItemName);
            sibling.appendChild(block);
          } else {
            listBlock = dom.create(listName);
            block.parentNode.insertBefore(listBlock, block);
            listBlock.appendChild(block);
            block = dom.rename(block, listItemName);
          }
          removeStyles(dom, block, [
            'margin',
            'margin-right',
            'margin-bottom',
            'margin-left',
            'margin-top',
            'padding',
            'padding-right',
            'padding-bottom',
            'padding-left',
            'padding-top'
          ]);
          updateListWithDetails(dom, listBlock, detail);
          mergeWithAdjacentLists(editor.dom, listBlock);
        }
      });
      editor.selection.setRng(resolveBookmark(bookmark));
    };
    var isValidLists = function (list1, list2) {
      return list1 && list2 && isListNode(list1) && list1.nodeName === list2.nodeName;
    };
    var hasSameListStyle = function (dom, list1, list2) {
      var targetStyle = dom.getStyle(list1, 'list-style-type', true);
      var style = dom.getStyle(list2, 'list-style-type', true);
      return targetStyle === style;
    };
    var hasSameClasses = function (elm1, elm2) {
      return elm1.className === elm2.className;
    };
    var shouldMerge = function (dom, list1, list2) {
      return isValidLists(list1, list2) && hasSameListStyle(dom, list1, list2) && hasSameClasses(list1, list2);
    };
    var mergeWithAdjacentLists = function (dom, listBlock) {
      var sibling, node;
      sibling = listBlock.nextSibling;
      if (shouldMerge(dom, listBlock, sibling)) {
        while (node = sibling.firstChild) {
          listBlock.appendChild(node);
        }
        dom.remove(sibling);
      }
      sibling = listBlock.previousSibling;
      if (shouldMerge(dom, listBlock, sibling)) {
        while (node = sibling.lastChild) {
          listBlock.insertBefore(node, listBlock.firstChild);
        }
        dom.remove(sibling);
      }
    };
    var updateList$1 = function (editor, list, listName, detail) {
      if (list.nodeName !== listName) {
        var newList = editor.dom.rename(list, listName);
        updateListWithDetails(editor.dom, newList, detail);
        fireListEvent(editor, listToggleActionFromListName(listName), newList);
      } else {
        updateListWithDetails(editor.dom, list, detail);
        fireListEvent(editor, listToggleActionFromListName(listName), list);
      }
    };
    var toggleMultipleLists = function (editor, parentList, lists, listName, detail) {
      var parentIsList = isListNode(parentList);
      if (parentIsList && parentList.nodeName === listName && !hasListStyleDetail(detail)) {
        flattenListSelection(editor);
      } else {
        applyList(editor, listName, detail);
        var bookmark = createBookmark(editor.selection.getRng());
        var allLists = parentIsList ? __spreadArray([parentList], lists, true) : lists;
        global$2.each(allLists, function (elm) {
          updateList$1(editor, elm, listName, detail);
        });
        editor.selection.setRng(resolveBookmark(bookmark));
      }
    };
    var hasListStyleDetail = function (detail) {
      return 'list-style-type' in detail;
    };
    var toggleSingleList = function (editor, parentList, listName, detail) {
      if (parentList === editor.getBody()) {
        return;
      }
      if (parentList) {
        if (parentList.nodeName === listName && !hasListStyleDetail(detail) && !isCustomList(parentList)) {
          flattenListSelection(editor);
        } else {
          var bookmark = createBookmark(editor.selection.getRng());
          updateListWithDetails(editor.dom, parentList, detail);
          var newList = editor.dom.rename(parentList, listName);
          mergeWithAdjacentLists(editor.dom, newList);
          editor.selection.setRng(resolveBookmark(bookmark));
          applyList(editor, listName, detail);
          fireListEvent(editor, listToggleActionFromListName(listName), newList);
        }
      } else {
        applyList(editor, listName, detail);
        fireListEvent(editor, listToggleActionFromListName(listName), parentList);
      }
    };
    var toggleList = function (editor, listName, _detail) {
      var parentList = getParentList(editor);
      var selectedSubLists = getSelectedSubLists(editor);
      var detail = isObject(_detail) ? _detail : {};
      if (selectedSubLists.length > 0) {
        toggleMultipleLists(editor, parentList, selectedSubLists, listName, detail);
      } else {
        toggleSingleList(editor, parentList, listName, detail);
      }
    };

    var DOM = global$3.DOM;
    var normalizeList = function (dom, list) {
      var parentNode = list.parentNode;
      if (parentNode.nodeName === 'LI' && parentNode.firstChild === list) {
        var sibling = parentNode.previousSibling;
        if (sibling && sibling.nodeName === 'LI') {
          sibling.appendChild(list);
          if (isEmpty(dom, parentNode)) {
            DOM.remove(parentNode);
          }
        } else {
          DOM.setStyle(parentNode, 'listStyleType', 'none');
        }
      }
      if (isListNode(parentNode)) {
        var sibling = parentNode.previousSibling;
        if (sibling && sibling.nodeName === 'LI') {
          sibling.appendChild(list);
        }
      }
    };
    var normalizeLists = function (dom, element) {
      var lists = global$2.grep(dom.select('ol,ul', element));
      global$2.each(lists, function (list) {
        normalizeList(dom, list);
      });
    };

    var findNextCaretContainer = function (editor, rng, isForward, root) {
      var node = rng.startContainer;
      var offset = rng.startOffset;
      if (isTextNode(node) && (isForward ? offset < node.data.length : offset > 0)) {
        return node;
      }
      var nonEmptyBlocks = editor.schema.getNonEmptyElements();
      if (node.nodeType === 1) {
        node = global$6.getNode(node, offset);
      }
      var walker = new global$5(node, root);
      if (isForward) {
        if (isBogusBr(editor.dom, node)) {
          walker.next();
        }
      }
      while (node = walker[isForward ? 'next' : 'prev2']()) {
        if (node.nodeName === 'LI' && !node.hasChildNodes()) {
          return node;
        }
        if (nonEmptyBlocks[node.nodeName]) {
          return node;
        }
        if (isTextNode(node) && node.data.length > 0) {
          return node;
        }
      }
    };
    var hasOnlyOneBlockChild = function (dom, elm) {
      var childNodes = elm.childNodes;
      return childNodes.length === 1 && !isListNode(childNodes[0]) && dom.isBlock(childNodes[0]);
    };
    var unwrapSingleBlockChild = function (dom, elm) {
      if (hasOnlyOneBlockChild(dom, elm)) {
        dom.remove(elm.firstChild, true);
      }
    };
    var moveChildren = function (dom, fromElm, toElm) {
      var node;
      var targetElm = hasOnlyOneBlockChild(dom, toElm) ? toElm.firstChild : toElm;
      unwrapSingleBlockChild(dom, fromElm);
      if (!isEmpty(dom, fromElm, true)) {
        while (node = fromElm.firstChild) {
          targetElm.appendChild(node);
        }
      }
    };
    var mergeLiElements = function (dom, fromElm, toElm) {
      var listNode;
      var ul = fromElm.parentNode;
      if (!isChildOfBody(dom, fromElm) || !isChildOfBody(dom, toElm)) {
        return;
      }
      if (isListNode(toElm.lastChild)) {
        listNode = toElm.lastChild;
      }
      if (ul === toElm.lastChild) {
        if (isBr(ul.previousSibling)) {
          dom.remove(ul.previousSibling);
        }
      }
      var node = toElm.lastChild;
      if (node && isBr(node) && fromElm.hasChildNodes()) {
        dom.remove(node);
      }
      if (isEmpty(dom, toElm, true)) {
        dom.$(toElm).empty();
      }
      moveChildren(dom, fromElm, toElm);
      if (listNode) {
        toElm.appendChild(listNode);
      }
      var contains$1 = contains(SugarElement.fromDom(toElm), SugarElement.fromDom(fromElm));
      var nestedLists = contains$1 ? dom.getParents(fromElm, isListNode, toElm) : [];
      dom.remove(fromElm);
      each$1(nestedLists, function (list) {
        if (isEmpty(dom, list) && list !== dom.getRoot()) {
          dom.remove(list);
        }
      });
    };
    var mergeIntoEmptyLi = function (editor, fromLi, toLi) {
      editor.dom.$(toLi).empty();
      mergeLiElements(editor.dom, fromLi, toLi);
      editor.selection.setCursorLocation(toLi, 0);
    };
    var mergeForward = function (editor, rng, fromLi, toLi) {
      var dom = editor.dom;
      if (dom.isEmpty(toLi)) {
        mergeIntoEmptyLi(editor, fromLi, toLi);
      } else {
        var bookmark = createBookmark(rng);
        mergeLiElements(dom, fromLi, toLi);
        editor.selection.setRng(resolveBookmark(bookmark));
      }
    };
    var mergeBackward = function (editor, rng, fromLi, toLi) {
      var bookmark = createBookmark(rng);
      mergeLiElements(editor.dom, fromLi, toLi);
      var resolvedBookmark = resolveBookmark(bookmark);
      editor.selection.setRng(resolvedBookmark);
    };
    var backspaceDeleteFromListToListCaret = function (editor, isForward) {
      var dom = editor.dom, selection = editor.selection;
      var selectionStartElm = selection.getStart();
      var root = getClosestListRootElm(editor, selectionStartElm);
      var li = dom.getParent(selection.getStart(), 'LI', root);
      if (li) {
        var ul = li.parentNode;
        if (ul === editor.getBody() && isEmpty(dom, ul)) {
          return true;
        }
        var rng_1 = normalizeRange(selection.getRng());
        var otherLi_1 = dom.getParent(findNextCaretContainer(editor, rng_1, isForward, root), 'LI', root);
        if (otherLi_1 && otherLi_1 !== li) {
          editor.undoManager.transact(function () {
            if (isForward) {
              mergeForward(editor, rng_1, otherLi_1, li);
            } else {
              if (isFirstChild(li)) {
                outdentListSelection(editor);
              } else {
                mergeBackward(editor, rng_1, li, otherLi_1);
              }
            }
          });
          return true;
        } else if (!otherLi_1) {
          if (!isForward && rng_1.startOffset === 0 && rng_1.endOffset === 0) {
            editor.undoManager.transact(function () {
              flattenListSelection(editor);
            });
            return true;
          }
        }
      }
      return false;
    };
    var removeBlock = function (dom, block, root) {
      var parentBlock = dom.getParent(block.parentNode, dom.isBlock, root);
      dom.remove(block);
      if (parentBlock && dom.isEmpty(parentBlock)) {
        dom.remove(parentBlock);
      }
    };
    var backspaceDeleteIntoListCaret = function (editor, isForward) {
      var dom = editor.dom;
      var selectionStartElm = editor.selection.getStart();
      var root = getClosestListRootElm(editor, selectionStartElm);
      var block = dom.getParent(selectionStartElm, dom.isBlock, root);
      if (block && dom.isEmpty(block)) {
        var rng = normalizeRange(editor.selection.getRng());
        var otherLi_2 = dom.getParent(findNextCaretContainer(editor, rng, isForward, root), 'LI', root);
        if (otherLi_2) {
          editor.undoManager.transact(function () {
            removeBlock(dom, block, root);
            mergeWithAdjacentLists(dom, otherLi_2.parentNode);
            editor.selection.select(otherLi_2, true);
            editor.selection.collapse(isForward);
          });
          return true;
        }
      }
      return false;
    };
    var backspaceDeleteCaret = function (editor, isForward) {
      return backspaceDeleteFromListToListCaret(editor, isForward) || backspaceDeleteIntoListCaret(editor, isForward);
    };
    var backspaceDeleteRange = function (editor) {
      var selectionStartElm = editor.selection.getStart();
      var root = getClosestListRootElm(editor, selectionStartElm);
      var startListParent = editor.dom.getParent(selectionStartElm, 'LI,DT,DD', root);
      if (startListParent || getSelectedListItems(editor).length > 0) {
        editor.undoManager.transact(function () {
          editor.execCommand('Delete');
          normalizeLists(editor.dom, editor.getBody());
        });
        return true;
      }
      return false;
    };
    var backspaceDelete = function (editor, isForward) {
      return editor.selection.isCollapsed() ? backspaceDeleteCaret(editor, isForward) : backspaceDeleteRange(editor);
    };
    var setup$1 = function (editor) {
      editor.on('keydown', function (e) {
        if (e.keyCode === global$4.BACKSPACE) {
          if (backspaceDelete(editor, false)) {
            e.preventDefault();
          }
        } else if (e.keyCode === global$4.DELETE) {
          if (backspaceDelete(editor, true)) {
            e.preventDefault();
          }
        }
      });
    };

    var get = function (editor) {
      return {
        backspaceDelete: function (isForward) {
          backspaceDelete(editor, isForward);
        }
      };
    };

    var updateList = function (editor, update) {
      var parentList = getParentList(editor);
      editor.undoManager.transact(function () {
        if (isObject(update.styles)) {
          editor.dom.setStyles(parentList, update.styles);
        }
        if (isObject(update.attrs)) {
          each(update.attrs, function (v, k) {
            return editor.dom.setAttrib(parentList, k, v);
          });
        }
      });
    };

    var parseAlphabeticBase26 = function (str) {
      var chars = reverse(trim(str).split(''));
      var values = map(chars, function (char, i) {
        var charValue = char.toUpperCase().charCodeAt(0) - 'A'.charCodeAt(0) + 1;
        return Math.pow(26, i) * charValue;
      });
      return foldl(values, function (sum, v) {
        return sum + v;
      }, 0);
    };
    var composeAlphabeticBase26 = function (value) {
      value--;
      if (value < 0) {
        return '';
      } else {
        var remainder = value % 26;
        var quotient = Math.floor(value / 26);
        var rest = composeAlphabeticBase26(quotient);
        var char = String.fromCharCode('A'.charCodeAt(0) + remainder);
        return rest + char;
      }
    };
    var isUppercase = function (str) {
      return /^[A-Z]+$/.test(str);
    };
    var isLowercase = function (str) {
      return /^[a-z]+$/.test(str);
    };
    var isNumeric = function (str) {
      return /^[0-9]+$/.test(str);
    };
    var deduceListType = function (start) {
      if (isNumeric(start)) {
        return 2;
      } else if (isUppercase(start)) {
        return 0;
      } else if (isLowercase(start)) {
        return 1;
      } else if (isEmpty$1(start)) {
        return 3;
      } else {
        return 4;
      }
    };
    var parseStartValue = function (start) {
      switch (deduceListType(start)) {
      case 2:
        return Optional.some({
          listStyleType: Optional.none(),
          start: start
        });
      case 0:
        return Optional.some({
          listStyleType: Optional.some('upper-alpha'),
          start: parseAlphabeticBase26(start).toString()
        });
      case 1:
        return Optional.some({
          listStyleType: Optional.some('lower-alpha'),
          start: parseAlphabeticBase26(start).toString()
        });
      case 3:
        return Optional.some({
          listStyleType: Optional.none(),
          start: ''
        });
      case 4:
        return Optional.none();
      }
    };
    var parseDetail = function (detail) {
      var start = parseInt(detail.start, 10);
      if (is(detail.listStyleType, 'upper-alpha')) {
        return composeAlphabeticBase26(start);
      } else if (is(detail.listStyleType, 'lower-alpha')) {
        return composeAlphabeticBase26(start).toLowerCase();
      } else {
        return detail.start;
      }
    };

    var open = function (editor) {
      var currentList = getParentList(editor);
      if (!isOlNode(currentList)) {
        return;
      }
      editor.windowManager.open({
        title: 'List Properties',
        body: {
          type: 'panel',
          items: [{
              type: 'input',
              name: 'start',
              label: 'Start list at number',
              inputMode: 'numeric'
            }]
        },
        initialData: {
          start: parseDetail({
            start: editor.dom.getAttrib(currentList, 'start', '1'),
            listStyleType: Optional.some(editor.dom.getStyle(currentList, 'list-style-type'))
          })
        },
        buttons: [
          {
            type: 'cancel',
            name: 'cancel',
            text: 'Cancel'
          },
          {
            type: 'submit',
            name: 'save',
            text: 'Save',
            primary: true
          }
        ],
        onSubmit: function (api) {
          var data = api.getData();
          parseStartValue(data.start).each(function (detail) {
            editor.execCommand('mceListUpdate', false, {
              attrs: { start: detail.start === '1' ? '' : detail.start },
              styles: { 'list-style-type': detail.listStyleType.getOr('') }
            });
          });
          api.close();
        }
      });
    };

    var queryListCommandState = function (editor, listName) {
      return function () {
        var parentList = getParentList(editor);
        return parentList && parentList.nodeName === listName;
      };
    };
    var registerDialog = function (editor) {
      editor.addCommand('mceListProps', function () {
        open(editor);
      });
    };
    var register$2 = function (editor) {
      editor.on('BeforeExecCommand', function (e) {
        var cmd = e.command.toLowerCase();
        if (cmd === 'indent') {
          indentListSelection(editor);
        } else if (cmd === 'outdent') {
          outdentListSelection(editor);
        }
      });
      editor.addCommand('InsertUnorderedList', function (ui, detail) {
        toggleList(editor, 'UL', detail);
      });
      editor.addCommand('InsertOrderedList', function (ui, detail) {
        toggleList(editor, 'OL', detail);
      });
      editor.addCommand('InsertDefinitionList', function (ui, detail) {
        toggleList(editor, 'DL', detail);
      });
      editor.addCommand('RemoveList', function () {
        flattenListSelection(editor);
      });
      registerDialog(editor);
      editor.addCommand('mceListUpdate', function (ui, detail) {
        if (isObject(detail)) {
          updateList(editor, detail);
        }
      });
      editor.addQueryStateHandler('InsertUnorderedList', queryListCommandState(editor, 'UL'));
      editor.addQueryStateHandler('InsertOrderedList', queryListCommandState(editor, 'OL'));
      editor.addQueryStateHandler('InsertDefinitionList', queryListCommandState(editor, 'DL'));
    };

    var setupTabKey = function (editor) {
      editor.on('keydown', function (e) {
        if (e.keyCode !== global$4.TAB || global$4.metaKeyPressed(e)) {
          return;
        }
        editor.undoManager.transact(function () {
          if (e.shiftKey ? outdentListSelection(editor) : indentListSelection(editor)) {
            e.preventDefault();
          }
        });
      });
    };
    var setup = function (editor) {
      if (shouldIndentOnTab(editor)) {
        setupTabKey(editor);
      }
      setup$1(editor);
    };

    var register$1 = function (editor) {
      var exec = function (command) {
        return function () {
          return editor.execCommand(command);
        };
      };
      if (!editor.hasPlugin('advlist')) {
        editor.ui.registry.addToggleButton('numlist', {
          icon: 'ordered-list',
          active: false,
          tooltip: 'Numbered list',
          onAction: exec('InsertOrderedList'),
          onSetup: function (api) {
            return listState(editor, 'OL', api.setActive);
          }
        });
        editor.ui.registry.addToggleButton('bullist', {
          icon: 'unordered-list',
          active: false,
          tooltip: 'Bullet list',
          onAction: exec('InsertUnorderedList'),
          onSetup: function (api) {
            return listState(editor, 'UL', api.setActive);
          }
        });
      }
    };

    var register = function (editor) {
      var listProperties = {
        text: 'List properties...',
        icon: 'ordered-list',
        onAction: function () {
          return editor.execCommand('mceListProps');
        },
        onSetup: function (api) {
          return listState(editor, 'OL', function (active) {
            return api.setDisabled(!active);
          });
        }
      };
      editor.ui.registry.addMenuItem('listprops', listProperties);
      editor.ui.registry.addContextMenu('lists', {
        update: function (node) {
          var parentList = getParentList(editor, node);
          return isOlNode(parentList) ? ['listprops'] : [];
        }
      });
    };

    function Plugin () {
      global$7.add('lists', function (editor) {
        if (editor.hasPlugin('rtc', true) === false) {
          setup(editor);
          register$2(editor);
        } else {
          registerDialog(editor);
        }
        register$1(editor);
        register(editor);
        return get(editor);
      });
    }

    Plugin();

}());


/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "media" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/media')
//   ES2015:
//     import 'tinymce/plugins/media'
__webpack_require__(1501);

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 *
 * Version: 5.10.5 (2022-05-25)
 */
(function () {
    'use strict';

    var global$9 = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var __assign = function () {
      __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };

    var typeOf = function (x) {
      var t = typeof x;
      if (x === null) {
        return 'null';
      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
        return 'array';
      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
        return 'string';
      } else {
        return t;
      }
    };
    var isType = function (type) {
      return function (value) {
        return typeOf(value) === type;
      };
    };
    var isString = isType('string');
    var isObject = isType('object');
    var isArray = isType('array');
    var isNullable = function (a) {
      return a === null || a === undefined;
    };
    var isNonNullable = function (a) {
      return !isNullable(a);
    };

    var noop = function () {
    };
    var constant = function (value) {
      return function () {
        return value;
      };
    };
    var identity = function (x) {
      return x;
    };
    var never = constant(false);
    var always = constant(true);

    var none = function () {
      return NONE;
    };
    var NONE = function () {
      var call = function (thunk) {
        return thunk();
      };
      var id = identity;
      var me = {
        fold: function (n, _s) {
          return n();
        },
        isSome: never,
        isNone: always,
        getOr: id,
        getOrThunk: call,
        getOrDie: function (msg) {
          throw new Error(msg || 'error: getOrDie called on none.');
        },
        getOrNull: constant(null),
        getOrUndefined: constant(undefined),
        or: id,
        orThunk: call,
        map: none,
        each: noop,
        bind: none,
        exists: never,
        forall: always,
        filter: function () {
          return none();
        },
        toArray: function () {
          return [];
        },
        toString: constant('none()')
      };
      return me;
    }();
    var some = function (a) {
      var constant_a = constant(a);
      var self = function () {
        return me;
      };
      var bind = function (f) {
        return f(a);
      };
      var me = {
        fold: function (n, s) {
          return s(a);
        },
        isSome: always,
        isNone: never,
        getOr: constant_a,
        getOrThunk: constant_a,
        getOrDie: constant_a,
        getOrNull: constant_a,
        getOrUndefined: constant_a,
        or: self,
        orThunk: self,
        map: function (f) {
          return some(f(a));
        },
        each: function (f) {
          f(a);
        },
        bind: bind,
        exists: bind,
        forall: bind,
        filter: function (f) {
          return f(a) ? me : NONE;
        },
        toArray: function () {
          return [a];
        },
        toString: function () {
          return 'some(' + a + ')';
        }
      };
      return me;
    };
    var from = function (value) {
      return value === null || value === undefined ? NONE : some(value);
    };
    var Optional = {
      some: some,
      none: none,
      from: from
    };

    var nativePush = Array.prototype.push;
    var each$1 = function (xs, f) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        f(x, i);
      }
    };
    var flatten = function (xs) {
      var r = [];
      for (var i = 0, len = xs.length; i < len; ++i) {
        if (!isArray(xs[i])) {
          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
        }
        nativePush.apply(r, xs[i]);
      }
      return r;
    };

    var Cell = function (initial) {
      var value = initial;
      var get = function () {
        return value;
      };
      var set = function (v) {
        value = v;
      };
      return {
        get: get,
        set: set
      };
    };

    var keys = Object.keys;
    var hasOwnProperty = Object.hasOwnProperty;
    var each = function (obj, f) {
      var props = keys(obj);
      for (var k = 0, len = props.length; k < len; k++) {
        var i = props[k];
        var x = obj[i];
        f(x, i);
      }
    };
    var get$1 = function (obj, key) {
      return has(obj, key) ? Optional.from(obj[key]) : Optional.none();
    };
    var has = function (obj, key) {
      return hasOwnProperty.call(obj, key);
    };

    var getScripts = function (editor) {
      return editor.getParam('media_scripts');
    };
    var getAudioTemplateCallback = function (editor) {
      return editor.getParam('audio_template_callback');
    };
    var getVideoTemplateCallback = function (editor) {
      return editor.getParam('video_template_callback');
    };
    var hasLiveEmbeds = function (editor) {
      return editor.getParam('media_live_embeds', true);
    };
    var shouldFilterHtml = function (editor) {
      return editor.getParam('media_filter_html', true);
    };
    var getUrlResolver = function (editor) {
      return editor.getParam('media_url_resolver');
    };
    var hasAltSource = function (editor) {
      return editor.getParam('media_alt_source', true);
    };
    var hasPoster = function (editor) {
      return editor.getParam('media_poster', true);
    };
    var hasDimensions = function (editor) {
      return editor.getParam('media_dimensions', true);
    };

    var global$8 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var global$7 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var global$6 = tinymce.util.Tools.resolve('tinymce.html.SaxParser');

    var getVideoScriptMatch = function (prefixes, src) {
      if (prefixes) {
        for (var i = 0; i < prefixes.length; i++) {
          if (src.indexOf(prefixes[i].filter) !== -1) {
            return prefixes[i];
          }
        }
      }
    };

    var DOM$1 = global$7.DOM;
    var trimPx = function (value) {
      return value.replace(/px$/, '');
    };
    var getEphoxEmbedData = function (attrs) {
      var style = attrs.map.style;
      var styles = style ? DOM$1.parseStyle(style) : {};
      return {
        type: 'ephox-embed-iri',
        source: attrs.map['data-ephox-embed-iri'],
        altsource: '',
        poster: '',
        width: get$1(styles, 'max-width').map(trimPx).getOr(''),
        height: get$1(styles, 'max-height').map(trimPx).getOr('')
      };
    };
    var htmlToData = function (prefixes, html) {
      var isEphoxEmbed = Cell(false);
      var data = {};
      global$6({
        validate: false,
        allow_conditional_comments: true,
        start: function (name, attrs) {
          if (isEphoxEmbed.get()) ; else if (has(attrs.map, 'data-ephox-embed-iri')) {
            isEphoxEmbed.set(true);
            data = getEphoxEmbedData(attrs);
          } else {
            if (!data.source && name === 'param') {
              data.source = attrs.map.movie;
            }
            if (name === 'iframe' || name === 'object' || name === 'embed' || name === 'video' || name === 'audio') {
              if (!data.type) {
                data.type = name;
              }
              data = global$8.extend(attrs.map, data);
            }
            if (name === 'script') {
              var videoScript = getVideoScriptMatch(prefixes, attrs.map.src);
              if (!videoScript) {
                return;
              }
              data = {
                type: 'script',
                source: attrs.map.src,
                width: String(videoScript.width),
                height: String(videoScript.height)
              };
            }
            if (name === 'source') {
              if (!data.source) {
                data.source = attrs.map.src;
              } else if (!data.altsource) {
                data.altsource = attrs.map.src;
              }
            }
            if (name === 'img' && !data.poster) {
              data.poster = attrs.map.src;
            }
          }
        }
      }).parse(html);
      data.source = data.source || data.src || data.data;
      data.altsource = data.altsource || '';
      data.poster = data.poster || '';
      return data;
    };

    var guess = function (url) {
      var mimes = {
        mp3: 'audio/mpeg',
        m4a: 'audio/x-m4a',
        wav: 'audio/wav',
        mp4: 'video/mp4',
        webm: 'video/webm',
        ogg: 'video/ogg',
        swf: 'application/x-shockwave-flash'
      };
      var fileEnd = url.toLowerCase().split('.').pop();
      var mime = mimes[fileEnd];
      return mime ? mime : '';
    };

    var global$5 = tinymce.util.Tools.resolve('tinymce.html.Schema');

    var global$4 = tinymce.util.Tools.resolve('tinymce.html.Writer');

    var DOM = global$7.DOM;
    var addPx = function (value) {
      return /^[0-9.]+$/.test(value) ? value + 'px' : value;
    };
    var setAttributes = function (attrs, updatedAttrs) {
      each(updatedAttrs, function (val, name) {
        var value = '' + val;
        if (attrs.map[name]) {
          var i = attrs.length;
          while (i--) {
            var attr = attrs[i];
            if (attr.name === name) {
              if (value) {
                attrs.map[name] = value;
                attr.value = value;
              } else {
                delete attrs.map[name];
                attrs.splice(i, 1);
              }
            }
          }
        } else if (value) {
          attrs.push({
            name: name,
            value: value
          });
          attrs.map[name] = value;
        }
      });
    };
    var updateEphoxEmbed = function (data, attrs) {
      var style = attrs.map.style;
      var styleMap = style ? DOM.parseStyle(style) : {};
      styleMap['max-width'] = addPx(data.width);
      styleMap['max-height'] = addPx(data.height);
      setAttributes(attrs, { style: DOM.serializeStyle(styleMap) });
    };
    var sources = [
      'source',
      'altsource'
    ];
    var updateHtml = function (html, data, updateAll) {
      var writer = global$4();
      var isEphoxEmbed = Cell(false);
      var sourceCount = 0;
      var hasImage;
      global$6({
        validate: false,
        allow_conditional_comments: true,
        comment: function (text) {
          writer.comment(text);
        },
        cdata: function (text) {
          writer.cdata(text);
        },
        text: function (text, raw) {
          writer.text(text, raw);
        },
        start: function (name, attrs, empty) {
          if (isEphoxEmbed.get()) ; else if (has(attrs.map, 'data-ephox-embed-iri')) {
            isEphoxEmbed.set(true);
            updateEphoxEmbed(data, attrs);
          } else {
            switch (name) {
            case 'video':
            case 'object':
            case 'embed':
            case 'img':
            case 'iframe':
              if (data.height !== undefined && data.width !== undefined) {
                setAttributes(attrs, {
                  width: data.width,
                  height: data.height
                });
              }
              break;
            }
            if (updateAll) {
              switch (name) {
              case 'video':
                setAttributes(attrs, {
                  poster: data.poster,
                  src: ''
                });
                if (data.altsource) {
                  setAttributes(attrs, { src: '' });
                }
                break;
              case 'iframe':
                setAttributes(attrs, { src: data.source });
                break;
              case 'source':
                if (sourceCount < 2) {
                  setAttributes(attrs, {
                    src: data[sources[sourceCount]],
                    type: data[sources[sourceCount] + 'mime']
                  });
                  if (!data[sources[sourceCount]]) {
                    return;
                  }
                }
                sourceCount++;
                break;
              case 'img':
                if (!data.poster) {
                  return;
                }
                hasImage = true;
                break;
              }
            }
          }
          writer.start(name, attrs, empty);
        },
        end: function (name) {
          if (!isEphoxEmbed.get()) {
            if (name === 'video' && updateAll) {
              for (var index = 0; index < 2; index++) {
                if (data[sources[index]]) {
                  var attrs = [];
                  attrs.map = {};
                  if (sourceCount <= index) {
                    setAttributes(attrs, {
                      src: data[sources[index]],
                      type: data[sources[index] + 'mime']
                    });
                    writer.start('source', attrs, true);
                  }
                }
              }
            }
            if (data.poster && name === 'object' && updateAll && !hasImage) {
              var imgAttrs = [];
              imgAttrs.map = {};
              setAttributes(imgAttrs, {
                src: data.poster,
                width: data.width,
                height: data.height
              });
              writer.start('img', imgAttrs, true);
            }
          }
          writer.end(name);
        }
      }, global$5({})).parse(html);
      return writer.getContent();
    };

    var urlPatterns = [
      {
        regex: /youtu\.be\/([\w\-_\?&=.]+)/i,
        type: 'iframe',
        w: 560,
        h: 314,
        url: 'www.youtube.com/embed/$1',
        allowFullscreen: true
      },
      {
        regex: /youtube\.com(.+)v=([^&]+)(&([a-z0-9&=\-_]+))?/i,
        type: 'iframe',
        w: 560,
        h: 314,
        url: 'www.youtube.com/embed/$2?$4',
        allowFullscreen: true
      },
      {
        regex: /youtube.com\/embed\/([a-z0-9\?&=\-_]+)/i,
        type: 'iframe',
        w: 560,
        h: 314,
        url: 'www.youtube.com/embed/$1',
        allowFullscreen: true
      },
      {
        regex: /vimeo\.com\/([0-9]+)/,
        type: 'iframe',
        w: 425,
        h: 350,
        url: 'player.vimeo.com/video/$1?title=0&byline=0&portrait=0&color=8dc7dc',
        allowFullscreen: true
      },
      {
        regex: /vimeo\.com\/(.*)\/([0-9]+)/,
        type: 'iframe',
        w: 425,
        h: 350,
        url: 'player.vimeo.com/video/$2?title=0&amp;byline=0',
        allowFullscreen: true
      },
      {
        regex: /maps\.google\.([a-z]{2,3})\/maps\/(.+)msid=(.+)/,
        type: 'iframe',
        w: 425,
        h: 350,
        url: 'maps.google.com/maps/ms?msid=$2&output=embed"',
        allowFullscreen: false
      },
      {
        regex: /dailymotion\.com\/video\/([^_]+)/,
        type: 'iframe',
        w: 480,
        h: 270,
        url: 'www.dailymotion.com/embed/video/$1',
        allowFullscreen: true
      },
      {
        regex: /dai\.ly\/([^_]+)/,
        type: 'iframe',
        w: 480,
        h: 270,
        url: 'www.dailymotion.com/embed/video/$1',
        allowFullscreen: true
      }
    ];
    var getProtocol = function (url) {
      var protocolMatches = url.match(/^(https?:\/\/|www\.)(.+)$/i);
      if (protocolMatches && protocolMatches.length > 1) {
        return protocolMatches[1] === 'www.' ? 'https://' : protocolMatches[1];
      } else {
        return 'https://';
      }
    };
    var getUrl = function (pattern, url) {
      var protocol = getProtocol(url);
      var match = pattern.regex.exec(url);
      var newUrl = protocol + pattern.url;
      var _loop_1 = function (i) {
        newUrl = newUrl.replace('$' + i, function () {
          return match[i] ? match[i] : '';
        });
      };
      for (var i = 0; i < match.length; i++) {
        _loop_1(i);
      }
      return newUrl.replace(/\?$/, '');
    };
    var matchPattern = function (url) {
      var patterns = urlPatterns.filter(function (pattern) {
        return pattern.regex.test(url);
      });
      if (patterns.length > 0) {
        return global$8.extend({}, patterns[0], { url: getUrl(patterns[0], url) });
      } else {
        return null;
      }
    };

    var getIframeHtml = function (data) {
      var allowFullscreen = data.allowfullscreen ? ' allowFullscreen="1"' : '';
      return '<iframe src="' + data.source + '" width="' + data.width + '" height="' + data.height + '"' + allowFullscreen + '></iframe>';
    };
    var getFlashHtml = function (data) {
      var html = '<object data="' + data.source + '" width="' + data.width + '" height="' + data.height + '" type="application/x-shockwave-flash">';
      if (data.poster) {
        html += '<img src="' + data.poster + '" width="' + data.width + '" height="' + data.height + '" />';
      }
      html += '</object>';
      return html;
    };
    var getAudioHtml = function (data, audioTemplateCallback) {
      if (audioTemplateCallback) {
        return audioTemplateCallback(data);
      } else {
        return '<audio controls="controls" src="' + data.source + '">' + (data.altsource ? '\n<source src="' + data.altsource + '"' + (data.altsourcemime ? ' type="' + data.altsourcemime + '"' : '') + ' />\n' : '') + '</audio>';
      }
    };
    var getVideoHtml = function (data, videoTemplateCallback) {
      if (videoTemplateCallback) {
        return videoTemplateCallback(data);
      } else {
        return '<video width="' + data.width + '" height="' + data.height + '"' + (data.poster ? ' poster="' + data.poster + '"' : '') + ' controls="controls">\n' + '<source src="' + data.source + '"' + (data.sourcemime ? ' type="' + data.sourcemime + '"' : '') + ' />\n' + (data.altsource ? '<source src="' + data.altsource + '"' + (data.altsourcemime ? ' type="' + data.altsourcemime + '"' : '') + ' />\n' : '') + '</video>';
      }
    };
    var getScriptHtml = function (data) {
      return '<script src="' + data.source + '"></script>';
    };
    var dataToHtml = function (editor, dataIn) {
      var data = global$8.extend({}, dataIn);
      if (!data.source) {
        global$8.extend(data, htmlToData(getScripts(editor), data.embed));
        if (!data.source) {
          return '';
        }
      }
      if (!data.altsource) {
        data.altsource = '';
      }
      if (!data.poster) {
        data.poster = '';
      }
      data.source = editor.convertURL(data.source, 'source');
      data.altsource = editor.convertURL(data.altsource, 'source');
      data.sourcemime = guess(data.source);
      data.altsourcemime = guess(data.altsource);
      data.poster = editor.convertURL(data.poster, 'poster');
      var pattern = matchPattern(data.source);
      if (pattern) {
        data.source = pattern.url;
        data.type = pattern.type;
        data.allowfullscreen = pattern.allowFullscreen;
        data.width = data.width || String(pattern.w);
        data.height = data.height || String(pattern.h);
      }
      if (data.embed) {
        return updateHtml(data.embed, data, true);
      } else {
        var videoScript = getVideoScriptMatch(getScripts(editor), data.source);
        if (videoScript) {
          data.type = 'script';
          data.width = String(videoScript.width);
          data.height = String(videoScript.height);
        }
        var audioTemplateCallback = getAudioTemplateCallback(editor);
        var videoTemplateCallback = getVideoTemplateCallback(editor);
        data.width = data.width || '300';
        data.height = data.height || '150';
        global$8.each(data, function (value, key) {
          data[key] = editor.dom.encode('' + value);
        });
        if (data.type === 'iframe') {
          return getIframeHtml(data);
        } else if (data.sourcemime === 'application/x-shockwave-flash') {
          return getFlashHtml(data);
        } else if (data.sourcemime.indexOf('audio') !== -1) {
          return getAudioHtml(data, audioTemplateCallback);
        } else if (data.type === 'script') {
          return getScriptHtml(data);
        } else {
          return getVideoHtml(data, videoTemplateCallback);
        }
      }
    };

    var isMediaElement = function (element) {
      return element.hasAttribute('data-mce-object') || element.hasAttribute('data-ephox-embed-iri');
    };
    var setup$2 = function (editor) {
      editor.on('click keyup touchend', function () {
        var selectedNode = editor.selection.getNode();
        if (selectedNode && editor.dom.hasClass(selectedNode, 'mce-preview-object')) {
          if (editor.dom.getAttrib(selectedNode, 'data-mce-selected')) {
            selectedNode.setAttribute('data-mce-selected', '2');
          }
        }
      });
      editor.on('ObjectSelected', function (e) {
        var objectType = e.target.getAttribute('data-mce-object');
        if (objectType === 'script') {
          e.preventDefault();
        }
      });
      editor.on('ObjectResized', function (e) {
        var target = e.target;
        if (target.getAttribute('data-mce-object')) {
          var html = target.getAttribute('data-mce-html');
          if (html) {
            html = unescape(html);
            target.setAttribute('data-mce-html', escape(updateHtml(html, {
              width: String(e.width),
              height: String(e.height)
            })));
          }
        }
      });
    };

    var global$3 = tinymce.util.Tools.resolve('tinymce.util.Promise');

    var cache = {};
    var embedPromise = function (data, dataToHtml, handler) {
      return new global$3(function (res, rej) {
        var wrappedResolve = function (response) {
          if (response.html) {
            cache[data.source] = response;
          }
          return res({
            url: data.source,
            html: response.html ? response.html : dataToHtml(data)
          });
        };
        if (cache[data.source]) {
          wrappedResolve(cache[data.source]);
        } else {
          handler({ url: data.source }, wrappedResolve, rej);
        }
      });
    };
    var defaultPromise = function (data, dataToHtml) {
      return global$3.resolve({
        html: dataToHtml(data),
        url: data.source
      });
    };
    var loadedData = function (editor) {
      return function (data) {
        return dataToHtml(editor, data);
      };
    };
    var getEmbedHtml = function (editor, data) {
      var embedHandler = getUrlResolver(editor);
      return embedHandler ? embedPromise(data, loadedData(editor), embedHandler) : defaultPromise(data, loadedData(editor));
    };
    var isCached = function (url) {
      return has(cache, url);
    };

    var extractMeta = function (sourceInput, data) {
      return get$1(data, sourceInput).bind(function (mainData) {
        return get$1(mainData, 'meta');
      });
    };
    var getValue = function (data, metaData, sourceInput) {
      return function (prop) {
        var _a;
        var getFromData = function () {
          return get$1(data, prop);
        };
        var getFromMetaData = function () {
          return get$1(metaData, prop);
        };
        var getNonEmptyValue = function (c) {
          return get$1(c, 'value').bind(function (v) {
            return v.length > 0 ? Optional.some(v) : Optional.none();
          });
        };
        var getFromValueFirst = function () {
          return getFromData().bind(function (child) {
            return isObject(child) ? getNonEmptyValue(child).orThunk(getFromMetaData) : getFromMetaData().orThunk(function () {
              return Optional.from(child);
            });
          });
        };
        var getFromMetaFirst = function () {
          return getFromMetaData().orThunk(function () {
            return getFromData().bind(function (child) {
              return isObject(child) ? getNonEmptyValue(child) : Optional.from(child);
            });
          });
        };
        return _a = {}, _a[prop] = (prop === sourceInput ? getFromValueFirst() : getFromMetaFirst()).getOr(''), _a;
      };
    };
    var getDimensions = function (data, metaData) {
      var dimensions = {};
      get$1(data, 'dimensions').each(function (dims) {
        each$1([
          'width',
          'height'
        ], function (prop) {
          get$1(metaData, prop).orThunk(function () {
            return get$1(dims, prop);
          }).each(function (value) {
            return dimensions[prop] = value;
          });
        });
      });
      return dimensions;
    };
    var unwrap = function (data, sourceInput) {
      var metaData = sourceInput ? extractMeta(sourceInput, data).getOr({}) : {};
      var get = getValue(data, metaData, sourceInput);
      return __assign(__assign(__assign(__assign(__assign({}, get('source')), get('altsource')), get('poster')), get('embed')), getDimensions(data, metaData));
    };
    var wrap = function (data) {
      var wrapped = __assign(__assign({}, data), {
        source: { value: get$1(data, 'source').getOr('') },
        altsource: { value: get$1(data, 'altsource').getOr('') },
        poster: { value: get$1(data, 'poster').getOr('') }
      });
      each$1([
        'width',
        'height'
      ], function (prop) {
        get$1(data, prop).each(function (value) {
          var dimensions = wrapped.dimensions || {};
          dimensions[prop] = value;
          wrapped.dimensions = dimensions;
        });
      });
      return wrapped;
    };
    var handleError = function (editor) {
      return function (error) {
        var errorMessage = error && error.msg ? 'Media embed handler error: ' + error.msg : 'Media embed handler threw unknown error.';
        editor.notificationManager.open({
          type: 'error',
          text: errorMessage
        });
      };
    };
    var snippetToData = function (editor, embedSnippet) {
      return htmlToData(getScripts(editor), embedSnippet);
    };
    var getEditorData = function (editor) {
      var element = editor.selection.getNode();
      var snippet = isMediaElement(element) ? editor.serializer.serialize(element, { selection: true }) : '';
      return __assign({ embed: snippet }, htmlToData(getScripts(editor), snippet));
    };
    var addEmbedHtml = function (api, editor) {
      return function (response) {
        if (isString(response.url) && response.url.trim().length > 0) {
          var html = response.html;
          var snippetData = snippetToData(editor, html);
          var nuData = __assign(__assign({}, snippetData), {
            source: response.url,
            embed: html
          });
          api.setData(wrap(nuData));
        }
      };
    };
    var selectPlaceholder = function (editor, beforeObjects) {
      var afterObjects = editor.dom.select('*[data-mce-object]');
      for (var i = 0; i < beforeObjects.length; i++) {
        for (var y = afterObjects.length - 1; y >= 0; y--) {
          if (beforeObjects[i] === afterObjects[y]) {
            afterObjects.splice(y, 1);
          }
        }
      }
      editor.selection.select(afterObjects[0]);
    };
    var handleInsert = function (editor, html) {
      var beforeObjects = editor.dom.select('*[data-mce-object]');
      editor.insertContent(html);
      selectPlaceholder(editor, beforeObjects);
      editor.nodeChanged();
    };
    var submitForm = function (prevData, newData, editor) {
      newData.embed = updateHtml(newData.embed, newData);
      if (newData.embed && (prevData.source === newData.source || isCached(newData.source))) {
        handleInsert(editor, newData.embed);
      } else {
        getEmbedHtml(editor, newData).then(function (response) {
          handleInsert(editor, response.html);
        }).catch(handleError(editor));
      }
    };
    var showDialog = function (editor) {
      var editorData = getEditorData(editor);
      var currentData = Cell(editorData);
      var initialData = wrap(editorData);
      var handleSource = function (prevData, api) {
        var serviceData = unwrap(api.getData(), 'source');
        if (prevData.source !== serviceData.source) {
          addEmbedHtml(win, editor)({
            url: serviceData.source,
            html: ''
          });
          getEmbedHtml(editor, serviceData).then(addEmbedHtml(win, editor)).catch(handleError(editor));
        }
      };
      var handleEmbed = function (api) {
        var data = unwrap(api.getData());
        var dataFromEmbed = snippetToData(editor, data.embed);
        api.setData(wrap(dataFromEmbed));
      };
      var handleUpdate = function (api, sourceInput) {
        var data = unwrap(api.getData(), sourceInput);
        var embed = dataToHtml(editor, data);
        api.setData(wrap(__assign(__assign({}, data), { embed: embed })));
      };
      var mediaInput = [{
          name: 'source',
          type: 'urlinput',
          filetype: 'media',
          label: 'Source'
        }];
      var sizeInput = !hasDimensions(editor) ? [] : [{
          type: 'sizeinput',
          name: 'dimensions',
          label: 'Constrain proportions',
          constrain: true
        }];
      var generalTab = {
        title: 'General',
        name: 'general',
        items: flatten([
          mediaInput,
          sizeInput
        ])
      };
      var embedTextarea = {
        type: 'textarea',
        name: 'embed',
        label: 'Paste your embed code below:'
      };
      var embedTab = {
        title: 'Embed',
        items: [embedTextarea]
      };
      var advancedFormItems = [];
      if (hasAltSource(editor)) {
        advancedFormItems.push({
          name: 'altsource',
          type: 'urlinput',
          filetype: 'media',
          label: 'Alternative source URL'
        });
      }
      if (hasPoster(editor)) {
        advancedFormItems.push({
          name: 'poster',
          type: 'urlinput',
          filetype: 'image',
          label: 'Media poster (Image URL)'
        });
      }
      var advancedTab = {
        title: 'Advanced',
        name: 'advanced',
        items: advancedFormItems
      };
      var tabs = [
        generalTab,
        embedTab
      ];
      if (advancedFormItems.length > 0) {
        tabs.push(advancedTab);
      }
      var body = {
        type: 'tabpanel',
        tabs: tabs
      };
      var win = editor.windowManager.open({
        title: 'Insert/Edit Media',
        size: 'normal',
        body: body,
        buttons: [
          {
            type: 'cancel',
            name: 'cancel',
            text: 'Cancel'
          },
          {
            type: 'submit',
            name: 'save',
            text: 'Save',
            primary: true
          }
        ],
        onSubmit: function (api) {
          var serviceData = unwrap(api.getData());
          submitForm(currentData.get(), serviceData, editor);
          api.close();
        },
        onChange: function (api, detail) {
          switch (detail.name) {
          case 'source':
            handleSource(currentData.get(), api);
            break;
          case 'embed':
            handleEmbed(api);
            break;
          case 'dimensions':
          case 'altsource':
          case 'poster':
            handleUpdate(api, detail.name);
            break;
          }
          currentData.set(unwrap(api.getData()));
        },
        initialData: initialData
      });
    };

    var get = function (editor) {
      var showDialog$1 = function () {
        showDialog(editor);
      };
      return { showDialog: showDialog$1 };
    };

    var register$1 = function (editor) {
      var showDialog$1 = function () {
        showDialog(editor);
      };
      editor.addCommand('mceMedia', showDialog$1);
    };

    var global$2 = tinymce.util.Tools.resolve('tinymce.html.Node');

    var global$1 = tinymce.util.Tools.resolve('tinymce.Env');

    var global = tinymce.util.Tools.resolve('tinymce.html.DomParser');

    var sanitize = function (editor, html) {
      if (shouldFilterHtml(editor) === false) {
        return html;
      }
      var writer = global$4();
      var blocked;
      global$6({
        validate: false,
        allow_conditional_comments: false,
        comment: function (text) {
          if (!blocked) {
            writer.comment(text);
          }
        },
        cdata: function (text) {
          if (!blocked) {
            writer.cdata(text);
          }
        },
        text: function (text, raw) {
          if (!blocked) {
            writer.text(text, raw);
          }
        },
        start: function (name, attrs, empty) {
          blocked = true;
          if (name === 'script' || name === 'noscript' || name === 'svg') {
            return;
          }
          for (var i = attrs.length - 1; i >= 0; i--) {
            var attrName = attrs[i].name;
            if (attrName.indexOf('on') === 0) {
              delete attrs.map[attrName];
              attrs.splice(i, 1);
            }
            if (attrName === 'style') {
              attrs[i].value = editor.dom.serializeStyle(editor.dom.parseStyle(attrs[i].value), name);
            }
          }
          writer.start(name, attrs, empty);
          blocked = false;
        },
        end: function (name) {
          if (blocked) {
            return;
          }
          writer.end(name);
        }
      }, global$5({})).parse(html);
      return writer.getContent();
    };

    var isLiveEmbedNode = function (node) {
      var name = node.name;
      return name === 'iframe' || name === 'video' || name === 'audio';
    };
    var getDimension = function (node, styles, dimension, defaultValue) {
      if (defaultValue === void 0) {
        defaultValue = null;
      }
      var value = node.attr(dimension);
      if (isNonNullable(value)) {
        return value;
      } else if (!has(styles, dimension)) {
        return defaultValue;
      } else {
        return null;
      }
    };
    var setDimensions = function (node, previewNode, styles) {
      var useDefaults = previewNode.name === 'img' || node.name === 'video';
      var defaultWidth = useDefaults ? '300' : null;
      var fallbackHeight = node.name === 'audio' ? '30' : '150';
      var defaultHeight = useDefaults ? fallbackHeight : null;
      previewNode.attr({
        width: getDimension(node, styles, 'width', defaultWidth),
        height: getDimension(node, styles, 'height', defaultHeight)
      });
    };
    var appendNodeContent = function (editor, nodeName, previewNode, html) {
      var newNode = global({
        forced_root_block: false,
        validate: false
      }, editor.schema).parse(html, { context: nodeName });
      while (newNode.firstChild) {
        previewNode.append(newNode.firstChild);
      }
    };
    var createPlaceholderNode = function (editor, node) {
      var name = node.name;
      var placeHolder = new global$2('img', 1);
      placeHolder.shortEnded = true;
      retainAttributesAndInnerHtml(editor, node, placeHolder);
      setDimensions(node, placeHolder, {});
      placeHolder.attr({
        'style': node.attr('style'),
        'src': global$1.transparentSrc,
        'data-mce-object': name,
        'class': 'mce-object mce-object-' + name
      });
      return placeHolder;
    };
    var createPreviewNode = function (editor, node) {
      var name = node.name;
      var previewWrapper = new global$2('span', 1);
      previewWrapper.attr({
        'contentEditable': 'false',
        'style': node.attr('style'),
        'data-mce-object': name,
        'class': 'mce-preview-object mce-object-' + name
      });
      retainAttributesAndInnerHtml(editor, node, previewWrapper);
      var styles = editor.dom.parseStyle(node.attr('style'));
      var previewNode = new global$2(name, 1);
      setDimensions(node, previewNode, styles);
      previewNode.attr({
        src: node.attr('src'),
        style: node.attr('style'),
        class: node.attr('class')
      });
      if (name === 'iframe') {
        previewNode.attr({
          allowfullscreen: node.attr('allowfullscreen'),
          frameborder: '0'
        });
      } else {
        var attrs = [
          'controls',
          'crossorigin',
          'currentTime',
          'loop',
          'muted',
          'poster',
          'preload'
        ];
        each$1(attrs, function (attrName) {
          previewNode.attr(attrName, node.attr(attrName));
        });
        var sanitizedHtml = previewWrapper.attr('data-mce-html');
        if (isNonNullable(sanitizedHtml)) {
          appendNodeContent(editor, name, previewNode, unescape(sanitizedHtml));
        }
      }
      var shimNode = new global$2('span', 1);
      shimNode.attr('class', 'mce-shim');
      previewWrapper.append(previewNode);
      previewWrapper.append(shimNode);
      return previewWrapper;
    };
    var retainAttributesAndInnerHtml = function (editor, sourceNode, targetNode) {
      var attribs = sourceNode.attributes;
      var ai = attribs.length;
      while (ai--) {
        var attrName = attribs[ai].name;
        var attrValue = attribs[ai].value;
        if (attrName !== 'width' && attrName !== 'height' && attrName !== 'style') {
          if (attrName === 'data' || attrName === 'src') {
            attrValue = editor.convertURL(attrValue, attrName);
          }
          targetNode.attr('data-mce-p-' + attrName, attrValue);
        }
      }
      var innerHtml = sourceNode.firstChild && sourceNode.firstChild.value;
      if (innerHtml) {
        targetNode.attr('data-mce-html', escape(sanitize(editor, innerHtml)));
        targetNode.firstChild = null;
      }
    };
    var isPageEmbedWrapper = function (node) {
      var nodeClass = node.attr('class');
      return nodeClass && /\btiny-pageembed\b/.test(nodeClass);
    };
    var isWithinEmbedWrapper = function (node) {
      while (node = node.parent) {
        if (node.attr('data-ephox-embed-iri') || isPageEmbedWrapper(node)) {
          return true;
        }
      }
      return false;
    };
    var placeHolderConverter = function (editor) {
      return function (nodes) {
        var i = nodes.length;
        var node;
        var videoScript;
        while (i--) {
          node = nodes[i];
          if (!node.parent) {
            continue;
          }
          if (node.parent.attr('data-mce-object')) {
            continue;
          }
          if (node.name === 'script') {
            videoScript = getVideoScriptMatch(getScripts(editor), node.attr('src'));
            if (!videoScript) {
              continue;
            }
          }
          if (videoScript) {
            if (videoScript.width) {
              node.attr('width', videoScript.width.toString());
            }
            if (videoScript.height) {
              node.attr('height', videoScript.height.toString());
            }
          }
          if (isLiveEmbedNode(node) && hasLiveEmbeds(editor) && global$1.ceFalse) {
            if (!isWithinEmbedWrapper(node)) {
              node.replace(createPreviewNode(editor, node));
            }
          } else {
            if (!isWithinEmbedWrapper(node)) {
              node.replace(createPlaceholderNode(editor, node));
            }
          }
        }
      };
    };

    var setup$1 = function (editor) {
      editor.on('preInit', function () {
        var specialElements = editor.schema.getSpecialElements();
        global$8.each('video audio iframe object'.split(' '), function (name) {
          specialElements[name] = new RegExp('</' + name + '[^>]*>', 'gi');
        });
        var boolAttrs = editor.schema.getBoolAttrs();
        global$8.each('webkitallowfullscreen mozallowfullscreen allowfullscreen'.split(' '), function (name) {
          boolAttrs[name] = {};
        });
        editor.parser.addNodeFilter('iframe,video,audio,object,embed,script', placeHolderConverter(editor));
        editor.serializer.addAttributeFilter('data-mce-object', function (nodes, name) {
          var i = nodes.length;
          var node;
          var realElm;
          var ai;
          var attribs;
          var innerHtml;
          var innerNode;
          var realElmName;
          var className;
          while (i--) {
            node = nodes[i];
            if (!node.parent) {
              continue;
            }
            realElmName = node.attr(name);
            realElm = new global$2(realElmName, 1);
            if (realElmName !== 'audio' && realElmName !== 'script') {
              className = node.attr('class');
              if (className && className.indexOf('mce-preview-object') !== -1) {
                realElm.attr({
                  width: node.firstChild.attr('width'),
                  height: node.firstChild.attr('height')
                });
              } else {
                realElm.attr({
                  width: node.attr('width'),
                  height: node.attr('height')
                });
              }
            }
            realElm.attr({ style: node.attr('style') });
            attribs = node.attributes;
            ai = attribs.length;
            while (ai--) {
              var attrName = attribs[ai].name;
              if (attrName.indexOf('data-mce-p-') === 0) {
                realElm.attr(attrName.substr(11), attribs[ai].value);
              }
            }
            if (realElmName === 'script') {
              realElm.attr('type', 'text/javascript');
            }
            innerHtml = node.attr('data-mce-html');
            if (innerHtml) {
              innerNode = new global$2('#text', 3);
              innerNode.raw = true;
              innerNode.value = sanitize(editor, unescape(innerHtml));
              realElm.append(innerNode);
            }
            node.replace(realElm);
          }
        });
      });
      editor.on('SetContent', function () {
        editor.$('span.mce-preview-object').each(function (index, elm) {
          var $elm = editor.$(elm);
          if ($elm.find('span.mce-shim').length === 0) {
            $elm.append('<span class="mce-shim"></span>');
          }
        });
      });
    };

    var setup = function (editor) {
      editor.on('ResolveName', function (e) {
        var name;
        if (e.target.nodeType === 1 && (name = e.target.getAttribute('data-mce-object'))) {
          e.name = name;
        }
      });
    };

    var register = function (editor) {
      var onAction = function () {
        return editor.execCommand('mceMedia');
      };
      editor.ui.registry.addToggleButton('media', {
        tooltip: 'Insert/edit media',
        icon: 'embed',
        onAction: onAction,
        onSetup: function (buttonApi) {
          var selection = editor.selection;
          buttonApi.setActive(isMediaElement(selection.getNode()));
          return selection.selectorChangedWithUnbind('img[data-mce-object],span[data-mce-object],div[data-ephox-embed-iri]', buttonApi.setActive).unbind;
        }
      });
      editor.ui.registry.addMenuItem('media', {
        icon: 'embed',
        text: 'Media...',
        onAction: onAction
      });
    };

    function Plugin () {
      global$9.add('media', function (editor) {
        register$1(editor);
        register(editor);
        setup(editor);
        setup$1(editor);
        setup$2(editor);
        return get(editor);
      });
    }

    Plugin();

}());


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "pagebreak" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/pagebreak')
//   ES2015:
//     import 'tinymce/plugins/pagebreak'
__webpack_require__(1503);

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 *
 * Version: 5.10.5 (2022-05-25)
 */
(function () {
    'use strict';

    var global$1 = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global = tinymce.util.Tools.resolve('tinymce.Env');

    var getSeparatorHtml = function (editor) {
      return editor.getParam('pagebreak_separator', '<!-- pagebreak -->');
    };
    var shouldSplitBlock = function (editor) {
      return editor.getParam('pagebreak_split_block', false);
    };

    var pageBreakClass = 'mce-pagebreak';
    var getPlaceholderHtml = function (shouldSplitBlock) {
      var html = '<img src="' + global.transparentSrc + '" class="' + pageBreakClass + '" data-mce-resize="false" data-mce-placeholder />';
      return shouldSplitBlock ? '<p>' + html + '</p>' : html;
    };
    var setup$1 = function (editor) {
      var separatorHtml = getSeparatorHtml(editor);
      var shouldSplitBlock$1 = function () {
        return shouldSplitBlock(editor);
      };
      var pageBreakSeparatorRegExp = new RegExp(separatorHtml.replace(/[\?\.\*\[\]\(\)\{\}\+\^\$\:]/g, function (a) {
        return '\\' + a;
      }), 'gi');
      editor.on('BeforeSetContent', function (e) {
        e.content = e.content.replace(pageBreakSeparatorRegExp, getPlaceholderHtml(shouldSplitBlock$1()));
      });
      editor.on('PreInit', function () {
        editor.serializer.addNodeFilter('img', function (nodes) {
          var i = nodes.length, node, className;
          while (i--) {
            node = nodes[i];
            className = node.attr('class');
            if (className && className.indexOf(pageBreakClass) !== -1) {
              var parentNode = node.parent;
              if (editor.schema.getBlockElements()[parentNode.name] && shouldSplitBlock$1()) {
                parentNode.type = 3;
                parentNode.value = separatorHtml;
                parentNode.raw = true;
                node.remove();
                continue;
              }
              node.type = 3;
              node.value = separatorHtml;
              node.raw = true;
            }
          }
        });
      });
    };

    var register$1 = function (editor) {
      editor.addCommand('mcePageBreak', function () {
        editor.insertContent(getPlaceholderHtml(shouldSplitBlock(editor)));
      });
    };

    var setup = function (editor) {
      editor.on('ResolveName', function (e) {
        if (e.target.nodeName === 'IMG' && editor.dom.hasClass(e.target, pageBreakClass)) {
          e.name = 'pagebreak';
        }
      });
    };

    var register = function (editor) {
      var onAction = function () {
        return editor.execCommand('mcePageBreak');
      };
      editor.ui.registry.addButton('pagebreak', {
        icon: 'page-break',
        tooltip: 'Page break',
        onAction: onAction
      });
      editor.ui.registry.addMenuItem('pagebreak', {
        text: 'Page break',
        icon: 'page-break',
        onAction: onAction
      });
    };

    function Plugin () {
      global$1.add('pagebreak', function (editor) {
        register$1(editor);
        register(editor);
        setup$1(editor);
        setup(editor);
      });
    }

    Plugin();

}());


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "paste" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/paste')
//   ES2015:
//     import 'tinymce/plugins/paste'
__webpack_require__(1505);

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 *
 * Version: 5.10.5 (2022-05-25)
 */
(function () {
    'use strict';

    var Cell = function (initial) {
      var value = initial;
      var get = function () {
        return value;
      };
      var set = function (v) {
        value = v;
      };
      return {
        get: get,
        set: set
      };
    };

    var global$b = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var hasProPlugin = function (editor) {
      if (editor.hasPlugin('powerpaste', true)) {
        if (typeof window.console !== 'undefined' && window.console.log) {
          window.console.log('PowerPaste is incompatible with Paste plugin! Remove \'paste\' from the \'plugins\' option.');
        }
        return true;
      } else {
        return false;
      }
    };

    var get = function (clipboard) {
      return { clipboard: clipboard };
    };

    var typeOf = function (x) {
      var t = typeof x;
      if (x === null) {
        return 'null';
      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
        return 'array';
      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
        return 'string';
      } else {
        return t;
      }
    };
    var isType = function (type) {
      return function (value) {
        return typeOf(value) === type;
      };
    };
    var isSimpleType = function (type) {
      return function (value) {
        return typeof value === type;
      };
    };
    var isArray = isType('array');
    var isNullable = function (a) {
      return a === null || a === undefined;
    };
    var isNonNullable = function (a) {
      return !isNullable(a);
    };
    var isFunction = isSimpleType('function');

    var noop = function () {
    };
    var constant = function (value) {
      return function () {
        return value;
      };
    };
    var identity = function (x) {
      return x;
    };
    var never = constant(false);
    var always = constant(true);

    var none = function () {
      return NONE;
    };
    var NONE = function () {
      var call = function (thunk) {
        return thunk();
      };
      var id = identity;
      var me = {
        fold: function (n, _s) {
          return n();
        },
        isSome: never,
        isNone: always,
        getOr: id,
        getOrThunk: call,
        getOrDie: function (msg) {
          throw new Error(msg || 'error: getOrDie called on none.');
        },
        getOrNull: constant(null),
        getOrUndefined: constant(undefined),
        or: id,
        orThunk: call,
        map: none,
        each: noop,
        bind: none,
        exists: never,
        forall: always,
        filter: function () {
          return none();
        },
        toArray: function () {
          return [];
        },
        toString: constant('none()')
      };
      return me;
    }();
    var some = function (a) {
      var constant_a = constant(a);
      var self = function () {
        return me;
      };
      var bind = function (f) {
        return f(a);
      };
      var me = {
        fold: function (n, s) {
          return s(a);
        },
        isSome: always,
        isNone: never,
        getOr: constant_a,
        getOrThunk: constant_a,
        getOrDie: constant_a,
        getOrNull: constant_a,
        getOrUndefined: constant_a,
        or: self,
        orThunk: self,
        map: function (f) {
          return some(f(a));
        },
        each: function (f) {
          f(a);
        },
        bind: bind,
        exists: bind,
        forall: bind,
        filter: function (f) {
          return f(a) ? me : NONE;
        },
        toArray: function () {
          return [a];
        },
        toString: function () {
          return 'some(' + a + ')';
        }
      };
      return me;
    };
    var from$1 = function (value) {
      return value === null || value === undefined ? NONE : some(value);
    };
    var Optional = {
      some: some,
      none: none,
      from: from$1
    };

    var nativeSlice = Array.prototype.slice;
    var nativePush = Array.prototype.push;
    var exists = function (xs, pred) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i)) {
          return true;
        }
      }
      return false;
    };
    var map = function (xs, f) {
      var len = xs.length;
      var r = new Array(len);
      for (var i = 0; i < len; i++) {
        var x = xs[i];
        r[i] = f(x, i);
      }
      return r;
    };
    var each = function (xs, f) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        f(x, i);
      }
    };
    var filter$1 = function (xs, pred) {
      var r = [];
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i)) {
          r.push(x);
        }
      }
      return r;
    };
    var foldl = function (xs, f, acc) {
      each(xs, function (x, i) {
        acc = f(acc, x, i);
      });
      return acc;
    };
    var flatten = function (xs) {
      var r = [];
      for (var i = 0, len = xs.length; i < len; ++i) {
        if (!isArray(xs[i])) {
          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
        }
        nativePush.apply(r, xs[i]);
      }
      return r;
    };
    var bind = function (xs, f) {
      return flatten(map(xs, f));
    };
    var from = isFunction(Array.from) ? Array.from : function (x) {
      return nativeSlice.call(x);
    };

    var __assign = function () {
      __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };

    var singleton = function (doRevoke) {
      var subject = Cell(Optional.none());
      var revoke = function () {
        return subject.get().each(doRevoke);
      };
      var clear = function () {
        revoke();
        subject.set(Optional.none());
      };
      var isSet = function () {
        return subject.get().isSome();
      };
      var get = function () {
        return subject.get();
      };
      var set = function (s) {
        revoke();
        subject.set(Optional.some(s));
      };
      return {
        clear: clear,
        isSet: isSet,
        get: get,
        set: set
      };
    };
    var value = function () {
      var subject = singleton(noop);
      var on = function (f) {
        return subject.get().each(f);
      };
      return __assign(__assign({}, subject), { on: on });
    };

    var checkRange = function (str, substr, start) {
      return substr === '' || str.length >= substr.length && str.substr(start, start + substr.length) === substr;
    };
    var startsWith = function (str, prefix) {
      return checkRange(str, prefix, 0);
    };
    var endsWith = function (str, suffix) {
      return checkRange(str, suffix, str.length - suffix.length);
    };
    var repeat = function (s, count) {
      return count <= 0 ? '' : new Array(count + 1).join(s);
    };

    var global$a = tinymce.util.Tools.resolve('tinymce.Env');

    var global$9 = tinymce.util.Tools.resolve('tinymce.util.Delay');

    var global$8 = tinymce.util.Tools.resolve('tinymce.util.Promise');

    var global$7 = tinymce.util.Tools.resolve('tinymce.util.VK');

    var firePastePreProcess = function (editor, html, internal, isWordHtml) {
      return editor.fire('PastePreProcess', {
        content: html,
        internal: internal,
        wordContent: isWordHtml
      });
    };
    var firePastePostProcess = function (editor, node, internal, isWordHtml) {
      return editor.fire('PastePostProcess', {
        node: node,
        internal: internal,
        wordContent: isWordHtml
      });
    };
    var firePastePlainTextToggle = function (editor, state) {
      return editor.fire('PastePlainTextToggle', { state: state });
    };
    var firePaste = function (editor, ieFake) {
      return editor.fire('paste', { ieFake: ieFake });
    };

    var global$6 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var shouldBlockDrop = function (editor) {
      return editor.getParam('paste_block_drop', false);
    };
    var shouldPasteDataImages = function (editor) {
      return editor.getParam('paste_data_images', false);
    };
    var shouldFilterDrop = function (editor) {
      return editor.getParam('paste_filter_drop', true);
    };
    var getPreProcess = function (editor) {
      return editor.getParam('paste_preprocess');
    };
    var getPostProcess = function (editor) {
      return editor.getParam('paste_postprocess');
    };
    var getWebkitStyles = function (editor) {
      return editor.getParam('paste_webkit_styles');
    };
    var shouldRemoveWebKitStyles = function (editor) {
      return editor.getParam('paste_remove_styles_if_webkit', true);
    };
    var shouldMergeFormats = function (editor) {
      return editor.getParam('paste_merge_formats', true);
    };
    var isSmartPasteEnabled = function (editor) {
      return editor.getParam('smart_paste', true);
    };
    var isPasteAsTextEnabled = function (editor) {
      return editor.getParam('paste_as_text', false);
    };
    var getRetainStyleProps = function (editor) {
      return editor.getParam('paste_retain_style_properties');
    };
    var getWordValidElements = function (editor) {
      var defaultValidElements = '-strong/b,-em/i,-u,-span,-p,-ol,-ul,-li,-h1,-h2,-h3,-h4,-h5,-h6,' + '-p/div,-a[href|name],sub,sup,strike,br,del,table[width],tr,' + 'td[colspan|rowspan|width],th[colspan|rowspan|width],thead,tfoot,tbody';
      return editor.getParam('paste_word_valid_elements', defaultValidElements);
    };
    var shouldConvertWordFakeLists = function (editor) {
      return editor.getParam('paste_convert_word_fake_lists', true);
    };
    var shouldUseDefaultFilters = function (editor) {
      return editor.getParam('paste_enable_default_filters', true);
    };
    var getValidate = function (editor) {
      return editor.getParam('validate');
    };
    var getAllowHtmlDataUrls = function (editor) {
      return editor.getParam('allow_html_data_urls', false, 'boolean');
    };
    var getPasteDataImages = function (editor) {
      return editor.getParam('paste_data_images', false, 'boolean');
    };
    var getImagesDataImgFilter = function (editor) {
      return editor.getParam('images_dataimg_filter');
    };
    var getImagesReuseFilename = function (editor) {
      return editor.getParam('images_reuse_filename');
    };
    var getForcedRootBlock = function (editor) {
      return editor.getParam('forced_root_block');
    };
    var getForcedRootBlockAttrs = function (editor) {
      return editor.getParam('forced_root_block_attrs');
    };
    var getTabSpaces = function (editor) {
      return editor.getParam('paste_tab_spaces', 4, 'number');
    };
    var getAllowedImageFileTypes = function (editor) {
      var defaultImageFileTypes = 'jpeg,jpg,jpe,jfi,jif,jfif,png,gif,bmp,webp';
      return global$6.explode(editor.getParam('images_file_types', defaultImageFileTypes, 'string'));
    };

    var internalMimeType = 'x-tinymce/html';
    var internalMark = '<!-- ' + internalMimeType + ' -->';
    var mark = function (html) {
      return internalMark + html;
    };
    var unmark = function (html) {
      return html.replace(internalMark, '');
    };
    var isMarked = function (html) {
      return html.indexOf(internalMark) !== -1;
    };
    var internalHtmlMime = constant(internalMimeType);

    var hasOwnProperty = Object.hasOwnProperty;
    var has = function (obj, key) {
      return hasOwnProperty.call(obj, key);
    };

    var global$5 = tinymce.util.Tools.resolve('tinymce.html.Entities');

    var isPlainText = function (text) {
      return !/<(?:\/?(?!(?:div|p|br|span)>)\w+|(?:(?!(?:span style="white-space:\s?pre;?">)|br\s?\/>))\w+\s[^>]+)>/i.test(text);
    };
    var toBRs = function (text) {
      return text.replace(/\r?\n/g, '<br>');
    };
    var openContainer = function (rootTag, rootAttrs) {
      var attrs = [];
      var tag = '<' + rootTag;
      if (typeof rootAttrs === 'object') {
        for (var key in rootAttrs) {
          if (has(rootAttrs, key)) {
            attrs.push(key + '="' + global$5.encodeAllRaw(rootAttrs[key]) + '"');
          }
        }
        if (attrs.length) {
          tag += ' ' + attrs.join(' ');
        }
      }
      return tag + '>';
    };
    var toBlockElements = function (text, rootTag, rootAttrs) {
      var blocks = text.split(/\n\n/);
      var tagOpen = openContainer(rootTag, rootAttrs);
      var tagClose = '</' + rootTag + '>';
      var paragraphs = global$6.map(blocks, function (p) {
        return p.split(/\n/).join('<br />');
      });
      var stitch = function (p) {
        return tagOpen + p + tagClose;
      };
      return paragraphs.length === 1 ? paragraphs[0] : global$6.map(paragraphs, stitch).join('');
    };
    var convert = function (text, rootTag, rootAttrs) {
      return rootTag ? toBlockElements(text, rootTag === true ? 'p' : rootTag, rootAttrs) : toBRs(text);
    };

    var global$4 = tinymce.util.Tools.resolve('tinymce.html.DomParser');

    var global$3 = tinymce.util.Tools.resolve('tinymce.html.Serializer');

    var nbsp = '\xA0';

    var global$2 = tinymce.util.Tools.resolve('tinymce.html.Node');

    var global$1 = tinymce.util.Tools.resolve('tinymce.html.Schema');

    var isRegExp = function (val) {
      return val.constructor === RegExp;
    };
    var filter = function (content, items) {
      global$6.each(items, function (v) {
        if (isRegExp(v)) {
          content = content.replace(v, '');
        } else {
          content = content.replace(v[0], v[1]);
        }
      });
      return content;
    };
    var innerText = function (html) {
      var schema = global$1();
      var domParser = global$4({}, schema);
      var text = '';
      var shortEndedElements = schema.getShortEndedElements();
      var ignoreElements = global$6.makeMap('script noscript style textarea video audio iframe object', ' ');
      var blockElements = schema.getBlockElements();
      var walk = function (node) {
        var name = node.name, currentNode = node;
        if (name === 'br') {
          text += '\n';
          return;
        }
        if (name === 'wbr') {
          return;
        }
        if (shortEndedElements[name]) {
          text += ' ';
        }
        if (ignoreElements[name]) {
          text += ' ';
          return;
        }
        if (node.type === 3) {
          text += node.value;
        }
        if (!node.shortEnded) {
          if (node = node.firstChild) {
            do {
              walk(node);
            } while (node = node.next);
          }
        }
        if (blockElements[name] && currentNode.next) {
          text += '\n';
          if (name === 'p') {
            text += '\n';
          }
        }
      };
      html = filter(html, [/<!\[[^\]]+\]>/g]);
      walk(domParser.parse(html));
      return text;
    };
    var trimHtml = function (html) {
      var trimSpaces = function (all, s1, s2) {
        if (!s1 && !s2) {
          return ' ';
        }
        return nbsp;
      };
      html = filter(html, [
        /^[\s\S]*<body[^>]*>\s*|\s*<\/body[^>]*>[\s\S]*$/ig,
        /<!--StartFragment-->|<!--EndFragment-->/g,
        [
          /( ?)<span class="Apple-converted-space">\u00a0<\/span>( ?)/g,
          trimSpaces
        ],
        /<br class="Apple-interchange-newline">/g,
        /<br>$/i
      ]);
      return html;
    };
    var createIdGenerator = function (prefix) {
      var count = 0;
      return function () {
        return prefix + count++;
      };
    };
    var getImageMimeType = function (ext) {
      var lowerExt = ext.toLowerCase();
      var mimeOverrides = {
        jpg: 'jpeg',
        jpe: 'jpeg',
        jfi: 'jpeg',
        jif: 'jpeg',
        jfif: 'jpeg',
        pjpeg: 'jpeg',
        pjp: 'jpeg',
        svg: 'svg+xml'
      };
      return global$6.hasOwn(mimeOverrides, lowerExt) ? 'image/' + mimeOverrides[lowerExt] : 'image/' + lowerExt;
    };

    var isWordContent = function (content) {
      return /<font face="Times New Roman"|class="?Mso|style="[^"]*\bmso-|style='[^']*\bmso-|w:WordDocument/i.test(content) || /class="OutlineElement/.test(content) || /id="?docs\-internal\-guid\-/.test(content);
    };
    var isNumericList = function (text) {
      var found = false;
      var patterns = [
        /^[IVXLMCD]+\.[ \u00a0]/,
        /^[ivxlmcd]+\.[ \u00a0]/,
        /^[a-z]{1,2}[\.\)][ \u00a0]/,
        /^[A-Z]{1,2}[\.\)][ \u00a0]/,
        /^[0-9]+\.[ \u00a0]/,
        /^[\u3007\u4e00\u4e8c\u4e09\u56db\u4e94\u516d\u4e03\u516b\u4e5d]+\.[ \u00a0]/,
        /^[\u58f1\u5f10\u53c2\u56db\u4f0d\u516d\u4e03\u516b\u4e5d\u62fe]+\.[ \u00a0]/
      ];
      text = text.replace(/^[\u00a0 ]+/, '');
      global$6.each(patterns, function (pattern) {
        if (pattern.test(text)) {
          found = true;
          return false;
        }
      });
      return found;
    };
    var isBulletList = function (text) {
      return /^[\s\u00a0]*[\u2022\u00b7\u00a7\u25CF]\s*/.test(text);
    };
    var convertFakeListsToProperLists = function (node) {
      var currentListNode, prevListNode, lastLevel = 1;
      var getText = function (node) {
        var txt = '';
        if (node.type === 3) {
          return node.value;
        }
        if (node = node.firstChild) {
          do {
            txt += getText(node);
          } while (node = node.next);
        }
        return txt;
      };
      var trimListStart = function (node, regExp) {
        if (node.type === 3) {
          if (regExp.test(node.value)) {
            node.value = node.value.replace(regExp, '');
            return false;
          }
        }
        if (node = node.firstChild) {
          do {
            if (!trimListStart(node, regExp)) {
              return false;
            }
          } while (node = node.next);
        }
        return true;
      };
      var removeIgnoredNodes = function (node) {
        if (node._listIgnore) {
          node.remove();
          return;
        }
        if (node = node.firstChild) {
          do {
            removeIgnoredNodes(node);
          } while (node = node.next);
        }
      };
      var convertParagraphToLi = function (paragraphNode, listName, start) {
        var level = paragraphNode._listLevel || lastLevel;
        if (level !== lastLevel) {
          if (level < lastLevel) {
            if (currentListNode) {
              currentListNode = currentListNode.parent.parent;
            }
          } else {
            prevListNode = currentListNode;
            currentListNode = null;
          }
        }
        if (!currentListNode || currentListNode.name !== listName) {
          prevListNode = prevListNode || currentListNode;
          currentListNode = new global$2(listName, 1);
          if (start > 1) {
            currentListNode.attr('start', '' + start);
          }
          paragraphNode.wrap(currentListNode);
        } else {
          currentListNode.append(paragraphNode);
        }
        paragraphNode.name = 'li';
        if (level > lastLevel && prevListNode) {
          prevListNode.lastChild.append(currentListNode);
        }
        lastLevel = level;
        removeIgnoredNodes(paragraphNode);
        trimListStart(paragraphNode, /^\u00a0+/);
        trimListStart(paragraphNode, /^\s*([\u2022\u00b7\u00a7\u25CF]|\w+\.)/);
        trimListStart(paragraphNode, /^\u00a0+/);
      };
      var elements = [];
      var child = node.firstChild;
      while (typeof child !== 'undefined' && child !== null) {
        elements.push(child);
        child = child.walk();
        if (child !== null) {
          while (typeof child !== 'undefined' && child.parent !== node) {
            child = child.walk();
          }
        }
      }
      for (var i = 0; i < elements.length; i++) {
        node = elements[i];
        if (node.name === 'p' && node.firstChild) {
          var nodeText = getText(node);
          if (isBulletList(nodeText)) {
            convertParagraphToLi(node, 'ul');
            continue;
          }
          if (isNumericList(nodeText)) {
            var matches = /([0-9]+)\./.exec(nodeText);
            var start = 1;
            if (matches) {
              start = parseInt(matches[1], 10);
            }
            convertParagraphToLi(node, 'ol', start);
            continue;
          }
          if (node._listLevel) {
            convertParagraphToLi(node, 'ul', 1);
            continue;
          }
          currentListNode = null;
        } else {
          prevListNode = currentListNode;
          currentListNode = null;
        }
      }
    };
    var filterStyles = function (editor, validStyles, node, styleValue) {
      var outputStyles = {};
      var styles = editor.dom.parseStyle(styleValue);
      global$6.each(styles, function (value, name) {
        switch (name) {
        case 'mso-list':
          var matches = /\w+ \w+([0-9]+)/i.exec(styleValue);
          if (matches) {
            node._listLevel = parseInt(matches[1], 10);
          }
          if (/Ignore/i.test(value) && node.firstChild) {
            node._listIgnore = true;
            node.firstChild._listIgnore = true;
          }
          break;
        case 'horiz-align':
          name = 'text-align';
          break;
        case 'vert-align':
          name = 'vertical-align';
          break;
        case 'font-color':
        case 'mso-foreground':
          name = 'color';
          break;
        case 'mso-background':
        case 'mso-highlight':
          name = 'background';
          break;
        case 'font-weight':
        case 'font-style':
          if (value !== 'normal') {
            outputStyles[name] = value;
          }
          return;
        case 'mso-element':
          if (/^(comment|comment-list)$/i.test(value)) {
            node.remove();
            return;
          }
          break;
        }
        if (name.indexOf('mso-comment') === 0) {
          node.remove();
          return;
        }
        if (name.indexOf('mso-') === 0) {
          return;
        }
        if (getRetainStyleProps(editor) === 'all' || validStyles && validStyles[name]) {
          outputStyles[name] = value;
        }
      });
      if (/(bold)/i.test(outputStyles['font-weight'])) {
        delete outputStyles['font-weight'];
        node.wrap(new global$2('b', 1));
      }
      if (/(italic)/i.test(outputStyles['font-style'])) {
        delete outputStyles['font-style'];
        node.wrap(new global$2('i', 1));
      }
      var outputStyle = editor.dom.serializeStyle(outputStyles, node.name);
      if (outputStyle) {
        return outputStyle;
      }
      return null;
    };
    var filterWordContent = function (editor, content) {
      var validStyles;
      var retainStyleProperties = getRetainStyleProps(editor);
      if (retainStyleProperties) {
        validStyles = global$6.makeMap(retainStyleProperties.split(/[, ]/));
      }
      content = filter(content, [
        /<br class="?Apple-interchange-newline"?>/gi,
        /<b[^>]+id="?docs-internal-[^>]*>/gi,
        /<!--[\s\S]+?-->/gi,
        /<(!|script[^>]*>.*?<\/script(?=[>\s])|\/?(\?xml(:\w+)?|img|meta|link|style|\w:\w+)(?=[\s\/>]))[^>]*>/gi,
        [
          /<(\/?)s>/gi,
          '<$1strike>'
        ],
        [
          /&nbsp;/gi,
          nbsp
        ],
        [
          /<span\s+style\s*=\s*"\s*mso-spacerun\s*:\s*yes\s*;?\s*"\s*>([\s\u00a0]*)<\/span>/gi,
          function (str, spaces) {
            return spaces.length > 0 ? spaces.replace(/./, ' ').slice(Math.floor(spaces.length / 2)).split('').join(nbsp) : '';
          }
        ]
      ]);
      var validElements = getWordValidElements(editor);
      var schema = global$1({
        valid_elements: validElements,
        valid_children: '-li[p]'
      });
      global$6.each(schema.elements, function (rule) {
        if (!rule.attributes.class) {
          rule.attributes.class = {};
          rule.attributesOrder.push('class');
        }
        if (!rule.attributes.style) {
          rule.attributes.style = {};
          rule.attributesOrder.push('style');
        }
      });
      var domParser = global$4({}, schema);
      domParser.addAttributeFilter('style', function (nodes) {
        var i = nodes.length, node;
        while (i--) {
          node = nodes[i];
          node.attr('style', filterStyles(editor, validStyles, node, node.attr('style')));
          if (node.name === 'span' && node.parent && !node.attributes.length) {
            node.unwrap();
          }
        }
      });
      domParser.addAttributeFilter('class', function (nodes) {
        var i = nodes.length, node, className;
        while (i--) {
          node = nodes[i];
          className = node.attr('class');
          if (/^(MsoCommentReference|MsoCommentText|msoDel)$/i.test(className)) {
            node.remove();
          }
          node.attr('class', null);
        }
      });
      domParser.addNodeFilter('del', function (nodes) {
        var i = nodes.length;
        while (i--) {
          nodes[i].remove();
        }
      });
      domParser.addNodeFilter('a', function (nodes) {
        var i = nodes.length, node, href, name;
        while (i--) {
          node = nodes[i];
          href = node.attr('href');
          name = node.attr('name');
          if (href && href.indexOf('#_msocom_') !== -1) {
            node.remove();
            continue;
          }
          if (href && href.indexOf('file://') === 0) {
            href = href.split('#')[1];
            if (href) {
              href = '#' + href;
            }
          }
          if (!href && !name) {
            node.unwrap();
          } else {
            if (name && !/^_?(?:toc|edn|ftn)/i.test(name)) {
              node.unwrap();
              continue;
            }
            node.attr({
              href: href,
              name: name
            });
          }
        }
      });
      var rootNode = domParser.parse(content);
      if (shouldConvertWordFakeLists(editor)) {
        convertFakeListsToProperLists(rootNode);
      }
      content = global$3({ validate: getValidate(editor) }, schema).serialize(rootNode);
      return content;
    };
    var preProcess$1 = function (editor, content) {
      return shouldUseDefaultFilters(editor) ? filterWordContent(editor, content) : content;
    };

    var preProcess = function (editor, html) {
      var parser = global$4({}, editor.schema);
      parser.addNodeFilter('meta', function (nodes) {
        global$6.each(nodes, function (node) {
          node.remove();
        });
      });
      var fragment = parser.parse(html, {
        forced_root_block: false,
        isRootContent: true
      });
      return global$3({ validate: getValidate(editor) }, editor.schema).serialize(fragment);
    };
    var processResult = function (content, cancelled) {
      return {
        content: content,
        cancelled: cancelled
      };
    };
    var postProcessFilter = function (editor, html, internal, isWordHtml) {
      var tempBody = editor.dom.create('div', { style: 'display:none' }, html);
      var postProcessArgs = firePastePostProcess(editor, tempBody, internal, isWordHtml);
      return processResult(postProcessArgs.node.innerHTML, postProcessArgs.isDefaultPrevented());
    };
    var filterContent = function (editor, content, internal, isWordHtml) {
      var preProcessArgs = firePastePreProcess(editor, content, internal, isWordHtml);
      var filteredContent = preProcess(editor, preProcessArgs.content);
      if (editor.hasEventListeners('PastePostProcess') && !preProcessArgs.isDefaultPrevented()) {
        return postProcessFilter(editor, filteredContent, internal, isWordHtml);
      } else {
        return processResult(filteredContent, preProcessArgs.isDefaultPrevented());
      }
    };
    var process = function (editor, html, internal) {
      var isWordHtml = isWordContent(html);
      var content = isWordHtml ? preProcess$1(editor, html) : html;
      return filterContent(editor, content, internal, isWordHtml);
    };

    var pasteHtml$1 = function (editor, html) {
      editor.insertContent(html, {
        merge: shouldMergeFormats(editor),
        paste: true
      });
      return true;
    };
    var isAbsoluteUrl = function (url) {
      return /^https?:\/\/[\w\?\-\/+=.&%@~#]+$/i.test(url);
    };
    var isImageUrl = function (editor, url) {
      return isAbsoluteUrl(url) && exists(getAllowedImageFileTypes(editor), function (type) {
        return endsWith(url.toLowerCase(), '.' + type.toLowerCase());
      });
    };
    var createImage = function (editor, url, pasteHtmlFn) {
      editor.undoManager.extra(function () {
        pasteHtmlFn(editor, url);
      }, function () {
        editor.insertContent('<img src="' + url + '">');
      });
      return true;
    };
    var createLink = function (editor, url, pasteHtmlFn) {
      editor.undoManager.extra(function () {
        pasteHtmlFn(editor, url);
      }, function () {
        editor.execCommand('mceInsertLink', false, url);
      });
      return true;
    };
    var linkSelection = function (editor, html, pasteHtmlFn) {
      return editor.selection.isCollapsed() === false && isAbsoluteUrl(html) ? createLink(editor, html, pasteHtmlFn) : false;
    };
    var insertImage = function (editor, html, pasteHtmlFn) {
      return isImageUrl(editor, html) ? createImage(editor, html, pasteHtmlFn) : false;
    };
    var smartInsertContent = function (editor, html) {
      global$6.each([
        linkSelection,
        insertImage,
        pasteHtml$1
      ], function (action) {
        return action(editor, html, pasteHtml$1) !== true;
      });
    };
    var insertContent = function (editor, html, pasteAsText) {
      if (pasteAsText || isSmartPasteEnabled(editor) === false) {
        pasteHtml$1(editor, html);
      } else {
        smartInsertContent(editor, html);
      }
    };

    var isCollapsibleWhitespace = function (c) {
      return ' \f\t\x0B'.indexOf(c) !== -1;
    };
    var isNewLineChar = function (c) {
      return c === '\n' || c === '\r';
    };
    var isNewline = function (text, idx) {
      return idx < text.length && idx >= 0 ? isNewLineChar(text[idx]) : false;
    };
    var normalizeWhitespace = function (editor, text) {
      var tabSpace = repeat(' ', getTabSpaces(editor));
      var normalizedText = text.replace(/\t/g, tabSpace);
      var result = foldl(normalizedText, function (acc, c) {
        if (isCollapsibleWhitespace(c) || c === nbsp) {
          if (acc.pcIsSpace || acc.str === '' || acc.str.length === normalizedText.length - 1 || isNewline(normalizedText, acc.str.length + 1)) {
            return {
              pcIsSpace: false,
              str: acc.str + nbsp
            };
          } else {
            return {
              pcIsSpace: true,
              str: acc.str + ' '
            };
          }
        } else {
          return {
            pcIsSpace: isNewLineChar(c),
            str: acc.str + c
          };
        }
      }, {
        pcIsSpace: false,
        str: ''
      });
      return result.str;
    };

    var doPaste = function (editor, content, internal, pasteAsText) {
      var args = process(editor, content, internal);
      if (args.cancelled === false) {
        insertContent(editor, args.content, pasteAsText);
      }
    };
    var pasteHtml = function (editor, html, internalFlag) {
      var internal = internalFlag ? internalFlag : isMarked(html);
      doPaste(editor, unmark(html), internal, false);
    };
    var pasteText = function (editor, text) {
      var encodedText = editor.dom.encode(text).replace(/\r\n/g, '\n');
      var normalizedText = normalizeWhitespace(editor, encodedText);
      var html = convert(normalizedText, getForcedRootBlock(editor), getForcedRootBlockAttrs(editor));
      doPaste(editor, html, false, true);
    };
    var getDataTransferItems = function (dataTransfer) {
      var items = {};
      var mceInternalUrlPrefix = 'data:text/mce-internal,';
      if (dataTransfer) {
        if (dataTransfer.getData) {
          var legacyText = dataTransfer.getData('Text');
          if (legacyText && legacyText.length > 0) {
            if (legacyText.indexOf(mceInternalUrlPrefix) === -1) {
              items['text/plain'] = legacyText;
            }
          }
        }
        if (dataTransfer.types) {
          for (var i = 0; i < dataTransfer.types.length; i++) {
            var contentType = dataTransfer.types[i];
            try {
              items[contentType] = dataTransfer.getData(contentType);
            } catch (ex) {
              items[contentType] = '';
            }
          }
        }
      }
      return items;
    };
    var getClipboardContent = function (editor, clipboardEvent) {
      return getDataTransferItems(clipboardEvent.clipboardData || editor.getDoc().dataTransfer);
    };
    var hasContentType = function (clipboardContent, mimeType) {
      return mimeType in clipboardContent && clipboardContent[mimeType].length > 0;
    };
    var hasHtmlOrText = function (content) {
      return hasContentType(content, 'text/html') || hasContentType(content, 'text/plain');
    };
    var parseDataUri = function (uri) {
      var matches = /data:([^;]+);base64,([a-z0-9\+\/=]+)/i.exec(uri);
      if (matches) {
        return {
          type: matches[1],
          data: decodeURIComponent(matches[2])
        };
      } else {
        return {
          type: null,
          data: null
        };
      }
    };
    var isValidDataUriImage = function (editor, imgElm) {
      var filter = getImagesDataImgFilter(editor);
      return filter ? filter(imgElm) : true;
    };
    var extractFilename = function (editor, str) {
      var m = str.match(/([\s\S]+?)(?:\.[a-z0-9.]+)$/i);
      return isNonNullable(m) ? editor.dom.encode(m[1]) : null;
    };
    var uniqueId = createIdGenerator('mceclip');
    var pasteImage = function (editor, imageItem) {
      var _a = parseDataUri(imageItem.uri), base64 = _a.data, type = _a.type;
      var id = uniqueId();
      var file = imageItem.blob;
      var img = new Image();
      img.src = imageItem.uri;
      if (isValidDataUriImage(editor, img)) {
        var blobCache = editor.editorUpload.blobCache;
        var blobInfo = void 0;
        var existingBlobInfo = blobCache.getByData(base64, type);
        if (!existingBlobInfo) {
          var useFileName = getImagesReuseFilename(editor) && isNonNullable(file.name);
          var name_1 = useFileName ? extractFilename(editor, file.name) : id;
          var filename = useFileName ? file.name : undefined;
          blobInfo = blobCache.create(id, file, base64, name_1, filename);
          blobCache.add(blobInfo);
        } else {
          blobInfo = existingBlobInfo;
        }
        pasteHtml(editor, '<img src="' + blobInfo.blobUri() + '">', false);
      } else {
        pasteHtml(editor, '<img src="' + imageItem.uri + '">', false);
      }
    };
    var isClipboardEvent = function (event) {
      return event.type === 'paste';
    };
    var isDataTransferItem = function (item) {
      return isNonNullable(item.getAsFile);
    };
    var readFilesAsDataUris = function (items) {
      return global$8.all(map(items, function (item) {
        return new global$8(function (resolve) {
          var blob = isDataTransferItem(item) ? item.getAsFile() : item;
          var reader = new window.FileReader();
          reader.onload = function () {
            resolve({
              blob: blob,
              uri: reader.result
            });
          };
          reader.readAsDataURL(blob);
        });
      }));
    };
    var isImage = function (editor) {
      var allowedExtensions = getAllowedImageFileTypes(editor);
      return function (file) {
        return startsWith(file.type, 'image/') && exists(allowedExtensions, function (extension) {
          return getImageMimeType(extension) === file.type;
        });
      };
    };
    var getImagesFromDataTransfer = function (editor, dataTransfer) {
      var items = dataTransfer.items ? bind(from(dataTransfer.items), function (item) {
        return item.kind === 'file' ? [item.getAsFile()] : [];
      }) : [];
      var files = dataTransfer.files ? from(dataTransfer.files) : [];
      return filter$1(items.length > 0 ? items : files, isImage(editor));
    };
    var pasteImageData = function (editor, e, rng) {
      var dataTransfer = isClipboardEvent(e) ? e.clipboardData : e.dataTransfer;
      if (getPasteDataImages(editor) && dataTransfer) {
        var images = getImagesFromDataTransfer(editor, dataTransfer);
        if (images.length > 0) {
          e.preventDefault();
          readFilesAsDataUris(images).then(function (fileResults) {
            if (rng) {
              editor.selection.setRng(rng);
            }
            each(fileResults, function (result) {
              pasteImage(editor, result);
            });
          });
          return true;
        }
      }
      return false;
    };
    var isBrokenAndroidClipboardEvent = function (e) {
      var clipboardData = e.clipboardData;
      return navigator.userAgent.indexOf('Android') !== -1 && clipboardData && clipboardData.items && clipboardData.items.length === 0;
    };
    var isKeyboardPasteEvent = function (e) {
      return global$7.metaKeyPressed(e) && e.keyCode === 86 || e.shiftKey && e.keyCode === 45;
    };
    var registerEventHandlers = function (editor, pasteBin, pasteFormat) {
      var keyboardPasteEvent = value();
      var keyboardPastePressed = value();
      var keyboardPastePlainTextState;
      editor.on('keyup', keyboardPastePressed.clear);
      editor.on('keydown', function (e) {
        var removePasteBinOnKeyUp = function (e) {
          if (isKeyboardPasteEvent(e) && !e.isDefaultPrevented()) {
            pasteBin.remove();
          }
        };
        if (isKeyboardPasteEvent(e) && !e.isDefaultPrevented()) {
          keyboardPastePlainTextState = e.shiftKey && e.keyCode === 86;
          if (keyboardPastePlainTextState && global$a.webkit && navigator.userAgent.indexOf('Version/') !== -1) {
            return;
          }
          e.stopImmediatePropagation();
          keyboardPasteEvent.set(e);
          keyboardPastePressed.set(true);
          if (global$a.ie && keyboardPastePlainTextState) {
            e.preventDefault();
            firePaste(editor, true);
            return;
          }
          pasteBin.remove();
          pasteBin.create();
          editor.once('keyup', removePasteBinOnKeyUp);
          editor.once('paste', function () {
            editor.off('keyup', removePasteBinOnKeyUp);
          });
        }
      });
      var insertClipboardContent = function (editor, clipboardContent, isKeyBoardPaste, plainTextMode, internal) {
        var content;
        if (hasContentType(clipboardContent, 'text/html')) {
          content = clipboardContent['text/html'];
        } else {
          content = pasteBin.getHtml();
          internal = internal ? internal : isMarked(content);
          if (pasteBin.isDefaultContent(content)) {
            plainTextMode = true;
          }
        }
        content = trimHtml(content);
        pasteBin.remove();
        var isPlainTextHtml = internal === false && isPlainText(content);
        var isAbsoluteUrl$1 = isAbsoluteUrl(content);
        if (!content.length || isPlainTextHtml && !isAbsoluteUrl$1) {
          plainTextMode = true;
        }
        if (plainTextMode || isAbsoluteUrl$1) {
          if (hasContentType(clipboardContent, 'text/plain') && isPlainTextHtml) {
            content = clipboardContent['text/plain'];
          } else {
            content = innerText(content);
          }
        }
        if (pasteBin.isDefaultContent(content)) {
          if (!isKeyBoardPaste) {
            editor.windowManager.alert('Please use Ctrl+V/Cmd+V keyboard shortcuts to paste contents.');
          }
          return;
        }
        if (plainTextMode) {
          pasteText(editor, content);
        } else {
          pasteHtml(editor, content, internal);
        }
      };
      var getLastRng = function () {
        return pasteBin.getLastRng() || editor.selection.getRng();
      };
      editor.on('paste', function (e) {
        var isKeyboardPaste = keyboardPasteEvent.isSet() || keyboardPastePressed.isSet();
        if (isKeyboardPaste) {
          keyboardPasteEvent.clear();
        }
        var clipboardContent = getClipboardContent(editor, e);
        var plainTextMode = pasteFormat.get() === 'text' || keyboardPastePlainTextState;
        var internal = hasContentType(clipboardContent, internalHtmlMime());
        keyboardPastePlainTextState = false;
        if (e.isDefaultPrevented() || isBrokenAndroidClipboardEvent(e)) {
          pasteBin.remove();
          return;
        }
        if (!hasHtmlOrText(clipboardContent) && pasteImageData(editor, e, getLastRng())) {
          pasteBin.remove();
          return;
        }
        if (!isKeyboardPaste) {
          e.preventDefault();
        }
        if (global$a.ie && (!isKeyboardPaste || e.ieFake) && !hasContentType(clipboardContent, 'text/html')) {
          pasteBin.create();
          editor.dom.bind(pasteBin.getEl(), 'paste', function (e) {
            e.stopPropagation();
          });
          editor.getDoc().execCommand('Paste', false, null);
          clipboardContent['text/html'] = pasteBin.getHtml();
        }
        if (hasContentType(clipboardContent, 'text/html')) {
          e.preventDefault();
          if (!internal) {
            internal = isMarked(clipboardContent['text/html']);
          }
          insertClipboardContent(editor, clipboardContent, isKeyboardPaste, plainTextMode, internal);
        } else {
          global$9.setEditorTimeout(editor, function () {
            insertClipboardContent(editor, clipboardContent, isKeyboardPaste, plainTextMode, internal);
          }, 0);
        }
      });
    };
    var registerEventsAndFilters = function (editor, pasteBin, pasteFormat) {
      registerEventHandlers(editor, pasteBin, pasteFormat);
      var src;
      editor.parser.addNodeFilter('img', function (nodes, name, args) {
        var isPasteInsert = function (args) {
          return args.data && args.data.paste === true;
        };
        var remove = function (node) {
          if (!node.attr('data-mce-object') && src !== global$a.transparentSrc) {
            node.remove();
          }
        };
        var isWebKitFakeUrl = function (src) {
          return src.indexOf('webkit-fake-url') === 0;
        };
        var isDataUri = function (src) {
          return src.indexOf('data:') === 0;
        };
        if (!getPasteDataImages(editor) && isPasteInsert(args)) {
          var i = nodes.length;
          while (i--) {
            src = nodes[i].attr('src');
            if (!src) {
              continue;
            }
            if (isWebKitFakeUrl(src)) {
              remove(nodes[i]);
            } else if (!getAllowHtmlDataUrls(editor) && isDataUri(src)) {
              remove(nodes[i]);
            }
          }
        }
      });
    };

    var getPasteBinParent = function (editor) {
      return global$a.ie && editor.inline ? document.body : editor.getBody();
    };
    var isExternalPasteBin = function (editor) {
      return getPasteBinParent(editor) !== editor.getBody();
    };
    var delegatePasteEvents = function (editor, pasteBinElm, pasteBinDefaultContent) {
      if (isExternalPasteBin(editor)) {
        editor.dom.bind(pasteBinElm, 'paste keyup', function (_e) {
          if (!isDefault(editor, pasteBinDefaultContent)) {
            editor.fire('paste');
          }
        });
      }
    };
    var create = function (editor, lastRngCell, pasteBinDefaultContent) {
      var dom = editor.dom, body = editor.getBody();
      lastRngCell.set(editor.selection.getRng());
      var pasteBinElm = editor.dom.add(getPasteBinParent(editor), 'div', {
        'id': 'mcepastebin',
        'class': 'mce-pastebin',
        'contentEditable': true,
        'data-mce-bogus': 'all',
        'style': 'position: fixed; top: 50%; width: 10px; height: 10px; overflow: hidden; opacity: 0'
      }, pasteBinDefaultContent);
      if (global$a.ie || global$a.gecko) {
        dom.setStyle(pasteBinElm, 'left', dom.getStyle(body, 'direction', true) === 'rtl' ? 65535 : -65535);
      }
      dom.bind(pasteBinElm, 'beforedeactivate focusin focusout', function (e) {
        e.stopPropagation();
      });
      delegatePasteEvents(editor, pasteBinElm, pasteBinDefaultContent);
      pasteBinElm.focus();
      editor.selection.select(pasteBinElm, true);
    };
    var remove = function (editor, lastRngCell) {
      if (getEl(editor)) {
        var pasteBinClone = void 0;
        var lastRng = lastRngCell.get();
        while (pasteBinClone = editor.dom.get('mcepastebin')) {
          editor.dom.remove(pasteBinClone);
          editor.dom.unbind(pasteBinClone);
        }
        if (lastRng) {
          editor.selection.setRng(lastRng);
        }
      }
      lastRngCell.set(null);
    };
    var getEl = function (editor) {
      return editor.dom.get('mcepastebin');
    };
    var getHtml = function (editor) {
      var copyAndRemove = function (toElm, fromElm) {
        toElm.appendChild(fromElm);
        editor.dom.remove(fromElm, true);
      };
      var pasteBinClones = global$6.grep(getPasteBinParent(editor).childNodes, function (elm) {
        return elm.id === 'mcepastebin';
      });
      var pasteBinElm = pasteBinClones.shift();
      global$6.each(pasteBinClones, function (pasteBinClone) {
        copyAndRemove(pasteBinElm, pasteBinClone);
      });
      var dirtyWrappers = editor.dom.select('div[id=mcepastebin]', pasteBinElm);
      for (var i = dirtyWrappers.length - 1; i >= 0; i--) {
        var cleanWrapper = editor.dom.create('div');
        pasteBinElm.insertBefore(cleanWrapper, dirtyWrappers[i]);
        copyAndRemove(cleanWrapper, dirtyWrappers[i]);
      }
      return pasteBinElm ? pasteBinElm.innerHTML : '';
    };
    var isDefaultContent = function (pasteBinDefaultContent, content) {
      return content === pasteBinDefaultContent;
    };
    var isPasteBin = function (elm) {
      return elm && elm.id === 'mcepastebin';
    };
    var isDefault = function (editor, pasteBinDefaultContent) {
      var pasteBinElm = getEl(editor);
      return isPasteBin(pasteBinElm) && isDefaultContent(pasteBinDefaultContent, pasteBinElm.innerHTML);
    };
    var PasteBin = function (editor) {
      var lastRng = Cell(null);
      var pasteBinDefaultContent = '%MCEPASTEBIN%';
      return {
        create: function () {
          return create(editor, lastRng, pasteBinDefaultContent);
        },
        remove: function () {
          return remove(editor, lastRng);
        },
        getEl: function () {
          return getEl(editor);
        },
        getHtml: function () {
          return getHtml(editor);
        },
        getLastRng: lastRng.get,
        isDefault: function () {
          return isDefault(editor, pasteBinDefaultContent);
        },
        isDefaultContent: function (content) {
          return isDefaultContent(pasteBinDefaultContent, content);
        }
      };
    };

    var Clipboard = function (editor, pasteFormat) {
      var pasteBin = PasteBin(editor);
      editor.on('PreInit', function () {
        return registerEventsAndFilters(editor, pasteBin, pasteFormat);
      });
      return {
        pasteFormat: pasteFormat,
        pasteHtml: function (html, internalFlag) {
          return pasteHtml(editor, html, internalFlag);
        },
        pasteText: function (text) {
          return pasteText(editor, text);
        },
        pasteImageData: function (e, rng) {
          return pasteImageData(editor, e, rng);
        },
        getDataTransferItems: getDataTransferItems,
        hasHtmlOrText: hasHtmlOrText,
        hasContentType: hasContentType
      };
    };

    var togglePlainTextPaste = function (editor, clipboard) {
      if (clipboard.pasteFormat.get() === 'text') {
        clipboard.pasteFormat.set('html');
        firePastePlainTextToggle(editor, false);
      } else {
        clipboard.pasteFormat.set('text');
        firePastePlainTextToggle(editor, true);
      }
      editor.focus();
    };

    var register$2 = function (editor, clipboard) {
      editor.addCommand('mceTogglePlainTextPaste', function () {
        togglePlainTextPaste(editor, clipboard);
      });
      editor.addCommand('mceInsertClipboardContent', function (ui, value) {
        if (value.content) {
          clipboard.pasteHtml(value.content, value.internal);
        }
        if (value.text) {
          clipboard.pasteText(value.text);
        }
      });
    };

    var hasWorkingClipboardApi = function (clipboardData) {
      return global$a.iOS === false && typeof (clipboardData === null || clipboardData === void 0 ? void 0 : clipboardData.setData) === 'function';
    };
    var setHtml5Clipboard = function (clipboardData, html, text) {
      if (hasWorkingClipboardApi(clipboardData)) {
        try {
          clipboardData.clearData();
          clipboardData.setData('text/html', html);
          clipboardData.setData('text/plain', text);
          clipboardData.setData(internalHtmlMime(), html);
          return true;
        } catch (e) {
          return false;
        }
      } else {
        return false;
      }
    };
    var setClipboardData = function (evt, data, fallback, done) {
      if (setHtml5Clipboard(evt.clipboardData, data.html, data.text)) {
        evt.preventDefault();
        done();
      } else {
        fallback(data.html, done);
      }
    };
    var fallback = function (editor) {
      return function (html, done) {
        var markedHtml = mark(html);
        var outer = editor.dom.create('div', {
          'contenteditable': 'false',
          'data-mce-bogus': 'all'
        });
        var inner = editor.dom.create('div', { contenteditable: 'true' }, markedHtml);
        editor.dom.setStyles(outer, {
          position: 'fixed',
          top: '0',
          left: '-3000px',
          width: '1000px',
          overflow: 'hidden'
        });
        outer.appendChild(inner);
        editor.dom.add(editor.getBody(), outer);
        var range = editor.selection.getRng();
        inner.focus();
        var offscreenRange = editor.dom.createRng();
        offscreenRange.selectNodeContents(inner);
        editor.selection.setRng(offscreenRange);
        global$9.setTimeout(function () {
          editor.selection.setRng(range);
          outer.parentNode.removeChild(outer);
          done();
        }, 0);
      };
    };
    var getData = function (editor) {
      return {
        html: editor.selection.getContent({ contextual: true }),
        text: editor.selection.getContent({ format: 'text' })
      };
    };
    var isTableSelection = function (editor) {
      return !!editor.dom.getParent(editor.selection.getStart(), 'td[data-mce-selected],th[data-mce-selected]', editor.getBody());
    };
    var hasSelectedContent = function (editor) {
      return !editor.selection.isCollapsed() || isTableSelection(editor);
    };
    var cut = function (editor) {
      return function (evt) {
        if (hasSelectedContent(editor)) {
          setClipboardData(evt, getData(editor), fallback(editor), function () {
            if (global$a.browser.isChrome() || global$a.browser.isFirefox()) {
              var rng_1 = editor.selection.getRng();
              global$9.setEditorTimeout(editor, function () {
                editor.selection.setRng(rng_1);
                editor.execCommand('Delete');
              }, 0);
            } else {
              editor.execCommand('Delete');
            }
          });
        }
      };
    };
    var copy = function (editor) {
      return function (evt) {
        if (hasSelectedContent(editor)) {
          setClipboardData(evt, getData(editor), fallback(editor), noop);
        }
      };
    };
    var register$1 = function (editor) {
      editor.on('cut', cut(editor));
      editor.on('copy', copy(editor));
    };

    var global = tinymce.util.Tools.resolve('tinymce.dom.RangeUtils');

    var getCaretRangeFromEvent = function (editor, e) {
      return global.getCaretRangeFromPoint(e.clientX, e.clientY, editor.getDoc());
    };
    var isPlainTextFileUrl = function (content) {
      var plainTextContent = content['text/plain'];
      return plainTextContent ? plainTextContent.indexOf('file://') === 0 : false;
    };
    var setFocusedRange = function (editor, rng) {
      editor.focus();
      editor.selection.setRng(rng);
    };
    var setup$2 = function (editor, clipboard, draggingInternallyState) {
      if (shouldBlockDrop(editor)) {
        editor.on('dragend dragover draggesture dragdrop drop drag', function (e) {
          e.preventDefault();
          e.stopPropagation();
        });
      }
      if (!shouldPasteDataImages(editor)) {
        editor.on('drop', function (e) {
          var dataTransfer = e.dataTransfer;
          if (dataTransfer && dataTransfer.files && dataTransfer.files.length > 0) {
            e.preventDefault();
          }
        });
      }
      editor.on('drop', function (e) {
        var rng = getCaretRangeFromEvent(editor, e);
        if (e.isDefaultPrevented() || draggingInternallyState.get()) {
          return;
        }
        var dropContent = clipboard.getDataTransferItems(e.dataTransfer);
        var internal = clipboard.hasContentType(dropContent, internalHtmlMime());
        if ((!clipboard.hasHtmlOrText(dropContent) || isPlainTextFileUrl(dropContent)) && clipboard.pasteImageData(e, rng)) {
          return;
        }
        if (rng && shouldFilterDrop(editor)) {
          var content_1 = dropContent['mce-internal'] || dropContent['text/html'] || dropContent['text/plain'];
          if (content_1) {
            e.preventDefault();
            global$9.setEditorTimeout(editor, function () {
              editor.undoManager.transact(function () {
                if (dropContent['mce-internal']) {
                  editor.execCommand('Delete');
                }
                setFocusedRange(editor, rng);
                content_1 = trimHtml(content_1);
                if (!dropContent['text/html']) {
                  clipboard.pasteText(content_1);
                } else {
                  clipboard.pasteHtml(content_1, internal);
                }
              });
            });
          }
        }
      });
      editor.on('dragstart', function (_e) {
        draggingInternallyState.set(true);
      });
      editor.on('dragover dragend', function (e) {
        if (shouldPasteDataImages(editor) && draggingInternallyState.get() === false) {
          e.preventDefault();
          setFocusedRange(editor, getCaretRangeFromEvent(editor, e));
        }
        if (e.type === 'dragend') {
          draggingInternallyState.set(false);
        }
      });
    };

    var setup$1 = function (editor) {
      var plugin = editor.plugins.paste;
      var preProcess = getPreProcess(editor);
      if (preProcess) {
        editor.on('PastePreProcess', function (e) {
          preProcess.call(plugin, plugin, e);
        });
      }
      var postProcess = getPostProcess(editor);
      if (postProcess) {
        editor.on('PastePostProcess', function (e) {
          postProcess.call(plugin, plugin, e);
        });
      }
    };

    var addPreProcessFilter = function (editor, filterFunc) {
      editor.on('PastePreProcess', function (e) {
        e.content = filterFunc(editor, e.content, e.internal, e.wordContent);
      });
    };
    var addPostProcessFilter = function (editor, filterFunc) {
      editor.on('PastePostProcess', function (e) {
        filterFunc(editor, e.node);
      });
    };
    var removeExplorerBrElementsAfterBlocks = function (editor, html) {
      if (!isWordContent(html)) {
        return html;
      }
      var blockElements = [];
      global$6.each(editor.schema.getBlockElements(), function (block, blockName) {
        blockElements.push(blockName);
      });
      var explorerBlocksRegExp = new RegExp('(?:<br>&nbsp;[\\s\\r\\n]+|<br>)*(<\\/?(' + blockElements.join('|') + ')[^>]*>)(?:<br>&nbsp;[\\s\\r\\n]+|<br>)*', 'g');
      html = filter(html, [[
          explorerBlocksRegExp,
          '$1'
        ]]);
      html = filter(html, [
        [
          /<br><br>/g,
          '<BR><BR>'
        ],
        [
          /<br>/g,
          ' '
        ],
        [
          /<BR><BR>/g,
          '<br>'
        ]
      ]);
      return html;
    };
    var removeWebKitStyles = function (editor, content, internal, isWordHtml) {
      if (isWordHtml || internal) {
        return content;
      }
      var webKitStylesSetting = getWebkitStyles(editor);
      var webKitStyles;
      if (shouldRemoveWebKitStyles(editor) === false || webKitStylesSetting === 'all') {
        return content;
      }
      if (webKitStylesSetting) {
        webKitStyles = webKitStylesSetting.split(/[, ]/);
      }
      if (webKitStyles) {
        var dom_1 = editor.dom, node_1 = editor.selection.getNode();
        content = content.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, function (all, before, value, after) {
          var inputStyles = dom_1.parseStyle(dom_1.decode(value));
          var outputStyles = {};
          if (webKitStyles === 'none') {
            return before + after;
          }
          for (var i = 0; i < webKitStyles.length; i++) {
            var inputValue = inputStyles[webKitStyles[i]], currentValue = dom_1.getStyle(node_1, webKitStyles[i], true);
            if (/color/.test(webKitStyles[i])) {
              inputValue = dom_1.toHex(inputValue);
              currentValue = dom_1.toHex(currentValue);
            }
            if (currentValue !== inputValue) {
              outputStyles[webKitStyles[i]] = inputValue;
            }
          }
          var outputStyle = dom_1.serializeStyle(outputStyles, 'span');
          if (outputStyle) {
            return before + ' style="' + outputStyle + '"' + after;
          }
          return before + after;
        });
      } else {
        content = content.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, '$1$3');
      }
      content = content.replace(/(<[^>]+) data-mce-style="([^"]+)"([^>]*>)/gi, function (all, before, value, after) {
        return before + ' style="' + value + '"' + after;
      });
      return content;
    };
    var removeUnderlineAndFontInAnchor = function (editor, root) {
      editor.$('a', root).find('font,u').each(function (i, node) {
        editor.dom.remove(node, true);
      });
    };
    var setup = function (editor) {
      if (global$a.webkit) {
        addPreProcessFilter(editor, removeWebKitStyles);
      }
      if (global$a.ie) {
        addPreProcessFilter(editor, removeExplorerBrElementsAfterBlocks);
        addPostProcessFilter(editor, removeUnderlineAndFontInAnchor);
      }
    };

    var makeSetupHandler = function (editor, clipboard) {
      return function (api) {
        api.setActive(clipboard.pasteFormat.get() === 'text');
        var pastePlainTextToggleHandler = function (e) {
          return api.setActive(e.state);
        };
        editor.on('PastePlainTextToggle', pastePlainTextToggleHandler);
        return function () {
          return editor.off('PastePlainTextToggle', pastePlainTextToggleHandler);
        };
      };
    };
    var register = function (editor, clipboard) {
      var onAction = function () {
        return editor.execCommand('mceTogglePlainTextPaste');
      };
      editor.ui.registry.addToggleButton('pastetext', {
        active: false,
        icon: 'paste-text',
        tooltip: 'Paste as text',
        onAction: onAction,
        onSetup: makeSetupHandler(editor, clipboard)
      });
      editor.ui.registry.addToggleMenuItem('pastetext', {
        text: 'Paste as text',
        icon: 'paste-text',
        onAction: onAction,
        onSetup: makeSetupHandler(editor, clipboard)
      });
    };

    function Plugin () {
      global$b.add('paste', function (editor) {
        if (hasProPlugin(editor) === false) {
          var draggingInternallyState = Cell(false);
          var pasteFormat = Cell(isPasteAsTextEnabled(editor) ? 'text' : 'html');
          var clipboard = Clipboard(editor, pasteFormat);
          setup(editor);
          register(editor, clipboard);
          register$2(editor, clipboard);
          setup$1(editor);
          register$1(editor);
          setup$2(editor, clipboard, draggingInternallyState);
          return get(clipboard);
        }
      });
    }

    Plugin();

}());


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "preview" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/preview')
//   ES2015:
//     import 'tinymce/plugins/preview'
__webpack_require__(1507);

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 *
 * Version: 5.10.5 (2022-05-25)
 */
(function () {
    'use strict';

    var global$2 = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var global$1 = tinymce.util.Tools.resolve('tinymce.Env');

    var global = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var getContentStyle = function (editor) {
      return editor.getParam('content_style', '', 'string');
    };
    var shouldUseContentCssCors = function (editor) {
      return editor.getParam('content_css_cors', false, 'boolean');
    };
    var getBodyClassByHash = function (editor) {
      var bodyClass = editor.getParam('body_class', '', 'hash');
      return bodyClass[editor.id] || '';
    };
    var getBodyClass = function (editor) {
      var bodyClass = editor.getParam('body_class', '', 'string');
      if (bodyClass.indexOf('=') === -1) {
        return bodyClass;
      } else {
        return getBodyClassByHash(editor);
      }
    };
    var getBodyIdByHash = function (editor) {
      var bodyId = editor.getParam('body_id', '', 'hash');
      return bodyId[editor.id] || bodyId;
    };
    var getBodyId = function (editor) {
      var bodyId = editor.getParam('body_id', 'tinymce', 'string');
      if (bodyId.indexOf('=') === -1) {
        return bodyId;
      } else {
        return getBodyIdByHash(editor);
      }
    };

    var getPreviewHtml = function (editor) {
      var headHtml = '';
      var encode = editor.dom.encode;
      var contentStyle = getContentStyle(editor);
      headHtml += '<base href="' + encode(editor.documentBaseURI.getURI()) + '">';
      var cors = shouldUseContentCssCors(editor) ? ' crossorigin="anonymous"' : '';
      global.each(editor.contentCSS, function (url) {
        headHtml += '<link type="text/css" rel="stylesheet" href="' + encode(editor.documentBaseURI.toAbsolute(url)) + '"' + cors + '>';
      });
      if (contentStyle) {
        headHtml += '<style type="text/css">' + contentStyle + '</style>';
      }
      var bodyId = getBodyId(editor);
      var bodyClass = getBodyClass(editor);
      var isMetaKeyPressed = global$1.mac ? 'e.metaKey' : 'e.ctrlKey && !e.altKey';
      var preventClicksOnLinksScript = '<script>' + 'document.addEventListener && document.addEventListener("click", function(e) {' + 'for (var elm = e.target; elm; elm = elm.parentNode) {' + 'if (elm.nodeName === "A" && !(' + isMetaKeyPressed + ')) {' + 'e.preventDefault();' + '}' + '}' + '}, false);' + '</script> ';
      var directionality = editor.getBody().dir;
      var dirAttr = directionality ? ' dir="' + encode(directionality) + '"' : '';
      var previewHtml = '<!DOCTYPE html>' + '<html>' + '<head>' + headHtml + '</head>' + '<body id="' + encode(bodyId) + '" class="mce-content-body ' + encode(bodyClass) + '"' + dirAttr + '>' + editor.getContent() + preventClicksOnLinksScript + '</body>' + '</html>';
      return previewHtml;
    };

    var open = function (editor) {
      var content = getPreviewHtml(editor);
      var dataApi = editor.windowManager.open({
        title: 'Preview',
        size: 'large',
        body: {
          type: 'panel',
          items: [{
              name: 'preview',
              type: 'iframe',
              sandboxed: true
            }]
        },
        buttons: [{
            type: 'cancel',
            name: 'close',
            text: 'Close',
            primary: true
          }],
        initialData: { preview: content }
      });
      dataApi.focus('close');
    };

    var register$1 = function (editor) {
      editor.addCommand('mcePreview', function () {
        open(editor);
      });
    };

    var register = function (editor) {
      var onAction = function () {
        return editor.execCommand('mcePreview');
      };
      editor.ui.registry.addButton('preview', {
        icon: 'preview',
        tooltip: 'Preview',
        onAction: onAction
      });
      editor.ui.registry.addMenuItem('preview', {
        icon: 'preview',
        text: 'Preview',
        onAction: onAction
      });
    };

    function Plugin () {
      global$2.add('preview', function (editor) {
        register$1(editor);
        register(editor);
      });
    }

    Plugin();

}());


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "table" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/table')
//   ES2015:
//     import 'tinymce/plugins/table'
__webpack_require__(1509);

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 *
 * Version: 5.10.5 (2022-05-25)
 */
(function () {
    'use strict';

    var typeOf = function (x) {
      var t = typeof x;
      if (x === null) {
        return 'null';
      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
        return 'array';
      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
        return 'string';
      } else {
        return t;
      }
    };
    var isType$1 = function (type) {
      return function (value) {
        return typeOf(value) === type;
      };
    };
    var isSimpleType = function (type) {
      return function (value) {
        return typeof value === type;
      };
    };
    var eq$2 = function (t) {
      return function (a) {
        return t === a;
      };
    };
    var isString = isType$1('string');
    var isObject = isType$1('object');
    var isArray = isType$1('array');
    var isNull = eq$2(null);
    var isBoolean = isSimpleType('boolean');
    var isUndefined = eq$2(undefined);
    var isNullable = function (a) {
      return a === null || a === undefined;
    };
    var isNonNullable = function (a) {
      return !isNullable(a);
    };
    var isFunction = isSimpleType('function');
    var isNumber = isSimpleType('number');

    var noop = function () {
    };
    var compose = function (fa, fb) {
      return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        return fa(fb.apply(null, args));
      };
    };
    var compose1 = function (fbc, fab) {
      return function (a) {
        return fbc(fab(a));
      };
    };
    var constant = function (value) {
      return function () {
        return value;
      };
    };
    var identity = function (x) {
      return x;
    };
    var tripleEquals = function (a, b) {
      return a === b;
    };
    function curry(fn) {
      var initialArgs = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        initialArgs[_i - 1] = arguments[_i];
      }
      return function () {
        var restArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          restArgs[_i] = arguments[_i];
        }
        var all = initialArgs.concat(restArgs);
        return fn.apply(null, all);
      };
    }
    var not = function (f) {
      return function (t) {
        return !f(t);
      };
    };
    var die = function (msg) {
      return function () {
        throw new Error(msg);
      };
    };
    var never = constant(false);
    var always = constant(true);

    var none$2 = function () {
      return NONE;
    };
    var NONE = function () {
      var call = function (thunk) {
        return thunk();
      };
      var id = identity;
      var me = {
        fold: function (n, _s) {
          return n();
        },
        isSome: never,
        isNone: always,
        getOr: id,
        getOrThunk: call,
        getOrDie: function (msg) {
          throw new Error(msg || 'error: getOrDie called on none.');
        },
        getOrNull: constant(null),
        getOrUndefined: constant(undefined),
        or: id,
        orThunk: call,
        map: none$2,
        each: noop,
        bind: none$2,
        exists: never,
        forall: always,
        filter: function () {
          return none$2();
        },
        toArray: function () {
          return [];
        },
        toString: constant('none()')
      };
      return me;
    }();
    var some = function (a) {
      var constant_a = constant(a);
      var self = function () {
        return me;
      };
      var bind = function (f) {
        return f(a);
      };
      var me = {
        fold: function (n, s) {
          return s(a);
        },
        isSome: always,
        isNone: never,
        getOr: constant_a,
        getOrThunk: constant_a,
        getOrDie: constant_a,
        getOrNull: constant_a,
        getOrUndefined: constant_a,
        or: self,
        orThunk: self,
        map: function (f) {
          return some(f(a));
        },
        each: function (f) {
          f(a);
        },
        bind: bind,
        exists: bind,
        forall: bind,
        filter: function (f) {
          return f(a) ? me : NONE;
        },
        toArray: function () {
          return [a];
        },
        toString: function () {
          return 'some(' + a + ')';
        }
      };
      return me;
    };
    var from$1 = function (value) {
      return value === null || value === undefined ? NONE : some(value);
    };
    var Optional = {
      some: some,
      none: none$2,
      from: from$1
    };

    var nativeSlice = Array.prototype.slice;
    var nativeIndexOf = Array.prototype.indexOf;
    var nativePush = Array.prototype.push;
    var rawIndexOf = function (ts, t) {
      return nativeIndexOf.call(ts, t);
    };
    var contains$2 = function (xs, x) {
      return rawIndexOf(xs, x) > -1;
    };
    var exists = function (xs, pred) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i)) {
          return true;
        }
      }
      return false;
    };
    var range$1 = function (num, f) {
      var r = [];
      for (var i = 0; i < num; i++) {
        r.push(f(i));
      }
      return r;
    };
    var map$1 = function (xs, f) {
      var len = xs.length;
      var r = new Array(len);
      for (var i = 0; i < len; i++) {
        var x = xs[i];
        r[i] = f(x, i);
      }
      return r;
    };
    var each$2 = function (xs, f) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        f(x, i);
      }
    };
    var eachr = function (xs, f) {
      for (var i = xs.length - 1; i >= 0; i--) {
        var x = xs[i];
        f(x, i);
      }
    };
    var partition = function (xs, pred) {
      var pass = [];
      var fail = [];
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        var arr = pred(x, i) ? pass : fail;
        arr.push(x);
      }
      return {
        pass: pass,
        fail: fail
      };
    };
    var filter$2 = function (xs, pred) {
      var r = [];
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i)) {
          r.push(x);
        }
      }
      return r;
    };
    var foldr = function (xs, f, acc) {
      eachr(xs, function (x, i) {
        acc = f(acc, x, i);
      });
      return acc;
    };
    var foldl = function (xs, f, acc) {
      each$2(xs, function (x, i) {
        acc = f(acc, x, i);
      });
      return acc;
    };
    var findUntil = function (xs, pred, until) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i)) {
          return Optional.some(x);
        } else if (until(x, i)) {
          break;
        }
      }
      return Optional.none();
    };
    var find$1 = function (xs, pred) {
      return findUntil(xs, pred, never);
    };
    var findIndex = function (xs, pred) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i)) {
          return Optional.some(i);
        }
      }
      return Optional.none();
    };
    var flatten$1 = function (xs) {
      var r = [];
      for (var i = 0, len = xs.length; i < len; ++i) {
        if (!isArray(xs[i])) {
          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
        }
        nativePush.apply(r, xs[i]);
      }
      return r;
    };
    var bind$2 = function (xs, f) {
      return flatten$1(map$1(xs, f));
    };
    var forall = function (xs, pred) {
      for (var i = 0, len = xs.length; i < len; ++i) {
        var x = xs[i];
        if (pred(x, i) !== true) {
          return false;
        }
      }
      return true;
    };
    var reverse = function (xs) {
      var r = nativeSlice.call(xs, 0);
      r.reverse();
      return r;
    };
    var mapToObject = function (xs, f) {
      var r = {};
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        r[String(x)] = f(x, i);
      }
      return r;
    };
    var pure = function (x) {
      return [x];
    };
    var sort$1 = function (xs, comparator) {
      var copy = nativeSlice.call(xs, 0);
      copy.sort(comparator);
      return copy;
    };
    var get$d = function (xs, i) {
      return i >= 0 && i < xs.length ? Optional.some(xs[i]) : Optional.none();
    };
    var head = function (xs) {
      return get$d(xs, 0);
    };
    var last$2 = function (xs) {
      return get$d(xs, xs.length - 1);
    };
    var findMap = function (arr, f) {
      for (var i = 0; i < arr.length; i++) {
        var r = f(arr[i], i);
        if (r.isSome()) {
          return r;
        }
      }
      return Optional.none();
    };

    var __assign = function () {
      __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };
    function __spreadArray(to, from, pack) {
      if (pack || arguments.length === 2)
        for (var i = 0, l = from.length, ar; i < l; i++) {
          if (ar || !(i in from)) {
            if (!ar)
              ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
          }
        }
      return to.concat(ar || Array.prototype.slice.call(from));
    }

    var cached = function (f) {
      var called = false;
      var r;
      return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        if (!called) {
          called = true;
          r = f.apply(null, args);
        }
        return r;
      };
    };

    var DeviceType = function (os, browser, userAgent, mediaMatch) {
      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
      var isiPhone = os.isiOS() && !isiPad;
      var isMobile = os.isiOS() || os.isAndroid();
      var isTouch = isMobile || mediaMatch('(pointer:coarse)');
      var isTablet = isiPad || !isiPhone && isMobile && mediaMatch('(min-device-width:768px)');
      var isPhone = isiPhone || isMobile && !isTablet;
      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
      var isDesktop = !isPhone && !isTablet && !iOSwebview;
      return {
        isiPad: constant(isiPad),
        isiPhone: constant(isiPhone),
        isTablet: constant(isTablet),
        isPhone: constant(isPhone),
        isTouch: constant(isTouch),
        isAndroid: os.isAndroid,
        isiOS: os.isiOS,
        isWebView: constant(iOSwebview),
        isDesktop: constant(isDesktop)
      };
    };

    var firstMatch = function (regexes, s) {
      for (var i = 0; i < regexes.length; i++) {
        var x = regexes[i];
        if (x.test(s)) {
          return x;
        }
      }
      return undefined;
    };
    var find = function (regexes, agent) {
      var r = firstMatch(regexes, agent);
      if (!r) {
        return {
          major: 0,
          minor: 0
        };
      }
      var group = function (i) {
        return Number(agent.replace(r, '$' + i));
      };
      return nu$2(group(1), group(2));
    };
    var detect$6 = function (versionRegexes, agent) {
      var cleanedAgent = String(agent).toLowerCase();
      if (versionRegexes.length === 0) {
        return unknown$2();
      }
      return find(versionRegexes, cleanedAgent);
    };
    var unknown$2 = function () {
      return nu$2(0, 0);
    };
    var nu$2 = function (major, minor) {
      return {
        major: major,
        minor: minor
      };
    };
    var Version = {
      nu: nu$2,
      detect: detect$6,
      unknown: unknown$2
    };

    var detectBrowser$1 = function (browsers, userAgentData) {
      return findMap(userAgentData.brands, function (uaBrand) {
        var lcBrand = uaBrand.brand.toLowerCase();
        return find$1(browsers, function (browser) {
          var _a;
          return lcBrand === ((_a = browser.brand) === null || _a === void 0 ? void 0 : _a.toLowerCase());
        }).map(function (info) {
          return {
            current: info.name,
            version: Version.nu(parseInt(uaBrand.version, 10), 0)
          };
        });
      });
    };

    var detect$5 = function (candidates, userAgent) {
      var agent = String(userAgent).toLowerCase();
      return find$1(candidates, function (candidate) {
        return candidate.search(agent);
      });
    };
    var detectBrowser = function (browsers, userAgent) {
      return detect$5(browsers, userAgent).map(function (browser) {
        var version = Version.detect(browser.versionRegexes, userAgent);
        return {
          current: browser.name,
          version: version
        };
      });
    };
    var detectOs = function (oses, userAgent) {
      return detect$5(oses, userAgent).map(function (os) {
        var version = Version.detect(os.versionRegexes, userAgent);
        return {
          current: os.name,
          version: version
        };
      });
    };

    var removeFromStart = function (str, numChars) {
      return str.substring(numChars);
    };

    var checkRange = function (str, substr, start) {
      return substr === '' || str.length >= substr.length && str.substr(start, start + substr.length) === substr;
    };
    var removeLeading = function (str, prefix) {
      return startsWith(str, prefix) ? removeFromStart(str, prefix.length) : str;
    };
    var contains$1 = function (str, substr) {
      return str.indexOf(substr) !== -1;
    };
    var startsWith = function (str, prefix) {
      return checkRange(str, prefix, 0);
    };
    var endsWith = function (str, suffix) {
      return checkRange(str, suffix, str.length - suffix.length);
    };
    var blank = function (r) {
      return function (s) {
        return s.replace(r, '');
      };
    };
    var trim = blank(/^\s+|\s+$/g);
    var isNotEmpty = function (s) {
      return s.length > 0;
    };
    var isEmpty$1 = function (s) {
      return !isNotEmpty(s);
    };
    var toFloat = function (value) {
      var num = parseFloat(value);
      return isNaN(num) ? Optional.none() : Optional.some(num);
    };

    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
    var checkContains = function (target) {
      return function (uastring) {
        return contains$1(uastring, target);
      };
    };
    var browsers = [
      {
        name: 'Edge',
        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
        search: function (uastring) {
          return contains$1(uastring, 'edge/') && contains$1(uastring, 'chrome') && contains$1(uastring, 'safari') && contains$1(uastring, 'applewebkit');
        }
      },
      {
        name: 'Chrome',
        brand: 'Chromium',
        versionRegexes: [
          /.*?chrome\/([0-9]+)\.([0-9]+).*/,
          normalVersionRegex
        ],
        search: function (uastring) {
          return contains$1(uastring, 'chrome') && !contains$1(uastring, 'chromeframe');
        }
      },
      {
        name: 'IE',
        versionRegexes: [
          /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
          /.*?rv:([0-9]+)\.([0-9]+).*/
        ],
        search: function (uastring) {
          return contains$1(uastring, 'msie') || contains$1(uastring, 'trident');
        }
      },
      {
        name: 'Opera',
        versionRegexes: [
          normalVersionRegex,
          /.*?opera\/([0-9]+)\.([0-9]+).*/
        ],
        search: checkContains('opera')
      },
      {
        name: 'Firefox',
        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
        search: checkContains('firefox')
      },
      {
        name: 'Safari',
        versionRegexes: [
          normalVersionRegex,
          /.*?cpu os ([0-9]+)_([0-9]+).*/
        ],
        search: function (uastring) {
          return (contains$1(uastring, 'safari') || contains$1(uastring, 'mobile/')) && contains$1(uastring, 'applewebkit');
        }
      }
    ];
    var oses = [
      {
        name: 'Windows',
        search: checkContains('win'),
        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
      },
      {
        name: 'iOS',
        search: function (uastring) {
          return contains$1(uastring, 'iphone') || contains$1(uastring, 'ipad');
        },
        versionRegexes: [
          /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
          /.*cpu os ([0-9]+)_([0-9]+).*/,
          /.*cpu iphone os ([0-9]+)_([0-9]+).*/
        ]
      },
      {
        name: 'Android',
        search: checkContains('android'),
        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
      },
      {
        name: 'OSX',
        search: checkContains('mac os x'),
        versionRegexes: [/.*?mac\ os\ x\ ?([0-9]+)_([0-9]+).*/]
      },
      {
        name: 'Linux',
        search: checkContains('linux'),
        versionRegexes: []
      },
      {
        name: 'Solaris',
        search: checkContains('sunos'),
        versionRegexes: []
      },
      {
        name: 'FreeBSD',
        search: checkContains('freebsd'),
        versionRegexes: []
      },
      {
        name: 'ChromeOS',
        search: checkContains('cros'),
        versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/]
      }
    ];
    var PlatformInfo = {
      browsers: constant(browsers),
      oses: constant(oses)
    };

    var edge = 'Edge';
    var chrome = 'Chrome';
    var ie = 'IE';
    var opera = 'Opera';
    var firefox = 'Firefox';
    var safari = 'Safari';
    var unknown$1 = function () {
      return nu$1({
        current: undefined,
        version: Version.unknown()
      });
    };
    var nu$1 = function (info) {
      var current = info.current;
      var version = info.version;
      var isBrowser = function (name) {
        return function () {
          return current === name;
        };
      };
      return {
        current: current,
        version: version,
        isEdge: isBrowser(edge),
        isChrome: isBrowser(chrome),
        isIE: isBrowser(ie),
        isOpera: isBrowser(opera),
        isFirefox: isBrowser(firefox),
        isSafari: isBrowser(safari)
      };
    };
    var Browser = {
      unknown: unknown$1,
      nu: nu$1,
      edge: constant(edge),
      chrome: constant(chrome),
      ie: constant(ie),
      opera: constant(opera),
      firefox: constant(firefox),
      safari: constant(safari)
    };

    var windows = 'Windows';
    var ios = 'iOS';
    var android = 'Android';
    var linux = 'Linux';
    var osx = 'OSX';
    var solaris = 'Solaris';
    var freebsd = 'FreeBSD';
    var chromeos = 'ChromeOS';
    var unknown = function () {
      return nu({
        current: undefined,
        version: Version.unknown()
      });
    };
    var nu = function (info) {
      var current = info.current;
      var version = info.version;
      var isOS = function (name) {
        return function () {
          return current === name;
        };
      };
      return {
        current: current,
        version: version,
        isWindows: isOS(windows),
        isiOS: isOS(ios),
        isAndroid: isOS(android),
        isOSX: isOS(osx),
        isLinux: isOS(linux),
        isSolaris: isOS(solaris),
        isFreeBSD: isOS(freebsd),
        isChromeOS: isOS(chromeos)
      };
    };
    var OperatingSystem = {
      unknown: unknown,
      nu: nu,
      windows: constant(windows),
      ios: constant(ios),
      android: constant(android),
      linux: constant(linux),
      osx: constant(osx),
      solaris: constant(solaris),
      freebsd: constant(freebsd),
      chromeos: constant(chromeos)
    };

    var detect$4 = function (userAgent, userAgentDataOpt, mediaMatch) {
      var browsers = PlatformInfo.browsers();
      var oses = PlatformInfo.oses();
      var browser = userAgentDataOpt.bind(function (userAgentData) {
        return detectBrowser$1(browsers, userAgentData);
      }).orThunk(function () {
        return detectBrowser(browsers, userAgent);
      }).fold(Browser.unknown, Browser.nu);
      var os = detectOs(oses, userAgent).fold(OperatingSystem.unknown, OperatingSystem.nu);
      var deviceType = DeviceType(os, browser, userAgent, mediaMatch);
      return {
        browser: browser,
        os: os,
        deviceType: deviceType
      };
    };
    var PlatformDetection = { detect: detect$4 };

    var mediaMatch = function (query) {
      return window.matchMedia(query).matches;
    };
    var platform = cached(function () {
      return PlatformDetection.detect(navigator.userAgent, Optional.from(navigator.userAgentData), mediaMatch);
    });
    var detect$3 = function () {
      return platform();
    };

    var compareDocumentPosition = function (a, b, match) {
      return (a.compareDocumentPosition(b) & match) !== 0;
    };
    var documentPositionContainedBy = function (a, b) {
      return compareDocumentPosition(a, b, Node.DOCUMENT_POSITION_CONTAINED_BY);
    };

    var COMMENT = 8;
    var DOCUMENT = 9;
    var DOCUMENT_FRAGMENT = 11;
    var ELEMENT = 1;
    var TEXT = 3;

    var fromHtml$1 = function (html, scope) {
      var doc = scope || document;
      var div = doc.createElement('div');
      div.innerHTML = html;
      if (!div.hasChildNodes() || div.childNodes.length > 1) {
        console.error('HTML does not have a single root node', html);
        throw new Error('HTML must have a single root node');
      }
      return fromDom$1(div.childNodes[0]);
    };
    var fromTag = function (tag, scope) {
      var doc = scope || document;
      var node = doc.createElement(tag);
      return fromDom$1(node);
    };
    var fromText = function (text, scope) {
      var doc = scope || document;
      var node = doc.createTextNode(text);
      return fromDom$1(node);
    };
    var fromDom$1 = function (node) {
      if (node === null || node === undefined) {
        throw new Error('Node cannot be null or undefined');
      }
      return { dom: node };
    };
    var fromPoint$1 = function (docElm, x, y) {
      return Optional.from(docElm.dom.elementFromPoint(x, y)).map(fromDom$1);
    };
    var SugarElement = {
      fromHtml: fromHtml$1,
      fromTag: fromTag,
      fromText: fromText,
      fromDom: fromDom$1,
      fromPoint: fromPoint$1
    };

    var is$2 = function (element, selector) {
      var dom = element.dom;
      if (dom.nodeType !== ELEMENT) {
        return false;
      } else {
        var elem = dom;
        if (elem.matches !== undefined) {
          return elem.matches(selector);
        } else if (elem.msMatchesSelector !== undefined) {
          return elem.msMatchesSelector(selector);
        } else if (elem.webkitMatchesSelector !== undefined) {
          return elem.webkitMatchesSelector(selector);
        } else if (elem.mozMatchesSelector !== undefined) {
          return elem.mozMatchesSelector(selector);
        } else {
          throw new Error('Browser lacks native selectors');
        }
      }
    };
    var bypassSelector = function (dom) {
      return dom.nodeType !== ELEMENT && dom.nodeType !== DOCUMENT && dom.nodeType !== DOCUMENT_FRAGMENT || dom.childElementCount === 0;
    };
    var all$1 = function (selector, scope) {
      var base = scope === undefined ? document : scope.dom;
      return bypassSelector(base) ? [] : map$1(base.querySelectorAll(selector), SugarElement.fromDom);
    };
    var one = function (selector, scope) {
      var base = scope === undefined ? document : scope.dom;
      return bypassSelector(base) ? Optional.none() : Optional.from(base.querySelector(selector)).map(SugarElement.fromDom);
    };

    var eq$1 = function (e1, e2) {
      return e1.dom === e2.dom;
    };
    var regularContains = function (e1, e2) {
      var d1 = e1.dom;
      var d2 = e2.dom;
      return d1 === d2 ? false : d1.contains(d2);
    };
    var ieContains = function (e1, e2) {
      return documentPositionContainedBy(e1.dom, e2.dom);
    };
    var contains = function (e1, e2) {
      return detect$3().browser.isIE() ? ieContains(e1, e2) : regularContains(e1, e2);
    };
    var is$1 = is$2;

    var keys = Object.keys;
    var hasOwnProperty = Object.hasOwnProperty;
    var each$1 = function (obj, f) {
      var props = keys(obj);
      for (var k = 0, len = props.length; k < len; k++) {
        var i = props[k];
        var x = obj[i];
        f(x, i);
      }
    };
    var map = function (obj, f) {
      return tupleMap(obj, function (x, i) {
        return {
          k: i,
          v: f(x, i)
        };
      });
    };
    var tupleMap = function (obj, f) {
      var r = {};
      each$1(obj, function (x, i) {
        var tuple = f(x, i);
        r[tuple.k] = tuple.v;
      });
      return r;
    };
    var objAcc = function (r) {
      return function (x, i) {
        r[i] = x;
      };
    };
    var internalFilter = function (obj, pred, onTrue, onFalse) {
      var r = {};
      each$1(obj, function (x, i) {
        (pred(x, i) ? onTrue : onFalse)(x, i);
      });
      return r;
    };
    var filter$1 = function (obj, pred) {
      var t = {};
      internalFilter(obj, pred, objAcc(t), noop);
      return t;
    };
    var mapToArray = function (obj, f) {
      var r = [];
      each$1(obj, function (value, name) {
        r.push(f(value, name));
      });
      return r;
    };
    var values = function (obj) {
      return mapToArray(obj, identity);
    };
    var size = function (obj) {
      return keys(obj).length;
    };
    var get$c = function (obj, key) {
      return has$1(obj, key) ? Optional.from(obj[key]) : Optional.none();
    };
    var has$1 = function (obj, key) {
      return hasOwnProperty.call(obj, key);
    };
    var hasNonNullableKey = function (obj, key) {
      return has$1(obj, key) && obj[key] !== undefined && obj[key] !== null;
    };
    var isEmpty = function (r) {
      for (var x in r) {
        if (hasOwnProperty.call(r, x)) {
          return false;
        }
      }
      return true;
    };

    var validSectionList = [
      'tfoot',
      'thead',
      'tbody',
      'colgroup'
    ];
    var isValidSection = function (parentName) {
      return contains$2(validSectionList, parentName);
    };
    var grid = function (rows, columns) {
      return {
        rows: rows,
        columns: columns
      };
    };
    var address = function (row, column) {
      return {
        row: row,
        column: column
      };
    };
    var detail = function (element, rowspan, colspan) {
      return {
        element: element,
        rowspan: rowspan,
        colspan: colspan
      };
    };
    var detailnew = function (element, rowspan, colspan, isNew) {
      return {
        element: element,
        rowspan: rowspan,
        colspan: colspan,
        isNew: isNew
      };
    };
    var extended = function (element, rowspan, colspan, row, column, isLocked) {
      return {
        element: element,
        rowspan: rowspan,
        colspan: colspan,
        row: row,
        column: column,
        isLocked: isLocked
      };
    };
    var rowdetail = function (element, cells, section) {
      return {
        element: element,
        cells: cells,
        section: section
      };
    };
    var rowdetailnew = function (element, cells, section, isNew) {
      return {
        element: element,
        cells: cells,
        section: section,
        isNew: isNew
      };
    };
    var elementnew = function (element, isNew, isLocked) {
      return {
        element: element,
        isNew: isNew,
        isLocked: isLocked
      };
    };
    var rowcells = function (element, cells, section, isNew) {
      return {
        element: element,
        cells: cells,
        section: section,
        isNew: isNew
      };
    };
    var bounds = function (startRow, startCol, finishRow, finishCol) {
      return {
        startRow: startRow,
        startCol: startCol,
        finishRow: finishRow,
        finishCol: finishCol
      };
    };
    var columnext = function (element, colspan, column) {
      return {
        element: element,
        colspan: colspan,
        column: column
      };
    };
    var colgroup = function (element, columns) {
      return {
        element: element,
        columns: columns
      };
    };

    typeof window !== 'undefined' ? window : Function('return this;')();

    var name = function (element) {
      var r = element.dom.nodeName;
      return r.toLowerCase();
    };
    var type$1 = function (element) {
      return element.dom.nodeType;
    };
    var isType = function (t) {
      return function (element) {
        return type$1(element) === t;
      };
    };
    var isComment = function (element) {
      return type$1(element) === COMMENT || name(element) === '#comment';
    };
    var isElement = isType(ELEMENT);
    var isText = isType(TEXT);
    var isDocument = isType(DOCUMENT);
    var isDocumentFragment = isType(DOCUMENT_FRAGMENT);
    var isTag = function (tag) {
      return function (e) {
        return isElement(e) && name(e) === tag;
      };
    };

    var owner = function (element) {
      return SugarElement.fromDom(element.dom.ownerDocument);
    };
    var documentOrOwner = function (dos) {
      return isDocument(dos) ? dos : owner(dos);
    };
    var defaultView = function (element) {
      return SugarElement.fromDom(documentOrOwner(element).dom.defaultView);
    };
    var parent = function (element) {
      return Optional.from(element.dom.parentNode).map(SugarElement.fromDom);
    };
    var parentElement = function (element) {
      return Optional.from(element.dom.parentElement).map(SugarElement.fromDom);
    };
    var parents = function (element, isRoot) {
      var stop = isFunction(isRoot) ? isRoot : never;
      var dom = element.dom;
      var ret = [];
      while (dom.parentNode !== null && dom.parentNode !== undefined) {
        var rawParent = dom.parentNode;
        var p = SugarElement.fromDom(rawParent);
        ret.push(p);
        if (stop(p) === true) {
          break;
        } else {
          dom = rawParent;
        }
      }
      return ret;
    };
    var prevSibling = function (element) {
      return Optional.from(element.dom.previousSibling).map(SugarElement.fromDom);
    };
    var nextSibling = function (element) {
      return Optional.from(element.dom.nextSibling).map(SugarElement.fromDom);
    };
    var children$3 = function (element) {
      return map$1(element.dom.childNodes, SugarElement.fromDom);
    };
    var child$3 = function (element, index) {
      var cs = element.dom.childNodes;
      return Optional.from(cs[index]).map(SugarElement.fromDom);
    };
    var firstChild = function (element) {
      return child$3(element, 0);
    };

    var isShadowRoot = function (dos) {
      return isDocumentFragment(dos) && isNonNullable(dos.dom.host);
    };
    var supported = isFunction(Element.prototype.attachShadow) && isFunction(Node.prototype.getRootNode);
    var isSupported$1 = constant(supported);
    var getRootNode = supported ? function (e) {
      return SugarElement.fromDom(e.dom.getRootNode());
    } : documentOrOwner;
    var getShadowRoot = function (e) {
      var r = getRootNode(e);
      return isShadowRoot(r) ? Optional.some(r) : Optional.none();
    };
    var getShadowHost = function (e) {
      return SugarElement.fromDom(e.dom.host);
    };
    var getOriginalEventTarget = function (event) {
      if (isSupported$1() && isNonNullable(event.target)) {
        var el = SugarElement.fromDom(event.target);
        if (isElement(el) && isOpenShadowHost(el)) {
          if (event.composed && event.composedPath) {
            var composedPath = event.composedPath();
            if (composedPath) {
              return head(composedPath);
            }
          }
        }
      }
      return Optional.from(event.target);
    };
    var isOpenShadowHost = function (element) {
      return isNonNullable(element.dom.shadowRoot);
    };

    var inBody = function (element) {
      var dom = isText(element) ? element.dom.parentNode : element.dom;
      if (dom === undefined || dom === null || dom.ownerDocument === null) {
        return false;
      }
      var doc = dom.ownerDocument;
      return getShadowRoot(SugarElement.fromDom(dom)).fold(function () {
        return doc.body.contains(dom);
      }, compose1(inBody, getShadowHost));
    };
    var body$1 = function () {
      return getBody$1(SugarElement.fromDom(document));
    };
    var getBody$1 = function (doc) {
      var b = doc.dom.body;
      if (b === null || b === undefined) {
        throw new Error('Body is not available yet');
      }
      return SugarElement.fromDom(b);
    };

    var ancestors$4 = function (scope, predicate, isRoot) {
      return filter$2(parents(scope, isRoot), predicate);
    };
    var children$2 = function (scope, predicate) {
      return filter$2(children$3(scope), predicate);
    };
    var descendants$1 = function (scope, predicate) {
      var result = [];
      each$2(children$3(scope), function (x) {
        if (predicate(x)) {
          result = result.concat([x]);
        }
        result = result.concat(descendants$1(x, predicate));
      });
      return result;
    };

    var ancestors$3 = function (scope, selector, isRoot) {
      return ancestors$4(scope, function (e) {
        return is$2(e, selector);
      }, isRoot);
    };
    var children$1 = function (scope, selector) {
      return children$2(scope, function (e) {
        return is$2(e, selector);
      });
    };
    var descendants = function (scope, selector) {
      return all$1(selector, scope);
    };

    function ClosestOrAncestor (is, ancestor, scope, a, isRoot) {
      if (is(scope, a)) {
        return Optional.some(scope);
      } else if (isFunction(isRoot) && isRoot(scope)) {
        return Optional.none();
      } else {
        return ancestor(scope, a, isRoot);
      }
    }

    var ancestor$2 = function (scope, predicate, isRoot) {
      var element = scope.dom;
      var stop = isFunction(isRoot) ? isRoot : never;
      while (element.parentNode) {
        element = element.parentNode;
        var el = SugarElement.fromDom(element);
        if (predicate(el)) {
          return Optional.some(el);
        } else if (stop(el)) {
          break;
        }
      }
      return Optional.none();
    };
    var closest$2 = function (scope, predicate, isRoot) {
      var is = function (s, test) {
        return test(s);
      };
      return ClosestOrAncestor(is, ancestor$2, scope, predicate, isRoot);
    };
    var child$2 = function (scope, predicate) {
      var pred = function (node) {
        return predicate(SugarElement.fromDom(node));
      };
      var result = find$1(scope.dom.childNodes, pred);
      return result.map(SugarElement.fromDom);
    };
    var descendant$1 = function (scope, predicate) {
      var descend = function (node) {
        for (var i = 0; i < node.childNodes.length; i++) {
          var child_1 = SugarElement.fromDom(node.childNodes[i]);
          if (predicate(child_1)) {
            return Optional.some(child_1);
          }
          var res = descend(node.childNodes[i]);
          if (res.isSome()) {
            return res;
          }
        }
        return Optional.none();
      };
      return descend(scope.dom);
    };

    var ancestor$1 = function (scope, selector, isRoot) {
      return ancestor$2(scope, function (e) {
        return is$2(e, selector);
      }, isRoot);
    };
    var child$1 = function (scope, selector) {
      return child$2(scope, function (e) {
        return is$2(e, selector);
      });
    };
    var descendant = function (scope, selector) {
      return one(selector, scope);
    };
    var closest$1 = function (scope, selector, isRoot) {
      var is = function (element, selector) {
        return is$2(element, selector);
      };
      return ClosestOrAncestor(is, ancestor$1, scope, selector, isRoot);
    };

    var rawSet = function (dom, key, value) {
      if (isString(value) || isBoolean(value) || isNumber(value)) {
        dom.setAttribute(key, value + '');
      } else {
        console.error('Invalid call to Attribute.set. Key ', key, ':: Value ', value, ':: Element ', dom);
        throw new Error('Attribute value was not simple');
      }
    };
    var set$2 = function (element, key, value) {
      rawSet(element.dom, key, value);
    };
    var setAll$1 = function (element, attrs) {
      var dom = element.dom;
      each$1(attrs, function (v, k) {
        rawSet(dom, k, v);
      });
    };
    var setOptions = function (element, attrs) {
      each$1(attrs, function (v, k) {
        v.fold(function () {
          remove$7(element, k);
        }, function (value) {
          rawSet(element.dom, k, value);
        });
      });
    };
    var get$b = function (element, key) {
      var v = element.dom.getAttribute(key);
      return v === null ? undefined : v;
    };
    var getOpt = function (element, key) {
      return Optional.from(get$b(element, key));
    };
    var remove$7 = function (element, key) {
      element.dom.removeAttribute(key);
    };
    var clone$2 = function (element) {
      return foldl(element.dom.attributes, function (acc, attr) {
        acc[attr.name] = attr.value;
        return acc;
      }, {});
    };

    var is = function (lhs, rhs, comparator) {
      if (comparator === void 0) {
        comparator = tripleEquals;
      }
      return lhs.exists(function (left) {
        return comparator(left, rhs);
      });
    };
    var cat = function (arr) {
      var r = [];
      var push = function (x) {
        r.push(x);
      };
      for (var i = 0; i < arr.length; i++) {
        arr[i].each(push);
      }
      return r;
    };
    var lift2 = function (oa, ob, f) {
      return oa.isSome() && ob.isSome() ? Optional.some(f(oa.getOrDie(), ob.getOrDie())) : Optional.none();
    };
    var bindFrom = function (a, f) {
      return a !== undefined && a !== null ? f(a) : Optional.none();
    };
    var flatten = function (oot) {
      return oot.bind(identity);
    };
    var someIf = function (b, a) {
      return b ? Optional.some(a) : Optional.none();
    };

    var isSupported = function (dom) {
      return dom.style !== undefined && isFunction(dom.style.getPropertyValue);
    };

    var internalSet = function (dom, property, value) {
      if (!isString(value)) {
        console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
        throw new Error('CSS value must be a string: ' + value);
      }
      if (isSupported(dom)) {
        dom.style.setProperty(property, value);
      }
    };
    var internalRemove = function (dom, property) {
      if (isSupported(dom)) {
        dom.style.removeProperty(property);
      }
    };
    var set$1 = function (element, property, value) {
      var dom = element.dom;
      internalSet(dom, property, value);
    };
    var setAll = function (element, css) {
      var dom = element.dom;
      each$1(css, function (v, k) {
        internalSet(dom, k, v);
      });
    };
    var get$a = function (element, property) {
      var dom = element.dom;
      var styles = window.getComputedStyle(dom);
      var r = styles.getPropertyValue(property);
      return r === '' && !inBody(element) ? getUnsafeProperty(dom, property) : r;
    };
    var getUnsafeProperty = function (dom, property) {
      return isSupported(dom) ? dom.style.getPropertyValue(property) : '';
    };
    var getRaw$2 = function (element, property) {
      var dom = element.dom;
      var raw = getUnsafeProperty(dom, property);
      return Optional.from(raw).filter(function (r) {
        return r.length > 0;
      });
    };
    var remove$6 = function (element, property) {
      var dom = element.dom;
      internalRemove(dom, property);
      if (is(getOpt(element, 'style').map(trim), '')) {
        remove$7(element, 'style');
      }
    };
    var copy$2 = function (source, target) {
      var sourceDom = source.dom;
      var targetDom = target.dom;
      if (isSupported(sourceDom) && isSupported(targetDom)) {
        targetDom.style.cssText = sourceDom.style.cssText;
      }
    };

    var getAttrValue = function (cell, name, fallback) {
      if (fallback === void 0) {
        fallback = 0;
      }
      return getOpt(cell, name).map(function (value) {
        return parseInt(value, 10);
      }).getOr(fallback);
    };
    var getSpan = function (cell, type) {
      return getAttrValue(cell, type, 1);
    };
    var hasColspan = function (cellOrCol) {
      if (isTag('col')(cellOrCol)) {
        return getAttrValue(cellOrCol, 'span', 1) > 1;
      } else {
        return getSpan(cellOrCol, 'colspan') > 1;
      }
    };
    var hasRowspan = function (cell) {
      return getSpan(cell, 'rowspan') > 1;
    };
    var getCssValue = function (element, property) {
      return parseInt(get$a(element, property), 10);
    };
    var minWidth = constant(10);
    var minHeight = constant(10);

    var firstLayer = function (scope, selector) {
      return filterFirstLayer(scope, selector, always);
    };
    var filterFirstLayer = function (scope, selector, predicate) {
      return bind$2(children$3(scope), function (x) {
        if (is$2(x, selector)) {
          return predicate(x) ? [x] : [];
        } else {
          return filterFirstLayer(x, selector, predicate);
        }
      });
    };

    var lookup = function (tags, element, isRoot) {
      if (isRoot === void 0) {
        isRoot = never;
      }
      if (isRoot(element)) {
        return Optional.none();
      }
      if (contains$2(tags, name(element))) {
        return Optional.some(element);
      }
      var isRootOrUpperTable = function (elm) {
        return is$2(elm, 'table') || isRoot(elm);
      };
      return ancestor$1(element, tags.join(','), isRootOrUpperTable);
    };
    var cell = function (element, isRoot) {
      return lookup([
        'td',
        'th'
      ], element, isRoot);
    };
    var cells$1 = function (ancestor) {
      return firstLayer(ancestor, 'th,td');
    };
    var columns$1 = function (ancestor) {
      if (is$2(ancestor, 'colgroup')) {
        return children$1(ancestor, 'col');
      } else {
        return bind$2(columnGroups(ancestor), function (columnGroup) {
          return children$1(columnGroup, 'col');
        });
      }
    };
    var table = function (element, isRoot) {
      return closest$1(element, 'table', isRoot);
    };
    var rows$1 = function (ancestor) {
      return firstLayer(ancestor, 'tr');
    };
    var columnGroups = function (ancestor) {
      return table(ancestor).fold(constant([]), function (table) {
        return children$1(table, 'colgroup');
      });
    };

    var fromRowsOrColGroups = function (elems, getSection) {
      return map$1(elems, function (row) {
        if (name(row) === 'colgroup') {
          var cells = map$1(columns$1(row), function (column) {
            var colspan = getAttrValue(column, 'span', 1);
            return detail(column, 1, colspan);
          });
          return rowdetail(row, cells, 'colgroup');
        } else {
          var cells = map$1(cells$1(row), function (cell) {
            var rowspan = getAttrValue(cell, 'rowspan', 1);
            var colspan = getAttrValue(cell, 'colspan', 1);
            return detail(cell, rowspan, colspan);
          });
          return rowdetail(row, cells, getSection(row));
        }
      });
    };
    var getParentSection = function (group) {
      return parent(group).map(function (parent) {
        var parentName = name(parent);
        return isValidSection(parentName) ? parentName : 'tbody';
      }).getOr('tbody');
    };
    var fromTable$1 = function (table) {
      var rows = rows$1(table);
      var columnGroups$1 = columnGroups(table);
      var elems = __spreadArray(__spreadArray([], columnGroups$1, true), rows, true);
      return fromRowsOrColGroups(elems, getParentSection);
    };
    var fromPastedRows = function (elems, section) {
      return fromRowsOrColGroups(elems, function () {
        return section;
      });
    };

    var addCells = function (gridRow, index, cells) {
      var existingCells = gridRow.cells;
      var before = existingCells.slice(0, index);
      var after = existingCells.slice(index);
      var newCells = before.concat(cells).concat(after);
      return setCells(gridRow, newCells);
    };
    var addCell = function (gridRow, index, cell) {
      return addCells(gridRow, index, [cell]);
    };
    var mutateCell = function (gridRow, index, cell) {
      var cells = gridRow.cells;
      cells[index] = cell;
    };
    var setCells = function (gridRow, cells) {
      return rowcells(gridRow.element, cells, gridRow.section, gridRow.isNew);
    };
    var mapCells = function (gridRow, f) {
      var cells = gridRow.cells;
      var r = map$1(cells, f);
      return rowcells(gridRow.element, r, gridRow.section, gridRow.isNew);
    };
    var getCell = function (gridRow, index) {
      return gridRow.cells[index];
    };
    var getCellElement = function (gridRow, index) {
      return getCell(gridRow, index).element;
    };
    var cellLength = function (gridRow) {
      return gridRow.cells.length;
    };
    var extractGridDetails = function (grid) {
      var result = partition(grid, function (row) {
        return row.section === 'colgroup';
      });
      return {
        rows: result.fail,
        cols: result.pass
      };
    };
    var clone$1 = function (gridRow, cloneRow, cloneCell) {
      var newCells = map$1(gridRow.cells, cloneCell);
      return rowcells(cloneRow(gridRow.element), newCells, gridRow.section, true);
    };

    var LOCKED_COL_ATTR = 'data-snooker-locked-cols';
    var getLockedColumnsFromTable = function (table) {
      return getOpt(table, LOCKED_COL_ATTR).bind(function (lockedColStr) {
        return Optional.from(lockedColStr.match(/\d+/g));
      }).map(function (lockedCols) {
        return mapToObject(lockedCols, always);
      });
    };
    var getLockedColumnsFromGrid = function (grid) {
      var locked = foldl(extractGridDetails(grid).rows, function (acc, row) {
        each$2(row.cells, function (cell, idx) {
          if (cell.isLocked) {
            acc[idx] = true;
          }
        });
        return acc;
      }, {});
      var lockedArr = mapToArray(locked, function (_val, key) {
        return parseInt(key, 10);
      });
      return sort$1(lockedArr);
    };

    var key = function (row, column) {
      return row + ',' + column;
    };
    var getAt = function (warehouse, row, column) {
      return Optional.from(warehouse.access[key(row, column)]);
    };
    var findItem = function (warehouse, item, comparator) {
      var filtered = filterItems(warehouse, function (detail) {
        return comparator(item, detail.element);
      });
      return filtered.length > 0 ? Optional.some(filtered[0]) : Optional.none();
    };
    var filterItems = function (warehouse, predicate) {
      var all = bind$2(warehouse.all, function (r) {
        return r.cells;
      });
      return filter$2(all, predicate);
    };
    var generateColumns = function (rowData) {
      var columnsGroup = {};
      var index = 0;
      each$2(rowData.cells, function (column) {
        var colspan = column.colspan;
        range$1(colspan, function (columnIndex) {
          var colIndex = index + columnIndex;
          columnsGroup[colIndex] = columnext(column.element, colspan, colIndex);
        });
        index += colspan;
      });
      return columnsGroup;
    };
    var generate$1 = function (list) {
      var access = {};
      var cells = [];
      var tableOpt = head(list).map(function (rowData) {
        return rowData.element;
      }).bind(table);
      var lockedColumns = tableOpt.bind(getLockedColumnsFromTable).getOr({});
      var maxRows = 0;
      var maxColumns = 0;
      var rowCount = 0;
      var _a = partition(list, function (rowData) {
          return rowData.section === 'colgroup';
        }), colgroupRows = _a.pass, rows = _a.fail;
      each$2(rows, function (rowData) {
        var currentRow = [];
        each$2(rowData.cells, function (rowCell) {
          var start = 0;
          while (access[key(rowCount, start)] !== undefined) {
            start++;
          }
          var isLocked = hasNonNullableKey(lockedColumns, start.toString());
          var current = extended(rowCell.element, rowCell.rowspan, rowCell.colspan, rowCount, start, isLocked);
          for (var occupiedColumnPosition = 0; occupiedColumnPosition < rowCell.colspan; occupiedColumnPosition++) {
            for (var occupiedRowPosition = 0; occupiedRowPosition < rowCell.rowspan; occupiedRowPosition++) {
              var rowPosition = rowCount + occupiedRowPosition;
              var columnPosition = start + occupiedColumnPosition;
              var newpos = key(rowPosition, columnPosition);
              access[newpos] = current;
              maxColumns = Math.max(maxColumns, columnPosition + 1);
            }
          }
          currentRow.push(current);
        });
        maxRows++;
        cells.push(rowdetail(rowData.element, currentRow, rowData.section));
        rowCount++;
      });
      var _b = last$2(colgroupRows).map(function (rowData) {
          var columns = generateColumns(rowData);
          var colgroup$1 = colgroup(rowData.element, values(columns));
          return {
            colgroups: [colgroup$1],
            columns: columns
          };
        }).getOrThunk(function () {
          return {
            colgroups: [],
            columns: {}
          };
        }), columns = _b.columns, colgroups = _b.colgroups;
      var grid$1 = grid(maxRows, maxColumns);
      return {
        grid: grid$1,
        access: access,
        all: cells,
        columns: columns,
        colgroups: colgroups
      };
    };
    var fromTable = function (table) {
      var list = fromTable$1(table);
      return generate$1(list);
    };
    var justCells = function (warehouse) {
      return bind$2(warehouse.all, function (w) {
        return w.cells;
      });
    };
    var justColumns = function (warehouse) {
      return values(warehouse.columns);
    };
    var hasColumns = function (warehouse) {
      return keys(warehouse.columns).length > 0;
    };
    var getColumnAt = function (warehouse, columnIndex) {
      return Optional.from(warehouse.columns[columnIndex]);
    };
    var Warehouse = {
      fromTable: fromTable,
      generate: generate$1,
      getAt: getAt,
      findItem: findItem,
      filterItems: filterItems,
      justCells: justCells,
      justColumns: justColumns,
      hasColumns: hasColumns,
      getColumnAt: getColumnAt
    };

    var inSelection = function (bounds, detail) {
      var leftEdge = detail.column;
      var rightEdge = detail.column + detail.colspan - 1;
      var topEdge = detail.row;
      var bottomEdge = detail.row + detail.rowspan - 1;
      return leftEdge <= bounds.finishCol && rightEdge >= bounds.startCol && (topEdge <= bounds.finishRow && bottomEdge >= bounds.startRow);
    };
    var isWithin = function (bounds, detail) {
      return detail.column >= bounds.startCol && detail.column + detail.colspan - 1 <= bounds.finishCol && detail.row >= bounds.startRow && detail.row + detail.rowspan - 1 <= bounds.finishRow;
    };
    var isRectangular = function (warehouse, bounds) {
      var isRect = true;
      var detailIsWithin = curry(isWithin, bounds);
      for (var i = bounds.startRow; i <= bounds.finishRow; i++) {
        for (var j = bounds.startCol; j <= bounds.finishCol; j++) {
          isRect = isRect && Warehouse.getAt(warehouse, i, j).exists(detailIsWithin);
        }
      }
      return isRect ? Optional.some(bounds) : Optional.none();
    };

    var getBounds = function (detailA, detailB) {
      return bounds(Math.min(detailA.row, detailB.row), Math.min(detailA.column, detailB.column), Math.max(detailA.row + detailA.rowspan - 1, detailB.row + detailB.rowspan - 1), Math.max(detailA.column + detailA.colspan - 1, detailB.column + detailB.colspan - 1));
    };
    var getAnyBox = function (warehouse, startCell, finishCell) {
      var startCoords = Warehouse.findItem(warehouse, startCell, eq$1);
      var finishCoords = Warehouse.findItem(warehouse, finishCell, eq$1);
      return startCoords.bind(function (sc) {
        return finishCoords.map(function (fc) {
          return getBounds(sc, fc);
        });
      });
    };
    var getBox$1 = function (warehouse, startCell, finishCell) {
      return getAnyBox(warehouse, startCell, finishCell).bind(function (bounds) {
        return isRectangular(warehouse, bounds);
      });
    };

    var moveBy$1 = function (warehouse, cell, row, column) {
      return Warehouse.findItem(warehouse, cell, eq$1).bind(function (detail) {
        var startRow = row > 0 ? detail.row + detail.rowspan - 1 : detail.row;
        var startCol = column > 0 ? detail.column + detail.colspan - 1 : detail.column;
        var dest = Warehouse.getAt(warehouse, startRow + row, startCol + column);
        return dest.map(function (d) {
          return d.element;
        });
      });
    };
    var intercepts$1 = function (warehouse, start, finish) {
      return getAnyBox(warehouse, start, finish).map(function (bounds) {
        var inside = Warehouse.filterItems(warehouse, curry(inSelection, bounds));
        return map$1(inside, function (detail) {
          return detail.element;
        });
      });
    };
    var parentCell = function (warehouse, innerCell) {
      var isContainedBy = function (c1, c2) {
        return contains(c2, c1);
      };
      return Warehouse.findItem(warehouse, innerCell, isContainedBy).map(function (detail) {
        return detail.element;
      });
    };

    var moveBy = function (cell, deltaRow, deltaColumn) {
      return table(cell).bind(function (table) {
        var warehouse = getWarehouse(table);
        return moveBy$1(warehouse, cell, deltaRow, deltaColumn);
      });
    };
    var intercepts = function (table, first, last) {
      var warehouse = getWarehouse(table);
      return intercepts$1(warehouse, first, last);
    };
    var nestedIntercepts = function (table, first, firstTable, last, lastTable) {
      var warehouse = getWarehouse(table);
      var optStartCell = eq$1(table, firstTable) ? Optional.some(first) : parentCell(warehouse, first);
      var optLastCell = eq$1(table, lastTable) ? Optional.some(last) : parentCell(warehouse, last);
      return optStartCell.bind(function (startCell) {
        return optLastCell.bind(function (lastCell) {
          return intercepts$1(warehouse, startCell, lastCell);
        });
      });
    };
    var getBox = function (table, first, last) {
      var warehouse = getWarehouse(table);
      return getBox$1(warehouse, first, last);
    };
    var getWarehouse = Warehouse.fromTable;

    var before$4 = function (marker, element) {
      var parent$1 = parent(marker);
      parent$1.each(function (v) {
        v.dom.insertBefore(element.dom, marker.dom);
      });
    };
    var after$5 = function (marker, element) {
      var sibling = nextSibling(marker);
      sibling.fold(function () {
        var parent$1 = parent(marker);
        parent$1.each(function (v) {
          append$1(v, element);
        });
      }, function (v) {
        before$4(v, element);
      });
    };
    var prepend = function (parent, element) {
      var firstChild$1 = firstChild(parent);
      firstChild$1.fold(function () {
        append$1(parent, element);
      }, function (v) {
        parent.dom.insertBefore(element.dom, v.dom);
      });
    };
    var append$1 = function (parent, element) {
      parent.dom.appendChild(element.dom);
    };
    var appendAt = function (parent, element, index) {
      child$3(parent, index).fold(function () {
        append$1(parent, element);
      }, function (v) {
        before$4(v, element);
      });
    };
    var wrap = function (element, wrapper) {
      before$4(element, wrapper);
      append$1(wrapper, element);
    };

    var before$3 = function (marker, elements) {
      each$2(elements, function (x) {
        before$4(marker, x);
      });
    };
    var after$4 = function (marker, elements) {
      each$2(elements, function (x, i) {
        var e = i === 0 ? marker : elements[i - 1];
        after$5(e, x);
      });
    };
    var append = function (parent, elements) {
      each$2(elements, function (x) {
        append$1(parent, x);
      });
    };

    var empty = function (element) {
      element.dom.textContent = '';
      each$2(children$3(element), function (rogue) {
        remove$5(rogue);
      });
    };
    var remove$5 = function (element) {
      var dom = element.dom;
      if (dom.parentNode !== null) {
        dom.parentNode.removeChild(dom);
      }
    };
    var unwrap = function (wrapper) {
      var children = children$3(wrapper);
      if (children.length > 0) {
        before$3(wrapper, children);
      }
      remove$5(wrapper);
    };

    var NodeValue = function (is, name) {
      var get = function (element) {
        if (!is(element)) {
          throw new Error('Can only get ' + name + ' value of a ' + name + ' node');
        }
        return getOption(element).getOr('');
      };
      var getOption = function (element) {
        return is(element) ? Optional.from(element.dom.nodeValue) : Optional.none();
      };
      var set = function (element, value) {
        if (!is(element)) {
          throw new Error('Can only set raw ' + name + ' value of a ' + name + ' node');
        }
        element.dom.nodeValue = value;
      };
      return {
        get: get,
        getOption: getOption,
        set: set
      };
    };

    var api$2 = NodeValue(isText, 'text');
    var get$9 = function (element) {
      return api$2.get(element);
    };
    var getOption = function (element) {
      return api$2.getOption(element);
    };
    var set = function (element, value) {
      return api$2.set(element, value);
    };

    var TagBoundaries = [
      'body',
      'p',
      'div',
      'article',
      'aside',
      'figcaption',
      'figure',
      'footer',
      'header',
      'nav',
      'section',
      'ol',
      'ul',
      'li',
      'table',
      'thead',
      'tbody',
      'tfoot',
      'caption',
      'tr',
      'td',
      'th',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'blockquote',
      'pre',
      'address'
    ];

    function DomUniverse () {
      var clone = function (element) {
        return SugarElement.fromDom(element.dom.cloneNode(false));
      };
      var document = function (element) {
        return documentOrOwner(element).dom;
      };
      var isBoundary = function (element) {
        if (!isElement(element)) {
          return false;
        }
        if (name(element) === 'body') {
          return true;
        }
        return contains$2(TagBoundaries, name(element));
      };
      var isEmptyTag = function (element) {
        if (!isElement(element)) {
          return false;
        }
        return contains$2([
          'br',
          'img',
          'hr',
          'input'
        ], name(element));
      };
      var isNonEditable = function (element) {
        return isElement(element) && get$b(element, 'contenteditable') === 'false';
      };
      var comparePosition = function (element, other) {
        return element.dom.compareDocumentPosition(other.dom);
      };
      var copyAttributesTo = function (source, destination) {
        var as = clone$2(source);
        setAll$1(destination, as);
      };
      var isSpecial = function (element) {
        var tag = name(element);
        return contains$2([
          'script',
          'noscript',
          'iframe',
          'noframes',
          'noembed',
          'title',
          'style',
          'textarea',
          'xmp'
        ], tag);
      };
      var getLanguage = function (element) {
        return isElement(element) ? getOpt(element, 'lang') : Optional.none();
      };
      return {
        up: constant({
          selector: ancestor$1,
          closest: closest$1,
          predicate: ancestor$2,
          all: parents
        }),
        down: constant({
          selector: descendants,
          predicate: descendants$1
        }),
        styles: constant({
          get: get$a,
          getRaw: getRaw$2,
          set: set$1,
          remove: remove$6
        }),
        attrs: constant({
          get: get$b,
          set: set$2,
          remove: remove$7,
          copyTo: copyAttributesTo
        }),
        insert: constant({
          before: before$4,
          after: after$5,
          afterAll: after$4,
          append: append$1,
          appendAll: append,
          prepend: prepend,
          wrap: wrap
        }),
        remove: constant({
          unwrap: unwrap,
          remove: remove$5
        }),
        create: constant({
          nu: SugarElement.fromTag,
          clone: clone,
          text: SugarElement.fromText
        }),
        query: constant({
          comparePosition: comparePosition,
          prevSibling: prevSibling,
          nextSibling: nextSibling
        }),
        property: constant({
          children: children$3,
          name: name,
          parent: parent,
          document: document,
          isText: isText,
          isComment: isComment,
          isElement: isElement,
          isSpecial: isSpecial,
          getLanguage: getLanguage,
          getText: get$9,
          setText: set,
          isBoundary: isBoundary,
          isEmptyTag: isEmptyTag,
          isNonEditable: isNonEditable
        }),
        eq: eq$1,
        is: is$1
      };
    }

    var all = function (universe, look, elements, f) {
      var head = elements[0];
      var tail = elements.slice(1);
      return f(universe, look, head, tail);
    };
    var oneAll = function (universe, look, elements) {
      return elements.length > 0 ? all(universe, look, elements, unsafeOne) : Optional.none();
    };
    var unsafeOne = function (universe, look, head, tail) {
      var start = look(universe, head);
      return foldr(tail, function (b, a) {
        var current = look(universe, a);
        return commonElement(universe, b, current);
      }, start);
    };
    var commonElement = function (universe, start, end) {
      return start.bind(function (s) {
        return end.filter(curry(universe.eq, s));
      });
    };

    var eq = function (universe, item) {
      return curry(universe.eq, item);
    };
    var ancestors$2 = function (universe, start, end, isRoot) {
      if (isRoot === void 0) {
        isRoot = never;
      }
      var ps1 = [start].concat(universe.up().all(start));
      var ps2 = [end].concat(universe.up().all(end));
      var prune = function (path) {
        var index = findIndex(path, isRoot);
        return index.fold(function () {
          return path;
        }, function (ind) {
          return path.slice(0, ind + 1);
        });
      };
      var pruned1 = prune(ps1);
      var pruned2 = prune(ps2);
      var shared = find$1(pruned1, function (x) {
        return exists(pruned2, eq(universe, x));
      });
      return {
        firstpath: pruned1,
        secondpath: pruned2,
        shared: shared
      };
    };

    var sharedOne$1 = oneAll;
    var ancestors$1 = ancestors$2;

    var universe$3 = DomUniverse();
    var sharedOne = function (look, elements) {
      return sharedOne$1(universe$3, function (_universe, element) {
        return look(element);
      }, elements);
    };
    var ancestors = function (start, finish, isRoot) {
      return ancestors$1(universe$3, start, finish, isRoot);
    };

    var lookupTable = function (container) {
      return ancestor$1(container, 'table');
    };
    var identify = function (start, finish, isRoot) {
      var getIsRoot = function (rootTable) {
        return function (element) {
          return isRoot !== undefined && isRoot(element) || eq$1(element, rootTable);
        };
      };
      if (eq$1(start, finish)) {
        return Optional.some({
          boxes: Optional.some([start]),
          start: start,
          finish: finish
        });
      } else {
        return lookupTable(start).bind(function (startTable) {
          return lookupTable(finish).bind(function (finishTable) {
            if (eq$1(startTable, finishTable)) {
              return Optional.some({
                boxes: intercepts(startTable, start, finish),
                start: start,
                finish: finish
              });
            } else if (contains(startTable, finishTable)) {
              var ancestorCells = ancestors$3(finish, 'td,th', getIsRoot(startTable));
              var finishCell = ancestorCells.length > 0 ? ancestorCells[ancestorCells.length - 1] : finish;
              return Optional.some({
                boxes: nestedIntercepts(startTable, start, startTable, finish, finishTable),
                start: start,
                finish: finishCell
              });
            } else if (contains(finishTable, startTable)) {
              var ancestorCells = ancestors$3(start, 'td,th', getIsRoot(finishTable));
              var startCell = ancestorCells.length > 0 ? ancestorCells[ancestorCells.length - 1] : start;
              return Optional.some({
                boxes: nestedIntercepts(finishTable, start, startTable, finish, finishTable),
                start: start,
                finish: startCell
              });
            } else {
              return ancestors(start, finish).shared.bind(function (lca) {
                return closest$1(lca, 'table', isRoot).bind(function (lcaTable) {
                  var finishAncestorCells = ancestors$3(finish, 'td,th', getIsRoot(lcaTable));
                  var finishCell = finishAncestorCells.length > 0 ? finishAncestorCells[finishAncestorCells.length - 1] : finish;
                  var startAncestorCells = ancestors$3(start, 'td,th', getIsRoot(lcaTable));
                  var startCell = startAncestorCells.length > 0 ? startAncestorCells[startAncestorCells.length - 1] : start;
                  return Optional.some({
                    boxes: nestedIntercepts(lcaTable, start, startTable, finish, finishTable),
                    start: startCell,
                    finish: finishCell
                  });
                });
              });
            }
          });
        });
      }
    };
    var retrieve$1 = function (container, selector) {
      var sels = descendants(container, selector);
      return sels.length > 0 ? Optional.some(sels) : Optional.none();
    };
    var getLast = function (boxes, lastSelectedSelector) {
      return find$1(boxes, function (box) {
        return is$2(box, lastSelectedSelector);
      });
    };
    var getEdges = function (container, firstSelectedSelector, lastSelectedSelector) {
      return descendant(container, firstSelectedSelector).bind(function (first) {
        return descendant(container, lastSelectedSelector).bind(function (last) {
          return sharedOne(lookupTable, [
            first,
            last
          ]).map(function (table) {
            return {
              first: first,
              last: last,
              table: table
            };
          });
        });
      });
    };
    var expandTo = function (finish, firstSelectedSelector) {
      return ancestor$1(finish, 'table').bind(function (table) {
        return descendant(table, firstSelectedSelector).bind(function (start) {
          return identify(start, finish).bind(function (identified) {
            return identified.boxes.map(function (boxes) {
              return {
                boxes: boxes,
                start: identified.start,
                finish: identified.finish
              };
            });
          });
        });
      });
    };
    var shiftSelection = function (boxes, deltaRow, deltaColumn, firstSelectedSelector, lastSelectedSelector) {
      return getLast(boxes, lastSelectedSelector).bind(function (last) {
        return moveBy(last, deltaRow, deltaColumn).bind(function (finish) {
          return expandTo(finish, firstSelectedSelector);
        });
      });
    };

    var retrieve = function (container, selector) {
      return retrieve$1(container, selector);
    };
    var retrieveBox = function (container, firstSelectedSelector, lastSelectedSelector) {
      return getEdges(container, firstSelectedSelector, lastSelectedSelector).bind(function (edges) {
        var isRoot = function (ancestor) {
          return eq$1(container, ancestor);
        };
        var sectionSelector = 'thead,tfoot,tbody,table';
        var firstAncestor = ancestor$1(edges.first, sectionSelector, isRoot);
        var lastAncestor = ancestor$1(edges.last, sectionSelector, isRoot);
        return firstAncestor.bind(function (fA) {
          return lastAncestor.bind(function (lA) {
            return eq$1(fA, lA) ? getBox(edges.table, edges.first, edges.last) : Optional.none();
          });
        });
      });
    };

    var generate = function (cases) {
      if (!isArray(cases)) {
        throw new Error('cases must be an array');
      }
      if (cases.length === 0) {
        throw new Error('there must be at least one case');
      }
      var constructors = [];
      var adt = {};
      each$2(cases, function (acase, count) {
        var keys$1 = keys(acase);
        if (keys$1.length !== 1) {
          throw new Error('one and only one name per case');
        }
        var key = keys$1[0];
        var value = acase[key];
        if (adt[key] !== undefined) {
          throw new Error('duplicate key detected:' + key);
        } else if (key === 'cata') {
          throw new Error('cannot have a case named cata (sorry)');
        } else if (!isArray(value)) {
          throw new Error('case arguments must be an array');
        }
        constructors.push(key);
        adt[key] = function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          var argLength = args.length;
          if (argLength !== value.length) {
            throw new Error('Wrong number of arguments to case ' + key + '. Expected ' + value.length + ' (' + value + '), got ' + argLength);
          }
          var match = function (branches) {
            var branchKeys = keys(branches);
            if (constructors.length !== branchKeys.length) {
              throw new Error('Wrong number of arguments to match. Expected: ' + constructors.join(',') + '\nActual: ' + branchKeys.join(','));
            }
            var allReqd = forall(constructors, function (reqKey) {
              return contains$2(branchKeys, reqKey);
            });
            if (!allReqd) {
              throw new Error('Not all branches were specified when using match. Specified: ' + branchKeys.join(', ') + '\nRequired: ' + constructors.join(', '));
            }
            return branches[key].apply(null, args);
          };
          return {
            fold: function () {
              var foldArgs = [];
              for (var _i = 0; _i < arguments.length; _i++) {
                foldArgs[_i] = arguments[_i];
              }
              if (foldArgs.length !== cases.length) {
                throw new Error('Wrong number of arguments to fold. Expected ' + cases.length + ', got ' + foldArgs.length);
              }
              var target = foldArgs[count];
              return target.apply(null, args);
            },
            match: match,
            log: function (label) {
              console.log(label, {
                constructors: constructors,
                constructor: key,
                params: args
              });
            }
          };
        };
      });
      return adt;
    };
    var Adt = { generate: generate };

    var type = Adt.generate([
      { none: [] },
      { multiple: ['elements'] },
      { single: ['element'] }
    ]);
    var cata$2 = function (subject, onNone, onMultiple, onSingle) {
      return subject.fold(onNone, onMultiple, onSingle);
    };
    var none$1 = type.none;
    var multiple = type.multiple;
    var single = type.single;

    var Selections = function (lazyRoot, getStart, selectedSelector) {
      var get = function () {
        return retrieve(lazyRoot(), selectedSelector).fold(function () {
          return getStart().fold(none$1, single);
        }, function (cells) {
          return multiple(cells);
        });
      };
      return { get: get };
    };

    var global$3 = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var clone = function (original, isDeep) {
      return SugarElement.fromDom(original.dom.cloneNode(isDeep));
    };
    var shallow = function (original) {
      return clone(original, false);
    };
    var deep = function (original) {
      return clone(original, true);
    };
    var shallowAs = function (original, tag) {
      var nu = SugarElement.fromTag(tag);
      var attributes = clone$2(original);
      setAll$1(nu, attributes);
      return nu;
    };
    var copy$1 = function (original, tag) {
      var nu = shallowAs(original, tag);
      var cloneChildren = children$3(deep(original));
      append(nu, cloneChildren);
      return nu;
    };
    var mutate$1 = function (original, tag) {
      var nu = shallowAs(original, tag);
      before$4(original, nu);
      var children = children$3(original);
      append(nu, children);
      remove$5(original);
      return nu;
    };

    var Dimension = function (name, getOffset) {
      var set = function (element, h) {
        if (!isNumber(h) && !h.match(/^[0-9]+$/)) {
          throw new Error(name + '.set accepts only positive integer values. Value was ' + h);
        }
        var dom = element.dom;
        if (isSupported(dom)) {
          dom.style[name] = h + 'px';
        }
      };
      var get = function (element) {
        var r = getOffset(element);
        if (r <= 0 || r === null) {
          var css = get$a(element, name);
          return parseFloat(css) || 0;
        }
        return r;
      };
      var getOuter = get;
      var aggregate = function (element, properties) {
        return foldl(properties, function (acc, property) {
          var val = get$a(element, property);
          var value = val === undefined ? 0 : parseInt(val, 10);
          return isNaN(value) ? acc : acc + value;
        }, 0);
      };
      var max = function (element, value, properties) {
        var cumulativeInclusions = aggregate(element, properties);
        var absoluteMax = value > cumulativeInclusions ? value - cumulativeInclusions : 0;
        return absoluteMax;
      };
      return {
        set: set,
        get: get,
        getOuter: getOuter,
        aggregate: aggregate,
        max: max
      };
    };

    var needManualCalc = function () {
      var browser = detect$3().browser;
      return browser.isIE() || browser.isEdge();
    };
    var toNumber = function (px, fallback) {
      return toFloat(px).getOr(fallback);
    };
    var getProp = function (element, name, fallback) {
      return toNumber(get$a(element, name), fallback);
    };
    var getBoxSizing = function (element) {
      return get$a(element, 'box-sizing');
    };
    var calcContentBoxSize = function (element, size, upper, lower) {
      var paddingUpper = getProp(element, 'padding-' + upper, 0);
      var paddingLower = getProp(element, 'padding-' + lower, 0);
      var borderUpper = getProp(element, 'border-' + upper + '-width', 0);
      var borderLower = getProp(element, 'border-' + lower + '-width', 0);
      return size - paddingUpper - paddingLower - borderUpper - borderLower;
    };
    var getCalculatedHeight = function (element, boxSizing) {
      var dom = element.dom;
      var height = dom.getBoundingClientRect().height || dom.offsetHeight;
      return boxSizing === 'border-box' ? height : calcContentBoxSize(element, height, 'top', 'bottom');
    };
    var getCalculatedWidth = function (element, boxSizing) {
      var dom = element.dom;
      var width = dom.getBoundingClientRect().width || dom.offsetWidth;
      return boxSizing === 'border-box' ? width : calcContentBoxSize(element, width, 'left', 'right');
    };
    var getHeight$1 = function (element) {
      return needManualCalc() ? getCalculatedHeight(element, getBoxSizing(element)) : getProp(element, 'height', element.dom.offsetHeight);
    };
    var getWidth = function (element) {
      return needManualCalc() ? getCalculatedWidth(element, getBoxSizing(element)) : getProp(element, 'width', element.dom.offsetWidth);
    };
    var getInnerWidth = function (element) {
      return getCalculatedWidth(element, 'content-box');
    };

    var api$1 = Dimension('width', function (element) {
      return element.dom.offsetWidth;
    });
    var get$8 = function (element) {
      return api$1.get(element);
    };
    var getOuter$2 = function (element) {
      return api$1.getOuter(element);
    };
    var getInner = getInnerWidth;
    var getRuntime$1 = getWidth;

    var columns = function (warehouse, isValidCell) {
      if (isValidCell === void 0) {
        isValidCell = always;
      }
      var grid = warehouse.grid;
      var cols = range$1(grid.columns, identity);
      var rowsArr = range$1(grid.rows, identity);
      return map$1(cols, function (col) {
        var getBlock = function () {
          return bind$2(rowsArr, function (r) {
            return Warehouse.getAt(warehouse, r, col).filter(function (detail) {
              return detail.column === col;
            }).toArray();
          });
        };
        var isValid = function (detail) {
          return detail.colspan === 1 && isValidCell(detail.element);
        };
        var getFallback = function () {
          return Warehouse.getAt(warehouse, 0, col);
        };
        return decide(getBlock, isValid, getFallback);
      });
    };
    var decide = function (getBlock, isValid, getFallback) {
      var inBlock = getBlock();
      var validInBlock = find$1(inBlock, isValid);
      var detailOption = validInBlock.orThunk(function () {
        return Optional.from(inBlock[0]).orThunk(getFallback);
      });
      return detailOption.map(function (detail) {
        return detail.element;
      });
    };
    var rows = function (warehouse) {
      var grid = warehouse.grid;
      var rowsArr = range$1(grid.rows, identity);
      var cols = range$1(grid.columns, identity);
      return map$1(rowsArr, function (row) {
        var getBlock = function () {
          return bind$2(cols, function (c) {
            return Warehouse.getAt(warehouse, row, c).filter(function (detail) {
              return detail.row === row;
            }).fold(constant([]), function (detail) {
              return [detail];
            });
          });
        };
        var isSingle = function (detail) {
          return detail.rowspan === 1;
        };
        var getFallback = function () {
          return Warehouse.getAt(warehouse, row, 0);
        };
        return decide(getBlock, isSingle, getFallback);
      });
    };

    var deduce = function (xs, index) {
      if (index < 0 || index >= xs.length - 1) {
        return Optional.none();
      }
      var current = xs[index].fold(function () {
        var rest = reverse(xs.slice(0, index));
        return findMap(rest, function (a, i) {
          return a.map(function (aa) {
            return {
              value: aa,
              delta: i + 1
            };
          });
        });
      }, function (c) {
        return Optional.some({
          value: c,
          delta: 0
        });
      });
      var next = xs[index + 1].fold(function () {
        var rest = xs.slice(index + 1);
        return findMap(rest, function (a, i) {
          return a.map(function (aa) {
            return {
              value: aa,
              delta: i + 1
            };
          });
        });
      }, function (n) {
        return Optional.some({
          value: n,
          delta: 1
        });
      });
      return current.bind(function (c) {
        return next.map(function (n) {
          var extras = n.delta + c.delta;
          return Math.abs(n.value - c.value) / extras;
        });
      });
    };

    var onDirection = function (isLtr, isRtl) {
      return function (element) {
        return getDirection(element) === 'rtl' ? isRtl : isLtr;
      };
    };
    var getDirection = function (element) {
      return get$a(element, 'direction') === 'rtl' ? 'rtl' : 'ltr';
    };

    var api = Dimension('height', function (element) {
      var dom = element.dom;
      return inBody(element) ? dom.getBoundingClientRect().height : dom.offsetHeight;
    });
    var get$7 = function (element) {
      return api.get(element);
    };
    var getOuter$1 = function (element) {
      return api.getOuter(element);
    };
    var getRuntime = getHeight$1;

    var r = function (left, top) {
      var translate = function (x, y) {
        return r(left + x, top + y);
      };
      return {
        left: left,
        top: top,
        translate: translate
      };
    };
    var SugarPosition = r;

    var boxPosition = function (dom) {
      var box = dom.getBoundingClientRect();
      return SugarPosition(box.left, box.top);
    };
    var firstDefinedOrZero = function (a, b) {
      if (a !== undefined) {
        return a;
      } else {
        return b !== undefined ? b : 0;
      }
    };
    var absolute = function (element) {
      var doc = element.dom.ownerDocument;
      var body = doc.body;
      var win = doc.defaultView;
      var html = doc.documentElement;
      if (body === element.dom) {
        return SugarPosition(body.offsetLeft, body.offsetTop);
      }
      var scrollTop = firstDefinedOrZero(win === null || win === void 0 ? void 0 : win.pageYOffset, html.scrollTop);
      var scrollLeft = firstDefinedOrZero(win === null || win === void 0 ? void 0 : win.pageXOffset, html.scrollLeft);
      var clientTop = firstDefinedOrZero(html.clientTop, body.clientTop);
      var clientLeft = firstDefinedOrZero(html.clientLeft, body.clientLeft);
      return viewport(element).translate(scrollLeft - clientLeft, scrollTop - clientTop);
    };
    var viewport = function (element) {
      var dom = element.dom;
      var doc = dom.ownerDocument;
      var body = doc.body;
      if (body === dom) {
        return SugarPosition(body.offsetLeft, body.offsetTop);
      }
      if (!inBody(element)) {
        return SugarPosition(0, 0);
      }
      return boxPosition(dom);
    };

    var rowInfo = function (row, y) {
      return {
        row: row,
        y: y
      };
    };
    var colInfo = function (col, x) {
      return {
        col: col,
        x: x
      };
    };
    var rtlEdge = function (cell) {
      var pos = absolute(cell);
      return pos.left + getOuter$2(cell);
    };
    var ltrEdge = function (cell) {
      return absolute(cell).left;
    };
    var getLeftEdge = function (index, cell) {
      return colInfo(index, ltrEdge(cell));
    };
    var getRightEdge = function (index, cell) {
      return colInfo(index, rtlEdge(cell));
    };
    var getTop$1 = function (cell) {
      return absolute(cell).top;
    };
    var getTopEdge = function (index, cell) {
      return rowInfo(index, getTop$1(cell));
    };
    var getBottomEdge = function (index, cell) {
      return rowInfo(index, getTop$1(cell) + getOuter$1(cell));
    };
    var findPositions = function (getInnerEdge, getOuterEdge, array) {
      if (array.length === 0) {
        return [];
      }
      var lines = map$1(array.slice(1), function (cellOption, index) {
        return cellOption.map(function (cell) {
          return getInnerEdge(index, cell);
        });
      });
      var lastLine = array[array.length - 1].map(function (cell) {
        return getOuterEdge(array.length - 1, cell);
      });
      return lines.concat([lastLine]);
    };
    var negate = function (step) {
      return -step;
    };
    var height = {
      delta: identity,
      positions: function (optElements) {
        return findPositions(getTopEdge, getBottomEdge, optElements);
      },
      edge: getTop$1
    };
    var ltr$1 = {
      delta: identity,
      edge: ltrEdge,
      positions: function (optElements) {
        return findPositions(getLeftEdge, getRightEdge, optElements);
      }
    };
    var rtl$1 = {
      delta: negate,
      edge: rtlEdge,
      positions: function (optElements) {
        return findPositions(getRightEdge, getLeftEdge, optElements);
      }
    };
    var detect$2 = onDirection(ltr$1, rtl$1);
    var width = {
      delta: function (amount, table) {
        return detect$2(table).delta(amount, table);
      },
      positions: function (cols, table) {
        return detect$2(table).positions(cols, table);
      },
      edge: function (cell) {
        return detect$2(cell).edge(cell);
      }
    };

    var units = {
      unsupportedLength: [
        'em',
        'ex',
        'cap',
        'ch',
        'ic',
        'rem',
        'lh',
        'rlh',
        'vw',
        'vh',
        'vi',
        'vb',
        'vmin',
        'vmax',
        'cm',
        'mm',
        'Q',
        'in',
        'pc',
        'pt',
        'px'
      ],
      fixed: [
        'px',
        'pt'
      ],
      relative: ['%'],
      empty: ['']
    };
    var pattern = function () {
      var decimalDigits = '[0-9]+';
      var signedInteger = '[+-]?' + decimalDigits;
      var exponentPart = '[eE]' + signedInteger;
      var dot = '\\.';
      var opt = function (input) {
        return '(?:' + input + ')?';
      };
      var unsignedDecimalLiteral = [
        'Infinity',
        decimalDigits + dot + opt(decimalDigits) + opt(exponentPart),
        dot + decimalDigits + opt(exponentPart),
        decimalDigits + opt(exponentPart)
      ].join('|');
      var float = '[+-]?(?:' + unsignedDecimalLiteral + ')';
      return new RegExp('^(' + float + ')(.*)$');
    }();
    var isUnit = function (unit, accepted) {
      return exists(accepted, function (acc) {
        return exists(units[acc], function (check) {
          return unit === check;
        });
      });
    };
    var parse = function (input, accepted) {
      var match = Optional.from(pattern.exec(input));
      return match.bind(function (array) {
        var value = Number(array[1]);
        var unitRaw = array[2];
        if (isUnit(unitRaw, accepted)) {
          return Optional.some({
            value: value,
            unit: unitRaw
          });
        } else {
          return Optional.none();
        }
      });
    };

    var rPercentageBasedSizeRegex = /(\d+(\.\d+)?)%/;
    var rPixelBasedSizeRegex = /(\d+(\.\d+)?)px|em/;
    var isCol$2 = isTag('col');
    var getPercentSize = function (elm, outerGetter, innerGetter) {
      var relativeParent = parentElement(elm).getOrThunk(function () {
        return getBody$1(owner(elm));
      });
      return outerGetter(elm) / innerGetter(relativeParent) * 100;
    };
    var setPixelWidth = function (cell, amount) {
      set$1(cell, 'width', amount + 'px');
    };
    var setPercentageWidth = function (cell, amount) {
      set$1(cell, 'width', amount + '%');
    };
    var setHeight = function (cell, amount) {
      set$1(cell, 'height', amount + 'px');
    };
    var getHeightValue = function (cell) {
      return getRuntime(cell) + 'px';
    };
    var convert = function (cell, number, getter, setter) {
      var newSize = table(cell).map(function (table) {
        var total = getter(table);
        return Math.floor(number / 100 * total);
      }).getOr(number);
      setter(cell, newSize);
      return newSize;
    };
    var normalizePixelSize = function (value, cell, getter, setter) {
      var number = parseFloat(value);
      return endsWith(value, '%') && name(cell) !== 'table' ? convert(cell, number, getter, setter) : number;
    };
    var getTotalHeight = function (cell) {
      var value = getHeightValue(cell);
      if (!value) {
        return get$7(cell);
      }
      return normalizePixelSize(value, cell, get$7, setHeight);
    };
    var get$6 = function (cell, type, f) {
      var v = f(cell);
      var span = getSpan(cell, type);
      return v / span;
    };
    var getRaw$1 = function (element, prop) {
      return getRaw$2(element, prop).orThunk(function () {
        return getOpt(element, prop).map(function (val) {
          return val + 'px';
        });
      });
    };
    var getRawWidth$1 = function (element) {
      return getRaw$1(element, 'width');
    };
    var getRawHeight = function (element) {
      return getRaw$1(element, 'height');
    };
    var getPercentageWidth = function (cell) {
      return getPercentSize(cell, get$8, getInner);
    };
    var getPixelWidth$1 = function (cell) {
      return isCol$2(cell) ? get$8(cell) : getRuntime$1(cell);
    };
    var getHeight = function (cell) {
      return get$6(cell, 'rowspan', getTotalHeight);
    };
    var getGenericWidth = function (cell) {
      var width = getRawWidth$1(cell);
      return width.bind(function (w) {
        return parse(w, [
          'fixed',
          'relative',
          'empty'
        ]);
      });
    };
    var setGenericWidth = function (cell, amount, unit) {
      set$1(cell, 'width', amount + unit);
    };
    var getPixelTableWidth = function (table) {
      return get$8(table) + 'px';
    };
    var getPercentTableWidth = function (table) {
      return getPercentSize(table, get$8, getInner) + '%';
    };
    var isPercentSizing$1 = function (table) {
      return getRawWidth$1(table).exists(function (size) {
        return rPercentageBasedSizeRegex.test(size);
      });
    };
    var isPixelSizing$1 = function (table) {
      return getRawWidth$1(table).exists(function (size) {
        return rPixelBasedSizeRegex.test(size);
      });
    };
    var isNoneSizing$1 = function (table) {
      return getRawWidth$1(table).isNone();
    };
    var percentageBasedSizeRegex = constant(rPercentageBasedSizeRegex);

    var isCol$1 = isTag('col');
    var getRawW = function (cell) {
      return getRawWidth$1(cell).getOrThunk(function () {
        return getPixelWidth$1(cell) + 'px';
      });
    };
    var getRawH = function (cell) {
      return getRawHeight(cell).getOrThunk(function () {
        return getHeight(cell) + 'px';
      });
    };
    var justCols = function (warehouse) {
      return map$1(Warehouse.justColumns(warehouse), function (column) {
        return Optional.from(column.element);
      });
    };
    var isValidColumn = function (cell) {
      var browser = detect$3().browser;
      var supportsColWidths = browser.isChrome() || browser.isFirefox();
      return isCol$1(cell) ? supportsColWidths : true;
    };
    var getDimension = function (cellOpt, index, backups, filter, getter, fallback) {
      return cellOpt.filter(filter).fold(function () {
        return fallback(deduce(backups, index));
      }, function (cell) {
        return getter(cell);
      });
    };
    var getWidthFrom = function (warehouse, table, getWidth, fallback) {
      var columnCells = columns(warehouse);
      var columns$1 = Warehouse.hasColumns(warehouse) ? justCols(warehouse) : columnCells;
      var backups = [Optional.some(width.edge(table))].concat(map$1(width.positions(columnCells, table), function (pos) {
        return pos.map(function (p) {
          return p.x;
        });
      }));
      var colFilter = not(hasColspan);
      return map$1(columns$1, function (cellOption, c) {
        return getDimension(cellOption, c, backups, colFilter, function (column) {
          if (isValidColumn(column)) {
            return getWidth(column);
          } else {
            var cell = bindFrom(columnCells[c], identity);
            return getDimension(cell, c, backups, colFilter, function (cell) {
              return fallback(Optional.some(get$8(cell)));
            }, fallback);
          }
        }, fallback);
      });
    };
    var getDeduced = function (deduced) {
      return deduced.map(function (d) {
        return d + 'px';
      }).getOr('');
    };
    var getRawWidths = function (warehouse, table) {
      return getWidthFrom(warehouse, table, getRawW, getDeduced);
    };
    var getPercentageWidths = function (warehouse, table, tableSize) {
      return getWidthFrom(warehouse, table, getPercentageWidth, function (deduced) {
        return deduced.fold(function () {
          return tableSize.minCellWidth();
        }, function (cellWidth) {
          return cellWidth / tableSize.pixelWidth() * 100;
        });
      });
    };
    var getPixelWidths = function (warehouse, table, tableSize) {
      return getWidthFrom(warehouse, table, getPixelWidth$1, function (deduced) {
        return deduced.getOrThunk(tableSize.minCellWidth);
      });
    };
    var getHeightFrom = function (warehouse, table, direction, getHeight, fallback) {
      var rows$1 = rows(warehouse);
      var backups = [Optional.some(direction.edge(table))].concat(map$1(direction.positions(rows$1, table), function (pos) {
        return pos.map(function (p) {
          return p.y;
        });
      }));
      return map$1(rows$1, function (cellOption, c) {
        return getDimension(cellOption, c, backups, not(hasRowspan), getHeight, fallback);
      });
    };
    var getPixelHeights = function (warehouse, table, direction) {
      return getHeightFrom(warehouse, table, direction, getHeight, function (deduced) {
        return deduced.getOrThunk(minHeight);
      });
    };
    var getRawHeights = function (warehouse, table, direction) {
      return getHeightFrom(warehouse, table, direction, getRawH, getDeduced);
    };

    var widthLookup = function (table, getter) {
      return function () {
        if (inBody(table)) {
          return getter(table);
        } else {
          return parseFloat(getRaw$2(table, 'width').getOr('0'));
        }
      };
    };
    var noneSize = function (table) {
      var getWidth = widthLookup(table, get$8);
      var zero = constant(0);
      var getWidths = function (warehouse, tableSize) {
        return getPixelWidths(warehouse, table, tableSize);
      };
      return {
        width: getWidth,
        pixelWidth: getWidth,
        getWidths: getWidths,
        getCellDelta: zero,
        singleColumnWidth: constant([0]),
        minCellWidth: zero,
        setElementWidth: noop,
        adjustTableWidth: noop,
        isRelative: true,
        label: 'none'
      };
    };
    var percentageSize = function (table) {
      var getFloatWidth = widthLookup(table, function (elem) {
        return parseFloat(getPercentTableWidth(elem));
      });
      var getWidth = widthLookup(table, get$8);
      var getCellDelta = function (delta) {
        return delta / getWidth() * 100;
      };
      var singleColumnWidth = function (w, _delta) {
        return [100 - w];
      };
      var minCellWidth = function () {
        return minWidth() / getWidth() * 100;
      };
      var adjustTableWidth = function (delta) {
        var currentWidth = getFloatWidth();
        var change = delta / 100 * currentWidth;
        var newWidth = currentWidth + change;
        setPercentageWidth(table, newWidth);
      };
      var getWidths = function (warehouse, tableSize) {
        return getPercentageWidths(warehouse, table, tableSize);
      };
      return {
        width: getFloatWidth,
        pixelWidth: getWidth,
        getWidths: getWidths,
        getCellDelta: getCellDelta,
        singleColumnWidth: singleColumnWidth,
        minCellWidth: minCellWidth,
        setElementWidth: setPercentageWidth,
        adjustTableWidth: adjustTableWidth,
        isRelative: true,
        label: 'percent'
      };
    };
    var pixelSize = function (table) {
      var getWidth = widthLookup(table, get$8);
      var getCellDelta = identity;
      var singleColumnWidth = function (w, delta) {
        var newNext = Math.max(minWidth(), w + delta);
        return [newNext - w];
      };
      var adjustTableWidth = function (delta) {
        var newWidth = getWidth() + delta;
        setPixelWidth(table, newWidth);
      };
      var getWidths = function (warehouse, tableSize) {
        return getPixelWidths(warehouse, table, tableSize);
      };
      return {
        width: getWidth,
        pixelWidth: getWidth,
        getWidths: getWidths,
        getCellDelta: getCellDelta,
        singleColumnWidth: singleColumnWidth,
        minCellWidth: minWidth,
        setElementWidth: setPixelWidth,
        adjustTableWidth: adjustTableWidth,
        isRelative: false,
        label: 'pixel'
      };
    };
    var chooseSize = function (element, width) {
      var percentMatch = percentageBasedSizeRegex().exec(width);
      if (percentMatch !== null) {
        return percentageSize(element);
      } else {
        return pixelSize(element);
      }
    };
    var getTableSize = function (table) {
      var width = getRawWidth$1(table);
      return width.fold(function () {
        return noneSize(table);
      }, function (w) {
        return chooseSize(table, w);
      });
    };
    var TableSize = {
      getTableSize: getTableSize,
      pixelSize: pixelSize,
      percentageSize: percentageSize,
      noneSize: noneSize
    };

    var statsStruct = function (minRow, minCol, maxRow, maxCol, allCells, selectedCells) {
      return {
        minRow: minRow,
        minCol: minCol,
        maxRow: maxRow,
        maxCol: maxCol,
        allCells: allCells,
        selectedCells: selectedCells
      };
    };
    var findSelectedStats = function (house, isSelected) {
      var totalColumns = house.grid.columns;
      var totalRows = house.grid.rows;
      var minRow = totalRows;
      var minCol = totalColumns;
      var maxRow = 0;
      var maxCol = 0;
      var allCells = [];
      var selectedCells = [];
      each$1(house.access, function (detail) {
        allCells.push(detail);
        if (isSelected(detail)) {
          selectedCells.push(detail);
          var startRow = detail.row;
          var endRow = startRow + detail.rowspan - 1;
          var startCol = detail.column;
          var endCol = startCol + detail.colspan - 1;
          if (startRow < minRow) {
            minRow = startRow;
          } else if (endRow > maxRow) {
            maxRow = endRow;
          }
          if (startCol < minCol) {
            minCol = startCol;
          } else if (endCol > maxCol) {
            maxCol = endCol;
          }
        }
      });
      return statsStruct(minRow, minCol, maxRow, maxCol, allCells, selectedCells);
    };
    var makeCell = function (list, seenSelected, rowIndex) {
      var row = list[rowIndex].element;
      var td = SugarElement.fromTag('td');
      append$1(td, SugarElement.fromTag('br'));
      var f = seenSelected ? append$1 : prepend;
      f(row, td);
    };
    var fillInGaps = function (list, house, stats, isSelected) {
      var totalColumns = house.grid.columns;
      var totalRows = house.grid.rows;
      for (var i = 0; i < totalRows; i++) {
        var seenSelected = false;
        for (var j = 0; j < totalColumns; j++) {
          if (!(i < stats.minRow || i > stats.maxRow || j < stats.minCol || j > stats.maxCol)) {
            var needCell = Warehouse.getAt(house, i, j).filter(isSelected).isNone();
            if (needCell) {
              makeCell(list, seenSelected, i);
            } else {
              seenSelected = true;
            }
          }
        }
      }
    };
    var clean = function (replica, stats, house, widthDelta) {
      each$1(house.columns, function (col) {
        if (col.column < stats.minCol || col.column > stats.maxCol) {
          remove$5(col.element);
        }
      });
      var emptyRows = filter$2(firstLayer(replica, 'tr'), function (row) {
        return row.dom.childElementCount === 0;
      });
      each$2(emptyRows, remove$5);
      if (stats.minCol === stats.maxCol || stats.minRow === stats.maxRow) {
        each$2(firstLayer(replica, 'th,td'), function (cell) {
          remove$7(cell, 'rowspan');
          remove$7(cell, 'colspan');
        });
      }
      remove$7(replica, LOCKED_COL_ATTR);
      remove$7(replica, 'data-snooker-col-series');
      var tableSize = TableSize.getTableSize(replica);
      tableSize.adjustTableWidth(widthDelta);
    };
    var getTableWidthDelta = function (table, warehouse, tableSize, stats) {
      if (stats.minCol === 0 && warehouse.grid.columns === stats.maxCol + 1) {
        return 0;
      }
      var colWidths = getPixelWidths(warehouse, table, tableSize);
      var allColsWidth = foldl(colWidths, function (acc, width) {
        return acc + width;
      }, 0);
      var selectedColsWidth = foldl(colWidths.slice(stats.minCol, stats.maxCol + 1), function (acc, width) {
        return acc + width;
      }, 0);
      var newWidth = selectedColsWidth / allColsWidth * tableSize.pixelWidth();
      var delta = newWidth - tableSize.pixelWidth();
      return tableSize.getCellDelta(delta);
    };
    var extract$1 = function (table, selectedSelector) {
      var isSelected = function (detail) {
        return is$2(detail.element, selectedSelector);
      };
      var replica = deep(table);
      var list = fromTable$1(replica);
      var tableSize = TableSize.getTableSize(table);
      var replicaHouse = Warehouse.generate(list);
      var replicaStats = findSelectedStats(replicaHouse, isSelected);
      var selector = 'th:not(' + selectedSelector + ')' + ',td:not(' + selectedSelector + ')';
      var unselectedCells = filterFirstLayer(replica, 'th,td', function (cell) {
        return is$2(cell, selector);
      });
      each$2(unselectedCells, remove$5);
      fillInGaps(list, replicaHouse, replicaStats, isSelected);
      var house = Warehouse.fromTable(table);
      var widthDelta = getTableWidthDelta(table, house, tableSize, replicaStats);
      clean(replica, replicaStats, replicaHouse, widthDelta);
      return replica;
    };

    var nbsp = '\xA0';

    var getEnd = function (element) {
      return name(element) === 'img' ? 1 : getOption(element).fold(function () {
        return children$3(element).length;
      }, function (v) {
        return v.length;
      });
    };
    var isTextNodeWithCursorPosition = function (el) {
      return getOption(el).filter(function (text) {
        return text.trim().length !== 0 || text.indexOf(nbsp) > -1;
      }).isSome();
    };
    var elementsWithCursorPosition = [
      'img',
      'br'
    ];
    var isCursorPosition = function (elem) {
      var hasCursorPosition = isTextNodeWithCursorPosition(elem);
      return hasCursorPosition || contains$2(elementsWithCursorPosition, name(elem));
    };

    var first = function (element) {
      return descendant$1(element, isCursorPosition);
    };
    var last$1 = function (element) {
      return descendantRtl(element, isCursorPosition);
    };
    var descendantRtl = function (scope, predicate) {
      var descend = function (element) {
        var children = children$3(element);
        for (var i = children.length - 1; i >= 0; i--) {
          var child = children[i];
          if (predicate(child)) {
            return Optional.some(child);
          }
          var res = descend(child);
          if (res.isSome()) {
            return res;
          }
        }
        return Optional.none();
      };
      return descend(scope);
    };

    var transferableAttributes = {
      scope: [
        'row',
        'col'
      ]
    };
    var createCell = function (doc) {
      return function () {
        var td = SugarElement.fromTag('td', doc.dom);
        append$1(td, SugarElement.fromTag('br', doc.dom));
        return td;
      };
    };
    var createCol = function (doc) {
      return function () {
        return SugarElement.fromTag('col', doc.dom);
      };
    };
    var createColgroup = function (doc) {
      return function () {
        return SugarElement.fromTag('colgroup', doc.dom);
      };
    };
    var createRow$1 = function (doc) {
      return function () {
        return SugarElement.fromTag('tr', doc.dom);
      };
    };
    var replace$1 = function (cell, tag, attrs) {
      var replica = copy$1(cell, tag);
      each$1(attrs, function (v, k) {
        if (v === null) {
          remove$7(replica, k);
        } else {
          set$2(replica, k, v);
        }
      });
      return replica;
    };
    var pasteReplace = function (cell) {
      return cell;
    };
    var cloneFormats = function (oldCell, newCell, formats) {
      var first$1 = first(oldCell);
      return first$1.map(function (firstText) {
        var formatSelector = formats.join(',');
        var parents = ancestors$3(firstText, formatSelector, function (element) {
          return eq$1(element, oldCell);
        });
        return foldr(parents, function (last, parent) {
          var clonedFormat = shallow(parent);
          remove$7(clonedFormat, 'contenteditable');
          append$1(last, clonedFormat);
          return clonedFormat;
        }, newCell);
      }).getOr(newCell);
    };
    var cloneAppropriateAttributes = function (original, clone) {
      each$1(transferableAttributes, function (validAttributes, attributeName) {
        return getOpt(original, attributeName).filter(function (attribute) {
          return contains$2(validAttributes, attribute);
        }).each(function (attribute) {
          return set$2(clone, attributeName, attribute);
        });
      });
    };
    var cellOperations = function (mutate, doc, formatsToClone) {
      var cloneCss = function (prev, clone) {
        copy$2(prev.element, clone);
        remove$6(clone, 'height');
        if (prev.colspan !== 1) {
          remove$6(clone, 'width');
        }
      };
      var newCell = function (prev) {
        var td = SugarElement.fromTag(name(prev.element), doc.dom);
        var formats = formatsToClone.getOr([
          'strong',
          'em',
          'b',
          'i',
          'span',
          'font',
          'h1',
          'h2',
          'h3',
          'h4',
          'h5',
          'h6',
          'p',
          'div'
        ]);
        var lastNode = formats.length > 0 ? cloneFormats(prev.element, td, formats) : td;
        append$1(lastNode, SugarElement.fromTag('br'));
        cloneCss(prev, td);
        cloneAppropriateAttributes(prev.element, td);
        mutate(prev.element, td);
        return td;
      };
      var newCol = function (prev) {
        var col = SugarElement.fromTag(name(prev.element), doc.dom);
        cloneCss(prev, col);
        mutate(prev.element, col);
        return col;
      };
      return {
        col: newCol,
        colgroup: createColgroup(doc),
        row: createRow$1(doc),
        cell: newCell,
        replace: replace$1,
        colGap: createCol(doc),
        gap: createCell(doc)
      };
    };
    var paste$1 = function (doc) {
      return {
        col: createCol(doc),
        colgroup: createColgroup(doc),
        row: createRow$1(doc),
        cell: createCell(doc),
        replace: pasteReplace,
        colGap: createCol(doc),
        gap: createCell(doc)
      };
    };

    var fromHtml = function (html, scope) {
      var doc = scope || document;
      var div = doc.createElement('div');
      div.innerHTML = html;
      return children$3(SugarElement.fromDom(div));
    };
    var fromDom = function (nodes) {
      return map$1(nodes, SugarElement.fromDom);
    };

    var getNodeName = function (elm) {
      return elm.nodeName.toLowerCase();
    };
    var getBody = function (editor) {
      return SugarElement.fromDom(editor.getBody());
    };
    var getPixelWidth = function (elm) {
      return elm.getBoundingClientRect().width;
    };
    var getPixelHeight = function (elm) {
      return elm.getBoundingClientRect().height;
    };
    var getIsRoot = function (editor) {
      return function (element) {
        return eq$1(element, getBody(editor));
      };
    };
    var removePxSuffix = function (size) {
      return size ? size.replace(/px$/, '') : '';
    };
    var addPxSuffix = function (size) {
      return /^\d+(\.\d+)?$/.test(size) ? size + 'px' : size;
    };
    var removeDataStyle = function (table) {
      remove$7(table, 'data-mce-style');
      var removeStyleAttribute = function (element) {
        return remove$7(element, 'data-mce-style');
      };
      each$2(cells$1(table), removeStyleAttribute);
      each$2(columns$1(table), removeStyleAttribute);
      each$2(rows$1(table), removeStyleAttribute);
    };
    var getRawWidth = function (editor, elm) {
      var raw = editor.dom.getStyle(elm, 'width') || editor.dom.getAttrib(elm, 'width');
      return Optional.from(raw).filter(isNotEmpty);
    };
    var isPercentage$1 = function (value) {
      return /^(\d+(\.\d+)?)%$/.test(value);
    };
    var isPixel = function (value) {
      return /^(\d+(\.\d+)?)px$/.test(value);
    };
    var getSelectionStart = function (editor) {
      return SugarElement.fromDom(editor.selection.getStart());
    };
    var getSelectionEnd = function (editor) {
      return SugarElement.fromDom(editor.selection.getEnd());
    };

    var selection = function (selections) {
      return cata$2(selections.get(), constant([]), identity, pure);
    };
    var unmergable = function (selections) {
      var hasSpan = function (elem, type) {
        return getOpt(elem, type).exists(function (span) {
          return parseInt(span, 10) > 1;
        });
      };
      var hasRowOrColSpan = function (elem) {
        return hasSpan(elem, 'rowspan') || hasSpan(elem, 'colspan');
      };
      var candidates = selection(selections);
      return candidates.length > 0 && forall(candidates, hasRowOrColSpan) ? Optional.some(candidates) : Optional.none();
    };
    var mergable = function (table, selections, ephemera) {
      return cata$2(selections.get(), Optional.none, function (cells) {
        if (cells.length <= 1) {
          return Optional.none();
        } else {
          return retrieveBox(table, ephemera.firstSelectedSelector, ephemera.lastSelectedSelector).map(function (bounds) {
            return {
              bounds: bounds,
              cells: cells
            };
          });
        }
      }, Optional.none);
    };

    var strSelected = 'data-mce-selected';
    var strSelectedSelector = 'td[' + strSelected + '],th[' + strSelected + ']';
    var strAttributeSelector = '[' + strSelected + ']';
    var strFirstSelected = 'data-mce-first-selected';
    var strFirstSelectedSelector = 'td[' + strFirstSelected + '],th[' + strFirstSelected + ']';
    var strLastSelected = 'data-mce-last-selected';
    var strLastSelectedSelector = 'td[' + strLastSelected + '],th[' + strLastSelected + ']';
    var attributeSelector = strAttributeSelector;
    var ephemera = {
      selected: strSelected,
      selectedSelector: strSelectedSelector,
      firstSelected: strFirstSelected,
      firstSelectedSelector: strFirstSelectedSelector,
      lastSelected: strLastSelected,
      lastSelectedSelector: strLastSelectedSelector
    };

    var noMenu = function (cell) {
      return {
        element: cell,
        mergable: Optional.none(),
        unmergable: Optional.none(),
        selection: [cell]
      };
    };
    var forMenu = function (selections, table, cell) {
      return {
        element: cell,
        mergable: mergable(table, selections, ephemera),
        unmergable: unmergable(selections),
        selection: selection(selections)
      };
    };
    var paste = function (element, clipboard, generators) {
      return {
        element: element,
        clipboard: clipboard,
        generators: generators
      };
    };
    var pasteRows = function (selections, cell, clipboard, generators) {
      return {
        selection: selection(selections),
        clipboard: clipboard,
        generators: generators
      };
    };

    var getSelectionCellFallback = function (element) {
      return table(element).bind(function (table) {
        return retrieve(table, ephemera.firstSelectedSelector);
      }).fold(constant(element), function (cells) {
        return cells[0];
      });
    };
    var getSelectionFromSelector = function (selector) {
      return function (initCell, isRoot) {
        var cellName = name(initCell);
        var cell = cellName === 'col' || cellName === 'colgroup' ? getSelectionCellFallback(initCell) : initCell;
        return closest$1(cell, selector, isRoot);
      };
    };
    var getSelectionCellOrCaption = getSelectionFromSelector('th,td,caption');
    var getSelectionCell = getSelectionFromSelector('th,td');
    var getCellsFromSelection = function (selections) {
      return selection(selections);
    };
    var getRowsFromSelection = function (selected, selector) {
      var cellOpt = getSelectionCell(selected);
      var rowsOpt = cellOpt.bind(function (cell) {
        return table(cell);
      }).map(function (table) {
        return rows$1(table);
      });
      return lift2(cellOpt, rowsOpt, function (cell, rows) {
        return filter$2(rows, function (row) {
          return exists(fromDom(row.dom.cells), function (rowCell) {
            return get$b(rowCell, selector) === '1' || eq$1(rowCell, cell);
          });
        });
      }).getOr([]);
    };

    var extractSelected = function (cells) {
      return table(cells[0]).map(function (table) {
        var replica = extract$1(table, attributeSelector);
        removeDataStyle(replica);
        return [replica];
      });
    };
    var serializeElements = function (editor, elements) {
      return map$1(elements, function (elm) {
        return editor.selection.serializer.serialize(elm.dom, {});
      }).join('');
    };
    var getTextContent = function (elements) {
      return map$1(elements, function (element) {
        return element.dom.innerText;
      }).join('');
    };
    var registerEvents = function (editor, selections, actions) {
      editor.on('BeforeGetContent', function (e) {
        var multiCellContext = function (cells) {
          e.preventDefault();
          extractSelected(cells).each(function (elements) {
            e.content = e.format === 'text' ? getTextContent(elements) : serializeElements(editor, elements);
          });
        };
        if (e.selection === true) {
          cata$2(selections.get(), noop, multiCellContext, noop);
        }
      });
      editor.on('BeforeSetContent', function (e) {
        if (e.selection === true && e.paste === true) {
          var selectedCells = getCellsFromSelection(selections);
          head(selectedCells).each(function (cell) {
            table(cell).each(function (table) {
              var elements = filter$2(fromHtml(e.content), function (content) {
                return name(content) !== 'meta';
              });
              var isTable = isTag('table');
              if (elements.length === 1 && isTable(elements[0])) {
                e.preventDefault();
                var doc = SugarElement.fromDom(editor.getDoc());
                var generators = paste$1(doc);
                var targets = paste(cell, elements[0], generators);
                actions.pasteCells(table, targets).each(function () {
                  editor.focus();
                });
              }
            });
          });
        }
      });
    };

    var adt$7 = Adt.generate([
      { none: [] },
      { only: ['index'] },
      {
        left: [
          'index',
          'next'
        ]
      },
      {
        middle: [
          'prev',
          'index',
          'next'
        ]
      },
      {
        right: [
          'prev',
          'index'
        ]
      }
    ]);
    var ColumnContext = __assign({}, adt$7);

    var neighbours = function (input, index) {
      if (input.length === 0) {
        return ColumnContext.none();
      }
      if (input.length === 1) {
        return ColumnContext.only(0);
      }
      if (index === 0) {
        return ColumnContext.left(0, 1);
      }
      if (index === input.length - 1) {
        return ColumnContext.right(index - 1, index);
      }
      if (index > 0 && index < input.length - 1) {
        return ColumnContext.middle(index - 1, index, index + 1);
      }
      return ColumnContext.none();
    };
    var determine = function (input, column, step, tableSize, resize) {
      var result = input.slice(0);
      var context = neighbours(input, column);
      var onNone = constant(map$1(result, constant(0)));
      var onOnly = function (index) {
        return tableSize.singleColumnWidth(result[index], step);
      };
      var onLeft = function (index, next) {
        return resize.calcLeftEdgeDeltas(result, index, next, step, tableSize.minCellWidth(), tableSize.isRelative);
      };
      var onMiddle = function (prev, index, next) {
        return resize.calcMiddleDeltas(result, prev, index, next, step, tableSize.minCellWidth(), tableSize.isRelative);
      };
      var onRight = function (prev, index) {
        return resize.calcRightEdgeDeltas(result, prev, index, step, tableSize.minCellWidth(), tableSize.isRelative);
      };
      return context.fold(onNone, onOnly, onLeft, onMiddle, onRight);
    };

    var total = function (start, end, measures) {
      var r = 0;
      for (var i = start; i < end; i++) {
        r += measures[i] !== undefined ? measures[i] : 0;
      }
      return r;
    };
    var recalculateWidthForCells = function (warehouse, widths) {
      var all = Warehouse.justCells(warehouse);
      return map$1(all, function (cell) {
        var width = total(cell.column, cell.column + cell.colspan, widths);
        return {
          element: cell.element,
          width: width,
          colspan: cell.colspan
        };
      });
    };
    var recalculateWidthForColumns = function (warehouse, widths) {
      var groups = Warehouse.justColumns(warehouse);
      return map$1(groups, function (column, index) {
        return {
          element: column.element,
          width: widths[index],
          colspan: column.colspan
        };
      });
    };
    var recalculateHeightForCells = function (warehouse, heights) {
      var all = Warehouse.justCells(warehouse);
      return map$1(all, function (cell) {
        var height = total(cell.row, cell.row + cell.rowspan, heights);
        return {
          element: cell.element,
          height: height,
          rowspan: cell.rowspan
        };
      });
    };
    var matchRowHeight = function (warehouse, heights) {
      return map$1(warehouse.all, function (row, i) {
        return {
          element: row.element,
          height: heights[i]
        };
      });
    };

    var sumUp = function (newSize) {
      return foldr(newSize, function (b, a) {
        return b + a;
      }, 0);
    };
    var recalculate = function (warehouse, widths) {
      if (Warehouse.hasColumns(warehouse)) {
        return recalculateWidthForColumns(warehouse, widths);
      } else {
        return recalculateWidthForCells(warehouse, widths);
      }
    };
    var recalculateAndApply = function (warehouse, widths, tableSize) {
      var newSizes = recalculate(warehouse, widths);
      each$2(newSizes, function (cell) {
        tableSize.setElementWidth(cell.element, cell.width);
      });
    };
    var adjustWidth = function (table, delta, index, resizing, tableSize) {
      var warehouse = Warehouse.fromTable(table);
      var step = tableSize.getCellDelta(delta);
      var widths = tableSize.getWidths(warehouse, tableSize);
      var isLastColumn = index === warehouse.grid.columns - 1;
      var clampedStep = resizing.clampTableDelta(widths, index, step, tableSize.minCellWidth(), isLastColumn);
      var deltas = determine(widths, index, clampedStep, tableSize, resizing);
      var newWidths = map$1(deltas, function (dx, i) {
        return dx + widths[i];
      });
      recalculateAndApply(warehouse, newWidths, tableSize);
      resizing.resizeTable(tableSize.adjustTableWidth, clampedStep, isLastColumn);
    };
    var adjustHeight = function (table, delta, index, direction) {
      var warehouse = Warehouse.fromTable(table);
      var heights = getPixelHeights(warehouse, table, direction);
      var newHeights = map$1(heights, function (dy, i) {
        return index === i ? Math.max(delta + dy, minHeight()) : dy;
      });
      var newCellSizes = recalculateHeightForCells(warehouse, newHeights);
      var newRowSizes = matchRowHeight(warehouse, newHeights);
      each$2(newRowSizes, function (row) {
        setHeight(row.element, row.height);
      });
      each$2(newCellSizes, function (cell) {
        setHeight(cell.element, cell.height);
      });
      var total = sumUp(newHeights);
      setHeight(table, total);
    };
    var adjustAndRedistributeWidths$1 = function (_table, list, details, tableSize, resizeBehaviour) {
      var warehouse = Warehouse.generate(list);
      var sizes = tableSize.getWidths(warehouse, tableSize);
      var tablePixelWidth = tableSize.pixelWidth();
      var _a = resizeBehaviour.calcRedestributedWidths(sizes, tablePixelWidth, details.pixelDelta, tableSize.isRelative), newSizes = _a.newSizes, delta = _a.delta;
      recalculateAndApply(warehouse, newSizes, tableSize);
      tableSize.adjustTableWidth(delta);
    };
    var adjustWidthTo = function (_table, list, _info, tableSize) {
      var warehouse = Warehouse.generate(list);
      var widths = tableSize.getWidths(warehouse, tableSize);
      recalculateAndApply(warehouse, widths, tableSize);
    };

    var zero = function (array) {
      return map$1(array, constant(0));
    };
    var surround = function (sizes, startIndex, endIndex, results, f) {
      return f(sizes.slice(0, startIndex)).concat(results).concat(f(sizes.slice(endIndex)));
    };
    var clampDeltaHelper = function (predicate) {
      return function (sizes, index, delta, minCellSize) {
        if (!predicate(delta)) {
          return delta;
        } else {
          var newSize = Math.max(minCellSize, sizes[index] - Math.abs(delta));
          var diff = Math.abs(newSize - sizes[index]);
          return delta >= 0 ? diff : -diff;
        }
      };
    };
    var clampNegativeDelta = clampDeltaHelper(function (delta) {
      return delta < 0;
    });
    var clampDelta = clampDeltaHelper(always);
    var resizeTable = function () {
      var calcFixedDeltas = function (sizes, index, next, delta, minCellSize) {
        var clampedDelta = clampNegativeDelta(sizes, index, delta, minCellSize);
        return surround(sizes, index, next + 1, [
          clampedDelta,
          0
        ], zero);
      };
      var calcRelativeDeltas = function (sizes, index, delta, minCellSize) {
        var ratio = (100 + delta) / 100;
        var newThis = Math.max(minCellSize, (sizes[index] + delta) / ratio);
        return map$1(sizes, function (size, idx) {
          var newSize = idx === index ? newThis : size / ratio;
          return newSize - size;
        });
      };
      var calcLeftEdgeDeltas = function (sizes, index, next, delta, minCellSize, isRelative) {
        if (isRelative) {
          return calcRelativeDeltas(sizes, index, delta, minCellSize);
        } else {
          return calcFixedDeltas(sizes, index, next, delta, minCellSize);
        }
      };
      var calcMiddleDeltas = function (sizes, _prev, index, next, delta, minCellSize, isRelative) {
        return calcLeftEdgeDeltas(sizes, index, next, delta, minCellSize, isRelative);
      };
      var resizeTable = function (resizer, delta) {
        return resizer(delta);
      };
      var calcRightEdgeDeltas = function (sizes, _prev, index, delta, minCellSize, isRelative) {
        if (isRelative) {
          return calcRelativeDeltas(sizes, index, delta, minCellSize);
        } else {
          var clampedDelta = clampNegativeDelta(sizes, index, delta, minCellSize);
          return zero(sizes.slice(0, index)).concat([clampedDelta]);
        }
      };
      var calcRedestributedWidths = function (sizes, totalWidth, pixelDelta, isRelative) {
        if (isRelative) {
          var tableWidth = totalWidth + pixelDelta;
          var ratio_1 = tableWidth / totalWidth;
          var newSizes = map$1(sizes, function (size) {
            return size / ratio_1;
          });
          return {
            delta: ratio_1 * 100 - 100,
            newSizes: newSizes
          };
        } else {
          return {
            delta: pixelDelta,
            newSizes: sizes
          };
        }
      };
      return {
        resizeTable: resizeTable,
        clampTableDelta: clampNegativeDelta,
        calcLeftEdgeDeltas: calcLeftEdgeDeltas,
        calcMiddleDeltas: calcMiddleDeltas,
        calcRightEdgeDeltas: calcRightEdgeDeltas,
        calcRedestributedWidths: calcRedestributedWidths
      };
    };
    var preserveTable = function () {
      var calcLeftEdgeDeltas = function (sizes, index, next, delta, minCellSize) {
        var idx = delta >= 0 ? next : index;
        var clampedDelta = clampDelta(sizes, idx, delta, minCellSize);
        return surround(sizes, index, next + 1, [
          clampedDelta,
          -clampedDelta
        ], zero);
      };
      var calcMiddleDeltas = function (sizes, _prev, index, next, delta, minCellSize) {
        return calcLeftEdgeDeltas(sizes, index, next, delta, minCellSize);
      };
      var resizeTable = function (resizer, delta, isLastColumn) {
        if (isLastColumn) {
          resizer(delta);
        }
      };
      var calcRightEdgeDeltas = function (sizes, _prev, _index, delta, _minCellSize, isRelative) {
        if (isRelative) {
          return zero(sizes);
        } else {
          var diff = delta / sizes.length;
          return map$1(sizes, constant(diff));
        }
      };
      var clampTableDelta = function (sizes, index, delta, minCellSize, isLastColumn) {
        if (isLastColumn) {
          if (delta >= 0) {
            return delta;
          } else {
            var maxDelta = foldl(sizes, function (a, b) {
              return a + b - minCellSize;
            }, 0);
            return Math.max(-maxDelta, delta);
          }
        } else {
          return clampNegativeDelta(sizes, index, delta, minCellSize);
        }
      };
      var calcRedestributedWidths = function (sizes, _totalWidth, _pixelDelta, _isRelative) {
        return {
          delta: 0,
          newSizes: sizes
        };
      };
      return {
        resizeTable: resizeTable,
        clampTableDelta: clampTableDelta,
        calcLeftEdgeDeltas: calcLeftEdgeDeltas,
        calcMiddleDeltas: calcMiddleDeltas,
        calcRightEdgeDeltas: calcRightEdgeDeltas,
        calcRedestributedWidths: calcRedestributedWidths
      };
    };

    var only = function (element, isResizable) {
      var parent = Optional.from(element.dom.documentElement).map(SugarElement.fromDom).getOr(element);
      return {
        parent: constant(parent),
        view: constant(element),
        origin: constant(SugarPosition(0, 0)),
        isResizable: isResizable
      };
    };
    var detached = function (editable, chrome, isResizable) {
      var origin = function () {
        return absolute(chrome);
      };
      return {
        parent: constant(chrome),
        view: constant(editable),
        origin: origin,
        isResizable: isResizable
      };
    };
    var body = function (editable, chrome, isResizable) {
      return {
        parent: constant(chrome),
        view: constant(editable),
        origin: constant(SugarPosition(0, 0)),
        isResizable: isResizable
      };
    };
    var ResizeWire = {
      only: only,
      detached: detached,
      body: body
    };

    var adt$6 = Adt.generate([
      { invalid: ['raw'] },
      { pixels: ['value'] },
      { percent: ['value'] }
    ]);
    var validateFor = function (suffix, type, value) {
      var rawAmount = value.substring(0, value.length - suffix.length);
      var amount = parseFloat(rawAmount);
      return rawAmount === amount.toString() ? type(amount) : adt$6.invalid(value);
    };
    var from = function (value) {
      if (endsWith(value, '%')) {
        return validateFor('%', adt$6.percent, value);
      }
      if (endsWith(value, 'px')) {
        return validateFor('px', adt$6.pixels, value);
      }
      return adt$6.invalid(value);
    };
    var Size = __assign(__assign({}, adt$6), { from: from });

    var redistributeToPercent = function (widths, totalWidth) {
      return map$1(widths, function (w) {
        var colType = Size.from(w);
        return colType.fold(function () {
          return w;
        }, function (px) {
          var ratio = px / totalWidth * 100;
          return ratio + '%';
        }, function (pc) {
          return pc + '%';
        });
      });
    };
    var redistributeToPx = function (widths, totalWidth, newTotalWidth) {
      var scale = newTotalWidth / totalWidth;
      return map$1(widths, function (w) {
        var colType = Size.from(w);
        return colType.fold(function () {
          return w;
        }, function (px) {
          return px * scale + 'px';
        }, function (pc) {
          return pc / 100 * newTotalWidth + 'px';
        });
      });
    };
    var redistributeEmpty = function (newWidthType, columns) {
      var f = newWidthType.fold(function () {
        return constant('');
      }, function (pixels) {
        var num = pixels / columns;
        return constant(num + 'px');
      }, function () {
        var num = 100 / columns;
        return constant(num + '%');
      });
      return range$1(columns, f);
    };
    var redistributeValues = function (newWidthType, widths, totalWidth) {
      return newWidthType.fold(function () {
        return widths;
      }, function (px) {
        return redistributeToPx(widths, totalWidth, px);
      }, function (_pc) {
        return redistributeToPercent(widths, totalWidth);
      });
    };
    var redistribute$1 = function (widths, totalWidth, newWidth) {
      var newType = Size.from(newWidth);
      var floats = forall(widths, function (s) {
        return s === '0px';
      }) ? redistributeEmpty(newType, widths.length) : redistributeValues(newType, widths, totalWidth);
      return normalize(floats);
    };
    var sum = function (values, fallback) {
      if (values.length === 0) {
        return fallback;
      }
      return foldr(values, function (rest, v) {
        return Size.from(v).fold(constant(0), identity, identity) + rest;
      }, 0);
    };
    var roundDown = function (num, unit) {
      var floored = Math.floor(num);
      return {
        value: floored + unit,
        remainder: num - floored
      };
    };
    var add$3 = function (value, amount) {
      return Size.from(value).fold(constant(value), function (px) {
        return px + amount + 'px';
      }, function (pc) {
        return pc + amount + '%';
      });
    };
    var normalize = function (values) {
      if (values.length === 0) {
        return values;
      }
      var scan = foldr(values, function (rest, value) {
        var info = Size.from(value).fold(function () {
          return {
            value: value,
            remainder: 0
          };
        }, function (num) {
          return roundDown(num, 'px');
        }, function (num) {
          return {
            value: num + '%',
            remainder: 0
          };
        });
        return {
          output: [info.value].concat(rest.output),
          remainder: rest.remainder + info.remainder
        };
      }, {
        output: [],
        remainder: 0
      });
      var r = scan.output;
      return r.slice(0, r.length - 1).concat([add$3(r[r.length - 1], Math.round(scan.remainder))]);
    };
    var validate = Size.from;

    var redistributeToW = function (newWidths, cells, unit) {
      each$2(cells, function (cell) {
        var widths = newWidths.slice(cell.column, cell.colspan + cell.column);
        var w = sum(widths, minWidth());
        set$1(cell.element, 'width', w + unit);
      });
    };
    var redistributeToColumns = function (newWidths, columns, unit) {
      each$2(columns, function (column, index) {
        var width = sum([newWidths[index]], minWidth());
        set$1(column.element, 'width', width + unit);
      });
    };
    var redistributeToH = function (newHeights, rows, cells, unit) {
      each$2(cells, function (cell) {
        var heights = newHeights.slice(cell.row, cell.rowspan + cell.row);
        var h = sum(heights, minHeight());
        set$1(cell.element, 'height', h + unit);
      });
      each$2(rows, function (row, i) {
        set$1(row.element, 'height', newHeights[i]);
      });
    };
    var getUnit = function (newSize) {
      return validate(newSize).fold(constant('px'), constant('px'), constant('%'));
    };
    var redistribute = function (table, optWidth, optHeight) {
      var warehouse = Warehouse.fromTable(table);
      var rows = warehouse.all;
      var cells = Warehouse.justCells(warehouse);
      var columns = Warehouse.justColumns(warehouse);
      optWidth.each(function (newWidth) {
        var widthUnit = getUnit(newWidth);
        var totalWidth = get$8(table);
        var oldWidths = getRawWidths(warehouse, table);
        var nuWidths = redistribute$1(oldWidths, totalWidth, newWidth);
        if (Warehouse.hasColumns(warehouse)) {
          redistributeToColumns(nuWidths, columns, widthUnit);
        } else {
          redistributeToW(nuWidths, cells, widthUnit);
        }
        set$1(table, 'width', newWidth);
      });
      optHeight.each(function (newHeight) {
        var hUnit = getUnit(newHeight);
        var totalHeight = get$7(table);
        var oldHeights = getRawHeights(warehouse, table, height);
        var nuHeights = redistribute$1(oldHeights, totalHeight, newHeight);
        redistributeToH(nuHeights, rows, cells, hUnit);
        set$1(table, 'height', newHeight);
      });
    };
    var isPercentSizing = isPercentSizing$1;
    var isPixelSizing = isPixelSizing$1;
    var isNoneSizing = isNoneSizing$1;

    var getGridSize = function (table) {
      var warehouse = Warehouse.fromTable(table);
      return warehouse.grid;
    };

    var Event = function (fields) {
      var handlers = [];
      var bind = function (handler) {
        if (handler === undefined) {
          throw new Error('Event bind error: undefined handler');
        }
        handlers.push(handler);
      };
      var unbind = function (handler) {
        handlers = filter$2(handlers, function (h) {
          return h !== handler;
        });
      };
      var trigger = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        var event = {};
        each$2(fields, function (name, i) {
          event[name] = args[i];
        });
        each$2(handlers, function (handler) {
          handler(event);
        });
      };
      return {
        bind: bind,
        unbind: unbind,
        trigger: trigger
      };
    };

    var create$4 = function (typeDefs) {
      var registry = map(typeDefs, function (event) {
        return {
          bind: event.bind,
          unbind: event.unbind
        };
      });
      var trigger = map(typeDefs, function (event) {
        return event.trigger;
      });
      return {
        registry: registry,
        trigger: trigger
      };
    };

    var last = function (fn, rate) {
      var timer = null;
      var cancel = function () {
        if (!isNull(timer)) {
          clearTimeout(timer);
          timer = null;
        }
      };
      var throttle = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        cancel();
        timer = setTimeout(function () {
          timer = null;
          fn.apply(null, args);
        }, rate);
      };
      return {
        cancel: cancel,
        throttle: throttle
      };
    };

    var sort = function (arr) {
      return arr.slice(0).sort();
    };
    var reqMessage = function (required, keys) {
      throw new Error('All required keys (' + sort(required).join(', ') + ') were not specified. Specified keys were: ' + sort(keys).join(', ') + '.');
    };
    var unsuppMessage = function (unsupported) {
      throw new Error('Unsupported keys for object: ' + sort(unsupported).join(', '));
    };
    var validateStrArr = function (label, array) {
      if (!isArray(array)) {
        throw new Error('The ' + label + ' fields must be an array. Was: ' + array + '.');
      }
      each$2(array, function (a) {
        if (!isString(a)) {
          throw new Error('The value ' + a + ' in the ' + label + ' fields was not a string.');
        }
      });
    };
    var invalidTypeMessage = function (incorrect, type) {
      throw new Error('All values need to be of type: ' + type + '. Keys (' + sort(incorrect).join(', ') + ') were not.');
    };
    var checkDupes = function (everything) {
      var sorted = sort(everything);
      var dupe = find$1(sorted, function (s, i) {
        return i < sorted.length - 1 && s === sorted[i + 1];
      });
      dupe.each(function (d) {
        throw new Error('The field: ' + d + ' occurs more than once in the combined fields: [' + sorted.join(', ') + '].');
      });
    };

    var base = function (handleUnsupported, required) {
      return baseWith(handleUnsupported, required, {
        validate: isFunction,
        label: 'function'
      });
    };
    var baseWith = function (handleUnsupported, required, pred) {
      if (required.length === 0) {
        throw new Error('You must specify at least one required field.');
      }
      validateStrArr('required', required);
      checkDupes(required);
      return function (obj) {
        var keys$1 = keys(obj);
        var allReqd = forall(required, function (req) {
          return contains$2(keys$1, req);
        });
        if (!allReqd) {
          reqMessage(required, keys$1);
        }
        handleUnsupported(required, keys$1);
        var invalidKeys = filter$2(required, function (key) {
          return !pred.validate(obj[key], key);
        });
        if (invalidKeys.length > 0) {
          invalidTypeMessage(invalidKeys, pred.label);
        }
        return obj;
      };
    };
    var handleExact = function (required, keys) {
      var unsupported = filter$2(keys, function (key) {
        return !contains$2(required, key);
      });
      if (unsupported.length > 0) {
        unsuppMessage(unsupported);
      }
    };
    var exactly = function (required) {
      return base(handleExact, required);
    };

    var DragMode = exactly([
      'compare',
      'extract',
      'mutate',
      'sink'
    ]);
    var DragSink = exactly([
      'element',
      'start',
      'stop',
      'destroy'
    ]);
    var DragApi = exactly([
      'forceDrop',
      'drop',
      'move',
      'delayDrop'
    ]);

    var InDrag = function () {
      var previous = Optional.none();
      var reset = function () {
        previous = Optional.none();
      };
      var update = function (mode, nu) {
        var result = previous.map(function (old) {
          return mode.compare(old, nu);
        });
        previous = Optional.some(nu);
        return result;
      };
      var onEvent = function (event, mode) {
        var dataOption = mode.extract(event);
        dataOption.each(function (data) {
          var offset = update(mode, data);
          offset.each(function (d) {
            events.trigger.move(d);
          });
        });
      };
      var events = create$4({ move: Event(['info']) });
      return {
        onEvent: onEvent,
        reset: reset,
        events: events.registry
      };
    };

    var NoDrag = function () {
      var events = create$4({ move: Event(['info']) });
      return {
        onEvent: noop,
        reset: noop,
        events: events.registry
      };
    };

    var Movement = function () {
      var noDragState = NoDrag();
      var inDragState = InDrag();
      var dragState = noDragState;
      var on = function () {
        dragState.reset();
        dragState = inDragState;
      };
      var off = function () {
        dragState.reset();
        dragState = noDragState;
      };
      var onEvent = function (event, mode) {
        dragState.onEvent(event, mode);
      };
      var isOn = function () {
        return dragState === inDragState;
      };
      return {
        on: on,
        off: off,
        isOn: isOn,
        onEvent: onEvent,
        events: inDragState.events
      };
    };

    var setup = function (mutation, mode, settings) {
      var active = false;
      var events = create$4({
        start: Event([]),
        stop: Event([])
      });
      var movement = Movement();
      var drop = function () {
        sink.stop();
        if (movement.isOn()) {
          movement.off();
          events.trigger.stop();
        }
      };
      var throttledDrop = last(drop, 200);
      var go = function (parent) {
        sink.start(parent);
        movement.on();
        events.trigger.start();
      };
      var mousemove = function (event) {
        throttledDrop.cancel();
        movement.onEvent(event, mode);
      };
      movement.events.move.bind(function (event) {
        mode.mutate(mutation, event.info);
      });
      var on = function () {
        active = true;
      };
      var off = function () {
        active = false;
      };
      var runIfActive = function (f) {
        return function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          if (active) {
            f.apply(null, args);
          }
        };
      };
      var sink = mode.sink(DragApi({
        forceDrop: drop,
        drop: runIfActive(drop),
        move: runIfActive(mousemove),
        delayDrop: runIfActive(throttledDrop.throttle)
      }), settings);
      var destroy = function () {
        sink.destroy();
      };
      return {
        element: sink.element,
        go: go,
        on: on,
        off: off,
        destroy: destroy,
        events: events.registry
      };
    };

    var mkEvent = function (target, x, y, stop, prevent, kill, raw) {
      return {
        target: target,
        x: x,
        y: y,
        stop: stop,
        prevent: prevent,
        kill: kill,
        raw: raw
      };
    };
    var fromRawEvent$1 = function (rawEvent) {
      var target = SugarElement.fromDom(getOriginalEventTarget(rawEvent).getOr(rawEvent.target));
      var stop = function () {
        return rawEvent.stopPropagation();
      };
      var prevent = function () {
        return rawEvent.preventDefault();
      };
      var kill = compose(prevent, stop);
      return mkEvent(target, rawEvent.clientX, rawEvent.clientY, stop, prevent, kill, rawEvent);
    };
    var handle$2 = function (filter, handler) {
      return function (rawEvent) {
        if (filter(rawEvent)) {
          handler(fromRawEvent$1(rawEvent));
        }
      };
    };
    var binder = function (element, event, filter, handler, useCapture) {
      var wrapped = handle$2(filter, handler);
      element.dom.addEventListener(event, wrapped, useCapture);
      return { unbind: curry(unbind, element, event, wrapped, useCapture) };
    };
    var bind$1 = function (element, event, filter, handler) {
      return binder(element, event, filter, handler, false);
    };
    var unbind = function (element, event, handler, useCapture) {
      element.dom.removeEventListener(event, handler, useCapture);
    };

    var filter = always;
    var bind = function (element, event, handler) {
      return bind$1(element, event, filter, handler);
    };
    var fromRawEvent = fromRawEvent$1;

    var read = function (element, attr) {
      var value = get$b(element, attr);
      return value === undefined || value === '' ? [] : value.split(' ');
    };
    var add$2 = function (element, attr, id) {
      var old = read(element, attr);
      var nu = old.concat([id]);
      set$2(element, attr, nu.join(' '));
      return true;
    };
    var remove$4 = function (element, attr, id) {
      var nu = filter$2(read(element, attr), function (v) {
        return v !== id;
      });
      if (nu.length > 0) {
        set$2(element, attr, nu.join(' '));
      } else {
        remove$7(element, attr);
      }
      return false;
    };

    var supports = function (element) {
      return element.dom.classList !== undefined;
    };
    var get$5 = function (element) {
      return read(element, 'class');
    };
    var add$1 = function (element, clazz) {
      return add$2(element, 'class', clazz);
    };
    var remove$3 = function (element, clazz) {
      return remove$4(element, 'class', clazz);
    };

    var add = function (element, clazz) {
      if (supports(element)) {
        element.dom.classList.add(clazz);
      } else {
        add$1(element, clazz);
      }
    };
    var cleanClass = function (element) {
      var classList = supports(element) ? element.dom.classList : get$5(element);
      if (classList.length === 0) {
        remove$7(element, 'class');
      }
    };
    var remove$2 = function (element, clazz) {
      if (supports(element)) {
        var classList = element.dom.classList;
        classList.remove(clazz);
      } else {
        remove$3(element, clazz);
      }
      cleanClass(element);
    };
    var has = function (element, clazz) {
      return supports(element) && element.dom.classList.contains(clazz);
    };

    var css = function (namespace) {
      var dashNamespace = namespace.replace(/\./g, '-');
      var resolve = function (str) {
        return dashNamespace + '-' + str;
      };
      return { resolve: resolve };
    };

    var styles$1 = css('ephox-dragster');
    var resolve$1 = styles$1.resolve;

    var Blocker = function (options) {
      var settings = __assign({ layerClass: resolve$1('blocker') }, options);
      var div = SugarElement.fromTag('div');
      set$2(div, 'role', 'presentation');
      setAll(div, {
        position: 'fixed',
        left: '0px',
        top: '0px',
        width: '100%',
        height: '100%'
      });
      add(div, resolve$1('blocker'));
      add(div, settings.layerClass);
      var element = constant(div);
      var destroy = function () {
        remove$5(div);
      };
      return {
        element: element,
        destroy: destroy
      };
    };

    var compare = function (old, nu) {
      return SugarPosition(nu.left - old.left, nu.top - old.top);
    };
    var extract = function (event) {
      return Optional.some(SugarPosition(event.x, event.y));
    };
    var mutate = function (mutation, info) {
      mutation.mutate(info.left, info.top);
    };
    var sink = function (dragApi, settings) {
      var blocker = Blocker(settings);
      var mdown = bind(blocker.element(), 'mousedown', dragApi.forceDrop);
      var mup = bind(blocker.element(), 'mouseup', dragApi.drop);
      var mmove = bind(blocker.element(), 'mousemove', dragApi.move);
      var mout = bind(blocker.element(), 'mouseout', dragApi.delayDrop);
      var destroy = function () {
        blocker.destroy();
        mup.unbind();
        mmove.unbind();
        mout.unbind();
        mdown.unbind();
      };
      var start = function (parent) {
        append$1(parent, blocker.element());
      };
      var stop = function () {
        remove$5(blocker.element());
      };
      return DragSink({
        element: blocker.element,
        start: start,
        stop: stop,
        destroy: destroy
      });
    };
    var MouseDrag = DragMode({
      compare: compare,
      extract: extract,
      sink: sink,
      mutate: mutate
    });

    var transform$1 = function (mutation, settings) {
      if (settings === void 0) {
        settings = {};
      }
      var mode = settings.mode !== undefined ? settings.mode : MouseDrag;
      return setup(mutation, mode, settings);
    };

    var closest = function (target) {
      return closest$1(target, '[contenteditable]');
    };
    var isEditable$1 = function (element, assumeEditable) {
      if (assumeEditable === void 0) {
        assumeEditable = false;
      }
      if (!detect$3().browser.isIE() && inBody(element)) {
        return element.dom.isContentEditable;
      } else {
        return closest(element).fold(constant(assumeEditable), function (editable) {
          return getRaw(editable) === 'true';
        });
      }
    };
    var getRaw = function (element) {
      return element.dom.contentEditable;
    };

    var styles = css('ephox-snooker');
    var resolve = styles.resolve;

    var Mutation = function () {
      var events = create$4({
        drag: Event([
          'xDelta',
          'yDelta'
        ])
      });
      var mutate = function (x, y) {
        events.trigger.drag(x, y);
      };
      return {
        mutate: mutate,
        events: events.registry
      };
    };

    var BarMutation = function () {
      var events = create$4({
        drag: Event([
          'xDelta',
          'yDelta',
          'target'
        ])
      });
      var target = Optional.none();
      var delegate = Mutation();
      delegate.events.drag.bind(function (event) {
        target.each(function (t) {
          events.trigger.drag(event.xDelta, event.yDelta, t);
        });
      });
      var assign = function (t) {
        target = Optional.some(t);
      };
      var get = function () {
        return target;
      };
      return {
        assign: assign,
        get: get,
        mutate: delegate.mutate,
        events: events.registry
      };
    };

    var col = function (column, x, y, w, h) {
      var bar = SugarElement.fromTag('div');
      setAll(bar, {
        position: 'absolute',
        left: x - w / 2 + 'px',
        top: y + 'px',
        height: h + 'px',
        width: w + 'px'
      });
      setAll$1(bar, {
        'data-column': column,
        'role': 'presentation'
      });
      return bar;
    };
    var row = function (r, x, y, w, h) {
      var bar = SugarElement.fromTag('div');
      setAll(bar, {
        position: 'absolute',
        left: x + 'px',
        top: y - h / 2 + 'px',
        height: h + 'px',
        width: w + 'px'
      });
      setAll$1(bar, {
        'data-row': r,
        'role': 'presentation'
      });
      return bar;
    };

    var resizeBar = resolve('resizer-bar');
    var resizeRowBar = resolve('resizer-rows');
    var resizeColBar = resolve('resizer-cols');
    var BAR_THICKNESS = 7;
    var resizableRows = function (warehouse, isResizable) {
      return bind$2(warehouse.all, function (row, i) {
        return isResizable(row.element) ? [i] : [];
      });
    };
    var resizableColumns = function (warehouse, isResizable) {
      var resizableCols = [];
      range$1(warehouse.grid.columns, function (index) {
        var colElmOpt = Warehouse.getColumnAt(warehouse, index).map(function (col) {
          return col.element;
        });
        if (colElmOpt.forall(isResizable)) {
          resizableCols.push(index);
        }
      });
      return filter$2(resizableCols, function (colIndex) {
        var columnCells = Warehouse.filterItems(warehouse, function (cell) {
          return cell.column === colIndex;
        });
        return forall(columnCells, function (cell) {
          return isResizable(cell.element);
        });
      });
    };
    var destroy = function (wire) {
      var previous = descendants(wire.parent(), '.' + resizeBar);
      each$2(previous, remove$5);
    };
    var drawBar = function (wire, positions, create) {
      var origin = wire.origin();
      each$2(positions, function (cpOption) {
        cpOption.each(function (cp) {
          var bar = create(origin, cp);
          add(bar, resizeBar);
          append$1(wire.parent(), bar);
        });
      });
    };
    var refreshCol = function (wire, colPositions, position, tableHeight) {
      drawBar(wire, colPositions, function (origin, cp) {
        var colBar = col(cp.col, cp.x - origin.left, position.top - origin.top, BAR_THICKNESS, tableHeight);
        add(colBar, resizeColBar);
        return colBar;
      });
    };
    var refreshRow = function (wire, rowPositions, position, tableWidth) {
      drawBar(wire, rowPositions, function (origin, cp) {
        var rowBar = row(cp.row, position.left - origin.left, cp.y - origin.top, tableWidth, BAR_THICKNESS);
        add(rowBar, resizeRowBar);
        return rowBar;
      });
    };
    var refreshGrid = function (warhouse, wire, table, rows, cols) {
      var position = absolute(table);
      var isResizable = wire.isResizable;
      var rowPositions = rows.length > 0 ? height.positions(rows, table) : [];
      var resizableRowBars = rowPositions.length > 0 ? resizableRows(warhouse, isResizable) : [];
      var resizableRowPositions = filter$2(rowPositions, function (_pos, i) {
        return exists(resizableRowBars, function (barIndex) {
          return i === barIndex;
        });
      });
      refreshRow(wire, resizableRowPositions, position, getOuter$2(table));
      var colPositions = cols.length > 0 ? width.positions(cols, table) : [];
      var resizableColBars = colPositions.length > 0 ? resizableColumns(warhouse, isResizable) : [];
      var resizableColPositions = filter$2(colPositions, function (_pos, i) {
        return exists(resizableColBars, function (barIndex) {
          return i === barIndex;
        });
      });
      refreshCol(wire, resizableColPositions, position, getOuter$1(table));
    };
    var refresh = function (wire, table) {
      destroy(wire);
      if (wire.isResizable(table)) {
        var warehouse = Warehouse.fromTable(table);
        var rows$1 = rows(warehouse);
        var cols = columns(warehouse);
        refreshGrid(warehouse, wire, table, rows$1, cols);
      }
    };
    var each = function (wire, f) {
      var bars = descendants(wire.parent(), '.' + resizeBar);
      each$2(bars, f);
    };
    var hide = function (wire) {
      each(wire, function (bar) {
        set$1(bar, 'display', 'none');
      });
    };
    var show = function (wire) {
      each(wire, function (bar) {
        set$1(bar, 'display', 'block');
      });
    };
    var isRowBar = function (element) {
      return has(element, resizeRowBar);
    };
    var isColBar = function (element) {
      return has(element, resizeColBar);
    };

    var resizeBarDragging = resolve('resizer-bar-dragging');
    var BarManager = function (wire) {
      var mutation = BarMutation();
      var resizing = transform$1(mutation, {});
      var hoverTable = Optional.none();
      var getResizer = function (element, type) {
        return Optional.from(get$b(element, type));
      };
      mutation.events.drag.bind(function (event) {
        getResizer(event.target, 'data-row').each(function (_dataRow) {
          var currentRow = getCssValue(event.target, 'top');
          set$1(event.target, 'top', currentRow + event.yDelta + 'px');
        });
        getResizer(event.target, 'data-column').each(function (_dataCol) {
          var currentCol = getCssValue(event.target, 'left');
          set$1(event.target, 'left', currentCol + event.xDelta + 'px');
        });
      });
      var getDelta = function (target, dir) {
        var newX = getCssValue(target, dir);
        var oldX = getAttrValue(target, 'data-initial-' + dir, 0);
        return newX - oldX;
      };
      resizing.events.stop.bind(function () {
        mutation.get().each(function (target) {
          hoverTable.each(function (table) {
            getResizer(target, 'data-row').each(function (row) {
              var delta = getDelta(target, 'top');
              remove$7(target, 'data-initial-top');
              events.trigger.adjustHeight(table, delta, parseInt(row, 10));
            });
            getResizer(target, 'data-column').each(function (column) {
              var delta = getDelta(target, 'left');
              remove$7(target, 'data-initial-left');
              events.trigger.adjustWidth(table, delta, parseInt(column, 10));
            });
            refresh(wire, table);
          });
        });
      });
      var handler = function (target, dir) {
        events.trigger.startAdjust();
        mutation.assign(target);
        set$2(target, 'data-initial-' + dir, getCssValue(target, dir));
        add(target, resizeBarDragging);
        set$1(target, 'opacity', '0.2');
        resizing.go(wire.parent());
      };
      var mousedown = bind(wire.parent(), 'mousedown', function (event) {
        if (isRowBar(event.target)) {
          handler(event.target, 'top');
        }
        if (isColBar(event.target)) {
          handler(event.target, 'left');
        }
      });
      var isRoot = function (e) {
        return eq$1(e, wire.view());
      };
      var findClosestEditableTable = function (target) {
        return closest$1(target, 'table', isRoot).filter(isEditable$1);
      };
      var mouseover = bind(wire.view(), 'mouseover', function (event) {
        findClosestEditableTable(event.target).fold(function () {
          if (inBody(event.target)) {
            destroy(wire);
          }
        }, function (table) {
          hoverTable = Optional.some(table);
          refresh(wire, table);
        });
      });
      var destroy$1 = function () {
        mousedown.unbind();
        mouseover.unbind();
        resizing.destroy();
        destroy(wire);
      };
      var refresh$1 = function (tbl) {
        refresh(wire, tbl);
      };
      var events = create$4({
        adjustHeight: Event([
          'table',
          'delta',
          'row'
        ]),
        adjustWidth: Event([
          'table',
          'delta',
          'column'
        ]),
        startAdjust: Event([])
      });
      return {
        destroy: destroy$1,
        refresh: refresh$1,
        on: resizing.on,
        off: resizing.off,
        hideBars: curry(hide, wire),
        showBars: curry(show, wire),
        events: events.registry
      };
    };

    var create$3 = function (wire, resizing, lazySizing) {
      var hdirection = height;
      var vdirection = width;
      var manager = BarManager(wire);
      var events = create$4({
        beforeResize: Event([
          'table',
          'type'
        ]),
        afterResize: Event([
          'table',
          'type'
        ]),
        startDrag: Event([])
      });
      manager.events.adjustHeight.bind(function (event) {
        var table = event.table;
        events.trigger.beforeResize(table, 'row');
        var delta = hdirection.delta(event.delta, table);
        adjustHeight(table, delta, event.row, hdirection);
        events.trigger.afterResize(table, 'row');
      });
      manager.events.startAdjust.bind(function (_event) {
        events.trigger.startDrag();
      });
      manager.events.adjustWidth.bind(function (event) {
        var table = event.table;
        events.trigger.beforeResize(table, 'col');
        var delta = vdirection.delta(event.delta, table);
        var tableSize = lazySizing(table);
        adjustWidth(table, delta, event.column, resizing, tableSize);
        events.trigger.afterResize(table, 'col');
      });
      return {
        on: manager.on,
        off: manager.off,
        hideBars: manager.hideBars,
        showBars: manager.showBars,
        destroy: manager.destroy,
        events: events.registry
      };
    };
    var TableResize = { create: create$3 };

    var fireNewRow = function (editor, row) {
      return editor.fire('newrow', { node: row });
    };
    var fireNewCell = function (editor, cell) {
      return editor.fire('newcell', { node: cell });
    };
    var fireObjectResizeStart = function (editor, target, width, height, origin) {
      editor.fire('ObjectResizeStart', {
        target: target,
        width: width,
        height: height,
        origin: origin
      });
    };
    var fireObjectResized = function (editor, target, width, height, origin) {
      editor.fire('ObjectResized', {
        target: target,
        width: width,
        height: height,
        origin: origin
      });
    };
    var fireTableSelectionChange = function (editor, cells, start, finish, otherCells) {
      editor.fire('TableSelectionChange', {
        cells: cells,
        start: start,
        finish: finish,
        otherCells: otherCells
      });
    };
    var fireTableSelectionClear = function (editor) {
      editor.fire('TableSelectionClear');
    };
    var fireTableModified = function (editor, table, data) {
      editor.fire('TableModified', __assign(__assign({}, data), { table: table }));
    };
    var styleModified = {
      structure: false,
      style: true
    };
    var structureModified = {
      structure: true,
      style: false
    };
    var styleAndStructureModified = {
      structure: true,
      style: true
    };

    var defaultTableToolbar = 'tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol';
    var defaultStyles = {
      'border-collapse': 'collapse',
      'width': '100%'
    };
    var defaultCellBorderWidths = range$1(5, function (i) {
      var size = i + 1 + 'px';
      return {
        title: size,
        value: size
      };
    });
    var defaultCellBorderStyles = map$1([
      'Solid',
      'Dotted',
      'Dashed',
      'Double',
      'Groove',
      'Ridge',
      'Inset',
      'Outset',
      'None',
      'Hidden'
    ], function (type) {
      return {
        title: type,
        value: type.toLowerCase()
      };
    });
    var determineDefaultStyles = function (editor) {
      var _a;
      if (isPixelsForced(editor)) {
        var dom = editor.dom;
        var parentBlock = (_a = dom.getParent(editor.selection.getStart(), dom.isBlock)) !== null && _a !== void 0 ? _a : editor.getBody();
        var contentWidth = getInner(SugarElement.fromDom(parentBlock));
        return __assign(__assign({}, defaultStyles), { width: contentWidth + 'px' });
      } else if (isResponsiveForced(editor)) {
        return filter$1(defaultStyles, function (_value, key) {
          return key !== 'width';
        });
      } else {
        return defaultStyles;
      }
    };
    var defaultAttributes = { border: '1' };
    var defaultColumnResizingBehaviour = 'preservetable';
    var getTableSizingMode = function (editor) {
      return editor.getParam('table_sizing_mode', 'auto');
    };
    var getTableResponseWidth = function (editor) {
      return editor.getParam('table_responsive_width');
    };
    var getTableBorderWidths = function (editor) {
      return editor.getParam('table_border_widths', defaultCellBorderWidths, 'array');
    };
    var getTableBorderStyles = function (editor) {
      return editor.getParam('table_border_styles', defaultCellBorderStyles, 'array');
    };
    var getDefaultAttributes = function (editor) {
      return editor.getParam('table_default_attributes', defaultAttributes, 'object');
    };
    var getDefaultStyles = function (editor) {
      return editor.getParam('table_default_styles', determineDefaultStyles(editor), 'object');
    };
    var hasTableResizeBars = function (editor) {
      return editor.getParam('table_resize_bars', true, 'boolean');
    };
    var hasTabNavigation = function (editor) {
      return editor.getParam('table_tab_navigation', true, 'boolean');
    };
    var hasAdvancedCellTab = function (editor) {
      return editor.getParam('table_cell_advtab', true, 'boolean');
    };
    var hasAdvancedRowTab = function (editor) {
      return editor.getParam('table_row_advtab', true, 'boolean');
    };
    var hasAdvancedTableTab = function (editor) {
      return editor.getParam('table_advtab', true, 'boolean');
    };
    var hasAppearanceOptions = function (editor) {
      return editor.getParam('table_appearance_options', true, 'boolean');
    };
    var hasTableGrid = function (editor) {
      return editor.getParam('table_grid', true, 'boolean');
    };
    var shouldStyleWithCss = function (editor) {
      return editor.getParam('table_style_by_css', false, 'boolean');
    };
    var getCellClassList = function (editor) {
      return editor.getParam('table_cell_class_list', [], 'array');
    };
    var getRowClassList = function (editor) {
      return editor.getParam('table_row_class_list', [], 'array');
    };
    var getTableClassList = function (editor) {
      return editor.getParam('table_class_list', [], 'array');
    };
    var isPercentagesForced = function (editor) {
      return getTableSizingMode(editor) === 'relative' || getTableResponseWidth(editor) === true;
    };
    var isPixelsForced = function (editor) {
      return getTableSizingMode(editor) === 'fixed' || getTableResponseWidth(editor) === false;
    };
    var isResponsiveForced = function (editor) {
      return getTableSizingMode(editor) === 'responsive';
    };
    var getToolbar = function (editor) {
      return editor.getParam('table_toolbar', defaultTableToolbar);
    };
    var useColumnGroup = function (editor) {
      return editor.getParam('table_use_colgroups', false, 'boolean');
    };
    var getTableHeaderType = function (editor) {
      var defaultValue = 'section';
      var value = editor.getParam('table_header_type', defaultValue, 'string');
      var validValues = [
        'section',
        'cells',
        'sectionCells',
        'auto'
      ];
      if (!contains$2(validValues, value)) {
        return defaultValue;
      } else {
        return value;
      }
    };
    var getColumnResizingBehaviour = function (editor) {
      var validModes = [
        'preservetable',
        'resizetable'
      ];
      var givenMode = editor.getParam('table_column_resizing', defaultColumnResizingBehaviour, 'string');
      return find$1(validModes, function (mode) {
        return mode === givenMode;
      }).getOr(defaultColumnResizingBehaviour);
    };
    var isPreserveTableColumnResizing = function (editor) {
      return getColumnResizingBehaviour(editor) === 'preservetable';
    };
    var isResizeTableColumnResizing = function (editor) {
      return getColumnResizingBehaviour(editor) === 'resizetable';
    };
    var getCloneElements = function (editor) {
      var cloneElements = editor.getParam('table_clone_elements');
      if (isString(cloneElements)) {
        return Optional.some(cloneElements.split(/[ ,]/));
      } else if (Array.isArray(cloneElements)) {
        return Optional.some(cloneElements);
      } else {
        return Optional.none();
      }
    };
    var hasObjectResizing = function (editor) {
      var objectResizing = editor.getParam('object_resizing', true);
      return isString(objectResizing) ? objectResizing === 'table' : objectResizing;
    };
    var getTableBackgroundColorMap = function (editor) {
      return editor.getParam('table_background_color_map', [], 'array');
    };
    var getTableBorderColorMap = function (editor) {
      return editor.getParam('table_border_color_map', [], 'array');
    };

    var get$4 = function (editor, table) {
      if (isPercentagesForced(editor)) {
        return TableSize.percentageSize(table);
      } else if (isPixelsForced(editor)) {
        return TableSize.pixelSize(table);
      } else {
        return TableSize.getTableSize(table);
      }
    };

    var cleanupLegacyAttributes = function (element) {
      remove$7(element, 'width');
    };
    var convertToPercentSize = function (table) {
      var newWidth = getPercentTableWidth(table);
      redistribute(table, Optional.some(newWidth), Optional.none());
      cleanupLegacyAttributes(table);
    };
    var convertToPixelSize = function (table) {
      var newWidth = getPixelTableWidth(table);
      redistribute(table, Optional.some(newWidth), Optional.none());
      cleanupLegacyAttributes(table);
    };
    var convertToNoneSize = function (table) {
      remove$6(table, 'width');
      var columns = columns$1(table);
      var rowElements = columns.length > 0 ? columns : cells$1(table);
      each$2(rowElements, function (cell) {
        remove$6(cell, 'width');
        cleanupLegacyAttributes(cell);
      });
      cleanupLegacyAttributes(table);
    };

    var enforcePercentage = convertToPercentSize;
    var enforcePixels = convertToPixelSize;
    var enforceNone = convertToNoneSize;
    var syncPixels = function (table) {
      var warehouse = Warehouse.fromTable(table);
      if (!Warehouse.hasColumns(warehouse)) {
        each$2(cells$1(table), function (cell) {
          var computedWidth = get$a(cell, 'width');
          set$1(cell, 'width', computedWidth);
          remove$7(cell, 'width');
        });
      }
    };

    var createContainer = function () {
      var container = SugarElement.fromTag('div');
      setAll(container, {
        position: 'static',
        height: '0',
        width: '0',
        padding: '0',
        margin: '0',
        border: '0'
      });
      append$1(body$1(), container);
      return container;
    };
    var get$3 = function (editor, isResizable) {
      return editor.inline ? ResizeWire.body(getBody(editor), createContainer(), isResizable) : ResizeWire.only(SugarElement.fromDom(editor.getDoc()), isResizable);
    };
    var remove$1 = function (editor, wire) {
      if (editor.inline) {
        remove$5(wire.parent());
      }
    };

    var barResizerPrefix = 'bar-';
    var isResizable = function (elm) {
      return get$b(elm, 'data-mce-resize') !== 'false';
    };
    var getResizeHandler = function (editor) {
      var selectionRng = Optional.none();
      var resize = Optional.none();
      var wire = Optional.none();
      var startW;
      var startRawW;
      var isTable = function (elm) {
        return elm.nodeName === 'TABLE';
      };
      var lazyResize = function () {
        return resize;
      };
      var lazyWire = function () {
        return wire.getOr(ResizeWire.only(SugarElement.fromDom(editor.getBody()), isResizable));
      };
      var lazySizing = function (table) {
        return get$4(editor, table);
      };
      var lazyResizingBehaviour = function () {
        return isPreserveTableColumnResizing(editor) ? preserveTable() : resizeTable();
      };
      var getNumColumns = function (table) {
        return getGridSize(table).columns;
      };
      var afterCornerResize = function (table, origin, width) {
        var isRightEdgeResize = endsWith(origin, 'e');
        if (startRawW === '') {
          enforcePercentage(table);
        }
        if (width !== startW && startRawW !== '') {
          set$1(table, 'width', startRawW);
          var resizing = lazyResizingBehaviour();
          var tableSize = lazySizing(table);
          var col = isPreserveTableColumnResizing(editor) || isRightEdgeResize ? getNumColumns(table) - 1 : 0;
          adjustWidth(table, width - startW, col, resizing, tableSize);
        } else if (isPercentage$1(startRawW)) {
          var percentW = parseFloat(startRawW.replace('%', ''));
          var targetPercentW = width * percentW / startW;
          set$1(table, 'width', targetPercentW + '%');
        }
        if (isPixel(startRawW)) {
          syncPixels(table);
        }
      };
      var destroy = function () {
        resize.each(function (sz) {
          sz.destroy();
        });
        wire.each(function (w) {
          remove$1(editor, w);
        });
      };
      editor.on('init', function () {
        var rawWire = get$3(editor, isResizable);
        wire = Optional.some(rawWire);
        if (hasObjectResizing(editor) && hasTableResizeBars(editor)) {
          var resizing = lazyResizingBehaviour();
          var sz = TableResize.create(rawWire, resizing, lazySizing);
          sz.on();
          sz.events.startDrag.bind(function (_event) {
            selectionRng = Optional.some(editor.selection.getRng());
          });
          sz.events.beforeResize.bind(function (event) {
            var rawTable = event.table.dom;
            fireObjectResizeStart(editor, rawTable, getPixelWidth(rawTable), getPixelHeight(rawTable), barResizerPrefix + event.type);
          });
          sz.events.afterResize.bind(function (event) {
            var table = event.table;
            var rawTable = table.dom;
            removeDataStyle(table);
            selectionRng.each(function (rng) {
              editor.selection.setRng(rng);
              editor.focus();
            });
            fireObjectResized(editor, rawTable, getPixelWidth(rawTable), getPixelHeight(rawTable), barResizerPrefix + event.type);
            editor.undoManager.add();
          });
          resize = Optional.some(sz);
        }
      });
      editor.on('ObjectResizeStart', function (e) {
        var targetElm = e.target;
        if (isTable(targetElm)) {
          var table = SugarElement.fromDom(targetElm);
          each$2(editor.dom.select('.mce-clonedresizable'), function (clone) {
            editor.dom.addClass(clone, 'mce-' + getColumnResizingBehaviour(editor) + '-columns');
          });
          if (!isPixelSizing(table) && isPixelsForced(editor)) {
            enforcePixels(table);
          } else if (!isPercentSizing(table) && isPercentagesForced(editor)) {
            enforcePercentage(table);
          }
          if (isNoneSizing(table) && startsWith(e.origin, barResizerPrefix)) {
            enforcePercentage(table);
          }
          startW = e.width;
          startRawW = isResponsiveForced(editor) ? '' : getRawWidth(editor, targetElm).getOr('');
        }
      });
      editor.on('ObjectResized', function (e) {
        var targetElm = e.target;
        if (isTable(targetElm)) {
          var table = SugarElement.fromDom(targetElm);
          var origin_1 = e.origin;
          if (startsWith(origin_1, 'corner-')) {
            afterCornerResize(table, origin_1, e.width);
          }
          removeDataStyle(table);
          fireTableModified(editor, table.dom, styleModified);
        }
      });
      editor.on('SwitchMode', function () {
        lazyResize().each(function (resize) {
          if (editor.mode.isReadOnly()) {
            resize.hideBars();
          } else {
            resize.showBars();
          }
        });
      });
      return {
        lazyResize: lazyResize,
        lazyWire: lazyWire,
        destroy: destroy
      };
    };

    var point = function (element, offset) {
      return {
        element: element,
        offset: offset
      };
    };

    var scan$1 = function (universe, element, direction) {
      if (universe.property().isText(element) && universe.property().getText(element).trim().length === 0 || universe.property().isComment(element)) {
        return direction(element).bind(function (elem) {
          return scan$1(universe, elem, direction).orThunk(function () {
            return Optional.some(elem);
          });
        });
      } else {
        return Optional.none();
      }
    };
    var toEnd = function (universe, element) {
      if (universe.property().isText(element)) {
        return universe.property().getText(element).length;
      }
      var children = universe.property().children(element);
      return children.length;
    };
    var freefallRtl$2 = function (universe, element) {
      var candidate = scan$1(universe, element, universe.query().prevSibling).getOr(element);
      if (universe.property().isText(candidate)) {
        return point(candidate, toEnd(universe, candidate));
      }
      var children = universe.property().children(candidate);
      return children.length > 0 ? freefallRtl$2(universe, children[children.length - 1]) : point(candidate, toEnd(universe, candidate));
    };

    var freefallRtl$1 = freefallRtl$2;

    var universe$2 = DomUniverse();
    var freefallRtl = function (element) {
      return freefallRtl$1(universe$2, element);
    };

    var halve = function (main, other) {
      var colspan = getSpan(main, 'colspan');
      if (colspan === 1) {
        var width = getGenericWidth(main);
        width.each(function (w) {
          var newWidth = w.value / 2;
          setGenericWidth(main, newWidth, w.unit);
          setGenericWidth(other, newWidth, w.unit);
        });
      }
    };

    var isHeaderCell = isTag('th');
    var isHeaderCells = function (cells) {
      return forall(cells, function (cell) {
        return isHeaderCell(cell.element);
      });
    };
    var getRowHeaderType = function (isHeaderRow, isHeaderCells) {
      if (isHeaderRow && isHeaderCells) {
        return 'sectionCells';
      } else if (isHeaderRow) {
        return 'section';
      } else {
        return 'cells';
      }
    };
    var getRowType$1 = function (row) {
      var isHeaderRow = row.section === 'thead';
      var isHeaderCells = is(findCommonCellType(row.cells), 'th');
      if (isHeaderRow || isHeaderCells) {
        return {
          type: 'header',
          subType: getRowHeaderType(isHeaderRow, isHeaderCells)
        };
      } else if (row.section === 'tfoot') {
        return { type: 'footer' };
      } else {
        return { type: 'body' };
      }
    };
    var findCommonCellType = function (cells) {
      var headerCells = filter$2(cells, function (cell) {
        return isHeaderCell(cell.element);
      });
      if (headerCells.length === 0) {
        return Optional.some('td');
      } else if (headerCells.length === cells.length) {
        return Optional.some('th');
      } else {
        return Optional.none();
      }
    };
    var findCommonRowType = function (rows) {
      var rowTypes = map$1(rows, function (row) {
        return getRowType$1(row).type;
      });
      var hasHeader = contains$2(rowTypes, 'header');
      var hasFooter = contains$2(rowTypes, 'footer');
      if (!hasHeader && !hasFooter) {
        return Optional.some('body');
      } else {
        var hasBody = contains$2(rowTypes, 'body');
        if (hasHeader && !hasBody && !hasFooter) {
          return Optional.some('header');
        } else if (!hasHeader && !hasBody && hasFooter) {
          return Optional.some('footer');
        } else {
          return Optional.none();
        }
      }
    };
    var findTableRowHeaderType = function (warehouse) {
      return findMap(warehouse.all, function (row) {
        var rowType = getRowType$1(row);
        return rowType.type === 'header' ? Optional.from(rowType.subType) : Optional.none();
      });
    };

    var transformCell = function (cell, comparator, substitution) {
      return elementnew(substitution(cell.element, comparator), true, cell.isLocked);
    };
    var transformRow = function (row, section) {
      return row.section !== section ? rowcells(row.element, row.cells, section, row.isNew) : row;
    };
    var section = function () {
      return {
        transformRow: transformRow,
        transformCell: function (cell, comparator, substitution) {
          var newCell = substitution(cell.element, comparator);
          var fixedCell = name(newCell) !== 'td' ? mutate$1(newCell, 'td') : newCell;
          return elementnew(fixedCell, cell.isNew, cell.isLocked);
        }
      };
    };
    var sectionCells = function () {
      return {
        transformRow: transformRow,
        transformCell: transformCell
      };
    };
    var cells = function () {
      return {
        transformRow: function (row, section) {
          var newSection = section === 'thead' ? 'tbody' : section;
          return transformRow(row, newSection);
        },
        transformCell: transformCell
      };
    };
    var fallback = function () {
      return {
        transformRow: identity,
        transformCell: transformCell
      };
    };
    var getTableSectionType = function (table, fallback) {
      var warehouse = Warehouse.fromTable(table);
      var type = findTableRowHeaderType(warehouse).getOr(fallback);
      switch (type) {
      case 'section':
        return section();
      case 'sectionCells':
        return sectionCells();
      case 'cells':
        return cells();
      }
    };
    var TableSection = {
      getTableSectionType: getTableSectionType,
      section: section,
      sectionCells: sectionCells,
      cells: cells,
      fallback: fallback
    };

    var setIfNot = function (element, property, value, ignore) {
      if (value === ignore) {
        remove$7(element, property);
      } else {
        set$2(element, property, value);
      }
    };
    var insert$1 = function (table, selector, element) {
      last$2(children$1(table, selector)).fold(function () {
        return prepend(table, element);
      }, function (child) {
        return after$5(child, element);
      });
    };
    var generateSection = function (table, sectionName) {
      var section = child$1(table, sectionName).getOrThunk(function () {
        var newSection = SugarElement.fromTag(sectionName, owner(table).dom);
        if (sectionName === 'thead') {
          insert$1(table, 'caption,colgroup', newSection);
        } else if (sectionName === 'colgroup') {
          insert$1(table, 'caption', newSection);
        } else {
          append$1(table, newSection);
        }
        return newSection;
      });
      empty(section);
      return section;
    };
    var render$1 = function (table, grid) {
      var newRows = [];
      var newCells = [];
      var syncRows = function (gridSection) {
        return map$1(gridSection, function (row) {
          if (row.isNew) {
            newRows.push(row.element);
          }
          var tr = row.element;
          empty(tr);
          each$2(row.cells, function (cell) {
            if (cell.isNew) {
              newCells.push(cell.element);
            }
            setIfNot(cell.element, 'colspan', cell.colspan, 1);
            setIfNot(cell.element, 'rowspan', cell.rowspan, 1);
            append$1(tr, cell.element);
          });
          return tr;
        });
      };
      var syncColGroup = function (gridSection) {
        return bind$2(gridSection, function (colGroup) {
          return map$1(colGroup.cells, function (col) {
            setIfNot(col.element, 'span', col.colspan, 1);
            return col.element;
          });
        });
      };
      var renderSection = function (gridSection, sectionName) {
        var section = generateSection(table, sectionName);
        var sync = sectionName === 'colgroup' ? syncColGroup : syncRows;
        var sectionElems = sync(gridSection);
        append(section, sectionElems);
      };
      var removeSection = function (sectionName) {
        child$1(table, sectionName).each(remove$5);
      };
      var renderOrRemoveSection = function (gridSection, sectionName) {
        if (gridSection.length > 0) {
          renderSection(gridSection, sectionName);
        } else {
          removeSection(sectionName);
        }
      };
      var headSection = [];
      var bodySection = [];
      var footSection = [];
      var columnGroupsSection = [];
      each$2(grid, function (row) {
        switch (row.section) {
        case 'thead':
          headSection.push(row);
          break;
        case 'tbody':
          bodySection.push(row);
          break;
        case 'tfoot':
          footSection.push(row);
          break;
        case 'colgroup':
          columnGroupsSection.push(row);
          break;
        }
      });
      renderOrRemoveSection(columnGroupsSection, 'colgroup');
      renderOrRemoveSection(headSection, 'thead');
      renderOrRemoveSection(bodySection, 'tbody');
      renderOrRemoveSection(footSection, 'tfoot');
      return {
        newRows: newRows,
        newCells: newCells
      };
    };
    var copy = function (grid) {
      return map$1(grid, function (row) {
        var tr = shallow(row.element);
        each$2(row.cells, function (cell) {
          var clonedCell = deep(cell.element);
          setIfNot(clonedCell, 'colspan', cell.colspan, 1);
          setIfNot(clonedCell, 'rowspan', cell.rowspan, 1);
          append$1(tr, clonedCell);
        });
        return tr;
      });
    };

    var getColumn = function (grid, index) {
      return map$1(grid, function (row) {
        return getCell(row, index);
      });
    };
    var getRow = function (grid, index) {
      return grid[index];
    };
    var findDiff = function (xs, comp) {
      if (xs.length === 0) {
        return 0;
      }
      var first = xs[0];
      var index = findIndex(xs, function (x) {
        return !comp(first.element, x.element);
      });
      return index.getOr(xs.length);
    };
    var subgrid = function (grid, row, column, comparator) {
      var gridRow = getRow(grid, row);
      var isColRow = gridRow.section === 'colgroup';
      var colspan = findDiff(gridRow.cells.slice(column), comparator);
      var rowspan = isColRow ? 1 : findDiff(getColumn(grid.slice(row), column), comparator);
      return {
        colspan: colspan,
        rowspan: rowspan
      };
    };

    var toDetails = function (grid, comparator) {
      var seen = map$1(grid, function (row) {
        return map$1(row.cells, never);
      });
      var updateSeen = function (rowIndex, columnIndex, rowspan, colspan) {
        for (var row = rowIndex; row < rowIndex + rowspan; row++) {
          for (var column = columnIndex; column < columnIndex + colspan; column++) {
            seen[row][column] = true;
          }
        }
      };
      return map$1(grid, function (row, rowIndex) {
        var details = bind$2(row.cells, function (cell, columnIndex) {
          if (seen[rowIndex][columnIndex] === false) {
            var result = subgrid(grid, rowIndex, columnIndex, comparator);
            updateSeen(rowIndex, columnIndex, result.rowspan, result.colspan);
            return [detailnew(cell.element, result.rowspan, result.colspan, cell.isNew)];
          } else {
            return [];
          }
        });
        return rowdetailnew(row.element, details, row.section, row.isNew);
      });
    };
    var toGrid = function (warehouse, generators, isNew) {
      var grid = [];
      each$2(warehouse.colgroups, function (colgroup) {
        var colgroupCols = [];
        for (var columnIndex = 0; columnIndex < warehouse.grid.columns; columnIndex++) {
          var element = Warehouse.getColumnAt(warehouse, columnIndex).map(function (column) {
            return elementnew(column.element, isNew, false);
          }).getOrThunk(function () {
            return elementnew(generators.colGap(), true, false);
          });
          colgroupCols.push(element);
        }
        grid.push(rowcells(colgroup.element, colgroupCols, 'colgroup', isNew));
      });
      for (var rowIndex = 0; rowIndex < warehouse.grid.rows; rowIndex++) {
        var rowCells = [];
        for (var columnIndex = 0; columnIndex < warehouse.grid.columns; columnIndex++) {
          var element = Warehouse.getAt(warehouse, rowIndex, columnIndex).map(function (item) {
            return elementnew(item.element, isNew, item.isLocked);
          }).getOrThunk(function () {
            return elementnew(generators.gap(), true, false);
          });
          rowCells.push(element);
        }
        var rowDetail = warehouse.all[rowIndex];
        var row = rowcells(rowDetail.element, rowCells, rowDetail.section, isNew);
        grid.push(row);
      }
      return grid;
    };

    var fromWarehouse = function (warehouse, generators) {
      return toGrid(warehouse, generators, false);
    };
    var toDetailList = function (grid) {
      return toDetails(grid, eq$1);
    };
    var findInWarehouse = function (warehouse, element) {
      return findMap(warehouse.all, function (r) {
        return find$1(r.cells, function (e) {
          return eq$1(element, e.element);
        });
      });
    };
    var extractCells = function (warehouse, target, predicate) {
      var details = map$1(target.selection, function (cell$1) {
        return cell(cell$1).bind(function (lc) {
          return findInWarehouse(warehouse, lc);
        }).filter(predicate);
      });
      var cells = cat(details);
      return someIf(cells.length > 0, cells);
    };
    var run = function (operation, extract, adjustment, postAction, genWrappers) {
      return function (wire, table, target, generators, behaviours) {
        var warehouse = Warehouse.fromTable(table);
        var tableSection = Optional.from(behaviours === null || behaviours === void 0 ? void 0 : behaviours.section).getOrThunk(TableSection.fallback);
        var output = extract(warehouse, target).map(function (info) {
          var model = fromWarehouse(warehouse, generators);
          var result = operation(model, info, eq$1, genWrappers(generators), tableSection);
          var lockedColumns = getLockedColumnsFromGrid(result.grid);
          var grid = toDetailList(result.grid);
          return {
            info: info,
            grid: grid,
            cursor: result.cursor,
            lockedColumns: lockedColumns
          };
        });
        return output.bind(function (out) {
          var newElements = render$1(table, out.grid);
          var tableSizing = Optional.from(behaviours === null || behaviours === void 0 ? void 0 : behaviours.sizing).getOrThunk(function () {
            return TableSize.getTableSize(table);
          });
          var resizing = Optional.from(behaviours === null || behaviours === void 0 ? void 0 : behaviours.resize).getOrThunk(preserveTable);
          adjustment(table, out.grid, out.info, {
            sizing: tableSizing,
            resize: resizing,
            section: tableSection
          });
          postAction(table);
          refresh(wire, table);
          remove$7(table, LOCKED_COL_ATTR);
          if (out.lockedColumns.length > 0) {
            set$2(table, LOCKED_COL_ATTR, out.lockedColumns.join(','));
          }
          return Optional.some({
            cursor: out.cursor,
            newRows: newElements.newRows,
            newCells: newElements.newCells
          });
        });
      };
    };
    var onPaste = function (warehouse, target) {
      return cell(target.element).bind(function (cell) {
        return findInWarehouse(warehouse, cell).map(function (details) {
          var value = __assign(__assign({}, details), {
            generators: target.generators,
            clipboard: target.clipboard
          });
          return value;
        });
      });
    };
    var onPasteByEditor = function (warehouse, target) {
      return extractCells(warehouse, target, always).map(function (cells) {
        return {
          cells: cells,
          generators: target.generators,
          clipboard: target.clipboard
        };
      });
    };
    var onMergable = function (_warehouse, target) {
      return target.mergable;
    };
    var onUnmergable = function (_warehouse, target) {
      return target.unmergable;
    };
    var onCells = function (warehouse, target) {
      return extractCells(warehouse, target, always);
    };
    var onUnlockedCells = function (warehouse, target) {
      return extractCells(warehouse, target, function (detail) {
        return !detail.isLocked;
      });
    };
    var isUnlockedTableCell = function (warehouse, cell) {
      return findInWarehouse(warehouse, cell).exists(function (detail) {
        return !detail.isLocked;
      });
    };
    var allUnlocked = function (warehouse, cells) {
      return forall(cells, function (cell) {
        return isUnlockedTableCell(warehouse, cell);
      });
    };
    var onUnlockedMergable = function (warehouse, target) {
      return onMergable(warehouse, target).filter(function (mergeable) {
        return allUnlocked(warehouse, mergeable.cells);
      });
    };
    var onUnlockedUnmergable = function (warehouse, target) {
      return onUnmergable(warehouse, target).filter(function (cells) {
        return allUnlocked(warehouse, cells);
      });
    };

    var merge$2 = function (grid, bounds, comparator, substitution) {
      var rows = extractGridDetails(grid).rows;
      if (rows.length === 0) {
        return grid;
      }
      for (var i = bounds.startRow; i <= bounds.finishRow; i++) {
        for (var j = bounds.startCol; j <= bounds.finishCol; j++) {
          var row = rows[i];
          var isLocked = getCell(row, j).isLocked;
          mutateCell(row, j, elementnew(substitution(), false, isLocked));
        }
      }
      return grid;
    };
    var unmerge = function (grid, target, comparator, substitution) {
      var rows = extractGridDetails(grid).rows;
      var first = true;
      for (var i = 0; i < rows.length; i++) {
        for (var j = 0; j < cellLength(rows[0]); j++) {
          var row = rows[i];
          var currentCell = getCell(row, j);
          var currentCellElm = currentCell.element;
          var isToReplace = comparator(currentCellElm, target);
          if (isToReplace === true && first === false) {
            mutateCell(row, j, elementnew(substitution(), true, currentCell.isLocked));
          } else if (isToReplace === true) {
            first = false;
          }
        }
      }
      return grid;
    };
    var uniqueCells = function (row, comparator) {
      return foldl(row, function (rest, cell) {
        return exists(rest, function (currentCell) {
          return comparator(currentCell.element, cell.element);
        }) ? rest : rest.concat([cell]);
      }, []);
    };
    var splitCols = function (grid, index, comparator, substitution) {
      if (index > 0 && index < grid[0].cells.length) {
        each$2(grid, function (row) {
          var prevCell = row.cells[index - 1];
          var current = row.cells[index];
          var isToReplace = comparator(current.element, prevCell.element);
          if (isToReplace) {
            mutateCell(row, index, elementnew(substitution(), true, current.isLocked));
          }
        });
      }
      return grid;
    };
    var splitRows = function (grid, index, comparator, substitution) {
      var rows = extractGridDetails(grid).rows;
      if (index > 0 && index < rows.length) {
        var rowPrevCells = rows[index - 1].cells;
        var cells = uniqueCells(rowPrevCells, comparator);
        each$2(cells, function (cell) {
          var replacement = Optional.none();
          for (var i = index; i < rows.length; i++) {
            var _loop_1 = function (j) {
              var row = rows[i];
              var current = getCell(row, j);
              var isToReplace = comparator(current.element, cell.element);
              if (isToReplace) {
                if (replacement.isNone()) {
                  replacement = Optional.some(substitution());
                }
                replacement.each(function (sub) {
                  mutateCell(row, j, elementnew(sub, true, current.isLocked));
                });
              }
            };
            for (var j = 0; j < cellLength(rows[0]); j++) {
              _loop_1(j);
            }
          }
        });
      }
      return grid;
    };

    var value$1 = function (o) {
      var or = function (_opt) {
        return value$1(o);
      };
      var orThunk = function (_f) {
        return value$1(o);
      };
      var map = function (f) {
        return value$1(f(o));
      };
      var mapError = function (_f) {
        return value$1(o);
      };
      var each = function (f) {
        f(o);
      };
      var bind = function (f) {
        return f(o);
      };
      var fold = function (_, onValue) {
        return onValue(o);
      };
      var exists = function (f) {
        return f(o);
      };
      var forall = function (f) {
        return f(o);
      };
      var toOptional = function () {
        return Optional.some(o);
      };
      return {
        isValue: always,
        isError: never,
        getOr: constant(o),
        getOrThunk: constant(o),
        getOrDie: constant(o),
        or: or,
        orThunk: orThunk,
        fold: fold,
        map: map,
        mapError: mapError,
        each: each,
        bind: bind,
        exists: exists,
        forall: forall,
        toOptional: toOptional
      };
    };
    var error = function (message) {
      var getOrThunk = function (f) {
        return f();
      };
      var getOrDie = function () {
        return die(String(message))();
      };
      var or = identity;
      var orThunk = function (f) {
        return f();
      };
      var map = function (_f) {
        return error(message);
      };
      var mapError = function (f) {
        return error(f(message));
      };
      var bind = function (_f) {
        return error(message);
      };
      var fold = function (onError, _) {
        return onError(message);
      };
      return {
        isValue: never,
        isError: always,
        getOr: identity,
        getOrThunk: getOrThunk,
        getOrDie: getOrDie,
        or: or,
        orThunk: orThunk,
        fold: fold,
        map: map,
        mapError: mapError,
        each: noop,
        bind: bind,
        exists: never,
        forall: always,
        toOptional: Optional.none
      };
    };
    var fromOption = function (opt, err) {
      return opt.fold(function () {
        return error(err);
      }, value$1);
    };
    var Result = {
      value: value$1,
      error: error,
      fromOption: fromOption
    };

    var measure = function (startAddress, gridA, gridB) {
      if (startAddress.row >= gridA.length || startAddress.column > cellLength(gridA[0])) {
        return Result.error('invalid start address out of table bounds, row: ' + startAddress.row + ', column: ' + startAddress.column);
      }
      var rowRemainder = gridA.slice(startAddress.row);
      var colRemainder = rowRemainder[0].cells.slice(startAddress.column);
      var colRequired = cellLength(gridB[0]);
      var rowRequired = gridB.length;
      return Result.value({
        rowDelta: rowRemainder.length - rowRequired,
        colDelta: colRemainder.length - colRequired
      });
    };
    var measureWidth = function (gridA, gridB) {
      var colLengthA = cellLength(gridA[0]);
      var colLengthB = cellLength(gridB[0]);
      return {
        rowDelta: 0,
        colDelta: colLengthA - colLengthB
      };
    };
    var measureHeight = function (gridA, gridB) {
      var rowLengthA = gridA.length;
      var rowLengthB = gridB.length;
      return {
        rowDelta: rowLengthA - rowLengthB,
        colDelta: 0
      };
    };
    var generateElements = function (amount, row, generators, isLocked) {
      var generator = row.section === 'colgroup' ? generators.col : generators.cell;
      return range$1(amount, function (idx) {
        return elementnew(generator(), true, isLocked(idx));
      });
    };
    var rowFill = function (grid, amount, generators, lockedColumns) {
      var exampleRow = grid[grid.length - 1];
      return grid.concat(range$1(amount, function () {
        var generator = exampleRow.section === 'colgroup' ? generators.colgroup : generators.row;
        var row = clone$1(exampleRow, generator, identity);
        var elements = generateElements(row.cells.length, row, generators, function (idx) {
          return has$1(lockedColumns, idx.toString());
        });
        return setCells(row, elements);
      }));
    };
    var colFill = function (grid, amount, generators, startIndex) {
      return map$1(grid, function (row) {
        var newChildren = generateElements(amount, row, generators, never);
        return addCells(row, startIndex, newChildren);
      });
    };
    var lockedColFill = function (grid, generators, lockedColumns) {
      return map$1(grid, function (row) {
        return foldl(lockedColumns, function (acc, colNum) {
          var newChild = generateElements(1, row, generators, always)[0];
          return addCell(acc, colNum, newChild);
        }, row);
      });
    };
    var tailor = function (gridA, delta, generators) {
      var fillCols = delta.colDelta < 0 ? colFill : identity;
      var fillRows = delta.rowDelta < 0 ? rowFill : identity;
      var lockedColumns = getLockedColumnsFromGrid(gridA);
      var gridWidth = cellLength(gridA[0]);
      var isLastColLocked = exists(lockedColumns, function (locked) {
        return locked === gridWidth - 1;
      });
      var modifiedCols = fillCols(gridA, Math.abs(delta.colDelta), generators, isLastColLocked ? gridWidth - 1 : gridWidth);
      var newLockedColumns = getLockedColumnsFromGrid(modifiedCols);
      return fillRows(modifiedCols, Math.abs(delta.rowDelta), generators, mapToObject(newLockedColumns, always));
    };

    var isSpanning = function (grid, row, col, comparator) {
      var candidate = getCell(grid[row], col);
      var matching = curry(comparator, candidate.element);
      var currentRow = grid[row];
      return grid.length > 1 && cellLength(currentRow) > 1 && (col > 0 && matching(getCellElement(currentRow, col - 1)) || col < currentRow.cells.length - 1 && matching(getCellElement(currentRow, col + 1)) || row > 0 && matching(getCellElement(grid[row - 1], col)) || row < grid.length - 1 && matching(getCellElement(grid[row + 1], col)));
    };
    var mergeTables = function (startAddress, gridA, gridB, generator, comparator, lockedColumns) {
      var startRow = startAddress.row;
      var startCol = startAddress.column;
      var mergeHeight = gridB.length;
      var mergeWidth = cellLength(gridB[0]);
      var endRow = startRow + mergeHeight;
      var endCol = startCol + mergeWidth + lockedColumns.length;
      var lockedColumnObj = mapToObject(lockedColumns, always);
      for (var r = startRow; r < endRow; r++) {
        var skippedCol = 0;
        for (var c = startCol; c < endCol; c++) {
          if (lockedColumnObj[c]) {
            skippedCol++;
            continue;
          }
          if (isSpanning(gridA, r, c, comparator)) {
            unmerge(gridA, getCellElement(gridA[r], c), comparator, generator.cell);
          }
          var gridBColIndex = c - startCol - skippedCol;
          var newCell = getCell(gridB[r - startRow], gridBColIndex);
          var newCellElm = newCell.element;
          var replacement = generator.replace(newCellElm);
          mutateCell(gridA[r], c, elementnew(replacement, true, newCell.isLocked));
        }
      }
      return gridA;
    };
    var getValidStartAddress = function (currentStartAddress, grid, lockedColumns) {
      var gridColLength = cellLength(grid[0]);
      var adjustedRowAddress = extractGridDetails(grid).cols.length + currentStartAddress.row;
      var possibleColAddresses = range$1(gridColLength - currentStartAddress.column, function (num) {
        return num + currentStartAddress.column;
      });
      var validColAddress = find$1(possibleColAddresses, function (num) {
        return forall(lockedColumns, function (col) {
          return col !== num;
        });
      }).getOr(gridColLength - 1);
      return {
        row: adjustedRowAddress,
        column: validColAddress
      };
    };
    var getLockedColumnsWithinBounds = function (startAddress, grid, lockedColumns) {
      return filter$2(lockedColumns, function (colNum) {
        return colNum >= startAddress.column && colNum <= cellLength(grid[0]) + startAddress.column;
      });
    };
    var merge$1 = function (startAddress, gridA, gridB, generator, comparator) {
      var lockedColumns = getLockedColumnsFromGrid(gridA);
      var validStartAddress = getValidStartAddress(startAddress, gridA, lockedColumns);
      var gridBRows = extractGridDetails(gridB).rows;
      var lockedColumnsWithinBounds = getLockedColumnsWithinBounds(validStartAddress, gridBRows, lockedColumns);
      var result = measure(validStartAddress, gridA, gridBRows);
      return result.map(function (diff) {
        var delta = __assign(__assign({}, diff), { colDelta: diff.colDelta - lockedColumnsWithinBounds.length });
        var fittedGrid = tailor(gridA, delta, generator);
        var newLockedColumns = getLockedColumnsFromGrid(fittedGrid);
        var newLockedColumnsWithinBounds = getLockedColumnsWithinBounds(validStartAddress, gridBRows, newLockedColumns);
        return mergeTables(validStartAddress, fittedGrid, gridBRows, generator, comparator, newLockedColumnsWithinBounds);
      });
    };
    var insertCols = function (index, gridA, gridB, generator, comparator) {
      splitCols(gridA, index, comparator, generator.cell);
      var delta = measureHeight(gridB, gridA);
      var fittedNewGrid = tailor(gridB, delta, generator);
      var secondDelta = measureHeight(gridA, fittedNewGrid);
      var fittedOldGrid = tailor(gridA, secondDelta, generator);
      return map$1(fittedOldGrid, function (gridRow, i) {
        return addCells(gridRow, index, fittedNewGrid[i].cells);
      });
    };
    var insertRows = function (index, gridA, gridB, generator, comparator) {
      splitRows(gridA, index, comparator, generator.cell);
      var locked = getLockedColumnsFromGrid(gridA);
      var diff = measureWidth(gridA, gridB);
      var delta = __assign(__assign({}, diff), { colDelta: diff.colDelta - locked.length });
      var fittedOldGrid = tailor(gridA, delta, generator);
      var _a = extractGridDetails(fittedOldGrid), oldCols = _a.cols, oldRows = _a.rows;
      var newLocked = getLockedColumnsFromGrid(fittedOldGrid);
      var secondDiff = measureWidth(gridB, gridA);
      var secondDelta = __assign(__assign({}, secondDiff), { colDelta: secondDiff.colDelta + newLocked.length });
      var fittedGridB = lockedColFill(gridB, generator, newLocked);
      var fittedNewGrid = tailor(fittedGridB, secondDelta, generator);
      return oldCols.concat(oldRows.slice(0, index)).concat(fittedNewGrid).concat(oldRows.slice(index, oldRows.length));
    };

    var cloneRow = function (row, cloneCell, comparator, substitution) {
      return clone$1(row, function (elem) {
        return substitution(elem, comparator);
      }, cloneCell);
    };
    var insertRowAt = function (grid, index, example, comparator, substitution) {
      var _a = extractGridDetails(grid), rows = _a.rows, cols = _a.cols;
      var before = rows.slice(0, index);
      var after = rows.slice(index);
      var newRow = cloneRow(rows[example], function (ex, c) {
        var withinSpan = index > 0 && index < rows.length && comparator(getCellElement(rows[index - 1], c), getCellElement(rows[index], c));
        var ret = withinSpan ? getCell(rows[index], c) : elementnew(substitution(ex.element, comparator), true, ex.isLocked);
        return ret;
      }, comparator, substitution);
      return cols.concat(before).concat([newRow]).concat(after);
    };
    var getElementFor = function (row, column, section, withinSpan, example, comparator, substitution) {
      if (section === 'colgroup' || !withinSpan) {
        var cell = getCell(row, example);
        return elementnew(substitution(cell.element, comparator), true, false);
      } else {
        return getCell(row, column);
      }
    };
    var insertColumnAt = function (grid, index, example, comparator, substitution) {
      return map$1(grid, function (row) {
        var withinSpan = index > 0 && index < cellLength(row) && comparator(getCellElement(row, index - 1), getCellElement(row, index));
        var sub = getElementFor(row, index, row.section, withinSpan, example, comparator, substitution);
        return addCell(row, index, sub);
      });
    };
    var deleteColumnsAt = function (grid, columns) {
      return bind$2(grid, function (row) {
        var existingCells = row.cells;
        var cells = foldr(columns, function (acc, column) {
          return column >= 0 && column < acc.length ? acc.slice(0, column).concat(acc.slice(column + 1)) : acc;
        }, existingCells);
        return cells.length > 0 ? [rowcells(row.element, cells, row.section, row.isNew)] : [];
      });
    };
    var deleteRowsAt = function (grid, start, finish) {
      var _a = extractGridDetails(grid), rows = _a.rows, cols = _a.cols;
      return cols.concat(rows.slice(0, start)).concat(rows.slice(finish + 1));
    };

    var notInStartRow = function (grid, rowIndex, colIndex, comparator) {
      return getCellElement(grid[rowIndex], colIndex) !== undefined && (rowIndex > 0 && comparator(getCellElement(grid[rowIndex - 1], colIndex), getCellElement(grid[rowIndex], colIndex)));
    };
    var notInStartColumn = function (row, index, comparator) {
      return index > 0 && comparator(getCellElement(row, index - 1), getCellElement(row, index));
    };
    var isDuplicatedCell = function (grid, rowIndex, colIndex, comparator) {
      return notInStartRow(grid, rowIndex, colIndex, comparator) || notInStartColumn(grid[rowIndex], colIndex, comparator);
    };
    var rowReplacerPredicate = function (targetRow, columnHeaders) {
      var entireTableIsHeader = forall(columnHeaders, identity) && isHeaderCells(targetRow.cells);
      return entireTableIsHeader ? always : function (cell, _rowIndex, colIndex) {
        var type = name(cell.element);
        return !(type === 'th' && columnHeaders[colIndex]);
      };
    };
    var columnReplacePredicate = function (targetColumn, rowHeaders) {
      var entireTableIsHeader = forall(rowHeaders, identity) && isHeaderCells(targetColumn);
      return entireTableIsHeader ? always : function (cell, rowIndex, _colIndex) {
        var type = name(cell.element);
        return !(type === 'th' && rowHeaders[rowIndex]);
      };
    };
    var determineScope = function (applyScope, element, newScope, isInHeader) {
      var hasSpan = function (scope) {
        return scope === 'row' ? hasRowspan(element) : hasColspan(element);
      };
      var getScope = function (scope) {
        return hasSpan(scope) ? scope + 'group' : scope;
      };
      if (applyScope) {
        return isHeaderCell(element) ? getScope(newScope) : null;
      } else if (isInHeader && isHeaderCell(element)) {
        var oppositeScope = newScope === 'row' ? 'col' : 'row';
        return getScope(oppositeScope);
      } else {
        return null;
      }
    };
    var rowScopeGenerator = function (applyScope, columnHeaders) {
      return function (cell, rowIndex, columnIndex) {
        return Optional.some(determineScope(applyScope, cell.element, 'col', columnHeaders[columnIndex]));
      };
    };
    var columnScopeGenerator = function (applyScope, rowHeaders) {
      return function (cell, rowIndex) {
        return Optional.some(determineScope(applyScope, cell.element, 'row', rowHeaders[rowIndex]));
      };
    };
    var replace = function (cell, comparator, substitute) {
      return elementnew(substitute(cell.element, comparator), true, cell.isLocked);
    };
    var replaceIn = function (grid, targets, comparator, substitute, replacer, genScope, shouldReplace) {
      var isTarget = function (cell) {
        return exists(targets, function (target) {
          return comparator(cell.element, target.element);
        });
      };
      return map$1(grid, function (row, rowIndex) {
        return mapCells(row, function (cell, colIndex) {
          if (isTarget(cell)) {
            var newCell_1 = shouldReplace(cell, rowIndex, colIndex) ? replacer(cell, comparator, substitute) : cell;
            genScope(newCell_1, rowIndex, colIndex).each(function (scope) {
              setOptions(newCell_1.element, { scope: Optional.from(scope) });
            });
            return newCell_1;
          } else {
            return cell;
          }
        });
      });
    };
    var getColumnCells = function (rows, columnIndex, comparator) {
      return bind$2(rows, function (row, i) {
        return isDuplicatedCell(rows, i, columnIndex, comparator) ? [] : [getCell(row, columnIndex)];
      });
    };
    var getRowCells = function (rows, rowIndex, comparator) {
      var targetRow = rows[rowIndex];
      return bind$2(targetRow.cells, function (item, i) {
        return isDuplicatedCell(rows, rowIndex, i, comparator) ? [] : [item];
      });
    };
    var replaceColumns = function (grid, indexes, applyScope, comparator, substitution) {
      var rows = extractGridDetails(grid).rows;
      var targets = bind$2(indexes, function (index) {
        return getColumnCells(rows, index, comparator);
      });
      var rowHeaders = map$1(grid, function (row) {
        return isHeaderCells(row.cells);
      });
      var shouldReplaceCell = columnReplacePredicate(targets, rowHeaders);
      var scopeGenerator = columnScopeGenerator(applyScope, rowHeaders);
      return replaceIn(grid, targets, comparator, substitution, replace, scopeGenerator, shouldReplaceCell);
    };
    var replaceRows = function (grid, indexes, section, applyScope, comparator, substitution, tableSection) {
      var _a = extractGridDetails(grid), cols = _a.cols, rows = _a.rows;
      var targetRow = rows[indexes[0]];
      var targets = bind$2(indexes, function (index) {
        return getRowCells(rows, index, comparator);
      });
      var columnHeaders = map$1(targetRow.cells, function (_cell, index) {
        return isHeaderCells(getColumnCells(rows, index, comparator));
      });
      var newRows = __spreadArray([], rows, true);
      each$2(indexes, function (index) {
        newRows[index] = tableSection.transformRow(rows[index], section);
      });
      var newGrid = cols.concat(newRows);
      var shouldReplaceCell = rowReplacerPredicate(targetRow, columnHeaders);
      var scopeGenerator = rowScopeGenerator(applyScope, columnHeaders);
      return replaceIn(newGrid, targets, comparator, substitution, tableSection.transformCell, scopeGenerator, shouldReplaceCell);
    };
    var replaceCells = function (grid, details, comparator, substitution) {
      var rows = extractGridDetails(grid).rows;
      var targetCells = map$1(details, function (detail) {
        return getCell(rows[detail.row], detail.column);
      });
      return replaceIn(grid, targetCells, comparator, substitution, replace, Optional.none, always);
    };

    var uniqueColumns = function (details) {
      var uniqueCheck = function (rest, detail) {
        var columnExists = exists(rest, function (currentDetail) {
          return currentDetail.column === detail.column;
        });
        return columnExists ? rest : rest.concat([detail]);
      };
      return foldl(details, uniqueCheck, []).sort(function (detailA, detailB) {
        return detailA.column - detailB.column;
      });
    };

    var isCol = isTag('col');
    var isColgroup = isTag('colgroup');
    var isRow$1 = function (element) {
      return name(element) === 'tr' || isColgroup(element);
    };
    var elementToData = function (element) {
      var colspan = getAttrValue(element, 'colspan', 1);
      var rowspan = getAttrValue(element, 'rowspan', 1);
      return {
        element: element,
        colspan: colspan,
        rowspan: rowspan
      };
    };
    var modification = function (generators, toData) {
      if (toData === void 0) {
        toData = elementToData;
      }
      var nuCell = function (data) {
        return isCol(data.element) ? generators.col(data) : generators.cell(data);
      };
      var nuRow = function (data) {
        return isColgroup(data.element) ? generators.colgroup(data) : generators.row(data);
      };
      var add = function (element) {
        if (isRow$1(element)) {
          return nuRow({ element: element });
        } else {
          var replacement = nuCell(toData(element));
          recent = Optional.some({
            item: element,
            replacement: replacement
          });
          return replacement;
        }
      };
      var recent = Optional.none();
      var getOrInit = function (element, comparator) {
        return recent.fold(function () {
          return add(element);
        }, function (p) {
          return comparator(element, p.item) ? p.replacement : add(element);
        });
      };
      return { getOrInit: getOrInit };
    };
    var transform = function (tag) {
      return function (generators) {
        var list = [];
        var find = function (element, comparator) {
          return find$1(list, function (x) {
            return comparator(x.item, element);
          });
        };
        var makeNew = function (element) {
          var attrs = tag === 'td' ? { scope: null } : {};
          var cell = generators.replace(element, tag, attrs);
          list.push({
            item: element,
            sub: cell
          });
          return cell;
        };
        var replaceOrInit = function (element, comparator) {
          if (isRow$1(element) || isCol(element)) {
            return element;
          } else {
            return find(element, comparator).fold(function () {
              return makeNew(element);
            }, function (p) {
              return comparator(element, p.item) ? p.sub : makeNew(element);
            });
          }
        };
        return { replaceOrInit: replaceOrInit };
      };
    };
    var getScopeAttribute = function (cell) {
      return getOpt(cell, 'scope').map(function (attribute) {
        return attribute.substr(0, 3);
      });
    };
    var merging = function (generators) {
      var unmerge = function (cell) {
        var scope = getScopeAttribute(cell);
        scope.each(function (attribute) {
          return set$2(cell, 'scope', attribute);
        });
        return function () {
          var raw = generators.cell({
            element: cell,
            colspan: 1,
            rowspan: 1
          });
          remove$6(raw, 'width');
          remove$6(cell, 'width');
          scope.each(function (attribute) {
            return set$2(raw, 'scope', attribute);
          });
          return raw;
        };
      };
      var merge = function (cells) {
        var getScopeProperty = function () {
          var stringAttributes = cat(map$1(cells, getScopeAttribute));
          if (stringAttributes.length === 0) {
            return Optional.none();
          } else {
            var baseScope_1 = stringAttributes[0];
            var scopes_1 = [
              'row',
              'col'
            ];
            var isMixed = exists(stringAttributes, function (attribute) {
              return attribute !== baseScope_1 && contains$2(scopes_1, attribute);
            });
            return isMixed ? Optional.none() : Optional.from(baseScope_1);
          }
        };
        remove$6(cells[0], 'width');
        getScopeProperty().fold(function () {
          return remove$7(cells[0], 'scope');
        }, function (attribute) {
          return set$2(cells[0], 'scope', attribute + 'group');
        });
        return constant(cells[0]);
      };
      return {
        unmerge: unmerge,
        merge: merge
      };
    };
    var Generators = {
      modification: modification,
      transform: transform,
      merging: merging
    };

    var blockList = [
      'body',
      'p',
      'div',
      'article',
      'aside',
      'figcaption',
      'figure',
      'footer',
      'header',
      'nav',
      'section',
      'ol',
      'ul',
      'table',
      'thead',
      'tfoot',
      'tbody',
      'caption',
      'tr',
      'td',
      'th',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'blockquote',
      'pre',
      'address'
    ];
    var isList$1 = function (universe, item) {
      var tagName = universe.property().name(item);
      return contains$2([
        'ol',
        'ul'
      ], tagName);
    };
    var isBlock$1 = function (universe, item) {
      var tagName = universe.property().name(item);
      return contains$2(blockList, tagName);
    };
    var isEmptyTag$1 = function (universe, item) {
      return contains$2([
        'br',
        'img',
        'hr',
        'input'
      ], universe.property().name(item));
    };

    var universe$1 = DomUniverse();
    var isBlock = function (element) {
      return isBlock$1(universe$1, element);
    };
    var isList = function (element) {
      return isList$1(universe$1, element);
    };
    var isEmptyTag = function (element) {
      return isEmptyTag$1(universe$1, element);
    };

    var merge = function (cells) {
      var isBr = function (el) {
        return name(el) === 'br';
      };
      var advancedBr = function (children) {
        return forall(children, function (c) {
          return isBr(c) || isText(c) && get$9(c).trim().length === 0;
        });
      };
      var isListItem = function (el) {
        return name(el) === 'li' || ancestor$2(el, isList).isSome();
      };
      var siblingIsBlock = function (el) {
        return nextSibling(el).map(function (rightSibling) {
          if (isBlock(rightSibling)) {
            return true;
          }
          if (isEmptyTag(rightSibling)) {
            return name(rightSibling) === 'img' ? false : true;
          }
          return false;
        }).getOr(false);
      };
      var markCell = function (cell) {
        return last$1(cell).bind(function (rightEdge) {
          var rightSiblingIsBlock = siblingIsBlock(rightEdge);
          return parent(rightEdge).map(function (parent) {
            return rightSiblingIsBlock === true || isListItem(parent) || isBr(rightEdge) || isBlock(parent) && !eq$1(cell, parent) ? [] : [SugarElement.fromTag('br')];
          });
        }).getOr([]);
      };
      var markContent = function () {
        var content = bind$2(cells, function (cell) {
          var children = children$3(cell);
          return advancedBr(children) ? [] : children.concat(markCell(cell));
        });
        return content.length === 0 ? [SugarElement.fromTag('br')] : content;
      };
      var contents = markContent();
      empty(cells[0]);
      append(cells[0], contents);
    };

    var isEditable = function (elem) {
      return isEditable$1(elem, true);
    };
    var prune = function (table) {
      var cells = cells$1(table);
      if (cells.length === 0) {
        remove$5(table);
      }
    };
    var outcome = function (grid, cursor) {
      return {
        grid: grid,
        cursor: cursor
      };
    };
    var findEditableCursorPosition = function (rows) {
      return findMap(rows, function (row) {
        return findMap(row.cells, function (cell) {
          var elem = cell.element;
          return someIf(isEditable(elem), elem);
        });
      });
    };
    var elementFromGrid = function (grid, row, column) {
      var _a, _b;
      var rows = extractGridDetails(grid).rows;
      return Optional.from((_b = (_a = rows[row]) === null || _a === void 0 ? void 0 : _a.cells[column]) === null || _b === void 0 ? void 0 : _b.element).filter(isEditable).orThunk(function () {
        return findEditableCursorPosition(rows);
      });
    };
    var bundle = function (grid, row, column) {
      var cursorElement = elementFromGrid(grid, row, column);
      return outcome(grid, cursorElement);
    };
    var uniqueRows = function (details) {
      var rowCompilation = function (rest, detail) {
        var rowExists = exists(rest, function (currentDetail) {
          return currentDetail.row === detail.row;
        });
        return rowExists ? rest : rest.concat([detail]);
      };
      return foldl(details, rowCompilation, []).sort(function (detailA, detailB) {
        return detailA.row - detailB.row;
      });
    };
    var opInsertRowsBefore = function (grid, details, comparator, genWrappers) {
      var targetIndex = details[0].row;
      var rows = uniqueRows(details);
      var newGrid = foldr(rows, function (acc, row) {
        var newG = insertRowAt(acc.grid, targetIndex, row.row + acc.delta, comparator, genWrappers.getOrInit);
        return {
          grid: newG,
          delta: acc.delta + 1
        };
      }, {
        grid: grid,
        delta: 0
      }).grid;
      return bundle(newGrid, targetIndex, details[0].column);
    };
    var opInsertRowsAfter = function (grid, details, comparator, genWrappers) {
      var rows = uniqueRows(details);
      var target = rows[rows.length - 1];
      var targetIndex = target.row + target.rowspan;
      var newGrid = foldr(rows, function (newG, row) {
        return insertRowAt(newG, targetIndex, row.row, comparator, genWrappers.getOrInit);
      }, grid);
      return bundle(newGrid, targetIndex, details[0].column);
    };
    var opInsertColumnsBefore = function (grid, extractDetail, comparator, genWrappers) {
      var details = extractDetail.details;
      var columns = uniqueColumns(details);
      var targetIndex = columns[0].column;
      var newGrid = foldr(columns, function (acc, col) {
        var newG = insertColumnAt(acc.grid, targetIndex, col.column + acc.delta, comparator, genWrappers.getOrInit);
        return {
          grid: newG,
          delta: acc.delta + 1
        };
      }, {
        grid: grid,
        delta: 0
      }).grid;
      return bundle(newGrid, details[0].row, targetIndex);
    };
    var opInsertColumnsAfter = function (grid, extractDetail, comparator, genWrappers) {
      var details = extractDetail.details;
      var target = details[details.length - 1];
      var targetIndex = target.column + target.colspan;
      var columns = uniqueColumns(details);
      var newGrid = foldr(columns, function (newG, col) {
        return insertColumnAt(newG, targetIndex, col.column, comparator, genWrappers.getOrInit);
      }, grid);
      return bundle(newGrid, details[0].row, targetIndex);
    };
    var opMakeColumnsHeader = function (initialGrid, details, comparator, genWrappers) {
      var columns = uniqueColumns(details);
      var columnIndexes = map$1(columns, function (detail) {
        return detail.column;
      });
      var newGrid = replaceColumns(initialGrid, columnIndexes, true, comparator, genWrappers.replaceOrInit);
      return bundle(newGrid, details[0].row, details[0].column);
    };
    var opMakeCellsHeader = function (initialGrid, details, comparator, genWrappers) {
      var newGrid = replaceCells(initialGrid, details, comparator, genWrappers.replaceOrInit);
      return bundle(newGrid, details[0].row, details[0].column);
    };
    var opUnmakeColumnsHeader = function (initialGrid, details, comparator, genWrappers) {
      var columns = uniqueColumns(details);
      var columnIndexes = map$1(columns, function (detail) {
        return detail.column;
      });
      var newGrid = replaceColumns(initialGrid, columnIndexes, false, comparator, genWrappers.replaceOrInit);
      return bundle(newGrid, details[0].row, details[0].column);
    };
    var opUnmakeCellsHeader = function (initialGrid, details, comparator, genWrappers) {
      var newGrid = replaceCells(initialGrid, details, comparator, genWrappers.replaceOrInit);
      return bundle(newGrid, details[0].row, details[0].column);
    };
    var makeRowsSection = function (section, applyScope) {
      return function (initialGrid, details, comparator, genWrappers, tableSection) {
        var rows = uniqueRows(details);
        var rowIndexes = map$1(rows, function (detail) {
          return detail.row;
        });
        var newGrid = replaceRows(initialGrid, rowIndexes, section, applyScope, comparator, genWrappers.replaceOrInit, tableSection);
        return bundle(newGrid, details[0].row, details[0].column);
      };
    };
    var opMakeRowsHeader = makeRowsSection('thead', true);
    var opMakeRowsBody = makeRowsSection('tbody', false);
    var opMakeRowsFooter = makeRowsSection('tfoot', false);
    var opEraseColumns = function (grid, extractDetail, _comparator, _genWrappers) {
      var columns = uniqueColumns(extractDetail.details);
      var newGrid = deleteColumnsAt(grid, map$1(columns, function (column) {
        return column.column;
      }));
      var maxColIndex = newGrid.length > 0 ? newGrid[0].cells.length - 1 : 0;
      return bundle(newGrid, columns[0].row, Math.min(columns[0].column, maxColIndex));
    };
    var opEraseRows = function (grid, details, _comparator, _genWrappers) {
      var rows = uniqueRows(details);
      var newGrid = deleteRowsAt(grid, rows[0].row, rows[rows.length - 1].row);
      var maxRowIndex = newGrid.length > 0 ? newGrid.length - 1 : 0;
      return bundle(newGrid, Math.min(details[0].row, maxRowIndex), details[0].column);
    };
    var opMergeCells = function (grid, mergable, comparator, genWrappers) {
      var cells = mergable.cells;
      merge(cells);
      var newGrid = merge$2(grid, mergable.bounds, comparator, genWrappers.merge(cells));
      return outcome(newGrid, Optional.from(cells[0]));
    };
    var opUnmergeCells = function (grid, unmergable, comparator, genWrappers) {
      var unmerge$1 = function (b, cell) {
        return unmerge(b, cell, comparator, genWrappers.unmerge(cell));
      };
      var newGrid = foldr(unmergable, unmerge$1, grid);
      return outcome(newGrid, Optional.from(unmergable[0]));
    };
    var opPasteCells = function (grid, pasteDetails, comparator, _genWrappers) {
      var gridify = function (table, generators) {
        var wh = Warehouse.fromTable(table);
        return toGrid(wh, generators, true);
      };
      var gridB = gridify(pasteDetails.clipboard, pasteDetails.generators);
      var startAddress = address(pasteDetails.row, pasteDetails.column);
      var mergedGrid = merge$1(startAddress, grid, gridB, pasteDetails.generators, comparator);
      return mergedGrid.fold(function () {
        return outcome(grid, Optional.some(pasteDetails.element));
      }, function (newGrid) {
        return bundle(newGrid, pasteDetails.row, pasteDetails.column);
      });
    };
    var gridifyRows = function (rows, generators, context) {
      var pasteDetails = fromPastedRows(rows, context.section);
      var wh = Warehouse.generate(pasteDetails);
      return toGrid(wh, generators, true);
    };
    var opPasteColsBefore = function (grid, pasteDetails, comparator, _genWrappers) {
      var rows = extractGridDetails(grid).rows;
      var index = pasteDetails.cells[0].column;
      var context = rows[pasteDetails.cells[0].row];
      var gridB = gridifyRows(pasteDetails.clipboard, pasteDetails.generators, context);
      var mergedGrid = insertCols(index, grid, gridB, pasteDetails.generators, comparator);
      return bundle(mergedGrid, pasteDetails.cells[0].row, pasteDetails.cells[0].column);
    };
    var opPasteColsAfter = function (grid, pasteDetails, comparator, _genWrappers) {
      var rows = extractGridDetails(grid).rows;
      var index = pasteDetails.cells[pasteDetails.cells.length - 1].column + pasteDetails.cells[pasteDetails.cells.length - 1].colspan;
      var context = rows[pasteDetails.cells[0].row];
      var gridB = gridifyRows(pasteDetails.clipboard, pasteDetails.generators, context);
      var mergedGrid = insertCols(index, grid, gridB, pasteDetails.generators, comparator);
      return bundle(mergedGrid, pasteDetails.cells[0].row, pasteDetails.cells[0].column);
    };
    var opPasteRowsBefore = function (grid, pasteDetails, comparator, _genWrappers) {
      var rows = extractGridDetails(grid).rows;
      var index = pasteDetails.cells[0].row;
      var context = rows[index];
      var gridB = gridifyRows(pasteDetails.clipboard, pasteDetails.generators, context);
      var mergedGrid = insertRows(index, grid, gridB, pasteDetails.generators, comparator);
      return bundle(mergedGrid, pasteDetails.cells[0].row, pasteDetails.cells[0].column);
    };
    var opPasteRowsAfter = function (grid, pasteDetails, comparator, _genWrappers) {
      var rows = extractGridDetails(grid).rows;
      var index = pasteDetails.cells[pasteDetails.cells.length - 1].row + pasteDetails.cells[pasteDetails.cells.length - 1].rowspan;
      var context = rows[pasteDetails.cells[0].row];
      var gridB = gridifyRows(pasteDetails.clipboard, pasteDetails.generators, context);
      var mergedGrid = insertRows(index, grid, gridB, pasteDetails.generators, comparator);
      return bundle(mergedGrid, pasteDetails.cells[0].row, pasteDetails.cells[0].column);
    };
    var opGetColumnsType = function (table, target) {
      var house = Warehouse.fromTable(table);
      var details = onCells(house, target);
      return details.bind(function (selectedCells) {
        var lastSelectedCell = selectedCells[selectedCells.length - 1];
        var minColRange = selectedCells[0].column;
        var maxColRange = lastSelectedCell.column + lastSelectedCell.colspan;
        var selectedColumnCells = flatten$1(map$1(house.all, function (row) {
          return filter$2(row.cells, function (cell) {
            return cell.column >= minColRange && cell.column < maxColRange;
          });
        }));
        return findCommonCellType(selectedColumnCells);
      }).getOr('');
    };
    var opGetCellsType = function (table, target) {
      var house = Warehouse.fromTable(table);
      var details = onCells(house, target);
      return details.bind(findCommonCellType).getOr('');
    };
    var opGetRowsType = function (table, target) {
      var house = Warehouse.fromTable(table);
      var details = onCells(house, target);
      return details.bind(function (selectedCells) {
        var lastSelectedCell = selectedCells[selectedCells.length - 1];
        var minRowRange = selectedCells[0].row;
        var maxRowRange = lastSelectedCell.row + lastSelectedCell.rowspan;
        var selectedRows = house.all.slice(minRowRange, maxRowRange);
        return findCommonRowType(selectedRows);
      }).getOr('');
    };
    var resize = function (table, list, details, behaviours) {
      return adjustWidthTo(table, list, details, behaviours.sizing);
    };
    var adjustAndRedistributeWidths = function (table, list, details, behaviours) {
      return adjustAndRedistributeWidths$1(table, list, details, behaviours.sizing, behaviours.resize);
    };
    var firstColumnIsLocked = function (_warehouse, details) {
      return exists(details, function (detail) {
        return detail.column === 0 && detail.isLocked;
      });
    };
    var lastColumnIsLocked = function (warehouse, details) {
      return exists(details, function (detail) {
        return detail.column + detail.colspan >= warehouse.grid.columns && detail.isLocked;
      });
    };
    var getColumnsWidth = function (warehouse, details) {
      var columns$1 = columns(warehouse);
      var uniqueCols = uniqueColumns(details);
      return foldl(uniqueCols, function (acc, detail) {
        var column = columns$1[detail.column];
        var colWidth = column.map(getOuter$2).getOr(0);
        return acc + colWidth;
      }, 0);
    };
    var insertColumnsExtractor = function (before) {
      return function (warehouse, target) {
        return onCells(warehouse, target).filter(function (details) {
          var checkLocked = before ? firstColumnIsLocked : lastColumnIsLocked;
          return !checkLocked(warehouse, details);
        }).map(function (details) {
          return {
            details: details,
            pixelDelta: getColumnsWidth(warehouse, details)
          };
        });
      };
    };
    var eraseColumnsExtractor = function (warehouse, target) {
      return onUnlockedCells(warehouse, target).map(function (details) {
        return {
          details: details,
          pixelDelta: -getColumnsWidth(warehouse, details)
        };
      });
    };
    var pasteColumnsExtractor = function (before) {
      return function (warehouse, target) {
        return onPasteByEditor(warehouse, target).filter(function (details) {
          var checkLocked = before ? firstColumnIsLocked : lastColumnIsLocked;
          return !checkLocked(warehouse, details.cells);
        });
      };
    };
    var headerCellGenerator = Generators.transform('th');
    var bodyCellGenerator = Generators.transform('td');
    var insertRowsBefore = run(opInsertRowsBefore, onCells, noop, noop, Generators.modification);
    var insertRowsAfter = run(opInsertRowsAfter, onCells, noop, noop, Generators.modification);
    var insertColumnsBefore = run(opInsertColumnsBefore, insertColumnsExtractor(true), adjustAndRedistributeWidths, noop, Generators.modification);
    var insertColumnsAfter = run(opInsertColumnsAfter, insertColumnsExtractor(false), adjustAndRedistributeWidths, noop, Generators.modification);
    var eraseColumns = run(opEraseColumns, eraseColumnsExtractor, adjustAndRedistributeWidths, prune, Generators.modification);
    var eraseRows = run(opEraseRows, onCells, noop, prune, Generators.modification);
    var makeColumnsHeader = run(opMakeColumnsHeader, onUnlockedCells, noop, noop, headerCellGenerator);
    var unmakeColumnsHeader = run(opUnmakeColumnsHeader, onUnlockedCells, noop, noop, bodyCellGenerator);
    var makeRowsHeader = run(opMakeRowsHeader, onUnlockedCells, noop, noop, headerCellGenerator);
    var makeRowsBody = run(opMakeRowsBody, onUnlockedCells, noop, noop, bodyCellGenerator);
    var makeRowsFooter = run(opMakeRowsFooter, onUnlockedCells, noop, noop, bodyCellGenerator);
    var makeCellsHeader = run(opMakeCellsHeader, onUnlockedCells, noop, noop, headerCellGenerator);
    var unmakeCellsHeader = run(opUnmakeCellsHeader, onUnlockedCells, noop, noop, bodyCellGenerator);
    var mergeCells = run(opMergeCells, onUnlockedMergable, resize, noop, Generators.merging);
    var unmergeCells = run(opUnmergeCells, onUnlockedUnmergable, resize, noop, Generators.merging);
    var pasteCells = run(opPasteCells, onPaste, resize, noop, Generators.modification);
    var pasteColsBefore = run(opPasteColsBefore, pasteColumnsExtractor(true), noop, noop, Generators.modification);
    var pasteColsAfter = run(opPasteColsAfter, pasteColumnsExtractor(false), noop, noop, Generators.modification);
    var pasteRowsBefore = run(opPasteRowsBefore, onPasteByEditor, noop, noop, Generators.modification);
    var pasteRowsAfter = run(opPasteRowsAfter, onPasteByEditor, noop, noop, Generators.modification);
    var getColumnsType = opGetColumnsType;
    var getCellsType = opGetCellsType;
    var getRowsType = opGetRowsType;

    var TableActions = function (editor, cellSelection, lazyWire) {
      var isTableBody = function (editor) {
        return name(getBody(editor)) === 'table';
      };
      var lastRowGuard = function (table) {
        return isTableBody(editor) === false || getGridSize(table).rows > 1;
      };
      var lastColumnGuard = function (table) {
        return isTableBody(editor) === false || getGridSize(table).columns > 1;
      };
      var cloneFormats = getCloneElements(editor);
      var colMutationOp = isResizeTableColumnResizing(editor) ? noop : halve;
      var getTableSectionType = function (table) {
        switch (getTableHeaderType(editor)) {
        case 'section':
          return TableSection.section();
        case 'sectionCells':
          return TableSection.sectionCells();
        case 'cells':
          return TableSection.cells();
        default:
          return TableSection.getTableSectionType(table, 'section');
        }
      };
      var setSelectionFromAction = function (table, result) {
        return result.cursor.fold(function () {
          var cells = cells$1(table);
          return head(cells).filter(inBody).map(function (firstCell) {
            cellSelection.clear(table);
            var rng = editor.dom.createRng();
            rng.selectNode(firstCell.dom);
            editor.selection.setRng(rng);
            set$2(firstCell, 'data-mce-selected', '1');
            return rng;
          });
        }, function (cell) {
          var des = freefallRtl(cell);
          var rng = editor.dom.createRng();
          rng.setStart(des.element.dom, des.offset);
          rng.setEnd(des.element.dom, des.offset);
          editor.selection.setRng(rng);
          cellSelection.clear(table);
          return Optional.some(rng);
        });
      };
      var execute = function (operation, guard, mutate, lazyWire, effect) {
        return function (table, target, noEvents) {
          if (noEvents === void 0) {
            noEvents = false;
          }
          removeDataStyle(table);
          var wire = lazyWire();
          var doc = SugarElement.fromDom(editor.getDoc());
          var generators = cellOperations(mutate, doc, cloneFormats);
          var behaviours = {
            sizing: get$4(editor, table),
            resize: isResizeTableColumnResizing(editor) ? resizeTable() : preserveTable(),
            section: getTableSectionType(table)
          };
          return guard(table) ? operation(wire, table, target, generators, behaviours).bind(function (result) {
            each$2(result.newRows, function (row) {
              fireNewRow(editor, row.dom);
            });
            each$2(result.newCells, function (cell) {
              fireNewCell(editor, cell.dom);
            });
            var range = setSelectionFromAction(table, result);
            if (inBody(table)) {
              removeDataStyle(table);
              if (!noEvents) {
                fireTableModified(editor, table.dom, effect);
              }
            }
            return range.map(function (rng) {
              return {
                rng: rng,
                effect: effect
              };
            });
          }) : Optional.none();
        };
      };
      var deleteRow = execute(eraseRows, lastRowGuard, noop, lazyWire, structureModified);
      var deleteColumn = execute(eraseColumns, lastColumnGuard, noop, lazyWire, structureModified);
      var insertRowsBefore$1 = execute(insertRowsBefore, always, noop, lazyWire, structureModified);
      var insertRowsAfter$1 = execute(insertRowsAfter, always, noop, lazyWire, structureModified);
      var insertColumnsBefore$1 = execute(insertColumnsBefore, always, colMutationOp, lazyWire, structureModified);
      var insertColumnsAfter$1 = execute(insertColumnsAfter, always, colMutationOp, lazyWire, structureModified);
      var mergeCells$1 = execute(mergeCells, always, noop, lazyWire, structureModified);
      var unmergeCells$1 = execute(unmergeCells, always, noop, lazyWire, structureModified);
      var pasteColsBefore$1 = execute(pasteColsBefore, always, noop, lazyWire, structureModified);
      var pasteColsAfter$1 = execute(pasteColsAfter, always, noop, lazyWire, structureModified);
      var pasteRowsBefore$1 = execute(pasteRowsBefore, always, noop, lazyWire, structureModified);
      var pasteRowsAfter$1 = execute(pasteRowsAfter, always, noop, lazyWire, structureModified);
      var pasteCells$1 = execute(pasteCells, always, noop, lazyWire, styleAndStructureModified);
      var makeCellsHeader$1 = execute(makeCellsHeader, always, noop, lazyWire, structureModified);
      var unmakeCellsHeader$1 = execute(unmakeCellsHeader, always, noop, lazyWire, structureModified);
      var makeColumnsHeader$1 = execute(makeColumnsHeader, always, noop, lazyWire, structureModified);
      var unmakeColumnsHeader$1 = execute(unmakeColumnsHeader, always, noop, lazyWire, structureModified);
      var makeRowsHeader$1 = execute(makeRowsHeader, always, noop, lazyWire, structureModified);
      var makeRowsBody$1 = execute(makeRowsBody, always, noop, lazyWire, structureModified);
      var makeRowsFooter$1 = execute(makeRowsFooter, always, noop, lazyWire, structureModified);
      var getTableCellType = getCellsType;
      var getTableColType = getColumnsType;
      var getTableRowType = getRowsType;
      return {
        deleteRow: deleteRow,
        deleteColumn: deleteColumn,
        insertRowsBefore: insertRowsBefore$1,
        insertRowsAfter: insertRowsAfter$1,
        insertColumnsBefore: insertColumnsBefore$1,
        insertColumnsAfter: insertColumnsAfter$1,
        mergeCells: mergeCells$1,
        unmergeCells: unmergeCells$1,
        pasteColsBefore: pasteColsBefore$1,
        pasteColsAfter: pasteColsAfter$1,
        pasteRowsBefore: pasteRowsBefore$1,
        pasteRowsAfter: pasteRowsAfter$1,
        pasteCells: pasteCells$1,
        makeCellsHeader: makeCellsHeader$1,
        unmakeCellsHeader: unmakeCellsHeader$1,
        makeColumnsHeader: makeColumnsHeader$1,
        unmakeColumnsHeader: unmakeColumnsHeader$1,
        makeRowsHeader: makeRowsHeader$1,
        makeRowsBody: makeRowsBody$1,
        makeRowsFooter: makeRowsFooter$1,
        getTableRowType: getTableRowType,
        getTableCellType: getTableCellType,
        getTableColType: getTableColType
      };
    };

    var DefaultRenderOptions = {
      styles: {
        'border-collapse': 'collapse',
        'width': '100%'
      },
      attributes: { border: '1' },
      colGroups: false
    };
    var tableHeaderCell = function () {
      return SugarElement.fromTag('th');
    };
    var tableCell = function () {
      return SugarElement.fromTag('td');
    };
    var tableColumn = function () {
      return SugarElement.fromTag('col');
    };
    var createRow = function (columns, rowHeaders, columnHeaders, rowIndex) {
      var tr = SugarElement.fromTag('tr');
      for (var j = 0; j < columns; j++) {
        var td = rowIndex < rowHeaders || j < columnHeaders ? tableHeaderCell() : tableCell();
        if (j < columnHeaders) {
          set$2(td, 'scope', 'row');
        }
        if (rowIndex < rowHeaders) {
          set$2(td, 'scope', 'col');
        }
        append$1(td, SugarElement.fromTag('br'));
        append$1(tr, td);
      }
      return tr;
    };
    var createGroupRow = function (columns) {
      var columnGroup = SugarElement.fromTag('colgroup');
      range$1(columns, function () {
        return append$1(columnGroup, tableColumn());
      });
      return columnGroup;
    };
    var createRows = function (rows, columns, rowHeaders, columnHeaders) {
      return range$1(rows, function (r) {
        return createRow(columns, rowHeaders, columnHeaders, r);
      });
    };
    var render = function (rows, columns, rowHeaders, columnHeaders, headerType, renderOpts) {
      if (renderOpts === void 0) {
        renderOpts = DefaultRenderOptions;
      }
      var table = SugarElement.fromTag('table');
      var rowHeadersGoInThead = headerType !== 'cells';
      setAll(table, renderOpts.styles);
      setAll$1(table, renderOpts.attributes);
      if (renderOpts.colGroups) {
        append$1(table, createGroupRow(columns));
      }
      var actualRowHeaders = Math.min(rows, rowHeaders);
      if (rowHeadersGoInThead && rowHeaders > 0) {
        var thead = SugarElement.fromTag('thead');
        append$1(table, thead);
        var theadRowHeaders = headerType === 'sectionCells' ? actualRowHeaders : 0;
        var theadRows = createRows(rowHeaders, columns, theadRowHeaders, columnHeaders);
        append(thead, theadRows);
      }
      var tbody = SugarElement.fromTag('tbody');
      append$1(table, tbody);
      var numRows = rowHeadersGoInThead ? rows - actualRowHeaders : rows;
      var numRowHeaders = rowHeadersGoInThead ? 0 : rowHeaders;
      var tbodyRows = createRows(numRows, columns, numRowHeaders, columnHeaders);
      append(tbody, tbodyRows);
      return table;
    };

    var get$2 = function (element) {
      return element.dom.innerHTML;
    };
    var getOuter = function (element) {
      var container = SugarElement.fromTag('div');
      var clone = SugarElement.fromDom(element.dom.cloneNode(true));
      append$1(container, clone);
      return get$2(container);
    };

    var placeCaretInCell = function (editor, cell) {
      editor.selection.select(cell.dom, true);
      editor.selection.collapse(true);
    };
    var selectFirstCellInTable = function (editor, tableElm) {
      descendant(tableElm, 'td,th').each(curry(placeCaretInCell, editor));
    };
    var fireEvents = function (editor, table) {
      each$2(descendants(table, 'tr'), function (row) {
        fireNewRow(editor, row.dom);
        each$2(descendants(row, 'th,td'), function (cell) {
          fireNewCell(editor, cell.dom);
        });
      });
    };
    var isPercentage = function (width) {
      return isString(width) && width.indexOf('%') !== -1;
    };
    var insert = function (editor, columns, rows, colHeaders, rowHeaders) {
      var defaultStyles = getDefaultStyles(editor);
      var options = {
        styles: defaultStyles,
        attributes: getDefaultAttributes(editor),
        colGroups: useColumnGroup(editor)
      };
      editor.undoManager.ignore(function () {
        var table = render(rows, columns, rowHeaders, colHeaders, getTableHeaderType(editor), options);
        set$2(table, 'data-mce-id', '__mce');
        var html = getOuter(table);
        editor.insertContent(html);
        editor.addVisual();
      });
      return descendant(getBody(editor), 'table[data-mce-id="__mce"]').map(function (table) {
        if (isPixelsForced(editor)) {
          enforcePixels(table);
        } else if (isResponsiveForced(editor)) {
          enforceNone(table);
        } else if (isPercentagesForced(editor) || isPercentage(defaultStyles.width)) {
          enforcePercentage(table);
        }
        removeDataStyle(table);
        remove$7(table, 'data-mce-id');
        fireEvents(editor, table);
        selectFirstCellInTable(editor, table);
        return table.dom;
      }).getOr(null);
    };
    var insertTableWithDataValidation = function (editor, rows, columns, options, errorMsg) {
      if (options === void 0) {
        options = {};
      }
      var checkInput = function (val) {
        return isNumber(val) && val > 0;
      };
      if (checkInput(rows) && checkInput(columns)) {
        var headerRows = options.headerRows || 0;
        var headerColumns = options.headerColumns || 0;
        return insert(editor, columns, rows, headerColumns, headerRows);
      } else {
        console.error(errorMsg);
        return null;
      }
    };

    var getClipboardElements = function (getClipboard) {
      return function () {
        return getClipboard().fold(function () {
          return [];
        }, function (elems) {
          return map$1(elems, function (e) {
            return e.dom;
          });
        });
      };
    };
    var setClipboardElements = function (setClipboard) {
      return function (elems) {
        var elmsOpt = elems.length > 0 ? Optional.some(fromDom(elems)) : Optional.none();
        setClipboard(elmsOpt);
      };
    };
    var insertTable = function (editor) {
      return function (columns, rows, options) {
        if (options === void 0) {
          options = {};
        }
        var table = insertTableWithDataValidation(editor, rows, columns, options, 'Invalid values for insertTable - rows and columns values are required to insert a table.');
        editor.undoManager.add();
        return table;
      };
    };
    var getApi = function (editor, clipboard, resizeHandler, selectionTargets) {
      return {
        insertTable: insertTable(editor),
        setClipboardRows: setClipboardElements(clipboard.setRows),
        getClipboardRows: getClipboardElements(clipboard.getRows),
        setClipboardCols: setClipboardElements(clipboard.setColumns),
        getClipboardCols: getClipboardElements(clipboard.getColumns),
        resizeHandler: resizeHandler,
        selectionTargets: selectionTargets
      };
    };

    var constrainSpan = function (element, property, value) {
      var currentColspan = getAttrValue(element, property, 1);
      if (value === 1 || currentColspan <= 1) {
        remove$7(element, property);
      } else {
        set$2(element, property, Math.min(value, currentColspan));
      }
    };
    var generateColGroup = function (house, minColRange, maxColRange) {
      if (Warehouse.hasColumns(house)) {
        var colsToCopy = filter$2(Warehouse.justColumns(house), function (col) {
          return col.column >= minColRange && col.column < maxColRange;
        });
        var copiedCols = map$1(colsToCopy, function (c) {
          var clonedCol = deep(c.element);
          constrainSpan(clonedCol, 'span', maxColRange - minColRange);
          return clonedCol;
        });
        var fakeColgroup = SugarElement.fromTag('colgroup');
        append(fakeColgroup, copiedCols);
        return [fakeColgroup];
      } else {
        return [];
      }
    };
    var generateRows = function (house, minColRange, maxColRange) {
      return map$1(house.all, function (row) {
        var cellsToCopy = filter$2(row.cells, function (cell) {
          return cell.column >= minColRange && cell.column < maxColRange;
        });
        var copiedCells = map$1(cellsToCopy, function (cell) {
          var clonedCell = deep(cell.element);
          constrainSpan(clonedCell, 'colspan', maxColRange - minColRange);
          return clonedCell;
        });
        var fakeTR = SugarElement.fromTag('tr');
        append(fakeTR, copiedCells);
        return fakeTR;
      });
    };
    var copyCols = function (table, target) {
      var house = Warehouse.fromTable(table);
      var details = onUnlockedCells(house, target);
      return details.map(function (selectedCells) {
        var lastSelectedCell = selectedCells[selectedCells.length - 1];
        var minColRange = selectedCells[0].column;
        var maxColRange = lastSelectedCell.column + lastSelectedCell.colspan;
        var fakeColGroups = generateColGroup(house, minColRange, maxColRange);
        var fakeRows = generateRows(house, minColRange, maxColRange);
        return __spreadArray(__spreadArray([], fakeColGroups, true), fakeRows, true);
      });
    };

    var copyRows = function (table, target, generators) {
      var warehouse = Warehouse.fromTable(table);
      var details = onCells(warehouse, target);
      return details.bind(function (selectedCells) {
        var grid = toGrid(warehouse, generators, false);
        var rows = extractGridDetails(grid).rows;
        var slicedGrid = rows.slice(selectedCells[0].row, selectedCells[selectedCells.length - 1].row + selectedCells[selectedCells.length - 1].rowspan);
        var filteredGrid = bind$2(slicedGrid, function (row) {
          var newCells = filter$2(row.cells, function (cell) {
            return !cell.isLocked;
          });
          return newCells.length > 0 ? [__assign(__assign({}, row), { cells: newCells })] : [];
        });
        var slicedDetails = toDetailList(filteredGrid);
        return someIf(slicedDetails.length > 0, slicedDetails);
      }).map(function (slicedDetails) {
        return copy(slicedDetails);
      });
    };

    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var getTDTHOverallStyle = function (dom, elm, name) {
      var cells = dom.select('td,th', elm);
      var firstChildStyle;
      var checkChildren = function (firstChildStyle, elms) {
        for (var i = 0; i < elms.length; i++) {
          var currentStyle = dom.getStyle(elms[i], name);
          if (typeof firstChildStyle === 'undefined') {
            firstChildStyle = currentStyle;
          }
          if (firstChildStyle !== currentStyle) {
            return '';
          }
        }
        return firstChildStyle;
      };
      return checkChildren(firstChildStyle, cells);
    };
    var applyAlign = function (editor, elm, name) {
      if (name) {
        editor.formatter.apply('align' + name, {}, elm);
      }
    };
    var applyVAlign = function (editor, elm, name) {
      if (name) {
        editor.formatter.apply('valign' + name, {}, elm);
      }
    };
    var unApplyAlign = function (editor, elm) {
      global$2.each('left center right'.split(' '), function (name) {
        editor.formatter.remove('align' + name, {}, elm);
      });
    };
    var unApplyVAlign = function (editor, elm) {
      global$2.each('top middle bottom'.split(' '), function (name) {
        editor.formatter.remove('valign' + name, {}, elm);
      });
    };

    var verticalAlignValues = [
      {
        text: 'None',
        value: ''
      },
      {
        text: 'Top',
        value: 'top'
      },
      {
        text: 'Middle',
        value: 'middle'
      },
      {
        text: 'Bottom',
        value: 'bottom'
      }
    ];

    var hexColour = function (value) {
      return { value: value };
    };
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    var longformRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
    var isHexString = function (hex) {
      return shorthandRegex.test(hex) || longformRegex.test(hex);
    };
    var normalizeHex = function (hex) {
      return removeLeading(hex, '#').toUpperCase();
    };
    var fromString$1 = function (hex) {
      return isHexString(hex) ? Optional.some({ value: normalizeHex(hex) }) : Optional.none();
    };
    var toHex = function (component) {
      var hex = component.toString(16);
      return (hex.length === 1 ? '0' + hex : hex).toUpperCase();
    };
    var fromRgba = function (rgbaColour) {
      var value = toHex(rgbaColour.red) + toHex(rgbaColour.green) + toHex(rgbaColour.blue);
      return hexColour(value);
    };

    var rgbRegex = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)/;
    var rgbaRegex = /^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d?(?:\.\d+)?)\)/;
    var rgbaColour = function (red, green, blue, alpha) {
      return {
        red: red,
        green: green,
        blue: blue,
        alpha: alpha
      };
    };
    var fromStringValues = function (red, green, blue, alpha) {
      var r = parseInt(red, 10);
      var g = parseInt(green, 10);
      var b = parseInt(blue, 10);
      var a = parseFloat(alpha);
      return rgbaColour(r, g, b, a);
    };
    var fromString = function (rgbaString) {
      if (rgbaString === 'transparent') {
        return Optional.some(rgbaColour(0, 0, 0, 0));
      }
      var rgbMatch = rgbRegex.exec(rgbaString);
      if (rgbMatch !== null) {
        return Optional.some(fromStringValues(rgbMatch[1], rgbMatch[2], rgbMatch[3], '1'));
      }
      var rgbaMatch = rgbaRegex.exec(rgbaString);
      if (rgbaMatch !== null) {
        return Optional.some(fromStringValues(rgbaMatch[1], rgbaMatch[2], rgbaMatch[3], rgbaMatch[4]));
      }
      return Optional.none();
    };

    var anyToHex = function (color) {
      return fromString$1(color).orThunk(function () {
        return fromString(color).map(fromRgba);
      }).getOrThunk(function () {
        var canvas = document.createElement('canvas');
        canvas.height = 1;
        canvas.width = 1;
        var canvasContext = canvas.getContext('2d');
        canvasContext.clearRect(0, 0, canvas.width, canvas.height);
        canvasContext.fillStyle = '#FFFFFF';
        canvasContext.fillStyle = color;
        canvasContext.fillRect(0, 0, 1, 1);
        var rgba = canvasContext.getImageData(0, 0, 1, 1).data;
        var r = rgba[0];
        var g = rgba[1];
        var b = rgba[2];
        var a = rgba[3];
        return fromRgba(rgbaColour(r, g, b, a));
      });
    };

    var Cell = function (initial) {
      var value = initial;
      var get = function () {
        return value;
      };
      var set = function (v) {
        value = v;
      };
      return {
        get: get,
        set: set
      };
    };

    var singleton = function (doRevoke) {
      var subject = Cell(Optional.none());
      var revoke = function () {
        return subject.get().each(doRevoke);
      };
      var clear = function () {
        revoke();
        subject.set(Optional.none());
      };
      var isSet = function () {
        return subject.get().isSome();
      };
      var get = function () {
        return subject.get();
      };
      var set = function (s) {
        revoke();
        subject.set(Optional.some(s));
      };
      return {
        clear: clear,
        isSet: isSet,
        get: get,
        set: set
      };
    };
    var unbindable = function () {
      return singleton(function (s) {
        return s.unbind();
      });
    };
    var value = function () {
      var subject = singleton(noop);
      var on = function (f) {
        return subject.get().each(f);
      };
      return __assign(__assign({}, subject), { on: on });
    };

    var onSetupToggle = function (editor, selections, formatName, formatValue) {
      return function (api) {
        var boundCallback = unbindable();
        var isNone = isEmpty$1(formatValue);
        var init = function () {
          var selectedCells = getCellsFromSelection(selections);
          var checkNode = function (cell) {
            return editor.formatter.match(formatName, { value: formatValue }, cell.dom, isNone);
          };
          if (isNone) {
            api.setActive(!exists(selectedCells, checkNode));
            boundCallback.set(editor.formatter.formatChanged(formatName, function (match) {
              return api.setActive(!match);
            }, true));
          } else {
            api.setActive(forall(selectedCells, checkNode));
            boundCallback.set(editor.formatter.formatChanged(formatName, api.setActive, false, { value: formatValue }));
          }
        };
        editor.initialized ? init() : editor.on('init', init);
        return boundCallback.clear;
      };
    };
    var isListGroup = function (item) {
      return hasNonNullableKey(item, 'menu');
    };
    var buildListItems = function (items) {
      return map$1(items, function (item) {
        var text = item.text || item.title;
        if (isListGroup(item)) {
          return {
            text: text,
            items: buildListItems(item.menu)
          };
        } else {
          return {
            text: text,
            value: item.value
          };
        }
      });
    };
    var buildMenuItems = function (editor, selections, items, format, onAction) {
      return map$1(items, function (item) {
        var text = item.text || item.title;
        if (isListGroup(item)) {
          return {
            type: 'nestedmenuitem',
            text: text,
            getSubmenuItems: function () {
              return buildMenuItems(editor, selections, item.menu, format, onAction);
            }
          };
        } else {
          return {
            text: text,
            type: 'togglemenuitem',
            onAction: function () {
              return onAction(item.value);
            },
            onSetup: onSetupToggle(editor, selections, format, item.value)
          };
        }
      });
    };
    var applyTableCellStyle = function (editor, style) {
      return function (value) {
        var _a;
        editor.execCommand('mceTableApplyCellStyle', false, (_a = {}, _a[style] = value, _a));
      };
    };
    var filterNoneItem = function (list) {
      return bind$2(list, function (item) {
        if (isListGroup(item)) {
          return [__assign(__assign({}, item), { menu: filterNoneItem(item.menu) })];
        } else {
          return isNotEmpty(item.value) ? [item] : [];
        }
      });
    };
    var generateMenuItemsCallback = function (editor, selections, items, format, onAction) {
      return function (callback) {
        return callback(buildMenuItems(editor, selections, items, format, onAction));
      };
    };
    var buildColorMenu = function (editor, colorList, style) {
      var colorMap = map$1(colorList, function (entry) {
        return {
          text: entry.title,
          value: '#' + anyToHex(entry.value).value,
          type: 'choiceitem'
        };
      });
      return [{
          type: 'fancymenuitem',
          fancytype: 'colorswatch',
          initData: {
            colors: colorMap.length > 0 ? colorMap : undefined,
            allowCustomColors: false
          },
          onAction: function (data) {
            var _a;
            var value = data.value === 'remove' ? '' : data.value;
            editor.execCommand('mceTableApplyCellStyle', false, (_a = {}, _a[style] = value, _a));
          }
        }];
    };
    var changeRowHeader = function (editor) {
      return function () {
        var currentType = editor.queryCommandValue('mceTableRowType');
        var newType = currentType === 'header' ? 'body' : 'header';
        editor.execCommand('mceTableRowType', false, { type: newType });
      };
    };
    var changeColumnHeader = function (editor) {
      return function () {
        var currentType = editor.queryCommandValue('mceTableColType');
        var newType = currentType === 'th' ? 'td' : 'th';
        editor.execCommand('mceTableColType', false, { type: newType });
      };
    };

    var getClassList$1 = function (editor) {
      var classes = buildListItems(getCellClassList(editor));
      if (classes.length > 0) {
        return Optional.some({
          name: 'class',
          type: 'listbox',
          label: 'Class',
          items: classes
        });
      }
      return Optional.none();
    };
    var children = [
      {
        name: 'width',
        type: 'input',
        label: 'Width'
      },
      {
        name: 'height',
        type: 'input',
        label: 'Height'
      },
      {
        name: 'celltype',
        type: 'listbox',
        label: 'Cell type',
        items: [
          {
            text: 'Cell',
            value: 'td'
          },
          {
            text: 'Header cell',
            value: 'th'
          }
        ]
      },
      {
        name: 'scope',
        type: 'listbox',
        label: 'Scope',
        items: [
          {
            text: 'None',
            value: ''
          },
          {
            text: 'Row',
            value: 'row'
          },
          {
            text: 'Column',
            value: 'col'
          },
          {
            text: 'Row group',
            value: 'rowgroup'
          },
          {
            text: 'Column group',
            value: 'colgroup'
          }
        ]
      },
      {
        name: 'halign',
        type: 'listbox',
        label: 'Horizontal align',
        items: [
          {
            text: 'None',
            value: ''
          },
          {
            text: 'Left',
            value: 'left'
          },
          {
            text: 'Center',
            value: 'center'
          },
          {
            text: 'Right',
            value: 'right'
          }
        ]
      },
      {
        name: 'valign',
        type: 'listbox',
        label: 'Vertical align',
        items: verticalAlignValues
      }
    ];
    var getItems$2 = function (editor) {
      return children.concat(getClassList$1(editor).toArray());
    };

    var getAdvancedTab = function (editor, dialogName) {
      var emptyBorderStyle = [{
          text: 'Select...',
          value: ''
        }];
      var advTabItems = [
        {
          name: 'borderstyle',
          type: 'listbox',
          label: 'Border style',
          items: emptyBorderStyle.concat(buildListItems(getTableBorderStyles(editor)))
        },
        {
          name: 'bordercolor',
          type: 'colorinput',
          label: 'Border color'
        },
        {
          name: 'backgroundcolor',
          type: 'colorinput',
          label: 'Background color'
        }
      ];
      var borderWidth = {
        name: 'borderwidth',
        type: 'input',
        label: 'Border width'
      };
      var items = dialogName === 'cell' ? [borderWidth].concat(advTabItems) : advTabItems;
      return {
        title: 'Advanced',
        name: 'advanced',
        items: items
      };
    };

    var modifiers = function (testTruthy) {
      return function (editor, node) {
        var dom = editor.dom;
        var setAttrib = function (attr, value) {
          if (!testTruthy || value) {
            dom.setAttrib(node, attr, value);
          }
        };
        var setStyle = function (prop, value) {
          if (!testTruthy || value) {
            dom.setStyle(node, prop, value);
          }
        };
        var setFormat = function (formatName, value) {
          if (!testTruthy || value) {
            if (value === '') {
              editor.formatter.remove(formatName, { value: null }, node, true);
            } else {
              editor.formatter.apply(formatName, { value: value }, node);
            }
          }
        };
        return {
          setAttrib: setAttrib,
          setStyle: setStyle,
          setFormat: setFormat
        };
      };
    };
    var DomModifier = {
      normal: modifiers(false),
      ifTruthy: modifiers(true)
    };

    var rgbToHex = function (dom) {
      return function (value) {
        return startsWith(value, 'rgb') ? dom.toHex(value) : value;
      };
    };
    var extractAdvancedStyles = function (dom, elm) {
      var element = SugarElement.fromDom(elm);
      return {
        borderwidth: getRaw$2(element, 'border-width').getOr(''),
        borderstyle: getRaw$2(element, 'border-style').getOr(''),
        bordercolor: getRaw$2(element, 'border-color').map(rgbToHex(dom)).getOr(''),
        backgroundcolor: getRaw$2(element, 'background-color').map(rgbToHex(dom)).getOr('')
      };
    };
    var getSharedValues = function (data) {
      var baseData = data[0];
      var comparisonData = data.slice(1);
      each$2(comparisonData, function (items) {
        each$2(keys(baseData), function (key) {
          each$1(items, function (itemValue, itemKey) {
            var comparisonValue = baseData[key];
            if (comparisonValue !== '' && key === itemKey) {
              if (comparisonValue !== itemValue) {
                baseData[key] = '';
              }
            }
          });
        });
      });
      return baseData;
    };
    var getAlignment = function (formats, formatName, editor, elm) {
      return find$1(formats, function (name) {
        return !isUndefined(editor.formatter.matchNode(elm, formatName + name));
      }).getOr('');
    };
    var getHAlignment = curry(getAlignment, [
      'left',
      'center',
      'right'
    ], 'align');
    var getVAlignment = curry(getAlignment, [
      'top',
      'middle',
      'bottom'
    ], 'valign');
    var extractDataFromSettings = function (editor, hasAdvTableTab) {
      var style = getDefaultStyles(editor);
      var attrs = getDefaultAttributes(editor);
      var extractAdvancedStyleData = function (dom) {
        return {
          borderstyle: get$c(style, 'border-style').getOr(''),
          bordercolor: rgbToHex(dom)(get$c(style, 'border-color').getOr('')),
          backgroundcolor: rgbToHex(dom)(get$c(style, 'background-color').getOr(''))
        };
      };
      var defaultData = {
        height: '',
        width: '100%',
        cellspacing: '',
        cellpadding: '',
        caption: false,
        class: '',
        align: '',
        border: ''
      };
      var getBorder = function () {
        var borderWidth = style['border-width'];
        if (shouldStyleWithCss(editor) && borderWidth) {
          return { border: borderWidth };
        }
        return get$c(attrs, 'border').fold(function () {
          return {};
        }, function (border) {
          return { border: border };
        });
      };
      var advStyle = hasAdvTableTab ? extractAdvancedStyleData(editor.dom) : {};
      var getCellPaddingCellSpacing = function () {
        var spacing = get$c(style, 'border-spacing').or(get$c(attrs, 'cellspacing')).fold(function () {
          return {};
        }, function (cellspacing) {
          return { cellspacing: cellspacing };
        });
        var padding = get$c(style, 'border-padding').or(get$c(attrs, 'cellpadding')).fold(function () {
          return {};
        }, function (cellpadding) {
          return { cellpadding: cellpadding };
        });
        return __assign(__assign({}, spacing), padding);
      };
      var data = __assign(__assign(__assign(__assign(__assign(__assign({}, defaultData), style), attrs), advStyle), getBorder()), getCellPaddingCellSpacing());
      return data;
    };
    var getRowType = function (elm) {
      return table(SugarElement.fromDom(elm)).map(function (table) {
        var target = { selection: fromDom(elm.cells) };
        return getRowsType(table, target);
      }).getOr('');
    };
    var extractDataFromTableElement = function (editor, elm, hasAdvTableTab) {
      var getBorder = function (dom, elm) {
        var optBorderWidth = getRaw$2(SugarElement.fromDom(elm), 'border-width');
        if (shouldStyleWithCss(editor) && optBorderWidth.isSome()) {
          return optBorderWidth.getOr('');
        }
        return dom.getAttrib(elm, 'border') || getTDTHOverallStyle(editor.dom, elm, 'border-width') || getTDTHOverallStyle(editor.dom, elm, 'border');
      };
      var dom = editor.dom;
      var cellspacing = shouldStyleWithCss(editor) ? dom.getStyle(elm, 'border-spacing') || dom.getAttrib(elm, 'cellspacing') : dom.getAttrib(elm, 'cellspacing') || dom.getStyle(elm, 'border-spacing');
      var cellpadding = shouldStyleWithCss(editor) ? getTDTHOverallStyle(dom, elm, 'padding') || dom.getAttrib(elm, 'cellpadding') : dom.getAttrib(elm, 'cellpadding') || getTDTHOverallStyle(dom, elm, 'padding');
      return __assign({
        width: dom.getStyle(elm, 'width') || dom.getAttrib(elm, 'width'),
        height: dom.getStyle(elm, 'height') || dom.getAttrib(elm, 'height'),
        cellspacing: cellspacing,
        cellpadding: cellpadding,
        border: getBorder(dom, elm),
        caption: !!dom.select('caption', elm)[0],
        class: dom.getAttrib(elm, 'class', ''),
        align: getHAlignment(editor, elm)
      }, hasAdvTableTab ? extractAdvancedStyles(dom, elm) : {});
    };
    var extractDataFromRowElement = function (editor, elm, hasAdvancedRowTab) {
      var dom = editor.dom;
      return __assign({
        height: dom.getStyle(elm, 'height') || dom.getAttrib(elm, 'height'),
        class: dom.getAttrib(elm, 'class', ''),
        type: getRowType(elm),
        align: getHAlignment(editor, elm)
      }, hasAdvancedRowTab ? extractAdvancedStyles(dom, elm) : {});
    };
    var extractDataFromCellElement = function (editor, cell, hasAdvancedCellTab, column) {
      var dom = editor.dom;
      var colElm = column.getOr(cell);
      var getStyle = function (element, style) {
        return dom.getStyle(element, style) || dom.getAttrib(element, style);
      };
      return __assign({
        width: getStyle(colElm, 'width'),
        height: getStyle(cell, 'height'),
        scope: dom.getAttrib(cell, 'scope'),
        celltype: getNodeName(cell),
        class: dom.getAttrib(cell, 'class', ''),
        halign: getHAlignment(editor, cell),
        valign: getVAlignment(editor, cell)
      }, hasAdvancedCellTab ? extractAdvancedStyles(dom, cell) : {});
    };

    var getSelectedCells = function (table, cells) {
      var warehouse = Warehouse.fromTable(table);
      var allCells = Warehouse.justCells(warehouse);
      var filtered = filter$2(allCells, function (cellA) {
        return exists(cells, function (cellB) {
          return eq$1(cellA.element, cellB);
        });
      });
      return map$1(filtered, function (cell) {
        return {
          element: cell.element.dom,
          column: Warehouse.getColumnAt(warehouse, cell.column).map(function (col) {
            return col.element.dom;
          })
        };
      });
    };
    var updateSimpleProps$1 = function (modifier, colModifier, data) {
      modifier.setAttrib('scope', data.scope);
      modifier.setAttrib('class', data.class);
      modifier.setStyle('height', addPxSuffix(data.height));
      colModifier.setStyle('width', addPxSuffix(data.width));
    };
    var updateAdvancedProps$1 = function (modifier, data) {
      modifier.setFormat('tablecellbackgroundcolor', data.backgroundcolor);
      modifier.setFormat('tablecellbordercolor', data.bordercolor);
      modifier.setFormat('tablecellborderstyle', data.borderstyle);
      modifier.setFormat('tablecellborderwidth', addPxSuffix(data.borderwidth));
    };
    var applyStyleData$1 = function (editor, cells, data) {
      var isSingleCell = cells.length === 1;
      each$2(cells, function (item) {
        var cellElm = item.element;
        var modifier = isSingleCell ? DomModifier.normal(editor, cellElm) : DomModifier.ifTruthy(editor, cellElm);
        var colModifier = item.column.map(function (col) {
          return isSingleCell ? DomModifier.normal(editor, col) : DomModifier.ifTruthy(editor, col);
        }).getOr(modifier);
        updateSimpleProps$1(modifier, colModifier, data);
        if (hasAdvancedCellTab(editor)) {
          updateAdvancedProps$1(modifier, data);
        }
        if (isSingleCell) {
          unApplyAlign(editor, cellElm);
          unApplyVAlign(editor, cellElm);
        }
        if (data.halign) {
          applyAlign(editor, cellElm, data.halign);
        }
        if (data.valign) {
          applyVAlign(editor, cellElm, data.valign);
        }
      });
    };
    var applyStructureData$1 = function (editor, data) {
      editor.execCommand('mceTableCellType', false, {
        type: data.celltype,
        no_events: true
      });
    };
    var applyCellData = function (editor, cells, oldData, data) {
      var modifiedData = filter$1(data, function (value, key) {
        return oldData[key] !== value;
      });
      if (size(modifiedData) > 0 && cells.length >= 1) {
        table(cells[0]).each(function (table) {
          var selectedCells = getSelectedCells(table, cells);
          var styleModified = size(filter$1(modifiedData, function (_value, key) {
            return key !== 'scope' && key !== 'celltype';
          })) > 0;
          var structureModified = has$1(modifiedData, 'celltype');
          if (styleModified || has$1(modifiedData, 'scope')) {
            applyStyleData$1(editor, selectedCells, data);
          }
          if (structureModified) {
            applyStructureData$1(editor, data);
          }
          fireTableModified(editor, table.dom, {
            structure: structureModified,
            style: styleModified
          });
        });
      }
    };
    var onSubmitCellForm = function (editor, cells, oldData, api) {
      var data = api.getData();
      api.close();
      editor.undoManager.transact(function () {
        applyCellData(editor, cells, oldData, data);
        editor.focus();
      });
    };
    var getData = function (editor, cells) {
      var cellsData = table(cells[0]).map(function (table) {
        return map$1(getSelectedCells(table, cells), function (item) {
          return extractDataFromCellElement(editor, item.element, hasAdvancedCellTab(editor), item.column);
        });
      });
      return getSharedValues(cellsData.getOrDie());
    };
    var open$2 = function (editor, selections) {
      var cells = getCellsFromSelection(selections);
      if (cells.length === 0) {
        return;
      }
      var data = getData(editor, cells);
      var dialogTabPanel = {
        type: 'tabpanel',
        tabs: [
          {
            title: 'General',
            name: 'general',
            items: getItems$2(editor)
          },
          getAdvancedTab(editor, 'cell')
        ]
      };
      var dialogPanel = {
        type: 'panel',
        items: [{
            type: 'grid',
            columns: 2,
            items: getItems$2(editor)
          }]
      };
      editor.windowManager.open({
        title: 'Cell Properties',
        size: 'normal',
        body: hasAdvancedCellTab(editor) ? dialogTabPanel : dialogPanel,
        buttons: [
          {
            type: 'cancel',
            name: 'cancel',
            text: 'Cancel'
          },
          {
            type: 'submit',
            name: 'save',
            text: 'Save',
            primary: true
          }
        ],
        initialData: data,
        onSubmit: curry(onSubmitCellForm, editor, cells, data)
      });
    };

    var getClassList = function (editor) {
      var classes = buildListItems(getRowClassList(editor));
      if (classes.length > 0) {
        return Optional.some({
          name: 'class',
          type: 'listbox',
          label: 'Class',
          items: classes
        });
      }
      return Optional.none();
    };
    var formChildren = [
      {
        type: 'listbox',
        name: 'type',
        label: 'Row type',
        items: [
          {
            text: 'Header',
            value: 'header'
          },
          {
            text: 'Body',
            value: 'body'
          },
          {
            text: 'Footer',
            value: 'footer'
          }
        ]
      },
      {
        type: 'listbox',
        name: 'align',
        label: 'Alignment',
        items: [
          {
            text: 'None',
            value: ''
          },
          {
            text: 'Left',
            value: 'left'
          },
          {
            text: 'Center',
            value: 'center'
          },
          {
            text: 'Right',
            value: 'right'
          }
        ]
      },
      {
        label: 'Height',
        name: 'height',
        type: 'input'
      }
    ];
    var getItems$1 = function (editor) {
      return formChildren.concat(getClassList(editor).toArray());
    };

    var updateSimpleProps = function (modifier, data) {
      modifier.setAttrib('class', data.class);
      modifier.setStyle('height', addPxSuffix(data.height));
    };
    var updateAdvancedProps = function (modifier, data) {
      modifier.setStyle('background-color', data.backgroundcolor);
      modifier.setStyle('border-color', data.bordercolor);
      modifier.setStyle('border-style', data.borderstyle);
    };
    var applyStyleData = function (editor, rows, data, oldData) {
      var isSingleRow = rows.length === 1;
      each$2(rows, function (rowElm) {
        var modifier = isSingleRow ? DomModifier.normal(editor, rowElm) : DomModifier.ifTruthy(editor, rowElm);
        updateSimpleProps(modifier, data);
        if (hasAdvancedRowTab(editor)) {
          updateAdvancedProps(modifier, data);
        }
        if (data.align !== oldData.align) {
          unApplyAlign(editor, rowElm);
          applyAlign(editor, rowElm, data.align);
        }
      });
    };
    var applyStructureData = function (editor, data) {
      editor.execCommand('mceTableRowType', false, {
        type: data.type,
        no_events: true
      });
    };
    var applyRowData = function (editor, rows, oldData, data) {
      var modifiedData = filter$1(data, function (value, key) {
        return oldData[key] !== value;
      });
      if (size(modifiedData) > 0) {
        var typeModified_1 = has$1(modifiedData, 'type');
        var styleModified_1 = typeModified_1 ? size(modifiedData) > 1 : true;
        if (styleModified_1) {
          applyStyleData(editor, rows, data, oldData);
        }
        if (typeModified_1) {
          applyStructureData(editor, data);
        }
        table(SugarElement.fromDom(rows[0])).each(function (table) {
          return fireTableModified(editor, table.dom, {
            structure: typeModified_1,
            style: styleModified_1
          });
        });
      }
    };
    var onSubmitRowForm = function (editor, rows, oldData, api) {
      var data = api.getData();
      api.close();
      editor.undoManager.transact(function () {
        applyRowData(editor, rows, oldData, data);
        editor.focus();
      });
    };
    var open$1 = function (editor) {
      var rows = getRowsFromSelection(getSelectionStart(editor), ephemera.selected);
      if (rows.length === 0) {
        return;
      }
      var rowsData = map$1(rows, function (rowElm) {
        return extractDataFromRowElement(editor, rowElm.dom, hasAdvancedRowTab(editor));
      });
      var data = getSharedValues(rowsData);
      var dialogTabPanel = {
        type: 'tabpanel',
        tabs: [
          {
            title: 'General',
            name: 'general',
            items: getItems$1(editor)
          },
          getAdvancedTab(editor, 'row')
        ]
      };
      var dialogPanel = {
        type: 'panel',
        items: [{
            type: 'grid',
            columns: 2,
            items: getItems$1(editor)
          }]
      };
      editor.windowManager.open({
        title: 'Row Properties',
        size: 'normal',
        body: hasAdvancedRowTab(editor) ? dialogTabPanel : dialogPanel,
        buttons: [
          {
            type: 'cancel',
            name: 'cancel',
            text: 'Cancel'
          },
          {
            type: 'submit',
            name: 'save',
            text: 'Save',
            primary: true
          }
        ],
        initialData: data,
        onSubmit: curry(onSubmitRowForm, editor, map$1(rows, function (r) {
          return r.dom;
        }), data)
      });
    };

    var getItems = function (editor, classes, insertNewTable) {
      var rowColCountItems = !insertNewTable ? [] : [
        {
          type: 'input',
          name: 'cols',
          label: 'Cols',
          inputMode: 'numeric'
        },
        {
          type: 'input',
          name: 'rows',
          label: 'Rows',
          inputMode: 'numeric'
        }
      ];
      var alwaysItems = [
        {
          type: 'input',
          name: 'width',
          label: 'Width'
        },
        {
          type: 'input',
          name: 'height',
          label: 'Height'
        }
      ];
      var appearanceItems = hasAppearanceOptions(editor) ? [
        {
          type: 'input',
          name: 'cellspacing',
          label: 'Cell spacing',
          inputMode: 'numeric'
        },
        {
          type: 'input',
          name: 'cellpadding',
          label: 'Cell padding',
          inputMode: 'numeric'
        },
        {
          type: 'input',
          name: 'border',
          label: 'Border width'
        },
        {
          type: 'label',
          label: 'Caption',
          items: [{
              type: 'checkbox',
              name: 'caption',
              label: 'Show caption'
            }]
        }
      ] : [];
      var alignmentItem = [{
          type: 'listbox',
          name: 'align',
          label: 'Alignment',
          items: [
            {
              text: 'None',
              value: ''
            },
            {
              text: 'Left',
              value: 'left'
            },
            {
              text: 'Center',
              value: 'center'
            },
            {
              text: 'Right',
              value: 'right'
            }
          ]
        }];
      var classListItem = classes.length > 0 ? [{
          type: 'listbox',
          name: 'class',
          label: 'Class',
          items: classes
        }] : [];
      return rowColCountItems.concat(alwaysItems).concat(appearanceItems).concat(alignmentItem).concat(classListItem);
    };

    var styleTDTH = function (dom, elm, name, value) {
      if (elm.tagName === 'TD' || elm.tagName === 'TH') {
        if (isString(name)) {
          dom.setStyle(elm, name, value);
        } else {
          dom.setStyle(elm, name);
        }
      } else {
        if (elm.children) {
          for (var i = 0; i < elm.children.length; i++) {
            styleTDTH(dom, elm.children[i], name, value);
          }
        }
      }
    };
    var applyDataToElement = function (editor, tableElm, data) {
      var dom = editor.dom;
      var attrs = {};
      var styles = {};
      attrs.class = data.class;
      styles.height = addPxSuffix(data.height);
      if (dom.getAttrib(tableElm, 'width') && !shouldStyleWithCss(editor)) {
        attrs.width = removePxSuffix(data.width);
      } else {
        styles.width = addPxSuffix(data.width);
      }
      if (shouldStyleWithCss(editor)) {
        styles['border-width'] = addPxSuffix(data.border);
        styles['border-spacing'] = addPxSuffix(data.cellspacing);
      } else {
        attrs.border = data.border;
        attrs.cellpadding = data.cellpadding;
        attrs.cellspacing = data.cellspacing;
      }
      if (shouldStyleWithCss(editor) && tableElm.children) {
        for (var i = 0; i < tableElm.children.length; i++) {
          styleTDTH(dom, tableElm.children[i], {
            'border-width': addPxSuffix(data.border),
            'padding': addPxSuffix(data.cellpadding)
          });
          if (hasAdvancedTableTab(editor)) {
            styleTDTH(dom, tableElm.children[i], { 'border-color': data.bordercolor });
          }
        }
      }
      if (hasAdvancedTableTab(editor)) {
        styles['background-color'] = data.backgroundcolor;
        styles['border-color'] = data.bordercolor;
        styles['border-style'] = data.borderstyle;
      }
      attrs.style = dom.serializeStyle(__assign(__assign({}, getDefaultStyles(editor)), styles));
      dom.setAttribs(tableElm, __assign(__assign({}, getDefaultAttributes(editor)), attrs));
    };
    var onSubmitTableForm = function (editor, tableElm, oldData, api) {
      var dom = editor.dom;
      var data = api.getData();
      var modifiedData = filter$1(data, function (value, key) {
        return oldData[key] !== value;
      });
      api.close();
      if (data.class === '') {
        delete data.class;
      }
      editor.undoManager.transact(function () {
        if (!tableElm) {
          var cols = parseInt(data.cols, 10) || 1;
          var rows = parseInt(data.rows, 10) || 1;
          tableElm = insert(editor, cols, rows, 0, 0);
        }
        if (size(modifiedData) > 0) {
          applyDataToElement(editor, tableElm, data);
          var captionElm = dom.select('caption', tableElm)[0];
          if (captionElm && !data.caption || !captionElm && data.caption) {
            editor.execCommand('mceTableToggleCaption');
          }
          if (data.align === '') {
            unApplyAlign(editor, tableElm);
          } else {
            applyAlign(editor, tableElm, data.align);
          }
        }
        editor.focus();
        editor.addVisual();
        if (size(modifiedData) > 0) {
          var captionModified = has$1(modifiedData, 'caption');
          var styleModified = captionModified ? size(modifiedData) > 1 : true;
          fireTableModified(editor, tableElm, {
            structure: captionModified,
            style: styleModified
          });
        }
      });
    };
    var open = function (editor, insertNewTable) {
      var dom = editor.dom;
      var tableElm;
      var data = extractDataFromSettings(editor, hasAdvancedTableTab(editor));
      if (insertNewTable === false) {
        tableElm = dom.getParent(editor.selection.getStart(), 'table', editor.getBody());
        if (tableElm) {
          data = extractDataFromTableElement(editor, tableElm, hasAdvancedTableTab(editor));
        } else {
          if (hasAdvancedTableTab(editor)) {
            data.borderstyle = '';
            data.bordercolor = '';
            data.backgroundcolor = '';
          }
        }
      } else {
        data.cols = '1';
        data.rows = '1';
        if (hasAdvancedTableTab(editor)) {
          data.borderstyle = '';
          data.bordercolor = '';
          data.backgroundcolor = '';
        }
      }
      var classes = buildListItems(getTableClassList(editor));
      if (classes.length > 0) {
        if (data.class) {
          data.class = data.class.replace(/\s*mce\-item\-table\s*/g, '');
        }
      }
      var generalPanel = {
        type: 'grid',
        columns: 2,
        items: getItems(editor, classes, insertNewTable)
      };
      var nonAdvancedForm = function () {
        return {
          type: 'panel',
          items: [generalPanel]
        };
      };
      var advancedForm = function () {
        return {
          type: 'tabpanel',
          tabs: [
            {
              title: 'General',
              name: 'general',
              items: [generalPanel]
            },
            getAdvancedTab(editor, 'table')
          ]
        };
      };
      var dialogBody = hasAdvancedTableTab(editor) ? advancedForm() : nonAdvancedForm();
      editor.windowManager.open({
        title: 'Table Properties',
        size: 'normal',
        body: dialogBody,
        onSubmit: curry(onSubmitTableForm, editor, tableElm, data),
        buttons: [
          {
            type: 'cancel',
            name: 'cancel',
            text: 'Cancel'
          },
          {
            type: 'submit',
            name: 'save',
            text: 'Save',
            primary: true
          }
        ],
        initialData: data
      });
    };

    var getSelectionStartCellOrCaption = function (editor) {
      return getSelectionCellOrCaption(getSelectionStart(editor), getIsRoot(editor));
    };
    var getSelectionStartCell = function (editor) {
      return getSelectionCell(getSelectionStart(editor), getIsRoot(editor));
    };
    var registerCommands = function (editor, actions, cellSelection, selections, clipboard) {
      var isRoot = getIsRoot(editor);
      var eraseTable = function () {
        return getSelectionStartCellOrCaption(editor).each(function (cellOrCaption) {
          table(cellOrCaption, isRoot).filter(not(isRoot)).each(function (table) {
            var cursor = SugarElement.fromText('');
            after$5(table, cursor);
            remove$5(table);
            if (editor.dom.isEmpty(editor.getBody())) {
              editor.setContent('');
              editor.selection.setCursorLocation();
            } else {
              var rng = editor.dom.createRng();
              rng.setStart(cursor.dom, 0);
              rng.setEnd(cursor.dom, 0);
              editor.selection.setRng(rng);
              editor.nodeChanged();
            }
          });
        });
      };
      var setSizingMode = function (sizing) {
        return getSelectionStartCellOrCaption(editor).each(function (cellOrCaption) {
          var isForcedSizing = isResponsiveForced(editor) || isPixelsForced(editor) || isPercentagesForced(editor);
          if (!isForcedSizing) {
            table(cellOrCaption, isRoot).each(function (table) {
              if (sizing === 'relative' && !isPercentSizing(table)) {
                enforcePercentage(table);
              } else if (sizing === 'fixed' && !isPixelSizing(table)) {
                enforcePixels(table);
              } else if (sizing === 'responsive' && !isNoneSizing(table)) {
                enforceNone(table);
              }
              removeDataStyle(table);
              fireTableModified(editor, table.dom, structureModified);
            });
          }
        });
      };
      var getTableFromCell = function (cell) {
        return table(cell, isRoot);
      };
      var performActionOnSelection = function (action) {
        return getSelectionStartCell(editor).bind(function (cell) {
          return getTableFromCell(cell).map(function (table) {
            return action(table, cell);
          });
        });
      };
      var toggleTableClass = function (_ui, clazz) {
        performActionOnSelection(function (table) {
          editor.formatter.toggle('tableclass', { value: clazz }, table.dom);
          fireTableModified(editor, table.dom, styleModified);
        });
      };
      var toggleTableCellClass = function (_ui, clazz) {
        performActionOnSelection(function (table) {
          var selectedCells = getCellsFromSelection(selections);
          var allHaveClass = forall(selectedCells, function (cell) {
            return editor.formatter.match('tablecellclass', { value: clazz }, cell.dom);
          });
          var formatterAction = allHaveClass ? editor.formatter.remove : editor.formatter.apply;
          each$2(selectedCells, function (cell) {
            return formatterAction('tablecellclass', { value: clazz }, cell.dom);
          });
          fireTableModified(editor, table.dom, styleModified);
        });
      };
      var toggleCaption = function () {
        getSelectionStartCellOrCaption(editor).each(function (cellOrCaption) {
          table(cellOrCaption, isRoot).each(function (table) {
            child$1(table, 'caption').fold(function () {
              var caption = SugarElement.fromTag('caption');
              append$1(caption, SugarElement.fromText('Caption'));
              appendAt(table, caption, 0);
              editor.selection.setCursorLocation(caption.dom, 0);
            }, function (caption) {
              if (isTag('caption')(cellOrCaption)) {
                one('td', table).each(function (td) {
                  return editor.selection.setCursorLocation(td.dom, 0);
                });
              }
              remove$5(caption);
            });
            fireTableModified(editor, table.dom, structureModified);
          });
        });
      };
      var postExecute = function (_data) {
        editor.focus();
      };
      var actOnSelection = function (execute, noEvents) {
        if (noEvents === void 0) {
          noEvents = false;
        }
        return performActionOnSelection(function (table, startCell) {
          var targets = forMenu(selections, table, startCell);
          execute(table, targets, noEvents).each(postExecute);
        });
      };
      var copyRowSelection = function () {
        return performActionOnSelection(function (table, startCell) {
          var targets = forMenu(selections, table, startCell);
          var generators = cellOperations(noop, SugarElement.fromDom(editor.getDoc()), Optional.none());
          return copyRows(table, targets, generators);
        });
      };
      var copyColSelection = function () {
        return performActionOnSelection(function (table, startCell) {
          var targets = forMenu(selections, table, startCell);
          return copyCols(table, targets);
        });
      };
      var pasteOnSelection = function (execute, getRows) {
        return getRows().each(function (rows) {
          var clonedRows = map$1(rows, function (row) {
            return deep(row);
          });
          performActionOnSelection(function (table, startCell) {
            var generators = paste$1(SugarElement.fromDom(editor.getDoc()));
            var targets = pasteRows(selections, startCell, clonedRows, generators);
            execute(table, targets).each(postExecute);
          });
        });
      };
      var actOnType = function (getAction) {
        return function (_ui, args) {
          return get$c(args, 'type').each(function (type) {
            actOnSelection(getAction(type), args.no_events);
          });
        };
      };
      each$1({
        mceTableSplitCells: function () {
          return actOnSelection(actions.unmergeCells);
        },
        mceTableMergeCells: function () {
          return actOnSelection(actions.mergeCells);
        },
        mceTableInsertRowBefore: function () {
          return actOnSelection(actions.insertRowsBefore);
        },
        mceTableInsertRowAfter: function () {
          return actOnSelection(actions.insertRowsAfter);
        },
        mceTableInsertColBefore: function () {
          return actOnSelection(actions.insertColumnsBefore);
        },
        mceTableInsertColAfter: function () {
          return actOnSelection(actions.insertColumnsAfter);
        },
        mceTableDeleteCol: function () {
          return actOnSelection(actions.deleteColumn);
        },
        mceTableDeleteRow: function () {
          return actOnSelection(actions.deleteRow);
        },
        mceTableCutCol: function () {
          return copyColSelection().each(function (selection) {
            clipboard.setColumns(selection);
            actOnSelection(actions.deleteColumn);
          });
        },
        mceTableCutRow: function () {
          return copyRowSelection().each(function (selection) {
            clipboard.setRows(selection);
            actOnSelection(actions.deleteRow);
          });
        },
        mceTableCopyCol: function () {
          return copyColSelection().each(function (selection) {
            return clipboard.setColumns(selection);
          });
        },
        mceTableCopyRow: function () {
          return copyRowSelection().each(function (selection) {
            return clipboard.setRows(selection);
          });
        },
        mceTablePasteColBefore: function () {
          return pasteOnSelection(actions.pasteColsBefore, clipboard.getColumns);
        },
        mceTablePasteColAfter: function () {
          return pasteOnSelection(actions.pasteColsAfter, clipboard.getColumns);
        },
        mceTablePasteRowBefore: function () {
          return pasteOnSelection(actions.pasteRowsBefore, clipboard.getRows);
        },
        mceTablePasteRowAfter: function () {
          return pasteOnSelection(actions.pasteRowsAfter, clipboard.getRows);
        },
        mceTableDelete: eraseTable,
        mceTableCellToggleClass: toggleTableCellClass,
        mceTableToggleClass: toggleTableClass,
        mceTableToggleCaption: toggleCaption,
        mceTableSizingMode: function (_ui, sizing) {
          return setSizingMode(sizing);
        },
        mceTableCellType: actOnType(function (type) {
          return type === 'th' ? actions.makeCellsHeader : actions.unmakeCellsHeader;
        }),
        mceTableColType: actOnType(function (type) {
          return type === 'th' ? actions.makeColumnsHeader : actions.unmakeColumnsHeader;
        }),
        mceTableRowType: actOnType(function (type) {
          switch (type) {
          case 'header':
            return actions.makeRowsHeader;
          case 'footer':
            return actions.makeRowsFooter;
          default:
            return actions.makeRowsBody;
          }
        })
      }, function (func, name) {
        return editor.addCommand(name, func);
      });
      each$1({
        mceTableProps: curry(open, editor, false),
        mceTableRowProps: curry(open$1, editor),
        mceTableCellProps: curry(open$2, editor, selections)
      }, function (func, name) {
        return editor.addCommand(name, function () {
          return func();
        });
      });
      editor.addCommand('mceInsertTable', function (_ui, args) {
        if (isObject(args) && keys(args).length > 0) {
          insertTableWithDataValidation(editor, args.rows, args.columns, args.options, 'Invalid values for mceInsertTable - rows and columns values are required to insert a table.');
        } else {
          open(editor, true);
        }
      });
      editor.addCommand('mceTableApplyCellStyle', function (_ui, args) {
        var getFormatName = function (style) {
          return 'tablecell' + style.toLowerCase().replace('-', '');
        };
        if (!isObject(args)) {
          return;
        }
        var cells = getCellsFromSelection(selections);
        if (cells.length === 0) {
          return;
        }
        var validArgs = filter$1(args, function (value, style) {
          return editor.formatter.has(getFormatName(style)) && isString(value);
        });
        if (isEmpty(validArgs)) {
          return;
        }
        each$1(validArgs, function (value, style) {
          each$2(cells, function (cell) {
            DomModifier.normal(editor, cell.dom).setFormat(getFormatName(style), value);
          });
        });
        getTableFromCell(cells[0]).each(function (table) {
          return fireTableModified(editor, table.dom, styleModified);
        });
      });
    };

    var registerQueryCommands = function (editor, actions, selections) {
      var isRoot = getIsRoot(editor);
      var lookupOnSelection = function (action) {
        return getSelectionCell(getSelectionStart(editor)).bind(function (cell) {
          return table(cell, isRoot).map(function (table) {
            var targets = forMenu(selections, table, cell);
            return action(table, targets);
          });
        }).getOr('');
      };
      each$1({
        mceTableRowType: function () {
          return lookupOnSelection(actions.getTableRowType);
        },
        mceTableCellType: function () {
          return lookupOnSelection(actions.getTableCellType);
        },
        mceTableColType: function () {
          return lookupOnSelection(actions.getTableColType);
        }
      }, function (func, name) {
        return editor.addQueryValueHandler(name, func);
      });
    };

    var Clipboard = function () {
      var rows = value();
      var cols = value();
      return {
        getRows: rows.get,
        setRows: function (r) {
          r.fold(rows.clear, rows.set);
          cols.clear();
        },
        clearRows: rows.clear,
        getColumns: cols.get,
        setColumns: function (c) {
          c.fold(cols.clear, cols.set);
          rows.clear();
        },
        clearColumns: cols.clear
      };
    };

    var genericBase = {
      remove_similar: true,
      inherit: false
    };
    var cellBase = __assign({ selector: 'td,th' }, genericBase);
    var cellFormats = {
      tablecellbackgroundcolor: __assign({ styles: { backgroundColor: '%value' } }, cellBase),
      tablecellverticalalign: __assign({ styles: { 'vertical-align': '%value' } }, cellBase),
      tablecellbordercolor: __assign({ styles: { borderColor: '%value' } }, cellBase),
      tablecellclass: __assign({ classes: ['%value'] }, cellBase),
      tableclass: __assign({
        selector: 'table',
        classes: ['%value']
      }, genericBase),
      tablecellborderstyle: __assign({ styles: { borderStyle: '%value' } }, cellBase),
      tablecellborderwidth: __assign({ styles: { borderWidth: '%value' } }, cellBase)
    };
    var registerFormats = function (editor) {
      editor.formatter.register(cellFormats);
    };

    var adt$5 = Adt.generate([
      { none: ['current'] },
      { first: ['current'] },
      {
        middle: [
          'current',
          'target'
        ]
      },
      { last: ['current'] }
    ]);
    var none = function (current) {
      if (current === void 0) {
        current = undefined;
      }
      return adt$5.none(current);
    };
    var CellLocation = __assign(__assign({}, adt$5), { none: none });

    var walk = function (all, current, index, direction, isEligible) {
      if (isEligible === void 0) {
        isEligible = always;
      }
      var forwards = direction === 1;
      if (!forwards && index <= 0) {
        return CellLocation.first(all[0]);
      } else if (forwards && index >= all.length - 1) {
        return CellLocation.last(all[all.length - 1]);
      } else {
        var newIndex = index + direction;
        var elem = all[newIndex];
        return isEligible(elem) ? CellLocation.middle(current, elem) : walk(all, current, newIndex, direction, isEligible);
      }
    };
    var detect$1 = function (current, isRoot) {
      return table(current, isRoot).bind(function (table) {
        var all = cells$1(table);
        var index = findIndex(all, function (x) {
          return eq$1(current, x);
        });
        return index.map(function (index) {
          return {
            index: index,
            all: all
          };
        });
      });
    };
    var next = function (current, isEligible, isRoot) {
      var detection = detect$1(current, isRoot);
      return detection.fold(function () {
        return CellLocation.none(current);
      }, function (info) {
        return walk(info.all, current, info.index, 1, isEligible);
      });
    };
    var prev = function (current, isEligible, isRoot) {
      var detection = detect$1(current, isRoot);
      return detection.fold(function () {
        return CellLocation.none();
      }, function (info) {
        return walk(info.all, current, info.index, -1, isEligible);
      });
    };

    var create$2 = function (start, soffset, finish, foffset) {
      return {
        start: start,
        soffset: soffset,
        finish: finish,
        foffset: foffset
      };
    };
    var SimRange = { create: create$2 };

    var adt$4 = Adt.generate([
      { before: ['element'] },
      {
        on: [
          'element',
          'offset'
        ]
      },
      { after: ['element'] }
    ]);
    var cata$1 = function (subject, onBefore, onOn, onAfter) {
      return subject.fold(onBefore, onOn, onAfter);
    };
    var getStart$1 = function (situ) {
      return situ.fold(identity, identity, identity);
    };
    var before$2 = adt$4.before;
    var on = adt$4.on;
    var after$3 = adt$4.after;
    var Situ = {
      before: before$2,
      on: on,
      after: after$3,
      cata: cata$1,
      getStart: getStart$1
    };

    var adt$3 = Adt.generate([
      { domRange: ['rng'] },
      {
        relative: [
          'startSitu',
          'finishSitu'
        ]
      },
      {
        exact: [
          'start',
          'soffset',
          'finish',
          'foffset'
        ]
      }
    ]);
    var exactFromRange = function (simRange) {
      return adt$3.exact(simRange.start, simRange.soffset, simRange.finish, simRange.foffset);
    };
    var getStart = function (selection) {
      return selection.match({
        domRange: function (rng) {
          return SugarElement.fromDom(rng.startContainer);
        },
        relative: function (startSitu, _finishSitu) {
          return Situ.getStart(startSitu);
        },
        exact: function (start, _soffset, _finish, _foffset) {
          return start;
        }
      });
    };
    var domRange = adt$3.domRange;
    var relative = adt$3.relative;
    var exact = adt$3.exact;
    var getWin = function (selection) {
      var start = getStart(selection);
      return defaultView(start);
    };
    var range = SimRange.create;
    var SimSelection = {
      domRange: domRange,
      relative: relative,
      exact: exact,
      exactFromRange: exactFromRange,
      getWin: getWin,
      range: range
    };

    var selectNode = function (win, element) {
      var rng = win.document.createRange();
      rng.selectNode(element.dom);
      return rng;
    };
    var selectNodeContents = function (win, element) {
      var rng = win.document.createRange();
      selectNodeContentsUsing(rng, element);
      return rng;
    };
    var selectNodeContentsUsing = function (rng, element) {
      return rng.selectNodeContents(element.dom);
    };
    var setStart = function (rng, situ) {
      situ.fold(function (e) {
        rng.setStartBefore(e.dom);
      }, function (e, o) {
        rng.setStart(e.dom, o);
      }, function (e) {
        rng.setStartAfter(e.dom);
      });
    };
    var setFinish = function (rng, situ) {
      situ.fold(function (e) {
        rng.setEndBefore(e.dom);
      }, function (e, o) {
        rng.setEnd(e.dom, o);
      }, function (e) {
        rng.setEndAfter(e.dom);
      });
    };
    var relativeToNative = function (win, startSitu, finishSitu) {
      var range = win.document.createRange();
      setStart(range, startSitu);
      setFinish(range, finishSitu);
      return range;
    };
    var exactToNative = function (win, start, soffset, finish, foffset) {
      var rng = win.document.createRange();
      rng.setStart(start.dom, soffset);
      rng.setEnd(finish.dom, foffset);
      return rng;
    };
    var toRect = function (rect) {
      return {
        left: rect.left,
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        width: rect.width,
        height: rect.height
      };
    };
    var getFirstRect$1 = function (rng) {
      var rects = rng.getClientRects();
      var rect = rects.length > 0 ? rects[0] : rng.getBoundingClientRect();
      return rect.width > 0 || rect.height > 0 ? Optional.some(rect).map(toRect) : Optional.none();
    };

    var adt$2 = Adt.generate([
      {
        ltr: [
          'start',
          'soffset',
          'finish',
          'foffset'
        ]
      },
      {
        rtl: [
          'start',
          'soffset',
          'finish',
          'foffset'
        ]
      }
    ]);
    var fromRange = function (win, type, range) {
      return type(SugarElement.fromDom(range.startContainer), range.startOffset, SugarElement.fromDom(range.endContainer), range.endOffset);
    };
    var getRanges = function (win, selection) {
      return selection.match({
        domRange: function (rng) {
          return {
            ltr: constant(rng),
            rtl: Optional.none
          };
        },
        relative: function (startSitu, finishSitu) {
          return {
            ltr: cached(function () {
              return relativeToNative(win, startSitu, finishSitu);
            }),
            rtl: cached(function () {
              return Optional.some(relativeToNative(win, finishSitu, startSitu));
            })
          };
        },
        exact: function (start, soffset, finish, foffset) {
          return {
            ltr: cached(function () {
              return exactToNative(win, start, soffset, finish, foffset);
            }),
            rtl: cached(function () {
              return Optional.some(exactToNative(win, finish, foffset, start, soffset));
            })
          };
        }
      });
    };
    var doDiagnose = function (win, ranges) {
      var rng = ranges.ltr();
      if (rng.collapsed) {
        var reversed = ranges.rtl().filter(function (rev) {
          return rev.collapsed === false;
        });
        return reversed.map(function (rev) {
          return adt$2.rtl(SugarElement.fromDom(rev.endContainer), rev.endOffset, SugarElement.fromDom(rev.startContainer), rev.startOffset);
        }).getOrThunk(function () {
          return fromRange(win, adt$2.ltr, rng);
        });
      } else {
        return fromRange(win, adt$2.ltr, rng);
      }
    };
    var diagnose = function (win, selection) {
      var ranges = getRanges(win, selection);
      return doDiagnose(win, ranges);
    };
    var asLtrRange = function (win, selection) {
      var diagnosis = diagnose(win, selection);
      return diagnosis.match({
        ltr: function (start, soffset, finish, foffset) {
          var rng = win.document.createRange();
          rng.setStart(start.dom, soffset);
          rng.setEnd(finish.dom, foffset);
          return rng;
        },
        rtl: function (start, soffset, finish, foffset) {
          var rng = win.document.createRange();
          rng.setStart(finish.dom, foffset);
          rng.setEnd(start.dom, soffset);
          return rng;
        }
      });
    };
    adt$2.ltr;
    adt$2.rtl;

    var searchForPoint = function (rectForOffset, x, y, maxX, length) {
      if (length === 0) {
        return 0;
      } else if (x === maxX) {
        return length - 1;
      }
      var xDelta = maxX;
      for (var i = 1; i < length; i++) {
        var rect = rectForOffset(i);
        var curDeltaX = Math.abs(x - rect.left);
        if (y <= rect.bottom) {
          if (y < rect.top || curDeltaX > xDelta) {
            return i - 1;
          } else {
            xDelta = curDeltaX;
          }
        }
      }
      return 0;
    };
    var inRect = function (rect, x, y) {
      return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
    };

    var locateOffset = function (doc, textnode, x, y, rect) {
      var rangeForOffset = function (o) {
        var r = doc.dom.createRange();
        r.setStart(textnode.dom, o);
        r.collapse(true);
        return r;
      };
      var rectForOffset = function (o) {
        var r = rangeForOffset(o);
        return r.getBoundingClientRect();
      };
      var length = get$9(textnode).length;
      var offset = searchForPoint(rectForOffset, x, y, rect.right, length);
      return rangeForOffset(offset);
    };
    var locate$1 = function (doc, node, x, y) {
      var r = doc.dom.createRange();
      r.selectNode(node.dom);
      var rects = r.getClientRects();
      var foundRect = findMap(rects, function (rect) {
        return inRect(rect, x, y) ? Optional.some(rect) : Optional.none();
      });
      return foundRect.map(function (rect) {
        return locateOffset(doc, node, x, y, rect);
      });
    };

    var searchInChildren = function (doc, node, x, y) {
      var r = doc.dom.createRange();
      var nodes = children$3(node);
      return findMap(nodes, function (n) {
        r.selectNode(n.dom);
        return inRect(r.getBoundingClientRect(), x, y) ? locateNode(doc, n, x, y) : Optional.none();
      });
    };
    var locateNode = function (doc, node, x, y) {
      return isText(node) ? locate$1(doc, node, x, y) : searchInChildren(doc, node, x, y);
    };
    var locate = function (doc, node, x, y) {
      var r = doc.dom.createRange();
      r.selectNode(node.dom);
      var rect = r.getBoundingClientRect();
      var boundedX = Math.max(rect.left, Math.min(rect.right, x));
      var boundedY = Math.max(rect.top, Math.min(rect.bottom, y));
      return locateNode(doc, node, boundedX, boundedY);
    };

    var COLLAPSE_TO_LEFT = true;
    var COLLAPSE_TO_RIGHT = false;
    var getCollapseDirection = function (rect, x) {
      return x - rect.left < rect.right - x ? COLLAPSE_TO_LEFT : COLLAPSE_TO_RIGHT;
    };
    var createCollapsedNode = function (doc, target, collapseDirection) {
      var r = doc.dom.createRange();
      r.selectNode(target.dom);
      r.collapse(collapseDirection);
      return r;
    };
    var locateInElement = function (doc, node, x) {
      var cursorRange = doc.dom.createRange();
      cursorRange.selectNode(node.dom);
      var rect = cursorRange.getBoundingClientRect();
      var collapseDirection = getCollapseDirection(rect, x);
      var f = collapseDirection === COLLAPSE_TO_LEFT ? first : last$1;
      return f(node).map(function (target) {
        return createCollapsedNode(doc, target, collapseDirection);
      });
    };
    var locateInEmpty = function (doc, node, x) {
      var rect = node.dom.getBoundingClientRect();
      var collapseDirection = getCollapseDirection(rect, x);
      return Optional.some(createCollapsedNode(doc, node, collapseDirection));
    };
    var search = function (doc, node, x) {
      var f = children$3(node).length === 0 ? locateInEmpty : locateInElement;
      return f(doc, node, x);
    };

    var caretPositionFromPoint = function (doc, x, y) {
      var _a, _b;
      return Optional.from((_b = (_a = doc.dom).caretPositionFromPoint) === null || _b === void 0 ? void 0 : _b.call(_a, x, y)).bind(function (pos) {
        if (pos.offsetNode === null) {
          return Optional.none();
        }
        var r = doc.dom.createRange();
        r.setStart(pos.offsetNode, pos.offset);
        r.collapse();
        return Optional.some(r);
      });
    };
    var caretRangeFromPoint = function (doc, x, y) {
      var _a, _b;
      return Optional.from((_b = (_a = doc.dom).caretRangeFromPoint) === null || _b === void 0 ? void 0 : _b.call(_a, x, y));
    };
    var searchTextNodes = function (doc, node, x, y) {
      var r = doc.dom.createRange();
      r.selectNode(node.dom);
      var rect = r.getBoundingClientRect();
      var boundedX = Math.max(rect.left, Math.min(rect.right, x));
      var boundedY = Math.max(rect.top, Math.min(rect.bottom, y));
      return locate(doc, node, boundedX, boundedY);
    };
    var searchFromPoint = function (doc, x, y) {
      return SugarElement.fromPoint(doc, x, y).bind(function (elem) {
        var fallback = function () {
          return search(doc, elem, x);
        };
        return children$3(elem).length === 0 ? fallback() : searchTextNodes(doc, elem, x, y).orThunk(fallback);
      });
    };
    var availableSearch = function () {
      if (document.caretPositionFromPoint) {
        return caretPositionFromPoint;
      } else if (document.caretRangeFromPoint) {
        return caretRangeFromPoint;
      } else {
        return searchFromPoint;
      }
    }();
    var fromPoint = function (win, x, y) {
      var doc = SugarElement.fromDom(win.document);
      return availableSearch(doc, x, y).map(function (rng) {
        return SimRange.create(SugarElement.fromDom(rng.startContainer), rng.startOffset, SugarElement.fromDom(rng.endContainer), rng.endOffset);
      });
    };

    var beforeSpecial = function (element, offset) {
      var name$1 = name(element);
      if ('input' === name$1) {
        return Situ.after(element);
      } else if (!contains$2([
          'br',
          'img'
        ], name$1)) {
        return Situ.on(element, offset);
      } else {
        return offset === 0 ? Situ.before(element) : Situ.after(element);
      }
    };
    var preprocessRelative = function (startSitu, finishSitu) {
      var start = startSitu.fold(Situ.before, beforeSpecial, Situ.after);
      var finish = finishSitu.fold(Situ.before, beforeSpecial, Situ.after);
      return SimSelection.relative(start, finish);
    };
    var preprocessExact = function (start, soffset, finish, foffset) {
      var startSitu = beforeSpecial(start, soffset);
      var finishSitu = beforeSpecial(finish, foffset);
      return SimSelection.relative(startSitu, finishSitu);
    };
    var preprocess = function (selection) {
      return selection.match({
        domRange: function (rng) {
          var start = SugarElement.fromDom(rng.startContainer);
          var finish = SugarElement.fromDom(rng.endContainer);
          return preprocessExact(start, rng.startOffset, finish, rng.endOffset);
        },
        relative: preprocessRelative,
        exact: preprocessExact
      });
    };

    var makeRange = function (start, soffset, finish, foffset) {
      var doc = owner(start);
      var rng = doc.dom.createRange();
      rng.setStart(start.dom, soffset);
      rng.setEnd(finish.dom, foffset);
      return rng;
    };
    var after$2 = function (start, soffset, finish, foffset) {
      var r = makeRange(start, soffset, finish, foffset);
      var same = eq$1(start, finish) && soffset === foffset;
      return r.collapsed && !same;
    };

    var getNativeSelection = function (win) {
      return Optional.from(win.getSelection());
    };
    var doSetNativeRange = function (win, rng) {
      getNativeSelection(win).each(function (selection) {
        selection.removeAllRanges();
        selection.addRange(rng);
      });
    };
    var doSetRange = function (win, start, soffset, finish, foffset) {
      var rng = exactToNative(win, start, soffset, finish, foffset);
      doSetNativeRange(win, rng);
    };
    var setLegacyRtlRange = function (win, selection, start, soffset, finish, foffset) {
      selection.collapse(start.dom, soffset);
      selection.extend(finish.dom, foffset);
    };
    var setRangeFromRelative = function (win, relative) {
      return diagnose(win, relative).match({
        ltr: function (start, soffset, finish, foffset) {
          doSetRange(win, start, soffset, finish, foffset);
        },
        rtl: function (start, soffset, finish, foffset) {
          getNativeSelection(win).each(function (selection) {
            if (selection.setBaseAndExtent) {
              selection.setBaseAndExtent(start.dom, soffset, finish.dom, foffset);
            } else if (selection.extend) {
              try {
                setLegacyRtlRange(win, selection, start, soffset, finish, foffset);
              } catch (e) {
                doSetRange(win, finish, foffset, start, soffset);
              }
            } else {
              doSetRange(win, finish, foffset, start, soffset);
            }
          });
        }
      });
    };
    var setExact = function (win, start, soffset, finish, foffset) {
      var relative = preprocessExact(start, soffset, finish, foffset);
      setRangeFromRelative(win, relative);
    };
    var setRelative = function (win, startSitu, finishSitu) {
      var relative = preprocessRelative(startSitu, finishSitu);
      setRangeFromRelative(win, relative);
    };
    var toNative = function (selection) {
      var win = SimSelection.getWin(selection).dom;
      var getDomRange = function (start, soffset, finish, foffset) {
        return exactToNative(win, start, soffset, finish, foffset);
      };
      var filtered = preprocess(selection);
      return diagnose(win, filtered).match({
        ltr: getDomRange,
        rtl: getDomRange
      });
    };
    var readRange = function (selection) {
      if (selection.rangeCount > 0) {
        var firstRng = selection.getRangeAt(0);
        var lastRng = selection.getRangeAt(selection.rangeCount - 1);
        return Optional.some(SimRange.create(SugarElement.fromDom(firstRng.startContainer), firstRng.startOffset, SugarElement.fromDom(lastRng.endContainer), lastRng.endOffset));
      } else {
        return Optional.none();
      }
    };
    var doGetExact = function (selection) {
      if (selection.anchorNode === null || selection.focusNode === null) {
        return readRange(selection);
      } else {
        var anchor = SugarElement.fromDom(selection.anchorNode);
        var focus_1 = SugarElement.fromDom(selection.focusNode);
        return after$2(anchor, selection.anchorOffset, focus_1, selection.focusOffset) ? Optional.some(SimRange.create(anchor, selection.anchorOffset, focus_1, selection.focusOffset)) : readRange(selection);
      }
    };
    var setToElement = function (win, element, selectNodeContents$1) {
      if (selectNodeContents$1 === void 0) {
        selectNodeContents$1 = true;
      }
      var rngGetter = selectNodeContents$1 ? selectNodeContents : selectNode;
      var rng = rngGetter(win, element);
      doSetNativeRange(win, rng);
    };
    var getExact = function (win) {
      return getNativeSelection(win).filter(function (sel) {
        return sel.rangeCount > 0;
      }).bind(doGetExact);
    };
    var get$1 = function (win) {
      return getExact(win).map(function (range) {
        return SimSelection.exact(range.start, range.soffset, range.finish, range.foffset);
      });
    };
    var getFirstRect = function (win, selection) {
      var rng = asLtrRange(win, selection);
      return getFirstRect$1(rng);
    };
    var getAtPoint = function (win, x, y) {
      return fromPoint(win, x, y);
    };
    var clear = function (win) {
      getNativeSelection(win).each(function (selection) {
        return selection.removeAllRanges();
      });
    };

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.VK');

    var forward = function (editor, isRoot, cell) {
      return go$1(editor, isRoot, next(cell, isEditable$1));
    };
    var backward = function (editor, isRoot, cell) {
      return go$1(editor, isRoot, prev(cell, isEditable$1));
    };
    var getCellFirstCursorPosition = function (editor, cell) {
      var selection = SimSelection.exact(cell, 0, cell, 0);
      return toNative(selection);
    };
    var go$1 = function (editor, isRoot, cell) {
      return cell.fold(Optional.none, Optional.none, function (current, next) {
        return first(next).map(function (cell) {
          return getCellFirstCursorPosition(editor, cell);
        });
      }, function (current) {
        editor.execCommand('mceTableInsertRowAfter');
        return forward(editor, isRoot, current);
      });
    };
    var rootElements = [
      'table',
      'li',
      'dl'
    ];
    var handle$1 = function (event, editor, cellSelection) {
      if (event.keyCode === global$1.TAB) {
        var body_1 = getBody(editor);
        var isRoot_1 = function (element) {
          var name$1 = name(element);
          return eq$1(element, body_1) || contains$2(rootElements, name$1);
        };
        var rng = editor.selection.getRng();
        var container = SugarElement.fromDom(event.shiftKey ? rng.startContainer : rng.endContainer);
        cell(container, isRoot_1).each(function (cell) {
          event.preventDefault();
          table(cell, isRoot_1).each(cellSelection.clear);
          editor.selection.collapse(event.shiftKey);
          var navigation = event.shiftKey ? backward : forward;
          var rng = navigation(editor, isRoot_1, cell);
          rng.each(function (range) {
            editor.selection.setRng(range);
          });
        });
      }
    };

    var create$1 = function (selection, kill) {
      return {
        selection: selection,
        kill: kill
      };
    };
    var Response = { create: create$1 };

    var create = function (start, soffset, finish, foffset) {
      return {
        start: Situ.on(start, soffset),
        finish: Situ.on(finish, foffset)
      };
    };
    var Situs = { create: create };

    var convertToRange = function (win, selection) {
      var rng = asLtrRange(win, selection);
      return SimRange.create(SugarElement.fromDom(rng.startContainer), rng.startOffset, SugarElement.fromDom(rng.endContainer), rng.endOffset);
    };
    var makeSitus = Situs.create;

    var sync = function (container, isRoot, start, soffset, finish, foffset, selectRange) {
      if (!(eq$1(start, finish) && soffset === foffset)) {
        return closest$1(start, 'td,th', isRoot).bind(function (s) {
          return closest$1(finish, 'td,th', isRoot).bind(function (f) {
            return detect(container, isRoot, s, f, selectRange);
          });
        });
      } else {
        return Optional.none();
      }
    };
    var detect = function (container, isRoot, start, finish, selectRange) {
      if (!eq$1(start, finish)) {
        return identify(start, finish, isRoot).bind(function (cellSel) {
          var boxes = cellSel.boxes.getOr([]);
          if (boxes.length > 1) {
            selectRange(container, boxes, cellSel.start, cellSel.finish);
            return Optional.some(Response.create(Optional.some(makeSitus(start, 0, start, getEnd(start))), true));
          } else {
            return Optional.none();
          }
        });
      } else {
        return Optional.none();
      }
    };
    var update = function (rows, columns, container, selected, annotations) {
      var updateSelection = function (newSels) {
        annotations.clearBeforeUpdate(container);
        annotations.selectRange(container, newSels.boxes, newSels.start, newSels.finish);
        return newSels.boxes;
      };
      return shiftSelection(selected, rows, columns, annotations.firstSelectedSelector, annotations.lastSelectedSelector).map(updateSelection);
    };

    var traverse = function (item, mode) {
      return {
        item: item,
        mode: mode
      };
    };
    var backtrack = function (universe, item, _direction, transition) {
      if (transition === void 0) {
        transition = sidestep;
      }
      return universe.property().parent(item).map(function (p) {
        return traverse(p, transition);
      });
    };
    var sidestep = function (universe, item, direction, transition) {
      if (transition === void 0) {
        transition = advance;
      }
      return direction.sibling(universe, item).map(function (p) {
        return traverse(p, transition);
      });
    };
    var advance = function (universe, item, direction, transition) {
      if (transition === void 0) {
        transition = advance;
      }
      var children = universe.property().children(item);
      var result = direction.first(children);
      return result.map(function (r) {
        return traverse(r, transition);
      });
    };
    var successors = [
      {
        current: backtrack,
        next: sidestep,
        fallback: Optional.none()
      },
      {
        current: sidestep,
        next: advance,
        fallback: Optional.some(backtrack)
      },
      {
        current: advance,
        next: advance,
        fallback: Optional.some(sidestep)
      }
    ];
    var go = function (universe, item, mode, direction, rules) {
      if (rules === void 0) {
        rules = successors;
      }
      var ruleOpt = find$1(rules, function (succ) {
        return succ.current === mode;
      });
      return ruleOpt.bind(function (rule) {
        return rule.current(universe, item, direction, rule.next).orThunk(function () {
          return rule.fallback.bind(function (fb) {
            return go(universe, item, fb, direction);
          });
        });
      });
    };

    var left$1 = function () {
      var sibling = function (universe, item) {
        return universe.query().prevSibling(item);
      };
      var first = function (children) {
        return children.length > 0 ? Optional.some(children[children.length - 1]) : Optional.none();
      };
      return {
        sibling: sibling,
        first: first
      };
    };
    var right$1 = function () {
      var sibling = function (universe, item) {
        return universe.query().nextSibling(item);
      };
      var first = function (children) {
        return children.length > 0 ? Optional.some(children[0]) : Optional.none();
      };
      return {
        sibling: sibling,
        first: first
      };
    };
    var Walkers = {
      left: left$1,
      right: right$1
    };

    var hone = function (universe, item, predicate, mode, direction, isRoot) {
      var next = go(universe, item, mode, direction);
      return next.bind(function (n) {
        if (isRoot(n.item)) {
          return Optional.none();
        } else {
          return predicate(n.item) ? Optional.some(n.item) : hone(universe, n.item, predicate, n.mode, direction, isRoot);
        }
      });
    };
    var left = function (universe, item, predicate, isRoot) {
      return hone(universe, item, predicate, sidestep, Walkers.left(), isRoot);
    };
    var right = function (universe, item, predicate, isRoot) {
      return hone(universe, item, predicate, sidestep, Walkers.right(), isRoot);
    };

    var isLeaf = function (universe) {
      return function (element) {
        return universe.property().children(element).length === 0;
      };
    };
    var before$1 = function (universe, item, isRoot) {
      return seekLeft$1(universe, item, isLeaf(universe), isRoot);
    };
    var after$1 = function (universe, item, isRoot) {
      return seekRight$1(universe, item, isLeaf(universe), isRoot);
    };
    var seekLeft$1 = left;
    var seekRight$1 = right;

    var universe = DomUniverse();
    var before = function (element, isRoot) {
      return before$1(universe, element, isRoot);
    };
    var after = function (element, isRoot) {
      return after$1(universe, element, isRoot);
    };
    var seekLeft = function (element, predicate, isRoot) {
      return seekLeft$1(universe, element, predicate, isRoot);
    };
    var seekRight = function (element, predicate, isRoot) {
      return seekRight$1(universe, element, predicate, isRoot);
    };

    var ancestor = function (scope, predicate, isRoot) {
      return ancestor$2(scope, predicate, isRoot).isSome();
    };

    var adt$1 = Adt.generate([
      { none: ['message'] },
      { success: [] },
      { failedUp: ['cell'] },
      { failedDown: ['cell'] }
    ]);
    var isOverlapping = function (bridge, before, after) {
      var beforeBounds = bridge.getRect(before);
      var afterBounds = bridge.getRect(after);
      return afterBounds.right > beforeBounds.left && afterBounds.left < beforeBounds.right;
    };
    var isRow = function (elem) {
      return closest$1(elem, 'tr');
    };
    var verify = function (bridge, before, beforeOffset, after, afterOffset, failure, isRoot) {
      return closest$1(after, 'td,th', isRoot).bind(function (afterCell) {
        return closest$1(before, 'td,th', isRoot).map(function (beforeCell) {
          if (!eq$1(afterCell, beforeCell)) {
            return sharedOne(isRow, [
              afterCell,
              beforeCell
            ]).fold(function () {
              return isOverlapping(bridge, beforeCell, afterCell) ? adt$1.success() : failure(beforeCell);
            }, function (_sharedRow) {
              return failure(beforeCell);
            });
          } else {
            return eq$1(after, afterCell) && getEnd(afterCell) === afterOffset ? failure(beforeCell) : adt$1.none('in same cell');
          }
        });
      }).getOr(adt$1.none('default'));
    };
    var cata = function (subject, onNone, onSuccess, onFailedUp, onFailedDown) {
      return subject.fold(onNone, onSuccess, onFailedUp, onFailedDown);
    };
    var BeforeAfter = __assign(__assign({}, adt$1), {
      verify: verify,
      cata: cata
    });

    var inParent = function (parent, children, element, index) {
      return {
        parent: parent,
        children: children,
        element: element,
        index: index
      };
    };
    var indexInParent = function (element) {
      return parent(element).bind(function (parent) {
        var children = children$3(parent);
        return indexOf(children, element).map(function (index) {
          return inParent(parent, children, element, index);
        });
      });
    };
    var indexOf = function (elements, element) {
      return findIndex(elements, curry(eq$1, element));
    };

    var isBr = function (elem) {
      return name(elem) === 'br';
    };
    var gatherer = function (cand, gather, isRoot) {
      return gather(cand, isRoot).bind(function (target) {
        return isText(target) && get$9(target).trim().length === 0 ? gatherer(target, gather, isRoot) : Optional.some(target);
      });
    };
    var handleBr = function (isRoot, element, direction) {
      return direction.traverse(element).orThunk(function () {
        return gatherer(element, direction.gather, isRoot);
      }).map(direction.relative);
    };
    var findBr = function (element, offset) {
      return child$3(element, offset).filter(isBr).orThunk(function () {
        return child$3(element, offset - 1).filter(isBr);
      });
    };
    var handleParent = function (isRoot, element, offset, direction) {
      return findBr(element, offset).bind(function (br) {
        return direction.traverse(br).fold(function () {
          return gatherer(br, direction.gather, isRoot).map(direction.relative);
        }, function (adjacent) {
          return indexInParent(adjacent).map(function (info) {
            return Situ.on(info.parent, info.index);
          });
        });
      });
    };
    var tryBr = function (isRoot, element, offset, direction) {
      var target = isBr(element) ? handleBr(isRoot, element, direction) : handleParent(isRoot, element, offset, direction);
      return target.map(function (tgt) {
        return {
          start: tgt,
          finish: tgt
        };
      });
    };
    var process = function (analysis) {
      return BeforeAfter.cata(analysis, function (_message) {
        return Optional.none();
      }, function () {
        return Optional.none();
      }, function (cell) {
        return Optional.some(point(cell, 0));
      }, function (cell) {
        return Optional.some(point(cell, getEnd(cell)));
      });
    };

    var moveDown = function (caret, amount) {
      return {
        left: caret.left,
        top: caret.top + amount,
        right: caret.right,
        bottom: caret.bottom + amount
      };
    };
    var moveUp = function (caret, amount) {
      return {
        left: caret.left,
        top: caret.top - amount,
        right: caret.right,
        bottom: caret.bottom - amount
      };
    };
    var translate = function (caret, xDelta, yDelta) {
      return {
        left: caret.left + xDelta,
        top: caret.top + yDelta,
        right: caret.right + xDelta,
        bottom: caret.bottom + yDelta
      };
    };
    var getTop = function (caret) {
      return caret.top;
    };
    var getBottom = function (caret) {
      return caret.bottom;
    };

    var getPartialBox = function (bridge, element, offset) {
      if (offset >= 0 && offset < getEnd(element)) {
        return bridge.getRangedRect(element, offset, element, offset + 1);
      } else if (offset > 0) {
        return bridge.getRangedRect(element, offset - 1, element, offset);
      }
      return Optional.none();
    };
    var toCaret = function (rect) {
      return {
        left: rect.left,
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom
      };
    };
    var getElemBox = function (bridge, element) {
      return Optional.some(bridge.getRect(element));
    };
    var getBoxAt = function (bridge, element, offset) {
      if (isElement(element)) {
        return getElemBox(bridge, element).map(toCaret);
      } else if (isText(element)) {
        return getPartialBox(bridge, element, offset).map(toCaret);
      } else {
        return Optional.none();
      }
    };
    var getEntireBox = function (bridge, element) {
      if (isElement(element)) {
        return getElemBox(bridge, element).map(toCaret);
      } else if (isText(element)) {
        return bridge.getRangedRect(element, 0, element, getEnd(element)).map(toCaret);
      } else {
        return Optional.none();
      }
    };

    var JUMP_SIZE = 5;
    var NUM_RETRIES = 100;
    var adt = Adt.generate([
      { none: [] },
      { retry: ['caret'] }
    ]);
    var isOutside = function (caret, box) {
      return caret.left < box.left || Math.abs(box.right - caret.left) < 1 || caret.left > box.right;
    };
    var inOutsideBlock = function (bridge, element, caret) {
      return closest$2(element, isBlock).fold(never, function (cell) {
        return getEntireBox(bridge, cell).exists(function (box) {
          return isOutside(caret, box);
        });
      });
    };
    var adjustDown = function (bridge, element, guessBox, original, caret) {
      var lowerCaret = moveDown(caret, JUMP_SIZE);
      if (Math.abs(guessBox.bottom - original.bottom) < 1) {
        return adt.retry(lowerCaret);
      } else if (guessBox.top > caret.bottom) {
        return adt.retry(lowerCaret);
      } else if (guessBox.top === caret.bottom) {
        return adt.retry(moveDown(caret, 1));
      } else {
        return inOutsideBlock(bridge, element, caret) ? adt.retry(translate(lowerCaret, JUMP_SIZE, 0)) : adt.none();
      }
    };
    var adjustUp = function (bridge, element, guessBox, original, caret) {
      var higherCaret = moveUp(caret, JUMP_SIZE);
      if (Math.abs(guessBox.top - original.top) < 1) {
        return adt.retry(higherCaret);
      } else if (guessBox.bottom < caret.top) {
        return adt.retry(higherCaret);
      } else if (guessBox.bottom === caret.top) {
        return adt.retry(moveUp(caret, 1));
      } else {
        return inOutsideBlock(bridge, element, caret) ? adt.retry(translate(higherCaret, JUMP_SIZE, 0)) : adt.none();
      }
    };
    var upMovement = {
      point: getTop,
      adjuster: adjustUp,
      move: moveUp,
      gather: before
    };
    var downMovement = {
      point: getBottom,
      adjuster: adjustDown,
      move: moveDown,
      gather: after
    };
    var isAtTable = function (bridge, x, y) {
      return bridge.elementFromPoint(x, y).filter(function (elm) {
        return name(elm) === 'table';
      }).isSome();
    };
    var adjustForTable = function (bridge, movement, original, caret, numRetries) {
      return adjustTil(bridge, movement, original, movement.move(caret, JUMP_SIZE), numRetries);
    };
    var adjustTil = function (bridge, movement, original, caret, numRetries) {
      if (numRetries === 0) {
        return Optional.some(caret);
      }
      if (isAtTable(bridge, caret.left, movement.point(caret))) {
        return adjustForTable(bridge, movement, original, caret, numRetries - 1);
      }
      return bridge.situsFromPoint(caret.left, movement.point(caret)).bind(function (guess) {
        return guess.start.fold(Optional.none, function (element) {
          return getEntireBox(bridge, element).bind(function (guessBox) {
            return movement.adjuster(bridge, element, guessBox, original, caret).fold(Optional.none, function (newCaret) {
              return adjustTil(bridge, movement, original, newCaret, numRetries - 1);
            });
          }).orThunk(function () {
            return Optional.some(caret);
          });
        }, Optional.none);
      });
    };
    var ieTryDown = function (bridge, caret) {
      return bridge.situsFromPoint(caret.left, caret.bottom + JUMP_SIZE);
    };
    var ieTryUp = function (bridge, caret) {
      return bridge.situsFromPoint(caret.left, caret.top - JUMP_SIZE);
    };
    var checkScroll = function (movement, adjusted, bridge) {
      if (movement.point(adjusted) > bridge.getInnerHeight()) {
        return Optional.some(movement.point(adjusted) - bridge.getInnerHeight());
      } else if (movement.point(adjusted) < 0) {
        return Optional.some(-movement.point(adjusted));
      } else {
        return Optional.none();
      }
    };
    var retry = function (movement, bridge, caret) {
      var moved = movement.move(caret, JUMP_SIZE);
      var adjusted = adjustTil(bridge, movement, caret, moved, NUM_RETRIES).getOr(moved);
      return checkScroll(movement, adjusted, bridge).fold(function () {
        return bridge.situsFromPoint(adjusted.left, movement.point(adjusted));
      }, function (delta) {
        bridge.scrollBy(0, delta);
        return bridge.situsFromPoint(adjusted.left, movement.point(adjusted) - delta);
      });
    };
    var Retries = {
      tryUp: curry(retry, upMovement),
      tryDown: curry(retry, downMovement),
      ieTryUp: ieTryUp,
      ieTryDown: ieTryDown,
      getJumpSize: constant(JUMP_SIZE)
    };

    var MAX_RETRIES = 20;
    var findSpot = function (bridge, isRoot, direction) {
      return bridge.getSelection().bind(function (sel) {
        return tryBr(isRoot, sel.finish, sel.foffset, direction).fold(function () {
          return Optional.some(point(sel.finish, sel.foffset));
        }, function (brNeighbour) {
          var range = bridge.fromSitus(brNeighbour);
          var analysis = BeforeAfter.verify(bridge, sel.finish, sel.foffset, range.finish, range.foffset, direction.failure, isRoot);
          return process(analysis);
        });
      });
    };
    var scan = function (bridge, isRoot, element, offset, direction, numRetries) {
      if (numRetries === 0) {
        return Optional.none();
      }
      return tryCursor(bridge, isRoot, element, offset, direction).bind(function (situs) {
        var range = bridge.fromSitus(situs);
        var analysis = BeforeAfter.verify(bridge, element, offset, range.finish, range.foffset, direction.failure, isRoot);
        return BeforeAfter.cata(analysis, function () {
          return Optional.none();
        }, function () {
          return Optional.some(situs);
        }, function (cell) {
          if (eq$1(element, cell) && offset === 0) {
            return tryAgain(bridge, element, offset, moveUp, direction);
          } else {
            return scan(bridge, isRoot, cell, 0, direction, numRetries - 1);
          }
        }, function (cell) {
          if (eq$1(element, cell) && offset === getEnd(cell)) {
            return tryAgain(bridge, element, offset, moveDown, direction);
          } else {
            return scan(bridge, isRoot, cell, getEnd(cell), direction, numRetries - 1);
          }
        });
      });
    };
    var tryAgain = function (bridge, element, offset, move, direction) {
      return getBoxAt(bridge, element, offset).bind(function (box) {
        return tryAt(bridge, direction, move(box, Retries.getJumpSize()));
      });
    };
    var tryAt = function (bridge, direction, box) {
      var browser = detect$3().browser;
      if (browser.isChrome() || browser.isSafari() || browser.isFirefox() || browser.isEdge()) {
        return direction.otherRetry(bridge, box);
      } else if (browser.isIE()) {
        return direction.ieRetry(bridge, box);
      } else {
        return Optional.none();
      }
    };
    var tryCursor = function (bridge, isRoot, element, offset, direction) {
      return getBoxAt(bridge, element, offset).bind(function (box) {
        return tryAt(bridge, direction, box);
      });
    };
    var handle = function (bridge, isRoot, direction) {
      return findSpot(bridge, isRoot, direction).bind(function (spot) {
        return scan(bridge, isRoot, spot.element, spot.offset, direction, MAX_RETRIES).map(bridge.fromSitus);
      });
    };

    var inSameTable = function (elem, table) {
      return ancestor(elem, function (e) {
        return parent(e).exists(function (p) {
          return eq$1(p, table);
        });
      });
    };
    var simulate = function (bridge, isRoot, direction, initial, anchor) {
      return closest$1(initial, 'td,th', isRoot).bind(function (start) {
        return closest$1(start, 'table', isRoot).bind(function (table) {
          if (!inSameTable(anchor, table)) {
            return Optional.none();
          }
          return handle(bridge, isRoot, direction).bind(function (range) {
            return closest$1(range.finish, 'td,th', isRoot).map(function (finish) {
              return {
                start: start,
                finish: finish,
                range: range
              };
            });
          });
        });
      });
    };
    var navigate = function (bridge, isRoot, direction, initial, anchor, precheck) {
      if (detect$3().browser.isIE()) {
        return Optional.none();
      } else {
        return precheck(initial, isRoot).orThunk(function () {
          return simulate(bridge, isRoot, direction, initial, anchor).map(function (info) {
            var range = info.range;
            return Response.create(Optional.some(makeSitus(range.start, range.soffset, range.finish, range.foffset)), true);
          });
        });
      }
    };
    var firstUpCheck = function (initial, isRoot) {
      return closest$1(initial, 'tr', isRoot).bind(function (startRow) {
        return closest$1(startRow, 'table', isRoot).bind(function (table) {
          var rows = descendants(table, 'tr');
          if (eq$1(startRow, rows[0])) {
            return seekLeft(table, function (element) {
              return last$1(element).isSome();
            }, isRoot).map(function (last) {
              var lastOffset = getEnd(last);
              return Response.create(Optional.some(makeSitus(last, lastOffset, last, lastOffset)), true);
            });
          } else {
            return Optional.none();
          }
        });
      });
    };
    var lastDownCheck = function (initial, isRoot) {
      return closest$1(initial, 'tr', isRoot).bind(function (startRow) {
        return closest$1(startRow, 'table', isRoot).bind(function (table) {
          var rows = descendants(table, 'tr');
          if (eq$1(startRow, rows[rows.length - 1])) {
            return seekRight(table, function (element) {
              return first(element).isSome();
            }, isRoot).map(function (first) {
              return Response.create(Optional.some(makeSitus(first, 0, first, 0)), true);
            });
          } else {
            return Optional.none();
          }
        });
      });
    };
    var select = function (bridge, container, isRoot, direction, initial, anchor, selectRange) {
      return simulate(bridge, isRoot, direction, initial, anchor).bind(function (info) {
        return detect(container, isRoot, info.start, info.finish, selectRange);
      });
    };

    var findCell = function (target, isRoot) {
      return closest$1(target, 'td,th', isRoot);
    };
    var MouseSelection = function (bridge, container, isRoot, annotations) {
      var cursor = value();
      var clearstate = cursor.clear;
      var applySelection = function (event) {
        cursor.on(function (start) {
          annotations.clearBeforeUpdate(container);
          findCell(event.target, isRoot).each(function (finish) {
            identify(start, finish, isRoot).each(function (cellSel) {
              var boxes = cellSel.boxes.getOr([]);
              if (boxes.length === 1) {
                var singleCell = boxes[0];
                var isNonEditableCell = getRaw(singleCell) === 'false';
                var isCellClosestContentEditable = is(closest(event.target), singleCell, eq$1);
                if (isNonEditableCell && isCellClosestContentEditable) {
                  annotations.selectRange(container, boxes, singleCell, singleCell);
                  bridge.selectContents(singleCell);
                }
              } else if (boxes.length > 1) {
                annotations.selectRange(container, boxes, cellSel.start, cellSel.finish);
                bridge.selectContents(finish);
              }
            });
          });
        });
      };
      var mousedown = function (event) {
        annotations.clear(container);
        findCell(event.target, isRoot).each(cursor.set);
      };
      var mouseover = function (event) {
        applySelection(event);
      };
      var mouseup = function (event) {
        applySelection(event);
        clearstate();
      };
      return {
        clearstate: clearstate,
        mousedown: mousedown,
        mouseover: mouseover,
        mouseup: mouseup
      };
    };

    var down = {
      traverse: nextSibling,
      gather: after,
      relative: Situ.before,
      otherRetry: Retries.tryDown,
      ieRetry: Retries.ieTryDown,
      failure: BeforeAfter.failedDown
    };
    var up = {
      traverse: prevSibling,
      gather: before,
      relative: Situ.before,
      otherRetry: Retries.tryUp,
      ieRetry: Retries.ieTryUp,
      failure: BeforeAfter.failedUp
    };

    var isKey = function (key) {
      return function (keycode) {
        return keycode === key;
      };
    };
    var isUp = isKey(38);
    var isDown = isKey(40);
    var isNavigation = function (keycode) {
      return keycode >= 37 && keycode <= 40;
    };
    var ltr = {
      isBackward: isKey(37),
      isForward: isKey(39)
    };
    var rtl = {
      isBackward: isKey(39),
      isForward: isKey(37)
    };

    var get = function (_DOC) {
      var doc = _DOC !== undefined ? _DOC.dom : document;
      var x = doc.body.scrollLeft || doc.documentElement.scrollLeft;
      var y = doc.body.scrollTop || doc.documentElement.scrollTop;
      return SugarPosition(x, y);
    };
    var by = function (x, y, _DOC) {
      var doc = _DOC !== undefined ? _DOC.dom : document;
      var win = doc.defaultView;
      if (win) {
        win.scrollBy(x, y);
      }
    };

    var WindowBridge = function (win) {
      var elementFromPoint = function (x, y) {
        return SugarElement.fromPoint(SugarElement.fromDom(win.document), x, y);
      };
      var getRect = function (element) {
        return element.dom.getBoundingClientRect();
      };
      var getRangedRect = function (start, soffset, finish, foffset) {
        var sel = SimSelection.exact(start, soffset, finish, foffset);
        return getFirstRect(win, sel);
      };
      var getSelection = function () {
        return get$1(win).map(function (exactAdt) {
          return convertToRange(win, exactAdt);
        });
      };
      var fromSitus = function (situs) {
        var relative = SimSelection.relative(situs.start, situs.finish);
        return convertToRange(win, relative);
      };
      var situsFromPoint = function (x, y) {
        return getAtPoint(win, x, y).map(function (exact) {
          return Situs.create(exact.start, exact.soffset, exact.finish, exact.foffset);
        });
      };
      var clearSelection = function () {
        clear(win);
      };
      var collapseSelection = function (toStart) {
        if (toStart === void 0) {
          toStart = false;
        }
        get$1(win).each(function (sel) {
          return sel.fold(function (rng) {
            return rng.collapse(toStart);
          }, function (startSitu, finishSitu) {
            var situ = toStart ? startSitu : finishSitu;
            setRelative(win, situ, situ);
          }, function (start, soffset, finish, foffset) {
            var node = toStart ? start : finish;
            var offset = toStart ? soffset : foffset;
            setExact(win, node, offset, node, offset);
          });
        });
      };
      var selectNode = function (element) {
        setToElement(win, element, false);
      };
      var selectContents = function (element) {
        setToElement(win, element);
      };
      var setSelection = function (sel) {
        setExact(win, sel.start, sel.soffset, sel.finish, sel.foffset);
      };
      var setRelativeSelection = function (start, finish) {
        setRelative(win, start, finish);
      };
      var getInnerHeight = function () {
        return win.innerHeight;
      };
      var getScrollY = function () {
        var pos = get(SugarElement.fromDom(win.document));
        return pos.top;
      };
      var scrollBy = function (x, y) {
        by(x, y, SugarElement.fromDom(win.document));
      };
      return {
        elementFromPoint: elementFromPoint,
        getRect: getRect,
        getRangedRect: getRangedRect,
        getSelection: getSelection,
        fromSitus: fromSitus,
        situsFromPoint: situsFromPoint,
        clearSelection: clearSelection,
        collapseSelection: collapseSelection,
        setSelection: setSelection,
        setRelativeSelection: setRelativeSelection,
        selectNode: selectNode,
        selectContents: selectContents,
        getInnerHeight: getInnerHeight,
        getScrollY: getScrollY,
        scrollBy: scrollBy
      };
    };

    var rc = function (rows, cols) {
      return {
        rows: rows,
        cols: cols
      };
    };
    var mouse = function (win, container, isRoot, annotations) {
      var bridge = WindowBridge(win);
      var handlers = MouseSelection(bridge, container, isRoot, annotations);
      return {
        clearstate: handlers.clearstate,
        mousedown: handlers.mousedown,
        mouseover: handlers.mouseover,
        mouseup: handlers.mouseup
      };
    };
    var keyboard = function (win, container, isRoot, annotations) {
      var bridge = WindowBridge(win);
      var clearToNavigate = function () {
        annotations.clear(container);
        return Optional.none();
      };
      var keydown = function (event, start, soffset, finish, foffset, direction) {
        var realEvent = event.raw;
        var keycode = realEvent.which;
        var shiftKey = realEvent.shiftKey === true;
        var handler = retrieve$1(container, annotations.selectedSelector).fold(function () {
          if (isNavigation(keycode) && !shiftKey) {
            annotations.clearBeforeUpdate(container);
          }
          if (isDown(keycode) && shiftKey) {
            return curry(select, bridge, container, isRoot, down, finish, start, annotations.selectRange);
          } else if (isUp(keycode) && shiftKey) {
            return curry(select, bridge, container, isRoot, up, finish, start, annotations.selectRange);
          } else if (isDown(keycode)) {
            return curry(navigate, bridge, isRoot, down, finish, start, lastDownCheck);
          } else if (isUp(keycode)) {
            return curry(navigate, bridge, isRoot, up, finish, start, firstUpCheck);
          } else {
            return Optional.none;
          }
        }, function (selected) {
          var update$1 = function (attempts) {
            return function () {
              var navigation = findMap(attempts, function (delta) {
                return update(delta.rows, delta.cols, container, selected, annotations);
              });
              return navigation.fold(function () {
                return getEdges(container, annotations.firstSelectedSelector, annotations.lastSelectedSelector).map(function (edges) {
                  var relative = isDown(keycode) || direction.isForward(keycode) ? Situ.after : Situ.before;
                  bridge.setRelativeSelection(Situ.on(edges.first, 0), relative(edges.table));
                  annotations.clear(container);
                  return Response.create(Optional.none(), true);
                });
              }, function (_) {
                return Optional.some(Response.create(Optional.none(), true));
              });
            };
          };
          if (isDown(keycode) && shiftKey) {
            return update$1([rc(+1, 0)]);
          } else if (isUp(keycode) && shiftKey) {
            return update$1([rc(-1, 0)]);
          } else if (direction.isBackward(keycode) && shiftKey) {
            return update$1([
              rc(0, -1),
              rc(-1, 0)
            ]);
          } else if (direction.isForward(keycode) && shiftKey) {
            return update$1([
              rc(0, +1),
              rc(+1, 0)
            ]);
          } else if (isNavigation(keycode) && !shiftKey) {
            return clearToNavigate;
          } else {
            return Optional.none;
          }
        });
        return handler();
      };
      var keyup = function (event, start, soffset, finish, foffset) {
        return retrieve$1(container, annotations.selectedSelector).fold(function () {
          var realEvent = event.raw;
          var keycode = realEvent.which;
          var shiftKey = realEvent.shiftKey === true;
          if (!shiftKey) {
            return Optional.none();
          }
          if (isNavigation(keycode)) {
            return sync(container, isRoot, start, soffset, finish, foffset, annotations.selectRange);
          } else {
            return Optional.none();
          }
        }, Optional.none);
      };
      return {
        keydown: keydown,
        keyup: keyup
      };
    };
    var external = function (win, container, isRoot, annotations) {
      var bridge = WindowBridge(win);
      return function (start, finish) {
        annotations.clearBeforeUpdate(container);
        identify(start, finish, isRoot).each(function (cellSel) {
          var boxes = cellSel.boxes.getOr([]);
          annotations.selectRange(container, boxes, cellSel.start, cellSel.finish);
          bridge.selectContents(finish);
          bridge.collapseSelection();
        });
      };
    };

    var remove = function (element, classes) {
      each$2(classes, function (x) {
        remove$2(element, x);
      });
    };

    var addClass = function (clazz) {
      return function (element) {
        add(element, clazz);
      };
    };
    var removeClasses = function (classes) {
      return function (element) {
        remove(element, classes);
      };
    };

    var byClass = function (ephemera) {
      var addSelectionClass = addClass(ephemera.selected);
      var removeSelectionClasses = removeClasses([
        ephemera.selected,
        ephemera.lastSelected,
        ephemera.firstSelected
      ]);
      var clear = function (container) {
        var sels = descendants(container, ephemera.selectedSelector);
        each$2(sels, removeSelectionClasses);
      };
      var selectRange = function (container, cells, start, finish) {
        clear(container);
        each$2(cells, addSelectionClass);
        add(start, ephemera.firstSelected);
        add(finish, ephemera.lastSelected);
      };
      return {
        clearBeforeUpdate: clear,
        clear: clear,
        selectRange: selectRange,
        selectedSelector: ephemera.selectedSelector,
        firstSelectedSelector: ephemera.firstSelectedSelector,
        lastSelectedSelector: ephemera.lastSelectedSelector
      };
    };
    var byAttr = function (ephemera, onSelection, onClear) {
      var removeSelectionAttributes = function (element) {
        remove$7(element, ephemera.selected);
        remove$7(element, ephemera.firstSelected);
        remove$7(element, ephemera.lastSelected);
      };
      var addSelectionAttribute = function (element) {
        set$2(element, ephemera.selected, '1');
      };
      var clear = function (container) {
        clearBeforeUpdate(container);
        onClear();
      };
      var clearBeforeUpdate = function (container) {
        var sels = descendants(container, ephemera.selectedSelector + ',' + ephemera.firstSelectedSelector + ',' + ephemera.lastSelectedSelector);
        each$2(sels, removeSelectionAttributes);
      };
      var selectRange = function (container, cells, start, finish) {
        clear(container);
        each$2(cells, addSelectionAttribute);
        set$2(start, ephemera.firstSelected, '1');
        set$2(finish, ephemera.lastSelected, '1');
        onSelection(cells, start, finish);
      };
      return {
        clearBeforeUpdate: clearBeforeUpdate,
        clear: clear,
        selectRange: selectRange,
        selectedSelector: ephemera.selectedSelector,
        firstSelectedSelector: ephemera.firstSelectedSelector,
        lastSelectedSelector: ephemera.lastSelectedSelector
      };
    };
    var SelectionAnnotation = {
      byClass: byClass,
      byAttr: byAttr
    };

    var getUpOrLeftCells = function (grid, selectedCells) {
      var upGrid = grid.slice(0, selectedCells[selectedCells.length - 1].row + 1);
      var upDetails = toDetailList(upGrid);
      return bind$2(upDetails, function (detail) {
        var slicedCells = detail.cells.slice(0, selectedCells[selectedCells.length - 1].column + 1);
        return map$1(slicedCells, function (cell) {
          return cell.element;
        });
      });
    };
    var getDownOrRightCells = function (grid, selectedCells) {
      var downGrid = grid.slice(selectedCells[0].row + selectedCells[0].rowspan - 1, grid.length);
      var downDetails = toDetailList(downGrid);
      return bind$2(downDetails, function (detail) {
        var slicedCells = detail.cells.slice(selectedCells[0].column + selectedCells[0].colspan - 1, detail.cells.length);
        return map$1(slicedCells, function (cell) {
          return cell.element;
        });
      });
    };
    var getOtherCells = function (table, target, generators) {
      var warehouse = Warehouse.fromTable(table);
      var details = onCells(warehouse, target);
      return details.map(function (selectedCells) {
        var grid = toGrid(warehouse, generators, false);
        var upOrLeftCells = getUpOrLeftCells(grid, selectedCells);
        var downOrRightCells = getDownOrRightCells(grid, selectedCells);
        return {
          upOrLeftCells: upOrLeftCells,
          downOrRightCells: downOrRightCells
        };
      });
    };

    var global = tinymce.util.Tools.resolve('tinymce.Env');

    var hasInternalTarget = function (e) {
      return has(SugarElement.fromDom(e.target), 'ephox-snooker-resizer-bar') === false;
    };
    function CellSelection (editor, lazyResize, selectionTargets) {
      var onSelection = function (cells, start, finish) {
        selectionTargets.targets().each(function (targets) {
          var tableOpt = table(start);
          tableOpt.each(function (table) {
            var cloneFormats = getCloneElements(editor);
            var generators = cellOperations(noop, SugarElement.fromDom(editor.getDoc()), cloneFormats);
            var otherCells = getOtherCells(table, targets, generators);
            fireTableSelectionChange(editor, cells, start, finish, otherCells);
          });
        });
      };
      var onClear = function () {
        return fireTableSelectionClear(editor);
      };
      var annotations = SelectionAnnotation.byAttr(ephemera, onSelection, onClear);
      editor.on('init', function (_e) {
        var win = editor.getWin();
        var body = getBody(editor);
        var isRoot = getIsRoot(editor);
        var syncSelection = function () {
          var sel = editor.selection;
          var start = SugarElement.fromDom(sel.getStart());
          var end = SugarElement.fromDom(sel.getEnd());
          var shared = sharedOne(table, [
            start,
            end
          ]);
          shared.fold(function () {
            return annotations.clear(body);
          }, noop);
        };
        var mouseHandlers = mouse(win, body, isRoot, annotations);
        var keyHandlers = keyboard(win, body, isRoot, annotations);
        var external$1 = external(win, body, isRoot, annotations);
        var hasShiftKey = function (event) {
          return event.raw.shiftKey === true;
        };
        editor.on('TableSelectorChange', function (e) {
          return external$1(e.start, e.finish);
        });
        var handleResponse = function (event, response) {
          if (!hasShiftKey(event)) {
            return;
          }
          if (response.kill) {
            event.kill();
          }
          response.selection.each(function (ns) {
            var relative = SimSelection.relative(ns.start, ns.finish);
            var rng = asLtrRange(win, relative);
            editor.selection.setRng(rng);
          });
        };
        var keyup = function (event) {
          var wrappedEvent = fromRawEvent(event);
          if (wrappedEvent.raw.shiftKey && isNavigation(wrappedEvent.raw.which)) {
            var rng = editor.selection.getRng();
            var start = SugarElement.fromDom(rng.startContainer);
            var end = SugarElement.fromDom(rng.endContainer);
            keyHandlers.keyup(wrappedEvent, start, rng.startOffset, end, rng.endOffset).each(function (response) {
              handleResponse(wrappedEvent, response);
            });
          }
        };
        var keydown = function (event) {
          var wrappedEvent = fromRawEvent(event);
          lazyResize().each(function (resize) {
            return resize.hideBars();
          });
          var rng = editor.selection.getRng();
          var start = SugarElement.fromDom(rng.startContainer);
          var end = SugarElement.fromDom(rng.endContainer);
          var direction = onDirection(ltr, rtl)(SugarElement.fromDom(editor.selection.getStart()));
          keyHandlers.keydown(wrappedEvent, start, rng.startOffset, end, rng.endOffset, direction).each(function (response) {
            handleResponse(wrappedEvent, response);
          });
          lazyResize().each(function (resize) {
            return resize.showBars();
          });
        };
        var isLeftMouse = function (raw) {
          return raw.button === 0;
        };
        var isLeftButtonPressed = function (raw) {
          if (raw.buttons === undefined) {
            return true;
          }
          if (global.browser.isEdge() && raw.buttons === 0) {
            return true;
          }
          return (raw.buttons & 1) !== 0;
        };
        var dragStart = function (_e) {
          mouseHandlers.clearstate();
        };
        var mouseDown = function (e) {
          if (isLeftMouse(e) && hasInternalTarget(e)) {
            mouseHandlers.mousedown(fromRawEvent(e));
          }
        };
        var mouseOver = function (e) {
          if (isLeftButtonPressed(e) && hasInternalTarget(e)) {
            mouseHandlers.mouseover(fromRawEvent(e));
          }
        };
        var mouseUp = function (e) {
          if (isLeftMouse(e) && hasInternalTarget(e)) {
            mouseHandlers.mouseup(fromRawEvent(e));
          }
        };
        var getDoubleTap = function () {
          var lastTarget = Cell(SugarElement.fromDom(body));
          var lastTimeStamp = Cell(0);
          var touchEnd = function (t) {
            var target = SugarElement.fromDom(t.target);
            if (name(target) === 'td' || name(target) === 'th') {
              var lT = lastTarget.get();
              var lTS = lastTimeStamp.get();
              if (eq$1(lT, target) && t.timeStamp - lTS < 300) {
                t.preventDefault();
                external$1(target, target);
              }
            }
            lastTarget.set(target);
            lastTimeStamp.set(t.timeStamp);
          };
          return { touchEnd: touchEnd };
        };
        var doubleTap = getDoubleTap();
        editor.on('dragstart', dragStart);
        editor.on('mousedown', mouseDown);
        editor.on('mouseover', mouseOver);
        editor.on('mouseup', mouseUp);
        editor.on('touchend', doubleTap.touchEnd);
        editor.on('keyup', keyup);
        editor.on('keydown', keydown);
        editor.on('NodeChange', syncSelection);
      });
      return { clear: annotations.clear };
    }

    var child = function (scope, selector) {
      return child$1(scope, selector).isSome();
    };

    var getSelectionTargets = function (editor, selections) {
      var targets = Cell(Optional.none());
      var changeHandlers = Cell([]);
      var selectionDetails = Optional.none();
      var isCaption = isTag('caption');
      var isDisabledForSelection = function (key) {
        return selectionDetails.forall(function (details) {
          return !details[key];
        });
      };
      var getStart = function () {
        return getSelectionCellOrCaption(getSelectionStart(editor), getIsRoot(editor));
      };
      var getEnd = function () {
        return getSelectionCellOrCaption(getSelectionEnd(editor), getIsRoot(editor));
      };
      var findTargets = function () {
        return getStart().bind(function (startCellOrCaption) {
          return flatten(lift2(table(startCellOrCaption), getEnd().bind(table), function (startTable, endTable) {
            if (eq$1(startTable, endTable)) {
              if (isCaption(startCellOrCaption)) {
                return Optional.some(noMenu(startCellOrCaption));
              } else {
                return Optional.some(forMenu(selections, startTable, startCellOrCaption));
              }
            }
            return Optional.none();
          }));
        });
      };
      var getExtractedDetails = function (targets) {
        var tableOpt = table(targets.element);
        return tableOpt.map(function (table) {
          var warehouse = Warehouse.fromTable(table);
          var selectedCells = onCells(warehouse, targets).getOr([]);
          var locked = foldl(selectedCells, function (acc, cell) {
            if (cell.isLocked) {
              acc.onAny = true;
              if (cell.column === 0) {
                acc.onFirst = true;
              } else if (cell.column + cell.colspan >= warehouse.grid.columns) {
                acc.onLast = true;
              }
            }
            return acc;
          }, {
            onAny: false,
            onFirst: false,
            onLast: false
          });
          return {
            mergeable: onUnlockedMergable(warehouse, targets).isSome(),
            unmergeable: onUnlockedUnmergable(warehouse, targets).isSome(),
            locked: locked
          };
        });
      };
      var resetTargets = function () {
        targets.set(cached(findTargets)());
        selectionDetails = targets.get().bind(getExtractedDetails);
        each$2(changeHandlers.get(), function (handler) {
          return handler();
        });
      };
      var setupHandler = function (handler) {
        handler();
        changeHandlers.set(changeHandlers.get().concat([handler]));
        return function () {
          changeHandlers.set(filter$2(changeHandlers.get(), function (h) {
            return h !== handler;
          }));
        };
      };
      var onSetup = function (api, isDisabled) {
        return setupHandler(function () {
          return targets.get().fold(function () {
            api.setDisabled(true);
          }, function (targets) {
            api.setDisabled(isDisabled(targets));
          });
        });
      };
      var onSetupWithToggle = function (api, isDisabled, isActive) {
        return setupHandler(function () {
          return targets.get().fold(function () {
            api.setDisabled(true);
            api.setActive(false);
          }, function (targets) {
            api.setDisabled(isDisabled(targets));
            api.setActive(isActive(targets));
          });
        });
      };
      var isDisabledFromLocked = function (lockedDisable) {
        return selectionDetails.exists(function (details) {
          return details.locked[lockedDisable];
        });
      };
      var onSetupTable = function (api) {
        return onSetup(api, function (_) {
          return false;
        });
      };
      var onSetupCellOrRow = function (api) {
        return onSetup(api, function (targets) {
          return isCaption(targets.element);
        });
      };
      var onSetupColumn = function (lockedDisable) {
        return function (api) {
          return onSetup(api, function (targets) {
            return isCaption(targets.element) || isDisabledFromLocked(lockedDisable);
          });
        };
      };
      var onSetupPasteable = function (getClipboardData) {
        return function (api) {
          return onSetup(api, function (targets) {
            return isCaption(targets.element) || getClipboardData().isNone();
          });
        };
      };
      var onSetupPasteableColumn = function (getClipboardData, lockedDisable) {
        return function (api) {
          return onSetup(api, function (targets) {
            return isCaption(targets.element) || getClipboardData().isNone() || isDisabledFromLocked(lockedDisable);
          });
        };
      };
      var onSetupMergeable = function (api) {
        return onSetup(api, function (_targets) {
          return isDisabledForSelection('mergeable');
        });
      };
      var onSetupUnmergeable = function (api) {
        return onSetup(api, function (_targets) {
          return isDisabledForSelection('unmergeable');
        });
      };
      var onSetupTableWithCaption = function (api) {
        return onSetupWithToggle(api, never, function (targets) {
          var tableOpt = table(targets.element, getIsRoot(editor));
          return tableOpt.exists(function (table) {
            return child(table, 'caption');
          });
        });
      };
      var onSetupTableHeaders = function (command, headerType) {
        return function (api) {
          return onSetupWithToggle(api, function (targets) {
            return isCaption(targets.element);
          }, function () {
            return editor.queryCommandValue(command) === headerType;
          });
        };
      };
      var onSetupTableRowHeaders = onSetupTableHeaders('mceTableRowType', 'header');
      var onSetupTableColumnHeaders = onSetupTableHeaders('mceTableColType', 'th');
      editor.on('NodeChange ExecCommand TableSelectorChange', resetTargets);
      return {
        onSetupTable: onSetupTable,
        onSetupCellOrRow: onSetupCellOrRow,
        onSetupColumn: onSetupColumn,
        onSetupPasteable: onSetupPasteable,
        onSetupPasteableColumn: onSetupPasteableColumn,
        onSetupMergeable: onSetupMergeable,
        onSetupUnmergeable: onSetupUnmergeable,
        resetTargets: resetTargets,
        onSetupTableWithCaption: onSetupTableWithCaption,
        onSetupTableRowHeaders: onSetupTableRowHeaders,
        onSetupTableColumnHeaders: onSetupTableColumnHeaders,
        targets: targets.get
      };
    };

    var addButtons = function (editor, selections, selectionTargets, clipboard) {
      editor.ui.registry.addMenuButton('table', {
        tooltip: 'Table',
        icon: 'table',
        fetch: function (callback) {
          return callback('inserttable | cell row column | advtablesort | tableprops deletetable');
        }
      });
      var cmd = function (command) {
        return function () {
          return editor.execCommand(command);
        };
      };
      editor.ui.registry.addButton('tableprops', {
        tooltip: 'Table properties',
        onAction: cmd('mceTableProps'),
        icon: 'table',
        onSetup: selectionTargets.onSetupTable
      });
      editor.ui.registry.addButton('tabledelete', {
        tooltip: 'Delete table',
        onAction: cmd('mceTableDelete'),
        icon: 'table-delete-table',
        onSetup: selectionTargets.onSetupTable
      });
      editor.ui.registry.addButton('tablecellprops', {
        tooltip: 'Cell properties',
        onAction: cmd('mceTableCellProps'),
        icon: 'table-cell-properties',
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addButton('tablemergecells', {
        tooltip: 'Merge cells',
        onAction: cmd('mceTableMergeCells'),
        icon: 'table-merge-cells',
        onSetup: selectionTargets.onSetupMergeable
      });
      editor.ui.registry.addButton('tablesplitcells', {
        tooltip: 'Split cell',
        onAction: cmd('mceTableSplitCells'),
        icon: 'table-split-cells',
        onSetup: selectionTargets.onSetupUnmergeable
      });
      editor.ui.registry.addButton('tableinsertrowbefore', {
        tooltip: 'Insert row before',
        onAction: cmd('mceTableInsertRowBefore'),
        icon: 'table-insert-row-above',
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addButton('tableinsertrowafter', {
        tooltip: 'Insert row after',
        onAction: cmd('mceTableInsertRowAfter'),
        icon: 'table-insert-row-after',
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addButton('tabledeleterow', {
        tooltip: 'Delete row',
        onAction: cmd('mceTableDeleteRow'),
        icon: 'table-delete-row',
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addButton('tablerowprops', {
        tooltip: 'Row properties',
        onAction: cmd('mceTableRowProps'),
        icon: 'table-row-properties',
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addButton('tableinsertcolbefore', {
        tooltip: 'Insert column before',
        onAction: cmd('mceTableInsertColBefore'),
        icon: 'table-insert-column-before',
        onSetup: selectionTargets.onSetupColumn('onFirst')
      });
      editor.ui.registry.addButton('tableinsertcolafter', {
        tooltip: 'Insert column after',
        onAction: cmd('mceTableInsertColAfter'),
        icon: 'table-insert-column-after',
        onSetup: selectionTargets.onSetupColumn('onLast')
      });
      editor.ui.registry.addButton('tabledeletecol', {
        tooltip: 'Delete column',
        onAction: cmd('mceTableDeleteCol'),
        icon: 'table-delete-column',
        onSetup: selectionTargets.onSetupColumn('onAny')
      });
      editor.ui.registry.addButton('tablecutrow', {
        tooltip: 'Cut row',
        icon: 'cut-row',
        onAction: cmd('mceTableCutRow'),
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addButton('tablecopyrow', {
        tooltip: 'Copy row',
        icon: 'duplicate-row',
        onAction: cmd('mceTableCopyRow'),
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addButton('tablepasterowbefore', {
        tooltip: 'Paste row before',
        icon: 'paste-row-before',
        onAction: cmd('mceTablePasteRowBefore'),
        onSetup: selectionTargets.onSetupPasteable(clipboard.getRows)
      });
      editor.ui.registry.addButton('tablepasterowafter', {
        tooltip: 'Paste row after',
        icon: 'paste-row-after',
        onAction: cmd('mceTablePasteRowAfter'),
        onSetup: selectionTargets.onSetupPasteable(clipboard.getRows)
      });
      editor.ui.registry.addButton('tablecutcol', {
        tooltip: 'Cut column',
        icon: 'cut-column',
        onAction: cmd('mceTableCutCol'),
        onSetup: selectionTargets.onSetupColumn('onAny')
      });
      editor.ui.registry.addButton('tablecopycol', {
        tooltip: 'Copy column',
        icon: 'duplicate-column',
        onAction: cmd('mceTableCopyCol'),
        onSetup: selectionTargets.onSetupColumn('onAny')
      });
      editor.ui.registry.addButton('tablepastecolbefore', {
        tooltip: 'Paste column before',
        icon: 'paste-column-before',
        onAction: cmd('mceTablePasteColBefore'),
        onSetup: selectionTargets.onSetupPasteableColumn(clipboard.getColumns, 'onFirst')
      });
      editor.ui.registry.addButton('tablepastecolafter', {
        tooltip: 'Paste column after',
        icon: 'paste-column-after',
        onAction: cmd('mceTablePasteColAfter'),
        onSetup: selectionTargets.onSetupPasteableColumn(clipboard.getColumns, 'onLast')
      });
      editor.ui.registry.addButton('tableinsertdialog', {
        tooltip: 'Insert table',
        onAction: cmd('mceInsertTable'),
        icon: 'table'
      });
      var tableClassList = filterNoneItem(getTableClassList(editor));
      if (tableClassList.length !== 0) {
        editor.ui.registry.addMenuButton('tableclass', {
          icon: 'table-classes',
          tooltip: 'Table styles',
          fetch: generateMenuItemsCallback(editor, selections, tableClassList, 'tableclass', function (value) {
            return editor.execCommand('mceTableToggleClass', false, value);
          }),
          onSetup: selectionTargets.onSetupTable
        });
      }
      var tableCellClassList = filterNoneItem(getCellClassList(editor));
      if (tableCellClassList.length !== 0) {
        editor.ui.registry.addMenuButton('tablecellclass', {
          icon: 'table-cell-classes',
          tooltip: 'Cell styles',
          fetch: generateMenuItemsCallback(editor, selections, tableCellClassList, 'tablecellclass', function (value) {
            return editor.execCommand('mceTableCellToggleClass', false, value);
          }),
          onSetup: selectionTargets.onSetupCellOrRow
        });
      }
      editor.ui.registry.addMenuButton('tablecellvalign', {
        icon: 'vertical-align',
        tooltip: 'Vertical align',
        fetch: generateMenuItemsCallback(editor, selections, verticalAlignValues, 'tablecellverticalalign', applyTableCellStyle(editor, 'vertical-align')),
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addMenuButton('tablecellborderwidth', {
        icon: 'border-width',
        tooltip: 'Border width',
        fetch: generateMenuItemsCallback(editor, selections, getTableBorderWidths(editor), 'tablecellborderwidth', applyTableCellStyle(editor, 'border-width')),
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addMenuButton('tablecellborderstyle', {
        icon: 'border-style',
        tooltip: 'Border style',
        fetch: generateMenuItemsCallback(editor, selections, getTableBorderStyles(editor), 'tablecellborderstyle', applyTableCellStyle(editor, 'border-style')),
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addToggleButton('tablecaption', {
        tooltip: 'Table caption',
        onAction: cmd('mceTableToggleCaption'),
        icon: 'table-caption',
        onSetup: selectionTargets.onSetupTableWithCaption
      });
      editor.ui.registry.addMenuButton('tablecellbackgroundcolor', {
        icon: 'cell-background-color',
        tooltip: 'Background color',
        fetch: function (callback) {
          return callback(buildColorMenu(editor, getTableBackgroundColorMap(editor), 'background-color'));
        },
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addMenuButton('tablecellbordercolor', {
        icon: 'cell-border-color',
        tooltip: 'Border color',
        fetch: function (callback) {
          return callback(buildColorMenu(editor, getTableBorderColorMap(editor), 'border-color'));
        },
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addToggleButton('tablerowheader', {
        tooltip: 'Row header',
        icon: 'table-top-header',
        onAction: changeRowHeader(editor),
        onSetup: selectionTargets.onSetupTableRowHeaders
      });
      editor.ui.registry.addToggleButton('tablecolheader', {
        tooltip: 'Column header',
        icon: 'table-left-header',
        onAction: changeColumnHeader(editor),
        onSetup: selectionTargets.onSetupTableColumnHeaders
      });
    };
    var addToolbars = function (editor) {
      var isTable = function (table) {
        return editor.dom.is(table, 'table') && editor.getBody().contains(table);
      };
      var toolbar = getToolbar(editor);
      if (toolbar.length > 0) {
        editor.ui.registry.addContextToolbar('table', {
          predicate: isTable,
          items: toolbar,
          scope: 'node',
          position: 'node'
        });
      }
    };

    var addMenuItems = function (editor, selections, selectionTargets, clipboard) {
      var cmd = function (command) {
        return function () {
          return editor.execCommand(command);
        };
      };
      var insertTableAction = function (data) {
        editor.execCommand('mceInsertTable', false, {
          rows: data.numRows,
          columns: data.numColumns
        });
      };
      var tableProperties = {
        text: 'Table properties',
        onSetup: selectionTargets.onSetupTable,
        onAction: cmd('mceTableProps')
      };
      var deleteTable = {
        text: 'Delete table',
        icon: 'table-delete-table',
        onSetup: selectionTargets.onSetupTable,
        onAction: cmd('mceTableDelete')
      };
      editor.ui.registry.addMenuItem('tableinsertrowbefore', {
        text: 'Insert row before',
        icon: 'table-insert-row-above',
        onAction: cmd('mceTableInsertRowBefore'),
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addMenuItem('tableinsertrowafter', {
        text: 'Insert row after',
        icon: 'table-insert-row-after',
        onAction: cmd('mceTableInsertRowAfter'),
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addMenuItem('tabledeleterow', {
        text: 'Delete row',
        icon: 'table-delete-row',
        onAction: cmd('mceTableDeleteRow'),
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addMenuItem('tablerowprops', {
        text: 'Row properties',
        icon: 'table-row-properties',
        onAction: cmd('mceTableRowProps'),
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addMenuItem('tablecutrow', {
        text: 'Cut row',
        icon: 'cut-row',
        onAction: cmd('mceTableCutRow'),
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addMenuItem('tablecopyrow', {
        text: 'Copy row',
        icon: 'duplicate-row',
        onAction: cmd('mceTableCopyRow'),
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addMenuItem('tablepasterowbefore', {
        text: 'Paste row before',
        icon: 'paste-row-before',
        onAction: cmd('mceTablePasteRowBefore'),
        onSetup: selectionTargets.onSetupPasteable(clipboard.getRows)
      });
      editor.ui.registry.addMenuItem('tablepasterowafter', {
        text: 'Paste row after',
        icon: 'paste-row-after',
        onAction: cmd('mceTablePasteRowAfter'),
        onSetup: selectionTargets.onSetupPasteable(clipboard.getRows)
      });
      var row = {
        type: 'nestedmenuitem',
        text: 'Row',
        getSubmenuItems: constant('tableinsertrowbefore tableinsertrowafter tabledeleterow tablerowprops | tablecutrow tablecopyrow tablepasterowbefore tablepasterowafter')
      };
      editor.ui.registry.addMenuItem('tableinsertcolumnbefore', {
        text: 'Insert column before',
        icon: 'table-insert-column-before',
        onAction: cmd('mceTableInsertColBefore'),
        onSetup: selectionTargets.onSetupColumn('onFirst')
      });
      editor.ui.registry.addMenuItem('tableinsertcolumnafter', {
        text: 'Insert column after',
        icon: 'table-insert-column-after',
        onAction: cmd('mceTableInsertColAfter'),
        onSetup: selectionTargets.onSetupColumn('onLast')
      });
      editor.ui.registry.addMenuItem('tabledeletecolumn', {
        text: 'Delete column',
        icon: 'table-delete-column',
        onAction: cmd('mceTableDeleteCol'),
        onSetup: selectionTargets.onSetupColumn('onAny')
      });
      editor.ui.registry.addMenuItem('tablecutcolumn', {
        text: 'Cut column',
        icon: 'cut-column',
        onAction: cmd('mceTableCutCol'),
        onSetup: selectionTargets.onSetupColumn('onAny')
      });
      editor.ui.registry.addMenuItem('tablecopycolumn', {
        text: 'Copy column',
        icon: 'duplicate-column',
        onAction: cmd('mceTableCopyCol'),
        onSetup: selectionTargets.onSetupColumn('onAny')
      });
      editor.ui.registry.addMenuItem('tablepastecolumnbefore', {
        text: 'Paste column before',
        icon: 'paste-column-before',
        onAction: cmd('mceTablePasteColBefore'),
        onSetup: selectionTargets.onSetupPasteableColumn(clipboard.getColumns, 'onFirst')
      });
      editor.ui.registry.addMenuItem('tablepastecolumnafter', {
        text: 'Paste column after',
        icon: 'paste-column-after',
        onAction: cmd('mceTablePasteColAfter'),
        onSetup: selectionTargets.onSetupPasteableColumn(clipboard.getColumns, 'onLast')
      });
      var column = {
        type: 'nestedmenuitem',
        text: 'Column',
        getSubmenuItems: constant('tableinsertcolumnbefore tableinsertcolumnafter tabledeletecolumn | tablecutcolumn tablecopycolumn tablepastecolumnbefore tablepastecolumnafter')
      };
      editor.ui.registry.addMenuItem('tablecellprops', {
        text: 'Cell properties',
        icon: 'table-cell-properties',
        onAction: cmd('mceTableCellProps'),
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addMenuItem('tablemergecells', {
        text: 'Merge cells',
        icon: 'table-merge-cells',
        onAction: cmd('mceTableMergeCells'),
        onSetup: selectionTargets.onSetupMergeable
      });
      editor.ui.registry.addMenuItem('tablesplitcells', {
        text: 'Split cell',
        icon: 'table-split-cells',
        onAction: cmd('mceTableSplitCells'),
        onSetup: selectionTargets.onSetupUnmergeable
      });
      var cell = {
        type: 'nestedmenuitem',
        text: 'Cell',
        getSubmenuItems: constant('tablecellprops tablemergecells tablesplitcells')
      };
      if (hasTableGrid(editor) === false) {
        editor.ui.registry.addMenuItem('inserttable', {
          text: 'Table',
          icon: 'table',
          onAction: cmd('mceInsertTable')
        });
      } else {
        editor.ui.registry.addNestedMenuItem('inserttable', {
          text: 'Table',
          icon: 'table',
          getSubmenuItems: function () {
            return [{
                type: 'fancymenuitem',
                fancytype: 'inserttable',
                onAction: insertTableAction
              }];
          }
        });
      }
      editor.ui.registry.addMenuItem('inserttabledialog', {
        text: 'Insert table',
        icon: 'table',
        onAction: cmd('mceInsertTable')
      });
      editor.ui.registry.addMenuItem('tableprops', tableProperties);
      editor.ui.registry.addMenuItem('deletetable', deleteTable);
      editor.ui.registry.addNestedMenuItem('row', row);
      editor.ui.registry.addNestedMenuItem('column', column);
      editor.ui.registry.addNestedMenuItem('cell', cell);
      editor.ui.registry.addContextMenu('table', {
        update: function () {
          selectionTargets.resetTargets();
          return selectionTargets.targets().fold(constant(''), function (targets) {
            if (name(targets.element) === 'caption') {
              return 'tableprops deletetable';
            } else {
              return 'cell row column | advtablesort | tableprops deletetable';
            }
          });
        }
      });
      var tableClassList = filterNoneItem(getTableClassList(editor));
      if (tableClassList.length !== 0) {
        editor.ui.registry.addNestedMenuItem('tableclass', {
          icon: 'table-classes',
          text: 'Table styles',
          getSubmenuItems: function () {
            return buildMenuItems(editor, selections, tableClassList, 'tableclass', function (value) {
              return editor.execCommand('mceTableToggleClass', false, value);
            });
          },
          onSetup: selectionTargets.onSetupTable
        });
      }
      var tableCellClassList = filterNoneItem(getCellClassList(editor));
      if (tableCellClassList.length !== 0) {
        editor.ui.registry.addNestedMenuItem('tablecellclass', {
          icon: 'table-cell-classes',
          text: 'Cell styles',
          getSubmenuItems: function () {
            return buildMenuItems(editor, selections, tableCellClassList, 'tablecellclass', function (value) {
              return editor.execCommand('mceTableCellToggleClass', false, value);
            });
          },
          onSetup: selectionTargets.onSetupCellOrRow
        });
      }
      editor.ui.registry.addNestedMenuItem('tablecellvalign', {
        icon: 'vertical-align',
        text: 'Vertical align',
        getSubmenuItems: function () {
          return buildMenuItems(editor, selections, verticalAlignValues, 'tablecellverticalalign', applyTableCellStyle(editor, 'vertical-align'));
        },
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addNestedMenuItem('tablecellborderwidth', {
        icon: 'border-width',
        text: 'Border width',
        getSubmenuItems: function () {
          return buildMenuItems(editor, selections, getTableBorderWidths(editor), 'tablecellborderwidth', applyTableCellStyle(editor, 'border-width'));
        },
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addNestedMenuItem('tablecellborderstyle', {
        icon: 'border-style',
        text: 'Border style',
        getSubmenuItems: function () {
          return buildMenuItems(editor, selections, getTableBorderStyles(editor), 'tablecellborderstyle', applyTableCellStyle(editor, 'border-style'));
        },
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addToggleMenuItem('tablecaption', {
        icon: 'table-caption',
        text: 'Table caption',
        onAction: cmd('mceTableToggleCaption'),
        onSetup: selectionTargets.onSetupTableWithCaption
      });
      editor.ui.registry.addNestedMenuItem('tablecellbackgroundcolor', {
        icon: 'cell-background-color',
        text: 'Background color',
        getSubmenuItems: function () {
          return buildColorMenu(editor, getTableBackgroundColorMap(editor), 'background-color');
        },
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addNestedMenuItem('tablecellbordercolor', {
        icon: 'cell-border-color',
        text: 'Border color',
        getSubmenuItems: function () {
          return buildColorMenu(editor, getTableBorderColorMap(editor), 'border-color');
        },
        onSetup: selectionTargets.onSetupCellOrRow
      });
      editor.ui.registry.addToggleMenuItem('tablerowheader', {
        text: 'Row header',
        icon: 'table-top-header',
        onAction: changeRowHeader(editor),
        onSetup: selectionTargets.onSetupTableRowHeaders
      });
      editor.ui.registry.addToggleMenuItem('tablecolheader', {
        text: 'Column header',
        icon: 'table-left-header',
        onAction: changeColumnHeader(editor),
        onSetup: selectionTargets.onSetupTableColumnHeaders
      });
    };

    var Plugin = function (editor) {
      var selections = Selections(function () {
        return getBody(editor);
      }, function () {
        return getSelectionCell(getSelectionStart(editor), getIsRoot(editor));
      }, ephemera.selectedSelector);
      var selectionTargets = getSelectionTargets(editor, selections);
      var resizeHandler = getResizeHandler(editor);
      var cellSelection = CellSelection(editor, resizeHandler.lazyResize, selectionTargets);
      var actions = TableActions(editor, cellSelection, resizeHandler.lazyWire);
      var clipboard = Clipboard();
      registerCommands(editor, actions, cellSelection, selections, clipboard);
      registerQueryCommands(editor, actions, selections);
      registerEvents(editor, selections, actions);
      addMenuItems(editor, selections, selectionTargets, clipboard);
      addButtons(editor, selections, selectionTargets, clipboard);
      addToolbars(editor);
      editor.on('PreInit', function () {
        editor.serializer.addTempAttr(ephemera.firstSelected);
        editor.serializer.addTempAttr(ephemera.lastSelected);
        registerFormats(editor);
      });
      if (hasTabNavigation(editor)) {
        editor.on('keydown', function (e) {
          handle$1(e, editor, cellSelection);
        });
      }
      editor.on('remove', function () {
        resizeHandler.destroy();
      });
      return getApi(editor, clipboard, resizeHandler, selectionTargets);
    };
    function Plugin$1 () {
      global$3.add('table', Plugin);
    }

    Plugin$1();

}());


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "textcolor" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/textcolor')
//   ES2015:
//     import 'tinymce/plugins/textcolor'
__webpack_require__(1511);

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 *
 * Version: 5.10.5 (2022-05-25)
 */
(function () {
    'use strict';

    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    function Plugin () {
      global.add('textcolor', function () {
      });
    }

    Plugin();

}());


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

// Exports the "wordcount" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/wordcount')
//   ES2015:
//     import 'tinymce/plugins/wordcount'
__webpack_require__(1513);

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 *
 * Version: 5.10.5 (2022-05-25)
 */
(function () {
    'use strict';

    var global$2 = tinymce.util.Tools.resolve('tinymce.PluginManager');

    var identity = function (x) {
      return x;
    };

    var __assign = function () {
      __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };

    var zeroWidth = '\uFEFF';
    var removeZwsp$1 = function (s) {
      return s.replace(/\uFEFF/g, '');
    };

    var map = function (xs, f) {
      var len = xs.length;
      var r = new Array(len);
      for (var i = 0; i < len; i++) {
        var x = xs[i];
        r[i] = f(x, i);
      }
      return r;
    };

    var punctuationStr = '[!-#%-*,-\\/:;?@\\[-\\]_{}\xA1\xAB\xB7\xBB\xBF;\xB7\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1361-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u3008\u3009\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30\u2E31\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uff3f\uFF5B\uFF5D\uFF5F-\uFF65]';
    var regExps = {
      aletter: '[A-Za-z\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05F3\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u10a0-\u10c5\u10d0-\u10fa\u10fc\u1100-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1a00-\u1a16\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bc0-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u24B6-\u24E9\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2d00-\u2d25\u2d30-\u2d65\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005\u303b\u303c\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790\ua791\ua7a0-\ua7a9\ua7fa-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uffa0-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc]',
      midnumlet: '[-\'\\.\u2018\u2019\u2024\uFE52\uFF07\uFF0E]',
      midletter: '[:\xB7\xB7\u05F4\u2027\uFE13\uFE55\uFF1A]',
      midnum: '[\xB1+*/,;;\u0589\u060C\u060D\u066C\u07F8\u2044\uFE10\uFE14\uFE50\uFE54\uFF0C\uFF1B]',
      numeric: '[0-9\u0660-\u0669\u066B\u06f0-\u06f9\u07c0-\u07c9\u0966-\u096f\u09e6-\u09ef\u0a66-\u0a6f\u0ae6-\u0aef\u0b66-\u0b6f\u0be6-\u0bef\u0c66-\u0c6f\u0ce6-\u0cef\u0d66-\u0d6f\u0e50-\u0e59\u0ed0-\u0ed9\u0f20-\u0f29\u1040-\u1049\u1090-\u1099\u17e0-\u17e9\u1810-\u1819\u1946-\u194f\u19d0-\u19d9\u1a80-\u1a89\u1a90-\u1a99\u1b50-\u1b59\u1bb0-\u1bb9\u1c40-\u1c49\u1c50-\u1c59\ua620-\ua629\ua8d0-\ua8d9\ua900-\ua909\ua9d0-\ua9d9\uaa50-\uaa59\uabf0-\uabf9]',
      cr: '\\r',
      lf: '\\n',
      newline: '[\x0B\f\x85\u2028\u2029]',
      extend: '[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065f\u0670\u06d6-\u06dc\u06df-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0859-\u085b\u0900-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962\u0963\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09cb-\u09cd\u09d7\u09e2\u09e3\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2\u0ae3\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0c01-\u0c03\u0c3e-\u0c44\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0c82\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d02\u0d03\u0d3e-\u0d44\u0d46-\u0d48\u0d4a-\u0d4d\u0d57\u0d62\u0d63\u0d82\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0df2\u0df3\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f3e\u0f3f\u0f71-\u0f84\u0f86\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u102b-\u103e\u1056-\u1059\u105e-\u1060\u1062-\u1064\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f\u109a-\u109d\u135d-\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b6-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u192b\u1930-\u193b\u19b0-\u19c0\u19c8\u19c9\u1a17-\u1a1b\u1a55-\u1a5e\u1a60-\u1a7c\u1a7f\u1b00-\u1b04\u1b34-\u1b44\u1b6b-\u1b73\u1b80-\u1b82\u1ba1-\u1baa\u1be6-\u1bf3\u1c24-\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce8\u1ced\u1cf2\u1dc0-\u1de6\u1dfc-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2d7f\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\uA672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua823-\ua827\ua880\ua881\ua8b4-\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua953\ua980-\ua983\ua9b3-\ua9c0\uaa29-\uaa36\uaa43\uaa4c\uaa4d\uaa7b\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe3-\uabea\uabec\uabed\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]',
      format: '[\xAD\u0600-\u0603\u06DD\u070F\u17b4\u17b5\u200E\u200F\u202A-\u202E\u2060-\u2064\u206A-\u206F\uFEFF\uFFF9-\uFFFB]',
      katakana: '[\u3031-\u3035\u309B\u309C\u30A0-\u30fa\u30fc-\u30ff\u31f0-\u31ff\u32D0-\u32FE\u3300-\u3357\uff66-\uff9d]',
      extendnumlet: '[=_\u203f\u2040\u2054\ufe33\ufe34\ufe4d-\ufe4f\uff3f\u2200-\u22FF<>]',
      punctuation: punctuationStr
    };
    var characterIndices = {
      ALETTER: 0,
      MIDNUMLET: 1,
      MIDLETTER: 2,
      MIDNUM: 3,
      NUMERIC: 4,
      CR: 5,
      LF: 6,
      NEWLINE: 7,
      EXTEND: 8,
      FORMAT: 9,
      KATAKANA: 10,
      EXTENDNUMLET: 11,
      AT: 12,
      OTHER: 13
    };
    var SETS$1 = [
      new RegExp(regExps.aletter),
      new RegExp(regExps.midnumlet),
      new RegExp(regExps.midletter),
      new RegExp(regExps.midnum),
      new RegExp(regExps.numeric),
      new RegExp(regExps.cr),
      new RegExp(regExps.lf),
      new RegExp(regExps.newline),
      new RegExp(regExps.extend),
      new RegExp(regExps.format),
      new RegExp(regExps.katakana),
      new RegExp(regExps.extendnumlet),
      new RegExp('@')
    ];
    var EMPTY_STRING$1 = '';
    var PUNCTUATION$1 = new RegExp('^' + regExps.punctuation + '$');
    var WHITESPACE$1 = /^\s+$/;

    var SETS = SETS$1;
    var OTHER = characterIndices.OTHER;
    var getType = function (char) {
      var type = OTHER;
      var setsLength = SETS.length;
      for (var j = 0; j < setsLength; ++j) {
        var set = SETS[j];
        if (set && set.test(char)) {
          type = j;
          break;
        }
      }
      return type;
    };
    var memoize = function (func) {
      var cache = {};
      return function (char) {
        if (cache[char]) {
          return cache[char];
        } else {
          var result = func(char);
          cache[char] = result;
          return result;
        }
      };
    };
    var classify = function (characters) {
      var memoized = memoize(getType);
      return map(characters, memoized);
    };

    var isWordBoundary = function (map, index) {
      var type = map[index];
      var nextType = map[index + 1];
      if (index < 0 || index > map.length - 1 && index !== 0) {
        return false;
      }
      if (type === characterIndices.ALETTER && nextType === characterIndices.ALETTER) {
        return false;
      }
      var nextNextType = map[index + 2];
      if (type === characterIndices.ALETTER && (nextType === characterIndices.MIDLETTER || nextType === characterIndices.MIDNUMLET || nextType === characterIndices.AT) && nextNextType === characterIndices.ALETTER) {
        return false;
      }
      var prevType = map[index - 1];
      if ((type === characterIndices.MIDLETTER || type === characterIndices.MIDNUMLET || nextType === characterIndices.AT) && nextType === characterIndices.ALETTER && prevType === characterIndices.ALETTER) {
        return false;
      }
      if ((type === characterIndices.NUMERIC || type === characterIndices.ALETTER) && (nextType === characterIndices.NUMERIC || nextType === characterIndices.ALETTER)) {
        return false;
      }
      if ((type === characterIndices.MIDNUM || type === characterIndices.MIDNUMLET) && nextType === characterIndices.NUMERIC && prevType === characterIndices.NUMERIC) {
        return false;
      }
      if (type === characterIndices.NUMERIC && (nextType === characterIndices.MIDNUM || nextType === characterIndices.MIDNUMLET) && nextNextType === characterIndices.NUMERIC) {
        return false;
      }
      if (type === characterIndices.EXTEND || type === characterIndices.FORMAT || prevType === characterIndices.EXTEND || prevType === characterIndices.FORMAT || nextType === characterIndices.EXTEND || nextType === characterIndices.FORMAT) {
        return false;
      }
      if (type === characterIndices.CR && nextType === characterIndices.LF) {
        return false;
      }
      if (type === characterIndices.NEWLINE || type === characterIndices.CR || type === characterIndices.LF) {
        return true;
      }
      if (nextType === characterIndices.NEWLINE || nextType === characterIndices.CR || nextType === characterIndices.LF) {
        return true;
      }
      if (type === characterIndices.KATAKANA && nextType === characterIndices.KATAKANA) {
        return false;
      }
      if (nextType === characterIndices.EXTENDNUMLET && (type === characterIndices.ALETTER || type === characterIndices.NUMERIC || type === characterIndices.KATAKANA || type === characterIndices.EXTENDNUMLET)) {
        return false;
      }
      if (type === characterIndices.EXTENDNUMLET && (nextType === characterIndices.ALETTER || nextType === characterIndices.NUMERIC || nextType === characterIndices.KATAKANA)) {
        return false;
      }
      if (type === characterIndices.AT) {
        return false;
      }
      return true;
    };

    var EMPTY_STRING = EMPTY_STRING$1;
    var WHITESPACE = WHITESPACE$1;
    var PUNCTUATION = PUNCTUATION$1;
    var isProtocol = function (str) {
      return str === 'http' || str === 'https';
    };
    var findWordEnd = function (characters, startIndex) {
      var i;
      for (i = startIndex; i < characters.length; i++) {
        if (WHITESPACE.test(characters[i])) {
          break;
        }
      }
      return i;
    };
    var findUrlEnd = function (characters, startIndex) {
      var endIndex = findWordEnd(characters, startIndex + 1);
      var peakedWord = characters.slice(startIndex + 1, endIndex).join(EMPTY_STRING);
      return peakedWord.substr(0, 3) === '://' ? endIndex : startIndex;
    };
    var findWords = function (chars, sChars, characterMap, options) {
      var words = [];
      var word = [];
      for (var i = 0; i < characterMap.length; ++i) {
        word.push(chars[i]);
        if (isWordBoundary(characterMap, i)) {
          var ch = sChars[i];
          if ((options.includeWhitespace || !WHITESPACE.test(ch)) && (options.includePunctuation || !PUNCTUATION.test(ch))) {
            var startOfWord = i - word.length + 1;
            var endOfWord = i + 1;
            var str = sChars.slice(startOfWord, endOfWord).join(EMPTY_STRING);
            if (isProtocol(str)) {
              var endOfUrl = findUrlEnd(sChars, i);
              var url = chars.slice(endOfWord, endOfUrl);
              Array.prototype.push.apply(word, url);
              i = endOfUrl;
            }
            words.push(word);
          }
          word = [];
        }
      }
      return words;
    };
    var getDefaultOptions = function () {
      return {
        includeWhitespace: false,
        includePunctuation: false
      };
    };
    var getWords$1 = function (chars, extract, options) {
      options = __assign(__assign({}, getDefaultOptions()), options);
      var filteredChars = [];
      var extractedChars = [];
      for (var i = 0; i < chars.length; i++) {
        var ch = extract(chars[i]);
        if (ch !== zeroWidth) {
          filteredChars.push(chars[i]);
          extractedChars.push(ch);
        }
      }
      var characterMap = classify(extractedChars);
      return findWords(filteredChars, extractedChars, characterMap, options);
    };

    var getWords = getWords$1;

    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.TreeWalker');

    var getText = function (node, schema) {
      var blockElements = schema.getBlockElements();
      var shortEndedElements = schema.getShortEndedElements();
      var isNewline = function (node) {
        return blockElements[node.nodeName] || shortEndedElements[node.nodeName];
      };
      var textBlocks = [];
      var txt = '';
      var treeWalker = new global$1(node, node);
      while (node = treeWalker.next()) {
        if (node.nodeType === 3) {
          txt += removeZwsp$1(node.data);
        } else if (isNewline(node) && txt.length) {
          textBlocks.push(txt);
          txt = '';
        }
      }
      if (txt.length) {
        textBlocks.push(txt);
      }
      return textBlocks;
    };

    var removeZwsp = function (text) {
      return text.replace(/\u200B/g, '');
    };
    var strLen = function (str) {
      return str.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, '_').length;
    };
    var countWords = function (node, schema) {
      var text = removeZwsp(getText(node, schema).join('\n'));
      return getWords(text.split(''), identity).length;
    };
    var countCharacters = function (node, schema) {
      var text = getText(node, schema).join('');
      return strLen(text);
    };
    var countCharactersWithoutSpaces = function (node, schema) {
      var text = getText(node, schema).join('').replace(/\s/g, '');
      return strLen(text);
    };

    var createBodyCounter = function (editor, count) {
      return function () {
        return count(editor.getBody(), editor.schema);
      };
    };
    var createSelectionCounter = function (editor, count) {
      return function () {
        return count(editor.selection.getRng().cloneContents(), editor.schema);
      };
    };
    var createBodyWordCounter = function (editor) {
      return createBodyCounter(editor, countWords);
    };
    var get = function (editor) {
      return {
        body: {
          getWordCount: createBodyWordCounter(editor),
          getCharacterCount: createBodyCounter(editor, countCharacters),
          getCharacterCountWithoutSpaces: createBodyCounter(editor, countCharactersWithoutSpaces)
        },
        selection: {
          getWordCount: createSelectionCounter(editor, countWords),
          getCharacterCount: createSelectionCounter(editor, countCharacters),
          getCharacterCountWithoutSpaces: createSelectionCounter(editor, countCharactersWithoutSpaces)
        },
        getCount: createBodyWordCounter(editor)
      };
    };

    var open = function (editor, api) {
      editor.windowManager.open({
        title: 'Word Count',
        body: {
          type: 'panel',
          items: [{
              type: 'table',
              header: [
                'Count',
                'Document',
                'Selection'
              ],
              cells: [
                [
                  'Words',
                  String(api.body.getWordCount()),
                  String(api.selection.getWordCount())
                ],
                [
                  'Characters (no spaces)',
                  String(api.body.getCharacterCountWithoutSpaces()),
                  String(api.selection.getCharacterCountWithoutSpaces())
                ],
                [
                  'Characters',
                  String(api.body.getCharacterCount()),
                  String(api.selection.getCharacterCount())
                ]
              ]
            }]
        },
        buttons: [{
            type: 'cancel',
            name: 'close',
            text: 'Close',
            primary: true
          }]
      });
    };

    var register$1 = function (editor, api) {
      editor.addCommand('mceWordCount', function () {
        return open(editor, api);
      });
    };

    var global = tinymce.util.Tools.resolve('tinymce.util.Delay');

    var fireWordCountUpdate = function (editor, api) {
      editor.fire('wordCountUpdate', {
        wordCount: {
          words: api.body.getWordCount(),
          characters: api.body.getCharacterCount(),
          charactersWithoutSpaces: api.body.getCharacterCountWithoutSpaces()
        }
      });
    };

    var updateCount = function (editor, api) {
      fireWordCountUpdate(editor, api);
    };
    var setup = function (editor, api, delay) {
      var debouncedUpdate = global.debounce(function () {
        return updateCount(editor, api);
      }, delay);
      editor.on('init', function () {
        updateCount(editor, api);
        global.setEditorTimeout(editor, function () {
          editor.on('SetContent BeforeAddUndo Undo Redo ViewUpdate keyup', debouncedUpdate);
        }, 0);
      });
    };

    var register = function (editor) {
      var onAction = function () {
        return editor.execCommand('mceWordCount');
      };
      editor.ui.registry.addButton('wordcount', {
        tooltip: 'Word count',
        icon: 'character-count',
        onAction: onAction
      });
      editor.ui.registry.addMenuItem('wordcount', {
        text: 'Word count',
        icon: 'character-count',
        onAction: onAction
      });
    };

    function Plugin (delay) {
      if (delay === void 0) {
        delay = 300;
      }
      global$2.add('wordcount', function (editor) {
        var api = get(editor);
        register$1(editor, api);
        register(editor);
        setup(editor, api, delay);
        return api;
      });
    }

    Plugin();

}());


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 *
 * Version: 5.10.5 (2022-05-25)
 */
(function () {
    'use strict';

    var typeOf = function (x) {
      var t = typeof x;
      if (x === null) {
        return 'null';
      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
        return 'array';
      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
        return 'string';
      } else {
        return t;
      }
    };
    var isType$1 = function (type) {
      return function (value) {
        return typeOf(value) === type;
      };
    };
    var isSimpleType = function (type) {
      return function (value) {
        return typeof value === type;
      };
    };
    var eq$1 = function (t) {
      return function (a) {
        return t === a;
      };
    };
    var isString = isType$1('string');
    var isObject = isType$1('object');
    var isArray = isType$1('array');
    var isNull = eq$1(null);
    var isBoolean = isSimpleType('boolean');
    var isUndefined = eq$1(undefined);
    var isNullable = function (a) {
      return a === null || a === undefined;
    };
    var isNonNullable = function (a) {
      return !isNullable(a);
    };
    var isFunction = isSimpleType('function');
    var isNumber = isSimpleType('number');
    var isArrayOf = function (value, pred) {
      if (isArray(value)) {
        for (var i = 0, len = value.length; i < len; ++i) {
          if (!pred(value[i])) {
            return false;
          }
        }
        return true;
      }
      return false;
    };

    var noop = function () {
    };
    var noarg = function (f) {
      return function () {
        return f();
      };
    };
    var compose = function (fa, fb) {
      return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        return fa(fb.apply(null, args));
      };
    };
    var compose1 = function (fbc, fab) {
      return function (a) {
        return fbc(fab(a));
      };
    };
    var constant$1 = function (value) {
      return function () {
        return value;
      };
    };
    var identity$1 = function (x) {
      return x;
    };
    var tripleEquals = function (a, b) {
      return a === b;
    };
    function curry(fn) {
      var initialArgs = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        initialArgs[_i - 1] = arguments[_i];
      }
      return function () {
        var restArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          restArgs[_i] = arguments[_i];
        }
        var all = initialArgs.concat(restArgs);
        return fn.apply(null, all);
      };
    }
    var not = function (f) {
      return function (t) {
        return !f(t);
      };
    };
    var die = function (msg) {
      return function () {
        throw new Error(msg);
      };
    };
    var never = constant$1(false);
    var always = constant$1(true);

    var global$g = tinymce.util.Tools.resolve('tinymce.ThemeManager');

    var __assign = function () {
      __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };
    function __rest(s, e) {
      var t = {};
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
          t[p] = s[p];
      if (s != null && typeof Object.getOwnPropertySymbols === 'function')
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
            t[p[i]] = s[p[i]];
        }
      return t;
    }
    function __spreadArray(to, from, pack) {
      if (pack || arguments.length === 2)
        for (var i = 0, l = from.length, ar; i < l; i++) {
          if (ar || !(i in from)) {
            if (!ar)
              ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
          }
        }
      return to.concat(ar || Array.prototype.slice.call(from));
    }

    var none = function () {
      return NONE;
    };
    var NONE = function () {
      var call = function (thunk) {
        return thunk();
      };
      var id = identity$1;
      var me = {
        fold: function (n, _s) {
          return n();
        },
        isSome: never,
        isNone: always,
        getOr: id,
        getOrThunk: call,
        getOrDie: function (msg) {
          throw new Error(msg || 'error: getOrDie called on none.');
        },
        getOrNull: constant$1(null),
        getOrUndefined: constant$1(undefined),
        or: id,
        orThunk: call,
        map: none,
        each: noop,
        bind: none,
        exists: never,
        forall: always,
        filter: function () {
          return none();
        },
        toArray: function () {
          return [];
        },
        toString: constant$1('none()')
      };
      return me;
    }();
    var some = function (a) {
      var constant_a = constant$1(a);
      var self = function () {
        return me;
      };
      var bind = function (f) {
        return f(a);
      };
      var me = {
        fold: function (n, s) {
          return s(a);
        },
        isSome: always,
        isNone: never,
        getOr: constant_a,
        getOrThunk: constant_a,
        getOrDie: constant_a,
        getOrNull: constant_a,
        getOrUndefined: constant_a,
        or: self,
        orThunk: self,
        map: function (f) {
          return some(f(a));
        },
        each: function (f) {
          f(a);
        },
        bind: bind,
        exists: bind,
        forall: bind,
        filter: function (f) {
          return f(a) ? me : NONE;
        },
        toArray: function () {
          return [a];
        },
        toString: function () {
          return 'some(' + a + ')';
        }
      };
      return me;
    };
    var from$1 = function (value) {
      return value === null || value === undefined ? NONE : some(value);
    };
    var Optional = {
      some: some,
      none: none,
      from: from$1
    };

    var nativeSlice = Array.prototype.slice;
    var nativeIndexOf = Array.prototype.indexOf;
    var nativePush = Array.prototype.push;
    var rawIndexOf = function (ts, t) {
      return nativeIndexOf.call(ts, t);
    };
    var indexOf = function (xs, x) {
      var r = rawIndexOf(xs, x);
      return r === -1 ? Optional.none() : Optional.some(r);
    };
    var contains$2 = function (xs, x) {
      return rawIndexOf(xs, x) > -1;
    };
    var exists = function (xs, pred) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i)) {
          return true;
        }
      }
      return false;
    };
    var range$2 = function (num, f) {
      var r = [];
      for (var i = 0; i < num; i++) {
        r.push(f(i));
      }
      return r;
    };
    var chunk$1 = function (array, size) {
      var r = [];
      for (var i = 0; i < array.length; i += size) {
        var s = nativeSlice.call(array, i, i + size);
        r.push(s);
      }
      return r;
    };
    var map$2 = function (xs, f) {
      var len = xs.length;
      var r = new Array(len);
      for (var i = 0; i < len; i++) {
        var x = xs[i];
        r[i] = f(x, i);
      }
      return r;
    };
    var each$1 = function (xs, f) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        f(x, i);
      }
    };
    var eachr = function (xs, f) {
      for (var i = xs.length - 1; i >= 0; i--) {
        var x = xs[i];
        f(x, i);
      }
    };
    var partition$3 = function (xs, pred) {
      var pass = [];
      var fail = [];
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        var arr = pred(x, i) ? pass : fail;
        arr.push(x);
      }
      return {
        pass: pass,
        fail: fail
      };
    };
    var filter$2 = function (xs, pred) {
      var r = [];
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i)) {
          r.push(x);
        }
      }
      return r;
    };
    var foldr = function (xs, f, acc) {
      eachr(xs, function (x, i) {
        acc = f(acc, x, i);
      });
      return acc;
    };
    var foldl = function (xs, f, acc) {
      each$1(xs, function (x, i) {
        acc = f(acc, x, i);
      });
      return acc;
    };
    var findUntil = function (xs, pred, until) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i)) {
          return Optional.some(x);
        } else if (until(x, i)) {
          break;
        }
      }
      return Optional.none();
    };
    var find$5 = function (xs, pred) {
      return findUntil(xs, pred, never);
    };
    var findIndex$1 = function (xs, pred) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i)) {
          return Optional.some(i);
        }
      }
      return Optional.none();
    };
    var flatten = function (xs) {
      var r = [];
      for (var i = 0, len = xs.length; i < len; ++i) {
        if (!isArray(xs[i])) {
          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
        }
        nativePush.apply(r, xs[i]);
      }
      return r;
    };
    var bind$3 = function (xs, f) {
      return flatten(map$2(xs, f));
    };
    var forall = function (xs, pred) {
      for (var i = 0, len = xs.length; i < len; ++i) {
        var x = xs[i];
        if (pred(x, i) !== true) {
          return false;
        }
      }
      return true;
    };
    var reverse = function (xs) {
      var r = nativeSlice.call(xs, 0);
      r.reverse();
      return r;
    };
    var difference = function (a1, a2) {
      return filter$2(a1, function (x) {
        return !contains$2(a2, x);
      });
    };
    var mapToObject = function (xs, f) {
      var r = {};
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        r[String(x)] = f(x, i);
      }
      return r;
    };
    var pure$2 = function (x) {
      return [x];
    };
    var sort = function (xs, comparator) {
      var copy = nativeSlice.call(xs, 0);
      copy.sort(comparator);
      return copy;
    };
    var get$f = function (xs, i) {
      return i >= 0 && i < xs.length ? Optional.some(xs[i]) : Optional.none();
    };
    var head = function (xs) {
      return get$f(xs, 0);
    };
    var last$2 = function (xs) {
      return get$f(xs, xs.length - 1);
    };
    var from = isFunction(Array.from) ? Array.from : function (x) {
      return nativeSlice.call(x);
    };
    var findMap = function (arr, f) {
      for (var i = 0; i < arr.length; i++) {
        var r = f(arr[i], i);
        if (r.isSome()) {
          return r;
        }
      }
      return Optional.none();
    };

    var keys = Object.keys;
    var hasOwnProperty = Object.hasOwnProperty;
    var each = function (obj, f) {
      var props = keys(obj);
      for (var k = 0, len = props.length; k < len; k++) {
        var i = props[k];
        var x = obj[i];
        f(x, i);
      }
    };
    var map$1 = function (obj, f) {
      return tupleMap(obj, function (x, i) {
        return {
          k: i,
          v: f(x, i)
        };
      });
    };
    var tupleMap = function (obj, f) {
      var r = {};
      each(obj, function (x, i) {
        var tuple = f(x, i);
        r[tuple.k] = tuple.v;
      });
      return r;
    };
    var objAcc = function (r) {
      return function (x, i) {
        r[i] = x;
      };
    };
    var internalFilter = function (obj, pred, onTrue, onFalse) {
      var r = {};
      each(obj, function (x, i) {
        (pred(x, i) ? onTrue : onFalse)(x, i);
      });
      return r;
    };
    var filter$1 = function (obj, pred) {
      var t = {};
      internalFilter(obj, pred, objAcc(t), noop);
      return t;
    };
    var mapToArray = function (obj, f) {
      var r = [];
      each(obj, function (value, name) {
        r.push(f(value, name));
      });
      return r;
    };
    var find$4 = function (obj, pred) {
      var props = keys(obj);
      for (var k = 0, len = props.length; k < len; k++) {
        var i = props[k];
        var x = obj[i];
        if (pred(x, i, obj)) {
          return Optional.some(x);
        }
      }
      return Optional.none();
    };
    var values = function (obj) {
      return mapToArray(obj, identity$1);
    };
    var get$e = function (obj, key) {
      return has$2(obj, key) ? Optional.from(obj[key]) : Optional.none();
    };
    var has$2 = function (obj, key) {
      return hasOwnProperty.call(obj, key);
    };
    var hasNonNullableKey = function (obj, key) {
      return has$2(obj, key) && obj[key] !== undefined && obj[key] !== null;
    };

    var is$1 = function (lhs, rhs, comparator) {
      if (comparator === void 0) {
        comparator = tripleEquals;
      }
      return lhs.exists(function (left) {
        return comparator(left, rhs);
      });
    };
    var equals = function (lhs, rhs, comparator) {
      if (comparator === void 0) {
        comparator = tripleEquals;
      }
      return lift2(lhs, rhs, comparator).getOr(lhs.isNone() && rhs.isNone());
    };
    var cat = function (arr) {
      var r = [];
      var push = function (x) {
        r.push(x);
      };
      for (var i = 0; i < arr.length; i++) {
        arr[i].each(push);
      }
      return r;
    };
    var sequence = function (arr) {
      var r = [];
      for (var i = 0; i < arr.length; i++) {
        var x = arr[i];
        if (x.isSome()) {
          r.push(x.getOrDie());
        } else {
          return Optional.none();
        }
      }
      return Optional.some(r);
    };
    var lift2 = function (oa, ob, f) {
      return oa.isSome() && ob.isSome() ? Optional.some(f(oa.getOrDie(), ob.getOrDie())) : Optional.none();
    };
    var lift3 = function (oa, ob, oc, f) {
      return oa.isSome() && ob.isSome() && oc.isSome() ? Optional.some(f(oa.getOrDie(), ob.getOrDie(), oc.getOrDie())) : Optional.none();
    };
    var mapFrom = function (a, f) {
      return a !== undefined && a !== null ? Optional.some(f(a)) : Optional.none();
    };
    var someIf = function (b, a) {
      return b ? Optional.some(a) : Optional.none();
    };

    var addToEnd = function (str, suffix) {
      return str + suffix;
    };
    var removeFromStart = function (str, numChars) {
      return str.substring(numChars);
    };

    var checkRange = function (str, substr, start) {
      return substr === '' || str.length >= substr.length && str.substr(start, start + substr.length) === substr;
    };
    var removeLeading = function (str, prefix) {
      return startsWith(str, prefix) ? removeFromStart(str, prefix.length) : str;
    };
    var ensureTrailing = function (str, suffix) {
      return endsWith(str, suffix) ? str : addToEnd(str, suffix);
    };
    var contains$1 = function (str, substr) {
      return str.indexOf(substr) !== -1;
    };
    var startsWith = function (str, prefix) {
      return checkRange(str, prefix, 0);
    };
    var endsWith = function (str, suffix) {
      return checkRange(str, suffix, str.length - suffix.length);
    };
    var blank = function (r) {
      return function (s) {
        return s.replace(r, '');
      };
    };
    var trim$1 = blank(/^\s+|\s+$/g);
    var isNotEmpty = function (s) {
      return s.length > 0;
    };
    var isEmpty = function (s) {
      return !isNotEmpty(s);
    };

    var isSupported$1 = function (dom) {
      return dom.style !== undefined && isFunction(dom.style.getPropertyValue);
    };

    var fromHtml$2 = function (html, scope) {
      var doc = scope || document;
      var div = doc.createElement('div');
      div.innerHTML = html;
      if (!div.hasChildNodes() || div.childNodes.length > 1) {
        console.error('HTML does not have a single root node', html);
        throw new Error('HTML must have a single root node');
      }
      return fromDom(div.childNodes[0]);
    };
    var fromTag = function (tag, scope) {
      var doc = scope || document;
      var node = doc.createElement(tag);
      return fromDom(node);
    };
    var fromText = function (text, scope) {
      var doc = scope || document;
      var node = doc.createTextNode(text);
      return fromDom(node);
    };
    var fromDom = function (node) {
      if (node === null || node === undefined) {
        throw new Error('Node cannot be null or undefined');
      }
      return { dom: node };
    };
    var fromPoint = function (docElm, x, y) {
      return Optional.from(docElm.dom.elementFromPoint(x, y)).map(fromDom);
    };
    var SugarElement = {
      fromHtml: fromHtml$2,
      fromTag: fromTag,
      fromText: fromText,
      fromDom: fromDom,
      fromPoint: fromPoint
    };

    typeof window !== 'undefined' ? window : Function('return this;')();

    var DOCUMENT = 9;
    var DOCUMENT_FRAGMENT = 11;
    var ELEMENT = 1;
    var TEXT = 3;

    var name$2 = function (element) {
      var r = element.dom.nodeName;
      return r.toLowerCase();
    };
    var type = function (element) {
      return element.dom.nodeType;
    };
    var isType = function (t) {
      return function (element) {
        return type(element) === t;
      };
    };
    var isElement$2 = isType(ELEMENT);
    var isText$1 = isType(TEXT);
    var isDocument = isType(DOCUMENT);
    var isDocumentFragment = isType(DOCUMENT_FRAGMENT);

    var cached = function (f) {
      var called = false;
      var r;
      return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        if (!called) {
          called = true;
          r = f.apply(null, args);
        }
        return r;
      };
    };

    var DeviceType = function (os, browser, userAgent, mediaMatch) {
      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
      var isiPhone = os.isiOS() && !isiPad;
      var isMobile = os.isiOS() || os.isAndroid();
      var isTouch = isMobile || mediaMatch('(pointer:coarse)');
      var isTablet = isiPad || !isiPhone && isMobile && mediaMatch('(min-device-width:768px)');
      var isPhone = isiPhone || isMobile && !isTablet;
      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
      var isDesktop = !isPhone && !isTablet && !iOSwebview;
      return {
        isiPad: constant$1(isiPad),
        isiPhone: constant$1(isiPhone),
        isTablet: constant$1(isTablet),
        isPhone: constant$1(isPhone),
        isTouch: constant$1(isTouch),
        isAndroid: os.isAndroid,
        isiOS: os.isiOS,
        isWebView: constant$1(iOSwebview),
        isDesktop: constant$1(isDesktop)
      };
    };

    var firstMatch = function (regexes, s) {
      for (var i = 0; i < regexes.length; i++) {
        var x = regexes[i];
        if (x.test(s)) {
          return x;
        }
      }
      return undefined;
    };
    var find$3 = function (regexes, agent) {
      var r = firstMatch(regexes, agent);
      if (!r) {
        return {
          major: 0,
          minor: 0
        };
      }
      var group = function (i) {
        return Number(agent.replace(r, '$' + i));
      };
      return nu$d(group(1), group(2));
    };
    var detect$4 = function (versionRegexes, agent) {
      var cleanedAgent = String(agent).toLowerCase();
      if (versionRegexes.length === 0) {
        return unknown$3();
      }
      return find$3(versionRegexes, cleanedAgent);
    };
    var unknown$3 = function () {
      return nu$d(0, 0);
    };
    var nu$d = function (major, minor) {
      return {
        major: major,
        minor: minor
      };
    };
    var Version = {
      nu: nu$d,
      detect: detect$4,
      unknown: unknown$3
    };

    var detectBrowser$1 = function (browsers, userAgentData) {
      return findMap(userAgentData.brands, function (uaBrand) {
        var lcBrand = uaBrand.brand.toLowerCase();
        return find$5(browsers, function (browser) {
          var _a;
          return lcBrand === ((_a = browser.brand) === null || _a === void 0 ? void 0 : _a.toLowerCase());
        }).map(function (info) {
          return {
            current: info.name,
            version: Version.nu(parseInt(uaBrand.version, 10), 0)
          };
        });
      });
    };

    var detect$3 = function (candidates, userAgent) {
      var agent = String(userAgent).toLowerCase();
      return find$5(candidates, function (candidate) {
        return candidate.search(agent);
      });
    };
    var detectBrowser = function (browsers, userAgent) {
      return detect$3(browsers, userAgent).map(function (browser) {
        var version = Version.detect(browser.versionRegexes, userAgent);
        return {
          current: browser.name,
          version: version
        };
      });
    };
    var detectOs = function (oses, userAgent) {
      return detect$3(oses, userAgent).map(function (os) {
        var version = Version.detect(os.versionRegexes, userAgent);
        return {
          current: os.name,
          version: version
        };
      });
    };

    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
    var checkContains = function (target) {
      return function (uastring) {
        return contains$1(uastring, target);
      };
    };
    var browsers = [
      {
        name: 'Edge',
        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
        search: function (uastring) {
          return contains$1(uastring, 'edge/') && contains$1(uastring, 'chrome') && contains$1(uastring, 'safari') && contains$1(uastring, 'applewebkit');
        }
      },
      {
        name: 'Chrome',
        brand: 'Chromium',
        versionRegexes: [
          /.*?chrome\/([0-9]+)\.([0-9]+).*/,
          normalVersionRegex
        ],
        search: function (uastring) {
          return contains$1(uastring, 'chrome') && !contains$1(uastring, 'chromeframe');
        }
      },
      {
        name: 'IE',
        versionRegexes: [
          /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
          /.*?rv:([0-9]+)\.([0-9]+).*/
        ],
        search: function (uastring) {
          return contains$1(uastring, 'msie') || contains$1(uastring, 'trident');
        }
      },
      {
        name: 'Opera',
        versionRegexes: [
          normalVersionRegex,
          /.*?opera\/([0-9]+)\.([0-9]+).*/
        ],
        search: checkContains('opera')
      },
      {
        name: 'Firefox',
        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
        search: checkContains('firefox')
      },
      {
        name: 'Safari',
        versionRegexes: [
          normalVersionRegex,
          /.*?cpu os ([0-9]+)_([0-9]+).*/
        ],
        search: function (uastring) {
          return (contains$1(uastring, 'safari') || contains$1(uastring, 'mobile/')) && contains$1(uastring, 'applewebkit');
        }
      }
    ];
    var oses = [
      {
        name: 'Windows',
        search: checkContains('win'),
        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
      },
      {
        name: 'iOS',
        search: function (uastring) {
          return contains$1(uastring, 'iphone') || contains$1(uastring, 'ipad');
        },
        versionRegexes: [
          /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
          /.*cpu os ([0-9]+)_([0-9]+).*/,
          /.*cpu iphone os ([0-9]+)_([0-9]+).*/
        ]
      },
      {
        name: 'Android',
        search: checkContains('android'),
        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
      },
      {
        name: 'OSX',
        search: checkContains('mac os x'),
        versionRegexes: [/.*?mac\ os\ x\ ?([0-9]+)_([0-9]+).*/]
      },
      {
        name: 'Linux',
        search: checkContains('linux'),
        versionRegexes: []
      },
      {
        name: 'Solaris',
        search: checkContains('sunos'),
        versionRegexes: []
      },
      {
        name: 'FreeBSD',
        search: checkContains('freebsd'),
        versionRegexes: []
      },
      {
        name: 'ChromeOS',
        search: checkContains('cros'),
        versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/]
      }
    ];
    var PlatformInfo = {
      browsers: constant$1(browsers),
      oses: constant$1(oses)
    };

    var edge = 'Edge';
    var chrome = 'Chrome';
    var ie = 'IE';
    var opera = 'Opera';
    var firefox = 'Firefox';
    var safari = 'Safari';
    var unknown$2 = function () {
      return nu$c({
        current: undefined,
        version: Version.unknown()
      });
    };
    var nu$c = function (info) {
      var current = info.current;
      var version = info.version;
      var isBrowser = function (name) {
        return function () {
          return current === name;
        };
      };
      return {
        current: current,
        version: version,
        isEdge: isBrowser(edge),
        isChrome: isBrowser(chrome),
        isIE: isBrowser(ie),
        isOpera: isBrowser(opera),
        isFirefox: isBrowser(firefox),
        isSafari: isBrowser(safari)
      };
    };
    var Browser = {
      unknown: unknown$2,
      nu: nu$c,
      edge: constant$1(edge),
      chrome: constant$1(chrome),
      ie: constant$1(ie),
      opera: constant$1(opera),
      firefox: constant$1(firefox),
      safari: constant$1(safari)
    };

    var windows = 'Windows';
    var ios = 'iOS';
    var android = 'Android';
    var linux = 'Linux';
    var osx = 'OSX';
    var solaris = 'Solaris';
    var freebsd = 'FreeBSD';
    var chromeos = 'ChromeOS';
    var unknown$1 = function () {
      return nu$b({
        current: undefined,
        version: Version.unknown()
      });
    };
    var nu$b = function (info) {
      var current = info.current;
      var version = info.version;
      var isOS = function (name) {
        return function () {
          return current === name;
        };
      };
      return {
        current: current,
        version: version,
        isWindows: isOS(windows),
        isiOS: isOS(ios),
        isAndroid: isOS(android),
        isOSX: isOS(osx),
        isLinux: isOS(linux),
        isSolaris: isOS(solaris),
        isFreeBSD: isOS(freebsd),
        isChromeOS: isOS(chromeos)
      };
    };
    var OperatingSystem = {
      unknown: unknown$1,
      nu: nu$b,
      windows: constant$1(windows),
      ios: constant$1(ios),
      android: constant$1(android),
      linux: constant$1(linux),
      osx: constant$1(osx),
      solaris: constant$1(solaris),
      freebsd: constant$1(freebsd),
      chromeos: constant$1(chromeos)
    };

    var detect$2 = function (userAgent, userAgentDataOpt, mediaMatch) {
      var browsers = PlatformInfo.browsers();
      var oses = PlatformInfo.oses();
      var browser = userAgentDataOpt.bind(function (userAgentData) {
        return detectBrowser$1(browsers, userAgentData);
      }).orThunk(function () {
        return detectBrowser(browsers, userAgent);
      }).fold(Browser.unknown, Browser.nu);
      var os = detectOs(oses, userAgent).fold(OperatingSystem.unknown, OperatingSystem.nu);
      var deviceType = DeviceType(os, browser, userAgent, mediaMatch);
      return {
        browser: browser,
        os: os,
        deviceType: deviceType
      };
    };
    var PlatformDetection = { detect: detect$2 };

    var mediaMatch = function (query) {
      return window.matchMedia(query).matches;
    };
    var platform = cached(function () {
      return PlatformDetection.detect(navigator.userAgent, Optional.from(navigator.userAgentData), mediaMatch);
    });
    var detect$1 = function () {
      return platform();
    };

    var compareDocumentPosition = function (a, b, match) {
      return (a.compareDocumentPosition(b) & match) !== 0;
    };
    var documentPositionContainedBy = function (a, b) {
      return compareDocumentPosition(a, b, Node.DOCUMENT_POSITION_CONTAINED_BY);
    };

    var is = function (element, selector) {
      var dom = element.dom;
      if (dom.nodeType !== ELEMENT) {
        return false;
      } else {
        var elem = dom;
        if (elem.matches !== undefined) {
          return elem.matches(selector);
        } else if (elem.msMatchesSelector !== undefined) {
          return elem.msMatchesSelector(selector);
        } else if (elem.webkitMatchesSelector !== undefined) {
          return elem.webkitMatchesSelector(selector);
        } else if (elem.mozMatchesSelector !== undefined) {
          return elem.mozMatchesSelector(selector);
        } else {
          throw new Error('Browser lacks native selectors');
        }
      }
    };
    var bypassSelector = function (dom) {
      return dom.nodeType !== ELEMENT && dom.nodeType !== DOCUMENT && dom.nodeType !== DOCUMENT_FRAGMENT || dom.childElementCount === 0;
    };
    var all$3 = function (selector, scope) {
      var base = scope === undefined ? document : scope.dom;
      return bypassSelector(base) ? [] : map$2(base.querySelectorAll(selector), SugarElement.fromDom);
    };
    var one = function (selector, scope) {
      var base = scope === undefined ? document : scope.dom;
      return bypassSelector(base) ? Optional.none() : Optional.from(base.querySelector(selector)).map(SugarElement.fromDom);
    };

    var eq = function (e1, e2) {
      return e1.dom === e2.dom;
    };
    var regularContains = function (e1, e2) {
      var d1 = e1.dom;
      var d2 = e2.dom;
      return d1 === d2 ? false : d1.contains(d2);
    };
    var ieContains = function (e1, e2) {
      return documentPositionContainedBy(e1.dom, e2.dom);
    };
    var contains = function (e1, e2) {
      return detect$1().browser.isIE() ? ieContains(e1, e2) : regularContains(e1, e2);
    };

    var owner$4 = function (element) {
      return SugarElement.fromDom(element.dom.ownerDocument);
    };
    var documentOrOwner = function (dos) {
      return isDocument(dos) ? dos : owner$4(dos);
    };
    var documentElement = function (element) {
      return SugarElement.fromDom(documentOrOwner(element).dom.documentElement);
    };
    var defaultView = function (element) {
      return SugarElement.fromDom(documentOrOwner(element).dom.defaultView);
    };
    var parent = function (element) {
      return Optional.from(element.dom.parentNode).map(SugarElement.fromDom);
    };
    var parentNode = function (element) {
      return parent(element);
    };
    var offsetParent = function (element) {
      return Optional.from(element.dom.offsetParent).map(SugarElement.fromDom);
    };
    var nextSibling = function (element) {
      return Optional.from(element.dom.nextSibling).map(SugarElement.fromDom);
    };
    var children = function (element) {
      return map$2(element.dom.childNodes, SugarElement.fromDom);
    };
    var child$2 = function (element, index) {
      var cs = element.dom.childNodes;
      return Optional.from(cs[index]).map(SugarElement.fromDom);
    };
    var firstChild = function (element) {
      return child$2(element, 0);
    };
    var spot = function (element, offset) {
      return {
        element: element,
        offset: offset
      };
    };
    var leaf = function (element, offset) {
      var cs = children(element);
      return cs.length > 0 && offset < cs.length ? spot(cs[offset], 0) : spot(element, offset);
    };

    var isShadowRoot = function (dos) {
      return isDocumentFragment(dos) && isNonNullable(dos.dom.host);
    };
    var supported = isFunction(Element.prototype.attachShadow) && isFunction(Node.prototype.getRootNode);
    var isSupported = constant$1(supported);
    var getRootNode = supported ? function (e) {
      return SugarElement.fromDom(e.dom.getRootNode());
    } : documentOrOwner;
    var getContentContainer = function (dos) {
      return isShadowRoot(dos) ? dos : SugarElement.fromDom(documentOrOwner(dos).dom.body);
    };
    var isInShadowRoot = function (e) {
      return getShadowRoot(e).isSome();
    };
    var getShadowRoot = function (e) {
      var r = getRootNode(e);
      return isShadowRoot(r) ? Optional.some(r) : Optional.none();
    };
    var getShadowHost = function (e) {
      return SugarElement.fromDom(e.dom.host);
    };
    var getOriginalEventTarget = function (event) {
      if (isSupported() && isNonNullable(event.target)) {
        var el = SugarElement.fromDom(event.target);
        if (isElement$2(el) && isOpenShadowHost(el)) {
          if (event.composed && event.composedPath) {
            var composedPath = event.composedPath();
            if (composedPath) {
              return head(composedPath);
            }
          }
        }
      }
      return Optional.from(event.target);
    };
    var isOpenShadowHost = function (element) {
      return isNonNullable(element.dom.shadowRoot);
    };

    var inBody = function (element) {
      var dom = isText$1(element) ? element.dom.parentNode : element.dom;
      if (dom === undefined || dom === null || dom.ownerDocument === null) {
        return false;
      }
      var doc = dom.ownerDocument;
      return getShadowRoot(SugarElement.fromDom(dom)).fold(function () {
        return doc.body.contains(dom);
      }, compose1(inBody, getShadowHost));
    };
    var body = function () {
      return getBody(SugarElement.fromDom(document));
    };
    var getBody = function (doc) {
      var b = doc.dom.body;
      if (b === null || b === undefined) {
        throw new Error('Body is not available yet');
      }
      return SugarElement.fromDom(b);
    };

    var rawSet = function (dom, key, value) {
      if (isString(value) || isBoolean(value) || isNumber(value)) {
        dom.setAttribute(key, value + '');
      } else {
        console.error('Invalid call to Attribute.set. Key ', key, ':: Value ', value, ':: Element ', dom);
        throw new Error('Attribute value was not simple');
      }
    };
    var set$8 = function (element, key, value) {
      rawSet(element.dom, key, value);
    };
    var setAll$1 = function (element, attrs) {
      var dom = element.dom;
      each(attrs, function (v, k) {
        rawSet(dom, k, v);
      });
    };
    var get$d = function (element, key) {
      var v = element.dom.getAttribute(key);
      return v === null ? undefined : v;
    };
    var getOpt = function (element, key) {
      return Optional.from(get$d(element, key));
    };
    var has$1 = function (element, key) {
      var dom = element.dom;
      return dom && dom.hasAttribute ? dom.hasAttribute(key) : false;
    };
    var remove$7 = function (element, key) {
      element.dom.removeAttribute(key);
    };

    var internalSet = function (dom, property, value) {
      if (!isString(value)) {
        console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
        throw new Error('CSS value must be a string: ' + value);
      }
      if (isSupported$1(dom)) {
        dom.style.setProperty(property, value);
      }
    };
    var internalRemove = function (dom, property) {
      if (isSupported$1(dom)) {
        dom.style.removeProperty(property);
      }
    };
    var set$7 = function (element, property, value) {
      var dom = element.dom;
      internalSet(dom, property, value);
    };
    var setAll = function (element, css) {
      var dom = element.dom;
      each(css, function (v, k) {
        internalSet(dom, k, v);
      });
    };
    var setOptions = function (element, css) {
      var dom = element.dom;
      each(css, function (v, k) {
        v.fold(function () {
          internalRemove(dom, k);
        }, function (value) {
          internalSet(dom, k, value);
        });
      });
    };
    var get$c = function (element, property) {
      var dom = element.dom;
      var styles = window.getComputedStyle(dom);
      var r = styles.getPropertyValue(property);
      return r === '' && !inBody(element) ? getUnsafeProperty(dom, property) : r;
    };
    var getUnsafeProperty = function (dom, property) {
      return isSupported$1(dom) ? dom.style.getPropertyValue(property) : '';
    };
    var getRaw = function (element, property) {
      var dom = element.dom;
      var raw = getUnsafeProperty(dom, property);
      return Optional.from(raw).filter(function (r) {
        return r.length > 0;
      });
    };
    var getAllRaw = function (element) {
      var css = {};
      var dom = element.dom;
      if (isSupported$1(dom)) {
        for (var i = 0; i < dom.style.length; i++) {
          var ruleName = dom.style.item(i);
          css[ruleName] = dom.style[ruleName];
        }
      }
      return css;
    };
    var isValidValue = function (tag, property, value) {
      var element = SugarElement.fromTag(tag);
      set$7(element, property, value);
      var style = getRaw(element, property);
      return style.isSome();
    };
    var remove$6 = function (element, property) {
      var dom = element.dom;
      internalRemove(dom, property);
      if (is$1(getOpt(element, 'style').map(trim$1), '')) {
        remove$7(element, 'style');
      }
    };
    var reflow = function (e) {
      return e.dom.offsetWidth;
    };

    var Dimension = function (name, getOffset) {
      var set = function (element, h) {
        if (!isNumber(h) && !h.match(/^[0-9]+$/)) {
          throw new Error(name + '.set accepts only positive integer values. Value was ' + h);
        }
        var dom = element.dom;
        if (isSupported$1(dom)) {
          dom.style[name] = h + 'px';
        }
      };
      var get = function (element) {
        var r = getOffset(element);
        if (r <= 0 || r === null) {
          var css = get$c(element, name);
          return parseFloat(css) || 0;
        }
        return r;
      };
      var getOuter = get;
      var aggregate = function (element, properties) {
        return foldl(properties, function (acc, property) {
          var val = get$c(element, property);
          var value = val === undefined ? 0 : parseInt(val, 10);
          return isNaN(value) ? acc : acc + value;
        }, 0);
      };
      var max = function (element, value, properties) {
        var cumulativeInclusions = aggregate(element, properties);
        var absoluteMax = value > cumulativeInclusions ? value - cumulativeInclusions : 0;
        return absoluteMax;
      };
      return {
        set: set,
        get: get,
        getOuter: getOuter,
        aggregate: aggregate,
        max: max
      };
    };

    var api$3 = Dimension('height', function (element) {
      var dom = element.dom;
      return inBody(element) ? dom.getBoundingClientRect().height : dom.offsetHeight;
    });
    var get$b = function (element) {
      return api$3.get(element);
    };
    var getOuter$2 = function (element) {
      return api$3.getOuter(element);
    };
    var setMax$1 = function (element, value) {
      var inclusions = [
        'margin-top',
        'border-top-width',
        'padding-top',
        'padding-bottom',
        'border-bottom-width',
        'margin-bottom'
      ];
      var absMax = api$3.max(element, value, inclusions);
      set$7(element, 'max-height', absMax + 'px');
    };

    var r$1 = function (left, top) {
      var translate = function (x, y) {
        return r$1(left + x, top + y);
      };
      return {
        left: left,
        top: top,
        translate: translate
      };
    };
    var SugarPosition = r$1;

    var boxPosition = function (dom) {
      var box = dom.getBoundingClientRect();
      return SugarPosition(box.left, box.top);
    };
    var firstDefinedOrZero = function (a, b) {
      if (a !== undefined) {
        return a;
      } else {
        return b !== undefined ? b : 0;
      }
    };
    var absolute$3 = function (element) {
      var doc = element.dom.ownerDocument;
      var body = doc.body;
      var win = doc.defaultView;
      var html = doc.documentElement;
      if (body === element.dom) {
        return SugarPosition(body.offsetLeft, body.offsetTop);
      }
      var scrollTop = firstDefinedOrZero(win === null || win === void 0 ? void 0 : win.pageYOffset, html.scrollTop);
      var scrollLeft = firstDefinedOrZero(win === null || win === void 0 ? void 0 : win.pageXOffset, html.scrollLeft);
      var clientTop = firstDefinedOrZero(html.clientTop, body.clientTop);
      var clientLeft = firstDefinedOrZero(html.clientLeft, body.clientLeft);
      return viewport$1(element).translate(scrollLeft - clientLeft, scrollTop - clientTop);
    };
    var viewport$1 = function (element) {
      var dom = element.dom;
      var doc = dom.ownerDocument;
      var body = doc.body;
      if (body === dom) {
        return SugarPosition(body.offsetLeft, body.offsetTop);
      }
      if (!inBody(element)) {
        return SugarPosition(0, 0);
      }
      return boxPosition(dom);
    };

    var api$2 = Dimension('width', function (element) {
      return element.dom.offsetWidth;
    });
    var set$6 = function (element, h) {
      return api$2.set(element, h);
    };
    var get$a = function (element) {
      return api$2.get(element);
    };
    var getOuter$1 = function (element) {
      return api$2.getOuter(element);
    };
    var setMax = function (element, value) {
      var inclusions = [
        'margin-left',
        'border-left-width',
        'padding-left',
        'padding-right',
        'border-right-width',
        'margin-right'
      ];
      var absMax = api$2.max(element, value, inclusions);
      set$7(element, 'max-width', absMax + 'px');
    };

    var mkEvent = function (target, x, y, stop, prevent, kill, raw) {
      return {
        target: target,
        x: x,
        y: y,
        stop: stop,
        prevent: prevent,
        kill: kill,
        raw: raw
      };
    };
    var fromRawEvent$1 = function (rawEvent) {
      var target = SugarElement.fromDom(getOriginalEventTarget(rawEvent).getOr(rawEvent.target));
      var stop = function () {
        return rawEvent.stopPropagation();
      };
      var prevent = function () {
        return rawEvent.preventDefault();
      };
      var kill = compose(prevent, stop);
      return mkEvent(target, rawEvent.clientX, rawEvent.clientY, stop, prevent, kill, rawEvent);
    };
    var handle = function (filter, handler) {
      return function (rawEvent) {
        if (filter(rawEvent)) {
          handler(fromRawEvent$1(rawEvent));
        }
      };
    };
    var binder = function (element, event, filter, handler, useCapture) {
      var wrapped = handle(filter, handler);
      element.dom.addEventListener(event, wrapped, useCapture);
      return { unbind: curry(unbind, element, event, wrapped, useCapture) };
    };
    var bind$2 = function (element, event, filter, handler) {
      return binder(element, event, filter, handler, false);
    };
    var capture$1 = function (element, event, filter, handler) {
      return binder(element, event, filter, handler, true);
    };
    var unbind = function (element, event, handler, useCapture) {
      element.dom.removeEventListener(event, handler, useCapture);
    };

    var before$2 = function (marker, element) {
      var parent$1 = parent(marker);
      parent$1.each(function (v) {
        v.dom.insertBefore(element.dom, marker.dom);
      });
    };
    var after$2 = function (marker, element) {
      var sibling = nextSibling(marker);
      sibling.fold(function () {
        var parent$1 = parent(marker);
        parent$1.each(function (v) {
          append$2(v, element);
        });
      }, function (v) {
        before$2(v, element);
      });
    };
    var prepend$1 = function (parent, element) {
      var firstChild$1 = firstChild(parent);
      firstChild$1.fold(function () {
        append$2(parent, element);
      }, function (v) {
        parent.dom.insertBefore(element.dom, v.dom);
      });
    };
    var append$2 = function (parent, element) {
      parent.dom.appendChild(element.dom);
    };
    var appendAt = function (parent, element, index) {
      child$2(parent, index).fold(function () {
        append$2(parent, element);
      }, function (v) {
        before$2(v, element);
      });
    };

    var before$1 = function (marker, elements) {
      each$1(elements, function (x) {
        before$2(marker, x);
      });
    };
    var append$1 = function (parent, elements) {
      each$1(elements, function (x) {
        append$2(parent, x);
      });
    };

    var empty = function (element) {
      element.dom.textContent = '';
      each$1(children(element), function (rogue) {
        remove$5(rogue);
      });
    };
    var remove$5 = function (element) {
      var dom = element.dom;
      if (dom.parentNode !== null) {
        dom.parentNode.removeChild(dom);
      }
    };
    var unwrap = function (wrapper) {
      var children$1 = children(wrapper);
      if (children$1.length > 0) {
        before$1(wrapper, children$1);
      }
      remove$5(wrapper);
    };

    var get$9 = function (_DOC) {
      var doc = _DOC !== undefined ? _DOC.dom : document;
      var x = doc.body.scrollLeft || doc.documentElement.scrollLeft;
      var y = doc.body.scrollTop || doc.documentElement.scrollTop;
      return SugarPosition(x, y);
    };
    var to = function (x, y, _DOC) {
      var doc = _DOC !== undefined ? _DOC.dom : document;
      var win = doc.defaultView;
      if (win) {
        win.scrollTo(x, y);
      }
    };

    var get$8 = function (_win) {
      var win = _win === undefined ? window : _win;
      if (detect$1().browser.isFirefox()) {
        return Optional.none();
      } else {
        return Optional.from(win['visualViewport']);
      }
    };
    var bounds$1 = function (x, y, width, height) {
      return {
        x: x,
        y: y,
        width: width,
        height: height,
        right: x + width,
        bottom: y + height
      };
    };
    var getBounds$3 = function (_win) {
      var win = _win === undefined ? window : _win;
      var doc = win.document;
      var scroll = get$9(SugarElement.fromDom(doc));
      return get$8(win).fold(function () {
        var html = win.document.documentElement;
        var width = html.clientWidth;
        var height = html.clientHeight;
        return bounds$1(scroll.left, scroll.top, width, height);
      }, function (visualViewport) {
        return bounds$1(Math.max(visualViewport.pageLeft, scroll.left), Math.max(visualViewport.pageTop, scroll.top), visualViewport.width, visualViewport.height);
      });
    };

    var walkUp = function (navigation, doc) {
      var frame = navigation.view(doc);
      return frame.fold(constant$1([]), function (f) {
        var parent = navigation.owner(f);
        var rest = walkUp(navigation, parent);
        return [f].concat(rest);
      });
    };
    var pathTo = function (element, navigation) {
      var d = navigation.owner(element);
      var paths = walkUp(navigation, d);
      return Optional.some(paths);
    };

    var view = function (doc) {
      var _a;
      var element = doc.dom === document ? Optional.none() : Optional.from((_a = doc.dom.defaultView) === null || _a === void 0 ? void 0 : _a.frameElement);
      return element.map(SugarElement.fromDom);
    };
    var owner$3 = function (element) {
      return owner$4(element);
    };

    var Navigation = /*#__PURE__*/Object.freeze({
        __proto__: null,
        view: view,
        owner: owner$3
    });

    var find$2 = function (element) {
      var doc = SugarElement.fromDom(document);
      var scroll = get$9(doc);
      var path = pathTo(element, Navigation);
      return path.fold(curry(absolute$3, element), function (frames) {
        var offset = viewport$1(element);
        var r = foldr(frames, function (b, a) {
          var loc = viewport$1(a);
          return {
            left: b.left + loc.left,
            top: b.top + loc.top
          };
        }, {
          left: 0,
          top: 0
        });
        return SugarPosition(r.left + offset.left + scroll.left, r.top + offset.top + scroll.top);
      });
    };

    var pointed = function (point, width, height) {
      return {
        point: point,
        width: width,
        height: height
      };
    };
    var rect = function (x, y, width, height) {
      return {
        x: x,
        y: y,
        width: width,
        height: height
      };
    };
    var bounds = function (x, y, width, height) {
      return {
        x: x,
        y: y,
        width: width,
        height: height,
        right: x + width,
        bottom: y + height
      };
    };
    var box$1 = function (element) {
      var xy = absolute$3(element);
      var w = getOuter$1(element);
      var h = getOuter$2(element);
      return bounds(xy.left, xy.top, w, h);
    };
    var absolute$2 = function (element) {
      var position = find$2(element);
      var width = getOuter$1(element);
      var height = getOuter$2(element);
      return bounds(position.left, position.top, width, height);
    };
    var win = function () {
      return getBounds$3(window);
    };

    var value$3 = function (o) {
      var or = function (_opt) {
        return value$3(o);
      };
      var orThunk = function (_f) {
        return value$3(o);
      };
      var map = function (f) {
        return value$3(f(o));
      };
      var mapError = function (_f) {
        return value$3(o);
      };
      var each = function (f) {
        f(o);
      };
      var bind = function (f) {
        return f(o);
      };
      var fold = function (_, onValue) {
        return onValue(o);
      };
      var exists = function (f) {
        return f(o);
      };
      var forall = function (f) {
        return f(o);
      };
      var toOptional = function () {
        return Optional.some(o);
      };
      return {
        isValue: always,
        isError: never,
        getOr: constant$1(o),
        getOrThunk: constant$1(o),
        getOrDie: constant$1(o),
        or: or,
        orThunk: orThunk,
        fold: fold,
        map: map,
        mapError: mapError,
        each: each,
        bind: bind,
        exists: exists,
        forall: forall,
        toOptional: toOptional
      };
    };
    var error$1 = function (message) {
      var getOrThunk = function (f) {
        return f();
      };
      var getOrDie = function () {
        return die(String(message))();
      };
      var or = identity$1;
      var orThunk = function (f) {
        return f();
      };
      var map = function (_f) {
        return error$1(message);
      };
      var mapError = function (f) {
        return error$1(f(message));
      };
      var bind = function (_f) {
        return error$1(message);
      };
      var fold = function (onError, _) {
        return onError(message);
      };
      return {
        isValue: never,
        isError: always,
        getOr: identity$1,
        getOrThunk: getOrThunk,
        getOrDie: getOrDie,
        or: or,
        orThunk: orThunk,
        fold: fold,
        map: map,
        mapError: mapError,
        each: noop,
        bind: bind,
        exists: never,
        forall: always,
        toOptional: Optional.none
      };
    };
    var fromOption = function (opt, err) {
      return opt.fold(function () {
        return error$1(err);
      }, value$3);
    };
    var Result = {
      value: value$3,
      error: error$1,
      fromOption: fromOption
    };

    var SimpleResultType;
    (function (SimpleResultType) {
      SimpleResultType[SimpleResultType['Error'] = 0] = 'Error';
      SimpleResultType[SimpleResultType['Value'] = 1] = 'Value';
    }(SimpleResultType || (SimpleResultType = {})));
    var fold$1 = function (res, onError, onValue) {
      return res.stype === SimpleResultType.Error ? onError(res.serror) : onValue(res.svalue);
    };
    var partition$2 = function (results) {
      var values = [];
      var errors = [];
      each$1(results, function (obj) {
        fold$1(obj, function (err) {
          return errors.push(err);
        }, function (val) {
          return values.push(val);
        });
      });
      return {
        values: values,
        errors: errors
      };
    };
    var mapError = function (res, f) {
      if (res.stype === SimpleResultType.Error) {
        return {
          stype: SimpleResultType.Error,
          serror: f(res.serror)
        };
      } else {
        return res;
      }
    };
    var map = function (res, f) {
      if (res.stype === SimpleResultType.Value) {
        return {
          stype: SimpleResultType.Value,
          svalue: f(res.svalue)
        };
      } else {
        return res;
      }
    };
    var bind$1 = function (res, f) {
      if (res.stype === SimpleResultType.Value) {
        return f(res.svalue);
      } else {
        return res;
      }
    };
    var bindError = function (res, f) {
      if (res.stype === SimpleResultType.Error) {
        return f(res.serror);
      } else {
        return res;
      }
    };
    var svalue = function (v) {
      return {
        stype: SimpleResultType.Value,
        svalue: v
      };
    };
    var serror = function (e) {
      return {
        stype: SimpleResultType.Error,
        serror: e
      };
    };
    var toResult$1 = function (res) {
      return fold$1(res, Result.error, Result.value);
    };
    var fromResult$1 = function (res) {
      return res.fold(serror, svalue);
    };
    var SimpleResult = {
      fromResult: fromResult$1,
      toResult: toResult$1,
      svalue: svalue,
      partition: partition$2,
      serror: serror,
      bind: bind$1,
      bindError: bindError,
      map: map,
      mapError: mapError,
      fold: fold$1
    };

    var field$2 = function (key, newKey, presence, prop) {
      return {
        tag: 'field',
        key: key,
        newKey: newKey,
        presence: presence,
        prop: prop
      };
    };
    var customField$1 = function (newKey, instantiator) {
      return {
        tag: 'custom',
        newKey: newKey,
        instantiator: instantiator
      };
    };
    var fold = function (value, ifField, ifCustom) {
      switch (value.tag) {
      case 'field':
        return ifField(value.key, value.newKey, value.presence, value.prop);
      case 'custom':
        return ifCustom(value.newKey, value.instantiator);
      }
    };

    var shallow$1 = function (old, nu) {
      return nu;
    };
    var deep = function (old, nu) {
      var bothObjects = isObject(old) && isObject(nu);
      return bothObjects ? deepMerge(old, nu) : nu;
    };
    var baseMerge = function (merger) {
      return function () {
        var objects = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          objects[_i] = arguments[_i];
        }
        if (objects.length === 0) {
          throw new Error('Can\'t merge zero objects');
        }
        var ret = {};
        for (var j = 0; j < objects.length; j++) {
          var curObject = objects[j];
          for (var key in curObject) {
            if (has$2(curObject, key)) {
              ret[key] = merger(ret[key], curObject[key]);
            }
          }
        }
        return ret;
      };
    };
    var deepMerge = baseMerge(deep);
    var merge$1 = baseMerge(shallow$1);

    var required$2 = function () {
      return {
        tag: 'required',
        process: {}
      };
    };
    var defaultedThunk = function (fallbackThunk) {
      return {
        tag: 'defaultedThunk',
        process: fallbackThunk
      };
    };
    var defaulted$1 = function (fallback) {
      return defaultedThunk(constant$1(fallback));
    };
    var asOption = function () {
      return {
        tag: 'option',
        process: {}
      };
    };
    var mergeWithThunk = function (baseThunk) {
      return {
        tag: 'mergeWithThunk',
        process: baseThunk
      };
    };
    var mergeWith = function (base) {
      return mergeWithThunk(constant$1(base));
    };

    var mergeValues$1 = function (values, base) {
      return values.length > 0 ? SimpleResult.svalue(deepMerge(base, merge$1.apply(undefined, values))) : SimpleResult.svalue(base);
    };
    var mergeErrors$1 = function (errors) {
      return compose(SimpleResult.serror, flatten)(errors);
    };
    var consolidateObj = function (objects, base) {
      var partition = SimpleResult.partition(objects);
      return partition.errors.length > 0 ? mergeErrors$1(partition.errors) : mergeValues$1(partition.values, base);
    };
    var consolidateArr = function (objects) {
      var partitions = SimpleResult.partition(objects);
      return partitions.errors.length > 0 ? mergeErrors$1(partitions.errors) : SimpleResult.svalue(partitions.values);
    };
    var ResultCombine = {
      consolidateObj: consolidateObj,
      consolidateArr: consolidateArr
    };

    var formatObj = function (input) {
      return isObject(input) && keys(input).length > 100 ? ' removed due to size' : JSON.stringify(input, null, 2);
    };
    var formatErrors = function (errors) {
      var es = errors.length > 10 ? errors.slice(0, 10).concat([{
          path: [],
          getErrorInfo: constant$1('... (only showing first ten failures)')
        }]) : errors;
      return map$2(es, function (e) {
        return 'Failed path: (' + e.path.join(' > ') + ')\n' + e.getErrorInfo();
      });
    };

    var nu$a = function (path, getErrorInfo) {
      return SimpleResult.serror([{
          path: path,
          getErrorInfo: getErrorInfo
        }]);
    };
    var missingRequired = function (path, key, obj) {
      return nu$a(path, function () {
        return 'Could not find valid *required* value for "' + key + '" in ' + formatObj(obj);
      });
    };
    var missingKey = function (path, key) {
      return nu$a(path, function () {
        return 'Choice schema did not contain choice key: "' + key + '"';
      });
    };
    var missingBranch = function (path, branches, branch) {
      return nu$a(path, function () {
        return 'The chosen schema: "' + branch + '" did not exist in branches: ' + formatObj(branches);
      });
    };
    var unsupportedFields = function (path, unsupported) {
      return nu$a(path, function () {
        return 'There are unsupported fields: [' + unsupported.join(', ') + '] specified';
      });
    };
    var custom = function (path, err) {
      return nu$a(path, constant$1(err));
    };

    var value$2 = function (validator) {
      var extract = function (path, val) {
        return SimpleResult.bindError(validator(val), function (err) {
          return custom(path, err);
        });
      };
      var toString = constant$1('val');
      return {
        extract: extract,
        toString: toString
      };
    };
    var anyValue$1 = value$2(SimpleResult.svalue);

    var requiredAccess = function (path, obj, key, bundle) {
      return get$e(obj, key).fold(function () {
        return missingRequired(path, key, obj);
      }, bundle);
    };
    var fallbackAccess = function (obj, key, fallback, bundle) {
      var v = get$e(obj, key).getOrThunk(function () {
        return fallback(obj);
      });
      return bundle(v);
    };
    var optionAccess = function (obj, key, bundle) {
      return bundle(get$e(obj, key));
    };
    var optionDefaultedAccess = function (obj, key, fallback, bundle) {
      var opt = get$e(obj, key).map(function (val) {
        return val === true ? fallback(obj) : val;
      });
      return bundle(opt);
    };
    var extractField = function (field, path, obj, key, prop) {
      var bundle = function (av) {
        return prop.extract(path.concat([key]), av);
      };
      var bundleAsOption = function (optValue) {
        return optValue.fold(function () {
          return SimpleResult.svalue(Optional.none());
        }, function (ov) {
          var result = prop.extract(path.concat([key]), ov);
          return SimpleResult.map(result, Optional.some);
        });
      };
      switch (field.tag) {
      case 'required':
        return requiredAccess(path, obj, key, bundle);
      case 'defaultedThunk':
        return fallbackAccess(obj, key, field.process, bundle);
      case 'option':
        return optionAccess(obj, key, bundleAsOption);
      case 'defaultedOptionThunk':
        return optionDefaultedAccess(obj, key, field.process, bundleAsOption);
      case 'mergeWithThunk': {
          return fallbackAccess(obj, key, constant$1({}), function (v) {
            var result = deepMerge(field.process(obj), v);
            return bundle(result);
          });
        }
      }
    };
    var extractFields = function (path, obj, fields) {
      var success = {};
      var errors = [];
      for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
        var field = fields_1[_i];
        fold(field, function (key, newKey, presence, prop) {
          var result = extractField(presence, path, obj, key, prop);
          SimpleResult.fold(result, function (err) {
            errors.push.apply(errors, err);
          }, function (res) {
            success[newKey] = res;
          });
        }, function (newKey, instantiator) {
          success[newKey] = instantiator(obj);
        });
      }
      return errors.length > 0 ? SimpleResult.serror(errors) : SimpleResult.svalue(success);
    };
    var valueThunk = function (getDelegate) {
      var extract = function (path, val) {
        return getDelegate().extract(path, val);
      };
      var toString = function () {
        return getDelegate().toString();
      };
      return {
        extract: extract,
        toString: toString
      };
    };
    var getSetKeys = function (obj) {
      return keys(filter$1(obj, isNonNullable));
    };
    var objOfOnly = function (fields) {
      var delegate = objOf(fields);
      var fieldNames = foldr(fields, function (acc, value) {
        return fold(value, function (key) {
          var _a;
          return deepMerge(acc, (_a = {}, _a[key] = true, _a));
        }, constant$1(acc));
      }, {});
      var extract = function (path, o) {
        var keys = isBoolean(o) ? [] : getSetKeys(o);
        var extra = filter$2(keys, function (k) {
          return !hasNonNullableKey(fieldNames, k);
        });
        return extra.length === 0 ? delegate.extract(path, o) : unsupportedFields(path, extra);
      };
      return {
        extract: extract,
        toString: delegate.toString
      };
    };
    var objOf = function (values) {
      var extract = function (path, o) {
        return extractFields(path, o, values);
      };
      var toString = function () {
        var fieldStrings = map$2(values, function (value) {
          return fold(value, function (key, _okey, _presence, prop) {
            return key + ' -> ' + prop.toString();
          }, function (newKey, _instantiator) {
            return 'state(' + newKey + ')';
          });
        });
        return 'obj{\n' + fieldStrings.join('\n') + '}';
      };
      return {
        extract: extract,
        toString: toString
      };
    };
    var arrOf = function (prop) {
      var extract = function (path, array) {
        var results = map$2(array, function (a, i) {
          return prop.extract(path.concat(['[' + i + ']']), a);
        });
        return ResultCombine.consolidateArr(results);
      };
      var toString = function () {
        return 'array(' + prop.toString() + ')';
      };
      return {
        extract: extract,
        toString: toString
      };
    };
    var oneOf = function (props) {
      var extract = function (path, val) {
        var errors = [];
        for (var _i = 0, props_1 = props; _i < props_1.length; _i++) {
          var prop = props_1[_i];
          var res = prop.extract(path, val);
          if (res.stype === SimpleResultType.Value) {
            return res;
          }
          errors.push(res);
        }
        return ResultCombine.consolidateArr(errors);
      };
      var toString = function () {
        return 'oneOf(' + map$2(props, function (prop) {
          return prop.toString();
        }).join(', ') + ')';
      };
      return {
        extract: extract,
        toString: toString
      };
    };
    var setOf$1 = function (validator, prop) {
      var validateKeys = function (path, keys) {
        return arrOf(value$2(validator)).extract(path, keys);
      };
      var extract = function (path, o) {
        var keys$1 = keys(o);
        var validatedKeys = validateKeys(path, keys$1);
        return SimpleResult.bind(validatedKeys, function (validKeys) {
          var schema = map$2(validKeys, function (vk) {
            return field$2(vk, vk, required$2(), prop);
          });
          return objOf(schema).extract(path, o);
        });
      };
      var toString = function () {
        return 'setOf(' + prop.toString() + ')';
      };
      return {
        extract: extract,
        toString: toString
      };
    };
    var thunk = function (_desc, processor) {
      var getP = cached(processor);
      var extract = function (path, val) {
        return getP().extract(path, val);
      };
      var toString = function () {
        return getP().toString();
      };
      return {
        extract: extract,
        toString: toString
      };
    };
    var arrOfObj = compose(arrOf, objOf);

    var anyValue = constant$1(anyValue$1);
    var typedValue = function (validator, expectedType) {
      return value$2(function (a) {
        var actualType = typeof a;
        return validator(a) ? SimpleResult.svalue(a) : SimpleResult.serror('Expected type: ' + expectedType + ' but got: ' + actualType);
      });
    };
    var number = typedValue(isNumber, 'number');
    var string = typedValue(isString, 'string');
    var boolean = typedValue(isBoolean, 'boolean');
    var functionProcessor = typedValue(isFunction, 'function');
    var isPostMessageable = function (val) {
      if (Object(val) !== val) {
        return true;
      }
      switch ({}.toString.call(val).slice(8, -1)) {
      case 'Boolean':
      case 'Number':
      case 'String':
      case 'Date':
      case 'RegExp':
      case 'Blob':
      case 'FileList':
      case 'ImageData':
      case 'ImageBitmap':
      case 'ArrayBuffer':
        return true;
      case 'Array':
      case 'Object':
        return Object.keys(val).every(function (prop) {
          return isPostMessageable(val[prop]);
        });
      default:
        return false;
      }
    };
    var postMessageable = value$2(function (a) {
      if (isPostMessageable(a)) {
        return SimpleResult.svalue(a);
      } else {
        return SimpleResult.serror('Expected value to be acceptable for sending via postMessage');
      }
    });

    var chooseFrom = function (path, input, branches, ch) {
      var fields = get$e(branches, ch);
      return fields.fold(function () {
        return missingBranch(path, branches, ch);
      }, function (vp) {
        return vp.extract(path.concat(['branch: ' + ch]), input);
      });
    };
    var choose$2 = function (key, branches) {
      var extract = function (path, input) {
        var choice = get$e(input, key);
        return choice.fold(function () {
          return missingKey(path, key);
        }, function (chosen) {
          return chooseFrom(path, input, branches, chosen);
        });
      };
      var toString = function () {
        return 'chooseOn(' + key + '). Possible values: ' + keys(branches);
      };
      return {
        extract: extract,
        toString: toString
      };
    };

    var arrOfVal = function () {
      return arrOf(anyValue$1);
    };
    var valueOf = function (validator) {
      return value$2(function (v) {
        return validator(v).fold(SimpleResult.serror, SimpleResult.svalue);
      });
    };
    var setOf = function (validator, prop) {
      return setOf$1(function (v) {
        return SimpleResult.fromResult(validator(v));
      }, prop);
    };
    var extractValue = function (label, prop, obj) {
      var res = prop.extract([label], obj);
      return SimpleResult.mapError(res, function (errs) {
        return {
          input: obj,
          errors: errs
        };
      });
    };
    var asRaw = function (label, prop, obj) {
      return SimpleResult.toResult(extractValue(label, prop, obj));
    };
    var getOrDie = function (extraction) {
      return extraction.fold(function (errInfo) {
        throw new Error(formatError(errInfo));
      }, identity$1);
    };
    var asRawOrDie$1 = function (label, prop, obj) {
      return getOrDie(asRaw(label, prop, obj));
    };
    var formatError = function (errInfo) {
      return 'Errors: \n' + formatErrors(errInfo.errors).join('\n') + '\n\nInput object: ' + formatObj(errInfo.input);
    };
    var choose$1 = function (key, branches) {
      return choose$2(key, map$1(branches, objOf));
    };
    var thunkOf = function (desc, schema) {
      return thunk(desc, schema);
    };

    var field$1 = field$2;
    var customField = customField$1;
    var validateEnum = function (values) {
      return valueOf(function (value) {
        return contains$2(values, value) ? Result.value(value) : Result.error('Unsupported value: "' + value + '", choose one of "' + values.join(', ') + '".');
      });
    };
    var required$1 = function (key) {
      return field$1(key, key, required$2(), anyValue());
    };
    var requiredOf = function (key, schema) {
      return field$1(key, key, required$2(), schema);
    };
    var requiredNumber = function (key) {
      return requiredOf(key, number);
    };
    var requiredString = function (key) {
      return requiredOf(key, string);
    };
    var requiredStringEnum = function (key, values) {
      return field$1(key, key, required$2(), validateEnum(values));
    };
    var requiredBoolean = function (key) {
      return requiredOf(key, boolean);
    };
    var requiredFunction = function (key) {
      return requiredOf(key, functionProcessor);
    };
    var forbid = function (key, message) {
      return field$1(key, key, asOption(), value$2(function (_v) {
        return SimpleResult.serror('The field: ' + key + ' is forbidden. ' + message);
      }));
    };
    var requiredObjOf = function (key, objSchema) {
      return field$1(key, key, required$2(), objOf(objSchema));
    };
    var requiredArrayOfObj = function (key, objFields) {
      return field$1(key, key, required$2(), arrOfObj(objFields));
    };
    var requiredArrayOf = function (key, schema) {
      return field$1(key, key, required$2(), arrOf(schema));
    };
    var option = function (key) {
      return field$1(key, key, asOption(), anyValue());
    };
    var optionOf = function (key, schema) {
      return field$1(key, key, asOption(), schema);
    };
    var optionNumber = function (key) {
      return optionOf(key, number);
    };
    var optionString = function (key) {
      return optionOf(key, string);
    };
    var optionFunction = function (key) {
      return optionOf(key, functionProcessor);
    };
    var optionArrayOf = function (key, schema) {
      return optionOf(key, arrOf(schema));
    };
    var optionObjOf = function (key, objSchema) {
      return optionOf(key, objOf(objSchema));
    };
    var optionObjOfOnly = function (key, objSchema) {
      return optionOf(key, objOfOnly(objSchema));
    };
    var defaulted = function (key, fallback) {
      return field$1(key, key, defaulted$1(fallback), anyValue());
    };
    var defaultedOf = function (key, fallback, schema) {
      return field$1(key, key, defaulted$1(fallback), schema);
    };
    var defaultedNumber = function (key, fallback) {
      return defaultedOf(key, fallback, number);
    };
    var defaultedString = function (key, fallback) {
      return defaultedOf(key, fallback, string);
    };
    var defaultedStringEnum = function (key, fallback, values) {
      return defaultedOf(key, fallback, validateEnum(values));
    };
    var defaultedBoolean = function (key, fallback) {
      return defaultedOf(key, fallback, boolean);
    };
    var defaultedFunction = function (key, fallback) {
      return defaultedOf(key, fallback, functionProcessor);
    };
    var defaultedPostMsg = function (key, fallback) {
      return defaultedOf(key, fallback, postMessageable);
    };
    var defaultedArrayOf = function (key, fallback, schema) {
      return defaultedOf(key, fallback, arrOf(schema));
    };
    var defaultedObjOf = function (key, fallback, objSchema) {
      return defaultedOf(key, fallback, objOf(objSchema));
    };

    var Cell = function (initial) {
      var value = initial;
      var get = function () {
        return value;
      };
      var set = function (v) {
        value = v;
      };
      return {
        get: get,
        set: set
      };
    };

    var generate$7 = function (cases) {
      if (!isArray(cases)) {
        throw new Error('cases must be an array');
      }
      if (cases.length === 0) {
        throw new Error('there must be at least one case');
      }
      var constructors = [];
      var adt = {};
      each$1(cases, function (acase, count) {
        var keys$1 = keys(acase);
        if (keys$1.length !== 1) {
          throw new Error('one and only one name per case');
        }
        var key = keys$1[0];
        var value = acase[key];
        if (adt[key] !== undefined) {
          throw new Error('duplicate key detected:' + key);
        } else if (key === 'cata') {
          throw new Error('cannot have a case named cata (sorry)');
        } else if (!isArray(value)) {
          throw new Error('case arguments must be an array');
        }
        constructors.push(key);
        adt[key] = function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          var argLength = args.length;
          if (argLength !== value.length) {
            throw new Error('Wrong number of arguments to case ' + key + '. Expected ' + value.length + ' (' + value + '), got ' + argLength);
          }
          var match = function (branches) {
            var branchKeys = keys(branches);
            if (constructors.length !== branchKeys.length) {
              throw new Error('Wrong number of arguments to match. Expected: ' + constructors.join(',') + '\nActual: ' + branchKeys.join(','));
            }
            var allReqd = forall(constructors, function (reqKey) {
              return contains$2(branchKeys, reqKey);
            });
            if (!allReqd) {
              throw new Error('Not all branches were specified when using match. Specified: ' + branchKeys.join(', ') + '\nRequired: ' + constructors.join(', '));
            }
            return branches[key].apply(null, args);
          };
          return {
            fold: function () {
              var foldArgs = [];
              for (var _i = 0; _i < arguments.length; _i++) {
                foldArgs[_i] = arguments[_i];
              }
              if (foldArgs.length !== cases.length) {
                throw new Error('Wrong number of arguments to fold. Expected ' + cases.length + ', got ' + foldArgs.length);
              }
              var target = foldArgs[count];
              return target.apply(null, args);
            },
            match: match,
            log: function (label) {
              console.log(label, {
                constructors: constructors,
                constructor: key,
                params: args
              });
            }
          };
        };
      });
      return adt;
    };
    var Adt = { generate: generate$7 };

    Adt.generate([
      {
        bothErrors: [
          'error1',
          'error2'
        ]
      },
      {
        firstError: [
          'error1',
          'value2'
        ]
      },
      {
        secondError: [
          'value1',
          'error2'
        ]
      },
      {
        bothValues: [
          'value1',
          'value2'
        ]
      }
    ]);
    var partition$1 = function (results) {
      var errors = [];
      var values = [];
      each$1(results, function (result) {
        result.fold(function (err) {
          errors.push(err);
        }, function (value) {
          values.push(value);
        });
      });
      return {
        errors: errors,
        values: values
      };
    };

    var exclude$1 = function (obj, fields) {
      var r = {};
      each(obj, function (v, k) {
        if (!contains$2(fields, k)) {
          r[k] = v;
        }
      });
      return r;
    };

    var wrap$2 = function (key, value) {
      var _a;
      return _a = {}, _a[key] = value, _a;
    };
    var wrapAll$1 = function (keyvalues) {
      var r = {};
      each$1(keyvalues, function (kv) {
        r[kv.key] = kv.value;
      });
      return r;
    };

    var exclude = function (obj, fields) {
      return exclude$1(obj, fields);
    };
    var wrap$1 = function (key, value) {
      return wrap$2(key, value);
    };
    var wrapAll = function (keyvalues) {
      return wrapAll$1(keyvalues);
    };
    var mergeValues = function (values, base) {
      return values.length === 0 ? Result.value(base) : Result.value(deepMerge(base, merge$1.apply(undefined, values)));
    };
    var mergeErrors = function (errors) {
      return Result.error(flatten(errors));
    };
    var consolidate = function (objs, base) {
      var partitions = partition$1(objs);
      return partitions.errors.length > 0 ? mergeErrors(partitions.errors) : mergeValues(partitions.values, base);
    };

    var ensureIsRoot = function (isRoot) {
      return isFunction(isRoot) ? isRoot : never;
    };
    var ancestor$2 = function (scope, transform, isRoot) {
      var element = scope.dom;
      var stop = ensureIsRoot(isRoot);
      while (element.parentNode) {
        element = element.parentNode;
        var el = SugarElement.fromDom(element);
        var transformed = transform(el);
        if (transformed.isSome()) {
          return transformed;
        } else if (stop(el)) {
          break;
        }
      }
      return Optional.none();
    };
    var closest$4 = function (scope, transform, isRoot) {
      var current = transform(scope);
      var stop = ensureIsRoot(isRoot);
      return current.orThunk(function () {
        return stop(scope) ? Optional.none() : ancestor$2(scope, transform, stop);
      });
    };

    var isSource = function (component, simulatedEvent) {
      return eq(component.element, simulatedEvent.event.target);
    };

    var defaultEventHandler = {
      can: always,
      abort: never,
      run: noop
    };
    var nu$9 = function (parts) {
      if (!hasNonNullableKey(parts, 'can') && !hasNonNullableKey(parts, 'abort') && !hasNonNullableKey(parts, 'run')) {
        throw new Error('EventHandler defined by: ' + JSON.stringify(parts, null, 2) + ' does not have can, abort, or run!');
      }
      return __assign(__assign({}, defaultEventHandler), parts);
    };
    var all$2 = function (handlers, f) {
      return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        return foldl(handlers, function (acc, handler) {
          return acc && f(handler).apply(undefined, args);
        }, true);
      };
    };
    var any = function (handlers, f) {
      return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        return foldl(handlers, function (acc, handler) {
          return acc || f(handler).apply(undefined, args);
        }, false);
      };
    };
    var read$2 = function (handler) {
      return isFunction(handler) ? {
        can: always,
        abort: never,
        run: handler
      } : handler;
    };
    var fuse$1 = function (handlers) {
      var can = all$2(handlers, function (handler) {
        return handler.can;
      });
      var abort = any(handlers, function (handler) {
        return handler.abort;
      });
      var run = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        each$1(handlers, function (handler) {
          handler.run.apply(undefined, args);
        });
      };
      return {
        can: can,
        abort: abort,
        run: run
      };
    };

    var constant = constant$1;
    var touchstart = constant('touchstart');
    var touchmove = constant('touchmove');
    var touchend = constant('touchend');
    var touchcancel = constant('touchcancel');
    var mousedown = constant('mousedown');
    var mousemove = constant('mousemove');
    var mouseout = constant('mouseout');
    var mouseup = constant('mouseup');
    var mouseover = constant('mouseover');
    var focusin = constant('focusin');
    var focusout = constant('focusout');
    var keydown = constant('keydown');
    var keyup = constant('keyup');
    var input = constant('input');
    var change = constant('change');
    var click = constant('click');
    var transitioncancel = constant('transitioncancel');
    var transitionend = constant('transitionend');
    var transitionstart = constant('transitionstart');
    var selectstart = constant('selectstart');

    var prefixName = function (name) {
      return constant$1('alloy.' + name);
    };
    var alloy = { tap: prefixName('tap') };
    var focus$4 = prefixName('focus');
    var postBlur = prefixName('blur.post');
    var postPaste = prefixName('paste.post');
    var receive = prefixName('receive');
    var execute$5 = prefixName('execute');
    var focusItem = prefixName('focus.item');
    var tap = alloy.tap;
    var longpress = prefixName('longpress');
    var sandboxClose = prefixName('sandbox.close');
    var typeaheadCancel = prefixName('typeahead.cancel');
    var systemInit = prefixName('system.init');
    var documentTouchmove = prefixName('system.touchmove');
    var documentTouchend = prefixName('system.touchend');
    var windowScroll = prefixName('system.scroll');
    var windowResize = prefixName('system.resize');
    var attachedToDom = prefixName('system.attached');
    var detachedFromDom = prefixName('system.detached');
    var dismissRequested = prefixName('system.dismissRequested');
    var repositionRequested = prefixName('system.repositionRequested');
    var focusShifted = prefixName('focusmanager.shifted');
    var slotVisibility = prefixName('slotcontainer.visibility');
    var changeTab = prefixName('change.tab');
    var dismissTab = prefixName('dismiss.tab');
    var highlight$1 = prefixName('highlight');
    var dehighlight$1 = prefixName('dehighlight');

    var emit = function (component, event) {
      dispatchWith(component, component.element, event, {});
    };
    var emitWith = function (component, event, properties) {
      dispatchWith(component, component.element, event, properties);
    };
    var emitExecute = function (component) {
      emit(component, execute$5());
    };
    var dispatch = function (component, target, event) {
      dispatchWith(component, target, event, {});
    };
    var dispatchWith = function (component, target, event, properties) {
      var data = __assign({ target: target }, properties);
      component.getSystem().triggerEvent(event, target, data);
    };
    var dispatchEvent = function (component, target, event, simulatedEvent) {
      component.getSystem().triggerEvent(event, target, simulatedEvent.event);
    };

    var derive$2 = function (configs) {
      return wrapAll(configs);
    };
    var abort = function (name, predicate) {
      return {
        key: name,
        value: nu$9({ abort: predicate })
      };
    };
    var can = function (name, predicate) {
      return {
        key: name,
        value: nu$9({ can: predicate })
      };
    };
    var preventDefault = function (name) {
      return {
        key: name,
        value: nu$9({
          run: function (component, simulatedEvent) {
            simulatedEvent.event.prevent();
          }
        })
      };
    };
    var run$1 = function (name, handler) {
      return {
        key: name,
        value: nu$9({ run: handler })
      };
    };
    var runActionExtra = function (name, action, extra) {
      return {
        key: name,
        value: nu$9({
          run: function (component, simulatedEvent) {
            action.apply(undefined, [
              component,
              simulatedEvent
            ].concat(extra));
          }
        })
      };
    };
    var runOnName = function (name) {
      return function (handler) {
        return run$1(name, handler);
      };
    };
    var runOnSourceName = function (name) {
      return function (handler) {
        return {
          key: name,
          value: nu$9({
            run: function (component, simulatedEvent) {
              if (isSource(component, simulatedEvent)) {
                handler(component, simulatedEvent);
              }
            }
          })
        };
      };
    };
    var redirectToUid = function (name, uid) {
      return run$1(name, function (component, simulatedEvent) {
        component.getSystem().getByUid(uid).each(function (redirectee) {
          dispatchEvent(redirectee, redirectee.element, name, simulatedEvent);
        });
      });
    };
    var redirectToPart = function (name, detail, partName) {
      var uid = detail.partUids[partName];
      return redirectToUid(name, uid);
    };
    var runWithTarget = function (name, f) {
      return run$1(name, function (component, simulatedEvent) {
        var ev = simulatedEvent.event;
        var target = component.getSystem().getByDom(ev.target).getOrThunk(function () {
          var closest = closest$4(ev.target, function (el) {
            return component.getSystem().getByDom(el).toOptional();
          }, never);
          return closest.getOr(component);
        });
        f(component, target, simulatedEvent);
      });
    };
    var cutter = function (name) {
      return run$1(name, function (component, simulatedEvent) {
        simulatedEvent.cut();
      });
    };
    var stopper = function (name) {
      return run$1(name, function (component, simulatedEvent) {
        simulatedEvent.stop();
      });
    };
    var runOnSource = function (name, f) {
      return runOnSourceName(name)(f);
    };
    var runOnAttached = runOnSourceName(attachedToDom());
    var runOnDetached = runOnSourceName(detachedFromDom());
    var runOnInit = runOnSourceName(systemInit());
    var runOnExecute$1 = runOnName(execute$5());

    var fromHtml$1 = function (html, scope) {
      var doc = scope || document;
      var div = doc.createElement('div');
      div.innerHTML = html;
      return children(SugarElement.fromDom(div));
    };

    var get$7 = function (element) {
      return element.dom.innerHTML;
    };
    var set$5 = function (element, content) {
      var owner = owner$4(element);
      var docDom = owner.dom;
      var fragment = SugarElement.fromDom(docDom.createDocumentFragment());
      var contentElements = fromHtml$1(content, docDom);
      append$1(fragment, contentElements);
      empty(element);
      append$2(element, fragment);
    };
    var getOuter = function (element) {
      var container = SugarElement.fromTag('div');
      var clone = SugarElement.fromDom(element.dom.cloneNode(true));
      append$2(container, clone);
      return get$7(container);
    };

    var clone$1 = function (original, isDeep) {
      return SugarElement.fromDom(original.dom.cloneNode(isDeep));
    };
    var shallow = function (original) {
      return clone$1(original, false);
    };

    var getHtml = function (element) {
      if (isShadowRoot(element)) {
        return '#shadow-root';
      } else {
        var clone = shallow(element);
        return getOuter(clone);
      }
    };

    var element = function (elem) {
      return getHtml(elem);
    };

    var isRecursive = function (component, originator, target) {
      return eq(originator, component.element) && !eq(originator, target);
    };
    var events$i = derive$2([can(focus$4(), function (component, simulatedEvent) {
        var event = simulatedEvent.event;
        var originator = event.originator;
        var target = event.target;
        if (isRecursive(component, originator, target)) {
          console.warn(focus$4() + ' did not get interpreted by the desired target. ' + '\nOriginator: ' + element(originator) + '\nTarget: ' + element(target) + '\nCheck the ' + focus$4() + ' event handlers');
          return false;
        } else {
          return true;
        }
      })]);

    var DefaultEvents = /*#__PURE__*/Object.freeze({
        __proto__: null,
        events: events$i
    });

    var unique = 0;
    var generate$6 = function (prefix) {
      var date = new Date();
      var time = date.getTime();
      var random = Math.floor(Math.random() * 1000000000);
      unique++;
      return prefix + '_' + random + unique + String(time);
    };

    var prefix$1 = constant$1('alloy-id-');
    var idAttr$1 = constant$1('data-alloy-id');

    var prefix = prefix$1();
    var idAttr = idAttr$1();
    var write = function (label, elem) {
      var id = generate$6(prefix + label);
      writeOnly(elem, id);
      return id;
    };
    var writeOnly = function (elem, uid) {
      Object.defineProperty(elem.dom, idAttr, {
        value: uid,
        writable: true
      });
    };
    var read$1 = function (elem) {
      var id = isElement$2(elem) ? elem.dom[idAttr] : null;
      return Optional.from(id);
    };
    var generate$5 = function (prefix) {
      return generate$6(prefix);
    };

    var make$8 = identity$1;

    var NoContextApi = function (getComp) {
      var getMessage = function (event) {
        return 'The component must be in a context to execute: ' + event + (getComp ? '\n' + element(getComp().element) + ' is not in context.' : '');
      };
      var fail = function (event) {
        return function () {
          throw new Error(getMessage(event));
        };
      };
      var warn = function (event) {
        return function () {
          console.warn(getMessage(event));
        };
      };
      return {
        debugInfo: constant$1('fake'),
        triggerEvent: warn('triggerEvent'),
        triggerFocus: warn('triggerFocus'),
        triggerEscape: warn('triggerEscape'),
        broadcast: warn('broadcast'),
        broadcastOn: warn('broadcastOn'),
        broadcastEvent: warn('broadcastEvent'),
        build: fail('build'),
        addToWorld: fail('addToWorld'),
        removeFromWorld: fail('removeFromWorld'),
        addToGui: fail('addToGui'),
        removeFromGui: fail('removeFromGui'),
        getByUid: fail('getByUid'),
        getByDom: fail('getByDom'),
        isConnected: never
      };
    };
    var singleton$1 = NoContextApi();

    var markAsBehaviourApi = function (f, apiName, apiFunction) {
      var delegate = apiFunction.toString();
      var endIndex = delegate.indexOf(')') + 1;
      var openBracketIndex = delegate.indexOf('(');
      var parameters = delegate.substring(openBracketIndex + 1, endIndex - 1).split(/,\s*/);
      f.toFunctionAnnotation = function () {
        return {
          name: apiName,
          parameters: cleanParameters(parameters.slice(0, 1).concat(parameters.slice(3)))
        };
      };
      return f;
    };
    var cleanParameters = function (parameters) {
      return map$2(parameters, function (p) {
        return endsWith(p, '/*') ? p.substring(0, p.length - '/*'.length) : p;
      });
    };
    var markAsExtraApi = function (f, extraName) {
      var delegate = f.toString();
      var endIndex = delegate.indexOf(')') + 1;
      var openBracketIndex = delegate.indexOf('(');
      var parameters = delegate.substring(openBracketIndex + 1, endIndex - 1).split(/,\s*/);
      f.toFunctionAnnotation = function () {
        return {
          name: extraName,
          parameters: cleanParameters(parameters)
        };
      };
      return f;
    };
    var markAsSketchApi = function (f, apiFunction) {
      var delegate = apiFunction.toString();
      var endIndex = delegate.indexOf(')') + 1;
      var openBracketIndex = delegate.indexOf('(');
      var parameters = delegate.substring(openBracketIndex + 1, endIndex - 1).split(/,\s*/);
      f.toFunctionAnnotation = function () {
        return {
          name: 'OVERRIDE',
          parameters: cleanParameters(parameters.slice(1))
        };
      };
      return f;
    };

    var premadeTag = generate$6('alloy-premade');
    var premade$1 = function (comp) {
      return wrap$1(premadeTag, comp);
    };
    var getPremade = function (spec) {
      return get$e(spec, premadeTag);
    };
    var makeApi = function (f) {
      return markAsSketchApi(function (component) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
          rest[_i - 1] = arguments[_i];
        }
        return f.apply(void 0, __spreadArray([
          component.getApis(),
          component
        ], rest, false));
      }, f);
    };

    var NoState = {
      init: function () {
        return nu$8({ readState: constant$1('No State required') });
      }
    };
    var nu$8 = function (spec) {
      return spec;
    };

    var generateFrom$1 = function (spec, all) {
      var schema = map$2(all, function (a) {
        return optionObjOf(a.name(), [
          required$1('config'),
          defaulted('state', NoState)
        ]);
      });
      var validated = asRaw('component.behaviours', objOf(schema), spec.behaviours).fold(function (errInfo) {
        throw new Error(formatError(errInfo) + '\nComplete spec:\n' + JSON.stringify(spec, null, 2));
      }, identity$1);
      return {
        list: all,
        data: map$1(validated, function (optBlobThunk) {
          var output = optBlobThunk.map(function (blob) {
            return {
              config: blob.config,
              state: blob.state.init(blob.config)
            };
          });
          return constant$1(output);
        })
      };
    };
    var getBehaviours$3 = function (bData) {
      return bData.list;
    };
    var getData$2 = function (bData) {
      return bData.data;
    };

    var byInnerKey = function (data, tuple) {
      var r = {};
      each(data, function (detail, key) {
        each(detail, function (value, indexKey) {
          var chain = get$e(r, indexKey).getOr([]);
          r[indexKey] = chain.concat([tuple(key, value)]);
        });
      });
      return r;
    };

    var nu$7 = function (s) {
      return {
        classes: isUndefined(s.classes) ? [] : s.classes,
        attributes: isUndefined(s.attributes) ? {} : s.attributes,
        styles: isUndefined(s.styles) ? {} : s.styles
      };
    };
    var merge = function (defnA, mod) {
      return __assign(__assign({}, defnA), {
        attributes: __assign(__assign({}, defnA.attributes), mod.attributes),
        styles: __assign(__assign({}, defnA.styles), mod.styles),
        classes: defnA.classes.concat(mod.classes)
      });
    };

    var combine$2 = function (info, baseMod, behaviours, base) {
      var modsByBehaviour = __assign({}, baseMod);
      each$1(behaviours, function (behaviour) {
        modsByBehaviour[behaviour.name()] = behaviour.exhibit(info, base);
      });
      var byAspect = byInnerKey(modsByBehaviour, function (name, modification) {
        return {
          name: name,
          modification: modification
        };
      });
      var combineObjects = function (objects) {
        return foldr(objects, function (b, a) {
          return __assign(__assign({}, a.modification), b);
        }, {});
      };
      var combinedClasses = foldr(byAspect.classes, function (b, a) {
        return a.modification.concat(b);
      }, []);
      var combinedAttributes = combineObjects(byAspect.attributes);
      var combinedStyles = combineObjects(byAspect.styles);
      return nu$7({
        classes: combinedClasses,
        attributes: combinedAttributes,
        styles: combinedStyles
      });
    };

    var sortKeys = function (label, keyName, array, order) {
      try {
        var sorted = sort(array, function (a, b) {
          var aKey = a[keyName];
          var bKey = b[keyName];
          var aIndex = order.indexOf(aKey);
          var bIndex = order.indexOf(bKey);
          if (aIndex === -1) {
            throw new Error('The ordering for ' + label + ' does not have an entry for ' + aKey + '.\nOrder specified: ' + JSON.stringify(order, null, 2));
          }
          if (bIndex === -1) {
            throw new Error('The ordering for ' + label + ' does not have an entry for ' + bKey + '.\nOrder specified: ' + JSON.stringify(order, null, 2));
          }
          if (aIndex < bIndex) {
            return -1;
          } else if (bIndex < aIndex) {
            return 1;
          } else {
            return 0;
          }
        });
        return Result.value(sorted);
      } catch (err) {
        return Result.error([err]);
      }
    };

    var uncurried = function (handler, purpose) {
      return {
        handler: handler,
        purpose: purpose
      };
    };
    var curried = function (handler, purpose) {
      return {
        cHandler: handler,
        purpose: purpose
      };
    };
    var curryArgs = function (descHandler, extraArgs) {
      return curried(curry.apply(undefined, [descHandler.handler].concat(extraArgs)), descHandler.purpose);
    };
    var getCurried = function (descHandler) {
      return descHandler.cHandler;
    };

    var behaviourTuple = function (name, handler) {
      return {
        name: name,
        handler: handler
      };
    };
    var nameToHandlers = function (behaviours, info) {
      var r = {};
      each$1(behaviours, function (behaviour) {
        r[behaviour.name()] = behaviour.handlers(info);
      });
      return r;
    };
    var groupByEvents = function (info, behaviours, base) {
      var behaviourEvents = __assign(__assign({}, base), nameToHandlers(behaviours, info));
      return byInnerKey(behaviourEvents, behaviourTuple);
    };
    var combine$1 = function (info, eventOrder, behaviours, base) {
      var byEventName = groupByEvents(info, behaviours, base);
      return combineGroups(byEventName, eventOrder);
    };
    var assemble = function (rawHandler) {
      var handler = read$2(rawHandler);
      return function (component, simulatedEvent) {
        var rest = [];
        for (var _i = 2; _i < arguments.length; _i++) {
          rest[_i - 2] = arguments[_i];
        }
        var args = [
          component,
          simulatedEvent
        ].concat(rest);
        if (handler.abort.apply(undefined, args)) {
          simulatedEvent.stop();
        } else if (handler.can.apply(undefined, args)) {
          handler.run.apply(undefined, args);
        }
      };
    };
    var missingOrderError = function (eventName, tuples) {
      return Result.error(['The event (' + eventName + ') has more than one behaviour that listens to it.\nWhen this occurs, you must ' + 'specify an event ordering for the behaviours in your spec (e.g. [ "listing", "toggling" ]).\nThe behaviours that ' + 'can trigger it are: ' + JSON.stringify(map$2(tuples, function (c) {
          return c.name;
        }), null, 2)]);
    };
    var fuse = function (tuples, eventOrder, eventName) {
      var order = eventOrder[eventName];
      if (!order) {
        return missingOrderError(eventName, tuples);
      } else {
        return sortKeys('Event: ' + eventName, 'name', tuples, order).map(function (sortedTuples) {
          var handlers = map$2(sortedTuples, function (tuple) {
            return tuple.handler;
          });
          return fuse$1(handlers);
        });
      }
    };
    var combineGroups = function (byEventName, eventOrder) {
      var r = mapToArray(byEventName, function (tuples, eventName) {
        var combined = tuples.length === 1 ? Result.value(tuples[0].handler) : fuse(tuples, eventOrder, eventName);
        return combined.map(function (handler) {
          var assembled = assemble(handler);
          var purpose = tuples.length > 1 ? filter$2(eventOrder[eventName], function (o) {
            return exists(tuples, function (t) {
              return t.name === o;
            });
          }).join(' > ') : tuples[0].name;
          return wrap$1(eventName, uncurried(assembled, purpose));
        });
      });
      return consolidate(r, {});
    };

    var _a$2;
    var baseBehaviour = 'alloy.base.behaviour';
    var schema$z = objOf([
      field$1('dom', 'dom', required$2(), objOf([
        required$1('tag'),
        defaulted('styles', {}),
        defaulted('classes', []),
        defaulted('attributes', {}),
        option('value'),
        option('innerHtml')
      ])),
      required$1('components'),
      required$1('uid'),
      defaulted('events', {}),
      defaulted('apis', {}),
      field$1('eventOrder', 'eventOrder', mergeWith((_a$2 = {}, _a$2[execute$5()] = [
        'disabling',
        baseBehaviour,
        'toggling',
        'typeaheadevents'
      ], _a$2[focus$4()] = [
        baseBehaviour,
        'focusing',
        'keying'
      ], _a$2[systemInit()] = [
        baseBehaviour,
        'disabling',
        'toggling',
        'representing'
      ], _a$2[input()] = [
        baseBehaviour,
        'representing',
        'streaming',
        'invalidating'
      ], _a$2[detachedFromDom()] = [
        baseBehaviour,
        'representing',
        'item-events',
        'tooltipping'
      ], _a$2[mousedown()] = [
        'focusing',
        baseBehaviour,
        'item-type-events'
      ], _a$2[touchstart()] = [
        'focusing',
        baseBehaviour,
        'item-type-events'
      ], _a$2[mouseover()] = [
        'item-type-events',
        'tooltipping'
      ], _a$2[receive()] = [
        'receiving',
        'reflecting',
        'tooltipping'
      ], _a$2)), anyValue()),
      option('domModification')
    ]);
    var toInfo = function (spec) {
      return asRaw('custom.definition', schema$z, spec);
    };
    var toDefinition = function (detail) {
      return __assign(__assign({}, detail.dom), {
        uid: detail.uid,
        domChildren: map$2(detail.components, function (comp) {
          return comp.element;
        })
      });
    };
    var toModification = function (detail) {
      return detail.domModification.fold(function () {
        return nu$7({});
      }, nu$7);
    };
    var toEvents = function (info) {
      return info.events;
    };

    var read = function (element, attr) {
      var value = get$d(element, attr);
      return value === undefined || value === '' ? [] : value.split(' ');
    };
    var add$4 = function (element, attr, id) {
      var old = read(element, attr);
      var nu = old.concat([id]);
      set$8(element, attr, nu.join(' '));
      return true;
    };
    var remove$4 = function (element, attr, id) {
      var nu = filter$2(read(element, attr), function (v) {
        return v !== id;
      });
      if (nu.length > 0) {
        set$8(element, attr, nu.join(' '));
      } else {
        remove$7(element, attr);
      }
      return false;
    };

    var supports = function (element) {
      return element.dom.classList !== undefined;
    };
    var get$6 = function (element) {
      return read(element, 'class');
    };
    var add$3 = function (element, clazz) {
      return add$4(element, 'class', clazz);
    };
    var remove$3 = function (element, clazz) {
      return remove$4(element, 'class', clazz);
    };

    var add$2 = function (element, clazz) {
      if (supports(element)) {
        element.dom.classList.add(clazz);
      } else {
        add$3(element, clazz);
      }
    };
    var cleanClass = function (element) {
      var classList = supports(element) ? element.dom.classList : get$6(element);
      if (classList.length === 0) {
        remove$7(element, 'class');
      }
    };
    var remove$2 = function (element, clazz) {
      if (supports(element)) {
        var classList = element.dom.classList;
        classList.remove(clazz);
      } else {
        remove$3(element, clazz);
      }
      cleanClass(element);
    };
    var has = function (element, clazz) {
      return supports(element) && element.dom.classList.contains(clazz);
    };

    var add$1 = function (element, classes) {
      each$1(classes, function (x) {
        add$2(element, x);
      });
    };
    var remove$1 = function (element, classes) {
      each$1(classes, function (x) {
        remove$2(element, x);
      });
    };
    var hasAll = function (element, classes) {
      return forall(classes, function (clazz) {
        return has(element, clazz);
      });
    };

    var get$5 = function (element) {
      return element.dom.value;
    };
    var set$4 = function (element, value) {
      if (value === undefined) {
        throw new Error('Value.set was undefined');
      }
      element.dom.value = value;
    };

    var renderToDom = function (definition) {
      var subject = SugarElement.fromTag(definition.tag);
      setAll$1(subject, definition.attributes);
      add$1(subject, definition.classes);
      setAll(subject, definition.styles);
      definition.innerHtml.each(function (html) {
        return set$5(subject, html);
      });
      var children = definition.domChildren;
      append$1(subject, children);
      definition.value.each(function (value) {
        set$4(subject, value);
      });
      if (!definition.uid) {
        debugger;
      }
      writeOnly(subject, definition.uid);
      return subject;
    };

    var getBehaviours$2 = function (spec) {
      var behaviours = get$e(spec, 'behaviours').getOr({});
      return bind$3(keys(behaviours), function (name) {
        var behaviour = behaviours[name];
        return isNonNullable(behaviour) ? [behaviour.me] : [];
      });
    };
    var generateFrom = function (spec, all) {
      return generateFrom$1(spec, all);
    };
    var generate$4 = function (spec) {
      var all = getBehaviours$2(spec);
      return generateFrom(spec, all);
    };

    var getDomDefinition = function (info, bList, bData) {
      var definition = toDefinition(info);
      var infoModification = toModification(info);
      var baseModification = { 'alloy.base.modification': infoModification };
      var modification = bList.length > 0 ? combine$2(bData, baseModification, bList, definition) : infoModification;
      return merge(definition, modification);
    };
    var getEvents = function (info, bList, bData) {
      var baseEvents = { 'alloy.base.behaviour': toEvents(info) };
      return combine$1(bData, info.eventOrder, bList, baseEvents).getOrDie();
    };
    var build$2 = function (spec) {
      var getMe = function () {
        return me;
      };
      var systemApi = Cell(singleton$1);
      var info = getOrDie(toInfo(spec));
      var bBlob = generate$4(spec);
      var bList = getBehaviours$3(bBlob);
      var bData = getData$2(bBlob);
      var modDefinition = getDomDefinition(info, bList, bData);
      var item = renderToDom(modDefinition);
      var events = getEvents(info, bList, bData);
      var subcomponents = Cell(info.components);
      var connect = function (newApi) {
        systemApi.set(newApi);
      };
      var disconnect = function () {
        systemApi.set(NoContextApi(getMe));
      };
      var syncComponents = function () {
        var children$1 = children(item);
        var subs = bind$3(children$1, function (child) {
          return systemApi.get().getByDom(child).fold(function () {
            return [];
          }, pure$2);
        });
        subcomponents.set(subs);
      };
      var config = function (behaviour) {
        var b = bData;
        var f = isFunction(b[behaviour.name()]) ? b[behaviour.name()] : function () {
          throw new Error('Could not find ' + behaviour.name() + ' in ' + JSON.stringify(spec, null, 2));
        };
        return f();
      };
      var hasConfigured = function (behaviour) {
        return isFunction(bData[behaviour.name()]);
      };
      var getApis = function () {
        return info.apis;
      };
      var readState = function (behaviourName) {
        return bData[behaviourName]().map(function (b) {
          return b.state.readState();
        }).getOr('not enabled');
      };
      var me = {
        uid: spec.uid,
        getSystem: systemApi.get,
        config: config,
        hasConfigured: hasConfigured,
        spec: spec,
        readState: readState,
        getApis: getApis,
        connect: connect,
        disconnect: disconnect,
        element: item,
        syncComponents: syncComponents,
        components: subcomponents.get,
        events: events
      };
      return me;
    };

    var buildSubcomponents = function (spec) {
      var components = get$e(spec, 'components').getOr([]);
      return map$2(components, build$1);
    };
    var buildFromSpec = function (userSpec) {
      var _a = make$8(userSpec), specEvents = _a.events, spec = __rest(_a, ['events']);
      var components = buildSubcomponents(spec);
      var completeSpec = __assign(__assign({}, spec), {
        events: __assign(__assign({}, DefaultEvents), specEvents),
        components: components
      });
      return Result.value(build$2(completeSpec));
    };
    var text = function (textContent) {
      var element = SugarElement.fromText(textContent);
      return external$2({ element: element });
    };
    var external$2 = function (spec) {
      var extSpec = asRawOrDie$1('external.component', objOfOnly([
        required$1('element'),
        option('uid')
      ]), spec);
      var systemApi = Cell(NoContextApi());
      var connect = function (newApi) {
        systemApi.set(newApi);
      };
      var disconnect = function () {
        systemApi.set(NoContextApi(function () {
          return me;
        }));
      };
      var uid = extSpec.uid.getOrThunk(function () {
        return generate$5('external');
      });
      writeOnly(extSpec.element, uid);
      var me = {
        uid: uid,
        getSystem: systemApi.get,
        config: Optional.none,
        hasConfigured: never,
        connect: connect,
        disconnect: disconnect,
        getApis: function () {
          return {};
        },
        element: extSpec.element,
        spec: spec,
        readState: constant$1('No state'),
        syncComponents: noop,
        components: constant$1([]),
        events: {}
      };
      return premade$1(me);
    };
    var uids = generate$5;
    var isSketchSpec$1 = function (spec) {
      return has$2(spec, 'uid');
    };
    var build$1 = function (spec) {
      return getPremade(spec).getOrThunk(function () {
        var userSpecWithUid = isSketchSpec$1(spec) ? spec : __assign({ uid: uids('') }, spec);
        return buildFromSpec(userSpecWithUid).getOrDie();
      });
    };
    var premade = premade$1;

    function ClosestOrAncestor (is, ancestor, scope, a, isRoot) {
      if (is(scope, a)) {
        return Optional.some(scope);
      } else if (isFunction(isRoot) && isRoot(scope)) {
        return Optional.none();
      } else {
        return ancestor(scope, a, isRoot);
      }
    }

    var ancestor$1 = function (scope, predicate, isRoot) {
      var element = scope.dom;
      var stop = isFunction(isRoot) ? isRoot : never;
      while (element.parentNode) {
        element = element.parentNode;
        var el = SugarElement.fromDom(element);
        if (predicate(el)) {
          return Optional.some(el);
        } else if (stop(el)) {
          break;
        }
      }
      return Optional.none();
    };
    var closest$3 = function (scope, predicate, isRoot) {
      var is = function (s, test) {
        return test(s);
      };
      return ClosestOrAncestor(is, ancestor$1, scope, predicate, isRoot);
    };
    var child$1 = function (scope, predicate) {
      var pred = function (node) {
        return predicate(SugarElement.fromDom(node));
      };
      var result = find$5(scope.dom.childNodes, pred);
      return result.map(SugarElement.fromDom);
    };
    var descendant$1 = function (scope, predicate) {
      var descend = function (node) {
        for (var i = 0; i < node.childNodes.length; i++) {
          var child_1 = SugarElement.fromDom(node.childNodes[i]);
          if (predicate(child_1)) {
            return Optional.some(child_1);
          }
          var res = descend(node.childNodes[i]);
          if (res.isSome()) {
            return res;
          }
        }
        return Optional.none();
      };
      return descend(scope.dom);
    };

    var closest$2 = function (scope, predicate, isRoot) {
      return closest$3(scope, predicate, isRoot).isSome();
    };

    var ancestor = function (scope, selector, isRoot) {
      return ancestor$1(scope, function (e) {
        return is(e, selector);
      }, isRoot);
    };
    var child = function (scope, selector) {
      return child$1(scope, function (e) {
        return is(e, selector);
      });
    };
    var descendant = function (scope, selector) {
      return one(selector, scope);
    };
    var closest$1 = function (scope, selector, isRoot) {
      var is$1 = function (element, selector) {
        return is(element, selector);
      };
      return ClosestOrAncestor(is$1, ancestor, scope, selector, isRoot);
    };

    var find$1 = function (queryElem) {
      var dependent = closest$3(queryElem, function (elem) {
        if (!isElement$2(elem)) {
          return false;
        }
        var id = get$d(elem, 'id');
        return id !== undefined && id.indexOf('aria-owns') > -1;
      });
      return dependent.bind(function (dep) {
        var id = get$d(dep, 'id');
        var dos = getRootNode(dep);
        return descendant(dos, '[aria-owns="' + id + '"]');
      });
    };
    var manager = function () {
      var ariaId = generate$6('aria-owns');
      var link = function (elem) {
        set$8(elem, 'aria-owns', ariaId);
      };
      var unlink = function (elem) {
        remove$7(elem, 'aria-owns');
      };
      return {
        id: ariaId,
        link: link,
        unlink: unlink
      };
    };

    var isAriaPartOf = function (component, queryElem) {
      return find$1(queryElem).exists(function (owner) {
        return isPartOf$1(component, owner);
      });
    };
    var isPartOf$1 = function (component, queryElem) {
      return closest$2(queryElem, function (el) {
        return eq(el, component.element);
      }, never) || isAriaPartOf(component, queryElem);
    };

    var unknown = 'unknown';
    var EventConfiguration;
    (function (EventConfiguration) {
      EventConfiguration[EventConfiguration['STOP'] = 0] = 'STOP';
      EventConfiguration[EventConfiguration['NORMAL'] = 1] = 'NORMAL';
      EventConfiguration[EventConfiguration['LOGGING'] = 2] = 'LOGGING';
    }(EventConfiguration || (EventConfiguration = {})));
    var eventConfig = Cell({});
    var makeEventLogger = function (eventName, initialTarget) {
      var sequence = [];
      var startTime = new Date().getTime();
      return {
        logEventCut: function (_name, target, purpose) {
          sequence.push({
            outcome: 'cut',
            target: target,
            purpose: purpose
          });
        },
        logEventStopped: function (_name, target, purpose) {
          sequence.push({
            outcome: 'stopped',
            target: target,
            purpose: purpose
          });
        },
        logNoParent: function (_name, target, purpose) {
          sequence.push({
            outcome: 'no-parent',
            target: target,
            purpose: purpose
          });
        },
        logEventNoHandlers: function (_name, target) {
          sequence.push({
            outcome: 'no-handlers-left',
            target: target
          });
        },
        logEventResponse: function (_name, target, purpose) {
          sequence.push({
            outcome: 'response',
            purpose: purpose,
            target: target
          });
        },
        write: function () {
          var finishTime = new Date().getTime();
          if (contains$2([
              'mousemove',
              'mouseover',
              'mouseout',
              systemInit()
            ], eventName)) {
            return;
          }
          console.log(eventName, {
            event: eventName,
            time: finishTime - startTime,
            target: initialTarget.dom,
            sequence: map$2(sequence, function (s) {
              if (!contains$2([
                  'cut',
                  'stopped',
                  'response'
                ], s.outcome)) {
                return s.outcome;
              } else {
                return '{' + s.purpose + '} ' + s.outcome + ' at (' + element(s.target) + ')';
              }
            })
          });
        }
      };
    };
    var processEvent = function (eventName, initialTarget, f) {
      var status = get$e(eventConfig.get(), eventName).orThunk(function () {
        var patterns = keys(eventConfig.get());
        return findMap(patterns, function (p) {
          return eventName.indexOf(p) > -1 ? Optional.some(eventConfig.get()[p]) : Optional.none();
        });
      }).getOr(EventConfiguration.NORMAL);
      switch (status) {
      case EventConfiguration.NORMAL:
        return f(noLogger());
      case EventConfiguration.LOGGING: {
          var logger = makeEventLogger(eventName, initialTarget);
          var output = f(logger);
          logger.write();
          return output;
        }
      case EventConfiguration.STOP:
        return true;
      }
    };
    var path = [
      'alloy/data/Fields',
      'alloy/debugging/Debugging'
    ];
    var getTrace = function () {
      var err = new Error();
      if (err.stack !== undefined) {
        var lines = err.stack.split('\n');
        return find$5(lines, function (line) {
          return line.indexOf('alloy') > 0 && !exists(path, function (p) {
            return line.indexOf(p) > -1;
          });
        }).getOr(unknown);
      } else {
        return unknown;
      }
    };
    var ignoreEvent = {
      logEventCut: noop,
      logEventStopped: noop,
      logNoParent: noop,
      logEventNoHandlers: noop,
      logEventResponse: noop,
      write: noop
    };
    var monitorEvent = function (eventName, initialTarget, f) {
      return processEvent(eventName, initialTarget, f);
    };
    var noLogger = constant$1(ignoreEvent);

    var menuFields = constant$1([
      required$1('menu'),
      required$1('selectedMenu')
    ]);
    var itemFields = constant$1([
      required$1('item'),
      required$1('selectedItem')
    ]);
    constant$1(objOf(itemFields().concat(menuFields())));
    var itemSchema$3 = constant$1(objOf(itemFields()));

    var _initSize = requiredObjOf('initSize', [
      required$1('numColumns'),
      required$1('numRows')
    ]);
    var itemMarkers = function () {
      return requiredOf('markers', itemSchema$3());
    };
    var tieredMenuMarkers = function () {
      return requiredObjOf('markers', [required$1('backgroundMenu')].concat(menuFields()).concat(itemFields()));
    };
    var markers$1 = function (required) {
      return requiredObjOf('markers', map$2(required, required$1));
    };
    var onPresenceHandler = function (label, fieldName, presence) {
      getTrace();
      return field$1(fieldName, fieldName, presence, valueOf(function (f) {
        return Result.value(function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          return f.apply(undefined, args);
        });
      }));
    };
    var onHandler = function (fieldName) {
      return onPresenceHandler('onHandler', fieldName, defaulted$1(noop));
    };
    var onKeyboardHandler = function (fieldName) {
      return onPresenceHandler('onKeyboardHandler', fieldName, defaulted$1(Optional.none));
    };
    var onStrictHandler = function (fieldName) {
      return onPresenceHandler('onHandler', fieldName, required$2());
    };
    var onStrictKeyboardHandler = function (fieldName) {
      return onPresenceHandler('onKeyboardHandler', fieldName, required$2());
    };
    var output$1 = function (name, value) {
      return customField(name, constant$1(value));
    };
    var snapshot = function (name) {
      return customField(name, identity$1);
    };
    var initSize = constant$1(_initSize);

    var nu$6 = function (x, y, bubble, direction, placement, boundsRestriction, labelPrefix, alwaysFit) {
      if (alwaysFit === void 0) {
        alwaysFit = false;
      }
      return {
        x: x,
        y: y,
        bubble: bubble,
        direction: direction,
        placement: placement,
        restriction: boundsRestriction,
        label: labelPrefix + '-' + placement,
        alwaysFit: alwaysFit
      };
    };

    var adt$a = Adt.generate([
      { southeast: [] },
      { southwest: [] },
      { northeast: [] },
      { northwest: [] },
      { south: [] },
      { north: [] },
      { east: [] },
      { west: [] }
    ]);
    var cata$2 = function (subject, southeast, southwest, northeast, northwest, south, north, east, west) {
      return subject.fold(southeast, southwest, northeast, northwest, south, north, east, west);
    };
    var cataVertical = function (subject, south, middle, north) {
      return subject.fold(south, south, north, north, south, north, middle, middle);
    };
    var cataHorizontal = function (subject, east, middle, west) {
      return subject.fold(east, west, east, west, middle, middle, east, west);
    };
    var southeast$3 = adt$a.southeast;
    var southwest$3 = adt$a.southwest;
    var northeast$3 = adt$a.northeast;
    var northwest$3 = adt$a.northwest;
    var south$3 = adt$a.south;
    var north$3 = adt$a.north;
    var east$3 = adt$a.east;
    var west$3 = adt$a.west;

    var cycleBy = function (value, delta, min, max) {
      var r = value + delta;
      if (r > max) {
        return min;
      } else if (r < min) {
        return max;
      } else {
        return r;
      }
    };
    var clamp$1 = function (value, min, max) {
      return Math.min(Math.max(value, min), max);
    };

    var getRestriction = function (anchor, restriction) {
      switch (restriction) {
      case 1:
        return anchor.x;
      case 0:
        return anchor.x + anchor.width;
      case 2:
        return anchor.y;
      case 3:
        return anchor.y + anchor.height;
      }
    };
    var boundsRestriction = function (anchor, restrictions) {
      return mapToObject([
        'left',
        'right',
        'top',
        'bottom'
      ], function (dir) {
        return get$e(restrictions, dir).map(function (restriction) {
          return getRestriction(anchor, restriction);
        });
      });
    };
    var adjustBounds = function (bounds$1, restriction, bubbleOffset) {
      var applyRestriction = function (dir, current) {
        return restriction[dir].map(function (pos) {
          var isVerticalAxis = dir === 'top' || dir === 'bottom';
          var offset = isVerticalAxis ? bubbleOffset.top : bubbleOffset.left;
          var comparator = dir === 'left' || dir === 'top' ? Math.max : Math.min;
          var newPos = comparator(pos, current) + offset;
          return isVerticalAxis ? clamp$1(newPos, bounds$1.y, bounds$1.bottom) : clamp$1(newPos, bounds$1.x, bounds$1.right);
        }).getOr(current);
      };
      var adjustedLeft = applyRestriction('left', bounds$1.x);
      var adjustedTop = applyRestriction('top', bounds$1.y);
      var adjustedRight = applyRestriction('right', bounds$1.right);
      var adjustedBottom = applyRestriction('bottom', bounds$1.bottom);
      return bounds(adjustedLeft, adjustedTop, adjustedRight - adjustedLeft, adjustedBottom - adjustedTop);
    };

    var labelPrefix$2 = 'layout';
    var eastX$1 = function (anchor) {
      return anchor.x;
    };
    var middleX$1 = function (anchor, element) {
      return anchor.x + anchor.width / 2 - element.width / 2;
    };
    var westX$1 = function (anchor, element) {
      return anchor.x + anchor.width - element.width;
    };
    var northY$2 = function (anchor, element) {
      return anchor.y - element.height;
    };
    var southY$2 = function (anchor) {
      return anchor.y + anchor.height;
    };
    var centreY$1 = function (anchor, element) {
      return anchor.y + anchor.height / 2 - element.height / 2;
    };
    var eastEdgeX$1 = function (anchor) {
      return anchor.x + anchor.width;
    };
    var westEdgeX$1 = function (anchor, element) {
      return anchor.x - element.width;
    };
    var southeast$2 = function (anchor, element, bubbles) {
      return nu$6(eastX$1(anchor), southY$2(anchor), bubbles.southeast(), southeast$3(), 'southeast', boundsRestriction(anchor, {
        left: 1,
        top: 3
      }), labelPrefix$2);
    };
    var southwest$2 = function (anchor, element, bubbles) {
      return nu$6(westX$1(anchor, element), southY$2(anchor), bubbles.southwest(), southwest$3(), 'southwest', boundsRestriction(anchor, {
        right: 0,
        top: 3
      }), labelPrefix$2);
    };
    var northeast$2 = function (anchor, element, bubbles) {
      return nu$6(eastX$1(anchor), northY$2(anchor, element), bubbles.northeast(), northeast$3(), 'northeast', boundsRestriction(anchor, {
        left: 1,
        bottom: 2
      }), labelPrefix$2);
    };
    var northwest$2 = function (anchor, element, bubbles) {
      return nu$6(westX$1(anchor, element), northY$2(anchor, element), bubbles.northwest(), northwest$3(), 'northwest', boundsRestriction(anchor, {
        right: 0,
        bottom: 2
      }), labelPrefix$2);
    };
    var north$2 = function (anchor, element, bubbles) {
      return nu$6(middleX$1(anchor, element), northY$2(anchor, element), bubbles.north(), north$3(), 'north', boundsRestriction(anchor, { bottom: 2 }), labelPrefix$2);
    };
    var south$2 = function (anchor, element, bubbles) {
      return nu$6(middleX$1(anchor, element), southY$2(anchor), bubbles.south(), south$3(), 'south', boundsRestriction(anchor, { top: 3 }), labelPrefix$2);
    };
    var east$2 = function (anchor, element, bubbles) {
      return nu$6(eastEdgeX$1(anchor), centreY$1(anchor, element), bubbles.east(), east$3(), 'east', boundsRestriction(anchor, { left: 0 }), labelPrefix$2);
    };
    var west$2 = function (anchor, element, bubbles) {
      return nu$6(westEdgeX$1(anchor, element), centreY$1(anchor, element), bubbles.west(), west$3(), 'west', boundsRestriction(anchor, { right: 1 }), labelPrefix$2);
    };
    var all$1 = function () {
      return [
        southeast$2,
        southwest$2,
        northeast$2,
        northwest$2,
        south$2,
        north$2,
        east$2,
        west$2
      ];
    };
    var allRtl$1 = function () {
      return [
        southwest$2,
        southeast$2,
        northwest$2,
        northeast$2,
        south$2,
        north$2,
        east$2,
        west$2
      ];
    };
    var aboveOrBelow = function () {
      return [
        northeast$2,
        northwest$2,
        southeast$2,
        southwest$2,
        north$2,
        south$2
      ];
    };
    var aboveOrBelowRtl = function () {
      return [
        northwest$2,
        northeast$2,
        southwest$2,
        southeast$2,
        north$2,
        south$2
      ];
    };
    var belowOrAbove = function () {
      return [
        southeast$2,
        southwest$2,
        northeast$2,
        northwest$2,
        south$2,
        north$2
      ];
    };
    var belowOrAboveRtl = function () {
      return [
        southwest$2,
        southeast$2,
        northwest$2,
        northeast$2,
        south$2,
        north$2
      ];
    };

    var chooseChannels = function (channels, message) {
      return message.universal ? channels : filter$2(channels, function (ch) {
        return contains$2(message.channels, ch);
      });
    };
    var events$h = function (receiveConfig) {
      return derive$2([run$1(receive(), function (component, message) {
          var channelMap = receiveConfig.channels;
          var channels = keys(channelMap);
          var receivingData = message;
          var targetChannels = chooseChannels(channels, receivingData);
          each$1(targetChannels, function (ch) {
            var channelInfo = channelMap[ch];
            var channelSchema = channelInfo.schema;
            var data = asRawOrDie$1('channel[' + ch + '] data\nReceiver: ' + element(component.element), channelSchema, receivingData.data);
            channelInfo.onReceive(component, data);
          });
        })]);
    };

    var ActiveReceiving = /*#__PURE__*/Object.freeze({
        __proto__: null,
        events: events$h
    });

    var ReceivingSchema = [requiredOf('channels', setOf(Result.value, objOfOnly([
        onStrictHandler('onReceive'),
        defaulted('schema', anyValue())
      ])))];

    var executeEvent = function (bConfig, bState, executor) {
      return runOnExecute$1(function (component) {
        executor(component, bConfig, bState);
      });
    };
    var loadEvent = function (bConfig, bState, f) {
      return runOnInit(function (component, _simulatedEvent) {
        f(component, bConfig, bState);
      });
    };
    var create$8 = function (schema, name, active, apis, extra, state) {
      var configSchema = objOfOnly(schema);
      var schemaSchema = optionObjOf(name, [optionObjOfOnly('config', schema)]);
      return doCreate(configSchema, schemaSchema, name, active, apis, extra, state);
    };
    var createModes$1 = function (modes, name, active, apis, extra, state) {
      var configSchema = modes;
      var schemaSchema = optionObjOf(name, [optionOf('config', modes)]);
      return doCreate(configSchema, schemaSchema, name, active, apis, extra, state);
    };
    var wrapApi = function (bName, apiFunction, apiName) {
      var f = function (component) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
          rest[_i - 1] = arguments[_i];
        }
        var args = [component].concat(rest);
        return component.config({ name: constant$1(bName) }).fold(function () {
          throw new Error('We could not find any behaviour configuration for: ' + bName + '. Using API: ' + apiName);
        }, function (info) {
          var rest = Array.prototype.slice.call(args, 1);
          return apiFunction.apply(undefined, [
            component,
            info.config,
            info.state
          ].concat(rest));
        });
      };
      return markAsBehaviourApi(f, apiName, apiFunction);
    };
    var revokeBehaviour = function (name) {
      return {
        key: name,
        value: undefined
      };
    };
    var doCreate = function (configSchema, schemaSchema, name, active, apis, extra, state) {
      var getConfig = function (info) {
        return hasNonNullableKey(info, name) ? info[name]() : Optional.none();
      };
      var wrappedApis = map$1(apis, function (apiF, apiName) {
        return wrapApi(name, apiF, apiName);
      });
      var wrappedExtra = map$1(extra, function (extraF, extraName) {
        return markAsExtraApi(extraF, extraName);
      });
      var me = __assign(__assign(__assign({}, wrappedExtra), wrappedApis), {
        revoke: curry(revokeBehaviour, name),
        config: function (spec) {
          var prepared = asRawOrDie$1(name + '-config', configSchema, spec);
          return {
            key: name,
            value: {
              config: prepared,
              me: me,
              configAsRaw: cached(function () {
                return asRawOrDie$1(name + '-config', configSchema, spec);
              }),
              initialConfig: spec,
              state: state
            }
          };
        },
        schema: constant$1(schemaSchema),
        exhibit: function (info, base) {
          return lift2(getConfig(info), get$e(active, 'exhibit'), function (behaviourInfo, exhibitor) {
            return exhibitor(base, behaviourInfo.config, behaviourInfo.state);
          }).getOrThunk(function () {
            return nu$7({});
          });
        },
        name: constant$1(name),
        handlers: function (info) {
          return getConfig(info).map(function (behaviourInfo) {
            var getEvents = get$e(active, 'events').getOr(function () {
              return {};
            });
            return getEvents(behaviourInfo.config, behaviourInfo.state);
          }).getOr({});
        }
      });
      return me;
    };

    var derive$1 = function (capabilities) {
      return wrapAll(capabilities);
    };
    var simpleSchema = objOfOnly([
      required$1('fields'),
      required$1('name'),
      defaulted('active', {}),
      defaulted('apis', {}),
      defaulted('state', NoState),
      defaulted('extra', {})
    ]);
    var create$7 = function (data) {
      var value = asRawOrDie$1('Creating behaviour: ' + data.name, simpleSchema, data);
      return create$8(value.fields, value.name, value.active, value.apis, value.extra, value.state);
    };
    var modeSchema = objOfOnly([
      required$1('branchKey'),
      required$1('branches'),
      required$1('name'),
      defaulted('active', {}),
      defaulted('apis', {}),
      defaulted('state', NoState),
      defaulted('extra', {})
    ]);
    var createModes = function (data) {
      var value = asRawOrDie$1('Creating behaviour: ' + data.name, modeSchema, data);
      return createModes$1(choose$1(value.branchKey, value.branches), value.name, value.active, value.apis, value.extra, value.state);
    };
    var revoke = constant$1(undefined);

    var Receiving = create$7({
      fields: ReceivingSchema,
      name: 'receiving',
      active: ActiveReceiving
    });

    var exhibit$6 = function (base, posConfig) {
      return nu$7({
        classes: [],
        styles: posConfig.useFixed() ? {} : { position: 'relative' }
      });
    };

    var ActivePosition = /*#__PURE__*/Object.freeze({
        __proto__: null,
        exhibit: exhibit$6
    });

    var getDocument = function () {
      return SugarElement.fromDom(document);
    };

    var focus$3 = function (element) {
      return element.dom.focus();
    };
    var blur$1 = function (element) {
      return element.dom.blur();
    };
    var hasFocus = function (element) {
      var root = getRootNode(element).dom;
      return element.dom === root.activeElement;
    };
    var active = function (root) {
      if (root === void 0) {
        root = getDocument();
      }
      return Optional.from(root.dom.activeElement).map(SugarElement.fromDom);
    };
    var search = function (element) {
      return active(getRootNode(element)).filter(function (e) {
        return element.dom.contains(e.dom);
      });
    };

    var preserve$1 = function (f, container) {
      var dos = getRootNode(container);
      var refocus = active(dos).bind(function (focused) {
        var hasFocus = function (elem) {
          return eq(focused, elem);
        };
        return hasFocus(container) ? Optional.some(container) : descendant$1(container, hasFocus);
      });
      var result = f(container);
      refocus.each(function (oldFocus) {
        active(dos).filter(function (newFocus) {
          return eq(newFocus, oldFocus);
        }).fold(function () {
          focus$3(oldFocus);
        }, noop);
      });
      return result;
    };

    var NuPositionCss = function (position, left, top, right, bottom) {
      var toPx = function (num) {
        return num + 'px';
      };
      return {
        position: position,
        left: left.map(toPx),
        top: top.map(toPx),
        right: right.map(toPx),
        bottom: bottom.map(toPx)
      };
    };
    var toOptions = function (position) {
      return __assign(__assign({}, position), { position: Optional.some(position.position) });
    };
    var applyPositionCss = function (element, position) {
      setOptions(element, toOptions(position));
    };

    var adt$9 = Adt.generate([
      { none: [] },
      {
        relative: [
          'x',
          'y',
          'width',
          'height'
        ]
      },
      {
        fixed: [
          'x',
          'y',
          'width',
          'height'
        ]
      }
    ]);
    var positionWithDirection = function (posName, decision, x, y, width, height) {
      var decisionRect = decision.rect;
      var decisionX = decisionRect.x - x;
      var decisionY = decisionRect.y - y;
      var decisionWidth = decisionRect.width;
      var decisionHeight = decisionRect.height;
      var decisionRight = width - (decisionX + decisionWidth);
      var decisionBottom = height - (decisionY + decisionHeight);
      var left = Optional.some(decisionX);
      var top = Optional.some(decisionY);
      var right = Optional.some(decisionRight);
      var bottom = Optional.some(decisionBottom);
      var none = Optional.none();
      return cata$2(decision.direction, function () {
        return NuPositionCss(posName, left, top, none, none);
      }, function () {
        return NuPositionCss(posName, none, top, right, none);
      }, function () {
        return NuPositionCss(posName, left, none, none, bottom);
      }, function () {
        return NuPositionCss(posName, none, none, right, bottom);
      }, function () {
        return NuPositionCss(posName, left, top, none, none);
      }, function () {
        return NuPositionCss(posName, left, none, none, bottom);
      }, function () {
        return NuPositionCss(posName, left, top, none, none);
      }, function () {
        return NuPositionCss(posName, none, top, right, none);
      });
    };
    var reposition = function (origin, decision) {
      return origin.fold(function () {
        var decisionRect = decision.rect;
        return NuPositionCss('absolute', Optional.some(decisionRect.x), Optional.some(decisionRect.y), Optional.none(), Optional.none());
      }, function (x, y, width, height) {
        return positionWithDirection('absolute', decision, x, y, width, height);
      }, function (x, y, width, height) {
        return positionWithDirection('fixed', decision, x, y, width, height);
      });
    };
    var toBox = function (origin, element) {
      var rel = curry(find$2, element);
      var position = origin.fold(rel, rel, function () {
        var scroll = get$9();
        return find$2(element).translate(-scroll.left, -scroll.top);
      });
      var width = getOuter$1(element);
      var height = getOuter$2(element);
      return bounds(position.left, position.top, width, height);
    };
    var viewport = function (origin, getBounds) {
      return getBounds.fold(function () {
        return origin.fold(win, win, bounds);
      }, function (b) {
        return origin.fold(b, b, function () {
          var bounds$1 = b();
          var pos = translate$2(origin, bounds$1.x, bounds$1.y);
          return bounds(pos.left, pos.top, bounds$1.width, bounds$1.height);
        });
      });
    };
    var translate$2 = function (origin, x, y) {
      var pos = SugarPosition(x, y);
      var removeScroll = function () {
        var outerScroll = get$9();
        return pos.translate(-outerScroll.left, -outerScroll.top);
      };
      return origin.fold(constant$1(pos), constant$1(pos), removeScroll);
    };
    var cata$1 = function (subject, onNone, onRelative, onFixed) {
      return subject.fold(onNone, onRelative, onFixed);
    };
    adt$9.none;
    var relative$1 = adt$9.relative;
    var fixed$1 = adt$9.fixed;

    var anchor = function (anchorBox, origin) {
      return {
        anchorBox: anchorBox,
        origin: origin
      };
    };
    var box = function (anchorBox, origin) {
      return anchor(anchorBox, origin);
    };

    var placementAttribute = 'data-alloy-placement';
    var setPlacement$1 = function (element, placement) {
      set$8(element, placementAttribute, placement);
    };
    var getPlacement = function (element) {
      return getOpt(element, placementAttribute);
    };
    var reset$2 = function (element) {
      return remove$7(element, placementAttribute);
    };

    var adt$8 = Adt.generate([
      { fit: ['reposition'] },
      {
        nofit: [
          'reposition',
          'visibleW',
          'visibleH',
          'isVisible'
        ]
      }
    ]);
    var determinePosition = function (box, bounds) {
      var boundsX = bounds.x, boundsY = bounds.y, boundsRight = bounds.right, boundsBottom = bounds.bottom;
      var x = box.x, y = box.y, right = box.right, bottom = box.bottom, width = box.width, height = box.height;
      var xInBounds = x >= boundsX && x <= boundsRight;
      var yInBounds = y >= boundsY && y <= boundsBottom;
      var originInBounds = xInBounds && yInBounds;
      var rightInBounds = right <= boundsRight && right >= boundsX;
      var bottomInBounds = bottom <= boundsBottom && bottom >= boundsY;
      var sizeInBounds = rightInBounds && bottomInBounds;
      var visibleW = Math.min(width, x >= boundsX ? boundsRight - x : right - boundsX);
      var visibleH = Math.min(height, y >= boundsY ? boundsBottom - y : bottom - boundsY);
      return {
        originInBounds: originInBounds,
        sizeInBounds: sizeInBounds,
        visibleW: visibleW,
        visibleH: visibleH
      };
    };
    var calcReposition = function (box, bounds$1) {
      var boundsX = bounds$1.x, boundsY = bounds$1.y, boundsRight = bounds$1.right, boundsBottom = bounds$1.bottom;
      var x = box.x, y = box.y, width = box.width, height = box.height;
      var maxX = Math.max(boundsX, boundsRight - width);
      var maxY = Math.max(boundsY, boundsBottom - height);
      var restrictedX = clamp$1(x, boundsX, maxX);
      var restrictedY = clamp$1(y, boundsY, maxY);
      var restrictedWidth = Math.min(restrictedX + width, boundsRight) - restrictedX;
      var restrictedHeight = Math.min(restrictedY + height, boundsBottom) - restrictedY;
      return bounds(restrictedX, restrictedY, restrictedWidth, restrictedHeight);
    };
    var calcMaxSizes = function (direction, box, bounds) {
      var upAvailable = constant$1(box.bottom - bounds.y);
      var downAvailable = constant$1(bounds.bottom - box.y);
      var maxHeight = cataVertical(direction, downAvailable, downAvailable, upAvailable);
      var westAvailable = constant$1(box.right - bounds.x);
      var eastAvailable = constant$1(bounds.right - box.x);
      var maxWidth = cataHorizontal(direction, eastAvailable, eastAvailable, westAvailable);
      return {
        maxWidth: maxWidth,
        maxHeight: maxHeight
      };
    };
    var attempt = function (candidate, width, height, bounds$1) {
      var bubble = candidate.bubble;
      var bubbleOffset = bubble.offset;
      var adjustedBounds = adjustBounds(bounds$1, candidate.restriction, bubbleOffset);
      var newX = candidate.x + bubbleOffset.left;
      var newY = candidate.y + bubbleOffset.top;
      var box = bounds(newX, newY, width, height);
      var _a = determinePosition(box, adjustedBounds), originInBounds = _a.originInBounds, sizeInBounds = _a.sizeInBounds, visibleW = _a.visibleW, visibleH = _a.visibleH;
      var fits = originInBounds && sizeInBounds;
      var fittedBox = fits ? box : calcReposition(box, adjustedBounds);
      var isPartlyVisible = fittedBox.width > 0 && fittedBox.height > 0;
      var _b = calcMaxSizes(candidate.direction, fittedBox, bounds$1), maxWidth = _b.maxWidth, maxHeight = _b.maxHeight;
      var reposition = {
        rect: fittedBox,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        direction: candidate.direction,
        placement: candidate.placement,
        classes: {
          on: bubble.classesOn,
          off: bubble.classesOff
        },
        layout: candidate.label,
        testY: newY
      };
      return fits || candidate.alwaysFit ? adt$8.fit(reposition) : adt$8.nofit(reposition, visibleW, visibleH, isPartlyVisible);
    };
    var attempts = function (element, candidates, anchorBox, elementBox, bubbles, bounds) {
      var panelWidth = elementBox.width;
      var panelHeight = elementBox.height;
      var attemptBestFit = function (layout, reposition, visibleW, visibleH, isVisible) {
        var next = layout(anchorBox, elementBox, bubbles, element, bounds);
        var attemptLayout = attempt(next, panelWidth, panelHeight, bounds);
        return attemptLayout.fold(constant$1(attemptLayout), function (newReposition, newVisibleW, newVisibleH, newIsVisible) {
          var improved = isVisible === newIsVisible ? newVisibleH > visibleH || newVisibleW > visibleW : !isVisible && newIsVisible;
          return improved ? attemptLayout : adt$8.nofit(reposition, visibleW, visibleH, isVisible);
        });
      };
      var abc = foldl(candidates, function (b, a) {
        var bestNext = curry(attemptBestFit, a);
        return b.fold(constant$1(b), bestNext);
      }, adt$8.nofit({
        rect: anchorBox,
        maxHeight: elementBox.height,
        maxWidth: elementBox.width,
        direction: southeast$3(),
        placement: 'southeast',
        classes: {
          on: [],
          off: []
        },
        layout: 'none',
        testY: anchorBox.y
      }, -1, -1, false));
      return abc.fold(identity$1, identity$1);
    };

    var singleton = function (doRevoke) {
      var subject = Cell(Optional.none());
      var revoke = function () {
        return subject.get().each(doRevoke);
      };
      var clear = function () {
        revoke();
        subject.set(Optional.none());
      };
      var isSet = function () {
        return subject.get().isSome();
      };
      var get = function () {
        return subject.get();
      };
      var set = function (s) {
        revoke();
        subject.set(Optional.some(s));
      };
      return {
        clear: clear,
        isSet: isSet,
        get: get,
        set: set
      };
    };
    var destroyable = function () {
      return singleton(function (s) {
        return s.destroy();
      });
    };
    var unbindable = function () {
      return singleton(function (s) {
        return s.unbind();
      });
    };
    var api$1 = function () {
      var subject = destroyable();
      var run = function (f) {
        return subject.get().each(f);
      };
      return __assign(__assign({}, subject), { run: run });
    };
    var value$1 = function () {
      var subject = singleton(noop);
      var on = function (f) {
        return subject.get().each(f);
      };
      return __assign(__assign({}, subject), { on: on });
    };

    var filter = always;
    var bind = function (element, event, handler) {
      return bind$2(element, event, filter, handler);
    };
    var capture = function (element, event, handler) {
      return capture$1(element, event, filter, handler);
    };
    var fromRawEvent = fromRawEvent$1;

    var properties = [
      'top',
      'bottom',
      'right',
      'left'
    ];
    var timerAttr = 'data-alloy-transition-timer';
    var isTransitioning$1 = function (element, transition) {
      return hasAll(element, transition.classes);
    };
    var shouldApplyTransitionCss = function (transition, decision, lastPlacement) {
      return lastPlacement.exists(function (placer) {
        var mode = transition.mode;
        return mode === 'all' ? true : placer[mode] !== decision[mode];
      });
    };
    var hasChanges = function (position, intermediate) {
      var round = function (value) {
        return parseFloat(value).toFixed(3);
      };
      return find$4(intermediate, function (value, key) {
        var newValue = position[key].map(round);
        var val = value.map(round);
        return !equals(newValue, val);
      }).isSome();
    };
    var getTransitionDuration = function (element) {
      var get = function (name) {
        var style = get$c(element, name);
        var times = isString(style) ? style.split(/\s*,\s*/) : [];
        return filter$2(times, isNotEmpty);
      };
      var parse = function (value) {
        if (isString(value) && /^[\d.]+/.test(value)) {
          var num = parseFloat(value);
          return endsWith(value, 'ms') ? num : num * 1000;
        } else {
          return 0;
        }
      };
      var delay = get('transition-delay');
      var duration = get('transition-duration');
      return foldl(duration, function (acc, dur, i) {
        var time = parse(delay[i]) + parse(dur);
        return Math.max(acc, time);
      }, 0);
    };
    var setupTransitionListeners = function (element, transition) {
      var transitionEnd = unbindable();
      var transitionCancel = unbindable();
      var timer;
      var isSourceTransition = function (e) {
        var _a;
        var pseudoElement = (_a = e.raw.pseudoElement) !== null && _a !== void 0 ? _a : '';
        return eq(e.target, element) && isEmpty(pseudoElement) && contains$2(properties, e.raw.propertyName);
      };
      var transitionDone = function (e) {
        if (isNullable(e) || isSourceTransition(e)) {
          transitionEnd.clear();
          transitionCancel.clear();
          var type = e === null || e === void 0 ? void 0 : e.raw.type;
          if (isNullable(type) || type === transitionend()) {
            clearTimeout(timer);
            remove$7(element, timerAttr);
            remove$1(element, transition.classes);
          }
        }
      };
      var transitionStarted = function () {
        transitionEnd.set(bind(element, transitionend(), transitionDone));
        transitionCancel.set(bind(element, transitioncancel(), transitionDone));
      };
      if ('ontransitionstart' in element.dom) {
        var transitionStart_1 = bind(element, transitionstart(), function (e) {
          if (isSourceTransition(e)) {
            transitionStart_1.unbind();
            transitionStarted();
          }
        });
      } else {
        transitionStarted();
      }
      var duration = getTransitionDuration(element);
      requestAnimationFrame(function () {
        timer = setTimeout(transitionDone, duration + 17);
        set$8(element, timerAttr, timer);
      });
    };
    var startTransitioning = function (element, transition) {
      add$1(element, transition.classes);
      getOpt(element, timerAttr).each(function (timerId) {
        clearTimeout(parseInt(timerId, 10));
        remove$7(element, timerAttr);
      });
      setupTransitionListeners(element, transition);
    };
    var applyTransitionCss = function (element, origin, position, transition, decision, lastPlacement) {
      var shouldTransition = shouldApplyTransitionCss(transition, decision, lastPlacement);
      if (shouldTransition || isTransitioning$1(element, transition)) {
        set$7(element, 'position', position.position);
        var rect = toBox(origin, element);
        var intermediatePosition_1 = reposition(origin, __assign(__assign({}, decision), { rect: rect }));
        var intermediateCssOptions = mapToObject(properties, function (prop) {
          return intermediatePosition_1[prop];
        });
        if (hasChanges(position, intermediateCssOptions)) {
          setOptions(element, intermediateCssOptions);
          if (shouldTransition) {
            startTransitioning(element, transition);
          }
          reflow(element);
        }
      } else {
        remove$1(element, transition.classes);
      }
    };

    var elementSize = function (p) {
      return {
        width: getOuter$1(p),
        height: getOuter$2(p)
      };
    };
    var layout = function (anchorBox, element, bubbles, options) {
      remove$6(element, 'max-height');
      remove$6(element, 'max-width');
      var elementBox = elementSize(element);
      return attempts(element, options.preference, anchorBox, elementBox, bubbles, options.bounds);
    };
    var setClasses = function (element, decision) {
      var classInfo = decision.classes;
      remove$1(element, classInfo.off);
      add$1(element, classInfo.on);
    };
    var setHeight = function (element, decision, options) {
      var maxHeightFunction = options.maxHeightFunction;
      maxHeightFunction(element, decision.maxHeight);
    };
    var setWidth = function (element, decision, options) {
      var maxWidthFunction = options.maxWidthFunction;
      maxWidthFunction(element, decision.maxWidth);
    };
    var position$2 = function (element, decision, options) {
      var positionCss = reposition(options.origin, decision);
      options.transition.each(function (transition) {
        applyTransitionCss(element, options.origin, positionCss, transition, decision, options.lastPlacement);
      });
      applyPositionCss(element, positionCss);
    };
    var setPlacement = function (element, decision) {
      setPlacement$1(element, decision.placement);
    };

    var setMaxHeight = function (element, maxHeight) {
      setMax$1(element, Math.floor(maxHeight));
    };
    var anchored = constant$1(function (element, available) {
      setMaxHeight(element, available);
      setAll(element, {
        'overflow-x': 'hidden',
        'overflow-y': 'auto'
      });
    });
    var expandable$1 = constant$1(function (element, available) {
      setMaxHeight(element, available);
    });

    var defaultOr = function (options, key, dephault) {
      return options[key] === undefined ? dephault : options[key];
    };
    var simple = function (anchor, element, bubble, layouts, lastPlacement, getBounds, overrideOptions, transition) {
      var maxHeightFunction = defaultOr(overrideOptions, 'maxHeightFunction', anchored());
      var maxWidthFunction = defaultOr(overrideOptions, 'maxWidthFunction', noop);
      var anchorBox = anchor.anchorBox;
      var origin = anchor.origin;
      var options = {
        bounds: viewport(origin, getBounds),
        origin: origin,
        preference: layouts,
        maxHeightFunction: maxHeightFunction,
        maxWidthFunction: maxWidthFunction,
        lastPlacement: lastPlacement,
        transition: transition
      };
      return go(anchorBox, element, bubble, options);
    };
    var go = function (anchorBox, element, bubble, options) {
      var decision = layout(anchorBox, element, bubble, options);
      position$2(element, decision, options);
      setPlacement(element, decision);
      setClasses(element, decision);
      setHeight(element, decision, options);
      setWidth(element, decision, options);
      return {
        layout: decision.layout,
        placement: decision.placement
      };
    };

    var allAlignments = [
      'valignCentre',
      'alignLeft',
      'alignRight',
      'alignCentre',
      'top',
      'bottom',
      'left',
      'right',
      'inset'
    ];
    var nu$5 = function (xOffset, yOffset, classes, insetModifier) {
      if (insetModifier === void 0) {
        insetModifier = 1;
      }
      var insetXOffset = xOffset * insetModifier;
      var insetYOffset = yOffset * insetModifier;
      var getClasses = function (prop) {
        return get$e(classes, prop).getOr([]);
      };
      var make = function (xDelta, yDelta, alignmentsOn) {
        var alignmentsOff = difference(allAlignments, alignmentsOn);
        return {
          offset: SugarPosition(xDelta, yDelta),
          classesOn: bind$3(alignmentsOn, getClasses),
          classesOff: bind$3(alignmentsOff, getClasses)
        };
      };
      return {
        southeast: function () {
          return make(-xOffset, yOffset, [
            'top',
            'alignLeft'
          ]);
        },
        southwest: function () {
          return make(xOffset, yOffset, [
            'top',
            'alignRight'
          ]);
        },
        south: function () {
          return make(-xOffset / 2, yOffset, [
            'top',
            'alignCentre'
          ]);
        },
        northeast: function () {
          return make(-xOffset, -yOffset, [
            'bottom',
            'alignLeft'
          ]);
        },
        northwest: function () {
          return make(xOffset, -yOffset, [
            'bottom',
            'alignRight'
          ]);
        },
        north: function () {
          return make(-xOffset / 2, -yOffset, [
            'bottom',
            'alignCentre'
          ]);
        },
        east: function () {
          return make(xOffset, -yOffset / 2, [
            'valignCentre',
            'left'
          ]);
        },
        west: function () {
          return make(-xOffset, -yOffset / 2, [
            'valignCentre',
            'right'
          ]);
        },
        insetNortheast: function () {
          return make(insetXOffset, insetYOffset, [
            'top',
            'alignLeft',
            'inset'
          ]);
        },
        insetNorthwest: function () {
          return make(-insetXOffset, insetYOffset, [
            'top',
            'alignRight',
            'inset'
          ]);
        },
        insetNorth: function () {
          return make(-insetXOffset / 2, insetYOffset, [
            'top',
            'alignCentre',
            'inset'
          ]);
        },
        insetSoutheast: function () {
          return make(insetXOffset, -insetYOffset, [
            'bottom',
            'alignLeft',
            'inset'
          ]);
        },
        insetSouthwest: function () {
          return make(-insetXOffset, -insetYOffset, [
            'bottom',
            'alignRight',
            'inset'
          ]);
        },
        insetSouth: function () {
          return make(-insetXOffset / 2, -insetYOffset, [
            'bottom',
            'alignCentre',
            'inset'
          ]);
        },
        insetEast: function () {
          return make(-insetXOffset, -insetYOffset / 2, [
            'valignCentre',
            'right',
            'inset'
          ]);
        },
        insetWest: function () {
          return make(insetXOffset, -insetYOffset / 2, [
            'valignCentre',
            'left',
            'inset'
          ]);
        }
      };
    };
    var fallback = function () {
      return nu$5(0, 0, {});
    };

    var nu$4 = identity$1;

    var onDirection = function (isLtr, isRtl) {
      return function (element) {
        return getDirection(element) === 'rtl' ? isRtl : isLtr;
      };
    };
    var getDirection = function (element) {
      return get$c(element, 'direction') === 'rtl' ? 'rtl' : 'ltr';
    };

    var AttributeValue;
    (function (AttributeValue) {
      AttributeValue['TopToBottom'] = 'toptobottom';
      AttributeValue['BottomToTop'] = 'bottomtotop';
    }(AttributeValue || (AttributeValue = {})));
    var Attribute = 'data-alloy-vertical-dir';
    var isBottomToTopDir = function (el) {
      return closest$2(el, function (current) {
        return isElement$2(current) && get$d(current, 'data-alloy-vertical-dir') === AttributeValue.BottomToTop;
      });
    };

    var schema$y = function () {
      return optionObjOf('layouts', [
        required$1('onLtr'),
        required$1('onRtl'),
        option('onBottomLtr'),
        option('onBottomRtl')
      ]);
    };
    var get$4 = function (elem, info, defaultLtr, defaultRtl, defaultBottomLtr, defaultBottomRtl, dirElement) {
      var isBottomToTop = dirElement.map(isBottomToTopDir).getOr(false);
      var customLtr = info.layouts.map(function (ls) {
        return ls.onLtr(elem);
      });
      var customRtl = info.layouts.map(function (ls) {
        return ls.onRtl(elem);
      });
      var ltr = isBottomToTop ? info.layouts.bind(function (ls) {
        return ls.onBottomLtr.map(function (f) {
          return f(elem);
        });
      }).or(customLtr).getOr(defaultBottomLtr) : customLtr.getOr(defaultLtr);
      var rtl = isBottomToTop ? info.layouts.bind(function (ls) {
        return ls.onBottomRtl.map(function (f) {
          return f(elem);
        });
      }).or(customRtl).getOr(defaultBottomRtl) : customRtl.getOr(defaultRtl);
      var f = onDirection(ltr, rtl);
      return f(elem);
    };

    var placement$4 = function (component, anchorInfo, origin) {
      var hotspot = anchorInfo.hotspot;
      var anchorBox = toBox(origin, hotspot.element);
      var layouts = get$4(component.element, anchorInfo, belowOrAbove(), belowOrAboveRtl(), aboveOrBelow(), aboveOrBelowRtl(), Optional.some(anchorInfo.hotspot.element));
      return Optional.some(nu$4({
        anchorBox: anchorBox,
        bubble: anchorInfo.bubble.getOr(fallback()),
        overrides: anchorInfo.overrides,
        layouts: layouts,
        placer: Optional.none()
      }));
    };
    var HotspotAnchor = [
      required$1('hotspot'),
      option('bubble'),
      defaulted('overrides', {}),
      schema$y(),
      output$1('placement', placement$4)
    ];

    var placement$3 = function (component, anchorInfo, origin) {
      var pos = translate$2(origin, anchorInfo.x, anchorInfo.y);
      var anchorBox = bounds(pos.left, pos.top, anchorInfo.width, anchorInfo.height);
      var layouts = get$4(component.element, anchorInfo, all$1(), allRtl$1(), all$1(), allRtl$1(), Optional.none());
      return Optional.some(nu$4({
        anchorBox: anchorBox,
        bubble: anchorInfo.bubble,
        overrides: anchorInfo.overrides,
        layouts: layouts,
        placer: Optional.none()
      }));
    };
    var MakeshiftAnchor = [
      required$1('x'),
      required$1('y'),
      defaulted('height', 0),
      defaulted('width', 0),
      defaulted('bubble', fallback()),
      defaulted('overrides', {}),
      schema$y(),
      output$1('placement', placement$3)
    ];

    var adt$7 = Adt.generate([
      { screen: ['point'] },
      {
        absolute: [
          'point',
          'scrollLeft',
          'scrollTop'
        ]
      }
    ]);
    var toFixed = function (pos) {
      return pos.fold(identity$1, function (point, scrollLeft, scrollTop) {
        return point.translate(-scrollLeft, -scrollTop);
      });
    };
    var toAbsolute = function (pos) {
      return pos.fold(identity$1, identity$1);
    };
    var sum = function (points) {
      return foldl(points, function (b, a) {
        return b.translate(a.left, a.top);
      }, SugarPosition(0, 0));
    };
    var sumAsFixed = function (positions) {
      var points = map$2(positions, toFixed);
      return sum(points);
    };
    var sumAsAbsolute = function (positions) {
      var points = map$2(positions, toAbsolute);
      return sum(points);
    };
    var screen = adt$7.screen;
    var absolute$1 = adt$7.absolute;

    var getOffset = function (component, origin, anchorInfo) {
      var win = defaultView(anchorInfo.root).dom;
      var hasSameOwner = function (frame) {
        var frameOwner = owner$4(frame);
        var compOwner = owner$4(component.element);
        return eq(frameOwner, compOwner);
      };
      return Optional.from(win.frameElement).map(SugarElement.fromDom).filter(hasSameOwner).map(absolute$3);
    };
    var getRootPoint = function (component, origin, anchorInfo) {
      var doc = owner$4(component.element);
      var outerScroll = get$9(doc);
      var offset = getOffset(component, origin, anchorInfo).getOr(outerScroll);
      return absolute$1(offset, outerScroll.left, outerScroll.top);
    };

    var getBox = function (left, top, width, height) {
      var point = screen(SugarPosition(left, top));
      return Optional.some(pointed(point, width, height));
    };
    var calcNewAnchor = function (optBox, rootPoint, anchorInfo, origin, elem) {
      return optBox.map(function (box) {
        var points = [
          rootPoint,
          box.point
        ];
        var topLeft = cata$1(origin, function () {
          return sumAsAbsolute(points);
        }, function () {
          return sumAsAbsolute(points);
        }, function () {
          return sumAsFixed(points);
        });
        var anchorBox = rect(topLeft.left, topLeft.top, box.width, box.height);
        var layoutsLtr = anchorInfo.showAbove ? aboveOrBelow() : belowOrAbove();
        var layoutsRtl = anchorInfo.showAbove ? aboveOrBelowRtl() : belowOrAboveRtl();
        var layouts = get$4(elem, anchorInfo, layoutsLtr, layoutsRtl, layoutsLtr, layoutsRtl, Optional.none());
        return nu$4({
          anchorBox: anchorBox,
          bubble: anchorInfo.bubble.getOr(fallback()),
          overrides: anchorInfo.overrides,
          layouts: layouts,
          placer: Optional.none()
        });
      });
    };

    var placement$2 = function (component, anchorInfo, origin) {
      var rootPoint = getRootPoint(component, origin, anchorInfo);
      return anchorInfo.node.filter(inBody).bind(function (target) {
        var rect = target.dom.getBoundingClientRect();
        var nodeBox = getBox(rect.left, rect.top, rect.width, rect.height);
        var elem = anchorInfo.node.getOr(component.element);
        return calcNewAnchor(nodeBox, rootPoint, anchorInfo, origin, elem);
      });
    };
    var NodeAnchor = [
      required$1('node'),
      required$1('root'),
      option('bubble'),
      schema$y(),
      defaulted('overrides', {}),
      defaulted('showAbove', false),
      output$1('placement', placement$2)
    ];

    var zeroWidth = '\uFEFF';
    var nbsp = '\xA0';

    var create$6 = function (start, soffset, finish, foffset) {
      return {
        start: start,
        soffset: soffset,
        finish: finish,
        foffset: foffset
      };
    };
    var SimRange = { create: create$6 };

    var adt$6 = Adt.generate([
      { before: ['element'] },
      {
        on: [
          'element',
          'offset'
        ]
      },
      { after: ['element'] }
    ]);
    var cata = function (subject, onBefore, onOn, onAfter) {
      return subject.fold(onBefore, onOn, onAfter);
    };
    var getStart$1 = function (situ) {
      return situ.fold(identity$1, identity$1, identity$1);
    };
    var before = adt$6.before;
    var on$1 = adt$6.on;
    var after$1 = adt$6.after;
    var Situ = {
      before: before,
      on: on$1,
      after: after$1,
      cata: cata,
      getStart: getStart$1
    };

    var adt$5 = Adt.generate([
      { domRange: ['rng'] },
      {
        relative: [
          'startSitu',
          'finishSitu'
        ]
      },
      {
        exact: [
          'start',
          'soffset',
          'finish',
          'foffset'
        ]
      }
    ]);
    var exactFromRange = function (simRange) {
      return adt$5.exact(simRange.start, simRange.soffset, simRange.finish, simRange.foffset);
    };
    var getStart = function (selection) {
      return selection.match({
        domRange: function (rng) {
          return SugarElement.fromDom(rng.startContainer);
        },
        relative: function (startSitu, _finishSitu) {
          return Situ.getStart(startSitu);
        },
        exact: function (start, _soffset, _finish, _foffset) {
          return start;
        }
      });
    };
    var domRange = adt$5.domRange;
    var relative = adt$5.relative;
    var exact = adt$5.exact;
    var getWin = function (selection) {
      var start = getStart(selection);
      return defaultView(start);
    };
    var range$1 = SimRange.create;
    var SimSelection = {
      domRange: domRange,
      relative: relative,
      exact: exact,
      exactFromRange: exactFromRange,
      getWin: getWin,
      range: range$1
    };

    var setStart = function (rng, situ) {
      situ.fold(function (e) {
        rng.setStartBefore(e.dom);
      }, function (e, o) {
        rng.setStart(e.dom, o);
      }, function (e) {
        rng.setStartAfter(e.dom);
      });
    };
    var setFinish = function (rng, situ) {
      situ.fold(function (e) {
        rng.setEndBefore(e.dom);
      }, function (e, o) {
        rng.setEnd(e.dom, o);
      }, function (e) {
        rng.setEndAfter(e.dom);
      });
    };
    var relativeToNative = function (win, startSitu, finishSitu) {
      var range = win.document.createRange();
      setStart(range, startSitu);
      setFinish(range, finishSitu);
      return range;
    };
    var exactToNative = function (win, start, soffset, finish, foffset) {
      var rng = win.document.createRange();
      rng.setStart(start.dom, soffset);
      rng.setEnd(finish.dom, foffset);
      return rng;
    };
    var toRect = function (rect) {
      return {
        left: rect.left,
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        width: rect.width,
        height: rect.height
      };
    };
    var getFirstRect$1 = function (rng) {
      var rects = rng.getClientRects();
      var rect = rects.length > 0 ? rects[0] : rng.getBoundingClientRect();
      return rect.width > 0 || rect.height > 0 ? Optional.some(rect).map(toRect) : Optional.none();
    };
    var getBounds$2 = function (rng) {
      var rect = rng.getBoundingClientRect();
      return rect.width > 0 || rect.height > 0 ? Optional.some(rect).map(toRect) : Optional.none();
    };

    var adt$4 = Adt.generate([
      {
        ltr: [
          'start',
          'soffset',
          'finish',
          'foffset'
        ]
      },
      {
        rtl: [
          'start',
          'soffset',
          'finish',
          'foffset'
        ]
      }
    ]);
    var fromRange = function (win, type, range) {
      return type(SugarElement.fromDom(range.startContainer), range.startOffset, SugarElement.fromDom(range.endContainer), range.endOffset);
    };
    var getRanges = function (win, selection) {
      return selection.match({
        domRange: function (rng) {
          return {
            ltr: constant$1(rng),
            rtl: Optional.none
          };
        },
        relative: function (startSitu, finishSitu) {
          return {
            ltr: cached(function () {
              return relativeToNative(win, startSitu, finishSitu);
            }),
            rtl: cached(function () {
              return Optional.some(relativeToNative(win, finishSitu, startSitu));
            })
          };
        },
        exact: function (start, soffset, finish, foffset) {
          return {
            ltr: cached(function () {
              return exactToNative(win, start, soffset, finish, foffset);
            }),
            rtl: cached(function () {
              return Optional.some(exactToNative(win, finish, foffset, start, soffset));
            })
          };
        }
      });
    };
    var doDiagnose = function (win, ranges) {
      var rng = ranges.ltr();
      if (rng.collapsed) {
        var reversed = ranges.rtl().filter(function (rev) {
          return rev.collapsed === false;
        });
        return reversed.map(function (rev) {
          return adt$4.rtl(SugarElement.fromDom(rev.endContainer), rev.endOffset, SugarElement.fromDom(rev.startContainer), rev.startOffset);
        }).getOrThunk(function () {
          return fromRange(win, adt$4.ltr, rng);
        });
      } else {
        return fromRange(win, adt$4.ltr, rng);
      }
    };
    var diagnose = function (win, selection) {
      var ranges = getRanges(win, selection);
      return doDiagnose(win, ranges);
    };
    var asLtrRange = function (win, selection) {
      var diagnosis = diagnose(win, selection);
      return diagnosis.match({
        ltr: function (start, soffset, finish, foffset) {
          var rng = win.document.createRange();
          rng.setStart(start.dom, soffset);
          rng.setEnd(finish.dom, foffset);
          return rng;
        },
        rtl: function (start, soffset, finish, foffset) {
          var rng = win.document.createRange();
          rng.setStart(finish.dom, foffset);
          rng.setEnd(start.dom, soffset);
          return rng;
        }
      });
    };
    adt$4.ltr;
    adt$4.rtl;

    var NodeValue = function (is, name) {
      var get = function (element) {
        if (!is(element)) {
          throw new Error('Can only get ' + name + ' value of a ' + name + ' node');
        }
        return getOption(element).getOr('');
      };
      var getOption = function (element) {
        return is(element) ? Optional.from(element.dom.nodeValue) : Optional.none();
      };
      var set = function (element, value) {
        if (!is(element)) {
          throw new Error('Can only set raw ' + name + ' value of a ' + name + ' node');
        }
        element.dom.nodeValue = value;
      };
      return {
        get: get,
        getOption: getOption,
        set: set
      };
    };

    var api = NodeValue(isText$1, 'text');
    var get$3 = function (element) {
      return api.get(element);
    };
    var getOption = function (element) {
      return api.getOption(element);
    };

    var getEnd = function (element) {
      return name$2(element) === 'img' ? 1 : getOption(element).fold(function () {
        return children(element).length;
      }, function (v) {
        return v.length;
      });
    };
    var isTextNodeWithCursorPosition = function (el) {
      return getOption(el).filter(function (text) {
        return text.trim().length !== 0 || text.indexOf(nbsp) > -1;
      }).isSome();
    };
    var elementsWithCursorPosition = [
      'img',
      'br'
    ];
    var isCursorPosition = function (elem) {
      var hasCursorPosition = isTextNodeWithCursorPosition(elem);
      return hasCursorPosition || contains$2(elementsWithCursorPosition, name$2(elem));
    };

    var last$1 = function (element) {
      return descendantRtl(element, isCursorPosition);
    };
    var descendantRtl = function (scope, predicate) {
      var descend = function (element) {
        var children$1 = children(element);
        for (var i = children$1.length - 1; i >= 0; i--) {
          var child = children$1[i];
          if (predicate(child)) {
            return Optional.some(child);
          }
          var res = descend(child);
          if (res.isSome()) {
            return res;
          }
        }
        return Optional.none();
      };
      return descend(scope);
    };

    var descendants = function (scope, selector) {
      return all$3(selector, scope);
    };

    var makeRange = function (start, soffset, finish, foffset) {
      var doc = owner$4(start);
      var rng = doc.dom.createRange();
      rng.setStart(start.dom, soffset);
      rng.setEnd(finish.dom, foffset);
      return rng;
    };
    var after = function (start, soffset, finish, foffset) {
      var r = makeRange(start, soffset, finish, foffset);
      var same = eq(start, finish) && soffset === foffset;
      return r.collapsed && !same;
    };

    var getNativeSelection = function (win) {
      return Optional.from(win.getSelection());
    };
    var readRange = function (selection) {
      if (selection.rangeCount > 0) {
        var firstRng = selection.getRangeAt(0);
        var lastRng = selection.getRangeAt(selection.rangeCount - 1);
        return Optional.some(SimRange.create(SugarElement.fromDom(firstRng.startContainer), firstRng.startOffset, SugarElement.fromDom(lastRng.endContainer), lastRng.endOffset));
      } else {
        return Optional.none();
      }
    };
    var doGetExact = function (selection) {
      if (selection.anchorNode === null || selection.focusNode === null) {
        return readRange(selection);
      } else {
        var anchor = SugarElement.fromDom(selection.anchorNode);
        var focus_1 = SugarElement.fromDom(selection.focusNode);
        return after(anchor, selection.anchorOffset, focus_1, selection.focusOffset) ? Optional.some(SimRange.create(anchor, selection.anchorOffset, focus_1, selection.focusOffset)) : readRange(selection);
      }
    };
    var getExact = function (win) {
      return getNativeSelection(win).filter(function (sel) {
        return sel.rangeCount > 0;
      }).bind(doGetExact);
    };
    var getFirstRect = function (win, selection) {
      var rng = asLtrRange(win, selection);
      return getFirstRect$1(rng);
    };
    var getBounds$1 = function (win, selection) {
      var rng = asLtrRange(win, selection);
      return getBounds$2(rng);
    };

    var point$1 = function (element, offset) {
      return {
        element: element,
        offset: offset
      };
    };
    var descendOnce$1 = function (element, offset) {
      var children$1 = children(element);
      if (children$1.length === 0) {
        return point$1(element, offset);
      } else if (offset < children$1.length) {
        return point$1(children$1[offset], 0);
      } else {
        var last = children$1[children$1.length - 1];
        var len = isText$1(last) ? get$3(last).length : children(last).length;
        return point$1(last, len);
      }
    };

    var descendOnce = function (element, offset) {
      return isText$1(element) ? point$1(element, offset) : descendOnce$1(element, offset);
    };
    var getAnchorSelection = function (win, anchorInfo) {
      var getSelection = anchorInfo.getSelection.getOrThunk(function () {
        return function () {
          return getExact(win);
        };
      });
      return getSelection().map(function (sel) {
        var modStart = descendOnce(sel.start, sel.soffset);
        var modFinish = descendOnce(sel.finish, sel.foffset);
        return SimSelection.range(modStart.element, modStart.offset, modFinish.element, modFinish.offset);
      });
    };
    var placement$1 = function (component, anchorInfo, origin) {
      var win = defaultView(anchorInfo.root).dom;
      var rootPoint = getRootPoint(component, origin, anchorInfo);
      var selectionBox = getAnchorSelection(win, anchorInfo).bind(function (sel) {
        var optRect = getBounds$1(win, SimSelection.exactFromRange(sel)).orThunk(function () {
          var x = SugarElement.fromText(zeroWidth);
          before$2(sel.start, x);
          var rect = getFirstRect(win, SimSelection.exact(x, 0, x, 1));
          remove$5(x);
          return rect;
        });
        return optRect.bind(function (rawRect) {
          return getBox(rawRect.left, rawRect.top, rawRect.width, rawRect.height);
        });
      });
      var targetElement = getAnchorSelection(win, anchorInfo).bind(function (sel) {
        return isElement$2(sel.start) ? Optional.some(sel.start) : parentNode(sel.start);
      });
      var elem = targetElement.getOr(component.element);
      return calcNewAnchor(selectionBox, rootPoint, anchorInfo, origin, elem);
    };
    var SelectionAnchor = [
      option('getSelection'),
      required$1('root'),
      option('bubble'),
      schema$y(),
      defaulted('overrides', {}),
      defaulted('showAbove', false),
      output$1('placement', placement$1)
    ];

    var labelPrefix$1 = 'link-layout';
    var eastX = function (anchor) {
      return anchor.x + anchor.width;
    };
    var westX = function (anchor, element) {
      return anchor.x - element.width;
    };
    var northY$1 = function (anchor, element) {
      return anchor.y - element.height + anchor.height;
    };
    var southY$1 = function (anchor) {
      return anchor.y;
    };
    var southeast$1 = function (anchor, element, bubbles) {
      return nu$6(eastX(anchor), southY$1(anchor), bubbles.southeast(), southeast$3(), 'southeast', boundsRestriction(anchor, {
        left: 0,
        top: 2
      }), labelPrefix$1);
    };
    var southwest$1 = function (anchor, element, bubbles) {
      return nu$6(westX(anchor, element), southY$1(anchor), bubbles.southwest(), southwest$3(), 'southwest', boundsRestriction(anchor, {
        right: 1,
        top: 2
      }), labelPrefix$1);
    };
    var northeast$1 = function (anchor, element, bubbles) {
      return nu$6(eastX(anchor), northY$1(anchor, element), bubbles.northeast(), northeast$3(), 'northeast', boundsRestriction(anchor, {
        left: 0,
        bottom: 3
      }), labelPrefix$1);
    };
    var northwest$1 = function (anchor, element, bubbles) {
      return nu$6(westX(anchor, element), northY$1(anchor, element), bubbles.northwest(), northwest$3(), 'northwest', boundsRestriction(anchor, {
        right: 1,
        bottom: 3
      }), labelPrefix$1);
    };
    var all = function () {
      return [
        southeast$1,
        southwest$1,
        northeast$1,
        northwest$1
      ];
    };
    var allRtl = function () {
      return [
        southwest$1,
        southeast$1,
        northwest$1,
        northeast$1
      ];
    };

    var placement = function (component, submenuInfo, origin) {
      var anchorBox = toBox(origin, submenuInfo.item.element);
      var layouts = get$4(component.element, submenuInfo, all(), allRtl(), all(), allRtl(), Optional.none());
      return Optional.some(nu$4({
        anchorBox: anchorBox,
        bubble: fallback(),
        overrides: submenuInfo.overrides,
        layouts: layouts,
        placer: Optional.none()
      }));
    };
    var SubmenuAnchor = [
      required$1('item'),
      schema$y(),
      defaulted('overrides', {}),
      output$1('placement', placement)
    ];

    var AnchorSchema = choose$1('type', {
      selection: SelectionAnchor,
      node: NodeAnchor,
      hotspot: HotspotAnchor,
      submenu: SubmenuAnchor,
      makeshift: MakeshiftAnchor
    });

    var TransitionSchema = [
      requiredArrayOf('classes', string),
      defaultedStringEnum('mode', 'all', [
        'all',
        'layout',
        'placement'
      ])
    ];
    var PositionSchema = [
      defaulted('useFixed', never),
      option('getBounds')
    ];
    var PlacementSchema = [
      requiredOf('anchor', AnchorSchema),
      optionObjOf('transition', TransitionSchema)
    ];

    var getFixedOrigin = function () {
      var html = document.documentElement;
      return fixed$1(0, 0, html.clientWidth, html.clientHeight);
    };
    var getRelativeOrigin = function (component) {
      var position = absolute$3(component.element);
      var bounds = component.element.dom.getBoundingClientRect();
      return relative$1(position.left, position.top, bounds.width, bounds.height);
    };
    var place = function (component, origin, anchoring, getBounds, placee, lastPlace, transition) {
      var anchor = box(anchoring.anchorBox, origin);
      return simple(anchor, placee.element, anchoring.bubble, anchoring.layouts, lastPlace, getBounds, anchoring.overrides, transition);
    };
    var position$1 = function (component, posConfig, posState, placee, placementSpec) {
      positionWithin(component, posConfig, posState, placee, placementSpec, Optional.none());
    };
    var positionWithin = function (component, posConfig, posState, placee, placementSpec, boxElement) {
      var boundsBox = boxElement.map(box$1);
      return positionWithinBounds(component, posConfig, posState, placee, placementSpec, boundsBox);
    };
    var positionWithinBounds = function (component, posConfig, posState, placee, placementSpec, bounds) {
      var placeeDetail = asRawOrDie$1('placement.info', objOf(PlacementSchema), placementSpec);
      var anchorage = placeeDetail.anchor;
      var element = placee.element;
      var placeeState = posState.get(placee.uid);
      preserve$1(function () {
        set$7(element, 'position', 'fixed');
        var oldVisibility = getRaw(element, 'visibility');
        set$7(element, 'visibility', 'hidden');
        var origin = posConfig.useFixed() ? getFixedOrigin() : getRelativeOrigin(component);
        var placer = anchorage.placement;
        var getBounds = bounds.map(constant$1).or(posConfig.getBounds);
        placer(component, anchorage, origin).each(function (anchoring) {
          var doPlace = anchoring.placer.getOr(place);
          var newState = doPlace(component, origin, anchoring, getBounds, placee, placeeState, placeeDetail.transition);
          posState.set(placee.uid, newState);
        });
        oldVisibility.fold(function () {
          remove$6(element, 'visibility');
        }, function (vis) {
          set$7(element, 'visibility', vis);
        });
        if (getRaw(element, 'left').isNone() && getRaw(element, 'top').isNone() && getRaw(element, 'right').isNone() && getRaw(element, 'bottom').isNone() && is$1(getRaw(element, 'position'), 'fixed')) {
          remove$6(element, 'position');
        }
      }, element);
    };
    var getMode = function (component, pConfig, _pState) {
      return pConfig.useFixed() ? 'fixed' : 'absolute';
    };
    var reset$1 = function (component, pConfig, posState, placee) {
      var element = placee.element;
      each$1([
        'position',
        'left',
        'right',
        'top',
        'bottom'
      ], function (prop) {
        return remove$6(element, prop);
      });
      reset$2(element);
      posState.clear(placee.uid);
    };

    var PositionApis = /*#__PURE__*/Object.freeze({
        __proto__: null,
        position: position$1,
        positionWithin: positionWithin,
        positionWithinBounds: positionWithinBounds,
        getMode: getMode,
        reset: reset$1
    });

    var init$g = function () {
      var state = {};
      var set = function (id, data) {
        state[id] = data;
      };
      var get = function (id) {
        return get$e(state, id);
      };
      var clear = function (id) {
        if (isNonNullable(id)) {
          delete state[id];
        } else {
          state = {};
        }
      };
      return nu$8({
        readState: function () {
          return state;
        },
        clear: clear,
        set: set,
        get: get
      });
    };

    var PositioningState = /*#__PURE__*/Object.freeze({
        __proto__: null,
        init: init$g
    });

    var Positioning = create$7({
      fields: PositionSchema,
      name: 'positioning',
      active: ActivePosition,
      apis: PositionApis,
      state: PositioningState
    });

    var fireDetaching = function (component) {
      emit(component, detachedFromDom());
      var children = component.components();
      each$1(children, fireDetaching);
    };
    var fireAttaching = function (component) {
      var children = component.components();
      each$1(children, fireAttaching);
      emit(component, attachedToDom());
    };
    var attach$1 = function (parent, child) {
      append$2(parent.element, child.element);
    };
    var detachChildren$1 = function (component) {
      each$1(component.components(), function (childComp) {
        return remove$5(childComp.element);
      });
      empty(component.element);
      component.syncComponents();
    };
    var replaceChildren = function (component, newChildren) {
      var subs = component.components();
      detachChildren$1(component);
      var deleted = difference(subs, newChildren);
      each$1(deleted, function (comp) {
        fireDetaching(comp);
        component.getSystem().removeFromWorld(comp);
      });
      each$1(newChildren, function (childComp) {
        if (!childComp.getSystem().isConnected()) {
          component.getSystem().addToWorld(childComp);
          attach$1(component, childComp);
          if (inBody(component.element)) {
            fireAttaching(childComp);
          }
        } else {
          attach$1(component, childComp);
        }
        component.syncComponents();
      });
    };

    var attach = function (parent, child) {
      attachWith(parent, child, append$2);
    };
    var attachWith = function (parent, child, insertion) {
      parent.getSystem().addToWorld(child);
      insertion(parent.element, child.element);
      if (inBody(parent.element)) {
        fireAttaching(child);
      }
      parent.syncComponents();
    };
    var doDetach = function (component) {
      fireDetaching(component);
      remove$5(component.element);
      component.getSystem().removeFromWorld(component);
    };
    var detach = function (component) {
      var parent$1 = parent(component.element).bind(function (p) {
        return component.getSystem().getByDom(p).toOptional();
      });
      doDetach(component);
      parent$1.each(function (p) {
        p.syncComponents();
      });
    };
    var detachChildren = function (component) {
      var subs = component.components();
      each$1(subs, doDetach);
      empty(component.element);
      component.syncComponents();
    };
    var attachSystem = function (element, guiSystem) {
      attachSystemWith(element, guiSystem, append$2);
    };
    var attachSystemAfter = function (element, guiSystem) {
      attachSystemWith(element, guiSystem, after$2);
    };
    var attachSystemWith = function (element, guiSystem, inserter) {
      inserter(element, guiSystem.element);
      var children$1 = children(guiSystem.element);
      each$1(children$1, function (child) {
        guiSystem.getByDom(child).each(fireAttaching);
      });
    };
    var detachSystem = function (guiSystem) {
      var children$1 = children(guiSystem.element);
      each$1(children$1, function (child) {
        guiSystem.getByDom(child).each(fireDetaching);
      });
      remove$5(guiSystem.element);
    };

    var rebuild = function (sandbox, sConfig, sState, data) {
      sState.get().each(function (_data) {
        detachChildren(sandbox);
      });
      var point = sConfig.getAttachPoint(sandbox);
      attach(point, sandbox);
      var built = sandbox.getSystem().build(data);
      attach(sandbox, built);
      sState.set(built);
      return built;
    };
    var open$1 = function (sandbox, sConfig, sState, data) {
      var newState = rebuild(sandbox, sConfig, sState, data);
      sConfig.onOpen(sandbox, newState);
      return newState;
    };
    var setContent = function (sandbox, sConfig, sState, data) {
      return sState.get().map(function () {
        return rebuild(sandbox, sConfig, sState, data);
      });
    };
    var openWhileCloaked = function (sandbox, sConfig, sState, data, transaction) {
      cloak(sandbox, sConfig);
      open$1(sandbox, sConfig, sState, data);
      transaction();
      decloak(sandbox, sConfig);
    };
    var close$1 = function (sandbox, sConfig, sState) {
      sState.get().each(function (data) {
        detachChildren(sandbox);
        detach(sandbox);
        sConfig.onClose(sandbox, data);
        sState.clear();
      });
    };
    var isOpen$1 = function (_sandbox, _sConfig, sState) {
      return sState.isOpen();
    };
    var isPartOf = function (sandbox, sConfig, sState, queryElem) {
      return isOpen$1(sandbox, sConfig, sState) && sState.get().exists(function (data) {
        return sConfig.isPartOf(sandbox, data, queryElem);
      });
    };
    var getState$2 = function (_sandbox, _sConfig, sState) {
      return sState.get();
    };
    var store = function (sandbox, cssKey, attr, newValue) {
      getRaw(sandbox.element, cssKey).fold(function () {
        remove$7(sandbox.element, attr);
      }, function (v) {
        set$8(sandbox.element, attr, v);
      });
      set$7(sandbox.element, cssKey, newValue);
    };
    var restore = function (sandbox, cssKey, attr) {
      getOpt(sandbox.element, attr).fold(function () {
        return remove$6(sandbox.element, cssKey);
      }, function (oldValue) {
        return set$7(sandbox.element, cssKey, oldValue);
      });
    };
    var cloak = function (sandbox, sConfig, _sState) {
      var sink = sConfig.getAttachPoint(sandbox);
      set$7(sandbox.element, 'position', Positioning.getMode(sink));
      store(sandbox, 'visibility', sConfig.cloakVisibilityAttr, 'hidden');
    };
    var hasPosition = function (element) {
      return exists([
        'top',
        'left',
        'right',
        'bottom'
      ], function (pos) {
        return getRaw(element, pos).isSome();
      });
    };
    var decloak = function (sandbox, sConfig, _sState) {
      if (!hasPosition(sandbox.element)) {
        remove$6(sandbox.element, 'position');
      }
      restore(sandbox, 'visibility', sConfig.cloakVisibilityAttr);
    };

    var SandboxApis = /*#__PURE__*/Object.freeze({
        __proto__: null,
        cloak: cloak,
        decloak: decloak,
        open: open$1,
        openWhileCloaked: openWhileCloaked,
        close: close$1,
        isOpen: isOpen$1,
        isPartOf: isPartOf,
        getState: getState$2,
        setContent: setContent
    });

    var events$g = function (sandboxConfig, sandboxState) {
      return derive$2([run$1(sandboxClose(), function (sandbox, _simulatedEvent) {
          close$1(sandbox, sandboxConfig, sandboxState);
        })]);
    };

    var ActiveSandbox = /*#__PURE__*/Object.freeze({
        __proto__: null,
        events: events$g
    });

    var SandboxSchema = [
      onHandler('onOpen'),
      onHandler('onClose'),
      required$1('isPartOf'),
      required$1('getAttachPoint'),
      defaulted('cloakVisibilityAttr', 'data-precloak-visibility')
    ];

    var init$f = function () {
      var contents = value$1();
      var readState = constant$1('not-implemented');
      return nu$8({
        readState: readState,
        isOpen: contents.isSet,
        clear: contents.clear,
        set: contents.set,
        get: contents.get
      });
    };

    var SandboxState = /*#__PURE__*/Object.freeze({
        __proto__: null,
        init: init$f
    });

    var Sandboxing = create$7({
      fields: SandboxSchema,
      name: 'sandboxing',
      active: ActiveSandbox,
      apis: SandboxApis,
      state: SandboxState
    });

    var dismissPopups = constant$1('dismiss.popups');
    var repositionPopups = constant$1('reposition.popups');
    var mouseReleased = constant$1('mouse.released');

    var schema$x = objOfOnly([
      defaulted('isExtraPart', never),
      optionObjOf('fireEventInstead', [defaulted('event', dismissRequested())])
    ]);
    var receivingChannel$1 = function (rawSpec) {
      var _a;
      var detail = asRawOrDie$1('Dismissal', schema$x, rawSpec);
      return _a = {}, _a[dismissPopups()] = {
        schema: objOfOnly([required$1('target')]),
        onReceive: function (sandbox, data) {
          if (Sandboxing.isOpen(sandbox)) {
            var isPart = Sandboxing.isPartOf(sandbox, data.target) || detail.isExtraPart(sandbox, data.target);
            if (!isPart) {
              detail.fireEventInstead.fold(function () {
                return Sandboxing.close(sandbox);
              }, function (fe) {
                return emit(sandbox, fe.event);
              });
            }
          }
        }
      }, _a;
    };

    var schema$w = objOfOnly([
      optionObjOf('fireEventInstead', [defaulted('event', repositionRequested())]),
      requiredFunction('doReposition')
    ]);
    var receivingChannel = function (rawSpec) {
      var _a;
      var detail = asRawOrDie$1('Reposition', schema$w, rawSpec);
      return _a = {}, _a[repositionPopups()] = {
        onReceive: function (sandbox) {
          if (Sandboxing.isOpen(sandbox)) {
            detail.fireEventInstead.fold(function () {
              return detail.doReposition(sandbox);
            }, function (fe) {
              return emit(sandbox, fe.event);
            });
          }
        }
      }, _a;
    };

    var onLoad$5 = function (component, repConfig, repState) {
      repConfig.store.manager.onLoad(component, repConfig, repState);
    };
    var onUnload$2 = function (component, repConfig, repState) {
      repConfig.store.manager.onUnload(component, repConfig, repState);
    };
    var setValue$3 = function (component, repConfig, repState, data) {
      repConfig.store.manager.setValue(component, repConfig, repState, data);
    };
    var getValue$3 = function (component, repConfig, repState) {
      return repConfig.store.manager.getValue(component, repConfig, repState);
    };
    var getState$1 = function (component, repConfig, repState) {
      return repState;
    };

    var RepresentApis = /*#__PURE__*/Object.freeze({
        __proto__: null,
        onLoad: onLoad$5,
        onUnload: onUnload$2,
        setValue: setValue$3,
        getValue: getValue$3,
        getState: getState$1
    });

    var events$f = function (repConfig, repState) {
      var es = repConfig.resetOnDom ? [
        runOnAttached(function (comp, _se) {
          onLoad$5(comp, repConfig, repState);
        }),
        runOnDetached(function (comp, _se) {
          onUnload$2(comp, repConfig, repState);
        })
      ] : [loadEvent(repConfig, repState, onLoad$5)];
      return derive$2(es);
    };

    var ActiveRepresenting = /*#__PURE__*/Object.freeze({
        __proto__: null,
        events: events$f
    });

    var memory$1 = function () {
      var data = Cell(null);
      var readState = function () {
        return {
          mode: 'memory',
          value: data.get()
        };
      };
      var isNotSet = function () {
        return data.get() === null;
      };
      var clear = function () {
        data.set(null);
      };
      return nu$8({
        set: data.set,
        get: data.get,
        isNotSet: isNotSet,
        clear: clear,
        readState: readState
      });
    };
    var manual = function () {
      var readState = noop;
      return nu$8({ readState: readState });
    };
    var dataset = function () {
      var dataByValue = Cell({});
      var dataByText = Cell({});
      var readState = function () {
        return {
          mode: 'dataset',
          dataByValue: dataByValue.get(),
          dataByText: dataByText.get()
        };
      };
      var clear = function () {
        dataByValue.set({});
        dataByText.set({});
      };
      var lookup = function (itemString) {
        return get$e(dataByValue.get(), itemString).orThunk(function () {
          return get$e(dataByText.get(), itemString);
        });
      };
      var update = function (items) {
        var currentDataByValue = dataByValue.get();
        var currentDataByText = dataByText.get();
        var newDataByValue = {};
        var newDataByText = {};
        each$1(items, function (item) {
          newDataByValue[item.value] = item;
          get$e(item, 'meta').each(function (meta) {
            get$e(meta, 'text').each(function (text) {
              newDataByText[text] = item;
            });
          });
        });
        dataByValue.set(__assign(__assign({}, currentDataByValue), newDataByValue));
        dataByText.set(__assign(__assign({}, currentDataByText), newDataByText));
      };
      return nu$8({
        readState: readState,
        lookup: lookup,
        update: update,
        clear: clear
      });
    };
    var init$e = function (spec) {
      return spec.store.manager.state(spec);
    };

    var RepresentState = /*#__PURE__*/Object.freeze({
        __proto__: null,
        memory: memory$1,
        dataset: dataset,
        manual: manual,
        init: init$e
    });

    var setValue$2 = function (component, repConfig, repState, data) {
      var store = repConfig.store;
      repState.update([data]);
      store.setValue(component, data);
      repConfig.onSetValue(component, data);
    };
    var getValue$2 = function (component, repConfig, repState) {
      var store = repConfig.store;
      var key = store.getDataKey(component);
      return repState.lookup(key).getOrThunk(function () {
        return store.getFallbackEntry(key);
      });
    };
    var onLoad$4 = function (component, repConfig, repState) {
      var store = repConfig.store;
      store.initialValue.each(function (data) {
        setValue$2(component, repConfig, repState, data);
      });
    };
    var onUnload$1 = function (component, repConfig, repState) {
      repState.clear();
    };
    var DatasetStore = [
      option('initialValue'),
      required$1('getFallbackEntry'),
      required$1('getDataKey'),
      required$1('setValue'),
      output$1('manager', {
        setValue: setValue$2,
        getValue: getValue$2,
        onLoad: onLoad$4,
        onUnload: onUnload$1,
        state: dataset
      })
    ];

    var getValue$1 = function (component, repConfig, _repState) {
      return repConfig.store.getValue(component);
    };
    var setValue$1 = function (component, repConfig, _repState, data) {
      repConfig.store.setValue(component, data);
      repConfig.onSetValue(component, data);
    };
    var onLoad$3 = function (component, repConfig, _repState) {
      repConfig.store.initialValue.each(function (data) {
        repConfig.store.setValue(component, data);
      });
    };
    var ManualStore = [
      required$1('getValue'),
      defaulted('setValue', noop),
      option('initialValue'),
      output$1('manager', {
        setValue: setValue$1,
        getValue: getValue$1,
        onLoad: onLoad$3,
        onUnload: noop,
        state: NoState.init
      })
    ];

    var setValue = function (component, repConfig, repState, data) {
      repState.set(data);
      repConfig.onSetValue(component, data);
    };
    var getValue = function (component, repConfig, repState) {
      return repState.get();
    };
    var onLoad$2 = function (component, repConfig, repState) {
      repConfig.store.initialValue.each(function (initVal) {
        if (repState.isNotSet()) {
          repState.set(initVal);
        }
      });
    };
    var onUnload = function (component, repConfig, repState) {
      repState.clear();
    };
    var MemoryStore = [
      option('initialValue'),
      output$1('manager', {
        setValue: setValue,
        getValue: getValue,
        onLoad: onLoad$2,
        onUnload: onUnload,
        state: memory$1
      })
    ];

    var RepresentSchema = [
      defaultedOf('store', { mode: 'memory' }, choose$1('mode', {
        memory: MemoryStore,
        manual: ManualStore,
        dataset: DatasetStore
      })),
      onHandler('onSetValue'),
      defaulted('resetOnDom', false)
    ];

    var Representing = create$7({
      fields: RepresentSchema,
      name: 'representing',
      active: ActiveRepresenting,
      apis: RepresentApis,
      extra: {
        setValueFrom: function (component, source) {
          var value = Representing.getValue(source);
          Representing.setValue(component, value);
        }
      },
      state: RepresentState
    });

    var field = function (name, forbidden) {
      return defaultedObjOf(name, {}, map$2(forbidden, function (f) {
        return forbid(f.name(), 'Cannot configure ' + f.name() + ' for ' + name);
      }).concat([customField('dump', identity$1)]));
    };
    var get$2 = function (data) {
      return data.dump;
    };
    var augment = function (data, original) {
      return __assign(__assign({}, derive$1(original)), data.dump);
    };
    var SketchBehaviours = {
      field: field,
      augment: augment,
      get: get$2
    };

    var _placeholder = 'placeholder';
    var adt$3 = Adt.generate([
      {
        single: [
          'required',
          'valueThunk'
        ]
      },
      {
        multiple: [
          'required',
          'valueThunks'
        ]
      }
    ]);
    var isSubstituted = function (spec) {
      return has$2(spec, 'uiType');
    };
    var subPlaceholder = function (owner, detail, compSpec, placeholders) {
      if (owner.exists(function (o) {
          return o !== compSpec.owner;
        })) {
        return adt$3.single(true, constant$1(compSpec));
      }
      return get$e(placeholders, compSpec.name).fold(function () {
        throw new Error('Unknown placeholder component: ' + compSpec.name + '\nKnown: [' + keys(placeholders) + ']\nNamespace: ' + owner.getOr('none') + '\nSpec: ' + JSON.stringify(compSpec, null, 2));
      }, function (newSpec) {
        return newSpec.replace();
      });
    };
    var scan = function (owner, detail, compSpec, placeholders) {
      if (isSubstituted(compSpec) && compSpec.uiType === _placeholder) {
        return subPlaceholder(owner, detail, compSpec, placeholders);
      } else {
        return adt$3.single(false, constant$1(compSpec));
      }
    };
    var substitute = function (owner, detail, compSpec, placeholders) {
      var base = scan(owner, detail, compSpec, placeholders);
      return base.fold(function (req, valueThunk) {
        var value = isSubstituted(compSpec) ? valueThunk(detail, compSpec.config, compSpec.validated) : valueThunk(detail);
        var childSpecs = get$e(value, 'components').getOr([]);
        var substituted = bind$3(childSpecs, function (c) {
          return substitute(owner, detail, c, placeholders);
        });
        return [__assign(__assign({}, value), { components: substituted })];
      }, function (req, valuesThunk) {
        if (isSubstituted(compSpec)) {
          var values = valuesThunk(detail, compSpec.config, compSpec.validated);
          var preprocessor = compSpec.validated.preprocess.getOr(identity$1);
          return preprocessor(values);
        } else {
          return valuesThunk(detail);
        }
      });
    };
    var substituteAll = function (owner, detail, components, placeholders) {
      return bind$3(components, function (c) {
        return substitute(owner, detail, c, placeholders);
      });
    };
    var oneReplace = function (label, replacements) {
      var called = false;
      var used = function () {
        return called;
      };
      var replace = function () {
        if (called) {
          throw new Error('Trying to use the same placeholder more than once: ' + label);
        }
        called = true;
        return replacements;
      };
      var required = function () {
        return replacements.fold(function (req, _) {
          return req;
        }, function (req, _) {
          return req;
        });
      };
      return {
        name: constant$1(label),
        required: required,
        used: used,
        replace: replace
      };
    };
    var substitutePlaces = function (owner, detail, components, placeholders) {
      var ps = map$1(placeholders, function (ph, name) {
        return oneReplace(name, ph);
      });
      var outcome = substituteAll(owner, detail, components, ps);
      each(ps, function (p) {
        if (p.used() === false && p.required()) {
          throw new Error('Placeholder: ' + p.name() + ' was not found in components list\nNamespace: ' + owner.getOr('none') + '\nComponents: ' + JSON.stringify(detail.components, null, 2));
        }
      });
      return outcome;
    };
    var single$2 = adt$3.single;
    var multiple = adt$3.multiple;
    var placeholder = constant$1(_placeholder);

    var adt$2 = Adt.generate([
      { required: ['data'] },
      { external: ['data'] },
      { optional: ['data'] },
      { group: ['data'] }
    ]);
    var fFactory = defaulted('factory', { sketch: identity$1 });
    var fSchema = defaulted('schema', []);
    var fName = required$1('name');
    var fPname = field$1('pname', 'pname', defaultedThunk(function (typeSpec) {
      return '<alloy.' + generate$6(typeSpec.name) + '>';
    }), anyValue());
    var fGroupSchema = customField('schema', function () {
      return [option('preprocess')];
    });
    var fDefaults = defaulted('defaults', constant$1({}));
    var fOverrides = defaulted('overrides', constant$1({}));
    var requiredSpec = objOf([
      fFactory,
      fSchema,
      fName,
      fPname,
      fDefaults,
      fOverrides
    ]);
    var externalSpec = objOf([
      fFactory,
      fSchema,
      fName,
      fDefaults,
      fOverrides
    ]);
    var optionalSpec = objOf([
      fFactory,
      fSchema,
      fName,
      fPname,
      fDefaults,
      fOverrides
    ]);
    var groupSpec = objOf([
      fFactory,
      fGroupSchema,
      fName,
      required$1('unit'),
      fPname,
      fDefaults,
      fOverrides
    ]);
    var asNamedPart = function (part) {
      return part.fold(Optional.some, Optional.none, Optional.some, Optional.some);
    };
    var name$1 = function (part) {
      var get = function (data) {
        return data.name;
      };
      return part.fold(get, get, get, get);
    };
    var asCommon = function (part) {
      return part.fold(identity$1, identity$1, identity$1, identity$1);
    };
    var convert = function (adtConstructor, partSchema) {
      return function (spec) {
        var data = asRawOrDie$1('Converting part type', partSchema, spec);
        return adtConstructor(data);
      };
    };
    var required = convert(adt$2.required, requiredSpec);
    var external$1 = convert(adt$2.external, externalSpec);
    var optional = convert(adt$2.optional, optionalSpec);
    var group = convert(adt$2.group, groupSpec);
    var original = constant$1('entirety');

    var PartType = /*#__PURE__*/Object.freeze({
        __proto__: null,
        required: required,
        external: external$1,
        optional: optional,
        group: group,
        asNamedPart: asNamedPart,
        name: name$1,
        asCommon: asCommon,
        original: original
    });

    var combine = function (detail, data, partSpec, partValidated) {
      return deepMerge(data.defaults(detail, partSpec, partValidated), partSpec, { uid: detail.partUids[data.name] }, data.overrides(detail, partSpec, partValidated));
    };
    var subs = function (owner, detail, parts) {
      var internals = {};
      var externals = {};
      each$1(parts, function (part) {
        part.fold(function (data) {
          internals[data.pname] = single$2(true, function (detail, partSpec, partValidated) {
            return data.factory.sketch(combine(detail, data, partSpec, partValidated));
          });
        }, function (data) {
          var partSpec = detail.parts[data.name];
          externals[data.name] = constant$1(data.factory.sketch(combine(detail, data, partSpec[original()]), partSpec));
        }, function (data) {
          internals[data.pname] = single$2(false, function (detail, partSpec, partValidated) {
            return data.factory.sketch(combine(detail, data, partSpec, partValidated));
          });
        }, function (data) {
          internals[data.pname] = multiple(true, function (detail, _partSpec, _partValidated) {
            var units = detail[data.name];
            return map$2(units, function (u) {
              return data.factory.sketch(deepMerge(data.defaults(detail, u, _partValidated), u, data.overrides(detail, u)));
            });
          });
        });
      });
      return {
        internals: constant$1(internals),
        externals: constant$1(externals)
      };
    };

    var generate$3 = function (owner, parts) {
      var r = {};
      each$1(parts, function (part) {
        asNamedPart(part).each(function (np) {
          var g = doGenerateOne(owner, np.pname);
          r[np.name] = function (config) {
            var validated = asRawOrDie$1('Part: ' + np.name + ' in ' + owner, objOf(np.schema), config);
            return __assign(__assign({}, g), {
              config: config,
              validated: validated
            });
          };
        });
      });
      return r;
    };
    var doGenerateOne = function (owner, pname) {
      return {
        uiType: placeholder(),
        owner: owner,
        name: pname
      };
    };
    var generateOne$1 = function (owner, pname, config) {
      return {
        uiType: placeholder(),
        owner: owner,
        name: pname,
        config: config,
        validated: {}
      };
    };
    var schemas = function (parts) {
      return bind$3(parts, function (part) {
        return part.fold(Optional.none, Optional.some, Optional.none, Optional.none).map(function (data) {
          return requiredObjOf(data.name, data.schema.concat([snapshot(original())]));
        }).toArray();
      });
    };
    var names = function (parts) {
      return map$2(parts, name$1);
    };
    var substitutes = function (owner, detail, parts) {
      return subs(owner, detail, parts);
    };
    var components$1 = function (owner, detail, internals) {
      return substitutePlaces(Optional.some(owner), detail, detail.components, internals);
    };
    var getPart = function (component, detail, partKey) {
      var uid = detail.partUids[partKey];
      return component.getSystem().getByUid(uid).toOptional();
    };
    var getPartOrDie = function (component, detail, partKey) {
      return getPart(component, detail, partKey).getOrDie('Could not find part: ' + partKey);
    };
    var getParts = function (component, detail, partKeys) {
      var r = {};
      var uids = detail.partUids;
      var system = component.getSystem();
      each$1(partKeys, function (pk) {
        r[pk] = constant$1(system.getByUid(uids[pk]));
      });
      return r;
    };
    var getAllParts = function (component, detail) {
      var system = component.getSystem();
      return map$1(detail.partUids, function (pUid, _k) {
        return constant$1(system.getByUid(pUid));
      });
    };
    var getAllPartNames = function (detail) {
      return keys(detail.partUids);
    };
    var getPartsOrDie = function (component, detail, partKeys) {
      var r = {};
      var uids = detail.partUids;
      var system = component.getSystem();
      each$1(partKeys, function (pk) {
        r[pk] = constant$1(system.getByUid(uids[pk]).getOrDie());
      });
      return r;
    };
    var defaultUids = function (baseUid, partTypes) {
      var partNames = names(partTypes);
      return wrapAll(map$2(partNames, function (pn) {
        return {
          key: pn,
          value: baseUid + '-' + pn
        };
      }));
    };
    var defaultUidsSchema = function (partTypes) {
      return field$1('partUids', 'partUids', mergeWithThunk(function (spec) {
        return defaultUids(spec.uid, partTypes);
      }), anyValue());
    };

    var AlloyParts = /*#__PURE__*/Object.freeze({
        __proto__: null,
        generate: generate$3,
        generateOne: generateOne$1,
        schemas: schemas,
        names: names,
        substitutes: substitutes,
        components: components$1,
        defaultUids: defaultUids,
        defaultUidsSchema: defaultUidsSchema,
        getAllParts: getAllParts,
        getAllPartNames: getAllPartNames,
        getPart: getPart,
        getPartOrDie: getPartOrDie,
        getParts: getParts,
        getPartsOrDie: getPartsOrDie
    });

    var base = function (partSchemas, partUidsSchemas) {
      var ps = partSchemas.length > 0 ? [requiredObjOf('parts', partSchemas)] : [];
      return ps.concat([
        required$1('uid'),
        defaulted('dom', {}),
        defaulted('components', []),
        snapshot('originalSpec'),
        defaulted('debug.sketcher', {})
      ]).concat(partUidsSchemas);
    };
    var asRawOrDie = function (label, schema, spec, partSchemas, partUidsSchemas) {
      var baseS = base(partSchemas, partUidsSchemas);
      return asRawOrDie$1(label + ' [SpecSchema]', objOfOnly(baseS.concat(schema)), spec);
    };

    var single$1 = function (owner, schema, factory, spec) {
      var specWithUid = supplyUid(spec);
      var detail = asRawOrDie(owner, schema, specWithUid, [], []);
      return factory(detail, specWithUid);
    };
    var composite$1 = function (owner, schema, partTypes, factory, spec) {
      var specWithUid = supplyUid(spec);
      var partSchemas = schemas(partTypes);
      var partUidsSchema = defaultUidsSchema(partTypes);
      var detail = asRawOrDie(owner, schema, specWithUid, partSchemas, [partUidsSchema]);
      var subs = substitutes(owner, detail, partTypes);
      var components = components$1(owner, detail, subs.internals());
      return factory(detail, components, specWithUid, subs.externals());
    };
    var hasUid = function (spec) {
      return has$2(spec, 'uid');
    };
    var supplyUid = function (spec) {
      return hasUid(spec) ? spec : __assign(__assign({}, spec), { uid: generate$5('uid') });
    };

    var isSketchSpec = function (spec) {
      return spec.uid !== undefined;
    };
    var singleSchema = objOfOnly([
      required$1('name'),
      required$1('factory'),
      required$1('configFields'),
      defaulted('apis', {}),
      defaulted('extraApis', {})
    ]);
    var compositeSchema = objOfOnly([
      required$1('name'),
      required$1('factory'),
      required$1('configFields'),
      required$1('partFields'),
      defaulted('apis', {}),
      defaulted('extraApis', {})
    ]);
    var single = function (rawConfig) {
      var config = asRawOrDie$1('Sketcher for ' + rawConfig.name, singleSchema, rawConfig);
      var sketch = function (spec) {
        return single$1(config.name, config.configFields, config.factory, spec);
      };
      var apis = map$1(config.apis, makeApi);
      var extraApis = map$1(config.extraApis, function (f, k) {
        return markAsExtraApi(f, k);
      });
      return __assign(__assign({
        name: config.name,
        configFields: config.configFields,
        sketch: sketch
      }, apis), extraApis);
    };
    var composite = function (rawConfig) {
      var config = asRawOrDie$1('Sketcher for ' + rawConfig.name, compositeSchema, rawConfig);
      var sketch = function (spec) {
        return composite$1(config.name, config.configFields, config.partFields, config.factory, spec);
      };
      var parts = generate$3(config.name, config.partFields);
      var apis = map$1(config.apis, makeApi);
      var extraApis = map$1(config.extraApis, function (f, k) {
        return markAsExtraApi(f, k);
      });
      return __assign(__assign({
        name: config.name,
        partFields: config.partFields,
        configFields: config.configFields,
        sketch: sketch,
        parts: parts
      }, apis), extraApis);
    };

    var inside = function (target) {
      return name$2(target) === 'input' && get$d(target, 'type') !== 'radio' || name$2(target) === 'textarea';
    };

    var getCurrent = function (component, composeConfig, _composeState) {
      return composeConfig.find(component);
    };

    var ComposeApis = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getCurrent: getCurrent
    });

    var ComposeSchema = [required$1('find')];

    var Composing = create$7({
      fields: ComposeSchema,
      name: 'composing',
      apis: ComposeApis
    });

    var nativeDisabled = [
      'input',
      'button',
      'textarea',
      'select'
    ];
    var onLoad$1 = function (component, disableConfig, disableState) {
      var f = disableConfig.disabled() ? disable$1 : enable$1;
      f(component, disableConfig);
    };
    var hasNative = function (component, config) {
      return config.useNative === true && contains$2(nativeDisabled, name$2(component.element));
    };
    var nativeIsDisabled = function (component) {
      return has$1(component.element, 'disabled');
    };
    var nativeDisable = function (component) {
      set$8(component.element, 'disabled', 'disabled');
    };
    var nativeEnable = function (component) {
      remove$7(component.element, 'disabled');
    };
    var ariaIsDisabled = function (component) {
      return get$d(component.element, 'aria-disabled') === 'true';
    };
    var ariaDisable = function (component) {
      set$8(component.element, 'aria-disabled', 'true');
    };
    var ariaEnable = function (component) {
      set$8(component.element, 'aria-disabled', 'false');
    };
    var disable$1 = function (component, disableConfig, _disableState) {
      disableConfig.disableClass.each(function (disableClass) {
        add$2(component.element, disableClass);
      });
      var f = hasNative(component, disableConfig) ? nativeDisable : ariaDisable;
      f(component);
      disableConfig.onDisabled(component);
    };
    var enable$1 = function (component, disableConfig, _disableState) {
      disableConfig.disableClass.each(function (disableClass) {
        remove$2(component.element, disableClass);
      });
      var f = hasNative(component, disableConfig) ? nativeEnable : ariaEnable;
      f(component);
      disableConfig.onEnabled(component);
    };
    var isDisabled = function (component, disableConfig) {
      return hasNative(component, disableConfig) ? nativeIsDisabled(component) : ariaIsDisabled(component);
    };
    var set$3 = function (component, disableConfig, disableState, disabled) {
      var f = disabled ? disable$1 : enable$1;
      f(component, disableConfig);
    };

    var DisableApis = /*#__PURE__*/Object.freeze({
        __proto__: null,
        enable: enable$1,
        disable: disable$1,
        isDisabled: isDisabled,
        onLoad: onLoad$1,
        set: set$3
    });

    var exhibit$5 = function (base, disableConfig) {
      return nu$7({ classes: disableConfig.disabled() ? disableConfig.disableClass.toArray() : [] });
    };
    var events$e = function (disableConfig, disableState) {
      return derive$2([
        abort(execute$5(), function (component, _simulatedEvent) {
          return isDisabled(component, disableConfig);
        }),
        loadEvent(disableConfig, disableState, onLoad$1)
      ]);
    };

    var ActiveDisable = /*#__PURE__*/Object.freeze({
        __proto__: null,
        exhibit: exhibit$5,
        events: events$e
    });

    var DisableSchema = [
      defaultedFunction('disabled', never),
      defaulted('useNative', true),
      option('disableClass'),
      onHandler('onDisabled'),
      onHandler('onEnabled')
    ];

    var Disabling = create$7({
      fields: DisableSchema,
      name: 'disabling',
      active: ActiveDisable,
      apis: DisableApis
    });

    var dehighlightAllExcept = function (component, hConfig, hState, skip) {
      var highlighted = descendants(component.element, '.' + hConfig.highlightClass);
      each$1(highlighted, function (h) {
        if (!exists(skip, function (skipComp) {
            return skipComp.element === h;
          })) {
          remove$2(h, hConfig.highlightClass);
          component.getSystem().getByDom(h).each(function (target) {
            hConfig.onDehighlight(component, target);
            emit(target, dehighlight$1());
          });
        }
      });
    };
    var dehighlightAll = function (component, hConfig, hState) {
      return dehighlightAllExcept(component, hConfig, hState, []);
    };
    var dehighlight = function (component, hConfig, hState, target) {
      if (isHighlighted(component, hConfig, hState, target)) {
        remove$2(target.element, hConfig.highlightClass);
        hConfig.onDehighlight(component, target);
        emit(target, dehighlight$1());
      }
    };
    var highlight = function (component, hConfig, hState, target) {
      dehighlightAllExcept(component, hConfig, hState, [target]);
      if (!isHighlighted(component, hConfig, hState, target)) {
        add$2(target.element, hConfig.highlightClass);
        hConfig.onHighlight(component, target);
        emit(target, highlight$1());
      }
    };
    var highlightFirst = function (component, hConfig, hState) {
      getFirst(component, hConfig).each(function (firstComp) {
        highlight(component, hConfig, hState, firstComp);
      });
    };
    var highlightLast = function (component, hConfig, hState) {
      getLast(component, hConfig).each(function (lastComp) {
        highlight(component, hConfig, hState, lastComp);
      });
    };
    var highlightAt = function (component, hConfig, hState, index) {
      getByIndex(component, hConfig, hState, index).fold(function (err) {
        throw err;
      }, function (firstComp) {
        highlight(component, hConfig, hState, firstComp);
      });
    };
    var highlightBy = function (component, hConfig, hState, predicate) {
      var candidates = getCandidates(component, hConfig);
      var targetComp = find$5(candidates, predicate);
      targetComp.each(function (c) {
        highlight(component, hConfig, hState, c);
      });
    };
    var isHighlighted = function (component, hConfig, hState, queryTarget) {
      return has(queryTarget.element, hConfig.highlightClass);
    };
    var getHighlighted = function (component, hConfig, _hState) {
      return descendant(component.element, '.' + hConfig.highlightClass).bind(function (e) {
        return component.getSystem().getByDom(e).toOptional();
      });
    };
    var getByIndex = function (component, hConfig, hState, index) {
      var items = descendants(component.element, '.' + hConfig.itemClass);
      return Optional.from(items[index]).fold(function () {
        return Result.error(new Error('No element found with index ' + index));
      }, component.getSystem().getByDom);
    };
    var getFirst = function (component, hConfig, _hState) {
      return descendant(component.element, '.' + hConfig.itemClass).bind(function (e) {
        return component.getSystem().getByDom(e).toOptional();
      });
    };
    var getLast = function (component, hConfig, _hState) {
      var items = descendants(component.element, '.' + hConfig.itemClass);
      var last = items.length > 0 ? Optional.some(items[items.length - 1]) : Optional.none();
      return last.bind(function (c) {
        return component.getSystem().getByDom(c).toOptional();
      });
    };
    var getDelta$2 = function (component, hConfig, hState, delta) {
      var items = descendants(component.element, '.' + hConfig.itemClass);
      var current = findIndex$1(items, function (item) {
        return has(item, hConfig.highlightClass);
      });
      return current.bind(function (selected) {
        var dest = cycleBy(selected, delta, 0, items.length - 1);
        return component.getSystem().getByDom(items[dest]).toOptional();
      });
    };
    var getPrevious = function (component, hConfig, hState) {
      return getDelta$2(component, hConfig, hState, -1);
    };
    var getNext = function (component, hConfig, hState) {
      return getDelta$2(component, hConfig, hState, +1);
    };
    var getCandidates = function (component, hConfig, _hState) {
      var items = descendants(component.element, '.' + hConfig.itemClass);
      return cat(map$2(items, function (i) {
        return component.getSystem().getByDom(i).toOptional();
      }));
    };

    var HighlightApis = /*#__PURE__*/Object.freeze({
        __proto__: null,
        dehighlightAll: dehighlightAll,
        dehighlight: dehighlight,
        highlight: highlight,
        highlightFirst: highlightFirst,
        highlightLast: highlightLast,
        highlightAt: highlightAt,
        highlightBy: highlightBy,
        isHighlighted: isHighlighted,
        getHighlighted: getHighlighted,
        getFirst: getFirst,
        getLast: getLast,
        getPrevious: getPrevious,
        getNext: getNext,
        getCandidates: getCandidates
    });

    var HighlightSchema = [
      required$1('highlightClass'),
      required$1('itemClass'),
      onHandler('onHighlight'),
      onHandler('onDehighlight')
    ];

    var Highlighting = create$7({
      fields: HighlightSchema,
      name: 'highlighting',
      apis: HighlightApis
    });

    var BACKSPACE = [8];
    var TAB = [9];
    var ENTER = [13];
    var ESCAPE = [27];
    var SPACE = [32];
    var LEFT = [37];
    var UP = [38];
    var RIGHT = [39];
    var DOWN = [40];

    var cyclePrev = function (values, index, predicate) {
      var before = reverse(values.slice(0, index));
      var after = reverse(values.slice(index + 1));
      return find$5(before.concat(after), predicate);
    };
    var tryPrev = function (values, index, predicate) {
      var before = reverse(values.slice(0, index));
      return find$5(before, predicate);
    };
    var cycleNext = function (values, index, predicate) {
      var before = values.slice(0, index);
      var after = values.slice(index + 1);
      return find$5(after.concat(before), predicate);
    };
    var tryNext = function (values, index, predicate) {
      var after = values.slice(index + 1);
      return find$5(after, predicate);
    };

    var inSet = function (keys) {
      return function (event) {
        var raw = event.raw;
        return contains$2(keys, raw.which);
      };
    };
    var and = function (preds) {
      return function (event) {
        return forall(preds, function (pred) {
          return pred(event);
        });
      };
    };
    var isShift = function (event) {
      var raw = event.raw;
      return raw.shiftKey === true;
    };
    var isControl = function (event) {
      var raw = event.raw;
      return raw.ctrlKey === true;
    };
    var isNotShift = not(isShift);

    var rule = function (matches, action) {
      return {
        matches: matches,
        classification: action
      };
    };
    var choose = function (transitions, event) {
      var transition = find$5(transitions, function (t) {
        return t.matches(event);
      });
      return transition.map(function (t) {
        return t.classification;
      });
    };

    var reportFocusShifting = function (component, prevFocus, newFocus) {
      var noChange = prevFocus.exists(function (p) {
        return newFocus.exists(function (n) {
          return eq(n, p);
        });
      });
      if (!noChange) {
        emitWith(component, focusShifted(), {
          prevFocus: prevFocus,
          newFocus: newFocus
        });
      }
    };
    var dom$2 = function () {
      var get = function (component) {
        return search(component.element);
      };
      var set = function (component, focusee) {
        var prevFocus = get(component);
        component.getSystem().triggerFocus(focusee, component.element);
        var newFocus = get(component);
        reportFocusShifting(component, prevFocus, newFocus);
      };
      return {
        get: get,
        set: set
      };
    };
    var highlights = function () {
      var get = function (component) {
        return Highlighting.getHighlighted(component).map(function (item) {
          return item.element;
        });
      };
      var set = function (component, element) {
        var prevFocus = get(component);
        component.getSystem().getByDom(element).fold(noop, function (item) {
          Highlighting.highlight(component, item);
        });
        var newFocus = get(component);
        reportFocusShifting(component, prevFocus, newFocus);
      };
      return {
        get: get,
        set: set
      };
    };

    var FocusInsideModes;
    (function (FocusInsideModes) {
      FocusInsideModes['OnFocusMode'] = 'onFocus';
      FocusInsideModes['OnEnterOrSpaceMode'] = 'onEnterOrSpace';
      FocusInsideModes['OnApiMode'] = 'onApi';
    }(FocusInsideModes || (FocusInsideModes = {})));

    var typical = function (infoSchema, stateInit, getKeydownRules, getKeyupRules, optFocusIn) {
      var schema = function () {
        return infoSchema.concat([
          defaulted('focusManager', dom$2()),
          defaultedOf('focusInside', 'onFocus', valueOf(function (val) {
            return contains$2([
              'onFocus',
              'onEnterOrSpace',
              'onApi'
            ], val) ? Result.value(val) : Result.error('Invalid value for focusInside');
          })),
          output$1('handler', me),
          output$1('state', stateInit),
          output$1('sendFocusIn', optFocusIn)
        ]);
      };
      var processKey = function (component, simulatedEvent, getRules, keyingConfig, keyingState) {
        var rules = getRules(component, simulatedEvent, keyingConfig, keyingState);
        return choose(rules, simulatedEvent.event).bind(function (rule) {
          return rule(component, simulatedEvent, keyingConfig, keyingState);
        });
      };
      var toEvents = function (keyingConfig, keyingState) {
        var onFocusHandler = keyingConfig.focusInside !== FocusInsideModes.OnFocusMode ? Optional.none() : optFocusIn(keyingConfig).map(function (focusIn) {
          return run$1(focus$4(), function (component, simulatedEvent) {
            focusIn(component, keyingConfig, keyingState);
            simulatedEvent.stop();
          });
        });
        var tryGoInsideComponent = function (component, simulatedEvent) {
          var isEnterOrSpace = inSet(SPACE.concat(ENTER))(simulatedEvent.event);
          if (keyingConfig.focusInside === FocusInsideModes.OnEnterOrSpaceMode && isEnterOrSpace && isSource(component, simulatedEvent)) {
            optFocusIn(keyingConfig).each(function (focusIn) {
              focusIn(component, keyingConfig, keyingState);
              simulatedEvent.stop();
            });
          }
        };
        var keyboardEvents = [
          run$1(keydown(), function (component, simulatedEvent) {
            processKey(component, simulatedEvent, getKeydownRules, keyingConfig, keyingState).fold(function () {
              tryGoInsideComponent(component, simulatedEvent);
            }, function (_) {
              simulatedEvent.stop();
            });
          }),
          run$1(keyup(), function (component, simulatedEvent) {
            processKey(component, simulatedEvent, getKeyupRules, keyingConfig, keyingState).each(function (_) {
              simulatedEvent.stop();
            });
          })
        ];
        return derive$2(onFocusHandler.toArray().concat(keyboardEvents));
      };
      var me = {
        schema: schema,
        processKey: processKey,
        toEvents: toEvents
      };
      return me;
    };

    var create$5 = function (cyclicField) {
      var schema = [
        option('onEscape'),
        option('onEnter'),
        defaulted('selector', '[data-alloy-tabstop="true"]:not(:disabled)'),
        defaulted('firstTabstop', 0),
        defaulted('useTabstopAt', always),
        option('visibilitySelector')
      ].concat([cyclicField]);
      var isVisible = function (tabbingConfig, element) {
        var target = tabbingConfig.visibilitySelector.bind(function (sel) {
          return closest$1(element, sel);
        }).getOr(element);
        return get$b(target) > 0;
      };
      var findInitial = function (component, tabbingConfig) {
        var tabstops = descendants(component.element, tabbingConfig.selector);
        var visibles = filter$2(tabstops, function (elem) {
          return isVisible(tabbingConfig, elem);
        });
        return Optional.from(visibles[tabbingConfig.firstTabstop]);
      };
      var findCurrent = function (component, tabbingConfig) {
        return tabbingConfig.focusManager.get(component).bind(function (elem) {
          return closest$1(elem, tabbingConfig.selector);
        });
      };
      var isTabstop = function (tabbingConfig, element) {
        return isVisible(tabbingConfig, element) && tabbingConfig.useTabstopAt(element);
      };
      var focusIn = function (component, tabbingConfig, _tabbingState) {
        findInitial(component, tabbingConfig).each(function (target) {
          tabbingConfig.focusManager.set(component, target);
        });
      };
      var goFromTabstop = function (component, tabstops, stopIndex, tabbingConfig, cycle) {
        return cycle(tabstops, stopIndex, function (elem) {
          return isTabstop(tabbingConfig, elem);
        }).fold(function () {
          return tabbingConfig.cyclic ? Optional.some(true) : Optional.none();
        }, function (target) {
          tabbingConfig.focusManager.set(component, target);
          return Optional.some(true);
        });
      };
      var go = function (component, _simulatedEvent, tabbingConfig, cycle) {
        var tabstops = descendants(component.element, tabbingConfig.selector);
        return findCurrent(component, tabbingConfig).bind(function (tabstop) {
          var optStopIndex = findIndex$1(tabstops, curry(eq, tabstop));
          return optStopIndex.bind(function (stopIndex) {
            return goFromTabstop(component, tabstops, stopIndex, tabbingConfig, cycle);
          });
        });
      };
      var goBackwards = function (component, simulatedEvent, tabbingConfig) {
        var navigate = tabbingConfig.cyclic ? cyclePrev : tryPrev;
        return go(component, simulatedEvent, tabbingConfig, navigate);
      };
      var goForwards = function (component, simulatedEvent, tabbingConfig) {
        var navigate = tabbingConfig.cyclic ? cycleNext : tryNext;
        return go(component, simulatedEvent, tabbingConfig, navigate);
      };
      var execute = function (component, simulatedEvent, tabbingConfig) {
        return tabbingConfig.onEnter.bind(function (f) {
          return f(component, simulatedEvent);
        });
      };
      var exit = function (component, simulatedEvent, tabbingConfig) {
        return tabbingConfig.onEscape.bind(function (f) {
          return f(component, simulatedEvent);
        });
      };
      var getKeydownRules = constant$1([
        rule(and([
          isShift,
          inSet(TAB)
        ]), goBackwards),
        rule(inSet(TAB), goForwards),
        rule(inSet(ESCAPE), exit),
        rule(and([
          isNotShift,
          inSet(ENTER)
        ]), execute)
      ]);
      var getKeyupRules = constant$1([]);
      return typical(schema, NoState.init, getKeydownRules, getKeyupRules, function () {
        return Optional.some(focusIn);
      });
    };

    var AcyclicType = create$5(customField('cyclic', never));

    var CyclicType = create$5(customField('cyclic', always));

    var doDefaultExecute = function (component, _simulatedEvent, focused) {
      dispatch(component, focused, execute$5());
      return Optional.some(true);
    };
    var defaultExecute = function (component, simulatedEvent, focused) {
      var isComplex = inside(focused) && inSet(SPACE)(simulatedEvent.event);
      return isComplex ? Optional.none() : doDefaultExecute(component, simulatedEvent, focused);
    };
    var stopEventForFirefox = function (_component, _simulatedEvent) {
      return Optional.some(true);
    };

    var schema$v = [
      defaulted('execute', defaultExecute),
      defaulted('useSpace', false),
      defaulted('useEnter', true),
      defaulted('useControlEnter', false),
      defaulted('useDown', false)
    ];
    var execute$4 = function (component, simulatedEvent, executeConfig) {
      return executeConfig.execute(component, simulatedEvent, component.element);
    };
    var getKeydownRules$5 = function (component, _simulatedEvent, executeConfig, _executeState) {
      var spaceExec = executeConfig.useSpace && !inside(component.element) ? SPACE : [];
      var enterExec = executeConfig.useEnter ? ENTER : [];
      var downExec = executeConfig.useDown ? DOWN : [];
      var execKeys = spaceExec.concat(enterExec).concat(downExec);
      return [rule(inSet(execKeys), execute$4)].concat(executeConfig.useControlEnter ? [rule(and([
          isControl,
          inSet(ENTER)
        ]), execute$4)] : []);
    };
    var getKeyupRules$5 = function (component, _simulatedEvent, executeConfig, _executeState) {
      return executeConfig.useSpace && !inside(component.element) ? [rule(inSet(SPACE), stopEventForFirefox)] : [];
    };
    var ExecutionType = typical(schema$v, NoState.init, getKeydownRules$5, getKeyupRules$5, function () {
      return Optional.none();
    });

    var flatgrid$1 = function () {
      var dimensions = value$1();
      var setGridSize = function (numRows, numColumns) {
        dimensions.set({
          numRows: numRows,
          numColumns: numColumns
        });
      };
      var getNumRows = function () {
        return dimensions.get().map(function (d) {
          return d.numRows;
        });
      };
      var getNumColumns = function () {
        return dimensions.get().map(function (d) {
          return d.numColumns;
        });
      };
      return nu$8({
        readState: function () {
          return dimensions.get().map(function (d) {
            return {
              numRows: String(d.numRows),
              numColumns: String(d.numColumns)
            };
          }).getOr({
            numRows: '?',
            numColumns: '?'
          });
        },
        setGridSize: setGridSize,
        getNumRows: getNumRows,
        getNumColumns: getNumColumns
      });
    };
    var init$d = function (spec) {
      return spec.state(spec);
    };

    var KeyingState = /*#__PURE__*/Object.freeze({
        __proto__: null,
        flatgrid: flatgrid$1,
        init: init$d
    });

    var useH = function (movement) {
      return function (component, simulatedEvent, config, state) {
        var move = movement(component.element);
        return use(move, component, simulatedEvent, config, state);
      };
    };
    var west$1 = function (moveLeft, moveRight) {
      var movement = onDirection(moveLeft, moveRight);
      return useH(movement);
    };
    var east$1 = function (moveLeft, moveRight) {
      var movement = onDirection(moveRight, moveLeft);
      return useH(movement);
    };
    var useV = function (move) {
      return function (component, simulatedEvent, config, state) {
        return use(move, component, simulatedEvent, config, state);
      };
    };
    var use = function (move, component, simulatedEvent, config, state) {
      var outcome = config.focusManager.get(component).bind(function (focused) {
        return move(component.element, focused, config, state);
      });
      return outcome.map(function (newFocus) {
        config.focusManager.set(component, newFocus);
        return true;
      });
    };
    var north$1 = useV;
    var south$1 = useV;
    var move$1 = useV;

    var isHidden$1 = function (dom) {
      return dom.offsetWidth <= 0 && dom.offsetHeight <= 0;
    };
    var isVisible = function (element) {
      return !isHidden$1(element.dom);
    };

    var locate = function (candidates, predicate) {
      return findIndex$1(candidates, predicate).map(function (index) {
        return {
          index: index,
          candidates: candidates
        };
      });
    };

    var locateVisible = function (container, current, selector) {
      var predicate = function (x) {
        return eq(x, current);
      };
      var candidates = descendants(container, selector);
      var visible = filter$2(candidates, isVisible);
      return locate(visible, predicate);
    };
    var findIndex = function (elements, target) {
      return findIndex$1(elements, function (elem) {
        return eq(target, elem);
      });
    };

    var withGrid = function (values, index, numCols, f) {
      var oldRow = Math.floor(index / numCols);
      var oldColumn = index % numCols;
      return f(oldRow, oldColumn).bind(function (address) {
        var newIndex = address.row * numCols + address.column;
        return newIndex >= 0 && newIndex < values.length ? Optional.some(values[newIndex]) : Optional.none();
      });
    };
    var cycleHorizontal$1 = function (values, index, numRows, numCols, delta) {
      return withGrid(values, index, numCols, function (oldRow, oldColumn) {
        var onLastRow = oldRow === numRows - 1;
        var colsInRow = onLastRow ? values.length - oldRow * numCols : numCols;
        var newColumn = cycleBy(oldColumn, delta, 0, colsInRow - 1);
        return Optional.some({
          row: oldRow,
          column: newColumn
        });
      });
    };
    var cycleVertical$1 = function (values, index, numRows, numCols, delta) {
      return withGrid(values, index, numCols, function (oldRow, oldColumn) {
        var newRow = cycleBy(oldRow, delta, 0, numRows - 1);
        var onLastRow = newRow === numRows - 1;
        var colsInRow = onLastRow ? values.length - newRow * numCols : numCols;
        var newCol = clamp$1(oldColumn, 0, colsInRow - 1);
        return Optional.some({
          row: newRow,
          column: newCol
        });
      });
    };
    var cycleRight$1 = function (values, index, numRows, numCols) {
      return cycleHorizontal$1(values, index, numRows, numCols, +1);
    };
    var cycleLeft$1 = function (values, index, numRows, numCols) {
      return cycleHorizontal$1(values, index, numRows, numCols, -1);
    };
    var cycleUp$1 = function (values, index, numRows, numCols) {
      return cycleVertical$1(values, index, numRows, numCols, -1);
    };
    var cycleDown$1 = function (values, index, numRows, numCols) {
      return cycleVertical$1(values, index, numRows, numCols, +1);
    };

    var schema$u = [
      required$1('selector'),
      defaulted('execute', defaultExecute),
      onKeyboardHandler('onEscape'),
      defaulted('captureTab', false),
      initSize()
    ];
    var focusIn$3 = function (component, gridConfig, _gridState) {
      descendant(component.element, gridConfig.selector).each(function (first) {
        gridConfig.focusManager.set(component, first);
      });
    };
    var findCurrent$1 = function (component, gridConfig) {
      return gridConfig.focusManager.get(component).bind(function (elem) {
        return closest$1(elem, gridConfig.selector);
      });
    };
    var execute$3 = function (component, simulatedEvent, gridConfig, _gridState) {
      return findCurrent$1(component, gridConfig).bind(function (focused) {
        return gridConfig.execute(component, simulatedEvent, focused);
      });
    };
    var doMove$2 = function (cycle) {
      return function (element, focused, gridConfig, gridState) {
        return locateVisible(element, focused, gridConfig.selector).bind(function (identified) {
          return cycle(identified.candidates, identified.index, gridState.getNumRows().getOr(gridConfig.initSize.numRows), gridState.getNumColumns().getOr(gridConfig.initSize.numColumns));
        });
      };
    };
    var handleTab = function (_component, _simulatedEvent, gridConfig) {
      return gridConfig.captureTab ? Optional.some(true) : Optional.none();
    };
    var doEscape$1 = function (component, simulatedEvent, gridConfig) {
      return gridConfig.onEscape(component, simulatedEvent);
    };
    var moveLeft$3 = doMove$2(cycleLeft$1);
    var moveRight$3 = doMove$2(cycleRight$1);
    var moveNorth$1 = doMove$2(cycleUp$1);
    var moveSouth$1 = doMove$2(cycleDown$1);
    var getKeydownRules$4 = constant$1([
      rule(inSet(LEFT), west$1(moveLeft$3, moveRight$3)),
      rule(inSet(RIGHT), east$1(moveLeft$3, moveRight$3)),
      rule(inSet(UP), north$1(moveNorth$1)),
      rule(inSet(DOWN), south$1(moveSouth$1)),
      rule(and([
        isShift,
        inSet(TAB)
      ]), handleTab),
      rule(and([
        isNotShift,
        inSet(TAB)
      ]), handleTab),
      rule(inSet(ESCAPE), doEscape$1),
      rule(inSet(SPACE.concat(ENTER)), execute$3)
    ]);
    var getKeyupRules$4 = constant$1([rule(inSet(SPACE), stopEventForFirefox)]);
    var FlatgridType = typical(schema$u, flatgrid$1, getKeydownRules$4, getKeyupRules$4, function () {
      return Optional.some(focusIn$3);
    });

    var horizontal = function (container, selector, current, delta) {
      var isDisabledButton = function (candidate) {
        return name$2(candidate) === 'button' && get$d(candidate, 'disabled') === 'disabled';
      };
      var tryCycle = function (initial, index, candidates) {
        var newIndex = cycleBy(index, delta, 0, candidates.length - 1);
        if (newIndex === initial) {
          return Optional.none();
        } else {
          return isDisabledButton(candidates[newIndex]) ? tryCycle(initial, newIndex, candidates) : Optional.from(candidates[newIndex]);
        }
      };
      return locateVisible(container, current, selector).bind(function (identified) {
        var index = identified.index;
        var candidates = identified.candidates;
        return tryCycle(index, index, candidates);
      });
    };

    var schema$t = [
      required$1('selector'),
      defaulted('getInitial', Optional.none),
      defaulted('execute', defaultExecute),
      onKeyboardHandler('onEscape'),
      defaulted('executeOnMove', false),
      defaulted('allowVertical', true)
    ];
    var findCurrent = function (component, flowConfig) {
      return flowConfig.focusManager.get(component).bind(function (elem) {
        return closest$1(elem, flowConfig.selector);
      });
    };
    var execute$2 = function (component, simulatedEvent, flowConfig) {
      return findCurrent(component, flowConfig).bind(function (focused) {
        return flowConfig.execute(component, simulatedEvent, focused);
      });
    };
    var focusIn$2 = function (component, flowConfig, _state) {
      flowConfig.getInitial(component).orThunk(function () {
        return descendant(component.element, flowConfig.selector);
      }).each(function (first) {
        flowConfig.focusManager.set(component, first);
      });
    };
    var moveLeft$2 = function (element, focused, info) {
      return horizontal(element, info.selector, focused, -1);
    };
    var moveRight$2 = function (element, focused, info) {
      return horizontal(element, info.selector, focused, +1);
    };
    var doMove$1 = function (movement) {
      return function (component, simulatedEvent, flowConfig, flowState) {
        return movement(component, simulatedEvent, flowConfig, flowState).bind(function () {
          return flowConfig.executeOnMove ? execute$2(component, simulatedEvent, flowConfig) : Optional.some(true);
        });
      };
    };
    var doEscape = function (component, simulatedEvent, flowConfig) {
      return flowConfig.onEscape(component, simulatedEvent);
    };
    var getKeydownRules$3 = function (_component, _se, flowConfig, _flowState) {
      var westMovers = LEFT.concat(flowConfig.allowVertical ? UP : []);
      var eastMovers = RIGHT.concat(flowConfig.allowVertical ? DOWN : []);
      return [
        rule(inSet(westMovers), doMove$1(west$1(moveLeft$2, moveRight$2))),
        rule(inSet(eastMovers), doMove$1(east$1(moveLeft$2, moveRight$2))),
        rule(inSet(ENTER), execute$2),
        rule(inSet(SPACE), execute$2),
        rule(inSet(ESCAPE), doEscape)
      ];
    };
    var getKeyupRules$3 = constant$1([rule(inSet(SPACE), stopEventForFirefox)]);
    var FlowType = typical(schema$t, NoState.init, getKeydownRules$3, getKeyupRules$3, function () {
      return Optional.some(focusIn$2);
    });

    var toCell = function (matrix, rowIndex, columnIndex) {
      return Optional.from(matrix[rowIndex]).bind(function (row) {
        return Optional.from(row[columnIndex]).map(function (cell) {
          return {
            rowIndex: rowIndex,
            columnIndex: columnIndex,
            cell: cell
          };
        });
      });
    };
    var cycleHorizontal = function (matrix, rowIndex, startCol, deltaCol) {
      var row = matrix[rowIndex];
      var colsInRow = row.length;
      var newColIndex = cycleBy(startCol, deltaCol, 0, colsInRow - 1);
      return toCell(matrix, rowIndex, newColIndex);
    };
    var cycleVertical = function (matrix, colIndex, startRow, deltaRow) {
      var nextRowIndex = cycleBy(startRow, deltaRow, 0, matrix.length - 1);
      var colsInNextRow = matrix[nextRowIndex].length;
      var nextColIndex = clamp$1(colIndex, 0, colsInNextRow - 1);
      return toCell(matrix, nextRowIndex, nextColIndex);
    };
    var moveHorizontal = function (matrix, rowIndex, startCol, deltaCol) {
      var row = matrix[rowIndex];
      var colsInRow = row.length;
      var newColIndex = clamp$1(startCol + deltaCol, 0, colsInRow - 1);
      return toCell(matrix, rowIndex, newColIndex);
    };
    var moveVertical = function (matrix, colIndex, startRow, deltaRow) {
      var nextRowIndex = clamp$1(startRow + deltaRow, 0, matrix.length - 1);
      var colsInNextRow = matrix[nextRowIndex].length;
      var nextColIndex = clamp$1(colIndex, 0, colsInNextRow - 1);
      return toCell(matrix, nextRowIndex, nextColIndex);
    };
    var cycleRight = function (matrix, startRow, startCol) {
      return cycleHorizontal(matrix, startRow, startCol, +1);
    };
    var cycleLeft = function (matrix, startRow, startCol) {
      return cycleHorizontal(matrix, startRow, startCol, -1);
    };
    var cycleUp = function (matrix, startRow, startCol) {
      return cycleVertical(matrix, startCol, startRow, -1);
    };
    var cycleDown = function (matrix, startRow, startCol) {
      return cycleVertical(matrix, startCol, startRow, +1);
    };
    var moveLeft$1 = function (matrix, startRow, startCol) {
      return moveHorizontal(matrix, startRow, startCol, -1);
    };
    var moveRight$1 = function (matrix, startRow, startCol) {
      return moveHorizontal(matrix, startRow, startCol, +1);
    };
    var moveUp$1 = function (matrix, startRow, startCol) {
      return moveVertical(matrix, startCol, startRow, -1);
    };
    var moveDown$1 = function (matrix, startRow, startCol) {
      return moveVertical(matrix, startCol, startRow, +1);
    };

    var schema$s = [
      requiredObjOf('selectors', [
        required$1('row'),
        required$1('cell')
      ]),
      defaulted('cycles', true),
      defaulted('previousSelector', Optional.none),
      defaulted('execute', defaultExecute)
    ];
    var focusIn$1 = function (component, matrixConfig, _state) {
      var focused = matrixConfig.previousSelector(component).orThunk(function () {
        var selectors = matrixConfig.selectors;
        return descendant(component.element, selectors.cell);
      });
      focused.each(function (cell) {
        matrixConfig.focusManager.set(component, cell);
      });
    };
    var execute$1 = function (component, simulatedEvent, matrixConfig) {
      return search(component.element).bind(function (focused) {
        return matrixConfig.execute(component, simulatedEvent, focused);
      });
    };
    var toMatrix = function (rows, matrixConfig) {
      return map$2(rows, function (row) {
        return descendants(row, matrixConfig.selectors.cell);
      });
    };
    var doMove = function (ifCycle, ifMove) {
      return function (element, focused, matrixConfig) {
        var move = matrixConfig.cycles ? ifCycle : ifMove;
        return closest$1(focused, matrixConfig.selectors.row).bind(function (inRow) {
          var cellsInRow = descendants(inRow, matrixConfig.selectors.cell);
          return findIndex(cellsInRow, focused).bind(function (colIndex) {
            var allRows = descendants(element, matrixConfig.selectors.row);
            return findIndex(allRows, inRow).bind(function (rowIndex) {
              var matrix = toMatrix(allRows, matrixConfig);
              return move(matrix, rowIndex, colIndex).map(function (next) {
                return next.cell;
              });
            });
          });
        });
      };
    };
    var moveLeft = doMove(cycleLeft, moveLeft$1);
    var moveRight = doMove(cycleRight, moveRight$1);
    var moveNorth = doMove(cycleUp, moveUp$1);
    var moveSouth = doMove(cycleDown, moveDown$1);
    var getKeydownRules$2 = constant$1([
      rule(inSet(LEFT), west$1(moveLeft, moveRight)),
      rule(inSet(RIGHT), east$1(moveLeft, moveRight)),
      rule(inSet(UP), north$1(moveNorth)),
      rule(inSet(DOWN), south$1(moveSouth)),
      rule(inSet(SPACE.concat(ENTER)), execute$1)
    ]);
    var getKeyupRules$2 = constant$1([rule(inSet(SPACE), stopEventForFirefox)]);
    var MatrixType = typical(schema$s, NoState.init, getKeydownRules$2, getKeyupRules$2, function () {
      return Optional.some(focusIn$1);
    });

    var schema$r = [
      required$1('selector'),
      defaulted('execute', defaultExecute),
      defaulted('moveOnTab', false)
    ];
    var execute = function (component, simulatedEvent, menuConfig) {
      return menuConfig.focusManager.get(component).bind(function (focused) {
        return menuConfig.execute(component, simulatedEvent, focused);
      });
    };
    var focusIn = function (component, menuConfig, _state) {
      descendant(component.element, menuConfig.selector).each(function (first) {
        menuConfig.focusManager.set(component, first);
      });
    };
    var moveUp = function (element, focused, info) {
      return horizontal(element, info.selector, focused, -1);
    };
    var moveDown = function (element, focused, info) {
      return horizontal(element, info.selector, focused, +1);
    };
    var fireShiftTab = function (component, simulatedEvent, menuConfig, menuState) {
      return menuConfig.moveOnTab ? move$1(moveUp)(component, simulatedEvent, menuConfig, menuState) : Optional.none();
    };
    var fireTab = function (component, simulatedEvent, menuConfig, menuState) {
      return menuConfig.moveOnTab ? move$1(moveDown)(component, simulatedEvent, menuConfig, menuState) : Optional.none();
    };
    var getKeydownRules$1 = constant$1([
      rule(inSet(UP), move$1(moveUp)),
      rule(inSet(DOWN), move$1(moveDown)),
      rule(and([
        isShift,
        inSet(TAB)
      ]), fireShiftTab),
      rule(and([
        isNotShift,
        inSet(TAB)
      ]), fireTab),
      rule(inSet(ENTER), execute),
      rule(inSet(SPACE), execute)
    ]);
    var getKeyupRules$1 = constant$1([rule(inSet(SPACE), stopEventForFirefox)]);
    var MenuType = typical(schema$r, NoState.init, getKeydownRules$1, getKeyupRules$1, function () {
      return Optional.some(focusIn);
    });

    var schema$q = [
      onKeyboardHandler('onSpace'),
      onKeyboardHandler('onEnter'),
      onKeyboardHandler('onShiftEnter'),
      onKeyboardHandler('onLeft'),
      onKeyboardHandler('onRight'),
      onKeyboardHandler('onTab'),
      onKeyboardHandler('onShiftTab'),
      onKeyboardHandler('onUp'),
      onKeyboardHandler('onDown'),
      onKeyboardHandler('onEscape'),
      defaulted('stopSpaceKeyup', false),
      option('focusIn')
    ];
    var getKeydownRules = function (component, simulatedEvent, specialInfo) {
      return [
        rule(inSet(SPACE), specialInfo.onSpace),
        rule(and([
          isNotShift,
          inSet(ENTER)
        ]), specialInfo.onEnter),
        rule(and([
          isShift,
          inSet(ENTER)
        ]), specialInfo.onShiftEnter),
        rule(and([
          isShift,
          inSet(TAB)
        ]), specialInfo.onShiftTab),
        rule(and([
          isNotShift,
          inSet(TAB)
        ]), specialInfo.onTab),
        rule(inSet(UP), specialInfo.onUp),
        rule(inSet(DOWN), specialInfo.onDown),
        rule(inSet(LEFT), specialInfo.onLeft),
        rule(inSet(RIGHT), specialInfo.onRight),
        rule(inSet(SPACE), specialInfo.onSpace),
        rule(inSet(ESCAPE), specialInfo.onEscape)
      ];
    };
    var getKeyupRules = function (component, simulatedEvent, specialInfo) {
      return specialInfo.stopSpaceKeyup ? [rule(inSet(SPACE), stopEventForFirefox)] : [];
    };
    var SpecialType = typical(schema$q, NoState.init, getKeydownRules, getKeyupRules, function (specialInfo) {
      return specialInfo.focusIn;
    });

    var acyclic = AcyclicType.schema();
    var cyclic = CyclicType.schema();
    var flow = FlowType.schema();
    var flatgrid = FlatgridType.schema();
    var matrix = MatrixType.schema();
    var execution = ExecutionType.schema();
    var menu = MenuType.schema();
    var special = SpecialType.schema();

    var KeyboardBranches = /*#__PURE__*/Object.freeze({
        __proto__: null,
        acyclic: acyclic,
        cyclic: cyclic,
        flow: flow,
        flatgrid: flatgrid,
        matrix: matrix,
        execution: execution,
        menu: menu,
        special: special
    });

    var isFlatgridState = function (keyState) {
      return hasNonNullableKey(keyState, 'setGridSize');
    };
    var Keying = createModes({
      branchKey: 'mode',
      branches: KeyboardBranches,
      name: 'keying',
      active: {
        events: function (keyingConfig, keyingState) {
          var handler = keyingConfig.handler;
          return handler.toEvents(keyingConfig, keyingState);
        }
      },
      apis: {
        focusIn: function (component, keyConfig, keyState) {
          keyConfig.sendFocusIn(keyConfig).fold(function () {
            component.getSystem().triggerFocus(component.element, component.element);
          }, function (sendFocusIn) {
            sendFocusIn(component, keyConfig, keyState);
          });
        },
        setGridSize: function (component, keyConfig, keyState, numRows, numColumns) {
          if (!isFlatgridState(keyState)) {
            console.error('Layout does not support setGridSize');
          } else {
            keyState.setGridSize(numRows, numColumns);
          }
        }
      },
      state: KeyingState
    });

    var set$2 = function (component, replaceConfig, replaceState, data) {
      preserve$1(function () {
        var newChildren = map$2(data, component.getSystem().build);
        replaceChildren(component, newChildren);
      }, component.element);
    };
    var insert = function (component, replaceConfig, insertion, childSpec) {
      var child = component.getSystem().build(childSpec);
      attachWith(component, child, insertion);
    };
    var append = function (component, replaceConfig, replaceState, appendee) {
      insert(component, replaceConfig, append$2, appendee);
    };
    var prepend = function (component, replaceConfig, replaceState, prependee) {
      insert(component, replaceConfig, prepend$1, prependee);
    };
    var remove = function (component, replaceConfig, replaceState, removee) {
      var children = contents(component);
      var foundChild = find$5(children, function (child) {
        return eq(removee.element, child.element);
      });
      foundChild.each(detach);
    };
    var contents = function (component, _replaceConfig) {
      return component.components();
    };
    var replaceAt = function (component, replaceConfig, replaceState, replaceeIndex, replacer) {
      var children = contents(component);
      return Optional.from(children[replaceeIndex]).map(function (replacee) {
        remove(component, replaceConfig, replaceState, replacee);
        replacer.each(function (r) {
          insert(component, replaceConfig, function (p, c) {
            appendAt(p, c, replaceeIndex);
          }, r);
        });
        return replacee;
      });
    };
    var replaceBy = function (component, replaceConfig, replaceState, replaceePred, replacer) {
      var children = contents(component);
      return findIndex$1(children, replaceePred).bind(function (replaceeIndex) {
        return replaceAt(component, replaceConfig, replaceState, replaceeIndex, replacer);
      });
    };

    var ReplaceApis = /*#__PURE__*/Object.freeze({
        __proto__: null,
        append: append,
        prepend: prepend,
        remove: remove,
        replaceAt: replaceAt,
        replaceBy: replaceBy,
        set: set$2,
        contents: contents
    });

    var Replacing = create$7({
      fields: [],
      name: 'replacing',
      apis: ReplaceApis
    });

    var events$d = function (name, eventHandlers) {
      var events = derive$2(eventHandlers);
      return create$7({
        fields: [required$1('enabled')],
        name: name,
        active: { events: constant$1(events) }
      });
    };
    var config = function (name, eventHandlers) {
      var me = events$d(name, eventHandlers);
      return {
        key: name,
        value: {
          config: {},
          me: me,
          configAsRaw: constant$1({}),
          initialConfig: {},
          state: NoState
        }
      };
    };

    var focus$2 = function (component, focusConfig) {
      if (!focusConfig.ignore) {
        focus$3(component.element);
        focusConfig.onFocus(component);
      }
    };
    var blur = function (component, focusConfig) {
      if (!focusConfig.ignore) {
        blur$1(component.element);
      }
    };
    var isFocused = function (component) {
      return hasFocus(component.element);
    };

    var FocusApis = /*#__PURE__*/Object.freeze({
        __proto__: null,
        focus: focus$2,
        blur: blur,
        isFocused: isFocused
    });

    var exhibit$4 = function (base, focusConfig) {
      var mod = focusConfig.ignore ? {} : { attributes: { tabindex: '-1' } };
      return nu$7(mod);
    };
    var events$c = function (focusConfig) {
      return derive$2([run$1(focus$4(), function (component, simulatedEvent) {
          focus$2(component, focusConfig);
          simulatedEvent.stop();
        })].concat(focusConfig.stopMousedown ? [run$1(mousedown(), function (_, simulatedEvent) {
          simulatedEvent.event.prevent();
        })] : []));
    };

    var ActiveFocus = /*#__PURE__*/Object.freeze({
        __proto__: null,
        exhibit: exhibit$4,
        events: events$c
    });

    var FocusSchema = [
      onHandler('onFocus'),
      defaulted('stopMousedown', false),
      defaulted('ignore', false)
    ];

    var Focusing = create$7({
      fields: FocusSchema,
      name: 'focusing',
      active: ActiveFocus,
      apis: FocusApis
    });

    var SetupBehaviourCellState = function (initialState) {
      var init = function () {
        var cell = Cell(initialState);
        var get = function () {
          return cell.get();
        };
        var set = function (newState) {
          return cell.set(newState);
        };
        var clear = function () {
          return cell.set(initialState);
        };
        var readState = function () {
          return cell.get();
        };
        return {
          get: get,
          set: set,
          clear: clear,
          readState: readState
        };
      };
      return { init: init };
    };

    var updateAriaState = function (component, toggleConfig, toggleState) {
      var ariaInfo = toggleConfig.aria;
      ariaInfo.update(component, ariaInfo, toggleState.get());
    };
    var updateClass = function (component, toggleConfig, toggleState) {
      toggleConfig.toggleClass.each(function (toggleClass) {
        if (toggleState.get()) {
          add$2(component.element, toggleClass);
        } else {
          remove$2(component.element, toggleClass);
        }
      });
    };
    var toggle$2 = function (component, toggleConfig, toggleState) {
      set$1(component, toggleConfig, toggleState, !toggleState.get());
    };
    var on = function (component, toggleConfig, toggleState) {
      toggleState.set(true);
      updateClass(component, toggleConfig, toggleState);
      updateAriaState(component, toggleConfig, toggleState);
    };
    var off = function (component, toggleConfig, toggleState) {
      toggleState.set(false);
      updateClass(component, toggleConfig, toggleState);
      updateAriaState(component, toggleConfig, toggleState);
    };
    var set$1 = function (component, toggleConfig, toggleState, state) {
      var action = state ? on : off;
      action(component, toggleConfig, toggleState);
    };
    var isOn = function (component, toggleConfig, toggleState) {
      return toggleState.get();
    };
    var onLoad = function (component, toggleConfig, toggleState) {
      set$1(component, toggleConfig, toggleState, toggleConfig.selected);
    };

    var ToggleApis = /*#__PURE__*/Object.freeze({
        __proto__: null,
        onLoad: onLoad,
        toggle: toggle$2,
        isOn: isOn,
        on: on,
        off: off,
        set: set$1
    });

    var exhibit$3 = function () {
      return nu$7({});
    };
    var events$b = function (toggleConfig, toggleState) {
      var execute = executeEvent(toggleConfig, toggleState, toggle$2);
      var load = loadEvent(toggleConfig, toggleState, onLoad);
      return derive$2(flatten([
        toggleConfig.toggleOnExecute ? [execute] : [],
        [load]
      ]));
    };

    var ActiveToggle = /*#__PURE__*/Object.freeze({
        __proto__: null,
        exhibit: exhibit$3,
        events: events$b
    });

    var updatePressed = function (component, ariaInfo, status) {
      set$8(component.element, 'aria-pressed', status);
      if (ariaInfo.syncWithExpanded) {
        updateExpanded(component, ariaInfo, status);
      }
    };
    var updateSelected = function (component, ariaInfo, status) {
      set$8(component.element, 'aria-selected', status);
    };
    var updateChecked = function (component, ariaInfo, status) {
      set$8(component.element, 'aria-checked', status);
    };
    var updateExpanded = function (component, ariaInfo, status) {
      set$8(component.element, 'aria-expanded', status);
    };

    var ToggleSchema = [
      defaulted('selected', false),
      option('toggleClass'),
      defaulted('toggleOnExecute', true),
      defaultedOf('aria', { mode: 'none' }, choose$1('mode', {
        pressed: [
          defaulted('syncWithExpanded', false),
          output$1('update', updatePressed)
        ],
        checked: [output$1('update', updateChecked)],
        expanded: [output$1('update', updateExpanded)],
        selected: [output$1('update', updateSelected)],
        none: [output$1('update', noop)]
      }))
    ];

    var Toggling = create$7({
      fields: ToggleSchema,
      name: 'toggling',
      active: ActiveToggle,
      apis: ToggleApis,
      state: SetupBehaviourCellState(false)
    });

    var pointerEvents = function () {
      var onClick = function (component, simulatedEvent) {
        simulatedEvent.stop();
        emitExecute(component);
      };
      return [
        run$1(click(), onClick),
        run$1(tap(), onClick),
        cutter(touchstart()),
        cutter(mousedown())
      ];
    };
    var events$a = function (optAction) {
      var executeHandler = function (action) {
        return runOnExecute$1(function (component, simulatedEvent) {
          action(component);
          simulatedEvent.stop();
        });
      };
      return derive$2(flatten([
        optAction.map(executeHandler).toArray(),
        pointerEvents()
      ]));
    };

    var hoverEvent = 'alloy.item-hover';
    var focusEvent = 'alloy.item-focus';
    var onHover = function (item) {
      if (search(item.element).isNone() || Focusing.isFocused(item)) {
        if (!Focusing.isFocused(item)) {
          Focusing.focus(item);
        }
        emitWith(item, hoverEvent, { item: item });
      }
    };
    var onFocus$1 = function (item) {
      emitWith(item, focusEvent, { item: item });
    };
    var hover = constant$1(hoverEvent);
    var focus$1 = constant$1(focusEvent);

    var builder$2 = function (detail) {
      return {
        dom: detail.dom,
        domModification: __assign(__assign({}, detail.domModification), { attributes: __assign(__assign(__assign({ 'role': detail.toggling.isSome() ? 'menuitemcheckbox' : 'menuitem' }, detail.domModification.attributes), { 'aria-haspopup': detail.hasSubmenu }), detail.hasSubmenu ? { 'aria-expanded': false } : {}) }),
        behaviours: SketchBehaviours.augment(detail.itemBehaviours, [
          detail.toggling.fold(Toggling.revoke, function (tConfig) {
            return Toggling.config(__assign({ aria: { mode: 'checked' } }, tConfig));
          }),
          Focusing.config({
            ignore: detail.ignoreFocus,
            stopMousedown: detail.ignoreFocus,
            onFocus: function (component) {
              onFocus$1(component);
            }
          }),
          Keying.config({ mode: 'execution' }),
          Representing.config({
            store: {
              mode: 'memory',
              initialValue: detail.data
            }
          }),
          config('item-type-events', __spreadArray(__spreadArray([], pointerEvents(), true), [
            run$1(mouseover(), onHover),
            run$1(focusItem(), Focusing.focus)
          ], false))
        ]),
        components: detail.components,
        eventOrder: detail.eventOrder
      };
    };
    var schema$p = [
      required$1('data'),
      required$1('components'),
      required$1('dom'),
      defaulted('hasSubmenu', false),
      option('toggling'),
      SketchBehaviours.field('itemBehaviours', [
        Toggling,
        Focusing,
        Keying,
        Representing
      ]),
      defaulted('ignoreFocus', false),
      defaulted('domModification', {}),
      output$1('builder', builder$2),
      defaulted('eventOrder', {})
    ];

    var builder$1 = function (detail) {
      return {
        dom: detail.dom,
        components: detail.components,
        events: derive$2([stopper(focusItem())])
      };
    };
    var schema$o = [
      required$1('dom'),
      required$1('components'),
      output$1('builder', builder$1)
    ];

    var owner$2 = constant$1('item-widget');
    var parts$h = constant$1([required({
        name: 'widget',
        overrides: function (detail) {
          return {
            behaviours: derive$1([Representing.config({
                store: {
                  mode: 'manual',
                  getValue: function (_component) {
                    return detail.data;
                  },
                  setValue: noop
                }
              })])
          };
        }
      })]);

    var builder = function (detail) {
      var subs = substitutes(owner$2(), detail, parts$h());
      var components = components$1(owner$2(), detail, subs.internals());
      var focusWidget = function (component) {
        return getPart(component, detail, 'widget').map(function (widget) {
          Keying.focusIn(widget);
          return widget;
        });
      };
      var onHorizontalArrow = function (component, simulatedEvent) {
        return inside(simulatedEvent.event.target) ? Optional.none() : function () {
          if (detail.autofocus) {
            simulatedEvent.setSource(component.element);
            return Optional.none();
          } else {
            return Optional.none();
          }
        }();
      };
      return {
        dom: detail.dom,
        components: components,
        domModification: detail.domModification,
        events: derive$2([
          runOnExecute$1(function (component, simulatedEvent) {
            focusWidget(component).each(function (_widget) {
              simulatedEvent.stop();
            });
          }),
          run$1(mouseover(), onHover),
          run$1(focusItem(), function (component, _simulatedEvent) {
            if (detail.autofocus) {
              focusWidget(component);
            } else {
              Focusing.focus(component);
            }
          })
        ]),
        behaviours: SketchBehaviours.augment(detail.widgetBehaviours, [
          Representing.config({
            store: {
              mode: 'memory',
              initialValue: detail.data
            }
          }),
          Focusing.config({
            ignore: detail.ignoreFocus,
            onFocus: function (component) {
              onFocus$1(component);
            }
          }),
          Keying.config({
            mode: 'special',
            focusIn: detail.autofocus ? function (component) {
              focusWidget(component);
            } : revoke(),
            onLeft: onHorizontalArrow,
            onRight: onHorizontalArrow,
            onEscape: function (component, simulatedEvent) {
              if (!Focusing.isFocused(component) && !detail.autofocus) {
                Focusing.focus(component);
                return Optional.some(true);
              } else if (detail.autofocus) {
                simulatedEvent.setSource(component.element);
                return Optional.none();
              } else {
                return Optional.none();
              }
            }
          })
        ])
      };
    };
    var schema$n = [
      required$1('uid'),
      required$1('data'),
      required$1('components'),
      required$1('dom'),
      defaulted('autofocus', false),
      defaulted('ignoreFocus', false),
      SketchBehaviours.field('widgetBehaviours', [
        Representing,
        Focusing,
        Keying
      ]),
      defaulted('domModification', {}),
      defaultUidsSchema(parts$h()),
      output$1('builder', builder)
    ];

    var itemSchema$2 = choose$1('type', {
      widget: schema$n,
      item: schema$p,
      separator: schema$o
    });
    var configureGrid = function (detail, movementInfo) {
      return {
        mode: 'flatgrid',
        selector: '.' + detail.markers.item,
        initSize: {
          numColumns: movementInfo.initSize.numColumns,
          numRows: movementInfo.initSize.numRows
        },
        focusManager: detail.focusManager
      };
    };
    var configureMatrix = function (detail, movementInfo) {
      return {
        mode: 'matrix',
        selectors: {
          row: movementInfo.rowSelector,
          cell: '.' + detail.markers.item
        },
        focusManager: detail.focusManager
      };
    };
    var configureMenu = function (detail, movementInfo) {
      return {
        mode: 'menu',
        selector: '.' + detail.markers.item,
        moveOnTab: movementInfo.moveOnTab,
        focusManager: detail.focusManager
      };
    };
    var parts$g = constant$1([group({
        factory: {
          sketch: function (spec) {
            var itemInfo = asRawOrDie$1('menu.spec item', itemSchema$2, spec);
            return itemInfo.builder(itemInfo);
          }
        },
        name: 'items',
        unit: 'item',
        defaults: function (detail, u) {
          return has$2(u, 'uid') ? u : __assign(__assign({}, u), { uid: generate$5('item') });
        },
        overrides: function (detail, u) {
          return {
            type: u.type,
            ignoreFocus: detail.fakeFocus,
            domModification: { classes: [detail.markers.item] }
          };
        }
      })]);
    var schema$m = constant$1([
      required$1('value'),
      required$1('items'),
      required$1('dom'),
      required$1('components'),
      defaulted('eventOrder', {}),
      field('menuBehaviours', [
        Highlighting,
        Representing,
        Composing,
        Keying
      ]),
      defaultedOf('movement', {
        mode: 'menu',
        moveOnTab: true
      }, choose$1('mode', {
        grid: [
          initSize(),
          output$1('config', configureGrid)
        ],
        matrix: [
          output$1('config', configureMatrix),
          required$1('rowSelector')
        ],
        menu: [
          defaulted('moveOnTab', true),
          output$1('config', configureMenu)
        ]
      })),
      itemMarkers(),
      defaulted('fakeFocus', false),
      defaulted('focusManager', dom$2()),
      onHandler('onHighlight')
    ]);

    var focus = constant$1('alloy.menu-focus');

    var make$7 = function (detail, components, _spec, _externals) {
      return {
        uid: detail.uid,
        dom: detail.dom,
        markers: detail.markers,
        behaviours: augment(detail.menuBehaviours, [
          Highlighting.config({
            highlightClass: detail.markers.selectedItem,
            itemClass: detail.markers.item,
            onHighlight: detail.onHighlight
          }),
          Representing.config({
            store: {
              mode: 'memory',
              initialValue: detail.value
            }
          }),
          Composing.config({ find: Optional.some }),
          Keying.config(detail.movement.config(detail, detail.movement))
        ]),
        events: derive$2([
          run$1(focus$1(), function (menu, simulatedEvent) {
            var event = simulatedEvent.event;
            menu.getSystem().getByDom(event.target).each(function (item) {
              Highlighting.highlight(menu, item);
              simulatedEvent.stop();
              emitWith(menu, focus(), {
                menu: menu,
                item: item
              });
            });
          }),
          run$1(hover(), function (menu, simulatedEvent) {
            var item = simulatedEvent.event.item;
            Highlighting.highlight(menu, item);
          })
        ]),
        components: components,
        eventOrder: detail.eventOrder,
        domModification: { attributes: { role: 'menu' } }
      };
    };

    var Menu = composite({
      name: 'Menu',
      configFields: schema$m(),
      partFields: parts$g(),
      factory: make$7
    });

    var transpose$1 = function (obj) {
      return tupleMap(obj, function (v, k) {
        return {
          k: v,
          v: k
        };
      });
    };
    var trace = function (items, byItem, byMenu, finish) {
      return get$e(byMenu, finish).bind(function (triggerItem) {
        return get$e(items, triggerItem).bind(function (triggerMenu) {
          var rest = trace(items, byItem, byMenu, triggerMenu);
          return Optional.some([triggerMenu].concat(rest));
        });
      }).getOr([]);
    };
    var generate$2 = function (menus, expansions) {
      var items = {};
      each(menus, function (menuItems, menu) {
        each$1(menuItems, function (item) {
          items[item] = menu;
        });
      });
      var byItem = expansions;
      var byMenu = transpose$1(expansions);
      var menuPaths = map$1(byMenu, function (_triggerItem, submenu) {
        return [submenu].concat(trace(items, byItem, byMenu, submenu));
      });
      return map$1(items, function (menu) {
        return get$e(menuPaths, menu).getOr([menu]);
      });
    };

    var init$c = function () {
      var expansions = Cell({});
      var menus = Cell({});
      var paths = Cell({});
      var primary = value$1();
      var directory = Cell({});
      var clear = function () {
        expansions.set({});
        menus.set({});
        paths.set({});
        primary.clear();
      };
      var isClear = function () {
        return primary.get().isNone();
      };
      var setMenuBuilt = function (menuName, built) {
        var _a;
        menus.set(__assign(__assign({}, menus.get()), (_a = {}, _a[menuName] = {
          type: 'prepared',
          menu: built
        }, _a)));
      };
      var setContents = function (sPrimary, sMenus, sExpansions, dir) {
        primary.set(sPrimary);
        expansions.set(sExpansions);
        menus.set(sMenus);
        directory.set(dir);
        var sPaths = generate$2(dir, sExpansions);
        paths.set(sPaths);
      };
      var getTriggeringItem = function (menuValue) {
        return find$4(expansions.get(), function (v, _k) {
          return v === menuValue;
        });
      };
      var getTriggerData = function (menuValue, getItemByValue, path) {
        return getPreparedMenu(menuValue).bind(function (menu) {
          return getTriggeringItem(menuValue).bind(function (triggeringItemValue) {
            return getItemByValue(triggeringItemValue).map(function (triggeredItem) {
              return {
                triggeredMenu: menu,
                triggeringItem: triggeredItem,
                triggeringPath: path
              };
            });
          });
        });
      };
      var getTriggeringPath = function (itemValue, getItemByValue) {
        var extraPath = filter$2(lookupItem(itemValue).toArray(), function (menuValue) {
          return getPreparedMenu(menuValue).isSome();
        });
        return get$e(paths.get(), itemValue).bind(function (path) {
          var revPath = reverse(extraPath.concat(path));
          var triggers = bind$3(revPath, function (menuValue, menuIndex) {
            return getTriggerData(menuValue, getItemByValue, revPath.slice(0, menuIndex + 1)).fold(function () {
              return is$1(primary.get(), menuValue) ? [] : [Optional.none()];
            }, function (data) {
              return [Optional.some(data)];
            });
          });
          return sequence(triggers);
        });
      };
      var expand = function (itemValue) {
        return get$e(expansions.get(), itemValue).map(function (menu) {
          var current = get$e(paths.get(), itemValue).getOr([]);
          return [menu].concat(current);
        });
      };
      var collapse = function (itemValue) {
        return get$e(paths.get(), itemValue).bind(function (path) {
          return path.length > 1 ? Optional.some(path.slice(1)) : Optional.none();
        });
      };
      var refresh = function (itemValue) {
        return get$e(paths.get(), itemValue);
      };
      var getPreparedMenu = function (menuValue) {
        return lookupMenu(menuValue).bind(extractPreparedMenu);
      };
      var lookupMenu = function (menuValue) {
        return get$e(menus.get(), menuValue);
      };
      var lookupItem = function (itemValue) {
        return get$e(expansions.get(), itemValue);
      };
      var otherMenus = function (path) {
        var menuValues = directory.get();
        return difference(keys(menuValues), path);
      };
      var getPrimary = function () {
        return primary.get().bind(getPreparedMenu);
      };
      var getMenus = function () {
        return menus.get();
      };
      return {
        setMenuBuilt: setMenuBuilt,
        setContents: setContents,
        expand: expand,
        refresh: refresh,
        collapse: collapse,
        lookupMenu: lookupMenu,
        lookupItem: lookupItem,
        otherMenus: otherMenus,
        getPrimary: getPrimary,
        getMenus: getMenus,
        clear: clear,
        isClear: isClear,
        getTriggeringPath: getTriggeringPath
      };
    };
    var extractPreparedMenu = function (prep) {
      return prep.type === 'prepared' ? Optional.some(prep.menu) : Optional.none();
    };
    var LayeredState = {
      init: init$c,
      extractPreparedMenu: extractPreparedMenu
    };

    var make$6 = function (detail, _rawUiSpec) {
      var submenuParentItems = value$1();
      var buildMenus = function (container, primaryName, menus) {
        return map$1(menus, function (spec, name) {
          var makeSketch = function () {
            return Menu.sketch(__assign(__assign({}, spec), {
              value: name,
              markers: detail.markers,
              fakeFocus: detail.fakeFocus,
              onHighlight: detail.onHighlight,
              focusManager: detail.fakeFocus ? highlights() : dom$2()
            }));
          };
          return name === primaryName ? {
            type: 'prepared',
            menu: container.getSystem().build(makeSketch())
          } : {
            type: 'notbuilt',
            nbMenu: makeSketch
          };
        });
      };
      var layeredState = LayeredState.init();
      var setup = function (container) {
        var componentMap = buildMenus(container, detail.data.primary, detail.data.menus);
        var directory = toDirectory();
        layeredState.setContents(detail.data.primary, componentMap, detail.data.expansions, directory);
        return layeredState.getPrimary();
      };
      var getItemValue = function (item) {
        return Representing.getValue(item).value;
      };
      var getItemByValue = function (_container, menus, itemValue) {
        return findMap(menus, function (menu) {
          if (!menu.getSystem().isConnected()) {
            return Optional.none();
          }
          var candidates = Highlighting.getCandidates(menu);
          return find$5(candidates, function (c) {
            return getItemValue(c) === itemValue;
          });
        });
      };
      var toDirectory = function (_container) {
        return map$1(detail.data.menus, function (data, _menuName) {
          return bind$3(data.items, function (item) {
            return item.type === 'separator' ? [] : [item.data.value];
          });
        });
      };
      var setActiveMenu = function (container, menu) {
        Highlighting.highlight(container, menu);
        Highlighting.getHighlighted(menu).orThunk(function () {
          return Highlighting.getFirst(menu);
        }).each(function (item) {
          dispatch(container, item.element, focusItem());
        });
      };
      var getMenus = function (state, menuValues) {
        return cat(map$2(menuValues, function (mv) {
          return state.lookupMenu(mv).bind(function (prep) {
            return prep.type === 'prepared' ? Optional.some(prep.menu) : Optional.none();
          });
        }));
      };
      var closeOthers = function (container, state, path) {
        var others = getMenus(state, state.otherMenus(path));
        each$1(others, function (o) {
          remove$1(o.element, [detail.markers.backgroundMenu]);
          if (!detail.stayInDom) {
            Replacing.remove(container, o);
          }
        });
      };
      var getSubmenuParents = function (container) {
        return submenuParentItems.get().getOrThunk(function () {
          var r = {};
          var items = descendants(container.element, '.' + detail.markers.item);
          var parentItems = filter$2(items, function (i) {
            return get$d(i, 'aria-haspopup') === 'true';
          });
          each$1(parentItems, function (i) {
            container.getSystem().getByDom(i).each(function (itemComp) {
              var key = getItemValue(itemComp);
              r[key] = itemComp;
            });
          });
          submenuParentItems.set(r);
          return r;
        });
      };
      var updateAriaExpansions = function (container, path) {
        var parentItems = getSubmenuParents(container);
        each(parentItems, function (v, k) {
          var expanded = contains$2(path, k);
          set$8(v.element, 'aria-expanded', expanded);
        });
      };
      var updateMenuPath = function (container, state, path) {
        return Optional.from(path[0]).bind(function (latestMenuName) {
          return state.lookupMenu(latestMenuName).bind(function (menuPrep) {
            if (menuPrep.type === 'notbuilt') {
              return Optional.none();
            } else {
              var activeMenu = menuPrep.menu;
              var rest = getMenus(state, path.slice(1));
              each$1(rest, function (r) {
                add$2(r.element, detail.markers.backgroundMenu);
              });
              if (!inBody(activeMenu.element)) {
                Replacing.append(container, premade(activeMenu));
              }
              remove$1(activeMenu.element, [detail.markers.backgroundMenu]);
              setActiveMenu(container, activeMenu);
              closeOthers(container, state, path);
              return Optional.some(activeMenu);
            }
          });
        });
      };
      var ExpandHighlightDecision;
      (function (ExpandHighlightDecision) {
        ExpandHighlightDecision[ExpandHighlightDecision['HighlightSubmenu'] = 0] = 'HighlightSubmenu';
        ExpandHighlightDecision[ExpandHighlightDecision['HighlightParent'] = 1] = 'HighlightParent';
      }(ExpandHighlightDecision || (ExpandHighlightDecision = {})));
      var buildIfRequired = function (container, menuName, menuPrep) {
        if (menuPrep.type === 'notbuilt') {
          var menu = container.getSystem().build(menuPrep.nbMenu());
          layeredState.setMenuBuilt(menuName, menu);
          return menu;
        } else {
          return menuPrep.menu;
        }
      };
      var expandRight = function (container, item, decision) {
        if (decision === void 0) {
          decision = ExpandHighlightDecision.HighlightSubmenu;
        }
        if (item.hasConfigured(Disabling) && Disabling.isDisabled(item)) {
          return Optional.some(item);
        } else {
          var value = getItemValue(item);
          return layeredState.expand(value).bind(function (path) {
            updateAriaExpansions(container, path);
            return Optional.from(path[0]).bind(function (menuName) {
              return layeredState.lookupMenu(menuName).bind(function (activeMenuPrep) {
                var activeMenu = buildIfRequired(container, menuName, activeMenuPrep);
                if (!inBody(activeMenu.element)) {
                  Replacing.append(container, premade(activeMenu));
                }
                detail.onOpenSubmenu(container, item, activeMenu, reverse(path));
                if (decision === ExpandHighlightDecision.HighlightSubmenu) {
                  Highlighting.highlightFirst(activeMenu);
                  return updateMenuPath(container, layeredState, path);
                } else {
                  Highlighting.dehighlightAll(activeMenu);
                  return Optional.some(item);
                }
              });
            });
          });
        }
      };
      var collapseLeft = function (container, item) {
        var value = getItemValue(item);
        return layeredState.collapse(value).bind(function (path) {
          updateAriaExpansions(container, path);
          return updateMenuPath(container, layeredState, path).map(function (activeMenu) {
            detail.onCollapseMenu(container, item, activeMenu);
            return activeMenu;
          });
        });
      };
      var updateView = function (container, item) {
        var value = getItemValue(item);
        return layeredState.refresh(value).bind(function (path) {
          updateAriaExpansions(container, path);
          return updateMenuPath(container, layeredState, path);
        });
      };
      var onRight = function (container, item) {
        return inside(item.element) ? Optional.none() : expandRight(container, item, ExpandHighlightDecision.HighlightSubmenu);
      };
      var onLeft = function (container, item) {
        return inside(item.element) ? Optional.none() : collapseLeft(container, item);
      };
      var onEscape = function (container, item) {
        return collapseLeft(container, item).orThunk(function () {
          return detail.onEscape(container, item).map(function () {
            return container;
          });
        });
      };
      var keyOnItem = function (f) {
        return function (container, simulatedEvent) {
          return closest$1(simulatedEvent.getSource(), '.' + detail.markers.item).bind(function (target) {
            return container.getSystem().getByDom(target).toOptional().bind(function (item) {
              return f(container, item).map(always);
            });
          });
        };
      };
      var events = derive$2([
        run$1(focus(), function (sandbox, simulatedEvent) {
          var item = simulatedEvent.event.item;
          layeredState.lookupItem(getItemValue(item)).each(function () {
            var menu = simulatedEvent.event.menu;
            Highlighting.highlight(sandbox, menu);
            var value = getItemValue(simulatedEvent.event.item);
            layeredState.refresh(value).each(function (path) {
              return closeOthers(sandbox, layeredState, path);
            });
          });
        }),
        runOnExecute$1(function (component, simulatedEvent) {
          var target = simulatedEvent.event.target;
          component.getSystem().getByDom(target).each(function (item) {
            var itemValue = getItemValue(item);
            if (itemValue.indexOf('collapse-item') === 0) {
              collapseLeft(component, item);
            }
            expandRight(component, item, ExpandHighlightDecision.HighlightSubmenu).fold(function () {
              detail.onExecute(component, item);
            }, noop);
          });
        }),
        runOnAttached(function (container, _simulatedEvent) {
          setup(container).each(function (primary) {
            Replacing.append(container, premade(primary));
            detail.onOpenMenu(container, primary);
            if (detail.highlightImmediately) {
              setActiveMenu(container, primary);
            }
          });
        })
      ].concat(detail.navigateOnHover ? [run$1(hover(), function (sandbox, simulatedEvent) {
          var item = simulatedEvent.event.item;
          updateView(sandbox, item);
          expandRight(sandbox, item, ExpandHighlightDecision.HighlightParent);
          detail.onHover(sandbox, item);
        })] : []));
      var getActiveItem = function (container) {
        return Highlighting.getHighlighted(container).bind(Highlighting.getHighlighted);
      };
      var collapseMenuApi = function (container) {
        getActiveItem(container).each(function (currentItem) {
          collapseLeft(container, currentItem);
        });
      };
      var highlightPrimary = function (container) {
        layeredState.getPrimary().each(function (primary) {
          setActiveMenu(container, primary);
        });
      };
      var extractMenuFromContainer = function (container) {
        return Optional.from(container.components()[0]).filter(function (comp) {
          return get$d(comp.element, 'role') === 'menu';
        });
      };
      var repositionMenus = function (container) {
        var maybeActivePrimary = layeredState.getPrimary().bind(function (primary) {
          return getActiveItem(container).bind(function (currentItem) {
            var itemValue = getItemValue(currentItem);
            var allMenus = values(layeredState.getMenus());
            var preparedMenus = cat(map$2(allMenus, LayeredState.extractPreparedMenu));
            return layeredState.getTriggeringPath(itemValue, function (v) {
              return getItemByValue(container, preparedMenus, v);
            });
          }).map(function (triggeringPath) {
            return {
              primary: primary,
              triggeringPath: triggeringPath
            };
          });
        });
        maybeActivePrimary.fold(function () {
          extractMenuFromContainer(container).each(function (primaryMenu) {
            detail.onRepositionMenu(container, primaryMenu, []);
          });
        }, function (_a) {
          var primary = _a.primary, triggeringPath = _a.triggeringPath;
          detail.onRepositionMenu(container, primary, triggeringPath);
        });
      };
      var apis = {
        collapseMenu: collapseMenuApi,
        highlightPrimary: highlightPrimary,
        repositionMenus: repositionMenus
      };
      return {
        uid: detail.uid,
        dom: detail.dom,
        markers: detail.markers,
        behaviours: augment(detail.tmenuBehaviours, [
          Keying.config({
            mode: 'special',
            onRight: keyOnItem(onRight),
            onLeft: keyOnItem(onLeft),
            onEscape: keyOnItem(onEscape),
            focusIn: function (container, _keyInfo) {
              layeredState.getPrimary().each(function (primary) {
                dispatch(container, primary.element, focusItem());
              });
            }
          }),
          Highlighting.config({
            highlightClass: detail.markers.selectedMenu,
            itemClass: detail.markers.menu
          }),
          Composing.config({
            find: function (container) {
              return Highlighting.getHighlighted(container);
            }
          }),
          Replacing.config({})
        ]),
        eventOrder: detail.eventOrder,
        apis: apis,
        events: events
      };
    };
    var collapseItem$1 = constant$1('collapse-item');

    var tieredData = function (primary, menus, expansions) {
      return {
        primary: primary,
        menus: menus,
        expansions: expansions
      };
    };
    var singleData = function (name, menu) {
      return {
        primary: name,
        menus: wrap$1(name, menu),
        expansions: {}
      };
    };
    var collapseItem = function (text) {
      return {
        value: generate$6(collapseItem$1()),
        meta: { text: text }
      };
    };
    var tieredMenu = single({
      name: 'TieredMenu',
      configFields: [
        onStrictKeyboardHandler('onExecute'),
        onStrictKeyboardHandler('onEscape'),
        onStrictHandler('onOpenMenu'),
        onStrictHandler('onOpenSubmenu'),
        onHandler('onRepositionMenu'),
        onHandler('onCollapseMenu'),
        defaulted('highlightImmediately', true),
        requiredObjOf('data', [
          required$1('primary'),
          required$1('menus'),
          required$1('expansions')
        ]),
        defaulted('fakeFocus', false),
        onHandler('onHighlight'),
        onHandler('onHover'),
        tieredMenuMarkers(),
        required$1('dom'),
        defaulted('navigateOnHover', true),
        defaulted('stayInDom', false),
        field('tmenuBehaviours', [
          Keying,
          Highlighting,
          Composing,
          Replacing
        ]),
        defaulted('eventOrder', {})
      ],
      apis: {
        collapseMenu: function (apis, tmenu) {
          apis.collapseMenu(tmenu);
        },
        highlightPrimary: function (apis, tmenu) {
          apis.highlightPrimary(tmenu);
        },
        repositionMenus: function (apis, tmenu) {
          apis.repositionMenus(tmenu);
        }
      },
      factory: make$6,
      extraApis: {
        tieredData: tieredData,
        singleData: singleData,
        collapseItem: collapseItem
      }
    });

    var makeMenu = function (detail, menuSandbox, placementSpec, menuSpec, getBounds) {
      var lazySink = function () {
        return detail.lazySink(menuSandbox);
      };
      var layouts = menuSpec.type === 'horizontal' ? {
        layouts: {
          onLtr: function () {
            return belowOrAbove();
          },
          onRtl: function () {
            return belowOrAboveRtl();
          }
        }
      } : {};
      var isFirstTierSubmenu = function (triggeringPaths) {
        return triggeringPaths.length === 2;
      };
      var getSubmenuLayouts = function (triggeringPaths) {
        return isFirstTierSubmenu(triggeringPaths) ? layouts : {};
      };
      return tieredMenu.sketch({
        dom: { tag: 'div' },
        data: menuSpec.data,
        markers: menuSpec.menu.markers,
        highlightImmediately: menuSpec.menu.highlightImmediately,
        onEscape: function () {
          Sandboxing.close(menuSandbox);
          detail.onEscape.map(function (handler) {
            return handler(menuSandbox);
          });
          return Optional.some(true);
        },
        onExecute: function () {
          return Optional.some(true);
        },
        onOpenMenu: function (tmenu, menu) {
          Positioning.positionWithinBounds(lazySink().getOrDie(), menu, placementSpec, getBounds());
        },
        onOpenSubmenu: function (tmenu, item, submenu, triggeringPaths) {
          var sink = lazySink().getOrDie();
          Positioning.position(sink, submenu, {
            anchor: __assign({
              type: 'submenu',
              item: item
            }, getSubmenuLayouts(triggeringPaths))
          });
        },
        onRepositionMenu: function (tmenu, primaryMenu, submenuTriggers) {
          var sink = lazySink().getOrDie();
          Positioning.positionWithinBounds(sink, primaryMenu, placementSpec, getBounds());
          each$1(submenuTriggers, function (st) {
            var submenuLayouts = getSubmenuLayouts(st.triggeringPath);
            Positioning.position(sink, st.triggeredMenu, {
              anchor: __assign({
                type: 'submenu',
                item: st.triggeringItem
              }, submenuLayouts)
            });
          });
        }
      });
    };
    var factory$m = function (detail, spec) {
      var isPartOfRelated = function (sandbox, queryElem) {
        var related = detail.getRelated(sandbox);
        return related.exists(function (rel) {
          return isPartOf$1(rel, queryElem);
        });
      };
      var setContent = function (sandbox, thing) {
        Sandboxing.setContent(sandbox, thing);
      };
      var showAt = function (sandbox, thing, placementSpec) {
        showWithin(sandbox, thing, placementSpec, Optional.none());
      };
      var showWithin = function (sandbox, thing, placementSpec, boxElement) {
        showWithinBounds(sandbox, thing, placementSpec, function () {
          return boxElement.map(function (elem) {
            return box$1(elem);
          });
        });
      };
      var showWithinBounds = function (sandbox, thing, placementSpec, getBounds) {
        var sink = detail.lazySink(sandbox).getOrDie();
        Sandboxing.openWhileCloaked(sandbox, thing, function () {
          return Positioning.positionWithinBounds(sink, sandbox, placementSpec, getBounds());
        });
        Representing.setValue(sandbox, Optional.some({
          mode: 'position',
          config: placementSpec,
          getBounds: getBounds
        }));
      };
      var showMenuAt = function (sandbox, placementSpec, menuSpec) {
        showMenuWithinBounds(sandbox, placementSpec, menuSpec, Optional.none);
      };
      var showMenuWithinBounds = function (sandbox, placementSpec, menuSpec, getBounds) {
        var menu = makeMenu(detail, sandbox, placementSpec, menuSpec, getBounds);
        Sandboxing.open(sandbox, menu);
        Representing.setValue(sandbox, Optional.some({
          mode: 'menu',
          menu: menu
        }));
      };
      var hide = function (sandbox) {
        if (Sandboxing.isOpen(sandbox)) {
          Representing.setValue(sandbox, Optional.none());
          Sandboxing.close(sandbox);
        }
      };
      var getContent = function (sandbox) {
        return Sandboxing.getState(sandbox);
      };
      var reposition = function (sandbox) {
        if (Sandboxing.isOpen(sandbox)) {
          Representing.getValue(sandbox).each(function (state) {
            switch (state.mode) {
            case 'menu':
              Sandboxing.getState(sandbox).each(tieredMenu.repositionMenus);
              break;
            case 'position':
              var sink = detail.lazySink(sandbox).getOrDie();
              Positioning.positionWithinBounds(sink, sandbox, state.config, state.getBounds());
              break;
            }
          });
        }
      };
      var apis = {
        setContent: setContent,
        showAt: showAt,
        showWithin: showWithin,
        showWithinBounds: showWithinBounds,
        showMenuAt: showMenuAt,
        showMenuWithinBounds: showMenuWithinBounds,
        hide: hide,
        getContent: getContent,
        reposition: reposition,
        isOpen: Sandboxing.isOpen
      };
      return {
        uid: detail.uid,
        dom: detail.dom,
        behaviours: augment(detail.inlineBehaviours, [
          Sandboxing.config({
            isPartOf: function (sandbox, data, queryElem) {
              return isPartOf$1(data, queryElem) || isPartOfRelated(sandbox, queryElem);
            },
            getAttachPoint: function (sandbox) {
              return detail.lazySink(sandbox).getOrDie();
            },
            onOpen: function (sandbox) {
              detail.onShow(sandbox);
            },
            onClose: function (sandbox) {
              detail.onHide(sandbox);
            }
          }),
          Representing.config({
            store: {
              mode: 'memory',
              initialValue: Optional.none()
            }
          }),
          Receiving.config({
            channels: __assign(__assign({}, receivingChannel$1(__assign({ isExtraPart: spec.isExtraPart }, detail.fireDismissalEventInstead.map(function (fe) {
              return { fireEventInstead: { event: fe.event } };
            }).getOr({})))), receivingChannel(__assign(__assign({}, detail.fireRepositionEventInstead.map(function (fe) {
              return { fireEventInstead: { event: fe.event } };
            }).getOr({})), { doReposition: reposition })))
          })
        ]),
        eventOrder: detail.eventOrder,
        apis: apis
      };
    };
    var InlineView = single({
      name: 'InlineView',
      configFields: [
        required$1('lazySink'),
        onHandler('onShow'),
        onHandler('onHide'),
        optionFunction('onEscape'),
        field('inlineBehaviours', [
          Sandboxing,
          Representing,
          Receiving
        ]),
        optionObjOf('fireDismissalEventInstead', [defaulted('event', dismissRequested())]),
        optionObjOf('fireRepositionEventInstead', [defaulted('event', repositionRequested())]),
        defaulted('getRelated', Optional.none),
        defaulted('isExtraPart', never),
        defaulted('eventOrder', Optional.none)
      ],
      factory: factory$m,
      apis: {
        showAt: function (apis, component, anchor, thing) {
          apis.showAt(component, anchor, thing);
        },
        showWithin: function (apis, component, anchor, thing, boxElement) {
          apis.showWithin(component, anchor, thing, boxElement);
        },
        showWithinBounds: function (apis, component, anchor, thing, bounds) {
          apis.showWithinBounds(component, anchor, thing, bounds);
        },
        showMenuAt: function (apis, component, anchor, menuSpec) {
          apis.showMenuAt(component, anchor, menuSpec);
        },
        showMenuWithinBounds: function (apis, component, anchor, menuSpec, bounds) {
          apis.showMenuWithinBounds(component, anchor, menuSpec, bounds);
        },
        hide: function (apis, component) {
          apis.hide(component);
        },
        isOpen: function (apis, component) {
          return apis.isOpen(component);
        },
        getContent: function (apis, component) {
          return apis.getContent(component);
        },
        setContent: function (apis, component, thing) {
          apis.setContent(component, thing);
        },
        reposition: function (apis, component) {
          apis.reposition(component);
        }
      }
    });

    var labelPrefix = 'layout-inset';
    var westEdgeX = function (anchor) {
      return anchor.x;
    };
    var middleX = function (anchor, element) {
      return anchor.x + anchor.width / 2 - element.width / 2;
    };
    var eastEdgeX = function (anchor, element) {
      return anchor.x + anchor.width - element.width;
    };
    var northY = function (anchor) {
      return anchor.y;
    };
    var southY = function (anchor, element) {
      return anchor.y + anchor.height - element.height;
    };
    var centreY = function (anchor, element) {
      return anchor.y + anchor.height / 2 - element.height / 2;
    };
    var southwest = function (anchor, element, bubbles) {
      return nu$6(eastEdgeX(anchor, element), southY(anchor, element), bubbles.insetSouthwest(), northwest$3(), 'southwest', boundsRestriction(anchor, {
        right: 0,
        bottom: 3
      }), labelPrefix);
    };
    var southeast = function (anchor, element, bubbles) {
      return nu$6(westEdgeX(anchor), southY(anchor, element), bubbles.insetSoutheast(), northeast$3(), 'southeast', boundsRestriction(anchor, {
        left: 1,
        bottom: 3
      }), labelPrefix);
    };
    var northwest = function (anchor, element, bubbles) {
      return nu$6(eastEdgeX(anchor, element), northY(anchor), bubbles.insetNorthwest(), southwest$3(), 'northwest', boundsRestriction(anchor, {
        right: 0,
        top: 2
      }), labelPrefix);
    };
    var northeast = function (anchor, element, bubbles) {
      return nu$6(westEdgeX(anchor), northY(anchor), bubbles.insetNortheast(), southeast$3(), 'northeast', boundsRestriction(anchor, {
        left: 1,
        top: 2
      }), labelPrefix);
    };
    var north = function (anchor, element, bubbles) {
      return nu$6(middleX(anchor, element), northY(anchor), bubbles.insetNorth(), south$3(), 'north', boundsRestriction(anchor, { top: 2 }), labelPrefix);
    };
    var south = function (anchor, element, bubbles) {
      return nu$6(middleX(anchor, element), southY(anchor, element), bubbles.insetSouth(), north$3(), 'south', boundsRestriction(anchor, { bottom: 3 }), labelPrefix);
    };
    var east = function (anchor, element, bubbles) {
      return nu$6(eastEdgeX(anchor, element), centreY(anchor, element), bubbles.insetEast(), west$3(), 'east', boundsRestriction(anchor, { right: 0 }), labelPrefix);
    };
    var west = function (anchor, element, bubbles) {
      return nu$6(westEdgeX(anchor), centreY(anchor, element), bubbles.insetWest(), east$3(), 'west', boundsRestriction(anchor, { left: 1 }), labelPrefix);
    };
    var lookupPreserveLayout = function (lastPlacement) {
      switch (lastPlacement) {
      case 'north':
        return north;
      case 'northeast':
        return northeast;
      case 'northwest':
        return northwest;
      case 'south':
        return south;
      case 'southeast':
        return southeast;
      case 'southwest':
        return southwest;
      case 'east':
        return east;
      case 'west':
        return west;
      }
    };
    var preserve = function (anchor, element, bubbles, placee, bounds) {
      var layout = getPlacement(placee).map(lookupPreserveLayout).getOr(north);
      return layout(anchor, element, bubbles, placee, bounds);
    };
    var lookupFlippedLayout = function (lastPlacement) {
      switch (lastPlacement) {
      case 'north':
        return south;
      case 'northeast':
        return southeast;
      case 'northwest':
        return southwest;
      case 'south':
        return north;
      case 'southeast':
        return northeast;
      case 'southwest':
        return northwest;
      case 'east':
        return west;
      case 'west':
        return east;
      }
    };
    var flip$2 = function (anchor, element, bubbles, placee, bounds) {
      var layout = getPlacement(placee).map(lookupFlippedLayout).getOr(north);
      return layout(anchor, element, bubbles, placee, bounds);
    };

    var global$f = tinymce.util.Tools.resolve('tinymce.util.Delay');

    var factory$l = function (detail) {
      var events = events$a(detail.action);
      var tag = detail.dom.tag;
      var lookupAttr = function (attr) {
        return get$e(detail.dom, 'attributes').bind(function (attrs) {
          return get$e(attrs, attr);
        });
      };
      var getModAttributes = function () {
        if (tag === 'button') {
          var type = lookupAttr('type').getOr('button');
          var roleAttrs = lookupAttr('role').map(function (role) {
            return { role: role };
          }).getOr({});
          return __assign({ type: type }, roleAttrs);
        } else {
          var role = lookupAttr('role').getOr('button');
          return { role: role };
        }
      };
      return {
        uid: detail.uid,
        dom: detail.dom,
        components: detail.components,
        events: events,
        behaviours: SketchBehaviours.augment(detail.buttonBehaviours, [
          Focusing.config({}),
          Keying.config({
            mode: 'execution',
            useSpace: true,
            useEnter: true
          })
        ]),
        domModification: { attributes: getModAttributes() },
        eventOrder: detail.eventOrder
      };
    };
    var Button = single({
      name: 'Button',
      factory: factory$l,
      configFields: [
        defaulted('uid', undefined),
        required$1('dom'),
        defaulted('components', []),
        SketchBehaviours.field('buttonBehaviours', [
          Focusing,
          Keying
        ]),
        option('action'),
        option('role'),
        defaulted('eventOrder', {})
      ]
    });

    var record = function (spec) {
      var uid = isSketchSpec(spec) && hasNonNullableKey(spec, 'uid') ? spec.uid : generate$5('memento');
      var get = function (anyInSystem) {
        return anyInSystem.getSystem().getByUid(uid).getOrDie();
      };
      var getOpt = function (anyInSystem) {
        return anyInSystem.getSystem().getByUid(uid).toOptional();
      };
      var asSpec = function () {
        return __assign(__assign({}, spec), { uid: uid });
      };
      return {
        get: get,
        getOpt: getOpt,
        asSpec: asSpec
      };
    };

    var global$e = tinymce.util.Tools.resolve('tinymce.util.I18n');

    var rtlTransform = {
      'indent': true,
      'outdent': true,
      'table-insert-column-after': true,
      'table-insert-column-before': true,
      'paste-column-after': true,
      'paste-column-before': true,
      'unordered-list': true,
      'list-bull-circle': true,
      'list-bull-default': true,
      'list-bull-square': true
    };
    var defaultIconName = 'temporary-placeholder';
    var defaultIcon = function (icons) {
      return function () {
        return get$e(icons, defaultIconName).getOr('!not found!');
      };
    };
    var getIconName = function (name, icons) {
      var lcName = name.toLowerCase();
      if (global$e.isRtl()) {
        var rtlName = ensureTrailing(lcName, '-rtl');
        return has$2(icons, rtlName) ? rtlName : lcName;
      } else {
        return lcName;
      }
    };
    var lookupIcon = function (name, icons) {
      return get$e(icons, getIconName(name, icons));
    };
    var get$1 = function (name, iconProvider) {
      var icons = iconProvider();
      return lookupIcon(name, icons).getOrThunk(defaultIcon(icons));
    };
    var getOr = function (name, iconProvider, fallbackIcon) {
      var icons = iconProvider();
      return lookupIcon(name, icons).or(fallbackIcon).getOrThunk(defaultIcon(icons));
    };
    var needsRtlTransform = function (iconName) {
      return global$e.isRtl() ? has$2(rtlTransform, iconName) : false;
    };
    var addFocusableBehaviour = function () {
      return config('add-focusable', [runOnAttached(function (comp) {
          child(comp.element, 'svg').each(function (svg) {
            return set$8(svg, 'focusable', 'false');
          });
        })]);
    };
    var renderIcon$2 = function (spec, iconName, icons, fallbackIcon) {
      var _a, _b;
      var rtlIconClasses = needsRtlTransform(iconName) ? ['tox-icon--flip'] : [];
      var iconHtml = get$e(icons, getIconName(iconName, icons)).or(fallbackIcon).getOrThunk(defaultIcon(icons));
      return {
        dom: {
          tag: spec.tag,
          attributes: (_a = spec.attributes) !== null && _a !== void 0 ? _a : {},
          classes: spec.classes.concat(rtlIconClasses),
          innerHtml: iconHtml
        },
        behaviours: derive$1(__spreadArray(__spreadArray([], (_b = spec.behaviours) !== null && _b !== void 0 ? _b : [], true), [addFocusableBehaviour()], false))
      };
    };
    var render$3 = function (iconName, spec, iconProvider, fallbackIcon) {
      if (fallbackIcon === void 0) {
        fallbackIcon = Optional.none();
      }
      return renderIcon$2(spec, iconName, iconProvider(), fallbackIcon);
    };
    var renderFirst = function (iconNames, spec, iconProvider) {
      var icons = iconProvider();
      var iconName = find$5(iconNames, function (name) {
        return has$2(icons, getIconName(name, icons));
      });
      return renderIcon$2(spec, iconName.getOr(defaultIconName), icons, Optional.none());
    };

    var notificationIconMap = {
      success: 'checkmark',
      error: 'warning',
      err: 'error',
      warning: 'warning',
      warn: 'warning',
      info: 'info'
    };
    var factory$k = function (detail) {
      var memBannerText = record({
        dom: {
          tag: 'p',
          innerHtml: detail.translationProvider(detail.text)
        },
        behaviours: derive$1([Replacing.config({})])
      });
      var renderPercentBar = function (percent) {
        return {
          dom: {
            tag: 'div',
            classes: ['tox-bar'],
            attributes: { style: 'width: ' + percent + '%' }
          }
        };
      };
      var renderPercentText = function (percent) {
        return {
          dom: {
            tag: 'div',
            classes: ['tox-text'],
            innerHtml: percent + '%'
          }
        };
      };
      var memBannerProgress = record({
        dom: {
          tag: 'div',
          classes: detail.progress ? [
            'tox-progress-bar',
            'tox-progress-indicator'
          ] : ['tox-progress-bar']
        },
        components: [
          {
            dom: {
              tag: 'div',
              classes: ['tox-bar-container']
            },
            components: [renderPercentBar(0)]
          },
          renderPercentText(0)
        ],
        behaviours: derive$1([Replacing.config({})])
      });
      var updateProgress = function (comp, percent) {
        if (comp.getSystem().isConnected()) {
          memBannerProgress.getOpt(comp).each(function (progress) {
            Replacing.set(progress, [
              {
                dom: {
                  tag: 'div',
                  classes: ['tox-bar-container']
                },
                components: [renderPercentBar(percent)]
              },
              renderPercentText(percent)
            ]);
          });
        }
      };
      var updateText = function (comp, text$1) {
        if (comp.getSystem().isConnected()) {
          var banner = memBannerText.get(comp);
          Replacing.set(banner, [text(text$1)]);
        }
      };
      var apis = {
        updateProgress: updateProgress,
        updateText: updateText
      };
      var iconChoices = flatten([
        detail.icon.toArray(),
        detail.level.toArray(),
        detail.level.bind(function (level) {
          return Optional.from(notificationIconMap[level]);
        }).toArray()
      ]);
      var memButton = record(Button.sketch({
        dom: {
          tag: 'button',
          classes: [
            'tox-notification__dismiss',
            'tox-button',
            'tox-button--naked',
            'tox-button--icon'
          ]
        },
        components: [render$3('close', {
            tag: 'div',
            classes: ['tox-icon'],
            attributes: { 'aria-label': detail.translationProvider('Close') }
          }, detail.iconProvider)],
        action: function (comp) {
          detail.onAction(comp);
        }
      }));
      var notificationIconSpec = renderFirst(iconChoices, {
        tag: 'div',
        classes: ['tox-notification__icon']
      }, detail.iconProvider);
      var notificationBodySpec = {
        dom: {
          tag: 'div',
          classes: ['tox-notification__body']
        },
        components: [memBannerText.asSpec()],
        behaviours: derive$1([Replacing.config({})])
      };
      var components = [
        notificationIconSpec,
        notificationBodySpec
      ];
      return {
        uid: detail.uid,
        dom: {
          tag: 'div',
          attributes: { role: 'alert' },
          classes: detail.level.map(function (level) {
            return [
              'tox-notification',
              'tox-notification--in',
              'tox-notification--' + level
            ];
          }).getOr([
            'tox-notification',
            'tox-notification--in'
          ])
        },
        behaviours: derive$1([
          Focusing.config({}),
          config('notification-events', [run$1(focusin(), function (comp) {
              memButton.getOpt(comp).each(Focusing.focus);
            })])
        ]),
        components: components.concat(detail.progress ? [memBannerProgress.asSpec()] : []).concat(!detail.closeButton ? [] : [memButton.asSpec()]),
        apis: apis
      };
    };
    var Notification = single({
      name: 'Notification',
      factory: factory$k,
      configFields: [
        option('level'),
        required$1('progress'),
        required$1('icon'),
        required$1('onAction'),
        required$1('text'),
        required$1('iconProvider'),
        required$1('translationProvider'),
        defaultedBoolean('closeButton', true)
      ],
      apis: {
        updateProgress: function (apis, comp, percent) {
          apis.updateProgress(comp, percent);
        },
        updateText: function (apis, comp, text) {
          apis.updateText(comp, text);
        }
      }
    });

    function NotificationManagerImpl (editor, extras, uiMothership) {
      var sharedBackstage = extras.backstage.shared;
      var getLayoutDirection = function (rel) {
        switch (rel) {
        case 'bc-bc':
          return south;
        case 'tc-tc':
          return north;
        case 'tc-bc':
          return north$2;
        case 'bc-tc':
        default:
          return south$2;
        }
      };
      var reposition = function (notifications) {
        if (notifications.length > 0) {
          each$1(notifications, function (notification, index) {
            if (index === 0) {
              notification.moveRel(null, 'banner');
            } else {
              notification.moveRel(notifications[index - 1].getEl(), 'bc-tc');
            }
          });
        }
      };
      var open = function (settings, closeCallback) {
        var hideCloseButton = !settings.closeButton && settings.timeout && (settings.timeout > 0 || settings.timeout < 0);
        var close = function () {
          closeCallback();
          InlineView.hide(notificationWrapper);
        };
        var notification = build$1(Notification.sketch({
          text: settings.text,
          level: contains$2([
            'success',
            'error',
            'warning',
            'warn',
            'info'
          ], settings.type) ? settings.type : undefined,
          progress: settings.progressBar === true,
          icon: Optional.from(settings.icon),
          closeButton: !hideCloseButton,
          onAction: close,
          iconProvider: sharedBackstage.providers.icons,
          translationProvider: sharedBackstage.providers.translate
        }));
        var notificationWrapper = build$1(InlineView.sketch(__assign({
          dom: {
            tag: 'div',
            classes: ['tox-notifications-container']
          },
          lazySink: sharedBackstage.getSink,
          fireDismissalEventInstead: {}
        }, sharedBackstage.header.isPositionedAtTop() ? {} : { fireRepositionEventInstead: {} })));
        uiMothership.add(notificationWrapper);
        if (settings.timeout > 0) {
          global$f.setTimeout(function () {
            close();
          }, settings.timeout);
        }
        var getBounds = function () {
          var contentArea = box$1(SugarElement.fromDom(editor.getContentAreaContainer()));
          var win$1 = win();
          var x = clamp$1(win$1.x, contentArea.x, contentArea.right);
          var y = clamp$1(win$1.y, contentArea.y, contentArea.bottom);
          var right = Math.max(contentArea.right, win$1.right);
          var bottom = Math.max(contentArea.bottom, win$1.bottom);
          return Optional.some(bounds(x, y, right - x, bottom - y));
        };
        return {
          close: close,
          moveTo: function (x, y) {
            InlineView.showAt(notificationWrapper, premade(notification), {
              anchor: {
                type: 'makeshift',
                x: x,
                y: y
              }
            });
          },
          moveRel: function (element, rel) {
            var notificationSpec = premade(notification);
            var anchorOverrides = { maxHeightFunction: expandable$1() };
            if (rel !== 'banner' && isNonNullable(element)) {
              var layoutDirection_1 = getLayoutDirection(rel);
              var nodeAnchor = {
                type: 'node',
                root: body(),
                node: Optional.some(SugarElement.fromDom(element)),
                overrides: anchorOverrides,
                layouts: {
                  onRtl: function () {
                    return [layoutDirection_1];
                  },
                  onLtr: function () {
                    return [layoutDirection_1];
                  }
                }
              };
              InlineView.showWithinBounds(notificationWrapper, notificationSpec, { anchor: nodeAnchor }, getBounds);
            } else {
              var anchor = __assign(__assign({}, sharedBackstage.anchors.banner()), { overrides: anchorOverrides });
              InlineView.showWithinBounds(notificationWrapper, notificationSpec, { anchor: anchor }, getBounds);
            }
          },
          text: function (nuText) {
            Notification.updateText(notification, nuText);
          },
          settings: settings,
          getEl: function () {
            return notification.element.dom;
          },
          progressBar: {
            value: function (percent) {
              Notification.updateProgress(notification, percent);
            }
          }
        };
      };
      var close = function (notification) {
        notification.close();
      };
      var getArgs = function (notification) {
        return notification.settings;
      };
      return {
        open: open,
        close: close,
        reposition: reposition,
        getArgs: getArgs
      };
    }

    var first = function (fn, rate) {
      var timer = null;
      var cancel = function () {
        if (!isNull(timer)) {
          clearTimeout(timer);
          timer = null;
        }
      };
      var throttle = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        if (isNull(timer)) {
          timer = setTimeout(function () {
            timer = null;
            fn.apply(null, args);
          }, rate);
        }
      };
      return {
        cancel: cancel,
        throttle: throttle
      };
    };
    var last = function (fn, rate) {
      var timer = null;
      var cancel = function () {
        if (!isNull(timer)) {
          clearTimeout(timer);
          timer = null;
        }
      };
      var throttle = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        cancel();
        timer = setTimeout(function () {
          timer = null;
          fn.apply(null, args);
        }, rate);
      };
      return {
        cancel: cancel,
        throttle: throttle
      };
    };

    var global$d = tinymce.util.Tools.resolve('tinymce.dom.TextSeeker');

    var isBoundary = function (dom, node) {
      return dom.isBlock(node) || contains$2([
        'BR',
        'IMG',
        'HR',
        'INPUT'
      ], node.nodeName) || dom.getContentEditable(node) === 'false';
    };
    var repeatLeft = function (dom, node, offset, process, rootNode) {
      var search = global$d(dom, function (node) {
        return isBoundary(dom, node);
      });
      return Optional.from(search.backwards(node, offset, process, rootNode));
    };

    var autocompleteSelector = '[data-mce-autocompleter]';
    var create$4 = function (editor, range) {
      return detect(SugarElement.fromDom(editor.selection.getNode())).getOrThunk(function () {
        var wrapper = SugarElement.fromHtml('<span data-mce-autocompleter="1" data-mce-bogus="1"></span>', editor.getDoc());
        append$2(wrapper, SugarElement.fromDom(range.extractContents()));
        range.insertNode(wrapper.dom);
        parent(wrapper).each(function (elm) {
          return elm.dom.normalize();
        });
        last$1(wrapper).map(function (last) {
          editor.selection.setCursorLocation(last.dom, getEnd(last));
        });
        return wrapper;
      });
    };
    var detect = function (elm) {
      return closest$1(elm, autocompleteSelector);
    };

    var isValidTextRange = function (rng) {
      return rng.collapsed && rng.startContainer.nodeType === 3;
    };
    var getText = function (rng) {
      return rng.toString().replace(/\u00A0/g, ' ').replace(/\uFEFF/g, '');
    };
    var isWhitespace = function (chr) {
      return chr !== '' && ' \xA0\f\n\r\t\x0B'.indexOf(chr) !== -1;
    };

    var stripTriggerChar = function (text, triggerCh) {
      return text.substring(triggerCh.length);
    };
    var findChar = function (text, index, ch) {
      var i;
      for (i = index - 1; i >= 0; i--) {
        var char = text.charAt(i);
        if (isWhitespace(char)) {
          return Optional.none();
        }
        if (char === ch) {
          break;
        }
      }
      return Optional.some(i);
    };
    var findStart = function (dom, initRange, ch, minChars) {
      if (minChars === void 0) {
        minChars = 0;
      }
      if (!isValidTextRange(initRange)) {
        return Optional.none();
      }
      var findTriggerChIndex = function (element, offset, text) {
        return findChar(text, offset, ch).getOr(offset);
      };
      var root = dom.getParent(initRange.startContainer, dom.isBlock) || dom.getRoot();
      return repeatLeft(dom, initRange.startContainer, initRange.startOffset, findTriggerChIndex, root).bind(function (spot) {
        var range = initRange.cloneRange();
        range.setStart(spot.container, spot.offset);
        range.setEnd(initRange.endContainer, initRange.endOffset);
        if (range.collapsed) {
          return Optional.none();
        }
        var text = getText(range);
        var triggerCharIndex = text.lastIndexOf(ch);
        if (triggerCharIndex !== 0 || stripTriggerChar(text, ch).length < minChars) {
          return Optional.none();
        } else {
          return Optional.some({
            text: stripTriggerChar(text, ch),
            range: range,
            triggerChar: ch
          });
        }
      });
    };
    var getContext = function (dom, initRange, ch, minChars) {
      if (minChars === void 0) {
        minChars = 0;
      }
      return detect(SugarElement.fromDom(initRange.startContainer)).fold(function () {
        return findStart(dom, initRange, ch, minChars);
      }, function (elm) {
        var range = dom.createRng();
        range.selectNode(elm.dom);
        var text = getText(range);
        return Optional.some({
          range: range,
          text: stripTriggerChar(text, ch),
          triggerChar: ch
        });
      });
    };

    var setup$e = function (api, editor) {
      editor.on('keypress compositionend', api.onKeypress.throttle);
      editor.on('remove', api.onKeypress.cancel);
      var redirectKeyToItem = function (item, e) {
        emitWith(item, keydown(), { raw: e });
      };
      editor.on('keydown', function (e) {
        var getItem = function () {
          return api.getView().bind(Highlighting.getHighlighted);
        };
        if (e.which === 8) {
          api.onKeypress.throttle(e);
        }
        if (api.isActive()) {
          if (e.which === 27) {
            api.cancelIfNecessary();
          }
          if (api.isMenuOpen()) {
            if (e.which === 13) {
              getItem().each(emitExecute);
              e.preventDefault();
            } else if (e.which === 40) {
              getItem().fold(function () {
                api.getView().each(Highlighting.highlightFirst);
              }, function (item) {
                redirectKeyToItem(item, e);
              });
              e.preventDefault();
              e.stopImmediatePropagation();
            } else if (e.which === 37 || e.which === 38 || e.which === 39) {
              getItem().each(function (item) {
                redirectKeyToItem(item, e);
                e.preventDefault();
                e.stopImmediatePropagation();
              });
            }
          } else {
            if (e.which === 13 || e.which === 38 || e.which === 40) {
              api.cancelIfNecessary();
            }
          }
        }
      });
      editor.on('NodeChange', function (e) {
        if (api.isActive() && !api.isProcessingAction() && detect(SugarElement.fromDom(e.element)).isNone()) {
          api.cancelIfNecessary();
        }
      });
    };
    var AutocompleterEditorEvents = { setup: setup$e };

    var global$c = tinymce.util.Tools.resolve('tinymce.util.Promise');

    var point = function (container, offset) {
      return {
        container: container,
        offset: offset
      };
    };

    var isText = function (node) {
      return node.nodeType === TEXT;
    };
    var isElement$1 = function (node) {
      return node.nodeType === ELEMENT;
    };
    var toLast = function (node) {
      if (isText(node)) {
        return point(node, node.data.length);
      } else {
        var children = node.childNodes;
        return children.length > 0 ? toLast(children[children.length - 1]) : point(node, children.length);
      }
    };
    var toLeaf = function (node, offset) {
      var children = node.childNodes;
      if (children.length > 0 && offset < children.length) {
        return toLeaf(children[offset], 0);
      } else if (children.length > 0 && isElement$1(node) && children.length === offset) {
        return toLast(children[children.length - 1]);
      } else {
        return point(node, offset);
      }
    };

    var isPreviousCharContent = function (dom, leaf) {
      return repeatLeft(dom, leaf.container, leaf.offset, function (element, offset) {
        return offset === 0 ? -1 : offset;
      }, dom.getRoot()).filter(function (spot) {
        var char = spot.container.data.charAt(spot.offset - 1);
        return !isWhitespace(char);
      }).isSome();
    };
    var isStartOfWord = function (dom) {
      return function (rng) {
        var leaf = toLeaf(rng.startContainer, rng.startOffset);
        return !isPreviousCharContent(dom, leaf);
      };
    };
    var getTriggerContext = function (dom, initRange, database) {
      return findMap(database.triggerChars, function (ch) {
        return getContext(dom, initRange, ch);
      });
    };
    var lookup$2 = function (editor, getDatabase) {
      var database = getDatabase();
      var rng = editor.selection.getRng();
      return getTriggerContext(editor.dom, rng, database).bind(function (context) {
        return lookupWithContext(editor, getDatabase, context);
      });
    };
    var lookupWithContext = function (editor, getDatabase, context, fetchOptions) {
      if (fetchOptions === void 0) {
        fetchOptions = {};
      }
      var database = getDatabase();
      var rng = editor.selection.getRng();
      var startText = rng.startContainer.nodeValue;
      var autocompleters = filter$2(database.lookupByChar(context.triggerChar), function (autocompleter) {
        return context.text.length >= autocompleter.minChars && autocompleter.matches.getOrThunk(function () {
          return isStartOfWord(editor.dom);
        })(context.range, startText, context.text);
      });
      if (autocompleters.length === 0) {
        return Optional.none();
      }
      var lookupData = global$c.all(map$2(autocompleters, function (ac) {
        var fetchResult = ac.fetch(context.text, ac.maxResults, fetchOptions);
        return fetchResult.then(function (results) {
          return {
            matchText: context.text,
            items: results,
            columns: ac.columns,
            onAction: ac.onAction,
            highlightOn: ac.highlightOn
          };
        });
      }));
      return Optional.some({
        lookupData: lookupData,
        context: context
      });
    };

    var separatorMenuItemSchema = objOf([
      requiredString('type'),
      optionString('text')
    ]);
    var createSeparatorMenuItem = function (spec) {
      return asRaw('separatormenuitem', separatorMenuItemSchema, spec);
    };

    var autocompleterItemSchema = objOf([
      defaulted('type', 'autocompleteitem'),
      defaulted('active', false),
      defaulted('disabled', false),
      defaulted('meta', {}),
      requiredString('value'),
      optionString('text'),
      optionString('icon')
    ]);
    var autocompleterSchema = objOf([
      requiredString('type'),
      requiredString('ch'),
      defaultedNumber('minChars', 1),
      defaulted('columns', 1),
      defaultedNumber('maxResults', 10),
      optionFunction('matches'),
      requiredFunction('fetch'),
      requiredFunction('onAction'),
      defaultedArrayOf('highlightOn', [], string)
    ]);
    var createSeparatorItem = function (spec) {
      return asRaw('Autocompleter.Separator', separatorMenuItemSchema, spec);
    };
    var createAutocompleterItem = function (spec) {
      return asRaw('Autocompleter.Item', autocompleterItemSchema, spec);
    };
    var createAutocompleter = function (spec) {
      return asRaw('Autocompleter', autocompleterSchema, spec);
    };

    var baseToolbarButtonFields = [
      defaultedBoolean('disabled', false),
      optionString('tooltip'),
      optionString('icon'),
      optionString('text'),
      defaultedFunction('onSetup', function () {
        return noop;
      })
    ];
    var toolbarButtonSchema = objOf([
      requiredString('type'),
      requiredFunction('onAction')
    ].concat(baseToolbarButtonFields));
    var createToolbarButton = function (spec) {
      return asRaw('toolbarbutton', toolbarButtonSchema, spec);
    };

    var baseToolbarToggleButtonFields = [defaultedBoolean('active', false)].concat(baseToolbarButtonFields);
    var toggleButtonSchema = objOf(baseToolbarToggleButtonFields.concat([
      requiredString('type'),
      requiredFunction('onAction')
    ]));
    var createToggleButton = function (spec) {
      return asRaw('ToggleButton', toggleButtonSchema, spec);
    };

    var contextBarFields = [
      defaultedFunction('predicate', never),
      defaultedStringEnum('scope', 'node', [
        'node',
        'editor'
      ]),
      defaultedStringEnum('position', 'selection', [
        'node',
        'selection',
        'line'
      ])
    ];

    var contextButtonFields = baseToolbarButtonFields.concat([
      defaulted('type', 'contextformbutton'),
      defaulted('primary', false),
      requiredFunction('onAction'),
      customField('original', identity$1)
    ]);
    var contextToggleButtonFields = baseToolbarToggleButtonFields.concat([
      defaulted('type', 'contextformbutton'),
      defaulted('primary', false),
      requiredFunction('onAction'),
      customField('original', identity$1)
    ]);
    var launchButtonFields = baseToolbarButtonFields.concat([defaulted('type', 'contextformbutton')]);
    var launchToggleButtonFields = baseToolbarToggleButtonFields.concat([defaulted('type', 'contextformtogglebutton')]);
    var toggleOrNormal = choose$1('type', {
      contextformbutton: contextButtonFields,
      contextformtogglebutton: contextToggleButtonFields
    });
    var contextFormSchema = objOf([
      defaulted('type', 'contextform'),
      defaultedFunction('initValue', constant$1('')),
      optionString('label'),
      requiredArrayOf('commands', toggleOrNormal),
      optionOf('launch', choose$1('type', {
        contextformbutton: launchButtonFields,
        contextformtogglebutton: launchToggleButtonFields
      }))
    ].concat(contextBarFields));
    var createContextForm = function (spec) {
      return asRaw('ContextForm', contextFormSchema, spec);
    };

    var contextToolbarSchema = objOf([
      defaulted('type', 'contexttoolbar'),
      requiredString('items')
    ].concat(contextBarFields));
    var createContextToolbar = function (spec) {
      return asRaw('ContextToolbar', contextToolbarSchema, spec);
    };

    var stringArray = function (a) {
      var all = {};
      each$1(a, function (key) {
        all[key] = {};
      });
      return keys(all);
    };

    var register$b = function (editor) {
      var popups = editor.ui.registry.getAll().popups;
      var dataset = map$1(popups, function (popup) {
        return createAutocompleter(popup).fold(function (err) {
          throw new Error(formatError(err));
        }, identity$1);
      });
      var triggerChars = stringArray(mapToArray(dataset, function (v) {
        return v.ch;
      }));
      var datasetValues = values(dataset);
      var lookupByChar = function (ch) {
        return filter$2(datasetValues, function (dv) {
          return dv.ch === ch;
        });
      };
      return {
        dataset: dataset,
        triggerChars: triggerChars,
        lookupByChar: lookupByChar
      };
    };

    var ItemResponse;
    (function (ItemResponse) {
      ItemResponse[ItemResponse['CLOSE_ON_EXECUTE'] = 0] = 'CLOSE_ON_EXECUTE';
      ItemResponse[ItemResponse['BUBBLE_TO_SANDBOX'] = 1] = 'BUBBLE_TO_SANDBOX';
    }(ItemResponse || (ItemResponse = {})));
    var ItemResponse$1 = ItemResponse;

    var navClass = 'tox-menu-nav__js';
    var selectableClass = 'tox-collection__item';
    var colorClass = 'tox-swatch';
    var presetClasses = {
      normal: navClass,
      color: colorClass
    };
    var tickedClass = 'tox-collection__item--enabled';
    var groupHeadingClass = 'tox-collection__group-heading';
    var iconClass = 'tox-collection__item-icon';
    var textClass = 'tox-collection__item-label';
    var accessoryClass = 'tox-collection__item-accessory';
    var caretClass = 'tox-collection__item-caret';
    var checkmarkClass = 'tox-collection__item-checkmark';
    var activeClass = 'tox-collection__item--active';
    var containerClass = 'tox-collection__item-container';
    var containerColumnClass = 'tox-collection__item-container--column';
    var containerRowClass = 'tox-collection__item-container--row';
    var containerAlignRightClass = 'tox-collection__item-container--align-right';
    var containerAlignLeftClass = 'tox-collection__item-container--align-left';
    var containerValignTopClass = 'tox-collection__item-container--valign-top';
    var containerValignMiddleClass = 'tox-collection__item-container--valign-middle';
    var containerValignBottomClass = 'tox-collection__item-container--valign-bottom';
    var classForPreset = function (presets) {
      return get$e(presetClasses, presets).getOr(navClass);
    };

    var forMenu = function (presets) {
      if (presets === 'color') {
        return 'tox-swatches';
      } else {
        return 'tox-menu';
      }
    };
    var classes = function (presets) {
      return {
        backgroundMenu: 'tox-background-menu',
        selectedMenu: 'tox-selected-menu',
        selectedItem: 'tox-collection__item--active',
        hasIcons: 'tox-menu--has-icons',
        menu: forMenu(presets),
        tieredMenu: 'tox-tiered-menu'
      };
    };

    var markers = function (presets) {
      var menuClasses = classes(presets);
      return {
        backgroundMenu: menuClasses.backgroundMenu,
        selectedMenu: menuClasses.selectedMenu,
        menu: menuClasses.menu,
        selectedItem: menuClasses.selectedItem,
        item: classForPreset(presets)
      };
    };
    var dom$1 = function (hasIcons, columns, presets) {
      var menuClasses = classes(presets);
      return {
        tag: 'div',
        classes: flatten([
          [
            menuClasses.menu,
            'tox-menu-' + columns + '-column'
          ],
          hasIcons ? [menuClasses.hasIcons] : []
        ])
      };
    };
    var components = [Menu.parts.items({})];
    var part = function (hasIcons, columns, presets) {
      var menuClasses = classes(presets);
      var d = {
        tag: 'div',
        classes: flatten([[menuClasses.tieredMenu]])
      };
      return {
        dom: d,
        markers: markers(presets)
      };
    };

    var chunk = function (rowDom, numColumns) {
      return function (items) {
        var chunks = chunk$1(items, numColumns);
        return map$2(chunks, function (c) {
          return {
            dom: rowDom,
            components: c
          };
        });
      };
    };
    var forSwatch = function (columns) {
      return {
        dom: {
          tag: 'div',
          classes: [
            'tox-menu',
            'tox-swatches-menu'
          ]
        },
        components: [{
            dom: {
              tag: 'div',
              classes: ['tox-swatches']
            },
            components: [Menu.parts.items({
                preprocess: columns !== 'auto' ? chunk({
                  tag: 'div',
                  classes: ['tox-swatches__row']
                }, columns) : identity$1
              })]
          }]
      };
    };
    var forToolbar = function (columns) {
      return {
        dom: {
          tag: 'div',
          classes: [
            'tox-menu',
            'tox-collection',
            'tox-collection--toolbar',
            'tox-collection--toolbar-lg'
          ]
        },
        components: [Menu.parts.items({
            preprocess: chunk({
              tag: 'div',
              classes: ['tox-collection__group']
            }, columns)
          })]
      };
    };
    var preprocessCollection = function (items, isSeparator) {
      var allSplits = [];
      var currentSplit = [];
      each$1(items, function (item, i) {
        if (isSeparator(item, i)) {
          if (currentSplit.length > 0) {
            allSplits.push(currentSplit);
          }
          currentSplit = [];
          if (has$2(item.dom, 'innerHtml')) {
            currentSplit.push(item);
          }
        } else {
          currentSplit.push(item);
        }
      });
      if (currentSplit.length > 0) {
        allSplits.push(currentSplit);
      }
      return map$2(allSplits, function (s) {
        return {
          dom: {
            tag: 'div',
            classes: ['tox-collection__group']
          },
          components: s
        };
      });
    };
    var forCollection = function (columns, initItems, _hasIcons) {
      return {
        dom: {
          tag: 'div',
          classes: [
            'tox-menu',
            'tox-collection'
          ].concat(columns === 1 ? ['tox-collection--list'] : ['tox-collection--grid'])
        },
        components: [Menu.parts.items({
            preprocess: function (items) {
              if (columns !== 'auto' && columns > 1) {
                return chunk({
                  tag: 'div',
                  classes: ['tox-collection__group']
                }, columns)(items);
              } else {
                return preprocessCollection(items, function (_item, i) {
                  return initItems[i].type === 'separator';
                });
              }
            }
          })]
      };
    };
    var forHorizontalCollection = function (initItems, _hasIcons) {
      return {
        dom: {
          tag: 'div',
          classes: [
            'tox-collection',
            'tox-collection--horizontal'
          ]
        },
        components: [Menu.parts.items({
            preprocess: function (items) {
              return preprocessCollection(items, function (_item, i) {
                return initItems[i].type === 'separator';
              });
            }
          })]
      };
    };

    var menuHasIcons = function (xs) {
      return exists(xs, function (item) {
        return 'icon' in item && item.icon !== undefined;
      });
    };
    var handleError = function (error) {
      console.error(formatError(error));
      console.log(error);
      return Optional.none();
    };
    var createHorizontalPartialMenuWithAlloyItems = function (value, _hasIcons, items, _columns, _presets) {
      var structure = forHorizontalCollection(items);
      return {
        value: value,
        dom: structure.dom,
        components: structure.components,
        items: items
      };
    };
    var createPartialMenuWithAlloyItems = function (value, hasIcons, items, columns, presets) {
      if (presets === 'color') {
        var structure = forSwatch(columns);
        return {
          value: value,
          dom: structure.dom,
          components: structure.components,
          items: items
        };
      }
      if (presets === 'normal' && columns === 'auto') {
        var structure = forCollection(columns, items);
        return {
          value: value,
          dom: structure.dom,
          components: structure.components,
          items: items
        };
      }
      if (presets === 'normal' && columns === 1) {
        var structure = forCollection(1, items);
        return {
          value: value,
          dom: structure.dom,
          components: structure.components,
          items: items
        };
      }
      if (presets === 'normal') {
        var structure = forCollection(columns, items);
        return {
          value: value,
          dom: structure.dom,
          components: structure.components,
          items: items
        };
      }
      if (presets === 'listpreview' && columns !== 'auto') {
        var structure = forToolbar(columns);
        return {
          value: value,
          dom: structure.dom,
          components: structure.components,
          items: items
        };
      }
      return {
        value: value,
        dom: dom$1(hasIcons, columns, presets),
        components: components,
        items: items
      };
    };

    var cardImageFields = [
      requiredString('type'),
      requiredString('src'),
      optionString('alt'),
      defaultedArrayOf('classes', [], string)
    ];
    var cardImageSchema = objOf(cardImageFields);

    var cardTextFields = [
      requiredString('type'),
      requiredString('text'),
      optionString('name'),
      defaultedArrayOf('classes', ['tox-collection__item-label'], string)
    ];
    var cardTextSchema = objOf(cardTextFields);

    var itemSchema$1 = valueThunk(function () {
      return choose$2('type', {
        cardimage: cardImageSchema,
        cardtext: cardTextSchema,
        cardcontainer: cardContainerSchema
      });
    });
    var cardContainerSchema = objOf([
      requiredString('type'),
      defaultedString('direction', 'horizontal'),
      defaultedString('align', 'left'),
      defaultedString('valign', 'middle'),
      requiredArrayOf('items', itemSchema$1)
    ]);

    var commonMenuItemFields = [
      defaultedBoolean('disabled', false),
      optionString('text'),
      optionString('shortcut'),
      field$1('value', 'value', defaultedThunk(function () {
        return generate$6('menuitem-value');
      }), anyValue()),
      defaulted('meta', {})
    ];

    var cardMenuItemSchema = objOf([
      requiredString('type'),
      optionString('label'),
      requiredArrayOf('items', itemSchema$1),
      defaultedFunction('onSetup', function () {
        return noop;
      }),
      defaultedFunction('onAction', noop)
    ].concat(commonMenuItemFields));
    var createCardMenuItem = function (spec) {
      return asRaw('cardmenuitem', cardMenuItemSchema, spec);
    };

    var choiceMenuItemSchema = objOf([
      requiredString('type'),
      defaultedBoolean('active', false),
      optionString('icon')
    ].concat(commonMenuItemFields));
    var createChoiceMenuItem = function (spec) {
      return asRaw('choicemenuitem', choiceMenuItemSchema, spec);
    };

    var baseFields = [
      requiredString('type'),
      requiredString('fancytype'),
      defaultedFunction('onAction', noop)
    ];
    var insertTableFields = [defaulted('initData', {})].concat(baseFields);
    var colorSwatchFields = [defaultedObjOf('initData', {}, [
        defaultedBoolean('allowCustomColors', true),
        optionArrayOf('colors', anyValue())
      ])].concat(baseFields);
    var fancyMenuItemSchema = choose$1('fancytype', {
      inserttable: insertTableFields,
      colorswatch: colorSwatchFields
    });
    var createFancyMenuItem = function (spec) {
      return asRaw('fancymenuitem', fancyMenuItemSchema, spec);
    };

    var menuItemSchema = objOf([
      requiredString('type'),
      defaultedFunction('onSetup', function () {
        return noop;
      }),
      defaultedFunction('onAction', noop),
      optionString('icon')
    ].concat(commonMenuItemFields));
    var createMenuItem = function (spec) {
      return asRaw('menuitem', menuItemSchema, spec);
    };

    var nestedMenuItemSchema = objOf([
      requiredString('type'),
      requiredFunction('getSubmenuItems'),
      defaultedFunction('onSetup', function () {
        return noop;
      }),
      optionString('icon')
    ].concat(commonMenuItemFields));
    var createNestedMenuItem = function (spec) {
      return asRaw('nestedmenuitem', nestedMenuItemSchema, spec);
    };

    var toggleMenuItemSchema = objOf([
      requiredString('type'),
      optionString('icon'),
      defaultedBoolean('active', false),
      defaultedFunction('onSetup', function () {
        return noop;
      }),
      requiredFunction('onAction')
    ].concat(commonMenuItemFields));
    var createToggleMenuItem = function (spec) {
      return asRaw('togglemenuitem', toggleMenuItemSchema, spec);
    };

    var detectSize = function (comp, margin, selectorClass) {
      var descendants$1 = descendants(comp.element, '.' + selectorClass);
      if (descendants$1.length > 0) {
        var columnLength = findIndex$1(descendants$1, function (c) {
          var thisTop = c.dom.getBoundingClientRect().top;
          var cTop = descendants$1[0].dom.getBoundingClientRect().top;
          return Math.abs(thisTop - cTop) > margin;
        }).getOr(descendants$1.length);
        return Optional.some({
          numColumns: columnLength,
          numRows: Math.ceil(descendants$1.length / columnLength)
        });
      } else {
        return Optional.none();
      }
    };

    var namedEvents = function (name, handlers) {
      return derive$1([config(name, handlers)]);
    };
    var unnamedEvents = function (handlers) {
      return namedEvents(generate$6('unnamed-events'), handlers);
    };
    var SimpleBehaviours = {
      namedEvents: namedEvents,
      unnamedEvents: unnamedEvents
    };

    var ExclusivityChannel = generate$6('tooltip.exclusive');
    var ShowTooltipEvent = generate$6('tooltip.show');
    var HideTooltipEvent = generate$6('tooltip.hide');

    var hideAllExclusive = function (component, _tConfig, _tState) {
      component.getSystem().broadcastOn([ExclusivityChannel], {});
    };
    var setComponents = function (component, tConfig, tState, specs) {
      tState.getTooltip().each(function (tooltip) {
        if (tooltip.getSystem().isConnected()) {
          Replacing.set(tooltip, specs);
        }
      });
    };

    var TooltippingApis = /*#__PURE__*/Object.freeze({
        __proto__: null,
        hideAllExclusive: hideAllExclusive,
        setComponents: setComponents
    });

    var events$9 = function (tooltipConfig, state) {
      var hide = function (comp) {
        state.getTooltip().each(function (p) {
          detach(p);
          tooltipConfig.onHide(comp, p);
          state.clearTooltip();
        });
        state.clearTimer();
      };
      var show = function (comp) {
        if (!state.isShowing()) {
          hideAllExclusive(comp);
          var sink = tooltipConfig.lazySink(comp).getOrDie();
          var popup = comp.getSystem().build({
            dom: tooltipConfig.tooltipDom,
            components: tooltipConfig.tooltipComponents,
            events: derive$2(tooltipConfig.mode === 'normal' ? [
              run$1(mouseover(), function (_) {
                emit(comp, ShowTooltipEvent);
              }),
              run$1(mouseout(), function (_) {
                emit(comp, HideTooltipEvent);
              })
            ] : []),
            behaviours: derive$1([Replacing.config({})])
          });
          state.setTooltip(popup);
          attach(sink, popup);
          tooltipConfig.onShow(comp, popup);
          Positioning.position(sink, popup, { anchor: tooltipConfig.anchor(comp) });
        }
      };
      return derive$2(flatten([
        [
          run$1(ShowTooltipEvent, function (comp) {
            state.resetTimer(function () {
              show(comp);
            }, tooltipConfig.delay);
          }),
          run$1(HideTooltipEvent, function (comp) {
            state.resetTimer(function () {
              hide(comp);
            }, tooltipConfig.delay);
          }),
          run$1(receive(), function (comp, message) {
            var receivingData = message;
            if (!receivingData.universal) {
              if (contains$2(receivingData.channels, ExclusivityChannel)) {
                hide(comp);
              }
            }
          }),
          runOnDetached(function (comp) {
            hide(comp);
          })
        ],
        tooltipConfig.mode === 'normal' ? [
          run$1(focusin(), function (comp) {
            emit(comp, ShowTooltipEvent);
          }),
          run$1(postBlur(), function (comp) {
            emit(comp, HideTooltipEvent);
          }),
          run$1(mouseover(), function (comp) {
            emit(comp, ShowTooltipEvent);
          }),
          run$1(mouseout(), function (comp) {
            emit(comp, HideTooltipEvent);
          })
        ] : [
          run$1(highlight$1(), function (comp, _se) {
            emit(comp, ShowTooltipEvent);
          }),
          run$1(dehighlight$1(), function (comp) {
            emit(comp, HideTooltipEvent);
          })
        ]
      ]));
    };

    var ActiveTooltipping = /*#__PURE__*/Object.freeze({
        __proto__: null,
        events: events$9
    });

    var TooltippingSchema = [
      required$1('lazySink'),
      required$1('tooltipDom'),
      defaulted('exclusive', true),
      defaulted('tooltipComponents', []),
      defaulted('delay', 300),
      defaultedStringEnum('mode', 'normal', [
        'normal',
        'follow-highlight'
      ]),
      defaulted('anchor', function (comp) {
        return {
          type: 'hotspot',
          hotspot: comp,
          layouts: {
            onLtr: constant$1([
              south$2,
              north$2,
              southeast$2,
              northeast$2,
              southwest$2,
              northwest$2
            ]),
            onRtl: constant$1([
              south$2,
              north$2,
              southeast$2,
              northeast$2,
              southwest$2,
              northwest$2
            ])
          }
        };
      }),
      onHandler('onHide'),
      onHandler('onShow')
    ];

    var init$b = function () {
      var timer = value$1();
      var popup = value$1();
      var clearTimer = function () {
        timer.on(clearTimeout);
      };
      var resetTimer = function (f, delay) {
        clearTimer();
        timer.set(setTimeout(f, delay));
      };
      var readState = constant$1('not-implemented');
      return nu$8({
        getTooltip: popup.get,
        isShowing: popup.isSet,
        setTooltip: popup.set,
        clearTooltip: popup.clear,
        clearTimer: clearTimer,
        resetTimer: resetTimer,
        readState: readState
      });
    };

    var TooltippingState = /*#__PURE__*/Object.freeze({
        __proto__: null,
        init: init$b
    });

    var Tooltipping = create$7({
      fields: TooltippingSchema,
      name: 'tooltipping',
      active: ActiveTooltipping,
      state: TooltippingState,
      apis: TooltippingApis
    });

    var escape = function (text) {
      return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };

    var global$b = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');

    var global$a = tinymce.util.Tools.resolve('tinymce.EditorManager');

    var getSkinUrl = function (editor) {
      var skin = editor.getParam('skin');
      var skinUrl = editor.getParam('skin_url');
      if (skin !== false) {
        var skinName = skin ? skin : 'oxide';
        if (skinUrl) {
          skinUrl = editor.documentBaseURI.toAbsolute(skinUrl);
        } else {
          skinUrl = global$a.baseURL + '/skins/ui/' + skinName;
        }
      }
      return skinUrl;
    };
    var isReadOnly = function (editor) {
      return editor.getParam('readonly', false, 'boolean');
    };
    var isSkinDisabled = function (editor) {
      return editor.getParam('skin') === false;
    };
    var getHeightSetting = function (editor) {
      return editor.getParam('height', Math.max(editor.getElement().offsetHeight, 200));
    };
    var getWidthSetting = function (editor) {
      return editor.getParam('width', global$b.DOM.getStyle(editor.getElement(), 'width'));
    };
    var getMinWidthSetting = function (editor) {
      return Optional.from(editor.getParam('min_width')).filter(isNumber);
    };
    var getMinHeightSetting = function (editor) {
      return Optional.from(editor.getParam('min_height')).filter(isNumber);
    };
    var getMaxWidthSetting = function (editor) {
      return Optional.from(editor.getParam('max_width')).filter(isNumber);
    };
    var getMaxHeightSetting = function (editor) {
      return Optional.from(editor.getParam('max_height')).filter(isNumber);
    };
    var getUserStyleFormats = function (editor) {
      return Optional.from(editor.getParam('style_formats')).filter(isArray);
    };
    var isMergeStyleFormats = function (editor) {
      return editor.getParam('style_formats_merge', false, 'boolean');
    };
    var getLineHeightFormats = function (editor) {
      return editor.getParam('lineheight_formats', '1 1.1 1.2 1.3 1.4 1.5 2', 'string').split(' ');
    };
    var getContentLanguages = function (editor) {
      return editor.getParam('content_langs', undefined, 'array');
    };
    var getRemovedMenuItems = function (editor) {
      return editor.getParam('removed_menuitems', '');
    };
    var isMenubarEnabled = function (editor) {
      return editor.getParam('menubar', true, 'boolean') !== false;
    };
    var isToolbarEnabled = function (editor) {
      var toolbar = editor.getParam('toolbar', true);
      var isToolbarTrue = toolbar === true;
      var isToolbarString = isString(toolbar);
      var isToolbarObjectArray = isArray(toolbar) && toolbar.length > 0;
      return !isMultipleToolbars(editor) && (isToolbarObjectArray || isToolbarString || isToolbarTrue);
    };
    var getMultipleToolbarsSetting = function (editor) {
      var toolbars = range$2(9, function (num) {
        return editor.getParam('toolbar' + (num + 1), false, 'string');
      });
      var toolbarArray = filter$2(toolbars, function (toolbar) {
        return typeof toolbar === 'string';
      });
      return toolbarArray.length > 0 ? Optional.some(toolbarArray) : Optional.none();
    };
    var isMultipleToolbars = function (editor) {
      return getMultipleToolbarsSetting(editor).fold(function () {
        var toolbar = editor.getParam('toolbar', [], 'string[]');
        return toolbar.length > 0;
      }, always);
    };
    var ToolbarMode;
    (function (ToolbarMode) {
      ToolbarMode['default'] = 'wrap';
      ToolbarMode['floating'] = 'floating';
      ToolbarMode['sliding'] = 'sliding';
      ToolbarMode['scrolling'] = 'scrolling';
    }(ToolbarMode || (ToolbarMode = {})));
    var getToolbarMode = function (editor) {
      return editor.getParam('toolbar_mode', '', 'string');
    };
    var ToolbarLocation;
    (function (ToolbarLocation) {
      ToolbarLocation['auto'] = 'auto';
      ToolbarLocation['top'] = 'top';
      ToolbarLocation['bottom'] = 'bottom';
    }(ToolbarLocation || (ToolbarLocation = {})));
    var getToolbarGroups = function (editor) {
      return editor.getParam('toolbar_groups', {}, 'object');
    };
    var getToolbarLocation = function (editor) {
      return editor.getParam('toolbar_location', ToolbarLocation.auto, 'string');
    };
    var isToolbarLocationBottom = function (editor) {
      return getToolbarLocation(editor) === ToolbarLocation.bottom;
    };
    var fixedContainerSelector = function (editor) {
      return editor.getParam('fixed_toolbar_container', '', 'string');
    };
    var fixedToolbarContainerTarget = function (editor) {
      return editor.getParam('fixed_toolbar_container_target');
    };
    var isToolbarPersist = function (editor) {
      return editor.getParam('toolbar_persist', false, 'boolean');
    };
    var fixedContainerTarget = function (editor) {
      if (!editor.inline) {
        return Optional.none();
      }
      var selector = fixedContainerSelector(editor);
      if (selector.length > 0) {
        return descendant(body(), selector);
      }
      var element = fixedToolbarContainerTarget(editor);
      if (isNonNullable(element)) {
        return Optional.some(SugarElement.fromDom(element));
      }
      return Optional.none();
    };
    var useFixedContainer = function (editor) {
      return editor.inline && fixedContainerTarget(editor).isSome();
    };
    var getUiContainer = function (editor) {
      var fixedContainer = fixedContainerTarget(editor);
      return fixedContainer.getOrThunk(function () {
        return getContentContainer(getRootNode(SugarElement.fromDom(editor.getElement())));
      });
    };
    var isDistractionFree = function (editor) {
      return editor.inline && !isMenubarEnabled(editor) && !isToolbarEnabled(editor) && !isMultipleToolbars(editor);
    };
    var isStickyToolbar = function (editor) {
      var isStickyToolbar = editor.getParam('toolbar_sticky', false, 'boolean');
      return (isStickyToolbar || editor.inline) && !useFixedContainer(editor) && !isDistractionFree(editor);
    };
    var getStickyToolbarOffset = function (editor) {
      return editor.getParam('toolbar_sticky_offset', 0, 'number');
    };
    var isDraggableModal$1 = function (editor) {
      return editor.getParam('draggable_modal', false, 'boolean');
    };
    var getMenus = function (editor) {
      var menu = editor.getParam('menu');
      if (menu) {
        return map$1(menu, function (menu) {
          return __assign(__assign({}, menu), { items: menu.items });
        });
      } else {
        return {};
      }
    };
    var getMenubar = function (editor) {
      return editor.getParam('menubar');
    };
    var getToolbar = function (editor) {
      return editor.getParam('toolbar', true);
    };
    var getFilePickerCallback = function (editor) {
      return editor.getParam('file_picker_callback');
    };
    var getFilePickerTypes = function (editor) {
      return editor.getParam('file_picker_types');
    };
    var getFileBrowserCallbackTypes = function (editor) {
      return editor.getParam('file_browser_callback_types');
    };
    var noTypeaheadUrls = function (editor) {
      return editor.getParam('typeahead_urls') === false;
    };
    var getAnchorTop = function (editor) {
      return editor.getParam('anchor_top', '#top');
    };
    var getAnchorBottom = function (editor) {
      return editor.getParam('anchor_bottom', '#bottom');
    };
    var getFilePickerValidatorHandler = function (editor) {
      var handler = editor.getParam('file_picker_validator_handler', undefined, 'function');
      if (handler === undefined) {
        return editor.getParam('filepicker_validator_handler', undefined, 'function');
      } else {
        return handler;
      }
    };

    var ReadOnlyChannel = 'silver.readonly';
    var ReadOnlyDataSchema = objOf([requiredBoolean('readonly')]);
    var broadcastReadonly = function (uiComponents, readonly) {
      var outerContainer = uiComponents.outerContainer;
      var target = outerContainer.element;
      if (readonly) {
        uiComponents.mothership.broadcastOn([dismissPopups()], { target: target });
        uiComponents.uiMothership.broadcastOn([dismissPopups()], { target: target });
      }
      uiComponents.mothership.broadcastOn([ReadOnlyChannel], { readonly: readonly });
      uiComponents.uiMothership.broadcastOn([ReadOnlyChannel], { readonly: readonly });
    };
    var setupReadonlyModeSwitch = function (editor, uiComponents) {
      editor.on('init', function () {
        if (editor.mode.isReadOnly()) {
          broadcastReadonly(uiComponents, true);
        }
      });
      editor.on('SwitchMode', function () {
        return broadcastReadonly(uiComponents, editor.mode.isReadOnly());
      });
      if (isReadOnly(editor)) {
        editor.setMode('readonly');
      }
    };
    var receivingConfig = function () {
      var _a;
      return Receiving.config({
        channels: (_a = {}, _a[ReadOnlyChannel] = {
          schema: ReadOnlyDataSchema,
          onReceive: function (comp, data) {
            Disabling.set(comp, data.readonly);
          }
        }, _a)
      });
    };

    var item = function (disabled) {
      return Disabling.config({
        disabled: disabled,
        disableClass: 'tox-collection__item--state-disabled'
      });
    };
    var button = function (disabled) {
      return Disabling.config({ disabled: disabled });
    };
    var splitButton = function (disabled) {
      return Disabling.config({
        disabled: disabled,
        disableClass: 'tox-tbtn--disabled'
      });
    };
    var toolbarButton = function (disabled) {
      return Disabling.config({
        disabled: disabled,
        disableClass: 'tox-tbtn--disabled',
        useNative: false
      });
    };
    var DisablingConfigs = {
      item: item,
      button: button,
      splitButton: splitButton,
      toolbarButton: toolbarButton
    };

    var runWithApi = function (info, comp) {
      var api = info.getApi(comp);
      return function (f) {
        f(api);
      };
    };
    var onControlAttached = function (info, editorOffCell) {
      return runOnAttached(function (comp) {
        var run = runWithApi(info, comp);
        run(function (api) {
          var onDestroy = info.onSetup(api);
          if (isFunction(onDestroy)) {
            editorOffCell.set(onDestroy);
          }
        });
      });
    };
    var onControlDetached = function (getApi, editorOffCell) {
      return runOnDetached(function (comp) {
        return runWithApi(getApi, comp)(editorOffCell.get());
      });
    };

    var _a$1;
    var onMenuItemExecute = function (info, itemResponse) {
      return runOnExecute$1(function (comp, simulatedEvent) {
        runWithApi(info, comp)(info.onAction);
        if (!info.triggersSubmenu && itemResponse === ItemResponse$1.CLOSE_ON_EXECUTE) {
          emit(comp, sandboxClose());
          simulatedEvent.stop();
        }
      });
    };
    var menuItemEventOrder = (_a$1 = {}, _a$1[execute$5()] = [
      'disabling',
      'alloy.base.behaviour',
      'toggling',
      'item-events'
    ], _a$1);

    var componentRenderPipeline = cat;
    var renderCommonItem = function (spec, structure, itemResponse, providersbackstage) {
      var editorOffCell = Cell(noop);
      return {
        type: 'item',
        dom: structure.dom,
        components: componentRenderPipeline(structure.optComponents),
        data: spec.data,
        eventOrder: menuItemEventOrder,
        hasSubmenu: spec.triggersSubmenu,
        itemBehaviours: derive$1([
          config('item-events', [
            onMenuItemExecute(spec, itemResponse),
            onControlAttached(spec, editorOffCell),
            onControlDetached(spec, editorOffCell)
          ]),
          DisablingConfigs.item(function () {
            return spec.disabled || providersbackstage.isDisabled();
          }),
          receivingConfig(),
          Replacing.config({})
        ].concat(spec.itemBehaviours))
      };
    };
    var buildData = function (source) {
      return {
        value: source.value,
        meta: __assign({ text: source.text.getOr('') }, source.meta)
      };
    };

    var global$9 = tinymce.util.Tools.resolve('tinymce.Env');

    var convertText = function (source) {
      var mac = {
        alt: '&#x2325;',
        ctrl: '&#x2303;',
        shift: '&#x21E7;',
        meta: '&#x2318;',
        access: '&#x2303;&#x2325;'
      };
      var other = {
        meta: 'Ctrl',
        access: 'Shift+Alt'
      };
      var replace = global$9.mac ? mac : other;
      var shortcut = source.split('+');
      var updated = map$2(shortcut, function (segment) {
        var search = segment.toLowerCase().trim();
        return has$2(replace, search) ? replace[search] : segment;
      });
      return global$9.mac ? updated.join('') : updated.join('+');
    };

    var renderIcon$1 = function (name, icons, classes) {
      if (classes === void 0) {
        classes = [iconClass];
      }
      return render$3(name, {
        tag: 'div',
        classes: classes
      }, icons);
    };
    var renderText = function (text$1) {
      return {
        dom: {
          tag: 'div',
          classes: [textClass]
        },
        components: [text(global$e.translate(text$1))]
      };
    };
    var renderHtml = function (html, classes) {
      return {
        dom: {
          tag: 'div',
          classes: classes,
          innerHtml: html
        }
      };
    };
    var renderStyledText = function (style, text$1) {
      return {
        dom: {
          tag: 'div',
          classes: [textClass]
        },
        components: [{
            dom: {
              tag: style.tag,
              styles: style.styles
            },
            components: [text(global$e.translate(text$1))]
          }]
      };
    };
    var renderShortcut = function (shortcut) {
      return {
        dom: {
          tag: 'div',
          classes: [accessoryClass],
          innerHtml: convertText(shortcut)
        }
      };
    };
    var renderCheckmark = function (icons) {
      return renderIcon$1('checkmark', icons, [checkmarkClass]);
    };
    var renderSubmenuCaret = function (icons) {
      return renderIcon$1('chevron-right', icons, [caretClass]);
    };
    var renderDownwardsCaret = function (icons) {
      return renderIcon$1('chevron-down', icons, [caretClass]);
    };
    var renderContainer = function (container, components) {
      var directionClass = container.direction === 'vertical' ? containerColumnClass : containerRowClass;
      var alignClass = container.align === 'left' ? containerAlignLeftClass : containerAlignRightClass;
      var getValignClass = function () {
        switch (container.valign) {
        case 'top':
          return containerValignTopClass;
        case 'middle':
          return containerValignMiddleClass;
        case 'bottom':
          return containerValignBottomClass;
        }
      };
      return {
        dom: {
          tag: 'div',
          classes: [
            containerClass,
            directionClass,
            alignClass,
            getValignClass()
          ]
        },
        components: components
      };
    };
    var renderImage = function (src, classes, alt) {
      return {
        dom: {
          tag: 'img',
          classes: classes,
          attributes: {
            src: src,
            alt: alt.getOr('')
          }
        }
      };
    };

    var renderColorStructure = function (item, providerBackstage, fallbackIcon) {
      var colorPickerCommand = 'custom';
      var removeColorCommand = 'remove';
      var itemText = item.ariaLabel;
      var itemValue = item.value;
      var iconSvg = item.iconContent.map(function (name) {
        return getOr(name, providerBackstage.icons, fallbackIcon);
      });
      var getDom = function () {
        var common = colorClass;
        var icon = iconSvg.getOr('');
        var attributes = itemText.map(function (text) {
          return { title: providerBackstage.translate(text) };
        }).getOr({});
        var baseDom = {
          tag: 'div',
          attributes: attributes,
          classes: [common]
        };
        if (itemValue === colorPickerCommand) {
          return __assign(__assign({}, baseDom), {
            tag: 'button',
            classes: __spreadArray(__spreadArray([], baseDom.classes, true), ['tox-swatches__picker-btn'], false),
            innerHtml: icon
          });
        } else if (itemValue === removeColorCommand) {
          return __assign(__assign({}, baseDom), {
            classes: __spreadArray(__spreadArray([], baseDom.classes, true), ['tox-swatch--remove'], false),
            innerHtml: icon
          });
        } else {
          return __assign(__assign({}, baseDom), {
            attributes: __assign(__assign({}, baseDom.attributes), { 'data-mce-color': itemValue }),
            styles: { 'background-color': itemValue }
          });
        }
      };
      return {
        dom: getDom(),
        optComponents: []
      };
    };
    var renderItemDomStructure = function (ariaLabel) {
      var domTitle = ariaLabel.map(function (label) {
        return { attributes: { title: global$e.translate(label) } };
      }).getOr({});
      return __assign({
        tag: 'div',
        classes: [
          navClass,
          selectableClass
        ]
      }, domTitle);
    };
    var renderNormalItemStructure = function (info, providersBackstage, renderIcons, fallbackIcon) {
      var iconSpec = {
        tag: 'div',
        classes: [iconClass]
      };
      var renderIcon = function (iconName) {
        return render$3(iconName, iconSpec, providersBackstage.icons, fallbackIcon);
      };
      var renderEmptyIcon = function () {
        return Optional.some({ dom: iconSpec });
      };
      var leftIcon = renderIcons ? info.iconContent.map(renderIcon).orThunk(renderEmptyIcon) : Optional.none();
      var checkmark = info.checkMark;
      var textRender = Optional.from(info.meta).fold(function () {
        return renderText;
      }, function (meta) {
        return has$2(meta, 'style') ? curry(renderStyledText, meta.style) : renderText;
      });
      var content = info.htmlContent.fold(function () {
        return info.textContent.map(textRender);
      }, function (html) {
        return Optional.some(renderHtml(html, [textClass]));
      });
      var menuItem = {
        dom: renderItemDomStructure(info.ariaLabel),
        optComponents: [
          leftIcon,
          content,
          info.shortcutContent.map(renderShortcut),
          checkmark,
          info.caret
        ]
      };
      return menuItem;
    };
    var renderItemStructure = function (info, providersBackstage, renderIcons, fallbackIcon) {
      if (fallbackIcon === void 0) {
        fallbackIcon = Optional.none();
      }
      if (info.presets === 'color') {
        return renderColorStructure(info, providersBackstage, fallbackIcon);
      } else {
        return renderNormalItemStructure(info, providersBackstage, renderIcons, fallbackIcon);
      }
    };

    var tooltipBehaviour = function (meta, sharedBackstage) {
      return get$e(meta, 'tooltipWorker').map(function (tooltipWorker) {
        return [Tooltipping.config({
            lazySink: sharedBackstage.getSink,
            tooltipDom: {
              tag: 'div',
              classes: ['tox-tooltip-worker-container']
            },
            tooltipComponents: [],
            anchor: function (comp) {
              return {
                type: 'submenu',
                item: comp,
                overrides: { maxHeightFunction: expandable$1 }
              };
            },
            mode: 'follow-highlight',
            onShow: function (component, _tooltip) {
              tooltipWorker(function (elm) {
                Tooltipping.setComponents(component, [external$2({ element: SugarElement.fromDom(elm) })]);
              });
            }
          })];
      }).getOr([]);
    };
    var encodeText = function (text) {
      return global$b.DOM.encode(text);
    };
    var replaceText = function (text, matchText) {
      var translated = global$e.translate(text);
      var encoded = encodeText(translated);
      if (matchText.length > 0) {
        var escapedMatchRegex = new RegExp(escape(matchText), 'gi');
        return encoded.replace(escapedMatchRegex, function (match) {
          return '<span class="tox-autocompleter-highlight">' + match + '</span>';
        });
      } else {
        return encoded;
      }
    };
    var renderAutocompleteItem = function (spec, matchText, useText, presets, onItemValueHandler, itemResponse, sharedBackstage, renderIcons) {
      if (renderIcons === void 0) {
        renderIcons = true;
      }
      var structure = renderItemStructure({
        presets: presets,
        textContent: Optional.none(),
        htmlContent: useText ? spec.text.map(function (text) {
          return replaceText(text, matchText);
        }) : Optional.none(),
        ariaLabel: spec.text,
        iconContent: spec.icon,
        shortcutContent: Optional.none(),
        checkMark: Optional.none(),
        caret: Optional.none(),
        value: spec.value
      }, sharedBackstage.providers, renderIcons, spec.icon);
      return renderCommonItem({
        data: buildData(spec),
        disabled: spec.disabled,
        getApi: constant$1({}),
        onAction: function (_api) {
          return onItemValueHandler(spec.value, spec.meta);
        },
        onSetup: constant$1(noop),
        triggersSubmenu: false,
        itemBehaviours: tooltipBehaviour(spec.meta, sharedBackstage)
      }, structure, itemResponse, sharedBackstage.providers);
    };

    var render$2 = function (items, extras) {
      return map$2(items, function (item) {
        switch (item.type) {
        case 'cardcontainer':
          return renderContainer(item, render$2(item.items, extras));
        case 'cardimage':
          return renderImage(item.src, item.classes, item.alt);
        case 'cardtext':
          var shouldHighlight = item.name.exists(function (name) {
            return contains$2(extras.cardText.highlightOn, name);
          });
          var matchText = shouldHighlight ? Optional.from(extras.cardText.matchText).getOr('') : '';
          return renderHtml(replaceText(item.text, matchText), item.classes);
        }
      });
    };
    var renderCardMenuItem = function (spec, itemResponse, sharedBackstage, extras) {
      var getApi = function (component) {
        return {
          isDisabled: function () {
            return Disabling.isDisabled(component);
          },
          setDisabled: function (state) {
            Disabling.set(component, state);
            each$1(descendants(component.element, '*'), function (elm) {
              component.getSystem().getByDom(elm).each(function (comp) {
                if (comp.hasConfigured(Disabling)) {
                  Disabling.set(comp, state);
                }
              });
            });
          }
        };
      };
      var structure = {
        dom: renderItemDomStructure(spec.label),
        optComponents: [Optional.some({
            dom: {
              tag: 'div',
              classes: [
                containerClass,
                containerRowClass
              ]
            },
            components: render$2(spec.items, extras)
          })]
      };
      return renderCommonItem({
        data: buildData(__assign({ text: Optional.none() }, spec)),
        disabled: spec.disabled,
        getApi: getApi,
        onAction: spec.onAction,
        onSetup: spec.onSetup,
        triggersSubmenu: false,
        itemBehaviours: Optional.from(extras.itemBehaviours).getOr([])
      }, structure, itemResponse, sharedBackstage.providers);
    };

    var renderChoiceItem = function (spec, useText, presets, onItemValueHandler, isSelected, itemResponse, providersBackstage, renderIcons) {
      if (renderIcons === void 0) {
        renderIcons = true;
      }
      var getApi = function (component) {
        return {
          setActive: function (state) {
            Toggling.set(component, state);
          },
          isActive: function () {
            return Toggling.isOn(component);
          },
          isDisabled: function () {
            return Disabling.isDisabled(component);
          },
          setDisabled: function (state) {
            return Disabling.set(component, state);
          }
        };
      };
      var structure = renderItemStructure({
        presets: presets,
        textContent: useText ? spec.text : Optional.none(),
        htmlContent: Optional.none(),
        ariaLabel: spec.text,
        iconContent: spec.icon,
        shortcutContent: useText ? spec.shortcut : Optional.none(),
        checkMark: useText ? Optional.some(renderCheckmark(providersBackstage.icons)) : Optional.none(),
        caret: Optional.none(),
        value: spec.value
      }, providersBackstage, renderIcons);
      return deepMerge(renderCommonItem({
        data: buildData(spec),
        disabled: spec.disabled,
        getApi: getApi,
        onAction: function (_api) {
          return onItemValueHandler(spec.value);
        },
        onSetup: function (api) {
          api.setActive(isSelected);
          return noop;
        },
        triggersSubmenu: false,
        itemBehaviours: []
      }, structure, itemResponse, providersBackstage), {
        toggling: {
          toggleClass: tickedClass,
          toggleOnExecute: false,
          selected: spec.active
        }
      });
    };

    var parts$f = generate$3(owner$2(), parts$h());

    var hexColour = function (value) {
      return { value: value };
    };
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    var longformRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
    var isHexString = function (hex) {
      return shorthandRegex.test(hex) || longformRegex.test(hex);
    };
    var normalizeHex = function (hex) {
      return removeLeading(hex, '#').toUpperCase();
    };
    var fromString$1 = function (hex) {
      return isHexString(hex) ? Optional.some({ value: normalizeHex(hex) }) : Optional.none();
    };
    var getLongForm = function (hex) {
      var hexString = hex.value.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });
      return { value: hexString };
    };
    var extractValues = function (hex) {
      var longForm = getLongForm(hex);
      var splitForm = longformRegex.exec(longForm.value);
      return splitForm === null ? [
        'FFFFFF',
        'FF',
        'FF',
        'FF'
      ] : splitForm;
    };
    var toHex = function (component) {
      var hex = component.toString(16);
      return (hex.length === 1 ? '0' + hex : hex).toUpperCase();
    };
    var fromRgba = function (rgbaColour) {
      var value = toHex(rgbaColour.red) + toHex(rgbaColour.green) + toHex(rgbaColour.blue);
      return hexColour(value);
    };

    var min = Math.min;
    var max = Math.max;
    var round$1 = Math.round;
    var rgbRegex = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)/;
    var rgbaRegex = /^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d?(?:\.\d+)?)\)/;
    var rgbaColour = function (red, green, blue, alpha) {
      return {
        red: red,
        green: green,
        blue: blue,
        alpha: alpha
      };
    };
    var isRgbaComponent = function (value) {
      var num = parseInt(value, 10);
      return num.toString() === value && num >= 0 && num <= 255;
    };
    var fromHsv = function (hsv) {
      var r;
      var g;
      var b;
      var hue = (hsv.hue || 0) % 360;
      var saturation = hsv.saturation / 100;
      var brightness = hsv.value / 100;
      saturation = max(0, min(saturation, 1));
      brightness = max(0, min(brightness, 1));
      if (saturation === 0) {
        r = g = b = round$1(255 * brightness);
        return rgbaColour(r, g, b, 1);
      }
      var side = hue / 60;
      var chroma = brightness * saturation;
      var x = chroma * (1 - Math.abs(side % 2 - 1));
      var match = brightness - chroma;
      switch (Math.floor(side)) {
      case 0:
        r = chroma;
        g = x;
        b = 0;
        break;
      case 1:
        r = x;
        g = chroma;
        b = 0;
        break;
      case 2:
        r = 0;
        g = chroma;
        b = x;
        break;
      case 3:
        r = 0;
        g = x;
        b = chroma;
        break;
      case 4:
        r = x;
        g = 0;
        b = chroma;
        break;
      case 5:
        r = chroma;
        g = 0;
        b = x;
        break;
      default:
        r = g = b = 0;
      }
      r = round$1(255 * (r + match));
      g = round$1(255 * (g + match));
      b = round$1(255 * (b + match));
      return rgbaColour(r, g, b, 1);
    };
    var fromHex = function (hexColour) {
      var result = extractValues(hexColour);
      var red = parseInt(result[1], 16);
      var green = parseInt(result[2], 16);
      var blue = parseInt(result[3], 16);
      return rgbaColour(red, green, blue, 1);
    };
    var fromStringValues = function (red, green, blue, alpha) {
      var r = parseInt(red, 10);
      var g = parseInt(green, 10);
      var b = parseInt(blue, 10);
      var a = parseFloat(alpha);
      return rgbaColour(r, g, b, a);
    };
    var fromString = function (rgbaString) {
      if (rgbaString === 'transparent') {
        return Optional.some(rgbaColour(0, 0, 0, 0));
      }
      var rgbMatch = rgbRegex.exec(rgbaString);
      if (rgbMatch !== null) {
        return Optional.some(fromStringValues(rgbMatch[1], rgbMatch[2], rgbMatch[3], '1'));
      }
      var rgbaMatch = rgbaRegex.exec(rgbaString);
      if (rgbaMatch !== null) {
        return Optional.some(fromStringValues(rgbaMatch[1], rgbaMatch[2], rgbaMatch[3], rgbaMatch[4]));
      }
      return Optional.none();
    };
    var toString = function (rgba) {
      return 'rgba(' + rgba.red + ',' + rgba.green + ',' + rgba.blue + ',' + rgba.alpha + ')';
    };
    var red = rgbaColour(255, 0, 0, 1);

    var fireSkinLoaded$1 = function (editor) {
      return editor.fire('SkinLoaded');
    };
    var fireSkinLoadError$1 = function (editor, error) {
      return editor.fire('SkinLoadError', error);
    };
    var fireResizeEditor = function (editor) {
      return editor.fire('ResizeEditor');
    };
    var fireResizeContent = function (editor, e) {
      return editor.fire('ResizeContent', e);
    };
    var fireScrollContent = function (editor, e) {
      return editor.fire('ScrollContent', e);
    };
    var fireTextColorChange = function (editor, data) {
      return editor.fire('TextColorChange', data);
    };

    var hsvColour = function (hue, saturation, value) {
      return {
        hue: hue,
        saturation: saturation,
        value: value
      };
    };
    var fromRgb = function (rgbaColour) {
      var h = 0;
      var s = 0;
      var v = 0;
      var r = rgbaColour.red / 255;
      var g = rgbaColour.green / 255;
      var b = rgbaColour.blue / 255;
      var minRGB = Math.min(r, Math.min(g, b));
      var maxRGB = Math.max(r, Math.max(g, b));
      if (minRGB === maxRGB) {
        v = minRGB;
        return hsvColour(0, 0, v * 100);
      }
      var d = r === minRGB ? g - b : b === minRGB ? r - g : b - r;
      h = r === minRGB ? 3 : b === minRGB ? 1 : 5;
      h = 60 * (h - d / (maxRGB - minRGB));
      s = (maxRGB - minRGB) / maxRGB;
      v = maxRGB;
      return hsvColour(Math.round(h), Math.round(s * 100), Math.round(v * 100));
    };

    var hexToHsv = function (hex) {
      return fromRgb(fromHex(hex));
    };
    var hsvToHex = function (hsv) {
      return fromRgba(fromHsv(hsv));
    };
    var anyToHex = function (color) {
      return fromString$1(color).orThunk(function () {
        return fromString(color).map(fromRgba);
      }).getOrThunk(function () {
        var canvas = document.createElement('canvas');
        canvas.height = 1;
        canvas.width = 1;
        var canvasContext = canvas.getContext('2d');
        canvasContext.clearRect(0, 0, canvas.width, canvas.height);
        canvasContext.fillStyle = '#FFFFFF';
        canvasContext.fillStyle = color;
        canvasContext.fillRect(0, 0, 1, 1);
        var rgba = canvasContext.getImageData(0, 0, 1, 1).data;
        var r = rgba[0];
        var g = rgba[1];
        var b = rgba[2];
        var a = rgba[3];
        return fromRgba(rgbaColour(r, g, b, a));
      });
    };

    var global$8 = tinymce.util.Tools.resolve('tinymce.util.LocalStorage');

    var storageName = 'tinymce-custom-colors';
    function ColorCache (max) {
      if (max === void 0) {
        max = 10;
      }
      var storageString = global$8.getItem(storageName);
      var localstorage = isString(storageString) ? JSON.parse(storageString) : [];
      var prune = function (list) {
        var diff = max - list.length;
        return diff < 0 ? list.slice(0, max) : list;
      };
      var cache = prune(localstorage);
      var add = function (key) {
        indexOf(cache, key).each(remove);
        cache.unshift(key);
        if (cache.length > max) {
          cache.pop();
        }
        global$8.setItem(storageName, JSON.stringify(cache));
      };
      var remove = function (idx) {
        cache.splice(idx, 1);
      };
      var state = function () {
        return cache.slice(0);
      };
      return {
        add: add,
        state: state
      };
    }

    var choiceItem = 'choiceitem';
    var defaultColors = [
      {
        type: choiceItem,
        text: 'Light Green',
        value: '#BFEDD2'
      },
      {
        type: choiceItem,
        text: 'Light Yellow',
        value: '#FBEEB8'
      },
      {
        type: choiceItem,
        text: 'Light Red',
        value: '#F8CAC6'
      },
      {
        type: choiceItem,
        text: 'Light Purple',
        value: '#ECCAFA'
      },
      {
        type: choiceItem,
        text: 'Light Blue',
        value: '#C2E0F4'
      },
      {
        type: choiceItem,
        text: 'Green',
        value: '#2DC26B'
      },
      {
        type: choiceItem,
        text: 'Yellow',
        value: '#F1C40F'
      },
      {
        type: choiceItem,
        text: 'Red',
        value: '#E03E2D'
      },
      {
        type: choiceItem,
        text: 'Purple',
        value: '#B96AD9'
      },
      {
        type: choiceItem,
        text: 'Blue',
        value: '#3598DB'
      },
      {
        type: choiceItem,
        text: 'Dark Turquoise',
        value: '#169179'
      },
      {
        type: choiceItem,
        text: 'Orange',
        value: '#E67E23'
      },
      {
        type: choiceItem,
        text: 'Dark Red',
        value: '#BA372A'
      },
      {
        type: choiceItem,
        text: 'Dark Purple',
        value: '#843FA1'
      },
      {
        type: choiceItem,
        text: 'Dark Blue',
        value: '#236FA1'
      },
      {
        type: choiceItem,
        text: 'Light Gray',
        value: '#ECF0F1'
      },
      {
        type: choiceItem,
        text: 'Medium Gray',
        value: '#CED4D9'
      },
      {
        type: choiceItem,
        text: 'Gray',
        value: '#95A5A6'
      },
      {
        type: choiceItem,
        text: 'Dark Gray',
        value: '#7E8C8D'
      },
      {
        type: choiceItem,
        text: 'Navy Blue',
        value: '#34495E'
      },
      {
        type: choiceItem,
        text: 'Black',
        value: '#000000'
      },
      {
        type: choiceItem,
        text: 'White',
        value: '#ffffff'
      }
    ];
    var colorCache = ColorCache(10);
    var mapColors = function (colorMap) {
      var colors = [];
      for (var i = 0; i < colorMap.length; i += 2) {
        colors.push({
          text: colorMap[i + 1],
          value: '#' + anyToHex(colorMap[i]).value,
          type: 'choiceitem'
        });
      }
      return colors;
    };
    var getColorCols$2 = function (editor, defaultCols) {
      return editor.getParam('color_cols', defaultCols, 'number');
    };
    var hasCustomColors$1 = function (editor) {
      return editor.getParam('custom_colors') !== false;
    };
    var getColorMap = function (editor) {
      return editor.getParam('color_map');
    };
    var getColors$2 = function (editor) {
      var unmapped = getColorMap(editor);
      return unmapped !== undefined ? mapColors(unmapped) : defaultColors;
    };
    var getCurrentColors = function () {
      return map$2(colorCache.state(), function (color) {
        return {
          type: choiceItem,
          text: color,
          value: color
        };
      });
    };
    var addColor = function (color) {
      colorCache.add(color);
    };

    var fallbackColor = '#000000';
    var getCurrentColor = function (editor, format) {
      var color;
      editor.dom.getParents(editor.selection.getStart(), function (elm) {
        var value;
        if (value = elm.style[format === 'forecolor' ? 'color' : 'background-color']) {
          color = color ? color : value;
        }
      });
      return Optional.from(color);
    };
    var applyFormat = function (editor, format, value) {
      editor.undoManager.transact(function () {
        editor.focus();
        editor.formatter.apply(format, { value: value });
        editor.nodeChanged();
      });
    };
    var removeFormat = function (editor, format) {
      editor.undoManager.transact(function () {
        editor.focus();
        editor.formatter.remove(format, { value: null }, null, true);
        editor.nodeChanged();
      });
    };
    var registerCommands = function (editor) {
      editor.addCommand('mceApplyTextcolor', function (format, value) {
        applyFormat(editor, format, value);
      });
      editor.addCommand('mceRemoveTextcolor', function (format) {
        removeFormat(editor, format);
      });
    };
    var calcCols = function (colors) {
      return Math.max(5, Math.ceil(Math.sqrt(colors)));
    };
    var getColorCols$1 = function (editor) {
      var colors = getColors$2(editor);
      var defaultCols = calcCols(colors.length);
      return getColorCols$2(editor, defaultCols);
    };
    var getAdditionalColors = function (hasCustom) {
      var type = 'choiceitem';
      var remove = {
        type: type,
        text: 'Remove color',
        icon: 'color-swatch-remove-color',
        value: 'remove'
      };
      var custom = {
        type: type,
        text: 'Custom color',
        icon: 'color-picker',
        value: 'custom'
      };
      return hasCustom ? [
        remove,
        custom
      ] : [remove];
    };
    var applyColor = function (editor, format, value, onChoice) {
      if (value === 'custom') {
        var dialog = colorPickerDialog(editor);
        dialog(function (colorOpt) {
          colorOpt.each(function (color) {
            addColor(color);
            editor.execCommand('mceApplyTextcolor', format, color);
            onChoice(color);
          });
        }, fallbackColor);
      } else if (value === 'remove') {
        onChoice('');
        editor.execCommand('mceRemoveTextcolor', format);
      } else {
        onChoice(value);
        editor.execCommand('mceApplyTextcolor', format, value);
      }
    };
    var getColors$1 = function (colors, hasCustom) {
      return colors.concat(getCurrentColors().concat(getAdditionalColors(hasCustom)));
    };
    var getFetch$1 = function (colors, hasCustom) {
      return function (callback) {
        callback(getColors$1(colors, hasCustom));
      };
    };
    var setIconColor = function (splitButtonApi, name, newColor) {
      var id = name === 'forecolor' ? 'tox-icon-text-color__color' : 'tox-icon-highlight-bg-color__color';
      splitButtonApi.setIconFill(id, newColor);
    };
    var registerTextColorButton = function (editor, name, format, tooltip, lastColor) {
      editor.ui.registry.addSplitButton(name, {
        tooltip: tooltip,
        presets: 'color',
        icon: name === 'forecolor' ? 'text-color' : 'highlight-bg-color',
        select: function (value) {
          var optCurrentRgb = getCurrentColor(editor, format);
          return optCurrentRgb.bind(function (currentRgb) {
            return fromString(currentRgb).map(function (rgba) {
              var currentHex = fromRgba(rgba).value;
              return contains$1(value.toLowerCase(), currentHex);
            });
          }).getOr(false);
        },
        columns: getColorCols$1(editor),
        fetch: getFetch$1(getColors$2(editor), hasCustomColors$1(editor)),
        onAction: function (_splitButtonApi) {
          applyColor(editor, format, lastColor.get(), noop);
        },
        onItemAction: function (_splitButtonApi, value) {
          applyColor(editor, format, value, function (newColor) {
            lastColor.set(newColor);
            fireTextColorChange(editor, {
              name: name,
              color: newColor
            });
          });
        },
        onSetup: function (splitButtonApi) {
          setIconColor(splitButtonApi, name, lastColor.get());
          var handler = function (e) {
            if (e.name === name) {
              setIconColor(splitButtonApi, e.name, e.color);
            }
          };
          editor.on('TextColorChange', handler);
          return function () {
            editor.off('TextColorChange', handler);
          };
        }
      });
    };
    var registerTextColorMenuItem = function (editor, name, format, text) {
      editor.ui.registry.addNestedMenuItem(name, {
        text: text,
        icon: name === 'forecolor' ? 'text-color' : 'highlight-bg-color',
        getSubmenuItems: function () {
          return [{
              type: 'fancymenuitem',
              fancytype: 'colorswatch',
              onAction: function (data) {
                applyColor(editor, format, data.value, noop);
              }
            }];
        }
      });
    };
    var colorPickerDialog = function (editor) {
      return function (callback, value) {
        var isValid = false;
        var onSubmit = function (api) {
          var data = api.getData();
          var hex = data.colorpicker;
          if (isValid) {
            callback(Optional.from(hex));
            api.close();
          } else {
            editor.windowManager.alert(editor.translate([
              'Invalid hex color code: {0}',
              hex
            ]));
          }
        };
        var onAction = function (_api, details) {
          if (details.name === 'hex-valid') {
            isValid = details.value;
          }
        };
        var initialData = { colorpicker: value };
        editor.windowManager.open({
          title: 'Color Picker',
          size: 'normal',
          body: {
            type: 'panel',
            items: [{
                type: 'colorpicker',
                name: 'colorpicker',
                label: 'Color'
              }]
          },
          buttons: [
            {
              type: 'cancel',
              name: 'cancel',
              text: 'Cancel'
            },
            {
              type: 'submit',
              name: 'save',
              text: 'Save',
              primary: true
            }
          ],
          initialData: initialData,
          onAction: onAction,
          onSubmit: onSubmit,
          onClose: noop,
          onCancel: function () {
            callback(Optional.none());
          }
        });
      };
    };
    var register$a = function (editor) {
      registerCommands(editor);
      var lastForeColor = Cell(fallbackColor);
      var lastBackColor = Cell(fallbackColor);
      registerTextColorButton(editor, 'forecolor', 'forecolor', 'Text color', lastForeColor);
      registerTextColorButton(editor, 'backcolor', 'hilitecolor', 'Background color', lastBackColor);
      registerTextColorMenuItem(editor, 'forecolor', 'forecolor', 'Text color');
      registerTextColorMenuItem(editor, 'backcolor', 'hilitecolor', 'Background color');
    };

    var createPartialChoiceMenu = function (value, items, onItemValueHandler, columns, presets, itemResponse, select, providersBackstage) {
      var hasIcons = menuHasIcons(items);
      var presetItemTypes = presets !== 'color' ? 'normal' : 'color';
      var alloyItems = createChoiceItems(items, onItemValueHandler, columns, presetItemTypes, itemResponse, select, providersBackstage);
      return createPartialMenuWithAlloyItems(value, hasIcons, alloyItems, columns, presets);
    };
    var createChoiceItems = function (items, onItemValueHandler, columns, itemPresets, itemResponse, select, providersBackstage) {
      return cat(map$2(items, function (item) {
        if (item.type === 'choiceitem') {
          return createChoiceMenuItem(item).fold(handleError, function (d) {
            return Optional.some(renderChoiceItem(d, columns === 1, itemPresets, onItemValueHandler, select(item.value), itemResponse, providersBackstage, menuHasIcons(items)));
          });
        } else {
          return Optional.none();
        }
      }));
    };

    var deriveMenuMovement = function (columns, presets) {
      var menuMarkers = markers(presets);
      if (columns === 1) {
        return {
          mode: 'menu',
          moveOnTab: true
        };
      } else if (columns === 'auto') {
        return {
          mode: 'grid',
          selector: '.' + menuMarkers.item,
          initSize: {
            numColumns: 1,
            numRows: 1
          }
        };
      } else {
        var rowClass = presets === 'color' ? 'tox-swatches__row' : 'tox-collection__group';
        return {
          mode: 'matrix',
          rowSelector: '.' + rowClass
        };
      }
    };
    var deriveCollectionMovement = function (columns, presets) {
      if (columns === 1) {
        return {
          mode: 'menu',
          moveOnTab: false,
          selector: '.tox-collection__item'
        };
      } else if (columns === 'auto') {
        return {
          mode: 'flatgrid',
          selector: '.' + 'tox-collection__item',
          initSize: {
            numColumns: 1,
            numRows: 1
          }
        };
      } else {
        return {
          mode: 'matrix',
          selectors: {
            row: presets === 'color' ? '.tox-swatches__row' : '.tox-collection__group',
            cell: presets === 'color' ? '.' + colorClass : '.' + selectableClass
          }
        };
      }
    };

    var renderColorSwatchItem = function (spec, backstage) {
      var items = getColorItems(spec, backstage);
      var columns = backstage.colorinput.getColorCols();
      var presets = 'color';
      var menuSpec = createPartialChoiceMenu(generate$6('menu-value'), items, function (value) {
        spec.onAction({ value: value });
      }, columns, presets, ItemResponse$1.CLOSE_ON_EXECUTE, never, backstage.shared.providers);
      var widgetSpec = __assign(__assign({}, menuSpec), {
        markers: markers(presets),
        movement: deriveMenuMovement(columns, presets)
      });
      return {
        type: 'widget',
        data: { value: generate$6('widget-id') },
        dom: {
          tag: 'div',
          classes: ['tox-fancymenuitem']
        },
        autofocus: true,
        components: [parts$f.widget(Menu.sketch(widgetSpec))]
      };
    };
    var getColorItems = function (spec, backstage) {
      var useCustomColors = spec.initData.allowCustomColors && backstage.colorinput.hasCustomColors();
      return spec.initData.colors.fold(function () {
        return getColors$1(backstage.colorinput.getColors(), useCustomColors);
      }, function (colors) {
        return colors.concat(getAdditionalColors(useCustomColors));
      });
    };

    var cellOverEvent = generate$6('cell-over');
    var cellExecuteEvent = generate$6('cell-execute');
    var makeCell = function (row, col, labelId) {
      var _a;
      var emitCellOver = function (c) {
        return emitWith(c, cellOverEvent, {
          row: row,
          col: col
        });
      };
      var emitExecute = function (c) {
        return emitWith(c, cellExecuteEvent, {
          row: row,
          col: col
        });
      };
      var onClick = function (c, se) {
        se.stop();
        emitExecute(c);
      };
      return build$1({
        dom: {
          tag: 'div',
          attributes: (_a = { role: 'button' }, _a['aria-labelledby'] = labelId, _a)
        },
        behaviours: derive$1([
          config('insert-table-picker-cell', [
            run$1(mouseover(), Focusing.focus),
            run$1(execute$5(), emitExecute),
            run$1(click(), onClick),
            run$1(tap(), onClick)
          ]),
          Toggling.config({
            toggleClass: 'tox-insert-table-picker__selected',
            toggleOnExecute: false
          }),
          Focusing.config({ onFocus: emitCellOver })
        ])
      });
    };
    var makeCells = function (labelId, numRows, numCols) {
      var cells = [];
      for (var i = 0; i < numRows; i++) {
        var row = [];
        for (var j = 0; j < numCols; j++) {
          row.push(makeCell(i, j, labelId));
        }
        cells.push(row);
      }
      return cells;
    };
    var selectCells = function (cells, selectedRow, selectedColumn, numRows, numColumns) {
      for (var i = 0; i < numRows; i++) {
        for (var j = 0; j < numColumns; j++) {
          Toggling.set(cells[i][j], i <= selectedRow && j <= selectedColumn);
        }
      }
    };
    var makeComponents = function (cells) {
      return bind$3(cells, function (cellRow) {
        return map$2(cellRow, premade);
      });
    };
    var makeLabelText = function (row, col) {
      return text(col + 'x' + row);
    };
    var renderInsertTableMenuItem = function (spec) {
      var numRows = 10;
      var numColumns = 10;
      var sizeLabelId = generate$6('size-label');
      var cells = makeCells(sizeLabelId, numRows, numColumns);
      var emptyLabelText = makeLabelText(0, 0);
      var memLabel = record({
        dom: {
          tag: 'span',
          classes: ['tox-insert-table-picker__label'],
          attributes: { id: sizeLabelId }
        },
        components: [emptyLabelText],
        behaviours: derive$1([Replacing.config({})])
      });
      return {
        type: 'widget',
        data: { value: generate$6('widget-id') },
        dom: {
          tag: 'div',
          classes: ['tox-fancymenuitem']
        },
        autofocus: true,
        components: [parts$f.widget({
            dom: {
              tag: 'div',
              classes: ['tox-insert-table-picker']
            },
            components: makeComponents(cells).concat(memLabel.asSpec()),
            behaviours: derive$1([
              config('insert-table-picker', [
                runOnAttached(function (c) {
                  Replacing.set(memLabel.get(c), [emptyLabelText]);
                }),
                runWithTarget(cellOverEvent, function (c, t, e) {
                  var _a = e.event, row = _a.row, col = _a.col;
                  selectCells(cells, row, col, numRows, numColumns);
                  Replacing.set(memLabel.get(c), [makeLabelText(row + 1, col + 1)]);
                }),
                runWithTarget(cellExecuteEvent, function (c, _, e) {
                  var _a = e.event, row = _a.row, col = _a.col;
                  spec.onAction({
                    numRows: row + 1,
                    numColumns: col + 1
                  });
                  emit(c, sandboxClose());
                })
              ]),
              Keying.config({
                initSize: {
                  numRows: numRows,
                  numColumns: numColumns
                },
                mode: 'flatgrid',
                selector: '[role="button"]'
              })
            ])
          })]
      };
    };

    var fancyMenuItems = {
      inserttable: renderInsertTableMenuItem,
      colorswatch: renderColorSwatchItem
    };
    var renderFancyMenuItem = function (spec, backstage) {
      return get$e(fancyMenuItems, spec.fancytype).map(function (render) {
        return render(spec, backstage);
      });
    };

    var renderNestedItem = function (spec, itemResponse, providersBackstage, renderIcons, downwardsCaret) {
      if (renderIcons === void 0) {
        renderIcons = true;
      }
      if (downwardsCaret === void 0) {
        downwardsCaret = false;
      }
      var caret = downwardsCaret ? renderDownwardsCaret(providersBackstage.icons) : renderSubmenuCaret(providersBackstage.icons);
      var getApi = function (component) {
        return {
          isDisabled: function () {
            return Disabling.isDisabled(component);
          },
          setDisabled: function (state) {
            return Disabling.set(component, state);
          }
        };
      };
      var structure = renderItemStructure({
        presets: 'normal',
        iconContent: spec.icon,
        textContent: spec.text,
        htmlContent: Optional.none(),
        ariaLabel: spec.text,
        caret: Optional.some(caret),
        checkMark: Optional.none(),
        shortcutContent: spec.shortcut
      }, providersBackstage, renderIcons);
      return renderCommonItem({
        data: buildData(spec),
        getApi: getApi,
        disabled: spec.disabled,
        onAction: noop,
        onSetup: spec.onSetup,
        triggersSubmenu: true,
        itemBehaviours: []
      }, structure, itemResponse, providersBackstage);
    };

    var renderNormalItem = function (spec, itemResponse, providersBackstage, renderIcons) {
      if (renderIcons === void 0) {
        renderIcons = true;
      }
      var getApi = function (component) {
        return {
          isDisabled: function () {
            return Disabling.isDisabled(component);
          },
          setDisabled: function (state) {
            return Disabling.set(component, state);
          }
        };
      };
      var structure = renderItemStructure({
        presets: 'normal',
        iconContent: spec.icon,
        textContent: spec.text,
        htmlContent: Optional.none(),
        ariaLabel: spec.text,
        caret: Optional.none(),
        checkMark: Optional.none(),
        shortcutContent: spec.shortcut
      }, providersBackstage, renderIcons);
      return renderCommonItem({
        data: buildData(spec),
        getApi: getApi,
        disabled: spec.disabled,
        onAction: spec.onAction,
        onSetup: spec.onSetup,
        triggersSubmenu: false,
        itemBehaviours: []
      }, structure, itemResponse, providersBackstage);
    };

    var renderSeparatorItem = function (spec) {
      var innerHtml = spec.text.fold(function () {
        return {};
      }, function (text) {
        return { innerHtml: text };
      });
      return {
        type: 'separator',
        dom: __assign({
          tag: 'div',
          classes: [
            selectableClass,
            groupHeadingClass
          ]
        }, innerHtml),
        components: []
      };
    };

    var renderToggleMenuItem = function (spec, itemResponse, providersBackstage, renderIcons) {
      if (renderIcons === void 0) {
        renderIcons = true;
      }
      var getApi = function (component) {
        return {
          setActive: function (state) {
            Toggling.set(component, state);
          },
          isActive: function () {
            return Toggling.isOn(component);
          },
          isDisabled: function () {
            return Disabling.isDisabled(component);
          },
          setDisabled: function (state) {
            return Disabling.set(component, state);
          }
        };
      };
      var structure = renderItemStructure({
        iconContent: spec.icon,
        textContent: spec.text,
        htmlContent: Optional.none(),
        ariaLabel: spec.text,
        checkMark: Optional.some(renderCheckmark(providersBackstage.icons)),
        caret: Optional.none(),
        shortcutContent: spec.shortcut,
        presets: 'normal',
        meta: spec.meta
      }, providersBackstage, renderIcons);
      return deepMerge(renderCommonItem({
        data: buildData(spec),
        disabled: spec.disabled,
        getApi: getApi,
        onAction: spec.onAction,
        onSetup: spec.onSetup,
        triggersSubmenu: false,
        itemBehaviours: []
      }, structure, itemResponse, providersBackstage), {
        toggling: {
          toggleClass: tickedClass,
          toggleOnExecute: false,
          selected: spec.active
        }
      });
    };

    var autocomplete = renderAutocompleteItem;
    var separator$3 = renderSeparatorItem;
    var normal = renderNormalItem;
    var nested = renderNestedItem;
    var toggle$1 = renderToggleMenuItem;
    var fancy = renderFancyMenuItem;
    var card = renderCardMenuItem;

    var FocusMode;
    (function (FocusMode) {
      FocusMode[FocusMode['ContentFocus'] = 0] = 'ContentFocus';
      FocusMode[FocusMode['UiFocus'] = 1] = 'UiFocus';
    }(FocusMode || (FocusMode = {})));
    var createMenuItemFromBridge = function (item, itemResponse, backstage, menuHasIcons, isHorizontalMenu) {
      var providersBackstage = backstage.shared.providers;
      var parseForHorizontalMenu = function (menuitem) {
        return !isHorizontalMenu ? menuitem : __assign(__assign({}, menuitem), {
          shortcut: Optional.none(),
          icon: menuitem.text.isSome() ? Optional.none() : menuitem.icon
        });
      };
      switch (item.type) {
      case 'menuitem':
        return createMenuItem(item).fold(handleError, function (d) {
          return Optional.some(normal(parseForHorizontalMenu(d), itemResponse, providersBackstage, menuHasIcons));
        });
      case 'nestedmenuitem':
        return createNestedMenuItem(item).fold(handleError, function (d) {
          return Optional.some(nested(parseForHorizontalMenu(d), itemResponse, providersBackstage, menuHasIcons, isHorizontalMenu));
        });
      case 'togglemenuitem':
        return createToggleMenuItem(item).fold(handleError, function (d) {
          return Optional.some(toggle$1(parseForHorizontalMenu(d), itemResponse, providersBackstage, menuHasIcons));
        });
      case 'separator':
        return createSeparatorMenuItem(item).fold(handleError, function (d) {
          return Optional.some(separator$3(d));
        });
      case 'fancymenuitem':
        return createFancyMenuItem(item).fold(handleError, function (d) {
          return fancy(parseForHorizontalMenu(d), backstage);
        });
      default: {
          console.error('Unknown item in general menu', item);
          return Optional.none();
        }
      }
    };
    var createAutocompleteItems = function (items, matchText, onItemValueHandler, columns, itemResponse, sharedBackstage, highlightOn) {
      var renderText = columns === 1;
      var renderIcons = !renderText || menuHasIcons(items);
      return cat(map$2(items, function (item) {
        switch (item.type) {
        case 'separator':
          return createSeparatorItem(item).fold(handleError, function (d) {
            return Optional.some(separator$3(d));
          });
        case 'cardmenuitem':
          return createCardMenuItem(item).fold(handleError, function (d) {
            return Optional.some(card(__assign(__assign({}, d), {
              onAction: function (api) {
                d.onAction(api);
                onItemValueHandler(d.value, d.meta);
              }
            }), itemResponse, sharedBackstage, {
              itemBehaviours: tooltipBehaviour(d.meta, sharedBackstage),
              cardText: {
                matchText: matchText,
                highlightOn: highlightOn
              }
            }));
          });
        case 'autocompleteitem':
        default:
          return createAutocompleterItem(item).fold(handleError, function (d) {
            return Optional.some(autocomplete(d, matchText, renderText, 'normal', onItemValueHandler, itemResponse, sharedBackstage, renderIcons));
          });
        }
      }));
    };
    var createPartialMenu = function (value, items, itemResponse, backstage, isHorizontalMenu) {
      var hasIcons = menuHasIcons(items);
      var alloyItems = cat(map$2(items, function (item) {
        var itemHasIcon = function (i) {
          return isHorizontalMenu ? !has$2(i, 'text') : hasIcons;
        };
        var createItem = function (i) {
          return createMenuItemFromBridge(i, itemResponse, backstage, itemHasIcon(i), isHorizontalMenu);
        };
        if (item.type === 'nestedmenuitem' && item.getSubmenuItems().length <= 0) {
          return createItem(__assign(__assign({}, item), { disabled: true }));
        } else {
          return createItem(item);
        }
      }));
      var createPartial = isHorizontalMenu ? createHorizontalPartialMenuWithAlloyItems : createPartialMenuWithAlloyItems;
      return createPartial(value, hasIcons, alloyItems, 1, 'normal');
    };
    var createTieredDataFrom = function (partialMenu) {
      return tieredMenu.singleData(partialMenu.value, partialMenu);
    };
    var createMenuFrom = function (partialMenu, columns, focusMode, presets) {
      var focusManager = focusMode === FocusMode.ContentFocus ? highlights() : dom$2();
      var movement = deriveMenuMovement(columns, presets);
      var menuMarkers = markers(presets);
      return {
        dom: partialMenu.dom,
        components: partialMenu.components,
        items: partialMenu.items,
        value: partialMenu.value,
        markers: {
          selectedItem: menuMarkers.selectedItem,
          item: menuMarkers.item
        },
        movement: movement,
        fakeFocus: focusMode === FocusMode.ContentFocus,
        focusManager: focusManager,
        menuBehaviours: SimpleBehaviours.unnamedEvents(columns !== 'auto' ? [] : [runOnAttached(function (comp, _se) {
            detectSize(comp, 4, menuMarkers.item).each(function (_a) {
              var numColumns = _a.numColumns, numRows = _a.numRows;
              Keying.setGridSize(comp, numRows, numColumns);
            });
          })])
      };
    };

    var register$9 = function (editor, sharedBackstage) {
      var activeAutocompleter = value$1();
      var processingAction = Cell(false);
      var autocompleter = build$1(InlineView.sketch({
        dom: {
          tag: 'div',
          classes: ['tox-autocompleter']
        },
        components: [],
        fireDismissalEventInstead: {},
        inlineBehaviours: derive$1([config('dismissAutocompleter', [run$1(dismissRequested(), function () {
              return cancelIfNecessary();
            })])]),
        lazySink: sharedBackstage.getSink
      }));
      var isMenuOpen = function () {
        return InlineView.isOpen(autocompleter);
      };
      var isActive = function () {
        return activeAutocompleter.get().isSome();
      };
      var hideIfNecessary = function () {
        if (isActive()) {
          InlineView.hide(autocompleter);
        }
      };
      var cancelIfNecessary = function () {
        if (isActive()) {
          var lastElement = activeAutocompleter.get().map(function (ac) {
            return ac.element;
          });
          detect(lastElement.getOr(SugarElement.fromDom(editor.selection.getNode()))).each(unwrap);
          hideIfNecessary();
          activeAutocompleter.clear();
          processingAction.set(false);
        }
      };
      var getAutocompleters = cached(function () {
        return register$b(editor);
      });
      var getCombinedItems = function (triggerChar, matches) {
        var columns = findMap(matches, function (m) {
          return Optional.from(m.columns);
        }).getOr(1);
        return bind$3(matches, function (match) {
          var choices = match.items;
          return createAutocompleteItems(choices, match.matchText, function (itemValue, itemMeta) {
            var nr = editor.selection.getRng();
            getContext(editor.dom, nr, triggerChar).fold(function () {
              return console.error('Lost context. Cursor probably moved');
            }, function (_a) {
              var range = _a.range;
              var autocompleterApi = {
                hide: function () {
                  cancelIfNecessary();
                },
                reload: function (fetchOptions) {
                  hideIfNecessary();
                  load(fetchOptions);
                }
              };
              processingAction.set(true);
              match.onAction(autocompleterApi, range, itemValue, itemMeta);
              processingAction.set(false);
            });
          }, columns, ItemResponse$1.BUBBLE_TO_SANDBOX, sharedBackstage, match.highlightOn);
        });
      };
      var commenceIfNecessary = function (context) {
        if (!isActive()) {
          var wrapper = create$4(editor, context.range);
          activeAutocompleter.set({
            triggerChar: context.triggerChar,
            element: wrapper,
            matchLength: context.text.length
          });
          processingAction.set(false);
        }
      };
      var display = function (ac, context, lookupData, items) {
        ac.matchLength = context.text.length;
        var columns = findMap(lookupData, function (ld) {
          return Optional.from(ld.columns);
        }).getOr(1);
        InlineView.showAt(autocompleter, Menu.sketch(createMenuFrom(createPartialMenuWithAlloyItems('autocompleter-value', true, items, columns, 'normal'), columns, FocusMode.ContentFocus, 'normal')), {
          anchor: {
            type: 'node',
            root: SugarElement.fromDom(editor.getBody()),
            node: Optional.from(ac.element)
          }
        });
        InlineView.getContent(autocompleter).each(Highlighting.highlightFirst);
      };
      var doLookup = function (fetchOptions) {
        return activeAutocompleter.get().map(function (ac) {
          return getContext(editor.dom, editor.selection.getRng(), ac.triggerChar).bind(function (newContext) {
            return lookupWithContext(editor, getAutocompleters, newContext, fetchOptions);
          });
        }).getOrThunk(function () {
          return lookup$2(editor, getAutocompleters);
        });
      };
      var load = function (fetchOptions) {
        doLookup(fetchOptions).fold(cancelIfNecessary, function (lookupInfo) {
          commenceIfNecessary(lookupInfo.context);
          lookupInfo.lookupData.then(function (lookupData) {
            activeAutocompleter.get().map(function (ac) {
              var context = lookupInfo.context;
              if (ac.triggerChar === context.triggerChar) {
                var combinedItems = getCombinedItems(context.triggerChar, lookupData);
                if (combinedItems.length > 0) {
                  display(ac, context, lookupData, combinedItems);
                } else if (context.text.length - ac.matchLength >= 10) {
                  cancelIfNecessary();
                } else {
                  hideIfNecessary();
                }
              }
            });
          });
        });
      };
      var onKeypress = last(function (e) {
        if (e.which === 27) {
          return;
        }
        load();
      }, 50);
      var autocompleterUiApi = {
        onKeypress: onKeypress,
        cancelIfNecessary: cancelIfNecessary,
        isMenuOpen: isMenuOpen,
        isActive: isActive,
        isProcessingAction: processingAction.get,
        getView: function () {
          return InlineView.getContent(autocompleter);
        }
      };
      if (editor.hasPlugin('rtc') === false) {
        AutocompleterEditorEvents.setup(autocompleterUiApi, editor);
      }
    };
    var Autocompleter = { register: register$9 };

    var closest = function (scope, selector, isRoot) {
      return closest$1(scope, selector, isRoot).isSome();
    };

    var DelayedFunction = function (fun, delay) {
      var ref = null;
      var schedule = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        ref = setTimeout(function () {
          fun.apply(null, args);
          ref = null;
        }, delay);
      };
      var cancel = function () {
        if (ref !== null) {
          clearTimeout(ref);
          ref = null;
        }
      };
      return {
        cancel: cancel,
        schedule: schedule
      };
    };

    var SIGNIFICANT_MOVE = 5;
    var LONGPRESS_DELAY = 400;
    var getTouch = function (event) {
      var raw = event.raw;
      if (raw.touches === undefined || raw.touches.length !== 1) {
        return Optional.none();
      }
      return Optional.some(raw.touches[0]);
    };
    var isFarEnough = function (touch, data) {
      var distX = Math.abs(touch.clientX - data.x);
      var distY = Math.abs(touch.clientY - data.y);
      return distX > SIGNIFICANT_MOVE || distY > SIGNIFICANT_MOVE;
    };
    var monitor = function (settings) {
      var startData = value$1();
      var longpressFired = Cell(false);
      var longpress$1 = DelayedFunction(function (event) {
        settings.triggerEvent(longpress(), event);
        longpressFired.set(true);
      }, LONGPRESS_DELAY);
      var handleTouchstart = function (event) {
        getTouch(event).each(function (touch) {
          longpress$1.cancel();
          var data = {
            x: touch.clientX,
            y: touch.clientY,
            target: event.target
          };
          longpress$1.schedule(event);
          longpressFired.set(false);
          startData.set(data);
        });
        return Optional.none();
      };
      var handleTouchmove = function (event) {
        longpress$1.cancel();
        getTouch(event).each(function (touch) {
          startData.on(function (data) {
            if (isFarEnough(touch, data)) {
              startData.clear();
            }
          });
        });
        return Optional.none();
      };
      var handleTouchend = function (event) {
        longpress$1.cancel();
        var isSame = function (data) {
          return eq(data.target, event.target);
        };
        return startData.get().filter(isSame).map(function (_data) {
          if (longpressFired.get()) {
            event.prevent();
            return false;
          } else {
            return settings.triggerEvent(tap(), event);
          }
        });
      };
      var handlers = wrapAll([
        {
          key: touchstart(),
          value: handleTouchstart
        },
        {
          key: touchmove(),
          value: handleTouchmove
        },
        {
          key: touchend(),
          value: handleTouchend
        }
      ]);
      var fireIfReady = function (event, type) {
        return get$e(handlers, type).bind(function (handler) {
          return handler(event);
        });
      };
      return { fireIfReady: fireIfReady };
    };

    var isDangerous = function (event) {
      var keyEv = event.raw;
      return keyEv.which === BACKSPACE[0] && !contains$2([
        'input',
        'textarea'
      ], name$2(event.target)) && !closest(event.target, '[contenteditable="true"]');
    };
    var isFirefox = function () {
      return detect$1().browser.isFirefox();
    };
    var bindFocus = function (container, handler) {
      if (isFirefox()) {
        return capture(container, 'focus', handler);
      } else {
        return bind(container, 'focusin', handler);
      }
    };
    var bindBlur = function (container, handler) {
      if (isFirefox()) {
        return capture(container, 'blur', handler);
      } else {
        return bind(container, 'focusout', handler);
      }
    };
    var setup$d = function (container, rawSettings) {
      var settings = __assign({ stopBackspace: true }, rawSettings);
      var pointerEvents = [
        'touchstart',
        'touchmove',
        'touchend',
        'touchcancel',
        'gesturestart',
        'mousedown',
        'mouseup',
        'mouseover',
        'mousemove',
        'mouseout',
        'click'
      ];
      var tapEvent = monitor(settings);
      var simpleEvents = map$2(pointerEvents.concat([
        'selectstart',
        'input',
        'contextmenu',
        'change',
        'transitionend',
        'transitioncancel',
        'drag',
        'dragstart',
        'dragend',
        'dragenter',
        'dragleave',
        'dragover',
        'drop',
        'keyup'
      ]), function (type) {
        return bind(container, type, function (event) {
          tapEvent.fireIfReady(event, type).each(function (tapStopped) {
            if (tapStopped) {
              event.kill();
            }
          });
          var stopped = settings.triggerEvent(type, event);
          if (stopped) {
            event.kill();
          }
        });
      });
      var pasteTimeout = value$1();
      var onPaste = bind(container, 'paste', function (event) {
        tapEvent.fireIfReady(event, 'paste').each(function (tapStopped) {
          if (tapStopped) {
            event.kill();
          }
        });
        var stopped = settings.triggerEvent('paste', event);
        if (stopped) {
          event.kill();
        }
        pasteTimeout.set(setTimeout(function () {
          settings.triggerEvent(postPaste(), event);
        }, 0));
      });
      var onKeydown = bind(container, 'keydown', function (event) {
        var stopped = settings.triggerEvent('keydown', event);
        if (stopped) {
          event.kill();
        } else if (settings.stopBackspace && isDangerous(event)) {
          event.prevent();
        }
      });
      var onFocusIn = bindFocus(container, function (event) {
        var stopped = settings.triggerEvent('focusin', event);
        if (stopped) {
          event.kill();
        }
      });
      var focusoutTimeout = value$1();
      var onFocusOut = bindBlur(container, function (event) {
        var stopped = settings.triggerEvent('focusout', event);
        if (stopped) {
          event.kill();
        }
        focusoutTimeout.set(setTimeout(function () {
          settings.triggerEvent(postBlur(), event);
        }, 0));
      });
      var unbind = function () {
        each$1(simpleEvents, function (e) {
          e.unbind();
        });
        onKeydown.unbind();
        onFocusIn.unbind();
        onFocusOut.unbind();
        onPaste.unbind();
        pasteTimeout.on(clearTimeout);
        focusoutTimeout.on(clearTimeout);
      };
      return { unbind: unbind };
    };

    var derive = function (rawEvent, rawTarget) {
      var source = get$e(rawEvent, 'target').getOr(rawTarget);
      return Cell(source);
    };

    var fromSource = function (event, source) {
      var stopper = Cell(false);
      var cutter = Cell(false);
      var stop = function () {
        stopper.set(true);
      };
      var cut = function () {
        cutter.set(true);
      };
      return {
        stop: stop,
        cut: cut,
        isStopped: stopper.get,
        isCut: cutter.get,
        event: event,
        setSource: source.set,
        getSource: source.get
      };
    };
    var fromExternal = function (event) {
      var stopper = Cell(false);
      var stop = function () {
        stopper.set(true);
      };
      return {
        stop: stop,
        cut: noop,
        isStopped: stopper.get,
        isCut: never,
        event: event,
        setSource: die('Cannot set source of a broadcasted event'),
        getSource: die('Cannot get source of a broadcasted event')
      };
    };

    var adt$1 = Adt.generate([
      { stopped: [] },
      { resume: ['element'] },
      { complete: [] }
    ]);
    var doTriggerHandler = function (lookup, eventType, rawEvent, target, source, logger) {
      var handler = lookup(eventType, target);
      var simulatedEvent = fromSource(rawEvent, source);
      return handler.fold(function () {
        logger.logEventNoHandlers(eventType, target);
        return adt$1.complete();
      }, function (handlerInfo) {
        var descHandler = handlerInfo.descHandler;
        var eventHandler = getCurried(descHandler);
        eventHandler(simulatedEvent);
        if (simulatedEvent.isStopped()) {
          logger.logEventStopped(eventType, handlerInfo.element, descHandler.purpose);
          return adt$1.stopped();
        } else if (simulatedEvent.isCut()) {
          logger.logEventCut(eventType, handlerInfo.element, descHandler.purpose);
          return adt$1.complete();
        } else {
          return parent(handlerInfo.element).fold(function () {
            logger.logNoParent(eventType, handlerInfo.element, descHandler.purpose);
            return adt$1.complete();
          }, function (parent) {
            logger.logEventResponse(eventType, handlerInfo.element, descHandler.purpose);
            return adt$1.resume(parent);
          });
        }
      });
    };
    var doTriggerOnUntilStopped = function (lookup, eventType, rawEvent, rawTarget, source, logger) {
      return doTriggerHandler(lookup, eventType, rawEvent, rawTarget, source, logger).fold(always, function (parent) {
        return doTriggerOnUntilStopped(lookup, eventType, rawEvent, parent, source, logger);
      }, never);
    };
    var triggerHandler = function (lookup, eventType, rawEvent, target, logger) {
      var source = derive(rawEvent, target);
      return doTriggerHandler(lookup, eventType, rawEvent, target, source, logger);
    };
    var broadcast = function (listeners, rawEvent, _logger) {
      var simulatedEvent = fromExternal(rawEvent);
      each$1(listeners, function (listener) {
        var descHandler = listener.descHandler;
        var handler = getCurried(descHandler);
        handler(simulatedEvent);
      });
      return simulatedEvent.isStopped();
    };
    var triggerUntilStopped = function (lookup, eventType, rawEvent, logger) {
      return triggerOnUntilStopped(lookup, eventType, rawEvent, rawEvent.target, logger);
    };
    var triggerOnUntilStopped = function (lookup, eventType, rawEvent, rawTarget, logger) {
      var source = derive(rawEvent, rawTarget);
      return doTriggerOnUntilStopped(lookup, eventType, rawEvent, rawTarget, source, logger);
    };

    var eventHandler = function (element, descHandler) {
      return {
        element: element,
        descHandler: descHandler
      };
    };
    var broadcastHandler = function (id, handler) {
      return {
        id: id,
        descHandler: handler
      };
    };
    var EventRegistry = function () {
      var registry = {};
      var registerId = function (extraArgs, id, events) {
        each(events, function (v, k) {
          var handlers = registry[k] !== undefined ? registry[k] : {};
          handlers[id] = curryArgs(v, extraArgs);
          registry[k] = handlers;
        });
      };
      var findHandler = function (handlers, elem) {
        return read$1(elem).bind(function (id) {
          return get$e(handlers, id);
        }).map(function (descHandler) {
          return eventHandler(elem, descHandler);
        });
      };
      var filterByType = function (type) {
        return get$e(registry, type).map(function (handlers) {
          return mapToArray(handlers, function (f, id) {
            return broadcastHandler(id, f);
          });
        }).getOr([]);
      };
      var find = function (isAboveRoot, type, target) {
        return get$e(registry, type).bind(function (handlers) {
          return closest$4(target, function (elem) {
            return findHandler(handlers, elem);
          }, isAboveRoot);
        });
      };
      var unregisterId = function (id) {
        each(registry, function (handlersById, _eventName) {
          if (has$2(handlersById, id)) {
            delete handlersById[id];
          }
        });
      };
      return {
        registerId: registerId,
        unregisterId: unregisterId,
        filterByType: filterByType,
        find: find
      };
    };

    var Registry = function () {
      var events = EventRegistry();
      var components = {};
      var readOrTag = function (component) {
        var elem = component.element;
        return read$1(elem).getOrThunk(function () {
          return write('uid-', component.element);
        });
      };
      var failOnDuplicate = function (component, tagId) {
        var conflict = components[tagId];
        if (conflict === component) {
          unregister(component);
        } else {
          throw new Error('The tagId "' + tagId + '" is already used by: ' + element(conflict.element) + '\nCannot use it for: ' + element(component.element) + '\n' + 'The conflicting element is' + (inBody(conflict.element) ? ' ' : ' not ') + 'already in the DOM');
        }
      };
      var register = function (component) {
        var tagId = readOrTag(component);
        if (hasNonNullableKey(components, tagId)) {
          failOnDuplicate(component, tagId);
        }
        var extraArgs = [component];
        events.registerId(extraArgs, tagId, component.events);
        components[tagId] = component;
      };
      var unregister = function (component) {
        read$1(component.element).each(function (tagId) {
          delete components[tagId];
          events.unregisterId(tagId);
        });
      };
      var filter = function (type) {
        return events.filterByType(type);
      };
      var find = function (isAboveRoot, type, target) {
        return events.find(isAboveRoot, type, target);
      };
      var getById = function (id) {
        return get$e(components, id);
      };
      return {
        find: find,
        filter: filter,
        register: register,
        unregister: unregister,
        getById: getById
      };
    };

    var factory$j = function (detail) {
      var _a = detail.dom, attributes = _a.attributes, domWithoutAttributes = __rest(_a, ['attributes']);
      return {
        uid: detail.uid,
        dom: __assign({
          tag: 'div',
          attributes: __assign({ role: 'presentation' }, attributes)
        }, domWithoutAttributes),
        components: detail.components,
        behaviours: get$2(detail.containerBehaviours),
        events: detail.events,
        domModification: detail.domModification,
        eventOrder: detail.eventOrder
      };
    };
    var Container = single({
      name: 'Container',
      factory: factory$j,
      configFields: [
        defaulted('components', []),
        field('containerBehaviours', []),
        defaulted('events', {}),
        defaulted('domModification', {}),
        defaulted('eventOrder', {})
      ]
    });

    var takeover = function (root) {
      var isAboveRoot = function (el) {
        return parent(root.element).fold(always, function (parent) {
          return eq(el, parent);
        });
      };
      var registry = Registry();
      var lookup = function (eventName, target) {
        return registry.find(isAboveRoot, eventName, target);
      };
      var domEvents = setup$d(root.element, {
        triggerEvent: function (eventName, event) {
          return monitorEvent(eventName, event.target, function (logger) {
            return triggerUntilStopped(lookup, eventName, event, logger);
          });
        }
      });
      var systemApi = {
        debugInfo: constant$1('real'),
        triggerEvent: function (eventName, target, data) {
          monitorEvent(eventName, target, function (logger) {
            return triggerOnUntilStopped(lookup, eventName, data, target, logger);
          });
        },
        triggerFocus: function (target, originator) {
          read$1(target).fold(function () {
            focus$3(target);
          }, function (_alloyId) {
            monitorEvent(focus$4(), target, function (logger) {
              triggerHandler(lookup, focus$4(), {
                originator: originator,
                kill: noop,
                prevent: noop,
                target: target
              }, target, logger);
              return false;
            });
          });
        },
        triggerEscape: function (comp, simulatedEvent) {
          systemApi.triggerEvent('keydown', comp.element, simulatedEvent.event);
        },
        getByUid: function (uid) {
          return getByUid(uid);
        },
        getByDom: function (elem) {
          return getByDom(elem);
        },
        build: build$1,
        addToGui: function (c) {
          add(c);
        },
        removeFromGui: function (c) {
          remove(c);
        },
        addToWorld: function (c) {
          addToWorld(c);
        },
        removeFromWorld: function (c) {
          removeFromWorld(c);
        },
        broadcast: function (message) {
          broadcast$1(message);
        },
        broadcastOn: function (channels, message) {
          broadcastOn(channels, message);
        },
        broadcastEvent: function (eventName, event) {
          broadcastEvent(eventName, event);
        },
        isConnected: always
      };
      var addToWorld = function (component) {
        component.connect(systemApi);
        if (!isText$1(component.element)) {
          registry.register(component);
          each$1(component.components(), addToWorld);
          systemApi.triggerEvent(systemInit(), component.element, { target: component.element });
        }
      };
      var removeFromWorld = function (component) {
        if (!isText$1(component.element)) {
          each$1(component.components(), removeFromWorld);
          registry.unregister(component);
        }
        component.disconnect();
      };
      var add = function (component) {
        attach(root, component);
      };
      var remove = function (component) {
        detach(component);
      };
      var destroy = function () {
        domEvents.unbind();
        remove$5(root.element);
      };
      var broadcastData = function (data) {
        var receivers = registry.filter(receive());
        each$1(receivers, function (receiver) {
          var descHandler = receiver.descHandler;
          var handler = getCurried(descHandler);
          handler(data);
        });
      };
      var broadcast$1 = function (message) {
        broadcastData({
          universal: true,
          data: message
        });
      };
      var broadcastOn = function (channels, message) {
        broadcastData({
          universal: false,
          channels: channels,
          data: message
        });
      };
      var broadcastEvent = function (eventName, event) {
        var listeners = registry.filter(eventName);
        return broadcast(listeners, event);
      };
      var getByUid = function (uid) {
        return registry.getById(uid).fold(function () {
          return Result.error(new Error('Could not find component with uid: "' + uid + '" in system.'));
        }, Result.value);
      };
      var getByDom = function (elem) {
        var uid = read$1(elem).getOr('not found');
        return getByUid(uid);
      };
      addToWorld(root);
      return {
        root: root,
        element: root.element,
        destroy: destroy,
        add: add,
        remove: remove,
        getByUid: getByUid,
        getByDom: getByDom,
        addToWorld: addToWorld,
        removeFromWorld: removeFromWorld,
        broadcast: broadcast$1,
        broadcastOn: broadcastOn,
        broadcastEvent: broadcastEvent
      };
    };

    var renderBar = function (spec, backstage) {
      return {
        dom: {
          tag: 'div',
          classes: [
            'tox-bar',
            'tox-form__controls-h-stack'
          ]
        },
        components: map$2(spec.items, backstage.interpreter)
      };
    };

    var schema$l = constant$1([
      defaulted('prefix', 'form-field'),
      field('fieldBehaviours', [
        Composing,
        Representing
      ])
    ]);
    var parts$e = constant$1([
      optional({
        schema: [required$1('dom')],
        name: 'label'
      }),
      optional({
        factory: {
          sketch: function (spec) {
            return {
              uid: spec.uid,
              dom: {
                tag: 'span',
                styles: { display: 'none' },
                attributes: { 'aria-hidden': 'true' },
                innerHtml: spec.text
              }
            };
          }
        },
        schema: [required$1('text')],
        name: 'aria-descriptor'
      }),
      required({
        factory: {
          sketch: function (spec) {
            var excludeFactory = exclude(spec, ['factory']);
            return spec.factory.sketch(excludeFactory);
          }
        },
        schema: [required$1('factory')],
        name: 'field'
      })
    ]);

    var factory$i = function (detail, components, _spec, _externals) {
      var behaviours = augment(detail.fieldBehaviours, [
        Composing.config({
          find: function (container) {
            return getPart(container, detail, 'field');
          }
        }),
        Representing.config({
          store: {
            mode: 'manual',
            getValue: function (field) {
              return Composing.getCurrent(field).bind(Representing.getValue);
            },
            setValue: function (field, value) {
              Composing.getCurrent(field).each(function (current) {
                Representing.setValue(current, value);
              });
            }
          }
        })
      ]);
      var events = derive$2([runOnAttached(function (component, _simulatedEvent) {
          var ps = getParts(component, detail, [
            'label',
            'field',
            'aria-descriptor'
          ]);
          ps.field().each(function (field) {
            var id = generate$6(detail.prefix);
            ps.label().each(function (label) {
              set$8(label.element, 'for', id);
              set$8(field.element, 'id', id);
            });
            ps['aria-descriptor']().each(function (descriptor) {
              var descriptorId = generate$6(detail.prefix);
              set$8(descriptor.element, 'id', descriptorId);
              set$8(field.element, 'aria-describedby', descriptorId);
            });
          });
        })]);
      var apis = {
        getField: function (container) {
          return getPart(container, detail, 'field');
        },
        getLabel: function (container) {
          return getPart(container, detail, 'label');
        }
      };
      return {
        uid: detail.uid,
        dom: detail.dom,
        components: components,
        behaviours: behaviours,
        events: events,
        apis: apis
      };
    };
    var FormField = composite({
      name: 'FormField',
      configFields: schema$l(),
      partFields: parts$e(),
      factory: factory$i,
      apis: {
        getField: function (apis, comp) {
          return apis.getField(comp);
        },
        getLabel: function (apis, comp) {
          return apis.getLabel(comp);
        }
      }
    });

    var exhibit$2 = function (base, tabConfig) {
      return nu$7({
        attributes: wrapAll([{
            key: tabConfig.tabAttr,
            value: 'true'
          }])
      });
    };

    var ActiveTabstopping = /*#__PURE__*/Object.freeze({
        __proto__: null,
        exhibit: exhibit$2
    });

    var TabstopSchema = [defaulted('tabAttr', 'data-alloy-tabstop')];

    var Tabstopping = create$7({
      fields: TabstopSchema,
      name: 'tabstopping',
      active: ActiveTabstopping
    });

    var global$7 = tinymce.util.Tools.resolve('tinymce.html.Entities');

    var renderFormFieldWith = function (pLabel, pField, extraClasses, extraBehaviours) {
      var spec = renderFormFieldSpecWith(pLabel, pField, extraClasses, extraBehaviours);
      return FormField.sketch(spec);
    };
    var renderFormField = function (pLabel, pField) {
      return renderFormFieldWith(pLabel, pField, [], []);
    };
    var renderFormFieldSpecWith = function (pLabel, pField, extraClasses, extraBehaviours) {
      return {
        dom: renderFormFieldDomWith(extraClasses),
        components: pLabel.toArray().concat([pField]),
        fieldBehaviours: derive$1(extraBehaviours)
      };
    };
    var renderFormFieldDom = function () {
      return renderFormFieldDomWith([]);
    };
    var renderFormFieldDomWith = function (extraClasses) {
      return {
        tag: 'div',
        classes: ['tox-form__group'].concat(extraClasses)
      };
    };
    var renderLabel$2 = function (label, providersBackstage) {
      return FormField.parts.label({
        dom: {
          tag: 'label',
          classes: ['tox-label'],
          innerHtml: providersBackstage.translate(label)
        }
      });
    };

    var formChangeEvent = generate$6('form-component-change');
    var formCloseEvent = generate$6('form-close');
    var formCancelEvent = generate$6('form-cancel');
    var formActionEvent = generate$6('form-action');
    var formSubmitEvent = generate$6('form-submit');
    var formBlockEvent = generate$6('form-block');
    var formUnblockEvent = generate$6('form-unblock');
    var formTabChangeEvent = generate$6('form-tabchange');
    var formResizeEvent = generate$6('form-resize');

    var renderCollection = function (spec, providersBackstage) {
      var _a;
      var pLabel = spec.label.map(function (label) {
        return renderLabel$2(label, providersBackstage);
      });
      var runOnItem = function (f) {
        return function (comp, se) {
          closest$1(se.event.target, '[data-collection-item-value]').each(function (target) {
            f(comp, se, target, get$d(target, 'data-collection-item-value'));
          });
        };
      };
      var setContents = function (comp, items) {
        var htmlLines = map$2(items, function (item) {
          var itemText = global$e.translate(item.text);
          var textContent = spec.columns === 1 ? '<div class="tox-collection__item-label">' + itemText + '</div>' : '';
          var iconContent = '<div class="tox-collection__item-icon">' + item.icon + '</div>';
          var mapItemName = {
            '_': ' ',
            ' - ': ' ',
            '-': ' '
          };
          var ariaLabel = itemText.replace(/\_| \- |\-/g, function (match) {
            return mapItemName[match];
          });
          var disabledClass = providersBackstage.isDisabled() ? ' tox-collection__item--state-disabled' : '';
          return '<div class="tox-collection__item' + disabledClass + '" tabindex="-1" data-collection-item-value="' + global$7.encodeAllRaw(item.value) + '" title="' + ariaLabel + '" aria-label="' + ariaLabel + '">' + iconContent + textContent + '</div>';
        });
        var chunks = spec.columns !== 'auto' && spec.columns > 1 ? chunk$1(htmlLines, spec.columns) : [htmlLines];
        var html = map$2(chunks, function (ch) {
          return '<div class="tox-collection__group">' + ch.join('') + '</div>';
        });
        set$5(comp.element, html.join(''));
      };
      var onClick = runOnItem(function (comp, se, tgt, itemValue) {
        se.stop();
        if (!providersBackstage.isDisabled()) {
          emitWith(comp, formActionEvent, {
            name: spec.name,
            value: itemValue
          });
        }
      });
      var collectionEvents = [
        run$1(mouseover(), runOnItem(function (comp, se, tgt) {
          focus$3(tgt);
        })),
        run$1(click(), onClick),
        run$1(tap(), onClick),
        run$1(focusin(), runOnItem(function (comp, se, tgt) {
          descendant(comp.element, '.' + activeClass).each(function (currentActive) {
            remove$2(currentActive, activeClass);
          });
          add$2(tgt, activeClass);
        })),
        run$1(focusout(), runOnItem(function (comp) {
          descendant(comp.element, '.' + activeClass).each(function (currentActive) {
            remove$2(currentActive, activeClass);
          });
        })),
        runOnExecute$1(runOnItem(function (comp, se, tgt, itemValue) {
          emitWith(comp, formActionEvent, {
            name: spec.name,
            value: itemValue
          });
        }))
      ];
      var iterCollectionItems = function (comp, applyAttributes) {
        return map$2(descendants(comp.element, '.tox-collection__item'), applyAttributes);
      };
      var pField = FormField.parts.field({
        dom: {
          tag: 'div',
          classes: ['tox-collection'].concat(spec.columns !== 1 ? ['tox-collection--grid'] : ['tox-collection--list'])
        },
        components: [],
        factory: { sketch: identity$1 },
        behaviours: derive$1([
          Disabling.config({
            disabled: providersBackstage.isDisabled,
            onDisabled: function (comp) {
              iterCollectionItems(comp, function (childElm) {
                add$2(childElm, 'tox-collection__item--state-disabled');
                set$8(childElm, 'aria-disabled', true);
              });
            },
            onEnabled: function (comp) {
              iterCollectionItems(comp, function (childElm) {
                remove$2(childElm, 'tox-collection__item--state-disabled');
                remove$7(childElm, 'aria-disabled');
              });
            }
          }),
          receivingConfig(),
          Replacing.config({}),
          Representing.config({
            store: {
              mode: 'memory',
              initialValue: []
            },
            onSetValue: function (comp, items) {
              setContents(comp, items);
              if (spec.columns === 'auto') {
                detectSize(comp, 5, 'tox-collection__item').each(function (_a) {
                  var numRows = _a.numRows, numColumns = _a.numColumns;
                  Keying.setGridSize(comp, numRows, numColumns);
                });
              }
              emit(comp, formResizeEvent);
            }
          }),
          Tabstopping.config({}),
          Keying.config(deriveCollectionMovement(spec.columns, 'normal')),
          config('collection-events', collectionEvents)
        ]),
        eventOrder: (_a = {}, _a[execute$5()] = [
          'disabling',
          'alloy.base.behaviour',
          'collection-events'
        ], _a)
      });
      var extraClasses = ['tox-form__group--collection'];
      return renderFormFieldWith(pLabel, pField, extraClasses, []);
    };

    var schema$k = constant$1([
      option('data'),
      defaulted('inputAttributes', {}),
      defaulted('inputStyles', {}),
      defaulted('tag', 'input'),
      defaulted('inputClasses', []),
      onHandler('onSetValue'),
      defaulted('styles', {}),
      defaulted('eventOrder', {}),
      field('inputBehaviours', [
        Representing,
        Focusing
      ]),
      defaulted('selectOnFocus', true)
    ]);
    var focusBehaviours = function (detail) {
      return derive$1([Focusing.config({
          onFocus: !detail.selectOnFocus ? noop : function (component) {
            var input = component.element;
            var value = get$5(input);
            input.dom.setSelectionRange(0, value.length);
          }
        })]);
    };
    var behaviours = function (detail) {
      return __assign(__assign({}, focusBehaviours(detail)), augment(detail.inputBehaviours, [Representing.config({
          store: __assign(__assign({ mode: 'manual' }, detail.data.map(function (data) {
            return { initialValue: data };
          }).getOr({})), {
            getValue: function (input) {
              return get$5(input.element);
            },
            setValue: function (input, data) {
              var current = get$5(input.element);
              if (current !== data) {
                set$4(input.element, data);
              }
            }
          }),
          onSetValue: detail.onSetValue
        })]));
    };
    var dom = function (detail) {
      return {
        tag: detail.tag,
        attributes: __assign({ type: 'text' }, detail.inputAttributes),
        styles: detail.inputStyles,
        classes: detail.inputClasses
      };
    };

    var factory$h = function (detail, _spec) {
      return {
        uid: detail.uid,
        dom: dom(detail),
        components: [],
        behaviours: behaviours(detail),
        eventOrder: detail.eventOrder
      };
    };
    var Input = single({
      name: 'Input',
      configFields: schema$k(),
      factory: factory$h
    });

    var exports$1 = {}, module = { exports: exports$1 };
    (function (define, exports, module, require) {
      (function (global, factory) {
        typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.EphoxContactWrapper = factory());
      }(this, function () {
        var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
        var promise = { exports: {} };
        (function (module) {
          (function (root) {
            var setTimeoutFunc = setTimeout;
            function noop() {
            }
            function bind(fn, thisArg) {
              return function () {
                fn.apply(thisArg, arguments);
              };
            }
            function Promise(fn) {
              if (typeof this !== 'object')
                throw new TypeError('Promises must be constructed via new');
              if (typeof fn !== 'function')
                throw new TypeError('not a function');
              this._state = 0;
              this._handled = false;
              this._value = undefined;
              this._deferreds = [];
              doResolve(fn, this);
            }
            function handle(self, deferred) {
              while (self._state === 3) {
                self = self._value;
              }
              if (self._state === 0) {
                self._deferreds.push(deferred);
                return;
              }
              self._handled = true;
              Promise._immediateFn(function () {
                var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
                if (cb === null) {
                  (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
                  return;
                }
                var ret;
                try {
                  ret = cb(self._value);
                } catch (e) {
                  reject(deferred.promise, e);
                  return;
                }
                resolve(deferred.promise, ret);
              });
            }
            function resolve(self, newValue) {
              try {
                if (newValue === self)
                  throw new TypeError('A promise cannot be resolved with itself.');
                if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
                  var then = newValue.then;
                  if (newValue instanceof Promise) {
                    self._state = 3;
                    self._value = newValue;
                    finale(self);
                    return;
                  } else if (typeof then === 'function') {
                    doResolve(bind(then, newValue), self);
                    return;
                  }
                }
                self._state = 1;
                self._value = newValue;
                finale(self);
              } catch (e) {
                reject(self, e);
              }
            }
            function reject(self, newValue) {
              self._state = 2;
              self._value = newValue;
              finale(self);
            }
            function finale(self) {
              if (self._state === 2 && self._deferreds.length === 0) {
                Promise._immediateFn(function () {
                  if (!self._handled) {
                    Promise._unhandledRejectionFn(self._value);
                  }
                });
              }
              for (var i = 0, len = self._deferreds.length; i < len; i++) {
                handle(self, self._deferreds[i]);
              }
              self._deferreds = null;
            }
            function Handler(onFulfilled, onRejected, promise) {
              this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
              this.onRejected = typeof onRejected === 'function' ? onRejected : null;
              this.promise = promise;
            }
            function doResolve(fn, self) {
              var done = false;
              try {
                fn(function (value) {
                  if (done)
                    return;
                  done = true;
                  resolve(self, value);
                }, function (reason) {
                  if (done)
                    return;
                  done = true;
                  reject(self, reason);
                });
              } catch (ex) {
                if (done)
                  return;
                done = true;
                reject(self, ex);
              }
            }
            Promise.prototype['catch'] = function (onRejected) {
              return this.then(null, onRejected);
            };
            Promise.prototype.then = function (onFulfilled, onRejected) {
              var prom = new this.constructor(noop);
              handle(this, new Handler(onFulfilled, onRejected, prom));
              return prom;
            };
            Promise.all = function (arr) {
              var args = Array.prototype.slice.call(arr);
              return new Promise(function (resolve, reject) {
                if (args.length === 0)
                  return resolve([]);
                var remaining = args.length;
                function res(i, val) {
                  try {
                    if (val && (typeof val === 'object' || typeof val === 'function')) {
                      var then = val.then;
                      if (typeof then === 'function') {
                        then.call(val, function (val) {
                          res(i, val);
                        }, reject);
                        return;
                      }
                    }
                    args[i] = val;
                    if (--remaining === 0) {
                      resolve(args);
                    }
                  } catch (ex) {
                    reject(ex);
                  }
                }
                for (var i = 0; i < args.length; i++) {
                  res(i, args[i]);
                }
              });
            };
            Promise.resolve = function (value) {
              if (value && typeof value === 'object' && value.constructor === Promise) {
                return value;
              }
              return new Promise(function (resolve) {
                resolve(value);
              });
            };
            Promise.reject = function (value) {
              return new Promise(function (resolve, reject) {
                reject(value);
              });
            };
            Promise.race = function (values) {
              return new Promise(function (resolve, reject) {
                for (var i = 0, len = values.length; i < len; i++) {
                  values[i].then(resolve, reject);
                }
              });
            };
            Promise._immediateFn = typeof setImmediate === 'function' ? function (fn) {
              setImmediate(fn);
            } : function (fn) {
              setTimeoutFunc(fn, 0);
            };
            Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
              if (typeof console !== 'undefined' && console) {
                console.warn('Possible Unhandled Promise Rejection:', err);
              }
            };
            Promise._setImmediateFn = function _setImmediateFn(fn) {
              Promise._immediateFn = fn;
            };
            Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
              Promise._unhandledRejectionFn = fn;
            };
            if (module.exports) {
              module.exports = Promise;
            } else if (!root.Promise) {
              root.Promise = Promise;
            }
          }(commonjsGlobal));
        }(promise));
        var promisePolyfill = promise.exports;
        var Global = function () {
          if (typeof window !== 'undefined') {
            return window;
          } else {
            return Function('return this;')();
          }
        }();
        var promisePolyfill_1 = { boltExport: Global.Promise || promisePolyfill };
        return promisePolyfill_1;
      }));
    }(undefined, exports$1, module));
    var Promise$1 = module.exports.boltExport;

    var nu$3 = function (baseFn) {
      var data = Optional.none();
      var callbacks = [];
      var map = function (f) {
        return nu$3(function (nCallback) {
          get(function (data) {
            nCallback(f(data));
          });
        });
      };
      var get = function (nCallback) {
        if (isReady()) {
          call(nCallback);
        } else {
          callbacks.push(nCallback);
        }
      };
      var set = function (x) {
        if (!isReady()) {
          data = Optional.some(x);
          run(callbacks);
          callbacks = [];
        }
      };
      var isReady = function () {
        return data.isSome();
      };
      var run = function (cbs) {
        each$1(cbs, call);
      };
      var call = function (cb) {
        data.each(function (x) {
          setTimeout(function () {
            cb(x);
          }, 0);
        });
      };
      baseFn(set);
      return {
        get: get,
        map: map,
        isReady: isReady
      };
    };
    var pure$1 = function (a) {
      return nu$3(function (callback) {
        callback(a);
      });
    };
    var LazyValue = {
      nu: nu$3,
      pure: pure$1
    };

    var errorReporter = function (err) {
      setTimeout(function () {
        throw err;
      }, 0);
    };
    var make$5 = function (run) {
      var get = function (callback) {
        run().then(callback, errorReporter);
      };
      var map = function (fab) {
        return make$5(function () {
          return run().then(fab);
        });
      };
      var bind = function (aFutureB) {
        return make$5(function () {
          return run().then(function (v) {
            return aFutureB(v).toPromise();
          });
        });
      };
      var anonBind = function (futureB) {
        return make$5(function () {
          return run().then(function () {
            return futureB.toPromise();
          });
        });
      };
      var toLazy = function () {
        return LazyValue.nu(get);
      };
      var toCached = function () {
        var cache = null;
        return make$5(function () {
          if (cache === null) {
            cache = run();
          }
          return cache;
        });
      };
      var toPromise = run;
      return {
        map: map,
        bind: bind,
        anonBind: anonBind,
        toLazy: toLazy,
        toCached: toCached,
        toPromise: toPromise,
        get: get
      };
    };
    var nu$2 = function (baseFn) {
      return make$5(function () {
        return new Promise$1(baseFn);
      });
    };
    var pure = function (a) {
      return make$5(function () {
        return Promise$1.resolve(a);
      });
    };
    var Future = {
      nu: nu$2,
      pure: pure
    };

    var ariaElements = [
      'input',
      'textarea'
    ];
    var isAriaElement = function (elem) {
      var name = name$2(elem);
      return contains$2(ariaElements, name);
    };
    var markValid = function (component, invalidConfig) {
      var elem = invalidConfig.getRoot(component).getOr(component.element);
      remove$2(elem, invalidConfig.invalidClass);
      invalidConfig.notify.each(function (notifyInfo) {
        if (isAriaElement(component.element)) {
          set$8(component.element, 'aria-invalid', false);
        }
        notifyInfo.getContainer(component).each(function (container) {
          set$5(container, notifyInfo.validHtml);
        });
        notifyInfo.onValid(component);
      });
    };
    var markInvalid = function (component, invalidConfig, invalidState, text) {
      var elem = invalidConfig.getRoot(component).getOr(component.element);
      add$2(elem, invalidConfig.invalidClass);
      invalidConfig.notify.each(function (notifyInfo) {
        if (isAriaElement(component.element)) {
          set$8(component.element, 'aria-invalid', true);
        }
        notifyInfo.getContainer(component).each(function (container) {
          set$5(container, text);
        });
        notifyInfo.onInvalid(component, text);
      });
    };
    var query = function (component, invalidConfig, _invalidState) {
      return invalidConfig.validator.fold(function () {
        return Future.pure(Result.value(true));
      }, function (validatorInfo) {
        return validatorInfo.validate(component);
      });
    };
    var run = function (component, invalidConfig, invalidState) {
      invalidConfig.notify.each(function (notifyInfo) {
        notifyInfo.onValidate(component);
      });
      return query(component, invalidConfig).map(function (valid) {
        if (component.getSystem().isConnected()) {
          return valid.fold(function (err) {
            markInvalid(component, invalidConfig, invalidState, err);
            return Result.error(err);
          }, function (v) {
            markValid(component, invalidConfig);
            return Result.value(v);
          });
        } else {
          return Result.error('No longer in system');
        }
      });
    };
    var isInvalid = function (component, invalidConfig) {
      var elem = invalidConfig.getRoot(component).getOr(component.element);
      return has(elem, invalidConfig.invalidClass);
    };

    var InvalidateApis = /*#__PURE__*/Object.freeze({
        __proto__: null,
        markValid: markValid,
        markInvalid: markInvalid,
        query: query,
        run: run,
        isInvalid: isInvalid
    });

    var events$8 = function (invalidConfig, invalidState) {
      return invalidConfig.validator.map(function (validatorInfo) {
        return derive$2([run$1(validatorInfo.onEvent, function (component) {
            run(component, invalidConfig, invalidState).get(identity$1);
          })].concat(validatorInfo.validateOnLoad ? [runOnAttached(function (component) {
            run(component, invalidConfig, invalidState).get(noop);
          })] : []));
      }).getOr({});
    };

    var ActiveInvalidate = /*#__PURE__*/Object.freeze({
        __proto__: null,
        events: events$8
    });

    var InvalidateSchema = [
      required$1('invalidClass'),
      defaulted('getRoot', Optional.none),
      optionObjOf('notify', [
        defaulted('aria', 'alert'),
        defaulted('getContainer', Optional.none),
        defaulted('validHtml', ''),
        onHandler('onValid'),
        onHandler('onInvalid'),
        onHandler('onValidate')
      ]),
      optionObjOf('validator', [
        required$1('validate'),
        defaulted('onEvent', 'input'),
        defaulted('validateOnLoad', true)
      ])
    ];

    var Invalidating = create$7({
      fields: InvalidateSchema,
      name: 'invalidating',
      active: ActiveInvalidate,
      apis: InvalidateApis,
      extra: {
        validation: function (validator) {
          return function (component) {
            var v = Representing.getValue(component);
            return Future.pure(validator(v));
          };
        }
      }
    });

    var getCoupled = function (component, coupleConfig, coupleState, name) {
      return coupleState.getOrCreate(component, coupleConfig, name);
    };

    var CouplingApis = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getCoupled: getCoupled
    });

    var CouplingSchema = [requiredOf('others', setOf(Result.value, anyValue()))];

    var init$a = function () {
      var coupled = {};
      var getOrCreate = function (component, coupleConfig, name) {
        var available = keys(coupleConfig.others);
        if (!available) {
          throw new Error('Cannot find coupled component: ' + name + '. Known coupled components: ' + JSON.stringify(available, null, 2));
        } else {
          return get$e(coupled, name).getOrThunk(function () {
            var builder = get$e(coupleConfig.others, name).getOrDie('No information found for coupled component: ' + name);
            var spec = builder(component);
            var built = component.getSystem().build(spec);
            coupled[name] = built;
            return built;
          });
        }
      };
      var readState = constant$1({});
      return nu$8({
        readState: readState,
        getOrCreate: getOrCreate
      });
    };

    var CouplingState = /*#__PURE__*/Object.freeze({
        __proto__: null,
        init: init$a
    });

    var Coupling = create$7({
      fields: CouplingSchema,
      name: 'coupling',
      apis: CouplingApis,
      state: CouplingState
    });

    var suffix = constant$1('sink');
    var partType$1 = constant$1(optional({
      name: suffix(),
      overrides: constant$1({
        dom: { tag: 'div' },
        behaviours: derive$1([Positioning.config({ useFixed: always })]),
        events: derive$2([
          cutter(keydown()),
          cutter(mousedown()),
          cutter(click())
        ])
      })
    }));

    var HighlightOnOpen;
    (function (HighlightOnOpen) {
      HighlightOnOpen[HighlightOnOpen['HighlightFirst'] = 0] = 'HighlightFirst';
      HighlightOnOpen[HighlightOnOpen['HighlightNone'] = 1] = 'HighlightNone';
    }(HighlightOnOpen || (HighlightOnOpen = {})));
    var getAnchor = function (detail, component) {
      var hotspot = detail.getHotspot(component).getOr(component);
      var type = 'hotspot';
      var overrides = detail.getAnchorOverrides();
      return detail.layouts.fold(function () {
        return {
          type: type,
          hotspot: hotspot,
          overrides: overrides
        };
      }, function (layouts) {
        return {
          type: type,
          hotspot: hotspot,
          overrides: overrides,
          layouts: layouts
        };
      });
    };
    var fetch = function (detail, mapFetch, component) {
      var fetcher = detail.fetch;
      return fetcher(component).map(mapFetch);
    };
    var openF = function (detail, mapFetch, anchor, component, sandbox, externals, highlightOnOpen) {
      var futureData = fetch(detail, mapFetch, component);
      var getLazySink = getSink(component, detail);
      return futureData.map(function (tdata) {
        return tdata.bind(function (data) {
          return Optional.from(tieredMenu.sketch(__assign(__assign({}, externals.menu()), {
            uid: generate$5(''),
            data: data,
            highlightImmediately: highlightOnOpen === HighlightOnOpen.HighlightFirst,
            onOpenMenu: function (tmenu, menu) {
              var sink = getLazySink().getOrDie();
              Positioning.position(sink, menu, { anchor: anchor });
              Sandboxing.decloak(sandbox);
            },
            onOpenSubmenu: function (tmenu, item, submenu) {
              var sink = getLazySink().getOrDie();
              Positioning.position(sink, submenu, {
                anchor: {
                  type: 'submenu',
                  item: item
                }
              });
              Sandboxing.decloak(sandbox);
            },
            onRepositionMenu: function (tmenu, primaryMenu, submenuTriggers) {
              var sink = getLazySink().getOrDie();
              Positioning.position(sink, primaryMenu, { anchor: anchor });
              each$1(submenuTriggers, function (st) {
                Positioning.position(sink, st.triggeredMenu, {
                  anchor: {
                    type: 'submenu',
                    item: st.triggeringItem
                  }
                });
              });
            },
            onEscape: function () {
              Focusing.focus(component);
              Sandboxing.close(sandbox);
              return Optional.some(true);
            }
          })));
        });
      });
    };
    var open = function (detail, mapFetch, hotspot, sandbox, externals, onOpenSync, highlightOnOpen) {
      var anchor = getAnchor(detail, hotspot);
      var processed = openF(detail, mapFetch, anchor, hotspot, sandbox, externals, highlightOnOpen);
      return processed.map(function (tdata) {
        tdata.fold(function () {
          if (Sandboxing.isOpen(sandbox)) {
            Sandboxing.close(sandbox);
          }
        }, function (data) {
          Sandboxing.cloak(sandbox);
          Sandboxing.open(sandbox, data);
          onOpenSync(sandbox);
        });
        return sandbox;
      });
    };
    var close = function (detail, mapFetch, component, sandbox, _externals, _onOpenSync, _highlightOnOpen) {
      Sandboxing.close(sandbox);
      return Future.pure(sandbox);
    };
    var togglePopup = function (detail, mapFetch, hotspot, externals, onOpenSync, highlightOnOpen) {
      var sandbox = Coupling.getCoupled(hotspot, 'sandbox');
      var showing = Sandboxing.isOpen(sandbox);
      var action = showing ? close : open;
      return action(detail, mapFetch, hotspot, sandbox, externals, onOpenSync, highlightOnOpen);
    };
    var matchWidth = function (hotspot, container, useMinWidth) {
      var menu = Composing.getCurrent(container).getOr(container);
      var buttonWidth = get$a(hotspot.element);
      if (useMinWidth) {
        set$7(menu.element, 'min-width', buttonWidth + 'px');
      } else {
        set$6(menu.element, buttonWidth);
      }
    };
    var getSink = function (anyInSystem, sinkDetail) {
      return anyInSystem.getSystem().getByUid(sinkDetail.uid + '-' + suffix()).map(function (internalSink) {
        return function () {
          return Result.value(internalSink);
        };
      }).getOrThunk(function () {
        return sinkDetail.lazySink.fold(function () {
          return function () {
            return Result.error(new Error('No internal sink is specified, nor could an external sink be found'));
          };
        }, function (lazySinkFn) {
          return function () {
            return lazySinkFn(anyInSystem);
          };
        });
      });
    };
    var doRepositionMenus = function (sandbox) {
      Sandboxing.getState(sandbox).each(function (tmenu) {
        tieredMenu.repositionMenus(tmenu);
      });
    };
    var makeSandbox$1 = function (detail, hotspot, extras) {
      var ariaOwner = manager();
      var onOpen = function (component, menu) {
        var anchor = getAnchor(detail, hotspot);
        ariaOwner.link(hotspot.element);
        if (detail.matchWidth) {
          matchWidth(anchor.hotspot, menu, detail.useMinWidth);
        }
        detail.onOpen(anchor, component, menu);
        if (extras !== undefined && extras.onOpen !== undefined) {
          extras.onOpen(component, menu);
        }
      };
      var onClose = function (component, menu) {
        ariaOwner.unlink(hotspot.element);
        if (extras !== undefined && extras.onClose !== undefined) {
          extras.onClose(component, menu);
        }
      };
      var lazySink = getSink(hotspot, detail);
      return {
        dom: {
          tag: 'div',
          classes: detail.sandboxClasses,
          attributes: {
            id: ariaOwner.id,
            role: 'listbox'
          }
        },
        behaviours: SketchBehaviours.augment(detail.sandboxBehaviours, [
          Representing.config({
            store: {
              mode: 'memory',
              initialValue: hotspot
            }
          }),
          Sandboxing.config({
            onOpen: onOpen,
            onClose: onClose,
            isPartOf: function (container, data, queryElem) {
              return isPartOf$1(data, queryElem) || isPartOf$1(hotspot, queryElem);
            },
            getAttachPoint: function () {
              return lazySink().getOrDie();
            }
          }),
          Composing.config({
            find: function (sandbox) {
              return Sandboxing.getState(sandbox).bind(function (menu) {
                return Composing.getCurrent(menu);
              });
            }
          }),
          Receiving.config({ channels: __assign(__assign({}, receivingChannel$1({ isExtraPart: never })), receivingChannel({ doReposition: doRepositionMenus })) })
        ])
      };
    };
    var repositionMenus = function (comp) {
      var sandbox = Coupling.getCoupled(comp, 'sandbox');
      doRepositionMenus(sandbox);
    };

    var sandboxFields = function () {
      return [
        defaulted('sandboxClasses', []),
        SketchBehaviours.field('sandboxBehaviours', [
          Composing,
          Receiving,
          Sandboxing,
          Representing
        ])
      ];
    };

    var schema$j = constant$1([
      required$1('dom'),
      required$1('fetch'),
      onHandler('onOpen'),
      onKeyboardHandler('onExecute'),
      defaulted('getHotspot', Optional.some),
      defaulted('getAnchorOverrides', constant$1({})),
      schema$y(),
      field('dropdownBehaviours', [
        Toggling,
        Coupling,
        Keying,
        Focusing
      ]),
      required$1('toggleClass'),
      defaulted('eventOrder', {}),
      option('lazySink'),
      defaulted('matchWidth', false),
      defaulted('useMinWidth', false),
      option('role')
    ].concat(sandboxFields()));
    var parts$d = constant$1([
      external$1({
        schema: [tieredMenuMarkers()],
        name: 'menu',
        defaults: function (detail) {
          return { onExecute: detail.onExecute };
        }
      }),
      partType$1()
    ]);

    var factory$g = function (detail, components, _spec, externals) {
      var _a;
      var lookupAttr = function (attr) {
        return get$e(detail.dom, 'attributes').bind(function (attrs) {
          return get$e(attrs, attr);
        });
      };
      var switchToMenu = function (sandbox) {
        Sandboxing.getState(sandbox).each(function (tmenu) {
          tieredMenu.highlightPrimary(tmenu);
        });
      };
      var action = function (component) {
        var onOpenSync = switchToMenu;
        togglePopup(detail, identity$1, component, externals, onOpenSync, HighlightOnOpen.HighlightFirst).get(noop);
      };
      var apis = {
        expand: function (comp) {
          if (!Toggling.isOn(comp)) {
            togglePopup(detail, identity$1, comp, externals, noop, HighlightOnOpen.HighlightNone).get(noop);
          }
        },
        open: function (comp) {
          if (!Toggling.isOn(comp)) {
            togglePopup(detail, identity$1, comp, externals, noop, HighlightOnOpen.HighlightFirst).get(noop);
          }
        },
        isOpen: Toggling.isOn,
        close: function (comp) {
          if (Toggling.isOn(comp)) {
            togglePopup(detail, identity$1, comp, externals, noop, HighlightOnOpen.HighlightFirst).get(noop);
          }
        },
        repositionMenus: function (comp) {
          if (Toggling.isOn(comp)) {
            repositionMenus(comp);
          }
        }
      };
      var triggerExecute = function (comp, _se) {
        emitExecute(comp);
        return Optional.some(true);
      };
      return {
        uid: detail.uid,
        dom: detail.dom,
        components: components,
        behaviours: augment(detail.dropdownBehaviours, [
          Toggling.config({
            toggleClass: detail.toggleClass,
            aria: { mode: 'expanded' }
          }),
          Coupling.config({
            others: {
              sandbox: function (hotspot) {
                return makeSandbox$1(detail, hotspot, {
                  onOpen: function () {
                    return Toggling.on(hotspot);
                  },
                  onClose: function () {
                    return Toggling.off(hotspot);
                  }
                });
              }
            }
          }),
          Keying.config({
            mode: 'special',
            onSpace: triggerExecute,
            onEnter: triggerExecute,
            onDown: function (comp, _se) {
              if (Dropdown.isOpen(comp)) {
                var sandbox = Coupling.getCoupled(comp, 'sandbox');
                switchToMenu(sandbox);
              } else {
                Dropdown.open(comp);
              }
              return Optional.some(true);
            },
            onEscape: function (comp, _se) {
              if (Dropdown.isOpen(comp)) {
                Dropdown.close(comp);
                return Optional.some(true);
              } else {
                return Optional.none();
              }
            }
          }),
          Focusing.config({})
        ]),
        events: events$a(Optional.some(action)),
        eventOrder: __assign(__assign({}, detail.eventOrder), (_a = {}, _a[execute$5()] = [
          'disabling',
          'toggling',
          'alloy.base.behaviour'
        ], _a)),
        apis: apis,
        domModification: {
          attributes: __assign(__assign({ 'aria-haspopup': 'true' }, detail.role.fold(function () {
            return {};
          }, function (role) {
            return { role: role };
          })), detail.dom.tag === 'button' ? { type: lookupAttr('type').getOr('button') } : {})
        }
      };
    };
    var Dropdown = composite({
      name: 'Dropdown',
      configFields: schema$j(),
      partFields: parts$d(),
      factory: factory$g,
      apis: {
        open: function (apis, comp) {
          return apis.open(comp);
        },
        expand: function (apis, comp) {
          return apis.expand(comp);
        },
        close: function (apis, comp) {
          return apis.close(comp);
        },
        isOpen: function (apis, comp) {
          return apis.isOpen(comp);
        },
        repositionMenus: function (apis, comp) {
          return apis.repositionMenus(comp);
        }
      }
    });

    var exhibit$1 = function () {
      return nu$7({
        styles: {
          '-webkit-user-select': 'none',
          'user-select': 'none',
          '-ms-user-select': 'none',
          '-moz-user-select': '-moz-none'
        },
        attributes: { unselectable: 'on' }
      });
    };
    var events$7 = function () {
      return derive$2([abort(selectstart(), always)]);
    };

    var ActiveUnselecting = /*#__PURE__*/Object.freeze({
        __proto__: null,
        events: events$7,
        exhibit: exhibit$1
    });

    var Unselecting = create$7({
      fields: [],
      name: 'unselecting',
      active: ActiveUnselecting
    });

    var renderPanelButton = function (spec, sharedBackstage) {
      return Dropdown.sketch({
        dom: spec.dom,
        components: spec.components,
        toggleClass: 'mce-active',
        dropdownBehaviours: derive$1([
          DisablingConfigs.button(sharedBackstage.providers.isDisabled),
          receivingConfig(),
          Unselecting.config({}),
          Tabstopping.config({})
        ]),
        layouts: spec.layouts,
        sandboxClasses: ['tox-dialog__popups'],
        lazySink: sharedBackstage.getSink,
        fetch: function (comp) {
          return Future.nu(function (callback) {
            return spec.fetch(callback);
          }).map(function (items) {
            return Optional.from(createTieredDataFrom(deepMerge(createPartialChoiceMenu(generate$6('menu-value'), items, function (value) {
              spec.onItemAction(comp, value);
            }, spec.columns, spec.presets, ItemResponse$1.CLOSE_ON_EXECUTE, never, sharedBackstage.providers), { movement: deriveMenuMovement(spec.columns, spec.presets) })));
          });
        },
        parts: { menu: part(false, 1, spec.presets) }
      });
    };

    var colorInputChangeEvent = generate$6('color-input-change');
    var colorSwatchChangeEvent = generate$6('color-swatch-change');
    var colorPickerCancelEvent = generate$6('color-picker-cancel');
    var renderColorInput = function (spec, sharedBackstage, colorInputBackstage) {
      var pField = FormField.parts.field({
        factory: Input,
        inputClasses: ['tox-textfield'],
        onSetValue: function (c) {
          return Invalidating.run(c).get(noop);
        },
        inputBehaviours: derive$1([
          Disabling.config({ disabled: sharedBackstage.providers.isDisabled }),
          receivingConfig(),
          Tabstopping.config({}),
          Invalidating.config({
            invalidClass: 'tox-textbox-field-invalid',
            getRoot: function (comp) {
              return parent(comp.element);
            },
            notify: {
              onValid: function (comp) {
                var val = Representing.getValue(comp);
                emitWith(comp, colorInputChangeEvent, { color: val });
              }
            },
            validator: {
              validateOnLoad: false,
              validate: function (input) {
                var inputValue = Representing.getValue(input);
                if (inputValue.length === 0) {
                  return Future.pure(Result.value(true));
                } else {
                  var span = SugarElement.fromTag('span');
                  set$7(span, 'background-color', inputValue);
                  var res = getRaw(span, 'background-color').fold(function () {
                    return Result.error('blah');
                  }, function (_) {
                    return Result.value(inputValue);
                  });
                  return Future.pure(res);
                }
              }
            }
          })
        ]),
        selectOnFocus: false
      });
      var pLabel = spec.label.map(function (label) {
        return renderLabel$2(label, sharedBackstage.providers);
      });
      var emitSwatchChange = function (colorBit, value) {
        emitWith(colorBit, colorSwatchChangeEvent, { value: value });
      };
      var onItemAction = function (comp, value) {
        memColorButton.getOpt(comp).each(function (colorBit) {
          if (value === 'custom') {
            colorInputBackstage.colorPicker(function (valueOpt) {
              valueOpt.fold(function () {
                return emit(colorBit, colorPickerCancelEvent);
              }, function (value) {
                emitSwatchChange(colorBit, value);
                addColor(value);
              });
            }, '#ffffff');
          } else if (value === 'remove') {
            emitSwatchChange(colorBit, '');
          } else {
            emitSwatchChange(colorBit, value);
          }
        });
      };
      var memColorButton = record(renderPanelButton({
        dom: {
          tag: 'span',
          attributes: { 'aria-label': sharedBackstage.providers.translate('Color swatch') }
        },
        layouts: {
          onRtl: function () {
            return [
              southwest$2,
              southeast$2,
              south$2
            ];
          },
          onLtr: function () {
            return [
              southeast$2,
              southwest$2,
              south$2
            ];
          }
        },
        components: [],
        fetch: getFetch$1(colorInputBackstage.getColors(), colorInputBackstage.hasCustomColors()),
        columns: colorInputBackstage.getColorCols(),
        presets: 'color',
        onItemAction: onItemAction
      }, sharedBackstage));
      return FormField.sketch({
        dom: {
          tag: 'div',
          classes: ['tox-form__group']
        },
        components: pLabel.toArray().concat([{
            dom: {
              tag: 'div',
              classes: ['tox-color-input']
            },
            components: [
              pField,
              memColorButton.asSpec()
            ]
          }]),
        fieldBehaviours: derive$1([config('form-field-events', [
            run$1(colorInputChangeEvent, function (comp, se) {
              memColorButton.getOpt(comp).each(function (colorButton) {
                set$7(colorButton.element, 'background-color', se.event.color);
              });
              emitWith(comp, formChangeEvent, { name: spec.name });
            }),
            run$1(colorSwatchChangeEvent, function (comp, se) {
              FormField.getField(comp).each(function (field) {
                Representing.setValue(field, se.event.value);
                Composing.getCurrent(comp).each(Focusing.focus);
              });
            }),
            run$1(colorPickerCancelEvent, function (comp, _se) {
              FormField.getField(comp).each(function (_field) {
                Composing.getCurrent(comp).each(Focusing.focus);
              });
            })
          ])])
      });
    };

    var labelPart = optional({
      schema: [required$1('dom')],
      name: 'label'
    });
    var edgePart = function (name) {
      return optional({
        name: '' + name + '-edge',
        overrides: function (detail) {
          var action = detail.model.manager.edgeActions[name];
          return action.fold(function () {
            return {};
          }, function (a) {
            return {
              events: derive$2([
                runActionExtra(touchstart(), function (comp, se, d) {
                  return a(comp, d);
                }, [detail]),
                runActionExtra(mousedown(), function (comp, se, d) {
                  return a(comp, d);
                }, [detail]),
                runActionExtra(mousemove(), function (comp, se, det) {
                  if (det.mouseIsDown.get()) {
                    a(comp, det);
                  }
                }, [detail])
              ])
            };
          });
        }
      });
    };
    var tlEdgePart = edgePart('top-left');
    var tedgePart = edgePart('top');
    var trEdgePart = edgePart('top-right');
    var redgePart = edgePart('right');
    var brEdgePart = edgePart('bottom-right');
    var bedgePart = edgePart('bottom');
    var blEdgePart = edgePart('bottom-left');
    var ledgePart = edgePart('left');
    var thumbPart = required({
      name: 'thumb',
      defaults: constant$1({ dom: { styles: { position: 'absolute' } } }),
      overrides: function (detail) {
        return {
          events: derive$2([
            redirectToPart(touchstart(), detail, 'spectrum'),
            redirectToPart(touchmove(), detail, 'spectrum'),
            redirectToPart(touchend(), detail, 'spectrum'),
            redirectToPart(mousedown(), detail, 'spectrum'),
            redirectToPart(mousemove(), detail, 'spectrum'),
            redirectToPart(mouseup(), detail, 'spectrum')
          ])
        };
      }
    });
    var spectrumPart = required({
      schema: [customField('mouseIsDown', function () {
          return Cell(false);
        })],
      name: 'spectrum',
      overrides: function (detail) {
        var modelDetail = detail.model;
        var model = modelDetail.manager;
        var setValueFrom = function (component, simulatedEvent) {
          return model.getValueFromEvent(simulatedEvent).map(function (value) {
            return model.setValueFrom(component, detail, value);
          });
        };
        return {
          behaviours: derive$1([
            Keying.config({
              mode: 'special',
              onLeft: function (spectrum) {
                return model.onLeft(spectrum, detail);
              },
              onRight: function (spectrum) {
                return model.onRight(spectrum, detail);
              },
              onUp: function (spectrum) {
                return model.onUp(spectrum, detail);
              },
              onDown: function (spectrum) {
                return model.onDown(spectrum, detail);
              }
            }),
            Focusing.config({})
          ]),
          events: derive$2([
            run$1(touchstart(), setValueFrom),
            run$1(touchmove(), setValueFrom),
            run$1(mousedown(), setValueFrom),
            run$1(mousemove(), function (spectrum, se) {
              if (detail.mouseIsDown.get()) {
                setValueFrom(spectrum, se);
              }
            })
          ])
        };
      }
    });
    var SliderParts = [
      labelPart,
      ledgePart,
      redgePart,
      tedgePart,
      bedgePart,
      tlEdgePart,
      trEdgePart,
      blEdgePart,
      brEdgePart,
      thumbPart,
      spectrumPart
    ];

    var _sliderChangeEvent = 'slider.change.value';
    var sliderChangeEvent = constant$1(_sliderChangeEvent);
    var isTouchEvent$2 = function (evt) {
      return evt.type.indexOf('touch') !== -1;
    };
    var getEventSource = function (simulatedEvent) {
      var evt = simulatedEvent.event.raw;
      if (isTouchEvent$2(evt)) {
        var touchEvent = evt;
        return touchEvent.touches !== undefined && touchEvent.touches.length === 1 ? Optional.some(touchEvent.touches[0]).map(function (t) {
          return SugarPosition(t.clientX, t.clientY);
        }) : Optional.none();
      } else {
        var mouseEvent = evt;
        return mouseEvent.clientX !== undefined ? Optional.some(mouseEvent).map(function (me) {
          return SugarPosition(me.clientX, me.clientY);
        }) : Optional.none();
      }
    };

    var t = 'top', r = 'right', b = 'bottom', l = 'left';
    var minX = function (detail) {
      return detail.model.minX;
    };
    var minY = function (detail) {
      return detail.model.minY;
    };
    var min1X = function (detail) {
      return detail.model.minX - 1;
    };
    var min1Y = function (detail) {
      return detail.model.minY - 1;
    };
    var maxX = function (detail) {
      return detail.model.maxX;
    };
    var maxY = function (detail) {
      return detail.model.maxY;
    };
    var max1X = function (detail) {
      return detail.model.maxX + 1;
    };
    var max1Y = function (detail) {
      return detail.model.maxY + 1;
    };
    var range = function (detail, max, min) {
      return max(detail) - min(detail);
    };
    var xRange = function (detail) {
      return range(detail, maxX, minX);
    };
    var yRange = function (detail) {
      return range(detail, maxY, minY);
    };
    var halfX = function (detail) {
      return xRange(detail) / 2;
    };
    var halfY = function (detail) {
      return yRange(detail) / 2;
    };
    var step = function (detail) {
      return detail.stepSize;
    };
    var snap = function (detail) {
      return detail.snapToGrid;
    };
    var snapStart = function (detail) {
      return detail.snapStart;
    };
    var rounded = function (detail) {
      return detail.rounded;
    };
    var hasEdge = function (detail, edgeName) {
      return detail[edgeName + '-edge'] !== undefined;
    };
    var hasLEdge = function (detail) {
      return hasEdge(detail, l);
    };
    var hasREdge = function (detail) {
      return hasEdge(detail, r);
    };
    var hasTEdge = function (detail) {
      return hasEdge(detail, t);
    };
    var hasBEdge = function (detail) {
      return hasEdge(detail, b);
    };
    var currentValue = function (detail) {
      return detail.model.value.get();
    };

    var xValue = function (x) {
      return { x: x };
    };
    var yValue = function (y) {
      return { y: y };
    };
    var xyValue = function (x, y) {
      return {
        x: x,
        y: y
      };
    };
    var fireSliderChange$3 = function (component, value) {
      emitWith(component, sliderChangeEvent(), { value: value });
    };
    var setToTLEdgeXY = function (edge, detail) {
      fireSliderChange$3(edge, xyValue(min1X(detail), min1Y(detail)));
    };
    var setToTEdge = function (edge, detail) {
      fireSliderChange$3(edge, yValue(min1Y(detail)));
    };
    var setToTEdgeXY = function (edge, detail) {
      fireSliderChange$3(edge, xyValue(halfX(detail), min1Y(detail)));
    };
    var setToTREdgeXY = function (edge, detail) {
      fireSliderChange$3(edge, xyValue(max1X(detail), min1Y(detail)));
    };
    var setToREdge = function (edge, detail) {
      fireSliderChange$3(edge, xValue(max1X(detail)));
    };
    var setToREdgeXY = function (edge, detail) {
      fireSliderChange$3(edge, xyValue(max1X(detail), halfY(detail)));
    };
    var setToBREdgeXY = function (edge, detail) {
      fireSliderChange$3(edge, xyValue(max1X(detail), max1Y(detail)));
    };
    var setToBEdge = function (edge, detail) {
      fireSliderChange$3(edge, yValue(max1Y(detail)));
    };
    var setToBEdgeXY = function (edge, detail) {
      fireSliderChange$3(edge, xyValue(halfX(detail), max1Y(detail)));
    };
    var setToBLEdgeXY = function (edge, detail) {
      fireSliderChange$3(edge, xyValue(min1X(detail), max1Y(detail)));
    };
    var setToLEdge = function (edge, detail) {
      fireSliderChange$3(edge, xValue(min1X(detail)));
    };
    var setToLEdgeXY = function (edge, detail) {
      fireSliderChange$3(edge, xyValue(min1X(detail), halfY(detail)));
    };

    var reduceBy = function (value, min, max, step) {
      if (value < min) {
        return value;
      } else if (value > max) {
        return max;
      } else if (value === min) {
        return min - 1;
      } else {
        return Math.max(min, value - step);
      }
    };
    var increaseBy = function (value, min, max, step) {
      if (value > max) {
        return value;
      } else if (value < min) {
        return min;
      } else if (value === max) {
        return max + 1;
      } else {
        return Math.min(max, value + step);
      }
    };
    var capValue = function (value, min, max) {
      return Math.max(min, Math.min(max, value));
    };
    var snapValueOf = function (value, min, max, step, snapStart) {
      return snapStart.fold(function () {
        var initValue = value - min;
        var extraValue = Math.round(initValue / step) * step;
        return capValue(min + extraValue, min - 1, max + 1);
      }, function (start) {
        var remainder = (value - start) % step;
        var adjustment = Math.round(remainder / step);
        var rawSteps = Math.floor((value - start) / step);
        var maxSteps = Math.floor((max - start) / step);
        var numSteps = Math.min(maxSteps, rawSteps + adjustment);
        var r = start + numSteps * step;
        return Math.max(start, r);
      });
    };
    var findOffsetOf = function (value, min, max) {
      return Math.min(max, Math.max(value, min)) - min;
    };
    var findValueOf = function (args) {
      var min = args.min, max = args.max, range = args.range, value = args.value, step = args.step, snap = args.snap, snapStart = args.snapStart, rounded = args.rounded, hasMinEdge = args.hasMinEdge, hasMaxEdge = args.hasMaxEdge, minBound = args.minBound, maxBound = args.maxBound, screenRange = args.screenRange;
      var capMin = hasMinEdge ? min - 1 : min;
      var capMax = hasMaxEdge ? max + 1 : max;
      if (value < minBound) {
        return capMin;
      } else if (value > maxBound) {
        return capMax;
      } else {
        var offset = findOffsetOf(value, minBound, maxBound);
        var newValue = capValue(offset / screenRange * range + min, capMin, capMax);
        if (snap && newValue >= min && newValue <= max) {
          return snapValueOf(newValue, min, max, step, snapStart);
        } else if (rounded) {
          return Math.round(newValue);
        } else {
          return newValue;
        }
      }
    };
    var findOffsetOfValue$2 = function (args) {
      var min = args.min, max = args.max, range = args.range, value = args.value, hasMinEdge = args.hasMinEdge, hasMaxEdge = args.hasMaxEdge, maxBound = args.maxBound, maxOffset = args.maxOffset, centerMinEdge = args.centerMinEdge, centerMaxEdge = args.centerMaxEdge;
      if (value < min) {
        return hasMinEdge ? 0 : centerMinEdge;
      } else if (value > max) {
        return hasMaxEdge ? maxBound : centerMaxEdge;
      } else {
        return (value - min) / range * maxOffset;
      }
    };

    var top = 'top', right = 'right', bottom = 'bottom', left = 'left', width = 'width', height = 'height';
    var getBounds = function (component) {
      return component.element.dom.getBoundingClientRect();
    };
    var getBoundsProperty = function (bounds, property) {
      return bounds[property];
    };
    var getMinXBounds = function (component) {
      var bounds = getBounds(component);
      return getBoundsProperty(bounds, left);
    };
    var getMaxXBounds = function (component) {
      var bounds = getBounds(component);
      return getBoundsProperty(bounds, right);
    };
    var getMinYBounds = function (component) {
      var bounds = getBounds(component);
      return getBoundsProperty(bounds, top);
    };
    var getMaxYBounds = function (component) {
      var bounds = getBounds(component);
      return getBoundsProperty(bounds, bottom);
    };
    var getXScreenRange = function (component) {
      var bounds = getBounds(component);
      return getBoundsProperty(bounds, width);
    };
    var getYScreenRange = function (component) {
      var bounds = getBounds(component);
      return getBoundsProperty(bounds, height);
    };
    var getCenterOffsetOf = function (componentMinEdge, componentMaxEdge, spectrumMinEdge) {
      return (componentMinEdge + componentMaxEdge) / 2 - spectrumMinEdge;
    };
    var getXCenterOffSetOf = function (component, spectrum) {
      var componentBounds = getBounds(component);
      var spectrumBounds = getBounds(spectrum);
      var componentMinEdge = getBoundsProperty(componentBounds, left);
      var componentMaxEdge = getBoundsProperty(componentBounds, right);
      var spectrumMinEdge = getBoundsProperty(spectrumBounds, left);
      return getCenterOffsetOf(componentMinEdge, componentMaxEdge, spectrumMinEdge);
    };
    var getYCenterOffSetOf = function (component, spectrum) {
      var componentBounds = getBounds(component);
      var spectrumBounds = getBounds(spectrum);
      var componentMinEdge = getBoundsProperty(componentBounds, top);
      var componentMaxEdge = getBoundsProperty(componentBounds, bottom);
      var spectrumMinEdge = getBoundsProperty(spectrumBounds, top);
      return getCenterOffsetOf(componentMinEdge, componentMaxEdge, spectrumMinEdge);
    };

    var fireSliderChange$2 = function (spectrum, value) {
      emitWith(spectrum, sliderChangeEvent(), { value: value });
    };
    var sliderValue$2 = function (x) {
      return { x: x };
    };
    var findValueOfOffset$1 = function (spectrum, detail, left) {
      var args = {
        min: minX(detail),
        max: maxX(detail),
        range: xRange(detail),
        value: left,
        step: step(detail),
        snap: snap(detail),
        snapStart: snapStart(detail),
        rounded: rounded(detail),
        hasMinEdge: hasLEdge(detail),
        hasMaxEdge: hasREdge(detail),
        minBound: getMinXBounds(spectrum),
        maxBound: getMaxXBounds(spectrum),
        screenRange: getXScreenRange(spectrum)
      };
      return findValueOf(args);
    };
    var setValueFrom$2 = function (spectrum, detail, value) {
      var xValue = findValueOfOffset$1(spectrum, detail, value);
      var sliderVal = sliderValue$2(xValue);
      fireSliderChange$2(spectrum, sliderVal);
      return xValue;
    };
    var setToMin$2 = function (spectrum, detail) {
      var min = minX(detail);
      fireSliderChange$2(spectrum, sliderValue$2(min));
    };
    var setToMax$2 = function (spectrum, detail) {
      var max = maxX(detail);
      fireSliderChange$2(spectrum, sliderValue$2(max));
    };
    var moveBy$2 = function (direction, spectrum, detail) {
      var f = direction > 0 ? increaseBy : reduceBy;
      var xValue = f(currentValue(detail).x, minX(detail), maxX(detail), step(detail));
      fireSliderChange$2(spectrum, sliderValue$2(xValue));
      return Optional.some(xValue);
    };
    var handleMovement$2 = function (direction) {
      return function (spectrum, detail) {
        return moveBy$2(direction, spectrum, detail).map(always);
      };
    };
    var getValueFromEvent$2 = function (simulatedEvent) {
      var pos = getEventSource(simulatedEvent);
      return pos.map(function (p) {
        return p.left;
      });
    };
    var findOffsetOfValue$1 = function (spectrum, detail, value, minEdge, maxEdge) {
      var minOffset = 0;
      var maxOffset = getXScreenRange(spectrum);
      var centerMinEdge = minEdge.bind(function (edge) {
        return Optional.some(getXCenterOffSetOf(edge, spectrum));
      }).getOr(minOffset);
      var centerMaxEdge = maxEdge.bind(function (edge) {
        return Optional.some(getXCenterOffSetOf(edge, spectrum));
      }).getOr(maxOffset);
      var args = {
        min: minX(detail),
        max: maxX(detail),
        range: xRange(detail),
        value: value,
        hasMinEdge: hasLEdge(detail),
        hasMaxEdge: hasREdge(detail),
        minBound: getMinXBounds(spectrum),
        minOffset: minOffset,
        maxBound: getMaxXBounds(spectrum),
        maxOffset: maxOffset,
        centerMinEdge: centerMinEdge,
        centerMaxEdge: centerMaxEdge
      };
      return findOffsetOfValue$2(args);
    };
    var findPositionOfValue$1 = function (slider, spectrum, value, minEdge, maxEdge, detail) {
      var offset = findOffsetOfValue$1(spectrum, detail, value, minEdge, maxEdge);
      return getMinXBounds(spectrum) - getMinXBounds(slider) + offset;
    };
    var setPositionFromValue$2 = function (slider, thumb, detail, edges) {
      var value = currentValue(detail);
      var pos = findPositionOfValue$1(slider, edges.getSpectrum(slider), value.x, edges.getLeftEdge(slider), edges.getRightEdge(slider), detail);
      var thumbRadius = get$a(thumb.element) / 2;
      set$7(thumb.element, 'left', pos - thumbRadius + 'px');
    };
    var onLeft$2 = handleMovement$2(-1);
    var onRight$2 = handleMovement$2(1);
    var onUp$2 = Optional.none;
    var onDown$2 = Optional.none;
    var edgeActions$2 = {
      'top-left': Optional.none(),
      'top': Optional.none(),
      'top-right': Optional.none(),
      'right': Optional.some(setToREdge),
      'bottom-right': Optional.none(),
      'bottom': Optional.none(),
      'bottom-left': Optional.none(),
      'left': Optional.some(setToLEdge)
    };

    var HorizontalModel = /*#__PURE__*/Object.freeze({
        __proto__: null,
        setValueFrom: setValueFrom$2,
        setToMin: setToMin$2,
        setToMax: setToMax$2,
        findValueOfOffset: findValueOfOffset$1,
        getValueFromEvent: getValueFromEvent$2,
        findPositionOfValue: findPositionOfValue$1,
        setPositionFromValue: setPositionFromValue$2,
        onLeft: onLeft$2,
        onRight: onRight$2,
        onUp: onUp$2,
        onDown: onDown$2,
        edgeActions: edgeActions$2
    });

    var fireSliderChange$1 = function (spectrum, value) {
      emitWith(spectrum, sliderChangeEvent(), { value: value });
    };
    var sliderValue$1 = function (y) {
      return { y: y };
    };
    var findValueOfOffset = function (spectrum, detail, top) {
      var args = {
        min: minY(detail),
        max: maxY(detail),
        range: yRange(detail),
        value: top,
        step: step(detail),
        snap: snap(detail),
        snapStart: snapStart(detail),
        rounded: rounded(detail),
        hasMinEdge: hasTEdge(detail),
        hasMaxEdge: hasBEdge(detail),
        minBound: getMinYBounds(spectrum),
        maxBound: getMaxYBounds(spectrum),
        screenRange: getYScreenRange(spectrum)
      };
      return findValueOf(args);
    };
    var setValueFrom$1 = function (spectrum, detail, value) {
      var yValue = findValueOfOffset(spectrum, detail, value);
      var sliderVal = sliderValue$1(yValue);
      fireSliderChange$1(spectrum, sliderVal);
      return yValue;
    };
    var setToMin$1 = function (spectrum, detail) {
      var min = minY(detail);
      fireSliderChange$1(spectrum, sliderValue$1(min));
    };
    var setToMax$1 = function (spectrum, detail) {
      var max = maxY(detail);
      fireSliderChange$1(spectrum, sliderValue$1(max));
    };
    var moveBy$1 = function (direction, spectrum, detail) {
      var f = direction > 0 ? increaseBy : reduceBy;
      var yValue = f(currentValue(detail).y, minY(detail), maxY(detail), step(detail));
      fireSliderChange$1(spectrum, sliderValue$1(yValue));
      return Optional.some(yValue);
    };
    var handleMovement$1 = function (direction) {
      return function (spectrum, detail) {
        return moveBy$1(direction, spectrum, detail).map(always);
      };
    };
    var getValueFromEvent$1 = function (simulatedEvent) {
      var pos = getEventSource(simulatedEvent);
      return pos.map(function (p) {
        return p.top;
      });
    };
    var findOffsetOfValue = function (spectrum, detail, value, minEdge, maxEdge) {
      var minOffset = 0;
      var maxOffset = getYScreenRange(spectrum);
      var centerMinEdge = minEdge.bind(function (edge) {
        return Optional.some(getYCenterOffSetOf(edge, spectrum));
      }).getOr(minOffset);
      var centerMaxEdge = maxEdge.bind(function (edge) {
        return Optional.some(getYCenterOffSetOf(edge, spectrum));
      }).getOr(maxOffset);
      var args = {
        min: minY(detail),
        max: maxY(detail),
        range: yRange(detail),
        value: value,
        hasMinEdge: hasTEdge(detail),
        hasMaxEdge: hasBEdge(detail),
        minBound: getMinYBounds(spectrum),
        minOffset: minOffset,
        maxBound: getMaxYBounds(spectrum),
        maxOffset: maxOffset,
        centerMinEdge: centerMinEdge,
        centerMaxEdge: centerMaxEdge
      };
      return findOffsetOfValue$2(args);
    };
    var findPositionOfValue = function (slider, spectrum, value, minEdge, maxEdge, detail) {
      var offset = findOffsetOfValue(spectrum, detail, value, minEdge, maxEdge);
      return getMinYBounds(spectrum) - getMinYBounds(slider) + offset;
    };
    var setPositionFromValue$1 = function (slider, thumb, detail, edges) {
      var value = currentValue(detail);
      var pos = findPositionOfValue(slider, edges.getSpectrum(slider), value.y, edges.getTopEdge(slider), edges.getBottomEdge(slider), detail);
      var thumbRadius = get$b(thumb.element) / 2;
      set$7(thumb.element, 'top', pos - thumbRadius + 'px');
    };
    var onLeft$1 = Optional.none;
    var onRight$1 = Optional.none;
    var onUp$1 = handleMovement$1(-1);
    var onDown$1 = handleMovement$1(1);
    var edgeActions$1 = {
      'top-left': Optional.none(),
      'top': Optional.some(setToTEdge),
      'top-right': Optional.none(),
      'right': Optional.none(),
      'bottom-right': Optional.none(),
      'bottom': Optional.some(setToBEdge),
      'bottom-left': Optional.none(),
      'left': Optional.none()
    };

    var VerticalModel = /*#__PURE__*/Object.freeze({
        __proto__: null,
        setValueFrom: setValueFrom$1,
        setToMin: setToMin$1,
        setToMax: setToMax$1,
        findValueOfOffset: findValueOfOffset,
        getValueFromEvent: getValueFromEvent$1,
        findPositionOfValue: findPositionOfValue,
        setPositionFromValue: setPositionFromValue$1,
        onLeft: onLeft$1,
        onRight: onRight$1,
        onUp: onUp$1,
        onDown: onDown$1,
        edgeActions: edgeActions$1
    });

    var fireSliderChange = function (spectrum, value) {
      emitWith(spectrum, sliderChangeEvent(), { value: value });
    };
    var sliderValue = function (x, y) {
      return {
        x: x,
        y: y
      };
    };
    var setValueFrom = function (spectrum, detail, value) {
      var xValue = findValueOfOffset$1(spectrum, detail, value.left);
      var yValue = findValueOfOffset(spectrum, detail, value.top);
      var val = sliderValue(xValue, yValue);
      fireSliderChange(spectrum, val);
      return val;
    };
    var moveBy = function (direction, isVerticalMovement, spectrum, detail) {
      var f = direction > 0 ? increaseBy : reduceBy;
      var xValue = isVerticalMovement ? currentValue(detail).x : f(currentValue(detail).x, minX(detail), maxX(detail), step(detail));
      var yValue = !isVerticalMovement ? currentValue(detail).y : f(currentValue(detail).y, minY(detail), maxY(detail), step(detail));
      fireSliderChange(spectrum, sliderValue(xValue, yValue));
      return Optional.some(xValue);
    };
    var handleMovement = function (direction, isVerticalMovement) {
      return function (spectrum, detail) {
        return moveBy(direction, isVerticalMovement, spectrum, detail).map(always);
      };
    };
    var setToMin = function (spectrum, detail) {
      var mX = minX(detail);
      var mY = minY(detail);
      fireSliderChange(spectrum, sliderValue(mX, mY));
    };
    var setToMax = function (spectrum, detail) {
      var mX = maxX(detail);
      var mY = maxY(detail);
      fireSliderChange(spectrum, sliderValue(mX, mY));
    };
    var getValueFromEvent = function (simulatedEvent) {
      return getEventSource(simulatedEvent);
    };
    var setPositionFromValue = function (slider, thumb, detail, edges) {
      var value = currentValue(detail);
      var xPos = findPositionOfValue$1(slider, edges.getSpectrum(slider), value.x, edges.getLeftEdge(slider), edges.getRightEdge(slider), detail);
      var yPos = findPositionOfValue(slider, edges.getSpectrum(slider), value.y, edges.getTopEdge(slider), edges.getBottomEdge(slider), detail);
      var thumbXRadius = get$a(thumb.element) / 2;
      var thumbYRadius = get$b(thumb.element) / 2;
      set$7(thumb.element, 'left', xPos - thumbXRadius + 'px');
      set$7(thumb.element, 'top', yPos - thumbYRadius + 'px');
    };
    var onLeft = handleMovement(-1, false);
    var onRight = handleMovement(1, false);
    var onUp = handleMovement(-1, true);
    var onDown = handleMovement(1, true);
    var edgeActions = {
      'top-left': Optional.some(setToTLEdgeXY),
      'top': Optional.some(setToTEdgeXY),
      'top-right': Optional.some(setToTREdgeXY),
      'right': Optional.some(setToREdgeXY),
      'bottom-right': Optional.some(setToBREdgeXY),
      'bottom': Optional.some(setToBEdgeXY),
      'bottom-left': Optional.some(setToBLEdgeXY),
      'left': Optional.some(setToLEdgeXY)
    };

    var TwoDModel = /*#__PURE__*/Object.freeze({
        __proto__: null,
        setValueFrom: setValueFrom,
        setToMin: setToMin,
        setToMax: setToMax,
        getValueFromEvent: getValueFromEvent,
        setPositionFromValue: setPositionFromValue,
        onLeft: onLeft,
        onRight: onRight,
        onUp: onUp,
        onDown: onDown,
        edgeActions: edgeActions
    });

    var SliderSchema = [
      defaulted('stepSize', 1),
      defaulted('onChange', noop),
      defaulted('onChoose', noop),
      defaulted('onInit', noop),
      defaulted('onDragStart', noop),
      defaulted('onDragEnd', noop),
      defaulted('snapToGrid', false),
      defaulted('rounded', true),
      option('snapStart'),
      requiredOf('model', choose$1('mode', {
        x: [
          defaulted('minX', 0),
          defaulted('maxX', 100),
          customField('value', function (spec) {
            return Cell(spec.mode.minX);
          }),
          required$1('getInitialValue'),
          output$1('manager', HorizontalModel)
        ],
        y: [
          defaulted('minY', 0),
          defaulted('maxY', 100),
          customField('value', function (spec) {
            return Cell(spec.mode.minY);
          }),
          required$1('getInitialValue'),
          output$1('manager', VerticalModel)
        ],
        xy: [
          defaulted('minX', 0),
          defaulted('maxX', 100),
          defaulted('minY', 0),
          defaulted('maxY', 100),
          customField('value', function (spec) {
            return Cell({
              x: spec.mode.minX,
              y: spec.mode.minY
            });
          }),
          required$1('getInitialValue'),
          output$1('manager', TwoDModel)
        ]
      })),
      field('sliderBehaviours', [
        Keying,
        Representing
      ]),
      customField('mouseIsDown', function () {
        return Cell(false);
      })
    ];

    var sketch$2 = function (detail, components, _spec, _externals) {
      var _a;
      var getThumb = function (component) {
        return getPartOrDie(component, detail, 'thumb');
      };
      var getSpectrum = function (component) {
        return getPartOrDie(component, detail, 'spectrum');
      };
      var getLeftEdge = function (component) {
        return getPart(component, detail, 'left-edge');
      };
      var getRightEdge = function (component) {
        return getPart(component, detail, 'right-edge');
      };
      var getTopEdge = function (component) {
        return getPart(component, detail, 'top-edge');
      };
      var getBottomEdge = function (component) {
        return getPart(component, detail, 'bottom-edge');
      };
      var modelDetail = detail.model;
      var model = modelDetail.manager;
      var refresh = function (slider, thumb) {
        model.setPositionFromValue(slider, thumb, detail, {
          getLeftEdge: getLeftEdge,
          getRightEdge: getRightEdge,
          getTopEdge: getTopEdge,
          getBottomEdge: getBottomEdge,
          getSpectrum: getSpectrum
        });
      };
      var setValue = function (slider, newValue) {
        modelDetail.value.set(newValue);
        var thumb = getThumb(slider);
        refresh(slider, thumb);
      };
      var changeValue = function (slider, newValue) {
        setValue(slider, newValue);
        var thumb = getThumb(slider);
        detail.onChange(slider, thumb, newValue);
        return Optional.some(true);
      };
      var resetToMin = function (slider) {
        model.setToMin(slider, detail);
      };
      var resetToMax = function (slider) {
        model.setToMax(slider, detail);
      };
      var choose = function (slider) {
        var fireOnChoose = function () {
          getPart(slider, detail, 'thumb').each(function (thumb) {
            var value = modelDetail.value.get();
            detail.onChoose(slider, thumb, value);
          });
        };
        var wasDown = detail.mouseIsDown.get();
        detail.mouseIsDown.set(false);
        if (wasDown) {
          fireOnChoose();
        }
      };
      var onDragStart = function (slider, simulatedEvent) {
        simulatedEvent.stop();
        detail.mouseIsDown.set(true);
        detail.onDragStart(slider, getThumb(slider));
      };
      var onDragEnd = function (slider, simulatedEvent) {
        simulatedEvent.stop();
        detail.onDragEnd(slider, getThumb(slider));
        choose(slider);
      };
      return {
        uid: detail.uid,
        dom: detail.dom,
        components: components,
        behaviours: augment(detail.sliderBehaviours, [
          Keying.config({
            mode: 'special',
            focusIn: function (slider) {
              return getPart(slider, detail, 'spectrum').map(Keying.focusIn).map(always);
            }
          }),
          Representing.config({
            store: {
              mode: 'manual',
              getValue: function (_) {
                return modelDetail.value.get();
              }
            }
          }),
          Receiving.config({ channels: (_a = {}, _a[mouseReleased()] = { onReceive: choose }, _a) })
        ]),
        events: derive$2([
          run$1(sliderChangeEvent(), function (slider, simulatedEvent) {
            changeValue(slider, simulatedEvent.event.value);
          }),
          runOnAttached(function (slider, _simulatedEvent) {
            var getInitial = modelDetail.getInitialValue();
            modelDetail.value.set(getInitial);
            var thumb = getThumb(slider);
            refresh(slider, thumb);
            var spectrum = getSpectrum(slider);
            detail.onInit(slider, thumb, spectrum, modelDetail.value.get());
          }),
          run$1(touchstart(), onDragStart),
          run$1(touchend(), onDragEnd),
          run$1(mousedown(), onDragStart),
          run$1(mouseup(), onDragEnd)
        ]),
        apis: {
          resetToMin: resetToMin,
          resetToMax: resetToMax,
          setValue: setValue,
          refresh: refresh
        },
        domModification: { styles: { position: 'relative' } }
      };
    };

    var Slider = composite({
      name: 'Slider',
      configFields: SliderSchema,
      partFields: SliderParts,
      factory: sketch$2,
      apis: {
        setValue: function (apis, slider, value) {
          apis.setValue(slider, value);
        },
        resetToMin: function (apis, slider) {
          apis.resetToMin(slider);
        },
        resetToMax: function (apis, slider) {
          apis.resetToMax(slider);
        },
        refresh: function (apis, slider) {
          apis.refresh(slider);
        }
      }
    });

    var fieldsUpdate = generate$6('rgb-hex-update');
    var sliderUpdate = generate$6('slider-update');
    var paletteUpdate = generate$6('palette-update');

    var sliderFactory = function (translate, getClass) {
      var spectrum = Slider.parts.spectrum({
        dom: {
          tag: 'div',
          classes: [getClass('hue-slider-spectrum')],
          attributes: { role: 'presentation' }
        }
      });
      var thumb = Slider.parts.thumb({
        dom: {
          tag: 'div',
          classes: [getClass('hue-slider-thumb')],
          attributes: { role: 'presentation' }
        }
      });
      return Slider.sketch({
        dom: {
          tag: 'div',
          classes: [getClass('hue-slider')],
          attributes: { role: 'presentation' }
        },
        rounded: false,
        model: {
          mode: 'y',
          getInitialValue: constant$1({ y: 0 })
        },
        components: [
          spectrum,
          thumb
        ],
        sliderBehaviours: derive$1([Focusing.config({})]),
        onChange: function (slider, _thumb, value) {
          emitWith(slider, sliderUpdate, { value: value });
        }
      });
    };

    var owner$1 = 'form';
    var schema$i = [field('formBehaviours', [Representing])];
    var getPartName$1 = function (name) {
      return '<alloy.field.' + name + '>';
    };
    var sketch$1 = function (fSpec) {
      var parts = function () {
        var record = [];
        var field = function (name, config) {
          record.push(name);
          return generateOne$1(owner$1, getPartName$1(name), config);
        };
        return {
          field: field,
          record: constant$1(record)
        };
      }();
      var spec = fSpec(parts);
      var partNames = parts.record();
      var fieldParts = map$2(partNames, function (n) {
        return required({
          name: n,
          pname: getPartName$1(n)
        });
      });
      return composite$1(owner$1, schema$i, fieldParts, make$4, spec);
    };
    var toResult = function (o, e) {
      return o.fold(function () {
        return Result.error(e);
      }, Result.value);
    };
    var make$4 = function (detail, components) {
      return {
        uid: detail.uid,
        dom: detail.dom,
        components: components,
        behaviours: augment(detail.formBehaviours, [Representing.config({
            store: {
              mode: 'manual',
              getValue: function (form) {
                var resPs = getAllParts(form, detail);
                return map$1(resPs, function (resPThunk, pName) {
                  return resPThunk().bind(function (v) {
                    var opt = Composing.getCurrent(v);
                    return toResult(opt, new Error('Cannot find a current component to extract the value from for form part \'' + pName + '\': ' + element(v.element)));
                  }).map(Representing.getValue);
                });
              },
              setValue: function (form, values) {
                each(values, function (newValue, key) {
                  getPart(form, detail, key).each(function (wrapper) {
                    Composing.getCurrent(wrapper).each(function (field) {
                      Representing.setValue(field, newValue);
                    });
                  });
                });
              }
            }
          })]),
        apis: {
          getField: function (form, key) {
            return getPart(form, detail, key).bind(Composing.getCurrent);
          }
        }
      };
    };
    var Form = {
      getField: makeApi(function (apis, component, key) {
        return apis.getField(component, key);
      }),
      sketch: sketch$1
    };

    var validInput = generate$6('valid-input');
    var invalidInput = generate$6('invalid-input');
    var validatingInput = generate$6('validating-input');
    var translatePrefix = 'colorcustom.rgb.';
    var rgbFormFactory = function (translate, getClass, onValidHexx, onInvalidHexx) {
      var invalidation = function (label, isValid) {
        return Invalidating.config({
          invalidClass: getClass('invalid'),
          notify: {
            onValidate: function (comp) {
              emitWith(comp, validatingInput, { type: label });
            },
            onValid: function (comp) {
              emitWith(comp, validInput, {
                type: label,
                value: Representing.getValue(comp)
              });
            },
            onInvalid: function (comp) {
              emitWith(comp, invalidInput, {
                type: label,
                value: Representing.getValue(comp)
              });
            }
          },
          validator: {
            validate: function (comp) {
              var value = Representing.getValue(comp);
              var res = isValid(value) ? Result.value(true) : Result.error(translate('aria.input.invalid'));
              return Future.pure(res);
            },
            validateOnLoad: false
          }
        });
      };
      var renderTextField = function (isValid, name, label, description, data) {
        var helptext = translate(translatePrefix + 'range');
        var pLabel = FormField.parts.label({
          dom: {
            tag: 'label',
            innerHtml: label,
            attributes: { 'aria-label': description }
          }
        });
        var pField = FormField.parts.field({
          data: data,
          factory: Input,
          inputAttributes: __assign({ type: 'text' }, name === 'hex' ? { 'aria-live': 'polite' } : {}),
          inputClasses: [getClass('textfield')],
          inputBehaviours: derive$1([
            invalidation(name, isValid),
            Tabstopping.config({})
          ]),
          onSetValue: function (input) {
            if (Invalidating.isInvalid(input)) {
              var run = Invalidating.run(input);
              run.get(noop);
            }
          }
        });
        var comps = [
          pLabel,
          pField
        ];
        var concats = name !== 'hex' ? [FormField.parts['aria-descriptor']({ text: helptext })] : [];
        var components = comps.concat(concats);
        return {
          dom: {
            tag: 'div',
            attributes: { role: 'presentation' }
          },
          components: components
        };
      };
      var copyRgbToHex = function (form, rgba) {
        var hex = fromRgba(rgba);
        Form.getField(form, 'hex').each(function (hexField) {
          if (!Focusing.isFocused(hexField)) {
            Representing.setValue(form, { hex: hex.value });
          }
        });
        return hex;
      };
      var copyRgbToForm = function (form, rgb) {
        var red = rgb.red;
        var green = rgb.green;
        var blue = rgb.blue;
        Representing.setValue(form, {
          red: red,
          green: green,
          blue: blue
        });
      };
      var memPreview = record({
        dom: {
          tag: 'div',
          classes: [getClass('rgba-preview')],
          styles: { 'background-color': 'white' },
          attributes: { role: 'presentation' }
        }
      });
      var updatePreview = function (anyInSystem, hex) {
        memPreview.getOpt(anyInSystem).each(function (preview) {
          set$7(preview.element, 'background-color', '#' + hex.value);
        });
      };
      var factory = function () {
        var state = {
          red: Cell(Optional.some(255)),
          green: Cell(Optional.some(255)),
          blue: Cell(Optional.some(255)),
          hex: Cell(Optional.some('ffffff'))
        };
        var copyHexToRgb = function (form, hex) {
          var rgb = fromHex(hex);
          copyRgbToForm(form, rgb);
          setValueRgb(rgb);
        };
        var get = function (prop) {
          return state[prop].get();
        };
        var set = function (prop, value) {
          state[prop].set(value);
        };
        var getValueRgb = function () {
          return get('red').bind(function (red) {
            return get('green').bind(function (green) {
              return get('blue').map(function (blue) {
                return rgbaColour(red, green, blue, 1);
              });
            });
          });
        };
        var setValueRgb = function (rgb) {
          var red = rgb.red;
          var green = rgb.green;
          var blue = rgb.blue;
          set('red', Optional.some(red));
          set('green', Optional.some(green));
          set('blue', Optional.some(blue));
        };
        var onInvalidInput = function (form, simulatedEvent) {
          var data = simulatedEvent.event;
          if (data.type !== 'hex') {
            set(data.type, Optional.none());
          } else {
            onInvalidHexx(form);
          }
        };
        var onValidHex = function (form, value) {
          onValidHexx(form);
          var hex = hexColour(value);
          set('hex', Optional.some(value));
          var rgb = fromHex(hex);
          copyRgbToForm(form, rgb);
          setValueRgb(rgb);
          emitWith(form, fieldsUpdate, { hex: hex });
          updatePreview(form, hex);
        };
        var onValidRgb = function (form, prop, value) {
          var val = parseInt(value, 10);
          set(prop, Optional.some(val));
          getValueRgb().each(function (rgb) {
            var hex = copyRgbToHex(form, rgb);
            emitWith(form, fieldsUpdate, { hex: hex });
            updatePreview(form, hex);
          });
        };
        var isHexInputEvent = function (data) {
          return data.type === 'hex';
        };
        var onValidInput = function (form, simulatedEvent) {
          var data = simulatedEvent.event;
          if (isHexInputEvent(data)) {
            onValidHex(form, data.value);
          } else {
            onValidRgb(form, data.type, data.value);
          }
        };
        var formPartStrings = function (key) {
          return {
            label: translate(translatePrefix + key + '.label'),
            description: translate(translatePrefix + key + '.description')
          };
        };
        var redStrings = formPartStrings('red');
        var greenStrings = formPartStrings('green');
        var blueStrings = formPartStrings('blue');
        var hexStrings = formPartStrings('hex');
        return deepMerge(Form.sketch(function (parts) {
          return {
            dom: {
              tag: 'form',
              classes: [getClass('rgb-form')],
              attributes: { 'aria-label': translate('aria.color.picker') }
            },
            components: [
              parts.field('red', FormField.sketch(renderTextField(isRgbaComponent, 'red', redStrings.label, redStrings.description, 255))),
              parts.field('green', FormField.sketch(renderTextField(isRgbaComponent, 'green', greenStrings.label, greenStrings.description, 255))),
              parts.field('blue', FormField.sketch(renderTextField(isRgbaComponent, 'blue', blueStrings.label, blueStrings.description, 255))),
              parts.field('hex', FormField.sketch(renderTextField(isHexString, 'hex', hexStrings.label, hexStrings.description, 'ffffff'))),
              memPreview.asSpec()
            ],
            formBehaviours: derive$1([
              Invalidating.config({ invalidClass: getClass('form-invalid') }),
              config('rgb-form-events', [
                run$1(validInput, onValidInput),
                run$1(invalidInput, onInvalidInput),
                run$1(validatingInput, onInvalidInput)
              ])
            ])
          };
        }), {
          apis: {
            updateHex: function (form, hex) {
              Representing.setValue(form, { hex: hex.value });
              copyHexToRgb(form, hex);
              updatePreview(form, hex);
            }
          }
        });
      };
      var rgbFormSketcher = single({
        factory: factory,
        name: 'RgbForm',
        configFields: [],
        apis: {
          updateHex: function (apis, form, hex) {
            apis.updateHex(form, hex);
          }
        },
        extraApis: {}
      });
      return rgbFormSketcher;
    };

    var paletteFactory = function (_translate, getClass) {
      var spectrumPart = Slider.parts.spectrum({
        dom: {
          tag: 'canvas',
          attributes: { role: 'presentation' },
          classes: [getClass('sv-palette-spectrum')]
        }
      });
      var thumbPart = Slider.parts.thumb({
        dom: {
          tag: 'div',
          attributes: { role: 'presentation' },
          classes: [getClass('sv-palette-thumb')],
          innerHtml: '<div class=' + getClass('sv-palette-inner-thumb') + ' role="presentation"></div>'
        }
      });
      var setColour = function (canvas, rgba) {
        var width = canvas.width, height = canvas.height;
        var ctx = canvas.getContext('2d');
        if (ctx === null) {
          return;
        }
        ctx.fillStyle = rgba;
        ctx.fillRect(0, 0, width, height);
        var grdWhite = ctx.createLinearGradient(0, 0, width, 0);
        grdWhite.addColorStop(0, 'rgba(255,255,255,1)');
        grdWhite.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = grdWhite;
        ctx.fillRect(0, 0, width, height);
        var grdBlack = ctx.createLinearGradient(0, 0, 0, height);
        grdBlack.addColorStop(0, 'rgba(0,0,0,0)');
        grdBlack.addColorStop(1, 'rgba(0,0,0,1)');
        ctx.fillStyle = grdBlack;
        ctx.fillRect(0, 0, width, height);
      };
      var setPaletteHue = function (slider, hue) {
        var canvas = slider.components()[0].element.dom;
        var hsv = hsvColour(hue, 100, 100);
        var rgba = fromHsv(hsv);
        setColour(canvas, toString(rgba));
      };
      var setPaletteThumb = function (slider, hex) {
        var hsv = fromRgb(fromHex(hex));
        Slider.setValue(slider, {
          x: hsv.saturation,
          y: 100 - hsv.value
        });
      };
      var factory = function (_detail) {
        var getInitialValue = constant$1({
          x: 0,
          y: 0
        });
        var onChange = function (slider, _thumb, value) {
          emitWith(slider, paletteUpdate, { value: value });
        };
        var onInit = function (_slider, _thumb, spectrum, _value) {
          setColour(spectrum.element.dom, toString(red));
        };
        var sliderBehaviours = derive$1([
          Composing.config({ find: Optional.some }),
          Focusing.config({})
        ]);
        return Slider.sketch({
          dom: {
            tag: 'div',
            attributes: { role: 'presentation' },
            classes: [getClass('sv-palette')]
          },
          model: {
            mode: 'xy',
            getInitialValue: getInitialValue
          },
          rounded: false,
          components: [
            spectrumPart,
            thumbPart
          ],
          onChange: onChange,
          onInit: onInit,
          sliderBehaviours: sliderBehaviours
        });
      };
      var saturationBrightnessPaletteSketcher = single({
        factory: factory,
        name: 'SaturationBrightnessPalette',
        configFields: [],
        apis: {
          setHue: function (_apis, slider, hue) {
            setPaletteHue(slider, hue);
          },
          setThumb: function (_apis, slider, hex) {
            setPaletteThumb(slider, hex);
          }
        },
        extraApis: {}
      });
      return saturationBrightnessPaletteSketcher;
    };

    var makeFactory = function (translate, getClass) {
      var factory = function (detail) {
        var rgbForm = rgbFormFactory(translate, getClass, detail.onValidHex, detail.onInvalidHex);
        var sbPalette = paletteFactory(translate, getClass);
        var hueSliderToDegrees = function (hue) {
          return (100 - hue) / 100 * 360;
        };
        var hueDegreesToSlider = function (hue) {
          return 100 - hue / 360 * 100;
        };
        var state = {
          paletteRgba: Cell(red),
          paletteHue: Cell(0)
        };
        var memSlider = record(sliderFactory(translate, getClass));
        var memPalette = record(sbPalette.sketch({}));
        var memRgb = record(rgbForm.sketch({}));
        var updatePalette = function (anyInSystem, _hex, hue) {
          memPalette.getOpt(anyInSystem).each(function (palette) {
            sbPalette.setHue(palette, hue);
          });
        };
        var updateFields = function (anyInSystem, hex) {
          memRgb.getOpt(anyInSystem).each(function (form) {
            rgbForm.updateHex(form, hex);
          });
        };
        var updateSlider = function (anyInSystem, _hex, hue) {
          memSlider.getOpt(anyInSystem).each(function (slider) {
            Slider.setValue(slider, { y: hueDegreesToSlider(hue) });
          });
        };
        var updatePaletteThumb = function (anyInSystem, hex) {
          memPalette.getOpt(anyInSystem).each(function (palette) {
            sbPalette.setThumb(palette, hex);
          });
        };
        var updateState = function (hex, hue) {
          var rgba = fromHex(hex);
          state.paletteRgba.set(rgba);
          state.paletteHue.set(hue);
        };
        var runUpdates = function (anyInSystem, hex, hue, updates) {
          updateState(hex, hue);
          each$1(updates, function (update) {
            update(anyInSystem, hex, hue);
          });
        };
        var onPaletteUpdate = function () {
          var updates = [updateFields];
          return function (form, simulatedEvent) {
            var value = simulatedEvent.event.value;
            var oldHue = state.paletteHue.get();
            var newHsv = hsvColour(oldHue, value.x, 100 - value.y);
            var newHex = hsvToHex(newHsv);
            runUpdates(form, newHex, oldHue, updates);
          };
        };
        var onSliderUpdate = function () {
          var updates = [
            updatePalette,
            updateFields
          ];
          return function (form, simulatedEvent) {
            var hue = hueSliderToDegrees(simulatedEvent.event.value.y);
            var oldRgb = state.paletteRgba.get();
            var oldHsv = fromRgb(oldRgb);
            var newHsv = hsvColour(hue, oldHsv.saturation, oldHsv.value);
            var newHex = hsvToHex(newHsv);
            runUpdates(form, newHex, hue, updates);
          };
        };
        var onFieldsUpdate = function () {
          var updates = [
            updatePalette,
            updateSlider,
            updatePaletteThumb
          ];
          return function (form, simulatedEvent) {
            var hex = simulatedEvent.event.hex;
            var hsv = hexToHsv(hex);
            runUpdates(form, hex, hsv.hue, updates);
          };
        };
        return {
          uid: detail.uid,
          dom: detail.dom,
          components: [
            memPalette.asSpec(),
            memSlider.asSpec(),
            memRgb.asSpec()
          ],
          behaviours: derive$1([
            config('colour-picker-events', [
              run$1(fieldsUpdate, onFieldsUpdate()),
              run$1(paletteUpdate, onPaletteUpdate()),
              run$1(sliderUpdate, onSliderUpdate())
            ]),
            Composing.config({
              find: function (comp) {
                return memRgb.getOpt(comp);
              }
            }),
            Keying.config({ mode: 'acyclic' })
          ])
        };
      };
      var colourPickerSketcher = single({
        name: 'ColourPicker',
        configFields: [
          required$1('dom'),
          defaulted('onValidHex', noop),
          defaulted('onInvalidHex', noop)
        ],
        factory: factory
      });
      return colourPickerSketcher;
    };

    var self$1 = function () {
      return Composing.config({ find: Optional.some });
    };
    var memento$1 = function (mem) {
      return Composing.config({ find: mem.getOpt });
    };
    var childAt = function (index) {
      return Composing.config({
        find: function (comp) {
          return child$2(comp.element, index).bind(function (element) {
            return comp.getSystem().getByDom(element).toOptional();
          });
        }
      });
    };
    var ComposingConfigs = {
      self: self$1,
      memento: memento$1,
      childAt: childAt
    };

    var english = {
      'colorcustom.rgb.red.label': 'R',
      'colorcustom.rgb.red.description': 'Red component',
      'colorcustom.rgb.green.label': 'G',
      'colorcustom.rgb.green.description': 'Green component',
      'colorcustom.rgb.blue.label': 'B',
      'colorcustom.rgb.blue.description': 'Blue component',
      'colorcustom.rgb.hex.label': '#',
      'colorcustom.rgb.hex.description': 'Hex color code',
      'colorcustom.rgb.range': 'Range 0 to 255',
      'colorcustom.sb.saturation': 'Saturation',
      'colorcustom.sb.brightness': 'Brightness',
      'colorcustom.sb.picker': 'Saturation and Brightness Picker',
      'colorcustom.sb.palette': 'Saturation and Brightness Palette',
      'colorcustom.sb.instructions': 'Use arrow keys to select saturation and brightness, on x and y axes',
      'colorcustom.hue.hue': 'Hue',
      'colorcustom.hue.slider': 'Hue Slider',
      'colorcustom.hue.palette': 'Hue Palette',
      'colorcustom.hue.instructions': 'Use arrow keys to select a hue',
      'aria.color.picker': 'Color Picker',
      'aria.input.invalid': 'Invalid input'
    };
    var getEnglishText = function (key) {
      return english[key];
    };
    var translate$1 = function (key) {
      return getEnglishText(key);
    };
    var renderColorPicker = function (_spec) {
      var getClass = function (key) {
        return 'tox-' + key;
      };
      var colourPickerFactory = makeFactory(translate$1, getClass);
      var onValidHex = function (form) {
        emitWith(form, formActionEvent, {
          name: 'hex-valid',
          value: true
        });
      };
      var onInvalidHex = function (form) {
        emitWith(form, formActionEvent, {
          name: 'hex-valid',
          value: false
        });
      };
      var memPicker = record(colourPickerFactory.sketch({
        dom: {
          tag: 'div',
          classes: [getClass('color-picker-container')],
          attributes: { role: 'presentation' }
        },
        onValidHex: onValidHex,
        onInvalidHex: onInvalidHex
      }));
      return {
        dom: { tag: 'div' },
        components: [memPicker.asSpec()],
        behaviours: derive$1([
          Representing.config({
            store: {
              mode: 'manual',
              getValue: function (comp) {
                var picker = memPicker.get(comp);
                var optRgbForm = Composing.getCurrent(picker);
                var optHex = optRgbForm.bind(function (rgbForm) {
                  var formValues = Representing.getValue(rgbForm);
                  return formValues.hex;
                });
                return optHex.map(function (hex) {
                  return '#' + hex;
                }).getOr('');
              },
              setValue: function (comp, newValue) {
                var pattern = /^#([a-fA-F0-9]{3}(?:[a-fA-F0-9]{3})?)/;
                var m = pattern.exec(newValue);
                var picker = memPicker.get(comp);
                var optRgbForm = Composing.getCurrent(picker);
                optRgbForm.fold(function () {
                  console.log('Can not find form');
                }, function (rgbForm) {
                  Representing.setValue(rgbForm, { hex: Optional.from(m[1]).getOr('') });
                  Form.getField(rgbForm, 'hex').each(function (hexField) {
                    emit(hexField, input());
                  });
                });
              }
            }
          }),
          ComposingConfigs.self()
        ])
      };
    };

    var global$6 = tinymce.util.Tools.resolve('tinymce.Resource');

    var isOldCustomEditor = function (spec) {
      return has$2(spec, 'init');
    };
    var renderCustomEditor = function (spec) {
      var editorApi = value$1();
      var memReplaced = record({ dom: { tag: spec.tag } });
      var initialValue = value$1();
      return {
        dom: {
          tag: 'div',
          classes: ['tox-custom-editor']
        },
        behaviours: derive$1([
          config('custom-editor-events', [runOnAttached(function (component) {
              memReplaced.getOpt(component).each(function (ta) {
                (isOldCustomEditor(spec) ? spec.init(ta.element.dom) : global$6.load(spec.scriptId, spec.scriptUrl).then(function (init) {
                  return init(ta.element.dom, spec.settings);
                })).then(function (ea) {
                  initialValue.on(function (cvalue) {
                    ea.setValue(cvalue);
                  });
                  initialValue.clear();
                  editorApi.set(ea);
                });
              });
            })]),
          Representing.config({
            store: {
              mode: 'manual',
              getValue: function () {
                return editorApi.get().fold(function () {
                  return initialValue.get().getOr('');
                }, function (ed) {
                  return ed.getValue();
                });
              },
              setValue: function (component, value) {
                editorApi.get().fold(function () {
                  initialValue.set(value);
                }, function (ed) {
                  return ed.setValue(value);
                });
              }
            }
          }),
          ComposingConfigs.self()
        ]),
        components: [memReplaced.asSpec()]
      };
    };

    var global$5 = tinymce.util.Tools.resolve('tinymce.util.Tools');

    var processors = objOf([
      defaulted('preprocess', identity$1),
      defaulted('postprocess', identity$1)
    ]);
    var memento = function (mem, rawProcessors) {
      var ps = asRawOrDie$1('RepresentingConfigs.memento processors', processors, rawProcessors);
      return Representing.config({
        store: {
          mode: 'manual',
          getValue: function (comp) {
            var other = mem.get(comp);
            var rawValue = Representing.getValue(other);
            return ps.postprocess(rawValue);
          },
          setValue: function (comp, rawValue) {
            var newValue = ps.preprocess(rawValue);
            var other = mem.get(comp);
            Representing.setValue(other, newValue);
          }
        }
      });
    };
    var withComp = function (optInitialValue, getter, setter) {
      return Representing.config(deepMerge({
        store: {
          mode: 'manual',
          getValue: getter,
          setValue: setter
        }
      }, optInitialValue.map(function (initialValue) {
        return { store: { initialValue: initialValue } };
      }).getOr({})));
    };
    var withElement = function (initialValue, getter, setter) {
      return withComp(initialValue, function (c) {
        return getter(c.element);
      }, function (c, v) {
        return setter(c.element, v);
      });
    };
    var domValue = function (optInitialValue) {
      return withElement(optInitialValue, get$5, set$4);
    };
    var domHtml = function (optInitialValue) {
      return withElement(optInitialValue, get$7, set$5);
    };
    var memory = function (initialValue) {
      return Representing.config({
        store: {
          mode: 'memory',
          initialValue: initialValue
        }
      });
    };
    var RepresentingConfigs = {
      memento: memento,
      withElement: withElement,
      withComp: withComp,
      domValue: domValue,
      domHtml: domHtml,
      memory: memory
    };

    var defaultImageFileTypes = 'jpeg,jpg,jpe,jfi,jif,jfif,png,gif,bmp,webp';
    var filterByExtension = function (files, providersBackstage) {
      var allowedImageFileTypes = global$5.explode(providersBackstage.getSetting('images_file_types', defaultImageFileTypes, 'string'));
      var isFileInAllowedTypes = function (file) {
        return exists(allowedImageFileTypes, function (type) {
          return endsWith(file.name.toLowerCase(), '.' + type.toLowerCase());
        });
      };
      return filter$2(from(files), isFileInAllowedTypes);
    };
    var renderDropZone = function (spec, providersBackstage) {
      var stopper = function (_, se) {
        se.stop();
      };
      var sequence = function (actions) {
        return function (comp, se) {
          each$1(actions, function (a) {
            a(comp, se);
          });
        };
      };
      var onDrop = function (comp, se) {
        if (!Disabling.isDisabled(comp)) {
          var transferEvent = se.event.raw;
          handleFiles(comp, transferEvent.dataTransfer.files);
        }
      };
      var onSelect = function (component, simulatedEvent) {
        var input = simulatedEvent.event.raw.target;
        handleFiles(component, input.files);
      };
      var handleFiles = function (component, files) {
        Representing.setValue(component, filterByExtension(files, providersBackstage));
        emitWith(component, formChangeEvent, { name: spec.name });
      };
      var memInput = record({
        dom: {
          tag: 'input',
          attributes: {
            type: 'file',
            accept: 'image/*'
          },
          styles: { display: 'none' }
        },
        behaviours: derive$1([config('input-file-events', [
            cutter(click()),
            cutter(tap())
          ])])
      });
      var renderField = function (s) {
        return {
          uid: s.uid,
          dom: {
            tag: 'div',
            classes: ['tox-dropzone-container']
          },
          behaviours: derive$1([
            RepresentingConfigs.memory([]),
            ComposingConfigs.self(),
            Disabling.config({}),
            Toggling.config({
              toggleClass: 'dragenter',
              toggleOnExecute: false
            }),
            config('dropzone-events', [
              run$1('dragenter', sequence([
                stopper,
                Toggling.toggle
              ])),
              run$1('dragleave', sequence([
                stopper,
                Toggling.toggle
              ])),
              run$1('dragover', stopper),
              run$1('drop', sequence([
                stopper,
                onDrop
              ])),
              run$1(change(), onSelect)
            ])
          ]),
          components: [{
              dom: {
                tag: 'div',
                classes: ['tox-dropzone'],
                styles: {}
              },
              components: [
                {
                  dom: {
                    tag: 'p',
                    innerHtml: providersBackstage.translate('Drop an image here')
                  }
                },
                Button.sketch({
                  dom: {
                    tag: 'button',
                    innerHtml: providersBackstage.translate('Browse for an image'),
                    styles: { position: 'relative' },
                    classes: [
                      'tox-button',
                      'tox-button--secondary'
                    ]
                  },
                  components: [memInput.asSpec()],
                  action: function (comp) {
                    var inputComp = memInput.get(comp);
                    inputComp.element.dom.click();
                  },
                  buttonBehaviours: derive$1([
                    Tabstopping.config({}),
                    DisablingConfigs.button(providersBackstage.isDisabled),
                    receivingConfig()
                  ])
                })
              ]
            }]
        };
      };
      var pLabel = spec.label.map(function (label) {
        return renderLabel$2(label, providersBackstage);
      });
      var pField = FormField.parts.field({ factory: { sketch: renderField } });
      return renderFormFieldWith(pLabel, pField, ['tox-form__group--stretched'], []);
    };

    var renderGrid = function (spec, backstage) {
      return {
        dom: {
          tag: 'div',
          classes: [
            'tox-form__grid',
            'tox-form__grid--' + spec.columns + 'col'
          ]
        },
        components: map$2(spec.items, backstage.interpreter)
      };
    };

    var beforeObject = generate$6('alloy-fake-before-tabstop');
    var afterObject = generate$6('alloy-fake-after-tabstop');
    var craftWithClasses = function (classes) {
      return {
        dom: {
          tag: 'div',
          styles: {
            width: '1px',
            height: '1px',
            outline: 'none'
          },
          attributes: { tabindex: '0' },
          classes: classes
        },
        behaviours: derive$1([
          Focusing.config({ ignore: true }),
          Tabstopping.config({})
        ])
      };
    };
    var craft = function (spec) {
      return {
        dom: {
          tag: 'div',
          classes: ['tox-navobj']
        },
        components: [
          craftWithClasses([beforeObject]),
          spec,
          craftWithClasses([afterObject])
        ],
        behaviours: derive$1([ComposingConfigs.childAt(1)])
      };
    };
    var triggerTab = function (placeholder, shiftKey) {
      emitWith(placeholder, keydown(), {
        raw: {
          which: 9,
          shiftKey: shiftKey
        }
      });
    };
    var onFocus = function (container, targetComp) {
      var target = targetComp.element;
      if (has(target, beforeObject)) {
        triggerTab(container, true);
      } else if (has(target, afterObject)) {
        triggerTab(container, false);
      }
    };
    var isPseudoStop = function (element) {
      return closest(element, [
        '.' + beforeObject,
        '.' + afterObject
      ].join(','), never);
    };

    var platformNeedsSandboxing = !(detect$1().browser.isIE() || detect$1().browser.isEdge());
    var getDynamicSource = function (isSandbox) {
      var cachedValue = Cell('');
      return {
        getValue: function (_frameComponent) {
          return cachedValue.get();
        },
        setValue: function (frameComponent, html) {
          if (!isSandbox) {
            set$8(frameComponent.element, 'src', 'javascript:\'\'');
            var doc = frameComponent.element.dom.contentWindow.document;
            doc.open();
            doc.write(html);
            doc.close();
          } else {
            set$8(frameComponent.element, 'srcdoc', html);
          }
          cachedValue.set(html);
        }
      };
    };
    var renderIFrame = function (spec, providersBackstage) {
      var isSandbox = platformNeedsSandboxing && spec.sandboxed;
      var attributes = __assign(__assign({}, spec.label.map(function (title) {
        return { title: title };
      }).getOr({})), isSandbox ? { sandbox: 'allow-scripts allow-same-origin' } : {});
      var sourcing = getDynamicSource(isSandbox);
      var pLabel = spec.label.map(function (label) {
        return renderLabel$2(label, providersBackstage);
      });
      var factory = function (newSpec) {
        return craft({
          uid: newSpec.uid,
          dom: {
            tag: 'iframe',
            attributes: attributes
          },
          behaviours: derive$1([
            Tabstopping.config({}),
            Focusing.config({}),
            RepresentingConfigs.withComp(Optional.none(), sourcing.getValue, sourcing.setValue)
          ])
        });
      };
      var pField = FormField.parts.field({ factory: { sketch: factory } });
      return renderFormFieldWith(pLabel, pField, ['tox-form__group--stretched'], []);
    };

    var create$3 = function (width, height) {
      return resize$3(document.createElement('canvas'), width, height);
    };
    var clone = function (canvas) {
      var tCanvas = create$3(canvas.width, canvas.height);
      var ctx = get2dContext(tCanvas);
      ctx.drawImage(canvas, 0, 0);
      return tCanvas;
    };
    var get2dContext = function (canvas) {
      return canvas.getContext('2d');
    };
    var resize$3 = function (canvas, width, height) {
      canvas.width = width;
      canvas.height = height;
      return canvas;
    };

    var getWidth$1 = function (image) {
      return image.naturalWidth || image.width;
    };
    var getHeight$1 = function (image) {
      return image.naturalHeight || image.height;
    };

    var blobToImage = function (blob) {
      return new Promise$1(function (resolve, reject) {
        var blobUrl = URL.createObjectURL(blob);
        var image = new Image();
        var removeListeners = function () {
          image.removeEventListener('load', loaded);
          image.removeEventListener('error', error);
        };
        var loaded = function () {
          removeListeners();
          resolve(image);
        };
        var error = function () {
          removeListeners();
          reject('Unable to load data of type ' + blob.type + ': ' + blobUrl);
        };
        image.addEventListener('load', loaded);
        image.addEventListener('error', error);
        image.src = blobUrl;
        if (image.complete) {
          setTimeout(loaded, 0);
        }
      });
    };
    var dataUriToBlobSync = function (uri) {
      var data = uri.split(',');
      var matches = /data:([^;]+)/.exec(data[0]);
      if (!matches) {
        return Optional.none();
      }
      var mimetype = matches[1];
      var base64 = data[1];
      var sliceSize = 1024;
      var byteCharacters = atob(base64);
      var bytesLength = byteCharacters.length;
      var slicesCount = Math.ceil(bytesLength / sliceSize);
      var byteArrays = new Array(slicesCount);
      for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);
        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
          bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
      }
      return Optional.some(new Blob(byteArrays, { type: mimetype }));
    };
    var dataUriToBlob = function (uri) {
      return new Promise$1(function (resolve, reject) {
        dataUriToBlobSync(uri).fold(function () {
          reject('uri is not base64: ' + uri);
        }, resolve);
      });
    };
    var canvasToBlob = function (canvas, type, quality) {
      type = type || 'image/png';
      if (isFunction(HTMLCanvasElement.prototype.toBlob)) {
        return new Promise$1(function (resolve, reject) {
          canvas.toBlob(function (blob) {
            if (blob) {
              resolve(blob);
            } else {
              reject();
            }
          }, type, quality);
        });
      } else {
        return dataUriToBlob(canvas.toDataURL(type, quality));
      }
    };
    var canvasToDataURL = function (canvas, type, quality) {
      type = type || 'image/png';
      return canvas.toDataURL(type, quality);
    };
    var blobToCanvas = function (blob) {
      return blobToImage(blob).then(function (image) {
        revokeImageUrl(image);
        var canvas = create$3(getWidth$1(image), getHeight$1(image));
        var context = get2dContext(canvas);
        context.drawImage(image, 0, 0);
        return canvas;
      });
    };
    var blobToDataUri = function (blob) {
      return new Promise$1(function (resolve) {
        var reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        };
        reader.readAsDataURL(blob);
      });
    };
    var revokeImageUrl = function (image) {
      URL.revokeObjectURL(image.src);
    };

    var create$2 = function (getCanvas, blob, uri) {
      var initialType = blob.type;
      var getType = constant$1(initialType);
      var toBlob = function () {
        return Promise$1.resolve(blob);
      };
      var toDataURL = constant$1(uri);
      var toBase64 = function () {
        return uri.split(',')[1];
      };
      var toAdjustedBlob = function (type, quality) {
        return getCanvas.then(function (canvas) {
          return canvasToBlob(canvas, type, quality);
        });
      };
      var toAdjustedDataURL = function (type, quality) {
        return getCanvas.then(function (canvas) {
          return canvasToDataURL(canvas, type, quality);
        });
      };
      var toAdjustedBase64 = function (type, quality) {
        return toAdjustedDataURL(type, quality).then(function (dataurl) {
          return dataurl.split(',')[1];
        });
      };
      var toCanvas = function () {
        return getCanvas.then(clone);
      };
      return {
        getType: getType,
        toBlob: toBlob,
        toDataURL: toDataURL,
        toBase64: toBase64,
        toAdjustedBlob: toAdjustedBlob,
        toAdjustedDataURL: toAdjustedDataURL,
        toAdjustedBase64: toAdjustedBase64,
        toCanvas: toCanvas
      };
    };
    var fromBlob = function (blob) {
      return blobToDataUri(blob).then(function (uri) {
        return create$2(blobToCanvas(blob), blob, uri);
      });
    };
    var fromCanvas = function (canvas, type) {
      return canvasToBlob(canvas, type).then(function (blob) {
        return create$2(Promise$1.resolve(canvas), blob, canvas.toDataURL());
      });
    };

    var blobToImageResult = function (blob) {
      return fromBlob(blob);
    };

    var clamp = function (value, min, max) {
      var parsedValue = typeof value === 'string' ? parseFloat(value) : value;
      if (parsedValue > max) {
        parsedValue = max;
      } else if (parsedValue < min) {
        parsedValue = min;
      }
      return parsedValue;
    };
    var identity = function () {
      return [
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1
      ];
    };
    var DELTA_INDEX = [
      0,
      0.01,
      0.02,
      0.04,
      0.05,
      0.06,
      0.07,
      0.08,
      0.1,
      0.11,
      0.12,
      0.14,
      0.15,
      0.16,
      0.17,
      0.18,
      0.2,
      0.21,
      0.22,
      0.24,
      0.25,
      0.27,
      0.28,
      0.3,
      0.32,
      0.34,
      0.36,
      0.38,
      0.4,
      0.42,
      0.44,
      0.46,
      0.48,
      0.5,
      0.53,
      0.56,
      0.59,
      0.62,
      0.65,
      0.68,
      0.71,
      0.74,
      0.77,
      0.8,
      0.83,
      0.86,
      0.89,
      0.92,
      0.95,
      0.98,
      1,
      1.06,
      1.12,
      1.18,
      1.24,
      1.3,
      1.36,
      1.42,
      1.48,
      1.54,
      1.6,
      1.66,
      1.72,
      1.78,
      1.84,
      1.9,
      1.96,
      2,
      2.12,
      2.25,
      2.37,
      2.5,
      2.62,
      2.75,
      2.87,
      3,
      3.2,
      3.4,
      3.6,
      3.8,
      4,
      4.3,
      4.7,
      4.9,
      5,
      5.5,
      6,
      6.5,
      6.8,
      7,
      7.3,
      7.5,
      7.8,
      8,
      8.4,
      8.7,
      9,
      9.4,
      9.6,
      9.8,
      10
    ];
    var multiply = function (matrix1, matrix2) {
      var col = [];
      var out = new Array(25);
      var val;
      for (var i = 0; i < 5; i++) {
        for (var j = 0; j < 5; j++) {
          col[j] = matrix2[j + i * 5];
        }
        for (var j = 0; j < 5; j++) {
          val = 0;
          for (var k = 0; k < 5; k++) {
            val += matrix1[j + k * 5] * col[k];
          }
          out[j + i * 5] = val;
        }
      }
      return out;
    };
    var adjustContrast = function (matrix, value) {
      var x;
      value = clamp(value, -1, 1);
      value *= 100;
      if (value < 0) {
        x = 127 + value / 100 * 127;
      } else {
        x = value % 1;
        if (x === 0) {
          x = DELTA_INDEX[value];
        } else {
          x = DELTA_INDEX[Math.floor(value)] * (1 - x) + DELTA_INDEX[Math.floor(value) + 1] * x;
        }
        x = x * 127 + 127;
      }
      return multiply(matrix, [
        x / 127,
        0,
        0,
        0,
        0.5 * (127 - x),
        0,
        x / 127,
        0,
        0,
        0.5 * (127 - x),
        0,
        0,
        x / 127,
        0,
        0.5 * (127 - x),
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1
      ]);
    };
    var adjustBrightness = function (matrix, value) {
      value = clamp(255 * value, -255, 255);
      return multiply(matrix, [
        1,
        0,
        0,
        0,
        value,
        0,
        1,
        0,
        0,
        value,
        0,
        0,
        1,
        0,
        value,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1
      ]);
    };
    var adjustColors = function (matrix, adjustR, adjustG, adjustB) {
      adjustR = clamp(adjustR, 0, 2);
      adjustG = clamp(adjustG, 0, 2);
      adjustB = clamp(adjustB, 0, 2);
      return multiply(matrix, [
        adjustR,
        0,
        0,
        0,
        0,
        0,
        adjustG,
        0,
        0,
        0,
        0,
        0,
        adjustB,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1
      ]);
    };

    var colorFilter = function (ir, matrix) {
      return ir.toCanvas().then(function (canvas) {
        return applyColorFilter(canvas, ir.getType(), matrix);
      });
    };
    var applyColorFilter = function (canvas, type, matrix) {
      var context = get2dContext(canvas);
      var applyMatrix = function (pixelsData, m) {
        var r, g, b, a;
        var data = pixelsData.data, m0 = m[0], m1 = m[1], m2 = m[2], m3 = m[3], m4 = m[4], m5 = m[5], m6 = m[6], m7 = m[7], m8 = m[8], m9 = m[9], m10 = m[10], m11 = m[11], m12 = m[12], m13 = m[13], m14 = m[14], m15 = m[15], m16 = m[16], m17 = m[17], m18 = m[18], m19 = m[19];
        for (var i = 0; i < data.length; i += 4) {
          r = data[i];
          g = data[i + 1];
          b = data[i + 2];
          a = data[i + 3];
          data[i] = r * m0 + g * m1 + b * m2 + a * m3 + m4;
          data[i + 1] = r * m5 + g * m6 + b * m7 + a * m8 + m9;
          data[i + 2] = r * m10 + g * m11 + b * m12 + a * m13 + m14;
          data[i + 3] = r * m15 + g * m16 + b * m17 + a * m18 + m19;
        }
        return pixelsData;
      };
      var pixels = applyMatrix(context.getImageData(0, 0, canvas.width, canvas.height), matrix);
      context.putImageData(pixels, 0, 0);
      return fromCanvas(canvas, type);
    };
    var convoluteFilter = function (ir, matrix) {
      return ir.toCanvas().then(function (canvas) {
        return applyConvoluteFilter(canvas, ir.getType(), matrix);
      });
    };
    var applyConvoluteFilter = function (canvas, type, matrix) {
      var context = get2dContext(canvas);
      var applyMatrix = function (pIn, pOut, aMatrix) {
        var clamp = function (value, min, max) {
          if (value > max) {
            value = max;
          } else if (value < min) {
            value = min;
          }
          return value;
        };
        var side = Math.round(Math.sqrt(aMatrix.length));
        var halfSide = Math.floor(side / 2);
        var rgba = pIn.data;
        var drgba = pOut.data;
        var w = pIn.width;
        var h = pIn.height;
        for (var y = 0; y < h; y++) {
          for (var x = 0; x < w; x++) {
            var r = 0;
            var g = 0;
            var b = 0;
            for (var cy = 0; cy < side; cy++) {
              for (var cx = 0; cx < side; cx++) {
                var scx = clamp(x + cx - halfSide, 0, w - 1);
                var scy = clamp(y + cy - halfSide, 0, h - 1);
                var innerOffset = (scy * w + scx) * 4;
                var wt = aMatrix[cy * side + cx];
                r += rgba[innerOffset] * wt;
                g += rgba[innerOffset + 1] * wt;
                b += rgba[innerOffset + 2] * wt;
              }
            }
            var offset = (y * w + x) * 4;
            drgba[offset] = clamp(r, 0, 255);
            drgba[offset + 1] = clamp(g, 0, 255);
            drgba[offset + 2] = clamp(b, 0, 255);
          }
        }
        return pOut;
      };
      var pixelsIn = context.getImageData(0, 0, canvas.width, canvas.height);
      var pixelsOut = context.getImageData(0, 0, canvas.width, canvas.height);
      pixelsOut = applyMatrix(pixelsIn, pixelsOut, matrix);
      context.putImageData(pixelsOut, 0, 0);
      return fromCanvas(canvas, type);
    };
    var functionColorFilter = function (colorFn) {
      var filterImpl = function (canvas, type, value) {
        var context = get2dContext(canvas);
        var lookup = new Array(256);
        var applyLookup = function (pixelsData, lookupData) {
          var data = pixelsData.data;
          for (var i = 0; i < data.length; i += 4) {
            data[i] = lookupData[data[i]];
            data[i + 1] = lookupData[data[i + 1]];
            data[i + 2] = lookupData[data[i + 2]];
          }
          return pixelsData;
        };
        for (var i = 0; i < lookup.length; i++) {
          lookup[i] = colorFn(i, value);
        }
        var pixels = applyLookup(context.getImageData(0, 0, canvas.width, canvas.height), lookup);
        context.putImageData(pixels, 0, 0);
        return fromCanvas(canvas, type);
      };
      return function (ir, value) {
        return ir.toCanvas().then(function (canvas) {
          return filterImpl(canvas, ir.getType(), value);
        });
      };
    };
    var complexAdjustableColorFilter = function (matrixAdjustFn) {
      return function (ir, adjust) {
        return colorFilter(ir, matrixAdjustFn(identity(), adjust));
      };
    };
    var basicColorFilter = function (matrix) {
      return function (ir) {
        return colorFilter(ir, matrix);
      };
    };
    var basicConvolutionFilter = function (kernel) {
      return function (ir) {
        return convoluteFilter(ir, kernel);
      };
    };
    var invert$1 = basicColorFilter([
      -1,
      0,
      0,
      0,
      255,
      0,
      -1,
      0,
      0,
      255,
      0,
      0,
      -1,
      0,
      255,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      1
    ]);
    var brightness$1 = complexAdjustableColorFilter(adjustBrightness);
    var contrast$1 = complexAdjustableColorFilter(adjustContrast);
    var colorize$1 = function (ir, adjustR, adjustG, adjustB) {
      return colorFilter(ir, adjustColors(identity(), adjustR, adjustG, adjustB));
    };
    var sharpen$1 = basicConvolutionFilter([
      0,
      -1,
      0,
      -1,
      5,
      -1,
      0,
      -1,
      0
    ]);
    var gamma$1 = functionColorFilter(function (color, value) {
      return Math.pow(color / 255, 1 - value) * 255;
    });

    var scale = function (image, dW, dH) {
      var sW = getWidth$1(image);
      var sH = getHeight$1(image);
      var wRatio = dW / sW;
      var hRatio = dH / sH;
      var scaleCapped = false;
      if (wRatio < 0.5 || wRatio > 2) {
        wRatio = wRatio < 0.5 ? 0.5 : 2;
        scaleCapped = true;
      }
      if (hRatio < 0.5 || hRatio > 2) {
        hRatio = hRatio < 0.5 ? 0.5 : 2;
        scaleCapped = true;
      }
      var scaled = _scale(image, wRatio, hRatio);
      return !scaleCapped ? scaled : scaled.then(function (tCanvas) {
        return scale(tCanvas, dW, dH);
      });
    };
    var _scale = function (image, wRatio, hRatio) {
      return new Promise$1(function (resolve) {
        var sW = getWidth$1(image);
        var sH = getHeight$1(image);
        var dW = Math.floor(sW * wRatio);
        var dH = Math.floor(sH * hRatio);
        var canvas = create$3(dW, dH);
        var context = get2dContext(canvas);
        context.drawImage(image, 0, 0, sW, sH, 0, 0, dW, dH);
        resolve(canvas);
      });
    };

    var ceilWithPrecision = function (num, precision) {
      if (precision === void 0) {
        precision = 2;
      }
      var mul = Math.pow(10, precision);
      var upper = Math.round(num * mul);
      return Math.ceil(upper / mul);
    };
    var rotate$1 = function (ir, angle) {
      return ir.toCanvas().then(function (canvas) {
        return applyRotate(canvas, ir.getType(), angle);
      });
    };
    var applyRotate = function (image, type, angle) {
      var degrees = angle < 0 ? 360 + angle : angle;
      var rad = degrees * Math.PI / 180;
      var width = image.width;
      var height = image.height;
      var sin = Math.sin(rad);
      var cos = Math.cos(rad);
      var newWidth = ceilWithPrecision(Math.abs(width * cos) + Math.abs(height * sin));
      var newHeight = ceilWithPrecision(Math.abs(width * sin) + Math.abs(height * cos));
      var canvas = create$3(newWidth, newHeight);
      var context = get2dContext(canvas);
      context.translate(newWidth / 2, newHeight / 2);
      context.rotate(rad);
      context.drawImage(image, -width / 2, -height / 2);
      return fromCanvas(canvas, type);
    };
    var flip$1 = function (ir, axis) {
      return ir.toCanvas().then(function (canvas) {
        return applyFlip(canvas, ir.getType(), axis);
      });
    };
    var applyFlip = function (image, type, axis) {
      var canvas = create$3(image.width, image.height);
      var context = get2dContext(canvas);
      if (axis === 'v') {
        context.scale(1, -1);
        context.drawImage(image, 0, -canvas.height);
      } else {
        context.scale(-1, 1);
        context.drawImage(image, -canvas.width, 0);
      }
      return fromCanvas(canvas, type);
    };
    var crop$1 = function (ir, x, y, w, h) {
      return ir.toCanvas().then(function (canvas) {
        return applyCrop(canvas, ir.getType(), x, y, w, h);
      });
    };
    var applyCrop = function (image, type, x, y, w, h) {
      var canvas = create$3(w, h);
      var context = get2dContext(canvas);
      context.drawImage(image, -x, -y);
      return fromCanvas(canvas, type);
    };
    var resize$2 = function (ir, w, h) {
      return ir.toCanvas().then(function (canvas) {
        return scale(canvas, w, h).then(function (newCanvas) {
          return fromCanvas(newCanvas, ir.getType());
        });
      });
    };

    var invert = function (ir) {
      return invert$1(ir);
    };
    var sharpen = function (ir) {
      return sharpen$1(ir);
    };
    var gamma = function (ir, value) {
      return gamma$1(ir, value);
    };
    var colorize = function (ir, adjustR, adjustG, adjustB) {
      return colorize$1(ir, adjustR, adjustG, adjustB);
    };
    var brightness = function (ir, adjust) {
      return brightness$1(ir, adjust);
    };
    var contrast = function (ir, adjust) {
      return contrast$1(ir, adjust);
    };
    var flip = function (ir, axis) {
      return flip$1(ir, axis);
    };
    var crop = function (ir, x, y, w, h) {
      return crop$1(ir, x, y, w, h);
    };
    var resize$1 = function (ir, w, h) {
      return resize$2(ir, w, h);
    };
    var rotate = function (ir, angle) {
      return rotate$1(ir, angle);
    };

    var renderIcon = function (iconName, iconsProvider, behaviours) {
      return render$3(iconName, {
        tag: 'span',
        classes: [
          'tox-icon',
          'tox-tbtn__icon-wrap'
        ],
        behaviours: behaviours
      }, iconsProvider);
    };
    var renderIconFromPack = function (iconName, iconsProvider) {
      return renderIcon(iconName, iconsProvider, []);
    };
    var renderReplacableIconFromPack = function (iconName, iconsProvider) {
      return renderIcon(iconName, iconsProvider, [Replacing.config({})]);
    };
    var renderLabel$1 = function (text, prefix, providersBackstage) {
      return {
        dom: {
          tag: 'span',
          innerHtml: providersBackstage.translate(text),
          classes: [prefix + '__select-label']
        },
        behaviours: derive$1([Replacing.config({})])
      };
    };

    var _a;
    var internalToolbarButtonExecute = generate$6('toolbar.button.execute');
    var onToolbarButtonExecute = function (info) {
      return runOnExecute$1(function (comp, _simulatedEvent) {
        runWithApi(info, comp)(function (itemApi) {
          emitWith(comp, internalToolbarButtonExecute, { buttonApi: itemApi });
          info.onAction(itemApi);
        });
      });
    };
    var toolbarButtonEventOrder = (_a = {}, _a[execute$5()] = [
      'disabling',
      'alloy.base.behaviour',
      'toggling',
      'toolbar-button-events'
    ], _a);

    var updateMenuText = generate$6('update-menu-text');
    var updateMenuIcon = generate$6('update-menu-icon');
    var renderCommonDropdown = function (spec, prefix, sharedBackstage) {
      var editorOffCell = Cell(noop);
      var optMemDisplayText = spec.text.map(function (text) {
        return record(renderLabel$1(text, prefix, sharedBackstage.providers));
      });
      var optMemDisplayIcon = spec.icon.map(function (iconName) {
        return record(renderReplacableIconFromPack(iconName, sharedBackstage.providers.icons));
      });
      var onLeftOrRightInMenu = function (comp, se) {
        var dropdown = Representing.getValue(comp);
        Focusing.focus(dropdown);
        emitWith(dropdown, 'keydown', { raw: se.event.raw });
        Dropdown.close(dropdown);
        return Optional.some(true);
      };
      var role = spec.role.fold(function () {
        return {};
      }, function (role) {
        return { role: role };
      });
      var tooltipAttributes = spec.tooltip.fold(function () {
        return {};
      }, function (tooltip) {
        var translatedTooltip = sharedBackstage.providers.translate(tooltip);
        return {
          'title': translatedTooltip,
          'aria-label': translatedTooltip
        };
      });
      var iconSpec = render$3('chevron-down', {
        tag: 'div',
        classes: [prefix + '__select-chevron']
      }, sharedBackstage.providers.icons);
      var memDropdown = record(Dropdown.sketch(__assign(__assign(__assign({}, spec.uid ? { uid: spec.uid } : {}), role), {
        dom: {
          tag: 'button',
          classes: [
            prefix,
            prefix + '--select'
          ].concat(map$2(spec.classes, function (c) {
            return prefix + '--' + c;
          })),
          attributes: __assign({}, tooltipAttributes)
        },
        components: componentRenderPipeline([
          optMemDisplayIcon.map(function (mem) {
            return mem.asSpec();
          }),
          optMemDisplayText.map(function (mem) {
            return mem.asSpec();
          }),
          Optional.some(iconSpec)
        ]),
        matchWidth: true,
        useMinWidth: true,
        dropdownBehaviours: derive$1(__spreadArray(__spreadArray([], spec.dropdownBehaviours, true), [
          DisablingConfigs.button(function () {
            return spec.disabled || sharedBackstage.providers.isDisabled();
          }),
          receivingConfig(),
          Unselecting.config({}),
          Replacing.config({}),
          config('dropdown-events', [
            onControlAttached(spec, editorOffCell),
            onControlDetached(spec, editorOffCell)
          ]),
          config('menubutton-update-display-text', [
            run$1(updateMenuText, function (comp, se) {
              optMemDisplayText.bind(function (mem) {
                return mem.getOpt(comp);
              }).each(function (displayText) {
                Replacing.set(displayText, [text(sharedBackstage.providers.translate(se.event.text))]);
              });
            }),
            run$1(updateMenuIcon, function (comp, se) {
              optMemDisplayIcon.bind(function (mem) {
                return mem.getOpt(comp);
              }).each(function (displayIcon) {
                Replacing.set(displayIcon, [renderReplacableIconFromPack(se.event.icon, sharedBackstage.providers.icons)]);
              });
            })
          ])
        ], false)),
        eventOrder: deepMerge(toolbarButtonEventOrder, {
          mousedown: [
            'focusing',
            'alloy.base.behaviour',
            'item-type-events',
            'normal-dropdown-events'
          ]
        }),
        sandboxBehaviours: derive$1([Keying.config({
            mode: 'special',
            onLeft: onLeftOrRightInMenu,
            onRight: onLeftOrRightInMenu
          })]),
        lazySink: sharedBackstage.getSink,
        toggleClass: prefix + '--active',
        parts: { menu: part(false, spec.columns, spec.presets) },
        fetch: function (comp) {
          return Future.nu(curry(spec.fetch, comp));
        }
      })));
      return memDropdown.asSpec();
    };

    var isMenuItemReference = function (item) {
      return isString(item);
    };
    var isSeparator$1 = function (item) {
      return item.type === 'separator';
    };
    var isExpandingMenuItem = function (item) {
      return has$2(item, 'getSubmenuItems');
    };
    var separator$2 = { type: 'separator' };
    var unwrapReferences = function (items, menuItems) {
      var realItems = foldl(items, function (acc, item) {
        if (isMenuItemReference(item)) {
          if (item === '') {
            return acc;
          } else if (item === '|') {
            return acc.length > 0 && !isSeparator$1(acc[acc.length - 1]) ? acc.concat([separator$2]) : acc;
          } else if (has$2(menuItems, item.toLowerCase())) {
            return acc.concat([menuItems[item.toLowerCase()]]);
          } else {
            return acc;
          }
        } else {
          return acc.concat([item]);
        }
      }, []);
      if (realItems.length > 0 && isSeparator$1(realItems[realItems.length - 1])) {
        realItems.pop();
      }
      return realItems;
    };
    var getFromExpandingItem = function (item, menuItems) {
      var submenuItems = item.getSubmenuItems();
      var rest = expand(submenuItems, menuItems);
      var newMenus = deepMerge(rest.menus, wrap$1(item.value, rest.items));
      var newExpansions = deepMerge(rest.expansions, wrap$1(item.value, item.value));
      return {
        item: item,
        menus: newMenus,
        expansions: newExpansions
      };
    };
    var getFromItem = function (item, menuItems) {
      return isExpandingMenuItem(item) ? getFromExpandingItem(item, menuItems) : {
        item: item,
        menus: {},
        expansions: {}
      };
    };
    var generateValueIfRequired = function (item) {
      if (isSeparator$1(item)) {
        return item;
      } else {
        var itemValue = get$e(item, 'value').getOrThunk(function () {
          return generate$6('generated-menu-item');
        });
        return deepMerge({ value: itemValue }, item);
      }
    };
    var expand = function (items, menuItems) {
      var realItems = unwrapReferences(isString(items) ? items.split(' ') : items, menuItems);
      return foldr(realItems, function (acc, item) {
        var itemWithValue = generateValueIfRequired(item);
        var newData = getFromItem(itemWithValue, menuItems);
        return {
          menus: deepMerge(acc.menus, newData.menus),
          items: [newData.item].concat(acc.items),
          expansions: deepMerge(acc.expansions, newData.expansions)
        };
      }, {
        menus: {},
        expansions: {},
        items: []
      });
    };

    var build = function (items, itemResponse, backstage, isHorizontalMenu) {
      var primary = generate$6('primary-menu');
      var data = expand(items, backstage.shared.providers.menuItems());
      if (data.items.length === 0) {
        return Optional.none();
      }
      var mainMenu = createPartialMenu(primary, data.items, itemResponse, backstage, isHorizontalMenu);
      var submenus = map$1(data.menus, function (menuItems, menuName) {
        return createPartialMenu(menuName, menuItems, itemResponse, backstage, false);
      });
      var menus = deepMerge(submenus, wrap$1(primary, mainMenu));
      return Optional.from(tieredMenu.tieredData(primary, menus, data.expansions));
    };

    var getMenuButtonApi = function (component) {
      return {
        isDisabled: function () {
          return Disabling.isDisabled(component);
        },
        setDisabled: function (state) {
          return Disabling.set(component, state);
        },
        setActive: function (state) {
          var elm = component.element;
          if (state) {
            add$2(elm, 'tox-tbtn--enabled');
            set$8(elm, 'aria-pressed', true);
          } else {
            remove$2(elm, 'tox-tbtn--enabled');
            remove$7(elm, 'aria-pressed');
          }
        },
        isActive: function () {
          return has(component.element, 'tox-tbtn--enabled');
        }
      };
    };
    var renderMenuButton = function (spec, prefix, backstage, role) {
      return renderCommonDropdown({
        text: spec.text,
        icon: spec.icon,
        tooltip: spec.tooltip,
        role: role,
        fetch: function (_comp, callback) {
          spec.fetch(function (items) {
            callback(build(items, ItemResponse$1.CLOSE_ON_EXECUTE, backstage, false));
          });
        },
        onSetup: spec.onSetup,
        getApi: getMenuButtonApi,
        columns: 1,
        presets: 'normal',
        classes: [],
        dropdownBehaviours: [Tabstopping.config({})]
      }, prefix, backstage.shared);
    };
    var getFetch = function (items, getButton, backstage) {
      var getMenuItemAction = function (item) {
        return function (api) {
          var newValue = !api.isActive();
          api.setActive(newValue);
          item.storage.set(newValue);
          backstage.shared.getSink().each(function (sink) {
            getButton().getOpt(sink).each(function (orig) {
              focus$3(orig.element);
              emitWith(orig, formActionEvent, {
                name: item.name,
                value: item.storage.get()
              });
            });
          });
        };
      };
      var getMenuItemSetup = function (item) {
        return function (api) {
          api.setActive(item.storage.get());
        };
      };
      return function (success) {
        success(map$2(items, function (item) {
          var text = item.text.fold(function () {
            return {};
          }, function (text) {
            return { text: text };
          });
          return __assign(__assign({
            type: item.type,
            active: false
          }, text), {
            onAction: getMenuItemAction(item),
            onSetup: getMenuItemSetup(item)
          });
        }));
      };
    };

    var renderCommonSpec = function (spec, actionOpt, extraBehaviours, dom, components, providersBackstage) {
      if (extraBehaviours === void 0) {
        extraBehaviours = [];
      }
      var action = actionOpt.fold(function () {
        return {};
      }, function (action) {
        return { action: action };
      });
      var common = __assign({
        buttonBehaviours: derive$1([
          DisablingConfigs.button(function () {
            return spec.disabled || providersBackstage.isDisabled();
          }),
          receivingConfig(),
          Tabstopping.config({}),
          config('button press', [
            preventDefault('click'),
            preventDefault('mousedown')
          ])
        ].concat(extraBehaviours)),
        eventOrder: {
          click: [
            'button press',
            'alloy.base.behaviour'
          ],
          mousedown: [
            'button press',
            'alloy.base.behaviour'
          ]
        }
      }, action);
      var domFinal = deepMerge(common, { dom: dom });
      return deepMerge(domFinal, { components: components });
    };
    var renderIconButtonSpec = function (spec, action, providersBackstage, extraBehaviours) {
      if (extraBehaviours === void 0) {
        extraBehaviours = [];
      }
      var tooltipAttributes = spec.tooltip.map(function (tooltip) {
        return {
          'aria-label': providersBackstage.translate(tooltip),
          'title': providersBackstage.translate(tooltip)
        };
      }).getOr({});
      var dom = {
        tag: 'button',
        classes: ['tox-tbtn'],
        attributes: tooltipAttributes
      };
      var icon = spec.icon.map(function (iconName) {
        return renderIconFromPack(iconName, providersBackstage.icons);
      });
      var components = componentRenderPipeline([icon]);
      return renderCommonSpec(spec, action, extraBehaviours, dom, components, providersBackstage);
    };
    var renderIconButton = function (spec, action, providersBackstage, extraBehaviours) {
      if (extraBehaviours === void 0) {
        extraBehaviours = [];
      }
      var iconButtonSpec = renderIconButtonSpec(spec, Optional.some(action), providersBackstage, extraBehaviours);
      return Button.sketch(iconButtonSpec);
    };
    var renderButtonSpec = function (spec, action, providersBackstage, extraBehaviours, extraClasses) {
      if (extraBehaviours === void 0) {
        extraBehaviours = [];
      }
      if (extraClasses === void 0) {
        extraClasses = [];
      }
      var translatedText = providersBackstage.translate(spec.text);
      var icon = spec.icon ? spec.icon.map(function (iconName) {
        return renderIconFromPack(iconName, providersBackstage.icons);
      }) : Optional.none();
      var components = icon.isSome() ? componentRenderPipeline([icon]) : [];
      var innerHtml = icon.isSome() ? {} : { innerHtml: translatedText };
      var classes = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], !spec.primary && !spec.borderless ? [
        'tox-button',
        'tox-button--secondary'
      ] : ['tox-button'], true), icon.isSome() ? ['tox-button--icon'] : [], true), spec.borderless ? ['tox-button--naked'] : [], true), extraClasses, true);
      var dom = __assign(__assign({
        tag: 'button',
        classes: classes
      }, innerHtml), { attributes: { title: translatedText } });
      return renderCommonSpec(spec, action, extraBehaviours, dom, components, providersBackstage);
    };
    var renderButton = function (spec, action, providersBackstage, extraBehaviours, extraClasses) {
      if (extraBehaviours === void 0) {
        extraBehaviours = [];
      }
      if (extraClasses === void 0) {
        extraClasses = [];
      }
      var buttonSpec = renderButtonSpec(spec, Optional.some(action), providersBackstage, extraBehaviours, extraClasses);
      return Button.sketch(buttonSpec);
    };
    var getAction = function (name, buttonType) {
      return function (comp) {
        if (buttonType === 'custom') {
          emitWith(comp, formActionEvent, {
            name: name,
            value: {}
          });
        } else if (buttonType === 'submit') {
          emit(comp, formSubmitEvent);
        } else if (buttonType === 'cancel') {
          emit(comp, formCancelEvent);
        } else {
          console.error('Unknown button type: ', buttonType);
        }
      };
    };
    var isMenuFooterButtonSpec = function (spec, buttonType) {
      return buttonType === 'menu';
    };
    var isNormalFooterButtonSpec = function (spec, buttonType) {
      return buttonType === 'custom' || buttonType === 'cancel' || buttonType === 'submit';
    };
    var renderFooterButton = function (spec, buttonType, backstage) {
      if (isMenuFooterButtonSpec(spec, buttonType)) {
        var getButton = function () {
          return memButton_1;
        };
        var menuButtonSpec = spec;
        var fixedSpec = __assign(__assign({}, spec), {
          onSetup: function (api) {
            api.setDisabled(spec.disabled);
            return noop;
          },
          fetch: getFetch(menuButtonSpec.items, getButton, backstage)
        });
        var memButton_1 = record(renderMenuButton(fixedSpec, 'tox-tbtn', backstage, Optional.none()));
        return memButton_1.asSpec();
      } else if (isNormalFooterButtonSpec(spec, buttonType)) {
        var action = getAction(spec.name, buttonType);
        var buttonSpec = __assign(__assign({}, spec), { borderless: false });
        return renderButton(buttonSpec, action, backstage.shared.providers, []);
      } else {
        console.error('Unknown footer button type: ', buttonType);
      }
    };
    var renderDialogButton = function (spec, providersBackstage) {
      var action = getAction(spec.name, 'custom');
      return renderFormField(Optional.none(), FormField.parts.field(__assign({ factory: Button }, renderButtonSpec(spec, Optional.some(action), providersBackstage, [
        RepresentingConfigs.memory(''),
        ComposingConfigs.self()
      ]))));
    };

    var schema$h = constant$1([
      defaulted('field1Name', 'field1'),
      defaulted('field2Name', 'field2'),
      onStrictHandler('onLockedChange'),
      markers$1(['lockClass']),
      defaulted('locked', false),
      SketchBehaviours.field('coupledFieldBehaviours', [
        Composing,
        Representing
      ])
    ]);
    var getField = function (comp, detail, partName) {
      return getPart(comp, detail, partName).bind(Composing.getCurrent);
    };
    var coupledPart = function (selfName, otherName) {
      return required({
        factory: FormField,
        name: selfName,
        overrides: function (detail) {
          return {
            fieldBehaviours: derive$1([config('coupled-input-behaviour', [run$1(input(), function (me) {
                  getField(me, detail, otherName).each(function (other) {
                    getPart(me, detail, 'lock').each(function (lock) {
                      if (Toggling.isOn(lock)) {
                        detail.onLockedChange(me, other, lock);
                      }
                    });
                  });
                })])])
          };
        }
      });
    };
    var parts$c = constant$1([
      coupledPart('field1', 'field2'),
      coupledPart('field2', 'field1'),
      required({
        factory: Button,
        schema: [required$1('dom')],
        name: 'lock',
        overrides: function (detail) {
          return {
            buttonBehaviours: derive$1([Toggling.config({
                selected: detail.locked,
                toggleClass: detail.markers.lockClass,
                aria: { mode: 'pressed' }
              })])
          };
        }
      })
    ]);

    var factory$f = function (detail, components, _spec, _externals) {
      return {
        uid: detail.uid,
        dom: detail.dom,
        components: components,
        behaviours: SketchBehaviours.augment(detail.coupledFieldBehaviours, [
          Composing.config({ find: Optional.some }),
          Representing.config({
            store: {
              mode: 'manual',
              getValue: function (comp) {
                var _a;
                var parts = getPartsOrDie(comp, detail, [
                  'field1',
                  'field2'
                ]);
                return _a = {}, _a[detail.field1Name] = Representing.getValue(parts.field1()), _a[detail.field2Name] = Representing.getValue(parts.field2()), _a;
              },
              setValue: function (comp, value) {
                var parts = getPartsOrDie(comp, detail, [
                  'field1',
                  'field2'
                ]);
                if (hasNonNullableKey(value, detail.field1Name)) {
                  Representing.setValue(parts.field1(), value[detail.field1Name]);
                }
                if (hasNonNullableKey(value, detail.field2Name)) {
                  Representing.setValue(parts.field2(), value[detail.field2Name]);
                }
              }
            }
          })
        ]),
        apis: {
          getField1: function (component) {
            return getPart(component, detail, 'field1');
          },
          getField2: function (component) {
            return getPart(component, detail, 'field2');
          },
          getLock: function (component) {
            return getPart(component, detail, 'lock');
          }
        }
      };
    };
    var FormCoupledInputs = composite({
      name: 'FormCoupledInputs',
      configFields: schema$h(),
      partFields: parts$c(),
      factory: factory$f,
      apis: {
        getField1: function (apis, component) {
          return apis.getField1(component);
        },
        getField2: function (apis, component) {
          return apis.getField2(component);
        },
        getLock: function (apis, component) {
          return apis.getLock(component);
        }
      }
    });

    var formatSize = function (size) {
      var unitDec = {
        '': 0,
        'px': 0,
        'pt': 1,
        'mm': 1,
        'pc': 2,
        'ex': 2,
        'em': 2,
        'ch': 2,
        'rem': 2,
        'cm': 3,
        'in': 4,
        '%': 4
      };
      var maxDecimal = function (unit) {
        return unit in unitDec ? unitDec[unit] : 1;
      };
      var numText = size.value.toFixed(maxDecimal(size.unit));
      if (numText.indexOf('.') !== -1) {
        numText = numText.replace(/\.?0*$/, '');
      }
      return numText + size.unit;
    };
    var parseSize = function (sizeText) {
      var numPattern = /^\s*(\d+(?:\.\d+)?)\s*(|cm|mm|in|px|pt|pc|em|ex|ch|rem|vw|vh|vmin|vmax|%)\s*$/;
      var match = numPattern.exec(sizeText);
      if (match !== null) {
        var value = parseFloat(match[1]);
        var unit = match[2];
        return Result.value({
          value: value,
          unit: unit
        });
      } else {
        return Result.error(sizeText);
      }
    };
    var convertUnit = function (size, unit) {
      var inInch = {
        '': 96,
        'px': 96,
        'pt': 72,
        'cm': 2.54,
        'pc': 12,
        'mm': 25.4,
        'in': 1
      };
      var supported = function (u) {
        return has$2(inInch, u);
      };
      if (size.unit === unit) {
        return Optional.some(size.value);
      } else if (supported(size.unit) && supported(unit)) {
        if (inInch[size.unit] === inInch[unit]) {
          return Optional.some(size.value);
        } else {
          return Optional.some(size.value / inInch[size.unit] * inInch[unit]);
        }
      } else {
        return Optional.none();
      }
    };
    var noSizeConversion = function (_input) {
      return Optional.none();
    };
    var ratioSizeConversion = function (scale, unit) {
      return function (size) {
        return convertUnit(size, unit).map(function (value) {
          return {
            value: value * scale,
            unit: unit
          };
        });
      };
    };
    var makeRatioConverter = function (currentFieldText, otherFieldText) {
      var cValue = parseSize(currentFieldText).toOptional();
      var oValue = parseSize(otherFieldText).toOptional();
      return lift2(cValue, oValue, function (cSize, oSize) {
        return convertUnit(cSize, oSize.unit).map(function (val) {
          return oSize.value / val;
        }).map(function (r) {
          return ratioSizeConversion(r, oSize.unit);
        }).getOr(noSizeConversion);
      }).getOr(noSizeConversion);
    };

    var renderSizeInput = function (spec, providersBackstage) {
      var converter = noSizeConversion;
      var ratioEvent = generate$6('ratio-event');
      var makeIcon = function (iconName) {
        return render$3(iconName, {
          tag: 'span',
          classes: [
            'tox-icon',
            'tox-lock-icon__' + iconName
          ]
        }, providersBackstage.icons);
      };
      var pLock = FormCoupledInputs.parts.lock({
        dom: {
          tag: 'button',
          classes: [
            'tox-lock',
            'tox-button',
            'tox-button--naked',
            'tox-button--icon'
          ],
          attributes: { title: providersBackstage.translate(spec.label.getOr('Constrain proportions')) }
        },
        components: [
          makeIcon('lock'),
          makeIcon('unlock')
        ],
        buttonBehaviours: derive$1([
          Disabling.config({
            disabled: function () {
              return spec.disabled || providersBackstage.isDisabled();
            }
          }),
          receivingConfig(),
          Tabstopping.config({})
        ])
      });
      var formGroup = function (components) {
        return {
          dom: {
            tag: 'div',
            classes: ['tox-form__group']
          },
          components: components
        };
      };
      var getFieldPart = function (isField1) {
        return FormField.parts.field({
          factory: Input,
          inputClasses: ['tox-textfield'],
          inputBehaviours: derive$1([
            Disabling.config({
              disabled: function () {
                return spec.disabled || providersBackstage.isDisabled();
              }
            }),
            receivingConfig(),
            Tabstopping.config({}),
            config('size-input-events', [
              run$1(focusin(), function (component, _simulatedEvent) {
                emitWith(component, ratioEvent, { isField1: isField1 });
              }),
              run$1(change(), function (component, _simulatedEvent) {
                emitWith(component, formChangeEvent, { name: spec.name });
              })
            ])
          ]),
          selectOnFocus: false
        });
      };
      var getLabel = function (label) {
        return {
          dom: {
            tag: 'label',
            classes: ['tox-label'],
            innerHtml: providersBackstage.translate(label)
          }
        };
      };
      var widthField = FormCoupledInputs.parts.field1(formGroup([
        FormField.parts.label(getLabel('Width')),
        getFieldPart(true)
      ]));
      var heightField = FormCoupledInputs.parts.field2(formGroup([
        FormField.parts.label(getLabel('Height')),
        getFieldPart(false)
      ]));
      return FormCoupledInputs.sketch({
        dom: {
          tag: 'div',
          classes: ['tox-form__group']
        },
        components: [{
            dom: {
              tag: 'div',
              classes: ['tox-form__controls-h-stack']
            },
            components: [
              widthField,
              heightField,
              formGroup([
                getLabel('&nbsp;'),
                pLock
              ])
            ]
          }],
        field1Name: 'width',
        field2Name: 'height',
        locked: true,
        markers: { lockClass: 'tox-locked' },
        onLockedChange: function (current, other, _lock) {
          parseSize(Representing.getValue(current)).each(function (size) {
            converter(size).each(function (newSize) {
              Representing.setValue(other, formatSize(newSize));
            });
          });
        },
        coupledFieldBehaviours: derive$1([
          Disabling.config({
            disabled: function () {
              return spec.disabled || providersBackstage.isDisabled();
            },
            onDisabled: function (comp) {
              FormCoupledInputs.getField1(comp).bind(FormField.getField).each(Disabling.disable);
              FormCoupledInputs.getField2(comp).bind(FormField.getField).each(Disabling.disable);
              FormCoupledInputs.getLock(comp).each(Disabling.disable);
            },
            onEnabled: function (comp) {
              FormCoupledInputs.getField1(comp).bind(FormField.getField).each(Disabling.enable);
              FormCoupledInputs.getField2(comp).bind(FormField.getField).each(Disabling.enable);
              FormCoupledInputs.getLock(comp).each(Disabling.enable);
            }
          }),
          receivingConfig(),
          config('size-input-events2', [run$1(ratioEvent, function (component, simulatedEvent) {
              var isField1 = simulatedEvent.event.isField1;
              var optCurrent = isField1 ? FormCoupledInputs.getField1(component) : FormCoupledInputs.getField2(component);
              var optOther = isField1 ? FormCoupledInputs.getField2(component) : FormCoupledInputs.getField1(component);
              var value1 = optCurrent.map(Representing.getValue).getOr('');
              var value2 = optOther.map(Representing.getValue).getOr('');
              converter = makeRatioConverter(value1, value2);
            })])
        ])
      });
    };

    var undo = constant$1(generate$6('undo'));
    var redo = constant$1(generate$6('redo'));
    var zoom = constant$1(generate$6('zoom'));
    var back = constant$1(generate$6('back'));
    var apply = constant$1(generate$6('apply'));
    var swap = constant$1(generate$6('swap'));
    var transform$1 = constant$1(generate$6('transform'));
    var tempTransform = constant$1(generate$6('temp-transform'));
    var transformApply = constant$1(generate$6('transform-apply'));
    var internal = {
      undo: undo,
      redo: redo,
      zoom: zoom,
      back: back,
      apply: apply,
      swap: swap,
      transform: transform$1,
      tempTransform: tempTransform,
      transformApply: transformApply
    };
    var saveState = constant$1('save-state');
    var disable = constant$1('disable');
    var enable = constant$1('enable');
    var external = {
      formActionEvent: formActionEvent,
      saveState: saveState,
      disable: disable,
      enable: enable
    };

    var renderEditPanel = function (imagePanel, providersBackstage) {
      var createButton = function (text, action, disabled, primary) {
        return record(renderButton({
          name: text,
          text: text,
          disabled: disabled,
          primary: primary,
          icon: Optional.none(),
          borderless: false
        }, action, providersBackstage));
      };
      var createIconButton = function (icon, tooltip, action, disabled) {
        return record(renderIconButton({
          name: icon,
          icon: Optional.some(icon),
          tooltip: Optional.some(tooltip),
          disabled: disabled,
          primary: false,
          borderless: false
        }, action, providersBackstage));
      };
      var disableAllComponents = function (comps, eventcomp) {
        comps.map(function (mem) {
          var component = mem.get(eventcomp);
          if (component.hasConfigured(Disabling)) {
            Disabling.disable(component);
          }
        });
      };
      var enableAllComponents = function (comps, eventcomp) {
        comps.map(function (mem) {
          var component = mem.get(eventcomp);
          if (component.hasConfigured(Disabling)) {
            Disabling.enable(component);
          }
        });
      };
      var panelDom = {
        tag: 'div',
        classes: [
          'tox-image-tools__toolbar',
          'tox-image-tools-edit-panel'
        ]
      };
      var noop$1 = noop;
      var emit$1 = function (comp, event, data) {
        emitWith(comp, event, data);
      };
      var emitDisable = function (component) {
        return emit(component, external.disable());
      };
      var emitEnable = function (component) {
        return emit(component, external.enable());
      };
      var emitTransform = function (comp, transform) {
        emitDisable(comp);
        emit$1(comp, internal.transform(), { transform: transform });
        emitEnable(comp);
      };
      var emitTempTransform = function (comp, transform) {
        emitDisable(comp);
        emit$1(comp, internal.tempTransform(), { transform: transform });
        emitEnable(comp);
      };
      var getBackSwap = function (anyInSystem) {
        return function () {
          memContainer.getOpt(anyInSystem).each(function (container) {
            Replacing.set(container, [ButtonPanel]);
          });
        };
      };
      var emitTransformApply = function (comp, transform) {
        emitDisable(comp);
        emit$1(comp, internal.transformApply(), {
          transform: transform,
          swap: getBackSwap(comp)
        });
        emitEnable(comp);
      };
      var createBackButton = function () {
        return createButton('Back', function (button) {
          return emit$1(button, internal.back(), { swap: getBackSwap(button) });
        }, false, false);
      };
      var createSpacer = function () {
        return record({
          dom: {
            tag: 'div',
            classes: ['tox-spacer']
          },
          behaviours: derive$1([Disabling.config({})])
        });
      };
      var createApplyButton = function () {
        return createButton('Apply', function (button) {
          return emit$1(button, internal.apply(), { swap: getBackSwap(button) });
        }, true, true);
      };
      var makeCropTransform = function () {
        return function (ir) {
          var rect = imagePanel.getRect();
          return crop(ir, rect.x, rect.y, rect.w, rect.h);
        };
      };
      var cropPanelComponents = [
        createBackButton(),
        createSpacer(),
        createButton('Apply', function (button) {
          var transform = makeCropTransform();
          emitTransformApply(button, transform);
          imagePanel.hideCrop();
        }, false, true)
      ];
      var CropPanel = Container.sketch({
        dom: panelDom,
        components: cropPanelComponents.map(function (mem) {
          return mem.asSpec();
        }),
        containerBehaviours: derive$1([config('image-tools-crop-buttons-events', [
            run$1(external.disable(), function (comp, _se) {
              disableAllComponents(cropPanelComponents, comp);
            }),
            run$1(external.enable(), function (comp, _se) {
              enableAllComponents(cropPanelComponents, comp);
            })
          ])])
      });
      var memSize = record(renderSizeInput({
        name: 'size',
        label: Optional.none(),
        constrain: true,
        disabled: false
      }, providersBackstage));
      var makeResizeTransform = function (width, height) {
        return function (ir) {
          return resize$1(ir, width, height);
        };
      };
      var resizePanelComponents = [
        createBackButton(),
        createSpacer(),
        memSize,
        createSpacer(),
        createButton('Apply', function (button) {
          memSize.getOpt(button).each(function (sizeInput) {
            var value = Representing.getValue(sizeInput);
            var width = parseInt(value.width, 10);
            var height = parseInt(value.height, 10);
            var transform = makeResizeTransform(width, height);
            emitTransformApply(button, transform);
          });
        }, false, true)
      ];
      var ResizePanel = Container.sketch({
        dom: panelDom,
        components: resizePanelComponents.map(function (mem) {
          return mem.asSpec();
        }),
        containerBehaviours: derive$1([config('image-tools-resize-buttons-events', [
            run$1(external.disable(), function (comp, _se) {
              disableAllComponents(resizePanelComponents, comp);
            }),
            run$1(external.enable(), function (comp, _se) {
              enableAllComponents(resizePanelComponents, comp);
            })
          ])])
      });
      var makeValueTransform = function (transform, value) {
        return function (ir) {
          return transform(ir, value);
        };
      };
      var horizontalFlip = makeValueTransform(flip, 'h');
      var verticalFlip = makeValueTransform(flip, 'v');
      var counterclockwiseRotate = makeValueTransform(rotate, -90);
      var clockwiseRotate = makeValueTransform(rotate, 90);
      var flipRotateOnAction = function (comp, operation) {
        emitTempTransform(comp, operation);
      };
      var flipRotateComponents = [
        createBackButton(),
        createSpacer(),
        createIconButton('flip-horizontally', 'Flip horizontally', function (button) {
          flipRotateOnAction(button, horizontalFlip);
        }, false),
        createIconButton('flip-vertically', 'Flip vertically', function (button) {
          flipRotateOnAction(button, verticalFlip);
        }, false),
        createIconButton('rotate-left', 'Rotate counterclockwise', function (button) {
          flipRotateOnAction(button, counterclockwiseRotate);
        }, false),
        createIconButton('rotate-right', 'Rotate clockwise', function (button) {
          flipRotateOnAction(button, clockwiseRotate);
        }, false),
        createSpacer(),
        createApplyButton()
      ];
      var FlipRotatePanel = Container.sketch({
        dom: panelDom,
        components: flipRotateComponents.map(function (mem) {
          return mem.asSpec();
        }),
        containerBehaviours: derive$1([config('image-tools-fliprotate-buttons-events', [
            run$1(external.disable(), function (comp, _se) {
              disableAllComponents(flipRotateComponents, comp);
            }),
            run$1(external.enable(), function (comp, _se) {
              enableAllComponents(flipRotateComponents, comp);
            })
          ])])
      });
      var makeSlider = function (label, onChoose, min, value, max) {
        var labelPart = Slider.parts.label({
          dom: {
            tag: 'label',
            classes: ['tox-label'],
            innerHtml: providersBackstage.translate(label)
          }
        });
        var spectrum = Slider.parts.spectrum({
          dom: {
            tag: 'div',
            classes: ['tox-slider__rail'],
            attributes: { role: 'presentation' }
          }
        });
        var thumb = Slider.parts.thumb({
          dom: {
            tag: 'div',
            classes: ['tox-slider__handle'],
            attributes: { role: 'presentation' }
          }
        });
        return record(Slider.sketch({
          dom: {
            tag: 'div',
            classes: ['tox-slider'],
            attributes: { role: 'presentation' }
          },
          model: {
            mode: 'x',
            minX: min,
            maxX: max,
            getInitialValue: constant$1({ x: value })
          },
          components: [
            labelPart,
            spectrum,
            thumb
          ],
          sliderBehaviours: derive$1([Focusing.config({})]),
          onChoose: onChoose
        }));
      };
      var makeVariableSlider = function (label, transform, min, value, max) {
        var onChoose = function (slider, _thumb, value) {
          var valTransform = makeValueTransform(transform, value.x / 100);
          emitTransform(slider, valTransform);
        };
        return makeSlider(label, onChoose, min, value, max);
      };
      var variableFilterPanelComponents = function (label, transform, min, value, max) {
        return [
          createBackButton(),
          makeVariableSlider(label, transform, min, value, max),
          createApplyButton()
        ];
      };
      var createVariableFilterPanel = function (label, transform, min, value, max) {
        var filterPanelComponents = variableFilterPanelComponents(label, transform, min, value, max);
        return Container.sketch({
          dom: panelDom,
          components: filterPanelComponents.map(function (mem) {
            return mem.asSpec();
          }),
          containerBehaviours: derive$1([config('image-tools-filter-panel-buttons-events', [
              run$1(external.disable(), function (comp, _se) {
                disableAllComponents(filterPanelComponents, comp);
              }),
              run$1(external.enable(), function (comp, _se) {
                enableAllComponents(filterPanelComponents, comp);
              })
            ])])
        });
      };
      var filterPanelComponents = [
        createBackButton(),
        createSpacer(),
        createApplyButton()
      ];
      var FilterPanel = Container.sketch({
        dom: panelDom,
        components: filterPanelComponents.map(function (mem) {
          return mem.asSpec();
        })
      });
      var BrightnessPanel = createVariableFilterPanel('Brightness', brightness, -100, 0, 100);
      var ContrastPanel = createVariableFilterPanel('Contrast', contrast, -100, 0, 100);
      var GammaPanel = createVariableFilterPanel('Gamma', gamma, -100, 0, 100);
      var makeColorTransform = function (red, green, blue) {
        return function (ir) {
          return colorize(ir, red, green, blue);
        };
      };
      var makeColorSlider = function (label) {
        var onChoose = function (slider, _thumb, _value) {
          var redOpt = memRed.getOpt(slider);
          var blueOpt = memBlue.getOpt(slider);
          var greenOpt = memGreen.getOpt(slider);
          redOpt.each(function (red) {
            blueOpt.each(function (blue) {
              greenOpt.each(function (green) {
                var r = Representing.getValue(red).x / 100;
                var g = Representing.getValue(green).x / 100;
                var b = Representing.getValue(blue).x / 100;
                var transform = makeColorTransform(r, g, b);
                emitTransform(slider, transform);
              });
            });
          });
        };
        return makeSlider(label, onChoose, 0, 100, 200);
      };
      var memRed = makeColorSlider('R');
      var memGreen = makeColorSlider('G');
      var memBlue = makeColorSlider('B');
      var colorizePanelComponents = [
        createBackButton(),
        memRed,
        memGreen,
        memBlue,
        createApplyButton()
      ];
      var ColorizePanel = Container.sketch({
        dom: panelDom,
        components: colorizePanelComponents.map(function (mem) {
          return mem.asSpec();
        })
      });
      var getTransformPanelEvent = function (panel, transform, update) {
        return function (button) {
          var swap = function () {
            memContainer.getOpt(button).each(function (container) {
              Replacing.set(container, [panel]);
              update(container);
            });
          };
          emit$1(button, internal.swap(), {
            transform: transform,
            swap: swap
          });
        };
      };
      var cropPanelUpdate = function (_anyInSystem) {
        imagePanel.showCrop();
      };
      var resizePanelUpdate = function (anyInSystem) {
        memSize.getOpt(anyInSystem).each(function (sizeInput) {
          var measurements = imagePanel.getMeasurements();
          var width = measurements.width;
          var height = measurements.height;
          Representing.setValue(sizeInput, {
            width: width,
            height: height
          });
        });
      };
      var sharpenTransform = Optional.some(sharpen);
      var invertTransform = Optional.some(invert);
      var buttonPanelComponents = [
        createIconButton('crop', 'Crop', getTransformPanelEvent(CropPanel, Optional.none(), cropPanelUpdate), false),
        createIconButton('resize', 'Resize', getTransformPanelEvent(ResizePanel, Optional.none(), resizePanelUpdate), false),
        createIconButton('orientation', 'Orientation', getTransformPanelEvent(FlipRotatePanel, Optional.none(), noop$1), false),
        createIconButton('brightness', 'Brightness', getTransformPanelEvent(BrightnessPanel, Optional.none(), noop$1), false),
        createIconButton('sharpen', 'Sharpen', getTransformPanelEvent(FilterPanel, sharpenTransform, noop$1), false),
        createIconButton('contrast', 'Contrast', getTransformPanelEvent(ContrastPanel, Optional.none(), noop$1), false),
        createIconButton('color-levels', 'Color levels', getTransformPanelEvent(ColorizePanel, Optional.none(), noop$1), false),
        createIconButton('gamma', 'Gamma', getTransformPanelEvent(GammaPanel, Optional.none(), noop$1), false),
        createIconButton('invert', 'Invert', getTransformPanelEvent(FilterPanel, invertTransform, noop$1), false)
      ];
      var ButtonPanel = Container.sketch({
        dom: panelDom,
        components: buttonPanelComponents.map(function (mem) {
          return mem.asSpec();
        })
      });
      var container = Container.sketch({
        dom: { tag: 'div' },
        components: [ButtonPanel],
        containerBehaviours: derive$1([Replacing.config({})])
      });
      var memContainer = record(container);
      var getApplyButton = function (anyInSystem) {
        return memContainer.getOpt(anyInSystem).map(function (container) {
          var panel = container.components()[0];
          return panel.components()[panel.components().length - 1];
        });
      };
      return {
        memContainer: memContainer,
        getApplyButton: getApplyButton
      };
    };

    var global$4 = tinymce.util.Tools.resolve('tinymce.geom.Rect');

    var global$3 = tinymce.util.Tools.resolve('tinymce.util.Observable');

    var global$2 = tinymce.util.Tools.resolve('tinymce.util.VK');

    var getDocumentSize = function (doc) {
      var max = Math.max;
      var documentElement = doc.documentElement;
      var body = doc.body;
      var scrollWidth = max(documentElement.scrollWidth, body.scrollWidth);
      var clientWidth = max(documentElement.clientWidth, body.clientWidth);
      var offsetWidth = max(documentElement.offsetWidth, body.offsetWidth);
      var scrollHeight = max(documentElement.scrollHeight, body.scrollHeight);
      var clientHeight = max(documentElement.clientHeight, body.clientHeight);
      var offsetHeight = max(documentElement.offsetHeight, body.offsetHeight);
      return {
        width: scrollWidth < offsetWidth ? clientWidth : scrollWidth,
        height: scrollHeight < offsetHeight ? clientHeight : scrollHeight
      };
    };
    var isTouchEvent$1 = function (e) {
      return isNonNullable(e.changedTouches);
    };
    var updateWithTouchData = function (e) {
      if (isTouchEvent$1(e)) {
        var keys = 'screenX screenY pageX pageY clientX clientY'.split(' ');
        for (var i = 0; i < keys.length; i++) {
          e[keys[i]] = e.changedTouches[0][keys[i]];
        }
      }
    };
    function DragHelper (id, settings) {
      var _a, _b, _c;
      var eventOverlay;
      var handleEvents = [];
      var overlayEvents = [];
      var doc = (_a = settings.document) !== null && _a !== void 0 ? _a : document;
      var root = (_b = settings.root) !== null && _b !== void 0 ? _b : doc;
      var sugarDoc = SugarElement.fromDom(doc);
      var downButton;
      var startX;
      var startY;
      var handleElement = SugarElement.fromDom(root.getElementById((_c = settings.handle) !== null && _c !== void 0 ? _c : id));
      var start = function (e) {
        var rawEvent = e.raw;
        var docSize = getDocumentSize(doc);
        updateWithTouchData(rawEvent);
        e.prevent();
        downButton = rawEvent.button;
        startX = rawEvent.screenX;
        startY = rawEvent.screenY;
        var cursor = get$c(handleElement, 'cursor');
        eventOverlay = SugarElement.fromTag('div', doc);
        setAll(eventOverlay, {
          'position': 'absolute',
          'top': '0',
          'left': '0',
          'width': docSize.width + 'px',
          'height': docSize.height + 'px',
          'z-index': 2147483647 + '',
          'opacity': '0.0001',
          cursor: cursor
        });
        append$2(getBody(sugarDoc), eventOverlay);
        overlayEvents.push(bind(sugarDoc, 'mousemove', drag), bind(sugarDoc, 'touchmove', drag), bind(sugarDoc, 'mouseup', stop), bind(sugarDoc, 'touchend', stop));
        settings.start(rawEvent);
      };
      var drag = function (e) {
        var rawEvent = e.raw;
        updateWithTouchData(rawEvent);
        if (rawEvent.button !== downButton) {
          return stop(e);
        }
        rawEvent.deltaX = rawEvent.screenX - startX;
        rawEvent.deltaY = rawEvent.screenY - startY;
        e.prevent();
        settings.drag(rawEvent);
      };
      var stop = function (e) {
        updateWithTouchData(e.raw);
        each$1(overlayEvents, function (e) {
          return e.unbind();
        });
        overlayEvents = [];
        remove$5(eventOverlay);
        if (settings.stop) {
          settings.stop(e.raw);
        }
      };
      var destroy = function () {
        each$1(overlayEvents.concat(handleEvents), function (e) {
          return e.unbind();
        });
        overlayEvents = [];
        handleEvents = [];
        if (isNonNullable(eventOverlay)) {
          remove$5(eventOverlay);
        }
      };
      handleEvents.push(bind(handleElement, 'mousedown', start), bind(handleElement, 'touchstart', start));
      return { destroy: destroy };
    }

    var count = 0;
    var create$1 = function (currentRect, viewPortRect, clampRect, containerElm, action) {
      var dragHelpers;
      var events = [];
      var prefix = 'tox-';
      var id = prefix + 'crid-' + count++;
      var container = SugarElement.fromDom(containerElm);
      var handles = [
        {
          name: 'move',
          xMul: 0,
          yMul: 0,
          deltaX: 1,
          deltaY: 1,
          deltaW: 0,
          deltaH: 0,
          label: 'Crop Mask'
        },
        {
          name: 'nw',
          xMul: 0,
          yMul: 0,
          deltaX: 1,
          deltaY: 1,
          deltaW: -1,
          deltaH: -1,
          label: 'Top Left Crop Handle'
        },
        {
          name: 'ne',
          xMul: 1,
          yMul: 0,
          deltaX: 0,
          deltaY: 1,
          deltaW: 1,
          deltaH: -1,
          label: 'Top Right Crop Handle'
        },
        {
          name: 'sw',
          xMul: 0,
          yMul: 1,
          deltaX: 1,
          deltaY: 0,
          deltaW: -1,
          deltaH: 1,
          label: 'Bottom Left Crop Handle'
        },
        {
          name: 'se',
          xMul: 1,
          yMul: 1,
          deltaX: 0,
          deltaY: 0,
          deltaW: 1,
          deltaH: 1,
          label: 'Bottom Right Crop Handle'
        }
      ];
      var blockers = [
        'top',
        'right',
        'bottom',
        'left'
      ];
      var getAbsoluteRect = function (outerRect, relativeRect) {
        return {
          x: relativeRect.x + outerRect.x,
          y: relativeRect.y + outerRect.y,
          w: relativeRect.w,
          h: relativeRect.h
        };
      };
      var getRelativeRect = function (outerRect, innerRect) {
        return {
          x: innerRect.x - outerRect.x,
          y: innerRect.y - outerRect.y,
          w: innerRect.w,
          h: innerRect.h
        };
      };
      var getInnerRect = function () {
        return getRelativeRect(clampRect, currentRect);
      };
      var moveRect = function (handle, startRect, deltaX, deltaY) {
        var x = startRect.x + deltaX * handle.deltaX;
        var y = startRect.y + deltaY * handle.deltaY;
        var w = Math.max(20, startRect.w + deltaX * handle.deltaW);
        var h = Math.max(20, startRect.h + deltaY * handle.deltaH);
        var rect = currentRect = global$4.clamp({
          x: x,
          y: y,
          w: w,
          h: h
        }, clampRect, handle.name === 'move');
        rect = getRelativeRect(clampRect, rect);
        instance.fire('updateRect', { rect: rect });
        setInnerRect(rect);
      };
      var render = function () {
        var createDragHelper = function (handle) {
          var startRect;
          return DragHelper(id, {
            document: containerElm.ownerDocument,
            root: getRootNode(container).dom,
            handle: id + '-' + handle.name,
            start: function () {
              startRect = currentRect;
            },
            drag: function (e) {
              moveRect(handle, startRect, e.deltaX, e.deltaY);
            }
          });
        };
        var cropContainer = SugarElement.fromTag('div');
        setAll$1(cropContainer, {
          id: id,
          'class': prefix + 'croprect-container',
          'role': 'grid',
          'aria-dropeffect': 'execute'
        });
        append$2(container, cropContainer);
        each$1(blockers, function (blocker) {
          descendant(container, '#' + id).each(function (blockerElm) {
            var cropBlocker = SugarElement.fromTag('div');
            setAll$1(cropBlocker, {
              'id': id + '-' + blocker,
              'class': prefix + 'croprect-block',
              'data-mce-bogus': 'all'
            });
            set$7(cropBlocker, 'display', 'none');
            append$2(blockerElm, cropBlocker);
          });
        });
        each$1(handles, function (handle) {
          descendant(container, '#' + id).each(function (handleElm) {
            var cropHandle = SugarElement.fromTag('div');
            setAll$1(cropHandle, {
              'id': id + '-' + handle.name,
              'aria-label': handle.label,
              'aria-grabbed': 'false',
              'data-mce-bogus': 'all',
              'role': 'gridcell',
              'tabindex': '-1',
              'title': handle.label
            });
            add$1(cropHandle, [
              prefix + 'croprect-handle',
              prefix + 'croprect-handle-' + handle.name
            ]);
            set$7(cropHandle, 'display', 'none');
            append$2(handleElm, cropHandle);
          });
        });
        dragHelpers = map$2(handles, createDragHelper);
        repaint(currentRect);
        var handleFocus = function (e) {
          set$8(e.target, 'aria-grabbed', e.raw.type === 'focus' ? 'true' : 'false');
        };
        var handleKeydown = function (e) {
          var activeHandle;
          each$1(handles, function (handle) {
            if (get$d(e.target, 'id') === id + '-' + handle.name) {
              activeHandle = handle;
              return false;
            }
          });
          var moveAndBlock = function (evt, handle, startRect, deltaX, deltaY) {
            evt.stopPropagation();
            evt.preventDefault();
            moveRect(activeHandle, startRect, deltaX, deltaY);
          };
          switch (e.raw.keyCode) {
          case global$2.LEFT:
            moveAndBlock(e, activeHandle, currentRect, -10, 0);
            break;
          case global$2.RIGHT:
            moveAndBlock(e, activeHandle, currentRect, 10, 0);
            break;
          case global$2.UP:
            moveAndBlock(e, activeHandle, currentRect, 0, -10);
            break;
          case global$2.DOWN:
            moveAndBlock(e, activeHandle, currentRect, 0, 10);
            break;
          case global$2.ENTER:
          case global$2.SPACEBAR:
            e.prevent();
            action();
            break;
          }
        };
        events.push(bind(container, 'focusin', handleFocus), bind(container, 'focusout', handleFocus), bind(container, 'keydown', handleKeydown));
      };
      var toggleVisibility = function (state) {
        var selectors = __spreadArray(__spreadArray([], map$2(handles, function (handle) {
          return '#' + id + '-' + handle.name;
        }), true), map$2(blockers, function (blocker) {
          return '#' + id + '-' + blocker;
        }), true).join(',');
        var elems = descendants(container, selectors);
        if (state) {
          each$1(elems, function (elm) {
            return remove$6(elm, 'display');
          });
        } else {
          each$1(elems, function (elm) {
            return set$7(elm, 'display', 'none');
          });
        }
      };
      var repaint = function (rect) {
        var updateElementRect = function (name, newRect) {
          descendant(container, '#' + id + '-' + name).each(function (elm) {
            setAll(elm, {
              left: newRect.x + 'px',
              top: newRect.y + 'px',
              width: Math.max(0, newRect.w) + 'px',
              height: Math.max(0, newRect.h) + 'px'
            });
          });
        };
        each$1(handles, function (handle) {
          descendant(container, '#' + id + '-' + handle.name).each(function (elm) {
            setAll(elm, {
              left: rect.w * handle.xMul + rect.x + 'px',
              top: rect.h * handle.yMul + rect.y + 'px'
            });
          });
        });
        updateElementRect('top', {
          x: viewPortRect.x,
          y: viewPortRect.y,
          w: viewPortRect.w,
          h: rect.y - viewPortRect.y
        });
        updateElementRect('right', {
          x: rect.x + rect.w,
          y: rect.y,
          w: viewPortRect.w - rect.x - rect.w + viewPortRect.x,
          h: rect.h
        });
        updateElementRect('bottom', {
          x: viewPortRect.x,
          y: rect.y + rect.h,
          w: viewPortRect.w,
          h: viewPortRect.h - rect.y - rect.h + viewPortRect.y
        });
        updateElementRect('left', {
          x: viewPortRect.x,
          y: rect.y,
          w: rect.x - viewPortRect.x,
          h: rect.h
        });
        updateElementRect('move', rect);
      };
      var setRect = function (rect) {
        currentRect = rect;
        repaint(currentRect);
      };
      var setViewPortRect = function (rect) {
        viewPortRect = rect;
        repaint(currentRect);
      };
      var setInnerRect = function (rect) {
        setRect(getAbsoluteRect(clampRect, rect));
      };
      var setClampRect = function (rect) {
        clampRect = rect;
        repaint(currentRect);
      };
      var destroy = function () {
        each$1(dragHelpers, function (helper) {
          return helper.destroy();
        });
        dragHelpers = [];
        each$1(events, function (e) {
          return e.unbind();
        });
        events = [];
      };
      render();
      var instance = __assign(__assign({}, global$3), {
        toggleVisibility: toggleVisibility,
        setClampRect: setClampRect,
        setRect: setRect,
        getInnerRect: getInnerRect,
        setInnerRect: setInnerRect,
        setViewPortRect: setViewPortRect,
        destroy: destroy
      });
      return instance;
    };
    var CropRect = { create: create$1 };

    var loadImage = function (image) {
      return new global$c(function (resolve) {
        var loaded = function () {
          image.removeEventListener('load', loaded);
          resolve(image);
        };
        if (image.complete) {
          resolve(image);
        } else {
          image.addEventListener('load', loaded);
        }
      });
    };
    var renderImagePanel = function (initialUrl) {
      var memBg = record({
        dom: {
          tag: 'div',
          classes: ['tox-image-tools__image-bg'],
          attributes: { role: 'presentation' }
        }
      });
      var zoomState = Cell(1);
      var cropRect = api$1();
      var rectState = Cell({
        x: 0,
        y: 0,
        w: 1,
        h: 1
      });
      var viewRectState = Cell({
        x: 0,
        y: 0,
        w: 1,
        h: 1
      });
      var repaintImg = function (anyInSystem, img) {
        memContainer.getOpt(anyInSystem).each(function (panel) {
          var zoom = zoomState.get();
          var panelW = get$a(panel.element);
          var panelH = get$b(panel.element);
          var width = img.dom.naturalWidth * zoom;
          var height = img.dom.naturalHeight * zoom;
          var left = Math.max(0, panelW / 2 - width / 2);
          var top = Math.max(0, panelH / 2 - height / 2);
          var css = {
            left: left.toString() + 'px',
            top: top.toString() + 'px',
            width: width.toString() + 'px',
            height: height.toString() + 'px',
            position: 'absolute'
          };
          setAll(img, css);
          memBg.getOpt(panel).each(function (bg) {
            setAll(bg.element, css);
          });
          cropRect.run(function (cRect) {
            var rect = rectState.get();
            cRect.setRect({
              x: rect.x * zoom + left,
              y: rect.y * zoom + top,
              w: rect.w * zoom,
              h: rect.h * zoom
            });
            cRect.setClampRect({
              x: left,
              y: top,
              w: width,
              h: height
            });
            cRect.setViewPortRect({
              x: 0,
              y: 0,
              w: panelW,
              h: panelH
            });
          });
        });
      };
      var zoomFit = function (anyInSystem, img) {
        memContainer.getOpt(anyInSystem).each(function (panel) {
          var panelW = get$a(panel.element);
          var panelH = get$b(panel.element);
          var width = img.dom.naturalWidth;
          var height = img.dom.naturalHeight;
          var zoom = Math.min(panelW / width, panelH / height);
          if (zoom >= 1) {
            zoomState.set(1);
          } else {
            zoomState.set(zoom);
          }
        });
      };
      var updateSrc = function (anyInSystem, url) {
        var img = SugarElement.fromTag('img');
        set$8(img, 'src', url);
        return loadImage(img.dom).then(function () {
          if (anyInSystem.getSystem().isConnected()) {
            memContainer.getOpt(anyInSystem).map(function (panel) {
              var aImg = external$2({ element: img });
              Replacing.replaceAt(panel, 1, Optional.some(aImg));
              var lastViewRect = viewRectState.get();
              var viewRect = {
                x: 0,
                y: 0,
                w: img.dom.naturalWidth,
                h: img.dom.naturalHeight
              };
              viewRectState.set(viewRect);
              var rect = global$4.inflate(viewRect, -20, -20);
              rectState.set(rect);
              if (lastViewRect.w !== viewRect.w || lastViewRect.h !== viewRect.h) {
                zoomFit(panel, img);
              }
              repaintImg(panel, img);
            });
          }
        });
      };
      var zoom = function (anyInSystem, direction) {
        var currentZoom = zoomState.get();
        var newZoom = direction > 0 ? Math.min(2, currentZoom + 0.1) : Math.max(0.1, currentZoom - 0.1);
        zoomState.set(newZoom);
        memContainer.getOpt(anyInSystem).each(function (panel) {
          var img = panel.components()[1].element;
          repaintImg(panel, img);
        });
      };
      var showCrop = function () {
        cropRect.run(function (cRect) {
          cRect.toggleVisibility(true);
        });
      };
      var hideCrop = function () {
        cropRect.run(function (cRect) {
          cRect.toggleVisibility(false);
        });
      };
      var getRect = function () {
        return rectState.get();
      };
      var container = Container.sketch({
        dom: {
          tag: 'div',
          classes: ['tox-image-tools__image']
        },
        components: [
          memBg.asSpec(),
          {
            dom: {
              tag: 'img',
              attributes: { src: initialUrl }
            }
          },
          {
            dom: { tag: 'div' },
            behaviours: derive$1([config('image-panel-crop-events', [
                runOnAttached(function (comp) {
                  memContainer.getOpt(comp).each(function (container) {
                    var el = container.element.dom;
                    var cRect = CropRect.create({
                      x: 10,
                      y: 10,
                      w: 100,
                      h: 100
                    }, {
                      x: 0,
                      y: 0,
                      w: 200,
                      h: 200
                    }, {
                      x: 0,
                      y: 0,
                      w: 200,
                      h: 200
                    }, el, noop);
                    cRect.toggleVisibility(false);
                    cRect.on('updateRect', function (e) {
                      var rect = e.rect;
                      var zoom = zoomState.get();
                      var newRect = {
                        x: Math.round(rect.x / zoom),
                        y: Math.round(rect.y / zoom),
                        w: Math.round(rect.w / zoom),
                        h: Math.round(rect.h / zoom)
                      };
                      rectState.set(newRect);
                    });
                    cropRect.set(cRect);
                  });
                }),
                runOnDetached(function () {
                  cropRect.clear();
                })
              ])])
          }
        ],
        containerBehaviours: derive$1([
          Replacing.config({}),
          config('image-panel-events', [runOnAttached(function (comp) {
              updateSrc(comp, initialUrl);
            })])
        ])
      });
      var memContainer = record(container);
      var getMeasurements = function () {
        var viewRect = viewRectState.get();
        return {
          width: viewRect.w,
          height: viewRect.h
        };
      };
      return {
        memContainer: memContainer,
        updateSrc: updateSrc,
        zoom: zoom,
        showCrop: showCrop,
        hideCrop: hideCrop,
        getRect: getRect,
        getMeasurements: getMeasurements
      };
    };

    var createButton = function (innerHtml, icon, disabled, action, providersBackstage) {
      return renderIconButton({
        name: innerHtml,
        icon: Optional.some(icon),
        disabled: disabled,
        tooltip: Optional.some(innerHtml),
        primary: false,
        borderless: false
      }, action, providersBackstage);
    };
    var setButtonEnabled = function (button, enabled) {
      if (enabled) {
        Disabling.enable(button);
      } else {
        Disabling.disable(button);
      }
    };
    var renderSideBar = function (providersBackstage) {
      var updateButtonUndoStates = function (anyInSystem, undoEnabled, redoEnabled) {
        memUndo.getOpt(anyInSystem).each(function (undo) {
          setButtonEnabled(undo, undoEnabled);
        });
        memRedo.getOpt(anyInSystem).each(function (redo) {
          setButtonEnabled(redo, redoEnabled);
        });
      };
      var memUndo = record(createButton('Undo', 'undo', true, function (button) {
        emitWith(button, internal.undo(), { direction: 1 });
      }, providersBackstage));
      var memRedo = record(createButton('Redo', 'redo', true, function (button) {
        emitWith(button, internal.redo(), { direction: 1 });
      }, providersBackstage));
      var container = Container.sketch({
        dom: {
          tag: 'div',
          classes: [
            'tox-image-tools__toolbar',
            'tox-image-tools__sidebar'
          ]
        },
        components: [
          memUndo.asSpec(),
          memRedo.asSpec(),
          createButton('Zoom in', 'zoom-in', false, function (button) {
            emitWith(button, internal.zoom(), { direction: 1 });
          }, providersBackstage),
          createButton('Zoom out', 'zoom-out', false, function (button) {
            emitWith(button, internal.zoom(), { direction: -1 });
          }, providersBackstage)
        ]
      });
      return {
        container: container,
        updateButtonUndoStates: updateButtonUndoStates
      };
    };

    function UndoStack () {
      var data = [];
      var index = -1;
      var add = function (state) {
        var removed = data.splice(++index);
        data.push(state);
        return {
          state: state,
          removed: removed
        };
      };
      var undo = function () {
        if (canUndo()) {
          return data[--index];
        }
      };
      var redo = function () {
        if (canRedo()) {
          return data[++index];
        }
      };
      var canUndo = function () {
        return index > 0;
      };
      var canRedo = function () {
        return index !== -1 && index < data.length - 1;
      };
      return {
        data: data,
        add: add,
        undo: undo,
        redo: redo,
        canUndo: canUndo,
        canRedo: canRedo
      };
    }

    var makeState = function (initialState) {
      var blobState = Cell(initialState);
      var tempState = value$1();
      var undoStack = UndoStack();
      undoStack.add(initialState);
      var getBlobState = function () {
        return blobState.get();
      };
      var setBlobState = function (state) {
        blobState.set(state);
      };
      var getTempState = function () {
        return tempState.get().getOrThunk(blobState.get);
      };
      var updateTempState = function (blob) {
        var newTempState = createState(blob);
        destroyTempState();
        tempState.set(newTempState);
        return newTempState.url;
      };
      var createState = function (blob) {
        return {
          blob: blob,
          url: URL.createObjectURL(blob)
        };
      };
      var destroyState = function (state) {
        URL.revokeObjectURL(state.url);
      };
      var destroyStates = function (states) {
        global$5.each(states, destroyState);
      };
      var destroyTempState = function () {
        tempState.on(destroyState);
        tempState.clear();
      };
      var addBlobState = function (blob) {
        var newState = createState(blob);
        setBlobState(newState);
        var removed = undoStack.add(newState).removed;
        destroyStates(removed);
        return newState.url;
      };
      var addTempState = function (blob) {
        var newState = createState(blob);
        tempState.set(newState);
        return newState.url;
      };
      var applyTempState = function (postApply) {
        return tempState.get().fold(noop, function (temp) {
          addBlobState(temp.blob);
          postApply();
        });
      };
      var undo = function () {
        var currentState = undoStack.undo();
        setBlobState(currentState);
        return currentState.url;
      };
      var redo = function () {
        var currentState = undoStack.redo();
        setBlobState(currentState);
        return currentState.url;
      };
      var getHistoryStates = function () {
        var undoEnabled = undoStack.canUndo();
        var redoEnabled = undoStack.canRedo();
        return {
          undoEnabled: undoEnabled,
          redoEnabled: redoEnabled
        };
      };
      return {
        getBlobState: getBlobState,
        setBlobState: setBlobState,
        addBlobState: addBlobState,
        getTempState: getTempState,
        updateTempState: updateTempState,
        addTempState: addTempState,
        applyTempState: applyTempState,
        destroyTempState: destroyTempState,
        undo: undo,
        redo: redo,
        getHistoryStates: getHistoryStates
      };
    };

    var renderImageTools = function (detail, providersBackstage) {
      var state = makeState(detail.currentState);
      var zoom = function (anyInSystem, simulatedEvent) {
        var direction = simulatedEvent.event.direction;
        imagePanel.zoom(anyInSystem, direction);
      };
      var updateButtonUndoStates = function (anyInSystem) {
        var historyStates = state.getHistoryStates();
        sideBar.updateButtonUndoStates(anyInSystem, historyStates.undoEnabled, historyStates.redoEnabled);
        emitWith(anyInSystem, external.formActionEvent, {
          name: external.saveState(),
          value: historyStates.undoEnabled
        });
      };
      var disableUndoRedo = function (anyInSystem) {
        sideBar.updateButtonUndoStates(anyInSystem, false, false);
      };
      var undo = function (anyInSystem, _simulatedEvent) {
        var url = state.undo();
        updateSrc(anyInSystem, url).then(function (_oImg) {
          unblock(anyInSystem);
          updateButtonUndoStates(anyInSystem);
        });
      };
      var redo = function (anyInSystem, _simulatedEvent) {
        var url = state.redo();
        updateSrc(anyInSystem, url).then(function (_oImg) {
          unblock(anyInSystem);
          updateButtonUndoStates(anyInSystem);
        });
      };
      var imageResultToBlob = function (ir) {
        return ir.toBlob();
      };
      var block = function (anyInSystem) {
        emitWith(anyInSystem, external.formActionEvent, {
          name: external.disable(),
          value: {}
        });
      };
      var unblock = function (anyInSystem) {
        editPanel.getApplyButton(anyInSystem).each(function (applyButton) {
          Disabling.enable(applyButton);
        });
        emitWith(anyInSystem, external.formActionEvent, {
          name: external.enable(),
          value: {}
        });
      };
      var updateSrc = function (anyInSystem, src) {
        block(anyInSystem);
        return imagePanel.updateSrc(anyInSystem, src);
      };
      var blobManipulate = function (anyInSystem, blob, filter, action, swap) {
        block(anyInSystem);
        blobToImageResult(blob).then(filter).then(imageResultToBlob).then(action).then(function (url) {
          return updateSrc(anyInSystem, url);
        }).then(function () {
          updateButtonUndoStates(anyInSystem);
          swap();
          unblock(anyInSystem);
        }).catch(function (err) {
          console.log(err);
          if (anyInSystem.getSystem().isConnected()) {
            unblock(anyInSystem);
          }
        });
      };
      var manipulate = function (anyInSystem, filter, swap) {
        var blob = state.getBlobState().blob;
        var action = function (blob) {
          return state.updateTempState(blob);
        };
        blobManipulate(anyInSystem, blob, filter, action, swap);
      };
      var tempManipulate = function (anyInSystem, filter) {
        var blob = state.getTempState().blob;
        var action = function (blob) {
          return state.addTempState(blob);
        };
        blobManipulate(anyInSystem, blob, filter, action, noop);
      };
      var manipulateApply = function (anyInSystem, filter, swap) {
        var blob = state.getBlobState().blob;
        var action = function (blob) {
          var url = state.addBlobState(blob);
          destroyTempState(anyInSystem);
          return url;
        };
        blobManipulate(anyInSystem, blob, filter, action, swap);
      };
      var apply = function (anyInSystem, simulatedEvent) {
        var postApply = function () {
          destroyTempState(anyInSystem);
          var swap = simulatedEvent.event.swap;
          swap();
        };
        state.applyTempState(postApply);
      };
      var destroyTempState = function (anyInSystem) {
        var currentUrl = state.getBlobState().url;
        state.destroyTempState();
        updateButtonUndoStates(anyInSystem);
        return currentUrl;
      };
      var cancel = function (anyInSystem) {
        var currentUrl = destroyTempState(anyInSystem);
        updateSrc(anyInSystem, currentUrl).then(function (_oImg) {
          unblock(anyInSystem);
        });
      };
      var back = function (anyInSystem, simulatedEvent) {
        cancel(anyInSystem);
        var swap = simulatedEvent.event.swap;
        swap();
        imagePanel.hideCrop();
      };
      var transform = function (anyInSystem, simulatedEvent) {
        return manipulate(anyInSystem, simulatedEvent.event.transform, noop);
      };
      var tempTransform = function (anyInSystem, simulatedEvent) {
        return tempManipulate(anyInSystem, simulatedEvent.event.transform);
      };
      var transformApply = function (anyInSystem, simulatedEvent) {
        return manipulateApply(anyInSystem, simulatedEvent.event.transform, simulatedEvent.event.swap);
      };
      var imagePanel = renderImagePanel(detail.currentState.url);
      var sideBar = renderSideBar(providersBackstage);
      var editPanel = renderEditPanel(imagePanel, providersBackstage);
      var swap = function (anyInSystem, simulatedEvent) {
        disableUndoRedo(anyInSystem);
        var transform = simulatedEvent.event.transform;
        var swap = simulatedEvent.event.swap;
        transform.fold(function () {
          swap();
        }, function (transform) {
          manipulate(anyInSystem, transform, swap);
        });
      };
      return {
        dom: {
          tag: 'div',
          attributes: { role: 'presentation' }
        },
        components: [
          editPanel.memContainer.asSpec(),
          imagePanel.memContainer.asSpec(),
          sideBar.container
        ],
        behaviours: derive$1([
          Representing.config({
            store: {
              mode: 'manual',
              getValue: function () {
                return state.getBlobState();
              }
            }
          }),
          config('image-tools-events', [
            run$1(internal.undo(), undo),
            run$1(internal.redo(), redo),
            run$1(internal.zoom(), zoom),
            run$1(internal.back(), back),
            run$1(internal.apply(), apply),
            run$1(internal.transform(), transform),
            run$1(internal.tempTransform(), tempTransform),
            run$1(internal.transformApply(), transformApply),
            run$1(internal.swap(), swap)
          ]),
          ComposingConfigs.self()
        ])
      };
    };

    var renderLabel = function (spec, backstageShared) {
      var label = {
        dom: {
          tag: 'label',
          innerHtml: backstageShared.providers.translate(spec.label),
          classes: ['tox-label']
        }
      };
      var comps = map$2(spec.items, backstageShared.interpreter);
      return {
        dom: {
          tag: 'div',
          classes: ['tox-form__group']
        },
        components: [label].concat(comps),
        behaviours: derive$1([
          ComposingConfigs.self(),
          Replacing.config({}),
          RepresentingConfigs.domHtml(Optional.none()),
          Keying.config({ mode: 'acyclic' })
        ])
      };
    };

    var isSingleListItem = function (item) {
      return !has$2(item, 'items');
    };
    var dataAttribute = 'data-value';
    var fetchItems = function (dropdownComp, name, items, selectedValue) {
      return map$2(items, function (item) {
        if (!isSingleListItem(item)) {
          return {
            type: 'nestedmenuitem',
            text: item.text,
            getSubmenuItems: function () {
              return fetchItems(dropdownComp, name, item.items, selectedValue);
            }
          };
        } else {
          return {
            type: 'togglemenuitem',
            text: item.text,
            value: item.value,
            active: item.value === selectedValue,
            onAction: function () {
              Representing.setValue(dropdownComp, item.value);
              emitWith(dropdownComp, formChangeEvent, { name: name });
              Focusing.focus(dropdownComp);
            }
          };
        }
      });
    };
    var findItemByValue = function (items, value) {
      return findMap(items, function (item) {
        if (!isSingleListItem(item)) {
          return findItemByValue(item.items, value);
        } else {
          return someIf(item.value === value, item);
        }
      });
    };
    var renderListBox = function (spec, backstage) {
      var providersBackstage = backstage.shared.providers;
      var initialItem = head(spec.items).filter(isSingleListItem);
      var pLabel = spec.label.map(function (label) {
        return renderLabel$2(label, providersBackstage);
      });
      var pField = FormField.parts.field({
        dom: {},
        factory: {
          sketch: function (sketchSpec) {
            return renderCommonDropdown({
              uid: sketchSpec.uid,
              text: initialItem.map(function (item) {
                return item.text;
              }),
              icon: Optional.none(),
              tooltip: spec.label,
              role: Optional.none(),
              fetch: function (comp, callback) {
                var items = fetchItems(comp, spec.name, spec.items, Representing.getValue(comp));
                callback(build(items, ItemResponse$1.CLOSE_ON_EXECUTE, backstage, false));
              },
              onSetup: constant$1(noop),
              getApi: constant$1({}),
              columns: 1,
              presets: 'normal',
              classes: [],
              dropdownBehaviours: [
                Tabstopping.config({}),
                Representing.config({
                  store: {
                    mode: 'manual',
                    initialValue: initialItem.map(function (item) {
                      return item.value;
                    }).getOr(''),
                    getValue: function (comp) {
                      return get$d(comp.element, dataAttribute);
                    },
                    setValue: function (comp, data) {
                      findItemByValue(spec.items, data).each(function (item) {
                        set$8(comp.element, dataAttribute, item.value);
                        emitWith(comp, updateMenuText, { text: item.text });
                      });
                    }
                  }
                })
              ]
            }, 'tox-listbox', backstage.shared);
          }
        }
      });
      var listBoxWrap = {
        dom: {
          tag: 'div',
          classes: ['tox-listboxfield']
        },
        components: [pField]
      };
      return FormField.sketch({
        dom: {
          tag: 'div',
          classes: ['tox-form__group']
        },
        components: flatten([
          pLabel.toArray(),
          [listBoxWrap]
        ]),
        fieldBehaviours: derive$1([Disabling.config({
            disabled: constant$1(spec.disabled),
            onDisabled: function (comp) {
              FormField.getField(comp).each(Disabling.disable);
            },
            onEnabled: function (comp) {
              FormField.getField(comp).each(Disabling.enable);
            }
          })])
      });
    };

    var renderPanel = function (spec, backstage) {
      return {
        dom: {
          tag: 'div',
          classes: spec.classes
        },
        components: map$2(spec.items, backstage.shared.interpreter)
      };
    };

    var factory$e = function (detail, _spec) {
      var options = map$2(detail.options, function (option) {
        return {
          dom: {
            tag: 'option',
            value: option.value,
            innerHtml: option.text
          }
        };
      });
      var initialValues = detail.data.map(function (v) {
        return wrap$1('initialValue', v);
      }).getOr({});
      return {
        uid: detail.uid,
        dom: {
          tag: 'select',
          classes: detail.selectClasses,
          attributes: detail.selectAttributes
        },
        components: options,
        behaviours: augment(detail.selectBehaviours, [
          Focusing.config({}),
          Representing.config({
            store: __assign({
              mode: 'manual',
              getValue: function (select) {
                return get$5(select.element);
              },
              setValue: function (select, newValue) {
                var found = find$5(detail.options, function (opt) {
                  return opt.value === newValue;
                });
                if (found.isSome()) {
                  set$4(select.element, newValue);
                }
              }
            }, initialValues)
          })
        ])
      };
    };
    var HtmlSelect = single({
      name: 'HtmlSelect',
      configFields: [
        required$1('options'),
        field('selectBehaviours', [
          Focusing,
          Representing
        ]),
        defaulted('selectClasses', []),
        defaulted('selectAttributes', {}),
        option('data')
      ],
      factory: factory$e
    });

    var renderSelectBox = function (spec, providersBackstage) {
      var translatedOptions = map$2(spec.items, function (item) {
        return {
          text: providersBackstage.translate(item.text),
          value: item.value
        };
      });
      var pLabel = spec.label.map(function (label) {
        return renderLabel$2(label, providersBackstage);
      });
      var pField = FormField.parts.field({
        dom: {},
        selectAttributes: { size: spec.size },
        options: translatedOptions,
        factory: HtmlSelect,
        selectBehaviours: derive$1([
          Disabling.config({
            disabled: function () {
              return spec.disabled || providersBackstage.isDisabled();
            }
          }),
          Tabstopping.config({}),
          config('selectbox-change', [run$1(change(), function (component, _) {
              emitWith(component, formChangeEvent, { name: spec.name });
            })])
        ])
      });
      var chevron = spec.size > 1 ? Optional.none() : Optional.some(render$3('chevron-down', {
        tag: 'div',
        classes: ['tox-selectfield__icon-js']
      }, providersBackstage.icons));
      var selectWrap = {
        dom: {
          tag: 'div',
          classes: ['tox-selectfield']
        },
        components: flatten([
          [pField],
          chevron.toArray()
        ])
      };
      return FormField.sketch({
        dom: {
          tag: 'div',
          classes: ['tox-form__group']
        },
        components: flatten([
          pLabel.toArray(),
          [selectWrap]
        ]),
        fieldBehaviours: derive$1([
          Disabling.config({
            disabled: function () {
              return spec.disabled || providersBackstage.isDisabled();
            },
            onDisabled: function (comp) {
              FormField.getField(comp).each(Disabling.disable);
            },
            onEnabled: function (comp) {
              FormField.getField(comp).each(Disabling.enable);
            }
          }),
          receivingConfig()
        ])
      });
    };

    var renderTable = function (spec, providersBackstage) {
      var renderTh = function (text) {
        return {
          dom: {
            tag: 'th',
            innerHtml: providersBackstage.translate(text)
          }
        };
      };
      var renderHeader = function (header) {
        return {
          dom: { tag: 'thead' },
          components: [{
              dom: { tag: 'tr' },
              components: map$2(header, renderTh)
            }]
        };
      };
      var renderTd = function (text) {
        return {
          dom: {
            tag: 'td',
            innerHtml: providersBackstage.translate(text)
          }
        };
      };
      var renderTr = function (row) {
        return {
          dom: { tag: 'tr' },
          components: map$2(row, renderTd)
        };
      };
      var renderRows = function (rows) {
        return {
          dom: { tag: 'tbody' },
          components: map$2(rows, renderTr)
        };
      };
      return {
        dom: {
          tag: 'table',
          classes: ['tox-dialog__table']
        },
        components: [
          renderHeader(spec.header),
          renderRows(spec.cells)
        ],
        behaviours: derive$1([
          Tabstopping.config({}),
          Focusing.config({})
        ])
      };
    };

    var renderTextField = function (spec, providersBackstage) {
      var pLabel = spec.label.map(function (label) {
        return renderLabel$2(label, providersBackstage);
      });
      var baseInputBehaviours = [
        Disabling.config({
          disabled: function () {
            return spec.disabled || providersBackstage.isDisabled();
          }
        }),
        receivingConfig(),
        Keying.config({
          mode: 'execution',
          useEnter: spec.multiline !== true,
          useControlEnter: spec.multiline === true,
          execute: function (comp) {
            emit(comp, formSubmitEvent);
            return Optional.some(true);
          }
        }),
        config('textfield-change', [
          run$1(input(), function (component, _) {
            emitWith(component, formChangeEvent, { name: spec.name });
          }),
          run$1(postPaste(), function (component, _) {
            emitWith(component, formChangeEvent, { name: spec.name });
          })
        ]),
        Tabstopping.config({})
      ];
      var validatingBehaviours = spec.validation.map(function (vl) {
        return Invalidating.config({
          getRoot: function (input) {
            return parent(input.element);
          },
          invalidClass: 'tox-invalid',
          validator: {
            validate: function (input) {
              var v = Representing.getValue(input);
              var result = vl.validator(v);
              return Future.pure(result === true ? Result.value(v) : Result.error(result));
            },
            validateOnLoad: vl.validateOnLoad
          }
        });
      }).toArray();
      var placeholder = spec.placeholder.fold(constant$1({}), function (p) {
        return { placeholder: providersBackstage.translate(p) };
      });
      var inputMode = spec.inputMode.fold(constant$1({}), function (mode) {
        return { inputmode: mode };
      });
      var inputAttributes = __assign(__assign({}, placeholder), inputMode);
      var pField = FormField.parts.field({
        tag: spec.multiline === true ? 'textarea' : 'input',
        inputAttributes: inputAttributes,
        inputClasses: [spec.classname],
        inputBehaviours: derive$1(flatten([
          baseInputBehaviours,
          validatingBehaviours
        ])),
        selectOnFocus: false,
        factory: Input
      });
      var extraClasses = spec.flex ? ['tox-form__group--stretched'] : [];
      var extraClasses2 = extraClasses.concat(spec.maximized ? ['tox-form-group--maximize'] : []);
      var extraBehaviours = [
        Disabling.config({
          disabled: function () {
            return spec.disabled || providersBackstage.isDisabled();
          },
          onDisabled: function (comp) {
            FormField.getField(comp).each(Disabling.disable);
          },
          onEnabled: function (comp) {
            FormField.getField(comp).each(Disabling.enable);
          }
        }),
        receivingConfig()
      ];
      return renderFormFieldWith(pLabel, pField, extraClasses2, extraBehaviours);
    };
    var renderInput = function (spec, providersBackstage) {
      return renderTextField({
        name: spec.name,
        multiline: false,
        label: spec.label,
        inputMode: spec.inputMode,
        placeholder: spec.placeholder,
        flex: false,
        disabled: spec.disabled,
        classname: 'tox-textfield',
        validation: Optional.none(),
        maximized: spec.maximized
      }, providersBackstage);
    };
    var renderTextarea = function (spec, providersBackstage) {
      return renderTextField({
        name: spec.name,
        multiline: true,
        label: spec.label,
        inputMode: Optional.none(),
        placeholder: spec.placeholder,
        flex: true,
        disabled: spec.disabled,
        classname: 'tox-textarea',
        validation: Optional.none(),
        maximized: spec.maximized
      }, providersBackstage);
    };

    var events$6 = function (streamConfig, streamState) {
      var streams = streamConfig.stream.streams;
      var processor = streams.setup(streamConfig, streamState);
      return derive$2([
        run$1(streamConfig.event, processor),
        runOnDetached(function () {
          return streamState.cancel();
        })
      ].concat(streamConfig.cancelEvent.map(function (e) {
        return [run$1(e, function () {
            return streamState.cancel();
          })];
      }).getOr([])));
    };

    var ActiveStreaming = /*#__PURE__*/Object.freeze({
        __proto__: null,
        events: events$6
    });

    var throttle = function (_config) {
      var state = Cell(null);
      var readState = function () {
        return { timer: state.get() !== null ? 'set' : 'unset' };
      };
      var setTimer = function (t) {
        state.set(t);
      };
      var cancel = function () {
        var t = state.get();
        if (t !== null) {
          t.cancel();
        }
      };
      return nu$8({
        readState: readState,
        setTimer: setTimer,
        cancel: cancel
      });
    };
    var init$9 = function (spec) {
      return spec.stream.streams.state(spec);
    };

    var StreamingState = /*#__PURE__*/Object.freeze({
        __proto__: null,
        throttle: throttle,
        init: init$9
    });

    var setup$c = function (streamInfo, streamState) {
      var sInfo = streamInfo.stream;
      var throttler = last(streamInfo.onStream, sInfo.delay);
      streamState.setTimer(throttler);
      return function (component, simulatedEvent) {
        throttler.throttle(component, simulatedEvent);
        if (sInfo.stopEvent) {
          simulatedEvent.stop();
        }
      };
    };
    var StreamingSchema = [
      requiredOf('stream', choose$1('mode', {
        throttle: [
          required$1('delay'),
          defaulted('stopEvent', true),
          output$1('streams', {
            setup: setup$c,
            state: throttle
          })
        ]
      })),
      defaulted('event', 'input'),
      option('cancelEvent'),
      onStrictHandler('onStream')
    ];

    var Streaming = create$7({
      fields: StreamingSchema,
      name: 'streaming',
      active: ActiveStreaming,
      state: StreamingState
    });

    var setValueFromItem = function (model, input, item) {
      var itemData = Representing.getValue(item);
      Representing.setValue(input, itemData);
      setCursorAtEnd(input);
    };
    var setSelectionOn = function (input, f) {
      var el = input.element;
      var value = get$5(el);
      var node = el.dom;
      if (get$d(el, 'type') !== 'number') {
        f(node, value);
      }
    };
    var setCursorAtEnd = function (input) {
      setSelectionOn(input, function (node, value) {
        return node.setSelectionRange(value.length, value.length);
      });
    };
    var setSelectionToEnd = function (input, startOffset) {
      setSelectionOn(input, function (node, value) {
        return node.setSelectionRange(startOffset, value.length);
      });
    };
    var attemptSelectOver = function (model, input, item) {
      if (!model.selectsOver) {
        return Optional.none();
      } else {
        var currentValue = Representing.getValue(input);
        var inputDisplay_1 = model.getDisplayText(currentValue);
        var itemValue = Representing.getValue(item);
        var itemDisplay = model.getDisplayText(itemValue);
        return itemDisplay.indexOf(inputDisplay_1) === 0 ? Optional.some(function () {
          setValueFromItem(model, input, item);
          setSelectionToEnd(input, inputDisplay_1.length);
        }) : Optional.none();
      }
    };

    var itemExecute = constant$1('alloy.typeahead.itemexecute');

    var make$3 = function (detail, components, spec, externals) {
      var navigateList = function (comp, simulatedEvent, highlighter) {
        detail.previewing.set(false);
        var sandbox = Coupling.getCoupled(comp, 'sandbox');
        if (Sandboxing.isOpen(sandbox)) {
          Composing.getCurrent(sandbox).each(function (menu) {
            Highlighting.getHighlighted(menu).fold(function () {
              highlighter(menu);
            }, function () {
              dispatchEvent(sandbox, menu.element, 'keydown', simulatedEvent);
            });
          });
        } else {
          var onOpenSync = function (sandbox) {
            Composing.getCurrent(sandbox).each(highlighter);
          };
          open(detail, mapFetch(comp), comp, sandbox, externals, onOpenSync, HighlightOnOpen.HighlightFirst).get(noop);
        }
      };
      var focusBehaviours$1 = focusBehaviours(detail);
      var mapFetch = function (comp) {
        return function (tdata) {
          return tdata.map(function (data) {
            var menus = values(data.menus);
            var items = bind$3(menus, function (menu) {
              return filter$2(menu.items, function (item) {
                return item.type === 'item';
              });
            });
            var repState = Representing.getState(comp);
            repState.update(map$2(items, function (item) {
              return item.data;
            }));
            return data;
          });
        };
      };
      var behaviours = [
        Focusing.config({}),
        Representing.config({
          onSetValue: detail.onSetValue,
          store: __assign({
            mode: 'dataset',
            getDataKey: function (comp) {
              return get$5(comp.element);
            },
            getFallbackEntry: function (itemString) {
              return {
                value: itemString,
                meta: {}
              };
            },
            setValue: function (comp, data) {
              set$4(comp.element, detail.model.getDisplayText(data));
            }
          }, detail.initialData.map(function (d) {
            return wrap$1('initialValue', d);
          }).getOr({}))
        }),
        Streaming.config({
          stream: {
            mode: 'throttle',
            delay: detail.responseTime,
            stopEvent: false
          },
          onStream: function (component, _simulatedEvent) {
            var sandbox = Coupling.getCoupled(component, 'sandbox');
            var focusInInput = Focusing.isFocused(component);
            if (focusInInput) {
              if (get$5(component.element).length >= detail.minChars) {
                var previousValue_1 = Composing.getCurrent(sandbox).bind(function (menu) {
                  return Highlighting.getHighlighted(menu).map(Representing.getValue);
                });
                detail.previewing.set(true);
                var onOpenSync = function (_sandbox) {
                  Composing.getCurrent(sandbox).each(function (menu) {
                    previousValue_1.fold(function () {
                      if (detail.model.selectsOver) {
                        Highlighting.highlightFirst(menu);
                      }
                    }, function (pv) {
                      Highlighting.highlightBy(menu, function (item) {
                        var itemData = Representing.getValue(item);
                        return itemData.value === pv.value;
                      });
                      Highlighting.getHighlighted(menu).orThunk(function () {
                        Highlighting.highlightFirst(menu);
                        return Optional.none();
                      });
                    });
                  });
                };
                open(detail, mapFetch(component), component, sandbox, externals, onOpenSync, HighlightOnOpen.HighlightFirst).get(noop);
              }
            }
          },
          cancelEvent: typeaheadCancel()
        }),
        Keying.config({
          mode: 'special',
          onDown: function (comp, simulatedEvent) {
            navigateList(comp, simulatedEvent, Highlighting.highlightFirst);
            return Optional.some(true);
          },
          onEscape: function (comp) {
            var sandbox = Coupling.getCoupled(comp, 'sandbox');
            if (Sandboxing.isOpen(sandbox)) {
              Sandboxing.close(sandbox);
              return Optional.some(true);
            }
            return Optional.none();
          },
          onUp: function (comp, simulatedEvent) {
            navigateList(comp, simulatedEvent, Highlighting.highlightLast);
            return Optional.some(true);
          },
          onEnter: function (comp) {
            var sandbox = Coupling.getCoupled(comp, 'sandbox');
            var sandboxIsOpen = Sandboxing.isOpen(sandbox);
            if (sandboxIsOpen && !detail.previewing.get()) {
              return Composing.getCurrent(sandbox).bind(function (menu) {
                return Highlighting.getHighlighted(menu);
              }).map(function (item) {
                emitWith(comp, itemExecute(), { item: item });
                return true;
              });
            } else {
              var currentValue = Representing.getValue(comp);
              emit(comp, typeaheadCancel());
              detail.onExecute(sandbox, comp, currentValue);
              if (sandboxIsOpen) {
                Sandboxing.close(sandbox);
              }
              return Optional.some(true);
            }
          }
        }),
        Toggling.config({
          toggleClass: detail.markers.openClass,
          aria: { mode: 'expanded' }
        }),
        Coupling.config({
          others: {
            sandbox: function (hotspot) {
              return makeSandbox$1(detail, hotspot, {
                onOpen: function () {
                  return Toggling.on(hotspot);
                },
                onClose: function () {
                  return Toggling.off(hotspot);
                }
              });
            }
          }
        }),
        config('typeaheadevents', [
          runOnExecute$1(function (comp) {
            var onOpenSync = noop;
            togglePopup(detail, mapFetch(comp), comp, externals, onOpenSync, HighlightOnOpen.HighlightFirst).get(noop);
          }),
          run$1(itemExecute(), function (comp, se) {
            var sandbox = Coupling.getCoupled(comp, 'sandbox');
            setValueFromItem(detail.model, comp, se.event.item);
            emit(comp, typeaheadCancel());
            detail.onItemExecute(comp, sandbox, se.event.item, Representing.getValue(comp));
            Sandboxing.close(sandbox);
            setCursorAtEnd(comp);
          })
        ].concat(detail.dismissOnBlur ? [run$1(postBlur(), function (typeahead) {
            var sandbox = Coupling.getCoupled(typeahead, 'sandbox');
            if (search(sandbox.element).isNone()) {
              Sandboxing.close(sandbox);
            }
          })] : []))
      ];
      return {
        uid: detail.uid,
        dom: dom(deepMerge(detail, {
          inputAttributes: {
            'role': 'combobox',
            'aria-autocomplete': 'list',
            'aria-haspopup': 'true'
          }
        })),
        behaviours: __assign(__assign({}, focusBehaviours$1), augment(detail.typeaheadBehaviours, behaviours)),
        eventOrder: detail.eventOrder
      };
    };

    var schema$g = constant$1([
      option('lazySink'),
      required$1('fetch'),
      defaulted('minChars', 5),
      defaulted('responseTime', 1000),
      onHandler('onOpen'),
      defaulted('getHotspot', Optional.some),
      defaulted('getAnchorOverrides', constant$1({})),
      defaulted('layouts', Optional.none()),
      defaulted('eventOrder', {}),
      defaultedObjOf('model', {}, [
        defaulted('getDisplayText', function (itemData) {
          return itemData.meta !== undefined && itemData.meta.text !== undefined ? itemData.meta.text : itemData.value;
        }),
        defaulted('selectsOver', true),
        defaulted('populateFromBrowse', true)
      ]),
      onHandler('onSetValue'),
      onKeyboardHandler('onExecute'),
      onHandler('onItemExecute'),
      defaulted('inputClasses', []),
      defaulted('inputAttributes', {}),
      defaulted('inputStyles', {}),
      defaulted('matchWidth', true),
      defaulted('useMinWidth', false),
      defaulted('dismissOnBlur', true),
      markers$1(['openClass']),
      option('initialData'),
      field('typeaheadBehaviours', [
        Focusing,
        Representing,
        Streaming,
        Keying,
        Toggling,
        Coupling
      ]),
      customField('previewing', function () {
        return Cell(true);
      })
    ].concat(schema$k()).concat(sandboxFields()));
    var parts$b = constant$1([external$1({
        schema: [tieredMenuMarkers()],
        name: 'menu',
        overrides: function (detail) {
          return {
            fakeFocus: true,
            onHighlight: function (menu, item) {
              if (!detail.previewing.get()) {
                menu.getSystem().getByUid(detail.uid).each(function (input) {
                  if (detail.model.populateFromBrowse) {
                    setValueFromItem(detail.model, input, item);
                  }
                });
              } else {
                menu.getSystem().getByUid(detail.uid).each(function (input) {
                  attemptSelectOver(detail.model, input, item).fold(function () {
                    return Highlighting.dehighlight(menu, item);
                  }, function (fn) {
                    return fn();
                  });
                });
              }
              detail.previewing.set(false);
            },
            onExecute: function (menu, item) {
              return menu.getSystem().getByUid(detail.uid).toOptional().map(function (typeahead) {
                emitWith(typeahead, itemExecute(), { item: item });
                return true;
              });
            },
            onHover: function (menu, item) {
              detail.previewing.set(false);
              menu.getSystem().getByUid(detail.uid).each(function (input) {
                if (detail.model.populateFromBrowse) {
                  setValueFromItem(detail.model, input, item);
                }
              });
            }
          };
        }
      })]);

    var Typeahead = composite({
      name: 'Typeahead',
      configFields: schema$g(),
      partFields: parts$b(),
      factory: make$3
    });

    var wrap = function (delegate) {
      var toCached = function () {
        return wrap(delegate.toCached());
      };
      var bindFuture = function (f) {
        return wrap(delegate.bind(function (resA) {
          return resA.fold(function (err) {
            return Future.pure(Result.error(err));
          }, function (a) {
            return f(a);
          });
        }));
      };
      var bindResult = function (f) {
        return wrap(delegate.map(function (resA) {
          return resA.bind(f);
        }));
      };
      var mapResult = function (f) {
        return wrap(delegate.map(function (resA) {
          return resA.map(f);
        }));
      };
      var mapError = function (f) {
        return wrap(delegate.map(function (resA) {
          return resA.mapError(f);
        }));
      };
      var foldResult = function (whenError, whenValue) {
        return delegate.map(function (res) {
          return res.fold(whenError, whenValue);
        });
      };
      var withTimeout = function (timeout, errorThunk) {
        return wrap(Future.nu(function (callback) {
          var timedOut = false;
          var timer = setTimeout(function () {
            timedOut = true;
            callback(Result.error(errorThunk()));
          }, timeout);
          delegate.get(function (result) {
            if (!timedOut) {
              clearTimeout(timer);
              callback(result);
            }
          });
        }));
      };
      return __assign(__assign({}, delegate), {
        toCached: toCached,
        bindFuture: bindFuture,
        bindResult: bindResult,
        mapResult: mapResult,
        mapError: mapError,
        foldResult: foldResult,
        withTimeout: withTimeout
      });
    };
    var nu$1 = function (worker) {
      return wrap(Future.nu(worker));
    };
    var value = function (value) {
      return wrap(Future.pure(Result.value(value)));
    };
    var error = function (error) {
      return wrap(Future.pure(Result.error(error)));
    };
    var fromResult = function (result) {
      return wrap(Future.pure(result));
    };
    var fromFuture = function (future) {
      return wrap(future.map(Result.value));
    };
    var fromPromise = function (promise) {
      return nu$1(function (completer) {
        promise.then(function (value) {
          completer(Result.value(value));
        }, function (error) {
          completer(Result.error(error));
        });
      });
    };
    var FutureResult = {
      nu: nu$1,
      wrap: wrap,
      pure: value,
      value: value,
      error: error,
      fromResult: fromResult,
      fromFuture: fromFuture,
      fromPromise: fromPromise
    };

    var separator$1 = { type: 'separator' };
    var toMenuItem = function (target) {
      return {
        type: 'menuitem',
        value: target.url,
        text: target.title,
        meta: { attach: target.attach },
        onAction: noop
      };
    };
    var staticMenuItem = function (title, url) {
      return {
        type: 'menuitem',
        value: url,
        text: title,
        meta: { attach: undefined },
        onAction: noop
      };
    };
    var toMenuItems = function (targets) {
      return map$2(targets, toMenuItem);
    };
    var filterLinkTargets = function (type, targets) {
      return filter$2(targets, function (target) {
        return target.type === type;
      });
    };
    var filteredTargets = function (type, targets) {
      return toMenuItems(filterLinkTargets(type, targets));
    };
    var headerTargets = function (linkInfo) {
      return filteredTargets('header', linkInfo.targets);
    };
    var anchorTargets = function (linkInfo) {
      return filteredTargets('anchor', linkInfo.targets);
    };
    var anchorTargetTop = function (linkInfo) {
      return Optional.from(linkInfo.anchorTop).map(function (url) {
        return staticMenuItem('<top>', url);
      }).toArray();
    };
    var anchorTargetBottom = function (linkInfo) {
      return Optional.from(linkInfo.anchorBottom).map(function (url) {
        return staticMenuItem('<bottom>', url);
      }).toArray();
    };
    var historyTargets = function (history) {
      return map$2(history, function (url) {
        return staticMenuItem(url, url);
      });
    };
    var joinMenuLists = function (items) {
      return foldl(items, function (a, b) {
        var bothEmpty = a.length === 0 || b.length === 0;
        return bothEmpty ? a.concat(b) : a.concat(separator$1, b);
      }, []);
    };
    var filterByQuery = function (term, menuItems) {
      var lowerCaseTerm = term.toLowerCase();
      return filter$2(menuItems, function (item) {
        var text = item.meta !== undefined && item.meta.text !== undefined ? item.meta.text : item.text;
        return contains$1(text.toLowerCase(), lowerCaseTerm) || contains$1(item.value.toLowerCase(), lowerCaseTerm);
      });
    };

    var getItems = function (fileType, input, urlBackstage) {
      var urlInputValue = Representing.getValue(input);
      var term = urlInputValue.meta.text !== undefined ? urlInputValue.meta.text : urlInputValue.value;
      var info = urlBackstage.getLinkInformation();
      return info.fold(function () {
        return [];
      }, function (linkInfo) {
        var history = filterByQuery(term, historyTargets(urlBackstage.getHistory(fileType)));
        return fileType === 'file' ? joinMenuLists([
          history,
          filterByQuery(term, headerTargets(linkInfo)),
          filterByQuery(term, flatten([
            anchorTargetTop(linkInfo),
            anchorTargets(linkInfo),
            anchorTargetBottom(linkInfo)
          ]))
        ]) : history;
      });
    };
    var errorId = generate$6('aria-invalid');
    var renderUrlInput = function (spec, backstage, urlBackstage) {
      var _a;
      var providersBackstage = backstage.shared.providers;
      var updateHistory = function (component) {
        var urlEntry = Representing.getValue(component);
        urlBackstage.addToHistory(urlEntry.value, spec.filetype);
      };
      var pField = FormField.parts.field({
        factory: Typeahead,
        dismissOnBlur: true,
        inputClasses: ['tox-textfield'],
        sandboxClasses: ['tox-dialog__popups'],
        inputAttributes: {
          'aria-errormessage': errorId,
          'type': 'url'
        },
        minChars: 0,
        responseTime: 0,
        fetch: function (input) {
          var items = getItems(spec.filetype, input, urlBackstage);
          var tdata = build(items, ItemResponse$1.BUBBLE_TO_SANDBOX, backstage, false);
          return Future.pure(tdata);
        },
        getHotspot: function (comp) {
          return memUrlBox.getOpt(comp);
        },
        onSetValue: function (comp, _newValue) {
          if (comp.hasConfigured(Invalidating)) {
            Invalidating.run(comp).get(noop);
          }
        },
        typeaheadBehaviours: derive$1(flatten([
          urlBackstage.getValidationHandler().map(function (handler) {
            return Invalidating.config({
              getRoot: function (comp) {
                return parent(comp.element);
              },
              invalidClass: 'tox-control-wrap--status-invalid',
              notify: {
                onInvalid: function (comp, err) {
                  memInvalidIcon.getOpt(comp).each(function (invalidComp) {
                    set$8(invalidComp.element, 'title', providersBackstage.translate(err));
                  });
                }
              },
              validator: {
                validate: function (input) {
                  var urlEntry = Representing.getValue(input);
                  return FutureResult.nu(function (completer) {
                    handler({
                      type: spec.filetype,
                      url: urlEntry.value
                    }, function (validation) {
                      if (validation.status === 'invalid') {
                        var err = Result.error(validation.message);
                        completer(err);
                      } else {
                        var val = Result.value(validation.message);
                        completer(val);
                      }
                    });
                  });
                },
                validateOnLoad: false
              }
            });
          }).toArray(),
          [
            Disabling.config({
              disabled: function () {
                return spec.disabled || providersBackstage.isDisabled();
              }
            }),
            Tabstopping.config({}),
            config('urlinput-events', flatten([
              spec.filetype === 'file' ? [run$1(input(), function (comp) {
                  emitWith(comp, formChangeEvent, { name: spec.name });
                })] : [],
              [
                run$1(change(), function (comp) {
                  emitWith(comp, formChangeEvent, { name: spec.name });
                  updateHistory(comp);
                }),
                run$1(postPaste(), function (comp) {
                  emitWith(comp, formChangeEvent, { name: spec.name });
                  updateHistory(comp);
                })
              ]
            ]))
          ]
        ])),
        eventOrder: (_a = {}, _a[input()] = [
          'streaming',
          'urlinput-events',
          'invalidating'
        ], _a),
        model: {
          getDisplayText: function (itemData) {
            return itemData.value;
          },
          selectsOver: false,
          populateFromBrowse: false
        },
        markers: { openClass: 'tox-textfield--popup-open' },
        lazySink: backstage.shared.getSink,
        parts: { menu: part(false, 1, 'normal') },
        onExecute: function (_menu, component, _entry) {
          emitWith(component, formSubmitEvent, {});
        },
        onItemExecute: function (typeahead, _sandbox, _item, _value) {
          updateHistory(typeahead);
          emitWith(typeahead, formChangeEvent, { name: spec.name });
        }
      });
      var pLabel = spec.label.map(function (label) {
        return renderLabel$2(label, providersBackstage);
      });
      var makeIcon = function (name, errId, icon, label) {
        if (icon === void 0) {
          icon = name;
        }
        if (label === void 0) {
          label = name;
        }
        return render$3(icon, {
          tag: 'div',
          classes: [
            'tox-icon',
            'tox-control-wrap__status-icon-' + name
          ],
          attributes: __assign({
            'title': providersBackstage.translate(label),
            'aria-live': 'polite'
          }, errId.fold(function () {
            return {};
          }, function (id) {
            return { id: id };
          }))
        }, providersBackstage.icons);
      };
      var memInvalidIcon = record(makeIcon('invalid', Optional.some(errorId), 'warning'));
      var memStatus = record({
        dom: {
          tag: 'div',
          classes: ['tox-control-wrap__status-icon-wrap']
        },
        components: [memInvalidIcon.asSpec()]
      });
      var optUrlPicker = urlBackstage.getUrlPicker(spec.filetype);
      var browseUrlEvent = generate$6('browser.url.event');
      var memUrlBox = record({
        dom: {
          tag: 'div',
          classes: ['tox-control-wrap']
        },
        components: [
          pField,
          memStatus.asSpec()
        ],
        behaviours: derive$1([Disabling.config({
            disabled: function () {
              return spec.disabled || providersBackstage.isDisabled();
            }
          })])
      });
      var memUrlPickerButton = record(renderButton({
        name: spec.name,
        icon: Optional.some('browse'),
        text: spec.label.getOr(''),
        disabled: spec.disabled,
        primary: false,
        borderless: true
      }, function (component) {
        return emit(component, browseUrlEvent);
      }, providersBackstage, [], ['tox-browse-url']));
      var controlHWrapper = function () {
        return {
          dom: {
            tag: 'div',
            classes: ['tox-form__controls-h-stack']
          },
          components: flatten([
            [memUrlBox.asSpec()],
            optUrlPicker.map(function () {
              return memUrlPickerButton.asSpec();
            }).toArray()
          ])
        };
      };
      var openUrlPicker = function (comp) {
        Composing.getCurrent(comp).each(function (field) {
          var componentData = Representing.getValue(field);
          var urlData = __assign({ fieldname: spec.name }, componentData);
          optUrlPicker.each(function (picker) {
            picker(urlData).get(function (chosenData) {
              Representing.setValue(field, chosenData);
              emitWith(comp, formChangeEvent, { name: spec.name });
            });
          });
        });
      };
      return FormField.sketch({
        dom: renderFormFieldDom(),
        components: pLabel.toArray().concat([controlHWrapper()]),
        fieldBehaviours: derive$1([
          Disabling.config({
            disabled: function () {
              return spec.disabled || providersBackstage.isDisabled();
            },
            onDisabled: function (comp) {
              FormField.getField(comp).each(Disabling.disable);
              memUrlPickerButton.getOpt(comp).each(Disabling.disable);
            },
            onEnabled: function (comp) {
              FormField.getField(comp).each(Disabling.enable);
              memUrlPickerButton.getOpt(comp).each(Disabling.enable);
            }
          }),
          receivingConfig(),
          config('url-input-events', [run$1(browseUrlEvent, openUrlPicker)])
        ])
      });
    };

    var renderAlertBanner = function (spec, providersBackstage) {
      return Container.sketch({
        dom: {
          tag: 'div',
          attributes: { role: 'alert' },
          classes: [
            'tox-notification',
            'tox-notification--in',
            'tox-notification--' + spec.level
          ]
        },
        components: [
          {
            dom: {
              tag: 'div',
              classes: ['tox-notification__icon']
            },
            components: [Button.sketch({
                dom: {
                  tag: 'button',
                  classes: [
                    'tox-button',
                    'tox-button--naked',
                    'tox-button--icon'
                  ],
                  innerHtml: get$1(spec.icon, providersBackstage.icons),
                  attributes: { title: providersBackstage.translate(spec.iconTooltip) }
                },
                action: function (comp) {
                  emitWith(comp, formActionEvent, {
                    name: 'alert-banner',
                    value: spec.url
                  });
                },
                buttonBehaviours: derive$1([addFocusableBehaviour()])
              })]
          },
          {
            dom: {
              tag: 'div',
              classes: ['tox-notification__body'],
              innerHtml: providersBackstage.translate(spec.text)
            }
          }
        ]
      });
    };

    var renderCheckbox = function (spec, providerBackstage) {
      var repBehaviour = Representing.config({
        store: {
          mode: 'manual',
          getValue: function (comp) {
            var el = comp.element.dom;
            return el.checked;
          },
          setValue: function (comp, value) {
            var el = comp.element.dom;
            el.checked = value;
          }
        }
      });
      var toggleCheckboxHandler = function (comp) {
        comp.element.dom.click();
        return Optional.some(true);
      };
      var pField = FormField.parts.field({
        factory: { sketch: identity$1 },
        dom: {
          tag: 'input',
          classes: ['tox-checkbox__input'],
          attributes: { type: 'checkbox' }
        },
        behaviours: derive$1([
          ComposingConfigs.self(),
          Disabling.config({
            disabled: function () {
              return spec.disabled || providerBackstage.isDisabled();
            }
          }),
          Tabstopping.config({}),
          Focusing.config({}),
          repBehaviour,
          Keying.config({
            mode: 'special',
            onEnter: toggleCheckboxHandler,
            onSpace: toggleCheckboxHandler,
            stopSpaceKeyup: true
          }),
          config('checkbox-events', [run$1(change(), function (component, _) {
              emitWith(component, formChangeEvent, { name: spec.name });
            })])
        ])
      });
      var pLabel = FormField.parts.label({
        dom: {
          tag: 'span',
          classes: ['tox-checkbox__label'],
          innerHtml: providerBackstage.translate(spec.label)
        },
        behaviours: derive$1([Unselecting.config({})])
      });
      var makeIcon = function (className) {
        var iconName = className === 'checked' ? 'selected' : 'unselected';
        return render$3(iconName, {
          tag: 'span',
          classes: [
            'tox-icon',
            'tox-checkbox-icon__' + className
          ]
        }, providerBackstage.icons);
      };
      var memIcons = record({
        dom: {
          tag: 'div',
          classes: ['tox-checkbox__icons']
        },
        components: [
          makeIcon('checked'),
          makeIcon('unchecked')
        ]
      });
      return FormField.sketch({
        dom: {
          tag: 'label',
          classes: ['tox-checkbox']
        },
        components: [
          pField,
          memIcons.asSpec(),
          pLabel
        ],
        fieldBehaviours: derive$1([
          Disabling.config({
            disabled: function () {
              return spec.disabled || providerBackstage.isDisabled();
            },
            disableClass: 'tox-checkbox--disabled',
            onDisabled: function (comp) {
              FormField.getField(comp).each(Disabling.disable);
            },
            onEnabled: function (comp) {
              FormField.getField(comp).each(Disabling.enable);
            }
          }),
          receivingConfig()
        ])
      });
    };

    var renderHtmlPanel = function (spec) {
      if (spec.presets === 'presentation') {
        return Container.sketch({
          dom: {
            tag: 'div',
            classes: ['tox-form__group'],
            innerHtml: spec.html
          }
        });
      } else {
        return Container.sketch({
          dom: {
            tag: 'div',
            classes: ['tox-form__group'],
            innerHtml: spec.html,
            attributes: { role: 'document' }
          },
          containerBehaviours: derive$1([
            Tabstopping.config({}),
            Focusing.config({})
          ])
        });
      }
    };

    var make$2 = function (render) {
      return function (parts, spec, backstage) {
        return get$e(spec, 'name').fold(function () {
          return render(spec, backstage);
        }, function (fieldName) {
          return parts.field(fieldName, render(spec, backstage));
        });
      };
    };
    var makeIframe = function (render) {
      return function (parts, spec, backstage) {
        var iframeSpec = deepMerge(spec, { source: 'dynamic' });
        return make$2(render)(parts, iframeSpec, backstage);
      };
    };
    var factories = {
      bar: make$2(function (spec, backstage) {
        return renderBar(spec, backstage.shared);
      }),
      collection: make$2(function (spec, backstage) {
        return renderCollection(spec, backstage.shared.providers);
      }),
      alertbanner: make$2(function (spec, backstage) {
        return renderAlertBanner(spec, backstage.shared.providers);
      }),
      input: make$2(function (spec, backstage) {
        return renderInput(spec, backstage.shared.providers);
      }),
      textarea: make$2(function (spec, backstage) {
        return renderTextarea(spec, backstage.shared.providers);
      }),
      label: make$2(function (spec, backstage) {
        return renderLabel(spec, backstage.shared);
      }),
      iframe: makeIframe(function (spec, backstage) {
        return renderIFrame(spec, backstage.shared.providers);
      }),
      button: make$2(function (spec, backstage) {
        return renderDialogButton(spec, backstage.shared.providers);
      }),
      checkbox: make$2(function (spec, backstage) {
        return renderCheckbox(spec, backstage.shared.providers);
      }),
      colorinput: make$2(function (spec, backstage) {
        return renderColorInput(spec, backstage.shared, backstage.colorinput);
      }),
      colorpicker: make$2(renderColorPicker),
      dropzone: make$2(function (spec, backstage) {
        return renderDropZone(spec, backstage.shared.providers);
      }),
      grid: make$2(function (spec, backstage) {
        return renderGrid(spec, backstage.shared);
      }),
      listbox: make$2(function (spec, backstage) {
        return renderListBox(spec, backstage);
      }),
      selectbox: make$2(function (spec, backstage) {
        return renderSelectBox(spec, backstage.shared.providers);
      }),
      sizeinput: make$2(function (spec, backstage) {
        return renderSizeInput(spec, backstage.shared.providers);
      }),
      urlinput: make$2(function (spec, backstage) {
        return renderUrlInput(spec, backstage, backstage.urlinput);
      }),
      customeditor: make$2(renderCustomEditor),
      htmlpanel: make$2(renderHtmlPanel),
      imagetools: make$2(function (spec, backstage) {
        return renderImageTools(spec, backstage.shared.providers);
      }),
      table: make$2(function (spec, backstage) {
        return renderTable(spec, backstage.shared.providers);
      }),
      panel: make$2(function (spec, backstage) {
        return renderPanel(spec, backstage);
      })
    };
    var noFormParts = {
      field: function (_name, spec) {
        return spec;
      }
    };
    var interpretInForm = function (parts, spec, oldBackstage) {
      var newBackstage = deepMerge(oldBackstage, {
        shared: {
          interpreter: function (childSpec) {
            return interpretParts(parts, childSpec, newBackstage);
          }
        }
      });
      return interpretParts(parts, spec, newBackstage);
    };
    var interpretParts = function (parts, spec, backstage) {
      return get$e(factories, spec.type).fold(function () {
        console.error('Unknown factory type "' + spec.type + '", defaulting to container: ', spec);
        return spec;
      }, function (factory) {
        return factory(parts, spec, backstage);
      });
    };
    var interpretWithoutForm = function (spec, backstage) {
      var parts = noFormParts;
      return interpretParts(parts, spec, backstage);
    };

    var bubbleAlignments$2 = {
      valignCentre: [],
      alignCentre: [],
      alignLeft: [],
      alignRight: [],
      right: [],
      left: [],
      bottom: [],
      top: []
    };
    var getInlineDialogAnchor = function (contentAreaElement, lazyAnchorbar, lazyUseEditableAreaAnchor) {
      var bubbleSize = 12;
      var overrides = { maxHeightFunction: expandable$1() };
      var editableAreaAnchor = function () {
        return {
          type: 'node',
          root: getContentContainer(contentAreaElement()),
          node: Optional.from(contentAreaElement()),
          bubble: nu$5(bubbleSize, bubbleSize, bubbleAlignments$2),
          layouts: {
            onRtl: function () {
              return [northeast];
            },
            onLtr: function () {
              return [northwest];
            }
          },
          overrides: overrides
        };
      };
      var standardAnchor = function () {
        return {
          type: 'hotspot',
          hotspot: lazyAnchorbar(),
          bubble: nu$5(-bubbleSize, bubbleSize, bubbleAlignments$2),
          layouts: {
            onRtl: function () {
              return [southeast$2];
            },
            onLtr: function () {
              return [southwest$2];
            }
          },
          overrides: overrides
        };
      };
      return function () {
        return lazyUseEditableAreaAnchor() ? editableAreaAnchor() : standardAnchor();
      };
    };
    var getBannerAnchor = function (contentAreaElement, lazyAnchorbar, lazyUseEditableAreaAnchor) {
      var editableAreaAnchor = function () {
        return {
          type: 'node',
          root: getContentContainer(contentAreaElement()),
          node: Optional.from(contentAreaElement()),
          layouts: {
            onRtl: function () {
              return [north];
            },
            onLtr: function () {
              return [north];
            }
          }
        };
      };
      var standardAnchor = function () {
        return {
          type: 'hotspot',
          hotspot: lazyAnchorbar(),
          layouts: {
            onRtl: function () {
              return [south$2];
            },
            onLtr: function () {
              return [south$2];
            }
          }
        };
      };
      return function () {
        return lazyUseEditableAreaAnchor() ? editableAreaAnchor() : standardAnchor();
      };
    };
    var getCursorAnchor = function (editor, bodyElement) {
      return function () {
        return {
          type: 'selection',
          root: bodyElement(),
          getSelection: function () {
            var rng = editor.selection.getRng();
            return Optional.some(SimSelection.range(SugarElement.fromDom(rng.startContainer), rng.startOffset, SugarElement.fromDom(rng.endContainer), rng.endOffset));
          }
        };
      };
    };
    var getNodeAnchor$1 = function (bodyElement) {
      return function (element) {
        return {
          type: 'node',
          root: bodyElement(),
          node: element
        };
      };
    };
    var getAnchors = function (editor, lazyAnchorbar, isToolbarTop) {
      var useFixedToolbarContainer = useFixedContainer(editor);
      var bodyElement = function () {
        return SugarElement.fromDom(editor.getBody());
      };
      var contentAreaElement = function () {
        return SugarElement.fromDom(editor.getContentAreaContainer());
      };
      var lazyUseEditableAreaAnchor = function () {
        return useFixedToolbarContainer || !isToolbarTop();
      };
      return {
        inlineDialog: getInlineDialogAnchor(contentAreaElement, lazyAnchorbar, lazyUseEditableAreaAnchor),
        banner: getBannerAnchor(contentAreaElement, lazyAnchorbar, lazyUseEditableAreaAnchor),
        cursor: getCursorAnchor(editor, bodyElement),
        node: getNodeAnchor$1(bodyElement)
      };
    };

    var colorPicker = function (editor) {
      return function (callback, value) {
        var dialog = colorPickerDialog(editor);
        dialog(callback, value);
      };
    };
    var hasCustomColors = function (editor) {
      return function () {
        return hasCustomColors$1(editor);
      };
    };
    var getColors = function (editor) {
      return function () {
        return getColors$2(editor);
      };
    };
    var getColorCols = function (editor) {
      return function () {
        return getColorCols$1(editor);
      };
    };
    var ColorInputBackstage = function (editor) {
      return {
        colorPicker: colorPicker(editor),
        hasCustomColors: hasCustomColors(editor),
        getColors: getColors(editor),
        getColorCols: getColorCols(editor)
      };
    };

    var isDraggableModal = function (editor) {
      return function () {
        return isDraggableModal$1(editor);
      };
    };
    var DialogBackstage = function (editor) {
      return { isDraggableModal: isDraggableModal(editor) };
    };

    var HeaderBackstage = function (editor) {
      var mode = Cell(isToolbarLocationBottom(editor) ? 'bottom' : 'top');
      return {
        isPositionedAtTop: function () {
          return mode.get() === 'top';
        },
        getDockingMode: mode.get,
        setDockingMode: mode.set
      };
    };

    var defaultStyleFormats = [
      {
        title: 'Headings',
        items: [
          {
            title: 'Heading 1',
            format: 'h1'
          },
          {
            title: 'Heading 2',
            format: 'h2'
          },
          {
            title: 'Heading 3',
            format: 'h3'
          },
          {
            title: 'Heading 4',
            format: 'h4'
          },
          {
            title: 'Heading 5',
            format: 'h5'
          },
          {
            title: 'Heading 6',
            format: 'h6'
          }
        ]
      },
      {
        title: 'Inline',
        items: [
          {
            title: 'Bold',
            format: 'bold'
          },
          {
            title: 'Italic',
            format: 'italic'
          },
          {
            title: 'Underline',
            format: 'underline'
          },
          {
            title: 'Strikethrough',
            format: 'strikethrough'
          },
          {
            title: 'Superscript',
            format: 'superscript'
          },
          {
            title: 'Subscript',
            format: 'subscript'
          },
          {
            title: 'Code',
            format: 'code'
          }
        ]
      },
      {
        title: 'Blocks',
        items: [
          {
            title: 'Paragraph',
            format: 'p'
          },
          {
            title: 'Blockquote',
            format: 'blockquote'
          },
          {
            title: 'Div',
            format: 'div'
          },
          {
            title: 'Pre',
            format: 'pre'
          }
        ]
      },
      {
        title: 'Align',
        items: [
          {
            title: 'Left',
            format: 'alignleft'
          },
          {
            title: 'Center',
            format: 'aligncenter'
          },
          {
            title: 'Right',
            format: 'alignright'
          },
          {
            title: 'Justify',
            format: 'alignjustify'
          }
        ]
      }
    ];
    var isNestedFormat = function (format) {
      return has$2(format, 'items');
    };
    var isBlockFormat = function (format) {
      return has$2(format, 'block');
    };
    var isInlineFormat = function (format) {
      return has$2(format, 'inline');
    };
    var isSelectorFormat = function (format) {
      return has$2(format, 'selector');
    };
    var mapFormats = function (userFormats) {
      return foldl(userFormats, function (acc, fmt) {
        if (isNestedFormat(fmt)) {
          var result = mapFormats(fmt.items);
          return {
            customFormats: acc.customFormats.concat(result.customFormats),
            formats: acc.formats.concat([{
                title: fmt.title,
                items: result.formats
              }])
          };
        } else if (isInlineFormat(fmt) || isBlockFormat(fmt) || isSelectorFormat(fmt)) {
          var formatName = isString(fmt.name) ? fmt.name : fmt.title.toLowerCase();
          var formatNameWithPrefix = 'custom-' + formatName;
          return {
            customFormats: acc.customFormats.concat([{
                name: formatNameWithPrefix,
                format: fmt
              }]),
            formats: acc.formats.concat([{
                title: fmt.title,
                format: formatNameWithPrefix,
                icon: fmt.icon
              }])
          };
        } else {
          return __assign(__assign({}, acc), { formats: acc.formats.concat(fmt) });
        }
      }, {
        customFormats: [],
        formats: []
      });
    };
    var registerCustomFormats = function (editor, userFormats) {
      var result = mapFormats(userFormats);
      var registerFormats = function (customFormats) {
        each$1(customFormats, function (fmt) {
          if (!editor.formatter.has(fmt.name)) {
            editor.formatter.register(fmt.name, fmt.format);
          }
        });
      };
      if (editor.formatter) {
        registerFormats(result.customFormats);
      } else {
        editor.on('init', function () {
          registerFormats(result.customFormats);
        });
      }
      return result.formats;
    };
    var getStyleFormats = function (editor) {
      return getUserStyleFormats(editor).map(function (userFormats) {
        var registeredUserFormats = registerCustomFormats(editor, userFormats);
        return isMergeStyleFormats(editor) ? defaultStyleFormats.concat(registeredUserFormats) : registeredUserFormats;
      }).getOr(defaultStyleFormats);
    };

    var processBasic = function (item, isSelectedFor, getPreviewFor) {
      var formatterSpec = {
        type: 'formatter',
        isSelected: isSelectedFor(item.format),
        getStylePreview: getPreviewFor(item.format)
      };
      return deepMerge(item, formatterSpec);
    };
    var register$8 = function (editor, formats, isSelectedFor, getPreviewFor) {
      var enrichSupported = function (item) {
        return processBasic(item, isSelectedFor, getPreviewFor);
      };
      var enrichMenu = function (item) {
        var submenuSpec = { type: 'submenu' };
        return deepMerge(item, submenuSpec);
      };
      var enrichCustom = function (item) {
        var formatName = isString(item.name) ? item.name : generate$6(item.title);
        var formatNameWithPrefix = 'custom-' + formatName;
        var customSpec = {
          type: 'formatter',
          format: formatNameWithPrefix,
          isSelected: isSelectedFor(formatNameWithPrefix),
          getStylePreview: getPreviewFor(formatNameWithPrefix)
        };
        var newItem = deepMerge(item, customSpec);
        editor.formatter.register(formatName, newItem);
        return newItem;
      };
      var doEnrich = function (items) {
        return map$2(items, function (item) {
          var keys$1 = keys(item);
          if (hasNonNullableKey(item, 'items')) {
            var newItems = doEnrich(item.items);
            return deepMerge(enrichMenu(item), { getStyleItems: constant$1(newItems) });
          } else if (hasNonNullableKey(item, 'format')) {
            return enrichSupported(item);
          } else if (keys$1.length === 1 && contains$2(keys$1, 'title')) {
            return deepMerge(item, { type: 'separator' });
          } else {
            return enrichCustom(item);
          }
        });
      };
      return doEnrich(formats);
    };

    var init$8 = function (editor) {
      var isSelectedFor = function (format) {
        return function () {
          return editor.formatter.match(format);
        };
      };
      var getPreviewFor = function (format) {
        return function () {
          var fmt = editor.formatter.get(format);
          return fmt !== undefined ? Optional.some({
            tag: fmt.length > 0 ? fmt[0].inline || fmt[0].block || 'div' : 'div',
            styles: editor.dom.parseStyle(editor.formatter.getCssText(format))
          }) : Optional.none();
        };
      };
      var flatten = function (fmt) {
        var subs = fmt.items;
        return subs !== undefined && subs.length > 0 ? bind$3(subs, flatten) : [fmt.format];
      };
      var settingsFormats = Cell([]);
      var settingsFlattenedFormats = Cell([]);
      var eventsFormats = Cell([]);
      var eventsFlattenedFormats = Cell([]);
      var replaceSettings = Cell(false);
      editor.on('PreInit', function (_e) {
        var formats = getStyleFormats(editor);
        var enriched = register$8(editor, formats, isSelectedFor, getPreviewFor);
        settingsFormats.set(enriched);
        settingsFlattenedFormats.set(bind$3(enriched, flatten));
      });
      editor.on('addStyleModifications', function (e) {
        var modifications = register$8(editor, e.items, isSelectedFor, getPreviewFor);
        eventsFormats.set(modifications);
        replaceSettings.set(e.replace);
        eventsFlattenedFormats.set(bind$3(modifications, flatten));
      });
      var getData = function () {
        var fromSettings = replaceSettings.get() ? [] : settingsFormats.get();
        var fromEvents = eventsFormats.get();
        return fromSettings.concat(fromEvents);
      };
      var getFlattenedKeys = function () {
        var fromSettings = replaceSettings.get() ? [] : settingsFlattenedFormats.get();
        var fromEvents = eventsFlattenedFormats.get();
        return fromSettings.concat(fromEvents);
      };
      return {
        getData: getData,
        getFlattenedKeys: getFlattenedKeys
      };
    };

    var isElement = function (node) {
      return isNonNullable(node) && node.nodeType === 1;
    };
    var trim = global$5.trim;
    var hasContentEditableState = function (value) {
      return function (node) {
        if (isElement(node)) {
          if (node.contentEditable === value) {
            return true;
          }
          if (node.getAttribute('data-mce-contenteditable') === value) {
            return true;
          }
        }
        return false;
      };
    };
    var isContentEditableTrue = hasContentEditableState('true');
    var isContentEditableFalse = hasContentEditableState('false');
    var create = function (type, title, url, level, attach) {
      return {
        type: type,
        title: title,
        url: url,
        level: level,
        attach: attach
      };
    };
    var isChildOfContentEditableTrue = function (node) {
      while (node = node.parentNode) {
        var value = node.contentEditable;
        if (value && value !== 'inherit') {
          return isContentEditableTrue(node);
        }
      }
      return false;
    };
    var select = function (selector, root) {
      return map$2(descendants(SugarElement.fromDom(root), selector), function (element) {
        return element.dom;
      });
    };
    var getElementText = function (elm) {
      return elm.innerText || elm.textContent;
    };
    var getOrGenerateId = function (elm) {
      return elm.id ? elm.id : generate$6('h');
    };
    var isAnchor = function (elm) {
      return elm && elm.nodeName === 'A' && (elm.id || elm.name) !== undefined;
    };
    var isValidAnchor = function (elm) {
      return isAnchor(elm) && isEditable(elm);
    };
    var isHeader = function (elm) {
      return elm && /^(H[1-6])$/.test(elm.nodeName);
    };
    var isEditable = function (elm) {
      return isChildOfContentEditableTrue(elm) && !isContentEditableFalse(elm);
    };
    var isValidHeader = function (elm) {
      return isHeader(elm) && isEditable(elm);
    };
    var getLevel = function (elm) {
      return isHeader(elm) ? parseInt(elm.nodeName.substr(1), 10) : 0;
    };
    var headerTarget = function (elm) {
      var headerId = getOrGenerateId(elm);
      var attach = function () {
        elm.id = headerId;
      };
      return create('header', getElementText(elm), '#' + headerId, getLevel(elm), attach);
    };
    var anchorTarget = function (elm) {
      var anchorId = elm.id || elm.name;
      var anchorText = getElementText(elm);
      return create('anchor', anchorText ? anchorText : '#' + anchorId, '#' + anchorId, 0, noop);
    };
    var getHeaderTargets = function (elms) {
      return map$2(filter$2(elms, isValidHeader), headerTarget);
    };
    var getAnchorTargets = function (elms) {
      return map$2(filter$2(elms, isValidAnchor), anchorTarget);
    };
    var getTargetElements = function (elm) {
      var elms = select('h1,h2,h3,h4,h5,h6,a:not([href])', elm);
      return elms;
    };
    var hasTitle = function (target) {
      return trim(target.title).length > 0;
    };
    var find = function (elm) {
      var elms = getTargetElements(elm);
      return filter$2(getHeaderTargets(elms).concat(getAnchorTargets(elms)), hasTitle);
    };
    var LinkTargets = { find: find };

    var STORAGE_KEY = 'tinymce-url-history';
    var HISTORY_LENGTH = 5;
    var isHttpUrl = function (url) {
      return isString(url) && /^https?/.test(url);
    };
    var isArrayOfUrl = function (a) {
      return isArray(a) && a.length <= HISTORY_LENGTH && forall(a, isHttpUrl);
    };
    var isRecordOfUrlArray = function (r) {
      return isObject(r) && find$4(r, function (value) {
        return !isArrayOfUrl(value);
      }).isNone();
    };
    var getAllHistory = function () {
      var unparsedHistory = global$8.getItem(STORAGE_KEY);
      if (unparsedHistory === null) {
        return {};
      }
      var history;
      try {
        history = JSON.parse(unparsedHistory);
      } catch (e) {
        if (e instanceof SyntaxError) {
          console.log('Local storage ' + STORAGE_KEY + ' was not valid JSON', e);
          return {};
        }
        throw e;
      }
      if (!isRecordOfUrlArray(history)) {
        console.log('Local storage ' + STORAGE_KEY + ' was not valid format', history);
        return {};
      }
      return history;
    };
    var setAllHistory = function (history) {
      if (!isRecordOfUrlArray(history)) {
        throw new Error('Bad format for history:\n' + JSON.stringify(history));
      }
      global$8.setItem(STORAGE_KEY, JSON.stringify(history));
    };
    var getHistory = function (fileType) {
      var history = getAllHistory();
      return get$e(history, fileType).getOr([]);
    };
    var addToHistory = function (url, fileType) {
      if (!isHttpUrl(url)) {
        return;
      }
      var history = getAllHistory();
      var items = get$e(history, fileType).getOr([]);
      var itemsWithoutUrl = filter$2(items, function (item) {
        return item !== url;
      });
      history[fileType] = [url].concat(itemsWithoutUrl).slice(0, HISTORY_LENGTH);
      setAllHistory(history);
    };

    var isTruthy = function (value) {
      return !!value;
    };
    var makeMap = function (value) {
      return map$1(global$5.makeMap(value, /[, ]/), isTruthy);
    };
    var getPicker = function (editor) {
      return Optional.from(getFilePickerCallback(editor)).filter(isFunction);
    };
    var getPickerTypes = function (editor) {
      var optFileTypes = Optional.some(getFilePickerTypes(editor)).filter(isTruthy);
      var optLegacyTypes = Optional.some(getFileBrowserCallbackTypes(editor)).filter(isTruthy);
      var optTypes = optFileTypes.or(optLegacyTypes).map(makeMap);
      return getPicker(editor).fold(never, function (_picker) {
        return optTypes.fold(always, function (types) {
          return keys(types).length > 0 ? types : false;
        });
      });
    };
    var getPickerSetting = function (editor, filetype) {
      var pickerTypes = getPickerTypes(editor);
      if (isBoolean(pickerTypes)) {
        return pickerTypes ? getPicker(editor) : Optional.none();
      } else {
        return pickerTypes[filetype] ? getPicker(editor) : Optional.none();
      }
    };
    var getUrlPicker = function (editor, filetype) {
      return getPickerSetting(editor, filetype).map(function (picker) {
        return function (entry) {
          return Future.nu(function (completer) {
            var handler = function (value, meta) {
              if (!isString(value)) {
                throw new Error('Expected value to be string');
              }
              if (meta !== undefined && !isObject(meta)) {
                throw new Error('Expected meta to be a object');
              }
              var r = {
                value: value,
                meta: meta
              };
              completer(r);
            };
            var meta = __assign({
              filetype: filetype,
              fieldname: entry.fieldname
            }, Optional.from(entry.meta).getOr({}));
            picker.call(editor, handler, entry.value, meta);
          });
        };
      });
    };
    var getTextSetting = function (value) {
      return Optional.from(value).filter(isString).getOrUndefined();
    };
    var getLinkInformation = function (editor) {
      if (noTypeaheadUrls(editor)) {
        return Optional.none();
      }
      return Optional.some({
        targets: LinkTargets.find(editor.getBody()),
        anchorTop: getTextSetting(getAnchorTop(editor)),
        anchorBottom: getTextSetting(getAnchorBottom(editor))
      });
    };
    var getValidationHandler = function (editor) {
      return Optional.from(getFilePickerValidatorHandler(editor));
    };
    var UrlInputBackstage = function (editor) {
      return {
        getHistory: getHistory,
        addToHistory: addToHistory,
        getLinkInformation: function () {
          return getLinkInformation(editor);
        },
        getValidationHandler: function () {
          return getValidationHandler(editor);
        },
        getUrlPicker: function (filetype) {
          return getUrlPicker(editor, filetype);
        }
      };
    };

    var init$7 = function (sink, editor, lazyAnchorbar) {
      var contextMenuState = Cell(false);
      var toolbar = HeaderBackstage(editor);
      var backstage = {
        shared: {
          providers: {
            icons: function () {
              return editor.ui.registry.getAll().icons;
            },
            menuItems: function () {
              return editor.ui.registry.getAll().menuItems;
            },
            translate: global$e.translate,
            isDisabled: function () {
              return editor.mode.isReadOnly() || editor.ui.isDisabled();
            },
            getSetting: editor.getParam.bind(editor)
          },
          interpreter: function (s) {
            return interpretWithoutForm(s, backstage);
          },
          anchors: getAnchors(editor, lazyAnchorbar, toolbar.isPositionedAtTop),
          header: toolbar,
          getSink: function () {
            return Result.value(sink);
          }
        },
        urlinput: UrlInputBackstage(editor),
        styleselect: init$8(editor),
        colorinput: ColorInputBackstage(editor),
        dialog: DialogBackstage(editor),
        isContextMenuOpen: function () {
          return contextMenuState.get();
        },
        setContextMenuState: function (state) {
          return contextMenuState.set(state);
        }
      };
      return backstage;
    };

    var setup$b = function (editor, mothership, uiMothership) {
      var broadcastEvent = function (name, evt) {
        each$1([
          mothership,
          uiMothership
        ], function (ship) {
          ship.broadcastEvent(name, evt);
        });
      };
      var broadcastOn = function (channel, message) {
        each$1([
          mothership,
          uiMothership
        ], function (ship) {
          ship.broadcastOn([channel], message);
        });
      };
      var fireDismissPopups = function (evt) {
        return broadcastOn(dismissPopups(), { target: evt.target });
      };
      var doc = getDocument();
      var onTouchstart = bind(doc, 'touchstart', fireDismissPopups);
      var onTouchmove = bind(doc, 'touchmove', function (evt) {
        return broadcastEvent(documentTouchmove(), evt);
      });
      var onTouchend = bind(doc, 'touchend', function (evt) {
        return broadcastEvent(documentTouchend(), evt);
      });
      var onMousedown = bind(doc, 'mousedown', fireDismissPopups);
      var onMouseup = bind(doc, 'mouseup', function (evt) {
        if (evt.raw.button === 0) {
          broadcastOn(mouseReleased(), { target: evt.target });
        }
      });
      var onContentClick = function (raw) {
        return broadcastOn(dismissPopups(), { target: SugarElement.fromDom(raw.target) });
      };
      var onContentMouseup = function (raw) {
        if (raw.button === 0) {
          broadcastOn(mouseReleased(), { target: SugarElement.fromDom(raw.target) });
        }
      };
      var onContentMousedown = function () {
        each$1(editor.editorManager.get(), function (loopEditor) {
          if (editor !== loopEditor) {
            loopEditor.fire('DismissPopups', { relatedTarget: editor });
          }
        });
      };
      var onWindowScroll = function (evt) {
        return broadcastEvent(windowScroll(), fromRawEvent(evt));
      };
      var onWindowResize = function (evt) {
        broadcastOn(repositionPopups(), {});
        broadcastEvent(windowResize(), fromRawEvent(evt));
      };
      var onEditorResize = function () {
        return broadcastOn(repositionPopups(), {});
      };
      var onEditorProgress = function (evt) {
        if (evt.state) {
          broadcastOn(dismissPopups(), { target: SugarElement.fromDom(editor.getContainer()) });
        }
      };
      var onDismissPopups = function (event) {
        broadcastOn(dismissPopups(), { target: SugarElement.fromDom(event.relatedTarget.getContainer()) });
      };
      editor.on('PostRender', function () {
        editor.on('click', onContentClick);
        editor.on('tap', onContentClick);
        editor.on('mouseup', onContentMouseup);
        editor.on('mousedown', onContentMousedown);
        editor.on('ScrollWindow', onWindowScroll);
        editor.on('ResizeWindow', onWindowResize);
        editor.on('ResizeEditor', onEditorResize);
        editor.on('AfterProgressState', onEditorProgress);
        editor.on('DismissPopups', onDismissPopups);
      });
      editor.on('remove', function () {
        editor.off('click', onContentClick);
        editor.off('tap', onContentClick);
        editor.off('mouseup', onContentMouseup);
        editor.off('mousedown', onContentMousedown);
        editor.off('ScrollWindow', onWindowScroll);
        editor.off('ResizeWindow', onWindowResize);
        editor.off('ResizeEditor', onEditorResize);
        editor.off('AfterProgressState', onEditorProgress);
        editor.off('DismissPopups', onDismissPopups);
        onMousedown.unbind();
        onTouchstart.unbind();
        onTouchmove.unbind();
        onTouchend.unbind();
        onMouseup.unbind();
      });
      editor.on('detach', function () {
        detachSystem(mothership);
        detachSystem(uiMothership);
        mothership.destroy();
        uiMothership.destroy();
      });
    };

    var parts$a = AlloyParts;
    var partType = PartType;

    var schema$f = constant$1([
      defaulted('shell', false),
      required$1('makeItem'),
      defaulted('setupItem', noop),
      SketchBehaviours.field('listBehaviours', [Replacing])
    ]);
    var customListDetail = function () {
      return { behaviours: derive$1([Replacing.config({})]) };
    };
    var itemsPart = optional({
      name: 'items',
      overrides: customListDetail
    });
    var parts$9 = constant$1([itemsPart]);
    var name = constant$1('CustomList');

    var factory$d = function (detail, components, _spec, _external) {
      var setItems = function (list, items) {
        getListContainer(list).fold(function () {
          console.error('Custom List was defined to not be a shell, but no item container was specified in components');
          throw new Error('Custom List was defined to not be a shell, but no item container was specified in components');
        }, function (container) {
          var itemComps = Replacing.contents(container);
          var numListsRequired = items.length;
          var numListsToAdd = numListsRequired - itemComps.length;
          var itemsToAdd = numListsToAdd > 0 ? range$2(numListsToAdd, function () {
            return detail.makeItem();
          }) : [];
          var itemsToRemove = itemComps.slice(numListsRequired);
          each$1(itemsToRemove, function (item) {
            return Replacing.remove(container, item);
          });
          each$1(itemsToAdd, function (item) {
            return Replacing.append(container, item);
          });
          var builtLists = Replacing.contents(container);
          each$1(builtLists, function (item, i) {
            detail.setupItem(list, item, items[i], i);
          });
        });
      };
      var extra = detail.shell ? {
        behaviours: [Replacing.config({})],
        components: []
      } : {
        behaviours: [],
        components: components
      };
      var getListContainer = function (component) {
        return detail.shell ? Optional.some(component) : getPart(component, detail, 'items');
      };
      return {
        uid: detail.uid,
        dom: detail.dom,
        components: extra.components,
        behaviours: augment(detail.listBehaviours, extra.behaviours),
        apis: { setItems: setItems }
      };
    };
    var CustomList = composite({
      name: name(),
      configFields: schema$f(),
      partFields: parts$9(),
      factory: factory$d,
      apis: {
        setItems: function (apis, list, items) {
          apis.setItems(list, items);
        }
      }
    });

    var schema$e = constant$1([
      required$1('dom'),
      defaulted('shell', true),
      field('toolbarBehaviours', [Replacing])
    ]);
    var enhanceGroups = function () {
      return { behaviours: derive$1([Replacing.config({})]) };
    };
    var parts$8 = constant$1([optional({
        name: 'groups',
        overrides: enhanceGroups
      })]);

    var factory$c = function (detail, components, _spec, _externals) {
      var setGroups = function (toolbar, groups) {
        getGroupContainer(toolbar).fold(function () {
          console.error('Toolbar was defined to not be a shell, but no groups container was specified in components');
          throw new Error('Toolbar was defined to not be a shell, but no groups container was specified in components');
        }, function (container) {
          Replacing.set(container, groups);
        });
      };
      var getGroupContainer = function (component) {
        return detail.shell ? Optional.some(component) : getPart(component, detail, 'groups');
      };
      var extra = detail.shell ? {
        behaviours: [Replacing.config({})],
        components: []
      } : {
        behaviours: [],
        components: components
      };
      return {
        uid: detail.uid,
        dom: detail.dom,
        components: extra.components,
        behaviours: augment(detail.toolbarBehaviours, extra.behaviours),
        apis: { setGroups: setGroups },
        domModification: { attributes: { role: 'group' } }
      };
    };
    var Toolbar = composite({
      name: 'Toolbar',
      configFields: schema$e(),
      partFields: parts$8(),
      factory: factory$c,
      apis: {
        setGroups: function (apis, toolbar, groups) {
          apis.setGroups(toolbar, groups);
        }
      }
    });

    var setup$a = noop;
    var isDocked$2 = never;
    var getBehaviours$1 = constant$1([]);

    var StaticHeader = /*#__PURE__*/Object.freeze({
        __proto__: null,
        setup: setup$a,
        isDocked: isDocked$2,
        getBehaviours: getBehaviours$1
    });

    var getOffsetParent = function (element) {
      var isFixed = is$1(getRaw(element, 'position'), 'fixed');
      var offsetParent$1 = isFixed ? Optional.none() : offsetParent(element);
      return offsetParent$1.orThunk(function () {
        var marker = SugarElement.fromTag('span');
        return parent(element).bind(function (parent) {
          append$2(parent, marker);
          var offsetParent$1 = offsetParent(marker);
          remove$5(marker);
          return offsetParent$1;
        });
      });
    };
    var getOrigin = function (element) {
      return getOffsetParent(element).map(absolute$3).getOrThunk(function () {
        return SugarPosition(0, 0);
      });
    };

    var morphAdt = Adt.generate([
      { static: [] },
      { absolute: ['positionCss'] },
      { fixed: ['positionCss'] }
    ]);
    var appear = function (component, contextualInfo) {
      var elem = component.element;
      add$2(elem, contextualInfo.transitionClass);
      remove$2(elem, contextualInfo.fadeOutClass);
      add$2(elem, contextualInfo.fadeInClass);
      contextualInfo.onShow(component);
    };
    var disappear = function (component, contextualInfo) {
      var elem = component.element;
      add$2(elem, contextualInfo.transitionClass);
      remove$2(elem, contextualInfo.fadeInClass);
      add$2(elem, contextualInfo.fadeOutClass);
      contextualInfo.onHide(component);
    };
    var isPartiallyVisible = function (box, viewport) {
      return box.y < viewport.bottom && box.bottom > viewport.y;
    };
    var isTopCompletelyVisible = function (box, viewport) {
      return box.y >= viewport.y;
    };
    var isBottomCompletelyVisible = function (box, viewport) {
      return box.bottom <= viewport.bottom;
    };
    var isVisibleForModes = function (modes, box, viewport) {
      return forall(modes, function (mode) {
        switch (mode) {
        case 'bottom':
          return isBottomCompletelyVisible(box, viewport);
        case 'top':
          return isTopCompletelyVisible(box, viewport);
        }
      });
    };
    var getPrior = function (elem, state) {
      return state.getInitialPos().map(function (pos) {
        return bounds(pos.bounds.x, pos.bounds.y, get$a(elem), get$b(elem));
      });
    };
    var storePrior = function (elem, box, state) {
      state.setInitialPos({
        style: getAllRaw(elem),
        position: get$c(elem, 'position') || 'static',
        bounds: box
      });
    };
    var revertToOriginal = function (elem, box, state) {
      return state.getInitialPos().bind(function (position) {
        state.clearInitialPos();
        switch (position.position) {
        case 'static':
          return Optional.some(morphAdt.static());
        case 'absolute':
          var offsetBox_1 = getOffsetParent(elem).map(box$1).getOrThunk(function () {
            return box$1(body());
          });
          return Optional.some(morphAdt.absolute(NuPositionCss('absolute', get$e(position.style, 'left').map(function (_left) {
            return box.x - offsetBox_1.x;
          }), get$e(position.style, 'top').map(function (_top) {
            return box.y - offsetBox_1.y;
          }), get$e(position.style, 'right').map(function (_right) {
            return offsetBox_1.right - box.right;
          }), get$e(position.style, 'bottom').map(function (_bottom) {
            return offsetBox_1.bottom - box.bottom;
          }))));
        default:
          return Optional.none();
        }
      });
    };
    var morphToOriginal = function (elem, viewport, state) {
      return getPrior(elem, state).filter(function (box) {
        return isVisibleForModes(state.getModes(), box, viewport);
      }).bind(function (box) {
        return revertToOriginal(elem, box, state);
      });
    };
    var morphToFixed = function (elem, viewport, state) {
      var box = box$1(elem);
      if (!isVisibleForModes(state.getModes(), box, viewport)) {
        storePrior(elem, box, state);
        var winBox = win();
        var left = box.x - winBox.x;
        var top_1 = viewport.y - winBox.y;
        var bottom = winBox.bottom - viewport.bottom;
        var isTop = box.y <= viewport.y;
        return Optional.some(morphAdt.fixed(NuPositionCss('fixed', Optional.some(left), isTop ? Optional.some(top_1) : Optional.none(), Optional.none(), !isTop ? Optional.some(bottom) : Optional.none())));
      } else {
        return Optional.none();
      }
    };
    var getMorph = function (component, viewport, state) {
      var elem = component.element;
      var isDocked = is$1(getRaw(elem, 'position'), 'fixed');
      return isDocked ? morphToOriginal(elem, viewport, state) : morphToFixed(elem, viewport, state);
    };
    var getMorphToOriginal = function (component, state) {
      var elem = component.element;
      return getPrior(elem, state).bind(function (box) {
        return revertToOriginal(elem, box, state);
      });
    };

    var morphToStatic = function (component, config, state) {
      state.setDocked(false);
      each$1([
        'left',
        'right',
        'top',
        'bottom',
        'position'
      ], function (prop) {
        return remove$6(component.element, prop);
      });
      config.onUndocked(component);
    };
    var morphToCoord = function (component, config, state, position) {
      var isDocked = position.position === 'fixed';
      state.setDocked(isDocked);
      applyPositionCss(component.element, position);
      var method = isDocked ? config.onDocked : config.onUndocked;
      method(component);
    };
    var updateVisibility = function (component, config, state, viewport, morphToDocked) {
      if (morphToDocked === void 0) {
        morphToDocked = false;
      }
      config.contextual.each(function (contextInfo) {
        contextInfo.lazyContext(component).each(function (box) {
          var isVisible = isPartiallyVisible(box, viewport);
          if (isVisible !== state.isVisible()) {
            state.setVisible(isVisible);
            if (morphToDocked && !isVisible) {
              add$1(component.element, [contextInfo.fadeOutClass]);
              contextInfo.onHide(component);
            } else {
              var method = isVisible ? appear : disappear;
              method(component, contextInfo);
            }
          }
        });
      });
    };
    var refreshInternal = function (component, config, state) {
      var viewport = config.lazyViewport(component);
      var isDocked = state.isDocked();
      if (isDocked) {
        updateVisibility(component, config, state, viewport);
      }
      getMorph(component, viewport, state).each(function (morph) {
        morph.fold(function () {
          return morphToStatic(component, config, state);
        }, function (position) {
          return morphToCoord(component, config, state, position);
        }, function (position) {
          updateVisibility(component, config, state, viewport, true);
          morphToCoord(component, config, state, position);
        });
      });
    };
    var resetInternal = function (component, config, state) {
      var elem = component.element;
      state.setDocked(false);
      getMorphToOriginal(component, state).each(function (morph) {
        morph.fold(function () {
          return morphToStatic(component, config, state);
        }, function (position) {
          return morphToCoord(component, config, state, position);
        }, noop);
      });
      state.setVisible(true);
      config.contextual.each(function (contextInfo) {
        remove$1(elem, [
          contextInfo.fadeInClass,
          contextInfo.fadeOutClass,
          contextInfo.transitionClass
        ]);
        contextInfo.onShow(component);
      });
      refresh$4(component, config, state);
    };
    var refresh$4 = function (component, config, state) {
      if (component.getSystem().isConnected()) {
        refreshInternal(component, config, state);
      }
    };
    var reset = function (component, config, state) {
      if (state.isDocked()) {
        resetInternal(component, config, state);
      }
    };
    var isDocked$1 = function (component, config, state) {
      return state.isDocked();
    };
    var setModes = function (component, config, state, modes) {
      return state.setModes(modes);
    };
    var getModes = function (component, config, state) {
      return state.getModes();
    };

    var DockingApis = /*#__PURE__*/Object.freeze({
        __proto__: null,
        refresh: refresh$4,
        reset: reset,
        isDocked: isDocked$1,
        getModes: getModes,
        setModes: setModes
    });

    var events$5 = function (dockInfo, dockState) {
      return derive$2([
        runOnSource(transitionend(), function (component, simulatedEvent) {
          dockInfo.contextual.each(function (contextInfo) {
            if (has(component.element, contextInfo.transitionClass)) {
              remove$1(component.element, [
                contextInfo.transitionClass,
                contextInfo.fadeInClass
              ]);
              var notify = dockState.isVisible() ? contextInfo.onShown : contextInfo.onHidden;
              notify(component);
            }
            simulatedEvent.stop();
          });
        }),
        run$1(windowScroll(), function (component, _) {
          refresh$4(component, dockInfo, dockState);
        }),
        run$1(windowResize(), function (component, _) {
          reset(component, dockInfo, dockState);
        })
      ]);
    };

    var ActiveDocking = /*#__PURE__*/Object.freeze({
        __proto__: null,
        events: events$5
    });

    var DockingSchema = [
      optionObjOf('contextual', [
        requiredString('fadeInClass'),
        requiredString('fadeOutClass'),
        requiredString('transitionClass'),
        requiredFunction('lazyContext'),
        onHandler('onShow'),
        onHandler('onShown'),
        onHandler('onHide'),
        onHandler('onHidden')
      ]),
      defaultedFunction('lazyViewport', win),
      defaultedArrayOf('modes', [
        'top',
        'bottom'
      ], string),
      onHandler('onDocked'),
      onHandler('onUndocked')
    ];

    var init$6 = function (spec) {
      var docked = Cell(false);
      var visible = Cell(true);
      var initialBounds = value$1();
      var modes = Cell(spec.modes);
      var readState = function () {
        return 'docked:  ' + docked.get() + ', visible: ' + visible.get() + ', modes: ' + modes.get().join(',');
      };
      return nu$8({
        isDocked: docked.get,
        setDocked: docked.set,
        getInitialPos: initialBounds.get,
        setInitialPos: initialBounds.set,
        clearInitialPos: initialBounds.clear,
        isVisible: visible.get,
        setVisible: visible.set,
        getModes: modes.get,
        setModes: modes.set,
        readState: readState
      });
    };

    var DockingState = /*#__PURE__*/Object.freeze({
        __proto__: null,
        init: init$6
    });

    var Docking = create$7({
      fields: DockingSchema,
      name: 'docking',
      active: ActiveDocking,
      apis: DockingApis,
      state: DockingState
    });

    var toolbarHeightChange = constant$1(generate$6('toolbar-height-change'));

    var visibility = {
      fadeInClass: 'tox-editor-dock-fadein',
      fadeOutClass: 'tox-editor-dock-fadeout',
      transitionClass: 'tox-editor-dock-transition'
    };
    var editorStickyOnClass = 'tox-tinymce--toolbar-sticky-on';
    var editorStickyOffClass = 'tox-tinymce--toolbar-sticky-off';
    var scrollFromBehindHeader = function (e, containerHeader) {
      var doc = owner$4(containerHeader);
      var viewHeight = doc.dom.defaultView.innerHeight;
      var scrollPos = get$9(doc);
      var markerElement = SugarElement.fromDom(e.elm);
      var markerPos = absolute$2(markerElement);
      var markerHeight = get$b(markerElement);
      var markerTop = markerPos.y;
      var markerBottom = markerTop + markerHeight;
      var editorHeaderPos = absolute$3(containerHeader);
      var editorHeaderHeight = get$b(containerHeader);
      var editorHeaderTop = editorHeaderPos.top;
      var editorHeaderBottom = editorHeaderTop + editorHeaderHeight;
      var editorHeaderDockedAtTop = Math.abs(editorHeaderTop - scrollPos.top) < 2;
      var editorHeaderDockedAtBottom = Math.abs(editorHeaderBottom - (scrollPos.top + viewHeight)) < 2;
      if (editorHeaderDockedAtTop && markerTop < editorHeaderBottom) {
        to(scrollPos.left, markerTop - editorHeaderHeight, doc);
      } else if (editorHeaderDockedAtBottom && markerBottom > editorHeaderTop) {
        var y = markerTop - viewHeight + markerHeight + editorHeaderHeight;
        to(scrollPos.left, y, doc);
      }
    };
    var isDockedMode = function (header, mode) {
      return contains$2(Docking.getModes(header), mode);
    };
    var updateIframeContentFlow = function (header) {
      var getOccupiedHeight = function (elm) {
        return getOuter$2(elm) + (parseInt(get$c(elm, 'margin-top'), 10) || 0) + (parseInt(get$c(elm, 'margin-bottom'), 10) || 0);
      };
      var elm = header.element;
      parent(elm).each(function (parentElem) {
        var padding = 'padding-' + Docking.getModes(header)[0];
        if (Docking.isDocked(header)) {
          var parentWidth = get$a(parentElem);
          set$7(elm, 'width', parentWidth + 'px');
          set$7(parentElem, padding, getOccupiedHeight(elm) + 'px');
        } else {
          remove$6(elm, 'width');
          remove$6(parentElem, padding);
        }
      });
    };
    var updateSinkVisibility = function (sinkElem, visible) {
      if (visible) {
        remove$2(sinkElem, visibility.fadeOutClass);
        add$1(sinkElem, [
          visibility.transitionClass,
          visibility.fadeInClass
        ]);
      } else {
        remove$2(sinkElem, visibility.fadeInClass);
        add$1(sinkElem, [
          visibility.fadeOutClass,
          visibility.transitionClass
        ]);
      }
    };
    var updateEditorClasses = function (editor, docked) {
      var editorContainer = SugarElement.fromDom(editor.getContainer());
      if (docked) {
        add$2(editorContainer, editorStickyOnClass);
        remove$2(editorContainer, editorStickyOffClass);
      } else {
        add$2(editorContainer, editorStickyOffClass);
        remove$2(editorContainer, editorStickyOnClass);
      }
    };
    var restoreFocus = function (headerElem, focusedElem) {
      var ownerDoc = owner$4(focusedElem);
      active(ownerDoc).filter(function (activeElm) {
        return !eq(focusedElem, activeElm);
      }).filter(function (activeElm) {
        return eq(activeElm, SugarElement.fromDom(ownerDoc.dom.body)) || contains(headerElem, activeElm);
      }).each(function () {
        return focus$3(focusedElem);
      });
    };
    var findFocusedElem = function (rootElm, lazySink) {
      return search(rootElm).orThunk(function () {
        return lazySink().toOptional().bind(function (sink) {
          return search(sink.element);
        });
      });
    };
    var setup$9 = function (editor, sharedBackstage, lazyHeader) {
      if (!editor.inline) {
        if (!sharedBackstage.header.isPositionedAtTop()) {
          editor.on('ResizeEditor', function () {
            lazyHeader().each(Docking.reset);
          });
        }
        editor.on('ResizeWindow ResizeEditor', function () {
          lazyHeader().each(updateIframeContentFlow);
        });
        editor.on('SkinLoaded', function () {
          lazyHeader().each(function (comp) {
            Docking.isDocked(comp) ? Docking.reset(comp) : Docking.refresh(comp);
          });
        });
        editor.on('FullscreenStateChanged', function () {
          lazyHeader().each(Docking.reset);
        });
      }
      editor.on('AfterScrollIntoView', function (e) {
        lazyHeader().each(function (header) {
          Docking.refresh(header);
          var headerElem = header.element;
          if (isVisible(headerElem)) {
            scrollFromBehindHeader(e, headerElem);
          }
        });
      });
      editor.on('PostRender', function () {
        updateEditorClasses(editor, false);
      });
    };
    var isDocked = function (lazyHeader) {
      return lazyHeader().map(Docking.isDocked).getOr(false);
    };
    var getIframeBehaviours = function () {
      var _a;
      return [Receiving.config({ channels: (_a = {}, _a[toolbarHeightChange()] = { onReceive: updateIframeContentFlow }, _a) })];
    };
    var getBehaviours = function (editor, sharedBackstage) {
      var focusedElm = value$1();
      var lazySink = sharedBackstage.getSink;
      var runOnSinkElement = function (f) {
        lazySink().each(function (sink) {
          return f(sink.element);
        });
      };
      var onDockingSwitch = function (comp) {
        if (!editor.inline) {
          updateIframeContentFlow(comp);
        }
        updateEditorClasses(editor, Docking.isDocked(comp));
        comp.getSystem().broadcastOn([repositionPopups()], {});
        lazySink().each(function (sink) {
          return sink.getSystem().broadcastOn([repositionPopups()], {});
        });
      };
      var additionalBehaviours = editor.inline ? [] : getIframeBehaviours();
      return __spreadArray([
        Focusing.config({}),
        Docking.config({
          contextual: __assign({
            lazyContext: function (comp) {
              var headerHeight = getOuter$2(comp.element);
              var container = editor.inline ? editor.getContentAreaContainer() : editor.getContainer();
              var box = box$1(SugarElement.fromDom(container));
              var boxHeight = box.height - headerHeight;
              var topBound = box.y + (isDockedMode(comp, 'top') ? 0 : headerHeight);
              return Optional.some(bounds(box.x, topBound, box.width, boxHeight));
            },
            onShow: function () {
              runOnSinkElement(function (elem) {
                return updateSinkVisibility(elem, true);
              });
            },
            onShown: function (comp) {
              runOnSinkElement(function (elem) {
                return remove$1(elem, [
                  visibility.transitionClass,
                  visibility.fadeInClass
                ]);
              });
              focusedElm.get().each(function (elem) {
                restoreFocus(comp.element, elem);
                focusedElm.clear();
              });
            },
            onHide: function (comp) {
              findFocusedElem(comp.element, lazySink).fold(focusedElm.clear, focusedElm.set);
              runOnSinkElement(function (elem) {
                return updateSinkVisibility(elem, false);
              });
            },
            onHidden: function () {
              runOnSinkElement(function (elem) {
                return remove$1(elem, [visibility.transitionClass]);
              });
            }
          }, visibility),
          lazyViewport: function (comp) {
            var win$1 = win();
            var offset = getStickyToolbarOffset(editor);
            var top = win$1.y + (isDockedMode(comp, 'top') ? offset : 0);
            var height = win$1.height - (isDockedMode(comp, 'bottom') ? offset : 0);
            return bounds(win$1.x, top, win$1.width, height);
          },
          modes: [sharedBackstage.header.getDockingMode()],
          onDocked: onDockingSwitch,
          onUndocked: onDockingSwitch
        })
      ], additionalBehaviours, true);
    };

    var StickyHeader = /*#__PURE__*/Object.freeze({
        __proto__: null,
        setup: setup$9,
        isDocked: isDocked,
        getBehaviours: getBehaviours
    });

    var renderHeader = function (spec) {
      var editor = spec.editor;
      var getBehaviours$2 = spec.sticky ? getBehaviours : getBehaviours$1;
      return {
        uid: spec.uid,
        dom: spec.dom,
        components: spec.components,
        behaviours: derive$1(getBehaviours$2(editor, spec.sharedBackstage))
      };
    };

    var groupToolbarButtonSchema = objOf([
      requiredString('type'),
      requiredOf('items', oneOf([
        arrOfObj([
          requiredString('name'),
          requiredArrayOf('items', string)
        ]),
        string
      ]))
    ].concat(baseToolbarButtonFields));
    var createGroupToolbarButton = function (spec) {
      return asRaw('GroupToolbarButton', groupToolbarButtonSchema, spec);
    };

    var baseMenuButtonFields = [
      optionString('text'),
      optionString('tooltip'),
      optionString('icon'),
      requiredFunction('fetch'),
      defaultedFunction('onSetup', function () {
        return noop;
      })
    ];

    var MenuButtonSchema = objOf(__spreadArray([requiredString('type')], baseMenuButtonFields, true));
    var createMenuButton = function (spec) {
      return asRaw('menubutton', MenuButtonSchema, spec);
    };

    var splitButtonSchema = objOf([
      requiredString('type'),
      optionString('tooltip'),
      optionString('icon'),
      optionString('text'),
      optionFunction('select'),
      requiredFunction('fetch'),
      defaultedFunction('onSetup', function () {
        return noop;
      }),
      defaultedStringEnum('presets', 'normal', [
        'normal',
        'color',
        'listpreview'
      ]),
      defaulted('columns', 1),
      requiredFunction('onAction'),
      requiredFunction('onItemAction')
    ]);
    var createSplitButton = function (spec) {
      return asRaw('SplitButton', splitButtonSchema, spec);
    };

    var factory$b = function (detail, spec) {
      var setMenus = function (comp, menus) {
        var newMenus = map$2(menus, function (m) {
          var buttonSpec = {
            type: 'menubutton',
            text: m.text,
            fetch: function (callback) {
              callback(m.getItems());
            }
          };
          var internal = createMenuButton(buttonSpec).mapError(function (errInfo) {
            return formatError(errInfo);
          }).getOrDie();
          return renderMenuButton(internal, 'tox-mbtn', spec.backstage, Optional.some('menuitem'));
        });
        Replacing.set(comp, newMenus);
      };
      var apis = {
        focus: Keying.focusIn,
        setMenus: setMenus
      };
      return {
        uid: detail.uid,
        dom: detail.dom,
        components: [],
        behaviours: derive$1([
          Replacing.config({}),
          config('menubar-events', [
            runOnAttached(function (component) {
              detail.onSetup(component);
            }),
            run$1(mouseover(), function (comp, se) {
              descendant(comp.element, '.' + 'tox-mbtn--active').each(function (activeButton) {
                closest$1(se.event.target, '.' + 'tox-mbtn').each(function (hoveredButton) {
                  if (!eq(activeButton, hoveredButton)) {
                    comp.getSystem().getByDom(activeButton).each(function (activeComp) {
                      comp.getSystem().getByDom(hoveredButton).each(function (hoveredComp) {
                        Dropdown.expand(hoveredComp);
                        Dropdown.close(activeComp);
                        Focusing.focus(hoveredComp);
                      });
                    });
                  }
                });
              });
            }),
            run$1(focusShifted(), function (comp, se) {
              se.event.prevFocus.bind(function (prev) {
                return comp.getSystem().getByDom(prev).toOptional();
              }).each(function (prev) {
                se.event.newFocus.bind(function (nu) {
                  return comp.getSystem().getByDom(nu).toOptional();
                }).each(function (nu) {
                  if (Dropdown.isOpen(prev)) {
                    Dropdown.expand(nu);
                    Dropdown.close(prev);
                  }
                });
              });
            })
          ]),
          Keying.config({
            mode: 'flow',
            selector: '.' + 'tox-mbtn',
            onEscape: function (comp) {
              detail.onEscape(comp);
              return Optional.some(true);
            }
          }),
          Tabstopping.config({})
        ]),
        apis: apis,
        domModification: { attributes: { role: 'menubar' } }
      };
    };
    var SilverMenubar = single({
      factory: factory$b,
      name: 'silver.Menubar',
      configFields: [
        required$1('dom'),
        required$1('uid'),
        required$1('onEscape'),
        required$1('backstage'),
        defaulted('onSetup', noop)
      ],
      apis: {
        focus: function (apis, comp) {
          apis.focus(comp);
        },
        setMenus: function (apis, comp, menus) {
          apis.setMenus(comp, menus);
        }
      }
    });

    var getAnimationRoot = function (component, slideConfig) {
      return slideConfig.getAnimationRoot.fold(function () {
        return component.element;
      }, function (get) {
        return get(component);
      });
    };

    var getDimensionProperty = function (slideConfig) {
      return slideConfig.dimension.property;
    };
    var getDimension = function (slideConfig, elem) {
      return slideConfig.dimension.getDimension(elem);
    };
    var disableTransitions = function (component, slideConfig) {
      var root = getAnimationRoot(component, slideConfig);
      remove$1(root, [
        slideConfig.shrinkingClass,
        slideConfig.growingClass
      ]);
    };
    var setShrunk = function (component, slideConfig) {
      remove$2(component.element, slideConfig.openClass);
      add$2(component.element, slideConfig.closedClass);
      set$7(component.element, getDimensionProperty(slideConfig), '0px');
      reflow(component.element);
    };
    var setGrown = function (component, slideConfig) {
      remove$2(component.element, slideConfig.closedClass);
      add$2(component.element, slideConfig.openClass);
      remove$6(component.element, getDimensionProperty(slideConfig));
    };
    var doImmediateShrink = function (component, slideConfig, slideState, _calculatedSize) {
      slideState.setCollapsed();
      set$7(component.element, getDimensionProperty(slideConfig), getDimension(slideConfig, component.element));
      reflow(component.element);
      disableTransitions(component, slideConfig);
      setShrunk(component, slideConfig);
      slideConfig.onStartShrink(component);
      slideConfig.onShrunk(component);
    };
    var doStartShrink = function (component, slideConfig, slideState, calculatedSize) {
      var size = calculatedSize.getOrThunk(function () {
        return getDimension(slideConfig, component.element);
      });
      slideState.setCollapsed();
      set$7(component.element, getDimensionProperty(slideConfig), size);
      reflow(component.element);
      var root = getAnimationRoot(component, slideConfig);
      remove$2(root, slideConfig.growingClass);
      add$2(root, slideConfig.shrinkingClass);
      setShrunk(component, slideConfig);
      slideConfig.onStartShrink(component);
    };
    var doStartSmartShrink = function (component, slideConfig, slideState) {
      var size = getDimension(slideConfig, component.element);
      var shrinker = size === '0px' ? doImmediateShrink : doStartShrink;
      shrinker(component, slideConfig, slideState, Optional.some(size));
    };
    var doStartGrow = function (component, slideConfig, slideState) {
      var root = getAnimationRoot(component, slideConfig);
      var wasShrinking = has(root, slideConfig.shrinkingClass);
      var beforeSize = getDimension(slideConfig, component.element);
      setGrown(component, slideConfig);
      var fullSize = getDimension(slideConfig, component.element);
      var startPartialGrow = function () {
        set$7(component.element, getDimensionProperty(slideConfig), beforeSize);
        reflow(component.element);
      };
      var startCompleteGrow = function () {
        setShrunk(component, slideConfig);
      };
      var setStartSize = wasShrinking ? startPartialGrow : startCompleteGrow;
      setStartSize();
      remove$2(root, slideConfig.shrinkingClass);
      add$2(root, slideConfig.growingClass);
      setGrown(component, slideConfig);
      set$7(component.element, getDimensionProperty(slideConfig), fullSize);
      slideState.setExpanded();
      slideConfig.onStartGrow(component);
    };
    var refresh$3 = function (component, slideConfig, slideState) {
      if (slideState.isExpanded()) {
        remove$6(component.element, getDimensionProperty(slideConfig));
        var fullSize = getDimension(slideConfig, component.element);
        set$7(component.element, getDimensionProperty(slideConfig), fullSize);
      }
    };
    var grow = function (component, slideConfig, slideState) {
      if (!slideState.isExpanded()) {
        doStartGrow(component, slideConfig, slideState);
      }
    };
    var shrink = function (component, slideConfig, slideState) {
      if (slideState.isExpanded()) {
        doStartSmartShrink(component, slideConfig, slideState);
      }
    };
    var immediateShrink = function (component, slideConfig, slideState) {
      if (slideState.isExpanded()) {
        doImmediateShrink(component, slideConfig, slideState);
      }
    };
    var hasGrown = function (component, slideConfig, slideState) {
      return slideState.isExpanded();
    };
    var hasShrunk = function (component, slideConfig, slideState) {
      return slideState.isCollapsed();
    };
    var isGrowing = function (component, slideConfig, _slideState) {
      var root = getAnimationRoot(component, slideConfig);
      return has(root, slideConfig.growingClass) === true;
    };
    var isShrinking = function (component, slideConfig, _slideState) {
      var root = getAnimationRoot(component, slideConfig);
      return has(root, slideConfig.shrinkingClass) === true;
    };
    var isTransitioning = function (component, slideConfig, slideState) {
      return isGrowing(component, slideConfig) || isShrinking(component, slideConfig);
    };
    var toggleGrow = function (component, slideConfig, slideState) {
      var f = slideState.isExpanded() ? doStartSmartShrink : doStartGrow;
      f(component, slideConfig, slideState);
    };

    var SlidingApis = /*#__PURE__*/Object.freeze({
        __proto__: null,
        refresh: refresh$3,
        grow: grow,
        shrink: shrink,
        immediateShrink: immediateShrink,
        hasGrown: hasGrown,
        hasShrunk: hasShrunk,
        isGrowing: isGrowing,
        isShrinking: isShrinking,
        isTransitioning: isTransitioning,
        toggleGrow: toggleGrow,
        disableTransitions: disableTransitions
    });

    var exhibit = function (base, slideConfig, _slideState) {
      var expanded = slideConfig.expanded;
      return expanded ? nu$7({
        classes: [slideConfig.openClass],
        styles: {}
      }) : nu$7({
        classes: [slideConfig.closedClass],
        styles: wrap$1(slideConfig.dimension.property, '0px')
      });
    };
    var events$4 = function (slideConfig, slideState) {
      return derive$2([runOnSource(transitionend(), function (component, simulatedEvent) {
          var raw = simulatedEvent.event.raw;
          if (raw.propertyName === slideConfig.dimension.property) {
            disableTransitions(component, slideConfig);
            if (slideState.isExpanded()) {
              remove$6(component.element, slideConfig.dimension.property);
            }
            var notify = slideState.isExpanded() ? slideConfig.onGrown : slideConfig.onShrunk;
            notify(component);
          }
        })]);
    };

    var ActiveSliding = /*#__PURE__*/Object.freeze({
        __proto__: null,
        exhibit: exhibit,
        events: events$4
    });

    var SlidingSchema = [
      required$1('closedClass'),
      required$1('openClass'),
      required$1('shrinkingClass'),
      required$1('growingClass'),
      option('getAnimationRoot'),
      onHandler('onShrunk'),
      onHandler('onStartShrink'),
      onHandler('onGrown'),
      onHandler('onStartGrow'),
      defaulted('expanded', false),
      requiredOf('dimension', choose$1('property', {
        width: [
          output$1('property', 'width'),
          output$1('getDimension', function (elem) {
            return get$a(elem) + 'px';
          })
        ],
        height: [
          output$1('property', 'height'),
          output$1('getDimension', function (elem) {
            return get$b(elem) + 'px';
          })
        ]
      }))
    ];

    var init$5 = function (spec) {
      var state = Cell(spec.expanded);
      var readState = function () {
        return 'expanded: ' + state.get();
      };
      return nu$8({
        isExpanded: function () {
          return state.get() === true;
        },
        isCollapsed: function () {
          return state.get() === false;
        },
        setCollapsed: curry(state.set, false),
        setExpanded: curry(state.set, true),
        readState: readState
      });
    };

    var SlidingState = /*#__PURE__*/Object.freeze({
        __proto__: null,
        init: init$5
    });

    var Sliding = create$7({
      fields: SlidingSchema,
      name: 'sliding',
      active: ActiveSliding,
      apis: SlidingApis,
      state: SlidingState
    });

    var owner = 'container';
    var schema$d = [field('slotBehaviours', [])];
    var getPartName = function (name) {
      return '<alloy.field.' + name + '>';
    };
    var sketch = function (sSpec) {
      var parts = function () {
        var record = [];
        var slot = function (name, config) {
          record.push(name);
          return generateOne$1(owner, getPartName(name), config);
        };
        return {
          slot: slot,
          record: constant$1(record)
        };
      }();
      var spec = sSpec(parts);
      var partNames = parts.record();
      var fieldParts = map$2(partNames, function (n) {
        return required({
          name: n,
          pname: getPartName(n)
        });
      });
      return composite$1(owner, schema$d, fieldParts, make$1, spec);
    };
    var make$1 = function (detail, components) {
      var getSlotNames = function (_) {
        return getAllPartNames(detail);
      };
      var getSlot = function (container, key) {
        return getPart(container, detail, key);
      };
      var onSlot = function (f, def) {
        return function (container, key) {
          return getPart(container, detail, key).map(function (slot) {
            return f(slot, key);
          }).getOr(def);
        };
      };
      var onSlots = function (f) {
        return function (container, keys) {
          each$1(keys, function (key) {
            return f(container, key);
          });
        };
      };
      var doShowing = function (comp, _key) {
        return get$d(comp.element, 'aria-hidden') !== 'true';
      };
      var doShow = function (comp, key) {
        if (!doShowing(comp)) {
          var element = comp.element;
          remove$6(element, 'display');
          remove$7(element, 'aria-hidden');
          emitWith(comp, slotVisibility(), {
            name: key,
            visible: true
          });
        }
      };
      var doHide = function (comp, key) {
        if (doShowing(comp)) {
          var element = comp.element;
          set$7(element, 'display', 'none');
          set$8(element, 'aria-hidden', 'true');
          emitWith(comp, slotVisibility(), {
            name: key,
            visible: false
          });
        }
      };
      var isShowing = onSlot(doShowing, false);
      var hideSlot = onSlot(doHide);
      var hideSlots = onSlots(hideSlot);
      var hideAllSlots = function (container) {
        return hideSlots(container, getSlotNames());
      };
      var showSlot = onSlot(doShow);
      var apis = {
        getSlotNames: getSlotNames,
        getSlot: getSlot,
        isShowing: isShowing,
        hideSlot: hideSlot,
        hideAllSlots: hideAllSlots,
        showSlot: showSlot
      };
      return {
        uid: detail.uid,
        dom: detail.dom,
        components: components,
        behaviours: get$2(detail.slotBehaviours),
        apis: apis
      };
    };
    var slotApis = map$1({
      getSlotNames: function (apis, c) {
        return apis.getSlotNames(c);
      },
      getSlot: function (apis, c, key) {
        return apis.getSlot(c, key);
      },
      isShowing: function (apis, c, key) {
        return apis.isShowing(c, key);
      },
      hideSlot: function (apis, c, key) {
        return apis.hideSlot(c, key);
      },
      hideAllSlots: function (apis, c) {
        return apis.hideAllSlots(c);
      },
      showSlot: function (apis, c, key) {
        return apis.showSlot(c, key);
      }
    }, function (value) {
      return makeApi(value);
    });
    var SlotContainer = __assign(__assign({}, slotApis), { sketch: sketch });

    var sidebarSchema = objOf([
      optionString('icon'),
      optionString('tooltip'),
      defaultedFunction('onShow', noop),
      defaultedFunction('onHide', noop),
      defaultedFunction('onSetup', function () {
        return noop;
      })
    ]);
    var createSidebar = function (spec) {
      return asRaw('sidebar', sidebarSchema, spec);
    };

    var setup$8 = function (editor) {
      var sidebars = editor.ui.registry.getAll().sidebars;
      each$1(keys(sidebars), function (name) {
        var spec = sidebars[name];
        var isActive = function () {
          return is$1(Optional.from(editor.queryCommandValue('ToggleSidebar')), name);
        };
        editor.ui.registry.addToggleButton(name, {
          icon: spec.icon,
          tooltip: spec.tooltip,
          onAction: function (buttonApi) {
            editor.execCommand('ToggleSidebar', false, name);
            buttonApi.setActive(isActive());
          },
          onSetup: function (buttonApi) {
            var handleToggle = function () {
              return buttonApi.setActive(isActive());
            };
            editor.on('ToggleSidebar', handleToggle);
            return function () {
              editor.off('ToggleSidebar', handleToggle);
            };
          }
        });
      });
    };
    var getApi = function (comp) {
      return {
        element: function () {
          return comp.element.dom;
        }
      };
    };
    var makePanels = function (parts, panelConfigs) {
      var specs = map$2(keys(panelConfigs), function (name) {
        var spec = panelConfigs[name];
        var bridged = getOrDie(createSidebar(spec));
        return {
          name: name,
          getApi: getApi,
          onSetup: bridged.onSetup,
          onShow: bridged.onShow,
          onHide: bridged.onHide
        };
      });
      return map$2(specs, function (spec) {
        var editorOffCell = Cell(noop);
        return parts.slot(spec.name, {
          dom: {
            tag: 'div',
            classes: ['tox-sidebar__pane']
          },
          behaviours: SimpleBehaviours.unnamedEvents([
            onControlAttached(spec, editorOffCell),
            onControlDetached(spec, editorOffCell),
            run$1(slotVisibility(), function (sidepanel, se) {
              var data = se.event;
              var optSidePanelSpec = find$5(specs, function (config) {
                return config.name === data.name;
              });
              optSidePanelSpec.each(function (sidePanelSpec) {
                var handler = data.visible ? sidePanelSpec.onShow : sidePanelSpec.onHide;
                handler(sidePanelSpec.getApi(sidepanel));
              });
            })
          ])
        });
      });
    };
    var makeSidebar = function (panelConfigs) {
      return SlotContainer.sketch(function (parts) {
        return {
          dom: {
            tag: 'div',
            classes: ['tox-sidebar__pane-container']
          },
          components: makePanels(parts, panelConfigs),
          slotBehaviours: SimpleBehaviours.unnamedEvents([runOnAttached(function (slotContainer) {
              return SlotContainer.hideAllSlots(slotContainer);
            })])
        };
      });
    };
    var setSidebar = function (sidebar, panelConfigs) {
      var optSlider = Composing.getCurrent(sidebar);
      optSlider.each(function (slider) {
        return Replacing.set(slider, [makeSidebar(panelConfigs)]);
      });
    };
    var toggleSidebar = function (sidebar, name) {
      var optSlider = Composing.getCurrent(sidebar);
      optSlider.each(function (slider) {
        var optSlotContainer = Composing.getCurrent(slider);
        optSlotContainer.each(function (slotContainer) {
          if (Sliding.hasGrown(slider)) {
            if (SlotContainer.isShowing(slotContainer, name)) {
              Sliding.shrink(slider);
            } else {
              SlotContainer.hideAllSlots(slotContainer);
              SlotContainer.showSlot(slotContainer, name);
            }
          } else {
            SlotContainer.hideAllSlots(slotContainer);
            SlotContainer.showSlot(slotContainer, name);
            Sliding.grow(slider);
          }
        });
      });
    };
    var whichSidebar = function (sidebar) {
      var optSlider = Composing.getCurrent(sidebar);
      return optSlider.bind(function (slider) {
        var sidebarOpen = Sliding.isGrowing(slider) || Sliding.hasGrown(slider);
        if (sidebarOpen) {
          var optSlotContainer = Composing.getCurrent(slider);
          return optSlotContainer.bind(function (slotContainer) {
            return find$5(SlotContainer.getSlotNames(slotContainer), function (name) {
              return SlotContainer.isShowing(slotContainer, name);
            });
          });
        } else {
          return Optional.none();
        }
      });
    };
    var fixSize = generate$6('FixSizeEvent');
    var autoSize = generate$6('AutoSizeEvent');
    var renderSidebar = function (spec) {
      return {
        uid: spec.uid,
        dom: {
          tag: 'div',
          classes: ['tox-sidebar'],
          attributes: { role: 'complementary' }
        },
        components: [{
            dom: {
              tag: 'div',
              classes: ['tox-sidebar__slider']
            },
            components: [],
            behaviours: derive$1([
              Tabstopping.config({}),
              Focusing.config({}),
              Sliding.config({
                dimension: { property: 'width' },
                closedClass: 'tox-sidebar--sliding-closed',
                openClass: 'tox-sidebar--sliding-open',
                shrinkingClass: 'tox-sidebar--sliding-shrinking',
                growingClass: 'tox-sidebar--sliding-growing',
                onShrunk: function (slider) {
                  var optSlotContainer = Composing.getCurrent(slider);
                  optSlotContainer.each(SlotContainer.hideAllSlots);
                  emit(slider, autoSize);
                },
                onGrown: function (slider) {
                  emit(slider, autoSize);
                },
                onStartGrow: function (slider) {
                  emitWith(slider, fixSize, { width: getRaw(slider.element, 'width').getOr('') });
                },
                onStartShrink: function (slider) {
                  emitWith(slider, fixSize, { width: get$a(slider.element) + 'px' });
                }
              }),
              Replacing.config({}),
              Composing.config({
                find: function (comp) {
                  var children = Replacing.contents(comp);
                  return head(children);
                }
              })
            ])
          }],
        behaviours: derive$1([
          ComposingConfigs.childAt(0),
          config('sidebar-sliding-events', [
            run$1(fixSize, function (comp, se) {
              set$7(comp.element, 'width', se.event.width);
            }),
            run$1(autoSize, function (comp, _se) {
              remove$6(comp.element, 'width');
            })
          ])
        ])
      };
    };

    var block = function (component, config, state, getBusySpec) {
      set$8(component.element, 'aria-busy', true);
      var root = config.getRoot(component).getOr(component);
      var blockerBehaviours = derive$1([
        Keying.config({
          mode: 'special',
          onTab: function () {
            return Optional.some(true);
          },
          onShiftTab: function () {
            return Optional.some(true);
          }
        }),
        Focusing.config({})
      ]);
      var blockSpec = getBusySpec(root, blockerBehaviours);
      var blocker = root.getSystem().build(blockSpec);
      Replacing.append(root, premade(blocker));
      if (blocker.hasConfigured(Keying) && config.focus) {
        Keying.focusIn(blocker);
      }
      if (!state.isBlocked()) {
        config.onBlock(component);
      }
      state.blockWith(function () {
        return Replacing.remove(root, blocker);
      });
    };
    var unblock = function (component, config, state) {
      remove$7(component.element, 'aria-busy');
      if (state.isBlocked()) {
        config.onUnblock(component);
      }
      state.clear();
    };

    var BlockingApis = /*#__PURE__*/Object.freeze({
        __proto__: null,
        block: block,
        unblock: unblock
    });

    var BlockingSchema = [
      defaultedFunction('getRoot', Optional.none),
      defaultedBoolean('focus', true),
      onHandler('onBlock'),
      onHandler('onUnblock')
    ];

    var init$4 = function () {
      var blocker = destroyable();
      var blockWith = function (destroy) {
        blocker.set({ destroy: destroy });
      };
      return nu$8({
        readState: blocker.isSet,
        blockWith: blockWith,
        clear: blocker.clear,
        isBlocked: blocker.isSet
      });
    };

    var BlockingState = /*#__PURE__*/Object.freeze({
        __proto__: null,
        init: init$4
    });

    var Blocking = create$7({
      fields: BlockingSchema,
      name: 'blocking',
      apis: BlockingApis,
      state: BlockingState
    });

    var getAttrs = function (elem) {
      var attributes = elem.dom.attributes !== undefined ? elem.dom.attributes : [];
      return foldl(attributes, function (b, attr) {
        var _a;
        if (attr.name === 'class') {
          return b;
        } else {
          return __assign(__assign({}, b), (_a = {}, _a[attr.name] = attr.value, _a));
        }
      }, {});
    };
    var getClasses = function (elem) {
      return Array.prototype.slice.call(elem.dom.classList, 0);
    };
    var fromHtml = function (html) {
      var elem = SugarElement.fromHtml(html);
      var children$1 = children(elem);
      var attrs = getAttrs(elem);
      var classes = getClasses(elem);
      var contents = children$1.length === 0 ? {} : { innerHtml: get$7(elem) };
      return __assign({
        tag: name$2(elem),
        classes: classes,
        attributes: attrs
      }, contents);
    };

    var getBusySpec$1 = function (providerBackstage) {
      return function (_root, _behaviours) {
        return {
          dom: {
            tag: 'div',
            attributes: {
              'aria-label': providerBackstage.translate('Loading...'),
              'tabindex': '0'
            },
            classes: ['tox-throbber__busy-spinner']
          },
          components: [{ dom: fromHtml('<div class="tox-spinner"><div></div><div></div><div></div></div>') }]
        };
      };
    };
    var focusBusyComponent = function (throbber) {
      return Composing.getCurrent(throbber).each(function (comp) {
        return focus$3(comp.element);
      });
    };
    var toggleEditorTabIndex = function (editor, state) {
      var tabIndexAttr = 'tabindex';
      var dataTabIndexAttr = 'data-mce-' + tabIndexAttr;
      Optional.from(editor.iframeElement).map(SugarElement.fromDom).each(function (iframe) {
        if (state) {
          getOpt(iframe, tabIndexAttr).each(function (tabIndex) {
            return set$8(iframe, dataTabIndexAttr, tabIndex);
          });
          set$8(iframe, tabIndexAttr, -1);
        } else {
          remove$7(iframe, tabIndexAttr);
          getOpt(iframe, dataTabIndexAttr).each(function (tabIndex) {
            set$8(iframe, tabIndexAttr, tabIndex);
            remove$7(iframe, dataTabIndexAttr);
          });
        }
      });
    };
    var toggleThrobber = function (editor, comp, state, providerBackstage) {
      var element = comp.element;
      toggleEditorTabIndex(editor, state);
      if (state) {
        Blocking.block(comp, getBusySpec$1(providerBackstage));
        remove$6(element, 'display');
        remove$7(element, 'aria-hidden');
        if (editor.hasFocus()) {
          focusBusyComponent(comp);
        }
      } else {
        var throbberFocus = Composing.getCurrent(comp).exists(function (busyComp) {
          return hasFocus(busyComp.element);
        });
        Blocking.unblock(comp);
        set$7(element, 'display', 'none');
        set$8(element, 'aria-hidden', 'true');
        if (throbberFocus) {
          editor.focus();
        }
      }
    };
    var renderThrobber = function (spec) {
      return {
        uid: spec.uid,
        dom: {
          tag: 'div',
          attributes: { 'aria-hidden': 'true' },
          classes: ['tox-throbber'],
          styles: { display: 'none' }
        },
        behaviours: derive$1([
          Replacing.config({}),
          Blocking.config({ focus: false }),
          Composing.config({
            find: function (comp) {
              return head(comp.components());
            }
          })
        ]),
        components: []
      };
    };
    var isFocusEvent = function (event) {
      return event.type === 'focusin';
    };
    var isPasteBinTarget = function (event) {
      if (isFocusEvent(event)) {
        var node = event.composed ? head(event.composedPath()) : Optional.from(event.target);
        return node.map(SugarElement.fromDom).filter(isElement$2).exists(function (targetElm) {
          return has(targetElm, 'mce-pastebin');
        });
      } else {
        return false;
      }
    };
    var setup$7 = function (editor, lazyThrobber, sharedBackstage) {
      var throbberState = Cell(false);
      var timer = value$1();
      var stealFocus = function (e) {
        if (throbberState.get() && !isPasteBinTarget(e)) {
          e.preventDefault();
          focusBusyComponent(lazyThrobber());
          editor.editorManager.setActive(editor);
        }
      };
      if (!editor.inline) {
        editor.on('PreInit', function () {
          editor.dom.bind(editor.getWin(), 'focusin', stealFocus);
          editor.on('BeforeExecCommand', function (e) {
            if (e.command.toLowerCase() === 'mcefocus' && e.value !== true) {
              stealFocus(e);
            }
          });
        });
      }
      var toggle = function (state) {
        if (state !== throbberState.get()) {
          throbberState.set(state);
          toggleThrobber(editor, lazyThrobber(), state, sharedBackstage.providers);
          editor.fire('AfterProgressState', { state: state });
        }
      };
      editor.on('ProgressState', function (e) {
        timer.on(global$f.clearTimeout);
        if (isNumber(e.time)) {
          var timerId = global$f.setEditorTimeout(editor, function () {
            return toggle(e.state);
          }, e.time);
          timer.set(timerId);
        } else {
          toggle(e.state);
          timer.clear();
        }
      });
    };

    var generate$1 = function (xs, f) {
      var init = {
        len: 0,
        list: []
      };
      var r = foldl(xs, function (b, a) {
        var value = f(a, b.len);
        return value.fold(constant$1(b), function (v) {
          return {
            len: v.finish,
            list: b.list.concat([v])
          };
        });
      }, init);
      return r.list;
    };

    var output = function (within, extra, withinWidth) {
      return {
        within: within,
        extra: extra,
        withinWidth: withinWidth
      };
    };
    var apportion = function (units, total, len) {
      var parray = generate$1(units, function (unit, current) {
        var width = len(unit);
        return Optional.some({
          element: unit,
          start: current,
          finish: current + width,
          width: width
        });
      });
      var within = filter$2(parray, function (unit) {
        return unit.finish <= total;
      });
      var withinWidth = foldr(within, function (acc, el) {
        return acc + el.width;
      }, 0);
      var extra = parray.slice(within.length);
      return {
        within: within,
        extra: extra,
        withinWidth: withinWidth
      };
    };
    var toUnit = function (parray) {
      return map$2(parray, function (unit) {
        return unit.element;
      });
    };
    var fitLast = function (within, extra, withinWidth) {
      var fits = toUnit(within.concat(extra));
      return output(fits, [], withinWidth);
    };
    var overflow = function (within, extra, overflower, withinWidth) {
      var fits = toUnit(within).concat([overflower]);
      return output(fits, toUnit(extra), withinWidth);
    };
    var fitAll = function (within, extra, withinWidth) {
      return output(toUnit(within), [], withinWidth);
    };
    var tryFit = function (total, units, len) {
      var divide = apportion(units, total, len);
      return divide.extra.length === 0 ? Optional.some(divide) : Optional.none();
    };
    var partition = function (total, units, len, overflower) {
      var divide = tryFit(total, units, len).getOrThunk(function () {
        return apportion(units, total - len(overflower), len);
      });
      var within = divide.within;
      var extra = divide.extra;
      var withinWidth = divide.withinWidth;
      if (extra.length === 1 && extra[0].width <= len(overflower)) {
        return fitLast(within, extra, withinWidth);
      } else if (extra.length >= 1) {
        return overflow(within, extra, overflower, withinWidth);
      } else {
        return fitAll(within, extra, withinWidth);
      }
    };

    var setGroups$1 = function (toolbar, storedGroups) {
      var bGroups = map$2(storedGroups, function (g) {
        return premade(g);
      });
      Toolbar.setGroups(toolbar, bGroups);
    };
    var findFocusedComp = function (comps) {
      return findMap(comps, function (comp) {
        return search(comp.element).bind(function (focusedElm) {
          return comp.getSystem().getByDom(focusedElm).toOptional();
        });
      });
    };
    var refresh$2 = function (toolbar, detail, setOverflow) {
      var builtGroups = detail.builtGroups.get();
      if (builtGroups.length === 0) {
        return;
      }
      var primary = getPartOrDie(toolbar, detail, 'primary');
      var overflowGroup = Coupling.getCoupled(toolbar, 'overflowGroup');
      set$7(primary.element, 'visibility', 'hidden');
      var groups = builtGroups.concat([overflowGroup]);
      var focusedComp = findFocusedComp(groups);
      setOverflow([]);
      setGroups$1(primary, groups);
      var availableWidth = get$a(primary.element);
      var overflows = partition(availableWidth, detail.builtGroups.get(), function (comp) {
        return get$a(comp.element);
      }, overflowGroup);
      if (overflows.extra.length === 0) {
        Replacing.remove(primary, overflowGroup);
        setOverflow([]);
      } else {
        setGroups$1(primary, overflows.within);
        setOverflow(overflows.extra);
      }
      remove$6(primary.element, 'visibility');
      reflow(primary.element);
      focusedComp.each(Focusing.focus);
    };

    var schema$c = constant$1([
      field('splitToolbarBehaviours', [Coupling]),
      customField('builtGroups', function () {
        return Cell([]);
      })
    ]);

    var schema$b = constant$1([
      markers$1(['overflowToggledClass']),
      optionFunction('getOverflowBounds'),
      required$1('lazySink'),
      customField('overflowGroups', function () {
        return Cell([]);
      })
    ].concat(schema$c()));
    var parts$7 = constant$1([
      required({
        factory: Toolbar,
        schema: schema$e(),
        name: 'primary'
      }),
      external$1({
        schema: schema$e(),
        name: 'overflow'
      }),
      external$1({ name: 'overflow-button' }),
      external$1({ name: 'overflow-group' })
    ]);

    var expandable = constant$1(function (element, available) {
      setMax(element, Math.floor(available));
    });

    var schema$a = constant$1([
      markers$1(['toggledClass']),
      required$1('lazySink'),
      requiredFunction('fetch'),
      optionFunction('getBounds'),
      optionObjOf('fireDismissalEventInstead', [defaulted('event', dismissRequested())]),
      schema$y()
    ]);
    var parts$6 = constant$1([
      external$1({
        name: 'button',
        overrides: function (detail) {
          return {
            dom: { attributes: { 'aria-haspopup': 'true' } },
            buttonBehaviours: derive$1([Toggling.config({
                toggleClass: detail.markers.toggledClass,
                aria: { mode: 'expanded' },
                toggleOnExecute: false
              })])
          };
        }
      }),
      external$1({
        factory: Toolbar,
        schema: schema$e(),
        name: 'toolbar',
        overrides: function (detail) {
          return {
            toolbarBehaviours: derive$1([Keying.config({
                mode: 'cyclic',
                onEscape: function (comp) {
                  getPart(comp, detail, 'button').each(Focusing.focus);
                  return Optional.none();
                }
              })])
          };
        }
      })
    ]);

    var toggle = function (button, externals) {
      var toolbarSandbox = Coupling.getCoupled(button, 'toolbarSandbox');
      if (Sandboxing.isOpen(toolbarSandbox)) {
        Sandboxing.close(toolbarSandbox);
      } else {
        Sandboxing.open(toolbarSandbox, externals.toolbar());
      }
    };
    var position = function (button, toolbar, detail, layouts) {
      var bounds = detail.getBounds.map(function (bounder) {
        return bounder();
      });
      var sink = detail.lazySink(button).getOrDie();
      Positioning.positionWithinBounds(sink, toolbar, {
        anchor: {
          type: 'hotspot',
          hotspot: button,
          layouts: layouts,
          overrides: { maxWidthFunction: expandable() }
        }
      }, bounds);
    };
    var setGroups = function (button, toolbar, detail, layouts, groups) {
      Toolbar.setGroups(toolbar, groups);
      position(button, toolbar, detail, layouts);
      Toggling.on(button);
    };
    var makeSandbox = function (button, spec, detail) {
      var ariaOwner = manager();
      var onOpen = function (sandbox, toolbar) {
        detail.fetch().get(function (groups) {
          setGroups(button, toolbar, detail, spec.layouts, groups);
          ariaOwner.link(button.element);
          Keying.focusIn(toolbar);
        });
      };
      var onClose = function () {
        Toggling.off(button);
        Focusing.focus(button);
        ariaOwner.unlink(button.element);
      };
      return {
        dom: {
          tag: 'div',
          attributes: { id: ariaOwner.id }
        },
        behaviours: derive$1([
          Keying.config({
            mode: 'special',
            onEscape: function (comp) {
              Sandboxing.close(comp);
              return Optional.some(true);
            }
          }),
          Sandboxing.config({
            onOpen: onOpen,
            onClose: onClose,
            isPartOf: function (container, data, queryElem) {
              return isPartOf$1(data, queryElem) || isPartOf$1(button, queryElem);
            },
            getAttachPoint: function () {
              return detail.lazySink(button).getOrDie();
            }
          }),
          Receiving.config({
            channels: __assign(__assign({}, receivingChannel$1(__assign({ isExtraPart: never }, detail.fireDismissalEventInstead.map(function (fe) {
              return { fireEventInstead: { event: fe.event } };
            }).getOr({})))), receivingChannel({
              doReposition: function () {
                Sandboxing.getState(Coupling.getCoupled(button, 'toolbarSandbox')).each(function (toolbar) {
                  position(button, toolbar, detail, spec.layouts);
                });
              }
            }))
          })
        ])
      };
    };
    var factory$a = function (detail, components, spec, externals) {
      return __assign(__assign({}, Button.sketch(__assign(__assign({}, externals.button()), {
        action: function (button) {
          toggle(button, externals);
        },
        buttonBehaviours: SketchBehaviours.augment({ dump: externals.button().buttonBehaviours }, [Coupling.config({
            others: {
              toolbarSandbox: function (button) {
                return makeSandbox(button, spec, detail);
              }
            }
          })])
      }))), {
        apis: {
          setGroups: function (button, groups) {
            Sandboxing.getState(Coupling.getCoupled(button, 'toolbarSandbox')).each(function (toolbar) {
              setGroups(button, toolbar, detail, spec.layouts, groups);
            });
          },
          reposition: function (button) {
            Sandboxing.getState(Coupling.getCoupled(button, 'toolbarSandbox')).each(function (toolbar) {
              position(button, toolbar, detail, spec.layouts);
            });
          },
          toggle: function (button) {
            toggle(button, externals);
          },
          getToolbar: function (button) {
            return Sandboxing.getState(Coupling.getCoupled(button, 'toolbarSandbox'));
          },
          isOpen: function (button) {
            return Sandboxing.isOpen(Coupling.getCoupled(button, 'toolbarSandbox'));
          }
        }
      });
    };
    var FloatingToolbarButton = composite({
      name: 'FloatingToolbarButton',
      factory: factory$a,
      configFields: schema$a(),
      partFields: parts$6(),
      apis: {
        setGroups: function (apis, button, groups) {
          apis.setGroups(button, groups);
        },
        reposition: function (apis, button) {
          apis.reposition(button);
        },
        toggle: function (apis, button) {
          apis.toggle(button);
        },
        getToolbar: function (apis, button) {
          return apis.getToolbar(button);
        },
        isOpen: function (apis, button) {
          return apis.isOpen(button);
        }
      }
    });

    var schema$9 = constant$1([
      required$1('items'),
      markers$1(['itemSelector']),
      field('tgroupBehaviours', [Keying])
    ]);
    var parts$5 = constant$1([group({
        name: 'items',
        unit: 'item'
      })]);

    var factory$9 = function (detail, components, _spec, _externals) {
      return {
        uid: detail.uid,
        dom: detail.dom,
        components: components,
        behaviours: augment(detail.tgroupBehaviours, [Keying.config({
            mode: 'flow',
            selector: detail.markers.itemSelector
          })]),
        domModification: { attributes: { role: 'toolbar' } }
      };
    };
    var ToolbarGroup = composite({
      name: 'ToolbarGroup',
      configFields: schema$9(),
      partFields: parts$5(),
      factory: factory$9
    });

    var buildGroups = function (comps) {
      return map$2(comps, function (g) {
        return premade(g);
      });
    };
    var refresh$1 = function (toolbar, memFloatingToolbarButton, detail) {
      refresh$2(toolbar, detail, function (overflowGroups) {
        detail.overflowGroups.set(overflowGroups);
        memFloatingToolbarButton.getOpt(toolbar).each(function (floatingToolbarButton) {
          FloatingToolbarButton.setGroups(floatingToolbarButton, buildGroups(overflowGroups));
        });
      });
    };
    var factory$8 = function (detail, components, spec, externals) {
      var memFloatingToolbarButton = record(FloatingToolbarButton.sketch({
        fetch: function () {
          return Future.nu(function (resolve) {
            resolve(buildGroups(detail.overflowGroups.get()));
          });
        },
        layouts: {
          onLtr: function () {
            return [
              southwest$2,
              southeast$2
            ];
          },
          onRtl: function () {
            return [
              southeast$2,
              southwest$2
            ];
          },
          onBottomLtr: function () {
            return [
              northwest$2,
              northeast$2
            ];
          },
          onBottomRtl: function () {
            return [
              northeast$2,
              northwest$2
            ];
          }
        },
        getBounds: spec.getOverflowBounds,
        lazySink: detail.lazySink,
        fireDismissalEventInstead: {},
        markers: { toggledClass: detail.markers.overflowToggledClass },
        parts: {
          button: externals['overflow-button'](),
          toolbar: externals.overflow()
        }
      }));
      return {
        uid: detail.uid,
        dom: detail.dom,
        components: components,
        behaviours: augment(detail.splitToolbarBehaviours, [Coupling.config({
            others: {
              overflowGroup: function () {
                return ToolbarGroup.sketch(__assign(__assign({}, externals['overflow-group']()), { items: [memFloatingToolbarButton.asSpec()] }));
              }
            }
          })]),
        apis: {
          setGroups: function (toolbar, groups) {
            detail.builtGroups.set(map$2(groups, toolbar.getSystem().build));
            refresh$1(toolbar, memFloatingToolbarButton, detail);
          },
          refresh: function (toolbar) {
            return refresh$1(toolbar, memFloatingToolbarButton, detail);
          },
          toggle: function (toolbar) {
            memFloatingToolbarButton.getOpt(toolbar).each(function (floatingToolbarButton) {
              FloatingToolbarButton.toggle(floatingToolbarButton);
            });
          },
          isOpen: function (toolbar) {
            return memFloatingToolbarButton.getOpt(toolbar).map(FloatingToolbarButton.isOpen).getOr(false);
          },
          reposition: function (toolbar) {
            memFloatingToolbarButton.getOpt(toolbar).each(function (floatingToolbarButton) {
              FloatingToolbarButton.reposition(floatingToolbarButton);
            });
          },
          getOverflow: function (toolbar) {
            return memFloatingToolbarButton.getOpt(toolbar).bind(FloatingToolbarButton.getToolbar);
          }
        },
        domModification: { attributes: { role: 'group' } }
      };
    };
    var SplitFloatingToolbar = composite({
      name: 'SplitFloatingToolbar',
      configFields: schema$b(),
      partFields: parts$7(),
      factory: factory$8,
      apis: {
        setGroups: function (apis, toolbar, groups) {
          apis.setGroups(toolbar, groups);
        },
        refresh: function (apis, toolbar) {
          apis.refresh(toolbar);
        },
        reposition: function (apis, toolbar) {
          apis.reposition(toolbar);
        },
        toggle: function (apis, toolbar) {
          apis.toggle(toolbar);
        },
        isOpen: function (apis, toolbar) {
          return apis.isOpen(toolbar);
        },
        getOverflow: function (apis, toolbar) {
          return apis.getOverflow(toolbar);
        }
      }
    });

    var schema$8 = constant$1([
      markers$1([
        'closedClass',
        'openClass',
        'shrinkingClass',
        'growingClass',
        'overflowToggledClass'
      ]),
      onHandler('onOpened'),
      onHandler('onClosed')
    ].concat(schema$c()));
    var parts$4 = constant$1([
      required({
        factory: Toolbar,
        schema: schema$e(),
        name: 'primary'
      }),
      required({
        factory: Toolbar,
        schema: schema$e(),
        name: 'overflow',
        overrides: function (detail) {
          return {
            toolbarBehaviours: derive$1([
              Sliding.config({
                dimension: { property: 'height' },
                closedClass: detail.markers.closedClass,
                openClass: detail.markers.openClass,
                shrinkingClass: detail.markers.shrinkingClass,
                growingClass: detail.markers.growingClass,
                onShrunk: function (comp) {
                  getPart(comp, detail, 'overflow-button').each(function (button) {
                    Toggling.off(button);
                    Focusing.focus(button);
                  });
                  detail.onClosed(comp);
                },
                onGrown: function (comp) {
                  Keying.focusIn(comp);
                  detail.onOpened(comp);
                },
                onStartGrow: function (comp) {
                  getPart(comp, detail, 'overflow-button').each(Toggling.on);
                }
              }),
              Keying.config({
                mode: 'acyclic',
                onEscape: function (comp) {
                  getPart(comp, detail, 'overflow-button').each(Focusing.focus);
                  return Optional.some(true);
                }
              })
            ])
          };
        }
      }),
      external$1({
        name: 'overflow-button',
        overrides: function (detail) {
          return {
            buttonBehaviours: derive$1([Toggling.config({
                toggleClass: detail.markers.overflowToggledClass,
                aria: { mode: 'pressed' },
                toggleOnExecute: false
              })])
          };
        }
      }),
      external$1({ name: 'overflow-group' })
    ]);

    var isOpen = function (toolbar, detail) {
      return getPart(toolbar, detail, 'overflow').map(Sliding.hasGrown).getOr(false);
    };
    var toggleToolbar = function (toolbar, detail) {
      getPart(toolbar, detail, 'overflow-button').bind(function () {
        return getPart(toolbar, detail, 'overflow');
      }).each(function (overf) {
        refresh(toolbar, detail);
        Sliding.toggleGrow(overf);
      });
    };
    var refresh = function (toolbar, detail) {
      getPart(toolbar, detail, 'overflow').each(function (overflow) {
        refresh$2(toolbar, detail, function (groups) {
          var builtGroups = map$2(groups, function (g) {
            return premade(g);
          });
          Toolbar.setGroups(overflow, builtGroups);
        });
        getPart(toolbar, detail, 'overflow-button').each(function (button) {
          if (Sliding.hasGrown(overflow)) {
            Toggling.on(button);
          }
        });
        Sliding.refresh(overflow);
      });
    };
    var factory$7 = function (detail, components, spec, externals) {
      var toolbarToggleEvent = 'alloy.toolbar.toggle';
      var doSetGroups = function (toolbar, groups) {
        var built = map$2(groups, toolbar.getSystem().build);
        detail.builtGroups.set(built);
      };
      return {
        uid: detail.uid,
        dom: detail.dom,
        components: components,
        behaviours: augment(detail.splitToolbarBehaviours, [
          Coupling.config({
            others: {
              overflowGroup: function (toolbar) {
                return ToolbarGroup.sketch(__assign(__assign({}, externals['overflow-group']()), {
                  items: [Button.sketch(__assign(__assign({}, externals['overflow-button']()), {
                      action: function (_button) {
                        emit(toolbar, toolbarToggleEvent);
                      }
                    }))]
                }));
              }
            }
          }),
          config('toolbar-toggle-events', [run$1(toolbarToggleEvent, function (toolbar) {
              toggleToolbar(toolbar, detail);
            })])
        ]),
        apis: {
          setGroups: function (toolbar, groups) {
            doSetGroups(toolbar, groups);
            refresh(toolbar, detail);
          },
          refresh: function (toolbar) {
            return refresh(toolbar, detail);
          },
          toggle: function (toolbar) {
            return toggleToolbar(toolbar, detail);
          },
          isOpen: function (toolbar) {
            return isOpen(toolbar, detail);
          }
        },
        domModification: { attributes: { role: 'group' } }
      };
    };
    var SplitSlidingToolbar = composite({
      name: 'SplitSlidingToolbar',
      configFields: schema$8(),
      partFields: parts$4(),
      factory: factory$7,
      apis: {
        setGroups: function (apis, toolbar, groups) {
          apis.setGroups(toolbar, groups);
        },
        refresh: function (apis, toolbar) {
          apis.refresh(toolbar);
        },
        toggle: function (apis, toolbar) {
          apis.toggle(toolbar);
        },
        isOpen: function (apis, toolbar) {
          return apis.isOpen(toolbar);
        }
      }
    });

    var renderToolbarGroupCommon = function (toolbarGroup) {
      var attributes = toolbarGroup.title.fold(function () {
        return {};
      }, function (title) {
        return { attributes: { title: title } };
      });
      return {
        dom: __assign({
          tag: 'div',
          classes: ['tox-toolbar__group']
        }, attributes),
        components: [ToolbarGroup.parts.items({})],
        items: toolbarGroup.items,
        markers: { itemSelector: '*:not(.tox-split-button) > .tox-tbtn:not([disabled]), ' + '.tox-split-button:not([disabled]), ' + '.tox-toolbar-nav-js:not([disabled])' },
        tgroupBehaviours: derive$1([
          Tabstopping.config({}),
          Focusing.config({})
        ])
      };
    };
    var renderToolbarGroup = function (toolbarGroup) {
      return ToolbarGroup.sketch(renderToolbarGroupCommon(toolbarGroup));
    };
    var getToolbarbehaviours = function (toolbarSpec, modeName) {
      var onAttached = runOnAttached(function (component) {
        var groups = map$2(toolbarSpec.initGroups, renderToolbarGroup);
        Toolbar.setGroups(component, groups);
      });
      return derive$1([
        DisablingConfigs.toolbarButton(toolbarSpec.providers.isDisabled),
        receivingConfig(),
        Keying.config({
          mode: modeName,
          onEscape: toolbarSpec.onEscape,
          selector: '.tox-toolbar__group'
        }),
        config('toolbar-events', [onAttached])
      ]);
    };
    var renderMoreToolbarCommon = function (toolbarSpec) {
      var modeName = toolbarSpec.cyclicKeying ? 'cyclic' : 'acyclic';
      return {
        uid: toolbarSpec.uid,
        dom: {
          tag: 'div',
          classes: ['tox-toolbar-overlord']
        },
        parts: {
          'overflow-group': renderToolbarGroupCommon({
            title: Optional.none(),
            items: []
          }),
          'overflow-button': renderIconButtonSpec({
            name: 'more',
            icon: Optional.some('more-drawer'),
            disabled: false,
            tooltip: Optional.some('More...'),
            primary: false,
            borderless: false
          }, Optional.none(), toolbarSpec.providers)
        },
        splitToolbarBehaviours: getToolbarbehaviours(toolbarSpec, modeName)
      };
    };
    var renderFloatingMoreToolbar = function (toolbarSpec) {
      var baseSpec = renderMoreToolbarCommon(toolbarSpec);
      var overflowXOffset = 4;
      var primary = SplitFloatingToolbar.parts.primary({
        dom: {
          tag: 'div',
          classes: ['tox-toolbar__primary']
        }
      });
      return SplitFloatingToolbar.sketch(__assign(__assign({}, baseSpec), {
        lazySink: toolbarSpec.getSink,
        getOverflowBounds: function () {
          var headerElem = toolbarSpec.moreDrawerData.lazyHeader().element;
          var headerBounds = absolute$2(headerElem);
          var docElem = documentElement(headerElem);
          var docBounds = absolute$2(docElem);
          var height = Math.max(docElem.dom.scrollHeight, docBounds.height);
          return bounds(headerBounds.x + overflowXOffset, docBounds.y, headerBounds.width - overflowXOffset * 2, height);
        },
        parts: __assign(__assign({}, baseSpec.parts), {
          overflow: {
            dom: {
              tag: 'div',
              classes: ['tox-toolbar__overflow'],
              attributes: toolbarSpec.attributes
            }
          }
        }),
        components: [primary],
        markers: { overflowToggledClass: 'tox-tbtn--enabled' }
      }));
    };
    var renderSlidingMoreToolbar = function (toolbarSpec) {
      var primary = SplitSlidingToolbar.parts.primary({
        dom: {
          tag: 'div',
          classes: ['tox-toolbar__primary']
        }
      });
      var overflow = SplitSlidingToolbar.parts.overflow({
        dom: {
          tag: 'div',
          classes: ['tox-toolbar__overflow']
        }
      });
      var baseSpec = renderMoreToolbarCommon(toolbarSpec);
      return SplitSlidingToolbar.sketch(__assign(__assign({}, baseSpec), {
        components: [
          primary,
          overflow
        ],
        markers: {
          openClass: 'tox-toolbar__overflow--open',
          closedClass: 'tox-toolbar__overflow--closed',
          growingClass: 'tox-toolbar__overflow--growing',
          shrinkingClass: 'tox-toolbar__overflow--shrinking',
          overflowToggledClass: 'tox-tbtn--enabled'
        },
        onOpened: function (comp) {
          comp.getSystem().broadcastOn([toolbarHeightChange()], { type: 'opened' });
        },
        onClosed: function (comp) {
          comp.getSystem().broadcastOn([toolbarHeightChange()], { type: 'closed' });
        }
      }));
    };
    var renderToolbar = function (toolbarSpec) {
      var modeName = toolbarSpec.cyclicKeying ? 'cyclic' : 'acyclic';
      return Toolbar.sketch({
        uid: toolbarSpec.uid,
        dom: {
          tag: 'div',
          classes: ['tox-toolbar'].concat(toolbarSpec.type === ToolbarMode.scrolling ? ['tox-toolbar--scrolling'] : [])
        },
        components: [Toolbar.parts.groups({})],
        toolbarBehaviours: getToolbarbehaviours(toolbarSpec, modeName)
      });
    };

    var factory$6 = function (detail, components, _spec) {
      var apis = {
        getSocket: function (comp) {
          return parts$a.getPart(comp, detail, 'socket');
        },
        setSidebar: function (comp, panelConfigs) {
          parts$a.getPart(comp, detail, 'sidebar').each(function (sidebar) {
            return setSidebar(sidebar, panelConfigs);
          });
        },
        toggleSidebar: function (comp, name) {
          parts$a.getPart(comp, detail, 'sidebar').each(function (sidebar) {
            return toggleSidebar(sidebar, name);
          });
        },
        whichSidebar: function (comp) {
          return parts$a.getPart(comp, detail, 'sidebar').bind(whichSidebar).getOrNull();
        },
        getHeader: function (comp) {
          return parts$a.getPart(comp, detail, 'header');
        },
        getToolbar: function (comp) {
          return parts$a.getPart(comp, detail, 'toolbar');
        },
        setToolbar: function (comp, groups) {
          parts$a.getPart(comp, detail, 'toolbar').each(function (toolbar) {
            toolbar.getApis().setGroups(toolbar, groups);
          });
        },
        setToolbars: function (comp, toolbars) {
          parts$a.getPart(comp, detail, 'multiple-toolbar').each(function (mToolbar) {
            CustomList.setItems(mToolbar, toolbars);
          });
        },
        refreshToolbar: function (comp) {
          var toolbar = parts$a.getPart(comp, detail, 'toolbar');
          toolbar.each(function (toolbar) {
            return toolbar.getApis().refresh(toolbar);
          });
        },
        toggleToolbarDrawer: function (comp) {
          parts$a.getPart(comp, detail, 'toolbar').each(function (toolbar) {
            mapFrom(toolbar.getApis().toggle, function (toggle) {
              return toggle(toolbar);
            });
          });
        },
        isToolbarDrawerToggled: function (comp) {
          return parts$a.getPart(comp, detail, 'toolbar').bind(function (toolbar) {
            return Optional.from(toolbar.getApis().isOpen).map(function (isOpen) {
              return isOpen(toolbar);
            });
          }).getOr(false);
        },
        getThrobber: function (comp) {
          return parts$a.getPart(comp, detail, 'throbber');
        },
        focusToolbar: function (comp) {
          var optToolbar = parts$a.getPart(comp, detail, 'toolbar').orThunk(function () {
            return parts$a.getPart(comp, detail, 'multiple-toolbar');
          });
          optToolbar.each(function (toolbar) {
            Keying.focusIn(toolbar);
          });
        },
        setMenubar: function (comp, menus) {
          parts$a.getPart(comp, detail, 'menubar').each(function (menubar) {
            SilverMenubar.setMenus(menubar, menus);
          });
        },
        focusMenubar: function (comp) {
          parts$a.getPart(comp, detail, 'menubar').each(function (menubar) {
            SilverMenubar.focus(menubar);
          });
        }
      };
      return {
        uid: detail.uid,
        dom: detail.dom,
        components: components,
        apis: apis,
        behaviours: detail.behaviours
      };
    };
    var partMenubar = partType.optional({
      factory: SilverMenubar,
      name: 'menubar',
      schema: [required$1('backstage')]
    });
    var toolbarFactory = function (spec) {
      if (spec.type === ToolbarMode.sliding) {
        return renderSlidingMoreToolbar;
      } else if (spec.type === ToolbarMode.floating) {
        return renderFloatingMoreToolbar;
      } else {
        return renderToolbar;
      }
    };
    var partMultipleToolbar = partType.optional({
      factory: {
        sketch: function (spec) {
          return CustomList.sketch({
            uid: spec.uid,
            dom: spec.dom,
            listBehaviours: derive$1([Keying.config({
                mode: 'acyclic',
                selector: '.tox-toolbar'
              })]),
            makeItem: function () {
              return renderToolbar({
                type: spec.type,
                uid: generate$6('multiple-toolbar-item'),
                cyclicKeying: false,
                initGroups: [],
                providers: spec.providers,
                onEscape: function () {
                  spec.onEscape();
                  return Optional.some(true);
                }
              });
            },
            setupItem: function (_mToolbar, tc, data, _index) {
              Toolbar.setGroups(tc, data);
            },
            shell: true
          });
        }
      },
      name: 'multiple-toolbar',
      schema: [
        required$1('dom'),
        required$1('onEscape')
      ]
    });
    var partToolbar = partType.optional({
      factory: {
        sketch: function (spec) {
          var renderer = toolbarFactory(spec);
          var toolbarSpec = {
            type: spec.type,
            uid: spec.uid,
            onEscape: function () {
              spec.onEscape();
              return Optional.some(true);
            },
            cyclicKeying: false,
            initGroups: [],
            getSink: spec.getSink,
            providers: spec.providers,
            moreDrawerData: {
              lazyToolbar: spec.lazyToolbar,
              lazyMoreButton: spec.lazyMoreButton,
              lazyHeader: spec.lazyHeader
            },
            attributes: spec.attributes
          };
          return renderer(toolbarSpec);
        }
      },
      name: 'toolbar',
      schema: [
        required$1('dom'),
        required$1('onEscape'),
        required$1('getSink')
      ]
    });
    var partHeader = partType.optional({
      factory: { sketch: renderHeader },
      name: 'header',
      schema: [required$1('dom')]
    });
    var partSocket = partType.optional({
      name: 'socket',
      schema: [required$1('dom')]
    });
    var partSidebar = partType.optional({
      factory: { sketch: renderSidebar },
      name: 'sidebar',
      schema: [required$1('dom')]
    });
    var partThrobber = partType.optional({
      factory: { sketch: renderThrobber },
      name: 'throbber',
      schema: [required$1('dom')]
    });
    var OuterContainer = composite({
      name: 'OuterContainer',
      factory: factory$6,
      configFields: [
        required$1('dom'),
        required$1('behaviours')
      ],
      partFields: [
        partHeader,
        partMenubar,
        partToolbar,
        partMultipleToolbar,
        partSocket,
        partSidebar,
        partThrobber
      ],
      apis: {
        getSocket: function (apis, comp) {
          return apis.getSocket(comp);
        },
        setSidebar: function (apis, comp, panelConfigs) {
          apis.setSidebar(comp, panelConfigs);
        },
        toggleSidebar: function (apis, comp, name) {
          apis.toggleSidebar(comp, name);
        },
        whichSidebar: function (apis, comp) {
          return apis.whichSidebar(comp);
        },
        getHeader: function (apis, comp) {
          return apis.getHeader(comp);
        },
        getToolbar: function (apis, comp) {
          return apis.getToolbar(comp);
        },
        setToolbar: function (apis, comp, grps) {
          var groups = map$2(grps, function (grp) {
            return renderToolbarGroup(grp);
          });
          apis.setToolbar(comp, groups);
        },
        setToolbars: function (apis, comp, ts) {
          var renderedToolbars = map$2(ts, function (g) {
            return map$2(g, renderToolbarGroup);
          });
          apis.setToolbars(comp, renderedToolbars);
        },
        refreshToolbar: function (apis, comp) {
          return apis.refreshToolbar(comp);
        },
        toggleToolbarDrawer: function (apis, comp) {
          apis.toggleToolbarDrawer(comp);
        },
        isToolbarDrawerToggled: function (apis, comp) {
          return apis.isToolbarDrawerToggled(comp);
        },
        getThrobber: function (apis, comp) {
          return apis.getThrobber(comp);
        },
        setMenubar: function (apis, comp, menus) {
          apis.setMenubar(comp, menus);
        },
        focusMenubar: function (apis, comp) {
          apis.focusMenubar(comp);
        },
        focusToolbar: function (apis, comp) {
          apis.focusToolbar(comp);
        }
      }
    });

    var defaultMenubar = 'file edit view insert format tools table help';
    var defaultMenus = {
      file: {
        title: 'File',
        items: 'newdocument restoredraft | preview | export print | deleteallconversations'
      },
      edit: {
        title: 'Edit',
        items: 'undo redo | cut copy paste pastetext | selectall | searchreplace'
      },
      view: {
        title: 'View',
        items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen | showcomments'
      },
      insert: {
        title: 'Insert',
        items: 'image link media addcomment pageembed template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor toc | insertdatetime'
      },
      format: {
        title: 'Format',
        items: 'bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontformats fontsizes align lineheight | forecolor backcolor | language | removeformat'
      },
      tools: {
        title: 'Tools',
        items: 'spellchecker spellcheckerlanguage | a11ycheck code wordcount'
      },
      table: {
        title: 'Table',
        items: 'inserttable | cell row column | advtablesort | tableprops deletetable'
      },
      help: {
        title: 'Help',
        items: 'help'
      }
    };
    var make = function (menu, registry, editor) {
      var removedMenuItems = getRemovedMenuItems(editor).split(/[ ,]/);
      return {
        text: menu.title,
        getItems: function () {
          return bind$3(menu.items, function (i) {
            var itemName = i.toLowerCase();
            if (itemName.trim().length === 0) {
              return [];
            } else if (exists(removedMenuItems, function (removedMenuItem) {
                return removedMenuItem === itemName;
              })) {
              return [];
            } else if (itemName === 'separator' || itemName === '|') {
              return [{ type: 'separator' }];
            } else if (registry.menuItems[itemName]) {
              return [registry.menuItems[itemName]];
            } else {
              return [];
            }
          });
        }
      };
    };
    var parseItemsString = function (items) {
      if (typeof items === 'string') {
        return items.split(' ');
      }
      return items;
    };
    var identifyMenus = function (editor, registry) {
      var rawMenuData = __assign(__assign({}, defaultMenus), registry.menus);
      var userDefinedMenus = keys(registry.menus).length > 0;
      var menubar = registry.menubar === undefined || registry.menubar === true ? parseItemsString(defaultMenubar) : parseItemsString(registry.menubar === false ? '' : registry.menubar);
      var validMenus = filter$2(menubar, function (menuName) {
        var isDefaultMenu = has$2(defaultMenus, menuName);
        if (userDefinedMenus) {
          return isDefaultMenu || get$e(registry.menus, menuName).exists(function (menu) {
            return has$2(menu, 'items');
          });
        } else {
          return isDefaultMenu;
        }
      });
      var menus = map$2(validMenus, function (menuName) {
        var menuData = rawMenuData[menuName];
        return make({
          title: menuData.title,
          items: parseItemsString(menuData.items)
        }, registry, editor);
      });
      return filter$2(menus, function (menu) {
        var isNotSeparator = function (item) {
          return item.type !== 'separator';
        };
        return menu.getItems().length > 0 && exists(menu.getItems(), isNotSeparator);
      });
    };

    var fireSkinLoaded = function (editor) {
      var done = function () {
        editor._skinLoaded = true;
        fireSkinLoaded$1(editor);
      };
      return function () {
        if (editor.initialized) {
          done();
        } else {
          editor.on('init', done);
        }
      };
    };
    var fireSkinLoadError = function (editor, err) {
      return function () {
        return fireSkinLoadError$1(editor, { message: err });
      };
    };

    var loadStylesheet = function (editor, stylesheetUrl, styleSheetLoader) {
      return new global$c(function (resolve, reject) {
        styleSheetLoader.load(stylesheetUrl, resolve, reject);
        editor.on('remove', function () {
          return styleSheetLoader.unload(stylesheetUrl);
        });
      });
    };
    var loadUiSkins = function (editor, skinUrl) {
      var skinUiCss = skinUrl + '/skin.min.css';
      return loadStylesheet(editor, skinUiCss, editor.ui.styleSheetLoader);
    };
    var loadShadowDomUiSkins = function (editor, skinUrl) {
      var isInShadowRoot$1 = isInShadowRoot(SugarElement.fromDom(editor.getElement()));
      if (isInShadowRoot$1) {
        var shadowDomSkinCss = skinUrl + '/skin.shadowdom.min.css';
        return loadStylesheet(editor, shadowDomSkinCss, global$b.DOM.styleSheetLoader);
      } else {
        return global$c.resolve();
      }
    };
    var loadSkin = function (isInline, editor) {
      var skinUrl = getSkinUrl(editor);
      if (skinUrl) {
        editor.contentCSS.push(skinUrl + (isInline ? '/content.inline' : '/content') + '.min.css');
      }
      if (isSkinDisabled(editor) === false && isString(skinUrl)) {
        global$c.all([
          loadUiSkins(editor, skinUrl),
          loadShadowDomUiSkins(editor, skinUrl)
        ]).then(fireSkinLoaded(editor), fireSkinLoadError(editor, 'Skin could not be loaded'));
      } else {
        fireSkinLoaded(editor)();
      }
    };
    var iframe = curry(loadSkin, false);
    var inline = curry(loadSkin, true);

    var onSetupFormatToggle = function (editor, name) {
      return function (api) {
        var boundCallback = unbindable();
        var init = function () {
          api.setActive(editor.formatter.match(name));
          var binding = editor.formatter.formatChanged(name, api.setActive);
          boundCallback.set(binding);
        };
        editor.initialized ? init() : editor.once('init', init);
        return function () {
          editor.off('init', init);
          boundCallback.clear();
        };
      };
    };
    var onSetupEvent = function (editor, event, f) {
      return function (api) {
        var handleEvent = function () {
          return f(api);
        };
        var init = function () {
          f(api);
          editor.on(event, handleEvent);
        };
        editor.initialized ? init() : editor.once('init', init);
        return function () {
          editor.off('init', init);
          editor.off(event, handleEvent);
        };
      };
    };
    var onActionToggleFormat$1 = function (editor) {
      return function (rawItem) {
        return function () {
          editor.undoManager.transact(function () {
            editor.focus();
            editor.execCommand('mceToggleFormat', false, rawItem.format);
          });
        };
      };
    };
    var onActionExecCommand = function (editor, command) {
      return function () {
        return editor.execCommand(command);
      };
    };

    var generateSelectItems = function (_editor, backstage, spec) {
      var generateItem = function (rawItem, response, disabled, value) {
        var translatedText = backstage.shared.providers.translate(rawItem.title);
        if (rawItem.type === 'separator') {
          return Optional.some({
            type: 'separator',
            text: translatedText
          });
        } else if (rawItem.type === 'submenu') {
          var items = bind$3(rawItem.getStyleItems(), function (si) {
            return validate(si, response, value);
          });
          if (response === 0 && items.length <= 0) {
            return Optional.none();
          } else {
            return Optional.some({
              type: 'nestedmenuitem',
              text: translatedText,
              disabled: items.length <= 0,
              getSubmenuItems: function () {
                return bind$3(rawItem.getStyleItems(), function (si) {
                  return validate(si, response, value);
                });
              }
            });
          }
        } else {
          return Optional.some(__assign({
            type: 'togglemenuitem',
            text: translatedText,
            icon: rawItem.icon,
            active: rawItem.isSelected(value),
            disabled: disabled,
            onAction: spec.onAction(rawItem)
          }, rawItem.getStylePreview().fold(function () {
            return {};
          }, function (preview) {
            return { meta: { style: preview } };
          })));
        }
      };
      var validate = function (item, response, value) {
        var invalid = item.type === 'formatter' && spec.isInvalid(item);
        if (response === 0) {
          return invalid ? [] : generateItem(item, response, false, value).toArray();
        } else {
          return generateItem(item, response, invalid, value).toArray();
        }
      };
      var validateItems = function (preItems) {
        var value = spec.getCurrentValue();
        var response = spec.shouldHide ? 0 : 1;
        return bind$3(preItems, function (item) {
          return validate(item, response, value);
        });
      };
      var getFetch = function (backstage, getStyleItems) {
        return function (comp, callback) {
          var preItems = getStyleItems();
          var items = validateItems(preItems);
          var menu = build(items, ItemResponse$1.CLOSE_ON_EXECUTE, backstage, false);
          callback(menu);
        };
      };
      return {
        validateItems: validateItems,
        getFetch: getFetch
      };
    };
    var createMenuItems = function (editor, backstage, spec) {
      var dataset = spec.dataset;
      var getStyleItems = dataset.type === 'basic' ? function () {
        return map$2(dataset.data, function (d) {
          return processBasic(d, spec.isSelectedFor, spec.getPreviewFor);
        });
      } : dataset.getData;
      return {
        items: generateSelectItems(editor, backstage, spec),
        getStyleItems: getStyleItems
      };
    };
    var createSelectButton = function (editor, backstage, spec) {
      var _a = createMenuItems(editor, backstage, spec), items = _a.items, getStyleItems = _a.getStyleItems;
      var getApi = function (comp) {
        return { getComponent: constant$1(comp) };
      };
      var onSetup = onSetupEvent(editor, 'NodeChange', function (api) {
        var comp = api.getComponent();
        spec.updateText(comp);
      });
      return renderCommonDropdown({
        text: spec.icon.isSome() ? Optional.none() : spec.text,
        icon: spec.icon,
        tooltip: Optional.from(spec.tooltip),
        role: Optional.none(),
        fetch: items.getFetch(backstage, getStyleItems),
        onSetup: onSetup,
        getApi: getApi,
        columns: 1,
        presets: 'normal',
        classes: spec.icon.isSome() ? [] : ['bespoke'],
        dropdownBehaviours: []
      }, 'tox-tbtn', backstage.shared);
    };

    var process = function (rawFormats) {
      return map$2(rawFormats, function (item) {
        var title = item, format = item;
        var values = item.split('=');
        if (values.length > 1) {
          title = values[0];
          format = values[1];
        }
        return {
          title: title,
          format: format
        };
      });
    };
    var buildBasicStaticDataset = function (data) {
      return {
        type: 'basic',
        data: data
      };
    };
    var Delimiter;
    (function (Delimiter) {
      Delimiter[Delimiter['SemiColon'] = 0] = 'SemiColon';
      Delimiter[Delimiter['Space'] = 1] = 'Space';
    }(Delimiter || (Delimiter = {})));
    var split = function (rawFormats, delimiter) {
      if (delimiter === Delimiter.SemiColon) {
        return rawFormats.replace(/;$/, '').split(';');
      } else {
        return rawFormats.split(' ');
      }
    };
    var buildBasicSettingsDataset = function (editor, settingName, defaults, delimiter) {
      var rawFormats = editor.getParam(settingName, defaults, 'string');
      var data = process(split(rawFormats, delimiter));
      return {
        type: 'basic',
        data: data
      };
    };

    var alignMenuItems = [
      {
        title: 'Left',
        icon: 'align-left',
        format: 'alignleft',
        command: 'JustifyLeft'
      },
      {
        title: 'Center',
        icon: 'align-center',
        format: 'aligncenter',
        command: 'JustifyCenter'
      },
      {
        title: 'Right',
        icon: 'align-right',
        format: 'alignright',
        command: 'JustifyRight'
      },
      {
        title: 'Justify',
        icon: 'align-justify',
        format: 'alignjustify',
        command: 'JustifyFull'
      }
    ];
    var getSpec$4 = function (editor) {
      var getMatchingValue = function () {
        return find$5(alignMenuItems, function (item) {
          return editor.formatter.match(item.format);
        });
      };
      var isSelectedFor = function (format) {
        return function () {
          return editor.formatter.match(format);
        };
      };
      var getPreviewFor = function (_format) {
        return Optional.none;
      };
      var updateSelectMenuIcon = function (comp) {
        var match = getMatchingValue();
        var alignment = match.fold(constant$1('left'), function (item) {
          return item.title.toLowerCase();
        });
        emitWith(comp, updateMenuIcon, { icon: 'align-' + alignment });
      };
      var dataset = buildBasicStaticDataset(alignMenuItems);
      var onAction = function (rawItem) {
        return function () {
          return find$5(alignMenuItems, function (item) {
            return item.format === rawItem.format;
          }).each(function (item) {
            return editor.execCommand(item.command);
          });
        };
      };
      return {
        tooltip: 'Align',
        text: Optional.none(),
        icon: Optional.some('align-left'),
        isSelectedFor: isSelectedFor,
        getCurrentValue: Optional.none,
        getPreviewFor: getPreviewFor,
        onAction: onAction,
        updateText: updateSelectMenuIcon,
        dataset: dataset,
        shouldHide: false,
        isInvalid: function (item) {
          return !editor.formatter.canApply(item.format);
        }
      };
    };
    var createAlignSelect = function (editor, backstage) {
      return createSelectButton(editor, backstage, getSpec$4(editor));
    };
    var alignSelectMenu = function (editor, backstage) {
      var menuItems = createMenuItems(editor, backstage, getSpec$4(editor));
      editor.ui.registry.addNestedMenuItem('align', {
        text: backstage.shared.providers.translate('Align'),
        getSubmenuItems: function () {
          return menuItems.items.validateItems(menuItems.getStyleItems());
        }
      });
    };

    var defaultFontsFormats = 'Andale Mono=andale mono,monospace;' + 'Arial=arial,helvetica,sans-serif;' + 'Arial Black=arial black,sans-serif;' + 'Book Antiqua=book antiqua,palatino,serif;' + 'Comic Sans MS=comic sans ms,sans-serif;' + 'Courier New=courier new,courier,monospace;' + 'Georgia=georgia,palatino,serif;' + 'Helvetica=helvetica,arial,sans-serif;' + 'Impact=impact,sans-serif;' + 'Symbol=symbol;' + 'Tahoma=tahoma,arial,helvetica,sans-serif;' + 'Terminal=terminal,monaco,monospace;' + 'Times New Roman=times new roman,times,serif;' + 'Trebuchet MS=trebuchet ms,geneva,sans-serif;' + 'Verdana=verdana,geneva,sans-serif;' + 'Webdings=webdings;' + 'Wingdings=wingdings,zapf dingbats';
    var systemStackFonts = [
      '-apple-system',
      'Segoe UI',
      'Roboto',
      'Helvetica Neue',
      'sans-serif'
    ];
    var splitFonts = function (fontFamily) {
      var fonts = fontFamily.split(/\s*,\s*/);
      return map$2(fonts, function (font) {
        return font.replace(/^['"]+|['"]+$/g, '');
      });
    };
    var isSystemFontStack = function (fontFamily) {
      var matchesSystemStack = function () {
        var fonts = splitFonts(fontFamily.toLowerCase());
        return forall(systemStackFonts, function (font) {
          return fonts.indexOf(font.toLowerCase()) > -1;
        });
      };
      return fontFamily.indexOf('-apple-system') === 0 && matchesSystemStack();
    };
    var getSpec$3 = function (editor) {
      var systemFont = 'System Font';
      var getMatchingValue = function () {
        var getFirstFont = function (fontFamily) {
          return fontFamily ? splitFonts(fontFamily)[0] : '';
        };
        var fontFamily = editor.queryCommandValue('FontName');
        var items = dataset.data;
        var font = fontFamily ? fontFamily.toLowerCase() : '';
        var matchOpt = find$5(items, function (item) {
          var format = item.format;
          return format.toLowerCase() === font || getFirstFont(format).toLowerCase() === getFirstFont(font).toLowerCase();
        }).orThunk(function () {
          return someIf(isSystemFontStack(font), {
            title: systemFont,
            format: font
          });
        });
        return {
          matchOpt: matchOpt,
          font: fontFamily
        };
      };
      var isSelectedFor = function (item) {
        return function (valueOpt) {
          return valueOpt.exists(function (value) {
            return value.format === item;
          });
        };
      };
      var getCurrentValue = function () {
        var matchOpt = getMatchingValue().matchOpt;
        return matchOpt;
      };
      var getPreviewFor = function (item) {
        return function () {
          return Optional.some({
            tag: 'div',
            styles: item.indexOf('dings') === -1 ? { 'font-family': item } : {}
          });
        };
      };
      var onAction = function (rawItem) {
        return function () {
          editor.undoManager.transact(function () {
            editor.focus();
            editor.execCommand('FontName', false, rawItem.format);
          });
        };
      };
      var updateSelectMenuText = function (comp) {
        var _a = getMatchingValue(), matchOpt = _a.matchOpt, font = _a.font;
        var text = matchOpt.fold(constant$1(font), function (item) {
          return item.title;
        });
        emitWith(comp, updateMenuText, { text: text });
      };
      var dataset = buildBasicSettingsDataset(editor, 'font_formats', defaultFontsFormats, Delimiter.SemiColon);
      return {
        tooltip: 'Fonts',
        text: Optional.some(systemFont),
        icon: Optional.none(),
        isSelectedFor: isSelectedFor,
        getCurrentValue: getCurrentValue,
        getPreviewFor: getPreviewFor,
        onAction: onAction,
        updateText: updateSelectMenuText,
        dataset: dataset,
        shouldHide: false,
        isInvalid: never
      };
    };
    var createFontSelect = function (editor, backstage) {
      return createSelectButton(editor, backstage, getSpec$3(editor));
    };
    var fontSelectMenu = function (editor, backstage) {
      var menuItems = createMenuItems(editor, backstage, getSpec$3(editor));
      editor.ui.registry.addNestedMenuItem('fontformats', {
        text: backstage.shared.providers.translate('Fonts'),
        getSubmenuItems: function () {
          return menuItems.items.validateItems(menuItems.getStyleItems());
        }
      });
    };

    var defaultFontsizeFormats = '8pt 10pt 12pt 14pt 18pt 24pt 36pt';
    var legacyFontSizes = {
      '8pt': '1',
      '10pt': '2',
      '12pt': '3',
      '14pt': '4',
      '18pt': '5',
      '24pt': '6',
      '36pt': '7'
    };
    var keywordFontSizes = {
      'xx-small': '7pt',
      'x-small': '8pt',
      'small': '10pt',
      'medium': '12pt',
      'large': '14pt',
      'x-large': '18pt',
      'xx-large': '24pt'
    };
    var round = function (number, precision) {
      var factor = Math.pow(10, precision);
      return Math.round(number * factor) / factor;
    };
    var toPt = function (fontSize, precision) {
      if (/[0-9.]+px$/.test(fontSize)) {
        return round(parseInt(fontSize, 10) * 72 / 96, precision || 0) + 'pt';
      } else {
        return get$e(keywordFontSizes, fontSize).getOr(fontSize);
      }
    };
    var toLegacy = function (fontSize) {
      return get$e(legacyFontSizes, fontSize).getOr('');
    };
    var getSpec$2 = function (editor) {
      var getMatchingValue = function () {
        var matchOpt = Optional.none();
        var items = dataset.data;
        var fontSize = editor.queryCommandValue('FontSize');
        if (fontSize) {
          var _loop_1 = function (precision) {
            var pt = toPt(fontSize, precision);
            var legacy = toLegacy(pt);
            matchOpt = find$5(items, function (item) {
              return item.format === fontSize || item.format === pt || item.format === legacy;
            });
          };
          for (var precision = 3; matchOpt.isNone() && precision >= 0; precision--) {
            _loop_1(precision);
          }
        }
        return {
          matchOpt: matchOpt,
          size: fontSize
        };
      };
      var isSelectedFor = function (item) {
        return function (valueOpt) {
          return valueOpt.exists(function (value) {
            return value.format === item;
          });
        };
      };
      var getCurrentValue = function () {
        var matchOpt = getMatchingValue().matchOpt;
        return matchOpt;
      };
      var getPreviewFor = constant$1(Optional.none);
      var onAction = function (rawItem) {
        return function () {
          editor.undoManager.transact(function () {
            editor.focus();
            editor.execCommand('FontSize', false, rawItem.format);
          });
        };
      };
      var updateSelectMenuText = function (comp) {
        var _a = getMatchingValue(), matchOpt = _a.matchOpt, size = _a.size;
        var text = matchOpt.fold(constant$1(size), function (match) {
          return match.title;
        });
        emitWith(comp, updateMenuText, { text: text });
      };
      var dataset = buildBasicSettingsDataset(editor, 'fontsize_formats', defaultFontsizeFormats, Delimiter.Space);
      return {
        tooltip: 'Font sizes',
        text: Optional.some('12pt'),
        icon: Optional.none(),
        isSelectedFor: isSelectedFor,
        getPreviewFor: getPreviewFor,
        getCurrentValue: getCurrentValue,
        onAction: onAction,
        updateText: updateSelectMenuText,
        dataset: dataset,
        shouldHide: false,
        isInvalid: never
      };
    };
    var createFontsizeSelect = function (editor, backstage) {
      return createSelectButton(editor, backstage, getSpec$2(editor));
    };
    var fontsizeSelectMenu = function (editor, backstage) {
      var menuItems = createMenuItems(editor, backstage, getSpec$2(editor));
      editor.ui.registry.addNestedMenuItem('fontsizes', {
        text: 'Font sizes',
        getSubmenuItems: function () {
          return menuItems.items.validateItems(menuItems.getStyleItems());
        }
      });
    };

    var findNearest = function (editor, getStyles) {
      var styles = getStyles();
      var formats = map$2(styles, function (style) {
        return style.format;
      });
      return Optional.from(editor.formatter.closest(formats)).bind(function (fmt) {
        return find$5(styles, function (data) {
          return data.format === fmt;
        });
      }).orThunk(function () {
        return someIf(editor.formatter.match('p'), {
          title: 'Paragraph',
          format: 'p'
        });
      });
    };

    var defaultBlocks = 'Paragraph=p;' + 'Heading 1=h1;' + 'Heading 2=h2;' + 'Heading 3=h3;' + 'Heading 4=h4;' + 'Heading 5=h5;' + 'Heading 6=h6;' + 'Preformatted=pre';
    var getSpec$1 = function (editor) {
      var fallbackFormat = 'Paragraph';
      var isSelectedFor = function (format) {
        return function () {
          return editor.formatter.match(format);
        };
      };
      var getPreviewFor = function (format) {
        return function () {
          var fmt = editor.formatter.get(format);
          return Optional.some({
            tag: fmt.length > 0 ? fmt[0].inline || fmt[0].block || 'div' : 'div',
            styles: editor.dom.parseStyle(editor.formatter.getCssText(format))
          });
        };
      };
      var updateSelectMenuText = function (comp) {
        var detectedFormat = findNearest(editor, function () {
          return dataset.data;
        });
        var text = detectedFormat.fold(constant$1(fallbackFormat), function (fmt) {
          return fmt.title;
        });
        emitWith(comp, updateMenuText, { text: text });
      };
      var dataset = buildBasicSettingsDataset(editor, 'block_formats', defaultBlocks, Delimiter.SemiColon);
      return {
        tooltip: 'Blocks',
        text: Optional.some(fallbackFormat),
        icon: Optional.none(),
        isSelectedFor: isSelectedFor,
        getCurrentValue: Optional.none,
        getPreviewFor: getPreviewFor,
        onAction: onActionToggleFormat$1(editor),
        updateText: updateSelectMenuText,
        dataset: dataset,
        shouldHide: false,
        isInvalid: function (item) {
          return !editor.formatter.canApply(item.format);
        }
      };
    };
    var createFormatSelect = function (editor, backstage) {
      return createSelectButton(editor, backstage, getSpec$1(editor));
    };
    var formatSelectMenu = function (editor, backstage) {
      var menuItems = createMenuItems(editor, backstage, getSpec$1(editor));
      editor.ui.registry.addNestedMenuItem('blockformats', {
        text: 'Blocks',
        getSubmenuItems: function () {
          return menuItems.items.validateItems(menuItems.getStyleItems());
        }
      });
    };

    var getSpec = function (editor, dataset) {
      var fallbackFormat = 'Paragraph';
      var isSelectedFor = function (format) {
        return function () {
          return editor.formatter.match(format);
        };
      };
      var getPreviewFor = function (format) {
        return function () {
          var fmt = editor.formatter.get(format);
          return fmt !== undefined ? Optional.some({
            tag: fmt.length > 0 ? fmt[0].inline || fmt[0].block || 'div' : 'div',
            styles: editor.dom.parseStyle(editor.formatter.getCssText(format))
          }) : Optional.none();
        };
      };
      var updateSelectMenuText = function (comp) {
        var getFormatItems = function (fmt) {
          var subs = fmt.items;
          return subs !== undefined && subs.length > 0 ? bind$3(subs, getFormatItems) : [{
              title: fmt.title,
              format: fmt.format
            }];
        };
        var flattenedItems = bind$3(getStyleFormats(editor), getFormatItems);
        var detectedFormat = findNearest(editor, constant$1(flattenedItems));
        var text = detectedFormat.fold(constant$1(fallbackFormat), function (fmt) {
          return fmt.title;
        });
        emitWith(comp, updateMenuText, { text: text });
      };
      return {
        tooltip: 'Formats',
        text: Optional.some(fallbackFormat),
        icon: Optional.none(),
        isSelectedFor: isSelectedFor,
        getCurrentValue: Optional.none,
        getPreviewFor: getPreviewFor,
        onAction: onActionToggleFormat$1(editor),
        updateText: updateSelectMenuText,
        shouldHide: editor.getParam('style_formats_autohide', false, 'boolean'),
        isInvalid: function (item) {
          return !editor.formatter.canApply(item.format);
        },
        dataset: dataset
      };
    };
    var createStyleSelect = function (editor, backstage) {
      var dataset = __assign({ type: 'advanced' }, backstage.styleselect);
      return createSelectButton(editor, backstage, getSpec(editor, dataset));
    };
    var styleSelectMenu = function (editor, backstage) {
      var dataset = __assign({ type: 'advanced' }, backstage.styleselect);
      var menuItems = createMenuItems(editor, backstage, getSpec(editor, dataset));
      editor.ui.registry.addNestedMenuItem('formats', {
        text: 'Formats',
        getSubmenuItems: function () {
          return menuItems.items.validateItems(menuItems.getStyleItems());
        }
      });
    };

    var events$3 = function (reflectingConfig, reflectingState) {
      var update = function (component, data) {
        reflectingConfig.updateState.each(function (updateState) {
          var newState = updateState(component, data);
          reflectingState.set(newState);
        });
        reflectingConfig.renderComponents.each(function (renderComponents) {
          var newComponents = renderComponents(data, reflectingState.get());
          var newChildren = map$2(newComponents, component.getSystem().build);
          replaceChildren(component, newChildren);
        });
      };
      return derive$2([
        run$1(receive(), function (component, message) {
          var receivingData = message;
          if (!receivingData.universal) {
            var channel = reflectingConfig.channel;
            if (contains$2(receivingData.channels, channel)) {
              update(component, receivingData.data);
            }
          }
        }),
        runOnAttached(function (comp, _se) {
          reflectingConfig.initialData.each(function (rawData) {
            update(comp, rawData);
          });
        })
      ]);
    };

    var ActiveReflecting = /*#__PURE__*/Object.freeze({
        __proto__: null,
        events: events$3
    });

    var getState = function (component, replaceConfig, reflectState) {
      return reflectState;
    };

    var ReflectingApis = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getState: getState
    });

    var ReflectingSchema = [
      required$1('channel'),
      option('renderComponents'),
      option('updateState'),
      option('initialData')
    ];

    var init$3 = function () {
      var cell = Cell(Optional.none());
      var clear = function () {
        return cell.set(Optional.none());
      };
      var readState = function () {
        return cell.get().getOr('none');
      };
      return {
        readState: readState,
        get: cell.get,
        set: cell.set,
        clear: clear
      };
    };

    var ReflectingState = /*#__PURE__*/Object.freeze({
        __proto__: null,
        init: init$3
    });

    var Reflecting = create$7({
      fields: ReflectingSchema,
      name: 'reflecting',
      active: ActiveReflecting,
      apis: ReflectingApis,
      state: ReflectingState
    });

    var schema$7 = constant$1([
      required$1('toggleClass'),
      required$1('fetch'),
      onStrictHandler('onExecute'),
      defaulted('getHotspot', Optional.some),
      defaulted('getAnchorOverrides', constant$1({})),
      schema$y(),
      onStrictHandler('onItemExecute'),
      option('lazySink'),
      required$1('dom'),
      onHandler('onOpen'),
      field('splitDropdownBehaviours', [
        Coupling,
        Keying,
        Focusing
      ]),
      defaulted('matchWidth', false),
      defaulted('useMinWidth', false),
      defaulted('eventOrder', {}),
      option('role')
    ].concat(sandboxFields()));
    var arrowPart = required({
      factory: Button,
      schema: [required$1('dom')],
      name: 'arrow',
      defaults: function () {
        return { buttonBehaviours: derive$1([Focusing.revoke()]) };
      },
      overrides: function (detail) {
        return {
          dom: {
            tag: 'span',
            attributes: { role: 'presentation' }
          },
          action: function (arrow) {
            arrow.getSystem().getByUid(detail.uid).each(emitExecute);
          },
          buttonBehaviours: derive$1([Toggling.config({
              toggleOnExecute: false,
              toggleClass: detail.toggleClass
            })])
        };
      }
    });
    var buttonPart = required({
      factory: Button,
      schema: [required$1('dom')],
      name: 'button',
      defaults: function () {
        return { buttonBehaviours: derive$1([Focusing.revoke()]) };
      },
      overrides: function (detail) {
        return {
          dom: {
            tag: 'span',
            attributes: { role: 'presentation' }
          },
          action: function (btn) {
            btn.getSystem().getByUid(detail.uid).each(function (splitDropdown) {
              detail.onExecute(splitDropdown, btn);
            });
          }
        };
      }
    });
    var parts$3 = constant$1([
      arrowPart,
      buttonPart,
      optional({
        factory: {
          sketch: function (spec) {
            return {
              uid: spec.uid,
              dom: {
                tag: 'span',
                styles: { display: 'none' },
                attributes: { 'aria-hidden': 'true' },
                innerHtml: spec.text
              }
            };
          }
        },
        schema: [required$1('text')],
        name: 'aria-descriptor'
      }),
      external$1({
        schema: [tieredMenuMarkers()],
        name: 'menu',
        defaults: function (detail) {
          return {
            onExecute: function (tmenu, item) {
              tmenu.getSystem().getByUid(detail.uid).each(function (splitDropdown) {
                detail.onItemExecute(splitDropdown, tmenu, item);
              });
            }
          };
        }
      }),
      partType$1()
    ]);

    var factory$5 = function (detail, components, spec, externals) {
      var _a;
      var switchToMenu = function (sandbox) {
        Composing.getCurrent(sandbox).each(function (current) {
          Highlighting.highlightFirst(current);
          Keying.focusIn(current);
        });
      };
      var action = function (component) {
        var onOpenSync = switchToMenu;
        togglePopup(detail, identity$1, component, externals, onOpenSync, HighlightOnOpen.HighlightFirst).get(noop);
      };
      var openMenu = function (comp) {
        action(comp);
        return Optional.some(true);
      };
      var executeOnButton = function (comp) {
        var button = getPartOrDie(comp, detail, 'button');
        emitExecute(button);
        return Optional.some(true);
      };
      var buttonEvents = __assign(__assign({}, derive$2([runOnAttached(function (component, _simulatedEvent) {
          var ariaDescriptor = getPart(component, detail, 'aria-descriptor');
          ariaDescriptor.each(function (descriptor) {
            var descriptorId = generate$6('aria');
            set$8(descriptor.element, 'id', descriptorId);
            set$8(component.element, 'aria-describedby', descriptorId);
          });
        })])), events$a(Optional.some(action)));
      var apis = {
        repositionMenus: function (comp) {
          if (Toggling.isOn(comp)) {
            repositionMenus(comp);
          }
        }
      };
      return {
        uid: detail.uid,
        dom: detail.dom,
        components: components,
        apis: apis,
        eventOrder: __assign(__assign({}, detail.eventOrder), (_a = {}, _a[execute$5()] = [
          'disabling',
          'toggling',
          'alloy.base.behaviour'
        ], _a)),
        events: buttonEvents,
        behaviours: augment(detail.splitDropdownBehaviours, [
          Coupling.config({
            others: {
              sandbox: function (hotspot) {
                var arrow = getPartOrDie(hotspot, detail, 'arrow');
                var extras = {
                  onOpen: function () {
                    Toggling.on(arrow);
                    Toggling.on(hotspot);
                  },
                  onClose: function () {
                    Toggling.off(arrow);
                    Toggling.off(hotspot);
                  }
                };
                return makeSandbox$1(detail, hotspot, extras);
              }
            }
          }),
          Keying.config({
            mode: 'special',
            onSpace: executeOnButton,
            onEnter: executeOnButton,
            onDown: openMenu
          }),
          Focusing.config({}),
          Toggling.config({
            toggleOnExecute: false,
            aria: { mode: 'expanded' }
          })
        ]),
        domModification: {
          attributes: {
            'role': detail.role.getOr('button'),
            'aria-haspopup': true
          }
        }
      };
    };
    var SplitDropdown = composite({
      name: 'SplitDropdown',
      configFields: schema$7(),
      partFields: parts$3(),
      factory: factory$5,
      apis: {
        repositionMenus: function (apis, comp) {
          return apis.repositionMenus(comp);
        }
      }
    });

    var getButtonApi = function (component) {
      return {
        isDisabled: function () {
          return Disabling.isDisabled(component);
        },
        setDisabled: function (state) {
          return Disabling.set(component, state);
        }
      };
    };
    var getToggleApi = function (component) {
      return {
        setActive: function (state) {
          Toggling.set(component, state);
        },
        isActive: function () {
          return Toggling.isOn(component);
        },
        isDisabled: function () {
          return Disabling.isDisabled(component);
        },
        setDisabled: function (state) {
          return Disabling.set(component, state);
        }
      };
    };
    var getTooltipAttributes = function (tooltip, providersBackstage) {
      return tooltip.map(function (tooltip) {
        return {
          'aria-label': providersBackstage.translate(tooltip),
          'title': providersBackstage.translate(tooltip)
        };
      }).getOr({});
    };
    var focusButtonEvent = generate$6('focus-button');
    var renderCommonStructure = function (icon, text, tooltip, receiver, behaviours, providersBackstage) {
      var _d;
      return {
        dom: {
          tag: 'button',
          classes: ['tox-tbtn'].concat(text.isSome() ? ['tox-tbtn--select'] : []),
          attributes: getTooltipAttributes(tooltip, providersBackstage)
        },
        components: componentRenderPipeline([
          icon.map(function (iconName) {
            return renderIconFromPack(iconName, providersBackstage.icons);
          }),
          text.map(function (text) {
            return renderLabel$1(text, 'tox-tbtn', providersBackstage);
          })
        ]),
        eventOrder: (_d = {}, _d[mousedown()] = [
          'focusing',
          'alloy.base.behaviour',
          'common-button-display-events'
        ], _d),
        buttonBehaviours: derive$1([
          DisablingConfigs.toolbarButton(providersBackstage.isDisabled),
          receivingConfig(),
          config('common-button-display-events', [run$1(mousedown(), function (button, se) {
              se.event.prevent();
              emit(button, focusButtonEvent);
            })])
        ].concat(receiver.map(function (r) {
          return Reflecting.config({
            channel: r,
            initialData: {
              icon: icon,
              text: text
            },
            renderComponents: function (data, _state) {
              return componentRenderPipeline([
                data.icon.map(function (iconName) {
                  return renderIconFromPack(iconName, providersBackstage.icons);
                }),
                data.text.map(function (text) {
                  return renderLabel$1(text, 'tox-tbtn', providersBackstage);
                })
              ]);
            }
          });
        }).toArray()).concat(behaviours.getOr([])))
      };
    };
    var renderFloatingToolbarButton = function (spec, backstage, identifyButtons, attributes) {
      var sharedBackstage = backstage.shared;
      return FloatingToolbarButton.sketch({
        lazySink: sharedBackstage.getSink,
        fetch: function () {
          return Future.nu(function (resolve) {
            resolve(map$2(identifyButtons(spec.items), renderToolbarGroup));
          });
        },
        markers: { toggledClass: 'tox-tbtn--enabled' },
        parts: {
          button: renderCommonStructure(spec.icon, spec.text, spec.tooltip, Optional.none(), Optional.none(), sharedBackstage.providers),
          toolbar: {
            dom: {
              tag: 'div',
              classes: ['tox-toolbar__overflow'],
              attributes: attributes
            }
          }
        }
      });
    };
    var renderCommonToolbarButton = function (spec, specialisation, providersBackstage) {
      var editorOffCell = Cell(noop);
      var structure = renderCommonStructure(spec.icon, spec.text, spec.tooltip, Optional.none(), Optional.none(), providersBackstage);
      return Button.sketch({
        dom: structure.dom,
        components: structure.components,
        eventOrder: toolbarButtonEventOrder,
        buttonBehaviours: derive$1([
          config('toolbar-button-events', [
            onToolbarButtonExecute({
              onAction: spec.onAction,
              getApi: specialisation.getApi
            }),
            onControlAttached(specialisation, editorOffCell),
            onControlDetached(specialisation, editorOffCell)
          ]),
          DisablingConfigs.toolbarButton(function () {
            return spec.disabled || providersBackstage.isDisabled();
          }),
          receivingConfig()
        ].concat(specialisation.toolbarButtonBehaviours))
      });
    };
    var renderToolbarButton = function (spec, providersBackstage) {
      return renderToolbarButtonWith(spec, providersBackstage, []);
    };
    var renderToolbarButtonWith = function (spec, providersBackstage, bonusEvents) {
      return renderCommonToolbarButton(spec, {
        toolbarButtonBehaviours: [].concat(bonusEvents.length > 0 ? [config('toolbarButtonWith', bonusEvents)] : []),
        getApi: getButtonApi,
        onSetup: spec.onSetup
      }, providersBackstage);
    };
    var renderToolbarToggleButton = function (spec, providersBackstage) {
      return renderToolbarToggleButtonWith(spec, providersBackstage, []);
    };
    var renderToolbarToggleButtonWith = function (spec, providersBackstage, bonusEvents) {
      return deepMerge(renderCommonToolbarButton(spec, {
        toolbarButtonBehaviours: [
          Replacing.config({}),
          Toggling.config({
            toggleClass: 'tox-tbtn--enabled',
            aria: { mode: 'pressed' },
            toggleOnExecute: false
          })
        ].concat(bonusEvents.length > 0 ? [config('toolbarToggleButtonWith', bonusEvents)] : []),
        getApi: getToggleApi,
        onSetup: spec.onSetup
      }, providersBackstage));
    };
    var fetchChoices = function (getApi, spec, providersBackstage) {
      return function (comp) {
        return Future.nu(function (callback) {
          return spec.fetch(callback);
        }).map(function (items) {
          return Optional.from(createTieredDataFrom(deepMerge(createPartialChoiceMenu(generate$6('menu-value'), items, function (value) {
            spec.onItemAction(getApi(comp), value);
          }, spec.columns, spec.presets, ItemResponse$1.CLOSE_ON_EXECUTE, spec.select.getOr(never), providersBackstage), {
            movement: deriveMenuMovement(spec.columns, spec.presets),
            menuBehaviours: SimpleBehaviours.unnamedEvents(spec.columns !== 'auto' ? [] : [runOnAttached(function (comp, _se) {
                detectSize(comp, 4, classForPreset(spec.presets)).each(function (_d) {
                  var numRows = _d.numRows, numColumns = _d.numColumns;
                  Keying.setGridSize(comp, numRows, numColumns);
                });
              })])
          })));
        });
      };
    };
    var renderSplitButton = function (spec, sharedBackstage) {
      var _d;
      var displayChannel = generate$6('channel-update-split-dropdown-display');
      var getApi = function (comp) {
        return {
          isDisabled: function () {
            return Disabling.isDisabled(comp);
          },
          setDisabled: function (state) {
            return Disabling.set(comp, state);
          },
          setIconFill: function (id, value) {
            descendant(comp.element, 'svg path[id="' + id + '"], rect[id="' + id + '"]').each(function (underlinePath) {
              set$8(underlinePath, 'fill', value);
            });
          },
          setIconStroke: function (id, value) {
            descendant(comp.element, 'svg path[id="' + id + '"], rect[id="' + id + '"]').each(function (underlinePath) {
              set$8(underlinePath, 'stroke', value);
            });
          },
          setActive: function (state) {
            set$8(comp.element, 'aria-pressed', state);
            descendant(comp.element, 'span').each(function (button) {
              comp.getSystem().getByDom(button).each(function (buttonComp) {
                return Toggling.set(buttonComp, state);
              });
            });
          },
          isActive: function () {
            return descendant(comp.element, 'span').exists(function (button) {
              return comp.getSystem().getByDom(button).exists(Toggling.isOn);
            });
          }
        };
      };
      var editorOffCell = Cell(noop);
      var specialisation = {
        getApi: getApi,
        onSetup: spec.onSetup
      };
      return SplitDropdown.sketch({
        dom: {
          tag: 'div',
          classes: ['tox-split-button'],
          attributes: __assign({ 'aria-pressed': false }, getTooltipAttributes(spec.tooltip, sharedBackstage.providers))
        },
        onExecute: function (button) {
          spec.onAction(getApi(button));
        },
        onItemExecute: function (_a, _b, _c) {
        },
        splitDropdownBehaviours: derive$1([
          DisablingConfigs.splitButton(sharedBackstage.providers.isDisabled),
          receivingConfig(),
          config('split-dropdown-events', [
            run$1(focusButtonEvent, Focusing.focus),
            onControlAttached(specialisation, editorOffCell),
            onControlDetached(specialisation, editorOffCell)
          ]),
          Unselecting.config({})
        ]),
        eventOrder: (_d = {}, _d[attachedToDom()] = [
          'alloy.base.behaviour',
          'split-dropdown-events'
        ], _d),
        toggleClass: 'tox-tbtn--enabled',
        lazySink: sharedBackstage.getSink,
        fetch: fetchChoices(getApi, spec, sharedBackstage.providers),
        parts: { menu: part(false, spec.columns, spec.presets) },
        components: [
          SplitDropdown.parts.button(renderCommonStructure(spec.icon, spec.text, Optional.none(), Optional.some(displayChannel), Optional.some([Toggling.config({
              toggleClass: 'tox-tbtn--enabled',
              toggleOnExecute: false
            })]), sharedBackstage.providers)),
          SplitDropdown.parts.arrow({
            dom: {
              tag: 'button',
              classes: [
                'tox-tbtn',
                'tox-split-button__chevron'
              ],
              innerHtml: get$1('chevron-down', sharedBackstage.providers.icons)
            },
            buttonBehaviours: derive$1([
              DisablingConfigs.splitButton(sharedBackstage.providers.isDisabled),
              receivingConfig(),
              addFocusableBehaviour()
            ])
          }),
          SplitDropdown.parts['aria-descriptor']({ text: sharedBackstage.providers.translate('To open the popup, press Shift+Enter') })
        ]
      });
    };

    var defaultToolbar = [
      {
        name: 'history',
        items: [
          'undo',
          'redo'
        ]
      },
      {
        name: 'styles',
        items: ['styleselect']
      },
      {
        name: 'formatting',
        items: [
          'bold',
          'italic'
        ]
      },
      {
        name: 'alignment',
        items: [
          'alignleft',
          'aligncenter',
          'alignright',
          'alignjustify'
        ]
      },
      {
        name: 'indentation',
        items: [
          'outdent',
          'indent'
        ]
      },
      {
        name: 'permanent pen',
        items: ['permanentpen']
      },
      {
        name: 'comments',
        items: ['addcomment']
      }
    ];
    var renderFromBridge = function (bridgeBuilder, render) {
      return function (spec, extras, editor) {
        var internal = bridgeBuilder(spec).mapError(function (errInfo) {
          return formatError(errInfo);
        }).getOrDie();
        return render(internal, extras, editor);
      };
    };
    var types = {
      button: renderFromBridge(createToolbarButton, function (s, extras) {
        return renderToolbarButton(s, extras.backstage.shared.providers);
      }),
      togglebutton: renderFromBridge(createToggleButton, function (s, extras) {
        return renderToolbarToggleButton(s, extras.backstage.shared.providers);
      }),
      menubutton: renderFromBridge(createMenuButton, function (s, extras) {
        return renderMenuButton(s, 'tox-tbtn', extras.backstage, Optional.none());
      }),
      splitbutton: renderFromBridge(createSplitButton, function (s, extras) {
        return renderSplitButton(s, extras.backstage.shared);
      }),
      grouptoolbarbutton: renderFromBridge(createGroupToolbarButton, function (s, extras, editor) {
        var _a;
        var buttons = editor.ui.registry.getAll().buttons;
        var identify = function (toolbar) {
          return identifyButtons(editor, {
            buttons: buttons,
            toolbar: toolbar,
            allowToolbarGroups: false
          }, extras, Optional.none());
        };
        var attributes = (_a = {}, _a[Attribute] = extras.backstage.shared.header.isPositionedAtTop() ? AttributeValue.TopToBottom : AttributeValue.BottomToTop, _a);
        switch (getToolbarMode(editor)) {
        case ToolbarMode.floating:
          return renderFloatingToolbarButton(s, extras.backstage, identify, attributes);
        default:
          throw new Error('Toolbar groups are only supported when using floating toolbar mode');
        }
      }),
      styleSelectButton: function (editor, extras) {
        return createStyleSelect(editor, extras.backstage);
      },
      fontsizeSelectButton: function (editor, extras) {
        return createFontsizeSelect(editor, extras.backstage);
      },
      fontSelectButton: function (editor, extras) {
        return createFontSelect(editor, extras.backstage);
      },
      formatButton: function (editor, extras) {
        return createFormatSelect(editor, extras.backstage);
      },
      alignMenuButton: function (editor, extras) {
        return createAlignSelect(editor, extras.backstage);
      }
    };
    var extractFrom = function (spec, extras, editor) {
      return get$e(types, spec.type).fold(function () {
        console.error('skipping button defined by', spec);
        return Optional.none();
      }, function (render) {
        return Optional.some(render(spec, extras, editor));
      });
    };
    var bespokeButtons = {
      styleselect: types.styleSelectButton,
      fontsizeselect: types.fontsizeSelectButton,
      fontselect: types.fontSelectButton,
      formatselect: types.formatButton,
      align: types.alignMenuButton
    };
    var removeUnusedDefaults = function (buttons) {
      var filteredItemGroups = map$2(defaultToolbar, function (group) {
        var items = filter$2(group.items, function (subItem) {
          return has$2(buttons, subItem) || has$2(bespokeButtons, subItem);
        });
        return {
          name: group.name,
          items: items
        };
      });
      return filter$2(filteredItemGroups, function (group) {
        return group.items.length > 0;
      });
    };
    var convertStringToolbar = function (strToolbar) {
      var groupsStrings = strToolbar.split('|');
      return map$2(groupsStrings, function (g) {
        return { items: g.trim().split(' ') };
      });
    };
    var isToolbarGroupSettingArray = function (toolbar) {
      return isArrayOf(toolbar, function (t) {
        return has$2(t, 'name') && has$2(t, 'items');
      });
    };
    var createToolbar = function (toolbarConfig) {
      var toolbar = toolbarConfig.toolbar;
      var buttons = toolbarConfig.buttons;
      if (toolbar === false) {
        return [];
      } else if (toolbar === undefined || toolbar === true) {
        return removeUnusedDefaults(buttons);
      } else if (isString(toolbar)) {
        return convertStringToolbar(toolbar);
      } else if (isToolbarGroupSettingArray(toolbar)) {
        return toolbar;
      } else {
        console.error('Toolbar type should be string, string[], boolean or ToolbarGroup[]');
        return [];
      }
    };
    var lookupButton = function (editor, buttons, toolbarItem, allowToolbarGroups, extras, prefixes) {
      return get$e(buttons, toolbarItem.toLowerCase()).orThunk(function () {
        return prefixes.bind(function (ps) {
          return findMap(ps, function (prefix) {
            return get$e(buttons, prefix + toolbarItem.toLowerCase());
          });
        });
      }).fold(function () {
        return get$e(bespokeButtons, toolbarItem.toLowerCase()).map(function (r) {
          return r(editor, extras);
        }).orThunk(function () {
          return Optional.none();
        });
      }, function (spec) {
        if (spec.type === 'grouptoolbarbutton' && !allowToolbarGroups) {
          console.warn('Ignoring the \'' + toolbarItem + '\' toolbar button. Group toolbar buttons are only supported when using floating toolbar mode and cannot be nested.');
          return Optional.none();
        } else {
          return extractFrom(spec, extras, editor);
        }
      });
    };
    var identifyButtons = function (editor, toolbarConfig, extras, prefixes) {
      var toolbarGroups = createToolbar(toolbarConfig);
      var groups = map$2(toolbarGroups, function (group) {
        var items = bind$3(group.items, function (toolbarItem) {
          return toolbarItem.trim().length === 0 ? [] : lookupButton(editor, toolbarConfig.buttons, toolbarItem, toolbarConfig.allowToolbarGroups, extras, prefixes).toArray();
        });
        return {
          title: Optional.from(editor.translate(group.name)),
          items: items
        };
      });
      return filter$2(groups, function (group) {
        return group.items.length > 0;
      });
    };

    var setToolbar = function (editor, uiComponents, rawUiConfig, backstage) {
      var comp = uiComponents.outerContainer;
      var toolbarConfig = rawUiConfig.toolbar;
      var toolbarButtonsConfig = rawUiConfig.buttons;
      if (isArrayOf(toolbarConfig, isString)) {
        var toolbars = toolbarConfig.map(function (t) {
          var config = {
            toolbar: t,
            buttons: toolbarButtonsConfig,
            allowToolbarGroups: rawUiConfig.allowToolbarGroups
          };
          return identifyButtons(editor, config, { backstage: backstage }, Optional.none());
        });
        OuterContainer.setToolbars(comp, toolbars);
      } else {
        OuterContainer.setToolbar(comp, identifyButtons(editor, rawUiConfig, { backstage: backstage }, Optional.none()));
      }
    };

    var detection = detect$1();
    var isiOS12 = detection.os.isiOS() && detection.os.version.major <= 12;
    var setupEvents$1 = function (editor, uiComponents) {
      var dom = editor.dom;
      var contentWindow = editor.getWin();
      var initialDocEle = editor.getDoc().documentElement;
      var lastWindowDimensions = Cell(SugarPosition(contentWindow.innerWidth, contentWindow.innerHeight));
      var lastDocumentDimensions = Cell(SugarPosition(initialDocEle.offsetWidth, initialDocEle.offsetHeight));
      var resizeWindow = function () {
        var outer = lastWindowDimensions.get();
        if (outer.left !== contentWindow.innerWidth || outer.top !== contentWindow.innerHeight) {
          lastWindowDimensions.set(SugarPosition(contentWindow.innerWidth, contentWindow.innerHeight));
          fireResizeContent(editor);
        }
      };
      var resizeDocument = function () {
        var docEle = editor.getDoc().documentElement;
        var inner = lastDocumentDimensions.get();
        if (inner.left !== docEle.offsetWidth || inner.top !== docEle.offsetHeight) {
          lastDocumentDimensions.set(SugarPosition(docEle.offsetWidth, docEle.offsetHeight));
          fireResizeContent(editor);
        }
      };
      var scroll = function (e) {
        return fireScrollContent(editor, e);
      };
      dom.bind(contentWindow, 'resize', resizeWindow);
      dom.bind(contentWindow, 'scroll', scroll);
      var elementLoad = capture(SugarElement.fromDom(editor.getBody()), 'load', resizeDocument);
      var mothership = uiComponents.uiMothership.element;
      editor.on('hide', function () {
        set$7(mothership, 'display', 'none');
      });
      editor.on('show', function () {
        remove$6(mothership, 'display');
      });
      editor.on('NodeChange', resizeDocument);
      editor.on('remove', function () {
        elementLoad.unbind();
        dom.unbind(contentWindow, 'resize', resizeWindow);
        dom.unbind(contentWindow, 'scroll', scroll);
        contentWindow = null;
      });
    };
    var render$1 = function (editor, uiComponents, rawUiConfig, backstage, args) {
      var lastToolbarWidth = Cell(0);
      var outerContainer = uiComponents.outerContainer;
      iframe(editor);
      var eTargetNode = SugarElement.fromDom(args.targetNode);
      var uiRoot = getContentContainer(getRootNode(eTargetNode));
      attachSystemAfter(eTargetNode, uiComponents.mothership);
      attachSystem(uiRoot, uiComponents.uiMothership);
      editor.on('PostRender', function () {
        setToolbar(editor, uiComponents, rawUiConfig, backstage);
        lastToolbarWidth.set(editor.getWin().innerWidth);
        OuterContainer.setMenubar(outerContainer, identifyMenus(editor, rawUiConfig));
        OuterContainer.setSidebar(outerContainer, rawUiConfig.sidebar);
        setupEvents$1(editor, uiComponents);
      });
      var socket = OuterContainer.getSocket(outerContainer).getOrDie('Could not find expected socket element');
      if (isiOS12) {
        setAll(socket.element, {
          'overflow': 'scroll',
          '-webkit-overflow-scrolling': 'touch'
        });
        var limit = first(function () {
          editor.fire('ScrollContent');
        }, 20);
        var unbinder = bind(socket.element, 'scroll', limit.throttle);
        editor.on('remove', unbinder.unbind);
      }
      setupReadonlyModeSwitch(editor, uiComponents);
      editor.addCommand('ToggleSidebar', function (_ui, value) {
        OuterContainer.toggleSidebar(outerContainer, value);
        editor.fire('ToggleSidebar');
      });
      editor.addQueryValueHandler('ToggleSidebar', function () {
        return OuterContainer.whichSidebar(outerContainer);
      });
      var toolbarMode = getToolbarMode(editor);
      var refreshDrawer = function () {
        OuterContainer.refreshToolbar(uiComponents.outerContainer);
      };
      if (toolbarMode === ToolbarMode.sliding || toolbarMode === ToolbarMode.floating) {
        editor.on('ResizeWindow ResizeEditor ResizeContent', function () {
          var width = editor.getWin().innerWidth;
          if (width !== lastToolbarWidth.get()) {
            refreshDrawer();
            lastToolbarWidth.set(width);
          }
        });
      }
      var api = {
        enable: function () {
          broadcastReadonly(uiComponents, false);
        },
        disable: function () {
          broadcastReadonly(uiComponents, true);
        },
        isDisabled: function () {
          return Disabling.isDisabled(outerContainer);
        }
      };
      return {
        iframeContainer: socket.element.dom,
        editorContainer: outerContainer.element.dom,
        api: api
      };
    };

    var Iframe = /*#__PURE__*/Object.freeze({
        __proto__: null,
        render: render$1
    });

    var parseToInt = function (val) {
      var re = /^[0-9\.]+(|px)$/i;
      if (re.test('' + val)) {
        return Optional.some(parseInt('' + val, 10));
      }
      return Optional.none();
    };
    var numToPx = function (val) {
      return isNumber(val) ? val + 'px' : val;
    };
    var calcCappedSize = function (size, minSize, maxSize) {
      var minOverride = minSize.filter(function (min) {
        return size < min;
      });
      var maxOverride = maxSize.filter(function (max) {
        return size > max;
      });
      return minOverride.or(maxOverride).getOr(size);
    };

    var getHeight = function (editor) {
      var baseHeight = getHeightSetting(editor);
      var minHeight = getMinHeightSetting(editor);
      var maxHeight = getMaxHeightSetting(editor);
      return parseToInt(baseHeight).map(function (height) {
        return calcCappedSize(height, minHeight, maxHeight);
      });
    };
    var getHeightWithFallback = function (editor) {
      var height = getHeight(editor);
      return height.getOr(getHeightSetting(editor));
    };
    var getWidth = function (editor) {
      var baseWidth = getWidthSetting(editor);
      var minWidth = getMinWidthSetting(editor);
      var maxWidth = getMaxWidthSetting(editor);
      return parseToInt(baseWidth).map(function (width) {
        return calcCappedSize(width, minWidth, maxWidth);
      });
    };
    var getWidthWithFallback = function (editor) {
      var width = getWidth(editor);
      return width.getOr(getWidthSetting(editor));
    };

    var InlineHeader = function (editor, targetElm, uiComponents, backstage, floatContainer) {
      var uiMothership = uiComponents.uiMothership, outerContainer = uiComponents.outerContainer;
      var DOM = global$b.DOM;
      var useFixedToolbarContainer = useFixedContainer(editor);
      var isSticky = isStickyToolbar(editor);
      var editorMaxWidthOpt = getMaxWidthSetting(editor).or(getWidth(editor));
      var headerBackstage = backstage.shared.header;
      var isPositionedAtTop = headerBackstage.isPositionedAtTop;
      var toolbarMode = getToolbarMode(editor);
      var isSplitToolbar = toolbarMode === ToolbarMode.sliding || toolbarMode === ToolbarMode.floating;
      var visible = Cell(false);
      var isVisible = function () {
        return visible.get() && !editor.removed;
      };
      var calcToolbarOffset = function (toolbar) {
        return isSplitToolbar ? toolbar.fold(constant$1(0), function (tbar) {
          return tbar.components().length > 1 ? get$b(tbar.components()[1].element) : 0;
        }) : 0;
      };
      var calcMode = function (container) {
        switch (getToolbarLocation(editor)) {
        case ToolbarLocation.auto:
          var toolbar_1 = OuterContainer.getToolbar(outerContainer);
          var offset = calcToolbarOffset(toolbar_1);
          var toolbarHeight = get$b(container.element) - offset;
          var targetBounds = box$1(targetElm);
          var roomAtTop = targetBounds.y > toolbarHeight;
          if (roomAtTop) {
            return 'top';
          } else {
            var doc = documentElement(targetElm);
            var docHeight = Math.max(doc.dom.scrollHeight, get$b(doc));
            var roomAtBottom = targetBounds.bottom < docHeight - toolbarHeight;
            if (roomAtBottom) {
              return 'bottom';
            } else {
              var winBounds = win();
              var isRoomAtBottomViewport = winBounds.bottom < targetBounds.bottom - toolbarHeight;
              return isRoomAtBottomViewport ? 'bottom' : 'top';
            }
          }
        case ToolbarLocation.bottom:
          return 'bottom';
        case ToolbarLocation.top:
        default:
          return 'top';
        }
      };
      var setupMode = function (mode) {
        var container = floatContainer.get();
        Docking.setModes(container, [mode]);
        headerBackstage.setDockingMode(mode);
        var verticalDir = isPositionedAtTop() ? AttributeValue.TopToBottom : AttributeValue.BottomToTop;
        set$8(container.element, Attribute, verticalDir);
      };
      var updateChromeWidth = function () {
        var maxWidth = editorMaxWidthOpt.getOrThunk(function () {
          var bodyMargin = parseToInt(get$c(body(), 'margin-left')).getOr(0);
          return get$a(body()) - absolute$3(targetElm).left + bodyMargin;
        });
        set$7(floatContainer.get().element, 'max-width', maxWidth + 'px');
      };
      var updateChromePosition = function () {
        var toolbar = OuterContainer.getToolbar(outerContainer);
        var offset = calcToolbarOffset(toolbar);
        var targetBounds = box$1(targetElm);
        var top = isPositionedAtTop() ? Math.max(targetBounds.y - get$b(floatContainer.get().element) + offset, 0) : targetBounds.bottom;
        setAll(outerContainer.element, {
          position: 'absolute',
          top: Math.round(top) + 'px',
          left: Math.round(targetBounds.x) + 'px'
        });
      };
      var repositionPopups$1 = function () {
        uiMothership.broadcastOn([repositionPopups()], {});
      };
      var updateChromeUi = function (resetDocking) {
        if (resetDocking === void 0) {
          resetDocking = false;
        }
        if (!isVisible()) {
          return;
        }
        if (!useFixedToolbarContainer) {
          updateChromeWidth();
        }
        if (isSplitToolbar) {
          OuterContainer.refreshToolbar(outerContainer);
        }
        if (!useFixedToolbarContainer) {
          updateChromePosition();
        }
        if (isSticky) {
          var floatContainerComp = floatContainer.get();
          resetDocking ? Docking.reset(floatContainerComp) : Docking.refresh(floatContainerComp);
        }
        repositionPopups$1();
      };
      var updateMode = function (updateUi) {
        if (updateUi === void 0) {
          updateUi = true;
        }
        if (useFixedToolbarContainer || !isSticky || !isVisible()) {
          return;
        }
        var currentMode = headerBackstage.getDockingMode();
        var newMode = calcMode(floatContainer.get());
        if (newMode !== currentMode) {
          setupMode(newMode);
          if (updateUi) {
            updateChromeUi(true);
          }
        }
      };
      var show = function () {
        visible.set(true);
        set$7(outerContainer.element, 'display', 'flex');
        DOM.addClass(editor.getBody(), 'mce-edit-focus');
        remove$6(uiMothership.element, 'display');
        updateMode(false);
        updateChromeUi();
      };
      var hide = function () {
        visible.set(false);
        if (uiComponents.outerContainer) {
          set$7(outerContainer.element, 'display', 'none');
          DOM.removeClass(editor.getBody(), 'mce-edit-focus');
        }
        set$7(uiMothership.element, 'display', 'none');
      };
      return {
        isVisible: isVisible,
        isPositionedAtTop: isPositionedAtTop,
        show: show,
        hide: hide,
        update: updateChromeUi,
        updateMode: updateMode,
        repositionPopups: repositionPopups$1
      };
    };

    var getTargetPosAndBounds = function (targetElm, isToolbarTop) {
      var bounds = box$1(targetElm);
      return {
        pos: isToolbarTop ? bounds.y : bounds.bottom,
        bounds: bounds
      };
    };
    var setupEvents = function (editor, targetElm, ui, toolbarPersist) {
      var prevPosAndBounds = Cell(getTargetPosAndBounds(targetElm, ui.isPositionedAtTop()));
      var resizeContent = function (e) {
        var _a = getTargetPosAndBounds(targetElm, ui.isPositionedAtTop()), pos = _a.pos, bounds = _a.bounds;
        var _b = prevPosAndBounds.get(), prevPos = _b.pos, prevBounds = _b.bounds;
        var hasResized = bounds.height !== prevBounds.height || bounds.width !== prevBounds.width;
        prevPosAndBounds.set({
          pos: pos,
          bounds: bounds
        });
        if (hasResized) {
          fireResizeContent(editor, e);
        }
        if (ui.isVisible()) {
          if (prevPos !== pos) {
            ui.update(true);
          } else if (hasResized) {
            ui.updateMode();
            ui.repositionPopups();
          }
        }
      };
      if (!toolbarPersist) {
        editor.on('activate', ui.show);
        editor.on('deactivate', ui.hide);
      }
      editor.on('SkinLoaded ResizeWindow', function () {
        return ui.update(true);
      });
      editor.on('NodeChange keydown', function (e) {
        global$f.requestAnimationFrame(function () {
          return resizeContent(e);
        });
      });
      editor.on('ScrollWindow', function () {
        return ui.updateMode();
      });
      var elementLoad = unbindable();
      elementLoad.set(capture(SugarElement.fromDom(editor.getBody()), 'load', resizeContent));
      editor.on('remove', function () {
        elementLoad.clear();
      });
    };
    var render = function (editor, uiComponents, rawUiConfig, backstage, args) {
      var mothership = uiComponents.mothership, uiMothership = uiComponents.uiMothership, outerContainer = uiComponents.outerContainer;
      var floatContainer = Cell(null);
      var targetElm = SugarElement.fromDom(args.targetNode);
      var ui = InlineHeader(editor, targetElm, uiComponents, backstage, floatContainer);
      var toolbarPersist = isToolbarPersist(editor);
      inline(editor);
      var render = function () {
        if (floatContainer.get()) {
          ui.show();
          return;
        }
        floatContainer.set(OuterContainer.getHeader(outerContainer).getOrDie());
        var uiContainer = getUiContainer(editor);
        attachSystem(uiContainer, mothership);
        attachSystem(uiContainer, uiMothership);
        setToolbar(editor, uiComponents, rawUiConfig, backstage);
        OuterContainer.setMenubar(outerContainer, identifyMenus(editor, rawUiConfig));
        ui.show();
        setupEvents(editor, targetElm, ui, toolbarPersist);
        editor.nodeChanged();
      };
      editor.on('show', render);
      editor.on('hide', ui.hide);
      if (!toolbarPersist) {
        editor.on('focus', render);
        editor.on('blur', ui.hide);
      }
      editor.on('init', function () {
        if (editor.hasFocus() || toolbarPersist) {
          render();
        }
      });
      setupReadonlyModeSwitch(editor, uiComponents);
      var api = {
        show: function () {
          ui.show();
        },
        hide: function () {
          ui.hide();
        },
        enable: function () {
          broadcastReadonly(uiComponents, false);
        },
        disable: function () {
          broadcastReadonly(uiComponents, true);
        },
        isDisabled: function () {
          return Disabling.isDisabled(outerContainer);
        }
      };
      return {
        editorContainer: outerContainer.element.dom,
        api: api
      };
    };

    var Inline = /*#__PURE__*/Object.freeze({
        __proto__: null,
        render: render
    });

    var showContextToolbarEvent = 'contexttoolbar-show';
    var hideContextToolbarEvent = 'contexttoolbar-hide';

    var getFormApi = function (input) {
      return {
        hide: function () {
          return emit(input, sandboxClose());
        },
        getValue: function () {
          return Representing.getValue(input);
        }
      };
    };
    var runOnExecute = function (memInput, original) {
      return run$1(internalToolbarButtonExecute, function (comp, se) {
        var input = memInput.get(comp);
        var formApi = getFormApi(input);
        original.onAction(formApi, se.event.buttonApi);
      });
    };
    var renderContextButton = function (memInput, button, extras) {
      var _a = button.original; _a.primary; var rest = __rest(_a, ['primary']);
      var bridged = getOrDie(createToolbarButton(__assign(__assign({}, rest), {
        type: 'button',
        onAction: noop
      })));
      return renderToolbarButtonWith(bridged, extras.backstage.shared.providers, [runOnExecute(memInput, button)]);
    };
    var renderContextToggleButton = function (memInput, button, extras) {
      var _a = button.original; _a.primary; var rest = __rest(_a, ['primary']);
      var bridged = getOrDie(createToggleButton(__assign(__assign({}, rest), {
        type: 'togglebutton',
        onAction: noop
      })));
      return renderToolbarToggleButtonWith(bridged, extras.backstage.shared.providers, [runOnExecute(memInput, button)]);
    };
    var generateOne = function (memInput, button, providersBackstage) {
      var extras = { backstage: { shared: { providers: providersBackstage } } };
      if (button.type === 'contextformtogglebutton') {
        return renderContextToggleButton(memInput, button, extras);
      } else {
        return renderContextButton(memInput, button, extras);
      }
    };
    var generate = function (memInput, buttons, providersBackstage) {
      var mementos = map$2(buttons, function (button) {
        return record(generateOne(memInput, button, providersBackstage));
      });
      var asSpecs = function () {
        return map$2(mementos, function (mem) {
          return mem.asSpec();
        });
      };
      var findPrimary = function (compInSystem) {
        return findMap(buttons, function (button, i) {
          if (button.primary) {
            return Optional.from(mementos[i]).bind(function (mem) {
              return mem.getOpt(compInSystem);
            }).filter(not(Disabling.isDisabled));
          } else {
            return Optional.none();
          }
        });
      };
      return {
        asSpecs: asSpecs,
        findPrimary: findPrimary
      };
    };

    var buildInitGroups = function (ctx, providers) {
      var inputAttributes = ctx.label.fold(function () {
        return {};
      }, function (label) {
        return { 'aria-label': label };
      });
      var memInput = record(Input.sketch({
        inputClasses: [
          'tox-toolbar-textfield',
          'tox-toolbar-nav-js'
        ],
        data: ctx.initValue(),
        inputAttributes: inputAttributes,
        selectOnFocus: true,
        inputBehaviours: derive$1([Keying.config({
            mode: 'special',
            onEnter: function (input) {
              return commands.findPrimary(input).map(function (primary) {
                emitExecute(primary);
                return true;
              });
            },
            onLeft: function (comp, se) {
              se.cut();
              return Optional.none();
            },
            onRight: function (comp, se) {
              se.cut();
              return Optional.none();
            }
          })])
      }));
      var commands = generate(memInput, ctx.commands, providers);
      return [
        {
          title: Optional.none(),
          items: [memInput.asSpec()]
        },
        {
          title: Optional.none(),
          items: commands.asSpecs()
        }
      ];
    };
    var renderContextForm = function (toolbarType, ctx, providers) {
      return renderToolbar({
        type: toolbarType,
        uid: generate$6('context-toolbar'),
        initGroups: buildInitGroups(ctx, providers),
        onEscape: Optional.none,
        cyclicKeying: true,
        providers: providers
      });
    };
    var ContextForm = {
      renderContextForm: renderContextForm,
      buildInitGroups: buildInitGroups
    };

    var isVerticalOverlap = function (a, b, threshold) {
      if (threshold === void 0) {
        threshold = 0.01;
      }
      return b.bottom - a.y >= threshold && a.bottom - b.y >= threshold;
    };
    var getRangeRect = function (rng) {
      var rect = rng.getBoundingClientRect();
      if (rect.height <= 0 && rect.width <= 0) {
        var leaf$1 = leaf(SugarElement.fromDom(rng.startContainer), rng.startOffset).element;
        var elm = isText$1(leaf$1) ? parent(leaf$1) : Optional.some(leaf$1);
        return elm.filter(isElement$2).map(function (e) {
          return e.dom.getBoundingClientRect();
        }).getOr(rect);
      } else {
        return rect;
      }
    };
    var getSelectionBounds = function (editor) {
      var rng = editor.selection.getRng();
      var rect = getRangeRect(rng);
      if (editor.inline) {
        var scroll_1 = get$9();
        return bounds(scroll_1.left + rect.left, scroll_1.top + rect.top, rect.width, rect.height);
      } else {
        var bodyPos = absolute$2(SugarElement.fromDom(editor.getBody()));
        return bounds(bodyPos.x + rect.left, bodyPos.y + rect.top, rect.width, rect.height);
      }
    };
    var getAnchorElementBounds = function (editor, lastElement) {
      return lastElement.filter(inBody).map(absolute$2).getOrThunk(function () {
        return getSelectionBounds(editor);
      });
    };
    var getHorizontalBounds = function (contentAreaBox, viewportBounds, margin) {
      var x = Math.max(contentAreaBox.x + margin, viewportBounds.x);
      var right = Math.min(contentAreaBox.right - margin, viewportBounds.right);
      return {
        x: x,
        width: right - x
      };
    };
    var getVerticalBounds = function (editor, contentAreaBox, viewportBounds, isToolbarLocationTop, toolbarType, margin) {
      var container = SugarElement.fromDom(editor.getContainer());
      var header = descendant(container, '.tox-editor-header').getOr(container);
      var headerBox = box$1(header);
      var isToolbarBelowContentArea = headerBox.y >= contentAreaBox.bottom;
      var isToolbarAbove = isToolbarLocationTop && !isToolbarBelowContentArea;
      if (editor.inline && isToolbarAbove) {
        return {
          y: Math.max(headerBox.bottom + margin, viewportBounds.y),
          bottom: viewportBounds.bottom
        };
      }
      if (editor.inline && !isToolbarAbove) {
        return {
          y: viewportBounds.y,
          bottom: Math.min(headerBox.y - margin, viewportBounds.bottom)
        };
      }
      var containerBounds = toolbarType === 'line' ? box$1(container) : contentAreaBox;
      if (isToolbarAbove) {
        return {
          y: Math.max(headerBox.bottom + margin, viewportBounds.y),
          bottom: Math.min(containerBounds.bottom - margin, viewportBounds.bottom)
        };
      }
      return {
        y: Math.max(containerBounds.y + margin, viewportBounds.y),
        bottom: Math.min(headerBox.y - margin, viewportBounds.bottom)
      };
    };
    var getContextToolbarBounds = function (editor, sharedBackstage, toolbarType, margin) {
      if (margin === void 0) {
        margin = 0;
      }
      var viewportBounds = getBounds$3(window);
      var contentAreaBox = box$1(SugarElement.fromDom(editor.getContentAreaContainer()));
      var toolbarOrMenubarEnabled = isMenubarEnabled(editor) || isToolbarEnabled(editor) || isMultipleToolbars(editor);
      var _a = getHorizontalBounds(contentAreaBox, viewportBounds, margin), x = _a.x, width = _a.width;
      if (editor.inline && !toolbarOrMenubarEnabled) {
        return bounds(x, viewportBounds.y, width, viewportBounds.height);
      } else {
        var isToolbarTop = sharedBackstage.header.isPositionedAtTop();
        var _b = getVerticalBounds(editor, contentAreaBox, viewportBounds, isToolbarTop, toolbarType, margin), y = _b.y, bottom = _b.bottom;
        return bounds(x, y, width, bottom - y);
      }
    };

    var bubbleSize$1 = 12;
    var bubbleAlignments$1 = {
      valignCentre: [],
      alignCentre: [],
      alignLeft: ['tox-pop--align-left'],
      alignRight: ['tox-pop--align-right'],
      right: ['tox-pop--right'],
      left: ['tox-pop--left'],
      bottom: ['tox-pop--bottom'],
      top: ['tox-pop--top'],
      inset: ['tox-pop--inset']
    };
    var anchorOverrides = {
      maxHeightFunction: expandable$1(),
      maxWidthFunction: expandable()
    };
    var isEntireElementSelected = function (editor, elem) {
      var rng = editor.selection.getRng();
      var leaf$1 = leaf(SugarElement.fromDom(rng.startContainer), rng.startOffset);
      return rng.startContainer === rng.endContainer && rng.startOffset === rng.endOffset - 1 && eq(leaf$1.element, elem);
    };
    var preservePosition = function (elem, position, f) {
      var currentPosition = getRaw(elem, 'position');
      set$7(elem, 'position', position);
      var result = f(elem);
      currentPosition.each(function (pos) {
        return set$7(elem, 'position', pos);
      });
      return result;
    };
    var shouldUseInsetLayouts = function (position) {
      return position === 'node';
    };
    var determineInsetLayout = function (editor, contextbar, elem, data, bounds) {
      var selectionBounds = getSelectionBounds(editor);
      var isSameAnchorElement = data.lastElement().exists(function (prev) {
        return eq(elem, prev);
      });
      if (isEntireElementSelected(editor, elem)) {
        return isSameAnchorElement ? preserve : north;
      } else if (isSameAnchorElement) {
        return preservePosition(contextbar, data.getMode(), function () {
          var isOverlapping = isVerticalOverlap(selectionBounds, box$1(contextbar));
          return isOverlapping && !data.isReposition() ? flip$2 : preserve;
        });
      } else {
        var yBounds = data.getMode() === 'fixed' ? bounds.y + get$9().top : bounds.y;
        var contextbarHeight = get$b(contextbar) + bubbleSize$1;
        return yBounds + contextbarHeight <= selectionBounds.y ? north : south;
      }
    };
    var getAnchorSpec$2 = function (editor, mobile, data, position) {
      var smartInsetLayout = function (elem) {
        return function (anchor, element, bubbles, placee, bounds) {
          var layout = determineInsetLayout(editor, placee, elem, data, bounds);
          var newAnchor = __assign(__assign({}, anchor), {
            y: bounds.y,
            height: bounds.height
          });
          return __assign(__assign({}, layout(newAnchor, element, bubbles, placee, bounds)), { alwaysFit: true });
        };
      };
      var getInsetLayouts = function (elem) {
        return shouldUseInsetLayouts(position) ? [smartInsetLayout(elem)] : [];
      };
      var desktopAnchorSpecLayouts = {
        onLtr: function (elem) {
          return [
            north$2,
            south$2,
            northeast$2,
            southeast$2,
            northwest$2,
            southwest$2
          ].concat(getInsetLayouts(elem));
        },
        onRtl: function (elem) {
          return [
            north$2,
            south$2,
            northwest$2,
            southwest$2,
            northeast$2,
            southeast$2
          ].concat(getInsetLayouts(elem));
        }
      };
      var mobileAnchorSpecLayouts = {
        onLtr: function (elem) {
          return [
            south$2,
            southeast$2,
            southwest$2,
            northeast$2,
            northwest$2,
            north$2
          ].concat(getInsetLayouts(elem));
        },
        onRtl: function (elem) {
          return [
            south$2,
            southwest$2,
            southeast$2,
            northwest$2,
            northeast$2,
            north$2
          ].concat(getInsetLayouts(elem));
        }
      };
      return mobile ? mobileAnchorSpecLayouts : desktopAnchorSpecLayouts;
    };
    var getAnchorLayout = function (editor, position, isTouch, data) {
      if (position === 'line') {
        return {
          bubble: nu$5(bubbleSize$1, 0, bubbleAlignments$1),
          layouts: {
            onLtr: function () {
              return [east$2];
            },
            onRtl: function () {
              return [west$2];
            }
          },
          overrides: anchorOverrides
        };
      } else {
        return {
          bubble: nu$5(0, bubbleSize$1, bubbleAlignments$1, 1 / bubbleSize$1),
          layouts: getAnchorSpec$2(editor, isTouch, data, position),
          overrides: anchorOverrides
        };
      }
    };

    var matchTargetWith = function (elem, candidates) {
      var ctxs = filter$2(candidates, function (toolbarApi) {
        return toolbarApi.predicate(elem.dom);
      });
      var _a = partition$3(ctxs, function (t) {
          return t.type === 'contexttoolbar';
        }), pass = _a.pass, fail = _a.fail;
      return {
        contextToolbars: pass,
        contextForms: fail
      };
    };
    var filterByPositionForStartNode = function (toolbars) {
      if (toolbars.length <= 1) {
        return toolbars;
      } else {
        var doesPositionExist = function (value) {
          return exists(toolbars, function (t) {
            return t.position === value;
          });
        };
        var filterToolbarsByPosition = function (value) {
          return filter$2(toolbars, function (t) {
            return t.position === value;
          });
        };
        var hasSelectionToolbars = doesPositionExist('selection');
        var hasNodeToolbars = doesPositionExist('node');
        if (hasSelectionToolbars || hasNodeToolbars) {
          if (hasNodeToolbars && hasSelectionToolbars) {
            var nodeToolbars = filterToolbarsByPosition('node');
            var selectionToolbars = map$2(filterToolbarsByPosition('selection'), function (t) {
              return __assign(__assign({}, t), { position: 'node' });
            });
            return nodeToolbars.concat(selectionToolbars);
          } else {
            return hasSelectionToolbars ? filterToolbarsByPosition('selection') : filterToolbarsByPosition('node');
          }
        } else {
          return filterToolbarsByPosition('line');
        }
      }
    };
    var filterByPositionForAncestorNode = function (toolbars) {
      if (toolbars.length <= 1) {
        return toolbars;
      } else {
        var findPosition_1 = function (value) {
          return find$5(toolbars, function (t) {
            return t.position === value;
          });
        };
        var basePosition = findPosition_1('selection').orThunk(function () {
          return findPosition_1('node');
        }).orThunk(function () {
          return findPosition_1('line');
        }).map(function (t) {
          return t.position;
        });
        return basePosition.fold(function () {
          return [];
        }, function (pos) {
          return filter$2(toolbars, function (t) {
            return t.position === pos;
          });
        });
      }
    };
    var matchStartNode = function (elem, nodeCandidates, editorCandidates) {
      var nodeMatches = matchTargetWith(elem, nodeCandidates);
      if (nodeMatches.contextForms.length > 0) {
        return Optional.some({
          elem: elem,
          toolbars: [nodeMatches.contextForms[0]]
        });
      } else {
        var editorMatches = matchTargetWith(elem, editorCandidates);
        if (editorMatches.contextForms.length > 0) {
          return Optional.some({
            elem: elem,
            toolbars: [editorMatches.contextForms[0]]
          });
        } else if (nodeMatches.contextToolbars.length > 0 || editorMatches.contextToolbars.length > 0) {
          var toolbars = filterByPositionForStartNode(nodeMatches.contextToolbars.concat(editorMatches.contextToolbars));
          return Optional.some({
            elem: elem,
            toolbars: toolbars
          });
        } else {
          return Optional.none();
        }
      }
    };
    var matchAncestor = function (isRoot, startNode, scopes) {
      if (isRoot(startNode)) {
        return Optional.none();
      } else {
        return ancestor$2(startNode, function (ancestorElem) {
          if (isElement$2(ancestorElem)) {
            var _a = matchTargetWith(ancestorElem, scopes.inNodeScope), contextToolbars = _a.contextToolbars, contextForms = _a.contextForms;
            var toolbars = contextForms.length > 0 ? contextForms : filterByPositionForAncestorNode(contextToolbars);
            return toolbars.length > 0 ? Optional.some({
              elem: ancestorElem,
              toolbars: toolbars
            }) : Optional.none();
          } else {
            return Optional.none();
          }
        }, isRoot);
      }
    };
    var lookup$1 = function (scopes, editor) {
      var rootElem = SugarElement.fromDom(editor.getBody());
      var isRoot = function (elem) {
        return eq(elem, rootElem);
      };
      var isOutsideRoot = function (startNode) {
        return !isRoot(startNode) && !contains(rootElem, startNode);
      };
      var startNode = SugarElement.fromDom(editor.selection.getNode());
      if (isOutsideRoot(startNode)) {
        return Optional.none();
      }
      return matchStartNode(startNode, scopes.inNodeScope, scopes.inEditorScope).orThunk(function () {
        return matchAncestor(isRoot, startNode, scopes);
      });
    };

    var categorise = function (contextToolbars, navigate) {
      var forms = {};
      var inNodeScope = [];
      var inEditorScope = [];
      var formNavigators = {};
      var lookupTable = {};
      var registerForm = function (key, toolbarSpec) {
        var contextForm = getOrDie(createContextForm(toolbarSpec));
        forms[key] = contextForm;
        contextForm.launch.map(function (launch) {
          formNavigators['form:' + key + ''] = __assign(__assign({}, toolbarSpec.launch), {
            type: launch.type === 'contextformtogglebutton' ? 'togglebutton' : 'button',
            onAction: function () {
              navigate(contextForm);
            }
          });
        });
        if (contextForm.scope === 'editor') {
          inEditorScope.push(contextForm);
        } else {
          inNodeScope.push(contextForm);
        }
        lookupTable[key] = contextForm;
      };
      var registerToolbar = function (key, toolbarSpec) {
        createContextToolbar(toolbarSpec).each(function (contextToolbar) {
          if (toolbarSpec.scope === 'editor') {
            inEditorScope.push(contextToolbar);
          } else {
            inNodeScope.push(contextToolbar);
          }
          lookupTable[key] = contextToolbar;
        });
      };
      var keys$1 = keys(contextToolbars);
      each$1(keys$1, function (key) {
        var toolbarApi = contextToolbars[key];
        if (toolbarApi.type === 'contextform') {
          registerForm(key, toolbarApi);
        } else if (toolbarApi.type === 'contexttoolbar') {
          registerToolbar(key, toolbarApi);
        }
      });
      return {
        forms: forms,
        inNodeScope: inNodeScope,
        inEditorScope: inEditorScope,
        lookupTable: lookupTable,
        formNavigators: formNavigators
      };
    };

    var forwardSlideEvent = generate$6('forward-slide');
    var backSlideEvent = generate$6('backward-slide');
    var changeSlideEvent = generate$6('change-slide-event');
    var resizingClass = 'tox-pop--resizing';
    var renderContextToolbar = function (spec) {
      var stack = Cell([]);
      return InlineView.sketch({
        dom: {
          tag: 'div',
          classes: ['tox-pop']
        },
        fireDismissalEventInstead: { event: 'doNotDismissYet' },
        onShow: function (comp) {
          stack.set([]);
          InlineView.getContent(comp).each(function (c) {
            remove$6(c.element, 'visibility');
          });
          remove$2(comp.element, resizingClass);
          remove$6(comp.element, 'width');
        },
        inlineBehaviours: derive$1([
          config('context-toolbar-events', [
            runOnSource(transitionend(), function (comp, se) {
              if (se.event.raw.propertyName === 'width') {
                remove$2(comp.element, resizingClass);
                remove$6(comp.element, 'width');
              }
            }),
            run$1(changeSlideEvent, function (comp, se) {
              var elem = comp.element;
              remove$6(elem, 'width');
              var currentWidth = get$a(elem);
              InlineView.setContent(comp, se.event.contents);
              add$2(elem, resizingClass);
              var newWidth = get$a(elem);
              set$7(elem, 'width', currentWidth + 'px');
              InlineView.getContent(comp).each(function (newContents) {
                se.event.focus.bind(function (f) {
                  focus$3(f);
                  return search(elem);
                }).orThunk(function () {
                  Keying.focusIn(newContents);
                  return active(getRootNode(elem));
                });
              });
              global$f.setTimeout(function () {
                set$7(comp.element, 'width', newWidth + 'px');
              }, 0);
            }),
            run$1(forwardSlideEvent, function (comp, se) {
              InlineView.getContent(comp).each(function (oldContents) {
                stack.set(stack.get().concat([{
                    bar: oldContents,
                    focus: active(getRootNode(comp.element))
                  }]));
              });
              emitWith(comp, changeSlideEvent, {
                contents: se.event.forwardContents,
                focus: Optional.none()
              });
            }),
            run$1(backSlideEvent, function (comp, _se) {
              last$2(stack.get()).each(function (last) {
                stack.set(stack.get().slice(0, stack.get().length - 1));
                emitWith(comp, changeSlideEvent, {
                  contents: premade(last.bar),
                  focus: last.focus
                });
              });
            })
          ]),
          Keying.config({
            mode: 'special',
            onEscape: function (comp) {
              return last$2(stack.get()).fold(function () {
                return spec.onEscape();
              }, function (_) {
                emit(comp, backSlideEvent);
                return Optional.some(true);
              });
            }
          })
        ]),
        lazySink: function () {
          return Result.value(spec.sink);
        }
      });
    };

    var transitionClass = 'tox-pop--transition';
    var register$7 = function (editor, registryContextToolbars, sink, extras) {
      var backstage = extras.backstage;
      var sharedBackstage = backstage.shared;
      var isTouch = detect$1().deviceType.isTouch;
      var lastElement = value$1();
      var lastTrigger = value$1();
      var lastContextPosition = value$1();
      var contextbar = build$1(renderContextToolbar({
        sink: sink,
        onEscape: function () {
          editor.focus();
          return Optional.some(true);
        }
      }));
      var getBounds = function () {
        var position = lastContextPosition.get().getOr('node');
        var margin = shouldUseInsetLayouts(position) ? 1 : 0;
        return getContextToolbarBounds(editor, sharedBackstage, position, margin);
      };
      var canLaunchToolbar = function () {
        return !editor.removed && !(isTouch() && backstage.isContextMenuOpen());
      };
      var isSameLaunchElement = function (elem) {
        return is$1(lift2(elem, lastElement.get(), eq), true);
      };
      var shouldContextToolbarHide = function () {
        if (!canLaunchToolbar()) {
          return true;
        } else {
          var contextToolbarBounds = getBounds();
          var anchorBounds = is$1(lastContextPosition.get(), 'node') ? getAnchorElementBounds(editor, lastElement.get()) : getSelectionBounds(editor);
          return contextToolbarBounds.height <= 0 || !isVerticalOverlap(anchorBounds, contextToolbarBounds);
        }
      };
      var close = function () {
        lastElement.clear();
        lastTrigger.clear();
        lastContextPosition.clear();
        InlineView.hide(contextbar);
      };
      var hideOrRepositionIfNecessary = function () {
        if (InlineView.isOpen(contextbar)) {
          var contextBarEle = contextbar.element;
          remove$6(contextBarEle, 'display');
          if (shouldContextToolbarHide()) {
            set$7(contextBarEle, 'display', 'none');
          } else {
            lastTrigger.set(0);
            InlineView.reposition(contextbar);
          }
        }
      };
      var wrapInPopDialog = function (toolbarSpec) {
        return {
          dom: {
            tag: 'div',
            classes: ['tox-pop__dialog']
          },
          components: [toolbarSpec],
          behaviours: derive$1([
            Keying.config({ mode: 'acyclic' }),
            config('pop-dialog-wrap-events', [
              runOnAttached(function (comp) {
                editor.shortcuts.add('ctrl+F9', 'focus statusbar', function () {
                  return Keying.focusIn(comp);
                });
              }),
              runOnDetached(function (_comp) {
                editor.shortcuts.remove('ctrl+F9');
              })
            ])
          ])
        };
      };
      var getScopes = cached(function () {
        return categorise(registryContextToolbars, function (toolbarApi) {
          var alloySpec = buildToolbar([toolbarApi]);
          emitWith(contextbar, forwardSlideEvent, { forwardContents: wrapInPopDialog(alloySpec) });
        });
      });
      var buildContextToolbarGroups = function (allButtons, ctx) {
        return identifyButtons(editor, {
          buttons: allButtons,
          toolbar: ctx.items,
          allowToolbarGroups: false
        }, extras, Optional.some(['form:']));
      };
      var buildContextFormGroups = function (ctx, providers) {
        return ContextForm.buildInitGroups(ctx, providers);
      };
      var buildToolbar = function (toolbars) {
        var buttons = editor.ui.registry.getAll().buttons;
        var scopes = getScopes();
        var allButtons = __assign(__assign({}, buttons), scopes.formNavigators);
        var toolbarType = getToolbarMode(editor) === ToolbarMode.scrolling ? ToolbarMode.scrolling : ToolbarMode.default;
        var initGroups = flatten(map$2(toolbars, function (ctx) {
          return ctx.type === 'contexttoolbar' ? buildContextToolbarGroups(allButtons, ctx) : buildContextFormGroups(ctx, sharedBackstage.providers);
        }));
        return renderToolbar({
          type: toolbarType,
          uid: generate$6('context-toolbar'),
          initGroups: initGroups,
          onEscape: Optional.none,
          cyclicKeying: true,
          providers: sharedBackstage.providers
        });
      };
      var getAnchor = function (position, element) {
        var anchorage = position === 'node' ? sharedBackstage.anchors.node(element) : sharedBackstage.anchors.cursor();
        var anchorLayout = getAnchorLayout(editor, position, isTouch(), {
          lastElement: lastElement.get,
          isReposition: function () {
            return is$1(lastTrigger.get(), 0);
          },
          getMode: function () {
            return Positioning.getMode(sink);
          }
        });
        return deepMerge(anchorage, anchorLayout);
      };
      var launchContext = function (toolbarApi, elem) {
        launchContextToolbar.cancel();
        if (!canLaunchToolbar()) {
          return;
        }
        var toolbarSpec = buildToolbar(toolbarApi);
        var position = toolbarApi[0].position;
        var anchor = getAnchor(position, elem);
        lastContextPosition.set(position);
        lastTrigger.set(1);
        var contextBarEle = contextbar.element;
        remove$6(contextBarEle, 'display');
        if (!isSameLaunchElement(elem)) {
          remove$2(contextBarEle, transitionClass);
          Positioning.reset(sink, contextbar);
        }
        InlineView.showWithinBounds(contextbar, wrapInPopDialog(toolbarSpec), {
          anchor: anchor,
          transition: {
            classes: [transitionClass],
            mode: 'placement'
          }
        }, function () {
          return Optional.some(getBounds());
        });
        elem.fold(lastElement.clear, lastElement.set);
        if (shouldContextToolbarHide()) {
          set$7(contextBarEle, 'display', 'none');
        }
      };
      var launchContextToolbar = last(function () {
        if (!editor.hasFocus() || editor.removed) {
          return;
        }
        if (has(contextbar.element, transitionClass)) {
          launchContextToolbar.throttle();
        } else {
          var scopes = getScopes();
          lookup$1(scopes, editor).fold(close, function (info) {
            launchContext(info.toolbars, Optional.some(info.elem));
          });
        }
      }, 17);
      editor.on('init', function () {
        editor.on('remove', close);
        editor.on('ScrollContent ScrollWindow ObjectResized ResizeEditor longpress', hideOrRepositionIfNecessary);
        editor.on('click keyup focus SetContent', launchContextToolbar.throttle);
        editor.on(hideContextToolbarEvent, close);
        editor.on(showContextToolbarEvent, function (e) {
          var scopes = getScopes();
          get$e(scopes.lookupTable, e.toolbarKey).each(function (ctx) {
            launchContext([ctx], someIf(e.target !== editor, e.target));
            InlineView.getContent(contextbar).each(Keying.focusIn);
          });
        });
        editor.on('focusout', function (_e) {
          global$f.setEditorTimeout(editor, function () {
            if (search(sink.element).isNone() && search(contextbar.element).isNone()) {
              close();
            }
          }, 0);
        });
        editor.on('SwitchMode', function () {
          if (editor.mode.isReadOnly()) {
            close();
          }
        });
        editor.on('AfterProgressState', function (event) {
          if (event.state) {
            close();
          } else if (editor.hasFocus()) {
            launchContextToolbar.throttle();
          }
        });
        editor.on('NodeChange', function (_e) {
          search(contextbar.element).fold(launchContextToolbar.throttle, noop);
        });
      });
    };

    var register$6 = function (editor) {
      var alignToolbarButtons = [
        {
          name: 'alignleft',
          text: 'Align left',
          cmd: 'JustifyLeft',
          icon: 'align-left'
        },
        {
          name: 'aligncenter',
          text: 'Align center',
          cmd: 'JustifyCenter',
          icon: 'align-center'
        },
        {
          name: 'alignright',
          text: 'Align right',
          cmd: 'JustifyRight',
          icon: 'align-right'
        },
        {
          name: 'alignjustify',
          text: 'Justify',
          cmd: 'JustifyFull',
          icon: 'align-justify'
        }
      ];
      each$1(alignToolbarButtons, function (item) {
        editor.ui.registry.addToggleButton(item.name, {
          tooltip: item.text,
          icon: item.icon,
          onAction: onActionExecCommand(editor, item.cmd),
          onSetup: onSetupFormatToggle(editor, item.name)
        });
      });
      editor.ui.registry.addButton('alignnone', {
        tooltip: 'No alignment',
        icon: 'align-none',
        onAction: onActionExecCommand(editor, 'JustifyNone')
      });
    };

    var units = {
      unsupportedLength: [
        'em',
        'ex',
        'cap',
        'ch',
        'ic',
        'rem',
        'lh',
        'rlh',
        'vw',
        'vh',
        'vi',
        'vb',
        'vmin',
        'vmax',
        'cm',
        'mm',
        'Q',
        'in',
        'pc',
        'pt',
        'px'
      ],
      fixed: [
        'px',
        'pt'
      ],
      relative: ['%'],
      empty: ['']
    };
    var pattern = function () {
      var decimalDigits = '[0-9]+';
      var signedInteger = '[+-]?' + decimalDigits;
      var exponentPart = '[eE]' + signedInteger;
      var dot = '\\.';
      var opt = function (input) {
        return '(?:' + input + ')?';
      };
      var unsignedDecimalLiteral = [
        'Infinity',
        decimalDigits + dot + opt(decimalDigits) + opt(exponentPart),
        dot + decimalDigits + opt(exponentPart),
        decimalDigits + opt(exponentPart)
      ].join('|');
      var float = '[+-]?(?:' + unsignedDecimalLiteral + ')';
      return new RegExp('^(' + float + ')(.*)$');
    }();
    var isUnit = function (unit, accepted) {
      return exists(accepted, function (acc) {
        return exists(units[acc], function (check) {
          return unit === check;
        });
      });
    };
    var parse = function (input, accepted) {
      var match = Optional.from(pattern.exec(input));
      return match.bind(function (array) {
        var value = Number(array[1]);
        var unitRaw = array[2];
        if (isUnit(unitRaw, accepted)) {
          return Optional.some({
            value: value,
            unit: unitRaw
          });
        } else {
          return Optional.none();
        }
      });
    };
    var normalise = function (input, accepted) {
      return parse(input, accepted).map(function (_a) {
        var value = _a.value, unit = _a.unit;
        return value + unit;
      });
    };

    var registerController = function (editor, spec) {
      var getMenuItems = function () {
        var options = spec.getOptions(editor);
        var initial = spec.getCurrent(editor).map(spec.hash);
        var current = value$1();
        return map$2(options, function (value) {
          return {
            type: 'togglemenuitem',
            text: spec.display(value),
            onSetup: function (api) {
              var setActive = function (active) {
                if (active) {
                  current.on(function (oldApi) {
                    return oldApi.setActive(false);
                  });
                  current.set(api);
                }
                api.setActive(active);
              };
              setActive(is$1(initial, spec.hash(value)));
              var unbindWatcher = spec.watcher(editor, value, setActive);
              return function () {
                current.clear();
                unbindWatcher();
              };
            },
            onAction: function () {
              return spec.setCurrent(editor, value);
            }
          };
        });
      };
      editor.ui.registry.addMenuButton(spec.name, {
        tooltip: spec.text,
        icon: spec.icon,
        fetch: function (callback) {
          return callback(getMenuItems());
        },
        onSetup: spec.onToolbarSetup
      });
      editor.ui.registry.addNestedMenuItem(spec.name, {
        type: 'nestedmenuitem',
        text: spec.text,
        getSubmenuItems: getMenuItems,
        onSetup: spec.onMenuSetup
      });
    };
    var lineHeightSpec = {
      name: 'lineheight',
      text: 'Line height',
      icon: 'line-height',
      getOptions: getLineHeightFormats,
      hash: function (input) {
        return normalise(input, [
          'fixed',
          'relative',
          'empty'
        ]).getOr(input);
      },
      display: identity$1,
      watcher: function (editor, value, callback) {
        return editor.formatter.formatChanged('lineheight', callback, false, { value: value }).unbind;
      },
      getCurrent: function (editor) {
        return Optional.from(editor.queryCommandValue('LineHeight'));
      },
      setCurrent: function (editor, value) {
        return editor.execCommand('LineHeight', false, value);
      }
    };
    var languageSpec = function (editor) {
      var settingsOpt = Optional.from(getContentLanguages(editor));
      return settingsOpt.map(function (settings) {
        return {
          name: 'language',
          text: 'Language',
          icon: 'language',
          getOptions: constant$1(settings),
          hash: function (input) {
            return isUndefined(input.customCode) ? input.code : input.code + '/' + input.customCode;
          },
          display: function (input) {
            return input.title;
          },
          watcher: function (editor, value, callback) {
            return editor.formatter.formatChanged('lang', callback, false, {
              value: value.code,
              customValue: value.customCode
            }).unbind;
          },
          getCurrent: function (editor) {
            var node = SugarElement.fromDom(editor.selection.getNode());
            return closest$4(node, function (n) {
              return Optional.some(n).filter(isElement$2).bind(function (ele) {
                var codeOpt = getOpt(ele, 'lang');
                return codeOpt.map(function (code) {
                  var customCode = getOpt(ele, 'data-mce-lang').getOrUndefined();
                  return {
                    code: code,
                    customCode: customCode,
                    title: ''
                  };
                });
              });
            });
          },
          setCurrent: function (editor, lang) {
            return editor.execCommand('Lang', false, lang);
          },
          onToolbarSetup: function (api) {
            var unbinder = unbindable();
            api.setActive(editor.formatter.match('lang', {}, undefined, true));
            unbinder.set(editor.formatter.formatChanged('lang', api.setActive, true));
            return unbinder.clear;
          }
        };
      });
    };
    var register$5 = function (editor) {
      registerController(editor, lineHeightSpec);
      languageSpec(editor).each(function (spec) {
        return registerController(editor, spec);
      });
    };

    var register$4 = function (editor, backstage) {
      alignSelectMenu(editor, backstage);
      fontSelectMenu(editor, backstage);
      styleSelectMenu(editor, backstage);
      formatSelectMenu(editor, backstage);
      fontsizeSelectMenu(editor, backstage);
    };

    var onSetupOutdentState = function (editor) {
      return onSetupEvent(editor, 'NodeChange', function (api) {
        api.setDisabled(!editor.queryCommandState('outdent'));
      });
    };
    var registerButtons$2 = function (editor) {
      editor.ui.registry.addButton('outdent', {
        tooltip: 'Decrease indent',
        icon: 'outdent',
        onSetup: onSetupOutdentState(editor),
        onAction: onActionExecCommand(editor, 'outdent')
      });
      editor.ui.registry.addButton('indent', {
        tooltip: 'Increase indent',
        icon: 'indent',
        onAction: onActionExecCommand(editor, 'indent')
      });
    };
    var register$3 = function (editor) {
      registerButtons$2(editor);
    };

    var onActionToggleFormat = function (editor, fmt) {
      return function () {
        editor.execCommand('mceToggleFormat', false, fmt);
      };
    };
    var registerFormatButtons = function (editor) {
      global$5.each([
        {
          name: 'bold',
          text: 'Bold',
          icon: 'bold'
        },
        {
          name: 'italic',
          text: 'Italic',
          icon: 'italic'
        },
        {
          name: 'underline',
          text: 'Underline',
          icon: 'underline'
        },
        {
          name: 'strikethrough',
          text: 'Strikethrough',
          icon: 'strike-through'
        },
        {
          name: 'subscript',
          text: 'Subscript',
          icon: 'subscript'
        },
        {
          name: 'superscript',
          text: 'Superscript',
          icon: 'superscript'
        }
      ], function (btn, _idx) {
        editor.ui.registry.addToggleButton(btn.name, {
          tooltip: btn.text,
          icon: btn.icon,
          onSetup: onSetupFormatToggle(editor, btn.name),
          onAction: onActionToggleFormat(editor, btn.name)
        });
      });
      for (var i = 1; i <= 6; i++) {
        var name_1 = 'h' + i;
        editor.ui.registry.addToggleButton(name_1, {
          text: name_1.toUpperCase(),
          tooltip: 'Heading ' + i,
          onSetup: onSetupFormatToggle(editor, name_1),
          onAction: onActionToggleFormat(editor, name_1)
        });
      }
    };
    var registerCommandButtons = function (editor) {
      global$5.each([
        {
          name: 'cut',
          text: 'Cut',
          action: 'Cut',
          icon: 'cut'
        },
        {
          name: 'copy',
          text: 'Copy',
          action: 'Copy',
          icon: 'copy'
        },
        {
          name: 'paste',
          text: 'Paste',
          action: 'Paste',
          icon: 'paste'
        },
        {
          name: 'help',
          text: 'Help',
          action: 'mceHelp',
          icon: 'help'
        },
        {
          name: 'selectall',
          text: 'Select all',
          action: 'SelectAll',
          icon: 'select-all'
        },
        {
          name: 'newdocument',
          text: 'New document',
          action: 'mceNewDocument',
          icon: 'new-document'
        },
        {
          name: 'removeformat',
          text: 'Clear formatting',
          action: 'RemoveFormat',
          icon: 'remove-formatting'
        },
        {
          name: 'remove',
          text: 'Remove',
          action: 'Delete',
          icon: 'remove'
        }
      ], function (btn) {
        editor.ui.registry.addButton(btn.name, {
          tooltip: btn.text,
          icon: btn.icon,
          onAction: onActionExecCommand(editor, btn.action)
        });
      });
    };
    var registerCommandToggleButtons = function (editor) {
      global$5.each([{
          name: 'blockquote',
          text: 'Blockquote',
          action: 'mceBlockQuote',
          icon: 'quote'
        }], function (btn) {
        editor.ui.registry.addToggleButton(btn.name, {
          tooltip: btn.text,
          icon: btn.icon,
          onAction: onActionExecCommand(editor, btn.action),
          onSetup: onSetupFormatToggle(editor, btn.name)
        });
      });
    };
    var registerButtons$1 = function (editor) {
      registerFormatButtons(editor);
      registerCommandButtons(editor);
      registerCommandToggleButtons(editor);
    };
    var registerMenuItems$2 = function (editor) {
      global$5.each([
        {
          name: 'bold',
          text: 'Bold',
          action: 'Bold',
          icon: 'bold',
          shortcut: 'Meta+B'
        },
        {
          name: 'italic',
          text: 'Italic',
          action: 'Italic',
          icon: 'italic',
          shortcut: 'Meta+I'
        },
        {
          name: 'underline',
          text: 'Underline',
          action: 'Underline',
          icon: 'underline',
          shortcut: 'Meta+U'
        },
        {
          name: 'strikethrough',
          text: 'Strikethrough',
          action: 'Strikethrough',
          icon: 'strike-through',
          shortcut: ''
        },
        {
          name: 'subscript',
          text: 'Subscript',
          action: 'Subscript',
          icon: 'subscript',
          shortcut: ''
        },
        {
          name: 'superscript',
          text: 'Superscript',
          action: 'Superscript',
          icon: 'superscript',
          shortcut: ''
        },
        {
          name: 'removeformat',
          text: 'Clear formatting',
          action: 'RemoveFormat',
          icon: 'remove-formatting',
          shortcut: ''
        },
        {
          name: 'newdocument',
          text: 'New document',
          action: 'mceNewDocument',
          icon: 'new-document',
          shortcut: ''
        },
        {
          name: 'cut',
          text: 'Cut',
          action: 'Cut',
          icon: 'cut',
          shortcut: 'Meta+X'
        },
        {
          name: 'copy',
          text: 'Copy',
          action: 'Copy',
          icon: 'copy',
          shortcut: 'Meta+C'
        },
        {
          name: 'paste',
          text: 'Paste',
          action: 'Paste',
          icon: 'paste',
          shortcut: 'Meta+V'
        },
        {
          name: 'selectall',
          text: 'Select all',
          action: 'SelectAll',
          icon: 'select-all',
          shortcut: 'Meta+A'
        }
      ], function (btn) {
        editor.ui.registry.addMenuItem(btn.name, {
          text: btn.text,
          icon: btn.icon,
          shortcut: btn.shortcut,
          onAction: onActionExecCommand(editor, btn.action)
        });
      });
      editor.ui.registry.addMenuItem('codeformat', {
        text: 'Code',
        icon: 'sourcecode',
        onAction: onActionToggleFormat(editor, 'code')
      });
    };
    var register$2 = function (editor) {
      registerButtons$1(editor);
      registerMenuItems$2(editor);
    };

    var onSetupUndoRedoState = function (editor, type) {
      return onSetupEvent(editor, 'Undo Redo AddUndo TypingUndo ClearUndos SwitchMode', function (api) {
        api.setDisabled(editor.mode.isReadOnly() || !editor.undoManager[type]());
      });
    };
    var registerMenuItems$1 = function (editor) {
      editor.ui.registry.addMenuItem('undo', {
        text: 'Undo',
        icon: 'undo',
        shortcut: 'Meta+Z',
        onSetup: onSetupUndoRedoState(editor, 'hasUndo'),
        onAction: onActionExecCommand(editor, 'undo')
      });
      editor.ui.registry.addMenuItem('redo', {
        text: 'Redo',
        icon: 'redo',
        shortcut: 'Meta+Y',
        onSetup: onSetupUndoRedoState(editor, 'hasRedo'),
        onAction: onActionExecCommand(editor, 'redo')
      });
    };
    var registerButtons = function (editor) {
      editor.ui.registry.addButton('undo', {
        tooltip: 'Undo',
        icon: 'undo',
        disabled: true,
        onSetup: onSetupUndoRedoState(editor, 'hasUndo'),
        onAction: onActionExecCommand(editor, 'undo')
      });
      editor.ui.registry.addButton('redo', {
        tooltip: 'Redo',
        icon: 'redo',
        disabled: true,
        onSetup: onSetupUndoRedoState(editor, 'hasRedo'),
        onAction: onActionExecCommand(editor, 'redo')
      });
    };
    var register$1 = function (editor) {
      registerMenuItems$1(editor);
      registerButtons(editor);
    };

    var onSetupVisualAidState = function (editor) {
      return onSetupEvent(editor, 'VisualAid', function (api) {
        api.setActive(editor.hasVisual);
      });
    };
    var registerMenuItems = function (editor) {
      editor.ui.registry.addToggleMenuItem('visualaid', {
        text: 'Visual aids',
        onSetup: onSetupVisualAidState(editor),
        onAction: onActionExecCommand(editor, 'mceToggleVisualAid')
      });
    };
    var registerToolbarButton = function (editor) {
      editor.ui.registry.addButton('visualaid', {
        tooltip: 'Visual aids',
        text: 'Visual aids',
        onAction: onActionExecCommand(editor, 'mceToggleVisualAid')
      });
    };
    var register = function (editor) {
      registerToolbarButton(editor);
      registerMenuItems(editor);
    };

    var setup$6 = function (editor, backstage) {
      register$6(editor);
      register$2(editor);
      register$4(editor, backstage);
      register$1(editor);
      register$a(editor);
      register(editor);
      register$3(editor);
      register$5(editor);
    };

    var nu = function (x, y) {
      return {
        type: 'makeshift',
        x: x,
        y: y
      };
    };
    var transpose = function (pos, dx, dy) {
      return nu(pos.x + dx, pos.y + dy);
    };
    var isTouchEvent = function (e) {
      return e.type === 'longpress' || e.type.indexOf('touch') === 0;
    };
    var fromPageXY = function (e) {
      if (isTouchEvent(e)) {
        var touch = e.touches[0];
        return nu(touch.pageX, touch.pageY);
      } else {
        return nu(e.pageX, e.pageY);
      }
    };
    var fromClientXY = function (e) {
      if (isTouchEvent(e)) {
        var touch = e.touches[0];
        return nu(touch.clientX, touch.clientY);
      } else {
        return nu(e.clientX, e.clientY);
      }
    };
    var transposeContentAreaContainer = function (element, pos) {
      var containerPos = global$b.DOM.getPos(element);
      return transpose(pos, containerPos.x, containerPos.y);
    };
    var getPointAnchor = function (editor, e) {
      if (e.type === 'contextmenu' || e.type === 'longpress') {
        if (editor.inline) {
          return fromPageXY(e);
        } else {
          return transposeContentAreaContainer(editor.getContentAreaContainer(), fromClientXY(e));
        }
      } else {
        return getSelectionAnchor(editor);
      }
    };
    var getSelectionAnchor = function (editor) {
      return {
        type: 'selection',
        root: SugarElement.fromDom(editor.selection.getNode())
      };
    };
    var getNodeAnchor = function (editor) {
      return {
        type: 'node',
        node: Optional.some(SugarElement.fromDom(editor.selection.getNode())),
        root: SugarElement.fromDom(editor.getBody())
      };
    };
    var getAnchorSpec$1 = function (editor, e, anchorType) {
      switch (anchorType) {
      case 'node':
        return getNodeAnchor(editor);
      case 'point':
        return getPointAnchor(editor, e);
      case 'selection':
        return getSelectionAnchor(editor);
      }
    };

    var initAndShow$1 = function (editor, e, buildMenu, backstage, contextmenu, anchorType) {
      var items = buildMenu();
      var anchorSpec = getAnchorSpec$1(editor, e, anchorType);
      build(items, ItemResponse$1.CLOSE_ON_EXECUTE, backstage, false).map(function (menuData) {
        e.preventDefault();
        InlineView.showMenuAt(contextmenu, { anchor: anchorSpec }, {
          menu: { markers: markers('normal') },
          data: menuData
        });
      });
    };

    var layouts = {
      onLtr: function () {
        return [
          south$2,
          southeast$2,
          southwest$2,
          northeast$2,
          northwest$2,
          north$2,
          north,
          south,
          northeast,
          southeast,
          northwest,
          southwest
        ];
      },
      onRtl: function () {
        return [
          south$2,
          southwest$2,
          southeast$2,
          northwest$2,
          northeast$2,
          north$2,
          north,
          south,
          northwest,
          southwest,
          northeast,
          southeast
        ];
      }
    };
    var bubbleSize = 12;
    var bubbleAlignments = {
      valignCentre: [],
      alignCentre: [],
      alignLeft: ['tox-pop--align-left'],
      alignRight: ['tox-pop--align-right'],
      right: ['tox-pop--right'],
      left: ['tox-pop--left'],
      bottom: ['tox-pop--bottom'],
      top: ['tox-pop--top']
    };
    var isTouchWithinSelection = function (editor, e) {
      var selection = editor.selection;
      if (selection.isCollapsed() || e.touches.length < 1) {
        return false;
      } else {
        var touch_1 = e.touches[0];
        var rng = selection.getRng();
        var rngRectOpt = getFirstRect(editor.getWin(), SimSelection.domRange(rng));
        return rngRectOpt.exists(function (rngRect) {
          return rngRect.left <= touch_1.clientX && rngRect.right >= touch_1.clientX && rngRect.top <= touch_1.clientY && rngRect.bottom >= touch_1.clientY;
        });
      }
    };
    var setupiOSOverrides = function (editor) {
      var originalSelection = editor.selection.getRng();
      var selectionReset = function () {
        global$f.setEditorTimeout(editor, function () {
          editor.selection.setRng(originalSelection);
        }, 10);
        unbindEventListeners();
      };
      editor.once('touchend', selectionReset);
      var preventMousedown = function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
      };
      editor.on('mousedown', preventMousedown, true);
      var clearSelectionReset = function () {
        return unbindEventListeners();
      };
      editor.once('longpresscancel', clearSelectionReset);
      var unbindEventListeners = function () {
        editor.off('touchend', selectionReset);
        editor.off('longpresscancel', clearSelectionReset);
        editor.off('mousedown', preventMousedown);
      };
    };
    var getAnchorSpec = function (editor, e, anchorType) {
      var anchorSpec = getAnchorSpec$1(editor, e, anchorType);
      var bubbleYOffset = anchorType === 'point' ? bubbleSize : 0;
      return __assign({
        bubble: nu$5(0, bubbleYOffset, bubbleAlignments),
        layouts: layouts,
        overrides: {
          maxWidthFunction: expandable(),
          maxHeightFunction: expandable$1()
        }
      }, anchorSpec);
    };
    var show = function (editor, e, items, backstage, contextmenu, anchorType, highlightImmediately) {
      var anchorSpec = getAnchorSpec(editor, e, anchorType);
      build(items, ItemResponse$1.CLOSE_ON_EXECUTE, backstage, true).map(function (menuData) {
        e.preventDefault();
        InlineView.showMenuWithinBounds(contextmenu, { anchor: anchorSpec }, {
          menu: {
            markers: markers('normal'),
            highlightImmediately: highlightImmediately
          },
          data: menuData,
          type: 'horizontal'
        }, function () {
          return Optional.some(getContextToolbarBounds(editor, backstage.shared, anchorType === 'node' ? 'node' : 'selection'));
        });
        editor.fire(hideContextToolbarEvent);
      });
    };
    var initAndShow = function (editor, e, buildMenu, backstage, contextmenu, anchorType) {
      var detection = detect$1();
      var isiOS = detection.os.isiOS();
      var isOSX = detection.os.isOSX();
      var isAndroid = detection.os.isAndroid();
      var isTouch = detection.deviceType.isTouch();
      var shouldHighlightImmediately = function () {
        return !(isAndroid || isiOS || isOSX && isTouch);
      };
      var open = function () {
        var items = buildMenu();
        show(editor, e, items, backstage, contextmenu, anchorType, shouldHighlightImmediately());
      };
      if ((isOSX || isiOS) && anchorType !== 'node') {
        var openiOS_1 = function () {
          setupiOSOverrides(editor);
          open();
        };
        if (isTouchWithinSelection(editor, e)) {
          openiOS_1();
        } else {
          editor.once('selectionchange', openiOS_1);
          editor.once('touchend', function () {
            return editor.off('selectionchange', openiOS_1);
          });
        }
      } else {
        open();
      }
    };

    var patchPipeConfig = function (config) {
      return typeof config === 'string' ? config.split(/[ ,]/) : config;
    };
    var shouldNeverUseNative = function (editor) {
      return editor.getParam('contextmenu_never_use_native', false, 'boolean');
    };
    var getMenuItems = function (editor, name, defaultItems) {
      var contextMenus = editor.ui.registry.getAll().contextMenus;
      return Optional.from(editor.getParam(name)).map(patchPipeConfig).getOrThunk(function () {
        return filter$2(patchPipeConfig(defaultItems), function (item) {
          return has$2(contextMenus, item);
        });
      });
    };
    var isContextMenuDisabled = function (editor) {
      return editor.getParam('contextmenu') === false;
    };
    var getContextMenu = function (editor) {
      return getMenuItems(editor, 'contextmenu', 'link linkchecker image imagetools table spellchecker configurepermanentpen');
    };
    var getAvoidOverlapSelector = function (editor) {
      return editor.getParam('contextmenu_avoid_overlap', '', 'string');
    };

    var isSeparator = function (item) {
      return isString(item) ? item === '|' : item.type === 'separator';
    };
    var separator = { type: 'separator' };
    var makeContextItem = function (item) {
      var commonMenuItem = function (item) {
        return {
          text: item.text,
          icon: item.icon,
          disabled: item.disabled,
          shortcut: item.shortcut
        };
      };
      if (isString(item)) {
        return item;
      } else {
        switch (item.type) {
        case 'separator':
          return separator;
        case 'submenu':
          return __assign(__assign({ type: 'nestedmenuitem' }, commonMenuItem(item)), {
            getSubmenuItems: function () {
              var items = item.getSubmenuItems();
              if (isString(items)) {
                return items;
              } else {
                return map$2(items, makeContextItem);
              }
            }
          });
        default:
          return __assign(__assign({ type: 'menuitem' }, commonMenuItem(item)), { onAction: noarg(item.onAction) });
        }
      }
    };
    var addContextMenuGroup = function (xs, groupItems) {
      if (groupItems.length === 0) {
        return xs;
      }
      var lastMenuItem = last$2(xs).filter(function (item) {
        return !isSeparator(item);
      });
      var before = lastMenuItem.fold(function () {
        return [];
      }, function (_) {
        return [separator];
      });
      return xs.concat(before).concat(groupItems).concat([separator]);
    };
    var generateContextMenu = function (contextMenus, menuConfig, selectedElement) {
      var sections = foldl(menuConfig, function (acc, name) {
        return get$e(contextMenus, name.toLowerCase()).map(function (menu) {
          var items = menu.update(selectedElement);
          if (isString(items)) {
            return addContextMenuGroup(acc, items.split(' '));
          } else if (items.length > 0) {
            var allItems = map$2(items, makeContextItem);
            return addContextMenuGroup(acc, allItems);
          } else {
            return acc;
          }
        }).getOrThunk(function () {
          return acc.concat([name]);
        });
      }, []);
      if (sections.length > 0 && isSeparator(sections[sections.length - 1])) {
        sections.pop();
      }
      return sections;
    };
    var isNativeOverrideKeyEvent = function (editor, e) {
      return e.ctrlKey && !shouldNeverUseNative(editor);
    };
    var isTriggeredByKeyboard = function (editor, e) {
      return e.type !== 'longpress' && (e.button !== 2 || e.target === editor.getBody() && e.pointerType === '');
    };
    var getSelectedElement = function (editor, e) {
      return isTriggeredByKeyboard(editor, e) ? editor.selection.getStart(true) : e.target;
    };
    var getAnchorType = function (editor, e) {
      var selector = getAvoidOverlapSelector(editor);
      var anchorType = isTriggeredByKeyboard(editor, e) ? 'selection' : 'point';
      if (isNotEmpty(selector)) {
        var target = getSelectedElement(editor, e);
        var selectorExists = closest(SugarElement.fromDom(target), selector);
        return selectorExists ? 'node' : anchorType;
      } else {
        return anchorType;
      }
    };
    var setup$5 = function (editor, lazySink, backstage) {
      var detection = detect$1();
      var isTouch = detection.deviceType.isTouch;
      var contextmenu = build$1(InlineView.sketch({
        dom: { tag: 'div' },
        lazySink: lazySink,
        onEscape: function () {
          return editor.focus();
        },
        onShow: function () {
          return backstage.setContextMenuState(true);
        },
        onHide: function () {
          return backstage.setContextMenuState(false);
        },
        fireDismissalEventInstead: {},
        inlineBehaviours: derive$1([config('dismissContextMenu', [run$1(dismissRequested(), function (comp, _se) {
              Sandboxing.close(comp);
              editor.focus();
            })])])
      }));
      var hideContextMenu = function (_e) {
        return InlineView.hide(contextmenu);
      };
      var showContextMenu = function (e) {
        if (shouldNeverUseNative(editor)) {
          e.preventDefault();
        }
        if (isNativeOverrideKeyEvent(editor, e) || isContextMenuDisabled(editor)) {
          return;
        }
        var anchorType = getAnchorType(editor, e);
        var buildMenu = function () {
          var selectedElement = getSelectedElement(editor, e);
          var registry = editor.ui.registry.getAll();
          var menuConfig = getContextMenu(editor);
          return generateContextMenu(registry.contextMenus, menuConfig, selectedElement);
        };
        var initAndShow$2 = isTouch() ? initAndShow : initAndShow$1;
        initAndShow$2(editor, e, buildMenu, backstage, contextmenu, anchorType);
      };
      editor.on('init', function () {
        var hideEvents = 'ResizeEditor ScrollContent ScrollWindow longpresscancel' + (isTouch() ? '' : ' ResizeWindow');
        editor.on(hideEvents, hideContextMenu);
        editor.on('longpress contextmenu', showContextMenu);
      });
    };

    var adt = Adt.generate([
      {
        offset: [
          'x',
          'y'
        ]
      },
      {
        absolute: [
          'x',
          'y'
        ]
      },
      {
        fixed: [
          'x',
          'y'
        ]
      }
    ]);
    var subtract = function (change) {
      return function (point) {
        return point.translate(-change.left, -change.top);
      };
    };
    var add = function (change) {
      return function (point) {
        return point.translate(change.left, change.top);
      };
    };
    var transform = function (changes) {
      return function (x, y) {
        return foldl(changes, function (rest, f) {
          return f(rest);
        }, SugarPosition(x, y));
      };
    };
    var asFixed = function (coord, scroll, origin) {
      return coord.fold(transform([
        add(origin),
        subtract(scroll)
      ]), transform([subtract(scroll)]), transform([]));
    };
    var asAbsolute = function (coord, scroll, origin) {
      return coord.fold(transform([add(origin)]), transform([]), transform([add(scroll)]));
    };
    var asOffset = function (coord, scroll, origin) {
      return coord.fold(transform([]), transform([subtract(origin)]), transform([
        add(scroll),
        subtract(origin)
      ]));
    };
    var withinRange = function (coord1, coord2, xRange, yRange, scroll, origin) {
      var a1 = asAbsolute(coord1, scroll, origin);
      var a2 = asAbsolute(coord2, scroll, origin);
      return Math.abs(a1.left - a2.left) <= xRange && Math.abs(a1.top - a2.top) <= yRange;
    };
    var getDeltas = function (coord1, coord2, xRange, yRange, scroll, origin) {
      var a1 = asAbsolute(coord1, scroll, origin);
      var a2 = asAbsolute(coord2, scroll, origin);
      var left = Math.abs(a1.left - a2.left);
      var top = Math.abs(a1.top - a2.top);
      return SugarPosition(left, top);
    };
    var toStyles = function (coord, scroll, origin) {
      var stylesOpt = coord.fold(function (x, y) {
        return {
          position: Optional.some('absolute'),
          left: Optional.some(x + 'px'),
          top: Optional.some(y + 'px')
        };
      }, function (x, y) {
        return {
          position: Optional.some('absolute'),
          left: Optional.some(x - origin.left + 'px'),
          top: Optional.some(y - origin.top + 'px')
        };
      }, function (x, y) {
        return {
          position: Optional.some('fixed'),
          left: Optional.some(x + 'px'),
          top: Optional.some(y + 'px')
        };
      });
      return __assign({
        right: Optional.none(),
        bottom: Optional.none()
      }, stylesOpt);
    };
    var translate = function (coord, deltaX, deltaY) {
      return coord.fold(function (x, y) {
        return offset(x + deltaX, y + deltaY);
      }, function (x, y) {
        return absolute(x + deltaX, y + deltaY);
      }, function (x, y) {
        return fixed(x + deltaX, y + deltaY);
      });
    };
    var absorb = function (partialCoord, originalCoord, scroll, origin) {
      var absorbOne = function (stencil, nu) {
        return function (optX, optY) {
          var original = stencil(originalCoord, scroll, origin);
          return nu(optX.getOr(original.left), optY.getOr(original.top));
        };
      };
      return partialCoord.fold(absorbOne(asOffset, offset), absorbOne(asAbsolute, absolute), absorbOne(asFixed, fixed));
    };
    var offset = adt.offset;
    var absolute = adt.absolute;
    var fixed = adt.fixed;

    var parseAttrToInt = function (element, name) {
      var value = get$d(element, name);
      return isUndefined(value) ? NaN : parseInt(value, 10);
    };
    var get = function (component, snapsInfo) {
      var element = component.element;
      var x = parseAttrToInt(element, snapsInfo.leftAttr);
      var y = parseAttrToInt(element, snapsInfo.topAttr);
      return isNaN(x) || isNaN(y) ? Optional.none() : Optional.some(SugarPosition(x, y));
    };
    var set = function (component, snapsInfo, pt) {
      var element = component.element;
      set$8(element, snapsInfo.leftAttr, pt.left + 'px');
      set$8(element, snapsInfo.topAttr, pt.top + 'px');
    };
    var clear = function (component, snapsInfo) {
      var element = component.element;
      remove$7(element, snapsInfo.leftAttr);
      remove$7(element, snapsInfo.topAttr);
    };

    var getCoords = function (component, snapInfo, coord, delta) {
      return get(component, snapInfo).fold(function () {
        return coord;
      }, function (fixed$1) {
        return fixed(fixed$1.left + delta.left, fixed$1.top + delta.top);
      });
    };
    var moveOrSnap = function (component, snapInfo, coord, delta, scroll, origin) {
      var newCoord = getCoords(component, snapInfo, coord, delta);
      var snap = snapInfo.mustSnap ? findClosestSnap(component, snapInfo, newCoord, scroll, origin) : findSnap(component, snapInfo, newCoord, scroll, origin);
      var fixedCoord = asFixed(newCoord, scroll, origin);
      set(component, snapInfo, fixedCoord);
      return snap.fold(function () {
        return {
          coord: fixed(fixedCoord.left, fixedCoord.top),
          extra: Optional.none()
        };
      }, function (spanned) {
        return {
          coord: spanned.output,
          extra: spanned.extra
        };
      });
    };
    var stopDrag = function (component, snapInfo) {
      clear(component, snapInfo);
    };
    var findMatchingSnap = function (snaps, newCoord, scroll, origin) {
      return findMap(snaps, function (snap) {
        var sensor = snap.sensor;
        var inRange = withinRange(newCoord, sensor, snap.range.left, snap.range.top, scroll, origin);
        return inRange ? Optional.some({
          output: absorb(snap.output, newCoord, scroll, origin),
          extra: snap.extra
        }) : Optional.none();
      });
    };
    var findClosestSnap = function (component, snapInfo, newCoord, scroll, origin) {
      var snaps = snapInfo.getSnapPoints(component);
      var matchSnap = findMatchingSnap(snaps, newCoord, scroll, origin);
      return matchSnap.orThunk(function () {
        var bestSnap = foldl(snaps, function (acc, snap) {
          var sensor = snap.sensor;
          var deltas = getDeltas(newCoord, sensor, snap.range.left, snap.range.top, scroll, origin);
          return acc.deltas.fold(function () {
            return {
              deltas: Optional.some(deltas),
              snap: Optional.some(snap)
            };
          }, function (bestDeltas) {
            var currAvg = (deltas.left + deltas.top) / 2;
            var bestAvg = (bestDeltas.left + bestDeltas.top) / 2;
            if (currAvg <= bestAvg) {
              return {
                deltas: Optional.some(deltas),
                snap: Optional.some(snap)
              };
            } else {
              return acc;
            }
          });
        }, {
          deltas: Optional.none(),
          snap: Optional.none()
        });
        return bestSnap.snap.map(function (snap) {
          return {
            output: absorb(snap.output, newCoord, scroll, origin),
            extra: snap.extra
          };
        });
      });
    };
    var findSnap = function (component, snapInfo, newCoord, scroll, origin) {
      var snaps = snapInfo.getSnapPoints(component);
      return findMatchingSnap(snaps, newCoord, scroll, origin);
    };
    var snapTo$1 = function (snap, scroll, origin) {
      return {
        coord: absorb(snap.output, snap.output, scroll, origin),
        extra: snap.extra
      };
    };

    var snapTo = function (component, dragConfig, _state, snap) {
      var target = dragConfig.getTarget(component.element);
      if (dragConfig.repositionTarget) {
        var doc = owner$4(component.element);
        var scroll_1 = get$9(doc);
        var origin_1 = getOrigin(target);
        var snapPin = snapTo$1(snap, scroll_1, origin_1);
        var styles = toStyles(snapPin.coord, scroll_1, origin_1);
        setOptions(target, styles);
      }
    };

    var DraggingApis = /*#__PURE__*/Object.freeze({
        __proto__: null,
        snapTo: snapTo
    });

    var initialAttribute = 'data-initial-z-index';
    var resetZIndex = function (blocker) {
      parent(blocker.element).filter(isElement$2).each(function (root) {
        getOpt(root, initialAttribute).fold(function () {
          return remove$6(root, 'z-index');
        }, function (zIndex) {
          return set$7(root, 'z-index', zIndex);
        });
        remove$7(root, initialAttribute);
      });
    };
    var changeZIndex = function (blocker) {
      parent(blocker.element).filter(isElement$2).each(function (root) {
        getRaw(root, 'z-index').each(function (zindex) {
          set$8(root, initialAttribute, zindex);
        });
        set$7(root, 'z-index', get$c(blocker.element, 'z-index'));
      });
    };
    var instigate = function (anyComponent, blocker) {
      anyComponent.getSystem().addToGui(blocker);
      changeZIndex(blocker);
    };
    var discard = function (blocker) {
      resetZIndex(blocker);
      blocker.getSystem().removeFromGui(blocker);
    };
    var createComponent = function (component, blockerClass, blockerEvents) {
      return component.getSystem().build(Container.sketch({
        dom: {
          styles: {
            'left': '0px',
            'top': '0px',
            'width': '100%',
            'height': '100%',
            'position': 'fixed',
            'z-index': '1000000000000000'
          },
          classes: [blockerClass]
        },
        events: blockerEvents
      }));
    };

    var SnapSchema = optionObjOf('snaps', [
      required$1('getSnapPoints'),
      onHandler('onSensor'),
      required$1('leftAttr'),
      required$1('topAttr'),
      defaulted('lazyViewport', win),
      defaulted('mustSnap', false)
    ]);

    var schema$6 = [
      defaulted('useFixed', never),
      required$1('blockerClass'),
      defaulted('getTarget', identity$1),
      defaulted('onDrag', noop),
      defaulted('repositionTarget', true),
      defaulted('onDrop', noop),
      defaultedFunction('getBounds', win),
      SnapSchema
    ];

    var getCurrentCoord = function (target) {
      return lift3(getRaw(target, 'left'), getRaw(target, 'top'), getRaw(target, 'position'), function (left, top, position) {
        var nu = position === 'fixed' ? fixed : offset;
        return nu(parseInt(left, 10), parseInt(top, 10));
      }).getOrThunk(function () {
        var location = absolute$3(target);
        return absolute(location.left, location.top);
      });
    };
    var clampCoords = function (component, coords, scroll, origin, startData) {
      var bounds = startData.bounds;
      var absoluteCoord = asAbsolute(coords, scroll, origin);
      var newX = clamp$1(absoluteCoord.left, bounds.x, bounds.x + bounds.width - startData.width);
      var newY = clamp$1(absoluteCoord.top, bounds.y, bounds.y + bounds.height - startData.height);
      var newCoords = absolute(newX, newY);
      return coords.fold(function () {
        var offset$1 = asOffset(newCoords, scroll, origin);
        return offset(offset$1.left, offset$1.top);
      }, constant$1(newCoords), function () {
        var fixed$1 = asFixed(newCoords, scroll, origin);
        return fixed(fixed$1.left, fixed$1.top);
      });
    };
    var calcNewCoord = function (component, optSnaps, currentCoord, scroll, origin, delta, startData) {
      var newCoord = optSnaps.fold(function () {
        var translated = translate(currentCoord, delta.left, delta.top);
        var fixedCoord = asFixed(translated, scroll, origin);
        return fixed(fixedCoord.left, fixedCoord.top);
      }, function (snapInfo) {
        var snapping = moveOrSnap(component, snapInfo, currentCoord, delta, scroll, origin);
        snapping.extra.each(function (extra) {
          snapInfo.onSensor(component, extra);
        });
        return snapping.coord;
      });
      return clampCoords(component, newCoord, scroll, origin, startData);
    };
    var dragBy = function (component, dragConfig, startData, delta) {
      var target = dragConfig.getTarget(component.element);
      if (dragConfig.repositionTarget) {
        var doc = owner$4(component.element);
        var scroll_1 = get$9(doc);
        var origin_1 = getOrigin(target);
        var currentCoord = getCurrentCoord(target);
        var newCoord = calcNewCoord(component, dragConfig.snaps, currentCoord, scroll_1, origin_1, delta, startData);
        var styles = toStyles(newCoord, scroll_1, origin_1);
        setOptions(target, styles);
      }
      dragConfig.onDrag(component, target, delta);
    };

    var calcStartData = function (dragConfig, comp) {
      return {
        bounds: dragConfig.getBounds(),
        height: getOuter$2(comp.element),
        width: getOuter$1(comp.element)
      };
    };
    var move = function (component, dragConfig, dragState, dragMode, event) {
      var delta = dragState.update(dragMode, event);
      var dragStartData = dragState.getStartData().getOrThunk(function () {
        return calcStartData(dragConfig, component);
      });
      delta.each(function (dlt) {
        dragBy(component, dragConfig, dragStartData, dlt);
      });
    };
    var stop = function (component, blocker, dragConfig, dragState) {
      blocker.each(discard);
      dragConfig.snaps.each(function (snapInfo) {
        stopDrag(component, snapInfo);
      });
      var target = dragConfig.getTarget(component.element);
      dragState.reset();
      dragConfig.onDrop(component, target);
    };
    var handlers = function (events) {
      return function (dragConfig, dragState) {
        var updateStartState = function (comp) {
          dragState.setStartData(calcStartData(dragConfig, comp));
        };
        return derive$2(__spreadArray([run$1(windowScroll(), function (comp) {
            dragState.getStartData().each(function () {
              return updateStartState(comp);
            });
          })], events(dragConfig, dragState, updateStartState), true));
      };
    };

    var init$2 = function (dragApi) {
      return derive$2([
        run$1(mousedown(), dragApi.forceDrop),
        run$1(mouseup(), dragApi.drop),
        run$1(mousemove(), function (comp, simulatedEvent) {
          dragApi.move(simulatedEvent.event);
        }),
        run$1(mouseout(), dragApi.delayDrop)
      ]);
    };

    var getData$1 = function (event) {
      return Optional.from(SugarPosition(event.x, event.y));
    };
    var getDelta$1 = function (old, nu) {
      return SugarPosition(nu.left - old.left, nu.top - old.top);
    };

    var MouseData = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getData: getData$1,
        getDelta: getDelta$1
    });

    var events$2 = function (dragConfig, dragState, updateStartState) {
      return [run$1(mousedown(), function (component, simulatedEvent) {
          var raw = simulatedEvent.event.raw;
          if (raw.button !== 0) {
            return;
          }
          simulatedEvent.stop();
          var stop$1 = function () {
            return stop(component, Optional.some(blocker), dragConfig, dragState);
          };
          var delayDrop = DelayedFunction(stop$1, 200);
          var dragApi = {
            drop: stop$1,
            delayDrop: delayDrop.schedule,
            forceDrop: stop$1,
            move: function (event) {
              delayDrop.cancel();
              move(component, dragConfig, dragState, MouseData, event);
            }
          };
          var blocker = createComponent(component, dragConfig.blockerClass, init$2(dragApi));
          var start = function () {
            updateStartState(component);
            instigate(component, blocker);
          };
          start();
        })];
    };
    var schema$5 = __spreadArray(__spreadArray([], schema$6, true), [output$1('dragger', { handlers: handlers(events$2) })], false);

    var init$1 = function (dragApi) {
      return derive$2([
        run$1(touchstart(), dragApi.forceDrop),
        run$1(touchend(), dragApi.drop),
        run$1(touchcancel(), dragApi.drop),
        run$1(touchmove(), function (comp, simulatedEvent) {
          dragApi.move(simulatedEvent.event);
        })
      ]);
    };

    var getDataFrom = function (touches) {
      var touch = touches[0];
      return Optional.some(SugarPosition(touch.clientX, touch.clientY));
    };
    var getData = function (event) {
      var raw = event.raw;
      var touches = raw.touches;
      return touches.length === 1 ? getDataFrom(touches) : Optional.none();
    };
    var getDelta = function (old, nu) {
      return SugarPosition(nu.left - old.left, nu.top - old.top);
    };

    var TouchData = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getData: getData,
        getDelta: getDelta
    });

    var events$1 = function (dragConfig, dragState, updateStartState) {
      var blockerSingleton = value$1();
      var stopBlocking = function (component) {
        stop(component, blockerSingleton.get(), dragConfig, dragState);
        blockerSingleton.clear();
      };
      return [
        run$1(touchstart(), function (component, simulatedEvent) {
          simulatedEvent.stop();
          var stop = function () {
            return stopBlocking(component);
          };
          var dragApi = {
            drop: stop,
            delayDrop: noop,
            forceDrop: stop,
            move: function (event) {
              move(component, dragConfig, dragState, TouchData, event);
            }
          };
          var blocker = createComponent(component, dragConfig.blockerClass, init$1(dragApi));
          blockerSingleton.set(blocker);
          var start = function () {
            updateStartState(component);
            instigate(component, blocker);
          };
          start();
        }),
        run$1(touchmove(), function (component, simulatedEvent) {
          simulatedEvent.stop();
          move(component, dragConfig, dragState, TouchData, simulatedEvent.event);
        }),
        run$1(touchend(), function (component, simulatedEvent) {
          simulatedEvent.stop();
          stopBlocking(component);
        }),
        run$1(touchcancel(), stopBlocking)
      ];
    };
    var schema$4 = __spreadArray(__spreadArray([], schema$6, true), [output$1('dragger', { handlers: handlers(events$1) })], false);

    var events = function (dragConfig, dragState, updateStartState) {
      return __spreadArray(__spreadArray([], events$2(dragConfig, dragState, updateStartState), true), events$1(dragConfig, dragState, updateStartState), true);
    };
    var schema$3 = __spreadArray(__spreadArray([], schema$6, true), [output$1('dragger', { handlers: handlers(events) })], false);

    var mouse = schema$5;
    var touch = schema$4;
    var mouseOrTouch = schema$3;

    var DraggingBranches = /*#__PURE__*/Object.freeze({
        __proto__: null,
        mouse: mouse,
        touch: touch,
        mouseOrTouch: mouseOrTouch
    });

    var init = function () {
      var previous = Optional.none();
      var startData = Optional.none();
      var reset = function () {
        previous = Optional.none();
        startData = Optional.none();
      };
      var calculateDelta = function (mode, nu) {
        var result = previous.map(function (old) {
          return mode.getDelta(old, nu);
        });
        previous = Optional.some(nu);
        return result;
      };
      var update = function (mode, dragEvent) {
        return mode.getData(dragEvent).bind(function (nuData) {
          return calculateDelta(mode, nuData);
        });
      };
      var setStartData = function (data) {
        startData = Optional.some(data);
      };
      var getStartData = function () {
        return startData;
      };
      var readState = constant$1({});
      return nu$8({
        readState: readState,
        reset: reset,
        update: update,
        getStartData: getStartData,
        setStartData: setStartData
      });
    };

    var DragState = /*#__PURE__*/Object.freeze({
        __proto__: null,
        init: init
    });

    var Dragging = createModes({
      branchKey: 'mode',
      branches: DraggingBranches,
      name: 'dragging',
      active: {
        events: function (dragConfig, dragState) {
          var dragger = dragConfig.dragger;
          return dragger.handlers(dragConfig, dragState);
        }
      },
      extra: {
        snap: function (sConfig) {
          return {
            sensor: sConfig.sensor,
            range: sConfig.range,
            output: sConfig.output,
            extra: Optional.from(sConfig.extra)
          };
        }
      },
      state: DragState,
      apis: DraggingApis
    });

    var snapWidth = 40;
    var snapOffset = snapWidth / 2;
    var calcSnap = function (selectorOpt, td, x, y, width, height) {
      return selectorOpt.fold(function () {
        return Dragging.snap({
          sensor: absolute(x - snapOffset, y - snapOffset),
          range: SugarPosition(width, height),
          output: absolute(Optional.some(x), Optional.some(y)),
          extra: { td: td }
        });
      }, function (selectorHandle) {
        var sensorLeft = x - snapOffset;
        var sensorTop = y - snapOffset;
        var sensorWidth = snapWidth;
        var sensorHeight = snapWidth;
        var rect = selectorHandle.element.dom.getBoundingClientRect();
        return Dragging.snap({
          sensor: absolute(sensorLeft, sensorTop),
          range: SugarPosition(sensorWidth, sensorHeight),
          output: absolute(Optional.some(x - rect.width / 2), Optional.some(y - rect.height / 2)),
          extra: { td: td }
        });
      });
    };
    var getSnapsConfig = function (getSnapPoints, cell, onChange) {
      var isSameCell = function (cellOpt, td) {
        return cellOpt.exists(function (currentTd) {
          return eq(currentTd, td);
        });
      };
      return {
        getSnapPoints: getSnapPoints,
        leftAttr: 'data-drag-left',
        topAttr: 'data-drag-top',
        onSensor: function (component, extra) {
          var td = extra.td;
          if (!isSameCell(cell.get(), td)) {
            cell.set(td);
            onChange(td);
          }
        },
        mustSnap: true
      };
    };
    var createSelector = function (snaps) {
      return record(Button.sketch({
        dom: {
          tag: 'div',
          classes: ['tox-selector']
        },
        buttonBehaviours: derive$1([
          Dragging.config({
            mode: 'mouseOrTouch',
            blockerClass: 'blocker',
            snaps: snaps
          }),
          Unselecting.config({})
        ]),
        eventOrder: {
          mousedown: [
            'dragging',
            'alloy.base.behaviour'
          ],
          touchstart: [
            'dragging',
            'alloy.base.behaviour'
          ]
        }
      }));
    };
    var setup$4 = function (editor, sink) {
      var tlTds = Cell([]);
      var brTds = Cell([]);
      var isVisible = Cell(false);
      var startCell = value$1();
      var finishCell = value$1();
      var getTopLeftSnap = function (td) {
        var box = absolute$2(td);
        return calcSnap(memTopLeft.getOpt(sink), td, box.x, box.y, box.width, box.height);
      };
      var getTopLeftSnaps = function () {
        return map$2(tlTds.get(), function (td) {
          return getTopLeftSnap(td);
        });
      };
      var getBottomRightSnap = function (td) {
        var box = absolute$2(td);
        return calcSnap(memBottomRight.getOpt(sink), td, box.right, box.bottom, box.width, box.height);
      };
      var getBottomRightSnaps = function () {
        return map$2(brTds.get(), function (td) {
          return getBottomRightSnap(td);
        });
      };
      var topLeftSnaps = getSnapsConfig(getTopLeftSnaps, startCell, function (start) {
        finishCell.get().each(function (finish) {
          editor.fire('TableSelectorChange', {
            start: start,
            finish: finish
          });
        });
      });
      var bottomRightSnaps = getSnapsConfig(getBottomRightSnaps, finishCell, function (finish) {
        startCell.get().each(function (start) {
          editor.fire('TableSelectorChange', {
            start: start,
            finish: finish
          });
        });
      });
      var memTopLeft = createSelector(topLeftSnaps);
      var memBottomRight = createSelector(bottomRightSnaps);
      var topLeft = build$1(memTopLeft.asSpec());
      var bottomRight = build$1(memBottomRight.asSpec());
      var showOrHideHandle = function (selector, cell, isAbove, isBelow) {
        var cellRect = cell.dom.getBoundingClientRect();
        remove$6(selector.element, 'display');
        var viewportHeight = defaultView(SugarElement.fromDom(editor.getBody())).dom.innerHeight;
        var aboveViewport = isAbove(cellRect);
        var belowViewport = isBelow(cellRect, viewportHeight);
        if (aboveViewport || belowViewport) {
          set$7(selector.element, 'display', 'none');
        }
      };
      var snapTo = function (selector, cell, getSnapConfig, pos) {
        var snap = getSnapConfig(cell);
        Dragging.snapTo(selector, snap);
        var isAbove = function (rect) {
          return rect[pos] < 0;
        };
        var isBelow = function (rect, viewportHeight) {
          return rect[pos] > viewportHeight;
        };
        showOrHideHandle(selector, cell, isAbove, isBelow);
      };
      var snapTopLeft = function (cell) {
        return snapTo(topLeft, cell, getTopLeftSnap, 'top');
      };
      var snapLastTopLeft = function () {
        return startCell.get().each(snapTopLeft);
      };
      var snapBottomRight = function (cell) {
        return snapTo(bottomRight, cell, getBottomRightSnap, 'bottom');
      };
      var snapLastBottomRight = function () {
        return finishCell.get().each(snapBottomRight);
      };
      if (detect$1().deviceType.isTouch()) {
        editor.on('TableSelectionChange', function (e) {
          if (!isVisible.get()) {
            attach(sink, topLeft);
            attach(sink, bottomRight);
            isVisible.set(true);
          }
          startCell.set(e.start);
          finishCell.set(e.finish);
          e.otherCells.each(function (otherCells) {
            tlTds.set(otherCells.upOrLeftCells);
            brTds.set(otherCells.downOrRightCells);
            snapTopLeft(e.start);
            snapBottomRight(e.finish);
          });
        });
        editor.on('ResizeEditor ResizeWindow ScrollContent', function () {
          snapLastTopLeft();
          snapLastBottomRight();
        });
        editor.on('TableSelectionClear', function () {
          if (isVisible.get()) {
            detach(topLeft);
            detach(bottomRight);
            isVisible.set(false);
          }
          startCell.clear();
          finishCell.clear();
        });
      }
    };

    var isHidden = function (elm) {
      if (elm.nodeType === 1) {
        if (elm.nodeName === 'BR' || !!elm.getAttribute('data-mce-bogus')) {
          return true;
        }
        if (elm.getAttribute('data-mce-type') === 'bookmark') {
          return true;
        }
      }
      return false;
    };
    var renderElementPath = function (editor, settings, providersBackstage) {
      if (!settings.delimiter) {
        settings.delimiter = '\xBB';
      }
      var getDataPath = function (data) {
        var parts = data || [];
        var newPathElements = map$2(parts, function (part, index) {
          return Button.sketch({
            dom: {
              tag: 'div',
              classes: ['tox-statusbar__path-item'],
              attributes: {
                'role': 'button',
                'data-index': index,
                'tab-index': -1,
                'aria-level': index + 1
              },
              innerHtml: part.name
            },
            action: function (_btn) {
              editor.focus();
              editor.selection.select(part.element);
              editor.nodeChanged();
            },
            buttonBehaviours: derive$1([
              DisablingConfigs.button(providersBackstage.isDisabled),
              receivingConfig()
            ])
          });
        });
        var divider = {
          dom: {
            tag: 'div',
            classes: ['tox-statusbar__path-divider'],
            attributes: { 'aria-hidden': true },
            innerHtml: ' ' + settings.delimiter + ' '
          }
        };
        return foldl(newPathElements.slice(1), function (acc, element) {
          var newAcc = acc;
          newAcc.push(divider);
          newAcc.push(element);
          return newAcc;
        }, [newPathElements[0]]);
      };
      var updatePath = function (parents) {
        var newPath = [];
        var i = parents.length;
        while (i-- > 0) {
          var parent_1 = parents[i];
          if (parent_1.nodeType === 1 && !isHidden(parent_1)) {
            var args = editor.fire('ResolveName', {
              name: parent_1.nodeName.toLowerCase(),
              target: parent_1
            });
            if (!args.isDefaultPrevented()) {
              newPath.push({
                name: args.name,
                element: parent_1
              });
            }
            if (args.isPropagationStopped()) {
              break;
            }
          }
        }
        return newPath;
      };
      return {
        dom: {
          tag: 'div',
          classes: ['tox-statusbar__path'],
          attributes: { role: 'navigation' }
        },
        behaviours: derive$1([
          Keying.config({
            mode: 'flow',
            selector: 'div[role=button]'
          }),
          Disabling.config({ disabled: providersBackstage.isDisabled }),
          receivingConfig(),
          Tabstopping.config({}),
          Replacing.config({}),
          config('elementPathEvents', [runOnAttached(function (comp, _e) {
              editor.shortcuts.add('alt+F11', 'focus statusbar elementpath', function () {
                return Keying.focusIn(comp);
              });
              editor.on('NodeChange', function (e) {
                var newPath = updatePath(e.parents);
                if (newPath.length > 0) {
                  Replacing.set(comp, getDataPath(newPath));
                } else {
                  Replacing.set(comp, []);
                }
              });
            })])
        ]),
        components: []
      };
    };

    var ResizeTypes;
    (function (ResizeTypes) {
      ResizeTypes[ResizeTypes['None'] = 0] = 'None';
      ResizeTypes[ResizeTypes['Both'] = 1] = 'Both';
      ResizeTypes[ResizeTypes['Vertical'] = 2] = 'Vertical';
    }(ResizeTypes || (ResizeTypes = {})));
    var getDimensions = function (editor, deltas, resizeType, originalHeight, originalWidth) {
      var dimensions = {};
      dimensions.height = calcCappedSize(originalHeight + deltas.top, getMinHeightSetting(editor), getMaxHeightSetting(editor));
      if (resizeType === ResizeTypes.Both) {
        dimensions.width = calcCappedSize(originalWidth + deltas.left, getMinWidthSetting(editor), getMaxWidthSetting(editor));
      }
      return dimensions;
    };
    var resize = function (editor, deltas, resizeType) {
      var container = SugarElement.fromDom(editor.getContainer());
      var dimensions = getDimensions(editor, deltas, resizeType, get$b(container), get$a(container));
      each(dimensions, function (val, dim) {
        return set$7(container, dim, numToPx(val));
      });
      fireResizeEditor(editor);
    };

    var getResizeType = function (editor) {
      var fallback = !editor.hasPlugin('autoresize');
      var resize = editor.getParam('resize', fallback);
      if (resize === false) {
        return ResizeTypes.None;
      } else if (resize === 'both') {
        return ResizeTypes.Both;
      } else {
        return ResizeTypes.Vertical;
      }
    };
    var keyboardHandler = function (editor, resizeType, x, y) {
      var scale = 20;
      var delta = SugarPosition(x * scale, y * scale);
      resize(editor, delta, resizeType);
      return Optional.some(true);
    };
    var renderResizeHandler = function (editor, providersBackstage) {
      var resizeType = getResizeType(editor);
      if (resizeType === ResizeTypes.None) {
        return Optional.none();
      }
      return Optional.some(render$3('resize-handle', {
        tag: 'div',
        classes: ['tox-statusbar__resize-handle'],
        attributes: { title: providersBackstage.translate('Resize') },
        behaviours: [
          Dragging.config({
            mode: 'mouse',
            repositionTarget: false,
            onDrag: function (_comp, _target, delta) {
              return resize(editor, delta, resizeType);
            },
            blockerClass: 'tox-blocker'
          }),
          Keying.config({
            mode: 'special',
            onLeft: function () {
              return keyboardHandler(editor, resizeType, -1, 0);
            },
            onRight: function () {
              return keyboardHandler(editor, resizeType, 1, 0);
            },
            onUp: function () {
              return keyboardHandler(editor, resizeType, 0, -1);
            },
            onDown: function () {
              return keyboardHandler(editor, resizeType, 0, 1);
            }
          }),
          Tabstopping.config({}),
          Focusing.config({})
        ]
      }, providersBackstage.icons));
    };

    var renderWordCount = function (editor, providersBackstage) {
      var _a;
      var replaceCountText = function (comp, count, mode) {
        return Replacing.set(comp, [text(providersBackstage.translate([
            '{0} ' + mode,
            count[mode]
          ]))]);
      };
      return Button.sketch({
        dom: {
          tag: 'button',
          classes: ['tox-statusbar__wordcount']
        },
        components: [],
        buttonBehaviours: derive$1([
          DisablingConfigs.button(providersBackstage.isDisabled),
          receivingConfig(),
          Tabstopping.config({}),
          Replacing.config({}),
          Representing.config({
            store: {
              mode: 'memory',
              initialValue: {
                mode: 'words',
                count: {
                  words: 0,
                  characters: 0
                }
              }
            }
          }),
          config('wordcount-events', [
            runOnExecute$1(function (comp) {
              var currentVal = Representing.getValue(comp);
              var newMode = currentVal.mode === 'words' ? 'characters' : 'words';
              Representing.setValue(comp, {
                mode: newMode,
                count: currentVal.count
              });
              replaceCountText(comp, currentVal.count, newMode);
            }),
            runOnAttached(function (comp) {
              editor.on('wordCountUpdate', function (e) {
                var mode = Representing.getValue(comp).mode;
                Representing.setValue(comp, {
                  mode: mode,
                  count: e.wordCount
                });
                replaceCountText(comp, e.wordCount, mode);
              });
            })
          ])
        ]),
        eventOrder: (_a = {}, _a[execute$5()] = [
          'disabling',
          'alloy.base.behaviour',
          'wordcount-events'
        ], _a)
      });
    };

    var renderStatusbar = function (editor, providersBackstage) {
      var renderBranding = function () {
        var label = global$e.translate([
          'Powered by {0}',
          'Tiny'
        ]);
        var linkHtml = '<a href="https://www.tiny.cloud/?utm_campaign=editor_referral&amp;utm_medium=poweredby&amp;utm_source=tinymce&amp;utm_content=v5" rel="noopener" target="_blank" tabindex="-1" aria-label="' + label + '">' + label + '</a>';
        return {
          dom: {
            tag: 'span',
            classes: ['tox-statusbar__branding'],
            innerHtml: linkHtml
          }
        };
      };
      var getTextComponents = function () {
        var components = [];
        if (editor.getParam('elementpath', true, 'boolean')) {
          components.push(renderElementPath(editor, {}, providersBackstage));
        }
        if (editor.hasPlugin('wordcount')) {
          components.push(renderWordCount(editor, providersBackstage));
        }
        if (editor.getParam('branding', true, 'boolean')) {
          components.push(renderBranding());
        }
        if (components.length > 0) {
          return [{
              dom: {
                tag: 'div',
                classes: ['tox-statusbar__text-container']
              },
              components: components
            }];
        }
        return [];
      };
      var getComponents = function () {
        var components = getTextComponents();
        var resizeHandler = renderResizeHandler(editor, providersBackstage);
        return components.concat(resizeHandler.toArray());
      };
      return {
        dom: {
          tag: 'div',
          classes: ['tox-statusbar']
        },
        components: getComponents()
      };
    };

    var setup$3 = function (editor) {
      var _a;
      var isInline = editor.inline;
      var mode = isInline ? Inline : Iframe;
      var header = isStickyToolbar(editor) ? StickyHeader : StaticHeader;
      var lazyOuterContainer = Optional.none();
      var platform = detect$1();
      var isIE = platform.browser.isIE();
      var platformClasses = isIE ? ['tox-platform-ie'] : [];
      var isTouch = platform.deviceType.isTouch();
      var touchPlatformClass = 'tox-platform-touch';
      var deviceClasses = isTouch ? [touchPlatformClass] : [];
      var isToolbarBottom = isToolbarLocationBottom(editor);
      var uiContainer = getUiContainer(editor);
      var dirAttributes = global$e.isRtl() ? { attributes: { dir: 'rtl' } } : {};
      var verticalDirAttributes = { attributes: (_a = {}, _a[Attribute] = isToolbarBottom ? AttributeValue.BottomToTop : AttributeValue.TopToBottom, _a) };
      var lazyHeader = function () {
        return lazyOuterContainer.bind(OuterContainer.getHeader);
      };
      var isHeaderDocked = function () {
        return header.isDocked(lazyHeader);
      };
      var resizeUiMothership = function () {
        set$7(uiMothership.element, 'width', document.body.clientWidth + 'px');
      };
      var makeSinkDefinition = function () {
        var isGridUiContainer = eq(body(), uiContainer) && get$c(uiContainer, 'display') === 'grid';
        var sinkSpec = {
          dom: __assign({
            tag: 'div',
            classes: [
              'tox',
              'tox-silver-sink',
              'tox-tinymce-aux'
            ].concat(platformClasses).concat(deviceClasses)
          }, dirAttributes),
          behaviours: derive$1([Positioning.config({
              useFixed: function () {
                return isHeaderDocked();
              }
            })])
        };
        var reactiveWidthSpec = {
          dom: { styles: { width: document.body.clientWidth + 'px' } },
          events: derive$2([run$1(windowResize(), resizeUiMothership)])
        };
        return deepMerge(sinkSpec, isGridUiContainer ? reactiveWidthSpec : {});
      };
      var sink = build$1(makeSinkDefinition());
      var lazySink = function () {
        return Result.value(sink);
      };
      var memAnchorBar = record({
        dom: {
          tag: 'div',
          classes: ['tox-anchorbar']
        }
      });
      var lazyAnchorBar = function () {
        return lazyOuterContainer.bind(function (container) {
          return memAnchorBar.getOpt(container);
        }).getOrDie('Could not find a anchor bar element');
      };
      var lazyToolbar = function () {
        return lazyOuterContainer.bind(function (container) {
          return OuterContainer.getToolbar(container);
        }).getOrDie('Could not find more toolbar element');
      };
      var lazyThrobber = function () {
        return lazyOuterContainer.bind(function (container) {
          return OuterContainer.getThrobber(container);
        }).getOrDie('Could not find throbber element');
      };
      var backstage = init$7(sink, editor, lazyAnchorBar);
      var partMenubar = OuterContainer.parts.menubar({
        dom: {
          tag: 'div',
          classes: ['tox-menubar']
        },
        backstage: backstage,
        onEscape: function () {
          editor.focus();
        }
      });
      var toolbarMode = getToolbarMode(editor);
      var partToolbar = OuterContainer.parts.toolbar(__assign({
        dom: {
          tag: 'div',
          classes: ['tox-toolbar']
        },
        getSink: lazySink,
        providers: backstage.shared.providers,
        onEscape: function () {
          editor.focus();
        },
        type: toolbarMode,
        lazyToolbar: lazyToolbar,
        lazyHeader: function () {
          return lazyHeader().getOrDie('Could not find header element');
        }
      }, verticalDirAttributes));
      var partMultipleToolbar = OuterContainer.parts['multiple-toolbar']({
        dom: {
          tag: 'div',
          classes: ['tox-toolbar-overlord']
        },
        providers: backstage.shared.providers,
        onEscape: function () {
          editor.focus();
        },
        type: toolbarMode
      });
      var partSocket = OuterContainer.parts.socket({
        dom: {
          tag: 'div',
          classes: ['tox-edit-area']
        }
      });
      var partSidebar = OuterContainer.parts.sidebar({
        dom: {
          tag: 'div',
          classes: ['tox-sidebar']
        }
      });
      var partThrobber = OuterContainer.parts.throbber({
        dom: {
          tag: 'div',
          classes: ['tox-throbber']
        },
        backstage: backstage
      });
      var sb = editor.getParam('statusbar', true, 'boolean');
      var statusbar = sb && !isInline ? Optional.some(renderStatusbar(editor, backstage.shared.providers)) : Optional.none();
      var socketSidebarContainer = {
        dom: {
          tag: 'div',
          classes: ['tox-sidebar-wrap']
        },
        components: [
          partSocket,
          partSidebar
        ]
      };
      var hasMultipleToolbar = isMultipleToolbars(editor);
      var hasToolbar = isToolbarEnabled(editor);
      var hasMenubar = isMenubarEnabled(editor);
      var getPartToolbar = function () {
        if (hasMultipleToolbar) {
          return [partMultipleToolbar];
        } else if (hasToolbar) {
          return [partToolbar];
        } else {
          return [];
        }
      };
      var partHeader = OuterContainer.parts.header({
        dom: __assign({
          tag: 'div',
          classes: ['tox-editor-header']
        }, verticalDirAttributes),
        components: flatten([
          hasMenubar ? [partMenubar] : [],
          getPartToolbar(),
          useFixedContainer(editor) ? [] : [memAnchorBar.asSpec()]
        ]),
        sticky: isStickyToolbar(editor),
        editor: editor,
        sharedBackstage: backstage.shared
      });
      var editorComponents = flatten([
        isToolbarBottom ? [] : [partHeader],
        isInline ? [] : [socketSidebarContainer],
        isToolbarBottom ? [partHeader] : []
      ]);
      var editorContainer = {
        dom: {
          tag: 'div',
          classes: ['tox-editor-container']
        },
        components: editorComponents
      };
      var containerComponents = flatten([
        [editorContainer],
        isInline ? [] : statusbar.toArray(),
        [partThrobber]
      ]);
      var isHidden = isDistractionFree(editor);
      var attributes = __assign(__assign({ role: 'application' }, global$e.isRtl() ? { dir: 'rtl' } : {}), isHidden ? { 'aria-hidden': 'true' } : {});
      var outerContainer = build$1(OuterContainer.sketch({
        dom: {
          tag: 'div',
          classes: [
            'tox',
            'tox-tinymce'
          ].concat(isInline ? ['tox-tinymce-inline'] : []).concat(isToolbarBottom ? ['tox-tinymce--toolbar-bottom'] : []).concat(deviceClasses).concat(platformClasses),
          styles: __assign({ visibility: 'hidden' }, isHidden ? {
            opacity: '0',
            border: '0'
          } : {}),
          attributes: attributes
        },
        components: containerComponents,
        behaviours: derive$1([
          receivingConfig(),
          Disabling.config({ disableClass: 'tox-tinymce--disabled' }),
          Keying.config({
            mode: 'cyclic',
            selector: '.tox-menubar, .tox-toolbar, .tox-toolbar__primary, .tox-toolbar__overflow--open, .tox-sidebar__overflow--open, .tox-statusbar__path, .tox-statusbar__wordcount, .tox-statusbar__branding a, .tox-statusbar__resize-handle'
          })
        ])
      }));
      lazyOuterContainer = Optional.some(outerContainer);
      editor.shortcuts.add('alt+F9', 'focus menubar', function () {
        OuterContainer.focusMenubar(outerContainer);
      });
      editor.shortcuts.add('alt+F10', 'focus toolbar', function () {
        OuterContainer.focusToolbar(outerContainer);
      });
      editor.addCommand('ToggleToolbarDrawer', function () {
        OuterContainer.toggleToolbarDrawer(outerContainer);
      });
      editor.addQueryStateHandler('ToggleToolbarDrawer', function () {
        return OuterContainer.isToolbarDrawerToggled(outerContainer);
      });
      var mothership = takeover(outerContainer);
      var uiMothership = takeover(sink);
      setup$b(editor, mothership, uiMothership);
      var getUi = function () {
        var channels = {
          broadcastAll: uiMothership.broadcast,
          broadcastOn: uiMothership.broadcastOn,
          register: noop
        };
        return { channels: channels };
      };
      var setEditorSize = function () {
        var parsedHeight = numToPx(getHeightWithFallback(editor));
        var parsedWidth = numToPx(getWidthWithFallback(editor));
        if (!editor.inline) {
          if (isValidValue('div', 'width', parsedWidth)) {
            set$7(outerContainer.element, 'width', parsedWidth);
          }
          if (isValidValue('div', 'height', parsedHeight)) {
            set$7(outerContainer.element, 'height', parsedHeight);
          } else {
            set$7(outerContainer.element, 'height', '200px');
          }
        }
        return parsedHeight;
      };
      var renderUI = function () {
        header.setup(editor, backstage.shared, lazyHeader);
        setup$6(editor, backstage);
        setup$5(editor, lazySink, backstage);
        setup$8(editor);
        setup$7(editor, lazyThrobber, backstage.shared);
        map$1(getToolbarGroups(editor), function (toolbarGroupButtonConfig, name) {
          editor.ui.registry.addGroupToolbarButton(name, toolbarGroupButtonConfig);
        });
        var _a = editor.ui.registry.getAll(), buttons = _a.buttons, menuItems = _a.menuItems, contextToolbars = _a.contextToolbars, sidebars = _a.sidebars;
        var toolbarOpt = getMultipleToolbarsSetting(editor);
        var rawUiConfig = {
          menuItems: menuItems,
          menus: getMenus(editor),
          menubar: getMenubar(editor),
          toolbar: toolbarOpt.getOrThunk(function () {
            return getToolbar(editor);
          }),
          allowToolbarGroups: toolbarMode === ToolbarMode.floating,
          buttons: buttons,
          sidebar: sidebars
        };
        register$7(editor, contextToolbars, sink, { backstage: backstage });
        setup$4(editor, sink);
        var elm = editor.getElement();
        var height = setEditorSize();
        var uiComponents = {
          mothership: mothership,
          uiMothership: uiMothership,
          outerContainer: outerContainer
        };
        var args = {
          targetNode: elm,
          height: height
        };
        return mode.render(editor, uiComponents, rawUiConfig, backstage, args);
      };
      return {
        mothership: mothership,
        uiMothership: uiMothership,
        backstage: backstage,
        renderUI: renderUI,
        getUi: getUi
      };
    };

    var describedBy = function (describedElement, describeElement) {
      var describeId = Optional.from(get$d(describedElement, 'id')).fold(function () {
        var id = generate$6('dialog-describe');
        set$8(describeElement, 'id', id);
        return id;
      }, identity$1);
      set$8(describedElement, 'aria-describedby', describeId);
    };

    var labelledBy = function (labelledElement, labelElement) {
      var labelId = getOpt(labelledElement, 'id').fold(function () {
        var id = generate$6('dialog-label');
        set$8(labelElement, 'id', id);
        return id;
      }, identity$1);
      set$8(labelledElement, 'aria-labelledby', labelId);
    };

    var schema$2 = constant$1([
      required$1('lazySink'),
      option('dragBlockClass'),
      defaultedFunction('getBounds', win),
      defaulted('useTabstopAt', always),
      defaulted('eventOrder', {}),
      field('modalBehaviours', [Keying]),
      onKeyboardHandler('onExecute'),
      onStrictKeyboardHandler('onEscape')
    ]);
    var basic = { sketch: identity$1 };
    var parts$2 = constant$1([
      optional({
        name: 'draghandle',
        overrides: function (detail, spec) {
          return {
            behaviours: derive$1([Dragging.config({
                mode: 'mouse',
                getTarget: function (handle) {
                  return ancestor(handle, '[role="dialog"]').getOr(handle);
                },
                blockerClass: detail.dragBlockClass.getOrDie(new Error('The drag blocker class was not specified for a dialog with a drag handle: \n' + JSON.stringify(spec, null, 2)).message),
                getBounds: detail.getDragBounds
              })])
          };
        }
      }),
      required({
        schema: [required$1('dom')],
        name: 'title'
      }),
      required({
        factory: basic,
        schema: [required$1('dom')],
        name: 'close'
      }),
      required({
        factory: basic,
        schema: [required$1('dom')],
        name: 'body'
      }),
      optional({
        factory: basic,
        schema: [required$1('dom')],
        name: 'footer'
      }),
      external$1({
        factory: {
          sketch: function (spec, detail) {
            return __assign(__assign({}, spec), {
              dom: detail.dom,
              components: detail.components
            });
          }
        },
        schema: [
          defaulted('dom', {
            tag: 'div',
            styles: {
              position: 'fixed',
              left: '0px',
              top: '0px',
              right: '0px',
              bottom: '0px'
            }
          }),
          defaulted('components', [])
        ],
        name: 'blocker'
      })
    ]);

    var factory$4 = function (detail, components, spec, externals) {
      var _a;
      var dialogComp = value$1();
      var showDialog = function (dialog) {
        dialogComp.set(dialog);
        var sink = detail.lazySink(dialog).getOrDie();
        var externalBlocker = externals.blocker();
        var blocker = sink.getSystem().build(__assign(__assign({}, externalBlocker), {
          components: externalBlocker.components.concat([premade(dialog)]),
          behaviours: derive$1([
            Focusing.config({}),
            config('dialog-blocker-events', [runOnSource(focusin(), function () {
                Keying.focusIn(dialog);
              })])
          ])
        }));
        attach(sink, blocker);
        Keying.focusIn(dialog);
      };
      var hideDialog = function (dialog) {
        dialogComp.clear();
        parent(dialog.element).each(function (blockerDom) {
          dialog.getSystem().getByDom(blockerDom).each(function (blocker) {
            detach(blocker);
          });
        });
      };
      var getDialogBody = function (dialog) {
        return getPartOrDie(dialog, detail, 'body');
      };
      var getDialogFooter = function (dialog) {
        return getPartOrDie(dialog, detail, 'footer');
      };
      var setBusy = function (dialog, getBusySpec) {
        Blocking.block(dialog, getBusySpec);
      };
      var setIdle = function (dialog) {
        Blocking.unblock(dialog);
      };
      var modalEventsId = generate$6('modal-events');
      var eventOrder = __assign(__assign({}, detail.eventOrder), (_a = {}, _a[attachedToDom()] = [modalEventsId].concat(detail.eventOrder['alloy.system.attached'] || []), _a));
      return {
        uid: detail.uid,
        dom: detail.dom,
        components: components,
        apis: {
          show: showDialog,
          hide: hideDialog,
          getBody: getDialogBody,
          getFooter: getDialogFooter,
          setIdle: setIdle,
          setBusy: setBusy
        },
        eventOrder: eventOrder,
        domModification: {
          attributes: {
            'role': 'dialog',
            'aria-modal': 'true'
          }
        },
        behaviours: augment(detail.modalBehaviours, [
          Replacing.config({}),
          Keying.config({
            mode: 'cyclic',
            onEnter: detail.onExecute,
            onEscape: detail.onEscape,
            useTabstopAt: detail.useTabstopAt
          }),
          Blocking.config({ getRoot: dialogComp.get }),
          config(modalEventsId, [runOnAttached(function (c) {
              labelledBy(c.element, getPartOrDie(c, detail, 'title').element);
              describedBy(c.element, getPartOrDie(c, detail, 'body').element);
            })])
        ])
      };
    };
    var ModalDialog = composite({
      name: 'ModalDialog',
      configFields: schema$2(),
      partFields: parts$2(),
      factory: factory$4,
      apis: {
        show: function (apis, dialog) {
          apis.show(dialog);
        },
        hide: function (apis, dialog) {
          apis.hide(dialog);
        },
        getBody: function (apis, dialog) {
          return apis.getBody(dialog);
        },
        getFooter: function (apis, dialog) {
          return apis.getFooter(dialog);
        },
        setBusy: function (apis, dialog, getBusySpec) {
          apis.setBusy(dialog, getBusySpec);
        },
        setIdle: function (apis, dialog) {
          apis.setIdle(dialog);
        }
      }
    });

    var dialogToggleMenuItemSchema = objOf([
      requiredString('type'),
      requiredString('name')
    ].concat(commonMenuItemFields));
    var dialogToggleMenuItemDataProcessor = boolean;

    var baseFooterButtonFields = [
      field$1('name', 'name', defaultedThunk(function () {
        return generate$6('button-name');
      }), string),
      optionString('icon'),
      defaultedStringEnum('align', 'end', [
        'start',
        'end'
      ]),
      defaultedBoolean('primary', false),
      defaultedBoolean('disabled', false)
    ];
    var dialogFooterButtonFields = __spreadArray(__spreadArray([], baseFooterButtonFields, true), [requiredString('text')], false);
    var normalFooterButtonFields = __spreadArray([requiredStringEnum('type', [
        'submit',
        'cancel',
        'custom'
      ])], dialogFooterButtonFields, true);
    var menuFooterButtonFields = __spreadArray([
      requiredStringEnum('type', ['menu']),
      optionString('text'),
      optionString('tooltip'),
      optionString('icon'),
      requiredArrayOf('items', dialogToggleMenuItemSchema)
    ], baseFooterButtonFields, true);
    var dialogFooterButtonSchema = choose$1('type', {
      submit: normalFooterButtonFields,
      cancel: normalFooterButtonFields,
      custom: normalFooterButtonFields,
      menu: menuFooterButtonFields
    });

    var alertBannerFields = [
      requiredString('type'),
      requiredString('text'),
      requiredStringEnum('level', [
        'info',
        'warn',
        'error',
        'success'
      ]),
      requiredString('icon'),
      defaulted('url', '')
    ];
    var alertBannerSchema = objOf(alertBannerFields);

    var createBarFields = function (itemsField) {
      return [
        requiredString('type'),
        itemsField
      ];
    };

    var buttonFields = [
      requiredString('type'),
      requiredString('text'),
      defaultedBoolean('disabled', false),
      defaultedBoolean('primary', false),
      field$1('name', 'name', defaultedThunk(function () {
        return generate$6('button-name');
      }), string),
      optionString('icon'),
      defaultedBoolean('borderless', false)
    ];
    var buttonSchema = objOf(buttonFields);

    var checkboxFields = [
      requiredString('type'),
      requiredString('name'),
      requiredString('label'),
      defaultedBoolean('disabled', false)
    ];
    var checkboxSchema = objOf(checkboxFields);
    var checkboxDataProcessor = boolean;

    var formComponentFields = [
      requiredString('type'),
      requiredString('name')
    ];
    var formComponentWithLabelFields = formComponentFields.concat([optionString('label')]);

    var collectionFields = formComponentWithLabelFields.concat([defaulted('columns', 'auto')]);
    var collectionSchema = objOf(collectionFields);
    var collectionDataProcessor = arrOfObj([
      requiredString('value'),
      requiredString('text'),
      requiredString('icon')
    ]);

    var colorInputFields = formComponentWithLabelFields;
    var colorInputSchema = objOf(colorInputFields);
    var colorInputDataProcessor = string;

    var colorPickerFields = formComponentWithLabelFields;
    var colorPickerSchema = objOf(colorPickerFields);
    var colorPickerDataProcessor = string;

    var customEditorFields = formComponentFields.concat([
      defaultedString('tag', 'textarea'),
      requiredString('scriptId'),
      requiredString('scriptUrl'),
      defaultedPostMsg('settings', undefined)
    ]);
    var customEditorFieldsOld = formComponentFields.concat([
      defaultedString('tag', 'textarea'),
      requiredFunction('init')
    ]);
    var customEditorSchema = valueOf(function (v) {
      return asRaw('customeditor.old', objOfOnly(customEditorFieldsOld), v).orThunk(function () {
        return asRaw('customeditor.new', objOfOnly(customEditorFields), v);
      });
    });
    var customEditorDataProcessor = string;

    var dropZoneFields = formComponentWithLabelFields;
    var dropZoneSchema = objOf(dropZoneFields);
    var dropZoneDataProcessor = arrOfVal();

    var createGridFields = function (itemsField) {
      return [
        requiredString('type'),
        requiredNumber('columns'),
        itemsField
      ];
    };

    var htmlPanelFields = [
      requiredString('type'),
      requiredString('html'),
      defaultedStringEnum('presets', 'presentation', [
        'presentation',
        'document'
      ])
    ];
    var htmlPanelSchema = objOf(htmlPanelFields);

    var iframeFields = formComponentWithLabelFields.concat([defaultedBoolean('sandboxed', true)]);
    var iframeSchema = objOf(iframeFields);
    var iframeDataProcessor = string;

    var imageToolsFields = formComponentWithLabelFields.concat([requiredOf('currentState', objOf([
        required$1('blob'),
        requiredString('url')
      ]))]);
    var imageToolsSchema = objOf(imageToolsFields);

    var inputFields = formComponentWithLabelFields.concat([
      optionString('inputMode'),
      optionString('placeholder'),
      defaultedBoolean('maximized', false),
      defaultedBoolean('disabled', false)
    ]);
    var inputSchema = objOf(inputFields);
    var inputDataProcessor = string;

    var createLabelFields = function (itemsField) {
      return [
        requiredString('type'),
        requiredString('label'),
        itemsField
      ];
    };

    var listBoxSingleItemFields = [
      requiredString('text'),
      requiredString('value')
    ];
    var listBoxNestedItemFields = [
      requiredString('text'),
      requiredArrayOf('items', thunkOf('items', function () {
        return listBoxItemSchema;
      }))
    ];
    var listBoxItemSchema = oneOf([
      objOf(listBoxSingleItemFields),
      objOf(listBoxNestedItemFields)
    ]);
    var listBoxFields = formComponentWithLabelFields.concat([
      requiredArrayOf('items', listBoxItemSchema),
      defaultedBoolean('disabled', false)
    ]);
    var listBoxSchema = objOf(listBoxFields);
    var listBoxDataProcessor = string;

    var selectBoxFields = formComponentWithLabelFields.concat([
      requiredArrayOfObj('items', [
        requiredString('text'),
        requiredString('value')
      ]),
      defaultedNumber('size', 1),
      defaultedBoolean('disabled', false)
    ]);
    var selectBoxSchema = objOf(selectBoxFields);
    var selectBoxDataProcessor = string;

    var sizeInputFields = formComponentWithLabelFields.concat([
      defaultedBoolean('constrain', true),
      defaultedBoolean('disabled', false)
    ]);
    var sizeInputSchema = objOf(sizeInputFields);
    var sizeInputDataProcessor = objOf([
      requiredString('width'),
      requiredString('height')
    ]);

    var tableFields = [
      requiredString('type'),
      requiredArrayOf('header', string),
      requiredArrayOf('cells', arrOf(string))
    ];
    var tableSchema = objOf(tableFields);

    var textAreaFields = formComponentWithLabelFields.concat([
      optionString('placeholder'),
      defaultedBoolean('maximized', false),
      defaultedBoolean('disabled', false)
    ]);
    var textAreaSchema = objOf(textAreaFields);
    var textAreaDataProcessor = string;

    var urlInputFields = formComponentWithLabelFields.concat([
      defaultedStringEnum('filetype', 'file', [
        'image',
        'media',
        'file'
      ]),
      defaulted('disabled', false)
    ]);
    var urlInputSchema = objOf(urlInputFields);
    var urlInputDataProcessor = objOf([
      requiredString('value'),
      defaulted('meta', {})
    ]);

    var createItemsField = function (name) {
      return field$1('items', 'items', required$2(), arrOf(valueOf(function (v) {
        return asRaw('Checking item of ' + name, itemSchema, v).fold(function (sErr) {
          return Result.error(formatError(sErr));
        }, function (passValue) {
          return Result.value(passValue);
        });
      })));
    };
    var itemSchema = valueThunk(function () {
      return choose$2('type', {
        alertbanner: alertBannerSchema,
        bar: objOf(createBarFields(createItemsField('bar'))),
        button: buttonSchema,
        checkbox: checkboxSchema,
        colorinput: colorInputSchema,
        colorpicker: colorPickerSchema,
        dropzone: dropZoneSchema,
        grid: objOf(createGridFields(createItemsField('grid'))),
        iframe: iframeSchema,
        input: inputSchema,
        listbox: listBoxSchema,
        selectbox: selectBoxSchema,
        sizeinput: sizeInputSchema,
        textarea: textAreaSchema,
        urlinput: urlInputSchema,
        customeditor: customEditorSchema,
        htmlpanel: htmlPanelSchema,
        imagetools: imageToolsSchema,
        collection: collectionSchema,
        label: objOf(createLabelFields(createItemsField('label'))),
        table: tableSchema,
        panel: panelSchema
      });
    });
    var panelFields = [
      requiredString('type'),
      defaulted('classes', []),
      requiredArrayOf('items', itemSchema)
    ];
    var panelSchema = objOf(panelFields);

    var tabFields = [
      field$1('name', 'name', defaultedThunk(function () {
        return generate$6('tab-name');
      }), string),
      requiredString('title'),
      requiredArrayOf('items', itemSchema)
    ];
    var tabPanelFields = [
      requiredString('type'),
      requiredArrayOfObj('tabs', tabFields)
    ];
    var tabPanelSchema = objOf(tabPanelFields);

    var dialogButtonFields = dialogFooterButtonFields;
    var dialogButtonSchema = dialogFooterButtonSchema;
    var dialogSchema = objOf([
      requiredString('title'),
      requiredOf('body', choose$2('type', {
        panel: panelSchema,
        tabpanel: tabPanelSchema
      })),
      defaultedString('size', 'normal'),
      requiredArrayOf('buttons', dialogButtonSchema),
      defaulted('initialData', {}),
      defaultedFunction('onAction', noop),
      defaultedFunction('onChange', noop),
      defaultedFunction('onSubmit', noop),
      defaultedFunction('onClose', noop),
      defaultedFunction('onCancel', noop),
      defaulted('onTabChange', noop)
    ]);
    var createDialog = function (spec) {
      return asRaw('dialog', dialogSchema, spec);
    };

    var urlDialogButtonSchema = objOf(__spreadArray([requiredStringEnum('type', [
        'cancel',
        'custom'
      ])], dialogButtonFields, true));
    var urlDialogSchema = objOf([
      requiredString('title'),
      requiredString('url'),
      optionNumber('height'),
      optionNumber('width'),
      optionArrayOf('buttons', urlDialogButtonSchema),
      defaultedFunction('onAction', noop),
      defaultedFunction('onCancel', noop),
      defaultedFunction('onClose', noop),
      defaultedFunction('onMessage', noop)
    ]);
    var createUrlDialog = function (spec) {
      return asRaw('dialog', urlDialogSchema, spec);
    };

    var getAllObjects = function (obj) {
      if (isObject(obj)) {
        return [obj].concat(bind$3(values(obj), getAllObjects));
      } else if (isArray(obj)) {
        return bind$3(obj, getAllObjects);
      } else {
        return [];
      }
    };

    var isNamedItem = function (obj) {
      return isString(obj.type) && isString(obj.name);
    };
    var dataProcessors = {
      checkbox: checkboxDataProcessor,
      colorinput: colorInputDataProcessor,
      colorpicker: colorPickerDataProcessor,
      dropzone: dropZoneDataProcessor,
      input: inputDataProcessor,
      iframe: iframeDataProcessor,
      sizeinput: sizeInputDataProcessor,
      selectbox: selectBoxDataProcessor,
      listbox: listBoxDataProcessor,
      size: sizeInputDataProcessor,
      textarea: textAreaDataProcessor,
      urlinput: urlInputDataProcessor,
      customeditor: customEditorDataProcessor,
      collection: collectionDataProcessor,
      togglemenuitem: dialogToggleMenuItemDataProcessor
    };
    var getDataProcessor = function (item) {
      return Optional.from(dataProcessors[item.type]);
    };
    var getNamedItems = function (structure) {
      return filter$2(getAllObjects(structure), isNamedItem);
    };

    var createDataValidator = function (structure) {
      var namedItems = getNamedItems(structure);
      var fields = bind$3(namedItems, function (item) {
        return getDataProcessor(item).fold(function () {
          return [];
        }, function (schema) {
          return [requiredOf(item.name, schema)];
        });
      });
      return objOf(fields);
    };

    var extract = function (structure) {
      var internalDialog = getOrDie(createDialog(structure));
      var dataValidator = createDataValidator(structure);
      var initialData = structure.initialData;
      return {
        internalDialog: internalDialog,
        dataValidator: dataValidator,
        initialData: initialData
      };
    };
    var DialogManager = {
      open: function (factory, structure) {
        var extraction = extract(structure);
        return factory(extraction.internalDialog, extraction.initialData, extraction.dataValidator);
      },
      openUrl: function (factory, structure) {
        var internalDialog = getOrDie(createUrlDialog(structure));
        return factory(internalDialog);
      },
      redial: function (structure) {
        return extract(structure);
      }
    };

    var toValidValues = function (values) {
      var errors = [];
      var result = {};
      each(values, function (value, name) {
        value.fold(function () {
          errors.push(name);
        }, function (v) {
          result[name] = v;
        });
      });
      return errors.length > 0 ? Result.error(errors) : Result.value(result);
    };

    var renderBodyPanel = function (spec, backstage) {
      var memForm = record(Form.sketch(function (parts) {
        return {
          dom: {
            tag: 'div',
            classes: ['tox-form'].concat(spec.classes)
          },
          components: map$2(spec.items, function (item) {
            return interpretInForm(parts, item, backstage);
          })
        };
      }));
      return {
        dom: {
          tag: 'div',
          classes: ['tox-dialog__body']
        },
        components: [{
            dom: {
              tag: 'div',
              classes: ['tox-dialog__body-content']
            },
            components: [memForm.asSpec()]
          }],
        behaviours: derive$1([
          Keying.config({
            mode: 'acyclic',
            useTabstopAt: not(isPseudoStop)
          }),
          ComposingConfigs.memento(memForm),
          RepresentingConfigs.memento(memForm, {
            postprocess: function (formValue) {
              return toValidValues(formValue).fold(function (err) {
                console.error(err);
                return {};
              }, identity$1);
            }
          })
        ])
      };
    };

    var factory$3 = function (detail, _spec) {
      return {
        uid: detail.uid,
        dom: detail.dom,
        components: detail.components,
        events: events$a(detail.action),
        behaviours: augment(detail.tabButtonBehaviours, [
          Focusing.config({}),
          Keying.config({
            mode: 'execution',
            useSpace: true,
            useEnter: true
          }),
          Representing.config({
            store: {
              mode: 'memory',
              initialValue: detail.value
            }
          })
        ]),
        domModification: detail.domModification
      };
    };
    var TabButton = single({
      name: 'TabButton',
      configFields: [
        defaulted('uid', undefined),
        required$1('value'),
        field$1('dom', 'dom', mergeWithThunk(function () {
          return {
            attributes: {
              'role': 'tab',
              'id': generate$6('aria'),
              'aria-selected': 'false'
            }
          };
        }), anyValue()),
        option('action'),
        defaulted('domModification', {}),
        field('tabButtonBehaviours', [
          Focusing,
          Keying,
          Representing
        ]),
        required$1('view')
      ],
      factory: factory$3
    });

    var schema$1 = constant$1([
      required$1('tabs'),
      required$1('dom'),
      defaulted('clickToDismiss', false),
      field('tabbarBehaviours', [
        Highlighting,
        Keying
      ]),
      markers$1([
        'tabClass',
        'selectedClass'
      ])
    ]);
    var tabsPart = group({
      factory: TabButton,
      name: 'tabs',
      unit: 'tab',
      overrides: function (barDetail) {
        var dismissTab$1 = function (tabbar, button) {
          Highlighting.dehighlight(tabbar, button);
          emitWith(tabbar, dismissTab(), {
            tabbar: tabbar,
            button: button
          });
        };
        var changeTab$1 = function (tabbar, button) {
          Highlighting.highlight(tabbar, button);
          emitWith(tabbar, changeTab(), {
            tabbar: tabbar,
            button: button
          });
        };
        return {
          action: function (button) {
            var tabbar = button.getSystem().getByUid(barDetail.uid).getOrDie();
            var activeButton = Highlighting.isHighlighted(tabbar, button);
            var response = function () {
              if (activeButton && barDetail.clickToDismiss) {
                return dismissTab$1;
              } else if (!activeButton) {
                return changeTab$1;
              } else {
                return noop;
              }
            }();
            response(tabbar, button);
          },
          domModification: { classes: [barDetail.markers.tabClass] }
        };
      }
    });
    var parts$1 = constant$1([tabsPart]);

    var factory$2 = function (detail, components, _spec, _externals) {
      return {
        'uid': detail.uid,
        'dom': detail.dom,
        components: components,
        'debug.sketcher': 'Tabbar',
        'domModification': { attributes: { role: 'tablist' } },
        'behaviours': augment(detail.tabbarBehaviours, [
          Highlighting.config({
            highlightClass: detail.markers.selectedClass,
            itemClass: detail.markers.tabClass,
            onHighlight: function (tabbar, tab) {
              set$8(tab.element, 'aria-selected', 'true');
            },
            onDehighlight: function (tabbar, tab) {
              set$8(tab.element, 'aria-selected', 'false');
            }
          }),
          Keying.config({
            mode: 'flow',
            getInitial: function (tabbar) {
              return Highlighting.getHighlighted(tabbar).map(function (tab) {
                return tab.element;
              });
            },
            selector: '.' + detail.markers.tabClass,
            executeOnMove: true
          })
        ])
      };
    };
    var Tabbar = composite({
      name: 'Tabbar',
      configFields: schema$1(),
      partFields: parts$1(),
      factory: factory$2
    });

    var factory$1 = function (detail, _spec) {
      return {
        uid: detail.uid,
        dom: detail.dom,
        behaviours: augment(detail.tabviewBehaviours, [Replacing.config({})]),
        domModification: { attributes: { role: 'tabpanel' } }
      };
    };
    var Tabview = single({
      name: 'Tabview',
      configFields: [field('tabviewBehaviours', [Replacing])],
      factory: factory$1
    });

    var schema = constant$1([
      defaulted('selectFirst', true),
      onHandler('onChangeTab'),
      onHandler('onDismissTab'),
      defaulted('tabs', []),
      field('tabSectionBehaviours', [])
    ]);
    var barPart = required({
      factory: Tabbar,
      schema: [
        required$1('dom'),
        requiredObjOf('markers', [
          required$1('tabClass'),
          required$1('selectedClass')
        ])
      ],
      name: 'tabbar',
      defaults: function (detail) {
        return { tabs: detail.tabs };
      }
    });
    var viewPart = required({
      factory: Tabview,
      name: 'tabview'
    });
    var parts = constant$1([
      barPart,
      viewPart
    ]);

    var factory = function (detail, components, _spec, _externals) {
      var changeTab$1 = function (button) {
        var tabValue = Representing.getValue(button);
        getPart(button, detail, 'tabview').each(function (tabview) {
          var tabWithValue = find$5(detail.tabs, function (t) {
            return t.value === tabValue;
          });
          tabWithValue.each(function (tabData) {
            var panel = tabData.view();
            getOpt(button.element, 'id').each(function (id) {
              set$8(tabview.element, 'aria-labelledby', id);
            });
            Replacing.set(tabview, panel);
            detail.onChangeTab(tabview, button, panel);
          });
        });
      };
      var changeTabBy = function (section, byPred) {
        getPart(section, detail, 'tabbar').each(function (tabbar) {
          byPred(tabbar).each(emitExecute);
        });
      };
      return {
        uid: detail.uid,
        dom: detail.dom,
        components: components,
        behaviours: get$2(detail.tabSectionBehaviours),
        events: derive$2(flatten([
          detail.selectFirst ? [runOnAttached(function (section, _simulatedEvent) {
              changeTabBy(section, Highlighting.getFirst);
            })] : [],
          [
            run$1(changeTab(), function (section, simulatedEvent) {
              var button = simulatedEvent.event.button;
              changeTab$1(button);
            }),
            run$1(dismissTab(), function (section, simulatedEvent) {
              var button = simulatedEvent.event.button;
              detail.onDismissTab(section, button);
            })
          ]
        ])),
        apis: {
          getViewItems: function (section) {
            return getPart(section, detail, 'tabview').map(function (tabview) {
              return Replacing.contents(tabview);
            }).getOr([]);
          },
          showTab: function (section, tabKey) {
            var getTabIfNotActive = function (tabbar) {
              var candidates = Highlighting.getCandidates(tabbar);
              var optTab = find$5(candidates, function (c) {
                return Representing.getValue(c) === tabKey;
              });
              return optTab.filter(function (tab) {
                return !Highlighting.isHighlighted(tabbar, tab);
              });
            };
            changeTabBy(section, getTabIfNotActive);
          }
        }
      };
    };
    var TabSection = composite({
      name: 'TabSection',
      configFields: schema(),
      partFields: parts(),
      factory: factory,
      apis: {
        getViewItems: function (apis, component) {
          return apis.getViewItems(component);
        },
        showTab: function (apis, component, tabKey) {
          apis.showTab(component, tabKey);
        }
      }
    });

    var measureHeights = function (allTabs, tabview, tabviewComp) {
      return map$2(allTabs, function (_tab, i) {
        Replacing.set(tabviewComp, allTabs[i].view());
        var rect = tabview.dom.getBoundingClientRect();
        Replacing.set(tabviewComp, []);
        return rect.height;
      });
    };
    var getMaxHeight = function (heights) {
      return head(sort(heights, function (a, b) {
        if (a > b) {
          return -1;
        } else if (a < b) {
          return +1;
        } else {
          return 0;
        }
      }));
    };
    var getMaxTabviewHeight = function (dialog, tabview, tablist) {
      var documentElement$1 = documentElement(dialog).dom;
      var rootElm = ancestor(dialog, '.tox-dialog-wrap').getOr(dialog);
      var isFixed = get$c(rootElm, 'position') === 'fixed';
      var maxHeight;
      if (isFixed) {
        maxHeight = Math.max(documentElement$1.clientHeight, window.innerHeight);
      } else {
        maxHeight = Math.max(documentElement$1.offsetHeight, documentElement$1.scrollHeight);
      }
      var tabviewHeight = get$b(tabview);
      var isTabListBeside = tabview.dom.offsetLeft >= tablist.dom.offsetLeft + get$a(tablist);
      var currentTabHeight = isTabListBeside ? Math.max(get$b(tablist), tabviewHeight) : tabviewHeight;
      var dialogTopMargin = parseInt(get$c(dialog, 'margin-top'), 10) || 0;
      var dialogBottomMargin = parseInt(get$c(dialog, 'margin-bottom'), 10) || 0;
      var dialogHeight = get$b(dialog) + dialogTopMargin + dialogBottomMargin;
      var chromeHeight = dialogHeight - currentTabHeight;
      return maxHeight - chromeHeight;
    };
    var showTab = function (allTabs, comp) {
      head(allTabs).each(function (tab) {
        return TabSection.showTab(comp, tab.value);
      });
    };
    var setTabviewHeight = function (tabview, height) {
      set$7(tabview, 'height', height + 'px');
      if (!detect$1().browser.isIE()) {
        set$7(tabview, 'flex-basis', height + 'px');
      } else {
        remove$6(tabview, 'flex-basis');
      }
    };
    var updateTabviewHeight = function (dialogBody, tabview, maxTabHeight) {
      ancestor(dialogBody, '[role="dialog"]').each(function (dialog) {
        descendant(dialog, '[role="tablist"]').each(function (tablist) {
          maxTabHeight.get().map(function (height) {
            set$7(tabview, 'height', '0');
            set$7(tabview, 'flex-basis', '0');
            return Math.min(height, getMaxTabviewHeight(dialog, tabview, tablist));
          }).each(function (height) {
            setTabviewHeight(tabview, height);
          });
        });
      });
    };
    var getTabview = function (dialog) {
      return descendant(dialog, '[role="tabpanel"]');
    };
    var setMode = function (allTabs) {
      var smartTabHeight = function () {
        var maxTabHeight = value$1();
        var extraEvents = [
          runOnAttached(function (comp) {
            var dialog = comp.element;
            getTabview(dialog).each(function (tabview) {
              set$7(tabview, 'visibility', 'hidden');
              comp.getSystem().getByDom(tabview).toOptional().each(function (tabviewComp) {
                var heights = measureHeights(allTabs, tabview, tabviewComp);
                var maxTabHeightOpt = getMaxHeight(heights);
                maxTabHeightOpt.fold(maxTabHeight.clear, maxTabHeight.set);
              });
              updateTabviewHeight(dialog, tabview, maxTabHeight);
              remove$6(tabview, 'visibility');
              showTab(allTabs, comp);
              global$f.requestAnimationFrame(function () {
                updateTabviewHeight(dialog, tabview, maxTabHeight);
              });
            });
          }),
          run$1(windowResize(), function (comp) {
            var dialog = comp.element;
            getTabview(dialog).each(function (tabview) {
              updateTabviewHeight(dialog, tabview, maxTabHeight);
            });
          }),
          run$1(formResizeEvent, function (comp, _se) {
            var dialog = comp.element;
            getTabview(dialog).each(function (tabview) {
              var oldFocus = active(getRootNode(tabview));
              set$7(tabview, 'visibility', 'hidden');
              var oldHeight = getRaw(tabview, 'height').map(function (h) {
                return parseInt(h, 10);
              });
              remove$6(tabview, 'height');
              remove$6(tabview, 'flex-basis');
              var newHeight = tabview.dom.getBoundingClientRect().height;
              var hasGrown = oldHeight.forall(function (h) {
                return newHeight > h;
              });
              if (hasGrown) {
                maxTabHeight.set(newHeight);
                updateTabviewHeight(dialog, tabview, maxTabHeight);
              } else {
                oldHeight.each(function (h) {
                  setTabviewHeight(tabview, h);
                });
              }
              remove$6(tabview, 'visibility');
              oldFocus.each(focus$3);
            });
          })
        ];
        var selectFirst = false;
        return {
          extraEvents: extraEvents,
          selectFirst: selectFirst
        };
      }();
      var naiveTabHeight = function () {
        var extraEvents = [];
        var selectFirst = true;
        return {
          extraEvents: extraEvents,
          selectFirst: selectFirst
        };
      }();
      return {
        smartTabHeight: smartTabHeight,
        naiveTabHeight: naiveTabHeight
      };
    };

    var SendDataToSectionChannel = 'send-data-to-section';
    var SendDataToViewChannel = 'send-data-to-view';
    var renderTabPanel = function (spec, backstage) {
      var storedValue = Cell({});
      var updateDataWithForm = function (form) {
        var formData = Representing.getValue(form);
        var validData = toValidValues(formData).getOr({});
        var currentData = storedValue.get();
        var newData = deepMerge(currentData, validData);
        storedValue.set(newData);
      };
      var setDataOnForm = function (form) {
        var tabData = storedValue.get();
        Representing.setValue(form, tabData);
      };
      var oldTab = Cell(null);
      var allTabs = map$2(spec.tabs, function (tab) {
        return {
          value: tab.name,
          dom: {
            tag: 'div',
            classes: ['tox-dialog__body-nav-item'],
            innerHtml: backstage.shared.providers.translate(tab.title)
          },
          view: function () {
            return [Form.sketch(function (parts) {
                return {
                  dom: {
                    tag: 'div',
                    classes: ['tox-form']
                  },
                  components: map$2(tab.items, function (item) {
                    return interpretInForm(parts, item, backstage);
                  }),
                  formBehaviours: derive$1([
                    Keying.config({
                      mode: 'acyclic',
                      useTabstopAt: not(isPseudoStop)
                    }),
                    config('TabView.form.events', [
                      runOnAttached(setDataOnForm),
                      runOnDetached(updateDataWithForm)
                    ]),
                    Receiving.config({
                      channels: wrapAll([
                        {
                          key: SendDataToSectionChannel,
                          value: { onReceive: updateDataWithForm }
                        },
                        {
                          key: SendDataToViewChannel,
                          value: { onReceive: setDataOnForm }
                        }
                      ])
                    })
                  ])
                };
              })];
          }
        };
      });
      var tabMode = setMode(allTabs).smartTabHeight;
      return TabSection.sketch({
        dom: {
          tag: 'div',
          classes: ['tox-dialog__body']
        },
        onChangeTab: function (section, button, _viewItems) {
          var name = Representing.getValue(button);
          emitWith(section, formTabChangeEvent, {
            name: name,
            oldName: oldTab.get()
          });
          oldTab.set(name);
        },
        tabs: allTabs,
        components: [
          TabSection.parts.tabbar({
            dom: {
              tag: 'div',
              classes: ['tox-dialog__body-nav']
            },
            components: [Tabbar.parts.tabs({})],
            markers: {
              tabClass: 'tox-tab',
              selectedClass: 'tox-dialog__body-nav-item--active'
            },
            tabbarBehaviours: derive$1([Tabstopping.config({})])
          }),
          TabSection.parts.tabview({
            dom: {
              tag: 'div',
              classes: ['tox-dialog__body-content']
            }
          })
        ],
        selectFirst: tabMode.selectFirst,
        tabSectionBehaviours: derive$1([
          config('tabpanel', tabMode.extraEvents),
          Keying.config({ mode: 'acyclic' }),
          Composing.config({
            find: function (comp) {
              return head(TabSection.getViewItems(comp));
            }
          }),
          Representing.config({
            store: {
              mode: 'manual',
              getValue: function (tsection) {
                tsection.getSystem().broadcastOn([SendDataToSectionChannel], {});
                return storedValue.get();
              },
              setValue: function (tsection, value) {
                storedValue.set(value);
                tsection.getSystem().broadcastOn([SendDataToViewChannel], {});
              }
            }
          })
        ])
      });
    };

    var dialogChannel = generate$6('update-dialog');
    var titleChannel = generate$6('update-title');
    var bodyChannel = generate$6('update-body');
    var footerChannel = generate$6('update-footer');
    var bodySendMessageChannel = generate$6('body-send-message');

    var renderBody = function (spec, id, backstage, ariaAttrs) {
      var renderComponents = function (incoming) {
        switch (incoming.body.type) {
        case 'tabpanel': {
            return [renderTabPanel(incoming.body, backstage)];
          }
        default: {
            return [renderBodyPanel(incoming.body, backstage)];
          }
        }
      };
      var updateState = function (_comp, incoming) {
        return Optional.some({
          isTabPanel: function () {
            return incoming.body.type === 'tabpanel';
          }
        });
      };
      var ariaAttributes = { 'aria-live': 'polite' };
      return {
        dom: {
          tag: 'div',
          classes: ['tox-dialog__content-js'],
          attributes: __assign(__assign({}, id.map(function (x) {
            return { id: x };
          }).getOr({})), ariaAttrs ? ariaAttributes : {})
        },
        components: [],
        behaviours: derive$1([
          ComposingConfigs.childAt(0),
          Reflecting.config({
            channel: bodyChannel,
            updateState: updateState,
            renderComponents: renderComponents,
            initialData: spec
          })
        ])
      };
    };
    var renderInlineBody = function (spec, contentId, backstage, ariaAttrs) {
      return renderBody(spec, Optional.some(contentId), backstage, ariaAttrs);
    };
    var renderModalBody = function (spec, backstage) {
      var bodySpec = renderBody(spec, Optional.none(), backstage, false);
      return ModalDialog.parts.body(bodySpec);
    };
    var renderIframeBody = function (spec) {
      var bodySpec = {
        dom: {
          tag: 'div',
          classes: ['tox-dialog__content-js']
        },
        components: [{
            dom: {
              tag: 'div',
              classes: ['tox-dialog__body-iframe']
            },
            components: [craft({
                dom: {
                  tag: 'iframe',
                  attributes: { src: spec.url }
                },
                behaviours: derive$1([
                  Tabstopping.config({}),
                  Focusing.config({})
                ])
              })]
          }],
        behaviours: derive$1([Keying.config({
            mode: 'acyclic',
            useTabstopAt: not(isPseudoStop)
          })])
      };
      return ModalDialog.parts.body(bodySpec);
    };

    var isTouch = global$9.deviceType.isTouch();
    var hiddenHeader = function (title, close) {
      return {
        dom: {
          tag: 'div',
          styles: { display: 'none' },
          classes: ['tox-dialog__header']
        },
        components: [
          title,
          close
        ]
      };
    };
    var pClose = function (onClose, providersBackstage) {
      return ModalDialog.parts.close(Button.sketch({
        dom: {
          tag: 'button',
          classes: [
            'tox-button',
            'tox-button--icon',
            'tox-button--naked'
          ],
          attributes: {
            'type': 'button',
            'aria-label': providersBackstage.translate('Close')
          }
        },
        action: onClose,
        buttonBehaviours: derive$1([Tabstopping.config({})])
      }));
    };
    var pUntitled = function () {
      return ModalDialog.parts.title({
        dom: {
          tag: 'div',
          classes: ['tox-dialog__title'],
          innerHtml: '',
          styles: { display: 'none' }
        }
      });
    };
    var pBodyMessage = function (message, providersBackstage) {
      return ModalDialog.parts.body({
        dom: {
          tag: 'div',
          classes: ['tox-dialog__body']
        },
        components: [{
            dom: {
              tag: 'div',
              classes: ['tox-dialog__body-content']
            },
            components: [{ dom: fromHtml('<p>' + providersBackstage.translate(message) + '</p>') }]
          }]
      });
    };
    var pFooter = function (buttons) {
      return ModalDialog.parts.footer({
        dom: {
          tag: 'div',
          classes: ['tox-dialog__footer']
        },
        components: buttons
      });
    };
    var pFooterGroup = function (startButtons, endButtons) {
      return [
        Container.sketch({
          dom: {
            tag: 'div',
            classes: ['tox-dialog__footer-start']
          },
          components: startButtons
        }),
        Container.sketch({
          dom: {
            tag: 'div',
            classes: ['tox-dialog__footer-end']
          },
          components: endButtons
        })
      ];
    };
    var renderDialog$1 = function (spec) {
      var _a;
      var dialogClass = 'tox-dialog';
      var blockerClass = dialogClass + '-wrap';
      var blockerBackdropClass = blockerClass + '__backdrop';
      var scrollLockClass = dialogClass + '__disable-scroll';
      return ModalDialog.sketch({
        lazySink: spec.lazySink,
        onEscape: function (comp) {
          spec.onEscape(comp);
          return Optional.some(true);
        },
        useTabstopAt: function (elem) {
          return !isPseudoStop(elem);
        },
        dom: {
          tag: 'div',
          classes: [dialogClass].concat(spec.extraClasses),
          styles: __assign({ position: 'relative' }, spec.extraStyles)
        },
        components: __spreadArray([
          spec.header,
          spec.body
        ], spec.footer.toArray(), true),
        parts: {
          blocker: {
            dom: fromHtml('<div class="' + blockerClass + '"></div>'),
            components: [{
                dom: {
                  tag: 'div',
                  classes: isTouch ? [
                    blockerBackdropClass,
                    blockerBackdropClass + '--opaque'
                  ] : [blockerBackdropClass]
                }
              }]
          }
        },
        dragBlockClass: blockerClass,
        modalBehaviours: derive$1(__spreadArray([
          Focusing.config({}),
          config('dialog-events', spec.dialogEvents.concat([runOnSource(focusin(), function (comp, _se) {
              Keying.focusIn(comp);
            })])),
          config('scroll-lock', [
            runOnAttached(function () {
              add$2(body(), scrollLockClass);
            }),
            runOnDetached(function () {
              remove$2(body(), scrollLockClass);
            })
          ])
        ], spec.extraBehaviours, true)),
        eventOrder: __assign((_a = {}, _a[execute$5()] = ['dialog-events'], _a[attachedToDom()] = [
          'scroll-lock',
          'dialog-events',
          'alloy.base.behaviour'
        ], _a[detachedFromDom()] = [
          'alloy.base.behaviour',
          'dialog-events',
          'scroll-lock'
        ], _a), spec.eventOrder)
      });
    };

    var renderClose = function (providersBackstage) {
      return Button.sketch({
        dom: {
          tag: 'button',
          classes: [
            'tox-button',
            'tox-button--icon',
            'tox-button--naked'
          ],
          attributes: {
            'type': 'button',
            'aria-label': providersBackstage.translate('Close'),
            'title': providersBackstage.translate('Close')
          }
        },
        components: [render$3('close', {
            tag: 'div',
            classes: ['tox-icon']
          }, providersBackstage.icons)],
        action: function (comp) {
          emit(comp, formCancelEvent);
        }
      });
    };
    var renderTitle = function (spec, id, providersBackstage) {
      var renderComponents = function (data) {
        return [text(providersBackstage.translate(data.title))];
      };
      return {
        dom: {
          tag: 'div',
          classes: ['tox-dialog__title'],
          attributes: __assign({}, id.map(function (x) {
            return { id: x };
          }).getOr({}))
        },
        components: renderComponents(spec),
        behaviours: derive$1([Reflecting.config({
            channel: titleChannel,
            renderComponents: renderComponents
          })])
      };
    };
    var renderDragHandle = function () {
      return { dom: fromHtml('<div class="tox-dialog__draghandle"></div>') };
    };
    var renderInlineHeader = function (spec, titleId, providersBackstage) {
      return Container.sketch({
        dom: fromHtml('<div class="tox-dialog__header"></div>'),
        components: [
          renderTitle(spec, Optional.some(titleId), providersBackstage),
          renderDragHandle(),
          renderClose(providersBackstage)
        ],
        containerBehaviours: derive$1([Dragging.config({
            mode: 'mouse',
            blockerClass: 'blocker',
            getTarget: function (handle) {
              return closest$1(handle, '[role="dialog"]').getOrDie();
            },
            snaps: {
              getSnapPoints: function () {
                return [];
              },
              leftAttr: 'data-drag-left',
              topAttr: 'data-drag-top'
            }
          })])
      });
    };
    var renderModalHeader = function (spec, providersBackstage) {
      var pTitle = ModalDialog.parts.title(renderTitle(spec, Optional.none(), providersBackstage));
      var pHandle = ModalDialog.parts.draghandle(renderDragHandle());
      var pClose = ModalDialog.parts.close(renderClose(providersBackstage));
      var components = [pTitle].concat(spec.draggable ? [pHandle] : []).concat([pClose]);
      return Container.sketch({
        dom: fromHtml('<div class="tox-dialog__header"></div>'),
        components: components
      });
    };

    var getHeader = function (title, backstage) {
      return renderModalHeader({
        title: backstage.shared.providers.translate(title),
        draggable: backstage.dialog.isDraggableModal()
      }, backstage.shared.providers);
    };
    var getBusySpec = function (message, bs, providers) {
      return {
        dom: {
          tag: 'div',
          classes: ['tox-dialog__busy-spinner'],
          attributes: { 'aria-label': providers.translate(message) },
          styles: {
            left: '0px',
            right: '0px',
            bottom: '0px',
            top: '0px',
            position: 'absolute'
          }
        },
        behaviours: bs,
        components: [{ dom: fromHtml('<div class="tox-spinner"><div></div><div></div><div></div></div>') }]
      };
    };
    var getEventExtras = function (lazyDialog, providers, extra) {
      return {
        onClose: function () {
          return extra.closeWindow();
        },
        onBlock: function (blockEvent) {
          ModalDialog.setBusy(lazyDialog(), function (_comp, bs) {
            return getBusySpec(blockEvent.message, bs, providers);
          });
        },
        onUnblock: function () {
          ModalDialog.setIdle(lazyDialog());
        }
      };
    };
    var renderModalDialog = function (spec, initialData, dialogEvents, backstage) {
      var _a;
      var updateState = function (_comp, incoming) {
        return Optional.some(incoming);
      };
      return build$1(renderDialog$1(__assign(__assign({}, spec), {
        lazySink: backstage.shared.getSink,
        extraBehaviours: __spreadArray([
          Reflecting.config({
            channel: dialogChannel,
            updateState: updateState,
            initialData: initialData
          }),
          RepresentingConfigs.memory({})
        ], spec.extraBehaviours, true),
        onEscape: function (comp) {
          emit(comp, formCancelEvent);
        },
        dialogEvents: dialogEvents,
        eventOrder: (_a = {}, _a[receive()] = [
          Reflecting.name(),
          Receiving.name()
        ], _a[attachedToDom()] = [
          'scroll-lock',
          Reflecting.name(),
          'messages',
          'dialog-events',
          'alloy.base.behaviour'
        ], _a[detachedFromDom()] = [
          'alloy.base.behaviour',
          'dialog-events',
          'messages',
          Reflecting.name(),
          'scroll-lock'
        ], _a)
      })));
    };
    var mapMenuButtons = function (buttons) {
      var mapItems = function (button) {
        var items = map$2(button.items, function (item) {
          var cell = Cell(false);
          return __assign(__assign({}, item), { storage: cell });
        });
        return __assign(__assign({}, button), { items: items });
      };
      return map$2(buttons, function (button) {
        if (button.type === 'menu') {
          return mapItems(button);
        }
        return button;
      });
    };
    var extractCellsToObject = function (buttons) {
      return foldl(buttons, function (acc, button) {
        if (button.type === 'menu') {
          var menuButton = button;
          return foldl(menuButton.items, function (innerAcc, item) {
            innerAcc[item.name] = item.storage;
            return innerAcc;
          }, acc);
        }
        return acc;
      }, {});
    };

    var initCommonEvents = function (fireApiEvent, extras) {
      return [
        runWithTarget(focusin(), onFocus),
        fireApiEvent(formCloseEvent, function (_api, spec) {
          extras.onClose();
          spec.onClose();
        }),
        fireApiEvent(formCancelEvent, function (api, spec, _event, self) {
          spec.onCancel(api);
          emit(self, formCloseEvent);
        }),
        run$1(formUnblockEvent, function (_c, _se) {
          return extras.onUnblock();
        }),
        run$1(formBlockEvent, function (_c, se) {
          return extras.onBlock(se.event);
        })
      ];
    };
    var initUrlDialog = function (getInstanceApi, extras) {
      var fireApiEvent = function (eventName, f) {
        return run$1(eventName, function (c, se) {
          withSpec(c, function (spec, _c) {
            f(getInstanceApi(), spec, se.event, c);
          });
        });
      };
      var withSpec = function (c, f) {
        Reflecting.getState(c).get().each(function (currentDialog) {
          f(currentDialog, c);
        });
      };
      return __spreadArray(__spreadArray([], initCommonEvents(fireApiEvent, extras), true), [fireApiEvent(formActionEvent, function (api, spec, event) {
          spec.onAction(api, { name: event.name });
        })], false);
    };
    var initDialog = function (getInstanceApi, extras, getSink) {
      var fireApiEvent = function (eventName, f) {
        return run$1(eventName, function (c, se) {
          withSpec(c, function (spec, _c) {
            f(getInstanceApi(), spec, se.event, c);
          });
        });
      };
      var withSpec = function (c, f) {
        Reflecting.getState(c).get().each(function (currentDialogInit) {
          f(currentDialogInit.internalDialog, c);
        });
      };
      return __spreadArray(__spreadArray([], initCommonEvents(fireApiEvent, extras), true), [
        fireApiEvent(formSubmitEvent, function (api, spec) {
          return spec.onSubmit(api);
        }),
        fireApiEvent(formChangeEvent, function (api, spec, event) {
          spec.onChange(api, { name: event.name });
        }),
        fireApiEvent(formActionEvent, function (api, spec, event, component) {
          var focusIn = function () {
            return Keying.focusIn(component);
          };
          var isDisabled = function (focused) {
            return has$1(focused, 'disabled') || getOpt(focused, 'aria-disabled').exists(function (val) {
              return val === 'true';
            });
          };
          var rootNode = getRootNode(component.element);
          var current = active(rootNode);
          spec.onAction(api, {
            name: event.name,
            value: event.value
          });
          active(rootNode).fold(focusIn, function (focused) {
            if (isDisabled(focused)) {
              focusIn();
            } else if (current.exists(function (cur) {
                return contains(focused, cur) && isDisabled(cur);
              })) {
              focusIn();
            } else {
              getSink().toOptional().filter(function (sink) {
                return !contains(sink.element, focused);
              }).each(focusIn);
            }
          });
        }),
        fireApiEvent(formTabChangeEvent, function (api, spec, event) {
          spec.onTabChange(api, {
            newTabName: event.name,
            oldTabName: event.oldName
          });
        }),
        runOnDetached(function (component) {
          var api = getInstanceApi();
          Representing.setValue(component, api.getData());
        })
      ], false);
    };
    var SilverDialogEvents = {
      initUrlDialog: initUrlDialog,
      initDialog: initDialog
    };

    var makeButton = function (button, backstage) {
      return renderFooterButton(button, button.type, backstage);
    };
    var lookup = function (compInSystem, footerButtons, buttonName) {
      return find$5(footerButtons, function (button) {
        return button.name === buttonName;
      }).bind(function (memButton) {
        return memButton.memento.getOpt(compInSystem);
      });
    };
    var renderComponents = function (_data, state) {
      var footerButtons = state.map(function (s) {
        return s.footerButtons;
      }).getOr([]);
      var buttonGroups = partition$3(footerButtons, function (button) {
        return button.align === 'start';
      });
      var makeGroup = function (edge, buttons) {
        return Container.sketch({
          dom: {
            tag: 'div',
            classes: ['tox-dialog__footer-' + edge]
          },
          components: map$2(buttons, function (button) {
            return button.memento.asSpec();
          })
        });
      };
      var startButtons = makeGroup('start', buttonGroups.pass);
      var endButtons = makeGroup('end', buttonGroups.fail);
      return [
        startButtons,
        endButtons
      ];
    };
    var renderFooter = function (initSpec, backstage) {
      var updateState = function (_comp, data) {
        var footerButtons = map$2(data.buttons, function (button) {
          var memButton = record(makeButton(button, backstage));
          return {
            name: button.name,
            align: button.align,
            memento: memButton
          };
        });
        var lookupByName = function (compInSystem, buttonName) {
          return lookup(compInSystem, footerButtons, buttonName);
        };
        return Optional.some({
          lookupByName: lookupByName,
          footerButtons: footerButtons
        });
      };
      return {
        dom: fromHtml('<div class="tox-dialog__footer"></div>'),
        components: [],
        behaviours: derive$1([Reflecting.config({
            channel: footerChannel,
            initialData: initSpec,
            updateState: updateState,
            renderComponents: renderComponents
          })])
      };
    };
    var renderInlineFooter = function (initSpec, backstage) {
      return renderFooter(initSpec, backstage);
    };
    var renderModalFooter = function (initSpec, backstage) {
      return ModalDialog.parts.footer(renderFooter(initSpec, backstage));
    };

    var getCompByName = function (access, name) {
      var root = access.getRoot();
      if (root.getSystem().isConnected()) {
        var form_1 = Composing.getCurrent(access.getFormWrapper()).getOr(access.getFormWrapper());
        return Form.getField(form_1, name).fold(function () {
          var footer = access.getFooter();
          var footerState = Reflecting.getState(footer);
          return footerState.get().bind(function (f) {
            return f.lookupByName(form_1, name);
          });
        }, function (comp) {
          return Optional.some(comp);
        });
      } else {
        return Optional.none();
      }
    };
    var validateData$1 = function (access, data) {
      var root = access.getRoot();
      return Reflecting.getState(root).get().map(function (dialogState) {
        return getOrDie(asRaw('data', dialogState.dataValidator, data));
      }).getOr(data);
    };
    var getDialogApi = function (access, doRedial, menuItemStates) {
      var withRoot = function (f) {
        var root = access.getRoot();
        if (root.getSystem().isConnected()) {
          f(root);
        }
      };
      var getData = function () {
        var root = access.getRoot();
        var valueComp = root.getSystem().isConnected() ? access.getFormWrapper() : root;
        var representedValues = Representing.getValue(valueComp);
        var menuItemCurrentState = map$1(menuItemStates, function (cell) {
          return cell.get();
        });
        return __assign(__assign({}, representedValues), menuItemCurrentState);
      };
      var setData = function (newData) {
        withRoot(function (_) {
          var prevData = instanceApi.getData();
          var mergedData = __assign(__assign({}, prevData), newData);
          var newInternalData = validateData$1(access, mergedData);
          var form = access.getFormWrapper();
          Representing.setValue(form, newInternalData);
          each(menuItemStates, function (v, k) {
            if (has$2(mergedData, k)) {
              v.set(mergedData[k]);
            }
          });
        });
      };
      var disable = function (name) {
        getCompByName(access, name).each(Disabling.disable);
      };
      var enable = function (name) {
        getCompByName(access, name).each(Disabling.enable);
      };
      var focus = function (name) {
        getCompByName(access, name).each(Focusing.focus);
      };
      var block = function (message) {
        if (!isString(message)) {
          throw new Error('The dialogInstanceAPI.block function should be passed a blocking message of type string as an argument');
        }
        withRoot(function (root) {
          emitWith(root, formBlockEvent, { message: message });
        });
      };
      var unblock = function () {
        withRoot(function (root) {
          emit(root, formUnblockEvent);
        });
      };
      var showTab = function (name) {
        withRoot(function (_) {
          var body = access.getBody();
          var bodyState = Reflecting.getState(body);
          if (bodyState.get().exists(function (b) {
              return b.isTabPanel();
            })) {
            Composing.getCurrent(body).each(function (tabSection) {
              TabSection.showTab(tabSection, name);
            });
          }
        });
      };
      var redial = function (d) {
        withRoot(function (root) {
          var dialogInit = doRedial(d);
          root.getSystem().broadcastOn([dialogChannel], dialogInit);
          root.getSystem().broadcastOn([titleChannel], dialogInit.internalDialog);
          root.getSystem().broadcastOn([bodyChannel], dialogInit.internalDialog);
          root.getSystem().broadcastOn([footerChannel], dialogInit.internalDialog);
          instanceApi.setData(dialogInit.initialData);
        });
      };
      var close = function () {
        withRoot(function (root) {
          emit(root, formCloseEvent);
        });
      };
      var instanceApi = {
        getData: getData,
        setData: setData,
        disable: disable,
        enable: enable,
        focus: focus,
        block: block,
        unblock: unblock,
        showTab: showTab,
        redial: redial,
        close: close
      };
      return instanceApi;
    };

    var getDialogSizeClasses = function (size) {
      switch (size) {
      case 'large':
        return ['tox-dialog--width-lg'];
      case 'medium':
        return ['tox-dialog--width-md'];
      default:
        return [];
      }
    };
    var renderDialog = function (dialogInit, extra, backstage) {
      var header = getHeader(dialogInit.internalDialog.title, backstage);
      var body = renderModalBody({ body: dialogInit.internalDialog.body }, backstage);
      var storagedMenuButtons = mapMenuButtons(dialogInit.internalDialog.buttons);
      var objOfCells = extractCellsToObject(storagedMenuButtons);
      var footer = renderModalFooter({ buttons: storagedMenuButtons }, backstage);
      var dialogEvents = SilverDialogEvents.initDialog(function () {
        return instanceApi;
      }, getEventExtras(function () {
        return dialog;
      }, backstage.shared.providers, extra), backstage.shared.getSink);
      var dialogSize = getDialogSizeClasses(dialogInit.internalDialog.size);
      var spec = {
        header: header,
        body: body,
        footer: Optional.some(footer),
        extraClasses: dialogSize,
        extraBehaviours: [],
        extraStyles: {}
      };
      var dialog = renderModalDialog(spec, dialogInit, dialogEvents, backstage);
      var modalAccess = function () {
        var getForm = function () {
          var outerForm = ModalDialog.getBody(dialog);
          return Composing.getCurrent(outerForm).getOr(outerForm);
        };
        return {
          getRoot: constant$1(dialog),
          getBody: function () {
            return ModalDialog.getBody(dialog);
          },
          getFooter: function () {
            return ModalDialog.getFooter(dialog);
          },
          getFormWrapper: getForm
        };
      }();
      var instanceApi = getDialogApi(modalAccess, extra.redial, objOfCells);
      return {
        dialog: dialog,
        instanceApi: instanceApi
      };
    };

    var renderInlineDialog = function (dialogInit, extra, backstage, ariaAttrs) {
      var _a, _b;
      var dialogLabelId = generate$6('dialog-label');
      var dialogContentId = generate$6('dialog-content');
      var updateState = function (_comp, incoming) {
        return Optional.some(incoming);
      };
      var memHeader = record(renderInlineHeader({
        title: dialogInit.internalDialog.title,
        draggable: true
      }, dialogLabelId, backstage.shared.providers));
      var memBody = record(renderInlineBody({ body: dialogInit.internalDialog.body }, dialogContentId, backstage, ariaAttrs));
      var storagedMenuButtons = mapMenuButtons(dialogInit.internalDialog.buttons);
      var objOfCells = extractCellsToObject(storagedMenuButtons);
      var memFooter = record(renderInlineFooter({ buttons: storagedMenuButtons }, backstage));
      var dialogEvents = SilverDialogEvents.initDialog(function () {
        return instanceApi;
      }, {
        onBlock: function (event) {
          Blocking.block(dialog, function (_comp, bs) {
            return getBusySpec(event.message, bs, backstage.shared.providers);
          });
        },
        onUnblock: function () {
          Blocking.unblock(dialog);
        },
        onClose: function () {
          return extra.closeWindow();
        }
      }, backstage.shared.getSink);
      var dialog = build$1({
        dom: {
          tag: 'div',
          classes: [
            'tox-dialog',
            'tox-dialog-inline'
          ],
          attributes: (_a = { role: 'dialog' }, _a['aria-labelledby'] = dialogLabelId, _a['aria-describedby'] = dialogContentId, _a)
        },
        eventOrder: (_b = {}, _b[receive()] = [
          Reflecting.name(),
          Receiving.name()
        ], _b[execute$5()] = ['execute-on-form'], _b[attachedToDom()] = [
          'reflecting',
          'execute-on-form'
        ], _b),
        behaviours: derive$1([
          Keying.config({
            mode: 'cyclic',
            onEscape: function (c) {
              emit(c, formCloseEvent);
              return Optional.some(true);
            },
            useTabstopAt: function (elem) {
              return !isPseudoStop(elem) && (name$2(elem) !== 'button' || get$d(elem, 'disabled') !== 'disabled');
            }
          }),
          Reflecting.config({
            channel: dialogChannel,
            updateState: updateState,
            initialData: dialogInit
          }),
          Focusing.config({}),
          config('execute-on-form', dialogEvents.concat([runOnSource(focusin(), function (comp, _se) {
              Keying.focusIn(comp);
            })])),
          Blocking.config({
            getRoot: function () {
              return Optional.some(dialog);
            }
          }),
          Replacing.config({}),
          RepresentingConfigs.memory({})
        ]),
        components: [
          memHeader.asSpec(),
          memBody.asSpec(),
          memFooter.asSpec()
        ]
      });
      var instanceApi = getDialogApi({
        getRoot: constant$1(dialog),
        getFooter: function () {
          return memFooter.get(dialog);
        },
        getBody: function () {
          return memBody.get(dialog);
        },
        getFormWrapper: function () {
          var body = memBody.get(dialog);
          return Composing.getCurrent(body).getOr(body);
        }
      }, extra.redial, objOfCells);
      return {
        dialog: dialog,
        instanceApi: instanceApi
      };
    };

    var global$1 = tinymce.util.Tools.resolve('tinymce.util.URI');

    var getUrlDialogApi = function (root) {
      var withRoot = function (f) {
        if (root.getSystem().isConnected()) {
          f(root);
        }
      };
      var block = function (message) {
        if (!isString(message)) {
          throw new Error('The urlDialogInstanceAPI.block function should be passed a blocking message of type string as an argument');
        }
        withRoot(function (root) {
          emitWith(root, formBlockEvent, { message: message });
        });
      };
      var unblock = function () {
        withRoot(function (root) {
          emit(root, formUnblockEvent);
        });
      };
      var close = function () {
        withRoot(function (root) {
          emit(root, formCloseEvent);
        });
      };
      var sendMessage = function (data) {
        withRoot(function (root) {
          root.getSystem().broadcastOn([bodySendMessageChannel], data);
        });
      };
      return {
        block: block,
        unblock: unblock,
        close: close,
        sendMessage: sendMessage
      };
    };

    var SUPPORTED_MESSAGE_ACTIONS = [
      'insertContent',
      'setContent',
      'execCommand',
      'close',
      'block',
      'unblock'
    ];
    var isSupportedMessage = function (data) {
      return isObject(data) && SUPPORTED_MESSAGE_ACTIONS.indexOf(data.mceAction) !== -1;
    };
    var isCustomMessage = function (data) {
      return !isSupportedMessage(data) && isObject(data) && has$2(data, 'mceAction');
    };
    var handleMessage = function (editor, api, data) {
      switch (data.mceAction) {
      case 'insertContent':
        editor.insertContent(data.content);
        break;
      case 'setContent':
        editor.setContent(data.content);
        break;
      case 'execCommand':
        var ui = isBoolean(data.ui) ? data.ui : false;
        editor.execCommand(data.cmd, ui, data.value);
        break;
      case 'close':
        api.close();
        break;
      case 'block':
        api.block(data.message);
        break;
      case 'unblock':
        api.unblock();
        break;
      }
    };
    var renderUrlDialog = function (internalDialog, extra, editor, backstage) {
      var _a;
      var header = getHeader(internalDialog.title, backstage);
      var body = renderIframeBody(internalDialog);
      var footer = internalDialog.buttons.bind(function (buttons) {
        if (buttons.length === 0) {
          return Optional.none();
        } else {
          return Optional.some(renderModalFooter({ buttons: buttons }, backstage));
        }
      });
      var dialogEvents = SilverDialogEvents.initUrlDialog(function () {
        return instanceApi;
      }, getEventExtras(function () {
        return dialog;
      }, backstage.shared.providers, extra));
      var styles = __assign(__assign({}, internalDialog.height.fold(function () {
        return {};
      }, function (height) {
        return {
          'height': height + 'px',
          'max-height': height + 'px'
        };
      })), internalDialog.width.fold(function () {
        return {};
      }, function (width) {
        return {
          'width': width + 'px',
          'max-width': width + 'px'
        };
      }));
      var classes = internalDialog.width.isNone() && internalDialog.height.isNone() ? ['tox-dialog--width-lg'] : [];
      var iframeUri = new global$1(internalDialog.url, { base_uri: new global$1(window.location.href) });
      var iframeDomain = iframeUri.protocol + '://' + iframeUri.host + (iframeUri.port ? ':' + iframeUri.port : '');
      var messageHandlerUnbinder = unbindable();
      var extraBehaviours = [
        config('messages', [
          runOnAttached(function () {
            var unbind = bind(SugarElement.fromDom(window), 'message', function (e) {
              if (iframeUri.isSameOrigin(new global$1(e.raw.origin))) {
                var data = e.raw.data;
                if (isSupportedMessage(data)) {
                  handleMessage(editor, instanceApi, data);
                } else if (isCustomMessage(data)) {
                  internalDialog.onMessage(instanceApi, data);
                }
              }
            });
            messageHandlerUnbinder.set(unbind);
          }),
          runOnDetached(messageHandlerUnbinder.clear)
        ]),
        Receiving.config({
          channels: (_a = {}, _a[bodySendMessageChannel] = {
            onReceive: function (comp, data) {
              descendant(comp.element, 'iframe').each(function (iframeEle) {
                var iframeWin = iframeEle.dom.contentWindow;
                iframeWin.postMessage(data, iframeDomain);
              });
            }
          }, _a)
        })
      ];
      var spec = {
        header: header,
        body: body,
        footer: footer,
        extraClasses: classes,
        extraBehaviours: extraBehaviours,
        extraStyles: styles
      };
      var dialog = renderModalDialog(spec, internalDialog, dialogEvents, backstage);
      var instanceApi = getUrlDialogApi(dialog);
      return {
        dialog: dialog,
        instanceApi: instanceApi
      };
    };

    var setup$2 = function (extras) {
      var sharedBackstage = extras.backstage.shared;
      var open = function (message, callback) {
        var closeDialog = function () {
          ModalDialog.hide(alertDialog);
          callback();
        };
        var memFooterClose = record(renderFooterButton({
          name: 'close-alert',
          text: 'OK',
          primary: true,
          align: 'end',
          disabled: false,
          icon: Optional.none()
        }, 'cancel', extras.backstage));
        var titleSpec = pUntitled();
        var closeSpec = pClose(closeDialog, sharedBackstage.providers);
        var alertDialog = build$1(renderDialog$1({
          lazySink: function () {
            return sharedBackstage.getSink();
          },
          header: hiddenHeader(titleSpec, closeSpec),
          body: pBodyMessage(message, sharedBackstage.providers),
          footer: Optional.some(pFooter(pFooterGroup([], [memFooterClose.asSpec()]))),
          onEscape: closeDialog,
          extraClasses: ['tox-alert-dialog'],
          extraBehaviours: [],
          extraStyles: {},
          dialogEvents: [run$1(formCancelEvent, closeDialog)],
          eventOrder: {}
        }));
        ModalDialog.show(alertDialog);
        var footerCloseButton = memFooterClose.get(alertDialog);
        Focusing.focus(footerCloseButton);
      };
      return { open: open };
    };

    var setup$1 = function (extras) {
      var sharedBackstage = extras.backstage.shared;
      var open = function (message, callback) {
        var closeDialog = function (state) {
          ModalDialog.hide(confirmDialog);
          callback(state);
        };
        var memFooterYes = record(renderFooterButton({
          name: 'yes',
          text: 'Yes',
          primary: true,
          align: 'end',
          disabled: false,
          icon: Optional.none()
        }, 'submit', extras.backstage));
        var footerNo = renderFooterButton({
          name: 'no',
          text: 'No',
          primary: false,
          align: 'end',
          disabled: false,
          icon: Optional.none()
        }, 'cancel', extras.backstage);
        var titleSpec = pUntitled();
        var closeSpec = pClose(function () {
          return closeDialog(false);
        }, sharedBackstage.providers);
        var confirmDialog = build$1(renderDialog$1({
          lazySink: function () {
            return sharedBackstage.getSink();
          },
          header: hiddenHeader(titleSpec, closeSpec),
          body: pBodyMessage(message, sharedBackstage.providers),
          footer: Optional.some(pFooter(pFooterGroup([], [
            footerNo,
            memFooterYes.asSpec()
          ]))),
          onEscape: function () {
            return closeDialog(false);
          },
          extraClasses: ['tox-confirm-dialog'],
          extraBehaviours: [],
          extraStyles: {},
          dialogEvents: [
            run$1(formCancelEvent, function () {
              return closeDialog(false);
            }),
            run$1(formSubmitEvent, function () {
              return closeDialog(true);
            })
          ],
          eventOrder: {}
        }));
        ModalDialog.show(confirmDialog);
        var footerYesButton = memFooterYes.get(confirmDialog);
        Focusing.focus(footerYesButton);
      };
      return { open: open };
    };

    var validateData = function (data, validator) {
      return getOrDie(asRaw('data', validator, data));
    };
    var isAlertOrConfirmDialog = function (target) {
      return closest(target, '.tox-alert-dialog') || closest(target, '.tox-confirm-dialog');
    };
    var inlineAdditionalBehaviours = function (editor, isStickyToolbar, isToolbarLocationTop) {
      if (isStickyToolbar && isToolbarLocationTop) {
        return [];
      } else {
        return [Docking.config({
            contextual: {
              lazyContext: function () {
                return Optional.some(box$1(SugarElement.fromDom(editor.getContentAreaContainer())));
              },
              fadeInClass: 'tox-dialog-dock-fadein',
              fadeOutClass: 'tox-dialog-dock-fadeout',
              transitionClass: 'tox-dialog-dock-transition'
            },
            modes: ['top']
          })];
      }
    };
    var setup = function (extras) {
      var backstage = extras.backstage;
      var editor = extras.editor;
      var isStickyToolbar$1 = isStickyToolbar(editor);
      var alertDialog = setup$2(extras);
      var confirmDialog = setup$1(extras);
      var open = function (config, params, closeWindow) {
        if (params !== undefined && params.inline === 'toolbar') {
          return openInlineDialog(config, backstage.shared.anchors.inlineDialog(), closeWindow, params.ariaAttrs);
        } else if (params !== undefined && params.inline === 'cursor') {
          return openInlineDialog(config, backstage.shared.anchors.cursor(), closeWindow, params.ariaAttrs);
        } else {
          return openModalDialog(config, closeWindow);
        }
      };
      var openUrl = function (config, closeWindow) {
        return openModalUrlDialog(config, closeWindow);
      };
      var openModalUrlDialog = function (config, closeWindow) {
        var factory = function (contents) {
          var dialog = renderUrlDialog(contents, {
            closeWindow: function () {
              ModalDialog.hide(dialog.dialog);
              closeWindow(dialog.instanceApi);
            }
          }, editor, backstage);
          ModalDialog.show(dialog.dialog);
          return dialog.instanceApi;
        };
        return DialogManager.openUrl(factory, config);
      };
      var openModalDialog = function (config, closeWindow) {
        var factory = function (contents, internalInitialData, dataValidator) {
          var initialData = internalInitialData;
          var dialogInit = {
            dataValidator: dataValidator,
            initialData: initialData,
            internalDialog: contents
          };
          var dialog = renderDialog(dialogInit, {
            redial: DialogManager.redial,
            closeWindow: function () {
              ModalDialog.hide(dialog.dialog);
              closeWindow(dialog.instanceApi);
            }
          }, backstage);
          ModalDialog.show(dialog.dialog);
          dialog.instanceApi.setData(initialData);
          return dialog.instanceApi;
        };
        return DialogManager.open(factory, config);
      };
      var openInlineDialog = function (config$1, anchor, closeWindow, ariaAttrs) {
        var factory = function (contents, internalInitialData, dataValidator) {
          var initialData = validateData(internalInitialData, dataValidator);
          var inlineDialog = value$1();
          var isToolbarLocationTop = backstage.shared.header.isPositionedAtTop();
          var dialogInit = {
            dataValidator: dataValidator,
            initialData: initialData,
            internalDialog: contents
          };
          var refreshDocking = function () {
            return inlineDialog.on(function (dialog) {
              InlineView.reposition(dialog);
              Docking.refresh(dialog);
            });
          };
          var dialogUi = renderInlineDialog(dialogInit, {
            redial: DialogManager.redial,
            closeWindow: function () {
              inlineDialog.on(InlineView.hide);
              editor.off('ResizeEditor', refreshDocking);
              inlineDialog.clear();
              closeWindow(dialogUi.instanceApi);
            }
          }, backstage, ariaAttrs);
          var inlineDialogComp = build$1(InlineView.sketch(__assign(__assign({
            lazySink: backstage.shared.getSink,
            dom: {
              tag: 'div',
              classes: []
            },
            fireDismissalEventInstead: {}
          }, isToolbarLocationTop ? {} : { fireRepositionEventInstead: {} }), {
            inlineBehaviours: derive$1(__spreadArray([config('window-manager-inline-events', [run$1(dismissRequested(), function (_comp, _se) {
                  emit(dialogUi.dialog, formCancelEvent);
                })])], inlineAdditionalBehaviours(editor, isStickyToolbar$1, isToolbarLocationTop), true)),
            isExtraPart: function (_comp, target) {
              return isAlertOrConfirmDialog(target);
            }
          })));
          inlineDialog.set(inlineDialogComp);
          InlineView.showWithin(inlineDialogComp, premade(dialogUi.dialog), { anchor: anchor }, Optional.some(body()));
          if (!isStickyToolbar$1 || !isToolbarLocationTop) {
            Docking.refresh(inlineDialogComp);
            editor.on('ResizeEditor', refreshDocking);
          }
          dialogUi.instanceApi.setData(initialData);
          Keying.focusIn(dialogUi.dialog);
          return dialogUi.instanceApi;
        };
        return DialogManager.open(factory, config$1);
      };
      var confirm = function (message, callback) {
        confirmDialog.open(message, function (state) {
          callback(state);
        });
      };
      var alert = function (message, callback) {
        alertDialog.open(message, function () {
          callback();
        });
      };
      var close = function (instanceApi) {
        instanceApi.close();
      };
      return {
        open: open,
        openUrl: openUrl,
        alert: alert,
        close: close,
        confirm: confirm
      };
    };

    function Theme () {
      global$g.add('silver', function (editor) {
        var _a = setup$3(editor), uiMothership = _a.uiMothership, backstage = _a.backstage, renderUI = _a.renderUI, getUi = _a.getUi;
        Autocompleter.register(editor, backstage.shared);
        var windowMgr = setup({
          editor: editor,
          backstage: backstage
        });
        return {
          renderUI: renderUI,
          getWindowManagerImpl: constant$1(windowMgr),
          getNotificationManagerImpl: function () {
            return NotificationManagerImpl(editor, { backstage: backstage }, uiMothership);
          },
          ui: getUi()
        };
      });
    }

    Theme();

}());

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50), __webpack_require__(536).setImmediate))

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 *
 * Version: 5.10.5 (2022-05-25)
 */
(function () {
    'use strict';

    var typeOf$1 = function (x) {
      if (x === null) {
        return 'null';
      }
      if (x === undefined) {
        return 'undefined';
      }
      var t = typeof x;
      if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
        return 'array';
      }
      if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
        return 'string';
      }
      return t;
    };
    var isEquatableType = function (x) {
      return [
        'undefined',
        'boolean',
        'number',
        'string',
        'function',
        'xml',
        'null'
      ].indexOf(x) !== -1;
    };

    var sort$1 = function (xs, compareFn) {
      var clone = Array.prototype.slice.call(xs);
      return clone.sort(compareFn);
    };

    var contramap = function (eqa, f) {
      return eq$2(function (x, y) {
        return eqa.eq(f(x), f(y));
      });
    };
    var eq$2 = function (f) {
      return { eq: f };
    };
    var tripleEq = eq$2(function (x, y) {
      return x === y;
    });
    var eqString = tripleEq;
    var eqArray = function (eqa) {
      return eq$2(function (x, y) {
        if (x.length !== y.length) {
          return false;
        }
        var len = x.length;
        for (var i = 0; i < len; i++) {
          if (!eqa.eq(x[i], y[i])) {
            return false;
          }
        }
        return true;
      });
    };
    var eqSortedArray = function (eqa, compareFn) {
      return contramap(eqArray(eqa), function (xs) {
        return sort$1(xs, compareFn);
      });
    };
    var eqRecord = function (eqa) {
      return eq$2(function (x, y) {
        var kx = Object.keys(x);
        var ky = Object.keys(y);
        if (!eqSortedArray(eqString).eq(kx, ky)) {
          return false;
        }
        var len = kx.length;
        for (var i = 0; i < len; i++) {
          var q = kx[i];
          if (!eqa.eq(x[q], y[q])) {
            return false;
          }
        }
        return true;
      });
    };
    var eqAny = eq$2(function (x, y) {
      if (x === y) {
        return true;
      }
      var tx = typeOf$1(x);
      var ty = typeOf$1(y);
      if (tx !== ty) {
        return false;
      }
      if (isEquatableType(tx)) {
        return x === y;
      } else if (tx === 'array') {
        return eqArray(eqAny).eq(x, y);
      } else if (tx === 'object') {
        return eqRecord(eqAny).eq(x, y);
      }
      return false;
    });

    var typeOf = function (x) {
      var t = typeof x;
      if (x === null) {
        return 'null';
      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
        return 'array';
      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
        return 'string';
      } else {
        return t;
      }
    };
    var isType$1 = function (type) {
      return function (value) {
        return typeOf(value) === type;
      };
    };
    var isSimpleType = function (type) {
      return function (value) {
        return typeof value === type;
      };
    };
    var eq$1 = function (t) {
      return function (a) {
        return t === a;
      };
    };
    var isString$1 = isType$1('string');
    var isObject = isType$1('object');
    var isArray$1 = isType$1('array');
    var isNull = eq$1(null);
    var isBoolean = isSimpleType('boolean');
    var isUndefined = eq$1(undefined);
    var isNullable = function (a) {
      return a === null || a === undefined;
    };
    var isNonNullable = function (a) {
      return !isNullable(a);
    };
    var isFunction = isSimpleType('function');
    var isNumber = isSimpleType('number');

    var noop = function () {
    };
    var compose = function (fa, fb) {
      return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        return fa(fb.apply(null, args));
      };
    };
    var compose1 = function (fbc, fab) {
      return function (a) {
        return fbc(fab(a));
      };
    };
    var constant = function (value) {
      return function () {
        return value;
      };
    };
    var identity = function (x) {
      return x;
    };
    var tripleEquals = function (a, b) {
      return a === b;
    };
    function curry(fn) {
      var initialArgs = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        initialArgs[_i - 1] = arguments[_i];
      }
      return function () {
        var restArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          restArgs[_i] = arguments[_i];
        }
        var all = initialArgs.concat(restArgs);
        return fn.apply(null, all);
      };
    }
    var not = function (f) {
      return function (t) {
        return !f(t);
      };
    };
    var die = function (msg) {
      return function () {
        throw new Error(msg);
      };
    };
    var apply = function (f) {
      return f();
    };
    var call = function (f) {
      f();
    };
    var never = constant(false);
    var always = constant(true);

    var none = function () {
      return NONE;
    };
    var NONE = function () {
      var call = function (thunk) {
        return thunk();
      };
      var id = identity;
      var me = {
        fold: function (n, _s) {
          return n();
        },
        isSome: never,
        isNone: always,
        getOr: id,
        getOrThunk: call,
        getOrDie: function (msg) {
          throw new Error(msg || 'error: getOrDie called on none.');
        },
        getOrNull: constant(null),
        getOrUndefined: constant(undefined),
        or: id,
        orThunk: call,
        map: none,
        each: noop,
        bind: none,
        exists: never,
        forall: always,
        filter: function () {
          return none();
        },
        toArray: function () {
          return [];
        },
        toString: constant('none()')
      };
      return me;
    }();
    var some = function (a) {
      var constant_a = constant(a);
      var self = function () {
        return me;
      };
      var bind = function (f) {
        return f(a);
      };
      var me = {
        fold: function (n, s) {
          return s(a);
        },
        isSome: always,
        isNone: never,
        getOr: constant_a,
        getOrThunk: constant_a,
        getOrDie: constant_a,
        getOrNull: constant_a,
        getOrUndefined: constant_a,
        or: self,
        orThunk: self,
        map: function (f) {
          return some(f(a));
        },
        each: function (f) {
          f(a);
        },
        bind: bind,
        exists: bind,
        forall: bind,
        filter: function (f) {
          return f(a) ? me : NONE;
        },
        toArray: function () {
          return [a];
        },
        toString: function () {
          return 'some(' + a + ')';
        }
      };
      return me;
    };
    var from$1 = function (value) {
      return value === null || value === undefined ? NONE : some(value);
    };
    var Optional = {
      some: some,
      none: none,
      from: from$1
    };

    var nativeSlice = Array.prototype.slice;
    var nativeIndexOf = Array.prototype.indexOf;
    var nativePush = Array.prototype.push;
    var rawIndexOf = function (ts, t) {
      return nativeIndexOf.call(ts, t);
    };
    var indexOf$2 = function (xs, x) {
      var r = rawIndexOf(xs, x);
      return r === -1 ? Optional.none() : Optional.some(r);
    };
    var contains$3 = function (xs, x) {
      return rawIndexOf(xs, x) > -1;
    };
    var exists = function (xs, pred) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i)) {
          return true;
        }
      }
      return false;
    };
    var map$3 = function (xs, f) {
      var len = xs.length;
      var r = new Array(len);
      for (var i = 0; i < len; i++) {
        var x = xs[i];
        r[i] = f(x, i);
      }
      return r;
    };
    var each$k = function (xs, f) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        f(x, i);
      }
    };
    var eachr = function (xs, f) {
      for (var i = xs.length - 1; i >= 0; i--) {
        var x = xs[i];
        f(x, i);
      }
    };
    var partition = function (xs, pred) {
      var pass = [];
      var fail = [];
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        var arr = pred(x, i) ? pass : fail;
        arr.push(x);
      }
      return {
        pass: pass,
        fail: fail
      };
    };
    var filter$4 = function (xs, pred) {
      var r = [];
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i)) {
          r.push(x);
        }
      }
      return r;
    };
    var foldr = function (xs, f, acc) {
      eachr(xs, function (x, i) {
        acc = f(acc, x, i);
      });
      return acc;
    };
    var foldl = function (xs, f, acc) {
      each$k(xs, function (x, i) {
        acc = f(acc, x, i);
      });
      return acc;
    };
    var findUntil$1 = function (xs, pred, until) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i)) {
          return Optional.some(x);
        } else if (until(x, i)) {
          break;
        }
      }
      return Optional.none();
    };
    var find$3 = function (xs, pred) {
      return findUntil$1(xs, pred, never);
    };
    var findIndex$2 = function (xs, pred) {
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        if (pred(x, i)) {
          return Optional.some(i);
        }
      }
      return Optional.none();
    };
    var flatten = function (xs) {
      var r = [];
      for (var i = 0, len = xs.length; i < len; ++i) {
        if (!isArray$1(xs[i])) {
          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
        }
        nativePush.apply(r, xs[i]);
      }
      return r;
    };
    var bind = function (xs, f) {
      return flatten(map$3(xs, f));
    };
    var forall = function (xs, pred) {
      for (var i = 0, len = xs.length; i < len; ++i) {
        var x = xs[i];
        if (pred(x, i) !== true) {
          return false;
        }
      }
      return true;
    };
    var reverse = function (xs) {
      var r = nativeSlice.call(xs, 0);
      r.reverse();
      return r;
    };
    var difference = function (a1, a2) {
      return filter$4(a1, function (x) {
        return !contains$3(a2, x);
      });
    };
    var mapToObject = function (xs, f) {
      var r = {};
      for (var i = 0, len = xs.length; i < len; i++) {
        var x = xs[i];
        r[String(x)] = f(x, i);
      }
      return r;
    };
    var sort = function (xs, comparator) {
      var copy = nativeSlice.call(xs, 0);
      copy.sort(comparator);
      return copy;
    };
    var get$a = function (xs, i) {
      return i >= 0 && i < xs.length ? Optional.some(xs[i]) : Optional.none();
    };
    var head = function (xs) {
      return get$a(xs, 0);
    };
    var last$2 = function (xs) {
      return get$a(xs, xs.length - 1);
    };
    var from = isFunction(Array.from) ? Array.from : function (x) {
      return nativeSlice.call(x);
    };
    var findMap = function (arr, f) {
      for (var i = 0; i < arr.length; i++) {
        var r = f(arr[i], i);
        if (r.isSome()) {
          return r;
        }
      }
      return Optional.none();
    };

    var keys = Object.keys;
    var hasOwnProperty$1 = Object.hasOwnProperty;
    var each$j = function (obj, f) {
      var props = keys(obj);
      for (var k = 0, len = props.length; k < len; k++) {
        var i = props[k];
        var x = obj[i];
        f(x, i);
      }
    };
    var map$2 = function (obj, f) {
      return tupleMap(obj, function (x, i) {
        return {
          k: i,
          v: f(x, i)
        };
      });
    };
    var tupleMap = function (obj, f) {
      var r = {};
      each$j(obj, function (x, i) {
        var tuple = f(x, i);
        r[tuple.k] = tuple.v;
      });
      return r;
    };
    var objAcc = function (r) {
      return function (x, i) {
        r[i] = x;
      };
    };
    var internalFilter = function (obj, pred, onTrue, onFalse) {
      var r = {};
      each$j(obj, function (x, i) {
        (pred(x, i) ? onTrue : onFalse)(x, i);
      });
      return r;
    };
    var bifilter = function (obj, pred) {
      var t = {};
      var f = {};
      internalFilter(obj, pred, objAcc(t), objAcc(f));
      return {
        t: t,
        f: f
      };
    };
    var filter$3 = function (obj, pred) {
      var t = {};
      internalFilter(obj, pred, objAcc(t), noop);
      return t;
    };
    var mapToArray = function (obj, f) {
      var r = [];
      each$j(obj, function (value, name) {
        r.push(f(value, name));
      });
      return r;
    };
    var values = function (obj) {
      return mapToArray(obj, identity);
    };
    var get$9 = function (obj, key) {
      return has$2(obj, key) ? Optional.from(obj[key]) : Optional.none();
    };
    var has$2 = function (obj, key) {
      return hasOwnProperty$1.call(obj, key);
    };
    var hasNonNullableKey = function (obj, key) {
      return has$2(obj, key) && obj[key] !== undefined && obj[key] !== null;
    };
    var equal$1 = function (a1, a2, eq) {
      if (eq === void 0) {
        eq = eqAny;
      }
      return eqRecord(eq).eq(a1, a2);
    };

    var isArray = Array.isArray;
    var toArray$1 = function (obj) {
      if (!isArray(obj)) {
        var array = [];
        for (var i = 0, l = obj.length; i < l; i++) {
          array[i] = obj[i];
        }
        return array;
      } else {
        return obj;
      }
    };
    var each$i = function (o, cb, s) {
      var n, l;
      if (!o) {
        return false;
      }
      s = s || o;
      if (o.length !== undefined) {
        for (n = 0, l = o.length; n < l; n++) {
          if (cb.call(s, o[n], n, o) === false) {
            return false;
          }
        }
      } else {
        for (n in o) {
          if (has$2(o, n)) {
            if (cb.call(s, o[n], n, o) === false) {
              return false;
            }
          }
        }
      }
      return true;
    };
    var map$1 = function (array, callback) {
      var out = [];
      each$i(array, function (item, index) {
        out.push(callback(item, index, array));
      });
      return out;
    };
    var filter$2 = function (a, f) {
      var o = [];
      each$i(a, function (v, index) {
        if (!f || f(v, index, a)) {
          o.push(v);
        }
      });
      return o;
    };
    var indexOf$1 = function (a, v) {
      if (a) {
        for (var i = 0, l = a.length; i < l; i++) {
          if (a[i] === v) {
            return i;
          }
        }
      }
      return -1;
    };
    var reduce = function (collection, iteratee, accumulator, thisArg) {
      var acc = isUndefined(accumulator) ? collection[0] : accumulator;
      for (var i = 0; i < collection.length; i++) {
        acc = iteratee.call(thisArg, acc, collection[i], i);
      }
      return acc;
    };
    var findIndex$1 = function (array, predicate, thisArg) {
      var i, l;
      for (i = 0, l = array.length; i < l; i++) {
        if (predicate.call(thisArg, array[i], i, array)) {
          return i;
        }
      }
      return -1;
    };
    var last$1 = function (collection) {
      return collection[collection.length - 1];
    };

    var __assign = function () {
      __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };
    function __rest(s, e) {
      var t = {};
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
          t[p] = s[p];
      if (s != null && typeof Object.getOwnPropertySymbols === 'function')
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
            t[p[i]] = s[p[i]];
        }
      return t;
    }
    function __spreadArray(to, from, pack) {
      if (pack || arguments.length === 2)
        for (var i = 0, l = from.length, ar; i < l; i++) {
          if (ar || !(i in from)) {
            if (!ar)
              ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
          }
        }
      return to.concat(ar || Array.prototype.slice.call(from));
    }

    var cached = function (f) {
      var called = false;
      var r;
      return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        if (!called) {
          called = true;
          r = f.apply(null, args);
        }
        return r;
      };
    };

    var DeviceType = function (os, browser, userAgent, mediaMatch) {
      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
      var isiPhone = os.isiOS() && !isiPad;
      var isMobile = os.isiOS() || os.isAndroid();
      var isTouch = isMobile || mediaMatch('(pointer:coarse)');
      var isTablet = isiPad || !isiPhone && isMobile && mediaMatch('(min-device-width:768px)');
      var isPhone = isiPhone || isMobile && !isTablet;
      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
      var isDesktop = !isPhone && !isTablet && !iOSwebview;
      return {
        isiPad: constant(isiPad),
        isiPhone: constant(isiPhone),
        isTablet: constant(isTablet),
        isPhone: constant(isPhone),
        isTouch: constant(isTouch),
        isAndroid: os.isAndroid,
        isiOS: os.isiOS,
        isWebView: constant(iOSwebview),
        isDesktop: constant(isDesktop)
      };
    };

    var firstMatch = function (regexes, s) {
      for (var i = 0; i < regexes.length; i++) {
        var x = regexes[i];
        if (x.test(s)) {
          return x;
        }
      }
      return undefined;
    };
    var find$2 = function (regexes, agent) {
      var r = firstMatch(regexes, agent);
      if (!r) {
        return {
          major: 0,
          minor: 0
        };
      }
      var group = function (i) {
        return Number(agent.replace(r, '$' + i));
      };
      return nu$4(group(1), group(2));
    };
    var detect$3 = function (versionRegexes, agent) {
      var cleanedAgent = String(agent).toLowerCase();
      if (versionRegexes.length === 0) {
        return unknown$2();
      }
      return find$2(versionRegexes, cleanedAgent);
    };
    var unknown$2 = function () {
      return nu$4(0, 0);
    };
    var nu$4 = function (major, minor) {
      return {
        major: major,
        minor: minor
      };
    };
    var Version = {
      nu: nu$4,
      detect: detect$3,
      unknown: unknown$2
    };

    var detectBrowser$1 = function (browsers, userAgentData) {
      return findMap(userAgentData.brands, function (uaBrand) {
        var lcBrand = uaBrand.brand.toLowerCase();
        return find$3(browsers, function (browser) {
          var _a;
          return lcBrand === ((_a = browser.brand) === null || _a === void 0 ? void 0 : _a.toLowerCase());
        }).map(function (info) {
          return {
            current: info.name,
            version: Version.nu(parseInt(uaBrand.version, 10), 0)
          };
        });
      });
    };

    var detect$2 = function (candidates, userAgent) {
      var agent = String(userAgent).toLowerCase();
      return find$3(candidates, function (candidate) {
        return candidate.search(agent);
      });
    };
    var detectBrowser = function (browsers, userAgent) {
      return detect$2(browsers, userAgent).map(function (browser) {
        var version = Version.detect(browser.versionRegexes, userAgent);
        return {
          current: browser.name,
          version: version
        };
      });
    };
    var detectOs = function (oses, userAgent) {
      return detect$2(oses, userAgent).map(function (os) {
        var version = Version.detect(os.versionRegexes, userAgent);
        return {
          current: os.name,
          version: version
        };
      });
    };

    var removeFromStart = function (str, numChars) {
      return str.substring(numChars);
    };

    var checkRange = function (str, substr, start) {
      return substr === '' || str.length >= substr.length && str.substr(start, start + substr.length) === substr;
    };
    var removeLeading = function (str, prefix) {
      return startsWith(str, prefix) ? removeFromStart(str, prefix.length) : str;
    };
    var contains$2 = function (str, substr) {
      return str.indexOf(substr) !== -1;
    };
    var startsWith = function (str, prefix) {
      return checkRange(str, prefix, 0);
    };
    var blank = function (r) {
      return function (s) {
        return s.replace(r, '');
      };
    };
    var trim$4 = blank(/^\s+|\s+$/g);
    var lTrim = blank(/^\s+/g);
    var rTrim = blank(/\s+$/g);
    var isNotEmpty = function (s) {
      return s.length > 0;
    };
    var isEmpty$3 = function (s) {
      return !isNotEmpty(s);
    };

    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
    var checkContains = function (target) {
      return function (uastring) {
        return contains$2(uastring, target);
      };
    };
    var browsers = [
      {
        name: 'Edge',
        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
        search: function (uastring) {
          return contains$2(uastring, 'edge/') && contains$2(uastring, 'chrome') && contains$2(uastring, 'safari') && contains$2(uastring, 'applewebkit');
        }
      },
      {
        name: 'Chrome',
        brand: 'Chromium',
        versionRegexes: [
          /.*?chrome\/([0-9]+)\.([0-9]+).*/,
          normalVersionRegex
        ],
        search: function (uastring) {
          return contains$2(uastring, 'chrome') && !contains$2(uastring, 'chromeframe');
        }
      },
      {
        name: 'IE',
        versionRegexes: [
          /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
          /.*?rv:([0-9]+)\.([0-9]+).*/
        ],
        search: function (uastring) {
          return contains$2(uastring, 'msie') || contains$2(uastring, 'trident');
        }
      },
      {
        name: 'Opera',
        versionRegexes: [
          normalVersionRegex,
          /.*?opera\/([0-9]+)\.([0-9]+).*/
        ],
        search: checkContains('opera')
      },
      {
        name: 'Firefox',
        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
        search: checkContains('firefox')
      },
      {
        name: 'Safari',
        versionRegexes: [
          normalVersionRegex,
          /.*?cpu os ([0-9]+)_([0-9]+).*/
        ],
        search: function (uastring) {
          return (contains$2(uastring, 'safari') || contains$2(uastring, 'mobile/')) && contains$2(uastring, 'applewebkit');
        }
      }
    ];
    var oses = [
      {
        name: 'Windows',
        search: checkContains('win'),
        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
      },
      {
        name: 'iOS',
        search: function (uastring) {
          return contains$2(uastring, 'iphone') || contains$2(uastring, 'ipad');
        },
        versionRegexes: [
          /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
          /.*cpu os ([0-9]+)_([0-9]+).*/,
          /.*cpu iphone os ([0-9]+)_([0-9]+).*/
        ]
      },
      {
        name: 'Android',
        search: checkContains('android'),
        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
      },
      {
        name: 'OSX',
        search: checkContains('mac os x'),
        versionRegexes: [/.*?mac\ os\ x\ ?([0-9]+)_([0-9]+).*/]
      },
      {
        name: 'Linux',
        search: checkContains('linux'),
        versionRegexes: []
      },
      {
        name: 'Solaris',
        search: checkContains('sunos'),
        versionRegexes: []
      },
      {
        name: 'FreeBSD',
        search: checkContains('freebsd'),
        versionRegexes: []
      },
      {
        name: 'ChromeOS',
        search: checkContains('cros'),
        versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/]
      }
    ];
    var PlatformInfo = {
      browsers: constant(browsers),
      oses: constant(oses)
    };

    var edge = 'Edge';
    var chrome = 'Chrome';
    var ie$1 = 'IE';
    var opera = 'Opera';
    var firefox = 'Firefox';
    var safari = 'Safari';
    var unknown$1 = function () {
      return nu$3({
        current: undefined,
        version: Version.unknown()
      });
    };
    var nu$3 = function (info) {
      var current = info.current;
      var version = info.version;
      var isBrowser = function (name) {
        return function () {
          return current === name;
        };
      };
      return {
        current: current,
        version: version,
        isEdge: isBrowser(edge),
        isChrome: isBrowser(chrome),
        isIE: isBrowser(ie$1),
        isOpera: isBrowser(opera),
        isFirefox: isBrowser(firefox),
        isSafari: isBrowser(safari)
      };
    };
    var Browser = {
      unknown: unknown$1,
      nu: nu$3,
      edge: constant(edge),
      chrome: constant(chrome),
      ie: constant(ie$1),
      opera: constant(opera),
      firefox: constant(firefox),
      safari: constant(safari)
    };

    var windows = 'Windows';
    var ios = 'iOS';
    var android = 'Android';
    var linux = 'Linux';
    var osx = 'OSX';
    var solaris = 'Solaris';
    var freebsd = 'FreeBSD';
    var chromeos = 'ChromeOS';
    var unknown = function () {
      return nu$2({
        current: undefined,
        version: Version.unknown()
      });
    };
    var nu$2 = function (info) {
      var current = info.current;
      var version = info.version;
      var isOS = function (name) {
        return function () {
          return current === name;
        };
      };
      return {
        current: current,
        version: version,
        isWindows: isOS(windows),
        isiOS: isOS(ios),
        isAndroid: isOS(android),
        isOSX: isOS(osx),
        isLinux: isOS(linux),
        isSolaris: isOS(solaris),
        isFreeBSD: isOS(freebsd),
        isChromeOS: isOS(chromeos)
      };
    };
    var OperatingSystem = {
      unknown: unknown,
      nu: nu$2,
      windows: constant(windows),
      ios: constant(ios),
      android: constant(android),
      linux: constant(linux),
      osx: constant(osx),
      solaris: constant(solaris),
      freebsd: constant(freebsd),
      chromeos: constant(chromeos)
    };

    var detect$1 = function (userAgent, userAgentDataOpt, mediaMatch) {
      var browsers = PlatformInfo.browsers();
      var oses = PlatformInfo.oses();
      var browser = userAgentDataOpt.bind(function (userAgentData) {
        return detectBrowser$1(browsers, userAgentData);
      }).orThunk(function () {
        return detectBrowser(browsers, userAgent);
      }).fold(Browser.unknown, Browser.nu);
      var os = detectOs(oses, userAgent).fold(OperatingSystem.unknown, OperatingSystem.nu);
      var deviceType = DeviceType(os, browser, userAgent, mediaMatch);
      return {
        browser: browser,
        os: os,
        deviceType: deviceType
      };
    };
    var PlatformDetection = { detect: detect$1 };

    var mediaMatch = function (query) {
      return window.matchMedia(query).matches;
    };
    var platform$2 = cached(function () {
      return PlatformDetection.detect(navigator.userAgent, Optional.from(navigator.userAgentData), mediaMatch);
    });
    var detect = function () {
      return platform$2();
    };

    var userAgent = navigator.userAgent;
    var platform$1 = detect();
    var browser$4 = platform$1.browser;
    var os = platform$1.os;
    var deviceType = platform$1.deviceType;
    var webkit = /WebKit/.test(userAgent) && !browser$4.isEdge();
    var fileApi = 'FormData' in window && 'FileReader' in window && 'URL' in window && !!URL.createObjectURL;
    var windowsPhone = userAgent.indexOf('Windows Phone') !== -1;
    var Env = {
      opera: browser$4.isOpera(),
      webkit: webkit,
      ie: browser$4.isIE() || browser$4.isEdge() ? browser$4.version.major : false,
      gecko: browser$4.isFirefox(),
      mac: os.isOSX() || os.isiOS(),
      iOS: deviceType.isiPad() || deviceType.isiPhone(),
      android: os.isAndroid(),
      contentEditable: true,
      transparentSrc: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
      caretAfter: true,
      range: window.getSelection && 'Range' in window,
      documentMode: browser$4.isIE() ? document.documentMode || 7 : 10,
      fileApi: fileApi,
      ceFalse: true,
      cacheSuffix: null,
      container: null,
      experimentalShadowDom: false,
      canHaveCSP: !browser$4.isIE(),
      desktop: deviceType.isDesktop(),
      windowsPhone: windowsPhone,
      browser: {
        current: browser$4.current,
        version: browser$4.version,
        isChrome: browser$4.isChrome,
        isEdge: browser$4.isEdge,
        isFirefox: browser$4.isFirefox,
        isIE: browser$4.isIE,
        isOpera: browser$4.isOpera,
        isSafari: browser$4.isSafari
      },
      os: {
        current: os.current,
        version: os.version,
        isAndroid: os.isAndroid,
        isChromeOS: os.isChromeOS,
        isFreeBSD: os.isFreeBSD,
        isiOS: os.isiOS,
        isLinux: os.isLinux,
        isOSX: os.isOSX,
        isSolaris: os.isSolaris,
        isWindows: os.isWindows
      },
      deviceType: {
        isDesktop: deviceType.isDesktop,
        isiPad: deviceType.isiPad,
        isiPhone: deviceType.isiPhone,
        isPhone: deviceType.isPhone,
        isTablet: deviceType.isTablet,
        isTouch: deviceType.isTouch,
        isWebView: deviceType.isWebView
      }
    };

    var whiteSpaceRegExp$2 = /^\s*|\s*$/g;
    var trim$3 = function (str) {
      return str === null || str === undefined ? '' : ('' + str).replace(whiteSpaceRegExp$2, '');
    };
    var is$3 = function (obj, type) {
      if (!type) {
        return obj !== undefined;
      }
      if (type === 'array' && isArray(obj)) {
        return true;
      }
      return typeof obj === type;
    };
    var makeMap$4 = function (items, delim, map) {
      var i;
      items = items || [];
      delim = delim || ',';
      if (typeof items === 'string') {
        items = items.split(delim);
      }
      map = map || {};
      i = items.length;
      while (i--) {
        map[items[i]] = {};
      }
      return map;
    };
    var hasOwnProperty = has$2;
    var create$9 = function (s, p, root) {
      var self = this;
      var sp, scn, c, de = 0;
      s = /^((static) )?([\w.]+)(:([\w.]+))?/.exec(s);
      var cn = s[3].match(/(^|\.)(\w+)$/i)[2];
      var ns = self.createNS(s[3].replace(/\.\w+$/, ''), root);
      if (ns[cn]) {
        return;
      }
      if (s[2] === 'static') {
        ns[cn] = p;
        if (this.onCreate) {
          this.onCreate(s[2], s[3], ns[cn]);
        }
        return;
      }
      if (!p[cn]) {
        p[cn] = function () {
        };
        de = 1;
      }
      ns[cn] = p[cn];
      self.extend(ns[cn].prototype, p);
      if (s[5]) {
        sp = self.resolve(s[5]).prototype;
        scn = s[5].match(/\.(\w+)$/i)[1];
        c = ns[cn];
        if (de) {
          ns[cn] = function () {
            return sp[scn].apply(this, arguments);
          };
        } else {
          ns[cn] = function () {
            this.parent = sp[scn];
            return c.apply(this, arguments);
          };
        }
        ns[cn].prototype[cn] = ns[cn];
        self.each(sp, function (f, n) {
          ns[cn].prototype[n] = sp[n];
        });
        self.each(p, function (f, n) {
          if (sp[n]) {
            ns[cn].prototype[n] = function () {
              this.parent = sp[n];
              return f.apply(this, arguments);
            };
          } else {
            if (n !== cn) {
              ns[cn].prototype[n] = f;
            }
          }
        });
      }
      self.each(p.static, function (f, n) {
        ns[cn][n] = f;
      });
    };
    var extend$6 = function (obj) {
      var exts = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        exts[_i - 1] = arguments[_i];
      }
      for (var i = 0; i < exts.length; i++) {
        var ext = exts[i];
        for (var name_1 in ext) {
          if (has$2(ext, name_1)) {
            var value = ext[name_1];
            if (value !== undefined) {
              obj[name_1] = value;
            }
          }
        }
      }
      return obj;
    };
    var walk$3 = function (o, f, n, s) {
      s = s || this;
      if (o) {
        if (n) {
          o = o[n];
        }
        each$i(o, function (o, i) {
          if (f.call(s, o, i, n) === false) {
            return false;
          }
          walk$3(o, f, n, s);
        });
      }
    };
    var createNS = function (n, o) {
      var i, v;
      o = o || window;
      n = n.split('.');
      for (i = 0; i < n.length; i++) {
        v = n[i];
        if (!o[v]) {
          o[v] = {};
        }
        o = o[v];
      }
      return o;
    };
    var resolve$3 = function (n, o) {
      var i, l;
      o = o || window;
      n = n.split('.');
      for (i = 0, l = n.length; i < l; i++) {
        o = o[n[i]];
        if (!o) {
          break;
        }
      }
      return o;
    };
    var explode$4 = function (s, d) {
      if (!s || is$3(s, 'array')) {
        return s;
      }
      return map$1(s.split(d || ','), trim$3);
    };
    var _addCacheSuffix = function (url) {
      var cacheSuffix = Env.cacheSuffix;
      if (cacheSuffix) {
        url += (url.indexOf('?') === -1 ? '?' : '&') + cacheSuffix;
      }
      return url;
    };
    var Tools = {
      trim: trim$3,
      isArray: isArray,
      is: is$3,
      toArray: toArray$1,
      makeMap: makeMap$4,
      each: each$i,
      map: map$1,
      grep: filter$2,
      inArray: indexOf$1,
      hasOwn: hasOwnProperty,
      extend: extend$6,
      create: create$9,
      walk: walk$3,
      createNS: createNS,
      resolve: resolve$3,
      explode: explode$4,
      _addCacheSuffix: _addCacheSuffix
    };

    var fromHtml$1 = function (html, scope) {
      var doc = scope || document;
      var div = doc.createElement('div');
      div.innerHTML = html;
      if (!div.hasChildNodes() || div.childNodes.length > 1) {
        console.error('HTML does not have a single root node', html);
        throw new Error('HTML must have a single root node');
      }
      return fromDom$2(div.childNodes[0]);
    };
    var fromTag = function (tag, scope) {
      var doc = scope || document;
      var node = doc.createElement(tag);
      return fromDom$2(node);
    };
    var fromText = function (text, scope) {
      var doc = scope || document;
      var node = doc.createTextNode(text);
      return fromDom$2(node);
    };
    var fromDom$2 = function (node) {
      if (node === null || node === undefined) {
        throw new Error('Node cannot be null or undefined');
      }
      return { dom: node };
    };
    var fromPoint$1 = function (docElm, x, y) {
      return Optional.from(docElm.dom.elementFromPoint(x, y)).map(fromDom$2);
    };
    var SugarElement = {
      fromHtml: fromHtml$1,
      fromTag: fromTag,
      fromText: fromText,
      fromDom: fromDom$2,
      fromPoint: fromPoint$1
    };

    var toArray = function (target, f) {
      var r = [];
      var recurse = function (e) {
        r.push(e);
        return f(e);
      };
      var cur = f(target);
      do {
        cur = cur.bind(recurse);
      } while (cur.isSome());
      return r;
    };

    var compareDocumentPosition = function (a, b, match) {
      return (a.compareDocumentPosition(b) & match) !== 0;
    };
    var documentPositionContainedBy = function (a, b) {
      return compareDocumentPosition(a, b, Node.DOCUMENT_POSITION_CONTAINED_BY);
    };

    var COMMENT = 8;
    var DOCUMENT = 9;
    var DOCUMENT_FRAGMENT = 11;
    var ELEMENT = 1;
    var TEXT = 3;

    var is$2 = function (element, selector) {
      var dom = element.dom;
      if (dom.nodeType !== ELEMENT) {
        return false;
      } else {
        var elem = dom;
        if (elem.matches !== undefined) {
          return elem.matches(selector);
        } else if (elem.msMatchesSelector !== undefined) {
          return elem.msMatchesSelector(selector);
        } else if (elem.webkitMatchesSelector !== undefined) {
          return elem.webkitMatchesSelector(selector);
        } else if (elem.mozMatchesSelector !== undefined) {
          return elem.mozMatchesSelector(selector);
        } else {
          throw new Error('Browser lacks native selectors');
        }
      }
    };
    var bypassSelector = function (dom) {
      return dom.nodeType !== ELEMENT && dom.nodeType !== DOCUMENT && dom.nodeType !== DOCUMENT_FRAGMENT || dom.childElementCount === 0;
    };
    var all = function (selector, scope) {
      var base = scope === undefined ? document : scope.dom;
      return bypassSelector(base) ? [] : map$3(base.querySelectorAll(selector), SugarElement.fromDom);
    };
    var one = function (selector, scope) {
      var base = scope === undefined ? document : scope.dom;
      return bypassSelector(base) ? Optional.none() : Optional.from(base.querySelector(selector)).map(SugarElement.fromDom);
    };

    var eq = function (e1, e2) {
      return e1.dom === e2.dom;
    };
    var regularContains = function (e1, e2) {
      var d1 = e1.dom;
      var d2 = e2.dom;
      return d1 === d2 ? false : d1.contains(d2);
    };
    var ieContains = function (e1, e2) {
      return documentPositionContainedBy(e1.dom, e2.dom);
    };
    var contains$1 = function (e1, e2) {
      return detect().browser.isIE() ? ieContains(e1, e2) : regularContains(e1, e2);
    };

    typeof window !== 'undefined' ? window : Function('return this;')();

    var name = function (element) {
      var r = element.dom.nodeName;
      return r.toLowerCase();
    };
    var type = function (element) {
      return element.dom.nodeType;
    };
    var isType = function (t) {
      return function (element) {
        return type(element) === t;
      };
    };
    var isComment$1 = function (element) {
      return type(element) === COMMENT || name(element) === '#comment';
    };
    var isElement$6 = isType(ELEMENT);
    var isText$8 = isType(TEXT);
    var isDocument$2 = isType(DOCUMENT);
    var isDocumentFragment$1 = isType(DOCUMENT_FRAGMENT);
    var isTag = function (tag) {
      return function (e) {
        return isElement$6(e) && name(e) === tag;
      };
    };

    var owner$1 = function (element) {
      return SugarElement.fromDom(element.dom.ownerDocument);
    };
    var documentOrOwner = function (dos) {
      return isDocument$2(dos) ? dos : owner$1(dos);
    };
    var documentElement = function (element) {
      return SugarElement.fromDom(documentOrOwner(element).dom.documentElement);
    };
    var defaultView = function (element) {
      return SugarElement.fromDom(documentOrOwner(element).dom.defaultView);
    };
    var parent = function (element) {
      return Optional.from(element.dom.parentNode).map(SugarElement.fromDom);
    };
    var parents$1 = function (element, isRoot) {
      var stop = isFunction(isRoot) ? isRoot : never;
      var dom = element.dom;
      var ret = [];
      while (dom.parentNode !== null && dom.parentNode !== undefined) {
        var rawParent = dom.parentNode;
        var p = SugarElement.fromDom(rawParent);
        ret.push(p);
        if (stop(p) === true) {
          break;
        } else {
          dom = rawParent;
        }
      }
      return ret;
    };
    var siblings = function (element) {
      var filterSelf = function (elements) {
        return filter$4(elements, function (x) {
          return !eq(element, x);
        });
      };
      return parent(element).map(children).map(filterSelf).getOr([]);
    };
    var prevSibling = function (element) {
      return Optional.from(element.dom.previousSibling).map(SugarElement.fromDom);
    };
    var nextSibling = function (element) {
      return Optional.from(element.dom.nextSibling).map(SugarElement.fromDom);
    };
    var prevSiblings = function (element) {
      return reverse(toArray(element, prevSibling));
    };
    var nextSiblings = function (element) {
      return toArray(element, nextSibling);
    };
    var children = function (element) {
      return map$3(element.dom.childNodes, SugarElement.fromDom);
    };
    var child$1 = function (element, index) {
      var cs = element.dom.childNodes;
      return Optional.from(cs[index]).map(SugarElement.fromDom);
    };
    var firstChild = function (element) {
      return child$1(element, 0);
    };
    var lastChild = function (element) {
      return child$1(element, element.dom.childNodes.length - 1);
    };
    var childNodesCount = function (element) {
      return element.dom.childNodes.length;
    };

    var getHead = function (doc) {
      var b = doc.dom.head;
      if (b === null || b === undefined) {
        throw new Error('Head is not available yet');
      }
      return SugarElement.fromDom(b);
    };

    var isShadowRoot = function (dos) {
      return isDocumentFragment$1(dos) && isNonNullable(dos.dom.host);
    };
    var supported = isFunction(Element.prototype.attachShadow) && isFunction(Node.prototype.getRootNode);
    var isSupported$1 = constant(supported);
    var getRootNode = supported ? function (e) {
      return SugarElement.fromDom(e.dom.getRootNode());
    } : documentOrOwner;
    var getStyleContainer = function (dos) {
      return isShadowRoot(dos) ? dos : getHead(documentOrOwner(dos));
    };
    var getShadowRoot = function (e) {
      var r = getRootNode(e);
      return isShadowRoot(r) ? Optional.some(r) : Optional.none();
    };
    var getShadowHost = function (e) {
      return SugarElement.fromDom(e.dom.host);
    };
    var getOriginalEventTarget = function (event) {
      if (isSupported$1() && isNonNullable(event.target)) {
        var el = SugarElement.fromDom(event.target);
        if (isElement$6(el) && isOpenShadowHost(el)) {
          if (event.composed && event.composedPath) {
            var composedPath = event.composedPath();
            if (composedPath) {
              return head(composedPath);
            }
          }
        }
      }
      return Optional.from(event.target);
    };
    var isOpenShadowHost = function (element) {
      return isNonNullable(element.dom.shadowRoot);
    };

    var before$4 = function (marker, element) {
      var parent$1 = parent(marker);
      parent$1.each(function (v) {
        v.dom.insertBefore(element.dom, marker.dom);
      });
    };
    var after$3 = function (marker, element) {
      var sibling = nextSibling(marker);
      sibling.fold(function () {
        var parent$1 = parent(marker);
        parent$1.each(function (v) {
          append$1(v, element);
        });
      }, function (v) {
        before$4(v, element);
      });
    };
    var prepend = function (parent, element) {
      var firstChild$1 = firstChild(parent);
      firstChild$1.fold(function () {
        append$1(parent, element);
      }, function (v) {
        parent.dom.insertBefore(element.dom, v.dom);
      });
    };
    var append$1 = function (parent, element) {
      parent.dom.appendChild(element.dom);
    };
    var wrap$3 = function (element, wrapper) {
      before$4(element, wrapper);
      append$1(wrapper, element);
    };

    var before$3 = function (marker, elements) {
      each$k(elements, function (x) {
        before$4(marker, x);
      });
    };
    var append = function (parent, elements) {
      each$k(elements, function (x) {
        append$1(parent, x);
      });
    };

    var empty = function (element) {
      element.dom.textContent = '';
      each$k(children(element), function (rogue) {
        remove$7(rogue);
      });
    };
    var remove$7 = function (element) {
      var dom = element.dom;
      if (dom.parentNode !== null) {
        dom.parentNode.removeChild(dom);
      }
    };
    var unwrap = function (wrapper) {
      var children$1 = children(wrapper);
      if (children$1.length > 0) {
        before$3(wrapper, children$1);
      }
      remove$7(wrapper);
    };

    var inBody = function (element) {
      var dom = isText$8(element) ? element.dom.parentNode : element.dom;
      if (dom === undefined || dom === null || dom.ownerDocument === null) {
        return false;
      }
      var doc = dom.ownerDocument;
      return getShadowRoot(SugarElement.fromDom(dom)).fold(function () {
        return doc.body.contains(dom);
      }, compose1(inBody, getShadowHost));
    };

    var r = function (left, top) {
      var translate = function (x, y) {
        return r(left + x, top + y);
      };
      return {
        left: left,
        top: top,
        translate: translate
      };
    };
    var SugarPosition = r;

    var boxPosition = function (dom) {
      var box = dom.getBoundingClientRect();
      return SugarPosition(box.left, box.top);
    };
    var firstDefinedOrZero = function (a, b) {
      if (a !== undefined) {
        return a;
      } else {
        return b !== undefined ? b : 0;
      }
    };
    var absolute = function (element) {
      var doc = element.dom.ownerDocument;
      var body = doc.body;
      var win = doc.defaultView;
      var html = doc.documentElement;
      if (body === element.dom) {
        return SugarPosition(body.offsetLeft, body.offsetTop);
      }
      var scrollTop = firstDefinedOrZero(win === null || win === void 0 ? void 0 : win.pageYOffset, html.scrollTop);
      var scrollLeft = firstDefinedOrZero(win === null || win === void 0 ? void 0 : win.pageXOffset, html.scrollLeft);
      var clientTop = firstDefinedOrZero(html.clientTop, body.clientTop);
      var clientLeft = firstDefinedOrZero(html.clientLeft, body.clientLeft);
      return viewport(element).translate(scrollLeft - clientLeft, scrollTop - clientTop);
    };
    var viewport = function (element) {
      var dom = element.dom;
      var doc = dom.ownerDocument;
      var body = doc.body;
      if (body === dom) {
        return SugarPosition(body.offsetLeft, body.offsetTop);
      }
      if (!inBody(element)) {
        return SugarPosition(0, 0);
      }
      return boxPosition(dom);
    };

    var get$8 = function (_DOC) {
      var doc = _DOC !== undefined ? _DOC.dom : document;
      var x = doc.body.scrollLeft || doc.documentElement.scrollLeft;
      var y = doc.body.scrollTop || doc.documentElement.scrollTop;
      return SugarPosition(x, y);
    };
    var to = function (x, y, _DOC) {
      var doc = _DOC !== undefined ? _DOC.dom : document;
      var win = doc.defaultView;
      if (win) {
        win.scrollTo(x, y);
      }
    };
    var intoView = function (element, alignToTop) {
      var isSafari = detect().browser.isSafari();
      if (isSafari && isFunction(element.dom.scrollIntoViewIfNeeded)) {
        element.dom.scrollIntoViewIfNeeded(false);
      } else {
        element.dom.scrollIntoView(alignToTop);
      }
    };

    var get$7 = function (_win) {
      var win = _win === undefined ? window : _win;
      if (detect().browser.isFirefox()) {
        return Optional.none();
      } else {
        return Optional.from(win['visualViewport']);
      }
    };
    var bounds = function (x, y, width, height) {
      return {
        x: x,
        y: y,
        width: width,
        height: height,
        right: x + width,
        bottom: y + height
      };
    };
    var getBounds = function (_win) {
      var win = _win === undefined ? window : _win;
      var doc = win.document;
      var scroll = get$8(SugarElement.fromDom(doc));
      return get$7(win).fold(function () {
        var html = win.document.documentElement;
        var width = html.clientWidth;
        var height = html.clientHeight;
        return bounds(scroll.left, scroll.top, width, height);
      }, function (visualViewport) {
        return bounds(Math.max(visualViewport.pageLeft, scroll.left), Math.max(visualViewport.pageTop, scroll.top), visualViewport.width, visualViewport.height);
      });
    };

    var isNodeType = function (type) {
      return function (node) {
        return !!node && node.nodeType === type;
      };
    };
    var isRestrictedNode = function (node) {
      return !!node && !Object.getPrototypeOf(node);
    };
    var isElement$5 = isNodeType(1);
    var matchNodeNames = function (names) {
      var lowercasedNames = names.map(function (s) {
        return s.toLowerCase();
      });
      return function (node) {
        if (node && node.nodeName) {
          var nodeName = node.nodeName.toLowerCase();
          return contains$3(lowercasedNames, nodeName);
        }
        return false;
      };
    };
    var matchStyleValues = function (name, values) {
      var items = values.toLowerCase().split(' ');
      return function (node) {
        if (isElement$5(node)) {
          for (var i = 0; i < items.length; i++) {
            var computed = node.ownerDocument.defaultView.getComputedStyle(node, null);
            var cssValue = computed ? computed.getPropertyValue(name) : null;
            if (cssValue === items[i]) {
              return true;
            }
          }
        }
        return false;
      };
    };
    var hasAttribute = function (attrName) {
      return function (node) {
        return isElement$5(node) && node.hasAttribute(attrName);
      };
    };
    var hasAttributeValue = function (attrName, attrValue) {
      return function (node) {
        return isElement$5(node) && node.getAttribute(attrName) === attrValue;
      };
    };
    var isBogus$2 = function (node) {
      return isElement$5(node) && node.hasAttribute('data-mce-bogus');
    };
    var isBogusAll$1 = function (node) {
      return isElement$5(node) && node.getAttribute('data-mce-bogus') === 'all';
    };
    var isTable$3 = function (node) {
      return isElement$5(node) && node.tagName === 'TABLE';
    };
    var hasContentEditableState = function (value) {
      return function (node) {
        if (isElement$5(node)) {
          if (node.contentEditable === value) {
            return true;
          }
          if (node.getAttribute('data-mce-contenteditable') === value) {
            return true;
          }
        }
        return false;
      };
    };
    var isTextareaOrInput = matchNodeNames([
      'textarea',
      'input'
    ]);
    var isText$7 = isNodeType(3);
    var isComment = isNodeType(8);
    var isDocument$1 = isNodeType(9);
    var isDocumentFragment = isNodeType(11);
    var isBr$5 = matchNodeNames(['br']);
    var isImg = matchNodeNames(['img']);
    var isContentEditableTrue$4 = hasContentEditableState('true');
    var isContentEditableFalse$b = hasContentEditableState('false');
    var isTableCell$5 = matchNodeNames([
      'td',
      'th'
    ]);
    var isMedia$2 = matchNodeNames([
      'video',
      'audio',
      'object',
      'embed'
    ]);

    var is$1 = function (lhs, rhs, comparator) {
      if (comparator === void 0) {
        comparator = tripleEquals;
      }
      return lhs.exists(function (left) {
        return comparator(left, rhs);
      });
    };
    var cat = function (arr) {
      var r = [];
      var push = function (x) {
        r.push(x);
      };
      for (var i = 0; i < arr.length; i++) {
        arr[i].each(push);
      }
      return r;
    };
    var lift2 = function (oa, ob, f) {
      return oa.isSome() && ob.isSome() ? Optional.some(f(oa.getOrDie(), ob.getOrDie())) : Optional.none();
    };
    var lift3 = function (oa, ob, oc, f) {
      return oa.isSome() && ob.isSome() && oc.isSome() ? Optional.some(f(oa.getOrDie(), ob.getOrDie(), oc.getOrDie())) : Optional.none();
    };
    var someIf = function (b, a) {
      return b ? Optional.some(a) : Optional.none();
    };

    var isSupported = function (dom) {
      return dom.style !== undefined && isFunction(dom.style.getPropertyValue);
    };

    var rawSet = function (dom, key, value) {
      if (isString$1(value) || isBoolean(value) || isNumber(value)) {
        dom.setAttribute(key, value + '');
      } else {
        console.error('Invalid call to Attribute.set. Key ', key, ':: Value ', value, ':: Element ', dom);
        throw new Error('Attribute value was not simple');
      }
    };
    var set$1 = function (element, key, value) {
      rawSet(element.dom, key, value);
    };
    var setAll$1 = function (element, attrs) {
      var dom = element.dom;
      each$j(attrs, function (v, k) {
        rawSet(dom, k, v);
      });
    };
    var get$6 = function (element, key) {
      var v = element.dom.getAttribute(key);
      return v === null ? undefined : v;
    };
    var getOpt = function (element, key) {
      return Optional.from(get$6(element, key));
    };
    var has$1 = function (element, key) {
      var dom = element.dom;
      return dom && dom.hasAttribute ? dom.hasAttribute(key) : false;
    };
    var remove$6 = function (element, key) {
      element.dom.removeAttribute(key);
    };
    var clone$3 = function (element) {
      return foldl(element.dom.attributes, function (acc, attr) {
        acc[attr.name] = attr.value;
        return acc;
      }, {});
    };

    var internalSet = function (dom, property, value) {
      if (!isString$1(value)) {
        console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
        throw new Error('CSS value must be a string: ' + value);
      }
      if (isSupported(dom)) {
        dom.style.setProperty(property, value);
      }
    };
    var setAll = function (element, css) {
      var dom = element.dom;
      each$j(css, function (v, k) {
        internalSet(dom, k, v);
      });
    };
    var get$5 = function (element, property) {
      var dom = element.dom;
      var styles = window.getComputedStyle(dom);
      var r = styles.getPropertyValue(property);
      return r === '' && !inBody(element) ? getUnsafeProperty(dom, property) : r;
    };
    var getUnsafeProperty = function (dom, property) {
      return isSupported(dom) ? dom.style.getPropertyValue(property) : '';
    };
    var getRaw = function (element, property) {
      var dom = element.dom;
      var raw = getUnsafeProperty(dom, property);
      return Optional.from(raw).filter(function (r) {
        return r.length > 0;
      });
    };
    var getAllRaw = function (element) {
      var css = {};
      var dom = element.dom;
      if (isSupported(dom)) {
        for (var i = 0; i < dom.style.length; i++) {
          var ruleName = dom.style.item(i);
          css[ruleName] = dom.style[ruleName];
        }
      }
      return css;
    };
    var reflow = function (e) {
      return e.dom.offsetWidth;
    };

    var browser$3 = detect().browser;
    var firstElement = function (nodes) {
      return find$3(nodes, isElement$6);
    };
    var getTableCaptionDeltaY = function (elm) {
      if (browser$3.isFirefox() && name(elm) === 'table') {
        return firstElement(children(elm)).filter(function (elm) {
          return name(elm) === 'caption';
        }).bind(function (caption) {
          return firstElement(nextSiblings(caption)).map(function (body) {
            var bodyTop = body.dom.offsetTop;
            var captionTop = caption.dom.offsetTop;
            var captionHeight = caption.dom.offsetHeight;
            return bodyTop <= captionTop ? -captionHeight : 0;
          });
        }).getOr(0);
      } else {
        return 0;
      }
    };
    var hasChild = function (elm, child) {
      return elm.children && contains$3(elm.children, child);
    };
    var getPos = function (body, elm, rootElm) {
      var x = 0, y = 0;
      var doc = body.ownerDocument;
      rootElm = rootElm ? rootElm : body;
      if (elm) {
        if (rootElm === body && elm.getBoundingClientRect && get$5(SugarElement.fromDom(body), 'position') === 'static') {
          var pos = elm.getBoundingClientRect();
          x = pos.left + (doc.documentElement.scrollLeft || body.scrollLeft) - doc.documentElement.clientLeft;
          y = pos.top + (doc.documentElement.scrollTop || body.scrollTop) - doc.documentElement.clientTop;
          return {
            x: x,
            y: y
          };
        }
        var offsetParent = elm;
        while (offsetParent && offsetParent !== rootElm && offsetParent.nodeType && !hasChild(offsetParent, rootElm)) {
          var castOffsetParent = offsetParent;
          x += castOffsetParent.offsetLeft || 0;
          y += castOffsetParent.offsetTop || 0;
          offsetParent = castOffsetParent.offsetParent;
        }
        offsetParent = elm.parentNode;
        while (offsetParent && offsetParent !== rootElm && offsetParent.nodeType && !hasChild(offsetParent, rootElm)) {
          x -= offsetParent.scrollLeft || 0;
          y -= offsetParent.scrollTop || 0;
          offsetParent = offsetParent.parentNode;
        }
        y += getTableCaptionDeltaY(SugarElement.fromDom(elm));
      }
      return {
        x: x,
        y: y
      };
    };

    var exports$1 = {}, module$1 = { exports: exports$1 };
    (function (define, exports, module, require) {
      (function (global, factory) {
        typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.EphoxContactWrapper = factory());
      }(this, function () {
        var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
        var promise = { exports: {} };
        (function (module) {
          (function (root) {
            var setTimeoutFunc = setTimeout;
            function noop() {
            }
            function bind(fn, thisArg) {
              return function () {
                fn.apply(thisArg, arguments);
              };
            }
            function Promise(fn) {
              if (typeof this !== 'object')
                throw new TypeError('Promises must be constructed via new');
              if (typeof fn !== 'function')
                throw new TypeError('not a function');
              this._state = 0;
              this._handled = false;
              this._value = undefined;
              this._deferreds = [];
              doResolve(fn, this);
            }
            function handle(self, deferred) {
              while (self._state === 3) {
                self = self._value;
              }
              if (self._state === 0) {
                self._deferreds.push(deferred);
                return;
              }
              self._handled = true;
              Promise._immediateFn(function () {
                var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
                if (cb === null) {
                  (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
                  return;
                }
                var ret;
                try {
                  ret = cb(self._value);
                } catch (e) {
                  reject(deferred.promise, e);
                  return;
                }
                resolve(deferred.promise, ret);
              });
            }
            function resolve(self, newValue) {
              try {
                if (newValue === self)
                  throw new TypeError('A promise cannot be resolved with itself.');
                if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
                  var then = newValue.then;
                  if (newValue instanceof Promise) {
                    self._state = 3;
                    self._value = newValue;
                    finale(self);
                    return;
                  } else if (typeof then === 'function') {
                    doResolve(bind(then, newValue), self);
                    return;
                  }
                }
                self._state = 1;
                self._value = newValue;
                finale(self);
              } catch (e) {
                reject(self, e);
              }
            }
            function reject(self, newValue) {
              self._state = 2;
              self._value = newValue;
              finale(self);
            }
            function finale(self) {
              if (self._state === 2 && self._deferreds.length === 0) {
                Promise._immediateFn(function () {
                  if (!self._handled) {
                    Promise._unhandledRejectionFn(self._value);
                  }
                });
              }
              for (var i = 0, len = self._deferreds.length; i < len; i++) {
                handle(self, self._deferreds[i]);
              }
              self._deferreds = null;
            }
            function Handler(onFulfilled, onRejected, promise) {
              this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
              this.onRejected = typeof onRejected === 'function' ? onRejected : null;
              this.promise = promise;
            }
            function doResolve(fn, self) {
              var done = false;
              try {
                fn(function (value) {
                  if (done)
                    return;
                  done = true;
                  resolve(self, value);
                }, function (reason) {
                  if (done)
                    return;
                  done = true;
                  reject(self, reason);
                });
              } catch (ex) {
                if (done)
                  return;
                done = true;
                reject(self, ex);
              }
            }
            Promise.prototype['catch'] = function (onRejected) {
              return this.then(null, onRejected);
            };
            Promise.prototype.then = function (onFulfilled, onRejected) {
              var prom = new this.constructor(noop);
              handle(this, new Handler(onFulfilled, onRejected, prom));
              return prom;
            };
            Promise.all = function (arr) {
              var args = Array.prototype.slice.call(arr);
              return new Promise(function (resolve, reject) {
                if (args.length === 0)
                  return resolve([]);
                var remaining = args.length;
                function res(i, val) {
                  try {
                    if (val && (typeof val === 'object' || typeof val === 'function')) {
                      var then = val.then;
                      if (typeof then === 'function') {
                        then.call(val, function (val) {
                          res(i, val);
                        }, reject);
                        return;
                      }
                    }
                    args[i] = val;
                    if (--remaining === 0) {
                      resolve(args);
                    }
                  } catch (ex) {
                    reject(ex);
                  }
                }
                for (var i = 0; i < args.length; i++) {
                  res(i, args[i]);
                }
              });
            };
            Promise.resolve = function (value) {
              if (value && typeof value === 'object' && value.constructor === Promise) {
                return value;
              }
              return new Promise(function (resolve) {
                resolve(value);
              });
            };
            Promise.reject = function (value) {
              return new Promise(function (resolve, reject) {
                reject(value);
              });
            };
            Promise.race = function (values) {
              return new Promise(function (resolve, reject) {
                for (var i = 0, len = values.length; i < len; i++) {
                  values[i].then(resolve, reject);
                }
              });
            };
            Promise._immediateFn = typeof setImmediate === 'function' ? function (fn) {
              setImmediate(fn);
            } : function (fn) {
              setTimeoutFunc(fn, 0);
            };
            Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
              if (typeof console !== 'undefined' && console) {
                console.warn('Possible Unhandled Promise Rejection:', err);
              }
            };
            Promise._setImmediateFn = function _setImmediateFn(fn) {
              Promise._immediateFn = fn;
            };
            Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
              Promise._unhandledRejectionFn = fn;
            };
            if (module.exports) {
              module.exports = Promise;
            } else if (!root.Promise) {
              root.Promise = Promise;
            }
          }(commonjsGlobal));
        }(promise));
        var promisePolyfill = promise.exports;
        var Global = function () {
          if (typeof window !== 'undefined') {
            return window;
          } else {
            return Function('return this;')();
          }
        }();
        var promisePolyfill_1 = { boltExport: Global.Promise || promisePolyfill };
        return promisePolyfill_1;
      }));
    }(undefined, exports$1, module$1));
    var Promise$1 = module$1.exports.boltExport;

    var nu$1 = function (baseFn) {
      var data = Optional.none();
      var callbacks = [];
      var map = function (f) {
        return nu$1(function (nCallback) {
          get(function (data) {
            nCallback(f(data));
          });
        });
      };
      var get = function (nCallback) {
        if (isReady()) {
          call(nCallback);
        } else {
          callbacks.push(nCallback);
        }
      };
      var set = function (x) {
        if (!isReady()) {
          data = Optional.some(x);
          run(callbacks);
          callbacks = [];
        }
      };
      var isReady = function () {
        return data.isSome();
      };
      var run = function (cbs) {
        each$k(cbs, call);
      };
      var call = function (cb) {
        data.each(function (x) {
          setTimeout(function () {
            cb(x);
          }, 0);
        });
      };
      baseFn(set);
      return {
        get: get,
        map: map,
        isReady: isReady
      };
    };
    var pure$1 = function (a) {
      return nu$1(function (callback) {
        callback(a);
      });
    };
    var LazyValue = {
      nu: nu$1,
      pure: pure$1
    };

    var errorReporter = function (err) {
      setTimeout(function () {
        throw err;
      }, 0);
    };
    var make = function (run) {
      var get = function (callback) {
        run().then(callback, errorReporter);
      };
      var map = function (fab) {
        return make(function () {
          return run().then(fab);
        });
      };
      var bind = function (aFutureB) {
        return make(function () {
          return run().then(function (v) {
            return aFutureB(v).toPromise();
          });
        });
      };
      var anonBind = function (futureB) {
        return make(function () {
          return run().then(function () {
            return futureB.toPromise();
          });
        });
      };
      var toLazy = function () {
        return LazyValue.nu(get);
      };
      var toCached = function () {
        var cache = null;
        return make(function () {
          if (cache === null) {
            cache = run();
          }
          return cache;
        });
      };
      var toPromise = run;
      return {
        map: map,
        bind: bind,
        anonBind: anonBind,
        toLazy: toLazy,
        toCached: toCached,
        toPromise: toPromise,
        get: get
      };
    };
    var nu = function (baseFn) {
      return make(function () {
        return new Promise$1(baseFn);
      });
    };
    var pure = function (a) {
      return make(function () {
        return Promise$1.resolve(a);
      });
    };
    var Future = {
      nu: nu,
      pure: pure
    };

    var par$1 = function (asyncValues, nu) {
      return nu(function (callback) {
        var r = [];
        var count = 0;
        var cb = function (i) {
          return function (value) {
            r[i] = value;
            count++;
            if (count >= asyncValues.length) {
              callback(r);
            }
          };
        };
        if (asyncValues.length === 0) {
          callback([]);
        } else {
          each$k(asyncValues, function (asyncValue, i) {
            asyncValue.get(cb(i));
          });
        }
      });
    };

    var par = function (futures) {
      return par$1(futures, Future.nu);
    };

    var value$1 = function (o) {
      var or = function (_opt) {
        return value$1(o);
      };
      var orThunk = function (_f) {
        return value$1(o);
      };
      var map = function (f) {
        return value$1(f(o));
      };
      var mapError = function (_f) {
        return value$1(o);
      };
      var each = function (f) {
        f(o);
      };
      var bind = function (f) {
        return f(o);
      };
      var fold = function (_, onValue) {
        return onValue(o);
      };
      var exists = function (f) {
        return f(o);
      };
      var forall = function (f) {
        return f(o);
      };
      var toOptional = function () {
        return Optional.some(o);
      };
      return {
        isValue: always,
        isError: never,
        getOr: constant(o),
        getOrThunk: constant(o),
        getOrDie: constant(o),
        or: or,
        orThunk: orThunk,
        fold: fold,
        map: map,
        mapError: mapError,
        each: each,
        bind: bind,
        exists: exists,
        forall: forall,
        toOptional: toOptional
      };
    };
    var error = function (message) {
      var getOrThunk = function (f) {
        return f();
      };
      var getOrDie = function () {
        return die(String(message))();
      };
      var or = identity;
      var orThunk = function (f) {
        return f();
      };
      var map = function (_f) {
        return error(message);
      };
      var mapError = function (f) {
        return error(f(message));
      };
      var bind = function (_f) {
        return error(message);
      };
      var fold = function (onError, _) {
        return onError(message);
      };
      return {
        isValue: never,
        isError: always,
        getOr: identity,
        getOrThunk: getOrThunk,
        getOrDie: getOrDie,
        or: or,
        orThunk: orThunk,
        fold: fold,
        map: map,
        mapError: mapError,
        each: noop,
        bind: bind,
        exists: never,
        forall: always,
        toOptional: Optional.none
      };
    };
    var fromOption = function (opt, err) {
      return opt.fold(function () {
        return error(err);
      }, value$1);
    };
    var Result = {
      value: value$1,
      error: error,
      fromOption: fromOption
    };

    var generate$1 = function (cases) {
      if (!isArray$1(cases)) {
        throw new Error('cases must be an array');
      }
      if (cases.length === 0) {
        throw new Error('there must be at least one case');
      }
      var constructors = [];
      var adt = {};
      each$k(cases, function (acase, count) {
        var keys$1 = keys(acase);
        if (keys$1.length !== 1) {
          throw new Error('one and only one name per case');
        }
        var key = keys$1[0];
        var value = acase[key];
        if (adt[key] !== undefined) {
          throw new Error('duplicate key detected:' + key);
        } else if (key === 'cata') {
          throw new Error('cannot have a case named cata (sorry)');
        } else if (!isArray$1(value)) {
          throw new Error('case arguments must be an array');
        }
        constructors.push(key);
        adt[key] = function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          var argLength = args.length;
          if (argLength !== value.length) {
            throw new Error('Wrong number of arguments to case ' + key + '. Expected ' + value.length + ' (' + value + '), got ' + argLength);
          }
          var match = function (branches) {
            var branchKeys = keys(branches);
            if (constructors.length !== branchKeys.length) {
              throw new Error('Wrong number of arguments to match. Expected: ' + constructors.join(',') + '\nActual: ' + branchKeys.join(','));
            }
            var allReqd = forall(constructors, function (reqKey) {
              return contains$3(branchKeys, reqKey);
            });
            if (!allReqd) {
              throw new Error('Not all branches were specified when using match. Specified: ' + branchKeys.join(', ') + '\nRequired: ' + constructors.join(', '));
            }
            return branches[key].apply(null, args);
          };
          return {
            fold: function () {
              var foldArgs = [];
              for (var _i = 0; _i < arguments.length; _i++) {
                foldArgs[_i] = arguments[_i];
              }
              if (foldArgs.length !== cases.length) {
                throw new Error('Wrong number of arguments to fold. Expected ' + cases.length + ', got ' + foldArgs.length);
              }
              var target = foldArgs[count];
              return target.apply(null, args);
            },
            match: match,
            log: function (label) {
              console.log(label, {
                constructors: constructors,
                constructor: key,
                params: args
              });
            }
          };
        };
      });
      return adt;
    };
    var Adt = { generate: generate$1 };

    Adt.generate([
      {
        bothErrors: [
          'error1',
          'error2'
        ]
      },
      {
        firstError: [
          'error1',
          'value2'
        ]
      },
      {
        secondError: [
          'value1',
          'error2'
        ]
      },
      {
        bothValues: [
          'value1',
          'value2'
        ]
      }
    ]);
    var unite = function (result) {
      return result.fold(identity, identity);
    };

    function ClosestOrAncestor (is, ancestor, scope, a, isRoot) {
      if (is(scope, a)) {
        return Optional.some(scope);
      } else if (isFunction(isRoot) && isRoot(scope)) {
        return Optional.none();
      } else {
        return ancestor(scope, a, isRoot);
      }
    }

    var ancestor$3 = function (scope, predicate, isRoot) {
      var element = scope.dom;
      var stop = isFunction(isRoot) ? isRoot : never;
      while (element.parentNode) {
        element = element.parentNode;
        var el = SugarElement.fromDom(element);
        if (predicate(el)) {
          return Optional.some(el);
        } else if (stop(el)) {
          break;
        }
      }
      return Optional.none();
    };
    var closest$3 = function (scope, predicate, isRoot) {
      var is = function (s, test) {
        return test(s);
      };
      return ClosestOrAncestor(is, ancestor$3, scope, predicate, isRoot);
    };
    var sibling$2 = function (scope, predicate) {
      var element = scope.dom;
      if (!element.parentNode) {
        return Optional.none();
      }
      return child(SugarElement.fromDom(element.parentNode), function (x) {
        return !eq(scope, x) && predicate(x);
      });
    };
    var child = function (scope, predicate) {
      var pred = function (node) {
        return predicate(SugarElement.fromDom(node));
      };
      var result = find$3(scope.dom.childNodes, pred);
      return result.map(SugarElement.fromDom);
    };

    var ancestor$2 = function (scope, selector, isRoot) {
      return ancestor$3(scope, function (e) {
        return is$2(e, selector);
      }, isRoot);
    };
    var descendant = function (scope, selector) {
      return one(selector, scope);
    };
    var closest$2 = function (scope, selector, isRoot) {
      var is = function (element, selector) {
        return is$2(element, selector);
      };
      return ClosestOrAncestor(is, ancestor$2, scope, selector, isRoot);
    };

    var promiseObj = window.Promise ? window.Promise : Promise$1;

    var requestAnimationFramePromise;
    var requestAnimationFrame = function (callback, element) {
      var requestAnimationFrameFunc = window.requestAnimationFrame;
      var vendors = [
        'ms',
        'moz',
        'webkit'
      ];
      var featurefill = function (cb) {
        window.setTimeout(cb, 0);
      };
      for (var i = 0; i < vendors.length && !requestAnimationFrameFunc; i++) {
        requestAnimationFrameFunc = window[vendors[i] + 'RequestAnimationFrame'];
      }
      if (!requestAnimationFrameFunc) {
        requestAnimationFrameFunc = featurefill;
      }
      requestAnimationFrameFunc(callback, element);
    };
    var wrappedSetTimeout = function (callback, time) {
      if (typeof time !== 'number') {
        time = 0;
      }
      return setTimeout(callback, time);
    };
    var wrappedSetInterval = function (callback, time) {
      if (typeof time !== 'number') {
        time = 1;
      }
      return setInterval(callback, time);
    };
    var wrappedClearTimeout = function (id) {
      return clearTimeout(id);
    };
    var wrappedClearInterval = function (id) {
      return clearInterval(id);
    };
    var debounce = function (callback, time) {
      var timer;
      var func = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        clearTimeout(timer);
        timer = wrappedSetTimeout(function () {
          callback.apply(this, args);
        }, time);
      };
      func.stop = function () {
        clearTimeout(timer);
      };
      return func;
    };
    var Delay = {
      requestAnimationFrame: function (callback, element) {
        if (requestAnimationFramePromise) {
          requestAnimationFramePromise.then(callback);
          return;
        }
        requestAnimationFramePromise = new promiseObj(function (resolve) {
          if (!element) {
            element = document.body;
          }
          requestAnimationFrame(resolve, element);
        }).then(callback);
      },
      setTimeout: wrappedSetTimeout,
      setInterval: wrappedSetInterval,
      setEditorTimeout: function (editor, callback, time) {
        return wrappedSetTimeout(function () {
          if (!editor.removed) {
            callback();
          }
        }, time);
      },
      setEditorInterval: function (editor, callback, time) {
        var timer = wrappedSetInterval(function () {
          if (!editor.removed) {
            callback();
          } else {
            clearInterval(timer);
          }
        }, time);
        return timer;
      },
      debounce: debounce,
      throttle: debounce,
      clearInterval: wrappedClearInterval,
      clearTimeout: wrappedClearTimeout
    };

    var StyleSheetLoader = function (documentOrShadowRoot, settings) {
      if (settings === void 0) {
        settings = {};
      }
      var idCount = 0;
      var loadedStates = {};
      var edos = SugarElement.fromDom(documentOrShadowRoot);
      var doc = documentOrOwner(edos);
      var maxLoadTime = settings.maxLoadTime || 5000;
      var _setReferrerPolicy = function (referrerPolicy) {
        settings.referrerPolicy = referrerPolicy;
      };
      var addStyle = function (element) {
        append$1(getStyleContainer(edos), element);
      };
      var removeStyle = function (id) {
        var styleContainer = getStyleContainer(edos);
        descendant(styleContainer, '#' + id).each(remove$7);
      };
      var getOrCreateState = function (url) {
        return get$9(loadedStates, url).getOrThunk(function () {
          return {
            id: 'mce-u' + idCount++,
            passed: [],
            failed: [],
            count: 0
          };
        });
      };
      var load = function (url, success, failure) {
        var link;
        var urlWithSuffix = Tools._addCacheSuffix(url);
        var state = getOrCreateState(urlWithSuffix);
        loadedStates[urlWithSuffix] = state;
        state.count++;
        var resolve = function (callbacks, status) {
          var i = callbacks.length;
          while (i--) {
            callbacks[i]();
          }
          state.status = status;
          state.passed = [];
          state.failed = [];
          if (link) {
            link.onload = null;
            link.onerror = null;
            link = null;
          }
        };
        var passed = function () {
          return resolve(state.passed, 2);
        };
        var failed = function () {
          return resolve(state.failed, 3);
        };
        var wait = function (testCallback, waitCallback) {
          if (!testCallback()) {
            if (Date.now() - startTime < maxLoadTime) {
              Delay.setTimeout(waitCallback);
            } else {
              failed();
            }
          }
        };
        var waitForWebKitLinkLoaded = function () {
          wait(function () {
            var styleSheets = documentOrShadowRoot.styleSheets;
            var i = styleSheets.length;
            while (i--) {
              var styleSheet = styleSheets[i];
              var owner = styleSheet.ownerNode;
              if (owner && owner.id === link.id) {
                passed();
                return true;
              }
            }
            return false;
          }, waitForWebKitLinkLoaded);
        };
        if (success) {
          state.passed.push(success);
        }
        if (failure) {
          state.failed.push(failure);
        }
        if (state.status === 1) {
          return;
        }
        if (state.status === 2) {
          passed();
          return;
        }
        if (state.status === 3) {
          failed();
          return;
        }
        state.status = 1;
        var linkElem = SugarElement.fromTag('link', doc.dom);
        setAll$1(linkElem, {
          rel: 'stylesheet',
          type: 'text/css',
          id: state.id
        });
        var startTime = Date.now();
        if (settings.contentCssCors) {
          set$1(linkElem, 'crossOrigin', 'anonymous');
        }
        if (settings.referrerPolicy) {
          set$1(linkElem, 'referrerpolicy', settings.referrerPolicy);
        }
        link = linkElem.dom;
        link.onload = waitForWebKitLinkLoaded;
        link.onerror = failed;
        addStyle(linkElem);
        set$1(linkElem, 'href', urlWithSuffix);
      };
      var loadF = function (url) {
        return Future.nu(function (resolve) {
          load(url, compose(resolve, constant(Result.value(url))), compose(resolve, constant(Result.error(url))));
        });
      };
      var loadAll = function (urls, success, failure) {
        par(map$3(urls, loadF)).get(function (result) {
          var parts = partition(result, function (r) {
            return r.isValue();
          });
          if (parts.fail.length > 0) {
            failure(parts.fail.map(unite));
          } else {
            success(parts.pass.map(unite));
          }
        });
      };
      var unload = function (url) {
        var urlWithSuffix = Tools._addCacheSuffix(url);
        get$9(loadedStates, urlWithSuffix).each(function (state) {
          var count = --state.count;
          if (count === 0) {
            delete loadedStates[urlWithSuffix];
            removeStyle(state.id);
          }
        });
      };
      var unloadAll = function (urls) {
        each$k(urls, function (url) {
          unload(url);
        });
      };
      return {
        load: load,
        loadAll: loadAll,
        unload: unload,
        unloadAll: unloadAll,
        _setReferrerPolicy: _setReferrerPolicy
      };
    };

    var create$8 = function () {
      var map = new WeakMap();
      var forElement = function (referenceElement, settings) {
        var root = getRootNode(referenceElement);
        var rootDom = root.dom;
        return Optional.from(map.get(rootDom)).getOrThunk(function () {
          var sl = StyleSheetLoader(rootDom, settings);
          map.set(rootDom, sl);
          return sl;
        });
      };
      return { forElement: forElement };
    };
    var instance = create$8();

    var DomTreeWalker = function () {
      function DomTreeWalker(startNode, rootNode) {
        this.node = startNode;
        this.rootNode = rootNode;
        this.current = this.current.bind(this);
        this.next = this.next.bind(this);
        this.prev = this.prev.bind(this);
        this.prev2 = this.prev2.bind(this);
      }
      DomTreeWalker.prototype.current = function () {
        return this.node;
      };
      DomTreeWalker.prototype.next = function (shallow) {
        this.node = this.findSibling(this.node, 'firstChild', 'nextSibling', shallow);
        return this.node;
      };
      DomTreeWalker.prototype.prev = function (shallow) {
        this.node = this.findSibling(this.node, 'lastChild', 'previousSibling', shallow);
        return this.node;
      };
      DomTreeWalker.prototype.prev2 = function (shallow) {
        this.node = this.findPreviousNode(this.node, 'lastChild', 'previousSibling', shallow);
        return this.node;
      };
      DomTreeWalker.prototype.findSibling = function (node, startName, siblingName, shallow) {
        var sibling, parent;
        if (node) {
          if (!shallow && node[startName]) {
            return node[startName];
          }
          if (node !== this.rootNode) {
            sibling = node[siblingName];
            if (sibling) {
              return sibling;
            }
            for (parent = node.parentNode; parent && parent !== this.rootNode; parent = parent.parentNode) {
              sibling = parent[siblingName];
              if (sibling) {
                return sibling;
              }
            }
          }
        }
      };
      DomTreeWalker.prototype.findPreviousNode = function (node, startName, siblingName, shallow) {
        var sibling, parent, child;
        if (node) {
          sibling = node[siblingName];
          if (this.rootNode && sibling === this.rootNode) {
            return;
          }
          if (sibling) {
            if (!shallow) {
              for (child = sibling[startName]; child; child = child[startName]) {
                if (!child[startName]) {
                  return child;
                }
              }
            }
            return sibling;
          }
          parent = node.parentNode;
          if (parent && parent !== this.rootNode) {
            return parent;
          }
        }
      };
      return DomTreeWalker;
    }();

    var blocks = [
      'article',
      'aside',
      'details',
      'div',
      'dt',
      'figcaption',
      'footer',
      'form',
      'fieldset',
      'header',
      'hgroup',
      'html',
      'main',
      'nav',
      'section',
      'summary',
      'body',
      'p',
      'dl',
      'multicol',
      'dd',
      'figure',
      'address',
      'center',
      'blockquote',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'listing',
      'xmp',
      'pre',
      'plaintext',
      'menu',
      'dir',
      'ul',
      'ol',
      'li',
      'hr',
      'table',
      'tbody',
      'thead',
      'tfoot',
      'th',
      'tr',
      'td',
      'caption'
    ];
    var tableCells = [
      'td',
      'th'
    ];
    var tableSections = [
      'thead',
      'tbody',
      'tfoot'
    ];
    var textBlocks = [
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'p',
      'div',
      'address',
      'pre',
      'form',
      'blockquote',
      'center',
      'dir',
      'fieldset',
      'header',
      'footer',
      'article',
      'section',
      'hgroup',
      'aside',
      'nav',
      'figure'
    ];
    var headings = [
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6'
    ];
    var listItems$1 = [
      'li',
      'dd',
      'dt'
    ];
    var lists = [
      'ul',
      'ol',
      'dl'
    ];
    var wsElements = [
      'pre',
      'script',
      'textarea',
      'style'
    ];
    var lazyLookup = function (items) {
      var lookup;
      return function (node) {
        lookup = lookup ? lookup : mapToObject(items, always);
        return has$2(lookup, name(node));
      };
    };
    var isHeading = lazyLookup(headings);
    var isBlock$2 = lazyLookup(blocks);
    var isTable$2 = function (node) {
      return name(node) === 'table';
    };
    var isInline$1 = function (node) {
      return isElement$6(node) && !isBlock$2(node);
    };
    var isBr$4 = function (node) {
      return isElement$6(node) && name(node) === 'br';
    };
    var isTextBlock$2 = lazyLookup(textBlocks);
    var isList = lazyLookup(lists);
    var isListItem = lazyLookup(listItems$1);
    var isTableSection = lazyLookup(tableSections);
    var isTableCell$4 = lazyLookup(tableCells);
    var isWsPreserveElement = lazyLookup(wsElements);

    var ancestor$1 = function (scope, selector, isRoot) {
      return ancestor$2(scope, selector, isRoot).isSome();
    };

    var zeroWidth = '\uFEFF';
    var nbsp = '\xA0';
    var isZwsp$1 = function (char) {
      return char === zeroWidth;
    };
    var removeZwsp = function (s) {
      return s.replace(/\uFEFF/g, '');
    };

    var ZWSP$1 = zeroWidth;
    var isZwsp = isZwsp$1;
    var trim$2 = removeZwsp;

    var isElement$4 = isElement$5;
    var isText$6 = isText$7;
    var isCaretContainerBlock$1 = function (node) {
      if (isText$6(node)) {
        node = node.parentNode;
      }
      return isElement$4(node) && node.hasAttribute('data-mce-caret');
    };
    var isCaretContainerInline = function (node) {
      return isText$6(node) && isZwsp(node.data);
    };
    var isCaretContainer$2 = function (node) {
      return isCaretContainerBlock$1(node) || isCaretContainerInline(node);
    };
    var hasContent = function (node) {
      return node.firstChild !== node.lastChild || !isBr$5(node.firstChild);
    };
    var insertInline$1 = function (node, before) {
      var doc = node.ownerDocument;
      var textNode = doc.createTextNode(ZWSP$1);
      var parentNode = node.parentNode;
      if (!before) {
        var sibling = node.nextSibling;
        if (isText$6(sibling)) {
          if (isCaretContainer$2(sibling)) {
            return sibling;
          }
          if (startsWithCaretContainer$1(sibling)) {
            sibling.splitText(1);
            return sibling;
          }
        }
        if (node.nextSibling) {
          parentNode.insertBefore(textNode, node.nextSibling);
        } else {
          parentNode.appendChild(textNode);
        }
      } else {
        var sibling = node.previousSibling;
        if (isText$6(sibling)) {
          if (isCaretContainer$2(sibling)) {
            return sibling;
          }
          if (endsWithCaretContainer$1(sibling)) {
            return sibling.splitText(sibling.data.length - 1);
          }
        }
        parentNode.insertBefore(textNode, node);
      }
      return textNode;
    };
    var isBeforeInline = function (pos) {
      var container = pos.container();
      if (!isText$7(container)) {
        return false;
      }
      return container.data.charAt(pos.offset()) === ZWSP$1 || pos.isAtStart() && isCaretContainerInline(container.previousSibling);
    };
    var isAfterInline = function (pos) {
      var container = pos.container();
      if (!isText$7(container)) {
        return false;
      }
      return container.data.charAt(pos.offset() - 1) === ZWSP$1 || pos.isAtEnd() && isCaretContainerInline(container.nextSibling);
    };
    var createBogusBr = function () {
      var br = document.createElement('br');
      br.setAttribute('data-mce-bogus', '1');
      return br;
    };
    var insertBlock$1 = function (blockName, node, before) {
      var doc = node.ownerDocument;
      var blockNode = doc.createElement(blockName);
      blockNode.setAttribute('data-mce-caret', before ? 'before' : 'after');
      blockNode.setAttribute('data-mce-bogus', 'all');
      blockNode.appendChild(createBogusBr());
      var parentNode = node.parentNode;
      if (!before) {
        if (node.nextSibling) {
          parentNode.insertBefore(blockNode, node.nextSibling);
        } else {
          parentNode.appendChild(blockNode);
        }
      } else {
        parentNode.insertBefore(blockNode, node);
      }
      return blockNode;
    };
    var startsWithCaretContainer$1 = function (node) {
      return isText$6(node) && node.data[0] === ZWSP$1;
    };
    var endsWithCaretContainer$1 = function (node) {
      return isText$6(node) && node.data[node.data.length - 1] === ZWSP$1;
    };
    var trimBogusBr = function (elm) {
      var brs = elm.getElementsByTagName('br');
      var lastBr = brs[brs.length - 1];
      if (isBogus$2(lastBr)) {
        lastBr.parentNode.removeChild(lastBr);
      }
    };
    var showCaretContainerBlock = function (caretContainer) {
      if (caretContainer && caretContainer.hasAttribute('data-mce-caret')) {
        trimBogusBr(caretContainer);
        caretContainer.removeAttribute('data-mce-caret');
        caretContainer.removeAttribute('data-mce-bogus');
        caretContainer.removeAttribute('style');
        caretContainer.removeAttribute('_moz_abspos');
        return caretContainer;
      }
      return null;
    };
    var isRangeInCaretContainerBlock = function (range) {
      return isCaretContainerBlock$1(range.startContainer);
    };

    var isContentEditableTrue$3 = isContentEditableTrue$4;
    var isContentEditableFalse$a = isContentEditableFalse$b;
    var isBr$3 = isBr$5;
    var isText$5 = isText$7;
    var isInvalidTextElement = matchNodeNames([
      'script',
      'style',
      'textarea'
    ]);
    var isAtomicInline = matchNodeNames([
      'img',
      'input',
      'textarea',
      'hr',
      'iframe',
      'video',
      'audio',
      'object',
      'embed'
    ]);
    var isTable$1 = matchNodeNames(['table']);
    var isCaretContainer$1 = isCaretContainer$2;
    var isCaretCandidate$3 = function (node) {
      if (isCaretContainer$1(node)) {
        return false;
      }
      if (isText$5(node)) {
        return !isInvalidTextElement(node.parentNode);
      }
      return isAtomicInline(node) || isBr$3(node) || isTable$1(node) || isNonUiContentEditableFalse(node);
    };
    var isUnselectable = function (node) {
      return isElement$5(node) && node.getAttribute('unselectable') === 'true';
    };
    var isNonUiContentEditableFalse = function (node) {
      return isUnselectable(node) === false && isContentEditableFalse$a(node);
    };
    var isInEditable = function (node, root) {
      for (node = node.parentNode; node && node !== root; node = node.parentNode) {
        if (isNonUiContentEditableFalse(node)) {
          return false;
        }
        if (isContentEditableTrue$3(node)) {
          return true;
        }
      }
      return true;
    };
    var isAtomicContentEditableFalse = function (node) {
      if (!isNonUiContentEditableFalse(node)) {
        return false;
      }
      return foldl(from(node.getElementsByTagName('*')), function (result, elm) {
        return result || isContentEditableTrue$3(elm);
      }, false) !== true;
    };
    var isAtomic$1 = function (node) {
      return isAtomicInline(node) || isAtomicContentEditableFalse(node);
    };
    var isEditableCaretCandidate$1 = function (node, root) {
      return isCaretCandidate$3(node) && isInEditable(node, root);
    };

    var whiteSpaceRegExp$1 = /^[ \t\r\n]*$/;
    var isWhitespaceText = function (text) {
      return whiteSpaceRegExp$1.test(text);
    };

    var hasWhitespacePreserveParent = function (node, rootNode) {
      var rootElement = SugarElement.fromDom(rootNode);
      var startNode = SugarElement.fromDom(node);
      return ancestor$1(startNode, 'pre,code', curry(eq, rootElement));
    };
    var isWhitespace = function (node, rootNode) {
      return isText$7(node) && isWhitespaceText(node.data) && hasWhitespacePreserveParent(node, rootNode) === false;
    };
    var isNamedAnchor = function (node) {
      return isElement$5(node) && node.nodeName === 'A' && !node.hasAttribute('href') && (node.hasAttribute('name') || node.hasAttribute('id'));
    };
    var isContent$1 = function (node, rootNode) {
      return isCaretCandidate$3(node) && isWhitespace(node, rootNode) === false || isNamedAnchor(node) || isBookmark(node);
    };
    var isBookmark = hasAttribute('data-mce-bookmark');
    var isBogus$1 = hasAttribute('data-mce-bogus');
    var isBogusAll = hasAttributeValue('data-mce-bogus', 'all');
    var isEmptyNode = function (targetNode, skipBogus) {
      var brCount = 0;
      if (isContent$1(targetNode, targetNode)) {
        return false;
      } else {
        var node = targetNode.firstChild;
        if (!node) {
          return true;
        }
        var walker = new DomTreeWalker(node, targetNode);
        do {
          if (skipBogus) {
            if (isBogusAll(node)) {
              node = walker.next(true);
              continue;
            }
            if (isBogus$1(node)) {
              node = walker.next();
              continue;
            }
          }
          if (isBr$5(node)) {
            brCount++;
            node = walker.next();
            continue;
          }
          if (isContent$1(node, targetNode)) {
            return false;
          }
          node = walker.next();
        } while (node);
        return brCount <= 1;
      }
    };
    var isEmpty$2 = function (elm, skipBogus) {
      if (skipBogus === void 0) {
        skipBogus = true;
      }
      return isEmptyNode(elm.dom, skipBogus);
    };

    var isSpan = function (node) {
      return node.nodeName.toLowerCase() === 'span';
    };
    var isInlineContent = function (node, root) {
      return isNonNullable(node) && (isContent$1(node, root) || isInline$1(SugarElement.fromDom(node)));
    };
    var surroundedByInlineContent = function (node, root) {
      var prev = new DomTreeWalker(node, root).prev(false);
      var next = new DomTreeWalker(node, root).next(false);
      var prevIsInline = isUndefined(prev) || isInlineContent(prev, root);
      var nextIsInline = isUndefined(next) || isInlineContent(next, root);
      return prevIsInline && nextIsInline;
    };
    var isBookmarkNode$2 = function (node) {
      return isSpan(node) && node.getAttribute('data-mce-type') === 'bookmark';
    };
    var isKeepTextNode = function (node, root) {
      return isText$7(node) && node.data.length > 0 && surroundedByInlineContent(node, root);
    };
    var isKeepElement = function (node) {
      return isElement$5(node) ? node.childNodes.length > 0 : false;
    };
    var isDocument = function (node) {
      return isDocumentFragment(node) || isDocument$1(node);
    };
    var trimNode = function (dom, node, root) {
      var rootNode = root || node;
      if (isElement$5(node) && isBookmarkNode$2(node)) {
        return node;
      }
      var children = node.childNodes;
      for (var i = children.length - 1; i >= 0; i--) {
        trimNode(dom, children[i], rootNode);
      }
      if (isElement$5(node)) {
        var currentChildren = node.childNodes;
        if (currentChildren.length === 1 && isBookmarkNode$2(currentChildren[0])) {
          node.parentNode.insertBefore(currentChildren[0], node);
        }
      }
      if (!isDocument(node) && !isContent$1(node, rootNode) && !isKeepElement(node) && !isKeepTextNode(node, rootNode)) {
        dom.remove(node);
      }
      return node;
    };

    var makeMap$3 = Tools.makeMap;
    var attrsCharsRegExp = /[&<>\"\u0060\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    var textCharsRegExp = /[<>&\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    var rawCharsRegExp = /[<>&\"\']/g;
    var entityRegExp = /&#([a-z0-9]+);?|&([a-z0-9]+);/gi;
    var asciiMap = {
      128: '\u20AC',
      130: '\u201A',
      131: '\u0192',
      132: '\u201E',
      133: '\u2026',
      134: '\u2020',
      135: '\u2021',
      136: '\u02c6',
      137: '\u2030',
      138: '\u0160',
      139: '\u2039',
      140: '\u0152',
      142: '\u017d',
      145: '\u2018',
      146: '\u2019',
      147: '\u201C',
      148: '\u201D',
      149: '\u2022',
      150: '\u2013',
      151: '\u2014',
      152: '\u02DC',
      153: '\u2122',
      154: '\u0161',
      155: '\u203A',
      156: '\u0153',
      158: '\u017e',
      159: '\u0178'
    };
    var baseEntities = {
      '"': '&quot;',
      '\'': '&#39;',
      '<': '&lt;',
      '>': '&gt;',
      '&': '&amp;',
      '`': '&#96;'
    };
    var reverseEntities = {
      '&lt;': '<',
      '&gt;': '>',
      '&amp;': '&',
      '&quot;': '"',
      '&apos;': '\''
    };
    var nativeDecode = function (text) {
      var elm = SugarElement.fromTag('div').dom;
      elm.innerHTML = text;
      return elm.textContent || elm.innerText || text;
    };
    var buildEntitiesLookup = function (items, radix) {
      var i, chr, entity;
      var lookup = {};
      if (items) {
        items = items.split(',');
        radix = radix || 10;
        for (i = 0; i < items.length; i += 2) {
          chr = String.fromCharCode(parseInt(items[i], radix));
          if (!baseEntities[chr]) {
            entity = '&' + items[i + 1] + ';';
            lookup[chr] = entity;
            lookup[entity] = chr;
          }
        }
        return lookup;
      }
    };
    var namedEntities = buildEntitiesLookup('50,nbsp,51,iexcl,52,cent,53,pound,54,curren,55,yen,56,brvbar,57,sect,58,uml,59,copy,' + '5a,ordf,5b,laquo,5c,not,5d,shy,5e,reg,5f,macr,5g,deg,5h,plusmn,5i,sup2,5j,sup3,5k,acute,' + '5l,micro,5m,para,5n,middot,5o,cedil,5p,sup1,5q,ordm,5r,raquo,5s,frac14,5t,frac12,5u,frac34,' + '5v,iquest,60,Agrave,61,Aacute,62,Acirc,63,Atilde,64,Auml,65,Aring,66,AElig,67,Ccedil,' + '68,Egrave,69,Eacute,6a,Ecirc,6b,Euml,6c,Igrave,6d,Iacute,6e,Icirc,6f,Iuml,6g,ETH,6h,Ntilde,' + '6i,Ograve,6j,Oacute,6k,Ocirc,6l,Otilde,6m,Ouml,6n,times,6o,Oslash,6p,Ugrave,6q,Uacute,' + '6r,Ucirc,6s,Uuml,6t,Yacute,6u,THORN,6v,szlig,70,agrave,71,aacute,72,acirc,73,atilde,74,auml,' + '75,aring,76,aelig,77,ccedil,78,egrave,79,eacute,7a,ecirc,7b,euml,7c,igrave,7d,iacute,7e,icirc,' + '7f,iuml,7g,eth,7h,ntilde,7i,ograve,7j,oacute,7k,ocirc,7l,otilde,7m,ouml,7n,divide,7o,oslash,' + '7p,ugrave,7q,uacute,7r,ucirc,7s,uuml,7t,yacute,7u,thorn,7v,yuml,ci,fnof,sh,Alpha,si,Beta,' + 'sj,Gamma,sk,Delta,sl,Epsilon,sm,Zeta,sn,Eta,so,Theta,sp,Iota,sq,Kappa,sr,Lambda,ss,Mu,' + 'st,Nu,su,Xi,sv,Omicron,t0,Pi,t1,Rho,t3,Sigma,t4,Tau,t5,Upsilon,t6,Phi,t7,Chi,t8,Psi,' + 't9,Omega,th,alpha,ti,beta,tj,gamma,tk,delta,tl,epsilon,tm,zeta,tn,eta,to,theta,tp,iota,' + 'tq,kappa,tr,lambda,ts,mu,tt,nu,tu,xi,tv,omicron,u0,pi,u1,rho,u2,sigmaf,u3,sigma,u4,tau,' + 'u5,upsilon,u6,phi,u7,chi,u8,psi,u9,omega,uh,thetasym,ui,upsih,um,piv,812,bull,816,hellip,' + '81i,prime,81j,Prime,81u,oline,824,frasl,88o,weierp,88h,image,88s,real,892,trade,89l,alefsym,' + '8cg,larr,8ch,uarr,8ci,rarr,8cj,darr,8ck,harr,8dl,crarr,8eg,lArr,8eh,uArr,8ei,rArr,8ej,dArr,' + '8ek,hArr,8g0,forall,8g2,part,8g3,exist,8g5,empty,8g7,nabla,8g8,isin,8g9,notin,8gb,ni,8gf,prod,' + '8gh,sum,8gi,minus,8gn,lowast,8gq,radic,8gt,prop,8gu,infin,8h0,ang,8h7,and,8h8,or,8h9,cap,8ha,cup,' + '8hb,int,8hk,there4,8hs,sim,8i5,cong,8i8,asymp,8j0,ne,8j1,equiv,8j4,le,8j5,ge,8k2,sub,8k3,sup,8k4,' + 'nsub,8k6,sube,8k7,supe,8kl,oplus,8kn,otimes,8l5,perp,8m5,sdot,8o8,lceil,8o9,rceil,8oa,lfloor,8ob,' + 'rfloor,8p9,lang,8pa,rang,9ea,loz,9j0,spades,9j3,clubs,9j5,hearts,9j6,diams,ai,OElig,aj,oelig,b0,' + 'Scaron,b1,scaron,bo,Yuml,m6,circ,ms,tilde,802,ensp,803,emsp,809,thinsp,80c,zwnj,80d,zwj,80e,lrm,' + '80f,rlm,80j,ndash,80k,mdash,80o,lsquo,80p,rsquo,80q,sbquo,80s,ldquo,80t,rdquo,80u,bdquo,810,dagger,' + '811,Dagger,81g,permil,81p,lsaquo,81q,rsaquo,85c,euro', 32);
    var encodeRaw = function (text, attr) {
      return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
        return baseEntities[chr] || chr;
      });
    };
    var encodeAllRaw = function (text) {
      return ('' + text).replace(rawCharsRegExp, function (chr) {
        return baseEntities[chr] || chr;
      });
    };
    var encodeNumeric = function (text, attr) {
      return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
        if (chr.length > 1) {
          return '&#' + ((chr.charCodeAt(0) - 55296) * 1024 + (chr.charCodeAt(1) - 56320) + 65536) + ';';
        }
        return baseEntities[chr] || '&#' + chr.charCodeAt(0) + ';';
      });
    };
    var encodeNamed = function (text, attr, entities) {
      entities = entities || namedEntities;
      return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
        return baseEntities[chr] || entities[chr] || chr;
      });
    };
    var getEncodeFunc = function (name, entities) {
      var entitiesMap = buildEntitiesLookup(entities) || namedEntities;
      var encodeNamedAndNumeric = function (text, attr) {
        return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
          if (baseEntities[chr] !== undefined) {
            return baseEntities[chr];
          }
          if (entitiesMap[chr] !== undefined) {
            return entitiesMap[chr];
          }
          if (chr.length > 1) {
            return '&#' + ((chr.charCodeAt(0) - 55296) * 1024 + (chr.charCodeAt(1) - 56320) + 65536) + ';';
          }
          return '&#' + chr.charCodeAt(0) + ';';
        });
      };
      var encodeCustomNamed = function (text, attr) {
        return encodeNamed(text, attr, entitiesMap);
      };
      var nameMap = makeMap$3(name.replace(/\+/g, ','));
      if (nameMap.named && nameMap.numeric) {
        return encodeNamedAndNumeric;
      }
      if (nameMap.named) {
        if (entities) {
          return encodeCustomNamed;
        }
        return encodeNamed;
      }
      if (nameMap.numeric) {
        return encodeNumeric;
      }
      return encodeRaw;
    };
    var decode = function (text) {
      return text.replace(entityRegExp, function (all, numeric) {
        if (numeric) {
          if (numeric.charAt(0).toLowerCase() === 'x') {
            numeric = parseInt(numeric.substr(1), 16);
          } else {
            numeric = parseInt(numeric, 10);
          }
          if (numeric > 65535) {
            numeric -= 65536;
            return String.fromCharCode(55296 + (numeric >> 10), 56320 + (numeric & 1023));
          }
          return asciiMap[numeric] || String.fromCharCode(numeric);
        }
        return reverseEntities[all] || namedEntities[all] || nativeDecode(all);
      });
    };
    var Entities = {
      encodeRaw: encodeRaw,
      encodeAllRaw: encodeAllRaw,
      encodeNumeric: encodeNumeric,
      encodeNamed: encodeNamed,
      getEncodeFunc: getEncodeFunc,
      decode: decode
    };

    var mapCache = {}, dummyObj = {};
    var makeMap$2 = Tools.makeMap, each$h = Tools.each, extend$5 = Tools.extend, explode$3 = Tools.explode, inArray$2 = Tools.inArray;
    var split$1 = function (items, delim) {
      items = Tools.trim(items);
      return items ? items.split(delim || ' ') : [];
    };
    var createMap = function (defaultValue, extendWith) {
      var value = makeMap$2(defaultValue, ' ', makeMap$2(defaultValue.toUpperCase(), ' '));
      return extend$5(value, extendWith);
    };
    var getTextRootBlockElements = function (schema) {
      return createMap('td th li dt dd figcaption caption details summary', schema.getTextBlockElements());
    };
    var compileSchema = function (type) {
      var schema = {};
      var globalAttributes, blockContent;
      var phrasingContent, flowContent, html4BlockContent, html4PhrasingContent;
      var add = function (name, attributes, children) {
        var ni, attributesOrder, element;
        var arrayToMap = function (array, obj) {
          var map = {};
          var i, l;
          for (i = 0, l = array.length; i < l; i++) {
            map[array[i]] = obj || {};
          }
          return map;
        };
        children = children || [];
        attributes = attributes || '';
        if (typeof children === 'string') {
          children = split$1(children);
        }
        var names = split$1(name);
        ni = names.length;
        while (ni--) {
          attributesOrder = split$1([
            globalAttributes,
            attributes
          ].join(' '));
          element = {
            attributes: arrayToMap(attributesOrder),
            attributesOrder: attributesOrder,
            children: arrayToMap(children, dummyObj)
          };
          schema[names[ni]] = element;
        }
      };
      var addAttrs = function (name, attributes) {
        var ni, schemaItem, i, l;
        var names = split$1(name);
        ni = names.length;
        var attrs = split$1(attributes);
        while (ni--) {
          schemaItem = schema[names[ni]];
          for (i = 0, l = attrs.length; i < l; i++) {
            schemaItem.attributes[attrs[i]] = {};
            schemaItem.attributesOrder.push(attrs[i]);
          }
        }
      };
      if (mapCache[type]) {
        return mapCache[type];
      }
      globalAttributes = 'id accesskey class dir lang style tabindex title role';
      blockContent = 'address blockquote div dl fieldset form h1 h2 h3 h4 h5 h6 hr menu ol p pre table ul';
      phrasingContent = 'a abbr b bdo br button cite code del dfn em embed i iframe img input ins kbd ' + 'label map noscript object q s samp script select small span strong sub sup ' + 'textarea u var #text #comment';
      if (type !== 'html4') {
        globalAttributes += ' contenteditable contextmenu draggable dropzone ' + 'hidden spellcheck translate';
        blockContent += ' article aside details dialog figure main header footer hgroup section nav';
        phrasingContent += ' audio canvas command datalist mark meter output picture ' + 'progress time wbr video ruby bdi keygen';
      }
      if (type !== 'html5-strict') {
        globalAttributes += ' xml:lang';
        html4PhrasingContent = 'acronym applet basefont big font strike tt';
        phrasingContent = [
          phrasingContent,
          html4PhrasingContent
        ].join(' ');
        each$h(split$1(html4PhrasingContent), function (name) {
          add(name, '', phrasingContent);
        });
        html4BlockContent = 'center dir isindex noframes';
        blockContent = [
          blockContent,
          html4BlockContent
        ].join(' ');
        flowContent = [
          blockContent,
          phrasingContent
        ].join(' ');
        each$h(split$1(html4BlockContent), function (name) {
          add(name, '', flowContent);
        });
      }
      flowContent = flowContent || [
        blockContent,
        phrasingContent
      ].join(' ');
      add('html', 'manifest', 'head body');
      add('head', '', 'base command link meta noscript script style title');
      add('title hr noscript br');
      add('base', 'href target');
      add('link', 'href rel media hreflang type sizes hreflang');
      add('meta', 'name http-equiv content charset');
      add('style', 'media type scoped');
      add('script', 'src async defer type charset');
      add('body', 'onafterprint onbeforeprint onbeforeunload onblur onerror onfocus ' + 'onhashchange onload onmessage onoffline ononline onpagehide onpageshow ' + 'onpopstate onresize onscroll onstorage onunload', flowContent);
      add('address dt dd div caption', '', flowContent);
      add('h1 h2 h3 h4 h5 h6 pre p abbr code var samp kbd sub sup i b u bdo span legend em strong small s cite dfn', '', phrasingContent);
      add('blockquote', 'cite', flowContent);
      add('ol', 'reversed start type', 'li');
      add('ul', '', 'li');
      add('li', 'value', flowContent);
      add('dl', '', 'dt dd');
      add('a', 'href target rel media hreflang type', phrasingContent);
      add('q', 'cite', phrasingContent);
      add('ins del', 'cite datetime', flowContent);
      add('img', 'src sizes srcset alt usemap ismap width height');
      add('iframe', 'src name width height', flowContent);
      add('embed', 'src type width height');
      add('object', 'data type typemustmatch name usemap form width height', [
        flowContent,
        'param'
      ].join(' '));
      add('param', 'name value');
      add('map', 'name', [
        flowContent,
        'area'
      ].join(' '));
      add('area', 'alt coords shape href target rel media hreflang type');
      add('table', 'border', 'caption colgroup thead tfoot tbody tr' + (type === 'html4' ? ' col' : ''));
      add('colgroup', 'span', 'col');
      add('col', 'span');
      add('tbody thead tfoot', '', 'tr');
      add('tr', '', 'td th');
      add('td', 'colspan rowspan headers', flowContent);
      add('th', 'colspan rowspan headers scope abbr', flowContent);
      add('form', 'accept-charset action autocomplete enctype method name novalidate target', flowContent);
      add('fieldset', 'disabled form name', [
        flowContent,
        'legend'
      ].join(' '));
      add('label', 'form for', phrasingContent);
      add('input', 'accept alt autocomplete checked dirname disabled form formaction formenctype formmethod formnovalidate ' + 'formtarget height list max maxlength min multiple name pattern readonly required size src step type value width');
      add('button', 'disabled form formaction formenctype formmethod formnovalidate formtarget name type value', type === 'html4' ? flowContent : phrasingContent);
      add('select', 'disabled form multiple name required size', 'option optgroup');
      add('optgroup', 'disabled label', 'option');
      add('option', 'disabled label selected value');
      add('textarea', 'cols dirname disabled form maxlength name readonly required rows wrap');
      add('menu', 'type label', [
        flowContent,
        'li'
      ].join(' '));
      add('noscript', '', flowContent);
      if (type !== 'html4') {
        add('wbr');
        add('ruby', '', [
          phrasingContent,
          'rt rp'
        ].join(' '));
        add('figcaption', '', flowContent);
        add('mark rt rp summary bdi', '', phrasingContent);
        add('canvas', 'width height', flowContent);
        add('video', 'src crossorigin poster preload autoplay mediagroup loop ' + 'muted controls width height buffered', [
          flowContent,
          'track source'
        ].join(' '));
        add('audio', 'src crossorigin preload autoplay mediagroup loop muted controls ' + 'buffered volume', [
          flowContent,
          'track source'
        ].join(' '));
        add('picture', '', 'img source');
        add('source', 'src srcset type media sizes');
        add('track', 'kind src srclang label default');
        add('datalist', '', [
          phrasingContent,
          'option'
        ].join(' '));
        add('article section nav aside main header footer', '', flowContent);
        add('hgroup', '', 'h1 h2 h3 h4 h5 h6');
        add('figure', '', [
          flowContent,
          'figcaption'
        ].join(' '));
        add('time', 'datetime', phrasingContent);
        add('dialog', 'open', flowContent);
        add('command', 'type label icon disabled checked radiogroup command');
        add('output', 'for form name', phrasingContent);
        add('progress', 'value max', phrasingContent);
        add('meter', 'value min max low high optimum', phrasingContent);
        add('details', 'open', [
          flowContent,
          'summary'
        ].join(' '));
        add('keygen', 'autofocus challenge disabled form keytype name');
      }
      if (type !== 'html5-strict') {
        addAttrs('script', 'language xml:space');
        addAttrs('style', 'xml:space');
        addAttrs('object', 'declare classid code codebase codetype archive standby align border hspace vspace');
        addAttrs('embed', 'align name hspace vspace');
        addAttrs('param', 'valuetype type');
        addAttrs('a', 'charset name rev shape coords');
        addAttrs('br', 'clear');
        addAttrs('applet', 'codebase archive code object alt name width height align hspace vspace');
        addAttrs('img', 'name longdesc align border hspace vspace');
        addAttrs('iframe', 'longdesc frameborder marginwidth marginheight scrolling align');
        addAttrs('font basefont', 'size color face');
        addAttrs('input', 'usemap align');
        addAttrs('select');
        addAttrs('textarea');
        addAttrs('h1 h2 h3 h4 h5 h6 div p legend caption', 'align');
        addAttrs('ul', 'type compact');
        addAttrs('li', 'type');
        addAttrs('ol dl menu dir', 'compact');
        addAttrs('pre', 'width xml:space');
        addAttrs('hr', 'align noshade size width');
        addAttrs('isindex', 'prompt');
        addAttrs('table', 'summary width frame rules cellspacing cellpadding align bgcolor');
        addAttrs('col', 'width align char charoff valign');
        addAttrs('colgroup', 'width align char charoff valign');
        addAttrs('thead', 'align char charoff valign');
        addAttrs('tr', 'align char charoff valign bgcolor');
        addAttrs('th', 'axis align char charoff valign nowrap bgcolor width height');
        addAttrs('form', 'accept');
        addAttrs('td', 'abbr axis scope align char charoff valign nowrap bgcolor width height');
        addAttrs('tfoot', 'align char charoff valign');
        addAttrs('tbody', 'align char charoff valign');
        addAttrs('area', 'nohref');
        addAttrs('body', 'background bgcolor text link vlink alink');
      }
      if (type !== 'html4') {
        addAttrs('input button select textarea', 'autofocus');
        addAttrs('input textarea', 'placeholder');
        addAttrs('a', 'download');
        addAttrs('link script img', 'crossorigin');
        addAttrs('img', 'loading');
        addAttrs('iframe', 'sandbox seamless allowfullscreen loading');
      }
      each$h(split$1('a form meter progress dfn'), function (name) {
        if (schema[name]) {
          delete schema[name].children[name];
        }
      });
      delete schema.caption.children.table;
      delete schema.script;
      mapCache[type] = schema;
      return schema;
    };
    var compileElementMap = function (value, mode) {
      var styles;
      if (value) {
        styles = {};
        if (typeof value === 'string') {
          value = { '*': value };
        }
        each$h(value, function (value, key) {
          styles[key] = styles[key.toUpperCase()] = mode === 'map' ? makeMap$2(value, /[, ]/) : explode$3(value, /[, ]/);
        });
      }
      return styles;
    };
    var Schema = function (settings) {
      var elements = {};
      var children = {};
      var patternElements = [];
      var customElementsMap = {}, specialElements = {};
      var createLookupTable = function (option, defaultValue, extendWith) {
        var value = settings[option];
        if (!value) {
          value = mapCache[option];
          if (!value) {
            value = createMap(defaultValue, extendWith);
            mapCache[option] = value;
          }
        } else {
          value = makeMap$2(value, /[, ]/, makeMap$2(value.toUpperCase(), /[, ]/));
        }
        return value;
      };
      settings = settings || {};
      var schemaItems = compileSchema(settings.schema);
      if (settings.verify_html === false) {
        settings.valid_elements = '*[*]';
      }
      var validStyles = compileElementMap(settings.valid_styles);
      var invalidStyles = compileElementMap(settings.invalid_styles, 'map');
      var validClasses = compileElementMap(settings.valid_classes, 'map');
      var whiteSpaceElementsMap = createLookupTable('whitespace_elements', 'pre script noscript style textarea video audio iframe object code');
      var selfClosingElementsMap = createLookupTable('self_closing_elements', 'colgroup dd dt li option p td tfoot th thead tr');
      var shortEndedElementsMap = createLookupTable('short_ended_elements', 'area base basefont br col frame hr img input isindex link ' + 'meta param embed source wbr track');
      var boolAttrMap = createLookupTable('boolean_attributes', 'checked compact declare defer disabled ismap multiple nohref noresize ' + 'noshade nowrap readonly selected autoplay loop controls');
      var nonEmptyOrMoveCaretBeforeOnEnter = 'td th iframe video audio object script code';
      var nonEmptyElementsMap = createLookupTable('non_empty_elements', nonEmptyOrMoveCaretBeforeOnEnter + ' pre', shortEndedElementsMap);
      var moveCaretBeforeOnEnterElementsMap = createLookupTable('move_caret_before_on_enter_elements', nonEmptyOrMoveCaretBeforeOnEnter + ' table', shortEndedElementsMap);
      var textBlockElementsMap = createLookupTable('text_block_elements', 'h1 h2 h3 h4 h5 h6 p div address pre form ' + 'blockquote center dir fieldset header footer article section hgroup aside main nav figure');
      var blockElementsMap = createLookupTable('block_elements', 'hr table tbody thead tfoot ' + 'th tr td li ol ul caption dl dt dd noscript menu isindex option ' + 'datalist select optgroup figcaption details summary', textBlockElementsMap);
      var textInlineElementsMap = createLookupTable('text_inline_elements', 'span strong b em i font s strike u var cite ' + 'dfn code mark q sup sub samp');
      each$h((settings.special || 'script noscript iframe noframes noembed title style textarea xmp').split(' '), function (name) {
        specialElements[name] = new RegExp('</' + name + '[^>]*>', 'gi');
      });
      var patternToRegExp = function (str) {
        return new RegExp('^' + str.replace(/([?+*])/g, '.$1') + '$');
      };
      var addValidElements = function (validElements) {
        var ei, el, ai, al, matches, element, attr, attrData, elementName, attrName, attrType, attributes, attributesOrder, prefix, outputName, globalAttributes, globalAttributesOrder, value;
        var elementRuleRegExp = /^([#+\-])?([^\[!\/]+)(?:\/([^\[!]+))?(?:(!?)\[([^\]]+)])?$/, attrRuleRegExp = /^([!\-])?(\w+[\\:]:\w+|[^=:<]+)?(?:([=:<])(.*))?$/, hasPatternsRegExp = /[*?+]/;
        if (validElements) {
          var validElementsArr = split$1(validElements, ',');
          if (elements['@']) {
            globalAttributes = elements['@'].attributes;
            globalAttributesOrder = elements['@'].attributesOrder;
          }
          for (ei = 0, el = validElementsArr.length; ei < el; ei++) {
            matches = elementRuleRegExp.exec(validElementsArr[ei]);
            if (matches) {
              prefix = matches[1];
              elementName = matches[2];
              outputName = matches[3];
              attrData = matches[5];
              attributes = {};
              attributesOrder = [];
              element = {
                attributes: attributes,
                attributesOrder: attributesOrder
              };
              if (prefix === '#') {
                element.paddEmpty = true;
              }
              if (prefix === '-') {
                element.removeEmpty = true;
              }
              if (matches[4] === '!') {
                element.removeEmptyAttrs = true;
              }
              if (globalAttributes) {
                each$j(globalAttributes, function (value, key) {
                  attributes[key] = value;
                });
                attributesOrder.push.apply(attributesOrder, globalAttributesOrder);
              }
              if (attrData) {
                attrData = split$1(attrData, '|');
                for (ai = 0, al = attrData.length; ai < al; ai++) {
                  matches = attrRuleRegExp.exec(attrData[ai]);
                  if (matches) {
                    attr = {};
                    attrType = matches[1];
                    attrName = matches[2].replace(/[\\:]:/g, ':');
                    prefix = matches[3];
                    value = matches[4];
                    if (attrType === '!') {
                      element.attributesRequired = element.attributesRequired || [];
                      element.attributesRequired.push(attrName);
                      attr.required = true;
                    }
                    if (attrType === '-') {
                      delete attributes[attrName];
                      attributesOrder.splice(inArray$2(attributesOrder, attrName), 1);
                      continue;
                    }
                    if (prefix) {
                      if (prefix === '=') {
                        element.attributesDefault = element.attributesDefault || [];
                        element.attributesDefault.push({
                          name: attrName,
                          value: value
                        });
                        attr.defaultValue = value;
                      }
                      if (prefix === ':') {
                        element.attributesForced = element.attributesForced || [];
                        element.attributesForced.push({
                          name: attrName,
                          value: value
                        });
                        attr.forcedValue = value;
                      }
                      if (prefix === '<') {
                        attr.validValues = makeMap$2(value, '?');
                      }
                    }
                    if (hasPatternsRegExp.test(attrName)) {
                      element.attributePatterns = element.attributePatterns || [];
                      attr.pattern = patternToRegExp(attrName);
                      element.attributePatterns.push(attr);
                    } else {
                      if (!attributes[attrName]) {
                        attributesOrder.push(attrName);
                      }
                      attributes[attrName] = attr;
                    }
                  }
                }
              }
              if (!globalAttributes && elementName === '@') {
                globalAttributes = attributes;
                globalAttributesOrder = attributesOrder;
              }
              if (outputName) {
                element.outputName = elementName;
                elements[outputName] = element;
              }
              if (hasPatternsRegExp.test(elementName)) {
                element.pattern = patternToRegExp(elementName);
                patternElements.push(element);
              } else {
                elements[elementName] = element;
              }
            }
          }
        }
      };
      var setValidElements = function (validElements) {
        elements = {};
        patternElements = [];
        addValidElements(validElements);
        each$h(schemaItems, function (element, name) {
          children[name] = element.children;
        });
      };
      var addCustomElements = function (customElements) {
        var customElementRegExp = /^(~)?(.+)$/;
        if (customElements) {
          mapCache.text_block_elements = mapCache.block_elements = null;
          each$h(split$1(customElements, ','), function (rule) {
            var matches = customElementRegExp.exec(rule), inline = matches[1] === '~', cloneName = inline ? 'span' : 'div', name = matches[2];
            children[name] = children[cloneName];
            customElementsMap[name] = cloneName;
            if (!inline) {
              blockElementsMap[name.toUpperCase()] = {};
              blockElementsMap[name] = {};
            }
            if (!elements[name]) {
              var customRule = elements[cloneName];
              customRule = extend$5({}, customRule);
              delete customRule.removeEmptyAttrs;
              delete customRule.removeEmpty;
              elements[name] = customRule;
            }
            each$h(children, function (element, elmName) {
              if (element[cloneName]) {
                children[elmName] = element = extend$5({}, children[elmName]);
                element[name] = element[cloneName];
              }
            });
          });
        }
      };
      var addValidChildren = function (validChildren) {
        var childRuleRegExp = /^([+\-]?)([A-Za-z0-9_\-.\u00b7\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u037d\u037f-\u1fff\u200c-\u200d\u203f-\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]+)\[([^\]]+)]$/;
        mapCache[settings.schema] = null;
        if (validChildren) {
          each$h(split$1(validChildren, ','), function (rule) {
            var matches = childRuleRegExp.exec(rule);
            var parent, prefix;
            if (matches) {
              prefix = matches[1];
              if (prefix) {
                parent = children[matches[2]];
              } else {
                parent = children[matches[2]] = { '#comment': {} };
              }
              parent = children[matches[2]];
              each$h(split$1(matches[3], '|'), function (child) {
                if (prefix === '-') {
                  delete parent[child];
                } else {
                  parent[child] = {};
                }
              });
            }
          });
        }
      };
      var getElementRule = function (name) {
        var element = elements[name], i;
        if (element) {
          return element;
        }
        i = patternElements.length;
        while (i--) {
          element = patternElements[i];
          if (element.pattern.test(name)) {
            return element;
          }
        }
      };
      if (!settings.valid_elements) {
        each$h(schemaItems, function (element, name) {
          elements[name] = {
            attributes: element.attributes,
            attributesOrder: element.attributesOrder
          };
          children[name] = element.children;
        });
        if (settings.schema !== 'html5') {
          each$h(split$1('strong/b em/i'), function (item) {
            var items = split$1(item, '/');
            elements[items[1]].outputName = items[0];
          });
        }
        each$h(textInlineElementsMap, function (_val, name) {
          if (elements[name]) {
            if (settings.padd_empty_block_inline_children) {
              elements[name].paddInEmptyBlock = true;
            }
            elements[name].removeEmpty = true;
          }
        });
        each$h(split$1('ol ul blockquote a table tbody'), function (name) {
          if (elements[name]) {
            elements[name].removeEmpty = true;
          }
        });
        each$h(split$1('p h1 h2 h3 h4 h5 h6 th td pre div address caption li'), function (name) {
          elements[name].paddEmpty = true;
        });
        each$h(split$1('span'), function (name) {
          elements[name].removeEmptyAttrs = true;
        });
      } else {
        setValidElements(settings.valid_elements);
      }
      addCustomElements(settings.custom_elements);
      addValidChildren(settings.valid_children);
      addValidElements(settings.extended_valid_elements);
      addValidChildren('+ol[ul|ol],+ul[ul|ol]');
      each$h({
        dd: 'dl',
        dt: 'dl',
        li: 'ul ol',
        td: 'tr',
        th: 'tr',
        tr: 'tbody thead tfoot',
        tbody: 'table',
        thead: 'table',
        tfoot: 'table',
        legend: 'fieldset',
        area: 'map',
        param: 'video audio object'
      }, function (parents, item) {
        if (elements[item]) {
          elements[item].parentsRequired = split$1(parents);
        }
      });
      if (settings.invalid_elements) {
        each$h(explode$3(settings.invalid_elements), function (item) {
          if (elements[item]) {
            delete elements[item];
          }
        });
      }
      if (!getElementRule('span')) {
        addValidElements('span[!data-mce-type|*]');
      }
      var getValidStyles = constant(validStyles);
      var getInvalidStyles = constant(invalidStyles);
      var getValidClasses = constant(validClasses);
      var getBoolAttrs = constant(boolAttrMap);
      var getBlockElements = constant(blockElementsMap);
      var getTextBlockElements = constant(textBlockElementsMap);
      var getTextInlineElements = constant(textInlineElementsMap);
      var getShortEndedElements = constant(shortEndedElementsMap);
      var getSelfClosingElements = constant(selfClosingElementsMap);
      var getNonEmptyElements = constant(nonEmptyElementsMap);
      var getMoveCaretBeforeOnEnterElements = constant(moveCaretBeforeOnEnterElementsMap);
      var getWhiteSpaceElements = constant(whiteSpaceElementsMap);
      var getSpecialElements = constant(specialElements);
      var isValidChild = function (name, child) {
        var parent = children[name.toLowerCase()];
        return !!(parent && parent[child.toLowerCase()]);
      };
      var isValid = function (name, attr) {
        var attrPatterns, i;
        var rule = getElementRule(name);
        if (rule) {
          if (attr) {
            if (rule.attributes[attr]) {
              return true;
            }
            attrPatterns = rule.attributePatterns;
            if (attrPatterns) {
              i = attrPatterns.length;
              while (i--) {
                if (attrPatterns[i].pattern.test(name)) {
                  return true;
                }
              }
            }
          } else {
            return true;
          }
        }
        return false;
      };
      var getCustomElements = constant(customElementsMap);
      return {
        children: children,
        elements: elements,
        getValidStyles: getValidStyles,
        getValidClasses: getValidClasses,
        getBlockElements: getBlockElements,
        getInvalidStyles: getInvalidStyles,
        getShortEndedElements: getShortEndedElements,
        getTextBlockElements: getTextBlockElements,
        getTextInlineElements: getTextInlineElements,
        getBoolAttrs: getBoolAttrs,
        getElementRule: getElementRule,
        getSelfClosingElements: getSelfClosingElements,
        getNonEmptyElements: getNonEmptyElements,
        getMoveCaretBeforeOnEnterElements: getMoveCaretBeforeOnEnterElements,
        getWhiteSpaceElements: getWhiteSpaceElements,
        getSpecialElements: getSpecialElements,
        isValidChild: isValidChild,
        isValid: isValid,
        getCustomElements: getCustomElements,
        addValidElements: addValidElements,
        setValidElements: setValidElements,
        addCustomElements: addCustomElements,
        addValidChildren: addValidChildren
      };
    };

    var toHex = function (match, r, g, b) {
      var hex = function (val) {
        val = parseInt(val, 10).toString(16);
        return val.length > 1 ? val : '0' + val;
      };
      return '#' + hex(r) + hex(g) + hex(b);
    };
    var Styles = function (settings, schema) {
      var _this = this;
      var rgbRegExp = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/gi;
      var urlOrStrRegExp = /(?:url(?:(?:\(\s*\"([^\"]+)\"\s*\))|(?:\(\s*\'([^\']+)\'\s*\))|(?:\(\s*([^)\s]+)\s*\))))|(?:\'([^\']+)\')|(?:\"([^\"]+)\")/gi;
      var styleRegExp = /\s*([^:]+):\s*([^;]+);?/g;
      var trimRightRegExp = /\s+$/;
      var i;
      var encodingLookup = {};
      var validStyles;
      var invalidStyles;
      var invisibleChar = zeroWidth;
      settings = settings || {};
      if (schema) {
        validStyles = schema.getValidStyles();
        invalidStyles = schema.getInvalidStyles();
      }
      var encodingItems = ('\\" \\\' \\; \\: ; : ' + invisibleChar).split(' ');
      for (i = 0; i < encodingItems.length; i++) {
        encodingLookup[encodingItems[i]] = invisibleChar + i;
        encodingLookup[invisibleChar + i] = encodingItems[i];
      }
      return {
        toHex: function (color) {
          return color.replace(rgbRegExp, toHex);
        },
        parse: function (css) {
          var styles = {};
          var matches, name, value, isEncoded;
          var urlConverter = settings.url_converter;
          var urlConverterScope = settings.url_converter_scope || _this;
          var compress = function (prefix, suffix, noJoin) {
            var top = styles[prefix + '-top' + suffix];
            if (!top) {
              return;
            }
            var right = styles[prefix + '-right' + suffix];
            if (!right) {
              return;
            }
            var bottom = styles[prefix + '-bottom' + suffix];
            if (!bottom) {
              return;
            }
            var left = styles[prefix + '-left' + suffix];
            if (!left) {
              return;
            }
            var box = [
              top,
              right,
              bottom,
              left
            ];
            i = box.length - 1;
            while (i--) {
              if (box[i] !== box[i + 1]) {
                break;
              }
            }
            if (i > -1 && noJoin) {
              return;
            }
            styles[prefix + suffix] = i === -1 ? box[0] : box.join(' ');
            delete styles[prefix + '-top' + suffix];
            delete styles[prefix + '-right' + suffix];
            delete styles[prefix + '-bottom' + suffix];
            delete styles[prefix + '-left' + suffix];
          };
          var canCompress = function (key) {
            var value = styles[key], i;
            if (!value) {
              return;
            }
            value = value.split(' ');
            i = value.length;
            while (i--) {
              if (value[i] !== value[0]) {
                return false;
              }
            }
            styles[key] = value[0];
            return true;
          };
          var compress2 = function (target, a, b, c) {
            if (!canCompress(a)) {
              return;
            }
            if (!canCompress(b)) {
              return;
            }
            if (!canCompress(c)) {
              return;
            }
            styles[target] = styles[a] + ' ' + styles[b] + ' ' + styles[c];
            delete styles[a];
            delete styles[b];
            delete styles[c];
          };
          var encode = function (str) {
            isEncoded = true;
            return encodingLookup[str];
          };
          var decode = function (str, keepSlashes) {
            if (isEncoded) {
              str = str.replace(/\uFEFF[0-9]/g, function (str) {
                return encodingLookup[str];
              });
            }
            if (!keepSlashes) {
              str = str.replace(/\\([\'\";:])/g, '$1');
            }
            return str;
          };
          var decodeSingleHexSequence = function (escSeq) {
            return String.fromCharCode(parseInt(escSeq.slice(1), 16));
          };
          var decodeHexSequences = function (value) {
            return value.replace(/\\[0-9a-f]+/gi, decodeSingleHexSequence);
          };
          var processUrl = function (match, url, url2, url3, str, str2) {
            str = str || str2;
            if (str) {
              str = decode(str);
              return '\'' + str.replace(/\'/g, '\\\'') + '\'';
            }
            url = decode(url || url2 || url3);
            if (!settings.allow_script_urls) {
              var scriptUrl = url.replace(/[\s\r\n]+/g, '');
              if (/(java|vb)script:/i.test(scriptUrl)) {
                return '';
              }
              if (!settings.allow_svg_data_urls && /^data:image\/svg/i.test(scriptUrl)) {
                return '';
              }
            }
            if (urlConverter) {
              url = urlConverter.call(urlConverterScope, url, 'style');
            }
            return 'url(\'' + url.replace(/\'/g, '\\\'') + '\')';
          };
          if (css) {
            css = css.replace(/[\u0000-\u001F]/g, '');
            css = css.replace(/\\[\"\';:\uFEFF]/g, encode).replace(/\"[^\"]+\"|\'[^\']+\'/g, function (str) {
              return str.replace(/[;:]/g, encode);
            });
            while (matches = styleRegExp.exec(css)) {
              styleRegExp.lastIndex = matches.index + matches[0].length;
              name = matches[1].replace(trimRightRegExp, '').toLowerCase();
              value = matches[2].replace(trimRightRegExp, '');
              if (name && value) {
                name = decodeHexSequences(name);
                value = decodeHexSequences(value);
                if (name.indexOf(invisibleChar) !== -1 || name.indexOf('"') !== -1) {
                  continue;
                }
                if (!settings.allow_script_urls && (name === 'behavior' || /expression\s*\(|\/\*|\*\//.test(value))) {
                  continue;
                }
                if (name === 'font-weight' && value === '700') {
                  value = 'bold';
                } else if (name === 'color' || name === 'background-color') {
                  value = value.toLowerCase();
                }
                value = value.replace(rgbRegExp, toHex);
                value = value.replace(urlOrStrRegExp, processUrl);
                styles[name] = isEncoded ? decode(value, true) : value;
              }
            }
            compress('border', '', true);
            compress('border', '-width');
            compress('border', '-color');
            compress('border', '-style');
            compress('padding', '');
            compress('margin', '');
            compress2('border', 'border-width', 'border-style', 'border-color');
            if (styles.border === 'medium none') {
              delete styles.border;
            }
            if (styles['border-image'] === 'none') {
              delete styles['border-image'];
            }
          }
          return styles;
        },
        serialize: function (styles, elementName) {
          var css = '';
          var serializeStyles = function (name) {
            var value;
            var styleList = validStyles[name];
            if (styleList) {
              for (var i_1 = 0, l = styleList.length; i_1 < l; i_1++) {
                name = styleList[i_1];
                value = styles[name];
                if (value) {
                  css += (css.length > 0 ? ' ' : '') + name + ': ' + value + ';';
                }
              }
            }
          };
          var isValid = function (name, elementName) {
            var styleMap = invalidStyles['*'];
            if (styleMap && styleMap[name]) {
              return false;
            }
            styleMap = invalidStyles[elementName];
            return !(styleMap && styleMap[name]);
          };
          if (elementName && validStyles) {
            serializeStyles('*');
            serializeStyles(elementName);
          } else {
            each$j(styles, function (value, name) {
              if (value && (!invalidStyles || isValid(name, elementName))) {
                css += (css.length > 0 ? ' ' : '') + name + ': ' + value + ';';
              }
            });
          }
          return css;
        }
      };
    };

    var deprecated = {
      keyLocation: true,
      layerX: true,
      layerY: true,
      returnValue: true,
      webkitMovementX: true,
      webkitMovementY: true,
      keyIdentifier: true,
      mozPressure: true
    };
    var isNativeEvent = function (event) {
      return event instanceof Event || isFunction(event.initEvent);
    };
    var hasIsDefaultPrevented = function (event) {
      return event.isDefaultPrevented === always || event.isDefaultPrevented === never;
    };
    var needsNormalizing = function (event) {
      return isNullable(event.preventDefault) || isNativeEvent(event);
    };
    var clone$2 = function (originalEvent, data) {
      var event = data !== null && data !== void 0 ? data : {};
      for (var name_1 in originalEvent) {
        if (!has$2(deprecated, name_1)) {
          event[name_1] = originalEvent[name_1];
        }
      }
      if (isNonNullable(event.composedPath)) {
        event.composedPath = function () {
          return originalEvent.composedPath();
        };
      }
      return event;
    };
    var normalize$3 = function (type, originalEvent, fallbackTarget, data) {
      var _a;
      var event = clone$2(originalEvent, data);
      event.type = type;
      if (isNullable(event.target)) {
        event.target = (_a = event.srcElement) !== null && _a !== void 0 ? _a : fallbackTarget;
      }
      if (needsNormalizing(originalEvent)) {
        event.preventDefault = function () {
          event.defaultPrevented = true;
          event.isDefaultPrevented = always;
          if (isFunction(originalEvent.preventDefault)) {
            originalEvent.preventDefault();
          } else if (isNativeEvent(originalEvent)) {
            originalEvent.returnValue = false;
          }
        };
        event.stopPropagation = function () {
          event.cancelBubble = true;
          event.isPropagationStopped = always;
          if (isFunction(originalEvent.stopPropagation)) {
            originalEvent.stopPropagation();
          } else if (isNativeEvent(originalEvent)) {
            originalEvent.cancelBubble = true;
          }
        };
        event.stopImmediatePropagation = function () {
          event.isImmediatePropagationStopped = always;
          event.stopPropagation();
        };
        if (!hasIsDefaultPrevented(event)) {
          event.isDefaultPrevented = event.defaultPrevented === true ? always : never;
          event.isPropagationStopped = event.cancelBubble === true ? always : never;
          event.isImmediatePropagationStopped = never;
        }
      }
      return event;
    };

    var eventExpandoPrefix = 'mce-data-';
    var mouseEventRe = /^(?:mouse|contextmenu)|click/;
    var addEvent = function (target, name, callback, capture) {
      if (target.addEventListener) {
        target.addEventListener(name, callback, capture || false);
      } else if (target.attachEvent) {
        target.attachEvent('on' + name, callback);
      }
    };
    var removeEvent = function (target, name, callback, capture) {
      if (target.removeEventListener) {
        target.removeEventListener(name, callback, capture || false);
      } else if (target.detachEvent) {
        target.detachEvent('on' + name, callback);
      }
    };
    var isMouseEvent = function (event) {
      return isNonNullable(event) && mouseEventRe.test(event.type);
    };
    var fix = function (originalEvent, data) {
      var event = normalize$3(originalEvent.type, originalEvent, document, data);
      if (isMouseEvent(originalEvent) && isUndefined(originalEvent.pageX) && !isUndefined(originalEvent.clientX)) {
        var eventDoc = event.target.ownerDocument || document;
        var doc = eventDoc.documentElement;
        var body = eventDoc.body;
        var mouseEvent = event;
        mouseEvent.pageX = originalEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
        mouseEvent.pageY = originalEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
      }
      if (isUndefined(event.metaKey)) {
        event.metaKey = false;
      }
      return event;
    };
    var bindOnReady = function (win, callback, eventUtils) {
      var doc = win.document, event = { type: 'ready' };
      if (eventUtils.domLoaded) {
        callback(event);
        return;
      }
      var isDocReady = function () {
        return doc.readyState === 'complete' || doc.readyState === 'interactive' && doc.body;
      };
      var readyHandler = function () {
        removeEvent(win, 'DOMContentLoaded', readyHandler);
        removeEvent(win, 'load', readyHandler);
        if (!eventUtils.domLoaded) {
          eventUtils.domLoaded = true;
          callback(event);
        }
        win = null;
      };
      if (isDocReady()) {
        readyHandler();
      } else {
        addEvent(win, 'DOMContentLoaded', readyHandler);
      }
      if (!eventUtils.domLoaded) {
        addEvent(win, 'load', readyHandler);
      }
    };
    var EventUtils = function () {
      function EventUtils() {
        this.domLoaded = false;
        this.events = {};
        this.count = 1;
        this.expando = eventExpandoPrefix + (+new Date()).toString(32);
        this.hasMouseEnterLeave = 'onmouseenter' in document.documentElement;
        this.hasFocusIn = 'onfocusin' in document.documentElement;
        this.count = 1;
      }
      EventUtils.prototype.bind = function (target, names, callback, scope) {
        var self = this;
        var id, callbackList, i, name, fakeName, nativeHandler, capture;
        var win = window;
        var defaultNativeHandler = function (evt) {
          self.executeHandlers(fix(evt || win.event), id);
        };
        if (!target || target.nodeType === 3 || target.nodeType === 8) {
          return;
        }
        if (!target[self.expando]) {
          id = self.count++;
          target[self.expando] = id;
          self.events[id] = {};
        } else {
          id = target[self.expando];
        }
        scope = scope || target;
        var namesList = names.split(' ');
        i = namesList.length;
        while (i--) {
          name = namesList[i];
          nativeHandler = defaultNativeHandler;
          fakeName = capture = false;
          if (name === 'DOMContentLoaded') {
            name = 'ready';
          }
          if (self.domLoaded && name === 'ready' && target.readyState === 'complete') {
            callback.call(scope, fix({ type: name }));
            continue;
          }
          if (!self.hasMouseEnterLeave) {
            fakeName = self.mouseEnterLeave[name];
            if (fakeName) {
              nativeHandler = function (evt) {
                var current = evt.currentTarget;
                var related = evt.relatedTarget;
                if (related && current.contains) {
                  related = current.contains(related);
                } else {
                  while (related && related !== current) {
                    related = related.parentNode;
                  }
                }
                if (!related) {
                  evt = fix(evt || win.event);
                  evt.type = evt.type === 'mouseout' ? 'mouseleave' : 'mouseenter';
                  evt.target = current;
                  self.executeHandlers(evt, id);
                }
              };
            }
          }
          if (!self.hasFocusIn && (name === 'focusin' || name === 'focusout')) {
            capture = true;
            fakeName = name === 'focusin' ? 'focus' : 'blur';
            nativeHandler = function (evt) {
              evt = fix(evt || win.event);
              evt.type = evt.type === 'focus' ? 'focusin' : 'focusout';
              self.executeHandlers(evt, id);
            };
          }
          callbackList = self.events[id][name];
          if (!callbackList) {
            self.events[id][name] = callbackList = [{
                func: callback,
                scope: scope
              }];
            callbackList.fakeName = fakeName;
            callbackList.capture = capture;
            callbackList.nativeHandler = nativeHandler;
            if (name === 'ready') {
              bindOnReady(target, nativeHandler, self);
            } else {
              addEvent(target, fakeName || name, nativeHandler, capture);
            }
          } else {
            if (name === 'ready' && self.domLoaded) {
              callback(fix({ type: name }));
            } else {
              callbackList.push({
                func: callback,
                scope: scope
              });
            }
          }
        }
        target = callbackList = null;
        return callback;
      };
      EventUtils.prototype.unbind = function (target, names, callback) {
        var callbackList, i, ci, name, eventMap;
        if (!target || target.nodeType === 3 || target.nodeType === 8) {
          return this;
        }
        var id = target[this.expando];
        if (id) {
          eventMap = this.events[id];
          if (names) {
            var namesList = names.split(' ');
            i = namesList.length;
            while (i--) {
              name = namesList[i];
              callbackList = eventMap[name];
              if (callbackList) {
                if (callback) {
                  ci = callbackList.length;
                  while (ci--) {
                    if (callbackList[ci].func === callback) {
                      var nativeHandler = callbackList.nativeHandler;
                      var fakeName = callbackList.fakeName, capture = callbackList.capture;
                      callbackList = callbackList.slice(0, ci).concat(callbackList.slice(ci + 1));
                      callbackList.nativeHandler = nativeHandler;
                      callbackList.fakeName = fakeName;
                      callbackList.capture = capture;
                      eventMap[name] = callbackList;
                    }
                  }
                }
                if (!callback || callbackList.length === 0) {
                  delete eventMap[name];
                  removeEvent(target, callbackList.fakeName || name, callbackList.nativeHandler, callbackList.capture);
                }
              }
            }
          } else {
            each$j(eventMap, function (callbackList, name) {
              removeEvent(target, callbackList.fakeName || name, callbackList.nativeHandler, callbackList.capture);
            });
            eventMap = {};
          }
          for (name in eventMap) {
            if (has$2(eventMap, name)) {
              return this;
            }
          }
          delete this.events[id];
          try {
            delete target[this.expando];
          } catch (ex) {
            target[this.expando] = null;
          }
        }
        return this;
      };
      EventUtils.prototype.fire = function (target, name, args) {
        var id;
        if (!target || target.nodeType === 3 || target.nodeType === 8) {
          return this;
        }
        var event = fix({
          type: name,
          target: target
        }, args);
        do {
          id = target[this.expando];
          if (id) {
            this.executeHandlers(event, id);
          }
          target = target.parentNode || target.ownerDocument || target.defaultView || target.parentWindow;
        } while (target && !event.isPropagationStopped());
        return this;
      };
      EventUtils.prototype.clean = function (target) {
        var i, children;
        if (!target || target.nodeType === 3 || target.nodeType === 8) {
          return this;
        }
        if (target[this.expando]) {
          this.unbind(target);
        }
        if (!target.getElementsByTagName) {
          target = target.document;
        }
        if (target && target.getElementsByTagName) {
          this.unbind(target);
          children = target.getElementsByTagName('*');
          i = children.length;
          while (i--) {
            target = children[i];
            if (target[this.expando]) {
              this.unbind(target);
            }
          }
        }
        return this;
      };
      EventUtils.prototype.destroy = function () {
        this.events = {};
      };
      EventUtils.prototype.cancel = function (e) {
        if (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
        return false;
      };
      EventUtils.prototype.executeHandlers = function (evt, id) {
        var container = this.events[id];
        var callbackList = container && container[evt.type];
        if (callbackList) {
          for (var i = 0, l = callbackList.length; i < l; i++) {
            var callback = callbackList[i];
            if (callback && callback.func.call(callback.scope, evt) === false) {
              evt.preventDefault();
            }
            if (evt.isImmediatePropagationStopped()) {
              return;
            }
          }
        }
      };
      EventUtils.Event = new EventUtils();
      return EventUtils;
    }();

    var support, Expr, getText, isXML, tokenize, compile, select$1, outermostContext, sortInput, hasDuplicate, setDocument, document$1, docElem, documentIsHTML, rbuggyQSA, rbuggyMatches, matches, contains, expando = 'sizzle' + -new Date(), preferredDoc = window.document, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), sortOrder = function (a, b) {
        if (a === b) {
          hasDuplicate = true;
        }
        return 0;
      }, strundefined = typeof undefined, MAX_NEGATIVE = 1 << 31, hasOwn = {}.hasOwnProperty, arr = [], pop = arr.pop, push_native = arr.push, push$1 = arr.push, slice$1 = arr.slice, indexOf = arr.indexOf || function (elem) {
        var i = 0, len = this.length;
        for (; i < len; i++) {
          if (this[i] === elem) {
            return i;
          }
        }
        return -1;
      }, booleans = 'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped', whitespace = '[\\x20\\t\\r\\n\\f]', identifier = '(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+', attributes = '\\[' + whitespace + '*(' + identifier + ')(?:' + whitespace + '*([*^$|!~]?=)' + whitespace + '*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' + identifier + '))|)' + whitespace + '*\\]', pseudos = ':(' + identifier + ')(?:\\((' + '(\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|' + '((?:\\\\.|[^\\\\()[\\]]|' + attributes + ')*)|' + '.*' + ')\\)|)', rtrim = new RegExp('^' + whitespace + '+|((?:^|[^\\\\])(?:\\\\.)*)' + whitespace + '+$', 'g'), rcomma = new RegExp('^' + whitespace + '*,' + whitespace + '*'), rcombinators = new RegExp('^' + whitespace + '*([>+~]|' + whitespace + ')' + whitespace + '*'), rattributeQuotes = new RegExp('=' + whitespace + '*([^\\]\'"]*?)' + whitespace + '*\\]', 'g'), rpseudo = new RegExp(pseudos), ridentifier = new RegExp('^' + identifier + '$'), matchExpr = {
        ID: new RegExp('^#(' + identifier + ')'),
        CLASS: new RegExp('^\\.(' + identifier + ')'),
        TAG: new RegExp('^(' + identifier + '|[*])'),
        ATTR: new RegExp('^' + attributes),
        PSEUDO: new RegExp('^' + pseudos),
        CHILD: new RegExp('^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' + whitespace + '*(even|odd|(([+-]|)(\\d*)n|)' + whitespace + '*(?:([+-]|)' + whitespace + '*(\\d+)|))' + whitespace + '*\\)|)', 'i'),
        bool: new RegExp('^(?:' + booleans + ')$', 'i'),
        needsContext: new RegExp('^' + whitespace + '*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' + whitespace + '*((?:-\\d)?\\d*)' + whitespace + '*\\)|)(?=[^-]|$)', 'i')
      }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rnative = /^[^{]+\{\s*\[native \w/, rquickExpr$1 = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, rescape = /'|\\/g, runescape = new RegExp('\\\\([\\da-f]{1,6}' + whitespace + '?|(' + whitespace + ')|.)', 'ig'), funescape = function (_, escaped, escapedWhitespace) {
        var high = '0x' + escaped - 65536;
        return high !== high || escapedWhitespace ? escaped : high < 0 ? String.fromCharCode(high + 65536) : String.fromCharCode(high >> 10 | 55296, high & 1023 | 56320);
      };
    try {
      push$1.apply(arr = slice$1.call(preferredDoc.childNodes), preferredDoc.childNodes);
      arr[preferredDoc.childNodes.length].nodeType;
    } catch (e) {
      push$1 = {
        apply: arr.length ? function (target, els) {
          push_native.apply(target, slice$1.call(els));
        } : function (target, els) {
          var j = target.length, i = 0;
          while (target[j++] = els[i++]) {
          }
          target.length = j - 1;
        }
      };
    }
    var Sizzle = function (selector, context, results, seed) {
      var match, elem, m, nodeType, i, groups, old, nid, newContext, newSelector;
      if ((context ? context.ownerDocument || context : preferredDoc) !== document$1) {
        setDocument(context);
      }
      context = context || document$1;
      results = results || [];
      if (!selector || typeof selector !== 'string') {
        return results;
      }
      if ((nodeType = context.nodeType) !== 1 && nodeType !== 9) {
        return [];
      }
      if (documentIsHTML && !seed) {
        if (match = rquickExpr$1.exec(selector)) {
          if (m = match[1]) {
            if (nodeType === 9) {
              elem = context.getElementById(m);
              if (elem && elem.parentNode) {
                if (elem.id === m) {
                  results.push(elem);
                  return results;
                }
              } else {
                return results;
              }
            } else {
              if (context.ownerDocument && (elem = context.ownerDocument.getElementById(m)) && contains(context, elem) && elem.id === m) {
                results.push(elem);
                return results;
              }
            }
          } else if (match[2]) {
            push$1.apply(results, context.getElementsByTagName(selector));
            return results;
          } else if ((m = match[3]) && support.getElementsByClassName) {
            push$1.apply(results, context.getElementsByClassName(m));
            return results;
          }
        }
        if (support.qsa && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
          nid = old = expando;
          newContext = context;
          newSelector = nodeType === 9 && selector;
          if (nodeType === 1 && context.nodeName.toLowerCase() !== 'object') {
            groups = tokenize(selector);
            if (old = context.getAttribute('id')) {
              nid = old.replace(rescape, '\\$&');
            } else {
              context.setAttribute('id', nid);
            }
            nid = '[id=\'' + nid + '\'] ';
            i = groups.length;
            while (i--) {
              groups[i] = nid + toSelector(groups[i]);
            }
            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
            newSelector = groups.join(',');
          }
          if (newSelector) {
            try {
              push$1.apply(results, newContext.querySelectorAll(newSelector));
              return results;
            } catch (qsaError) {
            } finally {
              if (!old) {
                context.removeAttribute('id');
              }
            }
          }
        }
      }
      return select$1(selector.replace(rtrim, '$1'), context, results, seed);
    };
    function createCache() {
      var keys = [];
      function cache(key, value) {
        if (keys.push(key + ' ') > Expr.cacheLength) {
          delete cache[keys.shift()];
        }
        return cache[key + ' '] = value;
      }
      return cache;
    }
    function markFunction(fn) {
      fn[expando] = true;
      return fn;
    }
    function siblingCheck(a, b) {
      var cur = b && a, diff = cur && a.nodeType === 1 && b.nodeType === 1 && (~b.sourceIndex || MAX_NEGATIVE) - (~a.sourceIndex || MAX_NEGATIVE);
      if (diff) {
        return diff;
      }
      if (cur) {
        while (cur = cur.nextSibling) {
          if (cur === b) {
            return -1;
          }
        }
      }
      return a ? 1 : -1;
    }
    function createInputPseudo(type) {
      return function (elem) {
        var name = elem.nodeName.toLowerCase();
        return name === 'input' && elem.type === type;
      };
    }
    function createButtonPseudo(type) {
      return function (elem) {
        var name = elem.nodeName.toLowerCase();
        return (name === 'input' || name === 'button') && elem.type === type;
      };
    }
    function createPositionalPseudo(fn) {
      return markFunction(function (argument) {
        argument = +argument;
        return markFunction(function (seed, matches) {
          var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
          while (i--) {
            if (seed[j = matchIndexes[i]]) {
              seed[j] = !(matches[j] = seed[j]);
            }
          }
        });
      });
    }
    function testContext(context) {
      return context && typeof context.getElementsByTagName !== strundefined && context;
    }
    support = Sizzle.support = {};
    isXML = Sizzle.isXML = function (elem) {
      var documentElement = elem && (elem.ownerDocument || elem).documentElement;
      return documentElement ? documentElement.nodeName !== 'HTML' : false;
    };
    setDocument = Sizzle.setDocument = function (node) {
      var hasCompare, doc = node ? node.ownerDocument || node : preferredDoc, parent = doc.defaultView;
      function getTop(win) {
        try {
          return win.top;
        } catch (ex) {
        }
        return null;
      }
      if (doc === document$1 || doc.nodeType !== 9 || !doc.documentElement) {
        return document$1;
      }
      document$1 = doc;
      docElem = doc.documentElement;
      documentIsHTML = !isXML(doc);
      if (parent && parent !== getTop(parent)) {
        if (parent.addEventListener) {
          parent.addEventListener('unload', function () {
            setDocument();
          }, false);
        } else if (parent.attachEvent) {
          parent.attachEvent('onunload', function () {
            setDocument();
          });
        }
      }
      support.attributes = true;
      support.getElementsByTagName = true;
      support.getElementsByClassName = rnative.test(doc.getElementsByClassName);
      support.getById = true;
      Expr.find.ID = function (id, context) {
        if (typeof context.getElementById !== strundefined && documentIsHTML) {
          var m = context.getElementById(id);
          return m && m.parentNode ? [m] : [];
        }
      };
      Expr.filter.ID = function (id) {
        var attrId = id.replace(runescape, funescape);
        return function (elem) {
          return elem.getAttribute('id') === attrId;
        };
      };
      Expr.find.TAG = support.getElementsByTagName ? function (tag, context) {
        if (typeof context.getElementsByTagName !== strundefined) {
          return context.getElementsByTagName(tag);
        }
      } : function (tag, context) {
        var elem, tmp = [], i = 0, results = context.getElementsByTagName(tag);
        if (tag === '*') {
          while (elem = results[i++]) {
            if (elem.nodeType === 1) {
              tmp.push(elem);
            }
          }
          return tmp;
        }
        return results;
      };
      Expr.find.CLASS = support.getElementsByClassName && function (className, context) {
        if (documentIsHTML) {
          return context.getElementsByClassName(className);
        }
      };
      rbuggyMatches = [];
      rbuggyQSA = [];
      support.disconnectedMatch = true;
      rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join('|'));
      rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join('|'));
      hasCompare = rnative.test(docElem.compareDocumentPosition);
      contains = hasCompare || rnative.test(docElem.contains) ? function (a, b) {
        var adown = a.nodeType === 9 ? a.documentElement : a, bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
      } : function (a, b) {
        if (b) {
          while (b = b.parentNode) {
            if (b === a) {
              return true;
            }
          }
        }
        return false;
      };
      sortOrder = hasCompare ? function (a, b) {
        if (a === b) {
          hasDuplicate = true;
          return 0;
        }
        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
        if (compare) {
          return compare;
        }
        compare = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1;
        if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
          if (a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a)) {
            return -1;
          }
          if (b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b)) {
            return 1;
          }
          return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
        }
        return compare & 4 ? -1 : 1;
      } : function (a, b) {
        if (a === b) {
          hasDuplicate = true;
          return 0;
        }
        var cur, i = 0, aup = a.parentNode, bup = b.parentNode, ap = [a], bp = [b];
        if (!aup || !bup) {
          return a === doc ? -1 : b === doc ? 1 : aup ? -1 : bup ? 1 : sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
        } else if (aup === bup) {
          return siblingCheck(a, b);
        }
        cur = a;
        while (cur = cur.parentNode) {
          ap.unshift(cur);
        }
        cur = b;
        while (cur = cur.parentNode) {
          bp.unshift(cur);
        }
        while (ap[i] === bp[i]) {
          i++;
        }
        return i ? siblingCheck(ap[i], bp[i]) : ap[i] === preferredDoc ? -1 : bp[i] === preferredDoc ? 1 : 0;
      };
      return doc;
    };
    Sizzle.matches = function (expr, elements) {
      return Sizzle(expr, null, null, elements);
    };
    Sizzle.matchesSelector = function (elem, expr) {
      if ((elem.ownerDocument || elem) !== document$1) {
        setDocument(elem);
      }
      expr = expr.replace(rattributeQuotes, '=\'$1\']');
      if (support.matchesSelector && documentIsHTML && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
        try {
          var ret = matches.call(elem, expr);
          if (ret || support.disconnectedMatch || elem.document && elem.document.nodeType !== 11) {
            return ret;
          }
        } catch (e) {
        }
      }
      return Sizzle(expr, document$1, null, [elem]).length > 0;
    };
    Sizzle.contains = function (context, elem) {
      if ((context.ownerDocument || context) !== document$1) {
        setDocument(context);
      }
      return contains(context, elem);
    };
    Sizzle.attr = function (elem, name) {
      if ((elem.ownerDocument || elem) !== document$1) {
        setDocument(elem);
      }
      var fn = Expr.attrHandle[name.toLowerCase()], val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
      return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
    };
    Sizzle.error = function (msg) {
      throw new Error('Syntax error, unrecognized expression: ' + msg);
    };
    Sizzle.uniqueSort = function (results) {
      var elem, duplicates = [], j = 0, i = 0;
      hasDuplicate = !support.detectDuplicates;
      sortInput = !support.sortStable && results.slice(0);
      results.sort(sortOrder);
      if (hasDuplicate) {
        while (elem = results[i++]) {
          if (elem === results[i]) {
            j = duplicates.push(i);
          }
        }
        while (j--) {
          results.splice(duplicates[j], 1);
        }
      }
      sortInput = null;
      return results;
    };
    getText = Sizzle.getText = function (elem) {
      var node, ret = '', i = 0, nodeType = elem.nodeType;
      if (!nodeType) {
        while (node = elem[i++]) {
          ret += getText(node);
        }
      } else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
        if (typeof elem.textContent === 'string') {
          return elem.textContent;
        } else {
          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
            ret += getText(elem);
          }
        }
      } else if (nodeType === 3 || nodeType === 4) {
        return elem.nodeValue;
      }
      return ret;
    };
    Expr = Sizzle.selectors = {
      cacheLength: 50,
      createPseudo: markFunction,
      match: matchExpr,
      attrHandle: {},
      find: {},
      relative: {
        '>': {
          dir: 'parentNode',
          first: true
        },
        ' ': { dir: 'parentNode' },
        '+': {
          dir: 'previousSibling',
          first: true
        },
        '~': { dir: 'previousSibling' }
      },
      preFilter: {
        ATTR: function (match) {
          match[1] = match[1].replace(runescape, funescape);
          match[3] = (match[3] || match[4] || match[5] || '').replace(runescape, funescape);
          if (match[2] === '~=') {
            match[3] = ' ' + match[3] + ' ';
          }
          return match.slice(0, 4);
        },
        CHILD: function (match) {
          match[1] = match[1].toLowerCase();
          if (match[1].slice(0, 3) === 'nth') {
            if (!match[3]) {
              Sizzle.error(match[0]);
            }
            match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === 'even' || match[3] === 'odd'));
            match[5] = +(match[7] + match[8] || match[3] === 'odd');
          } else if (match[3]) {
            Sizzle.error(match[0]);
          }
          return match;
        },
        PSEUDO: function (match) {
          var excess, unquoted = !match[6] && match[2];
          if (matchExpr.CHILD.test(match[0])) {
            return null;
          }
          if (match[3]) {
            match[2] = match[4] || match[5] || '';
          } else if (unquoted && rpseudo.test(unquoted) && (excess = tokenize(unquoted, true)) && (excess = unquoted.indexOf(')', unquoted.length - excess) - unquoted.length)) {
            match[0] = match[0].slice(0, excess);
            match[2] = unquoted.slice(0, excess);
          }
          return match.slice(0, 3);
        }
      },
      filter: {
        TAG: function (nodeNameSelector) {
          var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
          return nodeNameSelector === '*' ? function () {
            return true;
          } : function (elem) {
            return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
          };
        },
        CLASS: function (className) {
          var pattern = classCache[className + ' '];
          return pattern || (pattern = new RegExp('(^|' + whitespace + ')' + className + '(' + whitespace + '|$)')) && classCache(className, function (elem) {
            return pattern.test(typeof elem.className === 'string' && elem.className || typeof elem.getAttribute !== strundefined && elem.getAttribute('class') || '');
          });
        },
        ATTR: function (name, operator, check) {
          return function (elem) {
            var result = Sizzle.attr(elem, name);
            if (result == null) {
              return operator === '!=';
            }
            if (!operator) {
              return true;
            }
            result += '';
            return operator === '=' ? result === check : operator === '!=' ? result !== check : operator === '^=' ? check && result.indexOf(check) === 0 : operator === '*=' ? check && result.indexOf(check) > -1 : operator === '$=' ? check && result.slice(-check.length) === check : operator === '~=' ? (' ' + result + ' ').indexOf(check) > -1 : operator === '|=' ? result === check || result.slice(0, check.length + 1) === check + '-' : false;
          };
        },
        CHILD: function (type, what, argument, first, last) {
          var simple = type.slice(0, 3) !== 'nth', forward = type.slice(-4) !== 'last', ofType = what === 'of-type';
          return first === 1 && last === 0 ? function (elem) {
            return !!elem.parentNode;
          } : function (elem, context, xml) {
            var cache, outerCache, node, diff, nodeIndex, start, dir = simple !== forward ? 'nextSibling' : 'previousSibling', parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType;
            if (parent) {
              if (simple) {
                while (dir) {
                  node = elem;
                  while (node = node[dir]) {
                    if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {
                      return false;
                    }
                  }
                  start = dir = type === 'only' && !start && 'nextSibling';
                }
                return true;
              }
              start = [forward ? parent.firstChild : parent.lastChild];
              if (forward && useCache) {
                outerCache = parent[expando] || (parent[expando] = {});
                cache = outerCache[type] || [];
                nodeIndex = cache[0] === dirruns && cache[1];
                diff = cache[0] === dirruns && cache[2];
                node = nodeIndex && parent.childNodes[nodeIndex];
                while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {
                  if (node.nodeType === 1 && ++diff && node === elem) {
                    outerCache[type] = [
                      dirruns,
                      nodeIndex,
                      diff
                    ];
                    break;
                  }
                }
              } else if (useCache && (cache = (elem[expando] || (elem[expando] = {}))[type]) && cache[0] === dirruns) {
                diff = cache[1];
              } else {
                while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {
                  if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                    if (useCache) {
                      (node[expando] || (node[expando] = {}))[type] = [
                        dirruns,
                        diff
                      ];
                    }
                    if (node === elem) {
                      break;
                    }
                  }
                }
              }
              diff -= last;
              return diff === first || diff % first === 0 && diff / first >= 0;
            }
          };
        },
        PSEUDO: function (pseudo, argument) {
          var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error('unsupported pseudo: ' + pseudo);
          if (fn[expando]) {
            return fn(argument);
          }
          if (fn.length > 1) {
            args = [
              pseudo,
              pseudo,
              '',
              argument
            ];
            return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function (seed, matches) {
              var idx, matched = fn(seed, argument), i = matched.length;
              while (i--) {
                idx = indexOf.call(seed, matched[i]);
                seed[idx] = !(matches[idx] = matched[i]);
              }
            }) : function (elem) {
              return fn(elem, 0, args);
            };
          }
          return fn;
        }
      },
      pseudos: {
        not: markFunction(function (selector) {
          var input = [], results = [], matcher = compile(selector.replace(rtrim, '$1'));
          return matcher[expando] ? markFunction(function (seed, matches, context, xml) {
            var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
            while (i--) {
              if (elem = unmatched[i]) {
                seed[i] = !(matches[i] = elem);
              }
            }
          }) : function (elem, context, xml) {
            input[0] = elem;
            matcher(input, null, xml, results);
            input[0] = null;
            return !results.pop();
          };
        }),
        has: markFunction(function (selector) {
          return function (elem) {
            return Sizzle(selector, elem).length > 0;
          };
        }),
        contains: markFunction(function (text) {
          text = text.replace(runescape, funescape);
          return function (elem) {
            return (elem.textContent || elem.innerText || getText(elem)).indexOf(text) > -1;
          };
        }),
        lang: markFunction(function (lang) {
          if (!ridentifier.test(lang || '')) {
            Sizzle.error('unsupported lang: ' + lang);
          }
          lang = lang.replace(runescape, funescape).toLowerCase();
          return function (elem) {
            var elemLang;
            do {
              if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute('xml:lang') || elem.getAttribute('lang')) {
                elemLang = elemLang.toLowerCase();
                return elemLang === lang || elemLang.indexOf(lang + '-') === 0;
              }
            } while ((elem = elem.parentNode) && elem.nodeType === 1);
            return false;
          };
        }),
        target: function (elem) {
          var hash = window.location && window.location.hash;
          return hash && hash.slice(1) === elem.id;
        },
        root: function (elem) {
          return elem === docElem;
        },
        focus: function (elem) {
          return elem === document$1.activeElement && (!document$1.hasFocus || document$1.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
        },
        enabled: function (elem) {
          return elem.disabled === false;
        },
        disabled: function (elem) {
          return elem.disabled === true;
        },
        checked: function (elem) {
          var nodeName = elem.nodeName.toLowerCase();
          return nodeName === 'input' && !!elem.checked || nodeName === 'option' && !!elem.selected;
        },
        selected: function (elem) {
          if (elem.parentNode) {
            elem.parentNode.selectedIndex;
          }
          return elem.selected === true;
        },
        empty: function (elem) {
          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
            if (elem.nodeType < 6) {
              return false;
            }
          }
          return true;
        },
        parent: function (elem) {
          return !Expr.pseudos.empty(elem);
        },
        header: function (elem) {
          return rheader.test(elem.nodeName);
        },
        input: function (elem) {
          return rinputs.test(elem.nodeName);
        },
        button: function (elem) {
          var name = elem.nodeName.toLowerCase();
          return name === 'input' && elem.type === 'button' || name === 'button';
        },
        text: function (elem) {
          var attr;
          return elem.nodeName.toLowerCase() === 'input' && elem.type === 'text' && ((attr = elem.getAttribute('type')) == null || attr.toLowerCase() === 'text');
        },
        first: createPositionalPseudo(function () {
          return [0];
        }),
        last: createPositionalPseudo(function (matchIndexes, length) {
          return [length - 1];
        }),
        eq: createPositionalPseudo(function (matchIndexes, length, argument) {
          return [argument < 0 ? argument + length : argument];
        }),
        even: createPositionalPseudo(function (matchIndexes, length) {
          var i = 0;
          for (; i < length; i += 2) {
            matchIndexes.push(i);
          }
          return matchIndexes;
        }),
        odd: createPositionalPseudo(function (matchIndexes, length) {
          var i = 1;
          for (; i < length; i += 2) {
            matchIndexes.push(i);
          }
          return matchIndexes;
        }),
        lt: createPositionalPseudo(function (matchIndexes, length, argument) {
          var i = argument < 0 ? argument + length : argument;
          for (; --i >= 0;) {
            matchIndexes.push(i);
          }
          return matchIndexes;
        }),
        gt: createPositionalPseudo(function (matchIndexes, length, argument) {
          var i = argument < 0 ? argument + length : argument;
          for (; ++i < length;) {
            matchIndexes.push(i);
          }
          return matchIndexes;
        })
      }
    };
    Expr.pseudos.nth = Expr.pseudos.eq;
    each$k([
      'radio',
      'checkbox',
      'file',
      'password',
      'image'
    ], function (i) {
      Expr.pseudos[i] = createInputPseudo(i);
    });
    each$k([
      'submit',
      'reset'
    ], function (i) {
      Expr.pseudos[i] = createButtonPseudo(i);
    });
    function setFilters() {
    }
    setFilters.prototype = Expr.filters = Expr.pseudos;
    Expr.setFilters = new setFilters();
    tokenize = Sizzle.tokenize = function (selector, parseOnly) {
      var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + ' '];
      if (cached) {
        return parseOnly ? 0 : cached.slice(0);
      }
      soFar = selector;
      groups = [];
      preFilters = Expr.preFilter;
      while (soFar) {
        if (!matched || (match = rcomma.exec(soFar))) {
          if (match) {
            soFar = soFar.slice(match[0].length) || soFar;
          }
          groups.push(tokens = []);
        }
        matched = false;
        if (match = rcombinators.exec(soFar)) {
          matched = match.shift();
          tokens.push({
            value: matched,
            type: match[0].replace(rtrim, ' ')
          });
          soFar = soFar.slice(matched.length);
        }
        for (type in Expr.filter) {
          if (!Expr.filter.hasOwnProperty(type)) {
            continue;
          }
          if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
            matched = match.shift();
            tokens.push({
              value: matched,
              type: type,
              matches: match
            });
            soFar = soFar.slice(matched.length);
          }
        }
        if (!matched) {
          break;
        }
      }
      return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : tokenCache(selector, groups).slice(0);
    };
    function toSelector(tokens) {
      var i = 0, len = tokens.length, selector = '';
      for (; i < len; i++) {
        selector += tokens[i].value;
      }
      return selector;
    }
    function addCombinator(matcher, combinator, base) {
      var dir = combinator.dir, checkNonElements = base && dir === 'parentNode', doneName = done++;
      return combinator.first ? function (elem, context, xml) {
        while (elem = elem[dir]) {
          if (elem.nodeType === 1 || checkNonElements) {
            return matcher(elem, context, xml);
          }
        }
      } : function (elem, context, xml) {
        var oldCache, outerCache, newCache = [
            dirruns,
            doneName
          ];
        if (xml) {
          while (elem = elem[dir]) {
            if (elem.nodeType === 1 || checkNonElements) {
              if (matcher(elem, context, xml)) {
                return true;
              }
            }
          }
        } else {
          while (elem = elem[dir]) {
            if (elem.nodeType === 1 || checkNonElements) {
              outerCache = elem[expando] || (elem[expando] = {});
              if ((oldCache = outerCache[dir]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
                return newCache[2] = oldCache[2];
              } else {
                outerCache[dir] = newCache;
                if (newCache[2] = matcher(elem, context, xml)) {
                  return true;
                }
              }
            }
          }
        }
      };
    }
    function elementMatcher(matchers) {
      return matchers.length > 1 ? function (elem, context, xml) {
        var i = matchers.length;
        while (i--) {
          if (!matchers[i](elem, context, xml)) {
            return false;
          }
        }
        return true;
      } : matchers[0];
    }
    function multipleContexts(selector, contexts, results) {
      var i = 0, len = contexts.length;
      for (; i < len; i++) {
        Sizzle(selector, contexts[i], results);
      }
      return results;
    }
    function condense(unmatched, map, filter, context, xml) {
      var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
      for (; i < len; i++) {
        if (elem = unmatched[i]) {
          if (!filter || filter(elem, context, xml)) {
            newUnmatched.push(elem);
            if (mapped) {
              map.push(i);
            }
          }
        }
      }
      return newUnmatched;
    }
    function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
      if (postFilter && !postFilter[expando]) {
        postFilter = setMatcher(postFilter);
      }
      if (postFinder && !postFinder[expando]) {
        postFinder = setMatcher(postFinder, postSelector);
      }
      return markFunction(function (seed, results, context, xml) {
        var temp, i, elem, preMap = [], postMap = [], preexisting = results.length, elems = seed || multipleContexts(selector || '*', context.nodeType ? [context] : context, []), matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems, matcherOut = matcher ? postFinder || (seed ? preFilter : preexisting || postFilter) ? [] : results : matcherIn;
        if (matcher) {
          matcher(matcherIn, matcherOut, context, xml);
        }
        if (postFilter) {
          temp = condense(matcherOut, postMap);
          postFilter(temp, [], context, xml);
          i = temp.length;
          while (i--) {
            if (elem = temp[i]) {
              matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
            }
          }
        }
        if (seed) {
          if (postFinder || preFilter) {
            if (postFinder) {
              temp = [];
              i = matcherOut.length;
              while (i--) {
                if (elem = matcherOut[i]) {
                  temp.push(matcherIn[i] = elem);
                }
              }
              postFinder(null, matcherOut = [], temp, xml);
            }
            i = matcherOut.length;
            while (i--) {
              if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) {
                seed[temp] = !(results[temp] = elem);
              }
            }
          }
        } else {
          matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
          if (postFinder) {
            postFinder(null, results, matcherOut, xml);
          } else {
            push$1.apply(results, matcherOut);
          }
        }
      });
    }
    function matcherFromTokens(tokens) {
      var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[' '], i = leadingRelative ? 1 : 0, matchContext = addCombinator(function (elem) {
          return elem === checkContext;
        }, implicitRelative, true), matchAnyContext = addCombinator(function (elem) {
          return indexOf.call(checkContext, elem) > -1;
        }, implicitRelative, true), matchers = [function (elem, context, xml) {
            var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
            checkContext = null;
            return ret;
          }];
      for (; i < len; i++) {
        if (matcher = Expr.relative[tokens[i].type]) {
          matchers = [addCombinator(elementMatcher(matchers), matcher)];
        } else {
          matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
          if (matcher[expando]) {
            j = ++i;
            for (; j < len; j++) {
              if (Expr.relative[tokens[j].type]) {
                break;
              }
            }
            return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(tokens.slice(0, i - 1).concat({ value: tokens[i - 2].type === ' ' ? '*' : '' })).replace(rtrim, '$1'), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
          }
          matchers.push(matcher);
        }
      }
      return elementMatcher(matchers);
    }
    function matcherFromGroupMatchers(elementMatchers, setMatchers) {
      var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function (seed, context, xml, results, outermost) {
          var elem, j, matcher, matchedCount = 0, i = '0', unmatched = seed && [], setMatched = [], contextBackup = outermostContext, elems = seed || byElement && Expr.find.TAG('*', outermost), dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
          if (outermost) {
            outermostContext = context !== document$1 && context;
          }
          for (; i !== len && (elem = elems[i]) != null; i++) {
            if (byElement && elem) {
              j = 0;
              while (matcher = elementMatchers[j++]) {
                if (matcher(elem, context, xml)) {
                  results.push(elem);
                  break;
                }
              }
              if (outermost) {
                dirruns = dirrunsUnique;
              }
            }
            if (bySet) {
              if (elem = !matcher && elem) {
                matchedCount--;
              }
              if (seed) {
                unmatched.push(elem);
              }
            }
          }
          matchedCount += i;
          if (bySet && i !== matchedCount) {
            j = 0;
            while (matcher = setMatchers[j++]) {
              matcher(unmatched, setMatched, context, xml);
            }
            if (seed) {
              if (matchedCount > 0) {
                while (i--) {
                  if (!(unmatched[i] || setMatched[i])) {
                    setMatched[i] = pop.call(results);
                  }
                }
              }
              setMatched = condense(setMatched);
            }
            push$1.apply(results, setMatched);
            if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {
              Sizzle.uniqueSort(results);
            }
          }
          if (outermost) {
            dirruns = dirrunsUnique;
            outermostContext = contextBackup;
          }
          return unmatched;
        };
      return bySet ? markFunction(superMatcher) : superMatcher;
    }
    compile = Sizzle.compile = function (selector, match) {
      var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + ' '];
      if (!cached) {
        if (!match) {
          match = tokenize(selector);
        }
        i = match.length;
        while (i--) {
          cached = matcherFromTokens(match[i]);
          if (cached[expando]) {
            setMatchers.push(cached);
          } else {
            elementMatchers.push(cached);
          }
        }
        cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
        cached.selector = selector;
      }
      return cached;
    };
    select$1 = Sizzle.select = function (selector, context, results, seed) {
      var i, tokens, token, type, find, compiled = typeof selector === 'function' && selector, match = !seed && tokenize(selector = compiled.selector || selector);
      results = results || [];
      if (match.length === 1) {
        tokens = match[0] = match[0].slice(0);
        if (tokens.length > 2 && (token = tokens[0]).type === 'ID' && support.getById && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
          context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
          if (!context) {
            return results;
          } else if (compiled) {
            context = context.parentNode;
          }
          selector = selector.slice(tokens.shift().value.length);
        }
        i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
        while (i--) {
          token = tokens[i];
          if (Expr.relative[type = token.type]) {
            break;
          }
          if (find = Expr.find[type]) {
            if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
              tokens.splice(i, 1);
              selector = seed.length && toSelector(tokens);
              if (!selector) {
                push$1.apply(results, seed);
                return results;
              }
              break;
            }
          }
        }
      }
      (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, rsibling.test(selector) && testContext(context.parentNode) || context);
      return results;
    };
    support.sortStable = expando.split('').sort(sortOrder).join('') === expando;
    support.detectDuplicates = !!hasDuplicate;
    setDocument();
    support.sortDetached = true;

    var doc = document;
    var push = Array.prototype.push;
    var slice = Array.prototype.slice;
    var rquickExpr = /^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/;
    var Event$1 = EventUtils.Event;
    var skipUniques = Tools.makeMap('children,contents,next,prev');
    var isDefined = function (obj) {
      return typeof obj !== 'undefined';
    };
    var isString = function (obj) {
      return typeof obj === 'string';
    };
    var isWindow = function (obj) {
      return obj && obj === obj.window;
    };
    var createFragment$1 = function (html, fragDoc) {
      fragDoc = fragDoc || doc;
      var container = fragDoc.createElement('div');
      var frag = fragDoc.createDocumentFragment();
      container.innerHTML = html;
      var node;
      while (node = container.firstChild) {
        frag.appendChild(node);
      }
      return frag;
    };
    var domManipulate = function (targetNodes, sourceItem, callback, reverse) {
      var i;
      if (isString(sourceItem)) {
        sourceItem = createFragment$1(sourceItem, getElementDocument(targetNodes[0]));
      } else if (sourceItem.length && !sourceItem.nodeType) {
        sourceItem = DomQuery.makeArray(sourceItem);
        if (reverse) {
          for (i = sourceItem.length - 1; i >= 0; i--) {
            domManipulate(targetNodes, sourceItem[i], callback, reverse);
          }
        } else {
          for (i = 0; i < sourceItem.length; i++) {
            domManipulate(targetNodes, sourceItem[i], callback, reverse);
          }
        }
        return targetNodes;
      }
      if (sourceItem.nodeType) {
        i = targetNodes.length;
        while (i--) {
          callback.call(targetNodes[i], sourceItem);
        }
      }
      return targetNodes;
    };
    var hasClass = function (node, className) {
      return node && className && (' ' + node.className + ' ').indexOf(' ' + className + ' ') !== -1;
    };
    var wrap$2 = function (elements, wrapper, all) {
      var lastParent, newWrapper;
      wrapper = DomQuery(wrapper)[0];
      elements.each(function () {
        var self = this;
        if (!all || lastParent !== self.parentNode) {
          lastParent = self.parentNode;
          newWrapper = wrapper.cloneNode(false);
          self.parentNode.insertBefore(newWrapper, self);
          newWrapper.appendChild(self);
        } else {
          newWrapper.appendChild(self);
        }
      });
      return elements;
    };
    var numericCssMap = Tools.makeMap('fillOpacity fontWeight lineHeight opacity orphans widows zIndex zoom', ' ');
    var booleanMap = Tools.makeMap('checked compact declare defer disabled ismap multiple nohref noshade nowrap readonly selected', ' ');
    var propFix = {
      for: 'htmlFor',
      class: 'className',
      readonly: 'readOnly'
    };
    var cssFix = { float: 'cssFloat' };
    var attrHooks = {}, cssHooks = {};
    var DomQueryConstructor = function (selector, context) {
      return new DomQuery.fn.init(selector, context);
    };
    var inArray$1 = function (item, array) {
      var i;
      if (array.indexOf) {
        return array.indexOf(item);
      }
      i = array.length;
      while (i--) {
        if (array[i] === item) {
          return i;
        }
      }
      return -1;
    };
    var whiteSpaceRegExp = /^\s*|\s*$/g;
    var trim$1 = function (str) {
      return str === null || str === undefined ? '' : ('' + str).replace(whiteSpaceRegExp, '');
    };
    var each$g = function (obj, callback) {
      var length, key, i, value;
      if (obj) {
        length = obj.length;
        if (length === undefined) {
          for (key in obj) {
            if (obj.hasOwnProperty(key)) {
              value = obj[key];
              if (callback.call(value, key, value) === false) {
                break;
              }
            }
          }
        } else {
          for (i = 0; i < length; i++) {
            value = obj[i];
            if (callback.call(value, i, value) === false) {
              break;
            }
          }
        }
      }
      return obj;
    };
    var grep$2 = function (array, callback) {
      var out = [];
      each$g(array, function (i, item) {
        if (callback(item, i)) {
          out.push(item);
        }
      });
      return out;
    };
    var getElementDocument = function (element) {
      if (!element) {
        return doc;
      }
      if (element.nodeType === 9) {
        return element;
      }
      return element.ownerDocument;
    };
    DomQueryConstructor.fn = DomQueryConstructor.prototype = {
      constructor: DomQueryConstructor,
      selector: '',
      context: null,
      length: 0,
      init: function (selector, context) {
        var self = this;
        var match, node;
        if (!selector) {
          return self;
        }
        if (selector.nodeType) {
          self.context = self[0] = selector;
          self.length = 1;
          return self;
        }
        if (context && context.nodeType) {
          self.context = context;
        } else {
          if (context) {
            return DomQuery(selector).attr(context);
          }
          self.context = context = document;
        }
        if (isString(selector)) {
          self.selector = selector;
          if (selector.charAt(0) === '<' && selector.charAt(selector.length - 1) === '>' && selector.length >= 3) {
            match = [
              null,
              selector,
              null
            ];
          } else {
            match = rquickExpr.exec(selector);
          }
          if (match) {
            if (match[1]) {
              node = createFragment$1(selector, getElementDocument(context)).firstChild;
              while (node) {
                push.call(self, node);
                node = node.nextSibling;
              }
            } else {
              node = getElementDocument(context).getElementById(match[2]);
              if (!node) {
                return self;
              }
              if (node.id !== match[2]) {
                return self.find(selector);
              }
              self.length = 1;
              self[0] = node;
            }
          } else {
            return DomQuery(context).find(selector);
          }
        } else {
          this.add(selector, false);
        }
        return self;
      },
      toArray: function () {
        return Tools.toArray(this);
      },
      add: function (items, sort) {
        var self = this;
        var nodes, i;
        if (isString(items)) {
          return self.add(DomQuery(items));
        }
        if (sort !== false) {
          nodes = DomQuery.unique(self.toArray().concat(DomQuery.makeArray(items)));
          self.length = nodes.length;
          for (i = 0; i < nodes.length; i++) {
            self[i] = nodes[i];
          }
        } else {
          push.apply(self, DomQuery.makeArray(items));
        }
        return self;
      },
      attr: function (name, value) {
        var self = this;
        var hook;
        if (typeof name === 'object') {
          each$g(name, function (name, value) {
            self.attr(name, value);
          });
        } else if (isDefined(value)) {
          this.each(function () {
            var hook;
            if (this.nodeType === 1) {
              hook = attrHooks[name];
              if (hook && hook.set) {
                hook.set(this, value);
                return;
              }
              if (value === null) {
                this.removeAttribute(name, 2);
              } else {
                this.setAttribute(name, value, 2);
              }
            }
          });
        } else {
          if (self[0] && self[0].nodeType === 1) {
            hook = attrHooks[name];
            if (hook && hook.get) {
              return hook.get(self[0], name);
            }
            if (booleanMap[name]) {
              return self.prop(name) ? name : undefined;
            }
            value = self[0].getAttribute(name, 2);
            if (value === null) {
              value = undefined;
            }
          }
          return value;
        }
        return self;
      },
      removeAttr: function (name) {
        return this.attr(name, null);
      },
      prop: function (name, value) {
        var self = this;
        name = propFix[name] || name;
        if (typeof name === 'object') {
          each$g(name, function (name, value) {
            self.prop(name, value);
          });
        } else if (isDefined(value)) {
          this.each(function () {
            if (this.nodeType === 1) {
              this[name] = value;
            }
          });
        } else {
          if (self[0] && self[0].nodeType && name in self[0]) {
            return self[0][name];
          }
          return value;
        }
        return self;
      },
      css: function (name, value) {
        var self = this;
        var elm, hook;
        var camel = function (name) {
          return name.replace(/-(\D)/g, function (a, b) {
            return b.toUpperCase();
          });
        };
        var dashed = function (name) {
          return name.replace(/[A-Z]/g, function (a) {
            return '-' + a;
          });
        };
        if (typeof name === 'object') {
          each$g(name, function (name, value) {
            self.css(name, value);
          });
        } else {
          if (isDefined(value)) {
            name = camel(name);
            if (typeof value === 'number' && !numericCssMap[name]) {
              value = value.toString() + 'px';
            }
            self.each(function () {
              var style = this.style;
              hook = cssHooks[name];
              if (hook && hook.set) {
                hook.set(this, value);
                return;
              }
              try {
                this.style[cssFix[name] || name] = value;
              } catch (ex) {
              }
              if (value === null || value === '') {
                if (style.removeProperty) {
                  style.removeProperty(dashed(name));
                } else {
                  style.removeAttribute(name);
                }
              }
            });
          } else {
            elm = self[0];
            hook = cssHooks[name];
            if (hook && hook.get) {
              return hook.get(elm);
            }
            if (elm.ownerDocument.defaultView) {
              try {
                return elm.ownerDocument.defaultView.getComputedStyle(elm, null).getPropertyValue(dashed(name));
              } catch (ex) {
                return undefined;
              }
            } else if (elm.currentStyle) {
              return elm.currentStyle[camel(name)];
            } else {
              return '';
            }
          }
        }
        return self;
      },
      remove: function () {
        var self = this;
        var node, i = this.length;
        while (i--) {
          node = self[i];
          Event$1.clean(node);
          if (node.parentNode) {
            node.parentNode.removeChild(node);
          }
        }
        return this;
      },
      empty: function () {
        var self = this;
        var node, i = this.length;
        while (i--) {
          node = self[i];
          while (node.firstChild) {
            node.removeChild(node.firstChild);
          }
        }
        return this;
      },
      html: function (value) {
        var self = this;
        var i;
        if (isDefined(value)) {
          i = self.length;
          try {
            while (i--) {
              self[i].innerHTML = value;
            }
          } catch (ex) {
            DomQuery(self[i]).empty().append(value);
          }
          return self;
        }
        return self[0] ? self[0].innerHTML : '';
      },
      text: function (value) {
        var self = this;
        var i;
        if (isDefined(value)) {
          i = self.length;
          while (i--) {
            if ('innerText' in self[i]) {
              self[i].innerText = value;
            } else {
              self[0].textContent = value;
            }
          }
          return self;
        }
        return self[0] ? self[0].innerText || self[0].textContent : '';
      },
      append: function () {
        return domManipulate(this, arguments, function (node) {
          if (this.nodeType === 1 || this.host && this.host.nodeType === 1) {
            this.appendChild(node);
          }
        });
      },
      prepend: function () {
        return domManipulate(this, arguments, function (node) {
          if (this.nodeType === 1 || this.host && this.host.nodeType === 1) {
            this.insertBefore(node, this.firstChild);
          }
        }, true);
      },
      before: function () {
        var self = this;
        if (self[0] && self[0].parentNode) {
          return domManipulate(self, arguments, function (node) {
            this.parentNode.insertBefore(node, this);
          });
        }
        return self;
      },
      after: function () {
        var self = this;
        if (self[0] && self[0].parentNode) {
          return domManipulate(self, arguments, function (node) {
            this.parentNode.insertBefore(node, this.nextSibling);
          }, true);
        }
        return self;
      },
      appendTo: function (val) {
        DomQuery(val).append(this);
        return this;
      },
      prependTo: function (val) {
        DomQuery(val).prepend(this);
        return this;
      },
      replaceWith: function (content) {
        return this.before(content).remove();
      },
      wrap: function (content) {
        return wrap$2(this, content);
      },
      wrapAll: function (content) {
        return wrap$2(this, content, true);
      },
      wrapInner: function (content) {
        this.each(function () {
          DomQuery(this).contents().wrapAll(content);
        });
        return this;
      },
      unwrap: function () {
        return this.parent().each(function () {
          DomQuery(this).replaceWith(this.childNodes);
        });
      },
      clone: function () {
        var result = [];
        this.each(function () {
          result.push(this.cloneNode(true));
        });
        return DomQuery(result);
      },
      addClass: function (className) {
        return this.toggleClass(className, true);
      },
      removeClass: function (className) {
        return this.toggleClass(className, false);
      },
      toggleClass: function (className, state) {
        var self = this;
        if (typeof className !== 'string') {
          return self;
        }
        if (className.indexOf(' ') !== -1) {
          each$g(className.split(' '), function () {
            self.toggleClass(this, state);
          });
        } else {
          self.each(function (index, node) {
            var classState = hasClass(node, className);
            if (classState !== state) {
              var existingClassName = node.className;
              if (classState) {
                node.className = trim$1((' ' + existingClassName + ' ').replace(' ' + className + ' ', ' '));
              } else {
                node.className += existingClassName ? ' ' + className : className;
              }
            }
          });
        }
        return self;
      },
      hasClass: function (className) {
        return hasClass(this[0], className);
      },
      each: function (callback) {
        return each$g(this, callback);
      },
      on: function (name, callback) {
        return this.each(function () {
          Event$1.bind(this, name, callback);
        });
      },
      off: function (name, callback) {
        return this.each(function () {
          Event$1.unbind(this, name, callback);
        });
      },
      trigger: function (name) {
        return this.each(function () {
          if (typeof name === 'object') {
            Event$1.fire(this, name.type, name);
          } else {
            Event$1.fire(this, name);
          }
        });
      },
      show: function () {
        return this.css('display', '');
      },
      hide: function () {
        return this.css('display', 'none');
      },
      slice: function () {
        return DomQuery(slice.apply(this, arguments));
      },
      eq: function (index) {
        return index === -1 ? this.slice(index) : this.slice(index, +index + 1);
      },
      first: function () {
        return this.eq(0);
      },
      last: function () {
        return this.eq(-1);
      },
      find: function (selector) {
        var i, l;
        var ret = [];
        for (i = 0, l = this.length; i < l; i++) {
          DomQuery.find(selector, this[i], ret);
        }
        return DomQuery(ret);
      },
      filter: function (selector) {
        if (typeof selector === 'function') {
          return DomQuery(grep$2(this.toArray(), function (item, i) {
            return selector(i, item);
          }));
        }
        return DomQuery(DomQuery.filter(selector, this.toArray()));
      },
      closest: function (selector) {
        var result = [];
        if (selector instanceof DomQuery) {
          selector = selector[0];
        }
        this.each(function (i, node) {
          while (node) {
            if (typeof selector === 'string' && DomQuery(node).is(selector)) {
              result.push(node);
              break;
            } else if (node === selector) {
              result.push(node);
              break;
            }
            node = node.parentNode;
          }
        });
        return DomQuery(result);
      },
      offset: function (offset) {
        var elm, doc, docElm;
        var x = 0, y = 0, pos;
        if (!offset) {
          elm = this[0];
          if (elm) {
            doc = elm.ownerDocument;
            docElm = doc.documentElement;
            if (elm.getBoundingClientRect) {
              pos = elm.getBoundingClientRect();
              x = pos.left + (docElm.scrollLeft || doc.body.scrollLeft) - docElm.clientLeft;
              y = pos.top + (docElm.scrollTop || doc.body.scrollTop) - docElm.clientTop;
            }
          }
          return {
            left: x,
            top: y
          };
        }
        return this.css(offset);
      },
      push: push,
      sort: Array.prototype.sort,
      splice: Array.prototype.splice
    };
    Tools.extend(DomQueryConstructor, {
      extend: Tools.extend,
      makeArray: function (object) {
        if (isWindow(object) || object.nodeType) {
          return [object];
        }
        return Tools.toArray(object);
      },
      inArray: inArray$1,
      isArray: Tools.isArray,
      each: each$g,
      trim: trim$1,
      grep: grep$2,
      find: Sizzle,
      expr: Sizzle.selectors,
      unique: Sizzle.uniqueSort,
      text: Sizzle.getText,
      contains: Sizzle.contains,
      filter: function (expr, elems, not) {
        var i = elems.length;
        if (not) {
          expr = ':not(' + expr + ')';
        }
        while (i--) {
          if (elems[i].nodeType !== 1) {
            elems.splice(i, 1);
          }
        }
        if (elems.length === 1) {
          elems = DomQuery.find.matchesSelector(elems[0], expr) ? [elems[0]] : [];
        } else {
          elems = DomQuery.find.matches(expr, elems);
        }
        return elems;
      }
    });
    var dir = function (el, prop, until) {
      var matched = [];
      var cur = el[prop];
      if (typeof until !== 'string' && until instanceof DomQuery) {
        until = until[0];
      }
      while (cur && cur.nodeType !== 9) {
        if (until !== undefined) {
          if (cur === until) {
            break;
          }
          if (typeof until === 'string' && DomQuery(cur).is(until)) {
            break;
          }
        }
        if (cur.nodeType === 1) {
          matched.push(cur);
        }
        cur = cur[prop];
      }
      return matched;
    };
    var sibling$1 = function (node, siblingName, nodeType, until) {
      var result = [];
      if (until instanceof DomQuery) {
        until = until[0];
      }
      for (; node; node = node[siblingName]) {
        if (nodeType && node.nodeType !== nodeType) {
          continue;
        }
        if (until !== undefined) {
          if (node === until) {
            break;
          }
          if (typeof until === 'string' && DomQuery(node).is(until)) {
            break;
          }
        }
        result.push(node);
      }
      return result;
    };
    var firstSibling = function (node, siblingName, nodeType) {
      for (node = node[siblingName]; node; node = node[siblingName]) {
        if (node.nodeType === nodeType) {
          return node;
        }
      }
      return null;
    };
    each$g({
      parent: function (node) {
        var parent = node.parentNode;
        return parent && parent.nodeType !== 11 ? parent : null;
      },
      parents: function (node) {
        return dir(node, 'parentNode');
      },
      next: function (node) {
        return firstSibling(node, 'nextSibling', 1);
      },
      prev: function (node) {
        return firstSibling(node, 'previousSibling', 1);
      },
      children: function (node) {
        return sibling$1(node.firstChild, 'nextSibling', 1);
      },
      contents: function (node) {
        return Tools.toArray((node.nodeName === 'iframe' ? node.contentDocument || node.contentWindow.document : node).childNodes);
      }
    }, function (name, fn) {
      DomQueryConstructor.fn[name] = function (selector) {
        var self = this;
        var result = [];
        self.each(function () {
          var nodes = fn.call(result, this, selector, result);
          if (nodes) {
            if (DomQuery.isArray(nodes)) {
              result.push.apply(result, nodes);
            } else {
              result.push(nodes);
            }
          }
        });
        if (this.length > 1) {
          if (!skipUniques[name]) {
            result = DomQuery.unique(result);
          }
          if (name.indexOf('parents') === 0) {
            result = result.reverse();
          }
        }
        var wrappedResult = DomQuery(result);
        if (selector) {
          return wrappedResult.filter(selector);
        }
        return wrappedResult;
      };
    });
    each$g({
      parentsUntil: function (node, until) {
        return dir(node, 'parentNode', until);
      },
      nextUntil: function (node, until) {
        return sibling$1(node, 'nextSibling', 1, until).slice(1);
      },
      prevUntil: function (node, until) {
        return sibling$1(node, 'previousSibling', 1, until).slice(1);
      }
    }, function (name, fn) {
      DomQueryConstructor.fn[name] = function (selector, filter) {
        var self = this;
        var result = [];
        self.each(function () {
          var nodes = fn.call(result, this, selector, result);
          if (nodes) {
            if (DomQuery.isArray(nodes)) {
              result.push.apply(result, nodes);
            } else {
              result.push(nodes);
            }
          }
        });
        if (this.length > 1) {
          result = DomQuery.unique(result);
          if (name.indexOf('parents') === 0 || name === 'prevUntil') {
            result = result.reverse();
          }
        }
        var wrappedResult = DomQuery(result);
        if (filter) {
          return wrappedResult.filter(filter);
        }
        return wrappedResult;
      };
    });
    DomQueryConstructor.fn.is = function (selector) {
      return !!selector && this.filter(selector).length > 0;
    };
    DomQueryConstructor.fn.init.prototype = DomQueryConstructor.fn;
    DomQueryConstructor.overrideDefaults = function (callback) {
      var defaults;
      var sub = function (selector, context) {
        defaults = defaults || callback();
        if (arguments.length === 0) {
          selector = defaults.element;
        }
        if (!context) {
          context = defaults.context;
        }
        return new sub.fn.init(selector, context);
      };
      DomQuery.extend(sub, this);
      return sub;
    };
    DomQueryConstructor.attrHooks = attrHooks;
    DomQueryConstructor.cssHooks = cssHooks;
    var DomQuery = DomQueryConstructor;

    var each$f = Tools.each;
    var grep$1 = Tools.grep;
    var isIE = Env.ie;
    var simpleSelectorRe = /^([a-z0-9],?)+$/i;
    var setupAttrHooks = function (styles, settings, getContext) {
      var keepValues = settings.keep_values;
      var keepUrlHook = {
        set: function ($elm, value, name) {
          if (settings.url_converter && value !== null) {
            value = settings.url_converter.call(settings.url_converter_scope || getContext(), value, name, $elm[0]);
          }
          $elm.attr('data-mce-' + name, value).attr(name, value);
        },
        get: function ($elm, name) {
          return $elm.attr('data-mce-' + name) || $elm.attr(name);
        }
      };
      var attrHooks = {
        style: {
          set: function ($elm, value) {
            if (value !== null && typeof value === 'object') {
              $elm.css(value);
              return;
            }
            if (keepValues) {
              $elm.attr('data-mce-style', value);
            }
            if (value !== null && typeof value === 'string') {
              $elm.removeAttr('style');
              $elm.css(styles.parse(value));
            } else {
              $elm.attr('style', value);
            }
          },
          get: function ($elm) {
            var value = $elm.attr('data-mce-style') || $elm.attr('style');
            value = styles.serialize(styles.parse(value), $elm[0].nodeName);
            return value;
          }
        }
      };
      if (keepValues) {
        attrHooks.href = attrHooks.src = keepUrlHook;
      }
      return attrHooks;
    };
    var updateInternalStyleAttr = function (styles, $elm) {
      var rawValue = $elm.attr('style');
      var value = styles.serialize(styles.parse(rawValue), $elm[0].nodeName);
      if (!value) {
        value = null;
      }
      $elm.attr('data-mce-style', value);
    };
    var findNodeIndex = function (node, normalized) {
      var idx = 0, lastNodeType, nodeType;
      if (node) {
        for (lastNodeType = node.nodeType, node = node.previousSibling; node; node = node.previousSibling) {
          nodeType = node.nodeType;
          if (normalized && nodeType === 3) {
            if (nodeType === lastNodeType || !node.nodeValue.length) {
              continue;
            }
          }
          idx++;
          lastNodeType = nodeType;
        }
      }
      return idx;
    };
    var DOMUtils = function (doc, settings) {
      if (settings === void 0) {
        settings = {};
      }
      var addedStyles = {};
      var win = window;
      var files = {};
      var counter = 0;
      var stdMode = true;
      var boxModel = true;
      var styleSheetLoader = instance.forElement(SugarElement.fromDom(doc), {
        contentCssCors: settings.contentCssCors,
        referrerPolicy: settings.referrerPolicy
      });
      var boundEvents = [];
      var schema = settings.schema ? settings.schema : Schema({});
      var styles = Styles({
        url_converter: settings.url_converter,
        url_converter_scope: settings.url_converter_scope
      }, settings.schema);
      var events = settings.ownEvents ? new EventUtils() : EventUtils.Event;
      var blockElementsMap = schema.getBlockElements();
      var $ = DomQuery.overrideDefaults(function () {
        return {
          context: doc,
          element: self.getRoot()
        };
      });
      var isBlock = function (node) {
        if (typeof node === 'string') {
          return !!blockElementsMap[node];
        } else if (node) {
          var type = node.nodeType;
          if (type) {
            return !!(type === 1 && blockElementsMap[node.nodeName]);
          }
        }
        return false;
      };
      var get = function (elm) {
        return elm && doc && isString$1(elm) ? doc.getElementById(elm) : elm;
      };
      var $$ = function (elm) {
        return $(typeof elm === 'string' ? get(elm) : elm);
      };
      var getAttrib = function (elm, name, defaultVal) {
        var hook, value;
        var $elm = $$(elm);
        if ($elm.length) {
          hook = attrHooks[name];
          if (hook && hook.get) {
            value = hook.get($elm, name);
          } else {
            value = $elm.attr(name);
          }
        }
        if (typeof value === 'undefined') {
          value = defaultVal || '';
        }
        return value;
      };
      var getAttribs = function (elm) {
        var node = get(elm);
        if (!node) {
          return [];
        }
        return node.attributes;
      };
      var setAttrib = function (elm, name, value) {
        if (value === '') {
          value = null;
        }
        var $elm = $$(elm);
        var originalValue = $elm.attr(name);
        if (!$elm.length) {
          return;
        }
        var hook = attrHooks[name];
        if (hook && hook.set) {
          hook.set($elm, value, name);
        } else {
          $elm.attr(name, value);
        }
        if (originalValue !== value && settings.onSetAttrib) {
          settings.onSetAttrib({
            attrElm: $elm,
            attrName: name,
            attrValue: value
          });
        }
      };
      var clone = function (node, deep) {
        if (!isIE || node.nodeType !== 1 || deep) {
          return node.cloneNode(deep);
        } else {
          var clone_1 = doc.createElement(node.nodeName);
          each$f(getAttribs(node), function (attr) {
            setAttrib(clone_1, attr.nodeName, getAttrib(node, attr.nodeName));
          });
          return clone_1;
        }
      };
      var getRoot = function () {
        return settings.root_element || doc.body;
      };
      var getViewPort = function (argWin) {
        var vp = getBounds(argWin);
        return {
          x: vp.x,
          y: vp.y,
          w: vp.width,
          h: vp.height
        };
      };
      var getPos$1 = function (elm, rootElm) {
        return getPos(doc.body, get(elm), rootElm);
      };
      var setStyle = function (elm, name, value) {
        var $elm = isString$1(name) ? $$(elm).css(name, value) : $$(elm).css(name);
        if (settings.update_styles) {
          updateInternalStyleAttr(styles, $elm);
        }
      };
      var setStyles = function (elm, stylesArg) {
        var $elm = $$(elm).css(stylesArg);
        if (settings.update_styles) {
          updateInternalStyleAttr(styles, $elm);
        }
      };
      var getStyle = function (elm, name, computed) {
        var $elm = $$(elm);
        if (computed) {
          return $elm.css(name);
        }
        name = name.replace(/-(\D)/g, function (a, b) {
          return b.toUpperCase();
        });
        if (name === 'float') {
          name = Env.browser.isIE() ? 'styleFloat' : 'cssFloat';
        }
        return $elm[0] && $elm[0].style ? $elm[0].style[name] : undefined;
      };
      var getSize = function (elm) {
        var w, h;
        elm = get(elm);
        w = getStyle(elm, 'width');
        h = getStyle(elm, 'height');
        if (w.indexOf('px') === -1) {
          w = 0;
        }
        if (h.indexOf('px') === -1) {
          h = 0;
        }
        return {
          w: parseInt(w, 10) || elm.offsetWidth || elm.clientWidth,
          h: parseInt(h, 10) || elm.offsetHeight || elm.clientHeight
        };
      };
      var getRect = function (elm) {
        elm = get(elm);
        var pos = getPos$1(elm);
        var size = getSize(elm);
        return {
          x: pos.x,
          y: pos.y,
          w: size.w,
          h: size.h
        };
      };
      var is = function (elm, selector) {
        var i;
        if (!elm) {
          return false;
        }
        if (!Array.isArray(elm)) {
          if (selector === '*') {
            return elm.nodeType === 1;
          }
          if (simpleSelectorRe.test(selector)) {
            var selectors = selector.toLowerCase().split(/,/);
            var elmName = elm.nodeName.toLowerCase();
            for (i = selectors.length - 1; i >= 0; i--) {
              if (selectors[i] === elmName) {
                return true;
              }
            }
            return false;
          }
          if (elm.nodeType && elm.nodeType !== 1) {
            return false;
          }
        }
        var elms = !Array.isArray(elm) ? [elm] : elm;
        return Sizzle(selector, elms[0].ownerDocument || elms[0], null, elms).length > 0;
      };
      var getParents = function (elm, selector, root, collect) {
        var result = [];
        var selectorVal;
        var node = get(elm);
        collect = collect === undefined;
        root = root || (getRoot().nodeName !== 'BODY' ? getRoot().parentNode : null);
        if (Tools.is(selector, 'string')) {
          selectorVal = selector;
          if (selector === '*') {
            selector = function (node) {
              return node.nodeType === 1;
            };
          } else {
            selector = function (node) {
              return is(node, selectorVal);
            };
          }
        }
        while (node) {
          if (node === root || isNullable(node.nodeType) || isDocument$1(node) || isDocumentFragment(node)) {
            break;
          }
          if (!selector || typeof selector === 'function' && selector(node)) {
            if (collect) {
              result.push(node);
            } else {
              return [node];
            }
          }
          node = node.parentNode;
        }
        return collect ? result : null;
      };
      var getParent = function (node, selector, root) {
        var parents = getParents(node, selector, root, false);
        return parents && parents.length > 0 ? parents[0] : null;
      };
      var _findSib = function (node, selector, name) {
        var func = selector;
        if (node) {
          if (typeof selector === 'string') {
            func = function (node) {
              return is(node, selector);
            };
          }
          for (node = node[name]; node; node = node[name]) {
            if (typeof func === 'function' && func(node)) {
              return node;
            }
          }
        }
        return null;
      };
      var getNext = function (node, selector) {
        return _findSib(node, selector, 'nextSibling');
      };
      var getPrev = function (node, selector) {
        return _findSib(node, selector, 'previousSibling');
      };
      var select = function (selector, scope) {
        return Sizzle(selector, get(scope) || settings.root_element || doc, []);
      };
      var run = function (elm, func, scope) {
        var result;
        var node = typeof elm === 'string' ? get(elm) : elm;
        if (!node) {
          return false;
        }
        if (Tools.isArray(node) && (node.length || node.length === 0)) {
          result = [];
          each$f(node, function (elm, i) {
            if (elm) {
              result.push(func.call(scope, typeof elm === 'string' ? get(elm) : elm, i));
            }
          });
          return result;
        }
        var context = scope ? scope : this;
        return func.call(context, node);
      };
      var setAttribs = function (elm, attrs) {
        $$(elm).each(function (i, node) {
          each$f(attrs, function (value, name) {
            setAttrib(node, name, value);
          });
        });
      };
      var setHTML = function (elm, html) {
        var $elm = $$(elm);
        if (isIE) {
          $elm.each(function (i, target) {
            if (target.canHaveHTML === false) {
              return;
            }
            while (target.firstChild) {
              target.removeChild(target.firstChild);
            }
            try {
              target.innerHTML = '<br>' + html;
              target.removeChild(target.firstChild);
            } catch (ex) {
              DomQuery('<div></div>').html('<br>' + html).contents().slice(1).appendTo(target);
            }
            return html;
          });
        } else {
          $elm.html(html);
        }
      };
      var add = function (parentElm, name, attrs, html, create) {
        return run(parentElm, function (parentElm) {
          var newElm = typeof name === 'string' ? doc.createElement(name) : name;
          setAttribs(newElm, attrs);
          if (html) {
            if (typeof html !== 'string' && html.nodeType) {
              newElm.appendChild(html);
            } else if (typeof html === 'string') {
              setHTML(newElm, html);
            }
          }
          return !create ? parentElm.appendChild(newElm) : newElm;
        });
      };
      var create = function (name, attrs, html) {
        return add(doc.createElement(name), name, attrs, html, true);
      };
      var decode = Entities.decode;
      var encode = Entities.encodeAllRaw;
      var createHTML = function (name, attrs, html) {
        var outHtml = '', key;
        outHtml += '<' + name;
        for (key in attrs) {
          if (hasNonNullableKey(attrs, key)) {
            outHtml += ' ' + key + '="' + encode(attrs[key]) + '"';
          }
        }
        if (typeof html !== 'undefined') {
          return outHtml + '>' + html + '</' + name + '>';
        }
        return outHtml + ' />';
      };
      var createFragment = function (html) {
        var node;
        var container = doc.createElement('div');
        var frag = doc.createDocumentFragment();
        frag.appendChild(container);
        if (html) {
          container.innerHTML = html;
        }
        while (node = container.firstChild) {
          frag.appendChild(node);
        }
        frag.removeChild(container);
        return frag;
      };
      var remove = function (node, keepChildren) {
        var $node = $$(node);
        if (keepChildren) {
          $node.each(function () {
            var child;
            while (child = this.firstChild) {
              if (child.nodeType === 3 && child.data.length === 0) {
                this.removeChild(child);
              } else {
                this.parentNode.insertBefore(child, this);
              }
            }
          }).remove();
        } else {
          $node.remove();
        }
        return $node.length > 1 ? $node.toArray() : $node[0];
      };
      var removeAllAttribs = function (e) {
        return run(e, function (e) {
          var i;
          var attrs = e.attributes;
          for (i = attrs.length - 1; i >= 0; i--) {
            e.removeAttributeNode(attrs.item(i));
          }
        });
      };
      var parseStyle = function (cssText) {
        return styles.parse(cssText);
      };
      var serializeStyle = function (stylesArg, name) {
        return styles.serialize(stylesArg, name);
      };
      var addStyle = function (cssText) {
        var head, styleElm;
        if (self !== DOMUtils.DOM && doc === document) {
          if (addedStyles[cssText]) {
            return;
          }
          addedStyles[cssText] = true;
        }
        styleElm = doc.getElementById('mceDefaultStyles');
        if (!styleElm) {
          styleElm = doc.createElement('style');
          styleElm.id = 'mceDefaultStyles';
          styleElm.type = 'text/css';
          head = doc.getElementsByTagName('head')[0];
          if (head.firstChild) {
            head.insertBefore(styleElm, head.firstChild);
          } else {
            head.appendChild(styleElm);
          }
        }
        if (styleElm.styleSheet) {
          styleElm.styleSheet.cssText += cssText;
        } else {
          styleElm.appendChild(doc.createTextNode(cssText));
        }
      };
      var loadCSS = function (urls) {
        if (!urls) {
          urls = '';
        }
        each$k(urls.split(','), function (url) {
          files[url] = true;
          styleSheetLoader.load(url, noop);
        });
      };
      var toggleClass = function (elm, cls, state) {
        $$(elm).toggleClass(cls, state).each(function () {
          if (this.className === '') {
            DomQuery(this).attr('class', null);
          }
        });
      };
      var addClass = function (elm, cls) {
        $$(elm).addClass(cls);
      };
      var removeClass = function (elm, cls) {
        toggleClass(elm, cls, false);
      };
      var hasClass = function (elm, cls) {
        return $$(elm).hasClass(cls);
      };
      var show = function (elm) {
        $$(elm).show();
      };
      var hide = function (elm) {
        $$(elm).hide();
      };
      var isHidden = function (elm) {
        return $$(elm).css('display') === 'none';
      };
      var uniqueId = function (prefix) {
        return (!prefix ? 'mce_' : prefix) + counter++;
      };
      var getOuterHTML = function (elm) {
        var node = typeof elm === 'string' ? get(elm) : elm;
        return isElement$5(node) ? node.outerHTML : DomQuery('<div></div>').append(DomQuery(node).clone()).html();
      };
      var setOuterHTML = function (elm, html) {
        $$(elm).each(function () {
          try {
            if ('outerHTML' in this) {
              this.outerHTML = html;
              return;
            }
          } catch (ex) {
          }
          remove(DomQuery(this).html(html), true);
        });
      };
      var insertAfter = function (node, reference) {
        var referenceNode = get(reference);
        return run(node, function (node) {
          var parent = referenceNode.parentNode;
          var nextSibling = referenceNode.nextSibling;
          if (nextSibling) {
            parent.insertBefore(node, nextSibling);
          } else {
            parent.appendChild(node);
          }
          return node;
        });
      };
      var replace = function (newElm, oldElm, keepChildren) {
        return run(oldElm, function (oldElm) {
          if (Tools.is(oldElm, 'array')) {
            newElm = newElm.cloneNode(true);
          }
          if (keepChildren) {
            each$f(grep$1(oldElm.childNodes), function (node) {
              newElm.appendChild(node);
            });
          }
          return oldElm.parentNode.replaceChild(newElm, oldElm);
        });
      };
      var rename = function (elm, name) {
        var newElm;
        if (elm.nodeName !== name.toUpperCase()) {
          newElm = create(name);
          each$f(getAttribs(elm), function (attrNode) {
            setAttrib(newElm, attrNode.nodeName, getAttrib(elm, attrNode.nodeName));
          });
          replace(newElm, elm, true);
        }
        return newElm || elm;
      };
      var findCommonAncestor = function (a, b) {
        var ps = a, pe;
        while (ps) {
          pe = b;
          while (pe && ps !== pe) {
            pe = pe.parentNode;
          }
          if (ps === pe) {
            break;
          }
          ps = ps.parentNode;
        }
        if (!ps && a.ownerDocument) {
          return a.ownerDocument.documentElement;
        }
        return ps;
      };
      var toHex = function (rgbVal) {
        return styles.toHex(Tools.trim(rgbVal));
      };
      var isNonEmptyElement = function (node) {
        if (isElement$5(node)) {
          var isNamedAnchor = node.nodeName.toLowerCase() === 'a' && !getAttrib(node, 'href') && getAttrib(node, 'id');
          if (getAttrib(node, 'name') || getAttrib(node, 'data-mce-bookmark') || isNamedAnchor) {
            return true;
          }
        }
        return false;
      };
      var isEmpty = function (node, elements) {
        var type, name, brCount = 0;
        if (isNonEmptyElement(node)) {
          return false;
        }
        node = node.firstChild;
        if (node) {
          var walker = new DomTreeWalker(node, node.parentNode);
          var whitespace = schema ? schema.getWhiteSpaceElements() : {};
          elements = elements || (schema ? schema.getNonEmptyElements() : null);
          do {
            type = node.nodeType;
            if (isElement$5(node)) {
              var bogusVal = node.getAttribute('data-mce-bogus');
              if (bogusVal) {
                node = walker.next(bogusVal === 'all');
                continue;
              }
              name = node.nodeName.toLowerCase();
              if (elements && elements[name]) {
                if (name === 'br') {
                  brCount++;
                  node = walker.next();
                  continue;
                }
                return false;
              }
              if (isNonEmptyElement(node)) {
                return false;
              }
            }
            if (type === 8) {
              return false;
            }
            if (type === 3 && !isWhitespaceText(node.nodeValue)) {
              return false;
            }
            if (type === 3 && node.parentNode && whitespace[node.parentNode.nodeName] && isWhitespaceText(node.nodeValue)) {
              return false;
            }
            node = walker.next();
          } while (node);
        }
        return brCount <= 1;
      };
      var createRng = function () {
        return doc.createRange();
      };
      var split = function (parentElm, splitElm, replacementElm) {
        var range = createRng();
        var beforeFragment;
        var afterFragment;
        var parentNode;
        if (parentElm && splitElm) {
          range.setStart(parentElm.parentNode, findNodeIndex(parentElm));
          range.setEnd(splitElm.parentNode, findNodeIndex(splitElm));
          beforeFragment = range.extractContents();
          range = createRng();
          range.setStart(splitElm.parentNode, findNodeIndex(splitElm) + 1);
          range.setEnd(parentElm.parentNode, findNodeIndex(parentElm) + 1);
          afterFragment = range.extractContents();
          parentNode = parentElm.parentNode;
          parentNode.insertBefore(trimNode(self, beforeFragment), parentElm);
          if (replacementElm) {
            parentNode.insertBefore(replacementElm, parentElm);
          } else {
            parentNode.insertBefore(splitElm, parentElm);
          }
          parentNode.insertBefore(trimNode(self, afterFragment), parentElm);
          remove(parentElm);
          return replacementElm || splitElm;
        }
      };
      var bind = function (target, name, func, scope) {
        if (Tools.isArray(target)) {
          var i = target.length;
          var rv = [];
          while (i--) {
            rv[i] = bind(target[i], name, func, scope);
          }
          return rv;
        }
        if (settings.collect && (target === doc || target === win)) {
          boundEvents.push([
            target,
            name,
            func,
            scope
          ]);
        }
        var output = events.bind(target, name, func, scope || self);
        return output;
      };
      var unbind = function (target, name, func) {
        if (Tools.isArray(target)) {
          var i = target.length;
          var rv = [];
          while (i--) {
            rv[i] = unbind(target[i], name, func);
          }
          return rv;
        } else {
          if (boundEvents.length > 0 && (target === doc || target === win)) {
            var i = boundEvents.length;
            while (i--) {
              var item = boundEvents[i];
              if (target === item[0] && (!name || name === item[1]) && (!func || func === item[2])) {
                events.unbind(item[0], item[1], item[2]);
              }
            }
          }
          return events.unbind(target, name, func);
        }
      };
      var fire = function (target, name, evt) {
        return events.fire(target, name, evt);
      };
      var getContentEditable = function (node) {
        if (node && isElement$5(node)) {
          var contentEditable = node.getAttribute('data-mce-contenteditable');
          if (contentEditable && contentEditable !== 'inherit') {
            return contentEditable;
          }
          return node.contentEditable !== 'inherit' ? node.contentEditable : null;
        } else {
          return null;
        }
      };
      var getContentEditableParent = function (node) {
        var root = getRoot();
        var state = null;
        for (; node && node !== root; node = node.parentNode) {
          state = getContentEditable(node);
          if (state !== null) {
            break;
          }
        }
        return state;
      };
      var destroy = function () {
        if (boundEvents.length > 0) {
          var i = boundEvents.length;
          while (i--) {
            var item = boundEvents[i];
            events.unbind(item[0], item[1], item[2]);
          }
        }
        each$j(files, function (_, url) {
          styleSheetLoader.unload(url);
          delete files[url];
        });
        if (Sizzle.setDocument) {
          Sizzle.setDocument();
        }
      };
      var isChildOf = function (node, parent) {
        if (!isIE) {
          return node === parent || parent.contains(node);
        } else {
          while (node) {
            if (parent === node) {
              return true;
            }
            node = node.parentNode;
          }
          return false;
        }
      };
      var dumpRng = function (r) {
        return 'startContainer: ' + r.startContainer.nodeName + ', startOffset: ' + r.startOffset + ', endContainer: ' + r.endContainer.nodeName + ', endOffset: ' + r.endOffset;
      };
      var self = {
        doc: doc,
        settings: settings,
        win: win,
        files: files,
        stdMode: stdMode,
        boxModel: boxModel,
        styleSheetLoader: styleSheetLoader,
        boundEvents: boundEvents,
        styles: styles,
        schema: schema,
        events: events,
        isBlock: isBlock,
        $: $,
        $$: $$,
        root: null,
        clone: clone,
        getRoot: getRoot,
        getViewPort: getViewPort,
        getRect: getRect,
        getSize: getSize,
        getParent: getParent,
        getParents: getParents,
        get: get,
        getNext: getNext,
        getPrev: getPrev,
        select: select,
        is: is,
        add: add,
        create: create,
        createHTML: createHTML,
        createFragment: createFragment,
        remove: remove,
        setStyle: setStyle,
        getStyle: getStyle,
        setStyles: setStyles,
        removeAllAttribs: removeAllAttribs,
        setAttrib: setAttrib,
        setAttribs: setAttribs,
        getAttrib: getAttrib,
        getPos: getPos$1,
        parseStyle: parseStyle,
        serializeStyle: serializeStyle,
        addStyle: addStyle,
        loadCSS: loadCSS,
        addClass: addClass,
        removeClass: removeClass,
        hasClass: hasClass,
        toggleClass: toggleClass,
        show: show,
        hide: hide,
        isHidden: isHidden,
        uniqueId: uniqueId,
        setHTML: setHTML,
        getOuterHTML: getOuterHTML,
        setOuterHTML: setOuterHTML,
        decode: decode,
        encode: encode,
        insertAfter: insertAfter,
        replace: replace,
        rename: rename,
        findCommonAncestor: findCommonAncestor,
        toHex: toHex,
        run: run,
        getAttribs: getAttribs,
        isEmpty: isEmpty,
        createRng: createRng,
        nodeIndex: findNodeIndex,
        split: split,
        bind: bind,
        unbind: unbind,
        fire: fire,
        getContentEditable: getContentEditable,
        getContentEditableParent: getContentEditableParent,
        destroy: destroy,
        isChildOf: isChildOf,
        dumpRng: dumpRng
      };
      var attrHooks = setupAttrHooks(styles, settings, constant(self));
      return self;
    };
    DOMUtils.DOM = DOMUtils(document);
    DOMUtils.nodeIndex = findNodeIndex;

    var DOM$a = DOMUtils.DOM;
    var each$e = Tools.each, grep = Tools.grep;
    var QUEUED = 0;
    var LOADING = 1;
    var LOADED = 2;
    var FAILED = 3;
    var ScriptLoader = function () {
      function ScriptLoader(settings) {
        if (settings === void 0) {
          settings = {};
        }
        this.states = {};
        this.queue = [];
        this.scriptLoadedCallbacks = {};
        this.queueLoadedCallbacks = [];
        this.loading = 0;
        this.settings = settings;
      }
      ScriptLoader.prototype._setReferrerPolicy = function (referrerPolicy) {
        this.settings.referrerPolicy = referrerPolicy;
      };
      ScriptLoader.prototype.loadScript = function (url, success, failure) {
        var dom = DOM$a;
        var elm;
        var cleanup = function () {
          dom.remove(id);
          if (elm) {
            elm.onerror = elm.onload = elm = null;
          }
        };
        var done = function () {
          cleanup();
          success();
        };
        var error = function () {
          cleanup();
          if (isFunction(failure)) {
            failure();
          } else {
            if (typeof console !== 'undefined' && console.log) {
              console.log('Failed to load script: ' + url);
            }
          }
        };
        var id = dom.uniqueId();
        elm = document.createElement('script');
        elm.id = id;
        elm.type = 'text/javascript';
        elm.src = Tools._addCacheSuffix(url);
        if (this.settings.referrerPolicy) {
          dom.setAttrib(elm, 'referrerpolicy', this.settings.referrerPolicy);
        }
        elm.onload = done;
        elm.onerror = error;
        (document.getElementsByTagName('head')[0] || document.body).appendChild(elm);
      };
      ScriptLoader.prototype.isDone = function (url) {
        return this.states[url] === LOADED;
      };
      ScriptLoader.prototype.markDone = function (url) {
        this.states[url] = LOADED;
      };
      ScriptLoader.prototype.add = function (url, success, scope, failure) {
        var state = this.states[url];
        this.queue.push(url);
        if (state === undefined) {
          this.states[url] = QUEUED;
        }
        if (success) {
          if (!this.scriptLoadedCallbacks[url]) {
            this.scriptLoadedCallbacks[url] = [];
          }
          this.scriptLoadedCallbacks[url].push({
            success: success,
            failure: failure,
            scope: scope || this
          });
        }
      };
      ScriptLoader.prototype.load = function (url, success, scope, failure) {
        return this.add(url, success, scope, failure);
      };
      ScriptLoader.prototype.remove = function (url) {
        delete this.states[url];
        delete this.scriptLoadedCallbacks[url];
      };
      ScriptLoader.prototype.loadQueue = function (success, scope, failure) {
        this.loadScripts(this.queue, success, scope, failure);
      };
      ScriptLoader.prototype.loadScripts = function (scripts, success, scope, failure) {
        var self = this;
        var failures = [];
        var execCallbacks = function (name, url) {
          each$e(self.scriptLoadedCallbacks[url], function (callback) {
            if (isFunction(callback[name])) {
              callback[name].call(callback.scope);
            }
          });
          self.scriptLoadedCallbacks[url] = undefined;
        };
        self.queueLoadedCallbacks.push({
          success: success,
          failure: failure,
          scope: scope || this
        });
        var loadScripts = function () {
          var loadingScripts = grep(scripts);
          scripts.length = 0;
          each$e(loadingScripts, function (url) {
            if (self.states[url] === LOADED) {
              execCallbacks('success', url);
              return;
            }
            if (self.states[url] === FAILED) {
              execCallbacks('failure', url);
              return;
            }
            if (self.states[url] !== LOADING) {
              self.states[url] = LOADING;
              self.loading++;
              self.loadScript(url, function () {
                self.states[url] = LOADED;
                self.loading--;
                execCallbacks('success', url);
                loadScripts();
              }, function () {
                self.states[url] = FAILED;
                self.loading--;
                failures.push(url);
                execCallbacks('failure', url);
                loadScripts();
              });
            }
          });
          if (!self.loading) {
            var notifyCallbacks = self.queueLoadedCallbacks.slice(0);
            self.queueLoadedCallbacks.length = 0;
            each$e(notifyCallbacks, function (callback) {
              if (failures.length === 0) {
                if (isFunction(callback.success)) {
                  callback.success.call(callback.scope);
                }
              } else {
                if (isFunction(callback.failure)) {
                  callback.failure.call(callback.scope, failures);
                }
              }
            });
          }
        };
        loadScripts();
      };
      ScriptLoader.ScriptLoader = new ScriptLoader();
      return ScriptLoader;
    }();

    var Cell = function (initial) {
      var value = initial;
      var get = function () {
        return value;
      };
      var set = function (v) {
        value = v;
      };
      return {
        get: get,
        set: set
      };
    };

    var isRaw = function (str) {
      return isObject(str) && has$2(str, 'raw');
    };
    var isTokenised = function (str) {
      return isArray$1(str) && str.length > 1;
    };
    var data = {};
    var currentCode = Cell('en');
    var getLanguageData = function () {
      return get$9(data, currentCode.get());
    };
    var getData = function () {
      return map$2(data, function (value) {
        return __assign({}, value);
      });
    };
    var setCode = function (newCode) {
      if (newCode) {
        currentCode.set(newCode);
      }
    };
    var getCode = function () {
      return currentCode.get();
    };
    var add$4 = function (code, items) {
      var langData = data[code];
      if (!langData) {
        data[code] = langData = {};
      }
      each$j(items, function (translation, name) {
        langData[name.toLowerCase()] = translation;
      });
    };
    var translate = function (text) {
      var langData = getLanguageData().getOr({});
      var toString = function (obj) {
        if (isFunction(obj)) {
          return Object.prototype.toString.call(obj);
        }
        return !isEmpty(obj) ? '' + obj : '';
      };
      var isEmpty = function (text) {
        return text === '' || text === null || text === undefined;
      };
      var getLangData = function (text) {
        var textstr = toString(text);
        return get$9(langData, textstr.toLowerCase()).map(toString).getOr(textstr);
      };
      var removeContext = function (str) {
        return str.replace(/{context:\w+}$/, '');
      };
      if (isEmpty(text)) {
        return '';
      }
      if (isRaw(text)) {
        return toString(text.raw);
      }
      if (isTokenised(text)) {
        var values_1 = text.slice(1);
        var substitued = getLangData(text[0]).replace(/\{([0-9]+)\}/g, function ($1, $2) {
          return has$2(values_1, $2) ? toString(values_1[$2]) : $1;
        });
        return removeContext(substitued);
      }
      return removeContext(getLangData(text));
    };
    var isRtl$1 = function () {
      return getLanguageData().bind(function (items) {
        return get$9(items, '_dir');
      }).exists(function (dir) {
        return dir === 'rtl';
      });
    };
    var hasCode = function (code) {
      return has$2(data, code);
    };
    var I18n = {
      getData: getData,
      setCode: setCode,
      getCode: getCode,
      add: add$4,
      translate: translate,
      isRtl: isRtl$1,
      hasCode: hasCode
    };

    var AddOnManager = function () {
      var items = [];
      var urls = {};
      var lookup = {};
      var _listeners = [];
      var runListeners = function (name, state) {
        var matchedListeners = filter$4(_listeners, function (listener) {
          return listener.name === name && listener.state === state;
        });
        each$k(matchedListeners, function (listener) {
          return listener.callback();
        });
      };
      var get = function (name) {
        if (lookup[name]) {
          return lookup[name].instance;
        }
        return undefined;
      };
      var dependencies = function (name) {
        var result;
        if (lookup[name]) {
          result = lookup[name].dependencies;
        }
        return result || [];
      };
      var requireLangPack = function (name, languages) {
        if (AddOnManager.languageLoad !== false) {
          waitFor(name, function () {
            var language = I18n.getCode();
            var wrappedLanguages = ',' + (languages || '') + ',';
            if (!language || languages && wrappedLanguages.indexOf(',' + language + ',') === -1) {
              return;
            }
            ScriptLoader.ScriptLoader.add(urls[name] + '/langs/' + language + '.js');
          }, 'loaded');
        }
      };
      var add = function (id, addOn, dependencies) {
        var addOnConstructor = addOn;
        items.push(addOnConstructor);
        lookup[id] = {
          instance: addOnConstructor,
          dependencies: dependencies
        };
        runListeners(id, 'added');
        return addOnConstructor;
      };
      var remove = function (name) {
        delete urls[name];
        delete lookup[name];
      };
      var createUrl = function (baseUrl, dep) {
        if (typeof dep === 'object') {
          return dep;
        }
        return typeof baseUrl === 'string' ? {
          prefix: '',
          resource: dep,
          suffix: ''
        } : {
          prefix: baseUrl.prefix,
          resource: dep,
          suffix: baseUrl.suffix
        };
      };
      var addComponents = function (pluginName, scripts) {
        var pluginUrl = urls[pluginName];
        each$k(scripts, function (script) {
          ScriptLoader.ScriptLoader.add(pluginUrl + '/' + script);
        });
      };
      var loadDependencies = function (name, addOnUrl, success, scope) {
        var deps = dependencies(name);
        each$k(deps, function (dep) {
          var newUrl = createUrl(addOnUrl, dep);
          load(newUrl.resource, newUrl, undefined, undefined);
        });
        if (success) {
          if (scope) {
            success.call(scope);
          } else {
            success.call(ScriptLoader);
          }
        }
      };
      var load = function (name, addOnUrl, success, scope, failure) {
        if (urls[name]) {
          return;
        }
        var urlString = typeof addOnUrl === 'string' ? addOnUrl : addOnUrl.prefix + addOnUrl.resource + addOnUrl.suffix;
        if (urlString.indexOf('/') !== 0 && urlString.indexOf('://') === -1) {
          urlString = AddOnManager.baseURL + '/' + urlString;
        }
        urls[name] = urlString.substring(0, urlString.lastIndexOf('/'));
        var done = function () {
          runListeners(name, 'loaded');
          loadDependencies(name, addOnUrl, success, scope);
        };
        if (lookup[name]) {
          done();
        } else {
          ScriptLoader.ScriptLoader.add(urlString, done, scope, failure);
        }
      };
      var waitFor = function (name, callback, state) {
        if (state === void 0) {
          state = 'added';
        }
        if (has$2(lookup, name) && state === 'added') {
          callback();
        } else if (has$2(urls, name) && state === 'loaded') {
          callback();
        } else {
          _listeners.push({
            name: name,
            state: state,
            callback: callback
          });
        }
      };
      return {
        items: items,
        urls: urls,
        lookup: lookup,
        _listeners: _listeners,
        get: get,
        dependencies: dependencies,
        requireLangPack: requireLangPack,
        add: add,
        remove: remove,
        createUrl: createUrl,
        addComponents: addComponents,
        load: load,
        waitFor: waitFor
      };
    };
    AddOnManager.languageLoad = true;
    AddOnManager.baseURL = '';
    AddOnManager.PluginManager = AddOnManager();
    AddOnManager.ThemeManager = AddOnManager();

    var singleton = function (doRevoke) {
      var subject = Cell(Optional.none());
      var revoke = function () {
        return subject.get().each(doRevoke);
      };
      var clear = function () {
        revoke();
        subject.set(Optional.none());
      };
      var isSet = function () {
        return subject.get().isSome();
      };
      var get = function () {
        return subject.get();
      };
      var set = function (s) {
        revoke();
        subject.set(Optional.some(s));
      };
      return {
        clear: clear,
        isSet: isSet,
        get: get,
        set: set
      };
    };
    var value = function () {
      var subject = singleton(noop);
      var on = function (f) {
        return subject.get().each(f);
      };
      return __assign(__assign({}, subject), { on: on });
    };

    var first = function (fn, rate) {
      var timer = null;
      var cancel = function () {
        if (!isNull(timer)) {
          clearTimeout(timer);
          timer = null;
        }
      };
      var throttle = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        if (isNull(timer)) {
          timer = setTimeout(function () {
            timer = null;
            fn.apply(null, args);
          }, rate);
        }
      };
      return {
        cancel: cancel,
        throttle: throttle
      };
    };
    var last = function (fn, rate) {
      var timer = null;
      var cancel = function () {
        if (!isNull(timer)) {
          clearTimeout(timer);
          timer = null;
        }
      };
      var throttle = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        cancel();
        timer = setTimeout(function () {
          timer = null;
          fn.apply(null, args);
        }, rate);
      };
      return {
        cancel: cancel,
        throttle: throttle
      };
    };

    var read$4 = function (element, attr) {
      var value = get$6(element, attr);
      return value === undefined || value === '' ? [] : value.split(' ');
    };
    var add$3 = function (element, attr, id) {
      var old = read$4(element, attr);
      var nu = old.concat([id]);
      set$1(element, attr, nu.join(' '));
      return true;
    };
    var remove$5 = function (element, attr, id) {
      var nu = filter$4(read$4(element, attr), function (v) {
        return v !== id;
      });
      if (nu.length > 0) {
        set$1(element, attr, nu.join(' '));
      } else {
        remove$6(element, attr);
      }
      return false;
    };

    var supports = function (element) {
      return element.dom.classList !== undefined;
    };
    var get$4 = function (element) {
      return read$4(element, 'class');
    };
    var add$2 = function (element, clazz) {
      return add$3(element, 'class', clazz);
    };
    var remove$4 = function (element, clazz) {
      return remove$5(element, 'class', clazz);
    };

    var add$1 = function (element, clazz) {
      if (supports(element)) {
        element.dom.classList.add(clazz);
      } else {
        add$2(element, clazz);
      }
    };
    var cleanClass = function (element) {
      var classList = supports(element) ? element.dom.classList : get$4(element);
      if (classList.length === 0) {
        remove$6(element, 'class');
      }
    };
    var remove$3 = function (element, clazz) {
      if (supports(element)) {
        var classList = element.dom.classList;
        classList.remove(clazz);
      } else {
        remove$4(element, clazz);
      }
      cleanClass(element);
    };
    var has = function (element, clazz) {
      return supports(element) && element.dom.classList.contains(clazz);
    };

    var descendants$1 = function (scope, predicate) {
      var result = [];
      each$k(children(scope), function (x) {
        if (predicate(x)) {
          result = result.concat([x]);
        }
        result = result.concat(descendants$1(x, predicate));
      });
      return result;
    };

    var descendants = function (scope, selector) {
      return all(selector, scope);
    };

    var annotation = constant('mce-annotation');
    var dataAnnotation = constant('data-mce-annotation');
    var dataAnnotationId = constant('data-mce-annotation-uid');

    var identify = function (editor, annotationName) {
      var rng = editor.selection.getRng();
      var start = SugarElement.fromDom(rng.startContainer);
      var root = SugarElement.fromDom(editor.getBody());
      var selector = annotationName.fold(function () {
        return '.' + annotation();
      }, function (an) {
        return '[' + dataAnnotation() + '="' + an + '"]';
      });
      var newStart = child$1(start, rng.startOffset).getOr(start);
      var closest = closest$2(newStart, selector, function (n) {
        return eq(n, root);
      });
      var getAttr = function (c, property) {
        if (has$1(c, property)) {
          return Optional.some(get$6(c, property));
        } else {
          return Optional.none();
        }
      };
      return closest.bind(function (c) {
        return getAttr(c, '' + dataAnnotationId()).bind(function (uid) {
          return getAttr(c, '' + dataAnnotation()).map(function (name) {
            var elements = findMarkers(editor, uid);
            return {
              uid: uid,
              name: name,
              elements: elements
            };
          });
        });
      });
    };
    var isAnnotation = function (elem) {
      return isElement$6(elem) && has(elem, annotation());
    };
    var findMarkers = function (editor, uid) {
      var body = SugarElement.fromDom(editor.getBody());
      return descendants(body, '[' + dataAnnotationId() + '="' + uid + '"]');
    };
    var findAll = function (editor, name) {
      var body = SugarElement.fromDom(editor.getBody());
      var markers = descendants(body, '[' + dataAnnotation() + '="' + name + '"]');
      var directory = {};
      each$k(markers, function (m) {
        var uid = get$6(m, dataAnnotationId());
        var nodesAlready = get$9(directory, uid).getOr([]);
        directory[uid] = nodesAlready.concat([m]);
      });
      return directory;
    };

    var setup$n = function (editor, _registry) {
      var changeCallbacks = Cell({});
      var initData = function () {
        return {
          listeners: [],
          previous: value()
        };
      };
      var withCallbacks = function (name, f) {
        updateCallbacks(name, function (data) {
          f(data);
          return data;
        });
      };
      var updateCallbacks = function (name, f) {
        var callbackMap = changeCallbacks.get();
        var data = get$9(callbackMap, name).getOrThunk(initData);
        var outputData = f(data);
        callbackMap[name] = outputData;
        changeCallbacks.set(callbackMap);
      };
      var fireCallbacks = function (name, uid, elements) {
        withCallbacks(name, function (data) {
          each$k(data.listeners, function (f) {
            return f(true, name, {
              uid: uid,
              nodes: map$3(elements, function (elem) {
                return elem.dom;
              })
            });
          });
        });
      };
      var fireNoAnnotation = function (name) {
        withCallbacks(name, function (data) {
          each$k(data.listeners, function (f) {
            return f(false, name);
          });
        });
      };
      var onNodeChange = last(function () {
        var callbackMap = changeCallbacks.get();
        var annotations = sort(keys(callbackMap));
        each$k(annotations, function (name) {
          updateCallbacks(name, function (data) {
            var prev = data.previous.get();
            identify(editor, Optional.some(name)).fold(function () {
              if (prev.isSome()) {
                fireNoAnnotation(name);
                data.previous.clear();
              }
            }, function (_a) {
              var uid = _a.uid, name = _a.name, elements = _a.elements;
              if (!is$1(prev, uid)) {
                fireCallbacks(name, uid, elements);
                data.previous.set(uid);
              }
            });
            return {
              previous: data.previous,
              listeners: data.listeners
            };
          });
        });
      }, 30);
      editor.on('remove', function () {
        onNodeChange.cancel();
      });
      editor.on('NodeChange', function () {
        onNodeChange.throttle();
      });
      var addListener = function (name, f) {
        updateCallbacks(name, function (data) {
          return {
            previous: data.previous,
            listeners: data.listeners.concat([f])
          };
        });
      };
      return { addListener: addListener };
    };

    var setup$m = function (editor, registry) {
      var identifyParserNode = function (span) {
        return Optional.from(span.attr(dataAnnotation())).bind(registry.lookup);
      };
      editor.on('init', function () {
        editor.serializer.addNodeFilter('span', function (spans) {
          each$k(spans, function (span) {
            identifyParserNode(span).each(function (settings) {
              if (settings.persistent === false) {
                span.unwrap();
              }
            });
          });
        });
      });
    };

    var create$7 = function () {
      var annotations = {};
      var register = function (name, settings) {
        annotations[name] = {
          name: name,
          settings: settings
        };
      };
      var lookup = function (name) {
        return get$9(annotations, name).map(function (a) {
          return a.settings;
        });
      };
      return {
        register: register,
        lookup: lookup
      };
    };

    var unique = 0;
    var generate = function (prefix) {
      var date = new Date();
      var time = date.getTime();
      var random = Math.floor(Math.random() * 1000000000);
      unique++;
      return prefix + '_' + random + unique + String(time);
    };

    var add = function (element, classes) {
      each$k(classes, function (x) {
        add$1(element, x);
      });
    };

    var fromHtml = function (html, scope) {
      var doc = scope || document;
      var div = doc.createElement('div');
      div.innerHTML = html;
      return children(SugarElement.fromDom(div));
    };
    var fromDom$1 = function (nodes) {
      return map$3(nodes, SugarElement.fromDom);
    };

    var get$3 = function (element) {
      return element.dom.innerHTML;
    };
    var set = function (element, content) {
      var owner = owner$1(element);
      var docDom = owner.dom;
      var fragment = SugarElement.fromDom(docDom.createDocumentFragment());
      var contentElements = fromHtml(content, docDom);
      append(fragment, contentElements);
      empty(element);
      append$1(element, fragment);
    };

    var clone$1 = function (original, isDeep) {
      return SugarElement.fromDom(original.dom.cloneNode(isDeep));
    };
    var shallow = function (original) {
      return clone$1(original, false);
    };
    var deep$1 = function (original) {
      return clone$1(original, true);
    };

    var TextWalker = function (startNode, rootNode, isBoundary) {
      if (isBoundary === void 0) {
        isBoundary = never;
      }
      var walker = new DomTreeWalker(startNode, rootNode);
      var walk = function (direction) {
        var next;
        do {
          next = walker[direction]();
        } while (next && !isText$7(next) && !isBoundary(next));
        return Optional.from(next).filter(isText$7);
      };
      return {
        current: function () {
          return Optional.from(walker.current()).filter(isText$7);
        },
        next: function () {
          return walk('next');
        },
        prev: function () {
          return walk('prev');
        },
        prev2: function () {
          return walk('prev2');
        }
      };
    };

    var TextSeeker = function (dom, isBoundary) {
      var isBlockBoundary = isBoundary ? isBoundary : function (node) {
        return dom.isBlock(node) || isBr$5(node) || isContentEditableFalse$b(node);
      };
      var walk = function (node, offset, walker, process) {
        if (isText$7(node)) {
          var newOffset = process(node, offset, node.data);
          if (newOffset !== -1) {
            return Optional.some({
              container: node,
              offset: newOffset
            });
          }
        }
        return walker().bind(function (next) {
          return walk(next.container, next.offset, walker, process);
        });
      };
      var backwards = function (node, offset, process, root) {
        var walker = TextWalker(node, root, isBlockBoundary);
        return walk(node, offset, function () {
          return walker.prev().map(function (prev) {
            return {
              container: prev,
              offset: prev.length
            };
          });
        }, process).getOrNull();
      };
      var forwards = function (node, offset, process, root) {
        var walker = TextWalker(node, root, isBlockBoundary);
        return walk(node, offset, function () {
          return walker.next().map(function (next) {
            return {
              container: next,
              offset: 0
            };
          });
        }, process).getOrNull();
      };
      return {
        backwards: backwards,
        forwards: forwards
      };
    };

    var round$2 = Math.round;
    var clone = function (rect) {
      if (!rect) {
        return {
          left: 0,
          top: 0,
          bottom: 0,
          right: 0,
          width: 0,
          height: 0
        };
      }
      return {
        left: round$2(rect.left),
        top: round$2(rect.top),
        bottom: round$2(rect.bottom),
        right: round$2(rect.right),
        width: round$2(rect.width),
        height: round$2(rect.height)
      };
    };
    var collapse = function (rect, toStart) {
      rect = clone(rect);
      if (toStart) {
        rect.right = rect.left;
      } else {
        rect.left = rect.left + rect.width;
        rect.right = rect.left;
      }
      rect.width = 0;
      return rect;
    };
    var isEqual = function (rect1, rect2) {
      return rect1.left === rect2.left && rect1.top === rect2.top && rect1.bottom === rect2.bottom && rect1.right === rect2.right;
    };
    var isValidOverflow = function (overflowY, rect1, rect2) {
      return overflowY >= 0 && overflowY <= Math.min(rect1.height, rect2.height) / 2;
    };
    var isAbove$1 = function (rect1, rect2) {
      var halfHeight = Math.min(rect2.height / 2, rect1.height / 2);
      if (rect1.bottom - halfHeight < rect2.top) {
        return true;
      }
      if (rect1.top > rect2.bottom) {
        return false;
      }
      return isValidOverflow(rect2.top - rect1.bottom, rect1, rect2);
    };
    var isBelow$1 = function (rect1, rect2) {
      if (rect1.top > rect2.bottom) {
        return true;
      }
      if (rect1.bottom < rect2.top) {
        return false;
      }
      return isValidOverflow(rect2.bottom - rect1.top, rect1, rect2);
    };
    var containsXY = function (rect, clientX, clientY) {
      return clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
    };

    var clamp$2 = function (value, min, max) {
      return Math.min(Math.max(value, min), max);
    };

    var getSelectedNode = function (range) {
      var startContainer = range.startContainer, startOffset = range.startOffset;
      if (startContainer.hasChildNodes() && range.endOffset === startOffset + 1) {
        return startContainer.childNodes[startOffset];
      }
      return null;
    };
    var getNode$1 = function (container, offset) {
      if (isElement$5(container) && container.hasChildNodes()) {
        var childNodes = container.childNodes;
        var safeOffset = clamp$2(offset, 0, childNodes.length - 1);
        return childNodes[safeOffset];
      } else {
        return container;
      }
    };
    var getNodeUnsafe = function (container, offset) {
      if (offset < 0 && isElement$5(container) && container.hasChildNodes()) {
        return undefined;
      } else {
        return getNode$1(container, offset);
      }
    };

    var extendingChars = new RegExp('[\u0300-\u036f\u0483-\u0487\u0488-\u0489\u0591-\u05bd\u05bf\u05c1-\u05c2\u05c4-\u05c5\u05c7\u0610-\u061a' + '\u064b-\u065f\u0670\u06d6-\u06dc\u06df-\u06e4\u06e7-\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0' + '\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0859-\u085b\u08e3-\u0902\u093a\u093c' + '\u0941-\u0948\u094d\u0951-\u0957\u0962-\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2-\u09e3' + '\u0a01-\u0a02\u0a3c\u0a41-\u0a42\u0a47-\u0a48\u0a4b-\u0a4d\u0a51\u0a70-\u0a71\u0a75\u0a81-\u0a82\u0abc' + '\u0ac1-\u0ac5\u0ac7-\u0ac8\u0acd\u0ae2-\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57' + '\u0b62-\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c00\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55-\u0c56' + '\u0c62-\u0c63\u0c81\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc-\u0ccd\u0cd5-\u0cd6\u0ce2-\u0ce3\u0d01\u0d3e\u0d41-\u0d44' + '\u0d4d\u0d57\u0d62-\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9' + '\u0ebb-\u0ebc\u0ec8-\u0ecd\u0f18-\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86-\u0f87\u0f8d-\u0f97' + '\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039-\u103a\u103d-\u103e\u1058-\u1059\u105e-\u1060\u1071-\u1074' + '\u1082\u1085-\u1086\u108d\u109d\u135d-\u135f\u1712-\u1714\u1732-\u1734\u1752-\u1753\u1772-\u1773\u17b4-\u17b5' + '\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927-\u1928\u1932\u1939-\u193b\u1a17-\u1a18' + '\u1a1b\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1ab0-\u1abd\u1ABE\u1b00-\u1b03\u1b34' + '\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80-\u1b81\u1ba2-\u1ba5\u1ba8-\u1ba9\u1bab-\u1bad\u1be6\u1be8-\u1be9' + '\u1bed\u1bef-\u1bf1\u1c2c-\u1c33\u1c36-\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1cf4\u1cf8-\u1cf9' + '\u1dc0-\u1df5\u1dfc-\u1dff\u200c-\u200d\u20d0-\u20dc\u20DD-\u20E0\u20e1\u20E2-\u20E4\u20e5-\u20f0\u2cef-\u2cf1' + '\u2d7f\u2de0-\u2dff\u302a-\u302d\u302e-\u302f\u3099-\u309a\ua66f\uA670-\uA672\ua674-\ua67d\ua69e-\ua69f\ua6f0-\ua6f1' + '\ua802\ua806\ua80b\ua825-\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc' + '\ua9e5\uaa29-\uaa2e\uaa31-\uaa32\uaa35-\uaa36\uaa43\uaa4c\uaa7c\uaab0\uaab2-\uaab4\uaab7-\uaab8\uaabe-\uaabf\uaac1' + '\uaaec-\uaaed\uaaf6\uabe5\uabe8\uabed\ufb1e\ufe00-\ufe0f\ufe20-\ufe2f\uff9e-\uff9f]');
    var isExtendingChar = function (ch) {
      return typeof ch === 'string' && ch.charCodeAt(0) >= 768 && extendingChars.test(ch);
    };

    var or = function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return function (x) {
        for (var i = 0; i < args.length; i++) {
          if (args[i](x)) {
            return true;
          }
        }
        return false;
      };
    };
    var and = function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return function (x) {
        for (var i = 0; i < args.length; i++) {
          if (!args[i](x)) {
            return false;
          }
        }
        return true;
      };
    };

    var isElement$3 = isElement$5;
    var isCaretCandidate$2 = isCaretCandidate$3;
    var isBlock$1 = matchStyleValues('display', 'block table');
    var isFloated = matchStyleValues('float', 'left right');
    var isValidElementCaretCandidate = and(isElement$3, isCaretCandidate$2, not(isFloated));
    var isNotPre = not(matchStyleValues('white-space', 'pre pre-line pre-wrap'));
    var isText$4 = isText$7;
    var isBr$2 = isBr$5;
    var nodeIndex$1 = DOMUtils.nodeIndex;
    var resolveIndex$1 = getNodeUnsafe;
    var createRange$1 = function (doc) {
      return 'createRange' in doc ? doc.createRange() : DOMUtils.DOM.createRng();
    };
    var isWhiteSpace$1 = function (chr) {
      return chr && /[\r\n\t ]/.test(chr);
    };
    var isRange = function (rng) {
      return !!rng.setStart && !!rng.setEnd;
    };
    var isHiddenWhiteSpaceRange = function (range) {
      var container = range.startContainer;
      var offset = range.startOffset;
      if (isWhiteSpace$1(range.toString()) && isNotPre(container.parentNode) && isText$7(container)) {
        var text = container.data;
        if (isWhiteSpace$1(text[offset - 1]) || isWhiteSpace$1(text[offset + 1])) {
          return true;
        }
      }
      return false;
    };
    var getBrClientRect = function (brNode) {
      var doc = brNode.ownerDocument;
      var rng = createRange$1(doc);
      var nbsp$1 = doc.createTextNode(nbsp);
      var parentNode = brNode.parentNode;
      parentNode.insertBefore(nbsp$1, brNode);
      rng.setStart(nbsp$1, 0);
      rng.setEnd(nbsp$1, 1);
      var clientRect = clone(rng.getBoundingClientRect());
      parentNode.removeChild(nbsp$1);
      return clientRect;
    };
    var getBoundingClientRectWebKitText = function (rng) {
      var sc = rng.startContainer;
      var ec = rng.endContainer;
      var so = rng.startOffset;
      var eo = rng.endOffset;
      if (sc === ec && isText$7(ec) && so === 0 && eo === 1) {
        var newRng = rng.cloneRange();
        newRng.setEndAfter(ec);
        return getBoundingClientRect$1(newRng);
      } else {
        return null;
      }
    };
    var isZeroRect = function (r) {
      return r.left === 0 && r.right === 0 && r.top === 0 && r.bottom === 0;
    };
    var getBoundingClientRect$1 = function (item) {
      var clientRect;
      var clientRects = item.getClientRects();
      if (clientRects.length > 0) {
        clientRect = clone(clientRects[0]);
      } else {
        clientRect = clone(item.getBoundingClientRect());
      }
      if (!isRange(item) && isBr$2(item) && isZeroRect(clientRect)) {
        return getBrClientRect(item);
      }
      if (isZeroRect(clientRect) && isRange(item)) {
        return getBoundingClientRectWebKitText(item);
      }
      return clientRect;
    };
    var collapseAndInflateWidth = function (clientRect, toStart) {
      var newClientRect = collapse(clientRect, toStart);
      newClientRect.width = 1;
      newClientRect.right = newClientRect.left + 1;
      return newClientRect;
    };
    var getCaretPositionClientRects = function (caretPosition) {
      var clientRects = [];
      var addUniqueAndValidRect = function (clientRect) {
        if (clientRect.height === 0) {
          return;
        }
        if (clientRects.length > 0) {
          if (isEqual(clientRect, clientRects[clientRects.length - 1])) {
            return;
          }
        }
        clientRects.push(clientRect);
      };
      var addCharacterOffset = function (container, offset) {
        var range = createRange$1(container.ownerDocument);
        if (offset < container.data.length) {
          if (isExtendingChar(container.data[offset])) {
            return clientRects;
          }
          if (isExtendingChar(container.data[offset - 1])) {
            range.setStart(container, offset);
            range.setEnd(container, offset + 1);
            if (!isHiddenWhiteSpaceRange(range)) {
              addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect$1(range), false));
              return clientRects;
            }
          }
        }
        if (offset > 0) {
          range.setStart(container, offset - 1);
          range.setEnd(container, offset);
          if (!isHiddenWhiteSpaceRange(range)) {
            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect$1(range), false));
          }
        }
        if (offset < container.data.length) {
          range.setStart(container, offset);
          range.setEnd(container, offset + 1);
          if (!isHiddenWhiteSpaceRange(range)) {
            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect$1(range), true));
          }
        }
      };
      var container = caretPosition.container();
      var offset = caretPosition.offset();
      if (isText$4(container)) {
        addCharacterOffset(container, offset);
        return clientRects;
      }
      if (isElement$3(container)) {
        if (caretPosition.isAtEnd()) {
          var node = resolveIndex$1(container, offset);
          if (isText$4(node)) {
            addCharacterOffset(node, node.data.length);
          }
          if (isValidElementCaretCandidate(node) && !isBr$2(node)) {
            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect$1(node), false));
          }
        } else {
          var node = resolveIndex$1(container, offset);
          if (isText$4(node)) {
            addCharacterOffset(node, 0);
          }
          if (isValidElementCaretCandidate(node) && caretPosition.isAtEnd()) {
            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect$1(node), false));
            return clientRects;
          }
          var beforeNode = resolveIndex$1(caretPosition.container(), caretPosition.offset() - 1);
          if (isValidElementCaretCandidate(beforeNode) && !isBr$2(beforeNode)) {
            if (isBlock$1(beforeNode) || isBlock$1(node) || !isValidElementCaretCandidate(node)) {
              addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect$1(beforeNode), false));
            }
          }
          if (isValidElementCaretCandidate(node)) {
            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect$1(node), true));
          }
        }
      }
      return clientRects;
    };
    var CaretPosition = function (container, offset, clientRects) {
      var isAtStart = function () {
        if (isText$4(container)) {
          return offset === 0;
        }
        return offset === 0;
      };
      var isAtEnd = function () {
        if (isText$4(container)) {
          return offset >= container.data.length;
        }
        return offset >= container.childNodes.length;
      };
      var toRange = function () {
        var range = createRange$1(container.ownerDocument);
        range.setStart(container, offset);
        range.setEnd(container, offset);
        return range;
      };
      var getClientRects = function () {
        if (!clientRects) {
          clientRects = getCaretPositionClientRects(CaretPosition(container, offset));
        }
        return clientRects;
      };
      var isVisible = function () {
        return getClientRects().length > 0;
      };
      var isEqual = function (caretPosition) {
        return caretPosition && container === caretPosition.container() && offset === caretPosition.offset();
      };
      var getNode = function (before) {
        return resolveIndex$1(container, before ? offset - 1 : offset);
      };
      return {
        container: constant(container),
        offset: constant(offset),
        toRange: toRange,
        getClientRects: getClientRects,
        isVisible: isVisible,
        isAtStart: isAtStart,
        isAtEnd: isAtEnd,
        isEqual: isEqual,
        getNode: getNode
      };
    };
    CaretPosition.fromRangeStart = function (range) {
      return CaretPosition(range.startContainer, range.startOffset);
    };
    CaretPosition.fromRangeEnd = function (range) {
      return CaretPosition(range.endContainer, range.endOffset);
    };
    CaretPosition.after = function (node) {
      return CaretPosition(node.parentNode, nodeIndex$1(node) + 1);
    };
    CaretPosition.before = function (node) {
      return CaretPosition(node.parentNode, nodeIndex$1(node));
    };
    CaretPosition.isAbove = function (pos1, pos2) {
      return lift2(head(pos2.getClientRects()), last$2(pos1.getClientRects()), isAbove$1).getOr(false);
    };
    CaretPosition.isBelow = function (pos1, pos2) {
      return lift2(last$2(pos2.getClientRects()), head(pos1.getClientRects()), isBelow$1).getOr(false);
    };
    CaretPosition.isAtStart = function (pos) {
      return pos ? pos.isAtStart() : false;
    };
    CaretPosition.isAtEnd = function (pos) {
      return pos ? pos.isAtEnd() : false;
    };
    CaretPosition.isTextPosition = function (pos) {
      return pos ? isText$7(pos.container()) : false;
    };
    CaretPosition.isElementPosition = function (pos) {
      return CaretPosition.isTextPosition(pos) === false;
    };

    var trimEmptyTextNode$1 = function (dom, node) {
      if (isText$7(node) && node.data.length === 0) {
        dom.remove(node);
      }
    };
    var insertNode = function (dom, rng, node) {
      rng.insertNode(node);
      trimEmptyTextNode$1(dom, node.previousSibling);
      trimEmptyTextNode$1(dom, node.nextSibling);
    };
    var insertFragment = function (dom, rng, frag) {
      var firstChild = Optional.from(frag.firstChild);
      var lastChild = Optional.from(frag.lastChild);
      rng.insertNode(frag);
      firstChild.each(function (child) {
        return trimEmptyTextNode$1(dom, child.previousSibling);
      });
      lastChild.each(function (child) {
        return trimEmptyTextNode$1(dom, child.nextSibling);
      });
    };
    var rangeInsertNode = function (dom, rng, node) {
      if (isDocumentFragment(node)) {
        insertFragment(dom, rng, node);
      } else {
        insertNode(dom, rng, node);
      }
    };

    var isText$3 = isText$7;
    var isBogus = isBogus$2;
    var nodeIndex = DOMUtils.nodeIndex;
    var normalizedParent = function (node) {
      var parentNode = node.parentNode;
      if (isBogus(parentNode)) {
        return normalizedParent(parentNode);
      }
      return parentNode;
    };
    var getChildNodes = function (node) {
      if (!node) {
        return [];
      }
      return reduce(node.childNodes, function (result, node) {
        if (isBogus(node) && node.nodeName !== 'BR') {
          result = result.concat(getChildNodes(node));
        } else {
          result.push(node);
        }
        return result;
      }, []);
    };
    var normalizedTextOffset = function (node, offset) {
      while (node = node.previousSibling) {
        if (!isText$3(node)) {
          break;
        }
        offset += node.data.length;
      }
      return offset;
    };
    var equal = function (a) {
      return function (b) {
        return a === b;
      };
    };
    var normalizedNodeIndex = function (node) {
      var nodes, index;
      nodes = getChildNodes(normalizedParent(node));
      index = findIndex$1(nodes, equal(node), node);
      nodes = nodes.slice(0, index + 1);
      var numTextFragments = reduce(nodes, function (result, node, i) {
        if (isText$3(node) && isText$3(nodes[i - 1])) {
          result++;
        }
        return result;
      }, 0);
      nodes = filter$2(nodes, matchNodeNames([node.nodeName]));
      index = findIndex$1(nodes, equal(node), node);
      return index - numTextFragments;
    };
    var createPathItem = function (node) {
      var name;
      if (isText$3(node)) {
        name = 'text()';
      } else {
        name = node.nodeName.toLowerCase();
      }
      return name + '[' + normalizedNodeIndex(node) + ']';
    };
    var parentsUntil$1 = function (root, node, predicate) {
      var parents = [];
      for (node = node.parentNode; node !== root; node = node.parentNode) {
        if (predicate && predicate(node)) {
          break;
        }
        parents.push(node);
      }
      return parents;
    };
    var create$6 = function (root, caretPosition) {
      var container, offset, path = [], outputOffset, childNodes, parents;
      container = caretPosition.container();
      offset = caretPosition.offset();
      if (isText$3(container)) {
        outputOffset = normalizedTextOffset(container, offset);
      } else {
        childNodes = container.childNodes;
        if (offset >= childNodes.length) {
          outputOffset = 'after';
          offset = childNodes.length - 1;
        } else {
          outputOffset = 'before';
        }
        container = childNodes[offset];
      }
      path.push(createPathItem(container));
      parents = parentsUntil$1(root, container);
      parents = filter$2(parents, not(isBogus$2));
      path = path.concat(map$1(parents, function (node) {
        return createPathItem(node);
      }));
      return path.reverse().join('/') + ',' + outputOffset;
    };
    var resolvePathItem = function (node, name, index) {
      var nodes = getChildNodes(node);
      nodes = filter$2(nodes, function (node, index) {
        return !isText$3(node) || !isText$3(nodes[index - 1]);
      });
      nodes = filter$2(nodes, matchNodeNames([name]));
      return nodes[index];
    };
    var findTextPosition = function (container, offset) {
      var node = container, targetOffset = 0, dataLen;
      while (isText$3(node)) {
        dataLen = node.data.length;
        if (offset >= targetOffset && offset <= targetOffset + dataLen) {
          container = node;
          offset = offset - targetOffset;
          break;
        }
        if (!isText$3(node.nextSibling)) {
          container = node;
          offset = dataLen;
          break;
        }
        targetOffset += dataLen;
        node = node.nextSibling;
      }
      if (isText$3(container) && offset > container.data.length) {
        offset = container.data.length;
      }
      return CaretPosition(container, offset);
    };
    var resolve$2 = function (root, path) {
      var offset;
      if (!path) {
        return null;
      }
      var parts = path.split(',');
      var paths = parts[0].split('/');
      offset = parts.length > 1 ? parts[1] : 'before';
      var container = reduce(paths, function (result, value) {
        var match = /([\w\-\(\)]+)\[([0-9]+)\]/.exec(value);
        if (!match) {
          return null;
        }
        if (match[1] === 'text()') {
          match[1] = '#text';
        }
        return resolvePathItem(result, match[1], parseInt(match[2], 10));
      }, root);
      if (!container) {
        return null;
      }
      if (!isText$3(container)) {
        if (offset === 'after') {
          offset = nodeIndex(container) + 1;
        } else {
          offset = nodeIndex(container);
        }
        return CaretPosition(container.parentNode, offset);
      }
      return findTextPosition(container, parseInt(offset, 10));
    };

    var isContentEditableFalse$9 = isContentEditableFalse$b;
    var getNormalizedTextOffset = function (trim, container, offset) {
      var node, trimmedOffset;
      trimmedOffset = trim(container.data.slice(0, offset)).length;
      for (node = container.previousSibling; node && isText$7(node); node = node.previousSibling) {
        trimmedOffset += trim(node.data).length;
      }
      return trimmedOffset;
    };
    var getPoint = function (dom, trim, normalized, rng, start) {
      var container = rng[start ? 'startContainer' : 'endContainer'];
      var offset = rng[start ? 'startOffset' : 'endOffset'];
      var point = [];
      var childNodes, after = 0;
      var root = dom.getRoot();
      if (isText$7(container)) {
        point.push(normalized ? getNormalizedTextOffset(trim, container, offset) : offset);
      } else {
        childNodes = container.childNodes;
        if (offset >= childNodes.length && childNodes.length) {
          after = 1;
          offset = Math.max(0, childNodes.length - 1);
        }
        point.push(dom.nodeIndex(childNodes[offset], normalized) + after);
      }
      for (; container && container !== root; container = container.parentNode) {
        point.push(dom.nodeIndex(container, normalized));
      }
      return point;
    };
    var getLocation = function (trim, selection, normalized, rng) {
      var dom = selection.dom, bookmark = {};
      bookmark.start = getPoint(dom, trim, normalized, rng, true);
      if (!selection.isCollapsed()) {
        bookmark.end = getPoint(dom, trim, normalized, rng, false);
      }
      if (isRangeInCaretContainerBlock(rng)) {
        bookmark.isFakeCaret = true;
      }
      return bookmark;
    };
    var findIndex = function (dom, name, element) {
      var count = 0;
      Tools.each(dom.select(name), function (node) {
        if (node.getAttribute('data-mce-bogus') === 'all') {
          return;
        }
        if (node === element) {
          return false;
        }
        count++;
      });
      return count;
    };
    var moveEndPoint$1 = function (rng, start) {
      var container, offset, childNodes;
      var prefix = start ? 'start' : 'end';
      container = rng[prefix + 'Container'];
      offset = rng[prefix + 'Offset'];
      if (isElement$5(container) && container.nodeName === 'TR') {
        childNodes = container.childNodes;
        container = childNodes[Math.min(start ? offset : offset - 1, childNodes.length - 1)];
        if (container) {
          offset = start ? 0 : container.childNodes.length;
          rng['set' + (start ? 'Start' : 'End')](container, offset);
        }
      }
    };
    var normalizeTableCellSelection = function (rng) {
      moveEndPoint$1(rng, true);
      moveEndPoint$1(rng, false);
      return rng;
    };
    var findSibling = function (node, offset) {
      var sibling;
      if (isElement$5(node)) {
        node = getNode$1(node, offset);
        if (isContentEditableFalse$9(node)) {
          return node;
        }
      }
      if (isCaretContainer$2(node)) {
        if (isText$7(node) && isCaretContainerBlock$1(node)) {
          node = node.parentNode;
        }
        sibling = node.previousSibling;
        if (isContentEditableFalse$9(sibling)) {
          return sibling;
        }
        sibling = node.nextSibling;
        if (isContentEditableFalse$9(sibling)) {
          return sibling;
        }
      }
    };
    var findAdjacentContentEditableFalseElm = function (rng) {
      return findSibling(rng.startContainer, rng.startOffset) || findSibling(rng.endContainer, rng.endOffset);
    };
    var getOffsetBookmark = function (trim, normalized, selection) {
      var element = selection.getNode();
      var name = element ? element.nodeName : null;
      var rng = selection.getRng();
      if (isContentEditableFalse$9(element) || name === 'IMG') {
        return {
          name: name,
          index: findIndex(selection.dom, name, element)
        };
      }
      var sibling = findAdjacentContentEditableFalseElm(rng);
      if (sibling) {
        name = sibling.tagName;
        return {
          name: name,
          index: findIndex(selection.dom, name, sibling)
        };
      }
      return getLocation(trim, selection, normalized, rng);
    };
    var getCaretBookmark = function (selection) {
      var rng = selection.getRng();
      return {
        start: create$6(selection.dom.getRoot(), CaretPosition.fromRangeStart(rng)),
        end: create$6(selection.dom.getRoot(), CaretPosition.fromRangeEnd(rng))
      };
    };
    var getRangeBookmark = function (selection) {
      return { rng: selection.getRng() };
    };
    var createBookmarkSpan = function (dom, id, filled) {
      var args = {
        'data-mce-type': 'bookmark',
        id: id,
        'style': 'overflow:hidden;line-height:0px'
      };
      return filled ? dom.create('span', args, '&#xFEFF;') : dom.create('span', args);
    };
    var getPersistentBookmark = function (selection, filled) {
      var dom = selection.dom;
      var rng = selection.getRng();
      var id = dom.uniqueId();
      var collapsed = selection.isCollapsed();
      var element = selection.getNode();
      var name = element.nodeName;
      if (name === 'IMG') {
        return {
          name: name,
          index: findIndex(dom, name, element)
        };
      }
      var rng2 = normalizeTableCellSelection(rng.cloneRange());
      if (!collapsed) {
        rng2.collapse(false);
        var endBookmarkNode = createBookmarkSpan(dom, id + '_end', filled);
        rangeInsertNode(dom, rng2, endBookmarkNode);
      }
      rng = normalizeTableCellSelection(rng);
      rng.collapse(true);
      var startBookmarkNode = createBookmarkSpan(dom, id + '_start', filled);
      rangeInsertNode(dom, rng, startBookmarkNode);
      selection.moveToBookmark({
        id: id,
        keep: true
      });
      return { id: id };
    };
    var getBookmark$2 = function (selection, type, normalized) {
      if (type === 2) {
        return getOffsetBookmark(trim$2, normalized, selection);
      } else if (type === 3) {
        return getCaretBookmark(selection);
      } else if (type) {
        return getRangeBookmark(selection);
      } else {
        return getPersistentBookmark(selection, false);
      }
    };
    var getUndoBookmark = curry(getOffsetBookmark, identity, true);

    var DOM$9 = DOMUtils.DOM;
    var defaultPreviewStyles = 'font-family font-size font-weight font-style text-decoration text-transform color background-color border border-radius outline text-shadow';
    var getBodySetting = function (editor, name, defaultValue) {
      var value = editor.getParam(name, defaultValue);
      if (value.indexOf('=') !== -1) {
        var bodyObj = editor.getParam(name, '', 'hash');
        return get$9(bodyObj, editor.id).getOr(defaultValue);
      } else {
        return value;
      }
    };
    var getIframeAttrs = function (editor) {
      return editor.getParam('iframe_attrs', {});
    };
    var getDocType = function (editor) {
      return editor.getParam('doctype', '<!DOCTYPE html>');
    };
    var getDocumentBaseUrl = function (editor) {
      return editor.getParam('document_base_url', '');
    };
    var getBodyId = function (editor) {
      return getBodySetting(editor, 'body_id', 'tinymce');
    };
    var getBodyClass = function (editor) {
      return getBodySetting(editor, 'body_class', '');
    };
    var getContentSecurityPolicy = function (editor) {
      return editor.getParam('content_security_policy', '');
    };
    var shouldPutBrInPre$1 = function (editor) {
      return editor.getParam('br_in_pre', true);
    };
    var getForcedRootBlock = function (editor) {
      if (editor.getParam('force_p_newlines', false)) {
        return 'p';
      }
      var block = editor.getParam('forced_root_block', 'p');
      if (block === false) {
        return '';
      } else if (block === true) {
        return 'p';
      } else {
        return block;
      }
    };
    var getForcedRootBlockAttrs = function (editor) {
      return editor.getParam('forced_root_block_attrs', {});
    };
    var getBrNewLineSelector = function (editor) {
      return editor.getParam('br_newline_selector', '.mce-toc h2,figcaption,caption');
    };
    var getNoNewLineSelector = function (editor) {
      return editor.getParam('no_newline_selector', '');
    };
    var shouldKeepStyles = function (editor) {
      return editor.getParam('keep_styles', true);
    };
    var shouldEndContainerOnEmptyBlock = function (editor) {
      return editor.getParam('end_container_on_empty_block', false);
    };
    var getFontStyleValues = function (editor) {
      return Tools.explode(editor.getParam('font_size_style_values', 'xx-small,x-small,small,medium,large,x-large,xx-large'));
    };
    var getFontSizeClasses = function (editor) {
      return Tools.explode(editor.getParam('font_size_classes', ''));
    };
    var getImagesDataImgFilter = function (editor) {
      return editor.getParam('images_dataimg_filter', always, 'function');
    };
    var isAutomaticUploadsEnabled = function (editor) {
      return editor.getParam('automatic_uploads', true, 'boolean');
    };
    var shouldReuseFileName = function (editor) {
      return editor.getParam('images_reuse_filename', false, 'boolean');
    };
    var shouldReplaceBlobUris = function (editor) {
      return editor.getParam('images_replace_blob_uris', true, 'boolean');
    };
    var getIconPackName = function (editor) {
      return editor.getParam('icons', '', 'string');
    };
    var getIconsUrl = function (editor) {
      return editor.getParam('icons_url', '', 'string');
    };
    var getImageUploadUrl = function (editor) {
      return editor.getParam('images_upload_url', '', 'string');
    };
    var getImageUploadBasePath = function (editor) {
      return editor.getParam('images_upload_base_path', '', 'string');
    };
    var getImagesUploadCredentials = function (editor) {
      return editor.getParam('images_upload_credentials', false, 'boolean');
    };
    var getImagesUploadHandler = function (editor) {
      return editor.getParam('images_upload_handler', null, 'function');
    };
    var shouldUseContentCssCors = function (editor) {
      return editor.getParam('content_css_cors', false, 'boolean');
    };
    var getReferrerPolicy = function (editor) {
      return editor.getParam('referrer_policy', '', 'string');
    };
    var getLanguageCode = function (editor) {
      return editor.getParam('language', 'en', 'string');
    };
    var getLanguageUrl = function (editor) {
      return editor.getParam('language_url', '', 'string');
    };
    var shouldIndentUseMargin = function (editor) {
      return editor.getParam('indent_use_margin', false);
    };
    var getIndentation = function (editor) {
      return editor.getParam('indentation', '40px', 'string');
    };
    var getContentCss = function (editor) {
      var contentCss = editor.getParam('content_css');
      if (isString$1(contentCss)) {
        return map$3(contentCss.split(','), trim$4);
      } else if (isArray$1(contentCss)) {
        return contentCss;
      } else if (contentCss === false || editor.inline) {
        return [];
      } else {
        return ['default'];
      }
    };
    var getFontCss = function (editor) {
      var fontCss = editor.getParam('font_css', []);
      return isArray$1(fontCss) ? fontCss : map$3(fontCss.split(','), trim$4);
    };
    var getDirectionality = function (editor) {
      return editor.getParam('directionality', I18n.isRtl() ? 'rtl' : undefined);
    };
    var getInlineBoundarySelector = function (editor) {
      return editor.getParam('inline_boundaries_selector', 'a[href],code,.mce-annotation', 'string');
    };
    var getObjectResizing = function (editor) {
      var selector = editor.getParam('object_resizing');
      if (selector === false || Env.iOS) {
        return false;
      } else {
        return isString$1(selector) ? selector : 'table,img,figure.image,div,video,iframe';
      }
    };
    var getResizeImgProportional = function (editor) {
      return editor.getParam('resize_img_proportional', true, 'boolean');
    };
    var getPlaceholder = function (editor) {
      return editor.getParam('placeholder', DOM$9.getAttrib(editor.getElement(), 'placeholder'), 'string');
    };
    var getEventRoot = function (editor) {
      return editor.getParam('event_root');
    };
    var getServiceMessage = function (editor) {
      return editor.getParam('service_message');
    };
    var getTheme = function (editor) {
      return editor.getParam('theme');
    };
    var shouldValidate = function (editor) {
      return editor.getParam('validate');
    };
    var isInlineBoundariesEnabled = function (editor) {
      return editor.getParam('inline_boundaries') !== false;
    };
    var getFormats = function (editor) {
      return editor.getParam('formats');
    };
    var getPreviewStyles = function (editor) {
      var style = editor.getParam('preview_styles', defaultPreviewStyles);
      if (isString$1(style)) {
        return style;
      } else {
        return '';
      }
    };
    var canFormatEmptyLines = function (editor) {
      return editor.getParam('format_empty_lines', false, 'boolean');
    };
    var getCustomUiSelector = function (editor) {
      return editor.getParam('custom_ui_selector', '', 'string');
    };
    var getThemeUrl = function (editor) {
      return editor.getParam('theme_url');
    };
    var isInline = function (editor) {
      return editor.getParam('inline');
    };
    var hasHiddenInput = function (editor) {
      return editor.getParam('hidden_input');
    };
    var shouldPatchSubmit = function (editor) {
      return editor.getParam('submit_patch');
    };
    var isEncodingXml = function (editor) {
      return editor.getParam('encoding') === 'xml';
    };
    var shouldAddFormSubmitTrigger = function (editor) {
      return editor.getParam('add_form_submit_trigger');
    };
    var shouldAddUnloadTrigger = function (editor) {
      return editor.getParam('add_unload_trigger');
    };
    var hasForcedRootBlock = function (editor) {
      return getForcedRootBlock(editor) !== '';
    };
    var getCustomUndoRedoLevels = function (editor) {
      return editor.getParam('custom_undo_redo_levels', 0, 'number');
    };
    var shouldDisableNodeChange = function (editor) {
      return editor.getParam('disable_nodechange');
    };
    var isReadOnly$1 = function (editor) {
      return editor.getParam('readonly');
    };
    var hasContentCssCors = function (editor) {
      return editor.getParam('content_css_cors');
    };
    var getPlugins = function (editor) {
      return editor.getParam('plugins', '', 'string');
    };
    var getExternalPlugins$1 = function (editor) {
      return editor.getParam('external_plugins');
    };
    var shouldBlockUnsupportedDrop = function (editor) {
      return editor.getParam('block_unsupported_drop', true, 'boolean');
    };
    var isVisualAidsEnabled = function (editor) {
      return editor.getParam('visual', true, 'boolean');
    };
    var getVisualAidsTableClass = function (editor) {
      return editor.getParam('visual_table_class', 'mce-item-table', 'string');
    };
    var getVisualAidsAnchorClass = function (editor) {
      return editor.getParam('visual_anchor_class', 'mce-item-anchor', 'string');
    };
    var getIframeAriaText = function (editor) {
      return editor.getParam('iframe_aria_text', 'Rich Text Area. Press ALT-0 for help.', 'string');
    };

    var isElement$2 = isElement$5;
    var isText$2 = isText$7;
    var removeNode$1 = function (node) {
      var parentNode = node.parentNode;
      if (parentNode) {
        parentNode.removeChild(node);
      }
    };
    var trimCount = function (text) {
      var trimmedText = trim$2(text);
      return {
        count: text.length - trimmedText.length,
        text: trimmedText
      };
    };
    var deleteZwspChars = function (caretContainer) {
      var idx;
      while ((idx = caretContainer.data.lastIndexOf(ZWSP$1)) !== -1) {
        caretContainer.deleteData(idx, 1);
      }
    };
    var removeUnchanged = function (caretContainer, pos) {
      remove$2(caretContainer);
      return pos;
    };
    var removeTextAndReposition = function (caretContainer, pos) {
      var before = trimCount(caretContainer.data.substr(0, pos.offset()));
      var after = trimCount(caretContainer.data.substr(pos.offset()));
      var text = before.text + after.text;
      if (text.length > 0) {
        deleteZwspChars(caretContainer);
        return CaretPosition(caretContainer, pos.offset() - before.count);
      } else {
        return pos;
      }
    };
    var removeElementAndReposition = function (caretContainer, pos) {
      var parentNode = pos.container();
      var newPosition = indexOf$2(from(parentNode.childNodes), caretContainer).map(function (index) {
        return index < pos.offset() ? CaretPosition(parentNode, pos.offset() - 1) : pos;
      }).getOr(pos);
      remove$2(caretContainer);
      return newPosition;
    };
    var removeTextCaretContainer = function (caretContainer, pos) {
      return isText$2(caretContainer) && pos.container() === caretContainer ? removeTextAndReposition(caretContainer, pos) : removeUnchanged(caretContainer, pos);
    };
    var removeElementCaretContainer = function (caretContainer, pos) {
      return pos.container() === caretContainer.parentNode ? removeElementAndReposition(caretContainer, pos) : removeUnchanged(caretContainer, pos);
    };
    var removeAndReposition = function (container, pos) {
      return CaretPosition.isTextPosition(pos) ? removeTextCaretContainer(container, pos) : removeElementCaretContainer(container, pos);
    };
    var remove$2 = function (caretContainerNode) {
      if (isElement$2(caretContainerNode) && isCaretContainer$2(caretContainerNode)) {
        if (hasContent(caretContainerNode)) {
          caretContainerNode.removeAttribute('data-mce-caret');
        } else {
          removeNode$1(caretContainerNode);
        }
      }
      if (isText$2(caretContainerNode)) {
        deleteZwspChars(caretContainerNode);
        if (caretContainerNode.data.length === 0) {
          removeNode$1(caretContainerNode);
        }
      }
    };

    var browser$2 = detect().browser;
    var isContentEditableFalse$8 = isContentEditableFalse$b;
    var isMedia$1 = isMedia$2;
    var isTableCell$3 = isTableCell$5;
    var inlineFakeCaretSelector = '*[contentEditable=false],video,audio,embed,object';
    var getAbsoluteClientRect = function (root, element, before) {
      var clientRect = collapse(element.getBoundingClientRect(), before);
      var scrollX;
      var scrollY;
      if (root.tagName === 'BODY') {
        var docElm = root.ownerDocument.documentElement;
        scrollX = root.scrollLeft || docElm.scrollLeft;
        scrollY = root.scrollTop || docElm.scrollTop;
      } else {
        var rootRect = root.getBoundingClientRect();
        scrollX = root.scrollLeft - rootRect.left;
        scrollY = root.scrollTop - rootRect.top;
      }
      clientRect.left += scrollX;
      clientRect.right += scrollX;
      clientRect.top += scrollY;
      clientRect.bottom += scrollY;
      clientRect.width = 1;
      var margin = element.offsetWidth - element.clientWidth;
      if (margin > 0) {
        if (before) {
          margin *= -1;
        }
        clientRect.left += margin;
        clientRect.right += margin;
      }
      return clientRect;
    };
    var trimInlineCaretContainers = function (root) {
      var fakeCaretTargetNodes = descendants(SugarElement.fromDom(root), inlineFakeCaretSelector);
      for (var i = 0; i < fakeCaretTargetNodes.length; i++) {
        var node = fakeCaretTargetNodes[i].dom;
        var sibling = node.previousSibling;
        if (endsWithCaretContainer$1(sibling)) {
          var data = sibling.data;
          if (data.length === 1) {
            sibling.parentNode.removeChild(sibling);
          } else {
            sibling.deleteData(data.length - 1, 1);
          }
        }
        sibling = node.nextSibling;
        if (startsWithCaretContainer$1(sibling)) {
          var data = sibling.data;
          if (data.length === 1) {
            sibling.parentNode.removeChild(sibling);
          } else {
            sibling.deleteData(0, 1);
          }
        }
      }
    };
    var FakeCaret = function (editor, root, isBlock, hasFocus) {
      var lastVisualCaret = value();
      var cursorInterval;
      var caretContainerNode;
      var rootBlock = getForcedRootBlock(editor);
      var caretBlock = rootBlock.length > 0 ? rootBlock : 'p';
      var show = function (before, element) {
        var rng;
        hide();
        if (isTableCell$3(element)) {
          return null;
        }
        if (isBlock(element)) {
          caretContainerNode = insertBlock$1(caretBlock, element, before);
          var clientRect = getAbsoluteClientRect(root, element, before);
          DomQuery(caretContainerNode).css('top', clientRect.top);
          var caret = DomQuery('<div class="mce-visual-caret" data-mce-bogus="all"></div>').css(__assign({}, clientRect)).appendTo(root)[0];
          lastVisualCaret.set({
            caret: caret,
            element: element,
            before: before
          });
          if (before) {
            DomQuery(caret).addClass('mce-visual-caret-before');
          }
          startBlink();
          rng = element.ownerDocument.createRange();
          rng.setStart(caretContainerNode, 0);
          rng.setEnd(caretContainerNode, 0);
        } else {
          caretContainerNode = insertInline$1(element, before);
          rng = element.ownerDocument.createRange();
          if (isInlineFakeCaretTarget(caretContainerNode.nextSibling)) {
            rng.setStart(caretContainerNode, 0);
            rng.setEnd(caretContainerNode, 0);
          } else {
            rng.setStart(caretContainerNode, 1);
            rng.setEnd(caretContainerNode, 1);
          }
          return rng;
        }
        return rng;
      };
      var hide = function () {
        trimInlineCaretContainers(root);
        if (caretContainerNode) {
          remove$2(caretContainerNode);
          caretContainerNode = null;
        }
        lastVisualCaret.on(function (caretState) {
          DomQuery(caretState.caret).remove();
          lastVisualCaret.clear();
        });
        if (cursorInterval) {
          Delay.clearInterval(cursorInterval);
          cursorInterval = undefined;
        }
      };
      var startBlink = function () {
        cursorInterval = Delay.setInterval(function () {
          if (hasFocus()) {
            DomQuery('div.mce-visual-caret', root).toggleClass('mce-visual-caret-hidden');
          } else {
            DomQuery('div.mce-visual-caret', root).addClass('mce-visual-caret-hidden');
          }
        }, 500);
      };
      var reposition = function () {
        lastVisualCaret.on(function (caretState) {
          var clientRect = getAbsoluteClientRect(root, caretState.element, caretState.before);
          DomQuery(caretState.caret).css(__assign({}, clientRect));
        });
      };
      var destroy = function () {
        return Delay.clearInterval(cursorInterval);
      };
      var getCss = function () {
        return '.mce-visual-caret {' + 'position: absolute;' + 'background-color: black;' + 'background-color: currentcolor;' + '}' + '.mce-visual-caret-hidden {' + 'display: none;' + '}' + '*[data-mce-caret] {' + 'position: absolute;' + 'left: -1000px;' + 'right: auto;' + 'top: 0;' + 'margin: 0;' + 'padding: 0;' + '}';
      };
      return {
        show: show,
        hide: hide,
        getCss: getCss,
        reposition: reposition,
        destroy: destroy
      };
    };
    var isFakeCaretTableBrowser = function () {
      return browser$2.isIE() || browser$2.isEdge() || browser$2.isFirefox();
    };
    var isInlineFakeCaretTarget = function (node) {
      return isContentEditableFalse$8(node) || isMedia$1(node);
    };
    var isFakeCaretTarget = function (node) {
      return isInlineFakeCaretTarget(node) || isTable$3(node) && isFakeCaretTableBrowser();
    };

    var isContentEditableFalse$7 = isContentEditableFalse$b;
    var isMedia = isMedia$2;
    var isBlockLike = matchStyleValues('display', 'block table table-cell table-caption list-item');
    var isCaretContainer = isCaretContainer$2;
    var isCaretContainerBlock = isCaretContainerBlock$1;
    var isElement$1 = isElement$5;
    var isCaretCandidate$1 = isCaretCandidate$3;
    var isForwards = function (direction) {
      return direction > 0;
    };
    var isBackwards = function (direction) {
      return direction < 0;
    };
    var skipCaretContainers = function (walk, shallow) {
      var node;
      while (node = walk(shallow)) {
        if (!isCaretContainerBlock(node)) {
          return node;
        }
      }
      return null;
    };
    var findNode$1 = function (node, direction, predicateFn, rootNode, shallow) {
      var walker = new DomTreeWalker(node, rootNode);
      var isCefOrCaretContainer = isContentEditableFalse$7(node) || isCaretContainerBlock(node);
      if (isBackwards(direction)) {
        if (isCefOrCaretContainer) {
          node = skipCaretContainers(walker.prev.bind(walker), true);
          if (predicateFn(node)) {
            return node;
          }
        }
        while (node = skipCaretContainers(walker.prev.bind(walker), shallow)) {
          if (predicateFn(node)) {
            return node;
          }
        }
      }
      if (isForwards(direction)) {
        if (isCefOrCaretContainer) {
          node = skipCaretContainers(walker.next.bind(walker), true);
          if (predicateFn(node)) {
            return node;
          }
        }
        while (node = skipCaretContainers(walker.next.bind(walker), shallow)) {
          if (predicateFn(node)) {
            return node;
          }
        }
      }
      return null;
    };
    var getParentBlock$2 = function (node, rootNode) {
      while (node && node !== rootNode) {
        if (isBlockLike(node)) {
          return node;
        }
        node = node.parentNode;
      }
      return null;
    };
    var isInSameBlock = function (caretPosition1, caretPosition2, rootNode) {
      return getParentBlock$2(caretPosition1.container(), rootNode) === getParentBlock$2(caretPosition2.container(), rootNode);
    };
    var getChildNodeAtRelativeOffset = function (relativeOffset, caretPosition) {
      if (!caretPosition) {
        return null;
      }
      var container = caretPosition.container();
      var offset = caretPosition.offset();
      if (!isElement$1(container)) {
        return null;
      }
      return container.childNodes[offset + relativeOffset];
    };
    var beforeAfter = function (before, node) {
      var range = node.ownerDocument.createRange();
      if (before) {
        range.setStartBefore(node);
        range.setEndBefore(node);
      } else {
        range.setStartAfter(node);
        range.setEndAfter(node);
      }
      return range;
    };
    var isNodesInSameBlock = function (root, node1, node2) {
      return getParentBlock$2(node1, root) === getParentBlock$2(node2, root);
    };
    var lean = function (left, root, node) {
      var siblingName = left ? 'previousSibling' : 'nextSibling';
      while (node && node !== root) {
        var sibling = node[siblingName];
        if (isCaretContainer(sibling)) {
          sibling = sibling[siblingName];
        }
        if (isContentEditableFalse$7(sibling) || isMedia(sibling)) {
          if (isNodesInSameBlock(root, sibling, node)) {
            return sibling;
          }
          break;
        }
        if (isCaretCandidate$1(sibling)) {
          break;
        }
        node = node.parentNode;
      }
      return null;
    };
    var before$2 = curry(beforeAfter, true);
    var after$2 = curry(beforeAfter, false);
    var normalizeRange = function (direction, root, range) {
      var node;
      var leanLeft = curry(lean, true, root);
      var leanRight = curry(lean, false, root);
      var container = range.startContainer;
      var offset = range.startOffset;
      if (isCaretContainerBlock$1(container)) {
        if (!isElement$1(container)) {
          container = container.parentNode;
        }
        var location_1 = container.getAttribute('data-mce-caret');
        if (location_1 === 'before') {
          node = container.nextSibling;
          if (isFakeCaretTarget(node)) {
            return before$2(node);
          }
        }
        if (location_1 === 'after') {
          node = container.previousSibling;
          if (isFakeCaretTarget(node)) {
            return after$2(node);
          }
        }
      }
      if (!range.collapsed) {
        return range;
      }
      if (isText$7(container)) {
        if (isCaretContainer(container)) {
          if (direction === 1) {
            node = leanRight(container);
            if (node) {
              return before$2(node);
            }
            node = leanLeft(container);
            if (node) {
              return after$2(node);
            }
          }
          if (direction === -1) {
            node = leanLeft(container);
            if (node) {
              return after$2(node);
            }
            node = leanRight(container);
            if (node) {
              return before$2(node);
            }
          }
          return range;
        }
        if (endsWithCaretContainer$1(container) && offset >= container.data.length - 1) {
          if (direction === 1) {
            node = leanRight(container);
            if (node) {
              return before$2(node);
            }
          }
          return range;
        }
        if (startsWithCaretContainer$1(container) && offset <= 1) {
          if (direction === -1) {
            node = leanLeft(container);
            if (node) {
              return after$2(node);
            }
          }
          return range;
        }
        if (offset === container.data.length) {
          node = leanRight(container);
          if (node) {
            return before$2(node);
          }
          return range;
        }
        if (offset === 0) {
          node = leanLeft(container);
          if (node) {
            return after$2(node);
          }
          return range;
        }
      }
      return range;
    };
    var getRelativeCefElm = function (forward, caretPosition) {
      return Optional.from(getChildNodeAtRelativeOffset(forward ? 0 : -1, caretPosition)).filter(isContentEditableFalse$7);
    };
    var getNormalizedRangeEndPoint = function (direction, root, range) {
      var normalizedRange = normalizeRange(direction, root, range);
      if (direction === -1) {
        return CaretPosition.fromRangeStart(normalizedRange);
      }
      return CaretPosition.fromRangeEnd(normalizedRange);
    };
    var getElementFromPosition = function (pos) {
      return Optional.from(pos.getNode()).map(SugarElement.fromDom);
    };
    var getElementFromPrevPosition = function (pos) {
      return Optional.from(pos.getNode(true)).map(SugarElement.fromDom);
    };
    var getVisualCaretPosition = function (walkFn, caretPosition) {
      while (caretPosition = walkFn(caretPosition)) {
        if (caretPosition.isVisible()) {
          return caretPosition;
        }
      }
      return caretPosition;
    };
    var isMoveInsideSameBlock = function (from, to) {
      var inSameBlock = isInSameBlock(from, to);
      if (!inSameBlock && isBr$5(from.getNode())) {
        return true;
      }
      return inSameBlock;
    };

    var HDirection;
    (function (HDirection) {
      HDirection[HDirection['Backwards'] = -1] = 'Backwards';
      HDirection[HDirection['Forwards'] = 1] = 'Forwards';
    }(HDirection || (HDirection = {})));
    var isContentEditableFalse$6 = isContentEditableFalse$b;
    var isText$1 = isText$7;
    var isElement = isElement$5;
    var isBr$1 = isBr$5;
    var isCaretCandidate = isCaretCandidate$3;
    var isAtomic = isAtomic$1;
    var isEditableCaretCandidate = isEditableCaretCandidate$1;
    var getParents$3 = function (node, root) {
      var parents = [];
      while (node && node !== root) {
        parents.push(node);
        node = node.parentNode;
      }
      return parents;
    };
    var nodeAtIndex = function (container, offset) {
      if (container.hasChildNodes() && offset < container.childNodes.length) {
        return container.childNodes[offset];
      }
      return null;
    };
    var getCaretCandidatePosition = function (direction, node) {
      if (isForwards(direction)) {
        if (isCaretCandidate(node.previousSibling) && !isText$1(node.previousSibling)) {
          return CaretPosition.before(node);
        }
        if (isText$1(node)) {
          return CaretPosition(node, 0);
        }
      }
      if (isBackwards(direction)) {
        if (isCaretCandidate(node.nextSibling) && !isText$1(node.nextSibling)) {
          return CaretPosition.after(node);
        }
        if (isText$1(node)) {
          return CaretPosition(node, node.data.length);
        }
      }
      if (isBackwards(direction)) {
        if (isBr$1(node)) {
          return CaretPosition.before(node);
        }
        return CaretPosition.after(node);
      }
      return CaretPosition.before(node);
    };
    var moveForwardFromBr = function (root, nextNode) {
      var nextSibling = nextNode.nextSibling;
      if (nextSibling && isCaretCandidate(nextSibling)) {
        if (isText$1(nextSibling)) {
          return CaretPosition(nextSibling, 0);
        } else {
          return CaretPosition.before(nextSibling);
        }
      } else {
        return findCaretPosition$1(HDirection.Forwards, CaretPosition.after(nextNode), root);
      }
    };
    var findCaretPosition$1 = function (direction, startPos, root) {
      var node;
      var nextNode;
      var innerNode;
      var caretPosition;
      if (!isElement(root) || !startPos) {
        return null;
      }
      if (startPos.isEqual(CaretPosition.after(root)) && root.lastChild) {
        caretPosition = CaretPosition.after(root.lastChild);
        if (isBackwards(direction) && isCaretCandidate(root.lastChild) && isElement(root.lastChild)) {
          return isBr$1(root.lastChild) ? CaretPosition.before(root.lastChild) : caretPosition;
        }
      } else {
        caretPosition = startPos;
      }
      var container = caretPosition.container();
      var offset = caretPosition.offset();
      if (isText$1(container)) {
        if (isBackwards(direction) && offset > 0) {
          return CaretPosition(container, --offset);
        }
        if (isForwards(direction) && offset < container.length) {
          return CaretPosition(container, ++offset);
        }
        node = container;
      } else {
        if (isBackwards(direction) && offset > 0) {
          nextNode = nodeAtIndex(container, offset - 1);
          if (isCaretCandidate(nextNode)) {
            if (!isAtomic(nextNode)) {
              innerNode = findNode$1(nextNode, direction, isEditableCaretCandidate, nextNode);
              if (innerNode) {
                if (isText$1(innerNode)) {
                  return CaretPosition(innerNode, innerNode.data.length);
                }
                return CaretPosition.after(innerNode);
              }
            }
            if (isText$1(nextNode)) {
              return CaretPosition(nextNode, nextNode.data.length);
            }
            return CaretPosition.before(nextNode);
          }
        }
        if (isForwards(direction) && offset < container.childNodes.length) {
          nextNode = nodeAtIndex(container, offset);
          if (isCaretCandidate(nextNode)) {
            if (isBr$1(nextNode)) {
              return moveForwardFromBr(root, nextNode);
            }
            if (!isAtomic(nextNode)) {
              innerNode = findNode$1(nextNode, direction, isEditableCaretCandidate, nextNode);
              if (innerNode) {
                if (isText$1(innerNode)) {
                  return CaretPosition(innerNode, 0);
                }
                return CaretPosition.before(innerNode);
              }
            }
            if (isText$1(nextNode)) {
              return CaretPosition(nextNode, 0);
            }
            return CaretPosition.after(nextNode);
          }
        }
        node = nextNode ? nextNode : caretPosition.getNode();
      }
      if (isForwards(direction) && caretPosition.isAtEnd() || isBackwards(direction) && caretPosition.isAtStart()) {
        node = findNode$1(node, direction, always, root, true);
        if (isEditableCaretCandidate(node, root)) {
          return getCaretCandidatePosition(direction, node);
        }
      }
      nextNode = findNode$1(node, direction, isEditableCaretCandidate, root);
      var rootContentEditableFalseElm = last$1(filter$4(getParents$3(container, root), isContentEditableFalse$6));
      if (rootContentEditableFalseElm && (!nextNode || !rootContentEditableFalseElm.contains(nextNode))) {
        if (isForwards(direction)) {
          caretPosition = CaretPosition.after(rootContentEditableFalseElm);
        } else {
          caretPosition = CaretPosition.before(rootContentEditableFalseElm);
        }
        return caretPosition;
      }
      if (nextNode) {
        return getCaretCandidatePosition(direction, nextNode);
      }
      return null;
    };
    var CaretWalker = function (root) {
      return {
        next: function (caretPosition) {
          return findCaretPosition$1(HDirection.Forwards, caretPosition, root);
        },
        prev: function (caretPosition) {
          return findCaretPosition$1(HDirection.Backwards, caretPosition, root);
        }
      };
    };

    var walkToPositionIn = function (forward, root, start) {
      var position = forward ? CaretPosition.before(start) : CaretPosition.after(start);
      return fromPosition(forward, root, position);
    };
    var afterElement = function (node) {
      return isBr$5(node) ? CaretPosition.before(node) : CaretPosition.after(node);
    };
    var isBeforeOrStart = function (position) {
      if (CaretPosition.isTextPosition(position)) {
        return position.offset() === 0;
      } else {
        return isCaretCandidate$3(position.getNode());
      }
    };
    var isAfterOrEnd = function (position) {
      if (CaretPosition.isTextPosition(position)) {
        var container = position.container();
        return position.offset() === container.data.length;
      } else {
        return isCaretCandidate$3(position.getNode(true));
      }
    };
    var isBeforeAfterSameElement = function (from, to) {
      return !CaretPosition.isTextPosition(from) && !CaretPosition.isTextPosition(to) && from.getNode() === to.getNode(true);
    };
    var isAtBr = function (position) {
      return !CaretPosition.isTextPosition(position) && isBr$5(position.getNode());
    };
    var shouldSkipPosition = function (forward, from, to) {
      if (forward) {
        return !isBeforeAfterSameElement(from, to) && !isAtBr(from) && isAfterOrEnd(from) && isBeforeOrStart(to);
      } else {
        return !isBeforeAfterSameElement(to, from) && isBeforeOrStart(from) && isAfterOrEnd(to);
      }
    };
    var fromPosition = function (forward, root, pos) {
      var walker = CaretWalker(root);
      return Optional.from(forward ? walker.next(pos) : walker.prev(pos));
    };
    var navigate = function (forward, root, from) {
      return fromPosition(forward, root, from).bind(function (to) {
        if (isInSameBlock(from, to, root) && shouldSkipPosition(forward, from, to)) {
          return fromPosition(forward, root, to);
        } else {
          return Optional.some(to);
        }
      });
    };
    var navigateIgnore = function (forward, root, from, ignoreFilter) {
      return navigate(forward, root, from).bind(function (pos) {
        return ignoreFilter(pos) ? navigateIgnore(forward, root, pos, ignoreFilter) : Optional.some(pos);
      });
    };
    var positionIn = function (forward, element) {
      var startNode = forward ? element.firstChild : element.lastChild;
      if (isText$7(startNode)) {
        return Optional.some(CaretPosition(startNode, forward ? 0 : startNode.data.length));
      } else if (startNode) {
        if (isCaretCandidate$3(startNode)) {
          return Optional.some(forward ? CaretPosition.before(startNode) : afterElement(startNode));
        } else {
          return walkToPositionIn(forward, element, startNode);
        }
      } else {
        return Optional.none();
      }
    };
    var nextPosition = curry(fromPosition, true);
    var prevPosition = curry(fromPosition, false);
    var firstPositionIn = curry(positionIn, true);
    var lastPositionIn = curry(positionIn, false);

    var CARET_ID$1 = '_mce_caret';
    var isCaretNode = function (node) {
      return isElement$5(node) && node.id === CARET_ID$1;
    };
    var getParentCaretContainer = function (body, node) {
      while (node && node !== body) {
        if (node.id === CARET_ID$1) {
          return node;
        }
        node = node.parentNode;
      }
      return null;
    };

    var isStringPathBookmark = function (bookmark) {
      return isString$1(bookmark.start);
    };
    var isRangeBookmark = function (bookmark) {
      return has$2(bookmark, 'rng');
    };
    var isIdBookmark = function (bookmark) {
      return has$2(bookmark, 'id');
    };
    var isIndexBookmark = function (bookmark) {
      return has$2(bookmark, 'name');
    };
    var isPathBookmark = function (bookmark) {
      return Tools.isArray(bookmark.start);
    };

    var addBogus = function (dom, node) {
      if (isElement$5(node) && dom.isBlock(node) && !node.innerHTML && !Env.ie) {
        node.innerHTML = '<br data-mce-bogus="1" />';
      }
      return node;
    };
    var resolveCaretPositionBookmark = function (dom, bookmark) {
      var pos;
      var rng = dom.createRng();
      pos = resolve$2(dom.getRoot(), bookmark.start);
      rng.setStart(pos.container(), pos.offset());
      pos = resolve$2(dom.getRoot(), bookmark.end);
      rng.setEnd(pos.container(), pos.offset());
      return rng;
    };
    var insertZwsp = function (node, rng) {
      var textNode = node.ownerDocument.createTextNode(ZWSP$1);
      node.appendChild(textNode);
      rng.setStart(textNode, 0);
      rng.setEnd(textNode, 0);
    };
    var isEmpty$1 = function (node) {
      return node.hasChildNodes() === false;
    };
    var tryFindRangePosition = function (node, rng) {
      return lastPositionIn(node).fold(never, function (pos) {
        rng.setStart(pos.container(), pos.offset());
        rng.setEnd(pos.container(), pos.offset());
        return true;
      });
    };
    var padEmptyCaretContainer = function (root, node, rng) {
      if (isEmpty$1(node) && getParentCaretContainer(root, node)) {
        insertZwsp(node, rng);
        return true;
      } else {
        return false;
      }
    };
    var setEndPoint = function (dom, start, bookmark, rng) {
      var point = bookmark[start ? 'start' : 'end'];
      var i, node, offset, children;
      var root = dom.getRoot();
      if (point) {
        offset = point[0];
        for (node = root, i = point.length - 1; i >= 1; i--) {
          children = node.childNodes;
          if (padEmptyCaretContainer(root, node, rng)) {
            return true;
          }
          if (point[i] > children.length - 1) {
            if (padEmptyCaretContainer(root, node, rng)) {
              return true;
            }
            return tryFindRangePosition(node, rng);
          }
          node = children[point[i]];
        }
        if (node.nodeType === 3) {
          offset = Math.min(point[0], node.nodeValue.length);
        }
        if (node.nodeType === 1) {
          offset = Math.min(point[0], node.childNodes.length);
        }
        if (start) {
          rng.setStart(node, offset);
        } else {
          rng.setEnd(node, offset);
        }
      }
      return true;
    };
    var isValidTextNode = function (node) {
      return isText$7(node) && node.data.length > 0;
    };
    var restoreEndPoint = function (dom, suffix, bookmark) {
      var marker = dom.get(bookmark.id + '_' + suffix), node, idx, next, prev;
      var keep = bookmark.keep;
      var container, offset;
      if (marker) {
        node = marker.parentNode;
        if (suffix === 'start') {
          if (!keep) {
            idx = dom.nodeIndex(marker);
          } else {
            if (marker.hasChildNodes()) {
              node = marker.firstChild;
              idx = 1;
            } else if (isValidTextNode(marker.nextSibling)) {
              node = marker.nextSibling;
              idx = 0;
            } else if (isValidTextNode(marker.previousSibling)) {
              node = marker.previousSibling;
              idx = marker.previousSibling.data.length;
            } else {
              node = marker.parentNode;
              idx = dom.nodeIndex(marker) + 1;
            }
          }
          container = node;
          offset = idx;
        } else {
          if (!keep) {
            idx = dom.nodeIndex(marker);
          } else {
            if (marker.hasChildNodes()) {
              node = marker.firstChild;
              idx = 1;
            } else if (isValidTextNode(marker.previousSibling)) {
              node = marker.previousSibling;
              idx = marker.previousSibling.data.length;
            } else {
              node = marker.parentNode;
              idx = dom.nodeIndex(marker);
            }
          }
          container = node;
          offset = idx;
        }
        if (!keep) {
          prev = marker.previousSibling;
          next = marker.nextSibling;
          Tools.each(Tools.grep(marker.childNodes), function (node) {
            if (isText$7(node)) {
              node.nodeValue = node.nodeValue.replace(/\uFEFF/g, '');
            }
          });
          while (marker = dom.get(bookmark.id + '_' + suffix)) {
            dom.remove(marker, true);
          }
          if (prev && next && prev.nodeType === next.nodeType && isText$7(prev) && !Env.opera) {
            idx = prev.nodeValue.length;
            prev.appendData(next.nodeValue);
            dom.remove(next);
            container = prev;
            offset = idx;
          }
        }
        return Optional.some(CaretPosition(container, offset));
      } else {
        return Optional.none();
      }
    };
    var resolvePaths = function (dom, bookmark) {
      var rng = dom.createRng();
      if (setEndPoint(dom, true, bookmark, rng) && setEndPoint(dom, false, bookmark, rng)) {
        return Optional.some(rng);
      } else {
        return Optional.none();
      }
    };
    var resolveId = function (dom, bookmark) {
      var startPos = restoreEndPoint(dom, 'start', bookmark);
      var endPos = restoreEndPoint(dom, 'end', bookmark);
      return lift2(startPos, endPos.or(startPos), function (spos, epos) {
        var rng = dom.createRng();
        rng.setStart(addBogus(dom, spos.container()), spos.offset());
        rng.setEnd(addBogus(dom, epos.container()), epos.offset());
        return rng;
      });
    };
    var resolveIndex = function (dom, bookmark) {
      return Optional.from(dom.select(bookmark.name)[bookmark.index]).map(function (elm) {
        var rng = dom.createRng();
        rng.selectNode(elm);
        return rng;
      });
    };
    var resolve$1 = function (selection, bookmark) {
      var dom = selection.dom;
      if (bookmark) {
        if (isPathBookmark(bookmark)) {
          return resolvePaths(dom, bookmark);
        } else if (isStringPathBookmark(bookmark)) {
          return Optional.some(resolveCaretPositionBookmark(dom, bookmark));
        } else if (isIdBookmark(bookmark)) {
          return resolveId(dom, bookmark);
        } else if (isIndexBookmark(bookmark)) {
          return resolveIndex(dom, bookmark);
        } else if (isRangeBookmark(bookmark)) {
          return Optional.some(bookmark.rng);
        }
      }
      return Optional.none();
    };

    var getBookmark$1 = function (selection, type, normalized) {
      return getBookmark$2(selection, type, normalized);
    };
    var moveToBookmark = function (selection, bookmark) {
      resolve$1(selection, bookmark).each(function (rng) {
        selection.setRng(rng);
      });
    };
    var isBookmarkNode$1 = function (node) {
      return isElement$5(node) && node.tagName === 'SPAN' && node.getAttribute('data-mce-type') === 'bookmark';
    };

    var is = function (expected) {
      return function (actual) {
        return expected === actual;
      };
    };
    var isNbsp = is(nbsp);
    var isWhiteSpace = function (chr) {
      return chr !== '' && ' \f\n\r\t\x0B'.indexOf(chr) !== -1;
    };
    var isContent = function (chr) {
      return !isWhiteSpace(chr) && !isNbsp(chr);
    };

    var isNode = function (node) {
      return !!node.nodeType;
    };
    var isInlineBlock = function (node) {
      return node && /^(IMG)$/.test(node.nodeName);
    };
    var moveStart = function (dom, selection, rng) {
      var offset = rng.startOffset;
      var container = rng.startContainer;
      if (container === rng.endContainer) {
        if (isInlineBlock(container.childNodes[offset])) {
          return;
        }
      }
      if (isElement$5(container)) {
        var nodes = container.childNodes;
        var walker = void 0;
        if (offset < nodes.length) {
          container = nodes[offset];
          walker = new DomTreeWalker(container, dom.getParent(container, dom.isBlock));
        } else {
          container = nodes[nodes.length - 1];
          walker = new DomTreeWalker(container, dom.getParent(container, dom.isBlock));
          walker.next(true);
        }
        for (var node = walker.current(); node; node = walker.next()) {
          if (isText$7(node) && !isWhiteSpaceNode$1(node)) {
            rng.setStart(node, 0);
            selection.setRng(rng);
            return;
          }
        }
      }
    };
    var getNonWhiteSpaceSibling = function (node, next, inc) {
      if (node) {
        var nextName = next ? 'nextSibling' : 'previousSibling';
        for (node = inc ? node : node[nextName]; node; node = node[nextName]) {
          if (isElement$5(node) || !isWhiteSpaceNode$1(node)) {
            return node;
          }
        }
      }
    };
    var isTextBlock$1 = function (editor, name) {
      if (isNode(name)) {
        name = name.nodeName;
      }
      return !!editor.schema.getTextBlockElements()[name.toLowerCase()];
    };
    var isValid = function (ed, parent, child) {
      return ed.schema.isValidChild(parent, child);
    };
    var isWhiteSpaceNode$1 = function (node, allowSpaces) {
      if (allowSpaces === void 0) {
        allowSpaces = false;
      }
      if (isNonNullable(node) && isText$7(node)) {
        var data = allowSpaces ? node.data.replace(/ /g, '\xA0') : node.data;
        return isWhitespaceText(data);
      } else {
        return false;
      }
    };
    var isEmptyTextNode$1 = function (node) {
      return isNonNullable(node) && isText$7(node) && node.length === 0;
    };
    var replaceVars = function (value, vars) {
      if (isFunction(value)) {
        value = value(vars);
      } else if (isNonNullable(vars)) {
        value = value.replace(/%(\w+)/g, function (str, name) {
          return vars[name] || str;
        });
      }
      return value;
    };
    var isEq$5 = function (str1, str2) {
      str1 = str1 || '';
      str2 = str2 || '';
      str1 = '' + (str1.nodeName || str1);
      str2 = '' + (str2.nodeName || str2);
      return str1.toLowerCase() === str2.toLowerCase();
    };
    var normalizeStyleValue = function (dom, value, name) {
      if (name === 'color' || name === 'backgroundColor') {
        value = dom.toHex(value);
      }
      if (name === 'fontWeight' && value === 700) {
        value = 'bold';
      }
      if (name === 'fontFamily') {
        value = value.replace(/[\'\"]/g, '').replace(/,\s+/g, ',');
      }
      return '' + value;
    };
    var getStyle = function (dom, node, name) {
      return normalizeStyleValue(dom, dom.getStyle(node, name), name);
    };
    var getTextDecoration = function (dom, node) {
      var decoration;
      dom.getParent(node, function (n) {
        decoration = dom.getStyle(n, 'text-decoration');
        return decoration && decoration !== 'none';
      });
      return decoration;
    };
    var getParents$2 = function (dom, node, selector) {
      return dom.getParents(node, selector, dom.getRoot());
    };
    var isVariableFormatName = function (editor, formatName) {
      var hasVariableValues = function (format) {
        var isVariableValue = function (val) {
          return val.length > 1 && val.charAt(0) === '%';
        };
        return exists([
          'styles',
          'attributes'
        ], function (key) {
          return get$9(format, key).exists(function (field) {
            var fieldValues = isArray$1(field) ? field : values(field);
            return exists(fieldValues, isVariableValue);
          });
        });
      };
      return exists(editor.formatter.get(formatName), hasVariableValues);
    };
    var areSimilarFormats = function (editor, formatName, otherFormatName) {
      var validKeys = [
        'inline',
        'block',
        'selector',
        'attributes',
        'styles',
        'classes'
      ];
      var filterObj = function (format) {
        return filter$3(format, function (_, key) {
          return exists(validKeys, function (validKey) {
            return validKey === key;
          });
        });
      };
      return exists(editor.formatter.get(formatName), function (fmt1) {
        var filteredFmt1 = filterObj(fmt1);
        return exists(editor.formatter.get(otherFormatName), function (fmt2) {
          var filteredFmt2 = filterObj(fmt2);
          return equal$1(filteredFmt1, filteredFmt2);
        });
      });
    };
    var isBlockFormat = function (format) {
      return hasNonNullableKey(format, 'block');
    };
    var isSelectorFormat = function (format) {
      return hasNonNullableKey(format, 'selector');
    };
    var isInlineFormat = function (format) {
      return hasNonNullableKey(format, 'inline');
    };
    var isMixedFormat = function (format) {
      return isSelectorFormat(format) && isInlineFormat(format) && is$1(get$9(format, 'mixed'), true);
    };
    var shouldExpandToSelector = function (format) {
      return isSelectorFormat(format) && format.expand !== false && !isInlineFormat(format);
    };

    var isBookmarkNode = isBookmarkNode$1;
    var getParents$1 = getParents$2;
    var isWhiteSpaceNode = isWhiteSpaceNode$1;
    var isTextBlock = isTextBlock$1;
    var isBogusBr = function (node) {
      return isBr$5(node) && node.getAttribute('data-mce-bogus') && !node.nextSibling;
    };
    var findParentContentEditable = function (dom, node) {
      var parent = node;
      while (parent) {
        if (isElement$5(parent) && dom.getContentEditable(parent)) {
          return dom.getContentEditable(parent) === 'false' ? parent : node;
        }
        parent = parent.parentNode;
      }
      return node;
    };
    var walkText = function (start, node, offset, predicate) {
      var str = node.data;
      for (var i = offset; start ? i >= 0 : i < str.length; start ? i-- : i++) {
        if (predicate(str.charAt(i))) {
          return start ? i + 1 : i;
        }
      }
      return -1;
    };
    var findSpace = function (start, node, offset) {
      return walkText(start, node, offset, function (c) {
        return isNbsp(c) || isWhiteSpace(c);
      });
    };
    var findContent = function (start, node, offset) {
      return walkText(start, node, offset, isContent);
    };
    var findWordEndPoint = function (dom, body, container, offset, start, includeTrailingSpaces) {
      var lastTextNode;
      var rootNode = dom.getParent(container, dom.isBlock) || body;
      var walk = function (container, offset, pred) {
        var textSeeker = TextSeeker(dom);
        var walker = start ? textSeeker.backwards : textSeeker.forwards;
        return Optional.from(walker(container, offset, function (text, textOffset) {
          if (isBookmarkNode(text.parentNode)) {
            return -1;
          } else {
            lastTextNode = text;
            return pred(start, text, textOffset);
          }
        }, rootNode));
      };
      var spaceResult = walk(container, offset, findSpace);
      return spaceResult.bind(function (result) {
        return includeTrailingSpaces ? walk(result.container, result.offset + (start ? -1 : 0), findContent) : Optional.some(result);
      }).orThunk(function () {
        return lastTextNode ? Optional.some({
          container: lastTextNode,
          offset: start ? 0 : lastTextNode.length
        }) : Optional.none();
      });
    };
    var findSelectorEndPoint = function (dom, formatList, rng, container, siblingName) {
      if (isText$7(container) && isEmpty$3(container.data) && container[siblingName]) {
        container = container[siblingName];
      }
      var parents = getParents$1(dom, container);
      for (var i = 0; i < parents.length; i++) {
        for (var y = 0; y < formatList.length; y++) {
          var curFormat = formatList[y];
          if (isNonNullable(curFormat.collapsed) && curFormat.collapsed !== rng.collapsed) {
            continue;
          }
          if (isSelectorFormat(curFormat) && dom.is(parents[i], curFormat.selector)) {
            return parents[i];
          }
        }
      }
      return container;
    };
    var findBlockEndPoint = function (editor, formatList, container, siblingName) {
      var node = container;
      var dom = editor.dom;
      var root = dom.getRoot();
      var format = formatList[0];
      if (isBlockFormat(format)) {
        node = format.wrapper ? null : dom.getParent(container, format.block, root);
      }
      if (!node) {
        var scopeRoot = dom.getParent(container, 'LI,TD,TH');
        node = dom.getParent(isText$7(container) ? container.parentNode : container, function (node) {
          return node !== root && isTextBlock(editor, node);
        }, scopeRoot);
      }
      if (node && isBlockFormat(format) && format.wrapper) {
        node = getParents$1(dom, node, 'ul,ol').reverse()[0] || node;
      }
      if (!node) {
        node = container;
        while (node[siblingName] && !dom.isBlock(node[siblingName])) {
          node = node[siblingName];
          if (isEq$5(node, 'br')) {
            break;
          }
        }
      }
      return node || container;
    };
    var isAtBlockBoundary$1 = function (dom, root, container, siblingName) {
      var parent = container.parentNode;
      if (isNonNullable(container[siblingName])) {
        return false;
      } else if (parent === root || isNullable(parent) || dom.isBlock(parent)) {
        return true;
      } else {
        return isAtBlockBoundary$1(dom, root, parent, siblingName);
      }
    };
    var findParentContainer = function (dom, formatList, container, offset, start) {
      var parent = container;
      var siblingName = start ? 'previousSibling' : 'nextSibling';
      var root = dom.getRoot();
      if (isText$7(container) && !isWhiteSpaceNode(container)) {
        if (start ? offset > 0 : offset < container.data.length) {
          return container;
        }
      }
      while (true) {
        if (!formatList[0].block_expand && dom.isBlock(parent)) {
          return parent;
        }
        for (var sibling = parent[siblingName]; sibling; sibling = sibling[siblingName]) {
          var allowSpaces = isText$7(sibling) && !isAtBlockBoundary$1(dom, root, sibling, siblingName);
          if (!isBookmarkNode(sibling) && !isBogusBr(sibling) && !isWhiteSpaceNode(sibling, allowSpaces)) {
            return parent;
          }
        }
        if (parent === root || parent.parentNode === root) {
          container = parent;
          break;
        }
        parent = parent.parentNode;
      }
      return container;
    };
    var isSelfOrParentBookmark = function (container) {
      return isBookmarkNode(container.parentNode) || isBookmarkNode(container);
    };
    var expandRng = function (editor, rng, formatList, includeTrailingSpace) {
      if (includeTrailingSpace === void 0) {
        includeTrailingSpace = false;
      }
      var startContainer = rng.startContainer, startOffset = rng.startOffset, endContainer = rng.endContainer, endOffset = rng.endOffset;
      var dom = editor.dom;
      var format = formatList[0];
      if (isElement$5(startContainer) && startContainer.hasChildNodes()) {
        startContainer = getNode$1(startContainer, startOffset);
        if (isText$7(startContainer)) {
          startOffset = 0;
        }
      }
      if (isElement$5(endContainer) && endContainer.hasChildNodes()) {
        endContainer = getNode$1(endContainer, rng.collapsed ? endOffset : endOffset - 1);
        if (isText$7(endContainer)) {
          endOffset = endContainer.nodeValue.length;
        }
      }
      startContainer = findParentContentEditable(dom, startContainer);
      endContainer = findParentContentEditable(dom, endContainer);
      if (isSelfOrParentBookmark(startContainer)) {
        startContainer = isBookmarkNode(startContainer) ? startContainer : startContainer.parentNode;
        if (rng.collapsed) {
          startContainer = startContainer.previousSibling || startContainer;
        } else {
          startContainer = startContainer.nextSibling || startContainer;
        }
        if (isText$7(startContainer)) {
          startOffset = rng.collapsed ? startContainer.length : 0;
        }
      }
      if (isSelfOrParentBookmark(endContainer)) {
        endContainer = isBookmarkNode(endContainer) ? endContainer : endContainer.parentNode;
        if (rng.collapsed) {
          endContainer = endContainer.nextSibling || endContainer;
        } else {
          endContainer = endContainer.previousSibling || endContainer;
        }
        if (isText$7(endContainer)) {
          endOffset = rng.collapsed ? 0 : endContainer.length;
        }
      }
      if (rng.collapsed) {
        var startPoint = findWordEndPoint(dom, editor.getBody(), startContainer, startOffset, true, includeTrailingSpace);
        startPoint.each(function (_a) {
          var container = _a.container, offset = _a.offset;
          startContainer = container;
          startOffset = offset;
        });
        var endPoint = findWordEndPoint(dom, editor.getBody(), endContainer, endOffset, false, includeTrailingSpace);
        endPoint.each(function (_a) {
          var container = _a.container, offset = _a.offset;
          endContainer = container;
          endOffset = offset;
        });
      }
      if (isInlineFormat(format) || format.block_expand) {
        if (!isInlineFormat(format) || (!isText$7(startContainer) || startOffset === 0)) {
          startContainer = findParentContainer(dom, formatList, startContainer, startOffset, true);
        }
        if (!isInlineFormat(format) || (!isText$7(endContainer) || endOffset === endContainer.nodeValue.length)) {
          endContainer = findParentContainer(dom, formatList, endContainer, endOffset, false);
        }
      }
      if (shouldExpandToSelector(format)) {
        startContainer = findSelectorEndPoint(dom, formatList, rng, startContainer, 'previousSibling');
        endContainer = findSelectorEndPoint(dom, formatList, rng, endContainer, 'nextSibling');
      }
      if (isBlockFormat(format) || isSelectorFormat(format)) {
        startContainer = findBlockEndPoint(editor, formatList, startContainer, 'previousSibling');
        endContainer = findBlockEndPoint(editor, formatList, endContainer, 'nextSibling');
        if (isBlockFormat(format)) {
          if (!dom.isBlock(startContainer)) {
            startContainer = findParentContainer(dom, formatList, startContainer, startOffset, true);
          }
          if (!dom.isBlock(endContainer)) {
            endContainer = findParentContainer(dom, formatList, endContainer, endOffset, false);
          }
        }
      }
      if (isElement$5(startContainer)) {
        startOffset = dom.nodeIndex(startContainer);
        startContainer = startContainer.parentNode;
      }
      if (isElement$5(endContainer)) {
        endOffset = dom.nodeIndex(endContainer) + 1;
        endContainer = endContainer.parentNode;
      }
      return {
        startContainer: startContainer,
        startOffset: startOffset,
        endContainer: endContainer,
        endOffset: endOffset
      };
    };

    var walk$2 = function (dom, rng, callback) {
      var startOffset = rng.startOffset;
      var startContainer = getNode$1(rng.startContainer, startOffset);
      var endOffset = rng.endOffset;
      var endContainer = getNode$1(rng.endContainer, endOffset - 1);
      var exclude = function (nodes) {
        var firstNode = nodes[0];
        if (isText$7(firstNode) && firstNode === startContainer && startOffset >= firstNode.data.length) {
          nodes.splice(0, 1);
        }
        var lastNode = nodes[nodes.length - 1];
        if (endOffset === 0 && nodes.length > 0 && lastNode === endContainer && isText$7(lastNode)) {
          nodes.splice(nodes.length - 1, 1);
        }
        return nodes;
      };
      var collectSiblings = function (node, name, endNode) {
        var siblings = [];
        for (; node && node !== endNode; node = node[name]) {
          siblings.push(node);
        }
        return siblings;
      };
      var findEndPoint = function (node, root) {
        return dom.getParent(node, function (node) {
          return node.parentNode === root;
        }, root);
      };
      var walkBoundary = function (startNode, endNode, next) {
        var siblingName = next ? 'nextSibling' : 'previousSibling';
        for (var node = startNode, parent_1 = node.parentNode; node && node !== endNode; node = parent_1) {
          parent_1 = node.parentNode;
          var siblings_1 = collectSiblings(node === startNode ? node : node[siblingName], siblingName);
          if (siblings_1.length) {
            if (!next) {
              siblings_1.reverse();
            }
            callback(exclude(siblings_1));
          }
        }
      };
      if (startContainer === endContainer) {
        return callback(exclude([startContainer]));
      }
      var ancestor = dom.findCommonAncestor(startContainer, endContainer);
      if (dom.isChildOf(startContainer, endContainer)) {
        return walkBoundary(startContainer, ancestor, true);
      }
      if (dom.isChildOf(endContainer, startContainer)) {
        return walkBoundary(endContainer, ancestor);
      }
      var startPoint = findEndPoint(startContainer, ancestor) || startContainer;
      var endPoint = findEndPoint(endContainer, ancestor) || endContainer;
      walkBoundary(startContainer, startPoint, true);
      var siblings = collectSiblings(startPoint === startContainer ? startPoint : startPoint.nextSibling, 'nextSibling', endPoint === endContainer ? endPoint.nextSibling : endPoint);
      if (siblings.length) {
        callback(exclude(siblings));
      }
      walkBoundary(endContainer, endPoint);
    };

    var getRanges = function (selection) {
      var ranges = [];
      if (selection) {
        for (var i = 0; i < selection.rangeCount; i++) {
          ranges.push(selection.getRangeAt(i));
        }
      }
      return ranges;
    };
    var getSelectedNodes = function (ranges) {
      return bind(ranges, function (range) {
        var node = getSelectedNode(range);
        return node ? [SugarElement.fromDom(node)] : [];
      });
    };
    var hasMultipleRanges = function (selection) {
      return getRanges(selection).length > 1;
    };

    var getCellsFromRanges = function (ranges) {
      return filter$4(getSelectedNodes(ranges), isTableCell$4);
    };
    var getCellsFromElement = function (elm) {
      return descendants(elm, 'td[data-mce-selected],th[data-mce-selected]');
    };
    var getCellsFromElementOrRanges = function (ranges, element) {
      var selectedCells = getCellsFromElement(element);
      return selectedCells.length > 0 ? selectedCells : getCellsFromRanges(ranges);
    };
    var getCellsFromEditor = function (editor) {
      return getCellsFromElementOrRanges(getRanges(editor.selection.getSel()), SugarElement.fromDom(editor.getBody()));
    };
    var getClosestTable = function (cell, isRoot) {
      return ancestor$2(cell, 'table', isRoot);
    };

    var getStartNode = function (rng) {
      var sc = rng.startContainer, so = rng.startOffset;
      if (isText$7(sc)) {
        return so === 0 ? Optional.some(SugarElement.fromDom(sc)) : Optional.none();
      } else {
        return Optional.from(sc.childNodes[so]).map(SugarElement.fromDom);
      }
    };
    var getEndNode = function (rng) {
      var ec = rng.endContainer, eo = rng.endOffset;
      if (isText$7(ec)) {
        return eo === ec.data.length ? Optional.some(SugarElement.fromDom(ec)) : Optional.none();
      } else {
        return Optional.from(ec.childNodes[eo - 1]).map(SugarElement.fromDom);
      }
    };
    var getFirstChildren = function (node) {
      return firstChild(node).fold(constant([node]), function (child) {
        return [node].concat(getFirstChildren(child));
      });
    };
    var getLastChildren$1 = function (node) {
      return lastChild(node).fold(constant([node]), function (child) {
        if (name(child) === 'br') {
          return prevSibling(child).map(function (sibling) {
            return [node].concat(getLastChildren$1(sibling));
          }).getOr([]);
        } else {
          return [node].concat(getLastChildren$1(child));
        }
      });
    };
    var hasAllContentsSelected = function (elm, rng) {
      return lift2(getStartNode(rng), getEndNode(rng), function (startNode, endNode) {
        var start = find$3(getFirstChildren(elm), curry(eq, startNode));
        var end = find$3(getLastChildren$1(elm), curry(eq, endNode));
        return start.isSome() && end.isSome();
      }).getOr(false);
    };
    var moveEndPoint = function (dom, rng, node, start) {
      var root = node, walker = new DomTreeWalker(node, root);
      var moveCaretBeforeOnEnterElementsMap = filter$3(dom.schema.getMoveCaretBeforeOnEnterElements(), function (_, name) {
        return !contains$3([
          'td',
          'th',
          'table'
        ], name.toLowerCase());
      });
      do {
        if (isText$7(node) && Tools.trim(node.nodeValue).length !== 0) {
          if (start) {
            rng.setStart(node, 0);
          } else {
            rng.setEnd(node, node.nodeValue.length);
          }
          return;
        }
        if (moveCaretBeforeOnEnterElementsMap[node.nodeName]) {
          if (start) {
            rng.setStartBefore(node);
          } else {
            if (node.nodeName === 'BR') {
              rng.setEndBefore(node);
            } else {
              rng.setEndAfter(node);
            }
          }
          return;
        }
      } while (node = start ? walker.next() : walker.prev());
      if (root.nodeName === 'BODY') {
        if (start) {
          rng.setStart(root, 0);
        } else {
          rng.setEnd(root, root.childNodes.length);
        }
      }
    };
    var hasAnyRanges = function (editor) {
      var sel = editor.selection.getSel();
      return sel && sel.rangeCount > 0;
    };
    var runOnRanges = function (editor, executor) {
      var fakeSelectionNodes = getCellsFromEditor(editor);
      if (fakeSelectionNodes.length > 0) {
        each$k(fakeSelectionNodes, function (elem) {
          var node = elem.dom;
          var fakeNodeRng = editor.dom.createRng();
          fakeNodeRng.setStartBefore(node);
          fakeNodeRng.setEndAfter(node);
          executor(fakeNodeRng, true);
        });
      } else {
        executor(editor.selection.getRng(), false);
      }
    };
    var preserve = function (selection, fillBookmark, executor) {
      var bookmark = getPersistentBookmark(selection, fillBookmark);
      executor(bookmark);
      selection.moveToBookmark(bookmark);
    };

    var NodeValue = function (is, name) {
      var get = function (element) {
        if (!is(element)) {
          throw new Error('Can only get ' + name + ' value of a ' + name + ' node');
        }
        return getOption(element).getOr('');
      };
      var getOption = function (element) {
        return is(element) ? Optional.from(element.dom.nodeValue) : Optional.none();
      };
      var set = function (element, value) {
        if (!is(element)) {
          throw new Error('Can only set raw ' + name + ' value of a ' + name + ' node');
        }
        element.dom.nodeValue = value;
      };
      return {
        get: get,
        getOption: getOption,
        set: set
      };
    };

    var api$1 = NodeValue(isText$8, 'text');
    var get$2 = function (element) {
      return api$1.get(element);
    };

    var isZeroWidth = function (elem) {
      return isText$8(elem) && get$2(elem) === ZWSP$1;
    };
    var context = function (editor, elem, wrapName, nodeName) {
      return parent(elem).fold(function () {
        return 'skipping';
      }, function (parent) {
        if (nodeName === 'br' || isZeroWidth(elem)) {
          return 'valid';
        } else if (isAnnotation(elem)) {
          return 'existing';
        } else if (isCaretNode(elem.dom)) {
          return 'caret';
        } else if (!isValid(editor, wrapName, nodeName) || !isValid(editor, name(parent), wrapName)) {
          return 'invalid-child';
        } else {
          return 'valid';
        }
      });
    };

    var applyWordGrab = function (editor, rng) {
      var r = expandRng(editor, rng, [{ inline: 'span' }]);
      rng.setStart(r.startContainer, r.startOffset);
      rng.setEnd(r.endContainer, r.endOffset);
      editor.selection.setRng(rng);
    };
    var makeAnnotation = function (eDoc, _a, annotationName, decorate) {
      var _b = _a.uid, uid = _b === void 0 ? generate('mce-annotation') : _b, data = __rest(_a, ['uid']);
      var master = SugarElement.fromTag('span', eDoc);
      add$1(master, annotation());
      set$1(master, '' + dataAnnotationId(), uid);
      set$1(master, '' + dataAnnotation(), annotationName);
      var _c = decorate(uid, data), _d = _c.attributes, attributes = _d === void 0 ? {} : _d, _e = _c.classes, classes = _e === void 0 ? [] : _e;
      setAll$1(master, attributes);
      add(master, classes);
      return master;
    };
    var annotate = function (editor, rng, annotationName, decorate, data) {
      var newWrappers = [];
      var master = makeAnnotation(editor.getDoc(), data, annotationName, decorate);
      var wrapper = value();
      var finishWrapper = function () {
        wrapper.clear();
      };
      var getOrOpenWrapper = function () {
        return wrapper.get().getOrThunk(function () {
          var nu = shallow(master);
          newWrappers.push(nu);
          wrapper.set(nu);
          return nu;
        });
      };
      var processElements = function (elems) {
        each$k(elems, processElement);
      };
      var processElement = function (elem) {
        var ctx = context(editor, elem, 'span', name(elem));
        switch (ctx) {
        case 'invalid-child': {
            finishWrapper();
            var children$1 = children(elem);
            processElements(children$1);
            finishWrapper();
            break;
          }
        case 'valid': {
            var w = getOrOpenWrapper();
            wrap$3(elem, w);
            break;
          }
        }
      };
      var processNodes = function (nodes) {
        var elems = map$3(nodes, SugarElement.fromDom);
        processElements(elems);
      };
      walk$2(editor.dom, rng, function (nodes) {
        finishWrapper();
        processNodes(nodes);
      });
      return newWrappers;
    };
    var annotateWithBookmark = function (editor, name, settings, data) {
      editor.undoManager.transact(function () {
        var selection = editor.selection;
        var initialRng = selection.getRng();
        var hasFakeSelection = getCellsFromEditor(editor).length > 0;
        if (initialRng.collapsed && !hasFakeSelection) {
          applyWordGrab(editor, initialRng);
        }
        if (selection.getRng().collapsed && !hasFakeSelection) {
          var wrapper = makeAnnotation(editor.getDoc(), data, name, settings.decorate);
          set(wrapper, nbsp);
          selection.getRng().insertNode(wrapper.dom);
          selection.select(wrapper.dom);
        } else {
          preserve(selection, false, function () {
            runOnRanges(editor, function (selectionRng) {
              annotate(editor, selectionRng, name, settings.decorate, data);
            });
          });
        }
      });
    };

    var Annotator = function (editor) {
      var registry = create$7();
      setup$m(editor, registry);
      var changes = setup$n(editor);
      return {
        register: function (name, settings) {
          registry.register(name, settings);
        },
        annotate: function (name, data) {
          registry.lookup(name).each(function (settings) {
            annotateWithBookmark(editor, name, settings, data);
          });
        },
        annotationChanged: function (name, callback) {
          changes.addListener(name, callback);
        },
        remove: function (name) {
          identify(editor, Optional.some(name)).each(function (_a) {
            var elements = _a.elements;
            each$k(elements, unwrap);
          });
        },
        getAll: function (name) {
          var directory = findAll(editor, name);
          return map$2(directory, function (elems) {
            return map$3(elems, function (elem) {
              return elem.dom;
            });
          });
        }
      };
    };

    var BookmarkManager = function (selection) {
      return {
        getBookmark: curry(getBookmark$1, selection),
        moveToBookmark: curry(moveToBookmark, selection)
      };
    };
    BookmarkManager.isBookmarkNode = isBookmarkNode$1;

    var getContentEditableRoot$1 = function (root, node) {
      while (node && node !== root) {
        if (isContentEditableTrue$4(node) || isContentEditableFalse$b(node)) {
          return node;
        }
        node = node.parentNode;
      }
      return null;
    };

    var isXYWithinRange = function (clientX, clientY, range) {
      if (range.collapsed) {
        return false;
      }
      if (Env.browser.isIE() && range.startOffset === range.endOffset - 1 && range.startContainer === range.endContainer) {
        var elm = range.startContainer.childNodes[range.startOffset];
        if (isElement$5(elm)) {
          return exists(elm.getClientRects(), function (rect) {
            return containsXY(rect, clientX, clientY);
          });
        }
      }
      return exists(range.getClientRects(), function (rect) {
        return containsXY(rect, clientX, clientY);
      });
    };

    var firePreProcess = function (editor, args) {
      return editor.fire('PreProcess', args);
    };
    var firePostProcess = function (editor, args) {
      return editor.fire('PostProcess', args);
    };
    var fireRemove = function (editor) {
      return editor.fire('remove');
    };
    var fireDetach = function (editor) {
      return editor.fire('detach');
    };
    var fireSwitchMode = function (editor, mode) {
      return editor.fire('SwitchMode', { mode: mode });
    };
    var fireObjectResizeStart = function (editor, target, width, height, origin) {
      editor.fire('ObjectResizeStart', {
        target: target,
        width: width,
        height: height,
        origin: origin
      });
    };
    var fireObjectResized = function (editor, target, width, height, origin) {
      editor.fire('ObjectResized', {
        target: target,
        width: width,
        height: height,
        origin: origin
      });
    };
    var firePreInit = function (editor) {
      return editor.fire('PreInit');
    };
    var firePostRender = function (editor) {
      return editor.fire('PostRender');
    };
    var fireInit = function (editor) {
      return editor.fire('Init');
    };
    var firePlaceholderToggle = function (editor, state) {
      return editor.fire('PlaceholderToggle', { state: state });
    };
    var fireError = function (editor, errorType, error) {
      return editor.fire(errorType, error);
    };
    var fireFormatApply = function (editor, format, node, vars) {
      return editor.fire('FormatApply', {
        format: format,
        node: node,
        vars: vars
      });
    };
    var fireFormatRemove = function (editor, format, node, vars) {
      return editor.fire('FormatRemove', {
        format: format,
        node: node,
        vars: vars
      });
    };

    var VK = {
      BACKSPACE: 8,
      DELETE: 46,
      DOWN: 40,
      ENTER: 13,
      ESC: 27,
      LEFT: 37,
      RIGHT: 39,
      SPACEBAR: 32,
      TAB: 9,
      UP: 38,
      PAGE_UP: 33,
      PAGE_DOWN: 34,
      END: 35,
      HOME: 36,
      modifierPressed: function (e) {
        return e.shiftKey || e.ctrlKey || e.altKey || VK.metaKeyPressed(e);
      },
      metaKeyPressed: function (e) {
        return Env.mac ? e.metaKey : e.ctrlKey && !e.altKey;
      }
    };

    var isContentEditableFalse$5 = isContentEditableFalse$b;
    var ControlSelection = function (selection, editor) {
      var elementSelectionAttr = 'data-mce-selected';
      var dom = editor.dom, each = Tools.each;
      var selectedElm, selectedElmGhost, resizeHelper, selectedHandle, resizeBackdrop;
      var startX, startY, selectedElmX, selectedElmY, startW, startH, ratio, resizeStarted;
      var width, height;
      var editableDoc = editor.getDoc(), rootDocument = document;
      var abs = Math.abs, round = Math.round, rootElement = editor.getBody();
      var startScrollWidth, startScrollHeight;
      var resizeHandles = {
        nw: [
          0,
          0,
          -1,
          -1
        ],
        ne: [
          1,
          0,
          1,
          -1
        ],
        se: [
          1,
          1,
          1,
          1
        ],
        sw: [
          0,
          1,
          -1,
          1
        ]
      };
      var isImage = function (elm) {
        return elm && (elm.nodeName === 'IMG' || editor.dom.is(elm, 'figure.image'));
      };
      var isMedia = function (elm) {
        return isMedia$2(elm) || dom.hasClass(elm, 'mce-preview-object');
      };
      var isEventOnImageOutsideRange = function (evt, range) {
        if (evt.type === 'longpress' || evt.type.indexOf('touch') === 0) {
          var touch = evt.touches[0];
          return isImage(evt.target) && !isXYWithinRange(touch.clientX, touch.clientY, range);
        } else {
          return isImage(evt.target) && !isXYWithinRange(evt.clientX, evt.clientY, range);
        }
      };
      var contextMenuSelectImage = function (evt) {
        var target = evt.target;
        if (isEventOnImageOutsideRange(evt, editor.selection.getRng()) && !evt.isDefaultPrevented()) {
          editor.selection.select(target);
        }
      };
      var getResizeTargets = function (elm) {
        if (dom.is(elm, 'figure.image')) {
          return [elm.querySelector('img')];
        } else if (dom.hasClass(elm, 'mce-preview-object') && isNonNullable(elm.firstElementChild)) {
          return [
            elm,
            elm.firstElementChild
          ];
        } else {
          return [elm];
        }
      };
      var isResizable = function (elm) {
        var selector = getObjectResizing(editor);
        if (!selector) {
          return false;
        }
        if (elm.getAttribute('data-mce-resize') === 'false') {
          return false;
        }
        if (elm === editor.getBody()) {
          return false;
        }
        if (dom.hasClass(elm, 'mce-preview-object')) {
          return is$2(SugarElement.fromDom(elm.firstElementChild), selector);
        } else {
          return is$2(SugarElement.fromDom(elm), selector);
        }
      };
      var createGhostElement = function (elm) {
        if (isMedia(elm)) {
          return dom.create('img', { src: Env.transparentSrc });
        } else {
          return elm.cloneNode(true);
        }
      };
      var setSizeProp = function (element, name, value) {
        if (isNonNullable(value)) {
          var targets = getResizeTargets(element);
          each$k(targets, function (target) {
            if (target.style[name] || !editor.schema.isValid(target.nodeName.toLowerCase(), name)) {
              dom.setStyle(target, name, value);
            } else {
              dom.setAttrib(target, name, '' + value);
            }
          });
        }
      };
      var setGhostElmSize = function (ghostElm, width, height) {
        setSizeProp(ghostElm, 'width', width);
        setSizeProp(ghostElm, 'height', height);
      };
      var resizeGhostElement = function (e) {
        var deltaX, deltaY, proportional;
        var resizeHelperX, resizeHelperY;
        deltaX = e.screenX - startX;
        deltaY = e.screenY - startY;
        width = deltaX * selectedHandle[2] + startW;
        height = deltaY * selectedHandle[3] + startH;
        width = width < 5 ? 5 : width;
        height = height < 5 ? 5 : height;
        if ((isImage(selectedElm) || isMedia(selectedElm)) && getResizeImgProportional(editor) !== false) {
          proportional = !VK.modifierPressed(e);
        } else {
          proportional = VK.modifierPressed(e);
        }
        if (proportional) {
          if (abs(deltaX) > abs(deltaY)) {
            height = round(width * ratio);
            width = round(height / ratio);
          } else {
            width = round(height / ratio);
            height = round(width * ratio);
          }
        }
        setGhostElmSize(selectedElmGhost, width, height);
        resizeHelperX = selectedHandle.startPos.x + deltaX;
        resizeHelperY = selectedHandle.startPos.y + deltaY;
        resizeHelperX = resizeHelperX > 0 ? resizeHelperX : 0;
        resizeHelperY = resizeHelperY > 0 ? resizeHelperY : 0;
        dom.setStyles(resizeHelper, {
          left: resizeHelperX,
          top: resizeHelperY,
          display: 'block'
        });
        resizeHelper.innerHTML = width + ' &times; ' + height;
        if (selectedHandle[2] < 0 && selectedElmGhost.clientWidth <= width) {
          dom.setStyle(selectedElmGhost, 'left', selectedElmX + (startW - width));
        }
        if (selectedHandle[3] < 0 && selectedElmGhost.clientHeight <= height) {
          dom.setStyle(selectedElmGhost, 'top', selectedElmY + (startH - height));
        }
        deltaX = rootElement.scrollWidth - startScrollWidth;
        deltaY = rootElement.scrollHeight - startScrollHeight;
        if (deltaX + deltaY !== 0) {
          dom.setStyles(resizeHelper, {
            left: resizeHelperX - deltaX,
            top: resizeHelperY - deltaY
          });
        }
        if (!resizeStarted) {
          fireObjectResizeStart(editor, selectedElm, startW, startH, 'corner-' + selectedHandle.name);
          resizeStarted = true;
        }
      };
      var endGhostResize = function () {
        var wasResizeStarted = resizeStarted;
        resizeStarted = false;
        if (wasResizeStarted) {
          setSizeProp(selectedElm, 'width', width);
          setSizeProp(selectedElm, 'height', height);
        }
        dom.unbind(editableDoc, 'mousemove', resizeGhostElement);
        dom.unbind(editableDoc, 'mouseup', endGhostResize);
        if (rootDocument !== editableDoc) {
          dom.unbind(rootDocument, 'mousemove', resizeGhostElement);
          dom.unbind(rootDocument, 'mouseup', endGhostResize);
        }
        dom.remove(selectedElmGhost);
        dom.remove(resizeHelper);
        dom.remove(resizeBackdrop);
        showResizeRect(selectedElm);
        if (wasResizeStarted) {
          fireObjectResized(editor, selectedElm, width, height, 'corner-' + selectedHandle.name);
          dom.setAttrib(selectedElm, 'style', dom.getAttrib(selectedElm, 'style'));
        }
        editor.nodeChanged();
      };
      var showResizeRect = function (targetElm) {
        unbindResizeHandleEvents();
        var position = dom.getPos(targetElm, rootElement);
        var selectedElmX = position.x;
        var selectedElmY = position.y;
        var rect = targetElm.getBoundingClientRect();
        var targetWidth = rect.width || rect.right - rect.left;
        var targetHeight = rect.height || rect.bottom - rect.top;
        if (selectedElm !== targetElm) {
          hideResizeRect();
          selectedElm = targetElm;
          width = height = 0;
        }
        var e = editor.fire('ObjectSelected', { target: targetElm });
        var selectedValue = dom.getAttrib(selectedElm, elementSelectionAttr, '1');
        if (isResizable(targetElm) && !e.isDefaultPrevented()) {
          each(resizeHandles, function (handle, name) {
            var handleElm;
            var startDrag = function (e) {
              var target = getResizeTargets(selectedElm)[0];
              startX = e.screenX;
              startY = e.screenY;
              startW = target.clientWidth;
              startH = target.clientHeight;
              ratio = startH / startW;
              selectedHandle = handle;
              selectedHandle.name = name;
              selectedHandle.startPos = {
                x: targetWidth * handle[0] + selectedElmX,
                y: targetHeight * handle[1] + selectedElmY
              };
              startScrollWidth = rootElement.scrollWidth;
              startScrollHeight = rootElement.scrollHeight;
              resizeBackdrop = dom.add(rootElement, 'div', {
                'class': 'mce-resize-backdrop',
                'data-mce-bogus': 'all'
              });
              dom.setStyles(resizeBackdrop, {
                position: 'fixed',
                left: '0',
                top: '0',
                width: '100%',
                height: '100%'
              });
              selectedElmGhost = createGhostElement(selectedElm);
              dom.addClass(selectedElmGhost, 'mce-clonedresizable');
              dom.setAttrib(selectedElmGhost, 'data-mce-bogus', 'all');
              selectedElmGhost.contentEditable = 'false';
              dom.setStyles(selectedElmGhost, {
                left: selectedElmX,
                top: selectedElmY,
                margin: 0
              });
              setGhostElmSize(selectedElmGhost, targetWidth, targetHeight);
              selectedElmGhost.removeAttribute(elementSelectionAttr);
              rootElement.appendChild(selectedElmGhost);
              dom.bind(editableDoc, 'mousemove', resizeGhostElement);
              dom.bind(editableDoc, 'mouseup', endGhostResize);
              if (rootDocument !== editableDoc) {
                dom.bind(rootDocument, 'mousemove', resizeGhostElement);
                dom.bind(rootDocument, 'mouseup', endGhostResize);
              }
              resizeHelper = dom.add(rootElement, 'div', {
                'class': 'mce-resize-helper',
                'data-mce-bogus': 'all'
              }, startW + ' &times; ' + startH);
            };
            handleElm = dom.get('mceResizeHandle' + name);
            if (handleElm) {
              dom.remove(handleElm);
            }
            handleElm = dom.add(rootElement, 'div', {
              'id': 'mceResizeHandle' + name,
              'data-mce-bogus': 'all',
              'class': 'mce-resizehandle',
              'unselectable': true,
              'style': 'cursor:' + name + '-resize; margin:0; padding:0'
            });
            if (Env.ie === 11) {
              handleElm.contentEditable = false;
            }
            dom.bind(handleElm, 'mousedown', function (e) {
              e.stopImmediatePropagation();
              e.preventDefault();
              startDrag(e);
            });
            handle.elm = handleElm;
            dom.setStyles(handleElm, {
              left: targetWidth * handle[0] + selectedElmX - handleElm.offsetWidth / 2,
              top: targetHeight * handle[1] + selectedElmY - handleElm.offsetHeight / 2
            });
          });
        } else {
          hideResizeRect();
        }
        if (!dom.getAttrib(selectedElm, elementSelectionAttr)) {
          selectedElm.setAttribute(elementSelectionAttr, selectedValue);
        }
      };
      var hideResizeRect = function () {
        unbindResizeHandleEvents();
        if (selectedElm) {
          selectedElm.removeAttribute(elementSelectionAttr);
        }
        each$j(resizeHandles, function (value, name) {
          var handleElm = dom.get('mceResizeHandle' + name);
          if (handleElm) {
            dom.unbind(handleElm);
            dom.remove(handleElm);
          }
        });
      };
      var updateResizeRect = function (e) {
        var startElm, controlElm;
        var isChildOrEqual = function (node, parent) {
          if (node) {
            do {
              if (node === parent) {
                return true;
              }
            } while (node = node.parentNode);
          }
        };
        if (resizeStarted || editor.removed) {
          return;
        }
        each(dom.select('img[data-mce-selected],hr[data-mce-selected]'), function (img) {
          img.removeAttribute(elementSelectionAttr);
        });
        controlElm = e.type === 'mousedown' ? e.target : selection.getNode();
        controlElm = dom.$(controlElm).closest('table,img,figure.image,hr,video,span.mce-preview-object')[0];
        if (isChildOrEqual(controlElm, rootElement)) {
          disableGeckoResize();
          startElm = selection.getStart(true);
          if (isChildOrEqual(startElm, controlElm) && isChildOrEqual(selection.getEnd(true), controlElm)) {
            showResizeRect(controlElm);
            return;
          }
        }
        hideResizeRect();
      };
      var isWithinContentEditableFalse = function (elm) {
        return isContentEditableFalse$5(getContentEditableRoot$1(editor.getBody(), elm));
      };
      var unbindResizeHandleEvents = function () {
        each$j(resizeHandles, function (handle) {
          if (handle.elm) {
            dom.unbind(handle.elm);
            delete handle.elm;
          }
        });
      };
      var disableGeckoResize = function () {
        try {
          editor.getDoc().execCommand('enableObjectResizing', false, 'false');
        } catch (ex) {
        }
      };
      editor.on('init', function () {
        disableGeckoResize();
        if (Env.browser.isIE() || Env.browser.isEdge()) {
          editor.on('mousedown click', function (e) {
            var target = e.target, nodeName = target.nodeName;
            if (!resizeStarted && /^(TABLE|IMG|HR)$/.test(nodeName) && !isWithinContentEditableFalse(target)) {
              if (e.button !== 2) {
                editor.selection.select(target, nodeName === 'TABLE');
              }
              if (e.type === 'mousedown') {
                editor.nodeChanged();
              }
            }
          });
          var handleMSControlSelect_1 = function (e) {
            var delayedSelect = function (node) {
              Delay.setEditorTimeout(editor, function () {
                return editor.selection.select(node);
              });
            };
            if (isWithinContentEditableFalse(e.target) || isMedia$2(e.target)) {
              e.preventDefault();
              delayedSelect(e.target);
              return;
            }
            if (/^(TABLE|IMG|HR)$/.test(e.target.nodeName)) {
              e.preventDefault();
              if (e.target.tagName === 'IMG') {
                delayedSelect(e.target);
              }
            }
          };
          dom.bind(rootElement, 'mscontrolselect', handleMSControlSelect_1);
          editor.on('remove', function () {
            return dom.unbind(rootElement, 'mscontrolselect', handleMSControlSelect_1);
          });
        }
        var throttledUpdateResizeRect = Delay.throttle(function (e) {
          if (!editor.composing) {
            updateResizeRect(e);
          }
        });
        editor.on('nodechange ResizeEditor ResizeWindow ResizeContent drop FullscreenStateChanged', throttledUpdateResizeRect);
        editor.on('keyup compositionend', function (e) {
          if (selectedElm && selectedElm.nodeName === 'TABLE') {
            throttledUpdateResizeRect(e);
          }
        });
        editor.on('hide blur', hideResizeRect);
        editor.on('contextmenu longpress', contextMenuSelectImage, true);
      });
      editor.on('remove', unbindResizeHandleEvents);
      var destroy = function () {
        selectedElm = selectedElmGhost = resizeBackdrop = null;
      };
      return {
        isResizable: isResizable,
        showResizeRect: showResizeRect,
        hideResizeRect: hideResizeRect,
        updateResizeRect: updateResizeRect,
        destroy: destroy
      };
    };

    var hasCeProperty = function (node) {
      return isContentEditableTrue$4(node) || isContentEditableFalse$b(node);
    };
    var findParent$1 = function (node, rootNode, predicate) {
      while (node && node !== rootNode) {
        if (predicate(node)) {
          return node;
        }
        node = node.parentNode;
      }
      return null;
    };
    var findClosestIeRange = function (clientX, clientY, doc) {
      var rects;
      var element = doc.elementFromPoint(clientX, clientY);
      var rng = doc.body.createTextRange();
      if (!element || element.tagName === 'HTML') {
        element = doc.body;
      }
      rng.moveToElementText(element);
      rects = Tools.toArray(rng.getClientRects());
      rects = rects.sort(function (a, b) {
        a = Math.abs(Math.max(a.top - clientY, a.bottom - clientY));
        b = Math.abs(Math.max(b.top - clientY, b.bottom - clientY));
        return a - b;
      });
      if (rects.length > 0) {
        clientY = (rects[0].bottom + rects[0].top) / 2;
        try {
          rng.moveToPoint(clientX, clientY);
          rng.collapse(true);
          return rng;
        } catch (ex) {
        }
      }
      return null;
    };
    var moveOutOfContentEditableFalse = function (rng, rootNode) {
      var parentElement = rng && rng.parentElement ? rng.parentElement() : null;
      return isContentEditableFalse$b(findParent$1(parentElement, rootNode, hasCeProperty)) ? null : rng;
    };
    var fromPoint = function (clientX, clientY, doc) {
      var rng, point;
      var pointDoc = doc;
      if (pointDoc.caretPositionFromPoint) {
        point = pointDoc.caretPositionFromPoint(clientX, clientY);
        if (point) {
          rng = doc.createRange();
          rng.setStart(point.offsetNode, point.offset);
          rng.collapse(true);
        }
      } else if (pointDoc.caretRangeFromPoint) {
        rng = pointDoc.caretRangeFromPoint(clientX, clientY);
      } else if (pointDoc.body.createTextRange) {
        rng = pointDoc.body.createTextRange();
        try {
          rng.moveToPoint(clientX, clientY);
          rng.collapse(true);
        } catch (ex) {
          rng = findClosestIeRange(clientX, clientY, doc);
        }
        return moveOutOfContentEditableFalse(rng, doc.body);
      }
      return rng;
    };

    var isEq$4 = function (rng1, rng2) {
      return rng1 && rng2 && (rng1.startContainer === rng2.startContainer && rng1.startOffset === rng2.startOffset) && (rng1.endContainer === rng2.endContainer && rng1.endOffset === rng2.endOffset);
    };

    var findParent = function (node, rootNode, predicate) {
      while (node && node !== rootNode) {
        if (predicate(node)) {
          return node;
        }
        node = node.parentNode;
      }
      return null;
    };
    var hasParent$1 = function (node, rootNode, predicate) {
      return findParent(node, rootNode, predicate) !== null;
    };
    var hasParentWithName = function (node, rootNode, name) {
      return hasParent$1(node, rootNode, function (node) {
        return node.nodeName === name;
      });
    };
    var isTable = function (node) {
      return node && node.nodeName === 'TABLE';
    };
    var isTableCell$2 = function (node) {
      return node && /^(TD|TH|CAPTION)$/.test(node.nodeName);
    };
    var isCeFalseCaretContainer = function (node, rootNode) {
      return isCaretContainer$2(node) && hasParent$1(node, rootNode, isCaretNode) === false;
    };
    var hasBrBeforeAfter = function (dom, node, left) {
      var walker = new DomTreeWalker(node, dom.getParent(node.parentNode, dom.isBlock) || dom.getRoot());
      while (node = walker[left ? 'prev' : 'next']()) {
        if (isBr$5(node)) {
          return true;
        }
      }
    };
    var isPrevNode = function (node, name) {
      return node.previousSibling && node.previousSibling.nodeName === name;
    };
    var hasContentEditableFalseParent = function (body, node) {
      while (node && node !== body) {
        if (isContentEditableFalse$b(node)) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };
    var findTextNodeRelative = function (dom, isAfterNode, collapsed, left, startNode) {
      var lastInlineElement;
      var body = dom.getRoot();
      var node;
      var nonEmptyElementsMap = dom.schema.getNonEmptyElements();
      var parentBlockContainer = dom.getParent(startNode.parentNode, dom.isBlock) || body;
      if (left && isBr$5(startNode) && isAfterNode && dom.isEmpty(parentBlockContainer)) {
        return Optional.some(CaretPosition(startNode.parentNode, dom.nodeIndex(startNode)));
      }
      var walker = new DomTreeWalker(startNode, parentBlockContainer);
      while (node = walker[left ? 'prev' : 'next']()) {
        if (dom.getContentEditableParent(node) === 'false' || isCeFalseCaretContainer(node, body)) {
          return Optional.none();
        }
        if (isText$7(node) && node.nodeValue.length > 0) {
          if (hasParentWithName(node, body, 'A') === false) {
            return Optional.some(CaretPosition(node, left ? node.nodeValue.length : 0));
          }
          return Optional.none();
        }
        if (dom.isBlock(node) || nonEmptyElementsMap[node.nodeName.toLowerCase()]) {
          return Optional.none();
        }
        lastInlineElement = node;
      }
      if (collapsed && lastInlineElement) {
        return Optional.some(CaretPosition(lastInlineElement, 0));
      }
      return Optional.none();
    };
    var normalizeEndPoint = function (dom, collapsed, start, rng) {
      var container, offset;
      var body = dom.getRoot();
      var node;
      var directionLeft, normalized = false;
      container = rng[(start ? 'start' : 'end') + 'Container'];
      offset = rng[(start ? 'start' : 'end') + 'Offset'];
      var isAfterNode = isElement$5(container) && offset === container.childNodes.length;
      var nonEmptyElementsMap = dom.schema.getNonEmptyElements();
      directionLeft = start;
      if (isCaretContainer$2(container)) {
        return Optional.none();
      }
      if (isElement$5(container) && offset > container.childNodes.length - 1) {
        directionLeft = false;
      }
      if (isDocument$1(container)) {
        container = body;
        offset = 0;
      }
      if (container === body) {
        if (directionLeft) {
          node = container.childNodes[offset > 0 ? offset - 1 : 0];
          if (node) {
            if (isCaretContainer$2(node)) {
              return Optional.none();
            }
            if (nonEmptyElementsMap[node.nodeName] || isTable(node)) {
              return Optional.none();
            }
          }
        }
        if (container.hasChildNodes()) {
          offset = Math.min(!directionLeft && offset > 0 ? offset - 1 : offset, container.childNodes.length - 1);
          container = container.childNodes[offset];
          offset = isText$7(container) && isAfterNode ? container.data.length : 0;
          if (!collapsed && container === body.lastChild && isTable(container)) {
            return Optional.none();
          }
          if (hasContentEditableFalseParent(body, container) || isCaretContainer$2(container)) {
            return Optional.none();
          }
          if (container.hasChildNodes() && isTable(container) === false) {
            node = container;
            var walker = new DomTreeWalker(container, body);
            do {
              if (isContentEditableFalse$b(node) || isCaretContainer$2(node)) {
                normalized = false;
                break;
              }
              if (isText$7(node) && node.nodeValue.length > 0) {
                offset = directionLeft ? 0 : node.nodeValue.length;
                container = node;
                normalized = true;
                break;
              }
              if (nonEmptyElementsMap[node.nodeName.toLowerCase()] && !isTableCell$2(node)) {
                offset = dom.nodeIndex(node);
                container = node.parentNode;
                if (!directionLeft) {
                  offset++;
                }
                normalized = true;
                break;
              }
            } while (node = directionLeft ? walker.next() : walker.prev());
          }
        }
      }
      if (collapsed) {
        if (isText$7(container) && offset === 0) {
          findTextNodeRelative(dom, isAfterNode, collapsed, true, container).each(function (pos) {
            container = pos.container();
            offset = pos.offset();
            normalized = true;
          });
        }
        if (isElement$5(container)) {
          node = container.childNodes[offset];
          if (!node) {
            node = container.childNodes[offset - 1];
          }
          if (node && isBr$5(node) && !isPrevNode(node, 'A') && !hasBrBeforeAfter(dom, node, false) && !hasBrBeforeAfter(dom, node, true)) {
            findTextNodeRelative(dom, isAfterNode, collapsed, true, node).each(function (pos) {
              container = pos.container();
              offset = pos.offset();
              normalized = true;
            });
          }
        }
      }
      if (directionLeft && !collapsed && isText$7(container) && offset === container.nodeValue.length) {
        findTextNodeRelative(dom, isAfterNode, collapsed, false, container).each(function (pos) {
          container = pos.container();
          offset = pos.offset();
          normalized = true;
        });
      }
      return normalized ? Optional.some(CaretPosition(container, offset)) : Optional.none();
    };
    var normalize$2 = function (dom, rng) {
      var collapsed = rng.collapsed, normRng = rng.cloneRange();
      var startPos = CaretPosition.fromRangeStart(rng);
      normalizeEndPoint(dom, collapsed, true, normRng).each(function (pos) {
        if (!collapsed || !CaretPosition.isAbove(startPos, pos)) {
          normRng.setStart(pos.container(), pos.offset());
        }
      });
      if (!collapsed) {
        normalizeEndPoint(dom, collapsed, false, normRng).each(function (pos) {
          normRng.setEnd(pos.container(), pos.offset());
        });
      }
      if (collapsed) {
        normRng.collapse(true);
      }
      return isEq$4(rng, normRng) ? Optional.none() : Optional.some(normRng);
    };

    var splitText = function (node, offset) {
      return node.splitText(offset);
    };
    var split = function (rng) {
      var startContainer = rng.startContainer, startOffset = rng.startOffset, endContainer = rng.endContainer, endOffset = rng.endOffset;
      if (startContainer === endContainer && isText$7(startContainer)) {
        if (startOffset > 0 && startOffset < startContainer.nodeValue.length) {
          endContainer = splitText(startContainer, startOffset);
          startContainer = endContainer.previousSibling;
          if (endOffset > startOffset) {
            endOffset = endOffset - startOffset;
            startContainer = endContainer = splitText(endContainer, endOffset).previousSibling;
            endOffset = endContainer.nodeValue.length;
            startOffset = 0;
          } else {
            endOffset = 0;
          }
        }
      } else {
        if (isText$7(startContainer) && startOffset > 0 && startOffset < startContainer.nodeValue.length) {
          startContainer = splitText(startContainer, startOffset);
          startOffset = 0;
        }
        if (isText$7(endContainer) && endOffset > 0 && endOffset < endContainer.nodeValue.length) {
          endContainer = splitText(endContainer, endOffset).previousSibling;
          endOffset = endContainer.nodeValue.length;
        }
      }
      return {
        startContainer: startContainer,
        startOffset: startOffset,
        endContainer: endContainer,
        endOffset: endOffset
      };
    };

    var RangeUtils = function (dom) {
      var walk = function (rng, callback) {
        return walk$2(dom, rng, callback);
      };
      var split$1 = split;
      var normalize = function (rng) {
        return normalize$2(dom, rng).fold(never, function (normalizedRng) {
          rng.setStart(normalizedRng.startContainer, normalizedRng.startOffset);
          rng.setEnd(normalizedRng.endContainer, normalizedRng.endOffset);
          return true;
        });
      };
      return {
        walk: walk,
        split: split$1,
        normalize: normalize
      };
    };
    RangeUtils.compareRanges = isEq$4;
    RangeUtils.getCaretRangeFromPoint = fromPoint;
    RangeUtils.getSelectedNode = getSelectedNode;
    RangeUtils.getNode = getNode$1;

    var Dimension = function (name, getOffset) {
      var set = function (element, h) {
        if (!isNumber(h) && !h.match(/^[0-9]+$/)) {
          throw new Error(name + '.set accepts only positive integer values. Value was ' + h);
        }
        var dom = element.dom;
        if (isSupported(dom)) {
          dom.style[name] = h + 'px';
        }
      };
      var get = function (element) {
        var r = getOffset(element);
        if (r <= 0 || r === null) {
          var css = get$5(element, name);
          return parseFloat(css) || 0;
        }
        return r;
      };
      var getOuter = get;
      var aggregate = function (element, properties) {
        return foldl(properties, function (acc, property) {
          var val = get$5(element, property);
          var value = val === undefined ? 0 : parseInt(val, 10);
          return isNaN(value) ? acc : acc + value;
        }, 0);
      };
      var max = function (element, value, properties) {
        var cumulativeInclusions = aggregate(element, properties);
        var absoluteMax = value > cumulativeInclusions ? value - cumulativeInclusions : 0;
        return absoluteMax;
      };
      return {
        set: set,
        get: get,
        getOuter: getOuter,
        aggregate: aggregate,
        max: max
      };
    };

    var api = Dimension('height', function (element) {
      var dom = element.dom;
      return inBody(element) ? dom.getBoundingClientRect().height : dom.offsetHeight;
    });
    var get$1 = function (element) {
      return api.get(element);
    };

    var walkUp = function (navigation, doc) {
      var frame = navigation.view(doc);
      return frame.fold(constant([]), function (f) {
        var parent = navigation.owner(f);
        var rest = walkUp(navigation, parent);
        return [f].concat(rest);
      });
    };
    var pathTo = function (element, navigation) {
      var d = navigation.owner(element);
      return walkUp(navigation, d);
    };

    var view = function (doc) {
      var _a;
      var element = doc.dom === document ? Optional.none() : Optional.from((_a = doc.dom.defaultView) === null || _a === void 0 ? void 0 : _a.frameElement);
      return element.map(SugarElement.fromDom);
    };
    var owner = function (element) {
      return documentOrOwner(element);
    };

    var Navigation = /*#__PURE__*/Object.freeze({
        __proto__: null,
        view: view,
        owner: owner
    });

    var find$1 = function (element) {
      var doc = SugarElement.fromDom(document);
      var scroll = get$8(doc);
      var frames = pathTo(element, Navigation);
      var offset = viewport(element);
      var r = foldr(frames, function (b, a) {
        var loc = viewport(a);
        return {
          left: b.left + loc.left,
          top: b.top + loc.top
        };
      }, {
        left: 0,
        top: 0
      });
      return SugarPosition(r.left + offset.left + scroll.left, r.top + offset.top + scroll.top);
    };

    var excludeFromDescend = function (element) {
      return name(element) === 'textarea';
    };
    var fireScrollIntoViewEvent = function (editor, data) {
      var scrollEvent = editor.fire('ScrollIntoView', data);
      return scrollEvent.isDefaultPrevented();
    };
    var fireAfterScrollIntoViewEvent = function (editor, data) {
      editor.fire('AfterScrollIntoView', data);
    };
    var descend = function (element, offset) {
      var children$1 = children(element);
      if (children$1.length === 0 || excludeFromDescend(element)) {
        return {
          element: element,
          offset: offset
        };
      } else if (offset < children$1.length && !excludeFromDescend(children$1[offset])) {
        return {
          element: children$1[offset],
          offset: 0
        };
      } else {
        var last = children$1[children$1.length - 1];
        if (excludeFromDescend(last)) {
          return {
            element: element,
            offset: offset
          };
        } else {
          if (name(last) === 'img') {
            return {
              element: last,
              offset: 1
            };
          } else if (isText$8(last)) {
            return {
              element: last,
              offset: get$2(last).length
            };
          } else {
            return {
              element: last,
              offset: children(last).length
            };
          }
        }
      }
    };
    var markerInfo = function (element, cleanupFun) {
      var pos = absolute(element);
      var height = get$1(element);
      return {
        element: element,
        bottom: pos.top + height,
        height: height,
        pos: pos,
        cleanup: cleanupFun
      };
    };
    var createMarker = function (element, offset) {
      var startPoint = descend(element, offset);
      var span = SugarElement.fromHtml('<span data-mce-bogus="all" style="display: inline-block;">' + ZWSP$1 + '</span>');
      before$4(startPoint.element, span);
      return markerInfo(span, function () {
        return remove$7(span);
      });
    };
    var elementMarker = function (element) {
      return markerInfo(SugarElement.fromDom(element), noop);
    };
    var withMarker = function (editor, f, rng, alignToTop) {
      preserveWith(editor, function (_s, _e) {
        return applyWithMarker(editor, f, rng, alignToTop);
      }, rng);
    };
    var withScrollEvents = function (editor, doc, f, marker, alignToTop) {
      var data = {
        elm: marker.element.dom,
        alignToTop: alignToTop
      };
      if (fireScrollIntoViewEvent(editor, data)) {
        return;
      }
      var scrollTop = get$8(doc).top;
      f(doc, scrollTop, marker, alignToTop);
      fireAfterScrollIntoViewEvent(editor, data);
    };
    var applyWithMarker = function (editor, f, rng, alignToTop) {
      var body = SugarElement.fromDom(editor.getBody());
      var doc = SugarElement.fromDom(editor.getDoc());
      reflow(body);
      var marker = createMarker(SugarElement.fromDom(rng.startContainer), rng.startOffset);
      withScrollEvents(editor, doc, f, marker, alignToTop);
      marker.cleanup();
    };
    var withElement = function (editor, element, f, alignToTop) {
      var doc = SugarElement.fromDom(editor.getDoc());
      withScrollEvents(editor, doc, f, elementMarker(element), alignToTop);
    };
    var preserveWith = function (editor, f, rng) {
      var startElement = rng.startContainer;
      var startOffset = rng.startOffset;
      var endElement = rng.endContainer;
      var endOffset = rng.endOffset;
      f(SugarElement.fromDom(startElement), SugarElement.fromDom(endElement));
      var newRng = editor.dom.createRng();
      newRng.setStart(startElement, startOffset);
      newRng.setEnd(endElement, endOffset);
      editor.selection.setRng(rng);
    };
    var scrollToMarker = function (marker, viewHeight, alignToTop, doc) {
      var pos = marker.pos;
      if (alignToTop) {
        to(pos.left, pos.top, doc);
      } else {
        var y = pos.top - viewHeight + marker.height;
        to(pos.left, y, doc);
      }
    };
    var intoWindowIfNeeded = function (doc, scrollTop, viewHeight, marker, alignToTop) {
      var viewportBottom = viewHeight + scrollTop;
      var markerTop = marker.pos.top;
      var markerBottom = marker.bottom;
      var largerThanViewport = markerBottom - markerTop >= viewHeight;
      if (markerTop < scrollTop) {
        scrollToMarker(marker, viewHeight, alignToTop !== false, doc);
      } else if (markerTop > viewportBottom) {
        var align = largerThanViewport ? alignToTop !== false : alignToTop === true;
        scrollToMarker(marker, viewHeight, align, doc);
      } else if (markerBottom > viewportBottom && !largerThanViewport) {
        scrollToMarker(marker, viewHeight, alignToTop === true, doc);
      }
    };
    var intoWindow = function (doc, scrollTop, marker, alignToTop) {
      var viewHeight = doc.dom.defaultView.innerHeight;
      intoWindowIfNeeded(doc, scrollTop, viewHeight, marker, alignToTop);
    };
    var intoFrame = function (doc, scrollTop, marker, alignToTop) {
      var frameViewHeight = doc.dom.defaultView.innerHeight;
      intoWindowIfNeeded(doc, scrollTop, frameViewHeight, marker, alignToTop);
      var op = find$1(marker.element);
      var viewportBounds = getBounds(window);
      if (op.top < viewportBounds.y) {
        intoView(marker.element, alignToTop !== false);
      } else if (op.top > viewportBounds.bottom) {
        intoView(marker.element, alignToTop === true);
      }
    };
    var rangeIntoWindow = function (editor, rng, alignToTop) {
      return withMarker(editor, intoWindow, rng, alignToTop);
    };
    var elementIntoWindow = function (editor, element, alignToTop) {
      return withElement(editor, element, intoWindow, alignToTop);
    };
    var rangeIntoFrame = function (editor, rng, alignToTop) {
      return withMarker(editor, intoFrame, rng, alignToTop);
    };
    var elementIntoFrame = function (editor, element, alignToTop) {
      return withElement(editor, element, intoFrame, alignToTop);
    };
    var scrollElementIntoView = function (editor, element, alignToTop) {
      var scroller = editor.inline ? elementIntoWindow : elementIntoFrame;
      scroller(editor, element, alignToTop);
    };
    var scrollRangeIntoView = function (editor, rng, alignToTop) {
      var scroller = editor.inline ? rangeIntoWindow : rangeIntoFrame;
      scroller(editor, rng, alignToTop);
    };

    var getDocument = function () {
      return SugarElement.fromDom(document);
    };

    var focus$1 = function (element) {
      return element.dom.focus();
    };
    var hasFocus$1 = function (element) {
      var root = getRootNode(element).dom;
      return element.dom === root.activeElement;
    };
    var active = function (root) {
      if (root === void 0) {
        root = getDocument();
      }
      return Optional.from(root.dom.activeElement).map(SugarElement.fromDom);
    };
    var search = function (element) {
      return active(getRootNode(element)).filter(function (e) {
        return element.dom.contains(e.dom);
      });
    };

    var create$5 = function (start, soffset, finish, foffset) {
      return {
        start: start,
        soffset: soffset,
        finish: finish,
        foffset: foffset
      };
    };
    var SimRange = { create: create$5 };

    var adt$1 = Adt.generate([
      { before: ['element'] },
      {
        on: [
          'element',
          'offset'
        ]
      },
      { after: ['element'] }
    ]);
    var cata = function (subject, onBefore, onOn, onAfter) {
      return subject.fold(onBefore, onOn, onAfter);
    };
    var getStart$2 = function (situ) {
      return situ.fold(identity, identity, identity);
    };
    var before$1 = adt$1.before;
    var on = adt$1.on;
    var after$1 = adt$1.after;
    var Situ = {
      before: before$1,
      on: on,
      after: after$1,
      cata: cata,
      getStart: getStart$2
    };

    var adt = Adt.generate([
      { domRange: ['rng'] },
      {
        relative: [
          'startSitu',
          'finishSitu'
        ]
      },
      {
        exact: [
          'start',
          'soffset',
          'finish',
          'foffset'
        ]
      }
    ]);
    var exactFromRange = function (simRange) {
      return adt.exact(simRange.start, simRange.soffset, simRange.finish, simRange.foffset);
    };
    var getStart$1 = function (selection) {
      return selection.match({
        domRange: function (rng) {
          return SugarElement.fromDom(rng.startContainer);
        },
        relative: function (startSitu, _finishSitu) {
          return Situ.getStart(startSitu);
        },
        exact: function (start, _soffset, _finish, _foffset) {
          return start;
        }
      });
    };
    var domRange = adt.domRange;
    var relative = adt.relative;
    var exact = adt.exact;
    var getWin = function (selection) {
      var start = getStart$1(selection);
      return defaultView(start);
    };
    var range = SimRange.create;
    var SimSelection = {
      domRange: domRange,
      relative: relative,
      exact: exact,
      exactFromRange: exactFromRange,
      getWin: getWin,
      range: range
    };

    var browser$1 = detect().browser;
    var clamp$1 = function (offset, element) {
      var max = isText$8(element) ? get$2(element).length : children(element).length + 1;
      if (offset > max) {
        return max;
      } else if (offset < 0) {
        return 0;
      }
      return offset;
    };
    var normalizeRng = function (rng) {
      return SimSelection.range(rng.start, clamp$1(rng.soffset, rng.start), rng.finish, clamp$1(rng.foffset, rng.finish));
    };
    var isOrContains = function (root, elm) {
      return !isRestrictedNode(elm.dom) && (contains$1(root, elm) || eq(root, elm));
    };
    var isRngInRoot = function (root) {
      return function (rng) {
        return isOrContains(root, rng.start) && isOrContains(root, rng.finish);
      };
    };
    var shouldStore = function (editor) {
      return editor.inline === true || browser$1.isIE();
    };
    var nativeRangeToSelectionRange = function (r) {
      return SimSelection.range(SugarElement.fromDom(r.startContainer), r.startOffset, SugarElement.fromDom(r.endContainer), r.endOffset);
    };
    var readRange = function (win) {
      var selection = win.getSelection();
      var rng = !selection || selection.rangeCount === 0 ? Optional.none() : Optional.from(selection.getRangeAt(0));
      return rng.map(nativeRangeToSelectionRange);
    };
    var getBookmark = function (root) {
      var win = defaultView(root);
      return readRange(win.dom).filter(isRngInRoot(root));
    };
    var validate = function (root, bookmark) {
      return Optional.from(bookmark).filter(isRngInRoot(root)).map(normalizeRng);
    };
    var bookmarkToNativeRng = function (bookmark) {
      var rng = document.createRange();
      try {
        rng.setStart(bookmark.start.dom, bookmark.soffset);
        rng.setEnd(bookmark.finish.dom, bookmark.foffset);
        return Optional.some(rng);
      } catch (_) {
        return Optional.none();
      }
    };
    var store = function (editor) {
      var newBookmark = shouldStore(editor) ? getBookmark(SugarElement.fromDom(editor.getBody())) : Optional.none();
      editor.bookmark = newBookmark.isSome() ? newBookmark : editor.bookmark;
    };
    var storeNative = function (editor, rng) {
      var root = SugarElement.fromDom(editor.getBody());
      var range = shouldStore(editor) ? Optional.from(rng) : Optional.none();
      var newBookmark = range.map(nativeRangeToSelectionRange).filter(isRngInRoot(root));
      editor.bookmark = newBookmark.isSome() ? newBookmark : editor.bookmark;
    };
    var getRng = function (editor) {
      var bookmark = editor.bookmark ? editor.bookmark : Optional.none();
      return bookmark.bind(function (x) {
        return validate(SugarElement.fromDom(editor.getBody()), x);
      }).bind(bookmarkToNativeRng);
    };
    var restore = function (editor) {
      getRng(editor).each(function (rng) {
        return editor.selection.setRng(rng);
      });
    };

    var isEditorUIElement$1 = function (elm) {
      var className = elm.className.toString();
      return className.indexOf('tox-') !== -1 || className.indexOf('mce-') !== -1;
    };
    var FocusManager = { isEditorUIElement: isEditorUIElement$1 };

    var isManualNodeChange = function (e) {
      return e.type === 'nodechange' && e.selectionChange;
    };
    var registerPageMouseUp = function (editor, throttledStore) {
      var mouseUpPage = function () {
        throttledStore.throttle();
      };
      DOMUtils.DOM.bind(document, 'mouseup', mouseUpPage);
      editor.on('remove', function () {
        DOMUtils.DOM.unbind(document, 'mouseup', mouseUpPage);
      });
    };
    var registerFocusOut = function (editor) {
      editor.on('focusout', function () {
        store(editor);
      });
    };
    var registerMouseUp = function (editor, throttledStore) {
      editor.on('mouseup touchend', function (_e) {
        throttledStore.throttle();
      });
    };
    var registerEditorEvents = function (editor, throttledStore) {
      var browser = detect().browser;
      if (browser.isIE()) {
        registerFocusOut(editor);
      } else {
        registerMouseUp(editor, throttledStore);
      }
      editor.on('keyup NodeChange', function (e) {
        if (!isManualNodeChange(e)) {
          store(editor);
        }
      });
    };
    var register$3 = function (editor) {
      var throttledStore = first(function () {
        store(editor);
      }, 0);
      editor.on('init', function () {
        if (editor.inline) {
          registerPageMouseUp(editor, throttledStore);
        }
        registerEditorEvents(editor, throttledStore);
      });
      editor.on('remove', function () {
        throttledStore.cancel();
      });
    };

    var documentFocusInHandler;
    var DOM$8 = DOMUtils.DOM;
    var isEditorUIElement = function (elm) {
      return FocusManager.isEditorUIElement(elm);
    };
    var isEditorContentAreaElement = function (elm) {
      var classList = elm.classList;
      if (classList !== undefined) {
        return classList.contains('tox-edit-area') || classList.contains('tox-edit-area__iframe') || classList.contains('mce-content-body');
      } else {
        return false;
      }
    };
    var isUIElement = function (editor, elm) {
      var customSelector = getCustomUiSelector(editor);
      var parent = DOM$8.getParent(elm, function (elm) {
        return isEditorUIElement(elm) || (customSelector ? editor.dom.is(elm, customSelector) : false);
      });
      return parent !== null;
    };
    var getActiveElement = function (editor) {
      try {
        var root = getRootNode(SugarElement.fromDom(editor.getElement()));
        return active(root).fold(function () {
          return document.body;
        }, function (x) {
          return x.dom;
        });
      } catch (ex) {
        return document.body;
      }
    };
    var registerEvents$1 = function (editorManager, e) {
      var editor = e.editor;
      register$3(editor);
      editor.on('focusin', function () {
        var focusedEditor = editorManager.focusedEditor;
        if (focusedEditor !== editor) {
          if (focusedEditor) {
            focusedEditor.fire('blur', { focusedEditor: editor });
          }
          editorManager.setActive(editor);
          editorManager.focusedEditor = editor;
          editor.fire('focus', { blurredEditor: focusedEditor });
          editor.focus(true);
        }
      });
      editor.on('focusout', function () {
        Delay.setEditorTimeout(editor, function () {
          var focusedEditor = editorManager.focusedEditor;
          if (!isUIElement(editor, getActiveElement(editor)) && focusedEditor === editor) {
            editor.fire('blur', { focusedEditor: null });
            editorManager.focusedEditor = null;
          }
        });
      });
      if (!documentFocusInHandler) {
        documentFocusInHandler = function (e) {
          var activeEditor = editorManager.activeEditor;
          if (activeEditor) {
            getOriginalEventTarget(e).each(function (target) {
              if (target.ownerDocument === document) {
                if (target !== document.body && !isUIElement(activeEditor, target) && editorManager.focusedEditor === activeEditor) {
                  activeEditor.fire('blur', { focusedEditor: null });
                  editorManager.focusedEditor = null;
                }
              }
            });
          }
        };
        DOM$8.bind(document, 'focusin', documentFocusInHandler);
      }
    };
    var unregisterDocumentEvents = function (editorManager, e) {
      if (editorManager.focusedEditor === e.editor) {
        editorManager.focusedEditor = null;
      }
      if (!editorManager.activeEditor) {
        DOM$8.unbind(document, 'focusin', documentFocusInHandler);
        documentFocusInHandler = null;
      }
    };
    var setup$l = function (editorManager) {
      editorManager.on('AddEditor', curry(registerEvents$1, editorManager));
      editorManager.on('RemoveEditor', curry(unregisterDocumentEvents, editorManager));
    };

    var getContentEditableHost = function (editor, node) {
      return editor.dom.getParent(node, function (node) {
        return editor.dom.getContentEditable(node) === 'true';
      });
    };
    var getCollapsedNode = function (rng) {
      return rng.collapsed ? Optional.from(getNode$1(rng.startContainer, rng.startOffset)).map(SugarElement.fromDom) : Optional.none();
    };
    var getFocusInElement = function (root, rng) {
      return getCollapsedNode(rng).bind(function (node) {
        if (isTableSection(node)) {
          return Optional.some(node);
        } else if (contains$1(root, node) === false) {
          return Optional.some(root);
        } else {
          return Optional.none();
        }
      });
    };
    var normalizeSelection$1 = function (editor, rng) {
      getFocusInElement(SugarElement.fromDom(editor.getBody()), rng).bind(function (elm) {
        return firstPositionIn(elm.dom);
      }).fold(function () {
        editor.selection.normalize();
        return;
      }, function (caretPos) {
        return editor.selection.setRng(caretPos.toRange());
      });
    };
    var focusBody = function (body) {
      if (body.setActive) {
        try {
          body.setActive();
        } catch (ex) {
          body.focus();
        }
      } else {
        body.focus();
      }
    };
    var hasElementFocus = function (elm) {
      return hasFocus$1(elm) || search(elm).isSome();
    };
    var hasIframeFocus = function (editor) {
      return editor.iframeElement && hasFocus$1(SugarElement.fromDom(editor.iframeElement));
    };
    var hasInlineFocus = function (editor) {
      var rawBody = editor.getBody();
      return rawBody && hasElementFocus(SugarElement.fromDom(rawBody));
    };
    var hasUiFocus = function (editor) {
      var dos = getRootNode(SugarElement.fromDom(editor.getElement()));
      return active(dos).filter(function (elem) {
        return !isEditorContentAreaElement(elem.dom) && isUIElement(editor, elem.dom);
      }).isSome();
    };
    var hasFocus = function (editor) {
      return editor.inline ? hasInlineFocus(editor) : hasIframeFocus(editor);
    };
    var hasEditorOrUiFocus = function (editor) {
      return hasFocus(editor) || hasUiFocus(editor);
    };
    var focusEditor = function (editor) {
      var selection = editor.selection;
      var body = editor.getBody();
      var rng = selection.getRng();
      editor.quirks.refreshContentEditable();
      if (editor.bookmark !== undefined && hasFocus(editor) === false) {
        getRng(editor).each(function (bookmarkRng) {
          editor.selection.setRng(bookmarkRng);
          rng = bookmarkRng;
        });
      }
      var contentEditableHost = getContentEditableHost(editor, selection.getNode());
      if (editor.$.contains(body, contentEditableHost)) {
        focusBody(contentEditableHost);
        normalizeSelection$1(editor, rng);
        activateEditor(editor);
        return;
      }
      if (!editor.inline) {
        if (!Env.opera) {
          focusBody(body);
        }
        editor.getWin().focus();
      }
      if (Env.gecko || editor.inline) {
        focusBody(body);
        normalizeSelection$1(editor, rng);
      }
      activateEditor(editor);
    };
    var activateEditor = function (editor) {
      return editor.editorManager.setActive(editor);
    };
    var focus = function (editor, skipFocus) {
      if (editor.removed) {
        return;
      }
      if (skipFocus) {
        activateEditor(editor);
      } else {
        focusEditor(editor);
      }
    };

    var getEndpointElement = function (root, rng, start, real, resolve) {
      var container = start ? rng.startContainer : rng.endContainer;
      var offset = start ? rng.startOffset : rng.endOffset;
      return Optional.from(container).map(SugarElement.fromDom).map(function (elm) {
        return !real || !rng.collapsed ? child$1(elm, resolve(elm, offset)).getOr(elm) : elm;
      }).bind(function (elm) {
        return isElement$6(elm) ? Optional.some(elm) : parent(elm).filter(isElement$6);
      }).map(function (elm) {
        return elm.dom;
      }).getOr(root);
    };
    var getStart = function (root, rng, real) {
      return getEndpointElement(root, rng, true, real, function (elm, offset) {
        return Math.min(childNodesCount(elm), offset);
      });
    };
    var getEnd = function (root, rng, real) {
      return getEndpointElement(root, rng, false, real, function (elm, offset) {
        return offset > 0 ? offset - 1 : offset;
      });
    };
    var skipEmptyTextNodes = function (node, forwards) {
      var orig = node;
      while (node && isText$7(node) && node.length === 0) {
        node = forwards ? node.nextSibling : node.previousSibling;
      }
      return node || orig;
    };
    var getNode = function (root, rng) {
      var elm, startContainer, endContainer;
      if (!rng) {
        return root;
      }
      startContainer = rng.startContainer;
      endContainer = rng.endContainer;
      var startOffset = rng.startOffset;
      var endOffset = rng.endOffset;
      elm = rng.commonAncestorContainer;
      if (!rng.collapsed) {
        if (startContainer === endContainer) {
          if (endOffset - startOffset < 2) {
            if (startContainer.hasChildNodes()) {
              elm = startContainer.childNodes[startOffset];
            }
          }
        }
        if (startContainer.nodeType === 3 && endContainer.nodeType === 3) {
          if (startContainer.length === startOffset) {
            startContainer = skipEmptyTextNodes(startContainer.nextSibling, true);
          } else {
            startContainer = startContainer.parentNode;
          }
          if (endOffset === 0) {
            endContainer = skipEmptyTextNodes(endContainer.previousSibling, false);
          } else {
            endContainer = endContainer.parentNode;
          }
          if (startContainer && startContainer === endContainer) {
            return startContainer;
          }
        }
      }
      if (elm && elm.nodeType === 3) {
        return elm.parentNode;
      }
      return elm;
    };
    var getSelectedBlocks = function (dom, rng, startElm, endElm) {
      var node;
      var selectedBlocks = [];
      var root = dom.getRoot();
      startElm = dom.getParent(startElm || getStart(root, rng, rng.collapsed), dom.isBlock);
      endElm = dom.getParent(endElm || getEnd(root, rng, rng.collapsed), dom.isBlock);
      if (startElm && startElm !== root) {
        selectedBlocks.push(startElm);
      }
      if (startElm && endElm && startElm !== endElm) {
        node = startElm;
        var walker = new DomTreeWalker(startElm, root);
        while ((node = walker.next()) && node !== endElm) {
          if (dom.isBlock(node)) {
            selectedBlocks.push(node);
          }
        }
      }
      if (endElm && startElm !== endElm && endElm !== root) {
        selectedBlocks.push(endElm);
      }
      return selectedBlocks;
    };
    var select = function (dom, node, content) {
      return Optional.from(node).map(function (node) {
        var idx = dom.nodeIndex(node);
        var rng = dom.createRng();
        rng.setStart(node.parentNode, idx);
        rng.setEnd(node.parentNode, idx + 1);
        if (content) {
          moveEndPoint(dom, rng, node, true);
          moveEndPoint(dom, rng, node, false);
        }
        return rng;
      });
    };

    var processRanges = function (editor, ranges) {
      return map$3(ranges, function (range) {
        var evt = editor.fire('GetSelectionRange', { range: range });
        return evt.range !== range ? evt.range : range;
      });
    };

    var typeLookup = {
      '#text': 3,
      '#comment': 8,
      '#cdata': 4,
      '#pi': 7,
      '#doctype': 10,
      '#document-fragment': 11
    };
    var walk$1 = function (node, root, prev) {
      var startName = prev ? 'lastChild' : 'firstChild';
      var siblingName = prev ? 'prev' : 'next';
      if (node[startName]) {
        return node[startName];
      }
      if (node !== root) {
        var sibling = node[siblingName];
        if (sibling) {
          return sibling;
        }
        for (var parent_1 = node.parent; parent_1 && parent_1 !== root; parent_1 = parent_1.parent) {
          sibling = parent_1[siblingName];
          if (sibling) {
            return sibling;
          }
        }
      }
    };
    var isEmptyTextNode = function (node) {
      if (!isWhitespaceText(node.value)) {
        return false;
      }
      var parentNode = node.parent;
      if (parentNode && (parentNode.name !== 'span' || parentNode.attr('style')) && /^[ ]+$/.test(node.value)) {
        return false;
      }
      return true;
    };
    var isNonEmptyElement = function (node) {
      var isNamedAnchor = node.name === 'a' && !node.attr('href') && node.attr('id');
      return node.attr('name') || node.attr('id') && !node.firstChild || node.attr('data-mce-bookmark') || isNamedAnchor;
    };
    var AstNode = function () {
      function AstNode(name, type) {
        this.name = name;
        this.type = type;
        if (type === 1) {
          this.attributes = [];
          this.attributes.map = {};
        }
      }
      AstNode.create = function (name, attrs) {
        var node = new AstNode(name, typeLookup[name] || 1);
        if (attrs) {
          each$j(attrs, function (value, attrName) {
            node.attr(attrName, value);
          });
        }
        return node;
      };
      AstNode.prototype.replace = function (node) {
        var self = this;
        if (node.parent) {
          node.remove();
        }
        self.insert(node, self);
        self.remove();
        return self;
      };
      AstNode.prototype.attr = function (name, value) {
        var self = this;
        var attrs;
        if (typeof name !== 'string') {
          if (name !== undefined && name !== null) {
            each$j(name, function (value, key) {
              self.attr(key, value);
            });
          }
          return self;
        }
        if (attrs = self.attributes) {
          if (value !== undefined) {
            if (value === null) {
              if (name in attrs.map) {
                delete attrs.map[name];
                var i = attrs.length;
                while (i--) {
                  if (attrs[i].name === name) {
                    attrs.splice(i, 1);
                    return self;
                  }
                }
              }
              return self;
            }
            if (name in attrs.map) {
              var i = attrs.length;
              while (i--) {
                if (attrs[i].name === name) {
                  attrs[i].value = value;
                  break;
                }
              }
            } else {
              attrs.push({
                name: name,
                value: value
              });
            }
            attrs.map[name] = value;
            return self;
          }
          return attrs.map[name];
        }
      };
      AstNode.prototype.clone = function () {
        var self = this;
        var clone = new AstNode(self.name, self.type);
        var selfAttrs;
        if (selfAttrs = self.attributes) {
          var cloneAttrs = [];
          cloneAttrs.map = {};
          for (var i = 0, l = selfAttrs.length; i < l; i++) {
            var selfAttr = selfAttrs[i];
            if (selfAttr.name !== 'id') {
              cloneAttrs[cloneAttrs.length] = {
                name: selfAttr.name,
                value: selfAttr.value
              };
              cloneAttrs.map[selfAttr.name] = selfAttr.value;
            }
          }
          clone.attributes = cloneAttrs;
        }
        clone.value = self.value;
        clone.shortEnded = self.shortEnded;
        return clone;
      };
      AstNode.prototype.wrap = function (wrapper) {
        var self = this;
        self.parent.insert(wrapper, self);
        wrapper.append(self);
        return self;
      };
      AstNode.prototype.unwrap = function () {
        var self = this;
        for (var node = self.firstChild; node;) {
          var next = node.next;
          self.insert(node, self, true);
          node = next;
        }
        self.remove();
      };
      AstNode.prototype.remove = function () {
        var self = this, parent = self.parent, next = self.next, prev = self.prev;
        if (parent) {
          if (parent.firstChild === self) {
            parent.firstChild = next;
            if (next) {
              next.prev = null;
            }
          } else {
            prev.next = next;
          }
          if (parent.lastChild === self) {
            parent.lastChild = prev;
            if (prev) {
              prev.next = null;
            }
          } else {
            next.prev = prev;
          }
          self.parent = self.next = self.prev = null;
        }
        return self;
      };
      AstNode.prototype.append = function (node) {
        var self = this;
        if (node.parent) {
          node.remove();
        }
        var last = self.lastChild;
        if (last) {
          last.next = node;
          node.prev = last;
          self.lastChild = node;
        } else {
          self.lastChild = self.firstChild = node;
        }
        node.parent = self;
        return node;
      };
      AstNode.prototype.insert = function (node, refNode, before) {
        if (node.parent) {
          node.remove();
        }
        var parent = refNode.parent || this;
        if (before) {
          if (refNode === parent.firstChild) {
            parent.firstChild = node;
          } else {
            refNode.prev.next = node;
          }
          node.prev = refNode.prev;
          node.next = refNode;
          refNode.prev = node;
        } else {
          if (refNode === parent.lastChild) {
            parent.lastChild = node;
          } else {
            refNode.next.prev = node;
          }
          node.next = refNode.next;
          node.prev = refNode;
          refNode.next = node;
        }
        node.parent = parent;
        return node;
      };
      AstNode.prototype.getAll = function (name) {
        var self = this;
        var collection = [];
        for (var node = self.firstChild; node; node = walk$1(node, self)) {
          if (node.name === name) {
            collection.push(node);
          }
        }
        return collection;
      };
      AstNode.prototype.children = function () {
        var self = this;
        var collection = [];
        for (var node = self.firstChild; node; node = node.next) {
          collection.push(node);
        }
        return collection;
      };
      AstNode.prototype.empty = function () {
        var self = this;
        if (self.firstChild) {
          var nodes = [];
          for (var node = self.firstChild; node; node = walk$1(node, self)) {
            nodes.push(node);
          }
          var i = nodes.length;
          while (i--) {
            var node = nodes[i];
            node.parent = node.firstChild = node.lastChild = node.next = node.prev = null;
          }
        }
        self.firstChild = self.lastChild = null;
        return self;
      };
      AstNode.prototype.isEmpty = function (elements, whitespace, predicate) {
        if (whitespace === void 0) {
          whitespace = {};
        }
        var self = this;
        var node = self.firstChild;
        if (isNonEmptyElement(self)) {
          return false;
        }
        if (node) {
          do {
            if (node.type === 1) {
              if (node.attr('data-mce-bogus')) {
                continue;
              }
              if (elements[node.name]) {
                return false;
              }
              if (isNonEmptyElement(node)) {
                return false;
              }
            }
            if (node.type === 8) {
              return false;
            }
            if (node.type === 3 && !isEmptyTextNode(node)) {
              return false;
            }
            if (node.type === 3 && node.parent && whitespace[node.parent.name] && isWhitespaceText(node.value)) {
              return false;
            }
            if (predicate && predicate(node)) {
              return false;
            }
          } while (node = walk$1(node, self));
        }
        return true;
      };
      AstNode.prototype.walk = function (prev) {
        return walk$1(this, null, prev);
      };
      return AstNode;
    }();

    var extractBase64DataUris = function (html) {
      var dataImageUri = /data:[^;<"'\s]+;base64,([a-z0-9\+\/=\s]+)/gi;
      var chunks = [];
      var uris = {};
      var prefix = generate('img');
      var matches;
      var index = 0;
      var count = 0;
      while (matches = dataImageUri.exec(html)) {
        var uri = matches[0];
        var imageId = prefix + '_' + count++;
        uris[imageId] = uri;
        if (index < matches.index) {
          chunks.push(html.substr(index, matches.index - index));
        }
        chunks.push(imageId);
        index = matches.index + uri.length;
      }
      var re = new RegExp(prefix + '_[0-9]+', 'g');
      if (index === 0) {
        return {
          prefix: prefix,
          uris: uris,
          html: html,
          re: re
        };
      } else {
        if (index < html.length) {
          chunks.push(html.substr(index));
        }
        return {
          prefix: prefix,
          uris: uris,
          html: chunks.join(''),
          re: re
        };
      }
    };
    var restoreDataUris = function (html, result) {
      return html.replace(result.re, function (imageId) {
        return get$9(result.uris, imageId).getOr(imageId);
      });
    };
    var parseDataUri$1 = function (uri) {
      var matches = /data:([^;]+);base64,([a-z0-9\+\/=\s]+)/i.exec(uri);
      if (matches) {
        return Optional.some({
          type: matches[1],
          data: decodeURIComponent(matches[2])
        });
      } else {
        return Optional.none();
      }
    };

    var each$d = Tools.each, trim = Tools.trim;
    var queryParts = 'source protocol authority userInfo user password host port relative path directory file query anchor'.split(' ');
    var DEFAULT_PORTS = {
      ftp: 21,
      http: 80,
      https: 443,
      mailto: 25
    };
    var safeSvgDataUrlElements = [
      'img',
      'video'
    ];
    var blockSvgDataUris = function (allowSvgDataUrls, tagName) {
      if (isNonNullable(allowSvgDataUrls)) {
        return !allowSvgDataUrls;
      } else {
        return isNonNullable(tagName) ? !contains$3(safeSvgDataUrlElements, tagName) : true;
      }
    };
    var isInvalidUri = function (settings, uri, tagName) {
      if (settings.allow_html_data_urls) {
        return false;
      } else if (/^data:image\//i.test(uri)) {
        return blockSvgDataUris(settings.allow_svg_data_urls, tagName) && /^data:image\/svg\+xml/i.test(uri);
      } else {
        return /^data:/i.test(uri);
      }
    };
    var URI = function () {
      function URI(url, settings) {
        url = trim(url);
        this.settings = settings || {};
        var baseUri = this.settings.base_uri;
        var self = this;
        if (/^([\w\-]+):([^\/]{2})/i.test(url) || /^\s*#/.test(url)) {
          self.source = url;
          return;
        }
        var isProtocolRelative = url.indexOf('//') === 0;
        if (url.indexOf('/') === 0 && !isProtocolRelative) {
          url = (baseUri ? baseUri.protocol || 'http' : 'http') + '://mce_host' + url;
        }
        if (!/^[\w\-]*:?\/\//.test(url)) {
          var baseUrl = this.settings.base_uri ? this.settings.base_uri.path : new URI(document.location.href).directory;
          if (this.settings.base_uri && this.settings.base_uri.protocol == '') {
            url = '//mce_host' + self.toAbsPath(baseUrl, url);
          } else {
            var match = /([^#?]*)([#?]?.*)/.exec(url);
            url = (baseUri && baseUri.protocol || 'http') + '://mce_host' + self.toAbsPath(baseUrl, match[1]) + match[2];
          }
        }
        url = url.replace(/@@/g, '(mce_at)');
        var urlMatch = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@\/]*):?([^:@\/]*))?@)?(\[[a-zA-Z0-9:.%]+\]|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/.exec(url);
        each$d(queryParts, function (v, i) {
          var part = urlMatch[i];
          if (part) {
            part = part.replace(/\(mce_at\)/g, '@@');
          }
          self[v] = part;
        });
        if (baseUri) {
          if (!self.protocol) {
            self.protocol = baseUri.protocol;
          }
          if (!self.userInfo) {
            self.userInfo = baseUri.userInfo;
          }
          if (!self.port && self.host === 'mce_host') {
            self.port = baseUri.port;
          }
          if (!self.host || self.host === 'mce_host') {
            self.host = baseUri.host;
          }
          self.source = '';
        }
        if (isProtocolRelative) {
          self.protocol = '';
        }
      }
      URI.parseDataUri = function (uri) {
        var type;
        var uriComponents = decodeURIComponent(uri).split(',');
        var matches = /data:([^;]+)/.exec(uriComponents[0]);
        if (matches) {
          type = matches[1];
        }
        return {
          type: type,
          data: uriComponents[1]
        };
      };
      URI.isDomSafe = function (uri, context, options) {
        if (options === void 0) {
          options = {};
        }
        if (options.allow_script_urls) {
          return true;
        } else {
          var decodedUri = Entities.decode(uri).replace(/[\s\u0000-\u001F]+/g, '');
          try {
            decodedUri = decodeURIComponent(decodedUri);
          } catch (ex) {
            decodedUri = unescape(decodedUri);
          }
          if (/((java|vb)script|mhtml):/i.test(decodedUri)) {
            return false;
          }
          return !isInvalidUri(options, decodedUri, context);
        }
      };
      URI.getDocumentBaseUrl = function (loc) {
        var baseUrl;
        if (loc.protocol.indexOf('http') !== 0 && loc.protocol !== 'file:') {
          baseUrl = loc.href;
        } else {
          baseUrl = loc.protocol + '//' + loc.host + loc.pathname;
        }
        if (/^[^:]+:\/\/\/?[^\/]+\//.test(baseUrl)) {
          baseUrl = baseUrl.replace(/[\?#].*$/, '').replace(/[\/\\][^\/]+$/, '');
          if (!/[\/\\]$/.test(baseUrl)) {
            baseUrl += '/';
          }
        }
        return baseUrl;
      };
      URI.prototype.setPath = function (path) {
        var pathMatch = /^(.*?)\/?(\w+)?$/.exec(path);
        this.path = pathMatch[0];
        this.directory = pathMatch[1];
        this.file = pathMatch[2];
        this.source = '';
        this.getURI();
      };
      URI.prototype.toRelative = function (uri) {
        var output;
        if (uri === './') {
          return uri;
        }
        var relativeUri = new URI(uri, { base_uri: this });
        if (relativeUri.host !== 'mce_host' && this.host !== relativeUri.host && relativeUri.host || this.port !== relativeUri.port || this.protocol !== relativeUri.protocol && relativeUri.protocol !== '') {
          return relativeUri.getURI();
        }
        var tu = this.getURI(), uu = relativeUri.getURI();
        if (tu === uu || tu.charAt(tu.length - 1) === '/' && tu.substr(0, tu.length - 1) === uu) {
          return tu;
        }
        output = this.toRelPath(this.path, relativeUri.path);
        if (relativeUri.query) {
          output += '?' + relativeUri.query;
        }
        if (relativeUri.anchor) {
          output += '#' + relativeUri.anchor;
        }
        return output;
      };
      URI.prototype.toAbsolute = function (uri, noHost) {
        var absoluteUri = new URI(uri, { base_uri: this });
        return absoluteUri.getURI(noHost && this.isSameOrigin(absoluteUri));
      };
      URI.prototype.isSameOrigin = function (uri) {
        if (this.host == uri.host && this.protocol == uri.protocol) {
          if (this.port == uri.port) {
            return true;
          }
          var defaultPort = DEFAULT_PORTS[this.protocol];
          if (defaultPort && (this.port || defaultPort) == (uri.port || defaultPort)) {
            return true;
          }
        }
        return false;
      };
      URI.prototype.toRelPath = function (base, path) {
        var breakPoint = 0, out = '', i, l;
        var normalizedBase = base.substring(0, base.lastIndexOf('/')).split('/');
        var items = path.split('/');
        if (normalizedBase.length >= items.length) {
          for (i = 0, l = normalizedBase.length; i < l; i++) {
            if (i >= items.length || normalizedBase[i] !== items[i]) {
              breakPoint = i + 1;
              break;
            }
          }
        }
        if (normalizedBase.length < items.length) {
          for (i = 0, l = items.length; i < l; i++) {
            if (i >= normalizedBase.length || normalizedBase[i] !== items[i]) {
              breakPoint = i + 1;
              break;
            }
          }
        }
        if (breakPoint === 1) {
          return path;
        }
        for (i = 0, l = normalizedBase.length - (breakPoint - 1); i < l; i++) {
          out += '../';
        }
        for (i = breakPoint - 1, l = items.length; i < l; i++) {
          if (i !== breakPoint - 1) {
            out += '/' + items[i];
          } else {
            out += items[i];
          }
        }
        return out;
      };
      URI.prototype.toAbsPath = function (base, path) {
        var i, nb = 0, o = [], outPath;
        var tr = /\/$/.test(path) ? '/' : '';
        var normalizedBase = base.split('/');
        var normalizedPath = path.split('/');
        each$d(normalizedBase, function (k) {
          if (k) {
            o.push(k);
          }
        });
        normalizedBase = o;
        for (i = normalizedPath.length - 1, o = []; i >= 0; i--) {
          if (normalizedPath[i].length === 0 || normalizedPath[i] === '.') {
            continue;
          }
          if (normalizedPath[i] === '..') {
            nb++;
            continue;
          }
          if (nb > 0) {
            nb--;
            continue;
          }
          o.push(normalizedPath[i]);
        }
        i = normalizedBase.length - nb;
        if (i <= 0) {
          outPath = reverse(o).join('/');
        } else {
          outPath = normalizedBase.slice(0, i).join('/') + '/' + reverse(o).join('/');
        }
        if (outPath.indexOf('/') !== 0) {
          outPath = '/' + outPath;
        }
        if (tr && outPath.lastIndexOf('/') !== outPath.length - 1) {
          outPath += tr;
        }
        return outPath;
      };
      URI.prototype.getURI = function (noProtoHost) {
        if (noProtoHost === void 0) {
          noProtoHost = false;
        }
        var s;
        if (!this.source || noProtoHost) {
          s = '';
          if (!noProtoHost) {
            if (this.protocol) {
              s += this.protocol + '://';
            } else {
              s += '//';
            }
            if (this.userInfo) {
              s += this.userInfo + '@';
            }
            if (this.host) {
              s += this.host;
            }
            if (this.port) {
              s += ':' + this.port;
            }
          }
          if (this.path) {
            s += this.path;
          }
          if (this.query) {
            s += '?' + this.query;
          }
          if (this.anchor) {
            s += '#' + this.anchor;
          }
          this.source = s;
        }
        return this.source;
      };
      return URI;
    }();

    var filteredClobberElements = Tools.makeMap('button,fieldset,form,iframe,img,image,input,object,output,select,textarea');
    var isValidPrefixAttrName = function (name) {
      return name.indexOf('data-') === 0 || name.indexOf('aria-') === 0;
    };
    var findMatchingEndTagIndex = function (schema, html, startIndex) {
      var startTagRegExp = /<([!?\/])?([A-Za-z0-9\-_:.]+)/g;
      var endTagRegExp = /(?:\s(?:[^'">]+(?:"[^"]*"|'[^']*'))*[^"'>]*(?:"[^">]*|'[^'>]*)?|\s*|\/)>/g;
      var shortEndedElements = schema.getShortEndedElements();
      var count = 1, index = startIndex;
      while (count !== 0) {
        startTagRegExp.lastIndex = index;
        while (true) {
          var startMatch = startTagRegExp.exec(html);
          if (startMatch === null) {
            return index;
          } else if (startMatch[1] === '!') {
            if (startsWith(startMatch[2], '--')) {
              index = findCommentEndIndex(html, false, startMatch.index + '!--'.length);
            } else {
              index = findCommentEndIndex(html, true, startMatch.index + 1);
            }
            break;
          } else {
            endTagRegExp.lastIndex = startTagRegExp.lastIndex;
            var endMatch = endTagRegExp.exec(html);
            if (isNull(endMatch) || endMatch.index !== startTagRegExp.lastIndex) {
              continue;
            }
            if (startMatch[1] === '/') {
              count -= 1;
            } else if (!has$2(shortEndedElements, startMatch[2])) {
              count += 1;
            }
            index = startTagRegExp.lastIndex + endMatch[0].length;
            break;
          }
        }
      }
      return index;
    };
    var isConditionalComment = function (html, startIndex) {
      return /^\s*\[if [\w\W]+\]>.*<!\[endif\](--!?)?>/.test(html.substr(startIndex));
    };
    var findCommentEndIndex = function (html, isBogus, startIndex) {
      if (startIndex === void 0) {
        startIndex = 0;
      }
      var lcHtml = html.toLowerCase();
      if (lcHtml.indexOf('[if ', startIndex) !== -1 && isConditionalComment(lcHtml, startIndex)) {
        var endIfIndex = lcHtml.indexOf('[endif]', startIndex);
        return lcHtml.indexOf('>', endIfIndex);
      } else {
        if (isBogus) {
          var endIndex = lcHtml.indexOf('>', startIndex);
          return endIndex !== -1 ? endIndex : lcHtml.length;
        } else {
          var endCommentRegexp = /--!?>/g;
          endCommentRegexp.lastIndex = startIndex;
          var match = endCommentRegexp.exec(html);
          return match ? match.index + match[0].length : lcHtml.length;
        }
      }
    };
    var checkBogusAttribute = function (regExp, attrString) {
      var matches = regExp.exec(attrString);
      if (matches) {
        var name_1 = matches[1];
        var value = matches[2];
        return typeof name_1 === 'string' && name_1.toLowerCase() === 'data-mce-bogus' ? value : null;
      } else {
        return null;
      }
    };
    var SaxParser = function (settings, schema) {
      var _a;
      if (schema === void 0) {
        schema = Schema();
      }
      settings = settings || {};
      var doc = (_a = settings.document) !== null && _a !== void 0 ? _a : document;
      var form = doc.createElement('form');
      if (settings.fix_self_closing !== false) {
        settings.fix_self_closing = true;
      }
      var comment = settings.comment ? settings.comment : noop;
      var cdata = settings.cdata ? settings.cdata : noop;
      var text = settings.text ? settings.text : noop;
      var start = settings.start ? settings.start : noop;
      var end = settings.end ? settings.end : noop;
      var pi = settings.pi ? settings.pi : noop;
      var doctype = settings.doctype ? settings.doctype : noop;
      var parseInternal = function (base64Extract, format) {
        if (format === void 0) {
          format = 'html';
        }
        var html = base64Extract.html;
        var matches, index = 0, value, endRegExp;
        var stack = [];
        var attrList, i, textData, name;
        var isInternalElement, isShortEnded;
        var elementRule, isValidElement, attr, attribsValue, validAttributesMap, validAttributePatterns;
        var attributesRequired, attributesDefault, attributesForced;
        var anyAttributesRequired, attrValue, idCount = 0;
        var decode = Entities.decode;
        var filteredUrlAttrs = Tools.makeMap('src,href,data,background,action,formaction,poster,xlink:href');
        var parsingMode = format === 'html' ? 0 : 1;
        var processEndTag = function (name) {
          var pos, i;
          pos = stack.length;
          while (pos--) {
            if (stack[pos].name === name) {
              break;
            }
          }
          if (pos >= 0) {
            for (i = stack.length - 1; i >= pos; i--) {
              name = stack[i];
              if (name.valid) {
                end(name.name);
              }
            }
            stack.length = pos;
          }
        };
        var processText = function (value, raw) {
          return text(restoreDataUris(value, base64Extract), raw);
        };
        var processComment = function (value) {
          if (value === '') {
            return;
          }
          if (value.charAt(0) === '>') {
            value = ' ' + value;
          }
          if (!settings.allow_conditional_comments && value.substr(0, 3).toLowerCase() === '[if') {
            value = ' ' + value;
          }
          comment(restoreDataUris(value, base64Extract));
        };
        var processAttr = function (value) {
          return restoreDataUris(value, base64Extract);
        };
        var processMalformedComment = function (value, startIndex) {
          var startTag = value || '';
          var isBogus = !startsWith(startTag, '--');
          var endIndex = findCommentEndIndex(html, isBogus, startIndex);
          value = html.substr(startIndex, endIndex - startIndex);
          processComment(isBogus ? startTag + value : value);
          return endIndex + 1;
        };
        var parseAttribute = function (tagName, name, value, val2, val3) {
          name = name.toLowerCase();
          value = processAttr(name in fillAttrsMap ? name : decode(value || val2 || val3 || ''));
          if (validate && !isInternalElement && isValidPrefixAttrName(name) === false) {
            var attrRule = validAttributesMap[name];
            if (!attrRule && validAttributePatterns) {
              var i_1 = validAttributePatterns.length;
              while (i_1--) {
                attrRule = validAttributePatterns[i_1];
                if (attrRule.pattern.test(name)) {
                  break;
                }
              }
              if (i_1 === -1) {
                attrRule = null;
              }
            }
            if (!attrRule) {
              return;
            }
            if (attrRule.validValues && !(value in attrRule.validValues)) {
              return;
            }
          }
          var isNameOrId = name === 'name' || name === 'id';
          if (isNameOrId && tagName in filteredClobberElements && (value in doc || value in form)) {
            return;
          }
          if (filteredUrlAttrs[name] && !URI.isDomSafe(value, tagName, settings)) {
            return;
          }
          if (isInternalElement && (name in filteredUrlAttrs || name.indexOf('on') === 0)) {
            return;
          }
          attrList.map[name] = value;
          attrList.push({
            name: name,
            value: value
          });
        };
        var tokenRegExp = new RegExp('<(?:' + '(?:!--([\\w\\W]*?)--!?>)|' + '(?:!\\[CDATA\\[([\\w\\W]*?)\\]\\]>)|' + '(?:![Dd][Oo][Cc][Tt][Yy][Pp][Ee]([\\w\\W]*?)>)|' + '(?:!(--)?)|' + '(?:\\?([^\\s\\/<>]+) ?([\\w\\W]*?)[?/]>)|' + '(?:\\/([A-Za-z][A-Za-z0-9\\-_\\:\\.]*)>)|' + '(?:([A-Za-z][A-Za-z0-9\\-_:.]*)(\\s(?:[^\'">]+(?:"[^"]*"|\'[^\']*\'))*[^"\'>]*(?:"[^">]*|\'[^\'>]*)?|\\s*|\\/)>)' + ')', 'g');
        var attrRegExp = /([\w:\-]+)(?:\s*=\s*(?:(?:\"((?:[^\"])*)\")|(?:\'((?:[^\'])*)\')|([^>\s]+)))?/g;
        var shortEndedElements = schema.getShortEndedElements();
        var selfClosing = settings.self_closing_elements || schema.getSelfClosingElements();
        var fillAttrsMap = schema.getBoolAttrs();
        var validate = settings.validate;
        var removeInternalElements = settings.remove_internals;
        var fixSelfClosing = settings.fix_self_closing;
        var specialElements = schema.getSpecialElements();
        var processHtml = html + '>';
        while (matches = tokenRegExp.exec(processHtml)) {
          var matchText = matches[0];
          if (index < matches.index) {
            processText(decode(html.substr(index, matches.index - index)));
          }
          if (value = matches[7]) {
            value = value.toLowerCase();
            if (value.charAt(0) === ':') {
              value = value.substr(1);
            }
            processEndTag(value);
          } else if (value = matches[8]) {
            if (matches.index + matchText.length > html.length) {
              processText(decode(html.substr(matches.index)));
              index = matches.index + matchText.length;
              continue;
            }
            value = value.toLowerCase();
            if (value.charAt(0) === ':') {
              value = value.substr(1);
            }
            isShortEnded = value in shortEndedElements;
            if (fixSelfClosing && selfClosing[value] && stack.length > 0 && stack[stack.length - 1].name === value) {
              processEndTag(value);
            }
            var bogusValue = checkBogusAttribute(attrRegExp, matches[9]);
            if (bogusValue !== null) {
              if (bogusValue === 'all') {
                index = findMatchingEndTagIndex(schema, html, tokenRegExp.lastIndex);
                tokenRegExp.lastIndex = index;
                continue;
              }
              isValidElement = false;
            }
            if (!validate || (elementRule = schema.getElementRule(value))) {
              isValidElement = true;
              if (validate) {
                validAttributesMap = elementRule.attributes;
                validAttributePatterns = elementRule.attributePatterns;
              }
              if (attribsValue = matches[9]) {
                isInternalElement = attribsValue.indexOf('data-mce-type') !== -1;
                if (isInternalElement && removeInternalElements) {
                  isValidElement = false;
                }
                attrList = [];
                attrList.map = {};
                attribsValue.replace(attrRegExp, function (match, name, val, val2, val3) {
                  parseAttribute(value, name, val, val2, val3);
                  return '';
                });
              } else {
                attrList = [];
                attrList.map = {};
              }
              if (validate && !isInternalElement) {
                attributesRequired = elementRule.attributesRequired;
                attributesDefault = elementRule.attributesDefault;
                attributesForced = elementRule.attributesForced;
                anyAttributesRequired = elementRule.removeEmptyAttrs;
                if (anyAttributesRequired && !attrList.length) {
                  isValidElement = false;
                }
                if (attributesForced) {
                  i = attributesForced.length;
                  while (i--) {
                    attr = attributesForced[i];
                    name = attr.name;
                    attrValue = attr.value;
                    if (attrValue === '{$uid}') {
                      attrValue = 'mce_' + idCount++;
                    }
                    attrList.map[name] = attrValue;
                    attrList.push({
                      name: name,
                      value: attrValue
                    });
                  }
                }
                if (attributesDefault) {
                  i = attributesDefault.length;
                  while (i--) {
                    attr = attributesDefault[i];
                    name = attr.name;
                    if (!(name in attrList.map)) {
                      attrValue = attr.value;
                      if (attrValue === '{$uid}') {
                        attrValue = 'mce_' + idCount++;
                      }
                      attrList.map[name] = attrValue;
                      attrList.push({
                        name: name,
                        value: attrValue
                      });
                    }
                  }
                }
                if (attributesRequired) {
                  i = attributesRequired.length;
                  while (i--) {
                    if (attributesRequired[i] in attrList.map) {
                      break;
                    }
                  }
                  if (i === -1) {
                    isValidElement = false;
                  }
                }
                if (attr = attrList.map['data-mce-bogus']) {
                  if (attr === 'all') {
                    index = findMatchingEndTagIndex(schema, html, tokenRegExp.lastIndex);
                    tokenRegExp.lastIndex = index;
                    continue;
                  }
                  isValidElement = false;
                }
              }
              if (isValidElement) {
                start(value, attrList, isShortEnded);
              }
            } else {
              isValidElement = false;
            }
            if (endRegExp = specialElements[value]) {
              endRegExp.lastIndex = index = matches.index + matchText.length;
              if (matches = endRegExp.exec(html)) {
                if (isValidElement) {
                  textData = html.substr(index, matches.index - index);
                }
                index = matches.index + matches[0].length;
              } else {
                textData = html.substr(index);
                index = html.length;
              }
              if (isValidElement) {
                if (textData.length > 0) {
                  processText(textData, true);
                }
                end(value);
              }
              tokenRegExp.lastIndex = index;
              continue;
            }
            if (!isShortEnded) {
              if (!attribsValue || attribsValue.indexOf('/') !== attribsValue.length - 1) {
                stack.push({
                  name: value,
                  valid: isValidElement
                });
              } else if (isValidElement) {
                end(value);
              }
            }
          } else if (value = matches[1]) {
            processComment(value);
          } else if (value = matches[2]) {
            var isValidCdataSection = parsingMode === 1 || settings.preserve_cdata || stack.length > 0 && schema.isValidChild(stack[stack.length - 1].name, '#cdata');
            if (isValidCdataSection) {
              cdata(value);
            } else {
              index = processMalformedComment('', matches.index + 2);
              tokenRegExp.lastIndex = index;
              continue;
            }
          } else if (value = matches[3]) {
            doctype(value);
          } else if ((value = matches[4]) || matchText === '<!') {
            index = processMalformedComment(value, matches.index + matchText.length);
            tokenRegExp.lastIndex = index;
            continue;
          } else if (value = matches[5]) {
            if (parsingMode === 1) {
              pi(value, matches[6]);
            } else {
              index = processMalformedComment('?', matches.index + 2);
              tokenRegExp.lastIndex = index;
              continue;
            }
          }
          index = matches.index + matchText.length;
        }
        if (index < html.length) {
          processText(decode(html.substr(index)));
        }
        for (i = stack.length - 1; i >= 0; i--) {
          value = stack[i];
          if (value.valid) {
            end(value.name);
          }
        }
      };
      var parse = function (html, format) {
        if (format === void 0) {
          format = 'html';
        }
        parseInternal(extractBase64DataUris(html), format);
      };
      return { parse: parse };
    };
    SaxParser.findEndTag = findMatchingEndTagIndex;

    var trimHtml = function (tempAttrs, html) {
      var trimContentRegExp = new RegExp(['\\s?(' + tempAttrs.join('|') + ')="[^"]+"'].join('|'), 'gi');
      return html.replace(trimContentRegExp, '');
    };
    var trimInternal = function (serializer, html) {
      var bogusAllRegExp = /<(\w+) [^>]*data-mce-bogus="all"[^>]*>/g;
      var schema = serializer.schema;
      var content = trimHtml(serializer.getTempAttrs(), html);
      var shortEndedElements = schema.getShortEndedElements();
      var matches;
      while (matches = bogusAllRegExp.exec(content)) {
        var index = bogusAllRegExp.lastIndex;
        var matchLength = matches[0].length;
        var endTagIndex = void 0;
        if (shortEndedElements[matches[1]]) {
          endTagIndex = index;
        } else {
          endTagIndex = SaxParser.findEndTag(schema, content, index);
        }
        content = content.substring(0, index - matchLength) + content.substring(endTagIndex);
        bogusAllRegExp.lastIndex = index - matchLength;
      }
      return trim$2(content);
    };
    var trimExternal = trimInternal;

    var trimEmptyContents = function (editor, html) {
      var blockName = getForcedRootBlock(editor);
      var emptyRegExp = new RegExp('^(<' + blockName + '[^>]*>(&nbsp;|&#160;|\\s|\xA0|<br \\/>|)<\\/' + blockName + '>[\r\n]*|<br \\/>[\r\n]*)$');
      return html.replace(emptyRegExp, '');
    };
    var setupArgs$3 = function (args, format) {
      return __assign(__assign({}, args), {
        format: format,
        get: true,
        getInner: true
      });
    };
    var getContentFromBody = function (editor, args, format, body) {
      var defaultedArgs = setupArgs$3(args, format);
      var updatedArgs = args.no_events ? defaultedArgs : editor.fire('BeforeGetContent', defaultedArgs);
      var content;
      if (updatedArgs.format === 'raw') {
        content = Tools.trim(trimExternal(editor.serializer, body.innerHTML));
      } else if (updatedArgs.format === 'text') {
        content = editor.dom.isEmpty(body) ? '' : trim$2(body.innerText || body.textContent);
      } else if (updatedArgs.format === 'tree') {
        content = editor.serializer.serialize(body, updatedArgs);
      } else {
        content = trimEmptyContents(editor, editor.serializer.serialize(body, updatedArgs));
      }
      if (!contains$3([
          'text',
          'tree'
        ], updatedArgs.format) && !isWsPreserveElement(SugarElement.fromDom(body))) {
        updatedArgs.content = Tools.trim(content);
      } else {
        updatedArgs.content = content;
      }
      if (updatedArgs.no_events) {
        return updatedArgs.content;
      } else {
        return editor.fire('GetContent', updatedArgs).content;
      }
    };
    var getContentInternal = function (editor, args, format) {
      return Optional.from(editor.getBody()).fold(constant(args.format === 'tree' ? new AstNode('body', 11) : ''), function (body) {
        return getContentFromBody(editor, args, format, body);
      });
    };

    var each$c = Tools.each;
    var ElementUtils = function (dom) {
      var compare = function (node1, node2) {
        if (node1.nodeName !== node2.nodeName) {
          return false;
        }
        var getAttribs = function (node) {
          var attribs = {};
          each$c(dom.getAttribs(node), function (attr) {
            var name = attr.nodeName.toLowerCase();
            if (name.indexOf('_') !== 0 && name !== 'style' && name.indexOf('data-') !== 0) {
              attribs[name] = dom.getAttrib(node, name);
            }
          });
          return attribs;
        };
        var compareObjects = function (obj1, obj2) {
          var value, name;
          for (name in obj1) {
            if (has$2(obj1, name)) {
              value = obj2[name];
              if (typeof value === 'undefined') {
                return false;
              }
              if (obj1[name] !== value) {
                return false;
              }
              delete obj2[name];
            }
          }
          for (name in obj2) {
            if (has$2(obj2, name)) {
              return false;
            }
          }
          return true;
        };
        if (!compareObjects(getAttribs(node1), getAttribs(node2))) {
          return false;
        }
        if (!compareObjects(dom.parseStyle(dom.getAttrib(node1, 'style')), dom.parseStyle(dom.getAttrib(node2, 'style')))) {
          return false;
        }
        return !isBookmarkNode$1(node1) && !isBookmarkNode$1(node2);
      };
      return { compare: compare };
    };

    var makeMap$1 = Tools.makeMap;
    var Writer = function (settings) {
      var html = [];
      settings = settings || {};
      var indent = settings.indent;
      var indentBefore = makeMap$1(settings.indent_before || '');
      var indentAfter = makeMap$1(settings.indent_after || '');
      var encode = Entities.getEncodeFunc(settings.entity_encoding || 'raw', settings.entities);
      var htmlOutput = settings.element_format === 'html';
      return {
        start: function (name, attrs, empty) {
          var i, l, attr, value;
          if (indent && indentBefore[name] && html.length > 0) {
            value = html[html.length - 1];
            if (value.length > 0 && value !== '\n') {
              html.push('\n');
            }
          }
          html.push('<', name);
          if (attrs) {
            for (i = 0, l = attrs.length; i < l; i++) {
              attr = attrs[i];
              html.push(' ', attr.name, '="', encode(attr.value, true), '"');
            }
          }
          if (!empty || htmlOutput) {
            html[html.length] = '>';
          } else {
            html[html.length] = ' />';
          }
          if (empty && indent && indentAfter[name] && html.length > 0) {
            value = html[html.length - 1];
            if (value.length > 0 && value !== '\n') {
              html.push('\n');
            }
          }
        },
        end: function (name) {
          var value;
          html.push('</', name, '>');
          if (indent && indentAfter[name] && html.length > 0) {
            value = html[html.length - 1];
            if (value.length > 0 && value !== '\n') {
              html.push('\n');
            }
          }
        },
        text: function (text, raw) {
          if (text.length > 0) {
            html[html.length] = raw ? text : encode(text);
          }
        },
        cdata: function (text) {
          html.push('<![CDATA[', text, ']]>');
        },
        comment: function (text) {
          html.push('<!--', text, '-->');
        },
        pi: function (name, text) {
          if (text) {
            html.push('<?', name, ' ', encode(text), '?>');
          } else {
            html.push('<?', name, '?>');
          }
          if (indent) {
            html.push('\n');
          }
        },
        doctype: function (text) {
          html.push('<!DOCTYPE', text, '>', indent ? '\n' : '');
        },
        reset: function () {
          html.length = 0;
        },
        getContent: function () {
          return html.join('').replace(/\n$/, '');
        }
      };
    };

    var HtmlSerializer = function (settings, schema) {
      if (schema === void 0) {
        schema = Schema();
      }
      var writer = Writer(settings);
      settings = settings || {};
      settings.validate = 'validate' in settings ? settings.validate : true;
      var serialize = function (node) {
        var validate = settings.validate;
        var handlers = {
          3: function (node) {
            writer.text(node.value, node.raw);
          },
          8: function (node) {
            writer.comment(node.value);
          },
          7: function (node) {
            writer.pi(node.name, node.value);
          },
          10: function (node) {
            writer.doctype(node.value);
          },
          4: function (node) {
            writer.cdata(node.value);
          },
          11: function (node) {
            if (node = node.firstChild) {
              do {
                walk(node);
              } while (node = node.next);
            }
          }
        };
        writer.reset();
        var walk = function (node) {
          var handler = handlers[node.type];
          if (!handler) {
            var name_1 = node.name;
            var isEmpty = node.shortEnded;
            var attrs = node.attributes;
            if (validate && attrs && attrs.length > 1) {
              var sortedAttrs = [];
              sortedAttrs.map = {};
              var elementRule = schema.getElementRule(node.name);
              if (elementRule) {
                for (var i = 0, l = elementRule.attributesOrder.length; i < l; i++) {
                  var attrName = elementRule.attributesOrder[i];
                  if (attrName in attrs.map) {
                    var attrValue = attrs.map[attrName];
                    sortedAttrs.map[attrName] = attrValue;
                    sortedAttrs.push({
                      name: attrName,
                      value: attrValue
                    });
                  }
                }
                for (var i = 0, l = attrs.length; i < l; i++) {
                  var attrName = attrs[i].name;
                  if (!(attrName in sortedAttrs.map)) {
                    var attrValue = attrs.map[attrName];
                    sortedAttrs.map[attrName] = attrValue;
                    sortedAttrs.push({
                      name: attrName,
                      value: attrValue
                    });
                  }
                }
                attrs = sortedAttrs;
              }
            }
            writer.start(node.name, attrs, isEmpty);
            if (!isEmpty) {
              if (node = node.firstChild) {
                do {
                  walk(node);
                } while (node = node.next);
              }
              writer.end(name_1);
            }
          } else {
            handler(node);
          }
        };
        if (node.type === 1 && !settings.inner) {
          walk(node);
        } else {
          handlers[11](node);
        }
        return writer.getContent();
      };
      return { serialize: serialize };
    };

    var nonInheritableStyles = new Set();
    (function () {
      var nonInheritableStylesArr = [
        'margin',
        'margin-left',
        'margin-right',
        'margin-top',
        'margin-bottom',
        'padding',
        'padding-left',
        'padding-right',
        'padding-top',
        'padding-bottom',
        'border',
        'border-width',
        'border-style',
        'border-color',
        'background',
        'background-attachment',
        'background-clip',
        'background-color',
        'background-image',
        'background-origin',
        'background-position',
        'background-repeat',
        'background-size',
        'float',
        'position',
        'left',
        'right',
        'top',
        'bottom',
        'z-index',
        'display',
        'transform',
        'width',
        'max-width',
        'min-width',
        'height',
        'max-height',
        'min-height',
        'overflow',
        'overflow-x',
        'overflow-y',
        'text-overflow',
        'vertical-align',
        'transition',
        'transition-delay',
        'transition-duration',
        'transition-property',
        'transition-timing-function'
      ];
      each$k(nonInheritableStylesArr, function (style) {
        nonInheritableStyles.add(style);
      });
    }());
    var shorthandStyleProps = [
      'font',
      'text-decoration',
      'text-emphasis'
    ];
    var getStyleProps = function (dom, node) {
      return keys(dom.parseStyle(dom.getAttrib(node, 'style')));
    };
    var isNonInheritableStyle = function (style) {
      return nonInheritableStyles.has(style);
    };
    var hasInheritableStyles = function (dom, node) {
      return forall(getStyleProps(dom, node), function (style) {
        return !isNonInheritableStyle(style);
      });
    };
    var getLonghandStyleProps = function (styles) {
      return filter$4(styles, function (style) {
        return exists(shorthandStyleProps, function (prop) {
          return startsWith(style, prop);
        });
      });
    };
    var hasStyleConflict = function (dom, node, parentNode) {
      var nodeStyleProps = getStyleProps(dom, node);
      var parentNodeStyleProps = getStyleProps(dom, parentNode);
      var valueMismatch = function (prop) {
        var nodeValue = dom.getStyle(node, prop);
        var parentValue = dom.getStyle(parentNode, prop);
        return isNotEmpty(nodeValue) && isNotEmpty(parentValue) && nodeValue !== parentValue;
      };
      return exists(nodeStyleProps, function (nodeStyleProp) {
        var propExists = function (props) {
          return exists(props, function (prop) {
            return prop === nodeStyleProp;
          });
        };
        if (!propExists(parentNodeStyleProps) && propExists(shorthandStyleProps)) {
          var longhandProps = getLonghandStyleProps(parentNodeStyleProps);
          return exists(longhandProps, valueMismatch);
        } else {
          return valueMismatch(nodeStyleProp);
        }
      });
    };

    var isChar = function (forward, predicate, pos) {
      return Optional.from(pos.container()).filter(isText$7).exists(function (text) {
        var delta = forward ? 0 : -1;
        return predicate(text.data.charAt(pos.offset() + delta));
      });
    };
    var isBeforeSpace = curry(isChar, true, isWhiteSpace);
    var isAfterSpace = curry(isChar, false, isWhiteSpace);
    var isEmptyText = function (pos) {
      var container = pos.container();
      return isText$7(container) && (container.data.length === 0 || isZwsp(container.data) && BookmarkManager.isBookmarkNode(container.parentNode));
    };
    var matchesElementPosition = function (before, predicate) {
      return function (pos) {
        return Optional.from(getChildNodeAtRelativeOffset(before ? 0 : -1, pos)).filter(predicate).isSome();
      };
    };
    var isImageBlock = function (node) {
      return isImg(node) && get$5(SugarElement.fromDom(node), 'display') === 'block';
    };
    var isCefNode = function (node) {
      return isContentEditableFalse$b(node) && !isBogusAll$1(node);
    };
    var isBeforeImageBlock = matchesElementPosition(true, isImageBlock);
    var isAfterImageBlock = matchesElementPosition(false, isImageBlock);
    var isBeforeMedia = matchesElementPosition(true, isMedia$2);
    var isAfterMedia = matchesElementPosition(false, isMedia$2);
    var isBeforeTable = matchesElementPosition(true, isTable$3);
    var isAfterTable = matchesElementPosition(false, isTable$3);
    var isBeforeContentEditableFalse = matchesElementPosition(true, isCefNode);
    var isAfterContentEditableFalse = matchesElementPosition(false, isCefNode);

    var getLastChildren = function (elm) {
      var children = [];
      var rawNode = elm.dom;
      while (rawNode) {
        children.push(SugarElement.fromDom(rawNode));
        rawNode = rawNode.lastChild;
      }
      return children;
    };
    var removeTrailingBr = function (elm) {
      var allBrs = descendants(elm, 'br');
      var brs = filter$4(getLastChildren(elm).slice(-1), isBr$4);
      if (allBrs.length === brs.length) {
        each$k(brs, remove$7);
      }
    };
    var fillWithPaddingBr = function (elm) {
      empty(elm);
      append$1(elm, SugarElement.fromHtml('<br data-mce-bogus="1">'));
    };
    var trimBlockTrailingBr = function (elm) {
      lastChild(elm).each(function (lastChild) {
        prevSibling(lastChild).each(function (lastChildPrevSibling) {
          if (isBlock$2(elm) && isBr$4(lastChild) && isBlock$2(lastChildPrevSibling)) {
            remove$7(lastChild);
          }
        });
      });
    };

    var dropLast = function (xs) {
      return xs.slice(0, -1);
    };
    var parentsUntil = function (start, root, predicate) {
      if (contains$1(root, start)) {
        return dropLast(parents$1(start, function (elm) {
          return predicate(elm) || eq(elm, root);
        }));
      } else {
        return [];
      }
    };
    var parents = function (start, root) {
      return parentsUntil(start, root, never);
    };
    var parentsAndSelf = function (start, root) {
      return [start].concat(parents(start, root));
    };

    var navigateIgnoreEmptyTextNodes = function (forward, root, from) {
      return navigateIgnore(forward, root, from, isEmptyText);
    };
    var getClosestBlock$1 = function (root, pos) {
      return find$3(parentsAndSelf(SugarElement.fromDom(pos.container()), root), isBlock$2);
    };
    var isAtBeforeAfterBlockBoundary = function (forward, root, pos) {
      return navigateIgnoreEmptyTextNodes(forward, root.dom, pos).forall(function (newPos) {
        return getClosestBlock$1(root, pos).fold(function () {
          return isInSameBlock(newPos, pos, root.dom) === false;
        }, function (fromBlock) {
          return isInSameBlock(newPos, pos, root.dom) === false && contains$1(fromBlock, SugarElement.fromDom(newPos.container()));
        });
      });
    };
    var isAtBlockBoundary = function (forward, root, pos) {
      return getClosestBlock$1(root, pos).fold(function () {
        return navigateIgnoreEmptyTextNodes(forward, root.dom, pos).forall(function (newPos) {
          return isInSameBlock(newPos, pos, root.dom) === false;
        });
      }, function (parent) {
        return navigateIgnoreEmptyTextNodes(forward, parent.dom, pos).isNone();
      });
    };
    var isAtStartOfBlock = curry(isAtBlockBoundary, false);
    var isAtEndOfBlock = curry(isAtBlockBoundary, true);
    var isBeforeBlock = curry(isAtBeforeAfterBlockBoundary, false);
    var isAfterBlock = curry(isAtBeforeAfterBlockBoundary, true);

    var isBr = function (pos) {
      return getElementFromPosition(pos).exists(isBr$4);
    };
    var findBr = function (forward, root, pos) {
      var parentBlocks = filter$4(parentsAndSelf(SugarElement.fromDom(pos.container()), root), isBlock$2);
      var scope = head(parentBlocks).getOr(root);
      return fromPosition(forward, scope.dom, pos).filter(isBr);
    };
    var isBeforeBr$1 = function (root, pos) {
      return getElementFromPosition(pos).exists(isBr$4) || findBr(true, root, pos).isSome();
    };
    var isAfterBr = function (root, pos) {
      return getElementFromPrevPosition(pos).exists(isBr$4) || findBr(false, root, pos).isSome();
    };
    var findPreviousBr = curry(findBr, false);
    var findNextBr = curry(findBr, true);

    var isInMiddleOfText = function (pos) {
      return CaretPosition.isTextPosition(pos) && !pos.isAtStart() && !pos.isAtEnd();
    };
    var getClosestBlock = function (root, pos) {
      var parentBlocks = filter$4(parentsAndSelf(SugarElement.fromDom(pos.container()), root), isBlock$2);
      return head(parentBlocks).getOr(root);
    };
    var hasSpaceBefore = function (root, pos) {
      if (isInMiddleOfText(pos)) {
        return isAfterSpace(pos);
      } else {
        return isAfterSpace(pos) || prevPosition(getClosestBlock(root, pos).dom, pos).exists(isAfterSpace);
      }
    };
    var hasSpaceAfter = function (root, pos) {
      if (isInMiddleOfText(pos)) {
        return isBeforeSpace(pos);
      } else {
        return isBeforeSpace(pos) || nextPosition(getClosestBlock(root, pos).dom, pos).exists(isBeforeSpace);
      }
    };
    var isPreValue = function (value) {
      return contains$3([
        'pre',
        'pre-wrap'
      ], value);
    };
    var isInPre = function (pos) {
      return getElementFromPosition(pos).bind(function (elm) {
        return closest$3(elm, isElement$6);
      }).exists(function (elm) {
        return isPreValue(get$5(elm, 'white-space'));
      });
    };
    var isAtBeginningOfBody = function (root, pos) {
      return prevPosition(root.dom, pos).isNone();
    };
    var isAtEndOfBody = function (root, pos) {
      return nextPosition(root.dom, pos).isNone();
    };
    var isAtLineBoundary = function (root, pos) {
      return isAtBeginningOfBody(root, pos) || isAtEndOfBody(root, pos) || isAtStartOfBlock(root, pos) || isAtEndOfBlock(root, pos) || isAfterBr(root, pos) || isBeforeBr$1(root, pos);
    };
    var needsToHaveNbsp = function (root, pos) {
      if (isInPre(pos)) {
        return false;
      } else {
        return isAtLineBoundary(root, pos) || hasSpaceBefore(root, pos) || hasSpaceAfter(root, pos);
      }
    };
    var needsToBeNbspLeft = function (root, pos) {
      if (isInPre(pos)) {
        return false;
      } else {
        return isAtStartOfBlock(root, pos) || isBeforeBlock(root, pos) || isAfterBr(root, pos) || hasSpaceBefore(root, pos);
      }
    };
    var leanRight = function (pos) {
      var container = pos.container();
      var offset = pos.offset();
      if (isText$7(container) && offset < container.data.length) {
        return CaretPosition(container, offset + 1);
      } else {
        return pos;
      }
    };
    var needsToBeNbspRight = function (root, pos) {
      if (isInPre(pos)) {
        return false;
      } else {
        return isAtEndOfBlock(root, pos) || isAfterBlock(root, pos) || isBeforeBr$1(root, pos) || hasSpaceAfter(root, pos);
      }
    };
    var needsToBeNbsp = function (root, pos) {
      return needsToBeNbspLeft(root, pos) || needsToBeNbspRight(root, leanRight(pos));
    };
    var isNbspAt = function (text, offset) {
      return isNbsp(text.charAt(offset));
    };
    var hasNbsp = function (pos) {
      var container = pos.container();
      return isText$7(container) && contains$2(container.data, nbsp);
    };
    var normalizeNbspMiddle = function (text) {
      var chars = text.split('');
      return map$3(chars, function (chr, i) {
        if (isNbsp(chr) && i > 0 && i < chars.length - 1 && isContent(chars[i - 1]) && isContent(chars[i + 1])) {
          return ' ';
        } else {
          return chr;
        }
      }).join('');
    };
    var normalizeNbspAtStart = function (root, node) {
      var text = node.data;
      var firstPos = CaretPosition(node, 0);
      if (isNbspAt(text, 0) && !needsToBeNbsp(root, firstPos)) {
        node.data = ' ' + text.slice(1);
        return true;
      } else {
        return false;
      }
    };
    var normalizeNbspInMiddleOfTextNode = function (node) {
      var text = node.data;
      var newText = normalizeNbspMiddle(text);
      if (newText !== text) {
        node.data = newText;
        return true;
      } else {
        return false;
      }
    };
    var normalizeNbspAtEnd = function (root, node) {
      var text = node.data;
      var lastPos = CaretPosition(node, text.length - 1);
      if (isNbspAt(text, text.length - 1) && !needsToBeNbsp(root, lastPos)) {
        node.data = text.slice(0, -1) + ' ';
        return true;
      } else {
        return false;
      }
    };
    var normalizeNbsps = function (root, pos) {
      return Optional.some(pos).filter(hasNbsp).bind(function (pos) {
        var container = pos.container();
        var normalized = normalizeNbspAtStart(root, container) || normalizeNbspInMiddleOfTextNode(container) || normalizeNbspAtEnd(root, container);
        return normalized ? Optional.some(pos) : Optional.none();
      });
    };
    var normalizeNbspsInEditor = function (editor) {
      var root = SugarElement.fromDom(editor.getBody());
      if (editor.selection.isCollapsed()) {
        normalizeNbsps(root, CaretPosition.fromRangeStart(editor.selection.getRng())).each(function (pos) {
          editor.selection.setRng(pos.toRange());
        });
      }
    };

    var normalizeContent = function (content, isStartOfContent, isEndOfContent) {
      var result = foldl(content, function (acc, c) {
        if (isWhiteSpace(c) || isNbsp(c)) {
          if (acc.previousCharIsSpace || acc.str === '' && isStartOfContent || acc.str.length === content.length - 1 && isEndOfContent) {
            return {
              previousCharIsSpace: false,
              str: acc.str + nbsp
            };
          } else {
            return {
              previousCharIsSpace: true,
              str: acc.str + ' '
            };
          }
        } else {
          return {
            previousCharIsSpace: false,
            str: acc.str + c
          };
        }
      }, {
        previousCharIsSpace: false,
        str: ''
      });
      return result.str;
    };
    var normalize$1 = function (node, offset, count) {
      if (count === 0) {
        return;
      }
      var elm = SugarElement.fromDom(node);
      var root = ancestor$3(elm, isBlock$2).getOr(elm);
      var whitespace = node.data.slice(offset, offset + count);
      var isEndOfContent = offset + count >= node.data.length && needsToBeNbspRight(root, CaretPosition(node, node.data.length));
      var isStartOfContent = offset === 0 && needsToBeNbspLeft(root, CaretPosition(node, 0));
      node.replaceData(offset, count, normalizeContent(whitespace, isStartOfContent, isEndOfContent));
    };
    var normalizeWhitespaceAfter = function (node, offset) {
      var content = node.data.slice(offset);
      var whitespaceCount = content.length - lTrim(content).length;
      normalize$1(node, offset, whitespaceCount);
    };
    var normalizeWhitespaceBefore = function (node, offset) {
      var content = node.data.slice(0, offset);
      var whitespaceCount = content.length - rTrim(content).length;
      normalize$1(node, offset - whitespaceCount, whitespaceCount);
    };
    var mergeTextNodes = function (prevNode, nextNode, normalizeWhitespace, mergeToPrev) {
      if (mergeToPrev === void 0) {
        mergeToPrev = true;
      }
      var whitespaceOffset = rTrim(prevNode.data).length;
      var newNode = mergeToPrev ? prevNode : nextNode;
      var removeNode = mergeToPrev ? nextNode : prevNode;
      if (mergeToPrev) {
        newNode.appendData(removeNode.data);
      } else {
        newNode.insertData(0, removeNode.data);
      }
      remove$7(SugarElement.fromDom(removeNode));
      if (normalizeWhitespace) {
        normalizeWhitespaceAfter(newNode, whitespaceOffset);
      }
      return newNode;
    };

    var needsReposition = function (pos, elm) {
      var container = pos.container();
      var offset = pos.offset();
      return CaretPosition.isTextPosition(pos) === false && container === elm.parentNode && offset > CaretPosition.before(elm).offset();
    };
    var reposition = function (elm, pos) {
      return needsReposition(pos, elm) ? CaretPosition(pos.container(), pos.offset() - 1) : pos;
    };
    var beforeOrStartOf = function (node) {
      return isText$7(node) ? CaretPosition(node, 0) : CaretPosition.before(node);
    };
    var afterOrEndOf = function (node) {
      return isText$7(node) ? CaretPosition(node, node.data.length) : CaretPosition.after(node);
    };
    var getPreviousSiblingCaretPosition = function (elm) {
      if (isCaretCandidate$3(elm.previousSibling)) {
        return Optional.some(afterOrEndOf(elm.previousSibling));
      } else {
        return elm.previousSibling ? lastPositionIn(elm.previousSibling) : Optional.none();
      }
    };
    var getNextSiblingCaretPosition = function (elm) {
      if (isCaretCandidate$3(elm.nextSibling)) {
        return Optional.some(beforeOrStartOf(elm.nextSibling));
      } else {
        return elm.nextSibling ? firstPositionIn(elm.nextSibling) : Optional.none();
      }
    };
    var findCaretPositionBackwardsFromElm = function (rootElement, elm) {
      var startPosition = CaretPosition.before(elm.previousSibling ? elm.previousSibling : elm.parentNode);
      return prevPosition(rootElement, startPosition).fold(function () {
        return nextPosition(rootElement, CaretPosition.after(elm));
      }, Optional.some);
    };
    var findCaretPositionForwardsFromElm = function (rootElement, elm) {
      return nextPosition(rootElement, CaretPosition.after(elm)).fold(function () {
        return prevPosition(rootElement, CaretPosition.before(elm));
      }, Optional.some);
    };
    var findCaretPositionBackwards = function (rootElement, elm) {
      return getPreviousSiblingCaretPosition(elm).orThunk(function () {
        return getNextSiblingCaretPosition(elm);
      }).orThunk(function () {
        return findCaretPositionBackwardsFromElm(rootElement, elm);
      });
    };
    var findCaretPositionForward = function (rootElement, elm) {
      return getNextSiblingCaretPosition(elm).orThunk(function () {
        return getPreviousSiblingCaretPosition(elm);
      }).orThunk(function () {
        return findCaretPositionForwardsFromElm(rootElement, elm);
      });
    };
    var findCaretPosition = function (forward, rootElement, elm) {
      return forward ? findCaretPositionForward(rootElement, elm) : findCaretPositionBackwards(rootElement, elm);
    };
    var findCaretPosOutsideElmAfterDelete = function (forward, rootElement, elm) {
      return findCaretPosition(forward, rootElement, elm).map(curry(reposition, elm));
    };
    var setSelection$1 = function (editor, forward, pos) {
      pos.fold(function () {
        editor.focus();
      }, function (pos) {
        editor.selection.setRng(pos.toRange(), forward);
      });
    };
    var eqRawNode = function (rawNode) {
      return function (elm) {
        return elm.dom === rawNode;
      };
    };
    var isBlock = function (editor, elm) {
      return elm && has$2(editor.schema.getBlockElements(), name(elm));
    };
    var paddEmptyBlock = function (elm) {
      if (isEmpty$2(elm)) {
        var br = SugarElement.fromHtml('<br data-mce-bogus="1">');
        empty(elm);
        append$1(elm, br);
        return Optional.some(CaretPosition.before(br.dom));
      } else {
        return Optional.none();
      }
    };
    var deleteNormalized = function (elm, afterDeletePosOpt, normalizeWhitespace) {
      var prevTextOpt = prevSibling(elm).filter(isText$8);
      var nextTextOpt = nextSibling(elm).filter(isText$8);
      remove$7(elm);
      return lift3(prevTextOpt, nextTextOpt, afterDeletePosOpt, function (prev, next, pos) {
        var prevNode = prev.dom, nextNode = next.dom;
        var offset = prevNode.data.length;
        mergeTextNodes(prevNode, nextNode, normalizeWhitespace);
        return pos.container() === nextNode ? CaretPosition(prevNode, offset) : pos;
      }).orThunk(function () {
        if (normalizeWhitespace) {
          prevTextOpt.each(function (elm) {
            return normalizeWhitespaceBefore(elm.dom, elm.dom.length);
          });
          nextTextOpt.each(function (elm) {
            return normalizeWhitespaceAfter(elm.dom, 0);
          });
        }
        return afterDeletePosOpt;
      });
    };
    var isInlineElement = function (editor, element) {
      return has$2(editor.schema.getTextInlineElements(), name(element));
    };
    var deleteElement$2 = function (editor, forward, elm, moveCaret) {
      if (moveCaret === void 0) {
        moveCaret = true;
      }
      var afterDeletePos = findCaretPosOutsideElmAfterDelete(forward, editor.getBody(), elm.dom);
      var parentBlock = ancestor$3(elm, curry(isBlock, editor), eqRawNode(editor.getBody()));
      var normalizedAfterDeletePos = deleteNormalized(elm, afterDeletePos, isInlineElement(editor, elm));
      if (editor.dom.isEmpty(editor.getBody())) {
        editor.setContent('');
        editor.selection.setCursorLocation();
      } else {
        parentBlock.bind(paddEmptyBlock).fold(function () {
          if (moveCaret) {
            setSelection$1(editor, forward, normalizedAfterDeletePos);
          }
        }, function (paddPos) {
          if (moveCaret) {
            setSelection$1(editor, forward, Optional.some(paddPos));
          }
        });
      }
    };

    var isRootFromElement = function (root) {
      return function (cur) {
        return eq(root, cur);
      };
    };
    var getTableCells = function (table) {
      return descendants(table, 'td,th');
    };
    var getTableDetailsFromRange = function (rng, isRoot) {
      var getTable = function (node) {
        return getClosestTable(SugarElement.fromDom(node), isRoot);
      };
      var startTable = getTable(rng.startContainer);
      var endTable = getTable(rng.endContainer);
      var isStartInTable = startTable.isSome();
      var isEndInTable = endTable.isSome();
      var isSameTable = lift2(startTable, endTable, eq).getOr(false);
      var isMultiTable = !isSameTable && isStartInTable && isEndInTable;
      return {
        startTable: startTable,
        endTable: endTable,
        isStartInTable: isStartInTable,
        isEndInTable: isEndInTable,
        isSameTable: isSameTable,
        isMultiTable: isMultiTable
      };
    };

    var tableCellRng = function (start, end) {
      return {
        start: start,
        end: end
      };
    };
    var tableSelection = function (rng, table, cells) {
      return {
        rng: rng,
        table: table,
        cells: cells
      };
    };
    var deleteAction = Adt.generate([
      {
        singleCellTable: [
          'rng',
          'cell'
        ]
      },
      { fullTable: ['table'] },
      {
        partialTable: [
          'cells',
          'outsideDetails'
        ]
      },
      {
        multiTable: [
          'startTableCells',
          'endTableCells',
          'betweenRng'
        ]
      }
    ]);
    var getClosestCell$1 = function (container, isRoot) {
      return closest$2(SugarElement.fromDom(container), 'td,th', isRoot);
    };
    var isExpandedCellRng = function (cellRng) {
      return !eq(cellRng.start, cellRng.end);
    };
    var getTableFromCellRng = function (cellRng, isRoot) {
      return getClosestTable(cellRng.start, isRoot).bind(function (startParentTable) {
        return getClosestTable(cellRng.end, isRoot).bind(function (endParentTable) {
          return someIf(eq(startParentTable, endParentTable), startParentTable);
        });
      });
    };
    var isSingleCellTable = function (cellRng, isRoot) {
      return !isExpandedCellRng(cellRng) && getTableFromCellRng(cellRng, isRoot).exists(function (table) {
        var rows = table.dom.rows;
        return rows.length === 1 && rows[0].cells.length === 1;
      });
    };
    var getCellRng = function (rng, isRoot) {
      var startCell = getClosestCell$1(rng.startContainer, isRoot);
      var endCell = getClosestCell$1(rng.endContainer, isRoot);
      return lift2(startCell, endCell, tableCellRng);
    };
    var getCellRangeFromStartTable = function (isRoot) {
      return function (startCell) {
        return getClosestTable(startCell, isRoot).bind(function (table) {
          return last$2(getTableCells(table)).map(function (endCell) {
            return tableCellRng(startCell, endCell);
          });
        });
      };
    };
    var getCellRangeFromEndTable = function (isRoot) {
      return function (endCell) {
        return getClosestTable(endCell, isRoot).bind(function (table) {
          return head(getTableCells(table)).map(function (startCell) {
            return tableCellRng(startCell, endCell);
          });
        });
      };
    };
    var getTableSelectionFromCellRng = function (isRoot) {
      return function (cellRng) {
        return getTableFromCellRng(cellRng, isRoot).map(function (table) {
          return tableSelection(cellRng, table, getTableCells(table));
        });
      };
    };
    var getTableSelections = function (cellRng, selectionDetails, rng, isRoot) {
      if (rng.collapsed || !cellRng.forall(isExpandedCellRng)) {
        return Optional.none();
      } else if (selectionDetails.isSameTable) {
        var sameTableSelection = cellRng.bind(getTableSelectionFromCellRng(isRoot));
        return Optional.some({
          start: sameTableSelection,
          end: sameTableSelection
        });
      } else {
        var startCell = getClosestCell$1(rng.startContainer, isRoot);
        var endCell = getClosestCell$1(rng.endContainer, isRoot);
        var startTableSelection = startCell.bind(getCellRangeFromStartTable(isRoot)).bind(getTableSelectionFromCellRng(isRoot));
        var endTableSelection = endCell.bind(getCellRangeFromEndTable(isRoot)).bind(getTableSelectionFromCellRng(isRoot));
        return Optional.some({
          start: startTableSelection,
          end: endTableSelection
        });
      }
    };
    var getCellIndex = function (cells, cell) {
      return findIndex$2(cells, function (x) {
        return eq(x, cell);
      });
    };
    var getSelectedCells = function (tableSelection) {
      return lift2(getCellIndex(tableSelection.cells, tableSelection.rng.start), getCellIndex(tableSelection.cells, tableSelection.rng.end), function (startIndex, endIndex) {
        return tableSelection.cells.slice(startIndex, endIndex + 1);
      });
    };
    var isSingleCellTableContentSelected = function (optCellRng, rng, isRoot) {
      return optCellRng.exists(function (cellRng) {
        return isSingleCellTable(cellRng, isRoot) && hasAllContentsSelected(cellRng.start, rng);
      });
    };
    var unselectCells = function (rng, selectionDetails) {
      var startTable = selectionDetails.startTable, endTable = selectionDetails.endTable;
      var otherContentRng = rng.cloneRange();
      startTable.each(function (table) {
        return otherContentRng.setStartAfter(table.dom);
      });
      endTable.each(function (table) {
        return otherContentRng.setEndBefore(table.dom);
      });
      return otherContentRng;
    };
    var handleSingleTable = function (cellRng, selectionDetails, rng, isRoot) {
      return getTableSelections(cellRng, selectionDetails, rng, isRoot).bind(function (_a) {
        var start = _a.start, end = _a.end;
        return start.or(end);
      }).bind(function (tableSelection) {
        var isSameTable = selectionDetails.isSameTable;
        var selectedCells = getSelectedCells(tableSelection).getOr([]);
        if (isSameTable && tableSelection.cells.length === selectedCells.length) {
          return Optional.some(deleteAction.fullTable(tableSelection.table));
        } else if (selectedCells.length > 0) {
          if (isSameTable) {
            return Optional.some(deleteAction.partialTable(selectedCells, Optional.none()));
          } else {
            var otherContentRng = unselectCells(rng, selectionDetails);
            return Optional.some(deleteAction.partialTable(selectedCells, Optional.some(__assign(__assign({}, selectionDetails), { rng: otherContentRng }))));
          }
        } else {
          return Optional.none();
        }
      });
    };
    var handleMultiTable = function (cellRng, selectionDetails, rng, isRoot) {
      return getTableSelections(cellRng, selectionDetails, rng, isRoot).bind(function (_a) {
        var start = _a.start, end = _a.end;
        var startTableSelectedCells = start.bind(getSelectedCells).getOr([]);
        var endTableSelectedCells = end.bind(getSelectedCells).getOr([]);
        if (startTableSelectedCells.length > 0 && endTableSelectedCells.length > 0) {
          var otherContentRng = unselectCells(rng, selectionDetails);
          return Optional.some(deleteAction.multiTable(startTableSelectedCells, endTableSelectedCells, otherContentRng));
        } else {
          return Optional.none();
        }
      });
    };
    var getActionFromRange = function (root, rng) {
      var isRoot = isRootFromElement(root);
      var optCellRng = getCellRng(rng, isRoot);
      var selectionDetails = getTableDetailsFromRange(rng, isRoot);
      if (isSingleCellTableContentSelected(optCellRng, rng, isRoot)) {
        return optCellRng.map(function (cellRng) {
          return deleteAction.singleCellTable(rng, cellRng.start);
        });
      } else if (selectionDetails.isMultiTable) {
        return handleMultiTable(optCellRng, selectionDetails, rng, isRoot);
      } else {
        return handleSingleTable(optCellRng, selectionDetails, rng, isRoot);
      }
    };

    var freefallRtl = function (root) {
      var child = isComment$1(root) ? prevSibling(root) : lastChild(root);
      return child.bind(freefallRtl).orThunk(function () {
        return Optional.some(root);
      });
    };
    var cleanCells = function (cells) {
      return each$k(cells, function (cell) {
        remove$6(cell, 'contenteditable');
        fillWithPaddingBr(cell);
      });
    };
    var getOutsideBlock = function (editor, container) {
      return Optional.from(editor.dom.getParent(container, editor.dom.isBlock)).map(SugarElement.fromDom);
    };
    var handleEmptyBlock = function (editor, startInTable, emptyBlock) {
      emptyBlock.each(function (block) {
        if (startInTable) {
          remove$7(block);
        } else {
          fillWithPaddingBr(block);
          editor.selection.setCursorLocation(block.dom, 0);
        }
      });
    };
    var deleteContentInsideCell = function (editor, cell, rng, isFirstCellInSelection) {
      var insideTableRng = rng.cloneRange();
      if (isFirstCellInSelection) {
        insideTableRng.setStart(rng.startContainer, rng.startOffset);
        insideTableRng.setEndAfter(cell.dom.lastChild);
      } else {
        insideTableRng.setStartBefore(cell.dom.firstChild);
        insideTableRng.setEnd(rng.endContainer, rng.endOffset);
      }
      deleteCellContents(editor, insideTableRng, cell, false);
    };
    var collapseAndRestoreCellSelection = function (editor) {
      var selectedCells = getCellsFromEditor(editor);
      var selectedNode = SugarElement.fromDom(editor.selection.getNode());
      if (isTableCell$5(selectedNode.dom) && isEmpty$2(selectedNode)) {
        editor.selection.setCursorLocation(selectedNode.dom, 0);
      } else {
        editor.selection.collapse(true);
      }
      if (selectedCells.length > 1 && exists(selectedCells, function (cell) {
          return eq(cell, selectedNode);
        })) {
        set$1(selectedNode, 'data-mce-selected', '1');
      }
    };
    var emptySingleTableCells = function (editor, cells, outsideDetails) {
      var editorRng = editor.selection.getRng();
      var cellsToClean = outsideDetails.bind(function (_a) {
        var rng = _a.rng, isStartInTable = _a.isStartInTable;
        var outsideBlock = getOutsideBlock(editor, isStartInTable ? rng.endContainer : rng.startContainer);
        rng.deleteContents();
        handleEmptyBlock(editor, isStartInTable, outsideBlock.filter(isEmpty$2));
        var endPointCell = isStartInTable ? cells[0] : cells[cells.length - 1];
        deleteContentInsideCell(editor, endPointCell, editorRng, isStartInTable);
        if (!isEmpty$2(endPointCell)) {
          return Optional.some(isStartInTable ? cells.slice(1) : cells.slice(0, -1));
        } else {
          return Optional.none();
        }
      }).getOr(cells);
      cleanCells(cellsToClean);
      collapseAndRestoreCellSelection(editor);
      return true;
    };
    var emptyMultiTableCells = function (editor, startTableCells, endTableCells, betweenRng) {
      var rng = editor.selection.getRng();
      var startCell = startTableCells[0];
      var endCell = endTableCells[endTableCells.length - 1];
      deleteContentInsideCell(editor, startCell, rng, true);
      deleteContentInsideCell(editor, endCell, rng, false);
      var startTableCellsToClean = isEmpty$2(startCell) ? startTableCells : startTableCells.slice(1);
      var endTableCellsToClean = isEmpty$2(endCell) ? endTableCells : endTableCells.slice(0, -1);
      cleanCells(startTableCellsToClean.concat(endTableCellsToClean));
      betweenRng.deleteContents();
      collapseAndRestoreCellSelection(editor);
      return true;
    };
    var deleteCellContents = function (editor, rng, cell, moveSelection) {
      if (moveSelection === void 0) {
        moveSelection = true;
      }
      rng.deleteContents();
      var lastNode = freefallRtl(cell).getOr(cell);
      var lastBlock = SugarElement.fromDom(editor.dom.getParent(lastNode.dom, editor.dom.isBlock));
      if (isEmpty$2(lastBlock)) {
        fillWithPaddingBr(lastBlock);
        if (moveSelection) {
          editor.selection.setCursorLocation(lastBlock.dom, 0);
        }
      }
      if (!eq(cell, lastBlock)) {
        var additionalCleanupNodes = is$1(parent(lastBlock), cell) ? [] : siblings(lastBlock);
        each$k(additionalCleanupNodes.concat(children(cell)), function (node) {
          if (!eq(node, lastBlock) && !contains$1(node, lastBlock) && isEmpty$2(node)) {
            remove$7(node);
          }
        });
      }
      return true;
    };
    var deleteTableElement = function (editor, table) {
      deleteElement$2(editor, false, table);
      return true;
    };
    var deleteCellRange = function (editor, rootElm, rng) {
      return getActionFromRange(rootElm, rng).map(function (action) {
        return action.fold(curry(deleteCellContents, editor), curry(deleteTableElement, editor), curry(emptySingleTableCells, editor), curry(emptyMultiTableCells, editor));
      });
    };
    var deleteCaptionRange = function (editor, caption) {
      return emptyElement(editor, caption);
    };
    var deleteTableRange = function (editor, rootElm, rng, startElm) {
      return getParentCaption(rootElm, startElm).fold(function () {
        return deleteCellRange(editor, rootElm, rng);
      }, function (caption) {
        return deleteCaptionRange(editor, caption);
      }).getOr(false);
    };
    var deleteRange$2 = function (editor, startElm, selectedCells) {
      var rootNode = SugarElement.fromDom(editor.getBody());
      var rng = editor.selection.getRng();
      return selectedCells.length !== 0 ? emptySingleTableCells(editor, selectedCells, Optional.none()) : deleteTableRange(editor, rootNode, rng, startElm);
    };
    var getParentCell = function (rootElm, elm) {
      return find$3(parentsAndSelf(elm, rootElm), isTableCell$4);
    };
    var getParentCaption = function (rootElm, elm) {
      return find$3(parentsAndSelf(elm, rootElm), isTag('caption'));
    };
    var deleteBetweenCells = function (editor, rootElm, forward, fromCell, from) {
      return navigate(forward, editor.getBody(), from).bind(function (to) {
        return getParentCell(rootElm, SugarElement.fromDom(to.getNode())).map(function (toCell) {
          return eq(toCell, fromCell) === false;
        });
      });
    };
    var emptyElement = function (editor, elm) {
      fillWithPaddingBr(elm);
      editor.selection.setCursorLocation(elm.dom, 0);
      return Optional.some(true);
    };
    var isDeleteOfLastCharPos = function (fromCaption, forward, from, to) {
      return firstPositionIn(fromCaption.dom).bind(function (first) {
        return lastPositionIn(fromCaption.dom).map(function (last) {
          return forward ? from.isEqual(first) && to.isEqual(last) : from.isEqual(last) && to.isEqual(first);
        });
      }).getOr(true);
    };
    var emptyCaretCaption = function (editor, elm) {
      return emptyElement(editor, elm);
    };
    var validateCaretCaption = function (rootElm, fromCaption, to) {
      return getParentCaption(rootElm, SugarElement.fromDom(to.getNode())).map(function (toCaption) {
        return eq(toCaption, fromCaption) === false;
      });
    };
    var deleteCaretInsideCaption = function (editor, rootElm, forward, fromCaption, from) {
      return navigate(forward, editor.getBody(), from).bind(function (to) {
        return isDeleteOfLastCharPos(fromCaption, forward, from, to) ? emptyCaretCaption(editor, fromCaption) : validateCaretCaption(rootElm, fromCaption, to);
      }).or(Optional.some(true));
    };
    var deleteCaretCells = function (editor, forward, rootElm, startElm) {
      var from = CaretPosition.fromRangeStart(editor.selection.getRng());
      return getParentCell(rootElm, startElm).bind(function (fromCell) {
        return isEmpty$2(fromCell) ? emptyElement(editor, fromCell) : deleteBetweenCells(editor, rootElm, forward, fromCell, from);
      }).getOr(false);
    };
    var deleteCaretCaption = function (editor, forward, rootElm, fromCaption) {
      var from = CaretPosition.fromRangeStart(editor.selection.getRng());
      return isEmpty$2(fromCaption) ? emptyElement(editor, fromCaption) : deleteCaretInsideCaption(editor, rootElm, forward, fromCaption, from);
    };
    var isNearTable = function (forward, pos) {
      return forward ? isBeforeTable(pos) : isAfterTable(pos);
    };
    var isBeforeOrAfterTable = function (editor, forward) {
      var fromPos = CaretPosition.fromRangeStart(editor.selection.getRng());
      return isNearTable(forward, fromPos) || fromPosition(forward, editor.getBody(), fromPos).exists(function (pos) {
        return isNearTable(forward, pos);
      });
    };
    var deleteCaret$3 = function (editor, forward, startElm) {
      var rootElm = SugarElement.fromDom(editor.getBody());
      return getParentCaption(rootElm, startElm).fold(function () {
        return deleteCaretCells(editor, forward, rootElm, startElm) || isBeforeOrAfterTable(editor, forward);
      }, function (fromCaption) {
        return deleteCaretCaption(editor, forward, rootElm, fromCaption).getOr(false);
      });
    };
    var backspaceDelete$9 = function (editor, forward) {
      var startElm = SugarElement.fromDom(editor.selection.getStart(true));
      var cells = getCellsFromEditor(editor);
      return editor.selection.isCollapsed() && cells.length === 0 ? deleteCaret$3(editor, forward, startElm) : deleteRange$2(editor, startElm, cells);
    };

    var createRange = function (sc, so, ec, eo) {
      var rng = document.createRange();
      rng.setStart(sc, so);
      rng.setEnd(ec, eo);
      return rng;
    };
    var normalizeBlockSelectionRange = function (rng) {
      var startPos = CaretPosition.fromRangeStart(rng);
      var endPos = CaretPosition.fromRangeEnd(rng);
      var rootNode = rng.commonAncestorContainer;
      return fromPosition(false, rootNode, endPos).map(function (newEndPos) {
        if (!isInSameBlock(startPos, endPos, rootNode) && isInSameBlock(startPos, newEndPos, rootNode)) {
          return createRange(startPos.container(), startPos.offset(), newEndPos.container(), newEndPos.offset());
        } else {
          return rng;
        }
      }).getOr(rng);
    };
    var normalize = function (rng) {
      return rng.collapsed ? rng : normalizeBlockSelectionRange(rng);
    };

    var hasOnlyOneChild$1 = function (node) {
      return node.firstChild && node.firstChild === node.lastChild;
    };
    var isPaddingNode = function (node) {
      return node.name === 'br' || node.value === nbsp;
    };
    var isPaddedEmptyBlock = function (schema, node) {
      var blockElements = schema.getBlockElements();
      return blockElements[node.name] && hasOnlyOneChild$1(node) && isPaddingNode(node.firstChild);
    };
    var isEmptyFragmentElement = function (schema, node) {
      var nonEmptyElements = schema.getNonEmptyElements();
      return node && (node.isEmpty(nonEmptyElements) || isPaddedEmptyBlock(schema, node));
    };
    var isListFragment = function (schema, fragment) {
      var firstChild = fragment.firstChild;
      var lastChild = fragment.lastChild;
      if (firstChild && firstChild.name === 'meta') {
        firstChild = firstChild.next;
      }
      if (lastChild && lastChild.attr('id') === 'mce_marker') {
        lastChild = lastChild.prev;
      }
      if (isEmptyFragmentElement(schema, lastChild)) {
        lastChild = lastChild.prev;
      }
      if (!firstChild || firstChild !== lastChild) {
        return false;
      }
      return firstChild.name === 'ul' || firstChild.name === 'ol';
    };
    var cleanupDomFragment = function (domFragment) {
      var firstChild = domFragment.firstChild;
      var lastChild = domFragment.lastChild;
      if (firstChild && firstChild.nodeName === 'META') {
        firstChild.parentNode.removeChild(firstChild);
      }
      if (lastChild && lastChild.id === 'mce_marker') {
        lastChild.parentNode.removeChild(lastChild);
      }
      return domFragment;
    };
    var toDomFragment = function (dom, serializer, fragment) {
      var html = serializer.serialize(fragment);
      var domFragment = dom.createFragment(html);
      return cleanupDomFragment(domFragment);
    };
    var listItems = function (elm) {
      return filter$4(elm.childNodes, function (child) {
        return child.nodeName === 'LI';
      });
    };
    var isPadding = function (node) {
      return node.data === nbsp || isBr$5(node);
    };
    var isListItemPadded = function (node) {
      return node && node.firstChild && node.firstChild === node.lastChild && isPadding(node.firstChild);
    };
    var isEmptyOrPadded = function (elm) {
      return !elm.firstChild || isListItemPadded(elm);
    };
    var trimListItems = function (elms) {
      return elms.length > 0 && isEmptyOrPadded(elms[elms.length - 1]) ? elms.slice(0, -1) : elms;
    };
    var getParentLi = function (dom, node) {
      var parentBlock = dom.getParent(node, dom.isBlock);
      return parentBlock && parentBlock.nodeName === 'LI' ? parentBlock : null;
    };
    var isParentBlockLi = function (dom, node) {
      return !!getParentLi(dom, node);
    };
    var getSplit = function (parentNode, rng) {
      var beforeRng = rng.cloneRange();
      var afterRng = rng.cloneRange();
      beforeRng.setStartBefore(parentNode);
      afterRng.setEndAfter(parentNode);
      return [
        beforeRng.cloneContents(),
        afterRng.cloneContents()
      ];
    };
    var findFirstIn = function (node, rootNode) {
      var caretPos = CaretPosition.before(node);
      var caretWalker = CaretWalker(rootNode);
      var newCaretPos = caretWalker.next(caretPos);
      return newCaretPos ? newCaretPos.toRange() : null;
    };
    var findLastOf = function (node, rootNode) {
      var caretPos = CaretPosition.after(node);
      var caretWalker = CaretWalker(rootNode);
      var newCaretPos = caretWalker.prev(caretPos);
      return newCaretPos ? newCaretPos.toRange() : null;
    };
    var insertMiddle = function (target, elms, rootNode, rng) {
      var parts = getSplit(target, rng);
      var parentElm = target.parentNode;
      parentElm.insertBefore(parts[0], target);
      Tools.each(elms, function (li) {
        parentElm.insertBefore(li, target);
      });
      parentElm.insertBefore(parts[1], target);
      parentElm.removeChild(target);
      return findLastOf(elms[elms.length - 1], rootNode);
    };
    var insertBefore$1 = function (target, elms, rootNode) {
      var parentElm = target.parentNode;
      Tools.each(elms, function (elm) {
        parentElm.insertBefore(elm, target);
      });
      return findFirstIn(target, rootNode);
    };
    var insertAfter$1 = function (target, elms, rootNode, dom) {
      dom.insertAfter(elms.reverse(), target);
      return findLastOf(elms[0], rootNode);
    };
    var insertAtCaret$1 = function (serializer, dom, rng, fragment) {
      var domFragment = toDomFragment(dom, serializer, fragment);
      var liTarget = getParentLi(dom, rng.startContainer);
      var liElms = trimListItems(listItems(domFragment.firstChild));
      var BEGINNING = 1, END = 2;
      var rootNode = dom.getRoot();
      var isAt = function (location) {
        var caretPos = CaretPosition.fromRangeStart(rng);
        var caretWalker = CaretWalker(dom.getRoot());
        var newPos = location === BEGINNING ? caretWalker.prev(caretPos) : caretWalker.next(caretPos);
        return newPos ? getParentLi(dom, newPos.getNode()) !== liTarget : true;
      };
      if (isAt(BEGINNING)) {
        return insertBefore$1(liTarget, liElms, rootNode);
      } else if (isAt(END)) {
        return insertAfter$1(liTarget, liElms, rootNode, dom);
      }
      return insertMiddle(liTarget, liElms, rootNode, rng);
    };

    var trimOrPadLeftRight = function (dom, rng, html) {
      var root = SugarElement.fromDom(dom.getRoot());
      if (needsToBeNbspLeft(root, CaretPosition.fromRangeStart(rng))) {
        html = html.replace(/^ /, '&nbsp;');
      } else {
        html = html.replace(/^&nbsp;/, ' ');
      }
      if (needsToBeNbspRight(root, CaretPosition.fromRangeEnd(rng))) {
        html = html.replace(/(&nbsp;| )(<br( \/)>)?$/, '&nbsp;');
      } else {
        html = html.replace(/&nbsp;(<br( \/)?>)?$/, ' ');
      }
      return html;
    };

    var isTableCell$1 = isTableCell$5;
    var isTableCellContentSelected = function (dom, rng, cell) {
      if (cell !== null) {
        var endCell = dom.getParent(rng.endContainer, isTableCell$1);
        return cell === endCell && hasAllContentsSelected(SugarElement.fromDom(cell), rng);
      } else {
        return false;
      }
    };
    var validInsertion = function (editor, value, parentNode) {
      if (parentNode.getAttribute('data-mce-bogus') === 'all') {
        parentNode.parentNode.insertBefore(editor.dom.createFragment(value), parentNode);
      } else {
        var node = parentNode.firstChild;
        var node2 = parentNode.lastChild;
        if (!node || node === node2 && node.nodeName === 'BR') {
          editor.dom.setHTML(parentNode, value);
        } else {
          editor.selection.setContent(value);
        }
      }
    };
    var trimBrsFromTableCell = function (dom, elm) {
      Optional.from(dom.getParent(elm, 'td,th')).map(SugarElement.fromDom).each(trimBlockTrailingBr);
    };
    var reduceInlineTextElements = function (editor, merge) {
      var textInlineElements = editor.schema.getTextInlineElements();
      var dom = editor.dom;
      if (merge) {
        var root_1 = editor.getBody();
        var elementUtils_1 = ElementUtils(dom);
        Tools.each(dom.select('*[data-mce-fragment]'), function (node) {
          var isInline = isNonNullable(textInlineElements[node.nodeName.toLowerCase()]);
          if (isInline && hasInheritableStyles(dom, node)) {
            for (var parentNode = node.parentNode; isNonNullable(parentNode) && parentNode !== root_1; parentNode = parentNode.parentNode) {
              var styleConflict = hasStyleConflict(dom, node, parentNode);
              if (styleConflict) {
                break;
              }
              if (elementUtils_1.compare(parentNode, node)) {
                dom.remove(node, true);
                break;
              }
            }
          }
        });
      }
    };
    var markFragmentElements = function (fragment) {
      var node = fragment;
      while (node = node.walk()) {
        if (node.type === 1) {
          node.attr('data-mce-fragment', '1');
        }
      }
    };
    var unmarkFragmentElements = function (elm) {
      Tools.each(elm.getElementsByTagName('*'), function (elm) {
        elm.removeAttribute('data-mce-fragment');
      });
    };
    var isPartOfFragment = function (node) {
      return !!node.getAttribute('data-mce-fragment');
    };
    var canHaveChildren = function (editor, node) {
      return node && !editor.schema.getShortEndedElements()[node.nodeName];
    };
    var moveSelectionToMarker = function (editor, marker) {
      var nextRng;
      var dom = editor.dom;
      var selection = editor.selection;
      if (!marker) {
        return;
      }
      selection.scrollIntoView(marker);
      var parentEditableElm = getContentEditableRoot$1(editor.getBody(), marker);
      if (dom.getContentEditable(parentEditableElm) === 'false') {
        dom.remove(marker);
        selection.select(parentEditableElm);
        return;
      }
      var rng = dom.createRng();
      var node = marker.previousSibling;
      if (isText$7(node)) {
        rng.setStart(node, node.nodeValue.length);
        if (!Env.ie) {
          var node2 = marker.nextSibling;
          if (isText$7(node2)) {
            node.appendData(node2.data);
            node2.parentNode.removeChild(node2);
          }
        }
      } else {
        rng.setStartBefore(marker);
        rng.setEndBefore(marker);
      }
      var findNextCaretRng = function (rng) {
        var caretPos = CaretPosition.fromRangeStart(rng);
        var caretWalker = CaretWalker(editor.getBody());
        caretPos = caretWalker.next(caretPos);
        if (caretPos) {
          return caretPos.toRange();
        }
      };
      var parentBlock = dom.getParent(marker, dom.isBlock);
      dom.remove(marker);
      if (parentBlock && dom.isEmpty(parentBlock)) {
        editor.$(parentBlock).empty();
        rng.setStart(parentBlock, 0);
        rng.setEnd(parentBlock, 0);
        if (!isTableCell$1(parentBlock) && !isPartOfFragment(parentBlock) && (nextRng = findNextCaretRng(rng))) {
          rng = nextRng;
          dom.remove(parentBlock);
        } else {
          dom.add(parentBlock, dom.create('br', { 'data-mce-bogus': '1' }));
        }
      }
      selection.setRng(rng);
    };
    var deleteSelectedContent = function (editor) {
      var dom = editor.dom;
      var rng = normalize(editor.selection.getRng());
      editor.selection.setRng(rng);
      var startCell = dom.getParent(rng.startContainer, isTableCell$1);
      if (isTableCellContentSelected(dom, rng, startCell)) {
        deleteCellContents(editor, rng, SugarElement.fromDom(startCell));
      } else {
        editor.getDoc().execCommand('Delete', false, null);
      }
    };
    var insertHtmlAtCaret = function (editor, value, details) {
      var parentNode;
      var rng, node;
      var selection = editor.selection;
      var dom = editor.dom;
      if (/^ | $/.test(value)) {
        value = trimOrPadLeftRight(dom, selection.getRng(), value);
      }
      var parser = editor.parser;
      var merge = details.merge;
      var serializer = HtmlSerializer({ validate: shouldValidate(editor) }, editor.schema);
      var bookmarkHtml = '<span id="mce_marker" data-mce-type="bookmark">&#xFEFF;</span>';
      var args = editor.fire('BeforeSetContent', {
        content: value,
        format: 'html',
        selection: true,
        paste: details.paste
      });
      if (args.isDefaultPrevented()) {
        editor.fire('SetContent', {
          content: args.content,
          format: 'html',
          selection: true,
          paste: details.paste
        });
        return;
      }
      value = args.content;
      if (value.indexOf('{$caret}') === -1) {
        value += '{$caret}';
      }
      value = value.replace(/\{\$caret\}/, bookmarkHtml);
      rng = selection.getRng();
      var caretElement = rng.startContainer || (rng.parentElement ? rng.parentElement() : null);
      var body = editor.getBody();
      if (caretElement === body && selection.isCollapsed()) {
        if (dom.isBlock(body.firstChild) && canHaveChildren(editor, body.firstChild) && dom.isEmpty(body.firstChild)) {
          rng = dom.createRng();
          rng.setStart(body.firstChild, 0);
          rng.setEnd(body.firstChild, 0);
          selection.setRng(rng);
        }
      }
      if (!selection.isCollapsed()) {
        deleteSelectedContent(editor);
      }
      parentNode = selection.getNode();
      var parserArgs = {
        context: parentNode.nodeName.toLowerCase(),
        data: details.data,
        insert: true
      };
      var fragment = parser.parse(value, parserArgs);
      if (details.paste === true && isListFragment(editor.schema, fragment) && isParentBlockLi(dom, parentNode)) {
        rng = insertAtCaret$1(serializer, dom, selection.getRng(), fragment);
        selection.setRng(rng);
        editor.fire('SetContent', args);
        return;
      }
      markFragmentElements(fragment);
      node = fragment.lastChild;
      if (node.attr('id') === 'mce_marker') {
        var marker = node;
        for (node = node.prev; node; node = node.walk(true)) {
          if (node.type === 3 || !dom.isBlock(node.name)) {
            if (editor.schema.isValidChild(node.parent.name, 'span')) {
              node.parent.insert(marker, node, node.name === 'br');
            }
            break;
          }
        }
      }
      editor._selectionOverrides.showBlockCaretContainer(parentNode);
      if (!parserArgs.invalid) {
        value = serializer.serialize(fragment);
        validInsertion(editor, value, parentNode);
      } else {
        editor.selection.setContent(bookmarkHtml);
        parentNode = selection.getNode();
        var rootNode = editor.getBody();
        if (parentNode.nodeType === 9) {
          parentNode = node = rootNode;
        } else {
          node = parentNode;
        }
        while (node !== rootNode) {
          parentNode = node;
          node = node.parentNode;
        }
        value = parentNode === rootNode ? rootNode.innerHTML : dom.getOuterHTML(parentNode);
        value = serializer.serialize(parser.parse(value.replace(/<span (id="mce_marker"|id=mce_marker).+?<\/span>/i, function () {
          return serializer.serialize(fragment);
        })));
        if (parentNode === rootNode) {
          dom.setHTML(rootNode, value);
        } else {
          dom.setOuterHTML(parentNode, value);
        }
      }
      reduceInlineTextElements(editor, merge);
      moveSelectionToMarker(editor, dom.get('mce_marker'));
      unmarkFragmentElements(editor.getBody());
      trimBrsFromTableCell(dom, selection.getStart());
      editor.fire('SetContent', args);
      editor.addVisual();
    };

    var traverse = function (node, fn) {
      fn(node);
      if (node.firstChild) {
        traverse(node.firstChild, fn);
      }
      if (node.next) {
        traverse(node.next, fn);
      }
    };
    var findMatchingNodes = function (nodeFilters, attributeFilters, node) {
      var nodeMatches = {};
      var attrMatches = {};
      var matches = [];
      if (node.firstChild) {
        traverse(node.firstChild, function (node) {
          each$k(nodeFilters, function (filter) {
            if (filter.name === node.name) {
              if (nodeMatches[filter.name]) {
                nodeMatches[filter.name].nodes.push(node);
              } else {
                nodeMatches[filter.name] = {
                  filter: filter,
                  nodes: [node]
                };
              }
            }
          });
          each$k(attributeFilters, function (filter) {
            if (typeof node.attr(filter.name) === 'string') {
              if (attrMatches[filter.name]) {
                attrMatches[filter.name].nodes.push(node);
              } else {
                attrMatches[filter.name] = {
                  filter: filter,
                  nodes: [node]
                };
              }
            }
          });
        });
      }
      for (var name_1 in nodeMatches) {
        if (has$2(nodeMatches, name_1)) {
          matches.push(nodeMatches[name_1]);
        }
      }
      for (var name_2 in attrMatches) {
        if (has$2(attrMatches, name_2)) {
          matches.push(attrMatches[name_2]);
        }
      }
      return matches;
    };
    var filter$1 = function (nodeFilters, attributeFilters, node) {
      var matches = findMatchingNodes(nodeFilters, attributeFilters, node);
      each$k(matches, function (match) {
        each$k(match.filter.callbacks, function (callback) {
          callback(match.nodes, match.filter.name, {});
        });
      });
    };

    var defaultFormat$1 = 'html';
    var isTreeNode = function (content) {
      return content instanceof AstNode;
    };
    var moveSelection = function (editor) {
      if (hasFocus(editor)) {
        firstPositionIn(editor.getBody()).each(function (pos) {
          var node = pos.getNode();
          var caretPos = isTable$3(node) ? firstPositionIn(node).getOr(pos) : pos;
          editor.selection.setRng(caretPos.toRange());
        });
      }
    };
    var setEditorHtml = function (editor, html, noSelection) {
      editor.dom.setHTML(editor.getBody(), html);
      if (noSelection !== true) {
        moveSelection(editor);
      }
    };
    var setContentString = function (editor, body, content, args) {
      if (content.length === 0 || /^\s+$/.test(content)) {
        var padd = '<br data-mce-bogus="1">';
        if (body.nodeName === 'TABLE') {
          content = '<tr><td>' + padd + '</td></tr>';
        } else if (/^(UL|OL)$/.test(body.nodeName)) {
          content = '<li>' + padd + '</li>';
        }
        var forcedRootBlockName = getForcedRootBlock(editor);
        if (forcedRootBlockName && editor.schema.isValidChild(body.nodeName.toLowerCase(), forcedRootBlockName.toLowerCase())) {
          content = padd;
          content = editor.dom.createHTML(forcedRootBlockName, getForcedRootBlockAttrs(editor), content);
        } else if (!content) {
          content = '<br data-mce-bogus="1">';
        }
        setEditorHtml(editor, content, args.no_selection);
        editor.fire('SetContent', args);
      } else {
        if (args.format !== 'raw') {
          content = HtmlSerializer({ validate: editor.validate }, editor.schema).serialize(editor.parser.parse(content, {
            isRootContent: true,
            insert: true
          }));
        }
        args.content = isWsPreserveElement(SugarElement.fromDom(body)) ? content : Tools.trim(content);
        setEditorHtml(editor, args.content, args.no_selection);
        if (!args.no_events) {
          editor.fire('SetContent', args);
        }
      }
      return args.content;
    };
    var setContentTree = function (editor, body, content, args) {
      filter$1(editor.parser.getNodeFilters(), editor.parser.getAttributeFilters(), content);
      var html = HtmlSerializer({ validate: editor.validate }, editor.schema).serialize(content);
      args.content = isWsPreserveElement(SugarElement.fromDom(body)) ? html : Tools.trim(html);
      setEditorHtml(editor, args.content, args.no_selection);
      if (!args.no_events) {
        editor.fire('SetContent', args);
      }
      return content;
    };
    var setupArgs$2 = function (args, content) {
      return __assign(__assign({ format: defaultFormat$1 }, args), {
        set: true,
        content: isTreeNode(content) ? '' : content
      });
    };
    var setContentInternal = function (editor, content, args) {
      var defaultedArgs = setupArgs$2(args, content);
      var updatedArgs = args.no_events ? defaultedArgs : editor.fire('BeforeSetContent', defaultedArgs);
      if (!isTreeNode(content)) {
        content = updatedArgs.content;
      }
      return Optional.from(editor.getBody()).fold(constant(content), function (body) {
        return isTreeNode(content) ? setContentTree(editor, body, content, updatedArgs) : setContentString(editor, body, content, updatedArgs);
      });
    };

    var sibling = function (scope, predicate) {
      return sibling$2(scope, predicate).isSome();
    };

    var ensureIsRoot = function (isRoot) {
      return isFunction(isRoot) ? isRoot : never;
    };
    var ancestor = function (scope, transform, isRoot) {
      var element = scope.dom;
      var stop = ensureIsRoot(isRoot);
      while (element.parentNode) {
        element = element.parentNode;
        var el = SugarElement.fromDom(element);
        var transformed = transform(el);
        if (transformed.isSome()) {
          return transformed;
        } else if (stop(el)) {
          break;
        }
      }
      return Optional.none();
    };
    var closest$1 = function (scope, transform, isRoot) {
      var current = transform(scope);
      var stop = ensureIsRoot(isRoot);
      return current.orThunk(function () {
        return stop(scope) ? Optional.none() : ancestor(scope, transform, stop);
      });
    };

    var isEq$3 = isEq$5;
    var matchesUnInheritedFormatSelector = function (ed, node, name) {
      var formatList = ed.formatter.get(name);
      if (formatList) {
        for (var i = 0; i < formatList.length; i++) {
          var format = formatList[i];
          if (isSelectorFormat(format) && format.inherit === false && ed.dom.is(node, format.selector)) {
            return true;
          }
        }
      }
      return false;
    };
    var matchParents = function (editor, node, name, vars, similar) {
      var root = editor.dom.getRoot();
      if (node === root) {
        return false;
      }
      node = editor.dom.getParent(node, function (node) {
        if (matchesUnInheritedFormatSelector(editor, node, name)) {
          return true;
        }
        return node.parentNode === root || !!matchNode(editor, node, name, vars, true);
      });
      return !!matchNode(editor, node, name, vars, similar);
    };
    var matchName$1 = function (dom, node, format) {
      if (isEq$3(node, format.inline)) {
        return true;
      }
      if (isEq$3(node, format.block)) {
        return true;
      }
      if (format.selector) {
        return node.nodeType === 1 && dom.is(node, format.selector);
      }
    };
    var matchItems = function (dom, node, format, itemName, similar, vars) {
      var items = format[itemName];
      if (isFunction(format.onmatch)) {
        return format.onmatch(node, format, itemName);
      }
      if (items) {
        if (isUndefined(items.length)) {
          for (var key in items) {
            if (has$2(items, key)) {
              var value = itemName === 'attributes' ? dom.getAttrib(node, key) : getStyle(dom, node, key);
              var expectedValue = replaceVars(items[key], vars);
              var isEmptyValue = isNullable(value) || isEmpty$3(value);
              if (isEmptyValue && isNullable(expectedValue)) {
                continue;
              }
              if (similar && isEmptyValue && !format.exact) {
                return false;
              }
              if ((!similar || format.exact) && !isEq$3(value, normalizeStyleValue(dom, expectedValue, key))) {
                return false;
              }
            }
          }
        } else {
          for (var i = 0; i < items.length; i++) {
            if (itemName === 'attributes' ? dom.getAttrib(node, items[i]) : getStyle(dom, node, items[i])) {
              return true;
            }
          }
        }
      }
      return true;
    };
    var matchNode = function (ed, node, name, vars, similar) {
      var formatList = ed.formatter.get(name);
      var dom = ed.dom;
      if (formatList && node) {
        for (var i = 0; i < formatList.length; i++) {
          var format = formatList[i];
          if (matchName$1(ed.dom, node, format) && matchItems(dom, node, format, 'attributes', similar, vars) && matchItems(dom, node, format, 'styles', similar, vars)) {
            var classes = format.classes;
            if (classes) {
              for (var x = 0; x < classes.length; x++) {
                if (!ed.dom.hasClass(node, replaceVars(classes[x], vars))) {
                  return;
                }
              }
            }
            return format;
          }
        }
      }
    };
    var match$2 = function (editor, name, vars, node, similar) {
      if (node) {
        return matchParents(editor, node, name, vars, similar);
      }
      node = editor.selection.getNode();
      if (matchParents(editor, node, name, vars, similar)) {
        return true;
      }
      var startNode = editor.selection.getStart();
      if (startNode !== node) {
        if (matchParents(editor, startNode, name, vars, similar)) {
          return true;
        }
      }
      return false;
    };
    var matchAll = function (editor, names, vars) {
      var matchedFormatNames = [];
      var checkedMap = {};
      var startElement = editor.selection.getStart();
      editor.dom.getParent(startElement, function (node) {
        for (var i = 0; i < names.length; i++) {
          var name_1 = names[i];
          if (!checkedMap[name_1] && matchNode(editor, node, name_1, vars)) {
            checkedMap[name_1] = true;
            matchedFormatNames.push(name_1);
          }
        }
      }, editor.dom.getRoot());
      return matchedFormatNames;
    };
    var closest = function (editor, names) {
      var isRoot = function (elm) {
        return eq(elm, SugarElement.fromDom(editor.getBody()));
      };
      var match = function (elm, name) {
        return matchNode(editor, elm.dom, name) ? Optional.some(name) : Optional.none();
      };
      return Optional.from(editor.selection.getStart(true)).bind(function (rawElm) {
        return closest$1(SugarElement.fromDom(rawElm), function (elm) {
          return findMap(names, function (name) {
            return match(elm, name);
          });
        }, isRoot);
      }).getOrNull();
    };
    var canApply = function (editor, name) {
      var formatList = editor.formatter.get(name);
      var dom = editor.dom;
      if (formatList) {
        var startNode = editor.selection.getStart();
        var parents = getParents$2(dom, startNode);
        for (var x = formatList.length - 1; x >= 0; x--) {
          var format = formatList[x];
          if (!isSelectorFormat(format) || isNonNullable(format.defaultBlock)) {
            return true;
          }
          for (var i = parents.length - 1; i >= 0; i--) {
            if (dom.is(parents[i], format.selector)) {
              return true;
            }
          }
        }
      }
      return false;
    };
    var matchAllOnNode = function (editor, node, formatNames) {
      return foldl(formatNames, function (acc, name) {
        var matchSimilar = isVariableFormatName(editor, name);
        if (editor.formatter.matchNode(node, name, {}, matchSimilar)) {
          return acc.concat([name]);
        } else {
          return acc;
        }
      }, []);
    };

    var ZWSP = ZWSP$1, CARET_ID = '_mce_caret';
    var importNode = function (ownerDocument, node) {
      return ownerDocument.importNode(node, true);
    };
    var getEmptyCaretContainers = function (node) {
      var nodes = [];
      while (node) {
        if (node.nodeType === 3 && node.nodeValue !== ZWSP || node.childNodes.length > 1) {
          return [];
        }
        if (node.nodeType === 1) {
          nodes.push(node);
        }
        node = node.firstChild;
      }
      return nodes;
    };
    var isCaretContainerEmpty = function (node) {
      return getEmptyCaretContainers(node).length > 0;
    };
    var findFirstTextNode = function (node) {
      if (node) {
        var walker = new DomTreeWalker(node, node);
        for (node = walker.current(); node; node = walker.next()) {
          if (isText$7(node)) {
            return node;
          }
        }
      }
      return null;
    };
    var createCaretContainer = function (fill) {
      var caretContainer = SugarElement.fromTag('span');
      setAll$1(caretContainer, {
        'id': CARET_ID,
        'data-mce-bogus': '1',
        'data-mce-type': 'format-caret'
      });
      if (fill) {
        append$1(caretContainer, SugarElement.fromText(ZWSP));
      }
      return caretContainer;
    };
    var trimZwspFromCaretContainer = function (caretContainerNode) {
      var textNode = findFirstTextNode(caretContainerNode);
      if (textNode && textNode.nodeValue.charAt(0) === ZWSP) {
        textNode.deleteData(0, 1);
      }
      return textNode;
    };
    var removeCaretContainerNode = function (editor, node, moveCaret) {
      if (moveCaret === void 0) {
        moveCaret = true;
      }
      var dom = editor.dom, selection = editor.selection;
      if (isCaretContainerEmpty(node)) {
        deleteElement$2(editor, false, SugarElement.fromDom(node), moveCaret);
      } else {
        var rng = selection.getRng();
        var block = dom.getParent(node, dom.isBlock);
        var startContainer = rng.startContainer;
        var startOffset = rng.startOffset;
        var endContainer = rng.endContainer;
        var endOffset = rng.endOffset;
        var textNode = trimZwspFromCaretContainer(node);
        dom.remove(node, true);
        if (startContainer === textNode && startOffset > 0) {
          rng.setStart(textNode, startOffset - 1);
        }
        if (endContainer === textNode && endOffset > 0) {
          rng.setEnd(textNode, endOffset - 1);
        }
        if (block && dom.isEmpty(block)) {
          fillWithPaddingBr(SugarElement.fromDom(block));
        }
        selection.setRng(rng);
      }
    };
    var removeCaretContainer = function (editor, node, moveCaret) {
      if (moveCaret === void 0) {
        moveCaret = true;
      }
      var dom = editor.dom, selection = editor.selection;
      if (!node) {
        node = getParentCaretContainer(editor.getBody(), selection.getStart());
        if (!node) {
          while (node = dom.get(CARET_ID)) {
            removeCaretContainerNode(editor, node, false);
          }
        }
      } else {
        removeCaretContainerNode(editor, node, moveCaret);
      }
    };
    var insertCaretContainerNode = function (editor, caretContainer, formatNode) {
      var dom = editor.dom, block = dom.getParent(formatNode, curry(isTextBlock$1, editor));
      if (block && dom.isEmpty(block)) {
        formatNode.parentNode.replaceChild(caretContainer, formatNode);
      } else {
        removeTrailingBr(SugarElement.fromDom(formatNode));
        if (dom.isEmpty(formatNode)) {
          formatNode.parentNode.replaceChild(caretContainer, formatNode);
        } else {
          dom.insertAfter(caretContainer, formatNode);
        }
      }
    };
    var appendNode = function (parentNode, node) {
      parentNode.appendChild(node);
      return node;
    };
    var insertFormatNodesIntoCaretContainer = function (formatNodes, caretContainer) {
      var innerMostFormatNode = foldr(formatNodes, function (parentNode, formatNode) {
        return appendNode(parentNode, formatNode.cloneNode(false));
      }, caretContainer);
      return appendNode(innerMostFormatNode, innerMostFormatNode.ownerDocument.createTextNode(ZWSP));
    };
    var cleanFormatNode = function (editor, caretContainer, formatNode, name, vars, similar) {
      var formatter = editor.formatter;
      var dom = editor.dom;
      var validFormats = filter$4(keys(formatter.get()), function (formatName) {
        return formatName !== name && !contains$2(formatName, 'removeformat');
      });
      var matchedFormats = matchAllOnNode(editor, formatNode, validFormats);
      var uniqueFormats = filter$4(matchedFormats, function (fmtName) {
        return !areSimilarFormats(editor, fmtName, name);
      });
      if (uniqueFormats.length > 0) {
        var clonedFormatNode = formatNode.cloneNode(false);
        dom.add(caretContainer, clonedFormatNode);
        formatter.remove(name, vars, clonedFormatNode, similar);
        dom.remove(clonedFormatNode);
        return Optional.some(clonedFormatNode);
      } else {
        return Optional.none();
      }
    };
    var applyCaretFormat = function (editor, name, vars) {
      var caretContainer, textNode;
      var selection = editor.selection;
      var selectionRng = selection.getRng();
      var offset = selectionRng.startOffset;
      var container = selectionRng.startContainer;
      var text = container.nodeValue;
      caretContainer = getParentCaretContainer(editor.getBody(), selection.getStart());
      if (caretContainer) {
        textNode = findFirstTextNode(caretContainer);
      }
      var wordcharRegex = /[^\s\u00a0\u00ad\u200b\ufeff]/;
      if (text && offset > 0 && offset < text.length && wordcharRegex.test(text.charAt(offset)) && wordcharRegex.test(text.charAt(offset - 1))) {
        var bookmark = selection.getBookmark();
        selectionRng.collapse(true);
        var rng = expandRng(editor, selectionRng, editor.formatter.get(name));
        rng = split(rng);
        editor.formatter.apply(name, vars, rng);
        selection.moveToBookmark(bookmark);
      } else {
        if (!caretContainer || textNode.nodeValue !== ZWSP) {
          caretContainer = importNode(editor.getDoc(), createCaretContainer(true).dom);
          textNode = caretContainer.firstChild;
          selectionRng.insertNode(caretContainer);
          offset = 1;
          editor.formatter.apply(name, vars, caretContainer);
        } else {
          editor.formatter.apply(name, vars, caretContainer);
        }
        selection.setCursorLocation(textNode, offset);
      }
    };
    var removeCaretFormat = function (editor, name, vars, similar) {
      var dom = editor.dom;
      var selection = editor.selection;
      var hasContentAfter, node, formatNode;
      var parents = [];
      var rng = selection.getRng();
      var container = rng.startContainer;
      var offset = rng.startOffset;
      node = container;
      if (container.nodeType === 3) {
        if (offset !== container.nodeValue.length) {
          hasContentAfter = true;
        }
        node = node.parentNode;
      }
      while (node) {
        if (matchNode(editor, node, name, vars, similar)) {
          formatNode = node;
          break;
        }
        if (node.nextSibling) {
          hasContentAfter = true;
        }
        parents.push(node);
        node = node.parentNode;
      }
      if (!formatNode) {
        return;
      }
      if (hasContentAfter) {
        var bookmark = selection.getBookmark();
        rng.collapse(true);
        var expandedRng = expandRng(editor, rng, editor.formatter.get(name), true);
        expandedRng = split(expandedRng);
        editor.formatter.remove(name, vars, expandedRng, similar);
        selection.moveToBookmark(bookmark);
      } else {
        var caretContainer = getParentCaretContainer(editor.getBody(), formatNode);
        var newCaretContainer = createCaretContainer(false).dom;
        insertCaretContainerNode(editor, newCaretContainer, caretContainer !== null ? caretContainer : formatNode);
        var cleanedFormatNode = cleanFormatNode(editor, newCaretContainer, formatNode, name, vars, similar);
        var caretTextNode = insertFormatNodesIntoCaretContainer(parents.concat(cleanedFormatNode.toArray()), newCaretContainer);
        removeCaretContainerNode(editor, caretContainer, false);
        selection.setCursorLocation(caretTextNode, 1);
        if (dom.isEmpty(formatNode)) {
          dom.remove(formatNode);
        }
      }
    };
    var disableCaretContainer = function (editor, keyCode) {
      var selection = editor.selection, body = editor.getBody();
      removeCaretContainer(editor, null, false);
      if ((keyCode === 8 || keyCode === 46) && selection.isCollapsed() && selection.getStart().innerHTML === ZWSP) {
        removeCaretContainer(editor, getParentCaretContainer(body, selection.getStart()));
      }
      if (keyCode === 37 || keyCode === 39) {
        removeCaretContainer(editor, getParentCaretContainer(body, selection.getStart()));
      }
    };
    var setup$k = function (editor) {
      editor.on('mouseup keydown', function (e) {
        disableCaretContainer(editor, e.keyCode);
      });
    };
    var replaceWithCaretFormat = function (targetNode, formatNodes) {
      var caretContainer = createCaretContainer(false);
      var innerMost = insertFormatNodesIntoCaretContainer(formatNodes, caretContainer.dom);
      before$4(SugarElement.fromDom(targetNode), caretContainer);
      remove$7(SugarElement.fromDom(targetNode));
      return CaretPosition(innerMost, 0);
    };
    var isFormatElement = function (editor, element) {
      var inlineElements = editor.schema.getTextInlineElements();
      return has$2(inlineElements, name(element)) && !isCaretNode(element.dom) && !isBogus$2(element.dom);
    };
    var isEmptyCaretFormatElement = function (element) {
      return isCaretNode(element.dom) && isCaretContainerEmpty(element.dom);
    };

    var postProcessHooks = {};
    var filter = filter$2;
    var each$b = each$i;
    var addPostProcessHook = function (name, hook) {
      var hooks = postProcessHooks[name];
      if (!hooks) {
        postProcessHooks[name] = [];
      }
      postProcessHooks[name].push(hook);
    };
    var postProcess$1 = function (name, editor) {
      each$b(postProcessHooks[name], function (hook) {
        hook(editor);
      });
    };
    addPostProcessHook('pre', function (editor) {
      var rng = editor.selection.getRng();
      var blocks;
      var hasPreSibling = function (pre) {
        return isPre(pre.previousSibling) && indexOf$1(blocks, pre.previousSibling) !== -1;
      };
      var joinPre = function (pre1, pre2) {
        DomQuery(pre2).remove();
        DomQuery(pre1).append('<br><br>').append(pre2.childNodes);
      };
      var isPre = matchNodeNames(['pre']);
      if (!rng.collapsed) {
        blocks = editor.selection.getSelectedBlocks();
        each$b(filter(filter(blocks, isPre), hasPreSibling), function (pre) {
          joinPre(pre.previousSibling, pre);
        });
      }
    });

    var each$a = Tools.each;
    var isElementNode$1 = function (node) {
      return isElement$5(node) && !isBookmarkNode$1(node) && !isCaretNode(node) && !isBogus$2(node);
    };
    var findElementSibling = function (node, siblingName) {
      for (var sibling = node; sibling; sibling = sibling[siblingName]) {
        if (isText$7(sibling) && isNotEmpty(sibling.data)) {
          return node;
        }
        if (isElement$5(sibling) && !isBookmarkNode$1(sibling)) {
          return sibling;
        }
      }
      return node;
    };
    var mergeSiblingsNodes = function (dom, prev, next) {
      var elementUtils = ElementUtils(dom);
      if (prev && next) {
        prev = findElementSibling(prev, 'previousSibling');
        next = findElementSibling(next, 'nextSibling');
        if (elementUtils.compare(prev, next)) {
          for (var sibling = prev.nextSibling; sibling && sibling !== next;) {
            var tmpSibling = sibling;
            sibling = sibling.nextSibling;
            prev.appendChild(tmpSibling);
          }
          dom.remove(next);
          Tools.each(Tools.grep(next.childNodes), function (node) {
            prev.appendChild(node);
          });
          return prev;
        }
      }
      return next;
    };
    var mergeSiblings = function (dom, format, vars, node) {
      if (node && format.merge_siblings !== false) {
        var newNode = mergeSiblingsNodes(dom, getNonWhiteSpaceSibling(node), node);
        mergeSiblingsNodes(dom, newNode, getNonWhiteSpaceSibling(newNode, true));
      }
    };
    var clearChildStyles = function (dom, format, node) {
      if (format.clear_child_styles) {
        var selector = format.links ? '*:not(a)' : '*';
        each$a(dom.select(selector, node), function (node) {
          if (isElementNode$1(node)) {
            each$a(format.styles, function (value, name) {
              dom.setStyle(node, name, '');
            });
          }
        });
      }
    };
    var processChildElements = function (node, filter, process) {
      each$a(node.childNodes, function (node) {
        if (isElementNode$1(node)) {
          if (filter(node)) {
            process(node);
          }
          if (node.hasChildNodes()) {
            processChildElements(node, filter, process);
          }
        }
      });
    };
    var unwrapEmptySpan = function (dom, node) {
      if (node.nodeName === 'SPAN' && dom.getAttribs(node).length === 0) {
        dom.remove(node, true);
      }
    };
    var hasStyle = function (dom, name) {
      return function (node) {
        return !!(node && getStyle(dom, node, name));
      };
    };
    var applyStyle = function (dom, name, value) {
      return function (node) {
        dom.setStyle(node, name, value);
        if (node.getAttribute('style') === '') {
          node.removeAttribute('style');
        }
        unwrapEmptySpan(dom, node);
      };
    };

    var removeResult = Adt.generate([
      { keep: [] },
      { rename: ['name'] },
      { removed: [] }
    ]);
    var MCE_ATTR_RE = /^(src|href|style)$/;
    var each$9 = Tools.each;
    var isEq$2 = isEq$5;
    var isTableCellOrRow = function (node) {
      return /^(TR|TH|TD)$/.test(node.nodeName);
    };
    var isChildOfInlineParent = function (dom, node, parent) {
      return dom.isChildOf(node, parent) && node !== parent && !dom.isBlock(parent);
    };
    var getContainer = function (ed, rng, start) {
      var container = rng[start ? 'startContainer' : 'endContainer'];
      var offset = rng[start ? 'startOffset' : 'endOffset'];
      if (isElement$5(container)) {
        var lastIdx = container.childNodes.length - 1;
        if (!start && offset) {
          offset--;
        }
        container = container.childNodes[offset > lastIdx ? lastIdx : offset];
      }
      if (isText$7(container) && start && offset >= container.nodeValue.length) {
        container = new DomTreeWalker(container, ed.getBody()).next() || container;
      }
      if (isText$7(container) && !start && offset === 0) {
        container = new DomTreeWalker(container, ed.getBody()).prev() || container;
      }
      return container;
    };
    var normalizeTableSelection = function (node, start) {
      var prop = start ? 'firstChild' : 'lastChild';
      if (isTableCellOrRow(node) && node[prop]) {
        var childNode = node[prop];
        if (node.nodeName === 'TR') {
          return childNode[prop] || childNode;
        } else {
          return childNode;
        }
      }
      return node;
    };
    var wrap$1 = function (dom, node, name, attrs) {
      var wrapper = dom.create(name, attrs);
      node.parentNode.insertBefore(wrapper, node);
      wrapper.appendChild(node);
      return wrapper;
    };
    var wrapWithSiblings = function (dom, node, next, name, attrs) {
      var start = SugarElement.fromDom(node);
      var wrapper = SugarElement.fromDom(dom.create(name, attrs));
      var siblings = next ? nextSiblings(start) : prevSiblings(start);
      append(wrapper, siblings);
      if (next) {
        before$4(start, wrapper);
        prepend(wrapper, start);
      } else {
        after$3(start, wrapper);
        append$1(wrapper, start);
      }
      return wrapper.dom;
    };
    var matchName = function (dom, node, format) {
      if (isInlineFormat(format) && isEq$2(node, format.inline)) {
        return true;
      }
      if (isBlockFormat(format) && isEq$2(node, format.block)) {
        return true;
      }
      if (isSelectorFormat(format)) {
        return isElement$5(node) && dom.is(node, format.selector);
      }
    };
    var isColorFormatAndAnchor = function (node, format) {
      return format.links && node.nodeName === 'A';
    };
    var find = function (dom, node, next, inc) {
      var sibling = getNonWhiteSpaceSibling(node, next, inc);
      return isNullable(sibling) || sibling.nodeName === 'BR' || dom.isBlock(sibling);
    };
    var removeNode = function (ed, node, format) {
      var parentNode = node.parentNode;
      var rootBlockElm;
      var dom = ed.dom, forcedRootBlock = getForcedRootBlock(ed);
      if (isBlockFormat(format)) {
        if (!forcedRootBlock) {
          if (dom.isBlock(node) && !dom.isBlock(parentNode)) {
            if (!find(dom, node, false) && !find(dom, node.firstChild, true, true)) {
              node.insertBefore(dom.create('br'), node.firstChild);
            }
            if (!find(dom, node, true) && !find(dom, node.lastChild, false, true)) {
              node.appendChild(dom.create('br'));
            }
          }
        } else {
          if (parentNode === dom.getRoot()) {
            if (!format.list_block || !isEq$2(node, format.list_block)) {
              each$k(from(node.childNodes), function (node) {
                if (isValid(ed, forcedRootBlock, node.nodeName.toLowerCase())) {
                  if (!rootBlockElm) {
                    rootBlockElm = wrap$1(dom, node, forcedRootBlock);
                    dom.setAttribs(rootBlockElm, ed.settings.forced_root_block_attrs);
                  } else {
                    rootBlockElm.appendChild(node);
                  }
                } else {
                  rootBlockElm = null;
                }
              });
            }
          }
        }
      }
      if (isMixedFormat(format) && !isEq$2(format.inline, node)) {
        return;
      }
      dom.remove(node, true);
    };
    var removeFormatInternal = function (ed, format, vars, node, compareNode) {
      var stylesModified;
      var dom = ed.dom;
      if (!matchName(dom, node, format) && !isColorFormatAndAnchor(node, format)) {
        return removeResult.keep();
      }
      var elm = node;
      if (isInlineFormat(format) && format.remove === 'all' && isArray$1(format.preserve_attributes)) {
        var attrsToPreserve = filter$4(dom.getAttribs(elm), function (attr) {
          return contains$3(format.preserve_attributes, attr.name.toLowerCase());
        });
        dom.removeAllAttribs(elm);
        each$k(attrsToPreserve, function (attr) {
          return dom.setAttrib(elm, attr.name, attr.value);
        });
        if (attrsToPreserve.length > 0) {
          return removeResult.rename('span');
        }
      }
      if (format.remove !== 'all') {
        each$9(format.styles, function (value, name) {
          value = normalizeStyleValue(dom, replaceVars(value, vars), name + '');
          if (isNumber(name)) {
            name = value;
            compareNode = null;
          }
          if (format.remove_similar || (!compareNode || isEq$2(getStyle(dom, compareNode, name), value))) {
            dom.setStyle(elm, name, '');
          }
          stylesModified = true;
        });
        if (stylesModified && dom.getAttrib(elm, 'style') === '') {
          elm.removeAttribute('style');
          elm.removeAttribute('data-mce-style');
        }
        each$9(format.attributes, function (value, name) {
          var valueOut;
          value = replaceVars(value, vars);
          if (isNumber(name)) {
            name = value;
            compareNode = null;
          }
          if (format.remove_similar || (!compareNode || isEq$2(dom.getAttrib(compareNode, name), value))) {
            if (name === 'class') {
              value = dom.getAttrib(elm, name);
              if (value) {
                valueOut = '';
                each$k(value.split(/\s+/), function (cls) {
                  if (/mce\-\w+/.test(cls)) {
                    valueOut += (valueOut ? ' ' : '') + cls;
                  }
                });
                if (valueOut) {
                  dom.setAttrib(elm, name, valueOut);
                  return;
                }
              }
            }
            if (MCE_ATTR_RE.test(name)) {
              elm.removeAttribute('data-mce-' + name);
            }
            if (name === 'style' && matchNodeNames(['li'])(elm) && dom.getStyle(elm, 'list-style-type') === 'none') {
              elm.removeAttribute(name);
              dom.setStyle(elm, 'list-style-type', 'none');
              return;
            }
            if (name === 'class') {
              elm.removeAttribute('className');
            }
            elm.removeAttribute(name);
          }
        });
        each$9(format.classes, function (value) {
          value = replaceVars(value, vars);
          if (!compareNode || dom.hasClass(compareNode, value)) {
            dom.removeClass(elm, value);
          }
        });
        var attrs = dom.getAttribs(elm);
        for (var i = 0; i < attrs.length; i++) {
          var attrName = attrs[i].nodeName;
          if (attrName.indexOf('_') !== 0 && attrName.indexOf('data-') !== 0) {
            return removeResult.keep();
          }
        }
      }
      if (format.remove !== 'none') {
        removeNode(ed, elm, format);
        return removeResult.removed();
      }
      return removeResult.keep();
    };
    var removeFormat$1 = function (ed, format, vars, node, compareNode) {
      return removeFormatInternal(ed, format, vars, node, compareNode).fold(never, function (newName) {
        ed.dom.rename(node, newName);
        return true;
      }, always);
    };
    var findFormatRoot = function (editor, container, name, vars, similar) {
      var formatRoot;
      each$k(getParents$2(editor.dom, container.parentNode).reverse(), function (parent) {
        if (!formatRoot && parent.id !== '_start' && parent.id !== '_end') {
          var format = matchNode(editor, parent, name, vars, similar);
          if (format && format.split !== false) {
            formatRoot = parent;
          }
        }
      });
      return formatRoot;
    };
    var removeFormatFromClone = function (editor, format, vars, clone) {
      return removeFormatInternal(editor, format, vars, clone, clone).fold(constant(clone), function (newName) {
        var fragment = editor.dom.createFragment();
        fragment.appendChild(clone);
        return editor.dom.rename(clone, newName);
      }, constant(null));
    };
    var wrapAndSplit = function (editor, formatList, formatRoot, container, target, split, format, vars) {
      var clone, lastClone, firstClone;
      var dom = editor.dom;
      if (formatRoot) {
        var formatRootParent = formatRoot.parentNode;
        for (var parent_1 = container.parentNode; parent_1 && parent_1 !== formatRootParent; parent_1 = parent_1.parentNode) {
          clone = dom.clone(parent_1, false);
          for (var i = 0; i < formatList.length; i++) {
            clone = removeFormatFromClone(editor, formatList[i], vars, clone);
            if (clone === null) {
              break;
            }
          }
          if (clone) {
            if (lastClone) {
              clone.appendChild(lastClone);
            }
            if (!firstClone) {
              firstClone = clone;
            }
            lastClone = clone;
          }
        }
        if (split && (!format.mixed || !dom.isBlock(formatRoot))) {
          container = dom.split(formatRoot, container);
        }
        if (lastClone) {
          target.parentNode.insertBefore(lastClone, target);
          firstClone.appendChild(target);
          if (isInlineFormat(format)) {
            mergeSiblings(dom, format, vars, lastClone);
          }
        }
      }
      return container;
    };
    var remove$1 = function (ed, name, vars, node, similar) {
      var formatList = ed.formatter.get(name);
      var format = formatList[0];
      var contentEditable = true;
      var dom = ed.dom;
      var selection = ed.selection;
      var splitToFormatRoot = function (container) {
        var formatRoot = findFormatRoot(ed, container, name, vars, similar);
        return wrapAndSplit(ed, formatList, formatRoot, container, container, true, format, vars);
      };
      var isRemoveBookmarkNode = function (node) {
        return isBookmarkNode$1(node) && isElement$5(node) && (node.id === '_start' || node.id === '_end');
      };
      var removeNodeFormat = function (node) {
        return exists(formatList, function (fmt) {
          return removeFormat$1(ed, fmt, vars, node, node);
        });
      };
      var process = function (node) {
        var lastContentEditable = true;
        var hasContentEditableState = false;
        if (isElement$5(node) && dom.getContentEditable(node)) {
          lastContentEditable = contentEditable;
          contentEditable = dom.getContentEditable(node) === 'true';
          hasContentEditableState = true;
        }
        var children = from(node.childNodes);
        if (contentEditable && !hasContentEditableState) {
          var removed = removeNodeFormat(node);
          var currentNodeMatches = removed || exists(formatList, function (f) {
            return matchName$1(dom, node, f);
          });
          var parentNode = node.parentNode;
          if (!currentNodeMatches && isNonNullable(parentNode) && shouldExpandToSelector(format)) {
            removeNodeFormat(parentNode);
          }
        }
        if (format.deep) {
          if (children.length) {
            for (var i = 0; i < children.length; i++) {
              process(children[i]);
            }
            if (hasContentEditableState) {
              contentEditable = lastContentEditable;
            }
          }
        }
        var textDecorations = [
          'underline',
          'line-through',
          'overline'
        ];
        each$k(textDecorations, function (decoration) {
          if (isElement$5(node) && ed.dom.getStyle(node, 'text-decoration') === decoration && node.parentNode && getTextDecoration(dom, node.parentNode) === decoration) {
            removeFormat$1(ed, {
              deep: false,
              exact: true,
              inline: 'span',
              styles: { textDecoration: decoration }
            }, null, node);
          }
        });
      };
      var unwrap = function (start) {
        var node = dom.get(start ? '_start' : '_end');
        var out = node[start ? 'firstChild' : 'lastChild'];
        if (isRemoveBookmarkNode(out)) {
          out = out[start ? 'firstChild' : 'lastChild'];
        }
        if (isText$7(out) && out.data.length === 0) {
          out = start ? node.previousSibling || node.nextSibling : node.nextSibling || node.previousSibling;
        }
        dom.remove(node, true);
        return out;
      };
      var removeRngStyle = function (rng) {
        var startContainer, endContainer;
        var expandedRng = expandRng(ed, rng, formatList, rng.collapsed);
        if (format.split) {
          expandedRng = split(expandedRng);
          startContainer = getContainer(ed, expandedRng, true);
          endContainer = getContainer(ed, expandedRng);
          if (startContainer !== endContainer) {
            startContainer = normalizeTableSelection(startContainer, true);
            endContainer = normalizeTableSelection(endContainer, false);
            if (isChildOfInlineParent(dom, startContainer, endContainer)) {
              var marker = Optional.from(startContainer.firstChild).getOr(startContainer);
              splitToFormatRoot(wrapWithSiblings(dom, marker, true, 'span', {
                'id': '_start',
                'data-mce-type': 'bookmark'
              }));
              unwrap(true);
              return;
            }
            if (isChildOfInlineParent(dom, endContainer, startContainer)) {
              var marker = Optional.from(endContainer.lastChild).getOr(endContainer);
              splitToFormatRoot(wrapWithSiblings(dom, marker, false, 'span', {
                'id': '_end',
                'data-mce-type': 'bookmark'
              }));
              unwrap(false);
              return;
            }
            startContainer = wrap$1(dom, startContainer, 'span', {
              'id': '_start',
              'data-mce-type': 'bookmark'
            });
            endContainer = wrap$1(dom, endContainer, 'span', {
              'id': '_end',
              'data-mce-type': 'bookmark'
            });
            var newRng = dom.createRng();
            newRng.setStartAfter(startContainer);
            newRng.setEndBefore(endContainer);
            walk$2(dom, newRng, function (nodes) {
              each$k(nodes, function (n) {
                if (!isBookmarkNode$1(n) && !isBookmarkNode$1(n.parentNode)) {
                  splitToFormatRoot(n);
                }
              });
            });
            splitToFormatRoot(startContainer);
            splitToFormatRoot(endContainer);
            startContainer = unwrap(true);
            endContainer = unwrap();
          } else {
            startContainer = endContainer = splitToFormatRoot(startContainer);
          }
          expandedRng.startContainer = startContainer.parentNode ? startContainer.parentNode : startContainer;
          expandedRng.startOffset = dom.nodeIndex(startContainer);
          expandedRng.endContainer = endContainer.parentNode ? endContainer.parentNode : endContainer;
          expandedRng.endOffset = dom.nodeIndex(endContainer) + 1;
        }
        walk$2(dom, expandedRng, function (nodes) {
          each$k(nodes, process);
        });
      };
      if (node) {
        if (isNode(node)) {
          var rng = dom.createRng();
          rng.setStartBefore(node);
          rng.setEndAfter(node);
          removeRngStyle(rng);
        } else {
          removeRngStyle(node);
        }
        fireFormatRemove(ed, name, node, vars);
        return;
      }
      if (dom.getContentEditable(selection.getNode()) === 'false') {
        node = selection.getNode();
        for (var i = 0; i < formatList.length; i++) {
          if (formatList[i].ceFalseOverride) {
            if (removeFormat$1(ed, formatList[i], vars, node, node)) {
              break;
            }
          }
        }
        fireFormatRemove(ed, name, node, vars);
        return;
      }
      if (!selection.isCollapsed() || !isInlineFormat(format) || getCellsFromEditor(ed).length) {
        preserve(selection, true, function () {
          runOnRanges(ed, removeRngStyle);
        });
        if (isInlineFormat(format) && match$2(ed, name, vars, selection.getStart())) {
          moveStart(dom, selection, selection.getRng());
        }
        ed.nodeChanged();
      } else {
        removeCaretFormat(ed, name, vars, similar);
      }
      fireFormatRemove(ed, name, node, vars);
    };

    var each$8 = Tools.each;
    var mergeTextDecorationsAndColor = function (dom, format, vars, node) {
      var processTextDecorationsAndColor = function (n) {
        if (n.nodeType === 1 && n.parentNode && n.parentNode.nodeType === 1) {
          var textDecoration = getTextDecoration(dom, n.parentNode);
          if (dom.getStyle(n, 'color') && textDecoration) {
            dom.setStyle(n, 'text-decoration', textDecoration);
          } else if (dom.getStyle(n, 'text-decoration') === textDecoration) {
            dom.setStyle(n, 'text-decoration', null);
          }
        }
      };
      if (format.styles && (format.styles.color || format.styles.textDecoration)) {
        Tools.walk(node, processTextDecorationsAndColor, 'childNodes');
        processTextDecorationsAndColor(node);
      }
    };
    var mergeBackgroundColorAndFontSize = function (dom, format, vars, node) {
      if (format.styles && format.styles.backgroundColor) {
        processChildElements(node, hasStyle(dom, 'fontSize'), applyStyle(dom, 'backgroundColor', replaceVars(format.styles.backgroundColor, vars)));
      }
    };
    var mergeSubSup = function (dom, format, vars, node) {
      if (isInlineFormat(format) && (format.inline === 'sub' || format.inline === 'sup')) {
        processChildElements(node, hasStyle(dom, 'fontSize'), applyStyle(dom, 'fontSize', ''));
        dom.remove(dom.select(format.inline === 'sup' ? 'sub' : 'sup', node), true);
      }
    };
    var mergeWithChildren = function (editor, formatList, vars, node) {
      each$8(formatList, function (format) {
        if (isInlineFormat(format)) {
          each$8(editor.dom.select(format.inline, node), function (child) {
            if (!isElementNode$1(child)) {
              return;
            }
            removeFormat$1(editor, format, vars, child, format.exact ? child : null);
          });
        }
        clearChildStyles(editor.dom, format, node);
      });
    };
    var mergeWithParents = function (editor, format, name, vars, node) {
      if (matchNode(editor, node.parentNode, name, vars)) {
        if (removeFormat$1(editor, format, vars, node)) {
          return;
        }
      }
      if (format.merge_with_parents) {
        editor.dom.getParent(node.parentNode, function (parent) {
          if (matchNode(editor, parent, name, vars)) {
            removeFormat$1(editor, format, vars, node);
            return true;
          }
        });
      }
    };

    var each$7 = Tools.each;
    var isElementNode = function (node) {
      return isElement$5(node) && !isBookmarkNode$1(node) && !isCaretNode(node) && !isBogus$2(node);
    };
    var canFormatBR = function (editor, format, node, parentName) {
      if (canFormatEmptyLines(editor) && isInlineFormat(format)) {
        var validBRParentElements = getTextRootBlockElements(editor.schema);
        var hasCaretNodeSibling = sibling(SugarElement.fromDom(node), function (sibling) {
          return isCaretNode(sibling.dom);
        });
        return hasNonNullableKey(validBRParentElements, parentName) && isEmpty$2(SugarElement.fromDom(node.parentNode), false) && !hasCaretNodeSibling;
      } else {
        return false;
      }
    };
    var applyFormat$1 = function (ed, name, vars, node) {
      var formatList = ed.formatter.get(name);
      var format = formatList[0];
      var isCollapsed = !node && ed.selection.isCollapsed();
      var dom = ed.dom;
      var selection = ed.selection;
      var setElementFormat = function (elm, fmt) {
        if (fmt === void 0) {
          fmt = format;
        }
        if (isFunction(fmt.onformat)) {
          fmt.onformat(elm, fmt, vars, node);
        }
        each$7(fmt.styles, function (value, name) {
          dom.setStyle(elm, name, replaceVars(value, vars));
        });
        if (fmt.styles) {
          var styleVal = dom.getAttrib(elm, 'style');
          if (styleVal) {
            dom.setAttrib(elm, 'data-mce-style', styleVal);
          }
        }
        each$7(fmt.attributes, function (value, name) {
          dom.setAttrib(elm, name, replaceVars(value, vars));
        });
        each$7(fmt.classes, function (value) {
          value = replaceVars(value, vars);
          if (!dom.hasClass(elm, value)) {
            dom.addClass(elm, value);
          }
        });
      };
      var applyNodeStyle = function (formatList, node) {
        var found = false;
        each$7(formatList, function (format) {
          if (!isSelectorFormat(format)) {
            return false;
          }
          if (isNonNullable(format.collapsed) && format.collapsed !== isCollapsed) {
            return;
          }
          if (dom.is(node, format.selector) && !isCaretNode(node)) {
            setElementFormat(node, format);
            found = true;
            return false;
          }
        });
        return found;
      };
      var createWrapElement = function (wrapName) {
        if (isString$1(wrapName)) {
          var wrapElm = dom.create(wrapName);
          setElementFormat(wrapElm);
          return wrapElm;
        } else {
          return null;
        }
      };
      var applyRngStyle = function (dom, rng, nodeSpecific) {
        var newWrappers = [];
        var contentEditable = true;
        var wrapName = format.inline || format.block;
        var wrapElm = createWrapElement(wrapName);
        walk$2(dom, rng, function (nodes) {
          var currentWrapElm;
          var process = function (node) {
            var hasContentEditableState = false;
            var lastContentEditable = contentEditable;
            var nodeName = node.nodeName.toLowerCase();
            var parentNode = node.parentNode;
            var parentName = parentNode.nodeName.toLowerCase();
            if (isElement$5(node) && dom.getContentEditable(node)) {
              lastContentEditable = contentEditable;
              contentEditable = dom.getContentEditable(node) === 'true';
              hasContentEditableState = true;
            }
            if (isBr$5(node) && !canFormatBR(ed, format, node, parentName)) {
              currentWrapElm = null;
              if (isBlockFormat(format)) {
                dom.remove(node);
              }
              return;
            }
            if (isBlockFormat(format) && format.wrapper && matchNode(ed, node, name, vars)) {
              currentWrapElm = null;
              return;
            }
            if (contentEditable && !hasContentEditableState && isBlockFormat(format) && !format.wrapper && isTextBlock$1(ed, nodeName) && isValid(ed, parentName, wrapName)) {
              var elm = dom.rename(node, wrapName);
              setElementFormat(elm);
              newWrappers.push(elm);
              currentWrapElm = null;
              return;
            }
            if (isSelectorFormat(format)) {
              var found = applyNodeStyle(formatList, node);
              if (!found && isNonNullable(parentNode) && shouldExpandToSelector(format)) {
                found = applyNodeStyle(formatList, parentNode);
              }
              if (!isInlineFormat(format) || found) {
                currentWrapElm = null;
                return;
              }
            }
            if (contentEditable && !hasContentEditableState && isValid(ed, wrapName, nodeName) && isValid(ed, parentName, wrapName) && !(!nodeSpecific && isText$7(node) && isZwsp(node.data)) && !isCaretNode(node) && (!isInlineFormat(format) || !dom.isBlock(node))) {
              if (!currentWrapElm) {
                currentWrapElm = dom.clone(wrapElm, false);
                node.parentNode.insertBefore(currentWrapElm, node);
                newWrappers.push(currentWrapElm);
              }
              currentWrapElm.appendChild(node);
            } else {
              currentWrapElm = null;
              each$k(from(node.childNodes), process);
              if (hasContentEditableState) {
                contentEditable = lastContentEditable;
              }
              currentWrapElm = null;
            }
          };
          each$k(nodes, process);
        });
        if (format.links === true) {
          each$k(newWrappers, function (node) {
            var process = function (node) {
              if (node.nodeName === 'A') {
                setElementFormat(node, format);
              }
              each$k(from(node.childNodes), process);
            };
            process(node);
          });
        }
        each$k(newWrappers, function (node) {
          var getChildCount = function (node) {
            var count = 0;
            each$k(node.childNodes, function (node) {
              if (!isEmptyTextNode$1(node) && !isBookmarkNode$1(node)) {
                count++;
              }
            });
            return count;
          };
          var mergeStyles = function (node) {
            var childElement = find$3(node.childNodes, isElementNode).filter(function (child) {
              return matchName$1(dom, child, format);
            });
            return childElement.map(function (child) {
              var clone = dom.clone(child, false);
              setElementFormat(clone);
              dom.replace(clone, node, true);
              dom.remove(child, true);
              return clone;
            }).getOr(node);
          };
          var childCount = getChildCount(node);
          if ((newWrappers.length > 1 || !dom.isBlock(node)) && childCount === 0) {
            dom.remove(node, true);
            return;
          }
          if (isInlineFormat(format) || isBlockFormat(format) && format.wrapper) {
            if (!format.exact && childCount === 1) {
              node = mergeStyles(node);
            }
            mergeWithChildren(ed, formatList, vars, node);
            mergeWithParents(ed, format, name, vars, node);
            mergeBackgroundColorAndFontSize(dom, format, vars, node);
            mergeTextDecorationsAndColor(dom, format, vars, node);
            mergeSubSup(dom, format, vars, node);
            mergeSiblings(dom, format, vars, node);
          }
        });
      };
      if (dom.getContentEditable(selection.getNode()) === 'false') {
        node = selection.getNode();
        for (var i = 0, l = formatList.length; i < l; i++) {
          var formatItem = formatList[i];
          if (formatItem.ceFalseOverride && isSelectorFormat(formatItem) && dom.is(node, formatItem.selector)) {
            setElementFormat(node, formatItem);
            break;
          }
        }
        fireFormatApply(ed, name, node, vars);
        return;
      }
      if (format) {
        if (node) {
          if (isNode(node)) {
            if (!applyNodeStyle(formatList, node)) {
              var rng = dom.createRng();
              rng.setStartBefore(node);
              rng.setEndAfter(node);
              applyRngStyle(dom, expandRng(ed, rng, formatList), true);
            }
          } else {
            applyRngStyle(dom, node, true);
          }
        } else {
          if (!isCollapsed || !isInlineFormat(format) || getCellsFromEditor(ed).length) {
            var curSelNode = selection.getNode();
            var firstFormat = formatList[0];
            if (!ed.settings.forced_root_block && firstFormat.defaultBlock && !dom.getParent(curSelNode, dom.isBlock)) {
              applyFormat$1(ed, firstFormat.defaultBlock);
            }
            selection.setRng(normalize(selection.getRng()));
            preserve(selection, true, function () {
              runOnRanges(ed, function (selectionRng, fake) {
                var expandedRng = fake ? selectionRng : expandRng(ed, selectionRng, formatList);
                applyRngStyle(dom, expandedRng, false);
              });
            });
            moveStart(dom, selection, selection.getRng());
            ed.nodeChanged();
          } else {
            applyCaretFormat(ed, name, vars);
          }
        }
        postProcess$1(name, ed);
      }
      fireFormatApply(ed, name, node, vars);
    };

    var hasVars = function (value) {
      return has$2(value, 'vars');
    };
    var setup$j = function (registeredFormatListeners, editor) {
      registeredFormatListeners.set({});
      editor.on('NodeChange', function (e) {
        updateAndFireChangeCallbacks(editor, e.element, registeredFormatListeners.get());
      });
      editor.on('FormatApply FormatRemove', function (e) {
        var element = Optional.from(e.node).map(function (nodeOrRange) {
          return isNode(nodeOrRange) ? nodeOrRange : nodeOrRange.startContainer;
        }).bind(function (node) {
          return isElement$5(node) ? Optional.some(node) : Optional.from(node.parentElement);
        }).getOrThunk(function () {
          return fallbackElement(editor);
        });
        updateAndFireChangeCallbacks(editor, element, registeredFormatListeners.get());
      });
    };
    var fallbackElement = function (editor) {
      return editor.selection.getStart();
    };
    var matchingNode = function (editor, parents, format, similar, vars) {
      var isMatchingNode = function (node) {
        var matchingFormat = editor.formatter.matchNode(node, format, vars !== null && vars !== void 0 ? vars : {}, similar);
        return !isUndefined(matchingFormat);
      };
      var isUnableToMatch = function (node) {
        if (matchesUnInheritedFormatSelector(editor, node, format)) {
          return true;
        } else {
          if (!similar) {
            return isNonNullable(editor.formatter.matchNode(node, format, vars, true));
          } else {
            return false;
          }
        }
      };
      return findUntil$1(parents, isMatchingNode, isUnableToMatch);
    };
    var getParents = function (editor, elm) {
      var element = elm !== null && elm !== void 0 ? elm : fallbackElement(editor);
      return filter$4(getParents$2(editor.dom, element), function (node) {
        return isElement$5(node) && !isBogus$2(node);
      });
    };
    var updateAndFireChangeCallbacks = function (editor, elm, registeredCallbacks) {
      var parents = getParents(editor, elm);
      each$j(registeredCallbacks, function (data, format) {
        var runIfChanged = function (spec) {
          var match = matchingNode(editor, parents, format, spec.similar, hasVars(spec) ? spec.vars : undefined);
          var isSet = match.isSome();
          if (spec.state.get() !== isSet) {
            spec.state.set(isSet);
            var node_1 = match.getOr(elm);
            if (hasVars(spec)) {
              spec.callback(isSet, {
                node: node_1,
                format: format,
                parents: parents
              });
            } else {
              each$k(spec.callbacks, function (callback) {
                return callback(isSet, {
                  node: node_1,
                  format: format,
                  parents: parents
                });
              });
            }
          }
        };
        each$k([
          data.withSimilar,
          data.withoutSimilar
        ], runIfChanged);
        each$k(data.withVars, runIfChanged);
      });
    };
    var addListeners = function (editor, registeredFormatListeners, formats, callback, similar, vars) {
      var formatChangeItems = registeredFormatListeners.get();
      each$k(formats.split(','), function (format) {
        var group = get$9(formatChangeItems, format).getOrThunk(function () {
          var base = {
            withSimilar: {
              state: Cell(false),
              similar: true,
              callbacks: []
            },
            withoutSimilar: {
              state: Cell(false),
              similar: false,
              callbacks: []
            },
            withVars: []
          };
          formatChangeItems[format] = base;
          return base;
        });
        var getCurrent = function () {
          var parents = getParents(editor);
          return matchingNode(editor, parents, format, similar, vars).isSome();
        };
        if (isUndefined(vars)) {
          var toAppendTo = similar ? group.withSimilar : group.withoutSimilar;
          toAppendTo.callbacks.push(callback);
          if (toAppendTo.callbacks.length === 1) {
            toAppendTo.state.set(getCurrent());
          }
        } else {
          group.withVars.push({
            state: Cell(getCurrent()),
            similar: similar,
            vars: vars,
            callback: callback
          });
        }
      });
      registeredFormatListeners.set(formatChangeItems);
    };
    var removeListeners = function (registeredFormatListeners, formats, callback) {
      var formatChangeItems = registeredFormatListeners.get();
      each$k(formats.split(','), function (format) {
        return get$9(formatChangeItems, format).each(function (group) {
          formatChangeItems[format] = {
            withSimilar: __assign(__assign({}, group.withSimilar), {
              callbacks: filter$4(group.withSimilar.callbacks, function (cb) {
                return cb !== callback;
              })
            }),
            withoutSimilar: __assign(__assign({}, group.withoutSimilar), {
              callbacks: filter$4(group.withoutSimilar.callbacks, function (cb) {
                return cb !== callback;
              })
            }),
            withVars: filter$4(group.withVars, function (item) {
              return item.callback !== callback;
            })
          };
        });
      });
      registeredFormatListeners.set(formatChangeItems);
    };
    var formatChangedInternal = function (editor, registeredFormatListeners, formats, callback, similar, vars) {
      if (registeredFormatListeners.get() === null) {
        setup$j(registeredFormatListeners, editor);
      }
      addListeners(editor, registeredFormatListeners, formats, callback, similar, vars);
      return {
        unbind: function () {
          return removeListeners(registeredFormatListeners, formats, callback);
        }
      };
    };

    var toggle = function (editor, name, vars, node) {
      var fmt = editor.formatter.get(name);
      if (match$2(editor, name, vars, node) && (!('toggle' in fmt[0]) || fmt[0].toggle)) {
        remove$1(editor, name, vars, node);
      } else {
        applyFormat$1(editor, name, vars, node);
      }
    };

    var fromElements = function (elements, scope) {
      var doc = scope || document;
      var fragment = doc.createDocumentFragment();
      each$k(elements, function (element) {
        fragment.appendChild(element.dom);
      });
      return SugarElement.fromDom(fragment);
    };

    var tableModel = function (element, width, rows) {
      return {
        element: element,
        width: width,
        rows: rows
      };
    };
    var tableRow = function (element, cells) {
      return {
        element: element,
        cells: cells
      };
    };
    var cellPosition = function (x, y) {
      return {
        x: x,
        y: y
      };
    };
    var getSpan = function (td, key) {
      var value = parseInt(get$6(td, key), 10);
      return isNaN(value) ? 1 : value;
    };
    var fillout = function (table, x, y, tr, td) {
      var rowspan = getSpan(td, 'rowspan');
      var colspan = getSpan(td, 'colspan');
      var rows = table.rows;
      for (var y2 = y; y2 < y + rowspan; y2++) {
        if (!rows[y2]) {
          rows[y2] = tableRow(deep$1(tr), []);
        }
        for (var x2 = x; x2 < x + colspan; x2++) {
          var cells = rows[y2].cells;
          cells[x2] = y2 === y && x2 === x ? td : shallow(td);
        }
      }
    };
    var cellExists = function (table, x, y) {
      var rows = table.rows;
      var cells = rows[y] ? rows[y].cells : [];
      return !!cells[x];
    };
    var skipCellsX = function (table, x, y) {
      while (cellExists(table, x, y)) {
        x++;
      }
      return x;
    };
    var getWidth = function (rows) {
      return foldl(rows, function (acc, row) {
        return row.cells.length > acc ? row.cells.length : acc;
      }, 0);
    };
    var findElementPos = function (table, element) {
      var rows = table.rows;
      for (var y = 0; y < rows.length; y++) {
        var cells = rows[y].cells;
        for (var x = 0; x < cells.length; x++) {
          if (eq(cells[x], element)) {
            return Optional.some(cellPosition(x, y));
          }
        }
      }
      return Optional.none();
    };
    var extractRows = function (table, sx, sy, ex, ey) {
      var newRows = [];
      var rows = table.rows;
      for (var y = sy; y <= ey; y++) {
        var cells = rows[y].cells;
        var slice = sx < ex ? cells.slice(sx, ex + 1) : cells.slice(ex, sx + 1);
        newRows.push(tableRow(rows[y].element, slice));
      }
      return newRows;
    };
    var subTable = function (table, startPos, endPos) {
      var sx = startPos.x, sy = startPos.y;
      var ex = endPos.x, ey = endPos.y;
      var newRows = sy < ey ? extractRows(table, sx, sy, ex, ey) : extractRows(table, sx, ey, ex, sy);
      return tableModel(table.element, getWidth(newRows), newRows);
    };
    var createDomTable = function (table, rows) {
      var tableElement = shallow(table.element);
      var tableBody = SugarElement.fromTag('tbody');
      append(tableBody, rows);
      append$1(tableElement, tableBody);
      return tableElement;
    };
    var modelRowsToDomRows = function (table) {
      return map$3(table.rows, function (row) {
        var cells = map$3(row.cells, function (cell) {
          var td = deep$1(cell);
          remove$6(td, 'colspan');
          remove$6(td, 'rowspan');
          return td;
        });
        var tr = shallow(row.element);
        append(tr, cells);
        return tr;
      });
    };
    var fromDom = function (tableElm) {
      var table = tableModel(shallow(tableElm), 0, []);
      each$k(descendants(tableElm, 'tr'), function (tr, y) {
        each$k(descendants(tr, 'td,th'), function (td, x) {
          fillout(table, skipCellsX(table, x, y), y, tr, td);
        });
      });
      return tableModel(table.element, getWidth(table.rows), table.rows);
    };
    var toDom = function (table) {
      return createDomTable(table, modelRowsToDomRows(table));
    };
    var subsection = function (table, startElement, endElement) {
      return findElementPos(table, startElement).bind(function (startPos) {
        return findElementPos(table, endElement).map(function (endPos) {
          return subTable(table, startPos, endPos);
        });
      });
    };

    var findParentListContainer = function (parents) {
      return find$3(parents, function (elm) {
        return name(elm) === 'ul' || name(elm) === 'ol';
      });
    };
    var getFullySelectedListWrappers = function (parents, rng) {
      return find$3(parents, function (elm) {
        return name(elm) === 'li' && hasAllContentsSelected(elm, rng);
      }).fold(constant([]), function (_li) {
        return findParentListContainer(parents).map(function (listCont) {
          var listElm = SugarElement.fromTag(name(listCont));
          var listStyles = filter$3(getAllRaw(listCont), function (_style, name) {
            return startsWith(name, 'list-style');
          });
          setAll(listElm, listStyles);
          return [
            SugarElement.fromTag('li'),
            listElm
          ];
        }).getOr([]);
      });
    };
    var wrap = function (innerElm, elms) {
      var wrapped = foldl(elms, function (acc, elm) {
        append$1(elm, acc);
        return elm;
      }, innerElm);
      return elms.length > 0 ? fromElements([wrapped]) : wrapped;
    };
    var directListWrappers = function (commonAnchorContainer) {
      if (isListItem(commonAnchorContainer)) {
        return parent(commonAnchorContainer).filter(isList).fold(constant([]), function (listElm) {
          return [
            commonAnchorContainer,
            listElm
          ];
        });
      } else {
        return isList(commonAnchorContainer) ? [commonAnchorContainer] : [];
      }
    };
    var getWrapElements = function (rootNode, rng) {
      var commonAnchorContainer = SugarElement.fromDom(rng.commonAncestorContainer);
      var parents = parentsAndSelf(commonAnchorContainer, rootNode);
      var wrapElements = filter$4(parents, function (elm) {
        return isInline$1(elm) || isHeading(elm);
      });
      var listWrappers = getFullySelectedListWrappers(parents, rng);
      var allWrappers = wrapElements.concat(listWrappers.length ? listWrappers : directListWrappers(commonAnchorContainer));
      return map$3(allWrappers, shallow);
    };
    var emptyFragment = function () {
      return fromElements([]);
    };
    var getFragmentFromRange = function (rootNode, rng) {
      return wrap(SugarElement.fromDom(rng.cloneContents()), getWrapElements(rootNode, rng));
    };
    var getParentTable = function (rootElm, cell) {
      return ancestor$2(cell, 'table', curry(eq, rootElm));
    };
    var getTableFragment = function (rootNode, selectedTableCells) {
      return getParentTable(rootNode, selectedTableCells[0]).bind(function (tableElm) {
        var firstCell = selectedTableCells[0];
        var lastCell = selectedTableCells[selectedTableCells.length - 1];
        var fullTableModel = fromDom(tableElm);
        return subsection(fullTableModel, firstCell, lastCell).map(function (sectionedTableModel) {
          return fromElements([toDom(sectionedTableModel)]);
        });
      }).getOrThunk(emptyFragment);
    };
    var getSelectionFragment = function (rootNode, ranges) {
      return ranges.length > 0 && ranges[0].collapsed ? emptyFragment() : getFragmentFromRange(rootNode, ranges[0]);
    };
    var read$3 = function (rootNode, ranges) {
      var selectedCells = getCellsFromElementOrRanges(ranges, rootNode);
      return selectedCells.length > 0 ? getTableFragment(rootNode, selectedCells) : getSelectionFragment(rootNode, ranges);
    };

    var trimLeadingCollapsibleText = function (text) {
      return text.replace(/^[ \f\n\r\t\v]+/, '');
    };
    var isCollapsibleWhitespace = function (text, index) {
      return index >= 0 && index < text.length && isWhiteSpace(text.charAt(index));
    };
    var getInnerText = function (bin, shouldTrim) {
      var text = trim$2(bin.innerText);
      return shouldTrim ? trimLeadingCollapsibleText(text) : text;
    };
    var getContextNodeName = function (parentBlockOpt) {
      return parentBlockOpt.map(function (block) {
        return block.nodeName;
      }).getOr('div').toLowerCase();
    };
    var getTextContent = function (editor) {
      return Optional.from(editor.selection.getRng()).map(function (rng) {
        var parentBlockOpt = Optional.from(editor.dom.getParent(rng.commonAncestorContainer, editor.dom.isBlock));
        var body = editor.getBody();
        var contextNodeName = getContextNodeName(parentBlockOpt);
        var shouldTrimSpaces = Env.browser.isIE() && contextNodeName !== 'pre';
        var bin = editor.dom.add(body, contextNodeName, {
          'data-mce-bogus': 'all',
          'style': 'overflow: hidden; opacity: 0;'
        }, rng.cloneContents());
        var text = getInnerText(bin, shouldTrimSpaces);
        var nonRenderedText = trim$2(bin.textContent);
        editor.dom.remove(bin);
        if (isCollapsibleWhitespace(nonRenderedText, 0) || isCollapsibleWhitespace(nonRenderedText, nonRenderedText.length - 1)) {
          var parentBlock = parentBlockOpt.getOr(body);
          var parentBlockText = getInnerText(parentBlock, shouldTrimSpaces);
          var textIndex = parentBlockText.indexOf(text);
          if (textIndex === -1) {
            return text;
          } else {
            var hasProceedingSpace = isCollapsibleWhitespace(parentBlockText, textIndex - 1);
            var hasTrailingSpace = isCollapsibleWhitespace(parentBlockText, textIndex + text.length);
            return (hasProceedingSpace ? ' ' : '') + text + (hasTrailingSpace ? ' ' : '');
          }
        } else {
          return text;
        }
      }).getOr('');
    };
    var getSerializedContent = function (editor, args) {
      var rng = editor.selection.getRng(), tmpElm = editor.dom.create('body');
      var sel = editor.selection.getSel();
      var ranges = processRanges(editor, getRanges(sel));
      var fragment = args.contextual ? read$3(SugarElement.fromDom(editor.getBody()), ranges).dom : rng.cloneContents();
      if (fragment) {
        tmpElm.appendChild(fragment);
      }
      return editor.selection.serializer.serialize(tmpElm, args);
    };
    var setupArgs$1 = function (args, format) {
      return __assign(__assign({}, args), {
        format: format,
        get: true,
        selection: true
      });
    };
    var getSelectedContentInternal = function (editor, format, args) {
      if (args === void 0) {
        args = {};
      }
      var defaultedArgs = setupArgs$1(args, format);
      var updatedArgs = editor.fire('BeforeGetContent', defaultedArgs);
      if (updatedArgs.isDefaultPrevented()) {
        editor.fire('GetContent', updatedArgs);
        return updatedArgs.content;
      }
      if (updatedArgs.format === 'text') {
        return getTextContent(editor);
      } else {
        updatedArgs.getInner = true;
        var content = getSerializedContent(editor, updatedArgs);
        if (updatedArgs.format === 'tree') {
          return content;
        } else {
          updatedArgs.content = editor.selection.isCollapsed() ? '' : content;
          editor.fire('GetContent', updatedArgs);
          return updatedArgs.content;
        }
      }
    };

    var KEEP = 0, INSERT = 1, DELETE = 2;
    var diff = function (left, right) {
      var size = left.length + right.length + 2;
      var vDown = new Array(size);
      var vUp = new Array(size);
      var snake = function (start, end, diag) {
        return {
          start: start,
          end: end,
          diag: diag
        };
      };
      var buildScript = function (start1, end1, start2, end2, script) {
        var middle = getMiddleSnake(start1, end1, start2, end2);
        if (middle === null || middle.start === end1 && middle.diag === end1 - end2 || middle.end === start1 && middle.diag === start1 - start2) {
          var i = start1;
          var j = start2;
          while (i < end1 || j < end2) {
            if (i < end1 && j < end2 && left[i] === right[j]) {
              script.push([
                KEEP,
                left[i]
              ]);
              ++i;
              ++j;
            } else {
              if (end1 - start1 > end2 - start2) {
                script.push([
                  DELETE,
                  left[i]
                ]);
                ++i;
              } else {
                script.push([
                  INSERT,
                  right[j]
                ]);
                ++j;
              }
            }
          }
        } else {
          buildScript(start1, middle.start, start2, middle.start - middle.diag, script);
          for (var i2 = middle.start; i2 < middle.end; ++i2) {
            script.push([
              KEEP,
              left[i2]
            ]);
          }
          buildScript(middle.end, end1, middle.end - middle.diag, end2, script);
        }
      };
      var buildSnake = function (start, diag, end1, end2) {
        var end = start;
        while (end - diag < end2 && end < end1 && left[end] === right[end - diag]) {
          ++end;
        }
        return snake(start, end, diag);
      };
      var getMiddleSnake = function (start1, end1, start2, end2) {
        var m = end1 - start1;
        var n = end2 - start2;
        if (m === 0 || n === 0) {
          return null;
        }
        var delta = m - n;
        var sum = n + m;
        var offset = (sum % 2 === 0 ? sum : sum + 1) / 2;
        vDown[1 + offset] = start1;
        vUp[1 + offset] = end1 + 1;
        var d, k, i, x, y;
        for (d = 0; d <= offset; ++d) {
          for (k = -d; k <= d; k += 2) {
            i = k + offset;
            if (k === -d || k !== d && vDown[i - 1] < vDown[i + 1]) {
              vDown[i] = vDown[i + 1];
            } else {
              vDown[i] = vDown[i - 1] + 1;
            }
            x = vDown[i];
            y = x - start1 + start2 - k;
            while (x < end1 && y < end2 && left[x] === right[y]) {
              vDown[i] = ++x;
              ++y;
            }
            if (delta % 2 !== 0 && delta - d <= k && k <= delta + d) {
              if (vUp[i - delta] <= vDown[i]) {
                return buildSnake(vUp[i - delta], k + start1 - start2, end1, end2);
              }
            }
          }
          for (k = delta - d; k <= delta + d; k += 2) {
            i = k + offset - delta;
            if (k === delta - d || k !== delta + d && vUp[i + 1] <= vUp[i - 1]) {
              vUp[i] = vUp[i + 1] - 1;
            } else {
              vUp[i] = vUp[i - 1];
            }
            x = vUp[i] - 1;
            y = x - start1 + start2 - k;
            while (x >= start1 && y >= start2 && left[x] === right[y]) {
              vUp[i] = x--;
              y--;
            }
            if (delta % 2 === 0 && -d <= k && k <= d) {
              if (vUp[i] <= vDown[i + delta]) {
                return buildSnake(vUp[i], k + start1 - start2, end1, end2);
              }
            }
          }
        }
      };
      var script = [];
      buildScript(0, left.length, 0, right.length, script);
      return script;
    };

    var getOuterHtml = function (elm) {
      if (isElement$5(elm)) {
        return elm.outerHTML;
      } else if (isText$7(elm)) {
        return Entities.encodeRaw(elm.data, false);
      } else if (isComment(elm)) {
        return '<!--' + elm.data + '-->';
      }
      return '';
    };
    var createFragment = function (html) {
      var node;
      var container = document.createElement('div');
      var frag = document.createDocumentFragment();
      if (html) {
        container.innerHTML = html;
      }
      while (node = container.firstChild) {
        frag.appendChild(node);
      }
      return frag;
    };
    var insertAt = function (elm, html, index) {
      var fragment = createFragment(html);
      if (elm.hasChildNodes() && index < elm.childNodes.length) {
        var target = elm.childNodes[index];
        target.parentNode.insertBefore(fragment, target);
      } else {
        elm.appendChild(fragment);
      }
    };
    var removeAt = function (elm, index) {
      if (elm.hasChildNodes() && index < elm.childNodes.length) {
        var target = elm.childNodes[index];
        target.parentNode.removeChild(target);
      }
    };
    var applyDiff = function (diff, elm) {
      var index = 0;
      each$k(diff, function (action) {
        if (action[0] === KEEP) {
          index++;
        } else if (action[0] === INSERT) {
          insertAt(elm, action[1], index);
          index++;
        } else if (action[0] === DELETE) {
          removeAt(elm, index);
        }
      });
    };
    var read$2 = function (elm) {
      return filter$4(map$3(from(elm.childNodes), getOuterHtml), function (item) {
        return item.length > 0;
      });
    };
    var write = function (fragments, elm) {
      var currentFragments = map$3(from(elm.childNodes), getOuterHtml);
      applyDiff(diff(currentFragments, fragments), elm);
      return elm;
    };

    var lazyTempDocument = cached(function () {
      return document.implementation.createHTMLDocument('undo');
    });
    var hasIframes = function (html) {
      return html.indexOf('</iframe>') !== -1;
    };
    var createFragmentedLevel = function (fragments) {
      return {
        type: 'fragmented',
        fragments: fragments,
        content: '',
        bookmark: null,
        beforeBookmark: null
      };
    };
    var createCompleteLevel = function (content) {
      return {
        type: 'complete',
        fragments: null,
        content: content,
        bookmark: null,
        beforeBookmark: null
      };
    };
    var createFromEditor = function (editor) {
      var fragments = read$2(editor.getBody());
      var trimmedFragments = bind(fragments, function (html) {
        var trimmed = trimInternal(editor.serializer, html);
        return trimmed.length > 0 ? [trimmed] : [];
      });
      var content = trimmedFragments.join('');
      return hasIframes(content) ? createFragmentedLevel(trimmedFragments) : createCompleteLevel(content);
    };
    var applyToEditor = function (editor, level, before) {
      var bookmark = before ? level.beforeBookmark : level.bookmark;
      if (level.type === 'fragmented') {
        write(level.fragments, editor.getBody());
      } else {
        editor.setContent(level.content, {
          format: 'raw',
          no_selection: isNonNullable(bookmark) && isPathBookmark(bookmark) ? !bookmark.isFakeCaret : true
        });
      }
      editor.selection.moveToBookmark(bookmark);
    };
    var getLevelContent = function (level) {
      return level.type === 'fragmented' ? level.fragments.join('') : level.content;
    };
    var getCleanLevelContent = function (level) {
      var elm = SugarElement.fromTag('body', lazyTempDocument());
      set(elm, getLevelContent(level));
      each$k(descendants(elm, '*[data-mce-bogus]'), unwrap);
      return get$3(elm);
    };
    var hasEqualContent = function (level1, level2) {
      return getLevelContent(level1) === getLevelContent(level2);
    };
    var hasEqualCleanedContent = function (level1, level2) {
      return getCleanLevelContent(level1) === getCleanLevelContent(level2);
    };
    var isEq$1 = function (level1, level2) {
      if (!level1 || !level2) {
        return false;
      } else if (hasEqualContent(level1, level2)) {
        return true;
      } else {
        return hasEqualCleanedContent(level1, level2);
      }
    };

    var isUnlocked = function (locks) {
      return locks.get() === 0;
    };

    var setTyping = function (undoManager, typing, locks) {
      if (isUnlocked(locks)) {
        undoManager.typing = typing;
      }
    };
    var endTyping = function (undoManager, locks) {
      if (undoManager.typing) {
        setTyping(undoManager, false, locks);
        undoManager.add();
      }
    };
    var endTypingLevelIgnoreLocks = function (undoManager) {
      if (undoManager.typing) {
        undoManager.typing = false;
        undoManager.add();
      }
    };

    var beforeChange$1 = function (editor, locks, beforeBookmark) {
      if (isUnlocked(locks)) {
        beforeBookmark.set(getUndoBookmark(editor.selection));
      }
    };
    var addUndoLevel$1 = function (editor, undoManager, index, locks, beforeBookmark, level, event) {
      var currentLevel = createFromEditor(editor);
      level = level || {};
      level = Tools.extend(level, currentLevel);
      if (isUnlocked(locks) === false || editor.removed) {
        return null;
      }
      var lastLevel = undoManager.data[index.get()];
      if (editor.fire('BeforeAddUndo', {
          level: level,
          lastLevel: lastLevel,
          originalEvent: event
        }).isDefaultPrevented()) {
        return null;
      }
      if (lastLevel && isEq$1(lastLevel, level)) {
        return null;
      }
      if (undoManager.data[index.get()]) {
        beforeBookmark.get().each(function (bm) {
          undoManager.data[index.get()].beforeBookmark = bm;
        });
      }
      var customUndoRedoLevels = getCustomUndoRedoLevels(editor);
      if (customUndoRedoLevels) {
        if (undoManager.data.length > customUndoRedoLevels) {
          for (var i = 0; i < undoManager.data.length - 1; i++) {
            undoManager.data[i] = undoManager.data[i + 1];
          }
          undoManager.data.length--;
          index.set(undoManager.data.length);
        }
      }
      level.bookmark = getUndoBookmark(editor.selection);
      if (index.get() < undoManager.data.length - 1) {
        undoManager.data.length = index.get() + 1;
      }
      undoManager.data.push(level);
      index.set(undoManager.data.length - 1);
      var args = {
        level: level,
        lastLevel: lastLevel,
        originalEvent: event
      };
      if (index.get() > 0) {
        editor.setDirty(true);
        editor.fire('AddUndo', args);
        editor.fire('change', args);
      } else {
        editor.fire('AddUndo', args);
      }
      return level;
    };
    var clear$1 = function (editor, undoManager, index) {
      undoManager.data = [];
      index.set(0);
      undoManager.typing = false;
      editor.fire('ClearUndos');
    };
    var extra$1 = function (editor, undoManager, index, callback1, callback2) {
      if (undoManager.transact(callback1)) {
        var bookmark = undoManager.data[index.get()].bookmark;
        var lastLevel = undoManager.data[index.get() - 1];
        applyToEditor(editor, lastLevel, true);
        if (undoManager.transact(callback2)) {
          undoManager.data[index.get() - 1].beforeBookmark = bookmark;
        }
      }
    };
    var redo$1 = function (editor, index, data) {
      var level;
      if (index.get() < data.length - 1) {
        index.set(index.get() + 1);
        level = data[index.get()];
        applyToEditor(editor, level, false);
        editor.setDirty(true);
        editor.fire('Redo', { level: level });
      }
      return level;
    };
    var undo$1 = function (editor, undoManager, locks, index) {
      var level;
      if (undoManager.typing) {
        undoManager.add();
        undoManager.typing = false;
        setTyping(undoManager, false, locks);
      }
      if (index.get() > 0) {
        index.set(index.get() - 1);
        level = undoManager.data[index.get()];
        applyToEditor(editor, level, true);
        editor.setDirty(true);
        editor.fire('Undo', { level: level });
      }
      return level;
    };
    var reset$1 = function (undoManager) {
      undoManager.clear();
      undoManager.add();
    };
    var hasUndo$1 = function (editor, undoManager, index) {
      return index.get() > 0 || undoManager.typing && undoManager.data[0] && !isEq$1(createFromEditor(editor), undoManager.data[0]);
    };
    var hasRedo$1 = function (undoManager, index) {
      return index.get() < undoManager.data.length - 1 && !undoManager.typing;
    };
    var transact$1 = function (undoManager, locks, callback) {
      endTyping(undoManager, locks);
      undoManager.beforeChange();
      undoManager.ignore(callback);
      return undoManager.add();
    };
    var ignore$1 = function (locks, callback) {
      try {
        locks.set(locks.get() + 1);
        callback();
      } finally {
        locks.set(locks.get() - 1);
      }
    };

    var addVisualInternal = function (editor, elm) {
      var dom = editor.dom;
      var scope = isNonNullable(elm) ? elm : editor.getBody();
      if (isUndefined(editor.hasVisual)) {
        editor.hasVisual = isVisualAidsEnabled(editor);
      }
      each$k(dom.select('table,a', scope), function (matchedElm) {
        switch (matchedElm.nodeName) {
        case 'TABLE':
          var cls = getVisualAidsTableClass(editor);
          var value = dom.getAttrib(matchedElm, 'border');
          if ((!value || value === '0') && editor.hasVisual) {
            dom.addClass(matchedElm, cls);
          } else {
            dom.removeClass(matchedElm, cls);
          }
          break;
        case 'A':
          if (!dom.getAttrib(matchedElm, 'href')) {
            var value_1 = dom.getAttrib(matchedElm, 'name') || matchedElm.id;
            var cls_1 = getVisualAidsAnchorClass(editor);
            if (value_1 && editor.hasVisual) {
              dom.addClass(matchedElm, cls_1);
            } else {
              dom.removeClass(matchedElm, cls_1);
            }
          }
          break;
        }
      });
      editor.fire('VisualAid', {
        element: elm,
        hasVisual: editor.hasVisual
      });
    };

    var makePlainAdaptor = function (editor) {
      return {
        undoManager: {
          beforeChange: function (locks, beforeBookmark) {
            return beforeChange$1(editor, locks, beforeBookmark);
          },
          add: function (undoManager, index, locks, beforeBookmark, level, event) {
            return addUndoLevel$1(editor, undoManager, index, locks, beforeBookmark, level, event);
          },
          undo: function (undoManager, locks, index) {
            return undo$1(editor, undoManager, locks, index);
          },
          redo: function (index, data) {
            return redo$1(editor, index, data);
          },
          clear: function (undoManager, index) {
            return clear$1(editor, undoManager, index);
          },
          reset: function (undoManager) {
            return reset$1(undoManager);
          },
          hasUndo: function (undoManager, index) {
            return hasUndo$1(editor, undoManager, index);
          },
          hasRedo: function (undoManager, index) {
            return hasRedo$1(undoManager, index);
          },
          transact: function (undoManager, locks, callback) {
            return transact$1(undoManager, locks, callback);
          },
          ignore: function (locks, callback) {
            return ignore$1(locks, callback);
          },
          extra: function (undoManager, index, callback1, callback2) {
            return extra$1(editor, undoManager, index, callback1, callback2);
          }
        },
        formatter: {
          match: function (name, vars, node, similar) {
            return match$2(editor, name, vars, node, similar);
          },
          matchAll: function (names, vars) {
            return matchAll(editor, names, vars);
          },
          matchNode: function (node, name, vars, similar) {
            return matchNode(editor, node, name, vars, similar);
          },
          canApply: function (name) {
            return canApply(editor, name);
          },
          closest: function (names) {
            return closest(editor, names);
          },
          apply: function (name, vars, node) {
            return applyFormat$1(editor, name, vars, node);
          },
          remove: function (name, vars, node, similar) {
            return remove$1(editor, name, vars, node, similar);
          },
          toggle: function (name, vars, node) {
            return toggle(editor, name, vars, node);
          },
          formatChanged: function (registeredFormatListeners, formats, callback, similar, vars) {
            return formatChangedInternal(editor, registeredFormatListeners, formats, callback, similar, vars);
          }
        },
        editor: {
          getContent: function (args, format) {
            return getContentInternal(editor, args, format);
          },
          setContent: function (content, args) {
            return setContentInternal(editor, content, args);
          },
          insertContent: function (value, details) {
            return insertHtmlAtCaret(editor, value, details);
          },
          addVisual: function (elm) {
            return addVisualInternal(editor, elm);
          }
        },
        selection: {
          getContent: function (format, args) {
            return getSelectedContentInternal(editor, format, args);
          }
        },
        raw: {
          getModel: function () {
            return Optional.none();
          }
        }
      };
    };
    var makeRtcAdaptor = function (rtcEditor) {
      var defaultVars = function (vars) {
        return isObject(vars) ? vars : {};
      };
      var undoManager = rtcEditor.undoManager, formatter = rtcEditor.formatter, editor = rtcEditor.editor, selection = rtcEditor.selection, raw = rtcEditor.raw;
      return {
        undoManager: {
          beforeChange: undoManager.beforeChange,
          add: undoManager.add,
          undo: undoManager.undo,
          redo: undoManager.redo,
          clear: undoManager.clear,
          reset: undoManager.reset,
          hasUndo: undoManager.hasUndo,
          hasRedo: undoManager.hasRedo,
          transact: function (_undoManager, _locks, fn) {
            return undoManager.transact(fn);
          },
          ignore: function (_locks, callback) {
            return undoManager.ignore(callback);
          },
          extra: function (_undoManager, _index, callback1, callback2) {
            return undoManager.extra(callback1, callback2);
          }
        },
        formatter: {
          match: function (name, vars, _node, similar) {
            return formatter.match(name, defaultVars(vars), similar);
          },
          matchAll: formatter.matchAll,
          matchNode: formatter.matchNode,
          canApply: function (name) {
            return formatter.canApply(name);
          },
          closest: function (names) {
            return formatter.closest(names);
          },
          apply: function (name, vars, _node) {
            return formatter.apply(name, defaultVars(vars));
          },
          remove: function (name, vars, _node, _similar) {
            return formatter.remove(name, defaultVars(vars));
          },
          toggle: function (name, vars, _node) {
            return formatter.toggle(name, defaultVars(vars));
          },
          formatChanged: function (_rfl, formats, callback, similar, vars) {
            return formatter.formatChanged(formats, callback, similar, vars);
          }
        },
        editor: {
          getContent: function (args, _format) {
            return editor.getContent(args);
          },
          setContent: function (content, args) {
            return editor.setContent(content, args);
          },
          insertContent: function (content, _details) {
            return editor.insertContent(content);
          },
          addVisual: editor.addVisual
        },
        selection: {
          getContent: function (_format, args) {
            return selection.getContent(args);
          }
        },
        raw: {
          getModel: function () {
            return Optional.some(raw.getRawModel());
          }
        }
      };
    };
    var makeNoopAdaptor = function () {
      var nul = constant(null);
      var empty = constant('');
      return {
        undoManager: {
          beforeChange: noop,
          add: nul,
          undo: nul,
          redo: nul,
          clear: noop,
          reset: noop,
          hasUndo: never,
          hasRedo: never,
          transact: nul,
          ignore: noop,
          extra: noop
        },
        formatter: {
          match: never,
          matchAll: constant([]),
          matchNode: constant(undefined),
          canApply: never,
          closest: empty,
          apply: noop,
          remove: noop,
          toggle: noop,
          formatChanged: constant({ unbind: noop })
        },
        editor: {
          getContent: empty,
          setContent: empty,
          insertContent: noop,
          addVisual: noop
        },
        selection: { getContent: empty },
        raw: { getModel: constant(Optional.none()) }
      };
    };
    var isRtc = function (editor) {
      return has$2(editor.plugins, 'rtc');
    };
    var getRtcSetup = function (editor) {
      return get$9(editor.plugins, 'rtc').bind(function (rtcPlugin) {
        return Optional.from(rtcPlugin.setup);
      });
    };
    var setup$i = function (editor) {
      var editorCast = editor;
      return getRtcSetup(editor).fold(function () {
        editorCast.rtcInstance = makePlainAdaptor(editor);
        return Optional.none();
      }, function (setup) {
        editorCast.rtcInstance = makeNoopAdaptor();
        return Optional.some(function () {
          return setup().then(function (rtcEditor) {
            editorCast.rtcInstance = makeRtcAdaptor(rtcEditor);
            return rtcEditor.rtc.isRemote;
          });
        });
      });
    };
    var getRtcInstanceWithFallback = function (editor) {
      return editor.rtcInstance ? editor.rtcInstance : makePlainAdaptor(editor);
    };
    var getRtcInstanceWithError = function (editor) {
      var rtcInstance = editor.rtcInstance;
      if (!rtcInstance) {
        throw new Error('Failed to get RTC instance not yet initialized.');
      } else {
        return rtcInstance;
      }
    };
    var beforeChange = function (editor, locks, beforeBookmark) {
      getRtcInstanceWithError(editor).undoManager.beforeChange(locks, beforeBookmark);
    };
    var addUndoLevel = function (editor, undoManager, index, locks, beforeBookmark, level, event) {
      return getRtcInstanceWithError(editor).undoManager.add(undoManager, index, locks, beforeBookmark, level, event);
    };
    var undo = function (editor, undoManager, locks, index) {
      return getRtcInstanceWithError(editor).undoManager.undo(undoManager, locks, index);
    };
    var redo = function (editor, index, data) {
      return getRtcInstanceWithError(editor).undoManager.redo(index, data);
    };
    var clear = function (editor, undoManager, index) {
      getRtcInstanceWithError(editor).undoManager.clear(undoManager, index);
    };
    var reset = function (editor, undoManager) {
      getRtcInstanceWithError(editor).undoManager.reset(undoManager);
    };
    var hasUndo = function (editor, undoManager, index) {
      return getRtcInstanceWithError(editor).undoManager.hasUndo(undoManager, index);
    };
    var hasRedo = function (editor, undoManager, index) {
      return getRtcInstanceWithError(editor).undoManager.hasRedo(undoManager, index);
    };
    var transact = function (editor, undoManager, locks, callback) {
      return getRtcInstanceWithError(editor).undoManager.transact(undoManager, locks, callback);
    };
    var ignore = function (editor, locks, callback) {
      getRtcInstanceWithError(editor).undoManager.ignore(locks, callback);
    };
    var extra = function (editor, undoManager, index, callback1, callback2) {
      getRtcInstanceWithError(editor).undoManager.extra(undoManager, index, callback1, callback2);
    };
    var matchFormat = function (editor, name, vars, node, similar) {
      return getRtcInstanceWithError(editor).formatter.match(name, vars, node, similar);
    };
    var matchAllFormats = function (editor, names, vars) {
      return getRtcInstanceWithError(editor).formatter.matchAll(names, vars);
    };
    var matchNodeFormat = function (editor, node, name, vars, similar) {
      return getRtcInstanceWithError(editor).formatter.matchNode(node, name, vars, similar);
    };
    var canApplyFormat = function (editor, name) {
      return getRtcInstanceWithError(editor).formatter.canApply(name);
    };
    var closestFormat = function (editor, names) {
      return getRtcInstanceWithError(editor).formatter.closest(names);
    };
    var applyFormat = function (editor, name, vars, node) {
      getRtcInstanceWithError(editor).formatter.apply(name, vars, node);
    };
    var removeFormat = function (editor, name, vars, node, similar) {
      getRtcInstanceWithError(editor).formatter.remove(name, vars, node, similar);
    };
    var toggleFormat = function (editor, name, vars, node) {
      getRtcInstanceWithError(editor).formatter.toggle(name, vars, node);
    };
    var formatChanged = function (editor, registeredFormatListeners, formats, callback, similar, vars) {
      return getRtcInstanceWithError(editor).formatter.formatChanged(registeredFormatListeners, formats, callback, similar, vars);
    };
    var getContent$2 = function (editor, args, format) {
      return getRtcInstanceWithFallback(editor).editor.getContent(args, format);
    };
    var setContent$2 = function (editor, content, args) {
      return getRtcInstanceWithFallback(editor).editor.setContent(content, args);
    };
    var insertContent = function (editor, value, details) {
      return getRtcInstanceWithFallback(editor).editor.insertContent(value, details);
    };
    var getSelectedContent = function (editor, format, args) {
      return getRtcInstanceWithError(editor).selection.getContent(format, args);
    };
    var addVisual$1 = function (editor, elm) {
      return getRtcInstanceWithError(editor).editor.addVisual(elm);
    };

    var getContent$1 = function (editor, args) {
      if (args === void 0) {
        args = {};
      }
      var format = args.format ? args.format : 'html';
      return getSelectedContent(editor, format, args);
    };

    var removeEmpty = function (text) {
      if (text.dom.length === 0) {
        remove$7(text);
        return Optional.none();
      } else {
        return Optional.some(text);
      }
    };
    var walkPastBookmark = function (node, start) {
      return node.filter(function (elm) {
        return BookmarkManager.isBookmarkNode(elm.dom);
      }).bind(start ? nextSibling : prevSibling);
    };
    var merge = function (outer, inner, rng, start) {
      var outerElm = outer.dom;
      var innerElm = inner.dom;
      var oldLength = start ? outerElm.length : innerElm.length;
      if (start) {
        mergeTextNodes(outerElm, innerElm, false, !start);
        rng.setStart(innerElm, oldLength);
      } else {
        mergeTextNodes(innerElm, outerElm, false, !start);
        rng.setEnd(innerElm, oldLength);
      }
    };
    var normalizeTextIfRequired = function (inner, start) {
      parent(inner).each(function (root) {
        var text = inner.dom;
        if (start && needsToBeNbspLeft(root, CaretPosition(text, 0))) {
          normalizeWhitespaceAfter(text, 0);
        } else if (!start && needsToBeNbspRight(root, CaretPosition(text, text.length))) {
          normalizeWhitespaceBefore(text, text.length);
        }
      });
    };
    var mergeAndNormalizeText = function (outerNode, innerNode, rng, start) {
      outerNode.bind(function (outer) {
        var normalizer = start ? normalizeWhitespaceBefore : normalizeWhitespaceAfter;
        normalizer(outer.dom, start ? outer.dom.length : 0);
        return innerNode.filter(isText$8).map(function (inner) {
          return merge(outer, inner, rng, start);
        });
      }).orThunk(function () {
        var innerTextNode = walkPastBookmark(innerNode, start).or(innerNode).filter(isText$8);
        return innerTextNode.map(function (inner) {
          return normalizeTextIfRequired(inner, start);
        });
      });
    };
    var rngSetContent = function (rng, fragment) {
      var firstChild = Optional.from(fragment.firstChild).map(SugarElement.fromDom);
      var lastChild = Optional.from(fragment.lastChild).map(SugarElement.fromDom);
      rng.deleteContents();
      rng.insertNode(fragment);
      var prevText = firstChild.bind(prevSibling).filter(isText$8).bind(removeEmpty);
      var nextText = lastChild.bind(nextSibling).filter(isText$8).bind(removeEmpty);
      mergeAndNormalizeText(prevText, firstChild, rng, true);
      mergeAndNormalizeText(nextText, lastChild, rng, false);
      rng.collapse(false);
    };
    var setupArgs = function (args, content) {
      return __assign(__assign({ format: 'html' }, args), {
        set: true,
        selection: true,
        content: content
      });
    };
    var cleanContent = function (editor, args) {
      if (args.format !== 'raw') {
        var rng = editor.selection.getRng();
        var contextBlock = editor.dom.getParent(rng.commonAncestorContainer, editor.dom.isBlock);
        var contextArgs = contextBlock ? { context: contextBlock.nodeName.toLowerCase() } : {};
        var node = editor.parser.parse(args.content, __assign(__assign({
          isRootContent: true,
          forced_root_block: false
        }, contextArgs), args));
        return HtmlSerializer({ validate: editor.validate }, editor.schema).serialize(node);
      } else {
        return args.content;
      }
    };
    var setContent$1 = function (editor, content, args) {
      if (args === void 0) {
        args = {};
      }
      var defaultedArgs = setupArgs(args, content);
      var updatedArgs = defaultedArgs;
      if (!defaultedArgs.no_events) {
        var eventArgs = editor.fire('BeforeSetContent', defaultedArgs);
        if (eventArgs.isDefaultPrevented()) {
          editor.fire('SetContent', eventArgs);
          return;
        } else {
          updatedArgs = eventArgs;
        }
      }
      updatedArgs.content = cleanContent(editor, updatedArgs);
      var rng = editor.selection.getRng();
      rngSetContent(rng, rng.createContextualFragment(updatedArgs.content));
      editor.selection.setRng(rng);
      scrollRangeIntoView(editor, rng);
      if (!updatedArgs.no_events) {
        editor.fire('SetContent', updatedArgs);
      }
    };

    var deleteFromCallbackMap = function (callbackMap, selector, callback) {
      if (callbackMap && has$2(callbackMap, selector)) {
        var newCallbacks = filter$4(callbackMap[selector], function (cb) {
          return cb !== callback;
        });
        if (newCallbacks.length === 0) {
          delete callbackMap[selector];
        } else {
          callbackMap[selector] = newCallbacks;
        }
      }
    };
    function SelectorChanged (dom, editor) {
      var selectorChangedData;
      var currentSelectors;
      var findMatchingNode = function (selector, nodes) {
        return find$3(nodes, function (node) {
          return dom.is(node, selector);
        });
      };
      var getParents = function (elem) {
        return dom.getParents(elem, null, dom.getRoot());
      };
      return {
        selectorChangedWithUnbind: function (selector, callback) {
          if (!selectorChangedData) {
            selectorChangedData = {};
            currentSelectors = {};
            editor.on('NodeChange', function (e) {
              var node = e.element;
              var parents = getParents(node);
              var matchedSelectors = {};
              Tools.each(selectorChangedData, function (callbacks, selector) {
                findMatchingNode(selector, parents).each(function (node) {
                  if (!currentSelectors[selector]) {
                    each$k(callbacks, function (callback) {
                      callback(true, {
                        node: node,
                        selector: selector,
                        parents: parents
                      });
                    });
                    currentSelectors[selector] = callbacks;
                  }
                  matchedSelectors[selector] = callbacks;
                });
              });
              Tools.each(currentSelectors, function (callbacks, selector) {
                if (!matchedSelectors[selector]) {
                  delete currentSelectors[selector];
                  Tools.each(callbacks, function (callback) {
                    callback(false, {
                      node: node,
                      selector: selector,
                      parents: parents
                    });
                  });
                }
              });
            });
          }
          if (!selectorChangedData[selector]) {
            selectorChangedData[selector] = [];
          }
          selectorChangedData[selector].push(callback);
          findMatchingNode(selector, getParents(editor.selection.getStart())).each(function () {
            currentSelectors[selector] = selectorChangedData[selector];
          });
          return {
            unbind: function () {
              deleteFromCallbackMap(selectorChangedData, selector, callback);
              deleteFromCallbackMap(currentSelectors, selector, callback);
            }
          };
        }
      };
    }

    var isNativeIeSelection = function (rng) {
      return !!rng.select;
    };
    var isAttachedToDom = function (node) {
      return !!(node && node.ownerDocument) && contains$1(SugarElement.fromDom(node.ownerDocument), SugarElement.fromDom(node));
    };
    var isValidRange = function (rng) {
      if (!rng) {
        return false;
      } else if (isNativeIeSelection(rng)) {
        return true;
      } else {
        return isAttachedToDom(rng.startContainer) && isAttachedToDom(rng.endContainer);
      }
    };
    var EditorSelection = function (dom, win, serializer, editor) {
      var selectedRange;
      var explicitRange;
      var selectorChangedWithUnbind = SelectorChanged(dom, editor).selectorChangedWithUnbind;
      var setCursorLocation = function (node, offset) {
        var rng = dom.createRng();
        if (isNonNullable(node) && isNonNullable(offset)) {
          rng.setStart(node, offset);
          rng.setEnd(node, offset);
          setRng(rng);
          collapse(false);
        } else {
          moveEndPoint(dom, rng, editor.getBody(), true);
          setRng(rng);
        }
      };
      var getContent = function (args) {
        return getContent$1(editor, args);
      };
      var setContent = function (content, args) {
        return setContent$1(editor, content, args);
      };
      var getStart$1 = function (real) {
        return getStart(editor.getBody(), getRng$1(), real);
      };
      var getEnd$1 = function (real) {
        return getEnd(editor.getBody(), getRng$1(), real);
      };
      var getBookmark = function (type, normalized) {
        return bookmarkManager.getBookmark(type, normalized);
      };
      var moveToBookmark = function (bookmark) {
        return bookmarkManager.moveToBookmark(bookmark);
      };
      var select$1 = function (node, content) {
        select(dom, node, content).each(setRng);
        return node;
      };
      var isCollapsed = function () {
        var rng = getRng$1(), sel = getSel();
        if (!rng || rng.item) {
          return false;
        }
        if (rng.compareEndPoints) {
          return rng.compareEndPoints('StartToEnd', rng) === 0;
        }
        return !sel || rng.collapsed;
      };
      var collapse = function (toStart) {
        var rng = getRng$1();
        rng.collapse(!!toStart);
        setRng(rng);
      };
      var getSel = function () {
        return win.getSelection ? win.getSelection() : win.document.selection;
      };
      var getRng$1 = function () {
        var selection, rng, elm;
        var tryCompareBoundaryPoints = function (how, sourceRange, destinationRange) {
          try {
            return sourceRange.compareBoundaryPoints(how, destinationRange);
          } catch (ex) {
            return -1;
          }
        };
        var doc = win.document;
        if (editor.bookmark !== undefined && hasFocus(editor) === false) {
          var bookmark = getRng(editor);
          if (bookmark.isSome()) {
            return bookmark.map(function (r) {
              return processRanges(editor, [r])[0];
            }).getOr(doc.createRange());
          }
        }
        try {
          if ((selection = getSel()) && !isRestrictedNode(selection.anchorNode)) {
            if (selection.rangeCount > 0) {
              rng = selection.getRangeAt(0);
            } else {
              rng = selection.createRange ? selection.createRange() : doc.createRange();
            }
            rng = processRanges(editor, [rng])[0];
          }
        } catch (ex) {
        }
        if (!rng) {
          rng = doc.createRange ? doc.createRange() : doc.body.createTextRange();
        }
        if (rng.setStart && rng.startContainer.nodeType === 9 && rng.collapsed) {
          elm = dom.getRoot();
          rng.setStart(elm, 0);
          rng.setEnd(elm, 0);
        }
        if (selectedRange && explicitRange) {
          if (tryCompareBoundaryPoints(rng.START_TO_START, rng, selectedRange) === 0 && tryCompareBoundaryPoints(rng.END_TO_END, rng, selectedRange) === 0) {
            rng = explicitRange;
          } else {
            selectedRange = null;
            explicitRange = null;
          }
        }
        return rng;
      };
      var setRng = function (rng, forward) {
        var node;
        if (!isValidRange(rng)) {
          return;
        }
        var ieRange = isNativeIeSelection(rng) ? rng : null;
        if (ieRange) {
          explicitRange = null;
          try {
            ieRange.select();
          } catch (ex) {
          }
          return;
        }
        var sel = getSel();
        var evt = editor.fire('SetSelectionRange', {
          range: rng,
          forward: forward
        });
        rng = evt.range;
        if (sel) {
          explicitRange = rng;
          try {
            sel.removeAllRanges();
            sel.addRange(rng);
          } catch (ex) {
          }
          if (forward === false && sel.extend) {
            sel.collapse(rng.endContainer, rng.endOffset);
            sel.extend(rng.startContainer, rng.startOffset);
          }
          selectedRange = sel.rangeCount > 0 ? sel.getRangeAt(0) : null;
        }
        if (!rng.collapsed && rng.startContainer === rng.endContainer && sel.setBaseAndExtent && !Env.ie) {
          if (rng.endOffset - rng.startOffset < 2) {
            if (rng.startContainer.hasChildNodes()) {
              node = rng.startContainer.childNodes[rng.startOffset];
              if (node && node.tagName === 'IMG') {
                sel.setBaseAndExtent(rng.startContainer, rng.startOffset, rng.endContainer, rng.endOffset);
                if (sel.anchorNode !== rng.startContainer || sel.focusNode !== rng.endContainer) {
                  sel.setBaseAndExtent(node, 0, node, 1);
                }
              }
            }
          }
        }
        editor.fire('AfterSetSelectionRange', {
          range: rng,
          forward: forward
        });
      };
      var setNode = function (elm) {
        setContent(dom.getOuterHTML(elm));
        return elm;
      };
      var getNode$1 = function () {
        return getNode(editor.getBody(), getRng$1());
      };
      var getSelectedBlocks$1 = function (startElm, endElm) {
        return getSelectedBlocks(dom, getRng$1(), startElm, endElm);
      };
      var isForward = function () {
        var sel = getSel();
        var anchorNode = sel === null || sel === void 0 ? void 0 : sel.anchorNode;
        var focusNode = sel === null || sel === void 0 ? void 0 : sel.focusNode;
        if (!sel || !anchorNode || !focusNode || isRestrictedNode(anchorNode) || isRestrictedNode(focusNode)) {
          return true;
        }
        var anchorRange = dom.createRng();
        anchorRange.setStart(anchorNode, sel.anchorOffset);
        anchorRange.collapse(true);
        var focusRange = dom.createRng();
        focusRange.setStart(focusNode, sel.focusOffset);
        focusRange.collapse(true);
        return anchorRange.compareBoundaryPoints(anchorRange.START_TO_START, focusRange) <= 0;
      };
      var normalize = function () {
        var rng = getRng$1();
        var sel = getSel();
        if (!hasMultipleRanges(sel) && hasAnyRanges(editor)) {
          var normRng = normalize$2(dom, rng);
          normRng.each(function (normRng) {
            setRng(normRng, isForward());
          });
          return normRng.getOr(rng);
        }
        return rng;
      };
      var selectorChanged = function (selector, callback) {
        selectorChangedWithUnbind(selector, callback);
        return exports;
      };
      var getScrollContainer = function () {
        var scrollContainer;
        var node = dom.getRoot();
        while (node && node.nodeName !== 'BODY') {
          if (node.scrollHeight > node.clientHeight) {
            scrollContainer = node;
            break;
          }
          node = node.parentNode;
        }
        return scrollContainer;
      };
      var scrollIntoView = function (elm, alignToTop) {
        if (isNonNullable(elm)) {
          scrollElementIntoView(editor, elm, alignToTop);
        } else {
          scrollRangeIntoView(editor, getRng$1(), alignToTop);
        }
      };
      var placeCaretAt = function (clientX, clientY) {
        return setRng(fromPoint(clientX, clientY, editor.getDoc()));
      };
      var getBoundingClientRect = function () {
        var rng = getRng$1();
        return rng.collapsed ? CaretPosition.fromRangeStart(rng).getClientRects()[0] : rng.getBoundingClientRect();
      };
      var destroy = function () {
        win = selectedRange = explicitRange = null;
        controlSelection.destroy();
      };
      var exports = {
        bookmarkManager: null,
        controlSelection: null,
        dom: dom,
        win: win,
        serializer: serializer,
        editor: editor,
        collapse: collapse,
        setCursorLocation: setCursorLocation,
        getContent: getContent,
        setContent: setContent,
        getBookmark: getBookmark,
        moveToBookmark: moveToBookmark,
        select: select$1,
        isCollapsed: isCollapsed,
        isForward: isForward,
        setNode: setNode,
        getNode: getNode$1,
        getSel: getSel,
        setRng: setRng,
        getRng: getRng$1,
        getStart: getStart$1,
        getEnd: getEnd$1,
        getSelectedBlocks: getSelectedBlocks$1,
        normalize: normalize,
        selectorChanged: selectorChanged,
        selectorChangedWithUnbind: selectorChangedWithUnbind,
        getScrollContainer: getScrollContainer,
        scrollIntoView: scrollIntoView,
        placeCaretAt: placeCaretAt,
        getBoundingClientRect: getBoundingClientRect,
        destroy: destroy
      };
      var bookmarkManager = BookmarkManager(exports);
      var controlSelection = ControlSelection(exports, editor);
      exports.bookmarkManager = bookmarkManager;
      exports.controlSelection = controlSelection;
      return exports;
    };

    var removeAttrs = function (node, names) {
      each$k(names, function (name) {
        node.attr(name, null);
      });
    };
    var addFontToSpansFilter = function (domParser, styles, fontSizes) {
      domParser.addNodeFilter('font', function (nodes) {
        each$k(nodes, function (node) {
          var props = styles.parse(node.attr('style'));
          var color = node.attr('color');
          var face = node.attr('face');
          var size = node.attr('size');
          if (color) {
            props.color = color;
          }
          if (face) {
            props['font-family'] = face;
          }
          if (size) {
            props['font-size'] = fontSizes[parseInt(node.attr('size'), 10) - 1];
          }
          node.name = 'span';
          node.attr('style', styles.serialize(props));
          removeAttrs(node, [
            'color',
            'face',
            'size'
          ]);
        });
      });
    };
    var addStrikeToSpanFilter = function (domParser, styles) {
      domParser.addNodeFilter('strike', function (nodes) {
        each$k(nodes, function (node) {
          var props = styles.parse(node.attr('style'));
          props['text-decoration'] = 'line-through';
          node.name = 'span';
          node.attr('style', styles.serialize(props));
        });
      });
    };
    var addFilters = function (domParser, settings) {
      var styles = Styles();
      if (settings.convert_fonts_to_spans) {
        addFontToSpansFilter(domParser, styles, Tools.explode(settings.font_size_legacy_values));
      }
      addStrikeToSpanFilter(domParser, styles);
    };
    var register$2 = function (domParser, settings) {
      if (settings.inline_styles) {
        addFilters(domParser, settings);
      }
    };

    var blobUriToBlob = function (url) {
      return new promiseObj(function (resolve, reject) {
        var rejectWithError = function () {
          reject('Cannot convert ' + url + ' to Blob. Resource might not exist or is inaccessible.');
        };
        try {
          var xhr_1 = new XMLHttpRequest();
          xhr_1.open('GET', url, true);
          xhr_1.responseType = 'blob';
          xhr_1.onload = function () {
            if (xhr_1.status === 200) {
              resolve(xhr_1.response);
            } else {
              rejectWithError();
            }
          };
          xhr_1.onerror = rejectWithError;
          xhr_1.send();
        } catch (ex) {
          rejectWithError();
        }
      });
    };
    var parseDataUri = function (uri) {
      var type;
      var uriParts = decodeURIComponent(uri).split(',');
      var matches = /data:([^;]+)/.exec(uriParts[0]);
      if (matches) {
        type = matches[1];
      }
      return {
        type: type,
        data: uriParts[1]
      };
    };
    var buildBlob = function (type, data) {
      var str;
      try {
        str = atob(data);
      } catch (e) {
        return Optional.none();
      }
      var arr = new Uint8Array(str.length);
      for (var i = 0; i < arr.length; i++) {
        arr[i] = str.charCodeAt(i);
      }
      return Optional.some(new Blob([arr], { type: type }));
    };
    var dataUriToBlob = function (uri) {
      return new promiseObj(function (resolve) {
        var _a = parseDataUri(uri), type = _a.type, data = _a.data;
        buildBlob(type, data).fold(function () {
          return resolve(new Blob([]));
        }, resolve);
      });
    };
    var uriToBlob = function (url) {
      if (url.indexOf('blob:') === 0) {
        return blobUriToBlob(url);
      }
      if (url.indexOf('data:') === 0) {
        return dataUriToBlob(url);
      }
      return null;
    };
    var blobToDataUri = function (blob) {
      return new promiseObj(function (resolve) {
        var reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        };
        reader.readAsDataURL(blob);
      });
    };

    var count$1 = 0;
    var uniqueId = function (prefix) {
      return (prefix || 'blobid') + count$1++;
    };
    var imageToBlobInfo = function (blobCache, img, resolve, reject) {
      var base64, blobInfo;
      if (img.src.indexOf('blob:') === 0) {
        blobInfo = blobCache.getByUri(img.src);
        if (blobInfo) {
          resolve({
            image: img,
            blobInfo: blobInfo
          });
        } else {
          uriToBlob(img.src).then(function (blob) {
            blobToDataUri(blob).then(function (dataUri) {
              base64 = parseDataUri(dataUri).data;
              blobInfo = blobCache.create(uniqueId(), blob, base64);
              blobCache.add(blobInfo);
              resolve({
                image: img,
                blobInfo: blobInfo
              });
            });
          }, function (err) {
            reject(err);
          });
        }
        return;
      }
      var _a = parseDataUri(img.src), data = _a.data, type = _a.type;
      base64 = data;
      blobInfo = blobCache.getByData(base64, type);
      if (blobInfo) {
        resolve({
          image: img,
          blobInfo: blobInfo
        });
      } else {
        uriToBlob(img.src).then(function (blob) {
          blobInfo = blobCache.create(uniqueId(), blob, base64);
          blobCache.add(blobInfo);
          resolve({
            image: img,
            blobInfo: blobInfo
          });
        }, function (err) {
          reject(err);
        });
      }
    };
    var getAllImages = function (elm) {
      return elm ? from(elm.getElementsByTagName('img')) : [];
    };
    var ImageScanner = function (uploadStatus, blobCache) {
      var cachedPromises = {};
      var findAll = function (elm, predicate) {
        if (!predicate) {
          predicate = always;
        }
        var images = filter$4(getAllImages(elm), function (img) {
          var src = img.src;
          if (!Env.fileApi) {
            return false;
          }
          if (img.hasAttribute('data-mce-bogus')) {
            return false;
          }
          if (img.hasAttribute('data-mce-placeholder')) {
            return false;
          }
          if (!src || src === Env.transparentSrc) {
            return false;
          }
          if (src.indexOf('blob:') === 0) {
            return !uploadStatus.isUploaded(src) && predicate(img);
          }
          if (src.indexOf('data:') === 0) {
            return predicate(img);
          }
          return false;
        });
        var promises = map$3(images, function (img) {
          if (cachedPromises[img.src] !== undefined) {
            return new promiseObj(function (resolve) {
              cachedPromises[img.src].then(function (imageInfo) {
                if (typeof imageInfo === 'string') {
                  return imageInfo;
                }
                resolve({
                  image: img,
                  blobInfo: imageInfo.blobInfo
                });
              });
            });
          }
          var newPromise = new promiseObj(function (resolve, reject) {
            imageToBlobInfo(blobCache, img, resolve, reject);
          }).then(function (result) {
            delete cachedPromises[result.image.src];
            return result;
          }).catch(function (error) {
            delete cachedPromises[img.src];
            return error;
          });
          cachedPromises[img.src] = newPromise;
          return newPromise;
        });
        return promiseObj.all(promises);
      };
      return { findAll: findAll };
    };

    var paddEmptyNode = function (settings, args, blockElements, node) {
      var brPreferred = settings.padd_empty_with_br || args.insert;
      if (brPreferred && blockElements[node.name]) {
        node.empty().append(new AstNode('br', 1)).shortEnded = true;
      } else {
        node.empty().append(new AstNode('#text', 3)).value = nbsp;
      }
    };
    var isPaddedWithNbsp = function (node) {
      return hasOnlyChild(node, '#text') && node.firstChild.value === nbsp;
    };
    var hasOnlyChild = function (node, name) {
      return node && node.firstChild && node.firstChild === node.lastChild && node.firstChild.name === name;
    };
    var isPadded = function (schema, node) {
      var rule = schema.getElementRule(node.name);
      return rule && rule.paddEmpty;
    };
    var isEmpty = function (schema, nonEmptyElements, whitespaceElements, node) {
      return node.isEmpty(nonEmptyElements, whitespaceElements, function (node) {
        return isPadded(schema, node);
      });
    };
    var isLineBreakNode = function (node, blockElements) {
      return node && (has$2(blockElements, node.name) || node.name === 'br');
    };

    var isBogusImage = function (img) {
      return isNonNullable(img.attr('data-mce-bogus'));
    };
    var isInternalImageSource = function (img) {
      return img.attr('src') === Env.transparentSrc || isNonNullable(img.attr('data-mce-placeholder'));
    };
    var isValidDataImg = function (img, settings) {
      if (settings.images_dataimg_filter) {
        var imgElem_1 = new Image();
        imgElem_1.src = img.attr('src');
        each$j(img.attributes.map, function (value, key) {
          imgElem_1.setAttribute(key, value);
        });
        return settings.images_dataimg_filter(imgElem_1);
      } else {
        return true;
      }
    };
    var registerBase64ImageFilter = function (parser, settings) {
      var blobCache = settings.blob_cache;
      var processImage = function (img) {
        var inputSrc = img.attr('src');
        if (isInternalImageSource(img) || isBogusImage(img)) {
          return;
        }
        parseDataUri$1(inputSrc).filter(function () {
          return isValidDataImg(img, settings);
        }).bind(function (_a) {
          var type = _a.type, data = _a.data;
          return Optional.from(blobCache.getByData(data, type)).orThunk(function () {
            return buildBlob(type, data).map(function (blob) {
              var blobInfo = blobCache.create(uniqueId(), blob, data);
              blobCache.add(blobInfo);
              return blobInfo;
            });
          });
        }).each(function (blobInfo) {
          img.attr('src', blobInfo.blobUri());
        });
      };
      if (blobCache) {
        parser.addAttributeFilter('src', function (nodes) {
          return each$k(nodes, processImage);
        });
      }
    };
    var register$1 = function (parser, settings) {
      var schema = parser.schema;
      if (settings.remove_trailing_brs) {
        parser.addNodeFilter('br', function (nodes, _, args) {
          var i;
          var l = nodes.length;
          var node;
          var blockElements = Tools.extend({}, schema.getBlockElements());
          var nonEmptyElements = schema.getNonEmptyElements();
          var parent, lastParent, prev, prevName;
          var whiteSpaceElements = schema.getWhiteSpaceElements();
          var elementRule, textNode;
          blockElements.body = 1;
          for (i = 0; i < l; i++) {
            node = nodes[i];
            parent = node.parent;
            if (blockElements[node.parent.name] && node === parent.lastChild) {
              prev = node.prev;
              while (prev) {
                prevName = prev.name;
                if (prevName !== 'span' || prev.attr('data-mce-type') !== 'bookmark') {
                  if (prevName === 'br') {
                    node = null;
                  }
                  break;
                }
                prev = prev.prev;
              }
              if (node) {
                node.remove();
                if (isEmpty(schema, nonEmptyElements, whiteSpaceElements, parent)) {
                  elementRule = schema.getElementRule(parent.name);
                  if (elementRule) {
                    if (elementRule.removeEmpty) {
                      parent.remove();
                    } else if (elementRule.paddEmpty) {
                      paddEmptyNode(settings, args, blockElements, parent);
                    }
                  }
                }
              }
            } else {
              lastParent = node;
              while (parent && parent.firstChild === lastParent && parent.lastChild === lastParent) {
                lastParent = parent;
                if (blockElements[parent.name]) {
                  break;
                }
                parent = parent.parent;
              }
              if (lastParent === parent && settings.padd_empty_with_br !== true) {
                textNode = new AstNode('#text', 3);
                textNode.value = nbsp;
                node.replace(textNode);
              }
            }
          }
        });
      }
      parser.addAttributeFilter('href', function (nodes) {
        var i = nodes.length;
        var appendRel = function (rel) {
          var parts = rel.split(' ').filter(function (p) {
            return p.length > 0;
          });
          return parts.concat(['noopener']).sort().join(' ');
        };
        var addNoOpener = function (rel) {
          var newRel = rel ? Tools.trim(rel) : '';
          if (!/\b(noopener)\b/g.test(newRel)) {
            return appendRel(newRel);
          } else {
            return newRel;
          }
        };
        if (!settings.allow_unsafe_link_target) {
          while (i--) {
            var node = nodes[i];
            if (node.name === 'a' && node.attr('target') === '_blank') {
              node.attr('rel', addNoOpener(node.attr('rel')));
            }
          }
        }
      });
      if (!settings.allow_html_in_named_anchor) {
        parser.addAttributeFilter('id,name', function (nodes) {
          var i = nodes.length, sibling, prevSibling, parent, node;
          while (i--) {
            node = nodes[i];
            if (node.name === 'a' && node.firstChild && !node.attr('href')) {
              parent = node.parent;
              sibling = node.lastChild;
              do {
                prevSibling = sibling.prev;
                parent.insert(sibling, node);
                sibling = prevSibling;
              } while (sibling);
            }
          }
        });
      }
      if (settings.fix_list_elements) {
        parser.addNodeFilter('ul,ol', function (nodes) {
          var i = nodes.length, node, parentNode;
          while (i--) {
            node = nodes[i];
            parentNode = node.parent;
            if (parentNode.name === 'ul' || parentNode.name === 'ol') {
              if (node.prev && node.prev.name === 'li') {
                node.prev.append(node);
              } else {
                var li = new AstNode('li', 1);
                li.attr('style', 'list-style-type: none');
                node.wrap(li);
              }
            }
          }
        });
      }
      if (settings.validate && schema.getValidClasses()) {
        parser.addAttributeFilter('class', function (nodes) {
          var validClasses = schema.getValidClasses();
          var i = nodes.length;
          while (i--) {
            var node = nodes[i];
            var classList = node.attr('class').split(' ');
            var classValue = '';
            for (var ci = 0; ci < classList.length; ci++) {
              var className = classList[ci];
              var valid = false;
              var validClassesMap = validClasses['*'];
              if (validClassesMap && validClassesMap[className]) {
                valid = true;
              }
              validClassesMap = validClasses[node.name];
              if (!valid && validClassesMap && validClassesMap[className]) {
                valid = true;
              }
              if (valid) {
                if (classValue) {
                  classValue += ' ';
                }
                classValue += className;
              }
            }
            if (!classValue.length) {
              classValue = null;
            }
            node.attr('class', classValue);
          }
        });
      }
      registerBase64ImageFilter(parser, settings);
    };

    var makeMap = Tools.makeMap, each$6 = Tools.each, explode$2 = Tools.explode, extend$4 = Tools.extend;
    var DomParser = function (settings, schema) {
      if (schema === void 0) {
        schema = Schema();
      }
      var nodeFilters = {};
      var attributeFilters = [];
      var matchedNodes = {};
      var matchedAttributes = {};
      settings = settings || {};
      settings.validate = 'validate' in settings ? settings.validate : true;
      settings.root_name = settings.root_name || 'body';
      var fixInvalidChildren = function (nodes) {
        var nonSplitableElements = makeMap('tr,td,th,tbody,thead,tfoot,table');
        var nonEmptyElements = schema.getNonEmptyElements();
        var whitespaceElements = schema.getWhiteSpaceElements();
        var textBlockElements = schema.getTextBlockElements();
        var specialElements = schema.getSpecialElements();
        var removeOrUnwrapInvalidNode = function (node, originalNodeParent) {
          if (originalNodeParent === void 0) {
            originalNodeParent = node.parent;
          }
          if (specialElements[node.name]) {
            node.empty().remove();
          } else {
            var children = node.children();
            for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
              var childNode = children_1[_i];
              if (!schema.isValidChild(originalNodeParent.name, childNode.name)) {
                removeOrUnwrapInvalidNode(childNode, originalNodeParent);
              }
            }
            node.unwrap();
          }
        };
        for (var ni = 0; ni < nodes.length; ni++) {
          var node = nodes[ni];
          var parent_1 = void 0, newParent = void 0, tempNode = void 0;
          if (!node.parent || node.fixed) {
            continue;
          }
          if (textBlockElements[node.name] && node.parent.name === 'li') {
            var sibling = node.next;
            while (sibling) {
              if (textBlockElements[sibling.name]) {
                sibling.name = 'li';
                sibling.fixed = true;
                node.parent.insert(sibling, node.parent);
              } else {
                break;
              }
              sibling = sibling.next;
            }
            node.unwrap();
            continue;
          }
          var parents = [node];
          for (parent_1 = node.parent; parent_1 && !schema.isValidChild(parent_1.name, node.name) && !nonSplitableElements[parent_1.name]; parent_1 = parent_1.parent) {
            parents.push(parent_1);
          }
          if (parent_1 && parents.length > 1) {
            if (schema.isValidChild(parent_1.name, node.name)) {
              parents.reverse();
              newParent = filterNode(parents[0].clone());
              var currentNode = newParent;
              for (var i = 0; i < parents.length - 1; i++) {
                if (schema.isValidChild(currentNode.name, parents[i].name)) {
                  tempNode = filterNode(parents[i].clone());
                  currentNode.append(tempNode);
                } else {
                  tempNode = currentNode;
                }
                for (var childNode = parents[i].firstChild; childNode && childNode !== parents[i + 1];) {
                  var nextNode = childNode.next;
                  tempNode.append(childNode);
                  childNode = nextNode;
                }
                currentNode = tempNode;
              }
              if (!isEmpty(schema, nonEmptyElements, whitespaceElements, newParent)) {
                parent_1.insert(newParent, parents[0], true);
                parent_1.insert(node, newParent);
              } else {
                parent_1.insert(node, parents[0], true);
              }
              parent_1 = parents[0];
              if (isEmpty(schema, nonEmptyElements, whitespaceElements, parent_1) || hasOnlyChild(parent_1, 'br')) {
                parent_1.empty().remove();
              }
            } else {
              removeOrUnwrapInvalidNode(node);
            }
          } else if (node.parent) {
            if (node.name === 'li') {
              var sibling = node.prev;
              if (sibling && (sibling.name === 'ul' || sibling.name === 'ol')) {
                sibling.append(node);
                continue;
              }
              sibling = node.next;
              if (sibling && (sibling.name === 'ul' || sibling.name === 'ol')) {
                sibling.insert(node, sibling.firstChild, true);
                continue;
              }
              node.wrap(filterNode(new AstNode('ul', 1)));
              continue;
            }
            if (schema.isValidChild(node.parent.name, 'div') && schema.isValidChild('div', node.name)) {
              node.wrap(filterNode(new AstNode('div', 1)));
            } else {
              removeOrUnwrapInvalidNode(node);
            }
          }
        }
      };
      var filterNode = function (node) {
        var name = node.name;
        if (name in nodeFilters) {
          var list = matchedNodes[name];
          if (list) {
            list.push(node);
          } else {
            matchedNodes[name] = [node];
          }
        }
        var i = attributeFilters.length;
        while (i--) {
          var attrName = attributeFilters[i].name;
          if (attrName in node.attributes.map) {
            var list = matchedAttributes[attrName];
            if (list) {
              list.push(node);
            } else {
              matchedAttributes[attrName] = [node];
            }
          }
        }
        return node;
      };
      var addNodeFilter = function (name, callback) {
        each$6(explode$2(name), function (name) {
          var list = nodeFilters[name];
          if (!list) {
            nodeFilters[name] = list = [];
          }
          list.push(callback);
        });
      };
      var getNodeFilters = function () {
        var out = [];
        for (var name_1 in nodeFilters) {
          if (has$2(nodeFilters, name_1)) {
            out.push({
              name: name_1,
              callbacks: nodeFilters[name_1]
            });
          }
        }
        return out;
      };
      var addAttributeFilter = function (name, callback) {
        each$6(explode$2(name), function (name) {
          var i;
          for (i = 0; i < attributeFilters.length; i++) {
            if (attributeFilters[i].name === name) {
              attributeFilters[i].callbacks.push(callback);
              return;
            }
          }
          attributeFilters.push({
            name: name,
            callbacks: [callback]
          });
        });
      };
      var getAttributeFilters = function () {
        return [].concat(attributeFilters);
      };
      var parse = function (html, args) {
        var nodes, i, l, fi, fl, list, name;
        var invalidChildren = [];
        var node;
        var getRootBlockName = function (name) {
          if (name === false) {
            return '';
          } else if (name === true) {
            return 'p';
          } else {
            return name;
          }
        };
        args = args || {};
        matchedNodes = {};
        matchedAttributes = {};
        var blockElements = extend$4(makeMap('script,style,head,html,body,title,meta,param'), schema.getBlockElements());
        var textRootBlockElements = getTextRootBlockElements(schema);
        var nonEmptyElements = schema.getNonEmptyElements();
        var children = schema.children;
        var validate = settings.validate;
        var forcedRootBlockName = 'forced_root_block' in args ? args.forced_root_block : settings.forced_root_block;
        var rootBlockName = getRootBlockName(forcedRootBlockName);
        var whiteSpaceElements = schema.getWhiteSpaceElements();
        var startWhiteSpaceRegExp = /^[ \t\r\n]+/;
        var endWhiteSpaceRegExp = /[ \t\r\n]+$/;
        var allWhiteSpaceRegExp = /[ \t\r\n]+/g;
        var isAllWhiteSpaceRegExp = /^[ \t\r\n]+$/;
        var isInWhiteSpacePreservedElement = has$2(whiteSpaceElements, args.context) || has$2(whiteSpaceElements, settings.root_name);
        var addRootBlocks = function () {
          var node = rootNode.firstChild, rootBlockNode = null;
          var trim = function (rootBlock) {
            if (rootBlock) {
              node = rootBlock.firstChild;
              if (node && node.type === 3) {
                node.value = node.value.replace(startWhiteSpaceRegExp, '');
              }
              node = rootBlock.lastChild;
              if (node && node.type === 3) {
                node.value = node.value.replace(endWhiteSpaceRegExp, '');
              }
            }
          };
          if (!schema.isValidChild(rootNode.name, rootBlockName.toLowerCase())) {
            return;
          }
          while (node) {
            var next = node.next;
            if (node.type === 3 || node.type === 1 && node.name !== 'p' && !blockElements[node.name] && !node.attr('data-mce-type')) {
              if (!rootBlockNode) {
                rootBlockNode = createNode(rootBlockName, 1);
                rootBlockNode.attr(settings.forced_root_block_attrs);
                rootNode.insert(rootBlockNode, node);
                rootBlockNode.append(node);
              } else {
                rootBlockNode.append(node);
              }
            } else {
              trim(rootBlockNode);
              rootBlockNode = null;
            }
            node = next;
          }
          trim(rootBlockNode);
        };
        var createNode = function (name, type) {
          var node = new AstNode(name, type);
          var list;
          if (name in nodeFilters) {
            list = matchedNodes[name];
            if (list) {
              list.push(node);
            } else {
              matchedNodes[name] = [node];
            }
          }
          return node;
        };
        var removeWhitespaceBefore = function (node) {
          var blockElements = schema.getBlockElements();
          for (var textNode = node.prev; textNode && textNode.type === 3;) {
            var textVal = textNode.value.replace(endWhiteSpaceRegExp, '');
            if (textVal.length > 0) {
              textNode.value = textVal;
              return;
            }
            var textNodeNext = textNode.next;
            if (textNodeNext) {
              if (textNodeNext.type === 3 && textNodeNext.value.length) {
                textNode = textNode.prev;
                continue;
              }
              if (!blockElements[textNodeNext.name] && textNodeNext.name !== 'script' && textNodeNext.name !== 'style') {
                textNode = textNode.prev;
                continue;
              }
            }
            var sibling = textNode.prev;
            textNode.remove();
            textNode = sibling;
          }
        };
        var cloneAndExcludeBlocks = function (input) {
          var output = {};
          for (var name_2 in input) {
            if (name_2 !== 'li' && name_2 !== 'p') {
              output[name_2] = input[name_2];
            }
          }
          return output;
        };
        var isTextRootBlockEmpty = function (node) {
          var tempNode = node;
          while (isNonNullable(tempNode)) {
            if (tempNode.name in textRootBlockElements) {
              return isEmpty(schema, nonEmptyElements, whiteSpaceElements, tempNode);
            } else {
              tempNode = tempNode.parent;
            }
          }
          return false;
        };
        var parser = SaxParser({
          validate: validate,
          document: settings.document,
          allow_html_data_urls: settings.allow_html_data_urls,
          allow_svg_data_urls: settings.allow_svg_data_urls,
          allow_script_urls: settings.allow_script_urls,
          allow_conditional_comments: settings.allow_conditional_comments,
          preserve_cdata: settings.preserve_cdata,
          self_closing_elements: cloneAndExcludeBlocks(schema.getSelfClosingElements()),
          cdata: function (text) {
            node.append(createNode('#cdata', 4)).value = text;
          },
          text: function (text, raw) {
            var textNode;
            if (!isInWhiteSpacePreservedElement) {
              text = text.replace(allWhiteSpaceRegExp, ' ');
              if (isLineBreakNode(node.lastChild, blockElements)) {
                text = text.replace(startWhiteSpaceRegExp, '');
              }
            }
            if (text.length !== 0) {
              textNode = createNode('#text', 3);
              textNode.raw = !!raw;
              node.append(textNode).value = text;
            }
          },
          comment: function (text) {
            node.append(createNode('#comment', 8)).value = text;
          },
          pi: function (name, text) {
            node.append(createNode(name, 7)).value = text;
            removeWhitespaceBefore(node);
          },
          doctype: function (text) {
            var newNode = node.append(createNode('#doctype', 10));
            newNode.value = text;
            removeWhitespaceBefore(node);
          },
          start: function (name, attrs, empty) {
            var elementRule = validate ? schema.getElementRule(name) : {};
            if (elementRule) {
              var newNode = createNode(elementRule.outputName || name, 1);
              newNode.attributes = attrs;
              newNode.shortEnded = empty;
              node.append(newNode);
              var parent_2 = children[node.name];
              if (parent_2 && children[newNode.name] && !parent_2[newNode.name]) {
                invalidChildren.push(newNode);
              }
              var attrFiltersLen = attributeFilters.length;
              while (attrFiltersLen--) {
                var attrName = attributeFilters[attrFiltersLen].name;
                if (attrName in attrs.map) {
                  list = matchedAttributes[attrName];
                  if (list) {
                    list.push(newNode);
                  } else {
                    matchedAttributes[attrName] = [newNode];
                  }
                }
              }
              if (blockElements[name]) {
                removeWhitespaceBefore(newNode);
              }
              if (!empty) {
                node = newNode;
              }
              if (!isInWhiteSpacePreservedElement && whiteSpaceElements[name]) {
                isInWhiteSpacePreservedElement = true;
              }
            }
          },
          end: function (name) {
            var textNode, text, sibling;
            var elementRule = validate ? schema.getElementRule(name) : {};
            if (elementRule) {
              if (blockElements[name]) {
                if (!isInWhiteSpacePreservedElement) {
                  textNode = node.firstChild;
                  if (textNode && textNode.type === 3) {
                    text = textNode.value.replace(startWhiteSpaceRegExp, '');
                    if (text.length > 0) {
                      textNode.value = text;
                      textNode = textNode.next;
                    } else {
                      sibling = textNode.next;
                      textNode.remove();
                      textNode = sibling;
                      while (textNode && textNode.type === 3) {
                        text = textNode.value;
                        sibling = textNode.next;
                        if (text.length === 0 || isAllWhiteSpaceRegExp.test(text)) {
                          textNode.remove();
                          textNode = sibling;
                        }
                        textNode = sibling;
                      }
                    }
                  }
                  textNode = node.lastChild;
                  if (textNode && textNode.type === 3) {
                    text = textNode.value.replace(endWhiteSpaceRegExp, '');
                    if (text.length > 0) {
                      textNode.value = text;
                      textNode = textNode.prev;
                    } else {
                      sibling = textNode.prev;
                      textNode.remove();
                      textNode = sibling;
                      while (textNode && textNode.type === 3) {
                        text = textNode.value;
                        sibling = textNode.prev;
                        if (text.length === 0 || isAllWhiteSpaceRegExp.test(text)) {
                          textNode.remove();
                          textNode = sibling;
                        }
                        textNode = sibling;
                      }
                    }
                  }
                }
              }
              if (isInWhiteSpacePreservedElement && whiteSpaceElements[name]) {
                isInWhiteSpacePreservedElement = false;
              }
              var isNodeEmpty = isEmpty(schema, nonEmptyElements, whiteSpaceElements, node);
              var parentNode = node.parent;
              if (elementRule.paddInEmptyBlock && isNodeEmpty && isTextRootBlockEmpty(node)) {
                paddEmptyNode(settings, args, blockElements, node);
              } else if (elementRule.removeEmpty && isNodeEmpty) {
                if (blockElements[node.name]) {
                  node.empty().remove();
                } else {
                  node.unwrap();
                }
              } else if (elementRule.paddEmpty && (isPaddedWithNbsp(node) || isNodeEmpty)) {
                paddEmptyNode(settings, args, blockElements, node);
              }
              node = parentNode;
            }
          }
        }, schema);
        var rootNode = node = new AstNode(args.context || settings.root_name, 11);
        parser.parse(html, args.format);
        if (validate && invalidChildren.length) {
          if (!args.context) {
            fixInvalidChildren(invalidChildren);
          } else {
            args.invalid = true;
          }
        }
        if (rootBlockName && (rootNode.name === 'body' || args.isRootContent)) {
          addRootBlocks();
        }
        if (!args.invalid) {
          for (name in matchedNodes) {
            if (!has$2(matchedNodes, name)) {
              continue;
            }
            list = nodeFilters[name];
            nodes = matchedNodes[name];
            fi = nodes.length;
            while (fi--) {
              if (!nodes[fi].parent) {
                nodes.splice(fi, 1);
              }
            }
            for (i = 0, l = list.length; i < l; i++) {
              list[i](nodes, name, args);
            }
          }
          for (i = 0, l = attributeFilters.length; i < l; i++) {
            list = attributeFilters[i];
            if (list.name in matchedAttributes) {
              nodes = matchedAttributes[list.name];
              fi = nodes.length;
              while (fi--) {
                if (!nodes[fi].parent) {
                  nodes.splice(fi, 1);
                }
              }
              for (fi = 0, fl = list.callbacks.length; fi < fl; fi++) {
                list.callbacks[fi](nodes, list.name, args);
              }
            }
          }
        }
        return rootNode;
      };
      var exports = {
        schema: schema,
        addAttributeFilter: addAttributeFilter,
        getAttributeFilters: getAttributeFilters,
        addNodeFilter: addNodeFilter,
        getNodeFilters: getNodeFilters,
        filterNode: filterNode,
        parse: parse
      };
      register$1(exports, settings);
      register$2(exports, settings);
      return exports;
    };

    var register = function (htmlParser, settings, dom) {
      htmlParser.addAttributeFilter('data-mce-tabindex', function (nodes, name) {
        var i = nodes.length;
        while (i--) {
          var node = nodes[i];
          node.attr('tabindex', node.attr('data-mce-tabindex'));
          node.attr(name, null);
        }
      });
      htmlParser.addAttributeFilter('src,href,style', function (nodes, name) {
        var internalName = 'data-mce-' + name;
        var urlConverter = settings.url_converter;
        var urlConverterScope = settings.url_converter_scope;
        var i = nodes.length;
        while (i--) {
          var node = nodes[i];
          var value = node.attr(internalName);
          if (value !== undefined) {
            node.attr(name, value.length > 0 ? value : null);
            node.attr(internalName, null);
          } else {
            value = node.attr(name);
            if (name === 'style') {
              value = dom.serializeStyle(dom.parseStyle(value), node.name);
            } else if (urlConverter) {
              value = urlConverter.call(urlConverterScope, value, name, node.name);
            }
            node.attr(name, value.length > 0 ? value : null);
          }
        }
      });
      htmlParser.addAttributeFilter('class', function (nodes) {
        var i = nodes.length;
        while (i--) {
          var node = nodes[i];
          var value = node.attr('class');
          if (value) {
            value = node.attr('class').replace(/(?:^|\s)mce-item-\w+(?!\S)/g, '');
            node.attr('class', value.length > 0 ? value : null);
          }
        }
      });
      htmlParser.addAttributeFilter('data-mce-type', function (nodes, name, args) {
        var i = nodes.length;
        while (i--) {
          var node = nodes[i];
          if (node.attr('data-mce-type') === 'bookmark' && !args.cleanup) {
            var hasChildren = Optional.from(node.firstChild).exists(function (firstChild) {
              return !isZwsp(firstChild.value);
            });
            if (hasChildren) {
              node.unwrap();
            } else {
              node.remove();
            }
          }
        }
      });
      htmlParser.addNodeFilter('noscript', function (nodes) {
        var i = nodes.length;
        while (i--) {
          var node = nodes[i].firstChild;
          if (node) {
            node.value = Entities.decode(node.value);
          }
        }
      });
      htmlParser.addNodeFilter('script,style', function (nodes, name) {
        var trim = function (value) {
          return value.replace(/(<!--\[CDATA\[|\]\]-->)/g, '\n').replace(/^[\r\n]*|[\r\n]*$/g, '').replace(/^\s*((<!--)?(\s*\/\/)?\s*<!\[CDATA\[|(<!--\s*)?\/\*\s*<!\[CDATA\[\s*\*\/|(\/\/)?\s*<!--|\/\*\s*<!--\s*\*\/)\s*[\r\n]*/gi, '').replace(/\s*(\/\*\s*\]\]>\s*\*\/(-->)?|\s*\/\/\s*\]\]>(-->)?|\/\/\s*(-->)?|\]\]>|\/\*\s*-->\s*\*\/|\s*-->\s*)\s*$/g, '');
        };
        var i = nodes.length;
        while (i--) {
          var node = nodes[i];
          var value = node.firstChild ? node.firstChild.value : '';
          if (name === 'script') {
            var type = node.attr('type');
            if (type) {
              node.attr('type', type === 'mce-no/type' ? null : type.replace(/^mce\-/, ''));
            }
            if (settings.element_format === 'xhtml' && value.length > 0) {
              node.firstChild.value = '// <![CDATA[\n' + trim(value) + '\n// ]]>';
            }
          } else {
            if (settings.element_format === 'xhtml' && value.length > 0) {
              node.firstChild.value = '<!--\n' + trim(value) + '\n-->';
            }
          }
        }
      });
      htmlParser.addNodeFilter('#comment', function (nodes) {
        var i = nodes.length;
        while (i--) {
          var node = nodes[i];
          if (settings.preserve_cdata && node.value.indexOf('[CDATA[') === 0) {
            node.name = '#cdata';
            node.type = 4;
            node.value = dom.decode(node.value.replace(/^\[CDATA\[|\]\]$/g, ''));
          } else if (node.value.indexOf('mce:protected ') === 0) {
            node.name = '#text';
            node.type = 3;
            node.raw = true;
            node.value = unescape(node.value).substr(14);
          }
        }
      });
      htmlParser.addNodeFilter('xml:namespace,input', function (nodes, name) {
        var i = nodes.length;
        while (i--) {
          var node = nodes[i];
          if (node.type === 7) {
            node.remove();
          } else if (node.type === 1) {
            if (name === 'input' && !node.attr('type')) {
              node.attr('type', 'text');
            }
          }
        }
      });
      htmlParser.addAttributeFilter('data-mce-type', function (nodes) {
        each$k(nodes, function (node) {
          if (node.attr('data-mce-type') === 'format-caret') {
            if (node.isEmpty(htmlParser.schema.getNonEmptyElements())) {
              node.remove();
            } else {
              node.unwrap();
            }
          }
        });
      });
      htmlParser.addAttributeFilter('data-mce-src,data-mce-href,data-mce-style,' + 'data-mce-selected,data-mce-expando,' + 'data-mce-type,data-mce-resize,data-mce-placeholder', function (nodes, name) {
        var i = nodes.length;
        while (i--) {
          nodes[i].attr(name, null);
        }
      });
    };
    var trimTrailingBr = function (rootNode) {
      var isBr = function (node) {
        return node && node.name === 'br';
      };
      var brNode1 = rootNode.lastChild;
      if (isBr(brNode1)) {
        var brNode2 = brNode1.prev;
        if (isBr(brNode2)) {
          brNode1.remove();
          brNode2.remove();
        }
      }
    };

    var preProcess = function (editor, node, args) {
      var oldDoc;
      var dom = editor.dom;
      var clonedNode = node.cloneNode(true);
      var impl = document.implementation;
      if (impl.createHTMLDocument) {
        var doc_1 = impl.createHTMLDocument('');
        Tools.each(clonedNode.nodeName === 'BODY' ? clonedNode.childNodes : [clonedNode], function (node) {
          doc_1.body.appendChild(doc_1.importNode(node, true));
        });
        if (clonedNode.nodeName !== 'BODY') {
          clonedNode = doc_1.body.firstChild;
        } else {
          clonedNode = doc_1.body;
        }
        oldDoc = dom.doc;
        dom.doc = doc_1;
      }
      firePreProcess(editor, __assign(__assign({}, args), { node: clonedNode }));
      if (oldDoc) {
        dom.doc = oldDoc;
      }
      return clonedNode;
    };
    var shouldFireEvent = function (editor, args) {
      return editor && editor.hasEventListeners('PreProcess') && !args.no_events;
    };
    var process = function (editor, node, args) {
      return shouldFireEvent(editor, args) ? preProcess(editor, node, args) : node;
    };

    var addTempAttr = function (htmlParser, tempAttrs, name) {
      if (Tools.inArray(tempAttrs, name) === -1) {
        htmlParser.addAttributeFilter(name, function (nodes, name) {
          var i = nodes.length;
          while (i--) {
            nodes[i].attr(name, null);
          }
        });
        tempAttrs.push(name);
      }
    };
    var postProcess = function (editor, args, content) {
      if (!args.no_events && editor) {
        var outArgs = firePostProcess(editor, __assign(__assign({}, args), { content: content }));
        return outArgs.content;
      } else {
        return content;
      }
    };
    var getHtmlFromNode = function (dom, node, args) {
      var html = trim$2(args.getInner ? node.innerHTML : dom.getOuterHTML(node));
      return args.selection || isWsPreserveElement(SugarElement.fromDom(node)) ? html : Tools.trim(html);
    };
    var parseHtml = function (htmlParser, html, args) {
      var parserArgs = args.selection ? __assign({ forced_root_block: false }, args) : args;
      var rootNode = htmlParser.parse(html, parserArgs);
      trimTrailingBr(rootNode);
      return rootNode;
    };
    var serializeNode = function (settings, schema, node) {
      var htmlSerializer = HtmlSerializer(settings, schema);
      return htmlSerializer.serialize(node);
    };
    var toHtml = function (editor, settings, schema, rootNode, args) {
      var content = serializeNode(settings, schema, rootNode);
      return postProcess(editor, args, content);
    };
    var DomSerializerImpl = function (settings, editor) {
      var tempAttrs = ['data-mce-selected'];
      var dom = editor && editor.dom ? editor.dom : DOMUtils.DOM;
      var schema = editor && editor.schema ? editor.schema : Schema(settings);
      settings.entity_encoding = settings.entity_encoding || 'named';
      settings.remove_trailing_brs = 'remove_trailing_brs' in settings ? settings.remove_trailing_brs : true;
      var htmlParser = DomParser(settings, schema);
      register(htmlParser, settings, dom);
      var serialize = function (node, parserArgs) {
        if (parserArgs === void 0) {
          parserArgs = {};
        }
        var args = __assign({ format: 'html' }, parserArgs);
        var targetNode = process(editor, node, args);
        var html = getHtmlFromNode(dom, targetNode, args);
        var rootNode = parseHtml(htmlParser, html, args);
        return args.format === 'tree' ? rootNode : toHtml(editor, settings, schema, rootNode, args);
      };
      return {
        schema: schema,
        addNodeFilter: htmlParser.addNodeFilter,
        addAttributeFilter: htmlParser.addAttributeFilter,
        serialize: serialize,
        addRules: schema.addValidElements,
        setRules: schema.setValidElements,
        addTempAttr: curry(addTempAttr, htmlParser, tempAttrs),
        getTempAttrs: constant(tempAttrs),
        getNodeFilters: htmlParser.getNodeFilters,
        getAttributeFilters: htmlParser.getAttributeFilters
      };
    };

    var DomSerializer = function (settings, editor) {
      var domSerializer = DomSerializerImpl(settings, editor);
      return {
        schema: domSerializer.schema,
        addNodeFilter: domSerializer.addNodeFilter,
        addAttributeFilter: domSerializer.addAttributeFilter,
        serialize: domSerializer.serialize,
        addRules: domSerializer.addRules,
        setRules: domSerializer.setRules,
        addTempAttr: domSerializer.addTempAttr,
        getTempAttrs: domSerializer.getTempAttrs,
        getNodeFilters: domSerializer.getNodeFilters,
        getAttributeFilters: domSerializer.getAttributeFilters
      };
    };

    var defaultFormat = 'html';
    var getContent = function (editor, args) {
      if (args === void 0) {
        args = {};
      }
      var format = args.format ? args.format : defaultFormat;
      return getContent$2(editor, args, format);
    };

    var setContent = function (editor, content, args) {
      if (args === void 0) {
        args = {};
      }
      return setContent$2(editor, content, args);
    };

    var DOM$7 = DOMUtils.DOM;
    var restoreOriginalStyles = function (editor) {
      DOM$7.setStyle(editor.id, 'display', editor.orgDisplay);
    };
    var safeDestroy = function (x) {
      return Optional.from(x).each(function (x) {
        return x.destroy();
      });
    };
    var clearDomReferences = function (editor) {
      editor.contentAreaContainer = editor.formElement = editor.container = editor.editorContainer = null;
      editor.bodyElement = editor.contentDocument = editor.contentWindow = null;
      editor.iframeElement = editor.targetElm = null;
      if (editor.selection) {
        editor.selection = editor.selection.win = editor.selection.dom = editor.selection.dom.doc = null;
      }
    };
    var restoreForm = function (editor) {
      var form = editor.formElement;
      if (form) {
        if (form._mceOldSubmit) {
          form.submit = form._mceOldSubmit;
          form._mceOldSubmit = null;
        }
        DOM$7.unbind(form, 'submit reset', editor.formEventDelegate);
      }
    };
    var remove = function (editor) {
      if (!editor.removed) {
        var _selectionOverrides = editor._selectionOverrides, editorUpload = editor.editorUpload;
        var body = editor.getBody();
        var element = editor.getElement();
        if (body) {
          editor.save({ is_removing: true });
        }
        editor.removed = true;
        editor.unbindAllNativeEvents();
        if (editor.hasHiddenInput && element) {
          DOM$7.remove(element.nextSibling);
        }
        fireRemove(editor);
        editor.editorManager.remove(editor);
        if (!editor.inline && body) {
          restoreOriginalStyles(editor);
        }
        fireDetach(editor);
        DOM$7.remove(editor.getContainer());
        safeDestroy(_selectionOverrides);
        safeDestroy(editorUpload);
        editor.destroy();
      }
    };
    var destroy = function (editor, automatic) {
      var selection = editor.selection, dom = editor.dom;
      if (editor.destroyed) {
        return;
      }
      if (!automatic && !editor.removed) {
        editor.remove();
        return;
      }
      if (!automatic) {
        editor.editorManager.off('beforeunload', editor._beforeUnload);
        if (editor.theme && editor.theme.destroy) {
          editor.theme.destroy();
        }
        safeDestroy(selection);
        safeDestroy(dom);
      }
      restoreForm(editor);
      clearDomReferences(editor);
      editor.destroyed = true;
    };

    var deep = function (old, nu) {
      var bothObjects = isObject(old) && isObject(nu);
      return bothObjects ? deepMerge(old, nu) : nu;
    };
    var baseMerge = function (merger) {
      return function () {
        var objects = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          objects[_i] = arguments[_i];
        }
        if (objects.length === 0) {
          throw new Error('Can\'t merge zero objects');
        }
        var ret = {};
        for (var j = 0; j < objects.length; j++) {
          var curObject = objects[j];
          for (var key in curObject) {
            if (has$2(curObject, key)) {
              ret[key] = merger(ret[key], curObject[key]);
            }
          }
        }
        return ret;
      };
    };
    var deepMerge = baseMerge(deep);

    var deprecatedSettings = ('autoresize_on_init,content_editable_state,convert_fonts_to_spans,inline_styles,padd_empty_with_br,block_elements,' + 'boolean_attributes,editor_deselector,editor_selector,elements,file_browser_callback_types,filepicker_validator_handler,' + 'force_hex_style_colors,force_p_newlines,gecko_spellcheck,images_dataimg_filter,media_scripts,mode,move_caret_before_on_enter_elements,' + 'non_empty_elements,self_closing_elements,short_ended_elements,special,spellchecker_select_languages,spellchecker_whitelist,' + 'tab_focus,table_responsive_width,text_block_elements,text_inline_elements,toolbar_drawer,types,validate,whitespace_elements,' + 'paste_word_valid_elements,paste_retain_style_properties,paste_convert_word_fake_lists').split(',');
    var deprecatedPlugins = 'bbcode,colorpicker,contextmenu,fullpage,legacyoutput,spellchecker,textcolor'.split(',');
    var movedToPremiumPlugins = 'imagetools,toc'.split(',');
    var getDeprecatedSettings = function (settings) {
      var settingNames = filter$4(deprecatedSettings, function (setting) {
        return has$2(settings, setting);
      });
      var forcedRootBlock = settings.forced_root_block;
      if (forcedRootBlock === false || forcedRootBlock === '') {
        settingNames.push('forced_root_block (false only)');
      }
      return sort(settingNames);
    };
    var getDeprecatedPlugins = function (settings) {
      var plugins = Tools.makeMap(settings.plugins, ' ');
      var hasPlugin = function (plugin) {
        return has$2(plugins, plugin);
      };
      var pluginNames = __spreadArray(__spreadArray([], filter$4(deprecatedPlugins, hasPlugin), true), bind(movedToPremiumPlugins, function (plugin) {
        return hasPlugin(plugin) ? [plugin + ' (moving to premium)'] : [];
      }), true);
      return sort(pluginNames);
    };
    var logDeprecationsWarning = function (rawSettings, finalSettings) {
      var deprecatedSettings = getDeprecatedSettings(rawSettings);
      var deprecatedPlugins = getDeprecatedPlugins(finalSettings);
      var hasDeprecatedPlugins = deprecatedPlugins.length > 0;
      var hasDeprecatedSettings = deprecatedSettings.length > 0;
      var isLegacyMobileTheme = finalSettings.theme === 'mobile';
      if (hasDeprecatedPlugins || hasDeprecatedSettings || isLegacyMobileTheme) {
        var listJoiner = '\n- ';
        var themesMessage = isLegacyMobileTheme ? '\n\nThemes:' + listJoiner + 'mobile' : '';
        var pluginsMessage = hasDeprecatedPlugins ? '\n\nPlugins:' + listJoiner + deprecatedPlugins.join(listJoiner) : '';
        var settingsMessage = hasDeprecatedSettings ? '\n\nSettings:' + listJoiner + deprecatedSettings.join(listJoiner) : '';
        console.warn('The following deprecated features are currently enabled, these will be removed in TinyMCE 6.0. ' + 'See https://www.tiny.cloud/docs/release-notes/6.0-upcoming-changes/ for more information.' + themesMessage + pluginsMessage + settingsMessage);
      }
    };

    var sectionResult = function (sections, settings) {
      return {
        sections: constant(sections),
        settings: constant(settings)
      };
    };
    var deviceDetection = detect().deviceType;
    var isTouch = deviceDetection.isTouch();
    var isPhone = deviceDetection.isPhone();
    var isTablet = deviceDetection.isTablet();
    var legacyMobilePlugins = [
      'lists',
      'autolink',
      'autosave'
    ];
    var defaultTouchSettings = {
      table_grid: false,
      object_resizing: false,
      resize: false
    };
    var normalizePlugins = function (plugins) {
      var pluginNames = isArray$1(plugins) ? plugins.join(' ') : plugins;
      var trimmedPlugins = map$3(isString$1(pluginNames) ? pluginNames.split(' ') : [], trim$4);
      return filter$4(trimmedPlugins, function (item) {
        return item.length > 0;
      });
    };
    var filterLegacyMobilePlugins = function (plugins) {
      return filter$4(plugins, curry(contains$3, legacyMobilePlugins));
    };
    var extractSections = function (keys, settings) {
      var result = bifilter(settings, function (value, key) {
        return contains$3(keys, key);
      });
      return sectionResult(result.t, result.f);
    };
    var getSection = function (sectionResult, name, defaults) {
      if (defaults === void 0) {
        defaults = {};
      }
      var sections = sectionResult.sections();
      var sectionSettings = get$9(sections, name).getOr({});
      return Tools.extend({}, defaults, sectionSettings);
    };
    var hasSection = function (sectionResult, name) {
      return has$2(sectionResult.sections(), name);
    };
    var isSectionTheme = function (sectionResult, name, theme) {
      var section = sectionResult.sections();
      return hasSection(sectionResult, name) && section[name].theme === theme;
    };
    var getSectionConfig = function (sectionResult, name) {
      return hasSection(sectionResult, name) ? sectionResult.sections()[name] : {};
    };
    var getToolbarMode = function (settings, defaultVal) {
      return get$9(settings, 'toolbar_mode').orThunk(function () {
        return get$9(settings, 'toolbar_drawer').map(function (val) {
          return val === false ? 'wrap' : val;
        });
      }).getOr(defaultVal);
    };
    var getDefaultSettings = function (settings, id, documentBaseUrl, isTouch, editor) {
      var baseDefaults = {
        id: id,
        theme: 'silver',
        toolbar_mode: getToolbarMode(settings, 'floating'),
        plugins: '',
        document_base_url: documentBaseUrl,
        add_form_submit_trigger: true,
        submit_patch: true,
        add_unload_trigger: true,
        convert_urls: true,
        relative_urls: true,
        remove_script_host: true,
        object_resizing: true,
        doctype: '<!DOCTYPE html>',
        visual: true,
        font_size_legacy_values: 'xx-small,small,medium,large,x-large,xx-large,300%',
        forced_root_block: 'p',
        hidden_input: true,
        inline_styles: true,
        convert_fonts_to_spans: true,
        indent: true,
        indent_before: 'p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,' + 'tfoot,tbody,tr,section,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist',
        indent_after: 'p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,' + 'tfoot,tbody,tr,section,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist',
        entity_encoding: 'named',
        url_converter: editor.convertURL,
        url_converter_scope: editor
      };
      return __assign(__assign({}, baseDefaults), isTouch ? defaultTouchSettings : {});
    };
    var getDefaultMobileSettings = function (mobileSettings, isPhone) {
      var defaultMobileSettings = {
        resize: false,
        toolbar_mode: getToolbarMode(mobileSettings, 'scrolling'),
        toolbar_sticky: false
      };
      var defaultPhoneSettings = { menubar: false };
      return __assign(__assign(__assign({}, defaultTouchSettings), defaultMobileSettings), isPhone ? defaultPhoneSettings : {});
    };
    var getExternalPlugins = function (overrideSettings, settings) {
      var userDefinedExternalPlugins = settings.external_plugins ? settings.external_plugins : {};
      if (overrideSettings && overrideSettings.external_plugins) {
        return Tools.extend({}, overrideSettings.external_plugins, userDefinedExternalPlugins);
      } else {
        return userDefinedExternalPlugins;
      }
    };
    var combinePlugins = function (forcedPlugins, plugins) {
      return [].concat(normalizePlugins(forcedPlugins)).concat(normalizePlugins(plugins));
    };
    var getPlatformPlugins = function (isMobileDevice, sectionResult, desktopPlugins, mobilePlugins) {
      if (isMobileDevice && isSectionTheme(sectionResult, 'mobile', 'mobile')) {
        return filterLegacyMobilePlugins(mobilePlugins);
      } else if (isMobileDevice && hasSection(sectionResult, 'mobile')) {
        return mobilePlugins;
      } else {
        return desktopPlugins;
      }
    };
    var processPlugins = function (isMobileDevice, sectionResult, defaultOverrideSettings, settings) {
      var forcedPlugins = normalizePlugins(defaultOverrideSettings.forced_plugins);
      var desktopPlugins = normalizePlugins(settings.plugins);
      var mobileConfig = getSectionConfig(sectionResult, 'mobile');
      var mobilePlugins = mobileConfig.plugins ? normalizePlugins(mobileConfig.plugins) : desktopPlugins;
      var platformPlugins = getPlatformPlugins(isMobileDevice, sectionResult, desktopPlugins, mobilePlugins);
      var combinedPlugins = combinePlugins(forcedPlugins, platformPlugins);
      if (Env.browser.isIE() && contains$3(combinedPlugins, 'rtc')) {
        throw new Error('RTC plugin is not supported on IE 11.');
      }
      return Tools.extend(settings, { plugins: combinedPlugins.join(' ') });
    };
    var isOnMobile = function (isMobileDevice, sectionResult) {
      return isMobileDevice && hasSection(sectionResult, 'mobile');
    };
    var combineSettings = function (isMobileDevice, isPhone, defaultSettings, defaultOverrideSettings, settings) {
      var defaultDeviceSettings = isMobileDevice ? { mobile: getDefaultMobileSettings(settings.mobile || {}, isPhone) } : {};
      var sectionResult = extractSections(['mobile'], deepMerge(defaultDeviceSettings, settings));
      var extendedSettings = Tools.extend(defaultSettings, defaultOverrideSettings, sectionResult.settings(), isOnMobile(isMobileDevice, sectionResult) ? getSection(sectionResult, 'mobile') : {}, {
        validate: true,
        external_plugins: getExternalPlugins(defaultOverrideSettings, sectionResult.settings())
      });
      return processPlugins(isMobileDevice, sectionResult, defaultOverrideSettings, extendedSettings);
    };
    var getEditorSettings = function (editor, id, documentBaseUrl, defaultOverrideSettings, settings) {
      var defaultSettings = getDefaultSettings(settings, id, documentBaseUrl, isTouch, editor);
      var finalSettings = combineSettings(isPhone || isTablet, isPhone, defaultSettings, defaultOverrideSettings, settings);
      if (finalSettings.deprecation_warnings !== false) {
        logDeprecationsWarning(settings, finalSettings);
      }
      return finalSettings;
    };
    var getFiltered = function (predicate, editor, name) {
      return Optional.from(editor.settings[name]).filter(predicate);
    };
    var getParamObject = function (value) {
      var output = {};
      if (typeof value === 'string') {
        each$k(value.indexOf('=') > 0 ? value.split(/[;,](?![^=;,]*(?:[;,]|$))/) : value.split(','), function (val) {
          var arr = val.split('=');
          if (arr.length > 1) {
            output[Tools.trim(arr[0])] = Tools.trim(arr[1]);
          } else {
            output[Tools.trim(arr[0])] = Tools.trim(arr[0]);
          }
        });
      } else {
        output = value;
      }
      return output;
    };
    var isArrayOf = function (p) {
      return function (a) {
        return isArray$1(a) && forall(a, p);
      };
    };
    var getParam = function (editor, name, defaultVal, type) {
      var value = name in editor.settings ? editor.settings[name] : defaultVal;
      if (type === 'hash') {
        return getParamObject(value);
      } else if (type === 'string') {
        return getFiltered(isString$1, editor, name).getOr(defaultVal);
      } else if (type === 'number') {
        return getFiltered(isNumber, editor, name).getOr(defaultVal);
      } else if (type === 'boolean') {
        return getFiltered(isBoolean, editor, name).getOr(defaultVal);
      } else if (type === 'object') {
        return getFiltered(isObject, editor, name).getOr(defaultVal);
      } else if (type === 'array') {
        return getFiltered(isArray$1, editor, name).getOr(defaultVal);
      } else if (type === 'string[]') {
        return getFiltered(isArrayOf(isString$1), editor, name).getOr(defaultVal);
      } else if (type === 'function') {
        return getFiltered(isFunction, editor, name).getOr(defaultVal);
      } else {
        return value;
      }
    };

    var CreateIconManager = function () {
      var lookup = {};
      var add = function (id, iconPack) {
        lookup[id] = iconPack;
      };
      var get = function (id) {
        if (lookup[id]) {
          return lookup[id];
        }
        return { icons: {} };
      };
      var has = function (id) {
        return has$2(lookup, id);
      };
      return {
        add: add,
        get: get,
        has: has
      };
    };
    var IconManager = CreateIconManager();

    var getProp = function (propName, elm) {
      var rawElm = elm.dom;
      return rawElm[propName];
    };
    var getComputedSizeProp = function (propName, elm) {
      return parseInt(get$5(elm, propName), 10);
    };
    var getClientWidth = curry(getProp, 'clientWidth');
    var getClientHeight = curry(getProp, 'clientHeight');
    var getMarginTop = curry(getComputedSizeProp, 'margin-top');
    var getMarginLeft = curry(getComputedSizeProp, 'margin-left');
    var getBoundingClientRect = function (elm) {
      return elm.dom.getBoundingClientRect();
    };
    var isInsideElementContentArea = function (bodyElm, clientX, clientY) {
      var clientWidth = getClientWidth(bodyElm);
      var clientHeight = getClientHeight(bodyElm);
      return clientX >= 0 && clientY >= 0 && clientX <= clientWidth && clientY <= clientHeight;
    };
    var transpose = function (inline, elm, clientX, clientY) {
      var clientRect = getBoundingClientRect(elm);
      var deltaX = inline ? clientRect.left + elm.dom.clientLeft + getMarginLeft(elm) : 0;
      var deltaY = inline ? clientRect.top + elm.dom.clientTop + getMarginTop(elm) : 0;
      var x = clientX - deltaX;
      var y = clientY - deltaY;
      return {
        x: x,
        y: y
      };
    };
    var isXYInContentArea = function (editor, clientX, clientY) {
      var bodyElm = SugarElement.fromDom(editor.getBody());
      var targetElm = editor.inline ? bodyElm : documentElement(bodyElm);
      var transposedPoint = transpose(editor.inline, targetElm, clientX, clientY);
      return isInsideElementContentArea(targetElm, transposedPoint.x, transposedPoint.y);
    };
    var fromDomSafe = function (node) {
      return Optional.from(node).map(SugarElement.fromDom);
    };
    var isEditorAttachedToDom = function (editor) {
      var rawContainer = editor.inline ? editor.getBody() : editor.getContentAreaContainer();
      return fromDomSafe(rawContainer).map(inBody).getOr(false);
    };

    var NotificationManagerImpl = function () {
      var unimplemented = function () {
        throw new Error('Theme did not provide a NotificationManager implementation.');
      };
      return {
        open: unimplemented,
        close: unimplemented,
        reposition: unimplemented,
        getArgs: unimplemented
      };
    };

    var NotificationManager = function (editor) {
      var notifications = [];
      var getImplementation = function () {
        var theme = editor.theme;
        return theme && theme.getNotificationManagerImpl ? theme.getNotificationManagerImpl() : NotificationManagerImpl();
      };
      var getTopNotification = function () {
        return Optional.from(notifications[0]);
      };
      var isEqual = function (a, b) {
        return a.type === b.type && a.text === b.text && !a.progressBar && !a.timeout && !b.progressBar && !b.timeout;
      };
      var reposition = function () {
        if (notifications.length > 0) {
          getImplementation().reposition(notifications);
        }
      };
      var addNotification = function (notification) {
        notifications.push(notification);
      };
      var closeNotification = function (notification) {
        findIndex$2(notifications, function (otherNotification) {
          return otherNotification === notification;
        }).each(function (index) {
          notifications.splice(index, 1);
        });
      };
      var open = function (spec, fireEvent) {
        if (fireEvent === void 0) {
          fireEvent = true;
        }
        if (editor.removed || !isEditorAttachedToDom(editor)) {
          return;
        }
        if (fireEvent) {
          editor.fire('BeforeOpenNotification', { notification: spec });
        }
        return find$3(notifications, function (notification) {
          return isEqual(getImplementation().getArgs(notification), spec);
        }).getOrThunk(function () {
          editor.editorManager.setActive(editor);
          var notification = getImplementation().open(spec, function () {
            closeNotification(notification);
            reposition();
            getTopNotification().fold(function () {
              return editor.focus();
            }, function (top) {
              return focus$1(SugarElement.fromDom(top.getEl()));
            });
          });
          addNotification(notification);
          reposition();
          editor.fire('OpenNotification', { notification: __assign({}, notification) });
          return notification;
        });
      };
      var close = function () {
        getTopNotification().each(function (notification) {
          getImplementation().close(notification);
          closeNotification(notification);
          reposition();
        });
      };
      var getNotifications = constant(notifications);
      var registerEvents = function (editor) {
        editor.on('SkinLoaded', function () {
          var serviceMessage = getServiceMessage(editor);
          if (serviceMessage) {
            open({
              text: serviceMessage,
              type: 'warning',
              timeout: 0
            }, false);
          }
          reposition();
        });
        editor.on('show ResizeEditor ResizeWindow NodeChange', function () {
          Delay.requestAnimationFrame(reposition);
        });
        editor.on('remove', function () {
          each$k(notifications.slice(), function (notification) {
            getImplementation().close(notification);
          });
        });
      };
      registerEvents(editor);
      return {
        open: open,
        close: close,
        getNotifications: getNotifications
      };
    };

    var PluginManager = AddOnManager.PluginManager;

    var ThemeManager = AddOnManager.ThemeManager;

    function WindowManagerImpl () {
      var unimplemented = function () {
        throw new Error('Theme did not provide a WindowManager implementation.');
      };
      return {
        open: unimplemented,
        openUrl: unimplemented,
        alert: unimplemented,
        confirm: unimplemented,
        close: unimplemented,
        getParams: unimplemented,
        setParams: unimplemented
      };
    }

    var WindowManager = function (editor) {
      var dialogs = [];
      var getImplementation = function () {
        var theme = editor.theme;
        return theme && theme.getWindowManagerImpl ? theme.getWindowManagerImpl() : WindowManagerImpl();
      };
      var funcBind = function (scope, f) {
        return function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          return f ? f.apply(scope, args) : undefined;
        };
      };
      var fireOpenEvent = function (dialog) {
        editor.fire('OpenWindow', { dialog: dialog });
      };
      var fireCloseEvent = function (dialog) {
        editor.fire('CloseWindow', { dialog: dialog });
      };
      var addDialog = function (dialog) {
        dialogs.push(dialog);
        fireOpenEvent(dialog);
      };
      var closeDialog = function (dialog) {
        fireCloseEvent(dialog);
        dialogs = filter$4(dialogs, function (otherDialog) {
          return otherDialog !== dialog;
        });
        if (dialogs.length === 0) {
          editor.focus();
        }
      };
      var getTopDialog = function () {
        return Optional.from(dialogs[dialogs.length - 1]);
      };
      var storeSelectionAndOpenDialog = function (openDialog) {
        editor.editorManager.setActive(editor);
        store(editor);
        var dialog = openDialog();
        addDialog(dialog);
        return dialog;
      };
      var open = function (args, params) {
        return storeSelectionAndOpenDialog(function () {
          return getImplementation().open(args, params, closeDialog);
        });
      };
      var openUrl = function (args) {
        return storeSelectionAndOpenDialog(function () {
          return getImplementation().openUrl(args, closeDialog);
        });
      };
      var alert = function (message, callback, scope) {
        var windowManagerImpl = getImplementation();
        windowManagerImpl.alert(message, funcBind(scope ? scope : windowManagerImpl, callback));
      };
      var confirm = function (message, callback, scope) {
        var windowManagerImpl = getImplementation();
        windowManagerImpl.confirm(message, funcBind(scope ? scope : windowManagerImpl, callback));
      };
      var close = function () {
        getTopDialog().each(function (dialog) {
          getImplementation().close(dialog);
          closeDialog(dialog);
        });
      };
      editor.on('remove', function () {
        each$k(dialogs, function (dialog) {
          getImplementation().close(dialog);
        });
      });
      return {
        open: open,
        openUrl: openUrl,
        alert: alert,
        confirm: confirm,
        close: close
      };
    };

    var displayNotification = function (editor, message) {
      editor.notificationManager.open({
        type: 'error',
        text: message
      });
    };
    var displayError = function (editor, message) {
      if (editor._skinLoaded) {
        displayNotification(editor, message);
      } else {
        editor.on('SkinLoaded', function () {
          displayNotification(editor, message);
        });
      }
    };
    var uploadError = function (editor, message) {
      displayError(editor, I18n.translate([
        'Failed to upload image: {0}',
        message
      ]));
    };
    var logError = function (editor, errorType, msg) {
      fireError(editor, errorType, { message: msg });
      console.error(msg);
    };
    var createLoadError = function (type, url, name) {
      return name ? 'Failed to load ' + type + ': ' + name + ' from url ' + url : 'Failed to load ' + type + ' url: ' + url;
    };
    var pluginLoadError = function (editor, url, name) {
      logError(editor, 'PluginLoadError', createLoadError('plugin', url, name));
    };
    var iconsLoadError = function (editor, url, name) {
      logError(editor, 'IconsLoadError', createLoadError('icons', url, name));
    };
    var languageLoadError = function (editor, url, name) {
      logError(editor, 'LanguageLoadError', createLoadError('language', url, name));
    };
    var pluginInitError = function (editor, name, err) {
      var message = I18n.translate([
        'Failed to initialize plugin: {0}',
        name
      ]);
      fireError(editor, 'PluginLoadError', { message: message });
      initError(message, err);
      displayError(editor, message);
    };
    var initError = function (message) {
      var x = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        x[_i - 1] = arguments[_i];
      }
      var console = window.console;
      if (console) {
        if (console.error) {
          console.error.apply(console, __spreadArray([message], x, false));
        } else {
          console.log.apply(console, __spreadArray([message], x, false));
        }
      }
    };

    var isContentCssSkinName = function (url) {
      return /^[a-z0-9\-]+$/i.test(url);
    };
    var getContentCssUrls = function (editor) {
      return transformToUrls(editor, getContentCss(editor));
    };
    var getFontCssUrls = function (editor) {
      return transformToUrls(editor, getFontCss(editor));
    };
    var transformToUrls = function (editor, cssLinks) {
      var skinUrl = editor.editorManager.baseURL + '/skins/content';
      var suffix = editor.editorManager.suffix;
      var contentCssFile = 'content' + suffix + '.css';
      var inline = editor.inline === true;
      return map$3(cssLinks, function (url) {
        if (isContentCssSkinName(url) && !inline) {
          return skinUrl + '/' + url + '/' + contentCssFile;
        } else {
          return editor.documentBaseURI.toAbsolute(url);
        }
      });
    };
    var appendContentCssFromSettings = function (editor) {
      editor.contentCSS = editor.contentCSS.concat(getContentCssUrls(editor), getFontCssUrls(editor));
    };

    var UploadStatus = function () {
      var PENDING = 1, UPLOADED = 2;
      var blobUriStatuses = {};
      var createStatus = function (status, resultUri) {
        return {
          status: status,
          resultUri: resultUri
        };
      };
      var hasBlobUri = function (blobUri) {
        return blobUri in blobUriStatuses;
      };
      var getResultUri = function (blobUri) {
        var result = blobUriStatuses[blobUri];
        return result ? result.resultUri : null;
      };
      var isPending = function (blobUri) {
        return hasBlobUri(blobUri) ? blobUriStatuses[blobUri].status === PENDING : false;
      };
      var isUploaded = function (blobUri) {
        return hasBlobUri(blobUri) ? blobUriStatuses[blobUri].status === UPLOADED : false;
      };
      var markPending = function (blobUri) {
        blobUriStatuses[blobUri] = createStatus(PENDING, null);
      };
      var markUploaded = function (blobUri, resultUri) {
        blobUriStatuses[blobUri] = createStatus(UPLOADED, resultUri);
      };
      var removeFailed = function (blobUri) {
        delete blobUriStatuses[blobUri];
      };
      var destroy = function () {
        blobUriStatuses = {};
      };
      return {
        hasBlobUri: hasBlobUri,
        getResultUri: getResultUri,
        isPending: isPending,
        isUploaded: isUploaded,
        markPending: markPending,
        markUploaded: markUploaded,
        removeFailed: removeFailed,
        destroy: destroy
      };
    };

    var count = 0;
    var seed = function () {
      var rnd = function () {
        return Math.round(Math.random() * 4294967295).toString(36);
      };
      var now = new Date().getTime();
      return 's' + now.toString(36) + rnd() + rnd() + rnd();
    };
    var uuid = function (prefix) {
      return prefix + count++ + seed();
    };

    var BlobCache = function () {
      var cache = [];
      var mimeToExt = function (mime) {
        var mimes = {
          'image/jpeg': 'jpg',
          'image/jpg': 'jpg',
          'image/gif': 'gif',
          'image/png': 'png',
          'image/apng': 'apng',
          'image/avif': 'avif',
          'image/svg+xml': 'svg',
          'image/webp': 'webp',
          'image/bmp': 'bmp',
          'image/tiff': 'tiff'
        };
        return mimes[mime.toLowerCase()] || 'dat';
      };
      var create = function (o, blob, base64, name, filename) {
        if (isString$1(o)) {
          var id = o;
          return toBlobInfo({
            id: id,
            name: name,
            filename: filename,
            blob: blob,
            base64: base64
          });
        } else if (isObject(o)) {
          return toBlobInfo(o);
        } else {
          throw new Error('Unknown input type');
        }
      };
      var toBlobInfo = function (o) {
        if (!o.blob || !o.base64) {
          throw new Error('blob and base64 representations of the image are required for BlobInfo to be created');
        }
        var id = o.id || uuid('blobid');
        var name = o.name || id;
        var blob = o.blob;
        return {
          id: constant(id),
          name: constant(name),
          filename: constant(o.filename || name + '.' + mimeToExt(blob.type)),
          blob: constant(blob),
          base64: constant(o.base64),
          blobUri: constant(o.blobUri || URL.createObjectURL(blob)),
          uri: constant(o.uri)
        };
      };
      var add = function (blobInfo) {
        if (!get(blobInfo.id())) {
          cache.push(blobInfo);
        }
      };
      var findFirst = function (predicate) {
        return find$3(cache, predicate).getOrUndefined();
      };
      var get = function (id) {
        return findFirst(function (cachedBlobInfo) {
          return cachedBlobInfo.id() === id;
        });
      };
      var getByUri = function (blobUri) {
        return findFirst(function (blobInfo) {
          return blobInfo.blobUri() === blobUri;
        });
      };
      var getByData = function (base64, type) {
        return findFirst(function (blobInfo) {
          return blobInfo.base64() === base64 && blobInfo.blob().type === type;
        });
      };
      var removeByUri = function (blobUri) {
        cache = filter$4(cache, function (blobInfo) {
          if (blobInfo.blobUri() === blobUri) {
            URL.revokeObjectURL(blobInfo.blobUri());
            return false;
          }
          return true;
        });
      };
      var destroy = function () {
        each$k(cache, function (cachedBlobInfo) {
          URL.revokeObjectURL(cachedBlobInfo.blobUri());
        });
        cache = [];
      };
      return {
        create: create,
        add: add,
        get: get,
        getByUri: getByUri,
        getByData: getByData,
        findFirst: findFirst,
        removeByUri: removeByUri,
        destroy: destroy
      };
    };

    var Uploader = function (uploadStatus, settings) {
      var pendingPromises = {};
      var pathJoin = function (path1, path2) {
        if (path1) {
          return path1.replace(/\/$/, '') + '/' + path2.replace(/^\//, '');
        }
        return path2;
      };
      var defaultHandler = function (blobInfo, success, failure, progress) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', settings.url);
        xhr.withCredentials = settings.credentials;
        xhr.upload.onprogress = function (e) {
          progress(e.loaded / e.total * 100);
        };
        xhr.onerror = function () {
          failure('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
        };
        xhr.onload = function () {
          if (xhr.status < 200 || xhr.status >= 300) {
            failure('HTTP Error: ' + xhr.status);
            return;
          }
          var json = JSON.parse(xhr.responseText);
          if (!json || typeof json.location !== 'string') {
            failure('Invalid JSON: ' + xhr.responseText);
            return;
          }
          success(pathJoin(settings.basePath, json.location));
        };
        var formData = new FormData();
        formData.append('file', blobInfo.blob(), blobInfo.filename());
        xhr.send(formData);
      };
      var noUpload = function () {
        return new promiseObj(function (resolve) {
          resolve([]);
        });
      };
      var handlerSuccess = function (blobInfo, url) {
        return {
          url: url,
          blobInfo: blobInfo,
          status: true
        };
      };
      var handlerFailure = function (blobInfo, message, options) {
        return {
          url: '',
          blobInfo: blobInfo,
          status: false,
          error: {
            message: message,
            options: options
          }
        };
      };
      var resolvePending = function (blobUri, result) {
        Tools.each(pendingPromises[blobUri], function (resolve) {
          resolve(result);
        });
        delete pendingPromises[blobUri];
      };
      var uploadBlobInfo = function (blobInfo, handler, openNotification) {
        uploadStatus.markPending(blobInfo.blobUri());
        return new promiseObj(function (resolve) {
          var notification, progress;
          try {
            var closeNotification_1 = function () {
              if (notification) {
                notification.close();
                progress = noop;
              }
            };
            var success = function (url) {
              closeNotification_1();
              uploadStatus.markUploaded(blobInfo.blobUri(), url);
              resolvePending(blobInfo.blobUri(), handlerSuccess(blobInfo, url));
              resolve(handlerSuccess(blobInfo, url));
            };
            var failure = function (error, options) {
              var failureOptions = options ? options : {};
              closeNotification_1();
              uploadStatus.removeFailed(blobInfo.blobUri());
              resolvePending(blobInfo.blobUri(), handlerFailure(blobInfo, error, failureOptions));
              resolve(handlerFailure(blobInfo, error, failureOptions));
            };
            progress = function (percent) {
              if (percent < 0 || percent > 100) {
                return;
              }
              Optional.from(notification).orThunk(function () {
                return Optional.from(openNotification).map(apply);
              }).each(function (n) {
                notification = n;
                n.progressBar.value(percent);
              });
            };
            handler(blobInfo, success, failure, progress);
          } catch (ex) {
            resolve(handlerFailure(blobInfo, ex.message, {}));
          }
        });
      };
      var isDefaultHandler = function (handler) {
        return handler === defaultHandler;
      };
      var pendingUploadBlobInfo = function (blobInfo) {
        var blobUri = blobInfo.blobUri();
        return new promiseObj(function (resolve) {
          pendingPromises[blobUri] = pendingPromises[blobUri] || [];
          pendingPromises[blobUri].push(resolve);
        });
      };
      var uploadBlobs = function (blobInfos, openNotification) {
        blobInfos = Tools.grep(blobInfos, function (blobInfo) {
          return !uploadStatus.isUploaded(blobInfo.blobUri());
        });
        return promiseObj.all(Tools.map(blobInfos, function (blobInfo) {
          return uploadStatus.isPending(blobInfo.blobUri()) ? pendingUploadBlobInfo(blobInfo) : uploadBlobInfo(blobInfo, settings.handler, openNotification);
        }));
      };
      var upload = function (blobInfos, openNotification) {
        return !settings.url && isDefaultHandler(settings.handler) ? noUpload() : uploadBlobs(blobInfos, openNotification);
      };
      if (isFunction(settings.handler) === false) {
        settings.handler = defaultHandler;
      }
      return { upload: upload };
    };

    var openNotification = function (editor) {
      return function () {
        return editor.notificationManager.open({
          text: editor.translate('Image uploading...'),
          type: 'info',
          timeout: -1,
          progressBar: true
        });
      };
    };
    var createUploader = function (editor, uploadStatus) {
      return Uploader(uploadStatus, {
        url: getImageUploadUrl(editor),
        basePath: getImageUploadBasePath(editor),
        credentials: getImagesUploadCredentials(editor),
        handler: getImagesUploadHandler(editor)
      });
    };
    var ImageUploader = function (editor) {
      var uploadStatus = UploadStatus();
      var uploader = createUploader(editor, uploadStatus);
      return {
        upload: function (blobInfos, showNotification) {
          if (showNotification === void 0) {
            showNotification = true;
          }
          return uploader.upload(blobInfos, showNotification ? openNotification(editor) : undefined);
        }
      };
    };

    var UploadChangeHandler = function (editor) {
      var lastChangedLevel = Cell(null);
      editor.on('change AddUndo', function (e) {
        lastChangedLevel.set(__assign({}, e.level));
      });
      var fireIfChanged = function () {
        var data = editor.undoManager.data;
        last$2(data).filter(function (level) {
          return !isEq$1(lastChangedLevel.get(), level);
        }).each(function (level) {
          editor.setDirty(true);
          editor.fire('change', {
            level: level,
            lastLevel: get$a(data, data.length - 2).getOrNull()
          });
        });
      };
      return { fireIfChanged: fireIfChanged };
    };
    var EditorUpload = function (editor) {
      var blobCache = BlobCache();
      var uploader, imageScanner;
      var uploadStatus = UploadStatus();
      var urlFilters = [];
      var changeHandler = UploadChangeHandler(editor);
      var aliveGuard = function (callback) {
        return function (result) {
          if (editor.selection) {
            return callback(result);
          }
          return [];
        };
      };
      var cacheInvalidator = function (url) {
        return url + (url.indexOf('?') === -1 ? '?' : '&') + new Date().getTime();
      };
      var replaceString = function (content, search, replace) {
        var index = 0;
        do {
          index = content.indexOf(search, index);
          if (index !== -1) {
            content = content.substring(0, index) + replace + content.substr(index + search.length);
            index += replace.length - search.length + 1;
          }
        } while (index !== -1);
        return content;
      };
      var replaceImageUrl = function (content, targetUrl, replacementUrl) {
        var replacementString = 'src="' + replacementUrl + '"' + (replacementUrl === Env.transparentSrc ? ' data-mce-placeholder="1"' : '');
        content = replaceString(content, 'src="' + targetUrl + '"', replacementString);
        content = replaceString(content, 'data-mce-src="' + targetUrl + '"', 'data-mce-src="' + replacementUrl + '"');
        return content;
      };
      var replaceUrlInUndoStack = function (targetUrl, replacementUrl) {
        each$k(editor.undoManager.data, function (level) {
          if (level.type === 'fragmented') {
            level.fragments = map$3(level.fragments, function (fragment) {
              return replaceImageUrl(fragment, targetUrl, replacementUrl);
            });
          } else {
            level.content = replaceImageUrl(level.content, targetUrl, replacementUrl);
          }
        });
      };
      var replaceImageUriInView = function (image, resultUri) {
        var src = editor.convertURL(resultUri, 'src');
        replaceUrlInUndoStack(image.src, resultUri);
        editor.$(image).attr({
          'src': shouldReuseFileName(editor) ? cacheInvalidator(resultUri) : resultUri,
          'data-mce-src': src
        });
      };
      var uploadImages = function (callback) {
        if (!uploader) {
          uploader = createUploader(editor, uploadStatus);
        }
        return scanForImages().then(aliveGuard(function (imageInfos) {
          var blobInfos = map$3(imageInfos, function (imageInfo) {
            return imageInfo.blobInfo;
          });
          return uploader.upload(blobInfos, openNotification(editor)).then(aliveGuard(function (result) {
            var imagesToRemove = [];
            var filteredResult = map$3(result, function (uploadInfo, index) {
              var blobInfo = imageInfos[index].blobInfo;
              var image = imageInfos[index].image;
              if (uploadInfo.status && shouldReplaceBlobUris(editor)) {
                blobCache.removeByUri(image.src);
                if (isRtc(editor)) ; else {
                  replaceImageUriInView(image, uploadInfo.url);
                }
              } else if (uploadInfo.error) {
                if (uploadInfo.error.options.remove) {
                  replaceUrlInUndoStack(image.getAttribute('src'), Env.transparentSrc);
                  imagesToRemove.push(image);
                }
                uploadError(editor, uploadInfo.error.message);
              }
              return {
                element: image,
                status: uploadInfo.status,
                uploadUri: uploadInfo.url,
                blobInfo: blobInfo
              };
            });
            if (filteredResult.length > 0) {
              changeHandler.fireIfChanged();
            }
            if (imagesToRemove.length > 0) {
              if (isRtc(editor)) {
                console.error('Removing images on failed uploads is currently unsupported for RTC');
              } else {
                editor.undoManager.transact(function () {
                  each$k(imagesToRemove, function (element) {
                    editor.dom.remove(element);
                    blobCache.removeByUri(element.src);
                  });
                });
              }
            }
            if (callback) {
              callback(filteredResult);
            }
            return filteredResult;
          }));
        }));
      };
      var uploadImagesAuto = function (callback) {
        if (isAutomaticUploadsEnabled(editor)) {
          return uploadImages(callback);
        }
      };
      var isValidDataUriImage = function (imgElm) {
        if (forall(urlFilters, function (filter) {
            return filter(imgElm);
          }) === false) {
          return false;
        }
        if (imgElm.getAttribute('src').indexOf('data:') === 0) {
          var dataImgFilter = getImagesDataImgFilter(editor);
          return dataImgFilter(imgElm);
        }
        return true;
      };
      var addFilter = function (filter) {
        urlFilters.push(filter);
      };
      var scanForImages = function () {
        if (!imageScanner) {
          imageScanner = ImageScanner(uploadStatus, blobCache);
        }
        return imageScanner.findAll(editor.getBody(), isValidDataUriImage).then(aliveGuard(function (result) {
          result = filter$4(result, function (resultItem) {
            if (typeof resultItem === 'string') {
              displayError(editor, resultItem);
              return false;
            }
            return true;
          });
          if (isRtc(editor)) ; else {
            each$k(result, function (resultItem) {
              replaceUrlInUndoStack(resultItem.image.src, resultItem.blobInfo.blobUri());
              resultItem.image.src = resultItem.blobInfo.blobUri();
              resultItem.image.removeAttribute('data-mce-src');
            });
          }
          return result;
        }));
      };
      var destroy = function () {
        blobCache.destroy();
        uploadStatus.destroy();
        imageScanner = uploader = null;
      };
      var replaceBlobUris = function (content) {
        return content.replace(/src="(blob:[^"]+)"/g, function (match, blobUri) {
          var resultUri = uploadStatus.getResultUri(blobUri);
          if (resultUri) {
            return 'src="' + resultUri + '"';
          }
          var blobInfo = blobCache.getByUri(blobUri);
          if (!blobInfo) {
            blobInfo = foldl(editor.editorManager.get(), function (result, editor) {
              return result || editor.editorUpload && editor.editorUpload.blobCache.getByUri(blobUri);
            }, null);
          }
          if (blobInfo) {
            var blob = blobInfo.blob();
            return 'src="data:' + blob.type + ';base64,' + blobInfo.base64() + '"';
          }
          return match;
        });
      };
      editor.on('SetContent', function () {
        if (isAutomaticUploadsEnabled(editor)) {
          uploadImagesAuto();
        } else {
          scanForImages();
        }
      });
      editor.on('RawSaveContent', function (e) {
        e.content = replaceBlobUris(e.content);
      });
      editor.on('GetContent', function (e) {
        if (e.source_view || e.format === 'raw' || e.format === 'tree') {
          return;
        }
        e.content = replaceBlobUris(e.content);
      });
      editor.on('PostRender', function () {
        editor.parser.addNodeFilter('img', function (images) {
          each$k(images, function (img) {
            var src = img.attr('src');
            if (blobCache.getByUri(src)) {
              return;
            }
            var resultUri = uploadStatus.getResultUri(src);
            if (resultUri) {
              img.attr('src', resultUri);
            }
          });
        });
      });
      return {
        blobCache: blobCache,
        addFilter: addFilter,
        uploadImages: uploadImages,
        uploadImagesAuto: uploadImagesAuto,
        scanForImages: scanForImages,
        destroy: destroy
      };
    };

    var get = function (dom) {
      var formats = {
        valigntop: [{
            selector: 'td,th',
            styles: { verticalAlign: 'top' }
          }],
        valignmiddle: [{
            selector: 'td,th',
            styles: { verticalAlign: 'middle' }
          }],
        valignbottom: [{
            selector: 'td,th',
            styles: { verticalAlign: 'bottom' }
          }],
        alignleft: [
          {
            selector: 'figure.image',
            collapsed: false,
            classes: 'align-left',
            ceFalseOverride: true,
            preview: 'font-family font-size'
          },
          {
            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
            styles: { textAlign: 'left' },
            inherit: false,
            preview: false,
            defaultBlock: 'div'
          },
          {
            selector: 'img,table,audio,video',
            collapsed: false,
            styles: { float: 'left' },
            preview: 'font-family font-size'
          }
        ],
        aligncenter: [
          {
            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
            styles: { textAlign: 'center' },
            inherit: false,
            preview: 'font-family font-size',
            defaultBlock: 'div'
          },
          {
            selector: 'figure.image',
            collapsed: false,
            classes: 'align-center',
            ceFalseOverride: true,
            preview: 'font-family font-size'
          },
          {
            selector: 'img,audio,video',
            collapsed: false,
            styles: {
              display: 'block',
              marginLeft: 'auto',
              marginRight: 'auto'
            },
            preview: false
          },
          {
            selector: 'table',
            collapsed: false,
            styles: {
              marginLeft: 'auto',
              marginRight: 'auto'
            },
            preview: 'font-family font-size'
          }
        ],
        alignright: [
          {
            selector: 'figure.image',
            collapsed: false,
            classes: 'align-right',
            ceFalseOverride: true,
            preview: 'font-family font-size'
          },
          {
            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
            styles: { textAlign: 'right' },
            inherit: false,
            preview: 'font-family font-size',
            defaultBlock: 'div'
          },
          {
            selector: 'img,table,audio,video',
            collapsed: false,
            styles: { float: 'right' },
            preview: 'font-family font-size'
          }
        ],
        alignjustify: [{
            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
            styles: { textAlign: 'justify' },
            inherit: false,
            defaultBlock: 'div',
            preview: 'font-family font-size'
          }],
        bold: [
          {
            inline: 'strong',
            remove: 'all',
            preserve_attributes: [
              'class',
              'style'
            ]
          },
          {
            inline: 'span',
            styles: { fontWeight: 'bold' }
          },
          {
            inline: 'b',
            remove: 'all',
            preserve_attributes: [
              'class',
              'style'
            ]
          }
        ],
        italic: [
          {
            inline: 'em',
            remove: 'all',
            preserve_attributes: [
              'class',
              'style'
            ]
          },
          {
            inline: 'span',
            styles: { fontStyle: 'italic' }
          },
          {
            inline: 'i',
            remove: 'all',
            preserve_attributes: [
              'class',
              'style'
            ]
          }
        ],
        underline: [
          {
            inline: 'span',
            styles: { textDecoration: 'underline' },
            exact: true
          },
          {
            inline: 'u',
            remove: 'all',
            preserve_attributes: [
              'class',
              'style'
            ]
          }
        ],
        strikethrough: [
          {
            inline: 'span',
            styles: { textDecoration: 'line-through' },
            exact: true
          },
          {
            inline: 'strike',
            remove: 'all',
            preserve_attributes: [
              'class',
              'style'
            ]
          },
          {
            inline: 's',
            remove: 'all',
            preserve_attributes: [
              'class',
              'style'
            ]
          }
        ],
        forecolor: {
          inline: 'span',
          styles: { color: '%value' },
          links: true,
          remove_similar: true,
          clear_child_styles: true
        },
        hilitecolor: {
          inline: 'span',
          styles: { backgroundColor: '%value' },
          links: true,
          remove_similar: true,
          clear_child_styles: true
        },
        fontname: {
          inline: 'span',
          toggle: false,
          styles: { fontFamily: '%value' },
          clear_child_styles: true
        },
        fontsize: {
          inline: 'span',
          toggle: false,
          styles: { fontSize: '%value' },
          clear_child_styles: true
        },
        lineheight: {
          selector: 'h1,h2,h3,h4,h5,h6,p,li,td,th,div',
          defaultBlock: 'p',
          styles: { lineHeight: '%value' }
        },
        fontsize_class: {
          inline: 'span',
          attributes: { class: '%value' }
        },
        blockquote: {
          block: 'blockquote',
          wrapper: true,
          remove: 'all'
        },
        subscript: { inline: 'sub' },
        superscript: { inline: 'sup' },
        code: { inline: 'code' },
        link: {
          inline: 'a',
          selector: 'a',
          remove: 'all',
          split: true,
          deep: true,
          onmatch: function (node, _fmt, _itemName) {
            return isElement$5(node) && node.hasAttribute('href');
          },
          onformat: function (elm, _fmt, vars) {
            Tools.each(vars, function (value, key) {
              dom.setAttrib(elm, key, value);
            });
          }
        },
        lang: {
          inline: 'span',
          clear_child_styles: true,
          remove_similar: true,
          attributes: {
            'lang': '%value',
            'data-mce-lang': function (vars) {
              var _a;
              return (_a = vars === null || vars === void 0 ? void 0 : vars.customValue) !== null && _a !== void 0 ? _a : null;
            }
          }
        },
        removeformat: [
          {
            selector: 'b,strong,em,i,font,u,strike,s,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del,ins,small',
            remove: 'all',
            split: true,
            expand: false,
            block_expand: true,
            deep: true
          },
          {
            selector: 'span',
            attributes: [
              'style',
              'class'
            ],
            remove: 'empty',
            split: true,
            expand: false,
            deep: true
          },
          {
            selector: '*',
            attributes: [
              'style',
              'class'
            ],
            split: false,
            expand: false,
            deep: true
          }
        ]
      };
      Tools.each('p h1 h2 h3 h4 h5 h6 div address pre dt dd samp'.split(/\s/), function (name) {
        formats[name] = {
          block: name,
          remove: 'all'
        };
      });
      return formats;
    };

    var FormatRegistry = function (editor) {
      var formats = {};
      var get$1 = function (name) {
        return isNonNullable(name) ? formats[name] : formats;
      };
      var has = function (name) {
        return has$2(formats, name);
      };
      var register = function (name, format) {
        if (name) {
          if (!isString$1(name)) {
            each$j(name, function (format, name) {
              register(name, format);
            });
          } else {
            if (!isArray$1(format)) {
              format = [format];
            }
            each$k(format, function (format) {
              if (isUndefined(format.deep)) {
                format.deep = !isSelectorFormat(format);
              }
              if (isUndefined(format.split)) {
                format.split = !isSelectorFormat(format) || isInlineFormat(format);
              }
              if (isUndefined(format.remove) && isSelectorFormat(format) && !isInlineFormat(format)) {
                format.remove = 'none';
              }
              if (isSelectorFormat(format) && isInlineFormat(format)) {
                format.mixed = true;
                format.block_expand = true;
              }
              if (isString$1(format.classes)) {
                format.classes = format.classes.split(/\s+/);
              }
            });
            formats[name] = format;
          }
        }
      };
      var unregister = function (name) {
        if (name && formats[name]) {
          delete formats[name];
        }
        return formats;
      };
      register(get(editor.dom));
      register(getFormats(editor));
      return {
        get: get$1,
        has: has,
        register: register,
        unregister: unregister
      };
    };

    var each$5 = Tools.each;
    var dom = DOMUtils.DOM;
    var parsedSelectorToHtml = function (ancestry, editor) {
      var elm, item, fragment;
      var schema = editor && editor.schema || Schema({});
      var decorate = function (elm, item) {
        if (item.classes.length) {
          dom.addClass(elm, item.classes.join(' '));
        }
        dom.setAttribs(elm, item.attrs);
      };
      var createElement = function (sItem) {
        item = typeof sItem === 'string' ? {
          name: sItem,
          classes: [],
          attrs: {}
        } : sItem;
        var elm = dom.create(item.name);
        decorate(elm, item);
        return elm;
      };
      var getRequiredParent = function (elm, candidate) {
        var name = typeof elm !== 'string' ? elm.nodeName.toLowerCase() : elm;
        var elmRule = schema.getElementRule(name);
        var parentsRequired = elmRule && elmRule.parentsRequired;
        if (parentsRequired && parentsRequired.length) {
          return candidate && Tools.inArray(parentsRequired, candidate) !== -1 ? candidate : parentsRequired[0];
        } else {
          return false;
        }
      };
      var wrapInHtml = function (elm, ancestry, siblings) {
        var parent, parentCandidate;
        var ancestor = ancestry.length > 0 && ancestry[0];
        var ancestorName = ancestor && ancestor.name;
        var parentRequired = getRequiredParent(elm, ancestorName);
        if (parentRequired) {
          if (ancestorName === parentRequired) {
            parentCandidate = ancestry[0];
            ancestry = ancestry.slice(1);
          } else {
            parentCandidate = parentRequired;
          }
        } else if (ancestor) {
          parentCandidate = ancestry[0];
          ancestry = ancestry.slice(1);
        } else if (!siblings) {
          return elm;
        }
        if (parentCandidate) {
          parent = createElement(parentCandidate);
          parent.appendChild(elm);
        }
        if (siblings) {
          if (!parent) {
            parent = dom.create('div');
            parent.appendChild(elm);
          }
          Tools.each(siblings, function (sibling) {
            var siblingElm = createElement(sibling);
            parent.insertBefore(siblingElm, elm);
          });
        }
        return wrapInHtml(parent, ancestry, parentCandidate && parentCandidate.siblings);
      };
      if (ancestry && ancestry.length) {
        item = ancestry[0];
        elm = createElement(item);
        fragment = dom.create('div');
        fragment.appendChild(wrapInHtml(elm, ancestry.slice(1), item.siblings));
        return fragment;
      } else {
        return '';
      }
    };
    var parseSelectorItem = function (item) {
      var tagName;
      var obj = {
        classes: [],
        attrs: {}
      };
      item = obj.selector = Tools.trim(item);
      if (item !== '*') {
        tagName = item.replace(/(?:([#\.]|::?)([\w\-]+)|(\[)([^\]]+)\]?)/g, function ($0, $1, $2, $3, $4) {
          switch ($1) {
          case '#':
            obj.attrs.id = $2;
            break;
          case '.':
            obj.classes.push($2);
            break;
          case ':':
            if (Tools.inArray('checked disabled enabled read-only required'.split(' '), $2) !== -1) {
              obj.attrs[$2] = $2;
            }
            break;
          }
          if ($3 === '[') {
            var m = $4.match(/([\w\-]+)(?:\=\"([^\"]+))?/);
            if (m) {
              obj.attrs[m[1]] = m[2];
            }
          }
          return '';
        });
      }
      obj.name = tagName || 'div';
      return obj;
    };
    var parseSelector = function (selector) {
      if (!selector || typeof selector !== 'string') {
        return [];
      }
      selector = selector.split(/\s*,\s*/)[0];
      selector = selector.replace(/\s*(~\+|~|\+|>)\s*/g, '$1');
      return Tools.map(selector.split(/(?:>|\s+(?![^\[\]]+\]))/), function (item) {
        var siblings = Tools.map(item.split(/(?:~\+|~|\+)/), parseSelectorItem);
        var obj = siblings.pop();
        if (siblings.length) {
          obj.siblings = siblings;
        }
        return obj;
      }).reverse();
    };
    var getCssText = function (editor, format) {
      var name, previewFrag;
      var previewCss = '', parentFontSize;
      var previewStyles = getPreviewStyles(editor);
      if (previewStyles === '') {
        return '';
      }
      var removeVars = function (val) {
        return val.replace(/%(\w+)/g, '');
      };
      if (typeof format === 'string') {
        format = editor.formatter.get(format);
        if (!format) {
          return;
        }
        format = format[0];
      }
      if ('preview' in format) {
        var previewOpt = get$9(format, 'preview');
        if (is$1(previewOpt, false)) {
          return '';
        } else {
          previewStyles = previewOpt.getOr(previewStyles);
        }
      }
      name = format.block || format.inline || 'span';
      var items = parseSelector(format.selector);
      if (items.length) {
        if (!items[0].name) {
          items[0].name = name;
        }
        name = format.selector;
        previewFrag = parsedSelectorToHtml(items, editor);
      } else {
        previewFrag = parsedSelectorToHtml([name], editor);
      }
      var previewElm = dom.select(name, previewFrag)[0] || previewFrag.firstChild;
      each$5(format.styles, function (value, name) {
        var newValue = removeVars(value);
        if (newValue) {
          dom.setStyle(previewElm, name, newValue);
        }
      });
      each$5(format.attributes, function (value, name) {
        var newValue = removeVars(value);
        if (newValue) {
          dom.setAttrib(previewElm, name, newValue);
        }
      });
      each$5(format.classes, function (value) {
        var newValue = removeVars(value);
        if (!dom.hasClass(previewElm, newValue)) {
          dom.addClass(previewElm, newValue);
        }
      });
      editor.fire('PreviewFormats');
      dom.setStyles(previewFrag, {
        position: 'absolute',
        left: -65535
      });
      editor.getBody().appendChild(previewFrag);
      parentFontSize = dom.getStyle(editor.getBody(), 'fontSize', true);
      parentFontSize = /px$/.test(parentFontSize) ? parseInt(parentFontSize, 10) : 0;
      each$5(previewStyles.split(' '), function (name) {
        var value = dom.getStyle(previewElm, name, true);
        if (name === 'background-color' && /transparent|rgba\s*\([^)]+,\s*0\)/.test(value)) {
          value = dom.getStyle(editor.getBody(), name, true);
          if (dom.toHex(value).toLowerCase() === '#ffffff') {
            return;
          }
        }
        if (name === 'color') {
          if (dom.toHex(value).toLowerCase() === '#000000') {
            return;
          }
        }
        if (name === 'font-size') {
          if (/em|%$/.test(value)) {
            if (parentFontSize === 0) {
              return;
            }
            var numValue = parseFloat(value) / (/%$/.test(value) ? 100 : 1);
            value = numValue * parentFontSize + 'px';
          }
        }
        if (name === 'border' && value) {
          previewCss += 'padding:0 2px;';
        }
        previewCss += name + ':' + value + ';';
      });
      editor.fire('AfterPreviewFormats');
      dom.remove(previewFrag);
      return previewCss;
    };

    var setup$h = function (editor) {
      editor.addShortcut('meta+b', '', 'Bold');
      editor.addShortcut('meta+i', '', 'Italic');
      editor.addShortcut('meta+u', '', 'Underline');
      for (var i = 1; i <= 6; i++) {
        editor.addShortcut('access+' + i, '', [
          'FormatBlock',
          false,
          'h' + i
        ]);
      }
      editor.addShortcut('access+7', '', [
        'FormatBlock',
        false,
        'p'
      ]);
      editor.addShortcut('access+8', '', [
        'FormatBlock',
        false,
        'div'
      ]);
      editor.addShortcut('access+9', '', [
        'FormatBlock',
        false,
        'address'
      ]);
    };

    var Formatter = function (editor) {
      var formats = FormatRegistry(editor);
      var formatChangeState = Cell(null);
      setup$h(editor);
      setup$k(editor);
      return {
        get: formats.get,
        has: formats.has,
        register: formats.register,
        unregister: formats.unregister,
        apply: function (name, vars, node) {
          applyFormat(editor, name, vars, node);
        },
        remove: function (name, vars, node, similar) {
          removeFormat(editor, name, vars, node, similar);
        },
        toggle: function (name, vars, node) {
          toggleFormat(editor, name, vars, node);
        },
        match: function (name, vars, node, similar) {
          return matchFormat(editor, name, vars, node, similar);
        },
        closest: function (names) {
          return closestFormat(editor, names);
        },
        matchAll: function (names, vars) {
          return matchAllFormats(editor, names, vars);
        },
        matchNode: function (node, name, vars, similar) {
          return matchNodeFormat(editor, node, name, vars, similar);
        },
        canApply: function (name) {
          return canApplyFormat(editor, name);
        },
        formatChanged: function (formats, callback, similar, vars) {
          return formatChanged(editor, formatChangeState, formats, callback, similar, vars);
        },
        getCssText: curry(getCssText, editor)
      };
    };

    var shouldIgnoreCommand = function (cmd) {
      switch (cmd.toLowerCase()) {
      case 'undo':
      case 'redo':
      case 'mcerepaint':
      case 'mcefocus':
        return true;
      default:
        return false;
      }
    };
    var registerEvents = function (editor, undoManager, locks) {
      var isFirstTypedCharacter = Cell(false);
      var addNonTypingUndoLevel = function (e) {
        setTyping(undoManager, false, locks);
        undoManager.add({}, e);
      };
      editor.on('init', function () {
        undoManager.add();
      });
      editor.on('BeforeExecCommand', function (e) {
        var cmd = e.command;
        if (!shouldIgnoreCommand(cmd)) {
          endTyping(undoManager, locks);
          undoManager.beforeChange();
        }
      });
      editor.on('ExecCommand', function (e) {
        var cmd = e.command;
        if (!shouldIgnoreCommand(cmd)) {
          addNonTypingUndoLevel(e);
        }
      });
      editor.on('ObjectResizeStart cut', function () {
        undoManager.beforeChange();
      });
      editor.on('SaveContent ObjectResized blur', addNonTypingUndoLevel);
      editor.on('dragend', addNonTypingUndoLevel);
      editor.on('keyup', function (e) {
        var keyCode = e.keyCode;
        if (e.isDefaultPrevented()) {
          return;
        }
        if (keyCode >= 33 && keyCode <= 36 || keyCode >= 37 && keyCode <= 40 || keyCode === 45 || e.ctrlKey) {
          addNonTypingUndoLevel();
          editor.nodeChanged();
        }
        if (keyCode === 46 || keyCode === 8) {
          editor.nodeChanged();
        }
        if (isFirstTypedCharacter.get() && undoManager.typing && isEq$1(createFromEditor(editor), undoManager.data[0]) === false) {
          if (editor.isDirty() === false) {
            editor.setDirty(true);
            editor.fire('change', {
              level: undoManager.data[0],
              lastLevel: null
            });
          }
          editor.fire('TypingUndo');
          isFirstTypedCharacter.set(false);
          editor.nodeChanged();
        }
      });
      editor.on('keydown', function (e) {
        var keyCode = e.keyCode;
        if (e.isDefaultPrevented()) {
          return;
        }
        if (keyCode >= 33 && keyCode <= 36 || keyCode >= 37 && keyCode <= 40 || keyCode === 45) {
          if (undoManager.typing) {
            addNonTypingUndoLevel(e);
          }
          return;
        }
        var modKey = e.ctrlKey && !e.altKey || e.metaKey;
        if ((keyCode < 16 || keyCode > 20) && keyCode !== 224 && keyCode !== 91 && !undoManager.typing && !modKey) {
          undoManager.beforeChange();
          setTyping(undoManager, true, locks);
          undoManager.add({}, e);
          isFirstTypedCharacter.set(true);
        }
      });
      editor.on('mousedown', function (e) {
        if (undoManager.typing) {
          addNonTypingUndoLevel(e);
        }
      });
      var isInsertReplacementText = function (event) {
        return event.inputType === 'insertReplacementText';
      };
      var isInsertTextDataNull = function (event) {
        return event.inputType === 'insertText' && event.data === null;
      };
      var isInsertFromPasteOrDrop = function (event) {
        return event.inputType === 'insertFromPaste' || event.inputType === 'insertFromDrop';
      };
      editor.on('input', function (e) {
        if (e.inputType && (isInsertReplacementText(e) || isInsertTextDataNull(e) || isInsertFromPasteOrDrop(e))) {
          addNonTypingUndoLevel(e);
        }
      });
      editor.on('AddUndo Undo Redo ClearUndos', function (e) {
        if (!e.isDefaultPrevented()) {
          editor.nodeChanged();
        }
      });
    };
    var addKeyboardShortcuts = function (editor) {
      editor.addShortcut('meta+z', '', 'Undo');
      editor.addShortcut('meta+y,meta+shift+z', '', 'Redo');
    };

    var UndoManager = function (editor) {
      var beforeBookmark = value();
      var locks = Cell(0);
      var index = Cell(0);
      var undoManager = {
        data: [],
        typing: false,
        beforeChange: function () {
          beforeChange(editor, locks, beforeBookmark);
        },
        add: function (level, event) {
          return addUndoLevel(editor, undoManager, index, locks, beforeBookmark, level, event);
        },
        undo: function () {
          return undo(editor, undoManager, locks, index);
        },
        redo: function () {
          return redo(editor, index, undoManager.data);
        },
        clear: function () {
          clear(editor, undoManager, index);
        },
        reset: function () {
          reset(editor, undoManager);
        },
        hasUndo: function () {
          return hasUndo(editor, undoManager, index);
        },
        hasRedo: function () {
          return hasRedo(editor, undoManager, index);
        },
        transact: function (callback) {
          return transact(editor, undoManager, locks, callback);
        },
        ignore: function (callback) {
          ignore(editor, locks, callback);
        },
        extra: function (callback1, callback2) {
          extra(editor, undoManager, index, callback1, callback2);
        }
      };
      if (!isRtc(editor)) {
        registerEvents(editor, undoManager, locks);
      }
      addKeyboardShortcuts(editor);
      return undoManager;
    };

    var nonTypingKeycodes = [
      9,
      27,
      VK.HOME,
      VK.END,
      19,
      20,
      44,
      144,
      145,
      33,
      34,
      45,
      16,
      17,
      18,
      91,
      92,
      93,
      VK.DOWN,
      VK.UP,
      VK.LEFT,
      VK.RIGHT
    ].concat(Env.browser.isFirefox() ? [224] : []);
    var placeholderAttr = 'data-mce-placeholder';
    var isKeyboardEvent = function (e) {
      return e.type === 'keydown' || e.type === 'keyup';
    };
    var isDeleteEvent = function (e) {
      var keyCode = e.keyCode;
      return keyCode === VK.BACKSPACE || keyCode === VK.DELETE;
    };
    var isNonTypingKeyboardEvent = function (e) {
      if (isKeyboardEvent(e)) {
        var keyCode = e.keyCode;
        return !isDeleteEvent(e) && (VK.metaKeyPressed(e) || e.altKey || keyCode >= 112 && keyCode <= 123 || contains$3(nonTypingKeycodes, keyCode));
      } else {
        return false;
      }
    };
    var isTypingKeyboardEvent = function (e) {
      return isKeyboardEvent(e) && !(isDeleteEvent(e) || e.type === 'keyup' && e.keyCode === 229);
    };
    var isVisuallyEmpty = function (dom, rootElm, forcedRootBlock) {
      if (isEmpty$2(SugarElement.fromDom(rootElm), false)) {
        var isForcedRootBlockFalse = forcedRootBlock === '';
        var firstElement = rootElm.firstElementChild;
        if (!firstElement) {
          return true;
        } else if (dom.getStyle(rootElm.firstElementChild, 'padding-left') || dom.getStyle(rootElm.firstElementChild, 'padding-right')) {
          return false;
        } else {
          return isForcedRootBlockFalse ? !dom.isBlock(firstElement) : forcedRootBlock === firstElement.nodeName.toLowerCase();
        }
      } else {
        return false;
      }
    };
    var setup$g = function (editor) {
      var dom = editor.dom;
      var rootBlock = getForcedRootBlock(editor);
      var placeholder = getPlaceholder(editor);
      var updatePlaceholder = function (e, initial) {
        if (isNonTypingKeyboardEvent(e)) {
          return;
        }
        var body = editor.getBody();
        var showPlaceholder = isTypingKeyboardEvent(e) ? false : isVisuallyEmpty(dom, body, rootBlock);
        var isPlaceholderShown = dom.getAttrib(body, placeholderAttr) !== '';
        if (isPlaceholderShown !== showPlaceholder || initial) {
          dom.setAttrib(body, placeholderAttr, showPlaceholder ? placeholder : null);
          dom.setAttrib(body, 'aria-placeholder', showPlaceholder ? placeholder : null);
          firePlaceholderToggle(editor, showPlaceholder);
          editor.on(showPlaceholder ? 'keydown' : 'keyup', updatePlaceholder);
          editor.off(showPlaceholder ? 'keyup' : 'keydown', updatePlaceholder);
        }
      };
      if (placeholder) {
        editor.on('init', function (e) {
          updatePlaceholder(e, true);
          editor.on('change SetContent ExecCommand', updatePlaceholder);
          editor.on('paste', function (e) {
            return Delay.setEditorTimeout(editor, function () {
              return updatePlaceholder(e);
            });
          });
        });
      }
    };

    var strongRtl = /[\u0591-\u07FF\uFB1D-\uFDFF\uFE70-\uFEFC]/;
    var hasStrongRtl = function (text) {
      return strongRtl.test(text);
    };

    var isInlineTarget = function (editor, elm) {
      return is$2(SugarElement.fromDom(elm), getInlineBoundarySelector(editor));
    };
    var isRtl = function (element) {
      return DOMUtils.DOM.getStyle(element, 'direction', true) === 'rtl' || hasStrongRtl(element.textContent);
    };
    var findInlineParents = function (isInlineTarget, rootNode, pos) {
      return filter$4(DOMUtils.DOM.getParents(pos.container(), '*', rootNode), isInlineTarget);
    };
    var findRootInline = function (isInlineTarget, rootNode, pos) {
      var parents = findInlineParents(isInlineTarget, rootNode, pos);
      return Optional.from(parents[parents.length - 1]);
    };
    var hasSameParentBlock = function (rootNode, node1, node2) {
      var block1 = getParentBlock$2(node1, rootNode);
      var block2 = getParentBlock$2(node2, rootNode);
      return block1 && block1 === block2;
    };
    var isAtZwsp = function (pos) {
      return isBeforeInline(pos) || isAfterInline(pos);
    };
    var normalizePosition = function (forward, pos) {
      if (!pos) {
        return pos;
      }
      var container = pos.container(), offset = pos.offset();
      if (forward) {
        if (isCaretContainerInline(container)) {
          if (isText$7(container.nextSibling)) {
            return CaretPosition(container.nextSibling, 0);
          } else {
            return CaretPosition.after(container);
          }
        } else {
          return isBeforeInline(pos) ? CaretPosition(container, offset + 1) : pos;
        }
      } else {
        if (isCaretContainerInline(container)) {
          if (isText$7(container.previousSibling)) {
            return CaretPosition(container.previousSibling, container.previousSibling.data.length);
          } else {
            return CaretPosition.before(container);
          }
        } else {
          return isAfterInline(pos) ? CaretPosition(container, offset - 1) : pos;
        }
      }
    };
    var normalizeForwards = curry(normalizePosition, true);
    var normalizeBackwards = curry(normalizePosition, false);

    var isBeforeRoot = function (rootNode) {
      return function (elm) {
        return eq(rootNode, SugarElement.fromDom(elm.dom.parentNode));
      };
    };
    var isTextBlockOrListItem = function (element) {
      return isTextBlock$2(element) || isListItem(element);
    };
    var getParentBlock$1 = function (rootNode, elm) {
      if (contains$1(rootNode, elm)) {
        return closest$3(elm, isTextBlockOrListItem, isBeforeRoot(rootNode));
      } else {
        return Optional.none();
      }
    };
    var placeCaretInEmptyBody = function (editor) {
      var body = editor.getBody();
      var node = body.firstChild && editor.dom.isBlock(body.firstChild) ? body.firstChild : body;
      editor.selection.setCursorLocation(node, 0);
    };
    var paddEmptyBody = function (editor) {
      if (editor.dom.isEmpty(editor.getBody())) {
        editor.setContent('');
        placeCaretInEmptyBody(editor);
      }
    };
    var willDeleteLastPositionInElement = function (forward, fromPos, elm) {
      return lift2(firstPositionIn(elm), lastPositionIn(elm), function (firstPos, lastPos) {
        var normalizedFirstPos = normalizePosition(true, firstPos);
        var normalizedLastPos = normalizePosition(false, lastPos);
        var normalizedFromPos = normalizePosition(false, fromPos);
        if (forward) {
          return nextPosition(elm, normalizedFromPos).exists(function (nextPos) {
            return nextPos.isEqual(normalizedLastPos) && fromPos.isEqual(normalizedFirstPos);
          });
        } else {
          return prevPosition(elm, normalizedFromPos).exists(function (prevPos) {
            return prevPos.isEqual(normalizedFirstPos) && fromPos.isEqual(normalizedLastPos);
          });
        }
      }).getOr(true);
    };

    var blockPosition = function (block, position) {
      return {
        block: block,
        position: position
      };
    };
    var blockBoundary = function (from, to) {
      return {
        from: from,
        to: to
      };
    };
    var getBlockPosition = function (rootNode, pos) {
      var rootElm = SugarElement.fromDom(rootNode);
      var containerElm = SugarElement.fromDom(pos.container());
      return getParentBlock$1(rootElm, containerElm).map(function (block) {
        return blockPosition(block, pos);
      });
    };
    var isDifferentBlocks = function (blockBoundary) {
      return eq(blockBoundary.from.block, blockBoundary.to.block) === false;
    };
    var hasSameParent = function (blockBoundary) {
      return parent(blockBoundary.from.block).bind(function (parent1) {
        return parent(blockBoundary.to.block).filter(function (parent2) {
          return eq(parent1, parent2);
        });
      }).isSome();
    };
    var isEditable$1 = function (blockBoundary) {
      return isContentEditableFalse$b(blockBoundary.from.block.dom) === false && isContentEditableFalse$b(blockBoundary.to.block.dom) === false;
    };
    var skipLastBr = function (rootNode, forward, blockPosition) {
      if (isBr$5(blockPosition.position.getNode()) && isEmpty$2(blockPosition.block) === false) {
        return positionIn(false, blockPosition.block.dom).bind(function (lastPositionInBlock) {
          if (lastPositionInBlock.isEqual(blockPosition.position)) {
            return fromPosition(forward, rootNode, lastPositionInBlock).bind(function (to) {
              return getBlockPosition(rootNode, to);
            });
          } else {
            return Optional.some(blockPosition);
          }
        }).getOr(blockPosition);
      } else {
        return blockPosition;
      }
    };
    var readFromRange = function (rootNode, forward, rng) {
      var fromBlockPos = getBlockPosition(rootNode, CaretPosition.fromRangeStart(rng));
      var toBlockPos = fromBlockPos.bind(function (blockPos) {
        return fromPosition(forward, rootNode, blockPos.position).bind(function (to) {
          return getBlockPosition(rootNode, to).map(function (blockPos) {
            return skipLastBr(rootNode, forward, blockPos);
          });
        });
      });
      return lift2(fromBlockPos, toBlockPos, blockBoundary).filter(function (blockBoundary) {
        return isDifferentBlocks(blockBoundary) && hasSameParent(blockBoundary) && isEditable$1(blockBoundary);
      });
    };
    var read$1 = function (rootNode, forward, rng) {
      return rng.collapsed ? readFromRange(rootNode, forward, rng) : Optional.none();
    };

    var getChildrenUntilBlockBoundary = function (block) {
      var children$1 = children(block);
      return findIndex$2(children$1, isBlock$2).fold(constant(children$1), function (index) {
        return children$1.slice(0, index);
      });
    };
    var extractChildren = function (block) {
      var children = getChildrenUntilBlockBoundary(block);
      each$k(children, remove$7);
      return children;
    };
    var removeEmptyRoot = function (rootNode, block) {
      var parents = parentsAndSelf(block, rootNode);
      return find$3(parents.reverse(), function (element) {
        return isEmpty$2(element);
      }).each(remove$7);
    };
    var isEmptyBefore = function (el) {
      return filter$4(prevSiblings(el), function (el) {
        return !isEmpty$2(el);
      }).length === 0;
    };
    var nestedBlockMerge = function (rootNode, fromBlock, toBlock, insertionPoint) {
      if (isEmpty$2(toBlock)) {
        fillWithPaddingBr(toBlock);
        return firstPositionIn(toBlock.dom);
      }
      if (isEmptyBefore(insertionPoint) && isEmpty$2(fromBlock)) {
        before$4(insertionPoint, SugarElement.fromTag('br'));
      }
      var position = prevPosition(toBlock.dom, CaretPosition.before(insertionPoint.dom));
      each$k(extractChildren(fromBlock), function (child) {
        before$4(insertionPoint, child);
      });
      removeEmptyRoot(rootNode, fromBlock);
      return position;
    };
    var sidelongBlockMerge = function (rootNode, fromBlock, toBlock) {
      if (isEmpty$2(toBlock)) {
        remove$7(toBlock);
        if (isEmpty$2(fromBlock)) {
          fillWithPaddingBr(fromBlock);
        }
        return firstPositionIn(fromBlock.dom);
      }
      var position = lastPositionIn(toBlock.dom);
      each$k(extractChildren(fromBlock), function (child) {
        append$1(toBlock, child);
      });
      removeEmptyRoot(rootNode, fromBlock);
      return position;
    };
    var findInsertionPoint = function (toBlock, block) {
      var parentsAndSelf$1 = parentsAndSelf(block, toBlock);
      return Optional.from(parentsAndSelf$1[parentsAndSelf$1.length - 1]);
    };
    var getInsertionPoint = function (fromBlock, toBlock) {
      return contains$1(toBlock, fromBlock) ? findInsertionPoint(toBlock, fromBlock) : Optional.none();
    };
    var trimBr = function (first, block) {
      positionIn(first, block.dom).map(function (position) {
        return position.getNode();
      }).map(SugarElement.fromDom).filter(isBr$4).each(remove$7);
    };
    var mergeBlockInto = function (rootNode, fromBlock, toBlock) {
      trimBr(true, fromBlock);
      trimBr(false, toBlock);
      return getInsertionPoint(fromBlock, toBlock).fold(curry(sidelongBlockMerge, rootNode, fromBlock, toBlock), curry(nestedBlockMerge, rootNode, fromBlock, toBlock));
    };
    var mergeBlocks = function (rootNode, forward, block1, block2) {
      return forward ? mergeBlockInto(rootNode, block2, block1) : mergeBlockInto(rootNode, block1, block2);
    };

    var backspaceDelete$8 = function (editor, forward) {
      var rootNode = SugarElement.fromDom(editor.getBody());
      var position = read$1(rootNode.dom, forward, editor.selection.getRng()).bind(function (blockBoundary) {
        return mergeBlocks(rootNode, forward, blockBoundary.from.block, blockBoundary.to.block);
      });
      position.each(function (pos) {
        editor.selection.setRng(pos.toRange());
      });
      return position.isSome();
    };

    var deleteRangeMergeBlocks = function (rootNode, selection) {
      var rng = selection.getRng();
      return lift2(getParentBlock$1(rootNode, SugarElement.fromDom(rng.startContainer)), getParentBlock$1(rootNode, SugarElement.fromDom(rng.endContainer)), function (block1, block2) {
        if (eq(block1, block2) === false) {
          rng.deleteContents();
          mergeBlocks(rootNode, true, block1, block2).each(function (pos) {
            selection.setRng(pos.toRange());
          });
          return true;
        } else {
          return false;
        }
      }).getOr(false);
    };
    var isRawNodeInTable = function (root, rawNode) {
      var node = SugarElement.fromDom(rawNode);
      var isRoot = curry(eq, root);
      return ancestor$3(node, isTableCell$4, isRoot).isSome();
    };
    var isSelectionInTable = function (root, rng) {
      return isRawNodeInTable(root, rng.startContainer) || isRawNodeInTable(root, rng.endContainer);
    };
    var isEverythingSelected = function (root, rng) {
      var noPrevious = prevPosition(root.dom, CaretPosition.fromRangeStart(rng)).isNone();
      var noNext = nextPosition(root.dom, CaretPosition.fromRangeEnd(rng)).isNone();
      return !isSelectionInTable(root, rng) && noPrevious && noNext;
    };
    var emptyEditor = function (editor) {
      editor.setContent('');
      editor.selection.setCursorLocation();
      return true;
    };
    var deleteRange$1 = function (editor) {
      var rootNode = SugarElement.fromDom(editor.getBody());
      var rng = editor.selection.getRng();
      return isEverythingSelected(rootNode, rng) ? emptyEditor(editor) : deleteRangeMergeBlocks(rootNode, editor.selection);
    };
    var backspaceDelete$7 = function (editor, _forward) {
      return editor.selection.isCollapsed() ? false : deleteRange$1(editor);
    };

    var isContentEditableTrue$2 = isContentEditableTrue$4;
    var isContentEditableFalse$4 = isContentEditableFalse$b;
    var showCaret = function (direction, editor, node, before, scrollIntoView) {
      return Optional.from(editor._selectionOverrides.showCaret(direction, node, before, scrollIntoView));
    };
    var getNodeRange = function (node) {
      var rng = node.ownerDocument.createRange();
      rng.selectNode(node);
      return rng;
    };
    var selectNode = function (editor, node) {
      var e = editor.fire('BeforeObjectSelected', { target: node });
      if (e.isDefaultPrevented()) {
        return Optional.none();
      }
      return Optional.some(getNodeRange(node));
    };
    var renderCaretAtRange = function (editor, range, scrollIntoView) {
      var normalizedRange = normalizeRange(1, editor.getBody(), range);
      var caretPosition = CaretPosition.fromRangeStart(normalizedRange);
      var caretPositionNode = caretPosition.getNode();
      if (isInlineFakeCaretTarget(caretPositionNode)) {
        return showCaret(1, editor, caretPositionNode, !caretPosition.isAtEnd(), false);
      }
      var caretPositionBeforeNode = caretPosition.getNode(true);
      if (isInlineFakeCaretTarget(caretPositionBeforeNode)) {
        return showCaret(1, editor, caretPositionBeforeNode, false, false);
      }
      var ceRoot = editor.dom.getParent(caretPosition.getNode(), function (node) {
        return isContentEditableFalse$4(node) || isContentEditableTrue$2(node);
      });
      if (isInlineFakeCaretTarget(ceRoot)) {
        return showCaret(1, editor, ceRoot, false, scrollIntoView);
      }
      return Optional.none();
    };
    var renderRangeCaret = function (editor, range, scrollIntoView) {
      return range.collapsed ? renderCaretAtRange(editor, range, scrollIntoView).getOr(range) : range;
    };

    var isBeforeBoundary = function (pos) {
      return isBeforeContentEditableFalse(pos) || isBeforeMedia(pos);
    };
    var isAfterBoundary = function (pos) {
      return isAfterContentEditableFalse(pos) || isAfterMedia(pos);
    };
    var trimEmptyTextNode = function (dom, node) {
      if (isText$7(node) && node.data.length === 0) {
        dom.remove(node);
      }
    };
    var deleteContentAndShowCaret = function (editor, range, node, direction, forward, peekCaretPosition) {
      showCaret(direction, editor, peekCaretPosition.getNode(!forward), forward, true).each(function (caretRange) {
        if (range.collapsed) {
          var deleteRange = range.cloneRange();
          if (forward) {
            deleteRange.setEnd(caretRange.startContainer, caretRange.startOffset);
          } else {
            deleteRange.setStart(caretRange.endContainer, caretRange.endOffset);
          }
          deleteRange.deleteContents();
        } else {
          range.deleteContents();
        }
        editor.selection.setRng(caretRange);
      });
      trimEmptyTextNode(editor.dom, node);
      return true;
    };
    var deleteBoundaryText = function (editor, forward) {
      var range = editor.selection.getRng();
      if (!isText$7(range.commonAncestorContainer)) {
        return false;
      }
      var direction = forward ? HDirection.Forwards : HDirection.Backwards;
      var caretWalker = CaretWalker(editor.getBody());
      var getNextPosFn = curry(getVisualCaretPosition, forward ? caretWalker.next : caretWalker.prev);
      var isBeforeFn = forward ? isBeforeBoundary : isAfterBoundary;
      var caretPosition = getNormalizedRangeEndPoint(direction, editor.getBody(), range);
      var nextCaretPosition = normalizePosition(forward, getNextPosFn(caretPosition));
      if (!nextCaretPosition || !isMoveInsideSameBlock(caretPosition, nextCaretPosition)) {
        return false;
      } else if (isBeforeFn(nextCaretPosition)) {
        return deleteContentAndShowCaret(editor, range, caretPosition.getNode(), direction, forward, nextCaretPosition);
      }
      var peekCaretPosition = getNextPosFn(nextCaretPosition);
      if (peekCaretPosition && isBeforeFn(peekCaretPosition)) {
        if (isMoveInsideSameBlock(nextCaretPosition, peekCaretPosition)) {
          return deleteContentAndShowCaret(editor, range, caretPosition.getNode(), direction, forward, peekCaretPosition);
        }
      }
      return false;
    };
    var backspaceDelete$6 = function (editor, forward) {
      return deleteBoundaryText(editor, forward);
    };

    var isCompoundElement = function (node) {
      return isTableCell$4(SugarElement.fromDom(node)) || isListItem(SugarElement.fromDom(node));
    };
    var DeleteAction = Adt.generate([
      { remove: ['element'] },
      { moveToElement: ['element'] },
      { moveToPosition: ['position'] }
    ]);
    var isAtContentEditableBlockCaret = function (forward, from) {
      var elm = from.getNode(forward === false);
      var caretLocation = forward ? 'after' : 'before';
      return isElement$5(elm) && elm.getAttribute('data-mce-caret') === caretLocation;
    };
    var isDeleteFromCefDifferentBlocks = function (root, forward, from, to) {
      var inSameBlock = function (elm) {
        return isInline$1(SugarElement.fromDom(elm)) && !isInSameBlock(from, to, root);
      };
      return getRelativeCefElm(!forward, from).fold(function () {
        return getRelativeCefElm(forward, to).fold(never, inSameBlock);
      }, inSameBlock);
    };
    var deleteEmptyBlockOrMoveToCef = function (root, forward, from, to) {
      var toCefElm = to.getNode(forward === false);
      return getParentBlock$1(SugarElement.fromDom(root), SugarElement.fromDom(from.getNode())).map(function (blockElm) {
        return isEmpty$2(blockElm) ? DeleteAction.remove(blockElm.dom) : DeleteAction.moveToElement(toCefElm);
      }).orThunk(function () {
        return Optional.some(DeleteAction.moveToElement(toCefElm));
      });
    };
    var findCefPosition = function (root, forward, from) {
      return fromPosition(forward, root, from).bind(function (to) {
        if (isCompoundElement(to.getNode())) {
          return Optional.none();
        } else if (isDeleteFromCefDifferentBlocks(root, forward, from, to)) {
          return Optional.none();
        } else if (forward && isContentEditableFalse$b(to.getNode())) {
          return deleteEmptyBlockOrMoveToCef(root, forward, from, to);
        } else if (forward === false && isContentEditableFalse$b(to.getNode(true))) {
          return deleteEmptyBlockOrMoveToCef(root, forward, from, to);
        } else if (forward && isAfterContentEditableFalse(from)) {
          return Optional.some(DeleteAction.moveToPosition(to));
        } else if (forward === false && isBeforeContentEditableFalse(from)) {
          return Optional.some(DeleteAction.moveToPosition(to));
        } else {
          return Optional.none();
        }
      });
    };
    var getContentEditableBlockAction = function (forward, elm) {
      if (forward && isContentEditableFalse$b(elm.nextSibling)) {
        return Optional.some(DeleteAction.moveToElement(elm.nextSibling));
      } else if (forward === false && isContentEditableFalse$b(elm.previousSibling)) {
        return Optional.some(DeleteAction.moveToElement(elm.previousSibling));
      } else {
        return Optional.none();
      }
    };
    var skipMoveToActionFromInlineCefToContent = function (root, from, deleteAction) {
      return deleteAction.fold(function (elm) {
        return Optional.some(DeleteAction.remove(elm));
      }, function (elm) {
        return Optional.some(DeleteAction.moveToElement(elm));
      }, function (to) {
        if (isInSameBlock(from, to, root)) {
          return Optional.none();
        } else {
          return Optional.some(DeleteAction.moveToPosition(to));
        }
      });
    };
    var getContentEditableAction = function (root, forward, from) {
      if (isAtContentEditableBlockCaret(forward, from)) {
        return getContentEditableBlockAction(forward, from.getNode(forward === false)).fold(function () {
          return findCefPosition(root, forward, from);
        }, Optional.some);
      } else {
        return findCefPosition(root, forward, from).bind(function (deleteAction) {
          return skipMoveToActionFromInlineCefToContent(root, from, deleteAction);
        });
      }
    };
    var read = function (root, forward, rng) {
      var normalizedRange = normalizeRange(forward ? 1 : -1, root, rng);
      var from = CaretPosition.fromRangeStart(normalizedRange);
      var rootElement = SugarElement.fromDom(root);
      if (forward === false && isAfterContentEditableFalse(from)) {
        return Optional.some(DeleteAction.remove(from.getNode(true)));
      } else if (forward && isBeforeContentEditableFalse(from)) {
        return Optional.some(DeleteAction.remove(from.getNode()));
      } else if (forward === false && isBeforeContentEditableFalse(from) && isAfterBr(rootElement, from)) {
        return findPreviousBr(rootElement, from).map(function (br) {
          return DeleteAction.remove(br.getNode());
        });
      } else if (forward && isAfterContentEditableFalse(from) && isBeforeBr$1(rootElement, from)) {
        return findNextBr(rootElement, from).map(function (br) {
          return DeleteAction.remove(br.getNode());
        });
      } else {
        return getContentEditableAction(root, forward, from);
      }
    };

    var deleteElement$1 = function (editor, forward) {
      return function (element) {
        editor._selectionOverrides.hideFakeCaret();
        deleteElement$2(editor, forward, SugarElement.fromDom(element));
        return true;
      };
    };
    var moveToElement = function (editor, forward) {
      return function (element) {
        var pos = forward ? CaretPosition.before(element) : CaretPosition.after(element);
        editor.selection.setRng(pos.toRange());
        return true;
      };
    };
    var moveToPosition = function (editor) {
      return function (pos) {
        editor.selection.setRng(pos.toRange());
        return true;
      };
    };
    var getAncestorCe = function (editor, node) {
      return Optional.from(getContentEditableRoot$1(editor.getBody(), node));
    };
    var backspaceDeleteCaret = function (editor, forward) {
      var selectedNode = editor.selection.getNode();
      return getAncestorCe(editor, selectedNode).filter(isContentEditableFalse$b).fold(function () {
        return read(editor.getBody(), forward, editor.selection.getRng()).exists(function (deleteAction) {
          return deleteAction.fold(deleteElement$1(editor, forward), moveToElement(editor, forward), moveToPosition(editor));
        });
      }, always);
    };
    var deleteOffscreenSelection = function (rootElement) {
      each$k(descendants(rootElement, '.mce-offscreen-selection'), remove$7);
    };
    var backspaceDeleteRange = function (editor, forward) {
      var selectedNode = editor.selection.getNode();
      if (isContentEditableFalse$b(selectedNode) && !isTableCell$5(selectedNode)) {
        var hasCefAncestor = getAncestorCe(editor, selectedNode.parentNode).filter(isContentEditableFalse$b);
        return hasCefAncestor.fold(function () {
          deleteOffscreenSelection(SugarElement.fromDom(editor.getBody()));
          deleteElement$2(editor, forward, SugarElement.fromDom(editor.selection.getNode()));
          paddEmptyBody(editor);
          return true;
        }, always);
      }
      return false;
    };
    var paddEmptyElement = function (editor) {
      var dom = editor.dom, selection = editor.selection;
      var ceRoot = getContentEditableRoot$1(editor.getBody(), selection.getNode());
      if (isContentEditableTrue$4(ceRoot) && dom.isBlock(ceRoot) && dom.isEmpty(ceRoot)) {
        var br = dom.create('br', { 'data-mce-bogus': '1' });
        dom.setHTML(ceRoot, '');
        ceRoot.appendChild(br);
        selection.setRng(CaretPosition.before(br).toRange());
      }
      return true;
    };
    var backspaceDelete$5 = function (editor, forward) {
      if (editor.selection.isCollapsed()) {
        return backspaceDeleteCaret(editor, forward);
      } else {
        return backspaceDeleteRange(editor, forward);
      }
    };

    var deleteCaret$2 = function (editor, forward) {
      var fromPos = CaretPosition.fromRangeStart(editor.selection.getRng());
      return fromPosition(forward, editor.getBody(), fromPos).filter(function (pos) {
        return forward ? isBeforeImageBlock(pos) : isAfterImageBlock(pos);
      }).bind(function (pos) {
        return Optional.from(getChildNodeAtRelativeOffset(forward ? 0 : -1, pos));
      }).exists(function (elm) {
        editor.selection.select(elm);
        return true;
      });
    };
    var backspaceDelete$4 = function (editor, forward) {
      return editor.selection.isCollapsed() ? deleteCaret$2(editor, forward) : false;
    };

    var isText = isText$7;
    var startsWithCaretContainer = function (node) {
      return isText(node) && node.data[0] === ZWSP$1;
    };
    var endsWithCaretContainer = function (node) {
      return isText(node) && node.data[node.data.length - 1] === ZWSP$1;
    };
    var createZwsp = function (node) {
      return node.ownerDocument.createTextNode(ZWSP$1);
    };
    var insertBefore = function (node) {
      if (isText(node.previousSibling)) {
        if (endsWithCaretContainer(node.previousSibling)) {
          return node.previousSibling;
        } else {
          node.previousSibling.appendData(ZWSP$1);
          return node.previousSibling;
        }
      } else if (isText(node)) {
        if (startsWithCaretContainer(node)) {
          return node;
        } else {
          node.insertData(0, ZWSP$1);
          return node;
        }
      } else {
        var newNode = createZwsp(node);
        node.parentNode.insertBefore(newNode, node);
        return newNode;
      }
    };
    var insertAfter = function (node) {
      if (isText(node.nextSibling)) {
        if (startsWithCaretContainer(node.nextSibling)) {
          return node.nextSibling;
        } else {
          node.nextSibling.insertData(0, ZWSP$1);
          return node.nextSibling;
        }
      } else if (isText(node)) {
        if (endsWithCaretContainer(node)) {
          return node;
        } else {
          node.appendData(ZWSP$1);
          return node;
        }
      } else {
        var newNode = createZwsp(node);
        if (node.nextSibling) {
          node.parentNode.insertBefore(newNode, node.nextSibling);
        } else {
          node.parentNode.appendChild(newNode);
        }
        return newNode;
      }
    };
    var insertInline = function (before, node) {
      return before ? insertBefore(node) : insertAfter(node);
    };
    var insertInlineBefore = curry(insertInline, true);
    var insertInlineAfter = curry(insertInline, false);

    var insertInlinePos = function (pos, before) {
      if (isText$7(pos.container())) {
        return insertInline(before, pos.container());
      } else {
        return insertInline(before, pos.getNode());
      }
    };
    var isPosCaretContainer = function (pos, caret) {
      var caretNode = caret.get();
      return caretNode && pos.container() === caretNode && isCaretContainerInline(caretNode);
    };
    var renderCaret = function (caret, location) {
      return location.fold(function (element) {
        remove$2(caret.get());
        var text = insertInlineBefore(element);
        caret.set(text);
        return Optional.some(CaretPosition(text, text.length - 1));
      }, function (element) {
        return firstPositionIn(element).map(function (pos) {
          if (!isPosCaretContainer(pos, caret)) {
            remove$2(caret.get());
            var text = insertInlinePos(pos, true);
            caret.set(text);
            return CaretPosition(text, 1);
          } else {
            return CaretPosition(caret.get(), 1);
          }
        });
      }, function (element) {
        return lastPositionIn(element).map(function (pos) {
          if (!isPosCaretContainer(pos, caret)) {
            remove$2(caret.get());
            var text = insertInlinePos(pos, false);
            caret.set(text);
            return CaretPosition(text, text.length - 1);
          } else {
            return CaretPosition(caret.get(), caret.get().length - 1);
          }
        });
      }, function (element) {
        remove$2(caret.get());
        var text = insertInlineAfter(element);
        caret.set(text);
        return Optional.some(CaretPosition(text, 1));
      });
    };

    var evaluateUntil = function (fns, args) {
      for (var i = 0; i < fns.length; i++) {
        var result = fns[i].apply(null, args);
        if (result.isSome()) {
          return result;
        }
      }
      return Optional.none();
    };

    var Location = Adt.generate([
      { before: ['element'] },
      { start: ['element'] },
      { end: ['element'] },
      { after: ['element'] }
    ]);
    var rescope$1 = function (rootNode, node) {
      var parentBlock = getParentBlock$2(node, rootNode);
      return parentBlock ? parentBlock : rootNode;
    };
    var before = function (isInlineTarget, rootNode, pos) {
      var nPos = normalizeForwards(pos);
      var scope = rescope$1(rootNode, nPos.container());
      return findRootInline(isInlineTarget, scope, nPos).fold(function () {
        return nextPosition(scope, nPos).bind(curry(findRootInline, isInlineTarget, scope)).map(function (inline) {
          return Location.before(inline);
        });
      }, Optional.none);
    };
    var isNotInsideFormatCaretContainer = function (rootNode, elm) {
      return getParentCaretContainer(rootNode, elm) === null;
    };
    var findInsideRootInline = function (isInlineTarget, rootNode, pos) {
      return findRootInline(isInlineTarget, rootNode, pos).filter(curry(isNotInsideFormatCaretContainer, rootNode));
    };
    var start$1 = function (isInlineTarget, rootNode, pos) {
      var nPos = normalizeBackwards(pos);
      return findInsideRootInline(isInlineTarget, rootNode, nPos).bind(function (inline) {
        var prevPos = prevPosition(inline, nPos);
        return prevPos.isNone() ? Optional.some(Location.start(inline)) : Optional.none();
      });
    };
    var end = function (isInlineTarget, rootNode, pos) {
      var nPos = normalizeForwards(pos);
      return findInsideRootInline(isInlineTarget, rootNode, nPos).bind(function (inline) {
        var nextPos = nextPosition(inline, nPos);
        return nextPos.isNone() ? Optional.some(Location.end(inline)) : Optional.none();
      });
    };
    var after = function (isInlineTarget, rootNode, pos) {
      var nPos = normalizeBackwards(pos);
      var scope = rescope$1(rootNode, nPos.container());
      return findRootInline(isInlineTarget, scope, nPos).fold(function () {
        return prevPosition(scope, nPos).bind(curry(findRootInline, isInlineTarget, scope)).map(function (inline) {
          return Location.after(inline);
        });
      }, Optional.none);
    };
    var isValidLocation = function (location) {
      return isRtl(getElement(location)) === false;
    };
    var readLocation = function (isInlineTarget, rootNode, pos) {
      var location = evaluateUntil([
        before,
        start$1,
        end,
        after
      ], [
        isInlineTarget,
        rootNode,
        pos
      ]);
      return location.filter(isValidLocation);
    };
    var getElement = function (location) {
      return location.fold(identity, identity, identity, identity);
    };
    var getName = function (location) {
      return location.fold(constant('before'), constant('start'), constant('end'), constant('after'));
    };
    var outside = function (location) {
      return location.fold(Location.before, Location.before, Location.after, Location.after);
    };
    var inside = function (location) {
      return location.fold(Location.start, Location.start, Location.end, Location.end);
    };
    var isEq = function (location1, location2) {
      return getName(location1) === getName(location2) && getElement(location1) === getElement(location2);
    };
    var betweenInlines = function (forward, isInlineTarget, rootNode, from, to, location) {
      return lift2(findRootInline(isInlineTarget, rootNode, from), findRootInline(isInlineTarget, rootNode, to), function (fromInline, toInline) {
        if (fromInline !== toInline && hasSameParentBlock(rootNode, fromInline, toInline)) {
          return Location.after(forward ? fromInline : toInline);
        } else {
          return location;
        }
      }).getOr(location);
    };
    var skipNoMovement = function (fromLocation, toLocation) {
      return fromLocation.fold(always, function (fromLocation) {
        return !isEq(fromLocation, toLocation);
      });
    };
    var findLocationTraverse = function (forward, isInlineTarget, rootNode, fromLocation, pos) {
      var from = normalizePosition(forward, pos);
      var to = fromPosition(forward, rootNode, from).map(curry(normalizePosition, forward));
      var location = to.fold(function () {
        return fromLocation.map(outside);
      }, function (to) {
        return readLocation(isInlineTarget, rootNode, to).map(curry(betweenInlines, forward, isInlineTarget, rootNode, from, to)).filter(curry(skipNoMovement, fromLocation));
      });
      return location.filter(isValidLocation);
    };
    var findLocationSimple = function (forward, location) {
      if (forward) {
        return location.fold(compose(Optional.some, Location.start), Optional.none, compose(Optional.some, Location.after), Optional.none);
      } else {
        return location.fold(Optional.none, compose(Optional.some, Location.before), Optional.none, compose(Optional.some, Location.end));
      }
    };
    var findLocation$1 = function (forward, isInlineTarget, rootNode, pos) {
      var from = normalizePosition(forward, pos);
      var fromLocation = readLocation(isInlineTarget, rootNode, from);
      return readLocation(isInlineTarget, rootNode, from).bind(curry(findLocationSimple, forward)).orThunk(function () {
        return findLocationTraverse(forward, isInlineTarget, rootNode, fromLocation, pos);
      });
    };
    curry(findLocation$1, false);
    curry(findLocation$1, true);

    var hasSelectionModifyApi = function (editor) {
      return isFunction(editor.selection.getSel().modify);
    };
    var moveRel = function (forward, selection, pos) {
      var delta = forward ? 1 : -1;
      selection.setRng(CaretPosition(pos.container(), pos.offset() + delta).toRange());
      selection.getSel().modify('move', forward ? 'forward' : 'backward', 'word');
      return true;
    };
    var moveByWord = function (forward, editor) {
      var rng = editor.selection.getRng();
      var pos = forward ? CaretPosition.fromRangeEnd(rng) : CaretPosition.fromRangeStart(rng);
      if (!hasSelectionModifyApi(editor)) {
        return false;
      } else if (forward && isBeforeInline(pos)) {
        return moveRel(true, editor.selection, pos);
      } else if (!forward && isAfterInline(pos)) {
        return moveRel(false, editor.selection, pos);
      } else {
        return false;
      }
    };

    var BreakType;
    (function (BreakType) {
      BreakType[BreakType['Br'] = 0] = 'Br';
      BreakType[BreakType['Block'] = 1] = 'Block';
      BreakType[BreakType['Wrap'] = 2] = 'Wrap';
      BreakType[BreakType['Eol'] = 3] = 'Eol';
    }(BreakType || (BreakType = {})));
    var flip = function (direction, positions) {
      return direction === HDirection.Backwards ? reverse(positions) : positions;
    };
    var walk = function (direction, caretWalker, pos) {
      return direction === HDirection.Forwards ? caretWalker.next(pos) : caretWalker.prev(pos);
    };
    var getBreakType = function (scope, direction, currentPos, nextPos) {
      if (isBr$5(nextPos.getNode(direction === HDirection.Forwards))) {
        return BreakType.Br;
      } else if (isInSameBlock(currentPos, nextPos) === false) {
        return BreakType.Block;
      } else {
        return BreakType.Wrap;
      }
    };
    var getPositionsUntil = function (predicate, direction, scope, start) {
      var caretWalker = CaretWalker(scope);
      var currentPos = start;
      var positions = [];
      while (currentPos) {
        var nextPos = walk(direction, caretWalker, currentPos);
        if (!nextPos) {
          break;
        }
        if (isBr$5(nextPos.getNode(false))) {
          if (direction === HDirection.Forwards) {
            return {
              positions: flip(direction, positions).concat([nextPos]),
              breakType: BreakType.Br,
              breakAt: Optional.some(nextPos)
            };
          } else {
            return {
              positions: flip(direction, positions),
              breakType: BreakType.Br,
              breakAt: Optional.some(nextPos)
            };
          }
        }
        if (!nextPos.isVisible()) {
          currentPos = nextPos;
          continue;
        }
        if (predicate(currentPos, nextPos)) {
          var breakType = getBreakType(scope, direction, currentPos, nextPos);
          return {
            positions: flip(direction, positions),
            breakType: breakType,
            breakAt: Optional.some(nextPos)
          };
        }
        positions.push(nextPos);
        currentPos = nextPos;
      }
      return {
        positions: flip(direction, positions),
        breakType: BreakType.Eol,
        breakAt: Optional.none()
      };
    };
    var getAdjacentLinePositions = function (direction, getPositionsUntilBreak, scope, start) {
      return getPositionsUntilBreak(scope, start).breakAt.map(function (pos) {
        var positions = getPositionsUntilBreak(scope, pos).positions;
        return direction === HDirection.Backwards ? positions.concat(pos) : [pos].concat(positions);
      }).getOr([]);
    };
    var findClosestHorizontalPositionFromPoint = function (positions, x) {
      return foldl(positions, function (acc, newPos) {
        return acc.fold(function () {
          return Optional.some(newPos);
        }, function (lastPos) {
          return lift2(head(lastPos.getClientRects()), head(newPos.getClientRects()), function (lastRect, newRect) {
            var lastDist = Math.abs(x - lastRect.left);
            var newDist = Math.abs(x - newRect.left);
            return newDist <= lastDist ? newPos : lastPos;
          }).or(acc);
        });
      }, Optional.none());
    };
    var findClosestHorizontalPosition = function (positions, pos) {
      return head(pos.getClientRects()).bind(function (targetRect) {
        return findClosestHorizontalPositionFromPoint(positions, targetRect.left);
      });
    };
    var getPositionsUntilPreviousLine = curry(getPositionsUntil, CaretPosition.isAbove, -1);
    var getPositionsUntilNextLine = curry(getPositionsUntil, CaretPosition.isBelow, 1);
    var getPositionsAbove = curry(getAdjacentLinePositions, -1, getPositionsUntilPreviousLine);
    var getPositionsBelow = curry(getAdjacentLinePositions, 1, getPositionsUntilNextLine);
    var isAtFirstLine = function (scope, pos) {
      return getPositionsUntilPreviousLine(scope, pos).breakAt.isNone();
    };
    var isAtLastLine = function (scope, pos) {
      return getPositionsUntilNextLine(scope, pos).breakAt.isNone();
    };
    var getFirstLinePositions = function (scope) {
      return firstPositionIn(scope).map(function (pos) {
        return [pos].concat(getPositionsUntilNextLine(scope, pos).positions);
      }).getOr([]);
    };
    var getLastLinePositions = function (scope) {
      return lastPositionIn(scope).map(function (pos) {
        return getPositionsUntilPreviousLine(scope, pos).positions.concat(pos);
      }).getOr([]);
    };

    var getNodeClientRects = function (node) {
      var toArrayWithNode = function (clientRects) {
        return map$3(clientRects, function (rect) {
          var clientRect = clone(rect);
          clientRect.node = node;
          return clientRect;
        });
      };
      if (isElement$5(node)) {
        return toArrayWithNode(node.getClientRects());
      }
      if (isText$7(node)) {
        var rng = node.ownerDocument.createRange();
        rng.setStart(node, 0);
        rng.setEnd(node, node.data.length);
        return toArrayWithNode(rng.getClientRects());
      }
    };
    var getClientRects = function (nodes) {
      return bind(nodes, getNodeClientRects);
    };

    var VDirection;
    (function (VDirection) {
      VDirection[VDirection['Up'] = -1] = 'Up';
      VDirection[VDirection['Down'] = 1] = 'Down';
    }(VDirection || (VDirection = {})));
    var findUntil = function (direction, root, predicateFn, node) {
      while (node = findNode$1(node, direction, isEditableCaretCandidate$1, root)) {
        if (predicateFn(node)) {
          return;
        }
      }
    };
    var walkUntil$1 = function (direction, isAboveFn, isBeflowFn, root, predicateFn, caretPosition) {
      var line = 0;
      var result = [];
      var add = function (node) {
        var clientRects = getClientRects([node]);
        if (direction === -1) {
          clientRects = clientRects.reverse();
        }
        for (var i = 0; i < clientRects.length; i++) {
          var clientRect = clientRects[i];
          if (isBeflowFn(clientRect, targetClientRect)) {
            continue;
          }
          if (result.length > 0 && isAboveFn(clientRect, last$1(result))) {
            line++;
          }
          clientRect.line = line;
          if (predicateFn(clientRect)) {
            return true;
          }
          result.push(clientRect);
        }
      };
      var targetClientRect = last$1(caretPosition.getClientRects());
      if (!targetClientRect) {
        return result;
      }
      var node = caretPosition.getNode();
      add(node);
      findUntil(direction, root, add, node);
      return result;
    };
    var aboveLineNumber = function (lineNumber, clientRect) {
      return clientRect.line > lineNumber;
    };
    var isLineNumber = function (lineNumber, clientRect) {
      return clientRect.line === lineNumber;
    };
    var upUntil = curry(walkUntil$1, VDirection.Up, isAbove$1, isBelow$1);
    var downUntil = curry(walkUntil$1, VDirection.Down, isBelow$1, isAbove$1);
    var positionsUntil = function (direction, root, predicateFn, node) {
      var caretWalker = CaretWalker(root);
      var walkFn;
      var isBelowFn;
      var isAboveFn;
      var caretPosition;
      var result = [];
      var line = 0;
      var getClientRect = function (caretPosition) {
        if (direction === 1) {
          return last$1(caretPosition.getClientRects());
        }
        return last$1(caretPosition.getClientRects());
      };
      if (direction === 1) {
        walkFn = caretWalker.next;
        isBelowFn = isBelow$1;
        isAboveFn = isAbove$1;
        caretPosition = CaretPosition.after(node);
      } else {
        walkFn = caretWalker.prev;
        isBelowFn = isAbove$1;
        isAboveFn = isBelow$1;
        caretPosition = CaretPosition.before(node);
      }
      var targetClientRect = getClientRect(caretPosition);
      do {
        if (!caretPosition.isVisible()) {
          continue;
        }
        var rect = getClientRect(caretPosition);
        if (isAboveFn(rect, targetClientRect)) {
          continue;
        }
        if (result.length > 0 && isBelowFn(rect, last$1(result))) {
          line++;
        }
        var clientRect = clone(rect);
        clientRect.position = caretPosition;
        clientRect.line = line;
        if (predicateFn(clientRect)) {
          return result;
        }
        result.push(clientRect);
      } while (caretPosition = walkFn(caretPosition));
      return result;
    };
    var isAboveLine = function (lineNumber) {
      return function (clientRect) {
        return aboveLineNumber(lineNumber, clientRect);
      };
    };
    var isLine = function (lineNumber) {
      return function (clientRect) {
        return isLineNumber(lineNumber, clientRect);
      };
    };

    var isContentEditableFalse$3 = isContentEditableFalse$b;
    var findNode = findNode$1;
    var distanceToRectLeft = function (clientRect, clientX) {
      return Math.abs(clientRect.left - clientX);
    };
    var distanceToRectRight = function (clientRect, clientX) {
      return Math.abs(clientRect.right - clientX);
    };
    var isInsideX = function (clientX, clientRect) {
      return clientX >= clientRect.left && clientX <= clientRect.right;
    };
    var isInsideY = function (clientY, clientRect) {
      return clientY >= clientRect.top && clientY <= clientRect.bottom;
    };
    var isNodeClientRect = function (rect) {
      return hasNonNullableKey(rect, 'node');
    };
    var findClosestClientRect = function (clientRects, clientX, allowInside) {
      if (allowInside === void 0) {
        allowInside = always;
      }
      return reduce(clientRects, function (oldClientRect, clientRect) {
        if (isInsideX(clientX, clientRect)) {
          return allowInside(clientRect) ? clientRect : oldClientRect;
        }
        if (isInsideX(clientX, oldClientRect)) {
          return allowInside(oldClientRect) ? oldClientRect : clientRect;
        }
        var oldDistance = Math.min(distanceToRectLeft(oldClientRect, clientX), distanceToRectRight(oldClientRect, clientX));
        var newDistance = Math.min(distanceToRectLeft(clientRect, clientX), distanceToRectRight(clientRect, clientX));
        if (newDistance === oldDistance && isNodeClientRect(clientRect) && isContentEditableFalse$3(clientRect.node)) {
          return clientRect;
        }
        if (newDistance < oldDistance) {
          return clientRect;
        }
        return oldClientRect;
      });
    };
    var walkUntil = function (direction, root, predicateFn, startNode, includeChildren) {
      var node = findNode(startNode, direction, isEditableCaretCandidate$1, root, !includeChildren);
      do {
        if (!node || predicateFn(node)) {
          return;
        }
      } while (node = findNode(node, direction, isEditableCaretCandidate$1, root));
    };
    var findLineNodeRects = function (root, targetNodeRect, includeChildren) {
      if (includeChildren === void 0) {
        includeChildren = true;
      }
      var clientRects = [];
      var collect = function (checkPosFn, node) {
        var lineRects = filter$4(getClientRects([node]), function (clientRect) {
          return !checkPosFn(clientRect, targetNodeRect);
        });
        clientRects = clientRects.concat(lineRects);
        return lineRects.length === 0;
      };
      clientRects.push(targetNodeRect);
      walkUntil(VDirection.Up, root, curry(collect, isAbove$1), targetNodeRect.node, includeChildren);
      walkUntil(VDirection.Down, root, curry(collect, isBelow$1), targetNodeRect.node, includeChildren);
      return clientRects;
    };
    var getFakeCaretTargets = function (root) {
      return filter$4(from(root.getElementsByTagName('*')), isFakeCaretTarget);
    };
    var caretInfo = function (clientRect, clientX) {
      return {
        node: clientRect.node,
        before: distanceToRectLeft(clientRect, clientX) < distanceToRectRight(clientRect, clientX)
      };
    };
    var closestFakeCaret = function (root, clientX, clientY) {
      var fakeTargetNodeRects = getClientRects(getFakeCaretTargets(root));
      var targetNodeRects = filter$4(fakeTargetNodeRects, curry(isInsideY, clientY));
      var checkInside = function (clientRect) {
        return !isTable$3(clientRect.node) && !isMedia$2(clientRect.node);
      };
      var closestNodeRect = findClosestClientRect(targetNodeRects, clientX, checkInside);
      if (closestNodeRect) {
        var includeChildren = checkInside(closestNodeRect);
        closestNodeRect = findClosestClientRect(findLineNodeRects(root, closestNodeRect, includeChildren), clientX, checkInside);
        if (closestNodeRect && isFakeCaretTarget(closestNodeRect.node)) {
          return caretInfo(closestNodeRect, clientX);
        }
      }
      return null;
    };

    var moveToRange = function (editor, rng) {
      editor.selection.setRng(rng);
      scrollRangeIntoView(editor, editor.selection.getRng());
    };
    var renderRangeCaretOpt = function (editor, range, scrollIntoView) {
      return Optional.some(renderRangeCaret(editor, range, scrollIntoView));
    };
    var moveHorizontally = function (editor, direction, range, isBefore, isAfter, isElement) {
      var forwards = direction === HDirection.Forwards;
      var caretWalker = CaretWalker(editor.getBody());
      var getNextPosFn = curry(getVisualCaretPosition, forwards ? caretWalker.next : caretWalker.prev);
      var isBeforeFn = forwards ? isBefore : isAfter;
      if (!range.collapsed) {
        var node = getSelectedNode(range);
        if (isElement(node)) {
          return showCaret(direction, editor, node, direction === HDirection.Backwards, false);
        }
      }
      var caretPosition = getNormalizedRangeEndPoint(direction, editor.getBody(), range);
      if (isBeforeFn(caretPosition)) {
        return selectNode(editor, caretPosition.getNode(!forwards));
      }
      var nextCaretPosition = normalizePosition(forwards, getNextPosFn(caretPosition));
      var rangeIsInContainerBlock = isRangeInCaretContainerBlock(range);
      if (!nextCaretPosition) {
        return rangeIsInContainerBlock ? Optional.some(range) : Optional.none();
      }
      if (isBeforeFn(nextCaretPosition)) {
        return showCaret(direction, editor, nextCaretPosition.getNode(!forwards), forwards, false);
      }
      var peekCaretPosition = getNextPosFn(nextCaretPosition);
      if (peekCaretPosition && isBeforeFn(peekCaretPosition)) {
        if (isMoveInsideSameBlock(nextCaretPosition, peekCaretPosition)) {
          return showCaret(direction, editor, peekCaretPosition.getNode(!forwards), forwards, false);
        }
      }
      if (rangeIsInContainerBlock) {
        return renderRangeCaretOpt(editor, nextCaretPosition.toRange(), false);
      }
      return Optional.none();
    };
    var moveVertically = function (editor, direction, range, isBefore, isAfter, isElement) {
      var caretPosition = getNormalizedRangeEndPoint(direction, editor.getBody(), range);
      var caretClientRect = last$1(caretPosition.getClientRects());
      var forwards = direction === VDirection.Down;
      if (!caretClientRect) {
        return Optional.none();
      }
      var walkerFn = forwards ? downUntil : upUntil;
      var linePositions = walkerFn(editor.getBody(), isAboveLine(1), caretPosition);
      var nextLinePositions = filter$4(linePositions, isLine(1));
      var clientX = caretClientRect.left;
      var nextLineRect = findClosestClientRect(nextLinePositions, clientX);
      if (nextLineRect && isElement(nextLineRect.node)) {
        var dist1 = Math.abs(clientX - nextLineRect.left);
        var dist2 = Math.abs(clientX - nextLineRect.right);
        return showCaret(direction, editor, nextLineRect.node, dist1 < dist2, false);
      }
      var currentNode;
      if (isBefore(caretPosition)) {
        currentNode = caretPosition.getNode();
      } else if (isAfter(caretPosition)) {
        currentNode = caretPosition.getNode(true);
      } else {
        currentNode = getSelectedNode(range);
      }
      if (currentNode) {
        var caretPositions = positionsUntil(direction, editor.getBody(), isAboveLine(1), currentNode);
        var closestNextLineRect = findClosestClientRect(filter$4(caretPositions, isLine(1)), clientX);
        if (closestNextLineRect) {
          return renderRangeCaretOpt(editor, closestNextLineRect.position.toRange(), false);
        }
        closestNextLineRect = last$1(filter$4(caretPositions, isLine(0)));
        if (closestNextLineRect) {
          return renderRangeCaretOpt(editor, closestNextLineRect.position.toRange(), false);
        }
      }
      if (nextLinePositions.length === 0) {
        return getLineEndPoint(editor, forwards).filter(forwards ? isAfter : isBefore).map(function (pos) {
          return renderRangeCaret(editor, pos.toRange(), false);
        });
      }
      return Optional.none();
    };
    var getLineEndPoint = function (editor, forward) {
      var rng = editor.selection.getRng();
      var body = editor.getBody();
      if (forward) {
        var from = CaretPosition.fromRangeEnd(rng);
        var result = getPositionsUntilNextLine(body, from);
        return last$2(result.positions);
      } else {
        var from = CaretPosition.fromRangeStart(rng);
        var result = getPositionsUntilPreviousLine(body, from);
        return head(result.positions);
      }
    };
    var moveToLineEndPoint$3 = function (editor, forward, isElementPosition) {
      return getLineEndPoint(editor, forward).filter(isElementPosition).exists(function (pos) {
        editor.selection.setRng(pos.toRange());
        return true;
      });
    };

    var setCaretPosition = function (editor, pos) {
      var rng = editor.dom.createRng();
      rng.setStart(pos.container(), pos.offset());
      rng.setEnd(pos.container(), pos.offset());
      editor.selection.setRng(rng);
    };
    var setSelected = function (state, elm) {
      if (state) {
        elm.setAttribute('data-mce-selected', 'inline-boundary');
      } else {
        elm.removeAttribute('data-mce-selected');
      }
    };
    var renderCaretLocation = function (editor, caret, location) {
      return renderCaret(caret, location).map(function (pos) {
        setCaretPosition(editor, pos);
        return location;
      });
    };
    var findLocation = function (editor, caret, forward) {
      var rootNode = editor.getBody();
      var from = CaretPosition.fromRangeStart(editor.selection.getRng());
      var isInlineTarget$1 = curry(isInlineTarget, editor);
      var location = findLocation$1(forward, isInlineTarget$1, rootNode, from);
      return location.bind(function (location) {
        return renderCaretLocation(editor, caret, location);
      });
    };
    var toggleInlines = function (isInlineTarget, dom, elms) {
      var inlineBoundaries = map$3(descendants(SugarElement.fromDom(dom.getRoot()), '*[data-mce-selected="inline-boundary"]'), function (e) {
        return e.dom;
      });
      var selectedInlines = filter$4(inlineBoundaries, isInlineTarget);
      var targetInlines = filter$4(elms, isInlineTarget);
      each$k(difference(selectedInlines, targetInlines), curry(setSelected, false));
      each$k(difference(targetInlines, selectedInlines), curry(setSelected, true));
    };
    var safeRemoveCaretContainer = function (editor, caret) {
      if (editor.selection.isCollapsed() && editor.composing !== true && caret.get()) {
        var pos = CaretPosition.fromRangeStart(editor.selection.getRng());
        if (CaretPosition.isTextPosition(pos) && isAtZwsp(pos) === false) {
          setCaretPosition(editor, removeAndReposition(caret.get(), pos));
          caret.set(null);
        }
      }
    };
    var renderInsideInlineCaret = function (isInlineTarget, editor, caret, elms) {
      if (editor.selection.isCollapsed()) {
        var inlines = filter$4(elms, isInlineTarget);
        each$k(inlines, function (_inline) {
          var pos = CaretPosition.fromRangeStart(editor.selection.getRng());
          readLocation(isInlineTarget, editor.getBody(), pos).bind(function (location) {
            return renderCaretLocation(editor, caret, location);
          });
        });
      }
    };
    var move$2 = function (editor, caret, forward) {
      return isInlineBoundariesEnabled(editor) ? findLocation(editor, caret, forward).isSome() : false;
    };
    var moveWord = function (forward, editor, _caret) {
      return isInlineBoundariesEnabled(editor) ? moveByWord(forward, editor) : false;
    };
    var setupSelectedState = function (editor) {
      var caret = Cell(null);
      var isInlineTarget$1 = curry(isInlineTarget, editor);
      editor.on('NodeChange', function (e) {
        if (isInlineBoundariesEnabled(editor) && !(Env.browser.isIE() && e.initial)) {
          toggleInlines(isInlineTarget$1, editor.dom, e.parents);
          safeRemoveCaretContainer(editor, caret);
          renderInsideInlineCaret(isInlineTarget$1, editor, caret, e.parents);
        }
      });
      return caret;
    };
    var moveNextWord = curry(moveWord, true);
    var movePrevWord = curry(moveWord, false);
    var moveToLineEndPoint$2 = function (editor, forward, caret) {
      if (isInlineBoundariesEnabled(editor)) {
        var linePoint = getLineEndPoint(editor, forward).getOrThunk(function () {
          var rng = editor.selection.getRng();
          return forward ? CaretPosition.fromRangeEnd(rng) : CaretPosition.fromRangeStart(rng);
        });
        return readLocation(curry(isInlineTarget, editor), editor.getBody(), linePoint).exists(function (loc) {
          var outsideLoc = outside(loc);
          return renderCaret(caret, outsideLoc).exists(function (pos) {
            setCaretPosition(editor, pos);
            return true;
          });
        });
      } else {
        return false;
      }
    };

    var rangeFromPositions = function (from, to) {
      var range = document.createRange();
      range.setStart(from.container(), from.offset());
      range.setEnd(to.container(), to.offset());
      return range;
    };
    var hasOnlyTwoOrLessPositionsLeft = function (elm) {
      return lift2(firstPositionIn(elm), lastPositionIn(elm), function (firstPos, lastPos) {
        var normalizedFirstPos = normalizePosition(true, firstPos);
        var normalizedLastPos = normalizePosition(false, lastPos);
        return nextPosition(elm, normalizedFirstPos).forall(function (pos) {
          return pos.isEqual(normalizedLastPos);
        });
      }).getOr(true);
    };
    var setCaretLocation = function (editor, caret) {
      return function (location) {
        return renderCaret(caret, location).exists(function (pos) {
          setCaretPosition(editor, pos);
          return true;
        });
      };
    };
    var deleteFromTo = function (editor, caret, from, to) {
      var rootNode = editor.getBody();
      var isInlineTarget$1 = curry(isInlineTarget, editor);
      editor.undoManager.ignore(function () {
        editor.selection.setRng(rangeFromPositions(from, to));
        editor.execCommand('Delete');
        readLocation(isInlineTarget$1, rootNode, CaretPosition.fromRangeStart(editor.selection.getRng())).map(inside).map(setCaretLocation(editor, caret));
      });
      editor.nodeChanged();
    };
    var rescope = function (rootNode, node) {
      var parentBlock = getParentBlock$2(node, rootNode);
      return parentBlock ? parentBlock : rootNode;
    };
    var backspaceDeleteCollapsed = function (editor, caret, forward, from) {
      var rootNode = rescope(editor.getBody(), from.container());
      var isInlineTarget$1 = curry(isInlineTarget, editor);
      var fromLocation = readLocation(isInlineTarget$1, rootNode, from);
      return fromLocation.bind(function (location) {
        if (forward) {
          return location.fold(constant(Optional.some(inside(location))), Optional.none, constant(Optional.some(outside(location))), Optional.none);
        } else {
          return location.fold(Optional.none, constant(Optional.some(outside(location))), Optional.none, constant(Optional.some(inside(location))));
        }
      }).map(setCaretLocation(editor, caret)).getOrThunk(function () {
        var toPosition = navigate(forward, rootNode, from);
        var toLocation = toPosition.bind(function (pos) {
          return readLocation(isInlineTarget$1, rootNode, pos);
        });
        return lift2(fromLocation, toLocation, function () {
          return findRootInline(isInlineTarget$1, rootNode, from).exists(function (elm) {
            if (hasOnlyTwoOrLessPositionsLeft(elm)) {
              deleteElement$2(editor, forward, SugarElement.fromDom(elm));
              return true;
            } else {
              return false;
            }
          });
        }).orThunk(function () {
          return toLocation.bind(function (_) {
            return toPosition.map(function (to) {
              if (forward) {
                deleteFromTo(editor, caret, from, to);
              } else {
                deleteFromTo(editor, caret, to, from);
              }
              return true;
            });
          });
        }).getOr(false);
      });
    };
    var backspaceDelete$3 = function (editor, caret, forward) {
      if (editor.selection.isCollapsed() && isInlineBoundariesEnabled(editor)) {
        var from = CaretPosition.fromRangeStart(editor.selection.getRng());
        return backspaceDeleteCollapsed(editor, caret, forward, from);
      }
      return false;
    };

    var getParentInlines = function (rootElm, startElm) {
      var parents = parentsAndSelf(startElm, rootElm);
      return findIndex$2(parents, isBlock$2).fold(constant(parents), function (index) {
        return parents.slice(0, index);
      });
    };
    var hasOnlyOneChild = function (elm) {
      return childNodesCount(elm) === 1;
    };
    var deleteLastPosition = function (forward, editor, target, parentInlines) {
      var isFormatElement$1 = curry(isFormatElement, editor);
      var formatNodes = map$3(filter$4(parentInlines, isFormatElement$1), function (elm) {
        return elm.dom;
      });
      if (formatNodes.length === 0) {
        deleteElement$2(editor, forward, target);
      } else {
        var pos = replaceWithCaretFormat(target.dom, formatNodes);
        editor.selection.setRng(pos.toRange());
      }
    };
    var deleteCaret$1 = function (editor, forward) {
      var rootElm = SugarElement.fromDom(editor.getBody());
      var startElm = SugarElement.fromDom(editor.selection.getStart());
      var parentInlines = filter$4(getParentInlines(rootElm, startElm), hasOnlyOneChild);
      return last$2(parentInlines).exists(function (target) {
        var fromPos = CaretPosition.fromRangeStart(editor.selection.getRng());
        if (willDeleteLastPositionInElement(forward, fromPos, target.dom) && !isEmptyCaretFormatElement(target)) {
          deleteLastPosition(forward, editor, target, parentInlines);
          return true;
        } else {
          return false;
        }
      });
    };
    var backspaceDelete$2 = function (editor, forward) {
      return editor.selection.isCollapsed() ? deleteCaret$1(editor, forward) : false;
    };

    var deleteElement = function (editor, forward, element) {
      editor._selectionOverrides.hideFakeCaret();
      deleteElement$2(editor, forward, SugarElement.fromDom(element));
      return true;
    };
    var deleteCaret = function (editor, forward) {
      var isNearMedia = forward ? isBeforeMedia : isAfterMedia;
      var direction = forward ? HDirection.Forwards : HDirection.Backwards;
      var fromPos = getNormalizedRangeEndPoint(direction, editor.getBody(), editor.selection.getRng());
      if (isNearMedia(fromPos)) {
        return deleteElement(editor, forward, fromPos.getNode(!forward));
      } else {
        return Optional.from(normalizePosition(forward, fromPos)).filter(function (pos) {
          return isNearMedia(pos) && isMoveInsideSameBlock(fromPos, pos);
        }).exists(function (pos) {
          return deleteElement(editor, forward, pos.getNode(!forward));
        });
      }
    };
    var deleteRange = function (editor, forward) {
      var selectedNode = editor.selection.getNode();
      return isMedia$2(selectedNode) ? deleteElement(editor, forward, selectedNode) : false;
    };
    var backspaceDelete$1 = function (editor, forward) {
      return editor.selection.isCollapsed() ? deleteCaret(editor, forward) : deleteRange(editor, forward);
    };

    var isEditable = function (target) {
      return closest$3(target, function (elm) {
        return isContentEditableTrue$4(elm.dom) || isContentEditableFalse$b(elm.dom);
      }).exists(function (elm) {
        return isContentEditableTrue$4(elm.dom);
      });
    };
    var parseIndentValue = function (value) {
      var number = parseInt(value, 10);
      return isNaN(number) ? 0 : number;
    };
    var getIndentStyleName = function (useMargin, element) {
      var indentStyleName = useMargin || isTable$2(element) ? 'margin' : 'padding';
      var suffix = get$5(element, 'direction') === 'rtl' ? '-right' : '-left';
      return indentStyleName + suffix;
    };
    var indentElement = function (dom, command, useMargin, value, unit, element) {
      var indentStyleName = getIndentStyleName(useMargin, SugarElement.fromDom(element));
      if (command === 'outdent') {
        var styleValue = Math.max(0, parseIndentValue(element.style[indentStyleName]) - value);
        dom.setStyle(element, indentStyleName, styleValue ? styleValue + unit : '');
      } else {
        var styleValue = parseIndentValue(element.style[indentStyleName]) + value + unit;
        dom.setStyle(element, indentStyleName, styleValue);
      }
    };
    var validateBlocks = function (editor, blocks) {
      return forall(blocks, function (block) {
        var indentStyleName = getIndentStyleName(shouldIndentUseMargin(editor), block);
        var intentValue = getRaw(block, indentStyleName).map(parseIndentValue).getOr(0);
        var contentEditable = editor.dom.getContentEditable(block.dom);
        return contentEditable !== 'false' && intentValue > 0;
      });
    };
    var canOutdent = function (editor) {
      var blocks = getBlocksToIndent(editor);
      return !editor.mode.isReadOnly() && (blocks.length > 1 || validateBlocks(editor, blocks));
    };
    var isListComponent = function (el) {
      return isList(el) || isListItem(el);
    };
    var parentIsListComponent = function (el) {
      return parent(el).exists(isListComponent);
    };
    var getBlocksToIndent = function (editor) {
      return filter$4(fromDom$1(editor.selection.getSelectedBlocks()), function (el) {
        return !isListComponent(el) && !parentIsListComponent(el) && isEditable(el);
      });
    };
    var handle = function (editor, command) {
      var dom = editor.dom, selection = editor.selection, formatter = editor.formatter;
      var indentation = getIndentation(editor);
      var indentUnit = /[a-z%]+$/i.exec(indentation)[0];
      var indentValue = parseInt(indentation, 10);
      var useMargin = shouldIndentUseMargin(editor);
      var forcedRootBlock = getForcedRootBlock(editor);
      if (!editor.queryCommandState('InsertUnorderedList') && !editor.queryCommandState('InsertOrderedList')) {
        if (forcedRootBlock === '' && !dom.getParent(selection.getNode(), dom.isBlock)) {
          formatter.apply('div');
        }
      }
      each$k(getBlocksToIndent(editor), function (block) {
        indentElement(dom, command, useMargin, indentValue, indentUnit, block.dom);
      });
    };

    var backspaceDelete = function (editor, _forward) {
      if (editor.selection.isCollapsed() && canOutdent(editor)) {
        var dom = editor.dom;
        var rng = editor.selection.getRng();
        var pos = CaretPosition.fromRangeStart(rng);
        var block = dom.getParent(rng.startContainer, dom.isBlock);
        if (block !== null && isAtStartOfBlock(SugarElement.fromDom(block), pos)) {
          handle(editor, 'outdent');
          return true;
        }
      }
      return false;
    };

    var nativeCommand = function (editor, command) {
      editor.getDoc().execCommand(command, false, null);
    };
    var deleteCommand = function (editor, caret) {
      if (backspaceDelete(editor)) {
        return;
      } else if (backspaceDelete$5(editor, false)) {
        return;
      } else if (backspaceDelete$6(editor, false)) {
        return;
      } else if (backspaceDelete$3(editor, caret, false)) {
        return;
      } else if (backspaceDelete$8(editor, false)) {
        return;
      } else if (backspaceDelete$9(editor)) {
        return;
      } else if (backspaceDelete$4(editor, false)) {
        return;
      } else if (backspaceDelete$1(editor, false)) {
        return;
      } else if (backspaceDelete$7(editor)) {
        return;
      } else if (backspaceDelete$2(editor, false)) {
        return;
      } else {
        nativeCommand(editor, 'Delete');
        paddEmptyBody(editor);
      }
    };
    var forwardDeleteCommand = function (editor, caret) {
      if (backspaceDelete$5(editor, true)) {
        return;
      } else if (backspaceDelete$6(editor, true)) {
        return;
      } else if (backspaceDelete$3(editor, caret, true)) {
        return;
      } else if (backspaceDelete$8(editor, true)) {
        return;
      } else if (backspaceDelete$9(editor)) {
        return;
      } else if (backspaceDelete$4(editor, true)) {
        return;
      } else if (backspaceDelete$1(editor, true)) {
        return;
      } else if (backspaceDelete$7(editor)) {
        return;
      } else if (backspaceDelete$2(editor, true)) {
        return;
      } else {
        nativeCommand(editor, 'ForwardDelete');
      }
    };
    var setup$f = function (editor, caret) {
      editor.addCommand('delete', function () {
        deleteCommand(editor, caret);
      });
      editor.addCommand('forwardDelete', function () {
        forwardDeleteCommand(editor, caret);
      });
    };

    var SIGNIFICANT_MOVE = 5;
    var LONGPRESS_DELAY = 400;
    var getTouch = function (event) {
      if (event.touches === undefined || event.touches.length !== 1) {
        return Optional.none();
      }
      return Optional.some(event.touches[0]);
    };
    var isFarEnough = function (touch, data) {
      var distX = Math.abs(touch.clientX - data.x);
      var distY = Math.abs(touch.clientY - data.y);
      return distX > SIGNIFICANT_MOVE || distY > SIGNIFICANT_MOVE;
    };
    var setup$e = function (editor) {
      var startData = value();
      var longpressFired = Cell(false);
      var debounceLongpress = last(function (e) {
        editor.fire('longpress', __assign(__assign({}, e), { type: 'longpress' }));
        longpressFired.set(true);
      }, LONGPRESS_DELAY);
      editor.on('touchstart', function (e) {
        getTouch(e).each(function (touch) {
          debounceLongpress.cancel();
          var data = {
            x: touch.clientX,
            y: touch.clientY,
            target: e.target
          };
          debounceLongpress.throttle(e);
          longpressFired.set(false);
          startData.set(data);
        });
      }, true);
      editor.on('touchmove', function (e) {
        debounceLongpress.cancel();
        getTouch(e).each(function (touch) {
          startData.on(function (data) {
            if (isFarEnough(touch, data)) {
              startData.clear();
              longpressFired.set(false);
              editor.fire('longpresscancel');
            }
          });
        });
      }, true);
      editor.on('touchend touchcancel', function (e) {
        debounceLongpress.cancel();
        if (e.type === 'touchcancel') {
          return;
        }
        startData.get().filter(function (data) {
          return data.target.isEqualNode(e.target);
        }).each(function () {
          if (longpressFired.get()) {
            e.preventDefault();
          } else {
            editor.fire('tap', __assign(__assign({}, e), { type: 'tap' }));
          }
        });
      }, true);
    };

    var isBlockElement = function (blockElements, node) {
      return has$2(blockElements, node.nodeName);
    };
    var isValidTarget = function (blockElements, node) {
      if (isText$7(node)) {
        return true;
      } else if (isElement$5(node)) {
        return !isBlockElement(blockElements, node) && !isBookmarkNode$1(node);
      } else {
        return false;
      }
    };
    var hasBlockParent = function (blockElements, root, node) {
      return exists(parents(SugarElement.fromDom(node), SugarElement.fromDom(root)), function (elm) {
        return isBlockElement(blockElements, elm.dom);
      });
    };
    var shouldRemoveTextNode = function (blockElements, node) {
      if (isText$7(node)) {
        if (node.nodeValue.length === 0) {
          return true;
        } else if (/^\s+$/.test(node.nodeValue) && (!node.nextSibling || isBlockElement(blockElements, node.nextSibling))) {
          return true;
        }
      }
      return false;
    };
    var addRootBlocks = function (editor) {
      var dom = editor.dom, selection = editor.selection;
      var schema = editor.schema, blockElements = schema.getBlockElements();
      var node = selection.getStart();
      var rootNode = editor.getBody();
      var rootBlockNode, tempNode, wrapped;
      var forcedRootBlock = getForcedRootBlock(editor);
      if (!node || !isElement$5(node) || !forcedRootBlock) {
        return;
      }
      var rootNodeName = rootNode.nodeName.toLowerCase();
      if (!schema.isValidChild(rootNodeName, forcedRootBlock.toLowerCase()) || hasBlockParent(blockElements, rootNode, node)) {
        return;
      }
      var rng = selection.getRng();
      var startContainer = rng.startContainer;
      var startOffset = rng.startOffset;
      var endContainer = rng.endContainer;
      var endOffset = rng.endOffset;
      var restoreSelection = hasFocus(editor);
      node = rootNode.firstChild;
      while (node) {
        if (isValidTarget(blockElements, node)) {
          if (shouldRemoveTextNode(blockElements, node)) {
            tempNode = node;
            node = node.nextSibling;
            dom.remove(tempNode);
            continue;
          }
          if (!rootBlockNode) {
            rootBlockNode = dom.create(forcedRootBlock, getForcedRootBlockAttrs(editor));
            node.parentNode.insertBefore(rootBlockNode, node);
            wrapped = true;
          }
          tempNode = node;
          node = node.nextSibling;
          rootBlockNode.appendChild(tempNode);
        } else {
          rootBlockNode = null;
          node = node.nextSibling;
        }
      }
      if (wrapped && restoreSelection) {
        rng.setStart(startContainer, startOffset);
        rng.setEnd(endContainer, endOffset);
        selection.setRng(rng);
        editor.nodeChanged();
      }
    };
    var setup$d = function (editor) {
      if (getForcedRootBlock(editor)) {
        editor.on('NodeChange', curry(addRootBlocks, editor));
      }
    };

    var findBlockCaretContainer = function (editor) {
      return descendant(SugarElement.fromDom(editor.getBody()), '*[data-mce-caret]').map(function (elm) {
        return elm.dom;
      }).getOrNull();
    };
    var removeIeControlRect = function (editor) {
      editor.selection.setRng(editor.selection.getRng());
    };
    var showBlockCaretContainer = function (editor, blockCaretContainer) {
      if (blockCaretContainer.hasAttribute('data-mce-caret')) {
        showCaretContainerBlock(blockCaretContainer);
        removeIeControlRect(editor);
        editor.selection.scrollIntoView(blockCaretContainer);
      }
    };
    var handleBlockContainer = function (editor, e) {
      var blockCaretContainer = findBlockCaretContainer(editor);
      if (!blockCaretContainer) {
        return;
      }
      if (e.type === 'compositionstart') {
        e.preventDefault();
        e.stopPropagation();
        showBlockCaretContainer(editor, blockCaretContainer);
        return;
      }
      if (hasContent(blockCaretContainer)) {
        showBlockCaretContainer(editor, blockCaretContainer);
        editor.undoManager.add();
      }
    };
    var setup$c = function (editor) {
      editor.on('keyup compositionstart', curry(handleBlockContainer, editor));
    };

    var isContentEditableFalse$2 = isContentEditableFalse$b;
    var moveToCeFalseHorizontally = function (direction, editor, range) {
      return moveHorizontally(editor, direction, range, isBeforeContentEditableFalse, isAfterContentEditableFalse, isContentEditableFalse$2);
    };
    var moveToCeFalseVertically = function (direction, editor, range) {
      var isBefore = function (caretPosition) {
        return isBeforeContentEditableFalse(caretPosition) || isBeforeTable(caretPosition);
      };
      var isAfter = function (caretPosition) {
        return isAfterContentEditableFalse(caretPosition) || isAfterTable(caretPosition);
      };
      return moveVertically(editor, direction, range, isBefore, isAfter, isContentEditableFalse$2);
    };
    var createTextBlock = function (editor) {
      var textBlock = editor.dom.create(getForcedRootBlock(editor));
      if (!Env.ie || Env.ie >= 11) {
        textBlock.innerHTML = '<br data-mce-bogus="1">';
      }
      return textBlock;
    };
    var exitPreBlock = function (editor, direction, range) {
      var caretWalker = CaretWalker(editor.getBody());
      var getVisualCaretPosition$1 = curry(getVisualCaretPosition, direction === 1 ? caretWalker.next : caretWalker.prev);
      if (range.collapsed && hasForcedRootBlock(editor)) {
        var pre = editor.dom.getParent(range.startContainer, 'PRE');
        if (!pre) {
          return;
        }
        var caretPos = getVisualCaretPosition$1(CaretPosition.fromRangeStart(range));
        if (!caretPos) {
          var newBlock = createTextBlock(editor);
          if (direction === 1) {
            editor.$(pre).after(newBlock);
          } else {
            editor.$(pre).before(newBlock);
          }
          editor.selection.select(newBlock, true);
          editor.selection.collapse();
        }
      }
    };
    var getHorizontalRange = function (editor, forward) {
      var direction = forward ? HDirection.Forwards : HDirection.Backwards;
      var range = editor.selection.getRng();
      return moveToCeFalseHorizontally(direction, editor, range).orThunk(function () {
        exitPreBlock(editor, direction, range);
        return Optional.none();
      });
    };
    var getVerticalRange = function (editor, down) {
      var direction = down ? 1 : -1;
      var range = editor.selection.getRng();
      return moveToCeFalseVertically(direction, editor, range).orThunk(function () {
        exitPreBlock(editor, direction, range);
        return Optional.none();
      });
    };
    var moveH$2 = function (editor, forward) {
      return getHorizontalRange(editor, forward).exists(function (newRange) {
        moveToRange(editor, newRange);
        return true;
      });
    };
    var moveV$3 = function (editor, down) {
      return getVerticalRange(editor, down).exists(function (newRange) {
        moveToRange(editor, newRange);
        return true;
      });
    };
    var moveToLineEndPoint$1 = function (editor, forward) {
      var isCefPosition = forward ? isAfterContentEditableFalse : isBeforeContentEditableFalse;
      return moveToLineEndPoint$3(editor, forward, isCefPosition);
    };

    var isTarget = function (node) {
      return contains$3(['figcaption'], name(node));
    };
    var rangeBefore = function (target) {
      var rng = document.createRange();
      rng.setStartBefore(target.dom);
      rng.setEndBefore(target.dom);
      return rng;
    };
    var insertElement = function (root, elm, forward) {
      if (forward) {
        append$1(root, elm);
      } else {
        prepend(root, elm);
      }
    };
    var insertBr = function (root, forward) {
      var br = SugarElement.fromTag('br');
      insertElement(root, br, forward);
      return rangeBefore(br);
    };
    var insertBlock = function (root, forward, blockName, attrs) {
      var block = SugarElement.fromTag(blockName);
      var br = SugarElement.fromTag('br');
      setAll$1(block, attrs);
      append$1(block, br);
      insertElement(root, block, forward);
      return rangeBefore(br);
    };
    var insertEmptyLine = function (root, rootBlockName, attrs, forward) {
      if (rootBlockName === '') {
        return insertBr(root, forward);
      } else {
        return insertBlock(root, forward, rootBlockName, attrs);
      }
    };
    var getClosestTargetBlock = function (pos, root) {
      var isRoot = curry(eq, root);
      return closest$3(SugarElement.fromDom(pos.container()), isBlock$2, isRoot).filter(isTarget);
    };
    var isAtFirstOrLastLine = function (root, forward, pos) {
      return forward ? isAtLastLine(root.dom, pos) : isAtFirstLine(root.dom, pos);
    };
    var moveCaretToNewEmptyLine = function (editor, forward) {
      var root = SugarElement.fromDom(editor.getBody());
      var pos = CaretPosition.fromRangeStart(editor.selection.getRng());
      var rootBlock = getForcedRootBlock(editor);
      var rootBlockAttrs = getForcedRootBlockAttrs(editor);
      return getClosestTargetBlock(pos, root).exists(function () {
        if (isAtFirstOrLastLine(root, forward, pos)) {
          var rng = insertEmptyLine(root, rootBlock, rootBlockAttrs, forward);
          editor.selection.setRng(rng);
          return true;
        } else {
          return false;
        }
      });
    };
    var moveV$2 = function (editor, forward) {
      if (editor.selection.isCollapsed()) {
        return moveCaretToNewEmptyLine(editor, forward);
      } else {
        return false;
      }
    };

    var defaultPatterns = function (patterns) {
      return map$3(patterns, function (pattern) {
        return __assign({
          shiftKey: false,
          altKey: false,
          ctrlKey: false,
          metaKey: false,
          keyCode: 0,
          action: noop
        }, pattern);
      });
    };
    var matchesEvent = function (pattern, evt) {
      return evt.keyCode === pattern.keyCode && evt.shiftKey === pattern.shiftKey && evt.altKey === pattern.altKey && evt.ctrlKey === pattern.ctrlKey && evt.metaKey === pattern.metaKey;
    };
    var match$1 = function (patterns, evt) {
      return bind(defaultPatterns(patterns), function (pattern) {
        return matchesEvent(pattern, evt) ? [pattern] : [];
      });
    };
    var action = function (f) {
      var x = [];
      for (var _i = 1; _i < arguments.length; _i++) {
        x[_i - 1] = arguments[_i];
      }
      return function () {
        return f.apply(null, x);
      };
    };
    var execute = function (patterns, evt) {
      return find$3(match$1(patterns, evt), function (pattern) {
        return pattern.action();
      });
    };

    var moveH$1 = function (editor, forward) {
      var direction = forward ? HDirection.Forwards : HDirection.Backwards;
      var range = editor.selection.getRng();
      return moveHorizontally(editor, direction, range, isBeforeMedia, isAfterMedia, isMedia$2).exists(function (newRange) {
        moveToRange(editor, newRange);
        return true;
      });
    };
    var moveV$1 = function (editor, down) {
      var direction = down ? 1 : -1;
      var range = editor.selection.getRng();
      return moveVertically(editor, direction, range, isBeforeMedia, isAfterMedia, isMedia$2).exists(function (newRange) {
        moveToRange(editor, newRange);
        return true;
      });
    };
    var moveToLineEndPoint = function (editor, forward) {
      var isNearMedia = forward ? isAfterMedia : isBeforeMedia;
      return moveToLineEndPoint$3(editor, forward, isNearMedia);
    };

    var deflate = function (rect, delta) {
      return {
        left: rect.left - delta,
        top: rect.top - delta,
        right: rect.right + delta * 2,
        bottom: rect.bottom + delta * 2,
        width: rect.width + delta,
        height: rect.height + delta
      };
    };
    var getCorners = function (getYAxisValue, tds) {
      return bind(tds, function (td) {
        var rect = deflate(clone(td.getBoundingClientRect()), -1);
        return [
          {
            x: rect.left,
            y: getYAxisValue(rect),
            cell: td
          },
          {
            x: rect.right,
            y: getYAxisValue(rect),
            cell: td
          }
        ];
      });
    };
    var findClosestCorner = function (corners, x, y) {
      return foldl(corners, function (acc, newCorner) {
        return acc.fold(function () {
          return Optional.some(newCorner);
        }, function (oldCorner) {
          var oldDist = Math.sqrt(Math.abs(oldCorner.x - x) + Math.abs(oldCorner.y - y));
          var newDist = Math.sqrt(Math.abs(newCorner.x - x) + Math.abs(newCorner.y - y));
          return Optional.some(newDist < oldDist ? newCorner : oldCorner);
        });
      }, Optional.none());
    };
    var getClosestCell = function (getYAxisValue, isTargetCorner, table, x, y) {
      var cells = descendants(SugarElement.fromDom(table), 'td,th,caption').map(function (e) {
        return e.dom;
      });
      var corners = filter$4(getCorners(getYAxisValue, cells), function (corner) {
        return isTargetCorner(corner, y);
      });
      return findClosestCorner(corners, x, y).map(function (corner) {
        return corner.cell;
      });
    };
    var getBottomValue = function (rect) {
      return rect.bottom;
    };
    var getTopValue = function (rect) {
      return rect.top;
    };
    var isAbove = function (corner, y) {
      return corner.y < y;
    };
    var isBelow = function (corner, y) {
      return corner.y > y;
    };
    var getClosestCellAbove = curry(getClosestCell, getBottomValue, isAbove);
    var getClosestCellBelow = curry(getClosestCell, getTopValue, isBelow);
    var findClosestPositionInAboveCell = function (table, pos) {
      return head(pos.getClientRects()).bind(function (rect) {
        return getClosestCellAbove(table, rect.left, rect.top);
      }).bind(function (cell) {
        return findClosestHorizontalPosition(getLastLinePositions(cell), pos);
      });
    };
    var findClosestPositionInBelowCell = function (table, pos) {
      return last$2(pos.getClientRects()).bind(function (rect) {
        return getClosestCellBelow(table, rect.left, rect.top);
      }).bind(function (cell) {
        return findClosestHorizontalPosition(getFirstLinePositions(cell), pos);
      });
    };

    var hasNextBreak = function (getPositionsUntil, scope, lineInfo) {
      return lineInfo.breakAt.exists(function (breakPos) {
        return getPositionsUntil(scope, breakPos).breakAt.isSome();
      });
    };
    var startsWithWrapBreak = function (lineInfo) {
      return lineInfo.breakType === BreakType.Wrap && lineInfo.positions.length === 0;
    };
    var startsWithBrBreak = function (lineInfo) {
      return lineInfo.breakType === BreakType.Br && lineInfo.positions.length === 1;
    };
    var isAtTableCellLine = function (getPositionsUntil, scope, pos) {
      var lineInfo = getPositionsUntil(scope, pos);
      if (startsWithWrapBreak(lineInfo) || !isBr$5(pos.getNode()) && startsWithBrBreak(lineInfo)) {
        return !hasNextBreak(getPositionsUntil, scope, lineInfo);
      } else {
        return lineInfo.breakAt.isNone();
      }
    };
    var isAtFirstTableCellLine = curry(isAtTableCellLine, getPositionsUntilPreviousLine);
    var isAtLastTableCellLine = curry(isAtTableCellLine, getPositionsUntilNextLine);
    var isCaretAtStartOrEndOfTable = function (forward, rng, table) {
      var caretPos = CaretPosition.fromRangeStart(rng);
      return positionIn(!forward, table).exists(function (pos) {
        return pos.isEqual(caretPos);
      });
    };
    var navigateHorizontally = function (editor, forward, table, _td) {
      var rng = editor.selection.getRng();
      var direction = forward ? 1 : -1;
      if (isFakeCaretTableBrowser() && isCaretAtStartOrEndOfTable(forward, rng, table)) {
        showCaret(direction, editor, table, !forward, false).each(function (newRng) {
          moveToRange(editor, newRng);
        });
        return true;
      }
      return false;
    };
    var getClosestAbovePosition = function (root, table, start) {
      return findClosestPositionInAboveCell(table, start).orThunk(function () {
        return head(start.getClientRects()).bind(function (rect) {
          return findClosestHorizontalPositionFromPoint(getPositionsAbove(root, CaretPosition.before(table)), rect.left);
        });
      }).getOr(CaretPosition.before(table));
    };
    var getClosestBelowPosition = function (root, table, start) {
      return findClosestPositionInBelowCell(table, start).orThunk(function () {
        return head(start.getClientRects()).bind(function (rect) {
          return findClosestHorizontalPositionFromPoint(getPositionsBelow(root, CaretPosition.after(table)), rect.left);
        });
      }).getOr(CaretPosition.after(table));
    };
    var getTable = function (previous, pos) {
      var node = pos.getNode(previous);
      return isElement$5(node) && node.nodeName === 'TABLE' ? Optional.some(node) : Optional.none();
    };
    var renderBlock = function (down, editor, table, pos) {
      var forcedRootBlock = getForcedRootBlock(editor);
      if (forcedRootBlock) {
        editor.undoManager.transact(function () {
          var element = SugarElement.fromTag(forcedRootBlock);
          setAll$1(element, getForcedRootBlockAttrs(editor));
          append$1(element, SugarElement.fromTag('br'));
          if (down) {
            after$3(SugarElement.fromDom(table), element);
          } else {
            before$4(SugarElement.fromDom(table), element);
          }
          var rng = editor.dom.createRng();
          rng.setStart(element.dom, 0);
          rng.setEnd(element.dom, 0);
          moveToRange(editor, rng);
        });
      } else {
        moveToRange(editor, pos.toRange());
      }
    };
    var moveCaret = function (editor, down, pos) {
      var table = down ? getTable(true, pos) : getTable(false, pos);
      var last = down === false;
      table.fold(function () {
        return moveToRange(editor, pos.toRange());
      }, function (table) {
        return positionIn(last, editor.getBody()).filter(function (lastPos) {
          return lastPos.isEqual(pos);
        }).fold(function () {
          return moveToRange(editor, pos.toRange());
        }, function (_) {
          return renderBlock(down, editor, table, pos);
        });
      });
    };
    var navigateVertically = function (editor, down, table, td) {
      var rng = editor.selection.getRng();
      var pos = CaretPosition.fromRangeStart(rng);
      var root = editor.getBody();
      if (!down && isAtFirstTableCellLine(td, pos)) {
        var newPos = getClosestAbovePosition(root, table, pos);
        moveCaret(editor, down, newPos);
        return true;
      } else if (down && isAtLastTableCellLine(td, pos)) {
        var newPos = getClosestBelowPosition(root, table, pos);
        moveCaret(editor, down, newPos);
        return true;
      } else {
        return false;
      }
    };
    var move$1 = function (editor, forward, mover) {
      return Optional.from(editor.dom.getParent(editor.selection.getNode(), 'td,th')).bind(function (td) {
        return Optional.from(editor.dom.getParent(td, 'table')).map(function (table) {
          return mover(editor, forward, table, td);
        });
      }).getOr(false);
    };
    var moveH = function (editor, forward) {
      return move$1(editor, forward, navigateHorizontally);
    };
    var moveV = function (editor, forward) {
      return move$1(editor, forward, navigateVertically);
    };

    var executeKeydownOverride$3 = function (editor, caret, evt) {
      var os = detect().os;
      execute([
        {
          keyCode: VK.RIGHT,
          action: action(moveH$2, editor, true)
        },
        {
          keyCode: VK.LEFT,
          action: action(moveH$2, editor, false)
        },
        {
          keyCode: VK.UP,
          action: action(moveV$3, editor, false)
        },
        {
          keyCode: VK.DOWN,
          action: action(moveV$3, editor, true)
        },
        {
          keyCode: VK.RIGHT,
          action: action(moveH, editor, true)
        },
        {
          keyCode: VK.LEFT,
          action: action(moveH, editor, false)
        },
        {
          keyCode: VK.UP,
          action: action(moveV, editor, false)
        },
        {
          keyCode: VK.DOWN,
          action: action(moveV, editor, true)
        },
        {
          keyCode: VK.RIGHT,
          action: action(moveH$1, editor, true)
        },
        {
          keyCode: VK.LEFT,
          action: action(moveH$1, editor, false)
        },
        {
          keyCode: VK.UP,
          action: action(moveV$1, editor, false)
        },
        {
          keyCode: VK.DOWN,
          action: action(moveV$1, editor, true)
        },
        {
          keyCode: VK.RIGHT,
          action: action(move$2, editor, caret, true)
        },
        {
          keyCode: VK.LEFT,
          action: action(move$2, editor, caret, false)
        },
        {
          keyCode: VK.RIGHT,
          ctrlKey: !os.isOSX(),
          altKey: os.isOSX(),
          action: action(moveNextWord, editor, caret)
        },
        {
          keyCode: VK.LEFT,
          ctrlKey: !os.isOSX(),
          altKey: os.isOSX(),
          action: action(movePrevWord, editor, caret)
        },
        {
          keyCode: VK.UP,
          action: action(moveV$2, editor, false)
        },
        {
          keyCode: VK.DOWN,
          action: action(moveV$2, editor, true)
        }
      ], evt).each(function (_) {
        evt.preventDefault();
      });
    };
    var setup$b = function (editor, caret) {
      editor.on('keydown', function (evt) {
        if (evt.isDefaultPrevented() === false) {
          executeKeydownOverride$3(editor, caret, evt);
        }
      });
    };

    var executeKeydownOverride$2 = function (editor, caret, evt) {
      execute([
        {
          keyCode: VK.BACKSPACE,
          action: action(backspaceDelete, editor, false)
        },
        {
          keyCode: VK.BACKSPACE,
          action: action(backspaceDelete$5, editor, false)
        },
        {
          keyCode: VK.DELETE,
          action: action(backspaceDelete$5, editor, true)
        },
        {
          keyCode: VK.BACKSPACE,
          action: action(backspaceDelete$6, editor, false)
        },
        {
          keyCode: VK.DELETE,
          action: action(backspaceDelete$6, editor, true)
        },
        {
          keyCode: VK.BACKSPACE,
          action: action(backspaceDelete$3, editor, caret, false)
        },
        {
          keyCode: VK.DELETE,
          action: action(backspaceDelete$3, editor, caret, true)
        },
        {
          keyCode: VK.BACKSPACE,
          action: action(backspaceDelete$9, editor, false)
        },
        {
          keyCode: VK.DELETE,
          action: action(backspaceDelete$9, editor, true)
        },
        {
          keyCode: VK.BACKSPACE,
          action: action(backspaceDelete$4, editor, false)
        },
        {
          keyCode: VK.DELETE,
          action: action(backspaceDelete$4, editor, true)
        },
        {
          keyCode: VK.BACKSPACE,
          action: action(backspaceDelete$1, editor, false)
        },
        {
          keyCode: VK.DELETE,
          action: action(backspaceDelete$1, editor, true)
        },
        {
          keyCode: VK.BACKSPACE,
          action: action(backspaceDelete$7, editor, false)
        },
        {
          keyCode: VK.DELETE,
          action: action(backspaceDelete$7, editor, true)
        },
        {
          keyCode: VK.BACKSPACE,
          action: action(backspaceDelete$8, editor, false)
        },
        {
          keyCode: VK.DELETE,
          action: action(backspaceDelete$8, editor, true)
        },
        {
          keyCode: VK.BACKSPACE,
          action: action(backspaceDelete$2, editor, false)
        },
        {
          keyCode: VK.DELETE,
          action: action(backspaceDelete$2, editor, true)
        }
      ], evt).each(function (_) {
        evt.preventDefault();
      });
    };
    var executeKeyupOverride = function (editor, evt) {
      execute([
        {
          keyCode: VK.BACKSPACE,
          action: action(paddEmptyElement, editor)
        },
        {
          keyCode: VK.DELETE,
          action: action(paddEmptyElement, editor)
        }
      ], evt);
    };
    var setup$a = function (editor, caret) {
      editor.on('keydown', function (evt) {
        if (evt.isDefaultPrevented() === false) {
          executeKeydownOverride$2(editor, caret, evt);
        }
      });
      editor.on('keyup', function (evt) {
        if (evt.isDefaultPrevented() === false) {
          executeKeyupOverride(editor, evt);
        }
      });
    };

    var firstNonWhiteSpaceNodeSibling = function (node) {
      while (node) {
        if (node.nodeType === 1 || node.nodeType === 3 && node.data && /[\r\n\s]/.test(node.data)) {
          return node;
        }
        node = node.nextSibling;
      }
    };
    var moveToCaretPosition = function (editor, root) {
      var node, lastNode = root;
      var dom = editor.dom;
      var moveCaretBeforeOnEnterElementsMap = editor.schema.getMoveCaretBeforeOnEnterElements();
      if (!root) {
        return;
      }
      if (/^(LI|DT|DD)$/.test(root.nodeName)) {
        var firstChild = firstNonWhiteSpaceNodeSibling(root.firstChild);
        if (firstChild && /^(UL|OL|DL)$/.test(firstChild.nodeName)) {
          root.insertBefore(dom.doc.createTextNode(nbsp), root.firstChild);
        }
      }
      var rng = dom.createRng();
      root.normalize();
      if (root.hasChildNodes()) {
        var walker = new DomTreeWalker(root, root);
        while (node = walker.current()) {
          if (isText$7(node)) {
            rng.setStart(node, 0);
            rng.setEnd(node, 0);
            break;
          }
          if (moveCaretBeforeOnEnterElementsMap[node.nodeName.toLowerCase()]) {
            rng.setStartBefore(node);
            rng.setEndBefore(node);
            break;
          }
          lastNode = node;
          node = walker.next();
        }
        if (!node) {
          rng.setStart(lastNode, 0);
          rng.setEnd(lastNode, 0);
        }
      } else {
        if (isBr$5(root)) {
          if (root.nextSibling && dom.isBlock(root.nextSibling)) {
            rng.setStartBefore(root);
            rng.setEndBefore(root);
          } else {
            rng.setStartAfter(root);
            rng.setEndAfter(root);
          }
        } else {
          rng.setStart(root, 0);
          rng.setEnd(root, 0);
        }
      }
      editor.selection.setRng(rng);
      scrollRangeIntoView(editor, rng);
    };
    var getEditableRoot$1 = function (dom, node) {
      var root = dom.getRoot();
      var parent, editableRoot;
      parent = node;
      while (parent !== root && dom.getContentEditable(parent) !== 'false') {
        if (dom.getContentEditable(parent) === 'true') {
          editableRoot = parent;
        }
        parent = parent.parentNode;
      }
      return parent !== root ? editableRoot : root;
    };
    var getParentBlock = function (editor) {
      return Optional.from(editor.dom.getParent(editor.selection.getStart(true), editor.dom.isBlock));
    };
    var getParentBlockName = function (editor) {
      return getParentBlock(editor).fold(constant(''), function (parentBlock) {
        return parentBlock.nodeName.toUpperCase();
      });
    };
    var isListItemParentBlock = function (editor) {
      return getParentBlock(editor).filter(function (elm) {
        return isListItem(SugarElement.fromDom(elm));
      }).isSome();
    };

    var hasFirstChild = function (elm, name) {
      return elm.firstChild && elm.firstChild.nodeName === name;
    };
    var isFirstChild = function (elm) {
      var _a;
      return ((_a = elm.parentNode) === null || _a === void 0 ? void 0 : _a.firstChild) === elm;
    };
    var hasParent = function (elm, parentName) {
      return elm && elm.parentNode && elm.parentNode.nodeName === parentName;
    };
    var isListBlock = function (elm) {
      return elm && /^(OL|UL|LI)$/.test(elm.nodeName);
    };
    var isNestedList = function (elm) {
      return isListBlock(elm) && isListBlock(elm.parentNode);
    };
    var getContainerBlock = function (containerBlock) {
      var containerBlockParent = containerBlock.parentNode;
      if (/^(LI|DT|DD)$/.test(containerBlockParent.nodeName)) {
        return containerBlockParent;
      }
      return containerBlock;
    };
    var isFirstOrLastLi = function (containerBlock, parentBlock, first) {
      var node = containerBlock[first ? 'firstChild' : 'lastChild'];
      while (node) {
        if (isElement$5(node)) {
          break;
        }
        node = node[first ? 'nextSibling' : 'previousSibling'];
      }
      return node === parentBlock;
    };
    var insert$3 = function (editor, createNewBlock, containerBlock, parentBlock, newBlockName) {
      var dom = editor.dom;
      var rng = editor.selection.getRng();
      if (containerBlock === editor.getBody()) {
        return;
      }
      if (isNestedList(containerBlock)) {
        newBlockName = 'LI';
      }
      var newBlock = newBlockName ? createNewBlock(newBlockName) : dom.create('BR');
      if (isFirstOrLastLi(containerBlock, parentBlock, true) && isFirstOrLastLi(containerBlock, parentBlock, false)) {
        if (hasParent(containerBlock, 'LI')) {
          var containerBlockParent = getContainerBlock(containerBlock);
          dom.insertAfter(newBlock, containerBlockParent);
          if (isFirstChild(containerBlock)) {
            dom.remove(containerBlockParent);
          } else {
            dom.remove(containerBlock);
          }
        } else {
          dom.replace(newBlock, containerBlock);
        }
      } else if (isFirstOrLastLi(containerBlock, parentBlock, true)) {
        if (hasParent(containerBlock, 'LI')) {
          dom.insertAfter(newBlock, getContainerBlock(containerBlock));
          newBlock.appendChild(dom.doc.createTextNode(' '));
          newBlock.appendChild(containerBlock);
        } else {
          containerBlock.parentNode.insertBefore(newBlock, containerBlock);
        }
        dom.remove(parentBlock);
      } else if (isFirstOrLastLi(containerBlock, parentBlock, false)) {
        dom.insertAfter(newBlock, getContainerBlock(containerBlock));
        dom.remove(parentBlock);
      } else {
        containerBlock = getContainerBlock(containerBlock);
        var tmpRng = rng.cloneRange();
        tmpRng.setStartAfter(parentBlock);
        tmpRng.setEndAfter(containerBlock);
        var fragment = tmpRng.extractContents();
        if (newBlockName === 'LI' && hasFirstChild(fragment, 'LI')) {
          newBlock = fragment.firstChild;
          dom.insertAfter(fragment, containerBlock);
        } else {
          dom.insertAfter(fragment, containerBlock);
          dom.insertAfter(newBlock, containerBlock);
        }
        dom.remove(parentBlock);
      }
      moveToCaretPosition(editor, newBlock);
    };

    var trimZwsp = function (fragment) {
      each$k(descendants$1(SugarElement.fromDom(fragment), isText$8), function (text) {
        var rawNode = text.dom;
        rawNode.nodeValue = trim$2(rawNode.nodeValue);
      });
    };
    var isEmptyAnchor = function (dom, elm) {
      return elm && elm.nodeName === 'A' && dom.isEmpty(elm);
    };
    var isTableCell = function (node) {
      return node && /^(TD|TH|CAPTION)$/.test(node.nodeName);
    };
    var emptyBlock = function (elm) {
      elm.innerHTML = '<br data-mce-bogus="1">';
    };
    var containerAndSiblingName = function (container, nodeName) {
      return container.nodeName === nodeName || container.previousSibling && container.previousSibling.nodeName === nodeName;
    };
    var canSplitBlock = function (dom, node) {
      return node && dom.isBlock(node) && !/^(TD|TH|CAPTION|FORM)$/.test(node.nodeName) && !/^(fixed|absolute)/i.test(node.style.position) && dom.getContentEditable(node) !== 'true';
    };
    var trimInlineElementsOnLeftSideOfBlock = function (dom, nonEmptyElementsMap, block) {
      var node = block;
      var firstChilds = [];
      var i;
      if (!node) {
        return;
      }
      while (node = node.firstChild) {
        if (dom.isBlock(node)) {
          return;
        }
        if (isElement$5(node) && !nonEmptyElementsMap[node.nodeName.toLowerCase()]) {
          firstChilds.push(node);
        }
      }
      i = firstChilds.length;
      while (i--) {
        node = firstChilds[i];
        if (!node.hasChildNodes() || node.firstChild === node.lastChild && node.firstChild.nodeValue === '') {
          dom.remove(node);
        } else {
          if (isEmptyAnchor(dom, node)) {
            dom.remove(node);
          }
        }
      }
    };
    var normalizeZwspOffset = function (start, container, offset) {
      if (isText$7(container) === false) {
        return offset;
      } else if (start) {
        return offset === 1 && container.data.charAt(offset - 1) === ZWSP$1 ? 0 : offset;
      } else {
        return offset === container.data.length - 1 && container.data.charAt(offset) === ZWSP$1 ? container.data.length : offset;
      }
    };
    var includeZwspInRange = function (rng) {
      var newRng = rng.cloneRange();
      newRng.setStart(rng.startContainer, normalizeZwspOffset(true, rng.startContainer, rng.startOffset));
      newRng.setEnd(rng.endContainer, normalizeZwspOffset(false, rng.endContainer, rng.endOffset));
      return newRng;
    };
    var trimLeadingLineBreaks = function (node) {
      do {
        if (isText$7(node)) {
          node.nodeValue = node.nodeValue.replace(/^[\r\n]+/, '');
        }
        node = node.firstChild;
      } while (node);
    };
    var getEditableRoot = function (dom, node) {
      var root = dom.getRoot();
      var parent, editableRoot;
      parent = node;
      while (parent !== root && dom.getContentEditable(parent) !== 'false') {
        if (dom.getContentEditable(parent) === 'true') {
          editableRoot = parent;
        }
        parent = parent.parentNode;
      }
      return parent !== root ? editableRoot : root;
    };
    var applyAttributes = function (editor, node, forcedRootBlockAttrs) {
      var dom = editor.dom;
      Optional.from(forcedRootBlockAttrs.style).map(dom.parseStyle).each(function (attrStyles) {
        var currentStyles = getAllRaw(SugarElement.fromDom(node));
        var newStyles = __assign(__assign({}, currentStyles), attrStyles);
        dom.setStyles(node, newStyles);
      });
      var attrClassesOpt = Optional.from(forcedRootBlockAttrs.class).map(function (attrClasses) {
        return attrClasses.split(/\s+/);
      });
      var currentClassesOpt = Optional.from(node.className).map(function (currentClasses) {
        return filter$4(currentClasses.split(/\s+/), function (clazz) {
          return clazz !== '';
        });
      });
      lift2(attrClassesOpt, currentClassesOpt, function (attrClasses, currentClasses) {
        var filteredClasses = filter$4(currentClasses, function (clazz) {
          return !contains$3(attrClasses, clazz);
        });
        var newClasses = __spreadArray(__spreadArray([], attrClasses, true), filteredClasses, true);
        dom.setAttrib(node, 'class', newClasses.join(' '));
      });
      var appliedAttrs = [
        'style',
        'class'
      ];
      var remainingAttrs = filter$3(forcedRootBlockAttrs, function (_, attrs) {
        return !contains$3(appliedAttrs, attrs);
      });
      dom.setAttribs(node, remainingAttrs);
    };
    var setForcedBlockAttrs = function (editor, node) {
      var forcedRootBlockName = getForcedRootBlock(editor);
      if (forcedRootBlockName && forcedRootBlockName.toLowerCase() === node.tagName.toLowerCase()) {
        var forcedRootBlockAttrs = getForcedRootBlockAttrs(editor);
        applyAttributes(editor, node, forcedRootBlockAttrs);
      }
    };
    var wrapSelfAndSiblingsInDefaultBlock = function (editor, newBlockName, rng, container, offset) {
      var newBlock, parentBlock, startNode, node, next, rootBlockName;
      var blockName = newBlockName || 'P';
      var dom = editor.dom, editableRoot = getEditableRoot(dom, container);
      parentBlock = dom.getParent(container, dom.isBlock);
      if (!parentBlock || !canSplitBlock(dom, parentBlock)) {
        parentBlock = parentBlock || editableRoot;
        if (parentBlock === editor.getBody() || isTableCell(parentBlock)) {
          rootBlockName = parentBlock.nodeName.toLowerCase();
        } else {
          rootBlockName = parentBlock.parentNode.nodeName.toLowerCase();
        }
        if (!parentBlock.hasChildNodes()) {
          newBlock = dom.create(blockName);
          setForcedBlockAttrs(editor, newBlock);
          parentBlock.appendChild(newBlock);
          rng.setStart(newBlock, 0);
          rng.setEnd(newBlock, 0);
          return newBlock;
        }
        node = container;
        while (node.parentNode !== parentBlock) {
          node = node.parentNode;
        }
        while (node && !dom.isBlock(node)) {
          startNode = node;
          node = node.previousSibling;
        }
        if (startNode && editor.schema.isValidChild(rootBlockName, blockName.toLowerCase())) {
          newBlock = dom.create(blockName);
          setForcedBlockAttrs(editor, newBlock);
          startNode.parentNode.insertBefore(newBlock, startNode);
          node = startNode;
          while (node && !dom.isBlock(node)) {
            next = node.nextSibling;
            newBlock.appendChild(node);
            node = next;
          }
          rng.setStart(container, offset);
          rng.setEnd(container, offset);
        }
      }
      return container;
    };
    var addBrToBlockIfNeeded = function (dom, block) {
      block.normalize();
      var lastChild = block.lastChild;
      if (!lastChild || /^(left|right)$/gi.test(dom.getStyle(lastChild, 'float', true))) {
        dom.add(block, 'br');
      }
    };
    var insert$2 = function (editor, evt) {
      var tmpRng, container, offset, parentBlock;
      var newBlock, fragment, containerBlock, parentBlockName, newBlockName, isAfterLastNodeInContainer;
      var dom = editor.dom;
      var schema = editor.schema, nonEmptyElementsMap = schema.getNonEmptyElements();
      var rng = editor.selection.getRng();
      var createNewBlock = function (name) {
        var node = container, block, clonedNode, caretNode;
        var textInlineElements = schema.getTextInlineElements();
        if (name || parentBlockName === 'TABLE' || parentBlockName === 'HR') {
          block = dom.create(name || newBlockName);
        } else {
          block = parentBlock.cloneNode(false);
        }
        caretNode = block;
        if (shouldKeepStyles(editor) === false) {
          dom.setAttrib(block, 'style', null);
          dom.setAttrib(block, 'class', null);
        } else {
          do {
            if (textInlineElements[node.nodeName]) {
              if (isCaretNode(node) || isBookmarkNode$1(node)) {
                continue;
              }
              clonedNode = node.cloneNode(false);
              dom.setAttrib(clonedNode, 'id', '');
              if (block.hasChildNodes()) {
                clonedNode.appendChild(block.firstChild);
                block.appendChild(clonedNode);
              } else {
                caretNode = clonedNode;
                block.appendChild(clonedNode);
              }
            }
          } while ((node = node.parentNode) && node !== editableRoot);
        }
        setForcedBlockAttrs(editor, block);
        emptyBlock(caretNode);
        return block;
      };
      var isCaretAtStartOrEndOfBlock = function (start) {
        var node, name;
        var normalizedOffset = normalizeZwspOffset(start, container, offset);
        if (isText$7(container) && (start ? normalizedOffset > 0 : normalizedOffset < container.nodeValue.length)) {
          return false;
        }
        if (container.parentNode === parentBlock && isAfterLastNodeInContainer && !start) {
          return true;
        }
        if (start && isElement$5(container) && container === parentBlock.firstChild) {
          return true;
        }
        if (containerAndSiblingName(container, 'TABLE') || containerAndSiblingName(container, 'HR')) {
          return isAfterLastNodeInContainer && !start || !isAfterLastNodeInContainer && start;
        }
        var walker = new DomTreeWalker(container, parentBlock);
        if (isText$7(container)) {
          if (start && normalizedOffset === 0) {
            walker.prev();
          } else if (!start && normalizedOffset === container.nodeValue.length) {
            walker.next();
          }
        }
        while (node = walker.current()) {
          if (isElement$5(node)) {
            if (!node.getAttribute('data-mce-bogus')) {
              name = node.nodeName.toLowerCase();
              if (nonEmptyElementsMap[name] && name !== 'br') {
                return false;
              }
            }
          } else if (isText$7(node) && !isWhitespaceText(node.nodeValue)) {
            return false;
          }
          if (start) {
            walker.prev();
          } else {
            walker.next();
          }
        }
        return true;
      };
      var insertNewBlockAfter = function () {
        if (/^(H[1-6]|PRE|FIGURE)$/.test(parentBlockName) && containerBlockName !== 'HGROUP') {
          newBlock = createNewBlock(newBlockName);
        } else {
          newBlock = createNewBlock();
        }
        if (shouldEndContainerOnEmptyBlock(editor) && canSplitBlock(dom, containerBlock) && dom.isEmpty(parentBlock)) {
          newBlock = dom.split(containerBlock, parentBlock);
        } else {
          dom.insertAfter(newBlock, parentBlock);
        }
        moveToCaretPosition(editor, newBlock);
      };
      normalize$2(dom, rng).each(function (normRng) {
        rng.setStart(normRng.startContainer, normRng.startOffset);
        rng.setEnd(normRng.endContainer, normRng.endOffset);
      });
      container = rng.startContainer;
      offset = rng.startOffset;
      newBlockName = getForcedRootBlock(editor);
      var shiftKey = !!(evt && evt.shiftKey);
      var ctrlKey = !!(evt && evt.ctrlKey);
      if (isElement$5(container) && container.hasChildNodes()) {
        isAfterLastNodeInContainer = offset > container.childNodes.length - 1;
        container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
        if (isAfterLastNodeInContainer && isText$7(container)) {
          offset = container.nodeValue.length;
        } else {
          offset = 0;
        }
      }
      var editableRoot = getEditableRoot(dom, container);
      if (!editableRoot) {
        return;
      }
      if (newBlockName && !shiftKey || !newBlockName && shiftKey) {
        container = wrapSelfAndSiblingsInDefaultBlock(editor, newBlockName, rng, container, offset);
      }
      parentBlock = dom.getParent(container, dom.isBlock);
      containerBlock = parentBlock ? dom.getParent(parentBlock.parentNode, dom.isBlock) : null;
      parentBlockName = parentBlock ? parentBlock.nodeName.toUpperCase() : '';
      var containerBlockName = containerBlock ? containerBlock.nodeName.toUpperCase() : '';
      if (containerBlockName === 'LI' && !ctrlKey) {
        parentBlock = containerBlock;
        containerBlock = containerBlock.parentNode;
        parentBlockName = containerBlockName;
      }
      if (/^(LI|DT|DD)$/.test(parentBlockName)) {
        if (dom.isEmpty(parentBlock)) {
          insert$3(editor, createNewBlock, containerBlock, parentBlock, newBlockName);
          return;
        }
      }
      if (newBlockName && parentBlock === editor.getBody()) {
        return;
      }
      newBlockName = newBlockName || 'P';
      if (isCaretContainerBlock$1(parentBlock)) {
        newBlock = showCaretContainerBlock(parentBlock);
        if (dom.isEmpty(parentBlock)) {
          emptyBlock(parentBlock);
        }
        setForcedBlockAttrs(editor, newBlock);
        moveToCaretPosition(editor, newBlock);
      } else if (isCaretAtStartOrEndOfBlock()) {
        insertNewBlockAfter();
      } else if (isCaretAtStartOrEndOfBlock(true)) {
        newBlock = parentBlock.parentNode.insertBefore(createNewBlock(), parentBlock);
        moveToCaretPosition(editor, containerAndSiblingName(parentBlock, 'HR') ? newBlock : parentBlock);
      } else {
        tmpRng = includeZwspInRange(rng).cloneRange();
        tmpRng.setEndAfter(parentBlock);
        fragment = tmpRng.extractContents();
        trimZwsp(fragment);
        trimLeadingLineBreaks(fragment);
        newBlock = fragment.firstChild;
        dom.insertAfter(fragment, parentBlock);
        trimInlineElementsOnLeftSideOfBlock(dom, nonEmptyElementsMap, newBlock);
        addBrToBlockIfNeeded(dom, parentBlock);
        if (dom.isEmpty(parentBlock)) {
          emptyBlock(parentBlock);
        }
        newBlock.normalize();
        if (dom.isEmpty(newBlock)) {
          dom.remove(newBlock);
          insertNewBlockAfter();
        } else {
          setForcedBlockAttrs(editor, newBlock);
          moveToCaretPosition(editor, newBlock);
        }
      }
      dom.setAttrib(newBlock, 'id', '');
      editor.fire('NewBlock', { newBlock: newBlock });
    };

    var hasRightSideContent = function (schema, container, parentBlock) {
      var walker = new DomTreeWalker(container, parentBlock);
      var node;
      var nonEmptyElementsMap = schema.getNonEmptyElements();
      while (node = walker.next()) {
        if (nonEmptyElementsMap[node.nodeName.toLowerCase()] || node.length > 0) {
          return true;
        }
      }
    };
    var moveSelectionToBr = function (editor, brElm, extraBr) {
      var rng = editor.dom.createRng();
      if (!extraBr) {
        rng.setStartAfter(brElm);
        rng.setEndAfter(brElm);
      } else {
        rng.setStartBefore(brElm);
        rng.setEndBefore(brElm);
      }
      editor.selection.setRng(rng);
      scrollRangeIntoView(editor, rng);
    };
    var insertBrAtCaret = function (editor, evt) {
      var selection = editor.selection;
      var dom = editor.dom;
      var rng = selection.getRng();
      var brElm;
      var extraBr;
      normalize$2(dom, rng).each(function (normRng) {
        rng.setStart(normRng.startContainer, normRng.startOffset);
        rng.setEnd(normRng.endContainer, normRng.endOffset);
      });
      var offset = rng.startOffset;
      var container = rng.startContainer;
      if (container.nodeType === 1 && container.hasChildNodes()) {
        var isAfterLastNodeInContainer = offset > container.childNodes.length - 1;
        container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
        if (isAfterLastNodeInContainer && container.nodeType === 3) {
          offset = container.nodeValue.length;
        } else {
          offset = 0;
        }
      }
      var parentBlock = dom.getParent(container, dom.isBlock);
      var containerBlock = parentBlock ? dom.getParent(parentBlock.parentNode, dom.isBlock) : null;
      var containerBlockName = containerBlock ? containerBlock.nodeName.toUpperCase() : '';
      var isControlKey = !!(evt && evt.ctrlKey);
      if (containerBlockName === 'LI' && !isControlKey) {
        parentBlock = containerBlock;
      }
      if (container && container.nodeType === 3 && offset >= container.nodeValue.length) {
        if (!hasRightSideContent(editor.schema, container, parentBlock)) {
          brElm = dom.create('br');
          rng.insertNode(brElm);
          rng.setStartAfter(brElm);
          rng.setEndAfter(brElm);
          extraBr = true;
        }
      }
      brElm = dom.create('br');
      rangeInsertNode(dom, rng, brElm);
      moveSelectionToBr(editor, brElm, extraBr);
      editor.undoManager.add();
    };
    var insertBrBefore = function (editor, inline) {
      var br = SugarElement.fromTag('br');
      before$4(SugarElement.fromDom(inline), br);
      editor.undoManager.add();
    };
    var insertBrAfter = function (editor, inline) {
      if (!hasBrAfter(editor.getBody(), inline)) {
        after$3(SugarElement.fromDom(inline), SugarElement.fromTag('br'));
      }
      var br = SugarElement.fromTag('br');
      after$3(SugarElement.fromDom(inline), br);
      moveSelectionToBr(editor, br.dom, false);
      editor.undoManager.add();
    };
    var isBeforeBr = function (pos) {
      return isBr$5(pos.getNode());
    };
    var hasBrAfter = function (rootNode, startNode) {
      if (isBeforeBr(CaretPosition.after(startNode))) {
        return true;
      } else {
        return nextPosition(rootNode, CaretPosition.after(startNode)).map(function (pos) {
          return isBr$5(pos.getNode());
        }).getOr(false);
      }
    };
    var isAnchorLink = function (elm) {
      return elm && elm.nodeName === 'A' && 'href' in elm;
    };
    var isInsideAnchor = function (location) {
      return location.fold(never, isAnchorLink, isAnchorLink, never);
    };
    var readInlineAnchorLocation = function (editor) {
      var isInlineTarget$1 = curry(isInlineTarget, editor);
      var position = CaretPosition.fromRangeStart(editor.selection.getRng());
      return readLocation(isInlineTarget$1, editor.getBody(), position).filter(isInsideAnchor);
    };
    var insertBrOutsideAnchor = function (editor, location) {
      location.fold(noop, curry(insertBrBefore, editor), curry(insertBrAfter, editor), noop);
    };
    var insert$1 = function (editor, evt) {
      var anchorLocation = readInlineAnchorLocation(editor);
      if (anchorLocation.isSome()) {
        anchorLocation.each(curry(insertBrOutsideAnchor, editor));
      } else {
        insertBrAtCaret(editor, evt);
      }
    };

    var matchesSelector = function (editor, selector) {
      return getParentBlock(editor).filter(function (parentBlock) {
        return selector.length > 0 && is$2(SugarElement.fromDom(parentBlock), selector);
      }).isSome();
    };
    var shouldInsertBr = function (editor) {
      return matchesSelector(editor, getBrNewLineSelector(editor));
    };
    var shouldBlockNewLine$1 = function (editor) {
      return matchesSelector(editor, getNoNewLineSelector(editor));
    };

    var newLineAction = Adt.generate([
      { br: [] },
      { block: [] },
      { none: [] }
    ]);
    var shouldBlockNewLine = function (editor, _shiftKey) {
      return shouldBlockNewLine$1(editor);
    };
    var isBrMode = function (requiredState) {
      return function (editor, _shiftKey) {
        var brMode = getForcedRootBlock(editor) === '';
        return brMode === requiredState;
      };
    };
    var inListBlock = function (requiredState) {
      return function (editor, _shiftKey) {
        return isListItemParentBlock(editor) === requiredState;
      };
    };
    var inBlock = function (blockName, requiredState) {
      return function (editor, _shiftKey) {
        var state = getParentBlockName(editor) === blockName.toUpperCase();
        return state === requiredState;
      };
    };
    var inPreBlock = function (requiredState) {
      return inBlock('pre', requiredState);
    };
    var inSummaryBlock = function () {
      return inBlock('summary', true);
    };
    var shouldPutBrInPre = function (requiredState) {
      return function (editor, _shiftKey) {
        return shouldPutBrInPre$1(editor) === requiredState;
      };
    };
    var inBrContext = function (editor, _shiftKey) {
      return shouldInsertBr(editor);
    };
    var hasShiftKey = function (_editor, shiftKey) {
      return shiftKey;
    };
    var canInsertIntoEditableRoot = function (editor) {
      var forcedRootBlock = getForcedRootBlock(editor);
      var rootEditable = getEditableRoot$1(editor.dom, editor.selection.getStart());
      return rootEditable && editor.schema.isValidChild(rootEditable.nodeName, forcedRootBlock ? forcedRootBlock : 'P');
    };
    var match = function (predicates, action) {
      return function (editor, shiftKey) {
        var isMatch = foldl(predicates, function (res, p) {
          return res && p(editor, shiftKey);
        }, true);
        return isMatch ? Optional.some(action) : Optional.none();
      };
    };
    var getAction = function (editor, evt) {
      return evaluateUntil([
        match([shouldBlockNewLine], newLineAction.none()),
        match([inSummaryBlock()], newLineAction.br()),
        match([
          inPreBlock(true),
          shouldPutBrInPre(false),
          hasShiftKey
        ], newLineAction.br()),
        match([
          inPreBlock(true),
          shouldPutBrInPre(false)
        ], newLineAction.block()),
        match([
          inPreBlock(true),
          shouldPutBrInPre(true),
          hasShiftKey
        ], newLineAction.block()),
        match([
          inPreBlock(true),
          shouldPutBrInPre(true)
        ], newLineAction.br()),
        match([
          inListBlock(true),
          hasShiftKey
        ], newLineAction.br()),
        match([inListBlock(true)], newLineAction.block()),
        match([
          isBrMode(true),
          hasShiftKey,
          canInsertIntoEditableRoot
        ], newLineAction.block()),
        match([isBrMode(true)], newLineAction.br()),
        match([inBrContext], newLineAction.br()),
        match([
          isBrMode(false),
          hasShiftKey
        ], newLineAction.br()),
        match([canInsertIntoEditableRoot], newLineAction.block())
      ], [
        editor,
        !!(evt && evt.shiftKey)
      ]).getOr(newLineAction.none());
    };

    var insert = function (editor, evt) {
      getAction(editor, evt).fold(function () {
        insert$1(editor, evt);
      }, function () {
        insert$2(editor, evt);
      }, noop);
    };

    var handleEnterKeyEvent = function (editor, event) {
      if (event.isDefaultPrevented()) {
        return;
      }
      event.preventDefault();
      endTypingLevelIgnoreLocks(editor.undoManager);
      editor.undoManager.transact(function () {
        if (editor.selection.isCollapsed() === false) {
          editor.execCommand('Delete');
        }
        insert(editor, event);
      });
    };
    var setup$9 = function (editor) {
      editor.on('keydown', function (event) {
        if (event.keyCode === VK.ENTER) {
          handleEnterKeyEvent(editor, event);
        }
      });
    };

    var executeKeydownOverride$1 = function (editor, caret, evt) {
      execute([
        {
          keyCode: VK.END,
          action: action(moveToLineEndPoint$1, editor, true)
        },
        {
          keyCode: VK.HOME,
          action: action(moveToLineEndPoint$1, editor, false)
        },
        {
          keyCode: VK.END,
          action: action(moveToLineEndPoint, editor, true)
        },
        {
          keyCode: VK.HOME,
          action: action(moveToLineEndPoint, editor, false)
        },
        {
          keyCode: VK.END,
          action: action(moveToLineEndPoint$2, editor, true, caret)
        },
        {
          keyCode: VK.HOME,
          action: action(moveToLineEndPoint$2, editor, false, caret)
        }
      ], evt).each(function (_) {
        evt.preventDefault();
      });
    };
    var setup$8 = function (editor, caret) {
      editor.on('keydown', function (evt) {
        if (evt.isDefaultPrevented() === false) {
          executeKeydownOverride$1(editor, caret, evt);
        }
      });
    };

    var browser = detect().browser;
    var setupIeInput = function (editor) {
      var keypressThrotter = first(function () {
        if (!editor.composing) {
          normalizeNbspsInEditor(editor);
        }
      }, 0);
      if (browser.isIE()) {
        editor.on('keypress', function (_e) {
          keypressThrotter.throttle();
        });
        editor.on('remove', function (_e) {
          keypressThrotter.cancel();
        });
      }
    };
    var setup$7 = function (editor) {
      setupIeInput(editor);
      editor.on('input', function (e) {
        if (e.isComposing === false) {
          normalizeNbspsInEditor(editor);
        }
      });
    };

    var platform = detect();
    var executeKeyupAction = function (editor, caret, evt) {
      execute([
        {
          keyCode: VK.PAGE_UP,
          action: action(moveToLineEndPoint$2, editor, false, caret)
        },
        {
          keyCode: VK.PAGE_DOWN,
          action: action(moveToLineEndPoint$2, editor, true, caret)
        }
      ], evt);
    };
    var stopImmediatePropagation = function (e) {
      return e.stopImmediatePropagation();
    };
    var isPageUpDown = function (evt) {
      return evt.keyCode === VK.PAGE_UP || evt.keyCode === VK.PAGE_DOWN;
    };
    var setNodeChangeBlocker = function (blocked, editor, block) {
      if (block && !blocked.get()) {
        editor.on('NodeChange', stopImmediatePropagation, true);
      } else if (!block && blocked.get()) {
        editor.off('NodeChange', stopImmediatePropagation);
      }
      blocked.set(block);
    };
    var setup$6 = function (editor, caret) {
      if (platform.os.isOSX()) {
        return;
      }
      var blocked = Cell(false);
      editor.on('keydown', function (evt) {
        if (isPageUpDown(evt)) {
          setNodeChangeBlocker(blocked, editor, true);
        }
      });
      editor.on('keyup', function (evt) {
        if (evt.isDefaultPrevented() === false) {
          executeKeyupAction(editor, caret, evt);
        }
        if (isPageUpDown(evt) && blocked.get()) {
          setNodeChangeBlocker(blocked, editor, false);
          editor.nodeChanged();
        }
      });
    };

    var insertTextAtPosition = function (text, pos) {
      var container = pos.container();
      var offset = pos.offset();
      if (isText$7(container)) {
        container.insertData(offset, text);
        return Optional.some(CaretPosition(container, offset + text.length));
      } else {
        return getElementFromPosition(pos).map(function (elm) {
          var textNode = SugarElement.fromText(text);
          if (pos.isAtEnd()) {
            after$3(elm, textNode);
          } else {
            before$4(elm, textNode);
          }
          return CaretPosition(textNode.dom, text.length);
        });
      }
    };
    var insertNbspAtPosition = curry(insertTextAtPosition, nbsp);
    var insertSpaceAtPosition = curry(insertTextAtPosition, ' ');

    var locationToCaretPosition = function (root) {
      return function (location) {
        return location.fold(function (element) {
          return prevPosition(root.dom, CaretPosition.before(element));
        }, function (element) {
          return firstPositionIn(element);
        }, function (element) {
          return lastPositionIn(element);
        }, function (element) {
          return nextPosition(root.dom, CaretPosition.after(element));
        });
      };
    };
    var insertInlineBoundarySpaceOrNbsp = function (root, pos) {
      return function (checkPos) {
        return needsToHaveNbsp(root, checkPos) ? insertNbspAtPosition(pos) : insertSpaceAtPosition(pos);
      };
    };
    var setSelection = function (editor) {
      return function (pos) {
        editor.selection.setRng(pos.toRange());
        editor.nodeChanged();
        return true;
      };
    };
    var insertSpaceOrNbspAtSelection = function (editor) {
      var pos = CaretPosition.fromRangeStart(editor.selection.getRng());
      var root = SugarElement.fromDom(editor.getBody());
      if (editor.selection.isCollapsed()) {
        var isInlineTarget$1 = curry(isInlineTarget, editor);
        var caretPosition = CaretPosition.fromRangeStart(editor.selection.getRng());
        return readLocation(isInlineTarget$1, editor.getBody(), caretPosition).bind(locationToCaretPosition(root)).bind(insertInlineBoundarySpaceOrNbsp(root, pos)).exists(setSelection(editor));
      } else {
        return false;
      }
    };

    var executeKeydownOverride = function (editor, evt) {
      execute([{
          keyCode: VK.SPACEBAR,
          action: action(insertSpaceOrNbspAtSelection, editor)
        }], evt).each(function (_) {
        evt.preventDefault();
      });
    };
    var setup$5 = function (editor) {
      editor.on('keydown', function (evt) {
        if (evt.isDefaultPrevented() === false) {
          executeKeydownOverride(editor, evt);
        }
      });
    };

    var registerKeyboardOverrides = function (editor) {
      var caret = setupSelectedState(editor);
      setup$c(editor);
      setup$b(editor, caret);
      setup$a(editor, caret);
      setup$9(editor);
      setup$5(editor);
      setup$7(editor);
      setup$8(editor, caret);
      setup$6(editor, caret);
      return caret;
    };
    var setup$4 = function (editor) {
      if (!isRtc(editor)) {
        return registerKeyboardOverrides(editor);
      } else {
        return Cell(null);
      }
    };

    var NodeChange = function () {
      function NodeChange(editor) {
        this.lastPath = [];
        this.editor = editor;
        var lastRng;
        var self = this;
        if (!('onselectionchange' in editor.getDoc())) {
          editor.on('NodeChange click mouseup keyup focus', function (e) {
            var nativeRng = editor.selection.getRng();
            var fakeRng = {
              startContainer: nativeRng.startContainer,
              startOffset: nativeRng.startOffset,
              endContainer: nativeRng.endContainer,
              endOffset: nativeRng.endOffset
            };
            if (e.type === 'nodechange' || !isEq$4(fakeRng, lastRng)) {
              editor.fire('SelectionChange');
            }
            lastRng = fakeRng;
          });
        }
        editor.on('contextmenu', function () {
          editor.fire('SelectionChange');
        });
        editor.on('SelectionChange', function () {
          var startElm = editor.selection.getStart(true);
          if (!startElm || !Env.range && editor.selection.isCollapsed()) {
            return;
          }
          if (hasAnyRanges(editor) && !self.isSameElementPath(startElm) && editor.dom.isChildOf(startElm, editor.getBody())) {
            editor.nodeChanged({ selectionChange: true });
          }
        });
        editor.on('mouseup', function (e) {
          if (!e.isDefaultPrevented() && hasAnyRanges(editor)) {
            if (editor.selection.getNode().nodeName === 'IMG') {
              Delay.setEditorTimeout(editor, function () {
                editor.nodeChanged();
              });
            } else {
              editor.nodeChanged();
            }
          }
        });
      }
      NodeChange.prototype.nodeChanged = function (args) {
        var selection = this.editor.selection;
        var node, parents, root;
        if (this.editor.initialized && selection && !shouldDisableNodeChange(this.editor) && !this.editor.mode.isReadOnly()) {
          root = this.editor.getBody();
          node = selection.getStart(true) || root;
          if (node.ownerDocument !== this.editor.getDoc() || !this.editor.dom.isChildOf(node, root)) {
            node = root;
          }
          parents = [];
          this.editor.dom.getParent(node, function (node) {
            if (node === root) {
              return true;
            }
            parents.push(node);
          });
          args = args || {};
          args.element = node;
          args.parents = parents;
          this.editor.fire('NodeChange', args);
        }
      };
      NodeChange.prototype.isSameElementPath = function (startElm) {
        var i;
        var currentPath = this.editor.$(startElm).parentsUntil(this.editor.getBody()).add(startElm);
        if (currentPath.length === this.lastPath.length) {
          for (i = currentPath.length; i >= 0; i--) {
            if (currentPath[i] !== this.lastPath[i]) {
              break;
            }
          }
          if (i === -1) {
            this.lastPath = currentPath;
            return true;
          }
        }
        this.lastPath = currentPath;
        return false;
      };
      return NodeChange;
    }();

    var preventSummaryToggle = function (editor) {
      editor.on('click', function (e) {
        if (editor.dom.getParent(e.target, 'details')) {
          e.preventDefault();
        }
      });
    };
    var filterDetails = function (editor) {
      editor.parser.addNodeFilter('details', function (elms) {
        each$k(elms, function (details) {
          details.attr('data-mce-open', details.attr('open'));
          details.attr('open', 'open');
        });
      });
      editor.serializer.addNodeFilter('details', function (elms) {
        each$k(elms, function (details) {
          var open = details.attr('data-mce-open');
          details.attr('open', isString$1(open) ? open : null);
          details.attr('data-mce-open', null);
        });
      });
    };
    var setup$3 = function (editor) {
      preventSummaryToggle(editor);
      filterDetails(editor);
    };

    var isTextBlockNode = function (node) {
      return isElement$5(node) && isTextBlock$2(SugarElement.fromDom(node));
    };
    var normalizeSelection = function (editor) {
      var rng = editor.selection.getRng();
      var startPos = CaretPosition.fromRangeStart(rng);
      var endPos = CaretPosition.fromRangeEnd(rng);
      if (CaretPosition.isElementPosition(startPos)) {
        var container = startPos.container();
        if (isTextBlockNode(container)) {
          firstPositionIn(container).each(function (pos) {
            return rng.setStart(pos.container(), pos.offset());
          });
        }
      }
      if (CaretPosition.isElementPosition(endPos)) {
        var container = startPos.container();
        if (isTextBlockNode(container)) {
          lastPositionIn(container).each(function (pos) {
            return rng.setEnd(pos.container(), pos.offset());
          });
        }
      }
      editor.selection.setRng(normalize(rng));
    };
    var setup$2 = function (editor) {
      editor.on('click', function (e) {
        if (e.detail >= 3) {
          normalizeSelection(editor);
        }
      });
    };

    var getAbsolutePosition = function (elm) {
      var clientRect = elm.getBoundingClientRect();
      var doc = elm.ownerDocument;
      var docElem = doc.documentElement;
      var win = doc.defaultView;
      return {
        top: clientRect.top + win.pageYOffset - docElem.clientTop,
        left: clientRect.left + win.pageXOffset - docElem.clientLeft
      };
    };
    var getBodyPosition = function (editor) {
      return editor.inline ? getAbsolutePosition(editor.getBody()) : {
        left: 0,
        top: 0
      };
    };
    var getScrollPosition = function (editor) {
      var body = editor.getBody();
      return editor.inline ? {
        left: body.scrollLeft,
        top: body.scrollTop
      } : {
        left: 0,
        top: 0
      };
    };
    var getBodyScroll = function (editor) {
      var body = editor.getBody(), docElm = editor.getDoc().documentElement;
      var inlineScroll = {
        left: body.scrollLeft,
        top: body.scrollTop
      };
      var iframeScroll = {
        left: body.scrollLeft || docElm.scrollLeft,
        top: body.scrollTop || docElm.scrollTop
      };
      return editor.inline ? inlineScroll : iframeScroll;
    };
    var getMousePosition = function (editor, event) {
      if (event.target.ownerDocument !== editor.getDoc()) {
        var iframePosition = getAbsolutePosition(editor.getContentAreaContainer());
        var scrollPosition = getBodyScroll(editor);
        return {
          left: event.pageX - iframePosition.left + scrollPosition.left,
          top: event.pageY - iframePosition.top + scrollPosition.top
        };
      }
      return {
        left: event.pageX,
        top: event.pageY
      };
    };
    var calculatePosition = function (bodyPosition, scrollPosition, mousePosition) {
      return {
        pageX: mousePosition.left - bodyPosition.left + scrollPosition.left,
        pageY: mousePosition.top - bodyPosition.top + scrollPosition.top
      };
    };
    var calc = function (editor, event) {
      return calculatePosition(getBodyPosition(editor), getScrollPosition(editor), getMousePosition(editor, event));
    };

    var isContentEditableFalse$1 = isContentEditableFalse$b, isContentEditableTrue$1 = isContentEditableTrue$4;
    var isDraggable = function (rootElm, elm) {
      return isContentEditableFalse$1(elm) && elm !== rootElm;
    };
    var isValidDropTarget = function (editor, targetElement, dragElement) {
      if (targetElement === dragElement || editor.dom.isChildOf(targetElement, dragElement)) {
        return false;
      }
      return !isContentEditableFalse$1(targetElement);
    };
    var cloneElement = function (elm) {
      var cloneElm = elm.cloneNode(true);
      cloneElm.removeAttribute('data-mce-selected');
      return cloneElm;
    };
    var createGhost = function (editor, elm, width, height) {
      var dom = editor.dom;
      var clonedElm = elm.cloneNode(true);
      dom.setStyles(clonedElm, {
        width: width,
        height: height
      });
      dom.setAttrib(clonedElm, 'data-mce-selected', null);
      var ghostElm = dom.create('div', {
        'class': 'mce-drag-container',
        'data-mce-bogus': 'all',
        'unselectable': 'on',
        'contenteditable': 'false'
      });
      dom.setStyles(ghostElm, {
        position: 'absolute',
        opacity: 0.5,
        overflow: 'hidden',
        border: 0,
        padding: 0,
        margin: 0,
        width: width,
        height: height
      });
      dom.setStyles(clonedElm, {
        margin: 0,
        boxSizing: 'border-box'
      });
      ghostElm.appendChild(clonedElm);
      return ghostElm;
    };
    var appendGhostToBody = function (ghostElm, bodyElm) {
      if (ghostElm.parentNode !== bodyElm) {
        bodyElm.appendChild(ghostElm);
      }
    };
    var moveGhost = function (ghostElm, position, width, height, maxX, maxY) {
      var overflowX = 0, overflowY = 0;
      ghostElm.style.left = position.pageX + 'px';
      ghostElm.style.top = position.pageY + 'px';
      if (position.pageX + width > maxX) {
        overflowX = position.pageX + width - maxX;
      }
      if (position.pageY + height > maxY) {
        overflowY = position.pageY + height - maxY;
      }
      ghostElm.style.width = width - overflowX + 'px';
      ghostElm.style.height = height - overflowY + 'px';
    };
    var removeElement = function (elm) {
      if (elm && elm.parentNode) {
        elm.parentNode.removeChild(elm);
      }
    };
    var isLeftMouseButtonPressed = function (e) {
      return e.button === 0;
    };
    var applyRelPos = function (state, position) {
      return {
        pageX: position.pageX - state.relX,
        pageY: position.pageY + 5
      };
    };
    var start = function (state, editor) {
      return function (e) {
        if (isLeftMouseButtonPressed(e)) {
          var ceElm = find$3(editor.dom.getParents(e.target), or(isContentEditableFalse$1, isContentEditableTrue$1)).getOr(null);
          if (isDraggable(editor.getBody(), ceElm)) {
            var elmPos = editor.dom.getPos(ceElm);
            var bodyElm = editor.getBody();
            var docElm = editor.getDoc().documentElement;
            state.set({
              element: ceElm,
              dragging: false,
              screenX: e.screenX,
              screenY: e.screenY,
              maxX: (editor.inline ? bodyElm.scrollWidth : docElm.offsetWidth) - 2,
              maxY: (editor.inline ? bodyElm.scrollHeight : docElm.offsetHeight) - 2,
              relX: e.pageX - elmPos.x,
              relY: e.pageY - elmPos.y,
              width: ceElm.offsetWidth,
              height: ceElm.offsetHeight,
              ghost: createGhost(editor, ceElm, ceElm.offsetWidth, ceElm.offsetHeight)
            });
          }
        }
      };
    };
    var move = function (state, editor) {
      var throttledPlaceCaretAt = Delay.throttle(function (clientX, clientY) {
        editor._selectionOverrides.hideFakeCaret();
        editor.selection.placeCaretAt(clientX, clientY);
      }, 0);
      editor.on('remove', throttledPlaceCaretAt.stop);
      return function (e) {
        return state.on(function (state) {
          var movement = Math.max(Math.abs(e.screenX - state.screenX), Math.abs(e.screenY - state.screenY));
          if (!state.dragging && movement > 10) {
            var args = editor.fire('dragstart', { target: state.element });
            if (args.isDefaultPrevented()) {
              return;
            }
            state.dragging = true;
            editor.focus();
          }
          if (state.dragging) {
            var targetPos = applyRelPos(state, calc(editor, e));
            appendGhostToBody(state.ghost, editor.getBody());
            moveGhost(state.ghost, targetPos, state.width, state.height, state.maxX, state.maxY);
            throttledPlaceCaretAt(e.clientX, e.clientY);
          }
        });
      };
    };
    var getRawTarget = function (selection) {
      var rng = selection.getSel().getRangeAt(0);
      var startContainer = rng.startContainer;
      return startContainer.nodeType === 3 ? startContainer.parentNode : startContainer;
    };
    var drop = function (state, editor) {
      return function (e) {
        state.on(function (state) {
          if (state.dragging) {
            if (isValidDropTarget(editor, getRawTarget(editor.selection), state.element)) {
              var targetClone_1 = cloneElement(state.element);
              var args = editor.fire('drop', {
                clientX: e.clientX,
                clientY: e.clientY
              });
              if (!args.isDefaultPrevented()) {
                editor.undoManager.transact(function () {
                  removeElement(state.element);
                  editor.insertContent(editor.dom.getOuterHTML(targetClone_1));
                  editor._selectionOverrides.hideFakeCaret();
                });
              }
            }
            editor.fire('dragend');
          }
        });
        removeDragState(state);
      };
    };
    var stop = function (state, editor) {
      return function () {
        state.on(function (state) {
          if (state.dragging) {
            editor.fire('dragend');
          }
        });
        removeDragState(state);
      };
    };
    var removeDragState = function (state) {
      state.on(function (state) {
        removeElement(state.ghost);
      });
      state.clear();
    };
    var bindFakeDragEvents = function (editor) {
      var state = value();
      var pageDom = DOMUtils.DOM;
      var rootDocument = document;
      var dragStartHandler = start(state, editor);
      var dragHandler = move(state, editor);
      var dropHandler = drop(state, editor);
      var dragEndHandler = stop(state, editor);
      editor.on('mousedown', dragStartHandler);
      editor.on('mousemove', dragHandler);
      editor.on('mouseup', dropHandler);
      pageDom.bind(rootDocument, 'mousemove', dragHandler);
      pageDom.bind(rootDocument, 'mouseup', dragEndHandler);
      editor.on('remove', function () {
        pageDom.unbind(rootDocument, 'mousemove', dragHandler);
        pageDom.unbind(rootDocument, 'mouseup', dragEndHandler);
      });
      editor.on('keydown', function (e) {
        if (e.keyCode === VK.ESC) {
          dragEndHandler();
        }
      });
    };
    var blockIeDrop = function (editor) {
      editor.on('drop', function (e) {
        var realTarget = typeof e.clientX !== 'undefined' ? editor.getDoc().elementFromPoint(e.clientX, e.clientY) : null;
        if (isContentEditableFalse$1(realTarget) || editor.dom.getContentEditableParent(realTarget) === 'false') {
          e.preventDefault();
        }
      });
    };
    var blockUnsupportedFileDrop = function (editor) {
      var preventFileDrop = function (e) {
        if (!e.isDefaultPrevented()) {
          var dataTransfer = e.dataTransfer;
          if (dataTransfer && (contains$3(dataTransfer.types, 'Files') || dataTransfer.files.length > 0)) {
            e.preventDefault();
            if (e.type === 'drop') {
              displayError(editor, 'Dropped file type is not supported');
            }
          }
        }
      };
      var preventFileDropIfUIElement = function (e) {
        if (isUIElement(editor, e.target)) {
          preventFileDrop(e);
        }
      };
      var setup = function () {
        var pageDom = DOMUtils.DOM;
        var dom = editor.dom;
        var doc = document;
        var editorRoot = editor.inline ? editor.getBody() : editor.getDoc();
        var eventNames = [
          'drop',
          'dragover'
        ];
        each$k(eventNames, function (name) {
          pageDom.bind(doc, name, preventFileDropIfUIElement);
          dom.bind(editorRoot, name, preventFileDrop);
        });
        editor.on('remove', function () {
          each$k(eventNames, function (name) {
            pageDom.unbind(doc, name, preventFileDropIfUIElement);
            dom.unbind(editorRoot, name, preventFileDrop);
          });
        });
      };
      editor.on('init', function () {
        Delay.setEditorTimeout(editor, setup, 0);
      });
    };
    var init$2 = function (editor) {
      bindFakeDragEvents(editor);
      blockIeDrop(editor);
      if (shouldBlockUnsupportedDrop(editor)) {
        blockUnsupportedFileDrop(editor);
      }
    };

    var setup$1 = function (editor) {
      var renderFocusCaret = first(function () {
        if (!editor.removed && editor.getBody().contains(document.activeElement)) {
          var rng = editor.selection.getRng();
          if (rng.collapsed) {
            var caretRange = renderRangeCaret(editor, rng, false);
            editor.selection.setRng(caretRange);
          }
        }
      }, 0);
      editor.on('focus', function () {
        renderFocusCaret.throttle();
      });
      editor.on('blur', function () {
        renderFocusCaret.cancel();
      });
    };

    var setup = function (editor) {
      editor.on('init', function () {
        editor.on('focusin', function (e) {
          var target = e.target;
          if (isMedia$2(target)) {
            var ceRoot = getContentEditableRoot$1(editor.getBody(), target);
            var node = isContentEditableFalse$b(ceRoot) ? ceRoot : target;
            if (editor.selection.getNode() !== node) {
              selectNode(editor, node).each(function (rng) {
                return editor.selection.setRng(rng);
              });
            }
          }
        });
      });
    };

    var isContentEditableTrue = isContentEditableTrue$4;
    var isContentEditableFalse = isContentEditableFalse$b;
    var getContentEditableRoot = function (editor, node) {
      return getContentEditableRoot$1(editor.getBody(), node);
    };
    var SelectionOverrides = function (editor) {
      var selection = editor.selection, dom = editor.dom;
      var isBlock = dom.isBlock;
      var rootNode = editor.getBody();
      var fakeCaret = FakeCaret(editor, rootNode, isBlock, function () {
        return hasFocus(editor);
      });
      var realSelectionId = 'sel-' + dom.uniqueId();
      var elementSelectionAttr = 'data-mce-selected';
      var selectedElement;
      var isFakeSelectionElement = function (node) {
        return dom.hasClass(node, 'mce-offscreen-selection');
      };
      var isFakeSelectionTargetElement = function (node) {
        return node !== rootNode && (isContentEditableFalse(node) || isMedia$2(node)) && dom.isChildOf(node, rootNode);
      };
      var isNearFakeSelectionElement = function (pos) {
        return isBeforeContentEditableFalse(pos) || isAfterContentEditableFalse(pos) || isBeforeMedia(pos) || isAfterMedia(pos);
      };
      var getRealSelectionElement = function () {
        var container = dom.get(realSelectionId);
        return container ? container.getElementsByTagName('*')[0] : container;
      };
      var setRange = function (range) {
        if (range) {
          selection.setRng(range);
        }
      };
      var getRange = selection.getRng;
      var showCaret = function (direction, node, before, scrollIntoView) {
        if (scrollIntoView === void 0) {
          scrollIntoView = true;
        }
        var e = editor.fire('ShowCaret', {
          target: node,
          direction: direction,
          before: before
        });
        if (e.isDefaultPrevented()) {
          return null;
        }
        if (scrollIntoView) {
          selection.scrollIntoView(node, direction === -1);
        }
        return fakeCaret.show(before, node);
      };
      var showBlockCaretContainer = function (blockCaretContainer) {
        if (blockCaretContainer.hasAttribute('data-mce-caret')) {
          showCaretContainerBlock(blockCaretContainer);
          setRange(getRange());
          selection.scrollIntoView(blockCaretContainer);
        }
      };
      var registerEvents = function () {
        editor.on('mouseup', function (e) {
          var range = getRange();
          if (range.collapsed && isXYInContentArea(editor, e.clientX, e.clientY)) {
            renderCaretAtRange(editor, range, false).each(setRange);
          }
        });
        editor.on('click', function (e) {
          var contentEditableRoot = getContentEditableRoot(editor, e.target);
          if (contentEditableRoot) {
            if (isContentEditableFalse(contentEditableRoot)) {
              e.preventDefault();
              editor.focus();
            }
            if (isContentEditableTrue(contentEditableRoot)) {
              if (dom.isChildOf(contentEditableRoot, selection.getNode())) {
                removeElementSelection();
              }
            }
          }
        });
        editor.on('blur NewBlock', removeElementSelection);
        editor.on('ResizeWindow FullscreenStateChanged', fakeCaret.reposition);
        var hasNormalCaretPosition = function (elm) {
          var start = elm.firstChild;
          if (isNullable(start)) {
            return false;
          }
          var startPos = CaretPosition.before(start);
          if (isBr$5(startPos.getNode()) && elm.childNodes.length === 1) {
            return !isNearFakeSelectionElement(startPos);
          } else {
            var caretWalker = CaretWalker(elm);
            var newPos = caretWalker.next(startPos);
            return newPos && !isNearFakeSelectionElement(newPos);
          }
        };
        var isInSameBlock = function (node1, node2) {
          var block1 = dom.getParent(node1, isBlock);
          var block2 = dom.getParent(node2, isBlock);
          return block1 === block2;
        };
        var hasBetterMouseTarget = function (targetNode, caretNode) {
          var targetBlock = dom.getParent(targetNode, isBlock);
          var caretBlock = dom.getParent(caretNode, isBlock);
          if (isNullable(targetBlock)) {
            return false;
          }
          if (targetNode !== caretBlock && dom.isChildOf(targetBlock, caretBlock) && isContentEditableFalse(getContentEditableRoot(editor, targetBlock)) === false) {
            return true;
          }
          return !dom.isChildOf(caretBlock, targetBlock) && !isInSameBlock(targetBlock, caretBlock) && hasNormalCaretPosition(targetBlock);
        };
        editor.on('tap', function (e) {
          var targetElm = e.target;
          var contentEditableRoot = getContentEditableRoot(editor, targetElm);
          if (isContentEditableFalse(contentEditableRoot)) {
            e.preventDefault();
            selectNode(editor, contentEditableRoot).each(setElementSelection);
          } else if (isFakeSelectionTargetElement(targetElm)) {
            selectNode(editor, targetElm).each(setElementSelection);
          }
        }, true);
        editor.on('mousedown', function (e) {
          var targetElm = e.target;
          if (targetElm !== rootNode && targetElm.nodeName !== 'HTML' && !dom.isChildOf(targetElm, rootNode)) {
            return;
          }
          if (isXYInContentArea(editor, e.clientX, e.clientY) === false) {
            return;
          }
          var contentEditableRoot = getContentEditableRoot(editor, targetElm);
          if (contentEditableRoot) {
            if (isContentEditableFalse(contentEditableRoot)) {
              e.preventDefault();
              selectNode(editor, contentEditableRoot).each(setElementSelection);
            } else {
              removeElementSelection();
              if (!(isContentEditableTrue(contentEditableRoot) && e.shiftKey) && !isXYWithinRange(e.clientX, e.clientY, selection.getRng())) {
                hideFakeCaret();
                selection.placeCaretAt(e.clientX, e.clientY);
              }
            }
          } else if (isFakeSelectionTargetElement(targetElm)) {
            selectNode(editor, targetElm).each(setElementSelection);
          } else if (isFakeCaretTarget(targetElm) === false) {
            removeElementSelection();
            hideFakeCaret();
            var fakeCaretInfo = closestFakeCaret(rootNode, e.clientX, e.clientY);
            if (fakeCaretInfo) {
              if (!hasBetterMouseTarget(targetElm, fakeCaretInfo.node)) {
                e.preventDefault();
                var range = showCaret(1, fakeCaretInfo.node, fakeCaretInfo.before, false);
                setRange(range);
                editor.getBody().focus();
              }
            }
          }
        });
        editor.on('keypress', function (e) {
          if (VK.modifierPressed(e)) {
            return;
          }
          if (isContentEditableFalse(selection.getNode())) {
            e.preventDefault();
          }
        });
        editor.on('GetSelectionRange', function (e) {
          var rng = e.range;
          if (selectedElement) {
            if (!selectedElement.parentNode) {
              selectedElement = null;
              return;
            }
            rng = rng.cloneRange();
            rng.selectNode(selectedElement);
            e.range = rng;
          }
        });
        editor.on('SetSelectionRange', function (e) {
          e.range = normalizeShortEndedElementSelection(e.range);
          var rng = setElementSelection(e.range, e.forward);
          if (rng) {
            e.range = rng;
          }
        });
        var isPasteBin = function (node) {
          return node.id === 'mcepastebin';
        };
        editor.on('AfterSetSelectionRange', function (e) {
          var rng = e.range;
          var parentNode = rng.startContainer.parentNode;
          if (!isRangeInCaretContainer(rng) && !isPasteBin(parentNode)) {
            hideFakeCaret();
          }
          if (!isFakeSelectionElement(parentNode)) {
            removeElementSelection();
          }
        });
        editor.on('copy', function (e) {
          var clipboardData = e.clipboardData;
          if (!e.isDefaultPrevented() && e.clipboardData && !Env.ie) {
            var realSelectionElement = getRealSelectionElement();
            if (realSelectionElement) {
              e.preventDefault();
              clipboardData.clearData();
              clipboardData.setData('text/html', realSelectionElement.outerHTML);
              clipboardData.setData('text/plain', realSelectionElement.outerText || realSelectionElement.innerText);
            }
          }
        });
        init$2(editor);
        setup$1(editor);
        setup(editor);
      };
      var isWithinCaretContainer = function (node) {
        return isCaretContainer$2(node) || startsWithCaretContainer$1(node) || endsWithCaretContainer$1(node);
      };
      var isRangeInCaretContainer = function (rng) {
        return isWithinCaretContainer(rng.startContainer) || isWithinCaretContainer(rng.endContainer);
      };
      var normalizeShortEndedElementSelection = function (rng) {
        var shortEndedElements = editor.schema.getShortEndedElements();
        var newRng = dom.createRng();
        var startContainer = rng.startContainer;
        var startOffset = rng.startOffset;
        var endContainer = rng.endContainer;
        var endOffset = rng.endOffset;
        if (has$2(shortEndedElements, startContainer.nodeName.toLowerCase())) {
          if (startOffset === 0) {
            newRng.setStartBefore(startContainer);
          } else {
            newRng.setStartAfter(startContainer);
          }
        } else {
          newRng.setStart(startContainer, startOffset);
        }
        if (has$2(shortEndedElements, endContainer.nodeName.toLowerCase())) {
          if (endOffset === 0) {
            newRng.setEndBefore(endContainer);
          } else {
            newRng.setEndAfter(endContainer);
          }
        } else {
          newRng.setEnd(endContainer, endOffset);
        }
        return newRng;
      };
      var setupOffscreenSelection = function (node, targetClone, origTargetClone) {
        var $ = editor.$;
        var $realSelectionContainer = descendant(SugarElement.fromDom(editor.getBody()), '#' + realSelectionId).fold(function () {
          return $([]);
        }, function (elm) {
          return $([elm.dom]);
        });
        if ($realSelectionContainer.length === 0) {
          $realSelectionContainer = $('<div data-mce-bogus="all" class="mce-offscreen-selection"></div>').attr('id', realSelectionId);
          $realSelectionContainer.appendTo(editor.getBody());
        }
        var newRange = dom.createRng();
        if (targetClone === origTargetClone && Env.ie) {
          $realSelectionContainer.empty().append('<p style="font-size: 0" data-mce-bogus="all">\xA0</p>').append(targetClone);
          newRange.setStartAfter($realSelectionContainer[0].firstChild.firstChild);
          newRange.setEndAfter(targetClone);
        } else {
          $realSelectionContainer.empty().append(nbsp).append(targetClone).append(nbsp);
          newRange.setStart($realSelectionContainer[0].firstChild, 1);
          newRange.setEnd($realSelectionContainer[0].lastChild, 0);
        }
        $realSelectionContainer.css({ top: dom.getPos(node, editor.getBody()).y });
        $realSelectionContainer[0].focus();
        var sel = selection.getSel();
        sel.removeAllRanges();
        sel.addRange(newRange);
        return newRange;
      };
      var selectElement = function (elm) {
        var targetClone = elm.cloneNode(true);
        var e = editor.fire('ObjectSelected', {
          target: elm,
          targetClone: targetClone
        });
        if (e.isDefaultPrevented()) {
          return null;
        }
        var range = setupOffscreenSelection(elm, e.targetClone, targetClone);
        var nodeElm = SugarElement.fromDom(elm);
        each$k(descendants(SugarElement.fromDom(editor.getBody()), '*[data-mce-selected]'), function (elm) {
          if (!eq(nodeElm, elm)) {
            remove$6(elm, elementSelectionAttr);
          }
        });
        if (!dom.getAttrib(elm, elementSelectionAttr)) {
          elm.setAttribute(elementSelectionAttr, '1');
        }
        selectedElement = elm;
        hideFakeCaret();
        return range;
      };
      var setElementSelection = function (range, forward) {
        if (!range) {
          return null;
        }
        if (range.collapsed) {
          if (!isRangeInCaretContainer(range)) {
            var dir = forward ? 1 : -1;
            var caretPosition = getNormalizedRangeEndPoint(dir, rootNode, range);
            var beforeNode = caretPosition.getNode(!forward);
            if (isFakeCaretTarget(beforeNode)) {
              return showCaret(dir, beforeNode, forward ? !caretPosition.isAtEnd() : false, false);
            }
            var afterNode = caretPosition.getNode(forward);
            if (isFakeCaretTarget(afterNode)) {
              return showCaret(dir, afterNode, forward ? false : !caretPosition.isAtEnd(), false);
            }
          }
          return null;
        }
        var startContainer = range.startContainer;
        var startOffset = range.startOffset;
        var endOffset = range.endOffset;
        if (startContainer.nodeType === 3 && startOffset === 0 && isContentEditableFalse(startContainer.parentNode)) {
          startContainer = startContainer.parentNode;
          startOffset = dom.nodeIndex(startContainer);
          startContainer = startContainer.parentNode;
        }
        if (startContainer.nodeType !== 1) {
          return null;
        }
        if (endOffset === startOffset + 1 && startContainer === range.endContainer) {
          var node = startContainer.childNodes[startOffset];
          if (isFakeSelectionTargetElement(node)) {
            return selectElement(node);
          }
        }
        return null;
      };
      var removeElementSelection = function () {
        if (selectedElement) {
          selectedElement.removeAttribute(elementSelectionAttr);
        }
        descendant(SugarElement.fromDom(editor.getBody()), '#' + realSelectionId).each(remove$7);
        selectedElement = null;
      };
      var destroy = function () {
        fakeCaret.destroy();
        selectedElement = null;
      };
      var hideFakeCaret = function () {
        fakeCaret.hide();
      };
      if (Env.ceFalse && !isRtc(editor)) {
        registerEvents();
      }
      return {
        showCaret: showCaret,
        showBlockCaretContainer: showBlockCaretContainer,
        hideFakeCaret: hideFakeCaret,
        destroy: destroy
      };
    };

    var Quirks = function (editor) {
      var each = Tools.each;
      var BACKSPACE = VK.BACKSPACE, DELETE = VK.DELETE, dom = editor.dom, selection = editor.selection, parser = editor.parser;
      var isGecko = Env.gecko, isIE = Env.ie, isWebKit = Env.webkit;
      var mceInternalUrlPrefix = 'data:text/mce-internal,';
      var mceInternalDataType = isIE ? 'Text' : 'URL';
      var setEditorCommandState = function (cmd, state) {
        try {
          editor.getDoc().execCommand(cmd, false, state);
        } catch (ex) {
        }
      };
      var isDefaultPrevented = function (e) {
        return e.isDefaultPrevented();
      };
      var setMceInternalContent = function (e) {
        var selectionHtml, internalContent;
        if (e.dataTransfer) {
          if (editor.selection.isCollapsed() && e.target.tagName === 'IMG') {
            selection.select(e.target);
          }
          selectionHtml = editor.selection.getContent();
          if (selectionHtml.length > 0) {
            internalContent = mceInternalUrlPrefix + escape(editor.id) + ',' + escape(selectionHtml);
            e.dataTransfer.setData(mceInternalDataType, internalContent);
          }
        }
      };
      var getMceInternalContent = function (e) {
        var internalContent;
        if (e.dataTransfer) {
          internalContent = e.dataTransfer.getData(mceInternalDataType);
          if (internalContent && internalContent.indexOf(mceInternalUrlPrefix) >= 0) {
            internalContent = internalContent.substr(mceInternalUrlPrefix.length).split(',');
            return {
              id: unescape(internalContent[0]),
              html: unescape(internalContent[1])
            };
          }
        }
        return null;
      };
      var insertClipboardContents = function (content, internal) {
        if (editor.queryCommandSupported('mceInsertClipboardContent')) {
          editor.execCommand('mceInsertClipboardContent', false, {
            content: content,
            internal: internal
          });
        } else {
          editor.execCommand('mceInsertContent', false, content);
        }
      };
      var emptyEditorWhenDeleting = function () {
        var serializeRng = function (rng) {
          var body = dom.create('body');
          var contents = rng.cloneContents();
          body.appendChild(contents);
          return selection.serializer.serialize(body, { format: 'html' });
        };
        var allContentsSelected = function (rng) {
          var selection = serializeRng(rng);
          var allRng = dom.createRng();
          allRng.selectNode(editor.getBody());
          var allSelection = serializeRng(allRng);
          return selection === allSelection;
        };
        editor.on('keydown', function (e) {
          var keyCode = e.keyCode;
          var isCollapsed, body;
          if (!isDefaultPrevented(e) && (keyCode === DELETE || keyCode === BACKSPACE)) {
            isCollapsed = editor.selection.isCollapsed();
            body = editor.getBody();
            if (isCollapsed && !dom.isEmpty(body)) {
              return;
            }
            if (!isCollapsed && !allContentsSelected(editor.selection.getRng())) {
              return;
            }
            e.preventDefault();
            editor.setContent('');
            if (body.firstChild && dom.isBlock(body.firstChild)) {
              editor.selection.setCursorLocation(body.firstChild, 0);
            } else {
              editor.selection.setCursorLocation(body, 0);
            }
            editor.nodeChanged();
          }
        });
      };
      var selectAll = function () {
        editor.shortcuts.add('meta+a', null, 'SelectAll');
      };
      var documentElementEditingFocus = function () {
        if (!editor.inline) {
          dom.bind(editor.getDoc(), 'mousedown mouseup', function (e) {
            var rng;
            if (e.target === editor.getDoc().documentElement) {
              rng = selection.getRng();
              editor.getBody().focus();
              if (e.type === 'mousedown') {
                if (isCaretContainer$2(rng.startContainer)) {
                  return;
                }
                selection.placeCaretAt(e.clientX, e.clientY);
              } else {
                selection.setRng(rng);
              }
            }
          });
        }
      };
      var removeHrOnBackspace = function () {
        editor.on('keydown', function (e) {
          if (!isDefaultPrevented(e) && e.keyCode === BACKSPACE) {
            if (!editor.getBody().getElementsByTagName('hr').length) {
              return;
            }
            if (selection.isCollapsed() && selection.getRng().startOffset === 0) {
              var node = selection.getNode();
              var previousSibling = node.previousSibling;
              if (node.nodeName === 'HR') {
                dom.remove(node);
                e.preventDefault();
                return;
              }
              if (previousSibling && previousSibling.nodeName && previousSibling.nodeName.toLowerCase() === 'hr') {
                dom.remove(previousSibling);
                e.preventDefault();
              }
            }
          }
        });
      };
      var focusBody = function () {
        if (!Range.prototype.getClientRects) {
          editor.on('mousedown', function (e) {
            if (!isDefaultPrevented(e) && e.target.nodeName === 'HTML') {
              var body_1 = editor.getBody();
              body_1.blur();
              Delay.setEditorTimeout(editor, function () {
                body_1.focus();
              });
            }
          });
        }
      };
      var selectControlElements = function () {
        editor.on('click', function (e) {
          var target = e.target;
          if (/^(IMG|HR)$/.test(target.nodeName) && dom.getContentEditableParent(target) !== 'false') {
            e.preventDefault();
            editor.selection.select(target);
            editor.nodeChanged();
          }
          if (target.nodeName === 'A' && dom.hasClass(target, 'mce-item-anchor')) {
            e.preventDefault();
            selection.select(target);
          }
        });
      };
      var removeStylesWhenDeletingAcrossBlockElements = function () {
        var getAttributeApplyFunction = function () {
          var template = dom.getAttribs(selection.getStart().cloneNode(false));
          return function () {
            var target = selection.getStart();
            if (target !== editor.getBody()) {
              dom.setAttrib(target, 'style', null);
              each(template, function (attr) {
                target.setAttributeNode(attr.cloneNode(true));
              });
            }
          };
        };
        var isSelectionAcrossElements = function () {
          return !selection.isCollapsed() && dom.getParent(selection.getStart(), dom.isBlock) !== dom.getParent(selection.getEnd(), dom.isBlock);
        };
        editor.on('keypress', function (e) {
          var applyAttributes;
          if (!isDefaultPrevented(e) && (e.keyCode === 8 || e.keyCode === 46) && isSelectionAcrossElements()) {
            applyAttributes = getAttributeApplyFunction();
            editor.getDoc().execCommand('delete', false, null);
            applyAttributes();
            e.preventDefault();
            return false;
          }
        });
        dom.bind(editor.getDoc(), 'cut', function (e) {
          var applyAttributes;
          if (!isDefaultPrevented(e) && isSelectionAcrossElements()) {
            applyAttributes = getAttributeApplyFunction();
            Delay.setEditorTimeout(editor, function () {
              applyAttributes();
            });
          }
        });
      };
      var disableBackspaceIntoATable = function () {
        editor.on('keydown', function (e) {
          if (!isDefaultPrevented(e) && e.keyCode === BACKSPACE) {
            if (selection.isCollapsed() && selection.getRng().startOffset === 0) {
              var previousSibling = selection.getNode().previousSibling;
              if (previousSibling && previousSibling.nodeName && previousSibling.nodeName.toLowerCase() === 'table') {
                e.preventDefault();
                return false;
              }
            }
          }
        });
      };
      var removeBlockQuoteOnBackSpace = function () {
        editor.on('keydown', function (e) {
          var rng, parent;
          if (isDefaultPrevented(e) || e.keyCode !== VK.BACKSPACE) {
            return;
          }
          rng = selection.getRng();
          var container = rng.startContainer;
          var offset = rng.startOffset;
          var root = dom.getRoot();
          parent = container;
          if (!rng.collapsed || offset !== 0) {
            return;
          }
          while (parent && parent.parentNode && parent.parentNode.firstChild === parent && parent.parentNode !== root) {
            parent = parent.parentNode;
          }
          if (parent.tagName === 'BLOCKQUOTE') {
            editor.formatter.toggle('blockquote', null, parent);
            rng = dom.createRng();
            rng.setStart(container, 0);
            rng.setEnd(container, 0);
            selection.setRng(rng);
          }
        });
      };
      var setGeckoEditingOptions = function () {
        var setOpts = function () {
          setEditorCommandState('StyleWithCSS', false);
          setEditorCommandState('enableInlineTableEditing', false);
          if (!getObjectResizing(editor)) {
            setEditorCommandState('enableObjectResizing', false);
          }
        };
        if (!isReadOnly$1(editor)) {
          editor.on('BeforeExecCommand mousedown', setOpts);
        }
      };
      var addBrAfterLastLinks = function () {
        var fixLinks = function () {
          each(dom.select('a'), function (node) {
            var parentNode = node.parentNode;
            var root = dom.getRoot();
            if (parentNode.lastChild === node) {
              while (parentNode && !dom.isBlock(parentNode)) {
                if (parentNode.parentNode.lastChild !== parentNode || parentNode === root) {
                  return;
                }
                parentNode = parentNode.parentNode;
              }
              dom.add(parentNode, 'br', { 'data-mce-bogus': 1 });
            }
          });
        };
        editor.on('SetContent ExecCommand', function (e) {
          if (e.type === 'setcontent' || e.command === 'mceInsertLink') {
            fixLinks();
          }
        });
      };
      var setDefaultBlockType = function () {
        if (getForcedRootBlock(editor)) {
          editor.on('init', function () {
            setEditorCommandState('DefaultParagraphSeparator', getForcedRootBlock(editor));
          });
        }
      };
      var normalizeSelection = function () {
        editor.on('keyup focusin mouseup', function (e) {
          if (!VK.modifierPressed(e)) {
            selection.normalize();
          }
        }, true);
      };
      var showBrokenImageIcon = function () {
        editor.contentStyles.push('img:-moz-broken {' + '-moz-force-broken-image-icon:1;' + 'min-width:24px;' + 'min-height:24px' + '}');
      };
      var restoreFocusOnKeyDown = function () {
        if (!editor.inline) {
          editor.on('keydown', function () {
            if (document.activeElement === document.body) {
              editor.getWin().focus();
            }
          });
        }
      };
      var bodyHeight = function () {
        if (!editor.inline) {
          editor.contentStyles.push('body {min-height: 150px}');
          editor.on('click', function (e) {
            var rng;
            if (e.target.nodeName === 'HTML') {
              if (Env.ie > 11) {
                editor.getBody().focus();
                return;
              }
              rng = editor.selection.getRng();
              editor.getBody().focus();
              editor.selection.setRng(rng);
              editor.selection.normalize();
              editor.nodeChanged();
            }
          });
        }
      };
      var blockCmdArrowNavigation = function () {
        if (Env.mac) {
          editor.on('keydown', function (e) {
            if (VK.metaKeyPressed(e) && !e.shiftKey && (e.keyCode === 37 || e.keyCode === 39)) {
              e.preventDefault();
              var selection_1 = editor.selection.getSel();
              selection_1.modify('move', e.keyCode === 37 ? 'backward' : 'forward', 'lineboundary');
            }
          });
        }
      };
      var disableAutoUrlDetect = function () {
        setEditorCommandState('AutoUrlDetect', false);
      };
      var tapLinksAndImages = function () {
        editor.on('click', function (e) {
          var elm = e.target;
          do {
            if (elm.tagName === 'A') {
              e.preventDefault();
              return;
            }
          } while (elm = elm.parentNode);
        });
        editor.contentStyles.push('.mce-content-body {-webkit-touch-callout: none}');
      };
      var blockFormSubmitInsideEditor = function () {
        editor.on('init', function () {
          editor.dom.bind(editor.getBody(), 'submit', function (e) {
            e.preventDefault();
          });
        });
      };
      var removeAppleInterchangeBrs = function () {
        parser.addNodeFilter('br', function (nodes) {
          var i = nodes.length;
          while (i--) {
            if (nodes[i].attr('class') === 'Apple-interchange-newline') {
              nodes[i].remove();
            }
          }
        });
      };
      var ieInternalDragAndDrop = function () {
        editor.on('dragstart', function (e) {
          setMceInternalContent(e);
        });
        editor.on('drop', function (e) {
          if (!isDefaultPrevented(e)) {
            var internalContent = getMceInternalContent(e);
            if (internalContent && internalContent.id !== editor.id) {
              e.preventDefault();
              var rng = fromPoint(e.x, e.y, editor.getDoc());
              selection.setRng(rng);
              insertClipboardContents(internalContent.html, true);
            }
          }
        });
      };
      var refreshContentEditable = noop;
      var isHidden = function () {
        if (!isGecko || editor.removed) {
          return false;
        }
        var sel = editor.selection.getSel();
        return !sel || !sel.rangeCount || sel.rangeCount === 0;
      };
      var setupRtc = function () {
        if (isWebKit) {
          documentElementEditingFocus();
          selectControlElements();
          blockFormSubmitInsideEditor();
          selectAll();
          if (Env.iOS) {
            restoreFocusOnKeyDown();
            bodyHeight();
            tapLinksAndImages();
          }
        }
        if (isGecko) {
          focusBody();
          setGeckoEditingOptions();
          showBrokenImageIcon();
          blockCmdArrowNavigation();
        }
      };
      var setup = function () {
        removeBlockQuoteOnBackSpace();
        emptyEditorWhenDeleting();
        if (!Env.windowsPhone) {
          normalizeSelection();
        }
        if (isWebKit) {
          documentElementEditingFocus();
          selectControlElements();
          setDefaultBlockType();
          blockFormSubmitInsideEditor();
          disableBackspaceIntoATable();
          removeAppleInterchangeBrs();
          if (Env.iOS) {
            restoreFocusOnKeyDown();
            bodyHeight();
            tapLinksAndImages();
          } else {
            selectAll();
          }
        }
        if (Env.ie >= 11) {
          bodyHeight();
          disableBackspaceIntoATable();
        }
        if (Env.ie) {
          selectAll();
          disableAutoUrlDetect();
          ieInternalDragAndDrop();
        }
        if (isGecko) {
          removeHrOnBackspace();
          focusBody();
          removeStylesWhenDeletingAcrossBlockElements();
          setGeckoEditingOptions();
          addBrAfterLastLinks();
          showBrokenImageIcon();
          blockCmdArrowNavigation();
          disableBackspaceIntoATable();
        }
      };
      if (isRtc(editor)) {
        setupRtc();
      } else {
        setup();
      }
      return {
        refreshContentEditable: refreshContentEditable,
        isHidden: isHidden
      };
    };

    var DOM$6 = DOMUtils.DOM;
    var appendStyle = function (editor, text) {
      var body = SugarElement.fromDom(editor.getBody());
      var container = getStyleContainer(getRootNode(body));
      var style = SugarElement.fromTag('style');
      set$1(style, 'type', 'text/css');
      append$1(style, SugarElement.fromText(text));
      append$1(container, style);
      editor.on('remove', function () {
        remove$7(style);
      });
    };
    var getRootName = function (editor) {
      return editor.inline ? editor.getElement().nodeName.toLowerCase() : undefined;
    };
    var removeUndefined = function (obj) {
      return filter$3(obj, function (v) {
        return isUndefined(v) === false;
      });
    };
    var mkSchemaSettings = function (editor) {
      var settings = editor.settings;
      return removeUndefined({
        block_elements: settings.block_elements,
        boolean_attributes: settings.boolean_attributes,
        custom_elements: settings.custom_elements,
        extended_valid_elements: settings.extended_valid_elements,
        invalid_elements: settings.invalid_elements,
        invalid_styles: settings.invalid_styles,
        move_caret_before_on_enter_elements: settings.move_caret_before_on_enter_elements,
        non_empty_elements: settings.non_empty_elements,
        schema: settings.schema,
        self_closing_elements: settings.self_closing_elements,
        short_ended_elements: settings.short_ended_elements,
        special: settings.special,
        text_block_elements: settings.text_block_elements,
        text_inline_elements: settings.text_inline_elements,
        valid_children: settings.valid_children,
        valid_classes: settings.valid_classes,
        valid_elements: settings.valid_elements,
        valid_styles: settings.valid_styles,
        verify_html: settings.verify_html,
        whitespace_elements: settings.whitespace_elements,
        padd_empty_block_inline_children: settings.format_empty_lines
      });
    };
    var mkParserSettings = function (editor) {
      var settings = editor.settings;
      var blobCache = editor.editorUpload.blobCache;
      return removeUndefined({
        allow_conditional_comments: settings.allow_conditional_comments,
        allow_html_data_urls: settings.allow_html_data_urls,
        allow_svg_data_urls: settings.allow_svg_data_urls,
        allow_html_in_named_anchor: settings.allow_html_in_named_anchor,
        allow_script_urls: settings.allow_script_urls,
        allow_unsafe_link_target: settings.allow_unsafe_link_target,
        convert_fonts_to_spans: settings.convert_fonts_to_spans,
        fix_list_elements: settings.fix_list_elements,
        font_size_legacy_values: settings.font_size_legacy_values,
        forced_root_block: settings.forced_root_block,
        forced_root_block_attrs: settings.forced_root_block_attrs,
        padd_empty_with_br: settings.padd_empty_with_br,
        preserve_cdata: settings.preserve_cdata,
        remove_trailing_brs: settings.remove_trailing_brs,
        inline_styles: settings.inline_styles,
        root_name: getRootName(editor),
        validate: true,
        blob_cache: blobCache,
        document: editor.getDoc(),
        images_dataimg_filter: settings.images_dataimg_filter
      });
    };
    var mkSerializerSettings = function (editor) {
      var settings = editor.settings;
      return __assign(__assign(__assign({}, mkParserSettings(editor)), mkSchemaSettings(editor)), removeUndefined({
        url_converter: settings.url_converter,
        url_converter_scope: settings.url_converter_scope,
        element_format: settings.element_format,
        entities: settings.entities,
        entity_encoding: settings.entity_encoding,
        indent: settings.indent,
        indent_after: settings.indent_after,
        indent_before: settings.indent_before
      }));
    };
    var createParser = function (editor) {
      var parser = DomParser(mkParserSettings(editor), editor.schema);
      parser.addAttributeFilter('src,href,style,tabindex', function (nodes, name) {
        var i = nodes.length, node, value;
        var dom = editor.dom;
        var internalName = 'data-mce-' + name;
        while (i--) {
          node = nodes[i];
          value = node.attr(name);
          if (value && !node.attr(internalName)) {
            if (value.indexOf('data:') === 0 || value.indexOf('blob:') === 0) {
              continue;
            }
            if (name === 'style') {
              value = dom.serializeStyle(dom.parseStyle(value), node.name);
              if (!value.length) {
                value = null;
              }
              node.attr(internalName, value);
              node.attr(name, value);
            } else if (name === 'tabindex') {
              node.attr(internalName, value);
              node.attr(name, null);
            } else {
              node.attr(internalName, editor.convertURL(value, name, node.name));
            }
          }
        }
      });
      parser.addNodeFilter('script', function (nodes) {
        var i = nodes.length;
        while (i--) {
          var node = nodes[i];
          var type = node.attr('type') || 'no/type';
          if (type.indexOf('mce-') !== 0) {
            node.attr('type', 'mce-' + type);
          }
        }
      });
      if (editor.settings.preserve_cdata) {
        parser.addNodeFilter('#cdata', function (nodes) {
          var i = nodes.length;
          while (i--) {
            var node = nodes[i];
            node.type = 8;
            node.name = '#comment';
            node.value = '[CDATA[' + editor.dom.encode(node.value) + ']]';
          }
        });
      }
      parser.addNodeFilter('p,h1,h2,h3,h4,h5,h6,div', function (nodes) {
        var i = nodes.length;
        var nonEmptyElements = editor.schema.getNonEmptyElements();
        while (i--) {
          var node = nodes[i];
          if (node.isEmpty(nonEmptyElements) && node.getAll('br').length === 0) {
            node.append(new AstNode('br', 1)).shortEnded = true;
          }
        }
      });
      return parser;
    };
    var autoFocus = function (editor) {
      if (editor.settings.auto_focus) {
        Delay.setEditorTimeout(editor, function () {
          var focusEditor;
          if (editor.settings.auto_focus === true) {
            focusEditor = editor;
          } else {
            focusEditor = editor.editorManager.get(editor.settings.auto_focus);
          }
          if (!focusEditor.destroyed) {
            focusEditor.focus();
          }
        }, 100);
      }
    };
    var moveSelectionToFirstCaretPosition = function (editor) {
      var root = editor.dom.getRoot();
      if (!editor.inline && (!hasAnyRanges(editor) || editor.selection.getStart(true) === root)) {
        firstPositionIn(root).each(function (pos) {
          var node = pos.getNode();
          var caretPos = isTable$3(node) ? firstPositionIn(node).getOr(pos) : pos;
          if (Env.browser.isIE()) {
            storeNative(editor, caretPos.toRange());
          } else {
            editor.selection.setRng(caretPos.toRange());
          }
        });
      }
    };
    var initEditor = function (editor) {
      editor.bindPendingEventDelegates();
      editor.initialized = true;
      fireInit(editor);
      editor.focus(true);
      moveSelectionToFirstCaretPosition(editor);
      editor.nodeChanged({ initial: true });
      editor.execCallback('init_instance_callback', editor);
      autoFocus(editor);
    };
    var getStyleSheetLoader$1 = function (editor) {
      return editor.inline ? editor.ui.styleSheetLoader : editor.dom.styleSheetLoader;
    };
    var makeStylesheetLoadingPromises = function (editor, css, framedFonts) {
      var promises = [new promiseObj(function (resolve, reject) {
          return getStyleSheetLoader$1(editor).loadAll(css, resolve, reject);
        })];
      if (editor.inline) {
        return promises;
      } else {
        return promises.concat([new promiseObj(function (resolve, reject) {
            return editor.ui.styleSheetLoader.loadAll(framedFonts, resolve, reject);
          })]);
      }
    };
    var loadContentCss = function (editor) {
      var styleSheetLoader = getStyleSheetLoader$1(editor);
      var fontCss = getFontCss(editor);
      var css = editor.contentCSS;
      var removeCss = function () {
        styleSheetLoader.unloadAll(css);
        if (!editor.inline) {
          editor.ui.styleSheetLoader.unloadAll(fontCss);
        }
      };
      var loaded = function () {
        if (editor.removed) {
          removeCss();
        } else {
          editor.on('remove', removeCss);
        }
      };
      if (editor.contentStyles.length > 0) {
        var contentCssText_1 = '';
        Tools.each(editor.contentStyles, function (style) {
          contentCssText_1 += style + '\r\n';
        });
        editor.dom.addStyle(contentCssText_1);
      }
      var allStylesheets = promiseObj.all(makeStylesheetLoadingPromises(editor, css, fontCss)).then(loaded).catch(loaded);
      if (editor.settings.content_style) {
        appendStyle(editor, editor.settings.content_style);
      }
      return allStylesheets;
    };
    var preInit = function (editor) {
      var settings = editor.settings, doc = editor.getDoc(), body = editor.getBody();
      firePreInit(editor);
      if (!settings.browser_spellcheck && !settings.gecko_spellcheck) {
        doc.body.spellcheck = false;
        DOM$6.setAttrib(body, 'spellcheck', 'false');
      }
      editor.quirks = Quirks(editor);
      firePostRender(editor);
      var directionality = getDirectionality(editor);
      if (directionality !== undefined) {
        body.dir = directionality;
      }
      if (settings.protect) {
        editor.on('BeforeSetContent', function (e) {
          Tools.each(settings.protect, function (pattern) {
            e.content = e.content.replace(pattern, function (str) {
              return '<!--mce:protected ' + escape(str) + '-->';
            });
          });
        });
      }
      editor.on('SetContent', function () {
        editor.addVisual(editor.getBody());
      });
      editor.on('compositionstart compositionend', function (e) {
        editor.composing = e.type === 'compositionstart';
      });
    };
    var loadInitialContent = function (editor) {
      if (!isRtc(editor)) {
        editor.load({
          initial: true,
          format: 'html'
        });
      }
      editor.startContent = editor.getContent({ format: 'raw' });
    };
    var initEditorWithInitialContent = function (editor) {
      if (editor.removed !== true) {
        loadInitialContent(editor);
        initEditor(editor);
      }
    };
    var initContentBody = function (editor, skipWrite) {
      var settings = editor.settings;
      var targetElm = editor.getElement();
      var doc = editor.getDoc();
      if (!settings.inline) {
        editor.getElement().style.visibility = editor.orgVisibility;
      }
      if (!skipWrite && !editor.inline) {
        doc.open();
        doc.write(editor.iframeHTML);
        doc.close();
      }
      if (editor.inline) {
        DOM$6.addClass(targetElm, 'mce-content-body');
        editor.contentDocument = doc = document;
        editor.contentWindow = window;
        editor.bodyElement = targetElm;
        editor.contentAreaContainer = targetElm;
      }
      var body = editor.getBody();
      body.disabled = true;
      editor.readonly = !!settings.readonly;
      if (!editor.readonly) {
        if (editor.inline && DOM$6.getStyle(body, 'position', true) === 'static') {
          body.style.position = 'relative';
        }
        body.contentEditable = editor.getParam('content_editable_state', true);
      }
      body.disabled = false;
      editor.editorUpload = EditorUpload(editor);
      editor.schema = Schema(mkSchemaSettings(editor));
      editor.dom = DOMUtils(doc, {
        keep_values: true,
        url_converter: editor.convertURL,
        url_converter_scope: editor,
        hex_colors: settings.force_hex_style_colors,
        update_styles: true,
        root_element: editor.inline ? editor.getBody() : null,
        collect: function () {
          return editor.inline;
        },
        schema: editor.schema,
        contentCssCors: shouldUseContentCssCors(editor),
        referrerPolicy: getReferrerPolicy(editor),
        onSetAttrib: function (e) {
          editor.fire('SetAttrib', e);
        }
      });
      editor.parser = createParser(editor);
      editor.serializer = DomSerializer(mkSerializerSettings(editor), editor);
      editor.selection = EditorSelection(editor.dom, editor.getWin(), editor.serializer, editor);
      editor.annotator = Annotator(editor);
      editor.formatter = Formatter(editor);
      editor.undoManager = UndoManager(editor);
      editor._nodeChangeDispatcher = new NodeChange(editor);
      editor._selectionOverrides = SelectionOverrides(editor);
      setup$e(editor);
      setup$3(editor);
      if (!isRtc(editor)) {
        setup$2(editor);
      }
      var caret = setup$4(editor);
      setup$f(editor, caret);
      setup$d(editor);
      setup$g(editor);
      var setupRtcThunk = setup$i(editor);
      preInit(editor);
      setupRtcThunk.fold(function () {
        loadContentCss(editor).then(function () {
          return initEditorWithInitialContent(editor);
        });
      }, function (setupRtc) {
        editor.setProgressState(true);
        loadContentCss(editor).then(function () {
          setupRtc().then(function (_rtcMode) {
            editor.setProgressState(false);
            initEditorWithInitialContent(editor);
          }, function (err) {
            editor.notificationManager.open({
              type: 'error',
              text: String(err)
            });
            initEditorWithInitialContent(editor);
          });
        });
      });
    };

    var DOM$5 = DOMUtils.DOM;
    var relaxDomain = function (editor, ifr) {
      if (document.domain !== window.location.hostname && Env.browser.isIE()) {
        var bodyUuid = uuid('mce');
        editor[bodyUuid] = function () {
          initContentBody(editor);
        };
        var domainRelaxUrl = 'javascript:(function(){' + 'document.open();document.domain="' + document.domain + '";' + 'var ed = window.parent.tinymce.get("' + editor.id + '");document.write(ed.iframeHTML);' + 'document.close();ed.' + bodyUuid + '(true);})()';
        DOM$5.setAttrib(ifr, 'src', domainRelaxUrl);
        return true;
      }
      return false;
    };
    var createIframeElement = function (id, title, height, customAttrs) {
      var iframe = SugarElement.fromTag('iframe');
      setAll$1(iframe, customAttrs);
      setAll$1(iframe, {
        id: id + '_ifr',
        frameBorder: '0',
        allowTransparency: 'true',
        title: title
      });
      add$1(iframe, 'tox-edit-area__iframe');
      return iframe;
    };
    var getIframeHtml = function (editor) {
      var iframeHTML = getDocType(editor) + '<html><head>';
      if (getDocumentBaseUrl(editor) !== editor.documentBaseUrl) {
        iframeHTML += '<base href="' + editor.documentBaseURI.getURI() + '" />';
      }
      iframeHTML += '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />';
      var bodyId = getBodyId(editor);
      var bodyClass = getBodyClass(editor);
      var translatedAriaText = editor.translate(getIframeAriaText(editor));
      if (getContentSecurityPolicy(editor)) {
        iframeHTML += '<meta http-equiv="Content-Security-Policy" content="' + getContentSecurityPolicy(editor) + '" />';
      }
      iframeHTML += '</head>' + ('<body id="' + bodyId + '" class="mce-content-body ' + bodyClass + '" data-id="' + editor.id + '" aria-label="' + translatedAriaText + '">') + '<br>' + '</body></html>';
      return iframeHTML;
    };
    var createIframe = function (editor, o) {
      var iframeTitle = editor.translate('Rich Text Area');
      var ifr = createIframeElement(editor.id, iframeTitle, o.height, getIframeAttrs(editor)).dom;
      ifr.onload = function () {
        ifr.onload = null;
        editor.fire('load');
      };
      var isDomainRelaxed = relaxDomain(editor, ifr);
      editor.contentAreaContainer = o.iframeContainer;
      editor.iframeElement = ifr;
      editor.iframeHTML = getIframeHtml(editor);
      DOM$5.add(o.iframeContainer, ifr);
      return isDomainRelaxed;
    };
    var init$1 = function (editor, boxInfo) {
      var isDomainRelaxed = createIframe(editor, boxInfo);
      if (boxInfo.editorContainer) {
        DOM$5.get(boxInfo.editorContainer).style.display = editor.orgDisplay;
        editor.hidden = DOM$5.isHidden(boxInfo.editorContainer);
      }
      editor.getElement().style.display = 'none';
      DOM$5.setAttrib(editor.id, 'aria-hidden', 'true');
      if (!isDomainRelaxed) {
        initContentBody(editor);
      }
    };

    var DOM$4 = DOMUtils.DOM;
    var initPlugin = function (editor, initializedPlugins, plugin) {
      var Plugin = PluginManager.get(plugin);
      var pluginUrl = PluginManager.urls[plugin] || editor.documentBaseUrl.replace(/\/$/, '');
      plugin = Tools.trim(plugin);
      if (Plugin && Tools.inArray(initializedPlugins, plugin) === -1) {
        Tools.each(PluginManager.dependencies(plugin), function (dep) {
          initPlugin(editor, initializedPlugins, dep);
        });
        if (editor.plugins[plugin]) {
          return;
        }
        try {
          var pluginInstance = new Plugin(editor, pluginUrl, editor.$);
          editor.plugins[plugin] = pluginInstance;
          if (pluginInstance.init) {
            pluginInstance.init(editor, pluginUrl);
            initializedPlugins.push(plugin);
          }
        } catch (e) {
          pluginInitError(editor, plugin, e);
        }
      }
    };
    var trimLegacyPrefix = function (name) {
      return name.replace(/^\-/, '');
    };
    var initPlugins = function (editor) {
      var initializedPlugins = [];
      Tools.each(getPlugins(editor).split(/[ ,]/), function (name) {
        initPlugin(editor, initializedPlugins, trimLegacyPrefix(name));
      });
    };
    var initIcons = function (editor) {
      var iconPackName = Tools.trim(getIconPackName(editor));
      var currentIcons = editor.ui.registry.getAll().icons;
      var loadIcons = __assign(__assign({}, IconManager.get('default').icons), IconManager.get(iconPackName).icons);
      each$j(loadIcons, function (svgData, icon) {
        if (!has$2(currentIcons, icon)) {
          editor.ui.registry.addIcon(icon, svgData);
        }
      });
    };
    var initTheme = function (editor) {
      var theme = getTheme(editor);
      if (isString$1(theme)) {
        editor.settings.theme = trimLegacyPrefix(theme);
        var Theme = ThemeManager.get(theme);
        editor.theme = new Theme(editor, ThemeManager.urls[theme]);
        if (editor.theme.init) {
          editor.theme.init(editor, ThemeManager.urls[theme] || editor.documentBaseUrl.replace(/\/$/, ''), editor.$);
        }
      } else {
        editor.theme = {};
      }
    };
    var renderFromLoadedTheme = function (editor) {
      return editor.theme.renderUI();
    };
    var renderFromThemeFunc = function (editor) {
      var elm = editor.getElement();
      var theme = getTheme(editor);
      var info = theme(editor, elm);
      if (info.editorContainer.nodeType) {
        info.editorContainer.id = info.editorContainer.id || editor.id + '_parent';
      }
      if (info.iframeContainer && info.iframeContainer.nodeType) {
        info.iframeContainer.id = info.iframeContainer.id || editor.id + '_iframecontainer';
      }
      info.height = info.iframeHeight ? info.iframeHeight : elm.offsetHeight;
      return info;
    };
    var createThemeFalseResult = function (element) {
      return {
        editorContainer: element,
        iframeContainer: element,
        api: {}
      };
    };
    var renderThemeFalseIframe = function (targetElement) {
      var iframeContainer = DOM$4.create('div');
      DOM$4.insertAfter(iframeContainer, targetElement);
      return createThemeFalseResult(iframeContainer);
    };
    var renderThemeFalse = function (editor) {
      var targetElement = editor.getElement();
      return editor.inline ? createThemeFalseResult(null) : renderThemeFalseIframe(targetElement);
    };
    var renderThemeUi = function (editor) {
      var elm = editor.getElement();
      editor.orgDisplay = elm.style.display;
      if (isString$1(getTheme(editor))) {
        return renderFromLoadedTheme(editor);
      } else if (isFunction(getTheme(editor))) {
        return renderFromThemeFunc(editor);
      } else {
        return renderThemeFalse(editor);
      }
    };
    var augmentEditorUiApi = function (editor, api) {
      var uiApiFacade = {
        show: Optional.from(api.show).getOr(noop),
        hide: Optional.from(api.hide).getOr(noop),
        disable: Optional.from(api.disable).getOr(noop),
        isDisabled: Optional.from(api.isDisabled).getOr(never),
        enable: function () {
          if (!editor.mode.isReadOnly()) {
            Optional.from(api.enable).map(call);
          }
        }
      };
      editor.ui = __assign(__assign({}, editor.ui), uiApiFacade);
    };
    var init = function (editor) {
      editor.fire('ScriptsLoaded');
      initIcons(editor);
      initTheme(editor);
      initPlugins(editor);
      var renderInfo = renderThemeUi(editor);
      augmentEditorUiApi(editor, Optional.from(renderInfo.api).getOr({}));
      var boxInfo = {
        editorContainer: renderInfo.editorContainer,
        iframeContainer: renderInfo.iframeContainer
      };
      editor.editorContainer = boxInfo.editorContainer ? boxInfo.editorContainer : null;
      appendContentCssFromSettings(editor);
      if (editor.inline) {
        return initContentBody(editor);
      } else {
        return init$1(editor, boxInfo);
      }
    };

    var DOM$3 = DOMUtils.DOM;
    var hasSkipLoadPrefix = function (name) {
      return name.charAt(0) === '-';
    };
    var loadLanguage = function (scriptLoader, editor) {
      var languageCode = getLanguageCode(editor);
      var languageUrl = getLanguageUrl(editor);
      if (I18n.hasCode(languageCode) === false && languageCode !== 'en') {
        var url_1 = languageUrl !== '' ? languageUrl : editor.editorManager.baseURL + '/langs/' + languageCode + '.js';
        scriptLoader.add(url_1, noop, undefined, function () {
          languageLoadError(editor, url_1, languageCode);
        });
      }
    };
    var loadTheme = function (scriptLoader, editor, suffix, callback) {
      var theme = getTheme(editor);
      if (isString$1(theme)) {
        if (!hasSkipLoadPrefix(theme) && !has$2(ThemeManager.urls, theme)) {
          var themeUrl = getThemeUrl(editor);
          if (themeUrl) {
            ThemeManager.load(theme, editor.documentBaseURI.toAbsolute(themeUrl));
          } else {
            ThemeManager.load(theme, 'themes/' + theme + '/theme' + suffix + '.js');
          }
        }
        scriptLoader.loadQueue(function () {
          ThemeManager.waitFor(theme, callback);
        });
      } else {
        callback();
      }
    };
    var getIconsUrlMetaFromUrl = function (editor) {
      return Optional.from(getIconsUrl(editor)).filter(function (url) {
        return url.length > 0;
      }).map(function (url) {
        return {
          url: url,
          name: Optional.none()
        };
      });
    };
    var getIconsUrlMetaFromName = function (editor, name, suffix) {
      return Optional.from(name).filter(function (name) {
        return name.length > 0 && !IconManager.has(name);
      }).map(function (name) {
        return {
          url: editor.editorManager.baseURL + '/icons/' + name + '/icons' + suffix + '.js',
          name: Optional.some(name)
        };
      });
    };
    var loadIcons = function (scriptLoader, editor, suffix) {
      var defaultIconsUrl = getIconsUrlMetaFromName(editor, 'default', suffix);
      var customIconsUrl = getIconsUrlMetaFromUrl(editor).orThunk(function () {
        return getIconsUrlMetaFromName(editor, getIconPackName(editor), '');
      });
      each$k(cat([
        defaultIconsUrl,
        customIconsUrl
      ]), function (urlMeta) {
        scriptLoader.add(urlMeta.url, noop, undefined, function () {
          iconsLoadError(editor, urlMeta.url, urlMeta.name.getOrUndefined());
        });
      });
    };
    var loadPlugins = function (editor, suffix) {
      Tools.each(getExternalPlugins$1(editor), function (url, name) {
        PluginManager.load(name, url, noop, undefined, function () {
          pluginLoadError(editor, url, name);
        });
        editor.settings.plugins += ' ' + name;
      });
      Tools.each(getPlugins(editor).split(/[ ,]/), function (plugin) {
        plugin = Tools.trim(plugin);
        if (plugin && !PluginManager.urls[plugin]) {
          if (hasSkipLoadPrefix(plugin)) {
            plugin = plugin.substr(1, plugin.length);
            var dependencies = PluginManager.dependencies(plugin);
            Tools.each(dependencies, function (depPlugin) {
              var defaultSettings = {
                prefix: 'plugins/',
                resource: depPlugin,
                suffix: '/plugin' + suffix + '.js'
              };
              var dep = PluginManager.createUrl(defaultSettings, depPlugin);
              PluginManager.load(dep.resource, dep, noop, undefined, function () {
                pluginLoadError(editor, dep.prefix + dep.resource + dep.suffix, dep.resource);
              });
            });
          } else {
            var url_2 = {
              prefix: 'plugins/',
              resource: plugin,
              suffix: '/plugin' + suffix + '.js'
            };
            PluginManager.load(plugin, url_2, noop, undefined, function () {
              pluginLoadError(editor, url_2.prefix + url_2.resource + url_2.suffix, plugin);
            });
          }
        }
      });
    };
    var loadScripts = function (editor, suffix) {
      var scriptLoader = ScriptLoader.ScriptLoader;
      loadTheme(scriptLoader, editor, suffix, function () {
        loadLanguage(scriptLoader, editor);
        loadIcons(scriptLoader, editor, suffix);
        loadPlugins(editor, suffix);
        scriptLoader.loadQueue(function () {
          if (!editor.removed) {
            init(editor);
          }
        }, editor, function () {
          if (!editor.removed) {
            init(editor);
          }
        });
      });
    };
    var getStyleSheetLoader = function (element, editor) {
      return instance.forElement(element, {
        contentCssCors: hasContentCssCors(editor),
        referrerPolicy: getReferrerPolicy(editor)
      });
    };
    var render = function (editor) {
      var id = editor.id;
      I18n.setCode(getLanguageCode(editor));
      var readyHandler = function () {
        DOM$3.unbind(window, 'ready', readyHandler);
        editor.render();
      };
      if (!EventUtils.Event.domLoaded) {
        DOM$3.bind(window, 'ready', readyHandler);
        return;
      }
      if (!editor.getElement()) {
        return;
      }
      if (!Env.contentEditable) {
        return;
      }
      var element = SugarElement.fromDom(editor.getElement());
      var snapshot = clone$3(element);
      editor.on('remove', function () {
        eachr(element.dom.attributes, function (attr) {
          return remove$6(element, attr.name);
        });
        setAll$1(element, snapshot);
      });
      editor.ui.styleSheetLoader = getStyleSheetLoader(element, editor);
      if (!isInline(editor)) {
        editor.orgVisibility = editor.getElement().style.visibility;
        editor.getElement().style.visibility = 'hidden';
      } else {
        editor.inline = true;
      }
      var form = editor.getElement().form || DOM$3.getParent(id, 'form');
      if (form) {
        editor.formElement = form;
        if (hasHiddenInput(editor) && !isTextareaOrInput(editor.getElement())) {
          DOM$3.insertAfter(DOM$3.create('input', {
            type: 'hidden',
            name: id
          }), id);
          editor.hasHiddenInput = true;
        }
        editor.formEventDelegate = function (e) {
          editor.fire(e.type, e);
        };
        DOM$3.bind(form, 'submit reset', editor.formEventDelegate);
        editor.on('reset', function () {
          editor.resetContent();
        });
        if (shouldPatchSubmit(editor) && !form.submit.nodeType && !form.submit.length && !form._mceOldSubmit) {
          form._mceOldSubmit = form.submit;
          form.submit = function () {
            editor.editorManager.triggerSave();
            editor.setDirty(false);
            return form._mceOldSubmit(form);
          };
        }
      }
      editor.windowManager = WindowManager(editor);
      editor.notificationManager = NotificationManager(editor);
      if (isEncodingXml(editor)) {
        editor.on('GetContent', function (e) {
          if (e.save) {
            e.content = DOM$3.encode(e.content);
          }
        });
      }
      if (shouldAddFormSubmitTrigger(editor)) {
        editor.on('submit', function () {
          if (editor.initialized) {
            editor.save();
          }
        });
      }
      if (shouldAddUnloadTrigger(editor)) {
        editor._beforeUnload = function () {
          if (editor.initialized && !editor.destroyed && !editor.isHidden()) {
            editor.save({
              format: 'raw',
              no_events: true,
              set_dirty: false
            });
          }
        };
        editor.editorManager.on('BeforeUnload', editor._beforeUnload);
      }
      editor.editorManager.add(editor);
      loadScripts(editor, editor.suffix);
    };

    var addVisual = function (editor, elm) {
      return addVisual$1(editor, elm);
    };

    var legacyPropNames = {
      'font-size': 'size',
      'font-family': 'face'
    };
    var getSpecifiedFontProp = function (propName, rootElm, elm) {
      var getProperty = function (elm) {
        return getRaw(elm, propName).orThunk(function () {
          if (name(elm) === 'font') {
            return get$9(legacyPropNames, propName).bind(function (legacyPropName) {
              return getOpt(elm, legacyPropName);
            });
          } else {
            return Optional.none();
          }
        });
      };
      var isRoot = function (elm) {
        return eq(SugarElement.fromDom(rootElm), elm);
      };
      return closest$1(SugarElement.fromDom(elm), function (elm) {
        return getProperty(elm);
      }, isRoot);
    };
    var normalizeFontFamily = function (fontFamily) {
      return fontFamily.replace(/[\'\"\\]/g, '').replace(/,\s+/g, ',');
    };
    var getComputedFontProp = function (propName, elm) {
      return Optional.from(DOMUtils.DOM.getStyle(elm, propName, true));
    };
    var getFontProp = function (propName) {
      return function (rootElm, elm) {
        return Optional.from(elm).map(SugarElement.fromDom).filter(isElement$6).bind(function (element) {
          return getSpecifiedFontProp(propName, rootElm, element.dom).or(getComputedFontProp(propName, element.dom));
        }).getOr('');
      };
    };
    var getFontSize = getFontProp('font-size');
    var getFontFamily = compose(normalizeFontFamily, getFontProp('font-family'));

    var findFirstCaretElement = function (editor) {
      return firstPositionIn(editor.getBody()).map(function (caret) {
        var container = caret.container();
        return isText$7(container) ? container.parentNode : container;
      });
    };
    var getCaretElement = function (editor) {
      return Optional.from(editor.selection.getRng()).bind(function (rng) {
        var root = editor.getBody();
        var atStartOfNode = rng.startContainer === root && rng.startOffset === 0;
        return atStartOfNode ? Optional.none() : Optional.from(editor.selection.getStart(true));
      });
    };
    var bindRange = function (editor, binder) {
      return getCaretElement(editor).orThunk(curry(findFirstCaretElement, editor)).map(SugarElement.fromDom).filter(isElement$6).bind(binder);
    };
    var mapRange = function (editor, mapper) {
      return bindRange(editor, compose1(Optional.some, mapper));
    };

    var fromFontSizeNumber = function (editor, value) {
      if (/^[0-9.]+$/.test(value)) {
        var fontSizeNumber = parseInt(value, 10);
        if (fontSizeNumber >= 1 && fontSizeNumber <= 7) {
          var fontSizes = getFontStyleValues(editor);
          var fontClasses = getFontSizeClasses(editor);
          if (fontClasses) {
            return fontClasses[fontSizeNumber - 1] || value;
          } else {
            return fontSizes[fontSizeNumber - 1] || value;
          }
        } else {
          return value;
        }
      } else {
        return value;
      }
    };
    var normalizeFontNames = function (font) {
      var fonts = font.split(/\s*,\s*/);
      return map$3(fonts, function (font) {
        if (font.indexOf(' ') !== -1 && !(startsWith(font, '"') || startsWith(font, '\''))) {
          return '\'' + font + '\'';
        } else {
          return font;
        }
      }).join(',');
    };
    var fontNameAction = function (editor, value) {
      var font = fromFontSizeNumber(editor, value);
      editor.formatter.toggle('fontname', { value: normalizeFontNames(font) });
      editor.nodeChanged();
    };
    var fontNameQuery = function (editor) {
      return mapRange(editor, function (elm) {
        return getFontFamily(editor.getBody(), elm.dom);
      }).getOr('');
    };
    var fontSizeAction = function (editor, value) {
      editor.formatter.toggle('fontsize', { value: fromFontSizeNumber(editor, value) });
      editor.nodeChanged();
    };
    var fontSizeQuery = function (editor) {
      return mapRange(editor, function (elm) {
        return getFontSize(editor.getBody(), elm.dom);
      }).getOr('');
    };

    var lineHeightQuery = function (editor) {
      return mapRange(editor, function (elm) {
        var root = SugarElement.fromDom(editor.getBody());
        var specifiedStyle = closest$1(elm, function (elm) {
          return getRaw(elm, 'line-height');
        }, curry(eq, root));
        var computedStyle = function () {
          var lineHeight = parseFloat(get$5(elm, 'line-height'));
          var fontSize = parseFloat(get$5(elm, 'font-size'));
          return String(lineHeight / fontSize);
        };
        return specifiedStyle.getOrThunk(computedStyle);
      }).getOr('');
    };
    var lineHeightAction = function (editor, lineHeight) {
      editor.formatter.toggle('lineheight', { value: String(lineHeight) });
      editor.nodeChanged();
    };

    var processValue = function (value) {
      if (typeof value !== 'string') {
        var details = Tools.extend({
          paste: value.paste,
          data: { paste: value.paste }
        }, value);
        return {
          content: value.content,
          details: details
        };
      }
      return {
        content: value,
        details: {}
      };
    };
    var insertAtCaret = function (editor, value) {
      var result = processValue(value);
      insertContent(editor, result.content, result.details);
    };

    var each$4 = Tools.each;
    var map = Tools.map, inArray = Tools.inArray;
    var EditorCommands = function () {
      function EditorCommands(editor) {
        this.commands = {
          state: {},
          exec: {},
          value: {}
        };
        this.editor = editor;
        this.setupCommands(editor);
      }
      EditorCommands.prototype.execCommand = function (command, ui, value, args) {
        var func, state = false;
        var self = this;
        if (self.editor.removed) {
          return;
        }
        if (command.toLowerCase() !== 'mcefocus') {
          if (!/^(mceAddUndoLevel|mceEndUndoLevel|mceBeginUndoLevel|mceRepaint)$/.test(command) && (!args || !args.skip_focus)) {
            self.editor.focus();
          } else {
            restore(self.editor);
          }
        }
        args = self.editor.fire('BeforeExecCommand', {
          command: command,
          ui: ui,
          value: value
        });
        if (args.isDefaultPrevented()) {
          return false;
        }
        var customCommand = command.toLowerCase();
        if (func = self.commands.exec[customCommand]) {
          func(customCommand, ui, value);
          self.editor.fire('ExecCommand', {
            command: command,
            ui: ui,
            value: value
          });
          return true;
        }
        each$4(this.editor.plugins, function (p) {
          if (p.execCommand && p.execCommand(command, ui, value)) {
            self.editor.fire('ExecCommand', {
              command: command,
              ui: ui,
              value: value
            });
            state = true;
            return false;
          }
        });
        if (state) {
          return state;
        }
        if (self.editor.theme && self.editor.theme.execCommand && self.editor.theme.execCommand(command, ui, value)) {
          self.editor.fire('ExecCommand', {
            command: command,
            ui: ui,
            value: value
          });
          return true;
        }
        try {
          state = self.editor.getDoc().execCommand(command, ui, value);
        } catch (ex) {
        }
        if (state) {
          self.editor.fire('ExecCommand', {
            command: command,
            ui: ui,
            value: value
          });
          return true;
        }
        return false;
      };
      EditorCommands.prototype.queryCommandState = function (command) {
        var func;
        if (this.editor.quirks.isHidden() || this.editor.removed) {
          return;
        }
        command = command.toLowerCase();
        if (func = this.commands.state[command]) {
          return func(command);
        }
        try {
          return this.editor.getDoc().queryCommandState(command);
        } catch (ex) {
        }
        return false;
      };
      EditorCommands.prototype.queryCommandValue = function (command) {
        var func;
        if (this.editor.quirks.isHidden() || this.editor.removed) {
          return;
        }
        command = command.toLowerCase();
        if (func = this.commands.value[command]) {
          return func(command);
        }
        try {
          return this.editor.getDoc().queryCommandValue(command);
        } catch (ex) {
        }
      };
      EditorCommands.prototype.addCommands = function (commandList, type) {
        if (type === void 0) {
          type = 'exec';
        }
        var self = this;
        each$4(commandList, function (callback, command) {
          each$4(command.toLowerCase().split(','), function (command) {
            self.commands[type][command] = callback;
          });
        });
      };
      EditorCommands.prototype.addCommand = function (command, callback, scope) {
        var _this = this;
        command = command.toLowerCase();
        this.commands.exec[command] = function (command, ui, value, args) {
          return callback.call(scope || _this.editor, ui, value, args);
        };
      };
      EditorCommands.prototype.queryCommandSupported = function (command) {
        command = command.toLowerCase();
        if (this.commands.exec[command]) {
          return true;
        }
        try {
          return this.editor.getDoc().queryCommandSupported(command);
        } catch (ex) {
        }
        return false;
      };
      EditorCommands.prototype.addQueryStateHandler = function (command, callback, scope) {
        var _this = this;
        command = command.toLowerCase();
        this.commands.state[command] = function () {
          return callback.call(scope || _this.editor);
        };
      };
      EditorCommands.prototype.addQueryValueHandler = function (command, callback, scope) {
        var _this = this;
        command = command.toLowerCase();
        this.commands.value[command] = function () {
          return callback.call(scope || _this.editor);
        };
      };
      EditorCommands.prototype.hasCustomCommand = function (command) {
        command = command.toLowerCase();
        return !!this.commands.exec[command];
      };
      EditorCommands.prototype.execNativeCommand = function (command, ui, value) {
        if (ui === undefined) {
          ui = false;
        }
        if (value === undefined) {
          value = null;
        }
        return this.editor.getDoc().execCommand(command, ui, value);
      };
      EditorCommands.prototype.isFormatMatch = function (name) {
        return this.editor.formatter.match(name);
      };
      EditorCommands.prototype.toggleFormat = function (name, value) {
        this.editor.formatter.toggle(name, value);
        this.editor.nodeChanged();
      };
      EditorCommands.prototype.storeSelection = function (type) {
        this.selectionBookmark = this.editor.selection.getBookmark(type);
      };
      EditorCommands.prototype.restoreSelection = function () {
        this.editor.selection.moveToBookmark(this.selectionBookmark);
      };
      EditorCommands.prototype.setupCommands = function (editor) {
        var self = this;
        this.addCommands({
          'mceResetDesignMode,mceBeginUndoLevel': noop,
          'mceEndUndoLevel,mceAddUndoLevel': function () {
            editor.undoManager.add();
          },
          'mceFocus': function (_command, _ui, value) {
            focus(editor, value);
          },
          'Cut,Copy,Paste': function (command) {
            var doc = editor.getDoc();
            var failed;
            try {
              self.execNativeCommand(command);
            } catch (ex) {
              failed = true;
            }
            if (command === 'paste' && !doc.queryCommandEnabled(command)) {
              failed = true;
            }
            if (failed || !doc.queryCommandSupported(command)) {
              var msg = editor.translate('Your browser doesn\'t support direct access to the clipboard. ' + 'Please use the Ctrl+X/C/V keyboard shortcuts instead.');
              if (Env.mac) {
                msg = msg.replace(/Ctrl\+/g, '\u2318+');
              }
              editor.notificationManager.open({
                text: msg,
                type: 'error'
              });
            }
          },
          'unlink': function () {
            if (editor.selection.isCollapsed()) {
              var elm = editor.dom.getParent(editor.selection.getStart(), 'a');
              if (elm) {
                editor.dom.remove(elm, true);
              }
              return;
            }
            editor.formatter.remove('link');
          },
          'JustifyLeft,JustifyCenter,JustifyRight,JustifyFull,JustifyNone': function (command) {
            var align = command.substring(7);
            if (align === 'full') {
              align = 'justify';
            }
            each$4('left,center,right,justify'.split(','), function (name) {
              if (align !== name) {
                editor.formatter.remove('align' + name);
              }
            });
            if (align !== 'none') {
              self.toggleFormat('align' + align);
            }
          },
          'InsertUnorderedList,InsertOrderedList': function (command) {
            var listParent;
            self.execNativeCommand(command);
            var listElm = editor.dom.getParent(editor.selection.getNode(), 'ol,ul');
            if (listElm) {
              listParent = listElm.parentNode;
              if (/^(H[1-6]|P|ADDRESS|PRE)$/.test(listParent.nodeName)) {
                self.storeSelection();
                editor.dom.split(listParent, listElm);
                self.restoreSelection();
              }
            }
          },
          'Bold,Italic,Underline,Strikethrough,Superscript,Subscript': function (command) {
            self.toggleFormat(command);
          },
          'ForeColor,HiliteColor': function (command, ui, value) {
            self.toggleFormat(command, { value: value });
          },
          'FontName': function (command, ui, value) {
            fontNameAction(editor, value);
          },
          'FontSize': function (command, ui, value) {
            fontSizeAction(editor, value);
          },
          'LineHeight': function (command, ui, value) {
            lineHeightAction(editor, value);
          },
          'Lang': function (command, ui, lang) {
            self.toggleFormat(command, {
              value: lang.code,
              customValue: lang.customCode
            });
          },
          'RemoveFormat': function (command) {
            editor.formatter.remove(command);
          },
          'mceBlockQuote': function () {
            self.toggleFormat('blockquote');
          },
          'FormatBlock': function (command, ui, value) {
            return self.toggleFormat(value || 'p');
          },
          'mceCleanup': function () {
            var bookmark = editor.selection.getBookmark();
            editor.setContent(editor.getContent());
            editor.selection.moveToBookmark(bookmark);
          },
          'mceRemoveNode': function (command, ui, value) {
            var node = value || editor.selection.getNode();
            if (node !== editor.getBody()) {
              self.storeSelection();
              editor.dom.remove(node, true);
              self.restoreSelection();
            }
          },
          'mceSelectNodeDepth': function (command, ui, value) {
            var counter = 0;
            editor.dom.getParent(editor.selection.getNode(), function (node) {
              if (node.nodeType === 1 && counter++ === value) {
                editor.selection.select(node);
                return false;
              }
            }, editor.getBody());
          },
          'mceSelectNode': function (command, ui, value) {
            editor.selection.select(value);
          },
          'mceInsertContent': function (command, ui, value) {
            insertAtCaret(editor, value);
          },
          'mceInsertRawHTML': function (command, ui, value) {
            editor.selection.setContent('tiny_mce_marker');
            var content = editor.getContent();
            editor.setContent(content.replace(/tiny_mce_marker/g, function () {
              return value;
            }));
          },
          'mceInsertNewLine': function (command, ui, value) {
            insert(editor, value);
          },
          'mceToggleFormat': function (command, ui, value) {
            self.toggleFormat(value);
          },
          'mceSetContent': function (command, ui, value) {
            editor.setContent(value);
          },
          'Indent,Outdent': function (command) {
            handle(editor, command);
          },
          'mceRepaint': noop,
          'InsertHorizontalRule': function () {
            editor.execCommand('mceInsertContent', false, '<hr />');
          },
          'mceToggleVisualAid': function () {
            editor.hasVisual = !editor.hasVisual;
            editor.addVisual();
          },
          'mceReplaceContent': function (command, ui, value) {
            editor.execCommand('mceInsertContent', false, value.replace(/\{\$selection\}/g, editor.selection.getContent({ format: 'text' })));
          },
          'mceInsertLink': function (command, ui, value) {
            if (typeof value === 'string') {
              value = { href: value };
            }
            var anchor = editor.dom.getParent(editor.selection.getNode(), 'a');
            value.href = value.href.replace(/ /g, '%20');
            if (!anchor || !value.href) {
              editor.formatter.remove('link');
            }
            if (value.href) {
              editor.formatter.apply('link', value, anchor);
            }
          },
          'selectAll': function () {
            var editingHost = editor.dom.getParent(editor.selection.getStart(), isContentEditableTrue$4);
            if (editingHost) {
              var rng = editor.dom.createRng();
              rng.selectNodeContents(editingHost);
              editor.selection.setRng(rng);
            }
          },
          'mceNewDocument': function () {
            editor.setContent('');
          },
          'InsertLineBreak': function (command, ui, value) {
            insert$1(editor, value);
            return true;
          }
        });
        var alignStates = function (name) {
          return function () {
            var selection = editor.selection;
            var nodes = selection.isCollapsed() ? [editor.dom.getParent(selection.getNode(), editor.dom.isBlock)] : selection.getSelectedBlocks();
            var matches = map(nodes, function (node) {
              return !!editor.formatter.matchNode(node, name);
            });
            return inArray(matches, true) !== -1;
          };
        };
        self.addCommands({
          'JustifyLeft': alignStates('alignleft'),
          'JustifyCenter': alignStates('aligncenter'),
          'JustifyRight': alignStates('alignright'),
          'JustifyFull': alignStates('alignjustify'),
          'Bold,Italic,Underline,Strikethrough,Superscript,Subscript': function (command) {
            return self.isFormatMatch(command);
          },
          'mceBlockQuote': function () {
            return self.isFormatMatch('blockquote');
          },
          'Outdent': function () {
            return canOutdent(editor);
          },
          'InsertUnorderedList,InsertOrderedList': function (command) {
            var list = editor.dom.getParent(editor.selection.getNode(), 'ul,ol');
            return list && (command === 'insertunorderedlist' && list.tagName === 'UL' || command === 'insertorderedlist' && list.tagName === 'OL');
          }
        }, 'state');
        self.addCommands({
          Undo: function () {
            editor.undoManager.undo();
          },
          Redo: function () {
            editor.undoManager.redo();
          }
        });
        self.addQueryValueHandler('FontName', function () {
          return fontNameQuery(editor);
        }, this);
        self.addQueryValueHandler('FontSize', function () {
          return fontSizeQuery(editor);
        }, this);
        self.addQueryValueHandler('LineHeight', function () {
          return lineHeightQuery(editor);
        }, this);
      };
      return EditorCommands;
    }();

    var internalContentEditableAttr = 'data-mce-contenteditable';
    var toggleClass = function (elm, cls, state) {
      if (has(elm, cls) && state === false) {
        remove$3(elm, cls);
      } else if (state) {
        add$1(elm, cls);
      }
    };
    var setEditorCommandState = function (editor, cmd, state) {
      try {
        editor.getDoc().execCommand(cmd, false, String(state));
      } catch (ex) {
      }
    };
    var setContentEditable = function (elm, state) {
      elm.dom.contentEditable = state ? 'true' : 'false';
    };
    var switchOffContentEditableTrue = function (elm) {
      each$k(descendants(elm, '*[contenteditable="true"]'), function (elm) {
        set$1(elm, internalContentEditableAttr, 'true');
        setContentEditable(elm, false);
      });
    };
    var switchOnContentEditableTrue = function (elm) {
      each$k(descendants(elm, '*[' + internalContentEditableAttr + '="true"]'), function (elm) {
        remove$6(elm, internalContentEditableAttr);
        setContentEditable(elm, true);
      });
    };
    var removeFakeSelection = function (editor) {
      Optional.from(editor.selection.getNode()).each(function (elm) {
        elm.removeAttribute('data-mce-selected');
      });
    };
    var restoreFakeSelection = function (editor) {
      editor.selection.setRng(editor.selection.getRng());
    };
    var toggleReadOnly = function (editor, state) {
      var body = SugarElement.fromDom(editor.getBody());
      toggleClass(body, 'mce-content-readonly', state);
      if (state) {
        editor.selection.controlSelection.hideResizeRect();
        editor._selectionOverrides.hideFakeCaret();
        removeFakeSelection(editor);
        editor.readonly = true;
        setContentEditable(body, false);
        switchOffContentEditableTrue(body);
      } else {
        editor.readonly = false;
        setContentEditable(body, true);
        switchOnContentEditableTrue(body);
        setEditorCommandState(editor, 'StyleWithCSS', false);
        setEditorCommandState(editor, 'enableInlineTableEditing', false);
        setEditorCommandState(editor, 'enableObjectResizing', false);
        if (hasEditorOrUiFocus(editor)) {
          editor.focus();
        }
        restoreFakeSelection(editor);
        editor.nodeChanged();
      }
    };
    var isReadOnly = function (editor) {
      return editor.readonly;
    };
    var registerFilters = function (editor) {
      editor.parser.addAttributeFilter('contenteditable', function (nodes) {
        if (isReadOnly(editor)) {
          each$k(nodes, function (node) {
            node.attr(internalContentEditableAttr, node.attr('contenteditable'));
            node.attr('contenteditable', 'false');
          });
        }
      });
      editor.serializer.addAttributeFilter(internalContentEditableAttr, function (nodes) {
        if (isReadOnly(editor)) {
          each$k(nodes, function (node) {
            node.attr('contenteditable', node.attr(internalContentEditableAttr));
          });
        }
      });
      editor.serializer.addTempAttr(internalContentEditableAttr);
    };
    var registerReadOnlyContentFilters = function (editor) {
      if (editor.serializer) {
        registerFilters(editor);
      } else {
        editor.on('PreInit', function () {
          registerFilters(editor);
        });
      }
    };
    var isClickEvent = function (e) {
      return e.type === 'click';
    };
    var getAnchorHrefOpt = function (editor, elm) {
      var isRoot = function (elm) {
        return eq(elm, SugarElement.fromDom(editor.getBody()));
      };
      return closest$2(elm, 'a', isRoot).bind(function (a) {
        return getOpt(a, 'href');
      });
    };
    var processReadonlyEvents = function (editor, e) {
      if (isClickEvent(e) && !VK.metaKeyPressed(e)) {
        var elm = SugarElement.fromDom(e.target);
        getAnchorHrefOpt(editor, elm).each(function (href) {
          e.preventDefault();
          if (/^#/.test(href)) {
            var targetEl = editor.dom.select(href + ',[name="' + removeLeading(href, '#') + '"]');
            if (targetEl.length) {
              editor.selection.scrollIntoView(targetEl[0], true);
            }
          } else {
            window.open(href, '_blank', 'rel=noopener noreferrer,menubar=yes,toolbar=yes,location=yes,status=yes,resizable=yes,scrollbars=yes');
          }
        });
      }
    };
    var registerReadOnlySelectionBlockers = function (editor) {
      editor.on('ShowCaret', function (e) {
        if (isReadOnly(editor)) {
          e.preventDefault();
        }
      });
      editor.on('ObjectSelected', function (e) {
        if (isReadOnly(editor)) {
          e.preventDefault();
        }
      });
    };

    var nativeEvents = Tools.makeMap('focus blur focusin focusout click dblclick mousedown mouseup mousemove mouseover beforepaste paste cut copy selectionchange ' + 'mouseout mouseenter mouseleave wheel keydown keypress keyup input beforeinput contextmenu dragstart dragend dragover ' + 'draggesture dragdrop drop drag submit ' + 'compositionstart compositionend compositionupdate touchstart touchmove touchend touchcancel', ' ');
    var EventDispatcher = function () {
      function EventDispatcher(settings) {
        this.bindings = {};
        this.settings = settings || {};
        this.scope = this.settings.scope || this;
        this.toggleEvent = this.settings.toggleEvent || never;
      }
      EventDispatcher.isNative = function (name) {
        return !!nativeEvents[name.toLowerCase()];
      };
      EventDispatcher.prototype.fire = function (name, args) {
        var lcName = name.toLowerCase();
        var event = normalize$3(lcName, args || {}, this.scope);
        if (this.settings.beforeFire) {
          this.settings.beforeFire(event);
        }
        var handlers = this.bindings[lcName];
        if (handlers) {
          for (var i = 0, l = handlers.length; i < l; i++) {
            var callback = handlers[i];
            if (callback.removed) {
              continue;
            }
            if (callback.once) {
              this.off(lcName, callback.func);
            }
            if (event.isImmediatePropagationStopped()) {
              return event;
            }
            if (callback.func.call(this.scope, event) === false) {
              event.preventDefault();
              return event;
            }
          }
        }
        return event;
      };
      EventDispatcher.prototype.on = function (name, callback, prepend, extra) {
        if (callback === false) {
          callback = never;
        }
        if (callback) {
          var wrappedCallback = {
            func: callback,
            removed: false
          };
          if (extra) {
            Tools.extend(wrappedCallback, extra);
          }
          var names = name.toLowerCase().split(' ');
          var i = names.length;
          while (i--) {
            var currentName = names[i];
            var handlers = this.bindings[currentName];
            if (!handlers) {
              handlers = [];
              this.toggleEvent(currentName, true);
            }
            if (prepend) {
              handlers = __spreadArray([wrappedCallback], handlers, true);
            } else {
              handlers = __spreadArray(__spreadArray([], handlers, true), [wrappedCallback], false);
            }
            this.bindings[currentName] = handlers;
          }
        }
        return this;
      };
      EventDispatcher.prototype.off = function (name, callback) {
        var _this = this;
        if (name) {
          var names = name.toLowerCase().split(' ');
          var i = names.length;
          while (i--) {
            var currentName = names[i];
            var handlers = this.bindings[currentName];
            if (!currentName) {
              each$j(this.bindings, function (_value, bindingName) {
                _this.toggleEvent(bindingName, false);
                delete _this.bindings[bindingName];
              });
              return this;
            }
            if (handlers) {
              if (!callback) {
                handlers.length = 0;
              } else {
                var filteredHandlers = partition(handlers, function (handler) {
                  return handler.func === callback;
                });
                handlers = filteredHandlers.fail;
                this.bindings[currentName] = handlers;
                each$k(filteredHandlers.pass, function (handler) {
                  handler.removed = true;
                });
              }
              if (!handlers.length) {
                this.toggleEvent(name, false);
                delete this.bindings[currentName];
              }
            }
          }
        } else {
          each$j(this.bindings, function (_value, name) {
            _this.toggleEvent(name, false);
          });
          this.bindings = {};
        }
        return this;
      };
      EventDispatcher.prototype.once = function (name, callback, prepend) {
        return this.on(name, callback, prepend, { once: true });
      };
      EventDispatcher.prototype.has = function (name) {
        name = name.toLowerCase();
        return !(!this.bindings[name] || this.bindings[name].length === 0);
      };
      return EventDispatcher;
    }();

    var getEventDispatcher = function (obj) {
      if (!obj._eventDispatcher) {
        obj._eventDispatcher = new EventDispatcher({
          scope: obj,
          toggleEvent: function (name, state) {
            if (EventDispatcher.isNative(name) && obj.toggleNativeEvent) {
              obj.toggleNativeEvent(name, state);
            }
          }
        });
      }
      return obj._eventDispatcher;
    };
    var Observable = {
      fire: function (name, args, bubble) {
        var self = this;
        if (self.removed && name !== 'remove' && name !== 'detach') {
          return args;
        }
        var dispatcherArgs = getEventDispatcher(self).fire(name, args);
        if (bubble !== false && self.parent) {
          var parent_1 = self.parent();
          while (parent_1 && !dispatcherArgs.isPropagationStopped()) {
            parent_1.fire(name, dispatcherArgs, false);
            parent_1 = parent_1.parent();
          }
        }
        return dispatcherArgs;
      },
      on: function (name, callback, prepend) {
        return getEventDispatcher(this).on(name, callback, prepend);
      },
      off: function (name, callback) {
        return getEventDispatcher(this).off(name, callback);
      },
      once: function (name, callback) {
        return getEventDispatcher(this).once(name, callback);
      },
      hasEventListeners: function (name) {
        return getEventDispatcher(this).has(name);
      }
    };

    var DOM$2 = DOMUtils.DOM;
    var customEventRootDelegates;
    var getEventTarget = function (editor, eventName) {
      if (eventName === 'selectionchange') {
        return editor.getDoc();
      }
      if (!editor.inline && /^mouse|touch|click|contextmenu|drop|dragover|dragend/.test(eventName)) {
        return editor.getDoc().documentElement;
      }
      var eventRoot = getEventRoot(editor);
      if (eventRoot) {
        if (!editor.eventRoot) {
          editor.eventRoot = DOM$2.select(eventRoot)[0];
        }
        return editor.eventRoot;
      }
      return editor.getBody();
    };
    var isListening = function (editor) {
      return !editor.hidden && !isReadOnly(editor);
    };
    var fireEvent = function (editor, eventName, e) {
      if (isListening(editor)) {
        editor.fire(eventName, e);
      } else if (isReadOnly(editor)) {
        processReadonlyEvents(editor, e);
      }
    };
    var bindEventDelegate = function (editor, eventName) {
      var delegate;
      if (!editor.delegates) {
        editor.delegates = {};
      }
      if (editor.delegates[eventName] || editor.removed) {
        return;
      }
      var eventRootElm = getEventTarget(editor, eventName);
      if (getEventRoot(editor)) {
        if (!customEventRootDelegates) {
          customEventRootDelegates = {};
          editor.editorManager.on('removeEditor', function () {
            if (!editor.editorManager.activeEditor) {
              if (customEventRootDelegates) {
                each$j(customEventRootDelegates, function (_value, name) {
                  editor.dom.unbind(getEventTarget(editor, name));
                });
                customEventRootDelegates = null;
              }
            }
          });
        }
        if (customEventRootDelegates[eventName]) {
          return;
        }
        delegate = function (e) {
          var target = e.target;
          var editors = editor.editorManager.get();
          var i = editors.length;
          while (i--) {
            var body = editors[i].getBody();
            if (body === target || DOM$2.isChildOf(target, body)) {
              fireEvent(editors[i], eventName, e);
            }
          }
        };
        customEventRootDelegates[eventName] = delegate;
        DOM$2.bind(eventRootElm, eventName, delegate);
      } else {
        delegate = function (e) {
          fireEvent(editor, eventName, e);
        };
        DOM$2.bind(eventRootElm, eventName, delegate);
        editor.delegates[eventName] = delegate;
      }
    };
    var EditorObservable = __assign(__assign({}, Observable), {
      bindPendingEventDelegates: function () {
        var self = this;
        Tools.each(self._pendingNativeEvents, function (name) {
          bindEventDelegate(self, name);
        });
      },
      toggleNativeEvent: function (name, state) {
        var self = this;
        if (name === 'focus' || name === 'blur') {
          return;
        }
        if (self.removed) {
          return;
        }
        if (state) {
          if (self.initialized) {
            bindEventDelegate(self, name);
          } else {
            if (!self._pendingNativeEvents) {
              self._pendingNativeEvents = [name];
            } else {
              self._pendingNativeEvents.push(name);
            }
          }
        } else if (self.initialized) {
          self.dom.unbind(getEventTarget(self, name), name, self.delegates[name]);
          delete self.delegates[name];
        }
      },
      unbindAllNativeEvents: function () {
        var self = this;
        var body = self.getBody();
        var dom = self.dom;
        if (self.delegates) {
          each$j(self.delegates, function (value, name) {
            self.dom.unbind(getEventTarget(self, name), name, value);
          });
          delete self.delegates;
        }
        if (!self.inline && body && dom) {
          body.onload = null;
          dom.unbind(self.getWin());
          dom.unbind(self.getDoc());
        }
        if (dom) {
          dom.unbind(body);
          dom.unbind(self.getContainer());
        }
      }
    });

    var defaultModes = [
      'design',
      'readonly'
    ];
    var switchToMode = function (editor, activeMode, availableModes, mode) {
      var oldMode = availableModes[activeMode.get()];
      var newMode = availableModes[mode];
      try {
        newMode.activate();
      } catch (e) {
        console.error('problem while activating editor mode ' + mode + ':', e);
        return;
      }
      oldMode.deactivate();
      if (oldMode.editorReadOnly !== newMode.editorReadOnly) {
        toggleReadOnly(editor, newMode.editorReadOnly);
      }
      activeMode.set(mode);
      fireSwitchMode(editor, mode);
    };
    var setMode = function (editor, availableModes, activeMode, mode) {
      if (mode === activeMode.get()) {
        return;
      } else if (!has$2(availableModes, mode)) {
        throw new Error('Editor mode \'' + mode + '\' is invalid');
      }
      if (editor.initialized) {
        switchToMode(editor, activeMode, availableModes, mode);
      } else {
        editor.on('init', function () {
          return switchToMode(editor, activeMode, availableModes, mode);
        });
      }
    };
    var registerMode = function (availableModes, mode, api) {
      var _a;
      if (contains$3(defaultModes, mode)) {
        throw new Error('Cannot override default mode ' + mode);
      }
      return __assign(__assign({}, availableModes), (_a = {}, _a[mode] = __assign(__assign({}, api), {
        deactivate: function () {
          try {
            api.deactivate();
          } catch (e) {
            console.error('problem while deactivating editor mode ' + mode + ':', e);
          }
        }
      }), _a));
    };

    var create$4 = function (editor) {
      var activeMode = Cell('design');
      var availableModes = Cell({
        design: {
          activate: noop,
          deactivate: noop,
          editorReadOnly: false
        },
        readonly: {
          activate: noop,
          deactivate: noop,
          editorReadOnly: true
        }
      });
      registerReadOnlyContentFilters(editor);
      registerReadOnlySelectionBlockers(editor);
      return {
        isReadOnly: function () {
          return isReadOnly(editor);
        },
        set: function (mode) {
          return setMode(editor, availableModes.get(), activeMode, mode);
        },
        get: function () {
          return activeMode.get();
        },
        register: function (mode, api) {
          availableModes.set(registerMode(availableModes.get(), mode, api));
        }
      };
    };

    var each$3 = Tools.each, explode$1 = Tools.explode;
    var keyCodeLookup = {
      f1: 112,
      f2: 113,
      f3: 114,
      f4: 115,
      f5: 116,
      f6: 117,
      f7: 118,
      f8: 119,
      f9: 120,
      f10: 121,
      f11: 122,
      f12: 123
    };
    var modifierNames = Tools.makeMap('alt,ctrl,shift,meta,access');
    var parseShortcut = function (pattern) {
      var key;
      var shortcut = {};
      each$3(explode$1(pattern.toLowerCase(), '+'), function (value) {
        if (value in modifierNames) {
          shortcut[value] = true;
        } else {
          if (/^[0-9]{2,}$/.test(value)) {
            shortcut.keyCode = parseInt(value, 10);
          } else {
            shortcut.charCode = value.charCodeAt(0);
            shortcut.keyCode = keyCodeLookup[value] || value.toUpperCase().charCodeAt(0);
          }
        }
      });
      var id = [shortcut.keyCode];
      for (key in modifierNames) {
        if (shortcut[key]) {
          id.push(key);
        } else {
          shortcut[key] = false;
        }
      }
      shortcut.id = id.join(',');
      if (shortcut.access) {
        shortcut.alt = true;
        if (Env.mac) {
          shortcut.ctrl = true;
        } else {
          shortcut.shift = true;
        }
      }
      if (shortcut.meta) {
        if (Env.mac) {
          shortcut.meta = true;
        } else {
          shortcut.ctrl = true;
          shortcut.meta = false;
        }
      }
      return shortcut;
    };
    var Shortcuts = function () {
      function Shortcuts(editor) {
        this.shortcuts = {};
        this.pendingPatterns = [];
        this.editor = editor;
        var self = this;
        editor.on('keyup keypress keydown', function (e) {
          if ((self.hasModifier(e) || self.isFunctionKey(e)) && !e.isDefaultPrevented()) {
            each$3(self.shortcuts, function (shortcut) {
              if (self.matchShortcut(e, shortcut)) {
                self.pendingPatterns = shortcut.subpatterns.slice(0);
                if (e.type === 'keydown') {
                  self.executeShortcutAction(shortcut);
                }
                return true;
              }
            });
            if (self.matchShortcut(e, self.pendingPatterns[0])) {
              if (self.pendingPatterns.length === 1) {
                if (e.type === 'keydown') {
                  self.executeShortcutAction(self.pendingPatterns[0]);
                }
              }
              self.pendingPatterns.shift();
            }
          }
        });
      }
      Shortcuts.prototype.add = function (pattern, desc, cmdFunc, scope) {
        var self = this;
        var func = self.normalizeCommandFunc(cmdFunc);
        each$3(explode$1(Tools.trim(pattern)), function (pattern) {
          var shortcut = self.createShortcut(pattern, desc, func, scope);
          self.shortcuts[shortcut.id] = shortcut;
        });
        return true;
      };
      Shortcuts.prototype.remove = function (pattern) {
        var shortcut = this.createShortcut(pattern);
        if (this.shortcuts[shortcut.id]) {
          delete this.shortcuts[shortcut.id];
          return true;
        }
        return false;
      };
      Shortcuts.prototype.normalizeCommandFunc = function (cmdFunc) {
        var self = this;
        var cmd = cmdFunc;
        if (typeof cmd === 'string') {
          return function () {
            self.editor.execCommand(cmd, false, null);
          };
        } else if (Tools.isArray(cmd)) {
          return function () {
            self.editor.execCommand(cmd[0], cmd[1], cmd[2]);
          };
        } else {
          return cmd;
        }
      };
      Shortcuts.prototype.createShortcut = function (pattern, desc, cmdFunc, scope) {
        var shortcuts = Tools.map(explode$1(pattern, '>'), parseShortcut);
        shortcuts[shortcuts.length - 1] = Tools.extend(shortcuts[shortcuts.length - 1], {
          func: cmdFunc,
          scope: scope || this.editor
        });
        return Tools.extend(shortcuts[0], {
          desc: this.editor.translate(desc),
          subpatterns: shortcuts.slice(1)
        });
      };
      Shortcuts.prototype.hasModifier = function (e) {
        return e.altKey || e.ctrlKey || e.metaKey;
      };
      Shortcuts.prototype.isFunctionKey = function (e) {
        return e.type === 'keydown' && e.keyCode >= 112 && e.keyCode <= 123;
      };
      Shortcuts.prototype.matchShortcut = function (e, shortcut) {
        if (!shortcut) {
          return false;
        }
        if (shortcut.ctrl !== e.ctrlKey || shortcut.meta !== e.metaKey) {
          return false;
        }
        if (shortcut.alt !== e.altKey || shortcut.shift !== e.shiftKey) {
          return false;
        }
        if (e.keyCode === shortcut.keyCode || e.charCode && e.charCode === shortcut.charCode) {
          e.preventDefault();
          return true;
        }
        return false;
      };
      Shortcuts.prototype.executeShortcutAction = function (shortcut) {
        return shortcut.func ? shortcut.func.call(shortcut.scope) : null;
      };
      return Shortcuts;
    }();

    var create$3 = function () {
      var buttons = {};
      var menuItems = {};
      var popups = {};
      var icons = {};
      var contextMenus = {};
      var contextToolbars = {};
      var sidebars = {};
      var add = function (collection, type) {
        return function (name, spec) {
          return collection[name.toLowerCase()] = __assign(__assign({}, spec), { type: type });
        };
      };
      var addIcon = function (name, svgData) {
        return icons[name.toLowerCase()] = svgData;
      };
      return {
        addButton: add(buttons, 'button'),
        addGroupToolbarButton: add(buttons, 'grouptoolbarbutton'),
        addToggleButton: add(buttons, 'togglebutton'),
        addMenuButton: add(buttons, 'menubutton'),
        addSplitButton: add(buttons, 'splitbutton'),
        addMenuItem: add(menuItems, 'menuitem'),
        addNestedMenuItem: add(menuItems, 'nestedmenuitem'),
        addToggleMenuItem: add(menuItems, 'togglemenuitem'),
        addAutocompleter: add(popups, 'autocompleter'),
        addContextMenu: add(contextMenus, 'contextmenu'),
        addContextToolbar: add(contextToolbars, 'contexttoolbar'),
        addContextForm: add(contextToolbars, 'contextform'),
        addSidebar: add(sidebars, 'sidebar'),
        addIcon: addIcon,
        getAll: function () {
          return {
            buttons: buttons,
            menuItems: menuItems,
            icons: icons,
            popups: popups,
            contextMenus: contextMenus,
            contextToolbars: contextToolbars,
            sidebars: sidebars
          };
        }
      };
    };

    var registry = function () {
      var bridge = create$3();
      return {
        addAutocompleter: bridge.addAutocompleter,
        addButton: bridge.addButton,
        addContextForm: bridge.addContextForm,
        addContextMenu: bridge.addContextMenu,
        addContextToolbar: bridge.addContextToolbar,
        addIcon: bridge.addIcon,
        addMenuButton: bridge.addMenuButton,
        addMenuItem: bridge.addMenuItem,
        addNestedMenuItem: bridge.addNestedMenuItem,
        addSidebar: bridge.addSidebar,
        addSplitButton: bridge.addSplitButton,
        addToggleButton: bridge.addToggleButton,
        addGroupToolbarButton: bridge.addGroupToolbarButton,
        addToggleMenuItem: bridge.addToggleMenuItem,
        getAll: bridge.getAll
      };
    };

    var DOM$1 = DOMUtils.DOM;
    var extend$3 = Tools.extend, each$2 = Tools.each;
    var resolve = Tools.resolve;
    var ie = Env.ie;
    var Editor = function () {
      function Editor(id, settings, editorManager) {
        var _this = this;
        this.plugins = {};
        this.contentCSS = [];
        this.contentStyles = [];
        this.loadedCSS = {};
        this.isNotDirty = false;
        this.editorManager = editorManager;
        this.documentBaseUrl = editorManager.documentBaseURL;
        extend$3(this, EditorObservable);
        this.settings = getEditorSettings(this, id, this.documentBaseUrl, editorManager.defaultSettings, settings);
        if (this.settings.suffix) {
          editorManager.suffix = this.settings.suffix;
        }
        this.suffix = editorManager.suffix;
        if (this.settings.base_url) {
          editorManager._setBaseUrl(this.settings.base_url);
        }
        this.baseUri = editorManager.baseURI;
        if (this.settings.referrer_policy) {
          ScriptLoader.ScriptLoader._setReferrerPolicy(this.settings.referrer_policy);
          DOMUtils.DOM.styleSheetLoader._setReferrerPolicy(this.settings.referrer_policy);
        }
        AddOnManager.languageLoad = this.settings.language_load;
        AddOnManager.baseURL = editorManager.baseURL;
        this.id = id;
        this.setDirty(false);
        this.documentBaseURI = new URI(this.settings.document_base_url, { base_uri: this.baseUri });
        this.baseURI = this.baseUri;
        this.inline = !!this.settings.inline;
        this.shortcuts = new Shortcuts(this);
        this.editorCommands = new EditorCommands(this);
        if (this.settings.cache_suffix) {
          Env.cacheSuffix = this.settings.cache_suffix.replace(/^[\?\&]+/, '');
        }
        this.ui = {
          registry: registry(),
          styleSheetLoader: undefined,
          show: noop,
          hide: noop,
          enable: noop,
          disable: noop,
          isDisabled: never
        };
        var self = this;
        var modeInstance = create$4(self);
        this.mode = modeInstance;
        this.setMode = modeInstance.set;
        editorManager.fire('SetupEditor', { editor: this });
        this.execCallback('setup', this);
        this.$ = DomQuery.overrideDefaults(function () {
          return {
            context: _this.inline ? _this.getBody() : _this.getDoc(),
            element: _this.getBody()
          };
        });
      }
      Editor.prototype.render = function () {
        render(this);
      };
      Editor.prototype.focus = function (skipFocus) {
        this.execCommand('mceFocus', false, skipFocus);
      };
      Editor.prototype.hasFocus = function () {
        return hasFocus(this);
      };
      Editor.prototype.execCallback = function (name) {
        var x = [];
        for (var _i = 1; _i < arguments.length; _i++) {
          x[_i - 1] = arguments[_i];
        }
        var self = this;
        var callback = self.settings[name], scope;
        if (!callback) {
          return;
        }
        if (self.callbackLookup && (scope = self.callbackLookup[name])) {
          callback = scope.func;
          scope = scope.scope;
        }
        if (typeof callback === 'string') {
          scope = callback.replace(/\.\w+$/, '');
          scope = scope ? resolve(scope) : 0;
          callback = resolve(callback);
          self.callbackLookup = self.callbackLookup || {};
          self.callbackLookup[name] = {
            func: callback,
            scope: scope
          };
        }
        return callback.apply(scope || self, x);
      };
      Editor.prototype.translate = function (text) {
        return I18n.translate(text);
      };
      Editor.prototype.getParam = function (name, defaultVal, type) {
        return getParam(this, name, defaultVal, type);
      };
      Editor.prototype.hasPlugin = function (name, loaded) {
        var hasPlugin = contains$3(getPlugins(this).split(/[ ,]/), name);
        if (hasPlugin) {
          return loaded ? PluginManager.get(name) !== undefined : true;
        } else {
          return false;
        }
      };
      Editor.prototype.nodeChanged = function (args) {
        this._nodeChangeDispatcher.nodeChanged(args);
      };
      Editor.prototype.addCommand = function (name, callback, scope) {
        this.editorCommands.addCommand(name, callback, scope);
      };
      Editor.prototype.addQueryStateHandler = function (name, callback, scope) {
        this.editorCommands.addQueryStateHandler(name, callback, scope);
      };
      Editor.prototype.addQueryValueHandler = function (name, callback, scope) {
        this.editorCommands.addQueryValueHandler(name, callback, scope);
      };
      Editor.prototype.addShortcut = function (pattern, desc, cmdFunc, scope) {
        this.shortcuts.add(pattern, desc, cmdFunc, scope);
      };
      Editor.prototype.execCommand = function (cmd, ui, value, args) {
        return this.editorCommands.execCommand(cmd, ui, value, args);
      };
      Editor.prototype.queryCommandState = function (cmd) {
        return this.editorCommands.queryCommandState(cmd);
      };
      Editor.prototype.queryCommandValue = function (cmd) {
        return this.editorCommands.queryCommandValue(cmd);
      };
      Editor.prototype.queryCommandSupported = function (cmd) {
        return this.editorCommands.queryCommandSupported(cmd);
      };
      Editor.prototype.show = function () {
        var self = this;
        if (self.hidden) {
          self.hidden = false;
          if (self.inline) {
            self.getBody().contentEditable = 'true';
          } else {
            DOM$1.show(self.getContainer());
            DOM$1.hide(self.id);
          }
          self.load();
          self.fire('show');
        }
      };
      Editor.prototype.hide = function () {
        var self = this, doc = self.getDoc();
        if (!self.hidden) {
          if (ie && doc && !self.inline) {
            doc.execCommand('SelectAll');
          }
          self.save();
          if (self.inline) {
            self.getBody().contentEditable = 'false';
            if (self === self.editorManager.focusedEditor) {
              self.editorManager.focusedEditor = null;
            }
          } else {
            DOM$1.hide(self.getContainer());
            DOM$1.setStyle(self.id, 'display', self.orgDisplay);
          }
          self.hidden = true;
          self.fire('hide');
        }
      };
      Editor.prototype.isHidden = function () {
        return !!this.hidden;
      };
      Editor.prototype.setProgressState = function (state, time) {
        this.fire('ProgressState', {
          state: state,
          time: time
        });
      };
      Editor.prototype.load = function (args) {
        var self = this;
        var elm = self.getElement(), html;
        if (self.removed) {
          return '';
        }
        if (elm) {
          args = args || {};
          args.load = true;
          var value = isTextareaOrInput(elm) ? elm.value : elm.innerHTML;
          html = self.setContent(value, args);
          args.element = elm;
          if (!args.no_events) {
            self.fire('LoadContent', args);
          }
          args.element = elm = null;
          return html;
        }
      };
      Editor.prototype.save = function (args) {
        var self = this;
        var elm = self.getElement(), html, form;
        if (!elm || !self.initialized || self.removed) {
          return;
        }
        args = args || {};
        args.save = true;
        args.element = elm;
        html = args.content = self.getContent(args);
        if (!args.no_events) {
          self.fire('SaveContent', args);
        }
        if (args.format === 'raw') {
          self.fire('RawSaveContent', args);
        }
        html = args.content;
        if (!isTextareaOrInput(elm)) {
          if (args.is_removing || !self.inline) {
            elm.innerHTML = html;
          }
          if (form = DOM$1.getParent(self.id, 'form')) {
            each$2(form.elements, function (elm) {
              if (elm.name === self.id) {
                elm.value = html;
                return false;
              }
            });
          }
        } else {
          elm.value = html;
        }
        args.element = elm = null;
        if (args.set_dirty !== false) {
          self.setDirty(false);
        }
        return html;
      };
      Editor.prototype.setContent = function (content, args) {
        return setContent(this, content, args);
      };
      Editor.prototype.getContent = function (args) {
        return getContent(this, args);
      };
      Editor.prototype.insertContent = function (content, args) {
        if (args) {
          content = extend$3({ content: content }, args);
        }
        this.execCommand('mceInsertContent', false, content);
      };
      Editor.prototype.resetContent = function (initialContent) {
        if (initialContent === undefined) {
          setContent(this, this.startContent, { format: 'raw' });
        } else {
          setContent(this, initialContent);
        }
        this.undoManager.reset();
        this.setDirty(false);
        this.nodeChanged();
      };
      Editor.prototype.isDirty = function () {
        return !this.isNotDirty;
      };
      Editor.prototype.setDirty = function (state) {
        var oldState = !this.isNotDirty;
        this.isNotDirty = !state;
        if (state && state !== oldState) {
          this.fire('dirty');
        }
      };
      Editor.prototype.getContainer = function () {
        var self = this;
        if (!self.container) {
          self.container = DOM$1.get(self.editorContainer || self.id + '_parent');
        }
        return self.container;
      };
      Editor.prototype.getContentAreaContainer = function () {
        return this.contentAreaContainer;
      };
      Editor.prototype.getElement = function () {
        if (!this.targetElm) {
          this.targetElm = DOM$1.get(this.id);
        }
        return this.targetElm;
      };
      Editor.prototype.getWin = function () {
        var self = this;
        var elm;
        if (!self.contentWindow) {
          elm = self.iframeElement;
          if (elm) {
            self.contentWindow = elm.contentWindow;
          }
        }
        return self.contentWindow;
      };
      Editor.prototype.getDoc = function () {
        var self = this;
        var win;
        if (!self.contentDocument) {
          win = self.getWin();
          if (win) {
            self.contentDocument = win.document;
          }
        }
        return self.contentDocument;
      };
      Editor.prototype.getBody = function () {
        var doc = this.getDoc();
        return this.bodyElement || (doc ? doc.body : null);
      };
      Editor.prototype.convertURL = function (url, name, elm) {
        var self = this, settings = self.settings;
        if (settings.urlconverter_callback) {
          return self.execCallback('urlconverter_callback', url, elm, true, name);
        }
        if (!settings.convert_urls || elm && elm.nodeName === 'LINK' || url.indexOf('file:') === 0 || url.length === 0) {
          return url;
        }
        if (settings.relative_urls) {
          return self.documentBaseURI.toRelative(url);
        }
        url = self.documentBaseURI.toAbsolute(url, settings.remove_script_host);
        return url;
      };
      Editor.prototype.addVisual = function (elm) {
        addVisual(this, elm);
      };
      Editor.prototype.remove = function () {
        remove(this);
      };
      Editor.prototype.destroy = function (automatic) {
        destroy(this, automatic);
      };
      Editor.prototype.uploadImages = function (callback) {
        return this.editorUpload.uploadImages(callback);
      };
      Editor.prototype._scanForImages = function () {
        return this.editorUpload.scanForImages();
      };
      Editor.prototype.addButton = function () {
        throw new Error('editor.addButton has been removed in tinymce 5x, use editor.ui.registry.addButton or editor.ui.registry.addToggleButton or editor.ui.registry.addSplitButton instead');
      };
      Editor.prototype.addSidebar = function () {
        throw new Error('editor.addSidebar has been removed in tinymce 5x, use editor.ui.registry.addSidebar instead');
      };
      Editor.prototype.addMenuItem = function () {
        throw new Error('editor.addMenuItem has been removed in tinymce 5x, use editor.ui.registry.addMenuItem instead');
      };
      Editor.prototype.addContextToolbar = function () {
        throw new Error('editor.addContextToolbar has been removed in tinymce 5x, use editor.ui.registry.addContextToolbar instead');
      };
      return Editor;
    }();

    var DOM = DOMUtils.DOM;
    var explode = Tools.explode, each$1 = Tools.each, extend$2 = Tools.extend;
    var instanceCounter = 0, boundGlobalEvents = false;
    var beforeUnloadDelegate;
    var legacyEditors = [];
    var editors = [];
    var isValidLegacyKey = function (id) {
      return id !== 'length';
    };
    var globalEventDelegate = function (e) {
      var type = e.type;
      each$1(EditorManager.get(), function (editor) {
        switch (type) {
        case 'scroll':
          editor.fire('ScrollWindow', e);
          break;
        case 'resize':
          editor.fire('ResizeWindow', e);
          break;
        }
      });
    };
    var toggleGlobalEvents = function (state) {
      if (state !== boundGlobalEvents) {
        if (state) {
          DomQuery(window).on('resize scroll', globalEventDelegate);
        } else {
          DomQuery(window).off('resize scroll', globalEventDelegate);
        }
        boundGlobalEvents = state;
      }
    };
    var removeEditorFromList = function (targetEditor) {
      var oldEditors = editors;
      delete legacyEditors[targetEditor.id];
      for (var i = 0; i < legacyEditors.length; i++) {
        if (legacyEditors[i] === targetEditor) {
          legacyEditors.splice(i, 1);
          break;
        }
      }
      editors = filter$4(editors, function (editor) {
        return targetEditor !== editor;
      });
      if (EditorManager.activeEditor === targetEditor) {
        EditorManager.activeEditor = editors.length > 0 ? editors[0] : null;
      }
      if (EditorManager.focusedEditor === targetEditor) {
        EditorManager.focusedEditor = null;
      }
      return oldEditors.length !== editors.length;
    };
    var purgeDestroyedEditor = function (editor) {
      if (editor && editor.initialized && !(editor.getContainer() || editor.getBody()).parentNode) {
        removeEditorFromList(editor);
        editor.unbindAllNativeEvents();
        editor.destroy(true);
        editor.removed = true;
        editor = null;
      }
      return editor;
    };
    var isQuirksMode = document.compatMode !== 'CSS1Compat';
    var EditorManager = __assign(__assign({}, Observable), {
      baseURI: null,
      baseURL: null,
      defaultSettings: {},
      documentBaseURL: null,
      suffix: null,
      $: DomQuery,
      majorVersion: '5',
      minorVersion: '10.5',
      releaseDate: '2022-05-25',
      editors: legacyEditors,
      i18n: I18n,
      activeEditor: null,
      focusedEditor: null,
      settings: {},
      setup: function () {
        var self = this;
        var baseURL, documentBaseURL, suffix = '';
        documentBaseURL = URI.getDocumentBaseUrl(document.location);
        if (/^[^:]+:\/\/\/?[^\/]+\//.test(documentBaseURL)) {
          documentBaseURL = documentBaseURL.replace(/[\?#].*$/, '').replace(/[\/\\][^\/]+$/, '');
          if (!/[\/\\]$/.test(documentBaseURL)) {
            documentBaseURL += '/';
          }
        }
        var preInit = window.tinymce || window.tinyMCEPreInit;
        if (preInit) {
          baseURL = preInit.base || preInit.baseURL;
          suffix = preInit.suffix;
        } else {
          var scripts = document.getElementsByTagName('script');
          for (var i = 0; i < scripts.length; i++) {
            var src = scripts[i].src || '';
            if (src === '') {
              continue;
            }
            var srcScript = src.substring(src.lastIndexOf('/'));
            if (/tinymce(\.full|\.jquery|)(\.min|\.dev|)\.js/.test(src)) {
              if (srcScript.indexOf('.min') !== -1) {
                suffix = '.min';
              }
              baseURL = src.substring(0, src.lastIndexOf('/'));
              break;
            }
          }
          if (!baseURL && document.currentScript) {
            var src = document.currentScript.src;
            if (src.indexOf('.min') !== -1) {
              suffix = '.min';
            }
            baseURL = src.substring(0, src.lastIndexOf('/'));
          }
        }
        self.baseURL = new URI(documentBaseURL).toAbsolute(baseURL);
        self.documentBaseURL = documentBaseURL;
        self.baseURI = new URI(self.baseURL);
        self.suffix = suffix;
        setup$l(self);
      },
      overrideDefaults: function (defaultSettings) {
        var baseUrl = defaultSettings.base_url;
        if (baseUrl) {
          this._setBaseUrl(baseUrl);
        }
        var suffix = defaultSettings.suffix;
        if (defaultSettings.suffix) {
          this.suffix = suffix;
        }
        this.defaultSettings = defaultSettings;
        var pluginBaseUrls = defaultSettings.plugin_base_urls;
        if (pluginBaseUrls !== undefined) {
          each$j(pluginBaseUrls, function (pluginBaseUrl, pluginName) {
            AddOnManager.PluginManager.urls[pluginName] = pluginBaseUrl;
          });
        }
      },
      init: function (settings) {
        var self = this;
        var result;
        var invalidInlineTargets = Tools.makeMap('area base basefont br col frame hr img input isindex link meta param embed source wbr track ' + 'colgroup option table tbody tfoot thead tr th td script noscript style textarea video audio iframe object menu', ' ');
        var isInvalidInlineTarget = function (settings, elm) {
          return settings.inline && elm.tagName.toLowerCase() in invalidInlineTargets;
        };
        var createId = function (elm) {
          var id = elm.id;
          if (!id) {
            id = get$9(elm, 'name').filter(function (name) {
              return !DOM.get(name);
            }).getOrThunk(DOM.uniqueId);
            elm.setAttribute('id', id);
          }
          return id;
        };
        var execCallback = function (name) {
          var callback = settings[name];
          if (!callback) {
            return;
          }
          return callback.apply(self, []);
        };
        var hasClass = function (elm, className) {
          return className.constructor === RegExp ? className.test(elm.className) : DOM.hasClass(elm, className);
        };
        var findTargets = function (settings) {
          var targets = [];
          if (Env.browser.isIE() && Env.browser.version.major < 11) {
            initError('TinyMCE does not support the browser you are using. For a list of supported' + ' browsers please see: https://www.tinymce.com/docs/get-started/system-requirements/');
            return [];
          } else if (isQuirksMode) {
            initError('Failed to initialize the editor as the document is not in standards mode. ' + 'TinyMCE requires standards mode.');
            return [];
          }
          if (settings.types) {
            each$1(settings.types, function (type) {
              targets = targets.concat(DOM.select(type.selector));
            });
            return targets;
          } else if (settings.selector) {
            return DOM.select(settings.selector);
          } else if (settings.target) {
            return [settings.target];
          }
          switch (settings.mode) {
          case 'exact':
            var l = settings.elements || '';
            if (l.length > 0) {
              each$1(explode(l), function (id) {
                var elm = DOM.get(id);
                if (elm) {
                  targets.push(elm);
                } else {
                  each$1(document.forms, function (f) {
                    each$1(f.elements, function (e) {
                      if (e.name === id) {
                        id = 'mce_editor_' + instanceCounter++;
                        DOM.setAttrib(e, 'id', id);
                        targets.push(e);
                      }
                    });
                  });
                }
              });
            }
            break;
          case 'textareas':
          case 'specific_textareas':
            each$1(DOM.select('textarea'), function (elm) {
              if (settings.editor_deselector && hasClass(elm, settings.editor_deselector)) {
                return;
              }
              if (!settings.editor_selector || hasClass(elm, settings.editor_selector)) {
                targets.push(elm);
              }
            });
            break;
          }
          return targets;
        };
        var provideResults = function (editors) {
          result = editors;
        };
        var initEditors = function () {
          var initCount = 0;
          var editors = [];
          var targets;
          var createEditor = function (id, settings, targetElm) {
            var editor = new Editor(id, settings, self);
            editors.push(editor);
            editor.on('init', function () {
              if (++initCount === targets.length) {
                provideResults(editors);
              }
            });
            editor.targetElm = editor.targetElm || targetElm;
            editor.render();
          };
          DOM.unbind(window, 'ready', initEditors);
          execCallback('onpageload');
          targets = DomQuery.unique(findTargets(settings));
          if (settings.types) {
            each$1(settings.types, function (type) {
              Tools.each(targets, function (elm) {
                if (DOM.is(elm, type.selector)) {
                  createEditor(createId(elm), extend$2({}, settings, type), elm);
                  return false;
                }
                return true;
              });
            });
            return;
          }
          Tools.each(targets, function (elm) {
            purgeDestroyedEditor(self.get(elm.id));
          });
          targets = Tools.grep(targets, function (elm) {
            return !self.get(elm.id);
          });
          if (targets.length === 0) {
            provideResults([]);
          } else {
            each$1(targets, function (elm) {
              if (isInvalidInlineTarget(settings, elm)) {
                initError('Could not initialize inline editor on invalid inline target element', elm);
              } else {
                createEditor(createId(elm), settings, elm);
              }
            });
          }
        };
        self.settings = settings;
        DOM.bind(window, 'ready', initEditors);
        return new promiseObj(function (resolve) {
          if (result) {
            resolve(result);
          } else {
            provideResults = function (editors) {
              resolve(editors);
            };
          }
        });
      },
      get: function (id) {
        if (arguments.length === 0) {
          return editors.slice(0);
        } else if (isString$1(id)) {
          return find$3(editors, function (editor) {
            return editor.id === id;
          }).getOr(null);
        } else if (isNumber(id)) {
          return editors[id] ? editors[id] : null;
        } else {
          return null;
        }
      },
      add: function (editor) {
        var self = this;
        var existingEditor = legacyEditors[editor.id];
        if (existingEditor === editor) {
          return editor;
        }
        if (self.get(editor.id) === null) {
          if (isValidLegacyKey(editor.id)) {
            legacyEditors[editor.id] = editor;
          }
          legacyEditors.push(editor);
          editors.push(editor);
        }
        toggleGlobalEvents(true);
        self.activeEditor = editor;
        self.fire('AddEditor', { editor: editor });
        if (!beforeUnloadDelegate) {
          beforeUnloadDelegate = function (e) {
            var event = self.fire('BeforeUnload');
            if (event.returnValue) {
              e.preventDefault();
              e.returnValue = event.returnValue;
              return event.returnValue;
            }
          };
          window.addEventListener('beforeunload', beforeUnloadDelegate);
        }
        return editor;
      },
      createEditor: function (id, settings) {
        return this.add(new Editor(id, settings, this));
      },
      remove: function (selector) {
        var self = this;
        var i, editor;
        if (!selector) {
          for (i = editors.length - 1; i >= 0; i--) {
            self.remove(editors[i]);
          }
          return;
        }
        if (isString$1(selector)) {
          each$1(DOM.select(selector), function (elm) {
            editor = self.get(elm.id);
            if (editor) {
              self.remove(editor);
            }
          });
          return;
        }
        editor = selector;
        if (isNull(self.get(editor.id))) {
          return null;
        }
        if (removeEditorFromList(editor)) {
          self.fire('RemoveEditor', { editor: editor });
        }
        if (editors.length === 0) {
          window.removeEventListener('beforeunload', beforeUnloadDelegate);
        }
        editor.remove();
        toggleGlobalEvents(editors.length > 0);
        return editor;
      },
      execCommand: function (cmd, ui, value) {
        var self = this, editor = self.get(value);
        switch (cmd) {
        case 'mceAddEditor':
          if (!self.get(value)) {
            new Editor(value, self.settings, self).render();
          }
          return true;
        case 'mceRemoveEditor':
          if (editor) {
            editor.remove();
          }
          return true;
        case 'mceToggleEditor':
          if (!editor) {
            self.execCommand('mceAddEditor', false, value);
            return true;
          }
          if (editor.isHidden()) {
            editor.show();
          } else {
            editor.hide();
          }
          return true;
        }
        if (self.activeEditor) {
          return self.activeEditor.execCommand(cmd, ui, value);
        }
        return false;
      },
      triggerSave: function () {
        each$1(editors, function (editor) {
          editor.save();
        });
      },
      addI18n: function (code, items) {
        I18n.add(code, items);
      },
      translate: function (text) {
        return I18n.translate(text);
      },
      setActive: function (editor) {
        var activeEditor = this.activeEditor;
        if (this.activeEditor !== editor) {
          if (activeEditor) {
            activeEditor.fire('deactivate', { relatedTarget: editor });
          }
          editor.fire('activate', { relatedTarget: activeEditor });
        }
        this.activeEditor = editor;
      },
      _setBaseUrl: function (baseUrl) {
        this.baseURL = new URI(this.documentBaseURL).toAbsolute(baseUrl.replace(/\/+$/, ''));
        this.baseURI = new URI(this.baseURL);
      }
    });
    EditorManager.setup();

    var min$1 = Math.min, max$1 = Math.max, round$1 = Math.round;
    var relativePosition = function (rect, targetRect, rel) {
      var x = targetRect.x;
      var y = targetRect.y;
      var w = rect.w;
      var h = rect.h;
      var targetW = targetRect.w;
      var targetH = targetRect.h;
      var relChars = (rel || '').split('');
      if (relChars[0] === 'b') {
        y += targetH;
      }
      if (relChars[1] === 'r') {
        x += targetW;
      }
      if (relChars[0] === 'c') {
        y += round$1(targetH / 2);
      }
      if (relChars[1] === 'c') {
        x += round$1(targetW / 2);
      }
      if (relChars[3] === 'b') {
        y -= h;
      }
      if (relChars[4] === 'r') {
        x -= w;
      }
      if (relChars[3] === 'c') {
        y -= round$1(h / 2);
      }
      if (relChars[4] === 'c') {
        x -= round$1(w / 2);
      }
      return create$2(x, y, w, h);
    };
    var findBestRelativePosition = function (rect, targetRect, constrainRect, rels) {
      var pos, i;
      for (i = 0; i < rels.length; i++) {
        pos = relativePosition(rect, targetRect, rels[i]);
        if (pos.x >= constrainRect.x && pos.x + pos.w <= constrainRect.w + constrainRect.x && pos.y >= constrainRect.y && pos.y + pos.h <= constrainRect.h + constrainRect.y) {
          return rels[i];
        }
      }
      return null;
    };
    var inflate = function (rect, w, h) {
      return create$2(rect.x - w, rect.y - h, rect.w + w * 2, rect.h + h * 2);
    };
    var intersect = function (rect, cropRect) {
      var x1 = max$1(rect.x, cropRect.x);
      var y1 = max$1(rect.y, cropRect.y);
      var x2 = min$1(rect.x + rect.w, cropRect.x + cropRect.w);
      var y2 = min$1(rect.y + rect.h, cropRect.y + cropRect.h);
      if (x2 - x1 < 0 || y2 - y1 < 0) {
        return null;
      }
      return create$2(x1, y1, x2 - x1, y2 - y1);
    };
    var clamp = function (rect, clampRect, fixedSize) {
      var x1 = rect.x;
      var y1 = rect.y;
      var x2 = rect.x + rect.w;
      var y2 = rect.y + rect.h;
      var cx2 = clampRect.x + clampRect.w;
      var cy2 = clampRect.y + clampRect.h;
      var underflowX1 = max$1(0, clampRect.x - x1);
      var underflowY1 = max$1(0, clampRect.y - y1);
      var overflowX2 = max$1(0, x2 - cx2);
      var overflowY2 = max$1(0, y2 - cy2);
      x1 += underflowX1;
      y1 += underflowY1;
      if (fixedSize) {
        x2 += underflowX1;
        y2 += underflowY1;
        x1 -= overflowX2;
        y1 -= overflowY2;
      }
      x2 -= overflowX2;
      y2 -= overflowY2;
      return create$2(x1, y1, x2 - x1, y2 - y1);
    };
    var create$2 = function (x, y, w, h) {
      return {
        x: x,
        y: y,
        w: w,
        h: h
      };
    };
    var fromClientRect = function (clientRect) {
      return create$2(clientRect.left, clientRect.top, clientRect.width, clientRect.height);
    };
    var Rect = {
      inflate: inflate,
      relativePosition: relativePosition,
      findBestRelativePosition: findBestRelativePosition,
      intersect: intersect,
      clamp: clamp,
      create: create$2,
      fromClientRect: fromClientRect
    };

    var awaiter = function (resolveCb, rejectCb, timeout) {
      if (timeout === void 0) {
        timeout = 1000;
      }
      var done = false;
      var timer = null;
      var complete = function (completer) {
        return function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          if (!done) {
            done = true;
            if (timer !== null) {
              clearTimeout(timer);
              timer = null;
            }
            completer.apply(null, args);
          }
        };
      };
      var resolve = complete(resolveCb);
      var reject = complete(rejectCb);
      var start = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        if (!done && timer === null) {
          timer = setTimeout(function () {
            return reject.apply(null, args);
          }, timeout);
        }
      };
      return {
        start: start,
        resolve: resolve,
        reject: reject
      };
    };
    var create$1 = function () {
      var tasks = {};
      var resultFns = {};
      var load = function (id, url) {
        var loadErrMsg = 'Script at URL "' + url + '" failed to load';
        var runErrMsg = 'Script at URL "' + url + '" did not call `tinymce.Resource.add(\'' + id + '\', data)` within 1 second';
        if (tasks[id] !== undefined) {
          return tasks[id];
        } else {
          var task = new promiseObj(function (resolve, reject) {
            var waiter = awaiter(resolve, reject);
            resultFns[id] = waiter.resolve;
            ScriptLoader.ScriptLoader.loadScript(url, function () {
              return waiter.start(runErrMsg);
            }, function () {
              return waiter.reject(loadErrMsg);
            });
          });
          tasks[id] = task;
          return task;
        }
      };
      var add = function (id, data) {
        if (resultFns[id] !== undefined) {
          resultFns[id](data);
          delete resultFns[id];
        }
        tasks[id] = promiseObj.resolve(data);
      };
      return {
        load: load,
        add: add
      };
    };
    var Resource = create$1();

    var each = Tools.each, extend$1 = Tools.extend;
    var extendClass, initializing;
    var Class = function () {
    };
    Class.extend = extendClass = function (props) {
      var self = this;
      var _super = self.prototype;
      var Class = function () {
        var i, mixins, mixin;
        var self = this;
        if (!initializing) {
          if (self.init) {
            self.init.apply(self, arguments);
          }
          mixins = self.Mixins;
          if (mixins) {
            i = mixins.length;
            while (i--) {
              mixin = mixins[i];
              if (mixin.init) {
                mixin.init.apply(self, arguments);
              }
            }
          }
        }
      };
      var dummy = function () {
        return this;
      };
      var createMethod = function (name, fn) {
        return function () {
          var self = this;
          var tmp = self._super;
          self._super = _super[name];
          var ret = fn.apply(self, arguments);
          self._super = tmp;
          return ret;
        };
      };
      initializing = true;
      var prototype = new self();
      initializing = false;
      if (props.Mixins) {
        each(props.Mixins, function (mixin) {
          for (var name_1 in mixin) {
            if (name_1 !== 'init') {
              props[name_1] = mixin[name_1];
            }
          }
        });
        if (_super.Mixins) {
          props.Mixins = _super.Mixins.concat(props.Mixins);
        }
      }
      if (props.Methods) {
        each(props.Methods.split(','), function (name) {
          props[name] = dummy;
        });
      }
      if (props.Properties) {
        each(props.Properties.split(','), function (name) {
          var fieldName = '_' + name;
          props[name] = function (value) {
            var self = this;
            if (value !== undefined) {
              self[fieldName] = value;
              return self;
            }
            return self[fieldName];
          };
        });
      }
      if (props.Statics) {
        each(props.Statics, function (func, name) {
          Class[name] = func;
        });
      }
      if (props.Defaults && _super.Defaults) {
        props.Defaults = extend$1({}, _super.Defaults, props.Defaults);
      }
      each$j(props, function (member, name) {
        if (typeof member === 'function' && _super[name]) {
          prototype[name] = createMethod(name, member);
        } else {
          prototype[name] = member;
        }
      });
      Class.prototype = prototype;
      Class.constructor = Class;
      Class.extend = extendClass;
      return Class;
    };

    var min = Math.min, max = Math.max, round = Math.round;
    var Color = function (value) {
      var self = {};
      var r = 0, g = 0, b = 0;
      var rgb2hsv = function (r, g, b) {
        var h, s, v;
        h = 0;
        s = 0;
        v = 0;
        r = r / 255;
        g = g / 255;
        b = b / 255;
        var minRGB = min(r, min(g, b));
        var maxRGB = max(r, max(g, b));
        if (minRGB === maxRGB) {
          v = minRGB;
          return {
            h: 0,
            s: 0,
            v: v * 100
          };
        }
        var d = r === minRGB ? g - b : b === minRGB ? r - g : b - r;
        h = r === minRGB ? 3 : b === minRGB ? 1 : 5;
        h = 60 * (h - d / (maxRGB - minRGB));
        s = (maxRGB - minRGB) / maxRGB;
        v = maxRGB;
        return {
          h: round(h),
          s: round(s * 100),
          v: round(v * 100)
        };
      };
      var hsvToRgb = function (hue, saturation, brightness) {
        hue = (parseInt(hue, 10) || 0) % 360;
        saturation = parseInt(saturation, 10) / 100;
        brightness = parseInt(brightness, 10) / 100;
        saturation = max(0, min(saturation, 1));
        brightness = max(0, min(brightness, 1));
        if (saturation === 0) {
          r = g = b = round(255 * brightness);
          return;
        }
        var side = hue / 60;
        var chroma = brightness * saturation;
        var x = chroma * (1 - Math.abs(side % 2 - 1));
        var match = brightness - chroma;
        switch (Math.floor(side)) {
        case 0:
          r = chroma;
          g = x;
          b = 0;
          break;
        case 1:
          r = x;
          g = chroma;
          b = 0;
          break;
        case 2:
          r = 0;
          g = chroma;
          b = x;
          break;
        case 3:
          r = 0;
          g = x;
          b = chroma;
          break;
        case 4:
          r = x;
          g = 0;
          b = chroma;
          break;
        case 5:
          r = chroma;
          g = 0;
          b = x;
          break;
        default:
          r = g = b = 0;
        }
        r = round(255 * (r + match));
        g = round(255 * (g + match));
        b = round(255 * (b + match));
      };
      var toHex = function () {
        var hex = function (val) {
          val = parseInt(val, 10).toString(16);
          return val.length > 1 ? val : '0' + val;
        };
        return '#' + hex(r) + hex(g) + hex(b);
      };
      var toRgb = function () {
        return {
          r: r,
          g: g,
          b: b
        };
      };
      var toHsv = function () {
        return rgb2hsv(r, g, b);
      };
      var parse = function (value) {
        var matches;
        if (typeof value === 'object') {
          if ('r' in value) {
            r = value.r;
            g = value.g;
            b = value.b;
          } else if ('v' in value) {
            hsvToRgb(value.h, value.s, value.v);
          }
        } else {
          if (matches = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)[^\)]*\)/gi.exec(value)) {
            r = parseInt(matches[1], 10);
            g = parseInt(matches[2], 10);
            b = parseInt(matches[3], 10);
          } else if (matches = /#([0-F]{2})([0-F]{2})([0-F]{2})/gi.exec(value)) {
            r = parseInt(matches[1], 16);
            g = parseInt(matches[2], 16);
            b = parseInt(matches[3], 16);
          } else if (matches = /#([0-F])([0-F])([0-F])/gi.exec(value)) {
            r = parseInt(matches[1] + matches[1], 16);
            g = parseInt(matches[2] + matches[2], 16);
            b = parseInt(matches[3] + matches[3], 16);
          }
        }
        r = r < 0 ? 0 : r > 255 ? 255 : r;
        g = g < 0 ? 0 : g > 255 ? 255 : g;
        b = b < 0 ? 0 : b > 255 ? 255 : b;
        return self;
      };
      if (value) {
        parse(value);
      }
      self.toRgb = toRgb;
      self.toHsv = toHsv;
      self.toHex = toHex;
      self.parse = parse;
      return self;
    };

    var serialize = function (obj) {
      var data = JSON.stringify(obj);
      if (!isString$1(data)) {
        return data;
      }
      return data.replace(/[\u0080-\uFFFF]/g, function (match) {
        var hexCode = match.charCodeAt(0).toString(16);
        return '\\u' + '0000'.substring(hexCode.length) + hexCode;
      });
    };
    var JSONUtils = {
      serialize: serialize,
      parse: function (text) {
        try {
          return JSON.parse(text);
        } catch (ex) {
        }
      }
    };

    var JSONP = {
      callbacks: {},
      count: 0,
      send: function (settings) {
        var self = this, dom = DOMUtils.DOM, count = settings.count !== undefined ? settings.count : self.count;
        var id = 'tinymce_jsonp_' + count;
        self.callbacks[count] = function (json) {
          dom.remove(id);
          delete self.callbacks[count];
          settings.callback(json);
        };
        dom.add(dom.doc.body, 'script', {
          id: id,
          src: settings.url,
          type: 'text/javascript'
        });
        self.count++;
      }
    };

    var XHR = __assign(__assign({}, Observable), {
      send: function (settings) {
        var xhr, count = 0;
        var ready = function () {
          if (!settings.async || xhr.readyState === 4 || count++ > 10000) {
            if (settings.success && count < 10000 && xhr.status === 200) {
              settings.success.call(settings.success_scope, '' + xhr.responseText, xhr, settings);
            } else if (settings.error) {
              settings.error.call(settings.error_scope, count > 10000 ? 'TIMED_OUT' : 'GENERAL', xhr, settings);
            }
            xhr = null;
          } else {
            Delay.setTimeout(ready, 10);
          }
        };
        settings.scope = settings.scope || this;
        settings.success_scope = settings.success_scope || settings.scope;
        settings.error_scope = settings.error_scope || settings.scope;
        settings.async = settings.async !== false;
        settings.data = settings.data || '';
        XHR.fire('beforeInitialize', { settings: settings });
        xhr = new XMLHttpRequest();
        if (xhr.overrideMimeType) {
          xhr.overrideMimeType(settings.content_type);
        }
        xhr.open(settings.type || (settings.data ? 'POST' : 'GET'), settings.url, settings.async);
        if (settings.crossDomain) {
          xhr.withCredentials = true;
        }
        if (settings.content_type) {
          xhr.setRequestHeader('Content-Type', settings.content_type);
        }
        if (settings.requestheaders) {
          Tools.each(settings.requestheaders, function (header) {
            xhr.setRequestHeader(header.key, header.value);
          });
        }
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr = XHR.fire('beforeSend', {
          xhr: xhr,
          settings: settings
        }).xhr;
        xhr.send(settings.data);
        if (!settings.async) {
          return ready();
        }
        Delay.setTimeout(ready, 10);
      }
    });

    var extend = Tools.extend;
    var JSONRequest = function () {
      function JSONRequest(settings) {
        this.settings = extend({}, settings);
        this.count = 0;
      }
      JSONRequest.sendRPC = function (o) {
        return new JSONRequest().send(o);
      };
      JSONRequest.prototype.send = function (args) {
        var ecb = args.error, scb = args.success;
        var xhrArgs = extend(this.settings, args);
        xhrArgs.success = function (c, x) {
          c = JSONUtils.parse(c);
          if (typeof c === 'undefined') {
            c = { error: 'JSON Parse error.' };
          }
          if (c.error) {
            ecb.call(xhrArgs.error_scope || xhrArgs.scope, c.error, x);
          } else {
            scb.call(xhrArgs.success_scope || xhrArgs.scope, c.result);
          }
        };
        xhrArgs.error = function (ty, x) {
          if (ecb) {
            ecb.call(xhrArgs.error_scope || xhrArgs.scope, ty, x);
          }
        };
        xhrArgs.data = JSONUtils.serialize({
          id: args.id || 'c' + this.count++,
          method: args.method,
          params: args.params
        });
        xhrArgs.content_type = 'application/json';
        XHR.send(xhrArgs);
      };
      return JSONRequest;
    }();

    var create = function () {
      return function () {
        var data = {};
        var keys = [];
        var storage = {
          getItem: function (key) {
            var item = data[key];
            return item ? item : null;
          },
          setItem: function (key, value) {
            keys.push(key);
            data[key] = String(value);
          },
          key: function (index) {
            return keys[index];
          },
          removeItem: function (key) {
            keys = keys.filter(function (k) {
              return k === key;
            });
            delete data[key];
          },
          clear: function () {
            keys = [];
            data = {};
          },
          length: 0
        };
        Object.defineProperty(storage, 'length', {
          get: function () {
            return keys.length;
          },
          configurable: false,
          enumerable: false
        });
        return storage;
      }();
    };

    var localStorage;
    try {
      var test = '__storage_test__';
      localStorage = window.localStorage;
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
    } catch (e) {
      localStorage = create();
    }
    var LocalStorage = localStorage;

    var publicApi = {
      geom: { Rect: Rect },
      util: {
        Promise: promiseObj,
        Delay: Delay,
        Tools: Tools,
        VK: VK,
        URI: URI,
        Class: Class,
        EventDispatcher: EventDispatcher,
        Observable: Observable,
        I18n: I18n,
        XHR: XHR,
        JSON: JSONUtils,
        JSONRequest: JSONRequest,
        JSONP: JSONP,
        LocalStorage: LocalStorage,
        Color: Color,
        ImageUploader: ImageUploader
      },
      dom: {
        EventUtils: EventUtils,
        Sizzle: Sizzle,
        DomQuery: DomQuery,
        TreeWalker: DomTreeWalker,
        TextSeeker: TextSeeker,
        DOMUtils: DOMUtils,
        ScriptLoader: ScriptLoader,
        RangeUtils: RangeUtils,
        Serializer: DomSerializer,
        StyleSheetLoader: StyleSheetLoader,
        ControlSelection: ControlSelection,
        BookmarkManager: BookmarkManager,
        Selection: EditorSelection,
        Event: EventUtils.Event
      },
      html: {
        Styles: Styles,
        Entities: Entities,
        Node: AstNode,
        Schema: Schema,
        SaxParser: SaxParser,
        DomParser: DomParser,
        Writer: Writer,
        Serializer: HtmlSerializer
      },
      Env: Env,
      AddOnManager: AddOnManager,
      Annotator: Annotator,
      Formatter: Formatter,
      UndoManager: UndoManager,
      EditorCommands: EditorCommands,
      WindowManager: WindowManager,
      NotificationManager: NotificationManager,
      EditorObservable: EditorObservable,
      Shortcuts: Shortcuts,
      Editor: Editor,
      FocusManager: FocusManager,
      EditorManager: EditorManager,
      DOM: DOMUtils.DOM,
      ScriptLoader: ScriptLoader.ScriptLoader,
      PluginManager: PluginManager,
      ThemeManager: ThemeManager,
      IconManager: IconManager,
      Resource: Resource,
      trim: Tools.trim,
      isArray: Tools.isArray,
      is: Tools.is,
      toArray: Tools.toArray,
      makeMap: Tools.makeMap,
      each: Tools.each,
      map: Tools.map,
      grep: Tools.grep,
      inArray: Tools.inArray,
      extend: Tools.extend,
      create: Tools.create,
      walk: Tools.walk,
      createNS: Tools.createNS,
      resolve: Tools.resolve,
      explode: Tools.explode,
      _addCacheSuffix: Tools._addCacheSuffix,
      isOpera: Env.opera,
      isWebKit: Env.webkit,
      isIE: Env.ie,
      isGecko: Env.gecko,
      isMac: Env.mac
    };
    var tinymce = Tools.extend(EditorManager, publicApi);

    var exportToModuleLoaders = function (tinymce) {
      if (true) {
        try {
          module.exports = tinymce;
        } catch (_) {
        }
      }
    };
    var exportToWindowGlobal = function (tinymce) {
      window.tinymce = tinymce;
      window.tinyMCE = tinymce;
    };
    exportToWindowGlobal(tinymce);
    exportToModuleLoaders(tinymce);

}());

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50), __webpack_require__(536).setImmediate))

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhQgBCALMAAP///9bW1jG1/ym1/yGt/yGt9xmt9xCt9xCl9wil9////wAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFFAAKACwAAAAAQgBCAAAE/1DJSau902iDu//gt21haZ7KOKJsS6mkK5+wNt9BHnQ1h+m72wWY46k6xKBwkixiVr/mkimVNZXL60w7VXBd32lSOO5SnWSdec1uu9/wMzY+VHvKdAteX83LgVF7fmEUhHmGEohxil5EfnyAd3aPFZGUl5iZmh4+nBkpF51xohZHPqSgVpM8LzESnaifIZaCrSunKT02uTVIjoypHLivLxWwspBXjqyguDDNyMd1ystPxMPCn9Kp3JXU1aHXxLw22a89gb/g4dDdou/RvrSr7O3vu+bFs/Qlx7euwlDFWnMKm75tyDYpXMhwET9KltKhuVTrz0OHFRtlhKMImJuOfUQeMdqI8aIchREbqlzJskRKVRO7kHS5Ls3MDx5R5JR088ROeTW3hPQWs9BQmyY39mTx0mLRk5p+Rj3KUurUpi01zpkSAQAh+QQFFAAKACwdAAAAFwANAAAEOFApQYW8OOPBu/4XIY4iaJ5oih5sy5qVJSF0bXaelOyJSZIqSWFIHAYVhqQyeXS5joqaDarg9RQRACH5BAUUAAoALDYAEAAIAAgAAAQbUClBhVQja0W670UohkZplkeqpgrivlciJ1IEACH5BAUUAAoALDoAHQAIAAgAAAQbUClBhVQja0W670UohkZplkeqpgrivlciJ1IEACH5BAUUAAoALDYAKgAIAAgAAAQbUClBhVQja0W670UohkZplkeqpgrivlciJ1IEACH5BAUUAAoALCwANQAIAAgAAAQbUClBhVQja0W670UohkZplkeqpgrivlciJ1IEACH5BAUUAAoALB0AOgAIAAgAAAQbUClBhVQja0W670UohkZplkeqpgrivlciJ1IEACH5BAUUAAoALAsAFQALACgAAAQyEKhJq7046827/2AojmRpnmiqrpbgCtcgzxVh3zZV7PxOGcAgkHIoGosVhHJ5STgTkwgAIfkEBRQACgAsBAAVAAgAHQAABClQyakCvTjrzbv/YCiOoWAK06CuCuG+biHPsmHf9qHvuoL8wElimJBEAAAh+QQFFAAKACwAAB0ACAAIAAAEG1ApQYVUI2tFuu9FKIZGaZZHqqYK4r5XIidSBAAh+QQFFAAKACwEABAACAAIAAAEG1ApQYVUI2tFuu9FKIZGaZZHqqYK4r5XIidSBAAh+QQJFAAKACwAAAAAQgBCAAAEa1DJSau9OOvNu/9gKI5kaZ5oWgqsoL7YIM9wLRF4jttw4f8+3stALBKFqoNyqUSqENCo85WoJqbYrHbL7Xq/4LB4TC6bz+i0es1uu9/wuHxOr9vv+Lx+z+/7/4CBgoOEhYaHiImKi4yNjmARADs="

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * vue-i18n v8.21.1 
 * (c) 2020 kazuya kawaguchi
 * Released under the MIT License.
 */
/*  */

/**
 * constants
 */

var numberFormatKeys = [
  'style',
  'currency',
  'currencyDisplay',
  'useGrouping',
  'minimumIntegerDigits',
  'minimumFractionDigits',
  'maximumFractionDigits',
  'minimumSignificantDigits',
  'maximumSignificantDigits',
  'localeMatcher',
  'formatMatcher',
  'unit'
];

/**
 * utilities
 */

function warn (msg, err) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-i18n] ' + msg);
    /* istanbul ignore if */
    if (err) {
      console.warn(err.stack);
    }
  }
}

function error (msg, err) {
  if (typeof console !== 'undefined') {
    console.error('[vue-i18n] ' + msg);
    /* istanbul ignore if */
    if (err) {
      console.error(err.stack);
    }
  }
}

var isArray = Array.isArray;

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isBoolean (val) {
  return typeof val === 'boolean'
}

function isString (val) {
  return typeof val === 'string'
}

var toString = Object.prototype.toString;
var OBJECT_STRING = '[object Object]';
function isPlainObject (obj) {
  return toString.call(obj) === OBJECT_STRING
}

function isNull (val) {
  return val === null || val === undefined
}

function isFunction (val) {
  return typeof val === 'function'
}

function parseArgs () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  var locale = null;
  var params = null;
  if (args.length === 1) {
    if (isObject(args[0]) || isArray(args[0])) {
      params = args[0];
    } else if (typeof args[0] === 'string') {
      locale = args[0];
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
      locale = args[0];
    }
    /* istanbul ignore if */
    if (isObject(args[1]) || isArray(args[1])) {
      params = args[1];
    }
  }

  return { locale: locale, params: params }
}

function looseClone (obj) {
  return JSON.parse(JSON.stringify(obj))
}

function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

function includes (arr, item) {
  return !!~arr.indexOf(item)
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

function merge (target) {
  var arguments$1 = arguments;

  var output = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments$1[i];
    if (source !== undefined && source !== null) {
      var key = (void 0);
      for (key in source) {
        if (hasOwn(source, key)) {
          if (isObject(source[key])) {
            output[key] = merge(output[key], source[key]);
          } else {
            output[key] = source[key];
          }
        }
      }
    }
  }
  return output
}

function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = isArray(a);
      var isArrayB = isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/*  */

function extend (Vue) {
  if (!Vue.prototype.hasOwnProperty('$i18n')) {
    // $FlowFixMe
    Object.defineProperty(Vue.prototype, '$i18n', {
      get: function get () { return this._i18n }
    });
  }

  Vue.prototype.$t = function (key) {
    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

    var i18n = this.$i18n;
    return i18n._t.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this ].concat( values ))
  };

  Vue.prototype.$tc = function (key, choice) {
    var values = [], len = arguments.length - 2;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];

    var i18n = this.$i18n;
    return i18n._tc.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this, choice ].concat( values ))
  };

  Vue.prototype.$te = function (key, locale) {
    var i18n = this.$i18n;
    return i18n._te(key, i18n.locale, i18n._getMessages(), locale)
  };

  Vue.prototype.$d = function (value) {
    var ref;

    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
    return (ref = this.$i18n).d.apply(ref, [ value ].concat( args ))
  };

  Vue.prototype.$n = function (value) {
    var ref;

    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
    return (ref = this.$i18n).n.apply(ref, [ value ].concat( args ))
  };
}

/*  */

var mixin = {
  beforeCreate: function beforeCreate () {
    var options = this.$options;
    options.i18n = options.i18n || (options.__i18n ? {} : null);

    if (options.i18n) {
      if (options.i18n instanceof VueI18n) {
        // init locale messages via custom blocks
        if (options.__i18n) {
          try {
            var localeMessages = options.i18n && options.i18n.messages ? options.i18n.messages : {};
            options.__i18n.forEach(function (resource) {
              localeMessages = merge(localeMessages, JSON.parse(resource));
            });
            Object.keys(localeMessages).forEach(function (locale) {
              options.i18n.mergeLocaleMessage(locale, localeMessages[locale]);
            });
          } catch (e) {
            if (true) {
              error("Cannot parse locale messages via custom blocks.", e);
            }
          }
        }
        this._i18n = options.i18n;
        this._i18nWatcher = this._i18n.watchI18nData();
      } else if (isPlainObject(options.i18n)) {
        var rootI18n = this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n
          ? this.$root.$i18n
          : null;
        // component local i18n
        if (rootI18n) {
          options.i18n.root = this.$root;
          options.i18n.formatter = rootI18n.formatter;
          options.i18n.fallbackLocale = rootI18n.fallbackLocale;
          options.i18n.formatFallbackMessages = rootI18n.formatFallbackMessages;
          options.i18n.silentTranslationWarn = rootI18n.silentTranslationWarn;
          options.i18n.silentFallbackWarn = rootI18n.silentFallbackWarn;
          options.i18n.pluralizationRules = rootI18n.pluralizationRules;
          options.i18n.preserveDirectiveContent = rootI18n.preserveDirectiveContent;
        }

        // init locale messages via custom blocks
        if (options.__i18n) {
          try {
            var localeMessages$1 = options.i18n && options.i18n.messages ? options.i18n.messages : {};
            options.__i18n.forEach(function (resource) {
              localeMessages$1 = merge(localeMessages$1, JSON.parse(resource));
            });
            options.i18n.messages = localeMessages$1;
          } catch (e) {
            if (true) {
              warn("Cannot parse locale messages via custom blocks.", e);
            }
          }
        }

        var ref = options.i18n;
        var sharedMessages = ref.sharedMessages;
        if (sharedMessages && isPlainObject(sharedMessages)) {
          options.i18n.messages = merge(options.i18n.messages, sharedMessages);
        }

        this._i18n = new VueI18n(options.i18n);
        this._i18nWatcher = this._i18n.watchI18nData();

        if (options.i18n.sync === undefined || !!options.i18n.sync) {
          this._localeWatcher = this.$i18n.watchLocale();
        }

        if (rootI18n) {
          rootI18n.onComponentInstanceCreated(this._i18n);
        }
      } else {
        if (true) {
          warn("Cannot be interpreted 'i18n' option.");
        }
      }
    } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
      // root i18n
      this._i18n = this.$root.$i18n;
    } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
      // parent i18n
      this._i18n = options.parent.$i18n;
    }
  },

  beforeMount: function beforeMount () {
    var options = this.$options;
    options.i18n = options.i18n || (options.__i18n ? {} : null);

    if (options.i18n) {
      if (options.i18n instanceof VueI18n) {
        // init locale messages via custom blocks
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      } else if (isPlainObject(options.i18n)) {
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      } else {
        if (true) {
          warn("Cannot be interpreted 'i18n' option.");
        }
      }
    } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
      this._i18n.subscribeDataChanging(this);
      this._subscribing = true;
    } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
      this._i18n.subscribeDataChanging(this);
      this._subscribing = true;
    }
  },

  beforeDestroy: function beforeDestroy () {
    if (!this._i18n) { return }

    var self = this;
    this.$nextTick(function () {
      if (self._subscribing) {
        self._i18n.unsubscribeDataChanging(self);
        delete self._subscribing;
      }

      if (self._i18nWatcher) {
        self._i18nWatcher();
        self._i18n.destroyVM();
        delete self._i18nWatcher;
      }

      if (self._localeWatcher) {
        self._localeWatcher();
        delete self._localeWatcher;
      }
    });
  }
};

/*  */

var interpolationComponent = {
  name: 'i18n',
  functional: true,
  props: {
    tag: {
      type: [String, Boolean, Object],
      default: 'span'
    },
    path: {
      type: String,
      required: true
    },
    locale: {
      type: String
    },
    places: {
      type: [Array, Object]
    }
  },
  render: function render (h, ref) {
    var data = ref.data;
    var parent = ref.parent;
    var props = ref.props;
    var slots = ref.slots;

    var $i18n = parent.$i18n;
    if (!$i18n) {
      if (true) {
        warn('Cannot find VueI18n instance!');
      }
      return
    }

    var path = props.path;
    var locale = props.locale;
    var places = props.places;
    var params = slots();
    var children = $i18n.i(
      path,
      locale,
      onlyHasDefaultPlace(params) || places
        ? useLegacyPlaces(params.default, places)
        : params
    );

    var tag = (!!props.tag && props.tag !== true) || props.tag === false ? props.tag : 'span';
    return tag ? h(tag, data, children) : children
  }
};

function onlyHasDefaultPlace (params) {
  var prop;
  for (prop in params) {
    if (prop !== 'default') { return false }
  }
  return Boolean(prop)
}

function useLegacyPlaces (children, places) {
  var params = places ? createParamsFromPlaces(places) : {};

  if (!children) { return params }

  // Filter empty text nodes
  children = children.filter(function (child) {
    return child.tag || child.text.trim() !== ''
  });

  var everyPlace = children.every(vnodeHasPlaceAttribute);
  if ("prod" !== 'production' && everyPlace) {
    warn('`place` attribute is deprecated in next major version. Please switch to Vue slots.');
  }

  return children.reduce(
    everyPlace ? assignChildPlace : assignChildIndex,
    params
  )
}

function createParamsFromPlaces (places) {
  if (true) {
    warn('`places` prop is deprecated in next major version. Please switch to Vue slots.');
  }

  return Array.isArray(places)
    ? places.reduce(assignChildIndex, {})
    : Object.assign({}, places)
}

function assignChildPlace (params, child) {
  if (child.data && child.data.attrs && child.data.attrs.place) {
    params[child.data.attrs.place] = child;
  }
  return params
}

function assignChildIndex (params, child, index) {
  params[index] = child;
  return params
}

function vnodeHasPlaceAttribute (vnode) {
  return Boolean(vnode.data && vnode.data.attrs && vnode.data.attrs.place)
}

/*  */

var numberComponent = {
  name: 'i18n-n',
  functional: true,
  props: {
    tag: {
      type: [String, Boolean, Object],
      default: 'span'
    },
    value: {
      type: Number,
      required: true
    },
    format: {
      type: [String, Object]
    },
    locale: {
      type: String
    }
  },
  render: function render (h, ref) {
    var props = ref.props;
    var parent = ref.parent;
    var data = ref.data;

    var i18n = parent.$i18n;

    if (!i18n) {
      if (true) {
        warn('Cannot find VueI18n instance!');
      }
      return null
    }

    var key = null;
    var options = null;

    if (isString(props.format)) {
      key = props.format;
    } else if (isObject(props.format)) {
      if (props.format.key) {
        key = props.format.key;
      }

      // Filter out number format options only
      options = Object.keys(props.format).reduce(function (acc, prop) {
        var obj;

        if (includes(numberFormatKeys, prop)) {
          return Object.assign({}, acc, ( obj = {}, obj[prop] = props.format[prop], obj ))
        }
        return acc
      }, null);
    }

    var locale = props.locale || i18n.locale;
    var parts = i18n._ntp(props.value, locale, key, options);

    var values = parts.map(function (part, index) {
      var obj;

      var slot = data.scopedSlots && data.scopedSlots[part.type];
      return slot ? slot(( obj = {}, obj[part.type] = part.value, obj.index = index, obj.parts = parts, obj )) : part.value
    });

    var tag = (!!props.tag && props.tag !== true) || props.tag === false ? props.tag : 'span';
    return tag
      ? h(tag, {
        attrs: data.attrs,
        'class': data['class'],
        staticClass: data.staticClass
      }, values)
      : values
  }
};

/*  */

function bind (el, binding, vnode) {
  if (!assert(el, vnode)) { return }

  t(el, binding, vnode);
}

function update (el, binding, vnode, oldVNode) {
  if (!assert(el, vnode)) { return }

  var i18n = vnode.context.$i18n;
  if (localeEqual(el, vnode) &&
    (looseEqual(binding.value, binding.oldValue) &&
     looseEqual(el._localeMessage, i18n.getLocaleMessage(i18n.locale)))) { return }

  t(el, binding, vnode);
}

function unbind (el, binding, vnode, oldVNode) {
  var vm = vnode.context;
  if (!vm) {
    warn('Vue instance does not exists in VNode context');
    return
  }

  var i18n = vnode.context.$i18n || {};
  if (!binding.modifiers.preserve && !i18n.preserveDirectiveContent) {
    el.textContent = '';
  }
  el._vt = undefined;
  delete el['_vt'];
  el._locale = undefined;
  delete el['_locale'];
  el._localeMessage = undefined;
  delete el['_localeMessage'];
}

function assert (el, vnode) {
  var vm = vnode.context;
  if (!vm) {
    warn('Vue instance does not exists in VNode context');
    return false
  }

  if (!vm.$i18n) {
    warn('VueI18n instance does not exists in Vue instance');
    return false
  }

  return true
}

function localeEqual (el, vnode) {
  var vm = vnode.context;
  return el._locale === vm.$i18n.locale
}

function t (el, binding, vnode) {
  var ref$1, ref$2;

  var value = binding.value;

  var ref = parseValue(value);
  var path = ref.path;
  var locale = ref.locale;
  var args = ref.args;
  var choice = ref.choice;
  if (!path && !locale && !args) {
    warn('value type not supported');
    return
  }

  if (!path) {
    warn('`path` is required in v-t directive');
    return
  }

  var vm = vnode.context;
  if (choice != null) {
    el._vt = el.textContent = (ref$1 = vm.$i18n).tc.apply(ref$1, [ path, choice ].concat( makeParams(locale, args) ));
  } else {
    el._vt = el.textContent = (ref$2 = vm.$i18n).t.apply(ref$2, [ path ].concat( makeParams(locale, args) ));
  }
  el._locale = vm.$i18n.locale;
  el._localeMessage = vm.$i18n.getLocaleMessage(vm.$i18n.locale);
}

function parseValue (value) {
  var path;
  var locale;
  var args;
  var choice;

  if (isString(value)) {
    path = value;
  } else if (isPlainObject(value)) {
    path = value.path;
    locale = value.locale;
    args = value.args;
    choice = value.choice;
  }

  return { path: path, locale: locale, args: args, choice: choice }
}

function makeParams (locale, args) {
  var params = [];

  locale && params.push(locale);
  if (args && (Array.isArray(args) || isPlainObject(args))) {
    params.push(args);
  }

  return params
}

var Vue;

function install (_Vue) {
  /* istanbul ignore if */
  if ("prod" !== 'production' && install.installed && _Vue === Vue) {
    warn('already installed.');
    return
  }
  install.installed = true;

  Vue = _Vue;

  var version = (Vue.version && Number(Vue.version.split('.')[0])) || -1;
  /* istanbul ignore if */
  if ("prod" !== 'production' && version < 2) {
    warn(("vue-i18n (" + (install.version) + ") need to use Vue 2.0 or later (Vue: " + (Vue.version) + ")."));
    return
  }

  extend(Vue);
  Vue.mixin(mixin);
  Vue.directive('t', { bind: bind, update: update, unbind: unbind });
  Vue.component(interpolationComponent.name, interpolationComponent);
  Vue.component(numberComponent.name, numberComponent);

  // use simple mergeStrategies to prevent i18n instance lose '__proto__'
  var strats = Vue.config.optionMergeStrategies;
  strats.i18n = function (parentVal, childVal) {
    return childVal === undefined
      ? parentVal
      : childVal
  };
}

/*  */

var BaseFormatter = function BaseFormatter () {
  this._caches = Object.create(null);
};

BaseFormatter.prototype.interpolate = function interpolate (message, values) {
  if (!values) {
    return [message]
  }
  var tokens = this._caches[message];
  if (!tokens) {
    tokens = parse(message);
    this._caches[message] = tokens;
  }
  return compile(tokens, values)
};



var RE_TOKEN_LIST_VALUE = /^(?:\d)+/;
var RE_TOKEN_NAMED_VALUE = /^(?:\w)+/;

function parse (format) {
  var tokens = [];
  var position = 0;

  var text = '';
  while (position < format.length) {
    var char = format[position++];
    if (char === '{') {
      if (text) {
        tokens.push({ type: 'text', value: text });
      }

      text = '';
      var sub = '';
      char = format[position++];
      while (char !== undefined && char !== '}') {
        sub += char;
        char = format[position++];
      }
      var isClosed = char === '}';

      var type = RE_TOKEN_LIST_VALUE.test(sub)
        ? 'list'
        : isClosed && RE_TOKEN_NAMED_VALUE.test(sub)
          ? 'named'
          : 'unknown';
      tokens.push({ value: sub, type: type });
    } else if (char === '%') {
      // when found rails i18n syntax, skip text capture
      if (format[(position)] !== '{') {
        text += char;
      }
    } else {
      text += char;
    }
  }

  text && tokens.push({ type: 'text', value: text });

  return tokens
}

function compile (tokens, values) {
  var compiled = [];
  var index = 0;

  var mode = Array.isArray(values)
    ? 'list'
    : isObject(values)
      ? 'named'
      : 'unknown';
  if (mode === 'unknown') { return compiled }

  while (index < tokens.length) {
    var token = tokens[index];
    switch (token.type) {
      case 'text':
        compiled.push(token.value);
        break
      case 'list':
        compiled.push(values[parseInt(token.value, 10)]);
        break
      case 'named':
        if (mode === 'named') {
          compiled.push((values)[token.value]);
        } else {
          if (true) {
            warn(("Type of token '" + (token.type) + "' and format of value '" + mode + "' don't match!"));
          }
        }
        break
      case 'unknown':
        if (true) {
          warn("Detect 'unknown' type of token!");
        }
        break
    }
    index++;
  }

  return compiled
}

/*  */

/**
 *  Path parser
 *  - Inspired:
 *    Vue.js Path parser
 */

// actions
var APPEND = 0;
var PUSH = 1;
var INC_SUB_PATH_DEPTH = 2;
var PUSH_SUB_PATH = 3;

// states
var BEFORE_PATH = 0;
var IN_PATH = 1;
var BEFORE_IDENT = 2;
var IN_IDENT = 3;
var IN_SUB_PATH = 4;
var IN_SINGLE_QUOTE = 5;
var IN_DOUBLE_QUOTE = 6;
var AFTER_PATH = 7;
var ERROR = 8;

var pathStateMachine = [];

pathStateMachine[BEFORE_PATH] = {
  'ws': [BEFORE_PATH],
  'ident': [IN_IDENT, APPEND],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[IN_PATH] = {
  'ws': [IN_PATH],
  '.': [BEFORE_IDENT],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[BEFORE_IDENT] = {
  'ws': [BEFORE_IDENT],
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND]
};

pathStateMachine[IN_IDENT] = {
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND],
  'ws': [IN_PATH, PUSH],
  '.': [BEFORE_IDENT, PUSH],
  '[': [IN_SUB_PATH, PUSH],
  'eof': [AFTER_PATH, PUSH]
};

pathStateMachine[IN_SUB_PATH] = {
  "'": [IN_SINGLE_QUOTE, APPEND],
  '"': [IN_DOUBLE_QUOTE, APPEND],
  '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
  ']': [IN_PATH, PUSH_SUB_PATH],
  'eof': ERROR,
  'else': [IN_SUB_PATH, APPEND]
};

pathStateMachine[IN_SINGLE_QUOTE] = {
  "'": [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_SINGLE_QUOTE, APPEND]
};

pathStateMachine[IN_DOUBLE_QUOTE] = {
  '"': [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_DOUBLE_QUOTE, APPEND]
};

/**
 * Check if an expression is a literal value.
 */

var literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral (exp) {
  return literalValueRE.test(exp)
}

/**
 * Strip quotes from a string
 */

function stripQuotes (str) {
  var a = str.charCodeAt(0);
  var b = str.charCodeAt(str.length - 1);
  return a === b && (a === 0x22 || a === 0x27)
    ? str.slice(1, -1)
    : str
}

/**
 * Determine the type of a character in a keypath.
 */

function getPathCharType (ch) {
  if (ch === undefined || ch === null) { return 'eof' }

  var code = ch.charCodeAt(0);

  switch (code) {
    case 0x5B: // [
    case 0x5D: // ]
    case 0x2E: // .
    case 0x22: // "
    case 0x27: // '
      return ch

    case 0x5F: // _
    case 0x24: // $
    case 0x2D: // -
      return 'ident'

    case 0x09: // Tab
    case 0x0A: // Newline
    case 0x0D: // Return
    case 0xA0:  // No-break space
    case 0xFEFF:  // Byte Order Mark
    case 0x2028:  // Line Separator
    case 0x2029:  // Paragraph Separator
      return 'ws'
  }

  return 'ident'
}

/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */

function formatSubPath (path) {
  var trimmed = path.trim();
  // invalid leading 0
  if (path.charAt(0) === '0' && isNaN(path)) { return false }

  return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed
}

/**
 * Parse a string path into an array of segments
 */

function parse$1 (path) {
  var keys = [];
  var index = -1;
  var mode = BEFORE_PATH;
  var subPathDepth = 0;
  var c;
  var key;
  var newChar;
  var type;
  var transition;
  var action;
  var typeMap;
  var actions = [];

  actions[PUSH] = function () {
    if (key !== undefined) {
      keys.push(key);
      key = undefined;
    }
  };

  actions[APPEND] = function () {
    if (key === undefined) {
      key = newChar;
    } else {
      key += newChar;
    }
  };

  actions[INC_SUB_PATH_DEPTH] = function () {
    actions[APPEND]();
    subPathDepth++;
  };

  actions[PUSH_SUB_PATH] = function () {
    if (subPathDepth > 0) {
      subPathDepth--;
      mode = IN_SUB_PATH;
      actions[APPEND]();
    } else {
      subPathDepth = 0;
      if (key === undefined) { return false }
      key = formatSubPath(key);
      if (key === false) {
        return false
      } else {
        actions[PUSH]();
      }
    }
  };

  function maybeUnescapeQuote () {
    var nextChar = path[index + 1];
    if ((mode === IN_SINGLE_QUOTE && nextChar === "'") ||
      (mode === IN_DOUBLE_QUOTE && nextChar === '"')) {
      index++;
      newChar = '\\' + nextChar;
      actions[APPEND]();
      return true
    }
  }

  while (mode !== null) {
    index++;
    c = path[index];

    if (c === '\\' && maybeUnescapeQuote()) {
      continue
    }

    type = getPathCharType(c);
    typeMap = pathStateMachine[mode];
    transition = typeMap[type] || typeMap['else'] || ERROR;

    if (transition === ERROR) {
      return // parse error
    }

    mode = transition[0];
    action = actions[transition[1]];
    if (action) {
      newChar = transition[2];
      newChar = newChar === undefined
        ? c
        : newChar;
      if (action() === false) {
        return
      }
    }

    if (mode === AFTER_PATH) {
      return keys
    }
  }
}





var I18nPath = function I18nPath () {
  this._cache = Object.create(null);
};

/**
 * External parse that check for a cache hit first
 */
I18nPath.prototype.parsePath = function parsePath (path) {
  var hit = this._cache[path];
  if (!hit) {
    hit = parse$1(path);
    if (hit) {
      this._cache[path] = hit;
    }
  }
  return hit || []
};

/**
 * Get path value from path string
 */
I18nPath.prototype.getPathValue = function getPathValue (obj, path) {
  if (!isObject(obj)) { return null }

  var paths = this.parsePath(path);
  if (paths.length === 0) {
    return null
  } else {
    var length = paths.length;
    var last = obj;
    var i = 0;
    while (i < length) {
      var value = last[paths[i]];
      if (value === undefined) {
        return null
      }
      last = value;
      i++;
    }

    return last
  }
};

/*  */



var htmlTagMatcher = /<\/?[\w\s="/.':;#-\/]+>/;
var linkKeyMatcher = /(?:@(?:\.[a-z]+)?:(?:[\w\-_|.]+|\([\w\-_|.]+\)))/g;
var linkKeyPrefixMatcher = /^@(?:\.([a-z]+))?:/;
var bracketsMatcher = /[()]/g;
var defaultModifiers = {
  'upper': function (str) { return str.toLocaleUpperCase(); },
  'lower': function (str) { return str.toLocaleLowerCase(); },
  'capitalize': function (str) { return ("" + (str.charAt(0).toLocaleUpperCase()) + (str.substr(1))); }
};

var defaultFormatter = new BaseFormatter();

var VueI18n = function VueI18n (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #290
  /* istanbul ignore if */
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  var locale = options.locale || 'en-US';
  var fallbackLocale = options.fallbackLocale === false
    ? false
    : options.fallbackLocale || 'en-US';
  var messages = options.messages || {};
  var dateTimeFormats = options.dateTimeFormats || {};
  var numberFormats = options.numberFormats || {};

  this._vm = null;
  this._formatter = options.formatter || defaultFormatter;
  this._modifiers = options.modifiers || {};
  this._missing = options.missing || null;
  this._root = options.root || null;
  this._sync = options.sync === undefined ? true : !!options.sync;
  this._fallbackRoot = options.fallbackRoot === undefined
    ? true
    : !!options.fallbackRoot;
  this._formatFallbackMessages = options.formatFallbackMessages === undefined
    ? false
    : !!options.formatFallbackMessages;
  this._silentTranslationWarn = options.silentTranslationWarn === undefined
    ? false
    : options.silentTranslationWarn;
  this._silentFallbackWarn = options.silentFallbackWarn === undefined
    ? false
    : !!options.silentFallbackWarn;
  this._dateTimeFormatters = {};
  this._numberFormatters = {};
  this._path = new I18nPath();
  this._dataListeners = [];
  this._componentInstanceCreatedListener = options.componentInstanceCreatedListener || null;
  this._preserveDirectiveContent = options.preserveDirectiveContent === undefined
    ? false
    : !!options.preserveDirectiveContent;
  this.pluralizationRules = options.pluralizationRules || {};
  this._warnHtmlInMessage = options.warnHtmlInMessage || 'off';
  this._postTranslation = options.postTranslation || null;

  /**
   * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
   * @param choicesLength {number} an overall amount of available choices
   * @returns a final choice index
  */
  this.getChoiceIndex = function (choice, choicesLength) {
    var thisPrototype = Object.getPrototypeOf(this$1);
    if (thisPrototype && thisPrototype.getChoiceIndex) {
      var prototypeGetChoiceIndex = (thisPrototype.getChoiceIndex);
      return (prototypeGetChoiceIndex).call(this$1, choice, choicesLength)
    }

    // Default (old) getChoiceIndex implementation - english-compatible
    var defaultImpl = function (_choice, _choicesLength) {
      _choice = Math.abs(_choice);

      if (_choicesLength === 2) {
        return _choice
          ? _choice > 1
            ? 1
            : 0
          : 1
      }

      return _choice ? Math.min(_choice, 2) : 0
    };

    if (this$1.locale in this$1.pluralizationRules) {
      return this$1.pluralizationRules[this$1.locale].apply(this$1, [choice, choicesLength])
    } else {
      return defaultImpl(choice, choicesLength)
    }
  };


  this._exist = function (message, key) {
    if (!message || !key) { return false }
    if (!isNull(this$1._path.getPathValue(message, key))) { return true }
    // fallback for flat key
    if (message[key]) { return true }
    return false
  };

  if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    Object.keys(messages).forEach(function (locale) {
      this$1._checkLocaleMessage(locale, this$1._warnHtmlInMessage, messages[locale]);
    });
  }

  this._initVM({
    locale: locale,
    fallbackLocale: fallbackLocale,
    messages: messages,
    dateTimeFormats: dateTimeFormats,
    numberFormats: numberFormats
  });
};

var prototypeAccessors = { vm: { configurable: true },messages: { configurable: true },dateTimeFormats: { configurable: true },numberFormats: { configurable: true },availableLocales: { configurable: true },locale: { configurable: true },fallbackLocale: { configurable: true },formatFallbackMessages: { configurable: true },missing: { configurable: true },formatter: { configurable: true },silentTranslationWarn: { configurable: true },silentFallbackWarn: { configurable: true },preserveDirectiveContent: { configurable: true },warnHtmlInMessage: { configurable: true },postTranslation: { configurable: true } };

VueI18n.prototype._checkLocaleMessage = function _checkLocaleMessage (locale, level, message) {
  var paths = [];

  var fn = function (level, locale, message, paths) {
    if (isPlainObject(message)) {
      Object.keys(message).forEach(function (key) {
        var val = message[key];
        if (isPlainObject(val)) {
          paths.push(key);
          paths.push('.');
          fn(level, locale, val, paths);
          paths.pop();
          paths.pop();
        } else {
          paths.push(key);
          fn(level, locale, val, paths);
          paths.pop();
        }
      });
    } else if (isArray(message)) {
      message.forEach(function (item, index) {
        if (isPlainObject(item)) {
          paths.push(("[" + index + "]"));
          paths.push('.');
          fn(level, locale, item, paths);
          paths.pop();
          paths.pop();
        } else {
          paths.push(("[" + index + "]"));
          fn(level, locale, item, paths);
          paths.pop();
        }
      });
    } else if (isString(message)) {
      var ret = htmlTagMatcher.test(message);
      if (ret) {
        var msg = "Detected HTML in message '" + message + "' of keypath '" + (paths.join('')) + "' at '" + locale + "'. Consider component interpolation with '<i18n>' to avoid XSS. See https://bit.ly/2ZqJzkp";
        if (level === 'warn') {
          warn(msg);
        } else if (level === 'error') {
          error(msg);
        }
      }
    }
  };

  fn(level, locale, message, paths);
};

VueI18n.prototype._initVM = function _initVM (data) {
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  this._vm = new Vue({ data: data });
  Vue.config.silent = silent;
};

VueI18n.prototype.destroyVM = function destroyVM () {
  this._vm.$destroy();
};

VueI18n.prototype.subscribeDataChanging = function subscribeDataChanging (vm) {
  this._dataListeners.push(vm);
};

VueI18n.prototype.unsubscribeDataChanging = function unsubscribeDataChanging (vm) {
  remove(this._dataListeners, vm);
};

VueI18n.prototype.watchI18nData = function watchI18nData () {
  var self = this;
  return this._vm.$watch('$data', function () {
    var i = self._dataListeners.length;
    while (i--) {
      Vue.nextTick(function () {
        self._dataListeners[i] && self._dataListeners[i].$forceUpdate();
      });
    }
  }, { deep: true })
};

VueI18n.prototype.watchLocale = function watchLocale () {
  /* istanbul ignore if */
  if (!this._sync || !this._root) { return null }
  var target = this._vm;
  return this._root.$i18n.vm.$watch('locale', function (val) {
    target.$set(target, 'locale', val);
    target.$forceUpdate();
  }, { immediate: true })
};

VueI18n.prototype.onComponentInstanceCreated = function onComponentInstanceCreated (newI18n) {
  if (this._componentInstanceCreatedListener) {
    this._componentInstanceCreatedListener(newI18n, this);
  }
};

prototypeAccessors.vm.get = function () { return this._vm };

prototypeAccessors.messages.get = function () { return looseClone(this._getMessages()) };
prototypeAccessors.dateTimeFormats.get = function () { return looseClone(this._getDateTimeFormats()) };
prototypeAccessors.numberFormats.get = function () { return looseClone(this._getNumberFormats()) };
prototypeAccessors.availableLocales.get = function () { return Object.keys(this.messages).sort() };

prototypeAccessors.locale.get = function () { return this._vm.locale };
prototypeAccessors.locale.set = function (locale) {
  this._vm.$set(this._vm, 'locale', locale);
};

prototypeAccessors.fallbackLocale.get = function () { return this._vm.fallbackLocale };
prototypeAccessors.fallbackLocale.set = function (locale) {
  this._localeChainCache = {};
  this._vm.$set(this._vm, 'fallbackLocale', locale);
};

prototypeAccessors.formatFallbackMessages.get = function () { return this._formatFallbackMessages };
prototypeAccessors.formatFallbackMessages.set = function (fallback) { this._formatFallbackMessages = fallback; };

prototypeAccessors.missing.get = function () { return this._missing };
prototypeAccessors.missing.set = function (handler) { this._missing = handler; };

prototypeAccessors.formatter.get = function () { return this._formatter };
prototypeAccessors.formatter.set = function (formatter) { this._formatter = formatter; };

prototypeAccessors.silentTranslationWarn.get = function () { return this._silentTranslationWarn };
prototypeAccessors.silentTranslationWarn.set = function (silent) { this._silentTranslationWarn = silent; };

prototypeAccessors.silentFallbackWarn.get = function () { return this._silentFallbackWarn };
prototypeAccessors.silentFallbackWarn.set = function (silent) { this._silentFallbackWarn = silent; };

prototypeAccessors.preserveDirectiveContent.get = function () { return this._preserveDirectiveContent };
prototypeAccessors.preserveDirectiveContent.set = function (preserve) { this._preserveDirectiveContent = preserve; };

prototypeAccessors.warnHtmlInMessage.get = function () { return this._warnHtmlInMessage };
prototypeAccessors.warnHtmlInMessage.set = function (level) {
    var this$1 = this;

  var orgLevel = this._warnHtmlInMessage;
  this._warnHtmlInMessage = level;
  if (orgLevel !== level && (level === 'warn' || level === 'error')) {
    var messages = this._getMessages();
    Object.keys(messages).forEach(function (locale) {
      this$1._checkLocaleMessage(locale, this$1._warnHtmlInMessage, messages[locale]);
    });
  }
};

prototypeAccessors.postTranslation.get = function () { return this._postTranslation };
prototypeAccessors.postTranslation.set = function (handler) { this._postTranslation = handler; };

VueI18n.prototype._getMessages = function _getMessages () { return this._vm.messages };
VueI18n.prototype._getDateTimeFormats = function _getDateTimeFormats () { return this._vm.dateTimeFormats };
VueI18n.prototype._getNumberFormats = function _getNumberFormats () { return this._vm.numberFormats };

VueI18n.prototype._warnDefault = function _warnDefault (locale, key, result, vm, values, interpolateMode) {
  if (!isNull(result)) { return result }
  if (this._missing) {
    var missingRet = this._missing.apply(null, [locale, key, vm, values]);
    if (isString(missingRet)) {
      return missingRet
    }
  } else {
    if ("prod" !== 'production' && !this._isSilentTranslationWarn(key)) {
      warn(
        "Cannot translate the value of keypath '" + key + "'. " +
        'Use the value of keypath as default.'
      );
    }
  }

  if (this._formatFallbackMessages) {
    var parsedArgs = parseArgs.apply(void 0, values);
    return this._render(key, interpolateMode, parsedArgs.params, key)
  } else {
    return key
  }
};

VueI18n.prototype._isFallbackRoot = function _isFallbackRoot (val) {
  return !val && !isNull(this._root) && this._fallbackRoot
};

VueI18n.prototype._isSilentFallbackWarn = function _isSilentFallbackWarn (key) {
  return this._silentFallbackWarn instanceof RegExp
    ? this._silentFallbackWarn.test(key)
    : this._silentFallbackWarn
};

VueI18n.prototype._isSilentFallback = function _isSilentFallback (locale, key) {
  return this._isSilentFallbackWarn(key) && (this._isFallbackRoot() || locale !== this.fallbackLocale)
};

VueI18n.prototype._isSilentTranslationWarn = function _isSilentTranslationWarn (key) {
  return this._silentTranslationWarn instanceof RegExp
    ? this._silentTranslationWarn.test(key)
    : this._silentTranslationWarn
};

VueI18n.prototype._interpolate = function _interpolate (
  locale,
  message,
  key,
  host,
  interpolateMode,
  values,
  visitedLinkStack
) {
  if (!message) { return null }

  var pathRet = this._path.getPathValue(message, key);
  if (isArray(pathRet) || isPlainObject(pathRet)) { return pathRet }

  var ret;
  if (isNull(pathRet)) {
    /* istanbul ignore else */
    if (isPlainObject(message)) {
      ret = message[key];
      if (!(isString(ret) || isFunction(ret))) {
        if ("prod" !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallback(locale, key)) {
          warn(("Value of key '" + key + "' is not a string or function !"));
        }
        return null
      }
    } else {
      return null
    }
  } else {
    /* istanbul ignore else */
    if (isString(pathRet) || isFunction(pathRet)) {
      ret = pathRet;
    } else {
      if ("prod" !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallback(locale, key)) {
        warn(("Value of key '" + key + "' is not a string or function!"));
      }
      return null
    }
  }

  // Check for the existence of links within the translated string
  if (isString(ret) && (ret.indexOf('@:') >= 0 || ret.indexOf('@.') >= 0)) {
    ret = this._link(locale, message, ret, host, 'raw', values, visitedLinkStack);
  }

  return this._render(ret, interpolateMode, values, key)
};

VueI18n.prototype._link = function _link (
  locale,
  message,
  str,
  host,
  interpolateMode,
  values,
  visitedLinkStack
) {
  var ret = str;

  // Match all the links within the local
  // We are going to replace each of
  // them with its translation
  var matches = ret.match(linkKeyMatcher);
  for (var idx in matches) {
    // ie compatible: filter custom array
    // prototype method
    if (!matches.hasOwnProperty(idx)) {
      continue
    }
    var link = matches[idx];
    var linkKeyPrefixMatches = link.match(linkKeyPrefixMatcher);
    var linkPrefix = linkKeyPrefixMatches[0];
      var formatterName = linkKeyPrefixMatches[1];

    // Remove the leading @:, @.case: and the brackets
    var linkPlaceholder = link.replace(linkPrefix, '').replace(bracketsMatcher, '');

    if (includes(visitedLinkStack, linkPlaceholder)) {
      if (true) {
        warn(("Circular reference found. \"" + link + "\" is already visited in the chain of " + (visitedLinkStack.reverse().join(' <- '))));
      }
      return ret
    }
    visitedLinkStack.push(linkPlaceholder);

    // Translate the link
    var translated = this._interpolate(
      locale, message, linkPlaceholder, host,
      interpolateMode === 'raw' ? 'string' : interpolateMode,
      interpolateMode === 'raw' ? undefined : values,
      visitedLinkStack
    );

    if (this._isFallbackRoot(translated)) {
      if ("prod" !== 'production' && !this._isSilentTranslationWarn(linkPlaceholder)) {
        warn(("Fall back to translate the link placeholder '" + linkPlaceholder + "' with root locale."));
      }
      /* istanbul ignore if */
      if (!this._root) { throw Error('unexpected error') }
      var root = this._root.$i18n;
      translated = root._translate(
        root._getMessages(), root.locale, root.fallbackLocale,
        linkPlaceholder, host, interpolateMode, values
      );
    }
    translated = this._warnDefault(
      locale, linkPlaceholder, translated, host,
      isArray(values) ? values : [values],
      interpolateMode
    );

    if (this._modifiers.hasOwnProperty(formatterName)) {
      translated = this._modifiers[formatterName](translated);
    } else if (defaultModifiers.hasOwnProperty(formatterName)) {
      translated = defaultModifiers[formatterName](translated);
    }

    visitedLinkStack.pop();

    // Replace the link with the translated
    ret = !translated ? ret : ret.replace(link, translated);
  }

  return ret
};

VueI18n.prototype._createMessageContext = function _createMessageContext (values) {
  var _list = isArray(values) ? values : [];
  var _named = isObject(values) ? values : {};
  var list = function (index) { return _list[index]; };
  var named = function (key) { return _named[key]; };
  return {
    list: list,
    named: named
  }
};

VueI18n.prototype._render = function _render (message, interpolateMode, values, path) {
  if (isFunction(message)) {
    return message(this._createMessageContext(values))
  }

  var ret = this._formatter.interpolate(message, values, path);

  // If the custom formatter refuses to work - apply the default one
  if (!ret) {
    ret = defaultFormatter.interpolate(message, values, path);
  }

  // if interpolateMode is **not** 'string' ('row'),
  // return the compiled data (e.g. ['foo', VNode, 'bar']) with formatter
  return interpolateMode === 'string' && !isString(ret) ? ret.join('') : ret
};

VueI18n.prototype._appendItemToChain = function _appendItemToChain (chain, item, blocks) {
  var follow = false;
  if (!includes(chain, item)) {
    follow = true;
    if (item) {
      follow = item[item.length - 1] !== '!';
      item = item.replace(/!/g, '');
      chain.push(item);
      if (blocks && blocks[item]) {
        follow = blocks[item];
      }
    }
  }
  return follow
};

VueI18n.prototype._appendLocaleToChain = function _appendLocaleToChain (chain, locale, blocks) {
  var follow;
  var tokens = locale.split('-');
  do {
    var item = tokens.join('-');
    follow = this._appendItemToChain(chain, item, blocks);
    tokens.splice(-1, 1);
  } while (tokens.length && (follow === true))
  return follow
};

VueI18n.prototype._appendBlockToChain = function _appendBlockToChain (chain, block, blocks) {
  var follow = true;
  for (var i = 0; (i < block.length) && (isBoolean(follow)); i++) {
    var locale = block[i];
    if (isString(locale)) {
      follow = this._appendLocaleToChain(chain, locale, blocks);
    }
  }
  return follow
};

VueI18n.prototype._getLocaleChain = function _getLocaleChain (start, fallbackLocale) {
  if (start === '') { return [] }

  if (!this._localeChainCache) {
    this._localeChainCache = {};
  }

  var chain = this._localeChainCache[start];
  if (!chain) {
    if (!fallbackLocale) {
      fallbackLocale = this.fallbackLocale;
    }
    chain = [];

    // first block defined by start
    var block = [start];

    // while any intervening block found
    while (isArray(block)) {
      block = this._appendBlockToChain(
        chain,
        block,
        fallbackLocale
      );
    }

    // last block defined by default
    var defaults;
    if (isArray(fallbackLocale)) {
      defaults = fallbackLocale;
    } else if (isObject(fallbackLocale)) {
      /* $FlowFixMe */
      if (fallbackLocale['default']) {
        defaults = fallbackLocale['default'];
      } else {
        defaults = null;
      }
    } else {
      defaults = fallbackLocale;
    }

    // convert defaults to array
    if (isString(defaults)) {
      block = [defaults];
    } else {
      block = defaults;
    }
    if (block) {
      this._appendBlockToChain(
        chain,
        block,
        null
      );
    }
    this._localeChainCache[start] = chain;
  }
  return chain
};

VueI18n.prototype._translate = function _translate (
  messages,
  locale,
  fallback,
  key,
  host,
  interpolateMode,
  args
) {
  var chain = this._getLocaleChain(locale, fallback);
  var res;
  for (var i = 0; i < chain.length; i++) {
    var step = chain[i];
    res =
      this._interpolate(step, messages[step], key, host, interpolateMode, args, [key]);
    if (!isNull(res)) {
      if (step !== locale && "prod" !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn(("Fall back to translate the keypath '" + key + "' with '" + step + "' locale."));
      }
      return res
    }
  }
  return null
};

VueI18n.prototype._t = function _t (key, _locale, messages, host) {
    var ref;

    var values = [], len = arguments.length - 4;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 4 ];
  if (!key) { return '' }

  var parsedArgs = parseArgs.apply(void 0, values);
  var locale = parsedArgs.locale || _locale;

  var ret = this._translate(
    messages, locale, this.fallbackLocale, key,
    host, 'string', parsedArgs.params
  );
  if (this._isFallbackRoot(ret)) {
    if ("prod" !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
      warn(("Fall back to translate the keypath '" + key + "' with root locale."));
    }
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return (ref = this._root).$t.apply(ref, [ key ].concat( values ))
  } else {
    ret = this._warnDefault(locale, key, ret, host, values, 'string');
    if (this._postTranslation && ret !== null && ret !== undefined) {
      ret = this._postTranslation(ret, key);
    }
    return ret
  }
};

VueI18n.prototype.t = function t (key) {
    var ref;

    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];
  return (ref = this)._t.apply(ref, [ key, this.locale, this._getMessages(), null ].concat( values ))
};

VueI18n.prototype._i = function _i (key, locale, messages, host, values) {
  var ret =
    this._translate(messages, locale, this.fallbackLocale, key, host, 'raw', values);
  if (this._isFallbackRoot(ret)) {
    if ("prod" !== 'production' && !this._isSilentTranslationWarn(key)) {
      warn(("Fall back to interpolate the keypath '" + key + "' with root locale."));
    }
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.i(key, locale, values)
  } else {
    return this._warnDefault(locale, key, ret, host, [values], 'raw')
  }
};

VueI18n.prototype.i = function i (key, locale, values) {
  /* istanbul ignore if */
  if (!key) { return '' }

  if (!isString(locale)) {
    locale = this.locale;
  }

  return this._i(key, locale, this._getMessages(), null, values)
};

VueI18n.prototype._tc = function _tc (
  key,
  _locale,
  messages,
  host,
  choice
) {
    var ref;

    var values = [], len = arguments.length - 5;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 5 ];
  if (!key) { return '' }
  if (choice === undefined) {
    choice = 1;
  }

  var predefined = { 'count': choice, 'n': choice };
  var parsedArgs = parseArgs.apply(void 0, values);
  parsedArgs.params = Object.assign(predefined, parsedArgs.params);
  values = parsedArgs.locale === null ? [parsedArgs.params] : [parsedArgs.locale, parsedArgs.params];
  return this.fetchChoice((ref = this)._t.apply(ref, [ key, _locale, messages, host ].concat( values )), choice)
};

VueI18n.prototype.fetchChoice = function fetchChoice (message, choice) {
  /* istanbul ignore if */
  if (!message && !isString(message)) { return null }
  var choices = message.split('|');

  choice = this.getChoiceIndex(choice, choices.length);
  if (!choices[choice]) { return message }
  return choices[choice].trim()
};

VueI18n.prototype.tc = function tc (key, choice) {
    var ref;

    var values = [], len = arguments.length - 2;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];
  return (ref = this)._tc.apply(ref, [ key, this.locale, this._getMessages(), null, choice ].concat( values ))
};

VueI18n.prototype._te = function _te (key, locale, messages) {
    var args = [], len = arguments.length - 3;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 3 ];

  var _locale = parseArgs.apply(void 0, args).locale || locale;
  return this._exist(messages[_locale], key)
};

VueI18n.prototype.te = function te (key, locale) {
  return this._te(key, this.locale, this._getMessages(), locale)
};

VueI18n.prototype.getLocaleMessage = function getLocaleMessage (locale) {
  return looseClone(this._vm.messages[locale] || {})
};

VueI18n.prototype.setLocaleMessage = function setLocaleMessage (locale, message) {
  if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
  }
  this._vm.$set(this._vm.messages, locale, message);
};

VueI18n.prototype.mergeLocaleMessage = function mergeLocaleMessage (locale, message) {
  if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
  }
  this._vm.$set(this._vm.messages, locale, merge({}, this._vm.messages[locale] || {}, message));
};

VueI18n.prototype.getDateTimeFormat = function getDateTimeFormat (locale) {
  return looseClone(this._vm.dateTimeFormats[locale] || {})
};

VueI18n.prototype.setDateTimeFormat = function setDateTimeFormat (locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, format);
  this._clearDateTimeFormat(locale, format);
};

VueI18n.prototype.mergeDateTimeFormat = function mergeDateTimeFormat (locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, merge(this._vm.dateTimeFormats[locale] || {}, format));
  this._clearDateTimeFormat(locale, format);
};

VueI18n.prototype._clearDateTimeFormat = function _clearDateTimeFormat (locale, format) {
  for (var key in format) {
    var id = locale + "__" + key;

    if (!this._dateTimeFormatters.hasOwnProperty(id)) {
      continue
    }

    delete this._dateTimeFormatters[id];
  }
};

VueI18n.prototype._localizeDateTime = function _localizeDateTime (
  value,
  locale,
  fallback,
  dateTimeFormats,
  key
) {
  var _locale = locale;
  var formats = dateTimeFormats[_locale];

  var chain = this._getLocaleChain(locale, fallback);
  for (var i = 0; i < chain.length; i++) {
    var current = _locale;
    var step = chain[i];
    formats = dateTimeFormats[step];
    _locale = step;
    // fallback locale
    if (isNull(formats) || isNull(formats[key])) {
      if (step !== locale && "prod" !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn(("Fall back to '" + step + "' datetime formats from '" + current + "' datetime formats."));
      }
    } else {
      break
    }
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];
    var id = _locale + "__" + key;
    var formatter = this._dateTimeFormatters[id];
    if (!formatter) {
      formatter = this._dateTimeFormatters[id] = new Intl.DateTimeFormat(_locale, format);
    }
    return formatter.format(value)
  }
};

VueI18n.prototype._d = function _d (value, locale, key) {
  /* istanbul ignore if */
  if ("prod" !== 'production' && !VueI18n.availabilities.dateTimeFormat) {
    warn('Cannot format a Date value due to not supported Intl.DateTimeFormat.');
    return ''
  }

  if (!key) {
    return new Intl.DateTimeFormat(locale).format(value)
  }

  var ret =
    this._localizeDateTime(value, locale, this.fallbackLocale, this._getDateTimeFormats(), key);
  if (this._isFallbackRoot(ret)) {
    if ("prod" !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
      warn(("Fall back to datetime localization of root: key '" + key + "'."));
    }
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.d(value, key, locale)
  } else {
    return ret || ''
  }
};

VueI18n.prototype.d = function d (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;

  if (args.length === 1) {
    if (isString(args[0])) {
      key = args[0];
    } else if (isObject(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }
    }
  } else if (args.length === 2) {
    if (isString(args[0])) {
      key = args[0];
    }
    if (isString(args[1])) {
      locale = args[1];
    }
  }

  return this._d(value, locale, key)
};

VueI18n.prototype.getNumberFormat = function getNumberFormat (locale) {
  return looseClone(this._vm.numberFormats[locale] || {})
};

VueI18n.prototype.setNumberFormat = function setNumberFormat (locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, format);
  this._clearNumberFormat(locale, format);
};

VueI18n.prototype.mergeNumberFormat = function mergeNumberFormat (locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, merge(this._vm.numberFormats[locale] || {}, format));
  this._clearNumberFormat(locale, format);
};

VueI18n.prototype._clearNumberFormat = function _clearNumberFormat (locale, format) {
  for (var key in format) {
    var id = locale + "__" + key;

    if (!this._numberFormatters.hasOwnProperty(id)) {
      continue
    }

    delete this._numberFormatters[id];
  }
};

VueI18n.prototype._getNumberFormatter = function _getNumberFormatter (
  value,
  locale,
  fallback,
  numberFormats,
  key,
  options
) {
  var _locale = locale;
  var formats = numberFormats[_locale];

  var chain = this._getLocaleChain(locale, fallback);
  for (var i = 0; i < chain.length; i++) {
    var current = _locale;
    var step = chain[i];
    formats = numberFormats[step];
    _locale = step;
    // fallback locale
    if (isNull(formats) || isNull(formats[key])) {
      if (step !== locale && "prod" !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn(("Fall back to '" + step + "' number formats from '" + current + "' number formats."));
      }
    } else {
      break
    }
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];

    var formatter;
    if (options) {
      // If options specified - create one time number formatter
      formatter = new Intl.NumberFormat(_locale, Object.assign({}, format, options));
    } else {
      var id = _locale + "__" + key;
      formatter = this._numberFormatters[id];
      if (!formatter) {
        formatter = this._numberFormatters[id] = new Intl.NumberFormat(_locale, format);
      }
    }
    return formatter
  }
};

VueI18n.prototype._n = function _n (value, locale, key, options) {
  /* istanbul ignore if */
  if (!VueI18n.availabilities.numberFormat) {
    if (true) {
      warn('Cannot format a Number value due to not supported Intl.NumberFormat.');
    }
    return ''
  }

  if (!key) {
    var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
    return nf.format(value)
  }

  var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
  var ret = formatter && formatter.format(value);
  if (this._isFallbackRoot(ret)) {
    if ("prod" !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
      warn(("Fall back to number localization of root: key '" + key + "'."));
    }
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.n(value, Object.assign({}, { key: key, locale: locale }, options))
  } else {
    return ret || ''
  }
};

VueI18n.prototype.n = function n (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;
  var options = null;

  if (args.length === 1) {
    if (isString(args[0])) {
      key = args[0];
    } else if (isObject(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }

      // Filter out number format options only
      options = Object.keys(args[0]).reduce(function (acc, key) {
          var obj;

        if (includes(numberFormatKeys, key)) {
          return Object.assign({}, acc, ( obj = {}, obj[key] = args[0][key], obj ))
        }
        return acc
      }, null);
    }
  } else if (args.length === 2) {
    if (isString(args[0])) {
      key = args[0];
    }
    if (isString(args[1])) {
      locale = args[1];
    }
  }

  return this._n(value, locale, key, options)
};

VueI18n.prototype._ntp = function _ntp (value, locale, key, options) {
  /* istanbul ignore if */
  if (!VueI18n.availabilities.numberFormat) {
    if (true) {
      warn('Cannot format to parts a Number value due to not supported Intl.NumberFormat.');
    }
    return []
  }

  if (!key) {
    var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
    return nf.formatToParts(value)
  }

  var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
  var ret = formatter && formatter.formatToParts(value);
  if (this._isFallbackRoot(ret)) {
    if ("prod" !== 'production' && !this._isSilentTranslationWarn(key)) {
      warn(("Fall back to format number to parts of root: key '" + key + "' ."));
    }
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n._ntp(value, locale, key, options)
  } else {
    return ret || []
  }
};

Object.defineProperties( VueI18n.prototype, prototypeAccessors );

var availabilities;
// $FlowFixMe
Object.defineProperty(VueI18n, 'availabilities', {
  get: function get () {
    if (!availabilities) {
      var intlDefined = typeof Intl !== 'undefined';
      availabilities = {
        dateTimeFormat: intlDefined && typeof Intl.DateTimeFormat !== 'undefined',
        numberFormat: intlDefined && typeof Intl.NumberFormat !== 'undefined'
      };
    }

    return availabilities
  }
});

VueI18n.install = install;
VueI18n.version = '8.21.1';

/* harmony default export */ __webpack_exports__["a"] = (VueI18n);


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1617)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(622),
  /* template */
  __webpack_require__(1548),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-05e82cb6", Component.options)
  } else {
    hotAPI.reload("data-v-05e82cb6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1635)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(623),
  /* template */
  __webpack_require__(1566),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-406147de",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/common/ApprovalDialog.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ApprovalDialog.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-406147de", Component.options)
  } else {
    hotAPI.reload("data-v-406147de", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1673)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(624),
  /* template */
  __webpack_require__(1603),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-be6888bc",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/common/CNYInput.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CNYInput.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-be6888bc", Component.options)
  } else {
    hotAPI.reload("data-v-be6888bc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1655)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(625),
  /* template */
  __webpack_require__(1585),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6a6df71f",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/common/CommonConfirm.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CommonConfirm.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6a6df71f", Component.options)
  } else {
    hotAPI.reload("data-v-6a6df71f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1657)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(626),
  /* template */
  __webpack_require__(1587),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-75bd0e6f",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/common/CommonCrud.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CommonCrud.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-75bd0e6f", Component.options)
  } else {
    hotAPI.reload("data-v-75bd0e6f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1660)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(627),
  /* template */
  __webpack_require__(1590),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7c3e3aee",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/common/CommonEchars.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CommonEchars.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7c3e3aee", Component.options)
  } else {
    hotAPI.reload("data-v-7c3e3aee", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1670)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(628),
  /* template */
  __webpack_require__(1600),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b41f7a44",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/common/CommonEditor.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CommonEditor.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b41f7a44", Component.options)
  } else {
    hotAPI.reload("data-v-b41f7a44", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1677)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(630),
  /* template */
  __webpack_require__(1606),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f046f23c",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/common/CommonTooltip.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CommonTooltip.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f046f23c", Component.options)
  } else {
    hotAPI.reload("data-v-f046f23c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(631),
  /* template */
  __webpack_require__(1552),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/common/CommonUpload.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CommonUpload.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1790751c", Component.options)
  } else {
    hotAPI.reload("data-v-1790751c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1669)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(632),
  /* template */
  __webpack_require__(1599),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ae5c7cfe",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/common/NoDataFound.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] NoDataFound.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ae5c7cfe", Component.options)
  } else {
    hotAPI.reload("data-v-ae5c7cfe", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1651)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(633),
  /* template */
  __webpack_require__(1582),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-648200e0",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/common/SelectTree.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SelectTree.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-648200e0", Component.options)
  } else {
    hotAPI.reload("data-v-648200e0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1661)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(635),
  /* template */
  __webpack_require__(1591),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7db47407",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/common/upload/FileBox.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FileBox.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7db47407", Component.options)
  } else {
    hotAPI.reload("data-v-7db47407", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1614)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(636),
  /* template */
  __webpack_require__(1546),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0318f77e",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/components/common/upload/SingleUpload.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SingleUpload.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0318f77e", Component.options)
  } else {
    hotAPI.reload("data-v-0318f77e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1630)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(678),
  /* template */
  __webpack_require__(1562),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/libs/PDFViewer/PDFViewer.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] PDFViewer.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3a0a285a", Component.options)
  } else {
    hotAPI.reload("data-v-3a0a285a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1668)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(679),
  /* template */
  __webpack_require__(1598),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ad351d18",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/libs/amap/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ad351d18", Component.options)
  } else {
    hotAPI.reload("data-v-ad351d18", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1639)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(680),
  /* template */
  __webpack_require__(1570),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/libs/approvalBox/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-45c4bd25", Component.options)
  } else {
    hotAPI.reload("data-v-45c4bd25", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1628)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(681),
  /* template */
  __webpack_require__(1560),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/libs/commentBox/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-33b09976", Component.options)
  } else {
    hotAPI.reload("data-v-33b09976", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1672)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(682),
  /* template */
  __webpack_require__(1602),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b96626e6",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/libs/dictSelect/Dict.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Dict.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b96626e6", Component.options)
  } else {
    hotAPI.reload("data-v-b96626e6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1642)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(683),
  /* template */
  __webpack_require__(1573),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b69d82e",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/libs/dictSelect/DictSelect.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DictSelect.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4b69d82e", Component.options)
  } else {
    hotAPI.reload("data-v-4b69d82e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1625)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(684),
  /* template */
  __webpack_require__(1557),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-30cf0563",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/libs/loading/Loading.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Loading.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-30cf0563", Component.options)
  } else {
    hotAPI.reload("data-v-30cf0563", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1629)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(685),
  /* template */
  __webpack_require__(1561),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-351a0cf9",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/libs/message/Message.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Message.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-351a0cf9", Component.options)
  } else {
    hotAPI.reload("data-v-351a0cf9", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1626)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(686),
  /* template */
  __webpack_require__(1558),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/libs/messageBox/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-31f2929d", Component.options)
  } else {
    hotAPI.reload("data-v-31f2929d", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1641)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(687),
  /* template */
  __webpack_require__(1572),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4a5e30e8",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/libs/previewExcel/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4a5e30e8", Component.options)
  } else {
    hotAPI.reload("data-v-4a5e30e8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1647)
}
var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(688),
  /* template */
  __webpack_require__(1578),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-59f49474",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/.pipeline/container/context/git-checkout/src/libs/previewImg/index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-59f49474", Component.options)
  } else {
    hotAPI.reload("data-v-59f49474", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-content"
  }, [_c('p', [_vm._v("\n    您好，您当前暂时没有Eventplanning Dashboard看板权限。\n    "), _c('br'), _vm._v("\n    若需申请用户权限，请说明个人所在部门，团队请发送申请邮件至：\n    "), _c('br'), _vm._v("\n    zhifeng.wu.zw1@roche.com\n    "), _c('br'), _vm._v("\n    待审批和赋权后即可登录系统\n  ")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-00377641", module.exports)
  }
}

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "e2e-single-upload-container"
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "e2e-single-upload",
    attrs: {
      "action": _vm.localAction,
      "data": _vm.params,
      "auto-upload": _vm.autoUpload,
      "before-upload": _vm.localBeforeUpload,
      "on-change": _vm.onChange,
      "on-success": _vm.onSuccess,
      "on-error": _vm.onError,
      "headers": _vm.headers,
      "limit": _vm.limit,
      "disabled": _vm.disabled,
      "on-exceed": _vm.onExceed,
      "accept": _vm.localAccept,
      "multiple": _vm.multiple,
      "show-file-list": false,
      "with-credentials": true
    }
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0318f77e", module.exports)
  }
}

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meetingplan-application"
  }, [_c('div', {
    staticClass: "page-contain"
  }, [_c('div', {
    staticClass: "application-search-content-main"
  }, [_c('el-form', {
    staticClass: "application-search-content-main-fields",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticClass: "application-search-content-main-fields-year"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.year),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "year", $$v)
      },
      expression: "searchMainData.year"
    }
  }, _vm._l((_vm.baseDataRecords.Year), function(item) {
    return _c('el-option', {
      key: item.id,
      staticClass: "application-search-content-main-fields-year-items",
      attrs: {
        "value": item.id,
        "label": item.yearName
      }
    })
  }), 1)], 1), _vm._v(" "), _vm._l((_vm.searchMainQuarters), function(quarter, index) {
    return _c('el-form-item', {
      key: index,
      class: [_vm.searchMainData.quarter == quarter ? 'active' : '', 'application-search-content-main-fields-quarter']
    }, [_c('label', {
      on: {
        "click": function($event) {
          return _vm.handleMainSearch(quarter)
        }
      }
    }, [_vm._v(_vm._s(quarter))])])
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "application-search-content-main-add"
  }, [_c('el-button', {
    attrs: {
      "disabled": !_vm.canCreateMeeting,
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.handleAddClick
    }
  }, [_vm._v("+ 添加会议")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "application-search-content-main-fields-quarter-lines"
  }, _vm._l((_vm.searchMainQuarters), function(quarter, index) {
    return _c('div', {
      key: index,
      class: [_vm.searchMainData.quarter == quarter ? 'line-active' : '', 'application-search-content-main-fields-quarter-lines-line', 'application-search-content-main-fields-quarter-lines-line-q' + (index + 1)]
    })
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-contain-main-tab"
  }, [_c('div', {
    staticClass: "main-blocks"
  }, [_c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "main-block-contain"
  }, [_c('div', {
    staticClass: "main-block-contain-title"
  }, [_vm._v(_vm._s(_vm.mainData['1'].statusName)), _c('common-tooltip', {
    attrs: {
      "tipCode": "5"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-application"
  }, [_c('i', {
    staticClass: "iconfont icon-yitijiao"
  }), _vm._v(" "), _c('label', [_vm._v("￥" + _vm._s(_vm.mainData['1'].totalAmountStr))])]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-total"
  }, [_vm._v("数量"), _c('label', [_vm._v(_vm._s(_vm.mainData['1'].count))])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "main-block-contain"
  }, [_c('div', {
    staticClass: "main-block-contain-title"
  }, [_vm._v(_vm._s(_vm.mainData['2'].statusName)), _c('common-tooltip', {
    attrs: {
      "tipCode": "6"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-application"
  }, [_c('i', {
    staticClass: "iconfont icon-shenpizhong"
  }), _vm._v(" "), _c('label', [_vm._v("￥" + _vm._s(_vm.mainData['2'].totalAmountStr))])]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-total"
  }, [_vm._v("数量"), _c('label', [_vm._v(_vm._s(_vm.mainData['2'].count))])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "main-block-contain"
  }, [_c('div', {
    staticClass: "main-block-contain-title"
  }, [_vm._v(_vm._s(_vm.mainData['4'].statusName)), _c('common-tooltip', {
    attrs: {
      "tipCode": "2.1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-application"
  }, [_c('i', {
    staticClass: "iconfont icon-shenpitongguo"
  }), _vm._v(" "), _c('label', [_vm._v("￥" + _vm._s(_vm.mainData['4'].totalAmountStr))])]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-total"
  }, [_vm._v("数量"), _c('label', [_vm._v(_vm._s(_vm.mainData['4'].count))])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "main-block-contain"
  }, [_c('div', {
    staticClass: "main-block-contain-title"
  }, [_vm._v(_vm._s(_vm.mainData['5'].statusName)), _c('common-tooltip', {
    attrs: {
      "tipCode": "4.1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-application"
  }, [_c('i', {
    staticClass: "iconfont icon-shenpijujue"
  }), _vm._v(" "), _c('label', [_vm._v("￥" + _vm._s(_vm.mainData['5'].totalAmountStr))])]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-total"
  }, [_vm._v("数量"), _c('label', [_vm._v(_vm._s(_vm.mainData['5'].count))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "search-content"
  }, [_c('el-form', {
    staticClass: "search-content-fields",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "申请状态"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.searchData.status),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "status", $$v)
      },
      expression: "searchData.status"
    }
  }, _vm._l((_vm.baseDataRecords.MyApplicationStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Franchise/DA"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalField", $$v)
      },
      expression: "searchData.medicalField"
    }
  }, _vm._l((_vm.getMedicalFieldArray(_vm.searchData.departId, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "团队"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "teamL4", $$v)
      },
      expression: "searchData.teamL4"
    }
  }, _vm._l((_vm.getTeamArray(_vm.searchData.departId, _vm.searchData.medicalField, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "search-content-fields-operate"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleAdvancedSearchClick()
      }
    }
  }, [_vm._v("高级查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleResetSearchCondition()
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbar"
  }, [_c('div', {
    staticClass: "application-detail-info"
  }, [_vm._v("共计 " + _vm._s(_vm.applicationDetailCount) + " 场 预算总额：" + _vm._s(_vm._f("MoneyFormat")(_vm.applicationDetailAmt)) + " 当前排队提交中：" + _vm._s(_vm.inQueueNumber) + "场")]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', {
    staticClass: "operate-export"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.handlerExportExcelClick
    }
  }, [_c('i', {
    staticClass: "iconfont icon-daochu"
  }), _vm._v(" "), _c('span', [_vm._v("导出")])])])])]), _vm._v(" "), _c('common-crud', {
    ref: "crud",
    attrs: {
      "searchData": _vm.searchData,
      "searchDataLikeField": {
        'productId': '*',
        'companyStrategy': '*',
        'strategyKeynote': '*',
        'medicalFieldResult': '*',
        'hospitalLevelId': '*',
        'speakerLevelId': '*'
      },
      "crudApi": _vm.crudApi,
      "tableData": _vm.applicationDetailData,
      "showEditFormTitle": false,
      "editDialogClass": "biz-application-detail-edit-dialog",
      "handleSearchResult": _vm.handleSearchResult,
      "selectedDataArray": _vm.selectedData,
      "afterDelete": _vm.handleApplicationDeleted,
      "deleteSuccessMessages": "删除会议成功"
    },
    on: {
      "update:tableData": function($event) {
        _vm.applicationDetailData = $event
      },
      "update:table-data": function($event) {
        _vm.applicationDetailData = $event
      },
      "update:selectedDataArray": function($event) {
        _vm.selectedData = $event
      },
      "update:selected-data-array": function($event) {
        _vm.selectedData = $event
      }
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "width": "60",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingName",
      "label": "会议名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "teamL4",
      "label": "团队",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "productId",
      "label": "产品",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "meetingSystem",
      "label": "系统选择",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "meetingProp",
      "label": "会议性质",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "meetingType",
      "label": "A1会议类型",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "meetingGsdType",
      "label": "GSD项目类型",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingGsdType",
      "label": "GSD细类",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("\n                      " + _vm._s(_vm.basedataGetName('MeetingGsdTypeSub' + scope.row.meetingGsdType, scope.row.meetingGsdSubType)) + "\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "totalAmount",
      "label": "会议总预算",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("                    \n                      " + _vm._s(_vm._f("MoneyFormat")(scope.row.totalAmount)) + "\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "queueTaskStatus",
      "label": "排队状态",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            'color': scope.row.queueTaskStatus == '失败' ? 'red' : '#2d82f0'
          })
        }, [_vm._v("\n                      " + _vm._s(scope.row.queueTaskStatus) + "\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "modelScore",
      "width": "140"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("模型评分"), _c('common-tooltip', {
    attrs: {
      "tipCode": "8"
    }
  })], 1)]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatDateTime2Date,
      "sortable": "",
      "prop": "meetingBeginDate",
      "label": "开始日期",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "cityName",
      "label": "城市"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingWebStatus",
      "label": "会议计划状态",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingCurrentOptName",
      "label": "会议计划审批结点",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "aoneExeStatus",
      "label": "会议执行状态",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "userRealName",
      "label": "会议组织者",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingCode",
      "label": "计划编号",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "eventId",
      "label": "A1会议编号",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "createTime",
      "label": "创建时间",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("\n                      " + _vm._s(_vm._f("DateHourMinutesFormat")(scope.row.createTime)) + "\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-column-operate"
        }, [(scope.row.meetingWebStatus == '待提交') ? _c('div', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditClick(scope.row)
            }
          }
        }, [_vm._v("\n                      编辑\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleCopyClick(scope.row)
            }
          }
        }, [_vm._v("\n                      复制\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteClick(scope.row)
            }
          }
        }, [_vm._v("\n                      删除\n                    ")])], 1) : _vm._e(), _vm._v(" "), (scope.row.meetingWebStatus != '待提交') ? _c('div', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleViewClick(scope.row)
            }
          }
        }, [_vm._v("\n                      查看\n                    ")])], 1) : _vm._e()])]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "confirmDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("确认删除会议？")])])])], 2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-info"
  }, [_c('div', {
    staticClass: "bottom-info-info"
  }, [_vm._v("已选择 " + _vm._s(_vm.selectedData.length) + " 场会议 预算总额："), _c('label', [_vm._v(_vm._s(_vm._f("MoneyFormat")(_vm.selectedTotalAmount)))])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-info-operate"
  }, [_c('el-button', {
    attrs: {
      "disabled": !_vm.canBatchSubmit,
      "type": "primary"
    },
    on: {
      "click": _vm.handleBatchSubmit
    }
  }, [_vm._v("提交")])], 1)]), _vm._v(" "), _c('div', [_c('el-dialog', {
    staticClass: "advanced-search-dialog",
    attrs: {
      "center": "",
      "visible": _vm.advancedSearchVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.advancedSearchVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "advancedSearchForm",
    attrs: {
      "model": _vm.searchData,
      "label-position": "right",
      "label-width": "100px"
    }
  }, [_c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-huiyizhuangtai'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("会议状态")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "申请状态",
      "prop": "status"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.status),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "status", $$v)
      },
      expression: "searchData.status"
    }
  }, _vm._l((_vm.baseDataRecords.MyApplicationStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议执行状态",
      "prop": "aoneExeStatus"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.aoneExeStatus),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "aoneExeStatus", $$v)
      },
      expression: "searchData.aoneExeStatus"
    }
  }, _vm._l((_vm.baseDataRecords.AoneExeStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "排队状态",
      "prop": "queueTaskStatus"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.queueTaskStatus),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "queueTaskStatus", $$v)
      },
      expression: "searchData.queueTaskStatus"
    }
  }, _vm._l((_vm.baseDataRecords.QueueTaskStatus.filter(function (q) { return q.value != '1'; })), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-jibinglingyu'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("疾病领域")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "部门",
      "prop": "departId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.medicalField = '';
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.departId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "departId", $$v)
      },
      expression: "searchData.departId"
    }
  }, _vm._l((_vm.baseDataRecords.Depart), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "Franchise/DA",
      "prop": "medicalField"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalField", $$v)
      },
      expression: "searchData.medicalField"
    }
  }, _vm._l((_vm.getMedicalFieldArray(_vm.searchData.departId, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "团队",
      "prop": "teamL4"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "teamL4", $$v)
      },
      expression: "searchData.teamL4"
    }
  }, _vm._l((_vm.getTeamArray(_vm.searchData.departId, _vm.searchData.medicalField, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "治疗领域",
      "prop": "treatmentArea"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.treatmentArea),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "treatmentArea", $$v)
      },
      expression: "searchData.treatmentArea"
    }
  }, _vm._l((_vm.baseDataRecords.TreatmentArea), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.treatmentAreaName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "疾病领域",
      "prop": "diseaseArea"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.diseaseArea),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "diseaseArea", $$v)
      },
      expression: "searchData.diseaseArea"
    }
  }, _vm._l((_vm.baseDataRecords.DiseaseArea), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.diseaseAreaName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "产品",
      "prop": "productId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.productId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "productId", $$v)
      },
      expression: "searchData.productId"
    }
  }, _vm._l((_vm.baseDataRecords.Product), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.productName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-chanpincelve'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("产品策略")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "公司战略",
      "prop": "companyStrategy"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.companyStrategy),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "companyStrategy", $$v)
      },
      expression: "searchData.companyStrategy"
    }
  }, _vm._l((_vm.baseDataRecords.CompanyStrategy), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "策略重点",
      "prop": "strategyKeynote"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.strategyKeynote),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "strategyKeynote", $$v)
      },
      expression: "searchData.strategyKeynote"
    }
  }, _vm._l((_vm.baseDataRecords.Strategy), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.keynote
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "业务结果",
      "prop": "medicalFieldResult"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.medicalFieldResult),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalFieldResult", $$v)
      },
      expression: "searchData.medicalFieldResult"
    }
  }, _vm._l((_vm.baseDataRecords.DomainResult), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.treatAreaResult
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-fugaiziyuan'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("覆盖资源")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "医院层级",
      "prop": "hospitalLevelId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.hospitalLevelId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "hospitalLevelId", $$v)
      },
      expression: "searchData.hospitalLevelId"
    }
  }, _vm._l((_vm.baseDataRecords.HospitalLevel), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.hospitalLevel
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "科室",
      "prop": "offices"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.offices),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "offices", $$v)
      },
      expression: "searchData.offices"
    }
  }, _vm._l((_vm.baseDataRecords.Office), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.officeName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "讲者级别",
      "prop": "speakerLevelId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.speakerLevelId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "speakerLevelId", $$v)
      },
      expression: "searchData.speakerLevelId"
    }
  }, _vm._l((_vm.baseDataRecords.SpeakerLevel), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.speakerLevel
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-pingfenjieguo'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("评分结果")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "模型评分"
    }
  }, [_c('div', {
    staticClass: "advanced-search-dialog-score-model"
  }, [_c('el-input-number', {
    attrs: {
      "placeholder": "最小评分",
      "controls": false,
      "precision": 0,
      "min": 1,
      "max": 100
    },
    model: {
      value: (_vm.searchData.minModelScore),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "minModelScore", $$v)
      },
      expression: "searchData.minModelScore"
    }
  }), _vm._v(" "), _c('span'), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "placeholder": "最大评分",
      "controls": false,
      "precision": 0,
      "min": 1,
      "max": 100
    },
    model: {
      value: (_vm.searchData.maxModelScore),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "maxModelScore", $$v)
      },
      expression: "searchData.maxModelScore"
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-huiyixinxi'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("会议信息")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "系统选择",
      "prop": "meetingSystem"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingSystem),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingSystem", $$v)
      },
      expression: "searchData.meetingSystem"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingSystem), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议性质",
      "prop": "meetingProp"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingProp),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingProp", $$v)
      },
      expression: "searchData.meetingProp"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingProp), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "是否网络会",
      "prop": "meetingModality"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingModality),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingModality", $$v)
      },
      expression: "searchData.meetingModality"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingModality), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "A1会议类型",
      "prop": "meetingType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingType),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingType", $$v)
      },
      expression: "searchData.meetingType"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "GSD项目类型",
      "prop": "meetingGsdType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.meetingGsdSubType = ''
      }
    },
    model: {
      value: (_vm.searchData.meetingGsdType),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingGsdType", $$v)
      },
      expression: "searchData.meetingGsdType"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingGsdType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "GSD细类",
      "prop": "meetingGsdSubType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingGsdSubType),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingGsdSubType", $$v)
      },
      expression: "searchData.meetingGsdSubType"
    }
  }, _vm._l((_vm.MeetingGsdSubTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议名称",
      "prop": "meetingName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.searchData.meetingName),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingName", $$v)
      },
      expression: "searchData.meetingName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "计划编号",
      "prop": "meetingCode"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleMeetingCodeFilter,
      "clearable": "",
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        _vm.remoteMeetingCodeData = []
      }
    },
    model: {
      value: (_vm.searchData.meetingCode),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingCode", $$v)
      },
      expression: "searchData.meetingCode"
    }
  }, _vm._l((_vm.remoteMeetingCodeData), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item,
        "label": item
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "A1编号",
      "prop": "eventId"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.searchData.eventId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "eventId", $$v)
      },
      expression: "searchData.eventId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议组织者",
      "prop": "userRealName"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleMeetingCreatorFilter,
      "clearable": "",
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        _vm.remoteMeetingCreatorData = []
      }
    },
    model: {
      value: (_vm.searchData.userRealName),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "userRealName", $$v)
      },
      expression: "searchData.userRealName"
    }
  }, _vm._l((_vm.remoteMeetingCreatorData), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.CName,
        "label": item.CName + ' ' + item.AD
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议申请人",
      "prop": "meetingOrganizerId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleMeetingOrganizerFilter,
      "clearable": "",
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        _vm.remoteMeetingOrganizerData = []
      }
    },
    model: {
      value: (_vm.searchData.meetingOrganizerId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingOrganizerId", $$v)
      },
      expression: "searchData.meetingOrganizerId"
    }
  }, _vm._l((_vm.remoteMeetingOrganizerData), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "value": item.Id,
        "label": item.CName + ' ' + item.AD
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "成本中心",
      "prop": "costCenter"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    on: {
      "change": _vm.handleSearchCostCenterChange
    },
    model: {
      value: (_vm.searchData.costCenter),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "costCenter", $$v)
      },
      expression: "searchData.costCenter"
    }
  }, _vm._l((_vm.costCenterArray), function(item) {
    return _c('el-option', {
      key: item.costId,
      attrs: {
        "value": item.costId,
        "label": item.costId
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "WBS code",
      "prop": "wbsCode"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.wbsCode),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "wbsCode", $$v)
      },
      expression: "searchData.wbsCode"
    }
  }, _vm._l((_vm.wbsCodeArray), function(item) {
    return _c('el-option', {
      key: item.costId,
      attrs: {
        "value": item.costId,
        "label": item.costId
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-shijian'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("时间地点")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "起止日期",
      "prop": "dateRange"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.searchData.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "dateRange", $$v)
      },
      expression: "searchData.dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "省份",
      "prop": "province"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleProvinceChange
    },
    model: {
      value: (_vm.searchData.province),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "province", $$v)
      },
      expression: "searchData.province"
    }
  }, _vm._l((_vm.baseDataRecords.Province), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "城市",
      "prop": "city"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请先选择省份"
    },
    model: {
      value: (_vm.searchData.city),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "city", $$v)
      },
      expression: "searchData.city"
    }
  }, _vm._l((_vm.citiesData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "创建日期",
      "prop": "createDateRange"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.searchData.createDateRange),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "createDateRange", $$v)
      },
      expression: "searchData.createDateRange"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("高级查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleResetSearchCondition()
      }
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('label', {
    staticClass: "advanced-search-dialog-close",
    on: {
      "click": function($event) {
        _vm.advancedSearchVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1), _vm._v(" "), _c('common-confirm', {
    attrs: {
      "dialogVisiable": _vm.confirmBatchSubmitVisible,
      "confirm": _vm.handlerBatchSubmitConfirmOK
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.confirmBatchSubmitVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.confirmBatchSubmitVisible = $event
      }
    }
  }, [_c('div', [_vm._v("\n          确认提交 " + _vm._s(_vm.selectedData.length) + " 场会议申请？\n      ")]), _vm._v(" "), (_vm.isSeasonlyType) ? _c('div', [_vm._v("\n          该季度的计划申请，需要直线经理和二级审批人审批\n      ")]) : _c('div', [_vm._v("\n          " + _vm._s(_vm.monthlyTypeMessage) + "\n      ")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-04a6ca76", module.exports)
  }
}

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.hasPermission) ? [_c('router-view')] : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "loading": _vm.loading
    }
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-05e82cb6", module.exports)
  }
}

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit-main"
  }, [_c('div', {
    staticClass: "page-contain view-meeting-plan"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.addNewOrEditData,
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "会议名称"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.meetingName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": ""
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("系统选择"), _c('common-tooltip', {
    attrs: {
      "tipCode": "8"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingSystem', _vm.addNewOrEditData.meetingSystem)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "是否网络会议"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingModality', _vm.addNewOrEditData.meetingModality)))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "会议性质"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp)))])])], 1), _vm._v(" "), (_vm.meetingSystemType != 'GSD') ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "A1会议类型"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingType', _vm.addNewOrEditData.meetingType)))])])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.meetingSystemType != 'A1') ? _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "GSD项目类型"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingGsdType', _vm.addNewOrEditData.meetingGsdType)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "GSD细类"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingGsdTypeSub' + _vm.addNewOrEditData.meetingGsdType, _vm.addNewOrEditData.meetingGsdSubType)))])])], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "部门"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('Depart', _vm.addNewOrEditData.departId)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "Franchise/DA"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MedicalField', _vm.addNewOrEditData.medicalField)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "团队"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('Teams', _vm.addNewOrEditData.teamL4)))])])], 1)], 1), _vm._v(" "), _c('el-row', [(_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp) == '推广') ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "治疗领域"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('TreatmentArea', _vm.addNewOrEditData.treatmentArea)))])])], 1) : _vm._e(), _vm._v(" "), (_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp).indexOf('非推广') >= 0) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "疾病领域"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('DiseaseArea', _vm.addNewOrEditData.diseaseArea)))])])], 1) : _vm._e(), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "产品"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('Product', _vm.addNewOrEditData.productId)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "公司战略"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('CompanyStrategy', _vm.addNewOrEditData.companyStrategy)))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "策略重点"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.strategyKeynoteName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'A1' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'A1',
      "label": "治疗领域业务结果"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.medicalFieldResultName))])])], 1), _vm._v(" "), (_vm.addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') >= 0) ? _c('el-col', [_c('el-form-item', {
    staticClass: "not-required",
    attrs: {
      "label": "治疗领域业务结果（自定义描述）"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.medicalFieldResultDes))])])], 1) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "开始日期"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm._f("DateFormat")(_vm.addNewOrEditData.meetingBeginDate)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "结束日期"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm._f("DateFormat")(_vm.addNewOrEditData.meetingEndDate)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "会议时段"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingTimeInt', _vm.addNewOrEditData.meetingTimeInt)))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    class: (_vm.meetingSystemType != 'GSD') ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "国家"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.countryName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: (_vm.meetingSystemType != 'GSD') ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "省份"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.provinceName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: (_vm.meetingSystemType != 'GSD') ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "城市"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.cityName))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    class: (_vm.meetingSystemType != 'GSD' && _vm.basedataGetName('MeetingModality', _vm.addNewOrEditData.meetingModality).indexOf('线下') >= 0) ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD' && _vm.basedataGetName('MeetingModality', _vm.addNewOrEditData.meetingModality).indexOf('线下') >= 0,
      "label": "会议地点"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.meetingPlace))])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [(_vm.meetingSystemType != 'A1') ? _c('el-row', [_c('div', {
    staticClass: "col-full"
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "受赠方类型(GSD系统)"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.recipientSocietyOrHospital),
      callback: function($$v) {
        _vm.recipientSocietyOrHospital = $$v
      },
      expression: "recipientSocietyOrHospital"
    }
  }, [_c('el-radio', {
    staticClass: "tooltip-header-text",
    attrs: {
      "label": 1
    }
  }, [_vm._v("受赠学会"), _c('common-tooltip', {
    attrs: {
      "tipCode": "11"
    }
  })], 1), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("医院")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("大学")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("患者组织")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("其他")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.meetingSystemType != 'A1' && _vm.recipientSocietyOrHospital) ? _c('el-row', {
    staticClass: "recipientSociety-input"
  }, [_c('el-col', [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.recipientSocietyStr || _vm.addNewOrEditData.universityStr || _vm.addNewOrEditData.patientOrgStr || _vm.addNewOrEditData.otherStr))])])], 1) : _vm._e(), _vm._v(" "), (_vm.meetingSystemType == 'A1' || !_vm.recipientSocietyOrHospital) ? _c('div', [_c('el-row', [(!_vm.isOneHospital()) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院总数"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.moreThenOneHospital),
      callback: function($$v) {
        _vm.moreThenOneHospital = $$v
      },
      expression: "moreThenOneHospital"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("一家")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("两家及以上")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    staticClass: "more-tab"
  }, [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "hospitalLevelId"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("医院层级"), _c('common-tooltip', {
    attrs: {
      "tipCode": "9"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.hospitalLevelName))])])], 1), _vm._v(" "), (_vm.moreThenOneHospital && !_vm.isOneHospital()) ? _c('el-col', {
    staticClass: "col-add-remove"
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院数量",
      "prop": 'extendData.hospitalInfos.' + _vm.index + '.hospitalCount'
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.hospitalCount))])])], 1) : _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院",
      "prop": "hospitalId"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.hospitalName))])])], 1)], 1), _vm._v(" "), (_vm.moreThenOneHospital && !_vm.isOneHospital()) ? _c('div', _vm._l((_vm.addNewOrEditData.extendData.hospitalInfos), function(hospital, index) {
    return _c('div', {
      key: index,
      staticClass: "more-tab-div"
    }, [_c('el-row', {
      staticClass: "more-tab"
    }, [_c('el-col', [_c('el-form-item', {
      attrs: {
        "required": "",
        "prop": 'extendData.hospitalInfos.' + index + '.hospitalLevelId'
      }
    }, [_c('span', {
      staticClass: "tooltip-header-text",
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v("医院层级"), _c('common-tooltip', {
      attrs: {
        "tipCode": "9"
      }
    })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(hospital.hospitalLevelName))])])], 1), _vm._v(" "), _c('el-col', {
      staticClass: "col-add-remove"
    }, [_c('el-form-item', {
      attrs: {
        "required": "",
        "label": "医院数量",
        "prop": 'extendData.hospitalInfos.' + index + '.hospitalCount'
      }
    }, [_c('label', [_vm._v(_vm._s(hospital.hospitalCount))])])], 1)], 1)], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "科室"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('Office', _vm.addNewOrEditData.offices)))])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "是否包含讲者"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.includeSpeaker ? '是' : '否'))])])], 1)], 1), _vm._v(" "), (_vm.addNewOrEditData.includeSpeaker == 1) ? _c('el-row', {
    staticClass: "more-tab"
  }, [_c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD'
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("讲者级别"), _c('common-tooltip', {
    attrs: {
      "tipCode": "10"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.speakerLevelName))])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "col-add-remove"
  }, [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "讲者人数"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.speakerCount))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.includeSpeaker == 1) ? _c('div', {
    staticClass: "more-tab-div"
  }, _vm._l((_vm.addNewOrEditData.extendData.speakerInfos), function(speaker, index) {
    return _c('el-row', {
      key: index,
      staticClass: "more-tab"
    }, [_c('el-col', [_c('el-form-item', {
      class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
      attrs: {
        "required": _vm.meetingSystemType != 'GSD'
      }
    }, [_c('span', {
      staticClass: "tooltip-header-text",
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v("讲者级别"), _c('common-tooltip', {
      attrs: {
        "tipCode": "10"
      }
    })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(speaker.speakerLevelName))])])], 1), _vm._v(" "), _c('el-col', {
      staticClass: "col-add-remove"
    }, [_c('el-form-item', {
      class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
      attrs: {
        "required": _vm.meetingSystemType != 'GSD',
        "label": "讲者人数"
      }
    }, [_c('label', [_vm._v(_vm._s(speaker.speakerCount))])])], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "参会人数（外）"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.attendCount))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "罗氏员工人数（内）"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.rocheCount))])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": ""
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("会议总预算"), _c('common-tooltip', {
    attrs: {
      "tipCode": "12"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.totalAmount))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "成本中心"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.costCenter + ' ' + _vm.addNewOrEditData.costCenterName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    staticClass: "not-required",
    attrs: {
      "label": "WBS code"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.wbsCode))])])], 1)], 1), _vm._v(" "), _c('el-row', [(_vm.addNewOrEditData.meetingSystem.length == 2) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "A1预算"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.a1Amount))])])], 1) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.meetingSystem.length == 2) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "GSD预算"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.gsdAmount))])])], 1) : _vm._e(), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    staticClass: "not-required",
    attrs: {
      "label": "会议申请人"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.meetingOrganizerCnname + ' ' + _vm.addNewOrEditData.meetingOrganizerName))])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "approval-workflow-title"
  }, [_vm._v("\n                  审批流\n                  "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "content-box"
  }, _vm._l((_vm.addNewOrEditData.nodeList), function(node) {
    return _c('el-row', {
      key: node.id
    }, [_c('el-col', {
      staticClass: "approval-workflow"
    }, [_c('el-form-item', {
      staticClass: "not-required",
      attrs: {
        "label": node.isAuthorized === 0 ? node.nodeLevel + '【授权审批】' : node.nodeLevel,
        "prop": "treatAreaResult"
      }
    }, [_c('label', [_vm._v(_vm._s(node.realName) + " " + _vm._s(node.username) + " " + _vm._s(node.createTime) + " " + _vm._s(node.isAuthorized === 0 ? ("（" + (node.licensorName) + "授权）") : ''))]), _vm._v(" "), _c('span', {
      class: ['approval-status', _vm.approvalStatusClass(node.meetStatus)]
    }, [_vm._v(_vm._s(node.statusName))])]), _vm._v(" "), (node.remark) ? _c('el-form-item', {
      staticClass: "not-required"
    }, [_c('label', [_vm._v(_vm._s(node.remark))])]) : _vm._e()], 1)], 1)
  }), 1)])])], 1), _vm._v(" "), (!_vm.waitBack) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addNewOrEditData.canApprove),
      expression: "addNewOrEditData.canApprove"
    }],
    staticClass: "bottom-info"
  }, [_c('div', {
    staticClass: "bottom-info-operate"
  }, [_c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": _vm.handleApprovalRejectClick
    }
  }, [_vm._v("审批拒绝")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleApprovalConfirmClick
    }
  }, [_vm._v("审批通过")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', [_c('approval-dialog', {
    attrs: {
      "dialogVisiable": _vm.approvalDailogVisible,
      "confirm": _vm.handleApprovalConfirm,
      "reject": _vm.handleApprovalReject,
      "type": _vm.approvalType
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.approvalDailogVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.approvalDailogVisible = $event
      }
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-07c4f24c", module.exports)
  }
}

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "e2e-home page-submenu"
  }, [_c('div', {
    staticClass: "e2e-container",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "page-submenu_left"
  }, [_c('div', {
    staticClass: "e2e-content-box"
  }, [_c('left-bar', {
    attrs: {
      "tab": "user-manual"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-submenu_right"
  }, [_c('div', {
    staticClass: "e2e-content-box"
  }, [_c('div', {
    staticClass: "manual-container"
  }, [_c('div', {
    staticClass: "manual-desc"
  }, [_vm._v("如您有任何关于会议计划平台以及会议活动相关的问题或建议，可以下载手册文档以获取帮助,或欢迎点击以下链接访问 gSite。")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('FileBox', {
    staticStyle: {
      "margin-top": "32px",
      "margin-bottom": "100px"
    },
    attrs: {
      "fileList": _vm.fileList,
      "disabled": true,
      "disabledDelete": true,
      "autoUpload": false,
      "lineNum": 2,
      "accept": "pdf,image",
      "label": _vm.$t('home.manual'),
      "download": true
    },
    on: {
      "update:fileList": function($event) {
        _vm.fileList = $event
      },
      "update:file-list": function($event) {
        _vm.fileList = $event
      }
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manual-desc"
  }, [_c('a', {
    attrs: {
      "href": "https://sites.google.com/roche.com/eme-sharing-g-site/home",
      "target": "_blank"
    }
  }, [_vm._v("https://sites.google.com/roche.com/eme-sharing-g-site/home")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0bd5cfca", module.exports)
  }
}

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-sample",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', [_c('div', [_c('el-select', {
    attrs: {
      "placeholder": "请选择图标类型"
    },
    on: {
      "change": _vm.sampleChange
    },
    model: {
      value: (_vm.sampletype),
      callback: function($$v) {
        _vm.sampletype = $$v
      },
      expression: "sampletype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "1、年度预算分配、年度预算计划",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "2、预算计划与执行进度",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "3、预算计划与执行季度趋势",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "4、预算计划与执行月度趋势",
      "value": "4"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "5、策略计划占比",
      "value": "5"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "6、策略执行进度、会议执行进度",
      "value": "6"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "7、策略月度趋势",
      "value": "7"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "8、会议计划占比",
      "value": "8"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "9、评分",
      "value": "9"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 30,
      "placeholder": "选择图标类型后，会在这里显示对应的数据，修改数据后点击应用可以实时更新图表"
    },
    model: {
      value: (_vm.sampledata),
      callback: function($$v) {
        _vm.sampledata = $$v
      },
      expression: "sampledata"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.setSample
    }
  }, [_vm._v("应用")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('common-echars', {
    ref: "sample1",
    attrs: {
      "chartClass": "chart-class",
      "dataset-dimensions": ['已分配预算'],
      "dataset-source": _vm.data1,
      "option": _vm.option1
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('common-echars', {
    ref: "sample2",
    attrs: {
      "chartClass": "chart-class",
      "dataset-dimensions": ['进度', '已计划预算', '已执行预算', '待执行预算', '计划外预算'],
      "dataset-source": _vm.data2,
      "option": _vm.option2
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('common-echars', {
    ref: "sample3",
    attrs: {
      "chartClass": "chart-class",
      "dataset-dimensions": ['季度', '已计划', '已执行', '待执行', '计划外', '已分配预算'],
      "dataset-source": _vm.data3,
      "option": _vm.option3
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('common-echars', {
    ref: "sample4",
    attrs: {
      "chartClass": "chart-class",
      "dataset-dimensions": ['月度', '已计划', '已执行', '待执行', '计划外'],
      "dataset-source": _vm.data4,
      "option": _vm.option4
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('common-echars', {
    ref: "sample5",
    attrs: {
      "chartClass": "chart-class",
      "dataset-dimensions": ['策略名', '占比'],
      "dataset-source": _vm.data5,
      "option": _vm.option5
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('common-echars', {
    ref: "sample6",
    attrs: {
      "chartClass": "chart-class",
      "dataset-dimensions": ['策略名', '已执行', '待执行', '计划外', '已计划'],
      "dataset-source": _vm.data6,
      "option": _vm.option6
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('common-echars', {
    ref: "sample7",
    attrs: {
      "chartClass": "chart-class",
      "dataset-dimensions": _vm.dimensions7,
      "dataset-source": _vm.source7,
      "option": _vm.option7
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('common-echars', {
    ref: "sample8",
    attrs: {
      "chartClass": "chart-class",
      "dataset-dimensions": ['类型', '占比'],
      "dataset-source": _vm.data8,
      "option": _vm.option8
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('common-echars', {
    ref: "sample9",
    attrs: {
      "chartClass": "chart-class",
      "dataset-dimensions": ['预算', '评分'],
      "dataset-source": _vm.data9,
      "option": _vm.option9
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1375c92a", module.exports)
  }
}

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-upload"
  }, [_c('el-upload', {
    ref: "upload",
    attrs: {
      "action": "http://",
      "http-request": _vm.handleUpload,
      "show-file-list": false,
      "with-credentials": true,
      "accept": _vm.acceptType
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('common-confirm', {
    staticClass: "common-upload-confirm",
    attrs: {
      "iconColor": "#e40030",
      "dialogVisiable": _vm.importValidErrorVisible,
      "confirm": function () { return _vm.importValidErrorVisible = false; },
      "appendToDialog": ""
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.importValidErrorVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.importValidErrorVisible = $event
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.importValidErrorMessage)
    }
  })]), _vm._v(" "), _c('common-confirm', {
    staticClass: "common-upload-confirm",
    attrs: {
      "dialogVisiable": _vm.importValidUpdateVisible,
      "confirm": _vm.importExcel,
      "appendToDialog": ""
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.importValidUpdateVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.importValidUpdateVisible = $event
      }
    }
  }, [_c('div', [_vm._v("有重复的记录，是否继续上传？")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1790751c", module.exports)
  }
}

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-contain"
  }, [_c('div', {
    staticClass: "application-search-content-main"
  }, [_c('el-form', {
    staticClass: "application-search-content-main-fields",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticClass: "application-search-content-main-fields-year"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.year),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "year", $$v)
      },
      expression: "searchMainData.year"
    }
  }, _vm._l((_vm.baseDataRecords.Year), function(item) {
    return _c('el-option', {
      key: item.id,
      staticClass: "application-search-content-main-fields-year-items",
      attrs: {
        "value": item.id,
        "label": item.yearName
      }
    })
  }), 1)], 1), _vm._v(" "), _vm._l((_vm.searchMainQuarters), function(quater, index) {
    return _c('el-form-item', {
      key: index,
      class: [_vm.searchMainData.quarter == quater ? 'active' : '', 'application-search-content-main-fields-quarter']
    }, [_c('label', {
      on: {
        "click": function($event) {
          return _vm.handleMainSearch(quater)
        }
      }
    }, [_vm._v(_vm._s(quater))])])
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "application-search-content-main-roles",
    attrs: {
      "label": "角色"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.selectRoleId),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "selectRoleId", $$v)
      },
      expression: "searchMainData.selectRoleId"
    }
  }, _vm._l((_vm.userRoles), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.roleName
      }
    })
  }), 1)], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "application-search-content-main-fields-quarter-lines"
  }, _vm._l((_vm.searchMainQuarters), function(quater, index) {
    return _c('div', {
      key: index,
      class: [_vm.searchMainData.quarter == quater ? 'line-active' : '', 'application-search-content-main-fields-quarter-lines-line', 'application-search-content-main-fields-quarter-lines-line-q' + (index + 1)]
    })
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "search-content"
  }, [_c('el-form', {
    staticClass: "search-content-fields",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "任务状态"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.searchData.status),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "status", $$v)
      },
      expression: "searchData.status"
    }
  }, _vm._l((_vm.baseDataRecords.MyTaskStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Franchise/DA"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalField", $$v)
      },
      expression: "searchData.medicalField"
    }
  }, _vm._l((_vm.getMedicalFieldArray(_vm.searchData.departId, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "团队"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "teamL4", $$v)
      },
      expression: "searchData.teamL4"
    }
  }, _vm._l((_vm.getTeamArray(_vm.searchData.departId, _vm.searchData.medicalField, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "search-content-fields-operate"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleAdvancedSearchClick()
      }
    }
  }, [_vm._v("高级查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleResetSearchCondition()
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbar"
  }, [_c('div', {
    staticClass: "application-detail-info"
  }, [_vm._v("共计 " + _vm._s(_vm.applicationDetailCount) + " 场 预算总额：" + _vm._s(_vm._f("MoneyFormat")(_vm.applicationDetailAmt)) + " 当前排队审批中：" + _vm._s(_vm.inQueueNumber) + "场")]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', {
    staticClass: "operate-export"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.handlerExportExcelClick
    }
  }, [_c('i', {
    staticClass: "iconfont icon-daochu"
  }), _vm._v(" "), _c('span', [_vm._v("导出")])])])])]), _vm._v(" "), _c('common-crud', {
    ref: "crud",
    attrs: {
      "searchData": _vm.searchData,
      "searchDataLikeField": {
        'productId': '*',
        'companyStrategy': '*',
        'strategyKeynote': '*',
        'medicalFieldResult': '*',
        'hospitalLevelId': '*',
        'speakerLevelId': '*'
      },
      "crudApi": _vm.crudApi,
      "tableData": _vm.applicationDetailData,
      "showEditFormTitle": false,
      "editDialogClass": "biz-application-detail-edit-dialog",
      "handleSearchResult": _vm.handleSearchResult,
      "selectedDataArray": _vm.selectedData
    },
    on: {
      "update:tableData": function($event) {
        _vm.applicationDetailData = $event
      },
      "update:table-data": function($event) {
        _vm.applicationDetailData = $event
      },
      "update:selectedDataArray": function($event) {
        _vm.selectedData = $event
      },
      "update:selected-data-array": function($event) {
        _vm.selectedData = $event
      }
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "width": "60",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingName",
      "label": "会议名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "teamL4",
      "label": "团队",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "productId",
      "label": "产品",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "meetingSystem",
      "label": "系统选择",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "meetingProp",
      "label": "会议性质",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "meetingType",
      "label": "A1会议类型",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "meetingGsdType",
      "label": "GSD项目类型",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingGsdType",
      "label": "GSD细类",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("                    \n                      " + _vm._s(_vm.basedataGetName('MeetingGsdTypeSub' + scope.row.meetingGsdType, scope.row.meetingGsdSubType)) + "\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "totalAmount",
      "label": "会议总预算",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("                    \n                      " + _vm._s(_vm._f("MoneyFormat")(scope.row.totalAmount)) + "\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "queueTaskStatus",
      "label": "排队状态",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            'color': scope.row.queueTaskStatus == '失败' ? 'red' : '#2d82f0'
          })
        }, [_vm._v("                    \n                      " + _vm._s(scope.row.queueTaskStatus) + "\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "modelScore",
      "width": "140"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("模型评分"), _c('common-tooltip', {
    attrs: {
      "tipCode": "7"
    }
  })], 1)]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatDateTime2Date,
      "sortable": "",
      "prop": "meetingBeginDate",
      "label": "开始日期",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "cityName",
      "label": "城市"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingWebStatus",
      "label": "会议计划状态",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingCurrentOptName",
      "label": "会议计划审批结点",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "aoneExeStatus",
      "label": "会议执行状态",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "userRealName",
      "label": "会议组织者",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingCode",
      "label": "计划编号",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "eventId",
      "label": "A1会议编号",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "createTime",
      "label": "创建时间",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("                    \n                      " + _vm._s(_vm._f("DateHourMinutesFormat")(scope.row.createTime)) + "\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-column-operate"
        }, [(scope.row.meetingWebStatus == '待提交') ? _c('div', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditClick(scope.row)
            }
          }
        }, [_vm._v("\n                      编辑\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleCopyClick(scope.row)
            }
          }
        }, [_vm._v("\n                      复制\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteClick(scope.row)
            }
          }
        }, [_vm._v("\n                      删除\n                    ")])], 1) : _vm._e(), _vm._v(" "), (scope.row.meetingWebStatus != '待提交') ? _c('div', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleViewClick(scope.row)
            }
          }
        }, [_vm._v("\n                      查看\n                    ")])], 1) : _vm._e()])]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "confirmDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("确认删除会议？")])])])], 2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-info"
  }, [_c('div', {
    staticClass: "bottom-info-info"
  }, [_vm._v("已选择 " + _vm._s(_vm.selectedData.length) + " 场会议 预算总额："), _c('label', [_vm._v(_vm._s(_vm._f("MoneyFormat")(_vm.selectedTotalAmount)))])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-info-operate"
  }, [_c('el-button', {
    attrs: {
      "disabled": !_vm.canBatchSubmit
    },
    on: {
      "click": _vm.handleApprovalRejectClick
    }
  }, [_vm._v("审批拒绝")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.canBatchSubmit,
      "type": "primary"
    },
    on: {
      "click": _vm.handleApprovalConfirmClick
    }
  }, [_vm._v("审批通过")])], 1)]), _vm._v(" "), _c('div', [_c('el-dialog', {
    staticClass: "advanced-search-dialog",
    attrs: {
      "center": "",
      "visible": _vm.advancedSearchVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.advancedSearchVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "advancedSearchForm",
    attrs: {
      "model": _vm.searchData,
      "label-position": "right",
      "label-width": "100px"
    }
  }, [_c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-huiyizhuangtai'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("会议状态")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "任务状态",
      "prop": "status"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.status),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "status", $$v)
      },
      expression: "searchData.status"
    }
  }, _vm._l((_vm.baseDataRecords.MyTaskStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议执行状态",
      "prop": "aoneExeStatus"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.aoneExeStatus),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "aoneExeStatus", $$v)
      },
      expression: "searchData.aoneExeStatus"
    }
  }, _vm._l((_vm.baseDataRecords.AoneExeStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "排队状态",
      "prop": "queueTaskStatus"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.queueTaskStatus),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "queueTaskStatus", $$v)
      },
      expression: "searchData.queueTaskStatus"
    }
  }, _vm._l((_vm.baseDataRecords.QueueTaskStatus.filter(function (q) { return q.value != '1'; })), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-jibinglingyu'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("疾病领域")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "部门",
      "prop": "departId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.medicalField = '';
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.departId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "departId", $$v)
      },
      expression: "searchData.departId"
    }
  }, _vm._l((_vm.baseDataRecords.Depart), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "Franchise/DA",
      "prop": "medicalField"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalField", $$v)
      },
      expression: "searchData.medicalField"
    }
  }, _vm._l((_vm.getMedicalFieldArray(_vm.searchData.departId, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "团队",
      "prop": "teamL4"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "teamL4", $$v)
      },
      expression: "searchData.teamL4"
    }
  }, _vm._l((_vm.getTeamArray(_vm.searchData.departId, _vm.searchData.medicalField, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "治疗领域",
      "prop": "treatmentArea"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.treatmentArea),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "treatmentArea", $$v)
      },
      expression: "searchData.treatmentArea"
    }
  }, _vm._l((_vm.baseDataRecords.TreatmentArea), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.treatmentAreaName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "疾病领域",
      "prop": "diseaseArea"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.diseaseArea),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "diseaseArea", $$v)
      },
      expression: "searchData.diseaseArea"
    }
  }, _vm._l((_vm.baseDataRecords.DiseaseArea), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.diseaseAreaName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "产品",
      "prop": "productId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.productId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "productId", $$v)
      },
      expression: "searchData.productId"
    }
  }, _vm._l((_vm.baseDataRecords.Product), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.productName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-chanpincelve'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("产品策略")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "公司战略",
      "prop": "companyStrategy"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.companyStrategy),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "companyStrategy", $$v)
      },
      expression: "searchData.companyStrategy"
    }
  }, _vm._l((_vm.baseDataRecords.CompanyStrategy), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "策略重点",
      "prop": "strategyKeynote"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.strategyKeynote),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "strategyKeynote", $$v)
      },
      expression: "searchData.strategyKeynote"
    }
  }, _vm._l((_vm.baseDataRecords.Strategy), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.keynote
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "业务结果",
      "prop": "medicalFieldResult"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.medicalFieldResult),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalFieldResult", $$v)
      },
      expression: "searchData.medicalFieldResult"
    }
  }, _vm._l((_vm.baseDataRecords.DomainResult), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.treatAreaResult
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-fugaiziyuan'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("覆盖资源")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "医院层级",
      "prop": "hospitalLevelId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.hospitalLevelId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "hospitalLevelId", $$v)
      },
      expression: "searchData.hospitalLevelId"
    }
  }, _vm._l((_vm.baseDataRecords.HospitalLevel), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.hospitalLevel
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "科室",
      "prop": "offices"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.offices),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "offices", $$v)
      },
      expression: "searchData.offices"
    }
  }, _vm._l((_vm.baseDataRecords.Office), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.officeName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "讲者级别",
      "prop": "speakerLevelId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.speakerLevelId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "speakerLevelId", $$v)
      },
      expression: "searchData.speakerLevelId"
    }
  }, _vm._l((_vm.baseDataRecords.SpeakerLevel), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.speakerLevel
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-pingfenjieguo'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("评分结果")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "模型评分"
    }
  }, [_c('div', {
    staticClass: "advanced-search-dialog-score-model"
  }, [_c('el-input-number', {
    attrs: {
      "placeholder": "最小评分",
      "controls": false,
      "precision": 0,
      "min": 1,
      "max": 100
    },
    model: {
      value: (_vm.searchData.minModelScore),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "minModelScore", $$v)
      },
      expression: "searchData.minModelScore"
    }
  }), _vm._v(" "), _c('span'), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "placeholder": "最大评分",
      "controls": false,
      "precision": 0,
      "min": 1,
      "max": 100
    },
    model: {
      value: (_vm.searchData.maxModelScore),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "maxModelScore", $$v)
      },
      expression: "searchData.maxModelScore"
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-huiyixinxi'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("会议信息")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "系统选择",
      "prop": "meetingSystem"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingSystem),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingSystem", $$v)
      },
      expression: "searchData.meetingSystem"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingSystem), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议性质",
      "prop": "meetingProp"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingProp),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingProp", $$v)
      },
      expression: "searchData.meetingProp"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingProp), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "是否网络会",
      "prop": "meetingModality"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingModality),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingModality", $$v)
      },
      expression: "searchData.meetingModality"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingModality), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "A1会议类型",
      "prop": "meetingType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingType),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingType", $$v)
      },
      expression: "searchData.meetingType"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "GSD项目类型",
      "prop": "meetingGsdType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.meetingGsdSubType = ''
      }
    },
    model: {
      value: (_vm.searchData.meetingGsdType),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingGsdType", $$v)
      },
      expression: "searchData.meetingGsdType"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingGsdType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "GSD细类",
      "prop": "meetingGsdSubType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingGsdSubType),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingGsdSubType", $$v)
      },
      expression: "searchData.meetingGsdSubType"
    }
  }, _vm._l((_vm.MeetingGsdSubTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议名称",
      "prop": "meetingName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.searchData.meetingName),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingName", $$v)
      },
      expression: "searchData.meetingName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "计划编号",
      "prop": "meetingCode"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleMeetingCodeFilter,
      "clearable": "",
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        _vm.remoteMeetingCodeData = []
      }
    },
    model: {
      value: (_vm.searchData.meetingCode),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingCode", $$v)
      },
      expression: "searchData.meetingCode"
    }
  }, _vm._l((_vm.remoteMeetingCodeData), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item,
        "label": item
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "A1编号",
      "prop": "eventId"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.searchData.eventId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "eventId", $$v)
      },
      expression: "searchData.eventId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议组织者",
      "prop": "userRealName"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleMeetingCreatorFilter,
      "clearable": "",
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        _vm.remoteMeetingCreatorData = []
      }
    },
    model: {
      value: (_vm.searchData.userRealName),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "userRealName", $$v)
      },
      expression: "searchData.userRealName"
    }
  }, _vm._l((_vm.remoteMeetingCreatorData), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.CName,
        "label": item.CName + ' ' + item.AD
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议申请人",
      "prop": "meetingOrganizerId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleMeetingOrganizerFilter,
      "clearable": "",
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        _vm.remoteMeetingOrganizerData = []
      }
    },
    model: {
      value: (_vm.searchData.meetingOrganizerId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingOrganizerId", $$v)
      },
      expression: "searchData.meetingOrganizerId"
    }
  }, _vm._l((_vm.remoteMeetingOrganizerData), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "value": item.Id,
        "label": item.CName + ' ' + item.AD
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "成本中心",
      "prop": "costCenter"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    on: {
      "change": _vm.handleSearchCostCenterChange
    },
    model: {
      value: (_vm.searchData.costCenter),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "costCenter", $$v)
      },
      expression: "searchData.costCenter"
    }
  }, _vm._l((_vm.costCenterArray), function(item) {
    return _c('el-option', {
      key: item.costId,
      attrs: {
        "value": item.costId,
        "label": item.costId
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "WBS code",
      "prop": "wbsCode"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.wbsCode),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "wbsCode", $$v)
      },
      expression: "searchData.wbsCode"
    }
  }, _vm._l((_vm.wbsCodeArray), function(item) {
    return _c('el-option', {
      key: item.costId,
      attrs: {
        "value": item.costId,
        "label": item.costId
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-shijian'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("时间地点")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "起止日期",
      "prop": "dateRange"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.searchData.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "dateRange", $$v)
      },
      expression: "searchData.dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "省份",
      "prop": "province"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleProvinceChange
    },
    model: {
      value: (_vm.searchData.province),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "province", $$v)
      },
      expression: "searchData.province"
    }
  }, _vm._l((_vm.baseDataRecords.Province), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "城市",
      "prop": "city"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请先选择省份"
    },
    model: {
      value: (_vm.searchData.city),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "city", $$v)
      },
      expression: "searchData.city"
    }
  }, _vm._l((_vm.citiesData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "创建日期",
      "prop": "createDateRange"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.searchData.createDateRange),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "createDateRange", $$v)
      },
      expression: "searchData.createDateRange"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("高级查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleResetSearchCondition()
      }
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('label', {
    staticClass: "advanced-search-dialog-close",
    on: {
      "click": function($event) {
        _vm.advancedSearchVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('approval-dialog', {
    attrs: {
      "dialogVisiable": _vm.approvalDailogVisible,
      "confirm": _vm.handleApprovalConfirm,
      "reject": _vm.handleApprovalReject,
      "type": _vm.approvalType
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.approvalDailogVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.approvalDailogVisible = $event
      }
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1aae7a60", module.exports)
  }
}

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "e2e-home page-submenu"
  }, [_c('div', {
    staticClass: "e2e-container",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "page-submenu_left"
  }, [_c('div', {
    staticClass: "e2e-content-box"
  }, [_c('left-bar', {
    attrs: {
      "tab": "user-authorizedlevel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-submenu_right"
  }, [_c('div', {
    staticClass: "e2e-content-box"
  }, [_c('div', {
    staticClass: "user-container"
  }, [_c('div', {
    staticClass: "user-basic-container",
    staticStyle: {
      "width": "400px"
    }
  }, [_c('div', {
    staticClass: "e2e-form"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form,
      "label-position": "top"
    }
  }, [(_vm.isAdmin) ? _c('el-form-item', {
    attrs: {
      "label": "授权人AD",
      "prop": "licensorAd"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择（可搜索）",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.remoteMethodLAD
    },
    on: {
      "change": _vm.getAuthorizationTeamList
    },
    model: {
      value: (_vm.form.licensorAd),
      callback: function($$v) {
        _vm.$set(_vm.form, "licensorAd", $$v)
      },
      expression: "form.licensorAd"
    }
  }, _vm._l((_vm.licensorList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.adAccount,
        "label": item.workerNameLocal + ' ' + item.adAccount
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("授权天数")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("授权日期")]), _vm._v(" "), _c('span', {
    staticClass: "radio-after-text"
  }, [_vm._v("（最长授权时间180天）")])], 1), _vm._v(" "), (_vm.radio === '1') ? _c('el-form-item', {
    attrs: {
      "label": "授权天数",
      "prop": "days"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.days),
      callback: function($$v) {
        _vm.$set(_vm.form, "days", $$v)
      },
      expression: "form.days"
    }
  }, _vm._l((_vm.daysList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.label
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.radio === '2') ? _c('el-form-item', {
    attrs: {
      "label": "授权日期",
      "prop": "date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.form.date),
      callback: function($$v) {
        _vm.$set(_vm.form, "date", $$v)
      },
      expression: "form.date"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授权团队",
      "prop": "authorizationTeam"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.authorizationTeam),
      callback: function($$v) {
        _vm.$set(_vm.form, "authorizationTeam", $$v)
      },
      expression: "form.authorizationTeam"
    }
  }, _vm._l((_vm.authorizationTeamList), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "value": item,
        "label": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "被授权人AD",
      "prop": "authorizedPersonAd"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择（可搜索）",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.remoteMethodAPAD
    },
    on: {
      "change": _vm.changeAuthorizedPersonAd
    },
    model: {
      value: (_vm.form.authorizedPersonAd),
      callback: function($$v) {
        _vm.$set(_vm.form, "authorizedPersonAd", $$v)
      },
      expression: "form.authorizedPersonAd"
    }
  }, _vm._l((_vm.authorizedPersonList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.adAccount,
        "label": item.workerNameLocal + ' ' + item.adAccount
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.dialogVisible,
      "width": "500px",
      "show-close": true,
      "center": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dialogText1)), _c('br'), _c('br'), _vm._v(_vm._s(_vm.dialogText2)), _c('br'), _vm._v(_vm._s(_vm.dialogText3))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handlerOK()
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-21495f3c", module.exports)
  }
}

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-submenu"
  }, [_c('div', {
    staticClass: "page-submenu_left"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('left-bar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-submenu_right"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "search-content"
  }, [_c('div', {
    staticClass: "search-content-fields"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddNewClick()
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.selectedData.length <= 0,
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleBatchDeleteClick()
      }
    }
  }, [_vm._v("批量删除")])], 1)]), _vm._v(" "), _c('common-crud', {
    ref: "crud",
    attrs: {
      "addNewOrEditData": _vm.addNewOrEditData,
      "searchData": _vm.searchData,
      "tableData": _vm.menuData,
      "crudApi": _vm.crudApi,
      "editFormLabelPosition": "right",
      "showPageData": false,
      "selectedDataArray": _vm.selectedData,
      "addSuccessMessages": "添加菜单成功",
      "editSuccessMessages": "编辑菜单成功",
      "deleteSuccessMessages": "删除菜单成功",
      "deleteBatchSuccessMessages": "批量删除菜单成功"
    },
    on: {
      "update:tableData": function($event) {
        _vm.menuData = $event
      },
      "update:table-data": function($event) {
        _vm.menuData = $event
      },
      "update:selectedDataArray": function($event) {
        _vm.selectedData = $event
      },
      "update:selected-data-array": function($event) {
        _vm.selectedData = $event
      }
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "name",
      "label": "菜单名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "menuType",
      "label": "菜单类型",
      "width": "120px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "url",
      "label": "路径",
      "width": "180px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "sortNo",
      "label": "排序",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "130px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-column-operate"
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditClick(scope.row)
            }
          }
        }, [_vm._v("\n                      编辑\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteClick(scope.row)
            }
          }
        }, [_vm._v("\n                      删除\n                    ")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "editForm"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "菜单类型：",
      "prop": "menuType"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": !!_vm.addNewOrEditData.id
    },
    model: {
      value: (_vm.addNewOrEditData.menuType),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "menuType", $$v)
      },
      expression: "addNewOrEditData.menuType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("一级菜单")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("子菜单")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("按钮/权限")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": _vm.addNewOrEditData.menuType === 2 ? '按钮/权限：' : '菜单名称：',
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.addNewOrEditData.menuType === 2 ? '请输入按钮/权限' : '请输入菜单名称'
    },
    model: {
      value: (_vm.addNewOrEditData.name),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "name", $$v)
      },
      expression: "addNewOrEditData.name"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.addNewOrEditData.menuType != 0) ? _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "上级菜单：",
      "prop": "parentId"
    }
  }, [_c('select-tree', {
    attrs: {
      "disabled": !!_vm.addNewOrEditData.id,
      "data": _vm.menuData,
      "props": _vm.menuTreeProps
    },
    model: {
      value: (_vm.addNewOrEditData.parentId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "parentId", $$v)
      },
      expression: "addNewOrEditData.parentId"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "菜单路径：",
      "prop": "url"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入菜单路径"
    },
    model: {
      value: (_vm.addNewOrEditData.url),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "url", $$v)
      },
      expression: "addNewOrEditData.url"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "排序：",
      "prop": "sortNo"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    model: {
      value: (_vm.addNewOrEditData.sortNo),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "sortNo", $$v)
      },
      expression: "addNewOrEditData.sortNo"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "confirmAddNewMessage"
  }, [_c('div', [_c('span', [_vm._v("确认添加？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmEditMessage"
  }, [_c('div', [_c('span', [_vm._v("确认保存？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("删除菜单？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmBatchDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("批量删除菜单？")])])])], 2)], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-22555b23", module.exports)
  }
}

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ticket != '-1' && _vm.ticket) ? _c('div', {
    staticClass: "tableau",
    style: ({
      zoom: _vm.getZoom
    })
  }, [_c('Tableau', {
    ref: "effectivenessTableau",
    attrs: {
      "height": _vm.height,
      "width": _vm.width,
      "url": _vm.url
    }
  })], 1) : (_vm.ticket == '-1') ? _c('div', [_c('error-section')], 1) : _c('div')
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-25be9594", module.exports)
  }
}

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', {
    staticClass: "v-loading-container"
  }, [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-loading"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": __webpack_require__(1516),
      "alt": "Loading..."
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-30cf0563", module.exports)
  }
}

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    class: _vm.confirmText ? 'confirm-text-dialog__footer' : '',
    attrs: {
      "visible": _vm.centerDialogVisible,
      "custom-class": "message_box",
      "destroy-on-close": true,
      "close-on-click-modal": false,
      "before-close": _vm.handleClose,
      "show-close": _vm.icon === 'warning' || _vm.showClose ? true : false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "message_box_icon"
  }, [(_vm.icon === 'success') ? _c('i', {
    staticClass: "el-icon-success",
    staticStyle: {
      "color": "#008b40"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'warning') ? _c('div', [(_vm.severity === 'low') ? _c('i', {
    staticClass: "el-icon-warning",
    staticStyle: {
      "color": "#00b1ff"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.severity === 'medium') ? _c('i', {
    staticClass: "el-icon-warning",
    staticStyle: {
      "color": "#f5bb4a"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.severity === 'high') ? _c('i', {
    staticClass: "el-icon-warning",
    staticStyle: {
      "color": "#e40030"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.icon === 'error') ? _c('i', {
    staticClass: "el-icon-error",
    staticStyle: {
      "color": "#e40030"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "message_box_title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "message_box_confirm_title",
    domProps: {
      "innerHTML": _vm._s(_vm.confirmTitle)
    }
  }), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return [_c('div', {
      key: index,
      staticClass: "message_box_content"
    }, [_c('div', {
      staticClass: "content_title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "message_content_icon"
    }, [(item.level === 'success') ? _c('i', {
      staticClass: "el-icon-success",
      staticStyle: {
        "color": "#008b40"
      }
    }) : _vm._e(), _vm._v(" "), (item.level === 'warn') ? _c('div', [(_vm.severity === 'low') ? _c('i', {
      staticClass: "el-icon-warning",
      staticStyle: {
        "color": "#00b1ff"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.severity === 'medium') ? _c('i', {
      staticClass: "el-icon-warning",
      staticStyle: {
        "color": "#f5bb4a"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.severity === 'high') ? _c('i', {
      staticClass: "el-icon-warning",
      staticStyle: {
        "color": "#e40030"
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.icon === 'error') ? _c('i', {
      staticClass: "el-icon-error",
      staticStyle: {
        "color": "#e40030"
      }
    }) : _vm._e()])])]
  }), _vm._v(" "), _c('div', {
    staticClass: "message_box_sub_Title",
    domProps: {
      "innerHTML": _vm._s(_vm.subTitle)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "message_box_confirm_Text",
    domProps: {
      "innerHTML": _vm._s(_vm.confirmText)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.showCancel) ? _c('el-button', {
    staticClass: "message_box_btn",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('btn.cancel')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "message_box_btn",
    attrs: {
      "type": "primary",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("\n      " + _vm._s(_vm.btnText) + "\n    ")])], 1)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-31f2929d", module.exports)
  }
}

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-contain"
  }, [_c('div', {
    staticClass: "application-search-content-main"
  }, [_c('el-form', {
    staticClass: "application-search-content-main-fields",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticClass: "application-search-content-main-fields-year"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.year),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "year", $$v)
      },
      expression: "searchMainData.year"
    }
  }, _vm._l((_vm.baseDataRecords.Year), function(item) {
    return _c('el-option', {
      key: item.id,
      staticClass: "application-search-content-main-fields-year-items",
      attrs: {
        "value": item.id,
        "label": item.yearName
      }
    })
  }), 1)], 1), _vm._v(" "), _vm._l((_vm.searchMainQuarters), function(quater, index) {
    return _c('el-form-item', {
      key: index,
      class: [_vm.searchMainData.quarter == quater ? 'active' : '', 'application-search-content-main-fields-quarter']
    }, [_c('label', {
      on: {
        "click": function($event) {
          return _vm.handleMainSearch(quater)
        }
      }
    }, [_vm._v(_vm._s(quater))])])
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "application-search-content-main-roles",
    attrs: {
      "label": "角色"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.selectRoleId),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "selectRoleId", $$v)
      },
      expression: "searchMainData.selectRoleId"
    }
  }, _vm._l((_vm.userRoles), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.roleName
      }
    })
  }), 1)], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "application-search-content-main-fields-quarter-lines"
  }, _vm._l((_vm.searchMainQuarters), function(quater, index) {
    return _c('div', {
      key: index,
      class: [_vm.searchMainData.quarter == quater ? 'line-active' : '', 'application-search-content-main-fields-quarter-lines-line', 'application-search-content-main-fields-quarter-lines-line-q' + (index + 1)]
    })
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-contain-main-tab"
  }, [_c('div', {
    staticClass: "main-blocks"
  }, [_c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "main-block-contain"
  }, [_c('div', {
    staticClass: "main-block-contain-title"
  }, [_vm._v("预算使用进度"), _c('common-tooltip', {
    attrs: {
      "tipCode": '1.' + _vm.selectedRole
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-budget"
  }, [_c('label', {
    staticClass: "main-block-contain-budget-amount"
  }, [_vm._v("￥" + _vm._s(_vm.mainData['预算使用进度'].totalAmountStr))]), _vm._v(" "), _c('label', {
    class: ['main-block-contain-budget-percent', _vm.mainData['预算使用进度'].ratioNum > 120 ? 'main-block-contain-budget-percent-alert' : '']
  }, [_vm._v(_vm._s(_vm.mainData['预算使用进度'].ratio))]), _vm._v(" "), _c('label', {
    class: ['main-block-contain-budget-percent-title', _vm.mainData['预算使用进度'].ratioNum > 120 ? 'main-block-contain-budget-percent-alert' : '']
  }, [_vm._v("占比")])]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-split-line"
  }, [_c('div', {
    staticClass: "progress",
    style: ('width:' + (_vm.mainData['预算使用进度'].ratioNum > 100 ? '100%' : _vm.mainData['预算使用进度'].ratio))
  })]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-info"
  }, [_c('span', {
    staticClass: "main-block-contain-season-amount"
  }, [_vm._v("季度总预算"), _c('label', [_vm._v(_vm._s(_vm.mainData['预算使用进度'].qbudgetAmountStr))])]), _vm._v(" "), _c('span', {
    staticClass: "main-block-contain-total"
  }, [_vm._v("数量"), _c('label', [_vm._v(_vm._s(_vm.mainData['预算使用进度'].count))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "main-block-contain"
  }, [_c('div', {
    staticClass: "main-block-contain-title"
  }, [_vm._v(_vm._s(_vm.mainData['4'].statusName)), _c('common-tooltip', {
    attrs: {
      "tipCode": '2.' + _vm.selectedRole
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-budget"
  }, [_c('label', {
    staticClass: "main-block-contain-budget-amount"
  }, [_vm._v("￥" + _vm._s(_vm.mainData['4'].totalAmountStr))]), _vm._v(" "), _c('label', {
    staticClass: "main-block-contain-budget-percent"
  }, [_vm._v(_vm._s(_vm.mainData['4'].ratio))]), _vm._v(" "), _c('label', {
    staticClass: "main-block-contain-budget-percent-title"
  }, [_vm._v("占比")])]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-split-line"
  }, [_c('div', {
    staticClass: "pass",
    style: ('width:' + (_vm.mainData['4'].ratioNum > 100 ? '100%' : _vm.mainData['4'].ratio))
  })]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-info"
  }, [_c('span', {
    staticClass: "main-block-contain-season-amount"
  }, [_vm._v("季度总预算"), _c('label', [_vm._v(_vm._s(_vm.mainData['4'].qbudgetAmountStr))])]), _vm._v(" "), _c('span', {
    staticClass: "main-block-contain-total"
  }, [_vm._v("数量"), _c('label', [_vm._v(_vm._s(_vm.mainData['4'].count))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "main-block-contain"
  }, [_c('div', {
    staticClass: "main-block-contain-title"
  }, [_vm._v(_vm._s(_vm.mainData['3'].statusName)), _c('common-tooltip', {
    attrs: {
      "tipCode": '3.' + _vm.selectedRole
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-budget"
  }, [_c('label', {
    staticClass: "main-block-contain-budget-amount"
  }, [_vm._v("￥" + _vm._s(_vm.mainData['3'].totalAmountStr))]), _vm._v(" "), _c('label', {
    staticClass: "main-block-contain-budget-percent"
  }, [_vm._v(_vm._s(_vm.mainData['3'].ratio))]), _vm._v(" "), _c('label', {
    staticClass: "main-block-contain-budget-percent-title"
  }, [_vm._v("占比")])]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-split-line"
  }, [_c('div', {
    staticClass: "pending",
    style: ('width:' + (_vm.mainData['3'].ratioNum > 100 ? '100%' : _vm.mainData['3'].ratio))
  })]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-info"
  }, [_c('span', {
    staticClass: "main-block-contain-season-amount"
  }, [_vm._v("季度总预算"), _c('label', [_vm._v(_vm._s(_vm.mainData['3'].qbudgetAmountStr))])]), _vm._v(" "), _c('span', {
    staticClass: "main-block-contain-total"
  }, [_vm._v("数量"), _c('label', [_vm._v(_vm._s(_vm.mainData['3'].count))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "main-block-contain"
  }, [_c('div', {
    staticClass: "main-block-contain-title"
  }, [_vm._v(_vm._s(_vm.mainData['5'].statusName)), _c('common-tooltip', {
    attrs: {
      "tipCode": '4.' + _vm.selectedRole
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-budget"
  }, [_c('label', {
    staticClass: "main-block-contain-budget-amount"
  }, [_vm._v("￥" + _vm._s(_vm.mainData['5'].totalAmountStr))]), _vm._v(" "), _c('label', {
    staticClass: "main-block-contain-budget-percent"
  }, [_vm._v(_vm._s(_vm.mainData['5'].ratio))]), _vm._v(" "), _c('label', {
    staticClass: "main-block-contain-budget-percent-title"
  }, [_vm._v("占比")])]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-split-line"
  }, [_c('div', {
    staticClass: "reject",
    style: ('width:' + (_vm.mainData['5'].ratioNum > 100 ? '100%' : _vm.mainData['5'].ratio))
  })]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-info"
  }, [_c('span', {
    staticClass: "main-block-contain-season-amount"
  }, [_vm._v("季度总预算"), _c('label', [_vm._v(_vm._s(_vm.mainData['5'].qbudgetAmountStr))])]), _vm._v(" "), _c('span', {
    staticClass: "main-block-contain-total"
  }, [_vm._v("数量"), _c('label', [_vm._v(_vm._s(_vm.mainData['5'].count))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "search-content"
  }, [_c('el-form', {
    staticClass: "search-content-fields",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "任务状态"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.searchData.status),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "status", $$v)
      },
      expression: "searchData.status"
    }
  }, _vm._l((_vm.baseDataRecords.MyTaskStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Franchise/DA"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalField", $$v)
      },
      expression: "searchData.medicalField"
    }
  }, _vm._l((_vm.getMedicalFieldArray(_vm.searchData.departId, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "团队"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "teamL4", $$v)
      },
      expression: "searchData.teamL4"
    }
  }, _vm._l((_vm.getTeamArray(_vm.searchData.departId, _vm.searchData.medicalField, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "search-content-fields-operate"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleAdvancedSearchClick()
      }
    }
  }, [_vm._v("高级查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleResetSearchCondition()
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbar"
  }, [_c('div', {
    staticClass: "application-detail-info"
  }, [_vm._v("共计 " + _vm._s(_vm.applicationDetailCount) + " 场 预算总额：" + _vm._s(_vm._f("MoneyFormat")(_vm.applicationDetailAmt)) + " 当前排队审批中：" + _vm._s(_vm.inQueueNumber) + "场")]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', {
    staticClass: "operate-export"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.handlerExportExcelClick
    }
  }, [_c('i', {
    staticClass: "iconfont icon-daochu"
  }), _vm._v(" "), _c('span', [_vm._v("导出")])])])])]), _vm._v(" "), _c('common-crud', {
    ref: "crud",
    attrs: {
      "searchData": _vm.searchData,
      "searchDataLikeField": {
        'productId': '*',
        'companyStrategy': '*',
        'strategyKeynote': '*',
        'medicalFieldResult': '*',
        'hospitalLevelId': '*',
        'speakerLevelId': '*'
      },
      "crudApi": _vm.crudApi,
      "tableData": _vm.applicationDetailData,
      "showEditFormTitle": false,
      "editDialogClass": "biz-application-detail-edit-dialog",
      "handleSearchResult": _vm.handleSearchResult,
      "selectedDataArray": _vm.selectedData
    },
    on: {
      "update:tableData": function($event) {
        _vm.applicationDetailData = $event
      },
      "update:table-data": function($event) {
        _vm.applicationDetailData = $event
      },
      "update:selectedDataArray": function($event) {
        _vm.selectedData = $event
      },
      "update:selected-data-array": function($event) {
        _vm.selectedData = $event
      }
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "width": "60",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingName",
      "label": "会议名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "teamL4",
      "label": "团队",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "productId",
      "label": "产品",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "meetingSystem",
      "label": "系统选择",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "meetingProp",
      "label": "会议性质",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "meetingType",
      "label": "A1会议类型",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "meetingGsdType",
      "label": "GSD项目类型",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingGsdType",
      "label": "GSD细类",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("                    \n                      " + _vm._s(_vm.basedataGetName('MeetingGsdTypeSub' + scope.row.meetingGsdType, scope.row.meetingGsdSubType)) + "\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "totalAmount",
      "label": "会议总预算",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("                    \n                      " + _vm._s(_vm._f("MoneyFormat")(scope.row.totalAmount)) + "\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "queueTaskStatus",
      "label": "排队状态",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          style: ({
            'color': scope.row.queueTaskStatus == '失败' ? 'red' : '#2d82f0'
          })
        }, [_vm._v("                    \n                      " + _vm._s(scope.row.queueTaskStatus) + "\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "modelScore",
      "width": "140"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("模型评分"), _c('common-tooltip', {
    attrs: {
      "tipCode": "7"
    }
  })], 1)]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatDateTime2Date,
      "sortable": "",
      "prop": "meetingBeginDate",
      "label": "开始日期",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "cityName",
      "label": "城市"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingWebStatus",
      "label": "会议计划状态",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingCurrentOptName",
      "label": "会议计划审批结点",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "aoneExeStatus",
      "label": "会议执行状态",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "userRealName",
      "label": "会议组织者",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingCode",
      "label": "计划编号",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "eventId",
      "label": "A1会议编号",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "createTime",
      "label": "创建时间",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("                    \n                      " + _vm._s(_vm._f("DateHourMinutesFormat")(scope.row.createTime)) + "\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-column-operate"
        }, [(scope.row.meetingWebStatus == '待提交') ? _c('div', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditClick(scope.row)
            }
          }
        }, [_vm._v("\n                      编辑\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleCopyClick(scope.row)
            }
          }
        }, [_vm._v("\n                      复制\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteClick(scope.row)
            }
          }
        }, [_vm._v("\n                      删除\n                    ")])], 1) : _vm._e(), _vm._v(" "), (scope.row.meetingWebStatus != '待提交') ? _c('div', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleViewClick(scope.row)
            }
          }
        }, [_vm._v("\n                      查看\n                    ")])], 1) : _vm._e()])]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "confirmDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("确认删除会议？")])])])], 2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-info"
  }, [_c('div', {
    staticClass: "bottom-info-info"
  }, [_vm._v("已选择 " + _vm._s(_vm.selectedData.length) + " 场会议 预算总额："), _c('label', [_vm._v(_vm._s(_vm._f("MoneyFormat")(_vm.selectedTotalAmount)))])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-info-operate"
  }, [_c('el-button', {
    attrs: {
      "disabled": !_vm.canBatchSubmit
    },
    on: {
      "click": _vm.handleApprovalRejectClick
    }
  }, [_vm._v("审批拒绝")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.canBatchSubmit,
      "type": "primary"
    },
    on: {
      "click": _vm.handleApprovalConfirmClick
    }
  }, [_vm._v("审批通过")])], 1)]), _vm._v(" "), _c('div', [_c('el-dialog', {
    staticClass: "advanced-search-dialog",
    attrs: {
      "center": "",
      "visible": _vm.advancedSearchVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.advancedSearchVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "advancedSearchForm",
    attrs: {
      "model": _vm.searchData,
      "label-position": "right",
      "label-width": "100px"
    }
  }, [_c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-huiyizhuangtai'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("会议状态")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "任务状态",
      "prop": "status"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.status),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "status", $$v)
      },
      expression: "searchData.status"
    }
  }, _vm._l((_vm.baseDataRecords.MyTaskStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议执行状态",
      "prop": "aoneExeStatus"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.aoneExeStatus),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "aoneExeStatus", $$v)
      },
      expression: "searchData.aoneExeStatus"
    }
  }, _vm._l((_vm.baseDataRecords.AoneExeStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "排队状态",
      "prop": "queueTaskStatus"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.queueTaskStatus),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "queueTaskStatus", $$v)
      },
      expression: "searchData.queueTaskStatus"
    }
  }, _vm._l((_vm.baseDataRecords.QueueTaskStatus.filter(function (q) { return q.value != '1'; })), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-jibinglingyu'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("疾病领域")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "部门",
      "prop": "departId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.medicalField = '';
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.departId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "departId", $$v)
      },
      expression: "searchData.departId"
    }
  }, _vm._l((_vm.baseDataRecords.Depart), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "Franchise/DA",
      "prop": "medicalField"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalField", $$v)
      },
      expression: "searchData.medicalField"
    }
  }, _vm._l((_vm.getMedicalFieldArray(_vm.searchData.departId, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "团队",
      "prop": "teamL4"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "teamL4", $$v)
      },
      expression: "searchData.teamL4"
    }
  }, _vm._l((_vm.getTeamArray(_vm.searchData.departId, _vm.searchData.medicalField, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "治疗领域",
      "prop": "treatmentArea"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.treatmentArea),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "treatmentArea", $$v)
      },
      expression: "searchData.treatmentArea"
    }
  }, _vm._l((_vm.baseDataRecords.TreatmentArea), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.treatmentAreaName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "疾病领域",
      "prop": "diseaseArea"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.diseaseArea),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "diseaseArea", $$v)
      },
      expression: "searchData.diseaseArea"
    }
  }, _vm._l((_vm.baseDataRecords.DiseaseArea), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.diseaseAreaName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "产品",
      "prop": "productId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.productId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "productId", $$v)
      },
      expression: "searchData.productId"
    }
  }, _vm._l((_vm.baseDataRecords.Product), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.productName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-chanpincelve'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("产品策略")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "公司战略",
      "prop": "companyStrategy"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.companyStrategy),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "companyStrategy", $$v)
      },
      expression: "searchData.companyStrategy"
    }
  }, _vm._l((_vm.baseDataRecords.CompanyStrategy), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "策略重点",
      "prop": "strategyKeynote"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.strategyKeynote),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "strategyKeynote", $$v)
      },
      expression: "searchData.strategyKeynote"
    }
  }, _vm._l((_vm.baseDataRecords.Strategy), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.keynote
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "业务结果",
      "prop": "medicalFieldResult"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.medicalFieldResult),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalFieldResult", $$v)
      },
      expression: "searchData.medicalFieldResult"
    }
  }, _vm._l((_vm.baseDataRecords.DomainResult), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.treatAreaResult
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-fugaiziyuan'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("覆盖资源")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "医院层级",
      "prop": "hospitalLevelId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.hospitalLevelId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "hospitalLevelId", $$v)
      },
      expression: "searchData.hospitalLevelId"
    }
  }, _vm._l((_vm.baseDataRecords.HospitalLevel), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.hospitalLevel
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "科室",
      "prop": "offices"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.offices),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "offices", $$v)
      },
      expression: "searchData.offices"
    }
  }, _vm._l((_vm.baseDataRecords.Office), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.officeName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "讲者级别",
      "prop": "speakerLevelId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.speakerLevelId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "speakerLevelId", $$v)
      },
      expression: "searchData.speakerLevelId"
    }
  }, _vm._l((_vm.baseDataRecords.SpeakerLevel), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.speakerLevel
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-pingfenjieguo'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("评分结果")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "模型评分"
    }
  }, [_c('div', {
    staticClass: "advanced-search-dialog-score-model"
  }, [_c('el-input-number', {
    attrs: {
      "placeholder": "最小评分",
      "controls": false,
      "precision": 0,
      "min": 1,
      "max": 100
    },
    model: {
      value: (_vm.searchData.minModelScore),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "minModelScore", $$v)
      },
      expression: "searchData.minModelScore"
    }
  }), _vm._v(" "), _c('span'), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "placeholder": "最大评分",
      "controls": false,
      "precision": 0,
      "min": 1,
      "max": 100
    },
    model: {
      value: (_vm.searchData.maxModelScore),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "maxModelScore", $$v)
      },
      expression: "searchData.maxModelScore"
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-huiyixinxi'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("会议信息")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "系统选择",
      "prop": "meetingSystem"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingSystem),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingSystem", $$v)
      },
      expression: "searchData.meetingSystem"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingSystem), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议性质",
      "prop": "meetingProp"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingProp),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingProp", $$v)
      },
      expression: "searchData.meetingProp"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingProp), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "是否网络会",
      "prop": "meetingModality"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingModality),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingModality", $$v)
      },
      expression: "searchData.meetingModality"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingModality), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "A1会议类型",
      "prop": "meetingType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingType),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingType", $$v)
      },
      expression: "searchData.meetingType"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "GSD项目类型",
      "prop": "meetingGsdType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.meetingGsdSubType = ''
      }
    },
    model: {
      value: (_vm.searchData.meetingGsdType),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingGsdType", $$v)
      },
      expression: "searchData.meetingGsdType"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingGsdType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "GSD细类",
      "prop": "meetingGsdSubType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingGsdSubType),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingGsdSubType", $$v)
      },
      expression: "searchData.meetingGsdSubType"
    }
  }, _vm._l((_vm.MeetingGsdSubTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议名称",
      "prop": "meetingName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.searchData.meetingName),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingName", $$v)
      },
      expression: "searchData.meetingName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "计划编号",
      "prop": "meetingCode"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleMeetingCodeFilter,
      "clearable": "",
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        _vm.remoteMeetingCodeData = []
      }
    },
    model: {
      value: (_vm.searchData.meetingCode),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingCode", $$v)
      },
      expression: "searchData.meetingCode"
    }
  }, _vm._l((_vm.remoteMeetingCodeData), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item,
        "label": item
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "A1编号",
      "prop": "eventId"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.searchData.eventId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "eventId", $$v)
      },
      expression: "searchData.eventId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议组织者",
      "prop": "userRealName"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleMeetingCreatorFilter,
      "clearable": "",
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        _vm.remoteMeetingCreatorData = []
      }
    },
    model: {
      value: (_vm.searchData.userRealName),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "userRealName", $$v)
      },
      expression: "searchData.userRealName"
    }
  }, _vm._l((_vm.remoteMeetingCreatorData), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.CName,
        "label": item.CName + ' ' + item.AD
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议申请人",
      "prop": "meetingOrganizerId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleMeetingOrganizerFilter,
      "clearable": "",
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        _vm.remoteMeetingOrganizerData = []
      }
    },
    model: {
      value: (_vm.searchData.meetingOrganizerId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingOrganizerId", $$v)
      },
      expression: "searchData.meetingOrganizerId"
    }
  }, _vm._l((_vm.remoteMeetingOrganizerData), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "value": item.Id,
        "label": item.CName + ' ' + item.AD
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "成本中心",
      "prop": "costCenter"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    on: {
      "change": _vm.handleSearchCostCenterChange
    },
    model: {
      value: (_vm.searchData.costCenter),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "costCenter", $$v)
      },
      expression: "searchData.costCenter"
    }
  }, _vm._l((_vm.costCenterArray), function(item) {
    return _c('el-option', {
      key: item.costId,
      attrs: {
        "value": item.costId,
        "label": item.costId
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "WBS code",
      "prop": "wbsCode"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.wbsCode),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "wbsCode", $$v)
      },
      expression: "searchData.wbsCode"
    }
  }, _vm._l((_vm.wbsCodeArray), function(item) {
    return _c('el-option', {
      key: item.costId,
      attrs: {
        "value": item.costId,
        "label": item.costId
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-shijian'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("时间地点")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "起止日期",
      "prop": "dateRange"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.searchData.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "dateRange", $$v)
      },
      expression: "searchData.dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "省份",
      "prop": "province"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleProvinceChange
    },
    model: {
      value: (_vm.searchData.province),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "province", $$v)
      },
      expression: "searchData.province"
    }
  }, _vm._l((_vm.baseDataRecords.Province), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "城市",
      "prop": "city"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请先选择省份"
    },
    model: {
      value: (_vm.searchData.city),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "city", $$v)
      },
      expression: "searchData.city"
    }
  }, _vm._l((_vm.citiesData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "创建日期",
      "prop": "createDateRange"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.searchData.createDateRange),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "createDateRange", $$v)
      },
      expression: "searchData.createDateRange"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("高级查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleResetSearchCondition()
      }
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('label', {
    staticClass: "advanced-search-dialog-close",
    on: {
      "click": function($event) {
        _vm.advancedSearchVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('approval-dialog', {
    attrs: {
      "dialogVisiable": _vm.approvalDailogVisible,
      "confirm": _vm.handleApprovalConfirm,
      "reject": _vm.handleApprovalReject,
      "type": _vm.approvalType
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.approvalDailogVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.approvalDailogVisible = $event
      }
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3240deb5", module.exports)
  }
}

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.commentBoxVisiable,
      "center": true,
      "destroy-on-close": true,
      "close-on-click-modal": false,
      "custom-class": "comment_box"
    },
    on: {
      "update:visible": function($event) {
        _vm.commentBoxVisiable = $event
      }
    }
  }, [_c('span', {
    staticClass: "dialog-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', [_c('i', {
    staticStyle: {
      "font-size": "18px",
      "color": "#e40030",
      "font-weight": "500"
    }
  }), _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "comment"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "resize": "none",
      "maxlength": "500",
      "placeholder": _vm.placeholder,
      "show-word-limit": ""
    },
    on: {
      "blur": _vm.handleCommentBlur
    },
    model: {
      value: (_vm.form.comment),
      callback: function($$v) {
        _vm.$set(_vm.form, "comment", $$v)
      },
      expression: "form.comment"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "custom-btn",
    attrs: {
      "type": "primary",
      "round": "",
      "size": "medium",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v(_vm._s(_vm.$t('btn.confirm')) + "\n    ")]), _vm._v(" "), _c('el-button', {
    staticClass: "custom-btn",
    attrs: {
      "round": "",
      "size": "medium",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('btn.cancel')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-33b09976", module.exports)
  }
}

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "message-box"
  }, [_c('div', {
    ref: "vmessage",
    staticClass: "message"
  }, [_vm._v("\n    " + _vm._s(_vm.message) + "\n  ")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-351a0cf9", module.exports)
  }
}

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "pdfviewer",
    staticClass: "common_pdfviewer_wrapper",
    attrs: {
      "title": _vm.title === '' ? 'PDF Viewer' : _vm.title,
      "visible": _vm.visible,
      "close": _vm.handleClose,
      "top": "80px",
      "width": "1100px"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('div', {
    staticClass: "maincontent"
  }, [_c('div', {
    staticClass: "header"
  }, [(!!_vm.download) ? _c('el-button', {
    on: {
      "click": _vm.handleDownloadFile2
    }
  }, [_vm._v(_vm._s(_vm.$t('btn.download')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "main",
    class: {
      download: !!_vm.download
    }
  }, [_c('div', {
    staticClass: "operator"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-arrow-left",
      "disabled": _vm.atBegining
    },
    on: {
      "click": _vm.handlePrevious
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('canvas', {
    style: (_vm.canvasStyle),
    attrs: {
      "id": "the-canvas"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "operator"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-arrow-right",
      "disabled": _vm.atEnd
    },
    on: {
      "click": _vm.handleNext
    }
  })], 1)]), _vm._v(" "), (_vm.pagination.limit > 1) ? _c('div', {
    staticClass: "footer"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 1,
      "total": _vm.pagination.limit,
      "current-page": _vm.pagination.page
    },
    on: {
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pagination, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pagination, "page", $event)
      },
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3a0a285a", module.exports)
  }
}

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-contain"
  }, [_c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "search-content"
  }, [_c('div', {
    staticClass: "search-content-fields"
  }, [_c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.medicalField = '';
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.departId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "departId", $$v)
      },
      expression: "searchData.departId"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.departsList : _vm.userInfo.loginDeparts)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Franchise/DA"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalField", $$v)
      },
      expression: "searchData.medicalField"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.medicalFieldList : _vm.getMedicalFieldArray(_vm.searchData.departId, true))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "团队"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "teamL4", $$v)
      },
      expression: "searchData.teamL4"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.teamList : _vm.getTeamArray(_vm.searchData.departId, _vm.searchData.medicalField, true))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "自定义/标准"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.typeId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "typeId", $$v)
      },
      expression: "searchData.typeId"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "标准",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "自定义",
      "value": "1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "讲者级别"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.speakerLevel),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "speakerLevel", $$v)
      },
      expression: "searchData.speakerLevel"
    }
  }, _vm._l((_vm.speakerLevelNames), function(item) {
    return _c('el-option', {
      key: item.speakerLevel,
      attrs: {
        "value": item.speakerLevel,
        "label": item.speakerLevel
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticClass: "btn-search",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handlerExportExcelClick()
      }
    }
  }, [_vm._v("批量导出")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.canBatchDelete,
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleBatchDeleteClick()
      }
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddNewClick()
      }
    }
  }, [_vm._v("添加讲者级别")])], 1)]), _vm._v(" "), _c('common-crud', {
    ref: "crud",
    attrs: {
      "addNewOrEditData": _vm.addNewOrEditData,
      "searchData": _vm.searchData,
      "crudApi": _vm.crudApi,
      "tableData": _vm.speakerLevelData,
      "showEditFormTitle": false,
      "beforeSave": _vm.beforeSave,
      "afterSave": _vm.handleSpeakerLevelChange,
      "afterDelete": _vm.handleSpeakerLevelChange,
      "selectedDataArray": _vm.selectedData,
      "otherValid": _vm.validUpload,
      "addSuccessMessages": "添加讲者级别成功",
      "editSuccessMessages": "编辑讲者级别成功",
      "deleteSuccessMessages": "删除讲者级别成功",
      "deleteBatchSuccessMessages": "批量删除讲者级别成功"
    },
    on: {
      "update:tableData": function($event) {
        _vm.speakerLevelData = $event
      },
      "update:table-data": function($event) {
        _vm.speakerLevelData = $event
      },
      "update:selectedDataArray": function($event) {
        _vm.selectedData = $event
      },
      "update:selected-data-array": function($event) {
        _vm.selectedData = $event
      }
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "width": "60",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "departId",
      "label": "部门"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "medicalField",
      "width": "135"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('div', [_vm._v("Franchise/DA")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "teamL4",
      "label": "团队"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "typeId",
      "label": "标准/自定义",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "speakerLevel",
      "label": "讲者级别"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "modelScore",
      "label": "评分"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatDateTime2Date,
      "sortable": "",
      "prop": "updateTime",
      "label": "更新时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "updateBy",
      "label": "操作人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-column-operate"
        }, [_c('el-button', {
          attrs: {
            "disabled": scope.row.typeId == '0',
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditClick(scope.row)
            }
          }
        }, [_vm._v("\n                    编辑\n                  ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "disabled": scope.row.typeId == '0',
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteClick(scope.row)
            }
          }
        }, [_vm._v("\n                    删除\n                  ")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "customTitle"
  }, [_vm._v("讲者级别")]), _vm._v(" "), _c('template', {
    slot: "editForm"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "部门",
      "prop": "departId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.medicalField = '';
        _vm.addNewOrEditData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.addNewOrEditData.departId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "departId", $$v)
      },
      expression: "addNewOrEditData.departId"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.departsList : _vm.userInfo.loginDeparts)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "Franchise/DA",
      "prop": "medicalField"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.addNewOrEditData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "medicalField", $$v)
      },
      expression: "addNewOrEditData.medicalField"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.medicalFieldList : _vm.getMedicalFieldArray(_vm.addNewOrEditData.departId, false))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "团队",
      "prop": "teamL4"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "teamL4", $$v)
      },
      expression: "addNewOrEditData.teamL4"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.teamList : _vm.getTeamArray(_vm.addNewOrEditData.departId, _vm.addNewOrEditData.medicalField, false))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "讲者级别",
      "prop": "speakerLevel"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.addNewOrEditData.speakerLevel),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "speakerLevel", $$v)
      },
      expression: "addNewOrEditData.speakerLevel"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "评分（10分制）",
      "prop": "modelScore"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.modelScore),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "modelScore", $$v)
      },
      expression: "addNewOrEditData.modelScore"
    }
  }, _vm._l((10), function(n) {
    return _c('el-option', {
      key: n,
      attrs: {
        "label": n,
        "value": n
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('common-score', {
    ref: "speakerMeetingType",
    attrs: {
      "disabledDownload": !_vm.canDownload,
      "title": "会议类型与讲者级别",
      "type": "speakerMeetingType",
      "fileName": "会议类型与讲者级别.xlsx",
      "getExportParams": _vm.getScoreExportParams,
      "tipCode": "15"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "confirmAddNewMessage"
  }, [_c('div', [_c('span', [_vm._v("确认添加讲者级别？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmEditMessage"
  }, [_c('div', [_c('span', [_vm._v("确认保存讲者级别？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("删除讲者级别？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmBatchDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("批量删除讲者级别？")])])])], 2)], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3a9422a3", module.exports)
  }
}

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit-main"
  }, [_c('div', {
    staticClass: "page-contain edit-meeting-plan"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.addNewOrEditData,
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "会议名称",
      "prop": "meetingName"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "placeholder": "请输入会议名称"
    },
    model: {
      value: (_vm.addNewOrEditData.meetingName),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingName", $$v)
      },
      expression: "addNewOrEditData.meetingName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "meetingSystem"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("系统选择"), _c('common-tooltip', {
    attrs: {
      "tipCode": "8"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择（可多选）"
    },
    model: {
      value: (_vm.addNewOrEditData.meetingSystem),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingSystem", $$v)
      },
      expression: "addNewOrEditData.meetingSystem"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingSystem), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "是否网络会议",
      "prop": "meetingModality"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.meetingModality),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingModality", $$v)
      },
      expression: "addNewOrEditData.meetingModality"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingModality), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "会议性质",
      "prop": "meetingProp"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleMeetingPropChange
    },
    model: {
      value: (_vm.addNewOrEditData.meetingProp),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingProp", $$v)
      },
      expression: "addNewOrEditData.meetingProp"
    }
  }, _vm._l((_vm.meetingPropAndTypeArrays.selectMeetingProp), function(item) {
    return _c('el-option', {
      key: item.itemValue,
      attrs: {
        "value": item.itemValue,
        "label": item.itemText
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.meetingSystemType != 'GSD') ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "A1会议类型",
      "prop": "meetingType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleMeetingTypeChange
    },
    model: {
      value: (_vm.addNewOrEditData.meetingType),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingType", $$v)
      },
      expression: "addNewOrEditData.meetingType"
    }
  }, _vm._l((_vm.filterMeetingType), function(item) {
    return _c('el-option', {
      key: item.itemValue,
      attrs: {
        "value": item.itemValue,
        "label": item.itemText
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.meetingType === '24' && _vm.isCEDepart()) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "是否为GSD",
      "prop": "isGsd"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addNewOrEditData.isGsd),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "isGsd", $$v)
      },
      expression: "addNewOrEditData.isGsd"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.meetingSystemType != 'A1') ? _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "GSD项目类型",
      "prop": "meetingGsdType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.meetingGsdSubType = ''
      }
    },
    model: {
      value: (_vm.addNewOrEditData.meetingGsdType),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingGsdType", $$v)
      },
      expression: "addNewOrEditData.meetingGsdType"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingGsdType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "GSD细类",
      "prop": "meetingGsdSubType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.meetingGsdSubType),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingGsdSubType", $$v)
      },
      expression: "addNewOrEditData.meetingGsdSubType"
    }
  }, _vm._l((_vm.MeetingGsdSubTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "部门",
      "prop": "departId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleDepartChange
    },
    model: {
      value: (_vm.addNewOrEditData.departId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "departId", $$v)
      },
      expression: "addNewOrEditData.departId"
    }
  }, _vm._l((_vm.baseDataRecords.Depart), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "Franchise/DA",
      "prop": "medicalField"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.teamL4 = '';
        _vm.resetRelativeFields()
      }
    },
    model: {
      value: (_vm.addNewOrEditData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "medicalField", $$v)
      },
      expression: "addNewOrEditData.medicalField"
    }
  }, _vm._l((_vm.getMedicalFieldArray(_vm.addNewOrEditData.departId, false)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "团队",
      "prop": "teamL4"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.resetRelativeFields
    },
    model: {
      value: (_vm.addNewOrEditData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "teamL4", $$v)
      },
      expression: "addNewOrEditData.teamL4"
    }
  }, _vm._l((_vm.getTeamArray(_vm.addNewOrEditData.departId, _vm.addNewOrEditData.medicalField, false)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [(_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp) == '推广') ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "治疗领域",
      "prop": "treatmentArea"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    on: {
      "change": function($event) {
        return _vm.handleAreaChange()
      }
    },
    model: {
      value: (_vm.addNewOrEditData.treatmentArea),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "treatmentArea", $$v)
      },
      expression: "addNewOrEditData.treatmentArea"
    }
  }, _vm._l((_vm.areaRelationObject[_vm.addNewOrEditData.meetingProp]), function(item) {
    return _c('el-option', {
      key: item.areaDbId,
      attrs: {
        "value": item.areaDbId,
        "label": item.areaName
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp).indexOf('非推广') >= 0) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "疾病领域",
      "prop": "diseaseArea"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    on: {
      "change": function($event) {
        return _vm.handleAreaChange()
      }
    },
    model: {
      value: (_vm.addNewOrEditData.diseaseArea),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "diseaseArea", $$v)
      },
      expression: "addNewOrEditData.diseaseArea"
    }
  }, _vm._l((_vm.areaRelationObject[_vm.addNewOrEditData.meetingProp]), function(item) {
    return _c('el-option', {
      key: item.areaDbId,
      attrs: {
        "value": item.areaDbId,
        "label": item.areaName
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "产品",
      "prop": "productId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择（可多选，可搜索）"
    },
    on: {
      "change": _vm.resetRelativeFields
    },
    model: {
      value: (_vm.addNewOrEditData.productId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "productId", $$v)
      },
      expression: "addNewOrEditData.productId"
    }
  }, _vm._l((_vm.productArray), function(item) {
    return _c('el-option', {
      key: item.productDbId,
      attrs: {
        "value": item.productDbId,
        "label": item.productName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "公司战略",
      "prop": "companyStrategy"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择（可多选）"
    },
    model: {
      value: (_vm.addNewOrEditData.companyStrategy),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "companyStrategy", $$v)
      },
      expression: "addNewOrEditData.companyStrategy"
    }
  }, _vm._l((_vm.baseDataRecords.CompanyStrategy), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "策略重点",
      "prop": "strategyKeynote"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择（可多选，可搜索）"
    },
    model: {
      value: (_vm.addNewOrEditData.strategyKeynote),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "strategyKeynote", $$v)
      },
      expression: "addNewOrEditData.strategyKeynote"
    }
  }, [_vm._l((_vm.filterStrategy), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": ((item.productName) + " - " + (item.keynote))
      }
    })
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "999999",
      "label": "其他/不适用"
    }
  })], 2)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": _vm.meetingSystemType != 'A1',
      "label": "治疗领域业务结果",
      "prop": "medicalFieldResult"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择（可多选，可搜索）"
    },
    model: {
      value: (_vm.addNewOrEditData.medicalFieldResult),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "medicalFieldResult", $$v)
      },
      expression: "addNewOrEditData.medicalFieldResult"
    }
  }, [_vm._l((_vm.filterDomainResult), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": ((item.productName) + " - " + (item.treatAreaResult))
      }
    })
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "999999",
      "label": "其他"
    }
  })], 2)], 1)], 1), _vm._v(" "), (_vm.addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') >= 0) ? _c('el-col', [_c('el-form-item', {
    staticClass: "medicalFieldResultDesItem",
    attrs: {
      "label": "治疗领域业务结果（自定义描述）",
      "prop": "medicalFieldResultDes"
    }
  }, [_c('el-input', {
    staticClass: "medicalFieldResultDes",
    attrs: {
      "rows": "1",
      "maxlength": "200",
      "type": "textarea",
      "placeholder": "请输入业务结果描述"
    },
    model: {
      value: (_vm.addNewOrEditData.medicalFieldResultDes),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "medicalFieldResultDes", $$v)
      },
      expression: "addNewOrEditData.medicalFieldResultDes"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "开始日期",
      "prop": "meetingBeginDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "default-value": _vm.seasonStartDate,
      "picker-options": _vm.startPickerOptions,
      "type": "date",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.meetingBeginDate),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingBeginDate", $$v)
      },
      expression: "addNewOrEditData.meetingBeginDate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "结束日期",
      "prop": "meetingEndDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "default-value": _vm.addNewOrEditData.meetingBeginDate,
      "picker-options": _vm.endPickerOptions,
      "type": "date",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.meetingEndDate),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingEndDate", $$v)
      },
      expression: "addNewOrEditData.meetingEndDate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "会议时段",
      "prop": "meetingTimeInt"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.meetingTimeInt),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingTimeInt", $$v)
      },
      expression: "addNewOrEditData.meetingTimeInt"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingTimeInt), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "国家",
      "prop": "country"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleCountryChange
    },
    model: {
      value: (_vm.addNewOrEditData.country),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "country", $$v)
      },
      expression: "addNewOrEditData.country"
    }
  }, _vm._l((_vm.baseDataRecords.Country), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "省份",
      "prop": "province"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请先选择国家"
    },
    on: {
      "change": _vm.handleProvinceChange
    },
    model: {
      value: (_vm.addNewOrEditData.province),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "province", $$v)
      },
      expression: "addNewOrEditData.province"
    }
  }, _vm._l((_vm.remoteProvinceData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "城市",
      "prop": "city"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请先选择省份"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.cityName = _vm.getName(_vm.addNewOrEditData.city, _vm.remoteCitiesData, 'id', 'name');
        _vm.clearHospital()
      }
    },
    model: {
      value: (_vm.addNewOrEditData.city),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "city", $$v)
      },
      expression: "addNewOrEditData.city"
    }
  }, _vm._l((_vm.remoteCitiesData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD' && _vm.basedataGetName('MeetingModality', _vm.addNewOrEditData.meetingModality).indexOf('线下') >= 0,
      "label": "会议地点",
      "prop": "meetingPlace"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "placeholder": "请输入会议地点"
    },
    model: {
      value: (_vm.addNewOrEditData.meetingPlace),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingPlace", $$v)
      },
      expression: "addNewOrEditData.meetingPlace"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "meeting-place-tip"
  }, [_vm._v("原则上，不得在餐厅或酒吧等以餐饮、休闲娱乐为主要目的的场所举办学术会议。")])], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [(_vm.meetingSystemType != 'A1') ? _c('el-row', [_c('div', {
    staticClass: "col-full"
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "受赠方类型(GSD系统)"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.recipientSocietyOrHospital),
      callback: function($$v) {
        _vm.recipientSocietyOrHospital = $$v
      },
      expression: "recipientSocietyOrHospital"
    }
  }, [_c('el-radio', {
    staticClass: "tooltip-header-text",
    attrs: {
      "label": 1
    }
  }, [_vm._v("受赠学会"), _c('common-tooltip', {
    attrs: {
      "tipCode": "11"
    }
  })], 1), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("医院")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("大学")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("患者组织")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("其他")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.meetingSystemType != 'A1' && _vm.recipientSocietyOrHospital) ? _c('el-row', {
    staticClass: "recipientSociety-input"
  }, [_c('el-col', [(_vm.recipientSocietyOrHospital == 1) ? _c('el-form-item', {
    attrs: {
      "prop": "recipientSocietyStr"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入学会名称(必填)"
    },
    model: {
      value: (_vm.addNewOrEditData.recipientSocietyStr),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "recipientSocietyStr", $$v)
      },
      expression: "addNewOrEditData.recipientSocietyStr"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.recipientSocietyOrHospital == 2) ? _c('el-form-item', {
    attrs: {
      "prop": "universityStr"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入大学名称(必填)"
    },
    model: {
      value: (_vm.addNewOrEditData.universityStr),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "universityStr", $$v)
      },
      expression: "addNewOrEditData.universityStr"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.recipientSocietyOrHospital == 3) ? _c('el-form-item', {
    attrs: {
      "prop": "patientOrgStr"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入患者组织名称(必填)"
    },
    model: {
      value: (_vm.addNewOrEditData.patientOrgStr),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "patientOrgStr", $$v)
      },
      expression: "addNewOrEditData.patientOrgStr"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.recipientSocietyOrHospital == 4) ? _c('el-form-item', {
    attrs: {
      "prop": "otherStr"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入其他名称(必填)"
    },
    model: {
      value: (_vm.addNewOrEditData.otherStr),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "otherStr", $$v)
      },
      expression: "addNewOrEditData.otherStr"
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.meetingSystemType == 'A1' || !_vm.recipientSocietyOrHospital) ? _c('div', [_c('el-row', [(!_vm.isOneHospital()) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院总数"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.moreThenOneHospital),
      callback: function($$v) {
        _vm.moreThenOneHospital = $$v
      },
      expression: "moreThenOneHospital"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("一家")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("两家及以上")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    staticClass: "more-tab"
  }, [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "hospitalLevelId"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("医院层级"), _c('common-tooltip', {
    attrs: {
      "tipCode": "9"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.hospitalLevelId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "hospitalLevelId", $$v)
      },
      expression: "addNewOrEditData.hospitalLevelId"
    }
  }, _vm._l((_vm.filterHospitalLevel), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.hospitalLevel,
        "disabled": item.typeId === _vm.disableHospitalType || _vm.isSelectedHospitalLevel(item.id)
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.moreThenOneHospital && !_vm.isOneHospital()) ? _c('el-col', {
    staticClass: "col-add-remove"
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院数量",
      "prop": "hospitalCount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "placeholder": "请输入医院数量",
      "controls": false,
      "precision": 0,
      "min": 1
    },
    model: {
      value: (_vm.addNewOrEditData.hospitalCount),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "hospitalCount", $$v)
      },
      expression: "addNewOrEditData.hospitalCount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-add-remove"
  }, [_c('i', {
    staticClass: "iconfont icon-tianjia1",
    on: {
      "click": _vm.AddNewHospitalInfo
    }
  })])], 1) : _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院",
      "prop": "hospitalId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleHospitalFilter,
      "clearable": "",
      "placeholder": (_vm.isOneHospital() && !_vm.addNewOrEditData.cityName) ? '请先选择城市' : '请输入'
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.hospitalName = _vm.getName(_vm.addNewOrEditData.hospitalId, _vm.remoteHospitalData, 'id', 'hospitalName');
      },
      "focus": function($event) {
        _vm.remoteHospitalData = [];
      },
      "blur": function($event) {
        _vm.remoteHospitalData = _vm.remoteHospitalDataTemp
      }
    },
    model: {
      value: (_vm.addNewOrEditData.hospitalId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "hospitalId", $$v)
      },
      expression: "addNewOrEditData.hospitalId"
    }
  }, _vm._l((_vm.remoteHospitalData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.hospitalName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), (_vm.moreThenOneHospital && !_vm.isOneHospital()) ? _c('div', _vm._l((_vm.addNewOrEditData.extendData.hospitalInfos), function(hospital, index) {
    return _c('div', {
      key: index,
      staticClass: "more-tab-div"
    }, [_c('el-row', {
      staticClass: "more-tab"
    }, [_c('el-col', [_c('el-form-item', {
      attrs: {
        "required": "",
        "prop": 'extendData.hospitalInfos.' + index + '.hospitalLevelId'
      }
    }, [_c('span', {
      staticClass: "tooltip-header-text",
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v("医院层级"), _c('common-tooltip', {
      attrs: {
        "tipCode": "9"
      }
    })], 1), _vm._v(" "), _c('el-select', {
      attrs: {
        "clearable": "",
        "placeholder": "请选择"
      },
      model: {
        value: (hospital.hospitalLevelId),
        callback: function($$v) {
          _vm.$set(hospital, "hospitalLevelId", $$v)
        },
        expression: "hospital.hospitalLevelId"
      }
    }, _vm._l((_vm.filterHospitalLevel), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "value": item.id,
          "label": item.hospitalLevel,
          "disabled": item.typeId === _vm.disableHospitalType || _vm.isSelectedHospitalLevel(item.id)
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      staticClass: "col-add-remove"
    }, [_c('el-form-item', {
      attrs: {
        "required": "",
        "label": "医院数量",
        "prop": 'extendData.hospitalInfos.' + index + '.hospitalCount'
      }
    }, [_c('el-input-number', {
      attrs: {
        "placeholder": "请输入医院数量",
        "controls": false,
        "precision": 0,
        "min": 0
      },
      model: {
        value: (hospital.hospitalCount),
        callback: function($$v) {
          _vm.$set(hospital, "hospitalCount", $$v)
        },
        expression: "hospital.hospitalCount"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "operate-add-remove"
    }, [_c('i', {
      staticClass: "iconfont icon-tianjia1",
      on: {
        "click": _vm.AddNewHospitalInfo
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-shanjian",
      on: {
        "click": function($event) {
          return _vm.removeHosiptalInfo(index)
        }
      }
    })])], 1)], 1)], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "科室",
      "prop": "offices"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择（可多选，可搜索）"
    },
    model: {
      value: (_vm.addNewOrEditData.offices),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "offices", $$v)
      },
      expression: "addNewOrEditData.offices"
    }
  }, _vm._l((_vm.baseDataRecords.Office), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.officeName
      }
    })
  }), 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "是否包含讲者",
      "prop": "includeSpeaker"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addNewOrEditData.includeSpeaker),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "includeSpeaker", $$v)
      },
      expression: "addNewOrEditData.includeSpeaker"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.addNewOrEditData.includeSpeaker == 1) ? _c('el-row', {
    staticClass: "more-tab"
  }, [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "prop": "speakerLevel"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("讲者级别"), _c('common-tooltip', {
    attrs: {
      "tipCode": "10"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.speakerLevel),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "speakerLevel", $$v)
      },
      expression: "addNewOrEditData.speakerLevel"
    }
  }, _vm._l((_vm.filterSpeakerLevel), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.speakerLevel,
        "disabled": item.typeId === _vm.disableSpeakerType || _vm.isSelectedSpeakerLevel(item.id)
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "col-add-remove"
  }, [_c('el-form-item', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "讲者人数",
      "prop": "speakerCount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "placeholder": "请输入讲者人数",
      "controls": false,
      "precision": 0,
      "min": 0
    },
    model: {
      value: (_vm.addNewOrEditData.speakerCount),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "speakerCount", $$v)
      },
      expression: "addNewOrEditData.speakerCount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-add-remove"
  }, [_c('i', {
    staticClass: "iconfont icon-tianjia1",
    on: {
      "click": _vm.AddNewSpeakerInfo
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.includeSpeaker == 1) ? _c('div', {
    staticClass: "more-tab-div"
  }, _vm._l((_vm.addNewOrEditData.extendData.speakerInfos), function(speaker, index) {
    return _c('el-row', {
      key: index,
      staticClass: "more-tab"
    }, [_c('el-col', [_c('el-form-item', {
      attrs: {
        "required": _vm.meetingSystemType != 'GSD',
        "prop": 'extendData.speakerInfos.' + index + '.speakerLevel'
      }
    }, [_c('span', {
      staticClass: "tooltip-header-text",
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v("讲者级别"), _c('common-tooltip', {
      attrs: {
        "tipCode": "10"
      }
    })], 1), _vm._v(" "), _c('el-select', {
      attrs: {
        "clearable": "",
        "placeholder": "请选择"
      },
      model: {
        value: (speaker.speakerLevel),
        callback: function($$v) {
          _vm.$set(speaker, "speakerLevel", $$v)
        },
        expression: "speaker.speakerLevel"
      }
    }, _vm._l((_vm.filterSpeakerLevel), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "value": item.id,
          "label": item.speakerLevel,
          "disabled": item.typeId === _vm.disableSpeakerType || _vm.isSelectedSpeakerLevel(item.id)
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      staticClass: "col-add-remove"
    }, [_c('el-form-item', {
      attrs: {
        "required": _vm.meetingSystemType != 'GSD',
        "label": "讲者人数",
        "prop": 'extendData.speakerInfos.' + index + '.speakerCount'
      }
    }, [_c('el-input-number', {
      attrs: {
        "placeholder": "请输入讲者人数",
        "controls": false,
        "precision": 0,
        "min": 0
      },
      model: {
        value: (speaker.speakerCount),
        callback: function($$v) {
          _vm.$set(speaker, "speakerCount", $$v)
        },
        expression: "speaker.speakerCount"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "operate-add-remove"
    }, [_c('i', {
      staticClass: "iconfont icon-tianjia1",
      on: {
        "click": _vm.AddNewSpeakerInfo
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-shanjian",
      on: {
        "click": function($event) {
          return _vm.removeSpeakerInfo(index)
        }
      }
    })])], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "参会人数（外）",
      "prop": "attendCount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "placeholder": "请输入参会人数（外）",
      "controls": false,
      "precision": 0,
      "min": 0
    },
    model: {
      value: (_vm.addNewOrEditData.attendCount),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "attendCount", $$v)
      },
      expression: "addNewOrEditData.attendCount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "罗氏员工人数（内）",
      "prop": "rocheCount"
    }
  }, [_c('el-input-number', {
    attrs: {
      "placeholder": "请输入罗氏员工人数（内）",
      "controls": false,
      "precision": 0,
      "min": 0
    },
    model: {
      value: (_vm.addNewOrEditData.rocheCount),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "rocheCount", $$v)
      },
      expression: "addNewOrEditData.rocheCount"
    }
  })], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "totalAmount"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("会议总预算"), _c('common-tooltip', {
    attrs: {
      "tipCode": _vm.disableTotalAmount ? 17 : 12
    }
  })], 1), _vm._v(" "), _c('cny-input', {
    attrs: {
      "disabled": _vm.disableTotalAmount,
      "valueFixed": 2,
      "placeholder": "请输入"
    },
    on: {
      "blur": _vm.handleAmountCheck
    },
    model: {
      value: (_vm.addNewOrEditData.totalAmount),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "totalAmount", $$v)
      },
      expression: "addNewOrEditData.totalAmount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "类型",
      "prop": "costType"
    }
  }, [_c('el-select', {
    on: {
      "change": _vm.handleCostTypeChange
    },
    model: {
      value: (_vm.addNewOrEditData.costType),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "costType", $$v)
      },
      expression: "addNewOrEditData.costType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": '1',
      "label": "成本中心"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": '2',
      "label": "Real Wbs Code"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.addNewOrEditData.costType == '2') ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "Real Wbs Code",
      "prop": "wbsCode"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.wbsCode),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "wbsCode", $$v)
      },
      expression: "addNewOrEditData.wbsCode"
    }
  }, _vm._l((_vm.wbsCodeData), function(item) {
    return _c('el-option', {
      key: item.costId,
      attrs: {
        "value": item.costId,
        "label": item.costId
      }
    })
  }), 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', [(_vm.addNewOrEditData.costType == '1') ? _c('el-col', {
    staticClass: "cost-center-col"
  }, [(_vm.isMeCostCenter && !_vm.currentUserSelectVisibled) ? _c('div', {
    staticClass: "user-cost-center-field",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handlerUserCostCenterFieldClick($event)
      }
    }
  }, [_c('span', {
    staticClass: "user-cost-center-field-label"
  }, [_vm._v(_vm._s(_vm.addNewOrEditData.costCenter + ' ' + _vm.getName(_vm.addNewOrEditData.costCenter, _vm.costCenterData, 'costCenter', 'costCenterName')))]), _c('span', {
    staticClass: "current-user"
  }, [_vm._v("本人")])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "required": "",
      "label": "成本中心",
      "prop": "costCenter"
    }
  }, [_c('el-select', {
    ref: "costCenter",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    on: {
      "visible-change": _vm.handleCostCenterSelectVisibleChange,
      "change": _vm.handleCostCenterChange
    },
    model: {
      value: (_vm.addNewOrEditData.costCenter),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "costCenter", $$v)
      },
      expression: "addNewOrEditData.costCenter"
    }
  }, _vm._l((_vm.costCenterData), function(item, index) {
    return _c('el-option', {
      key: item.costCenter,
      staticClass: "edit-main-cost-center",
      attrs: {
        "value": item.costCenter,
        "label": item.costCenter + ' ' + item.costCenterName
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.costCenter + ' ' + item.costCenterName))]), _vm._v(" "), (item.isMe === '1') ? _c('span', {
      staticClass: "current-user"
    }, [_vm._v("本人")]) : _vm._e()])
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.costType == '1') ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "Statistical WBS code",
      "prop": "wbsCode"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.wbsCode),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "wbsCode", $$v)
      },
      expression: "addNewOrEditData.wbsCode"
    }
  }, _vm._l((_vm.wbsCodeData), function(item) {
    return _c('el-option', {
      key: item.costId,
      attrs: {
        "value": item.costId,
        "label": item.costId
      }
    })
  }), 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', [(_vm.addNewOrEditData.meetingSystem.length == 2) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "A1预算",
      "prop": "a1Amount"
    }
  }, [_c('cny-input', {
    attrs: {
      "valueFixed": 2,
      "placeholder": "请输入"
    },
    on: {
      "blur": _vm.handleAmountCheck
    },
    model: {
      value: (_vm.addNewOrEditData.a1Amount),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "a1Amount", $$v)
      },
      expression: "addNewOrEditData.a1Amount"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.meetingSystem.length == 2) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "GSD预算",
      "prop": "gsdAmount"
    }
  }, [_c('cny-input', {
    attrs: {
      "valueFixed": 2,
      "placeholder": "请输入"
    },
    on: {
      "blur": _vm.handleAmountCheck
    },
    model: {
      value: (_vm.addNewOrEditData.gsdAmount),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "gsdAmount", $$v)
      },
      expression: "addNewOrEditData.gsdAmount"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议申请人",
      "prop": "meetingOrganizerId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleMeetingOrganizerFilter,
      "clearable": "",
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.meetingOrganizerName = _vm.getName(_vm.addNewOrEditData.meetingOrganizerId, _vm.remoteMeetingOrganizerData, 'Id', 'AD');
        _vm.addNewOrEditData.meetingOrganizerCnname = _vm.getName(_vm.addNewOrEditData.meetingOrganizerId, _vm.remoteMeetingOrganizerData, 'Id', 'CName');
        _vm.remoteMeetingOrganizerData = []
      }
    },
    model: {
      value: (_vm.addNewOrEditData.meetingOrganizerId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "meetingOrganizerId", $$v)
      },
      expression: "addNewOrEditData.meetingOrganizerId"
    }
  }, _vm._l((_vm.remoteMeetingOrganizerData), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "value": item.Id,
        "label": item.CName + ' ' + item.AD
      }
    })
  }), 1)], 1)], 1)], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-info"
  }, [(!_vm.waitBack) ? _c('div', {
    staticClass: "bottom-info-operate"
  }, [(_vm.editType != 'edit') ? _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v("删除")]) : _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleDeleteClick()
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handlerSave
    }
  }, [_vm._v("保存")])], 1) : _vm._e()]), _vm._v(" "), _c('common-confirm', {
    attrs: {
      "dialogVisiable": _vm.confirmSaveVisible,
      "confirm": _vm.handlerSaveConfirmOK
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.confirmSaveVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.confirmSaveVisible = $event
      }
    }
  }, [_c('div', [_vm._v("\n          确认保存会议？\n      ")]), _vm._v(" "), (_vm.isSeasonlyType) ? _c('div', [_vm._v("\n          该季度的计划申请，需要直线经理和二级审批人审批\n      ")]) : _c('div', [_vm._v("\n          " + _vm._s(_vm.monthlyTypeMessage) + "\n      ")])]), _vm._v(" "), _c('common-confirm', {
    attrs: {
      "dialogVisiable": _vm.confirmDeleteVisible,
      "confirm": _vm.handlerDeleteConfirmOK
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.confirmDeleteVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.confirmDeleteVisible = $event
      }
    }
  }, [_c('div', [_vm._v("\n          确认删除会议？\n      ")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3ddf5019", module.exports)
  }
}

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "e2e-home page-submenu"
  }, [_c('div', {
    staticClass: "e2e-container",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "page-submenu_left"
  }, [_c('div', {
    staticClass: "e2e-content-box"
  }, [_c('left-bar', {
    attrs: {
      "tab": "user-personal-center"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-submenu_right"
  }, [_c('div', {
    staticClass: "e2e-content-box"
  }, [_c('div', {
    staticClass: "user-container"
  }, [_c('div', {
    staticClass: "user-basic-container",
    staticStyle: {
      "width": "400px"
    }
  }, [_c('div', {
    staticClass: "e2e-form"
  }, [_c('div', {
    staticClass: "e2e-form-row"
  }, [_c('div', {
    staticClass: "e2e-form-group"
  }, [_c('div', {
    staticClass: "e2e-form-label"
  }, [_vm._v("\n                                      " + _vm._s(_vm.$t('home.user_name')) + "\n                                  ")]), _vm._v(" "), _c('div', {
    staticClass: "e2e-form-item"
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.userInfo.realname),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "realname", $$v)
      },
      expression: "userInfo.realname"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "e2e-form-row"
  }, [_c('div', {
    staticClass: "e2e-form-group"
  }, [_c('div', {
    staticClass: "e2e-form-label"
  }, [_vm._v("\n                                      " + _vm._s(_vm.$t("home.user_role")) + "\n                                  ")]), _vm._v(" "), _c('div', {
    staticClass: "e2e-form-item"
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.userInfo.roleNames),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "roleNames", $$v)
      },
      expression: "userInfo.roleNames"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "e2e-form-row"
  }, [_c('div', {
    staticClass: "e2e-form-group"
  }, [_c('div', {
    staticClass: "e2e-form-label"
  }, [_vm._v("\n                                      " + _vm._s(_vm.$t("home.user_id")) + "\n                                  ")]), _vm._v(" "), _c('div', {
    staticClass: "e2e-form-item"
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.userInfo.workerId),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "workerId", $$v)
      },
      expression: "userInfo.workerId"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "e2e-form-row"
  }, [_c('div', {
    staticClass: "e2e-form-group"
  }, [_c('div', {
    staticClass: "e2e-form-label"
  }, [_vm._v("\n                                      " + _vm._s(_vm.$t('home.user_dept')) + "\n                                  ")]), _vm._v(" "), _c('div', {
    staticClass: "e2e-form-item"
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.userInfo.departIdList),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "departIdList", $$v)
      },
      expression: "userInfo.departIdList"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "e2e-form-row"
  }, [_c('div', {
    staticClass: "e2e-form-group"
  }, [_c('div', {
    staticClass: "e2e-form-label"
  }, [_vm._v("\n                                      " + _vm._s(_vm.$t('home.user_medical_field')) + "\n                                  ")]), _vm._v(" "), _c('div', {
    staticClass: "e2e-form-item"
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.userInfo.medicalFieldList),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "medicalFieldList", $$v)
      },
      expression: "userInfo.medicalFieldList"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "e2e-form-row"
  }, [_c('div', {
    staticClass: "e2e-form-group"
  }, [_c('div', {
    staticClass: "e2e-form-label"
  }, [_vm._v("\n                                      " + _vm._s(_vm.$t('home.user_email')) + "\n                                  ")]), _vm._v(" "), _c('div', {
    staticClass: "e2e-form-item"
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.userInfo.email),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "email", $$v)
      },
      expression: "userInfo.email"
    }
  })], 1)])])])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3f6fd5ea", module.exports)
  }
}

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "visible": _vm.dialogVisiable,
      "show-close": true,
      "center": true,
      "before-close": _vm.closeDialog,
      "append-to-body": _vm.appendToDialog,
      "close-on-click-modal": false,
      "custom-class": "approval-dialog",
      "width": "450px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisiable = $event
      }
    }
  }, [_c('div', {
    staticClass: "approval-info"
  }, [_c('i', {
    staticClass: "iconfont",
    class: _vm.type === 'confirm' ? 'icon-shenpitongguo' : 'icon-shenpijujue'
  }), _vm._v(" "), _c('span', [_vm._v("审批" + _vm._s(_vm.type == 'confirm' ? '通过' : '拒绝') + "　　")])]), _vm._v(" "), _c('div', {
    staticClass: "apprvoal-reason"
  }, [_c('el-input', {
    attrs: {
      "maxlength": "200",
      "type": "textarea",
      "placeholder": '请输入审批' + (_vm.type == 'confirm' ? '通过' : '拒绝') + '理由（选填）'
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirmOK
    }
  }, [_vm._v(_vm._s(_vm.$t("btn.confirm")))])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-406147de", module.exports)
  }
}

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ticket != '-1' && _vm.ticket) ? _c('div', {
    staticClass: "tableau",
    style: ({
      zoom: _vm.getZoom
    })
  }, [_c('Tableau', {
    ref: "meetingTableau",
    attrs: {
      "url": _vm.url,
      "width": _vm.width,
      "height": _vm.height
    }
  })], 1) : (_vm.ticket == '-1') ? _c('div', [_c('error-section')], 1) : _c('div')
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-415a0751", module.exports)
  }
}

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-contain"
  }, [_c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "search-content"
  }, [_c('div', {
    staticClass: "search-content-fields"
  }, [_c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.medicalField = '';
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.departId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "departId", $$v)
      },
      expression: "searchData.departId"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.departsList : _vm.userInfo.loginDeparts)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Franchise/DA"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalField", $$v)
      },
      expression: "searchData.medicalField"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.medicalFieldList : _vm.getMedicalFieldArray(_vm.searchData.departId, true))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "团队"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "teamL4", $$v)
      },
      expression: "searchData.teamL4"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.teamList : _vm.getTeamArray(_vm.searchData.departId, _vm.searchData.medicalField, true))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "产品"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.prodIds),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "prodIds", $$v)
      },
      expression: "searchData.prodIds"
    }
  }, _vm._l((_vm.baseDataRecords.Product), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.productName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "自定义/标准"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.typeId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "typeId", $$v)
      },
      expression: "searchData.typeId"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "标准",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "自定义",
      "value": "1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "医院层级"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.hospitalLevel),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "hospitalLevel", $$v)
      },
      expression: "searchData.hospitalLevel"
    }
  }, _vm._l((_vm.hospitalLevelNames), function(item) {
    return _c('el-option', {
      key: item.hospitalLevel,
      attrs: {
        "value": item.hospitalLevel,
        "label": item.hospitalLevel
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticClass: "btn-search",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handlerExportExcelClick()
      }
    }
  }, [_vm._v("批量导出")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.canBatchDelete,
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleBatchDeleteClick()
      }
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddNewClick()
      }
    }
  }, [_vm._v("添加医院层级")])], 1)]), _vm._v(" "), _c('common-crud', {
    ref: "crud",
    attrs: {
      "addNewOrEditData": _vm.addNewOrEditData,
      "searchData": _vm.searchData,
      "searchDataLikeField": {
        'prodIds': ','
      },
      "crudApi": _vm.crudApi,
      "tableData": _vm.hospitallevelData,
      "showEditFormTitle": false,
      "beforeSave": _vm.beforeSave,
      "afterSave": _vm.handleHospitalLevelChange,
      "afterDelete": _vm.handleHospitalLevelChange,
      "selectedDataArray": _vm.selectedData,
      "otherValid": _vm.validUpload,
      "addSuccessMessages": "添加医院层级成功",
      "editSuccessMessages": "编辑医院层级成功",
      "deleteSuccessMessages": "删除医院层级成功",
      "deleteBatchSuccessMessages": "批量删除医院层级成功"
    },
    on: {
      "update:tableData": function($event) {
        _vm.hospitallevelData = $event
      },
      "update:table-data": function($event) {
        _vm.hospitallevelData = $event
      },
      "update:selectedDataArray": function($event) {
        _vm.selectedData = $event
      },
      "update:selected-data-array": function($event) {
        _vm.selectedData = $event
      }
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "width": "60",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "departId",
      "label": "部门"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "medicalField",
      "width": "135"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('div', [_vm._v("Franchise/DA")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "teamL4",
      "label": "团队"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "prodIds",
      "label": "产品"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "typeId",
      "label": "标准/自定义",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "hospitalLevel",
      "label": "医院层级",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "modelScore",
      "label": "评分"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatDateTime2Date,
      "sortable": "",
      "prop": "updateTime",
      "label": "更新时间",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "updateBy",
      "label": "操作人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-column-operate"
        }, [_c('el-button', {
          attrs: {
            "disabled": scope.row.typeId == '0',
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditClick(scope.row)
            }
          }
        }, [_vm._v("\n                    编辑\n                  ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "disabled": scope.row.typeId == '0',
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteClick(scope.row)
            }
          }
        }, [_vm._v("\n                    删除\n                  ")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "customTitle"
  }, [_vm._v("医院层级")]), _vm._v(" "), _c('template', {
    slot: "editForm"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "部门",
      "prop": "departId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.medicalField = '';
        _vm.addNewOrEditData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.addNewOrEditData.departId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "departId", $$v)
      },
      expression: "addNewOrEditData.departId"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.departsList : _vm.userInfo.loginDeparts)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "Franchise/DA",
      "prop": "medicalField"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.addNewOrEditData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "medicalField", $$v)
      },
      expression: "addNewOrEditData.medicalField"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.medicalFieldList : _vm.getMedicalFieldArray(_vm.addNewOrEditData.departId, false))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "团队",
      "prop": "teamL4"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "teamL4", $$v)
      },
      expression: "addNewOrEditData.teamL4"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.teamList : _vm.getTeamArray(_vm.addNewOrEditData.departId, _vm.addNewOrEditData.medicalField, false))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "产品",
      "prop": "prodIds"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择（可多选，可搜索）"
    },
    model: {
      value: (_vm.addNewOrEditData.prodIds),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "prodIds", $$v)
      },
      expression: "addNewOrEditData.prodIds"
    }
  }, _vm._l((_vm.baseDataRecords.Product), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.productName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院层级",
      "prop": "hospitalLevel"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.addNewOrEditData.hospitalLevel),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "hospitalLevel", $$v)
      },
      expression: "addNewOrEditData.hospitalLevel"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "评分（10分制）",
      "prop": "modelScore"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.modelScore),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "modelScore", $$v)
      },
      expression: "addNewOrEditData.modelScore"
    }
  }, _vm._l((10), function(n) {
    return _c('el-option', {
      key: n,
      attrs: {
        "label": n,
        "value": n
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('common-score', {
    ref: "strategyHospital4Hospital",
    attrs: {
      "disabledDownload": !_vm.canDownload,
      "title": "策略重点与医院层级",
      "type": "strategyHospital4Hospital",
      "fileName": "策略重点与医院层级.xlsx",
      "getExportParams": _vm.getScoreExportParams,
      "tipCode": "16"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "confirmAddNewMessage"
  }, [_c('div', [_c('span', [_vm._v("确认添加医院层级？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmEditMessage"
  }, [_c('div', [_c('span', [_vm._v("确认保存医院层级？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("删除医院层级？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmBatchDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("批量删除医院层级？")])])])], 2)], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-421f5da2", module.exports)
  }
}

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-drawer"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "search-content"
  }, [_c('div', {
    staticClass: "search-content-fields"
  }, [_c('el-form', {
    ref: "searchForm",
    attrs: {
      "inline": ""
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.handleSaveClick
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "search-result"
  }, [_c('el-tree', {
    ref: "menuTree",
    attrs: {
      "props": _vm.menuTreeProps,
      "data": _vm.menuData,
      "node-key": "id",
      "show-checkbox": ""
    }
  })], 1)])]), _vm._v(" "), _c('common-confirm', {
    attrs: {
      "dialogVisiable": _vm.confirmSaveVisible,
      "confirm": _vm.handlerSaveConfirmOK,
      "appendToDialog": ""
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.confirmSaveVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.confirmSaveVisible = $event
      }
    }
  }, [_c('div', [_vm._v("\n        确认保存？\n      ")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-454b3b23", module.exports)
  }
}

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.approvalVisiable,
      "center": true,
      "destroy-on-close": true,
      "close-on-click-modal": false,
      "custom-class": "approval_box"
    },
    on: {
      "update:visible": function($event) {
        _vm.approvalVisiable = $event
      }
    }
  }, [_c('span', {
    staticClass: "dialog-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [(_vm.type === 'approve') ? _c('span', [_c('i', {
    staticClass: "el-icon-success",
    staticStyle: {
      "font-size": "18px",
      "color": "#008748",
      "font-weight": "100"
    }
  }), _vm._v("\n      " + _vm._s(_vm.title || _vm.$t('popup.approve')) + "\n    ")]) : _c('span', [_c('i', {
    staticClass: "el-icon-error",
    staticStyle: {
      "font-size": "18px",
      "color": "#e40030",
      "font-weight": "100"
    }
  }), _vm._v("\n      " + _vm._s(_vm.title || _vm.$t('popup.reject')) + "\n    ")])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.changeRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "comment"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "resize": "none",
      "maxlength": "500",
      "placeholder": _vm.placeholder,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.form.comment),
      callback: function($$v) {
        _vm.$set(_vm.form, "comment", $$v)
      },
      expression: "form.comment"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "round": "",
      "size": "medium",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.confirmApproval
    }
  }, [_vm._v(_vm._s(_vm.$t('btn.confirm')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-45c4bd25", module.exports)
  }
}

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "e2e-home page-submenu"
  }, [_c('div', {
    staticClass: "e2e-container",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "page-submenu_left"
  }, [_c('div', {
    staticClass: "e2e-content-box"
  }, [_c('left-bar', {
    attrs: {
      "tab": "user-authorizelm"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-submenu_right"
  }, [_c('div', {
    staticClass: "e2e-content-box"
  }, [_c('div', {
    staticClass: "user-container"
  }, [_c('div', {
    staticClass: "user-basic-container"
  }, [_c('div', {
    staticClass: "authorizelm-text"
  }, [_vm._v("授权功能说明： 针对指定对象进行审批权限的授权，本人失去原有审批权限，可以在授权页面查看和维护授权功能，无法针对多个用户进行重复授权。")]), _vm._v(" "), _c('div', {
    staticClass: "search-content"
  }, [_c('div', {
    staticClass: "search-content-fields"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddNewClick()
      }
    }
  }, [_vm._v("添加")])], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "header-cell-class-name": "table-header-cell",
      "tooltip-effect": "light"
    }
  }, [(_vm.isAdmin) ? _c('el-table-column', {
    attrs: {
      "prop": "licensorAd",
      "label": "授权人AD"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('el-table-column', {
    attrs: {
      "prop": "licensorName",
      "label": "授权人姓名"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "authorizedPersonAd",
      "label": "被授权人AD"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "authorizedPersonName",
      "label": "被授权人姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "authorizedPersonEmail",
      "label": "被授权人邮箱"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "authorizationDeadline",
      "label": "授权截至日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "终止授权"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteClick(scope.row)
            }
          }
        }, [_vm._v("\n                          终止\n                      ")])]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('common-confirm', {
    attrs: {
      "dialogVisiable": _vm.confirmDeleteVisible,
      "confirm": _vm.handlerDeleteConfirmOK
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.confirmDeleteVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.confirmDeleteVisible = $event
      }
    }
  }, [_c('div', [_vm._v("\n        是否确认取消授权?\n      ")])])], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4628556a", module.exports)
  }
}

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.centerDialogVisible,
      "close-on-click-modal": false,
      "width": "80%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleSheetClick
    },
    model: {
      value: (_vm.activeSheet),
      callback: function($$v) {
        _vm.activeSheet = $$v
      },
      expression: "activeSheet"
    }
  }, _vm._l((_vm.sheetNames), function(item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "label": item,
        "name": item
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [(_vm.download) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleDownload
    }
  }, [_c('i', {
    staticClass: "gsk-icon-download"
  }), _vm._v("\n        " + _vm._s(_vm.$t('btn.download')) + "\n      ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    ref: "result",
    staticClass: "excel-container"
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('btn.confirm')))])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4a5e30e8", module.exports)
  }
}

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.type == 'select') ? _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value": _vm.getValueSting,
      "autocomplete": "reset",
      "disabled": _vm.disabled,
      "clearable": _vm.clearable,
      "multiple": _vm.multiple,
      "collapse-tags": _vm.collapseTags,
      "filterable": "",
      "popper-append-to-body": false,
      "placeholder": _vm.placeholder || _vm.$t('system.select.common_select')
    },
    on: {
      "change": _vm.handleChange
    }
  }, _vm._l((_vm.dictOptions), function(dict, index) {
    return _c('el-option', {
      key: _vm.code + index,
      attrs: {
        "disabled": _vm.disabledOptions(dict),
        "label": _vm.$languageChoose({
          zh: dict.text,
          en: dict.textEn,
        }),
        "title": _vm.$languageChoose({
          zh: dict.text,
          en: dict.textEn,
        }),
        "value": dict.value
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.type == 'radio') ? _c('div', [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.dictOptions), function(dict, index) {
    return _c('el-radio', {
      key: index,
      attrs: {
        "label": dict.value
      }
    }, [_vm._v(_vm._s(_vm.$languageChoose({
      zh: dict.text,
      en: dict.textEn
    })) + "\n      ")])
  }), 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4b69d82e", module.exports)
  }
}

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-score"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "not-required",
    class: _vm.required ? 'required' : ''
  }, [_vm._v("*")]), _vm._v(_vm._s(("评分项：" + _vm.title))), (_vm.tipCode) ? _c('common-tooltip', {
    staticClass: "tooltip",
    attrs: {
      "tipCode": _vm.tipCode
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.disabledDownload,
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.handleExport
    }
  }, [_vm._v("数据下载")]), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "upload",
    attrs: {
      "action": 'http://',
      "show-file-list": true,
      "accept": _vm.acceptType,
      "auto-upload": false,
      "on-change": _vm.valid,
      "on-remove": _vm.valid,
      "limit": 1
    },
    nativeOn: {
      "click": function($event) {
        return (function (e) { return _vm.disabledUpload ? e.preventDefault() : ''; })($event)
      }
    }
  }, [_c('el-button', {
    staticClass: "btn-upload",
    class: _vm.error ? 'error' : '',
    attrs: {
      "disabled": _vm.disabledUpload,
      "type": "primary",
      "plain": ""
    }
  }, [_vm._v("数据上传")])], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d5edbb1", module.exports)
  }
}

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ticket != '-1' && _vm.ticket) ? _c('div', {
    staticClass: "tableau",
    style: ({
      zoom: _vm.getZoom
    })
  }, [_c('Tableau', {
    ref: "budgetTableau",
    attrs: {
      "url": _vm.url,
      "width": _vm.width,
      "height": _vm.height
    }
  })], 1) : (_vm.ticket == '-1') ? _c('div', [_c('error-section')], 1) : _c('div')
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4e0dfd05", module.exports)
  }
}

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "e2e-home page-submenu"
  }, [_c('div', {
    staticClass: "e2e-container",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "page-submenu_left"
  }, [_c('div', {
    staticClass: "e2e-content-box"
  }, [_c('left-bar', {
    attrs: {
      "tab": "user-authorizedlevel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-submenu_right"
  }, [_c('div', {
    staticClass: "e2e-content-box"
  }, [_c('div', {
    staticClass: "user-container"
  }, [_c('div', {
    staticClass: "user-basic-container"
  }, [_c('div', {
    staticClass: "authorizelm-text"
  }, [_vm._v("授权功能说明： 针对指定对象进行审批权限的授权，本人失去原有审批权限，可以在授权页面查看和维护授权功能，无法针对多个用户进行重复授权。")]), _vm._v(" "), _c('div', {
    staticClass: "search-content"
  }, [_c('div', {
    staticClass: "search-content-fields"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddNewClick()
      }
    }
  }, [_vm._v("添加")])], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "header-cell-class-name": "table-header-cell",
      "tooltip-effect": "light"
    }
  }, [(_vm.isAdmin) ? _c('el-table-column', {
    attrs: {
      "prop": "licensorAd",
      "label": "授权人AD"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('el-table-column', {
    attrs: {
      "prop": "licensorName",
      "label": "授权人姓名"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "authorizationTeam",
      "label": "授权团队"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "authorizedPersonAd",
      "label": "被授权人AD"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "authorizedPersonName",
      "label": "被授权人姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "authorizedPersonEmail",
      "label": "被授权人邮箱"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "authorizationDeadline",
      "label": "授权截至日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "终止授权"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteClick(scope.row)
            }
          }
        }, [_vm._v("\n                          终止\n                      ")])]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('common-confirm', {
    attrs: {
      "dialogVisiable": _vm.confirmDeleteVisible,
      "confirm": _vm.handlerDeleteConfirmOK
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.confirmDeleteVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.confirmDeleteVisible = $event
      }
    }
  }, [_c('div', [_vm._v("\n      是否确认取消授权?\n    ")])])], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4f13d1ac", module.exports)
  }
}

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit-main"
  }, [_c('div', {
    staticClass: "page-contain view-meeting-plan"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.addNewOrEditData,
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "会议名称"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.meetingName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": ""
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("系统选择"), _c('common-tooltip', {
    attrs: {
      "tipCode": "8"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingSystem', _vm.addNewOrEditData.meetingSystem)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "是否网络会议"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingModality', _vm.addNewOrEditData.meetingModality)))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "会议性质"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp)))])])], 1), _vm._v(" "), (_vm.meetingSystemType != 'GSD') ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "A1会议类型"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingType', _vm.addNewOrEditData.meetingType)))])])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.meetingSystemType != 'A1') ? _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "GSD项目类型"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingGsdType', _vm.addNewOrEditData.meetingGsdType)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "GSD细类"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingGsdTypeSub' + _vm.addNewOrEditData.meetingGsdType, _vm.addNewOrEditData.meetingGsdSubType)))])])], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "部门"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('Depart', _vm.addNewOrEditData.departId)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "Franchise/DA"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MedicalField', _vm.addNewOrEditData.medicalField)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "团队"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('Teams', _vm.addNewOrEditData.teamL4)))])])], 1)], 1), _vm._v(" "), _c('el-row', [(_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp) == '推广') ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "治疗领域"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('TreatmentArea', _vm.addNewOrEditData.treatmentArea)))])])], 1) : _vm._e(), _vm._v(" "), (_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp).indexOf('非推广') >= 0) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "疾病领域"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('DiseaseArea', _vm.addNewOrEditData.diseaseArea)))])])], 1) : _vm._e(), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "产品"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('Product', _vm.addNewOrEditData.productId)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "公司战略"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('CompanyStrategy', _vm.addNewOrEditData.companyStrategy)))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "策略重点"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.strategyKeynoteName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'A1' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'A1',
      "label": "治疗领域业务结果"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.medicalFieldResultName))])])], 1), _vm._v(" "), (_vm.addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') >= 0) ? _c('el-col', [_c('el-form-item', {
    staticClass: "not-required",
    attrs: {
      "label": "治疗领域业务结果（自定义描述）"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.medicalFieldResultDes))])])], 1) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "开始日期"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm._f("DateFormat")(_vm.addNewOrEditData.meetingBeginDate)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "结束日期"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm._f("DateFormat")(_vm.addNewOrEditData.meetingEndDate)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "会议时段"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingTimeInt', _vm.addNewOrEditData.meetingTimeInt)))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    class: (_vm.meetingSystemType != 'GSD') ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "国家"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.countryName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: (_vm.meetingSystemType != 'GSD') ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "省份"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.provinceName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: (_vm.meetingSystemType != 'GSD') ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "城市"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.cityName))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    class: (_vm.meetingSystemType != 'GSD' && _vm.basedataGetName('MeetingModality', _vm.addNewOrEditData.meetingModality).indexOf('线下') >= 0) ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD' && _vm.basedataGetName('MeetingModality', _vm.addNewOrEditData.meetingModality).indexOf('线下') >= 0,
      "label": "会议地点"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.meetingPlace))])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [(_vm.meetingSystemType != 'A1') ? _c('el-row', [_c('div', {
    staticClass: "col-full"
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "受赠方类型(GSD系统)"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.recipientSocietyOrHospital),
      callback: function($$v) {
        _vm.recipientSocietyOrHospital = $$v
      },
      expression: "recipientSocietyOrHospital"
    }
  }, [_c('el-radio', {
    staticClass: "tooltip-header-text",
    attrs: {
      "label": 1
    }
  }, [_vm._v("受赠学会"), _c('common-tooltip', {
    attrs: {
      "tipCode": "11"
    }
  })], 1), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("医院")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("大学")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("患者组织")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("其他")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.meetingSystemType != 'A1' && _vm.recipientSocietyOrHospital) ? _c('el-row', {
    staticClass: "recipientSociety-input"
  }, [_c('el-col', [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.recipientSocietyStr || _vm.addNewOrEditData.universityStr || _vm.addNewOrEditData.patientOrgStr || _vm.addNewOrEditData.otherStr))])])], 1) : _vm._e(), _vm._v(" "), (_vm.meetingSystemType == 'A1' || !_vm.recipientSocietyOrHospital) ? _c('div', [_c('el-row', [(!_vm.isOneHospital()) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院总数"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.moreThenOneHospital),
      callback: function($$v) {
        _vm.moreThenOneHospital = $$v
      },
      expression: "moreThenOneHospital"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("一家")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("两家及以上")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    staticClass: "more-tab"
  }, [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "hospitalLevelId"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("医院层级"), _c('common-tooltip', {
    attrs: {
      "tipCode": "9"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.hospitalLevelName))])])], 1), _vm._v(" "), (_vm.moreThenOneHospital && !_vm.isOneHospital()) ? _c('el-col', {
    staticClass: "col-add-remove"
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院数量",
      "prop": 'extendData.hospitalInfos.' + _vm.index + '.hospitalCount'
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.hospitalCount))])])], 1) : _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院",
      "prop": "hospitalId"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.hospitalName))])])], 1)], 1), _vm._v(" "), (_vm.moreThenOneHospital && !_vm.isOneHospital()) ? _c('div', _vm._l((_vm.addNewOrEditData.extendData.hospitalInfos), function(hospital, index) {
    return _c('div', {
      key: index,
      staticClass: "more-tab-div"
    }, [_c('el-row', {
      staticClass: "more-tab"
    }, [_c('el-col', [_c('el-form-item', {
      attrs: {
        "required": "",
        "prop": 'extendData.hospitalInfos.' + index + '.hospitalLevelId'
      }
    }, [_c('span', {
      staticClass: "tooltip-header-text",
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v("医院层级"), _c('common-tooltip', {
      attrs: {
        "tipCode": "9"
      }
    })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(hospital.hospitalLevelName))])])], 1), _vm._v(" "), _c('el-col', {
      staticClass: "col-add-remove"
    }, [_c('el-form-item', {
      attrs: {
        "required": "",
        "label": "医院数量",
        "prop": 'extendData.hospitalInfos.' + index + '.hospitalCount'
      }
    }, [_c('label', [_vm._v(_vm._s(hospital.hospitalCount))])])], 1)], 1)], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "科室"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('Office', _vm.addNewOrEditData.offices)))])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "是否包含讲者"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.includeSpeaker ? '是' : '否'))])])], 1)], 1), _vm._v(" "), (_vm.addNewOrEditData.includeSpeaker == 1) ? _c('el-row', {
    staticClass: "more-tab"
  }, [_c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD'
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("讲者级别"), _c('common-tooltip', {
    attrs: {
      "tipCode": "10"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.speakerLevelName))])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "col-add-remove"
  }, [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "讲者人数"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.speakerCount))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.includeSpeaker == 1) ? _c('div', {
    staticClass: "more-tab-div"
  }, _vm._l((_vm.addNewOrEditData.extendData.speakerInfos), function(speaker, index) {
    return _c('el-row', {
      key: index,
      staticClass: "more-tab"
    }, [_c('el-col', [_c('el-form-item', {
      class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
      attrs: {
        "required": _vm.meetingSystemType != 'GSD'
      }
    }, [_c('span', {
      staticClass: "tooltip-header-text",
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v("讲者级别"), _c('common-tooltip', {
      attrs: {
        "tipCode": "10"
      }
    })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(speaker.speakerLevelName))])])], 1), _vm._v(" "), _c('el-col', {
      staticClass: "col-add-remove"
    }, [_c('el-form-item', {
      class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
      attrs: {
        "required": _vm.meetingSystemType != 'GSD',
        "label": "讲者人数"
      }
    }, [_c('label', [_vm._v(_vm._s(speaker.speakerCount))])])], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "参会人数（外）"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.attendCount))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "罗氏员工人数（内）"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.rocheCount))])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": ""
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("会议总预算"), _c('common-tooltip', {
    attrs: {
      "tipCode": "12"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.totalAmount))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "成本中心"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.costCenter + ' ' + _vm.addNewOrEditData.costCenterName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    staticClass: "not-required",
    attrs: {
      "label": "WBS code"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.wbsCode))])])], 1)], 1), _vm._v(" "), _c('el-row', [(_vm.addNewOrEditData.meetingSystem.length == 2) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "A1预算"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.a1Amount))])])], 1) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.meetingSystem.length == 2) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "GSD预算"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.gsdAmount))])])], 1) : _vm._e(), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    staticClass: "not-required",
    attrs: {
      "label": "会议申请人"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.meetingOrganizerCnname + ' ' + _vm.addNewOrEditData.meetingOrganizerName))])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "approval-workflow-title"
  }, [_vm._v("\n                  审批流\n                  "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "content-box"
  }, _vm._l((_vm.addNewOrEditData.nodeList), function(node) {
    return _c('el-row', {
      key: node.id
    }, [_c('el-col', {
      staticClass: "approval-workflow"
    }, [_c('el-form-item', {
      staticClass: "not-required",
      attrs: {
        "label": node.isAuthorized === 0 ? node.nodeLevel + '【授权审批】' : node.nodeLevel,
        "prop": "treatAreaResult"
      }
    }, [_c('label', [_vm._v(_vm._s(node.realName) + " " + _vm._s(node.username) + " " + _vm._s(node.createTime) + " " + _vm._s(node.isAuthorized === 0 ? ("（" + (node.licensorName) + "授权）") : ''))]), _vm._v(" "), _c('span', {
      class: ['approval-status', _vm.approvalStatusClass(node.meetStatus)]
    }, [_vm._v(_vm._s(node.statusName))])]), _vm._v(" "), (node.remark) ? _c('el-form-item', {
      staticClass: "not-required"
    }, [_c('label', [_vm._v(_vm._s(node.remark))])]) : _vm._e()], 1)], 1)
  }), 1)])])], 1), _vm._v(" "), (!_vm.waitBack) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addNewOrEditData.canApprove),
      expression: "addNewOrEditData.canApprove"
    }],
    staticClass: "bottom-info"
  }, [_c('div', {
    staticClass: "bottom-info-operate"
  }, [_c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": _vm.handleApprovalRejectClick
    }
  }, [_vm._v("审批拒绝")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleApprovalConfirmClick
    }
  }, [_vm._v("审批通过")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', [_c('approval-dialog', {
    attrs: {
      "dialogVisiable": _vm.approvalDailogVisible,
      "confirm": _vm.handleApprovalConfirm,
      "reject": _vm.handleApprovalReject,
      "type": _vm.approvalType
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.approvalDailogVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.approvalDailogVisible = $event
      }
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-55241215", module.exports)
  }
}

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.centerDialogVisible,
      "close-on-click-modal": false,
      "width": "50%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('btn.confirm')))])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-59f49474", module.exports)
  }
}

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "e2e-home page-submenu"
  }, [_c('div', {
    staticClass: "e2e-container",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "page-submenu_left"
  }, [_c('div', {
    staticClass: "e2e-content-box"
  }, [_c('left-bar', {
    attrs: {
      "tab": "user-authorizelm"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-submenu_right"
  }, [_c('div', {
    staticClass: "e2e-content-box"
  }, [_c('div', {
    staticClass: "user-container"
  }, [_c('div', {
    staticClass: "user-basic-container",
    staticStyle: {
      "width": "400px"
    }
  }, [_c('div', {
    staticClass: "e2e-form"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form,
      "label-position": "top"
    }
  }, [(_vm.isAdmin) ? _c('el-form-item', {
    attrs: {
      "label": "授权人AD",
      "prop": "licensorAd"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择（可搜索）",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.remoteMethodLAD
    },
    model: {
      value: (_vm.form.licensorAd),
      callback: function($$v) {
        _vm.$set(_vm.form, "licensorAd", $$v)
      },
      expression: "form.licensorAd"
    }
  }, _vm._l((_vm.licensorList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.adAccount,
        "label": item.workerNameLocal + ' ' + item.adAccount
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("授权天数")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("授权日期")]), _vm._v(" "), _c('span', {
    staticClass: "radio-after-text"
  }, [_vm._v("（最长授权时间180天）")])], 1), _vm._v(" "), (_vm.radio === '1') ? _c('el-form-item', {
    attrs: {
      "label": "授权天数",
      "prop": "days"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.days),
      callback: function($$v) {
        _vm.$set(_vm.form, "days", $$v)
      },
      expression: "form.days"
    }
  }, _vm._l((_vm.daysList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.label
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.radio === '2') ? _c('el-form-item', {
    attrs: {
      "label": "授权日期",
      "prop": "date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.form.date),
      callback: function($$v) {
        _vm.$set(_vm.form, "date", $$v)
      },
      expression: "form.date"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "被授权人AD",
      "prop": "authorizedPersonAd"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择（可搜索）",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.remoteMethodAPAD
    },
    on: {
      "change": _vm.changeAuthorizedPersonAd
    },
    model: {
      value: (_vm.form.authorizedPersonAd),
      callback: function($$v) {
        _vm.$set(_vm.form, "authorizedPersonAd", $$v)
      },
      expression: "form.authorizedPersonAd"
    }
  }, _vm._l((_vm.authorizedPersonList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.adAccount,
        "label": item.workerNameLocal + ' ' + item.adAccount
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.dialogVisible,
      "width": "500px",
      "show-close": true,
      "center": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dialogText1)), _c('br'), _c('br'), _vm._v(_vm._s(_vm.dialogText2)), _c('br'), _vm._v(_vm._s(_vm.dialogText3))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handlerOK()
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5a8124dd", module.exports)
  }
}

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-submenu"
  }, [_c('div', {
    staticClass: "page-submenu_left"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('left-bar', {
    attrs: {
      "tab": "3"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-submenu_right"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('common-crud', {
    ref: "crud",
    attrs: {
      "searchData": _vm.searchData,
      "tableData": _vm.emailTemplateData,
      "addNewOrEditData": _vm.addNewOrEditData,
      "crudApi": _vm.crudApi,
      "showEditFormTitle": false,
      "beforeSave": _vm.beforeSave,
      "editSuccessMessages": "编辑邮件模板成功"
    },
    on: {
      "update:tableData": function($event) {
        _vm.emailTemplateData = $event
      },
      "update:table-data": function($event) {
        _vm.emailTemplateData = $event
      }
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "templateCode",
      "label": "模板Code",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "templateName",
      "label": "模板标题",
      "min-width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatDateTime2Date,
      "sortable": "",
      "prop": "updateTime",
      "label": "操作时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "updateBy",
      "label": "操作人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-column-operate"
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditClick(scope.row)
            }
          }
        }, [_vm._v("\n                    编辑\n                  ")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "customTitle"
  }, [_vm._v("公告信息")]), _vm._v(" "), _c('template', {
    slot: "editForm"
  }, [_c('el-row', [_c('div', {
    staticClass: "col-full"
  }, [_c('el-form-item', {
    attrs: {
      "label": "模板Code",
      "prop": "templateCode"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.addNewOrEditData.templateCode),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "templateCode", $$v)
      },
      expression: "addNewOrEditData.templateCode"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "col-full"
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "模板标题",
      "prop": "templateName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入模板标题"
    },
    model: {
      value: (_vm.addNewOrEditData.templateName),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "templateName", $$v)
      },
      expression: "addNewOrEditData.templateName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "col-full"
  }, [_c('el-form-item', {
    attrs: {
      "label": "模板标题",
      "prop": "templateContent"
    }
  }, [_c('common-editor', {
    ref: "editor",
    attrs: {
      "editorHeight": "300"
    },
    model: {
      value: (_vm.addNewOrEditData.templateContent),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "templateContent", $$v)
      },
      expression: "addNewOrEditData.templateContent"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('template', {
    slot: "confirmEditMessage"
  }, [_c('div', [_c('span', [_vm._v("确认保存邮件模板？")])])])], 2)], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5ac98730", module.exports)
  }
}

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-contain"
  }, [_c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('common-crud', {
    ref: "crud",
    attrs: {
      "addNewOrEditData": _vm.addNewOrEditData,
      "searchData": _vm.searchData,
      "crudApi": _vm.crudApi,
      "tableData": _vm.messagesData,
      "showEditFormTitle": false,
      "beforeSave": _vm.beforeSave,
      "afterSave": _vm.handleHospitalLevelChange,
      "afterDelete": _vm.handleHospitalLevelChange,
      "selectedDataArray": _vm.selectedData,
      "customListResult": true
    },
    on: {
      "update:tableData": function($event) {
        _vm.messagesData = $event
      },
      "update:table-data": function($event) {
        _vm.messagesData = $event
      },
      "update:selectedDataArray": function($event) {
        _vm.selectedData = $event
      },
      "update:selected-data-array": function($event) {
        _vm.selectedData = $event
      }
    }
  }, [_c('template', {
    slot: "customResult"
  }, _vm._l((_vm.messagesData), function(data, index) {
    return _c('div', {
      key: index,
      staticClass: "message-box"
    }, [_c('div', {
      staticClass: "message-box-title"
    }, [_vm._v("\n                【" + _vm._s(data.titile) + "】 " + _vm._s(data.sendTime) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "message-box-content"
    }, [_c('div', {
      staticClass: "message-box-content-info"
    }, [_vm._v(_vm._s(_vm._f("removeHtmlTag")((data.msgContent ? data.msgContent : ' '))))]), _vm._v(" "), _c('div', {
      staticClass: "message-box-content-operator"
    }, [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.meetingId),
        expression: "data.meetingId"
      }],
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.handleViewClick(data)
        }
      }
    }, [_vm._v("\n                      查看\n                  ")])], 1)])])
  }), 0), _vm._v(" "), _c('template', {
    slot: "customTitle"
  }, [_vm._v("医院层级")])], 2)], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-60b986d2", module.exports)
  }
}

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    ref: "select",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value": _vm.value,
      "placeholder": "请选择",
      "size": "mini",
      "disabled": _vm.disabled,
      "clearable": ""
    },
    on: {
      "visible-change": _vm.visibleChange,
      "clear": _vm.clear
    }
  }, [_c('el-option', {
    ref: "option",
    staticClass: "option",
    attrs: {
      "value": _vm.optionData.id,
      "label": _vm.optionData.name
    }
  }, [_c('el-tree', {
    ref: "tree",
    staticClass: "tree",
    attrs: {
      "node-key": _vm.nodeKey,
      "data": _vm.data,
      "props": _vm.props,
      "default-expanded-keys": [_vm.value],
      "highlight-current": "",
      "expand-on-click-node": false
    },
    on: {
      "node-click": _vm.handleNodeClick
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-648200e0", module.exports)
  }
}

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-drawer"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "search-content"
  }, [_c('div', {
    staticClass: "search-content-fields"
  }, [_c('el-form', {
    ref: "searchForm",
    attrs: {
      "inline": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "中文名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.searchData.itemText),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "itemText", $$v)
      },
      expression: "searchData.itemText"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "英文名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.searchData.itemTextEn),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "itemTextEn", $$v)
      },
      expression: "searchData.itemTextEn"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.status),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "status", $$v)
      },
      expression: "searchData.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "正常",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "禁用",
      "value": "0"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.handleResetSearchField
    }
  }, [_vm._v("重置")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.handleAddNewClick
    }
  }, [_vm._v("添加")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "search-result"
  }, [_c('common-crud', {
    ref: "crud",
    attrs: {
      "addNewOrEditData": _vm.addNewOrEditData,
      "searchData": _vm.searchData,
      "crudApi": _vm.crudApi,
      "tableData": _vm.dictItemData,
      "beforeSave": _vm.beforeSave,
      "addSuccessMessages": "添加数据字典项成功",
      "editSuccessMessages": "编辑数据字典项成功",
      "deleteSuccessMessages": "删除数据字典项成功",
      "deleteBatchSuccessMessages": "批量删除数据字典项成功"
    },
    on: {
      "update:tableData": function($event) {
        _vm.dictItemData = $event
      },
      "update:table-data": function($event) {
        _vm.dictItemData = $event
      }
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "itemText",
      "label": "中文名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "itemTextEn",
      "label": "英文名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "itemAbbreviation",
      "label": "缩写"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "itemValue",
      "label": "数据值"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatStatusData,
      "sortable": "",
      "prop": "status",
      "label": "状态"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-column-operate"
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditDictItemClick(scope.row)
            }
          }
        }, [_vm._v("\n                      编辑\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteClick(scope.row)
            }
          }
        }, [_vm._v("\n                      删除\n                    ")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "editForm"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "itemText",
      "label": "中文名称"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入中文名称"
    },
    model: {
      value: (_vm.addNewOrEditData.itemText),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "itemText", $$v)
      },
      expression: "addNewOrEditData.itemText"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "英文名称"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入英文名称"
    },
    model: {
      value: (_vm.addNewOrEditData.itemTextEn),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "itemTextEn", $$v)
      },
      expression: "addNewOrEditData.itemTextEn"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "itemValue",
      "label": "数据值"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入数据值"
    },
    model: {
      value: (_vm.addNewOrEditData.itemValue),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "itemValue", $$v)
      },
      expression: "addNewOrEditData.itemValue"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "缩写"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入缩写"
    },
    model: {
      value: (_vm.addNewOrEditData.itemAbbreviation),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "itemAbbreviation", $$v)
      },
      expression: "addNewOrEditData.itemAbbreviation"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "sortOrder",
      "label": "排序值"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "值越小越靠前，支持小数"
    },
    model: {
      value: (_vm.addNewOrEditData.sortOrder),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "sortOrder", $$v)
      },
      expression: "addNewOrEditData.sortOrder"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "status",
      "label": "是否启用"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.addNewOrEditData.status),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "status", $$v)
      },
      expression: "addNewOrEditData.status"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "col-full"
  }, [_c('el-form-item', {
    attrs: {
      "label": "描述"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入描述"
    },
    model: {
      value: (_vm.addNewOrEditData.description),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "description", $$v)
      },
      expression: "addNewOrEditData.description"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('template', {
    slot: "confirmAddNewMessage"
  }, [_c('div', [_c('span', [_vm._v("确认添加？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmEditMessage"
  }, [_c('div', [_c('span', [_vm._v("确认保存？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("删除字典项？")])])])], 2)], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-686a6933", module.exports)
  }
}

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-effectiveness"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page-contain"
  }, [_c('div', {
    staticClass: "search-content-main"
  }, [_c('el-form', {
    staticClass: "search-content-main-fields"
  }, [_c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.year),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "year", $$v)
      },
      expression: "searchMainData.year"
    }
  }, _vm._l((_vm.baseDataRecords.Year), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.yearName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.season),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "season", $$v)
      },
      expression: "searchMainData.season"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部季度"
    }
  }), _vm._v(" "), _vm._l((4), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "value": item,
        "label": '第' + item + '季'
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.meetingSystem),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "meetingSystem", $$v)
      },
      expression: "searchMainData.meetingSystem"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部系统"
    }
  }), _vm._v(" "), _vm._l((_vm.baseDataRecords.MeetingSystem), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.medicalFieldArr = [''];
        _vm.teamFieldArr = [''];
        _vm.searchMainData.medicalField = '';
        _vm.strategyKeynoteArr = [''];
        _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.departId),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "departId", $$v)
      },
      expression: "searchMainData.departId"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部部门"
    }
  }), _vm._v(" "), _vm._l((_vm.baseDataRecords.Depart), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.teamFieldArr = [''];
        _vm.strategyKeynoteArr = [''];
        _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.medicalFieldArr),
      callback: function($$v) {
        _vm.medicalFieldArr = $$v
      },
      expression: "medicalFieldArr"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部Franchise/DA"
    }
  }), _vm._v(" "), _vm._l((_vm.getMedicalFieldArray(_vm.searchMainData.departId, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.teamFieldArr),
      callback: function($$v) {
        _vm.teamFieldArr = $$v
      },
      expression: "teamFieldArr"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部团队"
    }
  }), _vm._v(" "), _vm._l((_vm.getTeamArray(_vm.searchMainData.departId, _vm.medicalFieldArr, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择（可搜索）"
    },
    on: {
      "change": function($event) {
        _vm.strategyKeynoteArr = [''];
        _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.productIdArr),
      callback: function($$v) {
        _vm.productIdArr = $$v
      },
      expression: "productIdArr"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部产品"
    }
  }), _vm._v(" "), _vm._l((_vm.baseDataRecords.Product), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.productName
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "search-content-main-fields"
  }, [_c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    staticStyle: {
      "width": "0.797rem"
    },
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择（可搜索）"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.strategyKeynoteArr),
      callback: function($$v) {
        _vm.strategyKeynoteArr = $$v
      },
      expression: "strategyKeynoteArr"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部策略重点"
    }
  }), _vm._v(" "), _vm._l((_vm.filterStrategy), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.keynote
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    staticStyle: {
      "width": "0.797rem"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.meetingModality),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "meetingModality", $$v)
      },
      expression: "searchMainData.meetingModality"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部会议形式"
    }
  }), _vm._v(" "), _vm._l((_vm.baseDataRecords.MeetingModality), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    staticStyle: {
      "width": "0.797rem"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchMainData.meetingType = '';
        _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.meetingProp),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "meetingProp", $$v)
      },
      expression: "searchMainData.meetingProp"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部会议性质"
    }
  }), _vm._v(" "), _vm._l((_vm.meetingPropAndTypeArrays.selectMeetingProp), function(item) {
    return _c('el-option', {
      key: item.itemValue,
      attrs: {
        "value": item.itemValue,
        "label": item.itemText
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    staticStyle: {
      "width": "0.797rem"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.meetingType),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "meetingType", $$v)
      },
      expression: "searchMainData.meetingType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部A1会议类型"
    }
  }), _vm._v(" "), _vm._l((_vm.filterMeetingType), function(item) {
    return _c('el-option', {
      key: item.itemValue,
      attrs: {
        "value": item.itemValue,
        "label": item.itemText
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    staticStyle: {
      "width": "0.797rem"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.meetingGsdType),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "meetingGsdType", $$v)
      },
      expression: "searchMainData.meetingGsdType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部GSD项目类型"
    }
  }), _vm._v(" "), _vm._l((_vm.baseDataRecords.MeetingGsdType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    staticStyle: {
      "width": "0.797rem"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.meetingGsdSubType),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "meetingGsdSubType", $$v)
      },
      expression: "searchMainData.meetingGsdSubType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部GSD细项"
    }
  }), _vm._v(" "), _vm._l((_vm.MeetingGsdSubTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "charts-row"
  }, [_c('div', {
    staticClass: "chart chart-full"
  }, [_c('div', {
    staticClass: "yAxisLabel"
  }, [_vm._v("K")]), _vm._v(" "), _c('div', {
    staticClass: "xAxisLabel"
  }, [_vm._v("评分")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', [_c('common-echars', {
    ref: "chart1",
    attrs: {
      "chartClass": "chart-class-1",
      "dataset-dimensions": ['评分', '预算'],
      "dataset-source": _vm.data1,
      "option": _vm.option1
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "page-header-title"
  }, [_vm._v("\n      评分\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "page-header-subinfo"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "iconfont icon-yusuan"
  }), _vm._v("预算")])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6911dd6e", module.exports)
  }
}

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "visible": _vm.dialogVisiable,
      "show-close": true,
      "center": true,
      "before-close": _vm.closeDialog,
      "append-to-body": _vm.appendToDialog,
      "close-on-click-modal": false,
      "custom-class": "common-confirm-dialog",
      "width": "300px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisiable = $event
      }
    }
  }, [_c('div', [_c('i', {
    staticClass: "iconfont",
    class: _vm.icon,
    style: ({
      color: _vm.iconColor
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "common-confirm-info"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirmOK
    }
  }, [_vm._v(_vm._s(_vm.$t("btn.confirm")))])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6a6df71f", module.exports)
  }
}

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tableau"
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-707e1f82", module.exports)
  }
}

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-result"
  }, [(!_vm.customListResult) ? _c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "header-cell-class-name": "table-header-cell",
      "tooltip-effect": "light",
      "row-key": _vm.rowKey,
      "tree-props": {
        children: 'children',
        hasChildren: 'hasChildren'
      }
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "sort-change": _vm.handleSortChange
    }
  }, [_vm._t("result")], 2) : _c('div', [_vm._t("customResult")], 2), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [(_vm.showPageData) ? _c('div', [_c('el-pagination', {
    attrs: {
      "current-page": _vm.pageData.pageNo,
      "page-size": _vm.pageData.pageSize,
      "page-sizes": [10, 20, 30, 50, 100],
      "layout": "total, prev, pager, next, sizes, jumper",
      "total": _vm.pageData.total,
      "prev-text": "<",
      "next-text": ">"
    },
    on: {
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pageData, "pageNo", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pageData, "pageNo", $event)
      },
      "update:pageSize": function($event) {
        return _vm.$set(_vm.pageData, "pageSize", $event)
      },
      "update:page-size": function($event) {
        return _vm.$set(_vm.pageData, "pageSize", $event)
      },
      "size-change": function($event) {
        return _vm.handleSearch(1)
      },
      "current-change": _vm.handleSearch,
      "prev-click": _vm.handleSearch,
      "next-click": _vm.handleSearch
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', [_c('el-dialog', {
    class: [_vm.editDialogClass, 'common-crud-dialog'],
    attrs: {
      "center": "",
      "visible": _vm.editVisible,
      "close-on-click-modal": false,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisible = $event
      }
    }
  }, [(_vm.showEditFormTitle) ? _c('div', [_c('span', {
    staticClass: "edit-form-title"
  }, [_vm._v(_vm._s(_vm.editType))])]) : _c('div', [_c('span', {
    staticClass: "edit-form-title"
  }, [_vm._t("customTitle")], 2)]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.addNewOrEditData,
      "show-message": false,
      "rules": _vm.rules,
      "label-position": _vm.editFormLabelPosition,
      "label-width": _vm.labelWidth
    }
  }, [_vm._t("editForm")], 2), _vm._v(" "), _c('common-confirm', {
    attrs: {
      "dialogVisiable": _vm.confirmEditSaveVisible,
      "confirm": _vm.handlerEditSaveConfirmOK,
      "appendToDialog": ""
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.confirmEditSaveVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.confirmEditSaveVisible = $event
      }
    }
  }, [(_vm.editType == '新增') ? _vm._t("confirmAddNewMessage") : _vm._t("confirmEditMessage")], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleEditConfirmClick()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.editVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1), _vm._v(" "), _c('common-confirm', {
    attrs: {
      "dialogVisiable": _vm.confirmDeleteVisible,
      "confirm": _vm.handlerDeleteConfirmOK,
      "appendToDialog": ""
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.confirmDeleteVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.confirmDeleteVisible = $event
      }
    }
  }, [_c('div', [_vm._t("confirmDeleteMessage")], 2)]), _vm._v(" "), _c('common-confirm', {
    attrs: {
      "dialogVisiable": _vm.confirmBatchDeleteVisible,
      "confirm": _vm.handlerBatchDeleteConfirmOK,
      "appendToDialog": ""
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.confirmBatchDeleteVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.confirmBatchDeleteVisible = $event
      }
    }
  }, [_vm._t("confirmBatchDeleteMessage")], 2), _vm._v(" "), _c('common-confirm', {
    staticClass: "tips-form-class",
    attrs: {
      "dialogVisiable": _vm.tipsFormVisible,
      "confirm": _vm.handlerTipsFormVisibleOK,
      "appendToDialog": ""
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.tipsFormVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.tipsFormVisible = $event
      }
    }
  }, [_vm._t("tipsFormMessage")], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-75bd0e6f", module.exports)
  }
}

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-submenu"
  }, [_c('div', {
    staticClass: "page-submenu_left"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('left-bar', {
    attrs: {
      "tab": "5"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-submenu_right"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "search-content"
  }, [_c('div', {
    staticClass: "search-content-fields"
  }, [_c('el-form', {
    ref: "searchForm",
    attrs: {
      "inline": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "字典名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.searchData.dictName),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "dictName", $$v)
      },
      expression: "searchData.dictName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "字典编号"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.searchData.dictCode),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "dictCode", $$v)
      },
      expression: "searchData.dictCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.handleResetSearchField
    }
  }, [_vm._v("重置")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleAddNewClick()
      }
    }
  }, [_vm._v("添加")])], 1)], 1)], 1)]), _vm._v(" "), _c('common-crud', {
    ref: "crud",
    attrs: {
      "addNewOrEditData": _vm.addNewOrEditData,
      "searchData": _vm.searchData,
      "tableData": _vm.dictData,
      "crudApi": _vm.crudApi,
      "addSuccessMessages": "添加数据字典成功",
      "editSuccessMessages": "编辑数据字典成功",
      "deleteSuccessMessages": "删除数据字典成功",
      "deleteBatchSuccessMessages": "批量删除数据字典成功"
    },
    on: {
      "update:tableData": function($event) {
        _vm.dictData = $event
      },
      "update:table-data": function($event) {
        _vm.dictData = $event
      }
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "dictName",
      "label": "字典名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "dictCode",
      "label": "字典编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "description",
      "label": "描述",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-column-operate"
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditClick(scope.row)
            }
          }
        }, [_vm._v("\n                      编辑\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleShowDictItemClick(scope.row)
            }
          }
        }, [_vm._v("\n                      字典配置\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteClick(scope.row)
            }
          }
        }, [_vm._v("\n                      删除\n                    ")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "editForm"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "字典名称",
      "prop": "dictName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入字典名称"
    },
    model: {
      value: (_vm.addNewOrEditData.dictName),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "dictName", $$v)
      },
      expression: "addNewOrEditData.dictName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "字典编码",
      "prop": "dictCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入字典编码"
    },
    model: {
      value: (_vm.addNewOrEditData.dictCode),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "dictCode", $$v)
      },
      expression: "addNewOrEditData.dictCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "col-full"
  }, [_c('el-form-item', {
    attrs: {
      "label": "描述",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入描述"
    },
    model: {
      value: (_vm.addNewOrEditData.description),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "description", $$v)
      },
      expression: "addNewOrEditData.description"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('template', {
    slot: "confirmAddNewMessage"
  }, [_c('div', [_c('span', [_vm._v("确认添加？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmEditMessage"
  }, [_c('div', [_c('span', [_vm._v("确认保存？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("删除字典？")])])])], 2)], 1)])]), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": '字典列表-' + _vm.dictName,
      "visible": _vm.dictItemDrawer,
      "direction": "rtl",
      "size": "900px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dictItemDrawer = $event
      }
    }
  }, [_c('dict-item', {
    ref: "dictItem",
    attrs: {
      "dictId": _vm.dictItemId
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-778fac58", module.exports)
  }
}

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-contain"
  }, [_c('div', {
    staticClass: "application-search-content-main"
  }, [_c('el-form', {
    staticClass: "application-search-content-main-fields",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticClass: "application-search-content-main-fields-year"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.year),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "year", $$v)
      },
      expression: "searchMainData.year"
    }
  }, _vm._l((_vm.baseDataRecords.Year), function(item) {
    return _c('el-option', {
      key: item.id,
      staticClass: "application-search-content-main-fields-year-items",
      attrs: {
        "value": item.id,
        "label": item.yearName
      }
    })
  }), 1)], 1), _vm._v(" "), _vm._l((_vm.searchMainQuarters), function(quater, index) {
    return _c('el-form-item', {
      key: index,
      class: [_vm.searchMainData.quarter == quater ? 'active' : '', 'application-search-content-main-fields-quarter']
    }, [_c('label', {
      on: {
        "click": function($event) {
          return _vm.handleMainSearch(quater)
        }
      }
    }, [_vm._v(_vm._s(quater))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "application-search-content-main-fields-quarter-lines"
  }, _vm._l((_vm.searchMainQuarters), function(quater, index) {
    return _c('div', {
      key: index,
      class: [_vm.searchMainData.quarter == quater ? 'line-active' : '', 'application-search-content-main-fields-quarter-lines-line', 'application-search-content-main-fields-quarter-lines-line-q' + (index + 1)]
    })
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-contain-main-tab"
  }, [_c('div', {
    staticClass: "main-blocks"
  }, [_c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "main-block-contain"
  }, [_c('div', {
    staticClass: "main-block-contain-title"
  }, [_vm._v("预算使用进度"), _c('common-tooltip', {
    attrs: {
      "tipCode": ('1.' + _vm.tabTipCode)
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-budget",
    staticStyle: {
      "font-size": "0.1rem"
    }
  }, [_c('label', {
    staticClass: "main-block-contain-budget-amount"
  }, [_vm._v("￥" + _vm._s(_vm.mainData['预算使用进度'].totalAmountStr))]), _vm._v(" "), _c('label', {
    class: ['main-block-contain-budget-percent', _vm.mainData['预算使用进度'].ratioNum > 120 ? 'main-block-contain-budget-percent-alert' : '', _vm.mainRole == '会议组织者' ? 'invisible' : '']
  }, [_vm._v(_vm._s(_vm.mainData['预算使用进度'].ratio))]), _vm._v(" "), _c('label', {
    staticClass: "main-block-contain-budget-percent-title",
    class: _vm.mainRole == '会议组织者' ? 'invisible' : ''
  }, [_vm._v("占比")])]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-split-line",
    class: _vm.mainRole == '会议组织者' ? 'invisible' : ''
  }, [_c('div', {
    staticClass: "progress",
    style: ('width:' + (_vm.mainData['预算使用进度'].ratioNum > 100 ? '100%' : _vm.mainData['预算使用进度'].ratio))
  })]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-info"
  }, [_c('span', {
    staticClass: "main-block-contain-season-amount"
  }, [_vm._v(_vm._s(_vm.budgetAmount)), _c('label', [_vm._v(_vm._s(_vm.mainData['预算使用进度'].qbudgetAmountStr))])]), _vm._v(" "), _c('span', {
    staticClass: "main-block-contain-total"
  }, [_vm._v("数量"), _c('label', [_vm._v(_vm._s(_vm.mainData['预算使用进度'].count))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "main-block-contain"
  }, [_c('div', {
    staticClass: "main-block-contain-title"
  }, [_vm._v(_vm._s(_vm.mainData['4'].statusName)), _c('common-tooltip', {
    attrs: {
      "tipCode": '2.' + _vm.tabTipCode
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-budget"
  }, [_c('label', {
    staticClass: "main-block-contain-budget-amount"
  }, [_vm._v("￥" + _vm._s(_vm.mainData['4'].totalAmountStr))]), _vm._v(" "), _c('label', {
    staticClass: "main-block-contain-budget-percent",
    class: _vm.mainRole == '会议组织者' ? 'invisible' : ''
  }, [_vm._v(_vm._s(_vm.mainData['4'].ratio))]), _vm._v(" "), _c('label', {
    staticClass: "main-block-contain-budget-percent-title",
    class: _vm.mainRole == '会议组织者' ? 'invisible' : ''
  }, [_vm._v("占比")])]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-split-line",
    class: _vm.mainRole == '会议组织者' ? 'invisible' : ''
  }, [_c('div', {
    staticClass: "pass",
    style: ('width:' + (_vm.mainData['4'].ratioNum > 100 ? '100%' : _vm.mainData['4'].ratio))
  })]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-info"
  }, [_c('span', {
    staticClass: "main-block-contain-season-amount"
  }, [_vm._v(_vm._s(_vm.budgetAmount)), _c('label', [_vm._v(_vm._s(_vm.mainData['4'].qbudgetAmountStr))])]), _vm._v(" "), _c('span', {
    staticClass: "main-block-contain-total"
  }, [_vm._v("数量"), _c('label', [_vm._v(_vm._s(_vm.mainData['4'].count))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "main-block-contain"
  }, [_c('div', {
    staticClass: "main-block-contain-title"
  }, [_vm._v(_vm._s(_vm.mainData['3'].statusName)), _c('common-tooltip', {
    attrs: {
      "tipCode": '3.' + _vm.tabTipCode
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-budget"
  }, [_c('label', {
    staticClass: "main-block-contain-budget-amount"
  }, [_vm._v("￥" + _vm._s(_vm.mainData['3'].totalAmountStr))]), _vm._v(" "), _c('label', {
    staticClass: "main-block-contain-budget-percent",
    class: _vm.mainRole == '会议组织者' ? 'invisible' : ''
  }, [_vm._v(_vm._s(_vm.mainData['3'].ratio))]), _vm._v(" "), _c('label', {
    staticClass: "main-block-contain-budget-percent-title",
    class: _vm.mainRole == '会议组织者' ? 'invisible' : ''
  }, [_vm._v("占比")])]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-split-line",
    class: _vm.mainRole == '会议组织者' ? 'invisible' : ''
  }, [_c('div', {
    staticClass: "pending",
    style: ('width:' + (_vm.mainData['3'].ratioNum > 100 ? '100%' : _vm.mainData['3'].ratio))
  })]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-info"
  }, [_c('span', {
    staticClass: "main-block-contain-season-amount"
  }, [_vm._v(_vm._s(_vm.budgetAmount)), _c('label', [_vm._v(_vm._s(_vm.mainData['3'].qbudgetAmountStr))])]), _vm._v(" "), _c('span', {
    staticClass: "main-block-contain-total"
  }, [_vm._v("数量"), _c('label', [_vm._v(_vm._s(_vm.mainData['3'].count))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "main-block-contain"
  }, [_c('div', {
    staticClass: "main-block-contain-title"
  }, [_vm._v(_vm._s(_vm.mainData['5'].statusName)), _c('common-tooltip', {
    attrs: {
      "tipCode": '4.' + _vm.tabTipCode
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-budget"
  }, [_c('label', {
    staticClass: "main-block-contain-budget-amount"
  }, [_vm._v("￥" + _vm._s(_vm.mainData['5'].totalAmountStr))]), _vm._v(" "), _c('label', {
    staticClass: "main-block-contain-budget-percent",
    class: _vm.mainRole == '会议组织者' ? 'invisible' : ''
  }, [_vm._v(_vm._s(_vm.mainData['5'].ratio))]), _vm._v(" "), _c('label', {
    staticClass: "main-block-contain-budget-percent-title",
    class: _vm.mainRole == '会议组织者' ? 'invisible' : ''
  }, [_vm._v("占比")])]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-split-line",
    class: _vm.mainRole == '会议组织者' ? 'invisible' : ''
  }, [_c('div', {
    staticClass: "reject",
    style: ('width:' + (_vm.mainData['5'].ratioNum > 100 ? '100%' : _vm.mainData['5'].ratio))
  })]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-info"
  }, [_c('span', {
    staticClass: "main-block-contain-season-amount"
  }, [_vm._v(_vm._s(_vm.budgetAmount)), _c('label', [_vm._v(_vm._s(_vm.mainData['5'].qbudgetAmountStr))])]), _vm._v(" "), _c('span', {
    staticClass: "main-block-contain-total"
  }, [_vm._v("数量"), _c('label', [_vm._v(_vm._s(_vm.mainData['5'].count))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "search-content"
  }, [_c('el-form', {
    staticClass: "search-content-fields",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "计划状态"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.searchData.status),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "status", $$v)
      },
      expression: "searchData.status"
    }
  }, _vm._l((_vm.baseDataRecords.MyLibraryStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Franchise/DA"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalField", $$v)
      },
      expression: "searchData.medicalField"
    }
  }, _vm._l((_vm.getMedicalFieldArray(_vm.searchData.departId, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "团队"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "teamL4", $$v)
      },
      expression: "searchData.teamL4"
    }
  }, _vm._l((_vm.getTeamArray(_vm.searchData.departId, _vm.searchData.medicalField, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "search-content-fields-operate"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleAdvancedSearchClick()
      }
    }
  }, [_vm._v("高级查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleResetSearchCondition()
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbar"
  }, [_c('div', {
    staticClass: "application-detail-info"
  }, [_vm._v("共计 " + _vm._s(_vm.applicationDetailCount) + " 场 预算总额：" + _vm._s(_vm._f("MoneyFormat")(_vm.applicationDetailAmt)))]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', {
    staticClass: "operate-export"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.handlerExportExcelClick
    }
  }, [_c('i', {
    staticClass: "iconfont icon-daochu"
  }), _vm._v(" "), _c('span', [_vm._v("导出")])])])])]), _vm._v(" "), _c('common-crud', {
    ref: "crud",
    attrs: {
      "searchData": _vm.searchData,
      "searchDataLikeField": {
        'productId': '*',
        'companyStrategy': '*',
        'strategyKeynote': '*',
        'medicalFieldResult': '*',
        'hospitalLevelId': '*',
        'speakerLevelId': '*'
      },
      "crudApi": _vm.crudApi,
      "tableData": _vm.applicationDetailData,
      "showEditFormTitle": false,
      "editDialogClass": "biz-application-detail-edit-dialog",
      "handleSearchResult": _vm.handleSearchResult,
      "selectedDataArray": _vm.selectedData
    },
    on: {
      "update:tableData": function($event) {
        _vm.applicationDetailData = $event
      },
      "update:table-data": function($event) {
        _vm.applicationDetailData = $event
      },
      "update:selectedDataArray": function($event) {
        _vm.selectedData = $event
      },
      "update:selected-data-array": function($event) {
        _vm.selectedData = $event
      }
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "width": "60",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingName",
      "label": "会议名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "teamL4",
      "label": "团队",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "productId",
      "label": "产品",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "meetingSystem",
      "label": "系统选择",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "meetingProp",
      "label": "会议性质",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "meetingType",
      "label": "A1会议类型",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "meetingGsdType",
      "label": "GSD项目类型",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingGsdType",
      "label": "GSD细类",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("                    \n                      " + _vm._s(_vm.basedataGetName('MeetingGsdTypeSub' + scope.row.meetingGsdType, scope.row.meetingGsdSubType)) + "\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "totalAmount",
      "label": "会议总预算",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("                    \n                      " + _vm._s(_vm._f("MoneyFormat")(scope.row.totalAmount)) + "\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "modelScore",
      "width": "140"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("模型评分"), _c('common-tooltip', {
    attrs: {
      "tipCode": "7"
    }
  })], 1)]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatDateTime2Date,
      "sortable": "",
      "prop": "meetingBeginDate",
      "label": "开始日期",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "cityName",
      "label": "城市"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingWebStatus",
      "label": "会议计划状态",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingCurrentOptName",
      "label": "会议计划审批结点",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "aoneExeStatus",
      "label": "会议执行状态",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "userRealName",
      "label": "会议组织者",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "meetingCode",
      "label": "计划编号",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "eventId",
      "label": "A1会议编号",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "createTime",
      "label": "创建时间",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v("                    \n                      " + _vm._s(_vm._f("DateHourMinutesFormat")(scope.row.createTime)) + "\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-column-operate"
        }, [_c('div', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleViewClick(scope.row)
            }
          }
        }, [_vm._v("\n                      查看\n                    ")])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "confirmDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("确认删除会议？")])])])], 2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-info"
  }, [_c('div', {
    staticClass: "bottom-info-info"
  }, [_vm._v("已选择 " + _vm._s(_vm.selectedData.length) + " 场会议 预算总额："), _c('label', [_vm._v(_vm._s(_vm._f("MoneyFormat")(_vm.selectedTotalAmount)))])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-info-operate"
  })]), _vm._v(" "), _c('div', [_c('el-dialog', {
    staticClass: "advanced-search-dialog",
    attrs: {
      "center": "",
      "visible": _vm.advancedSearchVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.advancedSearchVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "advancedSearchForm",
    attrs: {
      "model": _vm.searchData,
      "label-position": "right",
      "label-width": "100px"
    }
  }, [_c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-huiyizhuangtai'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("会议状态")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "计划状态",
      "prop": "status"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.status),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "status", $$v)
      },
      expression: "searchData.status"
    }
  }, _vm._l((_vm.baseDataRecords.MyLibraryStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议执行状态",
      "prop": "aoneExeStatus"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.aoneExeStatus),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "aoneExeStatus", $$v)
      },
      expression: "searchData.aoneExeStatus"
    }
  }, _vm._l((_vm.baseDataRecords.AoneExeStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-jibinglingyu'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("疾病领域")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "部门",
      "prop": "departId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.medicalField = '';
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.departId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "departId", $$v)
      },
      expression: "searchData.departId"
    }
  }, _vm._l((_vm.baseDataRecords.Depart), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "Franchise/DA",
      "prop": "medicalField"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalField", $$v)
      },
      expression: "searchData.medicalField"
    }
  }, _vm._l((_vm.getMedicalFieldArray(_vm.searchData.departId, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "团队",
      "prop": "teamL4"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "teamL4", $$v)
      },
      expression: "searchData.teamL4"
    }
  }, _vm._l((_vm.getTeamArray(_vm.searchData.departId, _vm.searchData.medicalField, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "治疗领域",
      "prop": "treatmentArea"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.treatmentArea),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "treatmentArea", $$v)
      },
      expression: "searchData.treatmentArea"
    }
  }, _vm._l((_vm.baseDataRecords.TreatmentArea), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.treatmentAreaName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "疾病领域",
      "prop": "diseaseArea"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.diseaseArea),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "diseaseArea", $$v)
      },
      expression: "searchData.diseaseArea"
    }
  }, _vm._l((_vm.baseDataRecords.DiseaseArea), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.diseaseAreaName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "产品",
      "prop": "productId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.productId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "productId", $$v)
      },
      expression: "searchData.productId"
    }
  }, _vm._l((_vm.baseDataRecords.Product), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.productName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-chanpincelve'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("产品策略")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "公司战略",
      "prop": "companyStrategy"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.companyStrategy),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "companyStrategy", $$v)
      },
      expression: "searchData.companyStrategy"
    }
  }, _vm._l((_vm.baseDataRecords.CompanyStrategy), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "策略重点",
      "prop": "strategyKeynote"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.strategyKeynote),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "strategyKeynote", $$v)
      },
      expression: "searchData.strategyKeynote"
    }
  }, _vm._l((_vm.baseDataRecords.Strategy), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.keynote
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "业务结果",
      "prop": "medicalFieldResult"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.medicalFieldResult),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalFieldResult", $$v)
      },
      expression: "searchData.medicalFieldResult"
    }
  }, _vm._l((_vm.baseDataRecords.DomainResult), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.treatAreaResult
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-fugaiziyuan'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("覆盖资源")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "医院层级",
      "prop": "hospitalLevelId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.hospitalLevelId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "hospitalLevelId", $$v)
      },
      expression: "searchData.hospitalLevelId"
    }
  }, _vm._l((_vm.baseDataRecords.HospitalLevel), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.hospitalLevel
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "科室",
      "prop": "offices"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.offices),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "offices", $$v)
      },
      expression: "searchData.offices"
    }
  }, _vm._l((_vm.baseDataRecords.Office), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.officeName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "讲者级别",
      "prop": "speakerLevelId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.speakerLevelId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "speakerLevelId", $$v)
      },
      expression: "searchData.speakerLevelId"
    }
  }, _vm._l((_vm.baseDataRecords.SpeakerLevel), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.speakerLevel
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-pingfenjieguo'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("评分结果")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "模型评分"
    }
  }, [_c('div', {
    staticClass: "advanced-search-dialog-score-model"
  }, [_c('el-input-number', {
    attrs: {
      "placeholder": "最小评分",
      "controls": false,
      "precision": 0,
      "min": 1,
      "max": 100
    },
    model: {
      value: (_vm.searchData.minModelScore),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "minModelScore", $$v)
      },
      expression: "searchData.minModelScore"
    }
  }), _vm._v(" "), _c('span'), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "placeholder": "最大评分",
      "controls": false,
      "precision": 0,
      "min": 1,
      "max": 100
    },
    model: {
      value: (_vm.searchData.maxModelScore),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "maxModelScore", $$v)
      },
      expression: "searchData.maxModelScore"
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-huiyixinxi'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("会议信息")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "系统选择",
      "prop": "meetingSystem"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingSystem),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingSystem", $$v)
      },
      expression: "searchData.meetingSystem"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingSystem), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议性质",
      "prop": "meetingProp"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingProp),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingProp", $$v)
      },
      expression: "searchData.meetingProp"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingProp), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "是否网络会",
      "prop": "meetingModality"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingModality),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingModality", $$v)
      },
      expression: "searchData.meetingModality"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingModality), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "A1会议类型",
      "prop": "meetingType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingType),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingType", $$v)
      },
      expression: "searchData.meetingType"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "GSD项目类型",
      "prop": "meetingGsdType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.meetingGsdSubType = ''
      }
    },
    model: {
      value: (_vm.searchData.meetingGsdType),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingGsdType", $$v)
      },
      expression: "searchData.meetingGsdType"
    }
  }, _vm._l((_vm.baseDataRecords.MeetingGsdType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "GSD细类",
      "prop": "meetingGsdSubType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.meetingGsdSubType),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingGsdSubType", $$v)
      },
      expression: "searchData.meetingGsdSubType"
    }
  }, _vm._l((_vm.MeetingGsdSubTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议名称",
      "prop": "meetingName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.searchData.meetingName),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingName", $$v)
      },
      expression: "searchData.meetingName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "计划编号",
      "prop": "meetingCode"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleMeetingCodeFilter,
      "clearable": "",
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        _vm.remoteMeetingCodeData = []
      }
    },
    model: {
      value: (_vm.searchData.meetingCode),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingCode", $$v)
      },
      expression: "searchData.meetingCode"
    }
  }, _vm._l((_vm.remoteMeetingCodeData), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item,
        "label": item
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "A1编号",
      "prop": "eventId"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.searchData.eventId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "eventId", $$v)
      },
      expression: "searchData.eventId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议组织者",
      "prop": "userRealName"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleMeetingCreatorFilter,
      "clearable": "",
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        _vm.remoteMeetingCreatorData = []
      }
    },
    model: {
      value: (_vm.searchData.userRealName),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "userRealName", $$v)
      },
      expression: "searchData.userRealName"
    }
  }, _vm._l((_vm.remoteMeetingCreatorData), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.CName,
        "label": item.CName + ' ' + item.AD
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "会议申请人",
      "prop": "meetingOrganizerId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleMeetingOrganizerFilter,
      "clearable": "",
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        _vm.remoteMeetingOrganizerData = []
      }
    },
    model: {
      value: (_vm.searchData.meetingOrganizerId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "meetingOrganizerId", $$v)
      },
      expression: "searchData.meetingOrganizerId"
    }
  }, _vm._l((_vm.remoteMeetingOrganizerData), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "value": item.Id,
        "label": item.CName + ' ' + item.AD
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "成本中心",
      "prop": "costCenter"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    on: {
      "change": _vm.handleSearchCostCenterChange
    },
    model: {
      value: (_vm.searchData.costCenter),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "costCenter", $$v)
      },
      expression: "searchData.costCenter"
    }
  }, _vm._l((_vm.costCenterArray), function(item) {
    return _c('el-option', {
      key: item.costId,
      attrs: {
        "value": item.costId,
        "label": item.costId
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "WBS code",
      "prop": "wbsCode"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.wbsCode),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "wbsCode", $$v)
      },
      expression: "searchData.wbsCode"
    }
  }, _vm._l((_vm.wbsCodeArray), function(item) {
    return _c('el-option', {
      key: item.costId,
      attrs: {
        "value": item.costId,
        "label": item.costId
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }, [_c('i', {
    staticClass: "l-user-item-icon",
    class: 'iconfont icon-shijian'
  }), _vm._v(" "), _c('span', {
    staticClass: "l-user-item-text"
  }, [_vm._v("时间地点")])]), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "起止日期",
      "prop": "dateRange"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.searchData.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "dateRange", $$v)
      },
      expression: "searchData.dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "省份",
      "prop": "province"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleProvinceChange
    },
    model: {
      value: (_vm.searchData.province),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "province", $$v)
      },
      expression: "searchData.province"
    }
  }, _vm._l((_vm.baseDataRecords.Province), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "城市",
      "prop": "city"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请先选择省份"
    },
    model: {
      value: (_vm.searchData.city),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "city", $$v)
      },
      expression: "searchData.city"
    }
  }, _vm._l((_vm.citiesData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "advanced-search-form-title"
  }), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "创建日期",
      "prop": "createDateRange"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.searchData.createDateRange),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "createDateRange", $$v)
      },
      expression: "searchData.createDateRange"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("高级查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleResetSearchCondition()
      }
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('label', {
    staticClass: "advanced-search-dialog-close",
    on: {
      "click": function($event) {
        _vm.advancedSearchVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('approval-dialog', {
    attrs: {
      "dialogVisiable": _vm.approvalDailogVisible,
      "confirm": _vm.handleApprovalConfirm,
      "reject": _vm.handleApprovalReject,
      "type": _vm.approvalType
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.approvalDailogVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.approvalDailogVisible = $event
      }
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-79d0c4be", module.exports)
  }
}

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-echarts"
  }, [_c('div', {
    ref: "myChart",
    class: _vm.chartClass
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7c3e3aee", module.exports)
  }
}

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "e2e-upload-container"
  }, [_c('div', {
    staticClass: "label-box"
  }, [(_vm.label) ? _c('div', {
    staticClass: "label-item"
  }, [_c('span', {
    staticClass: "label-text"
  }, [_vm._v(_vm._s(_vm.label || ' '))])]) : _vm._e(), _vm._v(" "), (
    !_vm.disabled &&
    _vm.localFileList.length !== 0 &&
    _vm.localFileList.length < _vm.limit
  ) ? _c('SingleUpload', {
    staticClass: "upload-item",
    attrs: {
      "action": _vm.action,
      "multiple": false,
      "accept": _vm.accept,
      "maxFileSize": _vm.maxFileSize,
      "disabled": _vm.disabled || _vm.fileList.length == 0,
      "autoUpload": _vm.autoUpload,
      "params": _vm.params,
      "change": _vm.onChange,
      "success": _vm.onSuccess,
      "error": _vm.onError,
      "beforeUpload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "gsk-icon-clip",
    staticStyle: {
      "font-size": "16px",
      "color": "#000"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "btn-add-text"
  }, [_vm._v(_vm._s(_vm.$t('btn.add')))])]) : _vm._e()], 1), _vm._v(" "), (_vm.subLabel) ? _c('div', {
    staticClass: "label-item",
    staticStyle: {
      "font-size": "12px",
      "white-space": "normal",
      "color": "#666",
      "margin-bottom": "10px"
    }
  }, [_c('span', {
    staticClass: "label-text"
  }, [_vm._v(_vm._s(_vm.subLabel || ' '))])]) : _vm._e(), _vm._v(" "), (_vm.localFileList.length != 0) ? _c('div', {
    staticClass: "file-box"
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckFile
    },
    model: {
      value: (_vm.checkedFilesList),
      callback: function($$v) {
        _vm.checkedFilesList = $$v
      },
      expression: "checkedFilesList"
    }
  }, [_vm._l((_vm.forEachFileList), function(lineFileList, lineIndex) {
    return [_c('div', {
      key: lineIndex,
      staticClass: "line-file-box"
    }, [_vm._l((lineFileList), function(file, fileIndex) {
      return [(_vm.select) ? _c('el-checkbox', {
        key: fileIndex,
        class: {
          'empty-file-item': !(file.name || file.fileName)
        },
        attrs: {
          "label": typeof file.id == 'object' ? file.id.id : file.id,
          "disabled": file.disableCheck
        }
      }) : _vm._e(), _vm._v(" "), (!(file.name || file.fileName) && _vm.select) ? _c('div', {
        key: fileIndex,
        staticStyle: {
          "width": "24px"
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        key: fileIndex,
        staticClass: "file-item",
        class: {
          'empty-file-item': !(file.name || file.fileName)
        }
      }, [(file.fileName || file.name) ? [_c('div', {
        staticClass: "file-type-box"
      }, [_c('i', {
        class: _vm.icon || _vm.getIconByFileName(file),
        style: (_vm.preview ?
          'font-size: 40px;cursor: pointer;' :
          'font-size: 40px;'),
        on: {
          "click": function($event) {
            _vm.preview ? _vm.previewFile(file) : function () {}
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "file-action-box"
      }, [_c('div', {
        staticClass: "line",
        staticStyle: {
          "display": "flex",
          "justify-content": "space-between"
        }
      }, [_c('span', {
        staticClass: "line-file-name",
        attrs: {
          "title": file.name || file.fileName
        },
        on: {
          "click": function($event) {
            _vm.preview ? _vm.previewFile(file) : function () {}
          }
        }
      }, [_vm._v(_vm._s(file.name || file.fileName))]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!_vm.disabledDelete && _vm.allowDelete(file)),
          expression: "!disabledDelete && allowDelete(file)"
        }],
        staticClass: "line-file-delete",
        on: {
          "click": function($event) {
            return _vm.delFile(file)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('btn.delete')))])]), _vm._v(" "), _c('div', {
        staticClass: "line",
        staticStyle: {
          "display": "flex",
          "justify-content": "space-between"
        }
      }, [_c('div', {
        staticStyle: {
          "display": "flex",
          "justify-content": "space-between"
        }
      }, [_c('span', [_vm._v(_vm._s(_vm._f("FileSizeFormat")((file.size || file.fileSize))))]), _vm._v(" "), (_vm.showDate) ? _c('span', {
        staticStyle: {
          "margin-left": "5px"
        },
        domProps: {
          "textContent": _vm._s(_vm.showDatePage(file))
        }
      }) : _vm._e()]), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "flex",
          "justify-content": "space-between"
        }
      }, [(_vm.preview) ? _c('span', {
        staticClass: "line-file-preview",
        on: {
          "click": function($event) {
            return _vm.previewFile(file)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('btn.preview')))]) : _vm._e(), _vm._v(" "), (_vm.download) ? _c('span', {
        staticClass: "line-file-download",
        on: {
          "click": function($event) {
            return _vm.downloadFile(file)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('btn.download')))]) : _vm._e()])])])] : _vm._e()], 2)]
    })], 2)]
  })], 2)], 1) : _c('div', {
    staticClass: "empty-box"
  }, [_c('NoDataFound', [_c('div', {
    staticClass: "empty-upload",
    staticStyle: {
      "font-size": "14px",
      "color": "#999",
      "text-align": "center"
    }
  }, [(!_vm.disabled) ? _c('SingleUpload', {
    attrs: {
      "action": _vm.action,
      "multiple": false,
      "accept": _vm.accept,
      "maxFileSize": _vm.maxFileSize,
      "disabled": _vm.disabled,
      "autoUpload": _vm.autoUpload,
      "params": _vm.params,
      "change": _vm.onChange,
      "success": _vm.onSuccess,
      "error": _vm.onError,
      "beforeUpload": _vm.beforeUpload
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$languageChoose({
    en: 'Only support ' +
      (_vm.forEachAccept || 'files') +
      ' within ' +
      _vm.maxFileSize +
      'M,',
    zh: '仅支持' + _vm.maxFileSize + 'M内的' + _vm.forEachAccept + '文件，'
  })))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#f36633"
    }
  }, [_vm._v(_vm._s(_vm.$t('btn.add')))])]) : _vm._e()], 1)])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7db47407", module.exports)
  }
}

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-submenu"
  }, [_c('div', {
    staticClass: "page-submenu_left"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('left-bar', {
    attrs: {
      "tab": "3"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-submenu_right"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "search-content"
  }, [_c('div', {
    staticClass: "search-content-fields"
  }, [_c('el-form', {
    attrs: {
      "inline": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "角色名称："
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.searchData.roleName),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "roleName", $$v)
      },
      expression: "searchData.roleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "disabled": _vm.selectedData.length <= 0,
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleBatchDeleteClick()
      }
    }
  }, [_vm._v("批量删除")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddNewClick()
      }
    }
  }, [_vm._v("添加")])], 1)], 1)], 1)]), _vm._v(" "), _c('common-crud', {
    ref: "crud",
    attrs: {
      "searchData": _vm.searchData,
      "tableData": _vm.roleData,
      "addNewOrEditData": _vm.addNewOrEditData,
      "crudApi": _vm.crudApi,
      "showEditFormTitle": false,
      "beforeSave": _vm.beforeSave,
      "selectedDataArray": _vm.selectedData,
      "addSuccessMessages": "添加角色成功",
      "editSuccessMessages": "编辑角色成功",
      "deleteSuccessMessages": "删除角色成功",
      "deleteBatchSuccessMessages": "批量删除角色成功"
    },
    on: {
      "update:tableData": function($event) {
        _vm.roleData = $event
      },
      "update:table-data": function($event) {
        _vm.roleData = $event
      },
      "update:selectedDataArray": function($event) {
        _vm.selectedData = $event
      },
      "update:selected-data-array": function($event) {
        _vm.selectedData = $event
      }
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "roleCode",
      "label": "角色编码"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "roleName",
      "label": "角色名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatDateTime2Date,
      "sortable": "",
      "prop": "updateTime",
      "label": "操作时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "updateBy",
      "label": "操作人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-column-operate"
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditClick(scope.row)
            }
          }
        }, [_vm._v("\n                    编辑\n                  ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleRolePrivilegeClick(scope.row)
            }
          }
        }, [_vm._v("\n                    授权\n                  ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteClick(scope.row)
            }
          }
        }, [_vm._v("\n                    删除\n                  ")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "customTitle"
  }, [_vm._v("角色信息")]), _vm._v(" "), _c('template', {
    slot: "editForm"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "角色名称",
      "prop": "roleName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.addNewOrEditData.roleName),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "roleName", $$v)
      },
      expression: "addNewOrEditData.roleName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "角色编码",
      "prop": "roleCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.addNewOrEditData.roleCode),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "roleCode", $$v)
      },
      expression: "addNewOrEditData.roleCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "col-full"
  }, [_c('el-form-item', {
    attrs: {
      "label": "描述",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入（建议75个字符以内）"
    },
    model: {
      value: (_vm.addNewOrEditData.description),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "description", $$v)
      },
      expression: "addNewOrEditData.description"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('template', {
    slot: "confirmAddNewMessage"
  }, [_c('div', [_c('span', [_vm._v("确认添加？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmEditMessage"
  }, [_c('div', [_c('span', [_vm._v("确认保存？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("删除角色？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmBatchDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("批量删除角色？")])])])], 2)], 1)])]), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": '角色权限配置-' + _vm.roleName,
      "visible": _vm.rolePrivilegeDrawer,
      "direction": "rtl",
      "size": "900px"
    },
    on: {
      "update:visible": function($event) {
        _vm.rolePrivilegeDrawer = $event
      }
    }
  }, [_c('role-privilege', {
    ref: "rolePrivilege",
    attrs: {
      "afterSave": _vm.handleAfterSavePrivilege,
      "roleId": _vm.roleId
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7f1a157a", module.exports)
  }
}

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sysmanagement-privilege"
  }, [_c('div', {
    staticClass: "page-submenu"
  }, [_c('div', {
    staticClass: "page-submenu_left"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('left-bar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-submenu_right"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "search-content"
  }, [_c('div', {
    staticClass: "search-content-fields"
  }, [_c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "员工ID"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入员工ID"
    },
    model: {
      value: (_vm.searchData.username),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "username", $$v)
      },
      expression: "searchData.username"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.searchData.realname),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "realname", $$v)
      },
      expression: "searchData.realname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.departIds),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "departIds", $$v)
      },
      expression: "searchData.departIds"
    }
  }, _vm._l((_vm.baseDataRecords.Depart), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所在治疗领域（franchise）"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalField", $$v)
      },
      expression: "searchData.medicalField"
    }
  }, _vm._l((_vm.baseDataRecords.MedicalField), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handlerExportExcelClick()
      }
    }
  }, [_vm._v("批量导出")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleAddNewClick()
      }
    }
  }, [_vm._v("新增用户")])], 1)]), _vm._v(" "), _c('common-crud', {
    ref: "crud",
    attrs: {
      "addNewOrEditData": _vm.addNewOrEditData,
      "searchData": _vm.searchData,
      "searchDataLikeField": {
        'username': '*',
        'realname': '*',
        'roleIds': '*',
        'departIds': '*'
      },
      "crudApi": _vm.crudApi,
      "tableData": _vm.privilegeData,
      "showEditFormTitle": false,
      "beforeSave": _vm.beforeSave,
      "editDialogClass": "sys-privilege-edit-dialog",
      "selectedDataArray": _vm.selectedData,
      "addSuccessMessages": "新增用户成功",
      "editSuccessMessages": "编辑用户成功",
      "deleteSuccessMessages": "删除用户成功"
    },
    on: {
      "update:tableData": function($event) {
        _vm.privilegeData = $event
      },
      "update:table-data": function($event) {
        _vm.privilegeData = $event
      },
      "update:selectedDataArray": function($event) {
        _vm.selectedData = $event
      },
      "update:selected-data-array": function($event) {
        _vm.selectedData = $event
      }
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "width": "60",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "username",
      "label": "员工ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "realname",
      "label": "姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "departIds",
      "label": "部门"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "medicalField",
      "width": "135"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('div', [_vm._v("所在治疗领域")]), _vm._v(" "), _c('div', [_vm._v("（franchise）")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-column-operate"
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditClick(scope.row)
            }
          }
        }, [_vm._v("\n                    编辑\n                  ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteClick(scope.row)
            }
          }
        }, [_vm._v("\n                    删除\n                  ")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "customTitle"
  }, [_vm._v(_vm._s(_vm.actionType == 'add' ? '新增用户' : '用户信息'))]), _vm._v(" "), _c('template', {
    slot: "editForm"
  }, [(_vm.actionType == 'add') ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "搜索AD账号"
    },
    model: {
      value: (_vm.adSearchText),
      callback: function($$v) {
        _vm.adSearchText = $$v
      },
      expression: "adSearchText"
    }
  }, [_c('el-button', {
    staticClass: "ad-search",
    attrs: {
      "slot": "append"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearchAD()
      }
    },
    slot: "append"
  }, [_vm._v("搜索")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "员工ID",
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "placeholder": "搜索AD账号系统自动查询"
    },
    model: {
      value: (_vm.addNewOrEditData.username),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "username", $$v)
      },
      expression: "addNewOrEditData.username"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "realname"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "placeholder": "搜索AD账号系统自动查询"
    },
    model: {
      value: (_vm.addNewOrEditData.realname),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "realname", $$v)
      },
      expression: "addNewOrEditData.realname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "部门",
      "prop": "departIds"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "multiple": "",
      "placeholder": "搜索AD账号系统自动查询"
    },
    model: {
      value: (_vm.addNewOrEditData.departIds),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "departIds", $$v)
      },
      expression: "addNewOrEditData.departIds"
    }
  }, _vm._l((_vm.baseDataRecords.Depart), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "所在治疗领域（franchise）",
      "prop": "medicalField"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "multiple": "",
      "placeholder": "搜索AD账号系统自动查询"
    },
    model: {
      value: (_vm.addNewOrEditData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "medicalField", $$v)
      },
      expression: "addNewOrEditData.medicalField"
    }
  }, _vm._l((_vm.baseDataRecords.MedicalField), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "prop": "allowDepartIds"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("允许查看部门数据"), _c('common-tooltip', {
    attrs: {
      "tipCode": "13"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "请选择（可多选）"
    },
    model: {
      value: (_vm.addNewOrEditData.allowDepartIds),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "allowDepartIds", $$v)
      },
      expression: "addNewOrEditData.allowDepartIds"
    }
  }, _vm._l((_vm.allowDeparts), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "confirmAddNewMessage"
  }, [_c('div', [_c('span', [_vm._v("确认添加该用户？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmEditMessage"
  }, [_c('div', [_c('span', [_vm._v("确认保存该用户？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("删除该用户？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmBatchDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("批量删除用户？")])])])], 2)], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-81adb67a", module.exports)
  }
}

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-container"
  }, _vm._l((_vm.options), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "l-user-item iconfont",
      class: {
        selected: item.name == _vm.tab
      },
      on: {
        "click": function($event) {
          return _vm.handleTabClick(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "l-user-item-icon",
      class: item.icon
    }), _vm._v(" "), _c('span', {
      staticClass: "l-user-item-text"
    }, [_vm._v(_vm._s(item.text))])])
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-88141bec", module.exports)
  }
}

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-container"
  }, _vm._l((_vm.options), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isShow(item)),
        expression: "isShow(item)"
      }],
      key: index,
      staticClass: "l-user-item",
      class: {
        selected: _vm.isActiveSubMenu(item)
      },
      on: {
        "click": function($event) {
          return _vm.handleTabClick(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont l-user-item-icon",
      class: item.icon
    }), _vm._v(" "), _c('span', {
      staticClass: "l-user-item-text"
    }, [_vm._v(_vm._s(item.text))])])
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a103c38a", module.exports)
  }
}

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-submenu"
  }, [_c('div', {
    staticClass: "page-submenu_left"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('left-bar', {
    attrs: {
      "tab": "1"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-submenu_right"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-content-fields"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.contentData,
      "show-message": false
    }
  }, [_c('div', {
    staticClass: "el-form-item inline-items"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("\n                        活动负责人申请开放时间：\n                      ")]), _vm._v(" "), _c('div', {}, [_c('label', [_vm._v("每个季度第")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "applyMonth"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls": false,
      "controls-position": "right",
      "precision": 0,
      "min": 1,
      "max": 12,
      "disabled": !_vm.editVisible
    },
    model: {
      value: (_vm.contentData.applyMonth),
      callback: function($$v) {
        _vm.$set(_vm.contentData, "applyMonth", $$v)
      },
      expression: "contentData.applyMonth"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v("个月")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "applyDay"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls": false,
      "controls-position": "right",
      "precision": 0,
      "min": 1,
      "max": 31,
      "disabled": !_vm.editVisible
    },
    model: {
      value: (_vm.contentData.applyDay),
      callback: function($$v) {
        _vm.$set(_vm.contentData, "applyDay", $$v)
      },
      expression: "contentData.applyDay"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v("号0点。")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item inline-items"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("\n                        直线经理审批截止时间：\n                      ")]), _vm._v(" "), _c('div', {}, [_c('label', [_vm._v("每个季度第")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "approveManageMonth"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls": false,
      "controls-position": "right",
      "precision": 0,
      "min": 1,
      "max": 12,
      "disabled": !_vm.editVisible
    },
    model: {
      value: (_vm.contentData.approveManageMonth),
      callback: function($$v) {
        _vm.$set(_vm.contentData, "approveManageMonth", $$v)
      },
      expression: "contentData.approveManageMonth"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v("个月")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "approveManageDay"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls": false,
      "controls-position": "right",
      "precision": 0,
      "min": 1,
      "max": 31,
      "disabled": !_vm.editVisible
    },
    model: {
      value: (_vm.contentData.approveManageDay),
      callback: function($$v) {
        _vm.$set(_vm.contentData, "approveManageDay", $$v)
      },
      expression: "contentData.approveManageDay"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v("号24点。")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item inline-items"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("\n                        VP-1审批截止时间：\n                      ")]), _vm._v(" "), _c('div', {}, [_c('label', [_vm._v("每个季度第")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "approveVpMonth"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls": false,
      "controls-position": "right",
      "precision": 0,
      "min": 1,
      "max": 12,
      "disabled": !_vm.editVisible
    },
    model: {
      value: (_vm.contentData.approveVpMonth),
      callback: function($$v) {
        _vm.$set(_vm.contentData, "approveVpMonth", $$v)
      },
      expression: "contentData.approveVpMonth"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v("个月")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "approveVpDay"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls": false,
      "controls-position": "right",
      "precision": 0,
      "min": 1,
      "max": 31,
      "disabled": !_vm.editVisible
    },
    model: {
      value: (_vm.contentData.approveVpDay),
      callback: function($$v) {
        _vm.$set(_vm.contentData, "approveVpDay", $$v)
      },
      expression: "contentData.approveVpDay"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v("号24点。")])], 1)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editVisible),
      expression: "!editVisible"
    }],
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleEditClick()
      }
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editVisible),
      expression: "editVisible"
    }],
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleCancelEditClick()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editVisible),
      expression: "editVisible"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleEditConfirmClick()
      }
    }
  }, [_vm._v("确认")])], 1)])])])]), _vm._v(" "), _c('common-confirm', {
    attrs: {
      "dialogVisiable": _vm.confirmEditSaveVisible,
      "confirm": _vm.handlerEditSaveConfirmOK
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.confirmEditSaveVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.confirmEditSaveVisible = $event
      }
    }
  }, [_c('div', [_c('span', [_vm._v("确认更改季度申请开放周期？")])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a48d6594", module.exports)
  }
}

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-contain"
  }, [_c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "search-content"
  }, [_c('div', {
    staticClass: "search-content-fields"
  }, [_c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "业务结果"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.searchData.treatAreaResult),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "treatAreaResult", $$v)
      },
      expression: "searchData.treatAreaResult"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.medicalField = '';
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.departId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "departId", $$v)
      },
      expression: "searchData.departId"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.departsList : _vm.userInfo.loginDeparts)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Franchise/DA"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalField", $$v)
      },
      expression: "searchData.medicalField"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.medicalFieldList : _vm.getMedicalFieldArray(_vm.searchData.departId, true))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "团队"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "teamL4", $$v)
      },
      expression: "searchData.teamL4"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.teamList : _vm.getTeamArray(_vm.searchData.departId, _vm.searchData.medicalField, true))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "产品"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.productId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "productId", $$v)
      },
      expression: "searchData.productId"
    }
  }, _vm._l((_vm.baseDataRecords.Product), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.productName
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": '/static/file/busTreatResult.xlsx?t=' + new Date().getTime()
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    }
  }, [_vm._v("导出模板")])], 1), _vm._v(" "), _c('span', [_c('common-upload', {
    attrs: {
      "importApi": _vm.crudApi,
      "importType": "Excel",
      "onSuccess": _vm.handleUpdateSuccess
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    }
  }, [_vm._v("批量上传")])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handlerExportExcelClick()
      }
    }
  }, [_vm._v("批量导出")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.selectedData.length <= 0,
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleBatchDeleteClick()
      }
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddNewClick()
      }
    }
  }, [_vm._v("添加业务结果")])], 1)]), _vm._v(" "), _c('common-crud', {
    ref: "crud",
    attrs: {
      "addNewOrEditData": _vm.addNewOrEditData,
      "searchData": _vm.searchData,
      "searchDataLikeField": {
        'treatAreaResult': '*'
      },
      "crudApi": _vm.crudApi,
      "tableData": _vm.domainresultData,
      "showEditFormTitle": false,
      "beforeSave": _vm.beforeSave,
      "afterSave": _vm.handleDomainResultChange,
      "afterDelete": _vm.handleDomainResultChange,
      "selectedDataArray": _vm.selectedData,
      "addSuccessMessages": "添加业务结果成功",
      "editSuccessMessages": "编辑业务结果成功",
      "deleteSuccessMessages": "删除业务结果成功",
      "deleteBatchSuccessMessages": "批量删除业务结果成功"
    },
    on: {
      "update:tableData": function($event) {
        _vm.domainresultData = $event
      },
      "update:table-data": function($event) {
        _vm.domainresultData = $event
      },
      "update:selectedDataArray": function($event) {
        _vm.selectedData = $event
      },
      "update:selected-data-array": function($event) {
        _vm.selectedData = $event
      }
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "width": "60",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "departId",
      "label": "部门"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "medicalField",
      "width": "135"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('div', [_vm._v("Franchise/DA")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "teamL4",
      "label": "团队"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "productId",
      "label": "产品"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "treatAreaResult",
      "label": "业务结果"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatDateTime2Date,
      "sortable": "",
      "prop": "updateTime",
      "label": "更新时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "updateBy",
      "label": "操作人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-column-operate"
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditClick(scope.row)
            }
          }
        }, [_vm._v("\n                    编辑\n                  ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteClick(scope.row)
            }
          }
        }, [_vm._v("\n                    删除\n                  ")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "customTitle"
  }, [_vm._v("业务结果")]), _vm._v(" "), _c('template', {
    slot: "editForm"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "部门",
      "prop": "departId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.medicalField = '';
        _vm.addNewOrEditData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.addNewOrEditData.departId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "departId", $$v)
      },
      expression: "addNewOrEditData.departId"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.departsList : _vm.userInfo.loginDeparts)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "Franchise/DA",
      "prop": "medicalField"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.addNewOrEditData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "medicalField", $$v)
      },
      expression: "addNewOrEditData.medicalField"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.medicalFieldList : _vm.getMedicalFieldArray(_vm.addNewOrEditData.departId, false))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "团队",
      "prop": "teamL4"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "teamL4", $$v)
      },
      expression: "addNewOrEditData.teamL4"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.teamList : _vm.getTeamArray(_vm.addNewOrEditData.departId, _vm.addNewOrEditData.medicalField, false))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "产品",
      "prop": "productId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.addNewOrEditData.productId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "productId", $$v)
      },
      expression: "addNewOrEditData.productId"
    }
  }, _vm._l((_vm.baseDataRecords.Product), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.productName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "col-full"
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "业务结果",
      "prop": "treatAreaResult"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入业务结果（建议20个字符以内）"
    },
    model: {
      value: (_vm.addNewOrEditData.treatAreaResult),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "treatAreaResult", $$v)
      },
      expression: "addNewOrEditData.treatAreaResult"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('template', {
    slot: "confirmAddNewMessage"
  }, [_c('div', [_c('span', [_vm._v("确认添加业务结果？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmEditMessage"
  }, [_c('div', [_c('span', [_vm._v("确认保存业务结果？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("删除业务结果？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmBatchDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("批量删除业务结果？")])])])], 2)], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-acafa2c2", module.exports)
  }
}

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "amapviewer",
    attrs: {
      "visible": _vm.visible,
      "title": _vm.title,
      "close": _vm.handleClose,
      "width": "1200px"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('div', {
    staticClass: "e2e-amap-container-warpper"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "mapContainer",
    staticClass: "e2e-amap-container"
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('div', {
    staticClass: "search-item"
  }, [_c('el-input', {
    ref: "mapSearch",
    attrs: {
      "placeholder": _vm.$t('system.input.fill_prefix') + _vm.$t('component.mapbox.location'),
      "autofocus": true,
      "prefix-icon": "el-icon-search"
    },
    on: {
      "input": this.onSearchChange
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search-result-warpper"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingResult),
      expression: "loadingResult"
    }],
    staticClass: "search-result-container",
    style: ({
      'height': _vm.loadingResult ? '80px' : ''
    })
  }, _vm._l((_vm.pois), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "result-warpper",
      on: {
        "click": function($event) {
          return _vm.handleSearchResultClick(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "result-item"
    }, [_vm._v("\n                                " + _vm._s(item.name) + "\n                            ")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "address-container"
  }, [_c('el-input', {
    ref: "address",
    attrs: {
      "placeholder": "",
      "clearable": true,
      "disabled": true
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "btn-clear",
    on: {
      "click": _vm.clearAddress
    }
  }, [_vm._v(_vm._s(_vm.$t('btn.clear')))])])], 2)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "24px",
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "plain": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancle($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('btn.cancel')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "200px"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleConfirm($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('btn.confirm')))])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ad351d18", module.exports)
  }
}

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-e2e-not-found"
  }, [(_vm.type == 'image') ? [_c('div', {
    staticClass: "e2e-not-found-container"
  }, [_c('div', [(_vm.type == 'image') ? _c('img', {
    style: ('height: ' + _vm.height + ';'),
    attrs: {
      "src": _vm.imgTableSrc,
      "alt": "",
      "srcset": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "color": "#999"
    }
  }, [(_vm.$slots.default) ? _c('span', [_vm._t("default")], 2) : _c('span', [_vm._v(_vm._s(_vm.$t('system.no_data')))])])])] : _vm._e(), _vm._v(" "), (_vm.type == 'text') ? [_c('div', {
    staticClass: "e2e-not-found-container"
  }, [_vm._v(_vm._s(_vm.$t('system.no_data')))])] : _vm._e()], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ae5c7cfe", module.exports)
  }
}

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-editor"
  }, [_c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.innerValue
    }
  }), _vm._v(" "), (_vm.isUpdated) ? _c('Editor', {
    attrs: {
      "id": _vm.editorId,
      "init": _vm.init,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder
    },
    model: {
      value: (_vm.innerValue),
      callback: function($$v) {
        _vm.innerValue = $$v
      },
      expression: "innerValue"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b41f7a44", module.exports)
  }
}

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "library-view"
  }, [_c('div', {
    staticClass: "page-contain view-meeting-plan"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.addNewOrEditData,
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "会议名称"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.meetingName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": ""
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("系统选择"), _c('common-tooltip', {
    attrs: {
      "tipCode": "8"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingSystem', _vm.addNewOrEditData.meetingSystem)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "是否网络会议"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingModality', _vm.addNewOrEditData.meetingModality)))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "会议性质"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp)))])])], 1), _vm._v(" "), (_vm.meetingSystemType != 'GSD') ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "A1会议类型"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingType', _vm.addNewOrEditData.meetingType)))])])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.meetingSystemType != 'A1') ? _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "GSD项目类型"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingGsdType', _vm.addNewOrEditData.meetingGsdType)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "GSD细类"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingGsdTypeSub' + _vm.addNewOrEditData.meetingGsdType, _vm.addNewOrEditData.meetingGsdSubType)))])])], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "部门"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('Depart', _vm.addNewOrEditData.departId)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "Franchise/DA"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MedicalField', _vm.addNewOrEditData.medicalField)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "团队"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('Teams', _vm.addNewOrEditData.teamL4)))])])], 1)], 1), _vm._v(" "), _c('el-row', [(_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp) == '推广') ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "治疗领域"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('TreatmentArea', _vm.addNewOrEditData.treatmentArea)))])])], 1) : _vm._e(), _vm._v(" "), (_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp).indexOf('非推广') >= 0) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "疾病领域"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('DiseaseArea', _vm.addNewOrEditData.diseaseArea)))])])], 1) : _vm._e(), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "产品"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('Product', _vm.addNewOrEditData.productId)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "公司战略"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('CompanyStrategy', _vm.addNewOrEditData.companyStrategy)))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "策略重点"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.strategyKeynoteName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'A1' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'A1',
      "label": "治疗领域业务结果"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.medicalFieldResultName))])])], 1), _vm._v(" "), (_vm.addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') >= 0) ? _c('el-col', [_c('el-form-item', {
    staticClass: "not-required",
    attrs: {
      "label": "治疗领域业务结果（自定义描述）"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.medicalFieldResultDes))])])], 1) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "开始日期"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm._f("DateFormat")(_vm.addNewOrEditData.meetingBeginDate)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "结束日期"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm._f("DateFormat")(_vm.addNewOrEditData.meetingEndDate)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "会议时段"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingTimeInt', _vm.addNewOrEditData.meetingTimeInt)))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    class: (_vm.meetingSystemType != 'GSD') ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "国家"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.countryName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: (_vm.meetingSystemType != 'GSD') ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "省份"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.provinceName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: (_vm.meetingSystemType != 'GSD') ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "城市"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.cityName))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    class: (_vm.meetingSystemType != 'GSD' || _vm.basedataGetName('MeetingModality', _vm.addNewOrEditData.meetingModality).indexOf('线下') >= 0) ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD' && _vm.basedataGetName('MeetingModality', _vm.addNewOrEditData.meetingModality).indexOf('线下') >= 0,
      "label": "会议地点"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.meetingPlace))])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [(_vm.meetingSystemType != 'A1') ? _c('el-row', [_c('div', {
    staticClass: "col-full"
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "受赠方类型(GSD系统)"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.recipientSocietyOrHospital),
      callback: function($$v) {
        _vm.recipientSocietyOrHospital = $$v
      },
      expression: "recipientSocietyOrHospital"
    }
  }, [_c('el-radio', {
    staticClass: "tooltip-header-text",
    attrs: {
      "label": 1
    }
  }, [_vm._v("受赠学会"), _c('common-tooltip', {
    attrs: {
      "tipCode": "11"
    }
  })], 1), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("医院")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("大学")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("患者组织")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("其他")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.meetingSystemType != 'A1' && _vm.recipientSocietyOrHospital) ? _c('el-row', {
    staticClass: "recipientSociety-input"
  }, [_c('el-col', [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.recipientSocietyStr || _vm.addNewOrEditData.universityStr || _vm.addNewOrEditData.patientOrgStr || _vm.addNewOrEditData.otherStr))])])], 1) : _vm._e(), _vm._v(" "), (_vm.meetingSystemType == 'A1' || !_vm.recipientSocietyOrHospital) ? _c('div', [_c('el-row', [(!_vm.isOneHospital()) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院总数"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.moreThenOneHospital),
      callback: function($$v) {
        _vm.moreThenOneHospital = $$v
      },
      expression: "moreThenOneHospital"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("一家")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("两家及以上")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    staticClass: "more-tab"
  }, [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "hospitalLevelId"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("医院层级"), _c('common-tooltip', {
    attrs: {
      "tipCode": "9"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.hospitalLevelName))])])], 1), _vm._v(" "), (_vm.moreThenOneHospital && !_vm.isOneHospital()) ? _c('el-col', {
    staticClass: "col-add-remove"
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院数量",
      "prop": 'extendData.hospitalInfos.' + _vm.index + '.hospitalCount'
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.hospitalCount))])])], 1) : _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院",
      "prop": "hospitalId"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.hospitalName))])])], 1)], 1), _vm._v(" "), (_vm.moreThenOneHospital && !_vm.isOneHospital()) ? _c('div', _vm._l((_vm.addNewOrEditData.extendData.hospitalInfos), function(hospital, index) {
    return _c('div', {
      key: index,
      staticClass: "more-tab-div"
    }, [_c('el-row', {
      staticClass: "more-tab"
    }, [_c('el-col', [_c('el-form-item', {
      attrs: {
        "required": "",
        "prop": 'extendData.hospitalInfos.' + index + '.hospitalLevelId'
      }
    }, [_c('span', {
      staticClass: "tooltip-header-text",
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v("医院层级"), _c('common-tooltip', {
      attrs: {
        "tipCode": "9"
      }
    })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(hospital.hospitalLevelName))])])], 1), _vm._v(" "), _c('el-col', {
      staticClass: "col-add-remove"
    }, [_c('el-form-item', {
      attrs: {
        "required": "",
        "label": "医院数量",
        "prop": 'extendData.hospitalInfos.' + index + '.hospitalCount'
      }
    }, [_c('label', [_vm._v(_vm._s(hospital.hospitalCount))])])], 1)], 1)], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "科室"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('Office', _vm.addNewOrEditData.offices)))])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "是否包含讲者"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.includeSpeaker ? '是' : '否'))])])], 1)], 1), _vm._v(" "), (_vm.addNewOrEditData.includeSpeaker == 1) ? _c('el-row', {
    staticClass: "more-tab"
  }, [_c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD'
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("讲者级别"), _c('common-tooltip', {
    attrs: {
      "tipCode": "10"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.speakerLevelName))])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "col-add-remove"
  }, [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "讲者人数"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.speakerCount))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.includeSpeaker == 1) ? _c('div', {
    staticClass: "more-tab-div"
  }, _vm._l((_vm.addNewOrEditData.extendData.speakerInfos), function(speaker, index) {
    return _c('el-row', {
      key: index,
      staticClass: "more-tab"
    }, [_c('el-col', [_c('el-form-item', {
      class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
      attrs: {
        "required": _vm.meetingSystemType != 'GSD'
      }
    }, [_c('span', {
      staticClass: "tooltip-header-text",
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v("讲者级别"), _c('common-tooltip', {
      attrs: {
        "tipCode": "10"
      }
    })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(speaker.speakerLevelName))])])], 1), _vm._v(" "), _c('el-col', {
      staticClass: "col-add-remove"
    }, [_c('el-form-item', {
      class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
      attrs: {
        "required": _vm.meetingSystemType != 'GSD',
        "label": "讲者人数"
      }
    }, [_c('label', [_vm._v(_vm._s(speaker.speakerCount))])])], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "参会人数（外）"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.attendCount))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "罗氏员工人数（内）"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.rocheCount))])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": ""
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("会议总预算"), _c('common-tooltip', {
    attrs: {
      "tipCode": "12"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.totalAmount))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    staticClass: "not-required",
    attrs: {
      "label": "成本中心"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.costCenter + ' ' + _vm.addNewOrEditData.costCenterName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "WBS code"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.wbsCode))])])], 1)], 1), _vm._v(" "), _c('el-row', [(_vm.addNewOrEditData.meetingSystem.length == 2) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "A1预算"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.a1Amount))])])], 1) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.meetingSystem.length == 2) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "GSD预算"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.gsdAmount))])])], 1) : _vm._e(), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    staticClass: "not-required",
    attrs: {
      "label": "会议申请人"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.meetingOrganizerCnname + ' ' + _vm.addNewOrEditData.meetingOrganizerName))])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "approval-workflow-title"
  }, [_vm._v("\n                  审批流\n                  "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "content-box"
  }, _vm._l((_vm.addNewOrEditData.nodeList), function(node) {
    return _c('el-row', {
      key: node.id
    }, [_c('el-col', {
      staticClass: "approval-workflow"
    }, [_c('el-form-item', {
      staticClass: "not-required",
      attrs: {
        "label": node.isAuthorized === 0 ? node.nodeLevel + '【授权审批】' : node.nodeLevel,
        "prop": "treatAreaResult"
      }
    }, [_c('label', [_vm._v(_vm._s(node.realName) + " " + _vm._s(node.username) + " " + _vm._s(node.createTime) + " " + _vm._s(node.isAuthorized === 0 ? ("（" + (node.licensorName) + "授权）") : ''))]), _vm._v(" "), _c('span', {
      class: ['approval-status', _vm.approvalStatusClass(node.meetStatus)]
    }, [_vm._v(_vm._s(node.statusName))])]), _vm._v(" "), (node.remark) ? _c('el-form-item', {
      staticClass: "not-required"
    }, [_c('label', [_vm._v(_vm._s(node.remark))])]) : _vm._e()], 1)], 1)
  }), 1)])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b4e872ae", module.exports)
  }
}

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.getValueSting))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b96626e6", module.exports)
  }
}

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cny-input"
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder
    },
    on: {
      "blur": _vm.formatDetailBudget,
      "focus": _vm.focusOnPrice
    },
    model: {
      value: (_vm.innerValue),
      callback: function($$v) {
        _vm.innerValue = $$v
      },
      expression: "innerValue"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-be6888bc", module.exports)
  }
}

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-contain"
  }, [_c('div', {
    staticClass: "search-content-main"
  }, [(!_vm.isConfigurationData) ? _c('el-form', {
    staticClass: "search-content-main-fields"
  }, [_c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields-year",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleBudgetMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.year),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "year", $$v)
      },
      expression: "searchMainData.year"
    }
  }, _vm._l((_vm.baseDataRecords.Year), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.yearName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields-departId",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.resetMedicalField();
        _vm.handleBudgetMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.departId),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "departId", $$v)
      },
      expression: "searchMainData.departId"
    }
  }, _vm._l((_vm.userInfo.loginDeparts), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields-medicalField",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.resetTeamField();
        _vm.handleBudgetMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "medicalField", $$v)
      },
      expression: "searchMainData.medicalField"
    }
  }, _vm._l((_vm.getMedicalFieldArray(_vm.searchMainData.departId)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields-medicalField",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleBudgetMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "teamL4", $$v)
      },
      expression: "searchMainData.teamL4"
    }
  }, _vm._l((_vm.getTeamArray(_vm.searchMainData.departId, _vm.searchMainData.medicalField)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1)], 1) : _c('el-form', {
    staticClass: "search-content-main-fields"
  }, [_c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields-year",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleBudgetMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.year),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "year", $$v)
      },
      expression: "searchMainData.year"
    }
  }, _vm._l((_vm.baseDataRecords.Year), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.yearName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields-departId",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.resetMedicalField();
        _vm.handleBudgetMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.departId),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "departId", $$v)
      },
      expression: "searchMainData.departId"
    }
  }, _vm._l((_vm.departsList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields-medicalField",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.resetTeamField();
        _vm.handleBudgetMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "medicalField", $$v)
      },
      expression: "searchMainData.medicalField"
    }
  }, _vm._l((_vm.medicalFieldList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields-medicalField",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleBudgetMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "teamL4", $$v)
      },
      expression: "searchMainData.teamL4"
    }
  }, _vm._l((_vm.teamList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (!_vm.editMainBudget) ? _c('div', {
    staticClass: "main-edit",
    on: {
      "click": _vm.handleMainEdit
    }
  }, [_c('i', {
    staticClass: "l-user-item-icon iconfont icon-bianji"
  }), _vm._v(" "), _c('label', [_vm._v("编辑年度/季度预算")])]) : _c('div', {
    staticClass: "main-edit"
  }, [_c('el-button', {
    staticClass: "main-edit-cancle",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.handleCancleMainEditClick()
      }
    }
  }, [_vm._v("\n          取消\n        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.handleConfirmMainEditClick()
      }
    }
  }, [_vm._v("\n          确定\n        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-contain-main-tab"
  }, [_c('div', {
    staticClass: "main-blocks"
  }, [_c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "main-block-contain"
  }, [_c('div', {
    staticClass: "main-block-contain-title"
  }, [_vm._v("年度")]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-budget"
  }, [_c('i', {
    staticClass: "iconfont icon-qiandaizi"
  }), _vm._v(" "), (!_vm.editMainBudget) ? _c('label', [_vm._v("￥" + _vm._s(_vm._f("MoneyFormat")(_vm.mainData.yearBudgAmt)))]) : _c('cny-input', {
    model: {
      value: (_vm.mainData.yearBudgAmt),
      callback: function($$v) {
        _vm.$set(_vm.mainData, "yearBudgAmt", $$v)
      },
      expression: "mainData.yearBudgAmt"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "main-block-contain"
  }, [_c('div', {
    staticClass: "main-block-contain-title"
  }, [_vm._v("一季度")]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-budget"
  }, [_c('i', {
    staticClass: "iconfont icon-qianbao"
  }), _vm._v(" "), (!_vm.editMainBudget) ? _c('label', [_vm._v("￥" + _vm._s(_vm._f("MoneyFormat")(_vm.mainData.q1BudgAmt)))]) : _c('cny-input', {
    model: {
      value: (_vm.mainData.q1BudgAmt),
      callback: function($$v) {
        _vm.$set(_vm.mainData, "q1BudgAmt", $$v)
      },
      expression: "mainData.q1BudgAmt"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "main-block-contain"
  }, [_c('div', {
    staticClass: "main-block-contain-title"
  }, [_vm._v("二季度")]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-budget"
  }, [_c('i', {
    staticClass: "iconfont icon-qianbao"
  }), _vm._v(" "), (!_vm.editMainBudget) ? _c('label', [_vm._v("￥" + _vm._s(_vm._f("MoneyFormat")(_vm.mainData.q2BudgAmt)))]) : _c('cny-input', {
    model: {
      value: (_vm.mainData.q2BudgAmt),
      callback: function($$v) {
        _vm.$set(_vm.mainData, "q2BudgAmt", $$v)
      },
      expression: "mainData.q2BudgAmt"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "main-block-contain"
  }, [_c('div', {
    staticClass: "main-block-contain-title"
  }, [_vm._v("三季度")]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-budget"
  }, [_c('i', {
    staticClass: "iconfont icon-qianbao"
  }), _vm._v(" "), (!_vm.editMainBudget) ? _c('label', [_vm._v("￥" + _vm._s(_vm._f("MoneyFormat")(_vm.mainData.q3BudgAmt)))]) : _c('cny-input', {
    model: {
      value: (_vm.mainData.q3BudgAmt),
      callback: function($$v) {
        _vm.$set(_vm.mainData, "q3BudgAmt", $$v)
      },
      expression: "mainData.q3BudgAmt"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "main-block-contain"
  }, [_c('div', {
    staticClass: "main-block-contain-title"
  }, [_vm._v("四季度")]), _vm._v(" "), _c('div', {
    staticClass: "main-block-contain-budget"
  }, [_c('i', {
    staticClass: "iconfont icon-qianbao"
  }), _vm._v(" "), (!_vm.editMainBudget) ? _c('label', [_vm._v("￥" + _vm._s(_vm._f("MoneyFormat")(_vm.mainData.q4BudgAmt)))]) : _c('cny-input', {
    model: {
      value: (_vm.mainData.q4BudgAmt),
      callback: function($$v) {
        _vm.$set(_vm.mainData, "q4BudgAmt", $$v)
      },
      expression: "mainData.q4BudgAmt"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "search-content"
  }, [_c('el-form', {
    staticClass: "search-content-fields"
  }, [_c('el-form-item', [_c('el-select', {
    model: {
      value: (_vm.searchData.quarter),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "quarter", $$v)
      },
      expression: "searchData.quarter"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部季度"
    }
  }), _vm._v(" "), _vm._l((_vm.baseDataRecords.Quarter), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    on: {
      "change": _vm.handleSearchCostCenterChange
    },
    model: {
      value: (_vm.searchData.costCenter),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "costCenter", $$v)
      },
      expression: "searchData.costCenter"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部成本中心"
    }
  }), _vm._v(" "), _vm._l((_vm.costCenterArray), function(item) {
    return _c('el-option', {
      key: item.costId,
      attrs: {
        "value": item.costId,
        "label": item.costName
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    model: {
      value: (_vm.searchData.wbsCode),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "wbsCode", $$v)
      },
      expression: "searchData.wbsCode"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部WBS code"
    }
  }), _vm._v(" "), _vm._l((_vm.wbsCodeArray), function(item) {
    return _c('el-option', {
      key: item.costId,
      attrs: {
        "value": item.costId,
        "label": item.costName
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "budget-detail-info"
  }, [_vm._v("预算拆分总计" + _vm._s(_vm.budgetDetailCount) + "条 共：" + _vm._s(_vm._f("MoneyFormat")(_vm.budgetDetailAmt)))]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": '/static/file/budget.xlsx?t=' + new Date().getTime()
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    }
  }, [_vm._v("导出模板")])], 1), _vm._v(" "), _c('span', [_c('common-upload', {
    attrs: {
      "importApi": _vm.crudApi,
      "importType": "Excel",
      "onSuccess": _vm.handleUpdateSuccess
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    }
  }, [_vm._v("批量上传")])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.mainData.id,
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handlerExportExcelClick()
      }
    }
  }, [_vm._v("批量导出")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.mainData.id || _vm.selectedData.length <= 0,
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleBatchDeleteClick()
      }
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.mainData.id,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddNewClick()
      }
    }
  }, [_vm._v("添加预算拆分")])], 1)])]), _vm._v(" "), _c('common-crud', {
    ref: "crud",
    attrs: {
      "addNewOrEditData": _vm.addNewOrEditData,
      "searchData": _vm.searchData,
      "crudApi": _vm.crudApi,
      "tableData": _vm.budgetDetailData,
      "showEditFormTitle": false,
      "beforeSave": _vm.beforeSave,
      "editDialogClass": "biz-budget-detail-edit-dialog",
      "handleSearchResult": _vm.handleSearchResult,
      "selectedDataArray": _vm.selectedData,
      "afterSave": _vm.handleBudgetChange,
      "afterDelete": _vm.handleBudgetChange,
      "defaultPageSize": 10,
      "addSuccessMessages": "添加预算拆分成功",
      "editSuccessMessages": "编辑预算拆分成功",
      "deleteSuccessMessages": "删除预算拆分成功",
      "deleteBatchSuccessMessages": "批量删除预算拆分成功"
    },
    on: {
      "update:tableData": function($event) {
        _vm.budgetDetailData = $event
      },
      "update:table-data": function($event) {
        _vm.budgetDetailData = $event
      },
      "update:selectedDataArray": function($event) {
        _vm.selectedData = $event
      },
      "update:selected-data-array": function($event) {
        _vm.selectedData = $event
      }
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "width": "60",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "departId",
      "label": "部门"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "medicalField",
      "width": "135"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('div', [_vm._v("Franchise/DA")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "teamL4",
      "label": "团队",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "prodIds",
      "label": "产品"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "quarter",
      "label": "季度"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "companyCode",
      "label": "法律实体",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "costType",
      "label": "类型",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.costType === '1' ? '成本中心' : scope.row.costType === '2' ? 'Real Wbs Code' : '') + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "costCenter",
      "label": "成本中心",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "wbsCode",
      "label": "WBS code",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "budgAmt",
      "label": "季度预算拆分金额",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm._f("MoneyFormat")(scope.row.budgAmt)) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatDateTime2Date,
      "sortable": "",
      "prop": "updateTime",
      "label": "更新时间",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "updateBy",
      "label": "操作人",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-column-operate"
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditClick(scope.row)
            }
          }
        }, [_vm._v("\n                    编辑\n                  ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteClick(scope.row)
            }
          }
        }, [_vm._v("\n                    删除\n                  ")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "customTitle"
  }, [_vm._v("预算拆分")]), _vm._v(" "), _c('template', {
    slot: "editForm"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "部门",
      "prop": "departId"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.departId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "departId", $$v)
      },
      expression: "addNewOrEditData.departId"
    }
  }, _vm._l((_vm.userInfo.loginDeparts), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "Franchise/DA",
      "prop": "medicalField"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "medicalField", $$v)
      },
      expression: "addNewOrEditData.medicalField"
    }
  }, _vm._l((_vm.userInfo.loginMedicalFields), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "团队",
      "prop": "teamL4"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "teamL4", $$v)
      },
      expression: "addNewOrEditData.teamL4"
    }
  }, _vm._l((_vm.userInfo.loginTeams), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamL4
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "rules": [{
        required: true,
        trigger: 'change'
      }],
      "label": "产品",
      "prop": "prodIds"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "disabled": _vm.isEdit,
      "multiple": "",
      "placeholder": "请选择（可多选，可搜索）"
    },
    model: {
      value: (_vm.addNewOrEditData.prodIds),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "prodIds", $$v)
      },
      expression: "addNewOrEditData.prodIds"
    }
  }, _vm._l((_vm.baseDataRecords.Product), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.productName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "所在年份",
      "prop": "year"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.year),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "year", $$v)
      },
      expression: "addNewOrEditData.year"
    }
  }, _vm._l((_vm.baseDataRecords.Year), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.yearName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "所在季度",
      "prop": "quarter"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.isEdit,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.quarter),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "quarter", $$v)
      },
      expression: "addNewOrEditData.quarter"
    }
  }, _vm._l((_vm.baseDataRecords.Quarter), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "类型",
      "prop": "costType"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.isEdit,
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleCostTypeChange
    },
    model: {
      value: (_vm.addNewOrEditData.costType),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "costType", $$v)
      },
      expression: "addNewOrEditData.costType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "成本中心"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "Real Wbs Code"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "法律实体",
      "prop": "companyCode"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "disabled": _vm.isEdit,
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleCompanyCodeChange
    },
    model: {
      value: (_vm.addNewOrEditData.companyCode),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "companyCode", $$v)
      },
      expression: "addNewOrEditData.companyCode"
    }
  }, _vm._l((_vm.companyCodeArray), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.text,
        "label": item.text
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), (_vm.addNewOrEditData.costType === 1) ? _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "成本中心",
      "prop": "costCenter",
      "rules": [{
        required: _vm.addNewOrEditData.costType === 1,
        message: '请选择成本中心',
        trigger: 'change'
      }]
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleCostCenter4EditFilter,
      "disabled": _vm.isEdit,
      "placeholder": "请使用ASPIRE新的成本中心"
    },
    on: {
      "change": function($event) {
        _vm.handleEditCostCenterChange();
        _vm.addNewOrEditData.costCenterName = _vm.getNameFromArray(_vm.filterCostCenter4EditArray, 'costCenter', 'description', _vm.addNewOrEditData.costCenter);
        _vm.filterCostCenter4EditArray = []
      }
    },
    model: {
      value: (_vm.addNewOrEditData.costCenter),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "costCenter", $$v)
      },
      expression: "addNewOrEditData.costCenter"
    }
  }, _vm._l((_vm.filterCostCenter4EditArray), function(item) {
    return _c('el-option', {
      key: item.costCenter,
      attrs: {
        "value": item.costCenter,
        "label": item.costCenter
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "成本中心owner",
      "prop": "owner"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("成本中心owner"), _c('common-tooltip', {
    attrs: {
      "tipCode": "14"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleOwnerFilter,
      "clearable": "",
      "disabled": _vm.isEdit,
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.ownerName = _vm.getName(_vm.addNewOrEditData.owner, _vm.remoteOwnerArray, 'username', 'realname');
        _vm.remoteOwnerArray = [];
        _vm.addNewOrEditData.isMedicalField = _vm.addNewOrEditData.owner ? _vm.addNewOrEditData.isMedicalField : false
      }
    },
    model: {
      value: (_vm.addNewOrEditData.owner),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "owner", $$v)
      },
      expression: "addNewOrEditData.owner"
    }
  }, _vm._l((_vm.remoteOwnerArray), function(item) {
    return _c('el-option', {
      key: item.username,
      attrs: {
        "value": item.username,
        "label": item.realname + ' ' + item.username
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "isMedicalField",
    attrs: {
      "hidden": ""
    }
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": !_vm.addNewOrEditData.owner
    },
    model: {
      value: (_vm.addNewOrEditData.isMedicalField),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "isMedicalField", $$v)
      },
      expression: "addNewOrEditData.isMedicalField"
    }
  }, [_vm._v("本franchise成员可使用")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "WBS code",
      "prop": "wbsCode",
      "rules": [{
        required: _vm.addNewOrEditData.costType === 2,
        message: '请选择WBS code',
        trigger: 'change'
      }]
    }
  }, [(_vm.addNewOrEditData.costType === 1) ? _c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "disabled": _vm.isEdit,
      "placeholder": "请使用ASPIRE新的WBS Code"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.wbsCodeName = _vm.getNameFromArray(_vm.wbsCode4EditArray, 'wbsElement', 'description', _vm.addNewOrEditData.wbsCode)
      }
    },
    model: {
      value: (_vm.addNewOrEditData.wbsCode),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "wbsCode", $$v)
      },
      expression: "addNewOrEditData.wbsCode"
    }
  }, _vm._l((_vm.wbsCode4EditArray), function(item) {
    return _c('el-option', {
      key: item.wbsElement,
      attrs: {
        "value": item.wbsElement,
        "label": item.wbsElement
      }
    })
  }), 1) : _c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "remote": "",
      "remote-method": _vm.handleWbsCodeRemoteFilter,
      "disabled": _vm.isEdit,
      "placeholder": "请使用ASPIRE新的WBS Code"
    },
    on: {
      "change": _vm.handleWbsCodeChange
    },
    model: {
      value: (_vm.addNewOrEditData.wbsCode),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "wbsCode", $$v)
      },
      expression: "addNewOrEditData.wbsCode"
    }
  }, _vm._l((_vm.filterWbsCode4EditArray), function(item) {
    return _c('el-option', {
      key: item.wbsElement,
      attrs: {
        "value": item.wbsElement,
        "label": item.wbsElement
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "rules": [{
        required: true,
        trigger: 'blur'
      }],
      "label": "季度预算拆分金额",
      "prop": "budgAmt"
    }
  }, [_c('cny-input', {
    model: {
      value: (_vm.addNewOrEditData.budgAmt),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "budgAmt", $$v)
      },
      expression: "addNewOrEditData.budgAmt"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "confirmAddNewMessage"
  }, [_c('div', [_c('span', [_vm._v("确认添加预算拆分？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmEditMessage"
  }, [_c('div', [_c('span', [_vm._v("确认保存预算拆分？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("删除预算拆分？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmBatchDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("批量删除预算拆分？")])])])], 2)], 1)])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "main-edit-confirm",
    attrs: {
      "title": "预算管理",
      "width": "400px",
      "show-close": false,
      "visible": _vm.confirmEditMainBudgetSaveVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.confirmEditMainBudgetSaveVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "main-budget-info"
  }, [_c('div', {
    staticClass: "main-budget-info-block"
  }, [_c('div', {
    staticClass: "main-budget-info-block-name"
  }, [_c('label', [_vm._v("年度预算：")])]), _vm._v(" "), _c('div', {
    staticClass: "main-budget-info-block-value"
  }, [_vm._v(_vm._s(_vm._f("MoneyFormat")(_vm.mainData.yearBudgAmt)))])]), _vm._v(" "), _c('div', {
    staticClass: "main-budget-info-block"
  }, [_c('div', {
    staticClass: "main-budget-info-block-name"
  }, [_c('label', [_vm._v("一季度预算：")])]), _vm._v(" "), _c('div', {
    staticClass: "main-budget-info-block-value"
  }, [_vm._v(_vm._s(_vm._f("MoneyFormat")(_vm.mainData.q1BudgAmt)))])]), _vm._v(" "), _c('div', {
    staticClass: "main-budget-info-block"
  }, [_c('div', {
    staticClass: "main-budget-info-block-name"
  }, [_c('label', [_vm._v("二季度预算：")])]), _vm._v(" "), _c('div', {
    staticClass: "main-budget-info-block-value"
  }, [_vm._v(_vm._s(_vm._f("MoneyFormat")(_vm.mainData.q2BudgAmt)))])]), _vm._v(" "), _c('div', {
    staticClass: "main-budget-info-block"
  }, [_c('div', {
    staticClass: "main-budget-info-block-name"
  }, [_c('label', [_vm._v("三季度预算：")])]), _vm._v(" "), _c('div', {
    staticClass: "main-budget-info-block-value"
  }, [_vm._v(_vm._s(_vm._f("MoneyFormat")(_vm.mainData.q3BudgAmt)))])]), _vm._v(" "), _c('div', {
    staticClass: "main-budget-info-block"
  }, [_c('div', {
    staticClass: "main-budget-info-block-name"
  }, [_c('label', [_vm._v("四季度预算：")])]), _vm._v(" "), _c('div', {
    staticClass: "main-budget-info-block-value"
  }, [_vm._v(_vm._s(_vm._f("MoneyFormat")(_vm.mainData.q4BudgAmt)))])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handlerEditMainBudgetSaveConfirmOK()
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.confirmEditMainBudgetSaveVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d4c1c57a", module.exports)
  }
}

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-contain"
  }, [_c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "search-content"
  }, [_c('div', {
    staticClass: "search-content-fields"
  }, [_c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "策略重点"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("策略重点\n                          "), _c('el-tooltip', {
    attrs: {
      "popper-class": "custom-tooltip",
      "placement": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("策略描述指引（试运行）")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("● 原则上，应倡导和促进在遵守法律法规和商业道德的前提下，公平有序的竞争。")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("● 避免使用容易引起歧义或误解的用词，尤其将学术推广活动和提升销量、扩大市场份额等直接关联，或其它容易引起反垄断、违反公平竞争原则风险的敏感用词")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("● 基于年度BAP内部讨论共识的策略，可基于不同产品及适应症，中央及区域差异分别制定策略描述；")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("● 基于策略及落实的实际需求选择最聚焦、简单的分类进行策略拆分；")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("● 特别注意推广及非推广类会议活动及项目的匹配度；")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("● 应该避免使用过于复杂或行业术语过多的语言。清晰、简洁、易于 理解；")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("● 基于材料审核的参考原则，谨慎用语，注意措辞分寸。不应含有明示或暗示的不科学、不合理的用词，尤其是明确的禁忌用语，如超适应症、销量翻 5 倍、医院份额＞ 50 、抵御竞争等")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("● 策略描述可基于策略及业务需求定期更新，但不建议频繁调整变化.")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("● 如业务团队有疑问，建议其及时咨询法务合规BP")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-warning-outline",
    staticStyle: {
      "font-size": "16px"
    }
  })])], 1), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.searchData.keynote),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "keynote", $$v)
      },
      expression: "searchData.keynote"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.medicalField = '';
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.departId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "departId", $$v)
      },
      expression: "searchData.departId"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.departsList : _vm.userInfo.loginDeparts)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Franchise/DA"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.searchData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalField", $$v)
      },
      expression: "searchData.medicalField"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.medicalFieldList : _vm.getMedicalFieldArray(_vm.searchData.departId, true))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "团队"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "teamL4", $$v)
      },
      expression: "searchData.teamL4"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.teamList : _vm.getTeamArray(_vm.searchData.departId, _vm.searchData.medicalField, true))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "产品"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.searchData.productId),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "productId", $$v)
      },
      expression: "searchData.productId"
    }
  }, _vm._l((_vm.baseDataRecords.Product), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.productName
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticClass: "btn-search",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": '/static/file/strategy.xlsx?t=' + new Date().getTime()
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    }
  }, [_vm._v("导出模板")])], 1), _vm._v(" "), _c('span', [_c('common-upload', {
    attrs: {
      "importApi": _vm.crudApi,
      "importType": "Excel",
      "onSuccess": _vm.handleUpdateSuccess
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    }
  }, [_vm._v("批量上传")])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handlerExportExcelClick()
      }
    }
  }, [_vm._v("批量导出")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.selectedData.length <= 0,
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleBatchDeleteClick()
      }
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddNewClick()
      }
    }
  }, [_vm._v("添加策略")])], 1)]), _vm._v(" "), _c('common-crud', {
    ref: "crud",
    attrs: {
      "addNewOrEditData": _vm.addNewOrEditData,
      "searchData": _vm.searchData,
      "searchDataLikeField": {
        'keynote': '*'
      },
      "crudApi": _vm.crudApi,
      "tableData": _vm.strategyData,
      "showEditFormTitle": false,
      "beforeSave": _vm.beforeSave,
      "afterSave": _vm.handleStrategyChange,
      "afterDelete": _vm.handleStrategyChange,
      "selectedDataArray": _vm.selectedData,
      "otherValid": _vm.validUpload,
      "addSuccessMessages": "添加策略成功",
      "editSuccessMessages": "编辑策略成功",
      "deleteSuccessMessages": "删除策略成功",
      "deleteBatchSuccessMessages": "批量删除策略成功"
    },
    on: {
      "update:tableData": function($event) {
        _vm.strategyData = $event
      },
      "update:table-data": function($event) {
        _vm.strategyData = $event
      },
      "update:selectedDataArray": function($event) {
        _vm.selectedData = $event
      },
      "update:selected-data-array": function($event) {
        _vm.selectedData = $event
      }
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "width": "60",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "departId",
      "label": "部门"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "medicalField",
      "width": "135"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('div', [_vm._v("Franchise/DA")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "teamL4",
      "label": "团队"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatBaseData,
      "sortable": "",
      "prop": "productId",
      "label": "产品"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "keynote",
      "label": "策略重点"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatDateTime2Date,
      "sortable": "",
      "prop": "updateTime",
      "label": "更新时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "updateBy",
      "label": "操作人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-column-operate"
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditClick(scope.row)
            }
          }
        }, [_vm._v("\n                    编辑\n                  ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteClick(scope.row)
            }
          }
        }, [_vm._v("\n                    删除\n                  ")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "customTitle"
  }, [_vm._v("策略重点")]), _vm._v(" "), _c('template', {
    slot: "editForm"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "部门",
      "prop": "departId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.medicalField = '';
        _vm.addNewOrEditData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.addNewOrEditData.departId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "departId", $$v)
      },
      expression: "addNewOrEditData.departId"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.departsList : _vm.userInfo.loginDeparts)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "Franchise/DA",
      "prop": "medicalField"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.addNewOrEditData.teamL4 = ''
      }
    },
    model: {
      value: (_vm.addNewOrEditData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "medicalField", $$v)
      },
      expression: "addNewOrEditData.medicalField"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.medicalFieldList : _vm.getMedicalFieldArray(_vm.addNewOrEditData.departId, false))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "团队",
      "prop": "teamL4"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.teamL4),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "teamL4", $$v)
      },
      expression: "addNewOrEditData.teamL4"
    }
  }, _vm._l(((_vm.isConfigurationData ? _vm.teamList : _vm.getTeamArray(_vm.addNewOrEditData.departId, _vm.addNewOrEditData.medicalField, false))), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "产品",
      "prop": "productId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择（可搜索）"
    },
    model: {
      value: (_vm.addNewOrEditData.productId),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "productId", $$v)
      },
      expression: "addNewOrEditData.productId"
    }
  }, _vm._l((_vm.baseDataRecords.Product), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.productName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "col-full"
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "策略重点名称（建议长度在8个字符以内）",
      "prop": "keynote"
    }
  }, [_c('el-input', {
    attrs: {
      "rows": "4",
      "maxlength": "200",
      "type": "textarea",
      "placeholder": "请输入策略重点（建议长度在8个字符以内）"
    },
    model: {
      value: (_vm.addNewOrEditData.keynote),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "keynote", $$v)
      },
      expression: "addNewOrEditData.keynote"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('common-score', {
    ref: "strategyHospital4Strategy",
    attrs: {
      "disabledDownload": !_vm.canDownload,
      "title": "策略重点与医院层级",
      "type": "strategyHospital4Strategy",
      "fileName": "策略重点与医院层级.xlsx",
      "getExportParams": _vm.getScoreExportParams
    }
  })], 1), _vm._v(" "), _c('el-col', [_c('common-score', {
    ref: "strategyOffice",
    attrs: {
      "disabledDownload": !_vm.canDownload,
      "title": "策略重点与科室",
      "type": "strategyOffice",
      "fileName": "策略重点与科室.xlsx",
      "getExportParams": _vm.getScoreExportParams
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "confirmAddNewMessage"
  }, [_c('div', [_c('span', [_vm._v("确认添加策略重点？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmEditMessage"
  }, [_c('div', [_c('span', [_vm._v("确认保存策略重点？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("删除策略重点？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmBatchDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("批量删除策略重点？")])])]), _vm._v(" "), _c('template', {
    staticClass: "tipsFormClass",
    slot: "tipsFormMessage"
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("策略描述指引（试运行）")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass"
  }, [_vm._v("● 原则上，应倡导和促进在遵守法律法规和商业道德的前提下，公平有序的竞争。")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass"
  }, [_vm._v("● 避免使用容易引起歧义或误解的用词，尤其将学术推广活动和提升销量、扩大市场份额等直接关联，或其它容易引起反垄断、违反公平竞争原则风险的敏感用词")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass"
  }, [_vm._v("● 基于年度BAP内部讨论共识的策略，可基于不同产品及适应症，中央及区域差异分别制定策略描述；")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass"
  }, [_vm._v("● 基于策略及落实的实际需求选择最聚焦、简单的分类进行策略拆分；")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass"
  }, [_vm._v("● 特别注意推广及非推广类会议活动及项目的匹配度；")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass"
  }, [_vm._v("● 应该避免使用过于复杂或行业术语过多的语言。清晰、简洁、易于 理解；")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass"
  }, [_vm._v("● 基于材料审核的参考原则，谨慎用语，注意措辞分寸。不应含有明示或暗示的不科学、不合理的用词，尤其是明确的禁忌用语，如超适应症、销量翻 5 倍、医院份额＞ 50 、抵御竞争等")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass"
  }, [_vm._v("● 策略描述可基于策略及业务需求定期更新，但不建议频繁调整变化.")]), _vm._v(" "), _c('div', {
    staticClass: "tipsFormDivClass"
  }, [_vm._v("● 如业务团队有疑问，建议其及时咨询法务合规BP")])])], 2)], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e8ad199e", module.exports)
  }
}

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tooltip', {
    attrs: {
      "manual": _vm.isPad,
      "effect": "dark",
      "content": _vm.basedataGetName('SysTip', _vm.tipCode),
      "placement": "top"
    },
    model: {
      value: (_vm.tooltipVisible),
      callback: function($$v) {
        _vm.tooltipVisible = $$v
      },
      expression: "tooltipVisible"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-tishi1",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showTooltip($event)
      }
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f046f23c", module.exports)
  }
}

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit-main"
  }, [_c('div', {
    staticClass: "page-contain view-meeting-plan"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.addNewOrEditData,
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "会议名称"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.meetingName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": ""
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("系统选择"), _c('common-tooltip', {
    attrs: {
      "tipCode": "8"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingSystem', _vm.addNewOrEditData.meetingSystem)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "是否网络会议"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingModality', _vm.addNewOrEditData.meetingModality)))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "会议性质"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp)))])])], 1), _vm._v(" "), (_vm.meetingSystemType != 'GSD') ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "A1会议类型"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingType', _vm.addNewOrEditData.meetingType)))])])], 1) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.meetingType === '24' && _vm.isCEDepart()) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "是否为GSD",
      "prop": "isGsd"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.addNewOrEditData.isGsd),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "isGsd", $$v)
      },
      expression: "addNewOrEditData.isGsd"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.meetingSystemType != 'A1') ? _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "GSD项目类型"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingGsdType', _vm.addNewOrEditData.meetingGsdType)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "GSD细类"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingGsdTypeSub' + _vm.addNewOrEditData.meetingGsdType, _vm.addNewOrEditData.meetingGsdSubType)))])])], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "部门"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('Depart', _vm.addNewOrEditData.departId)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "Franchise/DA"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MedicalField', _vm.addNewOrEditData.medicalField)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "团队"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('Teams', _vm.addNewOrEditData.teamL4)))])])], 1)], 1), _vm._v(" "), _c('el-row', [(_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp) == '推广') ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "治疗领域"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('TreatmentArea', _vm.addNewOrEditData.treatmentArea)))])])], 1) : _vm._e(), _vm._v(" "), (_vm.basedataGetName('MeetingProp', _vm.addNewOrEditData.meetingProp).indexOf('非推广') >= 0) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "疾病领域"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('DiseaseArea', _vm.addNewOrEditData.diseaseArea)))])])], 1) : _vm._e(), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "产品"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('Product', _vm.addNewOrEditData.productId)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "公司战略"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('CompanyStrategy', _vm.addNewOrEditData.companyStrategy)))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "策略重点"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.strategyKeynoteName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'A1' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'A1',
      "label": "治疗领域业务结果"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.medicalFieldResultName))])])], 1), _vm._v(" "), (_vm.addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') >= 0) ? _c('el-col', [_c('el-form-item', {
    staticClass: "not-required",
    attrs: {
      "label": "治疗领域业务结果（自定义描述）"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.medicalFieldResultDes))])])], 1) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "开始日期"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm._f("DateFormat")(_vm.addNewOrEditData.meetingBeginDate)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "结束日期"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm._f("DateFormat")(_vm.addNewOrEditData.meetingEndDate)))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "会议时段"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('MeetingTimeInt', _vm.addNewOrEditData.meetingTimeInt)))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    class: (_vm.meetingSystemType != 'GSD') ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "国家"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.countryName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: (_vm.meetingSystemType != 'GSD') ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "省份"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.provinceName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: (_vm.meetingSystemType != 'GSD') ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "城市"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.cityName))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    class: (_vm.meetingSystemType != 'GSD' || _vm.basedataGetName('MeetingModality', _vm.addNewOrEditData.meetingModality).indexOf('线下') >= 0) ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD' && _vm.basedataGetName('MeetingModality', _vm.addNewOrEditData.meetingModality).indexOf('线下') >= 0,
      "label": "会议地点"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.meetingPlace))])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [(_vm.meetingSystemType != 'A1') ? _c('el-row', [_c('div', {
    staticClass: "col-full"
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "受赠方类型(GSD系统)"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.recipientSocietyOrHospital),
      callback: function($$v) {
        _vm.recipientSocietyOrHospital = $$v
      },
      expression: "recipientSocietyOrHospital"
    }
  }, [_c('el-radio', {
    staticClass: "tooltip-header-text",
    attrs: {
      "label": 1
    }
  }, [_vm._v("受赠学会"), _c('common-tooltip', {
    attrs: {
      "tipCode": "11"
    }
  })], 1), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("医院")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("大学")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("患者组织")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("其他")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.meetingSystemType != 'A1' && _vm.recipientSocietyOrHospital) ? _c('el-row', {
    staticClass: "recipientSociety-input"
  }, [_c('el-col', [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.recipientSocietyStr || _vm.addNewOrEditData.universityStr || _vm.addNewOrEditData.patientOrgStr || _vm.addNewOrEditData.otherStr))])])], 1) : _vm._e(), _vm._v(" "), (_vm.meetingSystemType == 'A1' || !_vm.recipientSocietyOrHospital) ? _c('div', [_c('el-row', [(!_vm.isOneHospital()) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院总数"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.moreThenOneHospital),
      callback: function($$v) {
        _vm.moreThenOneHospital = $$v
      },
      expression: "moreThenOneHospital"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("一家")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("两家及以上")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    staticClass: "more-tab"
  }, [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "hospitalLevelId"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("医院层级"), _c('common-tooltip', {
    attrs: {
      "tipCode": "9"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.hospitalLevelName))])])], 1), _vm._v(" "), (_vm.moreThenOneHospital && !_vm.isOneHospital()) ? _c('el-col', {
    staticClass: "col-add-remove"
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院数量",
      "prop": 'extendData.hospitalInfos.' + _vm.index + '.hospitalCount'
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.hospitalCount))])])], 1) : _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "医院",
      "prop": "hospitalId"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.hospitalName))])])], 1)], 1), _vm._v(" "), (_vm.moreThenOneHospital && !_vm.isOneHospital()) ? _c('div', _vm._l((_vm.addNewOrEditData.extendData.hospitalInfos), function(hospital, index) {
    return _c('div', {
      key: index,
      staticClass: "more-tab-div"
    }, [_c('el-row', {
      staticClass: "more-tab"
    }, [_c('el-col', [_c('el-form-item', {
      attrs: {
        "required": "",
        "prop": 'extendData.hospitalInfos.' + index + '.hospitalLevelId'
      }
    }, [_c('span', {
      staticClass: "tooltip-header-text",
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v("医院层级"), _c('common-tooltip', {
      attrs: {
        "tipCode": "9"
      }
    })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(hospital.hospitalLevelName))])])], 1), _vm._v(" "), _c('el-col', {
      staticClass: "col-add-remove"
    }, [_c('el-form-item', {
      attrs: {
        "required": "",
        "label": "医院数量",
        "prop": 'extendData.hospitalInfos.' + index + '.hospitalCount'
      }
    }, [_c('label', [_vm._v(_vm._s(hospital.hospitalCount))])])], 1)], 1)], 1)
  }), 0) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "科室"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.basedataGetName('Office', _vm.addNewOrEditData.offices)))])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "是否包含讲者"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.includeSpeaker ? '是' : '否'))])])], 1)], 1), _vm._v(" "), (_vm.addNewOrEditData.includeSpeaker == 1) ? _c('el-row', {
    staticClass: "more-tab"
  }, [_c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD'
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("讲者级别"), _c('common-tooltip', {
    attrs: {
      "tipCode": "10"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.speakerLevelName))])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "col-add-remove"
  }, [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "讲者人数"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.speakerCount))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.includeSpeaker == 1) ? _c('div', {
    staticClass: "more-tab-div"
  }, _vm._l((_vm.addNewOrEditData.extendData.speakerInfos), function(speaker, index) {
    return _c('el-row', {
      key: index,
      staticClass: "more-tab"
    }, [_c('el-col', [_c('el-form-item', {
      class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
      attrs: {
        "required": _vm.meetingSystemType != 'GSD'
      }
    }, [_c('span', {
      staticClass: "tooltip-header-text",
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v("讲者级别"), _c('common-tooltip', {
      attrs: {
        "tipCode": "10"
      }
    })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(speaker.speakerLevelName))])])], 1), _vm._v(" "), _c('el-col', {
      staticClass: "col-add-remove"
    }, [_c('el-form-item', {
      class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
      attrs: {
        "required": _vm.meetingSystemType != 'GSD',
        "label": "讲者人数"
      }
    }, [_c('label', [_vm._v(_vm._s(speaker.speakerCount))])])], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "参会人数（外）"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.attendCount))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    class: _vm.meetingSystemType != 'GSD' ? '' : 'not-required',
    attrs: {
      "required": _vm.meetingSystemType != 'GSD',
      "label": "罗氏员工人数（内）"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.rocheCount))])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": ""
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("会议总预算"), _c('common-tooltip', {
    attrs: {
      "tipCode": "12"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.totalAmount))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "成本中心"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.costCenter + ' ' + _vm.addNewOrEditData.costCenterName))])])], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    staticClass: "not-required",
    attrs: {
      "label": "WBS code"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.wbsCode))])])], 1)], 1), _vm._v(" "), _c('el-row', [(_vm.addNewOrEditData.meetingSystem.length == 2) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "A1预算"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.a1Amount))])])], 1) : _vm._e(), _vm._v(" "), (_vm.addNewOrEditData.meetingSystem.length == 2) ? _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "GSD预算"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.gsdAmount))])])], 1) : _vm._e(), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    staticClass: "not-required",
    attrs: {
      "label": "会议申请人"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.addNewOrEditData.meetingOrganizerCnname + ' ' + _vm.addNewOrEditData.meetingOrganizerName))])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-contain-tab"
  }, [_c('div', {
    staticClass: "approval-workflow-title"
  }, [_vm._v("\n                  审批流\n                  "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "content-box"
  }, _vm._l((_vm.addNewOrEditData.nodeList), function(node) {
    return _c('el-row', {
      key: node.id
    }, [_c('el-col', {
      staticClass: "approval-workflow"
    }, [_c('el-form-item', {
      staticClass: "not-required",
      attrs: {
        "label": node.isAuthorized === 0 ? node.nodeLevel + '【授权审批】' : node.nodeLevel,
        "prop": "treatAreaResult"
      }
    }, [_c('label', [_vm._v(_vm._s(node.realName) + " " + _vm._s(node.username) + " " + _vm._s(node.createTime) + " " + _vm._s(node.isAuthorized === 0 ? ("（" + (node.licensorName) + "授权）") : ''))]), _vm._v(" "), _c('span', {
      class: ['approval-status', _vm.approvalStatusClass(node.meetStatus)]
    }, [_vm._v(_vm._s(node.statusName))])]), _vm._v(" "), (node.remark) ? _c('el-form-item', {
      staticClass: "not-required"
    }, [_c('label', [_vm._v(_vm._s(node.remark))])]) : _vm._e()], 1)], 1)
  }), 1)])])], 1), _vm._v(" "), ((_vm.addNewOrEditData.status == '5' || _vm.addNewOrEditData.status == '8') && _vm.addNewOrEditData.isAutoReject !== '1') ? _c('div', {
    staticClass: "bottom-info"
  }, [_c('div', {
    staticClass: "bottom-info-operate"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handlerChangeClick
    }
  }, [_vm._v("变更")])], 1)]) : _vm._e(), _vm._v(" "), _c('common-confirm', {
    attrs: {
      "dialogVisiable": _vm.confirmChangeVisible,
      "confirm": _vm.handlerChangeConfirmOK
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.confirmChangeVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.confirmChangeVisible = $event
      }
    }
  }, [_c('div', [_vm._v("\n          确认变更会议？\n      ")])]), _vm._v(" "), _c('common-confirm', {
    attrs: {
      "dialogVisiable": _vm.confirmCancleVisible,
      "confirm": _vm.handlerCancleConfirmOK
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.confirmCancleVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.confirmCancleVisible = $event
      }
    }
  }, [_c('div', [_vm._v("\n          确认取消会议？\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "cancle-alert-info"
  }, [_vm._v("\n          （确认取消后将无法恢复）\n      ")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f3df5218", module.exports)
  }
}

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-submenu"
  }, [_c('div', {
    staticClass: "page-submenu_left"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('left-bar', {
    attrs: {
      "tab": "2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-submenu_right"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "info-content-fields"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.contentData,
      "show-message": false
    }
  }, [_c('div', {
    staticClass: "el-form-item inline-items"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("\n                        活动负责人申请开放时间：\n                      ")]), _vm._v(" "), _c('div', [_c('label', [_vm._v("每个月")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "applyDay"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls": false,
      "controls-position": "right",
      "precision": 0,
      "min": 1,
      "max": 31,
      "disabled": !_vm.editVisible
    },
    model: {
      value: (_vm.contentData.applyDay),
      callback: function($$v) {
        _vm.$set(_vm.contentData, "applyDay", $$v)
      },
      expression: "contentData.applyDay"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v("号0点。")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item inline-items"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("\n                        直线经理审批截止时间：\n                      ")]), _vm._v(" "), _c('div', [_c('label', [_vm._v("每个月")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "approveManageDay"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls": false,
      "controls-position": "right",
      "precision": 0,
      "min": 1,
      "max": 31,
      "disabled": !_vm.editVisible
    },
    model: {
      value: (_vm.contentData.approveManageDay),
      callback: function($$v) {
        _vm.$set(_vm.contentData, "approveManageDay", $$v)
      },
      expression: "contentData.approveManageDay"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v("号24点。")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item inline-items"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("\n                        VP-1审批截止时间：\n                      ")]), _vm._v(" "), _c('div', [_c('label', [_vm._v("每个月")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "required": "",
      "prop": "approveVpDay"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls": false,
      "controls-position": "right",
      "precision": 0,
      "min": 1,
      "max": 31,
      "disabled": !_vm.editVisible
    },
    model: {
      value: (_vm.contentData.approveVpDay),
      callback: function($$v) {
        _vm.$set(_vm.contentData, "approveVpDay", $$v)
      },
      expression: "contentData.approveVpDay"
    }
  })], 1), _vm._v(" "), _c('label', [_vm._v("号24点。")])], 1)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editVisible),
      expression: "!editVisible"
    }],
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleEditClick()
      }
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editVisible),
      expression: "editVisible"
    }],
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleCancelEditClick()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editVisible),
      expression: "editVisible"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleEditConfirmClick()
      }
    }
  }, [_vm._v("确认")])], 1)])])])]), _vm._v(" "), _c('common-confirm', {
    attrs: {
      "dialogVisiable": _vm.confirmEditSaveVisible,
      "confirm": _vm.handlerEditSaveConfirmOK
    },
    on: {
      "update:dialogVisiable": function($event) {
        _vm.confirmEditSaveVisible = $event
      },
      "update:dialog-visiable": function($event) {
        _vm.confirmEditSaveVisible = $event
      }
    }
  }, [_c('div', [_c('span', [_vm._v("确认更改月度申请开放周期？")])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f6034e3e", module.exports)
  }
}

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-budget"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page-contain"
  }, [_c('div', {
    staticClass: "search-content-main"
  }, [_c('el-form', {
    staticClass: "search-content-main-fields"
  }, [_c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.year),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "year", $$v)
      },
      expression: "searchMainData.year"
    }
  }, _vm._l((_vm.baseDataRecords.Year), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.yearName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.meetingSystem),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "meetingSystem", $$v)
      },
      expression: "searchMainData.meetingSystem"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部系统"
    }
  }), _vm._v(" "), _vm._l((_vm.baseDataRecords.MeetingSystem), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.medicalFieldArr = [''];
        _vm.teamFieldArr = [''];
        _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.departId),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "departId", $$v)
      },
      expression: "searchMainData.departId"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部部门"
    }
  }), _vm._v(" "), _vm._l((_vm.baseDataRecords.Depart), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.teamFieldArr = [''];
        _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.medicalFieldArr),
      callback: function($$v) {
        _vm.medicalFieldArr = $$v
      },
      expression: "medicalFieldArr"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部Franchise/DA"
    }
  }), _vm._v(" "), _vm._l((_vm.getMedicalFieldArray(_vm.searchMainData.departId, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.teamFieldArr),
      callback: function($$v) {
        _vm.teamFieldArr = $$v
      },
      expression: "teamFieldArr"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部团队"
    }
  }), _vm._v(" "), _vm._l((_vm.getTeamArray(_vm.searchMainData.departId, _vm.medicalFieldArr, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择（可搜索）"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.productIdArr),
      callback: function($$v) {
        _vm.productIdArr = $$v
      },
      expression: "productIdArr"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部产品"
    }
  }), _vm._v(" "), _vm._l((_vm.baseDataRecords.Product), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.productName
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "search-content-main-fields"
  }, [_c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    staticStyle: {
      "width": "0.94rem"
    },
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择（可搜索）"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.costCenterArr),
      callback: function($$v) {
        _vm.costCenterArr = $$v
      },
      expression: "costCenterArr"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部成本中心"
    }
  }), _vm._v(" "), _vm._l((_vm.baseDataRecords.CostCenter), function(item) {
    return _c('el-option', {
      key: item.costId,
      attrs: {
        "value": item.costId,
        "label": item.costId
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    staticStyle: {
      "width": "0.94rem"
    },
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择（可搜索）"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.wbsCodeArr),
      callback: function($$v) {
        _vm.wbsCodeArr = $$v
      },
      expression: "wbsCodeArr"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部WBS code"
    }
  }), _vm._v(" "), _vm._l((_vm.baseDataRecords.WbsCode), function(item) {
    return _c('el-option', {
      key: item.costId,
      attrs: {
        "value": item.costId,
        "label": item.costId
      }
    })
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "charts-row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.onlyBudgetPlan),
      expression: "!onlyBudgetPlan"
    }],
    staticClass: "chart chart-small"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "axis-label"
  }, [_c('span', {
    staticClass: "axis-label-0"
  }, [_vm._v("0")]), _vm._v(" "), _c('span', {
    staticClass: "axis-label-100"
  }, [_vm._v("100%")]), _vm._v(" "), _c('span', {
    staticClass: "axis-label-remain"
  }, [_vm._v(_vm._s(_vm.data1Remain + '%'))])]), _vm._v(" "), _c('div', [_c('common-echars', {
    ref: "chart1",
    attrs: {
      "chartClass": "chart-class-1",
      "dataset-dimensions": ['已分配预算'],
      "dataset-source": _vm.data1,
      "option": _vm.option1
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "message-info"
  }, [_c('div', [_c('div', {
    staticClass: "message-info-total"
  }, [_vm._v("年度总预算：" + _vm._s(_vm._f("MoneyFormat")(_vm._f("ThousandMoneyFormat")(_vm.data1[0] ? _vm.data1[0].YearBudgetMainSum : 0))) + " K")]), _vm._v(" "), _c('div', {
    staticClass: "message-info-remain"
  }, [_vm._v("已分配预算：" + _vm._s(_vm._f("MoneyFormat")(_vm._f("ThousandMoneyFormat")(_vm.data1[0] ? _vm.data1[0].YearBudgetDetailSum : 0))) + " K")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chart",
    class: !_vm.onlyBudgetPlan ? 'chart-small' : 'chart-small-long2'
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "axis-label",
    class: !_vm.onlyBudgetPlan ? '' : 'axis-label-long'
  }, [_c('span', {
    staticClass: "axis-label-0"
  }, [_vm._v("0")]), _vm._v(" "), _c('span', {
    staticClass: "axis-label-100"
  }, [_vm._v("100%")]), _vm._v(" "), _c('span', {
    staticClass: "axis-label-remain"
  }, [_vm._v(_vm._s(_vm.data2Remain + '%'))])]), _vm._v(" "), _c('div', [_c('common-echars', {
    ref: "chart2",
    attrs: {
      "chartClass": "chart-class-2",
      "dataset-dimensions": ['已分配预算'],
      "dataset-source": _vm.data2,
      "option": _vm.option2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "message-info"
  }, [_c('div', [_c('div', {
    staticClass: "message-info-total"
  }, [_vm._v("已分配预算：" + _vm._s(_vm._f("MoneyFormat")(_vm._f("ThousandMoneyFormat")(_vm.data2[0] ? _vm.data2[0].YearBudgetDetailSum : 0))) + " K")]), _vm._v(" "), _c('div', {
    staticClass: "message-info-remain"
  }, [_vm._v("已计划预算：" + _vm._s(_vm._f("MoneyFormat")(_vm._f("ThousandMoneyFormat")(_vm.data2[0] ? _vm.data2[0].YearBudgetPlanSum : 0))) + " K")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chart chart-small-long"
  }, [_vm._m(5), _vm._v(" "), _c('div', [_c('common-echars', {
    ref: "chart3",
    attrs: {
      "chartClass": "chart-class-3",
      "dataset-dimensions": ['进度', '已计划预算', '已执行金额', '待执行预算', '计划外预算'],
      "dataset-source": _vm.data3,
      "option": _vm.option3
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "charts-row"
  }, [_c('div', {
    staticClass: "chart"
  }, [_vm._m(6), _vm._v(" "), _c('div', [_c('common-echars', {
    ref: "chart4",
    attrs: {
      "chartClass": "chart-class-4",
      "dataset-dimensions": ['季度', '已计划', '已执行', '待执行', '计划外', '已分配预算'],
      "dataset-source": _vm.data4,
      "option": _vm.option4
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "chart"
  }, [_vm._m(7), _vm._v(" "), _c('div', [_c('common-echars', {
    ref: "chart5",
    attrs: {
      "chartClass": "chart-class-5",
      "dataset-dimensions": ['月度', '已计划', '已执行', '待执行', '计划外'],
      "dataset-source": _vm.data5,
      "option": _vm.option5
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "page-header-title"
  }, [_vm._v("\n      预算\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "page-header-subinfo"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "iconfont icon-nianduyusuanfenpei"
  }), _vm._v("年度预算分配")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gauge-legend"
  }, [_c('div', {
    staticClass: "gauge-legend-value gauge-legend-value-1"
  }, [_c('div'), _vm._v(" "), _c('span', [_vm._v("已分配预算")])]), _vm._v(" "), _c('div', {
    staticClass: "gauge-legend-value gauge-legend-value-2"
  }, [_c('div'), _vm._v(" "), _c('span', [_vm._v("未分配预算")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "iconfont icon-nianduyusuanjihua"
  }), _vm._v("年度预算计划")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gauge-legend"
  }, [_c('div', {
    staticClass: "gauge-legend-value gauge-legend-value-3"
  }, [_c('div'), _vm._v(" "), _c('span', [_vm._v("已计划预算")])]), _vm._v(" "), _c('div', {
    staticClass: "gauge-legend-value gauge-legend-value-2"
  }, [_c('div'), _vm._v(" "), _c('span', [_vm._v("未计划预算")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "iconfont icon-yusuanjindu"
  }), _vm._v("预算计划与执行进度")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "iconfont icon-jiduqushi"
  }), _vm._v("预算计划与执行季度趋势")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "iconfont icon-yueduqushi"
  }), _vm._v("预算计划与执行月度趋势")])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f8e3b742", module.exports)
  }
}

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-submenu"
  }, [_c('div', {
    staticClass: "page-submenu_left"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('left-bar', {
    attrs: {
      "tab": "3"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-submenu_right"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "search-content"
  }, [_c('div', {
    staticClass: "search-content-fields"
  }, [_c('div', [_c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', [_c('div', {
    staticClass: "col-full"
  }, [_c('el-form-item', {
    attrs: {
      "label": "公告内容"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.searchData.contentCn),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "contentCn", $$v)
      },
      expression: "searchData.contentCn"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "开始展示日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.releaseTime),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "releaseTime", $$v)
      },
      expression: "searchData.releaseTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "停止展示日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.removeTime),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "removeTime", $$v)
      },
      expression: "searchData.removeTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "操作人"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.handleUpdateByFilter,
      "clearable": "",
      "placeholder": "请输入"
    },
    on: {
      "change": function($event) {
        _vm.remoteCreateByData = []
      }
    },
    model: {
      value: (_vm.searchData.createBy),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "createBy", $$v)
      },
      expression: "searchData.createBy"
    }
  }, _vm._l((_vm.remoteCreateByData), function(item) {
    return _c('el-option', {
      key: item.username,
      attrs: {
        "value": item.username,
        "label": item.realname
      }
    }, [_c('span', [_vm._v(_vm._s(item.realname))])])
  }), 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search-btn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("搜索")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', [_c('el-button', {
    staticClass: "batch-download-btn",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handlerExportExcelClick()
      }
    }
  }, [_vm._v("批量导出")]), _vm._v(" "), _c('el-button', {
    staticClass: "batch-delete-btn",
    attrs: {
      "disabled": _vm.selectedData.length <= 0,
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleBatchDeleteClick()
      }
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-button', {
    staticClass: "add-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddNewClick()
      }
    }
  }, [_vm._v("发布公告")])], 1)]), _vm._v(" "), _c('common-crud', {
    ref: "crud",
    attrs: {
      "searchData": _vm.searchData,
      "tableData": _vm.noticeData,
      "addNewOrEditData": _vm.addNewOrEditData,
      "crudApi": _vm.crudApi,
      "showEditFormTitle": false,
      "beforeSave": _vm.beforeSave,
      "selectedDataArray": _vm.selectedData,
      "afterSave": _vm.handleSystemNoticesChange,
      "afterDelete": _vm.handleSystemNoticesChange,
      "addSuccessMessages": "发布系统公告成功",
      "editSuccessMessages": "编辑系统公告成功",
      "deleteSuccessMessages": "删除系统公告成功",
      "deleteBatchSuccessMessages": "批量删除系统公告成功"
    },
    on: {
      "update:tableData": function($event) {
        _vm.noticeData = $event
      },
      "update:table-data": function($event) {
        _vm.noticeData = $event
      },
      "update:selectedDataArray": function($event) {
        _vm.selectedData = $event
      },
      "update:selected-data-array": function($event) {
        _vm.selectedData = $event
      }
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "contentCn",
      "label": "公告内容",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatDateTime2Date,
      "sortable": "",
      "prop": "releaseTime",
      "label": "开始展示日期",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatDateTime2Date,
      "sortable": "",
      "prop": "removeTime",
      "label": "停止展示日期",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatDateTime2Date,
      "sortable": "",
      "prop": "updateTime",
      "label": "操作时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "updateBy",
      "label": "操作人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-column-operate"
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditClick(scope.row)
            }
          }
        }, [_vm._v("\n                    编辑\n                  ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteClick(scope.row)
            }
          }
        }, [_vm._v("\n                    删除\n                  ")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "customTitle"
  }, [_vm._v("公告信息")]), _vm._v(" "), _c('template', {
    slot: "editForm"
  }, [_c('el-row', [_c('div', {
    staticClass: "col-full"
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "公告内容",
      "prop": "contentCn"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "200",
      "type": "textarea",
      "placeholder": "请输入公告内容（建议75个字符以内）"
    },
    model: {
      value: (_vm.addNewOrEditData.contentCn),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "contentCn", $$v)
      },
      expression: "addNewOrEditData.contentCn"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "开始展示日期",
      "prop": "releaseTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "picker-options": _vm.startPickerOptions,
      "type": "date",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.releaseTime),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "releaseTime", $$v)
      },
      expression: "addNewOrEditData.releaseTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "停止展示日期",
      "prop": "removeTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "picker-options": _vm.endPickerOptions,
      "type": "date",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addNewOrEditData.removeTime),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "removeTime", $$v)
      },
      expression: "addNewOrEditData.removeTime"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "confirmAddNewMessage"
  }, [_c('div', [_c('span', [_vm._v("确认发布公告？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmEditMessage"
  }, [_c('div', [_c('span', [_vm._v("确认保存公告？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("删除发布公告？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmBatchDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("批量删除公告？")])])])], 2)], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f99456ea", module.exports)
  }
}

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-meeting"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page-contain"
  }, [_c('div', {
    staticClass: "search-content-main"
  }, [_c('el-form', {
    staticClass: "search-content-main-fields"
  }, [_c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.year),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "year", $$v)
      },
      expression: "searchMainData.year"
    }
  }, _vm._l((_vm.baseDataRecords.Year), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.yearName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.seasonArr),
      callback: function($$v) {
        _vm.seasonArr = $$v
      },
      expression: "seasonArr"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部季度"
    }
  }), _vm._v(" "), _vm._l((4), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "value": item,
        "label": '第' + item + '季'
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.monthArr),
      callback: function($$v) {
        _vm.monthArr = $$v
      },
      expression: "monthArr"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部月份"
    }
  }), _vm._v(" "), _vm._l((12), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "value": item,
        "label": item + '月'
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.meetingSystem),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "meetingSystem", $$v)
      },
      expression: "searchMainData.meetingSystem"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部系统"
    }
  }), _vm._v(" "), _vm._l((_vm.baseDataRecords.MeetingSystem), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.medicalFieldArr = [''];
        _vm.teamFieldArr = [''];
        _vm.strategyKeynoteArr = [''];
        _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.departId),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "departId", $$v)
      },
      expression: "searchMainData.departId"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部部门"
    }
  }), _vm._v(" "), _vm._l((_vm.baseDataRecords.Depart), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.teamFieldArr = [''];
        _vm.strategyKeynoteArr = [''];
        _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.medicalFieldArr),
      callback: function($$v) {
        _vm.medicalFieldArr = $$v
      },
      expression: "medicalFieldArr"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部Franchise/DA"
    }
  }), _vm._v(" "), _vm._l((_vm.getMedicalFieldArray(_vm.searchMainData.departId, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.teamFieldArr),
      callback: function($$v) {
        _vm.teamFieldArr = $$v
      },
      expression: "teamFieldArr"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部团队"
    }
  }), _vm._v(" "), _vm._l((_vm.getTeamArray(_vm.searchMainData.departId, _vm.medicalFieldArr, true)), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.teamName
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "search-content-main-fields"
  }, [_c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "multiple": "",
      "filterable": "",
      "placeholder": "请选择（可搜索）"
    },
    on: {
      "change": function($event) {
        _vm.strategyKeynoteArr = [''];
        _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.productIdArr),
      callback: function($$v) {
        _vm.productIdArr = $$v
      },
      expression: "productIdArr"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部产品"
    }
  }), _vm._v(" "), _vm._l((_vm.baseDataRecords.Product), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.productName
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "multiple": "",
      "filterable": "",
      "placeholder": "请选择（可搜索）"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.strategyKeynoteArr),
      callback: function($$v) {
        _vm.strategyKeynoteArr = $$v
      },
      expression: "strategyKeynoteArr"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部策略重点"
    }
  }), _vm._v(" "), _vm._l((_vm.filterStrategy), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.keynote
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.meetingModality),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "meetingModality", $$v)
      },
      expression: "searchMainData.meetingModality"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部会议形式"
    }
  }), _vm._v(" "), _vm._l((_vm.baseDataRecords.MeetingModality), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.searchMainData.meetingType = '';
        _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.meetingProp),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "meetingProp", $$v)
      },
      expression: "searchMainData.meetingProp"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部会议性质"
    }
  }), _vm._v(" "), _vm._l((_vm.meetingPropAndTypeArrays.selectMeetingProp), function(item) {
    return _c('el-option', {
      key: item.itemValue,
      attrs: {
        "value": item.itemValue,
        "label": item.itemText
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.meetingType),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "meetingType", $$v)
      },
      expression: "searchMainData.meetingType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部A1会议类型"
    }
  }), _vm._v(" "), _vm._l((_vm.filterMeetingType), function(item) {
    return _c('el-option', {
      key: item.itemValue,
      attrs: {
        "value": item.itemValue,
        "label": item.itemText
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.meetingGsdType),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "meetingGsdType", $$v)
      },
      expression: "searchMainData.meetingGsdType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部GSD项目类型"
    }
  }), _vm._v(" "), _vm._l((_vm.baseDataRecords.MeetingGsdType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "search-content-main-fields",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.handleMainSearch()
      }
    },
    model: {
      value: (_vm.searchMainData.meetingGsdSubType),
      callback: function($$v) {
        _vm.$set(_vm.searchMainData, "meetingGsdSubType", $$v)
      },
      expression: "searchMainData.meetingGsdSubType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "全部GSD细项"
    }
  }), _vm._v(" "), _vm._l((_vm.MeetingGsdSubTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "value": item.value,
        "label": item.text
      }
    })
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search-content-other"
  }, [_c('div', {
    staticClass: "search-content-other-rate-types"
  }, [_c('div', {
    staticClass: "search-content-other-rate-types-item",
    class: _vm.searchMainData.planRateType == '1' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.searchMainData.planRateType = '1';
        _vm.handleMainSearch()
      }
    }
  }, [_vm._v("策略重点")]), _vm._v(" "), _c('div', {
    staticClass: "search-content-other-rate-types-item",
    class: _vm.searchMainData.planRateType == '2' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.searchMainData.planRateType = '2';
        _vm.handleMainSearch()
      }
    }
  }, [_vm._v("会议形式")]), _vm._v(" "), _c('div', {
    staticClass: "search-content-other-rate-types-item",
    class: _vm.searchMainData.planRateType == '3' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.searchMainData.planRateType = '3';
        _vm.handleMainSearch()
      }
    }
  }, [_vm._v("会议类型")])]), _vm._v(" "), _c('div', {
    staticClass: "search-content-other-distribute-types"
  }, [_c('div', {
    staticClass: "search-content-other-distribute-types-item",
    class: _vm.searchMainData.distributeType == '1' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.searchMainData.distributeType = '1';
        _vm.handleMainSearch()
      }
    }
  }, [_vm._v("场次")]), _vm._v(" "), _c('div', {
    staticClass: "search-content-other-distribute-types-item",
    class: _vm.searchMainData.distributeType == '2' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.searchMainData.distributeType = '2';
        _vm.handleMainSearch()
      }
    }
  }, [_vm._v("预算")])])]), _vm._v(" "), _c('div', {
    staticClass: "charts-row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchMainData.planRateType == '1'),
      expression: "searchMainData.planRateType == '1'"
    }],
    staticClass: "chart"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('common-echars', {
    ref: "chart1",
    attrs: {
      "chartClass": "chart-class-1",
      "dataset-dimensions": ['类型', '占比'],
      "dataset-source": _vm.data1,
      "option": _vm.option1
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchMainData.planRateType != '1'),
      expression: "searchMainData.planRateType != '1'"
    }],
    staticClass: "chart"
  }, [_vm._m(2), _vm._v(" "), _c('div', [_c('common-echars', {
    ref: "chart2",
    attrs: {
      "chartClass": "chart-class-2",
      "dataset-dimensions": ['类型', '占比'],
      "dataset-source": _vm.data2,
      "option": _vm.option2
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "chart chart-right"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "iconfont",
    class: _vm.searchMainData.planRateType == '1' ? 'icon-celvezhihangjindu' : 'icon-huiyizhihangjindu'
  }), _vm._v(_vm._s(_vm.searchMainData.planRateType == '1' ? '策略' : '会议') + "执行进度")]), _vm._v(" "), _c('div', [_c('common-echars', {
    ref: "chart3",
    attrs: {
      "chartClass": "chart-class-3",
      "dataset-dimensions": _vm.dimensions3,
      "dataset-source": _vm.data3,
      "option": _vm.option3
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "charts-row"
  }, [_c('div', {
    staticClass: "search-content-trend"
  }, [_c('div', {
    staticClass: "search-content-trend-item",
    class: _vm.searchMainData.selectMeetingStatus == '1' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.searchMainData.selectMeetingStatus = '1';
        _vm.handleMainSearch(true)
      }
    }
  }, [_vm._v("\n          已计划\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "search-content-trend-item",
    class: _vm.searchMainData.selectMeetingStatus == '3' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.searchMainData.selectMeetingStatus = '3';
        _vm.handleMainSearch(true)
      }
    }
  }, [_vm._v("\n          已执行\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "search-content-trend-item",
    class: _vm.searchMainData.selectMeetingStatus == '2' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.searchMainData.selectMeetingStatus = '2';
        _vm.handleMainSearch(true)
      }
    }
  }, [_vm._v("\n          待执行\n        ")]), _vm._v(" "), (_vm.searchMainData.planRateType != '1') ? _c('div', {
    staticClass: "search-content-trend-item",
    class: _vm.searchMainData.selectMeetingStatus == '4' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.searchMainData.selectMeetingStatus = '4';
        _vm.handleMainSearch(true)
      }
    }
  }, [_vm._v("\n          计划外\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "chart chart-full"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "iconfont",
    class: _vm.searchMainData.planRateType == '1' ? 'icon-celveyueduqushi' : 'icon-huiyiyueduqushi'
  }), _vm._v(_vm._s(_vm.searchMainData.planRateType == '1' ? '策略' : '会议') + "月度趋势")]), _vm._v(" "), _c('div', [_c('common-echars', {
    ref: "chart4",
    attrs: {
      "chartClass": "chart-class-4",
      "dataset-dimensions": _vm.dimensions4,
      "dataset-source": _vm.source4,
      "option": _vm.option4
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "page-header-title"
  }, [_vm._v("\n      会议\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "page-header-subinfo"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "iconfont icon-celvejihuazhanbi"
  }), _vm._v("策略计划占比")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "iconfont icon-huiyijihuazhanbi"
  }), _vm._v("会议计划占比")])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fc17aeaa", module.exports)
  }
}

/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
  * vue-router v3.5.1
  * (c) 2021 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if ("prod" !== 'production' && !condition) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
    .replace(encodeReserveRE, encodeReserveReplacer)
    .replace(commaRE, ','); };

function decode (str) {
  try {
    return decodeURIComponent(str)
  } catch (err) {
    if (true) {
      warn(false, ("Error decoding \"" + str + "\". Leaving it intact."));
    }
  }
  return str
}

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "prod" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    var value = extraQuery[key];
    parsedQuery[key] = Array.isArray(value)
      ? value.map(castQueryParamValue)
      : castQueryParamValue(value);
  }
  return parsedQuery
}

var castQueryParamValue = function (value) { return (value == null || typeof value === 'object' ? value : String(value)); };

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0 ? decode(parts.join('=')) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj
    ? Object.keys(obj)
      .map(function (key) {
        var val = obj[key];

        if (val === undefined) {
          return ''
        }

        if (val === null) {
          return encode(key)
        }

        if (Array.isArray(val)) {
          var result = [];
          val.forEach(function (val2) {
            if (val2 === undefined) {
              return
            }
            if (val2 === null) {
              result.push(encode(key));
            } else {
              result.push(encode(key) + '=' + encode(val2));
            }
          });
          return result.join('&')
        }

        return encode(key) + '=' + encode(val)
      })
      .filter(function (x) { return x.length > 0; })
      .join('&')
    : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b, onlyPath) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') && (onlyPath ||
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query))
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      (onlyPath || (
        a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params))
      )
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a).sort();
  var bKeys = Object.keys(b).sort();
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key, i) {
    var aVal = a[key];
    var bKey = bKeys[i];
    if (bKey !== key) { return false }
    var bVal = b[key];
    // query values can be null and undefined
    if (aVal == null || bVal == null) { return aVal === bVal }
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

function handleRouteEntered (route) {
  for (var i = 0; i < route.matched.length; i++) {
    var record = route.matched[i];
    for (var name in record.instances) {
      var instance = record.instances[name];
      var cbs = record.enteredCbs[name];
      if (!instance || !cbs) { continue }
      delete record.enteredCbs[name];
      for (var i$1 = 0; i$1 < cbs.length; i$1++) {
        if (!instance._isBeingDestroyed) { cbs[i$1](instance); }
      }
    }
  }
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode ? parent.$vnode.data : {};
      if (vnodeData.routerView) {
        depth++;
      }
      if (vnodeData.keepAlive && parent._directInactive && parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      var cachedData = cache[name];
      var cachedComponent = cachedData && cachedData.component;
      if (cachedComponent) {
        // #2301
        // pass props
        if (cachedData.configProps) {
          fillPropsinData(cachedComponent, data, cachedData.route, cachedData.configProps);
        }
        return h(cachedComponent, data, children)
      } else {
        // render previous empty view
        return h()
      }
    }

    var matched = route.matched[depth];
    var component = matched && matched.components[name];

    // render empty node if no matched route or no config component
    if (!matched || !component) {
      cache[name] = null;
      return h()
    }

    // cache component
    cache[name] = { component: component };

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive &&
        vnode.componentInstance &&
        vnode.componentInstance !== matched.instances[name]
      ) {
        matched.instances[name] = vnode.componentInstance;
      }

      // if the route transition has already been confirmed then we weren't
      // able to call the cbs during confirmation as the component was not
      // registered yet, so we call it here.
      handleRouteEntered(route);
    };

    var configProps = matched.props && matched.props[name];
    // save route and configProps in cache
    if (configProps) {
      extend(cache[name], {
        route: route,
        configProps: configProps
      });
      fillPropsinData(component, data, route, configProps);
    }

    return h(component, data, children)
  }
};

function fillPropsinData (component, data, route, configProps) {
  // resolve props
  var propsToPass = data.props = resolveProps(route, configProps);
  if (propsToPass) {
    // clone to prevent mutation
    propsToPass = data.props = extend({}, propsToPass);
    // pass non-declared props as attrs
    var attrs = data.attrs = data.attrs || {};
    for (var key in propsToPass) {
      if (!component.props || !(key in component.props)) {
        attrs[key] = propsToPass[key];
        delete propsToPass[key];
      }
    }
  }
}

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (true) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  params = params || {};
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    // and fix #3106 so that you can work with location descriptor object having params.pathMatch equal to empty string
    if (typeof params.pathMatch === 'string') { params[0] = params.pathMatch; }

    return filler(params, { pretty: true })
  } catch (e) {
    if (true) {
      // Fix #3072 no warn if `pathMatch` is string
      warn(typeof params.pathMatch === 'string', ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next
  } else if (next.name) {
    next = extend({}, raw);
    var params = next.params;
    if (params && typeof params === 'object') {
      next.params = extend({}, params);
    }
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params$1 = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params$1;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params$1, ("path " + (current.path)));
    } else if (true) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var noop = function () {};

var warnedCustomSlot;
var warnedTagProp;
var warnedEventProp;

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    custom: Boolean,
    exact: Boolean,
    exactPath: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    ariaCurrentValue: {
      type: String,
      default: 'page'
    },
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(
      this.to,
      current,
      this.append
    );
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback =
      globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback =
      globalExactActiveClass == null
        ? 'router-link-exact-active'
        : globalExactActiveClass;
    var activeClass =
      this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass =
      this.exactActiveClass == null
        ? exactActiveClassFallback
        : this.exactActiveClass;

    var compareTarget = route.redirectedFrom
      ? createRoute(null, normalizeLocation(route.redirectedFrom), null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget, this.exactPath);
    classes[activeClass] = this.exact || this.exactPath
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var ariaCurrentValue = classes[exactActiveClass] ? this.ariaCurrentValue : null;

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location, noop);
        } else {
          router.push(location, noop);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = { class: classes };

    var scopedSlot =
      !this.$scopedSlots.$hasNormal &&
      this.$scopedSlots.default &&
      this.$scopedSlots.default({
        href: href,
        route: route,
        navigate: handler,
        isActive: classes[activeClass],
        isExactActive: classes[exactActiveClass]
      });

    if (scopedSlot) {
      if ("prod" !== 'production' && !this.custom) {
        !warnedCustomSlot && warn(false, 'In Vue Router 4, the v-slot API will by default wrap its content with an <a> element. Use the custom prop to remove this warning:\n<router-link v-slot="{ navigate, href }" custom></router-link>\n');
        warnedCustomSlot = true;
      }
      if (scopedSlot.length === 1) {
        return scopedSlot[0]
      } else if (scopedSlot.length > 1 || !scopedSlot.length) {
        if (true) {
          warn(
            false,
            ("<router-link> with to=\"" + (this.to) + "\" is trying to use a scoped slot but it didn't provide exactly one child. Wrapping the content with a span element.")
          );
        }
        return scopedSlot.length === 0 ? h() : h('span', {}, scopedSlot)
      }
    }

    if (true) {
      if ('tag' in this.$options.propsData && !warnedTagProp) {
        warn(
          false,
          "<router-link>'s tag prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedTagProp = true;
      }
      if ('event' in this.$options.propsData && !warnedEventProp) {
        warn(
          false,
          "<router-link>'s event prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedEventProp = true;
      }
    }

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href, 'aria-current': ariaCurrentValue };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = (a.data = extend({}, a.data));
        aData.on = aData.on || {};
        // transform existing events in both objects into arrays so we can push later
        for (var event in aData.on) {
          var handler$1 = aData.on[event];
          if (event in on) {
            aData.on[event] = Array.isArray(handler$1) ? handler$1 : [handler$1];
          }
        }
        // append new listeners for router-link
        for (var event$1 in on) {
          if (event$1 in aData.on) {
            // on[event] is always a function
            aData.on[event$1].push(on[event$1]);
          } else {
            aData.on[event$1] = handler;
          }
        }

        var aAttrs = (a.data.attrs = extend({}, a.data.attrs));
        aAttrs.href = href;
        aAttrs['aria-current'] = ariaCurrentValue;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap,
  parentRoute
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route, parentRoute);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  if (false) {
    // warn if routes do not include leading slashes
    var found = pathList
    // check for missing leading slash
      .filter(function (path) { return path && path.charAt(0) !== '*' && path.charAt(0) !== '/'; });

    if (found.length > 0) {
      var pathNames = found.map(function (path) { return ("- " + path); }).join('\n');
      warn(false, ("Non-nested routes must include a leading slash character. Fix the following routes: \n" + pathNames));
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (true) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(
        path || name
      )) + " cannot be a " + "string id. Use an actual component instead."
    );

    warn(
      // eslint-disable-next-line no-control-regex
      !/[^\u0000-\u007F]+/.test(path),
      "Route with path \"" + path + "\" contains unencoded characters, make sure " +
        "your path is correctly encoded before passing it to the router. Use " +
        "encodeURI to encode static segments of your path."
    );
  }

  var pathToRegexpOptions =
    route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    alias: route.alias
      ? typeof route.alias === 'string'
        ? [route.alias]
        : route.alias
      : [],
    instances: {},
    enteredCbs: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props:
      route.props == null
        ? {}
        : route.components
          ? route.props
          : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (true) {
      if (
        route.name &&
        !route.redirect &&
        route.children.some(function (child) { return /^\/?$/.test(child.path); })
      ) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
            "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
            "the default child route will not be rendered. Remove the name from " +
            "this route and use the name of the default child route for named " +
            "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if ("prod" !== 'production' && alias === path) {
        warn(
          false,
          ("Found an alias with the same value as the path: \"" + path + "\". You have to remove that alias. It will be ignored in development.")
        );
        // skip in dev to make it work
        continue
      }

      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    }
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if ("prod" !== 'production' && !matchAs) {
      warn(
        false,
        "Duplicate named routes definition: " +
          "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (
  path,
  pathToRegexpOptions
) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (true) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(
        !keys[key.name],
        ("Duplicate param keys in route with path: \"" + path + "\"")
      );
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (
  path,
  parent,
  strict
) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function addRoute (parentOrRoute, route) {
    var parent = (typeof parentOrRoute !== 'object') ? nameMap[parentOrRoute] : undefined;
    // $flow-disable-line
    createRouteMap([route || parentOrRoute], pathList, pathMap, nameMap, parent);

    // add aliases of parent
    if (parent) {
      createRouteMap(
        // $flow-disable-line route is defined if parent is
        parent.alias.map(function (alias) { return ({ path: alias, children: [route] }); }),
        pathList,
        pathMap,
        nameMap,
        parent
      );
    }
  }

  function getRoutes () {
    return pathList.map(function (path) { return pathMap[path]; })
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (true) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
      return _createRoute(record, location, redirectedFrom)
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (true) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (true) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (true) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoute: addRoute,
    getRoutes: getRoutes,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = typeof m[i] === 'string' ? decode(m[i]) : m[i];
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

// use User Timing api (if present) for more accurate key precision
var Time =
  inBrowser && window.performance && window.performance.now
    ? window.performance
    : Date;

function genStateKey () {
  return Time.now().toFixed(3)
}

var _key = genStateKey();

function getStateKey () {
  return _key
}

function setStateKey (key) {
  return (_key = key)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Prevent browser scroll behavior on History popstate
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  // preserve existing history state as it could be overriden by the user
  var stateCopy = extend({}, window.history.state);
  stateCopy.key = getStateKey();
  window.history.replaceState(stateCopy, '', absolutePath);
  window.addEventListener('popstate', handlePopState);
  return function () {
    window.removeEventListener('popstate', handlePopState);
  }
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (true) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(
      router,
      to,
      from,
      isPop ? position : null
    );

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll
        .then(function (shouldScroll) {
          scrollToPosition((shouldScroll), position);
        })
        .catch(function (err) {
          if (true) {
            assert(false, err.toString());
          }
        });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function handlePopState (e) {
  saveScrollPosition();
  if (e.state && e.state.key) {
    setStateKey(e.state.key);
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

var hashStartsWithNumberRE = /^#\d/;

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    // getElementById would still fail if the selector contains a more complicated query like #main[data-attr]
    // but at the same time, it doesn't make much sense to select an element with an id and an extra selector
    var el = hashStartsWithNumberRE.test(shouldScroll.selector) // $flow-disable-line
      ? document.getElementById(shouldScroll.selector.slice(1)) // $flow-disable-line
      : document.querySelector(shouldScroll.selector);

    if (el) {
      var offset =
        shouldScroll.offset && typeof shouldScroll.offset === 'object'
          ? shouldScroll.offset
          : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    // $flow-disable-line
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({
        left: position.x,
        top: position.y,
        // $flow-disable-line
        behavior: shouldScroll.behavior
      });
    } else {
      window.scrollTo(position.x, position.y);
    }
  }
}

/*  */

var supportsPushState =
  inBrowser &&
  (function () {
    var ua = window.navigator.userAgent;

    if (
      (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
      ua.indexOf('Mobile Safari') !== -1 &&
      ua.indexOf('Chrome') === -1 &&
      ua.indexOf('Windows Phone') === -1
    ) {
      return false
    }

    return window.history && typeof window.history.pushState === 'function'
  })();

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      // preserve existing history state as it could be overriden by the user
      var stateCopy = extend({}, history.state);
      stateCopy.key = getStateKey();
      history.replaceState(stateCopy, '', url);
    } else {
      history.pushState({ key: setStateKey(genStateKey()) }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

// When changing thing, also edit router.d.ts
var NavigationFailureType = {
  redirected: 2,
  aborted: 4,
  cancelled: 8,
  duplicated: 16
};

function createNavigationRedirectedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.redirected,
    ("Redirected when going from \"" + (from.fullPath) + "\" to \"" + (stringifyRoute(
      to
    )) + "\" via a navigation guard.")
  )
}

function createNavigationDuplicatedError (from, to) {
  var error = createRouterError(
    from,
    to,
    NavigationFailureType.duplicated,
    ("Avoided redundant navigation to current location: \"" + (from.fullPath) + "\".")
  );
  // backwards compatible with the first introduction of Errors
  error.name = 'NavigationDuplicated';
  return error
}

function createNavigationCancelledError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.cancelled,
    ("Navigation cancelled from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" with a new navigation.")
  )
}

function createNavigationAbortedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.aborted,
    ("Navigation aborted from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" via a navigation guard.")
  )
}

function createRouterError (from, to, type, message) {
  var error = new Error(message);
  error._isRouter = true;
  error.from = from;
  error.to = to;
  error.type = type;

  return error
}

var propertiesToLog = ['params', 'query', 'hash'];

function stringifyRoute (to) {
  if (typeof to === 'string') { return to }
  if ('path' in to) { return to.path }
  var location = {};
  propertiesToLog.forEach(function (key) {
    if (key in to) { location[key] = to[key]; }
  });
  return JSON.stringify(location, null, 2)
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function isNavigationFailure (err, errorType) {
  return (
    isError(err) &&
    err._isRouter &&
    (errorType == null || err.type === errorType)
  )
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "prod" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
  this.listeners = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (
  location,
  onComplete,
  onAbort
) {
    var this$1 = this;

  var route;
  // catch redirect option https://github.com/vuejs/vue-router/issues/3201
  try {
    route = this.router.match(location, this.current);
  } catch (e) {
    this.errorCbs.forEach(function (cb) {
      cb(e);
    });
    // Exception should still be thrown
    throw e
  }
  var prev = this.current;
  this.confirmTransition(
    route,
    function () {
      this$1.updateRoute(route);
      onComplete && onComplete(route);
      this$1.ensureURL();
      this$1.router.afterHooks.forEach(function (hook) {
        hook && hook(route, prev);
      });

      // fire ready cbs once
      if (!this$1.ready) {
        this$1.ready = true;
        this$1.readyCbs.forEach(function (cb) {
          cb(route);
        });
      }
    },
    function (err) {
      if (onAbort) {
        onAbort(err);
      }
      if (err && !this$1.ready) {
        // Initial redirection should not mark the history as ready yet
        // because it's triggered by the redirection instead
        // https://github.com/vuejs/vue-router/issues/3225
        // https://github.com/vuejs/vue-router/issues/3331
        if (!isNavigationFailure(err, NavigationFailureType.redirected) || prev !== START) {
          this$1.ready = true;
          this$1.readyErrorCbs.forEach(function (cb) {
            cb(err);
          });
        }
      }
    }
  );
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  this.pending = route;
  var abort = function (err) {
    // changed after adding errors with
    // https://github.com/vuejs/vue-router/pull/3047 before that change,
    // redirect and aborted navigation would produce an err == null
    if (!isNavigationFailure(err) && isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  var lastRouteIndex = route.matched.length - 1;
  var lastCurrentIndex = current.matched.length - 1;
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    lastRouteIndex === lastCurrentIndex &&
    route.matched[lastRouteIndex] === current.matched[lastCurrentIndex]
  ) {
    this.ensureURL();
    return abort(createNavigationDuplicatedError(current, route))
  }

  var ref = resolveQueue(
    this.current.matched,
    route.matched
  );
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort(createNavigationCancelledError(current, route))
    }
    try {
      hook(route, current, function (to) {
        if (to === false) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(createNavigationAbortedError(current, route));
        } else if (isError(to)) {
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' &&
            (typeof to.path === 'string' || typeof to.name === 'string'))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort(createNavigationRedirectedError(current, route));
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort(createNavigationCancelledError(current, route))
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          handleRouteEntered(route);
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  this.current = route;
  this.cb && this.cb(route);
};

History.prototype.setupListeners = function setupListeners () {
  // Default implementation is empty
};

History.prototype.teardown = function teardown () {
  // clean up event listeners
  // https://github.com/vuejs/vue-router/issues/2341
  this.listeners.forEach(function (cleanupListener) {
    cleanupListener();
  });
  this.listeners = [];

  // reset current history route
  // https://github.com/vuejs/vue-router/issues/3294
  this.current = START;
  this.pending = null;
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated
) {
  return extractGuards(
    activated,
    'beforeRouteEnter',
    function (guard, _, match, key) {
      return bindEnterGuard(guard, match, key)
    }
  )
}

function bindEnterGuard (
  guard,
  match,
  key
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        if (!match.enteredCbs[key]) {
          match.enteredCbs[key] = [];
        }
        match.enteredCbs[key].push(cb);
      }
      next(cb);
    })
  }
}

/*  */

var HTML5History = /*@__PURE__*/(function (History) {
  function HTML5History (router, base) {
    History.call(this, router, base);

    this._startLocation = getLocation(this.base);
  }

  if ( History ) HTML5History.__proto__ = History;
  HTML5History.prototype = Object.create( History && History.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === this$1._startLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    };
    window.addEventListener('popstate', handleRoutingEvent);
    this.listeners.push(function () {
      window.removeEventListener('popstate', handleRoutingEvent);
    });
  };

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.toLowerCase().indexOf(base.toLowerCase()) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = /*@__PURE__*/(function (History) {
  function HashHistory (router, base, fallback) {
    History.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History ) HashHistory.__proto__ = History;
  HashHistory.prototype = Object.create( History && History.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    };
    var eventType = supportsPushState ? 'popstate' : 'hashchange';
    window.addEventListener(
      eventType,
      handleRoutingEvent
    );
    this.listeners.push(function () {
      window.removeEventListener(eventType, handleRoutingEvent);
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        pushHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        replaceHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) { return '' }

  href = href.slice(index + 1);

  return href
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/(function (History) {
  function AbstractHistory (router, base) {
    History.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History ) AbstractHistory.__proto__ = History;
  AbstractHistory.prototype = Object.create( History && History.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
        this$1.index++;
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(
      route,
      function () {
        var prev = this$1.current;
        this$1.index = targetIndex;
        this$1.updateRoute(route);
        this$1.router.afterHooks.forEach(function (hook) {
          hook && hook(route, prev);
        });
      },
      function (err) {
        if (isNavigationFailure(err, NavigationFailureType.duplicated)) {
          this$1.index = targetIndex;
        }
      }
    );
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback =
    mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (true) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (raw, current, redirectedFrom) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "prod" !== 'production' &&
    assert(
      install.installed,
      "not installed. Make sure to call `Vue.use(VueRouter)` " +
        "before creating root instance."
    );

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1.apps.indexOf(app);
    if (index > -1) { this$1.apps.splice(index, 1); }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1.app === app) { this$1.app = this$1.apps[0] || null; }

    if (!this$1.app) { this$1.history.teardown(); }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History || history instanceof HashHistory) {
    var handleInitialScroll = function (routeOrError) {
      var from = history.current;
      var expectScroll = this$1.options.scrollBehavior;
      var supportsScroll = supportsPushState && expectScroll;

      if (supportsScroll && 'fullPath' in routeOrError) {
        handleScroll(this$1, routeOrError, from, false);
      }
    };
    var setupListeners = function (routeOrError) {
      history.setupListeners();
      handleInitialScroll(routeOrError);
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupListeners,
      setupListeners
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.push(location, resolve, reject);
    })
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.replace(location, resolve, reject);
    })
  } else {
    this.history.replace(location, onComplete, onAbort);
  }
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply(
    [],
    route.matched.map(function (m) {
      return Object.keys(m.components).map(function (key) {
        return m.components[key]
      })
    })
  )
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  current = current || this.history.current;
  var location = normalizeLocation(to, current, append, this);
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.getRoutes = function getRoutes () {
  return this.matcher.getRoutes()
};

VueRouter.prototype.addRoute = function addRoute (parentOrRoute, route) {
  this.matcher.addRoute(parentOrRoute, route);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  if (true) {
    warn(false, 'router.addRoutes() is deprecated and has been removed in Vue Router 4. Use router.addRoute() instead.');
  }
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.5.1';
VueRouter.isNavigationFailure = isNavigationFailure;
VueRouter.NavigationFailureType = NavigationFailureType;
VueRouter.START_LOCATION = START;

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1008);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("0b680de0", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-00377641\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ErrorSection.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-00377641\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ErrorSection.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1009);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("3a4c65c1", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0318f77e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SingleUpload.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0318f77e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SingleUpload.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1010);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("3edb61c4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-04a6ca76\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-04a6ca76\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1011);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("c5068f6c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-04a6ca76\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-04a6ca76\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1012);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("beb2a0a4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-05e82cb6\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-05e82cb6\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1013);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("1c77d6c7", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-07c4f24c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-07c4f24c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1014);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("34fdcce1", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0bd5cfca\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0bd5cfca\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1015);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("4f053aee", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1375c92a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1375c92a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1016);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("96b93904", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1aae7a60\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1aae7a60\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1017);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("cfa18f3e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-21495f3c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-21495f3c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1018);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("0d1efd47", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-22555b23\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-22555b23\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1019);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("70424cc1", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-25be9594\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-25be9594\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1020);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("2cbd7f5e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-30cf0563\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Loading.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-30cf0563\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Loading.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1021);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("abe3b57c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-31f2929d\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-31f2929d\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1022);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("68610fcc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3240deb5\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3240deb5\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1023);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("e775026e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-33b09976\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-33b09976\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1024);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("3deec4f2", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-351a0cf9\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Message.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-351a0cf9\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Message.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1025);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("52122f79", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3a0a285a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PDFViewer.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3a0a285a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PDFViewer.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1026);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("d8819298", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3a9422a3\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3a9422a3\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1027);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("337d34ae", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3ddf5019\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue", function() {
     var newContent = require("!!../../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3ddf5019\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1028);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("deefc822", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3ddf5019\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3ddf5019\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1029);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("489427c4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3f6fd5ea\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3f6fd5ea\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1030);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("5e25cf67", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-406147de\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ApprovalDialog.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-406147de\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ApprovalDialog.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1031);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("50322ea2", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-415a0751\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-415a0751\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1032);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("232891b9", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-421f5da2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-421f5da2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1033);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("d8db2de2", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-454b3b23\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./roleprivilege.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-454b3b23\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./roleprivilege.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1034);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("25fd6d52", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-45c4bd25\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-45c4bd25\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1035);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("ccb3bed8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4628556a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4628556a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1036);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("13aab6f6", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4a5e30e8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4a5e30e8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1037);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("feaf2160", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4b69d82e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DictSelect.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4b69d82e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DictSelect.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1038);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("2f325903", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4d5edbb1\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CommonScore.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4d5edbb1\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CommonScore.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1039);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("716ffce3", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4e0dfd05\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4e0dfd05\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1040);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("084f0fa3", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4f13d1ac\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4f13d1ac\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1041);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("4c80f58e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-55241215\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-55241215\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1042);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("5ca5a094", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-59f49474\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-59f49474\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1043);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("d9036638", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5a8124dd\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5a8124dd\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1044);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("7a4f4ed4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5ac98730\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5ac98730\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1045);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("5a2b109f", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-60b986d2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-60b986d2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1046);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("161438df", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-648200e0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SelectTree.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-648200e0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SelectTree.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1047);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("e2b43fa0", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-686a6933\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dictitem.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-686a6933\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dictitem.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1048);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("2c4b3972", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6911dd6e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index-old.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6911dd6e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index-old.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1049);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("3dc91a80", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6911dd6e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index-old.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6911dd6e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index-old.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1050);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("435690a6", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6a6df71f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CommonConfirm.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6a6df71f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CommonConfirm.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1051);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("3683b74e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-707e1f82\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Tableau.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-707e1f82\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Tableau.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1052);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("25199d5d", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-75bd0e6f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CommonCrud.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-75bd0e6f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CommonCrud.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1053);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("38993861", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-778fac58\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-778fac58\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1054);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("6c29be49", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-79d0c4be\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-79d0c4be\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1055);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("5bbe2eb6", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7c3e3aee\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CommonEchars.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7c3e3aee\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CommonEchars.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1056);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("381453a6", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7db47407\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FileBox.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7db47407\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FileBox.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1057);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("102c127d", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7f1a157a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7f1a157a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1058);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("33729153", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-81adb67a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-81adb67a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1059);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("41018e82", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-88141bec\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LeftBar.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-88141bec\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LeftBar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1060);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("24181cee", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a103c38a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LeftBar.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a103c38a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LeftBar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1061);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("42755ee5", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a48d6594\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-a48d6594\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1062);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("00a533fc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-acafa2c2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-acafa2c2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1063);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("92078ac2", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ad351d18\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ad351d18\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1064);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("0b9d3b73", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ae5c7cfe\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NoDataFound.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ae5c7cfe\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NoDataFound.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1065);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("16f4e3de", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b41f7a44\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CommonEditor.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b41f7a44\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CommonEditor.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1066);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("76982eed", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b4e872ae\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b4e872ae\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1067);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("69641afc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b96626e6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Dict.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b96626e6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Dict.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1068);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("312be348", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-be6888bc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CNYInput.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-be6888bc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CNYInput.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1069);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("298e6331", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d4c1c57a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d4c1c57a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1070);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("7dc8f5f3", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d4c1c57a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d4c1c57a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1071);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("656e0ff1", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e8ad199e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e8ad199e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1072);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("6fae4daa", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f046f23c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CommonTooltip.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f046f23c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CommonTooltip.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1073);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("6a584947", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f3df5218\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f3df5218\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1074);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("801d0856", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f6034e3e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f6034e3e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1075);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("3f4d913a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f8e3b742\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index-old.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f8e3b742\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index-old.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1076);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("125719e4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f8e3b742\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index-old.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f8e3b742\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index-old.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1077);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("16a47fac", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f99456ea\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f99456ea\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1078);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("10f5d1c4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-fc17aeaa\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index-old.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-fc17aeaa\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index-old.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1079);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("6dc092c8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-fc17aeaa\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index-old.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-fc17aeaa\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/px2rem-loader/index.js?{\"remUnit\":198,\"baseDpr\":1}!../../../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/.pipeline/container/context/git-checkout/src/css/variable.less\",\"/.pipeline/container/context/git-checkout/src/css/common.less\",\"/.pipeline/container/context/git-checkout/src/css/e2e-style.less\",\"/.pipeline/container/context/git-checkout/src/css/el-reset.less\",\"/.pipeline/container/context/git-checkout/src/css/reset.less\"]}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index-old.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1685 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var stringify = function (obj) { return JSON.stringify(obj, null, 2); };
var SessionStorage = /** @class */ (function () {
    function SessionStorage(source, options) {
        var _a, _b, _c, _d, _e, _f;
        this.source = source;
        this.source = source;
        this.defaultValue = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.defaultValue, (_b !== null && _b !== void 0 ? _b : {}));
        this.serialize = (_d = (_c = options) === null || _c === void 0 ? void 0 : _c.serialize, (_d !== null && _d !== void 0 ? _d : stringify));
        this.deserialize = (_f = (_e = options) === null || _e === void 0 ? void 0 : _e.deserialize, (_f !== null && _f !== void 0 ? _f : JSON.parse));
    }
    SessionStorage.prototype.read = function () {
        var data = sessionStorage.getItem(this.source);
        if (!data) {
            sessionStorage.setItem(this.source, this.serialize(this.defaultValue));
            return this.defaultValue;
        }
        return this.deserialize(data);
    };
    SessionStorage.prototype.write = function (data) {
        sessionStorage.setItem(this.source, this.serialize(data));
    };
    return SessionStorage;
}());
/* harmony default export */ __webpack_exports__["a"] = (SessionStorage);


/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DBService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lowdb__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lowdb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lowdb__);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var DBService = /** @class */ (function () {
    function DBService(_name, Adapter) {
        this._name = _name;
        this.ready = this.initialize(Adapter);
    }
    DBService.prototype.initialize = function (Adapter) {
        return __awaiter(this, void 0, void 0, function () {
            var name, adapter, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        name = this._name;
                        adapter = new Adapter(name);
                        _a = this;
                        if (!!("then" in adapter)) return [3 /*break*/, 1];
                        _b = __WEBPACK_IMPORTED_MODULE_0_lowdb___default()(adapter);
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_0_lowdb___default()(adapter)];
                    case 2:
                        _b = _c.sent();
                        _c.label = 3;
                    case 3:
                        _a.db = (_b);
                        return [2 /*return*/];
                }
            });
        });
    };
    DBService.prototype.get = function (key) {
        return this.db.get(key).value();
    };
    DBService.prototype.set = function (key, value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.db.set(key, value).write()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DBService.prototype.unset = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.db.unset(key).write()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return DBService;
}());



/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_defaultsDeep__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_omit__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_pick__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_cloneDeep__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__db__ = __webpack_require__(1687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lowdb_adapters_LocalStorage__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lowdb_adapters_LocalStorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lowdb_adapters_LocalStorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__adapters_SessionStorage__ = __webpack_require__(1686);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







var DEFAULT_NAME = "vuex-along";
var ROOT_KEY = "root";
var VuexAlong = /** @class */ (function () {
    function VuexAlong(_a) {
        var _this = this;
        var local = _a.local, session = _a.session, _b = _a.name, name = _b === void 0 ? DEFAULT_NAME : _b, _c = _a.justSession, justSession = _c === void 0 ? false : _c, adapterOptions = _a.adapterOptions;
        var _d = adapterOptions || {}, _e = _d.local, localAdapter = _e === void 0 ? __WEBPACK_IMPORTED_MODULE_5_lowdb_adapters_LocalStorage___default.a : _e, _f = _d.session, sessionAdapter = _f === void 0 ? __WEBPACK_IMPORTED_MODULE_6__adapters_SessionStorage__["a" /* default */] : _f, 
        // Make sure your adapter is syncing. Then you can get the synchronized state
        _g = _d.sync, 
        // Make sure your adapter is syncing. Then you can get the synchronized state
        sync = _g === void 0 ? true : _g;
        this.local = local;
        this.session = session;
        this.justSession = justSession;
        this.sync = !!((!localAdapter && !sessionAdapter) || sync);
        if (!justSession) {
            this.localDBService = new __WEBPACK_IMPORTED_MODULE_4__db__["a" /* DBService */](name, localAdapter);
        }
        if (session) {
            this.sessionDBService = new __WEBPACK_IMPORTED_MODULE_4__db__["a" /* DBService */](name, sessionAdapter);
        }
        if (window) {
            window.clearVuexAlong = function (local, session) {
                _this.clear(local, session);
            };
        }
    }
    Object.defineProperty(VuexAlong.prototype, "ready", {
        get: function () {
            var _a, _b;
            if (this.sync) {
                return true;
            }
            return Promise.all([
                (_a = this.localDBService) === null || _a === void 0 ? void 0 : _a.ready,
                (_b = this.sessionDBService) === null || _b === void 0 ? void 0 : _b.ready,
            ]);
        },
        enumerable: true,
        configurable: true
    });
    VuexAlong.prototype.saveLocalData = function (state) {
        var _a;
        if (this.justSession) {
            return;
        }
        this._dataHandler(state, (_a = this.local, (_a !== null && _a !== void 0 ? _a : { list: [] })), this.localDBService);
    };
    VuexAlong.prototype.saveSessionData = function (state) {
        var session = this.session;
        if (!session) {
            return;
        }
        this._dataHandler(state, session, this.sessionDBService);
    };
    VuexAlong.prototype._dataHandler = function (state, options, db) {
        var _a;
        if (!db) {
            return;
        }
        var duplicateState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_cloneDeep__["a" /* default */])(state);
        var key = ROOT_KEY;
        var list = options.list, isFilter = options.isFilter;
        if ((_a = list) === null || _a === void 0 ? void 0 : _a.length) {
            duplicateState = isFilter
                ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_omit__["a" /* default */])(duplicateState, list)
                : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_pick__["a" /* default */])(duplicateState, list);
        }
        db.set(key, duplicateState).catch(logger);
    };
    VuexAlong.prototype.saveData = function (state) {
        this.saveLocalData(state);
        this.saveSessionData(state);
    };
    VuexAlong.prototype.restoreData = function (store) {
        var _a, _b;
        var key = ROOT_KEY;
        store.replaceState(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_defaultsDeep__["a" /* default */])((_a = this.sessionDBService) === null || _a === void 0 ? void 0 : _a.get(key), (_b = this.localDBService) === null || _b === void 0 ? void 0 : _b.get(key), store.state));
    };
    VuexAlong.prototype.clear = function (local, session) {
        if (local === void 0) { local = true; }
        if (session === void 0) { session = false; }
        var _a, _b;
        local && ((_a = this.localDBService) === null || _a === void 0 ? void 0 : _a.unset(ROOT_KEY).catch(logger));
        session && ((_b = this.sessionDBService) === null || _b === void 0 ? void 0 : _b.unset(ROOT_KEY).catch(logger));
    };
    return VuexAlong;
}());
/* harmony default export */ __webpack_exports__["a"] = (function (options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var vuexAlong = new VuexAlong(options);
    return function (store) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(vuexAlong.ready !== true)) return [3 /*break*/, 2];
                    return [4 /*yield*/, vuexAlong.ready];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    vuexAlong.restoreData(store);
                    store.subscribe(function (_mutation, state) { return vuexAlong.saveData(state); });
                    return [2 /*return*/];
            }
        });
    }); };
});
// utils
function logger(reason) {
    console.error(reason);
}


/***/ }),
/* 1689 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_vector_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixin_Draggable_js__ = __webpack_require__(1711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_Eventful_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_event_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_GestureMgr_js__ = __webpack_require__(1699);







var SILENT = 'silent';
function makeEventPacket(eveType, targetInfo, event) {
    return {
        type: eveType,
        event: event,
        target: targetInfo.target,
        topTarget: targetInfo.topTarget,
        cancelBubble: false,
        offsetX: event.zrX,
        offsetY: event.zrY,
        gestureEvent: event.gestureEvent,
        pinchX: event.pinchX,
        pinchY: event.pinchY,
        pinchScale: event.pinchScale,
        wheelDelta: event.zrDelta,
        zrByTouch: event.zrByTouch,
        which: event.which,
        stop: stopEvent
    };
}
function stopEvent() {
    __WEBPACK_IMPORTED_MODULE_5__core_event_js__["a" /* stop */](this.event);
}
var EmptyProxy = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(EmptyProxy, _super);
    function EmptyProxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handler = null;
        return _this;
    }
    EmptyProxy.prototype.dispose = function () { };
    EmptyProxy.prototype.setCursor = function () { };
    return EmptyProxy;
}(__WEBPACK_IMPORTED_MODULE_4__core_Eventful_js__["a" /* default */]));
var HoveredResult = (function () {
    function HoveredResult(x, y) {
        this.x = x;
        this.y = y;
    }
    return HoveredResult;
}());
var handlerNames = [
    'click', 'dblclick', 'mousewheel', 'mouseout',
    'mouseup', 'mousedown', 'mousemove', 'contextmenu'
];
var Handler = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Handler, _super);
    function Handler(storage, painter, proxy, painterRoot) {
        var _this = _super.call(this) || this;
        _this._hovered = new HoveredResult(0, 0);
        _this.storage = storage;
        _this.painter = painter;
        _this.painterRoot = painterRoot;
        proxy = proxy || new EmptyProxy();
        _this.proxy = null;
        _this.setHandlerProxy(proxy);
        _this._draggingMgr = new __WEBPACK_IMPORTED_MODULE_3__mixin_Draggable_js__["a" /* default */](_this);
        return _this;
    }
    Handler.prototype.setHandlerProxy = function (proxy) {
        if (this.proxy) {
            this.proxy.dispose();
        }
        if (proxy) {
            __WEBPACK_IMPORTED_MODULE_1__core_util_js__["each"](handlerNames, function (name) {
                proxy.on && proxy.on(name, this[name], this);
            }, this);
            proxy.handler = this;
        }
        this.proxy = proxy;
    };
    Handler.prototype.mousemove = function (event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = isOutsideBoundary(this, x, y);
        var lastHovered = this._hovered;
        var lastHoveredTarget = lastHovered.target;
        if (lastHoveredTarget && !lastHoveredTarget.__zr) {
            lastHovered = this.findHover(lastHovered.x, lastHovered.y);
            lastHoveredTarget = lastHovered.target;
        }
        var hovered = this._hovered = isOutside ? new HoveredResult(x, y) : this.findHover(x, y);
        var hoveredTarget = hovered.target;
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default');
        if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) {
            this.dispatchToElement(lastHovered, 'mouseout', event);
        }
        this.dispatchToElement(hovered, 'mousemove', event);
        if (hoveredTarget && hoveredTarget !== lastHoveredTarget) {
            this.dispatchToElement(hovered, 'mouseover', event);
        }
    };
    Handler.prototype.mouseout = function (event) {
        var eventControl = event.zrEventControl;
        if (eventControl !== 'only_globalout') {
            this.dispatchToElement(this._hovered, 'mouseout', event);
        }
        if (eventControl !== 'no_globalout') {
            this.trigger('globalout', { type: 'globalout', event: event });
        }
    };
    Handler.prototype.resize = function () {
        this._hovered = new HoveredResult(0, 0);
    };
    Handler.prototype.dispatch = function (eventName, eventArgs) {
        var handler = this[eventName];
        handler && handler.call(this, eventArgs);
    };
    Handler.prototype.dispose = function () {
        this.proxy.dispose();
        this.storage = null;
        this.proxy = null;
        this.painter = null;
    };
    Handler.prototype.setCursorStyle = function (cursorStyle) {
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(cursorStyle);
    };
    Handler.prototype.dispatchToElement = function (targetInfo, eventName, event) {
        targetInfo = targetInfo || {};
        var el = targetInfo.target;
        if (el && el.silent) {
            return;
        }
        var eventKey = ('on' + eventName);
        var eventPacket = makeEventPacket(eventName, targetInfo, event);
        while (el) {
            el[eventKey]
                && (eventPacket.cancelBubble = !!el[eventKey].call(el, eventPacket));
            el.trigger(eventName, eventPacket);
            el = el.__hostTarget ? el.__hostTarget : el.parent;
            if (eventPacket.cancelBubble) {
                break;
            }
        }
        if (!eventPacket.cancelBubble) {
            this.trigger(eventName, eventPacket);
            if (this.painter && this.painter.eachOtherLayer) {
                this.painter.eachOtherLayer(function (layer) {
                    if (typeof (layer[eventKey]) === 'function') {
                        layer[eventKey].call(layer, eventPacket);
                    }
                    if (layer.trigger) {
                        layer.trigger(eventName, eventPacket);
                    }
                });
            }
        }
    };
    Handler.prototype.findHover = function (x, y, exclude) {
        var list = this.storage.getDisplayList();
        var out = new HoveredResult(x, y);
        for (var i = list.length - 1; i >= 0; i--) {
            var hoverCheckResult = void 0;
            if (list[i] !== exclude
                && !list[i].ignore
                && (hoverCheckResult = isHover(list[i], x, y))) {
                !out.topTarget && (out.topTarget = list[i]);
                if (hoverCheckResult !== SILENT) {
                    out.target = list[i];
                    break;
                }
            }
        }
        return out;
    };
    Handler.prototype.processGesture = function (event, stage) {
        if (!this._gestureMgr) {
            this._gestureMgr = new __WEBPACK_IMPORTED_MODULE_6__core_GestureMgr_js__["a" /* GestureMgr */]();
        }
        var gestureMgr = this._gestureMgr;
        stage === 'start' && gestureMgr.clear();
        var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
        stage === 'end' && gestureMgr.clear();
        if (gestureInfo) {
            var type = gestureInfo.type;
            event.gestureEvent = type;
            var res = new HoveredResult();
            res.target = gestureInfo.target;
            this.dispatchToElement(res, type, gestureInfo.event);
        }
    };
    return Handler;
}(__WEBPACK_IMPORTED_MODULE_4__core_Eventful_js__["a" /* default */]));
__WEBPACK_IMPORTED_MODULE_1__core_util_js__["each"](['click', 'mousedown', 'mouseup', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
    Handler.prototype[name] = function (event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = isOutsideBoundary(this, x, y);
        var hovered;
        var hoveredTarget;
        if (name !== 'mouseup' || !isOutside) {
            hovered = this.findHover(x, y);
            hoveredTarget = hovered.target;
        }
        if (name === 'mousedown') {
            this._downEl = hoveredTarget;
            this._downPoint = [event.zrX, event.zrY];
            this._upEl = hoveredTarget;
        }
        else if (name === 'mouseup') {
            this._upEl = hoveredTarget;
        }
        else if (name === 'click') {
            if (this._downEl !== this._upEl
                || !this._downPoint
                || __WEBPACK_IMPORTED_MODULE_2__core_vector_js__["dist"](this._downPoint, [event.zrX, event.zrY]) > 4) {
                return;
            }
            this._downPoint = null;
        }
        this.dispatchToElement(hovered, name, event);
    };
});
function isHover(displayable, x, y) {
    if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
        var el = displayable;
        var isSilent = void 0;
        var ignoreClip = false;
        while (el) {
            if (el.ignoreClip) {
                ignoreClip = true;
            }
            if (!ignoreClip) {
                var clipPath = el.getClipPath();
                if (clipPath && !clipPath.contain(x, y)) {
                    return false;
                }
                if (el.silent) {
                    isSilent = true;
                }
            }
            var hostEl = el.__hostTarget;
            el = hostEl ? hostEl : el.parent;
        }
        return isSilent ? SILENT : true;
    }
    return false;
}
function isOutsideBoundary(handlerInstance, x, y) {
    var painter = handlerInstance.painter;
    return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
}
/* harmony default export */ __webpack_exports__["a"] = (Handler);


/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_timsort_js__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphic_constants_js__ = __webpack_require__(139);



var invalidZErrorLogged = false;
function logInvalidZError() {
    if (invalidZErrorLogged) {
        return;
    }
    invalidZErrorLogged = true;
    console.warn('z / z2 / zlevel of displayable is invalid, which may cause unexpected errors');
}
function shapeCompareFunc(a, b) {
    if (a.zlevel === b.zlevel) {
        if (a.z === b.z) {
            return a.z2 - b.z2;
        }
        return a.z - b.z;
    }
    return a.zlevel - b.zlevel;
}
var Storage = (function () {
    function Storage() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        this.displayableSortFunc = shapeCompareFunc;
    }
    Storage.prototype.traverse = function (cb, context) {
        for (var i = 0; i < this._roots.length; i++) {
            this._roots[i].traverse(cb, context);
        }
    };
    Storage.prototype.getDisplayList = function (update, includeIgnore) {
        includeIgnore = includeIgnore || false;
        var displayList = this._displayList;
        if (update || !displayList.length) {
            this.updateDisplayList(includeIgnore);
        }
        return displayList;
    };
    Storage.prototype.updateDisplayList = function (includeIgnore) {
        this._displayListLen = 0;
        var roots = this._roots;
        var displayList = this._displayList;
        for (var i = 0, len = roots.length; i < len; i++) {
            this._updateAndAddDisplayable(roots[i], null, includeIgnore);
        }
        displayList.length = this._displayListLen;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_timsort_js__["a" /* default */])(displayList, shapeCompareFunc);
    };
    Storage.prototype._updateAndAddDisplayable = function (el, clipPaths, includeIgnore) {
        if (el.ignore && !includeIgnore) {
            return;
        }
        el.beforeUpdate();
        el.update();
        el.afterUpdate();
        var userSetClipPath = el.getClipPath();
        if (el.ignoreClip) {
            clipPaths = null;
        }
        else if (userSetClipPath) {
            if (clipPaths) {
                clipPaths = clipPaths.slice();
            }
            else {
                clipPaths = [];
            }
            var currentClipPath = userSetClipPath;
            var parentClipPath = el;
            while (currentClipPath) {
                currentClipPath.parent = parentClipPath;
                currentClipPath.updateTransform();
                clipPaths.push(currentClipPath);
                parentClipPath = currentClipPath;
                currentClipPath = currentClipPath.getClipPath();
            }
        }
        if (el.childrenRef) {
            var children = el.childrenRef();
            for (var i = 0; i < children.length; i++) {
                var child = children[i];
                if (el.__dirty) {
                    child.__dirty |= __WEBPACK_IMPORTED_MODULE_2__graphic_constants_js__["a" /* REDRAW_BIT */];
                }
                this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
            }
            el.__dirty = 0;
        }
        else {
            var disp = el;
            if (clipPaths && clipPaths.length) {
                disp.__clipPaths = clipPaths;
            }
            else if (disp.__clipPaths && disp.__clipPaths.length > 0) {
                disp.__clipPaths = [];
            }
            if (isNaN(disp.z)) {
                logInvalidZError();
                disp.z = 0;
            }
            if (isNaN(disp.z2)) {
                logInvalidZError();
                disp.z2 = 0;
            }
            if (isNaN(disp.zlevel)) {
                logInvalidZError();
                disp.zlevel = 0;
            }
            this._displayList[this._displayListLen++] = disp;
        }
        var decalEl = el.getDecalElement && el.getDecalElement();
        if (decalEl) {
            this._updateAndAddDisplayable(decalEl, clipPaths, includeIgnore);
        }
        var textGuide = el.getTextGuideLine();
        if (textGuide) {
            this._updateAndAddDisplayable(textGuide, clipPaths, includeIgnore);
        }
        var textEl = el.getTextContent();
        if (textEl) {
            this._updateAndAddDisplayable(textEl, clipPaths, includeIgnore);
        }
    };
    Storage.prototype.addRoot = function (el) {
        if (el.__zr && el.__zr.storage === this) {
            return;
        }
        this._roots.push(el);
    };
    Storage.prototype.delRoot = function (el) {
        if (el instanceof Array) {
            for (var i = 0, l = el.length; i < l; i++) {
                this.delRoot(el[i]);
            }
            return;
        }
        var idx = __WEBPACK_IMPORTED_MODULE_0__core_util_js__["indexOf"](this._roots, el);
        if (idx >= 0) {
            this._roots.splice(idx, 1);
        }
    };
    Storage.prototype.delAllRoots = function () {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        return;
    };
    Storage.prototype.getRoots = function () {
        return this._roots;
    };
    Storage.prototype.dispose = function () {
        this._displayList = null;
        this._roots = null;
    };
    return Storage;
}());
/* harmony default export */ __webpack_exports__["a"] = (Storage);


/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_Eventful_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__requestAnimationFrame_js__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Animator_js__ = __webpack_require__(358);




function getTime() {
    return new Date().getTime();
}
var Animation = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Animation, _super);
    function Animation(opts) {
        var _this = _super.call(this) || this;
        _this._running = false;
        _this._time = 0;
        _this._pausedTime = 0;
        _this._pauseStart = 0;
        _this._paused = false;
        opts = opts || {};
        _this.stage = opts.stage || {};
        return _this;
    }
    Animation.prototype.addClip = function (clip) {
        if (clip.animation) {
            this.removeClip(clip);
        }
        if (!this._head) {
            this._head = this._tail = clip;
        }
        else {
            this._tail.next = clip;
            clip.prev = this._tail;
            clip.next = null;
            this._tail = clip;
        }
        clip.animation = this;
    };
    Animation.prototype.addAnimator = function (animator) {
        animator.animation = this;
        var clip = animator.getClip();
        if (clip) {
            this.addClip(clip);
        }
    };
    Animation.prototype.removeClip = function (clip) {
        if (!clip.animation) {
            return;
        }
        var prev = clip.prev;
        var next = clip.next;
        if (prev) {
            prev.next = next;
        }
        else {
            this._head = next;
        }
        if (next) {
            next.prev = prev;
        }
        else {
            this._tail = prev;
        }
        clip.next = clip.prev = clip.animation = null;
    };
    Animation.prototype.removeAnimator = function (animator) {
        var clip = animator.getClip();
        if (clip) {
            this.removeClip(clip);
        }
        animator.animation = null;
    };
    Animation.prototype.update = function (notTriggerFrameAndStageUpdate) {
        var time = getTime() - this._pausedTime;
        var delta = time - this._time;
        var clip = this._head;
        while (clip) {
            var nextClip = clip.next;
            var finished = clip.step(time, delta);
            if (finished) {
                clip.ondestroy();
                this.removeClip(clip);
                clip = nextClip;
            }
            else {
                clip = nextClip;
            }
        }
        this._time = time;
        if (!notTriggerFrameAndStageUpdate) {
            this.trigger('frame', delta);
            this.stage.update && this.stage.update();
        }
    };
    Animation.prototype._startLoop = function () {
        var self = this;
        this._running = true;
        function step() {
            if (self._running) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__requestAnimationFrame_js__["a" /* default */])(step);
                !self._paused && self.update();
            }
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__requestAnimationFrame_js__["a" /* default */])(step);
    };
    Animation.prototype.start = function () {
        if (this._running) {
            return;
        }
        this._time = getTime();
        this._pausedTime = 0;
        this._startLoop();
    };
    Animation.prototype.stop = function () {
        this._running = false;
    };
    Animation.prototype.pause = function () {
        if (!this._paused) {
            this._pauseStart = getTime();
            this._paused = true;
        }
    };
    Animation.prototype.resume = function () {
        if (this._paused) {
            this._pausedTime += getTime() - this._pauseStart;
            this._paused = false;
        }
    };
    Animation.prototype.clear = function () {
        var clip = this._head;
        while (clip) {
            var nextClip = clip.next;
            clip.prev = clip.next = clip.animation = null;
            clip = nextClip;
        }
        this._head = this._tail = null;
    };
    Animation.prototype.isFinished = function () {
        return this._head == null;
    };
    Animation.prototype.animate = function (target, options) {
        options = options || {};
        this.start();
        var animator = new __WEBPACK_IMPORTED_MODULE_3__Animator_js__["a" /* default */](target, options.loop);
        this.addAnimator(animator);
        return animator;
    };
    return Animation;
}(__WEBPACK_IMPORTED_MODULE_1__core_Eventful_js__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Animation);


/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__easing_js__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cubicEasing_js__ = __webpack_require__(359);



var Clip = (function () {
    function Clip(opts) {
        this._inited = false;
        this._startTime = 0;
        this._pausedTime = 0;
        this._paused = false;
        this._life = opts.life || 1000;
        this._delay = opts.delay || 0;
        this.loop = opts.loop || false;
        this.onframe = opts.onframe || __WEBPACK_IMPORTED_MODULE_1__core_util_js__["noop"];
        this.ondestroy = opts.ondestroy || __WEBPACK_IMPORTED_MODULE_1__core_util_js__["noop"];
        this.onrestart = opts.onrestart || __WEBPACK_IMPORTED_MODULE_1__core_util_js__["noop"];
        opts.easing && this.setEasing(opts.easing);
    }
    Clip.prototype.step = function (globalTime, deltaTime) {
        if (!this._inited) {
            this._startTime = globalTime + this._delay;
            this._inited = true;
        }
        if (this._paused) {
            this._pausedTime += deltaTime;
            return;
        }
        var life = this._life;
        var elapsedTime = globalTime - this._startTime - this._pausedTime;
        var percent = elapsedTime / life;
        if (percent < 0) {
            percent = 0;
        }
        percent = Math.min(percent, 1);
        var easingFunc = this.easingFunc;
        var schedule = easingFunc ? easingFunc(percent) : percent;
        this.onframe(schedule);
        if (percent === 1) {
            if (this.loop) {
                var remainder = elapsedTime % life;
                this._startTime = globalTime - remainder;
                this._pausedTime = 0;
                this.onrestart();
            }
            else {
                return true;
            }
        }
        return false;
    };
    Clip.prototype.pause = function () {
        this._paused = true;
    };
    Clip.prototype.resume = function () {
        this._paused = false;
    };
    Clip.prototype.setEasing = function (easing) {
        this.easing = easing;
        this.easingFunc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_util_js__["isFunction"])(easing)
            ? easing
            : __WEBPACK_IMPORTED_MODULE_0__easing_js__["a" /* default */][easing] || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cubicEasing_js__["a" /* createCubicEasingFunc */])(easing);
    };
    return Clip;
}());
/* harmony default export */ __webpack_exports__["a"] = (Clip);


/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_Eventful_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_js__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphic_js__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphic_constants_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_platform_js__ = __webpack_require__(67);









function createDom(id, painter, dpr) {
    var newDom = __WEBPACK_IMPORTED_MODULE_8__core_platform_js__["a" /* platformApi */].createCanvas();
    var width = painter.getWidth();
    var height = painter.getHeight();
    var newDomStyle = newDom.style;
    if (newDomStyle) {
        newDomStyle.position = 'absolute';
        newDomStyle.left = '0';
        newDomStyle.top = '0';
        newDomStyle.width = width + 'px';
        newDomStyle.height = height + 'px';
        newDom.setAttribute('data-zr-dom-id', id);
    }
    newDom.width = width * dpr;
    newDom.height = height * dpr;
    return newDom;
}
;
var Layer = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Layer, _super);
    function Layer(id, painter, dpr) {
        var _this = _super.call(this) || this;
        _this.motionBlur = false;
        _this.lastFrameAlpha = 0.7;
        _this.dpr = 1;
        _this.virtual = false;
        _this.config = {};
        _this.incremental = false;
        _this.zlevel = 0;
        _this.maxRepaintRectCount = 5;
        _this.__dirty = true;
        _this.__firstTimePaint = true;
        _this.__used = false;
        _this.__drawIndex = 0;
        _this.__startIndex = 0;
        _this.__endIndex = 0;
        _this.__prevStartIndex = null;
        _this.__prevEndIndex = null;
        var dom;
        dpr = dpr || __WEBPACK_IMPORTED_MODULE_2__config_js__["e" /* devicePixelRatio */];
        if (typeof id === 'string') {
            dom = createDom(id, painter, dpr);
        }
        else if (__WEBPACK_IMPORTED_MODULE_1__core_util_js__["isObject"](id)) {
            dom = id;
            id = dom.id;
        }
        _this.id = id;
        _this.dom = dom;
        var domStyle = dom.style;
        if (domStyle) {
            __WEBPACK_IMPORTED_MODULE_1__core_util_js__["disableUserSelect"](dom);
            dom.onselectstart = function () { return false; };
            domStyle.padding = '0';
            domStyle.margin = '0';
            domStyle.borderWidth = '0';
        }
        _this.painter = painter;
        _this.dpr = dpr;
        return _this;
    }
    Layer.prototype.getElementCount = function () {
        return this.__endIndex - this.__startIndex;
    };
    Layer.prototype.afterBrush = function () {
        this.__prevStartIndex = this.__startIndex;
        this.__prevEndIndex = this.__endIndex;
    };
    Layer.prototype.initContext = function () {
        this.ctx = this.dom.getContext('2d');
        this.ctx.dpr = this.dpr;
    };
    Layer.prototype.setUnpainted = function () {
        this.__firstTimePaint = true;
    };
    Layer.prototype.createBackBuffer = function () {
        var dpr = this.dpr;
        this.domBack = createDom('back-' + this.id, this.painter, dpr);
        this.ctxBack = this.domBack.getContext('2d');
        if (dpr !== 1) {
            this.ctxBack.scale(dpr, dpr);
        }
    };
    Layer.prototype.createRepaintRects = function (displayList, prevList, viewWidth, viewHeight) {
        if (this.__firstTimePaint) {
            this.__firstTimePaint = false;
            return null;
        }
        var mergedRepaintRects = [];
        var maxRepaintRectCount = this.maxRepaintRectCount;
        var full = false;
        var pendingRect = new __WEBPACK_IMPORTED_MODULE_6__core_BoundingRect_js__["a" /* default */](0, 0, 0, 0);
        function addRectToMergePool(rect) {
            if (!rect.isFinite() || rect.isZero()) {
                return;
            }
            if (mergedRepaintRects.length === 0) {
                var boundingRect = new __WEBPACK_IMPORTED_MODULE_6__core_BoundingRect_js__["a" /* default */](0, 0, 0, 0);
                boundingRect.copy(rect);
                mergedRepaintRects.push(boundingRect);
            }
            else {
                var isMerged = false;
                var minDeltaArea = Infinity;
                var bestRectToMergeIdx = 0;
                for (var i = 0; i < mergedRepaintRects.length; ++i) {
                    var mergedRect = mergedRepaintRects[i];
                    if (mergedRect.intersect(rect)) {
                        var pendingRect_1 = new __WEBPACK_IMPORTED_MODULE_6__core_BoundingRect_js__["a" /* default */](0, 0, 0, 0);
                        pendingRect_1.copy(mergedRect);
                        pendingRect_1.union(rect);
                        mergedRepaintRects[i] = pendingRect_1;
                        isMerged = true;
                        break;
                    }
                    else if (full) {
                        pendingRect.copy(rect);
                        pendingRect.union(mergedRect);
                        var aArea = rect.width * rect.height;
                        var bArea = mergedRect.width * mergedRect.height;
                        var pendingArea = pendingRect.width * pendingRect.height;
                        var deltaArea = pendingArea - aArea - bArea;
                        if (deltaArea < minDeltaArea) {
                            minDeltaArea = deltaArea;
                            bestRectToMergeIdx = i;
                        }
                    }
                }
                if (full) {
                    mergedRepaintRects[bestRectToMergeIdx].union(rect);
                    isMerged = true;
                }
                if (!isMerged) {
                    var boundingRect = new __WEBPACK_IMPORTED_MODULE_6__core_BoundingRect_js__["a" /* default */](0, 0, 0, 0);
                    boundingRect.copy(rect);
                    mergedRepaintRects.push(boundingRect);
                }
                if (!full) {
                    full = mergedRepaintRects.length >= maxRepaintRectCount;
                }
            }
        }
        for (var i = this.__startIndex; i < this.__endIndex; ++i) {
            var el = displayList[i];
            if (el) {
                var shouldPaint = el.shouldBePainted(viewWidth, viewHeight, true, true);
                var prevRect = el.__isRendered && ((el.__dirty & __WEBPACK_IMPORTED_MODULE_7__graphic_constants_js__["a" /* REDRAW_BIT */]) || !shouldPaint)
                    ? el.getPrevPaintRect()
                    : null;
                if (prevRect) {
                    addRectToMergePool(prevRect);
                }
                var curRect = shouldPaint && ((el.__dirty & __WEBPACK_IMPORTED_MODULE_7__graphic_constants_js__["a" /* REDRAW_BIT */]) || !el.__isRendered)
                    ? el.getPaintRect()
                    : null;
                if (curRect) {
                    addRectToMergePool(curRect);
                }
            }
        }
        for (var i = this.__prevStartIndex; i < this.__prevEndIndex; ++i) {
            var el = prevList[i];
            var shouldPaint = el.shouldBePainted(viewWidth, viewHeight, true, true);
            if (el && (!shouldPaint || !el.__zr) && el.__isRendered) {
                var prevRect = el.getPrevPaintRect();
                if (prevRect) {
                    addRectToMergePool(prevRect);
                }
            }
        }
        var hasIntersections;
        do {
            hasIntersections = false;
            for (var i = 0; i < mergedRepaintRects.length;) {
                if (mergedRepaintRects[i].isZero()) {
                    mergedRepaintRects.splice(i, 1);
                    continue;
                }
                for (var j = i + 1; j < mergedRepaintRects.length;) {
                    if (mergedRepaintRects[i].intersect(mergedRepaintRects[j])) {
                        hasIntersections = true;
                        mergedRepaintRects[i].union(mergedRepaintRects[j]);
                        mergedRepaintRects.splice(j, 1);
                    }
                    else {
                        j++;
                    }
                }
                i++;
            }
        } while (hasIntersections);
        this._paintRects = mergedRepaintRects;
        return mergedRepaintRects;
    };
    Layer.prototype.debugGetPaintRects = function () {
        return (this._paintRects || []).slice();
    };
    Layer.prototype.resize = function (width, height) {
        var dpr = this.dpr;
        var dom = this.dom;
        var domStyle = dom.style;
        var domBack = this.domBack;
        if (domStyle) {
            domStyle.width = width + 'px';
            domStyle.height = height + 'px';
        }
        dom.width = width * dpr;
        dom.height = height * dpr;
        if (domBack) {
            domBack.width = width * dpr;
            domBack.height = height * dpr;
            if (dpr !== 1) {
                this.ctxBack.scale(dpr, dpr);
            }
        }
    };
    Layer.prototype.clear = function (clearAll, clearColor, repaintRects) {
        var dom = this.dom;
        var ctx = this.ctx;
        var width = dom.width;
        var height = dom.height;
        clearColor = clearColor || this.clearColor;
        var haveMotionBLur = this.motionBlur && !clearAll;
        var lastFrameAlpha = this.lastFrameAlpha;
        var dpr = this.dpr;
        var self = this;
        if (haveMotionBLur) {
            if (!this.domBack) {
                this.createBackBuffer();
            }
            this.ctxBack.globalCompositeOperation = 'copy';
            this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
        }
        var domBack = this.domBack;
        function doClear(x, y, width, height) {
            ctx.clearRect(x, y, width, height);
            if (clearColor && clearColor !== 'transparent') {
                var clearColorGradientOrPattern = void 0;
                if (__WEBPACK_IMPORTED_MODULE_1__core_util_js__["isGradientObject"](clearColor)) {
                    clearColorGradientOrPattern = clearColor.__canvasGradient
                        || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helper_js__["a" /* getCanvasGradient */])(ctx, clearColor, {
                            x: 0,
                            y: 0,
                            width: width,
                            height: height
                        });
                    clearColor.__canvasGradient = clearColorGradientOrPattern;
                }
                else if (__WEBPACK_IMPORTED_MODULE_1__core_util_js__["isImagePatternObject"](clearColor)) {
                    clearColorGradientOrPattern = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__graphic_js__["c" /* createCanvasPattern */])(ctx, clearColor, {
                        dirty: function () {
                            self.setUnpainted();
                            self.__painter.refresh();
                        }
                    });
                }
                ctx.save();
                ctx.fillStyle = clearColorGradientOrPattern || clearColor;
                ctx.fillRect(x, y, width, height);
                ctx.restore();
            }
            if (haveMotionBLur) {
                ctx.save();
                ctx.globalAlpha = lastFrameAlpha;
                ctx.drawImage(domBack, x, y, width, height);
                ctx.restore();
            }
        }
        ;
        if (!repaintRects || haveMotionBLur) {
            doClear(0, 0, width, height);
        }
        else if (repaintRects.length) {
            __WEBPACK_IMPORTED_MODULE_1__core_util_js__["each"](repaintRects, function (rect) {
                doClear(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
            });
        }
    };
    return Layer;
}(__WEBPACK_IMPORTED_MODULE_3__core_Eventful_js__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Layer);


/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Layer_js__ = __webpack_require__(1694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation_requestAnimationFrame_js__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_env_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphic_js__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphic_constants_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helper_js__ = __webpack_require__(254);








var HOVER_LAYER_ZLEVEL = 1e5;
var CANVAS_ZLEVEL = 314159;
var EL_AFTER_INCREMENTAL_INC = 0.01;
var INCREMENTAL_INC = 0.001;
function isLayerValid(layer) {
    if (!layer) {
        return false;
    }
    if (layer.__builtin__) {
        return true;
    }
    if (typeof (layer.resize) !== 'function'
        || typeof (layer.refresh) !== 'function') {
        return false;
    }
    return true;
}
function createRoot(width, height) {
    var domRoot = document.createElement('div');
    domRoot.style.cssText = [
        'position:relative',
        'width:' + width + 'px',
        'height:' + height + 'px',
        'padding:0',
        'margin:0',
        'border-width:0'
    ].join(';') + ';';
    return domRoot;
}
var CanvasPainter = (function () {
    function CanvasPainter(root, storage, opts, id) {
        this.type = 'canvas';
        this._zlevelList = [];
        this._prevDisplayList = [];
        this._layers = {};
        this._layerConfig = {};
        this._needsManuallyCompositing = false;
        this.type = 'canvas';
        var singleCanvas = !root.nodeName
            || root.nodeName.toUpperCase() === 'CANVAS';
        this._opts = opts = __WEBPACK_IMPORTED_MODULE_1__core_util_js__["extend"]({}, opts || {});
        this.dpr = opts.devicePixelRatio || __WEBPACK_IMPORTED_MODULE_0__config_js__["e" /* devicePixelRatio */];
        this._singleCanvas = singleCanvas;
        this.root = root;
        var rootStyle = root.style;
        if (rootStyle) {
            __WEBPACK_IMPORTED_MODULE_1__core_util_js__["disableUserSelect"](root);
            root.innerHTML = '';
        }
        this.storage = storage;
        var zlevelList = this._zlevelList;
        this._prevDisplayList = [];
        var layers = this._layers;
        if (!singleCanvas) {
            this._width = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helper_js__["c" /* getSize */])(root, 0, opts);
            this._height = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helper_js__["c" /* getSize */])(root, 1, opts);
            var domRoot = this._domRoot = createRoot(this._width, this._height);
            root.appendChild(domRoot);
        }
        else {
            var rootCanvas = root;
            var width = rootCanvas.width;
            var height = rootCanvas.height;
            if (opts.width != null) {
                width = opts.width;
            }
            if (opts.height != null) {
                height = opts.height;
            }
            this.dpr = opts.devicePixelRatio || 1;
            rootCanvas.width = width * this.dpr;
            rootCanvas.height = height * this.dpr;
            this._width = width;
            this._height = height;
            var mainLayer = new __WEBPACK_IMPORTED_MODULE_2__Layer_js__["a" /* default */](rootCanvas, this, this.dpr);
            mainLayer.__builtin__ = true;
            mainLayer.initContext();
            layers[CANVAS_ZLEVEL] = mainLayer;
            mainLayer.zlevel = CANVAS_ZLEVEL;
            zlevelList.push(CANVAS_ZLEVEL);
            this._domRoot = root;
        }
    }
    CanvasPainter.prototype.getType = function () {
        return 'canvas';
    };
    CanvasPainter.prototype.isSingleCanvas = function () {
        return this._singleCanvas;
    };
    CanvasPainter.prototype.getViewportRoot = function () {
        return this._domRoot;
    };
    CanvasPainter.prototype.getViewportRootOffset = function () {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) {
            return {
                offsetLeft: viewportRoot.offsetLeft || 0,
                offsetTop: viewportRoot.offsetTop || 0
            };
        }
    };
    CanvasPainter.prototype.refresh = function (paintAll) {
        var list = this.storage.getDisplayList(true);
        var prevList = this._prevDisplayList;
        var zlevelList = this._zlevelList;
        this._redrawId = Math.random();
        this._paintList(list, prevList, paintAll, this._redrawId);
        for (var i = 0; i < zlevelList.length; i++) {
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (!layer.__builtin__ && layer.refresh) {
                var clearColor = i === 0 ? this._backgroundColor : null;
                layer.refresh(clearColor);
            }
        }
        if (this._opts.useDirtyRect) {
            this._prevDisplayList = list.slice();
        }
        return this;
    };
    CanvasPainter.prototype.refreshHover = function () {
        this._paintHoverList(this.storage.getDisplayList(false));
    };
    CanvasPainter.prototype._paintHoverList = function (list) {
        var len = list.length;
        var hoverLayer = this._hoverlayer;
        hoverLayer && hoverLayer.clear();
        if (!len) {
            return;
        }
        var scope = {
            inHover: true,
            viewWidth: this._width,
            viewHeight: this._height
        };
        var ctx;
        for (var i = 0; i < len; i++) {
            var el = list[i];
            if (el.__inHover) {
                if (!hoverLayer) {
                    hoverLayer = this._hoverlayer = this.getLayer(HOVER_LAYER_ZLEVEL);
                }
                if (!ctx) {
                    ctx = hoverLayer.ctx;
                    ctx.save();
                }
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__graphic_js__["b" /* brush */])(ctx, el, scope, i === len - 1);
            }
        }
        if (ctx) {
            ctx.restore();
        }
    };
    CanvasPainter.prototype.getHoverLayer = function () {
        return this.getLayer(HOVER_LAYER_ZLEVEL);
    };
    CanvasPainter.prototype.paintOne = function (ctx, el) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__graphic_js__["a" /* brushSingle */])(ctx, el);
    };
    CanvasPainter.prototype._paintList = function (list, prevList, paintAll, redrawId) {
        if (this._redrawId !== redrawId) {
            return;
        }
        paintAll = paintAll || false;
        this._updateLayerStatus(list);
        var _a = this._doPaintList(list, prevList, paintAll), finished = _a.finished, needsRefreshHover = _a.needsRefreshHover;
        if (this._needsManuallyCompositing) {
            this._compositeManually();
        }
        if (needsRefreshHover) {
            this._paintHoverList(list);
        }
        if (!finished) {
            var self_1 = this;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__animation_requestAnimationFrame_js__["a" /* default */])(function () {
                self_1._paintList(list, prevList, paintAll, redrawId);
            });
        }
        else {
            this.eachLayer(function (layer) {
                layer.afterBrush && layer.afterBrush();
            });
        }
    };
    CanvasPainter.prototype._compositeManually = function () {
        var ctx = this.getLayer(CANVAS_ZLEVEL).ctx;
        var width = this._domRoot.width;
        var height = this._domRoot.height;
        ctx.clearRect(0, 0, width, height);
        this.eachBuiltinLayer(function (layer) {
            if (layer.virtual) {
                ctx.drawImage(layer.dom, 0, 0, width, height);
            }
        });
    };
    CanvasPainter.prototype._doPaintList = function (list, prevList, paintAll) {
        var _this = this;
        var layerList = [];
        var useDirtyRect = this._opts.useDirtyRect;
        for (var zi = 0; zi < this._zlevelList.length; zi++) {
            var zlevel = this._zlevelList[zi];
            var layer = this._layers[zlevel];
            if (layer.__builtin__
                && layer !== this._hoverlayer
                && (layer.__dirty || paintAll)) {
                layerList.push(layer);
            }
        }
        var finished = true;
        var needsRefreshHover = false;
        var _loop_1 = function (k) {
            var layer = layerList[k];
            var ctx = layer.ctx;
            var repaintRects = useDirtyRect
                && layer.createRepaintRects(list, prevList, this_1._width, this_1._height);
            var start = paintAll ? layer.__startIndex : layer.__drawIndex;
            var useTimer = !paintAll && layer.incremental && Date.now;
            var startTime = useTimer && Date.now();
            var clearColor = layer.zlevel === this_1._zlevelList[0]
                ? this_1._backgroundColor : null;
            if (layer.__startIndex === layer.__endIndex) {
                layer.clear(false, clearColor, repaintRects);
            }
            else if (start === layer.__startIndex) {
                var firstEl = list[start];
                if (!firstEl.incremental || !firstEl.notClear || paintAll) {
                    layer.clear(false, clearColor, repaintRects);
                }
            }
            if (start === -1) {
                console.error('For some unknown reason. drawIndex is -1');
                start = layer.__startIndex;
            }
            var i;
            var repaint = function (repaintRect) {
                var scope = {
                    inHover: false,
                    allClipped: false,
                    prevEl: null,
                    viewWidth: _this._width,
                    viewHeight: _this._height
                };
                for (i = start; i < layer.__endIndex; i++) {
                    var el = list[i];
                    if (el.__inHover) {
                        needsRefreshHover = true;
                    }
                    _this._doPaintEl(el, layer, useDirtyRect, repaintRect, scope, i === layer.__endIndex - 1);
                    if (useTimer) {
                        var dTime = Date.now() - startTime;
                        if (dTime > 15) {
                            break;
                        }
                    }
                }
                if (scope.prevElClipPaths) {
                    ctx.restore();
                }
            };
            if (repaintRects) {
                if (repaintRects.length === 0) {
                    i = layer.__endIndex;
                }
                else {
                    var dpr = this_1.dpr;
                    for (var r = 0; r < repaintRects.length; ++r) {
                        var rect = repaintRects[r];
                        ctx.save();
                        ctx.beginPath();
                        ctx.rect(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
                        ctx.clip();
                        repaint(rect);
                        ctx.restore();
                    }
                }
            }
            else {
                ctx.save();
                repaint();
                ctx.restore();
            }
            layer.__drawIndex = i;
            if (layer.__drawIndex < layer.__endIndex) {
                finished = false;
            }
        };
        var this_1 = this;
        for (var k = 0; k < layerList.length; k++) {
            _loop_1(k);
        }
        if (__WEBPACK_IMPORTED_MODULE_4__core_env_js__["a" /* default */].wxa) {
            __WEBPACK_IMPORTED_MODULE_1__core_util_js__["each"](this._layers, function (layer) {
                if (layer && layer.ctx && layer.ctx.draw) {
                    layer.ctx.draw();
                }
            });
        }
        return {
            finished: finished,
            needsRefreshHover: needsRefreshHover
        };
    };
    CanvasPainter.prototype._doPaintEl = function (el, currentLayer, useDirtyRect, repaintRect, scope, isLast) {
        var ctx = currentLayer.ctx;
        if (useDirtyRect) {
            var paintRect = el.getPaintRect();
            if (!repaintRect || paintRect && paintRect.intersect(repaintRect)) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__graphic_js__["b" /* brush */])(ctx, el, scope, isLast);
                el.setPrevPaintRect(paintRect);
            }
        }
        else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__graphic_js__["b" /* brush */])(ctx, el, scope, isLast);
        }
    };
    CanvasPainter.prototype.getLayer = function (zlevel, virtual) {
        if (this._singleCanvas && !this._needsManuallyCompositing) {
            zlevel = CANVAS_ZLEVEL;
        }
        var layer = this._layers[zlevel];
        if (!layer) {
            layer = new __WEBPACK_IMPORTED_MODULE_2__Layer_js__["a" /* default */]('zr_' + zlevel, this, this.dpr);
            layer.zlevel = zlevel;
            layer.__builtin__ = true;
            if (this._layerConfig[zlevel]) {
                __WEBPACK_IMPORTED_MODULE_1__core_util_js__["merge"](layer, this._layerConfig[zlevel], true);
            }
            else if (this._layerConfig[zlevel - EL_AFTER_INCREMENTAL_INC]) {
                __WEBPACK_IMPORTED_MODULE_1__core_util_js__["merge"](layer, this._layerConfig[zlevel - EL_AFTER_INCREMENTAL_INC], true);
            }
            if (virtual) {
                layer.virtual = virtual;
            }
            this.insertLayer(zlevel, layer);
            layer.initContext();
        }
        return layer;
    };
    CanvasPainter.prototype.insertLayer = function (zlevel, layer) {
        var layersMap = this._layers;
        var zlevelList = this._zlevelList;
        var len = zlevelList.length;
        var domRoot = this._domRoot;
        var prevLayer = null;
        var i = -1;
        if (layersMap[zlevel]) {
            if (true) {
                __WEBPACK_IMPORTED_MODULE_1__core_util_js__["logError"]('ZLevel ' + zlevel + ' has been used already');
            }
            return;
        }
        if (!isLayerValid(layer)) {
            if (true) {
                __WEBPACK_IMPORTED_MODULE_1__core_util_js__["logError"]('Layer of zlevel ' + zlevel + ' is not valid');
            }
            return;
        }
        if (len > 0 && zlevel > zlevelList[0]) {
            for (i = 0; i < len - 1; i++) {
                if (zlevelList[i] < zlevel
                    && zlevelList[i + 1] > zlevel) {
                    break;
                }
            }
            prevLayer = layersMap[zlevelList[i]];
        }
        zlevelList.splice(i + 1, 0, zlevel);
        layersMap[zlevel] = layer;
        if (!layer.virtual) {
            if (prevLayer) {
                var prevDom = prevLayer.dom;
                if (prevDom.nextSibling) {
                    domRoot.insertBefore(layer.dom, prevDom.nextSibling);
                }
                else {
                    domRoot.appendChild(layer.dom);
                }
            }
            else {
                if (domRoot.firstChild) {
                    domRoot.insertBefore(layer.dom, domRoot.firstChild);
                }
                else {
                    domRoot.appendChild(layer.dom);
                }
            }
        }
        layer.__painter = this;
    };
    CanvasPainter.prototype.eachLayer = function (cb, context) {
        var zlevelList = this._zlevelList;
        for (var i = 0; i < zlevelList.length; i++) {
            var z = zlevelList[i];
            cb.call(context, this._layers[z], z);
        }
    };
    CanvasPainter.prototype.eachBuiltinLayer = function (cb, context) {
        var zlevelList = this._zlevelList;
        for (var i = 0; i < zlevelList.length; i++) {
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (layer.__builtin__) {
                cb.call(context, layer, z);
            }
        }
    };
    CanvasPainter.prototype.eachOtherLayer = function (cb, context) {
        var zlevelList = this._zlevelList;
        for (var i = 0; i < zlevelList.length; i++) {
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (!layer.__builtin__) {
                cb.call(context, layer, z);
            }
        }
    };
    CanvasPainter.prototype.getLayers = function () {
        return this._layers;
    };
    CanvasPainter.prototype._updateLayerStatus = function (list) {
        this.eachBuiltinLayer(function (layer, z) {
            layer.__dirty = layer.__used = false;
        });
        function updatePrevLayer(idx) {
            if (prevLayer) {
                if (prevLayer.__endIndex !== idx) {
                    prevLayer.__dirty = true;
                }
                prevLayer.__endIndex = idx;
            }
        }
        if (this._singleCanvas) {
            for (var i_1 = 1; i_1 < list.length; i_1++) {
                var el = list[i_1];
                if (el.zlevel !== list[i_1 - 1].zlevel || el.incremental) {
                    this._needsManuallyCompositing = true;
                    break;
                }
            }
        }
        var prevLayer = null;
        var incrementalLayerCount = 0;
        var prevZlevel;
        var i;
        for (i = 0; i < list.length; i++) {
            var el = list[i];
            var zlevel = el.zlevel;
            var layer = void 0;
            if (prevZlevel !== zlevel) {
                prevZlevel = zlevel;
                incrementalLayerCount = 0;
            }
            if (el.incremental) {
                layer = this.getLayer(zlevel + INCREMENTAL_INC, this._needsManuallyCompositing);
                layer.incremental = true;
                incrementalLayerCount = 1;
            }
            else {
                layer = this.getLayer(zlevel + (incrementalLayerCount > 0 ? EL_AFTER_INCREMENTAL_INC : 0), this._needsManuallyCompositing);
            }
            if (!layer.__builtin__) {
                __WEBPACK_IMPORTED_MODULE_1__core_util_js__["logError"]('ZLevel ' + zlevel + ' has been used by unkown layer ' + layer.id);
            }
            if (layer !== prevLayer) {
                layer.__used = true;
                if (layer.__startIndex !== i) {
                    layer.__dirty = true;
                }
                layer.__startIndex = i;
                if (!layer.incremental) {
                    layer.__drawIndex = i;
                }
                else {
                    layer.__drawIndex = -1;
                }
                updatePrevLayer(i);
                prevLayer = layer;
            }
            if ((el.__dirty & __WEBPACK_IMPORTED_MODULE_6__graphic_constants_js__["a" /* REDRAW_BIT */]) && !el.__inHover) {
                layer.__dirty = true;
                if (layer.incremental && layer.__drawIndex < 0) {
                    layer.__drawIndex = i;
                }
            }
        }
        updatePrevLayer(i);
        this.eachBuiltinLayer(function (layer, z) {
            if (!layer.__used && layer.getElementCount() > 0) {
                layer.__dirty = true;
                layer.__startIndex = layer.__endIndex = layer.__drawIndex = 0;
            }
            if (layer.__dirty && layer.__drawIndex < 0) {
                layer.__drawIndex = layer.__startIndex;
            }
        });
    };
    CanvasPainter.prototype.clear = function () {
        this.eachBuiltinLayer(this._clearLayer);
        return this;
    };
    CanvasPainter.prototype._clearLayer = function (layer) {
        layer.clear();
    };
    CanvasPainter.prototype.setBackgroundColor = function (backgroundColor) {
        this._backgroundColor = backgroundColor;
        __WEBPACK_IMPORTED_MODULE_1__core_util_js__["each"](this._layers, function (layer) {
            layer.setUnpainted();
        });
    };
    CanvasPainter.prototype.configLayer = function (zlevel, config) {
        if (config) {
            var layerConfig = this._layerConfig;
            if (!layerConfig[zlevel]) {
                layerConfig[zlevel] = config;
            }
            else {
                __WEBPACK_IMPORTED_MODULE_1__core_util_js__["merge"](layerConfig[zlevel], config, true);
            }
            for (var i = 0; i < this._zlevelList.length; i++) {
                var _zlevel = this._zlevelList[i];
                if (_zlevel === zlevel || _zlevel === zlevel + EL_AFTER_INCREMENTAL_INC) {
                    var layer = this._layers[_zlevel];
                    __WEBPACK_IMPORTED_MODULE_1__core_util_js__["merge"](layer, layerConfig[zlevel], true);
                }
            }
        }
    };
    CanvasPainter.prototype.delLayer = function (zlevel) {
        var layers = this._layers;
        var zlevelList = this._zlevelList;
        var layer = layers[zlevel];
        if (!layer) {
            return;
        }
        layer.dom.parentNode.removeChild(layer.dom);
        delete layers[zlevel];
        zlevelList.splice(__WEBPACK_IMPORTED_MODULE_1__core_util_js__["indexOf"](zlevelList, zlevel), 1);
    };
    CanvasPainter.prototype.resize = function (width, height) {
        if (!this._domRoot.style) {
            if (width == null || height == null) {
                return;
            }
            this._width = width;
            this._height = height;
            this.getLayer(CANVAS_ZLEVEL).resize(width, height);
        }
        else {
            var domRoot = this._domRoot;
            domRoot.style.display = 'none';
            var opts = this._opts;
            var root = this.root;
            width != null && (opts.width = width);
            height != null && (opts.height = height);
            width = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helper_js__["c" /* getSize */])(root, 0, opts);
            height = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helper_js__["c" /* getSize */])(root, 1, opts);
            domRoot.style.display = '';
            if (this._width !== width || height !== this._height) {
                domRoot.style.width = width + 'px';
                domRoot.style.height = height + 'px';
                for (var id in this._layers) {
                    if (this._layers.hasOwnProperty(id)) {
                        this._layers[id].resize(width, height);
                    }
                }
                this.refresh(true);
            }
            this._width = width;
            this._height = height;
        }
        return this;
    };
    CanvasPainter.prototype.clearLayer = function (zlevel) {
        var layer = this._layers[zlevel];
        if (layer) {
            layer.clear();
        }
    };
    CanvasPainter.prototype.dispose = function () {
        this.root.innerHTML = '';
        this.root =
            this.storage =
                this._domRoot =
                    this._layers = null;
    };
    CanvasPainter.prototype.getRenderedCanvas = function (opts) {
        opts = opts || {};
        if (this._singleCanvas && !this._compositeManually) {
            return this._layers[CANVAS_ZLEVEL].dom;
        }
        var imageLayer = new __WEBPACK_IMPORTED_MODULE_2__Layer_js__["a" /* default */]('image', this, opts.pixelRatio || this.dpr);
        imageLayer.initContext();
        imageLayer.clear(false, opts.backgroundColor || this._backgroundColor);
        var ctx = imageLayer.ctx;
        if (opts.pixelRatio <= this.dpr) {
            this.refresh();
            var width_1 = imageLayer.dom.width;
            var height_1 = imageLayer.dom.height;
            this.eachLayer(function (layer) {
                if (layer.__builtin__) {
                    ctx.drawImage(layer.dom, 0, 0, width_1, height_1);
                }
                else if (layer.renderToCanvas) {
                    ctx.save();
                    layer.renderToCanvas(ctx);
                    ctx.restore();
                }
            });
        }
        else {
            var scope = {
                inHover: false,
                viewWidth: this._width,
                viewHeight: this._height
            };
            var displayList = this.storage.getDisplayList(true);
            for (var i = 0, len = displayList.length; i < len; i++) {
                var el = displayList[i];
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__graphic_js__["b" /* brush */])(ctx, el, scope, i === len - 1);
            }
        }
        return imageLayer.dom;
    };
    CanvasPainter.prototype.getWidth = function () {
        return this._width;
    };
    CanvasPainter.prototype.getHeight = function () {
        return this._height;
    };
    return CanvasPainter;
}());
/* harmony default export */ __webpack_exports__["a"] = (CanvasPainter);
;


/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = containStroke;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_js__ = __webpack_require__(581);

var PI2 = Math.PI * 2;
function containStroke(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
    if (lineWidth === 0) {
        return false;
    }
    var _l = lineWidth;
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    if ((d - _l > r) || (d + _l < r)) {
        return false;
    }
    if (Math.abs(startAngle - endAngle) % PI2 < 1e-4) {
        return true;
    }
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_js__["a" /* normalizeRadian */])(endAngle);
        endAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_js__["a" /* normalizeRadian */])(tmp);
    }
    else {
        startAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_js__["a" /* normalizeRadian */])(startAngle);
        endAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_js__["a" /* normalizeRadian */])(endAngle);
    }
    if (startAngle > endAngle) {
        endAngle += PI2;
    }
    var angle = Math.atan2(y, x);
    if (angle < 0) {
        angle += PI2;
    }
    return (angle >= startAngle && angle <= endAngle)
        || (angle + PI2 >= startAngle && angle + PI2 <= endAngle);
}


/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = containStroke;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_curve_js__ = __webpack_require__(57);

function containStroke(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
    if (lineWidth === 0) {
        return false;
    }
    var _l = lineWidth;
    if ((y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l)
        || (y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l)
        || (x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l)
        || (x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l)) {
        return false;
    }
    var d = __WEBPACK_IMPORTED_MODULE_0__core_curve_js__["h" /* cubicProjectPoint */](x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
    return d <= _l / 2;
}


/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = contain;
/* harmony export (immutable) */ __webpack_exports__["a"] = containStroke;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_PathProxy_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line_js__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cubic_js__ = __webpack_require__(1697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quadratic_js__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__arc_js__ = __webpack_require__(1696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_curve_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__windingLine_js__ = __webpack_require__(582);







var CMD = __WEBPACK_IMPORTED_MODULE_0__core_PathProxy_js__["a" /* default */].CMD;
var PI2 = Math.PI * 2;
var EPSILON = 1e-4;
function isAroundEqual(a, b) {
    return Math.abs(a - b) < EPSILON;
}
var roots = [-1, -1, -1];
var extrema = [-1, -1];
function swapExtrema() {
    var tmp = extrema[0];
    extrema[0] = extrema[1];
    extrema[1] = tmp;
}
function windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
    if ((y > y0 && y > y1 && y > y2 && y > y3)
        || (y < y0 && y < y1 && y < y2 && y < y3)) {
        return 0;
    }
    var nRoots = __WEBPACK_IMPORTED_MODULE_5__core_curve_js__["a" /* cubicRootAt */](y0, y1, y2, y3, y, roots);
    if (nRoots === 0) {
        return 0;
    }
    else {
        var w = 0;
        var nExtrema = -1;
        var y0_ = void 0;
        var y1_ = void 0;
        for (var i = 0; i < nRoots; i++) {
            var t = roots[i];
            var unit = (t === 0 || t === 1) ? 0.5 : 1;
            var x_ = __WEBPACK_IMPORTED_MODULE_5__core_curve_js__["b" /* cubicAt */](x0, x1, x2, x3, t);
            if (x_ < x) {
                continue;
            }
            if (nExtrema < 0) {
                nExtrema = __WEBPACK_IMPORTED_MODULE_5__core_curve_js__["c" /* cubicExtrema */](y0, y1, y2, y3, extrema);
                if (extrema[1] < extrema[0] && nExtrema > 1) {
                    swapExtrema();
                }
                y0_ = __WEBPACK_IMPORTED_MODULE_5__core_curve_js__["b" /* cubicAt */](y0, y1, y2, y3, extrema[0]);
                if (nExtrema > 1) {
                    y1_ = __WEBPACK_IMPORTED_MODULE_5__core_curve_js__["b" /* cubicAt */](y0, y1, y2, y3, extrema[1]);
                }
            }
            if (nExtrema === 2) {
                if (t < extrema[0]) {
                    w += y0_ < y0 ? unit : -unit;
                }
                else if (t < extrema[1]) {
                    w += y1_ < y0_ ? unit : -unit;
                }
                else {
                    w += y3 < y1_ ? unit : -unit;
                }
            }
            else {
                if (t < extrema[0]) {
                    w += y0_ < y0 ? unit : -unit;
                }
                else {
                    w += y3 < y0_ ? unit : -unit;
                }
            }
        }
        return w;
    }
}
function windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
    if ((y > y0 && y > y1 && y > y2)
        || (y < y0 && y < y1 && y < y2)) {
        return 0;
    }
    var nRoots = __WEBPACK_IMPORTED_MODULE_5__core_curve_js__["d" /* quadraticRootAt */](y0, y1, y2, y, roots);
    if (nRoots === 0) {
        return 0;
    }
    else {
        var t = __WEBPACK_IMPORTED_MODULE_5__core_curve_js__["e" /* quadraticExtremum */](y0, y1, y2);
        if (t >= 0 && t <= 1) {
            var w = 0;
            var y_ = __WEBPACK_IMPORTED_MODULE_5__core_curve_js__["f" /* quadraticAt */](y0, y1, y2, t);
            for (var i = 0; i < nRoots; i++) {
                var unit = (roots[i] === 0 || roots[i] === 1) ? 0.5 : 1;
                var x_ = __WEBPACK_IMPORTED_MODULE_5__core_curve_js__["f" /* quadraticAt */](x0, x1, x2, roots[i]);
                if (x_ < x) {
                    continue;
                }
                if (roots[i] < t) {
                    w += y_ < y0 ? unit : -unit;
                }
                else {
                    w += y2 < y_ ? unit : -unit;
                }
            }
            return w;
        }
        else {
            var unit = (roots[0] === 0 || roots[0] === 1) ? 0.5 : 1;
            var x_ = __WEBPACK_IMPORTED_MODULE_5__core_curve_js__["f" /* quadraticAt */](x0, x1, x2, roots[0]);
            if (x_ < x) {
                return 0;
            }
            return y2 < y0 ? unit : -unit;
        }
    }
}
function windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
    y -= cy;
    if (y > r || y < -r) {
        return 0;
    }
    var tmp = Math.sqrt(r * r - y * y);
    roots[0] = -tmp;
    roots[1] = tmp;
    var dTheta = Math.abs(startAngle - endAngle);
    if (dTheta < 1e-4) {
        return 0;
    }
    if (dTheta >= PI2 - 1e-4) {
        startAngle = 0;
        endAngle = PI2;
        var dir = anticlockwise ? 1 : -1;
        if (x >= roots[0] + cx && x <= roots[1] + cx) {
            return dir;
        }
        else {
            return 0;
        }
    }
    if (startAngle > endAngle) {
        var tmp_1 = startAngle;
        startAngle = endAngle;
        endAngle = tmp_1;
    }
    if (startAngle < 0) {
        startAngle += PI2;
        endAngle += PI2;
    }
    var w = 0;
    for (var i = 0; i < 2; i++) {
        var x_ = roots[i];
        if (x_ + cx > x) {
            var angle = Math.atan2(y, x_);
            var dir = anticlockwise ? 1 : -1;
            if (angle < 0) {
                angle = PI2 + angle;
            }
            if ((angle >= startAngle && angle <= endAngle)
                || (angle + PI2 >= startAngle && angle + PI2 <= endAngle)) {
                if (angle > Math.PI / 2 && angle < Math.PI * 1.5) {
                    dir = -dir;
                }
                w += dir;
            }
        }
    }
    return w;
}
function containPath(path, lineWidth, isStroke, x, y) {
    var data = path.data;
    var len = path.len();
    var w = 0;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    for (var i = 0; i < len;) {
        var cmd = data[i++];
        var isFirst = i === 1;
        if (cmd === CMD.M && i > 1) {
            if (!isStroke) {
                w += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__windingLine_js__["a" /* default */])(xi, yi, x0, y0, x, y);
            }
        }
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        switch (cmd) {
            case CMD.M:
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case CMD.L:
                if (isStroke) {
                    if (__WEBPACK_IMPORTED_MODULE_1__line_js__["a" /* containStroke */](xi, yi, data[i], data[i + 1], lineWidth, x, y)) {
                        return true;
                    }
                }
                else {
                    w += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__windingLine_js__["a" /* default */])(xi, yi, data[i], data[i + 1], x, y) || 0;
                }
                xi = data[i++];
                yi = data[i++];
                break;
            case CMD.C:
                if (isStroke) {
                    if (__WEBPACK_IMPORTED_MODULE_2__cubic_js__["a" /* containStroke */](xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
                        return true;
                    }
                }
                else {
                    w += windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                }
                xi = data[i++];
                yi = data[i++];
                break;
            case CMD.Q:
                if (isStroke) {
                    if (__WEBPACK_IMPORTED_MODULE_3__quadratic_js__["a" /* containStroke */](xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
                        return true;
                    }
                }
                else {
                    w += windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                }
                xi = data[i++];
                yi = data[i++];
                break;
            case CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                if (!isFirst) {
                    w += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__windingLine_js__["a" /* default */])(xi, yi, x1, y1, x, y);
                }
                else {
                    x0 = x1;
                    y0 = y1;
                }
                var _x = (x - cx) * ry / rx + cx;
                if (isStroke) {
                    if (__WEBPACK_IMPORTED_MODULE_4__arc_js__["a" /* containStroke */](cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) {
                        return true;
                    }
                }
                else {
                    w += windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
                }
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                x1 = x0 + width;
                y1 = y0 + height;
                if (isStroke) {
                    if (__WEBPACK_IMPORTED_MODULE_1__line_js__["a" /* containStroke */](x0, y0, x1, y0, lineWidth, x, y)
                        || __WEBPACK_IMPORTED_MODULE_1__line_js__["a" /* containStroke */](x1, y0, x1, y1, lineWidth, x, y)
                        || __WEBPACK_IMPORTED_MODULE_1__line_js__["a" /* containStroke */](x1, y1, x0, y1, lineWidth, x, y)
                        || __WEBPACK_IMPORTED_MODULE_1__line_js__["a" /* containStroke */](x0, y1, x0, y0, lineWidth, x, y)) {
                        return true;
                    }
                }
                else {
                    w += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__windingLine_js__["a" /* default */])(x1, y0, x1, y1, x, y);
                    w += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__windingLine_js__["a" /* default */])(x0, y1, x0, y0, x, y);
                }
                break;
            case CMD.Z:
                if (isStroke) {
                    if (__WEBPACK_IMPORTED_MODULE_1__line_js__["a" /* containStroke */](xi, yi, x0, y0, lineWidth, x, y)) {
                        return true;
                    }
                }
                else {
                    w += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__windingLine_js__["a" /* default */])(xi, yi, x0, y0, x, y);
                }
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (!isStroke && !isAroundEqual(yi, y0)) {
        w += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__windingLine_js__["a" /* default */])(xi, yi, x0, y0, x, y) || 0;
    }
    return w !== 0;
}
function contain(pathProxy, x, y) {
    return containPath(pathProxy, 0, false, x, y);
}
function containStroke(pathProxy, lineWidth, x, y) {
    return containPath(pathProxy, lineWidth, true, x, y);
}


/***/ }),
/* 1699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GestureMgr; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_js__ = __webpack_require__(102);

var GestureMgr = (function () {
    function GestureMgr() {
        this._track = [];
    }
    GestureMgr.prototype.recognize = function (event, target, root) {
        this._doTrack(event, target, root);
        return this._recognize(event);
    };
    GestureMgr.prototype.clear = function () {
        this._track.length = 0;
        return this;
    };
    GestureMgr.prototype._doTrack = function (event, target, root) {
        var touches = event.touches;
        if (!touches) {
            return;
        }
        var trackItem = {
            points: [],
            touches: [],
            target: target,
            event: event
        };
        for (var i = 0, len = touches.length; i < len; i++) {
            var touch = touches[i];
            var pos = __WEBPACK_IMPORTED_MODULE_0__event_js__["c" /* clientToLocal */](root, touch, {});
            trackItem.points.push([pos.zrX, pos.zrY]);
            trackItem.touches.push(touch);
        }
        this._track.push(trackItem);
    };
    GestureMgr.prototype._recognize = function (event) {
        for (var eventName in recognizers) {
            if (recognizers.hasOwnProperty(eventName)) {
                var gestureInfo = recognizers[eventName](this._track, event);
                if (gestureInfo) {
                    return gestureInfo;
                }
            }
        }
    };
    return GestureMgr;
}());

function dist(pointPair) {
    var dx = pointPair[1][0] - pointPair[0][0];
    var dy = pointPair[1][1] - pointPair[0][1];
    return Math.sqrt(dx * dx + dy * dy);
}
function center(pointPair) {
    return [
        (pointPair[0][0] + pointPair[1][0]) / 2,
        (pointPair[0][1] + pointPair[1][1]) / 2
    ];
}
var recognizers = {
    pinch: function (tracks, event) {
        var trackLen = tracks.length;
        if (!trackLen) {
            return;
        }
        var pinchEnd = (tracks[trackLen - 1] || {}).points;
        var pinchPre = (tracks[trackLen - 2] || {}).points || pinchEnd;
        if (pinchPre
            && pinchPre.length > 1
            && pinchEnd
            && pinchEnd.length > 1) {
            var pinchScale = dist(pinchEnd) / dist(pinchPre);
            !isFinite(pinchScale) && (pinchScale = 1);
            event.pinchScale = pinchScale;
            var pinchCenter = center(pinchEnd);
            event.pinchX = pinchCenter[0];
            event.pinchY = pinchCenter[1];
            return {
                type: 'pinch',
                target: tracks[0].target,
                event: event
            };
        }
    }
};


/***/ }),
/* 1700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Point_js__ = __webpack_require__(255);

var extent = [0, 0];
var extent2 = [0, 0];
var minTv = new __WEBPACK_IMPORTED_MODULE_0__Point_js__["a" /* default */]();
var maxTv = new __WEBPACK_IMPORTED_MODULE_0__Point_js__["a" /* default */]();
var OrientedBoundingRect = (function () {
    function OrientedBoundingRect(rect, transform) {
        this._corners = [];
        this._axes = [];
        this._origin = [0, 0];
        for (var i = 0; i < 4; i++) {
            this._corners[i] = new __WEBPACK_IMPORTED_MODULE_0__Point_js__["a" /* default */]();
        }
        for (var i = 0; i < 2; i++) {
            this._axes[i] = new __WEBPACK_IMPORTED_MODULE_0__Point_js__["a" /* default */]();
        }
        if (rect) {
            this.fromBoundingRect(rect, transform);
        }
    }
    OrientedBoundingRect.prototype.fromBoundingRect = function (rect, transform) {
        var corners = this._corners;
        var axes = this._axes;
        var x = rect.x;
        var y = rect.y;
        var x2 = x + rect.width;
        var y2 = y + rect.height;
        corners[0].set(x, y);
        corners[1].set(x2, y);
        corners[2].set(x2, y2);
        corners[3].set(x, y2);
        if (transform) {
            for (var i = 0; i < 4; i++) {
                corners[i].transform(transform);
            }
        }
        __WEBPACK_IMPORTED_MODULE_0__Point_js__["a" /* default */].sub(axes[0], corners[1], corners[0]);
        __WEBPACK_IMPORTED_MODULE_0__Point_js__["a" /* default */].sub(axes[1], corners[3], corners[0]);
        axes[0].normalize();
        axes[1].normalize();
        for (var i = 0; i < 2; i++) {
            this._origin[i] = axes[i].dot(corners[0]);
        }
    };
    OrientedBoundingRect.prototype.intersect = function (other, mtv) {
        var overlapped = true;
        var noMtv = !mtv;
        minTv.set(Infinity, Infinity);
        maxTv.set(0, 0);
        if (!this._intersectCheckOneSide(this, other, minTv, maxTv, noMtv, 1)) {
            overlapped = false;
            if (noMtv) {
                return overlapped;
            }
        }
        if (!this._intersectCheckOneSide(other, this, minTv, maxTv, noMtv, -1)) {
            overlapped = false;
            if (noMtv) {
                return overlapped;
            }
        }
        if (!noMtv) {
            __WEBPACK_IMPORTED_MODULE_0__Point_js__["a" /* default */].copy(mtv, overlapped ? minTv : maxTv);
        }
        return overlapped;
    };
    OrientedBoundingRect.prototype._intersectCheckOneSide = function (self, other, minTv, maxTv, noMtv, inverse) {
        var overlapped = true;
        for (var i = 0; i < 2; i++) {
            var axis = this._axes[i];
            this._getProjMinMaxOnAxis(i, self._corners, extent);
            this._getProjMinMaxOnAxis(i, other._corners, extent2);
            if (extent[1] < extent2[0] || extent[0] > extent2[1]) {
                overlapped = false;
                if (noMtv) {
                    return overlapped;
                }
                var dist0 = Math.abs(extent2[0] - extent[1]);
                var dist1 = Math.abs(extent[0] - extent2[1]);
                if (Math.min(dist0, dist1) > maxTv.len()) {
                    if (dist0 < dist1) {
                        __WEBPACK_IMPORTED_MODULE_0__Point_js__["a" /* default */].scale(maxTv, axis, -dist0 * inverse);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_0__Point_js__["a" /* default */].scale(maxTv, axis, dist1 * inverse);
                    }
                }
            }
            else if (minTv) {
                var dist0 = Math.abs(extent2[0] - extent[1]);
                var dist1 = Math.abs(extent[0] - extent2[1]);
                if (Math.min(dist0, dist1) < minTv.len()) {
                    if (dist0 < dist1) {
                        __WEBPACK_IMPORTED_MODULE_0__Point_js__["a" /* default */].scale(minTv, axis, dist0 * inverse);
                    }
                    else {
                        __WEBPACK_IMPORTED_MODULE_0__Point_js__["a" /* default */].scale(minTv, axis, -dist1 * inverse);
                    }
                }
            }
        }
        return overlapped;
    };
    OrientedBoundingRect.prototype._getProjMinMaxOnAxis = function (dim, corners, out) {
        var axis = this._axes[dim];
        var origin = this._origin;
        var proj = corners[0].dot(axis) + origin[dim];
        var min = proj;
        var max = proj;
        for (var i = 1; i < corners.length; i++) {
            var proj_1 = corners[i].dot(axis) + origin[dim];
            min = Math.min(proj_1, min);
            max = Math.max(proj_1, max);
        }
        out[0] = min;
        out[1] = max;
    };
    return OrientedBoundingRect;
}());
/* harmony default export */ __webpack_exports__["a"] = (OrientedBoundingRect);


/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var wmUniqueIndex = Math.round(Math.random() * 9);
var supportDefineProperty = typeof Object.defineProperty === 'function';
var WeakMap = (function () {
    function WeakMap() {
        this._id = '__ec_inner_' + wmUniqueIndex++;
    }
    WeakMap.prototype.get = function (key) {
        return this._guard(key)[this._id];
    };
    WeakMap.prototype.set = function (key, value) {
        var target = this._guard(key);
        if (supportDefineProperty) {
            Object.defineProperty(target, this._id, {
                value: value,
                enumerable: false,
                configurable: true
            });
        }
        else {
            target[this._id] = value;
        }
        return this;
    };
    WeakMap.prototype["delete"] = function (key) {
        if (this.has(key)) {
            delete this._guard(key)[this._id];
            return true;
        }
        return false;
    };
    WeakMap.prototype.has = function (key) {
        return !!this._guard(key)[this._id];
    };
    WeakMap.prototype._guard = function (key) {
        if (key !== Object(key)) {
            throw TypeError('Value of WeakMap is not a non-null object.');
        }
        return key;
    };
    return WeakMap;
}());
/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),
/* 1702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildTransformer;
var LN2 = Math.log(2);
function determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
    var cacheKey = rowMask + '-' + colMask;
    var fullRank = rows.length;
    if (detCache.hasOwnProperty(cacheKey)) {
        return detCache[cacheKey];
    }
    if (rank === 1) {
        var colStart = Math.round(Math.log(((1 << fullRank) - 1) & ~colMask) / LN2);
        return rows[rowStart][colStart];
    }
    var subRowMask = rowMask | (1 << rowStart);
    var subRowStart = rowStart + 1;
    while (rowMask & (1 << subRowStart)) {
        subRowStart++;
    }
    var sum = 0;
    for (var j = 0, colLocalIdx = 0; j < fullRank; j++) {
        var colTag = 1 << j;
        if (!(colTag & colMask)) {
            sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j]
                * determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
            colLocalIdx++;
        }
    }
    detCache[cacheKey] = sum;
    return sum;
}
function buildTransformer(src, dest) {
    var mA = [
        [src[0], src[1], 1, 0, 0, 0, -dest[0] * src[0], -dest[0] * src[1]],
        [0, 0, 0, src[0], src[1], 1, -dest[1] * src[0], -dest[1] * src[1]],
        [src[2], src[3], 1, 0, 0, 0, -dest[2] * src[2], -dest[2] * src[3]],
        [0, 0, 0, src[2], src[3], 1, -dest[3] * src[2], -dest[3] * src[3]],
        [src[4], src[5], 1, 0, 0, 0, -dest[4] * src[4], -dest[4] * src[5]],
        [0, 0, 0, src[4], src[5], 1, -dest[5] * src[4], -dest[5] * src[5]],
        [src[6], src[7], 1, 0, 0, 0, -dest[6] * src[6], -dest[6] * src[7]],
        [0, 0, 0, src[6], src[7], 1, -dest[7] * src[6], -dest[7] * src[7]]
    ];
    var detCache = {};
    var det = determinant(mA, 8, 0, 0, 0, detCache);
    if (det === 0) {
        return;
    }
    var vh = [];
    for (var i = 0; i < 8; i++) {
        for (var j = 0; j < 8; j++) {
            vh[j] == null && (vh[j] = 0);
            vh[j] += ((i + j) % 2 ? -1 : 1)
                * determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache)
                / det * dest[i];
        }
    }
    return function (out, srcPointX, srcPointY) {
        var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
        out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
        out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
    };
}


/***/ }),
/* 1703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_event_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_Eventful_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_env_js__ = __webpack_require__(35);





var TOUCH_CLICK_DELAY = 300;
var globalEventSupported = __WEBPACK_IMPORTED_MODULE_4__core_env_js__["a" /* default */].domSupported;
var localNativeListenerNames = (function () {
    var mouseHandlerNames = [
        'click', 'dblclick', 'mousewheel', 'wheel', 'mouseout',
        'mouseup', 'mousedown', 'mousemove', 'contextmenu'
    ];
    var touchHandlerNames = [
        'touchstart', 'touchend', 'touchmove'
    ];
    var pointerEventNameMap = {
        pointerdown: 1, pointerup: 1, pointermove: 1, pointerout: 1
    };
    var pointerHandlerNames = __WEBPACK_IMPORTED_MODULE_2__core_util_js__["map"](mouseHandlerNames, function (name) {
        var nm = name.replace('mouse', 'pointer');
        return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
    });
    return {
        mouse: mouseHandlerNames,
        touch: touchHandlerNames,
        pointer: pointerHandlerNames
    };
})();
var globalNativeListenerNames = {
    mouse: ['mousemove', 'mouseup'],
    pointer: ['pointermove', 'pointerup']
};
var wheelEventSupported = false;
function isPointerFromTouch(event) {
    var pointerType = event.pointerType;
    return pointerType === 'pen' || pointerType === 'touch';
}
function setTouchTimer(scope) {
    scope.touching = true;
    if (scope.touchTimer != null) {
        clearTimeout(scope.touchTimer);
        scope.touchTimer = null;
    }
    scope.touchTimer = setTimeout(function () {
        scope.touching = false;
        scope.touchTimer = null;
    }, 700);
}
function markTouch(event) {
    event && (event.zrByTouch = true);
}
function normalizeGlobalEvent(instance, event) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_event_js__["d" /* normalizeEvent */])(instance.dom, new FakeGlobalEvent(instance, event), true);
}
function isLocalEl(instance, el) {
    var elTmp = el;
    var isLocal = false;
    while (elTmp && elTmp.nodeType !== 9
        && !(isLocal = elTmp.domBelongToZr
            || (elTmp !== el && elTmp === instance.painterRoot))) {
        elTmp = elTmp.parentNode;
    }
    return isLocal;
}
var FakeGlobalEvent = (function () {
    function FakeGlobalEvent(instance, event) {
        this.stopPropagation = __WEBPACK_IMPORTED_MODULE_2__core_util_js__["noop"];
        this.stopImmediatePropagation = __WEBPACK_IMPORTED_MODULE_2__core_util_js__["noop"];
        this.preventDefault = __WEBPACK_IMPORTED_MODULE_2__core_util_js__["noop"];
        this.type = event.type;
        this.target = this.currentTarget = instance.dom;
        this.pointerType = event.pointerType;
        this.clientX = event.clientX;
        this.clientY = event.clientY;
    }
    return FakeGlobalEvent;
}());
var localDOMHandlers = {
    mousedown: function (event) {
        event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_event_js__["d" /* normalizeEvent */])(this.dom, event);
        this.__mayPointerCapture = [event.zrX, event.zrY];
        this.trigger('mousedown', event);
    },
    mousemove: function (event) {
        event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_event_js__["d" /* normalizeEvent */])(this.dom, event);
        var downPoint = this.__mayPointerCapture;
        if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) {
            this.__togglePointerCapture(true);
        }
        this.trigger('mousemove', event);
    },
    mouseup: function (event) {
        event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_event_js__["d" /* normalizeEvent */])(this.dom, event);
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
    },
    mouseout: function (event) {
        event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_event_js__["d" /* normalizeEvent */])(this.dom, event);
        var element = event.toElement || event.relatedTarget;
        if (!isLocalEl(this, element)) {
            if (this.__pointerCapturing) {
                event.zrEventControl = 'no_globalout';
            }
            this.trigger('mouseout', event);
        }
    },
    wheel: function (event) {
        wheelEventSupported = true;
        event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_event_js__["d" /* normalizeEvent */])(this.dom, event);
        this.trigger('mousewheel', event);
    },
    mousewheel: function (event) {
        if (wheelEventSupported) {
            return;
        }
        event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_event_js__["d" /* normalizeEvent */])(this.dom, event);
        this.trigger('mousewheel', event);
    },
    touchstart: function (event) {
        event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_event_js__["d" /* normalizeEvent */])(this.dom, event);
        markTouch(event);
        this.__lastTouchMoment = new Date();
        this.handler.processGesture(event, 'start');
        localDOMHandlers.mousemove.call(this, event);
        localDOMHandlers.mousedown.call(this, event);
    },
    touchmove: function (event) {
        event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_event_js__["d" /* normalizeEvent */])(this.dom, event);
        markTouch(event);
        this.handler.processGesture(event, 'change');
        localDOMHandlers.mousemove.call(this, event);
    },
    touchend: function (event) {
        event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_event_js__["d" /* normalizeEvent */])(this.dom, event);
        markTouch(event);
        this.handler.processGesture(event, 'end');
        localDOMHandlers.mouseup.call(this, event);
        if (+new Date() - (+this.__lastTouchMoment) < TOUCH_CLICK_DELAY) {
            localDOMHandlers.click.call(this, event);
        }
    },
    pointerdown: function (event) {
        localDOMHandlers.mousedown.call(this, event);
    },
    pointermove: function (event) {
        if (!isPointerFromTouch(event)) {
            localDOMHandlers.mousemove.call(this, event);
        }
    },
    pointerup: function (event) {
        localDOMHandlers.mouseup.call(this, event);
    },
    pointerout: function (event) {
        if (!isPointerFromTouch(event)) {
            localDOMHandlers.mouseout.call(this, event);
        }
    }
};
__WEBPACK_IMPORTED_MODULE_2__core_util_js__["each"](['click', 'dblclick', 'contextmenu'], function (name) {
    localDOMHandlers[name] = function (event) {
        event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_event_js__["d" /* normalizeEvent */])(this.dom, event);
        this.trigger(name, event);
    };
});
var globalDOMHandlers = {
    pointermove: function (event) {
        if (!isPointerFromTouch(event)) {
            globalDOMHandlers.mousemove.call(this, event);
        }
    },
    pointerup: function (event) {
        globalDOMHandlers.mouseup.call(this, event);
    },
    mousemove: function (event) {
        this.trigger('mousemove', event);
    },
    mouseup: function (event) {
        var pointerCaptureReleasing = this.__pointerCapturing;
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
        if (pointerCaptureReleasing) {
            event.zrEventControl = 'only_globalout';
            this.trigger('mouseout', event);
        }
    }
};
function mountLocalDOMEventListeners(instance, scope) {
    var domHandlers = scope.domHandlers;
    if (__WEBPACK_IMPORTED_MODULE_4__core_env_js__["a" /* default */].pointerEventsSupported) {
        __WEBPACK_IMPORTED_MODULE_2__core_util_js__["each"](localNativeListenerNames.pointer, function (nativeEventName) {
            mountSingleDOMEventListener(scope, nativeEventName, function (event) {
                domHandlers[nativeEventName].call(instance, event);
            });
        });
    }
    else {
        if (__WEBPACK_IMPORTED_MODULE_4__core_env_js__["a" /* default */].touchEventsSupported) {
            __WEBPACK_IMPORTED_MODULE_2__core_util_js__["each"](localNativeListenerNames.touch, function (nativeEventName) {
                mountSingleDOMEventListener(scope, nativeEventName, function (event) {
                    domHandlers[nativeEventName].call(instance, event);
                    setTouchTimer(scope);
                });
            });
        }
        __WEBPACK_IMPORTED_MODULE_2__core_util_js__["each"](localNativeListenerNames.mouse, function (nativeEventName) {
            mountSingleDOMEventListener(scope, nativeEventName, function (event) {
                event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_event_js__["e" /* getNativeEvent */])(event);
                if (!scope.touching) {
                    domHandlers[nativeEventName].call(instance, event);
                }
            });
        });
    }
}
function mountGlobalDOMEventListeners(instance, scope) {
    if (__WEBPACK_IMPORTED_MODULE_4__core_env_js__["a" /* default */].pointerEventsSupported) {
        __WEBPACK_IMPORTED_MODULE_2__core_util_js__["each"](globalNativeListenerNames.pointer, mount);
    }
    else if (!__WEBPACK_IMPORTED_MODULE_4__core_env_js__["a" /* default */].touchEventsSupported) {
        __WEBPACK_IMPORTED_MODULE_2__core_util_js__["each"](globalNativeListenerNames.mouse, mount);
    }
    function mount(nativeEventName) {
        function nativeEventListener(event) {
            event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_event_js__["e" /* getNativeEvent */])(event);
            if (!isLocalEl(instance, event.target)) {
                event = normalizeGlobalEvent(instance, event);
                scope.domHandlers[nativeEventName].call(instance, event);
            }
        }
        mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, { capture: true });
    }
}
function mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
    scope.mounted[nativeEventName] = listener;
    scope.listenerOpts[nativeEventName] = opt;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_event_js__["f" /* addEventListener */])(scope.domTarget, nativeEventName, listener, opt);
}
function unmountDOMEventListeners(scope) {
    var mounted = scope.mounted;
    for (var nativeEventName in mounted) {
        if (mounted.hasOwnProperty(nativeEventName)) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_event_js__["g" /* removeEventListener */])(scope.domTarget, nativeEventName, mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
        }
    }
    scope.mounted = {};
}
var DOMHandlerScope = (function () {
    function DOMHandlerScope(domTarget, domHandlers) {
        this.mounted = {};
        this.listenerOpts = {};
        this.touching = false;
        this.domTarget = domTarget;
        this.domHandlers = domHandlers;
    }
    return DOMHandlerScope;
}());
var HandlerDomProxy = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(HandlerDomProxy, _super);
    function HandlerDomProxy(dom, painterRoot) {
        var _this = _super.call(this) || this;
        _this.__pointerCapturing = false;
        _this.dom = dom;
        _this.painterRoot = painterRoot;
        _this._localHandlerScope = new DOMHandlerScope(dom, localDOMHandlers);
        if (globalEventSupported) {
            _this._globalHandlerScope = new DOMHandlerScope(document, globalDOMHandlers);
        }
        mountLocalDOMEventListeners(_this, _this._localHandlerScope);
        return _this;
    }
    HandlerDomProxy.prototype.dispose = function () {
        unmountDOMEventListeners(this._localHandlerScope);
        if (globalEventSupported) {
            unmountDOMEventListeners(this._globalHandlerScope);
        }
    };
    HandlerDomProxy.prototype.setCursor = function (cursorStyle) {
        this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
    };
    HandlerDomProxy.prototype.__togglePointerCapture = function (isPointerCapturing) {
        this.__mayPointerCapture = null;
        if (globalEventSupported
            && ((+this.__pointerCapturing) ^ (+isPointerCapturing))) {
            this.__pointerCapturing = isPointerCapturing;
            var globalHandlerScope = this._globalHandlerScope;
            isPointerCapturing
                ? mountGlobalDOMEventListeners(this, globalHandlerScope)
                : unmountDOMEventListeners(globalHandlerScope);
        }
    };
    return HandlerDomProxy;
}(__WEBPACK_IMPORTED_MODULE_3__core_Eventful_js__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (HandlerDomProxy);


/***/ }),
/* 1704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Displayable_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_BoundingRect_js__ = __webpack_require__(22);



var m = [];
var IncrementalDisplayable = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(IncrementalDisplayable, _super);
    function IncrementalDisplayable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notClear = true;
        _this.incremental = true;
        _this._displayables = [];
        _this._temporaryDisplayables = [];
        _this._cursor = 0;
        return _this;
    }
    IncrementalDisplayable.prototype.traverse = function (cb, context) {
        cb.call(context, this);
    };
    IncrementalDisplayable.prototype.useStyle = function () {
        this.style = {};
    };
    IncrementalDisplayable.prototype.getCursor = function () {
        return this._cursor;
    };
    IncrementalDisplayable.prototype.innerAfterBrush = function () {
        this._cursor = this._displayables.length;
    };
    IncrementalDisplayable.prototype.clearDisplaybles = function () {
        this._displayables = [];
        this._temporaryDisplayables = [];
        this._cursor = 0;
        this.markRedraw();
        this.notClear = false;
    };
    IncrementalDisplayable.prototype.clearTemporalDisplayables = function () {
        this._temporaryDisplayables = [];
    };
    IncrementalDisplayable.prototype.addDisplayable = function (displayable, notPersistent) {
        if (notPersistent) {
            this._temporaryDisplayables.push(displayable);
        }
        else {
            this._displayables.push(displayable);
        }
        this.markRedraw();
    };
    IncrementalDisplayable.prototype.addDisplayables = function (displayables, notPersistent) {
        notPersistent = notPersistent || false;
        for (var i = 0; i < displayables.length; i++) {
            this.addDisplayable(displayables[i], notPersistent);
        }
    };
    IncrementalDisplayable.prototype.getDisplayables = function () {
        return this._displayables;
    };
    IncrementalDisplayable.prototype.getTemporalDisplayables = function () {
        return this._temporaryDisplayables;
    };
    IncrementalDisplayable.prototype.eachPendingDisplayable = function (cb) {
        for (var i = this._cursor; i < this._displayables.length; i++) {
            cb && cb(this._displayables[i]);
        }
        for (var i = 0; i < this._temporaryDisplayables.length; i++) {
            cb && cb(this._temporaryDisplayables[i]);
        }
    };
    IncrementalDisplayable.prototype.update = function () {
        this.updateTransform();
        for (var i = this._cursor; i < this._displayables.length; i++) {
            var displayable = this._displayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
        for (var i = 0; i < this._temporaryDisplayables.length; i++) {
            var displayable = this._temporaryDisplayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
    };
    IncrementalDisplayable.prototype.getBoundingRect = function () {
        if (!this._rect) {
            var rect = new __WEBPACK_IMPORTED_MODULE_2__core_BoundingRect_js__["a" /* default */](Infinity, Infinity, -Infinity, -Infinity);
            for (var i = 0; i < this._displayables.length; i++) {
                var displayable = this._displayables[i];
                var childRect = displayable.getBoundingRect().clone();
                if (displayable.needLocalTransform()) {
                    childRect.applyTransform(displayable.getLocalTransform(m));
                }
                rect.union(childRect);
            }
            this._rect = rect;
        }
        return this._rect;
    };
    IncrementalDisplayable.prototype.contain = function (x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        if (rect.contain(localPos[0], localPos[1])) {
            for (var i = 0; i < this._displayables.length; i++) {
                var displayable = this._displayables[i];
                if (displayable.contain(x, y)) {
                    return true;
                }
            }
        }
        return false;
    };
    return IncrementalDisplayable;
}(__WEBPACK_IMPORTED_MODULE_1__Displayable_js__["c" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (IncrementalDisplayable);


/***/ }),
/* 1705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildPath;
function buildPath(ctx, shape) {
    var x = shape.x;
    var y = shape.y;
    var width = shape.width;
    var height = shape.height;
    var r = shape.r;
    var r1;
    var r2;
    var r3;
    var r4;
    if (width < 0) {
        x = x + width;
        width = -width;
    }
    if (height < 0) {
        y = y + height;
        height = -height;
    }
    if (typeof r === 'number') {
        r1 = r2 = r3 = r4 = r;
    }
    else if (r instanceof Array) {
        if (r.length === 1) {
            r1 = r2 = r3 = r4 = r[0];
        }
        else if (r.length === 2) {
            r1 = r3 = r[0];
            r2 = r4 = r[1];
        }
        else if (r.length === 3) {
            r1 = r[0];
            r2 = r4 = r[1];
            r3 = r[2];
        }
        else {
            r1 = r[0];
            r2 = r[1];
            r3 = r[2];
            r4 = r[3];
        }
    }
    else {
        r1 = r2 = r3 = r4 = 0;
    }
    var total;
    if (r1 + r2 > width) {
        total = r1 + r2;
        r1 *= width / total;
        r2 *= width / total;
    }
    if (r3 + r4 > width) {
        total = r3 + r4;
        r3 *= width / total;
        r4 *= width / total;
    }
    if (r2 + r3 > height) {
        total = r2 + r3;
        r2 *= height / total;
        r3 *= height / total;
    }
    if (r1 + r4 > height) {
        total = r1 + r4;
        r1 *= height / total;
        r4 *= height / total;
    }
    ctx.moveTo(x + r1, y);
    ctx.lineTo(x + width - r2, y);
    r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
    ctx.lineTo(x + width, y + height - r3);
    r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
    ctx.lineTo(x + r4, y + height);
    r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
    ctx.lineTo(x, y + r1);
    r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
}


/***/ }),
/* 1706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_util_js__ = __webpack_require__(0);

var PI = Math.PI;
var PI2 = PI * 2;
var mathSin = Math.sin;
var mathCos = Math.cos;
var mathACos = Math.acos;
var mathATan2 = Math.atan2;
var mathAbs = Math.abs;
var mathSqrt = Math.sqrt;
var mathMax = Math.max;
var mathMin = Math.min;
var e = 1e-4;
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var dx10 = x1 - x0;
    var dy10 = y1 - y0;
    var dx32 = x3 - x2;
    var dy32 = y3 - y2;
    var t = dy32 * dx10 - dx32 * dy10;
    if (t * t < e) {
        return;
    }
    t = (dx32 * (y0 - y2) - dy32 * (x0 - x2)) / t;
    return [x0 + t * dx10, y0 + t * dy10];
}
function computeCornerTangents(x0, y0, x1, y1, radius, cr, clockwise) {
    var x01 = x0 - x1;
    var y01 = y0 - y1;
    var lo = (clockwise ? cr : -cr) / mathSqrt(x01 * x01 + y01 * y01);
    var ox = lo * y01;
    var oy = -lo * x01;
    var x11 = x0 + ox;
    var y11 = y0 + oy;
    var x10 = x1 + ox;
    var y10 = y1 + oy;
    var x00 = (x11 + x10) / 2;
    var y00 = (y11 + y10) / 2;
    var dx = x10 - x11;
    var dy = y10 - y11;
    var d2 = dx * dx + dy * dy;
    var r = radius - cr;
    var s = x11 * y10 - x10 * y11;
    var d = (dy < 0 ? -1 : 1) * mathSqrt(mathMax(0, r * r * d2 - s * s));
    var cx0 = (s * dy - dx * d) / d2;
    var cy0 = (-s * dx - dy * d) / d2;
    var cx1 = (s * dy + dx * d) / d2;
    var cy1 = (-s * dx + dy * d) / d2;
    var dx0 = cx0 - x00;
    var dy0 = cy0 - y00;
    var dx1 = cx1 - x00;
    var dy1 = cy1 - y00;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
        cx0 = cx1;
        cy0 = cy1;
    }
    return {
        cx: cx0,
        cy: cy0,
        x0: -ox,
        y0: -oy,
        x1: cx0 * (radius / r - 1),
        y1: cy0 * (radius / r - 1)
    };
}
function normalizeCornerRadius(cr) {
    var arr;
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["isArray"])(cr)) {
        var len = cr.length;
        if (!len) {
            return cr;
        }
        if (len === 1) {
            arr = [cr[0], cr[0], 0, 0];
        }
        else if (len === 2) {
            arr = [cr[0], cr[0], cr[1], cr[1]];
        }
        else if (len === 3) {
            arr = cr.concat(cr[2]);
        }
        else {
            arr = cr;
        }
    }
    else {
        arr = [cr, cr, cr, cr];
    }
    return arr;
}
function buildPath(ctx, shape) {
    var _a;
    var radius = mathMax(shape.r, 0);
    var innerRadius = mathMax(shape.r0 || 0, 0);
    var hasRadius = radius > 0;
    var hasInnerRadius = innerRadius > 0;
    if (!hasRadius && !hasInnerRadius) {
        return;
    }
    if (!hasRadius) {
        radius = innerRadius;
        innerRadius = 0;
    }
    if (innerRadius > radius) {
        var tmp = radius;
        radius = innerRadius;
        innerRadius = tmp;
    }
    var startAngle = shape.startAngle, endAngle = shape.endAngle;
    if (isNaN(startAngle) || isNaN(endAngle)) {
        return;
    }
    var cx = shape.cx, cy = shape.cy;
    var clockwise = !!shape.clockwise;
    var arc = mathAbs(endAngle - startAngle);
    var mod = arc > PI2 && arc % PI2;
    mod > e && (arc = mod);
    if (!(radius > e)) {
        ctx.moveTo(cx, cy);
    }
    else if (arc > PI2 - e) {
        ctx.moveTo(cx + radius * mathCos(startAngle), cy + radius * mathSin(startAngle));
        ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        if (innerRadius > e) {
            ctx.moveTo(cx + innerRadius * mathCos(endAngle), cy + innerRadius * mathSin(endAngle));
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    }
    else {
        var icrStart = void 0;
        var icrEnd = void 0;
        var ocrStart = void 0;
        var ocrEnd = void 0;
        var ocrs = void 0;
        var ocre = void 0;
        var icrs = void 0;
        var icre = void 0;
        var ocrMax = void 0;
        var icrMax = void 0;
        var limitedOcrMax = void 0;
        var limitedIcrMax = void 0;
        var xre = void 0;
        var yre = void 0;
        var xirs = void 0;
        var yirs = void 0;
        var xrs = radius * mathCos(startAngle);
        var yrs = radius * mathSin(startAngle);
        var xire = innerRadius * mathCos(endAngle);
        var yire = innerRadius * mathSin(endAngle);
        var hasArc = arc > e;
        if (hasArc) {
            var cornerRadius = shape.cornerRadius;
            if (cornerRadius) {
                _a = normalizeCornerRadius(cornerRadius), icrStart = _a[0], icrEnd = _a[1], ocrStart = _a[2], ocrEnd = _a[3];
            }
            var halfRd = mathAbs(radius - innerRadius) / 2;
            ocrs = mathMin(halfRd, ocrStart);
            ocre = mathMin(halfRd, ocrEnd);
            icrs = mathMin(halfRd, icrStart);
            icre = mathMin(halfRd, icrEnd);
            limitedOcrMax = ocrMax = mathMax(ocrs, ocre);
            limitedIcrMax = icrMax = mathMax(icrs, icre);
            if (ocrMax > e || icrMax > e) {
                xre = radius * mathCos(endAngle);
                yre = radius * mathSin(endAngle);
                xirs = innerRadius * mathCos(startAngle);
                yirs = innerRadius * mathSin(startAngle);
                if (arc < PI) {
                    var it_1 = intersect(xrs, yrs, xirs, yirs, xre, yre, xire, yire);
                    if (it_1) {
                        var x0 = xrs - it_1[0];
                        var y0 = yrs - it_1[1];
                        var x1 = xre - it_1[0];
                        var y1 = yre - it_1[1];
                        var a = 1 / mathSin(mathACos((x0 * x1 + y0 * y1) / (mathSqrt(x0 * x0 + y0 * y0) * mathSqrt(x1 * x1 + y1 * y1))) / 2);
                        var b = mathSqrt(it_1[0] * it_1[0] + it_1[1] * it_1[1]);
                        limitedOcrMax = mathMin(ocrMax, (radius - b) / (a + 1));
                        limitedIcrMax = mathMin(icrMax, (innerRadius - b) / (a - 1));
                    }
                }
            }
        }
        if (!hasArc) {
            ctx.moveTo(cx + xrs, cy + yrs);
        }
        else if (limitedOcrMax > e) {
            var crStart = mathMin(ocrStart, limitedOcrMax);
            var crEnd = mathMin(ocrEnd, limitedOcrMax);
            var ct0 = computeCornerTangents(xirs, yirs, xrs, yrs, radius, crStart, clockwise);
            var ct1 = computeCornerTangents(xre, yre, xire, yire, radius, crEnd, clockwise);
            ctx.moveTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedOcrMax < ocrMax && crStart === crEnd) {
                ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedOcrMax, mathATan2(ct0.y0, ct0.x0), mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
            else {
                crStart > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crStart, mathATan2(ct0.y0, ct0.x0), mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, radius, mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), !clockwise);
                crEnd > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crEnd, mathATan2(ct1.y1, ct1.x1), mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        }
        else {
            ctx.moveTo(cx + xrs, cy + yrs);
            ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        }
        if (!(innerRadius > e) || !hasArc) {
            ctx.lineTo(cx + xire, cy + yire);
        }
        else if (limitedIcrMax > e) {
            var crStart = mathMin(icrStart, limitedIcrMax);
            var crEnd = mathMin(icrEnd, limitedIcrMax);
            var ct0 = computeCornerTangents(xire, yire, xre, yre, innerRadius, -crEnd, clockwise);
            var ct1 = computeCornerTangents(xrs, yrs, xirs, yirs, innerRadius, -crStart, clockwise);
            ctx.lineTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedIcrMax < icrMax && crStart === crEnd) {
                ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedIcrMax, mathATan2(ct0.y0, ct0.x0), mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
            else {
                crEnd > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crEnd, mathATan2(ct0.y0, ct0.x0), mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, innerRadius, mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), clockwise);
                crStart > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crStart, mathATan2(ct1.y1, ct1.x1), mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        }
        else {
            ctx.lineTo(cx + xire, cy + yire);
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    }
    ctx.closePath();
}


/***/ }),
/* 1707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = smoothBezier;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_vector_js__ = __webpack_require__(23);

function smoothBezier(points, smooth, isLoop, constraint) {
    var cps = [];
    var v = [];
    var v1 = [];
    var v2 = [];
    var prevPoint;
    var nextPoint;
    var min;
    var max;
    if (constraint) {
        min = [Infinity, Infinity];
        max = [-Infinity, -Infinity];
        for (var i = 0, len = points.length; i < len; i++) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_vector_js__["min"])(min, min, points[i]);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_vector_js__["max"])(max, max, points[i]);
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_vector_js__["min"])(min, min, constraint[0]);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_vector_js__["max"])(max, max, constraint[1]);
    }
    for (var i = 0, len = points.length; i < len; i++) {
        var point = points[i];
        if (isLoop) {
            prevPoint = points[i ? i - 1 : len - 1];
            nextPoint = points[(i + 1) % len];
        }
        else {
            if (i === 0 || i === len - 1) {
                cps.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_vector_js__["clone"])(points[i]));
                continue;
            }
            else {
                prevPoint = points[i - 1];
                nextPoint = points[i + 1];
            }
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_vector_js__["sub"])(v, nextPoint, prevPoint);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_vector_js__["scale"])(v, v, smooth);
        var d0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_vector_js__["distance"])(point, prevPoint);
        var d1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_vector_js__["distance"])(point, nextPoint);
        var sum = d0 + d1;
        if (sum !== 0) {
            d0 /= sum;
            d1 /= sum;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_vector_js__["scale"])(v1, v, -d0);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_vector_js__["scale"])(v2, v, d1);
        var cp0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_vector_js__["add"])([], point, v1);
        var cp1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_vector_js__["add"])([], point, v2);
        if (constraint) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_vector_js__["max"])(cp0, cp0, min);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_vector_js__["min"])(cp0, cp0, max);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_vector_js__["max"])(cp1, cp1, min);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_vector_js__["min"])(cp1, cp1, max);
        }
        cps.push(cp0);
        cps.push(cp1);
    }
    if (isLoop) {
        cps.push(cps.shift());
    }
    return cps;
}


/***/ }),
/* 1708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ArcShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Path_js__ = __webpack_require__(24);


var ArcShape = (function () {
    function ArcShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return ArcShape;
}());

var Arc = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Arc, _super);
    function Arc(opts) {
        return _super.call(this, opts) || this;
    }
    Arc.prototype.getDefaultStyle = function () {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Arc.prototype.getDefaultShape = function () {
        return new ArcShape();
    };
    Arc.prototype.buildPath = function (ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var r = Math.max(shape.r, 0);
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var unitX = Math.cos(startAngle);
        var unitY = Math.sin(startAngle);
        ctx.moveTo(unitX * r + x, unitY * r + y);
        ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    };
    return Arc;
}(__WEBPACK_IMPORTED_MODULE_1__Path_js__["a" /* default */]));
Arc.prototype.type = 'arc';
/* harmony default export */ __webpack_exports__["a"] = (Arc);


/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BezierCurveShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Path_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_vector_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_curve_js__ = __webpack_require__(57);




var out = [];
var BezierCurveShape = (function () {
    function BezierCurveShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.percent = 1;
    }
    return BezierCurveShape;
}());

function someVectorAt(shape, t, isTangent) {
    var cpx2 = shape.cpx2;
    var cpy2 = shape.cpy2;
    if (cpx2 != null || cpy2 != null) {
        return [
            (isTangent ? __WEBPACK_IMPORTED_MODULE_3__core_curve_js__["m" /* cubicDerivativeAt */] : __WEBPACK_IMPORTED_MODULE_3__core_curve_js__["b" /* cubicAt */])(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t),
            (isTangent ? __WEBPACK_IMPORTED_MODULE_3__core_curve_js__["m" /* cubicDerivativeAt */] : __WEBPACK_IMPORTED_MODULE_3__core_curve_js__["b" /* cubicAt */])(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)
        ];
    }
    else {
        return [
            (isTangent ? __WEBPACK_IMPORTED_MODULE_3__core_curve_js__["n" /* quadraticDerivativeAt */] : __WEBPACK_IMPORTED_MODULE_3__core_curve_js__["f" /* quadraticAt */])(shape.x1, shape.cpx1, shape.x2, t),
            (isTangent ? __WEBPACK_IMPORTED_MODULE_3__core_curve_js__["n" /* quadraticDerivativeAt */] : __WEBPACK_IMPORTED_MODULE_3__core_curve_js__["f" /* quadraticAt */])(shape.y1, shape.cpy1, shape.y2, t)
        ];
    }
}
var BezierCurve = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(BezierCurve, _super);
    function BezierCurve(opts) {
        return _super.call(this, opts) || this;
    }
    BezierCurve.prototype.getDefaultStyle = function () {
        return {
            stroke: '#000',
            fill: null
        };
    };
    BezierCurve.prototype.getDefaultShape = function () {
        return new BezierCurveShape();
    };
    BezierCurve.prototype.buildPath = function (ctx, shape) {
        var x1 = shape.x1;
        var y1 = shape.y1;
        var x2 = shape.x2;
        var y2 = shape.y2;
        var cpx1 = shape.cpx1;
        var cpy1 = shape.cpy1;
        var cpx2 = shape.cpx2;
        var cpy2 = shape.cpy2;
        var percent = shape.percent;
        if (percent === 0) {
            return;
        }
        ctx.moveTo(x1, y1);
        if (cpx2 == null || cpy2 == null) {
            if (percent < 1) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_curve_js__["l" /* quadraticSubdivide */])(x1, cpx1, x2, percent, out);
                cpx1 = out[1];
                x2 = out[2];
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_curve_js__["l" /* quadraticSubdivide */])(y1, cpy1, y2, percent, out);
                cpy1 = out[1];
                y2 = out[2];
            }
            ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
        }
        else {
            if (percent < 1) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_curve_js__["k" /* cubicSubdivide */])(x1, cpx1, cpx2, x2, percent, out);
                cpx1 = out[1];
                cpx2 = out[2];
                x2 = out[3];
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_curve_js__["k" /* cubicSubdivide */])(y1, cpy1, cpy2, y2, percent, out);
                cpy1 = out[1];
                cpy2 = out[2];
                y2 = out[3];
            }
            ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
        }
    };
    BezierCurve.prototype.pointAt = function (t) {
        return someVectorAt(this.shape, t, false);
    };
    BezierCurve.prototype.tangentAt = function (t) {
        var p = someVectorAt(this.shape, t, true);
        return __WEBPACK_IMPORTED_MODULE_2__core_vector_js__["normalize"](p, p);
    };
    return BezierCurve;
}(__WEBPACK_IMPORTED_MODULE_1__Path_js__["a" /* default */]));
;
BezierCurve.prototype.type = 'bezier-curve';
/* harmony default export */ __webpack_exports__["a"] = (BezierCurve);


/***/ }),
/* 1710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RingShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Path_js__ = __webpack_require__(24);


var RingShape = (function () {
    function RingShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.r0 = 0;
    }
    return RingShape;
}());

var Ring = (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __extends */])(Ring, _super);
    function Ring(opts) {
        return _super.call(this, opts) || this;
    }
    Ring.prototype.getDefaultShape = function () {
        return new RingShape();
    };
    Ring.prototype.buildPath = function (ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var PI2 = Math.PI * 2;
        ctx.moveTo(x + shape.r, y);
        ctx.arc(x, y, shape.r, 0, PI2, false);
        ctx.moveTo(x + shape.r0, y);
        ctx.arc(x, y, shape.r0, 0, PI2, true);
    };
    return Ring;
}(__WEBPACK_IMPORTED_MODULE_1__Path_js__["a" /* default */]));
Ring.prototype.type = 'ring';
/* harmony default export */ __webpack_exports__["a"] = (Ring);


/***/ }),
/* 1711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Param = (function () {
    function Param(target, e) {
        this.target = target;
        this.topTarget = e && e.topTarget;
    }
    return Param;
}());
var Draggable = (function () {
    function Draggable(handler) {
        this.handler = handler;
        handler.on('mousedown', this._dragStart, this);
        handler.on('mousemove', this._drag, this);
        handler.on('mouseup', this._dragEnd, this);
    }
    Draggable.prototype._dragStart = function (e) {
        var draggingTarget = e.target;
        while (draggingTarget && !draggingTarget.draggable) {
            draggingTarget = draggingTarget.parent || draggingTarget.__hostTarget;
        }
        if (draggingTarget) {
            this._draggingTarget = draggingTarget;
            draggingTarget.dragging = true;
            this._x = e.offsetX;
            this._y = e.offsetY;
            this.handler.dispatchToElement(new Param(draggingTarget, e), 'dragstart', e.event);
        }
    };
    Draggable.prototype._drag = function (e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) {
            var x = e.offsetX;
            var y = e.offsetY;
            var dx = x - this._x;
            var dy = y - this._y;
            this._x = x;
            this._y = y;
            draggingTarget.drift(dx, dy, e);
            this.handler.dispatchToElement(new Param(draggingTarget, e), 'drag', e.event);
            var dropTarget = this.handler.findHover(x, y, draggingTarget).target;
            var lastDropTarget = this._dropTarget;
            this._dropTarget = dropTarget;
            if (draggingTarget !== dropTarget) {
                if (lastDropTarget && dropTarget !== lastDropTarget) {
                    this.handler.dispatchToElement(new Param(lastDropTarget, e), 'dragleave', e.event);
                }
                if (dropTarget && dropTarget !== lastDropTarget) {
                    this.handler.dispatchToElement(new Param(dropTarget, e), 'dragenter', e.event);
                }
            }
        }
    };
    Draggable.prototype._dragEnd = function (e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) {
            draggingTarget.dragging = false;
        }
        this.handler.dispatchToElement(new Param(draggingTarget, e), 'dragend', e.event);
        if (this._dropTarget) {
            this.handler.dispatchToElement(new Param(this._dropTarget, e), 'drop', e.event);
        }
        this._draggingTarget = null;
        this._dropTarget = null;
    };
    return Draggable;
}());
/* harmony default export */ __webpack_exports__["a"] = (Draggable);


/***/ }),
/* 1712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphic_js__ = __webpack_require__(1715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_js__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_js__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__patch_js__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__canvas_helper_js__ = __webpack_require__(254);






var svgId = 0;
var SVGPainter = (function () {
    function SVGPainter(root, storage, opts) {
        this.type = 'svg';
        this.refreshHover = createMethodNotSupport('refreshHover');
        this.configLayer = createMethodNotSupport('configLayer');
        this.storage = storage;
        this._opts = opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["extend"])({}, opts);
        this.root = root;
        this._id = 'zr' + svgId++;
        this._oldVNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["a" /* createSVGVNode */])(opts.width, opts.height);
        if (root && !opts.ssr) {
            var viewport = this._viewport = document.createElement('div');
            viewport.style.cssText = 'position:relative;overflow:hidden';
            var svgDom = this._svgDom = this._oldVNode.elm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["b" /* createElement */])('svg');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__patch_js__["a" /* updateAttrs */])(null, this._oldVNode);
            viewport.appendChild(svgDom);
            root.appendChild(viewport);
        }
        this.resize(opts.width, opts.height);
    }
    SVGPainter.prototype.getType = function () {
        return this.type;
    };
    SVGPainter.prototype.getViewportRoot = function () {
        return this._viewport;
    };
    SVGPainter.prototype.getViewportRootOffset = function () {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) {
            return {
                offsetLeft: viewportRoot.offsetLeft || 0,
                offsetTop: viewportRoot.offsetTop || 0
            };
        }
    };
    SVGPainter.prototype.getSvgDom = function () {
        return this._svgDom;
    };
    SVGPainter.prototype.refresh = function () {
        if (this.root) {
            var vnode = this.renderToVNode({
                willUpdate: true
            });
            vnode.attrs.style = 'position:absolute;left:0;top:0;user-select:none';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__patch_js__["b" /* default */])(this._oldVNode, vnode);
            this._oldVNode = vnode;
        }
    };
    SVGPainter.prototype.renderOneToVNode = function (el) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__graphic_js__["a" /* brush */])(el, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["c" /* createBrushScope */])(this._id));
    };
    SVGPainter.prototype.renderToVNode = function (opts) {
        opts = opts || {};
        var list = this.storage.getDisplayList(true);
        var bgColor = this._backgroundColor;
        var width = this._width;
        var height = this._height;
        var scope = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["c" /* createBrushScope */])(this._id);
        scope.animation = opts.animation;
        scope.willUpdate = opts.willUpdate;
        scope.compress = opts.compress;
        var children = [];
        if (bgColor && bgColor !== 'none') {
            var _a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_js__["c" /* normalizeColor */])(bgColor), color = _a.color, opacity = _a.opacity;
            this._bgVNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["d" /* createVNode */])('rect', 'bg', {
                width: width,
                height: height,
                x: '0',
                y: '0',
                id: '0',
                fill: color,
                'fill-opacity': opacity
            });
            children.push(this._bgVNode);
        }
        else {
            this._bgVNode = null;
        }
        var mainVNode = !opts.compress
            ? (this._mainVNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["d" /* createVNode */])('g', 'main', {}, [])) : null;
        this._paintList(list, scope, mainVNode ? mainVNode.children : children);
        mainVNode && children.push(mainVNode);
        var defs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["map"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["keys"])(scope.defs), function (id) { return scope.defs[id]; });
        if (defs.length) {
            children.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["d" /* createVNode */])('defs', 'defs', {}, defs));
        }
        if (opts.animation) {
            var animationCssStr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["e" /* getCssString */])(scope.cssNodes, scope.cssAnims, { newline: true });
            if (animationCssStr) {
                var styleNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["d" /* createVNode */])('style', 'stl', {}, [], animationCssStr);
                children.push(styleNode);
            }
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["a" /* createSVGVNode */])(width, height, children, opts.useViewBox);
    };
    SVGPainter.prototype.renderToString = function (opts) {
        opts = opts || {};
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["f" /* vNodeToString */])(this.renderToVNode({
            animation: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["retrieve2"])(opts.cssAnimation, true),
            willUpdate: false,
            compress: true,
            useViewBox: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["retrieve2"])(opts.useViewBox, true)
        }), { newline: true });
    };
    SVGPainter.prototype.setBackgroundColor = function (backgroundColor) {
        this._backgroundColor = backgroundColor;
        var bgVNode = this._bgVNode;
        if (bgVNode && bgVNode.elm) {
            var _a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_js__["c" /* normalizeColor */])(backgroundColor), color = _a.color, opacity = _a.opacity;
            bgVNode.elm.setAttribute('fill', color);
            if (opacity < 1) {
                bgVNode.elm.setAttribute('fill-opacity', opacity);
            }
        }
    };
    SVGPainter.prototype.getSvgRoot = function () {
        return this._mainVNode && this._mainVNode.elm;
    };
    SVGPainter.prototype._paintList = function (list, scope, out) {
        var listLen = list.length;
        var clipPathsGroupsStack = [];
        var clipPathsGroupsStackDepth = 0;
        var currentClipPathGroup;
        var prevClipPaths;
        var clipGroupNodeIdx = 0;
        for (var i = 0; i < listLen; i++) {
            var displayable = list[i];
            if (!displayable.invisible) {
                var clipPaths = displayable.__clipPaths;
                var len = clipPaths && clipPaths.length || 0;
                var prevLen = prevClipPaths && prevClipPaths.length || 0;
                var lca = void 0;
                for (lca = Math.max(len - 1, prevLen - 1); lca >= 0; lca--) {
                    if (clipPaths && prevClipPaths
                        && clipPaths[lca] === prevClipPaths[lca]) {
                        break;
                    }
                }
                for (var i_1 = prevLen - 1; i_1 > lca; i_1--) {
                    clipPathsGroupsStackDepth--;
                    currentClipPathGroup = clipPathsGroupsStack[clipPathsGroupsStackDepth - 1];
                }
                for (var i_2 = lca + 1; i_2 < len; i_2++) {
                    var groupAttrs = {};
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__graphic_js__["b" /* setClipPath */])(clipPaths[i_2], groupAttrs, scope);
                    var g = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["d" /* createVNode */])('g', 'clip-g-' + clipGroupNodeIdx++, groupAttrs, []);
                    (currentClipPathGroup ? currentClipPathGroup.children : out).push(g);
                    clipPathsGroupsStack[clipPathsGroupsStackDepth++] = g;
                    currentClipPathGroup = g;
                }
                prevClipPaths = clipPaths;
                var ret = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__graphic_js__["a" /* brush */])(displayable, scope);
                if (ret) {
                    (currentClipPathGroup ? currentClipPathGroup.children : out).push(ret);
                }
            }
        }
    };
    SVGPainter.prototype.resize = function (width, height) {
        var opts = this._opts;
        var root = this.root;
        var viewport = this._viewport;
        width != null && (opts.width = width);
        height != null && (opts.height = height);
        if (root && viewport) {
            viewport.style.display = 'none';
            width = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__canvas_helper_js__["c" /* getSize */])(root, 0, opts);
            height = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__canvas_helper_js__["c" /* getSize */])(root, 1, opts);
            viewport.style.display = '';
        }
        if (this._width !== width || this._height !== height) {
            this._width = width;
            this._height = height;
            if (viewport) {
                var viewportStyle = viewport.style;
                viewportStyle.width = width + 'px';
                viewportStyle.height = height + 'px';
            }
            var svgDom = this._svgDom;
            if (svgDom) {
                svgDom.setAttribute('width', width);
                svgDom.setAttribute('height', height);
            }
        }
    };
    SVGPainter.prototype.getWidth = function () {
        return this._width;
    };
    SVGPainter.prototype.getHeight = function () {
        return this._height;
    };
    SVGPainter.prototype.dispose = function () {
        if (this.root) {
            this.root.innerHTML = '';
        }
        this._svgDom =
            this._viewport =
                this.storage =
                    this._oldVNode =
                        this._bgVNode =
                            this._mainVNode = null;
    };
    SVGPainter.prototype.clear = function () {
        if (this._svgDom) {
            this._svgDom.innerHTML = null;
        }
        this._oldVNode = null;
    };
    SVGPainter.prototype.toDataURL = function (base64) {
        var str = encodeURIComponent(this.renderToString());
        var prefix = 'data:image/svg+xml;';
        if (base64) {
            str = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helper_js__["d" /* encodeBase64 */])(str);
            return str && prefix + 'base64,' + str;
        }
        return prefix + 'charset=UTF-8,' + str;
    };
    return SVGPainter;
}());
function createMethodNotSupport(method) {
    return function () {
        if (true) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["logError"])('In SVG mode painter not support method "' + method + '"');
        }
    };
}
/* harmony default export */ __webpack_exports__["a"] = (SVGPainter);


/***/ }),
/* 1713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EASING_MAP */
/* unused harmony export ANIMATE_STYLE_MAP */
/* harmony export (immutable) */ __webpack_exports__["a"] = createCSSAnimation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_Transformable_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_js__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SVGPathRebuilder_js__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_PathProxy_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_js__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphic_CompoundPath_js__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__animation_cubicEasing_js__ = __webpack_require__(359);








var EASING_MAP = {
    cubicIn: '0.32,0,0.67,0',
    cubicOut: '0.33,1,0.68,1',
    cubicInOut: '0.65,0,0.35,1',
    quadraticIn: '0.11,0,0.5,0',
    quadraticOut: '0.5,1,0.89,1',
    quadraticInOut: '0.45,0,0.55,1',
    quarticIn: '0.5,0,0.75,0',
    quarticOut: '0.25,1,0.5,1',
    quarticInOut: '0.76,0,0.24,1',
    quinticIn: '0.64,0,0.78,0',
    quinticOut: '0.22,1,0.36,1',
    quinticInOut: '0.83,0,0.17,1',
    sinusoidalIn: '0.12,0,0.39,0',
    sinusoidalOut: '0.61,1,0.88,1',
    sinusoidalInOut: '0.37,0,0.63,1',
    exponentialIn: '0.7,0,0.84,0',
    exponentialOut: '0.16,1,0.3,1',
    exponentialInOut: '0.87,0,0.13,1',
    circularIn: '0.55,0,1,0.45',
    circularOut: '0,0.55,0.45,1',
    circularInOut: '0.85,0,0.15,1'
};
var transformOriginKey = 'transform-origin';
function buildPathString(el, kfShape, path) {
    var shape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["extend"])({}, el.shape);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["extend"])(shape, kfShape);
    el.buildPath(path, shape);
    var svgPathBuilder = new __WEBPACK_IMPORTED_MODULE_2__SVGPathRebuilder_js__["a" /* default */]();
    svgPathBuilder.reset(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helper_js__["i" /* getPathPrecision */])(el));
    path.rebuildPath(svgPathBuilder, 1);
    svgPathBuilder.generateStr();
    return svgPathBuilder.getStr();
}
function setTransformOrigin(target, transform) {
    var originX = transform.originX, originY = transform.originY;
    if (originX || originY) {
        target[transformOriginKey] = originX + "px " + originY + "px";
    }
}
var ANIMATE_STYLE_MAP = {
    fill: 'fill',
    opacity: 'opacity',
    lineWidth: 'stroke-width',
    lineDashOffset: 'stroke-dashoffset'
};
function addAnimation(cssAnim, scope) {
    var animationName = scope.zrId + '-ani-' + scope.cssAnimIdx++;
    scope.cssAnims[animationName] = cssAnim;
    return animationName;
}
function createCompoundPathCSSAnimation(el, attrs, scope) {
    var paths = el.shape.paths;
    var composedAnim = {};
    var cssAnimationCfg;
    var cssAnimationName;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["each"])(paths, function (path) {
        var subScope = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["c" /* createBrushScope */])(scope.zrId);
        subScope.animation = true;
        createCSSAnimation(path, {}, subScope, true);
        var cssAnims = subScope.cssAnims;
        var cssNodes = subScope.cssNodes;
        var animNames = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["keys"])(cssAnims);
        var len = animNames.length;
        if (!len) {
            return;
        }
        cssAnimationName = animNames[len - 1];
        var lastAnim = cssAnims[cssAnimationName];
        for (var percent in lastAnim) {
            var kf = lastAnim[percent];
            composedAnim[percent] = composedAnim[percent] || { d: '' };
            composedAnim[percent].d += kf.d || '';
        }
        for (var className in cssNodes) {
            var val = cssNodes[className].animation;
            if (val.indexOf(cssAnimationName) >= 0) {
                cssAnimationCfg = val;
            }
        }
    });
    if (!cssAnimationCfg) {
        return;
    }
    attrs.d = false;
    var animationName = addAnimation(composedAnim, scope);
    return cssAnimationCfg.replace(cssAnimationName, animationName);
}
function getEasingFunc(easing) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["isString"])(easing)
        ? EASING_MAP[easing]
            ? "cubic-bezier(" + EASING_MAP[easing] + ")"
            : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__animation_cubicEasing_js__["a" /* createCubicEasingFunc */])(easing) ? easing : ''
        : '';
}
function createCSSAnimation(el, attrs, scope, onlyShape) {
    var animators = el.animators;
    var len = animators.length;
    var cssAnimations = [];
    if (el instanceof __WEBPACK_IMPORTED_MODULE_6__graphic_CompoundPath_js__["a" /* default */]) {
        var animationCfg = createCompoundPathCSSAnimation(el, attrs, scope);
        if (animationCfg) {
            cssAnimations.push(animationCfg);
        }
        else if (!len) {
            return;
        }
    }
    else if (!len) {
        return;
    }
    var groupAnimators = {};
    for (var i = 0; i < len; i++) {
        var animator = animators[i];
        var cfgArr = [animator.getMaxTime() / 1000 + 's'];
        var easing = getEasingFunc(animator.getClip().easing);
        var delay = animator.getDelay();
        if (easing) {
            cfgArr.push(easing);
        }
        else {
            cfgArr.push('linear');
        }
        if (delay) {
            cfgArr.push(delay / 1000 + 's');
        }
        if (animator.getLoop()) {
            cfgArr.push('infinite');
        }
        var cfg = cfgArr.join(' ');
        groupAnimators[cfg] = groupAnimators[cfg] || [cfg, []];
        groupAnimators[cfg][1].push(animator);
    }
    function createSingleCSSAnimation(groupAnimator) {
        var animators = groupAnimator[1];
        var len = animators.length;
        var transformKfs = {};
        var shapeKfs = {};
        var finalKfs = {};
        var animationTimingFunctionAttrName = 'animation-timing-function';
        function saveAnimatorTrackToCssKfs(animator, cssKfs, toCssAttrName) {
            var tracks = animator.getTracks();
            var maxTime = animator.getMaxTime();
            for (var k = 0; k < tracks.length; k++) {
                var track = tracks[k];
                if (track.needsAnimate()) {
                    var kfs = track.keyframes;
                    var attrName = track.propName;
                    toCssAttrName && (attrName = toCssAttrName(attrName));
                    if (attrName) {
                        for (var i = 0; i < kfs.length; i++) {
                            var kf = kfs[i];
                            var percent = Math.round(kf.time / maxTime * 100) + '%';
                            var kfEasing = getEasingFunc(kf.easing);
                            var rawValue = kf.rawValue;
                            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["isString"])(rawValue) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["isNumber"])(rawValue)) {
                                cssKfs[percent] = cssKfs[percent] || {};
                                cssKfs[percent][attrName] = kf.rawValue;
                                if (kfEasing) {
                                    cssKfs[percent][animationTimingFunctionAttrName] = kfEasing;
                                }
                            }
                        }
                    }
                }
            }
        }
        for (var i = 0; i < len; i++) {
            var animator = animators[i];
            var targetProp = animator.targetName;
            if (!targetProp) {
                !onlyShape && saveAnimatorTrackToCssKfs(animator, transformKfs);
            }
            else if (targetProp === 'shape') {
                saveAnimatorTrackToCssKfs(animator, shapeKfs);
            }
        }
        for (var percent in transformKfs) {
            var transform = {};
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_Transformable_js__["c" /* copyTransform */])(transform, el);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["extend"])(transform, transformKfs[percent]);
            var str = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helper_js__["q" /* getSRTTransformString */])(transform);
            var timingFunction = transformKfs[percent][animationTimingFunctionAttrName];
            finalKfs[percent] = str ? {
                transform: str
            } : {};
            setTransformOrigin(finalKfs[percent], transform);
            if (timingFunction) {
                finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
            }
        }
        ;
        var path;
        var canAnimateShape = true;
        for (var percent in shapeKfs) {
            finalKfs[percent] = finalKfs[percent] || {};
            var isFirst = !path;
            var timingFunction = shapeKfs[percent][animationTimingFunctionAttrName];
            if (isFirst) {
                path = new __WEBPACK_IMPORTED_MODULE_3__core_PathProxy_js__["a" /* default */]();
            }
            var len_1 = path.len();
            path.reset();
            finalKfs[percent].d = buildPathString(el, shapeKfs[percent], path);
            var newLen = path.len();
            if (!isFirst && len_1 !== newLen) {
                canAnimateShape = false;
                break;
            }
            if (timingFunction) {
                finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
            }
        }
        ;
        if (!canAnimateShape) {
            for (var percent in finalKfs) {
                delete finalKfs[percent].d;
            }
        }
        if (!onlyShape) {
            for (var i = 0; i < len; i++) {
                var animator = animators[i];
                var targetProp = animator.targetName;
                if (targetProp === 'style') {
                    saveAnimatorTrackToCssKfs(animator, finalKfs, function (propName) { return ANIMATE_STYLE_MAP[propName]; });
                }
            }
        }
        var percents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["keys"])(finalKfs);
        var allTransformOriginSame = true;
        var transformOrigin;
        for (var i = 1; i < percents.length; i++) {
            var p0 = percents[i - 1];
            var p1 = percents[i];
            if (finalKfs[p0][transformOriginKey] !== finalKfs[p1][transformOriginKey]) {
                allTransformOriginSame = false;
                break;
            }
            transformOrigin = finalKfs[p0][transformOriginKey];
        }
        if (allTransformOriginSame && transformOrigin) {
            for (var percent in finalKfs) {
                if (finalKfs[percent][transformOriginKey]) {
                    delete finalKfs[percent][transformOriginKey];
                }
            }
            attrs[transformOriginKey] = transformOrigin;
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["filter"])(percents, function (percent) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__core_util_js__["keys"])(finalKfs[percent]).length > 0; }).length) {
            var animationName = addAnimation(finalKfs, scope);
            return animationName + " " + groupAnimator[0] + " both";
        }
    }
    for (var key in groupAnimators) {
        var animationCfg = createSingleCSSAnimation(groupAnimators[key]);
        if (animationCfg) {
            cssAnimations.push(animationCfg);
        }
    }
    if (cssAnimations.length) {
        var className = scope.zrId + '-cls-' + scope.cssClassIdx++;
        scope.cssNodes['.' + className] = {
            animation: cssAnimations.join(',')
        };
        attrs["class"] = className;
    }
}


/***/ }),
/* 1714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createTextNode;
/* unused harmony export createComment */
/* harmony export (immutable) */ __webpack_exports__["c"] = insertBefore;
/* harmony export (immutable) */ __webpack_exports__["e"] = removeChild;
/* harmony export (immutable) */ __webpack_exports__["a"] = appendChild;
/* harmony export (immutable) */ __webpack_exports__["d"] = parentNode;
/* harmony export (immutable) */ __webpack_exports__["f"] = nextSibling;
/* unused harmony export tagName */
/* harmony export (immutable) */ __webpack_exports__["g"] = setTextContent;
/* unused harmony export getTextContent */
/* unused harmony export isElement */
/* unused harmony export isText */
/* unused harmony export isComment */
function createTextNode(text) {
    return document.createTextNode(text);
}
function createComment(text) {
    return document.createComment(text);
}
function insertBefore(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function removeChild(node, child) {
    node.removeChild(child);
}
function appendChild(node, child) {
    node.appendChild(child);
}
function parentNode(node) {
    return node.parentNode;
}
function nextSibling(node) {
    return node.nextSibling;
}
function tagName(elm) {
    return elm.tagName;
}
function setTextContent(node, text) {
    node.textContent = text;
}
function getTextContent(node) {
    return node.textContent;
}
function isElement(node) {
    return node.nodeType === 1;
}
function isText(node) {
    return node.nodeType === 3;
}
function isComment(node) {
    return node.nodeType === 8;
}


/***/ }),
/* 1715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export brushSVGPath */
/* unused harmony export brushSVGImage */
/* unused harmony export brushSVGTSpan */
/* harmony export (immutable) */ __webpack_exports__["a"] = brush;
/* harmony export (immutable) */ __webpack_exports__["b"] = setClipPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_js__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphic_Path_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphic_Image_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contain_text_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphic_TSpan_js__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SVGPathRebuilder_js__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mapStyleToAttrs_js__ = __webpack_require__(1716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_js__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__graphic_helper_image_js__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cssAnimation_js__ = __webpack_require__(1713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__graphic_Text_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__core_platform_js__ = __webpack_require__(67);













var round = Math.round;
function isImageLike(val) {
    return val && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__core_util_js__["isString"])(val.src);
}
function isCanvasLike(val) {
    return val && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__core_util_js__["isFunction"])(val.toDataURL);
}
function setStyleAttrs(attrs, style, el, scope) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__mapStyleToAttrs_js__["a" /* default */])(function (key, val) {
        var isFillStroke = key === 'fill' || key === 'stroke';
        if (isFillStroke && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["e" /* isGradient */])(val)) {
            setGradient(style, attrs, key, scope);
        }
        else if (isFillStroke && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["f" /* isPattern */])(val)) {
            setPattern(el, attrs, key, scope);
        }
        else {
            attrs[key] = val;
        }
    }, style, el, false);
    setShadow(el, attrs, scope);
}
function noRotateScale(m) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["g" /* isAroundZero */])(m[0] - 1)
        && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["g" /* isAroundZero */])(m[1])
        && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["g" /* isAroundZero */])(m[2])
        && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["g" /* isAroundZero */])(m[3] - 1);
}
function noTranslate(m) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["g" /* isAroundZero */])(m[4]) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["g" /* isAroundZero */])(m[5]);
}
function setTransform(attrs, m, compress) {
    if (m && !(noTranslate(m) && noRotateScale(m))) {
        var mul = compress ? 10 : 1e4;
        attrs.transform = noRotateScale(m)
            ? "translate(" + round(m[4] * mul) / mul + " " + round(m[5] * mul) / mul + ")" : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["h" /* getMatrixStr */])(m);
    }
}
function convertPolyShape(shape, attrs, mul) {
    var points = shape.points;
    var strArr = [];
    for (var i = 0; i < points.length; i++) {
        strArr.push(round(points[i][0] * mul) / mul);
        strArr.push(round(points[i][1] * mul) / mul);
    }
    attrs.points = strArr.join(' ');
}
function validatePolyShape(shape) {
    return !shape.smooth;
}
function createAttrsConvert(desc) {
    var normalizedDesc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__core_util_js__["map"])(desc, function (item) {
        return (typeof item === 'string' ? [item, item] : item);
    });
    return function (shape, attrs, mul) {
        for (var i = 0; i < normalizedDesc.length; i++) {
            var item = normalizedDesc[i];
            var val = shape[item[0]];
            if (val != null) {
                attrs[item[1]] = round(val * mul) / mul;
            }
        }
    };
}
var buitinShapesDef = {
    circle: [createAttrsConvert(['cx', 'cy', 'r'])],
    polyline: [convertPolyShape, validatePolyShape],
    polygon: [convertPolyShape, validatePolyShape]
};
function hasShapeAnimation(el) {
    var animators = el.animators;
    for (var i = 0; i < animators.length; i++) {
        if (animators[i].targetName === 'shape') {
            return true;
        }
    }
    return false;
}
function brushSVGPath(el, scope) {
    var style = el.style;
    var shape = el.shape;
    var builtinShpDef = buitinShapesDef[el.type];
    var attrs = {};
    var needsAnimate = scope.animation;
    var svgElType = 'path';
    var strokePercent = el.style.strokePercent;
    var precision = (scope.compress && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["i" /* getPathPrecision */])(el)) || 4;
    if (builtinShpDef
        && !scope.willUpdate
        && !(builtinShpDef[1] && !builtinShpDef[1](shape))
        && !(needsAnimate && hasShapeAnimation(el))
        && !(strokePercent < 1)) {
        svgElType = el.type;
        var mul = Math.pow(10, precision);
        builtinShpDef[0](shape, attrs, mul);
    }
    else {
        if (!el.path) {
            el.createPathProxy();
        }
        var path = el.path;
        if (el.shapeChanged()) {
            path.beginPath();
            el.buildPath(path, el.shape);
            el.pathUpdated();
        }
        var pathVersion = path.getVersion();
        var elExt = el;
        var svgPathBuilder = elExt.__svgPathBuilder;
        if (elExt.__svgPathVersion !== pathVersion
            || !svgPathBuilder
            || strokePercent !== elExt.__svgPathStrokePercent) {
            if (!svgPathBuilder) {
                svgPathBuilder = elExt.__svgPathBuilder = new __WEBPACK_IMPORTED_MODULE_5__SVGPathRebuilder_js__["a" /* default */]();
            }
            svgPathBuilder.reset(precision);
            path.rebuildPath(svgPathBuilder, strokePercent);
            svgPathBuilder.generateStr();
            elExt.__svgPathVersion = pathVersion;
            elExt.__svgPathStrokePercent = strokePercent;
        }
        attrs.d = svgPathBuilder.getStr();
    }
    setTransform(attrs, el.transform);
    setStyleAttrs(attrs, style, el, scope);
    scope.animation && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__cssAnimation_js__["a" /* createCSSAnimation */])(el, attrs, scope);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__core_js__["d" /* createVNode */])(svgElType, el.id + '', attrs);
}
function brushSVGImage(el, scope) {
    var style = el.style;
    var image = style.image;
    if (image && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__core_util_js__["isString"])(image)) {
        if (isImageLike(image)) {
            image = image.src;
        }
        else if (isCanvasLike(image)) {
            image = image.toDataURL();
        }
    }
    if (!image) {
        return;
    }
    var x = style.x || 0;
    var y = style.y || 0;
    var dw = style.width;
    var dh = style.height;
    var attrs = {
        href: image,
        width: dw,
        height: dh
    };
    if (x) {
        attrs.x = x;
    }
    if (y) {
        attrs.y = y;
    }
    setTransform(attrs, el.transform);
    setStyleAttrs(attrs, style, el, scope);
    scope.animation && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__cssAnimation_js__["a" /* createCSSAnimation */])(el, attrs, scope);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__core_js__["d" /* createVNode */])('image', el.id + '', attrs);
}
;
function brushSVGTSpan(el, scope) {
    var style = el.style;
    var text = style.text;
    text != null && (text += '');
    if (!text || isNaN(style.x) || isNaN(style.y)) {
        return;
    }
    var font = style.font || __WEBPACK_IMPORTED_MODULE_12__core_platform_js__["b" /* DEFAULT_FONT */];
    var x = style.x || 0;
    var y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["j" /* adjustTextY */])(style.y || 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__contain_text_js__["f" /* getLineHeight */])(font), style.textBaseline);
    var textAlign = __WEBPACK_IMPORTED_MODULE_0__helper_js__["k" /* TEXT_ALIGN_TO_ANCHOR */][style.textAlign]
        || style.textAlign;
    var attrs = {
        'dominant-baseline': 'central',
        'text-anchor': textAlign
    };
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__graphic_Text_js__["b" /* hasSeparateFont */])(style)) {
        var separatedFontStr = '';
        var fontStyle = style.fontStyle;
        var fontSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__graphic_Text_js__["c" /* parseFontSize */])(style.fontSize);
        if (!parseFloat(fontSize)) {
            return;
        }
        var fontFamily = style.fontFamily || __WEBPACK_IMPORTED_MODULE_12__core_platform_js__["e" /* DEFAULT_FONT_FAMILY */];
        var fontWeight = style.fontWeight;
        separatedFontStr += "font-size:" + fontSize + ";font-family:" + fontFamily + ";";
        if (fontStyle && fontStyle !== 'normal') {
            separatedFontStr += "font-style:" + fontStyle + ";";
        }
        if (fontWeight && fontWeight !== 'normal') {
            separatedFontStr += "font-weight:" + fontWeight + ";";
        }
        attrs.style = separatedFontStr;
    }
    else {
        attrs.style = "font: " + font;
    }
    if (text.match(/\s/)) {
        attrs['xml:space'] = 'preserve';
    }
    if (x) {
        attrs.x = x;
    }
    if (y) {
        attrs.y = y;
    }
    setTransform(attrs, el.transform);
    setStyleAttrs(attrs, style, el, scope);
    scope.animation && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__cssAnimation_js__["a" /* createCSSAnimation */])(el, attrs, scope);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__core_js__["d" /* createVNode */])('text', el.id + '', attrs, undefined, text);
}
function brush(el, scope) {
    if (el instanceof __WEBPACK_IMPORTED_MODULE_1__graphic_Path_js__["a" /* default */]) {
        return brushSVGPath(el, scope);
    }
    else if (el instanceof __WEBPACK_IMPORTED_MODULE_2__graphic_Image_js__["a" /* default */]) {
        return brushSVGImage(el, scope);
    }
    else if (el instanceof __WEBPACK_IMPORTED_MODULE_4__graphic_TSpan_js__["a" /* default */]) {
        return brushSVGTSpan(el, scope);
    }
}
function setShadow(el, attrs, scope) {
    var style = el.style;
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["l" /* hasShadow */])(style)) {
        var shadowKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["m" /* getShadowKey */])(el);
        var shadowCache = scope.shadowCache;
        var shadowId = shadowCache[shadowKey];
        if (!shadowId) {
            var globalScale = el.getGlobalScale();
            var scaleX = globalScale[0];
            var scaleY = globalScale[1];
            if (!scaleX || !scaleY) {
                return;
            }
            var offsetX = style.shadowOffsetX || 0;
            var offsetY = style.shadowOffsetY || 0;
            var blur_1 = style.shadowBlur;
            var _a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["c" /* normalizeColor */])(style.shadowColor), opacity = _a.opacity, color = _a.color;
            var stdDx = blur_1 / 2 / scaleX;
            var stdDy = blur_1 / 2 / scaleY;
            var stdDeviation = stdDx + ' ' + stdDy;
            shadowId = scope.zrId + '-s' + scope.shadowIdx++;
            scope.defs[shadowId] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__core_js__["d" /* createVNode */])('filter', shadowId, {
                'id': shadowId,
                'x': '-100%',
                'y': '-100%',
                'width': '300%',
                'height': '300%'
            }, [
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__core_js__["d" /* createVNode */])('feDropShadow', '', {
                    'dx': offsetX / scaleX,
                    'dy': offsetY / scaleY,
                    'stdDeviation': stdDeviation,
                    'flood-color': color,
                    'flood-opacity': opacity
                })
            ]);
            shadowCache[shadowKey] = shadowId;
        }
        attrs.filter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["n" /* getIdURL */])(shadowId);
    }
}
function setGradient(style, attrs, target, scope) {
    var val = style[target];
    var gradientTag;
    var gradientAttrs = {
        'gradientUnits': val.global
            ? 'userSpaceOnUse'
            : 'objectBoundingBox'
    };
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["a" /* isLinearGradient */])(val)) {
        gradientTag = 'linearGradient';
        gradientAttrs.x1 = val.x;
        gradientAttrs.y1 = val.y;
        gradientAttrs.x2 = val.x2;
        gradientAttrs.y2 = val.y2;
    }
    else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["b" /* isRadialGradient */])(val)) {
        gradientTag = 'radialGradient';
        gradientAttrs.cx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__core_util_js__["retrieve2"])(val.x, 0.5);
        gradientAttrs.cy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__core_util_js__["retrieve2"])(val.y, 0.5);
        gradientAttrs.r = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__core_util_js__["retrieve2"])(val.r, 0.5);
    }
    else {
        if (true) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__core_util_js__["logError"])('Illegal gradient type.');
        }
        return;
    }
    var colors = val.colorStops;
    var colorStops = [];
    for (var i = 0, len = colors.length; i < len; ++i) {
        var offset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["o" /* round4 */])(colors[i].offset) * 100 + '%';
        var stopColor = colors[i].color;
        var _a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["c" /* normalizeColor */])(stopColor), color = _a.color, opacity = _a.opacity;
        var stopsAttrs = {
            'offset': offset
        };
        stopsAttrs['stop-color'] = color;
        if (opacity < 1) {
            stopsAttrs['stop-opacity'] = opacity;
        }
        colorStops.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__core_js__["d" /* createVNode */])('stop', i + '', stopsAttrs));
    }
    var gradientVNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__core_js__["d" /* createVNode */])(gradientTag, '', gradientAttrs, colorStops);
    var gradientKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__core_js__["f" /* vNodeToString */])(gradientVNode);
    var gradientCache = scope.gradientCache;
    var gradientId = gradientCache[gradientKey];
    if (!gradientId) {
        gradientId = scope.zrId + '-g' + scope.gradientIdx++;
        gradientCache[gradientKey] = gradientId;
        gradientAttrs.id = gradientId;
        scope.defs[gradientId] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__core_js__["d" /* createVNode */])(gradientTag, gradientId, gradientAttrs, colorStops);
    }
    attrs[target] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["n" /* getIdURL */])(gradientId);
}
function setPattern(el, attrs, target, scope) {
    var val = el.style[target];
    var patternAttrs = {
        'patternUnits': 'userSpaceOnUse'
    };
    var child;
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["p" /* isImagePattern */])(val)) {
        var imageWidth_1 = val.imageWidth;
        var imageHeight_1 = val.imageHeight;
        var imageSrc = void 0;
        var patternImage = val.image;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__core_util_js__["isString"])(patternImage)) {
            imageSrc = patternImage;
        }
        else if (isImageLike(patternImage)) {
            imageSrc = patternImage.src;
        }
        else if (isCanvasLike(patternImage)) {
            imageSrc = patternImage.toDataURL();
        }
        if (typeof Image === 'undefined') {
            var errMsg = 'Image width/height must been given explictly in svg-ssr renderer.';
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__core_util_js__["assert"])(imageWidth_1, errMsg);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__core_util_js__["assert"])(imageHeight_1, errMsg);
        }
        else if (imageWidth_1 == null || imageHeight_1 == null) {
            var setSizeToVNode_1 = function (vNode, img) {
                if (vNode) {
                    var svgEl = vNode.elm;
                    var width = (vNode.attrs.width = imageWidth_1 || img.width);
                    var height = (vNode.attrs.height = imageHeight_1 || img.height);
                    if (svgEl) {
                        svgEl.setAttribute('width', width);
                        svgEl.setAttribute('height', height);
                    }
                }
            };
            var createdImage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__graphic_helper_image_js__["c" /* createOrUpdateImage */])(imageSrc, null, el, function (img) {
                setSizeToVNode_1(patternVNode, img);
                setSizeToVNode_1(child, img);
            });
            if (createdImage && createdImage.width && createdImage.height) {
                imageWidth_1 = imageWidth_1 || createdImage.width;
                imageHeight_1 = imageHeight_1 || createdImage.height;
            }
        }
        child = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__core_js__["d" /* createVNode */])('image', 'img', {
            href: imageSrc,
            width: imageWidth_1,
            height: imageHeight_1
        });
        patternAttrs.width = imageWidth_1;
        patternAttrs.height = imageHeight_1;
    }
    else if (val.svgElement) {
        child = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__core_util_js__["clone"])(val.svgElement);
        patternAttrs.width = val.svgWidth;
        patternAttrs.height = val.svgHeight;
    }
    if (!child) {
        return;
    }
    patternAttrs.patternTransform = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["q" /* getSRTTransformString */])(val);
    var patternVNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__core_js__["d" /* createVNode */])('pattern', '', patternAttrs, [child]);
    var patternKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__core_js__["f" /* vNodeToString */])(patternVNode);
    var patternCache = scope.patternCache;
    var patternId = patternCache[patternKey];
    if (!patternId) {
        patternId = scope.zrId + '-p' + scope.patternIdx++;
        patternCache[patternKey] = patternId;
        patternAttrs.id = patternId;
        patternVNode = scope.defs[patternId] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__core_js__["d" /* createVNode */])('pattern', patternId, patternAttrs, [child]);
    }
    attrs[target] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["n" /* getIdURL */])(patternId);
}
function setClipPath(clipPath, attrs, scope) {
    var clipPathCache = scope.clipPathCache, defs = scope.defs;
    var clipPathId = clipPathCache[clipPath.id];
    if (!clipPathId) {
        clipPathId = scope.zrId + '-c' + scope.clipPathIdx++;
        var clipPathAttrs = {
            id: clipPathId
        };
        clipPathCache[clipPath.id] = clipPathId;
        defs[clipPathId] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__core_js__["d" /* createVNode */])('clipPath', clipPathId, clipPathAttrs, [brushSVGPath(clipPath, scope)]);
    }
    attrs['clip-path'] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helper_js__["n" /* getIdURL */])(clipPathId);
}


/***/ }),
/* 1716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapStyleToAttrs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphic_Path_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphic_Image_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__canvas_dashStyle_js__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_js__ = __webpack_require__(168);





var NONE = 'none';
var mathRound = Math.round;
function pathHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== NONE;
}
function pathHasStroke(style) {
    var stroke = style.stroke;
    return stroke != null && stroke !== NONE;
}
var strokeProps = ['lineCap', 'miterLimit', 'lineJoin'];
var svgStrokeProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["map"])(strokeProps, function (prop) { return "stroke-" + prop.toLowerCase(); });
function mapStyleToAttrs(updateAttr, style, el, forceUpdate) {
    var opacity = style.opacity == null ? 1 : style.opacity;
    if (el instanceof __WEBPACK_IMPORTED_MODULE_1__graphic_Image_js__["a" /* default */]) {
        updateAttr('opacity', opacity);
        return;
    }
    if (pathHasFill(style)) {
        var fill = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helper_js__["c" /* normalizeColor */])(style.fill);
        updateAttr('fill', fill.color);
        var fillOpacity = style.fillOpacity != null
            ? style.fillOpacity * fill.opacity * opacity
            : fill.opacity * opacity;
        if (forceUpdate || fillOpacity < 1) {
            updateAttr('fill-opacity', fillOpacity);
        }
    }
    else {
        updateAttr('fill', NONE);
    }
    if (pathHasStroke(style)) {
        var stroke = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helper_js__["c" /* normalizeColor */])(style.stroke);
        updateAttr('stroke', stroke.color);
        var strokeScale = style.strokeNoScale
            ? el.getLineScale()
            : 1;
        var strokeWidth = (strokeScale ? (style.lineWidth || 0) / strokeScale : 0);
        var strokeOpacity = style.strokeOpacity != null
            ? style.strokeOpacity * stroke.opacity * opacity
            : stroke.opacity * opacity;
        var strokeFirst = style.strokeFirst;
        if (forceUpdate || strokeWidth !== 1) {
            updateAttr('stroke-width', strokeWidth);
        }
        if (forceUpdate || strokeFirst) {
            updateAttr('paint-order', strokeFirst ? 'stroke' : 'fill');
        }
        if (forceUpdate || strokeOpacity < 1) {
            updateAttr('stroke-opacity', strokeOpacity);
        }
        if (style.lineDash) {
            var _a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__canvas_dashStyle_js__["a" /* getLineDash */])(el), lineDash = _a[0], lineDashOffset = _a[1];
            if (lineDash) {
                lineDashOffset = mathRound(lineDashOffset || 0);
                updateAttr('stroke-dasharray', lineDash.join(','));
                if (lineDashOffset || forceUpdate) {
                    updateAttr('stroke-dashoffset', lineDashOffset);
                }
            }
        }
        else if (forceUpdate) {
            updateAttr('stroke-dasharray', NONE);
        }
        for (var i = 0; i < strokeProps.length; i++) {
            var propName = strokeProps[i];
            if (forceUpdate || style[propName] !== __WEBPACK_IMPORTED_MODULE_0__graphic_Path_js__["b" /* DEFAULT_PATH_STYLE */][propName]) {
                var val = style[propName] || __WEBPACK_IMPORTED_MODULE_0__graphic_Path_js__["b" /* DEFAULT_PATH_STYLE */][propName];
                val && updateAttr(svgStrokeProps[i], val);
            }
        }
    }
    else if (forceUpdate) {
        updateAttr('stroke', NONE);
    }
}


/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateAttrs;
/* harmony export (immutable) */ __webpack_exports__["b"] = patch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_js__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domapi_js__ = __webpack_require__(1714);



var colonChar = 58;
var xChar = 120;
var emptyNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["d" /* createVNode */])('', '');
function isUndef(s) {
    return s === undefined;
}
function isDef(s) {
    return s !== undefined;
}
function createKeyToOldIdx(children, beginIdx, endIdx) {
    var map = {};
    for (var i = beginIdx; i <= endIdx; ++i) {
        var key = children[i].key;
        if (key !== undefined) {
            if (true) {
                if (map[key] != null) {
                    console.error("Duplicate key " + key);
                }
            }
            map[key] = i;
        }
    }
    return map;
}
function sameVnode(vnode1, vnode2) {
    var isSameKey = vnode1.key === vnode2.key;
    var isSameTag = vnode1.tag === vnode2.tag;
    return isSameTag && isSameKey;
}
function createElm(vnode) {
    var i;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
        var elm = (vnode.elm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_js__["b" /* createElement */])(tag));
        updateAttrs(emptyNode, vnode);
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["isArray"])(children)) {
            for (i = 0; i < children.length; ++i) {
                var ch = children[i];
                if (ch != null) {
                    __WEBPACK_IMPORTED_MODULE_2__domapi_js__["a" /* appendChild */](elm, createElm(ch));
                }
            }
        }
        else if (isDef(vnode.text) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_util_js__["isObject"])(vnode.text)) {
            __WEBPACK_IMPORTED_MODULE_2__domapi_js__["a" /* appendChild */](elm, __WEBPACK_IMPORTED_MODULE_2__domapi_js__["b" /* createTextNode */](vnode.text));
        }
    }
    else {
        vnode.elm = __WEBPACK_IMPORTED_MODULE_2__domapi_js__["b" /* createTextNode */](vnode.text);
    }
    return vnode.elm;
}
function addVnodes(parentElm, before, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
        var ch = vnodes[startIdx];
        if (ch != null) {
            __WEBPACK_IMPORTED_MODULE_2__domapi_js__["c" /* insertBefore */](parentElm, createElm(ch), before);
        }
    }
}
function removeVnodes(parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
        var ch = vnodes[startIdx];
        if (ch != null) {
            if (isDef(ch.tag)) {
                var parent_1 = __WEBPACK_IMPORTED_MODULE_2__domapi_js__["d" /* parentNode */](ch.elm);
                __WEBPACK_IMPORTED_MODULE_2__domapi_js__["e" /* removeChild */](parent_1, ch.elm);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_2__domapi_js__["e" /* removeChild */](parentElm, ch.elm);
            }
        }
    }
}
function updateAttrs(oldVnode, vnode) {
    var key;
    var elm = vnode.elm;
    var oldAttrs = oldVnode && oldVnode.attrs || {};
    var attrs = vnode.attrs || {};
    if (oldAttrs === attrs) {
        return;
    }
    for (key in attrs) {
        var cur = attrs[key];
        var old = oldAttrs[key];
        if (old !== cur) {
            if (cur === true) {
                elm.setAttribute(key, '');
            }
            else if (cur === false) {
                elm.removeAttribute(key);
            }
            else {
                if (key.charCodeAt(0) !== xChar) {
                    elm.setAttribute(key, cur);
                }
                else if (key === 'xmlns:xlink' || key === 'xmlns') {
                    elm.setAttributeNS(__WEBPACK_IMPORTED_MODULE_1__core_js__["g" /* XMLNS */], key, cur);
                }
                else if (key.charCodeAt(3) === colonChar) {
                    elm.setAttributeNS(__WEBPACK_IMPORTED_MODULE_1__core_js__["h" /* XML_NAMESPACE */], key, cur);
                }
                else if (key.charCodeAt(5) === colonChar) {
                    elm.setAttributeNS(__WEBPACK_IMPORTED_MODULE_1__core_js__["i" /* XLINKNS */], key, cur);
                }
                else {
                    elm.setAttribute(key, cur);
                }
            }
        }
    }
    for (key in oldAttrs) {
        if (!(key in attrs)) {
            elm.removeAttribute(key);
        }
    }
}
function updateChildren(parentElm, oldCh, newCh) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx;
    var idxInOld;
    var elmToMove;
    var before;
    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
        if (oldStartVnode == null) {
            oldStartVnode = oldCh[++oldStartIdx];
        }
        else if (oldEndVnode == null) {
            oldEndVnode = oldCh[--oldEndIdx];
        }
        else if (newStartVnode == null) {
            newStartVnode = newCh[++newStartIdx];
        }
        else if (newEndVnode == null) {
            newEndVnode = newCh[--newEndIdx];
        }
        else if (sameVnode(oldStartVnode, newStartVnode)) {
            patchVnode(oldStartVnode, newStartVnode);
            oldStartVnode = oldCh[++oldStartIdx];
            newStartVnode = newCh[++newStartIdx];
        }
        else if (sameVnode(oldEndVnode, newEndVnode)) {
            patchVnode(oldEndVnode, newEndVnode);
            oldEndVnode = oldCh[--oldEndIdx];
            newEndVnode = newCh[--newEndIdx];
        }
        else if (sameVnode(oldStartVnode, newEndVnode)) {
            patchVnode(oldStartVnode, newEndVnode);
            __WEBPACK_IMPORTED_MODULE_2__domapi_js__["c" /* insertBefore */](parentElm, oldStartVnode.elm, __WEBPACK_IMPORTED_MODULE_2__domapi_js__["f" /* nextSibling */](oldEndVnode.elm));
            oldStartVnode = oldCh[++oldStartIdx];
            newEndVnode = newCh[--newEndIdx];
        }
        else if (sameVnode(oldEndVnode, newStartVnode)) {
            patchVnode(oldEndVnode, newStartVnode);
            __WEBPACK_IMPORTED_MODULE_2__domapi_js__["c" /* insertBefore */](parentElm, oldEndVnode.elm, oldStartVnode.elm);
            oldEndVnode = oldCh[--oldEndIdx];
            newStartVnode = newCh[++newStartIdx];
        }
        else {
            if (isUndef(oldKeyToIdx)) {
                oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
            }
            idxInOld = oldKeyToIdx[newStartVnode.key];
            if (isUndef(idxInOld)) {
                __WEBPACK_IMPORTED_MODULE_2__domapi_js__["c" /* insertBefore */](parentElm, createElm(newStartVnode), oldStartVnode.elm);
            }
            else {
                elmToMove = oldCh[idxInOld];
                if (elmToMove.tag !== newStartVnode.tag) {
                    __WEBPACK_IMPORTED_MODULE_2__domapi_js__["c" /* insertBefore */](parentElm, createElm(newStartVnode), oldStartVnode.elm);
                }
                else {
                    patchVnode(elmToMove, newStartVnode);
                    oldCh[idxInOld] = undefined;
                    __WEBPACK_IMPORTED_MODULE_2__domapi_js__["c" /* insertBefore */](parentElm, elmToMove.elm, oldStartVnode.elm);
                }
            }
            newStartVnode = newCh[++newStartIdx];
        }
    }
    if (oldStartIdx <= oldEndIdx || newStartIdx <= newEndIdx) {
        if (oldStartIdx > oldEndIdx) {
            before = newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].elm;
            addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx);
        }
        else {
            removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
        }
    }
}
function patchVnode(oldVnode, vnode) {
    var elm = (vnode.elm = oldVnode.elm);
    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (oldVnode === vnode) {
        return;
    }
    updateAttrs(oldVnode, vnode);
    if (isUndef(vnode.text)) {
        if (isDef(oldCh) && isDef(ch)) {
            if (oldCh !== ch) {
                updateChildren(elm, oldCh, ch);
            }
        }
        else if (isDef(ch)) {
            if (isDef(oldVnode.text)) {
                __WEBPACK_IMPORTED_MODULE_2__domapi_js__["g" /* setTextContent */](elm, '');
            }
            addVnodes(elm, null, ch, 0, ch.length - 1);
        }
        else if (isDef(oldCh)) {
            removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        }
        else if (isDef(oldVnode.text)) {
            __WEBPACK_IMPORTED_MODULE_2__domapi_js__["g" /* setTextContent */](elm, '');
        }
    }
    else if (oldVnode.text !== vnode.text) {
        if (isDef(oldCh)) {
            removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        }
        __WEBPACK_IMPORTED_MODULE_2__domapi_js__["g" /* setTextContent */](elm, vnode.text);
    }
}
function patch(oldVnode, vnode) {
    if (sameVnode(oldVnode, vnode)) {
        patchVnode(oldVnode, vnode);
    }
    else {
        var elm = oldVnode.elm;
        var parent_2 = __WEBPACK_IMPORTED_MODULE_2__domapi_js__["d" /* parentNode */](elm);
        createElm(vnode);
        if (parent_2 !== null) {
            __WEBPACK_IMPORTED_MODULE_2__domapi_js__["c" /* insertBefore */](parent_2, vnode.elm, __WEBPACK_IMPORTED_MODULE_2__domapi_js__["f" /* nextSibling */](elm));
            removeVnodes(parent_2, [oldVnode], 0, 0);
        }
    }
    return vnode;
}


/***/ }),
/* 1718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export clone */
/* harmony export (immutable) */ __webpack_exports__["a"] = split;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_bbox_js__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_BoundingRect_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_Point_js__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphic_shape_Polygon_js__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphic_shape_Rect_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphic_shape_Sector_js__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__convertPath_js__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__path_js__ = __webpack_require__(205);









function getDividingGrids(dimSize, rowDim, count) {
    var rowSize = dimSize[rowDim];
    var columnSize = dimSize[1 - rowDim];
    var ratio = Math.abs(rowSize / columnSize);
    var rowCount = Math.ceil(Math.sqrt(ratio * count));
    var columnCount = Math.floor(count / rowCount);
    if (columnCount === 0) {
        columnCount = 1;
        rowCount = count;
    }
    var grids = [];
    for (var i = 0; i < rowCount; i++) {
        grids.push(columnCount);
    }
    var currentCount = rowCount * columnCount;
    var remained = count - currentCount;
    if (remained > 0) {
        for (var i = 0; i < remained; i++) {
            grids[i % rowCount] += 1;
        }
    }
    return grids;
}
function divideSector(sectorShape, count, outShapes) {
    var r0 = sectorShape.r0;
    var r = sectorShape.r;
    var startAngle = sectorShape.startAngle;
    var endAngle = sectorShape.endAngle;
    var angle = Math.abs(endAngle - startAngle);
    var arcLen = angle * r;
    var deltaR = r - r0;
    var isAngleRow = arcLen > Math.abs(deltaR);
    var grids = getDividingGrids([arcLen, deltaR], isAngleRow ? 0 : 1, count);
    var rowSize = (isAngleRow ? angle : deltaR) / grids.length;
    for (var row = 0; row < grids.length; row++) {
        var columnSize = (isAngleRow ? deltaR : angle) / grids[row];
        for (var column = 0; column < grids[row]; column++) {
            var newShape = {};
            if (isAngleRow) {
                newShape.startAngle = startAngle + rowSize * row;
                newShape.endAngle = startAngle + rowSize * (row + 1);
                newShape.r0 = r0 + columnSize * column;
                newShape.r = r0 + columnSize * (column + 1);
            }
            else {
                newShape.startAngle = startAngle + columnSize * column;
                newShape.endAngle = startAngle + columnSize * (column + 1);
                newShape.r0 = r0 + rowSize * row;
                newShape.r = r0 + rowSize * (row + 1);
            }
            newShape.clockwise = sectorShape.clockwise;
            newShape.cx = sectorShape.cx;
            newShape.cy = sectorShape.cy;
            outShapes.push(newShape);
        }
    }
}
function divideRect(rectShape, count, outShapes) {
    var width = rectShape.width;
    var height = rectShape.height;
    var isHorizontalRow = width > height;
    var grids = getDividingGrids([width, height], isHorizontalRow ? 0 : 1, count);
    var rowSizeDim = isHorizontalRow ? 'width' : 'height';
    var columnSizeDim = isHorizontalRow ? 'height' : 'width';
    var rowDim = isHorizontalRow ? 'x' : 'y';
    var columnDim = isHorizontalRow ? 'y' : 'x';
    var rowSize = rectShape[rowSizeDim] / grids.length;
    for (var row = 0; row < grids.length; row++) {
        var columnSize = rectShape[columnSizeDim] / grids[row];
        for (var column = 0; column < grids[row]; column++) {
            var newShape = {};
            newShape[rowDim] = row * rowSize;
            newShape[columnDim] = column * columnSize;
            newShape[rowSizeDim] = rowSize;
            newShape[columnSizeDim] = columnSize;
            newShape.x += rectShape.x;
            newShape.y += rectShape.y;
            outShapes.push(newShape);
        }
    }
}
function crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function lineLineIntersect(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y;
    var nmCrossProduct = crossProduct2d(nx, ny, mx, my);
    if (Math.abs(nmCrossProduct) < 1e-6) {
        return null;
    }
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var p = crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) {
        return null;
    }
    return new __WEBPACK_IMPORTED_MODULE_2__core_Point_js__["a" /* default */](p * mx + a1x, p * my + a1y);
}
function projPtOnLine(pt, lineA, lineB) {
    var dir = new __WEBPACK_IMPORTED_MODULE_2__core_Point_js__["a" /* default */]();
    __WEBPACK_IMPORTED_MODULE_2__core_Point_js__["a" /* default */].sub(dir, lineB, lineA);
    dir.normalize();
    var dir2 = new __WEBPACK_IMPORTED_MODULE_2__core_Point_js__["a" /* default */]();
    __WEBPACK_IMPORTED_MODULE_2__core_Point_js__["a" /* default */].sub(dir2, pt, lineA);
    var len = dir2.dot(dir);
    return len;
}
function addToPoly(poly, pt) {
    var last = poly[poly.length - 1];
    if (last && last[0] === pt[0] && last[1] === pt[1]) {
        return;
    }
    poly.push(pt);
}
function splitPolygonByLine(points, lineA, lineB) {
    var len = points.length;
    var intersections = [];
    for (var i = 0; i < len; i++) {
        var p0 = points[i];
        var p1 = points[(i + 1) % len];
        var intersectionPt = lineLineIntersect(p0[0], p0[1], p1[0], p1[1], lineA.x, lineA.y, lineB.x, lineB.y);
        if (intersectionPt) {
            intersections.push({
                projPt: projPtOnLine(intersectionPt, lineA, lineB),
                pt: intersectionPt,
                idx: i
            });
        }
    }
    if (intersections.length < 2) {
        return [{ points: points }, { points: points }];
    }
    intersections.sort(function (a, b) {
        return a.projPt - b.projPt;
    });
    var splitPt0 = intersections[0];
    var splitPt1 = intersections[intersections.length - 1];
    if (splitPt1.idx < splitPt0.idx) {
        var tmp = splitPt0;
        splitPt0 = splitPt1;
        splitPt1 = tmp;
    }
    var splitPt0Arr = [splitPt0.pt.x, splitPt0.pt.y];
    var splitPt1Arr = [splitPt1.pt.x, splitPt1.pt.y];
    var newPolyA = [splitPt0Arr];
    var newPolyB = [splitPt1Arr];
    for (var i = splitPt0.idx + 1; i <= splitPt1.idx; i++) {
        addToPoly(newPolyA, points[i].slice());
    }
    addToPoly(newPolyA, splitPt1Arr);
    addToPoly(newPolyA, splitPt0Arr);
    for (var i = splitPt1.idx + 1; i <= splitPt0.idx + len; i++) {
        addToPoly(newPolyB, points[i % len].slice());
    }
    addToPoly(newPolyB, splitPt0Arr);
    addToPoly(newPolyB, splitPt1Arr);
    return [{
            points: newPolyA
        }, {
            points: newPolyB
        }];
}
function binaryDividePolygon(polygonShape) {
    var points = polygonShape.points;
    var min = [];
    var max = [];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_bbox_js__["e" /* fromPoints */])(points, min, max);
    var boundingRect = new __WEBPACK_IMPORTED_MODULE_1__core_BoundingRect_js__["a" /* default */](min[0], min[1], max[0] - min[0], max[1] - min[1]);
    var width = boundingRect.width;
    var height = boundingRect.height;
    var x = boundingRect.x;
    var y = boundingRect.y;
    var pt0 = new __WEBPACK_IMPORTED_MODULE_2__core_Point_js__["a" /* default */]();
    var pt1 = new __WEBPACK_IMPORTED_MODULE_2__core_Point_js__["a" /* default */]();
    if (width > height) {
        pt0.x = pt1.x = x + width / 2;
        pt0.y = y;
        pt1.y = y + height;
    }
    else {
        pt0.y = pt1.y = y + height / 2;
        pt0.x = x;
        pt1.x = x + width;
    }
    return splitPolygonByLine(points, pt0, pt1);
}
function binaryDivideRecursive(divider, shape, count, out) {
    if (count === 1) {
        out.push(shape);
    }
    else {
        var mid = Math.floor(count / 2);
        var sub = divider(shape);
        binaryDivideRecursive(divider, sub[0], mid, out);
        binaryDivideRecursive(divider, sub[1], count - mid, out);
    }
    return out;
}
function clone(path, count) {
    var paths = [];
    for (var i = 0; i < count; i++) {
        paths.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__path_js__["d" /* clonePath */])(path));
    }
    return paths;
}
function copyPathProps(source, target) {
    target.setStyle(source.style);
    target.z = source.z;
    target.z2 = source.z2;
    target.zlevel = source.zlevel;
}
function polygonConvert(points) {
    var out = [];
    for (var i = 0; i < points.length;) {
        out.push([points[i++], points[i++]]);
    }
    return out;
}
function split(path, count) {
    var outShapes = [];
    var shape = path.shape;
    var OutShapeCtor;
    switch (path.type) {
        case 'rect':
            divideRect(shape, count, outShapes);
            OutShapeCtor = __WEBPACK_IMPORTED_MODULE_5__graphic_shape_Rect_js__["a" /* default */];
            break;
        case 'sector':
            divideSector(shape, count, outShapes);
            OutShapeCtor = __WEBPACK_IMPORTED_MODULE_6__graphic_shape_Sector_js__["a" /* default */];
            break;
        case 'circle':
            divideSector({
                r0: 0, r: shape.r, startAngle: 0, endAngle: Math.PI * 2,
                cx: shape.cx, cy: shape.cy
            }, count, outShapes);
            OutShapeCtor = __WEBPACK_IMPORTED_MODULE_6__graphic_shape_Sector_js__["a" /* default */];
            break;
        default:
            var m = path.getComputedTransform();
            var scale = m ? Math.sqrt(Math.max(m[0] * m[0] + m[1] * m[1], m[2] * m[2] + m[3] * m[3])) : 1;
            var polygons = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["map"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__convertPath_js__["b" /* pathToPolygons */])(path.getUpdatedPathProxy(), scale), function (poly) { return polygonConvert(poly); });
            var polygonCount = polygons.length;
            if (polygonCount === 0) {
                binaryDivideRecursive(binaryDividePolygon, {
                    points: polygons[0]
                }, count, outShapes);
            }
            else if (polygonCount === count) {
                for (var i = 0; i < polygonCount; i++) {
                    outShapes.push({
                        points: polygons[i]
                    });
                }
            }
            else {
                var totalArea_1 = 0;
                var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_util_js__["map"])(polygons, function (poly) {
                    var min = [];
                    var max = [];
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_bbox_js__["e" /* fromPoints */])(poly, min, max);
                    var area = (max[1] - min[1]) * (max[0] - min[0]);
                    totalArea_1 += area;
                    return { poly: poly, area: area };
                });
                items.sort(function (a, b) { return b.area - a.area; });
                var left = count;
                for (var i = 0; i < polygonCount; i++) {
                    var item = items[i];
                    if (left <= 0) {
                        break;
                    }
                    var selfCount = i === polygonCount - 1
                        ? left
                        : Math.ceil(item.area / totalArea_1 * count);
                    if (selfCount < 0) {
                        continue;
                    }
                    binaryDivideRecursive(binaryDividePolygon, {
                        points: item.poly
                    }, selfCount, outShapes);
                    left -= selfCount;
                }
                ;
            }
            OutShapeCtor = __WEBPACK_IMPORTED_MODULE_4__graphic_shape_Polygon_js__["a" /* default */];
            break;
    }
    if (!OutShapeCtor) {
        return clone(path, count);
    }
    var out = [];
    for (var i = 0; i < outShapes.length; i++) {
        var subPath = new OutShapeCtor();
        subPath.setShape(outShapes[i]);
        copyPathProps(path, subPath);
        out.push(subPath);
    }
    return out;
}


/***/ }),
/* 1719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export alignBezierCurves */
/* unused harmony export centroid */
/* harmony export (immutable) */ __webpack_exports__["a"] = isCombineMorphing;
/* unused harmony export isMorphing */
/* harmony export (immutable) */ __webpack_exports__["b"] = morphPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = combineMorph;
/* harmony export (immutable) */ __webpack_exports__["d"] = separateMorph;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_curve_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphic_Path_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_vector_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__path_js__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_Transformable_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dividePath_js__ = __webpack_require__(1718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__convertPath_js__ = __webpack_require__(596);
/* unused harmony reexport defaultDividePath */








function alignSubpath(subpath1, subpath2) {
    var len1 = subpath1.length;
    var len2 = subpath2.length;
    if (len1 === len2) {
        return [subpath1, subpath2];
    }
    var tmpSegX = [];
    var tmpSegY = [];
    var shorterPath = len1 < len2 ? subpath1 : subpath2;
    var shorterLen = Math.min(len1, len2);
    var diff = Math.abs(len2 - len1) / 6;
    var shorterBezierCount = (shorterLen - 2) / 6;
    var eachCurveSubDivCount = Math.ceil(diff / shorterBezierCount) + 1;
    var newSubpath = [shorterPath[0], shorterPath[1]];
    var remained = diff;
    for (var i = 2; i < shorterLen;) {
        var x0 = shorterPath[i - 2];
        var y0 = shorterPath[i - 1];
        var x1 = shorterPath[i++];
        var y1 = shorterPath[i++];
        var x2 = shorterPath[i++];
        var y2 = shorterPath[i++];
        var x3 = shorterPath[i++];
        var y3 = shorterPath[i++];
        if (remained <= 0) {
            newSubpath.push(x1, y1, x2, y2, x3, y3);
            continue;
        }
        var actualSubDivCount = Math.min(remained, eachCurveSubDivCount - 1) + 1;
        for (var k = 1; k <= actualSubDivCount; k++) {
            var p = k / actualSubDivCount;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_curve_js__["k" /* cubicSubdivide */])(x0, x1, x2, x3, p, tmpSegX);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_curve_js__["k" /* cubicSubdivide */])(y0, y1, y2, y3, p, tmpSegY);
            x0 = tmpSegX[3];
            y0 = tmpSegY[3];
            newSubpath.push(tmpSegX[1], tmpSegY[1], tmpSegX[2], tmpSegY[2], x0, y0);
            x1 = tmpSegX[5];
            y1 = tmpSegY[5];
            x2 = tmpSegX[6];
            y2 = tmpSegY[6];
        }
        remained -= actualSubDivCount - 1;
    }
    return shorterPath === subpath1 ? [newSubpath, subpath2] : [subpath1, newSubpath];
}
function createSubpath(lastSubpathSubpath, otherSubpath) {
    var len = lastSubpathSubpath.length;
    var lastX = lastSubpathSubpath[len - 2];
    var lastY = lastSubpathSubpath[len - 1];
    var newSubpath = [];
    for (var i = 0; i < otherSubpath.length;) {
        newSubpath[i++] = lastX;
        newSubpath[i++] = lastY;
    }
    return newSubpath;
}
function alignBezierCurves(array1, array2) {
    var _a;
    var lastSubpath1;
    var lastSubpath2;
    var newArray1 = [];
    var newArray2 = [];
    for (var i = 0; i < Math.max(array1.length, array2.length); i++) {
        var subpath1 = array1[i];
        var subpath2 = array2[i];
        var newSubpath1 = void 0;
        var newSubpath2 = void 0;
        if (!subpath1) {
            newSubpath1 = createSubpath(lastSubpath1 || subpath2, subpath2);
            newSubpath2 = subpath2;
        }
        else if (!subpath2) {
            newSubpath2 = createSubpath(lastSubpath2 || subpath1, subpath1);
            newSubpath1 = subpath1;
        }
        else {
            _a = alignSubpath(subpath1, subpath2), newSubpath1 = _a[0], newSubpath2 = _a[1];
            lastSubpath1 = newSubpath1;
            lastSubpath2 = newSubpath2;
        }
        newArray1.push(newSubpath1);
        newArray2.push(newSubpath2);
    }
    return [newArray1, newArray2];
}
function centroid(array) {
    var signedArea = 0;
    var cx = 0;
    var cy = 0;
    var len = array.length;
    for (var i = 0, j = len - 2; i < len; j = i, i += 2) {
        var x0 = array[j];
        var y0 = array[j + 1];
        var x1 = array[i];
        var y1 = array[i + 1];
        var a = x0 * y1 - x1 * y0;
        signedArea += a;
        cx += (x0 + x1) * a;
        cy += (y0 + y1) * a;
    }
    if (signedArea === 0) {
        return [array[0] || 0, array[1] || 0];
    }
    return [cx / signedArea / 3, cy / signedArea / 3, signedArea];
}
function findBestRingOffset(fromSubBeziers, toSubBeziers, fromCp, toCp) {
    var bezierCount = (fromSubBeziers.length - 2) / 6;
    var bestScore = Infinity;
    var bestOffset = 0;
    var len = fromSubBeziers.length;
    var len2 = len - 2;
    for (var offset = 0; offset < bezierCount; offset++) {
        var cursorOffset = offset * 6;
        var score = 0;
        for (var k = 0; k < len; k += 2) {
            var idx = k === 0 ? cursorOffset : ((cursorOffset + k - 2) % len2 + 2);
            var x0 = fromSubBeziers[idx] - fromCp[0];
            var y0 = fromSubBeziers[idx + 1] - fromCp[1];
            var x1 = toSubBeziers[k] - toCp[0];
            var y1 = toSubBeziers[k + 1] - toCp[1];
            var dx = x1 - x0;
            var dy = y1 - y0;
            score += dx * dx + dy * dy;
        }
        if (score < bestScore) {
            bestScore = score;
            bestOffset = offset;
        }
    }
    return bestOffset;
}
function reverse(array) {
    var newArr = [];
    var len = array.length;
    for (var i = 0; i < len; i += 2) {
        newArr[i] = array[len - i - 2];
        newArr[i + 1] = array[len - i - 1];
    }
    return newArr;
}
function findBestMorphingRotation(fromArr, toArr, searchAngleIteration, searchAngleRange) {
    var result = [];
    var fromNeedsReverse;
    for (var i = 0; i < fromArr.length; i++) {
        var fromSubpathBezier = fromArr[i];
        var toSubpathBezier = toArr[i];
        var fromCp = centroid(fromSubpathBezier);
        var toCp = centroid(toSubpathBezier);
        if (fromNeedsReverse == null) {
            fromNeedsReverse = fromCp[2] < 0 !== toCp[2] < 0;
        }
        var newFromSubpathBezier = [];
        var newToSubpathBezier = [];
        var bestAngle = 0;
        var bestScore = Infinity;
        var tmpArr = [];
        var len = fromSubpathBezier.length;
        if (fromNeedsReverse) {
            fromSubpathBezier = reverse(fromSubpathBezier);
        }
        var offset = findBestRingOffset(fromSubpathBezier, toSubpathBezier, fromCp, toCp) * 6;
        var len2 = len - 2;
        for (var k = 0; k < len2; k += 2) {
            var idx = (offset + k) % len2 + 2;
            newFromSubpathBezier[k + 2] = fromSubpathBezier[idx] - fromCp[0];
            newFromSubpathBezier[k + 3] = fromSubpathBezier[idx + 1] - fromCp[1];
        }
        newFromSubpathBezier[0] = fromSubpathBezier[offset] - fromCp[0];
        newFromSubpathBezier[1] = fromSubpathBezier[offset + 1] - fromCp[1];
        if (searchAngleIteration > 0) {
            var step = searchAngleRange / searchAngleIteration;
            for (var angle = -searchAngleRange / 2; angle <= searchAngleRange / 2; angle += step) {
                var sa = Math.sin(angle);
                var ca = Math.cos(angle);
                var score = 0;
                for (var k = 0; k < fromSubpathBezier.length; k += 2) {
                    var x0 = newFromSubpathBezier[k];
                    var y0 = newFromSubpathBezier[k + 1];
                    var x1 = toSubpathBezier[k] - toCp[0];
                    var y1 = toSubpathBezier[k + 1] - toCp[1];
                    var newX1 = x1 * ca - y1 * sa;
                    var newY1 = x1 * sa + y1 * ca;
                    tmpArr[k] = newX1;
                    tmpArr[k + 1] = newY1;
                    var dx = newX1 - x0;
                    var dy = newY1 - y0;
                    score += dx * dx + dy * dy;
                }
                if (score < bestScore) {
                    bestScore = score;
                    bestAngle = angle;
                    for (var m = 0; m < tmpArr.length; m++) {
                        newToSubpathBezier[m] = tmpArr[m];
                    }
                }
            }
        }
        else {
            for (var i_1 = 0; i_1 < len; i_1 += 2) {
                newToSubpathBezier[i_1] = toSubpathBezier[i_1] - toCp[0];
                newToSubpathBezier[i_1 + 1] = toSubpathBezier[i_1 + 1] - toCp[1];
            }
        }
        result.push({
            from: newFromSubpathBezier,
            to: newToSubpathBezier,
            fromCp: fromCp,
            toCp: toCp,
            rotation: -bestAngle
        });
    }
    return result;
}
function isCombineMorphing(path) {
    return path.__isCombineMorphing;
}
function isMorphing(el) {
    return el.__morphT >= 0;
}
var SAVED_METHOD_PREFIX = '__mOriginal_';
function saveAndModifyMethod(obj, methodName, modifiers) {
    var savedMethodName = SAVED_METHOD_PREFIX + methodName;
    var originalMethod = obj[savedMethodName] || obj[methodName];
    if (!obj[savedMethodName]) {
        obj[savedMethodName] = obj[methodName];
    }
    var replace = modifiers.replace;
    var after = modifiers.after;
    var before = modifiers.before;
    obj[methodName] = function () {
        var args = arguments;
        var res;
        before && before.apply(this, args);
        if (replace) {
            res = replace.apply(this, args);
        }
        else {
            res = originalMethod.apply(this, args);
        }
        after && after.apply(this, args);
        return res;
    };
}
function restoreMethod(obj, methodName) {
    var savedMethodName = SAVED_METHOD_PREFIX + methodName;
    if (obj[savedMethodName]) {
        obj[methodName] = obj[savedMethodName];
        obj[savedMethodName] = null;
    }
}
function applyTransformOnBeziers(bezierCurves, mm) {
    for (var i = 0; i < bezierCurves.length; i++) {
        var subBeziers = bezierCurves[i];
        for (var k = 0; k < subBeziers.length;) {
            var x = subBeziers[k];
            var y = subBeziers[k + 1];
            subBeziers[k++] = mm[0] * x + mm[2] * y + mm[4];
            subBeziers[k++] = mm[1] * x + mm[3] * y + mm[5];
        }
    }
}
function prepareMorphPath(fromPath, toPath) {
    var fromPathProxy = fromPath.getUpdatedPathProxy();
    var toPathProxy = toPath.getUpdatedPathProxy();
    var _a = alignBezierCurves(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__convertPath_js__["a" /* pathToBezierCurves */])(fromPathProxy), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__convertPath_js__["a" /* pathToBezierCurves */])(toPathProxy)), fromBezierCurves = _a[0], toBezierCurves = _a[1];
    var fromPathTransform = fromPath.getComputedTransform();
    var toPathTransform = toPath.getComputedTransform();
    function updateIdentityTransform() {
        this.transform = null;
    }
    fromPathTransform && applyTransformOnBeziers(fromBezierCurves, fromPathTransform);
    toPathTransform && applyTransformOnBeziers(toBezierCurves, toPathTransform);
    saveAndModifyMethod(toPath, 'updateTransform', { replace: updateIdentityTransform });
    toPath.transform = null;
    var morphingData = findBestMorphingRotation(fromBezierCurves, toBezierCurves, 10, Math.PI);
    var tmpArr = [];
    saveAndModifyMethod(toPath, 'buildPath', { replace: function (path) {
            var t = toPath.__morphT;
            var onet = 1 - t;
            var newCp = [];
            for (var i = 0; i < morphingData.length; i++) {
                var item = morphingData[i];
                var from = item.from;
                var to = item.to;
                var angle = item.rotation * t;
                var fromCp = item.fromCp;
                var toCp = item.toCp;
                var sa = Math.sin(angle);
                var ca = Math.cos(angle);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_vector_js__["lerp"])(newCp, fromCp, toCp, t);
                for (var m = 0; m < from.length; m += 2) {
                    var x0_1 = from[m];
                    var y0_1 = from[m + 1];
                    var x1 = to[m];
                    var y1 = to[m + 1];
                    var x = x0_1 * onet + x1 * t;
                    var y = y0_1 * onet + y1 * t;
                    tmpArr[m] = (x * ca - y * sa) + newCp[0];
                    tmpArr[m + 1] = (x * sa + y * ca) + newCp[1];
                }
                var x0 = tmpArr[0];
                var y0 = tmpArr[1];
                path.moveTo(x0, y0);
                for (var m = 2; m < from.length;) {
                    var x1 = tmpArr[m++];
                    var y1 = tmpArr[m++];
                    var x2 = tmpArr[m++];
                    var y2 = tmpArr[m++];
                    var x3 = tmpArr[m++];
                    var y3 = tmpArr[m++];
                    if (x0 === x1 && y0 === y1 && x2 === x3 && y2 === y3) {
                        path.lineTo(x3, y3);
                    }
                    else {
                        path.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    }
                    x0 = x3;
                    y0 = y3;
                }
            }
        } });
}
function morphPath(fromPath, toPath, animationOpts) {
    if (!fromPath || !toPath) {
        return toPath;
    }
    var oldDone = animationOpts.done;
    var oldDuring = animationOpts.during;
    prepareMorphPath(fromPath, toPath);
    toPath.__morphT = 0;
    function restoreToPath() {
        restoreMethod(toPath, 'buildPath');
        restoreMethod(toPath, 'updateTransform');
        toPath.__morphT = -1;
        toPath.createPathProxy();
        toPath.dirtyShape();
    }
    toPath.animateTo({
        __morphT: 1
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["defaults"])({
        during: function (p) {
            toPath.dirtyShape();
            oldDuring && oldDuring(p);
        },
        done: function () {
            restoreToPath();
            oldDone && oldDone();
        }
    }, animationOpts));
    return toPath;
}
function hilbert(x, y, minX, minY, maxX, maxY) {
    var bits = 16;
    x = (maxX === minX) ? 0 : Math.round(32767 * (x - minX) / (maxX - minX));
    y = (maxY === minY) ? 0 : Math.round(32767 * (y - minY) / (maxY - minY));
    var d = 0;
    var tmp;
    for (var s = (1 << bits) / 2; s > 0; s /= 2) {
        var rx = 0;
        var ry = 0;
        if ((x & s) > 0) {
            rx = 1;
        }
        if ((y & s) > 0) {
            ry = 1;
        }
        d += s * s * ((3 * rx) ^ ry);
        if (ry === 0) {
            if (rx === 1) {
                x = s - 1 - x;
                y = s - 1 - y;
            }
            tmp = x;
            x = y;
            y = tmp;
        }
    }
    return d;
}
function sortPaths(pathList) {
    var xMin = Infinity;
    var yMin = Infinity;
    var xMax = -Infinity;
    var yMax = -Infinity;
    var cps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["map"])(pathList, function (path) {
        var rect = path.getBoundingRect();
        var m = path.getComputedTransform();
        var x = rect.x + rect.width / 2 + (m ? m[4] : 0);
        var y = rect.y + rect.height / 2 + (m ? m[5] : 0);
        xMin = Math.min(x, xMin);
        yMin = Math.min(y, yMin);
        xMax = Math.max(x, xMax);
        yMax = Math.max(y, yMax);
        return [x, y];
    });
    var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["map"])(cps, function (cp, idx) {
        return {
            cp: cp,
            z: hilbert(cp[0], cp[1], xMin, yMin, xMax, yMax),
            path: pathList[idx]
        };
    });
    return items.sort(function (a, b) { return a.z - b.z; }).map(function (item) { return item.path; });
}
;
function defaultDividePath(param) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__dividePath_js__["a" /* split */])(param.path, param.count);
}
function createEmptyReturn() {
    return {
        fromIndividuals: [],
        toIndividuals: [],
        count: 0
    };
}
function combineMorph(fromList, toPath, animationOpts) {
    var fromPathList = [];
    function addFromPath(fromList) {
        for (var i = 0; i < fromList.length; i++) {
            var from = fromList[i];
            if (isCombineMorphing(from)) {
                addFromPath(from.childrenRef());
            }
            else if (from instanceof __WEBPACK_IMPORTED_MODULE_1__graphic_Path_js__["a" /* default */]) {
                fromPathList.push(from);
            }
        }
    }
    addFromPath(fromList);
    var separateCount = fromPathList.length;
    if (!separateCount) {
        return createEmptyReturn();
    }
    var dividePath = animationOpts.dividePath || defaultDividePath;
    var toSubPathList = dividePath({
        path: toPath, count: separateCount
    });
    if (toSubPathList.length !== separateCount) {
        console.error('Invalid morphing: unmatched splitted path');
        return createEmptyReturn();
    }
    fromPathList = sortPaths(fromPathList);
    toSubPathList = sortPaths(toSubPathList);
    var oldDone = animationOpts.done;
    var oldDuring = animationOpts.during;
    var individualDelay = animationOpts.individualDelay;
    var identityTransform = new __WEBPACK_IMPORTED_MODULE_5__core_Transformable_js__["a" /* default */]();
    for (var i = 0; i < separateCount; i++) {
        var from = fromPathList[i];
        var to = toSubPathList[i];
        to.parent = toPath;
        to.copyTransform(identityTransform);
        if (!individualDelay) {
            prepareMorphPath(from, to);
        }
    }
    toPath.__isCombineMorphing = true;
    toPath.childrenRef = function () {
        return toSubPathList;
    };
    function addToSubPathListToZr(zr) {
        for (var i = 0; i < toSubPathList.length; i++) {
            toSubPathList[i].addSelfToZr(zr);
        }
    }
    saveAndModifyMethod(toPath, 'addSelfToZr', {
        after: function (zr) {
            addToSubPathListToZr(zr);
        }
    });
    saveAndModifyMethod(toPath, 'removeSelfFromZr', {
        after: function (zr) {
            for (var i = 0; i < toSubPathList.length; i++) {
                toSubPathList[i].removeSelfFromZr(zr);
            }
        }
    });
    function restoreToPath() {
        toPath.__isCombineMorphing = false;
        toPath.__morphT = -1;
        toPath.childrenRef = null;
        restoreMethod(toPath, 'addSelfToZr');
        restoreMethod(toPath, 'removeSelfFromZr');
    }
    var toLen = toSubPathList.length;
    if (individualDelay) {
        var animating_1 = toLen;
        var eachDone = function () {
            animating_1--;
            if (animating_1 === 0) {
                restoreToPath();
                oldDone && oldDone();
            }
        };
        for (var i = 0; i < toLen; i++) {
            var indivdualAnimationOpts = individualDelay ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["defaults"])({
                delay: (animationOpts.delay || 0) + individualDelay(i, toLen, fromPathList[i], toSubPathList[i]),
                done: eachDone
            }, animationOpts) : animationOpts;
            morphPath(fromPathList[i], toSubPathList[i], indivdualAnimationOpts);
        }
    }
    else {
        toPath.__morphT = 0;
        toPath.animateTo({
            __morphT: 1
        }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["defaults"])({
            during: function (p) {
                for (var i = 0; i < toLen; i++) {
                    var child = toSubPathList[i];
                    child.__morphT = toPath.__morphT;
                    child.dirtyShape();
                }
                oldDuring && oldDuring(p);
            },
            done: function () {
                restoreToPath();
                for (var i = 0; i < fromList.length; i++) {
                    restoreMethod(fromList[i], 'updateTransform');
                }
                oldDone && oldDone();
            }
        }, animationOpts));
    }
    if (toPath.__zr) {
        addToSubPathListToZr(toPath.__zr);
    }
    return {
        fromIndividuals: fromPathList,
        toIndividuals: toSubPathList,
        count: toLen
    };
}
function separateMorph(fromPath, toPathList, animationOpts) {
    var toLen = toPathList.length;
    var fromPathList = [];
    var dividePath = animationOpts.dividePath || defaultDividePath;
    function addFromPath(fromList) {
        for (var i = 0; i < fromList.length; i++) {
            var from = fromList[i];
            if (isCombineMorphing(from)) {
                addFromPath(from.childrenRef());
            }
            else if (from instanceof __WEBPACK_IMPORTED_MODULE_1__graphic_Path_js__["a" /* default */]) {
                fromPathList.push(from);
            }
        }
    }
    if (isCombineMorphing(fromPath)) {
        addFromPath(fromPath.childrenRef());
        var fromLen = fromPathList.length;
        if (fromLen < toLen) {
            var k = 0;
            for (var i = fromLen; i < toLen; i++) {
                fromPathList.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__path_js__["d" /* clonePath */])(fromPathList[k++ % fromLen]));
            }
        }
        fromPathList.length = toLen;
    }
    else {
        fromPathList = dividePath({ path: fromPath, count: toLen });
        var fromPathTransform = fromPath.getComputedTransform();
        for (var i = 0; i < fromPathList.length; i++) {
            fromPathList[i].setLocalTransform(fromPathTransform);
        }
        if (fromPathList.length !== toLen) {
            console.error('Invalid morphing: unmatched splitted path');
            return createEmptyReturn();
        }
    }
    fromPathList = sortPaths(fromPathList);
    toPathList = sortPaths(toPathList);
    var individualDelay = animationOpts.individualDelay;
    for (var i = 0; i < toLen; i++) {
        var indivdualAnimationOpts = individualDelay ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_util_js__["defaults"])({
            delay: (animationOpts.delay || 0) + individualDelay(i, toLen, fromPathList[i], toPathList[i])
        }, animationOpts) : animationOpts;
        morphPath(fromPathList[i], toPathList[i], indivdualAnimationOpts);
    }
    return {
        fromIndividuals: fromPathList,
        toIndividuals: toPathList,
        count: toPathList.length
    };
}



/***/ }),
/* 1720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = makeViewBoxTransform;
/* harmony export (immutable) */ __webpack_exports__["a"] = parseSVG;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphic_Group_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphic_Image_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphic_shape_Circle_js__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphic_shape_Rect_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphic_shape_Ellipse_js__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphic_shape_Line_js__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphic_shape_Polygon_js__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphic_shape_Polyline_js__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_matrix_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__path_js__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__core_util_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__graphic_LinearGradient_js__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__graphic_RadialGradient_js__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__graphic_TSpan_js__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__parseXML_js__ = __webpack_require__(597);
/* unused harmony reexport parseXML */















;
var nodeParsers;
var INHERITABLE_STYLE_ATTRIBUTES_MAP = {
    'fill': 'fill',
    'stroke': 'stroke',
    'stroke-width': 'lineWidth',
    'opacity': 'opacity',
    'fill-opacity': 'fillOpacity',
    'stroke-opacity': 'strokeOpacity',
    'stroke-dasharray': 'lineDash',
    'stroke-dashoffset': 'lineDashOffset',
    'stroke-linecap': 'lineCap',
    'stroke-linejoin': 'lineJoin',
    'stroke-miterlimit': 'miterLimit',
    'font-family': 'fontFamily',
    'font-size': 'fontSize',
    'font-style': 'fontStyle',
    'font-weight': 'fontWeight',
    'text-anchor': 'textAlign',
    'visibility': 'visibility',
    'display': 'display'
};
var INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__core_util_js__["keys"])(INHERITABLE_STYLE_ATTRIBUTES_MAP);
var SELF_STYLE_ATTRIBUTES_MAP = {
    'alignment-baseline': 'textBaseline',
    'stop-color': 'stopColor'
};
var SELF_STYLE_ATTRIBUTES_MAP_KEYS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__core_util_js__["keys"])(SELF_STYLE_ATTRIBUTES_MAP);
var SVGParser = (function () {
    function SVGParser() {
        this._defs = {};
        this._root = null;
    }
    SVGParser.prototype.parse = function (xml, opt) {
        opt = opt || {};
        var svg = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__parseXML_js__["a" /* parseXML */])(xml);
        if (true) {
            if (!svg) {
                throw new Error('Illegal svg');
            }
        }
        this._defsUsePending = [];
        var root = new __WEBPACK_IMPORTED_MODULE_0__graphic_Group_js__["a" /* default */]();
        this._root = root;
        var named = [];
        var viewBox = svg.getAttribute('viewBox') || '';
        var width = parseFloat((svg.getAttribute('width') || opt.width));
        var height = parseFloat((svg.getAttribute('height') || opt.height));
        isNaN(width) && (width = null);
        isNaN(height) && (height = null);
        parseAttributes(svg, root, null, true, false);
        var child = svg.firstChild;
        while (child) {
            this._parseNode(child, root, named, null, false, false);
            child = child.nextSibling;
        }
        applyDefs(this._defs, this._defsUsePending);
        this._defsUsePending = [];
        var viewBoxRect;
        var viewBoxTransform;
        if (viewBox) {
            var viewBoxArr = splitNumberSequence(viewBox);
            if (viewBoxArr.length >= 4) {
                viewBoxRect = {
                    x: parseFloat((viewBoxArr[0] || 0)),
                    y: parseFloat((viewBoxArr[1] || 0)),
                    width: parseFloat(viewBoxArr[2]),
                    height: parseFloat(viewBoxArr[3])
                };
            }
        }
        if (viewBoxRect && width != null && height != null) {
            viewBoxTransform = makeViewBoxTransform(viewBoxRect, { x: 0, y: 0, width: width, height: height });
            if (!opt.ignoreViewBox) {
                var elRoot = root;
                root = new __WEBPACK_IMPORTED_MODULE_0__graphic_Group_js__["a" /* default */]();
                root.add(elRoot);
                elRoot.scaleX = elRoot.scaleY = viewBoxTransform.scale;
                elRoot.x = viewBoxTransform.x;
                elRoot.y = viewBoxTransform.y;
            }
        }
        if (!opt.ignoreRootClip && width != null && height != null) {
            root.setClipPath(new __WEBPACK_IMPORTED_MODULE_3__graphic_shape_Rect_js__["a" /* default */]({
                shape: { x: 0, y: 0, width: width, height: height }
            }));
        }
        return {
            root: root,
            width: width,
            height: height,
            viewBoxRect: viewBoxRect,
            viewBoxTransform: viewBoxTransform,
            named: named
        };
    };
    SVGParser.prototype._parseNode = function (xmlNode, parentGroup, named, namedFrom, isInDefs, isInText) {
        var nodeName = xmlNode.nodeName.toLowerCase();
        var el;
        var namedFromForSub = namedFrom;
        if (nodeName === 'defs') {
            isInDefs = true;
        }
        if (nodeName === 'text') {
            isInText = true;
        }
        if (nodeName === 'defs' || nodeName === 'switch') {
            el = parentGroup;
        }
        else {
            if (!isInDefs) {
                var parser_1 = nodeParsers[nodeName];
                if (parser_1 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__core_util_js__["hasOwn"])(nodeParsers, nodeName)) {
                    el = parser_1.call(this, xmlNode, parentGroup);
                    var nameAttr = xmlNode.getAttribute('name');
                    if (nameAttr) {
                        var newNamed = {
                            name: nameAttr,
                            namedFrom: null,
                            svgNodeTagLower: nodeName,
                            el: el
                        };
                        named.push(newNamed);
                        if (nodeName === 'g') {
                            namedFromForSub = newNamed;
                        }
                    }
                    else if (namedFrom) {
                        named.push({
                            name: namedFrom.name,
                            namedFrom: namedFrom,
                            svgNodeTagLower: nodeName,
                            el: el
                        });
                    }
                    parentGroup.add(el);
                }
            }
            var parser = paintServerParsers[nodeName];
            if (parser && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__core_util_js__["hasOwn"])(paintServerParsers, nodeName)) {
                var def = parser.call(this, xmlNode);
                var id = xmlNode.getAttribute('id');
                if (id) {
                    this._defs[id] = def;
                }
            }
        }
        if (el && el.isGroup) {
            var child = xmlNode.firstChild;
            while (child) {
                if (child.nodeType === 1) {
                    this._parseNode(child, el, named, namedFromForSub, isInDefs, isInText);
                }
                else if (child.nodeType === 3 && isInText) {
                    this._parseText(child, el);
                }
                child = child.nextSibling;
            }
        }
    };
    SVGParser.prototype._parseText = function (xmlNode, parentGroup) {
        var text = new __WEBPACK_IMPORTED_MODULE_13__graphic_TSpan_js__["a" /* default */]({
            style: {
                text: xmlNode.textContent
            },
            silent: true,
            x: this._textX || 0,
            y: this._textY || 0
        });
        inheritStyle(parentGroup, text);
        parseAttributes(xmlNode, text, this._defsUsePending, false, false);
        applyTextAlignment(text, parentGroup);
        var textStyle = text.style;
        var fontSize = textStyle.fontSize;
        if (fontSize && fontSize < 9) {
            textStyle.fontSize = 9;
            text.scaleX *= fontSize / 9;
            text.scaleY *= fontSize / 9;
        }
        var font = (textStyle.fontSize || textStyle.fontFamily) && [
            textStyle.fontStyle,
            textStyle.fontWeight,
            (textStyle.fontSize || 12) + 'px',
            textStyle.fontFamily || 'sans-serif'
        ].join(' ');
        textStyle.font = font;
        var rect = text.getBoundingRect();
        this._textX += rect.width;
        parentGroup.add(text);
        return text;
    };
    SVGParser.internalField = (function () {
        nodeParsers = {
            'g': function (xmlNode, parentGroup) {
                var g = new __WEBPACK_IMPORTED_MODULE_0__graphic_Group_js__["a" /* default */]();
                inheritStyle(parentGroup, g);
                parseAttributes(xmlNode, g, this._defsUsePending, false, false);
                return g;
            },
            'rect': function (xmlNode, parentGroup) {
                var rect = new __WEBPACK_IMPORTED_MODULE_3__graphic_shape_Rect_js__["a" /* default */]();
                inheritStyle(parentGroup, rect);
                parseAttributes(xmlNode, rect, this._defsUsePending, false, false);
                rect.setShape({
                    x: parseFloat(xmlNode.getAttribute('x') || '0'),
                    y: parseFloat(xmlNode.getAttribute('y') || '0'),
                    width: parseFloat(xmlNode.getAttribute('width') || '0'),
                    height: parseFloat(xmlNode.getAttribute('height') || '0')
                });
                rect.silent = true;
                return rect;
            },
            'circle': function (xmlNode, parentGroup) {
                var circle = new __WEBPACK_IMPORTED_MODULE_2__graphic_shape_Circle_js__["a" /* default */]();
                inheritStyle(parentGroup, circle);
                parseAttributes(xmlNode, circle, this._defsUsePending, false, false);
                circle.setShape({
                    cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                    cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                    r: parseFloat(xmlNode.getAttribute('r') || '0')
                });
                circle.silent = true;
                return circle;
            },
            'line': function (xmlNode, parentGroup) {
                var line = new __WEBPACK_IMPORTED_MODULE_5__graphic_shape_Line_js__["a" /* default */]();
                inheritStyle(parentGroup, line);
                parseAttributes(xmlNode, line, this._defsUsePending, false, false);
                line.setShape({
                    x1: parseFloat(xmlNode.getAttribute('x1') || '0'),
                    y1: parseFloat(xmlNode.getAttribute('y1') || '0'),
                    x2: parseFloat(xmlNode.getAttribute('x2') || '0'),
                    y2: parseFloat(xmlNode.getAttribute('y2') || '0')
                });
                line.silent = true;
                return line;
            },
            'ellipse': function (xmlNode, parentGroup) {
                var ellipse = new __WEBPACK_IMPORTED_MODULE_4__graphic_shape_Ellipse_js__["a" /* default */]();
                inheritStyle(parentGroup, ellipse);
                parseAttributes(xmlNode, ellipse, this._defsUsePending, false, false);
                ellipse.setShape({
                    cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                    cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                    rx: parseFloat(xmlNode.getAttribute('rx') || '0'),
                    ry: parseFloat(xmlNode.getAttribute('ry') || '0')
                });
                ellipse.silent = true;
                return ellipse;
            },
            'polygon': function (xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute('points');
                var pointsArr;
                if (pointsStr) {
                    pointsArr = parsePoints(pointsStr);
                }
                var polygon = new __WEBPACK_IMPORTED_MODULE_6__graphic_shape_Polygon_js__["a" /* default */]({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                inheritStyle(parentGroup, polygon);
                parseAttributes(xmlNode, polygon, this._defsUsePending, false, false);
                return polygon;
            },
            'polyline': function (xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute('points');
                var pointsArr;
                if (pointsStr) {
                    pointsArr = parsePoints(pointsStr);
                }
                var polyline = new __WEBPACK_IMPORTED_MODULE_7__graphic_shape_Polyline_js__["a" /* default */]({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                inheritStyle(parentGroup, polyline);
                parseAttributes(xmlNode, polyline, this._defsUsePending, false, false);
                return polyline;
            },
            'image': function (xmlNode, parentGroup) {
                var img = new __WEBPACK_IMPORTED_MODULE_1__graphic_Image_js__["a" /* default */]();
                inheritStyle(parentGroup, img);
                parseAttributes(xmlNode, img, this._defsUsePending, false, false);
                img.setStyle({
                    image: xmlNode.getAttribute('xlink:href') || xmlNode.getAttribute('href'),
                    x: +xmlNode.getAttribute('x'),
                    y: +xmlNode.getAttribute('y'),
                    width: +xmlNode.getAttribute('width'),
                    height: +xmlNode.getAttribute('height')
                });
                img.silent = true;
                return img;
            },
            'text': function (xmlNode, parentGroup) {
                var x = xmlNode.getAttribute('x') || '0';
                var y = xmlNode.getAttribute('y') || '0';
                var dx = xmlNode.getAttribute('dx') || '0';
                var dy = xmlNode.getAttribute('dy') || '0';
                this._textX = parseFloat(x) + parseFloat(dx);
                this._textY = parseFloat(y) + parseFloat(dy);
                var g = new __WEBPACK_IMPORTED_MODULE_0__graphic_Group_js__["a" /* default */]();
                inheritStyle(parentGroup, g);
                parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                return g;
            },
            'tspan': function (xmlNode, parentGroup) {
                var x = xmlNode.getAttribute('x');
                var y = xmlNode.getAttribute('y');
                if (x != null) {
                    this._textX = parseFloat(x);
                }
                if (y != null) {
                    this._textY = parseFloat(y);
                }
                var dx = xmlNode.getAttribute('dx') || '0';
                var dy = xmlNode.getAttribute('dy') || '0';
                var g = new __WEBPACK_IMPORTED_MODULE_0__graphic_Group_js__["a" /* default */]();
                inheritStyle(parentGroup, g);
                parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                this._textX += parseFloat(dx);
                this._textY += parseFloat(dy);
                return g;
            },
            'path': function (xmlNode, parentGroup) {
                var d = xmlNode.getAttribute('d') || '';
                var path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__path_js__["b" /* createFromString */])(d);
                inheritStyle(parentGroup, path);
                parseAttributes(xmlNode, path, this._defsUsePending, false, false);
                path.silent = true;
                return path;
            }
        };
    })();
    return SVGParser;
}());
var paintServerParsers = {
    'lineargradient': function (xmlNode) {
        var x1 = parseInt(xmlNode.getAttribute('x1') || '0', 10);
        var y1 = parseInt(xmlNode.getAttribute('y1') || '0', 10);
        var x2 = parseInt(xmlNode.getAttribute('x2') || '10', 10);
        var y2 = parseInt(xmlNode.getAttribute('y2') || '0', 10);
        var gradient = new __WEBPACK_IMPORTED_MODULE_11__graphic_LinearGradient_js__["a" /* default */](x1, y1, x2, y2);
        parsePaintServerUnit(xmlNode, gradient);
        parseGradientColorStops(xmlNode, gradient);
        return gradient;
    },
    'radialgradient': function (xmlNode) {
        var cx = parseInt(xmlNode.getAttribute('cx') || '0', 10);
        var cy = parseInt(xmlNode.getAttribute('cy') || '0', 10);
        var r = parseInt(xmlNode.getAttribute('r') || '0', 10);
        var gradient = new __WEBPACK_IMPORTED_MODULE_12__graphic_RadialGradient_js__["a" /* default */](cx, cy, r);
        parsePaintServerUnit(xmlNode, gradient);
        parseGradientColorStops(xmlNode, gradient);
        return gradient;
    }
};
function parsePaintServerUnit(xmlNode, gradient) {
    var gradientUnits = xmlNode.getAttribute('gradientUnits');
    if (gradientUnits === 'userSpaceOnUse') {
        gradient.global = true;
    }
}
function parseGradientColorStops(xmlNode, gradient) {
    var stop = xmlNode.firstChild;
    while (stop) {
        if (stop.nodeType === 1
            && stop.nodeName.toLocaleLowerCase() === 'stop') {
            var offsetStr = stop.getAttribute('offset');
            var offset = void 0;
            if (offsetStr && offsetStr.indexOf('%') > 0) {
                offset = parseInt(offsetStr, 10) / 100;
            }
            else if (offsetStr) {
                offset = parseFloat(offsetStr);
            }
            else {
                offset = 0;
            }
            var styleVals = {};
            parseInlineStyle(stop, styleVals, styleVals);
            var stopColor = styleVals.stopColor
                || stop.getAttribute('stop-color')
                || '#000000';
            gradient.colorStops.push({
                offset: offset,
                color: stopColor
            });
        }
        stop = stop.nextSibling;
    }
}
function inheritStyle(parent, child) {
    if (parent && parent.__inheritedStyle) {
        if (!child.__inheritedStyle) {
            child.__inheritedStyle = {};
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__core_util_js__["defaults"])(child.__inheritedStyle, parent.__inheritedStyle);
    }
}
function parsePoints(pointsString) {
    var list = splitNumberSequence(pointsString);
    var points = [];
    for (var i = 0; i < list.length; i += 2) {
        var x = parseFloat(list[i]);
        var y = parseFloat(list[i + 1]);
        points.push([x, y]);
    }
    return points;
}
function parseAttributes(xmlNode, el, defsUsePending, onlyInlineStyle, isTextGroup) {
    var disp = el;
    var inheritedStyle = disp.__inheritedStyle = disp.__inheritedStyle || {};
    var selfStyle = {};
    if (xmlNode.nodeType === 1) {
        parseTransformAttribute(xmlNode, el);
        parseInlineStyle(xmlNode, inheritedStyle, selfStyle);
        if (!onlyInlineStyle) {
            parseAttributeStyle(xmlNode, inheritedStyle, selfStyle);
        }
    }
    disp.style = disp.style || {};
    if (inheritedStyle.fill != null) {
        disp.style.fill = getFillStrokeStyle(disp, 'fill', inheritedStyle.fill, defsUsePending);
    }
    if (inheritedStyle.stroke != null) {
        disp.style.stroke = getFillStrokeStyle(disp, 'stroke', inheritedStyle.stroke, defsUsePending);
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__core_util_js__["each"])([
        'lineWidth', 'opacity', 'fillOpacity', 'strokeOpacity', 'miterLimit', 'fontSize'
    ], function (propName) {
        if (inheritedStyle[propName] != null) {
            disp.style[propName] = parseFloat(inheritedStyle[propName]);
        }
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__core_util_js__["each"])([
        'lineDashOffset', 'lineCap', 'lineJoin', 'fontWeight', 'fontFamily', 'fontStyle', 'textAlign'
    ], function (propName) {
        if (inheritedStyle[propName] != null) {
            disp.style[propName] = inheritedStyle[propName];
        }
    });
    if (isTextGroup) {
        disp.__selfStyle = selfStyle;
    }
    if (inheritedStyle.lineDash) {
        disp.style.lineDash = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__core_util_js__["map"])(splitNumberSequence(inheritedStyle.lineDash), function (str) {
            return parseFloat(str);
        });
    }
    if (inheritedStyle.visibility === 'hidden' || inheritedStyle.visibility === 'collapse') {
        disp.invisible = true;
    }
    if (inheritedStyle.display === 'none') {
        disp.ignore = true;
    }
}
function applyTextAlignment(text, parentGroup) {
    var parentSelfStyle = parentGroup.__selfStyle;
    if (parentSelfStyle) {
        var textBaseline = parentSelfStyle.textBaseline;
        var zrTextBaseline = textBaseline;
        if (!textBaseline || textBaseline === 'auto') {
            zrTextBaseline = 'alphabetic';
        }
        else if (textBaseline === 'baseline') {
            zrTextBaseline = 'alphabetic';
        }
        else if (textBaseline === 'before-edge' || textBaseline === 'text-before-edge') {
            zrTextBaseline = 'top';
        }
        else if (textBaseline === 'after-edge' || textBaseline === 'text-after-edge') {
            zrTextBaseline = 'bottom';
        }
        else if (textBaseline === 'central' || textBaseline === 'mathematical') {
            zrTextBaseline = 'middle';
        }
        text.style.textBaseline = zrTextBaseline;
    }
    var parentInheritedStyle = parentGroup.__inheritedStyle;
    if (parentInheritedStyle) {
        var textAlign = parentInheritedStyle.textAlign;
        var zrTextAlign = textAlign;
        if (textAlign) {
            if (textAlign === 'middle') {
                zrTextAlign = 'center';
            }
            text.style.textAlign = zrTextAlign;
        }
    }
}
var urlRegex = /^url\(\s*#(.*?)\)/;
function getFillStrokeStyle(el, method, str, defsUsePending) {
    var urlMatch = str && str.match(urlRegex);
    if (urlMatch) {
        var url = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__core_util_js__["trim"])(urlMatch[1]);
        defsUsePending.push([el, method, url]);
        return;
    }
    if (str === 'none') {
        str = null;
    }
    return str;
}
function applyDefs(defs, defsUsePending) {
    for (var i = 0; i < defsUsePending.length; i++) {
        var item = defsUsePending[i];
        item[0].style[item[1]] = defs[item[2]];
    }
}
var numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function splitNumberSequence(rawStr) {
    return rawStr.match(numberReg) || [];
}
var transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.eE,]*)\)/g;
var DEGREE_TO_ANGLE = Math.PI / 180;
function parseTransformAttribute(xmlNode, node) {
    var transform = xmlNode.getAttribute('transform');
    if (transform) {
        transform = transform.replace(/,/g, ' ');
        var transformOps_1 = [];
        var mt = null;
        transform.replace(transformRegex, function (str, type, value) {
            transformOps_1.push(type, value);
            return '';
        });
        for (var i = transformOps_1.length - 1; i > 0; i -= 2) {
            var value = transformOps_1[i];
            var type = transformOps_1[i - 1];
            var valueArr = splitNumberSequence(value);
            mt = mt || __WEBPACK_IMPORTED_MODULE_8__core_matrix_js__["create"]();
            switch (type) {
                case 'translate':
                    __WEBPACK_IMPORTED_MODULE_8__core_matrix_js__["translate"](mt, mt, [parseFloat(valueArr[0]), parseFloat(valueArr[1] || '0')]);
                    break;
                case 'scale':
                    __WEBPACK_IMPORTED_MODULE_8__core_matrix_js__["scale"](mt, mt, [parseFloat(valueArr[0]), parseFloat(valueArr[1] || valueArr[0])]);
                    break;
                case 'rotate':
                    __WEBPACK_IMPORTED_MODULE_8__core_matrix_js__["rotate"](mt, mt, -parseFloat(valueArr[0]) * DEGREE_TO_ANGLE);
                    break;
                case 'skewX':
                    var sx = Math.tan(parseFloat(valueArr[0]) * DEGREE_TO_ANGLE);
                    __WEBPACK_IMPORTED_MODULE_8__core_matrix_js__["mul"](mt, [1, 0, sx, 1, 0, 0], mt);
                    break;
                case 'skewY':
                    var sy = Math.tan(parseFloat(valueArr[0]) * DEGREE_TO_ANGLE);
                    __WEBPACK_IMPORTED_MODULE_8__core_matrix_js__["mul"](mt, [1, sy, 0, 1, 0, 0], mt);
                    break;
                case 'matrix':
                    mt[0] = parseFloat(valueArr[0]);
                    mt[1] = parseFloat(valueArr[1]);
                    mt[2] = parseFloat(valueArr[2]);
                    mt[3] = parseFloat(valueArr[3]);
                    mt[4] = parseFloat(valueArr[4]);
                    mt[5] = parseFloat(valueArr[5]);
                    break;
            }
        }
        node.setLocalTransform(mt);
    }
}
var styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
function parseInlineStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    var style = xmlNode.getAttribute('style');
    if (!style) {
        return;
    }
    styleRegex.lastIndex = 0;
    var styleRegResult;
    while ((styleRegResult = styleRegex.exec(style)) != null) {
        var svgStlAttr = styleRegResult[1];
        var zrInheritableStlAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__core_util_js__["hasOwn"])(INHERITABLE_STYLE_ATTRIBUTES_MAP, svgStlAttr)
            ? INHERITABLE_STYLE_ATTRIBUTES_MAP[svgStlAttr]
            : null;
        if (zrInheritableStlAttr) {
            inheritableStyleResult[zrInheritableStlAttr] = styleRegResult[2];
        }
        var zrSelfStlAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__core_util_js__["hasOwn"])(SELF_STYLE_ATTRIBUTES_MAP, svgStlAttr)
            ? SELF_STYLE_ATTRIBUTES_MAP[svgStlAttr]
            : null;
        if (zrSelfStlAttr) {
            selfStyleResult[zrSelfStlAttr] = styleRegResult[2];
        }
    }
}
function parseAttributeStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    for (var i = 0; i < INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS.length; i++) {
        var svgAttrName = INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) {
            inheritableStyleResult[INHERITABLE_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
        }
    }
    for (var i = 0; i < SELF_STYLE_ATTRIBUTES_MAP_KEYS.length; i++) {
        var svgAttrName = SELF_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) {
            selfStyleResult[SELF_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
        }
    }
}
function makeViewBoxTransform(viewBoxRect, boundingRect) {
    var scaleX = boundingRect.width / viewBoxRect.width;
    var scaleY = boundingRect.height / viewBoxRect.height;
    var scale = Math.min(scaleX, scaleY);
    return {
        scale: scale,
        x: -(viewBoxRect.x + viewBoxRect.width / 2) * scale + (boundingRect.x + boundingRect.width / 2),
        y: -(viewBoxRect.y + viewBoxRect.height / 2) * scale + (boundingRect.y + boundingRect.height / 2)
    };
}
function parseSVG(xml, opt) {
    var parser = new SVGParser();
    return parser.parse(xml, opt);
}



/***/ }),
/* 1721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transformPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_PathProxy_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_vector_js__ = __webpack_require__(23);


var CMD = __WEBPACK_IMPORTED_MODULE_0__core_PathProxy_js__["a" /* default */].CMD;
var points = [[], [], []];
var mathSqrt = Math.sqrt;
var mathAtan2 = Math.atan2;
function transformPath(path, m) {
    if (!m) {
        return;
    }
    var data = path.data;
    var len = path.len();
    var cmd;
    var nPoint;
    var i;
    var j;
    var k;
    var p;
    var M = CMD.M;
    var C = CMD.C;
    var L = CMD.L;
    var R = CMD.R;
    var A = CMD.A;
    var Q = CMD.Q;
    for (i = 0, j = 0; i < len;) {
        cmd = data[i++];
        j = i;
        nPoint = 0;
        switch (cmd) {
            case M:
                nPoint = 1;
                break;
            case L:
                nPoint = 1;
                break;
            case C:
                nPoint = 3;
                break;
            case Q:
                nPoint = 2;
                break;
            case A:
                var x = m[4];
                var y = m[5];
                var sx = mathSqrt(m[0] * m[0] + m[1] * m[1]);
                var sy = mathSqrt(m[2] * m[2] + m[3] * m[3]);
                var angle = mathAtan2(-m[1] / sy, m[0] / sx);
                data[i] *= sx;
                data[i++] += x;
                data[i] *= sy;
                data[i++] += y;
                data[i++] *= sx;
                data[i++] *= sy;
                data[i++] += angle;
                data[i++] += angle;
                i += 2;
                j = i;
                break;
            case R:
                p[0] = data[i++];
                p[1] = data[i++];
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_vector_js__["applyTransform"])(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
                p[0] += data[i++];
                p[1] += data[i++];
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_vector_js__["applyTransform"])(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
        }
        for (k = 0; k < nPoint; k++) {
            var p_1 = points[k];
            p_1[0] = data[i++];
            p_1[1] = data[i++];
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_vector_js__["applyTransform"])(p_1, p_1, m);
            data[j++] = p_1[0];
            data[j++] = p_1[1];
        }
    }
    path.increaseVersion();
}


/***/ }),
/* 1722 */
/***/ (function(module, exports) {

module.exports = {"system":{"title":"Event Planning Platform","server_error_msg":"系统错误，请稍后重试","plural_suffix":"","login_expired":"登录已过期","network_error":"网络连接错误","network_timeout":"网络连接超时","loading":"加载中","approval":"Approval","input":{"fill_prefix":"请输入"},"select":{"common_select":"请选择"},"is_required":"是必填项","no_data":"暂无数据","standalone":"Comm-Standalone","sponsorship":"Comm-Sponsorship","medical":"AB&Med-Standalone"},"common":{"assign":"分配","assign_record":"分配记录","approval":"审批中","approve":"审批通过","need_bu_approve":"需要BU Head 审批","reject":"拒绝","return":"退回","search":"搜索","add":"添加","upload":"上传","export":"导出","view":"查看","delete":"删除","action":"操作","status":"状态","more":"更多","show":"显示","hide":"隐藏","show_more":"显示更多","please_fill_in":"请输入","please_fill_in_comments":"请填写理由","please_fill_in_reason":"请填写原因","please_fill_in_number":"请输入数字","please_choose":"请选择","please_select":"请选择","please_upload":"请上传","whether_eeib":"是否EEIB","sn":"S/N","supporting_documents":"支持文件","supporting_documents_optional":"支持文件(可选)","qr_code":"二维码","yes":"是","no":"否","not_required":"无需判断","approval_process":"审批流程","attendee":"参会者","speaker":"讲者","po_number":"PO号码","name":"姓名","comments":"评论","please_upload_files":"请上传文件","please_upload_supporting_documents":"请上传支持性文件","tax_included":"含税","detail":"详情","attachment":"附件","mudid":"MUDID","role":"角色","email":"电子邮件","close":"关闭","empty_data":"暂无数据"},"login":{"account_login":"账户登录","title":"Event Planning Platform","account":"账户","password":"密码","login":"登录","produce":"出品","wrong_user_name_or_password":"用户名或密码错误","please_fill_in_account":"请输入账户名","please_fill_in_password":"请输入密码","login_successful":"登录成功"},"breadcrumb":{"st":{"m1_module_title":"季度计划","m2_module_title":"讲者与参会者","m3_module_title":"会议申请","m4_module_title":"讲者合同和材料","m5_module_title":"会议安排","m6_module_title":"会议执行"},"sp":{"m0_module_title":"HCO管理","m1_module_title":"季度计划","m2_module_title":"会议申请","m3_module_title":"会议TPO-FMV-DD","m4_module_title":"讲者合同和材料","m4_module_title2":"HCO合同","m5_module_title":"会议安排","m6_module_title":"会议执行","m7_module_title":"GR process"},"md":{"m1_module_title":"季度计划","m3_module_title":"会议申请","m4_module_title":"讲者合同和材料","m5_module_title":"会议安排","m6_module_title":"会议执行"}},"approval":{"approve_successfully":"审批通过","reject_successfully":"审批拒绝","failed_to_approve":"审批失败","failed_to_reject":"拒绝失败","confirm_to_approve":"确认审批?","confirm_to_reject":"确认拒绝?","confirm_to_add":"确认新增?"},"tip":{"does_require":"是否需要","no_data_found":"没有找到数据","coi-submit-tips":"请确保所有的COI有效截止日期晚于会议日期，EEIB状态已明确，是EEIB的讲者/参会者的EEIB例外审批表已上传","coi-submit-tips_md":"Please make sure all COI expiry date is before meeting date, EEIB status is defined, and EEIB exception form for EE/attendee who is EEIB has been uploaded.","coi_expiry_date":"如果存在COI过期日期早于会议日期，请联系EO去更新COI，否则将无法提交审批","go_status":"如果存在EEIB状态未明确，请校验并在VEEVA中更新行政职务，否则将无法提交审批","go_exception_form":"如果有讲者/参会者是EEIB，请上传EEIB例外审批表，否则将无法提交审批","speaker_attendee":"如果有讲者/参会者的EEIB状态无法在VEEVA中验证，您需要联系EO将他们从提名列表中删除，否则将无法提交审批","coi_expiry_date_md":"If COI expiry date is before the meeting date, please contact Medical BO to renew COI, otherwise you cannot submit for approval.","go_status_md":"If EEIB status is undefined, please check and update the academic title in VEEVA, otherwise you cannot submit for approval.","go_exception_form_md":"Please update EEIB exception form for EE/attendee who is EEIB, otherwise you cannot submit for approval.","speaker_attendee_md":"Please contact Medical BO to delete EE/attendee in the nomination list whose EEIB status cannot be verified in VEEVA, otherwise you cannot submit for approval.","please_fill_in_reason":"请填写理由","paid_ee":"付费咨询专家、付费外部讲者","unpaid_ee":"不付费咨询专家、不付费外部讲者","attendee":"参会者，不为GSK提供服务。存在于SW/ GSK-led ME等会议，需要扫码签署参会确认函","t&e":"内部员工差旅花费","paid_speaker_tip":"被CMD审批通过，可以被HCPE会议提名的讲者","unpaid_speaker_tip":"被赞助会提名过的讲者以及所有的有偿讲者","attendee_tip":"所有VEEVA系统中的HCP","coiqr_code_tip":"讲者和参会者可使用此二维码填写COI","ee_tip":"可以被医学部会议提名的外部专家","eeib_status_tips":{"valid":"有效待确认：EEIB状态为有效待确认，需要EO在ER审批通过后的 “确认EEIB” 页面确认EEIB状态。","invalid":"无效：EEIB状态为无效。请确保COI有效未过期；行政职务不为空后根据更新后的EEIB状态进行后续操作。","confirmed":"已确认：该讲者/参会者已被确认为非EEIB。","approved":"审批通过：该讲者/参会者的EEIB状态已经被审批通过。","not_required":"无需判断：无需判断该讲者/参会者的EEIB状态。"},"eeib_status_tips_md":{"valid":"有效待确认：EEIB状态为有效待确认，需要BO在ER审批通过后的 “确认EEIB” 页面确认EEIB状态。","invalid":"无效：EEIB状态为无效。请确保COI有效未过期；行政职务不为空后根据更新后的EEIB状态进行后续操作。","confirmed":"已确认：该EE/参会者已被确认为非EEIB。","approved":"审批通过：该EE/参会者的EEIB状态已经被审批通过。","not_required":"无需判断：无需判断该EE/参会者的EEIB状态。"},"cl_code_info_yes":"非主席的讲者需选择演讲材料，否则无法成功提交合同","duration_start_date_and_end_date_cannot_more_than_n_days":"会议开始日期和结束日期相差超过5天，请重新选择","duration_start_date_and_end_date_cannot_more_than_ten_days":"会议开始日期和结束日期相差超过10天，请重新选择"},"breadcrumb_title":{"home":"首页","new_HCO_application_process":"新HCO申请进程","hco_management":"HCO管理","hco_update_process":"HCO更新流程"},"error":{"operation_is_timeout":"操作超时","time_out_message":"抱歉，您已操作超时，暂时无法使用Gmeeting系统。","system_error":"系统错误，请稍后重试","403_error_1":"抱歉，您无权限访问","403_error_2":"可能的原因：没有访问权限，请联系管理员…","404_error_1":"您访问的页面不存在","404_error_2":"可能的原因：网址输入错误、网址已失效…","500_error_1":"抱歉，服务器错误，请稍后访问","500_error_2":"可能的原因：服务器正在维护…","data_error":"由于数据错误，EO无法提交讲者提名"},"component":{"filebox":{"limit_prefix":"不能上传超过 ","limit_suffix":" 个文件","confirm_delete_file":"是否确认删除该文件？","not_support_preview":"该文件类型暂不支持预览！"},"singleupload":{"uploading":"上传中","upload_success":"上传成功","upload_failed":"上传失败","max_size_prefix":"最大上传 ","max_size_suffix":"M 的文件","error_file_format":"文件格式不正确","support_all_files_within":"支持所有类型的文件不大于"},"mapbox":{"location":"地址","load_map_error":"加载地图失败","default_confirm_title":"确认目标地址?"},"assignrecord":{"assigned_to":"分配给","system_automatically":"系统自动"}},"btn":{"back_to_home":"返回首页","save":"保存","submit":"提交","preview":"预览","approve":"同意","reject":"拒绝","generate":"生成","confirm":"确认","cancel":"取消","update":"更新","view":"查看","upload":"上传","review":"检查","check":"核对","add":"添加","delete":"删除","search":"搜索","back":"返回","close":"关闭","assign":"分配","export":"导出","no_data":"暂无数据","download":"下载","clear":"清除","advanced_search":"高级搜索","hide":"隐藏","show":"显示","action":"操作","more":"更多","withdraw":"撤回","canceled":" 撤销","edit":"修改","input":"填写","copy":"复制","next":"下一步","apply":"申请","batch_submission":"批量提交","previous_page":"上一页","next_page":"下一页","submit_for_trial":"试算","send":"发送","revocation":"Revocation","refresh":"刷新","adobeSign":"签署文件","add_more":"添加更多","edit_attendance":"编辑出席状态","confirm_attendance":"确认出席状态"},"popup":{"submit_confirm":"是否确认提交？","submit_success":"提交成功。","operation_success":"操作成功。","operation_failed":"操作失败。","generate_confirm":"是否确认生成？","generate_success":"生成成功","generate_failed":"生成失败","delete_confirm":"是否确认删除？","delete_success":"删除成功。","add_success":"添加成功。","confirm_success":"确认成功。","submit_fail":"提交失败。","save":"确认保存？","save_success":"保存成功。","save_fail":"保存失败。","update_confirm":"是否确认更新？","withdraw_confirm":"是否确认撤回？","withdraw_success":"撤回成功。","withdraw_fail":"撤回失败。","assign_confirm":"是否确认分配？","assign_success":"分配成功。","assign_fail":"分配失败。","close_confirm":"是否确认复原?","close_success":"复原成功","close_fail":"复原失败","approve":"审批成功","reject":"审批拒绝","approve_placeholder":"建议填写审批通过理由。","submit_placeholder":"请输入提交理由。","reject_placeholder":"请输入拒绝理由。","optional":"可选","required":"必填","confirm":"是否确认？","upload_confirm":"是否确认上传？","upload_success":"上传成功。","upload_fail":"上传失败。","del_quotation":"Whether to delete the Quotation?","del_quotation_2":"如果该报价单已在Ariba中提交订单，请及时在Ariba中取消","update_success":"更新成功.","update_fail":"更新失败.","download_success":"下载成功.","download_fail":"下载失败.","confirm_assgin":"确认分配?","uploaded_error":"上传错误","approve_successfully":"审核成功","confirm_successfully":"确认成功","reject_successfully":"拒绝成功","return_successfully":"退回成功","failed_to_approve":"审批失败","failed_to_reject":"拒绝失败","failed_to_return":"退回失败","cancel_confirm":"确认取消？","cancel_successfully":"取消成功","copy_confirm":"确认复制？","copy_success":"复制成功","failed_to_copy":"复制失败","assign_successfully":"分配成功","failed_to_assign":"分配失败","failed_to_confirm":"确认失败","get_meeting_info_failed":"获取会议信息失败","get_qr_code_failed":"获取二维码信息失败","get_speaker_info_failed":"获取讲者信息失败","trail_failed":"试算失败","submit_speaker_contract_to_g_sign":"Submit speaker contract to G-sign？"},"approval_process":{"unsubmitted":"未提交","submitted":"已提交","assigned":"已分配","created":"已创建","updated":"已更新","approved":"审批通过","confirmed":"已确认","pending":"待审批","rejected":"审批拒绝","deleted":"已删除","expired":"已过期","saved":"已保存"},"status":{"uploaded":"已上传","submitted":"已提交","unsubmitted":"未提交","blank":"待提交","approved":"审批通过","rejected":"审批拒绝","withdrawed":"审批撤回","pending":"待提交","confirmed":"已确认","no show":"受邀未参会","not required":"not required","generated":"已生成","assigned":"已分配","expired":"已过期","ceoe head approved":"CEOE Head 审批通过"},"label":{"start_date":"开始时间","end_date":"结束时间","province":"省","city":"市","all":"全部","name":"名称","adhoc":"Ad hoc","yes":"是","no":"否","not_applicable":"不适用","veeva_id_abac_id":"Veeva ID / ABAC ID","veeva_id":"Veeva ID","department":"部门","academic_title":"学术头衔","hospital":"医院","category":"类别","status":"状态","title":"头衔","title2":"行政职务","tax_excluded":"（含税）","tax_included":"（不含税）","po_number":"PO号码","po_status":"PO状态","po_amount":"PO金额","wbs_code_cost_center":"WBS Code / Cost Center","bank_account_number":"银行账号","bank_name":"银行开户行","price":"价格","meeting_theme":"Meeting theme","training":"培训信息"},"meeting":{"code":"会议编号","name":"会议名称","eo_name":"EO 名称","eo":"EO","coe":"COE","em":"EM","bo":"BO","mas":"MAS","hpt":"HCO payment","meeting_option":"会议细项","EO_COE_EM_HPT":"EO/COE/EM/HPT","per_capita_cost":"人均花费"},"dict":{"ta":"TA","meeting_status":"会议状态","meeting_type":"会议类型","engagement_type":"会议类型","meeting_category":"会议类别","meeting_series":"系列会 / 单场会","meeting_method":"会议形式","task_status":"任务状态","business_rationale":"业务目的"},"pdfViewer":{"data_error":"数据错误"},"home":{"personal_center":"个人中心","manual":"用户手册","comments":"Comments","logout":"退出","user_role":"角色","user_id":"员工号","user_dept":"部门","user_medical_field":"所在治疗领域（franchise）","user_bu":"BU","user_ta":"TA","user_name":"姓名","user_mudid":"MUDID","user_email":"邮箱","user_phone":"手机号码","user_head_protrait":"用户头像","user_update_phone":"更新手机号码","cell_phone_number":"手机号码","cell_phone_number_required":"手机号码为必填项","malformed_cell_phone_number":"手机号码格式错误","manual_help_text":"如有任何疑问，可以下载手册文档以获取帮助。","load_manual_fail":"获取用户手册失败","engagement":"会议","search_text_meeting_code_name":"请输入会议编号或会议名称","fail_to_get_meeting_list":"获取会议列表失败","fail_to_get_news_list":"获取消息列表失败","fail_to_get_notice_list":"获取公告列表失败","fail_to_get_task_list":"获取任务列表失败","news":"消息","quarterly_plan":"季度计划","hcp":"讲者与参会者","hco":"HCO","dashboard":"Dashboard","backend":"后台管理","cannot_access_module":"您没有权限访问该模块","notice":"公告","my_task":"我的任务","home":"主页","documentation":"文件管理","my_meeting":"我的会议","select_at_least_one_meeting":"请至少选择一场会议","fail_to_get_assign_user_list":"获取分配用户列表失败","meeting_total_budget":"会议总预算","engagement_request":"会议申请","speaker_contracting":"讲者合同和材料","ee_contracting":"EE 合同和材料","event_arrangement":"会议需求","engagement_execution":"会议执行","fail_to_get_meeting_info":"获取会议信息失败","meeting_tpo_fmv_dd":"会议TPO-FMV-DD","hco_contracting":"HCO合同","meeting_goods_recepit":"会议收货","please_separate_assign_medical_and_com_meeting":"请分别分配 medical 和 commercial 会议","all":"全选","re_assign":"重新分配","a_maximum_of_10_meetings_can_be_re_assigned_at_one_time":"重新分配时每次最多可选10场会议。","please_fill_in_mudid_or_name":"请输入MUDID或者姓名。"},"pr_po":{"label":{"pr_number":"PR编号","pr_status":"PR状态","po_number":"PO编号","po_status":"PO状态","submit_time":"提交时间","submit_method":"提交方式","ariba_category":"Ariba category","wbs_code":"WBS code","price":"Price","tax_excluded":"(tax excluded)","pr_description":"PR description (optional)","comments":"Comments","rpa_progress":"RPA progress"},"tip":{"manual_submit_tips":"一旦提交手动PR，系统将自动关闭RPA PR进程并且不可恢复。如您之前已申请过RPA PR，想要切换到手动PR模式: <br />1) 请到Ariba里申请PR/PO后，将号码输入在下方点击提交。 <br />2) 系统将在您输入PR/PO号后，自动取消由RPA方式提交的PR/PO。","manual_submit_popup_tips":"一旦提交手动PR，系统将自动关闭RPA PR进程并且不可恢复。","manual_submit_err":"您填写的PR/PO号与Ariba中不一致，请确认正确的PR/PO号并更新。","is_submit_manual":"1. 由于手动PR进程已开启，导致RPA PR进程已自动关闭，无法恢复。如果您需要更新PR/PO，请到Ariba进行更新，并在系统中输入最终的PR/PO号以支持付款请求。<br />2. 如有通过RPA PR 申请成功的PR/PO，系统将自动帮您取消PR。<br />3. RPA查询如RPA process中有对应的成功PR则自动发起取消PR命令；如有失败的PR则停止补偿；如有未发起的PR，则撤回。","not_submit_manual":"1. 当RPA status为”-“/”completed”/”failed”时，您可以通过RPA进行PR的更新和取消。<br /> 2. 如遇紧急情况，您可选择自行至Ariba申请PR并将申请的PR/PO号填写至系统中。<br /> 3. 如您选择切换成手动PR，系统将自动关闭RPA PR进程并且不可恢复。如您已申请RPA PR，系统将自动帮您取消PR。","rpa_status":"In submission ：PR申请已提交，RPA正在处理。<br />In re-submission ：PR申请已提交，RPA正在补偿处理。<br />Obtaining PO ：PR提交成功，正在获取PO信息。<br />Completed ：PR&PO已完成。<br />Closed ：RPA PR已关闭。<br />In cancellation：RPA正在执行取消PR。","pr_number_must_start_with_pr":"PR 号必须以 PR 开头","pr_number_least_6":"PR 编号需要至少 6 个字符","please_fill_in_the_character_after_pr":"请填写PR后的字符。"},"placeholder":{"pr_number":"请填写PR编号","po_number":"请填写PO编号","pr_description":"Please fill in PR description (optional), no more than 500 words","ariba_category":"会议计划及活动安排","select_ariba_category":"请选择 Ariba category","wbs_code":"请选择 WBS code","price":"请填写 price"}},"engagementRequest":{"title":{"summary_of_meeting_approval":"会议审批总览","city_allocation":"讲者参会者城市分配情况","breakdown_of_event_budget":"会议预算分类","meeting_budget_summary":"会议预算总览","tentative_attendee_list":"Tentative Attendee List","engagement":"会议","meeting_agenda":"会议议程","nominate_speaker":"提名讲者","select_attendee":"选择参会者","task_assign":"任务分配","approval_process":"审批流","meeting_invitation":"会议邀请函","confirm_final_attendee":"确认最终参会者","confirm_to_change":"是否确认修改","confirm_to_cancel":"是否确认取消会议","confirm_speaker_eeib":"讲者-EEIB确认","speaker_nomination":"讲者提名","nominated_speaker":"提名讲者列表","eeib_confirm":"EEIB待确认列表","eeib_approval":"EEIB待审批列表","valid_speaker":"有效讲者列表","confirm_ee_eeib":"EE-EEIB确认","confirm_attendee_eeib":"参会者-EEIB确认","scanned_attendees":"已扫码参会者列表","EEIB_approval":"EEIB审批列表","Final_attendees":"最终参会者列表","All":"全部","Breakdown_of_EE_service_fee_budget":"Breakdown of EE service fee budget","breakdown_of_te_budget":"Breakdown of T&E budget","confirm_to_submit_speaker":"Confirm to submit speaker","assessment_document":"Assessment document","paid_ee":"Paid EE","unpaid_ee":"Unpaid EE","confirm_eeib_speaker":"Confirm speaker EEIB","After_ER_approval":"ER审批通过后","ad_hoc_meeting":"临时会议","speaker":"讲者","QR_code":"二维码","re_assign_eo":"重新分配EO"},"label":{"quarterly_brand_cap":"Quarterly brand cap","planed_meeting_budget":"已审批通过季度计划预算","approved_meeting_budget":"季度计划中，已审批通过ER预算","ad_hoc_meeting_budget":"已审批通过Ad hoc会议预算","planed_meeting_volume":"季度计划中，已审批通过会议数量","approved_meeting_volume":"季度计划中，已审批通过ER会议数量","ad_hoc_meeting_volume":"已审批通过Ad hoc会议数量","meeting_name":"会议名称","bu":"业务部门","ta":"治疗领域","product":"产品名称","business_rationale":"业务目的","business_rationale_short_description":"业务目的简述","meeting_category":"会议类别","meeting_method":"会议形式","national":"全国会","regional":"区域会","city":"城市会","city2":"城市","online_meeting":"线上会议","offline_meeting":"线下会议","online_and_offline_meeting":"线上+线下会议","rm_territory_code":"RM Territory Code","province":"省/直辖市","province_city":"城市","start_date":"开始日期","end_date":"结束日期","meeting_duration":"会议时长","days":"天","number_of_paid_speaker_international":"有偿讲者-国际级人数","number_of_paid_speaker_national":"有偿讲者-国家级人数","number_of_paid_speaker_regional":"有偿讲者-区域级人数","number_of_paid_speaker":"有偿讲者人数","number_of_paid_speaker_online":"有偿讲者人数（线上）","number_of_paid_speaker_offline":"有偿讲者人数（线下）","number_of_unpaid_speaker":"无偿讲者人数","number_of_unpaid_speaker_online":"无偿讲者人数（线上）","number_of_unpaid_speaker_offline":"无偿讲者人数（线下）","number_of_hcp_attendee":"参会者人数","number_of_hcp_attendee_online":"参会者人数（线上）","number_of_hcp_attendee_offline":"参会者人数（线下）","planned_in_er":"会议申请计划人数","number_of_gsk_staff":"GSK员工人数","number_of_gsk_staff_online":"GSK员工人数（线上）","number_of_gsk_staff_offline":"GSK员工人数（线下）","number_of_speaker_and_attendee":"该城市分布的讲者和参会者人数","accommodation":"住宿","flight":"飞机","train":"Train","ground_transportaion":"地面交通","meal":"订餐","meeting_room":"会议场地","production":"物料/影音材料","webinar":"在线会议","translation":"翻译","others":"其他费用","booth":"展台","booth_material":"展台材料","video_play_material":"视频材料","speaker_fee_budget":"讲者费用预算","event_budget":"会议活动预算","meeting_budget":"总预算","T&E_budget":"T&E budget","rationale_of_exceeding_30%_of_budget_in_quarterly_plan":"会议预算超过季度计划中审批通过的预算的30%","rationale_of_exceeding_budget":"超出预算理由","meeting_agenda":"会议议程","product_name":"产品名称","quaterly_band_cap":"Quaterly Brand Cap","approved_engagement_budget":"审批通过的会议预算","budget_of_this_engagement":"Budget of This Engagement","budget_in_approved_quaterly_plan":"审批通过的季度预算","ee_service_fee_budget_approved_quaterly_plan":"EE service fee budget approved in quaterly plan","event_budget_approved_quaterly_plan":"Event budget approved in quaterly plan","te_budget_approved_quaterly_plan":"T&E budget approved in quaterly plan","paid_speaker":"有偿讲者","unpaid_speaker":"无偿讲者","meeting_time":"会议时间","meeting_location":"会议地址","meeting_code":"会议编号","sponsorship_fee_budget":"赞助费预算","no_of_paid_speaker":"有偿讲者人数","no_of_unpaid_speaker":"无偿讲者人数","meeting_total_budget":"会议总预算","category":"类型","veeva_id_abac_id":"Veeva ID/ABAC ID","veeva_id":"Veeva ID","name":"姓名","workplace":"医院","department":"科室","title":"职称","possibility":"参会可能性","download_template":"Download Template","please_choose_file":"Please choose file","no_of_attendee":"参会者人数","tenatative":"提名参会者","validated":"有效","comfirmed":"已确认","attendee_name":"Attendee Name","hospital":"医院","if_COI_with_red_flag":"COI red flag","if_GO":"是否是政府官员","disclosure_consent":"是否愿意被披露","brand_budget":"产品预算","location":"地点","meeting_information":"会议信息","paid_speaker_or_unpaid_speaker":"有偿讲者还是无偿讲者","meeting_invitation_letter":"会议邀请函","content_lab_code":"Content lab 编号","status":"状态","template":"模板","te_accommondation":"员工花费-住宿","te_flight":"员工花费-飞机","te_airTravel":"员工花费-飞机","hco_name":"HCO名称","is_series":"系列会/单场会","no_of_submeetings":"分会总场数","series_meeting":"系列会","single_meeting":"单场会","sponsor_fee_budget":"赞助费预算","te_flight2":"员工花费—飞机","rationale_of_exceeding":"超过季度预算的原因","sponsorship_letter":"招商函","venue_is_in_hospital":"场租是否在医院","if_held_in_target_hospital":"是否在目标医院举办","hospital_code_name":"医院编码&名称","hospital_level":"医院等级","if_co_sponsored_by_the_hospital":"If co-organized/organized by hospital 是否由医院协办/承办","if_contains_satellite":"是否包含卫星会","if_contains_satellite_symposium":"是否赞助卫星会","if_sponsorship_package":"是否package赞助","satellite_symposium_no":"卫星会数量","meeting_date":"会议日期","start_time":"开始时间","end_time":"结束时间","min":"分钟","satellite_sponsor_fee":"卫星会赞助费","if_contains_booth":"是否包含展台","booth_no":"展台数量","booth_area":"展台面积","booth_sponsor_fee":"展台赞助费","if_contains_video_play":"是否录像播放","video_play_no":"视频数量","video_duration":"录像时长","video_sponsor_fee":"录像赞助费","other_sponsor_fee":"其他赞助费金额","other_sponsor_fee_explaination":"其他赞助费说明","hco_budget":"产品赞助费预算","if_nominate_non_target_hcp":"是否提名非目标HCP","noof_paid_speaker":"有偿讲者人数","yes":"是","no":"否","quarter_plan_budget":"审批通过的季度预算","others_miscellaneous":"其他费用","click_here_to_access_to_Content_Lab":"点击此处进入Content Lab","m":"平方米","eeib_status":"EEIB状态","if_eeib":"是否EEIB","meeting_type":"会议类型","team":"Team","disease_area":"Disease area","above_ta":"Above TA","level_of_paid_EE":"Please select level of paid EE","no_of_paid_EE_of_this_level":"No. of paid EE of this level","service_fee_budget_of_paid_EE_of_this_level":"Service fee budget of paid EE of this level","EE_service_fee_budget":"EE service fee budget","Number_of_unpaid_EE":"Number of unpaid EE","is_required":" 是必填项","te_budget":"T&E budget","total_budget_without_te_budget":"Total budget (Without T&E budget)","assessment":"评价","agenda_symposium":"卫星会议程","valid":"有效待确认","expired":"已过期","invalid":"无效","if_only_provide_meal_city_transportation":"是否只提供餐食或小交通","confirmed":"已确认","approved":"审批通过","no_required":"无需判断","block":"锁定","not_required":"无需判断","file_need_to_sign":"待签署文件","adobeSign_status":"文件签署状态","attachments":"附件","Signed":"已签署","Canceled":"已拒签","Sended":"已发送","other_supporting_ducuments":"其他支持性材料（若有）"},"button":{"add":"添加","submit":"提交","cancel":"取消","confirm":"确认","close":"关闭","approve":"同意","reject":"拒绝","edit":"修改","delete":"删除","view":"查看","back":"返回","search":"搜索","all":"全部","Delete":"删除","upload":"Upload","add_to_confirmed_attendee":"Confirm selected final attendees are not EEIB","submit_as_final_attendee":"Submit as final attendee","update_coi":"更新COI","add_paid_speaker":"添加付费讲者","add_unpaid_speaker":"添加不付费讲者","cancel_meeting":"取消会议","Confirm_EEIB_status_and_attendance_of_selected_attendee":"Confirm EEIB status and attendance of selected attendee(s)","confirm_EEIB":"确认EEIB","confirm_change":"确认变更","cancel_change":"取消变更"},"placeholder":{"meeting_name":"请输入会议名称","bu":"请选择业务部门","ta":"请选择治疗领域","product":"请选择产品名称","business_rationale":"请选择业务目的","business_rational_short_description":"请输入业务目的简述(选填)","rm_territory_code":"Please fill in RM territory code","province":"请选择省份/直辖市","province_input":"请输入省份/直辖市","city":"请选择城市","city_input":"请输入城市","start_date":"请选择开始日期","end_date":"请选择结束日期","meeting_duration":"请输入会议时长","number":"请输入人数","budget":"请输入预算（CNY）","booth_material":"请为展台材料选择Content lab编码","video_play_material":"请为视频材料选择Content lab编码","category":"请选择类别","veeva_id":"请输入Veeva ID/ABAC ID","name":"请输入姓名","workplace":"请输入医院","department":"请选择科室","department_input":"请输入科室","title":"请选择职称","title_input":"请输入行政职务","possibility":"请选择参会可能性","attendee_name":"请输入参会者姓名","hospital":"请输入医院","please_select":"请选择","location":"请输入会议地址","product_meeting_budget":"请输入产品对应会议预算","nominate_speaker_search":"请输入Veeva ID/ABAC ID","hospital_code_name":"请输入姓名或ID","hospital_code&name":"请输入医院编码&名称","hospital_level":"请选择医院等级","meeting_date":"请选择会议日期","start_time":"请选择开始时间","end_time":"请选择结束时间","satellite_sponsor_fee":"请输入卫星会赞助费","booth_area":"请输入展台面积","booth_sponsor_fee":"请输入展台赞助费","video_duration":"请输入录像时长","video_sponsor_fee":"请输入录像赞助费","other_sponsor_fee":"请输入其他赞助费金额","other_sponsor_fee_explaination":"请输入其他赞助费说明","change_reason":"请输入变更理由","cancel_reason":"请输入取消理由","change_reason_sp":"请输入变更理由","cancel_reason_sp":"请输入取消理由","optional":"（选填）","hco_name":"请选择HCO名称","hco_budget":"请输入产品赞助费预算","non_target_hcp_reason":"请输入邀请非目标HCP理由","rationale_of_exceeding_budget_in_quarterly_plan":"请输入预算超出季度计划的理由","if_GO":"Please select GO","academic_title":"请输入行政职务","if_COI_with_red_flag":"请选择COI red flag ","coi_status":"请选择COI/GO状态","attendence":"请选择是否出席","eeib_status":"请选择EEIB状态","if_eeib":"请选择是否EEIB","level_of_paid_EE":"Please select level of paid EE","not_same_city_reason":"请说明需要提名非会议主办城市讲者的原因。"},"tip":{"date_range_warming":"会议开始日期必须早于会议结束日期","number_warming":"各城市分布的参会人数总和与讲者和参会者人数总和不一致","city_allocation_empty_warming":"请输入城市或讲者和参会者的人数","booth_material_required":"展台材料是必填项","breakdown_budget_warming":"分拆的预算加总与活动费用预算不相等","meeting_budget_is_over_10%_warming":"会议预算超过季度计划中审批通过的预算的10%","meeting_budget_is_over_30%_warming":"会议预算超过季度计划中审批通过的预算的30%。会议审批需要遵循ad hoc审批流程（同季度会审批流）。","meeting_budget_is_over_30%_warming_md":"会议预算超过季度计划中审批通过的预算的30%","meeting_budget_is_over_30%_warming_2":"会议预算超过季度计划中审批通过的预算的30%。","meeting_budget_exceeds_10%_of_the_approved_budget":"会议预算超过会议申请中审批通过的预算的10%》。 ","meeting_agenda_warming":"请上传会议议程","engagement_request_submit_warming":" 审批通过的季度预算+该会议预算超过季度计划中的10%","meeting_name_required":"会议名称是必填项","bu_required":"业务部门是必填项","ta_required":"治疗领域是必填项","product_required":"产品名称是必填项","hco_required":"HCO是必填项","hco_error_for_approval":"学会状态为审批中","hco_error_for_reject":"学会状态为已拒绝","hco_error_for_expired":"学会状态为已过期","hco_error_for_delete":"学会已被删除","business_rationale_required":"业务目的是必填项","business_rationale_short_description_required":"业务目的简述是必填项","meetingCategroy_required":"会议类别是必填项","meetingMethod_required":"会议形式是必填项","com_meeting_type_required":"meeting type is required","province_required":"省/直辖市是必填项","city_required":"城市是必填项","location_required":"会议地址是必填项","startDate_required":"开始日期是必填项","endDate_required":"结束日期是必填项","startTime_required":"start time is required","endTime_required":"end time is required","meetingDuration_required":"会议时长是必填项","sponsorshipPackageFlag_required":"是否package赞助是必填项","rmCode_required":"RM territory code is required","rationale_of_exceeding_of_budget":"请填写超过季度计划预算的原因","rationale_of_exceeding_budget":"请填写超出预算原因","rationale_of_exceeding_30%_of_budget":"请填写超过季度计划预算30%的原因","rationale_of_exceeding_30%_of_budget2":"会议预算超过季度计划中审批通过的预算的30%。会议审批触发ad hoc审批流程（同季度会审批流）。","add_paid_speaker_tip1":"您提名的讲者人数超过审批通过的会议申请中讲者人数的2倍。提名讲者 vs 计划讲者","add_paid_speaker_tip2":"付费演讲者的使用已经达到了每年允许的上限。","add_paid_speaker_tip2_ee":"The use of this paid EE has reached the allowed annual limit.","add_paid_speaker_tip3":"请关注剩余上限小于9000元人民币的讲者","add_unpaid_speaker_tip1":"您不能提名未完成培训的讲者","add_unpaid_speaker_tip2":"您不能提名COI/GO资质未确认有效的讲者。","add_unpaid_speaker_tip3":"如果您提名了一位非目标讲者，您必须提供理由给审批者。","add_unpaid_speaker_tip4":"您无法提名状态不合规的讲者。","confirm_to_upload_file":"是否确认上传文件？","please_choose_a_file":"请选择一份文件","TEbudget_required":"员工费用预算是必填项","brand_budget_warming":"各品牌预算加总必须等于会议总预算","hco_budget_warming":"HCO总预算必须等于赞助会预算","paid_speaker_tov_n/a_warming":"您提名的讲者需要特殊ToV，请联系PMO团队","confirm_to_change":" 是否确认修改？","this_change_will_cause_the_previous_speaker_information_become_invalid":"此次变更会引起讲者信息失效","speaker_vs_attendee_ratio":"讲者和参会者的比例是 ","ee_vs_attendee_ratio":"EE和参会者的比例是  ","hcp_vs_gsk_staff_ratio":"GSK员工和参会者的比例是","nominate_speaker_presentation_duration_empty":"请填写所有讲者的演讲时长","you_haven_not_nominated_any_speakers_yet":"您未提名任何讲者","you_haven_not_selected_any_attendee_yet":"您还没有选择参会者","submit_attendee_veeva_ileagle":"与Veeva不匹配的参会者不允许被提名","start_date_not_in_the_current_quarter":"开始日期必须在当前季度范围内","select_file":"请选择一个文件上传","meeting_agenda_uploaded_error_popup_subTitle":"您上传的会议议程格式有误，请检查后重新上传","content_lab_code_can_not_be_found":"未查询到Content lab code","content_lab_code_has_not_been_approved":"Content lab code 没有审批通过","please_correct_the_error":"请修改错误的部分","not_updated_the_meeting_agenda":"您还没有更新会议议程","meetingDate_required":"会议日期是必填项","start_time_is_required":"开始时间是必填项","end_time_is_required":"结束时间是必填项","timeDuration_required":"会议时长是必填项","budgetSatelliteAmt_required":"卫星会预算为必填","area_required":"展台大小为必填","amt_required":"展台预算为必填","videoDuration_required":"视频时长为必填","videoSponsorFee_required":"视频预算为必填","startDate_greater_than_endDate":"开始日期必须早于结束日期","endDate_less_than_startDate":"结束日期必须晚于开始日期","please_fill_in_engagement_request":"请填写会议申请","please_upload_meeting_agenda":"请上传会议议程","please_nominate_speaker":"请提名讲者","please_select_attendee":"请选择参会者","upload_attendee_failed":"Excel文件上传或读取失败，请使用模板重新上传","tov_greater_than_remainning_cap":"ToV金额不能超过剩余上限","you_can_only_select_either_paid_speaker_or_unpaid_speaker_for_each_meeting":"每场会议只能选择有偿讲者或无偿讲者中的一种","event_budget_is_total_budget_except_speaker_fee_budget_and_TE_budget":"活动费用预算是除讲者费用预算和员工费用预算外其他预算金额的汇总","change_budget_warming_tips_1":"会议预算超过会议申请中审批通过的预算的30%。会议审批触发ad hoc审批流程（同季度会审批流）。 ","change_budget_warming_tips_2":"会议预算超过季度计划中审批通过的预算的30%。会议审批需要遵循ad hoc审批流程（同季度会审批流）。 ","change_budget_warming_tips_3":"会议预算超过会议申请中审批通过的预算的10%","renominate_speaker_since_product_has_been_changed":"由于产品变更，提名的讲者已失效。请重新提名。","hospital_code_name":"医院编码&名称为必填字段","hospital_level":"医院等级为必填字段","international_ee":"国际级","national_ee":"国家级","regional_ee":"区域级","paid_speaker_fmv":"有偿讲者FMV（不含税）","event_budget_tips":"活动费用预算是除讲者费用预算和员工费用预算外其他预算金额的汇总","sponsorship_fee_budget":"赞助费预算为会议总预算扣除讲者费用预算、活动费用预算、员工费用预算。","please_fill_in_number_of_attendee":"请填写参会者人数","only_nominate_paid_speaker":"该会议只能提名付费讲者。若要提名无偿讲者，需先前往会议申请页面更改付费讲者数量、无偿讲者数量。","only_nominate_unpaid_speaker":"该会议只能提名无偿讲者。若要名付费讲者，需先前往会议申请页面更改付费讲者数量、无偿讲者数量。","can_not_nominate_speaker":"该会议无法提名讲者，请先前往会议申请页面更改付费讲者数量、无偿讲者数量。","input_meeting_information":"请点击添加，填写会议详细信息","change_to_single_meeting":"如需变更为单场会，请将分会数量减少至一场","you_cannot_city_hco_error":"您无法赞助市级学会举办系列会","please_select_bu_ta_product_first":"请先选择该会议的BU/TA/Product信息","can_not_delete_all_meeting_detail_information":"请至少保留一场会议详细信息","information_is_not_aligned":"BU/TA/Product信息与分会的相关信息不符，请更新:","please_delete_the_speakers":"请删除与会议product信息不匹配的讲者","change_paid_speaker_to_0":"变更付费讲者数量为0，该会议历史提名的付费讲者名单将清除","change_unpaid_speaker_to_0":"变更无偿讲者数量为0，该会议历史提名的无偿讲者名单将清除","speaker_fee_budget_can_not_smaller_than_total_uploaded_speaker_contract_value":"讲者费用预算不可低于已上传的讲者盖章合同的总金额","event_budget_can_not_smaller_than_total_confirmed_quotation_value":"活动费用预算不可低于已确认的报价单总金额","no_result":"查询无结果","non_target_hcp_reason_required":"提名非目标HCP的理由为必填","satellite_symposium_date_is_not_within_meeting_start_date_end_date":"卫星会日期不在会议起始日期范围内","start_time_greater_than_end_time":"开始日期必须早于结束日期","end_time_less_than_start_time":"结束日期必须晚于开始日期","number_of_attendees_must_be_more_than_0":"参会者人数必须大于0","number_of_GSK_staff_must_be_more_than_0":"GSK员工人数必须大于0","please_fill_in_number_of_GSK_staff":"请输入GSK员工人数","paid_speaker_unpaid_speaker_cannat_be_zero_at_the_same_time":"付费讲者和无偿讲者不能同时为 0","if_Attendee_is_EEIB_please_submit_EEIB_approval_email_to_COE":"If Attendee is EEIB, please submit EEIB approval email to COE.","speaker_fee_budget_is_less_than_the_allowed_threshold":"讲者费用预算低于设定下限","speaker_fee_budget_exceeds_the_allowed_threshold":"讲者费用预算超过设定上限","confirm_eeib_status":"Confirm EEIB status","not_nominate_ee_tips":"You didn't nominate any EE, confirm to submit?","The_range_of_meeting_dates_is_less_than_the_meeting_duration":"The range of meeting dates is less than the meeting duration","you_have_nominate_more_than_2_times_of_the_ee_approved_in_engagement_request_Nominated_ee_vs_planned_ee":"You have nominate more than 2 times of the EE approved in engagement request. Nominated EE vs Planned\n          EE","nominate_more_than_2_times_paid":"You have nominated more than 2 times of the paid EE approved in engagement request. Nominated paid EE vs Planned paid EE","nominate_more_than_2_times_unpaid":"You have nominated more than 2 times of the unpaid EE approved in engagement request. Nominated unpaid EE vs Planned unpaid EE","you_can_t_nominate_ee_whose_tov_exceeds_remaining_cap":"You can’t nominate EE whose TOV exceeds remaining cap.","you_can_t_nominate_ee_whose_daily_cap_exceeds_upper_limit":"You can’t nominate EE whose daily cap exceeds upper limit.","assessment_tips":"Scientific Workshop需要同时上传书面记录的所有参会者（包括讲者）的参会理由（needs或interests），请在一个文档中清晰列明。","assessment_tips_md":"Scientific Workshop需要同时上传书面记录的所有参会者（包括讲者）的参会理由（needs或interests），请在一个文档中清晰列明。","only_meal_city_transportation_provided":"【Only meal/city transportation provided】 is required","No_of_paid_speaker_cannot_increase":"有偿讲者人数不能增加","speaker_tov_14days_change":"ToV在会议开始前14天内不能变更。演讲时长的修改导致ToV变化，请检查后重新提交","Satellite_symposium_duration_less30":"卫星会时长不足30分钟，无法申请HCPE会议","nomination_tip":"提名审批通过后，对于非EEIB讲者，到最终盖章版合同完成大概需要7天左右时间； 对于EEIB讲者则大概需要14天时间。COE将根据实际情况进行操作。","times_remaining_cap":"付费演讲者的使用已经达到了每年允许的上限。","times_remaining_cap_ee":"The use of this paid EE has reached the allowed annual limit.","adobe_sign_tips":"如您已经上传了签署完成的文件，则无需进行文件选择。<br />如您未上传已签署完成的文件，请选择单个文件后进行文件签署。","adobe_sign_confirm_tip":"您还有待签署文件未签署。请先前往会议申请页面进行文件签署后再进行会议申请的提交。","adobe_sign_confirm_approve_tip":"您还有待签署文件未签署。您可以前往会议申请页面进行文件签署后再进行审批。","adobe_sign_non_confirm_tip":"请确认您已上传了CMD签署的最终版文件。\n若未上传，请前往会议申请页面进行文件的选择并签署后再进行会议提交。","adobe_sign_reject_tip":"您已经拒绝签署文件。请拒绝当前会议申请并填写拒绝理由。","adobe_confirm_to_approve":"确认通过当前会议审批？","delete_attendee_eeib_tips":"删除后，已填写的参会者后勤信息也将被删除；如需重新邀请该参会者，参会者需重新扫码接受会议邀请。","qr_code_ttt_tip":"仅付费讲者池中的HCP可以扫码。","meeting_type_tips":"会议审批通过后，会议类型不可变更。","sponsorship_letter_tips":"请确保您所填写的赞助信息与招商函一致。","meeting_agenda_tips":"请确保您所填写的赞助信息与大会议程一致。","sponsorship_item_tips":"请确保您所填写的赞助信息与招商函/大会议程一致。","over_45_min":"卫星会时长超过45分钟。","speaker_cannt_find_title":"讲者由于以下原因无法被查询到：","speaker_cannt_find_1":"1. HCP的产品不是会议的目标产品。","speaker_cannt_find_2":"2. HCP不是有效的付费讲者。","speaker_cannt_find_title_ee":"EE由于以下原因无法被查询到：","speaker_cannt_find_1_ee":"1. HCP的产品不是会议的目标产品。","speaker_cannt_find_2_ee":"1. HCP不是有效的paid EE。","speaker_cannt_find_3_ee":"1. HCP不是有效的unpaid EE。","speaker_ta_change_tip":"变更讲者TA标签会导致讲者材料，合同及材料培训失效。","delete_paid_speaker_tip":"确认删除后，该讲者现有合同将作失效处理。如删除后您又重新提名该讲者，会触发相应审批。若确认删除，请点击【确认】按钮","delete_unpaid_speaker_tip":"确认删除后，该讲者现有合同将作失效处理。若确认删除，请点击【确认】按钮"},"table":{"sn":"S/N","category":"类型","veevaId":"VEEVA ID /ABAC ID","name":"姓名","hospital":"医院","level":"讲者级别","possibility":"参会可能性","cl_code_by_ta":"CL code By TA","presentation_material":"Presentation Material","presentation_duration":"演讲时长","total_service_duration":"总服务时长","tov":"提名ToV","annual_times_for_paid":"年度付费次数","remaining_cap":"剩余上限","logistic_info":"后勤信息","action":"操作","hcp_type":"HCP类型","department":"科室","title":"行政职务","training_finished":"培训已完成","coi_expiry_date":"COI有效截止日期","if_coi_red_flag":"COI red flag","if_red_flag_approved":"If red flag approved","content_lab_code":"Content Lab编号","material_name":"材料名称","description":"描述","expiry_date":"有效期","type":"类型","annual_service_fee":"年度累计讲课费","workplace":"医院","province":"省份","city":"城市","attendee_name":"参会者姓名","if_COI_with_red_flag":"COI red flag","if_GO":"是否是政府官员","disclosure_consent":"是否愿意被披露","logistic_received":"Logistic Received","RSVP":"参会确认回复","coi_status":"COI/GO状态","go_status":"GO状态","training_expire_date":"培训结束日期","training_status":"培训状态","speaker_status":"讲者状态","tax_excluded":"(不含税)","high":"高","middle":"中","low":"低","meeting_budget":"会议预算","attendance":"是否出席","paid_unpaid":"Paid / Unpaid","paid_unpaid_z":"付费 / 免费讲者","tov_tax_exclude":"ToV（不含税）","annual_service_fee_tax_exclude":"年度累计讲课费(不含税)","tov_sp":"ToV","hcpe_no_hcpe":"HCPE/ Non HCPE","hcpe":"HCPE","no_hcpe":"Non HCPE","academic_title":"行政职务","coe":"COE","mudid":"MUDID","role":"角色","logistic":"Logistic","follow_up_duration":"Follow up duration","preparation_duration":"Preparation duration","only_meal_city_transportation_provided":"不提供住宿和大交通","if_chairman_of_the_conference":"是否为大会主席","acamedic_title":"行政职务","eeib_status":"EEIB状态","international":"国际级","national":"国家级","regional":"区域级","is_disclosure":"是否同意隐私披露","before_meeting_materials_completed":"会前讲者材料齐全","presentation_materials":"讲者演讲材料","speaker_agreement":"讲者合同"},"change":{"confirm_to_update_meeting_name":"Confirm to update meeting name?","confirm_to_update_start_date_or_end_date":"Confirm to update Start date or End date?","confirm_to_increase_the_number_of_speaker":"Confirm to increase the number of speaker?","confirm_to_decrease_the_number_of_speaker":"Confirm to decrease the number of speaker?","confirm_to_decrease_the_number_of_attendee":"Confirm to decrease the number of attendee?","confirm_to_update_the_number_of_attendee":"Confirm to update the number of attendee?","confirm_to_update_the_total_budget":"Confirm to update the total budget?","confirm_to_update_the_brand_budget":"Confirm to update the brand budget?","confirm_to_update_the_speaker_duration_or_TOV":"Confirm to update the speaker duration or TOV?","confirm_to_update_the_speaker_nomination_list":"Confirm to update the speaker nomination list?","confirm_to_update_the_tentative_attendee_list":"Confirm to update the tentative attendee list?","confirm_to_change":"是否确认变更？","this_change_may_affect_speaker_contract_or_event_arrangement":"This change may affect Speaker contract or Event Arrangement.","this_change_will_make_event_arrangement_pause":"This change will make Event Arrangement pause.","this_change_will_make_speaker_contract_and_envent_arrangement_pause":"This change will make Speaker contract and Event Arrangement pause.","this_change_will_make_engagement_request_re-approve":"This change will make Engagement Request re-approve.","the_number_of_speaker_cannot_less_than_approved_contract_volume":"讲者人数不能少于合同已被审批通过的讲者人数，请先取消讲者出席","this_change_will_make_speaker_contract_and_event_arrangement_pause":"This change will make Speaker contract and Event Arrangement pause.","the_number_of_attendee_cannont_less_than_confirmed_final_attendee":"参会者人数不能少于最终确认的参会者名单人数","total_budget_is_changed_over_10%":"Total budget is changed over 10%, Engagement will re-approve.","total_budget_is_changed_over_30%":"Total budget is changed over 30%, Engagement will re-approve.","total_budget_cannot_less_than_approved_value_with_contract_and_quotation":"会议总预算的110%不能少于已确认参会讲者ToV和已提交的报价单金额汇总","band_budget_exceed_brand_quarterly_plan_budget_over_10%_above":"Brand budget exceed Brand quarterly plan budget over 10% above, Engagement will re-approve and follow ad hoc approval process.","nominate_speaker_will_be_re-approval":"Nominate Speaker will be re-approval.","this_change_will_make_speaker_contract_pause":"This change will make Speaker contract pause.","you_can_not_delete_the_speaker_who_has_signed_the_contract":"You can not delete the speaker who has signed the contract.","tentative_attendee_list_will_be_re-approval":"Tentative attendee list will be re-approval.","this_change_will_cause_reapproval_of_this_engagement":"此次变更会导致会议重新审批。","this_change_will_cause_fmv":"此次变更可能会导致FMV重新校验，请在会议申请审批通过后检查FMV审批结果。若单价超出FMV标准，您需重新提交FMV审批。若未超标准，则无需其他操作。","this_change_will_cause_2":"此次变更会导致会议重新审批，并遵循ad hoc审批流程（同季度会审批流）"},"common":{"show":"显示","hide":"隐藏","assign_record":"分配记录","assigned":"已分配"}},"engagementExecution":{"invalid":"Invalid","in_progress":"In progress","draft":"Draft","confirmed":"Confirmed","valid":"Valid","assign_executor":"分配执行者","onsite_executor":"Onsite executor","upload_documents_for_payment_request_optional":"上传付费支持性文件（可选）","the_system_has_recorded_the_following_documents_for_speaker_payment":"系统已记录以下讲者付款的文件","the_system_has_recorded_the_following_documents_for_ee_payment":"系统已记录以下讲者付款的文件.","tax_application_form":"个税申请表","tax_application":"个税申请","id_number":"证件号码","contact_information":"联系电话","vendor_code":"供应商编号","bank_account_number":"银行卡号","bank_name":"银行名称","contract_amount_tax_included":"合同金额（含税）","sign_in":"Sign-in","offline_registered":"线下签到","e_registered":"线上签到","not_sign_in":"未签到","registration_form":"签到表","notConfirmedAttendee_tip":"EO提交的未邀请参会人数与EM确认的人数不符。","notConfirmedAttendee_tip_md":"BO提交的未邀请参会人数与EM确认的人数不符。","attendees_who_do_not_have_a_valid_veeva_id_cannot_be_submitted":"没有正确的VEEVA ID的参会者不能提交。","in_direct_tov":"拆分TOV","add_others":"添加其他","invited":"受邀","uninvited":"临参","final_registration_form":"最终签到表","no_show":"未参会","province":"省份","city":"城市","status":"状态","supporting_documents":"支持文件","action":"操作","category":"类别","name":"名称","title":"头衔","hospital":"医院","Hospital":"医院","department":"部门","Department":"部门","title2":"行政职务","veeva_id_abac_id":"Veeva ID / ABAC ID","veeva_id":"Veeva ID","Please identify at least one speaker for HCP issue":"请为HCP事项选择至少1位讲者","Please fill in the description in Others(required)":"请为其他类（如需）填写描述","Please select at least one issue":"请选择至少1个事项","Others":"其他","Issue category":"事项类别","Overall result of spot check":"飞检报告概览","Please select issues":"请选择事项","Speaker speech duration":"讲者演讲时长","speaker_payment":"讲者演讲时长","speaker_checklist":"Speaker checklist","record_speech_duration":"记录演讲时长","speaker_payment_request":"讲者付费申请","ee_payment_request":"讲者付费申请","speaker_attendee":"讲者/参会者","ee_attendee":"讲者/参会者","ee":"讲者","attendee":"参会者","speaker":"讲者","Speaker name":"讲者姓名","Academic title":"学术职称","academic_title":"行政职务","Contract presentation duration":"合同演讲时长","Contract payment amount":"合同付费金额","Actual speech duration":"实际演讲时长","Actual service payment amount":"年度累计讲课费金额","speaker_presentation_payment_duration":"讲者付费演讲时长","Speaker actual payment amount":"讲者实际付费金额","special_approval":"特殊审批","Does speaker have off-label":"讲者是否有超适应症","Submit":"提交","Save":"保存","Upload":"上传","Export":"导出","Update":"更新","Onsite Photo":"现场照片","Taking Time":"拍摄时间","Labels":"标签","Confirm":"确认","No label":"无标签","With label":"有标签","minor_change":"小修改","major_change":"大修改","Close":"关闭","settlement_detail":"结算单详情","settlement":"结算单","vendor_name":"供应商名称","Total settlement amount (pre-tax)":"结算单总金额（含税）","attachment":"附件","request_type":"需求类型","request_type_others":"需求类型-其他","Settlement amount":"结算单金额","Settlement amount (pre-tax)":"结算单总金额（含税）","settlement_amount_tax_included":"结算单金额（含税）","settlement_amount_tax_excluded":"结算单金额（不含税）","number_of_people":"人数","Approval process":"审批流程","Confirm to submit?":"确认提交?","Detail":"详情","Meeting Information":"会议信息","Meeting date":"会议日期","Meeting category":"会议类别","Meeting method":"会议形式","BU":"BU","TA":"TA","Product":"产品","Province":"省份","City":"城市","Location":"地点","Please upload Attachment":"请上传附件","OK":"OK","Confirm to update?":"确认更新?","sn":"S/N","settlement_category":"结算单类别","Sign-in":"签到","sign_in_status":"签到状态","sign_in_time":"签到时间","PO number":"PO号码","Action":"操作","Off-label":"超适应症","MUDID":"MUDID","Role":"角色","Settlement list":"结算单列表","settlement_list":"结算单列表","Speaker list":"讲者列表","export_template":"导出模板","export_data_file":"导出数据文件","If actual speech duration is less than speaker presentation payment duration, please fill in reasons":"如果实际演讲时长小于讲者付费演讲时长，请填写理由","If actual speech duration is less than 30% contract presentation duration, please fill in reasons":"如果实际演讲时长小于30%的合同付费演讲时长，请填写理由","Please fill in reasons":"请填写理由","Please upload special approval":"请上传特殊审批","Meeting information":"会议信息","Meeting name":"会议名称","Meeting duration":"会议时长","Reasons for speaker presentation duration less than speaker presentation payment duration":"演讲时长小于讲者付费演讲时长的理由","Speaker payment amount":"讲者付费金额","Contract amount":"合同金额","PO amount (Tax excluded)":"PO金额（不含税）","po_amount_tax_included":"PO金额（含税）","po_amount_tax_excluded":"PO金额（不含税）","Annual service fee (Tax excluded)":"年度累计讲课费（不含税）","Please fill in speaker presentation payment duration":"请输入讲者付费演讲时长","Speaker duration":"讲者演讲时长","sign_in_category":"签到类别","Reasons for special approval":"特殊审批理由","Onsite photos":"现场照片","Please upload":"请上传","Failed to submit.":"提交失败","Failed":"失败.","Assign":"分配","Assign record":"分配记录","Assigned":"已分配","Expired":"已过期","system_automatically_assigned_to":"系统自动分配至","eo_assigned_to":"EO assigned to ","assigned_to":"分配至","Assigned successfully":"分配成功","Webiner screenshot":"网络会屏幕截图","Screenshot":"屏幕截图","Details":"详情","Attendee report":"参会者报告","Registration HCP":"Registration HCP","Add":"添加","offline_registration_form":"线下签到表","QR code":"二维码","photos":"现场照片","Photos":"现场照片","Registration form":"签到表","Meeting type":"会议类型","ee_payment":"EE payment","ee_checklist":"EE checklist","T&E":"员工花费","t&e":"员工花费","Vendor payment":"供应商花费","vendor_payment":"供应商花费","Search":"搜索","Please choose speaker":"请选择讲者","You did not take any onsite photos, please seek for special approval":"您还未进行现场拍照，请获取特殊审批","Please choose photo":"请选择照片","spot_check_report":"飞检报告","spot_check":"飞检报告","ttt":"TTT","final_attendance":"最终参会名单","please_select_speaker_attendee":"请选择讲者或参会者","please_fill_in_veeva_id":"请输入 Veeva ID","please_fill_in_name":"请输入姓名","if_contain_content_training":"是否包含演讲内容培训","if_contain_gsk_requirement_training":"是否包含GSK规章制度培训","if_contain_scientific_training":"是否包含科学内容培训","presentation_materials_list":"讲者演讲材料清单（实际使用）","type":"类型","owner":"负责人","content_lab_code":"Content lab 编号","material_name":"材料名称","material_expiry_date":"材料过期日期","edit":"编辑","training_start_date":"培训生效开始日期","training_expiry_date":"培训有效截止日期","speaker_communication_form":"讲者沟通函","i_confirm_that_gsk_training":"I confirm that the GSK requirement training for this HCP has been completed","i_confirm_that_scientific_training":"I confirm that the scientific training for this HCP has been completed","please_select_type":"请选择类型","please_fill_in_owner":"请输入负责人","please_enter_content_lab":"请输入Content lab code/材料名称","description":"描述","export_date":"过期日期","ttt_tips":"只有Veeva ID及姓名有效的讲者可以刷新CL code及相关培训。","content_lab_code_planned":"Content lab 编号（会前计划）","content_lab_code_actually":"Content lab 编号（实际使用）","please_select_at_least_cl_code":"Please select at least one CL code.","confirm_ttt_tips":"是否给最终参会者更新培训记录（仅可确认一次） <br /> 1. 请确认最终参会名单是否准确 <br /> 2. 请确认CL code是否准确 <br /> 3. 请确认培训记录是否准确","confirm_process":"确认记录","Speaker presentation duration - Spot check":"讲者演讲时长-飞检报告","Speaker budget":"讲者预算","Speaker PO amount":"讲者PO金额","Event budget":"活动费用预算","Event PO amount":"活动PO金额","Contract payment amount (Tax included)":"合同付费金额(含税)","Actual service payment amount (Tax included)":"实际付费金额（含税）","Reasons for actual speech duration less than 70% of contract presentation duration":"实际演讲时长小于70%的合同付费演讲时长的理由","Reasons for actual speech duration less than 30mins":"实际演讲时长小于30分钟的理由","Speaker actual payment amount (Tax excluded)":"讲者实际付费金额（不含税）","Remaining cap (Tax excluded)":"剩余费用（不含税）","Content lab code":"Content lab code","Content lab code (If changed)":"Content lab code(如有变更)","The speaker deck has been copy-approved by GSK and within expiration date":"讲者演讲材料为GSK审批通过的版本且在有效期内(若讲者未使用讲者演讲材料，请选择不适用)","The speaker deck has any changes compared with GSK Content Lab approved version":"讲者演讲材料相较于GSK Content lab中审批通过的版本有变更","Actual speaker deck":"实际讲者演讲材料","reasons":"原因","Reasons for actual speech duration less than contract presentation duration":"实际演讲时长少于合同演讲时长的理由","If off-label":"是否超适应症","Supporting documents":"支持文件","rationale":"目的","If speaker presentation payment duration < 70% * Contarct presentation, please fill in reasons, and escalate to trio":"如果讲者付费演讲时长<70%的合同演讲时长，请填写理由，并抄送至Trio","If speaker presentation payment duration >= 70% * Contract presentation, please fill in reasons and CEOE Head will confirm the duration":"如果讲者付费演讲时长>=70%的合同演讲时长，请填写理由，并由CEOE Head确认时长","If speaker presentation payment duration >= 70% * 30min or <=100%*30min, please fill in reasons and CEOE Head will confirm the duration":"如果讲者付费演讲时长>=70%*30分钟或<=100%*30分钟，请填写理由，并由CEOE Head确认时长","Trio email approval":"Trio邮件审批","te_amount":"员工花费金额","number_of_gsk_staff":"GSK员工人数","te_accommodation_tax_included":"员工花费-住宿(含税)","te_accommodation_tax_excluded":"员工花费-住宿(不含税)","te_air_travel_tax_included":"员工花费-飞机(含税)","te_air_travel_tax_excluded":"员工花费-飞机(不含税)","te_ground_transportation_tax_included":"员工花费-地面交通(含税)","te_ground_transportation_tax_excluded":"员工花费-地面交通(不含税)","te_train_tax_included":"员工花费-火车(含税)","te_train_tax_excluded":"员工花费-火车(不含税)","te_meals_tax_included":"员工花费-餐饮(含税)","te_meals_tax_excluded":"员工花费-餐饮(不含税)","T&E - accommodation (tax-included)":"员工花费-住宿(含税)","T&E - accommodation (tax-excluded)":"员工花费-住宿(不含税)","T&E - air travel (tax-included)":"员工花费-飞机(含税)","T&E - air travel (tax-excluded)":"员工花费-飞机(不含税)","T&E - ground transportation (tax-included)":"员工花费-地面交通(含税)","T&E - ground transportation (tax-excluded)":"员工花费-地面交通(不含税)","T&E - train (tax-included)":"员工花费-火车(含税)","T&E - train (tax-excluded)":"员工花费-火车(不含税)","T&E - meals (tax-included)":"员工花费-餐饮(含税)","T&E - meals (tax-excluded)":"员工花费-餐饮(不含税)","T&E amount (tax-included)":"员工花费(含税)","T&E amount (tax-excluded)":"员工花费(不含税)","Total settlement amount (tax-excluded)":"结算单总金额(不含税)","Total settlement amount (tax-included)":"结算单总金额(含税)","total_settlement_amount_tax_included":"结算单总金额(含税)","total_settlement_amount_tax_excluded":"结算单总金额(不含税)","Onsite QR code":"现场二维码","Settlement amount is 10% over quotation amount in event arrangement":"结算单金额超过会议安排中报价单金额的10%","settlement_amount_is_10_over_quotation_amount_in_event_arrangement":"结算单金额超过会议安排中报价单金额的10%","GPS":"GPS","Participants":"参会者","Upload error":"上传错误.","Upload successfully":"上传成功.","You have submitted a special approval process":"您已经提交特殊照片审批流程","Submit error":"提交错误","The distance between the meeting address and the EO sign-in address is":"会议地址与EO签到地址的距离为","The Speaker has made":"讲者对过去12个月可能从GSK收到的任何旅行或其他费用作了适当和清晰的陈述(口头或包括在会议演示中使用的幻灯片中)","Please fill in comments":"请输入时长","please_upload_offline_registration_form":"请上传离线签到表","no_of_people_not_in_the_confirmed_attendee_list":"人数（没有在确认的参会者名单中）","number_of_uninvited_attenndees":"临时参会者人数","Failed in meeting query":"获取会议信息失败","Meeting code":"会议编号","Meeting location":"会议地点","Meeting budget":"会议预算","Approval from Compliance BP":"CBP的审批","Approval from MKT brand owner":"MKT brand owner的审批","Reason 1&7, need to get approval form MKT brand owner, If still be rejected then escalate to compliance BP":"理由1&7，需要获取MKT brand owner的审批。如果依旧被拒绝，需要获取Compliance BP的审批","Online screenshot":"线上截屏&线上后台报告","(Reason 1&7, need to get approval from MKT brand owner, If still be rejected then escalate to compliance BP)":"(理由1&7，需要获取MKT brand owner的审批。如果依旧被拒绝，需要获取Compliance BP的审批)","Onsite executor":"现场执行者","Assign successfully":"分配成功!","total_settlement_amount_is_not_equal_to_breakdown_settlement_amount":"结算单总金额不等于结算单拆分金额总和","breakdown_tov_amount_exceeds_detail_sttlement_amount":"拆分TOV金额超过了结算单细项金额","attendee_information_is_incomplete_please_add_either_veeva_id_and_name_or_name_hospital_and_department":"参会者信息不完整。请填写“Veeva ID和姓名”或“姓名、医院和部门”","any_changes_on_meeting_slides_without_gsk_approval":"未经GSK批准对会议幻灯片进行任何更改(若讲者未使用讲者演讲材料，请选择不适用)","Communicated with speaker":"已与讲者沟通","onsite_checklist_and_speech_duration":"Onsite checklist and speech duration","payment_request":"讲者付费流程","attended":"是否参会","paid_unpaid":"付费 / 非付费","reasons_for_unpaid":"非付费原因","speaker_chairman":"讲者主席","video_status":"Video status","duties_performed":"Duties performed or not","submit_for_payment_request":"提交付费申请","Please fill in":"Please fill in","Veeva ID":"VEEVA ID / ABAC ID","EE name":"EE name","Failed to submit":"Failed to submit.","EE list":"EE list","Delete successfully":"Delete successfully","Confirm to delete?":"Confirm to delete?","Total settlement amount":"Total settlement amount","tip":{"please_choose_major_or_minor_change":"请选择主要或次要变更","please_choose_communicated_with_speaker":"请选择是否与讲者联络","support_document":"支持文件","support_document_with_line_manager_approval":"支持文件 (Line manager审批邮件)","please_upload_supporting_documents":"请上传支持文件","request_type_can_not_be_duplicate":"需求类型名称不能重复"},"offline_photo_special_approval_option":"Offline photo / special approval (optional)","please_upload_photos":"Please upload photos","please_upload_photos_or_support_document":"请上传照片或支持性文件。","please_upload_screenshot_or_support_document":"请上传网络会照片或支持性文件。","please_fill_in_reason":"请填写理由","offline_meeting_photo":"Offline meeting photo","upload_meeting_photo":"Upload meeting photo","service_agreement":"Service agreement","on_site_photo":"On-site photo","on_site_photo_for_speaker":"On-site photo (For speaker)","meeting_agenda":"Meeting agenda","speaker_coi":"Speaker COI","meeting_info_with_checklist":"Meeting info with checklist","please_do_not_fill_in_the_request_type_already_existed":"不可填写相同需求类型","please_upload_related_supporting_documents":"Please upload related supporting documents. ","please_generate_iit":"请生成个税申请表. ","po_number_is_empty":"PO号码为空","final_signed_agreement_with_external_expert":"Final signed agreement with external expert","expert_assessment_form":"Expert assessment form","final_invitation_or_agenda":"Final invitation or agenda","meeting_photo_or_screenshot":"Meeting photo or screenshot","ee_list_with_signature_or_ee_screenshot":"EE list with signature or EE screenshot","ee_coi":"EE COI","total_presentation_duration":"Total presentation duration","total_service_fee_tax_included":"报酬总额（含税）","total_service_fee_exclude":"服务费总额（不含税）","please_select_at_least_one_document":"请至少选择一个文件","payment_checklist":"付费清单","coe leader approved":"Coe leader审批通过","ceoe head approved":"CEOE Head 审批通过","iit_filling_form":"个税申请表","eg_medical_engagement_relevant_material_planning_form":"(例如医学会议相关材料表格)","please_select_at_least_one_item":"请选择至少一项","approval_email_and_other_supporting_documents":"审批邮件以及其他支持性文件","marketing_confirmation":"后勤培训确认","material_confirmation":"演讲材料确认","scientific_training_confirmation":"科学内容培训确认","content_training_confirmation":"材料培训确认","medical_training_confirmation":"医学培训确认","medical_governance_training_confirmation":"医学培训确认","reason_for_the_lack_of_confirmation":"缺失确认材料理由","lack_of_confirmation_supporting_documents":"缺失确认材料理由支持性文件","scientific_training_content_training_medical_governance_training_should_be_confirmed_as_yes":"科学内容培训、材料培训及医学培训应被确认为是","if_speaker_material_is_validated_speaker_name_is_green":"若讲者材料齐全，则讲者姓名为绿色。","if_lack_of_speaker_material_speaker_name_is_red":"若讲者材料缺失，则讲者姓名为红色。","the_speaker_name_marked_as_green_when_the_materials_are_completed_before_meeting_start_date_otherwise_speaker_name_marked_as_red":"在会议开始日期前，若讲者材料齐全，讲者姓名为绿色，否则讲者姓名为红色。","please_upload_supporting_documents_for_minor_changes_in_speaker_contract_module_timely":"请及时在合同模块上传Minor change相关的支持性文件.","uninvited_attendee_comments":"临参人员原因","uninvitedStatusDropDownList":{"submitted":"已提交","unsubmitted":"未提交","return":"退回","-":"-","confirmed by eo":"EO已确认","confirmed by em":"EM已确认"},"photo_submit_tip":"您提交的照片系统将同时提交至Finance HCPE Team及Finance Vendor Team进行审批。","for_speaker_photo_approval":"讲者照片审批","for_vendor_photo_approval":"供应商照片审批","uninvited_attendee_list_cannot_be_uploaded_tips":"请注意：如临参人员已有veeva id，需准确填写<b>veeva id+姓名</b>。如临参人员无veeva id，需准确填写<b>姓名+医院+科室</b>且不要在veeva id列填写任何字符(如空格,”-”等)，否则无法成功提交。","online_attendee":"Online attendee","platform":"Platform","no_of_attendee_platform":"No. of attendee (Third party platform)","no_of_attendee_total":"No. of attendee (Total)"},"contract":{"meeting":{"bu":"业务单元","ta":"治疗领域","product":"产品名称","city":"城市","province":"省/直辖市","meeting_time":"会议日期","paid_speaker_num":"付费讲者人数","unpaid_speaker_num":"无偿讲者人数","speaker_num":"讲者人数","speaker_fee_budget":"讲者费用预算","disease_area":"治疗领域","online_meeting":"网络会","meeting_category":"会议类型","meeting_method":"会议形式","meeting_budget":"会议预算","sponsorship_fee_budget":"赞助费预算","satellite_symposium":"Satellite symposium","satellite_symposium_no":"卫星会数量","booth":"展台","meeting_code":"会议编号","meeting_status":"会议状态","meeting_location":"会议地址","meeting_date":"会议日期","if_hcpe":"HCPE/ Non HCPE","hcpe":"HCPE","non_hcpe":"Non HCPE","action":"操作","__________________EE_CONTRACT_BEGIN":"","ee_confirmation_and_contract":"EE confirmation and contract","ee_num":"Number of EE","meeting_type":"Meeting type","team":"Team","ee_fee_budget":"EE service fee budget","__________________EE_CONTRACT_END":"","gr_status":"GR Status"},"speaker":{"sn":"创建序号","category":"讲者类型","paid":"付费讲者","unpaid":"无偿讲者","veeva_id_abac_id":"Veeva ID/ABAC ID","veeva_id":"Veeva ID","hcp_id":"HCP ID","name":"姓名","title":"学术职称","academic_title":"行政职务","contract_type":"合同类型","level":"级别","tov":"不含税TOV","total_service_fee":"报酬总额（含税）","possibility":"参会可能性","attendance":"是否出席","presentation_material":"演讲材料","presentation_duration":"演讲时长","preparation_duration":"准备时长","follow_up_duration":"会后跟进时长","total_service_duration":"总服务时长","training_start_date":"医学培训生效开始日期","training_expire_date":"医学培训有效截止日期","medical_training_status":"医学培训状态","submitted_by":"提交人","hospital":"医院","department":"科室","status":"状态","contract":"合同","stamped_contract":"盖章版合同","action":"操作","briefing_confirmation":"材料培训确认","logistics_confirmation":"后勤培训确认","materials_confirmation":"演讲材料确认","if_speaker_consent_for_disclosure":"讲者披露方式","yes_by_individual_disclosure":"我同意披露我的个人信息，包括姓名、联系方式、所属单位及职称，以及相关的差旅、住宿或其他合理开支的费用信息","no_aggregated_disclosure":"我不同意披露我的个人信息","international":"国际级","national":"国家级","regional":"区域级","chairman_or_not":"是否是主席","__________________EE_CONTRACT_BEGIN":"","method_of_ee_consent_for_disclosure":"Method of EE consent for disclosure","__________________EE_CONTRACT_END":""},"field":{"start_date":"会议开始日期","end_date":"会议结束日期","meeting_topic":"会议主题","location":"地点","name":"讲者姓名","contact_information":"联系信息","title":"学术职称","academic_title":"行政职务","contact_address":"联系地址","estimated_title":"拟演讲的题目","presentation_duration":"演讲时长","total_service_fee":"服务费总额（含税）","total_service_fee_tax_included":"服务费总额（含税）","total_service_fee_exclude":"服务费总额（不含税）","if_contains_transportation_and_accomodation":"是否需要提供差旅和住宿？","presentation_topic_for_speech_service":"拟演讲的题目","advisory_service_description":"咨询服务描述","speaker_service_type":"讲者服务类型","ground_transportation_required":"是否需要地面交通？","transportation_and_accomodation_details":"差旅和住宿的详细内容","ground_transportation_details":"地面交通的详细内容","id_number":"身份证号","bank_account_number":"银行账号","bank_name":"银行开户行","gsk_name":"乙方名称","gsk_address":"乙方联系地址","coi_status":"COI状态","if_go":"是否为政府官员","go_status":"政府官员职务审批状态","coi_expired_day":"COI到期日","whether_eeib":"是否EEIB","eeib_status":"EEIB状态","reasons":"理由","__________________HCO_CONTRACT_BEGIN":"","hco_name":"HCO名称","hco_address":"HCO地址","hco_fax_number":"HCO传真号码","meeting_objective":"会议目的","meeting_location":"会议地址","meeting_name":"会议名称","contract_value":"服务费总额","sponsored_item":"合作项目","payment_times":"付款次数","prepayment_value":"预付款金额","balance_payment_value":"余款支付金额","hco_account_name":"账户信息-单位","hco_account_number":"HCO account number","hco_bank_name":"HCO bank name","payment_purpose":"账户信息-款项","contract_expiry_date":"合同有效期","vat_invoice_type":"发票类型","vat_rate":"发票税点","meeting_start_year":"会议开始年份","meeting_start_month":"会议开始月份","meeting_start_date":"会议开始日期","meeting_end_year":"会议结束年份","meeting_end_month":"会议结束月份","meeting_end_date":"会议结束日期","meeting_agenda_sent_date":"会议计划书发出时间","unit_amount_of_submeeting":"分会单价","quantity":"数量","completed_meetings_value":"已完成会议总金额","applied_down_payment_value":"本次申请预付款金额","meeting_code_for_payment":"Meeting code for payment","please_hco_bank_name":"Please fill in HCO bank name","please_hco_account_number":"Please fill in HCO account number","please_meeting_code_for_payment":"Please select Meeting code for payment","notes":"备注","optional":"（选填）","payment_application":"付款申请","WBS_Cost_center":"WBS/Cost center","Remaining_HCO_contract_value":"剩余HCO合同金额","__________________HCO_CONTRACT_END":"","__________________EE_CONTRACT_BEGIN":"","eei_status":"EEIB status","total_service_duration":"Total service duration","total_presentation_duration":"Total presentation duration","__________________EE_CONTRACT_END":"","send_e_contract":"可以发送电子合同","can_not_send_e_contract_commercial":"该讲者目前无法发送电子合同 </br> 您可以选择签署纸质合同或请医生注册医时空并绑定手机号后,再发起电子签约流程","can_not_send_e_contract_medical":"该讲者目前无法发送电子合同 </br> 您可以选择签署纸质合同或请医生注册医时空并绑定手机号后,再发起电子签约流程","confirm_send_e_contract":"请确认是否发送电子合同?","err_tilte":"会议收货条件未满足，无法提交会议收货申请:","err_sub_title":"①大会议程 </br>②会议执行照片审批通过 </br>③HCO PO已完成</br>④确认出席的讲者材料齐全：盖章讲者合同/讲者沟通函/讲者演讲材料（主席可以没有演讲材料）"},"tips":{"medical_training_tip":"付费讲者的医学培训需要由Medical TA完成，即使该讲者在本会议是无偿讲者。","rpa_pr_process_tip":"Due to manual PR process has been opened , RPA PR process has been automatically closed and cannot be recovered. If you need to update the PR/PO, please go to Ariba to update and enter the final PR/PO number into the system to support the payment request","manual_pr_process_tip":"After successfully pressing PR/PO in ARIBA, please input PR/PO number in the bottom and click to submit. The system will automatically verify.","__________________HCO_CONTRACT_BEGIN":"","vat_invoice_type_label_tip":"若主办方不能开具增值税专用发票，请联系GSK税务部门，并在系统中遵照非标准合同流程提交合同申请","vat_rate_label_tip":"请根据实际情况输入发票税点，系统将自动计算不含税金额并使用不含税金额下订单","vat_rate_must_greater_than_zero":"税点需在0-100之间","date_must_be_within_the_date_range_of_the_er":"会议开始日期需在会议申请中的会议日期区间内","date_must_be_within_the_date_range_of_the_er2":"会结束日期需在会议申请中的会议日期区间内","date_must_be_earlier_the_start_date_of_the_er":"合同中的开始日期必须早于或等于ER中会议开始日期","date_must_be_later_the_end_date_of_the_er":"合同中的结束日期必须晚于或等于ER中会议结束日期","invalid_date_range":"会议结束日期早于开始日期","payment_times_warming1":"付款次数应大于1","payment_times_warming2":"付款次数应大于2","payment_times_warming3":"付款次数应大于3","downpayment_count_warming":"累计预付款金额应等于合同总金额","please_upload_attachment":"请上传附件","payment_times_warming":"付款次数需满足公司规定","first_downpayment_warming":"第一笔预付款金额应满足公司规定","applied_down_payment_value_warming":"申请的预付款金额应满足公司规定","apply_sucess":"申请成功。","apply_faild":"申请失败","payment_times_must_greater_than_zero":"付款次数需大于0","downpayment_value_must_greater_than_zero":"预付款金额需大于0","non_standard_contract_title_tips":"请将招商函和大会议程作为附件粘贴到非标准合同中。","non_standard_contract_offline_approval_documents":"请上传全部的非标准合同线下审批支持性材料。","__________________HCO_CONTRACT_END":"","e_contract":"电子合同","e_contract_optional":"电子合同(Prefer)","e_contract_generate_record":"电子合同生成记录","please_fill_in_cancel_reason":"请输入撤销理由","please_fill_in_withdraw_reason":"请输入撤回理由","please_fill_in_change_reason":"请输入变更理由","please_confirm_whether_to_cancel_the_electronic_contract":"请确认是否发送电子合同撤销协议?","please_confirm_whether_to_withdraw_the_electronic_contract":"请确认是否撤回电子合同?","confrim_to_change":"确认变更?","training_list_status_tips":"请点击培训列的状态名称，查看培训内容详情并添加培训记录。","update_hco_payment":"付款申请需依据公司政策规定执行，且系统中所填写的金额应与<br />实际向财务申请的付款金额保持一致。","confirm_attendance_status":"是否确认讲者出席状态?","deleted_speaker_tip":"该讲者已被Veeva删除"},"shopping_cart":{"speaker_coi":"讲者COI","paid_speaker_coi":"付费讲者COI","unpaid_speaker_coi":"无偿讲者COI","paid_speaker_coi_tip":"已提名讲者（除确认不出席的讲者外）没有已确认的有效COI或其COI有效期不包含会议日期；或赞助了卫星会的会议没有提名讲者，请提名讲者并确认讲者有有效的COI。","unpaid_speaker_coi_tip":"已提名讲者（除确认不出席的讲者外）没有上传COI或其COI有效期不包含会议日期；或赞助了卫星会的会议没有提名讲者，请提名讲者并确认讲者有有效的COI。","speaker_contract":"讲者合同","ee_contract":"EE contract","go_status":"政府官员职务审批状态","code_category":"WBS/Cost center","wbs_code":"WBS编号","cc_code":"CC编号","cost_center":"Cost center","wbs_cost_center_code":"WBS/Cost center code","contract_value":"服务费总额","price":"价格","tax_excluded":"（不含税）","tax_included":"（含税）","pr_id":"PR ID","pr_number":"PR编号","pr_status":"PR状态","comments":"理由","vendor_id":"供应商 ID","po_number":"PO编号","po_status":"PO状态","rpa_progress":"RPA progress","speaker_po_number":"讲者PO编号","speaker_po_status":"讲者PO状态","vendor_name":"供应商名称","ariba_category":"Ariba类别","select_documents":"Gmeeting系统已留存以下文件，请选择在Ariba中创建PO需要的文件","go_exception_approval_form":"政府官员例外审批表","final_signed_conflict_of_interest":"签署的利益冲突协议","draft_agreement":"审批通过的讲者草稿版合同","pr_documents":"上传PR所需的文件（选填）","pr_description":"PR描述（选填）","additional_documents_for_pr":"Upload additional documents for PR request in Ariba","pr_return_reason":"HCO付款团队退回原因","unit_amount":"单价","quantity":"数量","quarterly_plan_approval_status":"季度计划审批状态","engagement_request_approval_status":"会议申请审批状态","sponsorship_letter":"招商函","agenda_congress":"大会议程","speaker_presentation_materials":"讲者演讲材料","stamped_hco_contract":"盖章HCO合同","cvent_status":"Cvent状态","return":"退回","cancel_success":"退回成功.","cancel_confirm":"是否确认退回？","return_reason":"退回理由","return_placeholder":"请输入退回理由.","hco_pr_generation":"生成HCO PR","confirm_to_create_a_new_HCO_PRPO":"是否确认重新申请新的HCO PR/PO？","confirm_to_cancel_HCO_PRPO":"是否确认取消HCO PR/PO？","rpa_pr_process":"RPA PR process","manual_pr_process":"Manual PR process","click_to_download":"Please click to download the above files required for PR.","__________________EE_CONTRACT_BEGIN":"","ee_coi":"EE COI","expert_assessment_form":"Expert assessment form","eeib_status":"EEIB状态","eeib_exception_approval_form":"EEIB exception approval form","agreement":"盖章版合同","non_promotionalactivity_form":"Non-promotional activity form","assessment_form":"Assessment form of nominated EE","__________________EE_CONTRACT_END":"","tips":"总花费超过十万英镑的GSK赞助会议，三方付款团队需要获得SOE提供的线下支持性文件，并在提交PR申请前作为补充材料上传到Gmeeting系统中。"},"material":{"sn":"创建序号","content_lab_code":"Content Lab编号","material_name":"演讲材料名称","description":"描述","expiry_date":"演讲材料有效期","type":"Type","changes":"演讲材料是否有变更？","action":"操作","minor_change":"较小变更","big_change":"重大变更","reasons_for_big_changes":"重大变更理由","new_content_lab_code":"新Content Lab编号","new_conten_lab_code_status":"新Content Lab状态","updating_date":"Updating date","only_the_material_corresponding_to_the_speaker_ta_can_be_added":"仅可添加该讲者TA对应的材料。"},"title":{"speaker_confirmation_and_contract":"讲者确认和合同","shopping_cart_checklist":"购物车清单","basic_information":"基本信息","contract_review":"查看合同","contract_generate":"生成合同","stamped_contract":"盖章版合同","details":"明细","contract_approval":"合同审批","reasons_for_non_standard_contract":"使用非标合同的理由","briefing_and_training_confirmation":"材料和培训信息","logistics_briefing_confirmation":"后勤培训确认","content_briefing_confirmation":"材料培训确认","content_briefing":"演讲内容培训","training_confirmation":"GSK规章制度培训确认","training":"GSK规章制度培训","content_and_content":"演讲材料和演讲内容培训","scientific_training":"科学内容培训","marketing_briefing":"后勤培训","medical_training_list":"GSK规章制度培训列表","add_new":"新增","meeting_information":"会议信息","standard_contract":"标准合同","non_standard_contract":"非标合同","non_standard_contract_supporting_documents":"非标合同支持文档","speaker_status":"讲者状态","ee_status":"EE 状态","contract":"合同","contract_checklist":"合同清单","non_standard_contract_checklist":"非标合同清单","contract_and_contract_checklist_generated_record":"合同和合同清单生成记录","non_standard_contract_and_non_standard_contract_checklist_generated_record":"非标合同和非标合同清单生成记录","payment_checklist_record":"Payment checklist 生成记录","upload_stamped_contract":"上传盖章合同","speaker_consent_for_disclosure":"讲者披露结果","offline_po_supporting_documents":"线下PO支持性文件","speaker_pr_generation":"生成讲者PR","title_of_speech":"Title of speech","title_of_speech_advisory":"Advisory service description","update_meeting_agenda":"更新会议议程","generated_record":"生成记录","approval_process":"审批流程","assign_record":"Assign record","key_fields_of_contract":"合同关键信息","key_fields_of_speaker":"讲者关键信息","key_fields_of_gsk":"GSK关键信息","training_list":"医学培训记录","training_details":"医学培训记录","presentation_materials_list":"演讲材料清单","the_original_material_basic_information":"材料基础信息","update_for_big_changes":"重大变更","material_basic_information":"材料基础信息","supporting_documents_for_minor_change":"较小变更的支持性文件","speaker_communication_letter":"讲者沟通函","attachment":"附件","meeting_agenda":"大会议程","issue_contract":"合同申请","prepare_hco_shopping_cart":"HCO购物车预申请","apply_hco_payment":"HCO预付款申请","hco_contracting":"HCO合同申请","supplymentary_contract":"补充协议","validation_process":"上传及校验记录","non_standard_contract_offline_approval_form":"非标准合同离线审批文件","speaker_contracting_and_briefing":"Speaker Contracting and Briefing","ee_contracting":"EE contracting","pr_preparation_information":"PR/PO相关信息","pr_po_preparation_information":"PR/PO相关信息（与合同保持一致）","contract_key_information":"合同关键信息","payment_application":"付款申请","photos_approval_status":"Onsite photos/Screenshot approval status","meeting_list":"会议列表","upload_stamped_supplymentary_contract":"上传盖章补充合同","upload_process":"上传记录","If_contract_value_has_been_changed":"If contract value has been changed","other_supporting_documents":"其他支持性材料（选填）","key_fields_of_supplymentary_contract":"Key fields of supplymentary contract（If applicable）","__________________EE_CONTRACT_BEGIN":"","ee_consent_for_disclosure":"EE consent for disclosure","ee_confirmation_and_contract":"EE confirmation and contract","ee_pr_generation":"EE PR generation","__________________EE_CONTRACT_END":"","e_contract_optional":"E-contract(Prefer)","e_contract":"E-contract","e_contract_generate_record":"E-contract generate record","expert_name":"Expert name","expert_id":"Expert Id","expert_title":"Expert title","contact_address_of_expert":"Contact address of expert","if_contains_transportation_and_accomodation":"If contains transportation and accomodation","speaker_signed_contract":"Speaker signed contract","after_meeting_stamped_contract":"After-Meeting Stamped contract","after_meeting_stamped_contract_update_record":"After-Meeting Stamped contract update record"},"common":{"more":"更多","show":"展开","hide":"隐藏","yes":"是","no":"否","expired":"已过期","no_records":"暂无记录","approved":"已审批","uploaded":"已上传","category":"Category","validate_successfully":"验证成功","validation_failed":"验证失败","veeva_id_abac_id":"Veeva ID/ABAC ID","veeva_id":"Veeva ID","not_required":"无需判断","speech_service":"提供演讲服务","advisory_service":"提供咨询服务","validated":"有效","invalid":"无效","0_tov":"0元讲者","chairman":"主席"},"popup":{"confirm_to_attend_the_meeting":"确认出席会议？","confirm_not_to_attend_the_meeting":"拒绝出席会议？","exceed_paid_num":"无偿讲者数量超过上限，请重新选择","exceed_unpaid_num":"无偿讲者数量超过上限，请重新选择","exceed_num":"讲者数量超过上限，请重新选择","exceed_budget":"您确认参会的讲者合同总金额不能超过总预算10%","exceed_budget_2":"您确认参会的EE合同总金额不能超过总预算10%","confirm_to_generate_contract":"确认生成合同？","confirm_to_generate_checklist":"确认生成合同清单？","contract_generate_success":"合同已被成功生成","checklist_generate_success":"合同清单已被成功生成","confirm_to_generate_shopping_cart_checklist":"确认生成购物车清单？","shopping_cart_checklist_generate_success":"购物车清单已被成功生成","confirm_to_complete_the_logistics_briefing":"确认完成后勤培训？","confirm_not_to_complete_the_logistics_briefing":"确认未完成后勤培训？","confirm_to_complete_the_materials":"确认最终演讲材料？","confirm_not_to_complete_the_materials":"拒绝最终演讲材料？","confirm_to_complete_the_briefing":"确认完成材料培训？","confirm_not_to_complete_the_briefing":"确认未完成材料培训？","approve_success":"合同已被成功审批","reject_success":"合同已被成功拒绝","confirm_to_change":"确认更改？","invalidate_contract_confirm":"由于演讲材料重大变更，该讲者合同将自动失效，是否确认？","confirm_to_cancel":"确认取消？","cancel_success":"取消成功","payment_checklist_generate_success":"付款清单已生成成功。","exceed_num2":"The no. of EE has exceeded the limit, please redo the selection.","confirm_to_cancel_e_sign":"您是否确认撤销","confirm_to_withdraw_e_sign":"您是否确认撤回"},"placeholder":{"please_fill_in_meeting_topic":"请输入会议主题","please_fill_in_location":"请输入地点","please_fill_in_contact_information":"请输入联系信息","please_fill_in_title":"请输入学术职称","please_fill_in_topic":"请输入拟演讲的题目","please_fill_in_total_service_fee":"请输入服务费总额（含税）","please_fill_in_address":"请输入联系地址","please_fill_in_details":"请输入详细内容","please_fill_in_id_number":"请输入身份证号","please_fill_in_the_correct_format_of_id_number":"请输入正确位数的身份证号","please_fill_in_bank_account_number":"请输入银行账号","please_fill_in_bank_name":"请输入银行开户行","please_fill_in_10_digit_numbers":"请输入10位数字","please_search_for_vendor_id":"请搜索供应商ID","please_select_wbs_or_cost_center":"请选择WBS或Cost center","please_fill_in_wbs_or_cost_center":"请选择WBS或Cost center code","please_fill_in_pr_number":"Please fill in PR number","please_fill_in_po_number":"Please fill in PO number","please_fill_in_wbs_code":"请输入WBS编号","please_fill_in_cc_code":"请输入CC编号","please_fill_in_wbs_cost_center_code":"请输入WBS/Cost center code","please_fill_in_price":"请输入价格","sum_of_price":"价格总额必须等于服务费总额（不含税）","sum_of_price1":"WBS Code/cost Center所对应的金额必须等于单价*数量总额","sum_of_price2":"单价*数量总额必须等于合同总金额","sum_of_quantity":"总数量必须等于会议场数/系列会场数","unit_tip":"分会金额（不同分会金额需要分开填写，点击右侧添加按钮添加不同分会金额）","quantity_tip":"分会数目","please_select_documents":"请选择文件","please_fill_in_desc":"请输入PR说明（可选）限500字","please_enter_content_lab_code":"请输入Content lab code/材料名称","please_fill_in_to_search":"请输入演讲材料和演讲材料名称进行搜索","please_fill_in_reasons":"请输入原因","please_fill_in_reasons_2":"请输入理由","please_upload_file":"请上传文件","please_add_new_content_lab_code":"请新增Content lab code","coi_go_valid":"由于该讲者COI和政府官员职务审批状态均为失效，您不可以提交合同。","coi_valid":"由于该讲者COI状态为失效，您不可以提交合同。","coi_eeib_invalid":"COI到期日必须晚于会议开始时间，EEIB状态必须为可用且EO已确认，否则不可提交合同","coi_eeib_invalid2":"COI到期日必须晚于会议开始时间，EEIB状态必须为可用且Medical BO已确认，否则不可提交合同","coi_invalid":"The COI expiry date must be later than the meeting start date, otherwise you cannot submit contract.","eeib_invalid":"The EEIB status must be validated and confirmed by EO, otherwise you cannot submit contract.","click_update_to_complete_pr_generation":"请点击更改按钮，尽快完成PR生成。","please_choose_training_start_date":"请选择培训开始日期","optional":"选填","__________________HCO_CONTRACT_BEGIN":"","please_enter_meeting_objective":"请输入会议目的","please_enter_each_sponsored_item":"请输入所有合同项目","please_enter_payment_times":"请输入付款次数","required_field":"必填项","at_least_6_months_after_meeting_end_date":"请选择会议结束日期后至少6个月","gsk_name":"请选择GSK名称","gsk_address":"请选择GSK地址","meeting_start_year":"请选择会议开始年份","meeting_start_month":"请选择会议开始月份","meeting_start_date":"请选择会议开始日期","meeting_end_year":"请选择会议结束年份","meeting_end_month":"请选择会议结束月份","meeting_end_date":"请选择会议结束日期","meeting_location":"请填写会议地点","meeting_agenda_sent_date":"请输入会议计划书发出时间","invoice_type":"请选择发票类型","Please_fill_in_what_had_been_changed_against_GSK_standard_contract":"请描述该非标准合同的修改处，不超过500字","Please_fill_in_payment_application_description":"请填写付款申请的备注，如发票冲销期限等，非必填","__________________HCO_CONTRACT_END":"","__________________EE_CONTRACT_BEGIN":"","coi_eeib_valid":"COI status and EEIB status of the speaker are invalid. Contract cannot be submitted.","__________________EE_CONTRACT_END":"","please_add_comments_here":"请添加备注：%等","please_fill_in_wbs_code_or_cost_center_code":"请输入WBS/Cost center code"},"btn":{"download_template":"Download template","add_new_materials":"新增演讲材料"}},"quarterlyPlan":{"content":{"planned_meeting_budget":"计划会议预算","submitted_meeting_budget":"已提交会议预算","approved_meeting_budget":"审批通过会议预算","adhoc_meeting_budget":"已审批通过Ad hoc会议预算","planned_meeting_volume":"计划会议数量","submitted_meeting_volume":"已提交会议数量","approved_meeting_volume":"审批通过会议数量","adhoc_meeting_volume":"已审批通过Ad hoc会议数量","draft":"待提交","in_progress":"审批中","to_do":"待审批","approve":"审批通过","reject":"审批拒绝","approved":"审批通过","rejected":"审批拒绝","default":"默认","quarterly_plan":"季度计划","bu":"业务部门","ta":"治疗领域","product":"产品名称","meeting_category":"会议类别","meeting_ttt":"If TTT meeting","meeting_type":"会议类型","if_ttt":"If TTT","meeting_date":"会议时间","total_budget":"总预算","meeting_method":"会议形式","name":"名称","mudid":"MUDID","role":"角色","add_engagement":"添加会议","engagement":"Engagement","approval_progress":"审批进度","assign_record":"分配记录","eo":"EO","line_manager":"Line manager","brand_owner":"Brand owner","marketing_head":"Marketing Head","medical_ta_head":"Medical TA Head","gm":"GM","all":"选择所有","improve_the_level_of_diagnosis_and_treatment":"提高诊疗水平","deliver_disease_knowledge_build_or_shape_treatment_goal":"提供疾病知识，建立或制定治疗目标","deliver_disease_knowledge_enhance_prevention_perception_and_goal":"提供疾病知识，增强预防意识和目标","improve_the_treatment_of_diseases":"Improve the treatment of diseases","seminar":"Seminar","webinar":"Webinar","seminar_webinar":"Seminar+Webinar","online_meeting":"线上会议","offline_meeting":"线下会议","online_offline_meeting":"线上+线下会议","regional":"区域会","national":"全国会","city":"城市会","meeting_time":"会议时间","ip_conference":"IP conference","meeting_total_budget":"会议总预算"},"label":{"draft":"待提交","inprogress":"审批中","todo":"待审批","approved":"审批通过","rejected":"审批拒绝","meeting_name":"会议名称","meeting_duration":"会议时长","days":"天","start_date":"开始日期","end_date":"结束日期","start_time":"开始时间（选填）","end_time":"结束时间（选填）","ta":"治疗领域","bu":"业务部门","team":"Team","disease_area":"Disease area","meeting_type":"会议类型","product":"产品名称","city":"城市","hco":"HCO","business_rationale":"业务目的","business_rationale_short_description":"业务目的简述","province":"省/直辖市","level_of_paid_ee":"Level","no_of_paid_ee_of_this_level":"No. of paid EE of this level","service_fee_budget_of_paid_ee_of_this_level":"Service fee budget of paid EE of this level","number_of_paid_ee":"有偿讲者人数","number_of_unpaid_ee":"无偿讲者人数","number_of_paid_ee_online":"有偿讲者人数(线上)","number_of_unpaid_ee_online":"无偿讲者人数(线上)","number_of_paid_ee_offline":"有偿讲者人数(线下)","number_of_unpaid_ee_offline":"无偿讲者人数(线下)","number_of_paid_speaker":"有偿讲者人数","number_of_unpaid_speaker":"无偿讲者人数","number_of_hcp_attendee":"参会者人数","number_of_gsk_staff":"GSK员工人数","number_of_hcp_attendee_online":"参会者人数（线上）","number_of_gsk_staff_online":"GSK员工人数（线上）","number_of_hcp_attendee_offline":"参会者人数（线下）","number_of_gsk_staff_offline":"GSK员工人数（线下）","speaker_fee_budget":"讲者费用预算","event_budget":"活动费用预算","total_budget":"总预算","t&e_budget":"员工费用预算","t&e_accommodation":"T&E Accommodation","t&e_air_travel":"T&E Air travel","sponsorship_budget":"赞助会费用预算","ee_service_fee_budget":"EE fee budget","product_name":"产品名称","brand_budget":"品牌预算","only_one_fill":"一场会议仅能选择付费讲者和无偿讲者中的一种类型","event_budget_description":"活动费用预算是除讲者费用预算和员工费用预算外其他预算费用的总和","event_budget_description_sp":"活动费用预算是除讲者费用预算,员工费用预算和赞助会费用预算外其他预算费用的总和","event_budget_description_md":"Event budget is total budget except EE service fee budget and T&E budget","hco_name":"HCO name","seires_meeting_single_meeting":"Seires meeting / Single meeting","seires_meeting":"Seires meeting","single_meeting":"Single meeting","noof_sub_meetings":"分会数量","accommodation_central_budget":"Accommodation (Central budget)","air_travel_central_budget":"Air travel (Central budget)","ground_transportation":"Ground transportation","food_beverage":"Food & beverage","venue":"Venue","production_audio_visual":"Production / Audio visual","others":"Others","booth_material_optional":"Booth Material (Optional）","ee_number":"EE number","preparation_duration":"Preparation duration","presentation_duration":"Presentation duration","follow_up_duration":"Follow-up duration","service_fee_budget_of_this_level":"Service fee budget of this level","total_budget_without_t&e_budget":"Total budget (Without T&E budget)","rationale_of_exceeding_budget_in_quarterly_plan":"Rationale of exceeding budget in quarterly plan"},"placeholder":{"please_fill_in_meeting_name":"请输入会议名称","please_select_province":"请选择省/直辖市","please_select_province_optional":"请选择省/直辖市(选填)","please_fill_in_meeting_duration":"请输入会议持续时间","please_select_start_date":"请选择开始日期","please_select_end_date":"请选择结束日期","please_select_start_time":"请选择开始时间","please_select_end_time":"请选择结束时间","please_select_ta":"请选择治疗领域","please_select_bu":"请选择业务部门","please_fill_in_city":"请输入城市","please_select_city":"请选择城市","please_select_city_optional":"请选择城市(选填)","please_fill_in_name_or_mudid":"请输入姓名或者MUDID","please_select_product":"请选择产品名称","please_select_business_rationale":"请选择业务目的","no_more_than_500_words":"请填写业务目的简短描述，最多500个字符(选填)","no_more_than_500_words_required":"Please fill in business rationale short description, maximum 500 characters","no_more_than_1000_words":"请填写业务目的简短描述，最多1000个字符","no_more_than_1000_words_required":"Please fill in business rationale short description, maximum 1000 characters","please_fill_in_paid_ee":"Please fill in number of paid EE","please_fill_in_unpaid_ee":"Please fill in number of unpaid EE","please_fill_in_paid_speaker":"请输入有偿讲者人数","please_fill_in_unpaid_speaker":"请输入无偿讲者人数","please_fill_in_hcp_attendee":"请输入参会者人数","please_fill_in_hcp_attendee_optional":"请输入参会者人数(选填)","please_fill_in_gsk_staff":"请输入GSK员工人数","please_fill_in_gsk_staff_optional":"请输入GSK员工人数(选填)","please_fill_in_speaker_fee_budget":"请输入讲者费用预算 (CNY)","please_fill_in_event_budget":"请输入活动费用预算 (CNY)","please_fill_in_t&e_budget":"请输入员工费用预算 (CNY)","please_fill_in_t&e_accommodation":"Please fill in T&E Accommodation (CNY)","please_fill_in_t&e_air_travel":"Please fill in T&E Air travel (CNY)","please_fill_in_sponsorship_budget":"请输入赞助会费用预算 (CNY)","please_fill_in_ee_service_fee_budget":"Please fill in EE service fee budget (CNY)","please_fill_in_product_name":"请输入产品名称","please_fill_in_brand_budget":"请输入品牌预算","event_budget_description":"活动费用预算是除讲者费用预算和员工费用预算外其他预算费用的总和","please_fill_in_hco_name":"Please select HCO","please_fill_in_number":"Please fill in number","please_fill_in_level":"Please fill in level","please_fill_in_level_no":"Please fill in No.","please_fill_in_level_service_fee_budget":"Please fill in service fee budget","please_fill_in_accommodation":"Please fill in accommodation","please_fill_in_air_travel":"Please fill in air travel","please_fill_in_ground_transportation":"Please fill in ground transportation","please_fill_in_food_beverage":"Please fill in food & beverage","please_fill_in_venue":"Please fill in venue","please_fill_in_production_audio_visual":"Please fill in production / audio visual","please_fill_in_others":"Please fill in others","please_fill_in_rationale_of_exceeding_budget_in_quarterly_plan":"Please fill in rationale of exceeding budget in quarterly plan","please_select_booth_material":"Please select Booth Material"},"btn":{"add_ad_hoc_meeting":"新增 ad hoc 会议","search":"搜索","delete":"删除","assign":"分配","submit":"提交","close":"关闭","confirm":"确认","submitted":"已提交","pending":"待审批","hide":"隐藏","more":"更多","update":"修改","assigned":"已分配","approve":"审批通过","reject":"审批拒绝","add_engagement":"添加会议"},"tip":{"this_quarter_has_not_been_opened":"本季度暂未开放","no_engagement":"无会议","meetingName_required":"会议名称为必填项","bu_required":"业务部门为必填项","team_required":"Team is required","ta_required":"治疗领域为必填项","hco_required":"HCO是必填项","isSeries_required":"系列会/单场会是必填项","sponsorshipBudget_required":"赞助会预算是必填项","product_required":" 产品名称是必填项","disease_type_required":"Disease type is required","business_rationale_required":"业务目的为必填项","business_rationale_short_description_required":"业务目的简短描述为必填项","meetingCategory_required":"会议类别为必填项","meetingMethod_required":"会议形式为必填项","com_meeting_type_required":"meeting type is required","brand_budget_required":"产品预算为必填项","province_required":"省/直辖市为必填项","meeting_type_required":"会议类型为必填项","city_required":"城市为必填项","startDate_required":"开始日期为必填项","endDate_required":"结束日期为必填项","startDate_greater_than_endDate":"开始日期不能晚于结束日期","endDate_less_than_startDate":"结束日期不能早于开始日期","meetingDuration_required":"会议时长为必填项","number_of_paid_speaker_required":"有偿讲者人数为必填项","number_of_sub_meetings_required":"分会数量为必填项","number_of_unpaid_speaker_required":"无偿讲者人数为必填项","number_of_paid_ee_required":"Number of paid EE is required","number_of_unpaid_ee_required":"Number of unpaid EE is required","number_of_hcp_attendee_required":"参会人数为必填项","number_of_hcp_attendee_cannat_be_zero":"参会人数为不能为0","paid_speaker_unpaid_speaker_cannat_be_zero_at_the_same_time":"付费讲者和无偿讲者不能同时为 0","number_of_gsk_staff_required":"GSK员工人数为必填项","number_of_te_budget_required":"tebudget为必填项","number_of_event_budget_required":"活动费用预算为必填项","number_of_sponsorship_budget_required":"赞助会费用预算为必填项","no_result_found":"No result founded","the_quarter_has_not_been_opened":"该季度尚未开放","add_meeting_successfully":"添加会议成功","failed_to_add_meeting":"添加会议失败","update_meeting_successfully":"修改会议成功","failed_to_update_meeting":"修改会议失败","the_ratio_of_attendee_to_speaker_is":"参会者与讲者比例为","the_ratio_of_speaker_to_attendee_is":"讲者与参会者比例为","the_ratio_of_gsk_staff_to_attendee_is":"GSK员工与参会者比例为","the_ratio_of_attendee_to_ee_is":"The ratio of EE : attendee is","total_brand_budget_must_equal_to_total_budget":"各品牌预算加总必须等于会议总预算","failed_to_get_ta_list":"获取 TA 列表失败","failed_to_get_product_list":"获取产品列表失败","failed_to_get_business_rationale_list":"获取业务目的失败","failed_to_get_fmv_information":"获取 FMV 信息失败","speaker_fee_budget_is_over_limitation":"讲者费用预算超过设定上限","speaker_fee_budget_is_below_limitation":"讲者费用预算低于设定下限","ee_fee_budget_is_below_limitation":"EE service fee budget cannot be 0","end_date_cannot_later_than_hco_expiry_date":"结束日期不能晚于HCO过期日期","meeting_duration_cannat_be_zero":"会议时长不能为0","paid_speaker_fmv":"付费讲者FMV","paid_ee_fmv":"付费讲者FMV","paid_ee_fmv_list":"付费讲者每小时FMV（不含税）","international_ee":"国际级","national_ee":"国家级","regional_ee":"区域级","local_ee":"Local EE","failed_to_delete_meeting":"删除失败","approve_meeting_successfully":"审批通过","reject_meeting_successfully":"审批拒绝","failed_to_approve_meeting":"审批通过失败","failed_to_reject_meeting":"审批拒绝失败","confirm_to_submit":"在审批前您仅能提交一次。是否确认提交?","confirm_to_delete":"是否确认删除?","failed_to_submit_meeting":"提交失败","submit_only_once":"在审批前您仅能提交一次。请确认汇报给您的EO是否都已提交。是否确认提交?","choose_at_least_one":"Please choose one item at least .","speaker_fee_budget_is_required":"Number of Speaker fee budget is required","ee_fee_budget_is_required":"Number of EE service fee budget is required","product_budget_is_required":"产品预算为必填项","get_meeting_info_failed":"获取会议信息失败","submit_successfully":"提交成功","delete_successfully":"删除成功","confirm_to_update":"是否确认更新？","confirm_to_assign":"是否确认分配?","assign_successfully":"分配成功","failed_to_assign":"分配失败","whether_submit":"提交后不可修改。是否确认提交？","level_of_paid_ee":"Level of paid EE is required","no_of_paid_ee_of_this_level":"No. of paid EE of this level is required","service_fee_budget_of_paid_ee_of_this_level":"Service fee budget of paid EE of this level is required","accommodation_central_budget":"Accommodation (Central budget) is required","air_travel_central_budget":"Air travel (Central budget) is required","ground_transportation":"Ground transportation is required","food_beverage":"Food & beverage is required","venue":"Venue is required","production_audio_visual":"Production / Audio visual is required","others":"Others is required","t&e_accommodation":"T&E Accommodation is required","t&e_air_travel":"T&E Air travel is required","ee_number":"EE number is required","please_upload_files":"请上传文件","per_capita_cost_tips":"人均花费= 会议总预算 / (讲者人数+参会者人数)"},"title":{"approval_process":"审批流程","assign_record":"分配记录"}},"hco_management":{"update_ta":"更新 TA","update_product":"更新 product","add_new_ta":"新增 TA","add_new_product":"新增 Product","delete_ta":"删除 TA","delete_product":"删除 Product","hco_management":"HCO管理","new_hco_application_process":"新HCO申请进程","new_add_hco":"添加新HCO","add_city_hco":"添加市级学会","add_national_provincial_hco":"添加国家级/省级学会","hco_update_process":"HCO更新流程","hco_information":"HCO信息","key_account":"关键联系人","hco_name":"HCO名称","hco_tag":"学会标签","hco_city":"HCO城市","fill_in_hco_name":"请输入HCO名称（50字符以内）","search_hco_name":"请输入HCO名称","search_hco_tag":"请输入学会标签","select_hco_city":"请选择HCO城市","hco_name_error":"此HCO名称已被锁定，请填写新的HCO名称。","hco_name_error2":"此HCO名称已存在。","hco_level":"HCO等级","select_hco_level":"请选择HCO等级","product":"Product","select_product":"请选择product","select_ta":"请选择TA","select_bu":"请选择BU","hco_province":"HCO省份","select_hco_province":"请选择HCO省份","select_hco_status":"请选择状态","vat_type":"发票类型","please_select_vat_type":"请选择发票类型","vat_rate":"税点","please_fill_in_vat_rate":"请输入税点","hco_expiry_date":"HCO到期日","select_hco_expiry_date":"请选择HCO到期日","dd_supporting_document":"DD相关文件","dd_supporting_document_label":"DD支持文件","supporting_document":"相关文件","other_supporting_document":"其他相关文件","legal_certificate":"法人证","legal_certificate_expiry_date":"法人证有效期","select_legal_certificate_expiry_date":"请选择法人证有效期","hco_coi_form":"HCO COI问卷","hco_coi_start_date":"HCO COI问卷开始日期","select_hco_coi_start_date":"请选HCO COI问卷开始日期","hco_coi_expiry_date":"HCO COI问卷有效期","committee_expiry_date":"管理委员会官方名单有效期","select_hco_coi_expiry_date":"请选HCO COI问卷有效期","select_committee_expiry_date":"请选管理委员会官方名单有效期","background_and_introduction_of_hco":"HCO背景介绍","tpo_email":"TPO问卷报告","bank_certificate":"银行开户许可证","background_of_committee_members_with_stamp":"管理委员会官方名单","please_fill_in_at_least_six_committee_members":"Please fill in at least six committee members.","committee_members_information":"委员会成员信息","new_hco_tracking_list":"新HCO相关清单","hco_invitation_letter":"HCO邀请函（非必填）","hco_event_list_in_the_past_year_in_relevant_ta":"HCO过去12个月中有关TA的活动清单","hco_event_list_in_the_past_year_in_relevant_product":"HCO过去12个月中有关TA的活动清单","hco_review_committee_meeting_minutes":"HCO审查委员会会议记录","has_hco_request_been_rejected_previously":"该HCO申请之前被拒绝过吗？","update_hco_expiry_date":"更新HCO到期日","update_hco":"更新HCO信息","confirm_to_submit_for_updating_hco_expiry_date":"确认提交更新HCO有效期吗？","in_process":"进行中","completed":"完成","all":"全部","action":"操作","status":"状态","if_updating":"待生效版本状态","version_in_use":"在用版本","update_version":"待生效版本","business_rationale":"业务理由","please_fill_in_business_rationale":"请填入业务理由","management_committee_members_information":"管理委员会成员信息","please_fill_in_name":"请输入姓名","please_fill_in_employer":"请输入目前受雇单位","please_fill_in_academic_title":"请输入学术职位","please_fill_in_administrative_title":"请输入行政职位","member_name":"姓名","applicable":"请在适用的地方打勾（多选）","government_officer":"政府官员","hcp":"医疗卫生专业人士","faculty_of_college":"大学/研究机构教授职员","others":"其他（请详述）","employer":"目前受雇单位","academic_title":"学术职位","administrative_title":"行政职位","member":"成员","add_member":"添加成员","new_hco_ppt":"新增HCO宣讲材料","hco_management_monitoring":"管理监控文件","hco_negative_news_approval":"ABAC确认无相关负面新闻证明","tax_supporting_document":"税务支持文件","updated_document":"更新文件","reason_description":"理由描述","fill_in_reason_description":"请输入理由描述","supporting_documents":"支持性文件","remove_hco_error":"该协会进入HCO白名单未满一年，请确认是否从中移除。","remove_hco_tip":"请确认是否将该HCO从白名单中移除？","please_upload_relevant_files":"请上传文件","please_fill_in_others":"请输入","confirm_without_deleting":"确认（无需删除HCO）","no_change":"您尚未进行任何更改。","reason":"理由","fill_in_reason":"请输入理由","confirm_to_change":"确认更改","confirm_to_change_ta":"确认更改TA","confirm_to_change_product":"确认更改Product","update_ta_error":"HCO相关字段或必要文件不全，请点击左侧“Update”按钮，更新HCO相关信息。","hco_registration_status":"HCO注册状态截屏","annual_inspection_result":"协会/学会的年检结果截屏","annual_inspection_year":"协会/学会的年检结果年份","select_annual_inspection_year":"请选择协会/学会的年检结果年份","annual_inspection_result_expiry_date":"协会/学会的年检结果有效期","stamped_training_confirmation":"HCO培训确认文件（盖章版）","training_confirmation_start_date":"培训开始日期","select_training_confirmation_start_date":"请选择培训开始日期","training_confirmation_expiry_date":"培训有效期","management_monitoring_documents_start_date":"管理监控文件开始日期","management_monitoring_documents_expiry_date":"管理监控文件有效期","select_management_monitoring_documents_start_date":"Please select management monitoring documents start date","the_evidence_of_hco_is_not_in_the_list_of_unusual_activities":"HCO并非处于查询时点公布的活动异常名录截屏","the_evidence_of_hco_is_not_in_the_list_of_dishonest_enterprise":"HCO并非处于查询时点公布的严重违法失信名单截屏","coi_update_tips_1":"更新HCO COI时请同步检查是否需有更新管理委员会官方名单","coi_update_tips_2":"请确认您已经上传了最新的管理委员会官方名单"},"speaker_attendee":{"add_coi":"新增COI","veeva_status":"VEEVA状态","expiry_date":"Expiry date","add_warining":"该讲者已经存在于付费讲者池中，如果您确认选择该讲者，该讲者需要再次得到CMD审批。","target":"目标","non_target":"非目标","hcp":"HCP","non_hcp":"非HCP","please_fill_in_name":"请输入姓名","please_fill_in_veevaIdAbacId":"请输入VEEVA ID或ABAC ID","please_fill_in_hcpNonHcp":"请选择HCP或非HCP","please_fill_in_title":"请输入职称","please_fill_in_hospital":"请输入医院","please_fill_in_department":"请输入科室","please_select-coi_start_date":"请选择 COI生效开始日期","please_fillin_name_or_veevaid_or_abacid":"请输入姓名或 VEEVA ID或ABAC ID","please_fill_in_level_of_expertise":"请输入专家等级","please_select_bu":"请选择业务单元","please_select_ta":"请选择治疗领域","please_select_product":"请选择产品","please_fill_in_product":"请输入产品","please_select_level":"请选择讲者等级","please_fill_in_disease_area":"请输入疾病领域","please_fill_in_province":"请输入省/直辖市","please_fill_in_city":"请输入城市","please_fill_in_academic_title":"请输入行政职务","name":"姓名","coi_list":"COI记录","veevaidabacid":"Veeva ID/ABAC ID","hcp_nonhcp":"HCP/非HCP","hcp_type":"HCP type","target_type":"Target/Non target","academic_title":"行政职务","academic_title_updated":"行政职务更新时间","if_go":"是否EEIB","hospital":"医院","department":"科室","title":"学术职称","province":"省份","city":"城市","bu":"业务部门","ta":"治疗领域","med_ta":"Med-TA","product":"产品名称","level_of_expertise":"专家等级","disease_area":"疾病领域","com_ta_med_ta":"Com-TA/Med-TA","criteria":"准则","com_product":"Com-Product","product_disease_area":"产品名称/疾病领域","coi_status":"COI状态","coi_start_date":"COI生效开始日期","coi_expiry_date":"COI有效截止日期","if_coi_red_flag":"是否存在COI red flag","training_status":"医学培训状态","training_start_date":"培训生效开始日期","training_start_date_2":"培训生效开始日期","training_expiry_date":"培训有效截止日期","training_expiry_date_2":"培训有效截止日期","training_status_2":"培训状态","trained_by":"培训者","create_time":"提交时间","training_expire_date_2":"Training expiry date","please_select-training_start_date":"请选择培训生效开始日期","please_select-training_start_date_2":"请选择培训生效开始日期","training_times":"医学培训次数","annual_speaker_fee_(ytd)":"年度讲者费用（截止当前）","speaker_fee_cap":"讲者费用上限","speaker_fee_usage_rate_(ytd)":"讲者费用使用率（截止当前）","new_paid_speaker_submit_comments_placeholder":"请填写备注信息（更新付费演讲者必须填写）","comments":"备注","status":"状态","status_update_date":"状态更新日期","speaker_fee":"讲者费用","engagement_type":"会议","attendee_type":"参会类型","engagement_code":"会议编号","engagement_name":"会议名称","engagement_date":"会议日期","engagement_status":"会议状态","content_lab_code":"Content Lab编号","material_name":"材料名称","material_expiry_date":"材料过期日期","briefing_date":"材料培训日期","basic_information":"基本信息","paid_speaker_list":"有偿讲者列表","unpaid_speaker_list":"无偿讲者列表","attendee_list":"参会者列表","add_new_paid_speaker":"添加新有偿讲者","delete_paid_speaker":"删除有偿讲者","new_paid_speaker":"新有偿讲者","go_exception_form":"EEIB例外审批表","speaker_communication_form":"讲者沟通函","batch_no":"批次编号","senario":"类型","create_date":"创建日期","submit_date":"提交日期","submitted":"已提交","approval_completed":"审批完成","info_integrity":"信息完整度","approval_supporting_document":"审批支持性材料","supporting_document":"支持性材料","please_select_at_least_n_criteria":"请至少选择4个准则","please_select_at_least_3_criteria":"请至少选择3个准则","confirm_coi":"确认COI","coi_red_flag/go_approval":"审批EEIB","compliance_or_legal_consulting_supporting_document":"合规或法务咨询支撑材料","invalid":"无效","valid":"有效","draft":"待提交","in_progress":"审批中","no_approval_required":"无需审批","paid_speaker":"有偿讲者","unpaid_speaker":"无偿讲者","attendee":"参会者","coiqr_code":"COI二维码","disclosure_consent":"披露变更函","disclosure_consent_tips":"讲者及参会者可以通过扫描二维码变更披露信息。","sn":"S/N","meeting_type":"会议类型","meeting_code":"会议编号","meeting_name":"会议名称","meeting_date":"会议日期","action":"操作","view":"查看","coi_detail":"COI 详情","speaker_detail":"讲者详情","training_details":"GSK规章制度培训详情","scientific_training_details":"科学内容培训详情","complete":"完成","edit":"编辑","attachment":"附件","yes":"是","no":"否","coi_start_date_placeholder":"请选择COI生效开始日期","meeting_information":"会议信息","meeting_category":"会议类别","meeting_method":"会议形式","location":"会议地点","if_need_cmd_approval":"是否需要CMD审批","if_need_gm_approval":"是否需要GM审批","document":"支持性文件（包括EEIB例外审批表，BU Head审批邮件和合规/法务咨询文件）","document_md":"支持性文件（包括EEIB例外审批表，BU Head审批邮件和合规/法务咨询文件）","hcp_id":"HCP ID","level_of_experience":"专家等级","coi_start_date_U":"COI生效开始日期","coi_expiry_date_U":"COI有效截止日期","if_coi_red_flag_U":"是否存在COI red flag","go_details":"EEIB详情","professional_title":"Professional title","consulting_supporting_document":"支持性文件","todo":"待审批","completed":"已完成","all":"全部","select":"选中","items":"数据","briefing_list":"演讲内容培训记录","content_training_details":"演讲内容培训详情","speaker_engagement_list":"讲者会议记录","commercial_speaker_engagement_list":"Commercial 讲者会议记录","medical_ee_engagement_list":"Medical EE 会议记录","attendee_engagement_list":"参会者会议记录","commercial_attendee_engagement_list":"Commercial 参会者会议记录","medical_attendee_engagement_list":"Medical 参会者会议记录","training_list":"GSK规章制度培训记录","scientific_training_list":"科学内容培训记录","conten_lab_code":"Conten Lab 编号","please_fill_in_name_or_veevaid_or_abacid":"请输入姓名或者VEEVA ID或者ABAC ID","approval_process":"审批流","engagement_list":"会议记录","choose_at_least_one":"请至少选择一条数据","undefined":"未定义","approver_new_paid_speaker":"新有偿讲者审批","approval_supporting document":"审批支持性文件","click_to_clear":"点击此处清除搜索条件","select_file":"请选择一份文件上传","coi_attachment":"COI","training_attachment":"讲者沟通函","submit_confirm":"是否确认提交","approve":"审批通过","reject":"审批拒绝","confirm_item":"数据","item_s":"(s)?","eo":"EO","coe":"COE","bo":"BO","mas":"MAS","coi_submit_tip":"同一签署日期的COI已经被提交过。","eeib":"EEIB","tov_ytd":" ToV (YTD)","deleted":"Deleted","coi_start_date_required":"COI生效开始日期是必填项","training_start_date_required":"医学培训生效开始日期是必填项","training_start_date_required_2":"培训生效开始日期是必填项","content_lab_code_required":"Content lab code是必填项","team":"Team","bu_team":"BU/Team","please_select_disease_area":"请选择疾病领域","ee":"EE","ee_list":"EE列表","new_ee":"新增 EE","new_ee_approval":"审批新增EE","mbo":"MBO","ee_engagement_list":"EE 会议记录","eeib_details":"EEIB 详情","eeib_status":"EEIB 状态","if_eeib":"是否EEIB","annual_service_fee":"年度服务费","service_fee_cap":"服务费上限","service_fee_usage_rate":"服务费使用率","ee_service_fee":"EE 服务费","please_fill_in_meeting_name":"请输入会议名称","please_fill_in_meeting_code":"请输入会议编号","please_fill_in_name_or_mudid":"请输入姓名或者MUDID","question_two":"您是否作为病人或健康志愿者参与了葛兰素史克申办的介入式临床试验？","question_three":"您或您的紧密家庭成员是否会对葛兰素史克的业务产生实际或被认为有明显影响？","if_coi_red_flag_1":"COI red flag 1","if_coi_red_flag_2":"COI red flag 2","whether_coi_red_flag":" COI red flag","medical_confirm_training_tip":"我确认已完成GSK规章制度培训","scientific_confirm_training_tip":"我确认已完成科学内容培训","submit_training_tip":"在该时间段内已有一份生效的培训记录。","please_check_paid_speaker":"请校验并检查未满足要求并标记为红色的讲者信息。","veevaid_error":"Veeva ID与讲者姓名不匹配。","submit_error":"该讲者已被另一位EO提交审批。","delete_error":"该讲者已被另一位EO提交删除申请。","pharmacy_tips":"药剂科讲者仅可以选择药剂师讲者等级","bu_error":"该药学讲者与系统已有等级不一致","bu_ta_error":"BU与TA不匹配。","eo_bu_ta_error":"讲者的BU/TA与当前EO不匹配。","product_error":"仅可以添加被审批通过的产品。","level_error":"讲者等级与EE Pool中的讲者等级不一致","level_error_2":"同一药剂科讲者不能提交不同讲者等级。","level_error_3":"非Vaccine讲者不允许申请Local等级","delete_speaker_comments":"删除讲者备注","only_for_vaccine":"仅适用于 Vaccine","staff_nurse_tips":"Staff Nurse无法提交新付费讲者申请","hcp_account_type_error_1":"医师（士）仅可以申请医师类付费讲者","hcp_account_type_error_2":"药师（士）仅可以申请药剂师类付费讲者","hcp_account_type_error_3":"该类HCP不能提交新付费讲者申请","hcp_account_type_nurse_tips":"需额外支持材料（如Veeva截图）以证明实际任职为非护士"},"tpo_fmv_dd":{"tpo_check":"TPO check","hco_tpo_id":"HCO TPO ID","tpo_status":"TPO状态","capa_status":"CAPA Status","commodity_code":"Commodity code","please_select_commodity_code":"Please select commodity code","has_capa_been_agreed":"Has CAPA been agreed?","abac_risk_level":"ABAC风险等级","tips":"TPO ID来源于TPO系统。可供选择的TPO ID为：TPO ID所对应的学会名称与Gmeeting中的学会名称完全一致，TPO ID的有效期在会议结束日期后，且其所对应的国家为中国。","tpo_tip":"CAPA has not been agreed, please complete the CAPA agreement process with Global TPO team first. If you choose not to proceed with this process, please redo the TPO assessment.","tpo_tip2":"请选择HCO TPO ID","tpo_tip3":"请输入TPO ID或HCO名称","tpo_tip4":"请上传TPO问卷","tpo_tip5":"选择的TPO ID将在会议结束前失效，请重新选择TPO ID","tpo_tip6":"此HCO的TPO评估未完成，请在TPO integrfy系统中完成评估","yes":"是","no":"否","fmv_check":" FMV check","dd_check":"DD check","meeting_code":"会议编号","meeting_name":"会议名称","category":"类别","unit_cost":"单价","sponsorship_fee":"赞助费用","duration_size":"时长/大小","satellite_start_end":"卫星会起止时间","unit_cost_tax_included":"Unit Cost (tax included)","unit_cost_tax_excluded":"Unit Cost (tax excluded)","fmv_tip0":"","fmv_tip1":"卫星会/展台单价已超过FMV标准，请选择下一步。如果您有关于FMV标准的问题，请联系中国ABAC团队或合规团队","fmv_tip2":"确认提交特殊审批？","fmv_tip3":"特殊审批提交成功。","please_fill_in_reasons_for_special_approval":"请填写特殊审批理由（必填）","special_approval":"特殊审批","Special approval":"Special approval","update":"更新","reject":"拒绝","approval_process":"审批流","sponsorship_letter":"招商函","agenda_congress_symposium":"大会议程","tpo_questionnaire":"TPO问卷","completed_hco_coi_form":"HCO COI表格","hco_legal_certificate":"HCO法人证","fmv_standard":"FMV标准","fmv_over":"标红的项已超过FMV标准","hco_coi_expiry_date":"HCO COI失效日期","hco_coi_status":"HCO COI状态","hco_legal_certificate_expiry_date":"HCO法人证有效期","hco_status":"HCO状态","other_supporting_documents":"其他支持性文件（选填）","other_supporting_documents_require":"其他支持性文件","meeting_information":"会议信息","business_rationale":"业务目的","hco_name":"HCO名称","meeting_category":"会议类别","meeting_date":"会议日期","location":"地点","total_budget":"总预算","total_hco_budget":"HCO总预算","satellite_symposium":"卫星会数量","booth":"展台数量","total_number_of_attendee":"参会者总人数","dd_tip1":"当HCO COI表格的失效日期晚于会议结束日期时","dd_tip2":"该HCO COI表格的状态为有效","dd_tip3":"HCO COI 有效期已失效，请在HCO管理模块更新。","dd_other_tip1":"特殊审批支持性文件（例如省级协会赞助线上会，线上会时长不足2小时，仅有展台等）","dd_other_tip2":"应额外上传资质证明材料，需包括以下三个必要材料：存续状态证明/学会不在异常活动名录里的证明材料/学会不在严重失信企业名单里的证明材料","dd_tip_hco1":"当HCO法人证有效期晚于会议结束日期时","dd_tip_hco2":"该HCO的状态为有效","meeting_method":"会议方式","bu":"BU","ta":"TA","product":"产品","province":"省/直辖市","city":"城市","meeting_budget":"会议预算","sponsorship_fee_budget":"赞助费用预算","video_play":"视频数量","approve_placeholder":"请填写理由（必填）。","if_sponsorship_package":"是否package赞助","if_venue_in_hospital":"会议地址是否在医院","if_co_sponsored_by_hospital":"If co-organized/organized by hospital 是否由医院协办/承办","start_end":"起止日期","next":"下一页","hco_coi_form_is_invalid":"HCO COI 有效期已失效，请在HCO管理模块更新。","hco_legal_certificate_is_invalid":"HCO法人证有效期已失效，请在HCO管理模块更新。","others":"其他","type_placeholder":"请选择一级理由（必填）","sub_type_placeholder":"请选择二级理由（选填）","type":"一级理由","sub_type":"二级理由"},"eventArrangement":{"component":{"meal":{"lunch":"午餐","tea":"茶歇","dinner":"晚餐"}},"title":{"upload_stamped_quotation":"上传盖章版报价单","meeting_information":"会议信息","logistic_information":"后勤信息","fill_in_po_number":"请输入PO编号","summary_of_event_budget":"会议活动预算小结（不含税）","upload_quotation":"上传报价单","quotation_list":"报价单列表","confirm_quotation":"确认报价单","food_beverage":"订餐","venue":"会议场地","production_audio_visual":"展台物料/影音材料","others_miscellaneous":"其他","vendor_pr_generation":"生成供应商PR","to_do":"待办","completed":"已完成","online_meeting_platform":"线上会议平台","regenerate_shoppingcart_checklist_title":"更新盖章版报价单需要重新生成购物车清单。","supporting_documents":"支持性文件"},"label":{"action":"操作","upload_documents_for_pr_request":"上传文件","tax_excluded":"(不含税)","task_assign":"分配任务","cvent_register":"Cvent注册","meeting_request":"会议需求","wbs_tip":"注册 Cvent 用 WBS code","cc_tip":"CC code for Cvent registration","wbs_cc_tip":"WBS/CC code for Cvent registration","last_update":"最后更新人","update_date_1":"更新开始时间","update_date_2":"更新结束时间","speaker":"讲者","attendee":"参会者","name":"姓名","logistic_request":"后勤需求","system_update":"系统更新时间","update_date":"更新日期","agenda_congress":"大会议程","materials_plan":"讲者和演讲材料（讲者及计划使用幻灯片信息）","booth_materials":"展台材料","coi":"讲者利益冲突协议","stamped_quotation_1":"盖章版报价单","stamped_quotation_2":"报价单支持性文件","total_amount_1":"报价单总金额（不含税）","total_amount_2":"报价单总金额（含税）","location_details":"详细地址","lunch":"午餐","tea":"茶歇","dinner":"晚餐","meeting_name":"会议名称","meeting_date":"会议开始时间-结束时间","meeting_duration":"会议时长","meeting_category":"会议类别","bu":"业务部门","ta":"治疗领域","register_cvent":"注册Cvent","cvent_status":"Cvent状态","cvent_code":"Cvent编号","updated_time":"更新时间","updated_user":"更新用户","product":"产品名称","category":"类型","vevvaId":"Veeva ID/ABAC ID","gender":"性别","province":"省/直辖市","city":"城市","hospital_code":"医院编号","hospital_name":"医院名称","department":"科室","title":"学术职称","id_number":"身份证号","mobile_number":"手机号","gsk_contract_mudid":"GSK联系人MUDID","gsk_contract_name":"GSK联系人姓名","gsk_contract_person_title":"GSK联系人角色","gsk_contract_mobile_number":"GSK联系人手机号","gsk_contract_sales_region":"GSK联系人销售区域","gsk_ram_mudid":"GSK销售 MUDID","gsk_ram_name":"GSK销售姓名","gsk_ram_mobile_number":"GSK销售手机号","gsk_ram_region":"GSK销售区域","require_accommodation":"是否有住宿安排","require_ground_transportation":"是否有地面交通安排","require_train":"是否有火车行程安排","require_flight":"是否有飞机行程安排","check_in":"入住日期","check_out":"离开日期","room_type":"房型","other_requirement":"其他要求","online_broadcasting_platform":"在线广播平台","accommodation":"住宿","ground_transportation":"地面交通","translation":"翻译","train":"火车","flight":"航班","meal":"用餐","webinar":"在线会议","materials":"材料","others":"其他","production":"展台物料/影音材料","meeting_room":"会议场地","departure_date":"出发日期","departure_time":"出发时间","departure_city":"出发城市","arrival_city":"到达城市","arrival_time":"到达时间","from":"出发地","to":"到达地","train_number":"车次","flight_number":"航班号","departure_or_Return":"出发/到达","departure":"出发","return":"到达","vendor":"供应商名称","po_status":"PO状态","po_number":"PO编号","total_event_budget":"总预算","quotation_amount":"报价单金额（含税）","quotation_amount_1":"报价单金额（不含税)","request_type":"需求类型","request_type_others":"需求类型-其他","updated_date":"更新日期","quotation":"报价单","supporting":"支持性文件","stamped_quotation":"盖章版报价单 & 准备购物车清单","description_of_request":"需求简述","production_request":"如果有生产请求","number_of_diners":"用餐人数","speaker_attendee":"讲者和参会者总人数","standard_room":"标准间","single_room":"单间","reject":"提交失败","meeting_invitation":"会议邀请函","sponsorship_letter":"招商函","meeting_agenda":"大会议程","attendee_list":"最终参会者确认名单","meeting_budget":"会议预算","event_budget":"活动费用预算","booth":"展台","satellite_symposium":"Satellite symposium","videoplay":"Videoplay","coi_2":"EE COI","ee":"EE","gcar_status":"Gcar","gcar_trial":"Gcar 试算","vendor_name":"Vendor name","gcar":"Gcar","gcar_status_2":"Gcar status","vendor_budget_tax_included":"供应商预算(含税)","status_detail":"Status-detail","quoation_vendor_system_confirmed":"报价单（供应商系统确认）","gcar_estimate_price":"Gcar 预估价格","gcar_additional_info":"Gcar 附加信息"},"button":{"meeting_register":"注册会议","update_actual_cost":"更新实际花费","gcar_submission":"Gcar submission"},"tip":{"gcar_submission_tip":"Gcar task is failed. Please revise relevant information and re-confirm Gcar request.","gcar_vendor_total_budget_cannot_more_than_ground_budget":"供应商总预算(含税)不能超过会议地面交通预算","wbs_tip":"Please fill in WBS code for Cvent registration.","cc_tip":"Please fill in CC code for Cvent registration.","wbs_cc_tip":"Please fill in WBS/CC code for Cvent registration.","cvent_tip":"会议总预算超过5000英镑，请点击下方按钮提交Cvent注册申请，并在结算单审批通过后提交更新后的申请","cvent_register_success_tip":"您已成功提交注册Cvent","cvent_update_success_tip":"您已成功更新Cvent","translation":"是否有翻译需求","digital":"是否有在线会议需求","others":"是否有其他要求","material":"是否有材料需求","design":"是否有创意设计需求","medical":"是否有医学文案设计需求","pr":"是否有品牌公关需求","lunch":"是否有午餐需求","tea":"是否有茶歇需求","dinner":"是否有晚餐需求","download_template":"下载模板文件","download_data":"下载数据文件","download_registration_form":"下载现场签到表","download":"下载","export":"导出","map_location_confirm_msg":"确认会议地点?","update":"是否确认更新?","edit":"是否确认修改?","date_change":"由于会议日期改变，请再次确认相关需求","batch_tip":"您选择的后勤信息未完成。请在提交前填写。","not_during_the_meeting":"不在会议期间","failed_to_get_cvent_info":"获取 cvent 信息失败","gcar_re_confirm_tips":"Gcar推送失败。请修正相关信息并重新确认Gcar需求。","gcar_task_is_failed":"Gcar推送失败。","please_select_vendor":"请选择供应商","gcar_budget_must_equal_meeting_ground_transportation":"Gcar 总金额(含税)必须等于会议地面交通预算。","gcar_budget_must_equal_vendor_total_budget":"Gcar 总金额(含税) 必须小于等于供应商预算(含税)","gcar_exceed_event_budget_prefix":"您已经超过了会议活动预算的110%,总的会议活动预算是:","gcar_exceed_event_budget_suffix":"您的请求不能被提交。","meeting_request_save":"您仅保存会议需求，请点击提交按钮进行后续审批流程。","check_list_tip_1":"系统已经记录了以下文件，请选择需要在Ariba申请采购订单的文件。","check_list_tip_2":"如检查清单中任一状态标红则无法生成检查清单文件。","upload_file_ariba":"上传在Ariba申请采购订单的额外文件。","check_list_download":"请下载PR需要的文件，包括购物车清单。"},"special":{"translation":"翻译","digital":"在线会议","material":"物料","design":"创意设计","medical":"医学文案设计","pr":"品牌公关","ariba_category":"Ariba类别","ariba_code_category":"WBS/Cost center","wbs_costcenter_code":"WBS/Cost center code"},"placeholder":{"pr_please_select_code_category":"请选择编号类型","pr_price_warining":"采购订单总金额必须等于总报价金额（不含税）","pr_placeholder_1":"请选择会议计划和活动管理","pr_placeholder_2":"请输入WBS编号","pr_placeholder_md":"请输入WBS/Cost center编号","pr_placeholder_3":"请填写价格","pr_placeholder_4":"请填写公关说明（选填），不超过500字","pr_placeholder_5":"会议计划及活动安排","quotation_amount":"请输入报价单金额（含税）","quotation_amount_1":"请输入报价单金额（不含税）","vendor":"请输入供应商名称","total_amount_1":"请输入报价单金额（不含税）","total_amount_2":"请输入报价单金额（含税）","gsk_contract_mudid":"请输入GSK联系人MUDID","gsk_contract_name":"请输入GSK联系人姓名","gsk_contract_person_title":"请输入GSK联系人角色","gsk_contract_mobile_number":"请输入GSK联系人手机号","gsk_contract_sales_region":"请输入GSK联系人销售区域","gsk_ram_mudid":"请输入GSK销售 MUDID","gsk_ram_name":"请输入GSK销售姓名","gsk_ram_mobile_number":"请输入GSK销售手机号","gsk_ram_region":"请输入GSK销售区域","select_date":"请选择日期","select_room_type":"请选择房型","other_requirement":"请填写其他住宿需求","departure_date":"请输入出发日期","departure_time":"请输入出发时间","departure_city":"请输入出发城市","arrival_city":"请输入到达城市","from":"请输入出发地","to":"请输入到达地","transportation_requirement":"请填写其他交通需求","train_requirement":"请填写其他火车需求","flight_requirement":"请填写其他飞机需求","other":"请填写其他需求","departure_or_Return":"请选择出发或返回","arrival_time":"请选择到达时间","train_number":"请填写车次","flight_number":"请输入航班号","select_file":"请选择要上传的文件","quantity_of_materials":"请填写材料的种类和数量。如果有一些特定的文档，您可以将它们作为附件上传。","quantity_of_materials_1":"请填写材料的种类和数量","request_type":"请输入需求类型","request_type_1":"请选择需求类型","meal_date":"请选择用餐日期","meal_time":"请选择用餐时间","number_of_diners":"请输入用餐人数","meeting_location":"请输入会议地点","online_platform_type_is_required":"线上会议平台是必填项","requirement":"请填写会议日期，会议时间，会议时常，预计参会人数，会议信息等","po_number":"请输入PO编号（不超过10个字符）","select_name":"请输入姓名","select_logistic":"请选择后勤需求","select_update_date":"请选择系统更新时间","select_start_date":"请选择更新开始时间","select_end_date":"请选择更新结束时间","select_category":"请选择类别","meal_date_1":"用餐日期","meal_time_1":"用餐时间","mobile_number":"请填写手机号码"},"gcar":{"sn":"S/N","category":"Category","vevva_id":"Vevva ID","name":"Name","department":"Department","hospital":"Hospital","title":"Title","gender":"Gender"}},"issueFeedback":{"issue_id":"Issue ID","issue_title":"Issue title"},"documentation":{"action_type_1":"操作类型-1","action_type_2":"操作类型-2","action_type_3":"操作类型-3","comments":"备注","type_1":"文档类型-1","type_2":"文档类型-2","type_3":"文档类型-3","type_5":"文档类型-5","document_type_1":"文档类型-1","document_type_2":"文档类型-2","document_type_3":"文档类型-3","document_type_4":"文档类型-4","document_type_5":"文档类型-5","meeting_code":"会议编号","sub_meeting_code":"分会编号","meeting_name":"会议名称","speaker_id":"讲者 Veeva ID","speaker_name":"讲者姓名","hco_name":"HCO 名称","vendor_name":"供应商名称","download_file":"下载文件","download_list":"下载列表","update_user":"操作用户","update_time":"操作时间","action":"操作","action_type":"操作类型","document_information":"文档信息","supporting_document":"支持性文件","please_select_action_type":"请选择操作类型","please_select_document_type":"请选择文档类型","please_fill_in_document_type":"请输入文档类型","please_fill_in_comments":"请输入备注","please_fill_in_meeting_code":"请输入会议编号","please_select_sub_meeting_code":"请选择分会编号","please_fill_in_meeting_name":"请输入会议名称","please_fill_in_speaker_id":"请输入讲者 Veeva ID","please_fill_in_speaker_name":"请输入讲者姓名","please_fill_in_hco_name":"请输入HCO名称","please_fill_in_vendor_name":"请输入供应商名称","please_upload_supporting_document":"请上传支持性文件","required":"（必填）","optional":"（选填）","valid_meeting_error":"会议名称与会议号码不匹配"},"meetingplan":{"application":{"title":"我的申请","add":"添加会议","copy":"复制会议","edit":"编辑会议","change":"变更会议","view":"查看会议"},"task":{"title":"我的任务","view":"查看会议"},"authorizedtask":{"title":"被授权任务","view":"查看会议"},"library":{"title":"计划库","view":"查看会议"}},"bizmanagement":{"budget":"预算管理","hospital-level":"医院层级管理","speaker-level":"讲者级别管理","strategy":"策略管理","domain-result":"业务结果管理"},"dashboard":{"sample":"示例","budget":"预算","meeting":"会议","effectiveness":"评分"},"sysmanagement":{"time-config":"时间结点配置","season-adjust":"会议计划季度申请开放周期","month-adjust":"会议计划月度调整开放周期","system-notice":"系统公告","menu":"菜单管理","role":"角色管理","privilege":"用户权限","dict-list":"数据字典","email-template":"邮件模板"},"messages":{"list":"全部消息"},"user":{"personal-center":"个人中心","manual":"用户手册","authorizelm":"直线经理授权","authorizedlevel":"二级审批人授权"}}

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./budget/index": 538,
	"./budget/index.vue": 538,
	"./domainresult/index": 539,
	"./domainresult/index.vue": 539,
	"./hospitallevel/index": 540,
	"./hospitallevel/index.vue": 540,
	"./speakerlevel/index": 541,
	"./speakerlevel/index.vue": 541,
	"./strategy/index": 542,
	"./strategy/index.vue": 542
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1723;

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./budget/index": 544,
	"./budget/index-old": 543,
	"./budget/index-old.vue": 543,
	"./budget/index.vue": 544,
	"./effectiveness/index": 546,
	"./effectiveness/index-old": 545,
	"./effectiveness/index-old.vue": 545,
	"./effectiveness/index.vue": 546,
	"./error/ErrorSection": 202,
	"./error/ErrorSection.vue": 202,
	"./meeting/index": 548,
	"./meeting/index-old": 547,
	"./meeting/index-old.vue": 547,
	"./meeting/index.vue": 548,
	"./sample/index": 549,
	"./sample/index.vue": 549
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1724;

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./list/index": 559,
	"./list/index.vue": 559
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1725;

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./LeftBar": 89,
	"./LeftBar.vue": 89,
	"./dictlist/dictitem": 355,
	"./dictlist/dictitem.vue": 355,
	"./dictlist/index": 560,
	"./dictlist/index.vue": 560,
	"./emailtemplate/index": 561,
	"./emailtemplate/index.vue": 561,
	"./menu/index": 562,
	"./menu/index.vue": 562,
	"./monthadjust/index": 563,
	"./monthadjust/index.vue": 563,
	"./privilege/index": 564,
	"./privilege/index.vue": 564,
	"./role/index": 565,
	"./role/index.vue": 565,
	"./role/roleprivilege": 356,
	"./role/roleprivilege.vue": 356,
	"./seasonadjust/index": 566,
	"./seasonadjust/index.vue": 566,
	"./systemnotice/index": 567,
	"./systemnotice/index.vue": 567
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1726;

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./LeftBar": 116,
	"./LeftBar.vue": 116,
	"./authorizedlevel/add/index": 568,
	"./authorizedlevel/add/index.vue": 568,
	"./authorizedlevel/index": 569,
	"./authorizedlevel/index.vue": 569,
	"./authorizelm/add/index": 570,
	"./authorizelm/add/index.vue": 570,
	"./authorizelm/index": 571,
	"./authorizelm/index.vue": 571,
	"./center/index": 572,
	"./center/index.vue": 572,
	"./manual/index": 573,
	"./manual/index.vue": 573
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1727;

/***/ }),
/* 1728 */
/***/ (function(module, exports) {

module.exports = XLSX;

/***/ }),
/* 1729 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1730 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1731 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1732 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1733 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(598);
module.exports = __webpack_require__(260);


/***/ })
],[1734]);


// WEBPACK FOOTER //
// static/js/app.09d148f37c076425f1a4.1789010827363.js